
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return import.meta.resolve($parcel$distDir + url);
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7826"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7826"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("getKs", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $bd15078e983a2521$export$ffb0004e005737fa, (v) => $bd15078e983a2521$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $bd15078e983a2521$export$34b9dba7ce09269b, (v) => $bd15078e983a2521$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $bd15078e983a2521$export$25062201e9e25d76, (v) => $bd15078e983a2521$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bd15078e983a2521$export$ffb0004e005737fa;
var $bd15078e983a2521$export$34b9dba7ce09269b;
var $bd15078e983a2521$export$25062201e9e25d76;
'use strict';

var $kc00y = parcelRequire("kc00y");
var $bd15078e983a2521$var$k = Symbol.for("react.element"), $bd15078e983a2521$var$l = Symbol.for("react.fragment"), $bd15078e983a2521$var$m = Object.prototype.hasOwnProperty, $bd15078e983a2521$var$n = $kc00y.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $bd15078e983a2521$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $bd15078e983a2521$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$bd15078e983a2521$var$m.call(a, b) && !$bd15078e983a2521$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $bd15078e983a2521$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $bd15078e983a2521$var$n.current
    };
}
$bd15078e983a2521$export$ffb0004e005737fa = $bd15078e983a2521$var$l;
$bd15078e983a2521$export$34b9dba7ce09269b = $bd15078e983a2521$var$q;
$bd15078e983a2521$export$25062201e9e25d76 = $bd15078e983a2521$var$q;

});
parcelRegister("kc00y", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2gdtR"));

});
parcelRegister("2gdtR", function(module, exports) {

$parcel$export(module.exports, "Children", () => $1a57885a3215e64f$export$dca3b0875bd9a954, (v) => $1a57885a3215e64f$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1a57885a3215e64f$export$16fa2f45be04daa8, (v) => $1a57885a3215e64f$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $1a57885a3215e64f$export$ffb0004e005737fa, (v) => $1a57885a3215e64f$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $1a57885a3215e64f$export$e2c29f18771995cb, (v) => $1a57885a3215e64f$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $1a57885a3215e64f$export$221d75b3f55bb0bd, (v) => $1a57885a3215e64f$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $1a57885a3215e64f$export$5f8d39834fd61797, (v) => $1a57885a3215e64f$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1a57885a3215e64f$export$74bf444e3cd11ea5, (v) => $1a57885a3215e64f$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1a57885a3215e64f$export$ae55be85d98224ed, (v) => $1a57885a3215e64f$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $1a57885a3215e64f$export$3ba232387fd5d6dd, (v) => $1a57885a3215e64f$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $1a57885a3215e64f$export$e530037191fcd5d7, (v) => $1a57885a3215e64f$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1a57885a3215e64f$export$fd42f52fd3ae1109, (v) => $1a57885a3215e64f$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1a57885a3215e64f$export$c8a8987d4410bf2d, (v) => $1a57885a3215e64f$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1a57885a3215e64f$export$d38cd72104c1f0e9, (v) => $1a57885a3215e64f$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1a57885a3215e64f$export$7d1e3a5e95ceca43, (v) => $1a57885a3215e64f$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1a57885a3215e64f$export$257a8862b851cb5b, (v) => $1a57885a3215e64f$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1a57885a3215e64f$export$a8257692ac88316c, (v) => $1a57885a3215e64f$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1a57885a3215e64f$export$488013bae63b21da, (v) => $1a57885a3215e64f$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1a57885a3215e64f$export$7c73462e0d25e514, (v) => $1a57885a3215e64f$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $1a57885a3215e64f$export$7568632d0d33d16d, (v) => $1a57885a3215e64f$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $1a57885a3215e64f$export$88948ce120ea2619, (v) => $1a57885a3215e64f$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $1a57885a3215e64f$export$35808ee640e87ca7, (v) => $1a57885a3215e64f$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1a57885a3215e64f$export$fae74005e78b1a27, (v) => $1a57885a3215e64f$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1a57885a3215e64f$export$dc8fbce3eb94dc1e, (v) => $1a57885a3215e64f$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $1a57885a3215e64f$export$6a7bc4e911dc01cf, (v) => $1a57885a3215e64f$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $1a57885a3215e64f$export$6d9c69b0de29b591, (v) => $1a57885a3215e64f$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $1a57885a3215e64f$export$f680877a34711e37, (v) => $1a57885a3215e64f$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1a57885a3215e64f$export$d5a552a76deda3c2, (v) => $1a57885a3215e64f$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $1a57885a3215e64f$export$aaabe4eda9ed9969, (v) => $1a57885a3215e64f$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1a57885a3215e64f$export$e5c5a5f917a5871c, (v) => $1a57885a3215e64f$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1a57885a3215e64f$export$1538c33de8887b59, (v) => $1a57885a3215e64f$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1a57885a3215e64f$export$13e3392192263954, (v) => $1a57885a3215e64f$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1a57885a3215e64f$export$b8f5890fc79d6aca, (v) => $1a57885a3215e64f$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1a57885a3215e64f$export$60241385465d0a34, (v) => $1a57885a3215e64f$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $1a57885a3215e64f$export$306c0aa65ff9ec16, (v) => $1a57885a3215e64f$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $1a57885a3215e64f$export$7b286972b8d8ccbf, (v) => $1a57885a3215e64f$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $1a57885a3215e64f$export$83d89fbfd8236492, (v) => $1a57885a3215e64f$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1a57885a3215e64f$export$dca3b0875bd9a954;
var $1a57885a3215e64f$export$16fa2f45be04daa8;
var $1a57885a3215e64f$export$ffb0004e005737fa;
var $1a57885a3215e64f$export$e2c29f18771995cb;
var $1a57885a3215e64f$export$221d75b3f55bb0bd;
var $1a57885a3215e64f$export$5f8d39834fd61797;
var $1a57885a3215e64f$export$74bf444e3cd11ea5;
var $1a57885a3215e64f$export$ae55be85d98224ed;
var $1a57885a3215e64f$export$3ba232387fd5d6dd;
var $1a57885a3215e64f$export$e530037191fcd5d7;
var $1a57885a3215e64f$export$fd42f52fd3ae1109;
var $1a57885a3215e64f$export$c8a8987d4410bf2d;
var $1a57885a3215e64f$export$d38cd72104c1f0e9;
var $1a57885a3215e64f$export$7d1e3a5e95ceca43;
var $1a57885a3215e64f$export$257a8862b851cb5b;
var $1a57885a3215e64f$export$a8257692ac88316c;
var $1a57885a3215e64f$export$488013bae63b21da;
var $1a57885a3215e64f$export$7c73462e0d25e514;
var $1a57885a3215e64f$export$7568632d0d33d16d;
var $1a57885a3215e64f$export$88948ce120ea2619;
var $1a57885a3215e64f$export$35808ee640e87ca7;
var $1a57885a3215e64f$export$fae74005e78b1a27;
var $1a57885a3215e64f$export$dc8fbce3eb94dc1e;
var $1a57885a3215e64f$export$6a7bc4e911dc01cf;
var $1a57885a3215e64f$export$6d9c69b0de29b591;
var $1a57885a3215e64f$export$f680877a34711e37;
var $1a57885a3215e64f$export$d5a552a76deda3c2;
var $1a57885a3215e64f$export$aaabe4eda9ed9969;
var $1a57885a3215e64f$export$e5c5a5f917a5871c;
var $1a57885a3215e64f$export$1538c33de8887b59;
var $1a57885a3215e64f$export$13e3392192263954;
var $1a57885a3215e64f$export$b8f5890fc79d6aca;
var $1a57885a3215e64f$export$60241385465d0a34;
var $1a57885a3215e64f$export$306c0aa65ff9ec16;
var $1a57885a3215e64f$export$7b286972b8d8ccbf;
var $1a57885a3215e64f$export$83d89fbfd8236492;
'use strict';
var $1a57885a3215e64f$var$l = Symbol.for("react.element"), $1a57885a3215e64f$var$n = Symbol.for("react.portal"), $1a57885a3215e64f$var$p = Symbol.for("react.fragment"), $1a57885a3215e64f$var$q = Symbol.for("react.strict_mode"), $1a57885a3215e64f$var$r = Symbol.for("react.profiler"), $1a57885a3215e64f$var$t = Symbol.for("react.provider"), $1a57885a3215e64f$var$u = Symbol.for("react.context"), $1a57885a3215e64f$var$v = Symbol.for("react.forward_ref"), $1a57885a3215e64f$var$w = Symbol.for("react.suspense"), $1a57885a3215e64f$var$x = Symbol.for("react.memo"), $1a57885a3215e64f$var$y = Symbol.for("react.lazy"), $1a57885a3215e64f$var$z = Symbol.iterator;
function $1a57885a3215e64f$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1a57885a3215e64f$var$z && a[$1a57885a3215e64f$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $1a57885a3215e64f$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1a57885a3215e64f$var$C = Object.assign, $1a57885a3215e64f$var$D = {};
function $1a57885a3215e64f$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1a57885a3215e64f$var$D;
    this.updater = e || $1a57885a3215e64f$var$B;
}
$1a57885a3215e64f$var$E.prototype.isReactComponent = {};
$1a57885a3215e64f$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1a57885a3215e64f$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1a57885a3215e64f$var$F() {}
$1a57885a3215e64f$var$F.prototype = $1a57885a3215e64f$var$E.prototype;
function $1a57885a3215e64f$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1a57885a3215e64f$var$D;
    this.updater = e || $1a57885a3215e64f$var$B;
}
var $1a57885a3215e64f$var$H = $1a57885a3215e64f$var$G.prototype = new $1a57885a3215e64f$var$F;
$1a57885a3215e64f$var$H.constructor = $1a57885a3215e64f$var$G;
$1a57885a3215e64f$var$C($1a57885a3215e64f$var$H, $1a57885a3215e64f$var$E.prototype);
$1a57885a3215e64f$var$H.isPureReactComponent = !0;
var $1a57885a3215e64f$var$I = Array.isArray, $1a57885a3215e64f$var$J = Object.prototype.hasOwnProperty, $1a57885a3215e64f$var$K = {
    current: null
}, $1a57885a3215e64f$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1a57885a3215e64f$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1a57885a3215e64f$var$J.call(b, d) && !$1a57885a3215e64f$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $1a57885a3215e64f$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $1a57885a3215e64f$var$K.current
    };
}
function $1a57885a3215e64f$var$N(a, b) {
    return {
        $$typeof: $1a57885a3215e64f$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1a57885a3215e64f$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1a57885a3215e64f$var$l;
}
function $1a57885a3215e64f$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1a57885a3215e64f$var$P = /\/+/g;
function $1a57885a3215e64f$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1a57885a3215e64f$var$escape("" + a.key) : b.toString(36);
}
function $1a57885a3215e64f$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1a57885a3215e64f$var$l:
                case $1a57885a3215e64f$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $1a57885a3215e64f$var$Q(h, 0) : d, $1a57885a3215e64f$var$I(c) ? (e = "", null != a && (e = a.replace($1a57885a3215e64f$var$P, "$&/") + "/"), $1a57885a3215e64f$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($1a57885a3215e64f$var$O(c) && (c = $1a57885a3215e64f$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($1a57885a3215e64f$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($1a57885a3215e64f$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $1a57885a3215e64f$var$Q(k, g);
        h += $1a57885a3215e64f$var$R(k, b, e, f, c);
    }
    else if (f = $1a57885a3215e64f$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $1a57885a3215e64f$var$Q(k, g++), h += $1a57885a3215e64f$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $1a57885a3215e64f$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $1a57885a3215e64f$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $1a57885a3215e64f$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $1a57885a3215e64f$var$U = {
    current: null
}, $1a57885a3215e64f$var$V = {
    transition: null
}, $1a57885a3215e64f$var$W = {
    ReactCurrentDispatcher: $1a57885a3215e64f$var$U,
    ReactCurrentBatchConfig: $1a57885a3215e64f$var$V,
    ReactCurrentOwner: $1a57885a3215e64f$var$K
};
function $1a57885a3215e64f$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$1a57885a3215e64f$export$dca3b0875bd9a954 = {
    map: $1a57885a3215e64f$var$S,
    forEach: function(a, b, e) {
        $1a57885a3215e64f$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $1a57885a3215e64f$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1a57885a3215e64f$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1a57885a3215e64f$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$1a57885a3215e64f$export$16fa2f45be04daa8 = $1a57885a3215e64f$var$E;
$1a57885a3215e64f$export$ffb0004e005737fa = $1a57885a3215e64f$var$p;
$1a57885a3215e64f$export$e2c29f18771995cb = $1a57885a3215e64f$var$r;
$1a57885a3215e64f$export$221d75b3f55bb0bd = $1a57885a3215e64f$var$G;
$1a57885a3215e64f$export$5f8d39834fd61797 = $1a57885a3215e64f$var$q;
$1a57885a3215e64f$export$74bf444e3cd11ea5 = $1a57885a3215e64f$var$w;
$1a57885a3215e64f$export$ae55be85d98224ed = $1a57885a3215e64f$var$W;
$1a57885a3215e64f$export$3ba232387fd5d6dd = $1a57885a3215e64f$var$X;
$1a57885a3215e64f$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $1a57885a3215e64f$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1a57885a3215e64f$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1a57885a3215e64f$var$J.call(b, f) && !$1a57885a3215e64f$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $1a57885a3215e64f$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$1a57885a3215e64f$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $1a57885a3215e64f$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $1a57885a3215e64f$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$1a57885a3215e64f$export$c8a8987d4410bf2d = $1a57885a3215e64f$var$M;
$1a57885a3215e64f$export$d38cd72104c1f0e9 = function(a) {
    var b = $1a57885a3215e64f$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1a57885a3215e64f$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1a57885a3215e64f$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1a57885a3215e64f$var$v,
        render: a
    };
};
$1a57885a3215e64f$export$a8257692ac88316c = $1a57885a3215e64f$var$O;
$1a57885a3215e64f$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1a57885a3215e64f$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1a57885a3215e64f$var$T
    };
};
$1a57885a3215e64f$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1a57885a3215e64f$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1a57885a3215e64f$export$7568632d0d33d16d = function(a) {
    var b = $1a57885a3215e64f$var$V.transition;
    $1a57885a3215e64f$var$V.transition = {};
    try {
        a();
    } finally{
        $1a57885a3215e64f$var$V.transition = b;
    }
};
$1a57885a3215e64f$export$88948ce120ea2619 = $1a57885a3215e64f$var$X;
$1a57885a3215e64f$export$35808ee640e87ca7 = function(a, b) {
    return $1a57885a3215e64f$var$U.current.useCallback(a, b);
};
$1a57885a3215e64f$export$fae74005e78b1a27 = function(a) {
    return $1a57885a3215e64f$var$U.current.useContext(a);
};
$1a57885a3215e64f$export$dc8fbce3eb94dc1e = function() {};
$1a57885a3215e64f$export$6a7bc4e911dc01cf = function(a) {
    return $1a57885a3215e64f$var$U.current.useDeferredValue(a);
};
$1a57885a3215e64f$export$6d9c69b0de29b591 = function(a, b) {
    return $1a57885a3215e64f$var$U.current.useEffect(a, b);
};
$1a57885a3215e64f$export$f680877a34711e37 = function() {
    return $1a57885a3215e64f$var$U.current.useId();
};
$1a57885a3215e64f$export$d5a552a76deda3c2 = function(a, b, e) {
    return $1a57885a3215e64f$var$U.current.useImperativeHandle(a, b, e);
};
$1a57885a3215e64f$export$aaabe4eda9ed9969 = function(a, b) {
    return $1a57885a3215e64f$var$U.current.useInsertionEffect(a, b);
};
$1a57885a3215e64f$export$e5c5a5f917a5871c = function(a, b) {
    return $1a57885a3215e64f$var$U.current.useLayoutEffect(a, b);
};
$1a57885a3215e64f$export$1538c33de8887b59 = function(a, b) {
    return $1a57885a3215e64f$var$U.current.useMemo(a, b);
};
$1a57885a3215e64f$export$13e3392192263954 = function(a, b, e) {
    return $1a57885a3215e64f$var$U.current.useReducer(a, b, e);
};
$1a57885a3215e64f$export$b8f5890fc79d6aca = function(a) {
    return $1a57885a3215e64f$var$U.current.useRef(a);
};
$1a57885a3215e64f$export$60241385465d0a34 = function(a) {
    return $1a57885a3215e64f$var$U.current.useState(a);
};
$1a57885a3215e64f$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $1a57885a3215e64f$var$U.current.useSyncExternalStore(a, b, e);
};
$1a57885a3215e64f$export$7b286972b8d8ccbf = function() {
    return $1a57885a3215e64f$var$U.current.useTransition();
};
$1a57885a3215e64f$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("63uH6", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $468ad51c3551a14d$export$ae55be85d98224ed, (v) => $468ad51c3551a14d$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $468ad51c3551a14d$export$d39a5bbd09211389, (v) => $468ad51c3551a14d$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $468ad51c3551a14d$export$882461b6382ed46c, (v) => $468ad51c3551a14d$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $468ad51c3551a14d$export$466bfc07425424d5, (v) => $468ad51c3551a14d$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $468ad51c3551a14d$export$cd75ccfd720a3cd4, (v) => $468ad51c3551a14d$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $468ad51c3551a14d$export$fa8d919ba61d84db, (v) => $468ad51c3551a14d$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $468ad51c3551a14d$export$757ceba2d55c277e, (v) => $468ad51c3551a14d$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $468ad51c3551a14d$export$b3890eb0ae9dca99, (v) => $468ad51c3551a14d$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $468ad51c3551a14d$export$502457920280e6be, (v) => $468ad51c3551a14d$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $468ad51c3551a14d$export$c78a37762a8d58e1, (v) => $468ad51c3551a14d$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $468ad51c3551a14d$export$dc54d992c10e8a18, (v) => $468ad51c3551a14d$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $468ad51c3551a14d$export$83d89fbfd8236492, (v) => $468ad51c3551a14d$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $468ad51c3551a14d$export$ae55be85d98224ed;
var $468ad51c3551a14d$export$d39a5bbd09211389;
var $468ad51c3551a14d$export$882461b6382ed46c;
var $468ad51c3551a14d$export$466bfc07425424d5;
var $468ad51c3551a14d$export$cd75ccfd720a3cd4;
var $468ad51c3551a14d$export$fa8d919ba61d84db;
var $468ad51c3551a14d$export$757ceba2d55c277e;
var $468ad51c3551a14d$export$b3890eb0ae9dca99;
var $468ad51c3551a14d$export$502457920280e6be;
var $468ad51c3551a14d$export$c78a37762a8d58e1;
var $468ad51c3551a14d$export$dc54d992c10e8a18;
var $468ad51c3551a14d$export$83d89fbfd8236492;
'use strict';

var $kc00y = parcelRequire("kc00y");

var $cV2f0 = parcelRequire("cV2f0");
function $468ad51c3551a14d$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $468ad51c3551a14d$var$da = new Set, $468ad51c3551a14d$var$ea = {};
function $468ad51c3551a14d$var$fa(a, b) {
    $468ad51c3551a14d$var$ha(a, b);
    $468ad51c3551a14d$var$ha(a + "Capture", b);
}
function $468ad51c3551a14d$var$ha(a, b) {
    $468ad51c3551a14d$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$468ad51c3551a14d$var$da.add(b[a]);
}
var $468ad51c3551a14d$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $468ad51c3551a14d$var$ja = Object.prototype.hasOwnProperty, $468ad51c3551a14d$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $468ad51c3551a14d$var$la = {}, $468ad51c3551a14d$var$ma = {};
function $468ad51c3551a14d$var$oa(a) {
    if ($468ad51c3551a14d$var$ja.call($468ad51c3551a14d$var$ma, a)) return !0;
    if ($468ad51c3551a14d$var$ja.call($468ad51c3551a14d$var$la, a)) return !1;
    if ($468ad51c3551a14d$var$ka.test(a)) return $468ad51c3551a14d$var$ma[a] = !0;
    $468ad51c3551a14d$var$la[a] = !0;
    return !1;
}
function $468ad51c3551a14d$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $468ad51c3551a14d$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $468ad51c3551a14d$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $468ad51c3551a14d$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $468ad51c3551a14d$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $468ad51c3551a14d$var$z[a] = new $468ad51c3551a14d$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $468ad51c3551a14d$var$z[b] = new $468ad51c3551a14d$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $468ad51c3551a14d$var$z[a] = new $468ad51c3551a14d$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $468ad51c3551a14d$var$z[a] = new $468ad51c3551a14d$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $468ad51c3551a14d$var$z[a] = new $468ad51c3551a14d$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $468ad51c3551a14d$var$z[a] = new $468ad51c3551a14d$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $468ad51c3551a14d$var$z[a] = new $468ad51c3551a14d$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $468ad51c3551a14d$var$z[a] = new $468ad51c3551a14d$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $468ad51c3551a14d$var$z[a] = new $468ad51c3551a14d$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $468ad51c3551a14d$var$ra = /[\-:]([a-z])/g;
function $468ad51c3551a14d$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($468ad51c3551a14d$var$ra, $468ad51c3551a14d$var$sa);
    $468ad51c3551a14d$var$z[b] = new $468ad51c3551a14d$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($468ad51c3551a14d$var$ra, $468ad51c3551a14d$var$sa);
    $468ad51c3551a14d$var$z[b] = new $468ad51c3551a14d$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($468ad51c3551a14d$var$ra, $468ad51c3551a14d$var$sa);
    $468ad51c3551a14d$var$z[b] = new $468ad51c3551a14d$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $468ad51c3551a14d$var$z[a] = new $468ad51c3551a14d$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$468ad51c3551a14d$var$z.xlinkHref = new $468ad51c3551a14d$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $468ad51c3551a14d$var$z[a] = new $468ad51c3551a14d$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $468ad51c3551a14d$var$ta(a, b, c, d) {
    var e = $468ad51c3551a14d$var$z.hasOwnProperty(b) ? $468ad51c3551a14d$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $468ad51c3551a14d$var$qa(b, c, e, d) && (c = null), d || null === e ? $468ad51c3551a14d$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $468ad51c3551a14d$var$ua = $kc00y.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $468ad51c3551a14d$var$va = Symbol.for("react.element"), $468ad51c3551a14d$var$wa = Symbol.for("react.portal"), $468ad51c3551a14d$var$ya = Symbol.for("react.fragment"), $468ad51c3551a14d$var$za = Symbol.for("react.strict_mode"), $468ad51c3551a14d$var$Aa = Symbol.for("react.profiler"), $468ad51c3551a14d$var$Ba = Symbol.for("react.provider"), $468ad51c3551a14d$var$Ca = Symbol.for("react.context"), $468ad51c3551a14d$var$Da = Symbol.for("react.forward_ref"), $468ad51c3551a14d$var$Ea = Symbol.for("react.suspense"), $468ad51c3551a14d$var$Fa = Symbol.for("react.suspense_list"), $468ad51c3551a14d$var$Ga = Symbol.for("react.memo"), $468ad51c3551a14d$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $468ad51c3551a14d$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $468ad51c3551a14d$var$Ja = Symbol.iterator;
function $468ad51c3551a14d$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $468ad51c3551a14d$var$Ja && a[$468ad51c3551a14d$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $468ad51c3551a14d$var$A = Object.assign, $468ad51c3551a14d$var$La;
function $468ad51c3551a14d$var$Ma(a) {
    if (void 0 === $468ad51c3551a14d$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $468ad51c3551a14d$var$La = b && b[1] || "";
    }
    return "\n" + $468ad51c3551a14d$var$La + a;
}
var $468ad51c3551a14d$var$Na = !1;
function $468ad51c3551a14d$var$Oa(a, b) {
    if (!a || $468ad51c3551a14d$var$Na) return "";
    $468ad51c3551a14d$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $468ad51c3551a14d$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $468ad51c3551a14d$var$Ma(a) : "";
}
function $468ad51c3551a14d$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $468ad51c3551a14d$var$Ma(a.type);
        case 16:
            return $468ad51c3551a14d$var$Ma("Lazy");
        case 13:
            return $468ad51c3551a14d$var$Ma("Suspense");
        case 19:
            return $468ad51c3551a14d$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $468ad51c3551a14d$var$Oa(a.type, !1), a;
        case 11:
            return a = $468ad51c3551a14d$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $468ad51c3551a14d$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $468ad51c3551a14d$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $468ad51c3551a14d$var$ya:
            return "Fragment";
        case $468ad51c3551a14d$var$wa:
            return "Portal";
        case $468ad51c3551a14d$var$Aa:
            return "Profiler";
        case $468ad51c3551a14d$var$za:
            return "StrictMode";
        case $468ad51c3551a14d$var$Ea:
            return "Suspense";
        case $468ad51c3551a14d$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $468ad51c3551a14d$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $468ad51c3551a14d$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $468ad51c3551a14d$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $468ad51c3551a14d$var$Ga:
            return b = a.displayName || null, null !== b ? b : $468ad51c3551a14d$var$Qa(a.type) || "Memo";
        case $468ad51c3551a14d$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $468ad51c3551a14d$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $468ad51c3551a14d$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $468ad51c3551a14d$var$Qa(b);
        case 8:
            return b === $468ad51c3551a14d$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $468ad51c3551a14d$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $468ad51c3551a14d$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $468ad51c3551a14d$var$Ua(a) {
    var b = $468ad51c3551a14d$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $468ad51c3551a14d$var$Va(a) {
    a._valueTracker || (a._valueTracker = $468ad51c3551a14d$var$Ua(a));
}
function $468ad51c3551a14d$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $468ad51c3551a14d$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $468ad51c3551a14d$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $468ad51c3551a14d$var$Ya(a, b) {
    var c = b.checked;
    return $468ad51c3551a14d$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $468ad51c3551a14d$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $468ad51c3551a14d$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $468ad51c3551a14d$var$ab(a, b) {
    b = b.checked;
    null != b && $468ad51c3551a14d$var$ta(a, "checked", b, !1);
}
function $468ad51c3551a14d$var$bb(a, b) {
    $468ad51c3551a14d$var$ab(a, b);
    var c = $468ad51c3551a14d$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $468ad51c3551a14d$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $468ad51c3551a14d$var$cb(a, b.type, $468ad51c3551a14d$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $468ad51c3551a14d$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $468ad51c3551a14d$var$cb(a, b, c) {
    if ("number" !== b || $468ad51c3551a14d$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $468ad51c3551a14d$var$eb = Array.isArray;
function $468ad51c3551a14d$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $468ad51c3551a14d$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $468ad51c3551a14d$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($468ad51c3551a14d$var$p(91));
    return $468ad51c3551a14d$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $468ad51c3551a14d$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($468ad51c3551a14d$var$p(92));
            if ($468ad51c3551a14d$var$eb(c)) {
                if (1 < c.length) throw Error($468ad51c3551a14d$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $468ad51c3551a14d$var$Sa(c)
    };
}
function $468ad51c3551a14d$var$ib(a, b) {
    var c = $468ad51c3551a14d$var$Sa(b.value), d = $468ad51c3551a14d$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $468ad51c3551a14d$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $468ad51c3551a14d$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $468ad51c3551a14d$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $468ad51c3551a14d$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $468ad51c3551a14d$var$mb, $468ad51c3551a14d$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $468ad51c3551a14d$var$mb = $468ad51c3551a14d$var$mb || document.createElement("div");
        $468ad51c3551a14d$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $468ad51c3551a14d$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $468ad51c3551a14d$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $468ad51c3551a14d$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $468ad51c3551a14d$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($468ad51c3551a14d$var$pb).forEach(function(a) {
    $468ad51c3551a14d$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $468ad51c3551a14d$var$pb[b] = $468ad51c3551a14d$var$pb[a];
    });
});
function $468ad51c3551a14d$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $468ad51c3551a14d$var$pb.hasOwnProperty(a) && $468ad51c3551a14d$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $468ad51c3551a14d$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $468ad51c3551a14d$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $468ad51c3551a14d$var$tb = $468ad51c3551a14d$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $468ad51c3551a14d$var$ub(a, b) {
    if (b) {
        if ($468ad51c3551a14d$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($468ad51c3551a14d$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($468ad51c3551a14d$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($468ad51c3551a14d$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($468ad51c3551a14d$var$p(62));
    }
}
function $468ad51c3551a14d$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $468ad51c3551a14d$var$wb = null;
function $468ad51c3551a14d$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $468ad51c3551a14d$var$yb = null, $468ad51c3551a14d$var$zb = null, $468ad51c3551a14d$var$Ab = null;
function $468ad51c3551a14d$var$Bb(a) {
    if (a = $468ad51c3551a14d$var$Cb(a)) {
        if ("function" !== typeof $468ad51c3551a14d$var$yb) throw Error($468ad51c3551a14d$var$p(280));
        var b = a.stateNode;
        b && (b = $468ad51c3551a14d$var$Db(b), $468ad51c3551a14d$var$yb(a.stateNode, a.type, b));
    }
}
function $468ad51c3551a14d$var$Eb(a) {
    $468ad51c3551a14d$var$zb ? $468ad51c3551a14d$var$Ab ? $468ad51c3551a14d$var$Ab.push(a) : $468ad51c3551a14d$var$Ab = [
        a
    ] : $468ad51c3551a14d$var$zb = a;
}
function $468ad51c3551a14d$var$Fb() {
    if ($468ad51c3551a14d$var$zb) {
        var a = $468ad51c3551a14d$var$zb, b = $468ad51c3551a14d$var$Ab;
        $468ad51c3551a14d$var$Ab = $468ad51c3551a14d$var$zb = null;
        $468ad51c3551a14d$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$468ad51c3551a14d$var$Bb(b[a]);
    }
}
function $468ad51c3551a14d$var$Gb(a, b) {
    return a(b);
}
function $468ad51c3551a14d$var$Hb() {}
var $468ad51c3551a14d$var$Ib = !1;
function $468ad51c3551a14d$var$Jb(a, b, c) {
    if ($468ad51c3551a14d$var$Ib) return a(b, c);
    $468ad51c3551a14d$var$Ib = !0;
    try {
        return $468ad51c3551a14d$var$Gb(a, b, c);
    } finally{
        if ($468ad51c3551a14d$var$Ib = !1, null !== $468ad51c3551a14d$var$zb || null !== $468ad51c3551a14d$var$Ab) $468ad51c3551a14d$var$Hb(), $468ad51c3551a14d$var$Fb();
    }
}
function $468ad51c3551a14d$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $468ad51c3551a14d$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($468ad51c3551a14d$var$p(231, b, typeof c));
    return c;
}
var $468ad51c3551a14d$var$Lb = !1;
if ($468ad51c3551a14d$var$ia) try {
    var $468ad51c3551a14d$var$Mb = {};
    Object.defineProperty($468ad51c3551a14d$var$Mb, "passive", {
        get: function() {
            $468ad51c3551a14d$var$Lb = !0;
        }
    });
    window.addEventListener("test", $468ad51c3551a14d$var$Mb, $468ad51c3551a14d$var$Mb);
    window.removeEventListener("test", $468ad51c3551a14d$var$Mb, $468ad51c3551a14d$var$Mb);
} catch (a) {
    $468ad51c3551a14d$var$Lb = !1;
}
function $468ad51c3551a14d$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $468ad51c3551a14d$var$Ob = !1, $468ad51c3551a14d$var$Pb = null, $468ad51c3551a14d$var$Qb = !1, $468ad51c3551a14d$var$Rb = null, $468ad51c3551a14d$var$Sb = {
    onError: function(a) {
        $468ad51c3551a14d$var$Ob = !0;
        $468ad51c3551a14d$var$Pb = a;
    }
};
function $468ad51c3551a14d$var$Tb(a, b, c, d, e, f, g, h, k) {
    $468ad51c3551a14d$var$Ob = !1;
    $468ad51c3551a14d$var$Pb = null;
    $468ad51c3551a14d$var$Nb.apply($468ad51c3551a14d$var$Sb, arguments);
}
function $468ad51c3551a14d$var$Ub(a, b, c, d, e, f, g, h, k) {
    $468ad51c3551a14d$var$Tb.apply(this, arguments);
    if ($468ad51c3551a14d$var$Ob) {
        if ($468ad51c3551a14d$var$Ob) {
            var l = $468ad51c3551a14d$var$Pb;
            $468ad51c3551a14d$var$Ob = !1;
            $468ad51c3551a14d$var$Pb = null;
        } else throw Error($468ad51c3551a14d$var$p(198));
        $468ad51c3551a14d$var$Qb || ($468ad51c3551a14d$var$Qb = !0, $468ad51c3551a14d$var$Rb = l);
    }
}
function $468ad51c3551a14d$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $468ad51c3551a14d$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $468ad51c3551a14d$var$Xb(a) {
    if ($468ad51c3551a14d$var$Vb(a) !== a) throw Error($468ad51c3551a14d$var$p(188));
}
function $468ad51c3551a14d$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $468ad51c3551a14d$var$Vb(a);
        if (null === b) throw Error($468ad51c3551a14d$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $468ad51c3551a14d$var$Xb(e), a;
                if (f === d) return $468ad51c3551a14d$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($468ad51c3551a14d$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($468ad51c3551a14d$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($468ad51c3551a14d$var$p(190));
    }
    if (3 !== c.tag) throw Error($468ad51c3551a14d$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $468ad51c3551a14d$var$Zb(a) {
    a = $468ad51c3551a14d$var$Yb(a);
    return null !== a ? $468ad51c3551a14d$var$$b(a) : null;
}
function $468ad51c3551a14d$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $468ad51c3551a14d$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $468ad51c3551a14d$var$ac = $cV2f0.unstable_scheduleCallback, $468ad51c3551a14d$var$bc = $cV2f0.unstable_cancelCallback, $468ad51c3551a14d$var$cc = $cV2f0.unstable_shouldYield, $468ad51c3551a14d$var$dc = $cV2f0.unstable_requestPaint, $468ad51c3551a14d$var$B = $cV2f0.unstable_now, $468ad51c3551a14d$var$ec = $cV2f0.unstable_getCurrentPriorityLevel, $468ad51c3551a14d$var$fc = $cV2f0.unstable_ImmediatePriority, $468ad51c3551a14d$var$gc = $cV2f0.unstable_UserBlockingPriority, $468ad51c3551a14d$var$hc = $cV2f0.unstable_NormalPriority, $468ad51c3551a14d$var$ic = $cV2f0.unstable_LowPriority, $468ad51c3551a14d$var$jc = $cV2f0.unstable_IdlePriority, $468ad51c3551a14d$var$kc = null, $468ad51c3551a14d$var$lc = null;
function $468ad51c3551a14d$var$mc(a) {
    if ($468ad51c3551a14d$var$lc && "function" === typeof $468ad51c3551a14d$var$lc.onCommitFiberRoot) try {
        $468ad51c3551a14d$var$lc.onCommitFiberRoot($468ad51c3551a14d$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $468ad51c3551a14d$var$oc = Math.clz32 ? Math.clz32 : $468ad51c3551a14d$var$nc, $468ad51c3551a14d$var$pc = Math.log, $468ad51c3551a14d$var$qc = Math.LN2;
function $468ad51c3551a14d$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($468ad51c3551a14d$var$pc(a) / $468ad51c3551a14d$var$qc | 0) | 0;
}
var $468ad51c3551a14d$var$rc = 64, $468ad51c3551a14d$var$sc = 4194304;
function $468ad51c3551a14d$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $468ad51c3551a14d$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $468ad51c3551a14d$var$tc(h) : (f &= g, 0 !== f && (d = $468ad51c3551a14d$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $468ad51c3551a14d$var$tc(g) : 0 !== f && (d = $468ad51c3551a14d$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $468ad51c3551a14d$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $468ad51c3551a14d$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $468ad51c3551a14d$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $468ad51c3551a14d$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $468ad51c3551a14d$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $468ad51c3551a14d$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $468ad51c3551a14d$var$yc() {
    var a = $468ad51c3551a14d$var$rc;
    $468ad51c3551a14d$var$rc <<= 1;
    0 === ($468ad51c3551a14d$var$rc & 4194240) && ($468ad51c3551a14d$var$rc = 64);
    return a;
}
function $468ad51c3551a14d$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $468ad51c3551a14d$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $468ad51c3551a14d$var$oc(b);
    a[b] = c;
}
function $468ad51c3551a14d$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $468ad51c3551a14d$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $468ad51c3551a14d$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $468ad51c3551a14d$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $468ad51c3551a14d$var$C = 0;
function $468ad51c3551a14d$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $468ad51c3551a14d$var$Ec, $468ad51c3551a14d$var$Fc, $468ad51c3551a14d$var$Gc, $468ad51c3551a14d$var$Hc, $468ad51c3551a14d$var$Ic, $468ad51c3551a14d$var$Jc = !1, $468ad51c3551a14d$var$Kc = [], $468ad51c3551a14d$var$Lc = null, $468ad51c3551a14d$var$Mc = null, $468ad51c3551a14d$var$Nc = null, $468ad51c3551a14d$var$Oc = new Map, $468ad51c3551a14d$var$Pc = new Map, $468ad51c3551a14d$var$Qc = [], $468ad51c3551a14d$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $468ad51c3551a14d$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $468ad51c3551a14d$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $468ad51c3551a14d$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $468ad51c3551a14d$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $468ad51c3551a14d$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $468ad51c3551a14d$var$Pc.delete(b.pointerId);
    }
}
function $468ad51c3551a14d$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $468ad51c3551a14d$var$Cb(b), null !== b && $468ad51c3551a14d$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $468ad51c3551a14d$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $468ad51c3551a14d$var$Lc = $468ad51c3551a14d$var$Tc($468ad51c3551a14d$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $468ad51c3551a14d$var$Mc = $468ad51c3551a14d$var$Tc($468ad51c3551a14d$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $468ad51c3551a14d$var$Nc = $468ad51c3551a14d$var$Tc($468ad51c3551a14d$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $468ad51c3551a14d$var$Oc.set(f, $468ad51c3551a14d$var$Tc($468ad51c3551a14d$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $468ad51c3551a14d$var$Pc.set(f, $468ad51c3551a14d$var$Tc($468ad51c3551a14d$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $468ad51c3551a14d$var$Vc(a) {
    var b = $468ad51c3551a14d$var$Wc(a.target);
    if (null !== b) {
        var c = $468ad51c3551a14d$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $468ad51c3551a14d$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $468ad51c3551a14d$var$Ic(a.priority, function() {
                        $468ad51c3551a14d$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $468ad51c3551a14d$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $468ad51c3551a14d$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $468ad51c3551a14d$var$wb = d;
            c.target.dispatchEvent(d);
            $468ad51c3551a14d$var$wb = null;
        } else return b = $468ad51c3551a14d$var$Cb(c), null !== b && $468ad51c3551a14d$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $468ad51c3551a14d$var$Zc(a, b, c) {
    $468ad51c3551a14d$var$Xc(a) && c.delete(b);
}
function $468ad51c3551a14d$var$$c() {
    $468ad51c3551a14d$var$Jc = !1;
    null !== $468ad51c3551a14d$var$Lc && $468ad51c3551a14d$var$Xc($468ad51c3551a14d$var$Lc) && ($468ad51c3551a14d$var$Lc = null);
    null !== $468ad51c3551a14d$var$Mc && $468ad51c3551a14d$var$Xc($468ad51c3551a14d$var$Mc) && ($468ad51c3551a14d$var$Mc = null);
    null !== $468ad51c3551a14d$var$Nc && $468ad51c3551a14d$var$Xc($468ad51c3551a14d$var$Nc) && ($468ad51c3551a14d$var$Nc = null);
    $468ad51c3551a14d$var$Oc.forEach($468ad51c3551a14d$var$Zc);
    $468ad51c3551a14d$var$Pc.forEach($468ad51c3551a14d$var$Zc);
}
function $468ad51c3551a14d$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $468ad51c3551a14d$var$Jc || ($468ad51c3551a14d$var$Jc = !0, $cV2f0.unstable_scheduleCallback($cV2f0.unstable_NormalPriority, $468ad51c3551a14d$var$$c)));
}
function $468ad51c3551a14d$var$bd(a) {
    function b(b) {
        return $468ad51c3551a14d$var$ad(b, a);
    }
    if (0 < $468ad51c3551a14d$var$Kc.length) {
        $468ad51c3551a14d$var$ad($468ad51c3551a14d$var$Kc[0], a);
        for(var c = 1; c < $468ad51c3551a14d$var$Kc.length; c++){
            var d = $468ad51c3551a14d$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $468ad51c3551a14d$var$Lc && $468ad51c3551a14d$var$ad($468ad51c3551a14d$var$Lc, a);
    null !== $468ad51c3551a14d$var$Mc && $468ad51c3551a14d$var$ad($468ad51c3551a14d$var$Mc, a);
    null !== $468ad51c3551a14d$var$Nc && $468ad51c3551a14d$var$ad($468ad51c3551a14d$var$Nc, a);
    $468ad51c3551a14d$var$Oc.forEach(b);
    $468ad51c3551a14d$var$Pc.forEach(b);
    for(c = 0; c < $468ad51c3551a14d$var$Qc.length; c++)d = $468ad51c3551a14d$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $468ad51c3551a14d$var$Qc.length && (c = $468ad51c3551a14d$var$Qc[0], null === c.blockedOn);)$468ad51c3551a14d$var$Vc(c), null === c.blockedOn && $468ad51c3551a14d$var$Qc.shift();
}
var $468ad51c3551a14d$var$cd = $468ad51c3551a14d$var$ua.ReactCurrentBatchConfig, $468ad51c3551a14d$var$dd = !0;
function $468ad51c3551a14d$var$ed(a, b, c, d) {
    var e = $468ad51c3551a14d$var$C, f = $468ad51c3551a14d$var$cd.transition;
    $468ad51c3551a14d$var$cd.transition = null;
    try {
        $468ad51c3551a14d$var$C = 1, $468ad51c3551a14d$var$fd(a, b, c, d);
    } finally{
        $468ad51c3551a14d$var$C = e, $468ad51c3551a14d$var$cd.transition = f;
    }
}
function $468ad51c3551a14d$var$gd(a, b, c, d) {
    var e = $468ad51c3551a14d$var$C, f = $468ad51c3551a14d$var$cd.transition;
    $468ad51c3551a14d$var$cd.transition = null;
    try {
        $468ad51c3551a14d$var$C = 4, $468ad51c3551a14d$var$fd(a, b, c, d);
    } finally{
        $468ad51c3551a14d$var$C = e, $468ad51c3551a14d$var$cd.transition = f;
    }
}
function $468ad51c3551a14d$var$fd(a, b, c, d) {
    if ($468ad51c3551a14d$var$dd) {
        var e = $468ad51c3551a14d$var$Yc(a, b, c, d);
        if (null === e) $468ad51c3551a14d$var$hd(a, b, d, $468ad51c3551a14d$var$id, c), $468ad51c3551a14d$var$Sc(a, d);
        else if ($468ad51c3551a14d$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($468ad51c3551a14d$var$Sc(a, d), b & 4 && -1 < $468ad51c3551a14d$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $468ad51c3551a14d$var$Cb(e);
                null !== f && $468ad51c3551a14d$var$Ec(f);
                f = $468ad51c3551a14d$var$Yc(a, b, c, d);
                null === f && $468ad51c3551a14d$var$hd(a, b, d, $468ad51c3551a14d$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $468ad51c3551a14d$var$hd(a, b, d, null, c);
    }
}
var $468ad51c3551a14d$var$id = null;
function $468ad51c3551a14d$var$Yc(a, b, c, d) {
    $468ad51c3551a14d$var$id = null;
    a = $468ad51c3551a14d$var$xb(d);
    a = $468ad51c3551a14d$var$Wc(a);
    if (null !== a) {
        if (b = $468ad51c3551a14d$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $468ad51c3551a14d$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $468ad51c3551a14d$var$id = a;
    return null;
}
function $468ad51c3551a14d$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($468ad51c3551a14d$var$ec()){
                case $468ad51c3551a14d$var$fc:
                    return 1;
                case $468ad51c3551a14d$var$gc:
                    return 4;
                case $468ad51c3551a14d$var$hc:
                case $468ad51c3551a14d$var$ic:
                    return 16;
                case $468ad51c3551a14d$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $468ad51c3551a14d$var$kd = null, $468ad51c3551a14d$var$ld = null, $468ad51c3551a14d$var$md = null;
function $468ad51c3551a14d$var$nd() {
    if ($468ad51c3551a14d$var$md) return $468ad51c3551a14d$var$md;
    var a, b = $468ad51c3551a14d$var$ld, c = b.length, d, e = "value" in $468ad51c3551a14d$var$kd ? $468ad51c3551a14d$var$kd.value : $468ad51c3551a14d$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $468ad51c3551a14d$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $468ad51c3551a14d$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $468ad51c3551a14d$var$pd() {
    return !0;
}
function $468ad51c3551a14d$var$qd() {
    return !1;
}
function $468ad51c3551a14d$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $468ad51c3551a14d$var$pd : $468ad51c3551a14d$var$qd;
        this.isPropagationStopped = $468ad51c3551a14d$var$qd;
        return this;
    }
    $468ad51c3551a14d$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $468ad51c3551a14d$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $468ad51c3551a14d$var$pd);
        },
        persist: function() {},
        isPersistent: $468ad51c3551a14d$var$pd
    });
    return b;
}
var $468ad51c3551a14d$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $468ad51c3551a14d$var$td = $468ad51c3551a14d$var$rd($468ad51c3551a14d$var$sd), $468ad51c3551a14d$var$ud = $468ad51c3551a14d$var$A({}, $468ad51c3551a14d$var$sd, {
    view: 0,
    detail: 0
}), $468ad51c3551a14d$var$vd = $468ad51c3551a14d$var$rd($468ad51c3551a14d$var$ud), $468ad51c3551a14d$var$wd, $468ad51c3551a14d$var$xd, $468ad51c3551a14d$var$yd, $468ad51c3551a14d$var$Ad = $468ad51c3551a14d$var$A({}, $468ad51c3551a14d$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $468ad51c3551a14d$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $468ad51c3551a14d$var$yd && ($468ad51c3551a14d$var$yd && "mousemove" === a.type ? ($468ad51c3551a14d$var$wd = a.screenX - $468ad51c3551a14d$var$yd.screenX, $468ad51c3551a14d$var$xd = a.screenY - $468ad51c3551a14d$var$yd.screenY) : $468ad51c3551a14d$var$xd = $468ad51c3551a14d$var$wd = 0, $468ad51c3551a14d$var$yd = a);
        return $468ad51c3551a14d$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $468ad51c3551a14d$var$xd;
    }
}), $468ad51c3551a14d$var$Bd = $468ad51c3551a14d$var$rd($468ad51c3551a14d$var$Ad), $468ad51c3551a14d$var$Cd = $468ad51c3551a14d$var$A({}, $468ad51c3551a14d$var$Ad, {
    dataTransfer: 0
}), $468ad51c3551a14d$var$Dd = $468ad51c3551a14d$var$rd($468ad51c3551a14d$var$Cd), $468ad51c3551a14d$var$Ed = $468ad51c3551a14d$var$A({}, $468ad51c3551a14d$var$ud, {
    relatedTarget: 0
}), $468ad51c3551a14d$var$Fd = $468ad51c3551a14d$var$rd($468ad51c3551a14d$var$Ed), $468ad51c3551a14d$var$Gd = $468ad51c3551a14d$var$A({}, $468ad51c3551a14d$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $468ad51c3551a14d$var$Hd = $468ad51c3551a14d$var$rd($468ad51c3551a14d$var$Gd), $468ad51c3551a14d$var$Id = $468ad51c3551a14d$var$A({}, $468ad51c3551a14d$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $468ad51c3551a14d$var$Jd = $468ad51c3551a14d$var$rd($468ad51c3551a14d$var$Id), $468ad51c3551a14d$var$Kd = $468ad51c3551a14d$var$A({}, $468ad51c3551a14d$var$sd, {
    data: 0
}), $468ad51c3551a14d$var$Ld = $468ad51c3551a14d$var$rd($468ad51c3551a14d$var$Kd), $468ad51c3551a14d$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $468ad51c3551a14d$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $468ad51c3551a14d$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $468ad51c3551a14d$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $468ad51c3551a14d$var$Od[a]) ? !!b[a] : !1;
}
function $468ad51c3551a14d$var$zd() {
    return $468ad51c3551a14d$var$Pd;
}
var $468ad51c3551a14d$var$Qd = $468ad51c3551a14d$var$A({}, $468ad51c3551a14d$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $468ad51c3551a14d$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $468ad51c3551a14d$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $468ad51c3551a14d$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $468ad51c3551a14d$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $468ad51c3551a14d$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $468ad51c3551a14d$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $468ad51c3551a14d$var$Rd = $468ad51c3551a14d$var$rd($468ad51c3551a14d$var$Qd), $468ad51c3551a14d$var$Sd = $468ad51c3551a14d$var$A({}, $468ad51c3551a14d$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $468ad51c3551a14d$var$Td = $468ad51c3551a14d$var$rd($468ad51c3551a14d$var$Sd), $468ad51c3551a14d$var$Ud = $468ad51c3551a14d$var$A({}, $468ad51c3551a14d$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $468ad51c3551a14d$var$zd
}), $468ad51c3551a14d$var$Vd = $468ad51c3551a14d$var$rd($468ad51c3551a14d$var$Ud), $468ad51c3551a14d$var$Wd = $468ad51c3551a14d$var$A({}, $468ad51c3551a14d$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $468ad51c3551a14d$var$Xd = $468ad51c3551a14d$var$rd($468ad51c3551a14d$var$Wd), $468ad51c3551a14d$var$Yd = $468ad51c3551a14d$var$A({}, $468ad51c3551a14d$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $468ad51c3551a14d$var$Zd = $468ad51c3551a14d$var$rd($468ad51c3551a14d$var$Yd), $468ad51c3551a14d$var$$d = [
    9,
    13,
    27,
    32
], $468ad51c3551a14d$var$ae = $468ad51c3551a14d$var$ia && "CompositionEvent" in window, $468ad51c3551a14d$var$be = null;
$468ad51c3551a14d$var$ia && "documentMode" in document && ($468ad51c3551a14d$var$be = document.documentMode);
var $468ad51c3551a14d$var$ce = $468ad51c3551a14d$var$ia && "TextEvent" in window && !$468ad51c3551a14d$var$be, $468ad51c3551a14d$var$de = $468ad51c3551a14d$var$ia && (!$468ad51c3551a14d$var$ae || $468ad51c3551a14d$var$be && 8 < $468ad51c3551a14d$var$be && 11 >= $468ad51c3551a14d$var$be), $468ad51c3551a14d$var$ee = String.fromCharCode(32), $468ad51c3551a14d$var$fe = !1;
function $468ad51c3551a14d$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $468ad51c3551a14d$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $468ad51c3551a14d$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $468ad51c3551a14d$var$ie = !1;
function $468ad51c3551a14d$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $468ad51c3551a14d$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $468ad51c3551a14d$var$fe = !0;
            return $468ad51c3551a14d$var$ee;
        case "textInput":
            return a = b.data, a === $468ad51c3551a14d$var$ee && $468ad51c3551a14d$var$fe ? null : a;
        default:
            return null;
    }
}
function $468ad51c3551a14d$var$ke(a, b) {
    if ($468ad51c3551a14d$var$ie) return "compositionend" === a || !$468ad51c3551a14d$var$ae && $468ad51c3551a14d$var$ge(a, b) ? (a = $468ad51c3551a14d$var$nd(), $468ad51c3551a14d$var$md = $468ad51c3551a14d$var$ld = $468ad51c3551a14d$var$kd = null, $468ad51c3551a14d$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $468ad51c3551a14d$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $468ad51c3551a14d$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $468ad51c3551a14d$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$468ad51c3551a14d$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $468ad51c3551a14d$var$ne(a, b, c, d) {
    $468ad51c3551a14d$var$Eb(d);
    b = $468ad51c3551a14d$var$oe(b, "onChange");
    0 < b.length && (c = new $468ad51c3551a14d$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $468ad51c3551a14d$var$pe = null, $468ad51c3551a14d$var$qe = null;
function $468ad51c3551a14d$var$re(a) {
    $468ad51c3551a14d$var$se(a, 0);
}
function $468ad51c3551a14d$var$te(a) {
    var b = $468ad51c3551a14d$var$ue(a);
    if ($468ad51c3551a14d$var$Wa(b)) return a;
}
function $468ad51c3551a14d$var$ve(a, b) {
    if ("change" === a) return b;
}
var $468ad51c3551a14d$var$we = !1;
if ($468ad51c3551a14d$var$ia) {
    var $468ad51c3551a14d$var$xe;
    if ($468ad51c3551a14d$var$ia) {
        var $468ad51c3551a14d$var$ye = "oninput" in document;
        if (!$468ad51c3551a14d$var$ye) {
            var $468ad51c3551a14d$var$ze = document.createElement("div");
            $468ad51c3551a14d$var$ze.setAttribute("oninput", "return;");
            $468ad51c3551a14d$var$ye = "function" === typeof $468ad51c3551a14d$var$ze.oninput;
        }
        $468ad51c3551a14d$var$xe = $468ad51c3551a14d$var$ye;
    } else $468ad51c3551a14d$var$xe = !1;
    $468ad51c3551a14d$var$we = $468ad51c3551a14d$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $468ad51c3551a14d$var$Ae() {
    $468ad51c3551a14d$var$pe && ($468ad51c3551a14d$var$pe.detachEvent("onpropertychange", $468ad51c3551a14d$var$Be), $468ad51c3551a14d$var$qe = $468ad51c3551a14d$var$pe = null);
}
function $468ad51c3551a14d$var$Be(a) {
    if ("value" === a.propertyName && $468ad51c3551a14d$var$te($468ad51c3551a14d$var$qe)) {
        var b = [];
        $468ad51c3551a14d$var$ne(b, $468ad51c3551a14d$var$qe, a, $468ad51c3551a14d$var$xb(a));
        $468ad51c3551a14d$var$Jb($468ad51c3551a14d$var$re, b);
    }
}
function $468ad51c3551a14d$var$Ce(a, b, c) {
    "focusin" === a ? ($468ad51c3551a14d$var$Ae(), $468ad51c3551a14d$var$pe = b, $468ad51c3551a14d$var$qe = c, $468ad51c3551a14d$var$pe.attachEvent("onpropertychange", $468ad51c3551a14d$var$Be)) : "focusout" === a && $468ad51c3551a14d$var$Ae();
}
function $468ad51c3551a14d$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $468ad51c3551a14d$var$te($468ad51c3551a14d$var$qe);
}
function $468ad51c3551a14d$var$Ee(a, b) {
    if ("click" === a) return $468ad51c3551a14d$var$te(b);
}
function $468ad51c3551a14d$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $468ad51c3551a14d$var$te(b);
}
function $468ad51c3551a14d$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $468ad51c3551a14d$var$He = "function" === typeof Object.is ? Object.is : $468ad51c3551a14d$var$Ge;
function $468ad51c3551a14d$var$Ie(a, b) {
    if ($468ad51c3551a14d$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$468ad51c3551a14d$var$ja.call(b, e) || !$468ad51c3551a14d$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $468ad51c3551a14d$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $468ad51c3551a14d$var$Ke(a, b) {
    var c = $468ad51c3551a14d$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $468ad51c3551a14d$var$Je(c);
    }
}
function $468ad51c3551a14d$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $468ad51c3551a14d$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $468ad51c3551a14d$var$Me() {
    for(var a = window, b = $468ad51c3551a14d$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $468ad51c3551a14d$var$Xa(a.document);
    }
    return b;
}
function $468ad51c3551a14d$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $468ad51c3551a14d$var$Oe(a) {
    var b = $468ad51c3551a14d$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $468ad51c3551a14d$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $468ad51c3551a14d$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $468ad51c3551a14d$var$Ke(c, f);
                var g = $468ad51c3551a14d$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $468ad51c3551a14d$var$Pe = $468ad51c3551a14d$var$ia && "documentMode" in document && 11 >= document.documentMode, $468ad51c3551a14d$var$Qe = null, $468ad51c3551a14d$var$Re = null, $468ad51c3551a14d$var$Se = null, $468ad51c3551a14d$var$Te = !1;
function $468ad51c3551a14d$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $468ad51c3551a14d$var$Te || null == $468ad51c3551a14d$var$Qe || $468ad51c3551a14d$var$Qe !== $468ad51c3551a14d$var$Xa(d) || (d = $468ad51c3551a14d$var$Qe, "selectionStart" in d && $468ad51c3551a14d$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $468ad51c3551a14d$var$Se && $468ad51c3551a14d$var$Ie($468ad51c3551a14d$var$Se, d) || ($468ad51c3551a14d$var$Se = d, d = $468ad51c3551a14d$var$oe($468ad51c3551a14d$var$Re, "onSelect"), 0 < d.length && (b = new $468ad51c3551a14d$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $468ad51c3551a14d$var$Qe)));
}
function $468ad51c3551a14d$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $468ad51c3551a14d$var$We = {
    animationend: $468ad51c3551a14d$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $468ad51c3551a14d$var$Ve("Animation", "AnimationIteration"),
    animationstart: $468ad51c3551a14d$var$Ve("Animation", "AnimationStart"),
    transitionend: $468ad51c3551a14d$var$Ve("Transition", "TransitionEnd")
}, $468ad51c3551a14d$var$Xe = {}, $468ad51c3551a14d$var$Ye = {};
$468ad51c3551a14d$var$ia && ($468ad51c3551a14d$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $468ad51c3551a14d$var$We.animationend.animation, delete $468ad51c3551a14d$var$We.animationiteration.animation, delete $468ad51c3551a14d$var$We.animationstart.animation), "TransitionEvent" in window || delete $468ad51c3551a14d$var$We.transitionend.transition);
function $468ad51c3551a14d$var$Ze(a) {
    if ($468ad51c3551a14d$var$Xe[a]) return $468ad51c3551a14d$var$Xe[a];
    if (!$468ad51c3551a14d$var$We[a]) return a;
    var b = $468ad51c3551a14d$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $468ad51c3551a14d$var$Ye) return $468ad51c3551a14d$var$Xe[a] = b[c];
    return a;
}
var $468ad51c3551a14d$var$$e = $468ad51c3551a14d$var$Ze("animationend"), $468ad51c3551a14d$var$af = $468ad51c3551a14d$var$Ze("animationiteration"), $468ad51c3551a14d$var$bf = $468ad51c3551a14d$var$Ze("animationstart"), $468ad51c3551a14d$var$cf = $468ad51c3551a14d$var$Ze("transitionend"), $468ad51c3551a14d$var$df = new Map, $468ad51c3551a14d$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $468ad51c3551a14d$var$ff(a, b) {
    $468ad51c3551a14d$var$df.set(a, b);
    $468ad51c3551a14d$var$fa(b, [
        a
    ]);
}
for(var $468ad51c3551a14d$var$gf = 0; $468ad51c3551a14d$var$gf < $468ad51c3551a14d$var$ef.length; $468ad51c3551a14d$var$gf++){
    var $468ad51c3551a14d$var$hf = $468ad51c3551a14d$var$ef[$468ad51c3551a14d$var$gf], $468ad51c3551a14d$var$jf = $468ad51c3551a14d$var$hf.toLowerCase(), $468ad51c3551a14d$var$kf = $468ad51c3551a14d$var$hf[0].toUpperCase() + $468ad51c3551a14d$var$hf.slice(1);
    $468ad51c3551a14d$var$ff($468ad51c3551a14d$var$jf, "on" + $468ad51c3551a14d$var$kf);
}
$468ad51c3551a14d$var$ff($468ad51c3551a14d$var$$e, "onAnimationEnd");
$468ad51c3551a14d$var$ff($468ad51c3551a14d$var$af, "onAnimationIteration");
$468ad51c3551a14d$var$ff($468ad51c3551a14d$var$bf, "onAnimationStart");
$468ad51c3551a14d$var$ff("dblclick", "onDoubleClick");
$468ad51c3551a14d$var$ff("focusin", "onFocus");
$468ad51c3551a14d$var$ff("focusout", "onBlur");
$468ad51c3551a14d$var$ff($468ad51c3551a14d$var$cf, "onTransitionEnd");
$468ad51c3551a14d$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$468ad51c3551a14d$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$468ad51c3551a14d$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$468ad51c3551a14d$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$468ad51c3551a14d$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$468ad51c3551a14d$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$468ad51c3551a14d$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$468ad51c3551a14d$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$468ad51c3551a14d$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$468ad51c3551a14d$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $468ad51c3551a14d$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $468ad51c3551a14d$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($468ad51c3551a14d$var$lf));
function $468ad51c3551a14d$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $468ad51c3551a14d$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $468ad51c3551a14d$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $468ad51c3551a14d$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $468ad51c3551a14d$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($468ad51c3551a14d$var$Qb) throw a = $468ad51c3551a14d$var$Rb, $468ad51c3551a14d$var$Qb = !1, $468ad51c3551a14d$var$Rb = null, a;
}
function $468ad51c3551a14d$var$D(a, b) {
    var c = b[$468ad51c3551a14d$var$of];
    void 0 === c && (c = b[$468ad51c3551a14d$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($468ad51c3551a14d$var$pf(b, a, 2, !1), c.add(d));
}
function $468ad51c3551a14d$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $468ad51c3551a14d$var$pf(c, a, d, b);
}
var $468ad51c3551a14d$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $468ad51c3551a14d$var$sf(a) {
    if (!a[$468ad51c3551a14d$var$rf]) {
        a[$468ad51c3551a14d$var$rf] = !0;
        $468ad51c3551a14d$var$da.forEach(function(b) {
            "selectionchange" !== b && ($468ad51c3551a14d$var$mf.has(b) || $468ad51c3551a14d$var$qf(b, !1, a), $468ad51c3551a14d$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$468ad51c3551a14d$var$rf] || (b[$468ad51c3551a14d$var$rf] = !0, $468ad51c3551a14d$var$qf("selectionchange", !1, b));
    }
}
function $468ad51c3551a14d$var$pf(a, b, c, d) {
    switch($468ad51c3551a14d$var$jd(b)){
        case 1:
            var e = $468ad51c3551a14d$var$ed;
            break;
        case 4:
            e = $468ad51c3551a14d$var$gd;
            break;
        default:
            e = $468ad51c3551a14d$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$468ad51c3551a14d$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $468ad51c3551a14d$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $468ad51c3551a14d$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $468ad51c3551a14d$var$Jb(function() {
        var d = f, e = $468ad51c3551a14d$var$xb(c), g = [];
        a: {
            var h = $468ad51c3551a14d$var$df.get(a);
            if (void 0 !== h) {
                var k = $468ad51c3551a14d$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $468ad51c3551a14d$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $468ad51c3551a14d$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $468ad51c3551a14d$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $468ad51c3551a14d$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $468ad51c3551a14d$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $468ad51c3551a14d$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $468ad51c3551a14d$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $468ad51c3551a14d$var$Vd;
                        break;
                    case $468ad51c3551a14d$var$$e:
                    case $468ad51c3551a14d$var$af:
                    case $468ad51c3551a14d$var$bf:
                        k = $468ad51c3551a14d$var$Hd;
                        break;
                    case $468ad51c3551a14d$var$cf:
                        k = $468ad51c3551a14d$var$Xd;
                        break;
                    case "scroll":
                        k = $468ad51c3551a14d$var$vd;
                        break;
                    case "wheel":
                        k = $468ad51c3551a14d$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $468ad51c3551a14d$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $468ad51c3551a14d$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $468ad51c3551a14d$var$Kb(w, x), null != F && t.push($468ad51c3551a14d$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $468ad51c3551a14d$var$wb && (n = c.relatedTarget || c.fromElement) && ($468ad51c3551a14d$var$Wc(n) || n[$468ad51c3551a14d$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $468ad51c3551a14d$var$Wc(n) : null, null !== n && (J = $468ad51c3551a14d$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $468ad51c3551a14d$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $468ad51c3551a14d$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $468ad51c3551a14d$var$ue(k);
                        u = null == n ? h : $468ad51c3551a14d$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $468ad51c3551a14d$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $468ad51c3551a14d$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $468ad51c3551a14d$var$vf(F))u++;
                            for(; 0 < w - u;)t = $468ad51c3551a14d$var$vf(t), w--;
                            for(; 0 < u - w;)x = $468ad51c3551a14d$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $468ad51c3551a14d$var$vf(t);
                                x = $468ad51c3551a14d$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $468ad51c3551a14d$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $468ad51c3551a14d$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $468ad51c3551a14d$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $468ad51c3551a14d$var$ve;
                else if ($468ad51c3551a14d$var$me(h)) {
                    if ($468ad51c3551a14d$var$we) na = $468ad51c3551a14d$var$Fe;
                    else {
                        na = $468ad51c3551a14d$var$De;
                        var xa = $468ad51c3551a14d$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $468ad51c3551a14d$var$Ee);
                if (na && (na = na(a, d))) {
                    $468ad51c3551a14d$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $468ad51c3551a14d$var$cb(h, "number", h.value);
            }
            xa = d ? $468ad51c3551a14d$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($468ad51c3551a14d$var$me(xa) || "true" === xa.contentEditable) $468ad51c3551a14d$var$Qe = xa, $468ad51c3551a14d$var$Re = d, $468ad51c3551a14d$var$Se = null;
                    break;
                case "focusout":
                    $468ad51c3551a14d$var$Se = $468ad51c3551a14d$var$Re = $468ad51c3551a14d$var$Qe = null;
                    break;
                case "mousedown":
                    $468ad51c3551a14d$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $468ad51c3551a14d$var$Te = !1;
                    $468ad51c3551a14d$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($468ad51c3551a14d$var$Pe) break;
                case "keydown":
                case "keyup":
                    $468ad51c3551a14d$var$Ue(g, c, e);
            }
            var $a;
            if ($468ad51c3551a14d$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $468ad51c3551a14d$var$ie ? $468ad51c3551a14d$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($468ad51c3551a14d$var$de && "ko" !== c.locale && ($468ad51c3551a14d$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $468ad51c3551a14d$var$ie && ($a = $468ad51c3551a14d$var$nd()) : ($468ad51c3551a14d$var$kd = e, $468ad51c3551a14d$var$ld = "value" in $468ad51c3551a14d$var$kd ? $468ad51c3551a14d$var$kd.value : $468ad51c3551a14d$var$kd.textContent, $468ad51c3551a14d$var$ie = !0)), xa = $468ad51c3551a14d$var$oe(d, ba), 0 < xa.length && (ba = new $468ad51c3551a14d$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $468ad51c3551a14d$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $468ad51c3551a14d$var$ce ? $468ad51c3551a14d$var$je(a, c) : $468ad51c3551a14d$var$ke(a, c)) d = $468ad51c3551a14d$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $468ad51c3551a14d$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $468ad51c3551a14d$var$se(g, b);
    });
}
function $468ad51c3551a14d$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $468ad51c3551a14d$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $468ad51c3551a14d$var$Kb(a, c), null != f && d.unshift($468ad51c3551a14d$var$tf(a, f, e)), f = $468ad51c3551a14d$var$Kb(a, b), null != f && d.push($468ad51c3551a14d$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $468ad51c3551a14d$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $468ad51c3551a14d$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $468ad51c3551a14d$var$Kb(c, f), null != k && g.unshift($468ad51c3551a14d$var$tf(c, k, h))) : e || (k = $468ad51c3551a14d$var$Kb(c, f), null != k && g.push($468ad51c3551a14d$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $468ad51c3551a14d$var$xf = /\r\n?/g, $468ad51c3551a14d$var$yf = /\u0000|\uFFFD/g;
function $468ad51c3551a14d$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($468ad51c3551a14d$var$xf, "\n").replace($468ad51c3551a14d$var$yf, "");
}
function $468ad51c3551a14d$var$Af(a, b, c) {
    b = $468ad51c3551a14d$var$zf(b);
    if ($468ad51c3551a14d$var$zf(a) !== b && c) throw Error($468ad51c3551a14d$var$p(425));
}
function $468ad51c3551a14d$var$Bf() {}
var $468ad51c3551a14d$var$Cf = null, $468ad51c3551a14d$var$Df = null;
function $468ad51c3551a14d$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $468ad51c3551a14d$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $468ad51c3551a14d$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $468ad51c3551a14d$var$Hf = "function" === typeof Promise ? Promise : void 0, $468ad51c3551a14d$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $468ad51c3551a14d$var$Hf ? function(a) {
    return $468ad51c3551a14d$var$Hf.resolve(null).then(a).catch($468ad51c3551a14d$var$If);
} : $468ad51c3551a14d$var$Ff;
function $468ad51c3551a14d$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $468ad51c3551a14d$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $468ad51c3551a14d$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $468ad51c3551a14d$var$bd(b);
}
function $468ad51c3551a14d$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $468ad51c3551a14d$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $468ad51c3551a14d$var$Nf = Math.random().toString(36).slice(2), $468ad51c3551a14d$var$Of = "__reactFiber$" + $468ad51c3551a14d$var$Nf, $468ad51c3551a14d$var$Pf = "__reactProps$" + $468ad51c3551a14d$var$Nf, $468ad51c3551a14d$var$uf = "__reactContainer$" + $468ad51c3551a14d$var$Nf, $468ad51c3551a14d$var$of = "__reactEvents$" + $468ad51c3551a14d$var$Nf, $468ad51c3551a14d$var$Qf = "__reactListeners$" + $468ad51c3551a14d$var$Nf, $468ad51c3551a14d$var$Rf = "__reactHandles$" + $468ad51c3551a14d$var$Nf;
function $468ad51c3551a14d$var$Wc(a) {
    var b = a[$468ad51c3551a14d$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$468ad51c3551a14d$var$uf] || c[$468ad51c3551a14d$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $468ad51c3551a14d$var$Mf(a); null !== a;){
                if (c = a[$468ad51c3551a14d$var$Of]) return c;
                a = $468ad51c3551a14d$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $468ad51c3551a14d$var$Cb(a) {
    a = a[$468ad51c3551a14d$var$Of] || a[$468ad51c3551a14d$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $468ad51c3551a14d$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($468ad51c3551a14d$var$p(33));
}
function $468ad51c3551a14d$var$Db(a) {
    return a[$468ad51c3551a14d$var$Pf] || null;
}
var $468ad51c3551a14d$var$Sf = [], $468ad51c3551a14d$var$Tf = -1;
function $468ad51c3551a14d$var$Uf(a) {
    return {
        current: a
    };
}
function $468ad51c3551a14d$var$E(a) {
    0 > $468ad51c3551a14d$var$Tf || (a.current = $468ad51c3551a14d$var$Sf[$468ad51c3551a14d$var$Tf], $468ad51c3551a14d$var$Sf[$468ad51c3551a14d$var$Tf] = null, $468ad51c3551a14d$var$Tf--);
}
function $468ad51c3551a14d$var$G(a, b) {
    $468ad51c3551a14d$var$Tf++;
    $468ad51c3551a14d$var$Sf[$468ad51c3551a14d$var$Tf] = a.current;
    a.current = b;
}
var $468ad51c3551a14d$var$Vf = {}, $468ad51c3551a14d$var$H = $468ad51c3551a14d$var$Uf($468ad51c3551a14d$var$Vf), $468ad51c3551a14d$var$Wf = $468ad51c3551a14d$var$Uf(!1), $468ad51c3551a14d$var$Xf = $468ad51c3551a14d$var$Vf;
function $468ad51c3551a14d$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $468ad51c3551a14d$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $468ad51c3551a14d$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $468ad51c3551a14d$var$$f() {
    $468ad51c3551a14d$var$E($468ad51c3551a14d$var$Wf);
    $468ad51c3551a14d$var$E($468ad51c3551a14d$var$H);
}
function $468ad51c3551a14d$var$ag(a, b, c) {
    if ($468ad51c3551a14d$var$H.current !== $468ad51c3551a14d$var$Vf) throw Error($468ad51c3551a14d$var$p(168));
    $468ad51c3551a14d$var$G($468ad51c3551a14d$var$H, b);
    $468ad51c3551a14d$var$G($468ad51c3551a14d$var$Wf, c);
}
function $468ad51c3551a14d$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($468ad51c3551a14d$var$p(108, $468ad51c3551a14d$var$Ra(a) || "Unknown", e));
    return $468ad51c3551a14d$var$A({}, c, d);
}
function $468ad51c3551a14d$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $468ad51c3551a14d$var$Vf;
    $468ad51c3551a14d$var$Xf = $468ad51c3551a14d$var$H.current;
    $468ad51c3551a14d$var$G($468ad51c3551a14d$var$H, a);
    $468ad51c3551a14d$var$G($468ad51c3551a14d$var$Wf, $468ad51c3551a14d$var$Wf.current);
    return !0;
}
function $468ad51c3551a14d$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($468ad51c3551a14d$var$p(169));
    c ? (a = $468ad51c3551a14d$var$bg(a, b, $468ad51c3551a14d$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $468ad51c3551a14d$var$E($468ad51c3551a14d$var$Wf), $468ad51c3551a14d$var$E($468ad51c3551a14d$var$H), $468ad51c3551a14d$var$G($468ad51c3551a14d$var$H, a)) : $468ad51c3551a14d$var$E($468ad51c3551a14d$var$Wf);
    $468ad51c3551a14d$var$G($468ad51c3551a14d$var$Wf, c);
}
var $468ad51c3551a14d$var$eg = null, $468ad51c3551a14d$var$fg = !1, $468ad51c3551a14d$var$gg = !1;
function $468ad51c3551a14d$var$hg(a) {
    null === $468ad51c3551a14d$var$eg ? $468ad51c3551a14d$var$eg = [
        a
    ] : $468ad51c3551a14d$var$eg.push(a);
}
function $468ad51c3551a14d$var$ig(a) {
    $468ad51c3551a14d$var$fg = !0;
    $468ad51c3551a14d$var$hg(a);
}
function $468ad51c3551a14d$var$jg() {
    if (!$468ad51c3551a14d$var$gg && null !== $468ad51c3551a14d$var$eg) {
        $468ad51c3551a14d$var$gg = !0;
        var a = 0, b = $468ad51c3551a14d$var$C;
        try {
            var c = $468ad51c3551a14d$var$eg;
            for($468ad51c3551a14d$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $468ad51c3551a14d$var$eg = null;
            $468ad51c3551a14d$var$fg = !1;
        } catch (e) {
            throw null !== $468ad51c3551a14d$var$eg && ($468ad51c3551a14d$var$eg = $468ad51c3551a14d$var$eg.slice(a + 1)), $468ad51c3551a14d$var$ac($468ad51c3551a14d$var$fc, $468ad51c3551a14d$var$jg), e;
        } finally{
            $468ad51c3551a14d$var$C = b, $468ad51c3551a14d$var$gg = !1;
        }
    }
    return null;
}
var $468ad51c3551a14d$var$kg = [], $468ad51c3551a14d$var$lg = 0, $468ad51c3551a14d$var$mg = null, $468ad51c3551a14d$var$ng = 0, $468ad51c3551a14d$var$og = [], $468ad51c3551a14d$var$pg = 0, $468ad51c3551a14d$var$qg = null, $468ad51c3551a14d$var$rg = 1, $468ad51c3551a14d$var$sg = "";
function $468ad51c3551a14d$var$tg(a, b) {
    $468ad51c3551a14d$var$kg[$468ad51c3551a14d$var$lg++] = $468ad51c3551a14d$var$ng;
    $468ad51c3551a14d$var$kg[$468ad51c3551a14d$var$lg++] = $468ad51c3551a14d$var$mg;
    $468ad51c3551a14d$var$mg = a;
    $468ad51c3551a14d$var$ng = b;
}
function $468ad51c3551a14d$var$ug(a, b, c) {
    $468ad51c3551a14d$var$og[$468ad51c3551a14d$var$pg++] = $468ad51c3551a14d$var$rg;
    $468ad51c3551a14d$var$og[$468ad51c3551a14d$var$pg++] = $468ad51c3551a14d$var$sg;
    $468ad51c3551a14d$var$og[$468ad51c3551a14d$var$pg++] = $468ad51c3551a14d$var$qg;
    $468ad51c3551a14d$var$qg = a;
    var d = $468ad51c3551a14d$var$rg;
    a = $468ad51c3551a14d$var$sg;
    var e = 32 - $468ad51c3551a14d$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $468ad51c3551a14d$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $468ad51c3551a14d$var$rg = 1 << 32 - $468ad51c3551a14d$var$oc(b) + e | c << e | d;
        $468ad51c3551a14d$var$sg = f + a;
    } else $468ad51c3551a14d$var$rg = 1 << f | c << e | d, $468ad51c3551a14d$var$sg = a;
}
function $468ad51c3551a14d$var$vg(a) {
    null !== a.return && ($468ad51c3551a14d$var$tg(a, 1), $468ad51c3551a14d$var$ug(a, 1, 0));
}
function $468ad51c3551a14d$var$wg(a) {
    for(; a === $468ad51c3551a14d$var$mg;)$468ad51c3551a14d$var$mg = $468ad51c3551a14d$var$kg[--$468ad51c3551a14d$var$lg], $468ad51c3551a14d$var$kg[$468ad51c3551a14d$var$lg] = null, $468ad51c3551a14d$var$ng = $468ad51c3551a14d$var$kg[--$468ad51c3551a14d$var$lg], $468ad51c3551a14d$var$kg[$468ad51c3551a14d$var$lg] = null;
    for(; a === $468ad51c3551a14d$var$qg;)$468ad51c3551a14d$var$qg = $468ad51c3551a14d$var$og[--$468ad51c3551a14d$var$pg], $468ad51c3551a14d$var$og[$468ad51c3551a14d$var$pg] = null, $468ad51c3551a14d$var$sg = $468ad51c3551a14d$var$og[--$468ad51c3551a14d$var$pg], $468ad51c3551a14d$var$og[$468ad51c3551a14d$var$pg] = null, $468ad51c3551a14d$var$rg = $468ad51c3551a14d$var$og[--$468ad51c3551a14d$var$pg], $468ad51c3551a14d$var$og[$468ad51c3551a14d$var$pg] = null;
}
var $468ad51c3551a14d$var$xg = null, $468ad51c3551a14d$var$yg = null, $468ad51c3551a14d$var$I = !1, $468ad51c3551a14d$var$zg = null;
function $468ad51c3551a14d$var$Ag(a, b) {
    var c = $468ad51c3551a14d$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $468ad51c3551a14d$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $468ad51c3551a14d$var$xg = a, $468ad51c3551a14d$var$yg = $468ad51c3551a14d$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $468ad51c3551a14d$var$xg = a, $468ad51c3551a14d$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $468ad51c3551a14d$var$qg ? {
                id: $468ad51c3551a14d$var$rg,
                overflow: $468ad51c3551a14d$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $468ad51c3551a14d$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $468ad51c3551a14d$var$xg = a, $468ad51c3551a14d$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $468ad51c3551a14d$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $468ad51c3551a14d$var$Eg(a) {
    if ($468ad51c3551a14d$var$I) {
        var b = $468ad51c3551a14d$var$yg;
        if (b) {
            var c = b;
            if (!$468ad51c3551a14d$var$Cg(a, b)) {
                if ($468ad51c3551a14d$var$Dg(a)) throw Error($468ad51c3551a14d$var$p(418));
                b = $468ad51c3551a14d$var$Lf(c.nextSibling);
                var d = $468ad51c3551a14d$var$xg;
                b && $468ad51c3551a14d$var$Cg(a, b) ? $468ad51c3551a14d$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $468ad51c3551a14d$var$I = !1, $468ad51c3551a14d$var$xg = a);
            }
        } else {
            if ($468ad51c3551a14d$var$Dg(a)) throw Error($468ad51c3551a14d$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $468ad51c3551a14d$var$I = !1;
            $468ad51c3551a14d$var$xg = a;
        }
    }
}
function $468ad51c3551a14d$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $468ad51c3551a14d$var$xg = a;
}
function $468ad51c3551a14d$var$Gg(a) {
    if (a !== $468ad51c3551a14d$var$xg) return !1;
    if (!$468ad51c3551a14d$var$I) return $468ad51c3551a14d$var$Fg(a), $468ad51c3551a14d$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$468ad51c3551a14d$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $468ad51c3551a14d$var$yg)) {
        if ($468ad51c3551a14d$var$Dg(a)) throw $468ad51c3551a14d$var$Hg(), Error($468ad51c3551a14d$var$p(418));
        for(; b;)$468ad51c3551a14d$var$Ag(a, b), b = $468ad51c3551a14d$var$Lf(b.nextSibling);
    }
    $468ad51c3551a14d$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($468ad51c3551a14d$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $468ad51c3551a14d$var$yg = $468ad51c3551a14d$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $468ad51c3551a14d$var$yg = null;
        }
    } else $468ad51c3551a14d$var$yg = $468ad51c3551a14d$var$xg ? $468ad51c3551a14d$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $468ad51c3551a14d$var$Hg() {
    for(var a = $468ad51c3551a14d$var$yg; a;)a = $468ad51c3551a14d$var$Lf(a.nextSibling);
}
function $468ad51c3551a14d$var$Ig() {
    $468ad51c3551a14d$var$yg = $468ad51c3551a14d$var$xg = null;
    $468ad51c3551a14d$var$I = !1;
}
function $468ad51c3551a14d$var$Jg(a) {
    null === $468ad51c3551a14d$var$zg ? $468ad51c3551a14d$var$zg = [
        a
    ] : $468ad51c3551a14d$var$zg.push(a);
}
var $468ad51c3551a14d$var$Kg = $468ad51c3551a14d$var$ua.ReactCurrentBatchConfig;
function $468ad51c3551a14d$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($468ad51c3551a14d$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($468ad51c3551a14d$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($468ad51c3551a14d$var$p(284));
        if (!c._owner) throw Error($468ad51c3551a14d$var$p(290, a));
    }
    return a;
}
function $468ad51c3551a14d$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($468ad51c3551a14d$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $468ad51c3551a14d$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $468ad51c3551a14d$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $468ad51c3551a14d$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $468ad51c3551a14d$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $468ad51c3551a14d$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $468ad51c3551a14d$var$Ha && $468ad51c3551a14d$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $468ad51c3551a14d$var$Lg(a, b, c), d.return = a, d;
        d = $468ad51c3551a14d$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $468ad51c3551a14d$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $468ad51c3551a14d$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $468ad51c3551a14d$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $468ad51c3551a14d$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $468ad51c3551a14d$var$va:
                    return c = $468ad51c3551a14d$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $468ad51c3551a14d$var$Lg(a, null, b), c.return = a, c;
                case $468ad51c3551a14d$var$wa:
                    return b = $468ad51c3551a14d$var$Sg(b, a.mode, c), b.return = a, b;
                case $468ad51c3551a14d$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($468ad51c3551a14d$var$eb(b) || $468ad51c3551a14d$var$Ka(b)) return b = $468ad51c3551a14d$var$Tg(b, a.mode, c, null), b.return = a, b;
            $468ad51c3551a14d$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $468ad51c3551a14d$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $468ad51c3551a14d$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $468ad51c3551a14d$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($468ad51c3551a14d$var$eb(c) || $468ad51c3551a14d$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $468ad51c3551a14d$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $468ad51c3551a14d$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $468ad51c3551a14d$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $468ad51c3551a14d$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($468ad51c3551a14d$var$eb(d) || $468ad51c3551a14d$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $468ad51c3551a14d$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $468ad51c3551a14d$var$I && $468ad51c3551a14d$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $468ad51c3551a14d$var$I && $468ad51c3551a14d$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $468ad51c3551a14d$var$I && $468ad51c3551a14d$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $468ad51c3551a14d$var$Ka(h);
        if ("function" !== typeof l) throw Error($468ad51c3551a14d$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($468ad51c3551a14d$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $468ad51c3551a14d$var$I && $468ad51c3551a14d$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $468ad51c3551a14d$var$I && $468ad51c3551a14d$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $468ad51c3551a14d$var$I && $468ad51c3551a14d$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $468ad51c3551a14d$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $468ad51c3551a14d$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $468ad51c3551a14d$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $468ad51c3551a14d$var$Ha && $468ad51c3551a14d$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $468ad51c3551a14d$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $468ad51c3551a14d$var$ya ? (d = $468ad51c3551a14d$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $468ad51c3551a14d$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $468ad51c3551a14d$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $468ad51c3551a14d$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $468ad51c3551a14d$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $468ad51c3551a14d$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($468ad51c3551a14d$var$eb(f)) return n(a, d, f, h);
            if ($468ad51c3551a14d$var$Ka(f)) return t(a, d, f, h);
            $468ad51c3551a14d$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $468ad51c3551a14d$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $468ad51c3551a14d$var$Ug = $468ad51c3551a14d$var$Og(!0), $468ad51c3551a14d$var$Vg = $468ad51c3551a14d$var$Og(!1), $468ad51c3551a14d$var$Wg = $468ad51c3551a14d$var$Uf(null), $468ad51c3551a14d$var$Xg = null, $468ad51c3551a14d$var$Yg = null, $468ad51c3551a14d$var$Zg = null;
function $468ad51c3551a14d$var$$g() {
    $468ad51c3551a14d$var$Zg = $468ad51c3551a14d$var$Yg = $468ad51c3551a14d$var$Xg = null;
}
function $468ad51c3551a14d$var$ah(a) {
    var b = $468ad51c3551a14d$var$Wg.current;
    $468ad51c3551a14d$var$E($468ad51c3551a14d$var$Wg);
    a._currentValue = b;
}
function $468ad51c3551a14d$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $468ad51c3551a14d$var$ch(a, b) {
    $468ad51c3551a14d$var$Xg = a;
    $468ad51c3551a14d$var$Zg = $468ad51c3551a14d$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($468ad51c3551a14d$var$dh = !0), a.firstContext = null);
}
function $468ad51c3551a14d$var$eh(a) {
    var b = a._currentValue;
    if ($468ad51c3551a14d$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $468ad51c3551a14d$var$Yg) {
            if (null === $468ad51c3551a14d$var$Xg) throw Error($468ad51c3551a14d$var$p(308));
            $468ad51c3551a14d$var$Yg = a;
            $468ad51c3551a14d$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $468ad51c3551a14d$var$Yg = $468ad51c3551a14d$var$Yg.next = a;
    }
    return b;
}
var $468ad51c3551a14d$var$fh = null;
function $468ad51c3551a14d$var$gh(a) {
    null === $468ad51c3551a14d$var$fh ? $468ad51c3551a14d$var$fh = [
        a
    ] : $468ad51c3551a14d$var$fh.push(a);
}
function $468ad51c3551a14d$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $468ad51c3551a14d$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $468ad51c3551a14d$var$ih(a, d);
}
function $468ad51c3551a14d$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $468ad51c3551a14d$var$jh = !1;
function $468ad51c3551a14d$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $468ad51c3551a14d$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $468ad51c3551a14d$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $468ad51c3551a14d$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($468ad51c3551a14d$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $468ad51c3551a14d$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $468ad51c3551a14d$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $468ad51c3551a14d$var$ih(a, c);
}
function $468ad51c3551a14d$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $468ad51c3551a14d$var$Cc(a, c);
    }
}
function $468ad51c3551a14d$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $468ad51c3551a14d$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $468ad51c3551a14d$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $468ad51c3551a14d$var$A({}, q, r);
                            break a;
                        case 2:
                            $468ad51c3551a14d$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $468ad51c3551a14d$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $468ad51c3551a14d$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($468ad51c3551a14d$var$p(191, e));
            e.call(d);
        }
    }
}
var $468ad51c3551a14d$var$th = {}, $468ad51c3551a14d$var$uh = $468ad51c3551a14d$var$Uf($468ad51c3551a14d$var$th), $468ad51c3551a14d$var$vh = $468ad51c3551a14d$var$Uf($468ad51c3551a14d$var$th), $468ad51c3551a14d$var$wh = $468ad51c3551a14d$var$Uf($468ad51c3551a14d$var$th);
function $468ad51c3551a14d$var$xh(a) {
    if (a === $468ad51c3551a14d$var$th) throw Error($468ad51c3551a14d$var$p(174));
    return a;
}
function $468ad51c3551a14d$var$yh(a, b) {
    $468ad51c3551a14d$var$G($468ad51c3551a14d$var$wh, b);
    $468ad51c3551a14d$var$G($468ad51c3551a14d$var$vh, a);
    $468ad51c3551a14d$var$G($468ad51c3551a14d$var$uh, $468ad51c3551a14d$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $468ad51c3551a14d$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $468ad51c3551a14d$var$lb(b, a);
    }
    $468ad51c3551a14d$var$E($468ad51c3551a14d$var$uh);
    $468ad51c3551a14d$var$G($468ad51c3551a14d$var$uh, b);
}
function $468ad51c3551a14d$var$zh() {
    $468ad51c3551a14d$var$E($468ad51c3551a14d$var$uh);
    $468ad51c3551a14d$var$E($468ad51c3551a14d$var$vh);
    $468ad51c3551a14d$var$E($468ad51c3551a14d$var$wh);
}
function $468ad51c3551a14d$var$Ah(a) {
    $468ad51c3551a14d$var$xh($468ad51c3551a14d$var$wh.current);
    var b = $468ad51c3551a14d$var$xh($468ad51c3551a14d$var$uh.current);
    var c = $468ad51c3551a14d$var$lb(b, a.type);
    b !== c && ($468ad51c3551a14d$var$G($468ad51c3551a14d$var$vh, a), $468ad51c3551a14d$var$G($468ad51c3551a14d$var$uh, c));
}
function $468ad51c3551a14d$var$Bh(a) {
    $468ad51c3551a14d$var$vh.current === a && ($468ad51c3551a14d$var$E($468ad51c3551a14d$var$uh), $468ad51c3551a14d$var$E($468ad51c3551a14d$var$vh));
}
var $468ad51c3551a14d$var$L = $468ad51c3551a14d$var$Uf(0);
function $468ad51c3551a14d$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $468ad51c3551a14d$var$Dh = [];
function $468ad51c3551a14d$var$Eh() {
    for(var a = 0; a < $468ad51c3551a14d$var$Dh.length; a++)$468ad51c3551a14d$var$Dh[a]._workInProgressVersionPrimary = null;
    $468ad51c3551a14d$var$Dh.length = 0;
}
var $468ad51c3551a14d$var$Fh = $468ad51c3551a14d$var$ua.ReactCurrentDispatcher, $468ad51c3551a14d$var$Gh = $468ad51c3551a14d$var$ua.ReactCurrentBatchConfig, $468ad51c3551a14d$var$Hh = 0, $468ad51c3551a14d$var$M = null, $468ad51c3551a14d$var$N = null, $468ad51c3551a14d$var$O = null, $468ad51c3551a14d$var$Ih = !1, $468ad51c3551a14d$var$Jh = !1, $468ad51c3551a14d$var$Kh = 0, $468ad51c3551a14d$var$Lh = 0;
function $468ad51c3551a14d$var$P() {
    throw Error($468ad51c3551a14d$var$p(321));
}
function $468ad51c3551a14d$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$468ad51c3551a14d$var$He(a[c], b[c])) return !1;
    return !0;
}
function $468ad51c3551a14d$var$Nh(a, b, c, d, e, f) {
    $468ad51c3551a14d$var$Hh = f;
    $468ad51c3551a14d$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $468ad51c3551a14d$var$Fh.current = null === a || null === a.memoizedState ? $468ad51c3551a14d$var$Oh : $468ad51c3551a14d$var$Ph;
    a = c(d, e);
    if ($468ad51c3551a14d$var$Jh) {
        f = 0;
        do {
            $468ad51c3551a14d$var$Jh = !1;
            $468ad51c3551a14d$var$Kh = 0;
            if (25 <= f) throw Error($468ad51c3551a14d$var$p(301));
            f += 1;
            $468ad51c3551a14d$var$O = $468ad51c3551a14d$var$N = null;
            b.updateQueue = null;
            $468ad51c3551a14d$var$Fh.current = $468ad51c3551a14d$var$Qh;
            a = c(d, e);
        }while ($468ad51c3551a14d$var$Jh);
    }
    $468ad51c3551a14d$var$Fh.current = $468ad51c3551a14d$var$Rh;
    b = null !== $468ad51c3551a14d$var$N && null !== $468ad51c3551a14d$var$N.next;
    $468ad51c3551a14d$var$Hh = 0;
    $468ad51c3551a14d$var$O = $468ad51c3551a14d$var$N = $468ad51c3551a14d$var$M = null;
    $468ad51c3551a14d$var$Ih = !1;
    if (b) throw Error($468ad51c3551a14d$var$p(300));
    return a;
}
function $468ad51c3551a14d$var$Sh() {
    var a = 0 !== $468ad51c3551a14d$var$Kh;
    $468ad51c3551a14d$var$Kh = 0;
    return a;
}
function $468ad51c3551a14d$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $468ad51c3551a14d$var$O ? $468ad51c3551a14d$var$M.memoizedState = $468ad51c3551a14d$var$O = a : $468ad51c3551a14d$var$O = $468ad51c3551a14d$var$O.next = a;
    return $468ad51c3551a14d$var$O;
}
function $468ad51c3551a14d$var$Uh() {
    if (null === $468ad51c3551a14d$var$N) {
        var a = $468ad51c3551a14d$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $468ad51c3551a14d$var$N.next;
    var b = null === $468ad51c3551a14d$var$O ? $468ad51c3551a14d$var$M.memoizedState : $468ad51c3551a14d$var$O.next;
    if (null !== b) $468ad51c3551a14d$var$O = b, $468ad51c3551a14d$var$N = a;
    else {
        if (null === a) throw Error($468ad51c3551a14d$var$p(310));
        $468ad51c3551a14d$var$N = a;
        a = {
            memoizedState: $468ad51c3551a14d$var$N.memoizedState,
            baseState: $468ad51c3551a14d$var$N.baseState,
            baseQueue: $468ad51c3551a14d$var$N.baseQueue,
            queue: $468ad51c3551a14d$var$N.queue,
            next: null
        };
        null === $468ad51c3551a14d$var$O ? $468ad51c3551a14d$var$M.memoizedState = $468ad51c3551a14d$var$O = a : $468ad51c3551a14d$var$O = $468ad51c3551a14d$var$O.next = a;
    }
    return $468ad51c3551a14d$var$O;
}
function $468ad51c3551a14d$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $468ad51c3551a14d$var$Wh(a) {
    var b = $468ad51c3551a14d$var$Uh(), c = b.queue;
    if (null === c) throw Error($468ad51c3551a14d$var$p(311));
    c.lastRenderedReducer = a;
    var d = $468ad51c3551a14d$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($468ad51c3551a14d$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $468ad51c3551a14d$var$M.lanes |= m;
                $468ad51c3551a14d$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $468ad51c3551a14d$var$He(d, b.memoizedState) || ($468ad51c3551a14d$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $468ad51c3551a14d$var$M.lanes |= f, $468ad51c3551a14d$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $468ad51c3551a14d$var$Xh(a) {
    var b = $468ad51c3551a14d$var$Uh(), c = b.queue;
    if (null === c) throw Error($468ad51c3551a14d$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $468ad51c3551a14d$var$He(f, b.memoizedState) || ($468ad51c3551a14d$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $468ad51c3551a14d$var$Yh() {}
function $468ad51c3551a14d$var$Zh(a, b) {
    var c = $468ad51c3551a14d$var$M, d = $468ad51c3551a14d$var$Uh(), e = b(), f = !$468ad51c3551a14d$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $468ad51c3551a14d$var$dh = !0);
    d = d.queue;
    $468ad51c3551a14d$var$$h($468ad51c3551a14d$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $468ad51c3551a14d$var$O && $468ad51c3551a14d$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $468ad51c3551a14d$var$bi(9, $468ad51c3551a14d$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $468ad51c3551a14d$var$Q) throw Error($468ad51c3551a14d$var$p(349));
        0 !== ($468ad51c3551a14d$var$Hh & 30) || $468ad51c3551a14d$var$di(c, b, e);
    }
    return e;
}
function $468ad51c3551a14d$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $468ad51c3551a14d$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $468ad51c3551a14d$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $468ad51c3551a14d$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $468ad51c3551a14d$var$ei(b) && $468ad51c3551a14d$var$fi(a);
}
function $468ad51c3551a14d$var$ai(a, b, c) {
    return c(function() {
        $468ad51c3551a14d$var$ei(b) && $468ad51c3551a14d$var$fi(a);
    });
}
function $468ad51c3551a14d$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$468ad51c3551a14d$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $468ad51c3551a14d$var$fi(a) {
    var b = $468ad51c3551a14d$var$ih(a, 1);
    null !== b && $468ad51c3551a14d$var$gi(b, a, 1, -1);
}
function $468ad51c3551a14d$var$hi(a) {
    var b = $468ad51c3551a14d$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $468ad51c3551a14d$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $468ad51c3551a14d$var$ii.bind(null, $468ad51c3551a14d$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $468ad51c3551a14d$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $468ad51c3551a14d$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $468ad51c3551a14d$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $468ad51c3551a14d$var$ji() {
    return $468ad51c3551a14d$var$Uh().memoizedState;
}
function $468ad51c3551a14d$var$ki(a, b, c, d) {
    var e = $468ad51c3551a14d$var$Th();
    $468ad51c3551a14d$var$M.flags |= a;
    e.memoizedState = $468ad51c3551a14d$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $468ad51c3551a14d$var$li(a, b, c, d) {
    var e = $468ad51c3551a14d$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $468ad51c3551a14d$var$N) {
        var g = $468ad51c3551a14d$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $468ad51c3551a14d$var$Mh(d, g.deps)) {
            e.memoizedState = $468ad51c3551a14d$var$bi(b, c, f, d);
            return;
        }
    }
    $468ad51c3551a14d$var$M.flags |= a;
    e.memoizedState = $468ad51c3551a14d$var$bi(1 | b, c, f, d);
}
function $468ad51c3551a14d$var$mi(a, b) {
    return $468ad51c3551a14d$var$ki(8390656, 8, a, b);
}
function $468ad51c3551a14d$var$$h(a, b) {
    return $468ad51c3551a14d$var$li(2048, 8, a, b);
}
function $468ad51c3551a14d$var$ni(a, b) {
    return $468ad51c3551a14d$var$li(4, 2, a, b);
}
function $468ad51c3551a14d$var$oi(a, b) {
    return $468ad51c3551a14d$var$li(4, 4, a, b);
}
function $468ad51c3551a14d$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $468ad51c3551a14d$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $468ad51c3551a14d$var$li(4, 4, $468ad51c3551a14d$var$pi.bind(null, b, a), c);
}
function $468ad51c3551a14d$var$ri() {}
function $468ad51c3551a14d$var$si(a, b) {
    var c = $468ad51c3551a14d$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $468ad51c3551a14d$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $468ad51c3551a14d$var$ti(a, b) {
    var c = $468ad51c3551a14d$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $468ad51c3551a14d$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $468ad51c3551a14d$var$ui(a, b, c) {
    if (0 === ($468ad51c3551a14d$var$Hh & 21)) return a.baseState && (a.baseState = !1, $468ad51c3551a14d$var$dh = !0), a.memoizedState = c;
    $468ad51c3551a14d$var$He(c, b) || (c = $468ad51c3551a14d$var$yc(), $468ad51c3551a14d$var$M.lanes |= c, $468ad51c3551a14d$var$rh |= c, a.baseState = !0);
    return b;
}
function $468ad51c3551a14d$var$vi(a, b) {
    var c = $468ad51c3551a14d$var$C;
    $468ad51c3551a14d$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $468ad51c3551a14d$var$Gh.transition;
    $468ad51c3551a14d$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $468ad51c3551a14d$var$C = c, $468ad51c3551a14d$var$Gh.transition = d;
    }
}
function $468ad51c3551a14d$var$wi() {
    return $468ad51c3551a14d$var$Uh().memoizedState;
}
function $468ad51c3551a14d$var$xi(a, b, c) {
    var d = $468ad51c3551a14d$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($468ad51c3551a14d$var$zi(a)) $468ad51c3551a14d$var$Ai(b, c);
    else if (c = $468ad51c3551a14d$var$hh(a, b, c, d), null !== c) {
        var e = $468ad51c3551a14d$var$R();
        $468ad51c3551a14d$var$gi(c, a, d, e);
        $468ad51c3551a14d$var$Bi(c, b, d);
    }
}
function $468ad51c3551a14d$var$ii(a, b, c) {
    var d = $468ad51c3551a14d$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($468ad51c3551a14d$var$zi(a)) $468ad51c3551a14d$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($468ad51c3551a14d$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $468ad51c3551a14d$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $468ad51c3551a14d$var$hh(a, b, e, d);
        null !== c && (e = $468ad51c3551a14d$var$R(), $468ad51c3551a14d$var$gi(c, a, d, e), $468ad51c3551a14d$var$Bi(c, b, d));
    }
}
function $468ad51c3551a14d$var$zi(a) {
    var b = a.alternate;
    return a === $468ad51c3551a14d$var$M || null !== b && b === $468ad51c3551a14d$var$M;
}
function $468ad51c3551a14d$var$Ai(a, b) {
    $468ad51c3551a14d$var$Jh = $468ad51c3551a14d$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $468ad51c3551a14d$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $468ad51c3551a14d$var$Cc(a, c);
    }
}
var $468ad51c3551a14d$var$Rh = {
    readContext: $468ad51c3551a14d$var$eh,
    useCallback: $468ad51c3551a14d$var$P,
    useContext: $468ad51c3551a14d$var$P,
    useEffect: $468ad51c3551a14d$var$P,
    useImperativeHandle: $468ad51c3551a14d$var$P,
    useInsertionEffect: $468ad51c3551a14d$var$P,
    useLayoutEffect: $468ad51c3551a14d$var$P,
    useMemo: $468ad51c3551a14d$var$P,
    useReducer: $468ad51c3551a14d$var$P,
    useRef: $468ad51c3551a14d$var$P,
    useState: $468ad51c3551a14d$var$P,
    useDebugValue: $468ad51c3551a14d$var$P,
    useDeferredValue: $468ad51c3551a14d$var$P,
    useTransition: $468ad51c3551a14d$var$P,
    useMutableSource: $468ad51c3551a14d$var$P,
    useSyncExternalStore: $468ad51c3551a14d$var$P,
    useId: $468ad51c3551a14d$var$P,
    unstable_isNewReconciler: !1
}, $468ad51c3551a14d$var$Oh = {
    readContext: $468ad51c3551a14d$var$eh,
    useCallback: function(a, b) {
        $468ad51c3551a14d$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $468ad51c3551a14d$var$eh,
    useEffect: $468ad51c3551a14d$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $468ad51c3551a14d$var$ki(4194308, 4, $468ad51c3551a14d$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $468ad51c3551a14d$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $468ad51c3551a14d$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $468ad51c3551a14d$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $468ad51c3551a14d$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $468ad51c3551a14d$var$xi.bind(null, $468ad51c3551a14d$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $468ad51c3551a14d$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $468ad51c3551a14d$var$hi,
    useDebugValue: $468ad51c3551a14d$var$ri,
    useDeferredValue: function(a) {
        return $468ad51c3551a14d$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $468ad51c3551a14d$var$hi(!1), b = a[0];
        a = $468ad51c3551a14d$var$vi.bind(null, a[1]);
        $468ad51c3551a14d$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $468ad51c3551a14d$var$M, e = $468ad51c3551a14d$var$Th();
        if ($468ad51c3551a14d$var$I) {
            if (void 0 === c) throw Error($468ad51c3551a14d$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $468ad51c3551a14d$var$Q) throw Error($468ad51c3551a14d$var$p(349));
            0 !== ($468ad51c3551a14d$var$Hh & 30) || $468ad51c3551a14d$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $468ad51c3551a14d$var$mi($468ad51c3551a14d$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $468ad51c3551a14d$var$bi(9, $468ad51c3551a14d$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $468ad51c3551a14d$var$Th(), b = $468ad51c3551a14d$var$Q.identifierPrefix;
        if ($468ad51c3551a14d$var$I) {
            var c = $468ad51c3551a14d$var$sg;
            var d = $468ad51c3551a14d$var$rg;
            c = (d & ~(1 << 32 - $468ad51c3551a14d$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $468ad51c3551a14d$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $468ad51c3551a14d$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $468ad51c3551a14d$var$Ph = {
    readContext: $468ad51c3551a14d$var$eh,
    useCallback: $468ad51c3551a14d$var$si,
    useContext: $468ad51c3551a14d$var$eh,
    useEffect: $468ad51c3551a14d$var$$h,
    useImperativeHandle: $468ad51c3551a14d$var$qi,
    useInsertionEffect: $468ad51c3551a14d$var$ni,
    useLayoutEffect: $468ad51c3551a14d$var$oi,
    useMemo: $468ad51c3551a14d$var$ti,
    useReducer: $468ad51c3551a14d$var$Wh,
    useRef: $468ad51c3551a14d$var$ji,
    useState: function() {
        return $468ad51c3551a14d$var$Wh($468ad51c3551a14d$var$Vh);
    },
    useDebugValue: $468ad51c3551a14d$var$ri,
    useDeferredValue: function(a) {
        var b = $468ad51c3551a14d$var$Uh();
        return $468ad51c3551a14d$var$ui(b, $468ad51c3551a14d$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $468ad51c3551a14d$var$Wh($468ad51c3551a14d$var$Vh)[0], b = $468ad51c3551a14d$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $468ad51c3551a14d$var$Yh,
    useSyncExternalStore: $468ad51c3551a14d$var$Zh,
    useId: $468ad51c3551a14d$var$wi,
    unstable_isNewReconciler: !1
}, $468ad51c3551a14d$var$Qh = {
    readContext: $468ad51c3551a14d$var$eh,
    useCallback: $468ad51c3551a14d$var$si,
    useContext: $468ad51c3551a14d$var$eh,
    useEffect: $468ad51c3551a14d$var$$h,
    useImperativeHandle: $468ad51c3551a14d$var$qi,
    useInsertionEffect: $468ad51c3551a14d$var$ni,
    useLayoutEffect: $468ad51c3551a14d$var$oi,
    useMemo: $468ad51c3551a14d$var$ti,
    useReducer: $468ad51c3551a14d$var$Xh,
    useRef: $468ad51c3551a14d$var$ji,
    useState: function() {
        return $468ad51c3551a14d$var$Xh($468ad51c3551a14d$var$Vh);
    },
    useDebugValue: $468ad51c3551a14d$var$ri,
    useDeferredValue: function(a) {
        var b = $468ad51c3551a14d$var$Uh();
        return null === $468ad51c3551a14d$var$N ? b.memoizedState = a : $468ad51c3551a14d$var$ui(b, $468ad51c3551a14d$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $468ad51c3551a14d$var$Xh($468ad51c3551a14d$var$Vh)[0], b = $468ad51c3551a14d$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $468ad51c3551a14d$var$Yh,
    useSyncExternalStore: $468ad51c3551a14d$var$Zh,
    useId: $468ad51c3551a14d$var$wi,
    unstable_isNewReconciler: !1
};
function $468ad51c3551a14d$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $468ad51c3551a14d$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $468ad51c3551a14d$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $468ad51c3551a14d$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $468ad51c3551a14d$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $468ad51c3551a14d$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $468ad51c3551a14d$var$R(), e = $468ad51c3551a14d$var$yi(a), f = $468ad51c3551a14d$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $468ad51c3551a14d$var$nh(a, f, e);
        null !== b && ($468ad51c3551a14d$var$gi(b, a, e, d), $468ad51c3551a14d$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $468ad51c3551a14d$var$R(), e = $468ad51c3551a14d$var$yi(a), f = $468ad51c3551a14d$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $468ad51c3551a14d$var$nh(a, f, e);
        null !== b && ($468ad51c3551a14d$var$gi(b, a, e, d), $468ad51c3551a14d$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $468ad51c3551a14d$var$R(), d = $468ad51c3551a14d$var$yi(a), e = $468ad51c3551a14d$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $468ad51c3551a14d$var$nh(a, e, d);
        null !== b && ($468ad51c3551a14d$var$gi(b, a, d, c), $468ad51c3551a14d$var$oh(b, a, d));
    }
};
function $468ad51c3551a14d$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$468ad51c3551a14d$var$Ie(c, d) || !$468ad51c3551a14d$var$Ie(e, f) : !0;
}
function $468ad51c3551a14d$var$Gi(a, b, c) {
    var d = !1, e = $468ad51c3551a14d$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $468ad51c3551a14d$var$eh(f) : (e = $468ad51c3551a14d$var$Zf(b) ? $468ad51c3551a14d$var$Xf : $468ad51c3551a14d$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $468ad51c3551a14d$var$Yf(a, e) : $468ad51c3551a14d$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $468ad51c3551a14d$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $468ad51c3551a14d$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $468ad51c3551a14d$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $468ad51c3551a14d$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $468ad51c3551a14d$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $468ad51c3551a14d$var$eh(f) : (f = $468ad51c3551a14d$var$Zf(b) ? $468ad51c3551a14d$var$Xf : $468ad51c3551a14d$var$H.current, e.context = $468ad51c3551a14d$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($468ad51c3551a14d$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $468ad51c3551a14d$var$Ei.enqueueReplaceState(e, e.state, null), $468ad51c3551a14d$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $468ad51c3551a14d$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $468ad51c3551a14d$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $468ad51c3551a14d$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $468ad51c3551a14d$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $468ad51c3551a14d$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $468ad51c3551a14d$var$Ni(a, b, c) {
    c = $468ad51c3551a14d$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $468ad51c3551a14d$var$Oi || ($468ad51c3551a14d$var$Oi = !0, $468ad51c3551a14d$var$Pi = d);
        $468ad51c3551a14d$var$Li(a, b);
    };
    return c;
}
function $468ad51c3551a14d$var$Qi(a, b, c) {
    c = $468ad51c3551a14d$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $468ad51c3551a14d$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $468ad51c3551a14d$var$Li(a, b);
        "function" !== typeof d && (null === $468ad51c3551a14d$var$Ri ? $468ad51c3551a14d$var$Ri = new Set([
            this
        ]) : $468ad51c3551a14d$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $468ad51c3551a14d$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $468ad51c3551a14d$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $468ad51c3551a14d$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $468ad51c3551a14d$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $468ad51c3551a14d$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $468ad51c3551a14d$var$mh(-1, 1), b.tag = 2, $468ad51c3551a14d$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $468ad51c3551a14d$var$Wi = $468ad51c3551a14d$var$ua.ReactCurrentOwner, $468ad51c3551a14d$var$dh = !1;
function $468ad51c3551a14d$var$Xi(a, b, c, d) {
    b.child = null === a ? $468ad51c3551a14d$var$Vg(b, null, c, d) : $468ad51c3551a14d$var$Ug(b, a.child, c, d);
}
function $468ad51c3551a14d$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $468ad51c3551a14d$var$ch(b, e);
    d = $468ad51c3551a14d$var$Nh(a, b, c, d, f, e);
    c = $468ad51c3551a14d$var$Sh();
    if (null !== a && !$468ad51c3551a14d$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $468ad51c3551a14d$var$Zi(a, b, e);
    $468ad51c3551a14d$var$I && c && $468ad51c3551a14d$var$vg(b);
    b.flags |= 1;
    $468ad51c3551a14d$var$Xi(a, b, d, e);
    return b.child;
}
function $468ad51c3551a14d$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$468ad51c3551a14d$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $468ad51c3551a14d$var$bj(a, b, f, d, e);
        a = $468ad51c3551a14d$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $468ad51c3551a14d$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $468ad51c3551a14d$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $468ad51c3551a14d$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $468ad51c3551a14d$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($468ad51c3551a14d$var$Ie(f, d) && a.ref === b.ref) {
            if ($468ad51c3551a14d$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($468ad51c3551a14d$var$dh = !0);
            else return b.lanes = a.lanes, $468ad51c3551a14d$var$Zi(a, b, e);
        }
    }
    return $468ad51c3551a14d$var$cj(a, b, c, d, e);
}
function $468ad51c3551a14d$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $468ad51c3551a14d$var$G($468ad51c3551a14d$var$ej, $468ad51c3551a14d$var$fj), $468ad51c3551a14d$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $468ad51c3551a14d$var$G($468ad51c3551a14d$var$ej, $468ad51c3551a14d$var$fj), $468ad51c3551a14d$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $468ad51c3551a14d$var$G($468ad51c3551a14d$var$ej, $468ad51c3551a14d$var$fj);
            $468ad51c3551a14d$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $468ad51c3551a14d$var$G($468ad51c3551a14d$var$ej, $468ad51c3551a14d$var$fj), $468ad51c3551a14d$var$fj |= d;
    $468ad51c3551a14d$var$Xi(a, b, e, c);
    return b.child;
}
function $468ad51c3551a14d$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $468ad51c3551a14d$var$cj(a, b, c, d, e) {
    var f = $468ad51c3551a14d$var$Zf(c) ? $468ad51c3551a14d$var$Xf : $468ad51c3551a14d$var$H.current;
    f = $468ad51c3551a14d$var$Yf(b, f);
    $468ad51c3551a14d$var$ch(b, e);
    c = $468ad51c3551a14d$var$Nh(a, b, c, d, f, e);
    d = $468ad51c3551a14d$var$Sh();
    if (null !== a && !$468ad51c3551a14d$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $468ad51c3551a14d$var$Zi(a, b, e);
    $468ad51c3551a14d$var$I && d && $468ad51c3551a14d$var$vg(b);
    b.flags |= 1;
    $468ad51c3551a14d$var$Xi(a, b, c, e);
    return b.child;
}
function $468ad51c3551a14d$var$hj(a, b, c, d, e) {
    if ($468ad51c3551a14d$var$Zf(c)) {
        var f = !0;
        $468ad51c3551a14d$var$cg(b);
    } else f = !1;
    $468ad51c3551a14d$var$ch(b, e);
    if (null === b.stateNode) $468ad51c3551a14d$var$ij(a, b), $468ad51c3551a14d$var$Gi(b, c, d), $468ad51c3551a14d$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $468ad51c3551a14d$var$eh(l) : (l = $468ad51c3551a14d$var$Zf(c) ? $468ad51c3551a14d$var$Xf : $468ad51c3551a14d$var$H.current, l = $468ad51c3551a14d$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $468ad51c3551a14d$var$Hi(b, g, d, l);
        $468ad51c3551a14d$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $468ad51c3551a14d$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $468ad51c3551a14d$var$Wf.current || $468ad51c3551a14d$var$jh ? ("function" === typeof m && ($468ad51c3551a14d$var$Di(b, c, m, d), k = b.memoizedState), (h = $468ad51c3551a14d$var$jh || $468ad51c3551a14d$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $468ad51c3551a14d$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $468ad51c3551a14d$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $468ad51c3551a14d$var$eh(k) : (k = $468ad51c3551a14d$var$Zf(c) ? $468ad51c3551a14d$var$Xf : $468ad51c3551a14d$var$H.current, k = $468ad51c3551a14d$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $468ad51c3551a14d$var$Hi(b, g, d, k);
        $468ad51c3551a14d$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $468ad51c3551a14d$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $468ad51c3551a14d$var$Wf.current || $468ad51c3551a14d$var$jh ? ("function" === typeof y && ($468ad51c3551a14d$var$Di(b, c, y, d), n = b.memoizedState), (l = $468ad51c3551a14d$var$jh || $468ad51c3551a14d$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $468ad51c3551a14d$var$jj(a, b, c, d, f, e);
}
function $468ad51c3551a14d$var$jj(a, b, c, d, e, f) {
    $468ad51c3551a14d$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $468ad51c3551a14d$var$dg(b, c, !1), $468ad51c3551a14d$var$Zi(a, b, f);
    d = b.stateNode;
    $468ad51c3551a14d$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $468ad51c3551a14d$var$Ug(b, a.child, null, f), b.child = $468ad51c3551a14d$var$Ug(b, null, h, f)) : $468ad51c3551a14d$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $468ad51c3551a14d$var$dg(b, c, !0);
    return b.child;
}
function $468ad51c3551a14d$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $468ad51c3551a14d$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $468ad51c3551a14d$var$ag(a, b.context, !1);
    $468ad51c3551a14d$var$yh(a, b.containerInfo);
}
function $468ad51c3551a14d$var$lj(a, b, c, d, e) {
    $468ad51c3551a14d$var$Ig();
    $468ad51c3551a14d$var$Jg(e);
    b.flags |= 256;
    $468ad51c3551a14d$var$Xi(a, b, c, d);
    return b.child;
}
var $468ad51c3551a14d$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $468ad51c3551a14d$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $468ad51c3551a14d$var$oj(a, b, c) {
    var d = b.pendingProps, e = $468ad51c3551a14d$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $468ad51c3551a14d$var$G($468ad51c3551a14d$var$L, e & 1);
    if (null === a) {
        $468ad51c3551a14d$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $468ad51c3551a14d$var$pj(g, d, 0, null), a = $468ad51c3551a14d$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $468ad51c3551a14d$var$nj(c), b.memoizedState = $468ad51c3551a14d$var$mj, a) : $468ad51c3551a14d$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $468ad51c3551a14d$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $468ad51c3551a14d$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $468ad51c3551a14d$var$Pg(h, f) : (f = $468ad51c3551a14d$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $468ad51c3551a14d$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $468ad51c3551a14d$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $468ad51c3551a14d$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $468ad51c3551a14d$var$qj(a, b) {
    b = $468ad51c3551a14d$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $468ad51c3551a14d$var$sj(a, b, c, d) {
    null !== d && $468ad51c3551a14d$var$Jg(d);
    $468ad51c3551a14d$var$Ug(b, a.child, null, c);
    a = $468ad51c3551a14d$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $468ad51c3551a14d$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $468ad51c3551a14d$var$Ki(Error($468ad51c3551a14d$var$p(422))), $468ad51c3551a14d$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $468ad51c3551a14d$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $468ad51c3551a14d$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $468ad51c3551a14d$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $468ad51c3551a14d$var$nj(g);
        b.memoizedState = $468ad51c3551a14d$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $468ad51c3551a14d$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($468ad51c3551a14d$var$p(419));
        d = $468ad51c3551a14d$var$Ki(f, d, void 0);
        return $468ad51c3551a14d$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($468ad51c3551a14d$var$dh || h) {
        d = $468ad51c3551a14d$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $468ad51c3551a14d$var$ih(a, e), $468ad51c3551a14d$var$gi(d, a, e, -1));
        }
        $468ad51c3551a14d$var$tj();
        d = $468ad51c3551a14d$var$Ki(Error($468ad51c3551a14d$var$p(421)));
        return $468ad51c3551a14d$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $468ad51c3551a14d$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $468ad51c3551a14d$var$yg = $468ad51c3551a14d$var$Lf(e.nextSibling);
    $468ad51c3551a14d$var$xg = b;
    $468ad51c3551a14d$var$I = !0;
    $468ad51c3551a14d$var$zg = null;
    null !== a && ($468ad51c3551a14d$var$og[$468ad51c3551a14d$var$pg++] = $468ad51c3551a14d$var$rg, $468ad51c3551a14d$var$og[$468ad51c3551a14d$var$pg++] = $468ad51c3551a14d$var$sg, $468ad51c3551a14d$var$og[$468ad51c3551a14d$var$pg++] = $468ad51c3551a14d$var$qg, $468ad51c3551a14d$var$rg = a.id, $468ad51c3551a14d$var$sg = a.overflow, $468ad51c3551a14d$var$qg = b);
    b = $468ad51c3551a14d$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $468ad51c3551a14d$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $468ad51c3551a14d$var$bh(a.return, b, c);
}
function $468ad51c3551a14d$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $468ad51c3551a14d$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $468ad51c3551a14d$var$Xi(a, b, d.children, c);
    d = $468ad51c3551a14d$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $468ad51c3551a14d$var$vj(a, c, b);
            else if (19 === a.tag) $468ad51c3551a14d$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $468ad51c3551a14d$var$G($468ad51c3551a14d$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $468ad51c3551a14d$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $468ad51c3551a14d$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $468ad51c3551a14d$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $468ad51c3551a14d$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $468ad51c3551a14d$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $468ad51c3551a14d$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $468ad51c3551a14d$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $468ad51c3551a14d$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($468ad51c3551a14d$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $468ad51c3551a14d$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $468ad51c3551a14d$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $468ad51c3551a14d$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $468ad51c3551a14d$var$kj(b);
            $468ad51c3551a14d$var$Ig();
            break;
        case 5:
            $468ad51c3551a14d$var$Ah(b);
            break;
        case 1:
            $468ad51c3551a14d$var$Zf(b.type) && $468ad51c3551a14d$var$cg(b);
            break;
        case 4:
            $468ad51c3551a14d$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $468ad51c3551a14d$var$G($468ad51c3551a14d$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $468ad51c3551a14d$var$G($468ad51c3551a14d$var$L, $468ad51c3551a14d$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $468ad51c3551a14d$var$oj(a, b, c);
                $468ad51c3551a14d$var$G($468ad51c3551a14d$var$L, $468ad51c3551a14d$var$L.current & 1);
                a = $468ad51c3551a14d$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $468ad51c3551a14d$var$G($468ad51c3551a14d$var$L, $468ad51c3551a14d$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $468ad51c3551a14d$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $468ad51c3551a14d$var$G($468ad51c3551a14d$var$L, $468ad51c3551a14d$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $468ad51c3551a14d$var$dj(a, b, c);
    }
    return $468ad51c3551a14d$var$Zi(a, b, c);
}
var $468ad51c3551a14d$var$zj, $468ad51c3551a14d$var$Aj, $468ad51c3551a14d$var$Bj, $468ad51c3551a14d$var$Cj;
$468ad51c3551a14d$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$468ad51c3551a14d$var$Aj = function() {};
$468ad51c3551a14d$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $468ad51c3551a14d$var$xh($468ad51c3551a14d$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $468ad51c3551a14d$var$Ya(a, e);
                d = $468ad51c3551a14d$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $468ad51c3551a14d$var$A({}, e, {
                    value: void 0
                });
                d = $468ad51c3551a14d$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $468ad51c3551a14d$var$gb(a, e);
                d = $468ad51c3551a14d$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $468ad51c3551a14d$var$Bf);
        }
        $468ad51c3551a14d$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($468ad51c3551a14d$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($468ad51c3551a14d$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $468ad51c3551a14d$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$468ad51c3551a14d$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $468ad51c3551a14d$var$Dj(a, b) {
    if (!$468ad51c3551a14d$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $468ad51c3551a14d$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $468ad51c3551a14d$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $468ad51c3551a14d$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $468ad51c3551a14d$var$S(b), null;
        case 1:
            return $468ad51c3551a14d$var$Zf(b.type) && $468ad51c3551a14d$var$$f(), $468ad51c3551a14d$var$S(b), null;
        case 3:
            d = b.stateNode;
            $468ad51c3551a14d$var$zh();
            $468ad51c3551a14d$var$E($468ad51c3551a14d$var$Wf);
            $468ad51c3551a14d$var$E($468ad51c3551a14d$var$H);
            $468ad51c3551a14d$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $468ad51c3551a14d$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $468ad51c3551a14d$var$zg && ($468ad51c3551a14d$var$Fj($468ad51c3551a14d$var$zg), $468ad51c3551a14d$var$zg = null));
            $468ad51c3551a14d$var$Aj(a, b);
            $468ad51c3551a14d$var$S(b);
            return null;
        case 5:
            $468ad51c3551a14d$var$Bh(b);
            var e = $468ad51c3551a14d$var$xh($468ad51c3551a14d$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $468ad51c3551a14d$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($468ad51c3551a14d$var$p(166));
                    $468ad51c3551a14d$var$S(b);
                    return null;
                }
                a = $468ad51c3551a14d$var$xh($468ad51c3551a14d$var$uh.current);
                if ($468ad51c3551a14d$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$468ad51c3551a14d$var$Of] = b;
                    d[$468ad51c3551a14d$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $468ad51c3551a14d$var$D("cancel", d);
                            $468ad51c3551a14d$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $468ad51c3551a14d$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $468ad51c3551a14d$var$lf.length; e++)$468ad51c3551a14d$var$D($468ad51c3551a14d$var$lf[e], d);
                            break;
                        case "source":
                            $468ad51c3551a14d$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $468ad51c3551a14d$var$D("error", d);
                            $468ad51c3551a14d$var$D("load", d);
                            break;
                        case "details":
                            $468ad51c3551a14d$var$D("toggle", d);
                            break;
                        case "input":
                            $468ad51c3551a14d$var$Za(d, f);
                            $468ad51c3551a14d$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $468ad51c3551a14d$var$D("invalid", d);
                            break;
                        case "textarea":
                            $468ad51c3551a14d$var$hb(d, f), $468ad51c3551a14d$var$D("invalid", d);
                    }
                    $468ad51c3551a14d$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $468ad51c3551a14d$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $468ad51c3551a14d$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $468ad51c3551a14d$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $468ad51c3551a14d$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $468ad51c3551a14d$var$Va(d);
                            $468ad51c3551a14d$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $468ad51c3551a14d$var$Va(d);
                            $468ad51c3551a14d$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $468ad51c3551a14d$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $468ad51c3551a14d$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$468ad51c3551a14d$var$Of] = b;
                    a[$468ad51c3551a14d$var$Pf] = d;
                    $468ad51c3551a14d$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $468ad51c3551a14d$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $468ad51c3551a14d$var$D("cancel", a);
                                $468ad51c3551a14d$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $468ad51c3551a14d$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $468ad51c3551a14d$var$lf.length; e++)$468ad51c3551a14d$var$D($468ad51c3551a14d$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $468ad51c3551a14d$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $468ad51c3551a14d$var$D("error", a);
                                $468ad51c3551a14d$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $468ad51c3551a14d$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $468ad51c3551a14d$var$Za(a, d);
                                e = $468ad51c3551a14d$var$Ya(a, d);
                                $468ad51c3551a14d$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $468ad51c3551a14d$var$A({}, d, {
                                    value: void 0
                                });
                                $468ad51c3551a14d$var$D("invalid", a);
                                break;
                            case "textarea":
                                $468ad51c3551a14d$var$hb(a, d);
                                e = $468ad51c3551a14d$var$gb(a, d);
                                $468ad51c3551a14d$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $468ad51c3551a14d$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $468ad51c3551a14d$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $468ad51c3551a14d$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $468ad51c3551a14d$var$ob(a, k) : "number" === typeof k && $468ad51c3551a14d$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($468ad51c3551a14d$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $468ad51c3551a14d$var$D("scroll", a) : null != k && $468ad51c3551a14d$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $468ad51c3551a14d$var$Va(a);
                                $468ad51c3551a14d$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $468ad51c3551a14d$var$Va(a);
                                $468ad51c3551a14d$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $468ad51c3551a14d$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $468ad51c3551a14d$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $468ad51c3551a14d$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $468ad51c3551a14d$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $468ad51c3551a14d$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $468ad51c3551a14d$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($468ad51c3551a14d$var$p(166));
                c = $468ad51c3551a14d$var$xh($468ad51c3551a14d$var$wh.current);
                $468ad51c3551a14d$var$xh($468ad51c3551a14d$var$uh.current);
                if ($468ad51c3551a14d$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$468ad51c3551a14d$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $468ad51c3551a14d$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $468ad51c3551a14d$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $468ad51c3551a14d$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$468ad51c3551a14d$var$Of] = b, b.stateNode = d;
            }
            $468ad51c3551a14d$var$S(b);
            return null;
        case 13:
            $468ad51c3551a14d$var$E($468ad51c3551a14d$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($468ad51c3551a14d$var$I && null !== $468ad51c3551a14d$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $468ad51c3551a14d$var$Hg(), $468ad51c3551a14d$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $468ad51c3551a14d$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($468ad51c3551a14d$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($468ad51c3551a14d$var$p(317));
                        f[$468ad51c3551a14d$var$Of] = b;
                    } else $468ad51c3551a14d$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $468ad51c3551a14d$var$S(b);
                    f = !1;
                } else null !== $468ad51c3551a14d$var$zg && ($468ad51c3551a14d$var$Fj($468ad51c3551a14d$var$zg), $468ad51c3551a14d$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($468ad51c3551a14d$var$L.current & 1) ? 0 === $468ad51c3551a14d$var$T && ($468ad51c3551a14d$var$T = 3) : $468ad51c3551a14d$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $468ad51c3551a14d$var$S(b);
            return null;
        case 4:
            return $468ad51c3551a14d$var$zh(), $468ad51c3551a14d$var$Aj(a, b), null === a && $468ad51c3551a14d$var$sf(b.stateNode.containerInfo), $468ad51c3551a14d$var$S(b), null;
        case 10:
            return $468ad51c3551a14d$var$ah(b.type._context), $468ad51c3551a14d$var$S(b), null;
        case 17:
            return $468ad51c3551a14d$var$Zf(b.type) && $468ad51c3551a14d$var$$f(), $468ad51c3551a14d$var$S(b), null;
        case 19:
            $468ad51c3551a14d$var$E($468ad51c3551a14d$var$L);
            f = b.memoizedState;
            if (null === f) return $468ad51c3551a14d$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $468ad51c3551a14d$var$Dj(f, !1);
                else {
                    if (0 !== $468ad51c3551a14d$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $468ad51c3551a14d$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $468ad51c3551a14d$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $468ad51c3551a14d$var$G($468ad51c3551a14d$var$L, $468ad51c3551a14d$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $468ad51c3551a14d$var$B() > $468ad51c3551a14d$var$Gj && (b.flags |= 128, d = !0, $468ad51c3551a14d$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $468ad51c3551a14d$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $468ad51c3551a14d$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$468ad51c3551a14d$var$I) return $468ad51c3551a14d$var$S(b), null;
                    } else 2 * $468ad51c3551a14d$var$B() - f.renderingStartTime > $468ad51c3551a14d$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $468ad51c3551a14d$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $468ad51c3551a14d$var$B(), b.sibling = null, c = $468ad51c3551a14d$var$L.current, $468ad51c3551a14d$var$G($468ad51c3551a14d$var$L, d ? c & 1 | 2 : c & 1), b;
            $468ad51c3551a14d$var$S(b);
            return null;
        case 22:
        case 23:
            return $468ad51c3551a14d$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($468ad51c3551a14d$var$fj & 1073741824) && ($468ad51c3551a14d$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $468ad51c3551a14d$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($468ad51c3551a14d$var$p(156, b.tag));
}
function $468ad51c3551a14d$var$Ij(a, b) {
    $468ad51c3551a14d$var$wg(b);
    switch(b.tag){
        case 1:
            return $468ad51c3551a14d$var$Zf(b.type) && $468ad51c3551a14d$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $468ad51c3551a14d$var$zh(), $468ad51c3551a14d$var$E($468ad51c3551a14d$var$Wf), $468ad51c3551a14d$var$E($468ad51c3551a14d$var$H), $468ad51c3551a14d$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $468ad51c3551a14d$var$Bh(b), null;
        case 13:
            $468ad51c3551a14d$var$E($468ad51c3551a14d$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($468ad51c3551a14d$var$p(340));
                $468ad51c3551a14d$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $468ad51c3551a14d$var$E($468ad51c3551a14d$var$L), null;
        case 4:
            return $468ad51c3551a14d$var$zh(), null;
        case 10:
            return $468ad51c3551a14d$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $468ad51c3551a14d$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $468ad51c3551a14d$var$Jj = !1, $468ad51c3551a14d$var$U = !1, $468ad51c3551a14d$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $468ad51c3551a14d$var$V = null;
function $468ad51c3551a14d$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $468ad51c3551a14d$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $468ad51c3551a14d$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $468ad51c3551a14d$var$W(a, b, d);
    }
}
var $468ad51c3551a14d$var$Nj = !1;
function $468ad51c3551a14d$var$Oj(a, b) {
    $468ad51c3551a14d$var$Cf = $468ad51c3551a14d$var$dd;
    a = $468ad51c3551a14d$var$Me();
    if ($468ad51c3551a14d$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $468ad51c3551a14d$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $468ad51c3551a14d$var$dd = !1;
    for($468ad51c3551a14d$var$V = b; null !== $468ad51c3551a14d$var$V;)if (b = $468ad51c3551a14d$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $468ad51c3551a14d$var$V = a;
    else for(; null !== $468ad51c3551a14d$var$V;){
        b = $468ad51c3551a14d$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $468ad51c3551a14d$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($468ad51c3551a14d$var$p(163));
            }
        } catch (F) {
            $468ad51c3551a14d$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $468ad51c3551a14d$var$V = a;
            break;
        }
        $468ad51c3551a14d$var$V = b.return;
    }
    n = $468ad51c3551a14d$var$Nj;
    $468ad51c3551a14d$var$Nj = !1;
    return n;
}
function $468ad51c3551a14d$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $468ad51c3551a14d$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $468ad51c3551a14d$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $468ad51c3551a14d$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $468ad51c3551a14d$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $468ad51c3551a14d$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$468ad51c3551a14d$var$Of], delete b[$468ad51c3551a14d$var$Pf], delete b[$468ad51c3551a14d$var$of], delete b[$468ad51c3551a14d$var$Qf], delete b[$468ad51c3551a14d$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $468ad51c3551a14d$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $468ad51c3551a14d$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $468ad51c3551a14d$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $468ad51c3551a14d$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $468ad51c3551a14d$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($468ad51c3551a14d$var$Vj(a, b, c), a = a.sibling; null !== a;)$468ad51c3551a14d$var$Vj(a, b, c), a = a.sibling;
}
function $468ad51c3551a14d$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($468ad51c3551a14d$var$Wj(a, b, c), a = a.sibling; null !== a;)$468ad51c3551a14d$var$Wj(a, b, c), a = a.sibling;
}
var $468ad51c3551a14d$var$X = null, $468ad51c3551a14d$var$Xj = !1;
function $468ad51c3551a14d$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$468ad51c3551a14d$var$Zj(a, b, c), c = c.sibling;
}
function $468ad51c3551a14d$var$Zj(a, b, c) {
    if ($468ad51c3551a14d$var$lc && "function" === typeof $468ad51c3551a14d$var$lc.onCommitFiberUnmount) try {
        $468ad51c3551a14d$var$lc.onCommitFiberUnmount($468ad51c3551a14d$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $468ad51c3551a14d$var$U || $468ad51c3551a14d$var$Lj(c, b);
        case 6:
            var d = $468ad51c3551a14d$var$X, e = $468ad51c3551a14d$var$Xj;
            $468ad51c3551a14d$var$X = null;
            $468ad51c3551a14d$var$Yj(a, b, c);
            $468ad51c3551a14d$var$X = d;
            $468ad51c3551a14d$var$Xj = e;
            null !== $468ad51c3551a14d$var$X && ($468ad51c3551a14d$var$Xj ? (a = $468ad51c3551a14d$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $468ad51c3551a14d$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $468ad51c3551a14d$var$X && ($468ad51c3551a14d$var$Xj ? (a = $468ad51c3551a14d$var$X, c = c.stateNode, 8 === a.nodeType ? $468ad51c3551a14d$var$Kf(a.parentNode, c) : 1 === a.nodeType && $468ad51c3551a14d$var$Kf(a, c), $468ad51c3551a14d$var$bd(a)) : $468ad51c3551a14d$var$Kf($468ad51c3551a14d$var$X, c.stateNode));
            break;
        case 4:
            d = $468ad51c3551a14d$var$X;
            e = $468ad51c3551a14d$var$Xj;
            $468ad51c3551a14d$var$X = c.stateNode.containerInfo;
            $468ad51c3551a14d$var$Xj = !0;
            $468ad51c3551a14d$var$Yj(a, b, c);
            $468ad51c3551a14d$var$X = d;
            $468ad51c3551a14d$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$468ad51c3551a14d$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $468ad51c3551a14d$var$Mj(c, b, g) : 0 !== (f & 4) && $468ad51c3551a14d$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $468ad51c3551a14d$var$Yj(a, b, c);
            break;
        case 1:
            if (!$468ad51c3551a14d$var$U && ($468ad51c3551a14d$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $468ad51c3551a14d$var$W(c, b, h);
            }
            $468ad51c3551a14d$var$Yj(a, b, c);
            break;
        case 21:
            $468ad51c3551a14d$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($468ad51c3551a14d$var$U = (d = $468ad51c3551a14d$var$U) || null !== c.memoizedState, $468ad51c3551a14d$var$Yj(a, b, c), $468ad51c3551a14d$var$U = d) : $468ad51c3551a14d$var$Yj(a, b, c);
            break;
        default:
            $468ad51c3551a14d$var$Yj(a, b, c);
    }
}
function $468ad51c3551a14d$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $468ad51c3551a14d$var$Kj);
        b.forEach(function(b) {
            var d = $468ad51c3551a14d$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $468ad51c3551a14d$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $468ad51c3551a14d$var$X = h.stateNode;
                        $468ad51c3551a14d$var$Xj = !1;
                        break a;
                    case 3:
                        $468ad51c3551a14d$var$X = h.stateNode.containerInfo;
                        $468ad51c3551a14d$var$Xj = !0;
                        break a;
                    case 4:
                        $468ad51c3551a14d$var$X = h.stateNode.containerInfo;
                        $468ad51c3551a14d$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $468ad51c3551a14d$var$X) throw Error($468ad51c3551a14d$var$p(160));
            $468ad51c3551a14d$var$Zj(f, g, e);
            $468ad51c3551a14d$var$X = null;
            $468ad51c3551a14d$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $468ad51c3551a14d$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$468ad51c3551a14d$var$dk(b, a), b = b.sibling;
}
function $468ad51c3551a14d$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $468ad51c3551a14d$var$ck(b, a);
            $468ad51c3551a14d$var$ek(a);
            if (d & 4) {
                try {
                    $468ad51c3551a14d$var$Pj(3, a, a.return), $468ad51c3551a14d$var$Qj(3, a);
                } catch (t) {
                    $468ad51c3551a14d$var$W(a, a.return, t);
                }
                try {
                    $468ad51c3551a14d$var$Pj(5, a, a.return);
                } catch (t) {
                    $468ad51c3551a14d$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $468ad51c3551a14d$var$ck(b, a);
            $468ad51c3551a14d$var$ek(a);
            d & 512 && null !== c && $468ad51c3551a14d$var$Lj(c, c.return);
            break;
        case 5:
            $468ad51c3551a14d$var$ck(b, a);
            $468ad51c3551a14d$var$ek(a);
            d & 512 && null !== c && $468ad51c3551a14d$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $468ad51c3551a14d$var$ob(e, "");
                } catch (t) {
                    $468ad51c3551a14d$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $468ad51c3551a14d$var$ab(e, f);
                    $468ad51c3551a14d$var$vb(h, g);
                    var l = $468ad51c3551a14d$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $468ad51c3551a14d$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $468ad51c3551a14d$var$nb(e, q) : "children" === m ? $468ad51c3551a14d$var$ob(e, q) : $468ad51c3551a14d$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $468ad51c3551a14d$var$bb(e, f);
                            break;
                        case "textarea":
                            $468ad51c3551a14d$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $468ad51c3551a14d$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $468ad51c3551a14d$var$fb(e, !!f.multiple, f.defaultValue, !0) : $468ad51c3551a14d$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$468ad51c3551a14d$var$Pf] = f;
                } catch (t) {
                    $468ad51c3551a14d$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $468ad51c3551a14d$var$ck(b, a);
            $468ad51c3551a14d$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($468ad51c3551a14d$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $468ad51c3551a14d$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $468ad51c3551a14d$var$ck(b, a);
            $468ad51c3551a14d$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $468ad51c3551a14d$var$bd(b.containerInfo);
            } catch (t) {
                $468ad51c3551a14d$var$W(a, a.return, t);
            }
            break;
        case 4:
            $468ad51c3551a14d$var$ck(b, a);
            $468ad51c3551a14d$var$ek(a);
            break;
        case 13:
            $468ad51c3551a14d$var$ck(b, a);
            $468ad51c3551a14d$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($468ad51c3551a14d$var$fk = $468ad51c3551a14d$var$B()));
            d & 4 && $468ad51c3551a14d$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($468ad51c3551a14d$var$U = (l = $468ad51c3551a14d$var$U) || m, $468ad51c3551a14d$var$ck(b, a), $468ad51c3551a14d$var$U = l) : $468ad51c3551a14d$var$ck(b, a);
            $468ad51c3551a14d$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($468ad51c3551a14d$var$V = a, m = a.child; null !== m;){
                    for(q = $468ad51c3551a14d$var$V = m; null !== $468ad51c3551a14d$var$V;){
                        r = $468ad51c3551a14d$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $468ad51c3551a14d$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $468ad51c3551a14d$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $468ad51c3551a14d$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $468ad51c3551a14d$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $468ad51c3551a14d$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $468ad51c3551a14d$var$V = y) : $468ad51c3551a14d$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $468ad51c3551a14d$var$rb("display", g));
                            } catch (t) {
                                $468ad51c3551a14d$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $468ad51c3551a14d$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $468ad51c3551a14d$var$ck(b, a);
            $468ad51c3551a14d$var$ek(a);
            d & 4 && $468ad51c3551a14d$var$ak(a);
            break;
        case 21:
            break;
        default:
            $468ad51c3551a14d$var$ck(b, a), $468ad51c3551a14d$var$ek(a);
    }
}
function $468ad51c3551a14d$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($468ad51c3551a14d$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($468ad51c3551a14d$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($468ad51c3551a14d$var$ob(e, ""), d.flags &= -33);
                    var f = $468ad51c3551a14d$var$Uj(a);
                    $468ad51c3551a14d$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $468ad51c3551a14d$var$Uj(a);
                    $468ad51c3551a14d$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($468ad51c3551a14d$var$p(161));
            }
        } catch (k) {
            $468ad51c3551a14d$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $468ad51c3551a14d$var$hk(a, b, c) {
    $468ad51c3551a14d$var$V = a;
    $468ad51c3551a14d$var$ik(a, b, c);
}
function $468ad51c3551a14d$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $468ad51c3551a14d$var$V;){
        var e = $468ad51c3551a14d$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $468ad51c3551a14d$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $468ad51c3551a14d$var$U;
                h = $468ad51c3551a14d$var$Jj;
                var l = $468ad51c3551a14d$var$U;
                $468ad51c3551a14d$var$Jj = g;
                if (($468ad51c3551a14d$var$U = k) && !l) for($468ad51c3551a14d$var$V = e; null !== $468ad51c3551a14d$var$V;)g = $468ad51c3551a14d$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $468ad51c3551a14d$var$jk(e) : null !== k ? (k.return = g, $468ad51c3551a14d$var$V = k) : $468ad51c3551a14d$var$jk(e);
                for(; null !== f;)$468ad51c3551a14d$var$V = f, $468ad51c3551a14d$var$ik(f, b, c), f = f.sibling;
                $468ad51c3551a14d$var$V = e;
                $468ad51c3551a14d$var$Jj = h;
                $468ad51c3551a14d$var$U = l;
            }
            $468ad51c3551a14d$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $468ad51c3551a14d$var$V = f) : $468ad51c3551a14d$var$kk(a, b, c);
    }
}
function $468ad51c3551a14d$var$kk(a) {
    for(; null !== $468ad51c3551a14d$var$V;){
        var b = $468ad51c3551a14d$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $468ad51c3551a14d$var$U || $468ad51c3551a14d$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$468ad51c3551a14d$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $468ad51c3551a14d$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $468ad51c3551a14d$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $468ad51c3551a14d$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $468ad51c3551a14d$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($468ad51c3551a14d$var$p(163));
                }
                $468ad51c3551a14d$var$U || b.flags & 512 && $468ad51c3551a14d$var$Rj(b);
            } catch (r) {
                $468ad51c3551a14d$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $468ad51c3551a14d$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $468ad51c3551a14d$var$V = c;
            break;
        }
        $468ad51c3551a14d$var$V = b.return;
    }
}
function $468ad51c3551a14d$var$gk(a) {
    for(; null !== $468ad51c3551a14d$var$V;){
        var b = $468ad51c3551a14d$var$V;
        if (b === a) {
            $468ad51c3551a14d$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $468ad51c3551a14d$var$V = c;
            break;
        }
        $468ad51c3551a14d$var$V = b.return;
    }
}
function $468ad51c3551a14d$var$jk(a) {
    for(; null !== $468ad51c3551a14d$var$V;){
        var b = $468ad51c3551a14d$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $468ad51c3551a14d$var$Qj(4, b);
                    } catch (k) {
                        $468ad51c3551a14d$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $468ad51c3551a14d$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $468ad51c3551a14d$var$Rj(b);
                    } catch (k) {
                        $468ad51c3551a14d$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $468ad51c3551a14d$var$Rj(b);
                    } catch (k) {
                        $468ad51c3551a14d$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $468ad51c3551a14d$var$W(b, b.return, k);
        }
        if (b === a) {
            $468ad51c3551a14d$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $468ad51c3551a14d$var$V = h;
            break;
        }
        $468ad51c3551a14d$var$V = b.return;
    }
}
var $468ad51c3551a14d$var$lk = Math.ceil, $468ad51c3551a14d$var$mk = $468ad51c3551a14d$var$ua.ReactCurrentDispatcher, $468ad51c3551a14d$var$nk = $468ad51c3551a14d$var$ua.ReactCurrentOwner, $468ad51c3551a14d$var$ok = $468ad51c3551a14d$var$ua.ReactCurrentBatchConfig, $468ad51c3551a14d$var$K = 0, $468ad51c3551a14d$var$Q = null, $468ad51c3551a14d$var$Y = null, $468ad51c3551a14d$var$Z = 0, $468ad51c3551a14d$var$fj = 0, $468ad51c3551a14d$var$ej = $468ad51c3551a14d$var$Uf(0), $468ad51c3551a14d$var$T = 0, $468ad51c3551a14d$var$pk = null, $468ad51c3551a14d$var$rh = 0, $468ad51c3551a14d$var$qk = 0, $468ad51c3551a14d$var$rk = 0, $468ad51c3551a14d$var$sk = null, $468ad51c3551a14d$var$tk = null, $468ad51c3551a14d$var$fk = 0, $468ad51c3551a14d$var$Gj = Infinity, $468ad51c3551a14d$var$uk = null, $468ad51c3551a14d$var$Oi = !1, $468ad51c3551a14d$var$Pi = null, $468ad51c3551a14d$var$Ri = null, $468ad51c3551a14d$var$vk = !1, $468ad51c3551a14d$var$wk = null, $468ad51c3551a14d$var$xk = 0, $468ad51c3551a14d$var$yk = 0, $468ad51c3551a14d$var$zk = null, $468ad51c3551a14d$var$Ak = -1, $468ad51c3551a14d$var$Bk = 0;
function $468ad51c3551a14d$var$R() {
    return 0 !== ($468ad51c3551a14d$var$K & 6) ? $468ad51c3551a14d$var$B() : -1 !== $468ad51c3551a14d$var$Ak ? $468ad51c3551a14d$var$Ak : $468ad51c3551a14d$var$Ak = $468ad51c3551a14d$var$B();
}
function $468ad51c3551a14d$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($468ad51c3551a14d$var$K & 2) && 0 !== $468ad51c3551a14d$var$Z) return $468ad51c3551a14d$var$Z & -$468ad51c3551a14d$var$Z;
    if (null !== $468ad51c3551a14d$var$Kg.transition) return 0 === $468ad51c3551a14d$var$Bk && ($468ad51c3551a14d$var$Bk = $468ad51c3551a14d$var$yc()), $468ad51c3551a14d$var$Bk;
    a = $468ad51c3551a14d$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $468ad51c3551a14d$var$jd(a.type);
    return a;
}
function $468ad51c3551a14d$var$gi(a, b, c, d) {
    if (50 < $468ad51c3551a14d$var$yk) throw $468ad51c3551a14d$var$yk = 0, $468ad51c3551a14d$var$zk = null, Error($468ad51c3551a14d$var$p(185));
    $468ad51c3551a14d$var$Ac(a, c, d);
    if (0 === ($468ad51c3551a14d$var$K & 2) || a !== $468ad51c3551a14d$var$Q) a === $468ad51c3551a14d$var$Q && (0 === ($468ad51c3551a14d$var$K & 2) && ($468ad51c3551a14d$var$qk |= c), 4 === $468ad51c3551a14d$var$T && $468ad51c3551a14d$var$Ck(a, $468ad51c3551a14d$var$Z)), $468ad51c3551a14d$var$Dk(a, d), 1 === c && 0 === $468ad51c3551a14d$var$K && 0 === (b.mode & 1) && ($468ad51c3551a14d$var$Gj = $468ad51c3551a14d$var$B() + 500, $468ad51c3551a14d$var$fg && $468ad51c3551a14d$var$jg());
}
function $468ad51c3551a14d$var$Dk(a, b) {
    var c = a.callbackNode;
    $468ad51c3551a14d$var$wc(a, b);
    var d = $468ad51c3551a14d$var$uc(a, a === $468ad51c3551a14d$var$Q ? $468ad51c3551a14d$var$Z : 0);
    if (0 === d) null !== c && $468ad51c3551a14d$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $468ad51c3551a14d$var$bc(c);
        if (1 === b) 0 === a.tag ? $468ad51c3551a14d$var$ig($468ad51c3551a14d$var$Ek.bind(null, a)) : $468ad51c3551a14d$var$hg($468ad51c3551a14d$var$Ek.bind(null, a)), $468ad51c3551a14d$var$Jf(function() {
            0 === ($468ad51c3551a14d$var$K & 6) && $468ad51c3551a14d$var$jg();
        }), c = null;
        else {
            switch($468ad51c3551a14d$var$Dc(d)){
                case 1:
                    c = $468ad51c3551a14d$var$fc;
                    break;
                case 4:
                    c = $468ad51c3551a14d$var$gc;
                    break;
                case 16:
                    c = $468ad51c3551a14d$var$hc;
                    break;
                case 536870912:
                    c = $468ad51c3551a14d$var$jc;
                    break;
                default:
                    c = $468ad51c3551a14d$var$hc;
            }
            c = $468ad51c3551a14d$var$Fk(c, $468ad51c3551a14d$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $468ad51c3551a14d$var$Gk(a, b) {
    $468ad51c3551a14d$var$Ak = -1;
    $468ad51c3551a14d$var$Bk = 0;
    if (0 !== ($468ad51c3551a14d$var$K & 6)) throw Error($468ad51c3551a14d$var$p(327));
    var c = a.callbackNode;
    if ($468ad51c3551a14d$var$Hk() && a.callbackNode !== c) return null;
    var d = $468ad51c3551a14d$var$uc(a, a === $468ad51c3551a14d$var$Q ? $468ad51c3551a14d$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $468ad51c3551a14d$var$Ik(a, d);
    else {
        b = d;
        var e = $468ad51c3551a14d$var$K;
        $468ad51c3551a14d$var$K |= 2;
        var f = $468ad51c3551a14d$var$Jk();
        if ($468ad51c3551a14d$var$Q !== a || $468ad51c3551a14d$var$Z !== b) $468ad51c3551a14d$var$uk = null, $468ad51c3551a14d$var$Gj = $468ad51c3551a14d$var$B() + 500, $468ad51c3551a14d$var$Kk(a, b);
        for(;;)try {
            $468ad51c3551a14d$var$Lk();
            break;
        } catch (h) {
            $468ad51c3551a14d$var$Mk(a, h);
        }
        $468ad51c3551a14d$var$$g();
        $468ad51c3551a14d$var$mk.current = f;
        $468ad51c3551a14d$var$K = e;
        null !== $468ad51c3551a14d$var$Y ? b = 0 : ($468ad51c3551a14d$var$Q = null, $468ad51c3551a14d$var$Z = 0, b = $468ad51c3551a14d$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $468ad51c3551a14d$var$xc(a), 0 !== e && (d = e, b = $468ad51c3551a14d$var$Nk(a, e)));
        if (1 === b) throw c = $468ad51c3551a14d$var$pk, $468ad51c3551a14d$var$Kk(a, 0), $468ad51c3551a14d$var$Ck(a, d), $468ad51c3551a14d$var$Dk(a, $468ad51c3551a14d$var$B()), c;
        if (6 === b) $468ad51c3551a14d$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$468ad51c3551a14d$var$Ok(e) && (b = $468ad51c3551a14d$var$Ik(a, d), 2 === b && (f = $468ad51c3551a14d$var$xc(a), 0 !== f && (d = f, b = $468ad51c3551a14d$var$Nk(a, f))), 1 === b)) throw c = $468ad51c3551a14d$var$pk, $468ad51c3551a14d$var$Kk(a, 0), $468ad51c3551a14d$var$Ck(a, d), $468ad51c3551a14d$var$Dk(a, $468ad51c3551a14d$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($468ad51c3551a14d$var$p(345));
                case 2:
                    $468ad51c3551a14d$var$Pk(a, $468ad51c3551a14d$var$tk, $468ad51c3551a14d$var$uk);
                    break;
                case 3:
                    $468ad51c3551a14d$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $468ad51c3551a14d$var$fk + 500 - $468ad51c3551a14d$var$B(), 10 < b)) {
                        if (0 !== $468ad51c3551a14d$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $468ad51c3551a14d$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $468ad51c3551a14d$var$Ff($468ad51c3551a14d$var$Pk.bind(null, a, $468ad51c3551a14d$var$tk, $468ad51c3551a14d$var$uk), b);
                        break;
                    }
                    $468ad51c3551a14d$var$Pk(a, $468ad51c3551a14d$var$tk, $468ad51c3551a14d$var$uk);
                    break;
                case 4:
                    $468ad51c3551a14d$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $468ad51c3551a14d$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $468ad51c3551a14d$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $468ad51c3551a14d$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $468ad51c3551a14d$var$Ff($468ad51c3551a14d$var$Pk.bind(null, a, $468ad51c3551a14d$var$tk, $468ad51c3551a14d$var$uk), d);
                        break;
                    }
                    $468ad51c3551a14d$var$Pk(a, $468ad51c3551a14d$var$tk, $468ad51c3551a14d$var$uk);
                    break;
                case 5:
                    $468ad51c3551a14d$var$Pk(a, $468ad51c3551a14d$var$tk, $468ad51c3551a14d$var$uk);
                    break;
                default:
                    throw Error($468ad51c3551a14d$var$p(329));
            }
        }
    }
    $468ad51c3551a14d$var$Dk(a, $468ad51c3551a14d$var$B());
    return a.callbackNode === c ? $468ad51c3551a14d$var$Gk.bind(null, a) : null;
}
function $468ad51c3551a14d$var$Nk(a, b) {
    var c = $468ad51c3551a14d$var$sk;
    a.current.memoizedState.isDehydrated && ($468ad51c3551a14d$var$Kk(a, b).flags |= 256);
    a = $468ad51c3551a14d$var$Ik(a, b);
    2 !== a && (b = $468ad51c3551a14d$var$tk, $468ad51c3551a14d$var$tk = c, null !== b && $468ad51c3551a14d$var$Fj(b));
    return a;
}
function $468ad51c3551a14d$var$Fj(a) {
    null === $468ad51c3551a14d$var$tk ? $468ad51c3551a14d$var$tk = a : $468ad51c3551a14d$var$tk.push.apply($468ad51c3551a14d$var$tk, a);
}
function $468ad51c3551a14d$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$468ad51c3551a14d$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $468ad51c3551a14d$var$Ck(a, b) {
    b &= ~$468ad51c3551a14d$var$rk;
    b &= ~$468ad51c3551a14d$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $468ad51c3551a14d$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $468ad51c3551a14d$var$Ek(a) {
    if (0 !== ($468ad51c3551a14d$var$K & 6)) throw Error($468ad51c3551a14d$var$p(327));
    $468ad51c3551a14d$var$Hk();
    var b = $468ad51c3551a14d$var$uc(a, 0);
    if (0 === (b & 1)) return $468ad51c3551a14d$var$Dk(a, $468ad51c3551a14d$var$B()), null;
    var c = $468ad51c3551a14d$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $468ad51c3551a14d$var$xc(a);
        0 !== d && (b = d, c = $468ad51c3551a14d$var$Nk(a, d));
    }
    if (1 === c) throw c = $468ad51c3551a14d$var$pk, $468ad51c3551a14d$var$Kk(a, 0), $468ad51c3551a14d$var$Ck(a, b), $468ad51c3551a14d$var$Dk(a, $468ad51c3551a14d$var$B()), c;
    if (6 === c) throw Error($468ad51c3551a14d$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $468ad51c3551a14d$var$Pk(a, $468ad51c3551a14d$var$tk, $468ad51c3551a14d$var$uk);
    $468ad51c3551a14d$var$Dk(a, $468ad51c3551a14d$var$B());
    return null;
}
function $468ad51c3551a14d$var$Qk(a, b) {
    var c = $468ad51c3551a14d$var$K;
    $468ad51c3551a14d$var$K |= 1;
    try {
        return a(b);
    } finally{
        $468ad51c3551a14d$var$K = c, 0 === $468ad51c3551a14d$var$K && ($468ad51c3551a14d$var$Gj = $468ad51c3551a14d$var$B() + 500, $468ad51c3551a14d$var$fg && $468ad51c3551a14d$var$jg());
    }
}
function $468ad51c3551a14d$var$Rk(a) {
    null !== $468ad51c3551a14d$var$wk && 0 === $468ad51c3551a14d$var$wk.tag && 0 === ($468ad51c3551a14d$var$K & 6) && $468ad51c3551a14d$var$Hk();
    var b = $468ad51c3551a14d$var$K;
    $468ad51c3551a14d$var$K |= 1;
    var c = $468ad51c3551a14d$var$ok.transition, d = $468ad51c3551a14d$var$C;
    try {
        if ($468ad51c3551a14d$var$ok.transition = null, $468ad51c3551a14d$var$C = 1, a) return a();
    } finally{
        $468ad51c3551a14d$var$C = d, $468ad51c3551a14d$var$ok.transition = c, $468ad51c3551a14d$var$K = b, 0 === ($468ad51c3551a14d$var$K & 6) && $468ad51c3551a14d$var$jg();
    }
}
function $468ad51c3551a14d$var$Hj() {
    $468ad51c3551a14d$var$fj = $468ad51c3551a14d$var$ej.current;
    $468ad51c3551a14d$var$E($468ad51c3551a14d$var$ej);
}
function $468ad51c3551a14d$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $468ad51c3551a14d$var$Gf(c));
    if (null !== $468ad51c3551a14d$var$Y) for(c = $468ad51c3551a14d$var$Y.return; null !== c;){
        var d = c;
        $468ad51c3551a14d$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $468ad51c3551a14d$var$$f();
                break;
            case 3:
                $468ad51c3551a14d$var$zh();
                $468ad51c3551a14d$var$E($468ad51c3551a14d$var$Wf);
                $468ad51c3551a14d$var$E($468ad51c3551a14d$var$H);
                $468ad51c3551a14d$var$Eh();
                break;
            case 5:
                $468ad51c3551a14d$var$Bh(d);
                break;
            case 4:
                $468ad51c3551a14d$var$zh();
                break;
            case 13:
                $468ad51c3551a14d$var$E($468ad51c3551a14d$var$L);
                break;
            case 19:
                $468ad51c3551a14d$var$E($468ad51c3551a14d$var$L);
                break;
            case 10:
                $468ad51c3551a14d$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $468ad51c3551a14d$var$Hj();
        }
        c = c.return;
    }
    $468ad51c3551a14d$var$Q = a;
    $468ad51c3551a14d$var$Y = a = $468ad51c3551a14d$var$Pg(a.current, null);
    $468ad51c3551a14d$var$Z = $468ad51c3551a14d$var$fj = b;
    $468ad51c3551a14d$var$T = 0;
    $468ad51c3551a14d$var$pk = null;
    $468ad51c3551a14d$var$rk = $468ad51c3551a14d$var$qk = $468ad51c3551a14d$var$rh = 0;
    $468ad51c3551a14d$var$tk = $468ad51c3551a14d$var$sk = null;
    if (null !== $468ad51c3551a14d$var$fh) {
        for(b = 0; b < $468ad51c3551a14d$var$fh.length; b++)if (c = $468ad51c3551a14d$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $468ad51c3551a14d$var$fh = null;
    }
    return a;
}
function $468ad51c3551a14d$var$Mk(a, b) {
    do {
        var c = $468ad51c3551a14d$var$Y;
        try {
            $468ad51c3551a14d$var$$g();
            $468ad51c3551a14d$var$Fh.current = $468ad51c3551a14d$var$Rh;
            if ($468ad51c3551a14d$var$Ih) {
                for(var d = $468ad51c3551a14d$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $468ad51c3551a14d$var$Ih = !1;
            }
            $468ad51c3551a14d$var$Hh = 0;
            $468ad51c3551a14d$var$O = $468ad51c3551a14d$var$N = $468ad51c3551a14d$var$M = null;
            $468ad51c3551a14d$var$Jh = !1;
            $468ad51c3551a14d$var$Kh = 0;
            $468ad51c3551a14d$var$nk.current = null;
            if (null === c || null === c.return) {
                $468ad51c3551a14d$var$T = 1;
                $468ad51c3551a14d$var$pk = b;
                $468ad51c3551a14d$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $468ad51c3551a14d$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $468ad51c3551a14d$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $468ad51c3551a14d$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $468ad51c3551a14d$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $468ad51c3551a14d$var$Si(f, l, b);
                            $468ad51c3551a14d$var$tj();
                            break a;
                        }
                        k = Error($468ad51c3551a14d$var$p(426));
                    }
                } else if ($468ad51c3551a14d$var$I && h.mode & 1) {
                    var J = $468ad51c3551a14d$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $468ad51c3551a14d$var$Vi(J, g, h, f, b);
                        $468ad51c3551a14d$var$Jg($468ad51c3551a14d$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $468ad51c3551a14d$var$Ji(k, h);
                4 !== $468ad51c3551a14d$var$T && ($468ad51c3551a14d$var$T = 2);
                null === $468ad51c3551a14d$var$sk ? $468ad51c3551a14d$var$sk = [
                    f
                ] : $468ad51c3551a14d$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $468ad51c3551a14d$var$Ni(f, k, b);
                            $468ad51c3551a14d$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $468ad51c3551a14d$var$Ri || !$468ad51c3551a14d$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $468ad51c3551a14d$var$Qi(f, h, b);
                                $468ad51c3551a14d$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $468ad51c3551a14d$var$Sk(c);
        } catch (na) {
            b = na;
            $468ad51c3551a14d$var$Y === c && null !== c && ($468ad51c3551a14d$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $468ad51c3551a14d$var$Jk() {
    var a = $468ad51c3551a14d$var$mk.current;
    $468ad51c3551a14d$var$mk.current = $468ad51c3551a14d$var$Rh;
    return null === a ? $468ad51c3551a14d$var$Rh : a;
}
function $468ad51c3551a14d$var$tj() {
    if (0 === $468ad51c3551a14d$var$T || 3 === $468ad51c3551a14d$var$T || 2 === $468ad51c3551a14d$var$T) $468ad51c3551a14d$var$T = 4;
    null === $468ad51c3551a14d$var$Q || 0 === ($468ad51c3551a14d$var$rh & 268435455) && 0 === ($468ad51c3551a14d$var$qk & 268435455) || $468ad51c3551a14d$var$Ck($468ad51c3551a14d$var$Q, $468ad51c3551a14d$var$Z);
}
function $468ad51c3551a14d$var$Ik(a, b) {
    var c = $468ad51c3551a14d$var$K;
    $468ad51c3551a14d$var$K |= 2;
    var d = $468ad51c3551a14d$var$Jk();
    if ($468ad51c3551a14d$var$Q !== a || $468ad51c3551a14d$var$Z !== b) $468ad51c3551a14d$var$uk = null, $468ad51c3551a14d$var$Kk(a, b);
    for(;;)try {
        $468ad51c3551a14d$var$Tk();
        break;
    } catch (e) {
        $468ad51c3551a14d$var$Mk(a, e);
    }
    $468ad51c3551a14d$var$$g();
    $468ad51c3551a14d$var$K = c;
    $468ad51c3551a14d$var$mk.current = d;
    if (null !== $468ad51c3551a14d$var$Y) throw Error($468ad51c3551a14d$var$p(261));
    $468ad51c3551a14d$var$Q = null;
    $468ad51c3551a14d$var$Z = 0;
    return $468ad51c3551a14d$var$T;
}
function $468ad51c3551a14d$var$Tk() {
    for(; null !== $468ad51c3551a14d$var$Y;)$468ad51c3551a14d$var$Uk($468ad51c3551a14d$var$Y);
}
function $468ad51c3551a14d$var$Lk() {
    for(; null !== $468ad51c3551a14d$var$Y && !$468ad51c3551a14d$var$cc();)$468ad51c3551a14d$var$Uk($468ad51c3551a14d$var$Y);
}
function $468ad51c3551a14d$var$Uk(a) {
    var b = $468ad51c3551a14d$var$Vk(a.alternate, a, $468ad51c3551a14d$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $468ad51c3551a14d$var$Sk(a) : $468ad51c3551a14d$var$Y = b;
    $468ad51c3551a14d$var$nk.current = null;
}
function $468ad51c3551a14d$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $468ad51c3551a14d$var$Ej(c, b, $468ad51c3551a14d$var$fj), null !== c) {
                $468ad51c3551a14d$var$Y = c;
                return;
            }
        } else {
            c = $468ad51c3551a14d$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $468ad51c3551a14d$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $468ad51c3551a14d$var$T = 6;
                $468ad51c3551a14d$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $468ad51c3551a14d$var$Y = b;
            return;
        }
        $468ad51c3551a14d$var$Y = b = a;
    }while (null !== b);
    0 === $468ad51c3551a14d$var$T && ($468ad51c3551a14d$var$T = 5);
}
function $468ad51c3551a14d$var$Pk(a, b, c) {
    var d = $468ad51c3551a14d$var$C, e = $468ad51c3551a14d$var$ok.transition;
    try {
        $468ad51c3551a14d$var$ok.transition = null, $468ad51c3551a14d$var$C = 1, $468ad51c3551a14d$var$Wk(a, b, c, d);
    } finally{
        $468ad51c3551a14d$var$ok.transition = e, $468ad51c3551a14d$var$C = d;
    }
    return null;
}
function $468ad51c3551a14d$var$Wk(a, b, c, d) {
    do $468ad51c3551a14d$var$Hk();
    while (null !== $468ad51c3551a14d$var$wk);
    if (0 !== ($468ad51c3551a14d$var$K & 6)) throw Error($468ad51c3551a14d$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($468ad51c3551a14d$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $468ad51c3551a14d$var$Bc(a, f);
    a === $468ad51c3551a14d$var$Q && ($468ad51c3551a14d$var$Y = $468ad51c3551a14d$var$Q = null, $468ad51c3551a14d$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $468ad51c3551a14d$var$vk || ($468ad51c3551a14d$var$vk = !0, $468ad51c3551a14d$var$Fk($468ad51c3551a14d$var$hc, function() {
        $468ad51c3551a14d$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $468ad51c3551a14d$var$ok.transition;
        $468ad51c3551a14d$var$ok.transition = null;
        var g = $468ad51c3551a14d$var$C;
        $468ad51c3551a14d$var$C = 1;
        var h = $468ad51c3551a14d$var$K;
        $468ad51c3551a14d$var$K |= 4;
        $468ad51c3551a14d$var$nk.current = null;
        $468ad51c3551a14d$var$Oj(a, c);
        $468ad51c3551a14d$var$dk(c, a);
        $468ad51c3551a14d$var$Oe($468ad51c3551a14d$var$Df);
        $468ad51c3551a14d$var$dd = !!$468ad51c3551a14d$var$Cf;
        $468ad51c3551a14d$var$Df = $468ad51c3551a14d$var$Cf = null;
        a.current = c;
        $468ad51c3551a14d$var$hk(c, a, e);
        $468ad51c3551a14d$var$dc();
        $468ad51c3551a14d$var$K = h;
        $468ad51c3551a14d$var$C = g;
        $468ad51c3551a14d$var$ok.transition = f;
    } else a.current = c;
    $468ad51c3551a14d$var$vk && ($468ad51c3551a14d$var$vk = !1, $468ad51c3551a14d$var$wk = a, $468ad51c3551a14d$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($468ad51c3551a14d$var$Ri = null);
    $468ad51c3551a14d$var$mc(c.stateNode, d);
    $468ad51c3551a14d$var$Dk(a, $468ad51c3551a14d$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($468ad51c3551a14d$var$Oi) throw $468ad51c3551a14d$var$Oi = !1, a = $468ad51c3551a14d$var$Pi, $468ad51c3551a14d$var$Pi = null, a;
    0 !== ($468ad51c3551a14d$var$xk & 1) && 0 !== a.tag && $468ad51c3551a14d$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $468ad51c3551a14d$var$zk ? $468ad51c3551a14d$var$yk++ : ($468ad51c3551a14d$var$yk = 0, $468ad51c3551a14d$var$zk = a) : $468ad51c3551a14d$var$yk = 0;
    $468ad51c3551a14d$var$jg();
    return null;
}
function $468ad51c3551a14d$var$Hk() {
    if (null !== $468ad51c3551a14d$var$wk) {
        var a = $468ad51c3551a14d$var$Dc($468ad51c3551a14d$var$xk), b = $468ad51c3551a14d$var$ok.transition, c = $468ad51c3551a14d$var$C;
        try {
            $468ad51c3551a14d$var$ok.transition = null;
            $468ad51c3551a14d$var$C = 16 > a ? 16 : a;
            if (null === $468ad51c3551a14d$var$wk) var d = !1;
            else {
                a = $468ad51c3551a14d$var$wk;
                $468ad51c3551a14d$var$wk = null;
                $468ad51c3551a14d$var$xk = 0;
                if (0 !== ($468ad51c3551a14d$var$K & 6)) throw Error($468ad51c3551a14d$var$p(331));
                var e = $468ad51c3551a14d$var$K;
                $468ad51c3551a14d$var$K |= 4;
                for($468ad51c3551a14d$var$V = a.current; null !== $468ad51c3551a14d$var$V;){
                    var f = $468ad51c3551a14d$var$V, g = f.child;
                    if (0 !== ($468ad51c3551a14d$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($468ad51c3551a14d$var$V = l; null !== $468ad51c3551a14d$var$V;){
                                    var m = $468ad51c3551a14d$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $468ad51c3551a14d$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $468ad51c3551a14d$var$V = q;
                                    else for(; null !== $468ad51c3551a14d$var$V;){
                                        m = $468ad51c3551a14d$var$V;
                                        var r = m.sibling, y = m.return;
                                        $468ad51c3551a14d$var$Sj(m);
                                        if (m === l) {
                                            $468ad51c3551a14d$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $468ad51c3551a14d$var$V = r;
                                            break;
                                        }
                                        $468ad51c3551a14d$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $468ad51c3551a14d$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $468ad51c3551a14d$var$V = g;
                    else b: for(; null !== $468ad51c3551a14d$var$V;){
                        f = $468ad51c3551a14d$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $468ad51c3551a14d$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $468ad51c3551a14d$var$V = x;
                            break b;
                        }
                        $468ad51c3551a14d$var$V = f.return;
                    }
                }
                var w = a.current;
                for($468ad51c3551a14d$var$V = w; null !== $468ad51c3551a14d$var$V;){
                    g = $468ad51c3551a14d$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $468ad51c3551a14d$var$V = u;
                    else b: for(g = w; null !== $468ad51c3551a14d$var$V;){
                        h = $468ad51c3551a14d$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $468ad51c3551a14d$var$Qj(9, h);
                            }
                        } catch (na) {
                            $468ad51c3551a14d$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $468ad51c3551a14d$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $468ad51c3551a14d$var$V = F;
                            break b;
                        }
                        $468ad51c3551a14d$var$V = h.return;
                    }
                }
                $468ad51c3551a14d$var$K = e;
                $468ad51c3551a14d$var$jg();
                if ($468ad51c3551a14d$var$lc && "function" === typeof $468ad51c3551a14d$var$lc.onPostCommitFiberRoot) try {
                    $468ad51c3551a14d$var$lc.onPostCommitFiberRoot($468ad51c3551a14d$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $468ad51c3551a14d$var$C = c, $468ad51c3551a14d$var$ok.transition = b;
        }
    }
    return !1;
}
function $468ad51c3551a14d$var$Xk(a, b, c) {
    b = $468ad51c3551a14d$var$Ji(c, b);
    b = $468ad51c3551a14d$var$Ni(a, b, 1);
    a = $468ad51c3551a14d$var$nh(a, b, 1);
    b = $468ad51c3551a14d$var$R();
    null !== a && ($468ad51c3551a14d$var$Ac(a, 1, b), $468ad51c3551a14d$var$Dk(a, b));
}
function $468ad51c3551a14d$var$W(a, b, c) {
    if (3 === a.tag) $468ad51c3551a14d$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $468ad51c3551a14d$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $468ad51c3551a14d$var$Ri || !$468ad51c3551a14d$var$Ri.has(d))) {
                a = $468ad51c3551a14d$var$Ji(c, a);
                a = $468ad51c3551a14d$var$Qi(b, a, 1);
                b = $468ad51c3551a14d$var$nh(b, a, 1);
                a = $468ad51c3551a14d$var$R();
                null !== b && ($468ad51c3551a14d$var$Ac(b, 1, a), $468ad51c3551a14d$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $468ad51c3551a14d$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $468ad51c3551a14d$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $468ad51c3551a14d$var$Q === a && ($468ad51c3551a14d$var$Z & c) === c && (4 === $468ad51c3551a14d$var$T || 3 === $468ad51c3551a14d$var$T && ($468ad51c3551a14d$var$Z & 130023424) === $468ad51c3551a14d$var$Z && 500 > $468ad51c3551a14d$var$B() - $468ad51c3551a14d$var$fk ? $468ad51c3551a14d$var$Kk(a, 0) : $468ad51c3551a14d$var$rk |= c);
    $468ad51c3551a14d$var$Dk(a, b);
}
function $468ad51c3551a14d$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $468ad51c3551a14d$var$sc, $468ad51c3551a14d$var$sc <<= 1, 0 === ($468ad51c3551a14d$var$sc & 130023424) && ($468ad51c3551a14d$var$sc = 4194304)));
    var c = $468ad51c3551a14d$var$R();
    a = $468ad51c3551a14d$var$ih(a, b);
    null !== a && ($468ad51c3551a14d$var$Ac(a, b, c), $468ad51c3551a14d$var$Dk(a, c));
}
function $468ad51c3551a14d$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $468ad51c3551a14d$var$Yk(a, c);
}
function $468ad51c3551a14d$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($468ad51c3551a14d$var$p(314));
    }
    null !== d && d.delete(b);
    $468ad51c3551a14d$var$Yk(a, c);
}
var $468ad51c3551a14d$var$Vk;
$468ad51c3551a14d$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $468ad51c3551a14d$var$Wf.current) $468ad51c3551a14d$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $468ad51c3551a14d$var$dh = !1, $468ad51c3551a14d$var$yj(a, b, c);
            $468ad51c3551a14d$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $468ad51c3551a14d$var$dh = !1, $468ad51c3551a14d$var$I && 0 !== (b.flags & 1048576) && $468ad51c3551a14d$var$ug(b, $468ad51c3551a14d$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $468ad51c3551a14d$var$ij(a, b);
            a = b.pendingProps;
            var e = $468ad51c3551a14d$var$Yf(b, $468ad51c3551a14d$var$H.current);
            $468ad51c3551a14d$var$ch(b, c);
            e = $468ad51c3551a14d$var$Nh(null, b, d, a, e, c);
            var f = $468ad51c3551a14d$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $468ad51c3551a14d$var$Zf(d) ? (f = !0, $468ad51c3551a14d$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $468ad51c3551a14d$var$kh(b), e.updater = $468ad51c3551a14d$var$Ei, b.stateNode = e, e._reactInternals = b, $468ad51c3551a14d$var$Ii(b, d, a, c), b = $468ad51c3551a14d$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $468ad51c3551a14d$var$I && f && $468ad51c3551a14d$var$vg(b), $468ad51c3551a14d$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $468ad51c3551a14d$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $468ad51c3551a14d$var$Zk(d);
                a = $468ad51c3551a14d$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $468ad51c3551a14d$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $468ad51c3551a14d$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $468ad51c3551a14d$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $468ad51c3551a14d$var$$i(null, b, d, $468ad51c3551a14d$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($468ad51c3551a14d$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $468ad51c3551a14d$var$Ci(d, e), $468ad51c3551a14d$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $468ad51c3551a14d$var$Ci(d, e), $468ad51c3551a14d$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $468ad51c3551a14d$var$kj(b);
                if (null === a) throw Error($468ad51c3551a14d$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $468ad51c3551a14d$var$lh(a, b);
                $468ad51c3551a14d$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $468ad51c3551a14d$var$Ji(Error($468ad51c3551a14d$var$p(423)), b);
                        b = $468ad51c3551a14d$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $468ad51c3551a14d$var$Ji(Error($468ad51c3551a14d$var$p(424)), b);
                        b = $468ad51c3551a14d$var$lj(a, b, d, c, e);
                        break a;
                    } else for($468ad51c3551a14d$var$yg = $468ad51c3551a14d$var$Lf(b.stateNode.containerInfo.firstChild), $468ad51c3551a14d$var$xg = b, $468ad51c3551a14d$var$I = !0, $468ad51c3551a14d$var$zg = null, c = $468ad51c3551a14d$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $468ad51c3551a14d$var$Ig();
                    if (d === e) {
                        b = $468ad51c3551a14d$var$Zi(a, b, c);
                        break a;
                    }
                    $468ad51c3551a14d$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $468ad51c3551a14d$var$Ah(b), null === a && $468ad51c3551a14d$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $468ad51c3551a14d$var$Ef(d, e) ? g = null : null !== f && $468ad51c3551a14d$var$Ef(d, f) && (b.flags |= 32), $468ad51c3551a14d$var$gj(a, b), $468ad51c3551a14d$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $468ad51c3551a14d$var$Eg(b), null;
        case 13:
            return $468ad51c3551a14d$var$oj(a, b, c);
        case 4:
            return $468ad51c3551a14d$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $468ad51c3551a14d$var$Ug(b, null, d, c) : $468ad51c3551a14d$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $468ad51c3551a14d$var$Ci(d, e), $468ad51c3551a14d$var$Yi(a, b, d, e, c);
        case 7:
            return $468ad51c3551a14d$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $468ad51c3551a14d$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $468ad51c3551a14d$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $468ad51c3551a14d$var$G($468ad51c3551a14d$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($468ad51c3551a14d$var$He(f.value, g)) {
                        if (f.children === e.children && !$468ad51c3551a14d$var$Wf.current) {
                            b = $468ad51c3551a14d$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $468ad51c3551a14d$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $468ad51c3551a14d$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($468ad51c3551a14d$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $468ad51c3551a14d$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $468ad51c3551a14d$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $468ad51c3551a14d$var$ch(b, c), e = $468ad51c3551a14d$var$eh(e), d = d(e), b.flags |= 1, $468ad51c3551a14d$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $468ad51c3551a14d$var$Ci(d, b.pendingProps), e = $468ad51c3551a14d$var$Ci(d.type, e), $468ad51c3551a14d$var$$i(a, b, d, e, c);
        case 15:
            return $468ad51c3551a14d$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $468ad51c3551a14d$var$Ci(d, e), $468ad51c3551a14d$var$ij(a, b), b.tag = 1, $468ad51c3551a14d$var$Zf(d) ? (a = !0, $468ad51c3551a14d$var$cg(b)) : a = !1, $468ad51c3551a14d$var$ch(b, c), $468ad51c3551a14d$var$Gi(b, d, e), $468ad51c3551a14d$var$Ii(b, d, e, c), $468ad51c3551a14d$var$jj(null, b, d, !0, a, c);
        case 19:
            return $468ad51c3551a14d$var$xj(a, b, c);
        case 22:
            return $468ad51c3551a14d$var$dj(a, b, c);
    }
    throw Error($468ad51c3551a14d$var$p(156, b.tag));
};
function $468ad51c3551a14d$var$Fk(a, b) {
    return $468ad51c3551a14d$var$ac(a, b);
}
function $468ad51c3551a14d$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $468ad51c3551a14d$var$Bg(a, b, c, d) {
    return new $468ad51c3551a14d$var$$k(a, b, c, d);
}
function $468ad51c3551a14d$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $468ad51c3551a14d$var$Zk(a) {
    if ("function" === typeof a) return $468ad51c3551a14d$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $468ad51c3551a14d$var$Da) return 11;
        if (a === $468ad51c3551a14d$var$Ga) return 14;
    }
    return 2;
}
function $468ad51c3551a14d$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $468ad51c3551a14d$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $468ad51c3551a14d$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $468ad51c3551a14d$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $468ad51c3551a14d$var$ya:
            return $468ad51c3551a14d$var$Tg(c.children, e, f, b);
        case $468ad51c3551a14d$var$za:
            g = 8;
            e |= 8;
            break;
        case $468ad51c3551a14d$var$Aa:
            return a = $468ad51c3551a14d$var$Bg(12, c, b, e | 2), a.elementType = $468ad51c3551a14d$var$Aa, a.lanes = f, a;
        case $468ad51c3551a14d$var$Ea:
            return a = $468ad51c3551a14d$var$Bg(13, c, b, e), a.elementType = $468ad51c3551a14d$var$Ea, a.lanes = f, a;
        case $468ad51c3551a14d$var$Fa:
            return a = $468ad51c3551a14d$var$Bg(19, c, b, e), a.elementType = $468ad51c3551a14d$var$Fa, a.lanes = f, a;
        case $468ad51c3551a14d$var$Ia:
            return $468ad51c3551a14d$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $468ad51c3551a14d$var$Ba:
                    g = 10;
                    break a;
                case $468ad51c3551a14d$var$Ca:
                    g = 9;
                    break a;
                case $468ad51c3551a14d$var$Da:
                    g = 11;
                    break a;
                case $468ad51c3551a14d$var$Ga:
                    g = 14;
                    break a;
                case $468ad51c3551a14d$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($468ad51c3551a14d$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $468ad51c3551a14d$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $468ad51c3551a14d$var$Tg(a, b, c, d) {
    a = $468ad51c3551a14d$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $468ad51c3551a14d$var$pj(a, b, c, d) {
    a = $468ad51c3551a14d$var$Bg(22, a, d, b);
    a.elementType = $468ad51c3551a14d$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $468ad51c3551a14d$var$Qg(a, b, c) {
    a = $468ad51c3551a14d$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $468ad51c3551a14d$var$Sg(a, b, c) {
    b = $468ad51c3551a14d$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $468ad51c3551a14d$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $468ad51c3551a14d$var$zc(0);
    this.expirationTimes = $468ad51c3551a14d$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $468ad51c3551a14d$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $468ad51c3551a14d$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $468ad51c3551a14d$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $468ad51c3551a14d$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $468ad51c3551a14d$var$kh(f);
    return a;
}
function $468ad51c3551a14d$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $468ad51c3551a14d$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $468ad51c3551a14d$var$dl(a) {
    if (!a) return $468ad51c3551a14d$var$Vf;
    a = a._reactInternals;
    a: {
        if ($468ad51c3551a14d$var$Vb(a) !== a || 1 !== a.tag) throw Error($468ad51c3551a14d$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($468ad51c3551a14d$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($468ad51c3551a14d$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($468ad51c3551a14d$var$Zf(c)) return $468ad51c3551a14d$var$bg(a, c, b);
    }
    return b;
}
function $468ad51c3551a14d$var$el(a, b, c, d, e, f, g, h, k) {
    a = $468ad51c3551a14d$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $468ad51c3551a14d$var$dl(null);
    c = a.current;
    d = $468ad51c3551a14d$var$R();
    e = $468ad51c3551a14d$var$yi(c);
    f = $468ad51c3551a14d$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $468ad51c3551a14d$var$nh(c, f, e);
    a.current.lanes = e;
    $468ad51c3551a14d$var$Ac(a, e, d);
    $468ad51c3551a14d$var$Dk(a, d);
    return a;
}
function $468ad51c3551a14d$var$fl(a, b, c, d) {
    var e = b.current, f = $468ad51c3551a14d$var$R(), g = $468ad51c3551a14d$var$yi(e);
    c = $468ad51c3551a14d$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $468ad51c3551a14d$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $468ad51c3551a14d$var$nh(e, b, g);
    null !== a && ($468ad51c3551a14d$var$gi(a, e, g, f), $468ad51c3551a14d$var$oh(a, e, g));
    return g;
}
function $468ad51c3551a14d$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $468ad51c3551a14d$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $468ad51c3551a14d$var$il(a, b) {
    $468ad51c3551a14d$var$hl(a, b);
    (a = a.alternate) && $468ad51c3551a14d$var$hl(a, b);
}
function $468ad51c3551a14d$var$jl() {
    return null;
}
var $468ad51c3551a14d$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $468ad51c3551a14d$var$ll(a) {
    this._internalRoot = a;
}
$468ad51c3551a14d$var$ml.prototype.render = $468ad51c3551a14d$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($468ad51c3551a14d$var$p(409));
    $468ad51c3551a14d$var$fl(a, b, null, null);
};
$468ad51c3551a14d$var$ml.prototype.unmount = $468ad51c3551a14d$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $468ad51c3551a14d$var$Rk(function() {
            $468ad51c3551a14d$var$fl(null, a, null, null);
        });
        b[$468ad51c3551a14d$var$uf] = null;
    }
};
function $468ad51c3551a14d$var$ml(a) {
    this._internalRoot = a;
}
$468ad51c3551a14d$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $468ad51c3551a14d$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $468ad51c3551a14d$var$Qc.length && 0 !== b && b < $468ad51c3551a14d$var$Qc[c].priority; c++);
        $468ad51c3551a14d$var$Qc.splice(c, 0, a);
        0 === c && $468ad51c3551a14d$var$Vc(a);
    }
};
function $468ad51c3551a14d$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $468ad51c3551a14d$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $468ad51c3551a14d$var$pl() {}
function $468ad51c3551a14d$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $468ad51c3551a14d$var$gl(g);
                f.call(a);
            };
        }
        var g = $468ad51c3551a14d$var$el(b, d, a, 0, null, !1, !1, "", $468ad51c3551a14d$var$pl);
        a._reactRootContainer = g;
        a[$468ad51c3551a14d$var$uf] = g.current;
        $468ad51c3551a14d$var$sf(8 === a.nodeType ? a.parentNode : a);
        $468ad51c3551a14d$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $468ad51c3551a14d$var$gl(k);
            h.call(a);
        };
    }
    var k = $468ad51c3551a14d$var$bl(a, 0, !1, null, null, !1, !1, "", $468ad51c3551a14d$var$pl);
    a._reactRootContainer = k;
    a[$468ad51c3551a14d$var$uf] = k.current;
    $468ad51c3551a14d$var$sf(8 === a.nodeType ? a.parentNode : a);
    $468ad51c3551a14d$var$Rk(function() {
        $468ad51c3551a14d$var$fl(b, k, c, d);
    });
    return k;
}
function $468ad51c3551a14d$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $468ad51c3551a14d$var$gl(g);
                h.call(a);
            };
        }
        $468ad51c3551a14d$var$fl(b, g, a, e);
    } else g = $468ad51c3551a14d$var$ql(c, b, a, e, d);
    return $468ad51c3551a14d$var$gl(g);
}
$468ad51c3551a14d$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $468ad51c3551a14d$var$tc(b.pendingLanes);
                0 !== c && ($468ad51c3551a14d$var$Cc(b, c | 1), $468ad51c3551a14d$var$Dk(b, $468ad51c3551a14d$var$B()), 0 === ($468ad51c3551a14d$var$K & 6) && ($468ad51c3551a14d$var$Gj = $468ad51c3551a14d$var$B() + 500, $468ad51c3551a14d$var$jg()));
            }
            break;
        case 13:
            $468ad51c3551a14d$var$Rk(function() {
                var b = $468ad51c3551a14d$var$ih(a, 1);
                if (null !== b) {
                    var c = $468ad51c3551a14d$var$R();
                    $468ad51c3551a14d$var$gi(b, a, 1, c);
                }
            }), $468ad51c3551a14d$var$il(a, 1);
    }
};
$468ad51c3551a14d$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $468ad51c3551a14d$var$ih(a, 134217728);
        if (null !== b) {
            var c = $468ad51c3551a14d$var$R();
            $468ad51c3551a14d$var$gi(b, a, 134217728, c);
        }
        $468ad51c3551a14d$var$il(a, 134217728);
    }
};
$468ad51c3551a14d$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $468ad51c3551a14d$var$yi(a), c = $468ad51c3551a14d$var$ih(a, b);
        if (null !== c) {
            var d = $468ad51c3551a14d$var$R();
            $468ad51c3551a14d$var$gi(c, a, b, d);
        }
        $468ad51c3551a14d$var$il(a, b);
    }
};
$468ad51c3551a14d$var$Hc = function() {
    return $468ad51c3551a14d$var$C;
};
$468ad51c3551a14d$var$Ic = function(a, b) {
    var c = $468ad51c3551a14d$var$C;
    try {
        return $468ad51c3551a14d$var$C = a, b();
    } finally{
        $468ad51c3551a14d$var$C = c;
    }
};
$468ad51c3551a14d$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $468ad51c3551a14d$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $468ad51c3551a14d$var$Db(d);
                        if (!e) throw Error($468ad51c3551a14d$var$p(90));
                        $468ad51c3551a14d$var$Wa(d);
                        $468ad51c3551a14d$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $468ad51c3551a14d$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $468ad51c3551a14d$var$fb(a, !!c.multiple, b, !1);
    }
};
$468ad51c3551a14d$var$Gb = $468ad51c3551a14d$var$Qk;
$468ad51c3551a14d$var$Hb = $468ad51c3551a14d$var$Rk;
var $468ad51c3551a14d$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $468ad51c3551a14d$var$Cb,
        $468ad51c3551a14d$var$ue,
        $468ad51c3551a14d$var$Db,
        $468ad51c3551a14d$var$Eb,
        $468ad51c3551a14d$var$Fb,
        $468ad51c3551a14d$var$Qk
    ]
}, $468ad51c3551a14d$var$tl = {
    findFiberByHostInstance: $468ad51c3551a14d$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $468ad51c3551a14d$var$ul = {
    bundleType: $468ad51c3551a14d$var$tl.bundleType,
    version: $468ad51c3551a14d$var$tl.version,
    rendererPackageName: $468ad51c3551a14d$var$tl.rendererPackageName,
    rendererConfig: $468ad51c3551a14d$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $468ad51c3551a14d$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $468ad51c3551a14d$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $468ad51c3551a14d$var$tl.findFiberByHostInstance || $468ad51c3551a14d$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $468ad51c3551a14d$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$468ad51c3551a14d$var$vl.isDisabled && $468ad51c3551a14d$var$vl.supportsFiber) try {
        $468ad51c3551a14d$var$kc = $468ad51c3551a14d$var$vl.inject($468ad51c3551a14d$var$ul), $468ad51c3551a14d$var$lc = $468ad51c3551a14d$var$vl;
    } catch (a) {}
}
$468ad51c3551a14d$export$ae55be85d98224ed = $468ad51c3551a14d$var$sl;
$468ad51c3551a14d$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$468ad51c3551a14d$var$nl(b)) throw Error($468ad51c3551a14d$var$p(200));
    return $468ad51c3551a14d$var$cl(a, b, null, c);
};
$468ad51c3551a14d$export$882461b6382ed46c = function(a, b) {
    if (!$468ad51c3551a14d$var$nl(a)) throw Error($468ad51c3551a14d$var$p(299));
    var c = !1, d = "", e = $468ad51c3551a14d$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $468ad51c3551a14d$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$468ad51c3551a14d$var$uf] = b.current;
    $468ad51c3551a14d$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $468ad51c3551a14d$var$ll(b);
};
$468ad51c3551a14d$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($468ad51c3551a14d$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($468ad51c3551a14d$var$p(268, a));
    }
    a = $468ad51c3551a14d$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$468ad51c3551a14d$export$cd75ccfd720a3cd4 = function(a) {
    return $468ad51c3551a14d$var$Rk(a);
};
$468ad51c3551a14d$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$468ad51c3551a14d$var$ol(b)) throw Error($468ad51c3551a14d$var$p(200));
    return $468ad51c3551a14d$var$rl(null, a, b, !0, c);
};
$468ad51c3551a14d$export$757ceba2d55c277e = function(a, b, c) {
    if (!$468ad51c3551a14d$var$nl(a)) throw Error($468ad51c3551a14d$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $468ad51c3551a14d$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $468ad51c3551a14d$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$468ad51c3551a14d$var$uf] = b.current;
    $468ad51c3551a14d$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $468ad51c3551a14d$var$ml(b);
};
$468ad51c3551a14d$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$468ad51c3551a14d$var$ol(b)) throw Error($468ad51c3551a14d$var$p(200));
    return $468ad51c3551a14d$var$rl(null, a, b, !1, c);
};
$468ad51c3551a14d$export$502457920280e6be = function(a) {
    if (!$468ad51c3551a14d$var$ol(a)) throw Error($468ad51c3551a14d$var$p(40));
    return a._reactRootContainer ? ($468ad51c3551a14d$var$Rk(function() {
        $468ad51c3551a14d$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$468ad51c3551a14d$var$uf] = null;
        });
    }), !0) : !1;
};
$468ad51c3551a14d$export$c78a37762a8d58e1 = $468ad51c3551a14d$var$Qk;
$468ad51c3551a14d$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$468ad51c3551a14d$var$ol(c)) throw Error($468ad51c3551a14d$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($468ad51c3551a14d$var$p(38));
    return $468ad51c3551a14d$var$rl(a, b, c, !1, d);
};
$468ad51c3551a14d$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("cV2f0", function(module, exports) {
'use strict';

module.exports = (parcelRequire("jalrZ"));

});
parcelRegister("jalrZ", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $df3f9720d29043ca$export$c4744153514ff05d, (v) => $df3f9720d29043ca$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $df3f9720d29043ca$export$3e506c1ccc9cc1a7, (v) => $df3f9720d29043ca$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $df3f9720d29043ca$export$e26fe2ed2fa76875, (v) => $df3f9720d29043ca$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $df3f9720d29043ca$export$502329bbf4b505b1, (v) => $df3f9720d29043ca$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $df3f9720d29043ca$export$6e3807111c4874c4, (v) => $df3f9720d29043ca$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $df3f9720d29043ca$export$c27134553091fb3a, (v) => $df3f9720d29043ca$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $df3f9720d29043ca$export$33ee1acdc04fd2a2, (v) => $df3f9720d29043ca$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $df3f9720d29043ca$export$b00a404bbd5edef2, (v) => $df3f9720d29043ca$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $df3f9720d29043ca$export$8352ce38b91d0c62, (v) => $df3f9720d29043ca$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $df3f9720d29043ca$export$d66a1c1c77bd778b, (v) => $df3f9720d29043ca$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $df3f9720d29043ca$export$d3dfb8e4810cb555, (v) => $df3f9720d29043ca$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $df3f9720d29043ca$export$839f9183b0465a69, (v) => $df3f9720d29043ca$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $df3f9720d29043ca$export$72fdf0e06517287b, (v) => $df3f9720d29043ca$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $df3f9720d29043ca$export$4b844e58a3e414b4, (v) => $df3f9720d29043ca$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $df3f9720d29043ca$export$816d2913ae6b83b1, (v) => $df3f9720d29043ca$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $df3f9720d29043ca$export$61bcfe829111a1d0, (v) => $df3f9720d29043ca$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $df3f9720d29043ca$export$7ee8c9beb337bc3f, (v) => $df3f9720d29043ca$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $df3f9720d29043ca$export$b5836b71941fa3ed, (v) => $df3f9720d29043ca$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $df3f9720d29043ca$export$cf845f2c119da08a, (v) => $df3f9720d29043ca$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $df3f9720d29043ca$export$c4744153514ff05d;
var $df3f9720d29043ca$export$3e506c1ccc9cc1a7;
var $df3f9720d29043ca$export$e26fe2ed2fa76875;
var $df3f9720d29043ca$export$502329bbf4b505b1;
var $df3f9720d29043ca$export$6e3807111c4874c4;
var $df3f9720d29043ca$export$c27134553091fb3a;
var $df3f9720d29043ca$export$33ee1acdc04fd2a2;
var $df3f9720d29043ca$export$b00a404bbd5edef2;
var $df3f9720d29043ca$export$8352ce38b91d0c62;
var $df3f9720d29043ca$export$d66a1c1c77bd778b;
var $df3f9720d29043ca$export$d3dfb8e4810cb555;
var $df3f9720d29043ca$export$839f9183b0465a69;
var $df3f9720d29043ca$export$72fdf0e06517287b;
var $df3f9720d29043ca$export$4b844e58a3e414b4;
var $df3f9720d29043ca$export$816d2913ae6b83b1;
var $df3f9720d29043ca$export$61bcfe829111a1d0;
var $df3f9720d29043ca$export$7ee8c9beb337bc3f;
var $df3f9720d29043ca$export$b5836b71941fa3ed;
var $df3f9720d29043ca$export$cf845f2c119da08a;
'use strict';
function $df3f9720d29043ca$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $df3f9720d29043ca$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $df3f9720d29043ca$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $df3f9720d29043ca$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $df3f9720d29043ca$var$g(C, c)) n < e && 0 > $df3f9720d29043ca$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $df3f9720d29043ca$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $df3f9720d29043ca$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $df3f9720d29043ca$var$l = performance;
    $df3f9720d29043ca$export$c4744153514ff05d = function() {
        return $df3f9720d29043ca$var$l.now();
    };
} else {
    var $df3f9720d29043ca$var$p = Date, $df3f9720d29043ca$var$q = $df3f9720d29043ca$var$p.now();
    $df3f9720d29043ca$export$c4744153514ff05d = function() {
        return $df3f9720d29043ca$var$p.now() - $df3f9720d29043ca$var$q;
    };
}
var $df3f9720d29043ca$var$r = [], $df3f9720d29043ca$var$t = [], $df3f9720d29043ca$var$u = 1, $df3f9720d29043ca$var$v = null, $df3f9720d29043ca$var$y = 3, $df3f9720d29043ca$var$z = !1, $df3f9720d29043ca$var$A = !1, $df3f9720d29043ca$var$B = !1, $df3f9720d29043ca$var$D = "function" === typeof setTimeout ? setTimeout : null, $df3f9720d29043ca$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $df3f9720d29043ca$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $df3f9720d29043ca$var$G(a) {
    for(var b = $df3f9720d29043ca$var$h($df3f9720d29043ca$var$t); null !== b;){
        if (null === b.callback) $df3f9720d29043ca$var$k($df3f9720d29043ca$var$t);
        else if (b.startTime <= a) $df3f9720d29043ca$var$k($df3f9720d29043ca$var$t), b.sortIndex = b.expirationTime, $df3f9720d29043ca$var$f($df3f9720d29043ca$var$r, b);
        else break;
        b = $df3f9720d29043ca$var$h($df3f9720d29043ca$var$t);
    }
}
function $df3f9720d29043ca$var$H(a) {
    $df3f9720d29043ca$var$B = !1;
    $df3f9720d29043ca$var$G(a);
    if (!$df3f9720d29043ca$var$A) {
        if (null !== $df3f9720d29043ca$var$h($df3f9720d29043ca$var$r)) $df3f9720d29043ca$var$A = !0, $df3f9720d29043ca$var$I($df3f9720d29043ca$var$J);
        else {
            var b = $df3f9720d29043ca$var$h($df3f9720d29043ca$var$t);
            null !== b && $df3f9720d29043ca$var$K($df3f9720d29043ca$var$H, b.startTime - a);
        }
    }
}
function $df3f9720d29043ca$var$J(a, b) {
    $df3f9720d29043ca$var$A = !1;
    $df3f9720d29043ca$var$B && ($df3f9720d29043ca$var$B = !1, $df3f9720d29043ca$var$E($df3f9720d29043ca$var$L), $df3f9720d29043ca$var$L = -1);
    $df3f9720d29043ca$var$z = !0;
    var c = $df3f9720d29043ca$var$y;
    try {
        $df3f9720d29043ca$var$G(b);
        for($df3f9720d29043ca$var$v = $df3f9720d29043ca$var$h($df3f9720d29043ca$var$r); null !== $df3f9720d29043ca$var$v && (!($df3f9720d29043ca$var$v.expirationTime > b) || a && !$df3f9720d29043ca$var$M());){
            var d = $df3f9720d29043ca$var$v.callback;
            if ("function" === typeof d) {
                $df3f9720d29043ca$var$v.callback = null;
                $df3f9720d29043ca$var$y = $df3f9720d29043ca$var$v.priorityLevel;
                var e = d($df3f9720d29043ca$var$v.expirationTime <= b);
                b = $df3f9720d29043ca$export$c4744153514ff05d();
                "function" === typeof e ? $df3f9720d29043ca$var$v.callback = e : $df3f9720d29043ca$var$v === $df3f9720d29043ca$var$h($df3f9720d29043ca$var$r) && $df3f9720d29043ca$var$k($df3f9720d29043ca$var$r);
                $df3f9720d29043ca$var$G(b);
            } else $df3f9720d29043ca$var$k($df3f9720d29043ca$var$r);
            $df3f9720d29043ca$var$v = $df3f9720d29043ca$var$h($df3f9720d29043ca$var$r);
        }
        if (null !== $df3f9720d29043ca$var$v) var w = !0;
        else {
            var m = $df3f9720d29043ca$var$h($df3f9720d29043ca$var$t);
            null !== m && $df3f9720d29043ca$var$K($df3f9720d29043ca$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $df3f9720d29043ca$var$v = null, $df3f9720d29043ca$var$y = c, $df3f9720d29043ca$var$z = !1;
    }
}
var $df3f9720d29043ca$var$N = !1, $df3f9720d29043ca$var$O = null, $df3f9720d29043ca$var$L = -1, $df3f9720d29043ca$var$P = 5, $df3f9720d29043ca$var$Q = -1;
function $df3f9720d29043ca$var$M() {
    return $df3f9720d29043ca$export$c4744153514ff05d() - $df3f9720d29043ca$var$Q < $df3f9720d29043ca$var$P ? !1 : !0;
}
function $df3f9720d29043ca$var$R() {
    if (null !== $df3f9720d29043ca$var$O) {
        var a = $df3f9720d29043ca$export$c4744153514ff05d();
        $df3f9720d29043ca$var$Q = a;
        var b = !0;
        try {
            b = $df3f9720d29043ca$var$O(!0, a);
        } finally{
            b ? $df3f9720d29043ca$var$S() : ($df3f9720d29043ca$var$N = !1, $df3f9720d29043ca$var$O = null);
        }
    } else $df3f9720d29043ca$var$N = !1;
}
var $df3f9720d29043ca$var$S;
if ("function" === typeof $df3f9720d29043ca$var$F) $df3f9720d29043ca$var$S = function() {
    $df3f9720d29043ca$var$F($df3f9720d29043ca$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $df3f9720d29043ca$var$T = new MessageChannel, $df3f9720d29043ca$var$U = $df3f9720d29043ca$var$T.port2;
    $df3f9720d29043ca$var$T.port1.onmessage = $df3f9720d29043ca$var$R;
    $df3f9720d29043ca$var$S = function() {
        $df3f9720d29043ca$var$U.postMessage(null);
    };
} else $df3f9720d29043ca$var$S = function() {
    $df3f9720d29043ca$var$D($df3f9720d29043ca$var$R, 0);
};
function $df3f9720d29043ca$var$I(a) {
    $df3f9720d29043ca$var$O = a;
    $df3f9720d29043ca$var$N || ($df3f9720d29043ca$var$N = !0, $df3f9720d29043ca$var$S());
}
function $df3f9720d29043ca$var$K(a, b) {
    $df3f9720d29043ca$var$L = $df3f9720d29043ca$var$D(function() {
        a($df3f9720d29043ca$export$c4744153514ff05d());
    }, b);
}
$df3f9720d29043ca$export$3e506c1ccc9cc1a7 = 5;
$df3f9720d29043ca$export$e26fe2ed2fa76875 = 1;
$df3f9720d29043ca$export$502329bbf4b505b1 = 4;
$df3f9720d29043ca$export$6e3807111c4874c4 = 3;
$df3f9720d29043ca$export$c27134553091fb3a = null;
$df3f9720d29043ca$export$33ee1acdc04fd2a2 = 2;
$df3f9720d29043ca$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$df3f9720d29043ca$export$8352ce38b91d0c62 = function() {
    $df3f9720d29043ca$var$A || $df3f9720d29043ca$var$z || ($df3f9720d29043ca$var$A = !0, $df3f9720d29043ca$var$I($df3f9720d29043ca$var$J));
};
$df3f9720d29043ca$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $df3f9720d29043ca$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$df3f9720d29043ca$export$d3dfb8e4810cb555 = function() {
    return $df3f9720d29043ca$var$y;
};
$df3f9720d29043ca$export$839f9183b0465a69 = function() {
    return $df3f9720d29043ca$var$h($df3f9720d29043ca$var$r);
};
$df3f9720d29043ca$export$72fdf0e06517287b = function(a) {
    switch($df3f9720d29043ca$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $df3f9720d29043ca$var$y;
    }
    var c = $df3f9720d29043ca$var$y;
    $df3f9720d29043ca$var$y = b;
    try {
        return a();
    } finally{
        $df3f9720d29043ca$var$y = c;
    }
};
$df3f9720d29043ca$export$4b844e58a3e414b4 = function() {};
$df3f9720d29043ca$export$816d2913ae6b83b1 = function() {};
$df3f9720d29043ca$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $df3f9720d29043ca$var$y;
    $df3f9720d29043ca$var$y = a;
    try {
        return b();
    } finally{
        $df3f9720d29043ca$var$y = c;
    }
};
$df3f9720d29043ca$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $df3f9720d29043ca$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $df3f9720d29043ca$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $df3f9720d29043ca$var$f($df3f9720d29043ca$var$t, a), null === $df3f9720d29043ca$var$h($df3f9720d29043ca$var$r) && a === $df3f9720d29043ca$var$h($df3f9720d29043ca$var$t) && ($df3f9720d29043ca$var$B ? ($df3f9720d29043ca$var$E($df3f9720d29043ca$var$L), $df3f9720d29043ca$var$L = -1) : $df3f9720d29043ca$var$B = !0, $df3f9720d29043ca$var$K($df3f9720d29043ca$var$H, c - d))) : (a.sortIndex = e, $df3f9720d29043ca$var$f($df3f9720d29043ca$var$r, a), $df3f9720d29043ca$var$A || $df3f9720d29043ca$var$z || ($df3f9720d29043ca$var$A = !0, $df3f9720d29043ca$var$I($df3f9720d29043ca$var$J)));
    return a;
};
$df3f9720d29043ca$export$b5836b71941fa3ed = $df3f9720d29043ca$var$M;
$df3f9720d29043ca$export$cf845f2c119da08a = function(a) {
    var b = $df3f9720d29043ca$var$y;
    return function() {
        var c = $df3f9720d29043ca$var$y;
        $df3f9720d29043ca$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $df3f9720d29043ca$var$y = c;
        }
    };
};

});



parcelRegister("cgjtm", function(module, exports) {

$parcel$export(module.exports, "init", () => init);
$parcel$export(module.exports, "forward", () => forward);
$parcel$export(module.exports, "inverse", () => inverse);
$parcel$export(module.exports, "names", () => names);
$parcel$export(module.exports, "default", () => $8ed61582026458ea$export$2e2bcd8739ae039);
// Heavily based on this etmerc projection implementation
// https://github.com/mbloch/mapshaper-proj/blob/master/src/projections/etmerc.js

var $2frHl = parcelRequire("2frHl");

var $02bCZ = parcelRequire("02bCZ");

var $3ZcmO = parcelRequire("3ZcmO");

var $cVuFE = parcelRequire("cVuFE");

var $eE5dd = parcelRequire("eE5dd");

var $7tD3o = parcelRequire("7tD3o");

var $3Pzy7 = parcelRequire("3Pzy7");

var $eRFTg = parcelRequire("eRFTg");
function init() {
    if (!this.approx && (isNaN(this.es) || this.es <= 0)) throw new Error('Incorrect elliptical usage. Try using the +approx option in the proj string, or PROJECTION["Fast_Transverse_Mercator"] in the WKT.');
    if (this.approx) {
        // When '+approx' is set, use tmerc instead
        (0, $2frHl.default).init.apply(this);
        this.forward = (0, $2frHl.default).forward;
        this.inverse = (0, $2frHl.default).inverse;
    }
    this.x0 = this.x0 !== undefined ? this.x0 : 0;
    this.y0 = this.y0 !== undefined ? this.y0 : 0;
    this.long0 = this.long0 !== undefined ? this.long0 : 0;
    this.lat0 = this.lat0 !== undefined ? this.lat0 : 0;
    this.cgb = [];
    this.cbg = [];
    this.utg = [];
    this.gtu = [];
    var f = this.es / (1 + Math.sqrt(1 - this.es));
    var n = f / (2 - f);
    var np = n;
    this.cgb[0] = n * (2 + n * (-2 / 3 + n * (-2 + n * (116 / 45 + n * (26 / 45 + n * (-2854 / 675))))));
    this.cbg[0] = n * (-2 + n * (2 / 3 + n * (4 / 3 + n * (-82 / 45 + n * (32 / 45 + n * (4642 / 4725))))));
    np = np * n;
    this.cgb[1] = np * (7 / 3 + n * (-1.6 + n * (-227 / 45 + n * (2704 / 315 + n * (2323 / 945)))));
    this.cbg[1] = np * (5 / 3 + n * (-16 / 15 + n * (-13 / 9 + n * (904 / 315 + n * (-1522 / 945)))));
    np = np * n;
    this.cgb[2] = np * (56 / 15 + n * (-136 / 35 + n * (-1262 / 105 + n * (73814 / 2835))));
    this.cbg[2] = np * (-26 / 15 + n * (34 / 21 + n * (1.6 + n * (-12686 / 2835))));
    np = np * n;
    this.cgb[3] = np * (4279 / 630 + n * (-332 / 35 + n * (-399572 / 14175)));
    this.cbg[3] = np * (1237 / 630 + n * (-2.4 + n * (-24832 / 14175)));
    np = np * n;
    this.cgb[4] = np * (4174 / 315 + n * (-144838 / 6237));
    this.cbg[4] = np * (-734 / 315 + n * (109598 / 31185));
    np = np * n;
    this.cgb[5] = np * (601676 / 22275);
    this.cbg[5] = np * (444337 / 155925);
    np = Math.pow(n, 2);
    this.Qn = this.k0 / (1 + n) * (1 + np * (1 / 4 + np * (1 / 64 + np / 256)));
    this.utg[0] = n * (-0.5 + n * (2 / 3 + n * (-37 / 96 + n * (1 / 360 + n * (81 / 512 + n * (-96199 / 604800))))));
    this.gtu[0] = n * (0.5 + n * (-2 / 3 + n * (5 / 16 + n * (41 / 180 + n * (-127 / 288 + n * (7891 / 37800))))));
    this.utg[1] = np * (-1 / 48 + n * (-1 / 15 + n * (437 / 1440 + n * (-46 / 105 + n * (1118711 / 3870720)))));
    this.gtu[1] = np * (13 / 48 + n * (-0.6 + n * (557 / 1440 + n * (281 / 630 + n * (-1983433 / 1935360)))));
    np = np * n;
    this.utg[2] = np * (-17 / 480 + n * (37 / 840 + n * (209 / 4480 + n * (-5569 / 90720))));
    this.gtu[2] = np * (61 / 240 + n * (-103 / 140 + n * (15061 / 26880 + n * (167603 / 181440))));
    np = np * n;
    this.utg[3] = np * (-4397 / 161280 + n * (11 / 504 + n * (830251 / 7257600)));
    this.gtu[3] = np * (49561 / 161280 + n * (-179 / 168 + n * (6601661 / 7257600)));
    np = np * n;
    this.utg[4] = np * (-4583 / 161280 + n * (108847 / 3991680));
    this.gtu[4] = np * (34729 / 80640 + n * (-3418889 / 1995840));
    np = np * n;
    this.utg[5] = np * (-20648693 / 638668800);
    this.gtu[5] = np * 0.6650675310896665;
    var Z = (0, $eE5dd.default)(this.cbg, this.lat0);
    this.Zb = -this.Qn * (Z + (0, $7tD3o.default)(this.gtu, 2 * Z));
}
function forward(p) {
    var Ce = (0, $eRFTg.default)(p.x - this.long0, this.over);
    var Cn = p.y;
    Cn = (0, $eE5dd.default)(this.cbg, Cn);
    var sin_Cn = Math.sin(Cn);
    var cos_Cn = Math.cos(Cn);
    var sin_Ce = Math.sin(Ce);
    var cos_Ce = Math.cos(Ce);
    Cn = Math.atan2(sin_Cn, cos_Ce * cos_Cn);
    Ce = Math.atan2(sin_Ce * cos_Cn, (0, $3ZcmO.default)(sin_Cn, cos_Cn * cos_Ce));
    Ce = (0, $cVuFE.default)(Math.tan(Ce));
    var tmp = (0, $3Pzy7.default)(this.gtu, 2 * Cn, 2 * Ce);
    Cn = Cn + tmp[0];
    Ce = Ce + tmp[1];
    var x;
    var y;
    if (Math.abs(Ce) <= 2.623395162778) {
        x = this.a * (this.Qn * Ce) + this.x0;
        y = this.a * (this.Qn * Cn + this.Zb) + this.y0;
    } else {
        x = Infinity;
        y = Infinity;
    }
    p.x = x;
    p.y = y;
    return p;
}
function inverse(p) {
    var Ce = (p.x - this.x0) * (1 / this.a);
    var Cn = (p.y - this.y0) * (1 / this.a);
    Cn = (Cn - this.Zb) / this.Qn;
    Ce = Ce / this.Qn;
    var lon;
    var lat;
    if (Math.abs(Ce) <= 2.623395162778) {
        var tmp = (0, $3Pzy7.default)(this.utg, 2 * Cn, 2 * Ce);
        Cn = Cn + tmp[0];
        Ce = Ce + tmp[1];
        Ce = Math.atan((0, $02bCZ.default)(Ce));
        var sin_Cn = Math.sin(Cn);
        var cos_Cn = Math.cos(Cn);
        var sin_Ce = Math.sin(Ce);
        var cos_Ce = Math.cos(Ce);
        Cn = Math.atan2(sin_Cn * cos_Ce, (0, $3ZcmO.default)(sin_Ce, cos_Ce * cos_Cn));
        Ce = Math.atan2(sin_Ce, cos_Ce * cos_Cn);
        lon = (0, $eRFTg.default)(Ce + this.long0, this.over);
        lat = (0, $eE5dd.default)(this.cgb, Cn);
    } else {
        lon = Infinity;
        lat = Infinity;
    }
    p.x = lon;
    p.y = lat;
    return p;
}
var names = [
    'Extended_Transverse_Mercator',
    'Extended Transverse Mercator',
    'etmerc',
    'Transverse_Mercator',
    'Transverse Mercator',
    'Gauss Kruger',
    'Gauss_Kruger',
    'tmerc'
];
var $8ed61582026458ea$export$2e2bcd8739ae039 = {
    init: init,
    forward: forward,
    inverse: inverse,
    names: names
};

});
parcelRegister("2frHl", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a3277c67bd1e922$export$2e2bcd8739ae039);
// Heavily based on this tmerc projection implementation
// https://github.com/mbloch/mapshaper-proj/blob/master/src/projections/tmerc.js

var $1t7xy = parcelRequire("1t7xy");

var $6D29U = parcelRequire("6D29U");

var $aItGy = parcelRequire("aItGy");

var $eRFTg = parcelRequire("eRFTg");

var $jDCGO = parcelRequire("jDCGO");

var $VoZg4 = parcelRequire("VoZg4");
function $1a3277c67bd1e922$export$2cd8252107eb640b() {
    this.x0 = this.x0 !== undefined ? this.x0 : 0;
    this.y0 = this.y0 !== undefined ? this.y0 : 0;
    this.long0 = this.long0 !== undefined ? this.long0 : 0;
    this.lat0 = this.lat0 !== undefined ? this.lat0 : 0;
    if (this.es) {
        this.en = (0, $1t7xy.default)(this.es);
        this.ml0 = (0, $6D29U.default)(this.lat0, Math.sin(this.lat0), Math.cos(this.lat0), this.en);
    }
}
function $1a3277c67bd1e922$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    var delta_lon = (0, $eRFTg.default)(lon - this.long0, this.over);
    var con;
    var x, y;
    var sin_phi = Math.sin(lat);
    var cos_phi = Math.cos(lat);
    if (!this.es) {
        var b = cos_phi * Math.sin(delta_lon);
        if (Math.abs(Math.abs(b) - 1) < (0, $jDCGO.EPSLN)) return 93;
        else {
            x = 0.5 * this.a * this.k0 * Math.log((1 + b) / (1 - b)) + this.x0;
            y = cos_phi * Math.cos(delta_lon) / Math.sqrt(1 - Math.pow(b, 2));
            b = Math.abs(y);
            if (b >= 1) {
                if (b - 1 > (0, $jDCGO.EPSLN)) return 93;
                else y = 0;
            } else y = Math.acos(y);
            if (lat < 0) y = -y;
            y = this.a * this.k0 * (y - this.lat0) + this.y0;
        }
    } else {
        var al = cos_phi * delta_lon;
        var als = Math.pow(al, 2);
        var c = this.ep2 * Math.pow(cos_phi, 2);
        var cs = Math.pow(c, 2);
        var tq = Math.abs(cos_phi) > (0, $jDCGO.EPSLN) ? Math.tan(lat) : 0;
        var t = Math.pow(tq, 2);
        var ts = Math.pow(t, 2);
        con = 1 - this.es * Math.pow(sin_phi, 2);
        al = al / Math.sqrt(con);
        var ml = (0, $6D29U.default)(lat, sin_phi, cos_phi, this.en);
        x = this.a * (this.k0 * al * (1 + als / 6 * (1 - t + c + als / 20 * (5 - 18 * t + ts + 14 * c - 58 * t * c + als / 42 * (61 + 179 * ts - ts * t - 479 * t))))) + this.x0;
        y = this.a * (this.k0 * (ml - this.ml0 + sin_phi * delta_lon * al / 2 * (1 + als / 12 * (5 - t + 9 * c + 4 * cs + als / 30 * (61 + ts - 58 * t + 270 * c - 330 * t * c + als / 56 * (1385 + 543 * ts - ts * t - 3111 * t)))))) + this.y0;
    }
    p.x = x;
    p.y = y;
    return p;
}
function $1a3277c67bd1e922$export$70ae2c07e401031b(p) {
    var con, phi;
    var lat, lon;
    var x = (p.x - this.x0) * (1 / this.a);
    var y = (p.y - this.y0) * (1 / this.a);
    if (!this.es) {
        var f = Math.exp(x / this.k0);
        var g = 0.5 * (f - 1 / f);
        var temp = this.lat0 + y / this.k0;
        var h = Math.cos(temp);
        con = Math.sqrt((1 - Math.pow(h, 2)) / (1 + Math.pow(g, 2)));
        lat = Math.asin(con);
        if (y < 0) lat = -lat;
        if (g === 0 && h === 0) lon = 0;
        else lon = (0, $eRFTg.default)(Math.atan2(g, h) + this.long0, this.over);
    } else {
        con = this.ml0 + y / this.k0;
        phi = (0, $aItGy.default)(con, this.es, this.en);
        if (Math.abs(phi) < (0, $jDCGO.HALF_PI)) {
            var sin_phi = Math.sin(phi);
            var cos_phi = Math.cos(phi);
            var tan_phi = Math.abs(cos_phi) > (0, $jDCGO.EPSLN) ? Math.tan(phi) : 0;
            var c = this.ep2 * Math.pow(cos_phi, 2);
            var cs = Math.pow(c, 2);
            var t = Math.pow(tan_phi, 2);
            var ts = Math.pow(t, 2);
            con = 1 - this.es * Math.pow(sin_phi, 2);
            var d = x * Math.sqrt(con) / this.k0;
            var ds = Math.pow(d, 2);
            con = con * tan_phi;
            lat = phi - con * ds / (1 - this.es) * 0.5 * (1 - ds / 12 * (5 + 3 * t - 9 * c * t + c - 4 * cs - ds / 30 * (61 + 90 * t - 252 * c * t + 45 * ts + 46 * c - ds / 56 * (1385 + 3633 * t + 4095 * ts + 1574 * ts * t))));
            lon = (0, $eRFTg.default)(this.long0 + d * (1 - ds / 6 * (1 + 2 * t + c - ds / 20 * (5 + 28 * t + 24 * ts + 8 * c * t + 6 * c - ds / 42 * (61 + 662 * t + 1320 * ts + 720 * ts * t)))) / cos_phi, this.over);
        } else {
            lat = (0, $jDCGO.HALF_PI) * (0, $VoZg4.default)(y);
            lon = 0;
        }
    }
    p.x = lon;
    p.y = lat;
    return p;
}
var $1a3277c67bd1e922$export$e4b2ac9215619f8d = [
    'Fast_Transverse_Mercator',
    'Fast Transverse Mercator'
];
var $1a3277c67bd1e922$export$2e2bcd8739ae039 = {
    init: $1a3277c67bd1e922$export$2cd8252107eb640b,
    forward: $1a3277c67bd1e922$export$174bb771924e7eb1,
    inverse: $1a3277c67bd1e922$export$70ae2c07e401031b,
    names: $1a3277c67bd1e922$export$e4b2ac9215619f8d
};

});
parcelRegister("1t7xy", function(module, exports) {

$parcel$export(module.exports, "default", () => $111e5935c2a2fab1$export$2e2bcd8739ae039);
var $111e5935c2a2fab1$var$C00 = 1;
var $111e5935c2a2fab1$var$C02 = 0.25;
var $111e5935c2a2fab1$var$C04 = 0.046875;
var $111e5935c2a2fab1$var$C06 = 0.01953125;
var $111e5935c2a2fab1$var$C08 = 0.01068115234375;
var $111e5935c2a2fab1$var$C22 = 0.75;
var $111e5935c2a2fab1$var$C44 = 0.46875;
var $111e5935c2a2fab1$var$C46 = 0.01302083333333333333;
var $111e5935c2a2fab1$var$C48 = 0.00712076822916666666;
var $111e5935c2a2fab1$var$C66 = 0.36458333333333333333;
var $111e5935c2a2fab1$var$C68 = 0.00569661458333333333;
var $111e5935c2a2fab1$var$C88 = 0.3076171875;
function $111e5935c2a2fab1$export$2e2bcd8739ae039(es) {
    var en = [];
    en[0] = $111e5935c2a2fab1$var$C00 - es * ($111e5935c2a2fab1$var$C02 + es * ($111e5935c2a2fab1$var$C04 + es * ($111e5935c2a2fab1$var$C06 + es * $111e5935c2a2fab1$var$C08)));
    en[1] = es * ($111e5935c2a2fab1$var$C22 - es * ($111e5935c2a2fab1$var$C04 + es * ($111e5935c2a2fab1$var$C06 + es * $111e5935c2a2fab1$var$C08)));
    var t = es * es;
    en[2] = t * ($111e5935c2a2fab1$var$C44 - es * ($111e5935c2a2fab1$var$C46 + es * $111e5935c2a2fab1$var$C48));
    t *= es;
    en[3] = t * ($111e5935c2a2fab1$var$C66 - es * $111e5935c2a2fab1$var$C68);
    en[4] = t * es * $111e5935c2a2fab1$var$C88;
    return en;
}

});

parcelRegister("6D29U", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d380f467af0942a$export$2e2bcd8739ae039);
function $4d380f467af0942a$export$2e2bcd8739ae039(phi, sphi, cphi, en) {
    cphi *= sphi;
    sphi *= sphi;
    return en[0] * phi - cphi * (en[1] + sphi * (en[2] + sphi * (en[3] + sphi * en[4])));
}

});

parcelRegister("aItGy", function(module, exports) {

$parcel$export(module.exports, "default", () => $7cd50a52f9ca4928$export$2e2bcd8739ae039);

var $6D29U = parcelRequire("6D29U");

var $jDCGO = parcelRequire("jDCGO");
var $7cd50a52f9ca4928$var$MAX_ITER = 20;
function $7cd50a52f9ca4928$export$2e2bcd8739ae039(arg, es, en) {
    var k = 1 / (1 - es);
    var phi = arg;
    for(var i = $7cd50a52f9ca4928$var$MAX_ITER; i; --i){
        var s = Math.sin(phi);
        var t = 1 - es * s * s;
        // t = this.pj_mlfn(phi, s, Math.cos(phi), en) - arg;
        // phi -= t * (t * Math.sqrt(t)) * k;
        t = ((0, $6D29U.default)(phi, s, Math.cos(phi), en) - arg) * (t * Math.sqrt(t)) * k;
        phi -= t;
        if (Math.abs(t) < (0, $jDCGO.EPSLN)) return phi;
    }
    // ..reportError("cass:pj_inv_mlfn: Convergence error");
    return phi;
}

});
parcelRegister("jDCGO", function(module, exports) {

$parcel$export(module.exports, "PJD_3PARAM", () => $e4bfabc9df9221e5$export$3a3ed3e590e8ec27);
$parcel$export(module.exports, "PJD_7PARAM", () => $e4bfabc9df9221e5$export$8cab19b7f383a7a7);
$parcel$export(module.exports, "PJD_GRIDSHIFT", () => $e4bfabc9df9221e5$export$83d26ae02793dd10);
$parcel$export(module.exports, "PJD_WGS84", () => $e4bfabc9df9221e5$export$ab5bf8c731b6bbbb);
$parcel$export(module.exports, "PJD_NODATUM", () => $e4bfabc9df9221e5$export$8df4c7729d8ed58d);
$parcel$export(module.exports, "SRS_WGS84_SEMIMAJOR", () => $e4bfabc9df9221e5$export$d612c03b7390d945);
$parcel$export(module.exports, "SRS_WGS84_SEMIMINOR", () => $e4bfabc9df9221e5$export$59af086d7527ec46);
$parcel$export(module.exports, "SRS_WGS84_ESQUARED", () => $e4bfabc9df9221e5$export$9b798f9d78b99fc0);
$parcel$export(module.exports, "SEC_TO_RAD", () => $e4bfabc9df9221e5$export$e0b9011552f3b2f7);
$parcel$export(module.exports, "HALF_PI", () => $e4bfabc9df9221e5$export$f504979d7e0a75c7);
$parcel$export(module.exports, "SIXTH", () => $e4bfabc9df9221e5$export$d7977f56a0faa834);
$parcel$export(module.exports, "RA4", () => $e4bfabc9df9221e5$export$9e703428410a9c7b);
$parcel$export(module.exports, "RA6", () => $e4bfabc9df9221e5$export$bb54dde5565ed6e3);
$parcel$export(module.exports, "EPSLN", () => $e4bfabc9df9221e5$export$2aa89dbfb8b504bb);
$parcel$export(module.exports, "D2R", () => $e4bfabc9df9221e5$export$ed6012a68c0f4a70);
$parcel$export(module.exports, "R2D", () => $e4bfabc9df9221e5$export$456934b8be7498c3);
$parcel$export(module.exports, "FORTPI", () => $e4bfabc9df9221e5$export$10cb69dd603c11b0);
$parcel$export(module.exports, "TWO_PI", () => $e4bfabc9df9221e5$export$6eec49b1a6289c4e);
$parcel$export(module.exports, "SPI", () => $e4bfabc9df9221e5$export$703a92fc6506ffb9);
var $e4bfabc9df9221e5$export$3a3ed3e590e8ec27 = 1;
var $e4bfabc9df9221e5$export$8cab19b7f383a7a7 = 2;
var $e4bfabc9df9221e5$export$83d26ae02793dd10 = 3;
var $e4bfabc9df9221e5$export$ab5bf8c731b6bbbb = 4; // WGS84 or equivalent
var $e4bfabc9df9221e5$export$8df4c7729d8ed58d = 5; // WGS84 or equivalent
var $e4bfabc9df9221e5$export$d612c03b7390d945 = 6378137.0; // only used in grid shift transforms
var $e4bfabc9df9221e5$export$59af086d7527ec46 = 6356752.314; // only used in grid shift transforms
var $e4bfabc9df9221e5$export$9b798f9d78b99fc0 = 0.0066943799901413165; // only used in grid shift transforms
var $e4bfabc9df9221e5$export$e0b9011552f3b2f7 = 4.84813681109535993589914102357e-6;
var $e4bfabc9df9221e5$export$f504979d7e0a75c7 = Math.PI / 2;
var $e4bfabc9df9221e5$export$d7977f56a0faa834 = 0.1666666666666666667;
var $e4bfabc9df9221e5$export$9e703428410a9c7b = 0.04722222222222222222;
var $e4bfabc9df9221e5$export$bb54dde5565ed6e3 = 0.02215608465608465608;
var $e4bfabc9df9221e5$export$2aa89dbfb8b504bb = 1.0e-10;
var $e4bfabc9df9221e5$export$ed6012a68c0f4a70 = 0.01745329251994329577;
var $e4bfabc9df9221e5$export$456934b8be7498c3 = 57.29577951308232088;
var $e4bfabc9df9221e5$export$10cb69dd603c11b0 = Math.PI / 4;
var $e4bfabc9df9221e5$export$6eec49b1a6289c4e = Math.PI * 2;
var $e4bfabc9df9221e5$export$703a92fc6506ffb9 = 3.14159265359;

});


parcelRegister("eRFTg", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad2682800b46e75b$export$2e2bcd8739ae039);

var $jDCGO = parcelRequire("jDCGO");

var $VoZg4 = parcelRequire("VoZg4");
function $ad2682800b46e75b$export$2e2bcd8739ae039(x, skipAdjust) {
    if (skipAdjust) return x;
    return Math.abs(x) <= (0, $jDCGO.SPI) ? x : x - (0, $VoZg4.default)(x) * (0, $jDCGO.TWO_PI);
}

});
parcelRegister("VoZg4", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ac8b4e407f43972$export$2e2bcd8739ae039);
function $0ac8b4e407f43972$export$2e2bcd8739ae039(x) {
    return x < 0 ? -1 : 1;
}

});



parcelRegister("02bCZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $00693510c7ae3cb4$export$2e2bcd8739ae039);
function $00693510c7ae3cb4$export$2e2bcd8739ae039(x) {
    var r = Math.exp(x);
    r = (r - 1 / r) / 2;
    return r;
}

});

parcelRegister("3ZcmO", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e70a96bb7763766$export$2e2bcd8739ae039);
function $2e70a96bb7763766$export$2e2bcd8739ae039(x, y) {
    x = Math.abs(x);
    y = Math.abs(y);
    var a = Math.max(x, y);
    var b = Math.min(x, y) / (a ? a : 1);
    return a * Math.sqrt(1 + Math.pow(b, 2));
}

});

parcelRegister("cVuFE", function(module, exports) {

$parcel$export(module.exports, "default", () => $9692997e0eaf3e70$export$2e2bcd8739ae039);

var $3ZcmO = parcelRequire("3ZcmO");

var $gSA3H = parcelRequire("gSA3H");
function $9692997e0eaf3e70$export$2e2bcd8739ae039(x) {
    var y = Math.abs(x);
    y = (0, $gSA3H.default)(y * (1 + y / ((0, $3ZcmO.default)(1, y) + 1)));
    return x < 0 ? -y : y;
}

});
parcelRegister("gSA3H", function(module, exports) {

$parcel$export(module.exports, "default", () => $c49da8ffda433174$export$2e2bcd8739ae039);
function $c49da8ffda433174$export$2e2bcd8739ae039(x) {
    var y = 1 + x;
    var z = y - 1;
    return z === 0 ? x : x * Math.log(y) / z;
}

});


parcelRegister("eE5dd", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa98d81f541aef07$export$2e2bcd8739ae039);
function $aa98d81f541aef07$export$2e2bcd8739ae039(pp, B) {
    var cos_2B = 2 * Math.cos(2 * B);
    var i = pp.length - 1;
    var h1 = pp[i];
    var h2 = 0;
    var h;
    while(--i >= 0){
        h = -h2 + cos_2B * h1 + pp[i];
        h2 = h1;
        h1 = h;
    }
    return B + h * Math.sin(2 * B);
}

});

parcelRegister("7tD3o", function(module, exports) {

$parcel$export(module.exports, "default", () => $57198917e281dd08$export$2e2bcd8739ae039);
function $57198917e281dd08$export$2e2bcd8739ae039(pp, arg_r) {
    var r = 2 * Math.cos(arg_r);
    var i = pp.length - 1;
    var hr1 = pp[i];
    var hr2 = 0;
    var hr;
    while(--i >= 0){
        hr = -hr2 + r * hr1 + pp[i];
        hr2 = hr1;
        hr1 = hr;
    }
    return Math.sin(arg_r) * hr;
}

});

parcelRegister("3Pzy7", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ca1b5dd66910d75$export$2e2bcd8739ae039);

var $02bCZ = parcelRequire("02bCZ");

var $c53CN = parcelRequire("c53CN");
function $2ca1b5dd66910d75$export$2e2bcd8739ae039(pp, arg_r, arg_i) {
    var sin_arg_r = Math.sin(arg_r);
    var cos_arg_r = Math.cos(arg_r);
    var sinh_arg_i = (0, $02bCZ.default)(arg_i);
    var cosh_arg_i = (0, $c53CN.default)(arg_i);
    var r = 2 * cos_arg_r * cosh_arg_i;
    var i = -2 * sin_arg_r * sinh_arg_i;
    var j = pp.length - 1;
    var hr = pp[j];
    var hi1 = 0;
    var hr1 = 0;
    var hi = 0;
    var hr2;
    var hi2;
    while(--j >= 0){
        hr2 = hr1;
        hi2 = hi1;
        hr1 = hr;
        hi1 = hi;
        hr = -hr2 + r * hr1 - i * hi1 + pp[j];
        hi = -hi2 + i * hr1 + r * hi1;
    }
    r = sin_arg_r * cosh_arg_i;
    i = cos_arg_r * sinh_arg_i;
    return [
        r * hr - i * hi,
        r * hi + i * hr
    ];
}

});
parcelRegister("c53CN", function(module, exports) {

$parcel$export(module.exports, "default", () => $8cb8c37ca2a7c58e$export$2e2bcd8739ae039);
function $8cb8c37ca2a7c58e$export$2e2bcd8739ae039(x) {
    var r = Math.exp(x);
    r = (r + 1 / r) / 2;
    return r;
}

});



parcelRegister("l2RN6", function(module, exports) {

$parcel$export(module.exports, "S_POLE", () => S_POLE);
$parcel$export(module.exports, "N_POLE", () => N_POLE);
$parcel$export(module.exports, "EQUIT", () => EQUIT);
$parcel$export(module.exports, "OBLIQ", () => OBLIQ);
$parcel$export(module.exports, "init", () => init);
$parcel$export(module.exports, "forward", () => forward);
$parcel$export(module.exports, "inverse", () => inverse);
$parcel$export(module.exports, "names", () => names);
$parcel$export(module.exports, "default", () => $f523829ed0822124$export$2e2bcd8739ae039);

var $jDCGO = parcelRequire("jDCGO");

var $4GxSW = parcelRequire("4GxSW");

var $eRFTg = parcelRequire("eRFTg");
var S_POLE = 1;
var N_POLE = 2;
var EQUIT = 3;
var OBLIQ = 4;
function init() {
    var t = Math.abs(this.lat0);
    if (Math.abs(t - (0, $jDCGO.HALF_PI)) < (0, $jDCGO.EPSLN)) this.mode = this.lat0 < 0 ? S_POLE : N_POLE;
    else if (Math.abs(t) < (0, $jDCGO.EPSLN)) this.mode = EQUIT;
    else this.mode = OBLIQ;
    if (this.es > 0) {
        var sinphi;
        this.qp = (0, $4GxSW.default)(this.e, 1);
        this.mmf = 0.5 / (1 - this.es);
        this.apa = authset(this.es);
        switch(this.mode){
            case N_POLE:
                this.dd = 1;
                break;
            case S_POLE:
                this.dd = 1;
                break;
            case EQUIT:
                this.rq = Math.sqrt(0.5 * this.qp);
                this.dd = 1 / this.rq;
                this.xmf = 1;
                this.ymf = 0.5 * this.qp;
                break;
            case OBLIQ:
                this.rq = Math.sqrt(0.5 * this.qp);
                sinphi = Math.sin(this.lat0);
                this.sinb1 = (0, $4GxSW.default)(this.e, sinphi) / this.qp;
                this.cosb1 = Math.sqrt(1 - this.sinb1 * this.sinb1);
                this.dd = Math.cos(this.lat0) / (Math.sqrt(1 - this.es * sinphi * sinphi) * this.rq * this.cosb1);
                this.ymf = (this.xmf = this.rq) / this.dd;
                this.xmf *= this.dd;
                break;
        }
    } else if (this.mode === OBLIQ) {
        this.sinph0 = Math.sin(this.lat0);
        this.cosph0 = Math.cos(this.lat0);
    }
}
function forward(p) {
    /* Forward equations
      ----------------- */ var x, y, coslam, sinlam, sinphi, q, sinb, cosb, b, cosphi;
    var lam = p.x;
    var phi = p.y;
    lam = (0, $eRFTg.default)(lam - this.long0, this.over);
    if (this.sphere) {
        sinphi = Math.sin(phi);
        cosphi = Math.cos(phi);
        coslam = Math.cos(lam);
        if (this.mode === this.OBLIQ || this.mode === this.EQUIT) {
            y = this.mode === this.EQUIT ? 1 + cosphi * coslam : 1 + this.sinph0 * sinphi + this.cosph0 * cosphi * coslam;
            if (y <= (0, $jDCGO.EPSLN)) return null;
            y = Math.sqrt(2 / y);
            x = y * cosphi * Math.sin(lam);
            y *= this.mode === this.EQUIT ? sinphi : this.cosph0 * sinphi - this.sinph0 * cosphi * coslam;
        } else if (this.mode === this.N_POLE || this.mode === this.S_POLE) {
            if (this.mode === this.N_POLE) coslam = -coslam;
            if (Math.abs(phi + this.lat0) < (0, $jDCGO.EPSLN)) return null;
            y = (0, $jDCGO.FORTPI) - phi * 0.5;
            y = 2 * (this.mode === this.S_POLE ? Math.cos(y) : Math.sin(y));
            x = y * Math.sin(lam);
            y *= coslam;
        }
    } else {
        sinb = 0;
        cosb = 0;
        b = 0;
        coslam = Math.cos(lam);
        sinlam = Math.sin(lam);
        sinphi = Math.sin(phi);
        q = (0, $4GxSW.default)(this.e, sinphi);
        if (this.mode === this.OBLIQ || this.mode === this.EQUIT) {
            sinb = q / this.qp;
            cosb = Math.sqrt(1 - sinb * sinb);
        }
        switch(this.mode){
            case this.OBLIQ:
                b = 1 + this.sinb1 * sinb + this.cosb1 * cosb * coslam;
                break;
            case this.EQUIT:
                b = 1 + cosb * coslam;
                break;
            case this.N_POLE:
                b = (0, $jDCGO.HALF_PI) + phi;
                q = this.qp - q;
                break;
            case this.S_POLE:
                b = phi - (0, $jDCGO.HALF_PI);
                q = this.qp + q;
                break;
        }
        if (Math.abs(b) < (0, $jDCGO.EPSLN)) return null;
        switch(this.mode){
            case this.OBLIQ:
            case this.EQUIT:
                b = Math.sqrt(2 / b);
                if (this.mode === this.OBLIQ) y = this.ymf * b * (this.cosb1 * sinb - this.sinb1 * cosb * coslam);
                else y = (b = Math.sqrt(2 / (1 + cosb * coslam))) * sinb * this.ymf;
                x = this.xmf * b * cosb * sinlam;
                break;
            case this.N_POLE:
            case this.S_POLE:
                if (q >= 0) {
                    x = (b = Math.sqrt(q)) * sinlam;
                    y = coslam * (this.mode === this.S_POLE ? b : -b);
                } else x = y = 0;
                break;
        }
    }
    p.x = this.a * x + this.x0;
    p.y = this.a * y + this.y0;
    return p;
}
function inverse(p) {
    p.x -= this.x0;
    p.y -= this.y0;
    var x = p.x / this.a;
    var y = p.y / this.a;
    var lam, phi, cCe, sCe, q, rho, ab;
    if (this.sphere) {
        var cosz = 0, rh, sinz = 0;
        rh = Math.sqrt(x * x + y * y);
        phi = rh * 0.5;
        if (phi > 1) return null;
        phi = 2 * Math.asin(phi);
        if (this.mode === this.OBLIQ || this.mode === this.EQUIT) {
            sinz = Math.sin(phi);
            cosz = Math.cos(phi);
        }
        switch(this.mode){
            case this.EQUIT:
                phi = Math.abs(rh) <= (0, $jDCGO.EPSLN) ? 0 : Math.asin(y * sinz / rh);
                x *= sinz;
                y = cosz * rh;
                break;
            case this.OBLIQ:
                phi = Math.abs(rh) <= (0, $jDCGO.EPSLN) ? this.lat0 : Math.asin(cosz * this.sinph0 + y * sinz * this.cosph0 / rh);
                x *= sinz * this.cosph0;
                y = (cosz - Math.sin(phi) * this.sinph0) * rh;
                break;
            case this.N_POLE:
                y = -y;
                phi = (0, $jDCGO.HALF_PI) - phi;
                break;
            case this.S_POLE:
                phi -= (0, $jDCGO.HALF_PI);
                break;
        }
        lam = y === 0 && (this.mode === this.EQUIT || this.mode === this.OBLIQ) ? 0 : Math.atan2(x, y);
    } else {
        ab = 0;
        if (this.mode === this.OBLIQ || this.mode === this.EQUIT) {
            x /= this.dd;
            y *= this.dd;
            rho = Math.sqrt(x * x + y * y);
            if (rho < (0, $jDCGO.EPSLN)) {
                p.x = this.long0;
                p.y = this.lat0;
                return p;
            }
            sCe = 2 * Math.asin(0.5 * rho / this.rq);
            cCe = Math.cos(sCe);
            x *= sCe = Math.sin(sCe);
            if (this.mode === this.OBLIQ) {
                ab = cCe * this.sinb1 + y * sCe * this.cosb1 / rho;
                q = this.qp * ab;
                y = rho * this.cosb1 * cCe - y * this.sinb1 * sCe;
            } else {
                ab = y * sCe / rho;
                q = this.qp * ab;
                y = rho * cCe;
            }
        } else if (this.mode === this.N_POLE || this.mode === this.S_POLE) {
            if (this.mode === this.N_POLE) y = -y;
            q = x * x + y * y;
            if (!q) {
                p.x = this.long0;
                p.y = this.lat0;
                return p;
            }
            ab = 1 - q / this.qp;
            if (this.mode === this.S_POLE) ab = -ab;
        }
        lam = Math.atan2(x, y);
        phi = authlat(Math.asin(ab), this.apa);
    }
    p.x = (0, $eRFTg.default)(this.long0 + lam, this.over);
    p.y = phi;
    return p;
}
/* determine latitude from authalic latitude */ var P00 = 0.33333333333333333333;
var P01 = 0.17222222222222222222;
var P02 = 0.10257936507936507936;
var P10 = 0.06388888888888888888;
var P11 = 0.06640211640211640211;
var P20 = 0.01641501294219154443;
function authset(es) {
    var t;
    var APA = [];
    APA[0] = es * P00;
    t = es * es;
    APA[0] += t * P01;
    APA[1] = t * P10;
    t *= es;
    APA[0] += t * P02;
    APA[1] += t * P11;
    APA[2] = t * P20;
    return APA;
}
function authlat(beta, APA) {
    var t = beta + beta;
    return beta + APA[0] * Math.sin(t) + APA[1] * Math.sin(t + t) + APA[2] * Math.sin(t + t + t);
}
var names = [
    'Lambert Azimuthal Equal Area',
    'Lambert_Azimuthal_Equal_Area',
    'laea'
];
var $f523829ed0822124$export$2e2bcd8739ae039 = {
    init: init,
    forward: forward,
    inverse: inverse,
    names: names,
    S_POLE: S_POLE,
    N_POLE: N_POLE,
    EQUIT: EQUIT,
    OBLIQ: OBLIQ
};

});
parcelRegister("4GxSW", function(module, exports) {

$parcel$export(module.exports, "default", () => $36955e8ef040add7$export$2e2bcd8739ae039);
function $36955e8ef040add7$export$2e2bcd8739ae039(eccent, sinphi) {
    var con;
    if (eccent > 1.0e-7) {
        con = eccent * sinphi;
        return (1 - eccent * eccent) * (sinphi / (1 - con * con) - 0.5 / eccent * Math.log((1 - con) / (1 + con)));
    } else return 2 * sinphi;
}

});


parcelRegister("bdfcS", function(module, exports) {

$parcel$export(module.exports, "init", () => init);
$parcel$export(module.exports, "forward", () => forward);
$parcel$export(module.exports, "inverse", () => inverse);
$parcel$export(module.exports, "phi1z", () => phi1z);
$parcel$export(module.exports, "names", () => names);
$parcel$export(module.exports, "default", () => $829cb453703685a7$export$2e2bcd8739ae039);

var $96xAh = parcelRequire("96xAh");

var $4GxSW = parcelRequire("4GxSW");

var $eRFTg = parcelRequire("eRFTg");

var $3GaS9 = parcelRequire("3GaS9");

var $jDCGO = parcelRequire("jDCGO");
function init() {
    if (Math.abs(this.lat1 + this.lat2) < (0, $jDCGO.EPSLN)) return;
    this.temp = this.b / this.a;
    this.es = 1 - Math.pow(this.temp, 2);
    this.e3 = Math.sqrt(this.es);
    this.sin_po = Math.sin(this.lat1);
    this.cos_po = Math.cos(this.lat1);
    this.t1 = this.sin_po;
    this.con = this.sin_po;
    this.ms1 = (0, $96xAh.default)(this.e3, this.sin_po, this.cos_po);
    this.qs1 = (0, $4GxSW.default)(this.e3, this.sin_po);
    this.sin_po = Math.sin(this.lat2);
    this.cos_po = Math.cos(this.lat2);
    this.t2 = this.sin_po;
    this.ms2 = (0, $96xAh.default)(this.e3, this.sin_po, this.cos_po);
    this.qs2 = (0, $4GxSW.default)(this.e3, this.sin_po);
    this.sin_po = Math.sin(this.lat0);
    this.cos_po = Math.cos(this.lat0);
    this.t3 = this.sin_po;
    this.qs0 = (0, $4GxSW.default)(this.e3, this.sin_po);
    if (Math.abs(this.lat1 - this.lat2) > (0, $jDCGO.EPSLN)) this.ns0 = (this.ms1 * this.ms1 - this.ms2 * this.ms2) / (this.qs2 - this.qs1);
    else this.ns0 = this.con;
    this.c = this.ms1 * this.ms1 + this.ns0 * this.qs1;
    this.rh = this.a * Math.sqrt(this.c - this.ns0 * this.qs0) / this.ns0;
}
function forward(p) {
    var lon = p.x;
    var lat = p.y;
    this.sin_phi = Math.sin(lat);
    this.cos_phi = Math.cos(lat);
    var qs = (0, $4GxSW.default)(this.e3, this.sin_phi);
    var rh1 = this.a * Math.sqrt(this.c - this.ns0 * qs) / this.ns0;
    var theta = this.ns0 * (0, $eRFTg.default)(lon - this.long0, this.over);
    var x = rh1 * Math.sin(theta) + this.x0;
    var y = this.rh - rh1 * Math.cos(theta) + this.y0;
    p.x = x;
    p.y = y;
    return p;
}
function inverse(p) {
    var rh1, qs, con, theta, lon, lat;
    p.x -= this.x0;
    p.y = this.rh - p.y + this.y0;
    if (this.ns0 >= 0) {
        rh1 = Math.sqrt(p.x * p.x + p.y * p.y);
        con = 1;
    } else {
        rh1 = -Math.sqrt(p.x * p.x + p.y * p.y);
        con = -1;
    }
    theta = 0;
    if (rh1 !== 0) theta = Math.atan2(con * p.x, con * p.y);
    con = rh1 * this.ns0 / this.a;
    if (this.sphere) lat = Math.asin((this.c - con * con) / (2 * this.ns0));
    else {
        qs = (this.c - con * con) / this.ns0;
        lat = this.phi1z(this.e3, qs);
    }
    lon = (0, $eRFTg.default)(theta / this.ns0 + this.long0, this.over);
    p.x = lon;
    p.y = lat;
    return p;
}
function phi1z(eccent, qs) {
    var sinphi, cosphi, con, com, dphi;
    var phi = (0, $3GaS9.default)(0.5 * qs);
    if (eccent < (0, $jDCGO.EPSLN)) return phi;
    var eccnts = eccent * eccent;
    for(var i = 1; i <= 25; i++){
        sinphi = Math.sin(phi);
        cosphi = Math.cos(phi);
        con = eccent * sinphi;
        com = 1 - con * con;
        dphi = 0.5 * com * com / cosphi * (qs / (1 - eccnts) - sinphi / com + 0.5 / eccent * Math.log((1 - con) / (1 + con)));
        phi = phi + dphi;
        if (Math.abs(dphi) <= 1e-7) return phi;
    }
    return null;
}
var names = [
    'Albers_Conic_Equal_Area',
    'Albers_Equal_Area',
    'Albers',
    'aea'
];
var $829cb453703685a7$export$2e2bcd8739ae039 = {
    init: init,
    forward: forward,
    inverse: inverse,
    names: names,
    phi1z: phi1z
};

});
parcelRegister("96xAh", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a0eb9ba7c2ed157$export$2e2bcd8739ae039);
function $6a0eb9ba7c2ed157$export$2e2bcd8739ae039(eccent, sinphi, cosphi) {
    var con = eccent * sinphi;
    return cosphi / Math.sqrt(1 - con * con);
}

});

parcelRegister("3GaS9", function(module, exports) {

$parcel$export(module.exports, "default", () => $2addba62c69c95c1$export$2e2bcd8739ae039);
function $2addba62c69c95c1$export$2e2bcd8739ae039(x) {
    if (Math.abs(x) > 1) x = x > 1 ? 1 : -1;
    return Math.asin(x);
}

});


parcelRegister("d4Re2", function(module, exports) {

$parcel$export(module.exports, "iterations", () => iterations);
$parcel$export(module.exports, "init", () => init);
$parcel$export(module.exports, "forward", () => forward);
$parcel$export(module.exports, "inverse", () => inverse);
$parcel$export(module.exports, "names", () => names);
$parcel$export(module.exports, "default", () => $9854ef8de7515ff3$export$2e2bcd8739ae039);

var $jDCGO = parcelRequire("jDCGO");
var iterations = 1;
function init() {
    this.A = [];
    this.A[1] = 0.6399175073;
    this.A[2] = -0.1358797613;
    this.A[3] = 0.063294409;
    this.A[4] = -0.02526853;
    this.A[5] = 0.0117879;
    this.A[6] = -0.0055161;
    this.A[7] = 0.0026906;
    this.A[8] = -0.001333;
    this.A[9] = 0.00067;
    this.A[10] = -0.00034;
    this.B_re = [];
    this.B_im = [];
    this.B_re[1] = 0.7557853228;
    this.B_im[1] = 0;
    this.B_re[2] = 0.249204646;
    this.B_im[2] = 0.003371507;
    this.B_re[3] = -0.001541739;
    this.B_im[3] = 0.041058560;
    this.B_re[4] = -0.10162907;
    this.B_im[4] = 0.01727609;
    this.B_re[5] = -0.26623489;
    this.B_im[5] = -0.36249218;
    this.B_re[6] = -0.6870983;
    this.B_im[6] = -1.1651967;
    this.C_re = [];
    this.C_im = [];
    this.C_re[1] = 1.3231270439;
    this.C_im[1] = 0;
    this.C_re[2] = -0.577245789;
    this.C_im[2] = -0.007809598;
    this.C_re[3] = 0.508307513;
    this.C_im[3] = -0.112208952;
    this.C_re[4] = -0.15094762;
    this.C_im[4] = 0.18200602;
    this.C_re[5] = 1.01418179;
    this.C_im[5] = 1.64497696;
    this.C_re[6] = 1.9660549;
    this.C_im[6] = 2.5127645;
    this.D = [];
    this.D[1] = 1.5627014243;
    this.D[2] = 0.5185406398;
    this.D[3] = -0.03333098;
    this.D[4] = -0.1052906;
    this.D[5] = -0.0368594;
    this.D[6] = 0.007317;
    this.D[7] = 0.01220;
    this.D[8] = 0.00394;
    this.D[9] = -0.0013;
}
function forward(p) {
    var n;
    var lon = p.x;
    var lat = p.y;
    var delta_lat = lat - this.lat0;
    var delta_lon = lon - this.long0;
    // 1. Calculate d_phi and d_psi    ...                          // and d_lambda
    // For this algorithm, delta_latitude is in seconds of arc x 10-5, so we need to scale to those units. Longitude is radians.
    var d_phi = delta_lat / (0, $jDCGO.SEC_TO_RAD) * 1E-5;
    var d_lambda = delta_lon;
    var d_phi_n = 1; // d_phi^0
    var d_psi = 0;
    for(n = 1; n <= 10; n++){
        d_phi_n = d_phi_n * d_phi;
        d_psi = d_psi + this.A[n] * d_phi_n;
    }
    // 2. Calculate theta
    var th_re = d_psi;
    var th_im = d_lambda;
    // 3. Calculate z
    var th_n_re = 1;
    var th_n_im = 0; // theta^0
    var th_n_re1;
    var th_n_im1;
    var z_re = 0;
    var z_im = 0;
    for(n = 1; n <= 6; n++){
        th_n_re1 = th_n_re * th_re - th_n_im * th_im;
        th_n_im1 = th_n_im * th_re + th_n_re * th_im;
        th_n_re = th_n_re1;
        th_n_im = th_n_im1;
        z_re = z_re + this.B_re[n] * th_n_re - this.B_im[n] * th_n_im;
        z_im = z_im + this.B_im[n] * th_n_re + this.B_re[n] * th_n_im;
    }
    // 4. Calculate easting and northing
    p.x = z_im * this.a + this.x0;
    p.y = z_re * this.a + this.y0;
    return p;
}
function inverse(p) {
    var n;
    var x = p.x;
    var y = p.y;
    var delta_x = x - this.x0;
    var delta_y = y - this.y0;
    // 1. Calculate z
    var z_re = delta_y / this.a;
    var z_im = delta_x / this.a;
    // 2a. Calculate theta - first approximation gives km accuracy
    var z_n_re = 1;
    var z_n_im = 0; // z^0
    var z_n_re1;
    var z_n_im1;
    var th_re = 0;
    var th_im = 0;
    for(n = 1; n <= 6; n++){
        z_n_re1 = z_n_re * z_re - z_n_im * z_im;
        z_n_im1 = z_n_im * z_re + z_n_re * z_im;
        z_n_re = z_n_re1;
        z_n_im = z_n_im1;
        th_re = th_re + this.C_re[n] * z_n_re - this.C_im[n] * z_n_im;
        th_im = th_im + this.C_im[n] * z_n_re + this.C_re[n] * z_n_im;
    }
    // 2b. Iterate to refine the accuracy of the calculation
    //        0 iterations gives km accuracy
    //        1 iteration gives m accuracy -- good enough for most mapping applications
    //        2 iterations bives mm accuracy
    for(var i = 0; i < this.iterations; i++){
        var th_n_re = th_re;
        var th_n_im = th_im;
        var th_n_re1;
        var th_n_im1;
        var num_re = z_re;
        var num_im = z_im;
        for(n = 2; n <= 6; n++){
            th_n_re1 = th_n_re * th_re - th_n_im * th_im;
            th_n_im1 = th_n_im * th_re + th_n_re * th_im;
            th_n_re = th_n_re1;
            th_n_im = th_n_im1;
            num_re = num_re + (n - 1) * (this.B_re[n] * th_n_re - this.B_im[n] * th_n_im);
            num_im = num_im + (n - 1) * (this.B_im[n] * th_n_re + this.B_re[n] * th_n_im);
        }
        th_n_re = 1;
        th_n_im = 0;
        var den_re = this.B_re[1];
        var den_im = this.B_im[1];
        for(n = 2; n <= 6; n++){
            th_n_re1 = th_n_re * th_re - th_n_im * th_im;
            th_n_im1 = th_n_im * th_re + th_n_re * th_im;
            th_n_re = th_n_re1;
            th_n_im = th_n_im1;
            den_re = den_re + n * (this.B_re[n] * th_n_re - this.B_im[n] * th_n_im);
            den_im = den_im + n * (this.B_im[n] * th_n_re + this.B_re[n] * th_n_im);
        }
        // Complex division
        var den2 = den_re * den_re + den_im * den_im;
        th_re = (num_re * den_re + num_im * den_im) / den2;
        th_im = (num_im * den_re - num_re * den_im) / den2;
    }
    // 3. Calculate d_phi              ...                                    // and d_lambda
    var d_psi = th_re;
    var d_lambda = th_im;
    var d_psi_n = 1; // d_psi^0
    var d_phi = 0;
    for(n = 1; n <= 9; n++){
        d_psi_n = d_psi_n * d_psi;
        d_phi = d_phi + this.D[n] * d_psi_n;
    }
    // 4. Calculate latitude and longitude
    // d_phi is calcuated in second of arc * 10^-5, so we need to scale back to radians. d_lambda is in radians.
    var lat = this.lat0 + d_phi * (0, $jDCGO.SEC_TO_RAD) * 1E5;
    var lon = this.long0 + d_lambda;
    p.x = lon;
    p.y = lat;
    return p;
}
var names = [
    'New_Zealand_Map_Grid',
    'nzmg'
];
var $9854ef8de7515ff3$export$2e2bcd8739ae039 = {
    init: init,
    forward: forward,
    inverse: inverse,
    names: names
};

});

parcelRegister("lCkAA", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $fbcd1e202f3ef7b1$var$ReactIs, $fbcd1e202f3ef7b1$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("d6I2y"))();

});
parcelRegister("d6I2y", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $kB96d = parcelRequire("kB96d");
function $98adff6187843a95$var$emptyFunction() {}
function $98adff6187843a95$var$emptyFunctionWithReset() {}
$98adff6187843a95$var$emptyFunctionWithReset.resetWarningCache = $98adff6187843a95$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $kB96d) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $98adff6187843a95$var$emptyFunctionWithReset,
        resetWarningCache: $98adff6187843a95$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("kB96d", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $efee5244184ba86e$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $efee5244184ba86e$var$ReactPropTypesSecret;

});



parcelRegister("1CR13", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $12f276ec6b21850f$export$2b8d127b894957b9, (v) => $12f276ec6b21850f$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $12f276ec6b21850f$export$cea3a54a6425200c, (v) => $12f276ec6b21850f$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $12f276ec6b21850f$export$a7c73072b1a182ae, (v) => $12f276ec6b21850f$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $12f276ec6b21850f$export$9f27bc3417b4524d, (v) => $12f276ec6b21850f$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $12f276ec6b21850f$export$db77ccec0bb4ccac, (v) => $12f276ec6b21850f$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $12f276ec6b21850f$export$8392c0c9d3dcbd35, (v) => $12f276ec6b21850f$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $12f276ec6b21850f$export$ffb0004e005737fa, (v) => $12f276ec6b21850f$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $12f276ec6b21850f$export$b624eff549462981, (v) => $12f276ec6b21850f$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $12f276ec6b21850f$export$7897aa7841a5380c, (v) => $12f276ec6b21850f$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $12f276ec6b21850f$export$602eac185826482c, (v) => $12f276ec6b21850f$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $12f276ec6b21850f$export$e2c29f18771995cb, (v) => $12f276ec6b21850f$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $12f276ec6b21850f$export$5f8d39834fd61797, (v) => $12f276ec6b21850f$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $12f276ec6b21850f$export$74bf444e3cd11ea5, (v) => $12f276ec6b21850f$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $12f276ec6b21850f$export$92387174baf9b227, (v) => $12f276ec6b21850f$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $12f276ec6b21850f$export$ec112efeb987d9c6, (v) => $12f276ec6b21850f$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $12f276ec6b21850f$export$b706b080d889d2c9, (v) => $12f276ec6b21850f$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $12f276ec6b21850f$export$5be5a87408f70ddc, (v) => $12f276ec6b21850f$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $12f276ec6b21850f$export$45a5e7f76e0caa8d, (v) => $12f276ec6b21850f$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $12f276ec6b21850f$export$455c2e768291efa6, (v) => $12f276ec6b21850f$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $12f276ec6b21850f$export$9522e17588c12572, (v) => $12f276ec6b21850f$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $12f276ec6b21850f$export$2110ac352bb060b9, (v) => $12f276ec6b21850f$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $12f276ec6b21850f$export$56885ab8b9c456ab, (v) => $12f276ec6b21850f$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $12f276ec6b21850f$export$d927fcb6adf8f9de, (v) => $12f276ec6b21850f$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $12f276ec6b21850f$export$b82d16f27459e05a, (v) => $12f276ec6b21850f$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $12f276ec6b21850f$export$522c17b4f5e123e8, (v) => $12f276ec6b21850f$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $12f276ec6b21850f$export$1aabd8a0274ecfd6, (v) => $12f276ec6b21850f$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $12f276ec6b21850f$export$9b621391a187a31a, (v) => $12f276ec6b21850f$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $12f276ec6b21850f$export$f5bbd400c2f4426f, (v) => $12f276ec6b21850f$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $12f276ec6b21850f$export$2b8d127b894957b9;
var $12f276ec6b21850f$export$cea3a54a6425200c;
var $12f276ec6b21850f$export$a7c73072b1a182ae;
var $12f276ec6b21850f$export$9f27bc3417b4524d;
var $12f276ec6b21850f$export$db77ccec0bb4ccac;
var $12f276ec6b21850f$export$8392c0c9d3dcbd35;
var $12f276ec6b21850f$export$ffb0004e005737fa;
var $12f276ec6b21850f$export$b624eff549462981;
var $12f276ec6b21850f$export$7897aa7841a5380c;
var $12f276ec6b21850f$export$602eac185826482c;
var $12f276ec6b21850f$export$e2c29f18771995cb;
var $12f276ec6b21850f$export$5f8d39834fd61797;
var $12f276ec6b21850f$export$74bf444e3cd11ea5;
var $12f276ec6b21850f$export$92387174baf9b227;
var $12f276ec6b21850f$export$ec112efeb987d9c6;
var $12f276ec6b21850f$export$b706b080d889d2c9;
var $12f276ec6b21850f$export$5be5a87408f70ddc;
var $12f276ec6b21850f$export$45a5e7f76e0caa8d;
var $12f276ec6b21850f$export$455c2e768291efa6;
var $12f276ec6b21850f$export$9522e17588c12572;
var $12f276ec6b21850f$export$2110ac352bb060b9;
var $12f276ec6b21850f$export$56885ab8b9c456ab;
var $12f276ec6b21850f$export$d927fcb6adf8f9de;
var $12f276ec6b21850f$export$b82d16f27459e05a;
var $12f276ec6b21850f$export$522c17b4f5e123e8;
var $12f276ec6b21850f$export$1aabd8a0274ecfd6;
var $12f276ec6b21850f$export$9b621391a187a31a;
var $12f276ec6b21850f$export$f5bbd400c2f4426f;
'use strict';
var $12f276ec6b21850f$var$b = "function" === typeof Symbol && Symbol.for, $12f276ec6b21850f$var$c = $12f276ec6b21850f$var$b ? Symbol.for("react.element") : 60103, $12f276ec6b21850f$var$d = $12f276ec6b21850f$var$b ? Symbol.for("react.portal") : 60106, $12f276ec6b21850f$var$e = $12f276ec6b21850f$var$b ? Symbol.for("react.fragment") : 60107, $12f276ec6b21850f$var$f = $12f276ec6b21850f$var$b ? Symbol.for("react.strict_mode") : 60108, $12f276ec6b21850f$var$g = $12f276ec6b21850f$var$b ? Symbol.for("react.profiler") : 60114, $12f276ec6b21850f$var$h = $12f276ec6b21850f$var$b ? Symbol.for("react.provider") : 60109, $12f276ec6b21850f$var$k = $12f276ec6b21850f$var$b ? Symbol.for("react.context") : 60110, $12f276ec6b21850f$var$l = $12f276ec6b21850f$var$b ? Symbol.for("react.async_mode") : 60111, $12f276ec6b21850f$var$m = $12f276ec6b21850f$var$b ? Symbol.for("react.concurrent_mode") : 60111, $12f276ec6b21850f$var$n = $12f276ec6b21850f$var$b ? Symbol.for("react.forward_ref") : 60112, $12f276ec6b21850f$var$p = $12f276ec6b21850f$var$b ? Symbol.for("react.suspense") : 60113, $12f276ec6b21850f$var$q = $12f276ec6b21850f$var$b ? Symbol.for("react.suspense_list") : 60120, $12f276ec6b21850f$var$r = $12f276ec6b21850f$var$b ? Symbol.for("react.memo") : 60115, $12f276ec6b21850f$var$t = $12f276ec6b21850f$var$b ? Symbol.for("react.lazy") : 60116, $12f276ec6b21850f$var$v = $12f276ec6b21850f$var$b ? Symbol.for("react.block") : 60121, $12f276ec6b21850f$var$w = $12f276ec6b21850f$var$b ? Symbol.for("react.fundamental") : 60117, $12f276ec6b21850f$var$x = $12f276ec6b21850f$var$b ? Symbol.for("react.responder") : 60118, $12f276ec6b21850f$var$y = $12f276ec6b21850f$var$b ? Symbol.for("react.scope") : 60119;
function $12f276ec6b21850f$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $12f276ec6b21850f$var$c:
                switch(a = a.type, a){
                    case $12f276ec6b21850f$var$l:
                    case $12f276ec6b21850f$var$m:
                    case $12f276ec6b21850f$var$e:
                    case $12f276ec6b21850f$var$g:
                    case $12f276ec6b21850f$var$f:
                    case $12f276ec6b21850f$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $12f276ec6b21850f$var$k:
                            case $12f276ec6b21850f$var$n:
                            case $12f276ec6b21850f$var$t:
                            case $12f276ec6b21850f$var$r:
                            case $12f276ec6b21850f$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $12f276ec6b21850f$var$d:
                return u;
        }
    }
}
function $12f276ec6b21850f$var$A(a) {
    return $12f276ec6b21850f$var$z(a) === $12f276ec6b21850f$var$m;
}
$12f276ec6b21850f$export$2b8d127b894957b9 = $12f276ec6b21850f$var$l;
$12f276ec6b21850f$export$cea3a54a6425200c = $12f276ec6b21850f$var$m;
$12f276ec6b21850f$export$a7c73072b1a182ae = $12f276ec6b21850f$var$k;
$12f276ec6b21850f$export$9f27bc3417b4524d = $12f276ec6b21850f$var$h;
$12f276ec6b21850f$export$db77ccec0bb4ccac = $12f276ec6b21850f$var$c;
$12f276ec6b21850f$export$8392c0c9d3dcbd35 = $12f276ec6b21850f$var$n;
$12f276ec6b21850f$export$ffb0004e005737fa = $12f276ec6b21850f$var$e;
$12f276ec6b21850f$export$b624eff549462981 = $12f276ec6b21850f$var$t;
$12f276ec6b21850f$export$7897aa7841a5380c = $12f276ec6b21850f$var$r;
$12f276ec6b21850f$export$602eac185826482c = $12f276ec6b21850f$var$d;
$12f276ec6b21850f$export$e2c29f18771995cb = $12f276ec6b21850f$var$g;
$12f276ec6b21850f$export$5f8d39834fd61797 = $12f276ec6b21850f$var$f;
$12f276ec6b21850f$export$74bf444e3cd11ea5 = $12f276ec6b21850f$var$p;
$12f276ec6b21850f$export$92387174baf9b227 = function(a) {
    return $12f276ec6b21850f$var$A(a) || $12f276ec6b21850f$var$z(a) === $12f276ec6b21850f$var$l;
};
$12f276ec6b21850f$export$ec112efeb987d9c6 = $12f276ec6b21850f$var$A;
$12f276ec6b21850f$export$b706b080d889d2c9 = function(a) {
    return $12f276ec6b21850f$var$z(a) === $12f276ec6b21850f$var$k;
};
$12f276ec6b21850f$export$5be5a87408f70ddc = function(a) {
    return $12f276ec6b21850f$var$z(a) === $12f276ec6b21850f$var$h;
};
$12f276ec6b21850f$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $12f276ec6b21850f$var$c;
};
$12f276ec6b21850f$export$455c2e768291efa6 = function(a) {
    return $12f276ec6b21850f$var$z(a) === $12f276ec6b21850f$var$n;
};
$12f276ec6b21850f$export$9522e17588c12572 = function(a) {
    return $12f276ec6b21850f$var$z(a) === $12f276ec6b21850f$var$e;
};
$12f276ec6b21850f$export$2110ac352bb060b9 = function(a) {
    return $12f276ec6b21850f$var$z(a) === $12f276ec6b21850f$var$t;
};
$12f276ec6b21850f$export$56885ab8b9c456ab = function(a) {
    return $12f276ec6b21850f$var$z(a) === $12f276ec6b21850f$var$r;
};
$12f276ec6b21850f$export$d927fcb6adf8f9de = function(a) {
    return $12f276ec6b21850f$var$z(a) === $12f276ec6b21850f$var$d;
};
$12f276ec6b21850f$export$b82d16f27459e05a = function(a) {
    return $12f276ec6b21850f$var$z(a) === $12f276ec6b21850f$var$g;
};
$12f276ec6b21850f$export$522c17b4f5e123e8 = function(a) {
    return $12f276ec6b21850f$var$z(a) === $12f276ec6b21850f$var$f;
};
$12f276ec6b21850f$export$1aabd8a0274ecfd6 = function(a) {
    return $12f276ec6b21850f$var$z(a) === $12f276ec6b21850f$var$p;
};
$12f276ec6b21850f$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $12f276ec6b21850f$var$e || a === $12f276ec6b21850f$var$m || a === $12f276ec6b21850f$var$g || a === $12f276ec6b21850f$var$f || a === $12f276ec6b21850f$var$p || a === $12f276ec6b21850f$var$q || "object" === typeof a && null !== a && (a.$$typeof === $12f276ec6b21850f$var$t || a.$$typeof === $12f276ec6b21850f$var$r || a.$$typeof === $12f276ec6b21850f$var$h || a.$$typeof === $12f276ec6b21850f$var$k || a.$$typeof === $12f276ec6b21850f$var$n || a.$$typeof === $12f276ec6b21850f$var$w || a.$$typeof === $12f276ec6b21850f$var$x || a.$$typeof === $12f276ec6b21850f$var$y || a.$$typeof === $12f276ec6b21850f$var$v);
};
$12f276ec6b21850f$export$f5bbd400c2f4426f = $12f276ec6b21850f$var$z;

});

parcelRegister("bkJfK", function(module, exports) {

$parcel$export(module.exports, "useFormikContext", () => useFormikContext);
$parcel$export(module.exports, "getIn", () => getIn);
$parcel$export(module.exports, "useFormik", () => useFormik);
$parcel$export(module.exports, "Formik", () => Formik);
$parcel$export(module.exports, "useField", () => useField);
$parcel$export(module.exports, "Field", () => Field);
$parcel$export(module.exports, "Form", () => Form);
$parcel$export(module.exports, "FieldArray", () => FieldArray);

var $kMZku = parcelRequire("kMZku");

var $eBHEL = parcelRequire("eBHEL");

var $2AJmr = parcelRequire("2AJmr");

var $kc00y = parcelRequire("kc00y");

var $31ATd = parcelRequire("31ATd");

var $8I1rW = parcelRequire("8I1rW");

var $bwrOM = parcelRequire("bwrOM");

var $aCf5k = parcelRequire("aCf5k");

var $j8Bf6 = parcelRequire("j8Bf6");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
var FormikContext = /*#__PURE__*/ (0, $kc00y.createContext)(undefined);
FormikContext.displayName = 'FormikContext';
var FormikProvider = FormikContext.Provider;
var FormikConsumer = FormikContext.Consumer;
function useFormikContext() {
    var formik = (0, $kc00y.useContext)(FormikContext);
    !!!formik && (0, $8I1rW.default)(false);
    return formik;
}
/** @private is the value an empty array? */ var isEmptyArray = function isEmptyArray(value) {
    return Array.isArray(value) && value.length === 0;
};
/** @private is the given object a Function? */ var isFunction = function isFunction(obj) {
    return typeof obj === 'function';
};
/** @private is the given object an Object? */ var isObject = function isObject(obj) {
    return obj !== null && typeof obj === 'object';
};
/** @private is the given object an integer? */ var isInteger = function isInteger(obj) {
    return String(Math.floor(Number(obj))) === obj;
};
/** @private is the given object a string? */ var isString = function isString(obj) {
    return Object.prototype.toString.call(obj) === '[object String]';
};
/** @private is the given object a NaN? */ // eslint-disable-next-line no-self-compare
var isNaN$1 = function isNaN1(obj) {
    return obj !== obj;
};
/** @private Does a React component have exactly 0 children? */ var isEmptyChildren = function isEmptyChildren(children) {
    return (0, $kc00y.Children).count(children) === 0;
};
/** @private is the given object/value a promise? */ var isPromise = function isPromise(value) {
    return isObject(value) && isFunction(value.then);
};
/** @private is the given object/value a type of synthetic event? */ var isInputEvent = function isInputEvent(value) {
    return value && isObject(value) && isObject(value.target);
};
/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?Document} doc Defaults to current document.
 * @return {Element | null}
 * @see https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/dom/getActiveElement.js
 */ function getActiveElement(doc) {
    doc = doc || (typeof document !== 'undefined' ? document : undefined);
    if (typeof doc === 'undefined') return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
/**
 * Deeply get a value from an object via its path.
 */ function getIn(obj, key, def, p) {
    if (p === void 0) p = 0;
    var path = (0, $aCf5k.default)(key);
    while(obj && p < path.length)obj = obj[path[p++]];
     // check if path is not in the end
    if (p !== path.length && !obj) return def;
    return obj === undefined ? def : obj;
}
/**
 * Deeply set a value from in object via it's path. If the value at `path`
 * has changed, return a shallow copy of obj with `value` set at `path`.
 * If `value` has not changed, return the original `obj`.
 *
 * Existing objects / arrays along `path` are also shallow copied. Sibling
 * objects along path retain the same internal js reference. Since new
 * objects / arrays are only created along `path`, we can test if anything
 * changed in a nested structure by comparing the object's reference in
 * the old and new object, similar to how russian doll cache invalidation
 * works.
 *
 * In earlier versions of this function, which used cloneDeep, there were
 * issues whereby settings a nested value would mutate the parent
 * instead of creating a new object. `clone` avoids that bug making a
 * shallow copy of the objects along the update path
 * so no object is mutated in place.
 *
 * Before changing this function, please read through the following
 * discussions.
 *
 * @see https://github.com/developit/linkstate
 * @see https://github.com/jaredpalmer/formik/pull/123
 */ function setIn(obj, path, value) {
    var res = (0, $bwrOM.default)(obj); // this keeps inheritance when obj is a class
    var resVal = res;
    var i = 0;
    var pathArray = (0, $aCf5k.default)(path);
    for(; i < pathArray.length - 1; i++){
        var currentPath = pathArray[i];
        var currentObj = getIn(obj, pathArray.slice(0, i + 1));
        if (currentObj && (isObject(currentObj) || Array.isArray(currentObj))) resVal = resVal[currentPath] = (0, $bwrOM.default)(currentObj);
        else {
            var nextPath = pathArray[i + 1];
            resVal = resVal[currentPath] = isInteger(nextPath) && Number(nextPath) >= 0 ? [] : {};
        }
    } // Return original object if new value is the same as current
    if ((i === 0 ? obj : resVal)[pathArray[i]] === value) return obj;
    if (value === undefined) delete resVal[pathArray[i]];
    else resVal[pathArray[i]] = value;
     // If the path array has a single element, the loop did not run.
    // Deleting on `resVal` had no effect in this scenario, so we delete on the result instead.
    if (i === 0 && value === undefined) delete res[pathArray[i]];
    return res;
}
/**
 * Recursively a set the same value for all keys and arrays nested object, cloning
 * @param object
 * @param value
 * @param visited
 * @param response
 */ function setNestedObjectValues(object, value, visited, response) {
    if (visited === void 0) visited = new WeakMap();
    if (response === void 0) response = {};
    for(var _i = 0, _Object$keys = Object.keys(object); _i < _Object$keys.length; _i++){
        var k = _Object$keys[_i];
        var val = object[k];
        if (isObject(val)) {
            if (!visited.get(val)) {
                visited.set(val, true); // In order to keep array values consistent for both dot path  and
                // bracket syntax, we need to check if this is an array so that
                // this will output  { friends: [true] } and not { friends: { "0": true } }
                response[k] = Array.isArray(val) ? [] : {};
                setNestedObjectValues(val, value, visited, response[k]);
            }
        } else response[k] = value;
    }
    return response;
}
function formikReducer(state, msg) {
    switch(msg.type){
        case 'SET_VALUES':
            return _extends({}, state, {
                values: msg.payload
            });
        case 'SET_TOUCHED':
            return _extends({}, state, {
                touched: msg.payload
            });
        case 'SET_ERRORS':
            if ((0, (/*@__PURE__*/$parcel$interopDefault($31ATd)))(state.errors, msg.payload)) return state;
            return _extends({}, state, {
                errors: msg.payload
            });
        case 'SET_STATUS':
            return _extends({}, state, {
                status: msg.payload
            });
        case 'SET_ISSUBMITTING':
            return _extends({}, state, {
                isSubmitting: msg.payload
            });
        case 'SET_ISVALIDATING':
            return _extends({}, state, {
                isValidating: msg.payload
            });
        case 'SET_FIELD_VALUE':
            return _extends({}, state, {
                values: setIn(state.values, msg.payload.field, msg.payload.value)
            });
        case 'SET_FIELD_TOUCHED':
            return _extends({}, state, {
                touched: setIn(state.touched, msg.payload.field, msg.payload.value)
            });
        case 'SET_FIELD_ERROR':
            return _extends({}, state, {
                errors: setIn(state.errors, msg.payload.field, msg.payload.value)
            });
        case 'RESET_FORM':
            return _extends({}, state, msg.payload);
        case 'SET_FORMIK_STATE':
            return msg.payload(state);
        case 'SUBMIT_ATTEMPT':
            return _extends({}, state, {
                touched: setNestedObjectValues(state.values, true),
                isSubmitting: true,
                submitCount: state.submitCount + 1
            });
        case 'SUBMIT_FAILURE':
            return _extends({}, state, {
                isSubmitting: false
            });
        case 'SUBMIT_SUCCESS':
            return _extends({}, state, {
                isSubmitting: false
            });
        default:
            return state;
    }
} // Initial empty states // objects
var emptyErrors = {};
var emptyTouched = {};
function useFormik(_ref) {
    var _ref$validateOnChange = _ref.validateOnChange, validateOnChange = _ref$validateOnChange === void 0 ? true : _ref$validateOnChange, _ref$validateOnBlur = _ref.validateOnBlur, validateOnBlur = _ref$validateOnBlur === void 0 ? true : _ref$validateOnBlur, _ref$validateOnMount = _ref.validateOnMount, validateOnMount = _ref$validateOnMount === void 0 ? false : _ref$validateOnMount, isInitialValid = _ref.isInitialValid, _ref$enableReinitiali = _ref.enableReinitialize, enableReinitialize = _ref$enableReinitiali === void 0 ? false : _ref$enableReinitiali, onSubmit = _ref.onSubmit, rest = _objectWithoutPropertiesLoose(_ref, [
        "validateOnChange",
        "validateOnBlur",
        "validateOnMount",
        "isInitialValid",
        "enableReinitialize",
        "onSubmit"
    ]);
    var props = _extends({
        validateOnChange: validateOnChange,
        validateOnBlur: validateOnBlur,
        validateOnMount: validateOnMount,
        onSubmit: onSubmit
    }, rest);
    var initialValues = (0, $kc00y.useRef)(props.initialValues);
    var initialErrors = (0, $kc00y.useRef)(props.initialErrors || emptyErrors);
    var initialTouched = (0, $kc00y.useRef)(props.initialTouched || emptyTouched);
    var initialStatus = (0, $kc00y.useRef)(props.initialStatus);
    var isMounted = (0, $kc00y.useRef)(false);
    var fieldRegistry = (0, $kc00y.useRef)({});
    (0, $kc00y.useEffect)(function() {
        isMounted.current = true;
        return function() {
            isMounted.current = false;
        };
    }, []);
    var _React$useState = (0, $kc00y.useState)(0), setIteration = _React$useState[1];
    var stateRef = (0, $kc00y.useRef)({
        values: (0, $2AJmr.default)(props.initialValues),
        errors: (0, $2AJmr.default)(props.initialErrors) || emptyErrors,
        touched: (0, $2AJmr.default)(props.initialTouched) || emptyTouched,
        status: (0, $2AJmr.default)(props.initialStatus),
        isSubmitting: false,
        isValidating: false,
        submitCount: 0
    });
    var state = stateRef.current;
    var dispatch = (0, $kc00y.useCallback)(function(action) {
        var prev = stateRef.current;
        stateRef.current = formikReducer(prev, action); // force rerender
        if (prev !== stateRef.current) setIteration(function(x) {
            return x + 1;
        });
    }, []);
    var runValidateHandler = (0, $kc00y.useCallback)(function(values, field) {
        return new Promise(function(resolve, reject) {
            var maybePromisedErrors = props.validate(values, field);
            if (maybePromisedErrors == null) // use loose null check here on purpose
            resolve(emptyErrors);
            else if (isPromise(maybePromisedErrors)) maybePromisedErrors.then(function(errors) {
                resolve(errors || emptyErrors);
            }, function(actualException) {
                reject(actualException);
            });
            else resolve(maybePromisedErrors);
        });
    }, [
        props.validate
    ]);
    /**
   * Run validation against a Yup schema and optionally run a function if successful
   */ var runValidationSchema = (0, $kc00y.useCallback)(function(values, field) {
        var validationSchema = props.validationSchema;
        var schema = isFunction(validationSchema) ? validationSchema(field) : validationSchema;
        var promise = field && schema.validateAt ? schema.validateAt(field, values) : validateYupSchema(values, schema);
        return new Promise(function(resolve, reject) {
            promise.then(function() {
                resolve(emptyErrors);
            }, function(err) {
                // Yup will throw a validation error if validation fails. We catch those and
                // resolve them into Formik errors. We can sniff if something is a Yup error
                // by checking error.name.
                // @see https://github.com/jquense/yup#validationerrorerrors-string--arraystring-value-any-path-string
                if (err.name === 'ValidationError') resolve(yupToFormErrors(err));
                else reject(err);
            });
        });
    }, [
        props.validationSchema
    ]);
    var runSingleFieldLevelValidation = (0, $kc00y.useCallback)(function(field, value) {
        return new Promise(function(resolve) {
            return resolve(fieldRegistry.current[field].validate(value));
        });
    }, []);
    var runFieldLevelValidations = (0, $kc00y.useCallback)(function(values) {
        var fieldKeysWithValidation = Object.keys(fieldRegistry.current).filter(function(f) {
            return isFunction(fieldRegistry.current[f].validate);
        }); // Construct an array with all of the field validation functions
        var fieldValidations = fieldKeysWithValidation.length > 0 ? fieldKeysWithValidation.map(function(f) {
            return runSingleFieldLevelValidation(f, getIn(values, f));
        }) : [
            Promise.resolve('DO_NOT_DELETE_YOU_WILL_BE_FIRED')
        ]; // use special case ;)
        return Promise.all(fieldValidations).then(function(fieldErrorsList) {
            return fieldErrorsList.reduce(function(prev, curr, index) {
                if (curr === 'DO_NOT_DELETE_YOU_WILL_BE_FIRED') return prev;
                if (curr) prev = setIn(prev, fieldKeysWithValidation[index], curr);
                return prev;
            }, {});
        });
    }, [
        runSingleFieldLevelValidation
    ]); // Run all validations and return the result
    var runAllValidations = (0, $kc00y.useCallback)(function(values) {
        return Promise.all([
            runFieldLevelValidations(values),
            props.validationSchema ? runValidationSchema(values) : {},
            props.validate ? runValidateHandler(values) : {}
        ]).then(function(_ref2) {
            var fieldErrors = _ref2[0], schemaErrors = _ref2[1], validateErrors = _ref2[2];
            var combinedErrors = (0, $kMZku.default).all([
                fieldErrors,
                schemaErrors,
                validateErrors
            ], {
                arrayMerge: arrayMerge
            });
            return combinedErrors;
        });
    }, [
        props.validate,
        props.validationSchema,
        runFieldLevelValidations,
        runValidateHandler,
        runValidationSchema
    ]); // Run all validations methods and update state accordingly
    var validateFormWithHighPriority = useEventCallback(function(values) {
        if (values === void 0) values = state.values;
        dispatch({
            type: 'SET_ISVALIDATING',
            payload: true
        });
        return runAllValidations(values).then(function(combinedErrors) {
            if (!!isMounted.current) {
                dispatch({
                    type: 'SET_ISVALIDATING',
                    payload: false
                });
                dispatch({
                    type: 'SET_ERRORS',
                    payload: combinedErrors
                });
            }
            return combinedErrors;
        });
    });
    (0, $kc00y.useEffect)(function() {
        if (validateOnMount && isMounted.current === true && (0, (/*@__PURE__*/$parcel$interopDefault($31ATd)))(initialValues.current, props.initialValues)) validateFormWithHighPriority(initialValues.current);
    }, [
        validateOnMount,
        validateFormWithHighPriority
    ]);
    var resetForm = (0, $kc00y.useCallback)(function(nextState) {
        var values = nextState && nextState.values ? nextState.values : initialValues.current;
        var errors = nextState && nextState.errors ? nextState.errors : initialErrors.current ? initialErrors.current : props.initialErrors || {};
        var touched = nextState && nextState.touched ? nextState.touched : initialTouched.current ? initialTouched.current : props.initialTouched || {};
        var status = nextState && nextState.status ? nextState.status : initialStatus.current ? initialStatus.current : props.initialStatus;
        initialValues.current = values;
        initialErrors.current = errors;
        initialTouched.current = touched;
        initialStatus.current = status;
        var dispatchFn = function dispatchFn() {
            dispatch({
                type: 'RESET_FORM',
                payload: {
                    isSubmitting: !!nextState && !!nextState.isSubmitting,
                    errors: errors,
                    touched: touched,
                    status: status,
                    values: values,
                    isValidating: !!nextState && !!nextState.isValidating,
                    submitCount: !!nextState && !!nextState.submitCount && typeof nextState.submitCount === 'number' ? nextState.submitCount : 0
                }
            });
        };
        if (props.onReset) {
            var maybePromisedOnReset = props.onReset(state.values, imperativeMethods);
            if (isPromise(maybePromisedOnReset)) maybePromisedOnReset.then(dispatchFn);
            else dispatchFn();
        } else dispatchFn();
    }, [
        props.initialErrors,
        props.initialStatus,
        props.initialTouched,
        props.onReset
    ]);
    (0, $kc00y.useEffect)(function() {
        if (isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($31ATd)))(initialValues.current, props.initialValues)) {
            if (enableReinitialize) {
                initialValues.current = props.initialValues;
                resetForm();
                if (validateOnMount) validateFormWithHighPriority(initialValues.current);
            }
        }
    }, [
        enableReinitialize,
        props.initialValues,
        resetForm,
        validateOnMount,
        validateFormWithHighPriority
    ]);
    (0, $kc00y.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($31ATd)))(initialErrors.current, props.initialErrors)) {
            initialErrors.current = props.initialErrors || emptyErrors;
            dispatch({
                type: 'SET_ERRORS',
                payload: props.initialErrors || emptyErrors
            });
        }
    }, [
        enableReinitialize,
        props.initialErrors
    ]);
    (0, $kc00y.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($31ATd)))(initialTouched.current, props.initialTouched)) {
            initialTouched.current = props.initialTouched || emptyTouched;
            dispatch({
                type: 'SET_TOUCHED',
                payload: props.initialTouched || emptyTouched
            });
        }
    }, [
        enableReinitialize,
        props.initialTouched
    ]);
    (0, $kc00y.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($31ATd)))(initialStatus.current, props.initialStatus)) {
            initialStatus.current = props.initialStatus;
            dispatch({
                type: 'SET_STATUS',
                payload: props.initialStatus
            });
        }
    }, [
        enableReinitialize,
        props.initialStatus,
        props.initialTouched
    ]);
    var validateField = useEventCallback(function(name) {
        // This will efficiently validate a single field by avoiding state
        // changes if the validation function is synchronous. It's different from
        // what is called when using validateForm.
        if (fieldRegistry.current[name] && isFunction(fieldRegistry.current[name].validate)) {
            var value = getIn(state.values, name);
            var maybePromise = fieldRegistry.current[name].validate(value);
            if (isPromise(maybePromise)) {
                // Only flip isValidating if the function is async.
                dispatch({
                    type: 'SET_ISVALIDATING',
                    payload: true
                });
                return maybePromise.then(function(x) {
                    return x;
                }).then(function(error) {
                    dispatch({
                        type: 'SET_FIELD_ERROR',
                        payload: {
                            field: name,
                            value: error
                        }
                    });
                    dispatch({
                        type: 'SET_ISVALIDATING',
                        payload: false
                    });
                });
            } else {
                dispatch({
                    type: 'SET_FIELD_ERROR',
                    payload: {
                        field: name,
                        value: maybePromise
                    }
                });
                return Promise.resolve(maybePromise);
            }
        } else if (props.validationSchema) {
            dispatch({
                type: 'SET_ISVALIDATING',
                payload: true
            });
            return runValidationSchema(state.values, name).then(function(x) {
                return x;
            }).then(function(error) {
                dispatch({
                    type: 'SET_FIELD_ERROR',
                    payload: {
                        field: name,
                        value: getIn(error, name)
                    }
                });
                dispatch({
                    type: 'SET_ISVALIDATING',
                    payload: false
                });
            });
        }
        return Promise.resolve();
    });
    var registerField = (0, $kc00y.useCallback)(function(name, _ref3) {
        var validate = _ref3.validate;
        fieldRegistry.current[name] = {
            validate: validate
        };
    }, []);
    var unregisterField = (0, $kc00y.useCallback)(function(name) {
        delete fieldRegistry.current[name];
    }, []);
    var setTouched = useEventCallback(function(touched, shouldValidate) {
        dispatch({
            type: 'SET_TOUCHED',
            payload: touched
        });
        var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
        return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
    });
    var setErrors = (0, $kc00y.useCallback)(function(errors) {
        dispatch({
            type: 'SET_ERRORS',
            payload: errors
        });
    }, []);
    var setValues = useEventCallback(function(values, shouldValidate) {
        var resolvedValues = isFunction(values) ? values(state.values) : values;
        dispatch({
            type: 'SET_VALUES',
            payload: resolvedValues
        });
        var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
        return willValidate ? validateFormWithHighPriority(resolvedValues) : Promise.resolve();
    });
    var setFieldError = (0, $kc00y.useCallback)(function(field, value) {
        dispatch({
            type: 'SET_FIELD_ERROR',
            payload: {
                field: field,
                value: value
            }
        });
    }, []);
    var setFieldValue = useEventCallback(function(field, value, shouldValidate) {
        var resolvedValue = isFunction(value) ? value(getIn(state.values, field)) : value;
        dispatch({
            type: 'SET_FIELD_VALUE',
            payload: {
                field: field,
                value: resolvedValue
            }
        });
        var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
        return willValidate ? validateFormWithHighPriority(setIn(state.values, field, resolvedValue)) : Promise.resolve();
    });
    var executeChange = (0, $kc00y.useCallback)(function(eventOrTextValue, maybePath) {
        // By default, assume that the first argument is a string. This allows us to use
        // handleChange with React Native and React Native Web's onChangeText prop which
        // provides just the value of the input.
        var field = maybePath;
        var val = eventOrTextValue;
        var parsed; // If the first argument is not a string though, it has to be a synthetic React Event (or a fake one),
        // so we handle like we would a normal HTML change event.
        if (!isString(eventOrTextValue)) {
            // If we can, persist the event
            // @see https://reactjs.org/docs/events.html#event-pooling
            if (eventOrTextValue.persist) eventOrTextValue.persist();
            var target = eventOrTextValue.target ? eventOrTextValue.target : eventOrTextValue.currentTarget;
            var type = target.type, name = target.name, id = target.id, value = target.value, checked = target.checked, outerHTML = target.outerHTML, options = target.options, multiple = target.multiple;
            field = maybePath ? maybePath : name ? name : id;
            field;
            val = /number|range/.test(type) ? (parsed = parseFloat(value), isNaN(parsed) ? '' : parsed) : /checkbox/.test(type) // checkboxes
             ? getValueForCheckbox(getIn(state.values, field), checked, value) : options && multiple // <select multiple>
             ? getSelectedValues(options) : value;
        }
        if (field) // Set form fields by name
        setFieldValue(field, val);
    }, [
        setFieldValue,
        state.values
    ]);
    var handleChange = useEventCallback(function(eventOrPath) {
        if (isString(eventOrPath)) return function(event) {
            return executeChange(event, eventOrPath);
        };
        else executeChange(eventOrPath);
    });
    var setFieldTouched = useEventCallback(function(field, touched, shouldValidate) {
        if (touched === void 0) touched = true;
        dispatch({
            type: 'SET_FIELD_TOUCHED',
            payload: {
                field: field,
                value: touched
            }
        });
        var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
        return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
    });
    var executeBlur = (0, $kc00y.useCallback)(function(e, path) {
        if (e.persist) e.persist();
        var _e$target = e.target, name = _e$target.name, id = _e$target.id, outerHTML = _e$target.outerHTML;
        var field = path ? path : name ? name : id;
        field;
        setFieldTouched(field, true);
    }, [
        setFieldTouched
    ]);
    var handleBlur = useEventCallback(function(eventOrString) {
        if (isString(eventOrString)) return function(event) {
            return executeBlur(event, eventOrString);
        };
        else executeBlur(eventOrString);
    });
    var setFormikState = (0, $kc00y.useCallback)(function(stateOrCb) {
        if (isFunction(stateOrCb)) dispatch({
            type: 'SET_FORMIK_STATE',
            payload: stateOrCb
        });
        else dispatch({
            type: 'SET_FORMIK_STATE',
            payload: function payload() {
                return stateOrCb;
            }
        });
    }, []);
    var setStatus = (0, $kc00y.useCallback)(function(status) {
        dispatch({
            type: 'SET_STATUS',
            payload: status
        });
    }, []);
    var setSubmitting = (0, $kc00y.useCallback)(function(isSubmitting) {
        dispatch({
            type: 'SET_ISSUBMITTING',
            payload: isSubmitting
        });
    }, []);
    var submitForm = useEventCallback(function() {
        dispatch({
            type: 'SUBMIT_ATTEMPT'
        });
        return validateFormWithHighPriority().then(function(combinedErrors) {
            // In case an error was thrown and passed to the resolved Promise,
            // `combinedErrors` can be an instance of an Error. We need to check
            // that and abort the submit.
            // If we don't do that, calling `Object.keys(new Error())` yields an
            // empty array, which causes the validation to pass and the form
            // to be submitted.
            var isInstanceOfError = combinedErrors instanceof Error;
            var isActuallyValid = !isInstanceOfError && Object.keys(combinedErrors).length === 0;
            if (isActuallyValid) {
                // Proceed with submit...
                //
                // To respect sync submit fns, we can't simply wrap executeSubmit in a promise and
                // _always_ dispatch SUBMIT_SUCCESS because isSubmitting would then always be false.
                // This would be fine in simple cases, but make it impossible to disable submit
                // buttons where people use callbacks or promises as side effects (which is basically
                // all of v1 Formik code). Instead, recall that we are inside of a promise chain already,
                //  so we can try/catch executeSubmit(), if it returns undefined, then just bail.
                // If there are errors, throw em. Otherwise, wrap executeSubmit in a promise and handle
                // cleanup of isSubmitting on behalf of the consumer.
                var promiseOrUndefined;
                try {
                    promiseOrUndefined = executeSubmit(); // Bail if it's sync, consumer is responsible for cleaning up
                    // via setSubmitting(false)
                    if (promiseOrUndefined === undefined) return;
                } catch (error) {
                    throw error;
                }
                return Promise.resolve(promiseOrUndefined).then(function(result) {
                    if (!!isMounted.current) dispatch({
                        type: 'SUBMIT_SUCCESS'
                    });
                    return result;
                })["catch"](function(_errors) {
                    if (!!isMounted.current) {
                        dispatch({
                            type: 'SUBMIT_FAILURE'
                        }); // This is a legit error rejected by the onSubmit fn
                        // so we don't want to break the promise chain
                        throw _errors;
                    }
                });
            } else if (!!isMounted.current) {
                // ^^^ Make sure Formik is still mounted before updating state
                dispatch({
                    type: 'SUBMIT_FAILURE'
                }); // throw combinedErrors;
                if (isInstanceOfError) throw combinedErrors;
            }
            return;
        });
    });
    var handleSubmit = useEventCallback(function(e) {
        if (e && e.preventDefault && isFunction(e.preventDefault)) e.preventDefault();
        if (e && e.stopPropagation && isFunction(e.stopPropagation)) e.stopPropagation();
         // Warn if form submission is triggered by a <button> without a
        var activeElement;
        submitForm()["catch"](function(reason) {
            console.warn("Warning: An unhandled error was caught from submitForm()", reason);
        });
    });
    var imperativeMethods = {
        resetForm: resetForm,
        validateForm: validateFormWithHighPriority,
        validateField: validateField,
        setErrors: setErrors,
        setFieldError: setFieldError,
        setFieldTouched: setFieldTouched,
        setFieldValue: setFieldValue,
        setStatus: setStatus,
        setSubmitting: setSubmitting,
        setTouched: setTouched,
        setValues: setValues,
        setFormikState: setFormikState,
        submitForm: submitForm
    };
    var executeSubmit = useEventCallback(function() {
        return onSubmit(state.values, imperativeMethods);
    });
    var handleReset = useEventCallback(function(e) {
        if (e && e.preventDefault && isFunction(e.preventDefault)) e.preventDefault();
        if (e && e.stopPropagation && isFunction(e.stopPropagation)) e.stopPropagation();
        resetForm();
    });
    var getFieldMeta = (0, $kc00y.useCallback)(function(name) {
        return {
            value: getIn(state.values, name),
            error: getIn(state.errors, name),
            touched: !!getIn(state.touched, name),
            initialValue: getIn(initialValues.current, name),
            initialTouched: !!getIn(initialTouched.current, name),
            initialError: getIn(initialErrors.current, name)
        };
    }, [
        state.errors,
        state.touched,
        state.values
    ]);
    var getFieldHelpers = (0, $kc00y.useCallback)(function(name) {
        return {
            setValue: function setValue(value, shouldValidate) {
                return setFieldValue(name, value, shouldValidate);
            },
            setTouched: function setTouched(value, shouldValidate) {
                return setFieldTouched(name, value, shouldValidate);
            },
            setError: function setError(value) {
                return setFieldError(name, value);
            }
        };
    }, [
        setFieldValue,
        setFieldTouched,
        setFieldError
    ]);
    var getFieldProps = (0, $kc00y.useCallback)(function(nameOrOptions) {
        var isAnObject = isObject(nameOrOptions);
        var name = isAnObject ? nameOrOptions.name : nameOrOptions;
        var valueState = getIn(state.values, name);
        var field = {
            name: name,
            value: valueState,
            onChange: handleChange,
            onBlur: handleBlur
        };
        if (isAnObject) {
            var type = nameOrOptions.type, valueProp = nameOrOptions.value, is = nameOrOptions.as, multiple = nameOrOptions.multiple;
            if (type === 'checkbox') {
                if (valueProp === undefined) field.checked = !!valueState;
                else {
                    field.checked = !!(Array.isArray(valueState) && ~valueState.indexOf(valueProp));
                    field.value = valueProp;
                }
            } else if (type === 'radio') {
                field.checked = valueState === valueProp;
                field.value = valueProp;
            } else if (is === 'select' && multiple) {
                field.value = field.value || [];
                field.multiple = true;
            }
        }
        return field;
    }, [
        handleBlur,
        handleChange,
        state.values
    ]);
    var dirty = (0, $kc00y.useMemo)(function() {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($31ATd)))(initialValues.current, state.values);
    }, [
        initialValues.current,
        state.values
    ]);
    var isValid = (0, $kc00y.useMemo)(function() {
        return typeof isInitialValid !== 'undefined' ? dirty ? state.errors && Object.keys(state.errors).length === 0 : isInitialValid !== false && isFunction(isInitialValid) ? isInitialValid(props) : isInitialValid : state.errors && Object.keys(state.errors).length === 0;
    }, [
        isInitialValid,
        dirty,
        state.errors,
        props
    ]);
    var ctx = _extends({}, state, {
        initialValues: initialValues.current,
        initialErrors: initialErrors.current,
        initialTouched: initialTouched.current,
        initialStatus: initialStatus.current,
        handleBlur: handleBlur,
        handleChange: handleChange,
        handleReset: handleReset,
        handleSubmit: handleSubmit,
        resetForm: resetForm,
        setErrors: setErrors,
        setFormikState: setFormikState,
        setFieldTouched: setFieldTouched,
        setFieldValue: setFieldValue,
        setFieldError: setFieldError,
        setStatus: setStatus,
        setSubmitting: setSubmitting,
        setTouched: setTouched,
        setValues: setValues,
        submitForm: submitForm,
        validateForm: validateFormWithHighPriority,
        validateField: validateField,
        isValid: isValid,
        dirty: dirty,
        unregisterField: unregisterField,
        registerField: registerField,
        getFieldProps: getFieldProps,
        getFieldMeta: getFieldMeta,
        getFieldHelpers: getFieldHelpers,
        validateOnBlur: validateOnBlur,
        validateOnChange: validateOnChange,
        validateOnMount: validateOnMount
    });
    return ctx;
}
function Formik(props) {
    var formikbag = useFormik(props);
    var component = props.component, children = props.children, render = props.render, innerRef = props.innerRef; // This allows folks to pass a ref to <Formik />
    (0, $kc00y.useImperativeHandle)(innerRef, function() {
        return formikbag;
    });
    return (0, $kc00y.createElement)(FormikProvider, {
        value: formikbag
    }, component ? (0, $kc00y.createElement)(component, formikbag) : render ? render(formikbag) : children // children come last, always called
     ? isFunction(children) ? children(formikbag) : !isEmptyChildren(children) ? (0, $kc00y.Children).only(children) : null : null);
}
function warnAboutMissingIdentifier(_ref4) {
    var htmlContent = _ref4.htmlContent, documentationAnchorLink = _ref4.documentationAnchorLink, handlerName = _ref4.handlerName;
    console.warn("Warning: Formik called `" + handlerName + "`, but you forgot to pass an `id` or `name` attribute to your input:\n    " + htmlContent + "\n    Formik cannot determine which value to update. For more info see https://formik.org/docs/api/formik#" + documentationAnchorLink + "\n  ");
}
/**
 * Transform Yup ValidationError to a more usable object
 */ function yupToFormErrors(yupError) {
    var errors = {};
    if (yupError.inner) {
        if (yupError.inner.length === 0) return setIn(errors, yupError.path, yupError.message);
        for(var _iterator = yupError.inner, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
            var _ref5;
            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref5 = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref5 = _i.value;
            }
            var err = _ref5;
            if (!getIn(errors, err.path)) errors = setIn(errors, err.path, err.message);
        }
    }
    return errors;
}
/**
 * Validate a yup schema.
 */ function validateYupSchema(values, schema, sync, context) {
    if (sync === void 0) sync = false;
    var normalizedValues = prepareDataForValidation(values);
    return schema[sync ? 'validateSync' : 'validate'](normalizedValues, {
        abortEarly: false,
        context: context || normalizedValues
    });
}
/**
 * Recursively prepare values.
 */ function prepareDataForValidation(values) {
    var data = Array.isArray(values) ? [] : {};
    for(var k in values)if (Object.prototype.hasOwnProperty.call(values, k)) {
        var key = String(k);
        if (Array.isArray(values[key]) === true) data[key] = values[key].map(function(value) {
            if (Array.isArray(value) === true || (0, $eBHEL.default)(value)) return prepareDataForValidation(value);
            else return value !== '' ? value : undefined;
        });
        else if ((0, $eBHEL.default)(values[key])) data[key] = prepareDataForValidation(values[key]);
        else data[key] = values[key] !== '' ? values[key] : undefined;
    }
    return data;
}
/**
 * deepmerge array merging algorithm
 * https://github.com/KyleAMathews/deepmerge#combine-array
 */ function arrayMerge(target, source, options) {
    var destination = target.slice();
    source.forEach(function merge(e, i) {
        if (typeof destination[i] === 'undefined') {
            var cloneRequested = options.clone !== false;
            var shouldClone = cloneRequested && options.isMergeableObject(e);
            destination[i] = shouldClone ? (0, $kMZku.default)(Array.isArray(e) ? [] : {}, e, options) : e;
        } else if (options.isMergeableObject(e)) destination[i] = (0, $kMZku.default)(target[i], e, options);
        else if (target.indexOf(e) === -1) destination.push(e);
    });
    return destination;
}
/** Return multi select values based on an array of options */ function getSelectedValues(options) {
    return Array.from(options).filter(function(el) {
        return el.selected;
    }).map(function(el) {
        return el.value;
    });
}
/** Return the next value for a checkbox */ function getValueForCheckbox(currentValue, checked, valueProp) {
    // If the current value was a boolean, return a boolean
    if (typeof currentValue === 'boolean') return Boolean(checked);
     // If the currentValue was not a boolean we want to return an array
    var currentArrayOfValues = [];
    var isValueInArray = false;
    var index = -1;
    if (!Array.isArray(currentValue)) {
        // eslint-disable-next-line eqeqeq
        if (!valueProp || valueProp == 'true' || valueProp == 'false') return Boolean(checked);
    } else {
        // If the current value is already an array, use it
        currentArrayOfValues = currentValue;
        index = currentValue.indexOf(valueProp);
        isValueInArray = index >= 0;
    } // If the checkbox was checked and the value is not already present in the aray we want to add the new value to the array of values
    if (checked && valueProp && !isValueInArray) return currentArrayOfValues.concat(valueProp);
     // If the checkbox was unchecked and the value is not in the array, simply return the already existing array of values
    if (!isValueInArray) return currentArrayOfValues;
     // If the checkbox was unchecked and the value is in the array, remove the value and return the array
    return currentArrayOfValues.slice(0, index).concat(currentArrayOfValues.slice(index + 1));
} // React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
// @see https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? (0, $kc00y.useLayoutEffect) : (0, $kc00y.useEffect);
function useEventCallback(fn) {
    var ref = (0, $kc00y.useRef)(fn); // we copy a ref to the callback scoped to the current state/props on each render
    useIsomorphicLayoutEffect(function() {
        ref.current = fn;
    });
    return (0, $kc00y.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return ref.current.apply(void 0, args);
    }, []);
}
function useField(propsOrFieldName) {
    var formik = useFormikContext();
    var getFieldProps = formik.getFieldProps, getFieldMeta = formik.getFieldMeta, getFieldHelpers = formik.getFieldHelpers, registerField = formik.registerField, unregisterField = formik.unregisterField;
    var isAnObject = isObject(propsOrFieldName); // Normalize propsOrFieldName to FieldHookConfig<Val>
    var props = isAnObject ? propsOrFieldName : {
        name: propsOrFieldName
    };
    var fieldName = props.name, validateFn = props.validate;
    (0, $kc00y.useEffect)(function() {
        if (fieldName) registerField(fieldName, {
            validate: validateFn
        });
        return function() {
            if (fieldName) unregisterField(fieldName);
        };
    }, [
        registerField,
        unregisterField,
        fieldName,
        validateFn
    ]);
    !fieldName && (0, $8I1rW.default)(false);
    var fieldHelpers = (0, $kc00y.useMemo)(function() {
        return getFieldHelpers(fieldName);
    }, [
        getFieldHelpers,
        fieldName
    ]);
    return [
        getFieldProps(props),
        getFieldMeta(fieldName),
        fieldHelpers
    ];
}
function Field(_ref) {
    var validate = _ref.validate, name = _ref.name, render = _ref.render, children = _ref.children, is = _ref.as, component = _ref.component, className = _ref.className, props = _objectWithoutPropertiesLoose(_ref, [
        "validate",
        "name",
        "render",
        "children",
        "as",
        "component",
        "className"
    ]);
    var _useFormikContext = useFormikContext(), formik = _objectWithoutPropertiesLoose(_useFormikContext, [
        "validate",
        "validationSchema"
    ]);
    var registerField = formik.registerField, unregisterField = formik.unregisterField;
    (0, $kc00y.useEffect)(function() {
        registerField(name, {
            validate: validate
        });
        return function() {
            unregisterField(name);
        };
    }, [
        registerField,
        unregisterField,
        name,
        validate
    ]);
    var field = formik.getFieldProps(_extends({
        name: name
    }, props));
    var meta = formik.getFieldMeta(name);
    var legacyBag = {
        field: field,
        form: formik
    };
    if (render) return render(_extends({}, legacyBag, {
        meta: meta
    }));
    if (isFunction(children)) return children(_extends({}, legacyBag, {
        meta: meta
    }));
    if (component) {
        // This behavior is backwards compat with earlier Formik 0.9 to 1.x
        if (typeof component === 'string') {
            var innerRef = props.innerRef, rest = _objectWithoutPropertiesLoose(props, [
                "innerRef"
            ]);
            return (0, $kc00y.createElement)(component, _extends({
                ref: innerRef
            }, field, rest, {
                className: className
            }), children);
        } // We don't pass `meta` for backwards compat
        return (0, $kc00y.createElement)(component, _extends({
            field: field,
            form: formik
        }, props, {
            className: className
        }), children);
    } // default to input here so we can check for both `as` and `children` above
    var asElement = is || 'input';
    if (typeof asElement === 'string') {
        var _innerRef = props.innerRef, _rest = _objectWithoutPropertiesLoose(props, [
            "innerRef"
        ]);
        return (0, $kc00y.createElement)(asElement, _extends({
            ref: _innerRef
        }, field, _rest, {
            className: className
        }), children);
    }
    return (0, $kc00y.createElement)(asElement, _extends({}, field, props, {
        className: className
    }), children);
}
var Form = /*#__PURE__*/ (0, $kc00y.forwardRef)(function(props, ref) {
    // iOS needs an "action" attribute for nice input: https://stackoverflow.com/a/39485162/406725
    // We default the action to "#" in case the preventDefault fails (just updates the URL hash)
    var action = props.action, rest = _objectWithoutPropertiesLoose(props, [
        "action"
    ]);
    var _action = action != null ? action : '#';
    var _useFormikContext = useFormikContext(), handleReset = _useFormikContext.handleReset, handleSubmit = _useFormikContext.handleSubmit;
    return (0, $kc00y.createElement)("form", _extends({
        onSubmit: handleSubmit,
        ref: ref,
        onReset: handleReset,
        action: _action
    }, rest));
});
Form.displayName = 'Form';
/**
 * A public higher-order component to access the imperative API
 */ function withFormik(_ref) {
    var _ref$mapPropsToValues = _ref.mapPropsToValues, mapPropsToValues = _ref$mapPropsToValues === void 0 ? function(vanillaProps) {
        var val = {};
        for(var k in vanillaProps)if (vanillaProps.hasOwnProperty(k) && typeof vanillaProps[k] !== 'function') // @todo TypeScript fix
        val[k] = vanillaProps[k];
        return val;
    } : _ref$mapPropsToValues, config = _objectWithoutPropertiesLoose(_ref, [
        "mapPropsToValues"
    ]);
    return function createFormik(Component$1) {
        var componentDisplayName = Component$1.displayName || Component$1.name || Component$1.constructor && Component$1.constructor.name || 'Component';
        /**
     * We need to use closures here for to provide the wrapped component's props to
     * the respective withFormik config methods.
     */ var C = /*#__PURE__*/ function(_React$Component) {
            _inheritsLoose(C, _React$Component);
            function C() {
                var _this;
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                _this = _React$Component.call.apply(_React$Component, [
                    this
                ].concat(args)) || this;
                _this.validate = function(values) {
                    return config.validate(values, _this.props);
                };
                _this.validationSchema = function() {
                    return isFunction(config.validationSchema) ? config.validationSchema(_this.props) : config.validationSchema;
                };
                _this.handleSubmit = function(values, actions) {
                    return config.handleSubmit(values, _extends({}, actions, {
                        props: _this.props
                    }));
                };
                _this.renderFormComponent = function(formikProps) {
                    return (0, $kc00y.createElement)(Component$1, _extends({}, _this.props, formikProps));
                };
                return _this;
            }
            var _proto = C.prototype;
            _proto.render = function render() {
                var _this$props = this.props, props = _objectWithoutPropertiesLoose(_this$props, [
                    "children"
                ]);
                return (0, $kc00y.createElement)(Formik, _extends({}, props, config, {
                    validate: config.validate && this.validate,
                    validationSchema: config.validationSchema && this.validationSchema,
                    initialValues: mapPropsToValues(this.props),
                    initialStatus: config.mapPropsToStatus && config.mapPropsToStatus(this.props),
                    initialErrors: config.mapPropsToErrors && config.mapPropsToErrors(this.props),
                    initialTouched: config.mapPropsToTouched && config.mapPropsToTouched(this.props),
                    onSubmit: this.handleSubmit,
                    children: this.renderFormComponent
                }));
            };
            return C;
        }((0, $kc00y.Component));
        C.displayName = "WithFormik(" + componentDisplayName + ")";
        return (0, (/*@__PURE__*/$parcel$interopDefault($j8Bf6)))(C, Component$1 // cast type to ComponentClass (even if SFC)
        );
    };
}
/**
 * Connect any component to Formik context, and inject as a prop called `formik`;
 * @param Comp React Component
 */ function connect(Comp) {
    var C = function C(props) {
        return (0, $kc00y.createElement)(FormikConsumer, null, function(formik) {
            !!!formik && (0, $8I1rW.default)(false);
            return (0, $kc00y.createElement)(Comp, _extends({}, props, {
                formik: formik
            }));
        });
    };
    var componentDisplayName = Comp.displayName || Comp.name || Comp.constructor && Comp.constructor.name || 'Component'; // Assign Comp to C.WrappedComponent so we can access the inner component in tests
    // For example, <Field.WrappedComponent /> gets us <FieldInner/>
    C.WrappedComponent = Comp;
    C.displayName = "FormikConnect(" + componentDisplayName + ")";
    return (0, (/*@__PURE__*/$parcel$interopDefault($j8Bf6)))(C, Comp // cast type to ComponentClass (even if SFC)
    );
}
/**
 * Some array helpers!
 */ var move = function move(array, from, to) {
    var copy = copyArrayLike(array);
    var value = copy[from];
    copy.splice(from, 1);
    copy.splice(to, 0, value);
    return copy;
};
var swap = function swap(arrayLike, indexA, indexB) {
    var copy = copyArrayLike(arrayLike);
    var a = copy[indexA];
    copy[indexA] = copy[indexB];
    copy[indexB] = a;
    return copy;
};
var insert = function insert(arrayLike, index, value) {
    var copy = copyArrayLike(arrayLike);
    copy.splice(index, 0, value);
    return copy;
};
var replace = function replace(arrayLike, index, value) {
    var copy = copyArrayLike(arrayLike);
    copy[index] = value;
    return copy;
};
var copyArrayLike = function copyArrayLike(arrayLike) {
    if (!arrayLike) return [];
    else if (Array.isArray(arrayLike)) return [].concat(arrayLike);
    else {
        var maxIndex = Object.keys(arrayLike).map(function(key) {
            return parseInt(key);
        }).reduce(function(max, el) {
            return el > max ? el : max;
        }, 0);
        return Array.from(_extends({}, arrayLike, {
            length: maxIndex + 1
        }));
    }
};
var createAlterationHandler = function createAlterationHandler(alteration, defaultFunction) {
    var fn = typeof alteration === 'function' ? alteration : defaultFunction;
    return function(data) {
        if (Array.isArray(data) || isObject(data)) {
            var clone = copyArrayLike(data);
            return fn(clone);
        } // This can be assumed to be a primitive, which
        // is a case for top level validation errors
        return data;
    };
};
var FieldArrayInner = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(FieldArrayInner, _React$Component);
    function FieldArrayInner(props) {
        var _this;
        _this = _React$Component.call(this, props) || this; // We need TypeScript generics on these, so we'll bind them in the constructor
        // @todo Fix TS 3.2.1
        _this.updateArrayField = function(fn, alterTouched, alterErrors) {
            var _this$props = _this.props, name = _this$props.name, setFormikState = _this$props.formik.setFormikState;
            setFormikState(function(prevState) {
                var updateErrors = createAlterationHandler(alterErrors, fn);
                var updateTouched = createAlterationHandler(alterTouched, fn); // values fn should be executed before updateErrors and updateTouched,
                // otherwise it causes an error with unshift.
                var values = setIn(prevState.values, name, fn(getIn(prevState.values, name)));
                var fieldError = alterErrors ? updateErrors(getIn(prevState.errors, name)) : undefined;
                var fieldTouched = alterTouched ? updateTouched(getIn(prevState.touched, name)) : undefined;
                if (isEmptyArray(fieldError)) fieldError = undefined;
                if (isEmptyArray(fieldTouched)) fieldTouched = undefined;
                return _extends({}, prevState, {
                    values: values,
                    errors: alterErrors ? setIn(prevState.errors, name, fieldError) : prevState.errors,
                    touched: alterTouched ? setIn(prevState.touched, name, fieldTouched) : prevState.touched
                });
            });
        };
        _this.push = function(value) {
            return _this.updateArrayField(function(arrayLike) {
                return [].concat(copyArrayLike(arrayLike), [
                    (0, $2AJmr.default)(value)
                ]);
            }, false, false);
        };
        _this.handlePush = function(value) {
            return function() {
                return _this.push(value);
            };
        };
        _this.swap = function(indexA, indexB) {
            return _this.updateArrayField(function(array) {
                return swap(array, indexA, indexB);
            }, true, true);
        };
        _this.handleSwap = function(indexA, indexB) {
            return function() {
                return _this.swap(indexA, indexB);
            };
        };
        _this.move = function(from, to) {
            return _this.updateArrayField(function(array) {
                return move(array, from, to);
            }, true, true);
        };
        _this.handleMove = function(from, to) {
            return function() {
                return _this.move(from, to);
            };
        };
        _this.insert = function(index, value) {
            return _this.updateArrayField(function(array) {
                return insert(array, index, value);
            }, function(array) {
                return insert(array, index, null);
            }, function(array) {
                return insert(array, index, null);
            });
        };
        _this.handleInsert = function(index, value) {
            return function() {
                return _this.insert(index, value);
            };
        };
        _this.replace = function(index, value) {
            return _this.updateArrayField(function(array) {
                return replace(array, index, value);
            }, false, false);
        };
        _this.handleReplace = function(index, value) {
            return function() {
                return _this.replace(index, value);
            };
        };
        _this.unshift = function(value) {
            var length = -1;
            _this.updateArrayField(function(array) {
                var arr = array ? [
                    value
                ].concat(array) : [
                    value
                ];
                length = arr.length;
                return arr;
            }, function(array) {
                return array ? [
                    null
                ].concat(array) : [
                    null
                ];
            }, function(array) {
                return array ? [
                    null
                ].concat(array) : [
                    null
                ];
            });
            return length;
        };
        _this.handleUnshift = function(value) {
            return function() {
                return _this.unshift(value);
            };
        };
        _this.handleRemove = function(index) {
            return function() {
                return _this.remove(index);
            };
        };
        _this.handlePop = function() {
            return function() {
                return _this.pop();
            };
        };
        _this.remove = _this.remove.bind(_assertThisInitialized(_this));
        _this.pop = _this.pop.bind(_assertThisInitialized(_this));
        return _this;
    }
    var _proto = FieldArrayInner.prototype;
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.validateOnChange && this.props.formik.validateOnChange && !(0, (/*@__PURE__*/$parcel$interopDefault($31ATd)))(getIn(prevProps.formik.values, prevProps.name), getIn(this.props.formik.values, this.props.name))) this.props.formik.validateForm(this.props.formik.values);
    };
    _proto.remove = function remove(index) {
        // We need to make sure we also remove relevant pieces of `touched` and `errors`
        var result;
        this.updateArrayField(function(array) {
            var copy = array ? copyArrayLike(array) : [];
            if (!result) result = copy[index];
            if (isFunction(copy.splice)) copy.splice(index, 1);
             // if the array only includes undefined values we have to return an empty array
            return isFunction(copy.every) ? copy.every(function(v) {
                return v === undefined;
            }) ? [] : copy : copy;
        }, true, true);
        return result;
    };
    _proto.pop = function pop() {
        // Remove relevant pieces of `touched` and `errors` too!
        var result;
        this.updateArrayField(function(array) {
            var tmp = array.slice();
            if (!result) result = tmp && tmp.pop && tmp.pop();
            return tmp;
        }, true, true);
        return result;
    };
    _proto.render = function render() {
        var arrayHelpers = {
            push: this.push,
            pop: this.pop,
            swap: this.swap,
            move: this.move,
            insert: this.insert,
            replace: this.replace,
            unshift: this.unshift,
            remove: this.remove,
            handlePush: this.handlePush,
            handlePop: this.handlePop,
            handleSwap: this.handleSwap,
            handleMove: this.handleMove,
            handleInsert: this.handleInsert,
            handleReplace: this.handleReplace,
            handleUnshift: this.handleUnshift,
            handleRemove: this.handleRemove
        };
        var _this$props2 = this.props, component = _this$props2.component, render = _this$props2.render, children = _this$props2.children, name = _this$props2.name, _this$props2$formik = _this$props2.formik, restOfFormik = _objectWithoutPropertiesLoose(_this$props2$formik, [
            "validate",
            "validationSchema"
        ]);
        var props = _extends({}, arrayHelpers, {
            form: restOfFormik,
            name: name
        });
        return component ? (0, $kc00y.createElement)(component, props) : render ? render(props) : children // children come last, always called
         ? typeof children === 'function' ? children(props) : !isEmptyChildren(children) ? (0, $kc00y.Children).only(children) : null : null;
    };
    return FieldArrayInner;
}((0, $kc00y.Component));
FieldArrayInner.defaultProps = {
    validateOnChange: true
};
var FieldArray = /*#__PURE__*/ connect(FieldArrayInner);
var ErrorMessageImpl = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(ErrorMessageImpl, _React$Component);
    function ErrorMessageImpl() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = ErrorMessageImpl.prototype;
    _proto.shouldComponentUpdate = function shouldComponentUpdate(props) {
        if (getIn(this.props.formik.errors, this.props.name) !== getIn(props.formik.errors, this.props.name) || getIn(this.props.formik.touched, this.props.name) !== getIn(props.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(props).length) return true;
        else return false;
    };
    _proto.render = function render() {
        var _this$props = this.props, component = _this$props.component, formik = _this$props.formik, render = _this$props.render, children = _this$props.children, name = _this$props.name, rest = _objectWithoutPropertiesLoose(_this$props, [
            "component",
            "formik",
            "render",
            "children",
            "name"
        ]);
        var touch = getIn(formik.touched, name);
        var error = getIn(formik.errors, name);
        return !!touch && !!error ? render ? isFunction(render) ? render(error) : null : children ? isFunction(children) ? children(error) : null : component ? (0, $kc00y.createElement)(component, rest, error) : error : null;
    };
    return ErrorMessageImpl;
}((0, $kc00y.Component));
var ErrorMessage = /*#__PURE__*/ connect(ErrorMessageImpl);
/**
 * Custom Field component for quickly hooking into Formik
 * context and wiring up forms.
 */ var FastFieldInner = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(FastFieldInner, _React$Component);
    function FastFieldInner(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        var render = props.render, children = props.children, component = props.component, is = props.as, name = props.name;
        !!render && (0, $8I1rW.default)(false);
        !!(component && render) && (0, $8I1rW.default)(false);
        !!(is && children && isFunction(children)) && (0, $8I1rW.default)(false);
        !!(component && children && isFunction(children)) && (0, $8I1rW.default)(false);
        !!(render && children && !isEmptyChildren(children)) && (0, $8I1rW.default)(false);
        return _this;
    }
    var _proto = FastFieldInner.prototype;
    _proto.shouldComponentUpdate = function shouldComponentUpdate(props) {
        if (this.props.shouldUpdate) return this.props.shouldUpdate(props, this.props);
        else if (props.name !== this.props.name || getIn(props.formik.values, this.props.name) !== getIn(this.props.formik.values, this.props.name) || getIn(props.formik.errors, this.props.name) !== getIn(this.props.formik.errors, this.props.name) || getIn(props.formik.touched, this.props.name) !== getIn(this.props.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(props).length || props.formik.isSubmitting !== this.props.formik.isSubmitting) return true;
        else return false;
    };
    _proto.componentDidMount = function componentDidMount() {
        // Register the Field with the parent Formik. Parent will cycle through
        // registered Field's validate fns right prior to submit
        this.props.formik.registerField(this.props.name, {
            validate: this.props.validate
        });
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.name !== prevProps.name) {
            this.props.formik.unregisterField(prevProps.name);
            this.props.formik.registerField(this.props.name, {
                validate: this.props.validate
            });
        }
        if (this.props.validate !== prevProps.validate) this.props.formik.registerField(this.props.name, {
            validate: this.props.validate
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.props.formik.unregisterField(this.props.name);
    };
    _proto.render = function render() {
        var _this$props = this.props, name = _this$props.name, render = _this$props.render, is = _this$props.as, children = _this$props.children, component = _this$props.component, formik = _this$props.formik, props = _objectWithoutPropertiesLoose(_this$props, [
            "validate",
            "name",
            "render",
            "as",
            "children",
            "component",
            "shouldUpdate",
            "formik"
        ]);
        var restOfFormik = _objectWithoutPropertiesLoose(formik, [
            "validate",
            "validationSchema"
        ]);
        var field = formik.getFieldProps(_extends({
            name: name
        }, props));
        var meta = {
            value: getIn(formik.values, name),
            error: getIn(formik.errors, name),
            touched: !!getIn(formik.touched, name),
            initialValue: getIn(formik.initialValues, name),
            initialTouched: !!getIn(formik.initialTouched, name),
            initialError: getIn(formik.initialErrors, name)
        };
        var bag = {
            field: field,
            meta: meta,
            form: restOfFormik
        };
        if (render) return render(bag);
        if (isFunction(children)) return children(bag);
        if (component) {
            // This behavior is backwards compat with earlier Formik 0.9 to 1.x
            if (typeof component === 'string') {
                var innerRef = props.innerRef, rest = _objectWithoutPropertiesLoose(props, [
                    "innerRef"
                ]);
                return (0, $kc00y.createElement)(component, _extends({
                    ref: innerRef
                }, field, rest), children);
            } // We don't pass `meta` for backwards compat
            return (0, $kc00y.createElement)(component, _extends({
                field: field,
                form: formik
            }, props), children);
        } // default to input here so we can check for both `as` and `children` above
        var asElement = is || 'input';
        if (typeof asElement === 'string') {
            var _innerRef = props.innerRef, _rest = _objectWithoutPropertiesLoose(props, [
                "innerRef"
            ]);
            return (0, $kc00y.createElement)(asElement, _extends({
                ref: _innerRef
            }, field, _rest), children);
        }
        return (0, $kc00y.createElement)(asElement, _extends({}, field, props), children);
    };
    return FastFieldInner;
}((0, $kc00y.Component));
var FastField = /*#__PURE__*/ connect(FastFieldInner);

});
parcelRegister("kMZku", function(module, exports) {

$parcel$export(module.exports, "default", () => $f227dd149481e5b0$export$2e2bcd8739ae039);
var $f227dd149481e5b0$var$isMergeableObject = function isMergeableObject(value) {
    return $f227dd149481e5b0$var$isNonNullObject(value) && !$f227dd149481e5b0$var$isSpecial(value);
};
function $f227dd149481e5b0$var$isNonNullObject(value) {
    return !!value && typeof value === 'object';
}
function $f227dd149481e5b0$var$isSpecial(value) {
    var stringValue = Object.prototype.toString.call(value);
    return stringValue === '[object RegExp]' || stringValue === '[object Date]' || $f227dd149481e5b0$var$isReactElement(value);
}
// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var $f227dd149481e5b0$var$canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var $f227dd149481e5b0$var$REACT_ELEMENT_TYPE = $f227dd149481e5b0$var$canUseSymbol ? Symbol.for('react.element') : 0xeac7;
function $f227dd149481e5b0$var$isReactElement(value) {
    return value.$$typeof === $f227dd149481e5b0$var$REACT_ELEMENT_TYPE;
}
function $f227dd149481e5b0$var$emptyTarget(val) {
    return Array.isArray(val) ? [] : {};
}
function $f227dd149481e5b0$var$cloneUnlessOtherwiseSpecified(value, options) {
    return options.clone !== false && options.isMergeableObject(value) ? $f227dd149481e5b0$var$deepmerge($f227dd149481e5b0$var$emptyTarget(value), value, options) : value;
}
function $f227dd149481e5b0$var$defaultArrayMerge(target, source, options) {
    return target.concat(source).map(function(element) {
        return $f227dd149481e5b0$var$cloneUnlessOtherwiseSpecified(element, options);
    });
}
function $f227dd149481e5b0$var$mergeObject(target, source, options) {
    var destination = {};
    if (options.isMergeableObject(target)) Object.keys(target).forEach(function(key) {
        destination[key] = $f227dd149481e5b0$var$cloneUnlessOtherwiseSpecified(target[key], options);
    });
    Object.keys(source).forEach(function(key) {
        if (!options.isMergeableObject(source[key]) || !target[key]) destination[key] = $f227dd149481e5b0$var$cloneUnlessOtherwiseSpecified(source[key], options);
        else destination[key] = $f227dd149481e5b0$var$deepmerge(target[key], source[key], options);
    });
    return destination;
}
function $f227dd149481e5b0$var$deepmerge(target, source, options) {
    options = options || {};
    options.arrayMerge = options.arrayMerge || $f227dd149481e5b0$var$defaultArrayMerge;
    options.isMergeableObject = options.isMergeableObject || $f227dd149481e5b0$var$isMergeableObject;
    var sourceIsArray = Array.isArray(source);
    var targetIsArray = Array.isArray(target);
    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
    if (!sourceAndTargetTypesMatch) return $f227dd149481e5b0$var$cloneUnlessOtherwiseSpecified(source, options);
    else if (sourceIsArray) return options.arrayMerge(target, source, options);
    else return $f227dd149481e5b0$var$mergeObject(target, source, options);
}
$f227dd149481e5b0$var$deepmerge.all = function deepmergeAll(array, options) {
    if (!Array.isArray(array)) throw new Error('first argument should be an array');
    return array.reduce(function(prev, next) {
        return $f227dd149481e5b0$var$deepmerge(prev, next, options);
    }, {});
};
var $f227dd149481e5b0$var$deepmerge_1 = $f227dd149481e5b0$var$deepmerge;
var $f227dd149481e5b0$export$2e2bcd8739ae039 = $f227dd149481e5b0$var$deepmerge_1;

});

parcelRegister("eBHEL", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa2662a89171ae10$export$2e2bcd8739ae039);

var $42LVW = parcelRequire("42LVW");

var $agrfU = parcelRequire("agrfU");

var $b8tfT = parcelRequire("b8tfT");
/** `Object#toString` result references. */ var $aa2662a89171ae10$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $aa2662a89171ae10$var$funcProto = Function.prototype, $aa2662a89171ae10$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $aa2662a89171ae10$var$funcToString = $aa2662a89171ae10$var$funcProto.toString;
/** Used to check objects for own properties. */ var $aa2662a89171ae10$var$hasOwnProperty = $aa2662a89171ae10$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $aa2662a89171ae10$var$objectCtorString = $aa2662a89171ae10$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $aa2662a89171ae10$var$isPlainObject(value) {
    if (!(0, $b8tfT.default)(value) || (0, $42LVW.default)(value) != $aa2662a89171ae10$var$objectTag) return false;
    var proto = (0, $agrfU.default)(value);
    if (proto === null) return true;
    var Ctor = $aa2662a89171ae10$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $aa2662a89171ae10$var$funcToString.call(Ctor) == $aa2662a89171ae10$var$objectCtorString;
}
var $aa2662a89171ae10$export$2e2bcd8739ae039 = $aa2662a89171ae10$var$isPlainObject;

});
parcelRegister("42LVW", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f1c87ee3d12b8f1$export$2e2bcd8739ae039);

var $cVOod = parcelRequire("cVOod");

var $edPn7 = parcelRequire("edPn7");

var $jn1Mc = parcelRequire("jn1Mc");
/** `Object#toString` result references. */ var $2f1c87ee3d12b8f1$var$nullTag = '[object Null]', $2f1c87ee3d12b8f1$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $2f1c87ee3d12b8f1$var$symToStringTag = (0, $cVOod.default) ? (0, $cVOod.default).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $2f1c87ee3d12b8f1$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $2f1c87ee3d12b8f1$var$undefinedTag : $2f1c87ee3d12b8f1$var$nullTag;
    return $2f1c87ee3d12b8f1$var$symToStringTag && $2f1c87ee3d12b8f1$var$symToStringTag in Object(value) ? (0, $edPn7.default)(value) : (0, $jn1Mc.default)(value);
}
var $2f1c87ee3d12b8f1$export$2e2bcd8739ae039 = $2f1c87ee3d12b8f1$var$baseGetTag;

});
parcelRegister("cVOod", function(module, exports) {

$parcel$export(module.exports, "default", () => $96a1e53ccc652a6a$export$2e2bcd8739ae039);

var $aQKD3 = parcelRequire("aQKD3");
/** Built-in value references. */ var $96a1e53ccc652a6a$var$Symbol = (0, $aQKD3.default).Symbol;
var $96a1e53ccc652a6a$export$2e2bcd8739ae039 = $96a1e53ccc652a6a$var$Symbol;

});
parcelRegister("aQKD3", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e62ee42f28f292a$export$2e2bcd8739ae039);

var $7oxg8 = parcelRequire("7oxg8");
/** Detect free variable `self`. */ var $7e62ee42f28f292a$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $7e62ee42f28f292a$var$root = (0, $7oxg8.default) || $7e62ee42f28f292a$var$freeSelf || Function('return this')();
var $7e62ee42f28f292a$export$2e2bcd8739ae039 = $7e62ee42f28f292a$var$root;

});
parcelRegister("7oxg8", function(module, exports) {

$parcel$export(module.exports, "default", () => $562492e835c708c5$export$2e2bcd8739ae039);
/** Detect free variable `global` from Node.js. */ var $562492e835c708c5$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var $562492e835c708c5$export$2e2bcd8739ae039 = $562492e835c708c5$var$freeGlobal;

});



parcelRegister("edPn7", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5aa20f7b95698c3$export$2e2bcd8739ae039);

var $cVOod = parcelRequire("cVOod");
/** Used for built-in method references. */ var $a5aa20f7b95698c3$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $a5aa20f7b95698c3$var$hasOwnProperty = $a5aa20f7b95698c3$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $a5aa20f7b95698c3$var$nativeObjectToString = $a5aa20f7b95698c3$var$objectProto.toString;
/** Built-in value references. */ var $a5aa20f7b95698c3$var$symToStringTag = (0, $cVOod.default) ? (0, $cVOod.default).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $a5aa20f7b95698c3$var$getRawTag(value) {
    var isOwn = $a5aa20f7b95698c3$var$hasOwnProperty.call(value, $a5aa20f7b95698c3$var$symToStringTag), tag = value[$a5aa20f7b95698c3$var$symToStringTag];
    try {
        value[$a5aa20f7b95698c3$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $a5aa20f7b95698c3$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$a5aa20f7b95698c3$var$symToStringTag] = tag;
        else delete value[$a5aa20f7b95698c3$var$symToStringTag];
    }
    return result;
}
var $a5aa20f7b95698c3$export$2e2bcd8739ae039 = $a5aa20f7b95698c3$var$getRawTag;

});

parcelRegister("jn1Mc", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1a18b158880239c$export$2e2bcd8739ae039);
/** Used for built-in method references. */ var $e1a18b158880239c$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $e1a18b158880239c$var$nativeObjectToString = $e1a18b158880239c$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $e1a18b158880239c$var$objectToString(value) {
    return $e1a18b158880239c$var$nativeObjectToString.call(value);
}
var $e1a18b158880239c$export$2e2bcd8739ae039 = $e1a18b158880239c$var$objectToString;

});


parcelRegister("agrfU", function(module, exports) {

$parcel$export(module.exports, "default", () => $77908a6195a5b3d0$export$2e2bcd8739ae039);

var $7NogN = parcelRequire("7NogN");
/** Built-in value references. */ var $77908a6195a5b3d0$var$getPrototype = (0, $7NogN.default)(Object.getPrototypeOf, Object);
var $77908a6195a5b3d0$export$2e2bcd8739ae039 = $77908a6195a5b3d0$var$getPrototype;

});
parcelRegister("7NogN", function(module, exports) {

$parcel$export(module.exports, "default", () => $5acfef831dc6d8d3$export$2e2bcd8739ae039);
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $5acfef831dc6d8d3$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
var $5acfef831dc6d8d3$export$2e2bcd8739ae039 = $5acfef831dc6d8d3$var$overArg;

});


parcelRegister("b8tfT", function(module, exports) {

$parcel$export(module.exports, "default", () => $81b722907b378862$export$2e2bcd8739ae039);
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $81b722907b378862$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
var $81b722907b378862$export$2e2bcd8739ae039 = $81b722907b378862$var$isObjectLike;

});


parcelRegister("2AJmr", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e32214946f434bc$export$2e2bcd8739ae039);

var $bslYV = parcelRequire("bslYV");
/** Used to compose bitmasks for cloning. */ var $1e32214946f434bc$var$CLONE_DEEP_FLAG = 1, $1e32214946f434bc$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $1e32214946f434bc$var$cloneDeep(value) {
    return (0, $bslYV.default)(value, $1e32214946f434bc$var$CLONE_DEEP_FLAG | $1e32214946f434bc$var$CLONE_SYMBOLS_FLAG);
}
var $1e32214946f434bc$export$2e2bcd8739ae039 = $1e32214946f434bc$var$cloneDeep;

});
parcelRegister("bslYV", function(module, exports) {

$parcel$export(module.exports, "default", () => $85735c5a52728133$export$2e2bcd8739ae039);

var $lFkAg = parcelRequire("lFkAg");

var $6lJDe = parcelRequire("6lJDe");

var $bmh9S = parcelRequire("bmh9S");

var $kjffV = parcelRequire("kjffV");

var $1PQuT = parcelRequire("1PQuT");

var $Irws4 = parcelRequire("Irws4");

var $fJXTB = parcelRequire("fJXTB");

var $512AJ = parcelRequire("512AJ");

var $8qOaq = parcelRequire("8qOaq");

var $lKcsa = parcelRequire("lKcsa");

var $ggB7P = parcelRequire("ggB7P");

var $fb5Xy = parcelRequire("fb5Xy");

var $35jdz = parcelRequire("35jdz");

var $6idGg = parcelRequire("6idGg");

var $ktsYn = parcelRequire("ktsYn");

var $i48KB = parcelRequire("i48KB");

var $21qzi = parcelRequire("21qzi");

var $jixRw = parcelRequire("jixRw");

var $aWBxg = parcelRequire("aWBxg");

var $7WLtA = parcelRequire("7WLtA");

var $lMs27 = parcelRequire("lMs27");

var $b8cgV = parcelRequire("b8cgV");
/** Used to compose bitmasks for cloning. */ var $85735c5a52728133$var$CLONE_DEEP_FLAG = 1, $85735c5a52728133$var$CLONE_FLAT_FLAG = 2, $85735c5a52728133$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $85735c5a52728133$var$argsTag = '[object Arguments]', $85735c5a52728133$var$arrayTag = '[object Array]', $85735c5a52728133$var$boolTag = '[object Boolean]', $85735c5a52728133$var$dateTag = '[object Date]', $85735c5a52728133$var$errorTag = '[object Error]', $85735c5a52728133$var$funcTag = '[object Function]', $85735c5a52728133$var$genTag = '[object GeneratorFunction]', $85735c5a52728133$var$mapTag = '[object Map]', $85735c5a52728133$var$numberTag = '[object Number]', $85735c5a52728133$var$objectTag = '[object Object]', $85735c5a52728133$var$regexpTag = '[object RegExp]', $85735c5a52728133$var$setTag = '[object Set]', $85735c5a52728133$var$stringTag = '[object String]', $85735c5a52728133$var$symbolTag = '[object Symbol]', $85735c5a52728133$var$weakMapTag = '[object WeakMap]';
var $85735c5a52728133$var$arrayBufferTag = '[object ArrayBuffer]', $85735c5a52728133$var$dataViewTag = '[object DataView]', $85735c5a52728133$var$float32Tag = '[object Float32Array]', $85735c5a52728133$var$float64Tag = '[object Float64Array]', $85735c5a52728133$var$int8Tag = '[object Int8Array]', $85735c5a52728133$var$int16Tag = '[object Int16Array]', $85735c5a52728133$var$int32Tag = '[object Int32Array]', $85735c5a52728133$var$uint8Tag = '[object Uint8Array]', $85735c5a52728133$var$uint8ClampedTag = '[object Uint8ClampedArray]', $85735c5a52728133$var$uint16Tag = '[object Uint16Array]', $85735c5a52728133$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $85735c5a52728133$var$cloneableTags = {};
$85735c5a52728133$var$cloneableTags[$85735c5a52728133$var$argsTag] = $85735c5a52728133$var$cloneableTags[$85735c5a52728133$var$arrayTag] = $85735c5a52728133$var$cloneableTags[$85735c5a52728133$var$arrayBufferTag] = $85735c5a52728133$var$cloneableTags[$85735c5a52728133$var$dataViewTag] = $85735c5a52728133$var$cloneableTags[$85735c5a52728133$var$boolTag] = $85735c5a52728133$var$cloneableTags[$85735c5a52728133$var$dateTag] = $85735c5a52728133$var$cloneableTags[$85735c5a52728133$var$float32Tag] = $85735c5a52728133$var$cloneableTags[$85735c5a52728133$var$float64Tag] = $85735c5a52728133$var$cloneableTags[$85735c5a52728133$var$int8Tag] = $85735c5a52728133$var$cloneableTags[$85735c5a52728133$var$int16Tag] = $85735c5a52728133$var$cloneableTags[$85735c5a52728133$var$int32Tag] = $85735c5a52728133$var$cloneableTags[$85735c5a52728133$var$mapTag] = $85735c5a52728133$var$cloneableTags[$85735c5a52728133$var$numberTag] = $85735c5a52728133$var$cloneableTags[$85735c5a52728133$var$objectTag] = $85735c5a52728133$var$cloneableTags[$85735c5a52728133$var$regexpTag] = $85735c5a52728133$var$cloneableTags[$85735c5a52728133$var$setTag] = $85735c5a52728133$var$cloneableTags[$85735c5a52728133$var$stringTag] = $85735c5a52728133$var$cloneableTags[$85735c5a52728133$var$symbolTag] = $85735c5a52728133$var$cloneableTags[$85735c5a52728133$var$uint8Tag] = $85735c5a52728133$var$cloneableTags[$85735c5a52728133$var$uint8ClampedTag] = $85735c5a52728133$var$cloneableTags[$85735c5a52728133$var$uint16Tag] = $85735c5a52728133$var$cloneableTags[$85735c5a52728133$var$uint32Tag] = true;
$85735c5a52728133$var$cloneableTags[$85735c5a52728133$var$errorTag] = $85735c5a52728133$var$cloneableTags[$85735c5a52728133$var$funcTag] = $85735c5a52728133$var$cloneableTags[$85735c5a52728133$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $85735c5a52728133$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $85735c5a52728133$var$CLONE_DEEP_FLAG, isFlat = bitmask & $85735c5a52728133$var$CLONE_FLAT_FLAG, isFull = bitmask & $85735c5a52728133$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!(0, $aWBxg.default)(value)) return value;
    var isArr = (0, $i48KB.default)(value);
    if (isArr) {
        result = (0, $35jdz.default)(value);
        if (!isDeep) return (0, $fJXTB.default)(value, result);
    } else {
        var tag = (0, $fb5Xy.default)(value), isFunc = tag == $85735c5a52728133$var$funcTag || tag == $85735c5a52728133$var$genTag;
        if ((0, $21qzi.default)(value)) return (0, $Irws4.default)(value, isDeep);
        if (tag == $85735c5a52728133$var$objectTag || tag == $85735c5a52728133$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : (0, $ktsYn.default)(value);
            if (!isDeep) return isFlat ? (0, $8qOaq.default)(value, (0, $1PQuT.default)(result, value)) : (0, $512AJ.default)(value, (0, $kjffV.default)(result, value));
        } else {
            if (!$85735c5a52728133$var$cloneableTags[tag]) return object ? value : {};
            result = (0, $6idGg.default)(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new (0, $lFkAg.default));
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ((0, $7WLtA.default)(value)) value.forEach(function(subValue) {
        result.add($85735c5a52728133$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ((0, $jixRw.default)(value)) value.forEach(function(subValue, key) {
        result.set(key, $85735c5a52728133$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? (0, $ggB7P.default) : (0, $lKcsa.default) : isFlat ? (0, $b8cgV.default) : (0, $lMs27.default);
    var props = isArr ? undefined : keysFunc(value);
    (0, $6lJDe.default)(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        (0, $bmh9S.default)(result, key, $85735c5a52728133$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
var $85735c5a52728133$export$2e2bcd8739ae039 = $85735c5a52728133$var$baseClone;

});
parcelRegister("lFkAg", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc5d64da7c4048b9$export$2e2bcd8739ae039);

var $PBKD1 = parcelRequire("PBKD1");

var $fh68K = parcelRequire("fh68K");

var $9Ayg3 = parcelRequire("9Ayg3");

var $6oJVY = parcelRequire("6oJVY");

var $2Ipyc = parcelRequire("2Ipyc");

var $jaoGy = parcelRequire("jaoGy");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $fc5d64da7c4048b9$var$Stack(entries) {
    var data = this.__data__ = new (0, $PBKD1.default)(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$fc5d64da7c4048b9$var$Stack.prototype.clear = (0, $fh68K.default);
$fc5d64da7c4048b9$var$Stack.prototype['delete'] = (0, $9Ayg3.default);
$fc5d64da7c4048b9$var$Stack.prototype.get = (0, $6oJVY.default);
$fc5d64da7c4048b9$var$Stack.prototype.has = (0, $2Ipyc.default);
$fc5d64da7c4048b9$var$Stack.prototype.set = (0, $jaoGy.default);
var $fc5d64da7c4048b9$export$2e2bcd8739ae039 = $fc5d64da7c4048b9$var$Stack;

});
parcelRegister("PBKD1", function(module, exports) {

$parcel$export(module.exports, "default", () => $09b20c1c6183aceb$export$2e2bcd8739ae039);

var $1Ugep = parcelRequire("1Ugep");

var $4vDTd = parcelRequire("4vDTd");

var $b5V4h = parcelRequire("b5V4h");

var $b8nMe = parcelRequire("b8nMe");

var $cCigt = parcelRequire("cCigt");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $09b20c1c6183aceb$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$09b20c1c6183aceb$var$ListCache.prototype.clear = (0, $1Ugep.default);
$09b20c1c6183aceb$var$ListCache.prototype['delete'] = (0, $4vDTd.default);
$09b20c1c6183aceb$var$ListCache.prototype.get = (0, $b5V4h.default);
$09b20c1c6183aceb$var$ListCache.prototype.has = (0, $b8nMe.default);
$09b20c1c6183aceb$var$ListCache.prototype.set = (0, $cCigt.default);
var $09b20c1c6183aceb$export$2e2bcd8739ae039 = $09b20c1c6183aceb$var$ListCache;

});
parcelRegister("1Ugep", function(module, exports) {

$parcel$export(module.exports, "default", () => $16379ca4287e7091$export$2e2bcd8739ae039);
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $16379ca4287e7091$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
var $16379ca4287e7091$export$2e2bcd8739ae039 = $16379ca4287e7091$var$listCacheClear;

});

parcelRegister("4vDTd", function(module, exports) {

$parcel$export(module.exports, "default", () => $3488ffe543a2677b$export$2e2bcd8739ae039);

var $289bT = parcelRequire("289bT");
/** Used for built-in method references. */ var $3488ffe543a2677b$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $3488ffe543a2677b$var$splice = $3488ffe543a2677b$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $3488ffe543a2677b$var$listCacheDelete(key) {
    var data = this.__data__, index = (0, $289bT.default)(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $3488ffe543a2677b$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
var $3488ffe543a2677b$export$2e2bcd8739ae039 = $3488ffe543a2677b$var$listCacheDelete;

});
parcelRegister("289bT", function(module, exports) {

$parcel$export(module.exports, "default", () => $18d3754113df963d$export$2e2bcd8739ae039);

var $ka1tK = parcelRequire("ka1tK");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $18d3754113df963d$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ((0, $ka1tK.default)(array[length][0], key)) return length;
    }
    return -1;
}
var $18d3754113df963d$export$2e2bcd8739ae039 = $18d3754113df963d$var$assocIndexOf;

});
parcelRegister("ka1tK", function(module, exports) {

$parcel$export(module.exports, "default", () => $ead5e37c46f2b6bc$export$2e2bcd8739ae039);
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $ead5e37c46f2b6bc$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
var $ead5e37c46f2b6bc$export$2e2bcd8739ae039 = $ead5e37c46f2b6bc$var$eq;

});



parcelRegister("b5V4h", function(module, exports) {

$parcel$export(module.exports, "default", () => $813c6ddc4e26bc27$export$2e2bcd8739ae039);

var $289bT = parcelRequire("289bT");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $813c6ddc4e26bc27$var$listCacheGet(key) {
    var data = this.__data__, index = (0, $289bT.default)(data, key);
    return index < 0 ? undefined : data[index][1];
}
var $813c6ddc4e26bc27$export$2e2bcd8739ae039 = $813c6ddc4e26bc27$var$listCacheGet;

});

parcelRegister("b8nMe", function(module, exports) {

$parcel$export(module.exports, "default", () => $81b2e2a4f10d40cc$export$2e2bcd8739ae039);

var $289bT = parcelRequire("289bT");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $81b2e2a4f10d40cc$var$listCacheHas(key) {
    return (0, $289bT.default)(this.__data__, key) > -1;
}
var $81b2e2a4f10d40cc$export$2e2bcd8739ae039 = $81b2e2a4f10d40cc$var$listCacheHas;

});

parcelRegister("cCigt", function(module, exports) {

$parcel$export(module.exports, "default", () => $92f733a1cbd298c5$export$2e2bcd8739ae039);

var $289bT = parcelRequire("289bT");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $92f733a1cbd298c5$var$listCacheSet(key, value) {
    var data = this.__data__, index = (0, $289bT.default)(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
var $92f733a1cbd298c5$export$2e2bcd8739ae039 = $92f733a1cbd298c5$var$listCacheSet;

});


parcelRegister("fh68K", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1ed34d81fdc9ca2$export$2e2bcd8739ae039);

var $PBKD1 = parcelRequire("PBKD1");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $b1ed34d81fdc9ca2$var$stackClear() {
    this.__data__ = new (0, $PBKD1.default);
    this.size = 0;
}
var $b1ed34d81fdc9ca2$export$2e2bcd8739ae039 = $b1ed34d81fdc9ca2$var$stackClear;

});

parcelRegister("9Ayg3", function(module, exports) {

$parcel$export(module.exports, "default", () => $6fb20cbe591414a1$export$2e2bcd8739ae039);
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $6fb20cbe591414a1$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
var $6fb20cbe591414a1$export$2e2bcd8739ae039 = $6fb20cbe591414a1$var$stackDelete;

});

parcelRegister("6oJVY", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a889d879c36cd52$export$2e2bcd8739ae039);
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $4a889d879c36cd52$var$stackGet(key) {
    return this.__data__.get(key);
}
var $4a889d879c36cd52$export$2e2bcd8739ae039 = $4a889d879c36cd52$var$stackGet;

});

parcelRegister("2Ipyc", function(module, exports) {

$parcel$export(module.exports, "default", () => $1fa382a81714a6ea$export$2e2bcd8739ae039);
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $1fa382a81714a6ea$var$stackHas(key) {
    return this.__data__.has(key);
}
var $1fa382a81714a6ea$export$2e2bcd8739ae039 = $1fa382a81714a6ea$var$stackHas;

});

parcelRegister("jaoGy", function(module, exports) {

$parcel$export(module.exports, "default", () => $df42198290ead1e2$export$2e2bcd8739ae039);

var $PBKD1 = parcelRequire("PBKD1");

var $eHZZw = parcelRequire("eHZZw");

var $8Ufnm = parcelRequire("8Ufnm");
/** Used as the size to enable large array optimizations. */ var $df42198290ead1e2$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $df42198290ead1e2$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof (0, $PBKD1.default)) {
        var pairs = data.__data__;
        if (!(0, $eHZZw.default) || pairs.length < $df42198290ead1e2$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new (0, $8Ufnm.default)(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
var $df42198290ead1e2$export$2e2bcd8739ae039 = $df42198290ead1e2$var$stackSet;

});
parcelRegister("eHZZw", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab552b0a7f560ad9$export$2e2bcd8739ae039);

var $9IkTg = parcelRequire("9IkTg");

var $aQKD3 = parcelRequire("aQKD3");
/* Built-in method references that are verified to be native. */ var $ab552b0a7f560ad9$var$Map = (0, $9IkTg.default)((0, $aQKD3.default), 'Map');
var $ab552b0a7f560ad9$export$2e2bcd8739ae039 = $ab552b0a7f560ad9$var$Map;

});
parcelRegister("9IkTg", function(module, exports) {

$parcel$export(module.exports, "default", () => $71286d7dc238b5c8$export$2e2bcd8739ae039);

var $3oFA5 = parcelRequire("3oFA5");

var $7rf8B = parcelRequire("7rf8B");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $71286d7dc238b5c8$var$getNative(object, key) {
    var value = (0, $7rf8B.default)(object, key);
    return (0, $3oFA5.default)(value) ? value : undefined;
}
var $71286d7dc238b5c8$export$2e2bcd8739ae039 = $71286d7dc238b5c8$var$getNative;

});
parcelRegister("3oFA5", function(module, exports) {

$parcel$export(module.exports, "default", () => $2793de1d576239b3$export$2e2bcd8739ae039);

var $mLztR = parcelRequire("mLztR");

var $kJ822 = parcelRequire("kJ822");

var $aWBxg = parcelRequire("aWBxg");

var $l1IED = parcelRequire("l1IED");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $2793de1d576239b3$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $2793de1d576239b3$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $2793de1d576239b3$var$funcProto = Function.prototype, $2793de1d576239b3$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $2793de1d576239b3$var$funcToString = $2793de1d576239b3$var$funcProto.toString;
/** Used to check objects for own properties. */ var $2793de1d576239b3$var$hasOwnProperty = $2793de1d576239b3$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $2793de1d576239b3$var$reIsNative = RegExp('^' + $2793de1d576239b3$var$funcToString.call($2793de1d576239b3$var$hasOwnProperty).replace($2793de1d576239b3$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $2793de1d576239b3$var$baseIsNative(value) {
    if (!(0, $aWBxg.default)(value) || (0, $kJ822.default)(value)) return false;
    var pattern = (0, $mLztR.default)(value) ? $2793de1d576239b3$var$reIsNative : $2793de1d576239b3$var$reIsHostCtor;
    return pattern.test((0, $l1IED.default)(value));
}
var $2793de1d576239b3$export$2e2bcd8739ae039 = $2793de1d576239b3$var$baseIsNative;

});
parcelRegister("mLztR", function(module, exports) {

$parcel$export(module.exports, "default", () => $0446f4d9f8aac06f$export$2e2bcd8739ae039);

var $42LVW = parcelRequire("42LVW");

var $aWBxg = parcelRequire("aWBxg");
/** `Object#toString` result references. */ var $0446f4d9f8aac06f$var$asyncTag = '[object AsyncFunction]', $0446f4d9f8aac06f$var$funcTag = '[object Function]', $0446f4d9f8aac06f$var$genTag = '[object GeneratorFunction]', $0446f4d9f8aac06f$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $0446f4d9f8aac06f$var$isFunction(value) {
    if (!(0, $aWBxg.default)(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = (0, $42LVW.default)(value);
    return tag == $0446f4d9f8aac06f$var$funcTag || tag == $0446f4d9f8aac06f$var$genTag || tag == $0446f4d9f8aac06f$var$asyncTag || tag == $0446f4d9f8aac06f$var$proxyTag;
}
var $0446f4d9f8aac06f$export$2e2bcd8739ae039 = $0446f4d9f8aac06f$var$isFunction;

});
parcelRegister("aWBxg", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f7c6fee675f6d2a$export$2e2bcd8739ae039);
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $7f7c6fee675f6d2a$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
var $7f7c6fee675f6d2a$export$2e2bcd8739ae039 = $7f7c6fee675f6d2a$var$isObject;

});


parcelRegister("kJ822", function(module, exports) {

$parcel$export(module.exports, "default", () => $f16e3d9a2891981c$export$2e2bcd8739ae039);

var $9W3lv = parcelRequire("9W3lv");
/** Used to detect methods masquerading as native. */ var $f16e3d9a2891981c$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec((0, $9W3lv.default) && (0, $9W3lv.default).keys && (0, $9W3lv.default).keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $f16e3d9a2891981c$var$isMasked(func) {
    return !!$f16e3d9a2891981c$var$maskSrcKey && $f16e3d9a2891981c$var$maskSrcKey in func;
}
var $f16e3d9a2891981c$export$2e2bcd8739ae039 = $f16e3d9a2891981c$var$isMasked;

});
parcelRegister("9W3lv", function(module, exports) {

$parcel$export(module.exports, "default", () => $73bc2043982af0ca$export$2e2bcd8739ae039);

var $aQKD3 = parcelRequire("aQKD3");
/** Used to detect overreaching core-js shims. */ var $73bc2043982af0ca$var$coreJsData = (0, $aQKD3.default)['__core-js_shared__'];
var $73bc2043982af0ca$export$2e2bcd8739ae039 = $73bc2043982af0ca$var$coreJsData;

});


parcelRegister("l1IED", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4ec546ab468a7dc$export$2e2bcd8739ae039);
/** Used for built-in method references. */ var $f4ec546ab468a7dc$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $f4ec546ab468a7dc$var$funcToString = $f4ec546ab468a7dc$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $f4ec546ab468a7dc$var$toSource(func) {
    if (func != null) {
        try {
            return $f4ec546ab468a7dc$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
var $f4ec546ab468a7dc$export$2e2bcd8739ae039 = $f4ec546ab468a7dc$var$toSource;

});


parcelRegister("7rf8B", function(module, exports) {

$parcel$export(module.exports, "default", () => $56a6cc0be8fd06b6$export$2e2bcd8739ae039);
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $56a6cc0be8fd06b6$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
var $56a6cc0be8fd06b6$export$2e2bcd8739ae039 = $56a6cc0be8fd06b6$var$getValue;

});



parcelRegister("8Ufnm", function(module, exports) {

$parcel$export(module.exports, "default", () => $67bf7b05312b11f0$export$2e2bcd8739ae039);

var $awj6d = parcelRequire("awj6d");

var $ax9wf = parcelRequire("ax9wf");

var $6L0Pz = parcelRequire("6L0Pz");

var $62NfI = parcelRequire("62NfI");

var $3NrLi = parcelRequire("3NrLi");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $67bf7b05312b11f0$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$67bf7b05312b11f0$var$MapCache.prototype.clear = (0, $awj6d.default);
$67bf7b05312b11f0$var$MapCache.prototype['delete'] = (0, $ax9wf.default);
$67bf7b05312b11f0$var$MapCache.prototype.get = (0, $6L0Pz.default);
$67bf7b05312b11f0$var$MapCache.prototype.has = (0, $62NfI.default);
$67bf7b05312b11f0$var$MapCache.prototype.set = (0, $3NrLi.default);
var $67bf7b05312b11f0$export$2e2bcd8739ae039 = $67bf7b05312b11f0$var$MapCache;

});
parcelRegister("awj6d", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a8bb547aedc70d2$export$2e2bcd8739ae039);

var $kWBDP = parcelRequire("kWBDP");

var $PBKD1 = parcelRequire("PBKD1");

var $eHZZw = parcelRequire("eHZZw");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $7a8bb547aedc70d2$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new (0, $kWBDP.default),
        'map': new ((0, $eHZZw.default) || (0, $PBKD1.default)),
        'string': new (0, $kWBDP.default)
    };
}
var $7a8bb547aedc70d2$export$2e2bcd8739ae039 = $7a8bb547aedc70d2$var$mapCacheClear;

});
parcelRegister("kWBDP", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3f66c3ce295bc56$export$2e2bcd8739ae039);

var $2fmLM = parcelRequire("2fmLM");

var $ic6Ds = parcelRequire("ic6Ds");

var $3fDDg = parcelRequire("3fDDg");

var $j57Yg = parcelRequire("j57Yg");

var $kbeuV = parcelRequire("kbeuV");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $f3f66c3ce295bc56$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$f3f66c3ce295bc56$var$Hash.prototype.clear = (0, $2fmLM.default);
$f3f66c3ce295bc56$var$Hash.prototype['delete'] = (0, $ic6Ds.default);
$f3f66c3ce295bc56$var$Hash.prototype.get = (0, $3fDDg.default);
$f3f66c3ce295bc56$var$Hash.prototype.has = (0, $j57Yg.default);
$f3f66c3ce295bc56$var$Hash.prototype.set = (0, $kbeuV.default);
var $f3f66c3ce295bc56$export$2e2bcd8739ae039 = $f3f66c3ce295bc56$var$Hash;

});
parcelRegister("2fmLM", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a2ea50d598846b8$export$2e2bcd8739ae039);

var $37pPU = parcelRequire("37pPU");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $1a2ea50d598846b8$var$hashClear() {
    this.__data__ = (0, $37pPU.default) ? (0, $37pPU.default)(null) : {};
    this.size = 0;
}
var $1a2ea50d598846b8$export$2e2bcd8739ae039 = $1a2ea50d598846b8$var$hashClear;

});
parcelRegister("37pPU", function(module, exports) {

$parcel$export(module.exports, "default", () => $2456111ab1cf6a6a$export$2e2bcd8739ae039);

var $9IkTg = parcelRequire("9IkTg");
/* Built-in method references that are verified to be native. */ var $2456111ab1cf6a6a$var$nativeCreate = (0, $9IkTg.default)(Object, 'create');
var $2456111ab1cf6a6a$export$2e2bcd8739ae039 = $2456111ab1cf6a6a$var$nativeCreate;

});


parcelRegister("ic6Ds", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3ee7e9e18d6d728$export$2e2bcd8739ae039);
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $d3ee7e9e18d6d728$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
var $d3ee7e9e18d6d728$export$2e2bcd8739ae039 = $d3ee7e9e18d6d728$var$hashDelete;

});

parcelRegister("3fDDg", function(module, exports) {

$parcel$export(module.exports, "default", () => $25e183f736d6b5c0$export$2e2bcd8739ae039);

var $37pPU = parcelRequire("37pPU");
/** Used to stand-in for `undefined` hash values. */ var $25e183f736d6b5c0$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $25e183f736d6b5c0$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $25e183f736d6b5c0$var$hasOwnProperty = $25e183f736d6b5c0$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $25e183f736d6b5c0$var$hashGet(key) {
    var data = this.__data__;
    if (0, $37pPU.default) {
        var result = data[key];
        return result === $25e183f736d6b5c0$var$HASH_UNDEFINED ? undefined : result;
    }
    return $25e183f736d6b5c0$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
var $25e183f736d6b5c0$export$2e2bcd8739ae039 = $25e183f736d6b5c0$var$hashGet;

});

parcelRegister("j57Yg", function(module, exports) {

$parcel$export(module.exports, "default", () => $de44aad9a531db03$export$2e2bcd8739ae039);

var $37pPU = parcelRequire("37pPU");
/** Used for built-in method references. */ var $de44aad9a531db03$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $de44aad9a531db03$var$hasOwnProperty = $de44aad9a531db03$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $de44aad9a531db03$var$hashHas(key) {
    var data = this.__data__;
    return (0, $37pPU.default) ? data[key] !== undefined : $de44aad9a531db03$var$hasOwnProperty.call(data, key);
}
var $de44aad9a531db03$export$2e2bcd8739ae039 = $de44aad9a531db03$var$hashHas;

});

parcelRegister("kbeuV", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb1014acae03df7a$export$2e2bcd8739ae039);

var $37pPU = parcelRequire("37pPU");
/** Used to stand-in for `undefined` hash values. */ var $eb1014acae03df7a$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $eb1014acae03df7a$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = (0, $37pPU.default) && value === undefined ? $eb1014acae03df7a$var$HASH_UNDEFINED : value;
    return this;
}
var $eb1014acae03df7a$export$2e2bcd8739ae039 = $eb1014acae03df7a$var$hashSet;

});



parcelRegister("ax9wf", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ab45ec4f71c3181$export$2e2bcd8739ae039);

var $gk39t = parcelRequire("gk39t");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $7ab45ec4f71c3181$var$mapCacheDelete(key) {
    var result = (0, $gk39t.default)(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
var $7ab45ec4f71c3181$export$2e2bcd8739ae039 = $7ab45ec4f71c3181$var$mapCacheDelete;

});
parcelRegister("gk39t", function(module, exports) {

$parcel$export(module.exports, "default", () => $be20f57e3f593a86$export$2e2bcd8739ae039);

var $gSwtd = parcelRequire("gSwtd");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $be20f57e3f593a86$var$getMapData(map, key) {
    var data = map.__data__;
    return (0, $gSwtd.default)(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
var $be20f57e3f593a86$export$2e2bcd8739ae039 = $be20f57e3f593a86$var$getMapData;

});
parcelRegister("gSwtd", function(module, exports) {

$parcel$export(module.exports, "default", () => $032bc9d01653d6df$export$2e2bcd8739ae039);
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $032bc9d01653d6df$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
var $032bc9d01653d6df$export$2e2bcd8739ae039 = $032bc9d01653d6df$var$isKeyable;

});



parcelRegister("6L0Pz", function(module, exports) {

$parcel$export(module.exports, "default", () => $4eb7c6d7581f095d$export$2e2bcd8739ae039);

var $gk39t = parcelRequire("gk39t");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $4eb7c6d7581f095d$var$mapCacheGet(key) {
    return (0, $gk39t.default)(this, key).get(key);
}
var $4eb7c6d7581f095d$export$2e2bcd8739ae039 = $4eb7c6d7581f095d$var$mapCacheGet;

});

parcelRegister("62NfI", function(module, exports) {

$parcel$export(module.exports, "default", () => $0122ba5ccccda5b8$export$2e2bcd8739ae039);

var $gk39t = parcelRequire("gk39t");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $0122ba5ccccda5b8$var$mapCacheHas(key) {
    return (0, $gk39t.default)(this, key).has(key);
}
var $0122ba5ccccda5b8$export$2e2bcd8739ae039 = $0122ba5ccccda5b8$var$mapCacheHas;

});

parcelRegister("3NrLi", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c3b7ba523d691e4$export$2e2bcd8739ae039);

var $gk39t = parcelRequire("gk39t");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $2c3b7ba523d691e4$var$mapCacheSet(key, value) {
    var data = (0, $gk39t.default)(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
var $2c3b7ba523d691e4$export$2e2bcd8739ae039 = $2c3b7ba523d691e4$var$mapCacheSet;

});




parcelRegister("6lJDe", function(module, exports) {

$parcel$export(module.exports, "default", () => $49f819c11a196270$export$2e2bcd8739ae039);
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $49f819c11a196270$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
var $49f819c11a196270$export$2e2bcd8739ae039 = $49f819c11a196270$var$arrayEach;

});

parcelRegister("bmh9S", function(module, exports) {

$parcel$export(module.exports, "default", () => $844f0f0b3d494fc3$export$2e2bcd8739ae039);

var $fQQT9 = parcelRequire("fQQT9");

var $ka1tK = parcelRequire("ka1tK");
/** Used for built-in method references. */ var $844f0f0b3d494fc3$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $844f0f0b3d494fc3$var$hasOwnProperty = $844f0f0b3d494fc3$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $844f0f0b3d494fc3$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($844f0f0b3d494fc3$var$hasOwnProperty.call(object, key) && (0, $ka1tK.default)(objValue, value)) || value === undefined && !(key in object)) (0, $fQQT9.default)(object, key, value);
}
var $844f0f0b3d494fc3$export$2e2bcd8739ae039 = $844f0f0b3d494fc3$var$assignValue;

});
parcelRegister("fQQT9", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8a4bce7221277e6$export$2e2bcd8739ae039);

var $ZeSOZ = parcelRequire("ZeSOZ");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $b8a4bce7221277e6$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && (0, $ZeSOZ.default)) (0, $ZeSOZ.default)(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
var $b8a4bce7221277e6$export$2e2bcd8739ae039 = $b8a4bce7221277e6$var$baseAssignValue;

});
parcelRegister("ZeSOZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b813e1dea152f4d$export$2e2bcd8739ae039);

var $9IkTg = parcelRequire("9IkTg");
var $0b813e1dea152f4d$var$defineProperty = function() {
    try {
        var func = (0, $9IkTg.default)(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
var $0b813e1dea152f4d$export$2e2bcd8739ae039 = $0b813e1dea152f4d$var$defineProperty;

});



parcelRegister("kjffV", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec916a7878d37bf1$export$2e2bcd8739ae039);

var $rxW2k = parcelRequire("rxW2k");

var $lMs27 = parcelRequire("lMs27");
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $ec916a7878d37bf1$var$baseAssign(object, source) {
    return object && (0, $rxW2k.default)(source, (0, $lMs27.default)(source), object);
}
var $ec916a7878d37bf1$export$2e2bcd8739ae039 = $ec916a7878d37bf1$var$baseAssign;

});
parcelRegister("rxW2k", function(module, exports) {

$parcel$export(module.exports, "default", () => $052cd8879beeb55d$export$2e2bcd8739ae039);

var $bmh9S = parcelRequire("bmh9S");

var $fQQT9 = parcelRequire("fQQT9");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $052cd8879beeb55d$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) (0, $fQQT9.default)(object, key, newValue);
        else (0, $bmh9S.default)(object, key, newValue);
    }
    return object;
}
var $052cd8879beeb55d$export$2e2bcd8739ae039 = $052cd8879beeb55d$var$copyObject;

});

parcelRegister("lMs27", function(module, exports) {

$parcel$export(module.exports, "default", () => $fdb3d3791f7e8825$export$2e2bcd8739ae039);

var $aZiQU = parcelRequire("aZiQU");

var $9l6PS = parcelRequire("9l6PS");

var $jSv8Q = parcelRequire("jSv8Q");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $fdb3d3791f7e8825$var$keys(object) {
    return (0, $jSv8Q.default)(object) ? (0, $aZiQU.default)(object) : (0, $9l6PS.default)(object);
}
var $fdb3d3791f7e8825$export$2e2bcd8739ae039 = $fdb3d3791f7e8825$var$keys;

});
parcelRegister("aZiQU", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ffe399847513755$export$2e2bcd8739ae039);

var $jPTde = parcelRequire("jPTde");

var $6VlWq = parcelRequire("6VlWq");

var $i48KB = parcelRequire("i48KB");

var $21qzi = parcelRequire("21qzi");

var $1LaAq = parcelRequire("1LaAq");

var $1c1iX = parcelRequire("1c1iX");
/** Used for built-in method references. */ var $7ffe399847513755$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7ffe399847513755$var$hasOwnProperty = $7ffe399847513755$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $7ffe399847513755$var$arrayLikeKeys(value, inherited) {
    var isArr = (0, $i48KB.default)(value), isArg = !isArr && (0, $6VlWq.default)(value), isBuff = !isArr && !isArg && (0, $21qzi.default)(value), isType = !isArr && !isArg && !isBuff && (0, $1c1iX.default)(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? (0, $jPTde.default)(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $7ffe399847513755$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    (0, $1LaAq.default)(key, length)))) result.push(key);
    return result;
}
var $7ffe399847513755$export$2e2bcd8739ae039 = $7ffe399847513755$var$arrayLikeKeys;

});
parcelRegister("jPTde", function(module, exports) {

$parcel$export(module.exports, "default", () => $e70d9bc4e0f977ad$export$2e2bcd8739ae039);
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $e70d9bc4e0f977ad$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
var $e70d9bc4e0f977ad$export$2e2bcd8739ae039 = $e70d9bc4e0f977ad$var$baseTimes;

});

parcelRegister("6VlWq", function(module, exports) {

$parcel$export(module.exports, "default", () => $50a916102e689610$export$2e2bcd8739ae039);

var $2rAG0 = parcelRequire("2rAG0");

var $b8tfT = parcelRequire("b8tfT");
/** Used for built-in method references. */ var $50a916102e689610$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $50a916102e689610$var$hasOwnProperty = $50a916102e689610$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $50a916102e689610$var$propertyIsEnumerable = $50a916102e689610$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $50a916102e689610$var$isArguments = (0, $2rAG0.default)(function() {
    return arguments;
}()) ? (0, $2rAG0.default) : function(value) {
    return (0, $b8tfT.default)(value) && $50a916102e689610$var$hasOwnProperty.call(value, 'callee') && !$50a916102e689610$var$propertyIsEnumerable.call(value, 'callee');
};
var $50a916102e689610$export$2e2bcd8739ae039 = $50a916102e689610$var$isArguments;

});
parcelRegister("2rAG0", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c7a8d9542e5bc00$export$2e2bcd8739ae039);

var $42LVW = parcelRequire("42LVW");

var $b8tfT = parcelRequire("b8tfT");
/** `Object#toString` result references. */ var $1c7a8d9542e5bc00$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $1c7a8d9542e5bc00$var$baseIsArguments(value) {
    return (0, $b8tfT.default)(value) && (0, $42LVW.default)(value) == $1c7a8d9542e5bc00$var$argsTag;
}
var $1c7a8d9542e5bc00$export$2e2bcd8739ae039 = $1c7a8d9542e5bc00$var$baseIsArguments;

});


parcelRegister("i48KB", function(module, exports) {

$parcel$export(module.exports, "default", () => $d26f636d2950faca$export$2e2bcd8739ae039);
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $d26f636d2950faca$var$isArray = Array.isArray;
var $d26f636d2950faca$export$2e2bcd8739ae039 = $d26f636d2950faca$var$isArray;

});

parcelRegister("21qzi", function(module, exports) {

$parcel$export(module.exports, "default", () => $179048a92e445af5$export$2e2bcd8739ae039);

var $aQKD3 = parcelRequire("aQKD3");

var $8hw76 = parcelRequire("8hw76");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $aQKD3.default).Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || (0, $8hw76.default);
var $179048a92e445af5$export$2e2bcd8739ae039 = isBuffer;

});
parcelRegister("8hw76", function(module, exports) {

$parcel$export(module.exports, "default", () => $6078d25e64437bbe$export$2e2bcd8739ae039);
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $6078d25e64437bbe$var$stubFalse() {
    return false;
}
var $6078d25e64437bbe$export$2e2bcd8739ae039 = $6078d25e64437bbe$var$stubFalse;

});


parcelRegister("1LaAq", function(module, exports) {

$parcel$export(module.exports, "default", () => $148264838403bce3$export$2e2bcd8739ae039);
/** Used as references for various `Number` constants. */ var $148264838403bce3$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $148264838403bce3$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $148264838403bce3$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $148264838403bce3$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $148264838403bce3$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
var $148264838403bce3$export$2e2bcd8739ae039 = $148264838403bce3$var$isIndex;

});

parcelRegister("1c1iX", function(module, exports) {

$parcel$export(module.exports, "default", () => $0de7ec8659d15a34$export$2e2bcd8739ae039);

var $8lkIn = parcelRequire("8lkIn");

var $gZMaq = parcelRequire("gZMaq");

var $6c0uc = parcelRequire("6c0uc");
/* Node.js helper references. */ var $0de7ec8659d15a34$var$nodeIsTypedArray = (0, $6c0uc.default) && (0, $6c0uc.default).isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $0de7ec8659d15a34$var$isTypedArray = $0de7ec8659d15a34$var$nodeIsTypedArray ? (0, $gZMaq.default)($0de7ec8659d15a34$var$nodeIsTypedArray) : (0, $8lkIn.default);
var $0de7ec8659d15a34$export$2e2bcd8739ae039 = $0de7ec8659d15a34$var$isTypedArray;

});
parcelRegister("8lkIn", function(module, exports) {

$parcel$export(module.exports, "default", () => $61305a6972738d66$export$2e2bcd8739ae039);

var $42LVW = parcelRequire("42LVW");

var $cbQxF = parcelRequire("cbQxF");

var $b8tfT = parcelRequire("b8tfT");
/** `Object#toString` result references. */ var $61305a6972738d66$var$argsTag = '[object Arguments]', $61305a6972738d66$var$arrayTag = '[object Array]', $61305a6972738d66$var$boolTag = '[object Boolean]', $61305a6972738d66$var$dateTag = '[object Date]', $61305a6972738d66$var$errorTag = '[object Error]', $61305a6972738d66$var$funcTag = '[object Function]', $61305a6972738d66$var$mapTag = '[object Map]', $61305a6972738d66$var$numberTag = '[object Number]', $61305a6972738d66$var$objectTag = '[object Object]', $61305a6972738d66$var$regexpTag = '[object RegExp]', $61305a6972738d66$var$setTag = '[object Set]', $61305a6972738d66$var$stringTag = '[object String]', $61305a6972738d66$var$weakMapTag = '[object WeakMap]';
var $61305a6972738d66$var$arrayBufferTag = '[object ArrayBuffer]', $61305a6972738d66$var$dataViewTag = '[object DataView]', $61305a6972738d66$var$float32Tag = '[object Float32Array]', $61305a6972738d66$var$float64Tag = '[object Float64Array]', $61305a6972738d66$var$int8Tag = '[object Int8Array]', $61305a6972738d66$var$int16Tag = '[object Int16Array]', $61305a6972738d66$var$int32Tag = '[object Int32Array]', $61305a6972738d66$var$uint8Tag = '[object Uint8Array]', $61305a6972738d66$var$uint8ClampedTag = '[object Uint8ClampedArray]', $61305a6972738d66$var$uint16Tag = '[object Uint16Array]', $61305a6972738d66$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $61305a6972738d66$var$typedArrayTags = {};
$61305a6972738d66$var$typedArrayTags[$61305a6972738d66$var$float32Tag] = $61305a6972738d66$var$typedArrayTags[$61305a6972738d66$var$float64Tag] = $61305a6972738d66$var$typedArrayTags[$61305a6972738d66$var$int8Tag] = $61305a6972738d66$var$typedArrayTags[$61305a6972738d66$var$int16Tag] = $61305a6972738d66$var$typedArrayTags[$61305a6972738d66$var$int32Tag] = $61305a6972738d66$var$typedArrayTags[$61305a6972738d66$var$uint8Tag] = $61305a6972738d66$var$typedArrayTags[$61305a6972738d66$var$uint8ClampedTag] = $61305a6972738d66$var$typedArrayTags[$61305a6972738d66$var$uint16Tag] = $61305a6972738d66$var$typedArrayTags[$61305a6972738d66$var$uint32Tag] = true;
$61305a6972738d66$var$typedArrayTags[$61305a6972738d66$var$argsTag] = $61305a6972738d66$var$typedArrayTags[$61305a6972738d66$var$arrayTag] = $61305a6972738d66$var$typedArrayTags[$61305a6972738d66$var$arrayBufferTag] = $61305a6972738d66$var$typedArrayTags[$61305a6972738d66$var$boolTag] = $61305a6972738d66$var$typedArrayTags[$61305a6972738d66$var$dataViewTag] = $61305a6972738d66$var$typedArrayTags[$61305a6972738d66$var$dateTag] = $61305a6972738d66$var$typedArrayTags[$61305a6972738d66$var$errorTag] = $61305a6972738d66$var$typedArrayTags[$61305a6972738d66$var$funcTag] = $61305a6972738d66$var$typedArrayTags[$61305a6972738d66$var$mapTag] = $61305a6972738d66$var$typedArrayTags[$61305a6972738d66$var$numberTag] = $61305a6972738d66$var$typedArrayTags[$61305a6972738d66$var$objectTag] = $61305a6972738d66$var$typedArrayTags[$61305a6972738d66$var$regexpTag] = $61305a6972738d66$var$typedArrayTags[$61305a6972738d66$var$setTag] = $61305a6972738d66$var$typedArrayTags[$61305a6972738d66$var$stringTag] = $61305a6972738d66$var$typedArrayTags[$61305a6972738d66$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $61305a6972738d66$var$baseIsTypedArray(value) {
    return (0, $b8tfT.default)(value) && (0, $cbQxF.default)(value.length) && !!$61305a6972738d66$var$typedArrayTags[(0, $42LVW.default)(value)];
}
var $61305a6972738d66$export$2e2bcd8739ae039 = $61305a6972738d66$var$baseIsTypedArray;

});
parcelRegister("cbQxF", function(module, exports) {

$parcel$export(module.exports, "default", () => $8dff44dd4a8469a3$export$2e2bcd8739ae039);
/** Used as references for various `Number` constants. */ var $8dff44dd4a8469a3$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $8dff44dd4a8469a3$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $8dff44dd4a8469a3$var$MAX_SAFE_INTEGER;
}
var $8dff44dd4a8469a3$export$2e2bcd8739ae039 = $8dff44dd4a8469a3$var$isLength;

});


parcelRegister("gZMaq", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5f7b4d4204d7b52$export$2e2bcd8739ae039);
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $c5f7b4d4204d7b52$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
var $c5f7b4d4204d7b52$export$2e2bcd8739ae039 = $c5f7b4d4204d7b52$var$baseUnary;

});

parcelRegister("6c0uc", function(module, exports) {

$parcel$export(module.exports, "default", () => $48243d9229376f04$export$2e2bcd8739ae039);

var $7oxg8 = parcelRequire("7oxg8");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && (0, $7oxg8.default).process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
var $48243d9229376f04$export$2e2bcd8739ae039 = nodeUtil;

});



parcelRegister("9l6PS", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ccb60a80ce34991$export$2e2bcd8739ae039);

var $89J4v = parcelRequire("89J4v");

var $hGyIi = parcelRequire("hGyIi");
/** Used for built-in method references. */ var $6ccb60a80ce34991$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $6ccb60a80ce34991$var$hasOwnProperty = $6ccb60a80ce34991$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $6ccb60a80ce34991$var$baseKeys(object) {
    if (!(0, $89J4v.default)(object)) return (0, $hGyIi.default)(object);
    var result = [];
    for(var key in Object(object))if ($6ccb60a80ce34991$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
var $6ccb60a80ce34991$export$2e2bcd8739ae039 = $6ccb60a80ce34991$var$baseKeys;

});
parcelRegister("89J4v", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f02204be2f703be$export$2e2bcd8739ae039);
/** Used for built-in method references. */ var $5f02204be2f703be$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $5f02204be2f703be$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $5f02204be2f703be$var$objectProto;
    return value === proto;
}
var $5f02204be2f703be$export$2e2bcd8739ae039 = $5f02204be2f703be$var$isPrototype;

});

parcelRegister("hGyIi", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce014948c98adc89$export$2e2bcd8739ae039);

var $7NogN = parcelRequire("7NogN");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $ce014948c98adc89$var$nativeKeys = (0, $7NogN.default)(Object.keys, Object);
var $ce014948c98adc89$export$2e2bcd8739ae039 = $ce014948c98adc89$var$nativeKeys;

});


parcelRegister("jSv8Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $e78b37933ed3e1a8$export$2e2bcd8739ae039);

var $mLztR = parcelRequire("mLztR");

var $cbQxF = parcelRequire("cbQxF");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $e78b37933ed3e1a8$var$isArrayLike(value) {
    return value != null && (0, $cbQxF.default)(value.length) && !(0, $mLztR.default)(value);
}
var $e78b37933ed3e1a8$export$2e2bcd8739ae039 = $e78b37933ed3e1a8$var$isArrayLike;

});



parcelRegister("1PQuT", function(module, exports) {

$parcel$export(module.exports, "default", () => $156346bdc00dde11$export$2e2bcd8739ae039);

var $rxW2k = parcelRequire("rxW2k");

var $b8cgV = parcelRequire("b8cgV");
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $156346bdc00dde11$var$baseAssignIn(object, source) {
    return object && (0, $rxW2k.default)(source, (0, $b8cgV.default)(source), object);
}
var $156346bdc00dde11$export$2e2bcd8739ae039 = $156346bdc00dde11$var$baseAssignIn;

});
parcelRegister("b8cgV", function(module, exports) {

$parcel$export(module.exports, "default", () => $81a9f601362b0f7a$export$2e2bcd8739ae039);

var $aZiQU = parcelRequire("aZiQU");

var $3gqvP = parcelRequire("3gqvP");

var $jSv8Q = parcelRequire("jSv8Q");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $81a9f601362b0f7a$var$keysIn(object) {
    return (0, $jSv8Q.default)(object) ? (0, $aZiQU.default)(object, true) : (0, $3gqvP.default)(object);
}
var $81a9f601362b0f7a$export$2e2bcd8739ae039 = $81a9f601362b0f7a$var$keysIn;

});
parcelRegister("3gqvP", function(module, exports) {

$parcel$export(module.exports, "default", () => $26076e8c9655715c$export$2e2bcd8739ae039);

var $aWBxg = parcelRequire("aWBxg");

var $89J4v = parcelRequire("89J4v");

var $9fCy7 = parcelRequire("9fCy7");
/** Used for built-in method references. */ var $26076e8c9655715c$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $26076e8c9655715c$var$hasOwnProperty = $26076e8c9655715c$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $26076e8c9655715c$var$baseKeysIn(object) {
    if (!(0, $aWBxg.default)(object)) return (0, $9fCy7.default)(object);
    var isProto = (0, $89J4v.default)(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !$26076e8c9655715c$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
var $26076e8c9655715c$export$2e2bcd8739ae039 = $26076e8c9655715c$var$baseKeysIn;

});
parcelRegister("9fCy7", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bc36ad68c747927$export$2e2bcd8739ae039);
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $6bc36ad68c747927$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
var $6bc36ad68c747927$export$2e2bcd8739ae039 = $6bc36ad68c747927$var$nativeKeysIn;

});




parcelRegister("Irws4", function(module, exports) {

$parcel$export(module.exports, "default", () => $0859758db942a8f2$export$2e2bcd8739ae039);

var $aQKD3 = parcelRequire("aQKD3");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $aQKD3.default).Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
var $0859758db942a8f2$export$2e2bcd8739ae039 = cloneBuffer;

});

parcelRegister("fJXTB", function(module, exports) {

$parcel$export(module.exports, "default", () => $b759850802116698$export$2e2bcd8739ae039);
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $b759850802116698$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
var $b759850802116698$export$2e2bcd8739ae039 = $b759850802116698$var$copyArray;

});

parcelRegister("512AJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a6f0e58ba4d2086$export$2e2bcd8739ae039);

var $rxW2k = parcelRequire("rxW2k");

var $234iA = parcelRequire("234iA");
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $3a6f0e58ba4d2086$var$copySymbols(source, object) {
    return (0, $rxW2k.default)(source, (0, $234iA.default)(source), object);
}
var $3a6f0e58ba4d2086$export$2e2bcd8739ae039 = $3a6f0e58ba4d2086$var$copySymbols;

});
parcelRegister("234iA", function(module, exports) {

$parcel$export(module.exports, "default", () => $17df3241a2cfbc35$export$2e2bcd8739ae039);

var $gHhgi = parcelRequire("gHhgi");

var $jT1Cc = parcelRequire("jT1Cc");
/** Used for built-in method references. */ var $17df3241a2cfbc35$var$objectProto = Object.prototype;
/** Built-in value references. */ var $17df3241a2cfbc35$var$propertyIsEnumerable = $17df3241a2cfbc35$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $17df3241a2cfbc35$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $17df3241a2cfbc35$var$getSymbols = !$17df3241a2cfbc35$var$nativeGetSymbols ? (0, $jT1Cc.default) : function(object) {
    if (object == null) return [];
    object = Object(object);
    return (0, $gHhgi.default)($17df3241a2cfbc35$var$nativeGetSymbols(object), function(symbol) {
        return $17df3241a2cfbc35$var$propertyIsEnumerable.call(object, symbol);
    });
};
var $17df3241a2cfbc35$export$2e2bcd8739ae039 = $17df3241a2cfbc35$var$getSymbols;

});
parcelRegister("gHhgi", function(module, exports) {

$parcel$export(module.exports, "default", () => $c27e0d599a7094a8$export$2e2bcd8739ae039);
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $c27e0d599a7094a8$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
var $c27e0d599a7094a8$export$2e2bcd8739ae039 = $c27e0d599a7094a8$var$arrayFilter;

});

parcelRegister("jT1Cc", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7a4681ba83cbc4b$export$2e2bcd8739ae039);
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $e7a4681ba83cbc4b$var$stubArray() {
    return [];
}
var $e7a4681ba83cbc4b$export$2e2bcd8739ae039 = $e7a4681ba83cbc4b$var$stubArray;

});



parcelRegister("8qOaq", function(module, exports) {

$parcel$export(module.exports, "default", () => $01958b025d8ad92d$export$2e2bcd8739ae039);

var $rxW2k = parcelRequire("rxW2k");

var $XPKYO = parcelRequire("XPKYO");
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $01958b025d8ad92d$var$copySymbolsIn(source, object) {
    return (0, $rxW2k.default)(source, (0, $XPKYO.default)(source), object);
}
var $01958b025d8ad92d$export$2e2bcd8739ae039 = $01958b025d8ad92d$var$copySymbolsIn;

});
parcelRegister("XPKYO", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b3da89cff840e0a$export$2e2bcd8739ae039);

var $a1KEh = parcelRequire("a1KEh");

var $agrfU = parcelRequire("agrfU");

var $234iA = parcelRequire("234iA");

var $jT1Cc = parcelRequire("jT1Cc");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $0b3da89cff840e0a$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $0b3da89cff840e0a$var$getSymbolsIn = !$0b3da89cff840e0a$var$nativeGetSymbols ? (0, $jT1Cc.default) : function(object) {
    var result = [];
    while(object){
        (0, $a1KEh.default)(result, (0, $234iA.default)(object));
        object = (0, $agrfU.default)(object);
    }
    return result;
};
var $0b3da89cff840e0a$export$2e2bcd8739ae039 = $0b3da89cff840e0a$var$getSymbolsIn;

});
parcelRegister("a1KEh", function(module, exports) {

$parcel$export(module.exports, "default", () => $74ce2ed71c580581$export$2e2bcd8739ae039);
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $74ce2ed71c580581$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
var $74ce2ed71c580581$export$2e2bcd8739ae039 = $74ce2ed71c580581$var$arrayPush;

});



parcelRegister("lKcsa", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd478dd6414a7998$export$2e2bcd8739ae039);

var $j2Wv7 = parcelRequire("j2Wv7");

var $234iA = parcelRequire("234iA");

var $lMs27 = parcelRequire("lMs27");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $fd478dd6414a7998$var$getAllKeys(object) {
    return (0, $j2Wv7.default)(object, (0, $lMs27.default), (0, $234iA.default));
}
var $fd478dd6414a7998$export$2e2bcd8739ae039 = $fd478dd6414a7998$var$getAllKeys;

});
parcelRegister("j2Wv7", function(module, exports) {

$parcel$export(module.exports, "default", () => $dddb9544984246ec$export$2e2bcd8739ae039);

var $a1KEh = parcelRequire("a1KEh");

var $i48KB = parcelRequire("i48KB");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $dddb9544984246ec$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return (0, $i48KB.default)(object) ? result : (0, $a1KEh.default)(result, symbolsFunc(object));
}
var $dddb9544984246ec$export$2e2bcd8739ae039 = $dddb9544984246ec$var$baseGetAllKeys;

});


parcelRegister("ggB7P", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd7af0419c32cb59$export$2e2bcd8739ae039);

var $j2Wv7 = parcelRequire("j2Wv7");

var $XPKYO = parcelRequire("XPKYO");

var $b8cgV = parcelRequire("b8cgV");
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $bd7af0419c32cb59$var$getAllKeysIn(object) {
    return (0, $j2Wv7.default)(object, (0, $b8cgV.default), (0, $XPKYO.default));
}
var $bd7af0419c32cb59$export$2e2bcd8739ae039 = $bd7af0419c32cb59$var$getAllKeysIn;

});

parcelRegister("fb5Xy", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0cc819005b2b96f$export$2e2bcd8739ae039);

var $2QS86 = parcelRequire("2QS86");

var $eHZZw = parcelRequire("eHZZw");

var $kk1ZK = parcelRequire("kk1ZK");

var $krcns = parcelRequire("krcns");

var $lxNxd = parcelRequire("lxNxd");

var $42LVW = parcelRequire("42LVW");

var $l1IED = parcelRequire("l1IED");
/** `Object#toString` result references. */ var $b0cc819005b2b96f$var$mapTag = '[object Map]', $b0cc819005b2b96f$var$objectTag = '[object Object]', $b0cc819005b2b96f$var$promiseTag = '[object Promise]', $b0cc819005b2b96f$var$setTag = '[object Set]', $b0cc819005b2b96f$var$weakMapTag = '[object WeakMap]';
var $b0cc819005b2b96f$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $b0cc819005b2b96f$var$dataViewCtorString = (0, $l1IED.default)((0, $2QS86.default)), $b0cc819005b2b96f$var$mapCtorString = (0, $l1IED.default)((0, $eHZZw.default)), $b0cc819005b2b96f$var$promiseCtorString = (0, $l1IED.default)((0, $kk1ZK.default)), $b0cc819005b2b96f$var$setCtorString = (0, $l1IED.default)((0, $krcns.default)), $b0cc819005b2b96f$var$weakMapCtorString = (0, $l1IED.default)((0, $lxNxd.default));
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $b0cc819005b2b96f$var$getTag = (0, $42LVW.default);
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((0, $2QS86.default) && $b0cc819005b2b96f$var$getTag(new (0, $2QS86.default)(new ArrayBuffer(1))) != $b0cc819005b2b96f$var$dataViewTag || (0, $eHZZw.default) && $b0cc819005b2b96f$var$getTag(new (0, $eHZZw.default)) != $b0cc819005b2b96f$var$mapTag || (0, $kk1ZK.default) && $b0cc819005b2b96f$var$getTag((0, $kk1ZK.default).resolve()) != $b0cc819005b2b96f$var$promiseTag || (0, $krcns.default) && $b0cc819005b2b96f$var$getTag(new (0, $krcns.default)) != $b0cc819005b2b96f$var$setTag || (0, $lxNxd.default) && $b0cc819005b2b96f$var$getTag(new (0, $lxNxd.default)) != $b0cc819005b2b96f$var$weakMapTag) $b0cc819005b2b96f$var$getTag = function(value) {
    var result = (0, $42LVW.default)(value), Ctor = result == $b0cc819005b2b96f$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? (0, $l1IED.default)(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $b0cc819005b2b96f$var$dataViewCtorString:
            return $b0cc819005b2b96f$var$dataViewTag;
        case $b0cc819005b2b96f$var$mapCtorString:
            return $b0cc819005b2b96f$var$mapTag;
        case $b0cc819005b2b96f$var$promiseCtorString:
            return $b0cc819005b2b96f$var$promiseTag;
        case $b0cc819005b2b96f$var$setCtorString:
            return $b0cc819005b2b96f$var$setTag;
        case $b0cc819005b2b96f$var$weakMapCtorString:
            return $b0cc819005b2b96f$var$weakMapTag;
    }
    return result;
};
var $b0cc819005b2b96f$export$2e2bcd8739ae039 = $b0cc819005b2b96f$var$getTag;

});
parcelRegister("2QS86", function(module, exports) {

$parcel$export(module.exports, "default", () => $213a6d24b31fe650$export$2e2bcd8739ae039);

var $9IkTg = parcelRequire("9IkTg");

var $aQKD3 = parcelRequire("aQKD3");
/* Built-in method references that are verified to be native. */ var $213a6d24b31fe650$var$DataView = (0, $9IkTg.default)((0, $aQKD3.default), 'DataView');
var $213a6d24b31fe650$export$2e2bcd8739ae039 = $213a6d24b31fe650$var$DataView;

});

parcelRegister("kk1ZK", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecb7390edc524b5f$export$2e2bcd8739ae039);

var $9IkTg = parcelRequire("9IkTg");

var $aQKD3 = parcelRequire("aQKD3");
/* Built-in method references that are verified to be native. */ var $ecb7390edc524b5f$var$Promise = (0, $9IkTg.default)((0, $aQKD3.default), 'Promise');
var $ecb7390edc524b5f$export$2e2bcd8739ae039 = $ecb7390edc524b5f$var$Promise;

});

parcelRegister("krcns", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee0fee1f47edf278$export$2e2bcd8739ae039);

var $9IkTg = parcelRequire("9IkTg");

var $aQKD3 = parcelRequire("aQKD3");
/* Built-in method references that are verified to be native. */ var $ee0fee1f47edf278$var$Set = (0, $9IkTg.default)((0, $aQKD3.default), 'Set');
var $ee0fee1f47edf278$export$2e2bcd8739ae039 = $ee0fee1f47edf278$var$Set;

});

parcelRegister("lxNxd", function(module, exports) {

$parcel$export(module.exports, "default", () => $faf31a951b8e59e2$export$2e2bcd8739ae039);

var $9IkTg = parcelRequire("9IkTg");

var $aQKD3 = parcelRequire("aQKD3");
/* Built-in method references that are verified to be native. */ var $faf31a951b8e59e2$var$WeakMap = (0, $9IkTg.default)((0, $aQKD3.default), 'WeakMap');
var $faf31a951b8e59e2$export$2e2bcd8739ae039 = $faf31a951b8e59e2$var$WeakMap;

});


parcelRegister("35jdz", function(module, exports) {

$parcel$export(module.exports, "default", () => $23f0befb3445fc09$export$2e2bcd8739ae039);
/** Used for built-in method references. */ var $23f0befb3445fc09$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $23f0befb3445fc09$var$hasOwnProperty = $23f0befb3445fc09$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $23f0befb3445fc09$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && $23f0befb3445fc09$var$hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
var $23f0befb3445fc09$export$2e2bcd8739ae039 = $23f0befb3445fc09$var$initCloneArray;

});

parcelRegister("6idGg", function(module, exports) {

$parcel$export(module.exports, "default", () => $494f093575e677c6$export$2e2bcd8739ae039);

var $6Vixl = parcelRequire("6Vixl");

var $iQZjr = parcelRequire("iQZjr");

var $4PXjD = parcelRequire("4PXjD");

var $6wfIO = parcelRequire("6wfIO");

var $3gFvs = parcelRequire("3gFvs");
/** `Object#toString` result references. */ var $494f093575e677c6$var$boolTag = '[object Boolean]', $494f093575e677c6$var$dateTag = '[object Date]', $494f093575e677c6$var$mapTag = '[object Map]', $494f093575e677c6$var$numberTag = '[object Number]', $494f093575e677c6$var$regexpTag = '[object RegExp]', $494f093575e677c6$var$setTag = '[object Set]', $494f093575e677c6$var$stringTag = '[object String]', $494f093575e677c6$var$symbolTag = '[object Symbol]';
var $494f093575e677c6$var$arrayBufferTag = '[object ArrayBuffer]', $494f093575e677c6$var$dataViewTag = '[object DataView]', $494f093575e677c6$var$float32Tag = '[object Float32Array]', $494f093575e677c6$var$float64Tag = '[object Float64Array]', $494f093575e677c6$var$int8Tag = '[object Int8Array]', $494f093575e677c6$var$int16Tag = '[object Int16Array]', $494f093575e677c6$var$int32Tag = '[object Int32Array]', $494f093575e677c6$var$uint8Tag = '[object Uint8Array]', $494f093575e677c6$var$uint8ClampedTag = '[object Uint8ClampedArray]', $494f093575e677c6$var$uint16Tag = '[object Uint16Array]', $494f093575e677c6$var$uint32Tag = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $494f093575e677c6$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $494f093575e677c6$var$arrayBufferTag:
            return (0, $6Vixl.default)(object);
        case $494f093575e677c6$var$boolTag:
        case $494f093575e677c6$var$dateTag:
            return new Ctor(+object);
        case $494f093575e677c6$var$dataViewTag:
            return (0, $iQZjr.default)(object, isDeep);
        case $494f093575e677c6$var$float32Tag:
        case $494f093575e677c6$var$float64Tag:
        case $494f093575e677c6$var$int8Tag:
        case $494f093575e677c6$var$int16Tag:
        case $494f093575e677c6$var$int32Tag:
        case $494f093575e677c6$var$uint8Tag:
        case $494f093575e677c6$var$uint8ClampedTag:
        case $494f093575e677c6$var$uint16Tag:
        case $494f093575e677c6$var$uint32Tag:
            return (0, $3gFvs.default)(object, isDeep);
        case $494f093575e677c6$var$mapTag:
            return new Ctor;
        case $494f093575e677c6$var$numberTag:
        case $494f093575e677c6$var$stringTag:
            return new Ctor(object);
        case $494f093575e677c6$var$regexpTag:
            return (0, $4PXjD.default)(object);
        case $494f093575e677c6$var$setTag:
            return new Ctor;
        case $494f093575e677c6$var$symbolTag:
            return (0, $6wfIO.default)(object);
    }
}
var $494f093575e677c6$export$2e2bcd8739ae039 = $494f093575e677c6$var$initCloneByTag;

});
parcelRegister("6Vixl", function(module, exports) {

$parcel$export(module.exports, "default", () => $50a671f892951027$export$2e2bcd8739ae039);

var $8Gmev = parcelRequire("8Gmev");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $50a671f892951027$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new (0, $8Gmev.default)(result).set(new (0, $8Gmev.default)(arrayBuffer));
    return result;
}
var $50a671f892951027$export$2e2bcd8739ae039 = $50a671f892951027$var$cloneArrayBuffer;

});
parcelRegister("8Gmev", function(module, exports) {

$parcel$export(module.exports, "default", () => $65237df6dbb80d40$export$2e2bcd8739ae039);

var $aQKD3 = parcelRequire("aQKD3");
/** Built-in value references. */ var $65237df6dbb80d40$var$Uint8Array = (0, $aQKD3.default).Uint8Array;
var $65237df6dbb80d40$export$2e2bcd8739ae039 = $65237df6dbb80d40$var$Uint8Array;

});


parcelRegister("iQZjr", function(module, exports) {

$parcel$export(module.exports, "default", () => $db9ca4bbe5e007a6$export$2e2bcd8739ae039);

var $6Vixl = parcelRequire("6Vixl");
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $db9ca4bbe5e007a6$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? (0, $6Vixl.default)(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
var $db9ca4bbe5e007a6$export$2e2bcd8739ae039 = $db9ca4bbe5e007a6$var$cloneDataView;

});

parcelRegister("4PXjD", function(module, exports) {

$parcel$export(module.exports, "default", () => $3859efb96995bb45$export$2e2bcd8739ae039);
/** Used to match `RegExp` flags from their coerced string values. */ var $3859efb96995bb45$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $3859efb96995bb45$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $3859efb96995bb45$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
var $3859efb96995bb45$export$2e2bcd8739ae039 = $3859efb96995bb45$var$cloneRegExp;

});

parcelRegister("6wfIO", function(module, exports) {

$parcel$export(module.exports, "default", () => $4bf1ed40a6950d12$export$2e2bcd8739ae039);

var $cVOod = parcelRequire("cVOod");
/** Used to convert symbols to primitives and strings. */ var $4bf1ed40a6950d12$var$symbolProto = (0, $cVOod.default) ? (0, $cVOod.default).prototype : undefined, $4bf1ed40a6950d12$var$symbolValueOf = $4bf1ed40a6950d12$var$symbolProto ? $4bf1ed40a6950d12$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $4bf1ed40a6950d12$var$cloneSymbol(symbol) {
    return $4bf1ed40a6950d12$var$symbolValueOf ? Object($4bf1ed40a6950d12$var$symbolValueOf.call(symbol)) : {};
}
var $4bf1ed40a6950d12$export$2e2bcd8739ae039 = $4bf1ed40a6950d12$var$cloneSymbol;

});

parcelRegister("3gFvs", function(module, exports) {

$parcel$export(module.exports, "default", () => $2613100373481499$export$2e2bcd8739ae039);

var $6Vixl = parcelRequire("6Vixl");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $2613100373481499$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? (0, $6Vixl.default)(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
var $2613100373481499$export$2e2bcd8739ae039 = $2613100373481499$var$cloneTypedArray;

});


parcelRegister("ktsYn", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee7cfd7d4f856c02$export$2e2bcd8739ae039);

var $aIIik = parcelRequire("aIIik");

var $agrfU = parcelRequire("agrfU");

var $89J4v = parcelRequire("89J4v");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $ee7cfd7d4f856c02$var$initCloneObject(object) {
    return typeof object.constructor == 'function' && !(0, $89J4v.default)(object) ? (0, $aIIik.default)((0, $agrfU.default)(object)) : {};
}
var $ee7cfd7d4f856c02$export$2e2bcd8739ae039 = $ee7cfd7d4f856c02$var$initCloneObject;

});
parcelRegister("aIIik", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ce05f6e03d8d303$export$2e2bcd8739ae039);

var $aWBxg = parcelRequire("aWBxg");
/** Built-in value references. */ var $7ce05f6e03d8d303$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $7ce05f6e03d8d303$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!(0, $aWBxg.default)(proto)) return {};
        if ($7ce05f6e03d8d303$var$objectCreate) return $7ce05f6e03d8d303$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
var $7ce05f6e03d8d303$export$2e2bcd8739ae039 = $7ce05f6e03d8d303$var$baseCreate;

});


parcelRegister("jixRw", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0c9f71a74dc845c$export$2e2bcd8739ae039);

var $aku4y = parcelRequire("aku4y");

var $gZMaq = parcelRequire("gZMaq");

var $6c0uc = parcelRequire("6c0uc");
/* Node.js helper references. */ var $e0c9f71a74dc845c$var$nodeIsMap = (0, $6c0uc.default) && (0, $6c0uc.default).isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $e0c9f71a74dc845c$var$isMap = $e0c9f71a74dc845c$var$nodeIsMap ? (0, $gZMaq.default)($e0c9f71a74dc845c$var$nodeIsMap) : (0, $aku4y.default);
var $e0c9f71a74dc845c$export$2e2bcd8739ae039 = $e0c9f71a74dc845c$var$isMap;

});
parcelRegister("aku4y", function(module, exports) {

$parcel$export(module.exports, "default", () => $7853196328ab8ce0$export$2e2bcd8739ae039);

var $fb5Xy = parcelRequire("fb5Xy");

var $b8tfT = parcelRequire("b8tfT");
/** `Object#toString` result references. */ var $7853196328ab8ce0$var$mapTag = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $7853196328ab8ce0$var$baseIsMap(value) {
    return (0, $b8tfT.default)(value) && (0, $fb5Xy.default)(value) == $7853196328ab8ce0$var$mapTag;
}
var $7853196328ab8ce0$export$2e2bcd8739ae039 = $7853196328ab8ce0$var$baseIsMap;

});


parcelRegister("7WLtA", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c92c6fa6fa6cc9f$export$2e2bcd8739ae039);

var $cKM4D = parcelRequire("cKM4D");

var $gZMaq = parcelRequire("gZMaq");

var $6c0uc = parcelRequire("6c0uc");
/* Node.js helper references. */ var $5c92c6fa6fa6cc9f$var$nodeIsSet = (0, $6c0uc.default) && (0, $6c0uc.default).isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $5c92c6fa6fa6cc9f$var$isSet = $5c92c6fa6fa6cc9f$var$nodeIsSet ? (0, $gZMaq.default)($5c92c6fa6fa6cc9f$var$nodeIsSet) : (0, $cKM4D.default);
var $5c92c6fa6fa6cc9f$export$2e2bcd8739ae039 = $5c92c6fa6fa6cc9f$var$isSet;

});
parcelRegister("cKM4D", function(module, exports) {

$parcel$export(module.exports, "default", () => $948f125c05db9a76$export$2e2bcd8739ae039);

var $fb5Xy = parcelRequire("fb5Xy");

var $b8tfT = parcelRequire("b8tfT");
/** `Object#toString` result references. */ var $948f125c05db9a76$var$setTag = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $948f125c05db9a76$var$baseIsSet(value) {
    return (0, $b8tfT.default)(value) && (0, $fb5Xy.default)(value) == $948f125c05db9a76$var$setTag;
}
var $948f125c05db9a76$export$2e2bcd8739ae039 = $948f125c05db9a76$var$baseIsSet;

});




parcelRegister("31ATd", function(module, exports) {
'use strict';
var $233e14948c671b0f$var$isArray = Array.isArray;
var $233e14948c671b0f$var$keyList = Object.keys;
var $233e14948c671b0f$var$hasProp = Object.prototype.hasOwnProperty;
var $233e14948c671b0f$var$hasElementType = typeof Element !== 'undefined';
function $233e14948c671b0f$var$equal(a, b) {
    // fast-deep-equal index.js 2.0.1
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        var arrA = $233e14948c671b0f$var$isArray(a), arrB = $233e14948c671b0f$var$isArray(b), i, length, key;
        if (arrA && arrB) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$233e14948c671b0f$var$equal(a[i], b[i])) return false;
            return true;
        }
        if (arrA != arrB) return false;
        var dateA = a instanceof Date, dateB = b instanceof Date;
        if (dateA != dateB) return false;
        if (dateA && dateB) return a.getTime() == b.getTime();
        var regexpA = a instanceof RegExp, regexpB = b instanceof RegExp;
        if (regexpA != regexpB) return false;
        if (regexpA && regexpB) return a.toString() == b.toString();
        var keys = $233e14948c671b0f$var$keyList(a);
        length = keys.length;
        if (length !== $233e14948c671b0f$var$keyList(b).length) return false;
        for(i = length; i-- !== 0;)if (!$233e14948c671b0f$var$hasProp.call(b, keys[i])) return false;
        // end fast-deep-equal
        // start react-fast-compare
        // custom handling for DOM elements
        if ($233e14948c671b0f$var$hasElementType && a instanceof Element && b instanceof Element) return a === b;
        // custom handling for React
        for(i = length; i-- !== 0;){
            key = keys[i];
            if (key === '_owner' && a.$$typeof) continue;
            else {
                // all other properties should be traversed as usual
                if (!$233e14948c671b0f$var$equal(a[key], b[key])) return false;
            }
        }
        // end react-fast-compare
        // fast-deep-equal index.js 2.0.1
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function exportedEqual(a, b) {
    try {
        return $233e14948c671b0f$var$equal(a, b);
    } catch (error) {
        if (error.message && error.message.match(/stack|recursion/i) || error.number === -2146828260) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

});

parcelRegister("8I1rW", function(module, exports) {

$parcel$export(module.exports, "default", () => $65738ea8e4b9014c$export$2e2bcd8739ae039);
var $65738ea8e4b9014c$var$isProduction = true;
function $65738ea8e4b9014c$var$warning(condition, message) {
    if (!$65738ea8e4b9014c$var$isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== 'undefined') console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
var $65738ea8e4b9014c$export$2e2bcd8739ae039 = $65738ea8e4b9014c$var$warning;

});

parcelRegister("bwrOM", function(module, exports) {

$parcel$export(module.exports, "default", () => $863842eecc722445$export$2e2bcd8739ae039);

var $bslYV = parcelRequire("bslYV");
/** Used to compose bitmasks for cloning. */ var $863842eecc722445$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */ function $863842eecc722445$var$clone(value) {
    return (0, $bslYV.default)(value, $863842eecc722445$var$CLONE_SYMBOLS_FLAG);
}
var $863842eecc722445$export$2e2bcd8739ae039 = $863842eecc722445$var$clone;

});

parcelRegister("aCf5k", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ba9278d80dcc338$export$2e2bcd8739ae039);

var $95kO3 = parcelRequire("95kO3");

var $fJXTB = parcelRequire("fJXTB");

var $i48KB = parcelRequire("i48KB");

var $7N8V6 = parcelRequire("7N8V6");

var $dRovF = parcelRequire("dRovF");

var $618qE = parcelRequire("618qE");

var $fgXm3 = parcelRequire("fgXm3");
/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */ function $7ba9278d80dcc338$var$toPath(value) {
    if ((0, $i48KB.default)(value)) return (0, $95kO3.default)(value, (0, $618qE.default));
    return (0, $7N8V6.default)(value) ? [
        value
    ] : (0, $fJXTB.default)((0, $dRovF.default)((0, $fgXm3.default)(value)));
}
var $7ba9278d80dcc338$export$2e2bcd8739ae039 = $7ba9278d80dcc338$var$toPath;

});
parcelRegister("95kO3", function(module, exports) {

$parcel$export(module.exports, "default", () => $69d4b8641124f261$export$2e2bcd8739ae039);
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $69d4b8641124f261$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
var $69d4b8641124f261$export$2e2bcd8739ae039 = $69d4b8641124f261$var$arrayMap;

});

parcelRegister("7N8V6", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ac40753e9fb8ac9$export$2e2bcd8739ae039);

var $42LVW = parcelRequire("42LVW");

var $b8tfT = parcelRequire("b8tfT");
/** `Object#toString` result references. */ var $5ac40753e9fb8ac9$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $5ac40753e9fb8ac9$var$isSymbol(value) {
    return typeof value == 'symbol' || (0, $b8tfT.default)(value) && (0, $42LVW.default)(value) == $5ac40753e9fb8ac9$var$symbolTag;
}
var $5ac40753e9fb8ac9$export$2e2bcd8739ae039 = $5ac40753e9fb8ac9$var$isSymbol;

});

parcelRegister("dRovF", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1733cbe4dae1139$export$2e2bcd8739ae039);

var $aP4to = parcelRequire("aP4to");
/** Used to match property names within property paths. */ var $a1733cbe4dae1139$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $a1733cbe4dae1139$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $a1733cbe4dae1139$var$stringToPath = (0, $aP4to.default)(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($a1733cbe4dae1139$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($a1733cbe4dae1139$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
var $a1733cbe4dae1139$export$2e2bcd8739ae039 = $a1733cbe4dae1139$var$stringToPath;

});
parcelRegister("aP4to", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e12230f351caecf$export$2e2bcd8739ae039);

var $anCCf = parcelRequire("anCCf");
/** Used as the maximum memoize cache size. */ var $7e12230f351caecf$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $7e12230f351caecf$var$memoizeCapped(func) {
    var result = (0, $anCCf.default)(func, function(key) {
        if (cache.size === $7e12230f351caecf$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
var $7e12230f351caecf$export$2e2bcd8739ae039 = $7e12230f351caecf$var$memoizeCapped;

});
parcelRegister("anCCf", function(module, exports) {

$parcel$export(module.exports, "default", () => $78ea01b3b87a99a8$export$2e2bcd8739ae039);

var $8Ufnm = parcelRequire("8Ufnm");
/** Error message constants. */ var $78ea01b3b87a99a8$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $78ea01b3b87a99a8$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($78ea01b3b87a99a8$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($78ea01b3b87a99a8$var$memoize.Cache || (0, $8Ufnm.default));
    return memoized;
}
// Expose `MapCache`.
$78ea01b3b87a99a8$var$memoize.Cache = (0, $8Ufnm.default);
var $78ea01b3b87a99a8$export$2e2bcd8739ae039 = $78ea01b3b87a99a8$var$memoize;

});



parcelRegister("618qE", function(module, exports) {

$parcel$export(module.exports, "default", () => $46195fdf4d1c7119$export$2e2bcd8739ae039);

var $7N8V6 = parcelRequire("7N8V6");
/** Used as references for various `Number` constants. */ var $46195fdf4d1c7119$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $46195fdf4d1c7119$var$toKey(value) {
    if (typeof value == 'string' || (0, $7N8V6.default)(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$46195fdf4d1c7119$var$INFINITY ? '-0' : result;
}
var $46195fdf4d1c7119$export$2e2bcd8739ae039 = $46195fdf4d1c7119$var$toKey;

});

parcelRegister("fgXm3", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1e66443af97c112$export$2e2bcd8739ae039);

var $2X29w = parcelRequire("2X29w");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $b1e66443af97c112$var$toString(value) {
    return value == null ? '' : (0, $2X29w.default)(value);
}
var $b1e66443af97c112$export$2e2bcd8739ae039 = $b1e66443af97c112$var$toString;

});
parcelRegister("2X29w", function(module, exports) {

$parcel$export(module.exports, "default", () => $2262c2f088aa8039$export$2e2bcd8739ae039);

var $cVOod = parcelRequire("cVOod");

var $95kO3 = parcelRequire("95kO3");

var $i48KB = parcelRequire("i48KB");

var $7N8V6 = parcelRequire("7N8V6");
/** Used as references for various `Number` constants. */ var $2262c2f088aa8039$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $2262c2f088aa8039$var$symbolProto = (0, $cVOod.default) ? (0, $cVOod.default).prototype : undefined, $2262c2f088aa8039$var$symbolToString = $2262c2f088aa8039$var$symbolProto ? $2262c2f088aa8039$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $2262c2f088aa8039$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ((0, $i48KB.default)(value)) // Recursively convert values (susceptible to call stack limits).
    return (0, $95kO3.default)(value, $2262c2f088aa8039$var$baseToString) + '';
    if ((0, $7N8V6.default)(value)) return $2262c2f088aa8039$var$symbolToString ? $2262c2f088aa8039$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$2262c2f088aa8039$var$INFINITY ? '-0' : result;
}
var $2262c2f088aa8039$export$2e2bcd8739ae039 = $2262c2f088aa8039$var$baseToString;

});



parcelRegister("j8Bf6", function(module, exports) {
'use strict';

var $cbG5Y = parcelRequire("cbG5Y");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $deeba7430f1a2bbe$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $deeba7430f1a2bbe$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $deeba7430f1a2bbe$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $deeba7430f1a2bbe$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $deeba7430f1a2bbe$var$TYPE_STATICS = {};
$deeba7430f1a2bbe$var$TYPE_STATICS[$cbG5Y.ForwardRef] = $deeba7430f1a2bbe$var$FORWARD_REF_STATICS;
$deeba7430f1a2bbe$var$TYPE_STATICS[$cbG5Y.Memo] = $deeba7430f1a2bbe$var$MEMO_STATICS;
function $deeba7430f1a2bbe$var$getStatics(component) {
    // React v16.11 and below
    if ($cbG5Y.isMemo(component)) return $deeba7430f1a2bbe$var$MEMO_STATICS;
     // React v16.12 and above
    return $deeba7430f1a2bbe$var$TYPE_STATICS[component['$$typeof']] || $deeba7430f1a2bbe$var$REACT_STATICS;
}
var $deeba7430f1a2bbe$var$defineProperty = Object.defineProperty;
var $deeba7430f1a2bbe$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $deeba7430f1a2bbe$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $deeba7430f1a2bbe$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $deeba7430f1a2bbe$var$getPrototypeOf = Object.getPrototypeOf;
var $deeba7430f1a2bbe$var$objectPrototype = Object.prototype;
function $deeba7430f1a2bbe$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($deeba7430f1a2bbe$var$objectPrototype) {
            var inheritedComponent = $deeba7430f1a2bbe$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $deeba7430f1a2bbe$var$objectPrototype) $deeba7430f1a2bbe$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $deeba7430f1a2bbe$var$getOwnPropertyNames(sourceComponent);
        if ($deeba7430f1a2bbe$var$getOwnPropertySymbols) keys = keys.concat($deeba7430f1a2bbe$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $deeba7430f1a2bbe$var$getStatics(targetComponent);
        var sourceStatics = $deeba7430f1a2bbe$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$deeba7430f1a2bbe$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $deeba7430f1a2bbe$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $deeba7430f1a2bbe$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $deeba7430f1a2bbe$var$hoistNonReactStatics;

});
parcelRegister("cbG5Y", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1CR13"));

});



parcelRegister("a9nNI", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $13fDO = parcelRequire("13fDO");

var $guJWw = parcelRequire("guJWw");

var $65cio = parcelRequire("65cio");

var $9JGc3 = parcelRequire("9JGc3");
function $763d350096424701$var$get(object, path, defaultValue) {
    if (object == null) return defaultValue;
    switch(typeof path){
        case 'string':
            {
                if ($13fDO.isUnsafeProperty(path)) return defaultValue;
                const result = object[path];
                if (result === undefined) {
                    if ($guJWw.isDeepKey(path)) return $763d350096424701$var$get(object, $9JGc3.toPath(path), defaultValue);
                    else return defaultValue;
                }
                return result;
            }
        case 'number':
        case 'symbol':
            {
                if (typeof path === 'number') path = $65cio.toKey(path);
                const result = object[path];
                if (result === undefined) return defaultValue;
                return result;
            }
        default:
            {
                if (Array.isArray(path)) return $763d350096424701$var$getWithPath(object, path, defaultValue);
                if (Object.is(path?.valueOf(), -0)) path = '-0';
                else path = String(path);
                if ($13fDO.isUnsafeProperty(path)) return defaultValue;
                const result = object[path];
                if (result === undefined) return defaultValue;
                return result;
            }
    }
}
function $763d350096424701$var$getWithPath(object, path, defaultValue) {
    if (path.length === 0) return defaultValue;
    let current = object;
    for(let index = 0; index < path.length; index++){
        if (current == null) return defaultValue;
        if ($13fDO.isUnsafeProperty(path[index])) return defaultValue;
        current = current[path[index]];
    }
    if (current === undefined) return defaultValue;
    return current;
}
module.exports.get = $763d350096424701$var$get;

});
parcelRegister("13fDO", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $0c4234409ae07a42$var$isUnsafeProperty(key) {
    return key === '__proto__';
}
module.exports.isUnsafeProperty = $0c4234409ae07a42$var$isUnsafeProperty;

});

parcelRegister("guJWw", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $c023160034a0d413$var$isDeepKey(key) {
    switch(typeof key){
        case 'number':
        case 'symbol':
            return false;
        case 'string':
            return key.includes('.') || key.includes('[') || key.includes(']');
    }
}
module.exports.isDeepKey = $c023160034a0d413$var$isDeepKey;

});

parcelRegister("65cio", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $46dcbf5bcead8eaa$var$toKey(value) {
    if (typeof value === 'string' || typeof value === 'symbol') return value;
    if (Object.is(value?.valueOf?.(), -0)) return '-0';
    return String(value);
}
module.exports.toKey = $46dcbf5bcead8eaa$var$toKey;

});

parcelRegister("9JGc3", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $81KHO = parcelRequire("81KHO");

var $65cio = parcelRequire("65cio");
function $71690bc043c5a873$var$toPath(deepKey) {
    if (Array.isArray(deepKey)) return deepKey.map($65cio.toKey);
    if (typeof deepKey === 'symbol') return [
        deepKey
    ];
    deepKey = $81KHO.toString(deepKey);
    const result = [];
    const length = deepKey.length;
    if (length === 0) return result;
    let index = 0;
    let key = '';
    let quoteChar = '';
    let bracket = false;
    if (deepKey.charCodeAt(0) === 46) {
        result.push('');
        index++;
    }
    while(index < length){
        const char = deepKey[index];
        if (quoteChar) {
            if (char === '\\' && index + 1 < length) {
                index++;
                key += deepKey[index];
            } else if (char === quoteChar) quoteChar = '';
            else key += char;
        } else if (bracket) {
            if (char === '"' || char === "'") quoteChar = char;
            else if (char === ']') {
                bracket = false;
                result.push(key);
                key = '';
            } else key += char;
        } else {
            if (char === '[') {
                bracket = true;
                if (key) {
                    result.push(key);
                    key = '';
                }
            } else if (char === '.') {
                if (key) {
                    result.push(key);
                    key = '';
                }
            } else key += char;
        }
        index++;
    }
    if (key) result.push(key);
    return result;
}
module.exports.toPath = $71690bc043c5a873$var$toPath;

});
parcelRegister("81KHO", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $5d82a57ef39bcf1a$var$toString(value) {
    if (value == null) return '';
    if (typeof value === 'string') return value;
    if (Array.isArray(value)) return value.map($5d82a57ef39bcf1a$var$toString).join(',');
    const result = String(value);
    if (result === '0' && Object.is(Number(value), -0)) return '-0';
    return result;
}
module.exports.toString = $5d82a57ef39bcf1a$var$toString;

});



parcelRegister("iKKQu", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $da70dc6b9e06043a$export$bf730a2d8bf68b42, (v) => $da70dc6b9e06043a$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $da70dc6b9e06043a$export$bf730a2d8bf68b42;
"use strict";

var $kc00y = parcelRequire("kc00y");

var $lEFxP = parcelRequire("lEFxP");
function $da70dc6b9e06043a$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $da70dc6b9e06043a$var$objectIs = "function" === typeof Object.is ? Object.is : $da70dc6b9e06043a$var$is, $da70dc6b9e06043a$var$useSyncExternalStore = $lEFxP.useSyncExternalStore, $da70dc6b9e06043a$var$useRef = $kc00y.useRef, $da70dc6b9e06043a$var$useEffect = $kc00y.useEffect, $da70dc6b9e06043a$var$useMemo = $kc00y.useMemo, $da70dc6b9e06043a$var$useDebugValue = $kc00y.useDebugValue;
$da70dc6b9e06043a$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $da70dc6b9e06043a$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $da70dc6b9e06043a$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($da70dc6b9e06043a$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $da70dc6b9e06043a$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $da70dc6b9e06043a$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $da70dc6b9e06043a$var$useDebugValue(value);
    return value;
};

});
parcelRegister("lEFxP", function(module, exports) {
'use strict';

module.exports = (parcelRequire("dam9e"));

});
parcelRegister("dam9e", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $995d63a9ffd174b6$export$306c0aa65ff9ec16, (v) => $995d63a9ffd174b6$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $995d63a9ffd174b6$export$306c0aa65ff9ec16;
"use strict";

var $kc00y = parcelRequire("kc00y");
function $995d63a9ffd174b6$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $995d63a9ffd174b6$var$objectIs = "function" === typeof Object.is ? Object.is : $995d63a9ffd174b6$var$is, $995d63a9ffd174b6$var$useState = $kc00y.useState, $995d63a9ffd174b6$var$useEffect = $kc00y.useEffect, $995d63a9ffd174b6$var$useLayoutEffect = $kc00y.useLayoutEffect, $995d63a9ffd174b6$var$useDebugValue = $kc00y.useDebugValue;
function $995d63a9ffd174b6$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $995d63a9ffd174b6$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $995d63a9ffd174b6$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $995d63a9ffd174b6$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $995d63a9ffd174b6$var$useEffect(function() {
        $995d63a9ffd174b6$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $995d63a9ffd174b6$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $995d63a9ffd174b6$var$useDebugValue(value);
    return value;
}
function $995d63a9ffd174b6$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$995d63a9ffd174b6$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $995d63a9ffd174b6$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $995d63a9ffd174b6$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $995d63a9ffd174b6$var$useSyncExternalStore$1 : $995d63a9ffd174b6$var$useSyncExternalStore$2;
$995d63a9ffd174b6$export$306c0aa65ff9ec16 = void 0 !== $kc00y.useSyncExternalStore ? $kc00y.useSyncExternalStore : $995d63a9ffd174b6$var$shim;

});



parcelRegister("6UrPn", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3ppVe = parcelRequire("3ppVe");

var $lrenS = parcelRequire("lrenS");

var $9XLXE = parcelRequire("9XLXE");
function $507d8f0b7e229c37$var$sortBy(collection, ...criteria) {
    const length = criteria.length;
    if (length > 1 && $9XLXE.isIterateeCall(collection, criteria[0], criteria[1])) criteria = [];
    else if (length > 2 && $9XLXE.isIterateeCall(criteria[0], criteria[1], criteria[2])) criteria = [
        criteria[0]
    ];
    return $3ppVe.orderBy(collection, $lrenS.flatten(criteria), [
        'asc'
    ]);
}
module.exports.sortBy = $507d8f0b7e229c37$var$sortBy;

});
parcelRegister("3ppVe", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $kWntU = parcelRequire("kWntU");

var $5OZNm = parcelRequire("5OZNm");

var $9JGc3 = parcelRequire("9JGc3");
function $27b7d0827a141962$var$orderBy(collection, criteria, orders, guard) {
    if (collection == null) return [];
    orders = guard ? undefined : orders;
    if (!Array.isArray(collection)) collection = Object.values(collection);
    if (!Array.isArray(criteria)) criteria = criteria == null ? [
        null
    ] : [
        criteria
    ];
    if (criteria.length === 0) criteria = [
        null
    ];
    if (!Array.isArray(orders)) orders = orders == null ? [] : [
        orders
    ];
    orders = orders.map((order)=>String(order));
    const getValueByNestedPath = (object, path)=>{
        let target = object;
        for(let i = 0; i < path.length && target != null; ++i)target = target[path[i]];
        return target;
    };
    const getValueByCriterion = (criterion, object)=>{
        if (object == null || criterion == null) return object;
        if (typeof criterion === 'object' && 'key' in criterion) {
            if (Object.hasOwn(object, criterion.key)) return object[criterion.key];
            return getValueByNestedPath(object, criterion.path);
        }
        if (typeof criterion === 'function') return criterion(object);
        if (Array.isArray(criterion)) return getValueByNestedPath(object, criterion);
        if (typeof object === 'object') return object[criterion];
        return object;
    };
    const preparedCriteria = criteria.map((criterion)=>{
        if (Array.isArray(criterion) && criterion.length === 1) criterion = criterion[0];
        if (criterion == null || typeof criterion === 'function' || Array.isArray(criterion) || $5OZNm.isKey(criterion)) return criterion;
        return {
            key: criterion,
            path: $9JGc3.toPath(criterion)
        };
    });
    const preparedCollection = collection.map((item)=>({
            original: item,
            criteria: preparedCriteria.map((criterion)=>getValueByCriterion(criterion, item))
        }));
    return preparedCollection.slice().sort((a, b)=>{
        for(let i = 0; i < preparedCriteria.length; i++){
            const comparedResult = $kWntU.compareValues(a.criteria[i], b.criteria[i], orders[i]);
            if (comparedResult !== 0) return comparedResult;
        }
        return 0;
    }).map((item)=>item.original);
}
module.exports.orderBy = $27b7d0827a141962$var$orderBy;

});
parcelRegister("kWntU", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $f3eb705e48888b82$var$getPriority(a) {
    if (typeof a === 'symbol') return 1;
    if (a === null) return 2;
    if (a === undefined) return 3;
    if (a !== a) return 4;
    return 0;
}
const $f3eb705e48888b82$var$compareValues = (a, b, order)=>{
    if (a !== b) {
        const aPriority = $f3eb705e48888b82$var$getPriority(a);
        const bPriority = $f3eb705e48888b82$var$getPriority(b);
        if (aPriority === bPriority && aPriority === 0) {
            if (a < b) return order === 'desc' ? 1 : -1;
            if (a > b) return order === 'desc' ? -1 : 1;
        }
        return order === 'desc' ? bPriority - aPriority : aPriority - bPriority;
    }
    return 0;
};
module.exports.compareValues = $f3eb705e48888b82$var$compareValues;

});

parcelRegister("5OZNm", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $i87Ch = parcelRequire("i87Ch");
const $43d18e7a6bedd75d$var$regexIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/;
const $43d18e7a6bedd75d$var$regexIsPlainProp = /^\w*$/;
function $43d18e7a6bedd75d$var$isKey(value, object) {
    if (Array.isArray(value)) return false;
    if (typeof value === 'number' || typeof value === 'boolean' || value == null || $i87Ch.isSymbol(value)) return true;
    return typeof value === 'string' && ($43d18e7a6bedd75d$var$regexIsPlainProp.test(value) || !$43d18e7a6bedd75d$var$regexIsDeepProp.test(value)) || object != null && Object.hasOwn(object, value);
}
module.exports.isKey = $43d18e7a6bedd75d$var$isKey;

});
parcelRegister("i87Ch", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $d32ee1cc0557e267$var$isSymbol(value) {
    return typeof value === 'symbol' || value instanceof Symbol;
}
module.exports.isSymbol = $d32ee1cc0557e267$var$isSymbol;

});



parcelRegister("lrenS", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $f9b746fe7b160c35$var$flatten(arr, depth = 1) {
    const result = [];
    const flooredDepth = Math.floor(depth);
    const recursive = (arr, currentDepth)=>{
        for(let i = 0; i < arr.length; i++){
            const item = arr[i];
            if (Array.isArray(item) && currentDepth < flooredDepth) recursive(item, currentDepth + 1);
            else result.push(item);
        }
    };
    recursive(arr, 0);
    return result;
}
module.exports.flatten = $f9b746fe7b160c35$var$flatten;

});

parcelRegister("9XLXE", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $70VIQ = parcelRequire("70VIQ");

var $2rzX1 = parcelRequire("2rzX1");

var $6ZAXy = parcelRequire("6ZAXy");

var $6NdZx = parcelRequire("6NdZx");
function $740ed3d29a692191$var$isIterateeCall(value, index, object) {
    if (!$6ZAXy.isObject(object)) return false;
    if (typeof index === 'number' && $2rzX1.isArrayLike(object) && $70VIQ.isIndex(index) && index < object.length || typeof index === 'string' && index in object) return $6NdZx.isEqualsSameValueZero(object[index], value);
    return false;
}
module.exports.isIterateeCall = $740ed3d29a692191$var$isIterateeCall;

});
parcelRegister("70VIQ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $51b54ef1546e38ad$var$IS_UNSIGNED_INTEGER = /^(?:0|[1-9]\d*)$/;
function $51b54ef1546e38ad$var$isIndex(value, length = Number.MAX_SAFE_INTEGER) {
    switch(typeof value){
        case 'number':
            return Number.isInteger(value) && value >= 0 && value < length;
        case 'symbol':
            return false;
        case 'string':
            return $51b54ef1546e38ad$var$IS_UNSIGNED_INTEGER.test(value);
    }
}
module.exports.isIndex = $51b54ef1546e38ad$var$isIndex;

});

parcelRegister("2rzX1", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $iu6G5 = parcelRequire("iu6G5");
function $1c79fd80ddb50531$var$isArrayLike(value) {
    return value != null && typeof value !== 'function' && $iu6G5.isLength(value.length);
}
module.exports.isArrayLike = $1c79fd80ddb50531$var$isArrayLike;

});
parcelRegister("iu6G5", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $d750356ab55b88c1$var$isLength(value) {
    return Number.isSafeInteger(value) && value >= 0;
}
module.exports.isLength = $d750356ab55b88c1$var$isLength;

});


parcelRegister("6ZAXy", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $51751bf7f4cf416a$var$isObject(value) {
    return value !== null && (typeof value === 'object' || typeof value === 'function');
}
module.exports.isObject = $51751bf7f4cf416a$var$isObject;

});

parcelRegister("6NdZx", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $4f222c211d9df5a4$var$isEqualsSameValueZero(value, other) {
    return value === other || Number.isNaN(value) && Number.isNaN(other);
}
module.exports.isEqualsSameValueZero = $4f222c211d9df5a4$var$isEqualsSameValueZero;

});



parcelRegister("cBmIv", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $4QGfZ = parcelRequire("4QGfZ");
function $92ca8fce199956ba$var$throttle(func, throttleMs = 0, options = {}) {
    const { leading: leading = true, trailing: trailing = true } = options;
    return $4QGfZ.debounce(func, throttleMs, {
        leading: leading,
        maxWait: throttleMs,
        trailing: trailing
    });
}
module.exports.throttle = $92ca8fce199956ba$var$throttle;

});
parcelRegister("4QGfZ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $jFaFb = parcelRequire("jFaFb");
function $387ccc197bb3e84e$var$debounce(func, debounceMs = 0, options = {}) {
    if (typeof options !== 'object') options = {};
    const { leading: leading = false, trailing: trailing = true, maxWait: maxWait } = options;
    const edges = Array(2);
    if (leading) edges[0] = 'leading';
    if (trailing) edges[1] = 'trailing';
    let result = undefined;
    let pendingAt = null;
    const _debounced = $jFaFb.debounce(function(...args) {
        result = func.apply(this, args);
        pendingAt = null;
    }, debounceMs, {
        edges: edges
    });
    const debounced = function(...args) {
        if (maxWait != null) {
            if (pendingAt === null) pendingAt = Date.now();
            if (Date.now() - pendingAt >= maxWait) {
                result = func.apply(this, args);
                pendingAt = Date.now();
                _debounced.cancel();
                _debounced.schedule();
                return result;
            }
        }
        _debounced.apply(this, args);
        return result;
    };
    const flush = ()=>{
        _debounced.flush();
        return result;
    };
    debounced.cancel = _debounced.cancel;
    debounced.flush = flush;
    return debounced;
}
module.exports.debounce = $387ccc197bb3e84e$var$debounce;

});
parcelRegister("jFaFb", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $e50a1e2365e4b743$var$debounce(func, debounceMs, { signal: signal, edges: edges } = {}) {
    let pendingThis = undefined;
    let pendingArgs = null;
    const leading = edges != null && edges.includes('leading');
    const trailing = edges == null || edges.includes('trailing');
    const invoke = ()=>{
        if (pendingArgs !== null) {
            func.apply(pendingThis, pendingArgs);
            pendingThis = undefined;
            pendingArgs = null;
        }
    };
    const onTimerEnd = ()=>{
        if (trailing) invoke();
        cancel();
    };
    let timeoutId = null;
    const schedule = ()=>{
        if (timeoutId != null) clearTimeout(timeoutId);
        timeoutId = setTimeout(()=>{
            timeoutId = null;
            onTimerEnd();
        }, debounceMs);
    };
    const cancelTimer = ()=>{
        if (timeoutId !== null) {
            clearTimeout(timeoutId);
            timeoutId = null;
        }
    };
    const cancel = ()=>{
        cancelTimer();
        pendingThis = undefined;
        pendingArgs = null;
    };
    const flush = ()=>{
        invoke();
    };
    const debounced = function(...args) {
        if (signal?.aborted) return;
        pendingThis = this;
        pendingArgs = args;
        const isFirstCall = timeoutId == null;
        schedule();
        if (leading && isFirstCall) invoke();
    };
    debounced.schedule = schedule;
    debounced.cancel = cancel;
    debounced.flush = flush;
    signal?.addEventListener('abort', cancel, {
        once: true
    });
    return debounced;
}
module.exports.debounce = $e50a1e2365e4b743$var$debounce;

});



parcelRegister("qpdRJ", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $04f5fe837e55bab5$export$a7c73072b1a182ae, (v) => $04f5fe837e55bab5$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $04f5fe837e55bab5$export$9f27bc3417b4524d, (v) => $04f5fe837e55bab5$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $04f5fe837e55bab5$export$db77ccec0bb4ccac, (v) => $04f5fe837e55bab5$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $04f5fe837e55bab5$export$8392c0c9d3dcbd35, (v) => $04f5fe837e55bab5$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $04f5fe837e55bab5$export$ffb0004e005737fa, (v) => $04f5fe837e55bab5$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $04f5fe837e55bab5$export$b624eff549462981, (v) => $04f5fe837e55bab5$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $04f5fe837e55bab5$export$7897aa7841a5380c, (v) => $04f5fe837e55bab5$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $04f5fe837e55bab5$export$602eac185826482c, (v) => $04f5fe837e55bab5$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $04f5fe837e55bab5$export$e2c29f18771995cb, (v) => $04f5fe837e55bab5$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $04f5fe837e55bab5$export$5f8d39834fd61797, (v) => $04f5fe837e55bab5$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $04f5fe837e55bab5$export$74bf444e3cd11ea5, (v) => $04f5fe837e55bab5$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $04f5fe837e55bab5$export$998bcd577473dd93, (v) => $04f5fe837e55bab5$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isAsyncMode", () => $04f5fe837e55bab5$export$92387174baf9b227, (v) => $04f5fe837e55bab5$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $04f5fe837e55bab5$export$ec112efeb987d9c6, (v) => $04f5fe837e55bab5$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $04f5fe837e55bab5$export$b706b080d889d2c9, (v) => $04f5fe837e55bab5$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $04f5fe837e55bab5$export$5be5a87408f70ddc, (v) => $04f5fe837e55bab5$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $04f5fe837e55bab5$export$45a5e7f76e0caa8d, (v) => $04f5fe837e55bab5$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $04f5fe837e55bab5$export$455c2e768291efa6, (v) => $04f5fe837e55bab5$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $04f5fe837e55bab5$export$9522e17588c12572, (v) => $04f5fe837e55bab5$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $04f5fe837e55bab5$export$2110ac352bb060b9, (v) => $04f5fe837e55bab5$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $04f5fe837e55bab5$export$56885ab8b9c456ab, (v) => $04f5fe837e55bab5$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $04f5fe837e55bab5$export$d927fcb6adf8f9de, (v) => $04f5fe837e55bab5$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $04f5fe837e55bab5$export$b82d16f27459e05a, (v) => $04f5fe837e55bab5$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $04f5fe837e55bab5$export$522c17b4f5e123e8, (v) => $04f5fe837e55bab5$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $04f5fe837e55bab5$export$1aabd8a0274ecfd6, (v) => $04f5fe837e55bab5$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $04f5fe837e55bab5$export$3d6c20d97e46b957, (v) => $04f5fe837e55bab5$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $04f5fe837e55bab5$export$9b621391a187a31a, (v) => $04f5fe837e55bab5$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $04f5fe837e55bab5$export$f5bbd400c2f4426f, (v) => $04f5fe837e55bab5$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $04f5fe837e55bab5$export$a7c73072b1a182ae;
var $04f5fe837e55bab5$export$9f27bc3417b4524d;
var $04f5fe837e55bab5$export$db77ccec0bb4ccac;
var $04f5fe837e55bab5$export$8392c0c9d3dcbd35;
var $04f5fe837e55bab5$export$ffb0004e005737fa;
var $04f5fe837e55bab5$export$b624eff549462981;
var $04f5fe837e55bab5$export$7897aa7841a5380c;
var $04f5fe837e55bab5$export$602eac185826482c;
var $04f5fe837e55bab5$export$e2c29f18771995cb;
var $04f5fe837e55bab5$export$5f8d39834fd61797;
var $04f5fe837e55bab5$export$74bf444e3cd11ea5;
var $04f5fe837e55bab5$export$998bcd577473dd93;
var $04f5fe837e55bab5$export$92387174baf9b227;
var $04f5fe837e55bab5$export$ec112efeb987d9c6;
var $04f5fe837e55bab5$export$b706b080d889d2c9;
var $04f5fe837e55bab5$export$5be5a87408f70ddc;
var $04f5fe837e55bab5$export$45a5e7f76e0caa8d;
var $04f5fe837e55bab5$export$455c2e768291efa6;
var $04f5fe837e55bab5$export$9522e17588c12572;
var $04f5fe837e55bab5$export$2110ac352bb060b9;
var $04f5fe837e55bab5$export$56885ab8b9c456ab;
var $04f5fe837e55bab5$export$d927fcb6adf8f9de;
var $04f5fe837e55bab5$export$b82d16f27459e05a;
var $04f5fe837e55bab5$export$522c17b4f5e123e8;
var $04f5fe837e55bab5$export$1aabd8a0274ecfd6;
var $04f5fe837e55bab5$export$3d6c20d97e46b957;
var $04f5fe837e55bab5$export$9b621391a187a31a;
var $04f5fe837e55bab5$export$f5bbd400c2f4426f;
'use strict';
var $04f5fe837e55bab5$var$b = Symbol.for("react.element"), $04f5fe837e55bab5$var$c = Symbol.for("react.portal"), $04f5fe837e55bab5$var$d = Symbol.for("react.fragment"), $04f5fe837e55bab5$var$e = Symbol.for("react.strict_mode"), $04f5fe837e55bab5$var$f = Symbol.for("react.profiler"), $04f5fe837e55bab5$var$g = Symbol.for("react.provider"), $04f5fe837e55bab5$var$h = Symbol.for("react.context"), $04f5fe837e55bab5$var$k = Symbol.for("react.server_context"), $04f5fe837e55bab5$var$l = Symbol.for("react.forward_ref"), $04f5fe837e55bab5$var$m = Symbol.for("react.suspense"), $04f5fe837e55bab5$var$n = Symbol.for("react.suspense_list"), $04f5fe837e55bab5$var$p = Symbol.for("react.memo"), $04f5fe837e55bab5$var$q = Symbol.for("react.lazy"), $04f5fe837e55bab5$var$t = Symbol.for("react.offscreen"), $04f5fe837e55bab5$var$u;
$04f5fe837e55bab5$var$u = Symbol.for("react.module.reference");
function $04f5fe837e55bab5$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $04f5fe837e55bab5$var$b:
                switch(a = a.type, a){
                    case $04f5fe837e55bab5$var$d:
                    case $04f5fe837e55bab5$var$f:
                    case $04f5fe837e55bab5$var$e:
                    case $04f5fe837e55bab5$var$m:
                    case $04f5fe837e55bab5$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $04f5fe837e55bab5$var$k:
                            case $04f5fe837e55bab5$var$h:
                            case $04f5fe837e55bab5$var$l:
                            case $04f5fe837e55bab5$var$q:
                            case $04f5fe837e55bab5$var$p:
                            case $04f5fe837e55bab5$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $04f5fe837e55bab5$var$c:
                return r;
        }
    }
}
$04f5fe837e55bab5$export$a7c73072b1a182ae = $04f5fe837e55bab5$var$h;
$04f5fe837e55bab5$export$9f27bc3417b4524d = $04f5fe837e55bab5$var$g;
$04f5fe837e55bab5$export$db77ccec0bb4ccac = $04f5fe837e55bab5$var$b;
$04f5fe837e55bab5$export$8392c0c9d3dcbd35 = $04f5fe837e55bab5$var$l;
$04f5fe837e55bab5$export$ffb0004e005737fa = $04f5fe837e55bab5$var$d;
$04f5fe837e55bab5$export$b624eff549462981 = $04f5fe837e55bab5$var$q;
$04f5fe837e55bab5$export$7897aa7841a5380c = $04f5fe837e55bab5$var$p;
$04f5fe837e55bab5$export$602eac185826482c = $04f5fe837e55bab5$var$c;
$04f5fe837e55bab5$export$e2c29f18771995cb = $04f5fe837e55bab5$var$f;
$04f5fe837e55bab5$export$5f8d39834fd61797 = $04f5fe837e55bab5$var$e;
$04f5fe837e55bab5$export$74bf444e3cd11ea5 = $04f5fe837e55bab5$var$m;
$04f5fe837e55bab5$export$998bcd577473dd93 = $04f5fe837e55bab5$var$n;
$04f5fe837e55bab5$export$92387174baf9b227 = function() {
    return !1;
};
$04f5fe837e55bab5$export$ec112efeb987d9c6 = function() {
    return !1;
};
$04f5fe837e55bab5$export$b706b080d889d2c9 = function(a) {
    return $04f5fe837e55bab5$var$v(a) === $04f5fe837e55bab5$var$h;
};
$04f5fe837e55bab5$export$5be5a87408f70ddc = function(a) {
    return $04f5fe837e55bab5$var$v(a) === $04f5fe837e55bab5$var$g;
};
$04f5fe837e55bab5$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $04f5fe837e55bab5$var$b;
};
$04f5fe837e55bab5$export$455c2e768291efa6 = function(a) {
    return $04f5fe837e55bab5$var$v(a) === $04f5fe837e55bab5$var$l;
};
$04f5fe837e55bab5$export$9522e17588c12572 = function(a) {
    return $04f5fe837e55bab5$var$v(a) === $04f5fe837e55bab5$var$d;
};
$04f5fe837e55bab5$export$2110ac352bb060b9 = function(a) {
    return $04f5fe837e55bab5$var$v(a) === $04f5fe837e55bab5$var$q;
};
$04f5fe837e55bab5$export$56885ab8b9c456ab = function(a) {
    return $04f5fe837e55bab5$var$v(a) === $04f5fe837e55bab5$var$p;
};
$04f5fe837e55bab5$export$d927fcb6adf8f9de = function(a) {
    return $04f5fe837e55bab5$var$v(a) === $04f5fe837e55bab5$var$c;
};
$04f5fe837e55bab5$export$b82d16f27459e05a = function(a) {
    return $04f5fe837e55bab5$var$v(a) === $04f5fe837e55bab5$var$f;
};
$04f5fe837e55bab5$export$522c17b4f5e123e8 = function(a) {
    return $04f5fe837e55bab5$var$v(a) === $04f5fe837e55bab5$var$e;
};
$04f5fe837e55bab5$export$1aabd8a0274ecfd6 = function(a) {
    return $04f5fe837e55bab5$var$v(a) === $04f5fe837e55bab5$var$m;
};
$04f5fe837e55bab5$export$3d6c20d97e46b957 = function(a) {
    return $04f5fe837e55bab5$var$v(a) === $04f5fe837e55bab5$var$n;
};
$04f5fe837e55bab5$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $04f5fe837e55bab5$var$d || a === $04f5fe837e55bab5$var$f || a === $04f5fe837e55bab5$var$e || a === $04f5fe837e55bab5$var$m || a === $04f5fe837e55bab5$var$n || a === $04f5fe837e55bab5$var$t || "object" === typeof a && null !== a && (a.$$typeof === $04f5fe837e55bab5$var$q || a.$$typeof === $04f5fe837e55bab5$var$p || a.$$typeof === $04f5fe837e55bab5$var$g || a.$$typeof === $04f5fe837e55bab5$var$h || a.$$typeof === $04f5fe837e55bab5$var$l || a.$$typeof === $04f5fe837e55bab5$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$04f5fe837e55bab5$export$f5bbd400c2f4426f = $04f5fe837e55bab5$var$v;

});

parcelRegister("h9BkM", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $c7d03cb6b3786efb$var$isPlainObject(object) {
    if (typeof object !== 'object') return false;
    if (object == null) return false;
    if (Object.getPrototypeOf(object) === null) return true;
    if (Object.prototype.toString.call(object) !== '[object Object]') {
        const tag = object[Symbol.toStringTag];
        if (tag == null) return false;
        const isTagReadonly = !Object.getOwnPropertyDescriptor(object, Symbol.toStringTag)?.writable;
        if (isTagReadonly) return false;
        return object.toString() === `[object ${tag}]`;
    }
    let proto = object;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(object) === proto;
}
module.exports.isPlainObject = $c7d03cb6b3786efb$var$isPlainObject;

});

parcelRegister("6SGPV", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9XLXE = parcelRequire("9XLXE");

var $kR9oW = parcelRequire("kR9oW");
function $502903a780b555fd$var$range(start, end, step) {
    if (step && typeof step !== 'number' && $9XLXE.isIterateeCall(start, end, step)) end = step = undefined;
    start = $kR9oW.toFinite(start);
    if (end === undefined) {
        end = start;
        start = 0;
    } else end = $kR9oW.toFinite(end);
    step = step === undefined ? start < end ? 1 : -1 : $kR9oW.toFinite(step);
    const length = Math.max(Math.ceil((end - start) / (step || 1)), 0);
    const result = new Array(length);
    for(let index = 0; index < length; index++){
        result[index] = start;
        start += step;
    }
    return result;
}
module.exports.range = $502903a780b555fd$var$range;

});
parcelRegister("kR9oW", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $84t2z = parcelRequire("84t2z");
function $f2f00cc224cbafc4$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $84t2z.toNumber(value);
    if (value === Infinity || value === -Infinity) {
        const sign = value < 0 ? -1 : 1;
        return sign * Number.MAX_VALUE;
    }
    return value === value ? value : 0;
}
module.exports.toFinite = $f2f00cc224cbafc4$var$toFinite;

});
parcelRegister("84t2z", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $i87Ch = parcelRequire("i87Ch");
function $5e05394d694bdb29$var$toNumber(value) {
    if ($i87Ch.isSymbol(value)) return NaN;
    return Number(value);
}
module.exports.toNumber = $5e05394d694bdb29$var$toNumber;

});



parcelRegister("92NOe", function(module, exports) {

$parcel$export(module.exports, "Color", () => Color);
$parcel$export(module.exports, "darker", () => darker);
$parcel$export(module.exports, "brighter", () => brighter);
$parcel$export(module.exports, "default", () => color);
$parcel$export(module.exports, "hslConvert", () => hslConvert);
$parcel$export(module.exports, "Rgb", () => Rgb);
$parcel$export(module.exports, "rgbConvert", () => rgbConvert);
$parcel$export(module.exports, "rgb", () => rgb);
$parcel$export(module.exports, "hsl", () => hsl);

var $81yG1 = parcelRequire("81yG1");
function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, $81yG1.default)(Color, color, {
    copy (channels) {
        return Object.assign(new this.constructor, this, channels);
    },
    displayable () {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    formatHex: color_formatHex,
    formatHex8: color_formatHex8,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHex8() {
    return this.rgb().formatHex8();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb;
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $81yG1.default)(Rgb, rgb, (0, $81yG1.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb () {
        return this;
    },
    clamp () {
        return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
    },
    displayable () {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    formatHex: rgb_formatHex,
    formatHex8: rgb_formatHex8,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
    const a = clampa(this.opacity);
    return `${a === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
}
function clampa(opacity) {
    return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value) {
    return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex(value) {
    value = clampi(value);
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl;
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $81yG1.default)(Hsl, hsl, (0, $81yG1.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    clamp () {
        return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
    },
    displayable () {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl () {
        const a = clampa(this.opacity);
        return `${a === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
    }
}));
function clamph(value) {
    value = (value || 0) % 360;
    return value < 0 ? value + 360 : value;
}
function clampt(value) {
    return Math.max(0, Math.min(1, value || 0));
}
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRegister("81yG1", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d7950d3152ef672$export$2e2bcd8739ae039);
$parcel$export(module.exports, "extend", () => $5d7950d3152ef672$export$8b58be045bf06082);
function $5d7950d3152ef672$export$2e2bcd8739ae039(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $5d7950d3152ef672$export$8b58be045bf06082(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


parcelRegister("8Ce7t", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $645cd330c9789871$export$bf730a2d8bf68b42, (v) => $645cd330c9789871$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $645cd330c9789871$export$bf730a2d8bf68b42;
"use strict";

var $kc00y = parcelRequire("kc00y");
function $645cd330c9789871$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $645cd330c9789871$var$objectIs = "function" === typeof Object.is ? Object.is : $645cd330c9789871$var$is, $645cd330c9789871$var$useSyncExternalStore = $kc00y.useSyncExternalStore, $645cd330c9789871$var$useRef = $kc00y.useRef, $645cd330c9789871$var$useEffect = $kc00y.useEffect, $645cd330c9789871$var$useMemo = $kc00y.useMemo, $645cd330c9789871$var$useDebugValue = $kc00y.useDebugValue;
$645cd330c9789871$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $645cd330c9789871$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $645cd330c9789871$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($645cd330c9789871$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $645cd330c9789871$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $645cd330c9789871$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $645cd330c9789871$var$useDebugValue(value);
    return value;
};

});

parcelRegister("gSMnB", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $f0yIZ = parcelRequire("f0yIZ");

var $fng2X = parcelRequire("fng2X");

var $86CbG = parcelRequire("86CbG");

var $92YJQ = parcelRequire("92YJQ");

var $hTl9t = parcelRequire("hTl9t");
function $c4a737abe03e01b8$var$uniqBy(array, iteratee$1 = $86CbG.identity) {
    if (!$92YJQ.isArrayLikeObject(array)) return [];
    return $f0yIZ.uniqBy(Array.from(array), $fng2X.ary($hTl9t.iteratee(iteratee$1), 1));
}
module.exports.uniqBy = $c4a737abe03e01b8$var$uniqBy;

});
parcelRegister("f0yIZ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $02d1d5d996412e88$var$uniqBy(arr, mapper) {
    const map = new Map();
    for(let i = 0; i < arr.length; i++){
        const item = arr[i];
        const key = mapper(item, i, arr);
        if (!map.has(key)) map.set(key, item);
    }
    return Array.from(map.values());
}
module.exports.uniqBy = $02d1d5d996412e88$var$uniqBy;

});

parcelRegister("fng2X", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $b315738ef0b8a346$var$ary(func, n) {
    return function(...args) {
        return func.apply(this, args.slice(0, n));
    };
}
module.exports.ary = $b315738ef0b8a346$var$ary;

});

parcelRegister("86CbG", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $5e6c817aa1312417$var$identity(x) {
    return x;
}
module.exports.identity = $5e6c817aa1312417$var$identity;

});

parcelRegister("92YJQ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $2rzX1 = parcelRequire("2rzX1");

var $bpHK2 = parcelRequire("bpHK2");
function $69636a555772081c$var$isArrayLikeObject(value) {
    return $bpHK2.isObjectLike(value) && $2rzX1.isArrayLike(value);
}
module.exports.isArrayLikeObject = $69636a555772081c$var$isArrayLikeObject;

});
parcelRegister("bpHK2", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $84f3f5a613fefb85$var$isObjectLike(value) {
    return typeof value === 'object' && value !== null;
}
module.exports.isObjectLike = $84f3f5a613fefb85$var$isObjectLike;

});


parcelRegister("hTl9t", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $86CbG = parcelRequire("86CbG");

var $8sBFm = parcelRequire("8sBFm");

var $egu6p = parcelRequire("egu6p");

var $emyB2 = parcelRequire("emyB2");
function $d067fb0841cf9669$var$iteratee(value) {
    if (value == null) return $86CbG.identity;
    switch(typeof value){
        case 'function':
            return value;
        case 'object':
            if (Array.isArray(value) && value.length === 2) return $emyB2.matchesProperty(value[0], value[1]);
            return $egu6p.matches(value);
        case 'string':
        case 'symbol':
        case 'number':
            return $8sBFm.property(value);
    }
}
module.exports.iteratee = $d067fb0841cf9669$var$iteratee;

});
parcelRegister("8sBFm", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $a9nNI = parcelRequire("a9nNI");
function $628e27f2be84deae$var$property(path) {
    return function(object) {
        return $a9nNI.get(object, path);
    };
}
module.exports.property = $628e27f2be84deae$var$property;

});

parcelRegister("egu6p", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $ayzzS = parcelRequire("ayzzS");

var $4quBf = parcelRequire("4quBf");
function $a629e90576cffd7e$var$matches(source) {
    source = $4quBf.cloneDeep(source);
    return (target)=>{
        return $ayzzS.isMatch(target, source);
    };
}
module.exports.matches = $a629e90576cffd7e$var$matches;

});
parcelRegister("ayzzS", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $lSJAQ = parcelRequire("lSJAQ");
function $7af8ad5215e69d5c$var$isMatch(target, source) {
    return $lSJAQ.isMatchWith(target, source, ()=>undefined);
}
module.exports.isMatch = $7af8ad5215e69d5c$var$isMatch;

});
parcelRegister("lSJAQ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $6ZAXy = parcelRequire("6ZAXy");

var $hlAqz = parcelRequire("hlAqz");

var $6NdZx = parcelRequire("6NdZx");
function $fee20202938120d7$var$isMatchWith(target, source, compare) {
    if (typeof compare !== 'function') return $fee20202938120d7$var$isMatchWith(target, source, ()=>undefined);
    return $fee20202938120d7$var$isMatchWithInternal(target, source, function doesMatch(objValue, srcValue, key, object, source, stack) {
        const isEqual = compare(objValue, srcValue, key, object, source, stack);
        if (isEqual !== undefined) return Boolean(isEqual);
        return $fee20202938120d7$var$isMatchWithInternal(objValue, srcValue, doesMatch, stack);
    }, new Map());
}
function $fee20202938120d7$var$isMatchWithInternal(target, source, compare, stack) {
    if (source === target) return true;
    switch(typeof source){
        case 'object':
            return $fee20202938120d7$var$isObjectMatch(target, source, compare, stack);
        case 'function':
            {
                const sourceKeys = Object.keys(source);
                if (sourceKeys.length > 0) return $fee20202938120d7$var$isMatchWithInternal(target, {
                    ...source
                }, compare, stack);
                return $6NdZx.isEqualsSameValueZero(target, source);
            }
        default:
            if (!$6ZAXy.isObject(target)) return $6NdZx.isEqualsSameValueZero(target, source);
            if (typeof source === 'string') return source === '';
            return true;
    }
}
function $fee20202938120d7$var$isObjectMatch(target, source, compare, stack) {
    if (source == null) return true;
    if (Array.isArray(source)) return $fee20202938120d7$var$isArrayMatch(target, source, compare, stack);
    if (source instanceof Map) return $fee20202938120d7$var$isMapMatch(target, source, compare, stack);
    if (source instanceof Set) return $fee20202938120d7$var$isSetMatch(target, source, compare, stack);
    const keys = Object.keys(source);
    if (target == null || $hlAqz.isPrimitive(target)) return keys.length === 0;
    if (keys.length === 0) return true;
    if (stack?.has(source)) return stack.get(source) === target;
    stack?.set(source, target);
    try {
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            if (!$hlAqz.isPrimitive(target) && !(key in target)) return false;
            if (source[key] === undefined && target[key] !== undefined) return false;
            if (source[key] === null && target[key] !== null) return false;
            const isEqual = compare(target[key], source[key], key, target, source, stack);
            if (!isEqual) return false;
        }
        return true;
    } finally{
        stack?.delete(source);
    }
}
function $fee20202938120d7$var$isMapMatch(target, source, compare, stack) {
    if (source.size === 0) return true;
    if (!(target instanceof Map)) return false;
    for (const [key, sourceValue] of source.entries()){
        const targetValue = target.get(key);
        const isEqual = compare(targetValue, sourceValue, key, target, source, stack);
        if (isEqual === false) return false;
    }
    return true;
}
function $fee20202938120d7$var$isArrayMatch(target, source, compare, stack) {
    if (source.length === 0) return true;
    if (!Array.isArray(target)) return false;
    const countedIndex = new Set();
    for(let i = 0; i < source.length; i++){
        const sourceItem = source[i];
        let found = false;
        for(let j = 0; j < target.length; j++){
            if (countedIndex.has(j)) continue;
            const targetItem = target[j];
            let matches = false;
            const isEqual = compare(targetItem, sourceItem, i, target, source, stack);
            if (isEqual) matches = true;
            if (matches) {
                countedIndex.add(j);
                found = true;
                break;
            }
        }
        if (!found) return false;
    }
    return true;
}
function $fee20202938120d7$var$isSetMatch(target, source, compare, stack) {
    if (source.size === 0) return true;
    if (!(target instanceof Set)) return false;
    return $fee20202938120d7$var$isArrayMatch([
        ...target
    ], [
        ...source
    ], compare, stack);
}
module.exports.isMatchWith = $fee20202938120d7$var$isMatchWith;
module.exports.isSetMatch = $fee20202938120d7$var$isSetMatch;

});
parcelRegister("hlAqz", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $ca10a79577dcb7c3$var$isPrimitive(value) {
    return value == null || typeof value !== 'object' && typeof value !== 'function';
}
module.exports.isPrimitive = $ca10a79577dcb7c3$var$isPrimitive;

});



parcelRegister("4quBf", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $7WJ5n = parcelRequire("7WJ5n");
function $339153a217503362$var$cloneDeep(obj) {
    return $7WJ5n.cloneDeepWithImpl(obj, undefined, obj, new Map(), undefined);
}
module.exports.cloneDeep = $339153a217503362$var$cloneDeep;

});
parcelRegister("7WJ5n", function(module, exports) {

var $4qF7V = parcelRequire("4qF7V");
var $5c90ec4238de0544$require$Buffer = $4qF7V.Buffer;
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hwgT8 = parcelRequire("hwgT8");

var $dhkB9 = parcelRequire("dhkB9");

var $eAQ28 = parcelRequire("eAQ28");

var $hlAqz = parcelRequire("hlAqz");

var $fO4iK = parcelRequire("fO4iK");
function $5c90ec4238de0544$var$cloneDeepWith(obj, cloneValue) {
    return $5c90ec4238de0544$var$cloneDeepWithImpl(obj, undefined, obj, new Map(), cloneValue);
}
function $5c90ec4238de0544$var$cloneDeepWithImpl(valueToClone, keyToClone, objectToClone, stack = new Map(), cloneValue) {
    const cloned = cloneValue?.(valueToClone, keyToClone, objectToClone, stack);
    if (cloned !== undefined) return cloned;
    if ($hlAqz.isPrimitive(valueToClone)) return valueToClone;
    if (stack.has(valueToClone)) return stack.get(valueToClone);
    if (Array.isArray(valueToClone)) {
        const result = new Array(valueToClone.length);
        stack.set(valueToClone, result);
        for(let i = 0; i < valueToClone.length; i++)result[i] = $5c90ec4238de0544$var$cloneDeepWithImpl(valueToClone[i], i, objectToClone, stack, cloneValue);
        if (Object.hasOwn(valueToClone, 'index')) result.index = valueToClone.index;
        if (Object.hasOwn(valueToClone, 'input')) result.input = valueToClone.input;
        return result;
    }
    if (valueToClone instanceof Date) return new Date(valueToClone.getTime());
    if (valueToClone instanceof RegExp) {
        const result = new RegExp(valueToClone.source, valueToClone.flags);
        result.lastIndex = valueToClone.lastIndex;
        return result;
    }
    if (valueToClone instanceof Map) {
        const result = new Map();
        stack.set(valueToClone, result);
        for (const [key, value] of valueToClone)result.set(key, $5c90ec4238de0544$var$cloneDeepWithImpl(value, key, objectToClone, stack, cloneValue));
        return result;
    }
    if (valueToClone instanceof Set) {
        const result = new Set();
        stack.set(valueToClone, result);
        for (const value of valueToClone)result.add($5c90ec4238de0544$var$cloneDeepWithImpl(value, undefined, objectToClone, stack, cloneValue));
        return result;
    }
    if (typeof $5c90ec4238de0544$require$Buffer !== 'undefined' && $5c90ec4238de0544$require$Buffer.isBuffer(valueToClone)) return valueToClone.subarray();
    if ($fO4iK.isTypedArray(valueToClone)) {
        const result = new (Object.getPrototypeOf(valueToClone)).constructor(valueToClone.length);
        stack.set(valueToClone, result);
        for(let i = 0; i < valueToClone.length; i++)result[i] = $5c90ec4238de0544$var$cloneDeepWithImpl(valueToClone[i], i, objectToClone, stack, cloneValue);
        return result;
    }
    if (valueToClone instanceof ArrayBuffer || typeof SharedArrayBuffer !== 'undefined' && valueToClone instanceof SharedArrayBuffer) return valueToClone.slice(0);
    if (valueToClone instanceof DataView) {
        const result = new DataView(valueToClone.buffer.slice(0), valueToClone.byteOffset, valueToClone.byteLength);
        stack.set(valueToClone, result);
        $5c90ec4238de0544$var$copyProperties(result, valueToClone, objectToClone, stack, cloneValue);
        return result;
    }
    if (typeof File !== 'undefined' && valueToClone instanceof File) {
        const result = new File([
            valueToClone
        ], valueToClone.name, {
            type: valueToClone.type
        });
        stack.set(valueToClone, result);
        $5c90ec4238de0544$var$copyProperties(result, valueToClone, objectToClone, stack, cloneValue);
        return result;
    }
    if (typeof Blob !== 'undefined' && valueToClone instanceof Blob) {
        const result = new Blob([
            valueToClone
        ], {
            type: valueToClone.type
        });
        stack.set(valueToClone, result);
        $5c90ec4238de0544$var$copyProperties(result, valueToClone, objectToClone, stack, cloneValue);
        return result;
    }
    if (valueToClone instanceof Error) {
        const result = structuredClone(valueToClone);
        stack.set(valueToClone, result);
        result.message = valueToClone.message;
        result.name = valueToClone.name;
        result.stack = valueToClone.stack;
        result.cause = valueToClone.cause;
        result.constructor = valueToClone.constructor;
        $5c90ec4238de0544$var$copyProperties(result, valueToClone, objectToClone, stack, cloneValue);
        return result;
    }
    if (valueToClone instanceof Boolean) {
        const result = new Boolean(valueToClone.valueOf());
        stack.set(valueToClone, result);
        $5c90ec4238de0544$var$copyProperties(result, valueToClone, objectToClone, stack, cloneValue);
        return result;
    }
    if (valueToClone instanceof Number) {
        const result = new Number(valueToClone.valueOf());
        stack.set(valueToClone, result);
        $5c90ec4238de0544$var$copyProperties(result, valueToClone, objectToClone, stack, cloneValue);
        return result;
    }
    if (valueToClone instanceof String) {
        const result = new String(valueToClone.valueOf());
        stack.set(valueToClone, result);
        $5c90ec4238de0544$var$copyProperties(result, valueToClone, objectToClone, stack, cloneValue);
        return result;
    }
    if (typeof valueToClone === 'object' && $5c90ec4238de0544$var$isCloneableObject(valueToClone)) {
        const result = Object.create(Object.getPrototypeOf(valueToClone));
        stack.set(valueToClone, result);
        $5c90ec4238de0544$var$copyProperties(result, valueToClone, objectToClone, stack, cloneValue);
        return result;
    }
    return valueToClone;
}
function $5c90ec4238de0544$var$copyProperties(target, source, objectToClone = target, stack, cloneValue) {
    const keys = [
        ...Object.keys(source),
        ...$hwgT8.getSymbols(source)
    ];
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        const descriptor = Object.getOwnPropertyDescriptor(target, key);
        if (descriptor == null || descriptor.writable) target[key] = $5c90ec4238de0544$var$cloneDeepWithImpl(source[key], key, objectToClone, stack, cloneValue);
    }
}
function $5c90ec4238de0544$var$isCloneableObject(object) {
    switch($dhkB9.getTag(object)){
        case $eAQ28.argumentsTag:
        case $eAQ28.arrayTag:
        case $eAQ28.arrayBufferTag:
        case $eAQ28.dataViewTag:
        case $eAQ28.booleanTag:
        case $eAQ28.dateTag:
        case $eAQ28.float32ArrayTag:
        case $eAQ28.float64ArrayTag:
        case $eAQ28.int8ArrayTag:
        case $eAQ28.int16ArrayTag:
        case $eAQ28.int32ArrayTag:
        case $eAQ28.mapTag:
        case $eAQ28.numberTag:
        case $eAQ28.objectTag:
        case $eAQ28.regexpTag:
        case $eAQ28.setTag:
        case $eAQ28.stringTag:
        case $eAQ28.symbolTag:
        case $eAQ28.uint8ArrayTag:
        case $eAQ28.uint8ClampedArrayTag:
        case $eAQ28.uint16ArrayTag:
        case $eAQ28.uint32ArrayTag:
            return true;
        default:
            return false;
    }
}
module.exports.cloneDeepWith = $5c90ec4238de0544$var$cloneDeepWith;
module.exports.cloneDeepWithImpl = $5c90ec4238de0544$var$cloneDeepWithImpl;
module.exports.copyProperties = $5c90ec4238de0544$var$copyProperties;

});
parcelRegister("4qF7V", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $33997e13a98a2b72$export$a143d493d941bafc, (v) => $33997e13a98a2b72$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $33997e13a98a2b72$export$f99ded8fe4b79145, (v) => $33997e13a98a2b72$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $33997e13a98a2b72$export$a143d493d941bafc;
var $33997e13a98a2b72$export$e4cf37d7f6fb9e0a;
var $33997e13a98a2b72$export$f99ded8fe4b79145;
var $33997e13a98a2b72$export$599f31c3813fae4d;
'use strict';

var $RIsAv = parcelRequire("RIsAv");

var $3rPX4 = parcelRequire("3rPX4");
const $33997e13a98a2b72$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$33997e13a98a2b72$export$a143d493d941bafc = $33997e13a98a2b72$var$Buffer;
$33997e13a98a2b72$export$e4cf37d7f6fb9e0a = $33997e13a98a2b72$var$SlowBuffer;
$33997e13a98a2b72$export$f99ded8fe4b79145 = 50;
const $33997e13a98a2b72$var$K_MAX_LENGTH = 0x7fffffff;
$33997e13a98a2b72$export$599f31c3813fae4d = $33997e13a98a2b72$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $33997e13a98a2b72$var$Buffer.TYPED_ARRAY_SUPPORT = $33997e13a98a2b72$var$typedArraySupport();
if (!$33997e13a98a2b72$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $33997e13a98a2b72$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($33997e13a98a2b72$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$33997e13a98a2b72$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($33997e13a98a2b72$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$33997e13a98a2b72$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $33997e13a98a2b72$var$createBuffer(length) {
    if (length > $33997e13a98a2b72$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $33997e13a98a2b72$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $33997e13a98a2b72$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $33997e13a98a2b72$var$allocUnsafe(arg);
    }
    return $33997e13a98a2b72$var$from(arg, encodingOrOffset, length);
}
$33997e13a98a2b72$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $33997e13a98a2b72$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $33997e13a98a2b72$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $33997e13a98a2b72$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($33997e13a98a2b72$var$isInstance(value, ArrayBuffer) || value && $33997e13a98a2b72$var$isInstance(value.buffer, ArrayBuffer)) return $33997e13a98a2b72$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($33997e13a98a2b72$var$isInstance(value, SharedArrayBuffer) || value && $33997e13a98a2b72$var$isInstance(value.buffer, SharedArrayBuffer))) return $33997e13a98a2b72$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $33997e13a98a2b72$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $33997e13a98a2b72$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $33997e13a98a2b72$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $33997e13a98a2b72$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $33997e13a98a2b72$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($33997e13a98a2b72$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($33997e13a98a2b72$var$Buffer, Uint8Array);
function $33997e13a98a2b72$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $33997e13a98a2b72$var$alloc(size, fill, encoding) {
    $33997e13a98a2b72$var$assertSize(size);
    if (size <= 0) return $33997e13a98a2b72$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $33997e13a98a2b72$var$createBuffer(size).fill(fill, encoding) : $33997e13a98a2b72$var$createBuffer(size).fill(fill);
    return $33997e13a98a2b72$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $33997e13a98a2b72$var$Buffer.alloc = function(size, fill, encoding) {
    return $33997e13a98a2b72$var$alloc(size, fill, encoding);
};
function $33997e13a98a2b72$var$allocUnsafe(size) {
    $33997e13a98a2b72$var$assertSize(size);
    return $33997e13a98a2b72$var$createBuffer(size < 0 ? 0 : $33997e13a98a2b72$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $33997e13a98a2b72$var$Buffer.allocUnsafe = function(size) {
    return $33997e13a98a2b72$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $33997e13a98a2b72$var$Buffer.allocUnsafeSlow = function(size) {
    return $33997e13a98a2b72$var$allocUnsafe(size);
};
function $33997e13a98a2b72$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$33997e13a98a2b72$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $33997e13a98a2b72$var$byteLength(string, encoding) | 0;
    let buf = $33997e13a98a2b72$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $33997e13a98a2b72$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $33997e13a98a2b72$var$checked(array.length) | 0;
    const buf = $33997e13a98a2b72$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $33997e13a98a2b72$var$fromArrayView(arrayView) {
    if ($33997e13a98a2b72$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $33997e13a98a2b72$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $33997e13a98a2b72$var$fromArrayLike(arrayView);
}
function $33997e13a98a2b72$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $33997e13a98a2b72$var$Buffer.prototype);
    return buf;
}
function $33997e13a98a2b72$var$fromObject(obj) {
    if ($33997e13a98a2b72$var$Buffer.isBuffer(obj)) {
        const len = $33997e13a98a2b72$var$checked(obj.length) | 0;
        const buf = $33997e13a98a2b72$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $33997e13a98a2b72$var$numberIsNaN(obj.length)) return $33997e13a98a2b72$var$createBuffer(0);
        return $33997e13a98a2b72$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $33997e13a98a2b72$var$fromArrayLike(obj.data);
}
function $33997e13a98a2b72$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $33997e13a98a2b72$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $33997e13a98a2b72$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $33997e13a98a2b72$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $33997e13a98a2b72$var$Buffer.alloc(+length);
}
$33997e13a98a2b72$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $33997e13a98a2b72$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$33997e13a98a2b72$var$Buffer.compare = function compare(a, b) {
    if ($33997e13a98a2b72$var$isInstance(a, Uint8Array)) a = $33997e13a98a2b72$var$Buffer.from(a, a.offset, a.byteLength);
    if ($33997e13a98a2b72$var$isInstance(b, Uint8Array)) b = $33997e13a98a2b72$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$33997e13a98a2b72$var$Buffer.isBuffer(a) || !$33997e13a98a2b72$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$33997e13a98a2b72$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$33997e13a98a2b72$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $33997e13a98a2b72$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $33997e13a98a2b72$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($33997e13a98a2b72$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$33997e13a98a2b72$var$Buffer.isBuffer(buf)) buf = $33997e13a98a2b72$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$33997e13a98a2b72$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $33997e13a98a2b72$var$byteLength(string, encoding) {
    if ($33997e13a98a2b72$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $33997e13a98a2b72$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $33997e13a98a2b72$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $33997e13a98a2b72$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $33997e13a98a2b72$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$33997e13a98a2b72$var$Buffer.byteLength = $33997e13a98a2b72$var$byteLength;
function $33997e13a98a2b72$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $33997e13a98a2b72$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $33997e13a98a2b72$var$utf8Slice(this, start, end);
        case 'ascii':
            return $33997e13a98a2b72$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $33997e13a98a2b72$var$latin1Slice(this, start, end);
        case 'base64':
            return $33997e13a98a2b72$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $33997e13a98a2b72$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$33997e13a98a2b72$var$Buffer.prototype._isBuffer = true;
function $33997e13a98a2b72$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$33997e13a98a2b72$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$33997e13a98a2b72$var$swap(this, i, i + 1);
    return this;
};
$33997e13a98a2b72$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $33997e13a98a2b72$var$swap(this, i, i + 3);
        $33997e13a98a2b72$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$33997e13a98a2b72$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $33997e13a98a2b72$var$swap(this, i, i + 7);
        $33997e13a98a2b72$var$swap(this, i + 1, i + 6);
        $33997e13a98a2b72$var$swap(this, i + 2, i + 5);
        $33997e13a98a2b72$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$33997e13a98a2b72$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $33997e13a98a2b72$var$utf8Slice(this, 0, length);
    return $33997e13a98a2b72$var$slowToString.apply(this, arguments);
};
$33997e13a98a2b72$var$Buffer.prototype.toLocaleString = $33997e13a98a2b72$var$Buffer.prototype.toString;
$33997e13a98a2b72$var$Buffer.prototype.equals = function equals(b) {
    if (!$33997e13a98a2b72$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $33997e13a98a2b72$var$Buffer.compare(this, b) === 0;
};
$33997e13a98a2b72$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $33997e13a98a2b72$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($33997e13a98a2b72$var$customInspectSymbol) $33997e13a98a2b72$var$Buffer.prototype[$33997e13a98a2b72$var$customInspectSymbol] = $33997e13a98a2b72$var$Buffer.prototype.inspect;
$33997e13a98a2b72$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($33997e13a98a2b72$var$isInstance(target, Uint8Array)) target = $33997e13a98a2b72$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$33997e13a98a2b72$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $33997e13a98a2b72$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($33997e13a98a2b72$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $33997e13a98a2b72$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($33997e13a98a2b72$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $33997e13a98a2b72$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $33997e13a98a2b72$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $33997e13a98a2b72$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$33997e13a98a2b72$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$33997e13a98a2b72$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $33997e13a98a2b72$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$33997e13a98a2b72$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $33997e13a98a2b72$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $33997e13a98a2b72$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($33997e13a98a2b72$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $33997e13a98a2b72$var$utf8Write(buf, string, offset, length) {
    return $33997e13a98a2b72$var$blitBuffer($33997e13a98a2b72$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $33997e13a98a2b72$var$asciiWrite(buf, string, offset, length) {
    return $33997e13a98a2b72$var$blitBuffer($33997e13a98a2b72$var$asciiToBytes(string), buf, offset, length);
}
function $33997e13a98a2b72$var$base64Write(buf, string, offset, length) {
    return $33997e13a98a2b72$var$blitBuffer($33997e13a98a2b72$var$base64ToBytes(string), buf, offset, length);
}
function $33997e13a98a2b72$var$ucs2Write(buf, string, offset, length) {
    return $33997e13a98a2b72$var$blitBuffer($33997e13a98a2b72$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$33997e13a98a2b72$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $33997e13a98a2b72$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $33997e13a98a2b72$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $33997e13a98a2b72$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $33997e13a98a2b72$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $33997e13a98a2b72$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$33997e13a98a2b72$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $33997e13a98a2b72$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $RIsAv.fromByteArray(buf);
    else return $RIsAv.fromByteArray(buf.slice(start, end));
}
function $33997e13a98a2b72$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $33997e13a98a2b72$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $33997e13a98a2b72$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $33997e13a98a2b72$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $33997e13a98a2b72$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $33997e13a98a2b72$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $33997e13a98a2b72$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $33997e13a98a2b72$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $33997e13a98a2b72$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $33997e13a98a2b72$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $33997e13a98a2b72$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$33997e13a98a2b72$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $33997e13a98a2b72$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $33997e13a98a2b72$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$33997e13a98a2b72$var$Buffer.prototype.readUintLE = $33997e13a98a2b72$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $33997e13a98a2b72$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$33997e13a98a2b72$var$Buffer.prototype.readUintBE = $33997e13a98a2b72$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $33997e13a98a2b72$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$33997e13a98a2b72$var$Buffer.prototype.readUint8 = $33997e13a98a2b72$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $33997e13a98a2b72$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$33997e13a98a2b72$var$Buffer.prototype.readUint16LE = $33997e13a98a2b72$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $33997e13a98a2b72$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$33997e13a98a2b72$var$Buffer.prototype.readUint16BE = $33997e13a98a2b72$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $33997e13a98a2b72$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$33997e13a98a2b72$var$Buffer.prototype.readUint32LE = $33997e13a98a2b72$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $33997e13a98a2b72$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$33997e13a98a2b72$var$Buffer.prototype.readUint32BE = $33997e13a98a2b72$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $33997e13a98a2b72$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$33997e13a98a2b72$var$Buffer.prototype.readBigUInt64LE = $33997e13a98a2b72$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $33997e13a98a2b72$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $33997e13a98a2b72$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$33997e13a98a2b72$var$Buffer.prototype.readBigUInt64BE = $33997e13a98a2b72$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $33997e13a98a2b72$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $33997e13a98a2b72$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$33997e13a98a2b72$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $33997e13a98a2b72$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$33997e13a98a2b72$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $33997e13a98a2b72$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$33997e13a98a2b72$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $33997e13a98a2b72$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$33997e13a98a2b72$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $33997e13a98a2b72$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$33997e13a98a2b72$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $33997e13a98a2b72$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$33997e13a98a2b72$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $33997e13a98a2b72$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$33997e13a98a2b72$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $33997e13a98a2b72$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$33997e13a98a2b72$var$Buffer.prototype.readBigInt64LE = $33997e13a98a2b72$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $33997e13a98a2b72$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $33997e13a98a2b72$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$33997e13a98a2b72$var$Buffer.prototype.readBigInt64BE = $33997e13a98a2b72$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $33997e13a98a2b72$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $33997e13a98a2b72$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$33997e13a98a2b72$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $33997e13a98a2b72$var$checkOffset(offset, 4, this.length);
    return $3rPX4.read(this, offset, true, 23, 4);
};
$33997e13a98a2b72$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $33997e13a98a2b72$var$checkOffset(offset, 4, this.length);
    return $3rPX4.read(this, offset, false, 23, 4);
};
$33997e13a98a2b72$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $33997e13a98a2b72$var$checkOffset(offset, 8, this.length);
    return $3rPX4.read(this, offset, true, 52, 8);
};
$33997e13a98a2b72$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $33997e13a98a2b72$var$checkOffset(offset, 8, this.length);
    return $3rPX4.read(this, offset, false, 52, 8);
};
function $33997e13a98a2b72$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$33997e13a98a2b72$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$33997e13a98a2b72$var$Buffer.prototype.writeUintLE = $33997e13a98a2b72$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $33997e13a98a2b72$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$33997e13a98a2b72$var$Buffer.prototype.writeUintBE = $33997e13a98a2b72$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $33997e13a98a2b72$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$33997e13a98a2b72$var$Buffer.prototype.writeUint8 = $33997e13a98a2b72$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $33997e13a98a2b72$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$33997e13a98a2b72$var$Buffer.prototype.writeUint16LE = $33997e13a98a2b72$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $33997e13a98a2b72$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$33997e13a98a2b72$var$Buffer.prototype.writeUint16BE = $33997e13a98a2b72$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $33997e13a98a2b72$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$33997e13a98a2b72$var$Buffer.prototype.writeUint32LE = $33997e13a98a2b72$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $33997e13a98a2b72$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$33997e13a98a2b72$var$Buffer.prototype.writeUint32BE = $33997e13a98a2b72$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $33997e13a98a2b72$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $33997e13a98a2b72$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $33997e13a98a2b72$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $33997e13a98a2b72$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $33997e13a98a2b72$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$33997e13a98a2b72$var$Buffer.prototype.writeBigUInt64LE = $33997e13a98a2b72$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $33997e13a98a2b72$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$33997e13a98a2b72$var$Buffer.prototype.writeBigUInt64BE = $33997e13a98a2b72$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $33997e13a98a2b72$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$33997e13a98a2b72$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $33997e13a98a2b72$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$33997e13a98a2b72$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $33997e13a98a2b72$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$33997e13a98a2b72$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $33997e13a98a2b72$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$33997e13a98a2b72$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $33997e13a98a2b72$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$33997e13a98a2b72$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $33997e13a98a2b72$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$33997e13a98a2b72$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $33997e13a98a2b72$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$33997e13a98a2b72$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $33997e13a98a2b72$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$33997e13a98a2b72$var$Buffer.prototype.writeBigInt64LE = $33997e13a98a2b72$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $33997e13a98a2b72$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$33997e13a98a2b72$var$Buffer.prototype.writeBigInt64BE = $33997e13a98a2b72$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $33997e13a98a2b72$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $33997e13a98a2b72$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $33997e13a98a2b72$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $33997e13a98a2b72$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $3rPX4.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$33997e13a98a2b72$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $33997e13a98a2b72$var$writeFloat(this, value, offset, true, noAssert);
};
$33997e13a98a2b72$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $33997e13a98a2b72$var$writeFloat(this, value, offset, false, noAssert);
};
function $33997e13a98a2b72$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $33997e13a98a2b72$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $3rPX4.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$33997e13a98a2b72$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $33997e13a98a2b72$var$writeDouble(this, value, offset, true, noAssert);
};
$33997e13a98a2b72$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $33997e13a98a2b72$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$33997e13a98a2b72$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$33997e13a98a2b72$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$33997e13a98a2b72$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$33997e13a98a2b72$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $33997e13a98a2b72$var$Buffer.isBuffer(val) ? val : $33997e13a98a2b72$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $33997e13a98a2b72$var$errors = {};
function $33997e13a98a2b72$var$E(sym, getMessage, Base) {
    $33997e13a98a2b72$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$33997e13a98a2b72$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$33997e13a98a2b72$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$33997e13a98a2b72$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $33997e13a98a2b72$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $33997e13a98a2b72$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $33997e13a98a2b72$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $33997e13a98a2b72$var$checkBounds(buf, offset, byteLength) {
    $33997e13a98a2b72$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $33997e13a98a2b72$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $33997e13a98a2b72$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $33997e13a98a2b72$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $33997e13a98a2b72$var$checkBounds(buf, offset, byteLength);
}
function $33997e13a98a2b72$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $33997e13a98a2b72$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $33997e13a98a2b72$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $33997e13a98a2b72$var$validateNumber(value, type);
        throw new $33997e13a98a2b72$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $33997e13a98a2b72$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $33997e13a98a2b72$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $33997e13a98a2b72$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $33997e13a98a2b72$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($33997e13a98a2b72$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $33997e13a98a2b72$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $33997e13a98a2b72$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $33997e13a98a2b72$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $33997e13a98a2b72$var$base64ToBytes(str) {
    return $RIsAv.toByteArray($33997e13a98a2b72$var$base64clean(str));
}
function $33997e13a98a2b72$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $33997e13a98a2b72$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $33997e13a98a2b72$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $33997e13a98a2b72$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $33997e13a98a2b72$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $33997e13a98a2b72$var$BufferBigIntNotDefined : fn;
}
function $33997e13a98a2b72$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("RIsAv", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $0a1770335400cc9d$export$d622b2ad8d90c771, (v) => $0a1770335400cc9d$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $0a1770335400cc9d$export$6100ba28696e12de, (v) => $0a1770335400cc9d$export$6100ba28696e12de = v);
var $0a1770335400cc9d$export$a48f0734ac7c2329;
var $0a1770335400cc9d$export$d622b2ad8d90c771;
var $0a1770335400cc9d$export$6100ba28696e12de;
'use strict';
$0a1770335400cc9d$export$a48f0734ac7c2329 = $0a1770335400cc9d$var$byteLength;
$0a1770335400cc9d$export$d622b2ad8d90c771 = $0a1770335400cc9d$var$toByteArray;
$0a1770335400cc9d$export$6100ba28696e12de = $0a1770335400cc9d$var$fromByteArray;
var $0a1770335400cc9d$var$lookup = [];
var $0a1770335400cc9d$var$revLookup = [];
var $0a1770335400cc9d$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $0a1770335400cc9d$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $0a1770335400cc9d$var$i = 0, $0a1770335400cc9d$var$len = $0a1770335400cc9d$var$code.length; $0a1770335400cc9d$var$i < $0a1770335400cc9d$var$len; ++$0a1770335400cc9d$var$i){
    $0a1770335400cc9d$var$lookup[$0a1770335400cc9d$var$i] = $0a1770335400cc9d$var$code[$0a1770335400cc9d$var$i];
    $0a1770335400cc9d$var$revLookup[$0a1770335400cc9d$var$code.charCodeAt($0a1770335400cc9d$var$i)] = $0a1770335400cc9d$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$0a1770335400cc9d$var$revLookup['-'.charCodeAt(0)] = 62;
$0a1770335400cc9d$var$revLookup['_'.charCodeAt(0)] = 63;
function $0a1770335400cc9d$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $0a1770335400cc9d$var$byteLength(b64) {
    var lens = $0a1770335400cc9d$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $0a1770335400cc9d$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $0a1770335400cc9d$var$toByteArray(b64) {
    var tmp;
    var lens = $0a1770335400cc9d$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $0a1770335400cc9d$var$Arr($0a1770335400cc9d$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $0a1770335400cc9d$var$revLookup[b64.charCodeAt(i)] << 18 | $0a1770335400cc9d$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $0a1770335400cc9d$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $0a1770335400cc9d$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $0a1770335400cc9d$var$revLookup[b64.charCodeAt(i)] << 2 | $0a1770335400cc9d$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $0a1770335400cc9d$var$revLookup[b64.charCodeAt(i)] << 10 | $0a1770335400cc9d$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $0a1770335400cc9d$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $0a1770335400cc9d$var$tripletToBase64(num) {
    return $0a1770335400cc9d$var$lookup[num >> 18 & 0x3F] + $0a1770335400cc9d$var$lookup[num >> 12 & 0x3F] + $0a1770335400cc9d$var$lookup[num >> 6 & 0x3F] + $0a1770335400cc9d$var$lookup[num & 0x3F];
}
function $0a1770335400cc9d$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($0a1770335400cc9d$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $0a1770335400cc9d$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($0a1770335400cc9d$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($0a1770335400cc9d$var$lookup[tmp >> 2] + $0a1770335400cc9d$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($0a1770335400cc9d$var$lookup[tmp >> 10] + $0a1770335400cc9d$var$lookup[tmp >> 4 & 0x3F] + $0a1770335400cc9d$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("3rPX4", function(module, exports) {

$parcel$export(module.exports, "read", () => $282c3139d9299a00$export$aafa59e2e03f2942, (v) => $282c3139d9299a00$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $282c3139d9299a00$export$68d8715fc104d294, (v) => $282c3139d9299a00$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $282c3139d9299a00$export$aafa59e2e03f2942;
var $282c3139d9299a00$export$68d8715fc104d294;
$282c3139d9299a00$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$282c3139d9299a00$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("hwgT8", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $cc1286769ca327a7$var$getSymbols(object) {
    return Object.getOwnPropertySymbols(object).filter((symbol)=>Object.prototype.propertyIsEnumerable.call(object, symbol));
}
module.exports.getSymbols = $cc1286769ca327a7$var$getSymbols;

});

parcelRegister("dhkB9", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $9aacd744f4e9dcd3$var$getTag(value) {
    if (value == null) return value === undefined ? '[object Undefined]' : '[object Null]';
    return Object.prototype.toString.call(value);
}
module.exports.getTag = $9aacd744f4e9dcd3$var$getTag;

});

parcelRegister("eAQ28", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $a9fcca4008ce65bf$var$regexpTag = '[object RegExp]';
const $a9fcca4008ce65bf$var$stringTag = '[object String]';
const $a9fcca4008ce65bf$var$numberTag = '[object Number]';
const $a9fcca4008ce65bf$var$booleanTag = '[object Boolean]';
const $a9fcca4008ce65bf$var$argumentsTag = '[object Arguments]';
const $a9fcca4008ce65bf$var$symbolTag = '[object Symbol]';
const $a9fcca4008ce65bf$var$dateTag = '[object Date]';
const $a9fcca4008ce65bf$var$mapTag = '[object Map]';
const $a9fcca4008ce65bf$var$setTag = '[object Set]';
const $a9fcca4008ce65bf$var$arrayTag = '[object Array]';
const $a9fcca4008ce65bf$var$functionTag = '[object Function]';
const $a9fcca4008ce65bf$var$arrayBufferTag = '[object ArrayBuffer]';
const $a9fcca4008ce65bf$var$objectTag = '[object Object]';
const $a9fcca4008ce65bf$var$errorTag = '[object Error]';
const $a9fcca4008ce65bf$var$dataViewTag = '[object DataView]';
const $a9fcca4008ce65bf$var$uint8ArrayTag = '[object Uint8Array]';
const $a9fcca4008ce65bf$var$uint8ClampedArrayTag = '[object Uint8ClampedArray]';
const $a9fcca4008ce65bf$var$uint16ArrayTag = '[object Uint16Array]';
const $a9fcca4008ce65bf$var$uint32ArrayTag = '[object Uint32Array]';
const $a9fcca4008ce65bf$var$bigUint64ArrayTag = '[object BigUint64Array]';
const $a9fcca4008ce65bf$var$int8ArrayTag = '[object Int8Array]';
const $a9fcca4008ce65bf$var$int16ArrayTag = '[object Int16Array]';
const $a9fcca4008ce65bf$var$int32ArrayTag = '[object Int32Array]';
const $a9fcca4008ce65bf$var$bigInt64ArrayTag = '[object BigInt64Array]';
const $a9fcca4008ce65bf$var$float32ArrayTag = '[object Float32Array]';
const $a9fcca4008ce65bf$var$float64ArrayTag = '[object Float64Array]';
module.exports.argumentsTag = $a9fcca4008ce65bf$var$argumentsTag;
module.exports.arrayBufferTag = $a9fcca4008ce65bf$var$arrayBufferTag;
module.exports.arrayTag = $a9fcca4008ce65bf$var$arrayTag;
module.exports.bigInt64ArrayTag = $a9fcca4008ce65bf$var$bigInt64ArrayTag;
module.exports.bigUint64ArrayTag = $a9fcca4008ce65bf$var$bigUint64ArrayTag;
module.exports.booleanTag = $a9fcca4008ce65bf$var$booleanTag;
module.exports.dataViewTag = $a9fcca4008ce65bf$var$dataViewTag;
module.exports.dateTag = $a9fcca4008ce65bf$var$dateTag;
module.exports.errorTag = $a9fcca4008ce65bf$var$errorTag;
module.exports.float32ArrayTag = $a9fcca4008ce65bf$var$float32ArrayTag;
module.exports.float64ArrayTag = $a9fcca4008ce65bf$var$float64ArrayTag;
module.exports.functionTag = $a9fcca4008ce65bf$var$functionTag;
module.exports.int16ArrayTag = $a9fcca4008ce65bf$var$int16ArrayTag;
module.exports.int32ArrayTag = $a9fcca4008ce65bf$var$int32ArrayTag;
module.exports.int8ArrayTag = $a9fcca4008ce65bf$var$int8ArrayTag;
module.exports.mapTag = $a9fcca4008ce65bf$var$mapTag;
module.exports.numberTag = $a9fcca4008ce65bf$var$numberTag;
module.exports.objectTag = $a9fcca4008ce65bf$var$objectTag;
module.exports.regexpTag = $a9fcca4008ce65bf$var$regexpTag;
module.exports.setTag = $a9fcca4008ce65bf$var$setTag;
module.exports.stringTag = $a9fcca4008ce65bf$var$stringTag;
module.exports.symbolTag = $a9fcca4008ce65bf$var$symbolTag;
module.exports.uint16ArrayTag = $a9fcca4008ce65bf$var$uint16ArrayTag;
module.exports.uint32ArrayTag = $a9fcca4008ce65bf$var$uint32ArrayTag;
module.exports.uint8ArrayTag = $a9fcca4008ce65bf$var$uint8ArrayTag;
module.exports.uint8ClampedArrayTag = $a9fcca4008ce65bf$var$uint8ClampedArrayTag;

});

parcelRegister("fO4iK", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $b81edcac1cf2e38b$var$isTypedArray(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}
module.exports.isTypedArray = $b81edcac1cf2e38b$var$isTypedArray;

});




parcelRegister("emyB2", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $ayzzS = parcelRequire("ayzzS");

var $65cio = parcelRequire("65cio");

var $25Ix9 = parcelRequire("25Ix9");

var $a9nNI = parcelRequire("a9nNI");

var $bcjIL = parcelRequire("bcjIL");
function $a74df4e5c86048f5$var$matchesProperty(property, source) {
    switch(typeof property){
        case 'object':
            if (Object.is(property?.valueOf(), -0)) property = '-0';
            break;
        case 'number':
            property = $65cio.toKey(property);
            break;
    }
    source = $25Ix9.cloneDeep(source);
    return function(target) {
        const result = $a9nNI.get(target, property);
        if (result === undefined) return $bcjIL.has(target, property);
        if (source === undefined) return result === undefined;
        return $ayzzS.isMatch(result, source);
    };
}
module.exports.matchesProperty = $a74df4e5c86048f5$var$matchesProperty;

});
parcelRegister("25Ix9", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $62Eho = parcelRequire("62Eho");
function $185e97e32f781444$var$cloneDeep(obj) {
    return $62Eho.cloneDeepWith(obj);
}
module.exports.cloneDeep = $185e97e32f781444$var$cloneDeep;

});
parcelRegister("62Eho", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $7WJ5n = parcelRequire("7WJ5n");

var $dhkB9 = parcelRequire("dhkB9");

var $eAQ28 = parcelRequire("eAQ28");
function $46622ca68f9b0f5c$var$cloneDeepWith(obj, customizer) {
    return $7WJ5n.cloneDeepWith(obj, (value, key, object, stack)=>{
        const cloned = customizer?.(value, key, object, stack);
        if (cloned !== undefined) return cloned;
        if (typeof obj !== 'object') return undefined;
        if ($dhkB9.getTag(obj) === $eAQ28.objectTag && typeof obj.constructor !== 'function') {
            const result = {};
            stack.set(obj, result);
            $7WJ5n.copyProperties(result, obj, object, stack);
            return result;
        }
        switch(Object.prototype.toString.call(obj)){
            case $eAQ28.numberTag:
            case $eAQ28.stringTag:
            case $eAQ28.booleanTag:
                {
                    const result = new obj.constructor(obj?.valueOf());
                    $7WJ5n.copyProperties(result, obj);
                    return result;
                }
            case $eAQ28.argumentsTag:
                {
                    const result = {};
                    $7WJ5n.copyProperties(result, obj);
                    result.length = obj.length;
                    result[Symbol.iterator] = obj[Symbol.iterator];
                    return result;
                }
            default:
                return undefined;
        }
    });
}
module.exports.cloneDeepWith = $46622ca68f9b0f5c$var$cloneDeepWith;

});


parcelRegister("bcjIL", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $guJWw = parcelRequire("guJWw");

var $70VIQ = parcelRequire("70VIQ");

var $xA6Zk = parcelRequire("xA6Zk");

var $9JGc3 = parcelRequire("9JGc3");
function $82701cdcd8e30c76$var$has(object, path) {
    let resolvedPath;
    if (Array.isArray(path)) resolvedPath = path;
    else if (typeof path === 'string' && $guJWw.isDeepKey(path) && object?.[path] == null) resolvedPath = $9JGc3.toPath(path);
    else resolvedPath = [
        path
    ];
    if (resolvedPath.length === 0) return false;
    let current = object;
    for(let i = 0; i < resolvedPath.length; i++){
        const key = resolvedPath[i];
        if (current == null || !Object.hasOwn(current, key)) {
            const isSparseIndex = (Array.isArray(current) || $xA6Zk.isArguments(current)) && $70VIQ.isIndex(key) && key < current.length;
            if (!isSparseIndex) return false;
        }
        current = current[key];
    }
    return true;
}
module.exports.has = $82701cdcd8e30c76$var$has;

});
parcelRegister("xA6Zk", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $dhkB9 = parcelRequire("dhkB9");
function $064f1837578a5ffe$var$isArguments(value) {
    return value !== null && typeof value === 'object' && $dhkB9.getTag(value) === '[object Arguments]';
}
module.exports.isArguments = $064f1837578a5ffe$var$isArguments;

});





parcelRegister("avW6N", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CSVLink = module.exports.CSVDownload = undefined;

var $6VXgY = parcelRequire("6VXgY");
var $7a79dfc77116ade8$var$_Download2 = $7a79dfc77116ade8$var$_interopRequireDefault($6VXgY);

var $frmQr = parcelRequire("frmQr");
var $7a79dfc77116ade8$var$_Link2 = $7a79dfc77116ade8$var$_interopRequireDefault($frmQr);
function $7a79dfc77116ade8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $7a79dfc77116ade8$var$CSVDownload = module.exports.CSVDownload = $7a79dfc77116ade8$var$_Download2.default;
var $7a79dfc77116ade8$var$CSVLink = module.exports.CSVLink = $7a79dfc77116ade8$var$_Link2.default;

});
parcelRegister("6VXgY", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $014d844fb2f56f5f$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $kc00y = parcelRequire("kc00y");
var $014d844fb2f56f5f$var$_react2 = $014d844fb2f56f5f$var$_interopRequireDefault($kc00y);

var $eukxq = parcelRequire("eukxq");

var $aGLfc = parcelRequire("aGLfc");
function $014d844fb2f56f5f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $014d844fb2f56f5f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $014d844fb2f56f5f$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $014d844fb2f56f5f$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $014d844fb2f56f5f$var$defaultProps = {
    target: '_blank'
};
var $014d844fb2f56f5f$var$CSVDownload = function(_React$Component) {
    $014d844fb2f56f5f$var$_inherits(CSVDownload, _React$Component);
    function CSVDownload(props) {
        $014d844fb2f56f5f$var$_classCallCheck(this, CSVDownload);
        var _this = $014d844fb2f56f5f$var$_possibleConstructorReturn(this, (CSVDownload.__proto__ || Object.getPrototypeOf(CSVDownload)).call(this, props));
        _this.state = {};
        return _this;
    }
    $014d844fb2f56f5f$var$_createClass(CSVDownload, [
        {
            key: 'buildURI',
            value: function buildURI() {
                return $eukxq.buildURI.apply(undefined, arguments);
            }
        },
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                var _props = this.props, data = _props.data, headers = _props.headers, separator = _props.separator, enclosingCharacter = _props.enclosingCharacter, uFEFF = _props.uFEFF, target = _props.target, specs = _props.specs, replace = _props.replace;
                this.state.page = window.open(this.buildURI(data, uFEFF, headers, separator, enclosingCharacter), target, specs, replace);
            }
        },
        {
            key: 'getWindow',
            value: function getWindow() {
                return this.state.page;
            }
        },
        {
            key: 'render',
            value: function render() {
                return null;
            }
        }
    ]);
    return CSVDownload;
}($014d844fb2f56f5f$var$_react2.default.Component);
$014d844fb2f56f5f$var$CSVDownload.defaultProps = Object.assign($aGLfc.defaultProps, $014d844fb2f56f5f$var$defaultProps);
$014d844fb2f56f5f$var$CSVDownload.propTypes = $aGLfc.propTypes;
module.exports.default = $014d844fb2f56f5f$var$CSVDownload;

});
parcelRegister("eukxq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $a8c3cc7aaca3f190$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
function $a8c3cc7aaca3f190$var$_toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    } else return Array.from(arr);
}
var $a8c3cc7aaca3f190$var$isSafari = module.exports.isSafari = function isSafari() {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
};
var $a8c3cc7aaca3f190$var$isJsons = module.exports.isJsons = function isJsons(array) {
    return Array.isArray(array) && array.every(function(row) {
        return (typeof row === "undefined" ? "undefined" : $a8c3cc7aaca3f190$var$_typeof(row)) === 'object' && !(row instanceof Array);
    });
};
var $a8c3cc7aaca3f190$var$isArrays = module.exports.isArrays = function isArrays(array) {
    return Array.isArray(array) && array.every(function(row) {
        return Array.isArray(row);
    });
};
var $a8c3cc7aaca3f190$var$jsonsHeaders = module.exports.jsonsHeaders = function jsonsHeaders(array) {
    return Array.from(array.map(function(json) {
        return Object.keys(json);
    }).reduce(function(a, b) {
        return new Set([].concat($a8c3cc7aaca3f190$var$_toConsumableArray(a), $a8c3cc7aaca3f190$var$_toConsumableArray(b)));
    }, []));
};
var $a8c3cc7aaca3f190$var$jsons2arrays = module.exports.jsons2arrays = function jsons2arrays(jsons, headers) {
    headers = headers || $a8c3cc7aaca3f190$var$jsonsHeaders(jsons);
    var headerLabels = headers;
    var headerKeys = headers;
    if ($a8c3cc7aaca3f190$var$isJsons(headers)) {
        headerLabels = headers.map(function(header) {
            return header.label;
        });
        headerKeys = headers.map(function(header) {
            return header.key;
        });
    }
    var data = jsons.map(function(object) {
        return headerKeys.map(function(header) {
            return $a8c3cc7aaca3f190$var$getHeaderValue(header, object);
        });
    });
    return [
        headerLabels
    ].concat($a8c3cc7aaca3f190$var$_toConsumableArray(data));
};
var $a8c3cc7aaca3f190$var$getHeaderValue = module.exports.getHeaderValue = function getHeaderValue(property, obj) {
    var foundValue = property.replace(/\[([^\]]+)]/g, ".$1").split(".").reduce(function(o, p, i, arr) {
        var value = o[p];
        if (value === undefined || value === null) arr.splice(1);
        else return value;
    }, obj);
    return foundValue === undefined ? property in obj ? obj[property] : '' : foundValue;
};
var $a8c3cc7aaca3f190$var$elementOrEmpty = module.exports.elementOrEmpty = function elementOrEmpty(element) {
    return typeof element === 'undefined' || element === null ? '' : element;
};
var $a8c3cc7aaca3f190$var$joiner = module.exports.joiner = function joiner(data) {
    var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ',';
    var enclosingCharacter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '"';
    return data.filter(function(e) {
        return e;
    }).map(function(row) {
        return row.map(function(element) {
            return $a8c3cc7aaca3f190$var$elementOrEmpty(element);
        }).map(function(column) {
            return "" + enclosingCharacter + column + enclosingCharacter;
        }).join(separator);
    }).join("\n");
};
var $a8c3cc7aaca3f190$var$arrays2csv = module.exports.arrays2csv = function arrays2csv(data, headers, separator, enclosingCharacter) {
    return $a8c3cc7aaca3f190$var$joiner(headers ? [
        headers
    ].concat($a8c3cc7aaca3f190$var$_toConsumableArray(data)) : data, separator, enclosingCharacter);
};
var $a8c3cc7aaca3f190$var$jsons2csv = module.exports.jsons2csv = function jsons2csv(data, headers, separator, enclosingCharacter) {
    return $a8c3cc7aaca3f190$var$joiner($a8c3cc7aaca3f190$var$jsons2arrays(data, headers), separator, enclosingCharacter);
};
var $a8c3cc7aaca3f190$var$string2csv = module.exports.string2csv = function string2csv(data, headers, separator, enclosingCharacter) {
    return headers ? headers.join(separator) + "\n" + data : data.replace(/"/g, '""');
};
var $a8c3cc7aaca3f190$var$toCSV = module.exports.toCSV = function toCSV(data, headers, separator, enclosingCharacter) {
    if ($a8c3cc7aaca3f190$var$isJsons(data)) return $a8c3cc7aaca3f190$var$jsons2csv(data, headers, separator, enclosingCharacter);
    if ($a8c3cc7aaca3f190$var$isArrays(data)) return $a8c3cc7aaca3f190$var$arrays2csv(data, headers, separator, enclosingCharacter);
    if (typeof data === 'string') return $a8c3cc7aaca3f190$var$string2csv(data, headers, separator);
    throw new TypeError("Data should be a \"String\", \"Array of arrays\" OR \"Array of objects\" ");
};
var $a8c3cc7aaca3f190$var$buildURI = module.exports.buildURI = function buildURI(data, uFEFF, headers, separator, enclosingCharacter) {
    var csv = $a8c3cc7aaca3f190$var$toCSV(data, headers, separator, enclosingCharacter);
    var type = $a8c3cc7aaca3f190$var$isSafari() ? 'application/csv' : 'text/csv';
    var blob = new Blob([
        uFEFF ? "\uFEFF" : '',
        csv
    ], {
        type: type
    });
    var dataURI = "data:" + type + ";charset=utf-8," + (uFEFF ? "\uFEFF" : '') + csv;
    var URL = window.URL || window.webkitURL;
    return typeof URL.createObjectURL === 'undefined' ? dataURI : URL.createObjectURL(blob);
};

});

parcelRegister("aGLfc", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PropsNotForwarded = module.exports.defaultProps = module.exports.propTypes = undefined;

var $kc00y = parcelRequire("kc00y");
var $7c8279520991b3c9$var$_react2 = $7c8279520991b3c9$var$_interopRequireDefault($kc00y);

var $lCkAA = parcelRequire("lCkAA");
function $7c8279520991b3c9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $7c8279520991b3c9$var$propTypes = module.exports.propTypes = {
    data: (0, $lCkAA.oneOfType)([
        $lCkAA.string,
        $lCkAA.array,
        $lCkAA.func
    ]).isRequired,
    headers: $lCkAA.array,
    target: $lCkAA.string,
    separator: $lCkAA.string,
    filename: $lCkAA.string,
    uFEFF: $lCkAA.bool,
    onClick: $lCkAA.func,
    asyncOnClick: $lCkAA.bool,
    enclosingCharacter: $lCkAA.string
};
var $7c8279520991b3c9$var$defaultProps = module.exports.defaultProps = {
    separator: ',',
    filename: 'generatedBy_react-csv.csv',
    uFEFF: true,
    asyncOnClick: false,
    enclosingCharacter: '"'
};
var $7c8279520991b3c9$var$PropsNotForwarded = module.exports.PropsNotForwarded = [
    'data',
    'headers'
];

});


parcelRegister("frmQr", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $b3db19248f1c7da6$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $b3db19248f1c7da6$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $kc00y = parcelRequire("kc00y");
var $b3db19248f1c7da6$var$_react2 = $b3db19248f1c7da6$var$_interopRequireDefault($kc00y);

var $eukxq = parcelRequire("eukxq");

var $aGLfc = parcelRequire("aGLfc");
function $b3db19248f1c7da6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b3db19248f1c7da6$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $b3db19248f1c7da6$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $b3db19248f1c7da6$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $b3db19248f1c7da6$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $b3db19248f1c7da6$var$CSVLink = function(_React$Component) {
    $b3db19248f1c7da6$var$_inherits(CSVLink, _React$Component);
    function CSVLink(props) {
        $b3db19248f1c7da6$var$_classCallCheck(this, CSVLink);
        var _this = $b3db19248f1c7da6$var$_possibleConstructorReturn(this, (CSVLink.__proto__ || Object.getPrototypeOf(CSVLink)).call(this, props));
        _this.buildURI = _this.buildURI.bind(_this);
        return _this;
    }
    $b3db19248f1c7da6$var$_createClass(CSVLink, [
        {
            key: 'buildURI',
            value: function buildURI() {
                return $eukxq.buildURI.apply(undefined, arguments);
            }
        },
        {
            key: 'handleLegacy',
            value: function handleLegacy(event) {
                var isAsync = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                if (window.navigator.msSaveOrOpenBlob) {
                    event.preventDefault();
                    var _props = this.props, data = _props.data, headers = _props.headers, separator = _props.separator, filename = _props.filename, enclosingCharacter = _props.enclosingCharacter, uFEFF = _props.uFEFF;
                    var csvData = isAsync && typeof data === 'function' ? data() : data;
                    var blob = new Blob([
                        uFEFF ? '\uFEFF' : '',
                        (0, $eukxq.toCSV)(csvData, headers, separator, enclosingCharacter)
                    ]);
                    window.navigator.msSaveBlob(blob, filename);
                    return false;
                }
            }
        },
        {
            key: 'handleAsyncClick',
            value: function handleAsyncClick(event) {
                var _this2 = this;
                var done = function done(proceed) {
                    if (proceed === false) {
                        event.preventDefault();
                        return;
                    }
                    _this2.handleLegacy(event, true);
                };
                this.props.onClick(event, done);
            }
        },
        {
            key: 'handleSyncClick',
            value: function handleSyncClick(event) {
                var stopEvent = this.props.onClick(event) === false;
                if (stopEvent) {
                    event.preventDefault();
                    return;
                }
                this.handleLegacy(event);
            }
        },
        {
            key: 'handleClick',
            value: function handleClick() {
                var _this3 = this;
                return function(event) {
                    if (typeof _this3.props.onClick === 'function') return _this3.props.asyncOnClick ? _this3.handleAsyncClick(event) : _this3.handleSyncClick(event);
                    _this3.handleLegacy(event);
                };
            }
        },
        {
            key: 'render',
            value: function render() {
                var _this4 = this;
                var _props2 = this.props, data = _props2.data, headers = _props2.headers, separator = _props2.separator, filename = _props2.filename, uFEFF = _props2.uFEFF, children = _props2.children, onClick = _props2.onClick, asyncOnClick = _props2.asyncOnClick, enclosingCharacter = _props2.enclosingCharacter, rest = $b3db19248f1c7da6$var$_objectWithoutProperties(_props2, [
                    'data',
                    'headers',
                    'separator',
                    'filename',
                    'uFEFF',
                    'children',
                    'onClick',
                    'asyncOnClick',
                    'enclosingCharacter'
                ]);
                var isNodeEnvironment = typeof window === 'undefined';
                var href = isNodeEnvironment ? '' : this.buildURI(data, uFEFF, headers, separator, enclosingCharacter);
                return $b3db19248f1c7da6$var$_react2.default.createElement('a', $b3db19248f1c7da6$var$_extends({
                    download: filename
                }, rest, {
                    ref: function ref(link) {
                        return _this4.link = link;
                    },
                    target: '_self',
                    href: href,
                    onClick: this.handleClick()
                }), children);
            }
        }
    ]);
    return CSVLink;
}($b3db19248f1c7da6$var$_react2.default.Component);
$b3db19248f1c7da6$var$CSVLink.defaultProps = $aGLfc.defaultProps;
$b3db19248f1c7da6$var$CSVLink.propTypes = $aGLfc.propTypes;
module.exports.default = $b3db19248f1c7da6$var$CSVLink;

});


var $bb3c8a906e7435b6$exports = {};
$parcel$extendImportMap({
    "aF9ma": "atolcd.dd1d4825.png",
    "aZ5qj": "europe.a06bc871.png",
    "ljb8U": "europesengage.e2d741fc.png",
    "lH6OC": "logo_prt3.60b6dc10.png",
    "4EvLf": "pdf.worker.min.29921527.js",
    "5ugjC": "rci.bc7afc7d.png",
    "2Fh4p": "rci-before.d43259a8.png"
});

var $948296388fc3e3c9$exports = {};
'use strict';

$948296388fc3e3c9$exports = (parcelRequire("getKs"));


var $945b3b548e437ca7$exports = {};

$parcel$export($945b3b548e437ca7$exports, "createRoot", () => $945b3b548e437ca7$export$882461b6382ed46c, (v) => $945b3b548e437ca7$export$882461b6382ed46c = v);
$parcel$export($945b3b548e437ca7$exports, "hydrateRoot", () => $945b3b548e437ca7$export$757ceba2d55c277e, (v) => $945b3b548e437ca7$export$757ceba2d55c277e = v);
var $945b3b548e437ca7$export$882461b6382ed46c;
var $945b3b548e437ca7$export$757ceba2d55c277e;
'use strict';
var $9018fd8b87cabbb7$exports = {};
'use strict';
function $9018fd8b87cabbb7$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($9018fd8b87cabbb7$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$9018fd8b87cabbb7$var$checkDCE();

$9018fd8b87cabbb7$exports = (parcelRequire("63uH6"));


var $945b3b548e437ca7$var$i;
$945b3b548e437ca7$export$882461b6382ed46c = $9018fd8b87cabbb7$exports.createRoot;
$945b3b548e437ca7$export$757ceba2d55c277e = $9018fd8b87cabbb7$exports.hydrateRoot;



/**
 * React Router DOM v6.30.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $kc00y = parcelRequire("kc00y");

/**
 * @remix-run/router v1.23.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $65d539d52291a3d6$var$_extends() {
    $65d539d52291a3d6$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $65d539d52291a3d6$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $65d539d52291a3d6$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($65d539d52291a3d6$export$e19cd5f9376f8cee || ($65d539d52291a3d6$export$e19cd5f9376f8cee = {}));
const $65d539d52291a3d6$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $65d539d52291a3d6$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $65d539d52291a3d6$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $65d539d52291a3d6$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $65d539d52291a3d6$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $65d539d52291a3d6$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $65d539d52291a3d6$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $65d539d52291a3d6$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $65d539d52291a3d6$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $65d539d52291a3d6$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $65d539d52291a3d6$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $65d539d52291a3d6$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $65d539d52291a3d6$export$fe53371bee54353d(to);
    }
    return $65d539d52291a3d6$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $65d539d52291a3d6$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $65d539d52291a3d6$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $65d539d52291a3d6$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $65d539d52291a3d6$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $65d539d52291a3d6$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $65d539d52291a3d6$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $65d539d52291a3d6$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $65d539d52291a3d6$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $65d539d52291a3d6$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $65d539d52291a3d6$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $65d539d52291a3d6$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $65d539d52291a3d6$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $65d539d52291a3d6$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $65d539d52291a3d6$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $65d539d52291a3d6$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $65d539d52291a3d6$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $65d539d52291a3d6$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $65d539d52291a3d6$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($65d539d52291a3d6$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $65d539d52291a3d6$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $65d539d52291a3d6$export$e19cd5f9376f8cee.Push;
        let location = $65d539d52291a3d6$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $65d539d52291a3d6$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $65d539d52291a3d6$export$e19cd5f9376f8cee.Replace;
        let location = $65d539d52291a3d6$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $65d539d52291a3d6$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $65d539d52291a3d6$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $65d539d52291a3d6$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($65d539d52291a3d6$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($65d539d52291a3d6$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $65d539d52291a3d6$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($65d539d52291a3d6$var$ResultType || ($65d539d52291a3d6$var$ResultType = {}));
const $65d539d52291a3d6$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $65d539d52291a3d6$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $65d539d52291a3d6$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $65d539d52291a3d6$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $65d539d52291a3d6$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($65d539d52291a3d6$var$isIndexRoute(route)) {
            let indexRoute = $65d539d52291a3d6$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $65d539d52291a3d6$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $65d539d52291a3d6$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $65d539d52291a3d6$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $65d539d52291a3d6$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $65d539d52291a3d6$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $65d539d52291a3d6$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $65d539d52291a3d6$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $65d539d52291a3d6$var$flattenRoutes(routes);
    $65d539d52291a3d6$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $65d539d52291a3d6$export$30d21fd6d7295f52(pathname);
        matches = $65d539d52291a3d6$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $65d539d52291a3d6$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $65d539d52291a3d6$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $65d539d52291a3d6$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $65d539d52291a3d6$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $65d539d52291a3d6$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $65d539d52291a3d6$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $65d539d52291a3d6$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $65d539d52291a3d6$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $65d539d52291a3d6$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $65d539d52291a3d6$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $65d539d52291a3d6$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $65d539d52291a3d6$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $65d539d52291a3d6$var$paramRe = /^:[\w-]+$/;
const $65d539d52291a3d6$var$dynamicSegmentValue = 3;
const $65d539d52291a3d6$var$indexRouteValue = 2;
const $65d539d52291a3d6$var$emptySegmentValue = 1;
const $65d539d52291a3d6$var$staticSegmentValue = 10;
const $65d539d52291a3d6$var$splatPenalty = -2;
const $65d539d52291a3d6$var$isSplat = (s)=>s === "*";
function $65d539d52291a3d6$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($65d539d52291a3d6$var$isSplat)) initialScore += $65d539d52291a3d6$var$splatPenalty;
    if (index) initialScore += $65d539d52291a3d6$var$indexRouteValue;
    return segments.filter((s)=>!$65d539d52291a3d6$var$isSplat(s)).reduce((score, segment)=>score + ($65d539d52291a3d6$var$paramRe.test(segment) ? $65d539d52291a3d6$var$dynamicSegmentValue : segment === "" ? $65d539d52291a3d6$var$emptySegmentValue : $65d539d52291a3d6$var$staticSegmentValue), initialScore);
}
function $65d539d52291a3d6$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $65d539d52291a3d6$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $65d539d52291a3d6$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $65d539d52291a3d6$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $65d539d52291a3d6$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $65d539d52291a3d6$export$a5c6d149b50c1d86($65d539d52291a3d6$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $65d539d52291a3d6$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $65d539d52291a3d6$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $65d539d52291a3d6$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $65d539d52291a3d6$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $65d539d52291a3d6$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $65d539d52291a3d6$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $65d539d52291a3d6$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $65d539d52291a3d6$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $65d539d52291a3d6$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $65d539d52291a3d6$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $65d539d52291a3d6$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
const $65d539d52291a3d6$var$ABSOLUTE_URL_REGEX$1 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $65d539d52291a3d6$var$isAbsoluteUrl = (url)=>$65d539d52291a3d6$var$ABSOLUTE_URL_REGEX$1.test(url);
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $65d539d52291a3d6$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $65d539d52291a3d6$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        if ($65d539d52291a3d6$var$isAbsoluteUrl(toPathname)) pathname = toPathname;
        else {
            if (toPathname.includes("//")) {
                let oldPathname = toPathname;
                toPathname = toPathname.replace(/\/\/+/g, "/");
                $65d539d52291a3d6$export$c0e02632e14916fd(false, "Pathnames cannot have embedded double slashes - normalizing " + (oldPathname + " -> " + toPathname));
            }
            if (toPathname.startsWith("/")) pathname = $65d539d52291a3d6$var$resolvePathname(toPathname.substring(1), "/");
            else pathname = $65d539d52291a3d6$var$resolvePathname(toPathname, fromPathname);
        }
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $65d539d52291a3d6$var$normalizeSearch(search),
        hash: $65d539d52291a3d6$var$normalizeHash(hash)
    };
}
function $65d539d52291a3d6$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $65d539d52291a3d6$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $65d539d52291a3d6$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $65d539d52291a3d6$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $65d539d52291a3d6$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $65d539d52291a3d6$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $65d539d52291a3d6$export$8ccf933b0513f8d0(toArg);
    else {
        to = $65d539d52291a3d6$var$_extends({}, toArg);
        $65d539d52291a3d6$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $65d539d52291a3d6$var$getInvalidPathError("?", "pathname", "search", to));
        $65d539d52291a3d6$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $65d539d52291a3d6$var$getInvalidPathError("#", "pathname", "hash", to));
        $65d539d52291a3d6$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $65d539d52291a3d6$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $65d539d52291a3d6$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $65d539d52291a3d6$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $65d539d52291a3d6$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $65d539d52291a3d6$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $65d539d52291a3d6$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $65d539d52291a3d6$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $65d539d52291a3d6$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $65d539d52291a3d6$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $65d539d52291a3d6$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $65d539d52291a3d6$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $65d539d52291a3d6$export$4051a07651545597(data, init) {
    return new $65d539d52291a3d6$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $65d539d52291a3d6$export$42a99a7a4bc0e76a extends Error {
}
class $65d539d52291a3d6$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $65d539d52291a3d6$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $65d539d52291a3d6$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $65d539d52291a3d6$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $65d539d52291a3d6$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $65d539d52291a3d6$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $65d539d52291a3d6$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $65d539d52291a3d6$var$unwrapTrackedPromise(value) {
    if (!$65d539d52291a3d6$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $65d539d52291a3d6$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $65d539d52291a3d6$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $65d539d52291a3d6$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $65d539d52291a3d6$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $65d539d52291a3d6$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $65d539d52291a3d6$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $65d539d52291a3d6$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $65d539d52291a3d6$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $65d539d52291a3d6$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $65d539d52291a3d6$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $65d539d52291a3d6$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $65d539d52291a3d6$var$validMutationMethods = new Set($65d539d52291a3d6$var$validMutationMethodsArr);
const $65d539d52291a3d6$var$validRequestMethodsArr = [
    "get",
    ...$65d539d52291a3d6$var$validMutationMethodsArr
];
const $65d539d52291a3d6$var$validRequestMethods = new Set($65d539d52291a3d6$var$validRequestMethodsArr);
const $65d539d52291a3d6$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $65d539d52291a3d6$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $65d539d52291a3d6$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $65d539d52291a3d6$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $65d539d52291a3d6$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $65d539d52291a3d6$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $65d539d52291a3d6$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $65d539d52291a3d6$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $65d539d52291a3d6$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $65d539d52291a3d6$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $65d539d52291a3d6$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $65d539d52291a3d6$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $65d539d52291a3d6$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $65d539d52291a3d6$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $65d539d52291a3d6$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $65d539d52291a3d6$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $65d539d52291a3d6$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$65d539d52291a3d6$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$65d539d52291a3d6$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $65d539d52291a3d6$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $65d539d52291a3d6$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $65d539d52291a3d6$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $65d539d52291a3d6$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $65d539d52291a3d6$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$65d539d52291a3d6$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($65d539d52291a3d6$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $65d539d52291a3d6$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $65d539d52291a3d6$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $65d539d52291a3d6$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $65d539d52291a3d6$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $65d539d52291a3d6$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $65d539d52291a3d6$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $65d539d52291a3d6$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $65d539d52291a3d6$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $65d539d52291a3d6$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($65d539d52291a3d6$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $65d539d52291a3d6$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $65d539d52291a3d6$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $65d539d52291a3d6$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $65d539d52291a3d6$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $65d539d52291a3d6$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $65d539d52291a3d6$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $65d539d52291a3d6$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $65d539d52291a3d6$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $65d539d52291a3d6$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $65d539d52291a3d6$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $65d539d52291a3d6$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $65d539d52291a3d6$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && $65d539d52291a3d6$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $65d539d52291a3d6$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $65d539d52291a3d6$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $65d539d52291a3d6$var$findNearestBoundary(matches).route.id,
            {
                type: $65d539d52291a3d6$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $65d539d52291a3d6$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($65d539d52291a3d6$var$isErrorResult(result) && $65d539d52291a3d6$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $65d539d52291a3d6$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $65d539d52291a3d6$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $65d539d52291a3d6$var$_extends({
            matches: updatedMatches || matches
        }, $65d539d52291a3d6$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $65d539d52291a3d6$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $65d539d52291a3d6$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $65d539d52291a3d6$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $65d539d52291a3d6$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $65d539d52291a3d6$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $65d539d52291a3d6$var$ResultType.error,
            error: $65d539d52291a3d6$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($65d539d52291a3d6$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $65d539d52291a3d6$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($65d539d52291a3d6$var$isDeferredResult(result)) throw $65d539d52291a3d6$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($65d539d52291a3d6$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $65d539d52291a3d6$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $65d539d52291a3d6$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $65d539d52291a3d6$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $65d539d52291a3d6$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($65d539d52291a3d6$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $65d539d52291a3d6$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $65d539d52291a3d6$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $65d539d52291a3d6$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $65d539d52291a3d6$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $65d539d52291a3d6$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $65d539d52291a3d6$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $65d539d52291a3d6$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $65d539d52291a3d6$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $65d539d52291a3d6$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $65d539d52291a3d6$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$65d539d52291a3d6$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $65d539d52291a3d6$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $65d539d52291a3d6$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $65d539d52291a3d6$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $65d539d52291a3d6$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $65d539d52291a3d6$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $65d539d52291a3d6$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $65d539d52291a3d6$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $65d539d52291a3d6$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $65d539d52291a3d6$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $65d539d52291a3d6$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $65d539d52291a3d6$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $65d539d52291a3d6$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($65d539d52291a3d6$var$isRedirectResult(actionResult) || $65d539d52291a3d6$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $65d539d52291a3d6$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($65d539d52291a3d6$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $65d539d52291a3d6$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $65d539d52291a3d6$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($65d539d52291a3d6$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($65d539d52291a3d6$var$isDeferredResult(actionResult)) throw $65d539d52291a3d6$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $65d539d52291a3d6$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $65d539d52291a3d6$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $65d539d52291a3d6$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $65d539d52291a3d6$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $65d539d52291a3d6$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $65d539d52291a3d6$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $65d539d52291a3d6$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $65d539d52291a3d6$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $65d539d52291a3d6$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $65d539d52291a3d6$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $65d539d52291a3d6$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $65d539d52291a3d6$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $65d539d52291a3d6$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $65d539d52291a3d6$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $65d539d52291a3d6$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $65d539d52291a3d6$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($65d539d52291a3d6$var$isDeferredResult(result)) result = await $65d539d52291a3d6$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $65d539d52291a3d6$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($65d539d52291a3d6$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $65d539d52291a3d6$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($65d539d52291a3d6$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $65d539d52291a3d6$export$3e9cee6b33872309(!$65d539d52291a3d6$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $65d539d52291a3d6$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $65d539d52291a3d6$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $65d539d52291a3d6$var$normalizeRedirectLocation(location, new URL(request.url), basename, init.history);
        let redirectLocation = $65d539d52291a3d6$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($65d539d52291a3d6$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $65d539d52291a3d6$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $65d539d52291a3d6$export$e19cd5f9376f8cee.Replace : $65d539d52291a3d6$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $65d539d52291a3d6$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($65d539d52291a3d6$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $65d539d52291a3d6$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $65d539d52291a3d6$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $65d539d52291a3d6$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $65d539d52291a3d6$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $65d539d52291a3d6$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($65d539d52291a3d6$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $65d539d52291a3d6$var$ResultType.redirect,
                response: $65d539d52291a3d6$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $65d539d52291a3d6$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $65d539d52291a3d6$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $65d539d52291a3d6$var$ResultType.error,
                    error: $65d539d52291a3d6$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $65d539d52291a3d6$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $65d539d52291a3d6$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $65d539d52291a3d6$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || $65d539d52291a3d6$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $65d539d52291a3d6$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $65d539d52291a3d6$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $65d539d52291a3d6$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $65d539d52291a3d6$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $65d539d52291a3d6$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $65d539d52291a3d6$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $65d539d52291a3d6$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $65d539d52291a3d6$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $65d539d52291a3d6$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $65d539d52291a3d6$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$65d539d52291a3d6$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $65d539d52291a3d6$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $65d539d52291a3d6$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $65d539d52291a3d6$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $65d539d52291a3d6$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $65d539d52291a3d6$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $65d539d52291a3d6$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $65d539d52291a3d6$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $65d539d52291a3d6$export$4d0306f8f6a4585b = Symbol("deferred");
function $65d539d52291a3d6$export$3336b097a6fbc59a(routes, opts) {
    $65d539d52291a3d6$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $65d539d52291a3d6$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $65d539d52291a3d6$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $65d539d52291a3d6$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $65d539d52291a3d6$var$createLocation("", $65d539d52291a3d6$export$fe53371bee54353d(url), null, "default");
        let matches = $65d539d52291a3d6$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$65d539d52291a3d6$var$isValidMethod(method) && method !== "HEAD") {
            let error = $65d539d52291a3d6$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $65d539d52291a3d6$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $65d539d52291a3d6$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $65d539d52291a3d6$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($65d539d52291a3d6$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $65d539d52291a3d6$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $65d539d52291a3d6$var$createLocation("", $65d539d52291a3d6$export$fe53371bee54353d(url), null, "default");
        let matches = $65d539d52291a3d6$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$65d539d52291a3d6$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $65d539d52291a3d6$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $65d539d52291a3d6$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $65d539d52291a3d6$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $65d539d52291a3d6$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $65d539d52291a3d6$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($65d539d52291a3d6$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$65d539d52291a3d6$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $65d539d52291a3d6$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($65d539d52291a3d6$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $65d539d52291a3d6$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $65d539d52291a3d6$var$isResponse(result) ? result : $65d539d52291a3d6$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($65d539d52291a3d6$var$isDataStrategyResult(e) && $65d539d52291a3d6$var$isResponse(e.result)) {
                if (e.type === $65d539d52291a3d6$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($65d539d52291a3d6$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $65d539d52291a3d6$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $65d539d52291a3d6$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $65d539d52291a3d6$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($65d539d52291a3d6$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($65d539d52291a3d6$var$isDeferredResult(result)) {
            let error = $65d539d52291a3d6$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $65d539d52291a3d6$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($65d539d52291a3d6$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($65d539d52291a3d6$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $65d539d52291a3d6$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $65d539d52291a3d6$var$_extends({}, context, {
                statusCode: $65d539d52291a3d6$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $65d539d52291a3d6$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $65d539d52291a3d6$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $65d539d52291a3d6$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $65d539d52291a3d6$var$isErrorResult(pendingActionResult[1]) ? $65d539d52291a3d6$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $65d539d52291a3d6$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $65d539d52291a3d6$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $65d539d52291a3d6$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $65d539d52291a3d6$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $65d539d52291a3d6$var$callDataStrategyImpl(dataStrategy || $65d539d52291a3d6$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($65d539d52291a3d6$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $65d539d52291a3d6$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($65d539d52291a3d6$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $65d539d52291a3d6$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $65d539d52291a3d6$export$fec11da027c70692(routes, context, error) {
    let newContext = $65d539d52291a3d6$var$_extends({}, context, {
        statusCode: $65d539d52291a3d6$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $65d539d52291a3d6$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $65d539d52291a3d6$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $65d539d52291a3d6$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $65d539d52291a3d6$export$cae722b0cc860f13(to ? to : ".", $65d539d52291a3d6$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $65d539d52291a3d6$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $65d539d52291a3d6$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $65d539d52291a3d6$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $65d539d52291a3d6$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $65d539d52291a3d6$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$65d539d52291a3d6$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$65d539d52291a3d6$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $65d539d52291a3d6$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $65d539d52291a3d6$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $65d539d52291a3d6$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$65d539d52291a3d6$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$65d539d52291a3d6$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $65d539d52291a3d6$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $65d539d52291a3d6$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $65d539d52291a3d6$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $65d539d52291a3d6$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $65d539d52291a3d6$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($65d539d52291a3d6$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $65d539d52291a3d6$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $65d539d52291a3d6$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $65d539d52291a3d6$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $65d539d52291a3d6$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $65d539d52291a3d6$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $65d539d52291a3d6$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $65d539d52291a3d6$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $65d539d52291a3d6$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $65d539d52291a3d6$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $65d539d52291a3d6$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($65d539d52291a3d6$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $65d539d52291a3d6$var$shouldRevalidateLoader(match, $65d539d52291a3d6$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $65d539d52291a3d6$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $65d539d52291a3d6$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $65d539d52291a3d6$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $65d539d52291a3d6$var$shouldRevalidateLoader(fetcherMatch, $65d539d52291a3d6$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $65d539d52291a3d6$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $65d539d52291a3d6$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $65d539d52291a3d6$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $65d539d52291a3d6$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $65d539d52291a3d6$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $65d539d52291a3d6$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$65d539d52291a3d6$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $65d539d52291a3d6$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $65d539d52291a3d6$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$65d539d52291a3d6$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $65d539d52291a3d6$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $65d539d52291a3d6$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $65d539d52291a3d6$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$65d539d52291a3d6$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $65d539d52291a3d6$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $65d539d52291a3d6$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $65d539d52291a3d6$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $65d539d52291a3d6$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $65d539d52291a3d6$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $65d539d52291a3d6$var$ResultType.data,
                result: undefined
            });
        };
        return $65d539d52291a3d6$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $65d539d52291a3d6$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $65d539d52291a3d6$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $65d539d52291a3d6$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $65d539d52291a3d6$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $65d539d52291a3d6$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $65d539d52291a3d6$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $65d539d52291a3d6$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($65d539d52291a3d6$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $65d539d52291a3d6$var$ResultType.error,
                error: e
            };
        }
        if (type === $65d539d52291a3d6$var$ResultType.error) return {
            type: $65d539d52291a3d6$var$ResultType.error,
            error: new $65d539d52291a3d6$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $65d539d52291a3d6$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $65d539d52291a3d6$var$ResultType.error) {
        if ($65d539d52291a3d6$export$e0163cfdf7bc9cfa(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: $65d539d52291a3d6$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: $65d539d52291a3d6$var$ResultType.error,
                error: new $65d539d52291a3d6$export$6c6580e81da25755(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: $65d539d52291a3d6$export$972111febbeef05b(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: $65d539d52291a3d6$var$ResultType.error,
            error: result,
            statusCode: $65d539d52291a3d6$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($65d539d52291a3d6$export$fbcedacb60443473(result)) {
        var _result$init5, _result$init6;
        return {
            type: $65d539d52291a3d6$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if ($65d539d52291a3d6$export$e0163cfdf7bc9cfa(result)) {
        var _result$init7, _result$init8;
        return {
            type: $65d539d52291a3d6$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $65d539d52291a3d6$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $65d539d52291a3d6$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $65d539d52291a3d6$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$65d539d52291a3d6$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $65d539d52291a3d6$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $65d539d52291a3d6$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    // Match Chrome's behavior:
    // https://github.com/chromium/chromium/blob/216dbeb61db0c667e62082e5f5400a32d6983df3/content/public/common/url_utils.cc#L82
    let invalidProtocols = [
        "about:",
        "blob:",
        "chrome:",
        "chrome-untrusted:",
        "content:",
        "data:",
        "devtools:",
        "file:",
        "filesystem:",
        // eslint-disable-next-line no-script-url
        "javascript:"
    ];
    if ($65d539d52291a3d6$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
        let isSameBasename = $65d539d52291a3d6$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    try {
        let url = historyInstance.createURL(location);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $65d539d52291a3d6$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($65d539d52291a3d6$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $65d539d52291a3d6$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $65d539d52291a3d6$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $65d539d52291a3d6$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $65d539d52291a3d6$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $65d539d52291a3d6$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $65d539d52291a3d6$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $65d539d52291a3d6$export$3e9cee6b33872309(!$65d539d52291a3d6$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($65d539d52291a3d6$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $65d539d52291a3d6$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $65d539d52291a3d6$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($65d539d52291a3d6$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $65d539d52291a3d6$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $65d539d52291a3d6$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $65d539d52291a3d6$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($65d539d52291a3d6$var$isErrorResult(result)) {
            let boundaryMatch = $65d539d52291a3d6$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $65d539d52291a3d6$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($65d539d52291a3d6$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $65d539d52291a3d6$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($65d539d52291a3d6$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $65d539d52291a3d6$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $65d539d52291a3d6$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $65d539d52291a3d6$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $65d539d52291a3d6$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $65d539d52291a3d6$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $65d539d52291a3d6$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $65d539d52291a3d6$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $65d539d52291a3d6$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $65d539d52291a3d6$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $65d539d52291a3d6$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $65d539d52291a3d6$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($65d539d52291a3d6$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $65d539d52291a3d6$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $65d539d52291a3d6$export$8ccf933b0513f8d0(path) : path;
    return $65d539d52291a3d6$export$fe53371bee54353d($65d539d52291a3d6$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $65d539d52291a3d6$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $65d539d52291a3d6$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $65d539d52291a3d6$var$ResultType.data || result.type === $65d539d52291a3d6$var$ResultType.error);
}
function $65d539d52291a3d6$var$isRedirectDataStrategyResultResult(result) {
    return $65d539d52291a3d6$var$isResponse(result.result) && $65d539d52291a3d6$var$redirectStatusCodes.has(result.result.status);
}
function $65d539d52291a3d6$var$isDeferredResult(result) {
    return result.type === $65d539d52291a3d6$var$ResultType.deferred;
}
function $65d539d52291a3d6$var$isErrorResult(result) {
    return result.type === $65d539d52291a3d6$var$ResultType.error;
}
function $65d539d52291a3d6$var$isRedirectResult(result) {
    return (result && result.type) === $65d539d52291a3d6$var$ResultType.redirect;
}
function $65d539d52291a3d6$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $65d539d52291a3d6$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $65d539d52291a3d6$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $65d539d52291a3d6$var$isRedirectResponse(result) {
    if (!$65d539d52291a3d6$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $65d539d52291a3d6$var$isValidMethod(method) {
    return $65d539d52291a3d6$var$validRequestMethods.has(method.toLowerCase());
}
function $65d539d52291a3d6$var$isMutationMethod(method) {
    return $65d539d52291a3d6$var$validMutationMethods.has(method.toLowerCase());
}
async function $65d539d52291a3d6$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$65d539d52291a3d6$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($65d539d52291a3d6$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $65d539d52291a3d6$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $65d539d52291a3d6$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($65d539d52291a3d6$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $65d539d52291a3d6$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $65d539d52291a3d6$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $65d539d52291a3d6$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $65d539d52291a3d6$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $65d539d52291a3d6$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $65d539d52291a3d6$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $65d539d52291a3d6$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $65d539d52291a3d6$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $65d539d52291a3d6$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $65d539d52291a3d6$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $65d539d52291a3d6$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $65d539d52291a3d6$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $65d539d52291a3d6$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $65d539d52291a3d6$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $65d539d52291a3d6$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $65d539d52291a3d6$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $65d539d52291a3d6$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $65d539d52291a3d6$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($65d539d52291a3d6$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $65d539d52291a3d6$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($65d539d52291a3d6$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $65d539d52291a3d6$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.30.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $kc00y = parcelRequire("kc00y");

function $7a844823b04d4282$var$_extends() {
    $7a844823b04d4282$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7a844823b04d4282$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $7a844823b04d4282$export$3add0d5dce533e2e = /*#__PURE__*/ $kc00y.createContext(null);
const $7a844823b04d4282$export$145dfa71566a64dc = /*#__PURE__*/ $kc00y.createContext(null);
const $7a844823b04d4282$var$AwaitContext = /*#__PURE__*/ $kc00y.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $7a844823b04d4282$export$26749e8557646306 = /*#__PURE__*/ $kc00y.createContext(null);
const $7a844823b04d4282$export$c7914228fb69b0f5 = /*#__PURE__*/ $kc00y.createContext(null);
const $7a844823b04d4282$export$9072aa6dd1f93057 = /*#__PURE__*/ $kc00y.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $7a844823b04d4282$var$RouteErrorContext = /*#__PURE__*/ $kc00y.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $7a844823b04d4282$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$7a844823b04d4282$export$9c954a9d03d32f4a() && (0, $65d539d52291a3d6$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $kc00y.useContext($7a844823b04d4282$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $7a844823b04d4282$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $65d539d52291a3d6$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $7a844823b04d4282$export$9c954a9d03d32f4a() {
    return $kc00y.useContext($7a844823b04d4282$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $7a844823b04d4282$export$45d76561a5302f2b() {
    !$7a844823b04d4282$export$9c954a9d03d32f4a() && (0, $65d539d52291a3d6$export$3e9cee6b33872309)(false);
    return $kc00y.useContext($7a844823b04d4282$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $7a844823b04d4282$export$1b3f31771c5d07c() {
    return $kc00y.useContext($7a844823b04d4282$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $7a844823b04d4282$export$6c330e8992e8a295(pattern) {
    !$7a844823b04d4282$export$9c954a9d03d32f4a() && (0, $65d539d52291a3d6$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $7a844823b04d4282$export$45d76561a5302f2b();
    return $kc00y.useMemo(()=>(0, $65d539d52291a3d6$export$81336c211d5ff295)(pattern, (0, $65d539d52291a3d6$export$30d21fd6d7295f52)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $7a844823b04d4282$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $7a844823b04d4282$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $kc00y.useContext($7a844823b04d4282$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $kc00y.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $7a844823b04d4282$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $kc00y.useContext($7a844823b04d4282$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $7a844823b04d4282$var$useNavigateStable() : $7a844823b04d4282$var$useNavigateUnstable();
}
function $7a844823b04d4282$var$useNavigateUnstable() {
    !$7a844823b04d4282$export$9c954a9d03d32f4a() && (0, $65d539d52291a3d6$export$3e9cee6b33872309)(false);
    let dataRouterContext = $kc00y.useContext($7a844823b04d4282$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $kc00y.useContext($7a844823b04d4282$export$26749e8557646306);
    let { matches: matches } = $kc00y.useContext($7a844823b04d4282$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7a844823b04d4282$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $65d539d52291a3d6$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $kc00y.useRef(false);
    $7a844823b04d4282$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $kc00y.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $65d539d52291a3d6$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $65d539d52291a3d6$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $7a844823b04d4282$var$OutletContext = /*#__PURE__*/ $kc00y.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $7a844823b04d4282$export$4138103a3ae699cc() {
    return $kc00y.useContext($7a844823b04d4282$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $7a844823b04d4282$export$a3be3530d8e40d0b(context) {
    let outlet = $kc00y.useContext($7a844823b04d4282$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $kc00y.createElement($7a844823b04d4282$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $7a844823b04d4282$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $kc00y.useContext($7a844823b04d4282$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $7a844823b04d4282$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $kc00y.useContext($7a844823b04d4282$export$26749e8557646306);
    let { matches: matches } = $kc00y.useContext($7a844823b04d4282$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7a844823b04d4282$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $65d539d52291a3d6$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $kc00y.useMemo(()=>(0, $65d539d52291a3d6$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $7a844823b04d4282$export$5d3fca4a98652595(routes, locationArg) {
    return $7a844823b04d4282$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $7a844823b04d4282$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$7a844823b04d4282$export$9c954a9d03d32f4a() && (0, $65d539d52291a3d6$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $kc00y.useContext($7a844823b04d4282$export$26749e8557646306);
    let { matches: parentMatches } = $kc00y.useContext($7a844823b04d4282$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $7a844823b04d4282$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $65d539d52291a3d6$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $65d539d52291a3d6$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $65d539d52291a3d6$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $7a844823b04d4282$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $65d539d52291a3d6$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $65d539d52291a3d6$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $kc00y.createElement($7a844823b04d4282$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $7a844823b04d4282$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $65d539d52291a3d6$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $7a844823b04d4282$var$DefaultErrorComponent() {
    let error = $7a844823b04d4282$export$ed527bf60f6e05f2();
    let message = (0, $65d539d52291a3d6$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $kc00y.createElement($kc00y.Fragment, null, /*#__PURE__*/ $kc00y.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $kc00y.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $kc00y.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $7a844823b04d4282$var$defaultErrorElement = /*#__PURE__*/ $kc00y.createElement($7a844823b04d4282$var$DefaultErrorComponent, null);
class $7a844823b04d4282$var$RenderErrorBoundary extends $kc00y.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $kc00y.createElement($7a844823b04d4282$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $kc00y.createElement($7a844823b04d4282$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $7a844823b04d4282$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $kc00y.useContext($7a844823b04d4282$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $kc00y.createElement($7a844823b04d4282$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $7a844823b04d4282$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $65d539d52291a3d6$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $7a844823b04d4282$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $7a844823b04d4282$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $kc00y.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $kc00y.createElement($7a844823b04d4282$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $kc00y.createElement($7a844823b04d4282$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $7a844823b04d4282$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($7a844823b04d4282$var$DataRouterHook || {});
var $7a844823b04d4282$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($7a844823b04d4282$var$DataRouterStateHook || {});
function $7a844823b04d4282$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $7a844823b04d4282$var$useDataRouterContext(hookName) {
    let ctx = $kc00y.useContext($7a844823b04d4282$export$3add0d5dce533e2e);
    !ctx && (0, $65d539d52291a3d6$export$3e9cee6b33872309)(false);
    return ctx;
}
function $7a844823b04d4282$var$useDataRouterState(hookName) {
    let state = $kc00y.useContext($7a844823b04d4282$export$145dfa71566a64dc);
    !state && (0, $65d539d52291a3d6$export$3e9cee6b33872309)(false);
    return state;
}
function $7a844823b04d4282$var$useRouteContext(hookName) {
    let route = $kc00y.useContext($7a844823b04d4282$export$9072aa6dd1f93057);
    !route && (0, $65d539d52291a3d6$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $7a844823b04d4282$var$useCurrentRouteId(hookName) {
    let route = $7a844823b04d4282$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $65d539d52291a3d6$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $7a844823b04d4282$export$5fc8298006ad9e58() {
    return $7a844823b04d4282$var$useCurrentRouteId($7a844823b04d4282$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $7a844823b04d4282$export$d0fd4b7106de2769() {
    let state = $7a844823b04d4282$var$useDataRouterState($7a844823b04d4282$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $7a844823b04d4282$export$600dc272ed516c15() {
    let dataRouterContext = $7a844823b04d4282$var$useDataRouterContext($7a844823b04d4282$var$DataRouterHook.UseRevalidator);
    let state = $7a844823b04d4282$var$useDataRouterState($7a844823b04d4282$var$DataRouterStateHook.UseRevalidator);
    return $kc00y.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $7a844823b04d4282$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $7a844823b04d4282$var$useDataRouterState($7a844823b04d4282$var$DataRouterStateHook.UseMatches);
    return $kc00y.useMemo(()=>matches.map((m)=>(0, $65d539d52291a3d6$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $7a844823b04d4282$export$1448a5050d252c4d() {
    let state = $7a844823b04d4282$var$useDataRouterState($7a844823b04d4282$var$DataRouterStateHook.UseLoaderData);
    let routeId = $7a844823b04d4282$var$useCurrentRouteId($7a844823b04d4282$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $7a844823b04d4282$export$fd5d37484eab868d(routeId) {
    let state = $7a844823b04d4282$var$useDataRouterState($7a844823b04d4282$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $7a844823b04d4282$export$fdc00f3f26066d5e() {
    let state = $7a844823b04d4282$var$useDataRouterState($7a844823b04d4282$var$DataRouterStateHook.UseActionData);
    let routeId = $7a844823b04d4282$var$useCurrentRouteId($7a844823b04d4282$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $7a844823b04d4282$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $kc00y.useContext($7a844823b04d4282$var$RouteErrorContext);
    let state = $7a844823b04d4282$var$useDataRouterState($7a844823b04d4282$var$DataRouterStateHook.UseRouteError);
    let routeId = $7a844823b04d4282$var$useCurrentRouteId($7a844823b04d4282$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $7a844823b04d4282$export$78a72ddb39bdd145() {
    let value = $kc00y.useContext($7a844823b04d4282$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $7a844823b04d4282$export$17f53340677d5831() {
    let value = $kc00y.useContext($7a844823b04d4282$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $7a844823b04d4282$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $7a844823b04d4282$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $7a844823b04d4282$var$useDataRouterContext($7a844823b04d4282$var$DataRouterHook.UseBlocker);
    let state = $7a844823b04d4282$var$useDataRouterState($7a844823b04d4282$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $kc00y.useState("");
    let blockerFunction = $kc00y.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $7a844823b04d4282$var$_extends({}, currentLocation, {
                pathname: (0, $65d539d52291a3d6$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $7a844823b04d4282$var$_extends({}, nextLocation, {
                pathname: (0, $65d539d52291a3d6$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $kc00y.useEffect(()=>{
        let key = String(++$7a844823b04d4282$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $kc00y.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $65d539d52291a3d6$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $7a844823b04d4282$var$useNavigateStable() {
    let { router: router } = $7a844823b04d4282$var$useDataRouterContext($7a844823b04d4282$var$DataRouterHook.UseNavigateStable);
    let id = $7a844823b04d4282$var$useCurrentRouteId($7a844823b04d4282$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $kc00y.useRef(false);
    $7a844823b04d4282$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $kc00y.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $7a844823b04d4282$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $7a844823b04d4282$var$alreadyWarned$1 = {};
function $7a844823b04d4282$var$warningOnce(key, cond, message) {
    if (!cond && !$7a844823b04d4282$var$alreadyWarned$1[key]) $7a844823b04d4282$var$alreadyWarned$1[key] = true;
}
const $7a844823b04d4282$var$alreadyWarned = {};
function $7a844823b04d4282$var$warnOnce(key, message) {}
const $7a844823b04d4282$var$logDeprecation = (flag, msg, link)=>$7a844823b04d4282$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $7a844823b04d4282$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $7a844823b04d4282$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || routerFuture.v7_relativeSplatPath === undefined)) $7a844823b04d4282$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $7a844823b04d4282$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $7a844823b04d4282$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $7a844823b04d4282$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $7a844823b04d4282$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $7a844823b04d4282$var$START_TRANSITION = "startTransition";
const $7a844823b04d4282$var$startTransitionImpl = $kc00y[$7a844823b04d4282$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $7a844823b04d4282$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $kc00y.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $kc00y.useCallback((newState)=>{
        if (v7_startTransition && $7a844823b04d4282$var$startTransitionImpl) $7a844823b04d4282$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $kc00y.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $kc00y.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $kc00y.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $kc00y.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $kc00y.useEffect(()=>$7a844823b04d4282$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $kc00y.createElement($kc00y.Fragment, null, /*#__PURE__*/ $kc00y.createElement($7a844823b04d4282$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $kc00y.createElement($7a844823b04d4282$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $kc00y.createElement($7a844823b04d4282$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $kc00y.createElement($7a844823b04d4282$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $7a844823b04d4282$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $7a844823b04d4282$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $7a844823b04d4282$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $kc00y.useRef();
    if (historyRef.current == null) historyRef.current = (0, $65d539d52291a3d6$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $kc00y.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $kc00y.useCallback((newState)=>{
        v7_startTransition && $7a844823b04d4282$var$startTransitionImpl ? $7a844823b04d4282$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $kc00y.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $kc00y.useEffect(()=>$7a844823b04d4282$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $kc00y.createElement($7a844823b04d4282$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $7a844823b04d4282$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$7a844823b04d4282$export$9c954a9d03d32f4a() && (0, $65d539d52291a3d6$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $kc00y.useContext($7a844823b04d4282$export$26749e8557646306);
    let { matches: matches } = $kc00y.useContext($7a844823b04d4282$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7a844823b04d4282$export$45d76561a5302f2b();
    let navigate = $7a844823b04d4282$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $65d539d52291a3d6$export$cae722b0cc860f13)(to, (0, $65d539d52291a3d6$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $kc00y.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $7a844823b04d4282$export$910ae8079b2c2852(props) {
    return $7a844823b04d4282$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $7a844823b04d4282$export$e7b0ac011bb776c6(_props) {
    (0, $65d539d52291a3d6$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $7a844823b04d4282$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $65d539d52291a3d6$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$7a844823b04d4282$export$9c954a9d03d32f4a() && (0, $65d539d52291a3d6$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $kc00y.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $7a844823b04d4282$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $65d539d52291a3d6$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $kc00y.useMemo(()=>{
        let trailingPathname = (0, $65d539d52291a3d6$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $kc00y.createElement($7a844823b04d4282$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $kc00y.createElement($7a844823b04d4282$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $7a844823b04d4282$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $7a844823b04d4282$export$5d3fca4a98652595($7a844823b04d4282$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $7a844823b04d4282$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $kc00y.createElement($7a844823b04d4282$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $kc00y.createElement($7a844823b04d4282$var$ResolveAwait, null, children));
}
var $7a844823b04d4282$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($7a844823b04d4282$var$AwaitRenderStatus || {});
const $7a844823b04d4282$var$neverSettledPromise = new Promise(()=>{});
class $7a844823b04d4282$var$AwaitErrorBoundary extends $kc00y.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $7a844823b04d4282$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $7a844823b04d4282$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $7a844823b04d4282$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $7a844823b04d4282$var$AwaitRenderStatus.error : "_data" in promise ? $7a844823b04d4282$var$AwaitRenderStatus.success : $7a844823b04d4282$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $7a844823b04d4282$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $7a844823b04d4282$var$AwaitRenderStatus.error && promise._error instanceof (0, $65d539d52291a3d6$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $7a844823b04d4282$var$neverSettledPromise;
        if (status === $7a844823b04d4282$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $7a844823b04d4282$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $kc00y.createElement($7a844823b04d4282$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $7a844823b04d4282$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $kc00y.createElement($7a844823b04d4282$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $7a844823b04d4282$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $7a844823b04d4282$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $kc00y.createElement($kc00y.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $7a844823b04d4282$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $kc00y.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $kc00y.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $kc00y.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $7a844823b04d4282$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $7a844823b04d4282$export$e7b0ac011bb776c6) && (0, $65d539d52291a3d6$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $65d539d52291a3d6$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $7a844823b04d4282$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $7a844823b04d4282$export$daf73786167a7f72(matches) {
    return $7a844823b04d4282$var$_renderMatches(matches);
}
function $7a844823b04d4282$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $kc00y.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $kc00y.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $kc00y.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $7a844823b04d4282$export$f30f7e456d254e83(routes, opts) {
    return (0, $65d539d52291a3d6$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $7a844823b04d4282$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $65d539d52291a3d6$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $7a844823b04d4282$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}



function $0608a055a17e1a05$var$_extends() {
    $0608a055a17e1a05$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0608a055a17e1a05$var$_extends.apply(this, arguments);
}
function $0608a055a17e1a05$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $0608a055a17e1a05$var$defaultMethod = "get";
const $0608a055a17e1a05$var$defaultEncType = "application/x-www-form-urlencoded";
function $0608a055a17e1a05$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $0608a055a17e1a05$var$isButtonElement(object) {
    return $0608a055a17e1a05$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $0608a055a17e1a05$var$isFormElement(object) {
    return $0608a055a17e1a05$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $0608a055a17e1a05$var$isInputElement(object) {
    return $0608a055a17e1a05$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $0608a055a17e1a05$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $0608a055a17e1a05$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$0608a055a17e1a05$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $0608a055a17e1a05$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $0608a055a17e1a05$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $0608a055a17e1a05$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $0608a055a17e1a05$var$_formDataSupportsSubmitter = null;
function $0608a055a17e1a05$var$isFormDataSubmitterSupported() {
    if ($0608a055a17e1a05$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $0608a055a17e1a05$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $0608a055a17e1a05$var$_formDataSupportsSubmitter = true;
    }
    return $0608a055a17e1a05$var$_formDataSupportsSubmitter;
}
const $0608a055a17e1a05$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $0608a055a17e1a05$var$getFormEncType(encType) {
    if (encType != null && !$0608a055a17e1a05$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $0608a055a17e1a05$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($0608a055a17e1a05$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $65d539d52291a3d6$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $0608a055a17e1a05$var$defaultMethod;
        encType = $0608a055a17e1a05$var$getFormEncType(target.getAttribute("enctype")) || $0608a055a17e1a05$var$defaultEncType;
        formData = new FormData(target);
    } else if ($0608a055a17e1a05$var$isButtonElement(target) || $0608a055a17e1a05$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $65d539d52291a3d6$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $0608a055a17e1a05$var$defaultMethod;
        encType = $0608a055a17e1a05$var$getFormEncType(target.getAttribute("formenctype")) || $0608a055a17e1a05$var$getFormEncType(form.getAttribute("enctype")) || $0608a055a17e1a05$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$0608a055a17e1a05$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($0608a055a17e1a05$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $0608a055a17e1a05$var$defaultMethod;
        action = null;
        encType = $0608a055a17e1a05$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $0608a055a17e1a05$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $0608a055a17e1a05$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $0608a055a17e1a05$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $0608a055a17e1a05$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $0608a055a17e1a05$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $0608a055a17e1a05$export$1f3f55432a00e06d(routes, opts) {
    return (0, $65d539d52291a3d6$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $0608a055a17e1a05$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $65d539d52291a3d6$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $0608a055a17e1a05$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7a844823b04d4282$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $0608a055a17e1a05$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $65d539d52291a3d6$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $0608a055a17e1a05$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $65d539d52291a3d6$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $0608a055a17e1a05$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7a844823b04d4282$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $0608a055a17e1a05$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $0608a055a17e1a05$var$_extends({}, state, {
        errors: $0608a055a17e1a05$var$deserializeErrors(state.errors)
    });
    return state;
}
function $0608a055a17e1a05$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $65d539d52291a3d6$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $0608a055a17e1a05$export$7ad602f0e94e62d1 = /*#__PURE__*/ $kc00y.createContext({
    isTransitioning: false
});
const $0608a055a17e1a05$export$148fd98d095596d4 = /*#__PURE__*/ $kc00y.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $0608a055a17e1a05$var$START_TRANSITION = "startTransition";
const $0608a055a17e1a05$var$startTransitionImpl = $kc00y[$0608a055a17e1a05$var$START_TRANSITION];
const $0608a055a17e1a05$var$FLUSH_SYNC = "flushSync";
const $0608a055a17e1a05$var$flushSyncImpl = $9018fd8b87cabbb7$exports[$0608a055a17e1a05$var$FLUSH_SYNC];
const $0608a055a17e1a05$var$USE_ID = "useId";
const $0608a055a17e1a05$var$useIdImpl = $kc00y[$0608a055a17e1a05$var$USE_ID];
function $0608a055a17e1a05$var$startTransitionSafe(cb) {
    if ($0608a055a17e1a05$var$startTransitionImpl) $0608a055a17e1a05$var$startTransitionImpl(cb);
    else cb();
}
function $0608a055a17e1a05$var$flushSyncSafe(cb) {
    if ($0608a055a17e1a05$var$flushSyncImpl) $0608a055a17e1a05$var$flushSyncImpl(cb);
    else cb();
}
class $0608a055a17e1a05$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $0608a055a17e1a05$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $kc00y.useState(router.state);
    let [pendingState, setPendingState] = $kc00y.useState();
    let [vtContext, setVtContext] = $kc00y.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $kc00y.useState();
    let [transition, setTransition] = $kc00y.useState();
    let [interruption, setInterruption] = $kc00y.useState();
    let fetcherData = $kc00y.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $kc00y.useCallback((cb)=>{
        if (v7_startTransition) $0608a055a17e1a05$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $kc00y.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $0608a055a17e1a05$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $0608a055a17e1a05$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $0608a055a17e1a05$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $0608a055a17e1a05$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $0608a055a17e1a05$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $kc00y.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $kc00y.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $0608a055a17e1a05$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $kc00y.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $kc00y.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $kc00y.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $kc00y.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $kc00y.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $kc00y.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $kc00y.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $kc00y.useEffect(()=>(0, $7a844823b04d4282$export$db5148ec97d6af7a)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $kc00y.createElement($kc00y.Fragment, null, /*#__PURE__*/ $kc00y.createElement((0, $7a844823b04d4282$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $kc00y.createElement((0, $7a844823b04d4282$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $kc00y.createElement($0608a055a17e1a05$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $kc00y.createElement($0608a055a17e1a05$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $kc00y.createElement((0, $7a844823b04d4282$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $kc00y.createElement($0608a055a17e1a05$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $0608a055a17e1a05$var$MemoizedDataRoutes = /*#__PURE__*/ $kc00y.memo($0608a055a17e1a05$var$DataRoutes);
function $0608a055a17e1a05$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $7a844823b04d4282$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $0608a055a17e1a05$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $kc00y.useRef();
    if (historyRef.current == null) historyRef.current = (0, $65d539d52291a3d6$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $kc00y.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $kc00y.useCallback((newState)=>{
        v7_startTransition && $0608a055a17e1a05$var$startTransitionImpl ? $0608a055a17e1a05$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $kc00y.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $kc00y.useEffect(()=>(0, $7a844823b04d4282$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $kc00y.createElement((0, $7a844823b04d4282$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $0608a055a17e1a05$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $kc00y.useRef();
    if (historyRef.current == null) historyRef.current = (0, $65d539d52291a3d6$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $kc00y.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $kc00y.useCallback((newState)=>{
        v7_startTransition && $0608a055a17e1a05$var$startTransitionImpl ? $0608a055a17e1a05$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $kc00y.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $kc00y.useEffect(()=>(0, $7a844823b04d4282$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $kc00y.createElement((0, $7a844823b04d4282$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $0608a055a17e1a05$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $kc00y.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $kc00y.useCallback((newState)=>{
        v7_startTransition && $0608a055a17e1a05$var$startTransitionImpl ? $0608a055a17e1a05$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $kc00y.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $kc00y.useEffect(()=>(0, $7a844823b04d4282$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $kc00y.createElement((0, $7a844823b04d4282$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $0608a055a17e1a05$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $0608a055a17e1a05$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $0608a055a17e1a05$export$a6c7ac8248d6e38a = /*#__PURE__*/ $kc00y.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $0608a055a17e1a05$var$_objectWithoutPropertiesLoose(_ref7, $0608a055a17e1a05$var$_excluded);
    let { basename: basename } = $kc00y.useContext((0, $7a844823b04d4282$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $0608a055a17e1a05$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($0608a055a17e1a05$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $65d539d52291a3d6$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $7a844823b04d4282$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $0608a055a17e1a05$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $kc00y.createElement("a", $0608a055a17e1a05$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $0608a055a17e1a05$export$b0d92dbee9b5b60d = /*#__PURE__*/ $kc00y.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $0608a055a17e1a05$var$_objectWithoutPropertiesLoose(_ref8, $0608a055a17e1a05$var$_excluded2);
    let path = (0, $7a844823b04d4282$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $7a844823b04d4282$export$45d76561a5302f2b)();
    let routerState = $kc00y.useContext((0, $7a844823b04d4282$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $kc00y.useContext((0, $7a844823b04d4282$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $0608a055a17e1a05$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $65d539d52291a3d6$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $kc00y.createElement($0608a055a17e1a05$export$a6c7ac8248d6e38a, $0608a055a17e1a05$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $0608a055a17e1a05$export$a7fed597f4b8afd8 = /*#__PURE__*/ $kc00y.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $0608a055a17e1a05$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $0608a055a17e1a05$var$_objectWithoutPropertiesLoose(_ref9, $0608a055a17e1a05$var$_excluded3);
    let submit = $0608a055a17e1a05$export$47c85c6e3a081d3();
    let formAction = $0608a055a17e1a05$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $kc00y.createElement("form", $0608a055a17e1a05$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $0608a055a17e1a05$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $0608a055a17e1a05$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $0608a055a17e1a05$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($0608a055a17e1a05$var$DataRouterHook || ($0608a055a17e1a05$var$DataRouterHook = {}));
var $0608a055a17e1a05$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($0608a055a17e1a05$var$DataRouterStateHook || ($0608a055a17e1a05$var$DataRouterStateHook = {}));
// Internal hooks
function $0608a055a17e1a05$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $0608a055a17e1a05$var$useDataRouterContext(hookName) {
    let ctx = $kc00y.useContext((0, $7a844823b04d4282$export$3add0d5dce533e2e));
    !ctx && (0, $65d539d52291a3d6$export$3e9cee6b33872309)(false);
    return ctx;
}
function $0608a055a17e1a05$var$useDataRouterState(hookName) {
    let state = $kc00y.useContext((0, $7a844823b04d4282$export$145dfa71566a64dc));
    !state && (0, $65d539d52291a3d6$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $0608a055a17e1a05$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $7a844823b04d4282$export$9770f232ac06a008)();
    let location = (0, $7a844823b04d4282$export$45d76561a5302f2b)();
    let path = (0, $7a844823b04d4282$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $kc00y.useCallback((event)=>{
        if ($0608a055a17e1a05$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $65d539d52291a3d6$export$fe53371bee54353d)(location) === (0, $65d539d52291a3d6$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $0608a055a17e1a05$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $kc00y.useRef($0608a055a17e1a05$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $kc00y.useRef(false);
    let location = (0, $7a844823b04d4282$export$45d76561a5302f2b)();
    let searchParams = $kc00y.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $0608a055a17e1a05$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $7a844823b04d4282$export$9770f232ac06a008)();
    let setSearchParams = $kc00y.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $0608a055a17e1a05$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $0608a055a17e1a05$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $0608a055a17e1a05$var$fetcherId = 0;
let $0608a055a17e1a05$var$getUniqueFetcherId = ()=>"__" + String(++$0608a055a17e1a05$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $0608a055a17e1a05$export$47c85c6e3a081d3() {
    let { router: router } = $0608a055a17e1a05$var$useDataRouterContext($0608a055a17e1a05$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $kc00y.useContext((0, $7a844823b04d4282$export$26749e8557646306));
    let currentRouteId = (0, $7a844823b04d4282$export$5fc8298006ad9e58)();
    return $kc00y.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $0608a055a17e1a05$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $0608a055a17e1a05$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $0608a055a17e1a05$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $0608a055a17e1a05$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $kc00y.useContext((0, $7a844823b04d4282$export$26749e8557646306));
    let routeContext = $kc00y.useContext((0, $7a844823b04d4282$export$9072aa6dd1f93057));
    !routeContext && (0, $65d539d52291a3d6$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $0608a055a17e1a05$var$_extends({}, (0, $7a844823b04d4282$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $7a844823b04d4282$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $65d539d52291a3d6$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $65d539d52291a3d6$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $0608a055a17e1a05$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $0608a055a17e1a05$var$useDataRouterContext($0608a055a17e1a05$var$DataRouterHook.UseFetcher);
    let state = $0608a055a17e1a05$var$useDataRouterState($0608a055a17e1a05$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $kc00y.useContext($0608a055a17e1a05$export$148fd98d095596d4);
    let route = $kc00y.useContext((0, $7a844823b04d4282$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $65d539d52291a3d6$export$3e9cee6b33872309)(false);
    !route && (0, $65d539d52291a3d6$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $65d539d52291a3d6$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $0608a055a17e1a05$var$useIdImpl ? $0608a055a17e1a05$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $kc00y.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($0608a055a17e1a05$var$getUniqueFetcherId());
    // Registration/cleanup
    $kc00y.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $kc00y.useCallback((href, opts)=>{
        !routeId && (0, $65d539d52291a3d6$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $0608a055a17e1a05$export$47c85c6e3a081d3();
    let submit = $kc00y.useCallback((target, opts)=>{
        submitImpl(target, $0608a055a17e1a05$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $kc00y.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $kc00y.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $kc00y.createElement($0608a055a17e1a05$export$a7fed597f4b8afd8, $0608a055a17e1a05$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $65d539d52291a3d6$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $kc00y.useMemo(()=>$0608a055a17e1a05$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $0608a055a17e1a05$export$fa996778a3a31087() {
    let state = $0608a055a17e1a05$var$useDataRouterState($0608a055a17e1a05$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $0608a055a17e1a05$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $0608a055a17e1a05$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $0608a055a17e1a05$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $0608a055a17e1a05$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $0608a055a17e1a05$var$useDataRouterContext($0608a055a17e1a05$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $0608a055a17e1a05$var$useDataRouterState($0608a055a17e1a05$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $kc00y.useContext((0, $7a844823b04d4282$export$26749e8557646306));
    let location = (0, $7a844823b04d4282$export$45d76561a5302f2b)();
    let matches = (0, $7a844823b04d4282$export$2378eb7f5ff86053)();
    let navigation = (0, $7a844823b04d4282$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $kc00y.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $0608a055a17e1a05$var$usePageHide($kc00y.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $0608a055a17e1a05$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $0608a055a17e1a05$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($0608a055a17e1a05$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $kc00y.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $0608a055a17e1a05$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $0608a055a17e1a05$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $kc00y.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($0608a055a17e1a05$var$_extends({}, location, {
                    pathname: (0, $65d539d52291a3d6$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($0608a055a17e1a05$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $kc00y.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $0608a055a17e1a05$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $kc00y.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $0608a055a17e1a05$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $kc00y.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $0608a055a17e1a05$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $7a844823b04d4282$export$b273b3273281a049)(when);
    $kc00y.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $kc00y.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $0608a055a17e1a05$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $kc00y.useContext($0608a055a17e1a05$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $65d539d52291a3d6$export$3e9cee6b33872309)(false);
    let { basename: basename } = $0608a055a17e1a05$var$useDataRouterContext($0608a055a17e1a05$var$DataRouterHook.useViewTransitionState);
    let path = (0, $7a844823b04d4282$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $65d539d52291a3d6$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $65d539d52291a3d6$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $65d539d52291a3d6$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $65d539d52291a3d6$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}



/**
 * @module ol/proj
 */ /**
 * The ol/proj module stores:
 * a list of {@link module:ol/proj/Projection~Projection}
 * objects, one for each projection supported by the application
 * a list of transform functions needed to convert coordinates in one projection
 * into another.
 *
 * The static functions are the methods used to maintain these.
 * Each transform function can handle not only simple coordinate pairs, but also
 * large arrays of coordinates such as vector geometries.
 *
 * When loaded, the library adds projection objects for EPSG:4326 (WGS84
 * geographic coordinates) and EPSG:3857 (Web or Spherical Mercator, as used
 * for example by Bing Maps or OpenStreetMap), together with the relevant
 * transform functions.
 *
 * Additional transforms may be added by using the http://proj4js.org/
 * library (version 2.2 or later). You can use the full build supplied by
 * Proj4js, or create a custom build to support those projections you need; see
 * the Proj4js website for how to do this. You also need the Proj4js definitions
 * for the required projections. These definitions can be obtained from
 * https://spatialreference.org/, and are a JS function, so can be loaded in a
 * script tag (as in the examples) or pasted into your application.
 *
 * After all required projection definitions are added to proj4's registry (by
 * using `proj4.defs()`), simply call `register(proj4)` from the `ol/proj/proj4`
 * package. Existing transforms are not changed by this function. See
 * examples/wms-image-custom-proj for an example of this.
 *
 * Additional projection definitions can be registered with `proj4.defs()` any
 * time. Just make sure to call `register(proj4)` again; for example, with user-supplied data where you don't
 * know in advance what projections are needed, you can initially load minimal
 * support and then load whichever are requested.
 *
 * Note that Proj4js does not support projection extents. If you want to add
 * one for creating default tile grids, you can add it after the Projection
 * object has been created with `setExtent`, for example,
 * `get('EPSG:1234').setExtent(extent)`.
 *
 * In addition to Proj4js support, any transform functions can be added with
 * {@link module:ol/proj.addCoordinateTransforms}. To use this, you must first create
 * a {@link module:ol/proj/Projection~Projection} object for the new projection and add it with
 * {@link module:ol/proj.addProjection}. You can then add the forward and inverse
 * functions with {@link module:ol/proj.addCoordinateTransforms}. See
 * examples/wms-custom-proj for an example of this.
 *
 * Note that if no transforms are needed and you only need to define the
 * projection, just add a {@link module:ol/proj/Projection~Projection} with
 * {@link module:ol/proj.addProjection}. See examples/wms-no-proj for an example of
 * this.
 */ /**
 * @module ol/console
 */ /**
 * @typedef {'info'|'warn'|'error'|'none'} Level
 */ /**
 * @type {Object<Level, number>}
 */ const $7636ffe0700f8dd9$var$levels = {
    info: 1,
    warn: 2,
    error: 3,
    none: 4
};
/**
 * @type {number}
 */ let $7636ffe0700f8dd9$var$level = $7636ffe0700f8dd9$var$levels.info;
function $7636ffe0700f8dd9$export$2c97a59140dbf245(l) {
    $7636ffe0700f8dd9$var$level = $7636ffe0700f8dd9$var$levels[l];
}
function $7636ffe0700f8dd9$export$bef1f36f5486a6a3(...args) {
    if ($7636ffe0700f8dd9$var$level > $7636ffe0700f8dd9$var$levels.info) return;
    console.log(...args); // eslint-disable-line no-console
}
function $7636ffe0700f8dd9$export$c106dd0671a0fc2d(...args) {
    if ($7636ffe0700f8dd9$var$level > $7636ffe0700f8dd9$var$levels.warn) return;
    console.warn(...args); // eslint-disable-line no-console
}
function $7636ffe0700f8dd9$export$a3bc9b8ed74fc(...args) {
    if ($7636ffe0700f8dd9$var$level > $7636ffe0700f8dd9$var$levels.error) return;
    console.error(...args); // eslint-disable-line no-console
}


/**
 * @module ol/coordinate
 */ /**
 * @module ol/extent
 */ /**
 * @module ol/extent/Relationship
 */ /**
 * Relationship to an extent.
 * @enum {number}
 */ var $6c0093e2f673fa5d$export$2e2bcd8739ae039 = {
    UNKNOWN: 0,
    INTERSECTING: 1,
    ABOVE: 2,
    RIGHT: 4,
    BELOW: 8,
    LEFT: 16
};


function $dea65c2f666fa450$export$8aceca7c77505534(coordinates) {
    const extent = $dea65c2f666fa450$export$fe201bb3bbe031e9();
    for(let i = 0, ii = coordinates.length; i < ii; ++i)$dea65c2f666fa450$export$1f820e3920fa5715(extent, coordinates[i]);
    return extent;
}
/**
 * @param {Array<number>} xs Xs.
 * @param {Array<number>} ys Ys.
 * @param {Extent} [dest] Destination extent.
 * @private
 * @return {Extent} Extent.
 */ function $dea65c2f666fa450$var$_boundingExtentXYs(xs, ys, dest) {
    const minX = Math.min.apply(null, xs);
    const minY = Math.min.apply(null, ys);
    const maxX = Math.max.apply(null, xs);
    const maxY = Math.max.apply(null, ys);
    return $dea65c2f666fa450$export$958e3e1a02eac4b6(minX, minY, maxX, maxY, dest);
}
function $dea65c2f666fa450$export$ab1029bcae9ddb4a(extent, value, dest) {
    if (dest) {
        dest[0] = extent[0] - value;
        dest[1] = extent[1] - value;
        dest[2] = extent[2] + value;
        dest[3] = extent[3] + value;
        return dest;
    }
    return [
        extent[0] - value,
        extent[1] - value,
        extent[2] + value,
        extent[3] + value
    ];
}
function $dea65c2f666fa450$export$9cd59f9826255e47(extent, dest) {
    if (dest) {
        dest[0] = extent[0];
        dest[1] = extent[1];
        dest[2] = extent[2];
        dest[3] = extent[3];
        return dest;
    }
    return extent.slice();
}
function $dea65c2f666fa450$export$cbe64c389534206f(extent, x, y) {
    let dx, dy;
    if (x < extent[0]) dx = extent[0] - x;
    else if (extent[2] < x) dx = x - extent[2];
    else dx = 0;
    if (y < extent[1]) dy = extent[1] - y;
    else if (extent[3] < y) dy = y - extent[3];
    else dy = 0;
    return dx * dx + dy * dy;
}
function $dea65c2f666fa450$export$ac68c24d37ca240f(extent, coordinate) {
    return $dea65c2f666fa450$export$805bdfd6d6690e97(extent, coordinate[0], coordinate[1]);
}
function $dea65c2f666fa450$export$be866b1e0809b17e(extent1, extent2) {
    return extent1[0] <= extent2[0] && extent2[2] <= extent1[2] && extent1[1] <= extent2[1] && extent2[3] <= extent1[3];
}
function $dea65c2f666fa450$export$805bdfd6d6690e97(extent, x, y) {
    return extent[0] <= x && x <= extent[2] && extent[1] <= y && y <= extent[3];
}
function $dea65c2f666fa450$export$f97905ead28c61a8(extent, coordinate) {
    const minX = extent[0];
    const minY = extent[1];
    const maxX = extent[2];
    const maxY = extent[3];
    const x = coordinate[0];
    const y = coordinate[1];
    let relationship = (0, $6c0093e2f673fa5d$export$2e2bcd8739ae039).UNKNOWN;
    if (x < minX) relationship = relationship | (0, $6c0093e2f673fa5d$export$2e2bcd8739ae039).LEFT;
    else if (x > maxX) relationship = relationship | (0, $6c0093e2f673fa5d$export$2e2bcd8739ae039).RIGHT;
    if (y < minY) relationship = relationship | (0, $6c0093e2f673fa5d$export$2e2bcd8739ae039).BELOW;
    else if (y > maxY) relationship = relationship | (0, $6c0093e2f673fa5d$export$2e2bcd8739ae039).ABOVE;
    if (relationship === (0, $6c0093e2f673fa5d$export$2e2bcd8739ae039).UNKNOWN) relationship = (0, $6c0093e2f673fa5d$export$2e2bcd8739ae039).INTERSECTING;
    return relationship;
}
function $dea65c2f666fa450$export$fe201bb3bbe031e9() {
    return [
        Infinity,
        Infinity,
        -Infinity,
        -Infinity
    ];
}
function $dea65c2f666fa450$export$958e3e1a02eac4b6(minX, minY, maxX, maxY, dest) {
    if (dest) {
        dest[0] = minX;
        dest[1] = minY;
        dest[2] = maxX;
        dest[3] = maxY;
        return dest;
    }
    return [
        minX,
        minY,
        maxX,
        maxY
    ];
}
function $dea65c2f666fa450$export$3e2152b047719fa1(dest) {
    return $dea65c2f666fa450$export$958e3e1a02eac4b6(Infinity, Infinity, -Infinity, -Infinity, dest);
}
function $dea65c2f666fa450$export$4838bf78d04a9440(coordinate, dest) {
    const x = coordinate[0];
    const y = coordinate[1];
    return $dea65c2f666fa450$export$958e3e1a02eac4b6(x, y, x, y, dest);
}
function $dea65c2f666fa450$export$29e3ad4dbd0cb863(coordinates, dest) {
    const extent = $dea65c2f666fa450$export$3e2152b047719fa1(dest);
    return $dea65c2f666fa450$export$795cd48be4d5f252(extent, coordinates);
}
function $dea65c2f666fa450$export$be0ab0bf96ca59ca(flatCoordinates, offset, end, stride, dest) {
    const extent = $dea65c2f666fa450$export$3e2152b047719fa1(dest);
    return $dea65c2f666fa450$export$30570204156ffd18(extent, flatCoordinates, offset, end, stride);
}
function $dea65c2f666fa450$export$73b4897e93bc5c83(rings, dest) {
    const extent = $dea65c2f666fa450$export$3e2152b047719fa1(dest);
    return $dea65c2f666fa450$export$9b319549574402d7(extent, rings);
}
function $dea65c2f666fa450$export$e9bab7fafb253603(extent1, extent2) {
    return extent1[0] == extent2[0] && extent1[2] == extent2[2] && extent1[1] == extent2[1] && extent1[3] == extent2[3];
}
function $dea65c2f666fa450$export$998afeab28643bd6(extent1, extent2, tolerance) {
    return Math.abs(extent1[0] - extent2[0]) < tolerance && Math.abs(extent1[2] - extent2[2]) < tolerance && Math.abs(extent1[1] - extent2[1]) < tolerance && Math.abs(extent1[3] - extent2[3]) < tolerance;
}
function $dea65c2f666fa450$export$8b58be045bf06082(extent1, extent2) {
    if (extent2[0] < extent1[0]) extent1[0] = extent2[0];
    if (extent2[2] > extent1[2]) extent1[2] = extent2[2];
    if (extent2[1] < extent1[1]) extent1[1] = extent2[1];
    if (extent2[3] > extent1[3]) extent1[3] = extent2[3];
    return extent1;
}
function $dea65c2f666fa450$export$1f820e3920fa5715(extent, coordinate) {
    if (coordinate[0] < extent[0]) extent[0] = coordinate[0];
    if (coordinate[0] > extent[2]) extent[2] = coordinate[0];
    if (coordinate[1] < extent[1]) extent[1] = coordinate[1];
    if (coordinate[1] > extent[3]) extent[3] = coordinate[1];
}
function $dea65c2f666fa450$export$795cd48be4d5f252(extent, coordinates) {
    for(let i = 0, ii = coordinates.length; i < ii; ++i)$dea65c2f666fa450$export$1f820e3920fa5715(extent, coordinates[i]);
    return extent;
}
function $dea65c2f666fa450$export$30570204156ffd18(extent, flatCoordinates, offset, end, stride) {
    for(; offset < end; offset += stride)$dea65c2f666fa450$export$f1dab130b92b85a9(extent, flatCoordinates[offset], flatCoordinates[offset + 1]);
    return extent;
}
function $dea65c2f666fa450$export$9b319549574402d7(extent, rings) {
    for(let i = 0, ii = rings.length; i < ii; ++i)$dea65c2f666fa450$export$795cd48be4d5f252(extent, rings[i]);
    return extent;
}
function $dea65c2f666fa450$export$f1dab130b92b85a9(extent, x, y) {
    extent[0] = Math.min(extent[0], x);
    extent[1] = Math.min(extent[1], y);
    extent[2] = Math.max(extent[2], x);
    extent[3] = Math.max(extent[3], y);
}
function $dea65c2f666fa450$export$f9ed8a3d123a08e2(extent, callback) {
    let val;
    val = callback($dea65c2f666fa450$export$8d09f5e2e1bf560d(extent));
    if (val) return val;
    val = callback($dea65c2f666fa450$export$e77c1cf70445e168(extent));
    if (val) return val;
    val = callback($dea65c2f666fa450$export$b84fa077c8b05295(extent));
    if (val) return val;
    val = callback($dea65c2f666fa450$export$cb1538b07e6964ff(extent));
    if (val) return val;
    return false;
}
function $dea65c2f666fa450$export$520c40045967cb15(extent) {
    let area = 0;
    if (!$dea65c2f666fa450$export$dd1bc94b04021eeb(extent)) area = $dea65c2f666fa450$export$3c49c185de0c2bfc(extent) * $dea65c2f666fa450$export$c08559766941f856(extent);
    return area;
}
function $dea65c2f666fa450$export$8d09f5e2e1bf560d(extent) {
    return [
        extent[0],
        extent[1]
    ];
}
function $dea65c2f666fa450$export$e77c1cf70445e168(extent) {
    return [
        extent[2],
        extent[1]
    ];
}
function $dea65c2f666fa450$export$c91255cadecfe081(extent) {
    return [
        (extent[0] + extent[2]) / 2,
        (extent[1] + extent[3]) / 2
    ];
}
function $dea65c2f666fa450$export$a1cfd206661d0801(extent, corner) {
    let coordinate;
    if (corner === 'bottom-left') coordinate = $dea65c2f666fa450$export$8d09f5e2e1bf560d(extent);
    else if (corner === 'bottom-right') coordinate = $dea65c2f666fa450$export$e77c1cf70445e168(extent);
    else if (corner === 'top-left') coordinate = $dea65c2f666fa450$export$cb1538b07e6964ff(extent);
    else if (corner === 'top-right') coordinate = $dea65c2f666fa450$export$b84fa077c8b05295(extent);
    else throw new Error('Invalid corner');
    return coordinate;
}
function $dea65c2f666fa450$export$7d6fa884b32a3751(extent1, extent2) {
    const minX = Math.min(extent1[0], extent2[0]);
    const minY = Math.min(extent1[1], extent2[1]);
    const maxX = Math.max(extent1[2], extent2[2]);
    const maxY = Math.max(extent1[3], extent2[3]);
    return (maxX - minX) * (maxY - minY);
}
function $dea65c2f666fa450$export$13ba650faf8308(center, resolution, rotation, size, dest) {
    const [x0, y0, x1, y1, x2, y2, x3, y3] = $dea65c2f666fa450$export$4b7a6fb4002cd6ac(center, resolution, rotation, size);
    return $dea65c2f666fa450$export$958e3e1a02eac4b6(Math.min(x0, x1, x2, x3), Math.min(y0, y1, y2, y3), Math.max(x0, x1, x2, x3), Math.max(y0, y1, y2, y3), dest);
}
function $dea65c2f666fa450$export$4b7a6fb4002cd6ac(center, resolution, rotation, size) {
    const dx = resolution * size[0] / 2;
    const dy = resolution * size[1] / 2;
    const cosRotation = Math.cos(rotation);
    const sinRotation = Math.sin(rotation);
    const xCos = dx * cosRotation;
    const xSin = dx * sinRotation;
    const yCos = dy * cosRotation;
    const ySin = dy * sinRotation;
    const x = center[0];
    const y = center[1];
    return [
        x - xCos + ySin,
        y - xSin - yCos,
        x - xCos - ySin,
        y - xSin + yCos,
        x + xCos - ySin,
        y + xSin + yCos,
        x + xCos + ySin,
        y + xSin - yCos,
        x - xCos + ySin,
        y - xSin - yCos
    ];
}
function $dea65c2f666fa450$export$c08559766941f856(extent) {
    return extent[3] - extent[1];
}
function $dea65c2f666fa450$export$f3fe0e9a60cde324(extent1, extent2) {
    const intersection = $dea65c2f666fa450$export$72209efa88586d42(extent1, extent2);
    return $dea65c2f666fa450$export$520c40045967cb15(intersection);
}
function $dea65c2f666fa450$export$72209efa88586d42(extent1, extent2, dest) {
    const intersection = dest ? dest : $dea65c2f666fa450$export$fe201bb3bbe031e9();
    if ($dea65c2f666fa450$export$7b0a31e10bbff018(extent1, extent2)) {
        if (extent1[0] > extent2[0]) intersection[0] = extent1[0];
        else intersection[0] = extent2[0];
        if (extent1[1] > extent2[1]) intersection[1] = extent1[1];
        else intersection[1] = extent2[1];
        if (extent1[2] < extent2[2]) intersection[2] = extent1[2];
        else intersection[2] = extent2[2];
        if (extent1[3] < extent2[3]) intersection[3] = extent1[3];
        else intersection[3] = extent2[3];
    } else $dea65c2f666fa450$export$3e2152b047719fa1(intersection);
    return intersection;
}
function $dea65c2f666fa450$export$1bc603050bd777b1(extent) {
    return $dea65c2f666fa450$export$3c49c185de0c2bfc(extent) + $dea65c2f666fa450$export$c08559766941f856(extent);
}
function $dea65c2f666fa450$export$31b21d0167753bb4(extent) {
    return [
        extent[2] - extent[0],
        extent[3] - extent[1]
    ];
}
function $dea65c2f666fa450$export$cb1538b07e6964ff(extent) {
    return [
        extent[0],
        extent[3]
    ];
}
function $dea65c2f666fa450$export$b84fa077c8b05295(extent) {
    return [
        extent[2],
        extent[3]
    ];
}
function $dea65c2f666fa450$export$3c49c185de0c2bfc(extent) {
    return extent[2] - extent[0];
}
function $dea65c2f666fa450$export$7b0a31e10bbff018(extent1, extent2) {
    return extent1[0] <= extent2[2] && extent1[2] >= extent2[0] && extent1[1] <= extent2[3] && extent1[3] >= extent2[1];
}
function $dea65c2f666fa450$export$dd1bc94b04021eeb(extent) {
    return extent[2] < extent[0] || extent[3] < extent[1];
}
function $dea65c2f666fa450$export$6a4fe494c558c238(extent, dest) {
    if (dest) {
        dest[0] = extent[0];
        dest[1] = extent[1];
        dest[2] = extent[2];
        dest[3] = extent[3];
        return dest;
    }
    return extent;
}
function $dea65c2f666fa450$export$80cbab86674143b6(extent, value) {
    const deltaX = (extent[2] - extent[0]) / 2 * (value - 1);
    const deltaY = (extent[3] - extent[1]) / 2 * (value - 1);
    extent[0] -= deltaX;
    extent[2] += deltaX;
    extent[1] -= deltaY;
    extent[3] += deltaY;
}
function $dea65c2f666fa450$export$a6a5a7a461419425(extent, start, end) {
    let intersects = false;
    const startRel = $dea65c2f666fa450$export$f97905ead28c61a8(extent, start);
    const endRel = $dea65c2f666fa450$export$f97905ead28c61a8(extent, end);
    if (startRel === (0, $6c0093e2f673fa5d$export$2e2bcd8739ae039).INTERSECTING || endRel === (0, $6c0093e2f673fa5d$export$2e2bcd8739ae039).INTERSECTING) intersects = true;
    else {
        const minX = extent[0];
        const minY = extent[1];
        const maxX = extent[2];
        const maxY = extent[3];
        const startX = start[0];
        const startY = start[1];
        const endX = end[0];
        const endY = end[1];
        const slope = (endY - startY) / (endX - startX);
        let x, y;
        if (!!(endRel & (0, $6c0093e2f673fa5d$export$2e2bcd8739ae039).ABOVE) && !(startRel & (0, $6c0093e2f673fa5d$export$2e2bcd8739ae039).ABOVE)) {
            // potentially intersects top
            x = endX - (endY - maxY) / slope;
            intersects = x >= minX && x <= maxX;
        }
        if (!intersects && !!(endRel & (0, $6c0093e2f673fa5d$export$2e2bcd8739ae039).RIGHT) && !(startRel & (0, $6c0093e2f673fa5d$export$2e2bcd8739ae039).RIGHT)) {
            // potentially intersects right
            y = endY - (endX - maxX) * slope;
            intersects = y >= minY && y <= maxY;
        }
        if (!intersects && !!(endRel & (0, $6c0093e2f673fa5d$export$2e2bcd8739ae039).BELOW) && !(startRel & (0, $6c0093e2f673fa5d$export$2e2bcd8739ae039).BELOW)) {
            // potentially intersects bottom
            x = endX - (endY - minY) / slope;
            intersects = x >= minX && x <= maxX;
        }
        if (!intersects && !!(endRel & (0, $6c0093e2f673fa5d$export$2e2bcd8739ae039).LEFT) && !(startRel & (0, $6c0093e2f673fa5d$export$2e2bcd8739ae039).LEFT)) {
            // potentially intersects left
            y = endY - (endX - minX) * slope;
            intersects = y >= minY && y <= maxY;
        }
    }
    return intersects;
}
function $dea65c2f666fa450$export$9f9dcb98c894b623(extent, transformFn, dest, stops) {
    if ($dea65c2f666fa450$export$dd1bc94b04021eeb(extent)) return $dea65c2f666fa450$export$3e2152b047719fa1(dest);
    let coordinates = [];
    if (stops > 1) {
        const width = extent[2] - extent[0];
        const height = extent[3] - extent[1];
        for(let i = 0; i < stops; ++i)coordinates.push(extent[0] + width * i / stops, extent[1], extent[2], extent[1] + height * i / stops, extent[2] - width * i / stops, extent[3], extent[0], extent[3] - height * i / stops);
    } else coordinates = [
        extent[0],
        extent[1],
        extent[2],
        extent[1],
        extent[2],
        extent[3],
        extent[0],
        extent[3]
    ];
    transformFn(coordinates, coordinates, 2);
    const xs = [];
    const ys = [];
    for(let i = 0, l = coordinates.length; i < l; i += 2){
        xs.push(coordinates[i]);
        ys.push(coordinates[i + 1]);
    }
    return $dea65c2f666fa450$var$_boundingExtentXYs(xs, ys, dest);
}
function $dea65c2f666fa450$export$39a9ce3624977b84(extent, projection) {
    const projectionExtent = projection.getExtent();
    const center = $dea65c2f666fa450$export$c91255cadecfe081(extent);
    if (projection.canWrapX() && (center[0] < projectionExtent[0] || center[0] >= projectionExtent[2])) {
        const worldWidth = $dea65c2f666fa450$export$3c49c185de0c2bfc(projectionExtent);
        const worldsAway = Math.floor((center[0] - projectionExtent[0]) / worldWidth);
        const offset = worldsAway * worldWidth;
        extent[0] -= offset;
        extent[2] -= offset;
    }
    return extent;
}
function $dea65c2f666fa450$export$9031237f01de0947(extent, projection, multiWorld) {
    if (projection.canWrapX()) {
        const projectionExtent = projection.getExtent();
        if (!isFinite(extent[0]) || !isFinite(extent[2])) return [
            [
                projectionExtent[0],
                extent[1],
                projectionExtent[2],
                extent[3]
            ]
        ];
        $dea65c2f666fa450$export$39a9ce3624977b84(extent, projection);
        const worldWidth = $dea65c2f666fa450$export$3c49c185de0c2bfc(projectionExtent);
        if ($dea65c2f666fa450$export$3c49c185de0c2bfc(extent) > worldWidth && !multiWorld) // the extent wraps around on itself
        return [
            [
                projectionExtent[0],
                extent[1],
                projectionExtent[2],
                extent[3]
            ]
        ];
        if (extent[0] < projectionExtent[0]) // the extent crosses the anti meridian, so it needs to be sliced
        return [
            [
                extent[0] + worldWidth,
                extent[1],
                projectionExtent[2],
                extent[3]
            ],
            [
                projectionExtent[0],
                extent[1],
                extent[2],
                extent[3]
            ]
        ];
        if (extent[2] > projectionExtent[2]) // the extent crosses the anti meridian, so it needs to be sliced
        return [
            [
                extent[0],
                extent[1],
                projectionExtent[2],
                extent[3]
            ],
            [
                projectionExtent[0],
                extent[1],
                extent[2] - worldWidth,
                extent[3]
            ]
        ];
    }
    return [
        extent
    ];
}


/**
 * @module ol/math
 */ /**
 * Takes a number and clamps it to within the provided bounds.
 * @param {number} value The input number.
 * @param {number} min The minimum value to return.
 * @param {number} max The maximum value to return.
 * @return {number} The input number if it is within bounds, or the nearest
 *     number within the bounds.
 */ function $6a95bd76d7103f37$export$7d15b64cf5a3a4c4(value, min, max) {
    return Math.min(Math.max(value, min), max);
}
function $6a95bd76d7103f37$export$251bb0a9cef172e6(x, y, x1, y1, x2, y2) {
    const dx = x2 - x1;
    const dy = y2 - y1;
    if (dx !== 0 || dy !== 0) {
        const t = ((x - x1) * dx + (y - y1) * dy) / (dx * dx + dy * dy);
        if (t > 1) {
            x1 = x2;
            y1 = y2;
        } else if (t > 0) {
            x1 += dx * t;
            y1 += dy * t;
        }
    }
    return $6a95bd76d7103f37$export$88e6ebb4fe54f538(x, y, x1, y1);
}
function $6a95bd76d7103f37$export$88e6ebb4fe54f538(x1, y1, x2, y2) {
    const dx = x2 - x1;
    const dy = y2 - y1;
    return dx * dx + dy * dy;
}
function $6a95bd76d7103f37$export$8240f01c446270e6(mat) {
    const n = mat.length;
    for(let i = 0; i < n; i++){
        // Find max in the i-th column (ignoring i - 1 first rows)
        let maxRow = i;
        let maxEl = Math.abs(mat[i][i]);
        for(let r = i + 1; r < n; r++){
            const absValue = Math.abs(mat[r][i]);
            if (absValue > maxEl) {
                maxEl = absValue;
                maxRow = r;
            }
        }
        if (maxEl === 0) return null; // matrix is singular
        // Swap max row with i-th (current) row
        const tmp = mat[maxRow];
        mat[maxRow] = mat[i];
        mat[i] = tmp;
        // Subtract the i-th row to make all the remaining rows 0 in the i-th column
        for(let j = i + 1; j < n; j++){
            const coef = -mat[j][i] / mat[i][i];
            for(let k = i; k < n + 1; k++)if (i == k) mat[j][k] = 0;
            else mat[j][k] += coef * mat[i][k];
        }
    }
    // Solve Ax=b for upper triangular matrix A (mat)
    const x = new Array(n);
    for(let l = n - 1; l >= 0; l--){
        x[l] = mat[l][n] / mat[l][l];
        for(let m = l - 1; m >= 0; m--)mat[m][n] -= mat[m][l] * x[l];
    }
    return x;
}
function $6a95bd76d7103f37$export$56cb859c01fa134d(angleInRadians) {
    return angleInRadians * 180 / Math.PI;
}
function $6a95bd76d7103f37$export$cba01ba138429a1d(angleInDegrees) {
    return angleInDegrees * Math.PI / 180;
}
function $6a95bd76d7103f37$export$ba467bec01d66def(a, b) {
    const r = a % b;
    return r * b < 0 ? r + b : r;
}
function $6a95bd76d7103f37$export$3a89f8d6f6bf6c9f(a, b, x) {
    return a + x * (b - a);
}
function $6a95bd76d7103f37$export$a81f732198733497(n, decimals) {
    const factor = Math.pow(10, decimals);
    return Math.round(n * factor) / factor;
}
function $6a95bd76d7103f37$export$2077e0241d6afd3c(n, decimals) {
    return Math.round($6a95bd76d7103f37$export$a81f732198733497(n, decimals));
}
function $6a95bd76d7103f37$export$a3fe094919f356fd(n, decimals) {
    return Math.floor($6a95bd76d7103f37$export$a81f732198733497(n, decimals));
}
function $6a95bd76d7103f37$export$803ce6b71a0a94b2(n, decimals) {
    return Math.ceil($6a95bd76d7103f37$export$a81f732198733497(n, decimals));
}
function $6a95bd76d7103f37$export$4997ffc0176396a6(n, min, max) {
    if (n >= min && n < max) return n;
    const range = max - min;
    return ((n - min) % range + range) % range + min;
}


/**
 * @module ol/string
 */ /**
 * @param {number} number Number to be formatted
 * @param {number} width The desired width
 * @param {number} [precision] Precision of the output string (i.e. number of decimal places)
 * @return {string} Formatted string
 */ function $cef15f396d6ffa11$export$24be126cb0a7bbeb(number, width, precision) {
    const numberString = precision !== undefined ? number.toFixed(precision) : '' + number;
    let decimal = numberString.indexOf('.');
    decimal = decimal === -1 ? numberString.length : decimal;
    return decimal > width ? numberString : new Array(1 + width - decimal).join('0') + numberString;
}
function $cef15f396d6ffa11$export$66e1c0999abad646(v1, v2) {
    const s1 = ('' + v1).split('.');
    const s2 = ('' + v2).split('.');
    for(let i = 0; i < Math.max(s1.length, s2.length); i++){
        const n1 = parseInt(s1[i] || '0', 10);
        const n2 = parseInt(s2[i] || '0', 10);
        if (n1 > n2) return 1;
        if (n2 > n1) return -1;
    }
    return 0;
}


function $a6adb03fd2fbc071$export$e16d8520af44a096(coordinate, delta) {
    coordinate[0] += +delta[0];
    coordinate[1] += +delta[1];
    return coordinate;
}
function $a6adb03fd2fbc071$export$cbe80a3fcd2b99b7(coordinate, circle) {
    const r = circle.getRadius();
    const center = circle.getCenter();
    const x0 = center[0];
    const y0 = center[1];
    const x1 = coordinate[0];
    const y1 = coordinate[1];
    let dx = x1 - x0;
    const dy = y1 - y0;
    if (dx === 0 && dy === 0) dx = 1;
    const d = Math.sqrt(dx * dx + dy * dy);
    const x = x0 + r * dx / d;
    const y = y0 + r * dy / d;
    return [
        x,
        y
    ];
}
function $a6adb03fd2fbc071$export$18cdd31d17f97131(coordinate, segment) {
    const x0 = coordinate[0];
    const y0 = coordinate[1];
    const start = segment[0];
    const end = segment[1];
    const x1 = start[0];
    const y1 = start[1];
    const x2 = end[0];
    const y2 = end[1];
    const dx = x2 - x1;
    const dy = y2 - y1;
    const along = dx === 0 && dy === 0 ? 0 : (dx * (x0 - x1) + dy * (y0 - y1)) / (dx * dx + dy * dy || 0);
    let x, y;
    if (along <= 0) {
        x = x1;
        y = y1;
    } else if (along >= 1) {
        x = x2;
        y = y2;
    } else {
        x = x1 + along * dx;
        y = y1 + along * dy;
    }
    return [
        x,
        y
    ];
}
function $a6adb03fd2fbc071$export$35ad6765fe262b6(fractionDigits) {
    return(/**
     * @param {Coordinate} coordinate Coordinate.
     * @return {string} String XY.
     */ function(coordinate) {
        return $a6adb03fd2fbc071$export$9ff8f16060979e0a(coordinate, fractionDigits);
    });
}
function $a6adb03fd2fbc071$export$6eb0ac5f024d8590(hemispheres, degrees, fractionDigits) {
    const normalizedDegrees = (0, $6a95bd76d7103f37$export$ba467bec01d66def)(degrees + 180, 360) - 180;
    const x = Math.abs(3600 * normalizedDegrees);
    const decimals = fractionDigits || 0;
    let deg = Math.floor(x / 3600);
    let min = Math.floor((x - deg * 3600) / 60);
    let sec = (0, $6a95bd76d7103f37$export$a81f732198733497)(x - deg * 3600 - min * 60, decimals);
    if (sec >= 60) {
        sec = 0;
        min += 1;
    }
    if (min >= 60) {
        min = 0;
        deg += 1;
    }
    let hdms = deg + '\u00b0';
    if (min !== 0 || sec !== 0) hdms += ' ' + (0, $cef15f396d6ffa11$export$24be126cb0a7bbeb)(min, 2) + '\u2032';
    if (sec !== 0) hdms += ' ' + (0, $cef15f396d6ffa11$export$24be126cb0a7bbeb)(sec, 2, decimals) + '\u2033';
    if (normalizedDegrees !== 0) hdms += ' ' + hemispheres.charAt(normalizedDegrees < 0 ? 1 : 0);
    return hdms;
}
function $a6adb03fd2fbc071$export$d9468344d3651243(coordinate, template, fractionDigits) {
    if (coordinate) return template.replace('{x}', coordinate[0].toFixed(fractionDigits)).replace('{y}', coordinate[1].toFixed(fractionDigits));
    return '';
}
function $a6adb03fd2fbc071$export$e9bab7fafb253603(coordinate1, coordinate2) {
    let equals = true;
    for(let i = coordinate1.length - 1; i >= 0; --i)if (coordinate1[i] != coordinate2[i]) {
        equals = false;
        break;
    }
    return equals;
}
function $a6adb03fd2fbc071$export$bb628a54ab399bc9(coordinate, angle) {
    const cosAngle = Math.cos(angle);
    const sinAngle = Math.sin(angle);
    const x = coordinate[0] * cosAngle - coordinate[1] * sinAngle;
    const y = coordinate[1] * cosAngle + coordinate[0] * sinAngle;
    coordinate[0] = x;
    coordinate[1] = y;
    return coordinate;
}
function $a6adb03fd2fbc071$export$dcdf75081b88279d(coordinate, scale) {
    coordinate[0] *= scale;
    coordinate[1] *= scale;
    return coordinate;
}
function $a6adb03fd2fbc071$export$88e6ebb4fe54f538(coord1, coord2) {
    const dx = coord1[0] - coord2[0];
    const dy = coord1[1] - coord2[1];
    return dx * dx + dy * dy;
}
function $a6adb03fd2fbc071$export$9f17032d917177de(coord1, coord2) {
    return Math.sqrt($a6adb03fd2fbc071$export$88e6ebb4fe54f538(coord1, coord2));
}
function $a6adb03fd2fbc071$export$6985570514055196(coordinate, segment) {
    return $a6adb03fd2fbc071$export$88e6ebb4fe54f538(coordinate, $a6adb03fd2fbc071$export$18cdd31d17f97131(coordinate, segment));
}
function $a6adb03fd2fbc071$export$c883fd238161f841(coordinate, fractionDigits) {
    if (coordinate) return $a6adb03fd2fbc071$export$6eb0ac5f024d8590('NS', coordinate[1], fractionDigits) + ' ' + $a6adb03fd2fbc071$export$6eb0ac5f024d8590('EW', coordinate[0], fractionDigits);
    return '';
}
function $a6adb03fd2fbc071$export$9ff8f16060979e0a(coordinate, fractionDigits) {
    return $a6adb03fd2fbc071$export$d9468344d3651243(coordinate, '{x}, {y}', fractionDigits);
}
function $a6adb03fd2fbc071$export$39a9ce3624977b84(coordinate, projection) {
    if (projection.canWrapX()) {
        const worldWidth = (0, $dea65c2f666fa450$export$3c49c185de0c2bfc)(projection.getExtent());
        const worldsAway = $a6adb03fd2fbc071$export$24e2b27d1ff0c1d5(coordinate, projection, worldWidth);
        if (worldsAway) coordinate[0] -= worldsAway * worldWidth;
    }
    return coordinate;
}
function $a6adb03fd2fbc071$export$24e2b27d1ff0c1d5(coordinate, projection, sourceExtentWidth) {
    const projectionExtent = projection.getExtent();
    let worldsAway = 0;
    if (projection.canWrapX() && (coordinate[0] < projectionExtent[0] || coordinate[0] > projectionExtent[2])) {
        sourceExtentWidth = sourceExtentWidth || (0, $dea65c2f666fa450$export$3c49c185de0c2bfc)(projectionExtent);
        worldsAway = Math.floor((coordinate[0] - projectionExtent[0]) / sourceExtentWidth);
    }
    return worldsAway;
}
function $a6adb03fd2fbc071$export$47cb7eb79666608a(p0, pA, pB) {
    const lenA = Math.sqrt((pA[0] - p0[0]) * (pA[0] - p0[0]) + (pA[1] - p0[1]) * (pA[1] - p0[1]));
    const tangentA = [
        (pA[0] - p0[0]) / lenA,
        (pA[1] - p0[1]) / lenA
    ];
    const orthoA = [
        -tangentA[1],
        tangentA[0]
    ];
    const lenB = Math.sqrt((pB[0] - p0[0]) * (pB[0] - p0[0]) + (pB[1] - p0[1]) * (pB[1] - p0[1]));
    const tangentB = [
        (pB[0] - p0[0]) / lenB,
        (pB[1] - p0[1]) / lenB
    ];
    // this angle can be clockwise or anticlockwise; hence the computation afterwards
    let angle = lenA === 0 || lenB === 0 ? 0 : Math.acos((0, $6a95bd76d7103f37$export$7d15b64cf5a3a4c4)(tangentB[0] * tangentA[0] + tangentB[1] * tangentA[1], -1, 1));
    angle = Math.max(angle, 0.00001); // avoid a zero angle otherwise this is detected as a line cap
    const isClockwise = tangentB[0] * orthoA[0] + tangentB[1] * orthoA[1] > 0;
    return !isClockwise ? Math.PI * 2 - angle : angle;
}





/**
 * @module ol/proj/Units
 */ /**
 * @typedef {'radians' | 'degrees' | 'ft' | 'm' | 'pixels' | 'tile-pixels' | 'us-ft'} Units
 * Projection units.
 */ /**
 * See http://duff.ess.washington.edu/data/raster/drg/docs/geotiff.txt
 * @type {Object<number, Units>}
 */ const $9149a5943443441b$var$unitByCode = {
    '9001': 'm',
    '9002': 'ft',
    '9003': 'us-ft',
    '9101': 'radians',
    '9102': 'degrees'
};
function $9149a5943443441b$export$7f58726df3255edc(code) {
    return $9149a5943443441b$var$unitByCode[code];
}
const $9149a5943443441b$export$1482081eec883108 = {
    // use the radius of the Normal sphere
    'radians': 6370997 / (2 * Math.PI),
    'degrees': 2 * Math.PI * 6370997 / 360,
    'ft': 0.3048,
    'm': 1,
    'us-ft': 1200 / 3937
};


/**
 * @module ol/proj/epsg3857
 */ /**
 * @module ol/proj/Projection
 */ 
/**
 * The function is called with a `number` view resolution and a
 * {@link module:ol/coordinate~Coordinate} as arguments, and returns the `number` resolution
 * in projection units at the passed coordinate.
 * @typedef {function(number, import("../coordinate.js").Coordinate):number} GetPointResolution
 * @api
 */ /**
 * @typedef {Object} Options
 * @property {string} code The SRS identifier code, e.g. `EPSG:4326`.
 * @property {import("./Units.js").Units} [units] Units. Required unless a
 * proj4 projection is defined for `code`.
 * @property {import("../extent.js").Extent} [extent] The validity extent for the SRS.
 * @property {string} [axisOrientation='enu'] The axis orientation as specified in Proj4.
 * @property {boolean} [global=false] Whether the projection is valid for the whole globe.
 * @property {number} [metersPerUnit] The meters per unit for the SRS.
 * If not provided, the `units` are used to get the meters per unit from the {@link METERS_PER_UNIT}
 * lookup table.
 * @property {import("../extent.js").Extent} [worldExtent] The world extent for the SRS.
 * @property {GetPointResolution} [getPointResolution]
 * Function to determine resolution at a point. The function is called with a
 * `number` view resolution and a {@link module:ol/coordinate~Coordinate} as arguments, and returns
 * the `number` resolution in projection units at the passed coordinate. If this is `undefined`,
 * the default {@link module:ol/proj.getPointResolution} function will be used.
 */ /**
 * @classdesc
 * In most cases, you should not need to create instances of this class.
 * Instead, where projection information is required, you can use a string
 * projection code or identifier (e.g. `EPSG:4326`) instead of a projection
 * instance.
 *
 * The library includes support for transforming coordinates between the following
 * projections:
 *
 *  WGS 84 / Geographic - Using codes `EPSG:4326`, `CRS:84`, `urn:ogc:def:crs:EPSG:6.6:4326`,
 *    `urn:ogc:def:crs:OGC:1.3:CRS84`, `urn:ogc:def:crs:OGC:2:84`, `http://www.opengis.net/gml/srs/epsg.xml#4326`,
 *    or `urn:x-ogc:def:crs:EPSG:4326`
 *  WGS 84 / Spherical Mercator - Using codes `EPSG:3857`, `EPSG:102100`, `EPSG:102113`, `EPSG:900913`,
 *    `urn:ogc:def:crs:EPSG:6.18:3:3857`, or `http://www.opengis.net/gml/srs/epsg.xml#3857`
 *  WGS 84 / UTM zones - Using codes `EPSG:32601` through `EPSG:32660` for northern zones
 *    and `EPSG:32701` through `EPSG:32760` for southern zones. Note that the built-in UTM transforms
 *    are lower accuracy (with errors on the order of 0.1 m) than those that you might get in a
 *    library like [proj4js](https://github.com/proj4js/proj4js).
 *
 * For additional projection support, or to use higher accuracy transforms than the built-in ones, you can use
 * the [proj4js](https://github.com/proj4js/proj4js) library. With `proj4js`, after adding any new projection
 * definitions, call the {@link module:ol/proj/proj4.register} function.
 *
 * You can use the {@link module:ol/proj.get} function to retrieve a projection instance
 * for one of the registered projections.
 *
 * @api
 */ class $860cd07813cc0557$var$Projection {
    /**
   * @param {Options} options Projection options.
   */ constructor(options){
        /**
     * @private
     * @type {string}
     */ this.code_ = options.code;
        /**
     * Units of projected coordinates. When set to `TILE_PIXELS`, a
     * `this.extent_` and `this.worldExtent_` must be configured properly for each
     * tile.
     * @private
     * @type {import("./Units.js").Units}
     */ this.units_ = /** @type {import("./Units.js").Units} */ options.units;
        /**
     * Validity extent of the projection in projected coordinates. For projections
     * with `TILE_PIXELS` units, this is the extent of the tile in
     * tile pixel space.
     * @private
     * @type {import("../extent.js").Extent}
     */ this.extent_ = options.extent !== undefined ? options.extent : null;
        /**
     * Extent of the world in EPSG:4326. For projections with
     * `TILE_PIXELS` units, this is the extent of the tile in
     * projected coordinate space.
     * @private
     * @type {import("../extent.js").Extent}
     */ this.worldExtent_ = options.worldExtent !== undefined ? options.worldExtent : null;
        /**
     * @private
     * @type {string}
     */ this.axisOrientation_ = options.axisOrientation !== undefined ? options.axisOrientation : 'enu';
        /**
     * @private
     * @type {boolean}
     */ this.global_ = options.global !== undefined ? options.global : false;
        /**
     * @private
     * @type {boolean}
     */ this.canWrapX_ = !!(this.global_ && this.extent_);
        /**
     * @private
     * @type {GetPointResolution|undefined}
     */ this.getPointResolutionFunc_ = options.getPointResolution;
        /**
     * @private
     * @type {import("../tilegrid/TileGrid.js").default}
     */ this.defaultTileGrid_ = null;
        /**
     * @private
     * @type {number|undefined}
     */ this.metersPerUnit_ = options.metersPerUnit;
    }
    /**
   * @return {boolean} The projection is suitable for wrapping the x-axis
   */ canWrapX() {
        return this.canWrapX_;
    }
    /**
   * Get the code for this projection, e.g. 'EPSG:4326'.
   * @return {string} Code.
   * @api
   */ getCode() {
        return this.code_;
    }
    /**
   * Get the validity extent for this projection.
   * @return {import("../extent.js").Extent} Extent.
   * @api
   */ getExtent() {
        return this.extent_;
    }
    /**
   * Get the units of this projection.
   * @return {import("./Units.js").Units} Units.
   * @api
   */ getUnits() {
        return this.units_;
    }
    /**
   * Get the amount of meters per unit of this projection.  If the projection is
   * not configured with `metersPerUnit` or a units identifier, the return is
   * `undefined`.
   * @return {number|undefined} Meters.
   * @api
   */ getMetersPerUnit() {
        return this.metersPerUnit_ || (0, $9149a5943443441b$export$1482081eec883108)[this.units_];
    }
    /**
   * Get the world extent for this projection.
   * @return {import("../extent.js").Extent} Extent.
   * @api
   */ getWorldExtent() {
        return this.worldExtent_;
    }
    /**
   * Get the axis orientation of this projection.
   * Example values are:
   * enu - the default easting, northing, elevation.
   * neu - northing, easting, up - useful for "lat/long" geographic coordinates,
   *     or south orientated transverse mercator.
   * wnu - westing, northing, up - some planetary coordinate systems have
   *     "west positive" coordinate systems
   * @return {string} Axis orientation.
   * @api
   */ getAxisOrientation() {
        return this.axisOrientation_;
    }
    /**
   * Is this projection a global projection which spans the whole world?
   * @return {boolean} Whether the projection is global.
   * @api
   */ isGlobal() {
        return this.global_;
    }
    /**
   * Set if the projection is a global projection which spans the whole world
   * @param {boolean} global Whether the projection is global.
   * @api
   */ setGlobal(global) {
        this.global_ = global;
        this.canWrapX_ = !!(global && this.extent_);
    }
    /**
   * @return {import("../tilegrid/TileGrid.js").default} The default tile grid.
   */ getDefaultTileGrid() {
        return this.defaultTileGrid_;
    }
    /**
   * @param {import("../tilegrid/TileGrid.js").default} tileGrid The default tile grid.
   */ setDefaultTileGrid(tileGrid) {
        this.defaultTileGrid_ = tileGrid;
    }
    /**
   * Set the validity extent for this projection.
   * @param {import("../extent.js").Extent} extent Extent.
   * @api
   */ setExtent(extent) {
        this.extent_ = extent;
        this.canWrapX_ = !!(this.global_ && extent);
    }
    /**
   * Set the world extent for this projection.
   * @param {import("../extent.js").Extent} worldExtent World extent
   *     [minlon, minlat, maxlon, maxlat].
   * @api
   */ setWorldExtent(worldExtent) {
        this.worldExtent_ = worldExtent;
    }
    /**
   * Set the getPointResolution function (see {@link module:ol/proj.getPointResolution}
   * for this projection.
   * @param {function(number, import("../coordinate.js").Coordinate):number} func Function
   * @api
   */ setGetPointResolution(func) {
        this.getPointResolutionFunc_ = func;
    }
    /**
   * Get the custom point resolution function for this projection (if set).
   * @return {GetPointResolution|undefined} The custom point
   * resolution function (if set).
   */ getPointResolutionFunc() {
        return this.getPointResolutionFunc_;
    }
}
var $860cd07813cc0557$export$2e2bcd8739ae039 = $860cd07813cc0557$var$Projection;


const $e9bc1fa2f35e7c83$export$2d2c9be8b5b863f = 6378137;
const $e9bc1fa2f35e7c83$export$f3928063e5e96d35 = Math.PI * $e9bc1fa2f35e7c83$export$2d2c9be8b5b863f;
const $e9bc1fa2f35e7c83$export$21e6da8a7375dfe8 = [
    -$e9bc1fa2f35e7c83$export$f3928063e5e96d35,
    -$e9bc1fa2f35e7c83$export$f3928063e5e96d35,
    $e9bc1fa2f35e7c83$export$f3928063e5e96d35,
    $e9bc1fa2f35e7c83$export$f3928063e5e96d35
];
const $e9bc1fa2f35e7c83$export$ae9d6ed80df710e5 = [
    -180,
    -85,
    180,
    85
];
const $e9bc1fa2f35e7c83$export$d26945d1ad52feeb = $e9bc1fa2f35e7c83$export$2d2c9be8b5b863f * Math.log(Math.tan(Math.PI / 2));
/**
 * @classdesc
 * Projection object for web/spherical Mercator (EPSG:3857).
 */ class $e9bc1fa2f35e7c83$var$EPSG3857Projection extends (0, $860cd07813cc0557$export$2e2bcd8739ae039) {
    /**
   * @param {string} code Code.
   */ constructor(code){
        super({
            code: code,
            units: 'm',
            extent: $e9bc1fa2f35e7c83$export$21e6da8a7375dfe8,
            global: true,
            worldExtent: $e9bc1fa2f35e7c83$export$ae9d6ed80df710e5,
            getPointResolution: function(resolution, point) {
                return resolution / Math.cosh(point[1] / $e9bc1fa2f35e7c83$export$2d2c9be8b5b863f);
            }
        });
    }
}
const $e9bc1fa2f35e7c83$export$b508d7ad9a891c1b = [
    new $e9bc1fa2f35e7c83$var$EPSG3857Projection('EPSG:3857'),
    new $e9bc1fa2f35e7c83$var$EPSG3857Projection('EPSG:102100'),
    new $e9bc1fa2f35e7c83$var$EPSG3857Projection('EPSG:102113'),
    new $e9bc1fa2f35e7c83$var$EPSG3857Projection('EPSG:900913'),
    new $e9bc1fa2f35e7c83$var$EPSG3857Projection('http://www.opengis.net/def/crs/EPSG/0/3857'),
    new $e9bc1fa2f35e7c83$var$EPSG3857Projection('http://www.opengis.net/gml/srs/epsg.xml#3857')
];
function $e9bc1fa2f35e7c83$export$1ff8bb36c0983070(input, output, dimension, stride) {
    const length = input.length;
    dimension = dimension > 1 ? dimension : 2;
    stride = stride ?? dimension;
    if (output === undefined) {
        if (dimension > 2) // preserve values beyond second dimension
        output = input.slice();
        else output = new Array(length);
    }
    for(let i = 0; i < length; i += stride){
        output[i] = $e9bc1fa2f35e7c83$export$f3928063e5e96d35 * input[i] / 180;
        let y = $e9bc1fa2f35e7c83$export$2d2c9be8b5b863f * Math.log(Math.tan(Math.PI * (+input[i + 1] + 90) / 360));
        if (y > $e9bc1fa2f35e7c83$export$d26945d1ad52feeb) y = $e9bc1fa2f35e7c83$export$d26945d1ad52feeb;
        else if (y < -$e9bc1fa2f35e7c83$export$d26945d1ad52feeb) y = -$e9bc1fa2f35e7c83$export$d26945d1ad52feeb;
        output[i + 1] = y;
    }
    return output;
}
function $e9bc1fa2f35e7c83$export$8c71322ec28ed6b4(input, output, dimension, stride) {
    const length = input.length;
    dimension = dimension > 1 ? dimension : 2;
    stride = stride ?? dimension;
    if (output === undefined) {
        if (dimension > 2) // preserve values beyond second dimension
        output = input.slice();
        else output = new Array(length);
    }
    for(let i = 0; i < length; i += stride){
        output[i] = 180 * input[i] / $e9bc1fa2f35e7c83$export$f3928063e5e96d35;
        output[i + 1] = 360 * Math.atan(Math.exp(input[i + 1] / $e9bc1fa2f35e7c83$export$2d2c9be8b5b863f)) / Math.PI - 90;
    }
    return output;
}


/**
 * @module ol/proj/epsg4326
 */ 
const $6b0bea253f4bbdff$export$2d2c9be8b5b863f = 6378137;
const $6b0bea253f4bbdff$export$21e6da8a7375dfe8 = [
    -180,
    -90,
    180,
    90
];
const $6b0bea253f4bbdff$export$1482081eec883108 = Math.PI * $6b0bea253f4bbdff$export$2d2c9be8b5b863f / 180;
/**
 * @classdesc
 * Projection object for WGS84 geographic coordinates (EPSG:4326).
 *
 * Note that OpenLayers does not strictly comply with the EPSG definition.
 * The EPSG registry defines 4326 as a CRS for Latitude,Longitude (y,x).
 * OpenLayers treats EPSG:4326 as a pseudo-projection, with x,y coordinates.
 */ class $6b0bea253f4bbdff$var$EPSG4326Projection extends (0, $860cd07813cc0557$export$2e2bcd8739ae039) {
    /**
   * @param {string} code Code.
   * @param {string} [axisOrientation] Axis orientation.
   */ constructor(code, axisOrientation){
        super({
            code: code,
            units: 'degrees',
            extent: $6b0bea253f4bbdff$export$21e6da8a7375dfe8,
            axisOrientation: axisOrientation,
            global: true,
            metersPerUnit: $6b0bea253f4bbdff$export$1482081eec883108,
            worldExtent: $6b0bea253f4bbdff$export$21e6da8a7375dfe8
        });
    }
}
const $6b0bea253f4bbdff$export$b508d7ad9a891c1b = [
    new $6b0bea253f4bbdff$var$EPSG4326Projection('CRS:84'),
    new $6b0bea253f4bbdff$var$EPSG4326Projection('EPSG:4326', 'neu'),
    new $6b0bea253f4bbdff$var$EPSG4326Projection('urn:ogc:def:crs:OGC:1.3:CRS84'),
    new $6b0bea253f4bbdff$var$EPSG4326Projection('urn:ogc:def:crs:OGC:2:84'),
    new $6b0bea253f4bbdff$var$EPSG4326Projection('http://www.opengis.net/def/crs/OGC/1.3/CRS84'),
    new $6b0bea253f4bbdff$var$EPSG4326Projection('http://www.opengis.net/gml/srs/epsg.xml#4326', 'neu'),
    new $6b0bea253f4bbdff$var$EPSG4326Projection('http://www.opengis.net/def/crs/EPSG/0/4326', 'neu')
];


/**
 * @module ol/proj/projections
 */ /**
 * @type {Object<string, import("./Projection.js").default>}
 */ let $d466f1e669617b7b$var$cache = {};
function $d466f1e669617b7b$export$42ffd38884aecdac() {
    $d466f1e669617b7b$var$cache = {};
}
function $d466f1e669617b7b$export$3988ae62b71be9a3(code) {
    return $d466f1e669617b7b$var$cache[code] || $d466f1e669617b7b$var$cache[code.replace(/urn:(x-)?ogc:def:crs:EPSG:(.*:)?(\w+)$/, 'EPSG:$3')] || null;
}
function $d466f1e669617b7b$export$e16d8520af44a096(code, projection) {
    $d466f1e669617b7b$var$cache[code] = projection;
}


/**
 * @module ol/proj/transforms
 */ /**
 * @module ol/obj
 */ /**
 * Removes all properties from an object.
 * @param {Object<string, unknown>} object The object to clear.
 */ function $9f2b61a1df00e9b3$export$42ffd38884aecdac(object) {
    for(const property in object)delete object[property];
}
function $9f2b61a1df00e9b3$export$dd1bc94b04021eeb(object) {
    let property;
    for(property in object)return false;
    return !property;
}


/**
 * @private
 * @type {!Object<string, Object<string, import("../proj.js").TransformFunction>>}
 */ let $2c3e3bd0cd8365f3$var$transforms = {};
function $2c3e3bd0cd8365f3$export$42ffd38884aecdac() {
    $2c3e3bd0cd8365f3$var$transforms = {};
}
function $2c3e3bd0cd8365f3$export$e16d8520af44a096(source, destination, transformFn) {
    const sourceCode = source.getCode();
    const destinationCode = destination.getCode();
    if (!(sourceCode in $2c3e3bd0cd8365f3$var$transforms)) $2c3e3bd0cd8365f3$var$transforms[sourceCode] = {};
    $2c3e3bd0cd8365f3$var$transforms[sourceCode][destinationCode] = transformFn;
}
function $2c3e3bd0cd8365f3$export$cd7f480d6b8286c3(source, destination) {
    const sourceCode = source.getCode();
    const destinationCode = destination.getCode();
    const transform = $2c3e3bd0cd8365f3$var$transforms[sourceCode][destinationCode];
    delete $2c3e3bd0cd8365f3$var$transforms[sourceCode][destinationCode];
    if ((0, $9f2b61a1df00e9b3$export$dd1bc94b04021eeb)($2c3e3bd0cd8365f3$var$transforms[sourceCode])) delete $2c3e3bd0cd8365f3$var$transforms[sourceCode];
    return transform;
}
function $2c3e3bd0cd8365f3$export$3988ae62b71be9a3(sourceCode, destinationCode) {
    if (sourceCode in $2c3e3bd0cd8365f3$var$transforms && destinationCode in $2c3e3bd0cd8365f3$var$transforms[sourceCode]) return $2c3e3bd0cd8365f3$var$transforms[sourceCode][destinationCode];
    return null;
}


/**
 * @module ol/proj/utm
 */ /**
 * Adapted from https://github.com/Turbo87/utm
 * Copyright (c) 2012-2017 Tobias Bieniek
 *
 * The functions here provide approximate transforms to and from UTM.
 * They are not appropriate for use beyond the validity extend of a UTM
 * zone, and the accuracy of the transform decreases toward the zone
 * edges.
 */ 

/**
 * @typedef {Object} UTMZone
 * @property {number} number The zone number (1 - 60).
 * @property {boolean} north The northern hemisphere.
 */ const $090ed79ae7db779d$var$K0 = 0.9996;
const $090ed79ae7db779d$var$E = 0.00669438;
const $090ed79ae7db779d$var$E2 = $090ed79ae7db779d$var$E * $090ed79ae7db779d$var$E;
const $090ed79ae7db779d$var$E3 = $090ed79ae7db779d$var$E2 * $090ed79ae7db779d$var$E;
const $090ed79ae7db779d$var$E_P2 = $090ed79ae7db779d$var$E / (1 - $090ed79ae7db779d$var$E);
const $090ed79ae7db779d$var$SQRT_E = Math.sqrt(1 - $090ed79ae7db779d$var$E);
const $090ed79ae7db779d$var$_E = (1 - $090ed79ae7db779d$var$SQRT_E) / (1 + $090ed79ae7db779d$var$SQRT_E);
const $090ed79ae7db779d$var$_E2 = $090ed79ae7db779d$var$_E * $090ed79ae7db779d$var$_E;
const $090ed79ae7db779d$var$_E3 = $090ed79ae7db779d$var$_E2 * $090ed79ae7db779d$var$_E;
const $090ed79ae7db779d$var$_E4 = $090ed79ae7db779d$var$_E3 * $090ed79ae7db779d$var$_E;
const $090ed79ae7db779d$var$_E5 = $090ed79ae7db779d$var$_E4 * $090ed79ae7db779d$var$_E;
const $090ed79ae7db779d$var$M1 = 1 - $090ed79ae7db779d$var$E / 4 - 3 * $090ed79ae7db779d$var$E2 / 64 - 5 * $090ed79ae7db779d$var$E3 / 256;
const $090ed79ae7db779d$var$M2 = 3 * $090ed79ae7db779d$var$E / 8 + 3 * $090ed79ae7db779d$var$E2 / 32 + 45 * $090ed79ae7db779d$var$E3 / 1024;
const $090ed79ae7db779d$var$M3 = 15 * $090ed79ae7db779d$var$E2 / 256 + 45 * $090ed79ae7db779d$var$E3 / 1024;
const $090ed79ae7db779d$var$M4 = 35 * $090ed79ae7db779d$var$E3 / 3072;
const $090ed79ae7db779d$var$P2 = 1.5 * $090ed79ae7db779d$var$_E - 27 / 32 * $090ed79ae7db779d$var$_E3 + 269 / 512 * $090ed79ae7db779d$var$_E5;
const $090ed79ae7db779d$var$P3 = 21 / 16 * $090ed79ae7db779d$var$_E2 - 55 / 32 * $090ed79ae7db779d$var$_E4;
const $090ed79ae7db779d$var$P4 = 151 / 96 * $090ed79ae7db779d$var$_E3 - 417 / 128 * $090ed79ae7db779d$var$_E5;
const $090ed79ae7db779d$var$P5 = 1097 / 512 * $090ed79ae7db779d$var$_E4;
const $090ed79ae7db779d$var$R = 6378137;
/**
 * @param {number} easting Easting value of coordinate.
 * @param {number} northing Northing value of coordinate.
 * @param {UTMZone} zone The UTM zone.
 * @return {import("../coordinate.js").Coordinate} The transformed coordinate.
 */ function $090ed79ae7db779d$var$toLonLat(easting, northing, zone) {
    const x = easting - 500000;
    const y = zone.north ? northing : northing - 10000000;
    const m = y / $090ed79ae7db779d$var$K0;
    const mu = m / ($090ed79ae7db779d$var$R * $090ed79ae7db779d$var$M1);
    const pRad = mu + $090ed79ae7db779d$var$P2 * Math.sin(2 * mu) + $090ed79ae7db779d$var$P3 * Math.sin(4 * mu) + $090ed79ae7db779d$var$P4 * Math.sin(6 * mu) + $090ed79ae7db779d$var$P5 * Math.sin(8 * mu);
    const pSin = Math.sin(pRad);
    const pSin2 = pSin * pSin;
    const pCos = Math.cos(pRad);
    const pTan = pSin / pCos;
    const pTan2 = pTan * pTan;
    const pTan4 = pTan2 * pTan2;
    const epSin = 1 - $090ed79ae7db779d$var$E * pSin2;
    const epSinSqrt = Math.sqrt(1 - $090ed79ae7db779d$var$E * pSin2);
    const n = $090ed79ae7db779d$var$R / epSinSqrt;
    const r = (1 - $090ed79ae7db779d$var$E) / epSin;
    const c = $090ed79ae7db779d$var$E_P2 * pCos ** 2;
    const c2 = c * c;
    const d = x / (n * $090ed79ae7db779d$var$K0);
    const d2 = d * d;
    const d3 = d2 * d;
    const d4 = d3 * d;
    const d5 = d4 * d;
    const d6 = d5 * d;
    const latitude = pRad - pTan / r * (d2 / 2 - d4 / 24 * (5 + 3 * pTan2 + 10 * c - 4 * c2 - 9 * $090ed79ae7db779d$var$E_P2)) + d6 / 720 * (61 + 90 * pTan2 + 298 * c + 45 * pTan4 - 252 * $090ed79ae7db779d$var$E_P2 - 3 * c2);
    let longitude = (d - d3 / 6 * (1 + 2 * pTan2 + c) + d5 / 120 * (5 - 2 * c + 28 * pTan2 - 3 * c2 + 8 * $090ed79ae7db779d$var$E_P2 + 24 * pTan4)) / pCos;
    longitude = (0, $6a95bd76d7103f37$export$4997ffc0176396a6)(longitude + (0, $6a95bd76d7103f37$export$cba01ba138429a1d)($090ed79ae7db779d$var$zoneToCentralLongitude(zone.number)), -Math.PI, Math.PI);
    return [
        (0, $6a95bd76d7103f37$export$56cb859c01fa134d)(longitude),
        (0, $6a95bd76d7103f37$export$56cb859c01fa134d)(latitude)
    ];
}
const $090ed79ae7db779d$var$MIN_LATITUDE = -80;
const $090ed79ae7db779d$var$MAX_LATITUDE = 84;
const $090ed79ae7db779d$var$MIN_LONGITUDE = -180;
const $090ed79ae7db779d$var$MAX_LONGITUDE = 180;
/**
 * @param {number} longitude The longitude.
 * @param {number} latitude The latitude.
 * @param {UTMZone} zone The UTM zone.
 * @return {import('../coordinate.js').Coordinate} The UTM coordinate.
 */ function $090ed79ae7db779d$var$fromLonLat(longitude, latitude, zone) {
    longitude = (0, $6a95bd76d7103f37$export$4997ffc0176396a6)(longitude, $090ed79ae7db779d$var$MIN_LONGITUDE, $090ed79ae7db779d$var$MAX_LONGITUDE);
    if (latitude < $090ed79ae7db779d$var$MIN_LATITUDE) latitude = $090ed79ae7db779d$var$MIN_LATITUDE;
    else if (latitude > $090ed79ae7db779d$var$MAX_LATITUDE) latitude = $090ed79ae7db779d$var$MAX_LATITUDE;
    const latRad = (0, $6a95bd76d7103f37$export$cba01ba138429a1d)(latitude);
    const latSin = Math.sin(latRad);
    const latCos = Math.cos(latRad);
    const latTan = latSin / latCos;
    const latTan2 = latTan * latTan;
    const latTan4 = latTan2 * latTan2;
    const lonRad = (0, $6a95bd76d7103f37$export$cba01ba138429a1d)(longitude);
    const centralLon = $090ed79ae7db779d$var$zoneToCentralLongitude(zone.number);
    const centralLonRad = (0, $6a95bd76d7103f37$export$cba01ba138429a1d)(centralLon);
    const n = $090ed79ae7db779d$var$R / Math.sqrt(1 - $090ed79ae7db779d$var$E * latSin ** 2);
    const c = $090ed79ae7db779d$var$E_P2 * latCos ** 2;
    const a = latCos * (0, $6a95bd76d7103f37$export$4997ffc0176396a6)(lonRad - centralLonRad, -Math.PI, Math.PI);
    const a2 = a * a;
    const a3 = a2 * a;
    const a4 = a3 * a;
    const a5 = a4 * a;
    const a6 = a5 * a;
    const m = $090ed79ae7db779d$var$R * ($090ed79ae7db779d$var$M1 * latRad - $090ed79ae7db779d$var$M2 * Math.sin(2 * latRad) + $090ed79ae7db779d$var$M3 * Math.sin(4 * latRad) - $090ed79ae7db779d$var$M4 * Math.sin(6 * latRad));
    const easting = $090ed79ae7db779d$var$K0 * n * (a + a3 / 6 * (1 - latTan2 + c) + a5 / 120 * (5 - 18 * latTan2 + latTan4 + 72 * c - 58 * $090ed79ae7db779d$var$E_P2)) + 500000;
    let northing = $090ed79ae7db779d$var$K0 * (m + n * latTan * (a2 / 2 + a4 / 24 * (5 - latTan2 + 9 * c + 4 * c ** 2) + a6 / 720 * (61 - 58 * latTan2 + latTan4 + 600 * c - 330 * $090ed79ae7db779d$var$E_P2)));
    if (!zone.north) northing += 10000000;
    return [
        easting,
        northing
    ];
}
/**
 * @param {number} zone The zone number.
 * @return {number} The central longitude in degrees.
 */ function $090ed79ae7db779d$var$zoneToCentralLongitude(zone) {
    return (zone - 1) * 6 - 180 + 3;
}
/**
 * @type {Array<RegExp>}
 */ const $090ed79ae7db779d$var$epsgRegExes = [
    /^EPSG:(\d+)$/,
    /^urn:ogc:def:crs:EPSG::(\d+)$/,
    /^http:\/\/www\.opengis\.net\/def\/crs\/EPSG\/0\/(\d+)$/
];
function $090ed79ae7db779d$export$bb54dc52a08ed170(code) {
    let epsgId = 0;
    for (const re of $090ed79ae7db779d$var$epsgRegExes){
        const match = code.match(re);
        if (match) {
            epsgId = parseInt(match[1]);
            break;
        }
    }
    if (!epsgId) return null;
    let number = 0;
    let north = false;
    if (epsgId > 32700 && epsgId < 32761) number = epsgId - 32700;
    else if (epsgId > 32600 && epsgId < 32661) {
        north = true;
        number = epsgId - 32600;
    }
    if (!number) return null;
    return {
        number: number,
        north: north
    };
}
/**
 * @param {function(number, number, UTMZone): import('../coordinate.js').Coordinate} transformer The transformer.
 * @param {UTMZone} zone The UTM zone.
 * @return {import('../proj.js').TransformFunction} The transform function.
 */ function $090ed79ae7db779d$var$makeTransformFunction(transformer, zone) {
    return function(input, output, dimension, stride) {
        const length = input.length;
        dimension = dimension > 1 ? dimension : 2;
        stride = stride ?? dimension;
        if (!output) {
            if (dimension > 2) output = input.slice();
            else output = new Array(length);
        }
        for(let i = 0; i < length; i += stride){
            const x = input[i];
            const y = input[i + 1];
            const coord = transformer(x, y, zone);
            output[i] = coord[0];
            output[i + 1] = coord[1];
        }
        return output;
    };
}
function $090ed79ae7db779d$export$3277980d225b59be(code) {
    const zone = $090ed79ae7db779d$export$bb54dc52a08ed170(code);
    if (!zone) return null;
    return new (0, $860cd07813cc0557$export$2e2bcd8739ae039)({
        code: code,
        units: 'm'
    });
}
function $090ed79ae7db779d$export$f94509e55523febf(projection) {
    const zone = $090ed79ae7db779d$export$bb54dc52a08ed170(projection.getCode());
    if (!zone) return null;
    return {
        forward: $090ed79ae7db779d$var$makeTransformFunction($090ed79ae7db779d$var$fromLonLat, zone),
        inverse: $090ed79ae7db779d$var$makeTransformFunction($090ed79ae7db779d$var$toLonLat, zone)
    };
}


/**
 * @module ol/sphere
 */ 
const $42da4f557dd38010$export$63f2df7bd7371262 = 6371008.8;
function $42da4f557dd38010$export$79376507b09a66f(c1, c2, radius) {
    radius = radius || $42da4f557dd38010$export$63f2df7bd7371262;
    const lat1 = (0, $6a95bd76d7103f37$export$cba01ba138429a1d)(c1[1]);
    const lat2 = (0, $6a95bd76d7103f37$export$cba01ba138429a1d)(c2[1]);
    const deltaLatBy2 = (lat2 - lat1) / 2;
    const deltaLonBy2 = (0, $6a95bd76d7103f37$export$cba01ba138429a1d)(c2[0] - c1[0]) / 2;
    const a = Math.sin(deltaLatBy2) * Math.sin(deltaLatBy2) + Math.sin(deltaLonBy2) * Math.sin(deltaLonBy2) * Math.cos(lat1) * Math.cos(lat2);
    return 2 * radius * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}
/**
 * Get the cumulative great circle length of linestring coordinates (geographic).
 * @param {Array} coordinates Linestring coordinates.
 * @param {number} radius The sphere radius to use.
 * @return {number} The length (in meters).
 */ function $42da4f557dd38010$var$getLengthInternal(coordinates, radius) {
    let length = 0;
    for(let i = 0, ii = coordinates.length; i < ii - 1; ++i)length += $42da4f557dd38010$export$79376507b09a66f(coordinates[i], coordinates[i + 1], radius);
    return length;
}
function $42da4f557dd38010$export$f0d11c074a923179(geometry, options) {
    options = options || {};
    const radius = options.radius || $42da4f557dd38010$export$63f2df7bd7371262;
    const projection = options.projection || 'EPSG:3857';
    const type = geometry.getType();
    if (type !== 'GeometryCollection') geometry = geometry.clone().transform(projection, 'EPSG:4326');
    let length = 0;
    let coordinates, coords, i, ii, j, jj;
    switch(type){
        case 'Point':
        case 'MultiPoint':
            break;
        case 'LineString':
        case 'LinearRing':
            coordinates = /** @type {import("./geom/SimpleGeometry.js").default} */ geometry.getCoordinates();
            length = $42da4f557dd38010$var$getLengthInternal(coordinates, radius);
            break;
        case 'MultiLineString':
        case 'Polygon':
            coordinates = /** @type {import("./geom/SimpleGeometry.js").default} */ geometry.getCoordinates();
            for(i = 0, ii = coordinates.length; i < ii; ++i)length += $42da4f557dd38010$var$getLengthInternal(coordinates[i], radius);
            break;
        case 'MultiPolygon':
            coordinates = /** @type {import("./geom/SimpleGeometry.js").default} */ geometry.getCoordinates();
            for(i = 0, ii = coordinates.length; i < ii; ++i){
                coords = coordinates[i];
                for(j = 0, jj = coords.length; j < jj; ++j)length += $42da4f557dd38010$var$getLengthInternal(coords[j], radius);
            }
            break;
        case 'GeometryCollection':
            {
                const geometries = /** @type {import("./geom/GeometryCollection.js").default} */ geometry.getGeometries();
                for(i = 0, ii = geometries.length; i < ii; ++i)length += $42da4f557dd38010$export$f0d11c074a923179(geometries[i], options);
                break;
            }
        default:
            throw new Error('Unsupported geometry type: ' + type);
    }
    return length;
}
/**
 * Returns the spherical area for a list of coordinates.
 *
 * [Reference](https://trs.jpl.nasa.gov/handle/2014/40409)
 * Robert. G. Chamberlain and William H. Duquette, "Some Algorithms for
 * Polygons on a Sphere", JPL Publication 07-03, Jet Propulsion
 * Laboratory, Pasadena, CA, June 2007
 *
 * @param {Array<import("./coordinate.js").Coordinate>} coordinates List of coordinates of a linear
 * ring. If the ring is oriented clockwise, the area will be positive,
 * otherwise it will be negative.
 * @param {number} radius The sphere radius.
 * @return {number} Area (in square meters).
 */ function $42da4f557dd38010$var$getAreaInternal(coordinates, radius) {
    let area = 0;
    const len = coordinates.length;
    let x1 = coordinates[len - 1][0];
    let y1 = coordinates[len - 1][1];
    for(let i = 0; i < len; i++){
        const x2 = coordinates[i][0];
        const y2 = coordinates[i][1];
        area += (0, $6a95bd76d7103f37$export$cba01ba138429a1d)(x2 - x1) * (2 + Math.sin((0, $6a95bd76d7103f37$export$cba01ba138429a1d)(y1)) + Math.sin((0, $6a95bd76d7103f37$export$cba01ba138429a1d)(y2)));
        x1 = x2;
        y1 = y2;
    }
    return area * radius * radius / 2.0;
}
function $42da4f557dd38010$export$520c40045967cb15(geometry, options) {
    options = options || {};
    const radius = options.radius || $42da4f557dd38010$export$63f2df7bd7371262;
    const projection = options.projection || 'EPSG:3857';
    const type = geometry.getType();
    if (type !== 'GeometryCollection') geometry = geometry.clone().transform(projection, 'EPSG:4326');
    let area = 0;
    let coordinates, coords, i, ii, j, jj;
    switch(type){
        case 'Point':
        case 'MultiPoint':
        case 'LineString':
        case 'MultiLineString':
        case 'LinearRing':
            break;
        case 'Polygon':
            coordinates = /** @type {import("./geom/Polygon.js").default} */ geometry.getCoordinates();
            area = Math.abs($42da4f557dd38010$var$getAreaInternal(coordinates[0], radius));
            for(i = 1, ii = coordinates.length; i < ii; ++i)area -= Math.abs($42da4f557dd38010$var$getAreaInternal(coordinates[i], radius));
            break;
        case 'MultiPolygon':
            coordinates = /** @type {import("./geom/SimpleGeometry.js").default} */ geometry.getCoordinates();
            for(i = 0, ii = coordinates.length; i < ii; ++i){
                coords = coordinates[i];
                area += Math.abs($42da4f557dd38010$var$getAreaInternal(coords[0], radius));
                for(j = 1, jj = coords.length; j < jj; ++j)area -= Math.abs($42da4f557dd38010$var$getAreaInternal(coords[j], radius));
            }
            break;
        case 'GeometryCollection':
            {
                const geometries = /** @type {import("./geom/GeometryCollection.js").default} */ geometry.getGeometries();
                for(i = 0, ii = geometries.length; i < ii; ++i)area += $42da4f557dd38010$export$520c40045967cb15(geometries[i], options);
                break;
            }
        default:
            throw new Error('Unsupported geometry type: ' + type);
    }
    return area;
}
function $42da4f557dd38010$export$cc800923e997bb8(c1, distance, bearing, radius) {
    radius = radius || $42da4f557dd38010$export$63f2df7bd7371262;
    const lat1 = (0, $6a95bd76d7103f37$export$cba01ba138429a1d)(c1[1]);
    const lon1 = (0, $6a95bd76d7103f37$export$cba01ba138429a1d)(c1[0]);
    const dByR = distance / radius;
    const lat = Math.asin(Math.sin(lat1) * Math.cos(dByR) + Math.cos(lat1) * Math.sin(dByR) * Math.cos(bearing));
    const lon = lon1 + Math.atan2(Math.sin(bearing) * Math.sin(dByR) * Math.cos(lat1), Math.cos(dByR) - Math.sin(lat1) * Math.sin(lat));
    return [
        (0, $6a95bd76d7103f37$export$56cb859c01fa134d)(lon),
        (0, $6a95bd76d7103f37$export$56cb859c01fa134d)(lat)
    ];
}


/**
 * A projection as {@link module:ol/proj/Projection~Projection}, SRS identifier
 * string or undefined.
 * @typedef {Projection|string|undefined} ProjectionLike
 * @api
 */ /**
 * @typedef {Object} Transforms
 * @property {TransformFunction} forward The forward transform (from geographic).
 * @property {TransformFunction} inverse The inverse transform (to geographic).
 */ /**
 * @type {Array<function(Projection): Transforms|null>}
 */ const $a86eee1c28205a05$var$transformFactories = [
    (0, $090ed79ae7db779d$export$f94509e55523febf)
];
/**
 * @type {Array<function(string): Projection|null>}
 */ const $a86eee1c28205a05$var$projectionFactories = [
    (0, $090ed79ae7db779d$export$3277980d225b59be)
];
let $a86eee1c28205a05$var$showCoordinateWarning = true;
function $a86eee1c28205a05$export$ed949affbc7c4223(disable) {
    const hide = disable === undefined ? true : disable;
    $a86eee1c28205a05$var$showCoordinateWarning = !hide;
}
function $a86eee1c28205a05$export$dd516654c5f598fb(input, output) {
    if (output !== undefined) {
        for(let i = 0, ii = input.length; i < ii; ++i)output[i] = input[i];
        output;
    } else output = input.slice();
    return output;
}
function $a86eee1c28205a05$export$83e8ab53904f8022(input, output) {
    if (output !== undefined && input !== output) {
        for(let i = 0, ii = input.length; i < ii; ++i)output[i] = input[i];
        input = output;
    }
    return input;
}
function $a86eee1c28205a05$export$59ae956cd3e343f7(projection) {
    (0, $d466f1e669617b7b$export$e16d8520af44a096)(projection.getCode(), projection);
    (0, $2c3e3bd0cd8365f3$export$e16d8520af44a096)(projection, projection, $a86eee1c28205a05$export$dd516654c5f598fb);
}
function $a86eee1c28205a05$export$638ad73f7aafb913(projections) {
    projections.forEach($a86eee1c28205a05$export$59ae956cd3e343f7);
}
function $a86eee1c28205a05$export$3988ae62b71be9a3(projectionLike) {
    if (!(typeof projectionLike === 'string')) return projectionLike;
    const projection = (0, $d466f1e669617b7b$export$3988ae62b71be9a3)(projectionLike);
    if (projection) return projection;
    for (const makeProjection of $a86eee1c28205a05$var$projectionFactories){
        const projection = makeProjection(projectionLike);
        if (projection) return projection;
    }
    return null;
}
function $a86eee1c28205a05$export$2d8f7b4eec383d44(projection, resolution, point, units) {
    projection = $a86eee1c28205a05$export$3988ae62b71be9a3(projection);
    let pointResolution;
    const getter = projection.getPointResolutionFunc();
    if (getter) {
        pointResolution = getter(resolution, point);
        if (units && units !== projection.getUnits()) {
            const metersPerUnit = projection.getMetersPerUnit();
            if (metersPerUnit) pointResolution = pointResolution * metersPerUnit / (0, $9149a5943443441b$export$1482081eec883108)[units];
        }
    } else {
        const projUnits = projection.getUnits();
        if (projUnits == 'degrees' && !units || units == 'degrees') pointResolution = resolution;
        else {
            // Estimate point resolution by transforming the center pixel to EPSG:4326,
            // measuring its width and height on the normal sphere, and taking the
            // average of the width and height.
            const toEPSG4326 = $a86eee1c28205a05$export$e3c4995a701c26a3(projection, $a86eee1c28205a05$export$3988ae62b71be9a3('EPSG:4326'));
            if (!toEPSG4326 && projUnits !== 'degrees') // no transform is available
            pointResolution = resolution * projection.getMetersPerUnit();
            else {
                let vertices = [
                    point[0] - resolution / 2,
                    point[1],
                    point[0] + resolution / 2,
                    point[1],
                    point[0],
                    point[1] - resolution / 2,
                    point[0],
                    point[1] + resolution / 2
                ];
                vertices = toEPSG4326(vertices, vertices, 2);
                const width = (0, $42da4f557dd38010$export$79376507b09a66f)(vertices.slice(0, 2), vertices.slice(2, 4));
                const height = (0, $42da4f557dd38010$export$79376507b09a66f)(vertices.slice(4, 6), vertices.slice(6, 8));
                pointResolution = (width + height) / 2;
            }
            const metersPerUnit = units ? (0, $9149a5943443441b$export$1482081eec883108)[units] : projection.getMetersPerUnit();
            if (metersPerUnit !== undefined) pointResolution /= metersPerUnit;
        }
    }
    return pointResolution;
}
function $a86eee1c28205a05$export$eeb8392580a05a37(projections) {
    $a86eee1c28205a05$export$638ad73f7aafb913(projections);
    projections.forEach(function(source) {
        projections.forEach(function(destination) {
            if (source !== destination) (0, $2c3e3bd0cd8365f3$export$e16d8520af44a096)(source, destination, $a86eee1c28205a05$export$dd516654c5f598fb);
        });
    });
}
function $a86eee1c28205a05$export$4856f21c2f184f24(projections1, projections2, forwardTransform, inverseTransform) {
    projections1.forEach(function(projection1) {
        projections2.forEach(function(projection2) {
            (0, $2c3e3bd0cd8365f3$export$e16d8520af44a096)(projection1, projection2, forwardTransform);
            (0, $2c3e3bd0cd8365f3$export$e16d8520af44a096)(projection2, projection1, inverseTransform);
        });
    });
}
function $a86eee1c28205a05$export$4860237d10380594() {
    (0, $d466f1e669617b7b$export$42ffd38884aecdac)();
    (0, $2c3e3bd0cd8365f3$export$42ffd38884aecdac)();
}
function $a86eee1c28205a05$export$549167224996a0fb(projection, defaultCode) {
    if (!projection) return $a86eee1c28205a05$export$3988ae62b71be9a3(defaultCode);
    if (typeof projection === 'string') return $a86eee1c28205a05$export$3988ae62b71be9a3(projection);
    return /** @type {Projection} */ projection;
}
function $a86eee1c28205a05$export$6b4aafd331159e0d(coordTransform) {
    return(/**
     * @param {Array<number>} input Input.
     * @param {Array<number>} [output] Output.
     * @param {number} [dimension] Dimensions that should be transformed.
     * @param {number} [stride] Stride.
     * @return {Array<number>} Output.
     */ function(input, output, dimension, stride) {
        const length = input.length;
        dimension = dimension !== undefined ? dimension : 2;
        stride = stride ?? dimension;
        output = output !== undefined ? output : new Array(length);
        for(let i = 0; i < length; i += stride){
            const point = coordTransform(input.slice(i, i + dimension));
            const pointLength = point.length;
            for(let j = 0, jj = stride; j < jj; ++j)output[i + j] = j >= pointLength ? input[i + j] : point[j];
        }
        return output;
    });
}
function $a86eee1c28205a05$export$6b1c2e6623f4f49d(source, destination, forward, inverse) {
    const sourceProj = $a86eee1c28205a05$export$3988ae62b71be9a3(source);
    const destProj = $a86eee1c28205a05$export$3988ae62b71be9a3(destination);
    (0, $2c3e3bd0cd8365f3$export$e16d8520af44a096)(sourceProj, destProj, $a86eee1c28205a05$export$6b4aafd331159e0d(forward));
    (0, $2c3e3bd0cd8365f3$export$e16d8520af44a096)(destProj, sourceProj, $a86eee1c28205a05$export$6b4aafd331159e0d(inverse));
}
function $a86eee1c28205a05$export$b15d9668511529b9(coordinate, projection) {
    $a86eee1c28205a05$export$ed949affbc7c4223();
    return $a86eee1c28205a05$export$51186ad6e864892a(coordinate, 'EPSG:4326', projection !== undefined ? projection : 'EPSG:3857');
}
function $a86eee1c28205a05$export$3fb495868742d370(coordinate, projection) {
    const lonLat = $a86eee1c28205a05$export$51186ad6e864892a(coordinate, projection !== undefined ? projection : 'EPSG:3857', 'EPSG:4326');
    const lon = lonLat[0];
    if (lon < -180 || lon > 180) lonLat[0] = (0, $6a95bd76d7103f37$export$ba467bec01d66def)(lon + 180, 360) - 180;
    return lonLat;
}
function $a86eee1c28205a05$export$fe091d73a555748b(projection1, projection2) {
    if (projection1 === projection2) return true;
    const equalUnits = projection1.getUnits() === projection2.getUnits();
    if (projection1.getCode() === projection2.getCode()) return equalUnits;
    const transformFunc = $a86eee1c28205a05$export$e3c4995a701c26a3(projection1, projection2);
    return transformFunc === $a86eee1c28205a05$export$dd516654c5f598fb && equalUnits;
}
function $a86eee1c28205a05$export$e3c4995a701c26a3(source, destination) {
    const sourceCode = source.getCode();
    const destinationCode = destination.getCode();
    let transformFunc = (0, $2c3e3bd0cd8365f3$export$3988ae62b71be9a3)(sourceCode, destinationCode);
    if (transformFunc) return transformFunc;
    /**
   * @type {Transforms|null}
   */ let sourceTransforms = null;
    /**
   * @type {Transforms|null}
   */ let destinationTransforms = null;
    // lazily add projections if we have supported transforms
    for (const makeTransforms of $a86eee1c28205a05$var$transformFactories){
        if (!sourceTransforms) sourceTransforms = makeTransforms(source);
        if (!destinationTransforms) destinationTransforms = makeTransforms(destination);
    }
    if (!sourceTransforms && !destinationTransforms) return null;
    const intermediateCode = 'EPSG:4326';
    if (!destinationTransforms) {
        const toDestination = (0, $2c3e3bd0cd8365f3$export$3988ae62b71be9a3)(intermediateCode, destinationCode);
        if (toDestination) transformFunc = $a86eee1c28205a05$var$composeTransformFuncs(sourceTransforms.inverse, toDestination);
    } else if (!sourceTransforms) {
        const fromSource = (0, $2c3e3bd0cd8365f3$export$3988ae62b71be9a3)(sourceCode, intermediateCode);
        if (fromSource) transformFunc = $a86eee1c28205a05$var$composeTransformFuncs(fromSource, destinationTransforms.forward);
    } else transformFunc = $a86eee1c28205a05$var$composeTransformFuncs(sourceTransforms.inverse, destinationTransforms.forward);
    if (transformFunc) {
        $a86eee1c28205a05$export$59ae956cd3e343f7(source);
        $a86eee1c28205a05$export$59ae956cd3e343f7(destination);
        (0, $2c3e3bd0cd8365f3$export$e16d8520af44a096)(source, destination, transformFunc);
    }
    return transformFunc;
}
/**
 * @param {TransformFunction} t1 The first transform function.
 * @param {TransformFunction} t2 The second transform function.
 * @return {TransformFunction} The composed transform function.
 */ function $a86eee1c28205a05$var$composeTransformFuncs(t1, t2) {
    return function(input, output, dimensions, stride) {
        output = t1(input, output, dimensions, stride);
        return t2(output, output, dimensions, stride);
    };
}
function $a86eee1c28205a05$export$fce0c6cfca85ed96(source, destination) {
    const sourceProjection = $a86eee1c28205a05$export$3988ae62b71be9a3(source);
    const destinationProjection = $a86eee1c28205a05$export$3988ae62b71be9a3(destination);
    return $a86eee1c28205a05$export$e3c4995a701c26a3(sourceProjection, destinationProjection);
}
function $a86eee1c28205a05$export$51186ad6e864892a(coordinate, source, destination) {
    const transformFunc = $a86eee1c28205a05$export$fce0c6cfca85ed96(source, destination);
    if (!transformFunc) {
        const sourceCode = $a86eee1c28205a05$export$3988ae62b71be9a3(source).getCode();
        const destinationCode = $a86eee1c28205a05$export$3988ae62b71be9a3(destination).getCode();
        throw new Error(`No transform available between ${sourceCode} and ${destinationCode}`);
    }
    return transformFunc(coordinate, undefined, coordinate.length);
}
function $a86eee1c28205a05$export$751c68e0e0efff79(extent, source, destination, stops) {
    const transformFunc = $a86eee1c28205a05$export$fce0c6cfca85ed96(source, destination);
    return (0, $dea65c2f666fa450$export$9f9dcb98c894b623)(extent, transformFunc, undefined, stops);
}
function $a86eee1c28205a05$export$affbde93b1db73f8(point, sourceProjection, destinationProjection) {
    const transformFunc = $a86eee1c28205a05$export$e3c4995a701c26a3(sourceProjection, destinationProjection);
    return transformFunc(point);
}
/**
 * @type {Projection|null}
 */ let $a86eee1c28205a05$var$userProjection = null;
function $a86eee1c28205a05$export$d0aeadbeac54116e(projection) {
    $a86eee1c28205a05$var$userProjection = $a86eee1c28205a05$export$3988ae62b71be9a3(projection);
}
function $a86eee1c28205a05$export$1ae11279759d4e8f() {
    $a86eee1c28205a05$var$userProjection = null;
}
function $a86eee1c28205a05$export$3973b77d5f6f2790() {
    return $a86eee1c28205a05$var$userProjection;
}
function $a86eee1c28205a05$export$aa7494edfbe36197() {
    $a86eee1c28205a05$export$d0aeadbeac54116e('EPSG:4326');
}
function $a86eee1c28205a05$export$698f563af1ba02a5(coordinate, sourceProjection) {
    if (!$a86eee1c28205a05$var$userProjection) return coordinate;
    return $a86eee1c28205a05$export$51186ad6e864892a(coordinate, sourceProjection, $a86eee1c28205a05$var$userProjection);
}
function $a86eee1c28205a05$export$d4b8ec0b96db1ee2(coordinate, destProjection) {
    if (!$a86eee1c28205a05$var$userProjection) {
        if ($a86eee1c28205a05$var$showCoordinateWarning && !(0, $a6adb03fd2fbc071$export$e9bab7fafb253603)(coordinate, [
            0,
            0
        ]) && coordinate[0] >= -180 && coordinate[0] <= 180 && coordinate[1] >= -90 && coordinate[1] <= 90) {
            $a86eee1c28205a05$var$showCoordinateWarning = false;
            (0, $7636ffe0700f8dd9$export$c106dd0671a0fc2d)('Call useGeographic() from ol/proj once to work with [longitude, latitude] coordinates.');
        }
        return coordinate;
    }
    return $a86eee1c28205a05$export$51186ad6e864892a(coordinate, $a86eee1c28205a05$var$userProjection, destProjection);
}
function $a86eee1c28205a05$export$96bfd09e2cffb006(extent, sourceProjection) {
    if (!$a86eee1c28205a05$var$userProjection) return extent;
    return $a86eee1c28205a05$export$751c68e0e0efff79(extent, sourceProjection, $a86eee1c28205a05$var$userProjection);
}
function $a86eee1c28205a05$export$494be3a3a25689ca(extent, destProjection) {
    if (!$a86eee1c28205a05$var$userProjection) return extent;
    return $a86eee1c28205a05$export$751c68e0e0efff79(extent, $a86eee1c28205a05$var$userProjection, destProjection);
}
function $a86eee1c28205a05$export$b56bb8ad8b3a00e9(resolution, sourceProjection) {
    if (!$a86eee1c28205a05$var$userProjection) return resolution;
    const sourceMetersPerUnit = $a86eee1c28205a05$export$3988ae62b71be9a3(sourceProjection).getMetersPerUnit();
    const userMetersPerUnit = $a86eee1c28205a05$var$userProjection.getMetersPerUnit();
    return sourceMetersPerUnit && userMetersPerUnit ? resolution * sourceMetersPerUnit / userMetersPerUnit : resolution;
}
function $a86eee1c28205a05$export$bd1cd3b88140b906(resolution, destProjection) {
    if (!$a86eee1c28205a05$var$userProjection) return resolution;
    const destMetersPerUnit = $a86eee1c28205a05$export$3988ae62b71be9a3(destProjection).getMetersPerUnit();
    const userMetersPerUnit = $a86eee1c28205a05$var$userProjection.getMetersPerUnit();
    return destMetersPerUnit && userMetersPerUnit ? resolution * userMetersPerUnit / destMetersPerUnit : resolution;
}
function $a86eee1c28205a05$export$1873f9cfeb8bd1d6(sourceProj, destProj, transform) {
    return function(coord) {
        let transformed, worldsAway;
        if (sourceProj.canWrapX()) {
            const sourceExtent = sourceProj.getExtent();
            const sourceExtentWidth = (0, $dea65c2f666fa450$export$3c49c185de0c2bfc)(sourceExtent);
            coord = coord.slice(0);
            worldsAway = (0, $a6adb03fd2fbc071$export$24e2b27d1ff0c1d5)(coord, sourceProj, sourceExtentWidth);
            if (worldsAway) // Move x to the real world
            coord[0] = coord[0] - worldsAway * sourceExtentWidth;
            coord[0] = (0, $6a95bd76d7103f37$export$7d15b64cf5a3a4c4)(coord[0], sourceExtent[0], sourceExtent[2]);
            coord[1] = (0, $6a95bd76d7103f37$export$7d15b64cf5a3a4c4)(coord[1], sourceExtent[1], sourceExtent[3]);
            transformed = transform(coord);
        } else transformed = transform(coord);
        if (worldsAway && destProj.canWrapX()) // Move transformed coordinate back to the offset world
        transformed[0] += worldsAway * (0, $dea65c2f666fa450$export$3c49c185de0c2bfc)(destProj.getExtent());
        return transformed;
    };
}
function $a86eee1c28205a05$export$86eed449eb2dcac4() {
    // Add transformations that don't alter coordinates to convert within set of
    // projections with equal meaning.
    $a86eee1c28205a05$export$eeb8392580a05a37((0, $e9bc1fa2f35e7c83$export$b508d7ad9a891c1b));
    $a86eee1c28205a05$export$eeb8392580a05a37((0, $6b0bea253f4bbdff$export$b508d7ad9a891c1b));
    // Add transformations to convert EPSG:4326 like coordinates to EPSG:3857 like
    // coordinates and back.
    $a86eee1c28205a05$export$4856f21c2f184f24((0, $6b0bea253f4bbdff$export$b508d7ad9a891c1b), (0, $e9bc1fa2f35e7c83$export$b508d7ad9a891c1b), (0, $e9bc1fa2f35e7c83$export$1ff8bb36c0983070), (0, $e9bc1fa2f35e7c83$export$8c71322ec28ed6b4));
}
$a86eee1c28205a05$export$86eed449eb2dcac4();


/**
 * @module ol/proj/proj4
 */ 



/**
 * @type {import("proj4")|null}
 */ let $9bd389b40b2d77bd$var$registered = null;
function $9bd389b40b2d77bd$export$bd9a8eae248cc953() {
    return !!$9bd389b40b2d77bd$var$registered;
}
function $9bd389b40b2d77bd$export$d07f55d4c15c0440() {
    $9bd389b40b2d77bd$var$registered = null;
}
function $9bd389b40b2d77bd$export$6503ec6e8aabbaf(proj4) {
    $9bd389b40b2d77bd$var$registered = proj4;
    const projCodes = Object.keys(proj4.defs);
    const len = projCodes.length;
    let i, j;
    for(i = 0; i < len; ++i){
        const code = projCodes[i];
        if (!(0, $d466f1e669617b7b$export$3988ae62b71be9a3)(code)) {
            const def = proj4.defs(code);
            let units = /** @type {import("./Units.js").Units} */ def.units;
            if (!units && def.projName === 'longlat') units = 'degrees';
            (0, $a86eee1c28205a05$export$59ae956cd3e343f7)(new (0, $860cd07813cc0557$export$2e2bcd8739ae039)({
                code: code,
                axisOrientation: def.axis,
                metersPerUnit: def.to_meter,
                units: units
            }));
        }
    }
    for(i = 0; i < len; ++i){
        const code1 = projCodes[i];
        const proj1 = (0, $d466f1e669617b7b$export$3988ae62b71be9a3)(code1);
        for(j = 0; j < len; ++j){
            const code2 = projCodes[j];
            const proj2 = (0, $d466f1e669617b7b$export$3988ae62b71be9a3)(code2);
            if (!(0, $2c3e3bd0cd8365f3$export$3988ae62b71be9a3)(code1, code2)) {
                if (proj4.defs[code1] === proj4.defs[code2]) (0, $a86eee1c28205a05$export$eeb8392580a05a37)([
                    proj1,
                    proj2
                ]);
                else {
                    const transform = proj4(code1, code2);
                    (0, $a86eee1c28205a05$export$6b1c2e6623f4f49d)(proj1, proj2, (0, $a86eee1c28205a05$export$1873f9cfeb8bd1d6)(proj1, proj2, transform.forward), (0, $a86eee1c28205a05$export$1873f9cfeb8bd1d6)(proj2, proj1, transform.inverse));
                }
            }
        }
    }
}
/**
 * @param {string} code The projection code.
 * @return {Promise<string>} The WKT definition.
 */ let $9bd389b40b2d77bd$var$projLookup = async function(code) {
    if (typeof code !== 'string' || !code.includes(':')) throw new Error('Invalid code');
    const [authority, num] = code.toLowerCase().split(':', 2);
    const response = await fetch(`https://spatialreference.org/ref/${authority}/${num}/ogcwkt/`);
    if (!response.ok) throw new Error(`Unexpected response from spatialreference.org: ${response.status}`);
    return response.text();
};
function $9bd389b40b2d77bd$export$fcdaa2a4d7a56b50(func) {
    $9bd389b40b2d77bd$var$projLookup = func;
}
function $9bd389b40b2d77bd$export$2e910186da6542fc() {
    return $9bd389b40b2d77bd$var$projLookup;
}
async function $9bd389b40b2d77bd$export$89133bfedc825dd5(code) {
    const proj4 = $9bd389b40b2d77bd$var$registered;
    if (!proj4) throw new Error('Proj4 must be registered first with register(proj4)');
    if (proj4.defs(code)) return (0, $d466f1e669617b7b$export$3988ae62b71be9a3)(code);
    proj4.defs(code, await $9bd389b40b2d77bd$var$projLookup(code));
    $9bd389b40b2d77bd$export$6503ec6e8aabbaf(proj4);
    return (0, $d466f1e669617b7b$export$3988ae62b71be9a3)(code);
}
/**
 * @param {number} code The EPSG code.
 * @return {Promise<string>} The proj4 or WKT definition.
 * @deprecated Use {@link module:ol/proj/proj4.projLookup} instead.
 */ let $9bd389b40b2d77bd$var$epsgLookup = async function(code) {
    return await $9bd389b40b2d77bd$var$projLookup('EPSG:' + code);
};
function $9bd389b40b2d77bd$export$a2ab1dacaf978878(func) {
    $9bd389b40b2d77bd$var$epsgLookup = func;
}
function $9bd389b40b2d77bd$export$740126bd4cc01b24() {
    return $9bd389b40b2d77bd$var$epsgLookup;
}
async function $9bd389b40b2d77bd$export$8d835cefe312e037(code) {
    if (typeof code === 'number') code = 'EPSG:' + code;
    return await $9bd389b40b2d77bd$export$89133bfedc825dd5(code);
}
function $9bd389b40b2d77bd$export$71e713433eeb8730(key) {
    return async function(code) {
        const response = await fetch(`https://api.maptiler.com/coordinates/search/code:${code}.json?transformations=true&exports=true&key=${key}`);
        if (!response.ok) throw new Error(`Unexpected response from maptiler.com: ${response.status}`);
        return response.json().then((json)=>{
            const results = json['results'];
            if (results?.length > 0) {
                const result = results.filter((r)=>r['id']?.['authority'] === 'EPSG' && r['id']?.['code'] === code)[0];
                if (result) {
                    const transforms = result['transformations'];
                    if (transforms?.length > 0) {
                        // use default transform if it does not require grids
                        const defaultTransform = result['default_transformation'];
                        if (transforms.filter((t)=>t['id']?.['authority'] === defaultTransform?.['authority'] && t['id']?.['code'] === defaultTransform?.['code'] && t['grids']?.length === 0).length > 0) return result['exports']?.['proj4'];
                        // otherwise use most accurate alternative without grids
                        const transform = transforms.filter((t)=>t['grids']?.length === 0 && t['target_crs']?.['authority'] === 'EPSG' && t['target_crs']?.['code'] === 4326 && t['deprecated'] === false && t['usable'] === true).sort((t1, t2)=>t1['accuracy'] - t2['accuracy'])[0]?.['exports']?.['proj4'];
                        if (transform) return transform;
                    }
                    // fallback to default
                    return result['exports']?.['proj4'];
                }
            }
        });
    };
}


function $b8abfb341abe22ae$export$2e2bcd8739ae039(defs) {
    defs('EPSG:4326', '+title=WGS 84 (long/lat) +proj=longlat +ellps=WGS84 +datum=WGS84 +units=degrees');
    defs('EPSG:4269', '+title=NAD83 (long/lat) +proj=longlat +a=6378137.0 +b=6356752.31414036 +ellps=GRS80 +datum=NAD83 +units=degrees');
    defs('EPSG:3857', '+title=WGS 84 / Pseudo-Mercator +proj=merc +a=6378137 +b=6378137 +lat_ts=0.0 +lon_0=0.0 +x_0=0.0 +y_0=0 +k=1.0 +units=m +nadgrids=@null +no_defs');
    // UTM WGS84
    for(var i = 1; i <= 60; ++i){
        defs('EPSG:' + (32600 + i), '+proj=utm +zone=' + i + ' +datum=WGS84 +units=m');
        defs('EPSG:' + (32700 + i), '+proj=utm +zone=' + i + ' +south +datum=WGS84 +units=m');
    }
    defs('EPSG:5041', '+title=WGS 84 / UPS North (E,N) +proj=stere +lat_0=90 +lon_0=0 +k=0.994 +x_0=2000000 +y_0=2000000 +datum=WGS84 +units=m');
    defs('EPSG:5042', '+title=WGS 84 / UPS South (E,N) +proj=stere +lat_0=-90 +lon_0=0 +k=0.994 +x_0=2000000 +y_0=2000000 +datum=WGS84 +units=m');
    defs.WGS84 = defs['EPSG:4326'];
    defs['EPSG:3785'] = defs['EPSG:3857']; // maintain backward compat, official code is 3857
    defs.GOOGLE = defs['EPSG:3857'];
    defs['EPSG:900913'] = defs['EPSG:3857'];
    defs['EPSG:102113'] = defs['EPSG:3857'];
}



var $jDCGO = parcelRequire("jDCGO");
var $e9b1519e8c1e3a0e$var$primeMeridian = {};
$e9b1519e8c1e3a0e$var$primeMeridian.greenwich = 0.0; // "0dE",
$e9b1519e8c1e3a0e$var$primeMeridian.lisbon = -9.131906111111; // "9d07'54.862\"W",
$e9b1519e8c1e3a0e$var$primeMeridian.paris = 2.337229166667; // "2d20'14.025\"E",
$e9b1519e8c1e3a0e$var$primeMeridian.bogota = -74.080916666667; // "74d04'51.3\"W",
$e9b1519e8c1e3a0e$var$primeMeridian.madrid = -3.687938888889; // "3d41'16.58\"W",
$e9b1519e8c1e3a0e$var$primeMeridian.rome = 12.452333333333; // "12d27'8.4\"E",
$e9b1519e8c1e3a0e$var$primeMeridian.bern = 7.439583333333; // "7d26'22.5\"E",
$e9b1519e8c1e3a0e$var$primeMeridian.jakarta = 106.807719444444; // "106d48'27.79\"E",
$e9b1519e8c1e3a0e$var$primeMeridian.ferro = -17.666666666667; // "17d40'W",
$e9b1519e8c1e3a0e$var$primeMeridian.brussels = 4.367975; // "4d22'4.71\"E",
$e9b1519e8c1e3a0e$var$primeMeridian.stockholm = 18.058277777778; // "18d3'29.8\"E",
$e9b1519e8c1e3a0e$var$primeMeridian.athens = 23.7163375; // "23d42'58.815\"E",
$e9b1519e8c1e3a0e$var$primeMeridian.oslo = 10.722916666667; // "10d43'22.5\"E"
var $e9b1519e8c1e3a0e$export$2e2bcd8739ae039 = $e9b1519e8c1e3a0e$var$primeMeridian;


var $9f2883142c6e7975$export$2e2bcd8739ae039 = {
    mm: {
        to_meter: 0.001
    },
    cm: {
        to_meter: 0.01
    },
    ft: {
        to_meter: 0.3048
    },
    'us-ft': {
        to_meter: 1200 / 3937
    },
    fath: {
        to_meter: 1.8288
    },
    kmi: {
        to_meter: 1852
    },
    'us-ch': {
        to_meter: 20.1168402336805
    },
    'us-mi': {
        to_meter: 1609.34721869444
    },
    km: {
        to_meter: 1000
    },
    'ind-ft': {
        to_meter: 0.30479841
    },
    'ind-yd': {
        to_meter: 0.91439523
    },
    mi: {
        to_meter: 1609.344
    },
    yd: {
        to_meter: 0.9144
    },
    ch: {
        to_meter: 20.1168
    },
    link: {
        to_meter: 0.201168
    },
    dm: {
        to_meter: 0.1
    },
    in: {
        to_meter: 0.0254
    },
    'ind-ch': {
        to_meter: 20.11669506
    },
    'us-in': {
        to_meter: 0.025400050800101
    },
    'us-yd': {
        to_meter: 0.914401828803658
    }
};


var $6e15fef3d69c3cec$var$ignoredChar = /[\s_\-\/\(\)]/g;
function $6e15fef3d69c3cec$export$2e2bcd8739ae039(obj, key) {
    if (obj[key]) return obj[key];
    var keys = Object.keys(obj);
    var lkey = key.toLowerCase().replace($6e15fef3d69c3cec$var$ignoredChar, '');
    var i = -1;
    var testkey, processedKey;
    while(++i < keys.length){
        testkey = keys[i];
        processedKey = testkey.toLowerCase().replace($6e15fef3d69c3cec$var$ignoredChar, '');
        if (processedKey === lkey) return obj[testkey];
    }
}


function $9e397f4b78164de8$export$2e2bcd8739ae039(defData) {
    /** @type {import('./defs').ProjectionDefinition} */ var self = {};
    var paramObj = defData.split('+').map(function(v) {
        return v.trim();
    }).filter(function(a) {
        return a;
    }).reduce(function(p, a) {
        /** @type {Array<?>} */ var split = a.split('=');
        split.push(true);
        p[split[0].toLowerCase()] = split[1];
        return p;
    }, {});
    var paramName, paramVal, paramOutname;
    var params = {
        proj: 'projName',
        datum: 'datumCode',
        rf: function(v) {
            self.rf = parseFloat(v);
        },
        lat_0: function(v) {
            self.lat0 = v * (0, $jDCGO.D2R);
        },
        lat_1: function(v) {
            self.lat1 = v * (0, $jDCGO.D2R);
        },
        lat_2: function(v) {
            self.lat2 = v * (0, $jDCGO.D2R);
        },
        lat_ts: function(v) {
            self.lat_ts = v * (0, $jDCGO.D2R);
        },
        lon_0: function(v) {
            self.long0 = v * (0, $jDCGO.D2R);
        },
        lon_1: function(v) {
            self.long1 = v * (0, $jDCGO.D2R);
        },
        lon_2: function(v) {
            self.long2 = v * (0, $jDCGO.D2R);
        },
        alpha: function(v) {
            self.alpha = parseFloat(v) * (0, $jDCGO.D2R);
        },
        gamma: function(v) {
            self.rectified_grid_angle = parseFloat(v) * (0, $jDCGO.D2R);
        },
        lonc: function(v) {
            self.longc = v * (0, $jDCGO.D2R);
        },
        x_0: function(v) {
            self.x0 = parseFloat(v);
        },
        y_0: function(v) {
            self.y0 = parseFloat(v);
        },
        k_0: function(v) {
            self.k0 = parseFloat(v);
        },
        k: function(v) {
            self.k0 = parseFloat(v);
        },
        a: function(v) {
            self.a = parseFloat(v);
        },
        b: function(v) {
            self.b = parseFloat(v);
        },
        r: function(v) {
            self.a = self.b = parseFloat(v);
        },
        r_a: function() {
            self.R_A = true;
        },
        zone: function(v) {
            self.zone = parseInt(v, 10);
        },
        south: function() {
            self.utmSouth = true;
        },
        towgs84: function(v) {
            self.datum_params = v.split(',').map(function(a) {
                return parseFloat(a);
            });
        },
        to_meter: function(v) {
            self.to_meter = parseFloat(v);
        },
        units: function(v) {
            self.units = v;
            var unit = (0, $6e15fef3d69c3cec$export$2e2bcd8739ae039)((0, $9f2883142c6e7975$export$2e2bcd8739ae039), v);
            if (unit) self.to_meter = unit.to_meter;
        },
        from_greenwich: function(v) {
            self.from_greenwich = v * (0, $jDCGO.D2R);
        },
        pm: function(v) {
            var pm = (0, $6e15fef3d69c3cec$export$2e2bcd8739ae039)((0, $e9b1519e8c1e3a0e$export$2e2bcd8739ae039), v);
            self.from_greenwich = (pm ? pm : parseFloat(v)) * (0, $jDCGO.D2R);
        },
        nadgrids: function(v) {
            if (v === '@null') self.datumCode = 'none';
            else self.nadgrids = v;
        },
        axis: function(v) {
            var legalAxis = 'ewnsud';
            if (v.length === 3 && legalAxis.indexOf(v.substr(0, 1)) !== -1 && legalAxis.indexOf(v.substr(1, 1)) !== -1 && legalAxis.indexOf(v.substr(2, 1)) !== -1) self.axis = v;
        },
        approx: function() {
            self.approx = true;
        },
        over: function() {
            self.over = true;
        }
    };
    for(paramName in paramObj){
        paramVal = paramObj[paramName];
        if (paramName in params) {
            paramOutname = params[paramName];
            if (typeof paramOutname === 'function') paramOutname(paramVal);
            else self[paramOutname] = paramVal;
        } else self[paramName] = paramVal;
    }
    if (typeof self.datumCode === 'string' && self.datumCode !== 'WGS84') self.datumCode = self.datumCode.toLowerCase();
    self['projStr'] = defData;
    return self;
}


class $802e0c0f600b6c6d$var$PROJJSONBuilderBase {
    static getId(node) {
        const idNode = node.find((child)=>Array.isArray(child) && child[0] === 'ID');
        if (idNode && idNode.length >= 3) return {
            authority: idNode[1],
            code: parseInt(idNode[2], 10)
        };
        return null;
    }
    static convertUnit(node, type = 'unit') {
        if (!node || node.length < 3) return {
            type: type,
            name: 'unknown',
            conversion_factor: null
        };
        const name = node[1];
        const conversionFactor = parseFloat(node[2]) || null;
        const idNode = node.find((child)=>Array.isArray(child) && child[0] === 'ID');
        const id = idNode ? {
            authority: idNode[1],
            code: parseInt(idNode[2], 10)
        } : null;
        return {
            type: type,
            name: name,
            conversion_factor: conversionFactor,
            id: id
        };
    }
    static convertAxis(node) {
        const name = node[1] || 'Unknown';
        // Determine the direction
        let direction;
        const abbreviationMatch = name.match(/^\((.)\)$/); // Match abbreviations like "(E)" or "(N)"
        if (abbreviationMatch) {
            // Use the abbreviation to determine the direction
            const abbreviation = abbreviationMatch[1].toUpperCase();
            if (abbreviation === 'E') direction = 'east';
            else if (abbreviation === 'N') direction = 'north';
            else if (abbreviation === 'U') direction = 'up';
            else if (node[2]) direction = node[2];
            else throw new Error(`Unknown axis abbreviation: ${abbreviation}`);
        } else // Use the explicit direction provided in the AXIS node
        direction = node[2] || 'unknown';
        const orderNode = node.find((child)=>Array.isArray(child) && child[0] === 'ORDER');
        const order = orderNode ? parseInt(orderNode[1], 10) : null;
        const unitNode = node.find((child)=>Array.isArray(child) && (child[0] === 'LENGTHUNIT' || child[0] === 'ANGLEUNIT' || child[0] === 'SCALEUNIT'));
        const unit = this.convertUnit(unitNode);
        return {
            name: name,
            direction: direction,
            unit: unit,
            order: order
        };
    }
    static extractAxes(node) {
        return node.filter((child)=>Array.isArray(child) && child[0] === 'AXIS').map((axis)=>this.convertAxis(axis)).sort((a, b)=>(a.order || 0) - (b.order || 0)); // Sort by the "order" property
    }
    static convert(node, result = {}) {
        switch(node[0]){
            case 'PROJCRS':
                result.type = 'ProjectedCRS';
                result.name = node[1];
                result.base_crs = node.find((child)=>Array.isArray(child) && child[0] === 'BASEGEOGCRS') ? this.convert(node.find((child)=>Array.isArray(child) && child[0] === 'BASEGEOGCRS')) : null;
                result.conversion = node.find((child)=>Array.isArray(child) && child[0] === 'CONVERSION') ? this.convert(node.find((child)=>Array.isArray(child) && child[0] === 'CONVERSION')) : null;
                const csNode = node.find((child)=>Array.isArray(child) && child[0] === 'CS');
                if (csNode) result.coordinate_system = {
                    type: csNode[1],
                    axis: this.extractAxes(node)
                };
                const lengthUnitNode = node.find((child)=>Array.isArray(child) && child[0] === 'LENGTHUNIT');
                if (lengthUnitNode) {
                    const unit = this.convertUnit(lengthUnitNode);
                    result.coordinate_system.unit = unit; // Add unit to coordinate_system
                }
                result.id = this.getId(node);
                break;
            case 'BASEGEOGCRS':
            case 'GEOGCRS':
            case 'GEODCRS':
                result.type = node[0] === 'GEODCRS' ? 'GeodeticCRS' : 'GeographicCRS';
                result.name = node[1];
                // Handle DATUM or ENSEMBLE
                const datumOrEnsembleNode = node.find((child)=>Array.isArray(child) && (child[0] === 'DATUM' || child[0] === 'ENSEMBLE'));
                if (datumOrEnsembleNode) {
                    const datumOrEnsemble = this.convert(datumOrEnsembleNode);
                    if (datumOrEnsembleNode[0] === 'ENSEMBLE') result.datum_ensemble = datumOrEnsemble;
                    else result.datum = datumOrEnsemble;
                    const primem = node.find((child)=>Array.isArray(child) && child[0] === 'PRIMEM');
                    if (primem && primem[1] !== 'Greenwich') datumOrEnsemble.prime_meridian = {
                        name: primem[1],
                        longitude: parseFloat(primem[2])
                    };
                }
                result.coordinate_system = {
                    type: 'ellipsoidal',
                    axis: this.extractAxes(node)
                };
                result.id = this.getId(node);
                break;
            case 'DATUM':
                result.type = 'GeodeticReferenceFrame';
                result.name = node[1];
                result.ellipsoid = node.find((child)=>Array.isArray(child) && child[0] === 'ELLIPSOID') ? this.convert(node.find((child)=>Array.isArray(child) && child[0] === 'ELLIPSOID')) : null;
                break;
            case 'ENSEMBLE':
                result.type = 'DatumEnsemble';
                result.name = node[1];
                // Extract ensemble members
                result.members = node.filter((child)=>Array.isArray(child) && child[0] === 'MEMBER').map((member)=>({
                        type: 'DatumEnsembleMember',
                        name: member[1],
                        id: this.getId(member)
                    }));
                // Extract accuracy
                const accuracyNode = node.find((child)=>Array.isArray(child) && child[0] === 'ENSEMBLEACCURACY');
                if (accuracyNode) result.accuracy = parseFloat(accuracyNode[1]);
                // Extract ellipsoid
                const ellipsoidNode = node.find((child)=>Array.isArray(child) && child[0] === 'ELLIPSOID');
                if (ellipsoidNode) result.ellipsoid = this.convert(ellipsoidNode); // Convert the ellipsoid node
                // Extract identifier for the ensemble
                result.id = this.getId(node);
                break;
            case 'ELLIPSOID':
                result.type = 'Ellipsoid';
                result.name = node[1];
                result.semi_major_axis = parseFloat(node[2]);
                result.inverse_flattening = parseFloat(node[3]);
                const units = node.find((child)=>Array.isArray(child) && child[0] === 'LENGTHUNIT') ? this.convert(node.find((child)=>Array.isArray(child) && child[0] === 'LENGTHUNIT'), result) : null;
                break;
            case 'CONVERSION':
                result.type = 'Conversion';
                result.name = node[1];
                result.method = node.find((child)=>Array.isArray(child) && child[0] === 'METHOD') ? this.convert(node.find((child)=>Array.isArray(child) && child[0] === 'METHOD')) : null;
                result.parameters = node.filter((child)=>Array.isArray(child) && child[0] === 'PARAMETER').map((param)=>this.convert(param));
                break;
            case 'METHOD':
                result.type = 'Method';
                result.name = node[1];
                result.id = this.getId(node);
                break;
            case 'PARAMETER':
                result.type = 'Parameter';
                result.name = node[1];
                result.value = parseFloat(node[2]);
                result.unit = this.convertUnit(node.find((child)=>Array.isArray(child) && (child[0] === 'LENGTHUNIT' || child[0] === 'ANGLEUNIT' || child[0] === 'SCALEUNIT')));
                result.id = this.getId(node);
                break;
            case 'BOUNDCRS':
                result.type = 'BoundCRS';
                // Process SOURCECRS
                const sourceCrsNode = node.find((child)=>Array.isArray(child) && child[0] === 'SOURCECRS');
                if (sourceCrsNode) {
                    const sourceCrsContent = sourceCrsNode.find((child)=>Array.isArray(child));
                    result.source_crs = sourceCrsContent ? this.convert(sourceCrsContent) : null;
                }
                // Process TARGETCRS
                const targetCrsNode = node.find((child)=>Array.isArray(child) && child[0] === 'TARGETCRS');
                if (targetCrsNode) {
                    const targetCrsContent = targetCrsNode.find((child)=>Array.isArray(child));
                    result.target_crs = targetCrsContent ? this.convert(targetCrsContent) : null;
                }
                // Process ABRIDGEDTRANSFORMATION
                const transformationNode = node.find((child)=>Array.isArray(child) && child[0] === 'ABRIDGEDTRANSFORMATION');
                if (transformationNode) result.transformation = this.convert(transformationNode);
                else result.transformation = null;
                break;
            case 'ABRIDGEDTRANSFORMATION':
                result.type = 'Transformation';
                result.name = node[1];
                result.method = node.find((child)=>Array.isArray(child) && child[0] === 'METHOD') ? this.convert(node.find((child)=>Array.isArray(child) && child[0] === 'METHOD')) : null;
                result.parameters = node.filter((child)=>Array.isArray(child) && (child[0] === 'PARAMETER' || child[0] === 'PARAMETERFILE')).map((param)=>{
                    if (param[0] === 'PARAMETER') return this.convert(param);
                    else if (param[0] === 'PARAMETERFILE') return {
                        name: param[1],
                        value: param[2],
                        id: {
                            'authority': 'EPSG',
                            'code': 8656
                        }
                    };
                });
                // Adjust the Scale difference parameter if present
                if (result.parameters.length === 7) {
                    const scaleDifference = result.parameters[6];
                    if (scaleDifference.name === 'Scale difference') scaleDifference.value = Math.round((scaleDifference.value - 1) * 1e12) / 1e6;
                }
                result.id = this.getId(node);
                break;
            case 'AXIS':
                if (!result.coordinate_system) result.coordinate_system = {
                    type: 'unspecified',
                    axis: []
                };
                result.coordinate_system.axis.push(this.convertAxis(node));
                break;
            case 'LENGTHUNIT':
                const unit = this.convertUnit(node, 'LinearUnit');
                if (result.coordinate_system && result.coordinate_system.axis) result.coordinate_system.axis.forEach((axis)=>{
                    if (!axis.unit) axis.unit = unit;
                });
                if (unit.conversion_factor && unit.conversion_factor !== 1) {
                    if (result.semi_major_axis) result.semi_major_axis = {
                        value: result.semi_major_axis,
                        unit: unit
                    };
                }
                break;
            default:
                result.keyword = node[0];
                break;
        }
        return result;
    }
}
var $802e0c0f600b6c6d$export$2e2bcd8739ae039 = $802e0c0f600b6c6d$var$PROJJSONBuilderBase;


class $8df90082acece1e7$var$PROJJSONBuilder2015 extends (0, $802e0c0f600b6c6d$export$2e2bcd8739ae039) {
    static convert(node, result = {}) {
        super.convert(node, result);
        // Skip `CS` and `USAGE` nodes for WKT2-2015
        if (result.coordinate_system && result.coordinate_system.subtype === 'Cartesian') delete result.coordinate_system;
        if (result.usage) delete result.usage;
        return result;
    }
}
var $8df90082acece1e7$export$2e2bcd8739ae039 = $8df90082acece1e7$var$PROJJSONBuilder2015;



class $19024bba2fe80cac$var$PROJJSONBuilder2019 extends (0, $802e0c0f600b6c6d$export$2e2bcd8739ae039) {
    static convert(node, result = {}) {
        super.convert(node, result);
        // Handle `CS` node for WKT2-2019
        const csNode = node.find((child)=>Array.isArray(child) && child[0] === 'CS');
        if (csNode) result.coordinate_system = {
            subtype: csNode[1],
            axis: this.extractAxes(node)
        };
        // Handle `USAGE` node for WKT2-2019
        const usageNode = node.find((child)=>Array.isArray(child) && child[0] === 'USAGE');
        if (usageNode) {
            const scope = usageNode.find((child)=>Array.isArray(child) && child[0] === 'SCOPE');
            const area = usageNode.find((child)=>Array.isArray(child) && child[0] === 'AREA');
            const bbox = usageNode.find((child)=>Array.isArray(child) && child[0] === 'BBOX');
            result.usage = {};
            if (scope) result.usage.scope = scope[1];
            if (area) result.usage.area = area[1];
            if (bbox) result.usage.bbox = bbox.slice(1);
        }
        return result;
    }
}
var $19024bba2fe80cac$export$2e2bcd8739ae039 = $19024bba2fe80cac$var$PROJJSONBuilder2019;


/**
 * Detects the WKT2 version based on the structure of the WKT.
 * @param {Array} root The root WKT array node.
 * @returns {string} The detected version ("2015" or "2019").
 */ function $18cde189d1b60b7c$var$detectWKT2Version(root) {
    // Check for WKT2-2019-specific nodes
    if (root.find((child)=>Array.isArray(child) && child[0] === 'USAGE')) return '2019'; // `USAGE` is specific to WKT2-2019
    // Check for WKT2-2015-specific nodes
    if (root.find((child)=>Array.isArray(child) && child[0] === 'CS')) return '2015'; // `CS` is valid in both, but default to 2015 unless `USAGE` is present
    if (root[0] === 'BOUNDCRS' || root[0] === 'PROJCRS' || root[0] === 'GEOGCRS') return '2015'; // These are valid in both, but default to 2015
    // Default to WKT2-2015 if no specific indicators are found
    return '2015';
}
function $18cde189d1b60b7c$export$48d0005f67ba915(root) {
    const version = $18cde189d1b60b7c$var$detectWKT2Version(root);
    const builder = version === '2019' ? (0, $19024bba2fe80cac$export$2e2bcd8739ae039) : (0, $8df90082acece1e7$export$2e2bcd8739ae039);
    return builder.convert(root);
}


/**
 * Detects whether the WKT string is WKT1 or WKT2.
 * @param {string} wkt The WKT string.
 * @returns {string} The detected version ("WKT1" or "WKT2").
 */ function $c96b9147efe4167b$export$9362d65e4771b5d5(wkt) {
    // Normalize the WKT string for easier keyword matching
    const normalizedWKT = wkt.toUpperCase();
    // Check for WKT2-specific keywords
    if (normalizedWKT.includes('PROJCRS') || normalizedWKT.includes('GEOGCRS') || normalizedWKT.includes('BOUNDCRS') || normalizedWKT.includes('VERTCRS') || normalizedWKT.includes('LENGTHUNIT') || normalizedWKT.includes('ANGLEUNIT') || normalizedWKT.includes('SCALEUNIT')) return 'WKT2';
    // Check for WKT1-specific keywords
    if (normalizedWKT.includes('PROJCS') || normalizedWKT.includes('GEOGCS') || normalizedWKT.includes('LOCAL_CS') || normalizedWKT.includes('VERT_CS') || normalizedWKT.includes('UNIT')) return 'WKT1';
    // Default to WKT1 if no specific indicators are found
    return 'WKT1';
}


var $5ca28040f1ade477$export$2e2bcd8739ae039 = $5ca28040f1ade477$var$parseString;
var $5ca28040f1ade477$var$NEUTRAL = 1;
var $5ca28040f1ade477$var$KEYWORD = 2;
var $5ca28040f1ade477$var$NUMBER = 3;
var $5ca28040f1ade477$var$QUOTED = 4;
var $5ca28040f1ade477$var$AFTERQUOTE = 5;
var $5ca28040f1ade477$var$ENDED = -1;
var $5ca28040f1ade477$var$whitespace = /\s/;
var $5ca28040f1ade477$var$latin = /[A-Za-z]/;
var $5ca28040f1ade477$var$keyword = /[A-Za-z84_]/;
var $5ca28040f1ade477$var$endThings = /[,\]]/;
var $5ca28040f1ade477$var$digets = /[\d\.E\-\+]/;
// const ignoredChar = /[\s_\-\/\(\)]/g;
function $5ca28040f1ade477$var$Parser(text) {
    if (typeof text !== 'string') throw new Error('not a string');
    this.text = text.trim();
    this.level = 0;
    this.place = 0;
    this.root = null;
    this.stack = [];
    this.currentObject = null;
    this.state = $5ca28040f1ade477$var$NEUTRAL;
}
$5ca28040f1ade477$var$Parser.prototype.readCharicter = function() {
    var char = this.text[this.place++];
    if (this.state !== $5ca28040f1ade477$var$QUOTED) while($5ca28040f1ade477$var$whitespace.test(char)){
        if (this.place >= this.text.length) return;
        char = this.text[this.place++];
    }
    switch(this.state){
        case $5ca28040f1ade477$var$NEUTRAL:
            return this.neutral(char);
        case $5ca28040f1ade477$var$KEYWORD:
            return this.keyword(char);
        case $5ca28040f1ade477$var$QUOTED:
            return this.quoted(char);
        case $5ca28040f1ade477$var$AFTERQUOTE:
            return this.afterquote(char);
        case $5ca28040f1ade477$var$NUMBER:
            return this.number(char);
        case $5ca28040f1ade477$var$ENDED:
            return;
    }
};
$5ca28040f1ade477$var$Parser.prototype.afterquote = function(char) {
    if (char === '"') {
        this.word += '"';
        this.state = $5ca28040f1ade477$var$QUOTED;
        return;
    }
    if ($5ca28040f1ade477$var$endThings.test(char)) {
        this.word = this.word.trim();
        this.afterItem(char);
        return;
    }
    throw new Error('havn\'t handled "' + char + '" in afterquote yet, index ' + this.place);
};
$5ca28040f1ade477$var$Parser.prototype.afterItem = function(char) {
    if (char === ',') {
        if (this.word !== null) this.currentObject.push(this.word);
        this.word = null;
        this.state = $5ca28040f1ade477$var$NEUTRAL;
        return;
    }
    if (char === ']') {
        this.level--;
        if (this.word !== null) {
            this.currentObject.push(this.word);
            this.word = null;
        }
        this.state = $5ca28040f1ade477$var$NEUTRAL;
        this.currentObject = this.stack.pop();
        if (!this.currentObject) this.state = $5ca28040f1ade477$var$ENDED;
        return;
    }
};
$5ca28040f1ade477$var$Parser.prototype.number = function(char) {
    if ($5ca28040f1ade477$var$digets.test(char)) {
        this.word += char;
        return;
    }
    if ($5ca28040f1ade477$var$endThings.test(char)) {
        this.word = parseFloat(this.word);
        this.afterItem(char);
        return;
    }
    throw new Error('havn\'t handled "' + char + '" in number yet, index ' + this.place);
};
$5ca28040f1ade477$var$Parser.prototype.quoted = function(char) {
    if (char === '"') {
        this.state = $5ca28040f1ade477$var$AFTERQUOTE;
        return;
    }
    this.word += char;
    return;
};
$5ca28040f1ade477$var$Parser.prototype.keyword = function(char) {
    if ($5ca28040f1ade477$var$keyword.test(char)) {
        this.word += char;
        return;
    }
    if (char === '[') {
        var newObjects = [];
        newObjects.push(this.word);
        this.level++;
        if (this.root === null) this.root = newObjects;
        else this.currentObject.push(newObjects);
        this.stack.push(this.currentObject);
        this.currentObject = newObjects;
        this.state = $5ca28040f1ade477$var$NEUTRAL;
        return;
    }
    if ($5ca28040f1ade477$var$endThings.test(char)) {
        this.afterItem(char);
        return;
    }
    throw new Error('havn\'t handled "' + char + '" in keyword yet, index ' + this.place);
};
$5ca28040f1ade477$var$Parser.prototype.neutral = function(char) {
    if ($5ca28040f1ade477$var$latin.test(char)) {
        this.word = char;
        this.state = $5ca28040f1ade477$var$KEYWORD;
        return;
    }
    if (char === '"') {
        this.word = '';
        this.state = $5ca28040f1ade477$var$QUOTED;
        return;
    }
    if ($5ca28040f1ade477$var$digets.test(char)) {
        this.word = char;
        this.state = $5ca28040f1ade477$var$NUMBER;
        return;
    }
    if ($5ca28040f1ade477$var$endThings.test(char)) {
        this.afterItem(char);
        return;
    }
    throw new Error('havn\'t handled "' + char + '" in neutral yet, index ' + this.place);
};
$5ca28040f1ade477$var$Parser.prototype.output = function() {
    while(this.place < this.text.length)this.readCharicter();
    if (this.state === $5ca28040f1ade477$var$ENDED) return this.root;
    throw new Error('unable to parse string "' + this.text + '". State is ' + this.state);
};
function $5ca28040f1ade477$var$parseString(txt) {
    var parser = new $5ca28040f1ade477$var$Parser(txt);
    return parser.output();
}


function $b55e22dc09ea3895$var$mapit(obj, key, value) {
    if (Array.isArray(key)) {
        value.unshift(key);
        key = null;
    }
    var thing = key ? {} : obj;
    var out = value.reduce(function(newObj, item) {
        $b55e22dc09ea3895$export$337bc7a3aef1f775(item, newObj);
        return newObj;
    }, thing);
    if (key) obj[key] = out;
}
function $b55e22dc09ea3895$export$337bc7a3aef1f775(v, obj) {
    if (!Array.isArray(v)) {
        obj[v] = true;
        return;
    }
    var key = v.shift();
    if (key === 'PARAMETER') key = v.shift();
    if (v.length === 1) {
        if (Array.isArray(v[0])) {
            obj[key] = {};
            $b55e22dc09ea3895$export$337bc7a3aef1f775(v[0], obj[key]);
            return;
        }
        obj[key] = v[0];
        return;
    }
    if (!v.length) {
        obj[key] = true;
        return;
    }
    if (key === 'TOWGS84') {
        obj[key] = v;
        return;
    }
    if (key === 'AXIS') {
        if (!(key in obj)) obj[key] = [];
        obj[key].push(v);
        return;
    }
    if (!Array.isArray(key)) obj[key] = {};
    var i;
    switch(key){
        case 'UNIT':
        case 'PRIMEM':
        case 'VERT_DATUM':
            obj[key] = {
                name: v[0].toLowerCase(),
                convert: v[1]
            };
            if (v.length === 3) $b55e22dc09ea3895$export$337bc7a3aef1f775(v[2], obj[key]);
            return;
        case 'SPHEROID':
        case 'ELLIPSOID':
            obj[key] = {
                name: v[0],
                a: v[1],
                rf: v[2]
            };
            if (v.length === 4) $b55e22dc09ea3895$export$337bc7a3aef1f775(v[3], obj[key]);
            return;
        case 'EDATUM':
        case 'ENGINEERINGDATUM':
        case 'LOCAL_DATUM':
        case 'DATUM':
        case 'VERT_CS':
        case 'VERTCRS':
        case 'VERTICALCRS':
            v[0] = [
                'name',
                v[0]
            ];
            $b55e22dc09ea3895$var$mapit(obj, key, v);
            return;
        case 'COMPD_CS':
        case 'COMPOUNDCRS':
        case 'FITTED_CS':
        // the followings are the crs defined in
        // https://github.com/proj4js/proj4js/blob/1da4ed0b865d0fcb51c136090569210cdcc9019e/lib/parseCode.js#L11
        case 'PROJECTEDCRS':
        case 'PROJCRS':
        case 'GEOGCS':
        case 'GEOCCS':
        case 'PROJCS':
        case 'LOCAL_CS':
        case 'GEODCRS':
        case 'GEODETICCRS':
        case 'GEODETICDATUM':
        case 'ENGCRS':
        case 'ENGINEERINGCRS':
            v[0] = [
                'name',
                v[0]
            ];
            $b55e22dc09ea3895$var$mapit(obj, key, v);
            obj[key].type = key;
            return;
        default:
            i = -1;
            while(++i < v.length){
                if (!Array.isArray(v[i])) return $b55e22dc09ea3895$export$337bc7a3aef1f775(v, obj[key]);
            }
            return $b55e22dc09ea3895$var$mapit(obj, key, v);
    }
}


var $1edb8ecb6a7db52b$var$D2R = 0.01745329251994329577;
function $1edb8ecb6a7db52b$export$e726aea149b4fd71(input) {
    return input * $1edb8ecb6a7db52b$var$D2R;
}
function $1edb8ecb6a7db52b$export$d6def86a6ec68808(wkt) {
    // Normalize projName for WKT2 compatibility
    const normalizedProjName = (wkt.projName || '').toLowerCase().replace(/_/g, ' ');
    if (wkt.long0 === undefined && wkt.longc !== undefined) wkt.long0 = wkt.longc; // keep in the projection's native prime meridian frame
    if (!wkt.lat_ts && wkt.lat1 && (normalizedProjName === 'stereographic south pole' || normalizedProjName === 'polar stereographic (variant b)')) {
        wkt.lat0 = $1edb8ecb6a7db52b$export$e726aea149b4fd71(wkt.lat1 > 0 ? 90 : -90);
        wkt.lat_ts = wkt.lat1;
        delete wkt.lat1;
    } else if (!wkt.lat_ts && wkt.lat0 && (normalizedProjName === 'polar stereographic' || normalizedProjName === 'polar stereographic (variant a)')) {
        wkt.lat_ts = wkt.lat0;
        wkt.lat0 = $1edb8ecb6a7db52b$export$e726aea149b4fd71(wkt.lat0 > 0 ? 90 : -90);
        delete wkt.lat1;
    }
}


// Helper function to process units and to_meter
function $f073838cca30d954$var$processUnit(unit) {
    let result = {
        units: null,
        to_meter: undefined
    };
    if (typeof unit === 'string') {
        result.units = unit.toLowerCase();
        if (result.units === 'metre') result.units = 'meter'; // Normalize 'metre' to 'meter'
        if (result.units === 'meter') result.to_meter = 1; // Only set to_meter if units are 'meter'
    } else if (unit && unit.name) {
        result.units = unit.name.toLowerCase();
        if (result.units === 'metre') result.units = 'meter'; // Normalize 'metre' to 'meter'
        result.to_meter = unit.conversion_factor;
    }
    return result;
}
function $f073838cca30d954$var$toValue(valueOrObject) {
    if (typeof valueOrObject === 'object') return valueOrObject.value * valueOrObject.unit.conversion_factor;
    return valueOrObject;
}
function $f073838cca30d954$var$calculateEllipsoid(value, result) {
    if (value.ellipsoid.radius) {
        result.a = value.ellipsoid.radius;
        result.rf = 0;
    } else {
        result.a = $f073838cca30d954$var$toValue(value.ellipsoid.semi_major_axis);
        if (value.ellipsoid.inverse_flattening !== undefined) result.rf = value.ellipsoid.inverse_flattening;
        else if (value.ellipsoid.semi_major_axis !== undefined && value.ellipsoid.semi_minor_axis !== undefined) result.rf = result.a / (result.a - $f073838cca30d954$var$toValue(value.ellipsoid.semi_minor_axis));
    }
}
function $f073838cca30d954$export$b04e619e90585ec3(projjson, result = {}) {
    if (!projjson || typeof projjson !== 'object') return projjson; // Return primitive values as-is
    if (projjson.type === 'BoundCRS') {
        $f073838cca30d954$export$b04e619e90585ec3(projjson.source_crs, result);
        if (projjson.transformation) {
            if (projjson.transformation.method && projjson.transformation.method.name === 'NTv2') // Set nadgrids to the filename from the parameterfile
            result.nadgrids = projjson.transformation.parameters[0].value;
            else // Populate datum_params if no parameterfile is found
            result.datum_params = projjson.transformation.parameters.map((param)=>param.value);
        }
        return result; // Return early for BoundCRS
    }
    // Handle specific keys in PROJJSON
    Object.keys(projjson).forEach((key)=>{
        const value = projjson[key];
        if (value === null) return;
        switch(key){
            case 'name':
                if (result.srsCode) break;
                result.name = value;
                result.srsCode = value; // Map `name` to `srsCode`
                break;
            case 'type':
                if (value === 'GeographicCRS') result.projName = 'longlat';
                else if (value === 'GeodeticCRS') {
                    if (projjson.coordinate_system && projjson.coordinate_system.subtype === 'Cartesian') result.projName = 'geocent';
                    else result.projName = 'longlat';
                } else if (value === 'ProjectedCRS' && projjson.conversion && projjson.conversion.method) result.projName = projjson.conversion.method.name; // Retain original capitalization
                break;
            case 'datum':
            case 'datum_ensemble':
                if (value.ellipsoid) {
                    // Extract ellipsoid properties
                    result.ellps = value.ellipsoid.name;
                    $f073838cca30d954$var$calculateEllipsoid(value, result);
                }
                if (value.prime_meridian) result.from_greenwich = value.prime_meridian.longitude * Math.PI / 180; // Convert to radians
                break;
            case 'ellipsoid':
                result.ellps = value.name;
                $f073838cca30d954$var$calculateEllipsoid(value, result);
                break;
            case 'prime_meridian':
                result.long0 = (value.longitude || 0) * Math.PI / 180; // Convert to radians
                break;
            case 'coordinate_system':
                if (value.axis) {
                    const directionMap = {
                        'east': 'e',
                        'north': 'n',
                        'west': 'w',
                        'south': 's',
                        'up': 'u',
                        'down': 'd',
                        'geocentricx': 'e',
                        'geocentricy': 'n',
                        'geocentricz': 'u'
                    };
                    const mapped = value.axis.map((axis)=>directionMap[axis.direction.toLowerCase()]);
                    if (mapped.every(Boolean)) {
                        result.axis = mapped.join('');
                        if (result.axis.length === 2) result.axis += 'u';
                    }
                    if (value.unit) {
                        const { units: units, to_meter: to_meter } = $f073838cca30d954$var$processUnit(value.unit);
                        result.units = units;
                        result.to_meter = to_meter;
                    } else if (value.axis[0] && value.axis[0].unit) {
                        const { units: units, to_meter: to_meter } = $f073838cca30d954$var$processUnit(value.axis[0].unit);
                        result.units = units;
                        result.to_meter = to_meter;
                    }
                }
                break;
            case 'id':
                if (value.authority && value.code) result.title = value.authority + ':' + value.code;
                break;
            case 'conversion':
                if (value.method && value.method.name) result.projName = value.method.name; // Retain original capitalization
                if (value.parameters) value.parameters.forEach((param)=>{
                    const paramName = param.name.toLowerCase().replace(/\s+/g, '_');
                    const paramValue = param.value;
                    if (param.unit && param.unit.conversion_factor) result[paramName] = paramValue * param.unit.conversion_factor; // Convert to radians or meters
                    else if (param.unit === 'degree') result[paramName] = paramValue * Math.PI / 180; // Convert to radians
                    else result[paramName] = paramValue;
                });
                break;
            case 'unit':
                if (value.name) {
                    result.units = value.name.toLowerCase();
                    if (result.units === 'metre') result.units = 'meter';
                }
                if (value.conversion_factor) result.to_meter = value.conversion_factor;
                break;
            case 'base_crs':
                $f073838cca30d954$export$b04e619e90585ec3(value, result); // Pass `result` directly
                result.datumCode = value.id ? value.id.authority + '_' + value.id.code : value.name; // Set datumCode
                break;
            default:
                break;
        }
    });
    // Additional calculated properties
    if (result.latitude_of_false_origin !== undefined) result.lat0 = result.latitude_of_false_origin; // Already in radians
    if (result.longitude_of_false_origin !== undefined) result.long0 = result.longitude_of_false_origin;
    if (result.latitude_of_standard_parallel !== undefined) {
        result.lat0 = result.latitude_of_standard_parallel;
        result.lat1 = result.latitude_of_standard_parallel;
    }
    if (result.latitude_of_1st_standard_parallel !== undefined) result.lat1 = result.latitude_of_1st_standard_parallel;
    if (result.latitude_of_2nd_standard_parallel !== undefined) result.lat2 = result.latitude_of_2nd_standard_parallel;
    if (result.latitude_of_projection_centre !== undefined) result.lat0 = result.latitude_of_projection_centre;
    if (result.longitude_of_projection_centre !== undefined) result.longc = result.longitude_of_projection_centre;
    if (result.easting_at_false_origin !== undefined) result.x0 = result.easting_at_false_origin;
    if (result.northing_at_false_origin !== undefined) result.y0 = result.northing_at_false_origin;
    if (result.latitude_of_natural_origin !== undefined) result.lat0 = result.latitude_of_natural_origin;
    if (result.longitude_of_natural_origin !== undefined) result.long0 = result.longitude_of_natural_origin;
    if (result.longitude_of_origin !== undefined) result.long0 = result.longitude_of_origin;
    if (result.false_easting !== undefined) result.x0 = result.false_easting;
    if (result.easting_at_projection_centre) result.x0 = result.easting_at_projection_centre;
    if (result.false_northing !== undefined) result.y0 = result.false_northing;
    if (result.northing_at_projection_centre) result.y0 = result.northing_at_projection_centre;
    if (result.standard_parallel_1 !== undefined) result.lat1 = result.standard_parallel_1;
    if (result.standard_parallel_2 !== undefined) result.lat2 = result.standard_parallel_2;
    if (result.scale_factor_at_natural_origin !== undefined) result.k0 = result.scale_factor_at_natural_origin;
    if (result.scale_factor_at_projection_centre !== undefined) result.k0 = result.scale_factor_at_projection_centre;
    if (result.scale_factor_on_pseudo_standard_parallel !== undefined) result.k0 = result.scale_factor_on_pseudo_standard_parallel;
    if (result.azimuth !== undefined) result.alpha = result.azimuth;
    if (result.azimuth_at_projection_centre !== undefined) result.alpha = result.azimuth_at_projection_centre;
    if (result.angle_from_rectified_to_skew_grid) result.rectified_grid_angle = result.angle_from_rectified_to_skew_grid;
    // Apply projection defaults
    (0, $1edb8ecb6a7db52b$export$d6def86a6ec68808)(result);
    return result;
}



var $45fe3180c5510e43$var$knownTypes = [
    'PROJECTEDCRS',
    'PROJCRS',
    'GEOGCS',
    'GEOCCS',
    'PROJCS',
    'LOCAL_CS',
    'GEODCRS',
    'GEODETICCRS',
    'GEODETICDATUM',
    'ENGCRS',
    'ENGINEERINGCRS'
];
function $45fe3180c5510e43$var$rename(obj, params) {
    var outName = params[0];
    var inName = params[1];
    if (!(outName in obj) && inName in obj) {
        obj[outName] = obj[inName];
        if (params.length === 3) obj[outName] = params[2](obj[outName]);
    }
}
function $45fe3180c5510e43$var$cleanWKT(wkt) {
    var keys = Object.keys(wkt);
    for(var i = 0, ii = keys.length; i < ii; ++i){
        var key = keys[i];
        // the followings are the crs defined in
        // https://github.com/proj4js/proj4js/blob/1da4ed0b865d0fcb51c136090569210cdcc9019e/lib/parseCode.js#L11
        if ($45fe3180c5510e43$var$knownTypes.indexOf(key) !== -1) $45fe3180c5510e43$var$setPropertiesFromWkt(wkt[key]);
        if (typeof wkt[key] === 'object') $45fe3180c5510e43$var$cleanWKT(wkt[key]);
    }
}
function $45fe3180c5510e43$var$setPropertiesFromWkt(wkt) {
    if (wkt.AUTHORITY) {
        var authority = Object.keys(wkt.AUTHORITY)[0];
        if (authority && authority in wkt.AUTHORITY) wkt.title = authority + ':' + wkt.AUTHORITY[authority];
    }
    if (wkt.type === 'GEOGCS') wkt.projName = 'longlat';
    else if (wkt.type === 'LOCAL_CS') {
        wkt.projName = 'identity';
        wkt.local = true;
    } else if (typeof wkt.PROJECTION === 'object') wkt.projName = Object.keys(wkt.PROJECTION)[0];
    else wkt.projName = wkt.PROJECTION;
    if (wkt.AXIS) {
        var axisOrder = '';
        for(var i = 0, ii = wkt.AXIS.length; i < ii; ++i){
            var axis = [
                wkt.AXIS[i][0].toLowerCase(),
                wkt.AXIS[i][1].toLowerCase()
            ];
            if (axis[0].indexOf('north') !== -1 || (axis[0] === 'y' || axis[0] === 'lat') && axis[1] === 'north') axisOrder += 'n';
            else if (axis[0].indexOf('south') !== -1 || (axis[0] === 'y' || axis[0] === 'lat') && axis[1] === 'south') axisOrder += 's';
            else if (axis[0].indexOf('east') !== -1 || (axis[0] === 'x' || axis[0] === 'lon') && axis[1] === 'east') axisOrder += 'e';
            else if (axis[0].indexOf('west') !== -1 || (axis[0] === 'x' || axis[0] === 'lon') && axis[1] === 'west') axisOrder += 'w';
        }
        if (axisOrder.length === 2) axisOrder += 'u';
        if (axisOrder.length === 3) wkt.axis = axisOrder;
    }
    if (wkt.UNIT) {
        wkt.units = wkt.UNIT.name.toLowerCase();
        if (wkt.units === 'metre') wkt.units = 'meter';
        if (wkt.UNIT.convert) {
            if (wkt.type === 'GEOGCS') {
                if (wkt.DATUM && wkt.DATUM.SPHEROID) wkt.to_meter = wkt.UNIT.convert * wkt.DATUM.SPHEROID.a;
            } else wkt.to_meter = wkt.UNIT.convert;
        }
    }
    var geogcs = wkt.GEOGCS;
    if (wkt.type === 'GEOGCS') geogcs = wkt;
    if (geogcs) {
        if (geogcs.PRIMEM && geogcs.PRIMEM.convert) wkt.from_greenwich = (0, $1edb8ecb6a7db52b$export$e726aea149b4fd71)(geogcs.PRIMEM.convert);
        if (geogcs.DATUM) wkt.datumCode = geogcs.DATUM.name.toLowerCase();
        else wkt.datumCode = geogcs.name.toLowerCase();
        if (wkt.datumCode.slice(0, 2) === 'd_') wkt.datumCode = wkt.datumCode.slice(2);
        if (wkt.datumCode === 'new_zealand_1949') wkt.datumCode = 'nzgd49';
        if (wkt.datumCode === 'wgs_1984' || wkt.datumCode === 'world_geodetic_system_1984') {
            if (wkt.PROJECTION === 'Mercator_Auxiliary_Sphere') wkt.sphere = true;
            wkt.datumCode = 'wgs84';
        }
        if (wkt.datumCode === 'belge_1972') wkt.datumCode = 'rnb72';
        if (geogcs.DATUM && geogcs.DATUM.SPHEROID) {
            wkt.ellps = geogcs.DATUM.SPHEROID.name.replace('_19', '').replace(/[Cc]larke\_18/, 'clrk');
            if (wkt.ellps.toLowerCase().slice(0, 13) === 'international') wkt.ellps = 'intl';
            wkt.a = geogcs.DATUM.SPHEROID.a;
            wkt.rf = parseFloat(geogcs.DATUM.SPHEROID.rf);
        }
        if (geogcs.DATUM && geogcs.DATUM.TOWGS84) wkt.datum_params = geogcs.DATUM.TOWGS84;
        if (~wkt.datumCode.indexOf('osgb_1936')) wkt.datumCode = 'osgb36';
        if (~wkt.datumCode.indexOf('osni_1952')) wkt.datumCode = 'osni52';
        if (~wkt.datumCode.indexOf('tm65') || ~wkt.datumCode.indexOf('geodetic_datum_of_1965')) wkt.datumCode = 'ire65';
        if (wkt.datumCode === 'ch1903+') wkt.datumCode = 'ch1903';
        if (~wkt.datumCode.indexOf('israel')) wkt.datumCode = 'isr93';
    }
    if (wkt.b && !isFinite(wkt.b)) wkt.b = wkt.a;
    if (wkt.rectified_grid_angle) wkt.rectified_grid_angle = (0, $1edb8ecb6a7db52b$export$e726aea149b4fd71)(wkt.rectified_grid_angle);
    function toMeter(input) {
        var ratio = wkt.to_meter || 1;
        return input * ratio;
    }
    var renamer = function(a) {
        return $45fe3180c5510e43$var$rename(wkt, a);
    };
    var list = [
        [
            'standard_parallel_1',
            'Standard_Parallel_1'
        ],
        [
            'standard_parallel_1',
            'Latitude of 1st standard parallel'
        ],
        [
            'standard_parallel_2',
            'Standard_Parallel_2'
        ],
        [
            'standard_parallel_2',
            'Latitude of 2nd standard parallel'
        ],
        [
            'false_easting',
            'False_Easting'
        ],
        [
            'false_easting',
            'False easting'
        ],
        [
            'false-easting',
            'Easting at false origin'
        ],
        [
            'false_northing',
            'False_Northing'
        ],
        [
            'false_northing',
            'False northing'
        ],
        [
            'false_northing',
            'Northing at false origin'
        ],
        [
            'central_meridian',
            'Central_Meridian'
        ],
        [
            'central_meridian',
            'Longitude of natural origin'
        ],
        [
            'central_meridian',
            'Longitude of false origin'
        ],
        [
            'latitude_of_origin',
            'Latitude_Of_Origin'
        ],
        [
            'latitude_of_origin',
            'Central_Parallel'
        ],
        [
            'latitude_of_origin',
            'Latitude of natural origin'
        ],
        [
            'latitude_of_origin',
            'Latitude of false origin'
        ],
        [
            'scale_factor',
            'Scale_Factor'
        ],
        [
            'k0',
            'scale_factor'
        ],
        [
            'latitude_of_center',
            'Latitude_Of_Center'
        ],
        [
            'latitude_of_center',
            'Latitude_of_center'
        ],
        [
            'lat0',
            'latitude_of_center',
            (0, $1edb8ecb6a7db52b$export$e726aea149b4fd71)
        ],
        [
            'longitude_of_center',
            'Longitude_Of_Center'
        ],
        [
            'longitude_of_center',
            'Longitude_of_center'
        ],
        [
            'longc',
            'longitude_of_center',
            (0, $1edb8ecb6a7db52b$export$e726aea149b4fd71)
        ],
        [
            'x0',
            'false_easting',
            toMeter
        ],
        [
            'y0',
            'false_northing',
            toMeter
        ],
        [
            'long0',
            'central_meridian',
            (0, $1edb8ecb6a7db52b$export$e726aea149b4fd71)
        ],
        [
            'lat0',
            'latitude_of_origin',
            (0, $1edb8ecb6a7db52b$export$e726aea149b4fd71)
        ],
        [
            'lat0',
            'standard_parallel_1',
            (0, $1edb8ecb6a7db52b$export$e726aea149b4fd71)
        ],
        [
            'lat1',
            'standard_parallel_1',
            (0, $1edb8ecb6a7db52b$export$e726aea149b4fd71)
        ],
        [
            'lat2',
            'standard_parallel_2',
            (0, $1edb8ecb6a7db52b$export$e726aea149b4fd71)
        ],
        [
            'azimuth',
            'Azimuth'
        ],
        [
            'alpha',
            'azimuth',
            (0, $1edb8ecb6a7db52b$export$e726aea149b4fd71)
        ],
        [
            'srsCode',
            'name'
        ]
    ];
    list.forEach(renamer);
    (0, $1edb8ecb6a7db52b$export$d6def86a6ec68808)(wkt);
}
function $45fe3180c5510e43$export$2e2bcd8739ae039(wkt) {
    if (typeof wkt === 'object') return (0, $f073838cca30d954$export$b04e619e90585ec3)(wkt);
    const version = (0, $c96b9147efe4167b$export$9362d65e4771b5d5)(wkt);
    var lisp = (0, $5ca28040f1ade477$export$2e2bcd8739ae039)(wkt);
    if (version === 'WKT2') {
        const projjson = (0, $18cde189d1b60b7c$export$48d0005f67ba915)(lisp);
        return (0, $f073838cca30d954$export$b04e619e90585ec3)(projjson);
    }
    var type = lisp[0];
    var obj = {};
    (0, $b55e22dc09ea3895$export$337bc7a3aef1f775)(lisp, obj);
    $45fe3180c5510e43$var$cleanWKT(obj);
    return obj[type];
}


/**
 * @typedef {Object} ProjectionDefinition
 * @property {string} title
 * @property {string} [projName]
 * @property {string} [ellps]
 * @property {import('./Proj.js').DatumDefinition} [datum]
 * @property {string} [datumName]
 * @property {number} [rf]
 * @property {number} [lat0]
 * @property {number} [lat1]
 * @property {number} [lat2]
 * @property {number} [lat_ts]
 * @property {number} [long0]
 * @property {number} [long1]
 * @property {number} [long2]
 * @property {number} [alpha]
 * @property {number} [longc]
 * @property {number} [x0]
 * @property {number} [y0]
 * @property {number} [k0]
 * @property {number} [a]
 * @property {number} [b]
 * @property {true} [R_A]
 * @property {number} [zone]
 * @property {true} [utmSouth]
 * @property {string|Array<number>} [datum_params]
 * @property {number} [to_meter]
 * @property {string} [units]
 * @property {number} [from_greenwich]
 * @property {string} [datumCode]
 * @property {string} [nadgrids]
 * @property {string} [axis]
 * @property {boolean} [sphere]
 * @property {number} [rectified_grid_angle]
 * @property {boolean} [approx]
 * @property {boolean} [over]
 * @property {string} [projStr]
 * @property {<T extends import('./core').TemplateCoordinates>(coordinates: T, enforceAxis?: boolean) => T} inverse
 * @property {<T extends import('./core').TemplateCoordinates>(coordinates: T, enforceAxis?: boolean) => T} forward
 */ /**
 * @overload
 * @param {string} name
 * @param {string|ProjectionDefinition|import('./core.js').PROJJSONDefinition} projection
 * @returns {void}
 */ /**
 * @overload
 * @param {Array<[string, string]>} name
 * @returns {Array<ProjectionDefinition|undefined>}
 */ /**
 * @overload
 * @param {string} name
 * @returns {ProjectionDefinition}
 */ /**
 * @param {string | Array<Array<string>> | Partial<Record<'EPSG'|'ESRI'|'IAU2000', ProjectionDefinition>>} name
 * @returns {ProjectionDefinition | Array<ProjectionDefinition|undefined> | void}
 */ function $b50b13974d7f3f7f$var$defs(name) {
    /* global console */ var that = this;
    if (arguments.length === 2) {
        var def = arguments[1];
        if (typeof def === 'string') {
            if (def.charAt(0) === '+') $b50b13974d7f3f7f$var$defs[/** @type {string} */ name] = (0, $9e397f4b78164de8$export$2e2bcd8739ae039)(arguments[1]);
            else $b50b13974d7f3f7f$var$defs[/** @type {string} */ name] = (0, $45fe3180c5510e43$export$2e2bcd8739ae039)(arguments[1]);
        } else if (def && typeof def === 'object' && !('projName' in def)) // PROJJSON
        $b50b13974d7f3f7f$var$defs[/** @type {string} */ name] = (0, $45fe3180c5510e43$export$2e2bcd8739ae039)(arguments[1]);
        else {
            $b50b13974d7f3f7f$var$defs[/** @type {string} */ name] = def;
            if (!def) delete $b50b13974d7f3f7f$var$defs[/** @type {string} */ name];
        }
    } else if (arguments.length === 1) {
        if (Array.isArray(name)) return name.map(function(v) {
            if (Array.isArray(v)) return $b50b13974d7f3f7f$var$defs.apply(that, v);
            else return $b50b13974d7f3f7f$var$defs(v);
        });
        else if (typeof name === 'string') {
            if (name in $b50b13974d7f3f7f$var$defs) return $b50b13974d7f3f7f$var$defs[name];
        } else if ('EPSG' in name) $b50b13974d7f3f7f$var$defs['EPSG:' + name.EPSG] = name;
        else if ('ESRI' in name) $b50b13974d7f3f7f$var$defs['ESRI:' + name.ESRI] = name;
        else if ('IAU2000' in name) $b50b13974d7f3f7f$var$defs['IAU2000:' + name.IAU2000] = name;
        else console.log(name);
        return;
    }
}
(0, $b8abfb341abe22ae$export$2e2bcd8739ae039)($b50b13974d7f3f7f$var$defs);
var $b50b13974d7f3f7f$export$2e2bcd8739ae039 = $b50b13974d7f3f7f$var$defs;





function $39cd55cd881e7f3e$var$testObj(code) {
    return typeof code === 'string';
}
function $39cd55cd881e7f3e$var$testDef(code) {
    return code in (0, $b50b13974d7f3f7f$export$2e2bcd8739ae039);
}
function $39cd55cd881e7f3e$var$testWKT(code) {
    return code.indexOf('+') !== 0 && code.indexOf('[') !== -1 || typeof code === 'object' && !('srsCode' in code);
}
var $39cd55cd881e7f3e$var$codes = [
    '3857',
    '900913',
    '3785',
    '102113'
];
function $39cd55cd881e7f3e$var$checkMercator(item) {
    if (item.title) return item.title.toLowerCase().indexOf('epsg:') === 0 && $39cd55cd881e7f3e$var$codes.indexOf(item.title.substr(5)) > -1;
    var auth = (0, $6e15fef3d69c3cec$export$2e2bcd8739ae039)(item, 'authority');
    if (!auth) return;
    var code = (0, $6e15fef3d69c3cec$export$2e2bcd8739ae039)(auth, 'epsg');
    return code && $39cd55cd881e7f3e$var$codes.indexOf(code) > -1;
}
function $39cd55cd881e7f3e$var$checkProjStr(item) {
    var ext = (0, $6e15fef3d69c3cec$export$2e2bcd8739ae039)(item, 'extension');
    if (!ext) return;
    return (0, $6e15fef3d69c3cec$export$2e2bcd8739ae039)(ext, 'proj4');
}
function $39cd55cd881e7f3e$var$testProj(code) {
    return code[0] === '+';
}
/**
 * @param {string | import('./core').PROJJSONDefinition | import('./defs').ProjectionDefinition} code
 * @returns {import('./defs').ProjectionDefinition}
 */ function $39cd55cd881e7f3e$var$parse(code) {
    let out;
    if ($39cd55cd881e7f3e$var$testObj(code)) {
        // check to see if this is a WKT string
        if ($39cd55cd881e7f3e$var$testDef(code)) out = (0, $b50b13974d7f3f7f$export$2e2bcd8739ae039)[code];
        else if ($39cd55cd881e7f3e$var$testWKT(code)) {
            out = (0, $45fe3180c5510e43$export$2e2bcd8739ae039)(code);
            var maybeProjStr = $39cd55cd881e7f3e$var$checkProjStr(out);
            if (maybeProjStr) out = (0, $9e397f4b78164de8$export$2e2bcd8739ae039)(maybeProjStr);
        } else if ($39cd55cd881e7f3e$var$testProj(code)) out = (0, $9e397f4b78164de8$export$2e2bcd8739ae039)(code);
    } else if (!('projName' in code)) out = (0, $45fe3180c5510e43$export$2e2bcd8739ae039)(code);
    else out = code;
    // test for special Web Mercator case, due to this being a very common and often malformed
    return out && $39cd55cd881e7f3e$var$checkMercator(out) ? (0, $b50b13974d7f3f7f$export$2e2bcd8739ae039)['EPSG:3857'] : out;
}
var $39cd55cd881e7f3e$export$2e2bcd8739ae039 = $39cd55cd881e7f3e$var$parse;


function $ddedbe7ebc7ebe00$export$2e2bcd8739ae039(destination, source) {
    destination = destination || {};
    var value, property;
    if (!source) return destination;
    for(property in source){
        value = source[property];
        if (value !== undefined) destination[property] = value;
    }
    return destination;
}



var $96xAh = parcelRequire("96xAh");

var $eRFTg = parcelRequire("eRFTg");

var $jDCGO = parcelRequire("jDCGO");
function $9bbed77786baf8a2$export$2e2bcd8739ae039(eccent, phi, sinphi) {
    var con = eccent * sinphi;
    var com = 0.5 * eccent;
    con = Math.pow((1 - con) / (1 + con), com);
    return Math.tan(0.5 * ((0, $jDCGO.HALF_PI) - phi)) / con;
}



var $jDCGO = parcelRequire("jDCGO");
function $1669155a5b2076cb$export$2e2bcd8739ae039(eccent, ts) {
    var eccnth = 0.5 * eccent;
    var con, dphi;
    var phi = (0, $jDCGO.HALF_PI) - 2 * Math.atan(ts);
    for(var i = 0; i <= 15; i++){
        con = eccent * Math.sin(phi);
        dphi = (0, $jDCGO.HALF_PI) - 2 * Math.atan(ts * Math.pow((1 - con) / (1 + con), eccnth)) - phi;
        phi += dphi;
        if (Math.abs(dphi) <= 0.0000000001) return phi;
    }
    // console.log("phi2z has NoConvergence");
    return -9999;
}



var $jDCGO = parcelRequire("jDCGO");
function $a199e4a0aa006532$export$2cd8252107eb640b() {
    var con = this.b / this.a;
    this.es = 1 - con * con;
    if (!('x0' in this)) this.x0 = 0;
    if (!('y0' in this)) this.y0 = 0;
    this.e = Math.sqrt(this.es);
    if (this.lat_ts) {
        if (this.sphere) this.k0 = Math.cos(this.lat_ts);
        else this.k0 = (0, $96xAh.default)(this.e, Math.sin(this.lat_ts), Math.cos(this.lat_ts));
    } else if (!this.k0) {
        if (this.k) this.k0 = this.k;
        else this.k0 = 1;
    }
}
function $a199e4a0aa006532$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    // convert to radians
    if (lat * (0, $jDCGO.R2D) > 90 && lat * (0, $jDCGO.R2D) < -90 && lon * (0, $jDCGO.R2D) > 180 && lon * (0, $jDCGO.R2D) < -180) return null;
    var x, y;
    if (Math.abs(Math.abs(lat) - (0, $jDCGO.HALF_PI)) <= (0, $jDCGO.EPSLN)) return null;
    else {
        if (this.sphere) {
            x = this.x0 + this.a * this.k0 * (0, $eRFTg.default)(lon - this.long0, this.over);
            y = this.y0 + this.a * this.k0 * Math.log(Math.tan((0, $jDCGO.FORTPI) + 0.5 * lat));
        } else {
            var sinphi = Math.sin(lat);
            var ts = (0, $9bbed77786baf8a2$export$2e2bcd8739ae039)(this.e, lat, sinphi);
            x = this.x0 + this.a * this.k0 * (0, $eRFTg.default)(lon - this.long0, this.over);
            y = this.y0 - this.a * this.k0 * Math.log(ts);
        }
        p.x = x;
        p.y = y;
        return p;
    }
}
function $a199e4a0aa006532$export$70ae2c07e401031b(p) {
    var x = p.x - this.x0;
    var y = p.y - this.y0;
    var lon, lat;
    if (this.sphere) lat = (0, $jDCGO.HALF_PI) - 2 * Math.atan(Math.exp(-y / (this.a * this.k0)));
    else {
        var ts = Math.exp(-y / (this.a * this.k0));
        lat = (0, $1669155a5b2076cb$export$2e2bcd8739ae039)(this.e, ts);
        if (lat === -9999) return null;
    }
    lon = (0, $eRFTg.default)(this.long0 + x / (this.a * this.k0), this.over);
    p.x = lon;
    p.y = lat;
    return p;
}
var $a199e4a0aa006532$export$e4b2ac9215619f8d = [
    'Mercator',
    'Popular Visualisation Pseudo Mercator',
    'Mercator_1SP',
    'Mercator_Auxiliary_Sphere',
    'Mercator_Variant_A',
    'merc'
];
var $a199e4a0aa006532$export$2e2bcd8739ae039 = {
    init: $a199e4a0aa006532$export$2cd8252107eb640b,
    forward: $a199e4a0aa006532$export$174bb771924e7eb1,
    inverse: $a199e4a0aa006532$export$70ae2c07e401031b,
    names: $a199e4a0aa006532$export$e4b2ac9215619f8d
};


function $74aa7cc11bd07059$export$2cd8252107eb640b() {
// no-op for longlat
}
function $74aa7cc11bd07059$export$174bb771924e7eb1(pt) {
    return pt;
}
var $74aa7cc11bd07059$export$e4b2ac9215619f8d = [
    'longlat',
    'identity'
];
var $74aa7cc11bd07059$export$2e2bcd8739ae039 = {
    init: $74aa7cc11bd07059$export$2cd8252107eb640b,
    forward: $74aa7cc11bd07059$export$174bb771924e7eb1,
    inverse: $74aa7cc11bd07059$export$174bb771924e7eb1,
    names: $74aa7cc11bd07059$export$e4b2ac9215619f8d
};


/** @type {Array<Partial<import('./Proj').default>>} */ var $9b3a1b7aca3fbe1b$var$projs = [
    (0, $a199e4a0aa006532$export$2e2bcd8739ae039),
    (0, $74aa7cc11bd07059$export$2e2bcd8739ae039)
];
var $9b3a1b7aca3fbe1b$var$names = {};
var $9b3a1b7aca3fbe1b$var$projStore = [];
function $9b3a1b7aca3fbe1b$export$e16d8520af44a096(proj, i) {
    var len = $9b3a1b7aca3fbe1b$var$projStore.length;
    if (!proj.names) {
        console.log(i);
        return true;
    }
    $9b3a1b7aca3fbe1b$var$projStore[len] = proj;
    proj.names.forEach(function(n) {
        $9b3a1b7aca3fbe1b$var$names[n.toLowerCase()] = len;
    });
    return this;
}
function $9b3a1b7aca3fbe1b$export$9ee0bb5510679155(n) {
    return n.replace(/[-\(\)\s]+/g, ' ').trim().replace(/ /g, '_');
}
function $9b3a1b7aca3fbe1b$export$3988ae62b71be9a3(name) {
    if (!name) return false;
    var n = name.toLowerCase();
    if (typeof $9b3a1b7aca3fbe1b$var$names[n] !== 'undefined' && $9b3a1b7aca3fbe1b$var$projStore[$9b3a1b7aca3fbe1b$var$names[n]]) return $9b3a1b7aca3fbe1b$var$projStore[$9b3a1b7aca3fbe1b$var$names[n]];
    n = $9b3a1b7aca3fbe1b$export$9ee0bb5510679155(n);
    if (n in $9b3a1b7aca3fbe1b$var$names && $9b3a1b7aca3fbe1b$var$projStore[$9b3a1b7aca3fbe1b$var$names[n]]) return $9b3a1b7aca3fbe1b$var$projStore[$9b3a1b7aca3fbe1b$var$names[n]];
}
function $9b3a1b7aca3fbe1b$export$b3571188c770cc5a() {
    $9b3a1b7aca3fbe1b$var$projs.forEach($9b3a1b7aca3fbe1b$export$e16d8520af44a096);
}
var $9b3a1b7aca3fbe1b$export$2e2bcd8739ae039 = {
    start: $9b3a1b7aca3fbe1b$export$b3571188c770cc5a,
    add: $9b3a1b7aca3fbe1b$export$e16d8520af44a096,
    get: $9b3a1b7aca3fbe1b$export$3988ae62b71be9a3
};



var $jDCGO = parcelRequire("jDCGO");
var $161614d4eac055e2$var$ellipsoids = {
    MERIT: {
        a: 6378137,
        rf: 298.257,
        ellipseName: 'MERIT 1983'
    },
    SGS85: {
        a: 6378136,
        rf: 298.257,
        ellipseName: 'Soviet Geodetic System 85'
    },
    GRS80: {
        a: 6378137,
        rf: 298.257222101,
        ellipseName: 'GRS 1980(IUGG, 1980)'
    },
    IAU76: {
        a: 6378140,
        rf: 298.257,
        ellipseName: 'IAU 1976'
    },
    airy: {
        a: 6377563.396,
        b: 6356256.91,
        ellipseName: 'Airy 1830'
    },
    APL4: {
        a: 6378137,
        rf: 298.25,
        ellipseName: 'Appl. Physics. 1965'
    },
    NWL9D: {
        a: 6378145,
        rf: 298.25,
        ellipseName: 'Naval Weapons Lab., 1965'
    },
    mod_airy: {
        a: 6377340.189,
        b: 6356034.446,
        ellipseName: 'Modified Airy'
    },
    andrae: {
        a: 6377104.43,
        rf: 300,
        ellipseName: 'Andrae 1876 (Den., Iclnd.)'
    },
    aust_SA: {
        a: 6378160,
        rf: 298.25,
        ellipseName: 'Australian Natl & S. Amer. 1969'
    },
    GRS67: {
        a: 6378160,
        rf: 298.247167427,
        ellipseName: 'GRS 67(IUGG 1967)'
    },
    bessel: {
        a: 6377397.155,
        rf: 299.1528128,
        ellipseName: 'Bessel 1841'
    },
    bess_nam: {
        a: 6377483.865,
        rf: 299.1528128,
        ellipseName: 'Bessel 1841 (Namibia)'
    },
    clrk66: {
        a: 6378206.4,
        b: 6356583.8,
        ellipseName: 'Clarke 1866'
    },
    clrk80: {
        a: 6378249.145,
        rf: 293.4663,
        ellipseName: 'Clarke 1880 mod.'
    },
    clrk80ign: {
        a: 6378249.2,
        b: 6356515,
        rf: 293.4660213,
        ellipseName: 'Clarke 1880 (IGN)'
    },
    clrk58: {
        a: 6378293.645208759,
        rf: 294.2606763692654,
        ellipseName: 'Clarke 1858'
    },
    CPM: {
        a: 6375738.7,
        rf: 334.29,
        ellipseName: 'Comm. des Poids et Mesures 1799'
    },
    delmbr: {
        a: 6376428,
        rf: 311.5,
        ellipseName: 'Delambre 1810 (Belgium)'
    },
    engelis: {
        a: 6378136.05,
        rf: 298.2566,
        ellipseName: 'Engelis 1985'
    },
    evrst30: {
        a: 6377276.345,
        rf: 300.8017,
        ellipseName: 'Everest 1830'
    },
    evrst48: {
        a: 6377304.063,
        rf: 300.8017,
        ellipseName: 'Everest 1948'
    },
    evrst56: {
        a: 6377301.243,
        rf: 300.8017,
        ellipseName: 'Everest 1956'
    },
    evrst69: {
        a: 6377295.664,
        rf: 300.8017,
        ellipseName: 'Everest 1969'
    },
    evrstSS: {
        a: 6377298.556,
        rf: 300.8017,
        ellipseName: 'Everest (Sabah & Sarawak)'
    },
    fschr60: {
        a: 6378166,
        rf: 298.3,
        ellipseName: 'Fischer (Mercury Datum) 1960'
    },
    fschr60m: {
        a: 6378155,
        rf: 298.3,
        ellipseName: 'Fischer 1960'
    },
    fschr68: {
        a: 6378150,
        rf: 298.3,
        ellipseName: 'Fischer 1968'
    },
    helmert: {
        a: 6378200,
        rf: 298.3,
        ellipseName: 'Helmert 1906'
    },
    hough: {
        a: 6378270,
        rf: 297,
        ellipseName: 'Hough'
    },
    intl: {
        a: 6378388,
        rf: 297,
        ellipseName: 'International 1909 (Hayford)'
    },
    kaula: {
        a: 6378163,
        rf: 298.24,
        ellipseName: 'Kaula 1961'
    },
    lerch: {
        a: 6378139,
        rf: 298.257,
        ellipseName: 'Lerch 1979'
    },
    mprts: {
        a: 6397300,
        rf: 191,
        ellipseName: 'Maupertius 1738'
    },
    new_intl: {
        a: 6378157.5,
        b: 6356772.2,
        ellipseName: 'New International 1967'
    },
    plessis: {
        a: 6376523,
        rf: 6355863,
        ellipseName: 'Plessis 1817 (France)'
    },
    krass: {
        a: 6378245,
        rf: 298.3,
        ellipseName: 'Krassovsky, 1942'
    },
    SEasia: {
        a: 6378155,
        b: 6356773.3205,
        ellipseName: 'Southeast Asia'
    },
    walbeck: {
        a: 6376896,
        b: 6355834.8467,
        ellipseName: 'Walbeck'
    },
    WGS60: {
        a: 6378165,
        rf: 298.3,
        ellipseName: 'WGS 60'
    },
    WGS66: {
        a: 6378145,
        rf: 298.25,
        ellipseName: 'WGS 66'
    },
    WGS7: {
        a: 6378135,
        rf: 298.26,
        ellipseName: 'WGS 72'
    },
    WGS84: {
        a: 6378137,
        rf: 298.257223563,
        ellipseName: 'WGS 84'
    },
    sphere: {
        a: 6370997,
        b: 6370997,
        ellipseName: 'Normal Sphere (r=6370997)'
    }
};
var $161614d4eac055e2$export$2e2bcd8739ae039 = $161614d4eac055e2$var$ellipsoids;



const $adb5c8d6b3f2cfc1$var$WGS84 = (0, $161614d4eac055e2$export$2e2bcd8739ae039).WGS84; // default ellipsoid
function $adb5c8d6b3f2cfc1$export$e3d7bf2ed2a7479f(a, b, rf, R_A) {
    var a2 = a * a; // used in geocentric
    var b2 = b * b; // used in geocentric
    var es = (a2 - b2) / a2; // e ^ 2
    var e = 0;
    if (R_A) {
        a *= 1 - es * ((0, $jDCGO.SIXTH) + es * ((0, $jDCGO.RA4) + es * (0, $jDCGO.RA6)));
        a2 = a * a;
        es = 0;
    } else e = Math.sqrt(es); // eccentricity
    var ep2 = (a2 - b2) / b2; // used in geocentric
    return {
        es: es,
        e: e,
        ep2: ep2
    };
}
function $adb5c8d6b3f2cfc1$export$b2690196de52b050(a, b, rf, ellps, sphere) {
    if (!a) {
        var ellipse = (0, $6e15fef3d69c3cec$export$2e2bcd8739ae039)((0, $161614d4eac055e2$export$2e2bcd8739ae039), ellps);
        if (!ellipse) ellipse = $adb5c8d6b3f2cfc1$var$WGS84;
        a = ellipse.a;
        b = ellipse.b;
        rf = ellipse.rf;
    }
    if (rf && !b) b = (1.0 - 1.0 / rf) * a;
    if (rf === 0 || Math.abs(a - b) < (0, $jDCGO.EPSLN)) {
        sphere = true;
        b = a;
    }
    return {
        a: a,
        b: b,
        rf: rf,
        sphere: sphere
    };
}


var $52a91c3464ce6c97$var$datums = {
    wgs84: {
        towgs84: '0,0,0',
        ellipse: 'WGS84',
        datumName: 'WGS84'
    },
    ch1903: {
        towgs84: '674.374,15.056,405.346',
        ellipse: 'bessel',
        datumName: 'swiss'
    },
    ggrs87: {
        towgs84: '-199.87,74.79,246.62',
        ellipse: 'GRS80',
        datumName: 'Greek_Geodetic_Reference_System_1987'
    },
    nad83: {
        towgs84: '0,0,0',
        ellipse: 'GRS80',
        datumName: 'North_American_Datum_1983'
    },
    nad27: {
        nadgrids: '@conus,@alaska,@ntv2_0.gsb,@ntv1_can.dat',
        ellipse: 'clrk66',
        datumName: 'North_American_Datum_1927'
    },
    potsdam: {
        towgs84: '598.1,73.7,418.2,0.202,0.045,-2.455,6.7',
        ellipse: 'bessel',
        datumName: 'Potsdam Rauenberg 1950 DHDN'
    },
    carthage: {
        towgs84: '-263.0,6.0,431.0',
        ellipse: 'clark80',
        datumName: 'Carthage 1934 Tunisia'
    },
    hermannskogel: {
        towgs84: '577.326,90.129,463.919,5.137,1.474,5.297,2.4232',
        ellipse: 'bessel',
        datumName: 'Hermannskogel'
    },
    mgi: {
        towgs84: '577.326,90.129,463.919,5.137,1.474,5.297,2.4232',
        ellipse: 'bessel',
        datumName: 'Militar-Geographische Institut'
    },
    osni52: {
        towgs84: '482.530,-130.596,564.557,-1.042,-0.214,-0.631,8.15',
        ellipse: 'airy',
        datumName: 'Irish National'
    },
    ire65: {
        towgs84: '482.530,-130.596,564.557,-1.042,-0.214,-0.631,8.15',
        ellipse: 'mod_airy',
        datumName: 'Ireland 1965'
    },
    rassadiran: {
        towgs84: '-133.63,-157.5,-158.62',
        ellipse: 'intl',
        datumName: 'Rassadiran'
    },
    nzgd49: {
        towgs84: '59.47,-5.04,187.44,0.47,-0.1,1.024,-4.5993',
        ellipse: 'intl',
        datumName: 'New Zealand Geodetic Datum 1949'
    },
    osgb36: {
        towgs84: '446.448,-125.157,542.060,0.1502,0.2470,0.8421,-20.4894',
        ellipse: 'airy',
        datumName: 'Ordnance Survey of Great Britain 1936'
    },
    s_jtsk: {
        towgs84: '589,76,480',
        ellipse: 'bessel',
        datumName: 'S-JTSK (Ferro)'
    },
    beduaram: {
        towgs84: '-106,-87,188',
        ellipse: 'clrk80',
        datumName: 'Beduaram'
    },
    gunung_segara: {
        towgs84: '-403,684,41',
        ellipse: 'bessel',
        datumName: 'Gunung Segara Jakarta'
    },
    rnb72: {
        towgs84: '106.869,-52.2978,103.724,-0.33657,0.456955,-1.84218,1',
        ellipse: 'intl',
        datumName: 'Reseau National Belge 1972'
    },
    EPSG_5451: {
        towgs84: '6.41,-49.05,-11.28,1.5657,0.5242,6.9718,-5.7649'
    },
    IGNF_LURESG: {
        towgs84: '-192.986,13.673,-39.309,-0.4099,-2.9332,2.6881,0.43'
    },
    EPSG_4614: {
        towgs84: '-119.4248,-303.65872,-11.00061,1.164298,0.174458,1.096259,3.657065'
    },
    EPSG_4615: {
        towgs84: '-494.088,-312.129,279.877,-1.423,-1.013,1.59,-0.748'
    },
    ESRI_37241: {
        towgs84: '-76.822,257.457,-12.817,2.136,-0.033,-2.392,-0.031'
    },
    ESRI_37249: {
        towgs84: '-440.296,58.548,296.265,1.128,10.202,4.559,-0.438'
    },
    ESRI_37245: {
        towgs84: '-511.151,-181.269,139.609,1.05,2.703,1.798,3.071'
    },
    EPSG_4178: {
        towgs84: '24.9,-126.4,-93.2,-0.063,-0.247,-0.041,1.01'
    },
    EPSG_4622: {
        towgs84: '-472.29,-5.63,-304.12,0.4362,-0.8374,0.2563,1.8984'
    },
    EPSG_4625: {
        towgs84: '126.93,547.94,130.41,-2.7867,5.1612,-0.8584,13.8227'
    },
    EPSG_5252: {
        towgs84: '0.023,0.036,-0.068,0.00176,0.00912,-0.01136,0.00439'
    },
    EPSG_4314: {
        towgs84: '597.1,71.4,412.1,0.894,0.068,-1.563,7.58'
    },
    EPSG_4282: {
        towgs84: '-178.3,-316.7,-131.5,5.278,6.077,10.979,19.166'
    },
    EPSG_4231: {
        towgs84: '-83.11,-97.38,-117.22,0.005693,-0.044698,0.044285,0.1218'
    },
    EPSG_4274: {
        towgs84: '-230.994,102.591,25.199,0.633,-0.239,0.9,1.95'
    },
    EPSG_4134: {
        towgs84: '-180.624,-225.516,173.919,-0.81,-1.898,8.336,16.71006'
    },
    EPSG_4254: {
        towgs84: '18.38,192.45,96.82,0.056,-0.142,-0.2,-0.0013'
    },
    EPSG_4159: {
        towgs84: '-194.513,-63.978,-25.759,-3.4027,3.756,-3.352,-0.9175'
    },
    EPSG_4687: {
        towgs84: '0.072,-0.507,-0.245,0.0183,-0.0003,0.007,-0.0093'
    },
    EPSG_4227: {
        towgs84: '-83.58,-397.54,458.78,-17.595,-2.847,4.256,3.225'
    },
    EPSG_4746: {
        towgs84: '599.4,72.4,419.2,-0.062,-0.022,-2.723,6.46'
    },
    EPSG_4745: {
        towgs84: '612.4,77,440.2,-0.054,0.057,-2.797,2.55'
    },
    EPSG_6311: {
        towgs84: '8.846,-4.394,-1.122,-0.00237,-0.146528,0.130428,0.783926'
    },
    EPSG_4289: {
        towgs84: '565.7381,50.4018,465.2904,-0.395026,0.330772,-1.876073,4.07244'
    },
    EPSG_4230: {
        towgs84: '-68.863,-134.888,-111.49,-0.53,-0.14,0.57,-3.4'
    },
    EPSG_4154: {
        towgs84: '-123.02,-158.95,-168.47'
    },
    EPSG_4156: {
        towgs84: '570.8,85.7,462.8,4.998,1.587,5.261,3.56'
    },
    EPSG_4299: {
        towgs84: '482.5,-130.6,564.6,-1.042,-0.214,-0.631,8.15'
    },
    EPSG_4179: {
        towgs84: '33.4,-146.6,-76.3,-0.359,-0.053,0.844,-0.84'
    },
    EPSG_4313: {
        towgs84: '-106.8686,52.2978,-103.7239,0.3366,-0.457,1.8422,-1.2747'
    },
    EPSG_4194: {
        towgs84: '163.511,127.533,-159.789'
    },
    EPSG_4195: {
        towgs84: '105,326,-102.5'
    },
    EPSG_4196: {
        towgs84: '-45,417,-3.5'
    },
    EPSG_4611: {
        towgs84: '-162.619,-276.959,-161.764,0.067753,-2.243648,-1.158828,-1.094246'
    },
    EPSG_4633: {
        towgs84: '137.092,131.66,91.475,-1.9436,-11.5993,-4.3321,-7.4824'
    },
    EPSG_4641: {
        towgs84: '-408.809,366.856,-412.987,1.8842,-0.5308,2.1655,-121.0993'
    },
    EPSG_4643: {
        towgs84: '-480.26,-438.32,-643.429,16.3119,20.1721,-4.0349,-111.7002'
    },
    EPSG_4300: {
        towgs84: '482.5,-130.6,564.6,-1.042,-0.214,-0.631,8.15'
    },
    EPSG_4188: {
        towgs84: '482.5,-130.6,564.6,-1.042,-0.214,-0.631,8.15'
    },
    EPSG_4660: {
        towgs84: '982.6087,552.753,-540.873,6.681627,-31.611492,-19.848161,16.805'
    },
    EPSG_4662: {
        towgs84: '97.295,-263.247,310.882,-1.5999,0.8386,3.1409,13.3259'
    },
    EPSG_3906: {
        towgs84: '577.88891,165.22205,391.18289,4.9145,-0.94729,-13.05098,7.78664'
    },
    EPSG_4307: {
        towgs84: '-209.3622,-87.8162,404.6198,0.0046,3.4784,0.5805,-1.4547'
    },
    EPSG_6892: {
        towgs84: '-76.269,-16.683,68.562,-6.275,10.536,-4.286,-13.686'
    },
    EPSG_4690: {
        towgs84: '221.597,152.441,176.523,2.403,1.3893,0.884,11.4648'
    },
    EPSG_4691: {
        towgs84: '218.769,150.75,176.75,3.5231,2.0037,1.288,10.9817'
    },
    EPSG_4629: {
        towgs84: '72.51,345.411,79.241,-1.5862,-0.8826,-0.5495,1.3653'
    },
    EPSG_4630: {
        towgs84: '165.804,216.213,180.26,-0.6251,-0.4515,-0.0721,7.4111'
    },
    EPSG_4692: {
        towgs84: '217.109,86.452,23.711,0.0183,-0.0003,0.007,-0.0093'
    },
    EPSG_9333: {
        towgs84: '0,0,0,-0.008393,0.000749,-0.010276,0'
    },
    EPSG_9059: {
        towgs84: '0,0,0'
    },
    EPSG_4312: {
        towgs84: '601.705,84.263,485.227,4.7354,1.3145,5.393,-2.3887'
    },
    EPSG_4123: {
        towgs84: '-96.062,-82.428,-121.753,4.801,0.345,-1.376,1.496'
    },
    EPSG_4309: {
        towgs84: '-124.45,183.74,44.64,-0.4384,0.5446,-0.9706,-2.1365'
    },
    ESRI_104106: {
        towgs84: '-283.088,-70.693,117.445,-1.157,0.059,-0.652,-4.058'
    },
    EPSG_4281: {
        towgs84: '-219.247,-73.802,269.529'
    },
    EPSG_4322: {
        towgs84: '0,0,4.5'
    },
    EPSG_4324: {
        towgs84: '0,0,1.9'
    },
    EPSG_4284: {
        towgs84: '43.822,-108.842,-119.585,1.455,-0.761,0.737,0.549'
    },
    EPSG_4277: {
        towgs84: '446.448,-125.157,542.06,0.15,0.247,0.842,-20.489'
    },
    EPSG_4207: {
        towgs84: '-282.1,-72.2,120,-1.529,0.145,-0.89,-4.46'
    },
    EPSG_4688: {
        towgs84: '347.175,1077.618,2623.677,33.9058,-70.6776,9.4013,186.0647'
    },
    EPSG_4689: {
        towgs84: '410.793,54.542,80.501,-2.5596,-2.3517,-0.6594,17.3218'
    },
    EPSG_4720: {
        towgs84: '0,0,4.5'
    },
    EPSG_4273: {
        towgs84: '278.3,93,474.5,7.889,0.05,-6.61,6.21'
    },
    EPSG_4240: {
        towgs84: '204.64,834.74,293.8'
    },
    EPSG_4817: {
        towgs84: '278.3,93,474.5,7.889,0.05,-6.61,6.21'
    },
    ESRI_104131: {
        towgs84: '426.62,142.62,460.09,4.98,4.49,-12.42,-17.1'
    },
    EPSG_4265: {
        towgs84: '-104.1,-49.1,-9.9,0.971,-2.917,0.714,-11.68'
    },
    EPSG_4263: {
        towgs84: '-111.92,-87.85,114.5,1.875,0.202,0.219,0.032'
    },
    EPSG_4298: {
        towgs84: '-689.5937,623.84046,-65.93566,-0.02331,1.17094,-0.80054,5.88536'
    },
    EPSG_4270: {
        towgs84: '-253.4392,-148.452,386.5267,0.15605,0.43,-0.1013,-0.0424'
    },
    EPSG_4229: {
        towgs84: '-121.8,98.1,-10.7'
    },
    EPSG_4220: {
        towgs84: '-55.5,-348,-229.2'
    },
    EPSG_4214: {
        towgs84: '12.646,-155.176,-80.863'
    },
    EPSG_4232: {
        towgs84: '-345,3,223'
    },
    EPSG_4238: {
        towgs84: '-1.977,-13.06,-9.993,0.364,0.254,0.689,-1.037'
    },
    EPSG_4168: {
        towgs84: '-170,33,326'
    },
    EPSG_4131: {
        towgs84: '199,931,318.9'
    },
    EPSG_4152: {
        towgs84: '-0.9102,2.0141,0.5602,0.029039,0.010065,0.010101,0'
    },
    EPSG_5228: {
        towgs84: '572.213,85.334,461.94,4.9732,1.529,5.2484,3.5378'
    },
    EPSG_8351: {
        towgs84: '485.021,169.465,483.839,7.786342,4.397554,4.102655,0'
    },
    EPSG_4683: {
        towgs84: '-127.62,-67.24,-47.04,-3.068,4.903,1.578,-1.06'
    },
    EPSG_4133: {
        towgs84: '0,0,0'
    },
    EPSG_7373: {
        towgs84: '0.819,-0.5762,-1.6446,-0.00378,-0.03317,0.00318,0.0693'
    },
    EPSG_9075: {
        towgs84: '-0.9102,2.0141,0.5602,0.029039,0.010065,0.010101,0'
    },
    EPSG_9072: {
        towgs84: '-0.9102,2.0141,0.5602,0.029039,0.010065,0.010101,0'
    },
    EPSG_9294: {
        towgs84: '1.16835,-1.42001,-2.24431,-0.00822,-0.05508,0.01818,0.23388'
    },
    EPSG_4212: {
        towgs84: '-267.434,173.496,181.814,-13.4704,8.7154,7.3926,14.7492'
    },
    EPSG_4191: {
        towgs84: '-44.183,-0.58,-38.489,2.3867,2.7072,-3.5196,-8.2703'
    },
    EPSG_4237: {
        towgs84: '52.684,-71.194,-13.975,-0.312,-0.1063,-0.3729,1.0191'
    },
    EPSG_4740: {
        towgs84: '-1.08,-0.27,-0.9'
    },
    EPSG_4124: {
        towgs84: '419.3836,99.3335,591.3451,0.850389,1.817277,-7.862238,-0.99496'
    },
    EPSG_5681: {
        towgs84: '584.9636,107.7175,413.8067,1.1155,0.2824,-3.1384,7.9922'
    },
    EPSG_4141: {
        towgs84: '23.772,17.49,17.859,-0.3132,-1.85274,1.67299,-5.4262'
    },
    EPSG_4204: {
        towgs84: '-85.645,-273.077,-79.708,2.289,-1.421,2.532,3.194'
    },
    EPSG_4319: {
        towgs84: '226.702,-193.337,-35.371,-2.229,-4.391,9.238,0.9798'
    },
    EPSG_4200: {
        towgs84: '24.82,-131.21,-82.66'
    },
    EPSG_4130: {
        towgs84: '0,0,0'
    },
    EPSG_4127: {
        towgs84: '-82.875,-57.097,-156.768,-2.158,1.524,-0.982,-0.359'
    },
    EPSG_4149: {
        towgs84: '674.374,15.056,405.346'
    },
    EPSG_4617: {
        towgs84: '-0.991,1.9072,0.5129,0.02579,0.00965,0.01166,0'
    },
    EPSG_4663: {
        towgs84: '-210.502,-66.902,-48.476,2.094,-15.067,-5.817,0.485'
    },
    EPSG_4664: {
        towgs84: '-211.939,137.626,58.3,-0.089,0.251,0.079,0.384'
    },
    EPSG_4665: {
        towgs84: '-105.854,165.589,-38.312,-0.003,-0.026,0.024,-0.048'
    },
    EPSG_4666: {
        towgs84: '631.392,-66.551,481.442,1.09,-4.445,-4.487,-4.43'
    },
    EPSG_4756: {
        towgs84: '-192.873,-39.382,-111.202,-0.00205,-0.0005,0.00335,0.0188'
    },
    EPSG_4723: {
        towgs84: '-179.483,-69.379,-27.584,-7.862,8.163,6.042,-13.925'
    },
    EPSG_4726: {
        towgs84: '8.853,-52.644,180.304,-0.393,-2.323,2.96,-24.081'
    },
    EPSG_4267: {
        towgs84: '-8.0,160.0,176.0'
    },
    EPSG_5365: {
        towgs84: '-0.16959,0.35312,0.51846,0.03385,-0.16325,0.03446,0.03693'
    },
    EPSG_4218: {
        towgs84: '304.5,306.5,-318.1'
    },
    EPSG_4242: {
        towgs84: '-33.722,153.789,94.959,-8.581,-4.478,4.54,8.95'
    },
    EPSG_4216: {
        towgs84: '-292.295,248.758,429.447,4.9971,2.99,6.6906,1.0289'
    },
    ESRI_104105: {
        towgs84: '631.392,-66.551,481.442,1.09,-4.445,-4.487,-4.43'
    },
    ESRI_104129: {
        towgs84: '0,0,0'
    },
    EPSG_4673: {
        towgs84: '174.05,-25.49,112.57'
    },
    EPSG_4202: {
        towgs84: '-124,-60,154'
    },
    EPSG_4203: {
        towgs84: '-117.763,-51.51,139.061,0.292,0.443,0.277,-0.191'
    },
    EPSG_3819: {
        towgs84: '595.48,121.69,515.35,4.115,-2.9383,0.853,-3.408'
    },
    EPSG_8694: {
        towgs84: '-93.799,-132.737,-219.073,-1.844,0.648,-6.37,-0.169'
    },
    EPSG_4145: {
        towgs84: '275.57,676.78,229.6'
    },
    EPSG_4283: {
        towgs84: '0.06155,-0.01087,-0.04019,0.039492,0.032722,0.032898,-0.009994'
    },
    EPSG_4317: {
        towgs84: '2.3287,-147.0425,-92.0802,-0.309248,0.324822,0.497299,5.689063'
    },
    EPSG_4272: {
        towgs84: '59.47,-5.04,187.44,0.47,-0.1,1.024,-4.5993'
    },
    EPSG_4248: {
        towgs84: '-307.7,265.3,-363.5'
    },
    EPSG_5561: {
        towgs84: '24,-121,-76'
    },
    EPSG_5233: {
        towgs84: '-0.293,766.95,87.713,0.195704,1.695068,3.473016,-0.039338'
    },
    ESRI_104130: {
        towgs84: '-86,-98,-119'
    },
    ESRI_104102: {
        towgs84: '682,-203,480'
    },
    ESRI_37207: {
        towgs84: '7,-10,-26'
    },
    EPSG_4675: {
        towgs84: '59.935,118.4,-10.871'
    },
    ESRI_104109: {
        towgs84: '-89.121,-348.182,260.871'
    },
    ESRI_104112: {
        towgs84: '-185.583,-230.096,281.361'
    },
    ESRI_104113: {
        towgs84: '25.1,-275.6,222.6'
    },
    IGNF_WGS72G: {
        towgs84: '0,12,6'
    },
    IGNF_NTFG: {
        towgs84: '-168,-60,320'
    },
    IGNF_EFATE57G: {
        towgs84: '-127,-769,472'
    },
    IGNF_PGP50G: {
        towgs84: '324.8,153.6,172.1'
    },
    IGNF_REUN47G: {
        towgs84: '94,-948,-1262'
    },
    IGNF_CSG67G: {
        towgs84: '-186,230,110'
    },
    IGNF_GUAD48G: {
        towgs84: '-467,-16,-300'
    },
    IGNF_TAHI51G: {
        towgs84: '162,117,154'
    },
    IGNF_TAHAAG: {
        towgs84: '65,342,77'
    },
    IGNF_NUKU72G: {
        towgs84: '84,274,65'
    },
    IGNF_PETRELS72G: {
        towgs84: '365,194,166'
    },
    IGNF_WALL78G: {
        towgs84: '253,-133,-127'
    },
    IGNF_MAYO50G: {
        towgs84: '-382,-59,-262'
    },
    IGNF_TANNAG: {
        towgs84: '-139,-967,436'
    },
    IGNF_IGN72G: {
        towgs84: '-13,-348,292'
    },
    IGNF_ATIGG: {
        towgs84: '1118,23,66'
    },
    IGNF_FANGA84G: {
        towgs84: '150.57,158.33,118.32'
    },
    IGNF_RUSAT84G: {
        towgs84: '202.13,174.6,-15.74'
    },
    IGNF_KAUE70G: {
        towgs84: '126.74,300.1,-75.49'
    },
    IGNF_MOP90G: {
        towgs84: '-10.8,-1.8,12.77'
    },
    IGNF_MHPF67G: {
        towgs84: '338.08,212.58,-296.17'
    },
    IGNF_TAHI79G: {
        towgs84: '160.61,116.05,153.69'
    },
    IGNF_ANAA92G: {
        towgs84: '1.5,3.84,4.81'
    },
    IGNF_MARQUI72G: {
        towgs84: '330.91,-13.92,58.56'
    },
    IGNF_APAT86G: {
        towgs84: '143.6,197.82,74.05'
    },
    IGNF_TUBU69G: {
        towgs84: '237.17,171.61,-77.84'
    },
    IGNF_STPM50G: {
        towgs84: '11.363,424.148,373.13'
    },
    EPSG_4150: {
        towgs84: '674.374,15.056,405.346'
    },
    EPSG_4754: {
        towgs84: '-208.4058,-109.8777,-2.5764'
    },
    ESRI_104101: {
        towgs84: '372.87,149.23,585.29'
    },
    EPSG_4693: {
        towgs84: '0,-0.15,0.68'
    },
    EPSG_6207: {
        towgs84: '293.17,726.18,245.36'
    },
    EPSG_4153: {
        towgs84: '-133.63,-157.5,-158.62'
    },
    EPSG_4132: {
        towgs84: '-241.54,-163.64,396.06'
    },
    EPSG_4221: {
        towgs84: '-154.5,150.7,100.4'
    },
    EPSG_4266: {
        towgs84: '-80.7,-132.5,41.1'
    },
    EPSG_4193: {
        towgs84: '-70.9,-151.8,-41.4'
    },
    EPSG_5340: {
        towgs84: '-0.41,0.46,-0.35'
    },
    EPSG_4246: {
        towgs84: '-294.7,-200.1,525.5'
    },
    EPSG_4318: {
        towgs84: '-3.2,-5.7,2.8'
    },
    EPSG_4121: {
        towgs84: '-199.87,74.79,246.62'
    },
    EPSG_4223: {
        towgs84: '-260.1,5.5,432.2'
    },
    EPSG_4158: {
        towgs84: '-0.465,372.095,171.736'
    },
    EPSG_4285: {
        towgs84: '-128.16,-282.42,21.93'
    },
    EPSG_4613: {
        towgs84: '-404.78,685.68,45.47'
    },
    EPSG_4607: {
        towgs84: '195.671,332.517,274.607'
    },
    EPSG_4475: {
        towgs84: '-381.788,-57.501,-256.673'
    },
    EPSG_4208: {
        towgs84: '-157.84,308.54,-146.6'
    },
    EPSG_4743: {
        towgs84: '70.995,-335.916,262.898'
    },
    EPSG_4710: {
        towgs84: '-323.65,551.39,-491.22'
    },
    EPSG_7881: {
        towgs84: '-0.077,0.079,0.086'
    },
    EPSG_4682: {
        towgs84: '283.729,735.942,261.143'
    },
    EPSG_4739: {
        towgs84: '-156,-271,-189'
    },
    EPSG_4679: {
        towgs84: '-80.01,253.26,291.19'
    },
    EPSG_4750: {
        towgs84: '-56.263,16.136,-22.856'
    },
    EPSG_4644: {
        towgs84: '-10.18,-350.43,291.37'
    },
    EPSG_4695: {
        towgs84: '-103.746,-9.614,-255.95'
    },
    EPSG_4292: {
        towgs84: '-355,21,72'
    },
    EPSG_4302: {
        towgs84: '-61.702,284.488,472.052'
    },
    EPSG_4143: {
        towgs84: '-124.76,53,466.79'
    },
    EPSG_4606: {
        towgs84: '-153,153,307'
    },
    EPSG_4699: {
        towgs84: '-770.1,158.4,-498.2'
    },
    EPSG_4247: {
        towgs84: '-273.5,110.6,-357.9'
    },
    EPSG_4160: {
        towgs84: '8.88,184.86,106.69'
    },
    EPSG_4161: {
        towgs84: '-233.43,6.65,173.64'
    },
    EPSG_9251: {
        towgs84: '-9.5,122.9,138.2'
    },
    EPSG_9253: {
        towgs84: '-78.1,101.6,133.3'
    },
    EPSG_4297: {
        towgs84: '-198.383,-240.517,-107.909'
    },
    EPSG_4269: {
        towgs84: '0,0,0'
    },
    EPSG_4301: {
        towgs84: '-147,506,687'
    },
    EPSG_4618: {
        towgs84: '-59,-11,-52'
    },
    EPSG_4612: {
        towgs84: '0,0,0'
    },
    EPSG_4678: {
        towgs84: '44.585,-131.212,-39.544'
    },
    EPSG_4250: {
        towgs84: '-130,29,364'
    },
    EPSG_4144: {
        towgs84: '214,804,268'
    },
    EPSG_4147: {
        towgs84: '-17.51,-108.32,-62.39'
    },
    EPSG_4259: {
        towgs84: '-254.1,-5.36,-100.29'
    },
    EPSG_4164: {
        towgs84: '-76,-138,67'
    },
    EPSG_4211: {
        towgs84: '-378.873,676.002,-46.255'
    },
    EPSG_4182: {
        towgs84: '-422.651,-172.995,84.02'
    },
    EPSG_4224: {
        towgs84: '-143.87,243.37,-33.52'
    },
    EPSG_4225: {
        towgs84: '-205.57,168.77,-4.12'
    },
    EPSG_5527: {
        towgs84: '-67.35,3.88,-38.22'
    },
    EPSG_4752: {
        towgs84: '98,390,-22'
    },
    EPSG_4310: {
        towgs84: '-30,190,89'
    },
    EPSG_9248: {
        towgs84: '-192.26,65.72,132.08'
    },
    EPSG_4680: {
        towgs84: '124.5,-63.5,-281'
    },
    EPSG_4701: {
        towgs84: '-79.9,-158,-168.9'
    },
    EPSG_4706: {
        towgs84: '-146.21,112.63,4.05'
    },
    EPSG_4805: {
        towgs84: '682,-203,480'
    },
    EPSG_4201: {
        towgs84: '-165,-11,206'
    },
    EPSG_4210: {
        towgs84: '-157,-2,-299'
    },
    EPSG_4183: {
        towgs84: '-104,167,-38'
    },
    EPSG_4139: {
        towgs84: '11,72,-101'
    },
    EPSG_4668: {
        towgs84: '-86,-98,-119'
    },
    EPSG_4717: {
        towgs84: '-2,151,181'
    },
    EPSG_4732: {
        towgs84: '102,52,-38'
    },
    EPSG_4280: {
        towgs84: '-377,681,-50'
    },
    EPSG_4209: {
        towgs84: '-138,-105,-289'
    },
    EPSG_4261: {
        towgs84: '31,146,47'
    },
    EPSG_4658: {
        towgs84: '-73,46,-86'
    },
    EPSG_4721: {
        towgs84: '265.025,384.929,-194.046'
    },
    EPSG_4222: {
        towgs84: '-136,-108,-292'
    },
    EPSG_4601: {
        towgs84: '-255,-15,71'
    },
    EPSG_4602: {
        towgs84: '725,685,536'
    },
    EPSG_4603: {
        towgs84: '72,213.7,93'
    },
    EPSG_4605: {
        towgs84: '9,183,236'
    },
    EPSG_4621: {
        towgs84: '137,248,-430'
    },
    EPSG_4657: {
        towgs84: '-28,199,5'
    },
    EPSG_4316: {
        towgs84: '103.25,-100.4,-307.19'
    },
    EPSG_4642: {
        towgs84: '-13,-348,292'
    },
    EPSG_4698: {
        towgs84: '145,-187,103'
    },
    EPSG_4192: {
        towgs84: '-206.1,-174.7,-87.7'
    },
    EPSG_4311: {
        towgs84: '-265,120,-358'
    },
    EPSG_4135: {
        towgs84: '58,-283,-182'
    },
    ESRI_104138: {
        towgs84: '198,-226,-347'
    },
    EPSG_4245: {
        towgs84: '-11,851,5'
    },
    EPSG_4142: {
        towgs84: '-125,53,467'
    },
    EPSG_4213: {
        towgs84: '-106,-87,188'
    },
    EPSG_4253: {
        towgs84: '-133,-77,-51'
    },
    EPSG_4129: {
        towgs84: '-132,-110,-335'
    },
    EPSG_4713: {
        towgs84: '-77,-128,142'
    },
    EPSG_4239: {
        towgs84: '217,823,299'
    },
    EPSG_4146: {
        towgs84: '295,736,257'
    },
    EPSG_4155: {
        towgs84: '-83,37,124'
    },
    EPSG_4165: {
        towgs84: '-173,253,27'
    },
    EPSG_4672: {
        towgs84: '175,-38,113'
    },
    EPSG_4236: {
        towgs84: '-637,-549,-203'
    },
    EPSG_4251: {
        towgs84: '-90,40,88'
    },
    EPSG_4271: {
        towgs84: '-2,374,172'
    },
    EPSG_4175: {
        towgs84: '-88,4,101'
    },
    EPSG_4716: {
        towgs84: '298,-304,-375'
    },
    EPSG_4315: {
        towgs84: '-23,259,-9'
    },
    EPSG_4744: {
        towgs84: '-242.2,-144.9,370.3'
    },
    EPSG_4244: {
        towgs84: '-97,787,86'
    },
    EPSG_4293: {
        towgs84: '616,97,-251'
    },
    EPSG_4714: {
        towgs84: '-127,-769,472'
    },
    EPSG_4736: {
        towgs84: '260,12,-147'
    },
    EPSG_6883: {
        towgs84: '-235,-110,393'
    },
    EPSG_6894: {
        towgs84: '-63,176,185'
    },
    EPSG_4205: {
        towgs84: '-43,-163,45'
    },
    EPSG_4256: {
        towgs84: '41,-220,-134'
    },
    EPSG_4262: {
        towgs84: '639,405,60'
    },
    EPSG_4604: {
        towgs84: '174,359,365'
    },
    EPSG_4169: {
        towgs84: '-115,118,426'
    },
    EPSG_4620: {
        towgs84: '-106,-129,165'
    },
    EPSG_4184: {
        towgs84: '-203,141,53'
    },
    EPSG_4616: {
        towgs84: '-289,-124,60'
    },
    EPSG_9403: {
        towgs84: '-307,-92,127'
    },
    EPSG_4684: {
        towgs84: '-133,-321,50'
    },
    EPSG_4708: {
        towgs84: '-491,-22,435'
    },
    EPSG_4707: {
        towgs84: '114,-116,-333'
    },
    EPSG_4709: {
        towgs84: '145,75,-272'
    },
    EPSG_4712: {
        towgs84: '-205,107,53'
    },
    EPSG_4711: {
        towgs84: '124,-234,-25'
    },
    EPSG_4718: {
        towgs84: '230,-199,-752'
    },
    EPSG_4719: {
        towgs84: '211,147,111'
    },
    EPSG_4724: {
        towgs84: '208,-435,-229'
    },
    EPSG_4725: {
        towgs84: '189,-79,-202'
    },
    EPSG_4735: {
        towgs84: '647,1777,-1124'
    },
    EPSG_4722: {
        towgs84: '-794,119,-298'
    },
    EPSG_4728: {
        towgs84: '-307,-92,127'
    },
    EPSG_4734: {
        towgs84: '-632,438,-609'
    },
    EPSG_4727: {
        towgs84: '912,-58,1227'
    },
    EPSG_4729: {
        towgs84: '185,165,42'
    },
    EPSG_4730: {
        towgs84: '170,42,84'
    },
    EPSG_4733: {
        towgs84: '276,-57,149'
    },
    ESRI_37218: {
        towgs84: '230,-199,-752'
    },
    ESRI_37240: {
        towgs84: '-7,215,225'
    },
    ESRI_37221: {
        towgs84: '252,-209,-751'
    },
    ESRI_4305: {
        towgs84: '-123,-206,219'
    },
    ESRI_104139: {
        towgs84: '-73,-247,227'
    },
    EPSG_4748: {
        towgs84: '51,391,-36'
    },
    EPSG_4219: {
        towgs84: '-384,664,-48'
    },
    EPSG_4255: {
        towgs84: '-333,-222,114'
    },
    EPSG_4257: {
        towgs84: '-587.8,519.75,145.76'
    },
    EPSG_4646: {
        towgs84: '-963,510,-359'
    },
    EPSG_6881: {
        towgs84: '-24,-203,268'
    },
    EPSG_6882: {
        towgs84: '-183,-15,273'
    },
    EPSG_4715: {
        towgs84: '-104,-129,239'
    },
    IGNF_RGF93GDD: {
        towgs84: '0,0,0'
    },
    IGNF_RGM04GDD: {
        towgs84: '0,0,0'
    },
    IGNF_RGSPM06GDD: {
        towgs84: '0,0,0'
    },
    IGNF_RGTAAF07GDD: {
        towgs84: '0,0,0'
    },
    IGNF_RGFG95GDD: {
        towgs84: '0,0,0'
    },
    IGNF_RGNCG: {
        towgs84: '0,0,0'
    },
    IGNF_RGPFGDD: {
        towgs84: '0,0,0'
    },
    IGNF_ETRS89G: {
        towgs84: '0,0,0'
    },
    IGNF_RGR92GDD: {
        towgs84: '0,0,0'
    },
    EPSG_4173: {
        towgs84: '0,0,0'
    },
    EPSG_4180: {
        towgs84: '0,0,0'
    },
    EPSG_4619: {
        towgs84: '0,0,0'
    },
    EPSG_4667: {
        towgs84: '0,0,0'
    },
    EPSG_4075: {
        towgs84: '0,0,0'
    },
    EPSG_6706: {
        towgs84: '0,0,0'
    },
    EPSG_7798: {
        towgs84: '0,0,0'
    },
    EPSG_4661: {
        towgs84: '0,0,0'
    },
    EPSG_4669: {
        towgs84: '0,0,0'
    },
    EPSG_8685: {
        towgs84: '0,0,0'
    },
    EPSG_4151: {
        towgs84: '0,0,0'
    },
    EPSG_9702: {
        towgs84: '0,0,0'
    },
    EPSG_4758: {
        towgs84: '0,0,0'
    },
    EPSG_4761: {
        towgs84: '0,0,0'
    },
    EPSG_4765: {
        towgs84: '0,0,0'
    },
    EPSG_8997: {
        towgs84: '0,0,0'
    },
    EPSG_4023: {
        towgs84: '0,0,0'
    },
    EPSG_4670: {
        towgs84: '0,0,0'
    },
    EPSG_4694: {
        towgs84: '0,0,0'
    },
    EPSG_4148: {
        towgs84: '0,0,0'
    },
    EPSG_4163: {
        towgs84: '0,0,0'
    },
    EPSG_4167: {
        towgs84: '0,0,0'
    },
    EPSG_4189: {
        towgs84: '0,0,0'
    },
    EPSG_4190: {
        towgs84: '0,0,0'
    },
    EPSG_4176: {
        towgs84: '0,0,0'
    },
    EPSG_4659: {
        towgs84: '0,0,0'
    },
    EPSG_3824: {
        towgs84: '0,0,0'
    },
    EPSG_3889: {
        towgs84: '0,0,0'
    },
    EPSG_4046: {
        towgs84: '0,0,0'
    },
    EPSG_4081: {
        towgs84: '0,0,0'
    },
    EPSG_4558: {
        towgs84: '0,0,0'
    },
    EPSG_4483: {
        towgs84: '0,0,0'
    },
    EPSG_5013: {
        towgs84: '0,0,0'
    },
    EPSG_5264: {
        towgs84: '0,0,0'
    },
    EPSG_5324: {
        towgs84: '0,0,0'
    },
    EPSG_5354: {
        towgs84: '0,0,0'
    },
    EPSG_5371: {
        towgs84: '0,0,0'
    },
    EPSG_5373: {
        towgs84: '0,0,0'
    },
    EPSG_5381: {
        towgs84: '0,0,0'
    },
    EPSG_5393: {
        towgs84: '0,0,0'
    },
    EPSG_5489: {
        towgs84: '0,0,0'
    },
    EPSG_5593: {
        towgs84: '0,0,0'
    },
    EPSG_6135: {
        towgs84: '0,0,0'
    },
    EPSG_6365: {
        towgs84: '0,0,0'
    },
    EPSG_5246: {
        towgs84: '0,0,0'
    },
    EPSG_7886: {
        towgs84: '0,0,0'
    },
    EPSG_8431: {
        towgs84: '0,0,0'
    },
    EPSG_8427: {
        towgs84: '0,0,0'
    },
    EPSG_8699: {
        towgs84: '0,0,0'
    },
    EPSG_8818: {
        towgs84: '0,0,0'
    },
    EPSG_4757: {
        towgs84: '0,0,0'
    },
    EPSG_9140: {
        towgs84: '0,0,0'
    },
    EPSG_8086: {
        towgs84: '0,0,0'
    },
    EPSG_4686: {
        towgs84: '0,0,0'
    },
    EPSG_4737: {
        towgs84: '0,0,0'
    },
    EPSG_4702: {
        towgs84: '0,0,0'
    },
    EPSG_4747: {
        towgs84: '0,0,0'
    },
    EPSG_4749: {
        towgs84: '0,0,0'
    },
    EPSG_4674: {
        towgs84: '0,0,0'
    },
    EPSG_4755: {
        towgs84: '0,0,0'
    },
    EPSG_4759: {
        towgs84: '0,0,0'
    },
    EPSG_4762: {
        towgs84: '0,0,0'
    },
    EPSG_4763: {
        towgs84: '0,0,0'
    },
    EPSG_4764: {
        towgs84: '0,0,0'
    },
    EPSG_4166: {
        towgs84: '0,0,0'
    },
    EPSG_4170: {
        towgs84: '0,0,0'
    },
    EPSG_5546: {
        towgs84: '0,0,0'
    },
    EPSG_7844: {
        towgs84: '0,0,0'
    },
    EPSG_4818: {
        towgs84: '589,76,480'
    },
    EPSG_10328: {
        towgs84: '0,0,0'
    },
    EPSG_9782: {
        towgs84: '0,0,0'
    },
    EPSG_9777: {
        towgs84: '0,0,0'
    },
    EPSG_10690: {
        towgs84: '0,0,0'
    },
    EPSG_10639: {
        towgs84: '0,0,0'
    },
    EPSG_10739: {
        towgs84: '0,0,0'
    },
    EPSG_7686: {
        towgs84: '0,0,0'
    },
    EPSG_8900: {
        towgs84: '0,0,0'
    },
    EPSG_5886: {
        towgs84: '0,0,0'
    },
    EPSG_7683: {
        towgs84: '0,0,0'
    },
    EPSG_6668: {
        towgs84: '0,0,0'
    },
    EPSG_20046: {
        towgs84: '0,0,0'
    },
    EPSG_10299: {
        towgs84: '0,0,0'
    },
    EPSG_10310: {
        towgs84: '0,0,0'
    },
    EPSG_10475: {
        towgs84: '0,0,0'
    },
    EPSG_4742: {
        towgs84: '0,0,0'
    },
    EPSG_10671: {
        towgs84: '0,0,0'
    },
    EPSG_10762: {
        towgs84: '0,0,0'
    },
    EPSG_10725: {
        towgs84: '0,0,0'
    },
    EPSG_10791: {
        towgs84: '0,0,0'
    },
    EPSG_10800: {
        towgs84: '0,0,0'
    },
    EPSG_10305: {
        towgs84: '0,0,0'
    },
    EPSG_10941: {
        towgs84: '0,0,0'
    },
    EPSG_10968: {
        towgs84: '0,0,0'
    },
    EPSG_10875: {
        towgs84: '0,0,0'
    },
    EPSG_6318: {
        towgs84: '0,0,0'
    },
    EPSG_10910: {
        towgs84: '0,0,0'
    }
};
for(var $52a91c3464ce6c97$var$key in $52a91c3464ce6c97$var$datums){
    var $52a91c3464ce6c97$var$datum = $52a91c3464ce6c97$var$datums[$52a91c3464ce6c97$var$key];
    if (!$52a91c3464ce6c97$var$datum.datumName) continue;
    $52a91c3464ce6c97$var$datums[$52a91c3464ce6c97$var$datum.datumName] = $52a91c3464ce6c97$var$datum;
}
var $52a91c3464ce6c97$export$2e2bcd8739ae039 = $52a91c3464ce6c97$var$datums;



var $jDCGO = parcelRequire("jDCGO");
function $9f20925dcb5fa64b$var$datum(datumCode, datum_params, a, b, es, ep2, nadgrids) {
    var out = {};
    if (datumCode === undefined || datumCode === 'none') out.datum_type = (0, $jDCGO.PJD_NODATUM);
    else out.datum_type = (0, $jDCGO.PJD_WGS84);
    if (datum_params) {
        out.datum_params = datum_params.map(parseFloat);
        if (out.datum_params[0] !== 0 || out.datum_params[1] !== 0 || out.datum_params[2] !== 0) out.datum_type = (0, $jDCGO.PJD_3PARAM);
        if (out.datum_params.length > 3) {
            if (out.datum_params[3] !== 0 || out.datum_params[4] !== 0 || out.datum_params[5] !== 0 || out.datum_params[6] !== 0) {
                out.datum_type = (0, $jDCGO.PJD_7PARAM);
                out.datum_params[3] *= (0, $jDCGO.SEC_TO_RAD);
                out.datum_params[4] *= (0, $jDCGO.SEC_TO_RAD);
                out.datum_params[5] *= (0, $jDCGO.SEC_TO_RAD);
                out.datum_params[6] = out.datum_params[6] / 1000000.0 + 1.0;
            }
        }
    }
    if (nadgrids) {
        out.datum_type = (0, $jDCGO.PJD_GRIDSHIFT);
        out.grids = nadgrids;
    }
    out.a = a; // datum object also uses these values
    out.b = b;
    out.es = es;
    out.ep2 = ep2;
    return out;
}
var $9f20925dcb5fa64b$export$2e2bcd8739ae039 = $9f20925dcb5fa64b$var$datum;



/**
 * Resources for details of NTv2 file formats:
 * - https://web.archive.org/web/20140127204822if_/http://www.mgs.gov.on.ca:80/stdprodconsume/groups/content/@mgs/@iandit/documents/resourcelist/stel02_047447.pdf
 * - http://mimaka.com/help/gs/html/004_NTV2%20Data%20Format.htm
 */ /**
 * @typedef {Object} NadgridInfo
 * @property {string} name The name of the NAD grid or 'null' if not specified.
 * @property {boolean} mandatory Indicates if the grid is mandatory (true) or optional (false).
 * @property {*} grid The loaded NAD grid object, or null if not loaded or not applicable.
 * @property {boolean} isNull True if the grid is explicitly 'null', otherwise false.
 */ /**
 * @typedef {Object} NTV2GridOptions
 * @property {boolean} [includeErrorFields=true] Whether to include error fields in the subgrids.
 */ /**
 * @typedef {Object} NadgridHeader
 * @property {number} [nFields] Number of fields in the header.
 * @property {number} [nSubgridFields] Number of fields in each subgrid header.
 * @property {number} nSubgrids Number of subgrids in the file.
 * @property {string} [shiftType] Type of shift (e.g., "SECONDS").
 * @property {number} [fromSemiMajorAxis] Source ellipsoid semi-major axis.
 * @property {number} [fromSemiMinorAxis] Source ellipsoid semi-minor axis.
 * @property {number} [toSemiMajorAxis] Target ellipsoid semi-major axis.
 * @property {number} [toSemiMinorAxis] Target ellipsoid semi-minor axis.
 */ /**
 * @typedef {Object} Subgrid
 * @property {Array<number>} ll Lower left corner of the grid in radians [longitude, latitude].
 * @property {Array<number>} del Grid spacing in radians [longitude interval, latitude interval].
 * @property {Array<number>} lim Number of columns in the grid [longitude columns, latitude columns].
 * @property {number} [count] Total number of grid nodes.
 * @property {Array} cvs Mapped node values for the grid.
 */ /** @typedef {{header: NadgridHeader, subgrids: Array<Subgrid>}} NADGrid */ /**
 * @typedef {Object} GeoTIFF
 * @property {() => Promise<number>} getImageCount - Returns the number of images in the GeoTIFF.
 * @property {(index: number) => Promise<GeoTIFFImage>} getImage - Returns a GeoTIFFImage for the given index.
 */ /**
 * @typedef {Object} GeoTIFFImage
 * @property {() => number} getWidth - Returns the width of the image.
 * @property {() => number} getHeight - Returns the height of the image.
 * @property {() => number[]} getBoundingBox - Returns the bounding box as [minX, minY, maxX, maxY] in degrees.
 * @property {() => Promise<ArrayLike<ArrayLike<number>>>} readRasters - Returns the raster data as an array of bands.
 * @property {Object} fileDirectory - The file directory object containing metadata.
 * @property {Object} fileDirectory.ModelPixelScale - The pixel scale array [scaleX, scaleY, scaleZ] in degrees.
 */ var $9262fced509c4a24$var$loadedNadgrids = {};
function $9262fced509c4a24$export$2e2bcd8739ae039(key, data, options) {
    if (data instanceof ArrayBuffer) return $9262fced509c4a24$var$readNTV2Grid(key, data, options);
    return {
        ready: $9262fced509c4a24$var$readGeotiffGrid(key, data)
    };
}
/**
 * @param {string} key The key to associate with the loaded grid.
 * @param {ArrayBuffer} data The NTv2 grid data as an ArrayBuffer.
 * @param {NTV2GridOptions} [options] Optional parameters for loading the grid.
 * @returns {NADGrid} The loaded NAD grid information.
 */ function $9262fced509c4a24$var$readNTV2Grid(key, data, options) {
    var includeErrorFields = true;
    if (options !== undefined && options.includeErrorFields === false) includeErrorFields = false;
    var view = new DataView(data);
    var isLittleEndian = $9262fced509c4a24$var$detectLittleEndian(view);
    var header = $9262fced509c4a24$var$readHeader(view, isLittleEndian);
    var subgrids = $9262fced509c4a24$var$readSubgrids(view, header, isLittleEndian, includeErrorFields);
    var nadgrid = {
        header: header,
        subgrids: subgrids
    };
    $9262fced509c4a24$var$loadedNadgrids[key] = nadgrid;
    return nadgrid;
}
/**
 * @param {string} key The key to associate with the loaded grid.
 * @param {GeoTIFF} tiff The GeoTIFF instance to read the grid from.
 * @returns {Promise<NADGrid>} A promise that resolves to the loaded NAD grid information.
 */ async function $9262fced509c4a24$var$readGeotiffGrid(key, tiff) {
    var subgrids = [];
    var subGridCount = await tiff.getImageCount();
    // proj produced tiff grid shift files appear to organize lower res subgrids first, higher res/ child subgrids last.
    for(var subgridIndex = subGridCount - 1; subgridIndex >= 0; subgridIndex--){
        var image = await tiff.getImage(subgridIndex);
        var rasters = await image.readRasters();
        var data = rasters;
        var lim = [
            image.getWidth(),
            image.getHeight()
        ];
        var imageBBoxRadians = image.getBoundingBox().map($9262fced509c4a24$var$degreesToRadians);
        var del = [
            image.fileDirectory.ModelPixelScale[0],
            image.fileDirectory.ModelPixelScale[1]
        ].map($9262fced509c4a24$var$degreesToRadians);
        var maxX = imageBBoxRadians[0] + (lim[0] - 1) * del[0];
        var minY = imageBBoxRadians[3] - (lim[1] - 1) * del[1];
        var latitudeOffsetBand = data[0];
        var longitudeOffsetBand = data[1];
        var nodes = [];
        for(let i = lim[1] - 1; i >= 0; i--)for(let j = lim[0] - 1; j >= 0; j--){
            var index = i * lim[0] + j;
            nodes.push([
                -$9262fced509c4a24$var$secondsToRadians(longitudeOffsetBand[index]),
                $9262fced509c4a24$var$secondsToRadians(latitudeOffsetBand[index])
            ]);
        }
        subgrids.push({
            del: del,
            lim: lim,
            ll: [
                -maxX,
                minY
            ],
            cvs: nodes
        });
    }
    var tifGrid = {
        header: {
            nSubgrids: subGridCount
        },
        subgrids: subgrids
    };
    $9262fced509c4a24$var$loadedNadgrids[key] = tifGrid;
    return tifGrid;
}
function $9262fced509c4a24$export$31c4d9288d81329a(nadgrids) {
    // Format details: http://proj.maptools.org/gen_parms.html
    if (nadgrids === undefined) return null;
    var grids = nadgrids.split(',');
    return grids.map($9262fced509c4a24$var$parseNadgridString);
}
/**
 * @param {string} value The nadgrid string to get information for.
 * @returns {NadgridInfo|null} An object with grid information, or null if the input is empty.
 */ function $9262fced509c4a24$var$parseNadgridString(value) {
    if (value.length === 0) return null;
    var optional = value[0] === '@';
    if (optional) value = value.slice(1);
    if (value === 'null') return {
        name: 'null',
        mandatory: !optional,
        grid: null,
        isNull: true
    };
    return {
        name: value,
        mandatory: !optional,
        grid: $9262fced509c4a24$var$loadedNadgrids[value] || null,
        isNull: false
    };
}
function $9262fced509c4a24$var$degreesToRadians(degrees) {
    return degrees * Math.PI / 180;
}
function $9262fced509c4a24$var$secondsToRadians(seconds) {
    return seconds / 3600 * Math.PI / 180;
}
function $9262fced509c4a24$var$detectLittleEndian(view) {
    var nFields = view.getInt32(8, false);
    if (nFields === 11) return false;
    nFields = view.getInt32(8, true);
    if (nFields !== 11) console.warn('Failed to detect nadgrid endian-ness, defaulting to little-endian');
    return true;
}
function $9262fced509c4a24$var$readHeader(view, isLittleEndian) {
    return {
        nFields: view.getInt32(8, isLittleEndian),
        nSubgridFields: view.getInt32(24, isLittleEndian),
        nSubgrids: view.getInt32(40, isLittleEndian),
        shiftType: $9262fced509c4a24$var$decodeString(view, 56, 64).trim(),
        fromSemiMajorAxis: view.getFloat64(120, isLittleEndian),
        fromSemiMinorAxis: view.getFloat64(136, isLittleEndian),
        toSemiMajorAxis: view.getFloat64(152, isLittleEndian),
        toSemiMinorAxis: view.getFloat64(168, isLittleEndian)
    };
}
function $9262fced509c4a24$var$decodeString(view, start, end) {
    return String.fromCharCode.apply(null, new Uint8Array(view.buffer.slice(start, end)));
}
function $9262fced509c4a24$var$readSubgrids(view, header, isLittleEndian, includeErrorFields) {
    var gridOffset = 176;
    var grids = [];
    for(var i = 0; i < header.nSubgrids; i++){
        var subHeader = $9262fced509c4a24$var$readGridHeader(view, gridOffset, isLittleEndian);
        var nodes = $9262fced509c4a24$var$readGridNodes(view, gridOffset, subHeader, isLittleEndian, includeErrorFields);
        var lngColumnCount = Math.round(1 + (subHeader.upperLongitude - subHeader.lowerLongitude) / subHeader.longitudeInterval);
        var latColumnCount = Math.round(1 + (subHeader.upperLatitude - subHeader.lowerLatitude) / subHeader.latitudeInterval);
        // Proj4 operates on radians whereas the coordinates are in seconds in the grid
        grids.push({
            ll: [
                $9262fced509c4a24$var$secondsToRadians(subHeader.lowerLongitude),
                $9262fced509c4a24$var$secondsToRadians(subHeader.lowerLatitude)
            ],
            del: [
                $9262fced509c4a24$var$secondsToRadians(subHeader.longitudeInterval),
                $9262fced509c4a24$var$secondsToRadians(subHeader.latitudeInterval)
            ],
            lim: [
                lngColumnCount,
                latColumnCount
            ],
            count: subHeader.gridNodeCount,
            cvs: $9262fced509c4a24$var$mapNodes(nodes)
        });
        var rowSize = 16;
        if (includeErrorFields === false) rowSize = 8;
        gridOffset += 176 + subHeader.gridNodeCount * rowSize;
    }
    return grids;
}
/**
 * @param {*} nodes
 * @returns Array<Array<number>>
 */ function $9262fced509c4a24$var$mapNodes(nodes) {
    return nodes.map(function(r) {
        return [
            $9262fced509c4a24$var$secondsToRadians(r.longitudeShift),
            $9262fced509c4a24$var$secondsToRadians(r.latitudeShift)
        ];
    });
}
function $9262fced509c4a24$var$readGridHeader(view, offset, isLittleEndian) {
    return {
        name: $9262fced509c4a24$var$decodeString(view, offset + 8, offset + 16).trim(),
        parent: $9262fced509c4a24$var$decodeString(view, offset + 24, offset + 24 + 8).trim(),
        lowerLatitude: view.getFloat64(offset + 72, isLittleEndian),
        upperLatitude: view.getFloat64(offset + 88, isLittleEndian),
        lowerLongitude: view.getFloat64(offset + 104, isLittleEndian),
        upperLongitude: view.getFloat64(offset + 120, isLittleEndian),
        latitudeInterval: view.getFloat64(offset + 136, isLittleEndian),
        longitudeInterval: view.getFloat64(offset + 152, isLittleEndian),
        gridNodeCount: view.getInt32(offset + 168, isLittleEndian)
    };
}
function $9262fced509c4a24$var$readGridNodes(view, offset, gridHeader, isLittleEndian, includeErrorFields) {
    var nodesOffset = offset + 176;
    var gridRecordLength = 16;
    if (includeErrorFields === false) gridRecordLength = 8;
    var gridShiftRecords = [];
    for(var i = 0; i < gridHeader.gridNodeCount; i++){
        var record = {
            latitudeShift: view.getFloat32(nodesOffset + i * gridRecordLength, isLittleEndian),
            longitudeShift: view.getFloat32(nodesOffset + i * gridRecordLength + 4, isLittleEndian)
        };
        if (includeErrorFields !== false) {
            record.latitudeAccuracy = view.getFloat32(nodesOffset + i * gridRecordLength + 8, isLittleEndian);
            record.longitudeAccuracy = view.getFloat32(nodesOffset + i * gridRecordLength + 12, isLittleEndian);
        }
        gridShiftRecords.push(record);
    }
    return gridShiftRecords;
}


/**
 * @typedef {Object} DatumDefinition
 * @property {number} datum_type - The type of datum.
 * @property {number} a - Semi-major axis of the ellipsoid.
 * @property {number} b - Semi-minor axis of the ellipsoid.
 * @property {number} es - Eccentricity squared of the ellipsoid.
 * @property {number} ep2 - Second eccentricity squared of the ellipsoid.
 */ /**
 * @param {string | import('./core').PROJJSONDefinition | import('./defs').ProjectionDefinition} srsCode
 * @param {(errorMessage?: string, instance?: Projection) => void} [callback]
 */ function $c04766b9ae61c421$var$Projection(srsCode, callback) {
    if (!(this instanceof $c04766b9ae61c421$var$Projection)) return new $c04766b9ae61c421$var$Projection(srsCode);
    /** @type {<T extends import('./core').TemplateCoordinates>(coordinates: T, enforceAxis?: boolean) => T} */ this.forward = null;
    /** @type {<T extends import('./core').TemplateCoordinates>(coordinates: T, enforceAxis?: boolean) => T} */ this.inverse = null;
    /** @type {function(): void} */ this.init = null;
    /** @type {string} */ this.name;
    /** @type {Array<string>} */ this.names = null;
    /** @type {string} */ this.title;
    callback = callback || function(error) {
        if (error) throw error;
    };
    var json = (0, $39cd55cd881e7f3e$export$2e2bcd8739ae039)(srsCode);
    if (typeof json !== 'object') {
        callback('Could not parse to valid json: ' + srsCode);
        return;
    }
    var ourProj = $c04766b9ae61c421$var$Projection.projections.get(json.projName);
    if (!ourProj) {
        callback('Could not get projection name from: ' + srsCode);
        return;
    }
    if (json.datumCode && json.datumCode !== 'none') {
        var datumDef = (0, $6e15fef3d69c3cec$export$2e2bcd8739ae039)((0, $52a91c3464ce6c97$export$2e2bcd8739ae039), json.datumCode);
        if (datumDef) {
            json.datum_params = json.datum_params || (datumDef.towgs84 ? datumDef.towgs84.split(',') : null);
            json.ellps = datumDef.ellipse;
            json.datumName = datumDef.datumName ? datumDef.datumName : json.datumCode;
        }
    }
    json.k0 = json.k0 || 1.0;
    json.axis = json.axis || 'enu';
    json.ellps = json.ellps || 'wgs84';
    json.lat1 = json.lat1 || json.lat0; // Lambert_Conformal_Conic_1SP, for example, needs this
    var sphere_ = (0, $adb5c8d6b3f2cfc1$export$b2690196de52b050)(json.a, json.b, json.rf, json.ellps, json.sphere);
    var ecc = (0, $adb5c8d6b3f2cfc1$export$e3d7bf2ed2a7479f)(sphere_.a, sphere_.b, sphere_.rf, json.R_A);
    var nadgrids = (0, $9262fced509c4a24$export$31c4d9288d81329a)(json.nadgrids);
    /** @type {DatumDefinition} */ var datumObj = json.datum || (0, $9f20925dcb5fa64b$export$2e2bcd8739ae039)(json.datumCode, json.datum_params, sphere_.a, sphere_.b, ecc.es, ecc.ep2, nadgrids);
    (0, $ddedbe7ebc7ebe00$export$2e2bcd8739ae039)(this, json); // transfer everything over from the projection because we don't know what we'll need
    (0, $ddedbe7ebc7ebe00$export$2e2bcd8739ae039)(this, ourProj); // transfer all the methods from the projection
    // copy the 4 things over we calculated in deriveConstants.sphere
    this.a = sphere_.a;
    this.b = sphere_.b;
    this.rf = sphere_.rf;
    this.sphere = sphere_.sphere;
    // copy the 3 things we calculated in deriveConstants.eccentricity
    this.es = ecc.es;
    this.e = ecc.e;
    this.ep2 = ecc.ep2;
    // add in the datum object
    this.datum = datumObj;
    // init the projection
    if ('init' in this && typeof this.init === 'function') this.init();
    // legecy callback from back in the day when it went to spatialreference.org
    callback(null, this);
}
$c04766b9ae61c421$var$Projection.projections = (0, $9b3a1b7aca3fbe1b$export$2e2bcd8739ae039);
$c04766b9ae61c421$var$Projection.projections.start();
var $c04766b9ae61c421$export$2e2bcd8739ae039 = $c04766b9ae61c421$var$Projection;



var $jDCGO = parcelRequire("jDCGO");

var $jDCGO = parcelRequire("jDCGO");

var $jDCGO = parcelRequire("jDCGO");
'use strict';
function $2fc2148347b1eda1$export$68c8d8590fbb24e4(source, dest) {
    if (source.datum_type !== dest.datum_type) return false; // false, datums are not equal
    else if (source.a !== dest.a || Math.abs(source.es - dest.es) > 0.000000000050) // the tolerance for es is to ensure that GRS80 and WGS84
    // are considered identical
    return false;
    else if (source.datum_type === (0, $jDCGO.PJD_3PARAM)) return source.datum_params[0] === dest.datum_params[0] && source.datum_params[1] === dest.datum_params[1] && source.datum_params[2] === dest.datum_params[2];
    else if (source.datum_type === (0, $jDCGO.PJD_7PARAM)) return source.datum_params[0] === dest.datum_params[0] && source.datum_params[1] === dest.datum_params[1] && source.datum_params[2] === dest.datum_params[2] && source.datum_params[3] === dest.datum_params[3] && source.datum_params[4] === dest.datum_params[4] && source.datum_params[5] === dest.datum_params[5] && source.datum_params[6] === dest.datum_params[6];
    else return true; // datums are equal
} // cs_compare_datums()
function $2fc2148347b1eda1$export$4a4ae2976f9a808a(p, es, a) {
    var Longitude = p.x;
    var Latitude = p.y;
    var Height = p.z ? p.z : 0; // Z value not always supplied
    var Rn; /*  Earth radius at location  */ 
    var Sin_Lat; /*  Math.sin(Latitude)  */ 
    var Sin2_Lat; /*  Square of Math.sin(Latitude)  */ 
    var Cos_Lat; /*  Math.cos(Latitude)  */ 
    /*
   ** Don't blow up if Latitude is just a little out of the value
   ** range as it may just be a rounding issue.  Also removed longitude
   ** test, it should be wrapped by Math.cos() and Math.sin().  NFW for PROJ.4, Sep/2001.
   */ if (Latitude < -(0, $jDCGO.HALF_PI) && Latitude > -1.001 * (0, $jDCGO.HALF_PI)) Latitude = -(0, $jDCGO.HALF_PI);
    else if (Latitude > (0, $jDCGO.HALF_PI) && Latitude < 1.001 * (0, $jDCGO.HALF_PI)) Latitude = (0, $jDCGO.HALF_PI);
    else if (Latitude < -(0, $jDCGO.HALF_PI)) /* Latitude out of range */ // ..reportError('geocent:lat out of range:' + Latitude);
    return {
        x: -Infinity,
        y: -Infinity,
        z: p.z
    };
    else if (Latitude > (0, $jDCGO.HALF_PI)) /* Latitude out of range */ return {
        x: Infinity,
        y: Infinity,
        z: p.z
    };
    if (Longitude > Math.PI) Longitude -= 2 * Math.PI;
    Sin_Lat = Math.sin(Latitude);
    Cos_Lat = Math.cos(Latitude);
    Sin2_Lat = Sin_Lat * Sin_Lat;
    Rn = a / Math.sqrt(1.0e0 - es * Sin2_Lat);
    return {
        x: (Rn + Height) * Cos_Lat * Math.cos(Longitude),
        y: (Rn + Height) * Cos_Lat * Math.sin(Longitude),
        z: (Rn * (1 - es) + Height) * Sin_Lat
    };
} // cs_geodetic_to_geocentric()
function $2fc2148347b1eda1$export$26210192c8922750(p, es, a, b) {
    /* local defintions and variables */ /* end-criterium of loop, accuracy of sin(Latitude) */ var genau = 1e-12;
    var genau2 = genau * genau;
    var maxiter = 30;
    var P; /* distance between semi-minor axis and location */ 
    var RR; /* distance between center and location */ 
    var CT; /* sin of geocentric latitude */ 
    var ST; /* cos of geocentric latitude */ 
    var RX;
    var RK;
    var RN; /* Earth radius at location */ 
    var CPHI0; /* cos of start or old geodetic latitude in iterations */ 
    var SPHI0; /* sin of start or old geodetic latitude in iterations */ 
    var CPHI; /* cos of searched geodetic latitude */ 
    var SPHI; /* sin of searched geodetic latitude */ 
    var SDPHI; /* end-criterium: addition-theorem of sin(Latitude(iter)-Latitude(iter-1)) */ 
    var iter; /* # of continous iteration, max. 30 is always enough (s.a.) */ 
    var X = p.x;
    var Y = p.y;
    var Z = p.z ? p.z : 0.0; // Z value not always supplied
    var Longitude;
    var Latitude;
    var Height;
    P = Math.sqrt(X * X + Y * Y);
    RR = Math.sqrt(X * X + Y * Y + Z * Z);
    /*      special cases for latitude and longitude */ if (P / a < genau) {
        /*  special case, if P=0. (X=0., Y=0.) */ Longitude = 0.0;
        /*  if (X,Y,Z)=(0.,0.,0.) then Height becomes semi-minor axis
     *  of ellipsoid (=center of mass), Latitude becomes PI/2 */ if (RR / a < genau) {
            Latitude = (0, $jDCGO.HALF_PI);
            Height = -b;
            return {
                x: p.x,
                y: p.y,
                z: p.z
            };
        }
    } else /*  ellipsoidal (geodetic) longitude
     *  interval: -PI < Longitude <= +PI */ Longitude = Math.atan2(Y, X);
    /* --------------------------------------------------------------
   * Following iterative algorithm was developped by
   * "Institut for Erdmessung", University of Hannover, July 1988.
   * Internet: www.ife.uni-hannover.de
   * Iterative computation of CPHI,SPHI and Height.
   * Iteration of CPHI and SPHI to 10**-12 radian resp.
   * 2*10**-7 arcsec.
   * --------------------------------------------------------------
   */ CT = Z / RR;
    ST = P / RR;
    RX = 1.0 / Math.sqrt(1.0 - es * (2.0 - es) * ST * ST);
    CPHI0 = ST * (1.0 - es) * RX;
    SPHI0 = CT * RX;
    iter = 0;
    /* loop to find sin(Latitude) resp. Latitude
   * until |sin(Latitude(iter)-Latitude(iter-1))| < genau */ do {
        iter++;
        RN = a / Math.sqrt(1.0 - es * SPHI0 * SPHI0);
        /*  ellipsoidal (geodetic) height */ Height = P * CPHI0 + Z * SPHI0 - RN * (1.0 - es * SPHI0 * SPHI0);
        RK = es * RN / (RN + Height);
        RX = 1.0 / Math.sqrt(1.0 - RK * (2.0 - RK) * ST * ST);
        CPHI = ST * (1.0 - RK) * RX;
        SPHI = CT * RX;
        SDPHI = SPHI * CPHI0 - CPHI * SPHI0;
        CPHI0 = CPHI;
        SPHI0 = SPHI;
    }while (SDPHI * SDPHI > genau2 && iter < maxiter);
    /*      ellipsoidal (geodetic) latitude */ Latitude = Math.atan(SPHI / Math.abs(CPHI));
    return {
        x: Longitude,
        y: Latitude,
        z: Height
    };
} // cs_geocentric_to_geodetic()
function $2fc2148347b1eda1$export$d18952b9ecb47c8f(p, datum_type, datum_params) {
    if (datum_type === (0, $jDCGO.PJD_3PARAM)) // if( x[io] === HUGE_VAL )
    //    continue;
    return {
        x: p.x + datum_params[0],
        y: p.y + datum_params[1],
        z: p.z + datum_params[2]
    };
    else if (datum_type === (0, $jDCGO.PJD_7PARAM)) {
        var Dx_BF = datum_params[0];
        var Dy_BF = datum_params[1];
        var Dz_BF = datum_params[2];
        var Rx_BF = datum_params[3];
        var Ry_BF = datum_params[4];
        var Rz_BF = datum_params[5];
        var M_BF = datum_params[6];
        // if( x[io] === HUGE_VAL )
        //    continue;
        return {
            x: M_BF * (p.x - Rz_BF * p.y + Ry_BF * p.z) + Dx_BF,
            y: M_BF * (Rz_BF * p.x + p.y - Rx_BF * p.z) + Dy_BF,
            z: M_BF * (-Ry_BF * p.x + Rx_BF * p.y + p.z) + Dz_BF
        };
    }
} // cs_geocentric_to_wgs84
function $2fc2148347b1eda1$export$2b744ad521e7ac0b(p, datum_type, datum_params) {
    if (datum_type === (0, $jDCGO.PJD_3PARAM)) // if( x[io] === HUGE_VAL )
    //    continue;
    return {
        x: p.x - datum_params[0],
        y: p.y - datum_params[1],
        z: p.z - datum_params[2]
    };
    else if (datum_type === (0, $jDCGO.PJD_7PARAM)) {
        var Dx_BF = datum_params[0];
        var Dy_BF = datum_params[1];
        var Dz_BF = datum_params[2];
        var Rx_BF = datum_params[3];
        var Ry_BF = datum_params[4];
        var Rz_BF = datum_params[5];
        var M_BF = datum_params[6];
        var x_tmp = (p.x - Dx_BF) / M_BF;
        var y_tmp = (p.y - Dy_BF) / M_BF;
        var z_tmp = (p.z - Dz_BF) / M_BF;
        // if( x[io] === HUGE_VAL )
        //    continue;
        return {
            x: x_tmp + Rz_BF * y_tmp - Ry_BF * z_tmp,
            y: -Rz_BF * x_tmp + y_tmp + Rx_BF * z_tmp,
            z: Ry_BF * x_tmp - Rx_BF * y_tmp + z_tmp
        };
    } // cs_geocentric_from_wgs84()
}



var $eRFTg = parcelRequire("eRFTg");
function $9d2b28f8b1969211$var$checkParams(type) {
    return type === (0, $jDCGO.PJD_3PARAM) || type === (0, $jDCGO.PJD_7PARAM);
}
function $9d2b28f8b1969211$export$2e2bcd8739ae039(source, dest, point) {
    // Short cut if the datums are identical.
    if ((0, $2fc2148347b1eda1$export$68c8d8590fbb24e4)(source, dest)) return point; // in this case, zero is sucess,
    // Explicitly skip datum transform by setting 'datum=none' as parameter for either source or dest
    if (source.datum_type === (0, $jDCGO.PJD_NODATUM) || dest.datum_type === (0, $jDCGO.PJD_NODATUM)) return point;
    // If this datum requires grid shifts, then apply it to geodetic coordinates.
    var source_a = source.a;
    var source_es = source.es;
    if (source.datum_type === (0, $jDCGO.PJD_GRIDSHIFT)) {
        var gridShiftCode = $9d2b28f8b1969211$export$cfa06df23524576a(source, false, point);
        if (gridShiftCode !== 0) return undefined;
        source_a = (0, $jDCGO.SRS_WGS84_SEMIMAJOR);
        source_es = (0, $jDCGO.SRS_WGS84_ESQUARED);
    }
    var dest_a = dest.a;
    var dest_b = dest.b;
    var dest_es = dest.es;
    if (dest.datum_type === (0, $jDCGO.PJD_GRIDSHIFT)) {
        dest_a = (0, $jDCGO.SRS_WGS84_SEMIMAJOR);
        dest_b = (0, $jDCGO.SRS_WGS84_SEMIMINOR);
        dest_es = (0, $jDCGO.SRS_WGS84_ESQUARED);
    }
    // Do we need to go through geocentric coordinates?
    if (source_es === dest_es && source_a === dest_a && !$9d2b28f8b1969211$var$checkParams(source.datum_type) && !$9d2b28f8b1969211$var$checkParams(dest.datum_type)) return point;
    // Convert to geocentric coordinates.
    point = (0, $2fc2148347b1eda1$export$4a4ae2976f9a808a)(point, source_es, source_a);
    // Convert between datums
    if ($9d2b28f8b1969211$var$checkParams(source.datum_type)) point = (0, $2fc2148347b1eda1$export$d18952b9ecb47c8f)(point, source.datum_type, source.datum_params);
    if ($9d2b28f8b1969211$var$checkParams(dest.datum_type)) point = (0, $2fc2148347b1eda1$export$2b744ad521e7ac0b)(point, dest.datum_type, dest.datum_params);
    point = (0, $2fc2148347b1eda1$export$26210192c8922750)(point, dest_es, dest_a, dest_b);
    if (dest.datum_type === (0, $jDCGO.PJD_GRIDSHIFT)) {
        var destGridShiftResult = $9d2b28f8b1969211$export$cfa06df23524576a(dest, true, point);
        if (destGridShiftResult !== 0) return undefined;
    }
    return point;
}
function $9d2b28f8b1969211$export$cfa06df23524576a(source, inverse, point) {
    if (source.grids === null || source.grids.length === 0) {
        console.log('Grid shift grids not found');
        return -1;
    }
    var input = {
        x: -point.x,
        y: point.y
    };
    var output = {
        x: Number.NaN,
        y: Number.NaN
    };
    var attemptedGrids = [];
    outer: for(var i = 0; i < source.grids.length; i++){
        var grid = source.grids[i];
        attemptedGrids.push(grid.name);
        if (grid.isNull) {
            output = input;
            break;
        }
        if (grid.grid === null) {
            if (grid.mandatory) {
                console.log('Unable to find mandatory grid \'' + grid.name + '\'');
                return -1;
            }
            continue;
        }
        var subgrids = grid.grid.subgrids;
        for(var j = 0, jj = subgrids.length; j < jj; j++){
            var subgrid = subgrids[j];
            // skip tables that don't match our point at all
            var epsilon = (Math.abs(subgrid.del[1]) + Math.abs(subgrid.del[0])) / 10000.0;
            var minX = subgrid.ll[0] - epsilon;
            var minY = subgrid.ll[1] - epsilon;
            var maxX = subgrid.ll[0] + (subgrid.lim[0] - 1) * subgrid.del[0] + epsilon;
            var maxY = subgrid.ll[1] + (subgrid.lim[1] - 1) * subgrid.del[1] + epsilon;
            if (minY > input.y || minX > input.x || maxY < input.y || maxX < input.x) continue;
            output = $9d2b28f8b1969211$var$applySubgridShift(input, inverse, subgrid);
            if (!isNaN(output.x)) break outer;
        }
    }
    if (isNaN(output.x)) {
        console.log('Failed to find a grid shift table for location \'' + -input.x * (0, $jDCGO.R2D) + ' ' + input.y * (0, $jDCGO.R2D) + ' tried: \'' + attemptedGrids + '\'');
        return -1;
    }
    point.x = -output.x;
    point.y = output.y;
    return 0;
}
function $9d2b28f8b1969211$var$applySubgridShift(pin, inverse, ct) {
    var val = {
        x: Number.NaN,
        y: Number.NaN
    };
    if (isNaN(pin.x)) return val;
    var tb = {
        x: pin.x,
        y: pin.y
    };
    tb.x -= ct.ll[0];
    tb.y -= ct.ll[1];
    tb.x = (0, $eRFTg.default)(tb.x - Math.PI) + Math.PI;
    var t = $9d2b28f8b1969211$var$nadInterpolate(tb, ct);
    if (inverse) {
        if (isNaN(t.x)) return val;
        t.x = tb.x - t.x;
        t.y = tb.y - t.y;
        var i = 9, tol = 1e-12;
        var dif, del;
        do {
            del = $9d2b28f8b1969211$var$nadInterpolate(t, ct);
            if (isNaN(del.x)) {
                console.log('Inverse grid shift iteration failed, presumably at grid edge.  Using first approximation.');
                break;
            }
            dif = {
                x: tb.x - (del.x + t.x),
                y: tb.y - (del.y + t.y)
            };
            t.x += dif.x;
            t.y += dif.y;
        }while (i-- && Math.abs(dif.x) > tol && Math.abs(dif.y) > tol);
        if (i < 0) {
            console.log('Inverse grid shift iterator failed to converge.');
            return val;
        }
        val.x = (0, $eRFTg.default)(t.x + ct.ll[0]);
        val.y = t.y + ct.ll[1];
    } else if (!isNaN(t.x)) {
        val.x = pin.x + t.x;
        val.y = pin.y + t.y;
    }
    return val;
}
function $9d2b28f8b1969211$var$nadInterpolate(pin, ct) {
    var t = {
        x: pin.x / ct.del[0],
        y: pin.y / ct.del[1]
    };
    var indx = {
        x: Math.floor(t.x),
        y: Math.floor(t.y)
    };
    var frct = {
        x: t.x - 1.0 * indx.x,
        y: t.y - 1.0 * indx.y
    };
    var val = {
        x: Number.NaN,
        y: Number.NaN
    };
    var inx;
    if (indx.x < 0 || indx.x >= ct.lim[0]) return val;
    if (indx.y < 0 || indx.y >= ct.lim[1]) return val;
    inx = indx.y * ct.lim[0] + indx.x;
    var f00 = {
        x: ct.cvs[inx][0],
        y: ct.cvs[inx][1]
    };
    inx++;
    var f10 = {
        x: ct.cvs[inx][0],
        y: ct.cvs[inx][1]
    };
    inx += ct.lim[0];
    var f11 = {
        x: ct.cvs[inx][0],
        y: ct.cvs[inx][1]
    };
    inx--;
    var f01 = {
        x: ct.cvs[inx][0],
        y: ct.cvs[inx][1]
    };
    var m11 = frct.x * frct.y, m10 = frct.x * (1.0 - frct.y), m00 = (1.0 - frct.x) * (1.0 - frct.y), m01 = (1.0 - frct.x) * frct.y;
    val.x = m00 * f00.x + m10 * f10.x + m01 * f01.x + m11 * f11.x;
    val.y = m00 * f00.y + m10 * f10.y + m01 * f01.y + m11 * f11.y;
    return val;
}


function $9ea33602e66f744d$export$2e2bcd8739ae039(crs, denorm, point) {
    var xin = point.x, yin = point.y, zin = point.z || 0.0;
    var v, t, i;
    /** @type {import("./core").InterfaceCoordinates} */ var out = {};
    for(i = 0; i < 3; i++){
        if (denorm && i === 2 && point.z === undefined) continue;
        if (i === 0) {
            v = xin;
            if ('ew'.indexOf(crs.axis[i]) !== -1) t = 'x';
            else t = 'y';
        } else if (i === 1) {
            v = yin;
            if ('ns'.indexOf(crs.axis[i]) !== -1) t = 'y';
            else t = 'x';
        } else {
            v = zin;
            t = 'z';
        }
        switch(crs.axis[i]){
            case 'e':
                out[t] = v;
                break;
            case 'w':
                out[t] = -v;
                break;
            case 'n':
                out[t] = v;
                break;
            case 's':
                out[t] = -v;
                break;
            case 'u':
                if (point[t] !== undefined) out.z = v;
                break;
            case 'd':
                if (point[t] !== undefined) out.z = -v;
                break;
            default:
                // console.log("ERROR: unknow axis ("+crs.axis[i]+") - check definition of "+crs.projName);
                return null;
        }
    }
    return out;
}



/**
 * @param {Array<number>} array
 * @returns {import("../core").InterfaceCoordinates}
 */ function $1104ed58f12ed77f$export$2e2bcd8739ae039(array) {
    var out = {
        x: array[0],
        y: array[1]
    };
    if (array.length > 2) out.z = array[2];
    if (array.length > 3) out.m = array[3];
    return out;
}


function $15e7cb30ea49d6a0$export$2e2bcd8739ae039(point) {
    $15e7cb30ea49d6a0$var$checkCoord(point.x);
    $15e7cb30ea49d6a0$var$checkCoord(point.y);
}
function $15e7cb30ea49d6a0$var$checkCoord(num) {
    if (typeof Number.isFinite === 'function') {
        if (Number.isFinite(num)) return;
        throw new TypeError('coordinates must be finite numbers');
    }
    if (typeof num !== 'number' || num !== num || !isFinite(num)) throw new TypeError('coordinates must be finite numbers');
}


function $78dbab15a0f3f2e9$var$checkNotWGS(source, dest) {
    return (source.datum.datum_type === (0, $jDCGO.PJD_3PARAM) || source.datum.datum_type === (0, $jDCGO.PJD_7PARAM) || source.datum.datum_type === (0, $jDCGO.PJD_GRIDSHIFT)) && dest.datumCode !== 'WGS84' || (dest.datum.datum_type === (0, $jDCGO.PJD_3PARAM) || dest.datum.datum_type === (0, $jDCGO.PJD_7PARAM) || dest.datum.datum_type === (0, $jDCGO.PJD_GRIDSHIFT)) && source.datumCode !== 'WGS84';
}
function $78dbab15a0f3f2e9$export$2e2bcd8739ae039(source, dest, point, enforceAxis) {
    var wgs84;
    if (Array.isArray(point)) point = (0, $1104ed58f12ed77f$export$2e2bcd8739ae039)(point);
    else // Clone the point object so inputs don't get modified
    point = {
        x: point.x,
        y: point.y,
        z: point.z,
        m: point.m
    };
    var hasZ = point.z !== undefined;
    (0, $15e7cb30ea49d6a0$export$2e2bcd8739ae039)(point);
    // Workaround for datum shifts towgs84, if either source or destination projection is not wgs84
    if (source.datum && dest.datum && $78dbab15a0f3f2e9$var$checkNotWGS(source, dest)) {
        wgs84 = new (0, $c04766b9ae61c421$export$2e2bcd8739ae039)('WGS84');
        point = $78dbab15a0f3f2e9$export$2e2bcd8739ae039(source, wgs84, point, enforceAxis);
        source = wgs84;
    }
    // DGR, 2010/11/12
    if (enforceAxis && source.axis !== 'enu') point = (0, $9ea33602e66f744d$export$2e2bcd8739ae039)(source, false, point);
    // Transform source points to long/lat, if they aren't already.
    if (source.projName === 'longlat') point = {
        x: point.x * (0, $jDCGO.D2R),
        y: point.y * (0, $jDCGO.D2R),
        z: point.z || 0
    };
    else {
        if (source.to_meter) point = {
            x: point.x * source.to_meter,
            y: point.y * source.to_meter,
            z: point.z || 0
        };
        point = source.inverse(point); // Convert Cartesian to longlat
        if (!point) return;
    }
    // Adjust for the prime meridian if necessary
    if (source.from_greenwich) point.x += source.from_greenwich;
    // Convert datums if needed, and if possible.
    point = (0, $9d2b28f8b1969211$export$2e2bcd8739ae039)(source.datum, dest.datum, point);
    if (!point) return;
    /** @type {import('./core').InterfaceCoordinates} */ point;
    // Adjust for the prime meridian if necessary
    if (dest.from_greenwich) point = {
        x: point.x - dest.from_greenwich,
        y: point.y,
        z: point.z || 0
    };
    if (dest.projName === 'longlat') // convert radians to decimal degrees
    point = {
        x: point.x * (0, $jDCGO.R2D),
        y: point.y * (0, $jDCGO.R2D),
        z: point.z || 0
    };
    else {
        point = dest.forward(point);
        if (dest.to_meter) point = {
            x: point.x / dest.to_meter,
            y: point.y / dest.to_meter,
            z: point.z || 0
        };
    }
    // DGR, 2010/11/12
    if (enforceAxis && dest.axis !== 'enu') return (0, $9ea33602e66f744d$export$2e2bcd8739ae039)(dest, true, point);
    if (point && !hasZ && dest.projName !== 'geocent') delete point.z;
    return point;
}


var $5671f5b5c060719c$var$wgs84 = (0, $c04766b9ae61c421$export$2e2bcd8739ae039)('WGS84');
/**
 * @typedef {{x: number, y: number, z?: number, m?: number}} InterfaceCoordinates
 */ /**
 * @typedef {Array<number> | InterfaceCoordinates} TemplateCoordinates
 */ /**
 * @typedef {Object} Converter
 * @property {<T extends TemplateCoordinates>(coordinates: T, enforceAxis?: boolean) => T} forward
 * @property {<T extends TemplateCoordinates>(coordinates: T, enforceAxis?: boolean) => T} inverse
 * @property {proj} [oProj]
 */ /**
 * @typedef {Object} PROJJSONDefinition
 * @property {string} [$schema]
 * @property {string} type
 * @property {string} [name]
 * @property {{authority: string, code: number}} [id]
 * @property {string} [scope]
 * @property {string} [area]
 * @property {{south_latitude: number, west_longitude: number, north_latitude: number, east_longitude: number}} [bbox]
 * @property {PROJJSONDefinition[]} [components]
 * @property {{type: string, name: string}} [datum]
 * @property {{
 *   name: string,
 *   members: Array<{
 *     name: string,
 *     id?: {authority: string, code: number}
 *   }>,
 *   ellipsoid?: {
 *     name: string,
 *     semi_major_axis: number,
 *     inverse_flattening?: number
 *   },
 *   accuracy?: string,
 *   id?: {authority: string, code: number}
 * }} [datum_ensemble]
 * @property {{
 *   subtype: string,
 *   axis: Array<{
 *     name: string,
 *     abbreviation?: string,
 *     direction: string,
 *     unit: string
 *   }>
 * }} [coordinate_system]
 * @property {{
 *   name: string,
 *   method: {name: string},
 *   parameters: Array<{
 *     name: string,
 *     value: number,
 *     unit?: string
 *   }>
 * }} [conversion]
 * @property {{
 *   name: string,
 *   method: {name: string},
 *   parameters: Array<{
 *     name: string,
 *     value: number,
 *     unit?: string,
 *     type?: string,
 *     file_name?: string
 *   }>
 * }} [transformation]
 */ /**
 * @template {TemplateCoordinates} T
 * @param {proj} from
 * @param {proj} to
 * @param {T} coords
 * @param {boolean} [enforceAxis]
 * @returns {T}
 */ function $5671f5b5c060719c$var$transformer(from, to, coords, enforceAxis) {
    var transformedArray, out, keys;
    if (Array.isArray(coords)) {
        transformedArray = (0, $78dbab15a0f3f2e9$export$2e2bcd8739ae039)(from, to, coords, enforceAxis) || {
            x: NaN,
            y: NaN
        };
        if (coords.length > 2) {
            if (typeof from.name !== 'undefined' && from.name === 'geocent' || typeof to.name !== 'undefined' && to.name === 'geocent') {
                if (typeof transformedArray.z === 'number') return /** @type {T} */ [
                    transformedArray.x,
                    transformedArray.y,
                    transformedArray.z
                ].concat(coords.slice(3));
                else return /** @type {T} */ [
                    transformedArray.x,
                    transformedArray.y,
                    coords[2]
                ].concat(coords.slice(3));
            } else return /** @type {T} */ [
                transformedArray.x,
                transformedArray.y
            ].concat(coords.slice(2));
        } else return /** @type {T} */ [
            transformedArray.x,
            transformedArray.y
        ];
    } else {
        out = (0, $78dbab15a0f3f2e9$export$2e2bcd8739ae039)(from, to, coords, enforceAxis);
        keys = Object.keys(coords);
        if (keys.length === 2) return /** @type {T} */ out;
        keys.forEach(function(key) {
            if (typeof from.name !== 'undefined' && from.name === 'geocent' || typeof to.name !== 'undefined' && to.name === 'geocent') {
                if (key === 'x' || key === 'y' || key === 'z') return;
            } else {
                if (key === 'x' || key === 'y') return;
            }
            out[key] = coords[key];
        });
        return /** @type {T} */ out;
    }
}
/**
 * @param {proj | string | PROJJSONDefinition | Converter} item
 * @returns {import('./Proj').default}
 */ function $5671f5b5c060719c$var$checkProj(item) {
    if (item instanceof (0, $c04766b9ae61c421$export$2e2bcd8739ae039)) return item;
    if (typeof item === 'object' && 'oProj' in item) return item.oProj;
    return (0, $c04766b9ae61c421$export$2e2bcd8739ae039)(/** @type {string | PROJJSONDefinition} */ item);
}
/**
 * @overload
 * @param {string | PROJJSONDefinition | proj} toProj
 * @returns {Converter}
 */ /**
 * @overload
 * @param {string | PROJJSONDefinition | proj} fromProj
 * @param {string | PROJJSONDefinition | proj} toProj
 * @returns {Converter}
 */ /**
 * @template {TemplateCoordinates} T
 * @overload
 * @param {string | PROJJSONDefinition | proj} toProj
 * @param {T} coord
 * @returns {T}
 */ /**
 * @template {TemplateCoordinates} T
 * @overload
 * @param {string | PROJJSONDefinition | proj} fromProj
 * @param {string | PROJJSONDefinition | proj} toProj
 * @param {T} coord
 * @returns {T}
 */ /**
 * @template {TemplateCoordinates} T
 * @param {string | PROJJSONDefinition | proj} fromProjOrToProj
 * @param {string | PROJJSONDefinition | proj | TemplateCoordinates} [toProjOrCoord]
 * @param {T} [coord]
 * @returns {T|Converter}
 */ function $5671f5b5c060719c$var$proj4(fromProjOrToProj, toProjOrCoord, coord) {
    /** @type {proj} */ var fromProj;
    /** @type {proj} */ var toProj;
    var single = false;
    /** @type {Converter} */ var obj;
    if (typeof toProjOrCoord === 'undefined') {
        toProj = $5671f5b5c060719c$var$checkProj(fromProjOrToProj);
        fromProj = $5671f5b5c060719c$var$wgs84;
        single = true;
    } else if (typeof /** @type {?} */ toProjOrCoord.x !== 'undefined' || Array.isArray(toProjOrCoord)) {
        coord = /** @type {?} */ toProjOrCoord;
        toProj = $5671f5b5c060719c$var$checkProj(fromProjOrToProj);
        fromProj = $5671f5b5c060719c$var$wgs84;
        single = true;
    }
    if (!fromProj) fromProj = $5671f5b5c060719c$var$checkProj(fromProjOrToProj);
    if (!toProj) toProj = $5671f5b5c060719c$var$checkProj(/** @type {string | PROJJSONDefinition | proj } */ toProjOrCoord);
    if (coord) return $5671f5b5c060719c$var$transformer(fromProj, toProj, coord);
    else {
        obj = {
            /**
       * @template {TemplateCoordinates} T
       * @param {T} coords
       * @param {boolean=} enforceAxis
       * @returns {T}
       */ forward: function(coords, enforceAxis) {
                return $5671f5b5c060719c$var$transformer(fromProj, toProj, coords, enforceAxis);
            },
            /**
       * @template {TemplateCoordinates} T
       * @param {T} coords
       * @param {boolean=} enforceAxis
       * @returns {T}
       */ inverse: function(coords, enforceAxis) {
                return $5671f5b5c060719c$var$transformer(toProj, fromProj, coords, enforceAxis);
            }
        };
        if (single) obj.oProj = toProj;
        return obj;
    }
}
var $5671f5b5c060719c$export$2e2bcd8739ae039 = $5671f5b5c060719c$var$proj4;



/**
 * UTM zones are grouped, and assigned to one of a group of 6
 * sets.
 *
 * {int} @private
 */ var $3371772b61ed5838$var$NUM_100K_SETS = 6;
/**
 * The column letters (for easting) of the lower left value, per
 * set.
 *
 * {string} @private
 */ var $3371772b61ed5838$var$SET_ORIGIN_COLUMN_LETTERS = 'AJSAJS';
/**
 * The row letters (for northing) of the lower left value, per
 * set.
 *
 * {string} @private
 */ var $3371772b61ed5838$var$SET_ORIGIN_ROW_LETTERS = 'AFAFAF';
var $3371772b61ed5838$var$A = 65; // A
var $3371772b61ed5838$var$I = 73; // I
var $3371772b61ed5838$var$O = 79; // O
var $3371772b61ed5838$var$V = 86; // V
var $3371772b61ed5838$var$Z = 90; // Z
var $3371772b61ed5838$export$2e2bcd8739ae039 = {
    forward: $3371772b61ed5838$export$174bb771924e7eb1,
    inverse: $3371772b61ed5838$export$70ae2c07e401031b,
    toPoint: $3371772b61ed5838$export$b63cca88ddc558a9
};
function $3371772b61ed5838$export$174bb771924e7eb1(ll, accuracy) {
    accuracy = accuracy || 5; // default accuracy 1m
    return $3371772b61ed5838$var$encode($3371772b61ed5838$var$LLtoUTM({
        lat: ll[1],
        lon: ll[0]
    }), accuracy);
}
function $3371772b61ed5838$export$70ae2c07e401031b(mgrs) {
    var bbox = $3371772b61ed5838$var$UTMtoLL($3371772b61ed5838$var$decode(mgrs.toUpperCase()));
    if (bbox.lat && bbox.lon) return [
        bbox.lon,
        bbox.lat,
        bbox.lon,
        bbox.lat
    ];
    return [
        bbox.left,
        bbox.bottom,
        bbox.right,
        bbox.top
    ];
}
function $3371772b61ed5838$export$b63cca88ddc558a9(mgrs) {
    var bbox = $3371772b61ed5838$var$UTMtoLL($3371772b61ed5838$var$decode(mgrs.toUpperCase()));
    if (bbox.lat && bbox.lon) return [
        bbox.lon,
        bbox.lat
    ];
    return [
        (bbox.left + bbox.right) / 2,
        (bbox.top + bbox.bottom) / 2
    ];
}
/**
 * Conversion from degrees to radians.
 *
 * @private
 * @param {number} deg the angle in degrees.
 * @return {number} the angle in radians.
 */ function $3371772b61ed5838$var$degToRad(deg) {
    return deg * (Math.PI / 180.0);
}
/**
 * Conversion from radians to degrees.
 *
 * @private
 * @param {number} rad the angle in radians.
 * @return {number} the angle in degrees.
 */ function $3371772b61ed5838$var$radToDeg(rad) {
    return 180.0 * (rad / Math.PI);
}
/**
 * Converts a set of Longitude and Latitude co-ordinates to UTM
 * using the WGS84 ellipsoid.
 *
 * @private
 * @param {object} ll Object literal with lat and lon properties
 *     representing the WGS84 coordinate to be converted.
 * @return {object} Object literal containing the UTM value with easting,
 *     northing, zoneNumber and zoneLetter properties, and an optional
 *     accuracy property in digits. Returns null if the conversion failed.
 */ function $3371772b61ed5838$var$LLtoUTM(ll) {
    var Lat = ll.lat;
    var Long = ll.lon;
    var a = 6378137.0; //ellip.radius;
    var eccSquared = 0.00669438; //ellip.eccsq;
    var k0 = 0.9996;
    var LongOrigin;
    var eccPrimeSquared;
    var N, T, C, A, M;
    var LatRad = $3371772b61ed5838$var$degToRad(Lat);
    var LongRad = $3371772b61ed5838$var$degToRad(Long);
    var LongOriginRad;
    var ZoneNumber;
    // (int)
    ZoneNumber = Math.floor((Long + 180) / 6) + 1;
    //Make sure the longitude 180.00 is in Zone 60
    if (Long === 180) ZoneNumber = 60;
    // Special zone for Norway
    if (Lat >= 56.0 && Lat < 64.0 && Long >= 3.0 && Long < 12.0) ZoneNumber = 32;
    // Special zones for Svalbard
    if (Lat >= 72.0 && Lat < 84.0) {
        if (Long >= 0.0 && Long < 9.0) ZoneNumber = 31;
        else if (Long >= 9.0 && Long < 21.0) ZoneNumber = 33;
        else if (Long >= 21.0 && Long < 33.0) ZoneNumber = 35;
        else if (Long >= 33.0 && Long < 42.0) ZoneNumber = 37;
    }
    LongOrigin = (ZoneNumber - 1) * 6 - 180 + 3; //+3 puts origin
    // in middle of
    // zone
    LongOriginRad = $3371772b61ed5838$var$degToRad(LongOrigin);
    eccPrimeSquared = eccSquared / (1 - eccSquared);
    N = a / Math.sqrt(1 - eccSquared * Math.sin(LatRad) * Math.sin(LatRad));
    T = Math.tan(LatRad) * Math.tan(LatRad);
    C = eccPrimeSquared * Math.cos(LatRad) * Math.cos(LatRad);
    A = Math.cos(LatRad) * (LongRad - LongOriginRad);
    M = a * ((1 - eccSquared / 4 - 3 * eccSquared * eccSquared / 64 - 5 * eccSquared * eccSquared * eccSquared / 256) * LatRad - (3 * eccSquared / 8 + 3 * eccSquared * eccSquared / 32 + 45 * eccSquared * eccSquared * eccSquared / 1024) * Math.sin(2 * LatRad) + (15 * eccSquared * eccSquared / 256 + 45 * eccSquared * eccSquared * eccSquared / 1024) * Math.sin(4 * LatRad) - 35 * eccSquared * eccSquared * eccSquared / 3072 * Math.sin(6 * LatRad));
    var UTMEasting = k0 * N * (A + (1 - T + C) * A * A * A / 6.0 + (5 - 18 * T + T * T + 72 * C - 58 * eccPrimeSquared) * A * A * A * A * A / 120.0) + 500000.0;
    var UTMNorthing = k0 * (M + N * Math.tan(LatRad) * (A * A / 2 + (5 - T + 9 * C + 4 * C * C) * A * A * A * A / 24.0 + (61 - 58 * T + T * T + 600 * C - 330 * eccPrimeSquared) * A * A * A * A * A * A / 720.0));
    if (Lat < 0.0) UTMNorthing += 10000000.0; //10000000 meter offset for
    return {
        northing: Math.round(UTMNorthing),
        easting: Math.round(UTMEasting),
        zoneNumber: ZoneNumber,
        zoneLetter: $3371772b61ed5838$var$getLetterDesignator(Lat)
    };
}
/**
 * Converts UTM coords to lat/long, using the WGS84 ellipsoid. This is a convenience
 * class where the Zone can be specified as a single string eg."60N" which
 * is then broken down into the ZoneNumber and ZoneLetter.
 *
 * @private
 * @param {object} utm An object literal with northing, easting, zoneNumber
 *     and zoneLetter properties. If an optional accuracy property is
 *     provided (in meters), a bounding box will be returned instead of
 *     latitude and longitude.
 * @return {object} An object literal containing either lat and lon values
 *     (if no accuracy was provided), or top, right, bottom and left values
 *     for the bounding box calculated according to the provided accuracy.
 *     Returns null if the conversion failed.
 */ function $3371772b61ed5838$var$UTMtoLL(utm) {
    var UTMNorthing = utm.northing;
    var UTMEasting = utm.easting;
    var zoneLetter = utm.zoneLetter;
    var zoneNumber = utm.zoneNumber;
    // check the ZoneNummber is valid
    if (zoneNumber < 0 || zoneNumber > 60) return null;
    var k0 = 0.9996;
    var a = 6378137.0; //ellip.radius;
    var eccSquared = 0.00669438; //ellip.eccsq;
    var eccPrimeSquared;
    var e1 = (1 - Math.sqrt(1 - eccSquared)) / (1 + Math.sqrt(1 - eccSquared));
    var N1, T1, C1, R1, D, M;
    var LongOrigin;
    var mu, phi1Rad;
    // remove 500,000 meter offset for longitude
    var x = UTMEasting - 500000.0;
    var y = UTMNorthing;
    // We must know somehow if we are in the Northern or Southern
    // hemisphere, this is the only time we use the letter So even
    // if the Zone letter isn't exactly correct it should indicate
    // the hemisphere correctly
    if (zoneLetter < 'N') y -= 10000000.0; // remove 10,000,000 meter offset used
    // There are 60 zones with zone 1 being at West -180 to -174
    LongOrigin = (zoneNumber - 1) * 6 - 180 + 3; // +3 puts origin
    // in middle of
    // zone
    eccPrimeSquared = eccSquared / (1 - eccSquared);
    M = y / k0;
    mu = M / (a * (1 - eccSquared / 4 - 3 * eccSquared * eccSquared / 64 - 5 * eccSquared * eccSquared * eccSquared / 256));
    phi1Rad = mu + (3 * e1 / 2 - 27 * e1 * e1 * e1 / 32) * Math.sin(2 * mu) + (21 * e1 * e1 / 16 - 55 * e1 * e1 * e1 * e1 / 32) * Math.sin(4 * mu) + 151 * e1 * e1 * e1 / 96 * Math.sin(6 * mu);
    // double phi1 = ProjMath.radToDeg(phi1Rad);
    N1 = a / Math.sqrt(1 - eccSquared * Math.sin(phi1Rad) * Math.sin(phi1Rad));
    T1 = Math.tan(phi1Rad) * Math.tan(phi1Rad);
    C1 = eccPrimeSquared * Math.cos(phi1Rad) * Math.cos(phi1Rad);
    R1 = a * (1 - eccSquared) / Math.pow(1 - eccSquared * Math.sin(phi1Rad) * Math.sin(phi1Rad), 1.5);
    D = x / (N1 * k0);
    var lat = phi1Rad - N1 * Math.tan(phi1Rad) / R1 * (D * D / 2 - (5 + 3 * T1 + 10 * C1 - 4 * C1 * C1 - 9 * eccPrimeSquared) * D * D * D * D / 24 + (61 + 90 * T1 + 298 * C1 + 45 * T1 * T1 - 252 * eccPrimeSquared - 3 * C1 * C1) * D * D * D * D * D * D / 720);
    lat = $3371772b61ed5838$var$radToDeg(lat);
    var lon = (D - (1 + 2 * T1 + C1) * D * D * D / 6 + (5 - 2 * C1 + 28 * T1 - 3 * C1 * C1 + 8 * eccPrimeSquared + 24 * T1 * T1) * D * D * D * D * D / 120) / Math.cos(phi1Rad);
    lon = LongOrigin + $3371772b61ed5838$var$radToDeg(lon);
    var result;
    if (utm.accuracy) {
        var topRight = $3371772b61ed5838$var$UTMtoLL({
            northing: utm.northing + utm.accuracy,
            easting: utm.easting + utm.accuracy,
            zoneLetter: utm.zoneLetter,
            zoneNumber: utm.zoneNumber
        });
        result = {
            top: topRight.lat,
            right: topRight.lon,
            bottom: lat,
            left: lon
        };
    } else result = {
        lat: lat,
        lon: lon
    };
    return result;
}
/**
 * Calculates the MGRS letter designator for the given latitude.
 *
 * @private
 * @param {number} lat The latitude in WGS84 to get the letter designator
 *     for.
 * @return {char} The letter designator.
 */ function $3371772b61ed5838$var$getLetterDesignator(lat) {
    //This is here as an error flag to show that the Latitude is
    //outside MGRS limits
    var LetterDesignator = 'Z';
    if (84 >= lat && lat >= 72) LetterDesignator = 'X';
    else if (72 > lat && lat >= 64) LetterDesignator = 'W';
    else if (64 > lat && lat >= 56) LetterDesignator = 'V';
    else if (56 > lat && lat >= 48) LetterDesignator = 'U';
    else if (48 > lat && lat >= 40) LetterDesignator = 'T';
    else if (40 > lat && lat >= 32) LetterDesignator = 'S';
    else if (32 > lat && lat >= 24) LetterDesignator = 'R';
    else if (24 > lat && lat >= 16) LetterDesignator = 'Q';
    else if (16 > lat && lat >= 8) LetterDesignator = 'P';
    else if (8 > lat && lat >= 0) LetterDesignator = 'N';
    else if (0 > lat && lat >= -8) LetterDesignator = 'M';
    else if (-8 > lat && lat >= -16) LetterDesignator = 'L';
    else if (-16 > lat && lat >= -24) LetterDesignator = 'K';
    else if (-24 > lat && lat >= -32) LetterDesignator = 'J';
    else if (-32 > lat && lat >= -40) LetterDesignator = 'H';
    else if (-40 > lat && lat >= -48) LetterDesignator = 'G';
    else if (-48 > lat && lat >= -56) LetterDesignator = 'F';
    else if (-56 > lat && lat >= -64) LetterDesignator = 'E';
    else if (-64 > lat && lat >= -72) LetterDesignator = 'D';
    else if (-72 > lat && lat >= -80) LetterDesignator = 'C';
    return LetterDesignator;
}
/**
 * Encodes a UTM location as MGRS string.
 *
 * @private
 * @param {object} utm An object literal with easting, northing,
 *     zoneLetter, zoneNumber
 * @param {number} accuracy Accuracy in digits (1-5).
 * @return {string} MGRS string for the given UTM location.
 */ function $3371772b61ed5838$var$encode(utm, accuracy) {
    // prepend with leading zeroes
    var seasting = "00000" + utm.easting, snorthing = "00000" + utm.northing;
    return utm.zoneNumber + utm.zoneLetter + $3371772b61ed5838$var$get100kID(utm.easting, utm.northing, utm.zoneNumber) + seasting.substr(seasting.length - 5, accuracy) + snorthing.substr(snorthing.length - 5, accuracy);
}
/**
 * Get the two letter 100k designator for a given UTM easting,
 * northing and zone number value.
 *
 * @private
 * @param {number} easting
 * @param {number} northing
 * @param {number} zoneNumber
 * @return the two letter 100k designator for the given UTM location.
 */ function $3371772b61ed5838$var$get100kID(easting, northing, zoneNumber) {
    var setParm = $3371772b61ed5838$var$get100kSetForZone(zoneNumber);
    var setColumn = Math.floor(easting / 100000);
    var setRow = Math.floor(northing / 100000) % 20;
    return $3371772b61ed5838$var$getLetter100kID(setColumn, setRow, setParm);
}
/**
 * Given a UTM zone number, figure out the MGRS 100K set it is in.
 *
 * @private
 * @param {number} i An UTM zone number.
 * @return {number} the 100k set the UTM zone is in.
 */ function $3371772b61ed5838$var$get100kSetForZone(i) {
    var setParm = i % $3371772b61ed5838$var$NUM_100K_SETS;
    if (setParm === 0) setParm = $3371772b61ed5838$var$NUM_100K_SETS;
    return setParm;
}
/**
 * Get the two-letter MGRS 100k designator given information
 * translated from the UTM northing, easting and zone number.
 *
 * @private
 * @param {number} column the column index as it relates to the MGRS
 *        100k set spreadsheet, created from the UTM easting.
 *        Values are 1-8.
 * @param {number} row the row index as it relates to the MGRS 100k set
 *        spreadsheet, created from the UTM northing value. Values
 *        are from 0-19.
 * @param {number} parm the set block, as it relates to the MGRS 100k set
 *        spreadsheet, created from the UTM zone. Values are from
 *        1-60.
 * @return two letter MGRS 100k code.
 */ function $3371772b61ed5838$var$getLetter100kID(column, row, parm) {
    // colOrigin and rowOrigin are the letters at the origin of the set
    var index = parm - 1;
    var colOrigin = $3371772b61ed5838$var$SET_ORIGIN_COLUMN_LETTERS.charCodeAt(index);
    var rowOrigin = $3371772b61ed5838$var$SET_ORIGIN_ROW_LETTERS.charCodeAt(index);
    // colInt and rowInt are the letters to build to return
    var colInt = colOrigin + column - 1;
    var rowInt = rowOrigin + row;
    var rollover = false;
    if (colInt > $3371772b61ed5838$var$Z) {
        colInt = colInt - $3371772b61ed5838$var$Z + $3371772b61ed5838$var$A - 1;
        rollover = true;
    }
    if (colInt === $3371772b61ed5838$var$I || colOrigin < $3371772b61ed5838$var$I && colInt > $3371772b61ed5838$var$I || (colInt > $3371772b61ed5838$var$I || colOrigin < $3371772b61ed5838$var$I) && rollover) colInt++;
    if (colInt === $3371772b61ed5838$var$O || colOrigin < $3371772b61ed5838$var$O && colInt > $3371772b61ed5838$var$O || (colInt > $3371772b61ed5838$var$O || colOrigin < $3371772b61ed5838$var$O) && rollover) {
        colInt++;
        if (colInt === $3371772b61ed5838$var$I) colInt++;
    }
    if (colInt > $3371772b61ed5838$var$Z) colInt = colInt - $3371772b61ed5838$var$Z + $3371772b61ed5838$var$A - 1;
    if (rowInt > $3371772b61ed5838$var$V) {
        rowInt = rowInt - $3371772b61ed5838$var$V + $3371772b61ed5838$var$A - 1;
        rollover = true;
    } else rollover = false;
    if (rowInt === $3371772b61ed5838$var$I || rowOrigin < $3371772b61ed5838$var$I && rowInt > $3371772b61ed5838$var$I || (rowInt > $3371772b61ed5838$var$I || rowOrigin < $3371772b61ed5838$var$I) && rollover) rowInt++;
    if (rowInt === $3371772b61ed5838$var$O || rowOrigin < $3371772b61ed5838$var$O && rowInt > $3371772b61ed5838$var$O || (rowInt > $3371772b61ed5838$var$O || rowOrigin < $3371772b61ed5838$var$O) && rollover) {
        rowInt++;
        if (rowInt === $3371772b61ed5838$var$I) rowInt++;
    }
    if (rowInt > $3371772b61ed5838$var$V) rowInt = rowInt - $3371772b61ed5838$var$V + $3371772b61ed5838$var$A - 1;
    var twoLetter = String.fromCharCode(colInt) + String.fromCharCode(rowInt);
    return twoLetter;
}
/**
 * Decode the UTM parameters from a MGRS string.
 *
 * @private
 * @param {string} mgrsString an UPPERCASE coordinate string is expected.
 * @return {object} An object literal with easting, northing, zoneLetter,
 *     zoneNumber and accuracy (in meters) properties.
 */ function $3371772b61ed5838$var$decode(mgrsString) {
    if (mgrsString && mgrsString.length === 0) throw "MGRSPoint coverting from nothing";
    var length = mgrsString.length;
    var hunK = null;
    var sb = "";
    var testChar;
    var i = 0;
    // get Zone number
    while(!/[A-Z]/.test(testChar = mgrsString.charAt(i))){
        if (i >= 2) throw "MGRSPoint bad conversion from: " + mgrsString;
        sb += testChar;
        i++;
    }
    var zoneNumber = parseInt(sb, 10);
    if (i === 0 || i + 3 > length) // A good MGRS string has to be 4-5 digits long,
    // ##AAA/#AAA at least.
    throw "MGRSPoint bad conversion from: " + mgrsString;
    var zoneLetter = mgrsString.charAt(i++);
    // Should we check the zone letter here? Why not.
    if (zoneLetter <= 'A' || zoneLetter === 'B' || zoneLetter === 'Y' || zoneLetter >= 'Z' || zoneLetter === 'I' || zoneLetter === 'O') throw "MGRSPoint zone letter " + zoneLetter + " not handled: " + mgrsString;
    hunK = mgrsString.substring(i, i += 2);
    var set = $3371772b61ed5838$var$get100kSetForZone(zoneNumber);
    var east100k = $3371772b61ed5838$var$getEastingFromChar(hunK.charAt(0), set);
    var north100k = $3371772b61ed5838$var$getNorthingFromChar(hunK.charAt(1), set);
    // We have a bug where the northing may be 2000000 too low.
    // How
    // do we know when to roll over?
    while(north100k < $3371772b61ed5838$var$getMinNorthing(zoneLetter))north100k += 2000000;
    // calculate the char index for easting/northing separator
    var remainder = length - i;
    if (remainder % 2 !== 0) throw "MGRSPoint has to have an even number \nof digits after the zone letter and two 100km letters - front \nhalf for easting meters, second half for \nnorthing meters" + mgrsString;
    var sep = remainder / 2;
    var sepEasting = 0.0;
    var sepNorthing = 0.0;
    var accuracyBonus, sepEastingString, sepNorthingString, easting, northing;
    if (sep > 0) {
        accuracyBonus = 100000.0 / Math.pow(10, sep);
        sepEastingString = mgrsString.substring(i, i + sep);
        sepEasting = parseFloat(sepEastingString) * accuracyBonus;
        sepNorthingString = mgrsString.substring(i + sep);
        sepNorthing = parseFloat(sepNorthingString) * accuracyBonus;
    }
    easting = sepEasting + east100k;
    northing = sepNorthing + north100k;
    return {
        easting: easting,
        northing: northing,
        zoneLetter: zoneLetter,
        zoneNumber: zoneNumber,
        accuracy: accuracyBonus
    };
}
/**
 * Given the first letter from a two-letter MGRS 100k zone, and given the
 * MGRS table set for the zone number, figure out the easting value that
 * should be added to the other, secondary easting value.
 *
 * @private
 * @param {char} e The first letter from a two-letter MGRS 100´k zone.
 * @param {number} set The MGRS table set for the zone number.
 * @return {number} The easting value for the given letter and set.
 */ function $3371772b61ed5838$var$getEastingFromChar(e, set) {
    // colOrigin is the letter at the origin of the set for the
    // column
    var curCol = $3371772b61ed5838$var$SET_ORIGIN_COLUMN_LETTERS.charCodeAt(set - 1);
    var eastingValue = 100000.0;
    var rewindMarker = false;
    while(curCol !== e.charCodeAt(0)){
        curCol++;
        if (curCol === $3371772b61ed5838$var$I) curCol++;
        if (curCol === $3371772b61ed5838$var$O) curCol++;
        if (curCol > $3371772b61ed5838$var$Z) {
            if (rewindMarker) throw "Bad character: " + e;
            curCol = $3371772b61ed5838$var$A;
            rewindMarker = true;
        }
        eastingValue += 100000.0;
    }
    return eastingValue;
}
/**
 * Given the second letter from a two-letter MGRS 100k zone, and given the
 * MGRS table set for the zone number, figure out the northing value that
 * should be added to the other, secondary northing value. You have to
 * remember that Northings are determined from the equator, and the vertical
 * cycle of letters mean a 2000000 additional northing meters. This happens
 * approx. every 18 degrees of latitude. This method does *NOT* count any
 * additional northings. You have to figure out how many 2000000 meters need
 * to be added for the zone letter of the MGRS coordinate.
 *
 * @private
 * @param {char} n Second letter of the MGRS 100k zone
 * @param {number} set The MGRS table set number, which is dependent on the
 *     UTM zone number.
 * @return {number} The northing value for the given letter and set.
 */ function $3371772b61ed5838$var$getNorthingFromChar(n, set) {
    if (n > 'V') throw "MGRSPoint given invalid Northing " + n;
    // rowOrigin is the letter at the origin of the set for the
    // column
    var curRow = $3371772b61ed5838$var$SET_ORIGIN_ROW_LETTERS.charCodeAt(set - 1);
    var northingValue = 0.0;
    var rewindMarker = false;
    while(curRow !== n.charCodeAt(0)){
        curRow++;
        if (curRow === $3371772b61ed5838$var$I) curRow++;
        if (curRow === $3371772b61ed5838$var$O) curRow++;
        // fixing a bug making whole application hang in this loop
        // when 'n' is a wrong character
        if (curRow > $3371772b61ed5838$var$V) {
            if (rewindMarker) throw "Bad character: " + n;
            curRow = $3371772b61ed5838$var$A;
            rewindMarker = true;
        }
        northingValue += 100000.0;
    }
    return northingValue;
}
/**
 * The function getMinNorthing returns the minimum northing value of a MGRS
 * zone.
 *
 * Ported from Geotrans' c Lattitude_Band_Value structure table.
 *
 * @private
 * @param {char} zoneLetter The MGRS zone to get the min northing for.
 * @return {number}
 */ function $3371772b61ed5838$var$getMinNorthing(zoneLetter) {
    var northing;
    switch(zoneLetter){
        case 'C':
            northing = 1100000.0;
            break;
        case 'D':
            northing = 2000000.0;
            break;
        case 'E':
            northing = 2800000.0;
            break;
        case 'F':
            northing = 3700000.0;
            break;
        case 'G':
            northing = 4600000.0;
            break;
        case 'H':
            northing = 5500000.0;
            break;
        case 'J':
            northing = 6400000.0;
            break;
        case 'K':
            northing = 7300000.0;
            break;
        case 'L':
            northing = 8200000.0;
            break;
        case 'M':
            northing = 9100000.0;
            break;
        case 'N':
            northing = 0.0;
            break;
        case 'P':
            northing = 800000.0;
            break;
        case 'Q':
            northing = 1700000.0;
            break;
        case 'R':
            northing = 2600000.0;
            break;
        case 'S':
            northing = 3500000.0;
            break;
        case 'T':
            northing = 4400000.0;
            break;
        case 'U':
            northing = 5300000.0;
            break;
        case 'V':
            northing = 6200000.0;
            break;
        case 'W':
            northing = 7000000.0;
            break;
        case 'X':
            northing = 7900000.0;
            break;
        default:
            northing = -1;
    }
    if (northing >= 0.0) return northing;
    else throw "Invalid zone letter: " + zoneLetter;
}


/**
 * @deprecated v3.0.0 - use proj4.toPoint instead
 * @param {number | import('./core').TemplateCoordinates | string} x
 * @param {number} [y]
 * @param {number} [z]
 */ function $455525ad3f9d7fbc$var$Point(x, y, z) {
    if (!(this instanceof $455525ad3f9d7fbc$var$Point)) return new $455525ad3f9d7fbc$var$Point(x, y, z);
    if (Array.isArray(x)) {
        this.x = x[0];
        this.y = x[1];
        this.z = x[2] || 0.0;
    } else if (typeof x === 'object') {
        this.x = x.x;
        this.y = x.y;
        this.z = x.z || 0.0;
    } else if (typeof x === 'string' && typeof y === 'undefined') {
        var coords = x.split(',');
        this.x = parseFloat(coords[0]);
        this.y = parseFloat(coords[1]);
        this.z = parseFloat(coords[2]) || 0.0;
    } else {
        this.x = x;
        this.y = y;
        this.z = z || 0.0;
    }
    console.warn('proj4.Point will be removed in version 3, use proj4.toPoint');
}
$455525ad3f9d7fbc$var$Point.fromMGRS = function(mgrsStr) {
    return new $455525ad3f9d7fbc$var$Point((0, $3371772b61ed5838$export$b63cca88ddc558a9)(mgrsStr));
};
$455525ad3f9d7fbc$var$Point.prototype.toMGRS = function(accuracy) {
    return (0, $3371772b61ed5838$export$174bb771924e7eb1)([
        this.x,
        this.y
    ], accuracy);
};
var $455525ad3f9d7fbc$export$2e2bcd8739ae039 = $455525ad3f9d7fbc$var$Point;








var $2frHl = parcelRequire("2frHl");

var $cgjtm = parcelRequire("cgjtm");

var $eRFTg = parcelRequire("eRFTg");
function $4e6957bd05a6aa16$export$2e2bcd8739ae039(zone, lon) {
    if (zone === undefined) {
        zone = Math.floor(((0, $eRFTg.default)(lon) + Math.PI) * 30 / Math.PI) + 1;
        if (zone < 0) return 0;
        else if (zone > 60) return 60;
    }
    return zone;
}



var $cgjtm = parcelRequire("cgjtm");

var $jDCGO = parcelRequire("jDCGO");
var $eb76c2980de5c027$export$3f91ef0e0d0d8bf8 = 'etmerc';
function $eb76c2980de5c027$export$2cd8252107eb640b() {
    var zone = (0, $4e6957bd05a6aa16$export$2e2bcd8739ae039)(this.zone, this.long0);
    if (zone === undefined) throw new Error('unknown utm zone');
    this.lat0 = 0;
    this.long0 = (6 * Math.abs(zone) - 183) * (0, $jDCGO.D2R);
    this.x0 = 500000;
    this.y0 = this.utmSouth ? 10000000 : 0;
    this.k0 = 0.9996;
    (0, $cgjtm.default).init.apply(this);
    this.forward = (0, $cgjtm.default).forward;
    this.inverse = (0, $cgjtm.default).inverse;
}
var $eb76c2980de5c027$export$e4b2ac9215619f8d = [
    'Universal Transverse Mercator System',
    'utm'
];
var $eb76c2980de5c027$export$2e2bcd8739ae039 = {
    init: $eb76c2980de5c027$export$2cd8252107eb640b,
    names: $eb76c2980de5c027$export$e4b2ac9215619f8d,
    dependsOn: $eb76c2980de5c027$export$3f91ef0e0d0d8bf8
};


function $5c86a46faa639ce5$export$2e2bcd8739ae039(esinp, exp) {
    return Math.pow((1 - esinp) / (1 + esinp), exp);
}



var $jDCGO = parcelRequire("jDCGO");
var $9f947445b6467013$var$MAX_ITER = 20;
function $9f947445b6467013$export$2cd8252107eb640b() {
    var sphi = Math.sin(this.lat0);
    var cphi = Math.cos(this.lat0);
    cphi *= cphi;
    this.rc = Math.sqrt(1 - this.es) / (1 - this.es * sphi * sphi);
    this.C = Math.sqrt(1 + this.es * cphi * cphi / (1 - this.es));
    this.phic0 = Math.asin(sphi / this.C);
    this.ratexp = 0.5 * this.C * this.e;
    this.K = Math.tan(0.5 * this.phic0 + (0, $jDCGO.FORTPI)) / (Math.pow(Math.tan(0.5 * this.lat0 + (0, $jDCGO.FORTPI)), this.C) * (0, $5c86a46faa639ce5$export$2e2bcd8739ae039)(this.e * sphi, this.ratexp));
}
function $9f947445b6467013$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    p.y = 2 * Math.atan(this.K * Math.pow(Math.tan(0.5 * lat + (0, $jDCGO.FORTPI)), this.C) * (0, $5c86a46faa639ce5$export$2e2bcd8739ae039)(this.e * Math.sin(lat), this.ratexp)) - (0, $jDCGO.HALF_PI);
    p.x = this.C * lon;
    return p;
}
function $9f947445b6467013$export$70ae2c07e401031b(p) {
    var DEL_TOL = 1e-14;
    var lon = p.x / this.C;
    var lat = p.y;
    var num = Math.pow(Math.tan(0.5 * lat + (0, $jDCGO.FORTPI)) / this.K, 1 / this.C);
    for(var i = $9f947445b6467013$var$MAX_ITER; i > 0; --i){
        lat = 2 * Math.atan(num * (0, $5c86a46faa639ce5$export$2e2bcd8739ae039)(this.e * Math.sin(p.y), -0.5 * this.e)) - (0, $jDCGO.HALF_PI);
        if (Math.abs(lat - p.y) < DEL_TOL) break;
        p.y = lat;
    }
    /* convergence failed */ if (!i) return null;
    p.x = lon;
    p.y = lat;
    return p;
}
var $9f947445b6467013$export$e4b2ac9215619f8d = [
    'gauss'
];
var $9f947445b6467013$export$2e2bcd8739ae039 = {
    init: $9f947445b6467013$export$2cd8252107eb640b,
    forward: $9f947445b6467013$export$174bb771924e7eb1,
    inverse: $9f947445b6467013$export$70ae2c07e401031b,
    names: $9f947445b6467013$export$e4b2ac9215619f8d
};



var $eRFTg = parcelRequire("eRFTg");

var $3ZcmO = parcelRequire("3ZcmO");
function $8cb6f78e1febc8ee$export$2cd8252107eb640b() {
    (0, $9f947445b6467013$export$2e2bcd8739ae039).init.apply(this);
    if (!this.rc) return;
    this.sinc0 = Math.sin(this.phic0);
    this.cosc0 = Math.cos(this.phic0);
    this.R2 = 2 * this.rc;
    if (!this.title) this.title = 'Oblique Stereographic Alternative';
}
function $8cb6f78e1febc8ee$export$174bb771924e7eb1(p) {
    var sinc, cosc, cosl, k;
    p.x = (0, $eRFTg.default)(p.x - this.long0, this.over);
    (0, $9f947445b6467013$export$2e2bcd8739ae039).forward.apply(this, [
        p
    ]);
    sinc = Math.sin(p.y);
    cosc = Math.cos(p.y);
    cosl = Math.cos(p.x);
    k = this.k0 * this.R2 / (1 + this.sinc0 * sinc + this.cosc0 * cosc * cosl);
    p.x = k * cosc * Math.sin(p.x);
    p.y = k * (this.cosc0 * sinc - this.sinc0 * cosc * cosl);
    p.x = this.a * p.x + this.x0;
    p.y = this.a * p.y + this.y0;
    return p;
}
function $8cb6f78e1febc8ee$export$70ae2c07e401031b(p) {
    var sinc, cosc, lon, lat, rho;
    p.x = (p.x - this.x0) / this.a;
    p.y = (p.y - this.y0) / this.a;
    p.x /= this.k0;
    p.y /= this.k0;
    if (rho = (0, $3ZcmO.default)(p.x, p.y)) {
        var c = 2 * Math.atan2(rho, this.R2);
        sinc = Math.sin(c);
        cosc = Math.cos(c);
        lat = Math.asin(cosc * this.sinc0 + p.y * sinc * this.cosc0 / rho);
        lon = Math.atan2(p.x * sinc, rho * this.cosc0 * cosc - p.y * this.sinc0 * sinc);
    } else {
        lat = this.phic0;
        lon = 0;
    }
    p.x = lon;
    p.y = lat;
    (0, $9f947445b6467013$export$2e2bcd8739ae039).inverse.apply(this, [
        p
    ]);
    p.x = (0, $eRFTg.default)(p.x + this.long0, this.over);
    return p;
}
var $8cb6f78e1febc8ee$export$e4b2ac9215619f8d = [
    'Stereographic_North_Pole',
    'Oblique_Stereographic',
    'sterea',
    'Oblique Stereographic Alternative',
    'Double_Stereographic'
];
var $8cb6f78e1febc8ee$export$2e2bcd8739ae039 = {
    init: $8cb6f78e1febc8ee$export$2cd8252107eb640b,
    forward: $8cb6f78e1febc8ee$export$174bb771924e7eb1,
    inverse: $8cb6f78e1febc8ee$export$70ae2c07e401031b,
    names: $8cb6f78e1febc8ee$export$e4b2ac9215619f8d
};



var $jDCGO = parcelRequire("jDCGO");

var $VoZg4 = parcelRequire("VoZg4");

var $96xAh = parcelRequire("96xAh");



var $eRFTg = parcelRequire("eRFTg");
function $e758b706eb2443fd$export$8adc077b4b982c95(phit, sinphi, eccen) {
    sinphi *= eccen;
    return Math.tan(0.5 * ((0, $jDCGO.HALF_PI) + phit)) * Math.pow((1 - sinphi) / (1 + sinphi), 0.5 * eccen);
}
function $e758b706eb2443fd$export$2cd8252107eb640b() {
    // setting default parameters
    this.x0 = this.x0 || 0;
    this.y0 = this.y0 || 0;
    this.lat0 = this.lat0 || 0;
    this.long0 = this.long0 || 0;
    this.coslat0 = Math.cos(this.lat0);
    this.sinlat0 = Math.sin(this.lat0);
    if (this.sphere) {
        if (this.k0 === 1 && !isNaN(this.lat_ts) && Math.abs(this.coslat0) <= (0, $jDCGO.EPSLN)) this.k0 = 0.5 * (1 + (0, $VoZg4.default)(this.lat0) * Math.sin(this.lat_ts));
    } else {
        if (Math.abs(this.coslat0) <= (0, $jDCGO.EPSLN)) {
            if (this.lat0 > 0) // North pole
            // trace('stere:north pole');
            this.con = 1;
            else // South pole
            // trace('stere:south pole');
            this.con = -1;
        }
        this.cons = Math.sqrt(Math.pow(1 + this.e, 1 + this.e) * Math.pow(1 - this.e, 1 - this.e));
        if (this.k0 === 1 && !isNaN(this.lat_ts) && Math.abs(this.coslat0) <= (0, $jDCGO.EPSLN) && Math.abs(Math.cos(this.lat_ts)) > (0, $jDCGO.EPSLN)) // When k0 is 1 (default value) and lat_ts is a vaild number and lat0 is at a pole and lat_ts is not at a pole
        // Recalculate k0 using formula 21-35 from p161 of Snyder, 1987
        this.k0 = 0.5 * this.cons * (0, $96xAh.default)(this.e, Math.sin(this.lat_ts), Math.cos(this.lat_ts)) / (0, $9bbed77786baf8a2$export$2e2bcd8739ae039)(this.e, this.con * this.lat_ts, this.con * Math.sin(this.lat_ts));
        this.ms1 = (0, $96xAh.default)(this.e, this.sinlat0, this.coslat0);
        this.X0 = 2 * Math.atan($e758b706eb2443fd$export$8adc077b4b982c95(this.lat0, this.sinlat0, this.e)) - (0, $jDCGO.HALF_PI);
        this.cosX0 = Math.cos(this.X0);
        this.sinX0 = Math.sin(this.X0);
    }
}
function $e758b706eb2443fd$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    var sinlat = Math.sin(lat);
    var coslat = Math.cos(lat);
    var A, X, sinX, cosX, ts, rh;
    var dlon = (0, $eRFTg.default)(lon - this.long0, this.over);
    if (Math.abs(Math.abs(lon - this.long0) - Math.PI) <= (0, $jDCGO.EPSLN) && Math.abs(lat + this.lat0) <= (0, $jDCGO.EPSLN)) {
        // case of the origine point
        // trace('stere:this is the origin point');
        p.x = NaN;
        p.y = NaN;
        return p;
    }
    if (this.sphere) {
        // trace('stere:sphere case');
        A = 2 * this.k0 / (1 + this.sinlat0 * sinlat + this.coslat0 * coslat * Math.cos(dlon));
        p.x = this.a * A * coslat * Math.sin(dlon) + this.x0;
        p.y = this.a * A * (this.coslat0 * sinlat - this.sinlat0 * coslat * Math.cos(dlon)) + this.y0;
        return p;
    } else {
        X = 2 * Math.atan($e758b706eb2443fd$export$8adc077b4b982c95(lat, sinlat, this.e)) - (0, $jDCGO.HALF_PI);
        cosX = Math.cos(X);
        sinX = Math.sin(X);
        if (Math.abs(this.coslat0) <= (0, $jDCGO.EPSLN)) {
            ts = (0, $9bbed77786baf8a2$export$2e2bcd8739ae039)(this.e, lat * this.con, this.con * sinlat);
            rh = 2 * this.a * this.k0 * ts / this.cons;
            p.x = this.x0 + rh * Math.sin(lon - this.long0);
            p.y = this.y0 - this.con * rh * Math.cos(lon - this.long0);
            // trace(p.toString());
            return p;
        } else if (Math.abs(this.sinlat0) < (0, $jDCGO.EPSLN)) {
            // Eq
            // trace('stere:equateur');
            A = 2 * this.a * this.k0 / (1 + cosX * Math.cos(dlon));
            p.y = A * sinX;
        } else {
            // other case
            // trace('stere:normal case');
            A = 2 * this.a * this.k0 * this.ms1 / (this.cosX0 * (1 + this.sinX0 * sinX + this.cosX0 * cosX * Math.cos(dlon)));
            p.y = A * (this.cosX0 * sinX - this.sinX0 * cosX * Math.cos(dlon)) + this.y0;
        }
        p.x = A * cosX * Math.sin(dlon) + this.x0;
    }
    // trace(p.toString());
    return p;
}
function $e758b706eb2443fd$export$70ae2c07e401031b(p) {
    p.x -= this.x0;
    p.y -= this.y0;
    var lon, lat, ts, ce, Chi;
    var rh = Math.sqrt(p.x * p.x + p.y * p.y);
    if (this.sphere) {
        var c = 2 * Math.atan(rh / (2 * this.a * this.k0));
        lon = this.long0;
        lat = this.lat0;
        if (rh <= (0, $jDCGO.EPSLN)) {
            p.x = lon;
            p.y = lat;
            return p;
        }
        lat = Math.asin(Math.cos(c) * this.sinlat0 + p.y * Math.sin(c) * this.coslat0 / rh);
        if (Math.abs(this.coslat0) < (0, $jDCGO.EPSLN)) {
            if (this.lat0 > 0) lon = (0, $eRFTg.default)(this.long0 + Math.atan2(p.x, -1 * p.y), this.over);
            else lon = (0, $eRFTg.default)(this.long0 + Math.atan2(p.x, p.y), this.over);
        } else lon = (0, $eRFTg.default)(this.long0 + Math.atan2(p.x * Math.sin(c), rh * this.coslat0 * Math.cos(c) - p.y * this.sinlat0 * Math.sin(c)), this.over);
        p.x = lon;
        p.y = lat;
        return p;
    } else if (Math.abs(this.coslat0) <= (0, $jDCGO.EPSLN)) {
        if (rh <= (0, $jDCGO.EPSLN)) {
            lat = this.lat0;
            lon = this.long0;
            p.x = lon;
            p.y = lat;
            // trace(p.toString());
            return p;
        }
        p.x *= this.con;
        p.y *= this.con;
        ts = rh * this.cons / (2 * this.a * this.k0);
        lat = this.con * (0, $1669155a5b2076cb$export$2e2bcd8739ae039)(this.e, ts);
        lon = this.con * (0, $eRFTg.default)(this.con * this.long0 + Math.atan2(p.x, -1 * p.y), this.over);
    } else {
        ce = 2 * Math.atan(rh * this.cosX0 / (2 * this.a * this.k0 * this.ms1));
        lon = this.long0;
        if (rh <= (0, $jDCGO.EPSLN)) Chi = this.X0;
        else {
            Chi = Math.asin(Math.cos(ce) * this.sinX0 + p.y * Math.sin(ce) * this.cosX0 / rh);
            lon = (0, $eRFTg.default)(this.long0 + Math.atan2(p.x * Math.sin(ce), rh * this.cosX0 * Math.cos(ce) - p.y * this.sinX0 * Math.sin(ce)), this.over);
        }
        lat = -1 * (0, $1669155a5b2076cb$export$2e2bcd8739ae039)(this.e, Math.tan(0.5 * ((0, $jDCGO.HALF_PI) + Chi)));
    }
    p.x = lon;
    p.y = lat;
    // trace(p.toString());
    return p;
}
var $e758b706eb2443fd$export$e4b2ac9215619f8d = [
    'stere',
    'Stereographic_South_Pole',
    'Polar_Stereographic_variant_A',
    'Polar_Stereographic_variant_B',
    'Polar_Stereographic'
];
var $e758b706eb2443fd$export$2e2bcd8739ae039 = {
    init: $e758b706eb2443fd$export$2cd8252107eb640b,
    forward: $e758b706eb2443fd$export$174bb771924e7eb1,
    inverse: $e758b706eb2443fd$export$70ae2c07e401031b,
    names: $e758b706eb2443fd$export$e4b2ac9215619f8d,
    ssfn_: $e758b706eb2443fd$export$8adc077b4b982c95
};


/*
  references:
    Formules et constantes pour le Calcul pour la
    projection cylindrique conforme à axe oblique et pour la transformation entre
    des systèmes de référence.
    http://www.swisstopo.admin.ch/internet/swisstopo/fr/home/topics/survey/sys/refsys/switzerland.parsysrelated1.31216.downloadList.77004.DownloadFile.tmp/swissprojectionfr.pdf
  */ /**
 * @typedef {Object} LocalThis
 * @property {number} lambda0
 * @property {number} e
 * @property {number} R
 * @property {number} b0
 * @property {number} K
 */ /** @this {import('../defs.js').ProjectionDefinition & LocalThis} */ function $cfa069f4b27cf0f3$export$2cd8252107eb640b() {
    var phy0 = this.lat0;
    this.lambda0 = this.long0;
    var sinPhy0 = Math.sin(phy0);
    var semiMajorAxis = this.a;
    var invF = this.rf;
    var flattening = 1 / invF;
    var e2 = 2 * flattening - Math.pow(flattening, 2);
    var e = this.e = Math.sqrt(e2);
    this.R = this.k0 * semiMajorAxis * Math.sqrt(1 - e2) / (1 - e2 * Math.pow(sinPhy0, 2));
    this.alpha = Math.sqrt(1 + e2 / (1 - e2) * Math.pow(Math.cos(phy0), 4));
    this.b0 = Math.asin(sinPhy0 / this.alpha);
    var k1 = Math.log(Math.tan(Math.PI / 4 + this.b0 / 2));
    var k2 = Math.log(Math.tan(Math.PI / 4 + phy0 / 2));
    var k3 = Math.log((1 + e * sinPhy0) / (1 - e * sinPhy0));
    this.K = k1 - this.alpha * k2 + this.alpha * e / 2 * k3;
}
function $cfa069f4b27cf0f3$export$174bb771924e7eb1(p) {
    var Sa1 = Math.log(Math.tan(Math.PI / 4 - p.y / 2));
    var Sa2 = this.e / 2 * Math.log((1 + this.e * Math.sin(p.y)) / (1 - this.e * Math.sin(p.y)));
    var S = -this.alpha * (Sa1 + Sa2) + this.K;
    // spheric latitude
    var b = 2 * (Math.atan(Math.exp(S)) - Math.PI / 4);
    // spheric longitude
    var I = this.alpha * (p.x - this.lambda0);
    // psoeudo equatorial rotation
    var rotI = Math.atan(Math.sin(I) / (Math.sin(this.b0) * Math.tan(b) + Math.cos(this.b0) * Math.cos(I)));
    var rotB = Math.asin(Math.cos(this.b0) * Math.sin(b) - Math.sin(this.b0) * Math.cos(b) * Math.cos(I));
    p.y = this.R / 2 * Math.log((1 + Math.sin(rotB)) / (1 - Math.sin(rotB))) + this.y0;
    p.x = this.R * rotI + this.x0;
    return p;
}
function $cfa069f4b27cf0f3$export$70ae2c07e401031b(p) {
    var Y = p.x - this.x0;
    var X = p.y - this.y0;
    var rotI = Y / this.R;
    var rotB = 2 * (Math.atan(Math.exp(X / this.R)) - Math.PI / 4);
    var b = Math.asin(Math.cos(this.b0) * Math.sin(rotB) + Math.sin(this.b0) * Math.cos(rotB) * Math.cos(rotI));
    var I = Math.atan(Math.sin(rotI) / (Math.cos(this.b0) * Math.cos(rotI) - Math.sin(this.b0) * Math.tan(rotB)));
    var lambda = this.lambda0 + I / this.alpha;
    var S = 0;
    var phy = b;
    var prevPhy = -1000;
    var iteration = 0;
    while(Math.abs(phy - prevPhy) > 0.0000001){
        if (++iteration > 20) // ...reportError("omercFwdInfinity");
        return;
        // S = Math.log(Math.tan(Math.PI / 4 + phy / 2));
        S = 1 / this.alpha * (Math.log(Math.tan(Math.PI / 4 + b / 2)) - this.K) + this.e * Math.log(Math.tan(Math.PI / 4 + Math.asin(this.e * Math.sin(phy)) / 2));
        prevPhy = phy;
        phy = 2 * Math.atan(Math.exp(S)) - Math.PI / 2;
    }
    p.x = lambda;
    p.y = phy;
    return p;
}
var $cfa069f4b27cf0f3$export$e4b2ac9215619f8d = [
    'somerc'
];
var $cfa069f4b27cf0f3$export$2e2bcd8739ae039 = {
    init: $cfa069f4b27cf0f3$export$2cd8252107eb640b,
    forward: $cfa069f4b27cf0f3$export$174bb771924e7eb1,
    inverse: $cfa069f4b27cf0f3$export$70ae2c07e401031b,
    names: $cfa069f4b27cf0f3$export$e4b2ac9215619f8d
};




var $eRFTg = parcelRequire("eRFTg");


var $jDCGO = parcelRequire("jDCGO");

/**
 * @typedef {Object} LocalThis
 * @property {boolean} no_off
 * @property {boolean} no_rot
 * @property {number} rectified_grid_angle
 * @property {number} es
 * @property {number} A
 * @property {number} B
 * @property {number} E
 * @property {number} e
 * @property {number} lam0
 * @property {number} singam
 * @property {number} cosgam
 * @property {number} sinrot
 * @property {number} cosrot
 * @property {number} rB
 * @property {number} ArB
 * @property {number} BrA
 * @property {number} u_0
 * @property {number} v_pole_n
 * @property {number} v_pole_s
 */ var $2aeff16c09dccd5b$var$TOL = 1e-7;
function $2aeff16c09dccd5b$var$isTypeA(P) {
    var typeAProjections = [
        'Hotine_Oblique_Mercator',
        'Hotine_Oblique_Mercator_variant_A',
        'Hotine_Oblique_Mercator_Azimuth_Natural_Origin'
    ];
    var projectionName = typeof P.projName === 'object' ? Object.keys(P.projName)[0] : P.projName;
    return 'no_uoff' in P || 'no_off' in P || typeAProjections.indexOf(projectionName) !== -1 || typeAProjections.indexOf((0, $9b3a1b7aca3fbe1b$export$9ee0bb5510679155)(projectionName)) !== -1;
}
function $2aeff16c09dccd5b$export$2cd8252107eb640b() {
    var con, com, cosph0, D, F, H, L, sinph0, p, J, gamma = 0, gamma0, lamc = 0, lam1 = 0, lam2 = 0, phi1 = 0, phi2 = 0, alpha_c = 0;
    // only Type A uses the no_off or no_uoff property
    // https://github.com/OSGeo/proj.4/issues/104
    this.no_off = $2aeff16c09dccd5b$var$isTypeA(this);
    this.no_rot = 'no_rot' in this;
    var alp = false;
    if ('alpha' in this) alp = true;
    var gam = false;
    if ('rectified_grid_angle' in this) gam = true;
    if (alp) alpha_c = this.alpha;
    if (gam) gamma = this.rectified_grid_angle;
    if (alp || gam) lamc = this.longc;
    else {
        lam1 = this.long1;
        phi1 = this.lat1;
        lam2 = this.long2;
        phi2 = this.lat2;
        if (Math.abs(phi1 - phi2) <= $2aeff16c09dccd5b$var$TOL || (con = Math.abs(phi1)) <= $2aeff16c09dccd5b$var$TOL || Math.abs(con - (0, $jDCGO.HALF_PI)) <= $2aeff16c09dccd5b$var$TOL || Math.abs(Math.abs(this.lat0) - (0, $jDCGO.HALF_PI)) <= $2aeff16c09dccd5b$var$TOL || Math.abs(Math.abs(phi2) - (0, $jDCGO.HALF_PI)) <= $2aeff16c09dccd5b$var$TOL) throw new Error();
    }
    var one_es = 1.0 - this.es;
    com = Math.sqrt(one_es);
    if (Math.abs(this.lat0) > (0, $jDCGO.EPSLN)) {
        sinph0 = Math.sin(this.lat0);
        cosph0 = Math.cos(this.lat0);
        con = 1 - this.es * sinph0 * sinph0;
        this.B = cosph0 * cosph0;
        this.B = Math.sqrt(1 + this.es * this.B * this.B / one_es);
        this.A = this.B * this.k0 * com / con;
        D = this.B * com / (cosph0 * Math.sqrt(con));
        F = D * D - 1;
        if (F <= 0) F = 0;
        else {
            F = Math.sqrt(F);
            if (this.lat0 < 0) F = -F;
        }
        this.E = F += D;
        this.E *= Math.pow((0, $9bbed77786baf8a2$export$2e2bcd8739ae039)(this.e, this.lat0, sinph0), this.B);
    } else {
        this.B = 1 / com;
        this.A = this.k0;
        this.E = D = F = 1;
    }
    if (alp || gam) {
        if (alp) {
            gamma0 = Math.asin(Math.sin(alpha_c) / D);
            if (!gam) gamma = alpha_c;
        } else {
            gamma0 = gamma;
            alpha_c = Math.asin(D * Math.sin(gamma0));
        }
        this.lam0 = lamc - Math.asin(0.5 * (F - 1 / F) * Math.tan(gamma0)) / this.B;
    } else {
        H = Math.pow((0, $9bbed77786baf8a2$export$2e2bcd8739ae039)(this.e, phi1, Math.sin(phi1)), this.B);
        L = Math.pow((0, $9bbed77786baf8a2$export$2e2bcd8739ae039)(this.e, phi2, Math.sin(phi2)), this.B);
        F = this.E / H;
        p = (L - H) / (L + H);
        J = this.E * this.E;
        J = (J - L * H) / (J + L * H);
        con = lam1 - lam2;
        if (con < -Math.PI) lam2 -= (0, $jDCGO.TWO_PI);
        else if (con > Math.PI) lam2 += (0, $jDCGO.TWO_PI);
        this.lam0 = (0, $eRFTg.default)(0.5 * (lam1 + lam2) - Math.atan(J * Math.tan(0.5 * this.B * (lam1 - lam2)) / p) / this.B, this.over);
        gamma0 = Math.atan(2 * Math.sin(this.B * (0, $eRFTg.default)(lam1 - this.lam0, this.over)) / (F - 1 / F));
        gamma = alpha_c = Math.asin(D * Math.sin(gamma0));
    }
    this.singam = Math.sin(gamma0);
    this.cosgam = Math.cos(gamma0);
    this.sinrot = Math.sin(gamma);
    this.cosrot = Math.cos(gamma);
    this.rB = 1 / this.B;
    this.ArB = this.A * this.rB;
    this.BrA = 1 / this.ArB;
    if (this.no_off) this.u_0 = 0;
    else {
        this.u_0 = Math.abs(this.ArB * Math.atan(Math.sqrt(D * D - 1) / Math.cos(alpha_c)));
        if (this.lat0 < 0) this.u_0 = -this.u_0;
    }
    F = 0.5 * gamma0;
    this.v_pole_n = this.ArB * Math.log(Math.tan((0, $jDCGO.FORTPI) - F));
    this.v_pole_s = this.ArB * Math.log(Math.tan((0, $jDCGO.FORTPI) + F));
}
function $2aeff16c09dccd5b$export$174bb771924e7eb1(p) {
    var coords = {};
    var S, T, U, V, W, temp, u, v;
    p.x = p.x - this.lam0;
    if (Math.abs(Math.abs(p.y) - (0, $jDCGO.HALF_PI)) > (0, $jDCGO.EPSLN)) {
        W = this.E / Math.pow((0, $9bbed77786baf8a2$export$2e2bcd8739ae039)(this.e, p.y, Math.sin(p.y)), this.B);
        temp = 1 / W;
        S = 0.5 * (W - temp);
        T = 0.5 * (W + temp);
        V = Math.sin(this.B * p.x);
        U = (S * this.singam - V * this.cosgam) / T;
        if (Math.abs(Math.abs(U) - 1.0) < (0, $jDCGO.EPSLN)) throw new Error();
        v = 0.5 * this.ArB * Math.log((1 - U) / (1 + U));
        temp = Math.cos(this.B * p.x);
        if (Math.abs(temp) < $2aeff16c09dccd5b$var$TOL) u = this.A * p.x;
        else u = this.ArB * Math.atan2(S * this.cosgam + V * this.singam, temp);
    } else {
        v = p.y > 0 ? this.v_pole_n : this.v_pole_s;
        u = this.ArB * p.y;
    }
    if (this.no_rot) {
        coords.x = u;
        coords.y = v;
    } else {
        u -= this.u_0;
        coords.x = v * this.cosrot + u * this.sinrot;
        coords.y = u * this.cosrot - v * this.sinrot;
    }
    coords.x = this.a * coords.x + this.x0;
    coords.y = this.a * coords.y + this.y0;
    return coords;
}
function $2aeff16c09dccd5b$export$70ae2c07e401031b(p) {
    var u, v, Qp, Sp, Tp, Vp, Up;
    var coords = {};
    p.x = (p.x - this.x0) * (1.0 / this.a);
    p.y = (p.y - this.y0) * (1.0 / this.a);
    if (this.no_rot) {
        v = p.y;
        u = p.x;
    } else {
        v = p.x * this.cosrot - p.y * this.sinrot;
        u = p.y * this.cosrot + p.x * this.sinrot + this.u_0;
    }
    Qp = Math.exp(-this.BrA * v);
    Sp = 0.5 * (Qp - 1 / Qp);
    Tp = 0.5 * (Qp + 1 / Qp);
    Vp = Math.sin(this.BrA * u);
    Up = (Vp * this.cosgam + Sp * this.singam) / Tp;
    if (Math.abs(Math.abs(Up) - 1) < (0, $jDCGO.EPSLN)) {
        coords.x = 0;
        coords.y = Up < 0 ? -(0, $jDCGO.HALF_PI) : (0, $jDCGO.HALF_PI);
    } else {
        coords.y = this.E / Math.sqrt((1 + Up) / (1 - Up));
        coords.y = (0, $1669155a5b2076cb$export$2e2bcd8739ae039)(this.e, Math.pow(coords.y, 1 / this.B));
        if (coords.y === Infinity) throw new Error();
        coords.x = -this.rB * Math.atan2(Sp * this.cosgam - Vp * this.singam, Math.cos(this.BrA * u));
    }
    coords.x += this.lam0;
    return coords;
}
var $2aeff16c09dccd5b$export$e4b2ac9215619f8d = [
    'Hotine_Oblique_Mercator',
    'Hotine Oblique Mercator',
    'Hotine_Oblique_Mercator_variant_A',
    'Hotine_Oblique_Mercator_Variant_B',
    'Hotine_Oblique_Mercator_Azimuth_Natural_Origin',
    'Hotine_Oblique_Mercator_Two_Point_Natural_Origin',
    'Hotine_Oblique_Mercator_Azimuth_Center',
    'Oblique_Mercator',
    'omerc'
];
var $2aeff16c09dccd5b$export$2e2bcd8739ae039 = {
    init: $2aeff16c09dccd5b$export$2cd8252107eb640b,
    forward: $2aeff16c09dccd5b$export$174bb771924e7eb1,
    inverse: $2aeff16c09dccd5b$export$70ae2c07e401031b,
    names: $2aeff16c09dccd5b$export$e4b2ac9215619f8d
};



var $96xAh = parcelRequire("96xAh");


var $VoZg4 = parcelRequire("VoZg4");

var $eRFTg = parcelRequire("eRFTg");


var $jDCGO = parcelRequire("jDCGO");
function $b19a30a478e73c5c$export$2cd8252107eb640b() {
    // double lat0;                    /* the reference latitude               */
    // double long0;                   /* the reference longitude              */
    // double lat1;                    /* first standard parallel              */
    // double lat2;                    /* second standard parallel             */
    // double r_maj;                   /* major axis                           */
    // double r_min;                   /* minor axis                           */
    // double false_east;              /* x offset in meters                   */
    // double false_north;             /* y offset in meters                   */
    // the above value can be set with proj4.defs
    // example: proj4.defs("EPSG:2154","+proj=lcc +lat_1=49 +lat_2=44 +lat_0=46.5 +lon_0=3 +x_0=700000 +y_0=6600000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs");
    if (!this.lat2) this.lat2 = this.lat1;
     // if lat2 is not defined
    if (!this.k0) this.k0 = 1;
    this.x0 = this.x0 || 0;
    this.y0 = this.y0 || 0;
    // Standard Parallels cannot be equal and on opposite sides of the equator
    if (Math.abs(this.lat1 + this.lat2) < (0, $jDCGO.EPSLN)) return;
    var temp = this.b / this.a;
    this.e = Math.sqrt(1 - temp * temp);
    var sin1 = Math.sin(this.lat1);
    var cos1 = Math.cos(this.lat1);
    var ms1 = (0, $96xAh.default)(this.e, sin1, cos1);
    var ts1 = (0, $9bbed77786baf8a2$export$2e2bcd8739ae039)(this.e, this.lat1, sin1);
    var sin2 = Math.sin(this.lat2);
    var cos2 = Math.cos(this.lat2);
    var ms2 = (0, $96xAh.default)(this.e, sin2, cos2);
    var ts2 = (0, $9bbed77786baf8a2$export$2e2bcd8739ae039)(this.e, this.lat2, sin2);
    var ts0 = Math.abs(Math.abs(this.lat0) - (0, $jDCGO.HALF_PI)) < (0, $jDCGO.EPSLN) ? 0 // Handle poles by setting ts0 to 0
     : (0, $9bbed77786baf8a2$export$2e2bcd8739ae039)(this.e, this.lat0, Math.sin(this.lat0));
    if (Math.abs(this.lat1 - this.lat2) > (0, $jDCGO.EPSLN)) this.ns = Math.log(ms1 / ms2) / Math.log(ts1 / ts2);
    else this.ns = sin1;
    if (isNaN(this.ns)) this.ns = sin1;
    this.f0 = ms1 / (this.ns * Math.pow(ts1, this.ns));
    this.rh = this.a * this.f0 * Math.pow(ts0, this.ns);
    if (!this.title) this.title = 'Lambert Conformal Conic';
}
function $b19a30a478e73c5c$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    // singular cases :
    if (Math.abs(2 * Math.abs(lat) - Math.PI) <= (0, $jDCGO.EPSLN)) lat = (0, $VoZg4.default)(lat) * ((0, $jDCGO.HALF_PI) - 2 * (0, $jDCGO.EPSLN));
    var con = Math.abs(Math.abs(lat) - (0, $jDCGO.HALF_PI));
    var ts, rh1;
    if (con > (0, $jDCGO.EPSLN)) {
        ts = (0, $9bbed77786baf8a2$export$2e2bcd8739ae039)(this.e, lat, Math.sin(lat));
        rh1 = this.a * this.f0 * Math.pow(ts, this.ns);
    } else {
        con = lat * this.ns;
        if (con <= 0) return null;
        rh1 = 0;
    }
    var theta = this.ns * (0, $eRFTg.default)(lon - this.long0, this.over);
    p.x = this.k0 * (rh1 * Math.sin(theta)) + this.x0;
    p.y = this.k0 * (this.rh - rh1 * Math.cos(theta)) + this.y0;
    return p;
}
function $b19a30a478e73c5c$export$70ae2c07e401031b(p) {
    var rh1, con, ts;
    var lat, lon;
    var x = (p.x - this.x0) / this.k0;
    var y = this.rh - (p.y - this.y0) / this.k0;
    if (this.ns > 0) {
        rh1 = Math.sqrt(x * x + y * y);
        con = 1;
    } else {
        rh1 = -Math.sqrt(x * x + y * y);
        con = -1;
    }
    var theta = 0;
    if (rh1 !== 0) theta = Math.atan2(con * x, con * y);
    if (rh1 !== 0 || this.ns > 0) {
        con = 1 / this.ns;
        ts = Math.pow(rh1 / (this.a * this.f0), con);
        lat = (0, $1669155a5b2076cb$export$2e2bcd8739ae039)(this.e, ts);
        if (lat === -9999) return null;
    } else lat = -(0, $jDCGO.HALF_PI);
    lon = (0, $eRFTg.default)(theta / this.ns + this.long0, this.over);
    p.x = lon;
    p.y = lat;
    return p;
}
var $b19a30a478e73c5c$export$e4b2ac9215619f8d = [
    'Lambert Tangential Conformal Conic Projection',
    'Lambert_Conformal_Conic',
    'Lambert_Conformal_Conic_1SP',
    'Lambert_Conformal_Conic_2SP',
    'lcc',
    'Lambert Conic Conformal (1SP)',
    'Lambert Conic Conformal (2SP)'
];
var $b19a30a478e73c5c$export$2e2bcd8739ae039 = {
    init: $b19a30a478e73c5c$export$2cd8252107eb640b,
    forward: $b19a30a478e73c5c$export$174bb771924e7eb1,
    inverse: $b19a30a478e73c5c$export$70ae2c07e401031b,
    names: $b19a30a478e73c5c$export$e4b2ac9215619f8d
};



var $eRFTg = parcelRequire("eRFTg");
function $5ff60b22b254aa04$export$2cd8252107eb640b() {
    this.a = 6377397.155;
    this.es = 0.006674372230614;
    this.e = Math.sqrt(this.es);
    if (!this.lat0) this.lat0 = 0.863937979737193;
    if (!this.long0) this.long0 = 0.4334234309119251; // 42.5° from Ferro = 24.833° from Greenwich
    /* if scale not set default to 0.9999 */ if (!this.k0) this.k0 = 0.9999;
    this.s45 = 0.785398163397448; /* 45 */ 
    this.s90 = 2 * this.s45;
    this.fi0 = this.lat0;
    this.e2 = this.es;
    this.e = Math.sqrt(this.e2);
    this.alfa = Math.sqrt(1 + this.e2 * Math.pow(Math.cos(this.fi0), 4) / (1 - this.e2));
    this.uq = 1.04216856380474;
    this.u0 = Math.asin(Math.sin(this.fi0) / this.alfa);
    this.g = Math.pow((1 + this.e * Math.sin(this.fi0)) / (1 - this.e * Math.sin(this.fi0)), this.alfa * this.e / 2);
    this.k = Math.tan(this.u0 / 2 + this.s45) / Math.pow(Math.tan(this.fi0 / 2 + this.s45), this.alfa) * this.g;
    this.k1 = this.k0;
    this.n0 = this.a * Math.sqrt(1 - this.e2) / (1 - this.e2 * Math.pow(Math.sin(this.fi0), 2));
    this.s0 = 1.37008346281555;
    this.n = Math.sin(this.s0);
    this.ro0 = this.k1 * this.n0 / Math.tan(this.s0);
    this.ad = this.s90 - this.uq;
}
function $5ff60b22b254aa04$export$174bb771924e7eb1(p) {
    var gfi, u, deltav, s, d, eps, ro;
    var lon = p.x;
    var lat = p.y;
    var delta_lon = (0, $eRFTg.default)(lon - this.long0, this.over);
    /* Transformation */ gfi = Math.pow((1 + this.e * Math.sin(lat)) / (1 - this.e * Math.sin(lat)), this.alfa * this.e / 2);
    u = 2 * (Math.atan(this.k * Math.pow(Math.tan(lat / 2 + this.s45), this.alfa) / gfi) - this.s45);
    deltav = -delta_lon * this.alfa;
    s = Math.asin(Math.cos(this.ad) * Math.sin(u) + Math.sin(this.ad) * Math.cos(u) * Math.cos(deltav));
    d = Math.asin(Math.cos(u) * Math.sin(deltav) / Math.cos(s));
    eps = this.n * d;
    ro = this.ro0 * Math.pow(Math.tan(this.s0 / 2 + this.s45), this.n) / Math.pow(Math.tan(s / 2 + this.s45), this.n);
    p.y = ro * Math.cos(eps) / 1;
    p.x = ro * Math.sin(eps) / 1;
    if (!this.czech) {
        p.y *= -1;
        p.x *= -1;
    }
    return p;
}
function $5ff60b22b254aa04$export$70ae2c07e401031b(p) {
    var u, deltav, s, d, eps, ro, fi1;
    var ok;
    /* Transformation */ /* revert y, x */ var tmp = p.x;
    p.x = p.y;
    p.y = tmp;
    if (!this.czech) {
        p.y *= -1;
        p.x *= -1;
    }
    ro = Math.sqrt(p.x * p.x + p.y * p.y);
    eps = Math.atan2(p.y, p.x);
    d = eps / Math.sin(this.s0);
    s = 2 * (Math.atan(Math.pow(this.ro0 / ro, 1 / this.n) * Math.tan(this.s0 / 2 + this.s45)) - this.s45);
    u = Math.asin(Math.cos(this.ad) * Math.sin(s) - Math.sin(this.ad) * Math.cos(s) * Math.cos(d));
    deltav = Math.asin(Math.cos(s) * Math.sin(d) / Math.cos(u));
    p.x = this.long0 - deltav / this.alfa;
    fi1 = u;
    ok = 0;
    var iter = 0;
    do {
        p.y = 2 * (Math.atan(Math.pow(this.k, -1 / this.alfa) * Math.pow(Math.tan(u / 2 + this.s45), 1 / this.alfa) * Math.pow((1 + this.e * Math.sin(fi1)) / (1 - this.e * Math.sin(fi1)), this.e / 2)) - this.s45);
        if (Math.abs(fi1 - p.y) < 0.0000000001) ok = 1;
        fi1 = p.y;
        iter += 1;
    }while (ok === 0 && iter < 15);
    if (iter >= 15) return null;
    return p;
}
var $5ff60b22b254aa04$export$e4b2ac9215619f8d = [
    'Krovak',
    'Krovak Modified',
    'Krovak (North Orientated)',
    'Krovak Modified (North Orientated)',
    'krovak'
];
var $5ff60b22b254aa04$export$2e2bcd8739ae039 = {
    init: $5ff60b22b254aa04$export$2cd8252107eb640b,
    forward: $5ff60b22b254aa04$export$174bb771924e7eb1,
    inverse: $5ff60b22b254aa04$export$70ae2c07e401031b,
    names: $5ff60b22b254aa04$export$e4b2ac9215619f8d
};


function $c49401959eb323cf$export$2e2bcd8739ae039(e0, e1, e2, e3, phi) {
    return e0 * phi - e1 * Math.sin(2 * phi) + e2 * Math.sin(4 * phi) - e3 * Math.sin(6 * phi);
}


function $2bab81ceab37387b$export$2e2bcd8739ae039(x) {
    return 1 - 0.25 * x * (1 + x / 16 * (3 + 1.25 * x));
}


function $52873dbf063a31f1$export$2e2bcd8739ae039(x) {
    return 0.375 * x * (1 + 0.25 * x * (1 + 0.46875 * x));
}


function $7f92a3574de7064a$export$2e2bcd8739ae039(x) {
    return 0.05859375 * x * x * (1 + 0.75 * x);
}


function $b51bf5c7b64f947b$export$2e2bcd8739ae039(x) {
    return x * x * x * (35 / 3072);
}


function $c5abe9bc8562569f$export$2e2bcd8739ae039(a, e, sinphi) {
    var temp = e * sinphi;
    return a / Math.sqrt(1 - temp * temp);
}



var $eRFTg = parcelRequire("eRFTg");

var $jDCGO = parcelRequire("jDCGO");

var $VoZg4 = parcelRequire("VoZg4");
function $5f1e150a9cf227e1$export$2e2bcd8739ae039(x) {
    return Math.abs(x) < (0, $jDCGO.HALF_PI) ? x : x - (0, $VoZg4.default)(x) * Math.PI;
}


function $b5eae160d0befa3c$export$2e2bcd8739ae039(ml, e0, e1, e2, e3) {
    var phi;
    var dphi;
    phi = ml / e0;
    for(var i = 0; i < 15; i++){
        dphi = (ml - (e0 * phi - e1 * Math.sin(2 * phi) + e2 * Math.sin(4 * phi) - e3 * Math.sin(6 * phi))) / (e0 - 2 * e1 * Math.cos(2 * phi) + 4 * e2 * Math.cos(4 * phi) - 6 * e3 * Math.cos(6 * phi));
        phi += dphi;
        if (Math.abs(dphi) <= 0.0000000001) return phi;
    }
    // ..reportError("IMLFN-CONV:Latitude failed to converge after 15 iterations");
    return NaN;
}



var $jDCGO = parcelRequire("jDCGO");
function $1bb7279d02bd698d$export$2cd8252107eb640b() {
    if (!this.sphere) {
        this.e0 = (0, $2bab81ceab37387b$export$2e2bcd8739ae039)(this.es);
        this.e1 = (0, $52873dbf063a31f1$export$2e2bcd8739ae039)(this.es);
        this.e2 = (0, $7f92a3574de7064a$export$2e2bcd8739ae039)(this.es);
        this.e3 = (0, $b51bf5c7b64f947b$export$2e2bcd8739ae039)(this.es);
        this.ml0 = this.a * (0, $c49401959eb323cf$export$2e2bcd8739ae039)(this.e0, this.e1, this.e2, this.e3, this.lat0);
    }
}
function $1bb7279d02bd698d$export$174bb771924e7eb1(p) {
    /* Forward equations
      ----------------- */ var x, y;
    var lam = p.x;
    var phi = p.y;
    lam = (0, $eRFTg.default)(lam - this.long0, this.over);
    if (this.sphere) {
        x = this.a * Math.asin(Math.cos(phi) * Math.sin(lam));
        y = this.a * (Math.atan2(Math.tan(phi), Math.cos(lam)) - this.lat0);
    } else {
        // ellipsoid
        var sinphi = Math.sin(phi);
        var cosphi = Math.cos(phi);
        var nl = (0, $c5abe9bc8562569f$export$2e2bcd8739ae039)(this.a, this.e, sinphi);
        var tl = Math.tan(phi) * Math.tan(phi);
        var al = lam * Math.cos(phi);
        var asq = al * al;
        var cl = this.es * cosphi * cosphi / (1 - this.es);
        var ml = this.a * (0, $c49401959eb323cf$export$2e2bcd8739ae039)(this.e0, this.e1, this.e2, this.e3, phi);
        x = nl * al * (1 - asq * tl * (1 / 6 - (8 - tl + 8 * cl) * asq / 120));
        y = ml - this.ml0 + nl * sinphi / cosphi * asq * (0.5 + (5 - tl + 6 * cl) * asq / 24);
    }
    p.x = x + this.x0;
    p.y = y + this.y0;
    return p;
}
function $1bb7279d02bd698d$export$70ae2c07e401031b(p) {
    p.x -= this.x0;
    p.y -= this.y0;
    var x = p.x / this.a;
    var y = p.y / this.a;
    var phi, lam;
    if (this.sphere) {
        var dd = y + this.lat0;
        phi = Math.asin(Math.sin(dd) * Math.cos(x));
        lam = Math.atan2(Math.tan(x), Math.cos(dd));
    } else {
        /* ellipsoid */ var ml1 = this.ml0 / this.a + y;
        var phi1 = (0, $b5eae160d0befa3c$export$2e2bcd8739ae039)(ml1, this.e0, this.e1, this.e2, this.e3);
        if (Math.abs(Math.abs(phi1) - (0, $jDCGO.HALF_PI)) <= (0, $jDCGO.EPSLN)) {
            p.x = this.long0;
            p.y = (0, $jDCGO.HALF_PI);
            if (y < 0) p.y *= -1;
            return p;
        }
        var nl1 = (0, $c5abe9bc8562569f$export$2e2bcd8739ae039)(this.a, this.e, Math.sin(phi1));
        var rl1 = nl1 * nl1 * nl1 / this.a / this.a * (1 - this.es);
        var tl1 = Math.pow(Math.tan(phi1), 2);
        var dl = x * this.a / nl1;
        var dsq = dl * dl;
        phi = phi1 - nl1 * Math.tan(phi1) / rl1 * dl * dl * (0.5 - (1 + 3 * tl1) * dl * dl / 24);
        lam = dl * (1 - dsq * (tl1 / 3 + (1 + 3 * tl1) * tl1 * dsq / 15)) / Math.cos(phi1);
    }
    p.x = (0, $eRFTg.default)(lam + this.long0, this.over);
    p.y = (0, $5f1e150a9cf227e1$export$2e2bcd8739ae039)(phi);
    return p;
}
var $1bb7279d02bd698d$export$e4b2ac9215619f8d = [
    'Cassini',
    'Cassini_Soldner',
    'cass'
];
var $1bb7279d02bd698d$export$2e2bcd8739ae039 = {
    init: $1bb7279d02bd698d$export$2cd8252107eb640b,
    forward: $1bb7279d02bd698d$export$174bb771924e7eb1,
    inverse: $1bb7279d02bd698d$export$70ae2c07e401031b,
    names: $1bb7279d02bd698d$export$e4b2ac9215619f8d
};



var $l2RN6 = parcelRequire("l2RN6");

var $bdfcS = parcelRequire("bdfcS");

var $eRFTg = parcelRequire("eRFTg");

var $3GaS9 = parcelRequire("3GaS9");

var $jDCGO = parcelRequire("jDCGO");
function $ddedabd240224093$export$2cd8252107eb640b() {
    /* Place parameters in static storage for common use
      ------------------------------------------------- */ this.sin_p14 = Math.sin(this.lat0);
    this.cos_p14 = Math.cos(this.lat0);
    // Approximation for projecting points to the horizon (infinity)
    this.infinity_dist = 1000 * this.a;
    this.rc = 1;
}
function $ddedabd240224093$export$174bb771924e7eb1(p) {
    var sinphi, cosphi; /* sin and cos value        */ 
    var dlon; /* delta longitude value      */ 
    var coslon; /* cos of longitude        */ 
    var ksp; /* scale factor          */ 
    var g;
    var x, y;
    var lon = p.x;
    var lat = p.y;
    /* Forward equations
      ----------------- */ dlon = (0, $eRFTg.default)(lon - this.long0, this.over);
    sinphi = Math.sin(lat);
    cosphi = Math.cos(lat);
    coslon = Math.cos(dlon);
    g = this.sin_p14 * sinphi + this.cos_p14 * cosphi * coslon;
    ksp = 1;
    if (g > 0 || Math.abs(g) <= (0, $jDCGO.EPSLN)) {
        x = this.x0 + this.a * ksp * cosphi * Math.sin(dlon) / g;
        y = this.y0 + this.a * ksp * (this.cos_p14 * sinphi - this.sin_p14 * cosphi * coslon) / g;
    } else {
        // Point is in the opposing hemisphere and is unprojectable
        // We still need to return a reasonable point, so we project
        // to infinity, on a bearing
        // equivalent to the northern hemisphere equivalent
        // This is a reasonable approximation for short shapes and lines that
        // straddle the horizon.
        x = this.x0 + this.infinity_dist * cosphi * Math.sin(dlon);
        y = this.y0 + this.infinity_dist * (this.cos_p14 * sinphi - this.sin_p14 * cosphi * coslon);
    }
    p.x = x;
    p.y = y;
    return p;
}
function $ddedabd240224093$export$70ae2c07e401031b(p) {
    var rh; /* Rho */ 
    var sinc, cosc;
    var c;
    var lon, lat;
    /* Inverse equations
      ----------------- */ p.x = (p.x - this.x0) / this.a;
    p.y = (p.y - this.y0) / this.a;
    p.x /= this.k0;
    p.y /= this.k0;
    if (rh = Math.sqrt(p.x * p.x + p.y * p.y)) {
        c = Math.atan2(rh, this.rc);
        sinc = Math.sin(c);
        cosc = Math.cos(c);
        lat = (0, $3GaS9.default)(cosc * this.sin_p14 + p.y * sinc * this.cos_p14 / rh);
        lon = Math.atan2(p.x * sinc, rh * this.cos_p14 * cosc - p.y * this.sin_p14 * sinc);
        lon = (0, $eRFTg.default)(this.long0 + lon, this.over);
    } else {
        lat = this.phic0;
        lon = 0;
    }
    p.x = lon;
    p.y = lat;
    return p;
}
var $ddedabd240224093$export$e4b2ac9215619f8d = [
    'gnom'
];
var $ddedabd240224093$export$2e2bcd8739ae039 = {
    init: $ddedabd240224093$export$2cd8252107eb640b,
    forward: $ddedabd240224093$export$174bb771924e7eb1,
    inverse: $ddedabd240224093$export$70ae2c07e401031b,
    names: $ddedabd240224093$export$e4b2ac9215619f8d
};



var $eRFTg = parcelRequire("eRFTg");

var $4GxSW = parcelRequire("4GxSW");

var $96xAh = parcelRequire("96xAh");

var $jDCGO = parcelRequire("jDCGO");
function $b178995647603036$export$2e2bcd8739ae039(eccent, q) {
    var temp = 1 - (1 - eccent * eccent) / (2 * eccent) * Math.log((1 - eccent) / (1 + eccent));
    if (Math.abs(Math.abs(q) - temp) < 1.0E-6) {
        if (q < 0) return -1 * (0, $jDCGO.HALF_PI);
        else return 0, $jDCGO.HALF_PI;
    }
    // var phi = 0.5* q/(1-eccent*eccent);
    var phi = Math.asin(0.5 * q);
    var dphi;
    var sin_phi;
    var cos_phi;
    var con;
    for(var i = 0; i < 30; i++){
        sin_phi = Math.sin(phi);
        cos_phi = Math.cos(phi);
        con = eccent * sin_phi;
        dphi = Math.pow(1 - con * con, 2) / (2 * cos_phi) * (q / (1 - eccent * eccent) - sin_phi / (1 - con * con) + 0.5 / eccent * Math.log((1 - con) / (1 + con)));
        phi += dphi;
        if (Math.abs(dphi) <= 0.0000000001) return phi;
    }
    // console.log("IQSFN-CONV:Latitude failed to converge after 30 iterations");
    return NaN;
}


function $d38acef4b970957d$export$2cd8252107eb640b() {
    // no-op
    if (!this.sphere) this.k0 = (0, $96xAh.default)(this.e, Math.sin(this.lat_ts), Math.cos(this.lat_ts));
}
function $d38acef4b970957d$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    var x, y;
    /* Forward equations
      ----------------- */ var dlon = (0, $eRFTg.default)(lon - this.long0, this.over);
    if (this.sphere) {
        x = this.x0 + this.a * dlon * Math.cos(this.lat_ts);
        y = this.y0 + this.a * Math.sin(lat) / Math.cos(this.lat_ts);
    } else {
        var qs = (0, $4GxSW.default)(this.e, Math.sin(lat));
        x = this.x0 + this.a * this.k0 * dlon;
        y = this.y0 + this.a * qs * 0.5 / this.k0;
    }
    p.x = x;
    p.y = y;
    return p;
}
function $d38acef4b970957d$export$70ae2c07e401031b(p) {
    p.x -= this.x0;
    p.y -= this.y0;
    var lon, lat;
    if (this.sphere) {
        lon = (0, $eRFTg.default)(this.long0 + p.x / this.a / Math.cos(this.lat_ts), this.over);
        lat = Math.asin(p.y / this.a * Math.cos(this.lat_ts));
    } else {
        lat = (0, $b178995647603036$export$2e2bcd8739ae039)(this.e, 2 * p.y * this.k0 / this.a);
        lon = (0, $eRFTg.default)(this.long0 + p.x / (this.a * this.k0), this.over);
    }
    p.x = lon;
    p.y = lat;
    return p;
}
var $d38acef4b970957d$export$e4b2ac9215619f8d = [
    'cea'
];
var $d38acef4b970957d$export$2e2bcd8739ae039 = {
    init: $d38acef4b970957d$export$2cd8252107eb640b,
    forward: $d38acef4b970957d$export$174bb771924e7eb1,
    inverse: $d38acef4b970957d$export$70ae2c07e401031b,
    names: $d38acef4b970957d$export$e4b2ac9215619f8d
};



var $eRFTg = parcelRequire("eRFTg");

function $19a129fcc5ffd145$export$2cd8252107eb640b() {
    this.x0 = this.x0 || 0;
    this.y0 = this.y0 || 0;
    this.lat0 = this.lat0 || 0;
    this.long0 = this.long0 || 0;
    this.lat_ts = this.lat_ts || 0;
    this.title = this.title || 'Equidistant Cylindrical (Plate Carre)';
    this.rc = Math.cos(this.lat_ts);
}
function $19a129fcc5ffd145$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    var dlon = (0, $eRFTg.default)(lon - this.long0, this.over);
    var dlat = (0, $5f1e150a9cf227e1$export$2e2bcd8739ae039)(lat - this.lat0);
    p.x = this.x0 + this.a * dlon * this.rc;
    p.y = this.y0 + this.a * dlat;
    return p;
}
function $19a129fcc5ffd145$export$70ae2c07e401031b(p) {
    var x = p.x;
    var y = p.y;
    p.x = (0, $eRFTg.default)(this.long0 + (x - this.x0) / (this.a * this.rc), this.over);
    p.y = (0, $5f1e150a9cf227e1$export$2e2bcd8739ae039)(this.lat0 + (y - this.y0) / this.a);
    return p;
}
var $19a129fcc5ffd145$export$e4b2ac9215619f8d = [
    'Equirectangular',
    'Equidistant_Cylindrical',
    'Equidistant_Cylindrical_Spherical',
    'eqc'
];
var $19a129fcc5ffd145$export$2e2bcd8739ae039 = {
    init: $19a129fcc5ffd145$export$2cd8252107eb640b,
    forward: $19a129fcc5ffd145$export$174bb771924e7eb1,
    inverse: $19a129fcc5ffd145$export$70ae2c07e401031b,
    names: $19a129fcc5ffd145$export$e4b2ac9215619f8d
};







var $eRFTg = parcelRequire("eRFTg");



var $jDCGO = parcelRequire("jDCGO");

/**
 * @typedef {Object} LocalThis
 * @property {number} temp
 * @property {number} es
 * @property {number} e
 * @property {number} e0
 * @property {number} e1
 * @property {number} e2
 * @property {number} e3
 * @property {number} ml0
 */ var $1ed23b92e493659a$var$MAX_ITER = 20;
function $1ed23b92e493659a$export$2cd8252107eb640b() {
    /* Place parameters in static storage for common use
      ------------------------------------------------- */ this.temp = this.b / this.a;
    this.es = 1 - Math.pow(this.temp, 2); // devait etre dans tmerc.js mais n y est pas donc je commente sinon retour de valeurs nulles
    this.e = Math.sqrt(this.es);
    this.e0 = (0, $2bab81ceab37387b$export$2e2bcd8739ae039)(this.es);
    this.e1 = (0, $52873dbf063a31f1$export$2e2bcd8739ae039)(this.es);
    this.e2 = (0, $7f92a3574de7064a$export$2e2bcd8739ae039)(this.es);
    this.e3 = (0, $b51bf5c7b64f947b$export$2e2bcd8739ae039)(this.es);
    this.ml0 = this.a * (0, $c49401959eb323cf$export$2e2bcd8739ae039)(this.e0, this.e1, this.e2, this.e3, this.lat0); // si que des zeros le calcul ne se fait pas
}
function $1ed23b92e493659a$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    var x, y, el;
    var dlon = (0, $eRFTg.default)(lon - this.long0, this.over);
    el = dlon * Math.sin(lat);
    if (this.sphere) {
        if (Math.abs(lat) <= (0, $jDCGO.EPSLN)) {
            x = this.a * dlon;
            y = -1 * this.a * this.lat0;
        } else {
            x = this.a * Math.sin(el) / Math.tan(lat);
            y = this.a * ((0, $5f1e150a9cf227e1$export$2e2bcd8739ae039)(lat - this.lat0) + (1 - Math.cos(el)) / Math.tan(lat));
        }
    } else if (Math.abs(lat) <= (0, $jDCGO.EPSLN)) {
        x = this.a * dlon;
        y = -1 * this.ml0;
    } else {
        var nl = (0, $c5abe9bc8562569f$export$2e2bcd8739ae039)(this.a, this.e, Math.sin(lat)) / Math.tan(lat);
        x = nl * Math.sin(el);
        y = this.a * (0, $c49401959eb323cf$export$2e2bcd8739ae039)(this.e0, this.e1, this.e2, this.e3, lat) - this.ml0 + nl * (1 - Math.cos(el));
    }
    p.x = x + this.x0;
    p.y = y + this.y0;
    return p;
}
function $1ed23b92e493659a$export$70ae2c07e401031b(p) {
    var lon, lat, x, y, i;
    var al, bl;
    var phi, dphi;
    x = p.x - this.x0;
    y = p.y - this.y0;
    if (this.sphere) {
        if (Math.abs(y + this.a * this.lat0) <= (0, $jDCGO.EPSLN)) {
            lon = (0, $eRFTg.default)(x / this.a + this.long0, this.over);
            lat = 0;
        } else {
            al = this.lat0 + y / this.a;
            bl = x * x / this.a / this.a + al * al;
            phi = al;
            var tanphi;
            for(i = $1ed23b92e493659a$var$MAX_ITER; i; --i){
                tanphi = Math.tan(phi);
                dphi = -1 * (al * (phi * tanphi + 1) - phi - 0.5 * (phi * phi + bl) * tanphi) / ((phi - al) / tanphi - 1);
                phi += dphi;
                if (Math.abs(dphi) <= (0, $jDCGO.EPSLN)) {
                    lat = phi;
                    break;
                }
            }
            lon = (0, $eRFTg.default)(this.long0 + Math.asin(x * Math.tan(phi) / this.a) / Math.sin(lat), this.over);
        }
    } else if (Math.abs(y + this.ml0) <= (0, $jDCGO.EPSLN)) {
        lat = 0;
        lon = (0, $eRFTg.default)(this.long0 + x / this.a, this.over);
    } else {
        al = (this.ml0 + y) / this.a;
        bl = x * x / this.a / this.a + al * al;
        phi = al;
        var cl, mln, mlnp, ma;
        var con;
        for(i = $1ed23b92e493659a$var$MAX_ITER; i; --i){
            con = this.e * Math.sin(phi);
            cl = Math.sqrt(1 - con * con) * Math.tan(phi);
            mln = this.a * (0, $c49401959eb323cf$export$2e2bcd8739ae039)(this.e0, this.e1, this.e2, this.e3, phi);
            mlnp = this.e0 - 2 * this.e1 * Math.cos(2 * phi) + 4 * this.e2 * Math.cos(4 * phi) - 6 * this.e3 * Math.cos(6 * phi);
            ma = mln / this.a;
            dphi = (al * (cl * ma + 1) - ma - 0.5 * cl * (ma * ma + bl)) / (this.es * Math.sin(2 * phi) * (ma * ma + bl - 2 * al * ma) / (4 * cl) + (al - ma) * (cl * mlnp - 2 / Math.sin(2 * phi)) - mlnp);
            phi -= dphi;
            if (Math.abs(dphi) <= (0, $jDCGO.EPSLN)) {
                lat = phi;
                break;
            }
        }
        // lat=phi4z(this.e,this.e0,this.e1,this.e2,this.e3,al,bl,0,0);
        cl = Math.sqrt(1 - this.es * Math.pow(Math.sin(lat), 2)) * Math.tan(lat);
        lon = (0, $eRFTg.default)(this.long0 + Math.asin(x * cl / this.a) / Math.sin(lat), this.over);
    }
    p.x = lon;
    p.y = lat;
    return p;
}
var $1ed23b92e493659a$export$e4b2ac9215619f8d = [
    'Polyconic',
    'American_Polyconic',
    'poly'
];
var $1ed23b92e493659a$export$2e2bcd8739ae039 = {
    init: $1ed23b92e493659a$export$2cd8252107eb640b,
    forward: $1ed23b92e493659a$export$174bb771924e7eb1,
    inverse: $1ed23b92e493659a$export$70ae2c07e401031b,
    names: $1ed23b92e493659a$export$e4b2ac9215619f8d
};



var $d4Re2 = parcelRequire("d4Re2");

var $eRFTg = parcelRequire("eRFTg");
function $6e4232175bd83b7d$export$2cd8252107eb640b() {
// no-op
}
function $6e4232175bd83b7d$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    /* Forward equations
      ----------------- */ var dlon = (0, $eRFTg.default)(lon - this.long0, this.over);
    var x = this.x0 + this.a * dlon;
    var y = this.y0 + this.a * Math.log(Math.tan(Math.PI / 4 + lat / 2.5)) * 1.25;
    p.x = x;
    p.y = y;
    return p;
}
function $6e4232175bd83b7d$export$70ae2c07e401031b(p) {
    p.x -= this.x0;
    p.y -= this.y0;
    var lon = (0, $eRFTg.default)(this.long0 + p.x / this.a, this.over);
    var lat = 2.5 * (Math.atan(Math.exp(0.8 * p.y / this.a)) - Math.PI / 4);
    p.x = lon;
    p.y = lat;
    return p;
}
var $6e4232175bd83b7d$export$e4b2ac9215619f8d = [
    'Miller_Cylindrical',
    'mill'
];
var $6e4232175bd83b7d$export$2e2bcd8739ae039 = {
    init: $6e4232175bd83b7d$export$2cd8252107eb640b,
    forward: $6e4232175bd83b7d$export$174bb771924e7eb1,
    inverse: $6e4232175bd83b7d$export$70ae2c07e401031b,
    names: $6e4232175bd83b7d$export$e4b2ac9215619f8d
};



var $eRFTg = parcelRequire("eRFTg");


var $1t7xy = parcelRequire("1t7xy");

var $6D29U = parcelRequire("6D29U");

var $aItGy = parcelRequire("aItGy");

var $jDCGO = parcelRequire("jDCGO");

var $3GaS9 = parcelRequire("3GaS9");
var $8400908b20c129dc$var$MAX_ITER = 20;
function $8400908b20c129dc$export$2cd8252107eb640b() {
    /* Place parameters in static storage for common use
    ------------------------------------------------- */ this.long0 = this.long0 || 0;
    if (!this.sphere) this.en = (0, $1t7xy.default)(this.es);
    else {
        this.n = 1;
        this.m = 0;
        this.es = 0;
        this.C_y = Math.sqrt((this.m + 1) / this.n);
        this.C_x = this.C_y / (this.m + 1);
    }
}
function $8400908b20c129dc$export$174bb771924e7eb1(p) {
    var x, y;
    var lon = p.x;
    var lat = p.y;
    /* Forward equations
    ----------------- */ lon = (0, $eRFTg.default)(lon - this.long0, this.over);
    if (this.sphere) {
        if (!this.m) lat = this.n !== 1 ? Math.asin(this.n * Math.sin(lat)) : lat;
        else {
            var k = this.n * Math.sin(lat);
            for(var i = $8400908b20c129dc$var$MAX_ITER; i; --i){
                var V = (this.m * lat + Math.sin(lat) - k) / (this.m + Math.cos(lat));
                lat -= V;
                if (Math.abs(V) < (0, $jDCGO.EPSLN)) break;
            }
        }
        x = this.a * this.C_x * lon * (this.m + Math.cos(lat));
        y = this.a * this.C_y * lat;
    } else {
        var s = Math.sin(lat);
        var c = Math.cos(lat);
        y = this.a * (0, $6D29U.default)(lat, s, c, this.en);
        x = this.a * lon * c / Math.sqrt(1 - this.es * s * s);
    }
    p.x = x;
    p.y = y;
    return p;
}
function $8400908b20c129dc$export$70ae2c07e401031b(p) {
    var lat, temp, lon, s;
    p.x -= this.x0;
    lon = p.x / this.a;
    p.y -= this.y0;
    lat = p.y / this.a;
    if (this.sphere) {
        lat /= this.C_y;
        lon = lon / (this.C_x * (this.m + Math.cos(lat)));
        if (this.m) lat = (0, $3GaS9.default)((this.m * lat + Math.sin(lat)) / this.n);
        else if (this.n !== 1) lat = (0, $3GaS9.default)(Math.sin(lat) / this.n);
        lon = (0, $eRFTg.default)(lon + this.long0, this.over);
        lat = (0, $5f1e150a9cf227e1$export$2e2bcd8739ae039)(lat);
    } else {
        lat = (0, $aItGy.default)(p.y / this.a, this.es, this.en);
        s = Math.abs(lat);
        if (s < (0, $jDCGO.HALF_PI)) {
            s = Math.sin(lat);
            temp = this.long0 + p.x * Math.sqrt(1 - this.es * s * s) / (this.a * Math.cos(lat));
            // temp = this.long0 + p.x / (this.a * Math.cos(lat));
            lon = (0, $eRFTg.default)(temp, this.over);
        } else if (s - (0, $jDCGO.EPSLN) < (0, $jDCGO.HALF_PI)) lon = this.long0;
    }
    p.x = lon;
    p.y = lat;
    return p;
}
var $8400908b20c129dc$export$e4b2ac9215619f8d = [
    'Sinusoidal',
    'sinu'
];
var $8400908b20c129dc$export$2e2bcd8739ae039 = {
    init: $8400908b20c129dc$export$2cd8252107eb640b,
    forward: $8400908b20c129dc$export$174bb771924e7eb1,
    inverse: $8400908b20c129dc$export$70ae2c07e401031b,
    names: $8400908b20c129dc$export$e4b2ac9215619f8d
};



var $eRFTg = parcelRequire("eRFTg");

var $jDCGO = parcelRequire("jDCGO");
function $b79975ea600eab93$export$2cd8252107eb640b() {
    this.x0 = this.x0 !== undefined ? this.x0 : 0;
    this.y0 = this.y0 !== undefined ? this.y0 : 0;
    this.long0 = this.long0 !== undefined ? this.long0 : 0;
}
function $b79975ea600eab93$export$174bb771924e7eb1(p) {
    /* Forward equations
      ----------------- */ var lon = p.x;
    var lat = p.y;
    var delta_lon = (0, $eRFTg.default)(lon - this.long0, this.over);
    var theta = lat;
    var con = Math.PI * Math.sin(lat);
    /* Iterate using the Newton-Raphson method to find theta
      ----------------------------------------------------- */ while(true){
        var delta_theta = -(theta + Math.sin(theta) - con) / (1 + Math.cos(theta));
        theta += delta_theta;
        if (Math.abs(delta_theta) < (0, $jDCGO.EPSLN)) break;
    }
    theta /= 2;
    /* If the latitude is 90 deg, force the x coordinate to be "0 + false easting"
       this is done here because of precision problems with "cos(theta)"
       -------------------------------------------------------------------------- */ if (Math.PI / 2 - Math.abs(lat) < (0, $jDCGO.EPSLN)) delta_lon = 0;
    var x = 0.900316316158 * this.a * delta_lon * Math.cos(theta) + this.x0;
    var y = 1.4142135623731 * this.a * Math.sin(theta) + this.y0;
    p.x = x;
    p.y = y;
    return p;
}
function $b79975ea600eab93$export$70ae2c07e401031b(p) {
    var theta;
    var arg;
    /* Inverse equations
      ----------------- */ p.x -= this.x0;
    p.y -= this.y0;
    arg = p.y / (1.4142135623731 * this.a);
    /* Because of division by zero problems, 'arg' can not be 1.  Therefore
       a number very close to one is used instead.
       ------------------------------------------------------------------- */ if (Math.abs(arg) > 0.999999999999) arg = 0.999999999999;
    theta = Math.asin(arg);
    var lon = (0, $eRFTg.default)(this.long0 + p.x / (0.900316316158 * this.a * Math.cos(theta)), this.over);
    if (lon < -Math.PI) lon = -Math.PI;
    if (lon > Math.PI) lon = Math.PI;
    arg = (2 * theta + Math.sin(2 * theta)) / Math.PI;
    if (Math.abs(arg) > 1) arg = 1;
    var lat = Math.asin(arg);
    p.x = lon;
    p.y = lat;
    return p;
}
var $b79975ea600eab93$export$e4b2ac9215619f8d = [
    'Mollweide',
    'moll'
];
var $b79975ea600eab93$export$2e2bcd8739ae039 = {
    init: $b79975ea600eab93$export$2cd8252107eb640b,
    forward: $b79975ea600eab93$export$174bb771924e7eb1,
    inverse: $b79975ea600eab93$export$70ae2c07e401031b,
    names: $b79975ea600eab93$export$e4b2ac9215619f8d
};







var $96xAh = parcelRequire("96xAh");


var $eRFTg = parcelRequire("eRFTg");



var $jDCGO = parcelRequire("jDCGO");
function $6653bb0d8e21c387$export$2cd8252107eb640b() {
    /* Place parameters in static storage for common use
      ------------------------------------------------- */ // Standard Parallels cannot be equal and on opposite sides of the equator
    if (Math.abs(this.lat1 + this.lat2) < (0, $jDCGO.EPSLN)) return;
    this.lat2 = this.lat2 || this.lat1;
    this.temp = this.b / this.a;
    this.es = 1 - Math.pow(this.temp, 2);
    this.e = Math.sqrt(this.es);
    this.e0 = (0, $2bab81ceab37387b$export$2e2bcd8739ae039)(this.es);
    this.e1 = (0, $52873dbf063a31f1$export$2e2bcd8739ae039)(this.es);
    this.e2 = (0, $7f92a3574de7064a$export$2e2bcd8739ae039)(this.es);
    this.e3 = (0, $b51bf5c7b64f947b$export$2e2bcd8739ae039)(this.es);
    this.sin_phi = Math.sin(this.lat1);
    this.cos_phi = Math.cos(this.lat1);
    this.ms1 = (0, $96xAh.default)(this.e, this.sin_phi, this.cos_phi);
    this.ml1 = (0, $c49401959eb323cf$export$2e2bcd8739ae039)(this.e0, this.e1, this.e2, this.e3, this.lat1);
    if (Math.abs(this.lat1 - this.lat2) < (0, $jDCGO.EPSLN)) this.ns = this.sin_phi;
    else {
        this.sin_phi = Math.sin(this.lat2);
        this.cos_phi = Math.cos(this.lat2);
        this.ms2 = (0, $96xAh.default)(this.e, this.sin_phi, this.cos_phi);
        this.ml2 = (0, $c49401959eb323cf$export$2e2bcd8739ae039)(this.e0, this.e1, this.e2, this.e3, this.lat2);
        this.ns = (this.ms1 - this.ms2) / (this.ml2 - this.ml1);
    }
    this.g = this.ml1 + this.ms1 / this.ns;
    this.ml0 = (0, $c49401959eb323cf$export$2e2bcd8739ae039)(this.e0, this.e1, this.e2, this.e3, this.lat0);
    this.rh = this.a * (this.g - this.ml0);
}
function $6653bb0d8e21c387$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    var rh1;
    /* Forward equations
      ----------------- */ if (this.sphere) rh1 = this.a * (this.g - lat);
    else {
        var ml = (0, $c49401959eb323cf$export$2e2bcd8739ae039)(this.e0, this.e1, this.e2, this.e3, lat);
        rh1 = this.a * (this.g - ml);
    }
    var theta = this.ns * (0, $eRFTg.default)(lon - this.long0, this.over);
    var x = this.x0 + rh1 * Math.sin(theta);
    var y = this.y0 + this.rh - rh1 * Math.cos(theta);
    p.x = x;
    p.y = y;
    return p;
}
function $6653bb0d8e21c387$export$70ae2c07e401031b(p) {
    p.x -= this.x0;
    p.y = this.rh - p.y + this.y0;
    var con, rh1, lat, lon;
    if (this.ns >= 0) {
        rh1 = Math.sqrt(p.x * p.x + p.y * p.y);
        con = 1;
    } else {
        rh1 = -Math.sqrt(p.x * p.x + p.y * p.y);
        con = -1;
    }
    var theta = 0;
    if (rh1 !== 0) theta = Math.atan2(con * p.x, con * p.y);
    if (this.sphere) {
        lon = (0, $eRFTg.default)(this.long0 + theta / this.ns, this.over);
        lat = (0, $5f1e150a9cf227e1$export$2e2bcd8739ae039)(this.g - rh1 / this.a);
        p.x = lon;
        p.y = lat;
        return p;
    } else {
        var ml = this.g - rh1 / this.a;
        lat = (0, $b5eae160d0befa3c$export$2e2bcd8739ae039)(ml, this.e0, this.e1, this.e2, this.e3);
        lon = (0, $eRFTg.default)(this.long0 + theta / this.ns, this.over);
        p.x = lon;
        p.y = lat;
        return p;
    }
}
var $6653bb0d8e21c387$export$e4b2ac9215619f8d = [
    'Equidistant_Conic',
    'eqdc'
];
var $6653bb0d8e21c387$export$2e2bcd8739ae039 = {
    init: $6653bb0d8e21c387$export$2cd8252107eb640b,
    forward: $6653bb0d8e21c387$export$174bb771924e7eb1,
    inverse: $6653bb0d8e21c387$export$70ae2c07e401031b,
    names: $6653bb0d8e21c387$export$e4b2ac9215619f8d
};



var $eRFTg = parcelRequire("eRFTg");

var $jDCGO = parcelRequire("jDCGO");

var $3GaS9 = parcelRequire("3GaS9");
function $4941dca385bdf94a$export$2cd8252107eb640b() {
    // this.R = 6370997; //Radius of earth
    this.R = this.a;
}
function $4941dca385bdf94a$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    /* Forward equations
    ----------------- */ var dlon = (0, $eRFTg.default)(lon - this.long0, this.over);
    var x, y;
    if (Math.abs(lat) <= (0, $jDCGO.EPSLN)) {
        x = this.x0 + this.R * dlon;
        y = this.y0;
    }
    var theta = (0, $3GaS9.default)(2 * Math.abs(lat / Math.PI));
    if (Math.abs(dlon) <= (0, $jDCGO.EPSLN) || Math.abs(Math.abs(lat) - (0, $jDCGO.HALF_PI)) <= (0, $jDCGO.EPSLN)) {
        x = this.x0;
        if (lat >= 0) y = this.y0 + Math.PI * this.R * Math.tan(0.5 * theta);
        else y = this.y0 + Math.PI * this.R * -Math.tan(0.5 * theta);
    //  return(OK);
    }
    var al = 0.5 * Math.abs(Math.PI / dlon - dlon / Math.PI);
    var asq = al * al;
    var sinth = Math.sin(theta);
    var costh = Math.cos(theta);
    var g = costh / (sinth + costh - 1);
    var gsq = g * g;
    var m = g * (2 / sinth - 1);
    var msq = m * m;
    var con = Math.PI * this.R * (al * (g - msq) + Math.sqrt(asq * (g - msq) * (g - msq) - (msq + asq) * (gsq - msq))) / (msq + asq);
    if (dlon < 0) con = -con;
    x = this.x0 + con;
    // con = Math.abs(con / (Math.PI * this.R));
    var q = asq + g;
    con = Math.PI * this.R * (m * q - al * Math.sqrt((msq + asq) * (asq + 1) - q * q)) / (msq + asq);
    if (lat >= 0) // y = this.y0 + Math.PI * this.R * Math.sqrt(1 - con * con - 2 * al * con);
    y = this.y0 + con;
    else // y = this.y0 - Math.PI * this.R * Math.sqrt(1 - con * con - 2 * al * con);
    y = this.y0 - con;
    p.x = x;
    p.y = y;
    return p;
}
function $4941dca385bdf94a$export$70ae2c07e401031b(p) {
    var lon, lat;
    var xx, yy, xys, c1, c2, c3;
    var a1;
    var m1;
    var con;
    var th1;
    var d;
    /* inverse equations
    ----------------- */ p.x -= this.x0;
    p.y -= this.y0;
    con = Math.PI * this.R;
    xx = p.x / con;
    yy = p.y / con;
    xys = xx * xx + yy * yy;
    c1 = -Math.abs(yy) * (1 + xys);
    c2 = c1 - 2 * yy * yy + xx * xx;
    c3 = -2 * c1 + 1 + 2 * yy * yy + xys * xys;
    d = yy * yy / c3 + (2 * c2 * c2 * c2 / c3 / c3 / c3 - 9 * c1 * c2 / c3 / c3) / 27;
    a1 = (c1 - c2 * c2 / 3 / c3) / c3;
    m1 = 2 * Math.sqrt(-a1 / 3);
    con = 3 * d / a1 / m1;
    if (Math.abs(con) > 1) {
        if (con >= 0) con = 1;
        else con = -1;
    }
    th1 = Math.acos(con) / 3;
    if (p.y >= 0) lat = (-m1 * Math.cos(th1 + Math.PI / 3) - c2 / 3 / c3) * Math.PI;
    else lat = -(-m1 * Math.cos(th1 + Math.PI / 3) - c2 / 3 / c3) * Math.PI;
    if (Math.abs(xx) < (0, $jDCGO.EPSLN)) lon = this.long0;
    else lon = (0, $eRFTg.default)(this.long0 + Math.PI * (xys - 1 + Math.sqrt(1 + 2 * (xx * xx - yy * yy) + xys * xys)) / 2 / xx, this.over);
    p.x = lon;
    p.y = lat;
    return p;
}
var $4941dca385bdf94a$export$e4b2ac9215619f8d = [
    'Van_der_Grinten_I',
    'VanDerGrinten',
    'Van_der_Grinten',
    'vandg'
];
var $4941dca385bdf94a$export$2e2bcd8739ae039 = {
    init: $4941dca385bdf94a$export$2cd8252107eb640b,
    forward: $4941dca385bdf94a$export$174bb771924e7eb1,
    inverse: $4941dca385bdf94a$export$70ae2c07e401031b,
    names: $4941dca385bdf94a$export$e4b2ac9215619f8d
};



var $eRFTg = parcelRequire("eRFTg");

var $jDCGO = parcelRequire("jDCGO");






var $3GaS9 = parcelRequire("3GaS9");

/**
 * Calculates the inverse geodesic problem using Vincenty's formulae.
 * Computes the forward azimuth and ellipsoidal distance between two points
 * specified by latitude and longitude on the surface of an ellipsoid.
 *
 * @param {number} lat1 Latitude of the first point in radians.
 * @param {number} lon1 Longitude of the first point in radians.
 * @param {number} lat2 Latitude of the second point in radians.
 * @param {number} lon2 Longitude of the second point in radians.
 * @param {number} a Semi-major axis of the ellipsoid (meters).
 * @param {number} f Flattening of the ellipsoid.
 * @returns {{ azi1: number, s12: number }} An object containing:
 *   - azi1: Forward azimuth from the first point to the second point (radians).
 *   - s12: Ellipsoidal distance between the two points (meters).
 */ function $4e62dcf6445084ed$export$56278523bd130841(lat1, lon1, lat2, lon2, a, f) {
    const L = lon2 - lon1;
    const U1 = Math.atan((1 - f) * Math.tan(lat1));
    const U2 = Math.atan((1 - f) * Math.tan(lat2));
    const sinU1 = Math.sin(U1), cosU1 = Math.cos(U1);
    const sinU2 = Math.sin(U2), cosU2 = Math.cos(U2);
    let lambda = L, lambdaP, iterLimit = 100;
    let sinLambda, cosLambda, sinSigma, cosSigma, sigma, sinAlpha, cos2Alpha, cos2SigmaM, C;
    let uSq, A, B, deltaSigma, s;
    do {
        sinLambda = Math.sin(lambda);
        cosLambda = Math.cos(lambda);
        sinSigma = Math.sqrt(cosU2 * sinLambda * (cosU2 * sinLambda) + (cosU1 * sinU2 - sinU1 * cosU2 * cosLambda) * (cosU1 * sinU2 - sinU1 * cosU2 * cosLambda));
        if (sinSigma === 0) return {
            azi1: 0,
            s12: 0
        }; // coincident points
        cosSigma = sinU1 * sinU2 + cosU1 * cosU2 * cosLambda;
        sigma = Math.atan2(sinSigma, cosSigma);
        sinAlpha = cosU1 * cosU2 * sinLambda / sinSigma;
        cos2Alpha = 1 - sinAlpha * sinAlpha;
        cos2SigmaM = cos2Alpha !== 0 ? cosSigma - 2 * sinU1 * sinU2 / cos2Alpha : 0;
        C = f / 16 * cos2Alpha * (4 + f * (4 - 3 * cos2Alpha));
        lambdaP = lambda;
        lambda = L + (1 - C) * f * sinAlpha * (sigma + C * sinSigma * (cos2SigmaM + C * cosSigma * (-1 + 2 * cos2SigmaM * cos2SigmaM)));
    }while (Math.abs(lambda - lambdaP) > 1e-12 && --iterLimit > 0);
    if (iterLimit === 0) return {
        azi1: NaN,
        s12: NaN
    }; // formula failed to converge
    uSq = cos2Alpha * (a * a - a * (1 - f) * (a * (1 - f))) / (a * (1 - f) * (a * (1 - f)));
    A = 1 + uSq / 16384 * (4096 + uSq * (-768 + uSq * (320 - 175 * uSq)));
    B = uSq / 1024 * (256 + uSq * (-128 + uSq * (74 - 47 * uSq)));
    deltaSigma = B * sinSigma * (cos2SigmaM + B / 4 * (cosSigma * (-1 + 2 * cos2SigmaM * cos2SigmaM) - B / 6 * cos2SigmaM * (-3 + 4 * sinSigma * sinSigma) * (-3 + 4 * cos2SigmaM * cos2SigmaM)));
    s = a * (1 - f) * A * (sigma - deltaSigma);
    // Forward azimuth
    const azi1 = Math.atan2(cosU2 * sinLambda, cosU1 * sinU2 - sinU1 * cosU2 * cosLambda);
    return {
        azi1: azi1,
        s12: s
    };
}
function $4e62dcf6445084ed$export$b5a922c94102a306(lat1, lon1, azi1, s12, a, f) {
    const U1 = Math.atan((1 - f) * Math.tan(lat1));
    const sinU1 = Math.sin(U1), cosU1 = Math.cos(U1);
    const sinAlpha1 = Math.sin(azi1), cosAlpha1 = Math.cos(azi1);
    const sigma1 = Math.atan2(sinU1, cosU1 * cosAlpha1);
    const sinAlpha = cosU1 * sinAlpha1;
    const cos2Alpha = 1 - sinAlpha * sinAlpha;
    const uSq = cos2Alpha * (a * a - a * (1 - f) * (a * (1 - f))) / (a * (1 - f) * (a * (1 - f)));
    const A = 1 + uSq / 16384 * (4096 + uSq * (-768 + uSq * (320 - 175 * uSq)));
    const B = uSq / 1024 * (256 + uSq * (-128 + uSq * (74 - 47 * uSq)));
    let sigma = s12 / (a * (1 - f) * A), sigmaP, iterLimit = 100;
    let cos2SigmaM, sinSigma, cosSigma, deltaSigma;
    do {
        cos2SigmaM = Math.cos(2 * sigma1 + sigma);
        sinSigma = Math.sin(sigma);
        cosSigma = Math.cos(sigma);
        deltaSigma = B * sinSigma * (cos2SigmaM + B / 4 * (cosSigma * (-1 + 2 * cos2SigmaM * cos2SigmaM) - B / 6 * cos2SigmaM * (-3 + 4 * sinSigma * sinSigma) * (-3 + 4 * cos2SigmaM * cos2SigmaM)));
        sigmaP = sigma;
        sigma = s12 / (a * (1 - f) * A) + deltaSigma;
    }while (Math.abs(sigma - sigmaP) > 1e-12 && --iterLimit > 0);
    if (iterLimit === 0) return {
        lat2: NaN,
        lon2: NaN
    };
    const tmp = sinU1 * sinSigma - cosU1 * cosSigma * cosAlpha1;
    const lat2 = Math.atan2(sinU1 * cosSigma + cosU1 * sinSigma * cosAlpha1, (1 - f) * Math.sqrt(sinAlpha * sinAlpha + tmp * tmp));
    const lambda = Math.atan2(sinSigma * sinAlpha1, cosU1 * cosSigma - sinU1 * sinSigma * cosAlpha1);
    const C = f / 16 * cos2Alpha * (4 + f * (4 - 3 * cos2Alpha));
    const L = lambda - (1 - C) * f * sinAlpha * (sigma + C * sinSigma * (cos2SigmaM + C * cosSigma * (-1 + 2 * cos2SigmaM * cos2SigmaM)));
    const lon2 = lon1 + L;
    return {
        lat2: lat2,
        lon2: lon2
    };
}


function $a5d5ae26b73a0961$export$2cd8252107eb640b() {
    this.sin_p12 = Math.sin(this.lat0);
    this.cos_p12 = Math.cos(this.lat0);
    // flattening for ellipsoid
    this.f = this.es / (1 + Math.sqrt(1 - this.es));
}
function $a5d5ae26b73a0961$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    var sinphi = Math.sin(p.y);
    var cosphi = Math.cos(p.y);
    var dlon = (0, $eRFTg.default)(lon - this.long0, this.over);
    var e0, e1, e2, e3, Mlp, Ml, c, kp, cos_c, vars, azi1;
    if (this.sphere) {
        if (Math.abs(this.sin_p12 - 1) <= (0, $jDCGO.EPSLN)) {
            // North Pole case
            p.x = this.x0 + this.a * ((0, $jDCGO.HALF_PI) - lat) * Math.sin(dlon);
            p.y = this.y0 - this.a * ((0, $jDCGO.HALF_PI) - lat) * Math.cos(dlon);
            return p;
        } else if (Math.abs(this.sin_p12 + 1) <= (0, $jDCGO.EPSLN)) {
            // South Pole case
            p.x = this.x0 + this.a * ((0, $jDCGO.HALF_PI) + lat) * Math.sin(dlon);
            p.y = this.y0 + this.a * ((0, $jDCGO.HALF_PI) + lat) * Math.cos(dlon);
            return p;
        } else {
            // default case
            cos_c = this.sin_p12 * sinphi + this.cos_p12 * cosphi * Math.cos(dlon);
            c = Math.acos(cos_c);
            kp = c ? c / Math.sin(c) : 1;
            p.x = this.x0 + this.a * kp * cosphi * Math.sin(dlon);
            p.y = this.y0 + this.a * kp * (this.cos_p12 * sinphi - this.sin_p12 * cosphi * Math.cos(dlon));
            return p;
        }
    } else {
        e0 = (0, $2bab81ceab37387b$export$2e2bcd8739ae039)(this.es);
        e1 = (0, $52873dbf063a31f1$export$2e2bcd8739ae039)(this.es);
        e2 = (0, $7f92a3574de7064a$export$2e2bcd8739ae039)(this.es);
        e3 = (0, $b51bf5c7b64f947b$export$2e2bcd8739ae039)(this.es);
        if (Math.abs(this.sin_p12 - 1) <= (0, $jDCGO.EPSLN)) {
            // North Pole case
            Mlp = this.a * (0, $c49401959eb323cf$export$2e2bcd8739ae039)(e0, e1, e2, e3, (0, $jDCGO.HALF_PI));
            Ml = this.a * (0, $c49401959eb323cf$export$2e2bcd8739ae039)(e0, e1, e2, e3, lat);
            p.x = this.x0 + (Mlp - Ml) * Math.sin(dlon);
            p.y = this.y0 - (Mlp - Ml) * Math.cos(dlon);
            return p;
        } else if (Math.abs(this.sin_p12 + 1) <= (0, $jDCGO.EPSLN)) {
            // South Pole case
            Mlp = this.a * (0, $c49401959eb323cf$export$2e2bcd8739ae039)(e0, e1, e2, e3, (0, $jDCGO.HALF_PI));
            Ml = this.a * (0, $c49401959eb323cf$export$2e2bcd8739ae039)(e0, e1, e2, e3, lat);
            p.x = this.x0 + (Mlp + Ml) * Math.sin(dlon);
            p.y = this.y0 + (Mlp + Ml) * Math.cos(dlon);
            return p;
        } else {
            // Default case
            if (Math.abs(lon) < (0, $jDCGO.EPSLN) && Math.abs(lat - this.lat0) < (0, $jDCGO.EPSLN)) {
                p.x = p.y = 0;
                return p;
            }
            vars = (0, $4e62dcf6445084ed$export$56278523bd130841)(this.lat0, this.long0, lat, lon, this.a, this.f);
            azi1 = vars.azi1;
            p.x = vars.s12 * Math.sin(azi1);
            p.y = vars.s12 * Math.cos(azi1);
            return p;
        }
    }
}
function $a5d5ae26b73a0961$export$70ae2c07e401031b(p) {
    p.x -= this.x0;
    p.y -= this.y0;
    var rh, z, sinz, cosz, lon, lat, con, e0, e1, e2, e3, Mlp, M, azi1, s12, vars;
    if (this.sphere) {
        rh = Math.sqrt(p.x * p.x + p.y * p.y);
        if (rh > 2 * (0, $jDCGO.HALF_PI) * this.a) return;
        z = rh / this.a;
        sinz = Math.sin(z);
        cosz = Math.cos(z);
        lon = this.long0;
        if (Math.abs(rh) <= (0, $jDCGO.EPSLN)) lat = this.lat0;
        else {
            lat = (0, $3GaS9.default)(cosz * this.sin_p12 + p.y * sinz * this.cos_p12 / rh);
            con = Math.abs(this.lat0) - (0, $jDCGO.HALF_PI);
            if (Math.abs(con) <= (0, $jDCGO.EPSLN)) {
                if (this.lat0 >= 0) lon = (0, $eRFTg.default)(this.long0 + Math.atan2(p.x, -p.y), this.over);
                else lon = (0, $eRFTg.default)(this.long0 - Math.atan2(-p.x, p.y), this.over);
            } else lon = (0, $eRFTg.default)(this.long0 + Math.atan2(p.x * sinz, rh * this.cos_p12 * cosz - p.y * this.sin_p12 * sinz), this.over);
        }
        p.x = lon;
        p.y = lat;
        return p;
    } else {
        e0 = (0, $2bab81ceab37387b$export$2e2bcd8739ae039)(this.es);
        e1 = (0, $52873dbf063a31f1$export$2e2bcd8739ae039)(this.es);
        e2 = (0, $7f92a3574de7064a$export$2e2bcd8739ae039)(this.es);
        e3 = (0, $b51bf5c7b64f947b$export$2e2bcd8739ae039)(this.es);
        if (Math.abs(this.sin_p12 - 1) <= (0, $jDCGO.EPSLN)) {
            // North pole case
            Mlp = this.a * (0, $c49401959eb323cf$export$2e2bcd8739ae039)(e0, e1, e2, e3, (0, $jDCGO.HALF_PI));
            rh = Math.sqrt(p.x * p.x + p.y * p.y);
            M = Mlp - rh;
            lat = (0, $b5eae160d0befa3c$export$2e2bcd8739ae039)(M / this.a, e0, e1, e2, e3);
            lon = (0, $eRFTg.default)(this.long0 + Math.atan2(p.x, -1 * p.y), this.over);
            p.x = lon;
            p.y = lat;
            return p;
        } else if (Math.abs(this.sin_p12 + 1) <= (0, $jDCGO.EPSLN)) {
            // South pole case
            Mlp = this.a * (0, $c49401959eb323cf$export$2e2bcd8739ae039)(e0, e1, e2, e3, (0, $jDCGO.HALF_PI));
            rh = Math.sqrt(p.x * p.x + p.y * p.y);
            M = rh - Mlp;
            lat = (0, $b5eae160d0befa3c$export$2e2bcd8739ae039)(M / this.a, e0, e1, e2, e3);
            lon = (0, $eRFTg.default)(this.long0 + Math.atan2(p.x, p.y), this.over);
            p.x = lon;
            p.y = lat;
            return p;
        } else {
            // default case
            azi1 = Math.atan2(p.x, p.y);
            s12 = Math.sqrt(p.x * p.x + p.y * p.y);
            vars = (0, $4e62dcf6445084ed$export$b5a922c94102a306)(this.lat0, this.long0, azi1, s12, this.a, this.f);
            p.x = vars.lon2;
            p.y = vars.lat2;
            return p;
        }
    }
}
var $a5d5ae26b73a0961$export$e4b2ac9215619f8d = [
    'Azimuthal_Equidistant',
    'aeqd'
];
var $a5d5ae26b73a0961$export$2e2bcd8739ae039 = {
    init: $a5d5ae26b73a0961$export$2cd8252107eb640b,
    forward: $a5d5ae26b73a0961$export$174bb771924e7eb1,
    inverse: $a5d5ae26b73a0961$export$70ae2c07e401031b,
    names: $a5d5ae26b73a0961$export$e4b2ac9215619f8d
};



var $eRFTg = parcelRequire("eRFTg");

var $3GaS9 = parcelRequire("3GaS9");

var $jDCGO = parcelRequire("jDCGO");
function $589e5dd8b01c50cf$export$2cd8252107eb640b() {
    // double temp;      /* temporary variable    */
    /* Place parameters in static storage for common use
      ------------------------------------------------- */ this.sin_p14 = Math.sin(this.lat0 || 0);
    this.cos_p14 = Math.cos(this.lat0 || 0);
}
function $589e5dd8b01c50cf$export$174bb771924e7eb1(p) {
    var sinphi, cosphi; /* sin and cos value        */ 
    var dlon; /* delta longitude value      */ 
    var coslon; /* cos of longitude        */ 
    var ksp; /* scale factor          */ 
    var g, x, y;
    var lon = p.x;
    var lat = p.y;
    /* Forward equations
      ----------------- */ dlon = (0, $eRFTg.default)(lon - (this.long0 || 0), this.over);
    sinphi = Math.sin(lat);
    cosphi = Math.cos(lat);
    coslon = Math.cos(dlon);
    g = this.sin_p14 * sinphi + this.cos_p14 * cosphi * coslon;
    ksp = 1;
    if (g > 0 || Math.abs(g) <= (0, $jDCGO.EPSLN)) {
        x = this.a * ksp * cosphi * Math.sin(dlon);
        y = (this.y0 || 0) + this.a * ksp * (this.cos_p14 * sinphi - this.sin_p14 * cosphi * coslon);
    }
    p.x = x;
    p.y = y;
    return p;
}
function $589e5dd8b01c50cf$export$70ae2c07e401031b(p) {
    var rh; /* height above ellipsoid      */ 
    var z; /* angle          */ 
    var sinz, cosz; /* sin of z and cos of z      */ 
    var con;
    var lon, lat;
    var long0, lat0;
    /* Inverse equations
      ----------------- */ p.x -= this.x0 || 0;
    p.y -= this.y0 || 0;
    rh = Math.sqrt(p.x * p.x + p.y * p.y);
    z = (0, $3GaS9.default)(rh / this.a);
    sinz = Math.sin(z);
    cosz = Math.cos(z);
    long0 = this.long0 || 0;
    lat0 = this.lat0 || 0;
    lon = long0;
    if (Math.abs(rh) <= (0, $jDCGO.EPSLN)) {
        lat = lat0;
        p.x = lon;
        p.y = lat;
        return p;
    }
    lat = (0, $3GaS9.default)(cosz * this.sin_p14 + p.y * sinz * this.cos_p14 / rh);
    con = Math.abs(lat0) - (0, $jDCGO.HALF_PI);
    if (Math.abs(con) <= (0, $jDCGO.EPSLN)) {
        if (lat0 >= 0) lon = (0, $eRFTg.default)(long0 + Math.atan2(p.x, -p.y), this.over);
        else lon = (0, $eRFTg.default)(long0 - Math.atan2(-p.x, p.y), this.over);
        p.x = lon;
        p.y = lat;
        return p;
    }
    lon = (0, $eRFTg.default)(long0 + Math.atan2(p.x * sinz, rh * this.cos_p14 * cosz - p.y * this.sin_p14 * sinz), this.over);
    p.x = lon;
    p.y = lat;
    return p;
}
var $589e5dd8b01c50cf$export$e4b2ac9215619f8d = [
    'ortho'
];
var $589e5dd8b01c50cf$export$2e2bcd8739ae039 = {
    init: $589e5dd8b01c50cf$export$2cd8252107eb640b,
    forward: $589e5dd8b01c50cf$export$174bb771924e7eb1,
    inverse: $589e5dd8b01c50cf$export$70ae2c07e401031b,
    names: $589e5dd8b01c50cf$export$e4b2ac9215619f8d
};


// QSC projection rewritten from the original PROJ4
// https://github.com/OSGeo/proj.4/blob/master/src/PJ_qsc.c

var $jDCGO = parcelRequire("jDCGO");
/**
 * @typedef {Object} LocalThis
 * @property {number} face
 * @property {number} x0
 * @property {number} y0
 * @property {number} es
 * @property {number} one_minus_f
 * @property {number} one_minus_f_squared
 */ /* constants */ var $4e0eaeb8e12a4938$var$FACE_ENUM = {
    FRONT: 1,
    RIGHT: 2,
    BACK: 3,
    LEFT: 4,
    TOP: 5,
    BOTTOM: 6
};
var $4e0eaeb8e12a4938$var$AREA_ENUM = {
    AREA_0: 1,
    AREA_1: 2,
    AREA_2: 3,
    AREA_3: 4
};
function $4e0eaeb8e12a4938$export$2cd8252107eb640b() {
    this.x0 = this.x0 || 0;
    this.y0 = this.y0 || 0;
    this.lat0 = this.lat0 || 0;
    this.long0 = this.long0 || 0;
    this.lat_ts = this.lat_ts || 0;
    this.title = this.title || 'Quadrilateralized Spherical Cube';
    /* Determine the cube face from the center of projection. */ if (this.lat0 >= (0, $jDCGO.HALF_PI) - (0, $jDCGO.FORTPI) / 2.0) this.face = $4e0eaeb8e12a4938$var$FACE_ENUM.TOP;
    else if (this.lat0 <= -((0, $jDCGO.HALF_PI) - (0, $jDCGO.FORTPI) / 2.0)) this.face = $4e0eaeb8e12a4938$var$FACE_ENUM.BOTTOM;
    else if (Math.abs(this.long0) <= (0, $jDCGO.FORTPI)) this.face = $4e0eaeb8e12a4938$var$FACE_ENUM.FRONT;
    else if (Math.abs(this.long0) <= (0, $jDCGO.HALF_PI) + (0, $jDCGO.FORTPI)) this.face = this.long0 > 0.0 ? $4e0eaeb8e12a4938$var$FACE_ENUM.RIGHT : $4e0eaeb8e12a4938$var$FACE_ENUM.LEFT;
    else this.face = $4e0eaeb8e12a4938$var$FACE_ENUM.BACK;
    /* Fill in useful values for the ellipsoid <-> sphere shift
   * described in [LK12]. */ if (this.es !== 0) {
        this.one_minus_f = 1 - (this.a - this.b) / this.a;
        this.one_minus_f_squared = this.one_minus_f * this.one_minus_f;
    }
}
function $4e0eaeb8e12a4938$export$174bb771924e7eb1(p) {
    var xy = {
        x: 0,
        y: 0
    };
    var lat, lon;
    var theta, phi;
    var t, mu;
    /* nu; */ var area = {
        value: 0
    };
    // move lon according to projection's lon
    p.x -= this.long0;
    /* Convert the geodetic latitude to a geocentric latitude.
   * This corresponds to the shift from the ellipsoid to the sphere
   * described in [LK12]. */ if (this.es !== 0) lat = Math.atan(this.one_minus_f_squared * Math.tan(p.y));
    else lat = p.y;
    /* Convert the input lat, lon into theta, phi as used by QSC.
   * This depends on the cube face and the area on it.
   * For the top and bottom face, we can compute theta and phi
   * directly from phi, lam. For the other faces, we must use
   * unit sphere cartesian coordinates as an intermediate step. */ lon = p.x; // lon = lp.lam;
    if (this.face === $4e0eaeb8e12a4938$var$FACE_ENUM.TOP) {
        phi = (0, $jDCGO.HALF_PI) - lat;
        if (lon >= (0, $jDCGO.FORTPI) && lon <= (0, $jDCGO.HALF_PI) + (0, $jDCGO.FORTPI)) {
            area.value = $4e0eaeb8e12a4938$var$AREA_ENUM.AREA_0;
            theta = lon - (0, $jDCGO.HALF_PI);
        } else if (lon > (0, $jDCGO.HALF_PI) + (0, $jDCGO.FORTPI) || lon <= -((0, $jDCGO.HALF_PI) + (0, $jDCGO.FORTPI))) {
            area.value = $4e0eaeb8e12a4938$var$AREA_ENUM.AREA_1;
            theta = lon > 0.0 ? lon - (0, $jDCGO.SPI) : lon + (0, $jDCGO.SPI);
        } else if (lon > -((0, $jDCGO.HALF_PI) + (0, $jDCGO.FORTPI)) && lon <= -(0, $jDCGO.FORTPI)) {
            area.value = $4e0eaeb8e12a4938$var$AREA_ENUM.AREA_2;
            theta = lon + (0, $jDCGO.HALF_PI);
        } else {
            area.value = $4e0eaeb8e12a4938$var$AREA_ENUM.AREA_3;
            theta = lon;
        }
    } else if (this.face === $4e0eaeb8e12a4938$var$FACE_ENUM.BOTTOM) {
        phi = (0, $jDCGO.HALF_PI) + lat;
        if (lon >= (0, $jDCGO.FORTPI) && lon <= (0, $jDCGO.HALF_PI) + (0, $jDCGO.FORTPI)) {
            area.value = $4e0eaeb8e12a4938$var$AREA_ENUM.AREA_0;
            theta = -lon + (0, $jDCGO.HALF_PI);
        } else if (lon < (0, $jDCGO.FORTPI) && lon >= -(0, $jDCGO.FORTPI)) {
            area.value = $4e0eaeb8e12a4938$var$AREA_ENUM.AREA_1;
            theta = -lon;
        } else if (lon < -(0, $jDCGO.FORTPI) && lon >= -((0, $jDCGO.HALF_PI) + (0, $jDCGO.FORTPI))) {
            area.value = $4e0eaeb8e12a4938$var$AREA_ENUM.AREA_2;
            theta = -lon - (0, $jDCGO.HALF_PI);
        } else {
            area.value = $4e0eaeb8e12a4938$var$AREA_ENUM.AREA_3;
            theta = lon > 0.0 ? -lon + (0, $jDCGO.SPI) : -lon - (0, $jDCGO.SPI);
        }
    } else {
        var q, r, s;
        var sinlat, coslat;
        var sinlon, coslon;
        if (this.face === $4e0eaeb8e12a4938$var$FACE_ENUM.RIGHT) lon = $4e0eaeb8e12a4938$var$qsc_shift_lon_origin(lon, +(0, $jDCGO.HALF_PI));
        else if (this.face === $4e0eaeb8e12a4938$var$FACE_ENUM.BACK) lon = $4e0eaeb8e12a4938$var$qsc_shift_lon_origin(lon, +(0, $jDCGO.SPI));
        else if (this.face === $4e0eaeb8e12a4938$var$FACE_ENUM.LEFT) lon = $4e0eaeb8e12a4938$var$qsc_shift_lon_origin(lon, -(0, $jDCGO.HALF_PI));
        sinlat = Math.sin(lat);
        coslat = Math.cos(lat);
        sinlon = Math.sin(lon);
        coslon = Math.cos(lon);
        q = coslat * coslon;
        r = coslat * sinlon;
        s = sinlat;
        if (this.face === $4e0eaeb8e12a4938$var$FACE_ENUM.FRONT) {
            phi = Math.acos(q);
            theta = $4e0eaeb8e12a4938$var$qsc_fwd_equat_face_theta(phi, s, r, area);
        } else if (this.face === $4e0eaeb8e12a4938$var$FACE_ENUM.RIGHT) {
            phi = Math.acos(r);
            theta = $4e0eaeb8e12a4938$var$qsc_fwd_equat_face_theta(phi, s, -q, area);
        } else if (this.face === $4e0eaeb8e12a4938$var$FACE_ENUM.BACK) {
            phi = Math.acos(-q);
            theta = $4e0eaeb8e12a4938$var$qsc_fwd_equat_face_theta(phi, s, -r, area);
        } else if (this.face === $4e0eaeb8e12a4938$var$FACE_ENUM.LEFT) {
            phi = Math.acos(-r);
            theta = $4e0eaeb8e12a4938$var$qsc_fwd_equat_face_theta(phi, s, q, area);
        } else {
            /* Impossible */ phi = theta = 0;
            area.value = $4e0eaeb8e12a4938$var$AREA_ENUM.AREA_0;
        }
    }
    /* Compute mu and nu for the area of definition.
   * For mu, see Eq. (3-21) in [OL76], but note the typos:
   * compare with Eq. (3-14). For nu, see Eq. (3-38). */ mu = Math.atan(12 / (0, $jDCGO.SPI) * (theta + Math.acos(Math.sin(theta) * Math.cos((0, $jDCGO.FORTPI))) - (0, $jDCGO.HALF_PI)));
    t = Math.sqrt((1 - Math.cos(phi)) / (Math.cos(mu) * Math.cos(mu)) / (1 - Math.cos(Math.atan(1 / Math.cos(theta)))));
    /* Apply the result to the real area. */ if (area.value === $4e0eaeb8e12a4938$var$AREA_ENUM.AREA_1) mu += (0, $jDCGO.HALF_PI);
    else if (area.value === $4e0eaeb8e12a4938$var$AREA_ENUM.AREA_2) mu += (0, $jDCGO.SPI);
    else if (area.value === $4e0eaeb8e12a4938$var$AREA_ENUM.AREA_3) mu += 1.5 * (0, $jDCGO.SPI);
    /* Now compute x, y from mu and nu */ xy.x = t * Math.cos(mu);
    xy.y = t * Math.sin(mu);
    xy.x = xy.x * this.a + this.x0;
    xy.y = xy.y * this.a + this.y0;
    p.x = xy.x;
    p.y = xy.y;
    return p;
}
function $4e0eaeb8e12a4938$export$70ae2c07e401031b(p) {
    var lp = {
        lam: 0,
        phi: 0
    };
    var mu, nu, cosmu, tannu;
    var tantheta, theta, cosphi, phi;
    var t;
    var area = {
        value: 0
    };
    /* de-offset */ p.x = (p.x - this.x0) / this.a;
    p.y = (p.y - this.y0) / this.a;
    /* Convert the input x, y to the mu and nu angles as used by QSC.
   * This depends on the area of the cube face. */ nu = Math.atan(Math.sqrt(p.x * p.x + p.y * p.y));
    mu = Math.atan2(p.y, p.x);
    if (p.x >= 0.0 && p.x >= Math.abs(p.y)) area.value = $4e0eaeb8e12a4938$var$AREA_ENUM.AREA_0;
    else if (p.y >= 0.0 && p.y >= Math.abs(p.x)) {
        area.value = $4e0eaeb8e12a4938$var$AREA_ENUM.AREA_1;
        mu -= (0, $jDCGO.HALF_PI);
    } else if (p.x < 0.0 && -p.x >= Math.abs(p.y)) {
        area.value = $4e0eaeb8e12a4938$var$AREA_ENUM.AREA_2;
        mu = mu < 0.0 ? mu + (0, $jDCGO.SPI) : mu - (0, $jDCGO.SPI);
    } else {
        area.value = $4e0eaeb8e12a4938$var$AREA_ENUM.AREA_3;
        mu += (0, $jDCGO.HALF_PI);
    }
    /* Compute phi and theta for the area of definition.
   * The inverse projection is not described in the original paper, but some
   * good hints can be found here (as of 2011-12-14):
   * http://fits.gsfc.nasa.gov/fitsbits/saf.93/saf.9302
   * (search for "Message-Id: <9302181759.AA25477 at fits.cv.nrao.edu>") */ t = (0, $jDCGO.SPI) / 12 * Math.tan(mu);
    tantheta = Math.sin(t) / (Math.cos(t) - 1 / Math.sqrt(2));
    theta = Math.atan(tantheta);
    cosmu = Math.cos(mu);
    tannu = Math.tan(nu);
    cosphi = 1 - cosmu * cosmu * tannu * tannu * (1 - Math.cos(Math.atan(1 / Math.cos(theta))));
    if (cosphi < -1) cosphi = -1;
    else if (cosphi > 1) cosphi = 1;
    /* Apply the result to the real area on the cube face.
   * For the top and bottom face, we can compute phi and lam directly.
   * For the other faces, we must use unit sphere cartesian coordinates
   * as an intermediate step. */ if (this.face === $4e0eaeb8e12a4938$var$FACE_ENUM.TOP) {
        phi = Math.acos(cosphi);
        lp.phi = (0, $jDCGO.HALF_PI) - phi;
        if (area.value === $4e0eaeb8e12a4938$var$AREA_ENUM.AREA_0) lp.lam = theta + (0, $jDCGO.HALF_PI);
        else if (area.value === $4e0eaeb8e12a4938$var$AREA_ENUM.AREA_1) lp.lam = theta < 0.0 ? theta + (0, $jDCGO.SPI) : theta - (0, $jDCGO.SPI);
        else if (area.value === $4e0eaeb8e12a4938$var$AREA_ENUM.AREA_2) lp.lam = theta - (0, $jDCGO.HALF_PI);
        else lp.lam = theta;
    } else if (this.face === $4e0eaeb8e12a4938$var$FACE_ENUM.BOTTOM) {
        phi = Math.acos(cosphi);
        lp.phi = phi - (0, $jDCGO.HALF_PI);
        if (area.value === $4e0eaeb8e12a4938$var$AREA_ENUM.AREA_0) lp.lam = -theta + (0, $jDCGO.HALF_PI);
        else if (area.value === $4e0eaeb8e12a4938$var$AREA_ENUM.AREA_1) lp.lam = -theta;
        else if (area.value === $4e0eaeb8e12a4938$var$AREA_ENUM.AREA_2) lp.lam = -theta - (0, $jDCGO.HALF_PI);
        else lp.lam = theta < 0.0 ? -theta - (0, $jDCGO.SPI) : -theta + (0, $jDCGO.SPI);
    } else {
        /* Compute phi and lam via cartesian unit sphere coordinates. */ var q, r, s;
        q = cosphi;
        t = q * q;
        if (t >= 1) s = 0;
        else s = Math.sqrt(1 - t) * Math.sin(theta);
        t += s * s;
        if (t >= 1) r = 0;
        else r = Math.sqrt(1 - t);
        /* Rotate q,r,s into the correct area. */ if (area.value === $4e0eaeb8e12a4938$var$AREA_ENUM.AREA_1) {
            t = r;
            r = -s;
            s = t;
        } else if (area.value === $4e0eaeb8e12a4938$var$AREA_ENUM.AREA_2) {
            r = -r;
            s = -s;
        } else if (area.value === $4e0eaeb8e12a4938$var$AREA_ENUM.AREA_3) {
            t = r;
            r = s;
            s = -t;
        }
        /* Rotate q,r,s into the correct cube face. */ if (this.face === $4e0eaeb8e12a4938$var$FACE_ENUM.RIGHT) {
            t = q;
            q = -r;
            r = t;
        } else if (this.face === $4e0eaeb8e12a4938$var$FACE_ENUM.BACK) {
            q = -q;
            r = -r;
        } else if (this.face === $4e0eaeb8e12a4938$var$FACE_ENUM.LEFT) {
            t = q;
            q = r;
            r = -t;
        }
        /* Now compute phi and lam from the unit sphere coordinates. */ lp.phi = Math.acos(-s) - (0, $jDCGO.HALF_PI);
        lp.lam = Math.atan2(r, q);
        if (this.face === $4e0eaeb8e12a4938$var$FACE_ENUM.RIGHT) lp.lam = $4e0eaeb8e12a4938$var$qsc_shift_lon_origin(lp.lam, -(0, $jDCGO.HALF_PI));
        else if (this.face === $4e0eaeb8e12a4938$var$FACE_ENUM.BACK) lp.lam = $4e0eaeb8e12a4938$var$qsc_shift_lon_origin(lp.lam, -(0, $jDCGO.SPI));
        else if (this.face === $4e0eaeb8e12a4938$var$FACE_ENUM.LEFT) lp.lam = $4e0eaeb8e12a4938$var$qsc_shift_lon_origin(lp.lam, +(0, $jDCGO.HALF_PI));
    }
    /* Apply the shift from the sphere to the ellipsoid as described
   * in [LK12]. */ if (this.es !== 0) {
        var invert_sign;
        var tanphi, xa;
        invert_sign = lp.phi < 0 ? 1 : 0;
        tanphi = Math.tan(lp.phi);
        xa = this.b / Math.sqrt(tanphi * tanphi + this.one_minus_f_squared);
        lp.phi = Math.atan(Math.sqrt(this.a * this.a - xa * xa) / (this.one_minus_f * xa));
        if (invert_sign) lp.phi = -lp.phi;
    }
    lp.lam += this.long0;
    p.x = lp.lam;
    p.y = lp.phi;
    return p;
}
/* Helper function for forward projection: compute the theta angle
 * and determine the area number. */ function $4e0eaeb8e12a4938$var$qsc_fwd_equat_face_theta(phi, y, x, area) {
    var theta;
    if (phi < (0, $jDCGO.EPSLN)) {
        area.value = $4e0eaeb8e12a4938$var$AREA_ENUM.AREA_0;
        theta = 0.0;
    } else {
        theta = Math.atan2(y, x);
        if (Math.abs(theta) <= (0, $jDCGO.FORTPI)) area.value = $4e0eaeb8e12a4938$var$AREA_ENUM.AREA_0;
        else if (theta > (0, $jDCGO.FORTPI) && theta <= (0, $jDCGO.HALF_PI) + (0, $jDCGO.FORTPI)) {
            area.value = $4e0eaeb8e12a4938$var$AREA_ENUM.AREA_1;
            theta -= (0, $jDCGO.HALF_PI);
        } else if (theta > (0, $jDCGO.HALF_PI) + (0, $jDCGO.FORTPI) || theta <= -((0, $jDCGO.HALF_PI) + (0, $jDCGO.FORTPI))) {
            area.value = $4e0eaeb8e12a4938$var$AREA_ENUM.AREA_2;
            theta = theta >= 0.0 ? theta - (0, $jDCGO.SPI) : theta + (0, $jDCGO.SPI);
        } else {
            area.value = $4e0eaeb8e12a4938$var$AREA_ENUM.AREA_3;
            theta += (0, $jDCGO.HALF_PI);
        }
    }
    return theta;
}
/* Helper function: shift the longitude. */ function $4e0eaeb8e12a4938$var$qsc_shift_lon_origin(lon, offset) {
    var slon = lon + offset;
    if (slon < -(0, $jDCGO.SPI)) slon += (0, $jDCGO.TWO_PI);
    else if (slon > +(0, $jDCGO.SPI)) slon -= (0, $jDCGO.TWO_PI);
    return slon;
}
var $4e0eaeb8e12a4938$export$e4b2ac9215619f8d = [
    'Quadrilateralized Spherical Cube',
    'Quadrilateralized_Spherical_Cube',
    'qsc'
];
var $4e0eaeb8e12a4938$export$2e2bcd8739ae039 = {
    init: $4e0eaeb8e12a4938$export$2cd8252107eb640b,
    forward: $4e0eaeb8e12a4938$export$174bb771924e7eb1,
    inverse: $4e0eaeb8e12a4938$export$70ae2c07e401031b,
    names: $4e0eaeb8e12a4938$export$e4b2ac9215619f8d
};


// Robinson projection
// Based on https://github.com/OSGeo/proj.4/blob/master/src/PJ_robin.c
// Polynomial coeficients from http://article.gmane.org/gmane.comp.gis.proj-4.devel/6039

var $jDCGO = parcelRequire("jDCGO");

var $eRFTg = parcelRequire("eRFTg");
var $6c3d95197fc16965$var$COEFS_X = [
    [
        1.0000,
        2.2199e-17,
        -0.0000715515,
        3.1103e-06
    ],
    [
        0.9986,
        -0.000482243,
        -0.000024897,
        -0.0000013309
    ],
    [
        0.9954,
        -0.00083103,
        -0.0000448605,
        -0.000000986701
    ],
    [
        0.9900,
        -0.00135364,
        -0.000059661,
        3.6777e-06
    ],
    [
        0.9822,
        -0.00167442,
        -0.00000449547,
        -0.00000572411
    ],
    [
        0.9730,
        -0.00214868,
        -0.0000903571,
        1.8736e-08
    ],
    [
        0.9600,
        -0.00305085,
        -0.0000900761,
        1.64917e-06
    ],
    [
        0.9427,
        -0.00382792,
        -0.0000653386,
        -0.0000026154
    ],
    [
        0.9216,
        -0.00467746,
        -0.00010457,
        4.81243e-06
    ],
    [
        0.8962,
        -0.00536223,
        -0.0000323831,
        -0.00000543432
    ],
    [
        0.8679,
        -0.00609363,
        -0.000113898,
        3.32484e-06
    ],
    [
        0.8350,
        -0.00698325,
        -0.0000640253,
        9.34959e-07
    ],
    [
        0.7986,
        -0.00755338,
        -0.0000500009,
        9.35324e-07
    ],
    [
        0.7597,
        -0.00798324,
        -0.000035971,
        -0.00000227626
    ],
    [
        0.7186,
        -0.00851367,
        -0.0000701149,
        -0.0000086303
    ],
    [
        0.6732,
        -0.00986209,
        -0.000199569,
        1.91974e-05
    ],
    [
        0.6213,
        -0.010418,
        8.83923e-05,
        6.24051e-06
    ],
    [
        0.5722,
        -0.00906601,
        0.000182,
        6.24051e-06
    ],
    [
        0.5322,
        -0.00677797,
        0.000275608,
        6.24051e-06
    ]
];
var $6c3d95197fc16965$var$COEFS_Y = [
    [
        -0.00000000000000000520417,
        0.0124,
        1.21431e-18,
        -0.0000000000845284
    ],
    [
        0.0620,
        0.0124,
        -0.00000000126793,
        4.22642e-10
    ],
    [
        0.1240,
        0.0124,
        5.07171e-09,
        -0.00000000160604
    ],
    [
        0.1860,
        0.0123999,
        -0.0000000190189,
        6.00152e-09
    ],
    [
        0.2480,
        0.0124002,
        7.10039e-08,
        -0.0000000224
    ],
    [
        0.3100,
        0.0123992,
        -0.000000264997,
        8.35986e-08
    ],
    [
        0.3720,
        0.0124029,
        9.88983e-07,
        -0.000000311994
    ],
    [
        0.4340,
        0.0123893,
        -0.00000369093,
        -0.000000435621
    ],
    [
        0.4958,
        0.0123198,
        -0.0000102252,
        -0.000000345523
    ],
    [
        0.5571,
        0.0121916,
        -0.0000154081,
        -0.000000582288
    ],
    [
        0.6176,
        0.0119938,
        -0.0000241424,
        -0.000000525327
    ],
    [
        0.6769,
        0.011713,
        -0.0000320223,
        -0.000000516405
    ],
    [
        0.7346,
        0.0113541,
        -0.0000397684,
        -0.000000609052
    ],
    [
        0.7903,
        0.0109107,
        -0.0000489042,
        -0.00000104739
    ],
    [
        0.8435,
        0.0103431,
        -0.000064615,
        -0.00000000140374
    ],
    [
        0.8936,
        0.00969686,
        -0.000064636,
        -0.000008547
    ],
    [
        0.9394,
        0.00840947,
        -0.000192841,
        -0.0000042106
    ],
    [
        0.9761,
        0.00616527,
        -0.000256,
        -0.0000042106
    ],
    [
        1.0000,
        0.00328947,
        -0.000319159,
        -0.0000042106
    ]
];
var $6c3d95197fc16965$var$FXC = 0.8487;
var $6c3d95197fc16965$var$FYC = 1.3523;
var $6c3d95197fc16965$var$C1 = (0, $jDCGO.R2D) / 5; // rad to 5-degree interval
var $6c3d95197fc16965$var$RC1 = 1 / $6c3d95197fc16965$var$C1;
var $6c3d95197fc16965$var$NODES = 18;
var $6c3d95197fc16965$var$poly3_val = function(coefs, x) {
    return coefs[0] + x * (coefs[1] + x * (coefs[2] + x * coefs[3]));
};
var $6c3d95197fc16965$var$poly3_der = function(coefs, x) {
    return coefs[1] + x * (2 * coefs[2] + x * 3 * coefs[3]);
};
function $6c3d95197fc16965$var$newton_rapshon(f_df, start, max_err, iters) {
    var x = start;
    for(; iters; --iters){
        var upd = f_df(x);
        x -= upd;
        if (Math.abs(upd) < max_err) break;
    }
    return x;
}
function $6c3d95197fc16965$export$2cd8252107eb640b() {
    this.x0 = this.x0 || 0;
    this.y0 = this.y0 || 0;
    this.long0 = this.long0 || 0;
    this.es = 0;
    this.title = this.title || 'Robinson';
}
function $6c3d95197fc16965$export$174bb771924e7eb1(ll) {
    var lon = (0, $eRFTg.default)(ll.x - this.long0, this.over);
    var dphi = Math.abs(ll.y);
    var i = Math.floor(dphi * $6c3d95197fc16965$var$C1);
    if (i < 0) i = 0;
    else if (i >= $6c3d95197fc16965$var$NODES) i = $6c3d95197fc16965$var$NODES - 1;
    dphi = (0, $jDCGO.R2D) * (dphi - $6c3d95197fc16965$var$RC1 * i);
    var xy = {
        x: $6c3d95197fc16965$var$poly3_val($6c3d95197fc16965$var$COEFS_X[i], dphi) * lon,
        y: $6c3d95197fc16965$var$poly3_val($6c3d95197fc16965$var$COEFS_Y[i], dphi)
    };
    if (ll.y < 0) xy.y = -xy.y;
    xy.x = xy.x * this.a * $6c3d95197fc16965$var$FXC + this.x0;
    xy.y = xy.y * this.a * $6c3d95197fc16965$var$FYC + this.y0;
    return xy;
}
function $6c3d95197fc16965$export$70ae2c07e401031b(xy) {
    var ll = {
        x: (xy.x - this.x0) / (this.a * $6c3d95197fc16965$var$FXC),
        y: Math.abs(xy.y - this.y0) / (this.a * $6c3d95197fc16965$var$FYC)
    };
    if (ll.y >= 1) {
        ll.x /= $6c3d95197fc16965$var$COEFS_X[$6c3d95197fc16965$var$NODES][0];
        ll.y = xy.y < 0 ? -(0, $jDCGO.HALF_PI) : (0, $jDCGO.HALF_PI);
    } else {
        // find table interval
        var i = Math.floor(ll.y * $6c3d95197fc16965$var$NODES);
        if (i < 0) i = 0;
        else if (i >= $6c3d95197fc16965$var$NODES) i = $6c3d95197fc16965$var$NODES - 1;
        for(;;){
            if ($6c3d95197fc16965$var$COEFS_Y[i][0] > ll.y) --i;
            else if ($6c3d95197fc16965$var$COEFS_Y[i + 1][0] <= ll.y) ++i;
            else break;
        }
        // linear interpolation in 5 degree interval
        var coefs = $6c3d95197fc16965$var$COEFS_Y[i];
        var t = 5 * (ll.y - coefs[0]) / ($6c3d95197fc16965$var$COEFS_Y[i + 1][0] - coefs[0]);
        // find t so that poly3_val(coefs, t) = ll.y
        t = $6c3d95197fc16965$var$newton_rapshon(function(x) {
            return ($6c3d95197fc16965$var$poly3_val(coefs, x) - ll.y) / $6c3d95197fc16965$var$poly3_der(coefs, x);
        }, t, (0, $jDCGO.EPSLN), 100);
        ll.x /= $6c3d95197fc16965$var$poly3_val($6c3d95197fc16965$var$COEFS_X[i], t);
        ll.y = (5 * i + t) * (0, $jDCGO.D2R);
        if (xy.y < 0) ll.y = -ll.y;
    }
    ll.x = (0, $eRFTg.default)(ll.x + this.long0, this.over);
    return ll;
}
var $6c3d95197fc16965$export$e4b2ac9215619f8d = [
    'Robinson',
    'robin'
];
var $6c3d95197fc16965$export$2e2bcd8739ae039 = {
    init: $6c3d95197fc16965$export$2cd8252107eb640b,
    forward: $6c3d95197fc16965$export$174bb771924e7eb1,
    inverse: $6c3d95197fc16965$export$70ae2c07e401031b,
    names: $6c3d95197fc16965$export$e4b2ac9215619f8d
};



function $a6f46c0772597d95$export$2cd8252107eb640b() {
    this.name = 'geocent';
}
function $a6f46c0772597d95$export$174bb771924e7eb1(p) {
    var point = (0, $2fc2148347b1eda1$export$4a4ae2976f9a808a)(p, this.es, this.a);
    return point;
}
function $a6f46c0772597d95$export$70ae2c07e401031b(p) {
    var point = (0, $2fc2148347b1eda1$export$26210192c8922750)(p, this.es, this.a, this.b);
    return point;
}
var $a6f46c0772597d95$export$e4b2ac9215619f8d = [
    'Geocentric',
    'geocentric',
    'geocent',
    'Geocent'
];
var $a6f46c0772597d95$export$2e2bcd8739ae039 = {
    init: $a6f46c0772597d95$export$2cd8252107eb640b,
    forward: $a6f46c0772597d95$export$174bb771924e7eb1,
    inverse: $a6f46c0772597d95$export$70ae2c07e401031b,
    names: $a6f46c0772597d95$export$e4b2ac9215619f8d
};



var $jDCGO = parcelRequire("jDCGO");

var $3ZcmO = parcelRequire("3ZcmO");
/**
 * @typedef {Object} LocalThis
 * @property {number} mode
 * @property {number} sinph0
 * @property {number} cosph0
 * @property {number} pn1
 * @property {number} h
 * @property {number} rp
 * @property {number} p
 * @property {number} h1
 * @property {number} pfact
 * @property {number} es
 * @property {number} tilt
 * @property {number} azi
 * @property {number} cg
 * @property {number} sg
 * @property {number} cw
 * @property {number} sw
 */ var $733bd8a5a2473ba7$var$mode = {
    N_POLE: 0,
    S_POLE: 1,
    EQUIT: 2,
    OBLIQ: 3
};
var $733bd8a5a2473ba7$var$params = {
    h: {
        def: 100000,
        num: true
    },
    azi: {
        def: 0,
        num: true,
        degrees: true
    },
    tilt: {
        def: 0,
        num: true,
        degrees: true
    },
    long0: {
        def: 0,
        num: true
    },
    lat0: {
        def: 0,
        num: true
    } // default is Equator, conversion to rad is automatic
};
function $733bd8a5a2473ba7$export$2cd8252107eb640b() {
    Object.keys($733bd8a5a2473ba7$var$params).forEach((function(p) {
        if (typeof this[p] === 'undefined') this[p] = $733bd8a5a2473ba7$var$params[p].def;
        else if ($733bd8a5a2473ba7$var$params[p].num && isNaN(this[p])) throw new Error('Invalid parameter value, must be numeric ' + p + ' = ' + this[p]);
        else if ($733bd8a5a2473ba7$var$params[p].num) this[p] = parseFloat(this[p]);
        if ($733bd8a5a2473ba7$var$params[p].degrees) this[p] = this[p] * (0, $jDCGO.D2R);
    }).bind(this));
    if (Math.abs(Math.abs(this.lat0) - (0, $jDCGO.HALF_PI)) < (0, $jDCGO.EPSLN)) this.mode = this.lat0 < 0 ? $733bd8a5a2473ba7$var$mode.S_POLE : $733bd8a5a2473ba7$var$mode.N_POLE;
    else if (Math.abs(this.lat0) < (0, $jDCGO.EPSLN)) this.mode = $733bd8a5a2473ba7$var$mode.EQUIT;
    else {
        this.mode = $733bd8a5a2473ba7$var$mode.OBLIQ;
        this.sinph0 = Math.sin(this.lat0);
        this.cosph0 = Math.cos(this.lat0);
    }
    this.pn1 = this.h / this.a; // Normalize relative to the Earth's radius
    if (this.pn1 <= 0 || this.pn1 > 1e10) throw new Error('Invalid height');
    this.p = 1 + this.pn1;
    this.rp = 1 / this.p;
    this.h1 = 1 / this.pn1;
    this.pfact = (this.p + 1) * this.h1;
    this.es = 0;
    var omega = this.tilt;
    var gamma = this.azi;
    this.cg = Math.cos(gamma);
    this.sg = Math.sin(gamma);
    this.cw = Math.cos(omega);
    this.sw = Math.sin(omega);
}
function $733bd8a5a2473ba7$export$174bb771924e7eb1(p) {
    p.x -= this.long0;
    var sinphi = Math.sin(p.y);
    var cosphi = Math.cos(p.y);
    var coslam = Math.cos(p.x);
    var x, y;
    switch(this.mode){
        case $733bd8a5a2473ba7$var$mode.OBLIQ:
            y = this.sinph0 * sinphi + this.cosph0 * cosphi * coslam;
            break;
        case $733bd8a5a2473ba7$var$mode.EQUIT:
            y = cosphi * coslam;
            break;
        case $733bd8a5a2473ba7$var$mode.S_POLE:
            y = -sinphi;
            break;
        case $733bd8a5a2473ba7$var$mode.N_POLE:
            y = sinphi;
            break;
    }
    y = this.pn1 / (this.p - y);
    x = y * cosphi * Math.sin(p.x);
    switch(this.mode){
        case $733bd8a5a2473ba7$var$mode.OBLIQ:
            y *= this.cosph0 * sinphi - this.sinph0 * cosphi * coslam;
            break;
        case $733bd8a5a2473ba7$var$mode.EQUIT:
            y *= sinphi;
            break;
        case $733bd8a5a2473ba7$var$mode.N_POLE:
            y *= -(cosphi * coslam);
            break;
        case $733bd8a5a2473ba7$var$mode.S_POLE:
            y *= cosphi * coslam;
            break;
    }
    // Tilt
    var yt, ba;
    yt = y * this.cg + x * this.sg;
    ba = 1 / (yt * this.sw * this.h1 + this.cw);
    x = (x * this.cg - y * this.sg) * this.cw * ba;
    y = yt * ba;
    p.x = x * this.a;
    p.y = y * this.a;
    return p;
}
function $733bd8a5a2473ba7$export$70ae2c07e401031b(p) {
    p.x /= this.a;
    p.y /= this.a;
    var r = {
        x: p.x,
        y: p.y
    };
    // Un-Tilt
    var bm, bq, yt;
    yt = 1 / (this.pn1 - p.y * this.sw);
    bm = this.pn1 * p.x * yt;
    bq = this.pn1 * p.y * this.cw * yt;
    p.x = bm * this.cg + bq * this.sg;
    p.y = bq * this.cg - bm * this.sg;
    var rh = (0, $3ZcmO.default)(p.x, p.y);
    if (Math.abs(rh) < (0, $jDCGO.EPSLN)) {
        r.x = 0;
        r.y = p.y;
    } else {
        var cosz, sinz;
        sinz = 1 - rh * rh * this.pfact;
        sinz = (this.p - Math.sqrt(sinz)) / (this.pn1 / rh + rh / this.pn1);
        cosz = Math.sqrt(1 - sinz * sinz);
        switch(this.mode){
            case $733bd8a5a2473ba7$var$mode.OBLIQ:
                r.y = Math.asin(cosz * this.sinph0 + p.y * sinz * this.cosph0 / rh);
                p.y = (cosz - this.sinph0 * Math.sin(r.y)) * rh;
                p.x *= sinz * this.cosph0;
                break;
            case $733bd8a5a2473ba7$var$mode.EQUIT:
                r.y = Math.asin(p.y * sinz / rh);
                p.y = cosz * rh;
                p.x *= sinz;
                break;
            case $733bd8a5a2473ba7$var$mode.N_POLE:
                r.y = Math.asin(cosz);
                p.y = -p.y;
                break;
            case $733bd8a5a2473ba7$var$mode.S_POLE:
                r.y = -Math.asin(cosz);
                break;
        }
        r.x = Math.atan2(p.x, p.y);
    }
    p.x = r.x + this.long0;
    p.y = r.y;
    return p;
}
var $733bd8a5a2473ba7$export$e4b2ac9215619f8d = [
    'Tilted_Perspective',
    'tpers'
];
var $733bd8a5a2473ba7$export$2e2bcd8739ae039 = {
    init: $733bd8a5a2473ba7$export$2cd8252107eb640b,
    forward: $733bd8a5a2473ba7$export$174bb771924e7eb1,
    inverse: $733bd8a5a2473ba7$export$70ae2c07e401031b,
    names: $733bd8a5a2473ba7$export$e4b2ac9215619f8d
};



var $3ZcmO = parcelRequire("3ZcmO");
function $7bef3ff1ed839340$export$2cd8252107eb640b() {
    this.flip_axis = this.sweep === 'x' ? 1 : 0;
    this.h = Number(this.h);
    this.radius_g_1 = this.h / this.a;
    if (this.radius_g_1 <= 0 || this.radius_g_1 > 1e10) throw new Error();
    this.radius_g = 1.0 + this.radius_g_1;
    this.C = this.radius_g * this.radius_g - 1.0;
    if (this.es !== 0.0) {
        var one_es = 1.0 - this.es;
        var rone_es = 1 / one_es;
        this.radius_p = Math.sqrt(one_es);
        this.radius_p2 = one_es;
        this.radius_p_inv2 = rone_es;
        this.shape = 'ellipse'; // Use as a condition in the forward and inverse functions.
    } else {
        this.radius_p = 1.0;
        this.radius_p2 = 1.0;
        this.radius_p_inv2 = 1.0;
        this.shape = 'sphere'; // Use as a condition in the forward and inverse functions.
    }
    if (!this.title) this.title = 'Geostationary Satellite View';
}
function $7bef3ff1ed839340$var$forward(p) {
    var lon = p.x;
    var lat = p.y;
    var tmp, v_x, v_y, v_z;
    lon = lon - this.long0;
    if (this.shape === 'ellipse') {
        lat = Math.atan(this.radius_p2 * Math.tan(lat));
        var r = this.radius_p / (0, $3ZcmO.default)(this.radius_p * Math.cos(lat), Math.sin(lat));
        v_x = r * Math.cos(lon) * Math.cos(lat);
        v_y = r * Math.sin(lon) * Math.cos(lat);
        v_z = r * Math.sin(lat);
        if ((this.radius_g - v_x) * v_x - v_y * v_y - v_z * v_z * this.radius_p_inv2 < 0.0) {
            p.x = Number.NaN;
            p.y = Number.NaN;
            return p;
        }
        tmp = this.radius_g - v_x;
        if (this.flip_axis) {
            p.x = this.radius_g_1 * Math.atan(v_y / (0, $3ZcmO.default)(v_z, tmp));
            p.y = this.radius_g_1 * Math.atan(v_z / tmp);
        } else {
            p.x = this.radius_g_1 * Math.atan(v_y / tmp);
            p.y = this.radius_g_1 * Math.atan(v_z / (0, $3ZcmO.default)(v_y, tmp));
        }
    } else if (this.shape === 'sphere') {
        tmp = Math.cos(lat);
        v_x = Math.cos(lon) * tmp;
        v_y = Math.sin(lon) * tmp;
        v_z = Math.sin(lat);
        tmp = this.radius_g - v_x;
        if (this.flip_axis) {
            p.x = this.radius_g_1 * Math.atan(v_y / (0, $3ZcmO.default)(v_z, tmp));
            p.y = this.radius_g_1 * Math.atan(v_z / tmp);
        } else {
            p.x = this.radius_g_1 * Math.atan(v_y / tmp);
            p.y = this.radius_g_1 * Math.atan(v_z / (0, $3ZcmO.default)(v_y, tmp));
        }
    }
    p.x = p.x * this.a;
    p.y = p.y * this.a;
    return p;
}
function $7bef3ff1ed839340$var$inverse(p) {
    var v_x = -1;
    var v_y = 0.0;
    var v_z = 0.0;
    var a, b, det, k;
    p.x = p.x / this.a;
    p.y = p.y / this.a;
    if (this.shape === 'ellipse') {
        if (this.flip_axis) {
            v_z = Math.tan(p.y / this.radius_g_1);
            v_y = Math.tan(p.x / this.radius_g_1) * (0, $3ZcmO.default)(1.0, v_z);
        } else {
            v_y = Math.tan(p.x / this.radius_g_1);
            v_z = Math.tan(p.y / this.radius_g_1) * (0, $3ZcmO.default)(1.0, v_y);
        }
        var v_zp = v_z / this.radius_p;
        a = v_y * v_y + v_zp * v_zp + v_x * v_x;
        b = 2 * this.radius_g * v_x;
        det = b * b - 4 * a * this.C;
        if (det < 0.0) {
            p.x = Number.NaN;
            p.y = Number.NaN;
            return p;
        }
        k = (-b - Math.sqrt(det)) / (2.0 * a);
        v_x = this.radius_g + k * v_x;
        v_y *= k;
        v_z *= k;
        p.x = Math.atan2(v_y, v_x);
        p.y = Math.atan(v_z * Math.cos(p.x) / v_x);
        p.y = Math.atan(this.radius_p_inv2 * Math.tan(p.y));
    } else if (this.shape === 'sphere') {
        if (this.flip_axis) {
            v_z = Math.tan(p.y / this.radius_g_1);
            v_y = Math.tan(p.x / this.radius_g_1) * Math.sqrt(1.0 + v_z * v_z);
        } else {
            v_y = Math.tan(p.x / this.radius_g_1);
            v_z = Math.tan(p.y / this.radius_g_1) * Math.sqrt(1.0 + v_y * v_y);
        }
        a = v_y * v_y + v_z * v_z + v_x * v_x;
        b = 2 * this.radius_g * v_x;
        det = b * b - 4 * a * this.C;
        if (det < 0.0) {
            p.x = Number.NaN;
            p.y = Number.NaN;
            return p;
        }
        k = (-b - Math.sqrt(det)) / (2.0 * a);
        v_x = this.radius_g + k * v_x;
        v_y *= k;
        v_z *= k;
        p.x = Math.atan2(v_y, v_x);
        p.y = Math.atan(v_z * Math.cos(p.x) / v_x);
    }
    p.x = p.x + this.long0;
    return p;
}
var $7bef3ff1ed839340$export$e4b2ac9215619f8d = [
    'Geostationary Satellite View',
    'Geostationary_Satellite',
    'geos'
];
var $7bef3ff1ed839340$export$2e2bcd8739ae039 = {
    init: $7bef3ff1ed839340$export$2cd8252107eb640b,
    forward: $7bef3ff1ed839340$var$forward,
    inverse: $7bef3ff1ed839340$var$inverse,
    names: $7bef3ff1ed839340$export$e4b2ac9215619f8d
};


/**
 * Copyright 2018 Bernie Jenny, Monash University, Melbourne, Australia.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Equal Earth is a projection inspired by the Robinson projection, but unlike
 * the Robinson projection retains the relative size of areas. The projection
 * was designed in 2018 by Bojan Savric, Tom Patterson and Bernhard Jenny.
 *
 * Publication:
 * Bojan Savric, Tom Patterson & Bernhard Jenny (2018). The Equal Earth map
 * projection, International Journal of Geographical Information Science,
 * DOI: 10.1080/13658816.2018.1504949
 *
 * Code released August 2018
 * Ported to JavaScript and adapted for mapshaper-proj by Matthew Bloch August 2018
 * Modified for proj4js by Andreas Hocevar by Andreas Hocevar March 2024
 */ 
var $eRFTg = parcelRequire("eRFTg");
var $39399e295a214ad8$var$A1 = 1.340264, $39399e295a214ad8$var$A2 = -0.081106, $39399e295a214ad8$var$A3 = 0.000893, $39399e295a214ad8$var$A4 = 0.003796, $39399e295a214ad8$var$M = Math.sqrt(3) / 2.0;
function $39399e295a214ad8$export$2cd8252107eb640b() {
    this.es = 0;
    this.long0 = this.long0 !== undefined ? this.long0 : 0;
    this.x0 = this.x0 !== undefined ? this.x0 : 0;
    this.y0 = this.y0 !== undefined ? this.y0 : 0;
}
function $39399e295a214ad8$export$174bb771924e7eb1(p) {
    var lam = (0, $eRFTg.default)(p.x - this.long0, this.over);
    var phi = p.y;
    var paramLat = Math.asin($39399e295a214ad8$var$M * Math.sin(phi)), paramLatSq = paramLat * paramLat, paramLatPow6 = paramLatSq * paramLatSq * paramLatSq;
    p.x = lam * Math.cos(paramLat) / ($39399e295a214ad8$var$M * ($39399e295a214ad8$var$A1 + 3 * $39399e295a214ad8$var$A2 * paramLatSq + paramLatPow6 * (7 * $39399e295a214ad8$var$A3 + 9 * $39399e295a214ad8$var$A4 * paramLatSq)));
    p.y = paramLat * ($39399e295a214ad8$var$A1 + $39399e295a214ad8$var$A2 * paramLatSq + paramLatPow6 * ($39399e295a214ad8$var$A3 + $39399e295a214ad8$var$A4 * paramLatSq));
    p.x = this.a * p.x + this.x0;
    p.y = this.a * p.y + this.y0;
    return p;
}
function $39399e295a214ad8$export$70ae2c07e401031b(p) {
    p.x = (p.x - this.x0) / this.a;
    p.y = (p.y - this.y0) / this.a;
    var EPS = 1e-9, NITER = 12, paramLat = p.y, paramLatSq, paramLatPow6, fy, fpy, dlat, i;
    for(i = 0; i < NITER; ++i){
        paramLatSq = paramLat * paramLat;
        paramLatPow6 = paramLatSq * paramLatSq * paramLatSq;
        fy = paramLat * ($39399e295a214ad8$var$A1 + $39399e295a214ad8$var$A2 * paramLatSq + paramLatPow6 * ($39399e295a214ad8$var$A3 + $39399e295a214ad8$var$A4 * paramLatSq)) - p.y;
        fpy = $39399e295a214ad8$var$A1 + 3 * $39399e295a214ad8$var$A2 * paramLatSq + paramLatPow6 * (7 * $39399e295a214ad8$var$A3 + 9 * $39399e295a214ad8$var$A4 * paramLatSq);
        paramLat -= dlat = fy / fpy;
        if (Math.abs(dlat) < EPS) break;
    }
    paramLatSq = paramLat * paramLat;
    paramLatPow6 = paramLatSq * paramLatSq * paramLatSq;
    p.x = $39399e295a214ad8$var$M * p.x * ($39399e295a214ad8$var$A1 + 3 * $39399e295a214ad8$var$A2 * paramLatSq + paramLatPow6 * (7 * $39399e295a214ad8$var$A3 + 9 * $39399e295a214ad8$var$A4 * paramLatSq)) / Math.cos(paramLat);
    p.y = Math.asin(Math.sin(paramLat) / $39399e295a214ad8$var$M);
    p.x = (0, $eRFTg.default)(p.x + this.long0, this.over);
    return p;
}
var $39399e295a214ad8$export$e4b2ac9215619f8d = [
    'eqearth',
    'Equal Earth',
    'Equal_Earth'
];
var $39399e295a214ad8$export$2e2bcd8739ae039 = {
    init: $39399e295a214ad8$export$2cd8252107eb640b,
    forward: $39399e295a214ad8$export$174bb771924e7eb1,
    inverse: $39399e295a214ad8$export$70ae2c07e401031b,
    names: $39399e295a214ad8$export$e4b2ac9215619f8d
};




var $eRFTg = parcelRequire("eRFTg");

var $3ZcmO = parcelRequire("3ZcmO");

var $1t7xy = parcelRequire("1t7xy");

var $aItGy = parcelRequire("aItGy");

var $6D29U = parcelRequire("6D29U");

var $jDCGO = parcelRequire("jDCGO");
/**
 * @typedef {Object} LocalThis
 * @property {number} phi1
 * @property {number} cphi1
 * @property {number} es
 * @property {Array<number>} en
 * @property {number} m1
 * @property {number} am1
 */ var $c4234e109a782db2$var$EPS10 = 1e-10;
function $c4234e109a782db2$export$2cd8252107eb640b() {
    var c;
    this.phi1 = this.lat1;
    if (Math.abs(this.phi1) < $c4234e109a782db2$var$EPS10) throw new Error();
    if (this.es) {
        this.en = (0, $1t7xy.default)(this.es);
        this.m1 = (0, $6D29U.default)(this.phi1, this.am1 = Math.sin(this.phi1), c = Math.cos(this.phi1), this.en);
        this.am1 = c / (Math.sqrt(1 - this.es * this.am1 * this.am1) * this.am1);
        this.inverse = $c4234e109a782db2$var$e_inv;
        this.forward = $c4234e109a782db2$var$e_fwd;
    } else {
        if (Math.abs(this.phi1) + $c4234e109a782db2$var$EPS10 >= (0, $jDCGO.HALF_PI)) this.cphi1 = 0;
        else this.cphi1 = 1 / Math.tan(this.phi1);
        this.inverse = $c4234e109a782db2$var$s_inv;
        this.forward = $c4234e109a782db2$var$s_fwd;
    }
}
function $c4234e109a782db2$var$e_fwd(p) {
    var lam = (0, $eRFTg.default)(p.x - (this.long0 || 0), this.over);
    var phi = p.y;
    var rh, E, c;
    rh = this.am1 + this.m1 - (0, $6D29U.default)(phi, E = Math.sin(phi), c = Math.cos(phi), this.en);
    E = c * lam / (rh * Math.sqrt(1 - this.es * E * E));
    p.x = rh * Math.sin(E);
    p.y = this.am1 - rh * Math.cos(E);
    p.x = this.a * p.x + (this.x0 || 0);
    p.y = this.a * p.y + (this.y0 || 0);
    return p;
}
function $c4234e109a782db2$var$e_inv(p) {
    p.x = (p.x - (this.x0 || 0)) / this.a;
    p.y = (p.y - (this.y0 || 0)) / this.a;
    var s, rh, lam, phi;
    rh = (0, $3ZcmO.default)(p.x, p.y = this.am1 - p.y);
    phi = (0, $aItGy.default)(this.am1 + this.m1 - rh, this.es, this.en);
    if ((s = Math.abs(phi)) < (0, $jDCGO.HALF_PI)) {
        s = Math.sin(phi);
        lam = rh * Math.atan2(p.x, p.y) * Math.sqrt(1 - this.es * s * s) / Math.cos(phi);
    } else if (Math.abs(s - (0, $jDCGO.HALF_PI)) <= $c4234e109a782db2$var$EPS10) lam = 0;
    else throw new Error();
    p.x = (0, $eRFTg.default)(lam + (this.long0 || 0), this.over);
    p.y = (0, $5f1e150a9cf227e1$export$2e2bcd8739ae039)(phi);
    return p;
}
function $c4234e109a782db2$var$s_fwd(p) {
    var lam = (0, $eRFTg.default)(p.x - (this.long0 || 0), this.over);
    var phi = p.y;
    var E, rh;
    rh = this.cphi1 + this.phi1 - phi;
    if (Math.abs(rh) > $c4234e109a782db2$var$EPS10) {
        p.x = rh * Math.sin(E = lam * Math.cos(phi) / rh);
        p.y = this.cphi1 - rh * Math.cos(E);
    } else p.x = p.y = 0;
    p.x = this.a * p.x + (this.x0 || 0);
    p.y = this.a * p.y + (this.y0 || 0);
    return p;
}
function $c4234e109a782db2$var$s_inv(p) {
    p.x = (p.x - (this.x0 || 0)) / this.a;
    p.y = (p.y - (this.y0 || 0)) / this.a;
    var lam, phi;
    var rh = (0, $3ZcmO.default)(p.x, p.y = this.cphi1 - p.y);
    phi = this.cphi1 + this.phi1 - rh;
    if (Math.abs(phi) > (0, $jDCGO.HALF_PI)) throw new Error();
    if (Math.abs(Math.abs(phi) - (0, $jDCGO.HALF_PI)) <= $c4234e109a782db2$var$EPS10) lam = 0;
    else lam = rh * Math.atan2(p.x, p.y) / Math.cos(phi);
    p.x = (0, $eRFTg.default)(lam + (this.long0 || 0), this.over);
    p.y = (0, $5f1e150a9cf227e1$export$2e2bcd8739ae039)(phi);
    return p;
}
var $c4234e109a782db2$export$e4b2ac9215619f8d = [
    'bonne',
    'Bonne (Werner lat_1=90)'
];
var $c4234e109a782db2$export$2e2bcd8739ae039 = {
    init: $c4234e109a782db2$export$2cd8252107eb640b,
    names: $c4234e109a782db2$export$e4b2ac9215619f8d
};



var $eRFTg = parcelRequire("eRFTg");

var $jDCGO = parcelRequire("jDCGO");


/**
    Original projection implementation:
        https://github.com/OSGeo/PROJ/blob/46c47e9adf6376ae06afabe5d24a0016a05ced82/src/projections/ob_tran.cpp

    Documentation:
        https://proj.org/operations/projections/ob_tran.html

    References/Formulas:
        https://pubs.usgs.gov/pp/1395/report.pdf

    Examples:
        +proj=ob_tran +o_proj=moll +o_lat_p=45 +o_lon_p=-90
        +proj=ob_tran +o_proj=moll +o_lat_p=45 +o_lon_p=-90 +lon_0=60
        +proj=ob_tran +o_proj=moll +o_lat_p=45 +o_lon_p=-90 +lon_0=-90
*/ const $907f7ddcd3064c1e$var$projectionType = {
    OBLIQUE: {
        forward: $907f7ddcd3064c1e$var$forwardOblique,
        inverse: $907f7ddcd3064c1e$var$inverseOblique
    },
    TRANSVERSE: {
        forward: $907f7ddcd3064c1e$var$forwardTransverse,
        inverse: $907f7ddcd3064c1e$var$inverseTransverse
    }
};
/**
 * @typedef {Object} LocalThis
 * @property {number} lamp
 * @property {number} cphip
 * @property {number} sphip
 * @property {Object} projectionType
 * @property {string | undefined} o_proj
 * @property {string | undefined} o_lon_p
 * @property {string | undefined} o_lat_p
 * @property {string | undefined} o_alpha
 * @property {string | undefined} o_lon_c
 * @property {string | undefined} o_lat_c
 * @property {string | undefined} o_lon_1
 * @property {string | undefined} o_lat_1
 * @property {string | undefined} o_lon_2
 * @property {string | undefined} o_lat_2
 * @property {number | undefined} oLongP
 * @property {number | undefined} oLatP
 * @property {number | undefined} oAlpha
 * @property {number | undefined} oLongC
 * @property {number | undefined} oLatC
 * @property {number | undefined} oLong1
 * @property {number | undefined} oLat1
 * @property {number | undefined} oLong2
 * @property {number | undefined} oLat2
 * @property {boolean} isIdentity
 * @property {import('..').Converter} obliqueProjection
 *
 */ /**
 *    Parameters can be from the following sets:
 *       New pole --> o_lat_p, o_lon_p
 *       Rotate about point --> o_alpha, o_lon_c, o_lat_c
 *       New equator points --> lon_1, lat_1, lon_2, lat_2
 *
 *    Per the original source code, the parameter sets are
 *    checked in the order of the object below.
 */ const $907f7ddcd3064c1e$var$paramSets = {
    ROTATE: {
        o_alpha: 'oAlpha',
        o_lon_c: 'oLongC',
        o_lat_c: 'oLatC'
    },
    NEW_POLE: {
        o_lat_p: 'oLatP',
        o_lon_p: 'oLongP'
    },
    NEW_EQUATOR: {
        o_lon_1: 'oLong1',
        o_lat_1: 'oLat1',
        o_lon_2: 'oLong2',
        o_lat_2: 'oLat2'
    }
};
function $907f7ddcd3064c1e$export$2cd8252107eb640b() {
    this.x0 = this.x0 || 0;
    this.y0 = this.y0 || 0;
    this.long0 = this.long0 || 0;
    this.title = this.title || 'General Oblique Transformation';
    this.isIdentity = (0, $74aa7cc11bd07059$export$e4b2ac9215619f8d).includes(this.o_proj);
    /** Verify required parameters exist */ if (!this.o_proj) throw new Error('Missing parameter: o_proj');
    if (this.o_proj === `ob_tran`) throw new Error('Invalid value for o_proj: ' + this.o_proj);
    const newProjStr = this.projStr.replace('+proj=ob_tran', '').replace('+o_proj=', '+proj=').trim();
    /** @type {import('../defs.js').ProjectionDefinition} */ const oProj = (0, $c04766b9ae61c421$export$2e2bcd8739ae039)(newProjStr);
    if (!oProj) throw new Error('Invalid parameter: o_proj. Unknown projection ' + this.o_proj);
    oProj.long0 = 0; // we handle long0 before/after forward/inverse
    this.obliqueProjection = oProj;
    let matchedSet;
    const paramSetsKeys = Object.keys($907f7ddcd3064c1e$var$paramSets);
    /**
   * parse strings, convert to radians, throw on NaN
   * @param {string} name
   * @returns {number | undefined}
   */ const parseParam = (name)=>{
        if (typeof this[name] === `undefined`) return undefined;
        const val = parseFloat(this[name]) * (0, $jDCGO.D2R);
        if (isNaN(val)) throw new Error('Invalid value for ' + name + ': ' + this[name]);
        return val;
    };
    for(let i = 0; i < paramSetsKeys.length; i++){
        const setKey = paramSetsKeys[i];
        const set = $907f7ddcd3064c1e$var$paramSets[setKey];
        const params = Object.entries(set);
        const setHasParams = params.some(([p])=>typeof this[p] !== 'undefined');
        if (!setHasParams) continue;
        matchedSet = set;
        for(let ii = 0; ii < params.length; ii++){
            const [inputParam, param] = params[ii];
            const val = parseParam(inputParam);
            if (typeof val === 'undefined') throw new Error('Missing parameter: ' + inputParam + '.');
            this[param] = val;
        }
        break;
    }
    if (!matchedSet) throw new Error('No valid parameters provided for ob_tran projection.');
    const { lamp: lamp, phip: phip } = $907f7ddcd3064c1e$var$createRotation(this, matchedSet);
    this.lamp = lamp;
    if (Math.abs(phip) > (0, $jDCGO.EPSLN)) {
        this.cphip = Math.cos(phip);
        this.sphip = Math.sin(phip);
        this.projectionType = $907f7ddcd3064c1e$var$projectionType.OBLIQUE;
    } else this.projectionType = $907f7ddcd3064c1e$var$projectionType.TRANSVERSE;
}
function $907f7ddcd3064c1e$export$174bb771924e7eb1(p) {
    return this.projectionType.forward(this, p);
}
function $907f7ddcd3064c1e$export$70ae2c07e401031b(p) {
    return this.projectionType.inverse(this, p);
}
/**
 * @param {import('../defs.js').ProjectionDefinition & LocalThis} params - Initialized projection definition
 * @param {Object} how - Transformation method
 * @returns {{phip: number, lamp: number}}
 */ function $907f7ddcd3064c1e$var$createRotation(params, how) {
    let phip, lamp;
    if (how === $907f7ddcd3064c1e$var$paramSets.ROTATE) {
        let lamc = params.oLongC;
        let phic = params.oLatC;
        let alpha = params.oAlpha;
        if (Math.abs(Math.abs(phic) - (0, $jDCGO.HALF_PI)) <= (0, $jDCGO.EPSLN)) throw new Error('Invalid value for o_lat_c: ' + params.o_lat_c + " should be < 90\xb0");
        lamp = lamc + Math.atan2(-1 * Math.cos(alpha), -1 * Math.sin(alpha) * Math.sin(phic));
        phip = Math.asin(Math.cos(phic) * Math.sin(alpha));
    } else if (how === $907f7ddcd3064c1e$var$paramSets.NEW_POLE) {
        lamp = params.oLongP;
        phip = params.oLatP;
    } else {
        let lam1 = params.oLong1;
        let phi1 = params.oLat1;
        let lam2 = params.oLong2;
        let phi2 = params.oLat2;
        let con = Math.abs(phi1);
        if (Math.abs(phi1) > (0, $jDCGO.HALF_PI) - (0, $jDCGO.EPSLN)) throw new Error('Invalid value for o_lat_1: ' + params.o_lat_1 + " should be < 90\xb0");
        if (Math.abs(phi2) > (0, $jDCGO.HALF_PI) - (0, $jDCGO.EPSLN)) throw new Error('Invalid value for o_lat_2: ' + params.o_lat_2 + " should be < 90\xb0");
        if (Math.abs(phi1 - phi2) < (0, $jDCGO.EPSLN)) throw new Error('Invalid value for o_lat_1 and o_lat_2: o_lat_1 should be different from o_lat_2');
        if (con < (0, $jDCGO.EPSLN)) throw new Error('Invalid value for o_lat_1: o_lat_1 should be different from zero');
        lamp = Math.atan2(Math.cos(phi1) * Math.sin(phi2) * Math.cos(lam1) - Math.sin(phi1) * Math.cos(phi2) * Math.cos(lam2), Math.sin(phi1) * Math.cos(phi2) * Math.sin(lam2) - Math.cos(phi1) * Math.sin(phi2) * Math.sin(lam1));
        phip = Math.atan(-1 * Math.cos(lamp - lam1) / Math.tan(phi1));
    }
    return {
        lamp: lamp,
        phip: phip
    };
}
/**
 * Forward (lng, lat) to (x, y) for oblique case
 * @param {import('../defs.js').ProjectionDefinition & LocalThis} self
 * @param {{x: number, y: number}} lp - lambda, phi
 */ function $907f7ddcd3064c1e$var$forwardOblique(self, lp) {
    let { x: lam, y: phi } = lp;
    lam += self.long0;
    const coslam = Math.cos(lam);
    const sinphi = Math.sin(phi);
    const cosphi = Math.cos(phi);
    lp.x = (0, $eRFTg.default)(Math.atan2(cosphi * Math.sin(lam), self.sphip * cosphi * coslam + self.cphip * sinphi) + self.lamp);
    lp.y = Math.asin(self.sphip * sinphi - self.cphip * cosphi * coslam);
    const result = self.obliqueProjection.forward(lp);
    if (self.isIdentity) {
        result.x *= (0, $jDCGO.R2D);
        result.y *= (0, $jDCGO.R2D);
    }
    return result;
}
/**
 * Forward (lng, lat) to (x, y) for transverse case
 * @param {import('../defs.js').ProjectionDefinition & LocalThis} self
 * @param {{x: number, y: number}} lp - lambda, phi
 */ function $907f7ddcd3064c1e$var$forwardTransverse(self, lp) {
    let { x: lam, y: phi } = lp;
    lam += self.long0;
    const cosphi = Math.cos(phi);
    const coslam = Math.cos(lam);
    lp.x = (0, $eRFTg.default)(Math.atan2(cosphi * Math.sin(lam), Math.sin(phi)) + self.lamp);
    lp.y = Math.asin(-1 * cosphi * coslam);
    const result = self.obliqueProjection.forward(lp);
    if (self.isIdentity) {
        result.x *= (0, $jDCGO.R2D);
        result.y *= (0, $jDCGO.R2D);
    }
    return result;
}
/**
 * Inverse (x, y) to (lng, lat) for oblique case
 * @param {import('../defs.js').ProjectionDefinition & LocalThis} self
 * @param {{x: number, y: number}} lp - lambda, phi
 */ function $907f7ddcd3064c1e$var$inverseOblique(self, lp) {
    if (self.isIdentity) {
        lp.x *= (0, $jDCGO.D2R);
        lp.y *= (0, $jDCGO.D2R);
    }
    const innerLp = self.obliqueProjection.inverse(lp);
    let { x: lam, y: phi } = innerLp;
    if (lam < Number.MAX_VALUE) {
        lam -= self.lamp;
        const coslam = Math.cos(lam);
        const sinphi = Math.sin(phi);
        const cosphi = Math.cos(phi);
        lp.x = Math.atan2(cosphi * Math.sin(lam), self.sphip * cosphi * coslam - self.cphip * sinphi);
        lp.y = Math.asin(self.sphip * sinphi + self.cphip * cosphi * coslam);
    }
    lp.x = (0, $eRFTg.default)(lp.x + self.long0);
    return lp;
}
/**
 * Inverse (x, y) to (lng, lat) for transverse case
 * @param {import('../defs.js').ProjectionDefinition & LocalThis} self
 * @param {{x: number, y: number}} lp - lambda, phi
 */ function $907f7ddcd3064c1e$var$inverseTransverse(self, lp) {
    if (self.isIdentity) {
        lp.x *= (0, $jDCGO.D2R);
        lp.y *= (0, $jDCGO.D2R);
    }
    const innerLp = self.obliqueProjection.inverse(lp);
    let { x: lam, y: phi } = innerLp;
    if (lam < Number.MAX_VALUE) {
        const cosphi = Math.cos(phi);
        lam -= self.lamp;
        lp.x = Math.atan2(cosphi * Math.sin(lam), -1 * Math.sin(phi));
        lp.y = Math.asin(cosphi * Math.cos(lam));
    }
    lp.x = (0, $eRFTg.default)(lp.x + self.long0);
    return lp;
}
var $907f7ddcd3064c1e$export$e4b2ac9215619f8d = [
    'General Oblique Transformation',
    'General_Oblique_Transformation',
    'ob_tran'
];
var $907f7ddcd3064c1e$export$2e2bcd8739ae039 = {
    init: $907f7ddcd3064c1e$export$2cd8252107eb640b,
    forward: $907f7ddcd3064c1e$export$174bb771924e7eb1,
    inverse: $907f7ddcd3064c1e$export$70ae2c07e401031b,
    names: $907f7ddcd3064c1e$export$e4b2ac9215619f8d
};


function $fc8203b79dc2cf19$export$2e2bcd8739ae039(proj4) {
    proj4.Proj.projections.add((0, $2frHl.default));
    proj4.Proj.projections.add((0, $cgjtm.default));
    proj4.Proj.projections.add((0, $eb76c2980de5c027$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $8cb6f78e1febc8ee$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $e758b706eb2443fd$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $cfa069f4b27cf0f3$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $2aeff16c09dccd5b$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $b19a30a478e73c5c$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $5ff60b22b254aa04$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $1bb7279d02bd698d$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $l2RN6.default));
    proj4.Proj.projections.add((0, $bdfcS.default));
    proj4.Proj.projections.add((0, $ddedabd240224093$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $d38acef4b970957d$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $19a129fcc5ffd145$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $1ed23b92e493659a$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $d4Re2.default));
    proj4.Proj.projections.add((0, $6e4232175bd83b7d$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $8400908b20c129dc$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $b79975ea600eab93$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $6653bb0d8e21c387$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $4941dca385bdf94a$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $a5d5ae26b73a0961$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $589e5dd8b01c50cf$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $4e0eaeb8e12a4938$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $6c3d95197fc16965$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $a6f46c0772597d95$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $733bd8a5a2473ba7$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $7bef3ff1ed839340$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $39399e295a214ad8$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $c4234e109a782db2$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $907f7ddcd3064c1e$export$2e2bcd8739ae039));
}


/**
 * @typedef {Object} Mgrs
 * @property {(lonlat: [number, number]) => string} forward
 * @property {(mgrsString: string) => [number, number, number, number]} inverse
 * @property {(mgrsString: string) => [number, number]} toPoint
 */ /**
 * @typedef {import('./defs').ProjectionDefinition} ProjectionDefinition
 * @typedef {import('./core').TemplateCoordinates} TemplateCoordinates
 * @typedef {import('./core').InterfaceCoordinates} InterfaceCoordinates
 * @typedef {import('./core').Converter} Converter
 * @typedef {import('./Proj').DatumDefinition} DatumDefinition
 */ /**
 * @template {import('./core').TemplateCoordinates} T
 * @type {core<T> & {defaultDatum: string, Proj: typeof Proj, WGS84: Proj, Point: typeof Point, toPoint: typeof common, defs: typeof defs, nadgrid: typeof nadgrid, transform: typeof transform, mgrs: Mgrs, version: string}}
 */ const $ca159ace55b1c3df$var$proj4 = Object.assign((0, $5671f5b5c060719c$export$2e2bcd8739ae039), {
    defaultDatum: 'WGS84',
    Proj: $c04766b9ae61c421$export$2e2bcd8739ae039,
    WGS84: new (0, $c04766b9ae61c421$export$2e2bcd8739ae039)('WGS84'),
    Point: $455525ad3f9d7fbc$export$2e2bcd8739ae039,
    toPoint: (0, $1104ed58f12ed77f$export$2e2bcd8739ae039),
    defs: $b50b13974d7f3f7f$export$2e2bcd8739ae039,
    nadgrid: $9262fced509c4a24$export$2e2bcd8739ae039,
    transform: $78dbab15a0f3f2e9$export$2e2bcd8739ae039,
    mgrs: $3371772b61ed5838$export$2e2bcd8739ae039,
    version: '__VERSION__'
});
(0, $fc8203b79dc2cf19$export$2e2bcd8739ae039)($ca159ace55b1c3df$var$proj4);
var $ca159ace55b1c3df$export$2e2bcd8739ae039 = $ca159ace55b1c3df$var$proj4;



var $kc00y = parcelRequire("kc00y");
var $1cb5f76251c4ecca$exports = {};
"use strict";
Object.defineProperty($1cb5f76251c4ecca$exports, "__esModule", {
    value: true
});
$1cb5f76251c4ecca$exports.parseCookie = $1cb5f76251c4ecca$var$parseCookie;
$1cb5f76251c4ecca$exports.parse = $1cb5f76251c4ecca$var$parseCookie;
$1cb5f76251c4ecca$exports.stringifyCookie = $1cb5f76251c4ecca$var$stringifyCookie;
$1cb5f76251c4ecca$exports.stringifySetCookie = $1cb5f76251c4ecca$var$stringifySetCookie;
$1cb5f76251c4ecca$exports.serialize = $1cb5f76251c4ecca$var$stringifySetCookie;
$1cb5f76251c4ecca$exports.parseSetCookie = $1cb5f76251c4ecca$var$parseSetCookie;
$1cb5f76251c4ecca$exports.stringifySetCookie = $1cb5f76251c4ecca$var$stringifySetCookie;
$1cb5f76251c4ecca$exports.serialize = $1cb5f76251c4ecca$var$stringifySetCookie;
/**
 * RegExp to match cookie-name in RFC 6265 sec 4.1.1
 * This refers out to the obsoleted definition of token in RFC 2616 sec 2.2
 * which has been replaced by the token definition in RFC 7230 appendix B.
 *
 * cookie-name       = token
 * token             = 1*tchar
 * tchar             = "!" / "#" / "$" / "%" / "&" / "'" /
 *                     "*" / "+" / "-" / "." / "^" / "_" /
 *                     "`" / "|" / "~" / DIGIT / ALPHA
 *
 * Note: Allowing more characters - https://github.com/jshttp/cookie/issues/191
 * Allow same range as cookie value, except `=`, which delimits end of name.
 */ const $1cb5f76251c4ecca$var$cookieNameRegExp = /^[\u0021-\u003A\u003C\u003E-\u007E]+$/;
/**
 * RegExp to match cookie-value in RFC 6265 sec 4.1.1
 *
 * cookie-value      = *cookie-octet / ( DQUOTE *cookie-octet DQUOTE )
 * cookie-octet      = %x21 / %x23-2B / %x2D-3A / %x3C-5B / %x5D-7E
 *                     ; US-ASCII characters excluding CTLs,
 *                     ; whitespace DQUOTE, comma, semicolon,
 *                     ; and backslash
 *
 * Allowing more characters: https://github.com/jshttp/cookie/issues/191
 * Comma, backslash, and DQUOTE are not part of the parsing algorithm.
 */ const $1cb5f76251c4ecca$var$cookieValueRegExp = /^[\u0021-\u003A\u003C-\u007E]*$/;
/**
 * RegExp to match domain-value in RFC 6265 sec 4.1.1
 *
 * domain-value      = <subdomain>
 *                     ; defined in [RFC1034], Section 3.5, as
 *                     ; enhanced by [RFC1123], Section 2.1
 * <subdomain>       = <label> | <subdomain> "." <label>
 * <label>           = <let-dig> [ [ <ldh-str> ] <let-dig> ]
 *                     Labels must be 63 characters or less.
 *                     'let-dig' not 'letter' in the first char, per RFC1123
 * <ldh-str>         = <let-dig-hyp> | <let-dig-hyp> <ldh-str>
 * <let-dig-hyp>     = <let-dig> | "-"
 * <let-dig>         = <letter> | <digit>
 * <letter>          = any one of the 52 alphabetic characters A through Z in
 *                     upper case and a through z in lower case
 * <digit>           = any one of the ten digits 0 through 9
 *
 * Keep support for leading dot: https://github.com/jshttp/cookie/issues/173
 *
 * > (Note that a leading %x2E ("."), if present, is ignored even though that
 * character is not permitted, but a trailing %x2E ("."), if present, will
 * cause the user agent to ignore the attribute.)
 */ const $1cb5f76251c4ecca$var$domainValueRegExp = /^([.]?[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)([.][a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)*$/i;
/**
 * RegExp to match path-value in RFC 6265 sec 4.1.1
 *
 * path-value        = <any CHAR except CTLs or ";">
 * CHAR              = %x01-7F
 *                     ; defined in RFC 5234 appendix B.1
 */ const $1cb5f76251c4ecca$var$pathValueRegExp = /^[\u0020-\u003A\u003D-\u007E]*$/;
/**
 * RegExp to match max-age-value in RFC 6265 sec 5.6.2
 */ const $1cb5f76251c4ecca$var$maxAgeRegExp = /^-?\d+$/;
const $1cb5f76251c4ecca$var$__toString = Object.prototype.toString;
const $1cb5f76251c4ecca$var$NullObject = /* @__PURE__ */ (()=>{
    const C = function() {};
    C.prototype = Object.create(null);
    return C;
})();
/**
 * Parse a `Cookie` header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 */ function $1cb5f76251c4ecca$var$parseCookie(str, options) {
    const obj = new $1cb5f76251c4ecca$var$NullObject();
    const len = str.length;
    // RFC 6265 sec 4.1.1, RFC 2616 2.2 defines a cookie name consists of one char minimum, plus '='.
    if (len < 2) return obj;
    const dec = options?.decode || $1cb5f76251c4ecca$var$decode;
    let index = 0;
    do {
        const eqIdx = $1cb5f76251c4ecca$var$eqIndex(str, index, len);
        if (eqIdx === -1) break; // No more cookie pairs.
        const endIdx = $1cb5f76251c4ecca$var$endIndex(str, index, len);
        if (eqIdx > endIdx) {
            // backtrack on prior semicolon
            index = str.lastIndexOf(";", eqIdx - 1) + 1;
            continue;
        }
        const key = $1cb5f76251c4ecca$var$valueSlice(str, index, eqIdx);
        // only assign once
        if (obj[key] === undefined) obj[key] = dec($1cb5f76251c4ecca$var$valueSlice(str, eqIdx + 1, endIdx));
        index = endIdx + 1;
    }while (index < len);
    return obj;
}
/**
 * Stringifies an object into an HTTP `Cookie` header.
 */ function $1cb5f76251c4ecca$var$stringifyCookie(cookie, options) {
    const enc = options?.encode || encodeURIComponent;
    const cookieStrings = [];
    for (const name of Object.keys(cookie)){
        const val = cookie[name];
        if (val === undefined) continue;
        if (!$1cb5f76251c4ecca$var$cookieNameRegExp.test(name)) throw new TypeError(`cookie name is invalid: ${name}`);
        const value = enc(val);
        if (!$1cb5f76251c4ecca$var$cookieValueRegExp.test(value)) throw new TypeError(`cookie val is invalid: ${val}`);
        cookieStrings.push(`${name}=${value}`);
    }
    return cookieStrings.join("; ");
}
function $1cb5f76251c4ecca$var$stringifySetCookie(_name, _val, _opts) {
    const cookie = typeof _name === "object" ? _name : {
        ..._opts,
        name: _name,
        value: String(_val)
    };
    const options = typeof _val === "object" ? _val : _opts;
    const enc = options?.encode || encodeURIComponent;
    if (!$1cb5f76251c4ecca$var$cookieNameRegExp.test(cookie.name)) throw new TypeError(`argument name is invalid: ${cookie.name}`);
    const value = cookie.value ? enc(cookie.value) : "";
    if (!$1cb5f76251c4ecca$var$cookieValueRegExp.test(value)) throw new TypeError(`argument val is invalid: ${cookie.value}`);
    let str = cookie.name + "=" + value;
    if (cookie.maxAge !== undefined) {
        if (!Number.isInteger(cookie.maxAge)) throw new TypeError(`option maxAge is invalid: ${cookie.maxAge}`);
        str += "; Max-Age=" + cookie.maxAge;
    }
    if (cookie.domain) {
        if (!$1cb5f76251c4ecca$var$domainValueRegExp.test(cookie.domain)) throw new TypeError(`option domain is invalid: ${cookie.domain}`);
        str += "; Domain=" + cookie.domain;
    }
    if (cookie.path) {
        if (!$1cb5f76251c4ecca$var$pathValueRegExp.test(cookie.path)) throw new TypeError(`option path is invalid: ${cookie.path}`);
        str += "; Path=" + cookie.path;
    }
    if (cookie.expires) {
        if (!$1cb5f76251c4ecca$var$isDate(cookie.expires) || !Number.isFinite(cookie.expires.valueOf())) throw new TypeError(`option expires is invalid: ${cookie.expires}`);
        str += "; Expires=" + cookie.expires.toUTCString();
    }
    if (cookie.httpOnly) str += "; HttpOnly";
    if (cookie.secure) str += "; Secure";
    if (cookie.partitioned) str += "; Partitioned";
    if (cookie.priority) {
        const priority = typeof cookie.priority === "string" ? cookie.priority.toLowerCase() : undefined;
        switch(priority){
            case "low":
                str += "; Priority=Low";
                break;
            case "medium":
                str += "; Priority=Medium";
                break;
            case "high":
                str += "; Priority=High";
                break;
            default:
                throw new TypeError(`option priority is invalid: ${cookie.priority}`);
        }
    }
    if (cookie.sameSite) {
        const sameSite = typeof cookie.sameSite === "string" ? cookie.sameSite.toLowerCase() : cookie.sameSite;
        switch(sameSite){
            case true:
            case "strict":
                str += "; SameSite=Strict";
                break;
            case "lax":
                str += "; SameSite=Lax";
                break;
            case "none":
                str += "; SameSite=None";
                break;
            default:
                throw new TypeError(`option sameSite is invalid: ${cookie.sameSite}`);
        }
    }
    return str;
}
/**
 * Deserialize a `Set-Cookie` header into an object.
 *
 * deserialize('foo=bar; httpOnly')
 *   => { name: 'foo', value: 'bar', httpOnly: true }
 */ function $1cb5f76251c4ecca$var$parseSetCookie(str, options) {
    const dec = options?.decode || $1cb5f76251c4ecca$var$decode;
    const len = str.length;
    const endIdx = $1cb5f76251c4ecca$var$endIndex(str, 0, len);
    const eqIdx = $1cb5f76251c4ecca$var$eqIndex(str, 0, endIdx);
    const setCookie = eqIdx === -1 ? {
        name: "",
        value: dec($1cb5f76251c4ecca$var$valueSlice(str, 0, endIdx))
    } : {
        name: $1cb5f76251c4ecca$var$valueSlice(str, 0, eqIdx),
        value: dec($1cb5f76251c4ecca$var$valueSlice(str, eqIdx + 1, endIdx))
    };
    let index = endIdx + 1;
    while(index < len){
        const endIdx = $1cb5f76251c4ecca$var$endIndex(str, index, len);
        const eqIdx = $1cb5f76251c4ecca$var$eqIndex(str, index, endIdx);
        const attr = eqIdx === -1 ? $1cb5f76251c4ecca$var$valueSlice(str, index, endIdx) : $1cb5f76251c4ecca$var$valueSlice(str, index, eqIdx);
        const val = eqIdx === -1 ? undefined : $1cb5f76251c4ecca$var$valueSlice(str, eqIdx + 1, endIdx);
        switch(attr.toLowerCase()){
            case "httponly":
                setCookie.httpOnly = true;
                break;
            case "secure":
                setCookie.secure = true;
                break;
            case "partitioned":
                setCookie.partitioned = true;
                break;
            case "domain":
                setCookie.domain = val;
                break;
            case "path":
                setCookie.path = val;
                break;
            case "max-age":
                if (val && $1cb5f76251c4ecca$var$maxAgeRegExp.test(val)) setCookie.maxAge = Number(val);
                break;
            case "expires":
                if (!val) break;
                const date = new Date(val);
                if (Number.isFinite(date.valueOf())) setCookie.expires = date;
                break;
            case "priority":
                if (!val) break;
                const priority = val.toLowerCase();
                if (priority === "low" || priority === "medium" || priority === "high") setCookie.priority = priority;
                break;
            case "samesite":
                if (!val) break;
                const sameSite = val.toLowerCase();
                if (sameSite === "lax" || sameSite === "strict" || sameSite === "none") setCookie.sameSite = sameSite;
                break;
        }
        index = endIdx + 1;
    }
    return setCookie;
}
/**
 * Find the `;` character between `min` and `len` in str.
 */ function $1cb5f76251c4ecca$var$endIndex(str, min, len) {
    const index = str.indexOf(";", min);
    return index === -1 ? len : index;
}
/**
 * Find the `=` character between `min` and `max` in str.
 */ function $1cb5f76251c4ecca$var$eqIndex(str, min, max) {
    const index = str.indexOf("=", min);
    return index < max ? index : -1;
}
/**
 * Slice out a value between startPod to max.
 */ function $1cb5f76251c4ecca$var$valueSlice(str, min, max) {
    let start = min;
    let end = max;
    do {
        const code = str.charCodeAt(start);
        if (code !== 0x20 /*   */  && code !== 0x09 /* \t */ ) break;
    }while (++start < end);
    while(end > start){
        const code = str.charCodeAt(end - 1);
        if (code !== 0x20 /*   */  && code !== 0x09 /* \t */ ) break;
        end--;
    }
    return str.slice(start, end);
}
/**
 * URL-decode string value. Optimized to skip native call when no %.
 */ function $1cb5f76251c4ecca$var$decode(str) {
    if (str.indexOf("%") === -1) return str;
    try {
        return decodeURIComponent(str);
    } catch (e) {
        return str;
    }
}
/**
 * Determine if value is a Date.
 */ function $1cb5f76251c4ecca$var$isDate(val) {
    return $1cb5f76251c4ecca$var$__toString.call(val) === "[object Date]";
}


// Keep in sync with csrf.kt
const $fbd4d34e07af0ac7$var$csrfTokenHeaderName = "X-XTok";
const $fbd4d34e07af0ac7$var$csrfCookieName = location.protocol === "https:" ? "__Host-xt" : "xt";
function $fbd4d34e07af0ac7$var$getCsrfTokenFromCookie(cookie) {
    return (0, $1cb5f76251c4ecca$exports.parse)(cookie)[$fbd4d34e07af0ac7$var$csrfCookieName];
}
let $fbd4d34e07af0ac7$var$oldCookie = document.cookie;
let $fbd4d34e07af0ac7$var$csrfToken = $fbd4d34e07af0ac7$var$getCsrfTokenFromCookie($fbd4d34e07af0ac7$var$oldCookie);
function $fbd4d34e07af0ac7$var$getCsrfToken() {
    const cookie = document.cookie;
    if (cookie !== $fbd4d34e07af0ac7$var$oldCookie) {
        $fbd4d34e07af0ac7$var$csrfToken = $fbd4d34e07af0ac7$var$getCsrfTokenFromCookie(cookie);
        $fbd4d34e07af0ac7$var$oldCookie = cookie;
    }
    return $fbd4d34e07af0ac7$var$csrfToken;
}
function $fbd4d34e07af0ac7$var$filterParams(obj) {
    return Object.entries(obj).filter((e)=>e[1] != null).map((v)=>typeof v[1] === "object" ? [
            v[0],
            JSON.stringify(v[1])
        ] : v);
}
function $fbd4d34e07af0ac7$export$2e2bcd8739ae039(strings, ...values) {
    return strings.slice(1).reduce((res, string, i)=>{
        const value = values[i];
        if (typeof value === "object") res += decodeURIComponent((value instanceof URLSearchParams ? value : new URLSearchParams($fbd4d34e07af0ac7$var$filterParams(value))).toString());
        else res += encodeURI(value);
        res = res.concat(string);
        return res;
    }, strings[0]);
}
function $fbd4d34e07af0ac7$export$b163ec2f884327db(options = {}) {
    return {
        ...options,
        credentials: "same-origin",
        headers: {
            Accept: "*/*",
            ...options.headers,
            [$fbd4d34e07af0ac7$var$csrfTokenHeaderName]: $fbd4d34e07af0ac7$var$getCsrfToken()
        }
    };
}



var $f7a9c14f75da0acc$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if ($f7a9c14f75da0acc$exports) {
        classNames.default = classNames;
        $f7a9c14f75da0acc$exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();




var $kc00y = parcelRequire("kc00y");

var $kc00y = parcelRequire("kc00y");

"use client";
const $6c3886f519efe212$export$666ad80b5007f835 = [
    'xxl',
    'xl',
    'lg',
    'md',
    'sm',
    'xs'
];
const $6c3886f519efe212$export$ff817e17bad2e091 = 'xs';
const $6c3886f519efe212$var$ThemeContext = /*#__PURE__*/ $kc00y.createContext({
    prefixes: {},
    breakpoints: $6c3886f519efe212$export$666ad80b5007f835,
    minBreakpoint: $6c3886f519efe212$export$ff817e17bad2e091
});
const { Consumer: $6c3886f519efe212$export$b631efc24e9d5e2f, Provider: $6c3886f519efe212$var$Provider } = $6c3886f519efe212$var$ThemeContext;
function $6c3886f519efe212$var$ThemeProvider({ prefixes: prefixes = {}, breakpoints: breakpoints = $6c3886f519efe212$export$666ad80b5007f835, minBreakpoint: minBreakpoint = $6c3886f519efe212$export$ff817e17bad2e091, dir: dir, children: children }) {
    const contextValue = (0, $kc00y.useMemo)(()=>({
            prefixes: {
                ...prefixes
            },
            breakpoints: breakpoints,
            minBreakpoint: minBreakpoint,
            dir: dir
        }), [
        prefixes,
        breakpoints,
        minBreakpoint,
        dir
    ]);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($6c3886f519efe212$var$Provider, {
        value: contextValue,
        children: children
    });
}
function $6c3886f519efe212$export$7f387860ebffb32c(prefix, defaultPrefix) {
    const { prefixes: prefixes } = (0, $kc00y.useContext)($6c3886f519efe212$var$ThemeContext);
    return prefix || prefixes[defaultPrefix] || defaultPrefix;
}
function $6c3886f519efe212$export$8970c8db816a5863() {
    const { breakpoints: breakpoints } = (0, $kc00y.useContext)($6c3886f519efe212$var$ThemeContext);
    return breakpoints;
}
function $6c3886f519efe212$export$d926d6ef38f3fd32() {
    const { minBreakpoint: minBreakpoint } = (0, $kc00y.useContext)($6c3886f519efe212$var$ThemeContext);
    return minBreakpoint;
}
function $6c3886f519efe212$export$35e511eefa30ac5a() {
    const { dir: dir } = (0, $kc00y.useContext)($6c3886f519efe212$var$ThemeContext);
    return dir === 'rtl';
}
function $6c3886f519efe212$export$ce75053c20498f85(Component, opts) {
    if (typeof opts === 'string') opts = {
        prefix: opts
    };
    const isClassy = Component.prototype && Component.prototype.isReactComponent;
    // If it's a functional component make sure we don't break it with a ref
    const { prefix: prefix, forwardRefAs: forwardRefAs = isClassy ? 'ref' : 'innerRef' } = opts;
    const Wrapped = /*#__PURE__*/ $kc00y.forwardRef(({ ...props }, ref)=>{
        props[forwardRefAs] = ref;
        const bsPrefix = $6c3886f519efe212$export$7f387860ebffb32c(props.bsPrefix, prefix);
        return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)(Component, {
            ...props,
            bsPrefix: bsPrefix
        });
    });
    Wrapped.displayName = `Bootstrap(${Component.displayName || Component.name})`;
    return Wrapped;
}
var $6c3886f519efe212$export$2e2bcd8739ae039 = $6c3886f519efe212$var$ThemeProvider;



"use client";
const $3e3841c053791fa3$var$Spinner = /*#__PURE__*/ $kc00y.forwardRef(({ bsPrefix: bsPrefix, variant: variant, animation: animation = 'border', size: size, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', className: className, ...props }, ref)=>{
    bsPrefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(bsPrefix, 'spinner');
    const bsSpinnerPrefix = `${bsPrefix}-${animation}`;
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, bsSpinnerPrefix, size && `${bsSpinnerPrefix}-${size}`, variant && `text-${variant}`)
    });
});
$3e3841c053791fa3$var$Spinner.displayName = 'Spinner';
var $3e3841c053791fa3$export$2e2bcd8739ae039 = $3e3841c053791fa3$var$Spinner;


var $6433b9e637966cc6$exports = {};

$parcel$export($6433b9e637966cc6$exports, "loading", () => $6433b9e637966cc6$export$46c1c92549715335, (v) => $6433b9e637966cc6$export$46c1c92549715335 = v);
var $6433b9e637966cc6$export$46c1c92549715335;
$6433b9e637966cc6$export$46c1c92549715335 = `lzbsza_loading`;


const $c21b1c237cfa1d94$var$Loading = ({ className: className, ...rest })=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($6433b9e637966cc6$exports))).loading, className),
        ...rest,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $3e3841c053791fa3$export$2e2bcd8739ae039), {
            animation: "border"
        })
    });
var $c21b1c237cfa1d94$export$2e2bcd8739ae039 = $c21b1c237cfa1d94$var$Loading;



var $kc00y = parcelRequire("kc00y");

var $kc00y = parcelRequire("kc00y");
/* istanbul ignore file */ /**
 * Universal global scope object. In the browser this is `self`, in Node.js and React Native it's `global`.
 * This file is excluded from coverage reporting because these globals are environment-specific so we can't test them all.
 */ const $77fae5be6c2b1145$export$af1bbc55aad4f91e = (()=>{
    if (typeof self === "object" && self.self === self) return self;
    if (typeof $parcel$global === "object" && $parcel$global.global === $parcel$global) return $parcel$global;
    if (typeof $parcel$global === "object" && $parcel$global.GLOBAL === $parcel$global) return $parcel$global;
    return {}; // fallback that relies on imported modules to be singletons
})();
/**
 * Globally available object used to connect the DevTools to all React Async instances.
 */ $77fae5be6c2b1145$export$af1bbc55aad4f91e.__REACT_ASYNC__ = $77fae5be6c2b1145$export$af1bbc55aad4f91e.__REACT_ASYNC__ || {};
const $77fae5be6c2b1145$var$noop = ()=>{};
class $77fae5be6c2b1145$var$MockAbortController {
    constructor(){
        this.abort = $77fae5be6c2b1145$var$noop;
        this.signal = {};
    }
}
let $77fae5be6c2b1145$var$PropTypes;

try {
    $77fae5be6c2b1145$var$PropTypes = (parcelRequire("lCkAA"));
} catch (e) {}
const $77fae5be6c2b1145$var$childrenFn = $77fae5be6c2b1145$var$PropTypes && $77fae5be6c2b1145$var$PropTypes.oneOfType([
    $77fae5be6c2b1145$var$PropTypes.node,
    $77fae5be6c2b1145$var$PropTypes.func
]);
const $77fae5be6c2b1145$var$stateObject = $77fae5be6c2b1145$var$PropTypes && $77fae5be6c2b1145$var$PropTypes.shape({
    initialValue: $77fae5be6c2b1145$var$PropTypes.any,
    data: $77fae5be6c2b1145$var$PropTypes.any,
    error: $77fae5be6c2b1145$var$PropTypes.instanceOf(Error),
    value: $77fae5be6c2b1145$var$PropTypes.any,
    startedAt: $77fae5be6c2b1145$var$PropTypes.instanceOf(Date),
    finishedAt: $77fae5be6c2b1145$var$PropTypes.instanceOf(Date),
    status: $77fae5be6c2b1145$var$PropTypes.oneOf([
        "initial",
        "pending",
        "fulfilled",
        "rejected"
    ]),
    isInitial: $77fae5be6c2b1145$var$PropTypes.bool,
    isPending: $77fae5be6c2b1145$var$PropTypes.bool,
    isLoading: $77fae5be6c2b1145$var$PropTypes.bool,
    isFulfilled: $77fae5be6c2b1145$var$PropTypes.bool,
    isResolved: $77fae5be6c2b1145$var$PropTypes.bool,
    isRejected: $77fae5be6c2b1145$var$PropTypes.bool,
    isSettled: $77fae5be6c2b1145$var$PropTypes.bool,
    counter: $77fae5be6c2b1145$var$PropTypes.number,
    promise: $77fae5be6c2b1145$var$PropTypes.instanceOf(Promise),
    run: $77fae5be6c2b1145$var$PropTypes.func,
    reload: $77fae5be6c2b1145$var$PropTypes.func,
    cancel: $77fae5be6c2b1145$var$PropTypes.func,
    setData: $77fae5be6c2b1145$var$PropTypes.func,
    setError: $77fae5be6c2b1145$var$PropTypes.func
});
var $77fae5be6c2b1145$var$propTypes = $77fae5be6c2b1145$var$PropTypes && {
    Async: {
        children: $77fae5be6c2b1145$var$childrenFn,
        promise: $77fae5be6c2b1145$var$PropTypes.instanceOf(Promise),
        promiseFn: $77fae5be6c2b1145$var$PropTypes.func,
        deferFn: $77fae5be6c2b1145$var$PropTypes.func,
        watch: $77fae5be6c2b1145$var$PropTypes.any,
        watchFn: $77fae5be6c2b1145$var$PropTypes.func,
        initialValue: $77fae5be6c2b1145$var$PropTypes.any,
        onResolve: $77fae5be6c2b1145$var$PropTypes.func,
        onReject: $77fae5be6c2b1145$var$PropTypes.func,
        reducer: $77fae5be6c2b1145$var$PropTypes.func,
        dispatcher: $77fae5be6c2b1145$var$PropTypes.func,
        debugLabel: $77fae5be6c2b1145$var$PropTypes.string,
        suspense: $77fae5be6c2b1145$var$PropTypes.bool
    },
    Initial: {
        children: $77fae5be6c2b1145$var$childrenFn,
        state: $77fae5be6c2b1145$var$stateObject.isRequired,
        persist: $77fae5be6c2b1145$var$PropTypes.bool
    },
    Pending: {
        children: $77fae5be6c2b1145$var$childrenFn,
        state: $77fae5be6c2b1145$var$stateObject.isRequired,
        initial: $77fae5be6c2b1145$var$PropTypes.bool
    },
    Fulfilled: {
        children: $77fae5be6c2b1145$var$childrenFn,
        state: $77fae5be6c2b1145$var$stateObject.isRequired,
        persist: $77fae5be6c2b1145$var$PropTypes.bool
    },
    Rejected: {
        children: $77fae5be6c2b1145$var$childrenFn,
        state: $77fae5be6c2b1145$var$stateObject.isRequired,
        persist: $77fae5be6c2b1145$var$PropTypes.bool
    },
    Settled: {
        children: $77fae5be6c2b1145$var$childrenFn,
        state: $77fae5be6c2b1145$var$stateObject.isRequired,
        persist: $77fae5be6c2b1145$var$PropTypes.bool
    }
};
const $77fae5be6c2b1145$var$renderFn = (children, ...args)=>{
    if (typeof children === "function") {
        const render = children;
        return render(...args);
    }
    return children;
};
/**
 * Renders only when no promise has started or completed yet.
 *
 * @prop {Function|Node} children Function (passing state) or React node
 * @prop {Object} state React Async state object
 * @prop {boolean} persist Show until we have data, even while pending (loading) or when an error occurred
 */ const $77fae5be6c2b1145$export$ef55f14ef766f494 = ({ children: children, persist: persist, state: state = {} })=>(0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).Fragment, null, state.isInitial || persist && !state.data ? $77fae5be6c2b1145$var$renderFn(children, state) : null);
/**
 * Renders only while pending (promise is loading).
 *
 * @prop {Function|Node} children Function (passing state) or React node
 * @prop {Object} state React Async state object
 * @prop {boolean} initial Show only on initial load (data is undefined)
 */ const $77fae5be6c2b1145$export$fcb4895414d32f4e = ({ children: children, initial: initial, state: state = {} })=>(0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).Fragment, null, state.isPending && (!initial || !state.value) ? $77fae5be6c2b1145$var$renderFn(children, state) : null);
/**
 * Renders only when promise is resolved.
 *
 * @prop {Function|Node} children Function (passing data and state) or React node
 * @prop {Object} state React Async state object
 * @prop {boolean} persist Show old data while pending (promise is loading)
 */ const $77fae5be6c2b1145$export$e51ea416e03c0b2 = ({ children: children, persist: persist, state: state = {} })=>(0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).Fragment, null, state.isFulfilled || persist && state.data ? $77fae5be6c2b1145$var$renderFn(children, state.data, state) : null);
/**
 * Renders only when promise is rejected.
 *
 * @prop {Function|Node} children Function (passing error and state) or React node
 * @prop {Object} state React Async state object
 * @prop {boolean} persist Show old error while pending (promise is loading)
 */ const $77fae5be6c2b1145$export$9c650b30aa842e16 = ({ children: children, persist: persist, state: state = {} })=>(0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).Fragment, null, state.isRejected || persist && state.error ? $77fae5be6c2b1145$var$renderFn(children, state.error, state) : null);
/**
 * Renders only when promise is fulfilled or rejected.
 *
 * @prop {Function|Node} children Function (passing state) or React node
 * @prop {Object} state React Async state object
 * @prop {boolean} persist Show old data or error while pending (promise is loading)
 */ const $77fae5be6c2b1145$export$6248b08a30065aab = ({ children: children, persist: persist, state: state = {} })=>(0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).Fragment, null, state.isSettled || persist && state.value ? $77fae5be6c2b1145$var$renderFn(children, state) : null);
if ($77fae5be6c2b1145$var$propTypes) {
    $77fae5be6c2b1145$export$ef55f14ef766f494.propTypes = $77fae5be6c2b1145$var$propTypes.Initial;
    $77fae5be6c2b1145$export$fcb4895414d32f4e.propTypes = $77fae5be6c2b1145$var$propTypes.Pending;
    $77fae5be6c2b1145$export$e51ea416e03c0b2.propTypes = $77fae5be6c2b1145$var$propTypes.Fulfilled;
    $77fae5be6c2b1145$export$9c650b30aa842e16.propTypes = $77fae5be6c2b1145$var$propTypes.Rejected;
    $77fae5be6c2b1145$export$6248b08a30065aab.propTypes = $77fae5be6c2b1145$var$propTypes.Settled;
}
var $77fae5be6c2b1145$export$71c2f43e23882c69;
(function(StatusTypes) {
    StatusTypes["initial"] = "initial";
    StatusTypes["pending"] = "pending";
    StatusTypes["fulfilled"] = "fulfilled";
    StatusTypes["rejected"] = "rejected";
})($77fae5be6c2b1145$export$71c2f43e23882c69 || ($77fae5be6c2b1145$export$71c2f43e23882c69 = {}));
const $77fae5be6c2b1145$var$getInitialStatus = (value, promise)=>{
    if (value instanceof Error) return $77fae5be6c2b1145$export$71c2f43e23882c69.rejected;
    if (value !== undefined) return $77fae5be6c2b1145$export$71c2f43e23882c69.fulfilled;
    if (promise) return $77fae5be6c2b1145$export$71c2f43e23882c69.pending;
    return $77fae5be6c2b1145$export$71c2f43e23882c69.initial;
};
const $77fae5be6c2b1145$var$getIdleStatus = (value)=>{
    if (value instanceof Error) return $77fae5be6c2b1145$export$71c2f43e23882c69.rejected;
    if (value !== undefined) return $77fae5be6c2b1145$export$71c2f43e23882c69.fulfilled;
    return $77fae5be6c2b1145$export$71c2f43e23882c69.initial;
};
const $77fae5be6c2b1145$var$getStatusProps = (status)=>({
        status: status,
        isInitial: status === $77fae5be6c2b1145$export$71c2f43e23882c69.initial,
        isPending: status === $77fae5be6c2b1145$export$71c2f43e23882c69.pending,
        isLoading: status === $77fae5be6c2b1145$export$71c2f43e23882c69.pending,
        isFulfilled: status === $77fae5be6c2b1145$export$71c2f43e23882c69.fulfilled,
        isResolved: status === $77fae5be6c2b1145$export$71c2f43e23882c69.fulfilled,
        isRejected: status === $77fae5be6c2b1145$export$71c2f43e23882c69.rejected,
        isSettled: status === $77fae5be6c2b1145$export$71c2f43e23882c69.fulfilled || status === $77fae5be6c2b1145$export$71c2f43e23882c69.rejected
    });
// This exists to make sure we don't hold any references to user-provided functions
// The way NeverSettle extends from Promise is complicated, but can't be done differently because Babel doesn't support
// extending built-in classes. See https://babeljs.io/docs/en/caveats/#classes
const $77fae5be6c2b1145$var$NeverSettle = function() {};
/* istanbul ignore next */ if (Object.setPrototypeOf) Object.setPrototypeOf($77fae5be6c2b1145$var$NeverSettle, Promise);
else $77fae5be6c2b1145$var$NeverSettle.__proto__ = Promise;
$77fae5be6c2b1145$var$NeverSettle.prototype = Object.assign(Object.create(Promise.prototype), {
    finally () {
        return this;
    },
    catch () {
        return this;
    },
    then () {
        return this;
    }
});
const $77fae5be6c2b1145$export$f8415f49327504d8 = new $77fae5be6c2b1145$var$NeverSettle();
var $77fae5be6c2b1145$export$1385d81a6c6bbcd4;
(function(ActionTypes) {
    ActionTypes["start"] = "start";
    ActionTypes["cancel"] = "cancel";
    ActionTypes["fulfill"] = "fulfill";
    ActionTypes["reject"] = "reject";
})($77fae5be6c2b1145$export$1385d81a6c6bbcd4 || ($77fae5be6c2b1145$export$1385d81a6c6bbcd4 = {}));
const $77fae5be6c2b1145$export$2cd8252107eb640b = ({ initialValue: initialValue, promise: promise, promiseFn: promiseFn })=>({
        initialValue: initialValue,
        data: initialValue instanceof Error ? undefined : initialValue,
        error: initialValue instanceof Error ? initialValue : undefined,
        value: initialValue,
        startedAt: promise || promiseFn ? new Date() : undefined,
        finishedAt: initialValue ? new Date() : undefined,
        ...$77fae5be6c2b1145$var$getStatusProps($77fae5be6c2b1145$var$getInitialStatus(initialValue, promise || promiseFn)),
        counter: 0,
        promise: $77fae5be6c2b1145$export$f8415f49327504d8
    });
const $77fae5be6c2b1145$export$1650419e431d3ba3 = (state, action)=>{
    switch(action.type){
        case $77fae5be6c2b1145$export$1385d81a6c6bbcd4.start:
            return {
                ...state,
                startedAt: new Date(),
                finishedAt: undefined,
                ...$77fae5be6c2b1145$var$getStatusProps($77fae5be6c2b1145$export$71c2f43e23882c69.pending),
                counter: action.meta.counter,
                promise: action.meta.promise
            };
        case $77fae5be6c2b1145$export$1385d81a6c6bbcd4.cancel:
            return {
                ...state,
                startedAt: undefined,
                finishedAt: undefined,
                ...$77fae5be6c2b1145$var$getStatusProps($77fae5be6c2b1145$var$getIdleStatus(state.error || state.data)),
                counter: action.meta.counter,
                promise: action.meta.promise
            };
        case $77fae5be6c2b1145$export$1385d81a6c6bbcd4.fulfill:
            return {
                ...state,
                data: action.payload,
                value: action.payload,
                error: undefined,
                finishedAt: new Date(),
                ...$77fae5be6c2b1145$var$getStatusProps($77fae5be6c2b1145$export$71c2f43e23882c69.fulfilled),
                promise: action.meta.promise
            };
        case $77fae5be6c2b1145$export$1385d81a6c6bbcd4.reject:
            return {
                ...state,
                error: action.payload,
                value: action.payload,
                finishedAt: new Date(),
                ...$77fae5be6c2b1145$var$getStatusProps($77fae5be6c2b1145$export$71c2f43e23882c69.rejected),
                promise: action.meta.promise
            };
        default:
            return state;
    }
};
const $77fae5be6c2b1145$export$9883d18982e679cf = (dispatch)=>(action, ...args)=>{
        dispatch(action, ...args);
        if (action.type === $77fae5be6c2b1145$export$1385d81a6c6bbcd4.start && typeof action.payload === "function") action.payload();
    };
class $77fae5be6c2b1145$var$Async extends (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).Component {
}
/**
 * createInstance allows you to create instances of Async that are bound to a specific promise.
 * A unique instance also uses its own React context for better nesting capability.
 */ function $77fae5be6c2b1145$export$99152e8d49ca4e7d(defaultOptions = {}, displayName = "Async") {
    const { Consumer: UnguardedConsumer, Provider: Provider } = (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createContext(undefined);
    function Consumer({ children: children }) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement(UnguardedConsumer, null, (value)=>{
            if (!value) throw new Error("this component should only be used within an associated <Async> component!");
            return children(value);
        });
    }
    class Async extends (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).Component {
        constructor(props){
            super(props);
            this.mounted = false;
            this.counter = 0;
            this.args = [];
            this.promise = $77fae5be6c2b1145$export$f8415f49327504d8;
            this.abortController = new $77fae5be6c2b1145$var$MockAbortController();
            this.start = this.start.bind(this);
            this.load = this.load.bind(this);
            this.run = this.run.bind(this);
            this.cancel = this.cancel.bind(this);
            this.onResolve = this.onResolve.bind(this);
            this.onReject = this.onReject.bind(this);
            this.setData = this.setData.bind(this);
            this.setError = this.setError.bind(this);
            const promise = props.promise;
            const promiseFn = props.promiseFn || defaultOptions.promiseFn;
            const initialValue = props.initialValue || defaultOptions.initialValue;
            this.state = {
                ...$77fae5be6c2b1145$export$2cd8252107eb640b({
                    initialValue: initialValue,
                    promise: promise,
                    promiseFn: promiseFn
                }),
                cancel: this.cancel,
                run: this.run,
                reload: ()=>{
                    this.load();
                    this.run(...this.args);
                },
                setData: this.setData,
                setError: this.setError
            };
            this.debugLabel = props.debugLabel || defaultOptions.debugLabel;
            const { devToolsDispatcher: devToolsDispatcher } = $77fae5be6c2b1145$export$af1bbc55aad4f91e.__REACT_ASYNC__;
            const _reducer = props.reducer || defaultOptions.reducer;
            const _dispatcher = props.dispatcher || defaultOptions.dispatcher || devToolsDispatcher;
            const reducer$1 = _reducer ? (state, action)=>_reducer(state, action, $77fae5be6c2b1145$export$1650419e431d3ba3) : $77fae5be6c2b1145$export$1650419e431d3ba3;
            const dispatch = $77fae5be6c2b1145$export$9883d18982e679cf((action, callback)=>{
                this.setState((state)=>reducer$1(state, action), callback);
            });
            this.dispatch = _dispatcher ? (action)=>_dispatcher(action, dispatch, props) : dispatch;
        }
        componentDidMount() {
            this.mounted = true;
            if (this.props.promise || !this.state.initialValue) this.load();
        }
        componentDidUpdate(prevProps) {
            const { watch: watch, watchFn: watchFn = defaultOptions.watchFn, promise: promise, promiseFn: promiseFn } = this.props;
            if (watch !== prevProps.watch) {
                if (this.counter) this.cancel();
                return this.load();
            }
            if (watchFn && watchFn({
                ...defaultOptions,
                ...this.props
            }, {
                ...defaultOptions,
                ...prevProps
            })) {
                if (this.counter) this.cancel();
                return this.load();
            }
            if (promise !== prevProps.promise) {
                if (this.counter) this.cancel();
                if (promise) return this.load();
            }
            if (promiseFn !== prevProps.promiseFn) {
                if (this.counter) this.cancel();
                if (promiseFn) return this.load();
            }
        }
        componentWillUnmount() {
            this.cancel();
            this.mounted = false;
        }
        getMeta(meta) {
            return {
                counter: this.counter,
                promise: this.promise,
                debugLabel: this.debugLabel,
                ...meta
            };
        }
        start(promiseFn) {
            if ("AbortController" in $77fae5be6c2b1145$export$af1bbc55aad4f91e) {
                this.abortController.abort();
                this.abortController = new $77fae5be6c2b1145$export$af1bbc55aad4f91e.AbortController();
            }
            this.counter++;
            return this.promise = new Promise((resolve, reject)=>{
                if (!this.mounted) return;
                const executor = ()=>promiseFn().then(resolve, reject);
                this.dispatch({
                    type: $77fae5be6c2b1145$export$1385d81a6c6bbcd4.start,
                    payload: executor,
                    meta: this.getMeta()
                });
            });
        }
        load() {
            const promise = this.props.promise;
            const promiseFn = this.props.promiseFn || defaultOptions.promiseFn;
            if (promise) this.start(()=>promise).then(this.onResolve(this.counter)).catch(this.onReject(this.counter));
            else if (promiseFn) {
                const props = {
                    ...defaultOptions,
                    ...this.props
                };
                this.start(()=>promiseFn(props, this.abortController)).then(this.onResolve(this.counter)).catch(this.onReject(this.counter));
            }
        }
        run(...args) {
            const deferFn = this.props.deferFn || defaultOptions.deferFn;
            if (deferFn) {
                this.args = args;
                const props = {
                    ...defaultOptions,
                    ...this.props
                };
                return this.start(()=>deferFn(args, props, this.abortController)).then(this.onResolve(this.counter), this.onReject(this.counter));
            }
        }
        cancel() {
            const onCancel = this.props.onCancel || defaultOptions.onCancel;
            onCancel && onCancel();
            this.counter++;
            this.abortController.abort();
            this.mounted && this.dispatch({
                type: $77fae5be6c2b1145$export$1385d81a6c6bbcd4.cancel,
                meta: this.getMeta()
            });
        }
        onResolve(counter) {
            return (data)=>{
                if (this.counter === counter) {
                    const onResolve = this.props.onResolve || defaultOptions.onResolve;
                    this.setData(data, ()=>onResolve && onResolve(data));
                }
                return data;
            };
        }
        onReject(counter) {
            return (error)=>{
                if (this.counter === counter) {
                    const onReject = this.props.onReject || defaultOptions.onReject;
                    this.setError(error, ()=>onReject && onReject(error));
                }
                return error;
            };
        }
        setData(data, callback) {
            this.mounted && this.dispatch({
                type: $77fae5be6c2b1145$export$1385d81a6c6bbcd4.fulfill,
                payload: data,
                meta: this.getMeta()
            }, callback);
            return data;
        }
        setError(error, callback) {
            this.mounted && this.dispatch({
                type: $77fae5be6c2b1145$export$1385d81a6c6bbcd4.reject,
                payload: error,
                error: true,
                meta: this.getMeta()
            }, callback);
            return error;
        }
        render() {
            const { children: children, suspense: suspense } = this.props;
            if (suspense && this.state.isPending && this.promise !== $77fae5be6c2b1145$export$f8415f49327504d8) // Rely on Suspense to handle the loading state
            throw this.promise;
            if (typeof children === "function") {
                const render = children;
                return (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement(Provider, {
                    value: this.state
                }, render(this.state));
            }
            if (children !== undefined && children !== null) return (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement(Provider, {
                value: this.state
            }, children);
            return null;
        }
    }
    if ($77fae5be6c2b1145$var$propTypes) Async.propTypes = $77fae5be6c2b1145$var$propTypes.Async;
    const AsyncInitial = (props)=>(0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement(Consumer, null, (st)=>(0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement($77fae5be6c2b1145$export$ef55f14ef766f494, Object.assign({}, props, {
                state: st
            })));
    const AsyncPending = (props)=>(0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement(Consumer, null, (st)=>(0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement($77fae5be6c2b1145$export$fcb4895414d32f4e, Object.assign({}, props, {
                state: st
            })));
    const AsyncFulfilled = (props)=>(0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement(Consumer, null, (st)=>(0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement($77fae5be6c2b1145$export$e51ea416e03c0b2, Object.assign({}, props, {
                state: st
            })));
    const AsyncRejected = (props)=>(0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement(Consumer, null, (st)=>(0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement($77fae5be6c2b1145$export$9c650b30aa842e16, Object.assign({}, props, {
                state: st
            })));
    const AsyncSettled = (props)=>(0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement(Consumer, null, (st)=>(0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement($77fae5be6c2b1145$export$6248b08a30065aab, Object.assign({}, props, {
                state: st
            })));
    AsyncInitial.displayName = `${displayName}.Initial`;
    AsyncPending.displayName = `${displayName}.Pending`;
    AsyncFulfilled.displayName = `${displayName}.Fulfilled`;
    AsyncRejected.displayName = `${displayName}.Rejected`;
    AsyncSettled.displayName = `${displayName}.Settled`;
    return Object.assign(Async, {
        displayName: displayName,
        Initial: AsyncInitial,
        Pending: AsyncPending,
        Loading: AsyncPending,
        Fulfilled: AsyncFulfilled,
        Resolved: AsyncFulfilled,
        Rejected: AsyncRejected,
        Settled: AsyncSettled
    });
}
var $77fae5be6c2b1145$export$4d3c597da532240f = $77fae5be6c2b1145$export$99152e8d49ca4e7d();
function $77fae5be6c2b1145$var$useAsync(arg1, arg2) {
    const options = typeof arg1 === "function" ? {
        ...arg2,
        promiseFn: arg1
    } : arg1;
    const counter = (0, $kc00y.useRef)(0);
    const isMounted = (0, $kc00y.useRef)(true);
    const lastArgs = (0, $kc00y.useRef)(undefined);
    const lastOptions = (0, $kc00y.useRef)(options);
    const lastPromise = (0, $kc00y.useRef)($77fae5be6c2b1145$export$f8415f49327504d8);
    const abortController = (0, $kc00y.useRef)(new $77fae5be6c2b1145$var$MockAbortController());
    const { devToolsDispatcher: devToolsDispatcher } = $77fae5be6c2b1145$export$af1bbc55aad4f91e.__REACT_ASYNC__;
    const { reducer: reducer$1, dispatcher: dispatcher = devToolsDispatcher } = options;
    const [state, _dispatch] = (0, $kc00y.useReducer)(reducer$1 ? (state, action)=>reducer$1(state, action, $77fae5be6c2b1145$export$1650419e431d3ba3) : $77fae5be6c2b1145$export$1650419e431d3ba3, options, $77fae5be6c2b1145$export$2cd8252107eb640b);
    const dispatch = (0, $kc00y.useCallback)(dispatcher ? (action)=>dispatcher(action, $77fae5be6c2b1145$export$9883d18982e679cf(_dispatch), lastOptions.current) : $77fae5be6c2b1145$export$9883d18982e679cf(_dispatch), [
        dispatcher
    ]);
    const { debugLabel: debugLabel } = options;
    const getMeta = (0, $kc00y.useCallback)((meta)=>({
            counter: counter.current,
            promise: lastPromise.current,
            debugLabel: debugLabel,
            ...meta
        }), [
        debugLabel
    ]);
    const setData = (0, $kc00y.useCallback)((data, callback = $77fae5be6c2b1145$var$noop)=>{
        if (isMounted.current) {
            dispatch({
                type: $77fae5be6c2b1145$export$1385d81a6c6bbcd4.fulfill,
                payload: data,
                meta: getMeta()
            });
            callback();
        }
        return data;
    }, [
        dispatch,
        getMeta
    ]);
    const setError = (0, $kc00y.useCallback)((error, callback = $77fae5be6c2b1145$var$noop)=>{
        if (isMounted.current) {
            dispatch({
                type: $77fae5be6c2b1145$export$1385d81a6c6bbcd4.reject,
                payload: error,
                error: true,
                meta: getMeta()
            });
            callback();
        }
        return error;
    }, [
        dispatch,
        getMeta
    ]);
    const { onResolve: onResolve, onReject: onReject } = options;
    const handleResolve = (0, $kc00y.useCallback)((count)=>(data)=>count === counter.current && setData(data, ()=>onResolve && onResolve(data)), [
        setData,
        onResolve
    ]);
    const handleReject = (0, $kc00y.useCallback)((count)=>(err)=>count === counter.current && setError(err, ()=>onReject && onReject(err)), [
        setError,
        onReject
    ]);
    const start = (0, $kc00y.useCallback)((promiseFn)=>{
        if ("AbortController" in $77fae5be6c2b1145$export$af1bbc55aad4f91e) {
            abortController.current.abort();
            abortController.current = new $77fae5be6c2b1145$export$af1bbc55aad4f91e.AbortController();
        }
        counter.current++;
        return lastPromise.current = new Promise((resolve, reject)=>{
            if (!isMounted.current) return;
            const executor = ()=>promiseFn().then(resolve, reject);
            dispatch({
                type: $77fae5be6c2b1145$export$1385d81a6c6bbcd4.start,
                payload: executor,
                meta: getMeta()
            });
        });
    }, [
        dispatch,
        getMeta
    ]);
    const { promise: promise, promiseFn: promiseFn, initialValue: initialValue } = options;
    const load = (0, $kc00y.useCallback)(()=>{
        const isPreInitialized = initialValue && counter.current === 0;
        if (promise) start(()=>promise).then(handleResolve(counter.current)).catch(handleReject(counter.current));
        else if (promiseFn && !isPreInitialized) start(()=>promiseFn(lastOptions.current, abortController.current)).then(handleResolve(counter.current)).catch(handleReject(counter.current));
    }, [
        start,
        promise,
        promiseFn,
        initialValue,
        handleResolve,
        handleReject
    ]);
    const { deferFn: deferFn } = options;
    const run = (0, $kc00y.useCallback)((...args)=>{
        if (deferFn) {
            lastArgs.current = args;
            start(()=>deferFn(args, lastOptions.current, abortController.current)).then(handleResolve(counter.current)).catch(handleReject(counter.current));
        }
    }, [
        start,
        deferFn,
        handleResolve,
        handleReject
    ]);
    const reload = (0, $kc00y.useCallback)(()=>{
        lastArgs.current ? run(...lastArgs.current) : load();
    }, [
        run,
        load
    ]);
    const { onCancel: onCancel } = options;
    const cancel = (0, $kc00y.useCallback)(()=>{
        onCancel && onCancel();
        counter.current++;
        abortController.current.abort();
        isMounted.current && dispatch({
            type: $77fae5be6c2b1145$export$1385d81a6c6bbcd4.cancel,
            meta: getMeta()
        });
    }, [
        onCancel,
        dispatch,
        getMeta
    ]);
    /* These effects should only be triggered on changes to specific props */ /* eslint-disable react-hooks/exhaustive-deps */ const { watch: watch, watchFn: watchFn } = options;
    (0, $kc00y.useEffect)(()=>{
        if (watchFn && lastOptions.current && watchFn(options, lastOptions.current)) {
            lastOptions.current = options;
            load();
        }
    });
    (0, $kc00y.useEffect)(()=>{
        lastOptions.current = options;
    }, [
        options
    ]);
    (0, $kc00y.useEffect)(()=>{
        if (counter.current) cancel();
        if (promise || promiseFn) load();
    }, [
        promise,
        promiseFn,
        watch
    ]);
    (0, $kc00y.useEffect)(()=>()=>{
            isMounted.current = false;
        }, []);
    (0, $kc00y.useEffect)(()=>()=>cancel(), []);
    /* eslint-enable react-hooks/exhaustive-deps */ (0, $kc00y.useDebugValue)(state, ({ status: status })=>`[${counter.current}] ${status}`);
    if (options.suspense && state.isPending && lastPromise.current !== $77fae5be6c2b1145$export$f8415f49327504d8) // Rely on Suspense to handle the loading state
    throw lastPromise.current;
    return (0, $kc00y.useMemo)(()=>({
            ...state,
            run: run,
            reload: reload,
            cancel: cancel,
            setData: setData,
            setError: setError
        }), [
        state,
        run,
        reload,
        cancel,
        setData,
        setError
    ]);
}
class $77fae5be6c2b1145$export$26e841bcf1aeb894 extends Error {
    constructor(response){
        super(`${response.status} ${response.statusText}`);
        this.response = response;
        /* istanbul ignore next */ if (Object.setPrototypeOf) // Not available in IE 10, but can be polyfilled
        Object.setPrototypeOf(this, $77fae5be6c2b1145$export$26e841bcf1aeb894.prototype);
    }
}
const $77fae5be6c2b1145$var$parseResponse = (accept, json)=>(res)=>{
        if (!res.ok) return Promise.reject(new $77fae5be6c2b1145$export$26e841bcf1aeb894(res));
        if (typeof json === "boolean") return json ? res.json() : res;
        return accept === "application/json" ? res.json() : res;
    };
function $77fae5be6c2b1145$var$isEvent(e) {
    return typeof e === "object" && "preventDefault" in e;
}
/**
 *
 * @param {RequestInfo} resource
 * @param {RequestInit} init
 * @param {FetchOptions} options
 * @returns {AsyncState<T, FetchRun<T>>}
 */ function $77fae5be6c2b1145$var$useAsyncFetch(resource, init, { defer: defer, json: json, ...options } = {}) {
    const method = resource.method || init && init.method;
    const headers = resource.headers || init && init.headers || {};
    const accept = headers["Accept"] || headers["accept"] || headers.get && headers.get("accept");
    const doFetch = (input, init)=>$77fae5be6c2b1145$export$af1bbc55aad4f91e.fetch(input, init).then($77fae5be6c2b1145$var$parseResponse(accept, json));
    const isDefer = typeof defer === "boolean" ? defer : [
        "POST",
        "PUT",
        "PATCH",
        "DELETE"
    ].indexOf(method) !== -1;
    const fn = isDefer ? "deferFn" : "promiseFn";
    const identity = JSON.stringify({
        resource: resource,
        init: init,
        isDefer: isDefer
    });
    const promiseFn = (0, $kc00y.useCallback)((_, { signal: signal })=>{
        return doFetch(resource, {
            signal: signal,
            ...init
        });
    }, [
        identity
    ] // eslint-disable-line react-hooks/exhaustive-deps
    );
    const deferFn = (0, $kc00y.useCallback)(function([override], _, { signal: signal }) {
        if (!override || $77fae5be6c2b1145$var$isEvent(override)) return doFetch(resource, {
            signal: signal,
            ...init
        });
        if (typeof override === "function") {
            const { resource: runResource, ...runInit } = override({
                resource: resource,
                signal: signal,
                ...init
            });
            return doFetch(runResource || resource, {
                signal: signal,
                ...runInit
            });
        }
        const { resource: runResource, ...runInit } = override;
        return doFetch(runResource || resource, {
            signal: signal,
            ...init,
            ...runInit
        });
    }, [
        identity
    ] // eslint-disable-line react-hooks/exhaustive-deps
    );
    const state = $77fae5be6c2b1145$var$useAsync({
        ...options,
        [fn]: isDefer ? deferFn : promiseFn
    });
    (0, $kc00y.useDebugValue)(state, ({ counter: counter, status: status })=>`[${counter}] ${status}`);
    return state;
}
const $77fae5be6c2b1145$var$unsupported = ()=>{
    throw new Error("useAsync requires React v16.8 or up. Upgrade your React version or use the <Async> component instead.");
};
var $77fae5be6c2b1145$export$cdf1dc76b55502e3 = (0, $kc00y.useEffect) ? $77fae5be6c2b1145$var$useAsync : $77fae5be6c2b1145$var$unsupported;
const $77fae5be6c2b1145$export$d852f5f778460fa4 = (0, $kc00y.useEffect) ? $77fae5be6c2b1145$var$useAsyncFetch : $77fae5be6c2b1145$var$unsupported;
var $77fae5be6c2b1145$export$2e2bcd8739ae039 = $77fae5be6c2b1145$export$4d3c597da532240f;








var $kc00y = parcelRequire("kc00y");


"use client";
const $4c73f725f3c8b0a1$var$Container = /*#__PURE__*/ $kc00y.forwardRef(({ bsPrefix: bsPrefix, fluid: fluid = false, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', className: className, ...props }, ref)=>{
    const prefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(bsPrefix, 'container');
    const suffix = typeof fluid === 'string' ? `-${fluid}` : '-fluid';
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, fluid ? `${prefix}${suffix}` : prefix)
    });
});
$4c73f725f3c8b0a1$var$Container.displayName = 'Container';
var $4c73f725f3c8b0a1$export$2e2bcd8739ae039 = $4c73f725f3c8b0a1$var$Container;





var $kc00y = parcelRequire("kc00y");


var $kc00y = parcelRequire("kc00y");


"use client";
function $360599dc87384838$export$2ed43d61a0a9f5a3({ as: as, bsPrefix: bsPrefix, className: className, ...props }) {
    bsPrefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(bsPrefix, 'col');
    const breakpoints = (0, $6c3886f519efe212$export$8970c8db816a5863)();
    const minBreakpoint = (0, $6c3886f519efe212$export$d926d6ef38f3fd32)();
    const spans = [];
    const classes = [];
    breakpoints.forEach((brkPoint)=>{
        const propValue = props[brkPoint];
        delete props[brkPoint];
        let span;
        let offset;
        let order;
        if (typeof propValue === 'object' && propValue != null) ({ span: span, offset: offset, order: order } = propValue);
        else span = propValue;
        const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : '';
        if (span) spans.push(span === true ? `${bsPrefix}${infix}` : `${bsPrefix}${infix}-${span}`);
        if (order != null) classes.push(`order${infix}-${order}`);
        if (offset != null) classes.push(`offset${infix}-${offset}`);
    });
    return [
        {
            ...props,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, ...spans, ...classes)
        },
        {
            as: as,
            bsPrefix: bsPrefix,
            spans: spans
        }
    ];
}
const $360599dc87384838$var$Col = /*#__PURE__*/ $kc00y.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
(props, ref)=>{
    const [{ className: className, ...colProps }, { as: Component = 'div', bsPrefix: bsPrefix, spans: spans }] = $360599dc87384838$export$2ed43d61a0a9f5a3(props);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)(Component, {
        ...colProps,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, !spans.length && bsPrefix)
    });
});
$360599dc87384838$var$Col.displayName = 'Col';
var $360599dc87384838$export$2e2bcd8739ae039 = $360599dc87384838$var$Col;



var $kc00y = parcelRequire("kc00y");


"use client";
const $2fbf711edf8913b6$var$Row = /*#__PURE__*/ $kc00y.forwardRef(({ bsPrefix: bsPrefix, className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...props }, ref)=>{
    const decoratedBsPrefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(bsPrefix, 'row');
    const breakpoints = (0, $6c3886f519efe212$export$8970c8db816a5863)();
    const minBreakpoint = (0, $6c3886f519efe212$export$d926d6ef38f3fd32)();
    const sizePrefix = `${decoratedBsPrefix}-cols`;
    const classes = [];
    breakpoints.forEach((brkPoint)=>{
        const propValue = props[brkPoint];
        delete props[brkPoint];
        let cols;
        if (propValue != null && typeof propValue === 'object') ({ cols: cols } = propValue);
        else cols = propValue;
        const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : '';
        if (cols != null) classes.push(`${sizePrefix}${infix}-${cols}`);
    });
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, decoratedBsPrefix, ...classes)
    });
});
$2fbf711edf8913b6$var$Row.displayName = 'Row';
var $2fbf711edf8913b6$export$2e2bcd8739ae039 = $2fbf711edf8913b6$var$Row;




var $lCkAA = parcelRequire("lCkAA");

var $kc00y = parcelRequire("kc00y");


var $kc00y = parcelRequire("kc00y");


var $kc00y = parcelRequire("kc00y");

var $lCkAA = parcelRequire("lCkAA");

const $073b3b38f9e4f13d$var$propTypes = {
    /**
   * Specify whether the feedback is for valid or invalid fields
   *
   * @type {('valid'|'invalid')}
   */ type: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).string,
    /** Display feedback as a tooltip. */ tooltip: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).bool,
    as: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).elementType
};
const $073b3b38f9e4f13d$var$Feedback = /*#__PURE__*/ $kc00y.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({ as: Component = 'div', className: className, type: type = 'valid', tooltip: tooltip = false, ...props }, ref)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, `${type}-${tooltip ? 'tooltip' : 'feedback'}`)
    }));
$073b3b38f9e4f13d$var$Feedback.displayName = 'Feedback';
$073b3b38f9e4f13d$var$Feedback.propTypes = $073b3b38f9e4f13d$var$propTypes;
var $073b3b38f9e4f13d$export$2e2bcd8739ae039 = $073b3b38f9e4f13d$var$Feedback;




var $kc00y = parcelRequire("kc00y");

var $kc00y = parcelRequire("kc00y");
"use client";
// TODO
const $ff292da2b1385757$var$FormContext = /*#__PURE__*/ $kc00y.createContext({});
var $ff292da2b1385757$export$2e2bcd8739ae039 = $ff292da2b1385757$var$FormContext;




"use client";
const $4c16259bbd613a35$var$FormCheckInput = /*#__PURE__*/ $kc00y.forwardRef(({ id: id, bsPrefix: bsPrefix, className: className, type: type = 'checkbox', isValid: isValid = false, isInvalid: isInvalid = false, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'input', ...props }, ref)=>{
    const { controlId: controlId } = (0, $kc00y.useContext)((0, $ff292da2b1385757$export$2e2bcd8739ae039));
    bsPrefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(bsPrefix, 'form-check-input');
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)(Component, {
        ...props,
        ref: ref,
        type: type,
        id: id || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, bsPrefix, isValid && 'is-valid', isInvalid && 'is-invalid')
    });
});
$4c16259bbd613a35$var$FormCheckInput.displayName = 'FormCheckInput';
var $4c16259bbd613a35$export$2e2bcd8739ae039 = $4c16259bbd613a35$var$FormCheckInput;




var $kc00y = parcelRequire("kc00y");



"use client";
const $66c38c89e149195e$var$FormCheckLabel = /*#__PURE__*/ $kc00y.forwardRef(({ bsPrefix: bsPrefix, className: className, htmlFor: htmlFor, ...props }, ref)=>{
    const { controlId: controlId } = (0, $kc00y.useContext)((0, $ff292da2b1385757$export$2e2bcd8739ae039));
    bsPrefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(bsPrefix, 'form-check-label');
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("label", {
        ...props,
        ref: ref,
        htmlFor: htmlFor || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, bsPrefix)
    });
});
$66c38c89e149195e$var$FormCheckLabel.displayName = 'FormCheckLabel';
var $66c38c89e149195e$export$2e2bcd8739ae039 = $66c38c89e149195e$var$FormCheckLabel;





var $kc00y = parcelRequire("kc00y");
/**
 * Iterates through children that are typically specified as `props.children`,
 * but only maps over children that are "valid elements".
 *
 * The mapFunction provided index will be normalised to the components mapped,
 * so an invalid component would not increase the index.
 *
 */ function $539f969aeabf579c$export$871de8747c9eaa88(children, func) {
    let index = 0;
    return $kc00y.Children.map(children, (child)=>/*#__PURE__*/ $kc00y.isValidElement(child) ? func(child, index++) : child);
}
/**
 * Iterates through children that are "valid elements".
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child with the index reflecting the position relative to "valid components".
 */ function $539f969aeabf579c$export$4b80e395e36b5a56(children, func) {
    let index = 0;
    $kc00y.Children.forEach(children, (child)=>{
        if (/*#__PURE__*/ $kc00y.isValidElement(child)) func(child, index++);
    });
}
/**
 * Finds whether a component's `children` prop includes a React element of the
 * specified type.
 */ function $539f969aeabf579c$export$500fd6099226ffae(children, type) {
    return $kc00y.Children.toArray(children).some((child)=>/*#__PURE__*/ $kc00y.isValidElement(child) && child.type === type);
}



"use client";
const $15ea91ee06c5121b$var$FormCheck = /*#__PURE__*/ $kc00y.forwardRef(({ id: id, bsPrefix: bsPrefix, bsSwitchPrefix: bsSwitchPrefix, inline: inline = false, reverse: reverse = false, disabled: disabled = false, isValid: isValid = false, isInvalid: isInvalid = false, feedbackTooltip: feedbackTooltip = false, feedback: feedback, feedbackType: feedbackType, className: className, style: style, title: title = '', type: type = 'checkbox', label: label, children: children, as: // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as = 'input', ...props }, ref)=>{
    bsPrefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(bsPrefix, 'form-check');
    bsSwitchPrefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(bsSwitchPrefix, 'form-switch');
    const { controlId: controlId } = (0, $kc00y.useContext)((0, $ff292da2b1385757$export$2e2bcd8739ae039));
    const innerFormContext = (0, $kc00y.useMemo)(()=>({
            controlId: id || controlId
        }), [
        controlId,
        id
    ]);
    const hasLabel = !children && label != null && label !== false || (0, $539f969aeabf579c$export$500fd6099226ffae)(children, (0, $66c38c89e149195e$export$2e2bcd8739ae039));
    const input = /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $4c16259bbd613a35$export$2e2bcd8739ae039), {
        ...props,
        type: type === 'switch' ? 'checkbox' : type,
        ref: ref,
        isValid: isValid,
        isInvalid: isInvalid,
        disabled: disabled,
        as: as
    });
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ff292da2b1385757$export$2e2bcd8739ae039).Provider, {
        value: innerFormContext,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
            style: style,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, hasLabel && bsPrefix, inline && `${bsPrefix}-inline`, reverse && `${bsPrefix}-reverse`, type === 'switch' && bsSwitchPrefix),
            children: children || /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                children: [
                    input,
                    hasLabel && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $66c38c89e149195e$export$2e2bcd8739ae039), {
                        title: title,
                        children: label
                    }),
                    feedback && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $073b3b38f9e4f13d$export$2e2bcd8739ae039), {
                        type: feedbackType,
                        tooltip: feedbackTooltip,
                        children: feedback
                    })
                ]
            })
        })
    });
});
$15ea91ee06c5121b$var$FormCheck.displayName = 'FormCheck';
var $15ea91ee06c5121b$export$2e2bcd8739ae039 = Object.assign($15ea91ee06c5121b$var$FormCheck, {
    Input: (0, $4c16259bbd613a35$export$2e2bcd8739ae039),
    Label: (0, $66c38c89e149195e$export$2e2bcd8739ae039)
});




var $kc00y = parcelRequire("kc00y");
var $61fad0cb6b7e8586$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $61fad0cb6b7e8586$var$__DEV__ = false;
var $61fad0cb6b7e8586$var$warning = function() {};
if ($61fad0cb6b7e8586$var$__DEV__) {
    var $61fad0cb6b7e8586$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== 'undefined') console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $61fad0cb6b7e8586$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $61fad0cb6b7e8586$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
$61fad0cb6b7e8586$exports = $61fad0cb6b7e8586$var$warning;






"use client";
const $399684c98cf70cc1$var$FormControl = /*#__PURE__*/ $kc00y.forwardRef(({ bsPrefix: bsPrefix, type: type, size: size, htmlSize: htmlSize, id: id, className: className, isValid: isValid = false, isInvalid: isInvalid = false, plaintext: plaintext, readOnly: readOnly, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'input', ...props }, ref)=>{
    const { controlId: controlId } = (0, $kc00y.useContext)((0, $ff292da2b1385757$export$2e2bcd8739ae039));
    bsPrefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(bsPrefix, 'form-control');
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)(Component, {
        ...props,
        type: type,
        size: htmlSize,
        ref: ref,
        readOnly: readOnly,
        id: id || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, plaintext ? `${bsPrefix}-plaintext` : bsPrefix, size && `${bsPrefix}-${size}`, type === 'color' && `${bsPrefix}-color`, isValid && 'is-valid', isInvalid && 'is-invalid')
    });
});
$399684c98cf70cc1$var$FormControl.displayName = 'FormControl';
var $399684c98cf70cc1$export$2e2bcd8739ae039 = Object.assign($399684c98cf70cc1$var$FormControl, {
    Feedback: $073b3b38f9e4f13d$export$2e2bcd8739ae039
});



var $kc00y = parcelRequire("kc00y");



"use client";
const $6112228b771b3389$var$FormFloating = /*#__PURE__*/ $kc00y.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(bsPrefix, 'form-floating');
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, bsPrefix),
        ...props
    });
});
$6112228b771b3389$var$FormFloating.displayName = 'FormFloating';
var $6112228b771b3389$export$2e2bcd8739ae039 = $6112228b771b3389$var$FormFloating;



var $kc00y = parcelRequire("kc00y");


const $64a347326443b276$var$FormGroup = /*#__PURE__*/ $kc00y.forwardRef(({ controlId: controlId, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...props }, ref)=>{
    const context = (0, $kc00y.useMemo)(()=>({
            controlId: controlId
        }), [
        controlId
    ]);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ff292da2b1385757$export$2e2bcd8739ae039).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)(Component, {
            ...props,
            ref: ref
        })
    });
});
$64a347326443b276$var$FormGroup.displayName = 'FormGroup';
var $64a347326443b276$export$2e2bcd8739ae039 = $64a347326443b276$var$FormGroup;




var $kc00y = parcelRequire("kc00y");





"use client";
const $7d214c23de4a956f$var$FormLabel = /*#__PURE__*/ $kc00y.forwardRef(({ // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'label', bsPrefix: bsPrefix, column: column = false, visuallyHidden: visuallyHidden = false, className: className, htmlFor: htmlFor, ...props }, ref)=>{
    const { controlId: controlId } = (0, $kc00y.useContext)((0, $ff292da2b1385757$export$2e2bcd8739ae039));
    bsPrefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(bsPrefix, 'form-label');
    let columnClass = 'col-form-label';
    if (typeof column === 'string') columnClass = `${columnClass} ${columnClass}-${column}`;
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, bsPrefix, visuallyHidden && 'visually-hidden', column && columnClass);
    htmlFor = htmlFor || controlId;
    if (column) return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
        ref: ref,
        as: "label",
        className: classes,
        htmlFor: htmlFor,
        ...props
    });
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)(Component, {
        ref: ref,
        className: classes,
        htmlFor: htmlFor,
        ...props
    });
});
$7d214c23de4a956f$var$FormLabel.displayName = 'FormLabel';
var $7d214c23de4a956f$export$2e2bcd8739ae039 = $7d214c23de4a956f$var$FormLabel;




var $kc00y = parcelRequire("kc00y");



"use client";
const $fb281c3c0e7b8a11$var$FormRange = /*#__PURE__*/ $kc00y.forwardRef(({ bsPrefix: bsPrefix, className: className, id: id, ...props }, ref)=>{
    const { controlId: controlId } = (0, $kc00y.useContext)((0, $ff292da2b1385757$export$2e2bcd8739ae039));
    bsPrefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(bsPrefix, 'form-range');
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("input", {
        ...props,
        type: "range",
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, bsPrefix),
        id: id || controlId
    });
});
$fb281c3c0e7b8a11$var$FormRange.displayName = 'FormRange';
var $fb281c3c0e7b8a11$export$2e2bcd8739ae039 = $fb281c3c0e7b8a11$var$FormRange;




var $kc00y = parcelRequire("kc00y");



"use client";
const $7ffbb553d29e18b8$var$FormSelect = /*#__PURE__*/ $kc00y.forwardRef(({ bsPrefix: bsPrefix, size: size, htmlSize: htmlSize, className: className, isValid: isValid = false, isInvalid: isInvalid = false, id: id, ...props }, ref)=>{
    const { controlId: controlId } = (0, $kc00y.useContext)((0, $ff292da2b1385757$export$2e2bcd8739ae039));
    bsPrefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(bsPrefix, 'form-select');
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("select", {
        ...props,
        size: htmlSize,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, bsPrefix, size && `${bsPrefix}-${size}`, isValid && `is-valid`, isInvalid && `is-invalid`),
        id: id || controlId
    });
});
$7ffbb553d29e18b8$var$FormSelect.displayName = 'FormSelect';
var $7ffbb553d29e18b8$export$2e2bcd8739ae039 = $7ffbb553d29e18b8$var$FormSelect;




var $kc00y = parcelRequire("kc00y");


"use client";
const $7ed85de6e400dd62$var$FormText = /*#__PURE__*/ $kc00y.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({ bsPrefix: bsPrefix, className: className, as: Component = 'small', muted: muted, ...props }, ref)=>{
    bsPrefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(bsPrefix, 'form-text');
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, bsPrefix, muted && 'text-muted')
    });
});
$7ed85de6e400dd62$var$FormText.displayName = 'FormText';
var $7ed85de6e400dd62$export$2e2bcd8739ae039 = $7ed85de6e400dd62$var$FormText;



var $kc00y = parcelRequire("kc00y");


const $7148def5305be6b3$var$Switch = /*#__PURE__*/ $kc00y.forwardRef((props, ref)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $15ea91ee06c5121b$export$2e2bcd8739ae039), {
        ...props,
        ref: ref,
        type: "switch"
    }));
$7148def5305be6b3$var$Switch.displayName = 'Switch';
var $7148def5305be6b3$export$2e2bcd8739ae039 = Object.assign($7148def5305be6b3$var$Switch, {
    Input: (0, $15ea91ee06c5121b$export$2e2bcd8739ae039).Input,
    Label: (0, $15ea91ee06c5121b$export$2e2bcd8739ae039).Label
});




var $kc00y = parcelRequire("kc00y");



"use client";
const $64fb4d6c077c0e42$var$FloatingLabel = /*#__PURE__*/ $kc00y.forwardRef(({ bsPrefix: bsPrefix, className: className, children: children, controlId: controlId, label: label, ...props }, ref)=>{
    bsPrefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(bsPrefix, 'form-floating');
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $64a347326443b276$export$2e2bcd8739ae039), {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, bsPrefix),
        controlId: controlId,
        ...props,
        children: [
            children,
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("label", {
                htmlFor: controlId,
                children: label
            })
        ]
    });
});
$64fb4d6c077c0e42$var$FloatingLabel.displayName = 'FloatingLabel';
var $64fb4d6c077c0e42$export$2e2bcd8739ae039 = $64fb4d6c077c0e42$var$FloatingLabel;



const $951ad4dd33e349d1$var$propTypes = {
    /**
   * The Form `ref` will be forwarded to the underlying element,
   * which means, unless it's rendered `as` a composite component,
   * it will be a DOM node, when resolved.
   *
   * @type {ReactRef}
   * @alias ref
   */ _ref: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).any,
    /**
   * Mark a form as having been validated. Setting it to `true` will
   * toggle any validation styles on the forms elements.
   */ validated: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).bool,
    as: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).elementType
};
const $951ad4dd33e349d1$var$Form = /*#__PURE__*/ $kc00y.forwardRef(({ className: className, validated: validated, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'form', ...props }, ref)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, validated && 'was-validated')
    }));
$951ad4dd33e349d1$var$Form.displayName = 'Form';
$951ad4dd33e349d1$var$Form.propTypes = $951ad4dd33e349d1$var$propTypes;
var $951ad4dd33e349d1$export$2e2bcd8739ae039 = Object.assign($951ad4dd33e349d1$var$Form, {
    Group: (0, $64a347326443b276$export$2e2bcd8739ae039),
    Control: (0, $399684c98cf70cc1$export$2e2bcd8739ae039),
    Floating: (0, $6112228b771b3389$export$2e2bcd8739ae039),
    Check: (0, $15ea91ee06c5121b$export$2e2bcd8739ae039),
    Switch: $7148def5305be6b3$export$2e2bcd8739ae039,
    Label: (0, $7d214c23de4a956f$export$2e2bcd8739ae039),
    Text: (0, $7ed85de6e400dd62$export$2e2bcd8739ae039),
    Range: (0, $fb281c3c0e7b8a11$export$2e2bcd8739ae039),
    Select: (0, $7ffbb553d29e18b8$export$2e2bcd8739ae039),
    FloatingLabel: $64fb4d6c077c0e42$export$2e2bcd8739ae039
});







var $kc00y = parcelRequire("kc00y");

var $kc00y = parcelRequire("kc00y");

const $cdcc2451955840fb$var$_excluded = [
    "as",
    "disabled"
];
function $cdcc2451955840fb$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $cdcc2451955840fb$export$72369ab2cc99204b(href) {
    return !href || href.trim() === '#';
}
function $cdcc2451955840fb$export$a0ee72f2c720a5c3({ tagName: tagName, disabled: disabled, href: href, target: target, rel: rel, role: role, onClick: onClick, tabIndex: tabIndex = 0, type: type }) {
    if (!tagName) {
        if (href != null || target != null || rel != null) tagName = 'a';
        else tagName = 'button';
    }
    const meta = {
        tagName: tagName
    };
    if (tagName === 'button') return [
        {
            type: type || 'button',
            disabled: disabled
        },
        meta
    ];
    const handleClick = (event)=>{
        if (disabled || tagName === 'a' && $cdcc2451955840fb$export$72369ab2cc99204b(href)) event.preventDefault();
        if (disabled) {
            event.stopPropagation();
            return;
        }
        onClick == null || onClick(event);
    };
    const handleKeyDown = (event)=>{
        if (event.key === ' ') {
            event.preventDefault();
            handleClick(event);
        }
    };
    if (tagName === 'a') {
        // Ensure there's a href so Enter can trigger anchor button.
        href || (href = '#');
        if (disabled) href = undefined;
    }
    return [
        {
            role: role != null ? role : 'button',
            // explicitly undefined so that it overrides the props disabled in a spread
            // e.g. <Tag {...props} {...hookProps} />
            disabled: undefined,
            tabIndex: disabled ? undefined : tabIndex,
            href: href,
            target: tagName === 'a' ? target : undefined,
            'aria-disabled': !disabled ? undefined : disabled,
            rel: tagName === 'a' ? rel : undefined,
            onClick: handleClick,
            onKeyDown: handleKeyDown
        },
        meta
    ];
}
const $cdcc2451955840fb$var$Button = /*#__PURE__*/ $kc00y.forwardRef((_ref, ref)=>{
    let { as: asProp, disabled: disabled } = _ref, props = $cdcc2451955840fb$var$_objectWithoutPropertiesLoose(_ref, $cdcc2451955840fb$var$_excluded);
    const [buttonProps, { tagName: Component }] = $cdcc2451955840fb$export$a0ee72f2c720a5c3(Object.assign({
        tagName: asProp,
        disabled: disabled
    }, props));
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)(Component, Object.assign({}, props, buttonProps, {
        ref: ref
    }));
});
$cdcc2451955840fb$var$Button.displayName = 'Button';
var $cdcc2451955840fb$export$2e2bcd8739ae039 = $cdcc2451955840fb$var$Button;




"use client";
const $ec326a924dcbf351$var$Button = /*#__PURE__*/ $kc00y.forwardRef(({ as: as, bsPrefix: bsPrefix, variant: variant = 'primary', size: size, active: active = false, disabled: disabled = false, className: className, ...props }, ref)=>{
    const prefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(bsPrefix, 'btn');
    const [buttonProps, { tagName: tagName }] = (0, $cdcc2451955840fb$export$a0ee72f2c720a5c3)({
        tagName: as,
        disabled: disabled,
        ...props
    });
    const Component = tagName;
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)(Component, {
        ...buttonProps,
        ...props,
        ref: ref,
        disabled: disabled,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, prefix, active && 'active', variant && `${prefix}-${variant}`, size && `${prefix}-${size}`, props.href && disabled && 'disabled')
    });
});
$ec326a924dcbf351$var$Button.displayName = 'Button';
var $ec326a924dcbf351$export$2e2bcd8739ae039 = $ec326a924dcbf351$var$Button;





/* eslint-disable no-return-assign */ var $aa5eecc52b084e6f$export$2e2bcd8739ae039 = !!(typeof window !== 'undefined' && window.document && window.document.createElement);


var $c414e224cd570c88$export$63fefd044b2bc624 = false;
var $c414e224cd570c88$export$a614c6b395900f69 = false;
try {
    var $c414e224cd570c88$var$options = {
        get passive () {
            return $c414e224cd570c88$export$63fefd044b2bc624 = true;
        },
        get once () {
            // eslint-disable-next-line no-multi-assign
            return $c414e224cd570c88$export$a614c6b395900f69 = $c414e224cd570c88$export$63fefd044b2bc624 = true;
        }
    };
    if (0, $aa5eecc52b084e6f$export$2e2bcd8739ae039) {
        window.addEventListener('test', $c414e224cd570c88$var$options, $c414e224cd570c88$var$options);
        window.removeEventListener('test', $c414e224cd570c88$var$options, true);
    }
} catch (e) {
/* */ }
/**
 * An `addEventListener` ponyfill, supports the `once` option
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $c414e224cd570c88$var$addEventListener(node, eventName, handler, options) {
    if (options && typeof options !== 'boolean' && !$c414e224cd570c88$export$a614c6b395900f69) {
        var once = options.once, capture = options.capture;
        var wrappedHandler = handler;
        if (!$c414e224cd570c88$export$a614c6b395900f69 && once) {
            wrappedHandler = handler.__once || function onceHandler(event) {
                this.removeEventListener(eventName, onceHandler, capture);
                handler.call(this, event);
            };
            handler.__once = wrappedHandler;
        }
        node.addEventListener(eventName, wrappedHandler, $c414e224cd570c88$export$63fefd044b2bc624 ? options : capture);
    }
    node.addEventListener(eventName, handler, options);
}
var $c414e224cd570c88$export$2e2bcd8739ae039 = $c414e224cd570c88$var$addEventListener;



/**
 * Returns the owner document of a given element.
 * 
 * @param node the element
 */ function $3b44b30b48869541$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}


/**
 * A `removeEventListener` ponyfill
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $21bd0a760d3f2599$var$removeEventListener(node, eventName, handler, options) {
    var capture = options && typeof options !== 'boolean' ? options.capture : options;
    node.removeEventListener(eventName, handler, capture);
    if (handler.__once) node.removeEventListener(eventName, handler.__once, capture);
}
var $21bd0a760d3f2599$export$2e2bcd8739ae039 = $21bd0a760d3f2599$var$removeEventListener;



var $ff8ce7114f51a84b$var$size;
function $ff8ce7114f51a84b$export$2e2bcd8739ae039(recalc) {
    if (!$ff8ce7114f51a84b$var$size && $ff8ce7114f51a84b$var$size !== 0 || recalc) {
        if (0, $aa5eecc52b084e6f$export$2e2bcd8739ae039) {
            var scrollDiv = document.createElement('div');
            scrollDiv.style.position = 'absolute';
            scrollDiv.style.top = '-9999px';
            scrollDiv.style.width = '50px';
            scrollDiv.style.height = '50px';
            scrollDiv.style.overflow = 'scroll';
            document.body.appendChild(scrollDiv);
            $ff8ce7114f51a84b$var$size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
            document.body.removeChild(scrollDiv);
        }
    }
    return $ff8ce7114f51a84b$var$size;
}



var $kc00y = parcelRequire("kc00y");
function $6a822e76c29b5649$export$2e2bcd8739ae039() {
    return (0, $kc00y.useState)(null);
}



var $kc00y = parcelRequire("kc00y");

var $kc00y = parcelRequire("kc00y");
/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */ function $9d42d40627beb5c6$var$useCommittedRef(value) {
    const ref = (0, $kc00y.useRef)(value);
    (0, $kc00y.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}
var $9d42d40627beb5c6$export$2e2bcd8739ae039 = $9d42d40627beb5c6$var$useCommittedRef;


function $4655b62db0931f1e$export$2e2bcd8739ae039(fn) {
    const ref = (0, $9d42d40627beb5c6$export$2e2bcd8739ae039)(fn);
    return (0, $kc00y.useCallback)(function(...args) {
        return ref.current && ref.current(...args);
    }, [
        ref
    ]);
}



var $kc00y = parcelRequire("kc00y");
const $950969aa8a9dbb93$var$toFnRef = (ref)=>!ref || typeof ref === 'function' ? ref : (value)=>{
        ref.current = value;
    };
function $950969aa8a9dbb93$export$c9058316764c140e(refA, refB) {
    const a = $950969aa8a9dbb93$var$toFnRef(refA);
    const b = $950969aa8a9dbb93$var$toFnRef(refB);
    return (value)=>{
        if (a) a(value);
        if (b) b(value);
    };
}
/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */ function $950969aa8a9dbb93$var$useMergedRefs(refA, refB) {
    return (0, $kc00y.useMemo)(()=>$950969aa8a9dbb93$export$c9058316764c140e(refA, refB), [
        refA,
        refB
    ]);
}
var $950969aa8a9dbb93$export$2e2bcd8739ae039 = $950969aa8a9dbb93$var$useMergedRefs;



var $kc00y = parcelRequire("kc00y");
function $db979b0b72de6377$export$2e2bcd8739ae039(value) {
    const valueRef = (0, $kc00y.useRef)(value);
    valueRef.current = value;
    return valueRef;
}



var $kc00y = parcelRequire("kc00y");
function $580a01bf10c105ab$export$2e2bcd8739ae039(fn) {
    const onUnmount = (0, $db979b0b72de6377$export$2e2bcd8739ae039)(fn);
    (0, $kc00y.useEffect)(()=>()=>onUnmount.current(), []);
}



function $e7ac5c17fb23e752$export$2e2bcd8739ae039(node) {
    var doc = (0, $3b44b30b48869541$export$2e2bcd8739ae039)(node);
    return doc && doc.defaultView || window;
}


function $dd46c661049de2d8$export$2e2bcd8739ae039(node, psuedoElement) {
    return (0, $e7ac5c17fb23e752$export$2e2bcd8739ae039)(node).getComputedStyle(node, psuedoElement);
}


/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */ var $1a7fbd44a031175e$var$rUpper = /([A-Z])/g;
function $1a7fbd44a031175e$export$2e2bcd8739ae039(string) {
    return string.replace($1a7fbd44a031175e$var$rUpper, '-$1').toLowerCase();
}


var $e762f84c74a0ba6d$var$msPattern = /^ms-/;
function $e762f84c74a0ba6d$export$2e2bcd8739ae039(string) {
    return (0, $1a7fbd44a031175e$export$2e2bcd8739ae039)(string).replace($e762f84c74a0ba6d$var$msPattern, '-ms-');
}


var $ebbe43ccd468b44c$var$supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
function $ebbe43ccd468b44c$export$2e2bcd8739ae039(value) {
    return !!(value && $ebbe43ccd468b44c$var$supportedTransforms.test(value));
}


function $8f85a640dc294d7f$var$style(node, property) {
    var css = '';
    var transforms = '';
    if (typeof property === 'string') return node.style.getPropertyValue((0, $e762f84c74a0ba6d$export$2e2bcd8739ae039)(property)) || (0, $dd46c661049de2d8$export$2e2bcd8739ae039)(node).getPropertyValue((0, $e762f84c74a0ba6d$export$2e2bcd8739ae039)(property));
    Object.keys(property).forEach(function(key) {
        var value = property[key];
        if (!value && value !== 0) node.style.removeProperty((0, $e762f84c74a0ba6d$export$2e2bcd8739ae039)(key));
        else if ((0, $ebbe43ccd468b44c$export$2e2bcd8739ae039)(key)) transforms += key + "(" + value + ") ";
        else css += (0, $e762f84c74a0ba6d$export$2e2bcd8739ae039)(key) + ": " + value + ";";
    });
    if (transforms) css += "transform: " + transforms + ";";
    node.style.cssText += ";" + css;
}
var $8f85a640dc294d7f$export$2e2bcd8739ae039 = $8f85a640dc294d7f$var$style;




function $f36f0227633f632b$var$listen(node, eventName, handler, options) {
    (0, $c414e224cd570c88$export$2e2bcd8739ae039)(node, eventName, handler, options);
    return function() {
        (0, $21bd0a760d3f2599$export$2e2bcd8739ae039)(node, eventName, handler, options);
    };
}
var $f36f0227633f632b$export$2e2bcd8739ae039 = $f36f0227633f632b$var$listen;


/**
 * Triggers an event on a given element.
 * 
 * @param node the element
 * @param eventName the event name to trigger
 * @param bubbles whether the event should bubble up
 * @param cancelable whether the event should be cancelable
 */ function $f959750c44d603a2$export$2e2bcd8739ae039(node, eventName, bubbles, cancelable) {
    if (bubbles === void 0) bubbles = false;
    if (cancelable === void 0) cancelable = true;
    if (node) {
        var event = document.createEvent('HTMLEvents');
        event.initEvent(eventName, bubbles, cancelable);
        node.dispatchEvent(event);
    }
}


function $93e7709a8ffaec4e$var$parseDuration(node) {
    var str = (0, $8f85a640dc294d7f$export$2e2bcd8739ae039)(node, 'transitionDuration') || '';
    var mult = str.indexOf('ms') === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function $93e7709a8ffaec4e$var$emulateTransitionEnd(element, duration, padding) {
    if (padding === void 0) padding = 5;
    var called = false;
    var handle = setTimeout(function() {
        if (!called) (0, $f959750c44d603a2$export$2e2bcd8739ae039)(element, 'transitionend', true);
    }, duration + padding);
    var remove = (0, $f36f0227633f632b$export$2e2bcd8739ae039)(element, 'transitionend', function() {
        called = true;
    }, {
        once: true
    });
    return function() {
        clearTimeout(handle);
        remove();
    };
}
function $93e7709a8ffaec4e$export$2e2bcd8739ae039(element, handler, duration, padding) {
    if (duration == null) duration = $93e7709a8ffaec4e$var$parseDuration(element) || 0;
    var removeEmulate = $93e7709a8ffaec4e$var$emulateTransitionEnd(element, duration, padding);
    var remove = (0, $f36f0227633f632b$export$2e2bcd8739ae039)(element, 'transitionend', handler);
    return function() {
        removeEmulate();
        remove();
    };
}



var $kc00y = parcelRequire("kc00y");

function $4c7192fc72d10e28$export$2e2bcd8739ae039(doc) {
    if (doc === void 0) doc = (0, $3b44b30b48869541$export$2e2bcd8739ae039)();
    // Support: IE 9 only
    // IE9 throws an "Unspecified error" accessing document.activeElement from an <iframe>
    try {
        var active = doc.activeElement; // IE11 returns a seemingly empty object in some cases when accessing
        // document.activeElement from an <iframe>
        if (!active || !active.nodeName) return null;
        return active;
    } catch (e) {
        /* ie throws if no active element */ return doc.body;
    }
}


/* eslint-disable no-bitwise, no-cond-assign */ /**
 * Checks if an element contains another given element.
 * 
 * @param context the context element
 * @param node the element to check
 */ function $1416702938ee6af3$export$2e2bcd8739ae039(context, node) {
    // HTML DOM and SVG DOM may have different support levels,
    // so we need to check on context instead of a document root element.
    if (context.contains) return context.contains(node);
    if (context.compareDocumentPosition) return context === node || !!(context.compareDocumentPosition(node) & 16);
}





var $kc00y = parcelRequire("kc00y");


var $kc00y = parcelRequire("kc00y");
function $05ea5591019bd8c4$export$2e2bcd8739ae039() {
    const mounted = (0, $kc00y.useRef)(true);
    const isMounted = (0, $kc00y.useRef)(()=>mounted.current);
    (0, $kc00y.useEffect)(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    return isMounted.current;
}



var $kc00y = parcelRequire("kc00y");
function $74583fc47e953773$export$2e2bcd8739ae039(value) {
    const valueRef = (0, $kc00y.useRef)(value);
    valueRef.current = value;
    return valueRef;
}



var $kc00y = parcelRequire("kc00y");
function $acbfe4e2e1cdfea4$export$2e2bcd8739ae039(fn) {
    const onUnmount = (0, $74583fc47e953773$export$2e2bcd8739ae039)(fn);
    (0, $kc00y.useEffect)(()=>()=>onUnmount.current(), []);
}



var $kc00y = parcelRequire("kc00y");
function $5c0ae6e770e05919$export$2e2bcd8739ae039(value) {
    const ref = (0, $kc00y.useRef)(null);
    (0, $kc00y.useEffect)(()=>{
        ref.current = value;
    });
    return ref.current;
}



var $kc00y = parcelRequire("kc00y");

var $kc00y = parcelRequire("kc00y");
/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */ function $52026e7d7af8fa9c$var$useCommittedRef(value) {
    const ref = (0, $kc00y.useRef)(value);
    (0, $kc00y.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}
var $52026e7d7af8fa9c$export$2e2bcd8739ae039 = $52026e7d7af8fa9c$var$useCommittedRef;


function $0261b276e783eb4f$export$2e2bcd8739ae039(fn) {
    const ref = (0, $52026e7d7af8fa9c$export$2e2bcd8739ae039)(fn);
    return (0, $kc00y.useCallback)(function(...args) {
        return ref.current && ref.current(...args);
    }, [
        ref
    ]);
}



const $53889a51b2c4b977$export$fd7bcb7e9bef4e8a = `data-rr-ui-`;
const $53889a51b2c4b977$export$635202801f9383a0 = `rrUi`;
function $53889a51b2c4b977$export$5cc3b7b83e34ade7(property) {
    return `${$53889a51b2c4b977$export$fd7bcb7e9bef4e8a}${property}`;
}
function $53889a51b2c4b977$export$7776c0a7cd2eb3e0(property) {
    return `${$53889a51b2c4b977$export$635202801f9383a0}${property}`;
}


/**
 * Get the width of the vertical window scrollbar if it's visible
 */ function $4b0c6ee675688784$export$2e2bcd8739ae039(ownerDocument = document) {
    const window = ownerDocument.defaultView;
    return Math.abs(window.innerWidth - ownerDocument.documentElement.clientWidth);
}


const $e44ffbce266e7c34$export$1a88c12b8b979fa0 = (0, $53889a51b2c4b977$export$5cc3b7b83e34ade7)('modal-open');
/**
 * Manages a stack of Modals as well as ensuring
 * body scrolling is is disabled and padding accounted for
 */ class $e44ffbce266e7c34$var$ModalManager {
    constructor({ ownerDocument: ownerDocument, handleContainerOverflow: handleContainerOverflow = true, isRTL: isRTL = false } = {}){
        this.handleContainerOverflow = handleContainerOverflow;
        this.isRTL = isRTL;
        this.modals = [];
        this.ownerDocument = ownerDocument;
    }
    getScrollbarWidth() {
        return (0, $4b0c6ee675688784$export$2e2bcd8739ae039)(this.ownerDocument);
    }
    getElement() {
        return (this.ownerDocument || document).body;
    }
    setModalAttributes(_modal) {
    // For overriding
    }
    removeModalAttributes(_modal) {
    // For overriding
    }
    setContainerStyle(containerState) {
        const style = {
            overflow: 'hidden'
        };
        // we are only interested in the actual `style` here
        // because we will override it
        const paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
        const container = this.getElement();
        containerState.style = {
            overflow: container.style.overflow,
            [paddingProp]: container.style[paddingProp]
        };
        if (containerState.scrollBarWidth) // use computed style, here to get the real padding
        // to add our scrollbar width
        style[paddingProp] = `${parseInt((0, $8f85a640dc294d7f$export$2e2bcd8739ae039)(container, paddingProp) || '0', 10) + containerState.scrollBarWidth}px`;
        container.setAttribute($e44ffbce266e7c34$export$1a88c12b8b979fa0, '');
        (0, $8f85a640dc294d7f$export$2e2bcd8739ae039)(container, style);
    }
    reset() {
        [
            ...this.modals
        ].forEach((m)=>this.remove(m));
    }
    removeContainerStyle(containerState) {
        const container = this.getElement();
        container.removeAttribute($e44ffbce266e7c34$export$1a88c12b8b979fa0);
        Object.assign(container.style, containerState.style);
    }
    add(modal) {
        let modalIdx = this.modals.indexOf(modal);
        if (modalIdx !== -1) return modalIdx;
        modalIdx = this.modals.length;
        this.modals.push(modal);
        this.setModalAttributes(modal);
        if (modalIdx !== 0) return modalIdx;
        this.state = {
            scrollBarWidth: this.getScrollbarWidth(),
            style: {}
        };
        if (this.handleContainerOverflow) this.setContainerStyle(this.state);
        return modalIdx;
    }
    remove(modal) {
        const modalIdx = this.modals.indexOf(modal);
        if (modalIdx === -1) return;
        this.modals.splice(modalIdx, 1);
        // if that was the last modal in a container,
        // clean up the container
        if (!this.modals.length && this.handleContainerOverflow) this.removeContainerStyle(this.state);
        this.removeModalAttributes(modal);
    }
    isTopModal(modal) {
        return !!this.modals.length && this.modals[this.modals.length - 1] === modal;
    }
}
var $e44ffbce266e7c34$export$2e2bcd8739ae039 = $e44ffbce266e7c34$var$ModalManager;





var $kc00y = parcelRequire("kc00y");

var $kc00y = parcelRequire("kc00y");

const $4cbb0ff85b062c6d$var$Context = /*#__PURE__*/ (0, $kc00y.createContext)((0, $aa5eecc52b084e6f$export$2e2bcd8739ae039) ? window : undefined);
const $4cbb0ff85b062c6d$export$f7d306aeb1cf5fbc = $4cbb0ff85b062c6d$var$Context.Provider;
function $4cbb0ff85b062c6d$export$2e2bcd8739ae039() {
    return (0, $kc00y.useContext)($4cbb0ff85b062c6d$var$Context);
}


const $7297954784ff1701$export$c91fd81e6d65f84a = (ref, document)=>{
    if (!(0, $aa5eecc52b084e6f$export$2e2bcd8739ae039)) return null;
    if (ref == null) return (document || (0, $3b44b30b48869541$export$2e2bcd8739ae039)()).body;
    if (typeof ref === 'function') ref = ref();
    if (ref && 'current' in ref) ref = ref.current;
    if (ref && ('nodeType' in ref || ref.getBoundingClientRect)) return ref;
    return null;
};
function $7297954784ff1701$export$2e2bcd8739ae039(ref, onResolved) {
    const window = (0, $4cbb0ff85b062c6d$export$2e2bcd8739ae039)();
    const [resolvedRef, setRef] = (0, $kc00y.useState)(()=>$7297954784ff1701$export$c91fd81e6d65f84a(ref, window == null ? void 0 : window.document));
    if (!resolvedRef) {
        const earlyRef = $7297954784ff1701$export$c91fd81e6d65f84a(ref);
        if (earlyRef) setRef(earlyRef);
    }
    (0, $kc00y.useEffect)(()=>{
        if (onResolved && resolvedRef) onResolved(resolvedRef);
    }, [
        onResolved,
        resolvedRef
    ]);
    (0, $kc00y.useEffect)(()=>{
        const nextRef = $7297954784ff1701$export$c91fd81e6d65f84a(ref);
        if (nextRef !== resolvedRef) setRef(nextRef);
    }, [
        ref,
        resolvedRef
    ]);
    return resolvedRef;
}




var $kc00y = parcelRequire("kc00y");
const $e83f66af48ac0793$var$toFnRef = (ref)=>!ref || typeof ref === 'function' ? ref : (value)=>{
        ref.current = value;
    };
function $e83f66af48ac0793$export$c9058316764c140e(refA, refB) {
    const a = $e83f66af48ac0793$var$toFnRef(refA);
    const b = $e83f66af48ac0793$var$toFnRef(refB);
    return (value)=>{
        if (a) a(value);
        if (b) b(value);
    };
}
/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */ function $e83f66af48ac0793$var$useMergedRefs(refA, refB) {
    return (0, $kc00y.useMemo)(()=>$e83f66af48ac0793$export$c9058316764c140e(refA, refB), [
        refA,
        refB
    ]);
}
var $e83f66af48ac0793$export$2e2bcd8739ae039 = $e83f66af48ac0793$var$useMergedRefs;




var $kc00y = parcelRequire("kc00y");
const $c09ab3415be1be37$var$isReactNative = typeof $parcel$global !== 'undefined' && // @ts-ignore
$parcel$global.navigator && // @ts-ignore
$parcel$global.navigator.product === 'ReactNative';
const $c09ab3415be1be37$var$isDOM = typeof document !== 'undefined';
var /**
 * Is `useLayoutEffect` in a DOM or React Native environment, otherwise resolves to useEffect
 * Only useful to avoid the console warning.
 *
 * PREFER `useEffect` UNLESS YOU KNOW WHAT YOU ARE DOING.
 *
 * @category effects
 */ $c09ab3415be1be37$export$2e2bcd8739ae039 = $c09ab3415be1be37$var$isDOM || $c09ab3415be1be37$var$isReactNative ? (0, $kc00y.useLayoutEffect) : (0, $kc00y.useEffect);



var $kc00y = parcelRequire("kc00y");



var $kc00y = parcelRequire("kc00y");

var $kc00y = parcelRequire("kc00y");
function $91d5586e687d56e1$export$806fcc22e55e107d(e) {
    return e.code === 'Escape' || e.keyCode === 27;
}
function $91d5586e687d56e1$export$13e065f3a74cfe36() {
    const parts = $kc00y.version.split('.');
    return {
        major: +parts[0],
        minor: +parts[1],
        patch: +parts[2]
    };
}
function $91d5586e687d56e1$export$87943f2672146d57(element) {
    if (!element || typeof element === 'function') return null;
    const { major: major } = $91d5586e687d56e1$export$13e065f3a74cfe36();
    const childRef = major >= 19 ? element.props.ref : element.ref;
    return childRef;
}


function $45ae2d5550567d5b$var$NoopTransition({ children: children, in: inProp, onExited: onExited, mountOnEnter: mountOnEnter, unmountOnExit: unmountOnExit }) {
    const ref = (0, $kc00y.useRef)(null);
    const hasEnteredRef = (0, $kc00y.useRef)(inProp);
    const handleExited = (0, $0261b276e783eb4f$export$2e2bcd8739ae039)(onExited);
    (0, $kc00y.useEffect)(()=>{
        if (inProp) hasEnteredRef.current = true;
        else handleExited(ref.current);
    }, [
        inProp,
        handleExited
    ]);
    const combinedRef = (0, $e83f66af48ac0793$export$2e2bcd8739ae039)(ref, (0, $91d5586e687d56e1$export$87943f2672146d57)(children));
    const child = /*#__PURE__*/ (0, $kc00y.cloneElement)(children, {
        ref: combinedRef
    });
    if (inProp) return child;
    if (unmountOnExit) return null;
    if (!hasEnteredRef.current && mountOnEnter) return null;
    return child;
}
var $45ae2d5550567d5b$export$2e2bcd8739ae039 = $45ae2d5550567d5b$var$NoopTransition;



var $kc00y = parcelRequire("kc00y");

var $kc00y = parcelRequire("kc00y");


const $a7850a69bb625769$var$_excluded = [
    "onEnter",
    "onEntering",
    "onEntered",
    "onExit",
    "onExiting",
    "onExited",
    "addEndListener",
    "children"
];
function $a7850a69bb625769$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $a7850a69bb625769$export$2e2bcd8739ae039(_ref) {
    let { onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited, addEndListener: addEndListener, children: children } = _ref, props = $a7850a69bb625769$var$_objectWithoutPropertiesLoose(_ref, $a7850a69bb625769$var$_excluded);
    const nodeRef = (0, $kc00y.useRef)(null);
    const mergedRef = (0, $e83f66af48ac0793$export$2e2bcd8739ae039)(nodeRef, (0, $91d5586e687d56e1$export$87943f2672146d57)(children));
    const normalize = (callback)=>(param)=>{
            if (callback && nodeRef.current) callback(nodeRef.current, param);
        };
    /* eslint-disable react-hooks/exhaustive-deps */ const handleEnter = (0, $kc00y.useCallback)(normalize(onEnter), [
        onEnter
    ]);
    const handleEntering = (0, $kc00y.useCallback)(normalize(onEntering), [
        onEntering
    ]);
    const handleEntered = (0, $kc00y.useCallback)(normalize(onEntered), [
        onEntered
    ]);
    const handleExit = (0, $kc00y.useCallback)(normalize(onExit), [
        onExit
    ]);
    const handleExiting = (0, $kc00y.useCallback)(normalize(onExiting), [
        onExiting
    ]);
    const handleExited = (0, $kc00y.useCallback)(normalize(onExited), [
        onExited
    ]);
    const handleAddEndListener = (0, $kc00y.useCallback)(normalize(addEndListener), [
        addEndListener
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ return Object.assign({}, props, {
        nodeRef: nodeRef
    }, onEnter && {
        onEnter: handleEnter
    }, onEntering && {
        onEntering: handleEntering
    }, onEntered && {
        onEntered: handleEntered
    }, onExit && {
        onExit: handleExit
    }, onExiting && {
        onExiting: handleExiting
    }, onExited && {
        onExited: handleExited
    }, addEndListener && {
        addEndListener: handleAddEndListener
    }, {
        children: typeof children === 'function' ? (status, innerProps)=>// TODO: Types for RTG missing innerProps, so need to cast.
            children(status, Object.assign({}, innerProps, {
                ref: mergedRef
            })) : /*#__PURE__*/ (0, $kc00y.cloneElement)(children, {
            ref: mergedRef
        })
    });
}



const $897ea3fa6afa4456$var$_excluded = [
    "component"
];
function $897ea3fa6afa4456$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
// Normalizes Transition callbacks when nodeRef is used.
const $897ea3fa6afa4456$var$RTGTransition = /*#__PURE__*/ $kc00y.forwardRef((_ref, ref)=>{
    let { component: Component } = _ref, props = $897ea3fa6afa4456$var$_objectWithoutPropertiesLoose(_ref, $897ea3fa6afa4456$var$_excluded);
    const transitionProps = (0, $a7850a69bb625769$export$2e2bcd8739ae039)(props);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)(Component, Object.assign({
        ref: ref
    }, transitionProps));
});
var $897ea3fa6afa4456$export$2e2bcd8739ae039 = $897ea3fa6afa4456$var$RTGTransition;




function $f7bb0e3ef4a0f95f$export$7b286972b8d8ccbf({ in: inProp, onTransition: onTransition }) {
    const ref = (0, $kc00y.useRef)(null);
    const isInitialRef = (0, $kc00y.useRef)(true);
    const handleTransition = (0, $0261b276e783eb4f$export$2e2bcd8739ae039)(onTransition);
    (0, $c09ab3415be1be37$export$2e2bcd8739ae039)(()=>{
        if (!ref.current) return undefined;
        let stale = false;
        handleTransition({
            in: inProp,
            element: ref.current,
            initial: isInitialRef.current,
            isStale: ()=>stale
        });
        return ()=>{
            stale = true;
        };
    }, [
        inProp,
        handleTransition
    ]);
    (0, $c09ab3415be1be37$export$2e2bcd8739ae039)(()=>{
        isInitialRef.current = false;
        // this is for strict mode
        return ()=>{
            isInitialRef.current = true;
        };
    }, []);
    return ref;
}
function $f7bb0e3ef4a0f95f$export$2e2bcd8739ae039({ children: children, in: inProp, onExited: onExited, onEntered: onEntered, transition: transition }) {
    const [exited, setExited] = (0, $kc00y.useState)(!inProp);
    // TODO: I think this needs to be in an effect
    if (inProp && exited) setExited(false);
    const ref = $f7bb0e3ef4a0f95f$export$7b286972b8d8ccbf({
        in: !!inProp,
        onTransition: (options)=>{
            const onFinish = ()=>{
                if (options.isStale()) return;
                if (options.in) onEntered == null || onEntered(options.element, options.initial);
                else {
                    setExited(true);
                    onExited == null || onExited(options.element);
                }
            };
            Promise.resolve(transition(options)).then(onFinish, (error)=>{
                if (!options.in) setExited(true);
                throw error;
            });
        }
    });
    const combinedRef = (0, $e83f66af48ac0793$export$2e2bcd8739ae039)(ref, (0, $91d5586e687d56e1$export$87943f2672146d57)(children));
    return exited && !inProp ? null : /*#__PURE__*/ (0, $kc00y.cloneElement)(children, {
        ref: combinedRef
    });
}
function $f7bb0e3ef4a0f95f$export$f41d64aae6d6dba5(component, runTransition, props) {
    if (component) return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $897ea3fa6afa4456$export$2e2bcd8739ae039), Object.assign({}, props, {
        component: component
    }));
    if (runTransition) return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($f7bb0e3ef4a0f95f$export$2e2bcd8739ae039, Object.assign({}, props, {
        transition: runTransition
    }));
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $45ae2d5550567d5b$export$2e2bcd8739ae039), Object.assign({}, props));
}




const $38ebb733d4e3053f$var$_excluded = [
    "show",
    "role",
    "className",
    "style",
    "children",
    "backdrop",
    "keyboard",
    "onBackdropClick",
    "onEscapeKeyDown",
    "transition",
    "runTransition",
    "backdropTransition",
    "runBackdropTransition",
    "autoFocus",
    "enforceFocus",
    "restoreFocus",
    "restoreFocusOptions",
    "renderDialog",
    "renderBackdrop",
    "manager",
    "container",
    "onShow",
    "onHide",
    "onExit",
    "onExited",
    "onExiting",
    "onEnter",
    "onEntering",
    "onEntered"
];
function $38ebb733d4e3053f$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
let $38ebb733d4e3053f$var$manager;
/*
  Modal props are split into a version with and without index signature so that you can fully use them in another projects
  This is due to Typescript not playing well with index signatures e.g. when using Omit
*/ function $38ebb733d4e3053f$var$getManager(window) {
    if (!$38ebb733d4e3053f$var$manager) $38ebb733d4e3053f$var$manager = new (0, $e44ffbce266e7c34$export$2e2bcd8739ae039)({
        ownerDocument: window == null ? void 0 : window.document
    });
    return $38ebb733d4e3053f$var$manager;
}
function $38ebb733d4e3053f$var$useModalManager(provided) {
    const window = (0, $4cbb0ff85b062c6d$export$2e2bcd8739ae039)();
    const modalManager = provided || $38ebb733d4e3053f$var$getManager(window);
    const modal = (0, $kc00y.useRef)({
        dialog: null,
        backdrop: null
    });
    return Object.assign(modal.current, {
        add: ()=>modalManager.add(modal.current),
        remove: ()=>modalManager.remove(modal.current),
        isTopModal: ()=>modalManager.isTopModal(modal.current),
        setDialogRef: (0, $kc00y.useCallback)((ref)=>{
            modal.current.dialog = ref;
        }, []),
        setBackdropRef: (0, $kc00y.useCallback)((ref)=>{
            modal.current.backdrop = ref;
        }, [])
    });
}
const $38ebb733d4e3053f$var$Modal = /*#__PURE__*/ (0, $kc00y.forwardRef)((_ref, ref)=>{
    let { show: show = false, role: role = 'dialog', className: className, style: style, children: children, backdrop: backdrop = true, keyboard: keyboard = true, onBackdropClick: onBackdropClick, onEscapeKeyDown: onEscapeKeyDown, transition: transition, runTransition: runTransition, backdropTransition: backdropTransition, runBackdropTransition: runBackdropTransition, autoFocus: autoFocus = true, enforceFocus: enforceFocus = true, restoreFocus: restoreFocus = true, restoreFocusOptions: restoreFocusOptions, renderDialog: renderDialog, renderBackdrop: renderBackdrop = (props)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", Object.assign({}, props)), manager: providedManager, container: containerRef, onShow: onShow, onHide: onHide = ()=>{}, onExit: onExit, onExited: onExited, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onEntered: onEntered } = _ref, rest = $38ebb733d4e3053f$var$_objectWithoutPropertiesLoose(_ref, $38ebb733d4e3053f$var$_excluded);
    const ownerWindow = (0, $4cbb0ff85b062c6d$export$2e2bcd8739ae039)();
    const container = (0, $7297954784ff1701$export$2e2bcd8739ae039)(containerRef);
    const modal = $38ebb733d4e3053f$var$useModalManager(providedManager);
    const isMounted = (0, $05ea5591019bd8c4$export$2e2bcd8739ae039)();
    const prevShow = (0, $5c0ae6e770e05919$export$2e2bcd8739ae039)(show);
    const [exited, setExited] = (0, $kc00y.useState)(!show);
    const lastFocusRef = (0, $kc00y.useRef)(null);
    (0, $kc00y.useImperativeHandle)(ref, ()=>modal, [
        modal
    ]);
    if ((0, $aa5eecc52b084e6f$export$2e2bcd8739ae039) && !prevShow && show) lastFocusRef.current = (0, $4c7192fc72d10e28$export$2e2bcd8739ae039)(ownerWindow == null ? void 0 : ownerWindow.document);
    // TODO: I think this needs to be in an effect
    if (show && exited) setExited(false);
    const handleShow = (0, $0261b276e783eb4f$export$2e2bcd8739ae039)(()=>{
        modal.add();
        removeKeydownListenerRef.current = (0, $f36f0227633f632b$export$2e2bcd8739ae039)(document, 'keydown', handleDocumentKeyDown);
        removeFocusListenerRef.current = (0, $f36f0227633f632b$export$2e2bcd8739ae039)(document, 'focus', // the timeout is necessary b/c this will run before the new modal is mounted
        // and so steals focus from it
        ()=>setTimeout(handleEnforceFocus), true);
        if (onShow) onShow();
        // autofocus after onShow to not trigger a focus event for previous
        // modals before this one is shown.
        if (autoFocus) {
            var _modal$dialog$ownerDo, _modal$dialog;
            const currentActiveElement = (0, $4c7192fc72d10e28$export$2e2bcd8739ae039)((_modal$dialog$ownerDo = (_modal$dialog = modal.dialog) == null ? void 0 : _modal$dialog.ownerDocument) != null ? _modal$dialog$ownerDo : ownerWindow == null ? void 0 : ownerWindow.document);
            if (modal.dialog && currentActiveElement && !(0, $1416702938ee6af3$export$2e2bcd8739ae039)(modal.dialog, currentActiveElement)) {
                lastFocusRef.current = currentActiveElement;
                modal.dialog.focus();
            }
        }
    });
    const handleHide = (0, $0261b276e783eb4f$export$2e2bcd8739ae039)(()=>{
        modal.remove();
        removeKeydownListenerRef.current == null || removeKeydownListenerRef.current();
        removeFocusListenerRef.current == null || removeFocusListenerRef.current();
        if (restoreFocus) {
            var _lastFocusRef$current;
            // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
            (_lastFocusRef$current = lastFocusRef.current) == null || _lastFocusRef$current.focus == null || _lastFocusRef$current.focus(restoreFocusOptions);
            lastFocusRef.current = null;
        }
    });
    // TODO: try and combine these effects: https://github.com/react-bootstrap/react-overlays/pull/794#discussion_r409954120
    // Show logic when:
    //  - show is `true` _and_ `container` has resolved
    (0, $kc00y.useEffect)(()=>{
        if (!show || !container) return;
        handleShow();
    }, [
        show,
        container,
        /* should never change: */ handleShow
    ]);
    // Hide cleanup logic when:
    //  - `exited` switches to true
    //  - component unmounts;
    (0, $kc00y.useEffect)(()=>{
        if (!exited) return;
        handleHide();
    }, [
        exited,
        handleHide
    ]);
    (0, $acbfe4e2e1cdfea4$export$2e2bcd8739ae039)(()=>{
        handleHide();
    });
    // --------------------------------
    const handleEnforceFocus = (0, $0261b276e783eb4f$export$2e2bcd8739ae039)(()=>{
        if (!enforceFocus || !isMounted() || !modal.isTopModal()) return;
        const currentActiveElement = (0, $4c7192fc72d10e28$export$2e2bcd8739ae039)(ownerWindow == null ? void 0 : ownerWindow.document);
        if (modal.dialog && currentActiveElement && !(0, $1416702938ee6af3$export$2e2bcd8739ae039)(modal.dialog, currentActiveElement)) modal.dialog.focus();
    });
    const handleBackdropClick = (0, $0261b276e783eb4f$export$2e2bcd8739ae039)((e)=>{
        if (e.target !== e.currentTarget) return;
        onBackdropClick == null || onBackdropClick(e);
        if (backdrop === true) onHide();
    });
    const handleDocumentKeyDown = (0, $0261b276e783eb4f$export$2e2bcd8739ae039)((e)=>{
        if (keyboard && (0, $91d5586e687d56e1$export$806fcc22e55e107d)(e) && modal.isTopModal()) {
            onEscapeKeyDown == null || onEscapeKeyDown(e);
            if (!e.defaultPrevented) onHide();
        }
    });
    const removeFocusListenerRef = (0, $kc00y.useRef)();
    const removeKeydownListenerRef = (0, $kc00y.useRef)();
    const handleHidden = (...args)=>{
        setExited(true);
        onExited == null || onExited(...args);
    };
    if (!container) return null;
    const dialogProps = Object.assign({
        role: role,
        ref: modal.setDialogRef,
        // apparently only works on the dialog role element
        'aria-modal': role === 'dialog' ? true : undefined
    }, rest, {
        style: style,
        className: className,
        tabIndex: -1
    });
    let dialog = renderDialog ? renderDialog(dialogProps) : /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", Object.assign({}, dialogProps, {
        children: /*#__PURE__*/ $kc00y.cloneElement(children, {
            role: 'document'
        })
    }));
    dialog = (0, $f7bb0e3ef4a0f95f$export$f41d64aae6d6dba5)(transition, runTransition, {
        unmountOnExit: true,
        mountOnEnter: true,
        appear: true,
        in: !!show,
        onExit: onExit,
        onExiting: onExiting,
        onExited: handleHidden,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered,
        children: dialog
    });
    let backdropElement = null;
    if (backdrop) {
        backdropElement = renderBackdrop({
            ref: modal.setBackdropRef,
            onClick: handleBackdropClick
        });
        backdropElement = (0, $f7bb0e3ef4a0f95f$export$f41d64aae6d6dba5)(backdropTransition, runBackdropTransition, {
            in: !!show,
            appear: true,
            mountOnEnter: true,
            unmountOnExit: true,
            children: backdropElement
        });
    }
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9018fd8b87cabbb7$exports))).createPortal(/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
            children: [
                backdropElement,
                dialog
            ]
        }), container)
    });
});
$38ebb733d4e3053f$var$Modal.displayName = 'Modal';
var $38ebb733d4e3053f$export$2e2bcd8739ae039 = Object.assign($38ebb733d4e3053f$var$Modal, {
    Manager: (0, $e44ffbce266e7c34$export$2e2bcd8739ae039)
});


/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $c6f47c13d4796d39$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}


function $a80b022aa5789286$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $c6f47c13d4796d39$export$2e2bcd8739ae039)(element, className)) {
        if (typeof element.className === 'string') element.className = element.className + " " + className;
        else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
    }
}



var $f666525aadfce5dc$var$toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
function $f666525aadfce5dc$export$2e2bcd8739ae039(element, selector) {
    return $f666525aadfce5dc$var$toArray(element.querySelectorAll(selector));
}


function $1bc98b03a1c48f7b$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
function $1bc98b03a1c48f7b$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === 'string') element.className = $1bc98b03a1c48f7b$var$replaceClassName(element.className, className);
    else element.setAttribute('class', $1bc98b03a1c48f7b$var$replaceClassName(element.className && element.className.baseVal || '', className));
}



const $51c7d6344e391079$var$Selector = {
    FIXED_CONTENT: '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top',
    STICKY_CONTENT: '.sticky-top',
    NAVBAR_TOGGLER: '.navbar-toggler'
};
class $51c7d6344e391079$var$BootstrapModalManager extends (0, $e44ffbce266e7c34$export$2e2bcd8739ae039) {
    adjustAndStore(prop, element, adjust) {
        const actual = element.style[prop];
        // @ts-expect-error TODO: DOMStringMap and CSSStyleDeclaration aren't strictly compatible
        element.dataset[prop] = actual;
        (0, $8f85a640dc294d7f$export$2e2bcd8739ae039)(element, {
            [prop]: `${parseFloat((0, $8f85a640dc294d7f$export$2e2bcd8739ae039)(element, prop)) + adjust}px`
        });
    }
    restore(prop, element) {
        const value = element.dataset[prop];
        if (value !== undefined) {
            delete element.dataset[prop];
            (0, $8f85a640dc294d7f$export$2e2bcd8739ae039)(element, {
                [prop]: value
            });
        }
    }
    setContainerStyle(containerState) {
        super.setContainerStyle(containerState);
        const container = this.getElement();
        (0, $a80b022aa5789286$export$2e2bcd8739ae039)(container, 'modal-open');
        if (!containerState.scrollBarWidth) return;
        const paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
        const marginProp = this.isRTL ? 'marginLeft' : 'marginRight';
        (0, $f666525aadfce5dc$export$2e2bcd8739ae039)(container, $51c7d6344e391079$var$Selector.FIXED_CONTENT).forEach((el)=>this.adjustAndStore(paddingProp, el, containerState.scrollBarWidth));
        (0, $f666525aadfce5dc$export$2e2bcd8739ae039)(container, $51c7d6344e391079$var$Selector.STICKY_CONTENT).forEach((el)=>this.adjustAndStore(marginProp, el, -containerState.scrollBarWidth));
        (0, $f666525aadfce5dc$export$2e2bcd8739ae039)(container, $51c7d6344e391079$var$Selector.NAVBAR_TOGGLER).forEach((el)=>this.adjustAndStore(marginProp, el, containerState.scrollBarWidth));
    }
    removeContainerStyle(containerState) {
        super.removeContainerStyle(containerState);
        const container = this.getElement();
        (0, $1bc98b03a1c48f7b$export$2e2bcd8739ae039)(container, 'modal-open');
        const paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
        const marginProp = this.isRTL ? 'marginLeft' : 'marginRight';
        (0, $f666525aadfce5dc$export$2e2bcd8739ae039)(container, $51c7d6344e391079$var$Selector.FIXED_CONTENT).forEach((el)=>this.restore(paddingProp, el));
        (0, $f666525aadfce5dc$export$2e2bcd8739ae039)(container, $51c7d6344e391079$var$Selector.STICKY_CONTENT).forEach((el)=>this.restore(marginProp, el));
        (0, $f666525aadfce5dc$export$2e2bcd8739ae039)(container, $51c7d6344e391079$var$Selector.NAVBAR_TOGGLER).forEach((el)=>this.restore(marginProp, el));
    }
}
let $51c7d6344e391079$var$sharedManager;
function $51c7d6344e391079$export$a03641438014b436(options) {
    if (!$51c7d6344e391079$var$sharedManager) $51c7d6344e391079$var$sharedManager = new $51c7d6344e391079$var$BootstrapModalManager(options);
    return $51c7d6344e391079$var$sharedManager;
}
var $51c7d6344e391079$export$2e2bcd8739ae039 = $51c7d6344e391079$var$BootstrapModalManager;




var $kc00y = parcelRequire("kc00y");
function $5643d0ce020fb17f$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}


function $fa18464dbdd601aa$export$2e2bcd8739ae039(t, e) {
    return $fa18464dbdd601aa$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $fa18464dbdd601aa$export$2e2bcd8739ae039(t, e);
}


function $9edc1cf2bf13fb9a$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $fa18464dbdd601aa$export$2e2bcd8739ae039)(t, o);
}




var $kc00y = parcelRequire("kc00y");

var $00acbc264eaf1494$export$2e2bcd8739ae039 = {
    disabled: false
};




var $kc00y = parcelRequire("kc00y");
var $dc14543d3e286a0d$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createContext(null);


var $5cb2e9dd64739893$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $92dadb5ebc6bf1cd$export$bb38bb9a1161268 = 'unmounted';
var $92dadb5ebc6bf1cd$export$84cbff306f539230 = 'exited';
var $92dadb5ebc6bf1cd$export$df38205c966be359 = 'entering';
var $92dadb5ebc6bf1cd$export$78e9e6e3e014d60a = 'entered';
var $92dadb5ebc6bf1cd$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $92dadb5ebc6bf1cd$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $9edc1cf2bf13fb9a$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $92dadb5ebc6bf1cd$export$84cbff306f539230;
                _this.appearStatus = $92dadb5ebc6bf1cd$export$df38205c966be359;
            } else initialStatus = $92dadb5ebc6bf1cd$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $92dadb5ebc6bf1cd$export$bb38bb9a1161268;
        else initialStatus = $92dadb5ebc6bf1cd$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $92dadb5ebc6bf1cd$export$bb38bb9a1161268) return {
            status: $92dadb5ebc6bf1cd$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $92dadb5ebc6bf1cd$export$df38205c966be359 && status !== $92dadb5ebc6bf1cd$export$78e9e6e3e014d60a) nextStatus = $92dadb5ebc6bf1cd$export$df38205c966be359;
            } else if (status === $92dadb5ebc6bf1cd$export$df38205c966be359 || status === $92dadb5ebc6bf1cd$export$78e9e6e3e014d60a) nextStatus = $92dadb5ebc6bf1cd$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $92dadb5ebc6bf1cd$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($9018fd8b87cabbb7$exports))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $5cb2e9dd64739893$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $92dadb5ebc6bf1cd$export$84cbff306f539230) this.setState({
            status: $92dadb5ebc6bf1cd$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($9018fd8b87cabbb7$exports))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $00acbc264eaf1494$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $92dadb5ebc6bf1cd$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $92dadb5ebc6bf1cd$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $92dadb5ebc6bf1cd$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($9018fd8b87cabbb7$exports))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $00acbc264eaf1494$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $92dadb5ebc6bf1cd$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $92dadb5ebc6bf1cd$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $92dadb5ebc6bf1cd$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($9018fd8b87cabbb7$exports))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $92dadb5ebc6bf1cd$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $5643d0ce020fb17f$export$2e2bcd8739ae039)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement((0, $dc14543d3e286a0d$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).Component);
$92dadb5ebc6bf1cd$var$Transition.contextType = (0, $dc14543d3e286a0d$export$2e2bcd8739ae039);
$92dadb5ebc6bf1cd$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $92dadb5ebc6bf1cd$var$noop() {}
$92dadb5ebc6bf1cd$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $92dadb5ebc6bf1cd$var$noop,
    onEntering: $92dadb5ebc6bf1cd$var$noop,
    onEntered: $92dadb5ebc6bf1cd$var$noop,
    onExit: $92dadb5ebc6bf1cd$var$noop,
    onExiting: $92dadb5ebc6bf1cd$var$noop,
    onExited: $92dadb5ebc6bf1cd$var$noop
};
$92dadb5ebc6bf1cd$var$Transition.UNMOUNTED = $92dadb5ebc6bf1cd$export$bb38bb9a1161268;
$92dadb5ebc6bf1cd$var$Transition.EXITED = $92dadb5ebc6bf1cd$export$84cbff306f539230;
$92dadb5ebc6bf1cd$var$Transition.ENTERING = $92dadb5ebc6bf1cd$export$df38205c966be359;
$92dadb5ebc6bf1cd$var$Transition.ENTERED = $92dadb5ebc6bf1cd$export$78e9e6e3e014d60a;
$92dadb5ebc6bf1cd$var$Transition.EXITING = $92dadb5ebc6bf1cd$export$4aacc83d4d59139f;
var $92dadb5ebc6bf1cd$export$2e2bcd8739ae039 = $92dadb5ebc6bf1cd$var$Transition;





function $d81af195f4d05992$var$parseDuration(node, property) {
    const str = (0, $8f85a640dc294d7f$export$2e2bcd8739ae039)(node, property) || '';
    const mult = str.indexOf('ms') === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function $d81af195f4d05992$export$2e2bcd8739ae039(element, handler) {
    const duration = $d81af195f4d05992$var$parseDuration(element, 'transitionDuration');
    const delay = $d81af195f4d05992$var$parseDuration(element, 'transitionDelay');
    const remove = (0, $93e7709a8ffaec4e$export$2e2bcd8739ae039)(element, (e)=>{
        if (e.target === element) {
            remove();
            handler(e);
        }
    }, duration + delay);
}


// reading a dimension prop will cause the browser to recalculate,
// which will let our animations work
function $15b2c193227448e6$export$2e2bcd8739ae039(node) {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    node.offsetHeight;
}



var $kc00y = parcelRequire("kc00y");



function $4715ea7dc6e2917f$export$2e2bcd8739ae039(componentOrElement) {
    if (componentOrElement && 'setState' in componentOrElement) // TODO: Remove in next major.
    // eslint-disable-next-line react/no-find-dom-node
    return (0, (/*@__PURE__*/$parcel$interopDefault($9018fd8b87cabbb7$exports))).findDOMNode(componentOrElement);
    return componentOrElement != null ? componentOrElement : null;
}



"use client";
// Normalizes Transition callbacks when nodeRef is used.
const $401bdd4c2cc04a2e$var$TransitionWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).forwardRef(({ onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited, addEndListener: addEndListener, children: children, childRef: childRef, ...props }, ref)=>{
    const nodeRef = (0, $kc00y.useRef)(null);
    const mergedRef = (0, $950969aa8a9dbb93$export$2e2bcd8739ae039)(nodeRef, childRef);
    const attachRef = (r)=>{
        mergedRef((0, $4715ea7dc6e2917f$export$2e2bcd8739ae039)(r));
    };
    const normalize = (callback)=>(param)=>{
            if (callback && nodeRef.current) callback(nodeRef.current, param);
        };
    const handleEnter = (0, $kc00y.useCallback)(normalize(onEnter), [
        onEnter
    ]);
    const handleEntering = (0, $kc00y.useCallback)(normalize(onEntering), [
        onEntering
    ]);
    const handleEntered = (0, $kc00y.useCallback)(normalize(onEntered), [
        onEntered
    ]);
    const handleExit = (0, $kc00y.useCallback)(normalize(onExit), [
        onExit
    ]);
    const handleExiting = (0, $kc00y.useCallback)(normalize(onExiting), [
        onExiting
    ]);
    const handleExited = (0, $kc00y.useCallback)(normalize(onExited), [
        onExited
    ]);
    const handleAddEndListener = (0, $kc00y.useCallback)(normalize(addEndListener), [
        addEndListener
    ]);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $92dadb5ebc6bf1cd$export$2e2bcd8739ae039), {
        ref: ref,
        ...props,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        nodeRef: nodeRef,
        children: typeof children === 'function' ? (status, innerProps)=>// TODO: Types for RTG missing innerProps, so need to cast.
            children(status, {
                ...innerProps,
                ref: attachRef
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).cloneElement(children, {
            ref: attachRef
        })
    });
});
$401bdd4c2cc04a2e$var$TransitionWrapper.displayName = 'TransitionWrapper';
var $401bdd4c2cc04a2e$export$2e2bcd8739ae039 = $401bdd4c2cc04a2e$var$TransitionWrapper;



const $25d8c693c355530c$var$fadeStyles = {
    [(0, $92dadb5ebc6bf1cd$export$df38205c966be359)]: 'show',
    [(0, $92dadb5ebc6bf1cd$export$78e9e6e3e014d60a)]: 'show'
};
const $25d8c693c355530c$var$Fade = /*#__PURE__*/ $kc00y.forwardRef(({ className: className, children: children, transitionClasses: transitionClasses = {}, onEnter: onEnter, ...rest }, ref)=>{
    const props = {
        in: false,
        timeout: 300,
        mountOnEnter: false,
        unmountOnExit: false,
        appear: false,
        ...rest
    };
    const handleEnter = (0, $kc00y.useCallback)((node, isAppearing)=>{
        (0, $15b2c193227448e6$export$2e2bcd8739ae039)(node);
        onEnter == null || onEnter(node, isAppearing);
    }, [
        onEnter
    ]);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $401bdd4c2cc04a2e$export$2e2bcd8739ae039), {
        ref: ref,
        addEndListener: (0, $d81af195f4d05992$export$2e2bcd8739ae039),
        ...props,
        onEnter: handleEnter,
        childRef: (0, $91d5586e687d56e1$export$87943f2672146d57)(children),
        children: (status, innerProps)=>/*#__PURE__*/ $kc00y.cloneElement(children, {
                ...innerProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))('fade', className, children.props.className, $25d8c693c355530c$var$fadeStyles[status], transitionClasses[status])
            })
    });
});
$25d8c693c355530c$var$Fade.displayName = 'Fade';
var $25d8c693c355530c$export$2e2bcd8739ae039 = $25d8c693c355530c$var$Fade;



var $kc00y = parcelRequire("kc00y");



"use client";
const $6d3d2bbc78468a94$var$ModalBody = /*#__PURE__*/ $kc00y.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(bsPrefix, 'modal-body');
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, bsPrefix),
        ...props
    });
});
$6d3d2bbc78468a94$var$ModalBody.displayName = 'ModalBody';
var $6d3d2bbc78468a94$export$2e2bcd8739ae039 = $6d3d2bbc78468a94$var$ModalBody;



var $kc00y = parcelRequire("kc00y");
"use client";
const $515e095cb5609dfa$var$ModalContext = /*#__PURE__*/ $kc00y.createContext({
    onHide () {}
});
var $515e095cb5609dfa$export$2e2bcd8739ae039 = $515e095cb5609dfa$var$ModalContext;




var $kc00y = parcelRequire("kc00y");


"use client";
const $a1e5e61b09d62dd1$var$ModalDialog = /*#__PURE__*/ $kc00y.forwardRef(({ bsPrefix: bsPrefix, className: className, contentClassName: contentClassName, centered: centered, size: size, fullscreen: fullscreen, children: children, scrollable: scrollable, ...props }, ref)=>{
    bsPrefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(bsPrefix, 'modal');
    const dialogClass = `${bsPrefix}-dialog`;
    const fullScreenClass = typeof fullscreen === 'string' ? `${bsPrefix}-fullscreen-${fullscreen}` : `${bsPrefix}-fullscreen`;
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(dialogClass, className, size && `${bsPrefix}-${size}`, centered && `${dialogClass}-centered`, scrollable && `${dialogClass}-scrollable`, fullscreen && fullScreenClass),
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(`${bsPrefix}-content`, contentClassName),
            children: children
        })
    });
});
$a1e5e61b09d62dd1$var$ModalDialog.displayName = 'ModalDialog';
var $a1e5e61b09d62dd1$export$2e2bcd8739ae039 = $a1e5e61b09d62dd1$var$ModalDialog;



var $kc00y = parcelRequire("kc00y");



"use client";
const $6226c1f8626352b5$var$ModalFooter = /*#__PURE__*/ $kc00y.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(bsPrefix, 'modal-footer');
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, bsPrefix),
        ...props
    });
});
$6226c1f8626352b5$var$ModalFooter.displayName = 'ModalFooter';
var $6226c1f8626352b5$export$2e2bcd8739ae039 = $6226c1f8626352b5$var$ModalFooter;




var $kc00y = parcelRequire("kc00y");


var $kc00y = parcelRequire("kc00y");


var $lCkAA = parcelRequire("lCkAA");

var $kc00y = parcelRequire("kc00y");


const $80bef9dfc5e82bc1$var$propTypes = {
    /** An accessible label indicating the relevant information about the Close Button. */ 'aria-label': (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).string,
    /** A callback fired after the Close Button is clicked. */ onClick: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).func,
    /**
   * Render different color variant for the button.
   *
   * Omitting this will render the default dark color.
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).oneOf([
        'white'
    ])
};
const $80bef9dfc5e82bc1$var$CloseButton = /*#__PURE__*/ $kc00y.forwardRef(({ className: className, variant: variant, 'aria-label': ariaLabel = 'Close', ...props }, ref)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("button", {
        ref: ref,
        type: "button",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))('btn-close', variant && `btn-close-${variant}`, className),
        "aria-label": ariaLabel,
        ...props
    }));
$80bef9dfc5e82bc1$var$CloseButton.displayName = 'CloseButton';
$80bef9dfc5e82bc1$var$CloseButton.propTypes = $80bef9dfc5e82bc1$var$propTypes;
var $80bef9dfc5e82bc1$export$2e2bcd8739ae039 = $80bef9dfc5e82bc1$var$CloseButton;




"use client";
const $63ee3d51f3ee506e$var$AbstractModalHeader = /*#__PURE__*/ $kc00y.forwardRef(({ closeLabel: closeLabel = 'Close', closeVariant: closeVariant, closeButton: closeButton = false, onHide: onHide, children: children, ...props }, ref)=>{
    const context = (0, $kc00y.useContext)((0, $515e095cb5609dfa$export$2e2bcd8739ae039));
    const handleClick = (0, $4655b62db0931f1e$export$2e2bcd8739ae039)(()=>{
        context == null || context.onHide();
        onHide == null || onHide();
    });
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
        ref: ref,
        ...props,
        children: [
            children,
            closeButton && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $80bef9dfc5e82bc1$export$2e2bcd8739ae039), {
                "aria-label": closeLabel,
                variant: closeVariant,
                onClick: handleClick
            })
        ]
    });
});
$63ee3d51f3ee506e$var$AbstractModalHeader.displayName = 'AbstractModalHeader';
var $63ee3d51f3ee506e$export$2e2bcd8739ae039 = $63ee3d51f3ee506e$var$AbstractModalHeader;



"use client";
const $2df357c71d197c51$var$ModalHeader = /*#__PURE__*/ $kc00y.forwardRef(({ bsPrefix: bsPrefix, className: className, closeLabel: closeLabel = 'Close', closeButton: closeButton = false, ...props }, ref)=>{
    bsPrefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(bsPrefix, 'modal-header');
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $63ee3d51f3ee506e$export$2e2bcd8739ae039), {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, bsPrefix),
        closeLabel: closeLabel,
        closeButton: closeButton
    });
});
$2df357c71d197c51$var$ModalHeader.displayName = 'ModalHeader';
var $2df357c71d197c51$export$2e2bcd8739ae039 = $2df357c71d197c51$var$ModalHeader;



var $kc00y = parcelRequire("kc00y");


var $kc00y = parcelRequire("kc00y");


var $b5bbb0b2ce1c31b6$export$2e2bcd8739ae039 = (className)=>/*#__PURE__*/ // eslint-disable-next-line react/display-name
    $kc00y.forwardRef((p, ref)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
            ...p,
            ref: ref,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(p.className, className)
        }));




"use client";
const $84ae5a7da8af1722$var$DivStyledAsH4 = (0, $b5bbb0b2ce1c31b6$export$2e2bcd8739ae039)('h4');
const $84ae5a7da8af1722$var$ModalTitle = /*#__PURE__*/ $kc00y.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = $84ae5a7da8af1722$var$DivStyledAsH4, ...props }, ref)=>{
    bsPrefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(bsPrefix, 'modal-title');
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, bsPrefix),
        ...props
    });
});
$84ae5a7da8af1722$var$ModalTitle.displayName = 'ModalTitle';
var $84ae5a7da8af1722$export$2e2bcd8739ae039 = $84ae5a7da8af1722$var$ModalTitle;




"use client";
function $8e1f7dde30da3bf6$var$DialogTransition(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $25d8c693c355530c$export$2e2bcd8739ae039), {
        ...props,
        timeout: null
    });
}
function $8e1f7dde30da3bf6$var$BackdropTransition(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $25d8c693c355530c$export$2e2bcd8739ae039), {
        ...props,
        timeout: null
    });
}
const $8e1f7dde30da3bf6$var$Modal = /*#__PURE__*/ $kc00y.forwardRef(({ bsPrefix: bsPrefix, className: className, style: style, dialogClassName: dialogClassName, contentClassName: contentClassName, children: children, dialogAs: Dialog = (0, $a1e5e61b09d62dd1$export$2e2bcd8739ae039), 'data-bs-theme': dataBsTheme, 'aria-labelledby': ariaLabelledby, 'aria-describedby': ariaDescribedby, 'aria-label': ariaLabel, show: /* BaseModal props */ show = false, animation: animation = true, backdrop: backdrop = true, keyboard: keyboard = true, onEscapeKeyDown: onEscapeKeyDown, onShow: onShow, onHide: onHide, container: container, autoFocus: autoFocus = true, enforceFocus: enforceFocus = true, restoreFocus: restoreFocus = true, restoreFocusOptions: restoreFocusOptions, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onExited: onExited, backdropClassName: backdropClassName, manager: propsManager, ...props }, ref)=>{
    const [modalStyle, setStyle] = (0, $kc00y.useState)({});
    const [animateStaticModal, setAnimateStaticModal] = (0, $kc00y.useState)(false);
    const waitingForMouseUpRef = (0, $kc00y.useRef)(false);
    const ignoreBackdropClickRef = (0, $kc00y.useRef)(false);
    const removeStaticModalAnimationRef = (0, $kc00y.useRef)(null);
    const [modal, setModalRef] = (0, $6a822e76c29b5649$export$2e2bcd8739ae039)();
    const mergedRef = (0, $950969aa8a9dbb93$export$2e2bcd8739ae039)(ref, setModalRef);
    const handleHide = (0, $4655b62db0931f1e$export$2e2bcd8739ae039)(onHide);
    const isRTL = (0, $6c3886f519efe212$export$35e511eefa30ac5a)();
    bsPrefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(bsPrefix, 'modal');
    const modalContext = (0, $kc00y.useMemo)(()=>({
            onHide: handleHide
        }), [
        handleHide
    ]);
    function getModalManager() {
        if (propsManager) return propsManager;
        return (0, $51c7d6344e391079$export$a03641438014b436)({
            isRTL: isRTL
        });
    }
    function updateDialogStyle(node) {
        if (!(0, $aa5eecc52b084e6f$export$2e2bcd8739ae039)) return;
        const containerIsOverflowing = getModalManager().getScrollbarWidth() > 0;
        const modalIsOverflowing = node.scrollHeight > (0, $3b44b30b48869541$export$2e2bcd8739ae039)(node).documentElement.clientHeight;
        setStyle({
            paddingRight: containerIsOverflowing && !modalIsOverflowing ? (0, $ff8ce7114f51a84b$export$2e2bcd8739ae039)() : undefined,
            paddingLeft: !containerIsOverflowing && modalIsOverflowing ? (0, $ff8ce7114f51a84b$export$2e2bcd8739ae039)() : undefined
        });
    }
    const handleWindowResize = (0, $4655b62db0931f1e$export$2e2bcd8739ae039)(()=>{
        if (modal) updateDialogStyle(modal.dialog);
    });
    (0, $580a01bf10c105ab$export$2e2bcd8739ae039)(()=>{
        (0, $21bd0a760d3f2599$export$2e2bcd8739ae039)(window, 'resize', handleWindowResize);
        removeStaticModalAnimationRef.current == null || removeStaticModalAnimationRef.current();
    });
    // We prevent the modal from closing during a drag by detecting where the
    // click originates from. If it starts in the modal and then ends outside
    // don't close.
    const handleDialogMouseDown = ()=>{
        waitingForMouseUpRef.current = true;
    };
    const handleMouseUp = (e)=>{
        if (waitingForMouseUpRef.current && modal && e.target === modal.dialog) ignoreBackdropClickRef.current = true;
        waitingForMouseUpRef.current = false;
    };
    const handleStaticModalAnimation = ()=>{
        setAnimateStaticModal(true);
        removeStaticModalAnimationRef.current = (0, $93e7709a8ffaec4e$export$2e2bcd8739ae039)(modal.dialog, ()=>{
            setAnimateStaticModal(false);
        });
    };
    const handleStaticBackdropClick = (e)=>{
        if (e.target !== e.currentTarget) return;
        handleStaticModalAnimation();
    };
    const handleClick = (e)=>{
        if (backdrop === 'static') {
            handleStaticBackdropClick(e);
            return;
        }
        if (ignoreBackdropClickRef.current || e.target !== e.currentTarget) {
            ignoreBackdropClickRef.current = false;
            return;
        }
        onHide == null || onHide();
    };
    const handleEscapeKeyDown = (e)=>{
        if (keyboard) onEscapeKeyDown == null || onEscapeKeyDown(e);
        else {
            // Call preventDefault to stop modal from closing in @restart/ui.
            e.preventDefault();
            if (backdrop === 'static') // Play static modal animation.
            handleStaticModalAnimation();
        }
    };
    const handleEnter = (node, isAppearing)=>{
        if (node) updateDialogStyle(node);
        onEnter == null || onEnter(node, isAppearing);
    };
    const handleExit = (node)=>{
        removeStaticModalAnimationRef.current == null || removeStaticModalAnimationRef.current();
        onExit == null || onExit(node);
    };
    const handleEntering = (node, isAppearing)=>{
        onEntering == null || onEntering(node, isAppearing);
        // FIXME: This should work even when animation is disabled.
        (0, $c414e224cd570c88$export$2e2bcd8739ae039)(window, 'resize', handleWindowResize);
    };
    const handleExited = (node)=>{
        if (node) node.style.display = ''; // RHL removes it sometimes
        onExited == null || onExited(node);
        // FIXME: This should work even when animation is disabled.
        (0, $21bd0a760d3f2599$export$2e2bcd8739ae039)(window, 'resize', handleWindowResize);
    };
    const renderBackdrop = (0, $kc00y.useCallback)((backdropProps)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
            ...backdropProps,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(`${bsPrefix}-backdrop`, backdropClassName, !animation && 'show')
        }), [
        animation,
        backdropClassName,
        bsPrefix
    ]);
    const baseModalStyle = {
        ...style,
        ...modalStyle
    };
    // If `display` is not set to block, autoFocus inside the modal fails
    // https://github.com/react-bootstrap/react-bootstrap/issues/5102
    baseModalStyle.display = 'block';
    const renderDialog = (dialogProps)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
            role: "dialog",
            ...dialogProps,
            style: baseModalStyle,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, bsPrefix, animateStaticModal && `${bsPrefix}-static`, !animation && 'show'),
            onClick: backdrop ? handleClick : undefined,
            onMouseUp: handleMouseUp,
            "data-bs-theme": dataBsTheme,
            "aria-label": ariaLabel,
            "aria-labelledby": ariaLabelledby,
            "aria-describedby": ariaDescribedby,
            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)(Dialog, {
                ...props,
                onMouseDown: handleDialogMouseDown,
                className: dialogClassName,
                contentClassName: contentClassName,
                children: children
            })
        });
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $515e095cb5609dfa$export$2e2bcd8739ae039).Provider, {
        value: modalContext,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $38ebb733d4e3053f$export$2e2bcd8739ae039), {
            show: show,
            ref: mergedRef,
            backdrop: backdrop,
            container: container,
            keyboard: true // Always set true - see handleEscapeKeyDown
            ,
            autoFocus: autoFocus,
            enforceFocus: enforceFocus,
            restoreFocus: restoreFocus,
            restoreFocusOptions: restoreFocusOptions,
            onEscapeKeyDown: handleEscapeKeyDown,
            onShow: onShow,
            onHide: onHide,
            onEnter: handleEnter,
            onEntering: handleEntering,
            onEntered: onEntered,
            onExit: handleExit,
            onExiting: onExiting,
            onExited: handleExited,
            manager: getModalManager(),
            transition: animation ? $8e1f7dde30da3bf6$var$DialogTransition : undefined,
            backdropTransition: animation ? $8e1f7dde30da3bf6$var$BackdropTransition : undefined,
            renderBackdrop: renderBackdrop,
            renderDialog: renderDialog
        })
    });
});
$8e1f7dde30da3bf6$var$Modal.displayName = 'Modal';
var $8e1f7dde30da3bf6$export$2e2bcd8739ae039 = Object.assign($8e1f7dde30da3bf6$var$Modal, {
    Body: (0, $6d3d2bbc78468a94$export$2e2bcd8739ae039),
    Header: (0, $2df357c71d197c51$export$2e2bcd8739ae039),
    Title: (0, $84ae5a7da8af1722$export$2e2bcd8739ae039),
    Footer: (0, $6226c1f8626352b5$export$2e2bcd8739ae039),
    Dialog: (0, $a1e5e61b09d62dd1$export$2e2bcd8739ae039),
    TRANSITION_DURATION: 300,
    BACKDROP_TRANSITION_DURATION: 150
});




var $kc00y = parcelRequire("kc00y");


var $kc00y = parcelRequire("kc00y");

var $kc00y = parcelRequire("kc00y");
function $b13b7fb73f273d5d$export$2e2bcd8739ae039() {
    const mounted = (0, $kc00y.useRef)(true);
    const isMounted = (0, $kc00y.useRef)(()=>mounted.current);
    (0, $kc00y.useEffect)(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    return isMounted.current;
}



/*
 * Browsers including Internet Explorer, Chrome, Safari, and Firefox store the
 * delay as a 32-bit signed integer internally. This causes an integer overflow
 * when using delays larger than 2,147,483,647 ms (about 24.8 days),
 * resulting in the timeout being executed immediately.
 *
 * via: https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/setTimeout
 */ const $a94bfcd8f48e4d34$var$MAX_DELAY_MS = 2 ** 31 - 1;
function $a94bfcd8f48e4d34$var$setChainedTimeout(handleRef, fn, timeoutAtMs) {
    const delayMs = timeoutAtMs - Date.now();
    handleRef.current = delayMs <= $a94bfcd8f48e4d34$var$MAX_DELAY_MS ? setTimeout(fn, delayMs) : setTimeout(()=>$a94bfcd8f48e4d34$var$setChainedTimeout(handleRef, fn, timeoutAtMs), $a94bfcd8f48e4d34$var$MAX_DELAY_MS);
}
function $a94bfcd8f48e4d34$export$2e2bcd8739ae039() {
    const isMounted = (0, $b13b7fb73f273d5d$export$2e2bcd8739ae039)();
    // types are confused between node and web here IDK
    const handleRef = (0, $kc00y.useRef)();
    (0, $580a01bf10c105ab$export$2e2bcd8739ae039)(()=>clearTimeout(handleRef.current));
    return (0, $kc00y.useMemo)(()=>{
        const clear = ()=>clearTimeout(handleRef.current);
        function set(fn, delayMs = 0) {
            if (!isMounted()) return;
            clear();
            if (delayMs <= $a94bfcd8f48e4d34$var$MAX_DELAY_MS) // For simplicity, if the timeout is short, just set a normal timeout.
            handleRef.current = setTimeout(fn, delayMs);
            else $a94bfcd8f48e4d34$var$setChainedTimeout(handleRef, fn, Date.now() + delayMs);
        }
        return {
            set: set,
            clear: clear,
            handleRef: handleRef
        };
    }, []);
}



var $kc00y = parcelRequire("kc00y");



const $0478d6e7b877283c$var$fadeStyles = {
    [(0, $92dadb5ebc6bf1cd$export$df38205c966be359)]: 'showing',
    [(0, $92dadb5ebc6bf1cd$export$4aacc83d4d59139f)]: 'showing show'
};
const $0478d6e7b877283c$var$ToastFade = /*#__PURE__*/ $kc00y.forwardRef((props, ref)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $25d8c693c355530c$export$2e2bcd8739ae039), {
        ...props,
        ref: ref,
        transitionClasses: $0478d6e7b877283c$var$fadeStyles
    }));
$0478d6e7b877283c$var$ToastFade.displayName = 'ToastFade';
var $0478d6e7b877283c$export$2e2bcd8739ae039 = $0478d6e7b877283c$var$ToastFade;




var $kc00y = parcelRequire("kc00y");




var $kc00y = parcelRequire("kc00y");
"use client";
const $e6ef1dfaa77ff774$var$ToastContext = /*#__PURE__*/ $kc00y.createContext({
    onClose () {}
});
var $e6ef1dfaa77ff774$export$2e2bcd8739ae039 = $e6ef1dfaa77ff774$var$ToastContext;



"use client";
const $e00ab8cfd5fd1297$var$ToastHeader = /*#__PURE__*/ $kc00y.forwardRef(({ bsPrefix: bsPrefix, closeLabel: closeLabel = 'Close', closeVariant: closeVariant, closeButton: closeButton = true, className: className, children: children, ...props }, ref)=>{
    bsPrefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(bsPrefix, 'toast-header');
    const context = (0, $kc00y.useContext)((0, $e6ef1dfaa77ff774$export$2e2bcd8739ae039));
    const handleClick = (0, $4655b62db0931f1e$export$2e2bcd8739ae039)((e)=>{
        context == null || context.onClose == null || context.onClose(e);
    });
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(bsPrefix, className),
        children: [
            children,
            closeButton && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $80bef9dfc5e82bc1$export$2e2bcd8739ae039), {
                "aria-label": closeLabel,
                variant: closeVariant,
                onClick: handleClick,
                "data-dismiss": "toast"
            })
        ]
    });
});
$e00ab8cfd5fd1297$var$ToastHeader.displayName = 'ToastHeader';
var $e00ab8cfd5fd1297$export$2e2bcd8739ae039 = $e00ab8cfd5fd1297$var$ToastHeader;



var $kc00y = parcelRequire("kc00y");



"use client";
const $0df0ddfb726af080$var$ToastBody = /*#__PURE__*/ $kc00y.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(bsPrefix, 'toast-body');
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, bsPrefix),
        ...props
    });
});
$0df0ddfb726af080$var$ToastBody.displayName = 'ToastBody';
var $0df0ddfb726af080$export$2e2bcd8739ae039 = $0df0ddfb726af080$var$ToastBody;





"use client";
const $061cb62cf04cf454$var$Toast = /*#__PURE__*/ $kc00y.forwardRef(({ bsPrefix: bsPrefix, className: className, transition: Transition = (0, $0478d6e7b877283c$export$2e2bcd8739ae039), show: show = true, animation: animation = true, delay: delay = 5000, autohide: autohide = false, onClose: onClose, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onExited: onExited, bg: bg, ...props }, ref)=>{
    bsPrefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(bsPrefix, 'toast');
    // We use refs for these, because we don't want to restart the autohide
    // timer in case these values change.
    const delayRef = (0, $kc00y.useRef)(delay);
    const onCloseRef = (0, $kc00y.useRef)(onClose);
    (0, $kc00y.useEffect)(()=>{
        delayRef.current = delay;
        onCloseRef.current = onClose;
    }, [
        delay,
        onClose
    ]);
    const autohideTimeout = (0, $a94bfcd8f48e4d34$export$2e2bcd8739ae039)();
    const autohideToast = !!(autohide && show);
    const autohideFunc = (0, $kc00y.useCallback)(()=>{
        if (autohideToast) onCloseRef.current == null || onCloseRef.current();
    }, [
        autohideToast
    ]);
    (0, $kc00y.useEffect)(()=>{
        // Only reset timer if show or autohide changes.
        autohideTimeout.set(autohideFunc, delayRef.current);
    }, [
        autohideTimeout,
        autohideFunc
    ]);
    const toastContext = (0, $kc00y.useMemo)(()=>({
            onClose: onClose
        }), [
        onClose
    ]);
    const hasAnimation = !!(Transition && animation);
    const toast = /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(bsPrefix, className, bg && `bg-${bg}`, !hasAnimation && (show ? 'show' : 'hide')),
        role: "alert",
        "aria-live": "assertive",
        "aria-atomic": "true"
    });
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e6ef1dfaa77ff774$export$2e2bcd8739ae039).Provider, {
        value: toastContext,
        children: hasAnimation && Transition ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)(Transition, {
            in: show,
            onEnter: onEnter,
            onEntering: onEntering,
            onEntered: onEntered,
            onExit: onExit,
            onExiting: onExiting,
            onExited: onExited,
            unmountOnExit: true,
            children: toast
        }) : toast
    });
});
$061cb62cf04cf454$var$Toast.displayName = 'Toast';
var $061cb62cf04cf454$export$2e2bcd8739ae039 = Object.assign($061cb62cf04cf454$var$Toast, {
    Body: (0, $0df0ddfb726af080$export$2e2bcd8739ae039),
    Header: (0, $e00ab8cfd5fd1297$export$2e2bcd8739ae039)
});


const $958d7290af97c4cf$var$ToastAutohide = ({ header: header, content: content, variant: variant, delay: delay, id: id, onClose: onClose })=>{
    const isPersistent = delay === null || delay === undefined;
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $061cb62cf04cf454$export$2e2bcd8739ae039), {
        bg: variant.toLowerCase(),
        onClose: ()=>onClose && id && onClose(id),
        show: true,
        delay: isPersistent ? undefined : delay,
        autohide: !isPersistent,
        className: "toast-fixed",
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $061cb62cf04cf454$export$2e2bcd8739ae039).Header, {
                closeLabel: "Fermer",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("span", {
                    className: "fw-bold me-auto",
                    children: header
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $061cb62cf04cf454$export$2e2bcd8739ae039).Body, {
                children: content
            })
        ]
    });
};
var $958d7290af97c4cf$export$2e2bcd8739ae039 = $958d7290af97c4cf$var$ToastAutohide;




var $kc00y = parcelRequire("kc00y");


var $kc00y = parcelRequire("kc00y");


"use client";
const $3815ec25cbe538be$var$positionClasses = {
    'top-start': 'top-0 start-0',
    'top-center': 'top-0 start-50 translate-middle-x',
    'top-end': 'top-0 end-0',
    'middle-start': 'top-50 start-0 translate-middle-y',
    'middle-center': 'top-50 start-50 translate-middle',
    'middle-end': 'top-50 end-0 translate-middle-y',
    'bottom-start': 'bottom-0 start-0',
    'bottom-center': 'bottom-0 start-50 translate-middle-x',
    'bottom-end': 'bottom-0 end-0'
};
const $3815ec25cbe538be$var$ToastContainer = /*#__PURE__*/ $kc00y.forwardRef(({ bsPrefix: bsPrefix, position: position, containerPosition: containerPosition, className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(bsPrefix, 'toast-container');
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(bsPrefix, position && $3815ec25cbe538be$var$positionClasses[position], containerPosition && `position-${containerPosition}`, className)
    });
});
$3815ec25cbe538be$var$ToastContainer.displayName = 'ToastContainer';
var $3815ec25cbe538be$export$2e2bcd8739ae039 = $3815ec25cbe538be$var$ToastContainer;


var $677778c972512b4d$export$83552892bed02fae = /*#__PURE__*/ function(TypeToastEnum) {
    TypeToastEnum["INFO"] = "info";
    TypeToastEnum["SUCCESS"] = "success";
    TypeToastEnum["WARNING"] = "warning";
    TypeToastEnum["DANGER"] = "danger";
    TypeToastEnum["PERSISTENT"] = "persistent";
    return TypeToastEnum;
}({});



const $6bdae0bad7b05751$var$ToastContext = /*#__PURE__*/ (0, $kc00y.createContext)(undefined);
const $6bdae0bad7b05751$export$91b3d218c74c79e4 = ()=>{
    const context = (0, $kc00y.useContext)($6bdae0bad7b05751$var$ToastContext);
    if (!context) throw new Error("useToastContext must be used within a ToastProvider");
    return context;
};
const $6bdae0bad7b05751$var$toastReducer = (state, action)=>{
    switch(action.type){
        case "ADD_TOAST":
            return {
                ...state,
                toasts: [
                    ...state.toasts,
                    action.payload
                ]
            };
        case "REMOVE_TOAST":
            return {
                ...state,
                toasts: state.toasts.filter((toast)=>toast.id !== action.payload)
            };
        default:
            return state;
    }
};
const $6bdae0bad7b05751$var$ToastWrapper = /*#__PURE__*/ (0, $kc00y.forwardRef)((props, ref)=>{
    const [state, dispatch] = (0, $kc00y.useReducer)($6bdae0bad7b05751$var$toastReducer, {
        toasts: []
    });
    const addToast = ({ header: header, type: type, message: message, delay: delay = 3000 })=>{
        const key = Math.floor(Math.random() * 10000000);
        const toastDelay = type === (0, $677778c972512b4d$export$83552892bed02fae).PERSISTENT ? null : delay;
        const handleRemoveToast = (id)=>{
            dispatch({
                type: "REMOVE_TOAST",
                payload: id
            });
        };
        dispatch({
            type: "ADD_TOAST",
            payload: {
                id: key,
                component: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $958d7290af97c4cf$export$2e2bcd8739ae039), {
                    id: key,
                    header: header,
                    content: message,
                    variant: type === (0, $677778c972512b4d$export$83552892bed02fae).PERSISTENT ? "info" : type,
                    delay: toastDelay,
                    onClose: handleRemoveToast
                }, key)
            }
        });
        return key;
    };
    const removeToast = (id)=>{
        dispatch({
            type: "REMOVE_TOAST",
            payload: id
        });
    };
    (0, $kc00y.useImperativeHandle)(ref, ()=>({
            addToastRef ({ header: header, type: type, message: message, delay: delay }) {
                return addToast({
                    header: header,
                    type: type,
                    message: message,
                    delay: delay
                });
            },
            removeToastRef (id) {
                removeToast(id);
            }
        }));
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $3815ec25cbe538be$export$2e2bcd8739ae039), {
        position: "bottom-end",
        className: "p-2",
        children: state.toasts.map((toast)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                children: toast.component
            }, toast.id))
    });
});
$6bdae0bad7b05751$var$ToastWrapper.displayName = "ToastWrapper";
const $6bdae0bad7b05751$export$f5d03d415824e0e = ({ children: children })=>{
    const toastRef = (0, $kc00y.useRef)(null);
    const addToast = ({ header: header, type: type, message: message, delay: delay = 3000 })=>{
        return toastRef.current?.addToastRef({
            header: header,
            type: type,
            message: message,
            delay: delay
        }) || 0;
    };
    const removeToast = (id)=>{
        toastRef.current?.removeToastRef(id);
    };
    const info = (message, header = "Information", delay)=>{
        addToast({
            message: message,
            header: header,
            delay: delay,
            type: (0, $677778c972512b4d$export$83552892bed02fae).INFO
        });
    };
    const success = (message, header = "Information", delay)=>{
        addToast({
            message: message,
            header: header,
            delay: delay,
            type: (0, $677778c972512b4d$export$83552892bed02fae).SUCCESS
        });
    };
    const warning = (message, header = "Information", delay)=>{
        addToast({
            message: message,
            header: header,
            delay: delay,
            type: (0, $677778c972512b4d$export$83552892bed02fae).WARNING
        });
    };
    const error = (message, header = "Information", delay)=>{
        addToast({
            message: message,
            header: header,
            delay: delay,
            type: (0, $677778c972512b4d$export$83552892bed02fae).DANGER
        });
    };
    const persistent = (message, header = "Information")=>{
        return addToast({
            message: message,
            header: header,
            type: (0, $677778c972512b4d$export$83552892bed02fae).PERSISTENT
        }) || 0;
    };
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)($6bdae0bad7b05751$var$ToastContext.Provider, {
        value: {
            success: success,
            warning: warning,
            info: info,
            error: error,
            persistent: persistent,
            addToast: addToast,
            removeToast: removeToast
        },
        children: [
            children,
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($6bdae0bad7b05751$var$ToastWrapper, {
                ref: toastRef
            })
        ]
    });
};



const $7d5f25ee93f10b42$var$usePostState = ({ id: id, query: query, onConfirm: onConfirm, successToast: successToast, closeModal: closeModal, errorToast: errorToast })=>{
    return (0, $8d9ebd8892d8a5f5$export$9158e33c8d0ca687)(id ? `${query}/${id}` : `${query}`, {
        onResolve: (res)=>{
            onConfirm && onConfirm(res);
            successToast("L'action a bien \xe9t\xe9 ex\xe9cut\xe9e");
            closeModal();
        },
        onReject: async (error)=>{
            errorToast(`Erreur lors de l'ex\xe9cution de l'action : ${await error.text()}`);
            closeModal();
        }
    });
};
const $7d5f25ee93f10b42$var$usePutState = ({ id: id, query: query, onConfirm: onConfirm, successToast: successToast, closeModal: closeModal, errorToast: errorToast })=>{
    return (0, $8d9ebd8892d8a5f5$export$f378150f39d4621f)(id ? `${query}/${id}` : `${query}`, {
        onResolve: (res)=>{
            onConfirm && onConfirm(res);
            successToast("L'action a bien \xe9t\xe9 ex\xe9cut\xe9e");
            closeModal();
        },
        onReject: async (error)=>{
            errorToast(`Erreur lors de l'ex\xe9cution de l'action : ${await error.text()}`);
            closeModal();
        }
    }, false);
};
const $7d5f25ee93f10b42$var$ConfirmModalBody = ({ query: query, id: id, closeModal: closeModal, onConfirm: onConfirm, content: content, href: href, isPost: isPost })=>{
    const { success: successToast, error: errorToast } = (0, $6bdae0bad7b05751$export$91b3d218c74c79e4)();
    const usePost = $7d5f25ee93f10b42$var$usePostState({
        id: id,
        query: query,
        closeModal: closeModal,
        onConfirm: onConfirm,
        errorToast: errorToast,
        successToast: successToast
    });
    const usePut = $7d5f25ee93f10b42$var$usePutState({
        id: id,
        query: query,
        closeModal: closeModal,
        onConfirm: onConfirm,
        errorToast: errorToast,
        successToast: successToast
    });
    const isSubmitting = href === undefined && (isPost ? usePost.isPending || usePost.isLoading : usePut.isPending || usePut.isLoading);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8e1f7dde30da3bf6$export$2e2bcd8739ae039).Body, {
                children: content
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $8e1f7dde30da3bf6$export$2e2bcd8739ae039).Footer, {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                        variant: "secondary",
                        onClick: closeModal,
                        children: "Annuler"
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                        variant: "primary",
                        onClick: async ()=>{
                            if (isSubmitting) return;
                            // Si on a un href, on n'est pas en post
                            if (href === undefined) try {
                                isPost ? await usePost.run() : await usePut.run();
                            } catch (e) {
                                (0, $958d7290af97c4cf$export$2e2bcd8739ae039)({
                                    content: `Erreur lors de l'ex\xe9cution de l'action : ${e.message}`,
                                    variant: "danger"
                                });
                            }
                            else {
                                if (onConfirm) // Si onConfirm est fourni, exécutez-le directement
                                onConfirm(id);
                                closeModal();
                            }
                        },
                        href: href,
                        disabled: isSubmitting,
                        children: "Valider"
                    })
                ]
            })
        ]
    });
};
const $7d5f25ee93f10b42$var$ConfirmModal = ({ ref: ref, visible: visible, closeModal: closeModal, header: header = "Confirmation", query: query, id: id, onConfirm: onConfirm, content: content = "Confirmer ?", href: href, isPost: isPost = true })=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $8e1f7dde30da3bf6$export$2e2bcd8739ae039), {
        show: visible,
        onHide: closeModal,
        ref: ref,
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8e1f7dde30da3bf6$export$2e2bcd8739ae039).Header, {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8e1f7dde30da3bf6$export$2e2bcd8739ae039).Title, {
                    children: header
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($7d5f25ee93f10b42$var$ConfirmModalBody, {
                query: query,
                id: id,
                closeModal: closeModal,
                onConfirm: onConfirm,
                content: content,
                href: href,
                isPost: isPost
            })
        ]
    });
};
var $7d5f25ee93f10b42$export$2e2bcd8739ae039 = $7d5f25ee93f10b42$var$ConfirmModal;



var $kc00y = parcelRequire("kc00y");
const $ca8671088139af49$var$useModal = ()=>{
    const [visible, setVisible] = (0, $kc00y.useState)(false);
    const [value, setValue] = (0, $kc00y.useState)(null);
    const ref = (0, $kc00y.useRef)(null);
    (0, $kc00y.useEffect)(()=>{
        if (!ref.current) return;
        const modal = ref.current;
        visible && modal.showModal();
        !visible && modal.close();
    }, [
        visible
    ]);
    function show(value = null) {
        setVisible(true);
        const modal = ref.current;
        modal?.showModal();
        setValue(value);
    }
    function close() {
        const modal = ref.current;
        modal?.close();
        setVisible(false);
        setValue(null);
    }
    return {
        visible: visible,
        value: value,
        show: show,
        close: close,
        ref: ref
    };
};
var $ca8671088139af49$export$2e2bcd8739ae039 = $ca8671088139af49$var$useModal;




var $kc00y = parcelRequire("kc00y");


var $lCkAA = parcelRequire("lCkAA");

var $kc00y = parcelRequire("kc00y");


function $93c14b0a090563ae$export$2e2bcd8739ae039() {
    return $93c14b0a090563ae$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $93c14b0a090563ae$export$2e2bcd8739ae039.apply(null, arguments);
}




var $kc00y = parcelRequire("kc00y");
var $dd7e63b9f56b8b40$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $dd7e63b9f56b8b40$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
$dd7e63b9f56b8b40$exports = $dd7e63b9f56b8b40$var$invariant;


var $5824edc689e55384$var$noop = function noop() {};
function $5824edc689e55384$var$readOnlyPropType(handler, name) {
    return function(props, propName) {
        if (props[propName] !== undefined) {
            if (!props[handler]) return new Error("You have provided a `" + propName + "` prop to `" + name + "` " + ("without an `" + handler + "` handler prop. This will render a read-only field. ") + ("If the field should be mutable use `" + $5824edc689e55384$export$26cbf8c37e721e67(propName) + "`. ") + ("Otherwise, set `" + handler + "`."));
        }
    };
}
function $5824edc689e55384$export$8abd944bed26e726(controlledValues, displayName) {
    var propTypes = {};
    Object.keys(controlledValues).forEach(function(prop) {
        // add default propTypes for folks that use runtime checks
        propTypes[$5824edc689e55384$export$26cbf8c37e721e67(prop)] = $5824edc689e55384$var$noop;
        var handler;
    });
    return propTypes;
}
function $5824edc689e55384$export$12ae2baa35bd9b8b(props, prop) {
    return props[prop] !== undefined;
}
function $5824edc689e55384$export$26cbf8c37e721e67(key) {
    return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}
function $5824edc689e55384$export$95e5b18573b29087(component) {
    return !!component && (typeof component !== 'function' || component.prototype && component.prototype.isReactComponent);
}


function $b0582fd40c314767$var$_toPropertyKey(arg) {
    var key = $b0582fd40c314767$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $b0582fd40c314767$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $b0582fd40c314767$export$2ee51287a16ca325(propValue, defaultValue, handler) {
    var wasPropRef = (0, $kc00y.useRef)(propValue !== undefined);
    var _useState = (0, $kc00y.useState)(defaultValue), stateValue = _useState[0], setState = _useState[1];
    var isProp = propValue !== undefined;
    var wasProp = wasPropRef.current;
    wasPropRef.current = isProp;
    /**
   * If a prop switches from controlled to Uncontrolled
   * reset its value to the defaultValue
   */ if (!isProp && wasProp && stateValue !== defaultValue) setState(defaultValue);
    return [
        isProp ? propValue : stateValue,
        (0, $kc00y.useCallback)(function(value) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            if (handler) handler.apply(void 0, [
                value
            ].concat(args));
            setState(value);
        }, [
            handler
        ])
    ];
}
function $b0582fd40c314767$export$2e2bcd8739ae039(props, config) {
    return Object.keys(config).reduce(function(result, fieldName) {
        var _extends2;
        var _ref = result, defaultValue = _ref[$5824edc689e55384$export$26cbf8c37e721e67(fieldName)], propsValue = _ref[fieldName], rest = (0, $5643d0ce020fb17f$export$2e2bcd8739ae039)(_ref, [
            $5824edc689e55384$export$26cbf8c37e721e67(fieldName),
            fieldName
        ].map($b0582fd40c314767$var$_toPropertyKey));
        var handlerName = config[fieldName];
        var _useUncontrolledProp = $b0582fd40c314767$export$2ee51287a16ca325(propsValue, defaultValue, props[handlerName]), value = _useUncontrolledProp[0], handler = _useUncontrolledProp[1];
        return (0, $93c14b0a090563ae$export$2e2bcd8739ae039)({}, rest, (_extends2 = {}, _extends2[fieldName] = value, _extends2[handlerName] = handler, _extends2));
    }, props);
}






var $kc00y = parcelRequire("kc00y");
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $6d7734923b30ada1$var$componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function $6d7734923b30ada1$var$componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function $6d7734923b30ada1$var$componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
$6d7734923b30ada1$var$componentWillMount.__suppressDeprecationWarning = true;
$6d7734923b30ada1$var$componentWillReceiveProps.__suppressDeprecationWarning = true;
$6d7734923b30ada1$var$componentWillUpdate.__suppressDeprecationWarning = true;
function $6d7734923b30ada1$export$cea1c58a6db52bca(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error('Can only polyfill class components');
    if (typeof Component.getDerivedStateFromProps !== 'function' && typeof prototype.getSnapshotBeforeUpdate !== 'function') return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === 'function') foundWillMountName = 'componentWillMount';
    else if (typeof prototype.UNSAFE_componentWillMount === 'function') foundWillMountName = 'UNSAFE_componentWillMount';
    if (typeof prototype.componentWillReceiveProps === 'function') foundWillReceivePropsName = 'componentWillReceiveProps';
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
    if (typeof prototype.componentWillUpdate === 'function') foundWillUpdateName = 'componentWillUpdate';
    else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') foundWillUpdateName = 'UNSAFE_componentWillUpdate';
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
        throw Error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + componentName + ' uses ' + newApiName + ' but also contains the following legacy lifecycles:' + (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') + (foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '') + (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') + '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-async-component-lifecycle-hooks');
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === 'function') {
        prototype.componentWillMount = $6d7734923b30ada1$var$componentWillMount;
        prototype.componentWillReceiveProps = $6d7734923b30ada1$var$componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
        if (typeof prototype.componentDidUpdate !== 'function') throw new Error('Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype');
        prototype.componentWillUpdate = $6d7734923b30ada1$var$componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}




var $d54d1fe3bbbbc10c$var$_jsxFileName = "/Users/jquense/src/uncontrollable/src/uncontrollable.js";
function $d54d1fe3bbbbc10c$export$2e2bcd8739ae039(Component, controlledValues, methods) {
    if (methods === void 0) methods = [];
    var displayName = Component.displayName || Component.name || 'Component';
    var canAcceptRef = $5824edc689e55384$export$95e5b18573b29087(Component);
    var controlledProps = Object.keys(controlledValues);
    var PROPS_TO_OMIT = controlledProps.map($5824edc689e55384$export$26cbf8c37e721e67);
    !(canAcceptRef || !methods.length) && (0, (/*@__PURE__*/$parcel$interopDefault($dd7e63b9f56b8b40$exports)))(false);
    var UncontrolledComponent = /*#__PURE__*/ function(_React$Component) {
        (0, $9edc1cf2bf13fb9a$export$2e2bcd8739ae039)(UncontrolledComponent, _React$Component);
        function UncontrolledComponent() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.handlers = Object.create(null);
            controlledProps.forEach(function(propName) {
                var handlerName = controlledValues[propName];
                var handleChange = function handleChange(value) {
                    if (_this.props[handlerName]) {
                        var _this$props;
                        _this._notifying = true;
                        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                        (_this$props = _this.props)[handlerName].apply(_this$props, [
                            value
                        ].concat(args));
                        _this._notifying = false;
                    }
                    if (!_this.unmounted) _this.setState(function(_ref) {
                        var _extends2;
                        var values = _ref.values;
                        return {
                            values: (0, $93c14b0a090563ae$export$2e2bcd8739ae039)(Object.create(null), values, (_extends2 = {}, _extends2[propName] = value, _extends2))
                        };
                    });
                };
                _this.handlers[handlerName] = handleChange;
            });
            if (methods.length) _this.attachRef = function(ref) {
                _this.inner = ref;
            };
            var values = Object.create(null);
            controlledProps.forEach(function(key) {
                values[key] = _this.props[$5824edc689e55384$export$26cbf8c37e721e67(key)];
            });
            _this.state = {
                values: values,
                prevProps: {}
            };
            return _this;
        }
        var _proto = UncontrolledComponent.prototype;
        _proto.shouldComponentUpdate = function shouldComponentUpdate() {
            //let setState trigger the update
            return !this._notifying;
        };
        UncontrolledComponent.getDerivedStateFromProps = function getDerivedStateFromProps(props, _ref2) {
            var values = _ref2.values, prevProps = _ref2.prevProps;
            var nextState = {
                values: (0, $93c14b0a090563ae$export$2e2bcd8739ae039)(Object.create(null), values),
                prevProps: {}
            };
            controlledProps.forEach(function(key) {
                /**
         * If a prop switches from controlled to Uncontrolled
         * reset its value to the defaultValue
         */ nextState.prevProps[key] = props[key];
                if (!$5824edc689e55384$export$12ae2baa35bd9b8b(props, key) && $5824edc689e55384$export$12ae2baa35bd9b8b(prevProps, key)) nextState.values[key] = props[$5824edc689e55384$export$26cbf8c37e721e67(key)];
            });
            return nextState;
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.unmounted = true;
        };
        _proto.render = function render() {
            var _this2 = this;
            var _this$props2 = this.props, innerRef = _this$props2.innerRef, props = (0, $5643d0ce020fb17f$export$2e2bcd8739ae039)(_this$props2, [
                "innerRef"
            ]);
            PROPS_TO_OMIT.forEach(function(prop) {
                delete props[prop];
            });
            var newProps = {};
            controlledProps.forEach(function(propName) {
                var propValue = _this2.props[propName];
                newProps[propName] = propValue !== undefined ? propValue : _this2.state.values[propName];
            });
            return (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement(Component, (0, $93c14b0a090563ae$export$2e2bcd8739ae039)({}, props, newProps, this.handlers, {
                ref: innerRef || this.attachRef
            }));
        };
        return UncontrolledComponent;
    }((0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).Component);
    (0, $6d7734923b30ada1$export$cea1c58a6db52bca)(UncontrolledComponent);
    UncontrolledComponent.displayName = "Uncontrolled(" + displayName + ")";
    UncontrolledComponent.propTypes = (0, $93c14b0a090563ae$export$2e2bcd8739ae039)({
        innerRef: function innerRef() {}
    }, $5824edc689e55384$export$8abd944bed26e726(controlledValues, displayName));
    methods.forEach(function(method) {
        UncontrolledComponent.prototype[method] = function $proxiedMethod() {
            var _this$inner;
            return (_this$inner = this.inner)[method].apply(_this$inner, arguments);
        };
    });
    var WrappedComponent = UncontrolledComponent;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).forwardRef) {
        WrappedComponent = (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).forwardRef(function(props, ref) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement(UncontrolledComponent, (0, $93c14b0a090563ae$export$2e2bcd8739ae039)({}, props, {
                innerRef: ref,
                __source: {
                    fileName: $d54d1fe3bbbbc10c$var$_jsxFileName,
                    lineNumber: 128
                },
                __self: this
            }));
        });
        WrappedComponent.propTypes = UncontrolledComponent.propTypes;
    }
    WrappedComponent.ControlledComponent = Component;
    /**
   * useful when wrapping a Component and you want to control
   * everything
   */ WrappedComponent.deferControlTo = function(newComponent, additions, nextMethods) {
        if (additions === void 0) additions = {};
        return $d54d1fe3bbbbc10c$export$2e2bcd8739ae039(newComponent, (0, $93c14b0a090563ae$export$2e2bcd8739ae039)({}, controlledValues, additions), nextMethods);
    };
    return WrappedComponent;
}







var $kc00y = parcelRequire("kc00y");


var $kc00y = parcelRequire("kc00y");


var $kc00y = parcelRequire("kc00y");
function $076d41a58396540c$export$2e2bcd8739ae039() {
    return (0, $kc00y.useState)(null);
}




var $kc00y = parcelRequire("kc00y");
var $f035112a1ee37c2c$var$has = Object.prototype.hasOwnProperty;
function $f035112a1ee37c2c$var$find(iter, tar, key) {
    for (key of iter.keys()){
        if ($f035112a1ee37c2c$export$de8294bb3be0322f(key, tar)) return key;
    }
}
function $f035112a1ee37c2c$export$de8294bb3be0322f(foo, bar) {
    var ctor, len, tmp;
    if (foo === bar) return true;
    if (foo && bar && (ctor = foo.constructor) === bar.constructor) {
        if (ctor === Date) return foo.getTime() === bar.getTime();
        if (ctor === RegExp) return foo.toString() === bar.toString();
        if (ctor === Array) {
            if ((len = foo.length) === bar.length) {
                while(len-- && $f035112a1ee37c2c$export$de8294bb3be0322f(foo[len], bar[len]));
            }
            return len === -1;
        }
        if (ctor === Set) {
            if (foo.size !== bar.size) return false;
            for (len of foo){
                tmp = len;
                if (tmp && typeof tmp === 'object') {
                    tmp = $f035112a1ee37c2c$var$find(bar, tmp);
                    if (!tmp) return false;
                }
                if (!bar.has(tmp)) return false;
            }
            return true;
        }
        if (ctor === Map) {
            if (foo.size !== bar.size) return false;
            for (len of foo){
                tmp = len[0];
                if (tmp && typeof tmp === 'object') {
                    tmp = $f035112a1ee37c2c$var$find(bar, tmp);
                    if (!tmp) return false;
                }
                if (!$f035112a1ee37c2c$export$de8294bb3be0322f(len[1], bar.get(tmp))) return false;
            }
            return true;
        }
        if (ctor === ArrayBuffer) {
            foo = new Uint8Array(foo);
            bar = new Uint8Array(bar);
        } else if (ctor === DataView) {
            if ((len = foo.byteLength) === bar.byteLength) {
                while(len-- && foo.getInt8(len) === bar.getInt8(len));
            }
            return len === -1;
        }
        if (ArrayBuffer.isView(foo)) {
            if ((len = foo.byteLength) === bar.byteLength) {
                while(len-- && foo[len] === bar[len]);
            }
            return len === -1;
        }
        if (!ctor || typeof foo === 'object') {
            len = 0;
            for(ctor in foo){
                if ($f035112a1ee37c2c$var$has.call(foo, ctor) && ++len && !$f035112a1ee37c2c$var$has.call(bar, ctor)) return false;
                if (!(ctor in bar) || !$f035112a1ee37c2c$export$de8294bb3be0322f(foo[ctor], bar[ctor])) return false;
            }
            return Object.keys(bar).length === len;
        }
    }
    return foo !== foo && bar !== bar;
}



var $kc00y = parcelRequire("kc00y");

/**
 * `useSafeState` takes the return value of a `useState` hook and wraps the
 * setter to prevent updates onces the component has unmounted. Can used
 * with `useMergeState` and `useStateAsync` as well
 *
 * @param state The return value of a useStateHook
 *
 * ```ts
 * const [show, setShow] = useSafeState(useState(true));
 * ```
 */ function $b1e206547c363bcb$var$useSafeState(state) {
    const isMounted = (0, $05ea5591019bd8c4$export$2e2bcd8739ae039)();
    return [
        state[0],
        (0, $kc00y.useCallback)((nextState)=>{
            if (!isMounted()) return;
            return state[1](nextState);
        }, [
            isMounted,
            state[1]
        ])
    ];
}
var $b1e206547c363bcb$export$2e2bcd8739ae039 = $b1e206547c363bcb$var$useSafeState;



function $af134027d3678390$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}


function $46f3e81cd776f4c8$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $a58d35a7c563f8e5$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $46f3e81cd776f4c8$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $a58d35a7c563f8e5$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $46f3e81cd776f4c8$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $a58d35a7c563f8e5$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $46f3e81cd776f4c8$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $b19d5aae4fdeb8ca$export$8960430cfd85939f = Math.max;
var $b19d5aae4fdeb8ca$export$96ec731ed4dcb222 = Math.min;
var $b19d5aae4fdeb8ca$export$2077e0241d6afd3c = Math.round;



function $1ac5e2a25df8d0b7$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}


function $eff7a14367d98ee4$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $1ac5e2a25df8d0b7$export$2e2bcd8739ae039)());
}


function $d7ece3c5b449c172$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $a58d35a7c563f8e5$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $b19d5aae4fdeb8ca$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $b19d5aae4fdeb8ca$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $a58d35a7c563f8e5$export$45a5e7f76e0caa8d)(element) ? (0, $46f3e81cd776f4c8$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $eff7a14367d98ee4$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}


function $70c6c7f1af6109b4$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $d7ece3c5b449c172$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}



function $4eb9338490615be9$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $a58d35a7c563f8e5$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $6a8318aab15e9bd0$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}



function $6063374ec834d9fa$export$2e2bcd8739ae039(element) {
    return (0, $46f3e81cd776f4c8$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}




function $f82086201488237d$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $6a8318aab15e9bd0$export$2e2bcd8739ae039)(element)) >= 0;
}




function $c99e2a756865540b$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $a58d35a7c563f8e5$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $cdaf1e8db795123a$export$2e2bcd8739ae039(element) {
    if ((0, $6a8318aab15e9bd0$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $a58d35a7c563f8e5$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $c99e2a756865540b$export$2e2bcd8739ae039)(element) // fallback
    );
}



function $29f73c7459974fa6$var$getTrueOffsetParent(element) {
    if (!(0, $a58d35a7c563f8e5$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $6063374ec834d9fa$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $29f73c7459974fa6$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $1ac5e2a25df8d0b7$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $1ac5e2a25df8d0b7$export$2e2bcd8739ae039)());
    if (isIE && (0, $a58d35a7c563f8e5$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $6063374ec834d9fa$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $cdaf1e8db795123a$export$2e2bcd8739ae039)(element);
    if ((0, $a58d35a7c563f8e5$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $a58d35a7c563f8e5$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $6a8318aab15e9bd0$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $6063374ec834d9fa$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $29f73c7459974fa6$export$2e2bcd8739ae039(element) {
    var window = (0, $46f3e81cd776f4c8$export$2e2bcd8739ae039)(element);
    var offsetParent = $29f73c7459974fa6$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $f82086201488237d$export$2e2bcd8739ae039)(offsetParent) && (0, $6063374ec834d9fa$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $29f73c7459974fa6$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $6a8318aab15e9bd0$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $6a8318aab15e9bd0$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $6063374ec834d9fa$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $29f73c7459974fa6$var$getContainingBlock(element) || window;
}


function $4d3b18a360f5c55d$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $062be686f3b03ae1$export$f28d906d67a997f3(min, value, max) {
    return (0, $b19d5aae4fdeb8ca$export$8960430cfd85939f)(min, (0, $b19d5aae4fdeb8ca$export$96ec731ed4dcb222)(value, max));
}
function $062be686f3b03ae1$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $062be686f3b03ae1$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}


function $b96712f9d73924b6$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $ec40e7b62448b7b5$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $b96712f9d73924b6$export$2e2bcd8739ae039)(), paddingObject);
}


function $f42c4cf35056a606$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


var $7ceeeafb45311bd4$export$1e95b668f3b82d = 'top';
var $7ceeeafb45311bd4$export$40e543e69a8b3fbb = 'bottom';
var $7ceeeafb45311bd4$export$79ffe56a765070d2 = 'right';
var $7ceeeafb45311bd4$export$eabcd2c8791e7bf4 = 'left';
var $7ceeeafb45311bd4$export$dfb5619354ba860 = 'auto';
var $7ceeeafb45311bd4$export$aec2ce47c367b8c3 = [
    $7ceeeafb45311bd4$export$1e95b668f3b82d,
    $7ceeeafb45311bd4$export$40e543e69a8b3fbb,
    $7ceeeafb45311bd4$export$79ffe56a765070d2,
    $7ceeeafb45311bd4$export$eabcd2c8791e7bf4
];
var $7ceeeafb45311bd4$export$b3571188c770cc5a = 'start';
var $7ceeeafb45311bd4$export$bd5df0f255a350f8 = 'end';
var $7ceeeafb45311bd4$export$390fd549c5303b4d = 'clippingParents';
var $7ceeeafb45311bd4$export$d7b7311ec04a3e8f = 'viewport';
var $7ceeeafb45311bd4$export$ae5ab1c730825774 = 'popper';
var $7ceeeafb45311bd4$export$ca50aac9f3ba507f = 'reference';
var $7ceeeafb45311bd4$export$368f9a87e87fa4e1 = /*#__PURE__*/ $7ceeeafb45311bd4$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $7ceeeafb45311bd4$export$b3571188c770cc5a,
        placement + "-" + $7ceeeafb45311bd4$export$bd5df0f255a350f8
    ]);
}, []);
var $7ceeeafb45311bd4$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($7ceeeafb45311bd4$export$aec2ce47c367b8c3, [
    $7ceeeafb45311bd4$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $7ceeeafb45311bd4$export$b3571188c770cc5a,
        placement + "-" + $7ceeeafb45311bd4$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $7ceeeafb45311bd4$export$421679a7c3d56e = 'beforeRead';
var $7ceeeafb45311bd4$export$aafa59e2e03f2942 = 'read';
var $7ceeeafb45311bd4$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $7ceeeafb45311bd4$export$c65e99957a05207c = 'beforeMain';
var $7ceeeafb45311bd4$export$f22da7240b7add18 = 'main';
var $7ceeeafb45311bd4$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $7ceeeafb45311bd4$export$8d4d2d70e7d46032 = 'beforeWrite';
var $7ceeeafb45311bd4$export$68d8715fc104d294 = 'write';
var $7ceeeafb45311bd4$export$70a6e5159acce2e6 = 'afterWrite';
var $7ceeeafb45311bd4$export$d087d3878fdf71d5 = [
    $7ceeeafb45311bd4$export$421679a7c3d56e,
    $7ceeeafb45311bd4$export$aafa59e2e03f2942,
    $7ceeeafb45311bd4$export$6964f6c886723980,
    $7ceeeafb45311bd4$export$c65e99957a05207c,
    $7ceeeafb45311bd4$export$f22da7240b7add18,
    $7ceeeafb45311bd4$export$bab79516f2d662fe,
    $7ceeeafb45311bd4$export$8d4d2d70e7d46032,
    $7ceeeafb45311bd4$export$68d8715fc104d294,
    $7ceeeafb45311bd4$export$70a6e5159acce2e6
];


var $488a7a88112c55e7$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $ec40e7b62448b7b5$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $f42c4cf35056a606$export$2e2bcd8739ae039)(padding, (0, $7ceeeafb45311bd4$export$aec2ce47c367b8c3)));
};
function $488a7a88112c55e7$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $af134027d3678390$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $4d3b18a360f5c55d$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $7ceeeafb45311bd4$export$eabcd2c8791e7bf4),
        (0, $7ceeeafb45311bd4$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $488a7a88112c55e7$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $70c6c7f1af6109b4$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $7ceeeafb45311bd4$export$1e95b668f3b82d) : (0, $7ceeeafb45311bd4$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $7ceeeafb45311bd4$export$40e543e69a8b3fbb) : (0, $7ceeeafb45311bd4$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $29f73c7459974fa6$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $062be686f3b03ae1$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $488a7a88112c55e7$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $4eb9338490615be9$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $488a7a88112c55e7$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $488a7a88112c55e7$var$arrow,
    effect: $488a7a88112c55e7$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};








function $bf22a0bca2fcd727$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}



var $7bef6b18f4629ffc$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $7bef6b18f4629ffc$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $b19d5aae4fdeb8ca$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $b19d5aae4fdeb8ca$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $7bef6b18f4629ffc$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $7ceeeafb45311bd4$export$eabcd2c8791e7bf4);
    var sideY = (0, $7ceeeafb45311bd4$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $29f73c7459974fa6$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $46f3e81cd776f4c8$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $c99e2a756865540b$export$2e2bcd8739ae039)(popper);
            if ((0, $6063374ec834d9fa$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $7ceeeafb45311bd4$export$1e95b668f3b82d) || (placement === (0, $7ceeeafb45311bd4$export$eabcd2c8791e7bf4) || placement === (0, $7ceeeafb45311bd4$export$79ffe56a765070d2)) && variation === (0, $7ceeeafb45311bd4$export$bd5df0f255a350f8)) {
            sideY = (0, $7ceeeafb45311bd4$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $7ceeeafb45311bd4$export$eabcd2c8791e7bf4) || (placement === (0, $7ceeeafb45311bd4$export$1e95b668f3b82d) || placement === (0, $7ceeeafb45311bd4$export$40e543e69a8b3fbb)) && variation === (0, $7ceeeafb45311bd4$export$bd5df0f255a350f8)) {
            sideX = (0, $7ceeeafb45311bd4$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $7bef6b18f4629ffc$var$unsetSides);
    var _ref4 = roundOffsets === true ? $7bef6b18f4629ffc$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $46f3e81cd776f4c8$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $7bef6b18f4629ffc$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $af134027d3678390$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $bf22a0bca2fcd727$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $7bef6b18f4629ffc$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $7bef6b18f4629ffc$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $7bef6b18f4629ffc$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $7bef6b18f4629ffc$var$computeStyles,
    data: {}
};



var $43b44492dc58ef15$var$passive = {
    passive: true
};
function $43b44492dc58ef15$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $46f3e81cd776f4c8$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $43b44492dc58ef15$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $43b44492dc58ef15$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $43b44492dc58ef15$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $43b44492dc58ef15$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $43b44492dc58ef15$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $43b44492dc58ef15$var$effect,
    data: {}
};


var $9216ceee8804002d$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $9216ceee8804002d$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $9216ceee8804002d$var$hash[matched];
    });
}



var $33da2021c4e86f0e$var$hash = {
    start: 'end',
    end: 'start'
};
function $33da2021c4e86f0e$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $33da2021c4e86f0e$var$hash[matched];
    });
}








function $e616e8cecdc2e5bb$export$2e2bcd8739ae039(node) {
    var win = (0, $46f3e81cd776f4c8$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}


function $13a1cf6927e3535a$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $d7ece3c5b449c172$export$2e2bcd8739ae039)((0, $c99e2a756865540b$export$2e2bcd8739ae039)(element)).left + (0, $e616e8cecdc2e5bb$export$2e2bcd8739ae039)(element).scrollLeft;
}



function $e4ab739342733fcb$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $46f3e81cd776f4c8$export$2e2bcd8739ae039)(element);
    var html = (0, $c99e2a756865540b$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $eff7a14367d98ee4$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $13a1cf6927e3535a$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $34de92241a42faa3$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $c99e2a756865540b$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $e616e8cecdc2e5bb$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $b19d5aae4fdeb8ca$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $b19d5aae4fdeb8ca$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $13a1cf6927e3535a$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $6063374ec834d9fa$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += (0, $b19d5aae4fdeb8ca$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}




function $84d12d4e286ea295$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $6063374ec834d9fa$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}




function $9079b2cb875c9978$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $6a8318aab15e9bd0$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $a58d35a7c563f8e5$export$1b3bfaa9684536aa)(node) && (0, $84d12d4e286ea295$export$2e2bcd8739ae039)(node)) return node;
    return $9079b2cb875c9978$export$2e2bcd8739ae039((0, $cdaf1e8db795123a$export$2e2bcd8739ae039)(node));
}





function $1467a14c32af674d$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $9079b2cb875c9978$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $46f3e81cd776f4c8$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $84d12d4e286ea295$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($1467a14c32af674d$export$2e2bcd8739ae039((0, $cdaf1e8db795123a$export$2e2bcd8739ae039)(target)));
}










function $239d692fb4466bd5$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $2a7086f043393bf1$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $d7ece3c5b449c172$export$2e2bcd8739ae039)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $2a7086f043393bf1$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $7ceeeafb45311bd4$export$d7b7311ec04a3e8f) ? (0, $239d692fb4466bd5$export$2e2bcd8739ae039)((0, $e4ab739342733fcb$export$2e2bcd8739ae039)(element, strategy)) : (0, $a58d35a7c563f8e5$export$45a5e7f76e0caa8d)(clippingParent) ? $2a7086f043393bf1$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $239d692fb4466bd5$export$2e2bcd8739ae039)((0, $34de92241a42faa3$export$2e2bcd8739ae039)((0, $c99e2a756865540b$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $2a7086f043393bf1$var$getClippingParents(element) {
    var clippingParents = (0, $1467a14c32af674d$export$2e2bcd8739ae039)((0, $cdaf1e8db795123a$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $6063374ec834d9fa$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $a58d35a7c563f8e5$export$1b3bfaa9684536aa)(element) ? (0, $29f73c7459974fa6$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $a58d35a7c563f8e5$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $a58d35a7c563f8e5$export$45a5e7f76e0caa8d)(clippingParent) && (0, $4eb9338490615be9$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $6a8318aab15e9bd0$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $2a7086f043393bf1$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $2a7086f043393bf1$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $2a7086f043393bf1$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $b19d5aae4fdeb8ca$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $b19d5aae4fdeb8ca$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $b19d5aae4fdeb8ca$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $b19d5aae4fdeb8ca$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $2a7086f043393bf1$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $e6eede691da7fa83$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $af134027d3678390$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $bf22a0bca2fcd727$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $7ceeeafb45311bd4$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $7ceeeafb45311bd4$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $7ceeeafb45311bd4$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $7ceeeafb45311bd4$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $4d3b18a360f5c55d$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $7ceeeafb45311bd4$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $7ceeeafb45311bd4$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}







function $0246a59ce632f72b$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $7ceeeafb45311bd4$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $7ceeeafb45311bd4$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $7ceeeafb45311bd4$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $ec40e7b62448b7b5$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $f42c4cf35056a606$export$2e2bcd8739ae039)(padding, (0, $7ceeeafb45311bd4$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $7ceeeafb45311bd4$export$ae5ab1c730825774) ? (0, $7ceeeafb45311bd4$export$ca50aac9f3ba507f) : (0, $7ceeeafb45311bd4$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $2a7086f043393bf1$export$2e2bcd8739ae039)((0, $a58d35a7c563f8e5$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $c99e2a756865540b$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $d7ece3c5b449c172$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $e6eede691da7fa83$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $239d692fb4466bd5$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $7ceeeafb45311bd4$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $7ceeeafb45311bd4$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $7ceeeafb45311bd4$export$79ffe56a765070d2),
                (0, $7ceeeafb45311bd4$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $7ceeeafb45311bd4$export$1e95b668f3b82d),
                (0, $7ceeeafb45311bd4$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $371e624e1761785a$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $7ceeeafb45311bd4$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $bf22a0bca2fcd727$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $7ceeeafb45311bd4$export$368f9a87e87fa4e1) : (0, $7ceeeafb45311bd4$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $bf22a0bca2fcd727$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $7ceeeafb45311bd4$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $0246a59ce632f72b$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $af134027d3678390$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $68ecfbc025cdb17f$var$getExpandedFallbackPlacements(placement) {
    if ((0, $af134027d3678390$export$2e2bcd8739ae039)(placement) === (0, $7ceeeafb45311bd4$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $9216ceee8804002d$export$2e2bcd8739ae039)(placement);
    return [
        (0, $33da2021c4e86f0e$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $33da2021c4e86f0e$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $68ecfbc025cdb17f$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $af134027d3678390$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $9216ceee8804002d$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $68ecfbc025cdb17f$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $af134027d3678390$export$2e2bcd8739ae039)(placement) === (0, $7ceeeafb45311bd4$export$dfb5619354ba860) ? (0, $371e624e1761785a$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $af134027d3678390$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $bf22a0bca2fcd727$export$2e2bcd8739ae039)(placement) === (0, $7ceeeafb45311bd4$export$b3571188c770cc5a);
        var isVertical = [
            (0, $7ceeeafb45311bd4$export$1e95b668f3b82d),
            (0, $7ceeeafb45311bd4$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $0246a59ce632f72b$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $7ceeeafb45311bd4$export$79ffe56a765070d2) : (0, $7ceeeafb45311bd4$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $7ceeeafb45311bd4$export$40e543e69a8b3fbb) : (0, $7ceeeafb45311bd4$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $9216ceee8804002d$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $9216ceee8804002d$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $68ecfbc025cdb17f$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $68ecfbc025cdb17f$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};




function $6ccaccfbe6f0ce9a$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $6ccaccfbe6f0ce9a$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $7ceeeafb45311bd4$export$1e95b668f3b82d),
        (0, $7ceeeafb45311bd4$export$79ffe56a765070d2),
        (0, $7ceeeafb45311bd4$export$40e543e69a8b3fbb),
        (0, $7ceeeafb45311bd4$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $6ccaccfbe6f0ce9a$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $0246a59ce632f72b$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $0246a59ce632f72b$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $6ccaccfbe6f0ce9a$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $6ccaccfbe6f0ce9a$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $6ccaccfbe6f0ce9a$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $6ccaccfbe6f0ce9a$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $6ccaccfbe6f0ce9a$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $6ccaccfbe6f0ce9a$var$hide
};




function $9eca81c7e9ced78f$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $af134027d3678390$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $7ceeeafb45311bd4$export$eabcd2c8791e7bf4),
        (0, $7ceeeafb45311bd4$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $7ceeeafb45311bd4$export$eabcd2c8791e7bf4),
        (0, $7ceeeafb45311bd4$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $9eca81c7e9ced78f$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $7ceeeafb45311bd4$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $9eca81c7e9ced78f$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $9eca81c7e9ced78f$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $9eca81c7e9ced78f$var$offset
};



function $3f30db5754e1c98f$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $e6eede691da7fa83$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $3f30db5754e1c98f$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $3f30db5754e1c98f$var$popperOffsets,
    data: {}
};





function $a8d84858f12e2f63$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}









function $8e75d17e424470bc$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $0246a59ce632f72b$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $af134027d3678390$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $bf22a0bca2fcd727$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $4d3b18a360f5c55d$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $a8d84858f12e2f63$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $7ceeeafb45311bd4$export$1e95b668f3b82d) : (0, $7ceeeafb45311bd4$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $7ceeeafb45311bd4$export$40e543e69a8b3fbb) : (0, $7ceeeafb45311bd4$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $7ceeeafb45311bd4$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $7ceeeafb45311bd4$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $70c6c7f1af6109b4$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $b96712f9d73924b6$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $062be686f3b03ae1$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $29f73c7459974fa6$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $062be686f3b03ae1$export$f28d906d67a997f3)(tether ? (0, $b19d5aae4fdeb8ca$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $b19d5aae4fdeb8ca$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $7ceeeafb45311bd4$export$1e95b668f3b82d) : (0, $7ceeeafb45311bd4$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $7ceeeafb45311bd4$export$40e543e69a8b3fbb) : (0, $7ceeeafb45311bd4$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $7ceeeafb45311bd4$export$1e95b668f3b82d),
            (0, $7ceeeafb45311bd4$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $062be686f3b03ae1$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $062be686f3b03ae1$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $8e75d17e424470bc$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $8e75d17e424470bc$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};







function $0d68eab9acc86397$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $67391bdc5f4a3762$export$2e2bcd8739ae039(node) {
    if (node === (0, $46f3e81cd776f4c8$export$2e2bcd8739ae039)(node) || !(0, $a58d35a7c563f8e5$export$1b3bfaa9684536aa)(node)) return (0, $e616e8cecdc2e5bb$export$2e2bcd8739ae039)(node);
    else return (0, $0d68eab9acc86397$export$2e2bcd8739ae039)(node);
}








function $a7b27491e2165093$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $b19d5aae4fdeb8ca$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $b19d5aae4fdeb8ca$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $a7b27491e2165093$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $a58d35a7c563f8e5$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $a58d35a7c563f8e5$export$1b3bfaa9684536aa)(offsetParent) && $a7b27491e2165093$var$isElementScaled(offsetParent);
    var documentElement = (0, $c99e2a756865540b$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $d7ece3c5b449c172$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $6a8318aab15e9bd0$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $84d12d4e286ea295$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $67391bdc5f4a3762$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $a58d35a7c563f8e5$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $d7ece3c5b449c172$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $13a1cf6927e3535a$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}






function $d9203fbb455dc6b5$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $d9203fbb455dc6b5$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $d9203fbb455dc6b5$var$order(modifiers); // order based on phase
    return (0, $7ceeeafb45311bd4$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $2c79632fd7bb45bf$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $49e5fcc68aa032d4$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $c93eae753a11d759$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $c93eae753a11d759$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $c93eae753a11d759$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $c93eae753a11d759$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $c93eae753a11d759$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $a58d35a7c563f8e5$export$45a5e7f76e0caa8d)(reference) ? (0, $1467a14c32af674d$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $1467a14c32af674d$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $1467a14c32af674d$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $d9203fbb455dc6b5$export$2e2bcd8739ae039)((0, $49e5fcc68aa032d4$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$c93eae753a11d759$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $a7b27491e2165093$export$2e2bcd8739ae039)(reference, (0, $29f73c7459974fa6$export$2e2bcd8739ae039)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $70c6c7f1af6109b4$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $2c79632fd7bb45bf$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$c93eae753a11d759$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $c93eae753a11d759$export$8f7491d57c8f97a9 = /*#__PURE__*/ $c93eae753a11d759$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules


const $52a44912a8ab8575$export$8f7491d57c8f97a9 = (0, $c93eae753a11d759$export$ed5e13716264f202)({
    defaultModifiers: [
        (0, $6ccaccfbe6f0ce9a$export$2e2bcd8739ae039),
        (0, $3f30db5754e1c98f$export$2e2bcd8739ae039),
        (0, $7bef6b18f4629ffc$export$2e2bcd8739ae039),
        (0, $43b44492dc58ef15$export$2e2bcd8739ae039),
        (0, $9eca81c7e9ced78f$export$2e2bcd8739ae039),
        (0, $68ecfbc025cdb17f$export$2e2bcd8739ae039),
        (0, $8e75d17e424470bc$export$2e2bcd8739ae039),
        (0, $488a7a88112c55e7$export$2e2bcd8739ae039)
    ]
});


const $24ab08ee897405f9$var$_excluded = [
    "enabled",
    "placement",
    "strategy",
    "modifiers"
];
function $24ab08ee897405f9$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
const $24ab08ee897405f9$var$disabledApplyStylesModifier = {
    name: 'applyStyles',
    enabled: false,
    phase: 'afterWrite',
    fn: ()=>undefined
};
// until docjs supports type exports...
const $24ab08ee897405f9$var$ariaDescribedByModifier = {
    name: 'ariaDescribedBy',
    enabled: true,
    phase: 'afterWrite',
    effect: ({ state: state })=>()=>{
            const { reference: reference, popper: popper } = state.elements;
            if ('removeAttribute' in reference) {
                const ids = (reference.getAttribute('aria-describedby') || '').split(',').filter((id)=>id.trim() !== popper.id);
                if (!ids.length) reference.removeAttribute('aria-describedby');
                else reference.setAttribute('aria-describedby', ids.join(','));
            }
        },
    fn: ({ state: state })=>{
        var _popper$getAttribute;
        const { popper: popper, reference: reference } = state.elements;
        const role = (_popper$getAttribute = popper.getAttribute('role')) == null ? void 0 : _popper$getAttribute.toLowerCase();
        if (popper.id && role === 'tooltip' && 'setAttribute' in reference) {
            const ids = reference.getAttribute('aria-describedby');
            if (ids && ids.split(',').indexOf(popper.id) !== -1) return;
            reference.setAttribute('aria-describedby', ids ? `${ids},${popper.id}` : popper.id);
        }
    }
};
const $24ab08ee897405f9$var$EMPTY_MODIFIERS = [];
/**
 * Position an element relative some reference element using Popper.js
 *
 * @param referenceElement
 * @param popperElement
 * @param {object}      options
 * @param {object=}     options.modifiers Popper.js modifiers
 * @param {boolean=}    options.enabled toggle the popper functionality on/off
 * @param {string=}     options.placement The popper element placement relative to the reference element
 * @param {string=}     options.strategy the positioning strategy
 * @param {function=}   options.onCreate called when the popper is created
 * @param {function=}   options.onUpdate called when the popper is updated
 *
 * @returns {UsePopperState} The popper state
 */ function $24ab08ee897405f9$var$usePopper(referenceElement, popperElement, _ref = {}) {
    let { enabled: enabled = true, placement: placement = 'bottom', strategy: strategy = 'absolute', modifiers: modifiers = $24ab08ee897405f9$var$EMPTY_MODIFIERS } = _ref, config = $24ab08ee897405f9$var$_objectWithoutPropertiesLoose(_ref, $24ab08ee897405f9$var$_excluded);
    const prevModifiers = (0, $kc00y.useRef)(modifiers);
    const popperInstanceRef = (0, $kc00y.useRef)();
    const update = (0, $kc00y.useCallback)(()=>{
        var _popperInstanceRef$cu;
        (_popperInstanceRef$cu = popperInstanceRef.current) == null || _popperInstanceRef$cu.update();
    }, []);
    const forceUpdate = (0, $kc00y.useCallback)(()=>{
        var _popperInstanceRef$cu2;
        (_popperInstanceRef$cu2 = popperInstanceRef.current) == null || _popperInstanceRef$cu2.forceUpdate();
    }, []);
    const [popperState, setState] = (0, $b1e206547c363bcb$export$2e2bcd8739ae039)((0, $kc00y.useState)({
        placement: placement,
        update: update,
        forceUpdate: forceUpdate,
        attributes: {},
        styles: {
            popper: {},
            arrow: {}
        }
    }));
    const updateModifier = (0, $kc00y.useMemo)(()=>({
            name: 'updateStateModifier',
            enabled: true,
            phase: 'write',
            requires: [
                'computeStyles'
            ],
            fn: ({ state: state })=>{
                const styles = {};
                const attributes = {};
                Object.keys(state.elements).forEach((element)=>{
                    styles[element] = state.styles[element];
                    attributes[element] = state.attributes[element];
                });
                setState({
                    state: state,
                    styles: styles,
                    attributes: attributes,
                    update: update,
                    forceUpdate: forceUpdate,
                    placement: state.placement
                });
            }
        }), [
        update,
        forceUpdate,
        setState
    ]);
    const nextModifiers = (0, $kc00y.useMemo)(()=>{
        if (!(0, $f035112a1ee37c2c$export$de8294bb3be0322f)(prevModifiers.current, modifiers)) prevModifiers.current = modifiers;
        return prevModifiers.current;
    }, [
        modifiers
    ]);
    (0, $kc00y.useEffect)(()=>{
        if (!popperInstanceRef.current || !enabled) return;
        popperInstanceRef.current.setOptions({
            placement: placement,
            strategy: strategy,
            modifiers: [
                ...nextModifiers,
                updateModifier,
                $24ab08ee897405f9$var$disabledApplyStylesModifier
            ]
        });
    }, [
        strategy,
        placement,
        updateModifier,
        enabled,
        nextModifiers
    ]);
    (0, $kc00y.useEffect)(()=>{
        if (!enabled || referenceElement == null || popperElement == null) return undefined;
        popperInstanceRef.current = (0, $52a44912a8ab8575$export$8f7491d57c8f97a9)(referenceElement, popperElement, Object.assign({}, config, {
            placement: placement,
            strategy: strategy,
            modifiers: [
                ...nextModifiers,
                $24ab08ee897405f9$var$ariaDescribedByModifier,
                updateModifier
            ]
        }));
        return ()=>{
            if (popperInstanceRef.current != null) {
                popperInstanceRef.current.destroy();
                popperInstanceRef.current = undefined;
                setState((s)=>Object.assign({}, s, {
                        attributes: {},
                        styles: {
                            popper: {}
                        }
                    }));
            }
        };
    // This is only run once to _create_ the popper
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        enabled,
        referenceElement,
        popperElement
    ]);
    return popperState;
}
var $24ab08ee897405f9$export$2e2bcd8739ae039 = $24ab08ee897405f9$var$usePopper;





var $kc00y = parcelRequire("kc00y");





var $kc00y = parcelRequire("kc00y");


const $cba6c8f98b365b95$var$noop = ()=>{};
function $cba6c8f98b365b95$var$isLeftClickEvent(event) {
    return event.button === 0;
}
function $cba6c8f98b365b95$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
const $cba6c8f98b365b95$export$347601c75fcd4732 = (ref)=>ref && ('current' in ref ? ref.current : ref);
const $cba6c8f98b365b95$var$InitialTriggerEvents = {
    click: 'mousedown',
    mouseup: 'mousedown',
    pointerup: 'pointerdown'
};
/**
 * The `useClickOutside` hook registers your callback on the document that fires
 * when a pointer event is registered outside of the provided ref or element.
 *
 * @param {Ref<HTMLElement>| HTMLElement} ref  The element boundary
 * @param {function} onClickOutside
 * @param {object=}  options
 * @param {boolean=} options.disabled
 * @param {string=}  options.clickTrigger The DOM event name (click, mousedown, etc) to attach listeners on
 */ function $cba6c8f98b365b95$var$useClickOutside(ref, onClickOutside = $cba6c8f98b365b95$var$noop, { disabled: disabled, clickTrigger: clickTrigger = 'click' } = {}) {
    const preventMouseClickOutsideRef = (0, $kc00y.useRef)(false);
    const waitingForTrigger = (0, $kc00y.useRef)(false);
    const handleMouseCapture = (0, $kc00y.useCallback)((e)=>{
        const currentTarget = $cba6c8f98b365b95$export$347601c75fcd4732(ref);
        (0, (/*@__PURE__*/$parcel$interopDefault($61fad0cb6b7e8586$exports)))(!!currentTarget, "ClickOutside captured a close event but does not have a ref to compare it to. useClickOutside(), should be passed a ref that resolves to a DOM node");
        preventMouseClickOutsideRef.current = !currentTarget || $cba6c8f98b365b95$var$isModifiedEvent(e) || !$cba6c8f98b365b95$var$isLeftClickEvent(e) || !!(0, $1416702938ee6af3$export$2e2bcd8739ae039)(currentTarget, e.target) || waitingForTrigger.current;
        waitingForTrigger.current = false;
    }, [
        ref
    ]);
    const handleInitialMouse = (0, $0261b276e783eb4f$export$2e2bcd8739ae039)((e)=>{
        const currentTarget = $cba6c8f98b365b95$export$347601c75fcd4732(ref);
        if (currentTarget && (0, $1416702938ee6af3$export$2e2bcd8739ae039)(currentTarget, e.target)) waitingForTrigger.current = true;
        else // When clicking on scrollbars within current target, click events are not triggered, so this ref
        // is never reset inside `handleMouseCapture`. This would cause a bug where it requires 2 clicks
        // to close the overlay.
        waitingForTrigger.current = false;
    });
    const handleMouse = (0, $0261b276e783eb4f$export$2e2bcd8739ae039)((e)=>{
        if (!preventMouseClickOutsideRef.current) onClickOutside(e);
    });
    (0, $kc00y.useEffect)(()=>{
        var _ownerWindow$event, _ownerWindow$parent;
        if (disabled || ref == null) return undefined;
        const doc = (0, $3b44b30b48869541$export$2e2bcd8739ae039)($cba6c8f98b365b95$export$347601c75fcd4732(ref));
        const ownerWindow = doc.defaultView || window;
        // Store the current event to avoid triggering handlers immediately
        // For things rendered in an iframe, the event might originate on the parent window
        // so we should fall back to that global event if the local one doesn't exist
        // https://github.com/facebook/react/issues/20074
        let currentEvent = (_ownerWindow$event = ownerWindow.event) != null ? _ownerWindow$event : (_ownerWindow$parent = ownerWindow.parent) == null ? void 0 : _ownerWindow$parent.event;
        let removeInitialTriggerListener = null;
        if ($cba6c8f98b365b95$var$InitialTriggerEvents[clickTrigger]) removeInitialTriggerListener = (0, $f36f0227633f632b$export$2e2bcd8739ae039)(doc, $cba6c8f98b365b95$var$InitialTriggerEvents[clickTrigger], handleInitialMouse, true);
        // Use capture for this listener so it fires before React's listener, to
        // avoid false positives in the contains() check below if the target DOM
        // element is removed in the React mouse callback.
        const removeMouseCaptureListener = (0, $f36f0227633f632b$export$2e2bcd8739ae039)(doc, clickTrigger, handleMouseCapture, true);
        const removeMouseListener = (0, $f36f0227633f632b$export$2e2bcd8739ae039)(doc, clickTrigger, (e)=>{
            // skip if this event is the same as the one running when we added the handlers
            if (e === currentEvent) {
                currentEvent = undefined;
                return;
            }
            handleMouse(e);
        });
        let mobileSafariHackListeners = [];
        if ('ontouchstart' in doc.documentElement) mobileSafariHackListeners = [].slice.call(doc.body.children).map((el)=>(0, $f36f0227633f632b$export$2e2bcd8739ae039)(el, 'mousemove', $cba6c8f98b365b95$var$noop));
        return ()=>{
            removeInitialTriggerListener == null || removeInitialTriggerListener();
            removeMouseCaptureListener();
            removeMouseListener();
            mobileSafariHackListeners.forEach((remove)=>remove());
        };
    }, [
        ref,
        disabled,
        clickTrigger,
        handleMouseCapture,
        handleInitialMouse,
        handleMouse
    ]);
}
var $cba6c8f98b365b95$export$2e2bcd8739ae039 = $cba6c8f98b365b95$var$useClickOutside;



const $fd37908a5c2d91e4$var$noop = ()=>{};
/**
 * The `useRootClose` hook registers your callback on the document
 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
 * style behavior where your callback is triggered when the user tries to
 * interact with the rest of the document or hits the `esc` key.
 *
 * @param {Ref<HTMLElement>| HTMLElement} ref  The element boundary
 * @param {function} onRootClose
 * @param {object=}  options
 * @param {boolean=} options.disabled
 * @param {string=}  options.clickTrigger The DOM event name (click, mousedown, etc) to attach listeners on
 */ function $fd37908a5c2d91e4$var$useRootClose(ref, onRootClose, { disabled: disabled, clickTrigger: clickTrigger } = {}) {
    const onClose = onRootClose || $fd37908a5c2d91e4$var$noop;
    (0, $cba6c8f98b365b95$export$2e2bcd8739ae039)(ref, onClose, {
        disabled: disabled,
        clickTrigger: clickTrigger
    });
    const handleKeyUp = (0, $0261b276e783eb4f$export$2e2bcd8739ae039)((e)=>{
        if ((0, $91d5586e687d56e1$export$806fcc22e55e107d)(e)) onClose(e);
    });
    (0, $kc00y.useEffect)(()=>{
        if (disabled || ref == null) return undefined;
        const doc = (0, $3b44b30b48869541$export$2e2bcd8739ae039)((0, $cba6c8f98b365b95$export$347601c75fcd4732)(ref));
        // Store the current event to avoid triggering handlers immediately
        // https://github.com/facebook/react/issues/20074
        let currentEvent = (doc.defaultView || window).event;
        const removeKeyupListener = (0, $f36f0227633f632b$export$2e2bcd8739ae039)(doc, 'keyup', (e)=>{
            // skip if this event is the same as the one running when we added the handlers
            if (e === currentEvent) {
                currentEvent = undefined;
                return;
            }
            handleKeyUp(e);
        });
        return ()=>{
            removeKeyupListener();
        };
    }, [
        ref,
        disabled,
        handleKeyUp
    ]);
}
var $fd37908a5c2d91e4$export$2e2bcd8739ae039 = $fd37908a5c2d91e4$var$useRootClose;



function $fbf0dea5f10fe2a4$export$ba6dad097c8f5c38(modifiers) {
    const result = {};
    if (!Array.isArray(modifiers)) return modifiers || result;
    // eslint-disable-next-line no-unused-expressions
    modifiers == null || modifiers.forEach((m)=>{
        result[m.name] = m;
    });
    return result;
}
function $fbf0dea5f10fe2a4$export$af3a999d4a134c86(map = {}) {
    if (Array.isArray(map)) return map;
    return Object.keys(map).map((k)=>{
        map[k].name = k;
        return map[k];
    });
}
function $fbf0dea5f10fe2a4$export$2e2bcd8739ae039({ enabled: enabled, enableEvents: enableEvents, placement: placement, flip: flip, offset: offset, fixed: fixed, containerPadding: containerPadding, arrowElement: arrowElement, popperConfig: popperConfig = {} }) {
    var _modifiers$eventListe, _modifiers$preventOve, _modifiers$preventOve2, _modifiers$offset, _modifiers$arrow;
    const modifiers = $fbf0dea5f10fe2a4$export$ba6dad097c8f5c38(popperConfig.modifiers);
    return Object.assign({}, popperConfig, {
        placement: placement,
        enabled: enabled,
        strategy: fixed ? 'fixed' : popperConfig.strategy,
        modifiers: $fbf0dea5f10fe2a4$export$af3a999d4a134c86(Object.assign({}, modifiers, {
            eventListeners: {
                enabled: enableEvents,
                options: (_modifiers$eventListe = modifiers.eventListeners) == null ? void 0 : _modifiers$eventListe.options
            },
            preventOverflow: Object.assign({}, modifiers.preventOverflow, {
                options: containerPadding ? Object.assign({
                    padding: containerPadding
                }, (_modifiers$preventOve = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve.options) : (_modifiers$preventOve2 = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve2.options
            }),
            offset: {
                options: Object.assign({
                    offset: offset
                }, (_modifiers$offset = modifiers.offset) == null ? void 0 : _modifiers$offset.options)
            },
            arrow: Object.assign({}, modifiers.arrow, {
                enabled: !!arrowElement,
                options: Object.assign({}, (_modifiers$arrow = modifiers.arrow) == null ? void 0 : _modifiers$arrow.options, {
                    element: arrowElement
                })
            }),
            flip: Object.assign({
                enabled: !!flip
            }, modifiers.flip)
        }))
    });
}



/**
 * Built on top of `Popper.js`, the overlay component is
 * great for custom tooltip overlays.
 */ const $eaf70213777e0419$var$Overlay = /*#__PURE__*/ $kc00y.forwardRef((props, outerRef)=>{
    const { flip: flip, offset: offset, placement: placement, containerPadding: containerPadding, popperConfig: popperConfig = {}, transition: Transition, runTransition: runTransition } = props;
    const [rootElement, attachRef] = (0, $076d41a58396540c$export$2e2bcd8739ae039)();
    const [arrowElement, attachArrowRef] = (0, $076d41a58396540c$export$2e2bcd8739ae039)();
    const mergedRef = (0, $e83f66af48ac0793$export$2e2bcd8739ae039)(attachRef, outerRef);
    const container = (0, $7297954784ff1701$export$2e2bcd8739ae039)(props.container);
    const target = (0, $7297954784ff1701$export$2e2bcd8739ae039)(props.target);
    const [exited, setExited] = (0, $kc00y.useState)(!props.show);
    const popper = (0, $24ab08ee897405f9$export$2e2bcd8739ae039)(target, rootElement, (0, $fbf0dea5f10fe2a4$export$2e2bcd8739ae039)({
        placement: placement,
        enableEvents: !!props.show,
        containerPadding: containerPadding || 5,
        flip: flip,
        offset: offset,
        arrowElement: arrowElement,
        popperConfig: popperConfig
    }));
    // TODO: I think this needs to be in an effect
    if (props.show && exited) setExited(false);
    const handleHidden = (...args)=>{
        setExited(true);
        if (props.onExited) props.onExited(...args);
    };
    // Don't un-render the overlay while it's transitioning out.
    const mountOverlay = props.show || !exited;
    (0, $fd37908a5c2d91e4$export$2e2bcd8739ae039)(rootElement, props.onHide, {
        disabled: !props.rootClose || props.rootCloseDisabled,
        clickTrigger: props.rootCloseEvent
    });
    if (!mountOverlay) // Don't bother showing anything if we don't have to.
    return null;
    const { onExit: onExit, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onEntered: onEntered } = props;
    let child = props.children(Object.assign({}, popper.attributes.popper, {
        style: popper.styles.popper,
        ref: mergedRef
    }), {
        popper: popper,
        placement: placement,
        show: !!props.show,
        arrowProps: Object.assign({}, popper.attributes.arrow, {
            style: popper.styles.arrow,
            ref: attachArrowRef
        })
    });
    child = (0, $f7bb0e3ef4a0f95f$export$f41d64aae6d6dba5)(Transition, runTransition, {
        in: !!props.show,
        appear: true,
        mountOnEnter: true,
        unmountOnExit: true,
        children: child,
        onExit: onExit,
        onExiting: onExiting,
        onExited: handleHidden,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered
    });
    return container ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9018fd8b87cabbb7$exports))).createPortal(child, container) : null;
});
$eaf70213777e0419$var$Overlay.displayName = 'Overlay';
var $eaf70213777e0419$export$2e2bcd8739ae039 = $eaf70213777e0419$var$Overlay;




var $kc00y = parcelRequire("kc00y");
const $a72fb555b4b57bff$var$isReactNative = typeof $parcel$global !== 'undefined' && // @ts-ignore
$parcel$global.navigator && // @ts-ignore
$parcel$global.navigator.product === 'ReactNative';
const $a72fb555b4b57bff$var$isDOM = typeof document !== 'undefined';
var /**
 * Is `useLayoutEffect` in a DOM or React Native environment, otherwise resolves to useEffect
 * Only useful to avoid the console warning.
 *
 * PREFER `useEffect` UNLESS YOU KNOW WHAT YOU ARE DOING.
 *
 * @category effects
 */ $a72fb555b4b57bff$export$2e2bcd8739ae039 = $a72fb555b4b57bff$var$isDOM || $a72fb555b4b57bff$var$isReactNative ? (0, $kc00y.useLayoutEffect) : (0, $kc00y.useEffect);




var $kc00y = parcelRequire("kc00y");




var $kc00y = parcelRequire("kc00y");


var $kc00y = parcelRequire("kc00y");



"use client";
const $bc63851decf03106$var$PopoverHeader = /*#__PURE__*/ $kc00y.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(bsPrefix, 'popover-header');
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, bsPrefix),
        ...props
    });
});
$bc63851decf03106$var$PopoverHeader.displayName = 'PopoverHeader';
var $bc63851decf03106$export$2e2bcd8739ae039 = $bc63851decf03106$var$PopoverHeader;



var $kc00y = parcelRequire("kc00y");



"use client";
const $7da83f2f4c5fcff9$var$PopoverBody = /*#__PURE__*/ $kc00y.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(bsPrefix, 'popover-body');
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, bsPrefix),
        ...props
    });
});
$7da83f2f4c5fcff9$var$PopoverBody.displayName = 'PopoverBody';
var $7da83f2f4c5fcff9$export$2e2bcd8739ae039 = $7da83f2f4c5fcff9$var$PopoverBody;



var $kc00y = parcelRequire("kc00y");
class $0f86490ce402600f$export$34582a676b91ff07 extends $kc00y.Component {
}
function $0f86490ce402600f$export$c15856915a9b3464(placement, isRTL) {
    let bsDirection = placement;
    if (placement === 'left') bsDirection = isRTL ? 'end' : 'start';
    else if (placement === 'right') bsDirection = isRTL ? 'start' : 'end';
    return bsDirection;
}


function $3bfcc6398577e1ba$export$2e2bcd8739ae039(position = 'absolute') {
    return {
        position: position,
        top: '0',
        left: '0',
        opacity: '0',
        pointerEvents: 'none'
    };
}



"use client";
const $24bc7fd4c9d44342$var$Popover = /*#__PURE__*/ $kc00y.forwardRef(({ bsPrefix: bsPrefix, placement: placement = 'right', className: className, style: style, children: children, body: body, arrowProps: arrowProps, hasDoneInitialMeasure: hasDoneInitialMeasure, popper: popper, show: show, ...props }, ref)=>{
    const decoratedBsPrefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(bsPrefix, 'popover');
    const isRTL = (0, $6c3886f519efe212$export$35e511eefa30ac5a)();
    const [primaryPlacement] = (placement == null ? void 0 : placement.split('-')) || [];
    const bsDirection = (0, $0f86490ce402600f$export$c15856915a9b3464)(primaryPlacement, isRTL);
    let computedStyle = style;
    if (show && !hasDoneInitialMeasure) computedStyle = {
        ...style,
        ...(0, $3bfcc6398577e1ba$export$2e2bcd8739ae039)(popper == null ? void 0 : popper.strategy)
    };
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
        ref: ref,
        role: "tooltip",
        style: computedStyle,
        "x-placement": primaryPlacement,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, decoratedBsPrefix, primaryPlacement && `bs-popover-${bsDirection}`),
        ...props,
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                className: "popover-arrow",
                ...arrowProps
            }),
            body ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $7da83f2f4c5fcff9$export$2e2bcd8739ae039), {
                children: children
            }) : children
        ]
    });
});
$24bc7fd4c9d44342$var$Popover.displayName = 'Popover';
var $24bc7fd4c9d44342$export$2e2bcd8739ae039 = Object.assign($24bc7fd4c9d44342$var$Popover, {
    Header: (0, $bc63851decf03106$export$2e2bcd8739ae039),
    Body: (0, $7da83f2f4c5fcff9$export$2e2bcd8739ae039),
    // Default popover offset.
    // https://github.com/twbs/bootstrap/blob/5c32767e0e0dbac2d934bcdee03719a65d3f1187/js/src/popover.js#L28
    POPPER_OFFSET: [
        0,
        8
    ]
});




var $kc00y = parcelRequire("kc00y");




"use client";
const $fbf962b4d348672d$var$Tooltip = /*#__PURE__*/ $kc00y.forwardRef(({ bsPrefix: bsPrefix, placement: placement = 'right', className: className, style: style, children: children, arrowProps: arrowProps, hasDoneInitialMeasure: hasDoneInitialMeasure, popper: popper, show: show, ...props }, ref)=>{
    bsPrefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(bsPrefix, 'tooltip');
    const isRTL = (0, $6c3886f519efe212$export$35e511eefa30ac5a)();
    const [primaryPlacement] = (placement == null ? void 0 : placement.split('-')) || [];
    const bsDirection = (0, $0f86490ce402600f$export$c15856915a9b3464)(primaryPlacement, isRTL);
    let computedStyle = style;
    if (show && !hasDoneInitialMeasure) computedStyle = {
        ...style,
        ...(0, $3bfcc6398577e1ba$export$2e2bcd8739ae039)(popper == null ? void 0 : popper.strategy)
    };
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
        ref: ref,
        style: computedStyle,
        role: "tooltip",
        "x-placement": primaryPlacement,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, bsPrefix, `bs-tooltip-${bsDirection}`),
        ...props,
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                className: "tooltip-arrow",
                ...arrowProps
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                className: `${bsPrefix}-inner`,
                children: children
            })
        ]
    });
});
$fbf962b4d348672d$var$Tooltip.displayName = 'Tooltip';
var $fbf962b4d348672d$export$2e2bcd8739ae039 = Object.assign($fbf962b4d348672d$var$Tooltip, {
    // Default tooltip offset.
    // https://github.com/twbs/bootstrap/blob/beca2a6c7f6bc88b6449339fc76edcda832c59e5/js/src/tooltip.js#L65
    TOOLTIP_OFFSET: [
        0,
        6
    ]
});


"use client";
function $56b738e5d6d20839$export$2e2bcd8739ae039(customOffset) {
    const overlayRef = (0, $kc00y.useRef)(null);
    const popoverClass = (0, $6c3886f519efe212$export$7f387860ebffb32c)(undefined, 'popover');
    const tooltipClass = (0, $6c3886f519efe212$export$7f387860ebffb32c)(undefined, 'tooltip');
    const offset = (0, $kc00y.useMemo)(()=>({
            name: 'offset',
            options: {
                offset: ()=>{
                    if (customOffset) return customOffset;
                    if (overlayRef.current) {
                        if ((0, $c6f47c13d4796d39$export$2e2bcd8739ae039)(overlayRef.current, popoverClass)) return (0, $24bc7fd4c9d44342$export$2e2bcd8739ae039).POPPER_OFFSET;
                        if ((0, $c6f47c13d4796d39$export$2e2bcd8739ae039)(overlayRef.current, tooltipClass)) return (0, $fbf962b4d348672d$export$2e2bcd8739ae039).TOOLTIP_OFFSET;
                    }
                    return [
                        0,
                        0
                    ];
                }
            }
        }), [
        customOffset,
        popoverClass,
        tooltipClass
    ]);
    return [
        overlayRef,
        [
            offset
        ]
    ];
}





"use client";
function $ebf0018bb6c6294b$var$wrapRefs(props, arrowProps) {
    const { ref: ref } = props;
    const { ref: aRef } = arrowProps;
    props.ref = ref.__wrapped || (ref.__wrapped = (r)=>ref((0, $4715ea7dc6e2917f$export$2e2bcd8739ae039)(r)));
    arrowProps.ref = aRef.__wrapped || (aRef.__wrapped = (r)=>aRef((0, $4715ea7dc6e2917f$export$2e2bcd8739ae039)(r)));
}
const $ebf0018bb6c6294b$var$Overlay = /*#__PURE__*/ $kc00y.forwardRef(({ children: overlay, transition: transition = (0, $25d8c693c355530c$export$2e2bcd8739ae039), popperConfig: popperConfig = {}, rootClose: rootClose = false, placement: placement = 'top', show: outerShow = false, ...outerProps }, outerRef)=>{
    const popperRef = (0, $kc00y.useRef)({});
    const [firstRenderedState, setFirstRenderedState] = (0, $kc00y.useState)(null);
    const [ref, modifiers] = (0, $56b738e5d6d20839$export$2e2bcd8739ae039)(outerProps.offset);
    const mergedRef = (0, $950969aa8a9dbb93$export$2e2bcd8739ae039)(outerRef, ref);
    const actualTransition = transition === true ? (0, $25d8c693c355530c$export$2e2bcd8739ae039) : transition || undefined;
    const handleFirstUpdate = (0, $4655b62db0931f1e$export$2e2bcd8739ae039)((state)=>{
        setFirstRenderedState(state);
        popperConfig == null || popperConfig.onFirstUpdate == null || popperConfig.onFirstUpdate(state);
    });
    (0, $a72fb555b4b57bff$export$2e2bcd8739ae039)(()=>{
        if (firstRenderedState && outerProps.target) // Must wait for target element to resolve before updating popper.
        popperRef.current.scheduleUpdate == null || popperRef.current.scheduleUpdate();
    }, [
        firstRenderedState,
        outerProps.target
    ]);
    (0, $kc00y.useEffect)(()=>{
        if (!outerShow) setFirstRenderedState(null);
    }, [
        outerShow
    ]);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eaf70213777e0419$export$2e2bcd8739ae039), {
        ...outerProps,
        ref: mergedRef,
        popperConfig: {
            ...popperConfig,
            modifiers: modifiers.concat(popperConfig.modifiers || []),
            onFirstUpdate: handleFirstUpdate
        },
        transition: actualTransition,
        rootClose: rootClose,
        placement: placement,
        show: outerShow,
        children: (overlayProps, { arrowProps: arrowProps, popper: popperObj, show: show })=>{
            var _popperObj$state;
            $ebf0018bb6c6294b$var$wrapRefs(overlayProps, arrowProps);
            // Need to get placement from popper object, handling case when overlay is flipped using 'flip' prop
            const updatedPlacement = popperObj == null ? void 0 : popperObj.placement;
            const popper = Object.assign(popperRef.current, {
                state: popperObj == null ? void 0 : popperObj.state,
                scheduleUpdate: popperObj == null ? void 0 : popperObj.update,
                placement: updatedPlacement,
                outOfBoundaries: (popperObj == null || (_popperObj$state = popperObj.state) == null || (_popperObj$state = _popperObj$state.modifiersData.hide) == null ? void 0 : _popperObj$state.isReferenceHidden) || false,
                strategy: popperConfig.strategy
            });
            const hasDoneInitialMeasure = !!firstRenderedState;
            if (typeof overlay === 'function') return overlay({
                ...overlayProps,
                placement: updatedPlacement,
                show: show,
                ...!transition && show && {
                    className: 'show'
                },
                popper: popper,
                arrowProps: arrowProps,
                hasDoneInitialMeasure: hasDoneInitialMeasure
            });
            return /*#__PURE__*/ $kc00y.cloneElement(overlay, {
                ...overlayProps,
                placement: updatedPlacement,
                arrowProps: arrowProps,
                popper: popper,
                hasDoneInitialMeasure: hasDoneInitialMeasure,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(overlay.props.className, !transition && show && 'show'),
                style: {
                    ...overlay.props.style,
                    ...overlayProps.style
                }
            });
        }
    });
});
$ebf0018bb6c6294b$var$Overlay.displayName = 'Overlay';
var $ebf0018bb6c6294b$export$2e2bcd8739ae039 = $ebf0018bb6c6294b$var$Overlay;




"use client";
function $4c986386eda483ee$var$normalizeDelay(delay) {
    return delay && typeof delay === 'object' ? delay : {
        show: delay,
        hide: delay
    };
}
// Simple implementation of mouseEnter and mouseLeave.
// React's built version is broken: https://github.com/facebook/react/issues/4251
// for cases when the trigger is disabled and mouseOut/Over can cause flicker
// moving from one child element to another.
function $4c986386eda483ee$var$handleMouseOverOut(handler, args, relatedNative) {
    const [e] = args;
    const target = e.currentTarget;
    const related = e.relatedTarget || e.nativeEvent[relatedNative];
    if ((!related || related !== target) && !(0, $1416702938ee6af3$export$2e2bcd8739ae039)(target, related)) handler(...args);
}
const $4c986386eda483ee$var$triggerType = (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).oneOf([
    'click',
    'hover',
    'focus'
]);
const $4c986386eda483ee$var$OverlayTrigger = ({ trigger: trigger = [
    'hover',
    'focus'
], overlay: overlay, children: children, popperConfig: popperConfig = {}, show: propsShow, defaultShow: defaultShow = false, onToggle: onToggle, delay: propsDelay, placement: placement, flip: flip = placement && placement.indexOf('auto') !== -1, ...props })=>{
    const triggerNodeRef = (0, $kc00y.useRef)(null);
    const mergedRef = (0, $950969aa8a9dbb93$export$2e2bcd8739ae039)(triggerNodeRef, (0, $91d5586e687d56e1$export$87943f2672146d57)(children));
    const timeout = (0, $a94bfcd8f48e4d34$export$2e2bcd8739ae039)();
    const hoverStateRef = (0, $kc00y.useRef)('');
    const [show, setShow] = (0, $b0582fd40c314767$export$2ee51287a16ca325)(propsShow, defaultShow, onToggle);
    const delay = $4c986386eda483ee$var$normalizeDelay(propsDelay);
    const { onFocus: onFocus, onBlur: onBlur, onClick: onClick } = typeof children !== 'function' ? $kc00y.Children.only(children).props : {};
    const attachRef = (r)=>{
        mergedRef((0, $4715ea7dc6e2917f$export$2e2bcd8739ae039)(r));
    };
    const handleShow = (0, $kc00y.useCallback)(()=>{
        timeout.clear();
        hoverStateRef.current = 'show';
        if (!delay.show) {
            setShow(true);
            return;
        }
        timeout.set(()=>{
            if (hoverStateRef.current === 'show') setShow(true);
        }, delay.show);
    }, [
        delay.show,
        setShow,
        timeout
    ]);
    const handleHide = (0, $kc00y.useCallback)(()=>{
        timeout.clear();
        hoverStateRef.current = 'hide';
        if (!delay.hide) {
            setShow(false);
            return;
        }
        timeout.set(()=>{
            if (hoverStateRef.current === 'hide') setShow(false);
        }, delay.hide);
    }, [
        delay.hide,
        setShow,
        timeout
    ]);
    const handleFocus = (0, $kc00y.useCallback)((...args)=>{
        handleShow();
        onFocus == null || onFocus(...args);
    }, [
        handleShow,
        onFocus
    ]);
    const handleBlur = (0, $kc00y.useCallback)((...args)=>{
        handleHide();
        onBlur == null || onBlur(...args);
    }, [
        handleHide,
        onBlur
    ]);
    const handleClick = (0, $kc00y.useCallback)((...args)=>{
        setShow(!show);
        onClick == null || onClick(...args);
    }, [
        onClick,
        setShow,
        show
    ]);
    const handleMouseOver = (0, $kc00y.useCallback)((...args)=>{
        $4c986386eda483ee$var$handleMouseOverOut(handleShow, args, 'fromElement');
    }, [
        handleShow
    ]);
    const handleMouseOut = (0, $kc00y.useCallback)((...args)=>{
        $4c986386eda483ee$var$handleMouseOverOut(handleHide, args, 'toElement');
    }, [
        handleHide
    ]);
    const triggers = trigger == null ? [] : [].concat(trigger);
    const triggerProps = {
        ref: attachRef
    };
    if (triggers.indexOf('click') !== -1) triggerProps.onClick = handleClick;
    if (triggers.indexOf('focus') !== -1) {
        triggerProps.onFocus = handleFocus;
        triggerProps.onBlur = handleBlur;
    }
    if (triggers.indexOf('hover') !== -1) {
        triggerProps.onMouseOver = handleMouseOver;
        triggerProps.onMouseOut = handleMouseOut;
    }
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            typeof children === 'function' ? children(triggerProps) : /*#__PURE__*/ (0, $kc00y.cloneElement)(children, triggerProps),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ebf0018bb6c6294b$export$2e2bcd8739ae039), {
                ...props,
                show: show,
                onHide: handleHide,
                flip: flip,
                placement: placement,
                popperConfig: popperConfig,
                target: triggerNodeRef.current,
                children: overlay
            })
        ]
    });
};
var $4c986386eda483ee$export$2e2bcd8739ae039 = $4c986386eda483ee$var$OverlayTrigger;


const $26478c730c1b77dd$var$TooltipCustom = ({ tooltipText: tooltipText, tooltipId: tooltipId, tooltipHeader: tooltipHeader, placement: placement = "bottom", maxWidth: maxWidth, children: children, nowrap: nowrap = true, visibleMap: visibleMap = true })=>{
    const [showTooltip, setShowTooltip] = (0, $kc00y.useState)(false);
    // Masque la tooltip lors du click sur le children
    const handleButtonClick = ()=>{
        setShowTooltip(false);
    };
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
        className: "tooltip-wrapper m-0 p-0",
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $4c986386eda483ee$export$2e2bcd8739ae039), {
            /*
           Ajoute la tooltips au composant map-container si il existe pour qu'elle s'affiche
           aussi en fullscreen
    */ container: visibleMap ? document.getElementById("map-container") : document.body,
            show: showTooltip,
            overlay: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $24bc7fd4c9d44342$export$2e2bcd8739ae039), {
                id: tooltipId,
                className: "tooltip-popover",
                children: [
                    tooltipHeader && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $24bc7fd4c9d44342$export$2e2bcd8739ae039).Header, {
                        as: "h3",
                        children: tooltipHeader
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $24bc7fd4c9d44342$export$2e2bcd8739ae039).Body, {
                        children: tooltipText
                    })
                ]
            }),
            placement: placement,
            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                onMouseEnter: ()=>setShowTooltip(true),
                onMouseLeave: ()=>setShowTooltip(false),
                onClick: handleButtonClick,
                style: {
                    maxWidth: maxWidth,
                    overflowX: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: nowrap ? "nowrap" : "normal"
                },
                children: children
            })
        })
    });
};
var $26478c730c1b77dd$export$2e2bcd8739ae039 = $26478c730c1b77dd$var$TooltipCustom;


const $4c9f3f4d48e33e9a$var$ConfirmButtonWithModal = ({ path: path, reload: reload, icon: icon, disabled: disabled = false, classEnable: classEnable, textDisable: textDisable, textEnable: textEnable, tooltipId: tooltipId, isPost: isPost = true, header: header, content: content, variant: variant = "link", className: className = "p-0 m-0" })=>{
    const { visible: visible, show: show, close: close, ref: ref } = (0, $ca8671088139af49$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                tooltipText: disabled ? textDisable : textEnable,
                tooltipId: tooltipId,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                    variant: variant,
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, disabled ? "text-decoration-none text-muted" : "text-decoration-none text-" + classEnable),
                    disabled: disabled,
                    onClick: ()=>show(),
                    children: icon
                })
            }),
            !disabled && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $7d5f25ee93f10b42$export$2e2bcd8739ae039), {
                isPost: isPost,
                visible: visible,
                closeModal: close,
                query: path,
                ref: ref,
                header: header,
                content: content,
                onConfirm: ()=>reload ? reload() : window.location.reload()
            })
        ]
    });
};
var $4c9f3f4d48e33e9a$export$2e2bcd8739ae039 = $4c9f3f4d48e33e9a$var$ConfirmButtonWithModal;





function $f31cb1a228122acb$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("svg", {
        id: "ea1882__Layer_1",
        width: 512,
        height: 512,
        "data-name": "Layer 1",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
            fill: "currentColor",
            d: "M12 0a12 12 0 1 0 12 12A12.013 12.013 0 0 0 12 0m0 21a9 9 0 1 1 9-9 9.01 9.01 0 0 1-9 9m5-9a1.5 1.5 0 0 1-1.5 1.5h-2v2a1.5 1.5 0 0 1-3 0v-2h-2a1.5 1.5 0 0 1 0-3h2v-2a1.5 1.5 0 0 1 3 0v2h2A1.5 1.5 0 0 1 17 12"
        })
    });
}



function $4c98f21230ccaa30$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("svg", {
        id: "2a8ec1__arrow-circle-down",
        width: 512,
        height: 512,
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
                fill: "currentColor",
                d: "M24 12a12 12 0 1 0-12 12 12.013 12.013 0 0 0 12-12M2 12a10 10 0 1 1 10 10A10.01 10.01 0 0 1 2 12"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
                fill: "currentColor",
                d: "M8 12a3 3 0 0 1 .752-1.987c.291-.327.574-.637.777-.84L12.353 6.3a1 1 0 0 1 1.426 1.4l-2.829 2.88c-.187.188-.441.468-.7.759a1 1 0 0 0 0 1.323c.258.29.512.57.693.752l2.836 2.886a1 1 0 0 1-1.426 1.4l-2.829-2.878c-.2-.2-.48-.507-.769-.833A3 3 0 0 1 8 12"
            })
        ]
    });
}



function $a948f0ace9e6d864$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("svg", {
        id: "4fc93a__arrow-circle-down",
        width: 512,
        height: 512,
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
                fill: "currentColor",
                d: "M0 12A12 12 0 1 0 12 0 12.013 12.013 0 0 0 0 12m22 0A10 10 0 1 1 12 2a10.01 10.01 0 0 1 10 10"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
                fill: "currentColor",
                d: "M16 12a3 3 0 0 1-.752 1.987c-.291.327-.574.637-.777.84L11.647 17.7a1 1 0 1 1-1.426-1.4l2.829-2.88c.187-.188.441-.468.7-.759a1 1 0 0 0 0-1.323 21 21 0 0 0-.693-.752L10.221 7.7a1 1 0 1 1 1.426-1.4l2.829 2.879c.2.2.48.507.769.833A3 3 0 0 1 16 12"
            })
        ]
    });
}



function $7f59d78985c13830$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("svg", {
        xmlSpace: "preserve",
        id: "425a2e__Capa_1",
        width: 512,
        height: 512,
        x: 0,
        y: 0,
        style: {},
        viewBox: "0 0 512 512",
        ...props,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("g", {
            fill: "currentColor",
            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
                d: "M121.752 0C56.95 0 4.418 52.532 4.418 117.333S56.95 234.667 121.752 234.667s117.333-52.532 117.333-117.333C239.014 52.561 186.524.071 121.752 0m0 170.667c-29.455 0-53.333-23.878-53.333-53.333S92.296 64 121.752 64s53.333 23.878 53.333 53.333-23.878 53.334-53.333 53.334M121.752 277.333c-64.801 0-117.333 52.532-117.333 117.333S56.95 512 121.752 512s117.333-52.532 117.333-117.333c-.071-64.772-52.561-117.263-117.333-117.334m0 170.667c-29.455 0-53.333-23.878-53.333-53.333s23.878-53.333 53.333-53.333 53.333 23.878 53.333 53.333S151.207 448 121.752 448M486.253 392.832h-44.501V119.168h44.501c11.782-.003 21.331-9.556 21.329-21.338a21.33 21.33 0 0 0-6.246-15.078L424.834 6.251C416.503-2.077 402.999-2.077 394.669 6.251l-76.501 76.501c-8.33 8.332-8.328 21.84.005 30.17a21.33 21.33 0 0 0 15.078 6.246h44.501v273.664H333.25c-11.782.003-21.331 9.556-21.329 21.338a21.33 21.33 0 0 0 6.246 15.078l76.501 76.501c8.331 8.328 21.835 8.328 30.165 0l76.501-76.501c8.33-8.332 8.328-21.84-.005-30.17a21.33 21.33 0 0 0-15.076-6.246"
            })
        })
    });
}



function $6b8de4afd055d9b9$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("svg", {
        id: "b33be1__arrow-circle-down",
        width: 512,
        height: 512,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("g", {
            fill: "currentColor",
            children: [
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
                    d: "M12 24A12 12 0 1 0 0 12a12.013 12.013 0 0 0 12 12m0-21a9 9 0 1 1-9 9 9.01 9.01 0 0 1 9-9"
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
                    d: "M8.551 11.185 10.5 9.269V17.5a1.5 1.5 0 0 0 3 0V9.269l1.949 1.916a1.5 1.5 0 1 0 2.1-2.14L14.45 6a3.524 3.524 0 0 0-4.9 0l-3.1 3.048a1.5 1.5 0 1 0 2.1 2.14Z"
                })
            ]
        })
    });
}



function $943efc54a78acb0c$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("svg", {
        id: "6a59cf__Bold",
        width: 512,
        height: 512,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
            fill: "currentColor",
            d: "M4.943 5.606 1.024 9.525a3.585 3.585 0 0 0 0 4.95l3.919 3.919a1.5 1.5 0 1 0 2.121-2.121l-2.779-2.781 18.25-.023a1.5 1.5 0 0 0 1.5-1.5 1.5 1.5 0 0 0-1.5-1.5L4.3 10.492l2.764-2.765a1.5 1.5 0 0 0-2.121-2.121"
        })
    });
}



function $032cd54fed8c7572$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("svg", {
        id: "930af9__arrow-circle-down",
        width: 512,
        height: 512,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
            fill: "currentColor",
            d: "M23 9.545 20.57 7.07a1.5 1.5 0 1 0-2.14 2.1l1.3 1.327H13.5V4.266l1.327 1.3a1.5 1.5 0 1 0 2.1-2.14L14.458 1a3.5 3.5 0 0 0-2.444-1H12a3.5 3.5 0 0 0-2.455 1L7.07 3.43a1.5 1.5 0 1 0 2.1 2.14l1.33-1.305V10.5H4.266l1.3-1.327a1.5 1.5 0 1 0-2.14-2.1L1 9.542a3.5 3.5 0 0 0-1 2.444V12a3.5 3.5 0 0 0 1 2.454l2.43 2.476a1.5 1.5 0 1 0 2.14-2.1L4.265 13.5H10.5v6.239l-1.327-1.3a1.5 1.5 0 1 0-2.1 2.14l2.472 2.43a3.52 3.52 0 0 0 4.913 0l2.475-2.433a1.5 1.5 0 1 0-2.1-2.14l-1.327 1.3V13.5h6.234l-1.3 1.327a1.5 1.5 0 1 0 2.14 2.1L23 14.458a3.52 3.52 0 0 0 0-4.913"
        })
    });
}



function $20b7baff1b1e93b8$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("svg", {
        id: "0b6704__Layer_1",
        "data-name": "Layer 1",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
            fill: "currentColor",
            d: "M5.648 5.958c.733.22 1.521.831 2.354 1.478 1.245.967 2.655 2.064 4.323 2.064 1.965 0 3.643-1.242 4.333-2.992.545.343 1.069.79 1.56 1.405a1 1 0 0 0 1.406.156 1 1 0 0 0 .156-1.405c-.876-1.094-1.831-1.812-2.818-2.283-.185-2.45-2.181-4.391-4.637-4.391-3.825 0-6.504 2.141-7.482 3.406-.331.426-.43.99-.264 1.506.163.509.562.904 1.069 1.056m6.677-3.968c1.117 0 2.073.71 2.473 1.713C13.847 3.533 12.9 3.5 12 3.5a1 1 0 1 0 0 2c.96 0 1.902.044 2.808.254-.392 1.02-1.355 1.746-2.483 1.746-.981 0-2.009-.798-3.097-1.643-.783-.609-1.59-1.236-2.468-1.617 1.005-1.017 3.054-2.25 5.564-2.25ZM9.09 14.804a4.74 4.74 0 0 0-2.69-2.511 4.7 4.7 0 0 0-1.99-.267c.176-.48.417-.983.736-1.503a1 1 0 1 0-1.705-1.045c-.726 1.184-1.147 2.31-1.285 3.335a4.84 4.84 0 0 0-1.711 6.006c1.751 3.858 5.895 4.919 7.122 5.152q.154.03.307.029a1.6 1.6 0 0 0 1.176-.51 1.67 1.67 0 0 0 .396-1.575 3.4 3.4 0 0 1-.104-.776c-.008-.585.055-1.19.122-1.83.153-1.472.312-2.995-.374-4.504Zm-1.615 4.297c-.07.669-.143 1.361-.133 2.062q.004.359.06.722c-1.341-.344-3.971-1.327-5.136-3.893a2.85 2.85 0 0 1 .242-2.77c.309.689.837 1.536 1.786 2.485a.997.997 0 0 0 1.414 0 1 1 0 0 0 0-1.414c-.978-.978-1.363-1.762-1.516-2.23a2.66 2.66 0 0 1 1.515.106 2.76 2.76 0 0 1 1.563 1.462c.461 1.016.337 2.208.205 3.47m15.431-7.166a1.62 1.62 0 0 0-1.214-.915 1.7 1.7 0 0 0-1.496.521c-.556.592-1.321 1.124-2.132 1.686-1.309.908-2.661 1.847-3.455 3.25a4.65 4.65 0 0 0-.431 3.579c.149.528.399 1.006.709 1.44a6.8 6.8 0 0 1-1.99.509 1 1 0 0 0 .102 1.994c1.37-.017 2.537-.543 3.48-1.081a4.76 4.76 0 0 0 2.272.579c1.669 0 3.291-.869 4.162-2.409 1.851-3.27.865-7.292-.008-9.154Zm-1.732 8.169c-.579 1.025-1.732 1.526-2.844 1.353.848-.918 1.428-1.964 1.73-2.963a1 1 0 1 0-1.914-.578 5.7 5.7 0 0 1-1.589 2.496 2.667 2.667 0 0 1-.208-2.95c.569-1.006 1.68-1.776 2.855-2.592.72-.5 1.46-1.014 2.094-1.605.609 1.593 1.181 4.532-.125 6.84Z"
        })
    });
}



function $d201a0435ab3abe2$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("svg", {
        id: "ae97ce__Bold",
        width: 512,
        height: 512,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
            fill: "currentColor",
            d: "M21.542 7A2.457 2.457 0 0 0 24 4.542V1.5A1.5 1.5 0 0 0 22.5 0 1.5 1.5 0 0 0 21 1.5V4h-3.374A6.675 6.675 0 0 0 6.374 4H3V1.5A1.5 1.5 0 0 0 1.5 0 1.5 1.5 0 0 0 0 1.5v3.042A2.46 2.46 0 0 0 2.458 7h2.8L4.24 11H1.5A1.5 1.5 0 0 0 0 12.5 1.5 1.5 0 0 0 1.5 14h2.072c-.016.2-.042.4-.042.614A8.4 8.4 0 0 0 3.878 17h-1.42A2.457 2.457 0 0 0 0 19.458V22.5A1.5 1.5 0 0 0 1.5 24 1.5 1.5 0 0 0 3 22.5V20h2.468a8.46 8.46 0 0 0 13.064 0H21v2.5a1.5 1.5 0 0 0 1.5 1.5 1.5 1.5 0 0 0 1.5-1.5v-3.042A2.46 2.46 0 0 0 21.542 17h-1.42a8.4 8.4 0 0 0 .348-2.386c0-.209-.026-.41-.042-.614H22.5a1.5 1.5 0 0 0 1.5-1.5 1.5 1.5 0 0 0-1.5-1.5h-2.746l-1.007-4ZM12 20.083a5.476 5.476 0 0 1-5.47-5.469 5 5 0 0 1 .038-.6l1.944-7.671a3.72 3.72 0 0 1 6.976 0l1.944 7.675a5 5 0 0 1 .038.6A5.476 5.476 0 0 1 12 20.083"
        })
    });
}



function $9f37caef697816c7$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("svg", {
        id: "125518__Layer_1",
        width: 512,
        height: 512,
        "data-name": "Layer 1",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
            fill: "currentColor",
            d: "M16.365 14.183c0 .379-.264.698-.566.866l-1.564.87.694 1.893a.887.887 0 0 1-1.374 1.006l-1.556-1.203-1.556 1.203a.887.887 0 0 1-1.374-1.006l.694-1.893-1.564-.87c-.302-.168-.566-.487-.566-.866 0-.321.279-.676.731-.676h2.247l.596-2.283a.83.83 0 0 1 .792-.621.83.83 0 0 1 .792.621l.596 2.283h2.247c.452 0 .731.354.731.676M18.5 2H18v-.5a1.5 1.5 0 1 0-3 0V2H9v-.5a1.5 1.5 0 1 0-3 0V2h-.5A5.506 5.506 0 0 0 0 7.5v11C0 21.533 2.467 24 5.5 24h13c3.033 0 5.5-2.467 5.5-5.5v-11C24 4.467 21.533 2 18.5 2m0 19h-13A2.503 2.503 0 0 1 3 18.5V9h18v9.5c0 1.378-1.122 2.5-2.5 2.5"
        })
    });
}



function $e1ff0c44ecae4c04$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("svg", {
        id: "f496e6__Layer_1",
        "data-name": "Layer 1",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
            fill: "currentColor",
            d: "M8 22.5A1.5 1.5 0 0 1 6.5 24h-1A5.507 5.507 0 0 1 0 18.5v-1a1.5 1.5 0 0 1 3 0v1C3 19.879 4.121 21 5.5 21h1A1.5 1.5 0 0 1 8 22.5M22.5 16a1.5 1.5 0 0 0-1.5 1.5v1c0 1.379-1.121 2.5-2.5 2.5h-1a1.5 1.5 0 0 0 0 3h1c3.032 0 5.5-2.468 5.5-5.5v-1a1.5 1.5 0 0 0-1.5-1.5m-4-16h-1a1.5 1.5 0 0 0 0 3h1C19.879 3 21 4.121 21 5.5v1a1.5 1.5 0 0 0 3 0v-1C24 2.468 21.532 0 18.5 0m-17 8A1.5 1.5 0 0 0 3 6.5v-1C3 4.121 4.121 3 5.5 3h1a1.5 1.5 0 0 0 0-3h-1A5.507 5.507 0 0 0 0 5.5v1A1.5 1.5 0 0 0 1.5 8M12 10a2 2 0 1 0-.001 3.999A2 2 0 0 0 12 10m3.5 8h-7C6.57 18 5 16.43 5 14.5v-5C5 7.57 6.57 6 8.5 6h.196l.885-1.331A1.5 1.5 0 0 1 10.83 4h2.34a1.5 1.5 0 0 1 1.249.669L15.304 6h.196C17.43 6 19 7.57 19 9.5v5c0 1.93-1.57 3.5-3.5 3.5m.5-8.5c0-.275-.225-.5-.5-.5h-7c-.275 0-.5.225-.5.5v5c0 .275.225.5.5.5h7c.275 0 .5-.225.5-.5Z"
        })
    });
}



function $d8bce3f262abae7f$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("svg", {
        id: "d7a023__Layer_1",
        "data-name": "Layer 1",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
            fill: "currentColor",
            d: "M18 9V1a1 1 0 0 1 1-1c.66 0 .815.128 1.426.377l3.095 1.259a1.02 1.02 0 0 1 0 1.729L20 5.245V9a1 1 0 1 1-2 0m2 5h-4c-1.103 0-2-.897-2-2 0-.889.586-1.793 1.333-2.058a.999.999 0 1 0-.667-1.884c-1.545.546-2.667 2.204-2.667 3.942 0 2.206 1.794 4 4 4h4c1.103 0 2 .897 2 2s-.897 2-2 2h-5a1 1 0 1 0 0 2h5c2.206 0 4-1.794 4-4s-1.794-4-4-4Zm-8 3v4c0 1.654-1.346 3-3 3H3c-1.654 0-3-1.346-3-3v-4c0-1.654 1.346-3 3-3 0-1.103.897-2 2-2h2c1.103 0 2 .897 2 2 1.654 0 3 1.346 3 3M2 17v1h8v-1c0-.552-.449-1-1-1H3c-.551 0-1 .448-1 1m8 4v-1H7a1 1 0 1 1-2 0H2v1c0 .552.449 1 1 1h6c.551 0 1-.448 1-1"
        })
    });
}



function $c594f6ccebb4edce$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("svg", {
        id: "d60b67__Layer_1",
        width: 512,
        height: 512,
        "data-name": "Layer 1",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
            fill: "currentColor",
            d: "M3.5 21H24v3H3.5C1.57 24 0 22.43 0 20.5V0h3v20.5a.5.5 0 0 0 .5.5M24 8.05V19H5V8.05l3.025-3.024C9.346 3.704 11.652 3.704 12.975 5.026L15.5 7.551l1.525-1.525c1.321-1.322 3.627-1.322 4.95 0Zm-3 1.243-1.146-1.146a.496.496 0 0 0-.707-.001L15.5 11.792l-4.646-4.646a.5.5 0 0 0-.707 0L8 9.292v6.707h13Z"
        })
    });
}



function $d5569e69382c7ac8$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("svg", {
        id: "48fb44__Layer_1",
        width: 512,
        height: 512,
        "data-name": "Layer 1",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
                fill: "currentColor",
                d: "M18.556 11.385h-4.545a1.39 1.39 0 0 1-1.393-1.389V5.433a3.43 3.43 0 0 0-1.331-2.722A3.3 3.3 0 0 0 8.436 2.1 11.112 11.112 0 1 0 21.9 15.579a3.31 3.31 0 0 0-.61-2.858 3.49 3.49 0 0 0-2.734-1.336m.433 3.459a8.115 8.115 0 1 1-9.822-9.835A.3.3 0 0 1 9.239 5a.33.33 0 0 1 .2.077.46.46 0 0 1 .176.356v4.561a4.39 4.39 0 0 0 4.393 4.39h4.545a.47.47 0 0 1 .365.18.31.31 0 0 1 .071.28"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
                fill: "currentColor",
                d: "M23.651 7.446A10.07 10.07 0 0 0 16.582.372 2.014 2.014 0 0 0 14.019 2.3V7a3 3 0 0 0 3 3h4.719a2.008 2.008 0 0 0 1.913-2.554"
            })
        ]
    });
}



function $4c160483fd4c524a$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("svg", {
        id: "16dbbf__Layer_1",
        width: 512,
        height: 512,
        "data-name": "Layer 1",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
            fill: "currentColor",
            d: "M24 12c0 1.65-1.35 3-3 3H3c-1.65 0-3-1.35-3-3s1.35-3 3-3h18c1.65 0 3 1.35 3 3M3 6h12c1.65 0 3-1.35 3-3s-1.35-3-3-3H3C1.35 0 0 1.35 0 3s1.35 3 3 3m6 12H3c-1.65 0-3 1.35-3 3s1.35 3 3 3h6c1.65 0 3-1.35 3-3s-1.35-3-3-3"
        })
    });
}



function $c29e2b1e74aaf7ce$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("svg", {
        id: "5a4a0b__Layer_1",
        width: 512,
        height: 512,
        "data-name": "Layer 1",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
            fill: "currentColor",
            d: "M20 8a4.006 4.006 0 0 0-3.873 3H8c-1.654 0-3-1.346-3-3v-.127A4.006 4.006 0 0 0 8 4c0-2.206-1.794-4-4-4S0 1.794 0 4a4.006 4.006 0 0 0 3 3.873v8.253a4.006 4.006 0 0 0-3 3.873c0 2.206 1.794 4 4 4s4-1.794 4-4a4.006 4.006 0 0 0-3-3.873v-4.129a4.97 4.97 0 0 0 3 1.002h8.127a4.01 4.01 0 0 0 3.873 3c2.206 0 4-1.794 4-4s-1.794-4-4-4ZM2 4c0-1.103.897-2 2-2s2 .897 2 2-.897 2-2 2-2-.897-2-2m4 16c0 1.103-.897 2-2 2s-2-.897-2-2 .897-2 2-2 2 .897 2 2m14-6c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2"
        })
    });
}



function $bf908d9eeb594ba1$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("svg", {
        id: "61c4a0__Outline",
        width: 512,
        height: 512,
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
                fill: "currentColor",
                d: "M20 0H4a4 4 0 0 0-4 4v12a4 4 0 0 0 4 4h2.9l4.451 3.763a1 1 0 0 0 1.292 0L17.1 20H20a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4m2 16a2 2 0 0 1-2 2h-2.9a2 2 0 0 0-1.291.473L12 21.69l-3.807-3.217A2 2 0 0 0 6.9 18H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2Z"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
                fill: "currentColor",
                d: "M7 7h5a1 1 0 0 0 0-2H7a1 1 0 0 0 0 2M17 9H7a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2M17 13H7a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2"
            })
        ]
    });
}



function $86551a210c653693$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("svg", {
        id: "536a07__Layer_1",
        width: 512,
        height: 512,
        "data-name": "Layer 1",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
            fill: "currentColor",
            d: "M18.068 6.447a1.5 1.5 0 0 1-.016 2.121l-5.793 5.707a2.504 2.504 0 0 1-3.528-.008l-2.776-2.69a1.5 1.5 0 1 1 2.088-2.154l2.453 2.378 5.45-5.369a1.5 1.5 0 0 1 2.121.016ZM24 5.338v9c0 3.033-2.468 5.5-5.5 5.5h-1.172l-3.708 3.065a2.4 2.4 0 0 1-1.607.601 2.52 2.52 0 0 1-1.674-.635l-3.598-3.031H5.5a5.506 5.506 0 0 1-5.5-5.5v-9c0-3.033 2.467-5.5 5.5-5.5h13c3.032 0 5.5 2.467 5.5 5.5m-3 0c0-1.378-1.121-2.5-2.5-2.5h-13a2.503 2.503 0 0 0-2.5 2.5v9c0 1.378 1.122 2.5 2.5 2.5h1.789c.354 0 .696.125.966.353l3.749 3.158 3.829-3.167c.27-.223.607-.344.956-.344h1.712c1.379 0 2.5-1.122 2.5-2.5v-9Z"
        })
    });
}



function $efc5d7e69e041882$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("svg", {
        id: "f49473__Layer_1",
        width: 512,
        height: 512,
        "data-name": "Layer 1",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
            fill: "currentColor",
            d: "M22.5 21h-9v-2h6.942a3.56 3.56 0 0 0 2.8-1.355 3.45 3.45 0 0 0 .667-2.941C22.713 9.59 18.462 5.753 13.5 5.1V3h1a1.5 1.5 0 1 0 0-3h-5a1.5 1.5 0 1 0 0 3h1v2.099c-4.961.653-9.212 4.49-10.409 9.604a3.45 3.45 0 0 0 .667 2.942A3.56 3.56 0 0 0 3.558 19H10.5v2h-9a1.5 1.5 0 1 0 0 3h21a1.5 1.5 0 1 0 0-3M3.109 15.781a.46.46 0 0 1-.097-.394C4.013 11.107 7.793 8 12 8s7.986 3.106 8.988 7.387a.45.45 0 0 1-.097.394.57.57 0 0 1-.449.219H3.558a.57.57 0 0 1-.449-.219"
        })
    });
}



function $1f1a0e11253bbce0$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("svg", {
        id: "035c06__Outline",
        width: 512,
        height: 512,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
            fill: "currentColor",
            d: "M23.707.293a1 1 0 0 0-1.414 0L12 10.586 1.707.293a1 1 0 0 0-1.414 0 1 1 0 0 0 0 1.414L10.586 12 .293 22.293a1 1 0 0 0 0 1.414 1 1 0 0 0 1.414 0L12 13.414l10.293 10.293a1 1 0 0 0 1.414 0 1 1 0 0 0 0-1.414L13.414 12 23.707 1.707a1 1 0 0 0 0-1.414"
        })
    });
}



function $b59d10c8d021db57$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("svg", {
        id: "db86d7__Layer_1",
        width: 512,
        height: 512,
        "data-name": "Layer 1",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
            fill: "currentColor",
            d: "M16 8a8 8 0 1 0 8 8 8.01 8.01 0 0 0-8-8m0 14a6 6 0 1 1 6-6 6.006 6.006 0 0 1-6 6m1-7h2v2h-2v2h-2v-2h-2v-2h2v-2h2ZM.144.144l4.71 13.766 2.9-6.158 6.158-2.9Zm6.1 6.1L5.146 8.59l-1.79-5.234 5.234 1.79Z"
        })
    });
}



function $e29c9cfcd339e6bd$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("svg", {
        id: "ad9d64__Layer_1",
        width: 512,
        height: 512,
        "data-name": "Layer 1",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
            fill: "currentColor",
            d: "M17 12.5a1.5 1.5 0 0 1-1.5 1.5h-7a1.5 1.5 0 0 1 0-3h7a1.5 1.5 0 0 1 1.5 1.5M12.5 16h-4a1.5 1.5 0 0 0 0 3h4a1.5 1.5 0 0 0 0-3M22 8.157V18.5a5.506 5.506 0 0 1-5.5 5.5h-9A5.506 5.506 0 0 1 2 18.5v-13A5.506 5.506 0 0 1 7.5 0h6.343a5.46 5.46 0 0 1 3.889 1.611l2.657 2.657A5.46 5.46 0 0 1 22 8.157M19 18.5V9h-4a2 2 0 0 1-2-2V3H7.5A2.5 2.5 0 0 0 5 5.5v13A2.5 2.5 0 0 0 7.5 21h9a2.5 2.5 0 0 0 2.5-2.5"
        })
    });
}



function $1dba4951148bced8$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("svg", {
        id: "1fb6e8__Layer_1",
        width: 512,
        height: 512,
        "data-name": "Layer 1",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
            fill: "currentColor",
            d: "M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0m0 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10m4-10c0 2.209-1.791 4-4 4s-4-1.791-4-4a4 4 0 0 1 8 0"
        })
    });
}



function $27ba250e14ae930a$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("svg", {
        xmlSpace: "preserve",
        id: "062146__Capa_1",
        width: 512,
        height: 512,
        x: 0,
        y: 0,
        style: {},
        viewBox: "0 0 512 512",
        ...props,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("g", {
            fill: "currentColor",
            children: [
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
                    d: "M188.821 377.6c37.49 37.491 98.274 37.491 135.765.001l.001-.001 68.523-68.523c12.712-12.278 13.064-32.536.786-45.248s-32.536-13.064-45.248-.786q-.4.386-.786.786l-59.371 59.349L288 32c0-17.673-14.327-32-32-32s-32 14.327-32 32l.448 290.709-58.901-58.901c-12.712-12.278-32.97-11.926-45.248.786-11.977 12.401-11.977 32.061 0 44.462Z"
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
                    d: "M480 309.333c-17.673 0-32 14.327-32 32v97.941a8.746 8.746 0 0 1-8.725 8.725H72.725A8.746 8.746 0 0 1 64 439.274v-97.941c0-17.673-14.327-32-32-32s-32 14.327-32 32v97.941C.047 479.42 32.58 511.953 72.725 512h366.549c40.146-.047 72.678-32.58 72.725-72.725v-97.941C512 323.66 497.673 309.333 480 309.333"
                })
            ]
        })
    });
}



function $eceeac58f56a0e4c$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("svg", {
        id: "722833__Layer_1",
        width: 512,
        height: 512,
        "data-name": "Layer 1",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
            fill: "currentColor",
            d: "M21 18c-.221 0-.434.027-.642.072l-4.525-5.128c.1-.299.167-.612.167-.945s-.067-.646-.167-.945l4.525-5.128A3 3 0 1 0 21-.002a2.99 2.99 0 0 0-2.816 2H5.816A2.99 2.99 0 0 0 3-.002 3.003 3.003 0 0 0 0 3a2.99 2.99 0 0 0 2 2.816v12.367a2.99 2.99 0 0 0-2 2.816 3 3 0 0 0 3 3 2.99 2.99 0 0 0 2.816-2h12.367a2.99 2.99 0 0 0 2.816 2 3 3 0 1 0 0-6Zm-16 .779V5.221A3 3 0 0 0 5.221 5h11.955l-3.582 4.06a3 3 0 1 0 0 5.88L17.176 19H5.221A3 3 0 0 0 5 18.779"
        })
    });
}



function $c829c145a5d9dcf0$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("svg", {
        xmlSpace: "preserve",
        id: "d9d781__Capa_1",
        width: 512,
        height: 512,
        x: 0,
        y: 0,
        style: {},
        viewBox: "0 0 512 512",
        ...props,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
            fill: "currentColor",
            d: "M437.781 36.885A117.14 117.14 0 0 0 352.64 0H288c-60.623.095-111.219 46.301-116.8 106.667H160C95.228 106.737 42.737 159.228 42.667 224v170.667C42.737 459.439 95.228 511.929 160 512h85.333c64.772-.071 117.263-52.561 117.333-117.333v-11.2c60.37-5.572 106.582-56.173 106.667-116.8V116.693a116.29 116.29 0 0 0-31.552-79.808M298.667 394.667c0 29.455-23.878 53.333-53.333 53.333H160c-29.455 0-53.333-23.878-53.333-53.333V224c0-29.455 23.878-53.333 53.333-53.333h10.667v96C170.737 331.439 223.228 383.929 288 384h10.667Zm106.666-128C405.333 296.122 381.455 320 352 320h-64c-29.455 0-53.333-23.878-53.333-53.333V117.333C234.667 87.878 258.545 64 288 64h53.333v21.333C341.333 108.897 360.436 128 384 128h21.333Z"
        })
    });
}



function $0cd2b3d9c6aaab2a$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("svg", {
        id: "31c009__Bold",
        width: 512,
        height: 512,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
            fill: "currentColor",
            d: "M22.824 1.176a4.11 4.11 0 0 0-5.676 0L1.611 16.713A5.46 5.46 0 0 0 0 20.6v1.9A1.5 1.5 0 0 0 1.5 24h1.9a5.46 5.46 0 0 0 3.889-1.611L22.824 6.852a4.02 4.02 0 0 0 0-5.676M5.166 20.268A2.52 2.52 0 0 1 3.4 21H3v-.4a2.52 2.52 0 0 1 .732-1.768L15.3 7.267 16.733 8.7ZM20.7 4.731 18.854 6.58 17.42 5.146 19.27 3.3a1.037 1.037 0 0 1 1.433 0 1.015 1.015 0 0 1-.003 1.431"
        })
    });
}



function $51dd8a53ecd48274$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("svg", {
        id: "ab0352__Outline",
        width: 512,
        height: 512,
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
                fill: "currentColor",
                d: "M23.271 9.419C21.72 6.893 18.192 2.655 12 2.655S2.28 6.893.729 9.419a4.91 4.91 0 0 0 0 5.162C2.28 17.107 5.808 21.345 12 21.345s9.72-4.238 11.271-6.764a4.91 4.91 0 0 0 0-5.162m-1.705 4.115C20.234 15.7 17.219 19.345 12 19.345S3.766 15.7 2.434 13.534a2.92 2.92 0 0 1 0-3.068C3.766 8.3 6.781 4.655 12 4.655s8.234 3.641 9.566 5.811A2.92 2.92 0 0 1 21.566 13.534"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
                fill: "currentColor",
                d: "M12 7a5 5 0 1 0 5 5 5.006 5.006 0 0 0-5-5m0 8a3 3 0 1 1 3-3 3 3 0 0 1-3 3"
            })
        ]
    });
}



function $ff351197b573b056$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("svg", {
        xmlSpace: "preserve",
        id: "c661c6__Capa_1",
        width: 512,
        height: 512,
        x: 0,
        y: 0,
        style: {},
        viewBox: "0 0 509.319 509.319",
        ...props,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
            fill: "currentColor",
            d: "M488.942 188.222a326.4 326.4 0 0 0-58.432-64.555l60.096-60.075c12.135-12.848 11.558-33.101-1.29-45.236-12.346-11.661-31.65-11.647-43.979.031l-69.248 69.269a267.5 267.5 0 0 0-121.451-28.203c-94.756.907-182.745 49.263-234.304 128.769-27.112 39.874-27.112 92.264 0 132.139a326.4 326.4 0 0 0 58.432 64.555L18.67 445.054c-12.501 12.501-12.501 32.769 0 45.269s32.769 12.501 45.269 0l69.248-69.269a267.5 267.5 0 0 0 121.451 28.203c94.756-.905 182.745-49.262 234.304-128.768 27.17-39.903 27.17-92.364 0-132.267m-415.829 96c-12.285-18.016-12.285-41.717 0-59.733C112.451 162.079 180.866 124 254.638 123.454a208.1 208.1 0 0 1 72.875 12.8l-39.552 39.531c-43.381-18.416-93.478 1.823-111.893 45.204a85.33 85.33 0 0 0 0 66.689l-51.989 52.011a257.9 257.9 0 0 1-50.966-55.467m363.05 0c-39.339 62.41-107.754 100.489-181.525 101.035a208.1 208.1 0 0 1-72.875-12.8l39.552-39.552c43.381 18.416 93.478-1.823 111.893-45.204a85.33 85.33 0 0 0 0-66.689l51.989-51.989a257.9 257.9 0 0 1 50.965 55.467c12.286 18.015 12.286 41.716.001 59.732"
        })
    });
}



function $d603cf6bb31cd289$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("svg", {
        id: "817335__Layer_1",
        width: 512,
        height: 512,
        "data-name": "Layer 1",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
            fill: "currentColor",
            d: "M17.8 21.21c.42.72.17 1.63-.55 2.05-.83.48-1.78.74-2.75.74h-9A5.51 5.51 0 0 1 0 18.5v-13C0 2.47 2.47 0 5.5 0h6.34c1.45 0 2.87.59 3.89 1.61l2.66 2.66c.82.82 1.35 1.85 1.54 2.99.14.82-.42 1.61-1.23 1.75C18.64 9.02 13.01 9.01 13.01 9.01c-1.1 0-2-.9-2-2V3H5.5A2.5 2.5 0 0 0 3 5.5v13A2.5 2.5 0 0 0 5.5 21h9c.44 0 .87-.12 1.25-.33.71-.41 1.63-.17 2.05.55Zm5.91-6.42-3-3.16c-.63-.63-1.71-.18-1.71.71V14h-5.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5H19v1.66c0 .89 1.08 1.34 1.71.71l3-3.16a.996.996 0 0 0 0-1.41Z"
        })
    });
}



function $b5d2ac725b6110c7$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("svg", {
        id: "aabc7c__Layer_1",
        width: 512,
        height: 512,
        "data-name": "Layer 1",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
            fill: "currentColor",
            d: "m19.95 5.54-3.49-3.49A6.96 6.96 0 0 0 11.51 0H7C4.24 0 2 2.24 2 5v14c0 2.76 2.24 5 5 5h10c2.76 0 5-2.24 5-5v-8.51c0-1.87-.73-3.63-2.05-4.95m-1.41 1.41q.48.48.81 1.05h-4.34c-.55 0-1-.45-1-1V2.66q.57.33 1.05.81l3.49 3.49ZM20 19c0 1.65-1.35 3-3 3H7c-1.65 0-3-1.35-3-3V5c0-1.65 1.35-3 3-3h4.51c.16 0 .33 0 .49.02V7c0 1.65 1.35 3 3 3h4.98c.02.16.02.32.02.49ZM7.09 13H6c-.55 0-1 .45-1 1v4.44c0 .35.28.62.62.62s.62-.28.62-.62v-1.22h.84c1.18 0 2.14-.95 2.14-2.11S8.26 13 7.08 13Zm0 2.97h-.83v-1.72h.84c.48 0 .89.39.89.86s-.41.86-.89.86Zm11.93-2.34c0 .35-.28.62-.62.62h-1.69v1.14h1.24c.35 0 .62.28.62.62s-.28.62-.62.62h-1.24v1.8c0 .35-.28.62-.62.62s-.62-.28-.62-.62v-4.81c0-.35.28-.62.62-.62h2.31c.35 0 .62.28.62.62Zm-6.93-.62H11c-.55 0-1 .45-1 1v4.44c0 .35.28.56.62.56h1.46c1.18 0 2.14-.95 2.14-2.11v-1.78c0-1.16-.96-2.11-2.14-2.11Zm.89 3.89c0 .47-.41.86-.89.86h-.83v-3.5h.84c.48 0 .89.39.89.86v1.78Z"
        })
    });
}



function $ce12cbf77937a349$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("svg", {
        id: "b4b0ae__Layer_1",
        width: 512,
        height: 512,
        "data-name": "Layer 1",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
            fill: "currentColor",
            d: "M14 24a1 1 0 0 1-.6-.2l-4-3A1 1 0 0 1 9 20v-5.62L1.984 6.487A3.9 3.9 0 0 1 4.9 0h14.2a3.9 3.9 0 0 1 2.913 6.488L15 14.38V23a1 1 0 0 1-1 1"
        })
    });
}



function $9c1281d993528c08$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("svg", {
        id: "fb4d84__Layer_1",
        "data-name": "Layer 1",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
            fill: "currentColor",
            d: "M12.5 2H8v-.5a1.5 1.5 0 1 0-3 0v.598A11.5 11.5 0 0 0 .749 3.539a1.5 1.5 0 0 0 1.503 2.597 8.4 8.4 0 0 1 2.749-.987v2.032c-2.862.68-5 3.251-5 6.318v5.5c0 2.757 2.243 5 5 5h3c2.757 0 5-2.243 5-5v-5.5c0-3.067-2.138-5.638-5-6.318V4.999h4.5a1.5 1.5 0 1 0 0-3ZM10 13.5V19c0 1.103-.897 2-2 2H5c-1.103 0-2-.897-2-2h3.5a1.5 1.5 0 1 0 0-3H3v-2.5C3 11.57 4.57 10 6.5 10s3.5 1.57 3.5 3.5M24 1.294V5.69c0 .841-.791 1.459-1.607 1.255l-4.956-1.507a2.028 2.028 0 0 1-.005-3.877L22.393.039A1.293 1.293 0 0 1 24 1.294"
        })
    });
}



function $e8d5b70a755cc6a3$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("svg", {
        id: "7a8024__Layer_1",
        "data-name": "Layer 1",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
            fill: "currentColor",
            d: "M18 8H6a6.01 6.01 0 0 1 5-5.916V0h2v2.084c2.834.477 5 2.948 5 5.916m0 8v6h2v2H4v-2h2v-6H4v-3h2v-3h12v3h2v3Zm-4.5-1.5a1.5 1.5 0 1 0-3.001.001A1.5 1.5 0 0 0 13.5 14.5"
        })
    });
}



function $5376f494e5ab2706$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("svg", {
        id: "64e2e4__Layer_1",
        "data-name": "Layer 1",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
            fill: "currentColor",
            d: "M11.5 14a2 2 0 0 1-2-2c0-.504.193-.959.5-1.31V6.5a1.5 1.5 0 1 1 3 0v4.19c.307.352.5.806.5 1.31a2 2 0 0 1-2 2m-3.918 2.313-1.554 1.204c-.165.136-.412.115-.574-.048-1.848-1.87-2.717-4.452-2.383-7.083.485-3.816 3.614-6.897 7.44-7.326 4.43-.493 8.437 2.401 9.319 6.74a1.5 1.5 0 0 0 2.94-.598C21.575 3.329 16.155-.59 10.177.078 4.992.659.752 4.835.095 10.007c-.451 3.552.725 7.04 3.225 9.57a3.47 3.47 0 0 0 2.467 1.041 3.3 3.3 0 0 0 2.116-.759l1.515-1.172a1.5 1.5 0 0 0-1.835-2.373ZM24 18c0 3.314-2.686 6-6 6s-6-2.686-6-6a6 6 0 1 1 12 0m-3.191-.153a1.6 1.6 0 0 0-1.413-.846h-2.029l1.303-1.998a1.001 1.001 0 0 0-1.676-1.096l-1.925 3.01a1.62 1.62 0 0 0 .249 1.431c.303.408.788.652 1.297.652h2.035l-1.385 1.991a.998.998 0 1 0 1.641 1.138l1.824-2.639a1.6 1.6 0 0 0 .077-1.645Z"
        })
    });
}



function $0c26c7c3f9abc26c$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("svg", {
        id: "630323__Layer_1",
        "data-name": "Layer 1",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
            fill: "currentColor",
            d: "M11.5 14a2 2 0 0 1-2-2c0-.504.193-.959.5-1.31V6.5a1.5 1.5 0 1 1 3 0v4.19c.307.352.5.806.5 1.31a2 2 0 0 1-2 2m-3.918 2.314-1.553 1.203c-.165.137-.413.116-.576-.048a8.49 8.49 0 0 1-2.382-7.083C3.555 6.57 6.684 3.489 10.51 3.06c4.442-.496 8.437 2.401 9.318 6.74a1.5 1.5 0 1 0 2.94-.598C21.575 3.329 16.16-.586 10.177.078 4.991.659.752 4.835.095 10.007c-.451 3.551.725 7.04 3.226 9.57a3.46 3.46 0 0 0 2.466 1.04 3.3 3.3 0 0 0 2.117-.759l1.515-1.172a1.499 1.499 0 1 0-1.835-2.372ZM24 18c0 3.314-2.686 6-6 6s-6-2.686-6-6a6 6 0 1 1 12 0m-2.5 0a1 1 0 0 0-1-1H19v-1.5a1 1 0 1 0-2 0V17h-1.5a1 1 0 1 0 0 2H17v1.5a1 1 0 1 0 2 0V19h1.5a1 1 0 0 0 1-1"
        })
    });
}



function $2d0d32b58b4eb5c9$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("svg", {
        id: "ab6829__Layer_1",
        width: 512,
        height: 512,
        "data-name": "Layer 1",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
            fill: "currentColor",
            d: "M10.57 10.99c.23.13.48.19.73.19.53 0 1.04-.28 1.31-.77.4-.72.15-1.64-.58-2.04l-.64-.36c.07-.33.1-.67.1-1.02s-.04-.69-.1-1.02l.64-.36c.72-.4.98-1.32.58-2.04s-1.32-.98-2.04-.58l-.65.36c-.54-.51-1.2-.89-1.92-1.12v-.76c0-.83-.67-1.5-1.5-1.5S5 .64 5 1.47v.76c-.72.23-1.38.61-1.92 1.12l-.65-.36c-.72-.4-1.64-.15-2.04.58-.4.72-.15 1.64.58 2.04l.64.36c-.07.33-.1.67-.1 1.02s.04.69.1 1.02l-.64.36c-.72.4-.98 1.32-.58 2.04a1.504 1.504 0 0 0 2.04.58l.65-.36c.54.51 1.2.89 1.92 1.12v.76c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-.76c.72-.23 1.38-.61 1.92-1.12ZM6.5 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2m16.03 9.37-.64-.36c.07-.33.1-.67.1-1.02s-.04-.69-.1-1.02l.64-.36c.72-.4.98-1.32.58-2.04s-1.32-.98-2.04-.58l-.65.36c-.54-.51-1.2-.89-1.92-1.12v-.76c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.76c-.72.23-1.38.61-1.92 1.12l-.65-.36c-.72-.4-1.64-.15-2.04.58-.4.72-.15 1.64.58 2.04l.64.36c-.07.33-.1.67-.1 1.02s.04.69.1 1.02l-.64.36c-.72.4-.98 1.32-.58 2.04a1.504 1.504 0 0 0 2.04.58l.65-.36c.54.51 1.2.89 1.92 1.12v.76c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-.76c.72-.23 1.38-.61 1.92-1.12l.65.36c.23.13.48.19.73.19.53 0 1.04-.28 1.31-.77.4-.72.15-1.64-.58-2.04M17 19c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2"
        })
    });
}



function $01c61f9c65c83096$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("svg", {
        id: "9e6c9e__Layer_1",
        "data-name": "Layer 1",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
            fill: "currentColor",
            d: "M20.5 0h-17C1.57 0 0 1.57 0 3.5V24h13.418c-.073-.068-.15-.129-.221-.2a7.46 7.46 0 0 1-1.761-2.8H10v-7.5h2.919c.092-.103.18-.208.278-.307L17 9.474V3h3.5c.275 0 .5.225.5.5v6.952l2.775 2.714c.079.079.149.165.225.247V3.5C24 1.57 22.43 0 20.5 0m-17 3H7v7.5H3v-7c0-.275.225-.5.5-.5M7 21H3v-7.5h4Zm7-10.5h-4V3h4Zm4.5.305-3.889 3.803C13.572 15.647 13 17.028 13 18.497s.572 2.851 1.611 3.89 2.42 1.611 3.889 1.611 2.851-.572 3.889-1.611S24 19.967 24 18.497s-.572-2.85-1.623-3.9Zm1.768 9.46c-.94.944-2.588.946-3.534 0-.473-.473-.732-1.101-.732-1.769s.26-1.295.721-1.756L18.502 15l1.768 1.729c.473.473.732 1.101.732 1.768s-.26 1.296-.732 1.769Z"
        })
    });
}



function $53b734e01cf61152$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("svg", {
        id: "1af171__Layer_1",
        "data-name": "Layer 1",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
            fill: "currentColor",
            d: "M.343 9.144a12 12 0 0 1 1.135-2.908A3.46 3.46 0 0 1 1 4.5 3.5 3.5 0 0 1 4.5 1a3.46 3.46 0 0 1 1.736.478A12 12 0 0 1 9.144.342a1.5 1.5 0 0 1 .71 2.914 9 9 0 0 0-1.908.722c.026.172.053.343.053.522a3.5 3.5 0 0 1-3.5 3.5c-.179 0-.35-.027-.522-.053a9 9 0 0 0-.722 1.909 1.5 1.5 0 1 1-2.914-.711Zm9.513 11.6a9 9 0 0 1-1.908-.722c.026-.172.053-.343.053-.522a3.5 3.5 0 0 0-3.5-3.5c-.179 0-.35.027-.522.053a9 9 0 0 1-.722-1.909 1.5 1.5 0 0 0-2.914.712 12 12 0 0 0 1.135 2.908A3.46 3.46 0 0 0 1 19.5 3.5 3.5 0 0 0 4.5 23a3.46 3.46 0 0 0 1.736-.478c.904.493 1.876.884 2.908 1.136q.18.043.356.043a1.5 1.5 0 0 0 .354-2.958Zm12.7-7.701a1.5 1.5 0 0 0-1.812 1.101 9 9 0 0 1-.722 1.909c-.171-.026-.343-.053-.521-.053a3.5 3.5 0 0 0-3.5 3.5c0 .179.027.35.053.521a9 9 0 0 1-1.909.722 1.5 1.5 0 1 0 .712 2.915 12 12 0 0 0 2.907-1.136A3.46 3.46 0 0 0 19.5 23a3.5 3.5 0 0 0 3.5-3.5 3.46 3.46 0 0 0-.478-1.736c.493-.904.883-1.875 1.135-2.908a1.5 1.5 0 0 0-1.102-1.813Zm-8.411-9.787a9 9 0 0 1 1.908.722c-.026.172-.053.343-.053.522A3.5 3.5 0 0 0 19.5 8c.179 0 .35-.027.522-.053.303.602.557 1.235.722 1.909a1.5 1.5 0 1 0 2.914-.711 12 12 0 0 0-1.135-2.908 3.46 3.46 0 0 0 .478-1.736 3.5 3.5 0 0 0-3.5-3.5 3.46 3.46 0 0 0-1.736.478A12 12 0 0 0 14.857.343a1.5 1.5 0 1 0-.71 2.914ZM6 12q0 .335.036.66a1.5 1.5 0 0 0 1.651 1.332 1.5 1.5 0 0 0 1.331-1.651 3.004 3.004 0 0 1 2.981-3.34v.611c0 .583.687.893 1.125.508l2.01-1.773a1.032 1.032 0 0 0 0-1.575l-2.01-1.773a.677.677 0 0 0-1.125.508V6c-3.309 0-6 2.691-6 6Zm12 0q0-.335-.036-.66a1.5 1.5 0 1 0-2.982.319q.019.169.019.34c0 1.654-1.346 3-3 3v-.612a.677.677 0 0 0-1.125-.508l-2.01 1.773a1.032 1.032 0 0 0 0 1.575L10.876 19a.677.677 0 0 0 1.125-.508v-.493c3.309 0 6-2.691 6-6Z"
        })
    });
}



function $bf171d36cdc5355b$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("svg", {
        id: "e1397e__Layer_1",
        width: 512,
        height: 512,
        "data-name": "Layer 1",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
            fill: "currentColor",
            d: "M8.02 19c1.78 0 3.48-.76 4.7-2.13l7.1-8.52c1.65-1.9 1.55-4.79-.23-6.58l-.37-.37c-1.78-1.78-4.67-1.88-6.55-.25L4.09 8.31A6.23 6.23 0 0 0 2 12.97v3.9L.44 18.43a1.49 1.49 0 0 0 0 2.12c.29.29.68.44 1.06.44s.77-.15 1.06-.44l1.56-1.56h3.9Zm-1.97-8.41 8.56-7.14c.72-.62 1.81-.59 2.49.09l.37.37c.67.67.71 1.77.07 2.51l-7.09 8.5c-.23.25-.49.47-.78.64l-4.22-4.22c.16-.28.37-.53.6-.74ZM24 22.5c0 .83-.67 1.5-1.5 1.5h-17c-.83 0-1.5-.67-1.5-1.5S4.67 21 5.5 21h17c.83 0 1.5.67 1.5 1.5"
        })
    });
}



function $cec9bbc39c654998$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("svg", {
        xmlSpace: "preserve",
        id: "4a99ea__Capa_1",
        width: 512,
        height: 512,
        x: 0,
        y: 0,
        style: {},
        viewBox: "0 0 512.001 512.001",
        ...props,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
            fill: "currentColor",
            d: "M490.134 185.472 338.966 34.304c-45.855-45.737-120.076-45.737-165.931 0L21.867 185.472A74.18 74.18 0 0 0 0 238.272v221.397C.047 488.568 23.475 511.976 52.374 512h407.253c28.899-.023 52.326-23.432 52.373-52.331V238.272a74.18 74.18 0 0 0-21.866-52.8M448 448H341.334v-67.883c0-44.984-36.467-81.451-81.451-81.451h-7.765c-44.984 0-81.451 36.467-81.451 81.451V448H64V238.272a10.77 10.77 0 0 1 3.115-7.552L218.283 79.552c20.825-20.831 54.594-20.835 75.425-.01l.01.01L444.886 230.72a10.78 10.78 0 0 1 3.115 7.552V448Z"
        })
    });
}



function $256a08773634a940$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("svg", {
        id: "9e371e__Layer_1",
        width: 512,
        height: 512,
        "data-name": "Layer 1",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
            fill: "currentColor",
            d: "M3 0h18v3.409A11.95 11.95 0 0 1 17.013 12 11.94 11.94 0 0 1 21 20.591 3.41 3.41 0 0 1 17.591 24H6.409A3.413 3.413 0 0 1 3 20.591 11.96 11.96 0 0 1 6.972 12 11.96 11.96 0 0 1 3 3.409Zm15 3H6v.409c0 3.384 2.271 5.9 4.177 7.417L11.653 12l-1.476 1.174C8.271 14.689 6 17.207 6 20.591a.41.41 0 0 0 .409.409h11.182a.41.41 0 0 0 .409-.409c0-3.386-2.281-5.9-4.2-7.414L12.318 12l1.482-1.176C15.718 9.309 18 6.793 18 3.409Zm-6.012 6.711-.566-.45A9.14 9.14 0 0 1 8.237 5h7.524a9.14 9.14 0 0 1-3.2 4.255l-.576.456"
        })
    });
}



function $27688a12e8f8fbd7$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("svg", {
        id: "4b0f6b__Bold",
        width: 512,
        height: 512,
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
                fill: "currentColor",
                d: "M12 0a12 12 0 1 0 12 12A12.013 12.013 0 0 0 12 0m0 21a9 9 0 1 1 9-9 9.01 9.01 0 0 1-9 9"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("circle", {
                cx: 12.005,
                cy: 17.5,
                r: 1.5
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
                fill: "currentColor",
                d: "M12.757 4.987a4.25 4.25 0 0 0-5 4.181 1.5 1.5 0 0 0 3 0 1.248 1.248 0 1 1 1.847 1.1 3.32 3.32 0 0 0-2.038 3.158 1.5 1.5 0 0 0 3 0 1.3 1.3 0 0 1 .016-.218 1.9 1.9 0 0 1 .471-.313 4.248 4.248 0 0 0-1.292-7.9Z"
            })
        ]
    });
}



function $a03f5741f2ada281$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("svg", {
        id: "2b670e__Layer_1",
        width: 512,
        height: 512,
        "data-name": "Layer 1",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
            fill: "currentColor",
            d: "M22 0h-2.172a2.98 2.98 0 0 0-2.121.879l-8.361 8.36a7.537 7.537 0 1 0 5.415 5.415L16 13.415V11h3V8h2.414l1.707-1.707A2.98 2.98 0 0 0 24 4.171V2a2 2 0 0 0-2-2m0 4.171a1 1 0 0 1-.293.708L20.586 6H17v3h-3v3.585l-1.545 1.545A5.6 5.6 0 0 1 13 16.5 5.5 5.5 0 1 1 7.5 11a4.24 4.24 0 0 1 2.369.544l9.252-9.251A1 1 0 0 1 19.828 2H22ZM5 18a1 1 0 1 0 1-1 1 1 0 0 0-1 1"
        })
    });
}



function $72bd140b5b65084d$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("svg", {
        id: "8f43a2__Layer_1",
        width: 512,
        height: 512,
        "data-name": "Layer 1",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
            fill: "currentColor",
            d: "M22 0h-1.436a2.98 2.98 0 0 0-2.121.879L9.916 9.4a7.518 7.518 0 1 0 4.684 4.684l2.4-2.4V8h3V5h3.551A3 3 0 0 0 24 3.436V2a2 2 0 0 0-2-2M5.5 20A1.5 1.5 0 1 1 7 18.5 1.5 1.5 0 0 1 5.5 20"
        })
    });
}



function $f2af2d2cef1e2ed8$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("svg", {
        id: "d5e7cd__Layer_1",
        "data-name": "Layer 1",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
            fill: "currentColor",
            d: "M10.252 12.682a2.5 2.5 0 0 0 3.496 0l2.494-2.439C17.376 9.11 18 7.603 18 6s-.624-3.11-1.758-4.243S13.601 0 12 0 8.89.624 7.758 1.757C6.624 2.89 6 4.397 6 6s.624 3.11 1.77 4.254ZM12 4a2 2 0 1 1 .001 3.999A2 2 0 0 1 12 4m12 12.5c0 .524-.274 1.012-.724 1.283l-9.413 5.696a3.59 3.59 0 0 1-3.727 0L.724 17.783a1.5 1.5 0 0 1 0-2.566l4.957-3a1.5 1.5 0 1 1 1.553 2.566L4.398 16.5l7.292 4.413a.6.6 0 0 0 .62 0l7.293-4.413-2.836-1.717a1.5 1.5 0 1 1 1.553-2.566l4.957 3a1.5 1.5 0 0 1 .724 1.283Z"
        })
    });
}



function $61f8937bd63b6364$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("svg", {
        id: "38a73b__Bold",
        width: 512,
        height: 512,
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
                fill: "currentColor",
                d: "m.912 10.6 9.288 5.569a3.49 3.49 0 0 0 3.6 0l9.288-5.569a1.86 1.86 0 0 0 0-3.192L13.8 1.831a3.49 3.49 0 0 0-3.6 0L.912 7.4a1.86 1.86 0 0 0 0 3.192Zm10.831-6.2a.5.5 0 0 1 .514 0L19.918 9l-7.661 4.6a.5.5 0 0 1-.514 0L4.082 9Z"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
                fill: "currentColor",
                d: "M13.286 18.831a2.5 2.5 0 0 1-2.572 0l-8.442-5.065A1.5 1.5 0 0 0 0 15.052a1.5 1.5 0 0 0 .728 1.286L9.17 21.4a5.49 5.49 0 0 0 5.66 0l8.442-5.065A1.5 1.5 0 0 0 24 15.052a1.5 1.5 0 0 0-2.272-1.286Z"
            })
        ]
    });
}



function $c95a6a5e297cadad$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("svg", {
        id: "6c4915__Layer_1",
        width: 512,
        height: 512,
        "data-name": "Layer 1",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
            fill: "currentColor",
            d: "M21 24H3v-3.409A11.95 11.95 0 0 1 6.987 12 11.94 11.94 0 0 1 3 3.409 3.41 3.41 0 0 1 6.409 0h11.182A3.413 3.413 0 0 1 21 3.409 11.96 11.96 0 0 1 17.028 12 11.96 11.96 0 0 1 21 20.591ZM6 21h12v-.409c0-3.384-2.271-5.9-4.177-7.417L12.347 12l1.476-1.174C15.729 9.311 18 6.793 18 3.409A.41.41 0 0 0 17.591 3H6.409A.41.41 0 0 0 6 3.409c0 3.386 2.281 5.9 4.2 7.414L11.682 12 10.2 13.176C8.282 14.691 6 17.207 6 20.591Zm6.012-6.711.566.45A9.14 9.14 0 0 1 15.763 19H8.239a9.14 9.14 0 0 1 3.2-4.255l.576-.456"
        })
    });
}



function $eea666b1b3edf009$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("svg", {
        id: "dfbeea__Layer_1",
        width: 512,
        height: 512,
        "data-name": "Layer 1",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
            fill: "currentColor",
            d: "M13.5 11C11.02 11 9 13.02 9 15.5c0 1.56.79 2.93 2 3.74v3.86c0 .8.97 1.21 1.54.64l.96-.96.96.96A.9.9 0 0 0 16 23.1v-3.86c1.21-.81 2-2.18 2-3.74 0-2.48-2.02-4.5-4.5-4.5m0 3c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5.67-1.5 1.5-1.5M22 8.2v10.34a5.5 5.5 0 0 1-1.38 3.64 1.503 1.503 0 0 1-2.25-1.99c.4-.46.62-1.04.62-1.65v-9.5h-4c-1.1 0-2-.9-2-2v-4H7.5A2.5 2.5 0 0 0 5 5.54v13a2.5 2.5 0 0 0 2.5 2.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5a5.51 5.51 0 0 1-5.5-5.5v-13C2 2.51 4.47.04 7.5.04h6.34c1.47 0 2.85.57 3.89 1.61l2.66 2.66A5.46 5.46 0 0 1 22 8.2"
        })
    });
}



function $a996abd98d73ffbe$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("svg", {
        id: "7771d5__Layer_1",
        width: 512,
        height: 512,
        "data-name": "Layer 1",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
            fill: "currentColor",
            d: "M21 18.126V13c0-4.963-4.037-9-9-9s-9 4.037-9 9v5.126A4.006 4.006 0 0 0 0 22c0 1.103.897 2 2 2h20c1.103 0 2-.897 2-2a4.006 4.006 0 0 0-3-3.874M12 6c3.859 0 7 3.141 7 7v5H5v-5c0-3.859 3.141-7 7-7M2 22c0-1.103.897-2 2-2h16c1.103 0 2 .897 2 2ZM20.797 6.211a1 1 0 0 1-.008-1.414l1.5-1.517a1 1 0 1 1 1.422 1.406l-1.5 1.517a1 1 0 0 1-1.414.008M16.612 2.04l.777-1.5a1 1 0 1 1 1.776.92l-.777 1.5a1 1 0 0 1-1.348.428 1 1 0 0 1-.428-1.348M.289 4.687a.999.999 0 1 1 1.422-1.406l1.5 1.517a.999.999 0 1 1-1.422 1.406ZM4.835 1.46A1 1 0 0 1 6.611.54l.777 1.5a1 1 0 0 1-1.776.92ZM8 13c0-2.206 1.794-4 4-4a1 1 0 1 1 0 2c-1.103 0-2 .897-2 2a1 1 0 1 1-2 0"
        })
    });
}



function $1605980a69d2a507$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("svg", {
        id: "165524__Bold",
        width: 512,
        height: 512,
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
                fill: "currentColor",
                d: "M8 7h14.5a1.5 1.5 0 0 0 0-3H8a1.5 1.5 0 0 0 0 3M22.5 11H8a1.5 1.5 0 0 0 0 3h14.5a1.5 1.5 0 0 0 0-3M22.5 18H8a1.5 1.5 0 0 0 0 3h14.5a1.5 1.5 0 0 0 0-3"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("circle", {
                cx: 2.5,
                cy: 5.5,
                r: 2.5
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("circle", {
                cx: 2.5,
                cy: 12,
                r: 2.5
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("circle", {
                cx: 2.5,
                cy: 19,
                r: 2.5
            })
        ]
    });
}



function $eb249b12eb41ffc5$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("svg", {
        id: "26675c__Layer_1",
        width: 512,
        height: 512,
        "data-name": "Layer 1",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
            fill: "currentColor",
            d: "M12 5a1.5 1.5 0 0 1-1.5-1.5v-2a1.5 1.5 0 0 1 3 0v2A1.5 1.5 0 0 1 12 5m1.5 17.5v-2a1.5 1.5 0 0 0-3 0v2a1.5 1.5 0 0 0 3 0M5 12a1.5 1.5 0 0 0-1.5-1.5h-2a1.5 1.5 0 0 0 0 3h2A1.5 1.5 0 0 0 5 12m19 0a1.5 1.5 0 0 0-1.5-1.5h-2a1.5 1.5 0 0 0 0 3h2A1.5 1.5 0 0 0 24 12m-6.524-6.671.981-1.743a1.5 1.5 0 0 0-2.613-1.473l-.982 1.743a1.5 1.5 0 0 0 .571 2.044 1.5 1.5 0 0 0 .735.194 1.5 1.5 0 0 0 1.308-.765m-9.32 16.558.982-1.743a1.5 1.5 0 0 0-2.614-1.473l-.981 1.743a1.5 1.5 0 0 0 2.613 1.473M5.9 8.567a1.5 1.5 0 0 0-.57-2.043l-1.744-.981a1.5 1.5 0 0 0-1.473 2.613l1.743.982A1.5 1.5 0 0 0 5.9 8.567m16.558 9.32a1.5 1.5 0 0 0-.57-2.043l-1.743-.982a1.5 1.5 0 0 0-1.473 2.614l1.743.981a1.5 1.5 0 0 0 2.043-.57M8.567 5.9a1.5 1.5 0 0 0 .571-2.043l-.982-1.744a1.5 1.5 0 0 0-2.613 1.473l.981 1.743a1.5 1.5 0 0 0 1.308.764 1.5 1.5 0 0 0 .735-.193m9.32 16.558a1.5 1.5 0 0 0 .57-2.043l-.981-1.743a1.5 1.5 0 0 0-2.614 1.473l.982 1.743a1.5 1.5 0 0 0 2.043.57m2.257-13.32 1.743-.982a1.5 1.5 0 0 0-1.473-2.613l-1.743.981a1.5 1.5 0 0 0 1.473 2.614M3.586 18.457l1.743-.981a1.5 1.5 0 0 0-1.473-2.614l-1.743.982a1.5 1.5 0 0 0 .738 2.806 1.5 1.5 0 0 0 .735-.193"
        })
    });
}



function $3d8a9c46e8c2ffed$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("svg", {
        xmlSpace: "preserve",
        id: "7ee1ee__Capa_1",
        width: 512,
        height: 512,
        x: 0,
        y: 0,
        style: {},
        viewBox: "0 0 508.779 508.779",
        ...props,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("g", {
            fill: "currentColor",
            children: [
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
                    d: "M403.723 180.395v-31.061C403.723 66.859 336.864 0 254.389 0S105.056 66.859 105.056 149.333v31.061c-39.236 20.023-63.952 60.334-64 104.384v106.667c.071 64.772 52.561 117.263 117.333 117.333h192c64.772-.071 117.263-52.561 117.333-117.333V284.779c-.047-44.05-24.763-84.362-63.999-104.384M254.389 64c47.128 0 85.333 38.205 85.333 85.333v18.112H169.056v-18.112c0-47.128 38.205-85.333 85.333-85.333m149.334 327.445c0 29.455-23.878 53.333-53.333 53.333h-192c-29.455 0-53.333-23.878-53.333-53.333V284.779c0-29.455 23.878-53.333 53.333-53.333h192c29.455 0 53.333 23.878 53.333 53.333Z"
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
                    d: "M243.723 295.445h21.333c17.673 0 32 14.327 32 32s-14.327 32-32 32h-21.333c-17.673 0-32-14.327-32-32s14.327-32 32-32"
                })
            ]
        })
    });
}



function $c26857e96933a949$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("svg", {
        id: "41355f__Layer_1",
        width: 512,
        height: 512,
        "data-name": "Layer 1",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
            fill: "currentColor",
            d: "m20.469 1.146-.031-.011-2.591-.863a5.34 5.34 0 0 0-3.1-.081L9.44 1.734A2.3 2.3 0 0 1 7.859 1.6l-.5-.23A5.318 5.318 0 0 0 0 6.277V17.8a5.33 5.33 0 0 0 3.822 5.1l2.74.857A5.3 5.3 0 0 0 8.148 24a6.3 6.3 0 0 0 1.416-.192L15.1 22.28a2.3 2.3 0 0 1 1.249.01l2.259.651A4.363 4.363 0 0 0 24 18.7V6.154a5.33 5.33 0 0 0-3.531-5.008M14 3.534V19.47l-4 1.105V4.668ZM4.682 20.027A2.33 2.33 0 0 1 3 17.8V6.277a2.29 2.29 0 0 1 1.032-1.929 2.34 2.34 0 0 1 1.3-.4 2.15 2.15 0 0 1 .823.162L7 4.464v16.288ZM21 18.7a1.367 1.367 0 0 1-1.625 1.341L17 19.37V3.153l2.475.823A2.32 2.32 0 0 1 21 6.154Z"
        })
    });
}



function $7534e45f1184cb0b$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("svg", {
        id: "92b6c8__Layer_1",
        "data-name": "Layer 1",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
            fill: "currentColor",
            d: "M10.336 10.366c.459.449 1.061.674 1.664.674s1.205-.225 1.663-.673l1.872-1.831C16.479 7.592 17 6.336 17 5s-.521-2.592-1.465-3.536S13.335 0 12 0 9.408.52 8.465 1.464 7 3.664 7 5s.523 2.595 1.48 3.551Zm-.457-7.488C10.444 2.312 11.198 2 12 2s1.555.312 2.121.879C14.687 3.445 15 4.198 15 5s-.312 1.555-.871 2.114l-1.864 1.824a.38.38 0 0 1-.529 0L9.887 7.13C9.315 6.559 9 5.803 9 5.001s.312-1.555.879-2.122ZM23 6a1 1 0 0 0-1 1h-2.5a1 1 0 1 0 0 2H22v7h-2.258a2 2 0 0 1-1.414-.586l-2.621-2.621a.999.999 0 1 0-1.414 1.414l2.621 2.621A4.02 4.02 0 0 0 19.742 18H22v3H10v-1.757a3.98 3.98 0 0 0-1.172-2.829l-2.242-2.242A3.97 3.97 0 0 0 3.757 13H2V9h2.5a1 1 0 0 0 0-2H2a1 1 0 0 0-2 0v16a1 1 0 0 0 2 0h20a1 1 0 1 0 2 0V7a1 1 0 0 0-1-1M2 15h1.757c.534 0 1.037.208 1.415.586l2.242 2.242c.378.378.586.88.586 1.415V21H2Zm8.5-10a1.5 1.5 0 1 1 3.001.001A1.5 1.5 0 0 1 10.5 5"
        })
    });
}



function $905a0bdd72d3d355$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("svg", {
        id: "20181d__Isolation_Mode",
        width: 512,
        height: 512,
        "data-name": "Isolation Mode",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
                fill: "currentColor",
                d: "M12 .021A10.077 10.077 0 0 0 1.935 10.087c0 5.274 8.166 12.329 9.1 13.117l.967.817.967-.817c.932-.788 9.1-7.843 9.1-13.117A10.077 10.077 0 0 0 12 .021m0 20.043c-3.065-2.792-7.067-7.328-7.067-9.977a7.067 7.067 0 1 1 14.134 0c0 2.644-4.003 7.182-7.067 9.977"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("circle", {
                cx: 12,
                cy: 10.002,
                r: 2.997
            })
        ]
    });
}



function $7c0d122c1d0221cd$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("svg", {
        id: "bc9910__Layer_1",
        "data-name": "Layer 1",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
            fill: "currentColor",
            d: "m23.993 11.098-1.035-1.711-12.601 7.629c-1.315.018-4.485.129-5.639.764a3.3 3.3 0 0 0-1.586 1.98c-.247.851-.147 1.746.279 2.522s1.13 1.339 1.979 1.586q.462.133.93.133c.551 0 1.096-.139 1.592-.412 1.198-.658 2.84-3.629 3.488-4.868l12.593-7.624ZM6.761 0C4.935 2.693 5.794 7 3.5 7c-1 0-1-3-1-3C1.422 5.112 0 7.41 0 9.5a6.5 6.5 0 1 0 13 0C13 5.394 8.792 2.364 6.761 0m1.178 13.414a2 2 0 0 1-2.829-2.829L6.525 9.17l1.414 1.415a2 2 0 0 1 0 2.829"
        })
    });
}



function $ad5b221a073b2c1b$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("svg", {
        id: "948c2c__Layer_1",
        "data-name": "Layer 1",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
            fill: "currentColor",
            d: "M9 12c3.309 0 6-2.691 6-6s-2.691-6-6-6-6 2.691-6 6 2.691 6 6 6M9 2c2.206 0 4 1.794 4 4s-1.794 4-4 4-4-1.794-4-4 1.794-4 4-4M5 14h6v2H5c-1.654 0-3 1.346-3 3v5H0v-5c0-2.757 2.243-5 5-5m16.5-3h-6a2.503 2.503 0 0 0-2.5 2.5V24h11V13.5c0-1.378-1.121-2.5-2.5-2.5m.5 11h-7v-8.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 .5.5Zm-6.001-7.003h5v2h-5Zm0 3.003h5v2h-5Z"
        })
    });
}



function $8c8be0a53f920dd9$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("svg", {
        xmlSpace: "preserve",
        id: "ec753d__Capa_1",
        width: 512,
        height: 512,
        x: 0,
        y: 0,
        style: {},
        viewBox: "0 0 512 512",
        ...props,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("g", {
            fill: "currentColor",
            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
                d: "M480 224H32c-17.673 0-32 14.327-32 32s14.327 32 32 32h448c17.673 0 32-14.327 32-32s-14.327-32-32-32M32 138.667h448c17.673 0 32-14.327 32-32s-14.327-32-32-32H32c-17.673 0-32 14.327-32 32s14.327 32 32 32M480 373.333H32c-17.673 0-32 14.327-32 32s14.327 32 32 32h448c17.673 0 32-14.327 32-32s-14.327-32-32-32"
            })
        })
    });
}



function $9b3c2689c91f9f58$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("svg", {
        id: "9239ee__Bold",
        width: 512,
        height: 512,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
            fill: "currentColor",
            d: "M16.5 13.5h-9a1.5 1.5 0 0 1 0-3h9a1.5 1.5 0 0 1 0 3"
        })
    });
}



function $d003f8b768c015ff$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("svg", {
        id: "93de65__Layer_1",
        "data-name": "Layer 1",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
            fill: "currentColor",
            d: "M8 6.5a1.5 1.5 0 1 1-3.001-.001A1.5 1.5 0 0 1 8 6.5M6.5 10a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 6.5 10m0 5a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 6.5 15m5-7h6a1.5 1.5 0 1 0 0-3h-6a1.5 1.5 0 1 0 0 3m0 5h6a1.5 1.5 0 1 0 0-3h-6a1.5 1.5 0 1 0 0 3m12.319 5.89a1.12 1.12 0 0 1 0 1.22C22.908 21.543 20.793 24 17 24s-5.91-2.459-6.82-3.89a1.12 1.12 0 0 1 0-1.22C11.091 17.457 13.206 15 17 15s5.908 2.457 6.819 3.89M19 19.5a2 2 0 1 0-3.999-.001A2 2 0 0 0 19 19.5M18.5 0h-13A5.506 5.506 0 0 0 0 5.5v12C0 20.532 2.467 23 5.5 23h2a1.5 1.5 0 1 0 0-3h-2A2.503 2.503 0 0 1 3 17.5v-12C3 4.122 4.122 3 5.5 3h13C19.878 3 21 4.122 21 5.5V13a1.5 1.5 0 1 0 3 0V5.5C24 2.467 21.533 0 18.5 0"
        })
    });
}



function $da50346a8839259a$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("svg", {
        id: "88e0a1__Bold",
        width: 512,
        height: 512,
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("circle", {
                cx: 16,
                cy: 8,
                r: 2
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("circle", {
                cx: 9,
                cy: 8,
                r: 2
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("circle", {
                cx: 8,
                cy: 15,
                r: 2
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
                fill: "currentColor",
                d: "M24.036 10.928A12.144 12.144 0 0 0 12.5.008 12 12 0 1 0 12.083 24c.338 0 .669-.022 1-.049a1.5 1.5 0 0 0 1.376-1.508l-.03-3.425a2.859 2.859 0 0 1 4.88-2.047l.1.1a2.38 2.38 0 0 0 2.19.644A2.34 2.34 0 0 0 23.3 16.25a11.9 11.9 0 0 0 .736-5.322m-3.249 3.366a5.86 5.86 0 0 0-9.359 4.75l.017 1.933A9 9 0 0 1 12.082 3c.1 0 .212 0 .318.006a9.105 9.105 0 0 1 8.648 8.185 9 9 0 0 1-.261 3.103"
            })
        ]
    });
}



function $991c38f722f5cb61$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("svg", {
        id: "3e2cb9__Layer_1",
        "data-name": "Layer 1",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
            fill: "currentColor",
            d: "M5 10.5v3a2.5 2.5 0 1 0 5 0v-3a2.5 2.5 0 1 0-5 0m3.4 0v3c0 .496-.404.9-.9.9s-.9-.404-.9-.9v-3c0-.496.404-.9.9-.9s.9.404.9.9m2.6 0v3a2.5 2.5 0 1 0 5 0v-3a2.5 2.5 0 1 0-5 0m3.4 0v3c0 .496-.404.9-.9.9s-.9-.404-.9-.9v-3c0-.496.404-.9.9-.9s.9.404.9.9m9.6 4.231c0 .69-.56 1.25-1.25 1.25s-1.25-.56-1.25-1.25a1.25 1.25 0 0 1 2.5 0m-5.75-4.25c-.69 0-1.25-.56-1.25-1.25s.56-1.25 1.25-1.25a1.25 1.25 0 0 1 0 2.5m-.576 4.263 4.178-6.4a.8.8 0 0 1 1.34.874l-4.178 6.4a.8.8 0 0 1-1.34-.874M3.2 16.001a.8.8 0 0 1-.8-.8v-4.532l-.36.372A.8.8 0 0 1 .891 9.928l1.63-1.682A.862.862 0 0 1 4 8.845v6.357a.8.8 0 0 1-.8.8Zm17.213 2.451a1.5 1.5 0 0 1-.022 2.121c-2.258 2.21-5.238 3.428-8.391 3.428s-6.133-1.218-8.391-3.428a1.5 1.5 0 1 1 2.099-2.144c1.694 1.659 3.929 2.572 6.292 2.572s4.598-.913 6.292-2.572a1.5 1.5 0 0 1 2.121.023M3.586 5.549a1.5 1.5 0 0 1 .022-2.121C5.867 1.218 8.847 0 12 0s6.133 1.218 8.391 3.428a1.5 1.5 0 1 1-2.099 2.144C16.598 3.913 14.363 3 12 3s-4.598.913-6.292 2.572a1.5 1.5 0 0 1-2.121-.023Z"
        })
    });
}



function $c42fbb73d2b37302$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("svg", {
        xmlSpace: "preserve",
        id: "c06eac__Capa_1",
        width: 512,
        height: 512,
        x: 0,
        y: 0,
        style: {},
        viewBox: "0 0 512 512",
        ...props,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
            fill: "currentColor",
            d: "M480 224H288V32c0-17.673-14.327-32-32-32s-32 14.327-32 32v192H32c-17.673 0-32 14.327-32 32s14.327 32 32 32h192v192c0 17.673 14.327 32 32 32s32-14.327 32-32V288h192c17.673 0 32-14.327 32-32s-14.327-32-32-32"
        })
    });
}



function $184976094180ac3d$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("svg", {
        id: "b79fa5__Layer_1",
        "data-name": "Layer 1",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
            fill: "currentColor",
            d: "M9.671 21.562a1.499 1.499 0 1 1-2.342 1.875l-4-5C1.63 16.17 0 13.729 0 10.567c0-2.83 1.091-5.485 3.072-7.476C5.056 1.098 7.694 0 10.5 0s5.443 1.098 7.427 3.09a10.6 10.6 0 0 1 3.016 8.564 1.5 1.5 0 0 1-2.984-.308q.023-.221.034-.442a7.6 7.6 0 0 0-2.191-5.697c-1.416-1.423-3.298-2.206-5.3-2.206s-3.885.783-5.301 2.207a7.55 7.55 0 0 0-2.199 5.36c0 2.241 1.278 4.133 2.701 6.033l3.971 4.962Zm3.951-6.524 3.671 3.67a1.025 1.025 0 0 0 1.414 0l3.67-3.67A2 2 0 0 0 22 15h-8q-.194.002-.378.038m10.263 1.32-3.764 3.764c-.585.585-1.353.877-2.121.877s-1.536-.292-2.121-.877l-3.764-3.764a2 2 0 0 0-.115.641v5a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-5c0-.226-.046-.439-.115-.642ZM10.5 15C8.019 15 6 12.981 6 10.5S8.019 6 10.5 6 15 8.019 15 10.5 12.981 15 10.5 15m1.5-4.5c0-.827-.673-1.5-1.5-1.5S9 9.673 9 10.5s.673 1.5 1.5 1.5 1.5-.673 1.5-1.5"
        })
    });
}



function $e326dab9667246e9$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("svg", {
        id: "bae79f__Bold",
        width: 512,
        height: 512,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
            fill: "currentColor",
            d: "M19.5 6H19V4.5A4.505 4.505 0 0 0 14.5 0h-5A4.505 4.505 0 0 0 5 4.5V6h-.5A4.505 4.505 0 0 0 0 10.5v6A4.505 4.505 0 0 0 4.5 21h.776A4.49 4.49 0 0 0 9.5 24h5a4.49 4.49 0 0 0 4.224-3h.776a4.505 4.505 0 0 0 4.5-4.5v-6A4.505 4.505 0 0 0 19.5 6M8 4.5A1.5 1.5 0 0 1 9.5 3h5A1.5 1.5 0 0 1 16 4.5V6H8Zm8 15a1.5 1.5 0 0 1-1.5 1.5h-5A1.5 1.5 0 0 1 8 19.5v-2A1.5 1.5 0 0 1 9.5 16h5a1.5 1.5 0 0 1 1.5 1.5Zm5-3a1.5 1.5 0 0 1-1.5 1.5H19v-.5a4.505 4.505 0 0 0-4.5-4.5h-5A4.505 4.505 0 0 0 5 17.5v.5h-.5A1.5 1.5 0 0 1 3 16.5v-6A1.5 1.5 0 0 1 4.5 9h15a1.5 1.5 0 0 1 1.5 1.5Z"
        })
    });
}



function $5404fe47966938c8$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("svg", {
        id: "68935e__Layer_1",
        "data-name": "Layer 1",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
            fill: "currentColor",
            d: "M21 17h-1v-1a1 1 0 1 0-2 0v1h-5c-1.654 0-3 1.346-3 3v.5c0 .827-.673 1.5-1.5 1.5S7 21.327 7 20.5v-17c0-.539-.133-1.044-.351-1.5H9a1 1 0 1 0 0-2H3.5C1.57 0 0 1.57 0 3.5V4c0 1.654 1.346 3 3 3h2v13.5A3.504 3.504 0 0 0 8.498 24H20.5c1.93 0 3.5-1.57 3.5-3.5V20c0-1.654-1.346-3-3-3M5 5H3c-.552 0-1-.449-1-1v-.5C2 2.673 2.673 2 3.5 2S5 2.673 5 3.5Zm17 15.5c0 .827-.673 1.5-1.5 1.5h-8.838c.217-.455.338-.963.338-1.5V20c0-.551.448-1 1-1h8c.552 0 1 .449 1 1ZM17 14c3.859 0 7-3.14 7-7s-3.141-7-7-7-7 3.14-7 7 3.141 7 7 7m0-12c2.757 0 5 2.243 5 5s-2.243 5-5 5-5-2.243-5-5 2.243-5 5-5m-3.482 4.8a1 1 0 0 1 1.414-.015l1.131 1.108a.377.377 0 0 0 .522 0l2.223-2.134a1 1 0 0 1 1.385 1.443L17.98 9.326c-.453.447-1.052.671-1.653.671s-1.204-.224-1.664-.674l-1.131-1.108a1 1 0 0 1-.014-1.414Z"
        })
    });
}



function $34a1d1791d81395f$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("svg", {
        id: "bc1cd3__Layer_1",
        "data-name": "Layer 1",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
            fill: "currentColor",
            d: "m17.404 13.87-4.181-7.167a1.416 1.416 0 0 0-2.447 0L6.595 13.87c-.551.944.13 2.13 1.224 2.13h8.361a1.417 1.417 0 0 0 1.224-2.13M12 15c-.552 0-1-.448-1-1s.448-1 1-1a1 1 0 0 1 0 2m1-4a1 1 0 0 1-2 0V9a1 1 0 0 1 2 0Zm8.868 4.889-.542-.309c.429-1.113.674-2.317.674-3.58s-.245-2.467-.674-3.58l.542-.309a1.5 1.5 0 0 0-1.483-2.608l-.544.309A10 10 0 0 0 13.5 2.124v-.625a1.5 1.5 0 1 0-3 0v.625a10 10 0 0 0-6.341 3.688l-.544-.309a1.5 1.5 0 0 0-1.483 2.608l.542.309C2.245 9.533 2 10.737 2 12s.245 2.467.674 3.58l-.542.309a1.5 1.5 0 0 0 1.483 2.608l.544-.309a10 10 0 0 0 6.341 3.688v.625a1.5 1.5 0 1 0 3 0v-.625a10 10 0 0 0 6.341-3.688l.544.309a1.498 1.498 0 0 0 2.045-.562 1.5 1.5 0 0 0-.562-2.046M12 19c-3.86 0-7-3.141-7-7s3.14-7 7-7 7 3.141 7 7-3.14 7-7 7"
        })
    });
}



function $63b917b4b41e9254$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("svg", {
        id: "c63309__Layer_1",
        width: 512,
        height: 512,
        "data-name": "Layer 1",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
            fill: "currentColor",
            d: "M21.567 4.4A5.31 5.31 0 0 0 16.33 0H7.657a5.31 5.31 0 0 0-5.238 4.4L.081 17.765A5.317 5.317 0 0 0 5.319 24h13.362a5.32 5.32 0 0 0 5.238-6.239Zm-1.111 15.772a2.31 2.31 0 0 1-1.775.828H5.319a2.317 2.317 0 0 1-2.283-2.718L5.374 4.918A2.314 2.314 0 0 1 7.657 3h8.673a2.31 2.31 0 0 1 2.282 1.917l2.352 13.363a2.31 2.31 0 0 1-.508 1.892M13.5 5.5v1a1.5 1.5 0 0 1-3 0v-1a1.5 1.5 0 0 1 3 0m0 6v1a1.5 1.5 0 0 1-3 0v-1a1.5 1.5 0 0 1 3 0m0 6v1a1.5 1.5 0 0 1-3 0v-1a1.5 1.5 0 0 1 3 0"
        })
    });
}



function $edbb0873c41baafd$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("svg", {
        id: "e518ed__Layer_1",
        width: 512,
        height: 512,
        "data-name": "Layer 1",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
            fill: "currentColor",
            d: "M12 0a11.94 11.94 0 0 0-8 3.078V1a1 1 0 1 0-2 0v4c0 1.103.897 2 2 2h4a1 1 0 1 0 0-2H4.87A9.95 9.95 0 0 1 12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10c-5.21 0-9.492-3.908-9.959-9.09a1 1 0 0 0-1.992.18C.61 19.31 5.748 24 12 24c6.617 0 12-5.383 12-12S18.617 0 12 0"
        })
    });
}



function $4ee37104d76d8d68$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("svg", {
        id: "c0a08c__Layer_1",
        width: 512,
        height: 512,
        "data-name": "Layer 1",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
            fill: "currentColor",
            d: "m19 11.994-3.524-3.447c-1.961-1.961-1.961-5.133-.012-7.083C16.409.52 17.665 0 19 0s2.591.52 3.535 1.464S24 3.664 24 5s-.52 2.591-1.465 3.536ZM19 3c-.534 0-1.037.208-1.415.586a2.003 2.003 0 0 0 0 2.828L19 7.797l1.426-1.395C20.792 6.036 21 5.534 21 5s-.208-1.037-.586-1.415A2 2 0 0 0 19 3M5 23.994l-3.524-3.447c-1.961-1.961-1.961-5.133-.012-7.083C2.409 12.52 3.665 12 5 12s2.591.52 3.535 1.464S10 15.664 10 17s-.52 2.591-1.465 3.536ZM5 15c-.534 0-1.037.208-1.415.586a2.003 2.003 0 0 0 0 2.828L5 19.797l1.426-1.395C6.792 18.036 7 17.534 7 17s-.208-1.037-.586-1.415A2 2 0 0 0 5 15m14.5 0h-4c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5h.646l-2.069-2.023a7 7 0 0 1-.481-.531c-1.547.727-2.597 2.291-2.597 4.055 0 2.481 2.019 4.5 4.5 4.5h4c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5h-8.755a7 7 0 0 1-.794.95l-2.096 2.05H19.5c2.481 0 4.5-2.019 4.5-4.5s-2.019-4.5-4.5-4.5Z"
        })
    });
}



function $88080ba167357c0a$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("svg", {
        id: "4cfce0__Layer_1",
        width: 512,
        height: 512,
        "data-name": "Layer 1",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
            fill: "currentColor",
            d: "M11 13.03v-13H3.5C1.57.03 0 1.601 0 3.53v16c0 2.481 2.019 4.5 4.5 4.5h16c1.93 0 3.5-1.57 3.5-3.5v-7.5Zm10 7.5c0 .275-.225.5-.5.5h-16c-.827 0-1.5-.673-1.5-1.5v-16a.5.5 0 0 1 .5-.5H8v2H5v3h3v2H5v3h3v3h3v3h3v-3h2v3h3v-3h2Z"
        })
    });
}



function $bd7e2dbc65d25ee1$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("svg", {
        xmlSpace: "preserve",
        id: "0ee1c9__Capa_1",
        width: 512,
        height: 512,
        x: 0,
        y: 0,
        style: {},
        viewBox: "0 0 513.749 513.749",
        ...props,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
            fill: "currentColor",
            d: "m504.352 459.061-99.435-99.477c74.402-99.427 54.115-240.344-45.312-314.746S119.261-9.277 44.859 90.15-9.256 330.494 90.171 404.896C170.039 464.662 279.736 464.662 359.605 404.896l99.477 99.477C471.583 516.874 491.851 516.874 504.351 504.373s12.501-32.769 0-45.269Zm-278.635-73.365c-88.366 0-160-71.634-160-160s71.634-160 160-160 160 71.634 160 160c-.094 88.326-71.673 159.906-160 160"
        })
    });
}



function $28aca348168235e4$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("svg", {
        id: "d5ff73__Layer_1",
        width: 512,
        height: 512,
        "data-name": "Layer 1",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
            fill: "currentColor",
            d: "M12 19c-2.757 0-5-2.243-5-5v-4c0-2.757 2.243-5 5-5s5 2.243 5 5v4c0 2.757-2.243 5-5 5m0-11c-1.103 0-2 .897-2 2v4c0 1.103.897 2 2 2s2-.897 2-2v-4c0-1.103-.897-2-2-2m6.5 16h-13A5.506 5.506 0 0 1 0 18.5v-13C0 2.467 2.467 0 5.5 0h13C21.533 0 24 2.467 24 5.5v13c0 3.033-2.467 5.5-5.5 5.5M5.5 3A2.503 2.503 0 0 0 3 5.5v13C3 19.878 4.122 21 5.5 21h13c1.378 0 2.5-1.122 2.5-2.5v-13C21 4.122 19.878 3 18.5 3Z"
        })
    });
}



function $3861600376af66f7$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("svg", {
        id: "fe341a__Layer_1",
        "data-name": "Layer 1",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
            fill: "currentColor",
            d: "M3.5 0H7v3H3.5a.5.5 0 0 0-.5.5V7H0V3.5C0 1.57 1.57 0 3.5 0M3 9H0v6h3Zm0 8H0v7h7v-3H3Zm18 4h-4v3h7v-7h-3Zm0-6h3V9h-3Zm-.5-15H17v3h3.5a.5.5 0 0 1 .5.5V7h3V3.5C24 1.57 22.43 0 20.5 0M9 3h6V0H9Zm0 21h6v-3H9Z"
        })
    });
}



function $f742741bb1db7e48$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("svg", {
        id: "21437c__Layer_1",
        "data-name": "Layer 1",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
            fill: "currentColor",
            d: "M16.663 2.002A3.5 3.5 0 0 0 13.5 0h-3a3.5 3.5 0 0 0-3.163 2.002A5.507 5.507 0 0 0 2 7.5v11C2 21.532 4.468 24 7.5 24h9c3.032 0 5.5-2.468 5.5-5.5v-11a5.506 5.506 0 0 0-5.337-5.498M19 18.5c0 1.379-1.121 2.5-2.5 2.5h-9A2.5 2.5 0 0 1 5 18.5v-11C5 6.121 6.121 5 7.5 5h1A1.5 1.5 0 0 0 10 3.5c0-.275.225-.5.5-.5h3c.275 0 .5.225.5.5A1.5 1.5 0 0 0 15.5 5h1C17.879 5 19 6.121 19 7.5Zm-7.831-9.255-.793.793.793.793a.999.999 0 1 1-1.414 1.414l-.793-.793-.793.793a.997.997 0 0 1-1.414 0 1 1 0 0 1 0-1.414l.793-.793-.793-.793a.999.999 0 1 1 1.414-1.414l.793.793.793-.793a.999.999 0 1 1 1.414 1.414m0 7-.793.793.793.793a.999.999 0 1 1-1.414 1.414l-.793-.793-.793.793a.997.997 0 0 1-1.414 0 1 1 0 0 1 0-1.414l.793-.793-.793-.793a.999.999 0 1 1 1.414-1.414l.793.793.793-.793a.999.999 0 1 1 1.414 1.414M17 10.5a1.5 1.5 0 0 1-1.5 1.5h-1a1.5 1.5 0 0 1 0-3h1a1.5 1.5 0 0 1 1.5 1.5m0 6a1.5 1.5 0 0 1-1.5 1.5h-1a1.5 1.5 0 0 1 0-3h1a1.5 1.5 0 0 1 1.5 1.5"
        })
    });
}



function $7fbbd37bddf2b2d4$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("svg", {
        id: "2b998b__Layer_1",
        width: 512,
        height: 512,
        "data-name": "Layer 1",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
            fill: "currentColor",
            d: "M23.436 5.089a1.5 1.5 0 0 0-.352-.622A5.5 5.5 0 0 0 18.5 2h-13A5.5 5.5 0 0 0 .916 4.467a1.5 1.5 0 0 0-.352.622A5.45 5.45 0 0 0 0 7.5v9C0 19.533 2.467 22 5.5 22h13c3.033 0 5.5-2.467 5.5-5.5v-9c0-.865-.206-1.682-.564-2.411M3 7.5q0-.257.051-.5H10.5v4.5H3ZM13.5 7h7.449q.05.243.051.5v4h-7.5ZM3 16.5v-2h7.5V19h-5A2.503 2.503 0 0 1 3 16.5M18.5 19h-5v-4.5H21v2c0 1.378-1.122 2.5-2.5 2.5"
        })
    });
}



function $eac63c8e069d6295$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("svg", {
        id: "c40d0a__Layer_1",
        width: 512,
        height: 512,
        "data-name": "Layer 1",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
            fill: "currentColor",
            d: "M10 24H0v-3h10Zm-2-8H0v3h8Zm-2-5H0v3h6Zm5-5v6.621l3.439 3.44 2.122-2.122L14 11.379V6Zm1-6A12.006 12.006 0 0 0 .4 9h3.13A8.995 8.995 0 1 1 12 21v3a12 12 0 0 0 0-24"
        })
    });
}



function $7e4c1a315f05f205$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("svg", {
        id: "eb4314__Layer_1",
        width: 512,
        height: 512,
        "data-name": "Layer 1",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
            fill: "currentColor",
            d: "M16 4H8c-4.411 0-8 3.589-8 8s3.589 8 8 8h8c4.411 0 8-3.589 8-8s-3.589-8-8-8m0 14H8c-3.309 0-6-2.691-6-6s2.691-6 6-6h8c3.309 0 6 2.691 6 6s-2.691 6-6 6M8 8c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4m0 6c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2"
        })
    });
}



function $b588943cd3450995$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("svg", {
        id: "dd7dfd__Layer_1",
        width: 512,
        height: 512,
        "data-name": "Layer 1",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
            fill: "currentColor",
            d: "M16 4H8c-4.411 0-8 3.589-8 8s3.589 8 8 8h8c4.411 0 8-3.589 8-8s-3.589-8-8-8m0 14H8c-3.309 0-6-2.691-6-6s2.691-6 6-6h8c3.309 0 6 2.691 6 6s-2.691 6-6 6m4-6c0 2.206-1.794 4-4 4s-4-1.794-4-4 1.794-4 4-4 4 1.794 4 4"
        })
    });
}



function $e01b1ff32d2680dc$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("svg", {
        id: "f6bb9d__Layer_1",
        "data-name": "Layer 1",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
            fill: "currentColor",
            d: "M23.03 1.71A4.47 4.47 0 0 0 19.499 0h-2.636a5.48 5.48 0 0 0-5.351 4.226L8.123 18.457a4.48 4.48 0 0 0 .847 3.833A4.47 4.47 0 0 0 12.501 24h2.636a5.48 5.48 0 0 0 5.351-4.226l3.389-14.231a4.48 4.48 0 0 0-.847-3.833m-2.072 3.138L17.57 19.079A2.49 2.49 0 0 1 15.137 21h-2.636c-.462 0-.891-.208-1.177-.57a1.49 1.49 0 0 1-.283-1.277l3.388-14.231a2.49 2.49 0 0 1 2.433-1.921h2.636c.462 0 .891.208 1.177.57s.39.828.283 1.277M6 22.5A1.5 1.5 0 0 1 4.5 24 4.505 4.505 0 0 1 0 19.5a1.5 1.5 0 1 1 3 0S3.673 21 4.5 21s1.5.672 1.5 1.5m0-21C6 2.328 5.329 3 4.5 3S3 3.673 3 4.5a1.5 1.5 0 0 1-3 0C0 2.019 2.019 0 4.5 0A1.5 1.5 0 0 1 6 1.5m-6 8a1.5 1.5 0 1 1 3.001.001A1.5 1.5 0 0 1 0 9.5m8-8a1.5 1.5 0 1 1 3.001.001A1.5 1.5 0 0 1 8 1.5m-8 13a1.5 1.5 0 1 1 3.001.001A1.5 1.5 0 0 1 0 14.5"
        })
    });
}



function $6bfc853f5330ffbe$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("svg", {
        xmlSpace: "preserve",
        id: "56c575__Capa_1",
        width: 512,
        height: 512,
        x: 0,
        y: 0,
        style: {},
        viewBox: "0 0 512 512",
        ...props,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("g", {
            fill: "currentColor",
            children: [
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
                    d: "M490.667 96c0-17.673-14.327-32-32-32h-80.555C364.632 25.757 328.549.13 288 0h-64c-40.549.13-76.632 25.757-90.112 64H53.333c-17.673 0-32 14.327-32 32s14.327 32 32 32H64v266.667C64 459.468 116.532 512 181.333 512h149.333C395.468 512 448 459.468 448 394.667V128h10.667c17.673 0 32-14.327 32-32M384 394.667C384 424.122 360.122 448 330.667 448H181.333C151.878 448 128 424.122 128 394.667V128h256Z"
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
                    d: "M202.667 384c17.673 0 32-14.327 32-32V224c0-17.673-14.327-32-32-32s-32 14.327-32 32v128c0 17.673 14.327 32 32 32M309.333 384c17.673 0 32-14.327 32-32V224c0-17.673-14.327-32-32-32s-32 14.327-32 32v128c0 17.673 14.327 32 32 32"
                })
            ]
        })
    });
}



function $e29ee8011de35584$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("svg", {
        id: "9e9245__Layer_1",
        width: 512,
        height: 512,
        "data-name": "Layer 1",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
            fill: "currentColor",
            d: "M24 21H0L10.264 3.223a2 2 0 0 1 3.472 0ZM3.471 19h17.058L12 4.229Z"
        })
    });
}



function $cc335155ea44841a$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("svg", {
        id: "43901b__Layer_1",
        width: 512,
        height: 512,
        "data-name": "Layer 1",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
            fill: "currentColor",
            d: "M11 13V7c0-.55.45-1 1-1s1 .45 1 1v6c0 .55-.45 1-1 1s-1-.45-1-1m1 2c-.83 0-1.5.67-1.5 1.5S11.17 18 12 18s1.5-.67 1.5-1.5S12.83 15 12 15m11.58 4.88c-.7 1.35-2.17 2.12-4.01 2.12H4.44c-1.85 0-3.31-.77-4.01-2.12-.71-1.36-.51-3.1.5-4.56L8.97 2.6C9.68 1.58 10.8 1 12 1s2.32.58 3 1.57l8.08 12.77c1.01 1.46 1.2 3.19.49 4.54Zm-2.15-3.42s-.02-.02-.02-.04L13.34 3.67C13.05 3.26 12.55 3 12 3s-1.05.26-1.36.71L2.59 16.42c-.62.88-.76 1.84-.4 2.53.35.68 1.15 1.05 2.24 1.05h15.12c1.09 0 1.89-.37 2.24-1.05.36-.69.22-1.65-.37-2.49Z"
        })
    });
}



function $be257bd0b13779d6$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("svg", {
        xmlSpace: "preserve",
        id: "636a73__Capa_1",
        width: 512,
        height: 512,
        x: 0,
        y: 0,
        style: {},
        viewBox: "0 0 512.033 512.033",
        ...props,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("g", {
            fill: "currentColor",
            children: [
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
                    d: "M352.017 170.7H170.683v-16.491c.009-49.815 40.399-90.19 90.214-90.181a90.2 90.2 0 0 1 78.895 46.511c8.577 15.452 28.057 21.025 43.509 12.448s21.025-28.057 12.448-43.509C354.469 4.992 260.62-21.925 186.134 19.356c-49.024 27.17-79.445 78.803-79.451 134.853v29.44c-39.236 20.023-63.952 60.334-64 104.384V394.7c.071 64.772 52.561 117.263 117.333 117.333h192c64.772-.071 117.263-52.561 117.333-117.333V288.033c-.069-64.772-52.56-117.262-117.332-117.333m53.333 224c0 29.455-23.878 53.333-53.333 53.333h-192c-29.455 0-53.333-23.878-53.333-53.333V288.033c0-29.455 23.878-53.333 53.333-53.333h192c29.455 0 53.333 23.878 53.333 53.333Z"
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
                    d: "M245.35 298.7h21.333c17.673 0 32 14.327 32 32s-14.327 32-32 32H245.35c-17.673 0-32-14.327-32-32s14.327-32 32-32"
                })
            ]
        })
    });
}



function $bafcb27b68637007$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("svg", {
        xmlSpace: "preserve",
        id: "d1452a__Capa_1",
        width: 512,
        height: 512,
        x: 0,
        y: 0,
        style: {},
        viewBox: "0 0 512.022 512.022",
        ...props,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("g", {
            fill: "currentColor",
            children: [
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
                    d: "m165.558 141.889 59.328-59.349.448 290.816c0 17.673 14.327 32 32 32s32-14.327 32-32l-.448-290.453 58.987 58.987c12.278 12.712 32.536 13.064 45.248.786s13.064-32.536.786-45.248q-.387-.4-.786-.786l-68.523-68.523c-37.49-37.491-98.274-37.491-135.765-.001l-.001.001-68.522 68.522c-12.278 12.712-11.926 32.97.786 45.248 12.401 11.977 32.061 11.977 44.462 0"
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
                    d: "M480.011 309.355c-17.673 0-32 14.327-32 32v97.941a8.746 8.746 0 0 1-8.725 8.725H72.736a8.746 8.746 0 0 1-8.725-8.725v-97.941c0-17.673-14.327-32-32-32s-32 14.327-32 32v97.941c.047 40.146 32.58 72.678 72.725 72.725h366.549c40.146-.047 72.678-32.58 72.725-72.725v-97.941c.001-17.673-14.326-32-31.999-32"
                })
            ]
        })
    });
}



function $863559d598e1efcc$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("svg", {
        xmlSpace: "preserve",
        id: "0fc0f5__Capa_1",
        width: 512,
        height: 512,
        x: 0,
        y: 0,
        style: {},
        viewBox: "0 0 512.016 512.016",
        ...props,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("g", {
            fill: "currentColor",
            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
                d: "M158.992 299.058C68.075 307.276-1.191 384.099.016 475.378v4.629c0 17.673 14.327 32 32 32s32-14.327 32-32v-5.909c-.962-56.045 40.398-103.838 96-110.933 58.693-5.82 110.992 37.042 116.812 95.735.344 3.47.518 6.954.521 10.441v10.667c0 17.673 14.327 32 32 32s32-14.327 32-32v-10.667c-.104-94.363-76.685-170.774-171.047-170.67q-5.662.006-11.31.387M170.682 256.008c70.692 0 128-57.308 128-128s-57.308-128-128-128-128 57.308-128 128c.071 70.663 57.337 127.929 128 128m0-192c35.346 0 64 28.654 64 64s-28.654 64-64 64-64-28.654-64-64 28.654-64 64-64M480.016 213.341h-32v-32c0-17.673-14.327-32-32-32s-32 14.327-32 32v32h-32c-17.673 0-32 14.327-32 32s14.327 32 32 32h32v32c0 17.673 14.327 32 32 32s32-14.327 32-32v-32h32c17.673 0 32-14.327 32-32s-14.327-32-32-32"
            })
        })
    });
}



function $5a566642996ec9f8$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("svg", {
        id: "86eb28__Layer_1",
        width: 512,
        height: 512,
        "data-name": "Layer 1",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
            fill: "currentColor",
            d: "M15 6c0-3.309-2.691-6-6-6S3 2.691 3 6s2.691 6 6 6 6-2.691 6-6M9 9C7.346 9 6 7.654 6 6s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3m-.012 6.314a1.5 1.5 0 0 1-1.303 1.674c-2.627.328-4.686 2.749-4.686 5.512a1.5 1.5 0 1 1-3 0c0-4.249 3.213-7.977 7.314-8.488a1.5 1.5 0 0 1 1.674 1.303ZM23 18.498l-.638-.376c.084-.362.138-.735.138-1.123s-.054-.76-.138-1.123L23 15.5a1.5 1.5 0 1 0-1.523-2.585l-.648.382a5 5 0 0 0-1.83-1.043v-.755a1.5 1.5 0 1 0-3 0v.755a5 5 0 0 0-1.83 1.043l-.648-.382a1.5 1.5 0 0 0-1.523 2.585l.638.376c-.084.362-.138.735-.138 1.123s.054.76.138 1.123l-.638.376a1.5 1.5 0 1 0 1.523 2.585l.648-.382a5 5 0 0 0 1.83 1.043v.755a1.5 1.5 0 1 0 3 0v-.755a5 5 0 0 0 1.83-1.043l.648.382A1.5 1.5 0 1 0 23 18.498m-5.5.001c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5 1.5.673 1.5 1.5-.673 1.5-1.5 1.5"
        })
    });
}



function $a180105d81a81477$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("svg", {
        id: "ba225d__Layer_1",
        width: 512,
        height: 512,
        "data-name": "Layer 1",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
            fill: "currentColor",
            d: "M10.884 15.42a1.5 1.5 0 0 1-.807 1.962A4.99 4.99 0 0 0 6.999 22v.5a1.5 1.5 0 1 1-3 0V22a7.98 7.98 0 0 1 4.922-7.386 1.5 1.5 0 0 1 1.962.807Zm12.676 8.14c-.293.293-.677.439-1.061.439s-.768-.146-1.061-.439L.439 2.561c-.585-.586-.585-1.536 0-2.122A1.5 1.5 0 0 1 2.561.439l3.728 3.728A6.01 6.01 0 0 1 12 0c3.309 0 6 2.691 6 6a6.01 6.01 0 0 1-4.168 5.711l9.728 9.728a1.5 1.5 0 0 1 0 2.121M9.084 6.963l1.954 1.954c.119-.005.759.083.962.083 1.654 0 3-1.346 3-3s-1.346-3-3-3-3 1.346-3 3c0 .204.089.844.084.963"
        })
    });
}



function $d9bec15b4fc7f198$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("svg", {
        id: "7d54fe__Layer_1",
        width: 512,
        height: 512,
        "data-name": "Layer 1",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
            fill: "currentColor",
            d: "M7.5 13A4.5 4.5 0 1 1 12 8.5 4.505 4.505 0 0 1 7.5 13m0-6A1.5 1.5 0 1 0 9 8.5 1.5 1.5 0 0 0 7.5 7M15 22.5a7.5 7.5 0 0 0-15 0 1.5 1.5 0 0 0 3 0 4.5 4.5 0 0 1 9 0 1.5 1.5 0 0 0 3 0m9-4.5a7 7 0 0 0-11.455-5.4 1.5 1.5 0 1 0 1.91 2.314A3.95 3.95 0 0 1 17 14a4 4 0 0 1 4 4 1.5 1.5 0 0 0 3 0m-6.5-9A4.5 4.5 0 1 1 22 4.5 4.505 4.505 0 0 1 17.5 9m0-6A1.5 1.5 0 1 0 19 4.5 1.5 1.5 0 0 0 17.5 3"
        })
    });
}



function $79042f219bb5ff87$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("svg", {
        xmlSpace: "preserve",
        id: "4cc68c__Bold",
        width: 512,
        height: 512,
        x: 0,
        y: 0,
        style: {},
        viewBox: "0 0 512 512",
        ...props,
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
                fill: "currentColor",
                d: "M288 192h-32v-32c0-17.673-14.327-32-32-32s-32 14.327-32 32v32h-32c-17.673 0-32 14.327-32 32s14.327 32 32 32h32v32c0 17.673 14.327 32 32 32s32-14.327 32-32v-32h32c17.673 0 32-14.327 32-32s-14.327-32-32-32"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
                fill: "currentColor",
                d: "m502.661 457.569-99.046-99.067c74.18-99.06 54.01-239.499-45.05-313.678S119.067-9.187 44.887 89.873s-54.01 239.499 45.05 313.678c79.587 59.597 188.929 59.623 268.544.063l99.088 99.088c12.452 12.452 32.64 12.452 45.092 0s12.452-32.64 0-45.092ZM225.116 384.49c-88.02 0-159.374-71.354-159.374-159.374S137.097 65.742 225.116 65.742 384.49 137.096 384.49 225.116c-.093 87.981-71.392 159.281-159.374 159.374"
            })
        ]
    });
}



function $6ba6b9d2de9f5d6a$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("svg", {
        xmlSpace: "preserve",
        id: "6f5828__Bold",
        width: 512,
        height: 512,
        x: 0,
        y: 0,
        style: {},
        viewBox: "0 0 512 512",
        ...props,
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
                fill: "currentColor",
                d: "M288 192H160c-17.673 0-32 14.327-32 32s14.327 32 32 32h128c17.673 0 32-14.327 32-32s-14.327-32-32-32"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("path", {
                fill: "currentColor",
                d: "m502.661 457.569-99.046-99.067c74.18-99.06 54.01-239.499-45.05-313.678S119.067-9.187 44.887 89.873s-54.01 239.499 45.05 313.678c79.587 59.597 188.929 59.623 268.544.063l99.088 99.088c12.452 12.452 32.64 12.452 45.092 0s12.452-32.64 0-45.092ZM225.116 384.49c-88.02 0-159.374-71.354-159.374-159.374S137.097 65.742 225.116 65.742 384.49 137.096 384.49 225.116c-.093 87.981-71.392 159.281-159.374 159.374"
            })
        ]
    });
}



var $86bb1858f7ecc8d9$export$1ca1ec8b29a4ce27;
$86bb1858f7ecc8d9$export$1ca1ec8b29a4ce27 = `_8Wb43a_icon`;


function $8603b77743deb39a$var$createIconComponent(SvgComponent, style) {
    return function({ size: size = "1em", className: className }) {
        return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("span", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))($86bb1858f7ecc8d9$export$1ca1ec8b29a4ce27, className),
            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)(SvgComponent, {
                style: {
                    height: size,
                    width: size,
                    ...style
                }
            })
        });
    };
}
const $8603b77743deb39a$export$b51dd496211ae105 = $8603b77743deb39a$var$createIconComponent((0, $0cd2b3d9c6aaab2a$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$e04bcc6127e699bf = $8603b77743deb39a$var$createIconComponent((0, $1f1a0e11253bbce0$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$16ae26c700600e84 = $8603b77743deb39a$var$createIconComponent((0, $9f37caef697816c7$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$49a5d8503f8a110a = $8603b77743deb39a$var$createIconComponent((0, $bf908d9eeb594ba1$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$cbe811cb8e919f27 = $8603b77743deb39a$var$createIconComponent((0, $905a0bdd72d3d355$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$66493327321323ad = $8603b77743deb39a$var$createIconComponent((0, $1f1a0e11253bbce0$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$56037a7cca3845e9 = $8603b77743deb39a$var$createIconComponent((0, $eb249b12eb41ffc5$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$73b2275057918051 = $8603b77743deb39a$var$createIconComponent((0, $a996abd98d73ffbe$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$81608868aefa31ce = $8603b77743deb39a$var$createIconComponent((0, $c29e2b1e74aaf7ce$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$2be804e19c04baed = $8603b77743deb39a$var$createIconComponent((0, $bd7e2dbc65d25ee1$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$4019ac48f69e96df = $8603b77743deb39a$var$createIconComponent((0, $d603cf6bb31cd289$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$625671e92c10ce58 = $8603b77743deb39a$var$createIconComponent((0, $ce12cbf77937a349$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$e817ff83c15c44f9 = $8603b77743deb39a$var$createIconComponent((0, $e1ff0c44ecae4c04$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$6c15dfad3d23e29b = $8603b77743deb39a$var$createIconComponent((0, $cc335155ea44841a$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$d7cfde09abbb52ee = $8603b77743deb39a$var$createIconComponent((0, $d003f8b768c015ff$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$bea8ebba691c5813 = ({ toggled: toggled = false, ...props })=>$8603b77743deb39a$var$createIconComponent(toggled ? (0, $b588943cd3450995$export$2e2bcd8739ae039) : (0, $7e4c1a315f05f205$export$2e2bcd8739ae039))({
        ...props
    });
const $8603b77743deb39a$export$955b76260b5140c = $8603b77743deb39a$var$createIconComponent((0, $943efc54a78acb0c$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$ce5c58c6a297ddaf = $8603b77743deb39a$var$createIconComponent((0, $9b3c2689c91f9f58$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$4d4e10ce882b8153 = $8603b77743deb39a$var$createIconComponent((0, $6bfc853f5330ffbe$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$d776d19dfae66ece = $8603b77743deb39a$var$createIconComponent((0, $f31cb1a228122acb$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$8bb46d5eef767d7 = $8603b77743deb39a$var$createIconComponent((0, $d003f8b768c015ff$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$ba2fbb9644c8bf32 = $8603b77743deb39a$var$createIconComponent((0, $e8d5b70a755cc6a3$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$adb7c12af9c0e6e8 = $8603b77743deb39a$var$createIconComponent((0, $eac63c8e069d6295$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$84ac927778fdc063 = $8603b77743deb39a$var$createIconComponent((0, $e29c9cfcd339e6bd$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$340bfce9b4df026b = $8603b77743deb39a$var$createIconComponent((0, $27688a12e8f8fbd7$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$196109e945d3b66f = $8603b77743deb39a$var$createIconComponent((0, $86551a210c653693$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$f736853d852cc436 = $8603b77743deb39a$var$createIconComponent((0, $e29ee8011de35584$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$3caee6c66795d211 = $8603b77743deb39a$var$createIconComponent((0, $f742741bb1db7e48$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$f9db439cdc8db790 = $8603b77743deb39a$var$createIconComponent((0, $f742741bb1db7e48$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$926c029a160f0d15 = $8603b77743deb39a$var$createIconComponent((0, $34a1d1791d81395f$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$7876caa18827ace7 = $8603b77743deb39a$var$createIconComponent((0, $eea666b1b3edf009$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$c9bef5de7ad5da31 = $8603b77743deb39a$var$createIconComponent((0, $bafcb27b68637007$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$4a5ccdc9878f4668 = $8603b77743deb39a$var$createIconComponent((0, $27ba250e14ae930a$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$b0c934bdae14c9ef = $8603b77743deb39a$var$createIconComponent((0, $61f8937bd63b6364$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$c304c9f6181ead35 = $8603b77743deb39a$var$createIconComponent((0, $d201a0435ab3abe2$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$931ba9c16d55112 = $8603b77743deb39a$var$createIconComponent((0, $01c61f9c65c83096$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$ef875af7def69d98 = $8603b77743deb39a$var$createIconComponent((0, $4ee37104d76d8d68$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$249df474ea45aebc = $8603b77743deb39a$var$createIconComponent((0, $3861600376af66f7$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$e4cfe2ae2a038e0f = $8603b77743deb39a$var$createIconComponent((0, $032cd54fed8c7572$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$f3d1eed2a70340c3 = $8603b77743deb39a$var$createIconComponent((0, $88080ba167357c0a$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$8fb9a74ca2700ad5 = $8603b77743deb39a$var$createIconComponent((0, $c594f6ccebb4edce$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$279925e52ecb7067 = $8603b77743deb39a$var$createIconComponent((0, $79042f219bb5ff87$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$8a3fa2b294d0816a = $8603b77743deb39a$var$createIconComponent((0, $6ba6b9d2de9f5d6a$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$34759e72450b621e = $8603b77743deb39a$var$createIconComponent((0, $d8bce3f262abae7f$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$e7e4d28a1367130c = $8603b77743deb39a$var$createIconComponent((0, $5376f494e5ab2706$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$50a7b2527c056255 = $8603b77743deb39a$var$createIconComponent((0, $51dd8a53ecd48274$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$16fcff7afd79949 = $8603b77743deb39a$var$createIconComponent((0, $d9bec15b4fc7f198$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$5d9c28f3fa3ba1a = $8603b77743deb39a$var$createIconComponent((0, $20b7baff1b1e93b8$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$f3f0c8a5b29f8e52 = $8603b77743deb39a$var$createIconComponent((0, $cec9bbc39c654998$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$3581a0f12e3918d1 = $8603b77743deb39a$var$createIconComponent((0, $e01b1ff32d2680dc$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$77223e42038127b5 = $8603b77743deb39a$var$createIconComponent((0, $256a08773634a940$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$db5ab3e755729b3d = $8603b77743deb39a$var$createIconComponent((0, $c26857e96933a949$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$fc789d8a435194dc = $8603b77743deb39a$var$createIconComponent((0, $1dba4951148bced8$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$365092c6388045c9 = $8603b77743deb39a$var$createIconComponent((0, $bf171d36cdc5355b$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$fa5eb5b4918005e3 = $8603b77743deb39a$var$createIconComponent((0, $eceeac58f56a0e4c$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$9c955948016ac53c = $8603b77743deb39a$var$createIconComponent((0, $da50346a8839259a$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$61207fb985d79449 = $8603b77743deb39a$var$createIconComponent((0, $e326dab9667246e9$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$57cd704edc5f43cd = $8603b77743deb39a$var$createIconComponent((0, $53b734e01cf61152$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$17f4bb5f559b3806 = $8603b77743deb39a$var$createIconComponent((0, $edbb0873c41baafd$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$37a0f4bc54062d1c = $8603b77743deb39a$var$createIconComponent((0, $c95a6a5e297cadad$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$9963061ea3f5d8da = $8603b77743deb39a$var$createIconComponent((0, $ad5b221a073b2c1b$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$527d32aa1785fdd4 = $8603b77743deb39a$var$createIconComponent((0, $1605980a69d2a507$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$62b5e6d9957cff7b = $8603b77743deb39a$var$createIconComponent((0, $c829c145a5d9dcf0$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$5ee68ae963bf2bda = $8603b77743deb39a$var$createIconComponent((0, $63b917b4b41e9254$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$94727896c77b7d99 = $8603b77743deb39a$var$createIconComponent((0, $7f59d78985c13830$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$72e0de8e793fca75 = $8603b77743deb39a$var$createIconComponent((0, $8c8be0a53f920dd9$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$8a9b10ae77f54b81 = $8603b77743deb39a$var$createIconComponent((0, $a180105d81a81477$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$c3f8793f0bc04c26 = $8603b77743deb39a$var$createIconComponent((0, $28aca348168235e4$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$c1a4ecc4992509c4 = $8603b77743deb39a$var$createIconComponent((0, $991c38f722f5cb61$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$bfc5043f33fb4eee = $8603b77743deb39a$var$createIconComponent((0, $3d8a9c46e8c2ffed$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$40e1334ac13dc359 = $8603b77743deb39a$var$createIconComponent((0, $be257bd0b13779d6$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$9bc70769102dd23 = $8603b77743deb39a$var$createIconComponent((0, $863559d598e1efcc$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$3c0742b661df1fc4 = $8603b77743deb39a$var$createIconComponent((0, $5a566642996ec9f8$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$7b7ad8f03d93a9da = $8603b77743deb39a$var$createIconComponent((0, $c42fbb73d2b37302$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$f80e384965135114 = $8603b77743deb39a$var$createIconComponent((0, $9c1281d993528c08$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$4176b1d4e95be624 = $8603b77743deb39a$var$createIconComponent((0, $f31cb1a228122acb$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$3213a407ffb0559 = $8603b77743deb39a$var$createIconComponent((0, $a948f0ace9e6d864$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$41884575254a94be = $8603b77743deb39a$var$createIconComponent((0, $4c98f21230ccaa30$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$26cd8460138f9c88 = $8603b77743deb39a$var$createIconComponent((0, $27688a12e8f8fbd7$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$2f6d05691f8bfa80 = $8603b77743deb39a$var$createIconComponent((0, $5404fe47966938c8$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$91aad23dbc00e487 = $8603b77743deb39a$var$createIconComponent((0, $d5569e69382c7ac8$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$d112062dd42154c4 = $8603b77743deb39a$var$createIconComponent((0, $0c26c7c3f9abc26c$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$26f6a63b41d0ff2a = $8603b77743deb39a$var$createIconComponent((0, $4c160483fd4c524a$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$f78aa240ba8eef75 = $8603b77743deb39a$var$createIconComponent((0, $7fbbd37bddf2b2d4$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$257bd3ea676c4e1e = $8603b77743deb39a$var$createIconComponent((0, $efc5d7e69e041882$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$779959098413998d = $8603b77743deb39a$var$createIconComponent((0, $f2af2d2cef1e2ed8$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$3577c0003511ce2d = $8603b77743deb39a$var$createIconComponent((0, $6b8de4afd055d9b9$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$6ba70f07963961ce = $8603b77743deb39a$var$createIconComponent((0, $184976094180ac3d$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$6abbf1cbc7a5c0f9 = $8603b77743deb39a$var$createIconComponent((0, $7c0d122c1d0221cd$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$20b7f16ef18cfa38 = $8603b77743deb39a$var$createIconComponent((0, $2d0d32b58b4eb5c9$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$e9e91475793130c8 = $8603b77743deb39a$var$createIconComponent((0, $ff351197b573b056$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$5be70e40251e6f9b = $8603b77743deb39a$var$createIconComponent((0, $cc335155ea44841a$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$e52728f4e2dd782d = $8603b77743deb39a$var$createIconComponent((0, $b59d10c8d021db57$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$d74eed6863461f9 = $8603b77743deb39a$var$createIconComponent((0, $a03f5741f2ada281$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$1875cfea283c88df = $8603b77743deb39a$var$createIconComponent((0, $72bd140b5b65084d$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$bcb90d01a22e14f9 = $8603b77743deb39a$var$createIconComponent((0, $7534e45f1184cb0b$export$2e2bcd8739ae039));
const $8603b77743deb39a$export$a53026e91890dfa1 = $8603b77743deb39a$var$createIconComponent((0, $b5d2ac725b6110c7$export$2e2bcd8739ae039));





const $d4b7ea36fcb7fe56$var$LinkButton = ({ pathname: pathname, state: state = {}, children: children, variant: variant = "primary", classname: classname, onClick: onClick, disabled: disabled = false, search: search })=>{
    const { pathname: currentPathname, search: currentSearch, state: currentState } = (0, $7a844823b04d4282$export$45d76561a5302f2b)();
    const statePrevious = currentState?.from ?? [];
    // Si on a des search param pour la page destination, on les charge
    const newSearch = search ?? localStorage.getItem(pathname);
    // Puis on sauvegarde les nouveaux search de la page courrante
    localStorage.setItem(currentPathname, currentSearch);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $0608a055a17e1a05$export$b0d92dbee9b5b60d), {
        to: {
            pathname: pathname,
            search: newSearch ?? ""
        },
        state: {
            ...currentState,
            ...state,
            from: [
                ...statePrevious,
                `${currentPathname}${currentSearch}`
            ]
        },
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(`text-decoration-none btn btn-${variant} ${classname} text-nowrap`, //class général
        disabled ? "disabled pointer-events-none" : "" // class quand disable
        ),
        onClick: onClick,
        children: children
    });
};
var $d4b7ea36fcb7fe56$export$2e2bcd8739ae039 = $d4b7ea36fcb7fe56$var$LinkButton;


/**
 * CreateButton ne doit être utilisé que dans le cadre d'une redirection vers une page de création
 * Il permet de gérer le bouton retour
 */ const $8ad69b89456b65bc$var$CreateButton = ({ title: title, href: href, onClick: onClick, disabled: disabled = false, state: state, classnames: classnames })=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $d4b7ea36fcb7fe56$export$2e2bcd8739ae039), {
        pathname: href,
        variant: "primary",
        onClick: onClick,
        disabled: disabled,
        classname: classnames,
        state: state,
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$d776d19dfae66ece), {}),
            " ",
            title
        ]
    });
};
var $8ad69b89456b65bc$export$2e2bcd8739ae039 = $8ad69b89456b65bc$var$CreateButton;









var $kc00y = parcelRequire("kc00y");

var $lCkAA = parcelRequire("lCkAA");


"use client";
const $ad18c81fdcf37de8$export$513805011eaa4892 = {
    /**
   * @default 'img'
   */ bsPrefix: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).string,
    /**
   * Sets image as fluid image.
   */ fluid: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).bool,
    /**
   * Sets image shape as rounded.
   */ rounded: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).bool,
    /**
   * Sets image shape as circle.
   */ roundedCircle: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).bool,
    /**
   * Sets image shape as thumbnail.
   */ thumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).bool
};
const $ad18c81fdcf37de8$var$Image = /*#__PURE__*/ $kc00y.forwardRef(({ bsPrefix: bsPrefix, className: className, fluid: fluid = false, rounded: rounded = false, roundedCircle: roundedCircle = false, thumbnail: thumbnail = false, ...props }, ref)=>{
    bsPrefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(bsPrefix, 'img');
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("img", {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, fluid && `${bsPrefix}-fluid`, rounded && `rounded`, roundedCircle && `rounded-circle`, thumbnail && `${bsPrefix}-thumbnail`)
    });
});
$ad18c81fdcf37de8$var$Image.displayName = 'Image';
var $ad18c81fdcf37de8$export$2e2bcd8739ae039 = $ad18c81fdcf37de8$var$Image;



var $kc00y = parcelRequire("kc00y");


"use client";
const $13de46b4dfcc473f$var$Table = /*#__PURE__*/ $kc00y.forwardRef(({ bsPrefix: bsPrefix, className: className, striped: striped, bordered: bordered, borderless: borderless, hover: hover, size: size, variant: variant, responsive: responsive, ...props }, ref)=>{
    const decoratedBsPrefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(bsPrefix, 'table');
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, decoratedBsPrefix, variant && `${decoratedBsPrefix}-${variant}`, size && `${decoratedBsPrefix}-${size}`, striped && `${decoratedBsPrefix}-${typeof striped === 'string' ? `striped-${striped}` : 'striped'}`, bordered && `${decoratedBsPrefix}-bordered`, borderless && `${decoratedBsPrefix}-borderless`, hover && `${decoratedBsPrefix}-hover`);
    const table = /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("table", {
        ...props,
        className: classes,
        ref: ref
    });
    if (responsive) {
        let responsiveClass = `${decoratedBsPrefix}-responsive`;
        if (typeof responsive === 'string') responsiveClass = `${responsiveClass}-${responsive}`;
        return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
            className: responsiveClass,
            children: table
        });
    }
    return table;
});
$13de46b4dfcc473f$var$Table.displayName = 'Table';
var $13de46b4dfcc473f$export$2e2bcd8739ae039 = $13de46b4dfcc473f$var$Table;




const $c87e26f22dbceec5$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
const $c87e26f22dbceec5$export$2c14ff85d6318973 = (token, count, options)=>{
    let result;
    const tokenValue = $c87e26f22dbceec5$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};


function $97c55e21245bf6af$export$38e44e97ce4dbb7d(args) {
    return (options = {})=>{
        // TODO: Remove String()
        const width = options.width ? String(options.width) : args.defaultWidth;
        const format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}


const $2a73b4587096bd96$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
const $2a73b4587096bd96$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $2a73b4587096bd96$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $2a73b4587096bd96$export$cbf60ecb96cbb82f = {
    date: (0, $97c55e21245bf6af$export$38e44e97ce4dbb7d)({
        formats: $2a73b4587096bd96$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $97c55e21245bf6af$export$38e44e97ce4dbb7d)({
        formats: $2a73b4587096bd96$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $97c55e21245bf6af$export$38e44e97ce4dbb7d)({
        formats: $2a73b4587096bd96$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


const $69d1c03a8f0bcb15$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
const $69d1c03a8f0bcb15$export$8fbbfd65594f46a0 = (token, _date, _baseDate, _options)=>$69d1c03a8f0bcb15$var$formatRelativeLocale[token];


/**
 * The localize function argument callback which allows to convert raw value to
 * the actual type.
 *
 * @param value - The value to convert
 *
 * @returns The converted value
 */ /**
 * The map of localized values for each width.
 */ /**
 * The index type of the locale unit value. It types conversion of units of
 * values that don't start at 0 (i.e. quarters).
 */ /**
 * Converts the unit value to the tuple of values.
 */ /**
 * The tuple of localized era values. The first element represents BC,
 * the second element represents AD.
 */ /**
 * The tuple of localized quarter values. The first element represents Q1.
 */ /**
 * The tuple of localized day values. The first element represents Sunday.
 */ /**
 * The tuple of localized month values. The first element represents January.
 */ function $90d2699d90bb2336$export$63596d6ee8878b25(args) {
    return (value, options)=>{
        const context = options?.context ? String(options.context) : "standalone";
        let valuesArray;
        if (context === "formatting" && args.formattingValues) {
            const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            const width = options?.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            const defaultWidth = args.defaultWidth;
            const width = options?.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[width] || args.values[defaultWidth];
        }
        const index = args.argumentCallback ? args.argumentCallback(value) : value;
        // @ts-expect-error - For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}


const $e80cddcf5ec54ef9$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
const $e80cddcf5ec54ef9$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $e80cddcf5ec54ef9$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
const $e80cddcf5ec54ef9$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
const $e80cddcf5ec54ef9$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
const $e80cddcf5ec54ef9$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
const $e80cddcf5ec54ef9$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    const rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
const $e80cddcf5ec54ef9$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $e80cddcf5ec54ef9$var$ordinalNumber,
    era: (0, $90d2699d90bb2336$export$63596d6ee8878b25)({
        values: $e80cddcf5ec54ef9$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $90d2699d90bb2336$export$63596d6ee8878b25)({
        values: $e80cddcf5ec54ef9$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $90d2699d90bb2336$export$63596d6ee8878b25)({
        values: $e80cddcf5ec54ef9$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $90d2699d90bb2336$export$63596d6ee8878b25)({
        values: $e80cddcf5ec54ef9$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $90d2699d90bb2336$export$63596d6ee8878b25)({
        values: $e80cddcf5ec54ef9$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $e80cddcf5ec54ef9$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


function $2adbe1e330f72e54$export$1430a0f35710914d(args) {
    return (string, options = {})=>{
        const width = options.width;
        const matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        const matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        const key = Array.isArray(parsePatterns) ? $2adbe1e330f72e54$var$findIndex(parsePatterns, (pattern)=>pattern.test(matchedString)) : $2adbe1e330f72e54$var$findKey(parsePatterns, (pattern)=>pattern.test(matchedString));
        let value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $2adbe1e330f72e54$var$findKey(object, predicate) {
    for(const key in object){
        if (Object.prototype.hasOwnProperty.call(object, key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $2adbe1e330f72e54$var$findIndex(array, predicate) {
    for(let key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}


function $ec319733e12d7439$export$fdaf2fd6d7edde95(args) {
    return (string, options = {})=>{
        const matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        let value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        // [TODO] I challenge you to fix the type
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}


const $001de63c280f5a47$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const $001de63c280f5a47$var$parseOrdinalNumberPattern = /\d+/i;
const $001de63c280f5a47$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
const $001de63c280f5a47$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
const $001de63c280f5a47$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
const $001de63c280f5a47$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $001de63c280f5a47$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
const $001de63c280f5a47$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $001de63c280f5a47$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
const $001de63c280f5a47$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
const $001de63c280f5a47$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
const $001de63c280f5a47$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
const $001de63c280f5a47$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $ec319733e12d7439$export$fdaf2fd6d7edde95)({
        matchPattern: $001de63c280f5a47$var$matchOrdinalNumberPattern,
        parsePattern: $001de63c280f5a47$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $2adbe1e330f72e54$export$1430a0f35710914d)({
        matchPatterns: $001de63c280f5a47$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $001de63c280f5a47$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $2adbe1e330f72e54$export$1430a0f35710914d)({
        matchPatterns: $001de63c280f5a47$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $001de63c280f5a47$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $2adbe1e330f72e54$export$1430a0f35710914d)({
        matchPatterns: $001de63c280f5a47$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $001de63c280f5a47$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $2adbe1e330f72e54$export$1430a0f35710914d)({
        matchPatterns: $001de63c280f5a47$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $001de63c280f5a47$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $2adbe1e330f72e54$export$1430a0f35710914d)({
        matchPatterns: $001de63c280f5a47$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $001de63c280f5a47$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


const $5a150a3bcfb37384$export$137380d9ce54f7f = {
    code: "en-US",
    formatDistance: (0, $c87e26f22dbceec5$export$2c14ff85d6318973),
    formatLong: (0, $2a73b4587096bd96$export$cbf60ecb96cbb82f),
    formatRelative: (0, $69d1c03a8f0bcb15$export$8fbbfd65594f46a0),
    localize: (0, $e80cddcf5ec54ef9$export$b3bd0bc58e36cd63),
    match: (0, $001de63c280f5a47$export$4659b591c19bdf3d),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var // Fallback for modularized imports:
$5a150a3bcfb37384$export$2e2bcd8739ae039 = $5a150a3bcfb37384$export$137380d9ce54f7f;


let $1f6f737b74a6aaae$var$defaultOptions = {};
function $1f6f737b74a6aaae$export$430a3269e24b912e() {
    return $1f6f737b74a6aaae$var$defaultOptions;
}
function $1f6f737b74a6aaae$export$95365be1b0704abc(newOptions) {
    $1f6f737b74a6aaae$var$defaultOptions = newOptions;
}


/**
 * @module constants
 * @summary Useful constants
 * @description
 * Collection of useful date constants.
 *
 * The constants could be imported from `date-fns/constants`:
 *
 * ```ts
 * import { maxTime, minTime } from "./constants/date-fns/constants";
 *
 * function isAllowedTime(time) {
 *   return time <= maxTime && time >= minTime;
 * }
 * ```
 */ /**
 * @constant
 * @name daysInWeek
 * @summary Days in 1 week.
 */ const $36f05d0f10127335$export$dfd9b671c89acc8e = 7;
const $36f05d0f10127335$export$3913210603d8e9ae = 365.2425;
const $36f05d0f10127335$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
const $36f05d0f10127335$export$4dec998e48f9c246 = -$36f05d0f10127335$export$81caae6e1cc7a622;
const $36f05d0f10127335$export$4fad13613e88edc8 = 604800000;
const $36f05d0f10127335$export$b76b1809a2898f9a = 86400000;
const $36f05d0f10127335$export$91246f0b9bd9beff = 60000;
const $36f05d0f10127335$export$7f72910d6dfd237a = 3600000;
const $36f05d0f10127335$export$397c2d5776aa9055 = 1000;
const $36f05d0f10127335$export$3633035e63cee86a = 525600;
const $36f05d0f10127335$export$ab7da2ccd1075c38 = 43200;
const $36f05d0f10127335$export$2423174df8cd3cd2 = 1440;
const $36f05d0f10127335$export$f2f5ae5a8e2d8f9f = 60;
const $36f05d0f10127335$export$3c58128db900d44e = 3;
const $36f05d0f10127335$export$80d7e435f744f319 = 12;
const $36f05d0f10127335$export$4db7641526e3241f = 4;
const $36f05d0f10127335$export$698aec755e92c695 = 3600;
const $36f05d0f10127335$export$a77c1a7ebebe2a5a = 60;
const $36f05d0f10127335$export$815a9362476d2fe3 = $36f05d0f10127335$export$698aec755e92c695 * 24;
const $36f05d0f10127335$export$34804a017b31e2fe = $36f05d0f10127335$export$815a9362476d2fe3 * 7;
const $36f05d0f10127335$export$7271e9e3478110d1 = $36f05d0f10127335$export$815a9362476d2fe3 * $36f05d0f10127335$export$3913210603d8e9ae;
const $36f05d0f10127335$export$8e6600bbdee7dabb = $36f05d0f10127335$export$7271e9e3478110d1 / 12;
const $36f05d0f10127335$export$be1dccf2de902d31 = $36f05d0f10127335$export$8e6600bbdee7dabb * 3;
const $36f05d0f10127335$export$2a7b97929c48d47d = Symbol.for("constructDateFrom");


function $074d8b7777dc6b36$export$ead8a1812b171991(date, value) {
    if (typeof date === "function") return date(value);
    if (date && typeof date === "object" && (0, $36f05d0f10127335$export$2a7b97929c48d47d) in date) return date[0, $36f05d0f10127335$export$2a7b97929c48d47d](value);
    if (date instanceof Date) return new date.constructor(value);
    return new Date(value);
}
var // Fallback for modularized imports:
$074d8b7777dc6b36$export$2e2bcd8739ae039 = $074d8b7777dc6b36$export$ead8a1812b171991;


function $189325ccd94be08c$export$e67a095c620b86fe(argument, context) {
    // [TODO] Get rid of `toDate` or `constructFrom`?
    return (0, $074d8b7777dc6b36$export$ead8a1812b171991)(context || argument, argument);
}
var // Fallback for modularized imports:
$189325ccd94be08c$export$2e2bcd8739ae039 = $189325ccd94be08c$export$e67a095c620b86fe;


function $48b514f78dfee153$export$113002b5eff6e430(date) {
    const _date = (0, $189325ccd94be08c$export$e67a095c620b86fe)(date);
    const utcDate = new Date(Date.UTC(_date.getFullYear(), _date.getMonth(), _date.getDate(), _date.getHours(), _date.getMinutes(), _date.getSeconds(), _date.getMilliseconds()));
    utcDate.setUTCFullYear(_date.getFullYear());
    return +date - +utcDate;
}



function $cecf8623b6e5b22e$export$9f53b88e82f64d8d(context, ...dates) {
    const normalize = (0, $074d8b7777dc6b36$export$ead8a1812b171991).bind(null, context || dates.find((date)=>typeof date === "object"));
    return dates.map(normalize);
}




function $fe415ce3b30833bb$export$63fa379ae8a9ba2(date, options) {
    const _date = (0, $189325ccd94be08c$export$e67a095c620b86fe)(date, options?.in);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$fe415ce3b30833bb$export$2e2bcd8739ae039 = $fe415ce3b30833bb$export$63fa379ae8a9ba2;


function $ccb95d21e55ad71e$export$4a02e9c37dab4871(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $cecf8623b6e5b22e$export$9f53b88e82f64d8d)(options?.in, laterDate, earlierDate);
    const laterStartOfDay = (0, $fe415ce3b30833bb$export$63fa379ae8a9ba2)(laterDate_);
    const earlierStartOfDay = (0, $fe415ce3b30833bb$export$63fa379ae8a9ba2)(earlierDate_);
    const laterTimestamp = +laterStartOfDay - (0, $48b514f78dfee153$export$113002b5eff6e430)(laterStartOfDay);
    const earlierTimestamp = +earlierStartOfDay - (0, $48b514f78dfee153$export$113002b5eff6e430)(earlierStartOfDay);
    // Round the number of days to the nearest integer because the number of
    // milliseconds in a day is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((laterTimestamp - earlierTimestamp) / (0, $36f05d0f10127335$export$b76b1809a2898f9a));
}
var // Fallback for modularized imports:
$ccb95d21e55ad71e$export$2e2bcd8739ae039 = $ccb95d21e55ad71e$export$4a02e9c37dab4871;



function $d3f63cae10dd2b8a$export$f91e89d3d0406102(date, options) {
    const date_ = (0, $189325ccd94be08c$export$e67a095c620b86fe)(date, options?.in);
    date_.setFullYear(date_.getFullYear(), 0, 1);
    date_.setHours(0, 0, 0, 0);
    return date_;
}
var // Fallback for modularized imports:
$d3f63cae10dd2b8a$export$2e2bcd8739ae039 = $d3f63cae10dd2b8a$export$f91e89d3d0406102;



function $bedc90cefbca22ba$export$d3b42cd8452deec(date, options) {
    const _date = (0, $189325ccd94be08c$export$e67a095c620b86fe)(date, options?.in);
    const diff = (0, $ccb95d21e55ad71e$export$4a02e9c37dab4871)(_date, (0, $d3f63cae10dd2b8a$export$f91e89d3d0406102)(_date));
    const dayOfYear = diff + 1;
    return dayOfYear;
}
var // Fallback for modularized imports:
$bedc90cefbca22ba$export$2e2bcd8739ae039 = $bedc90cefbca22ba$export$d3b42cd8452deec;





function $7ec38c5e4ca45b81$export$42c81a444fbfb5d4(date, options) {
    const defaultOptions = (0, $1f6f737b74a6aaae$export$430a3269e24b912e)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $189325ccd94be08c$export$e67a095c620b86fe)(date, options?.in);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    _date.setDate(_date.getDate() - diff);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$7ec38c5e4ca45b81$export$2e2bcd8739ae039 = $7ec38c5e4ca45b81$export$42c81a444fbfb5d4;


function $52fad94cb6aed986$export$6173213f95a4431e(date, options) {
    return (0, $7ec38c5e4ca45b81$export$42c81a444fbfb5d4)(date, {
        ...options,
        weekStartsOn: 1
    });
}
var // Fallback for modularized imports:
$52fad94cb6aed986$export$2e2bcd8739ae039 = $52fad94cb6aed986$export$6173213f95a4431e;






function $f74efcf6cf1c76a4$export$3dbc52535f6f8fcc(date, options) {
    const _date = (0, $189325ccd94be08c$export$e67a095c620b86fe)(date, options?.in);
    const year = _date.getFullYear();
    const fourthOfJanuaryOfNextYear = (0, $074d8b7777dc6b36$export$ead8a1812b171991)(_date, 0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $52fad94cb6aed986$export$6173213f95a4431e)(fourthOfJanuaryOfNextYear);
    const fourthOfJanuaryOfThisYear = (0, $074d8b7777dc6b36$export$ead8a1812b171991)(_date, 0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $52fad94cb6aed986$export$6173213f95a4431e)(fourthOfJanuaryOfThisYear);
    if (_date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (_date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
var // Fallback for modularized imports:
$f74efcf6cf1c76a4$export$2e2bcd8739ae039 = $f74efcf6cf1c76a4$export$3dbc52535f6f8fcc;



function $cc43d7264d8a3ccc$export$236bdfa374eb69a9(date, options) {
    const year = (0, $f74efcf6cf1c76a4$export$3dbc52535f6f8fcc)(date, options);
    const fourthOfJanuary = (0, $074d8b7777dc6b36$export$ead8a1812b171991)(options?.in || date, 0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    return (0, $52fad94cb6aed986$export$6173213f95a4431e)(fourthOfJanuary);
}
var // Fallback for modularized imports:
$cc43d7264d8a3ccc$export$2e2bcd8739ae039 = $cc43d7264d8a3ccc$export$236bdfa374eb69a9;



function $52193498aabd8019$export$7cabdc5698b63e2f(date, options) {
    const _date = (0, $189325ccd94be08c$export$e67a095c620b86fe)(date, options?.in);
    const diff = +(0, $52fad94cb6aed986$export$6173213f95a4431e)(_date) - +(0, $cc43d7264d8a3ccc$export$236bdfa374eb69a9)(_date);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / (0, $36f05d0f10127335$export$4fad13613e88edc8)) + 1;
}
var // Fallback for modularized imports:
$52193498aabd8019$export$2e2bcd8739ae039 = $52193498aabd8019$export$7cabdc5698b63e2f;











function $3a863317cd2bc168$export$12d572480ceb6e58(date, options) {
    const _date = (0, $189325ccd94be08c$export$e67a095c620b86fe)(date, options?.in);
    const year = _date.getFullYear();
    const defaultOptions = (0, $1f6f737b74a6aaae$export$430a3269e24b912e)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const firstWeekOfNextYear = (0, $074d8b7777dc6b36$export$ead8a1812b171991)(options?.in || date, 0);
    firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $7ec38c5e4ca45b81$export$42c81a444fbfb5d4)(firstWeekOfNextYear, options);
    const firstWeekOfThisYear = (0, $074d8b7777dc6b36$export$ead8a1812b171991)(options?.in || date, 0);
    firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $7ec38c5e4ca45b81$export$42c81a444fbfb5d4)(firstWeekOfThisYear, options);
    if (+_date >= +startOfNextYear) return year + 1;
    else if (+_date >= +startOfThisYear) return year;
    else return year - 1;
}
var // Fallback for modularized imports:
$3a863317cd2bc168$export$2e2bcd8739ae039 = $3a863317cd2bc168$export$12d572480ceb6e58;



function $b274f52451d13ce5$export$bb7b45bb8e74da0f(date, options) {
    const defaultOptions = (0, $1f6f737b74a6aaae$export$430a3269e24b912e)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const year = (0, $3a863317cd2bc168$export$12d572480ceb6e58)(date, options);
    const firstWeek = (0, $074d8b7777dc6b36$export$ead8a1812b171991)(options?.in || date, 0);
    firstWeek.setFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    const _date = (0, $7ec38c5e4ca45b81$export$42c81a444fbfb5d4)(firstWeek, options);
    return _date;
}
var // Fallback for modularized imports:
$b274f52451d13ce5$export$2e2bcd8739ae039 = $b274f52451d13ce5$export$bb7b45bb8e74da0f;



function $baea89970e06eb9a$export$efe19b760242b2fc(date, options) {
    const _date = (0, $189325ccd94be08c$export$e67a095c620b86fe)(date, options?.in);
    const diff = +(0, $7ec38c5e4ca45b81$export$42c81a444fbfb5d4)(_date, options) - +(0, $b274f52451d13ce5$export$bb7b45bb8e74da0f)(_date, options);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / (0, $36f05d0f10127335$export$4fad13613e88edc8)) + 1;
}
var // Fallback for modularized imports:
$baea89970e06eb9a$export$2e2bcd8739ae039 = $baea89970e06eb9a$export$efe19b760242b2fc;



function $95876af0000dbf17$export$c8306e720e213c0f(number, targetLength) {
    const sign = number < 0 ? "-" : "";
    const output = Math.abs(number).toString().padStart(targetLength, "0");
    return sign + output;
}



const $f7de5855c1609b7d$export$b0d4b338e1516f13 = {
    // Year
    y (date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        const signedYear = date.getFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $95876af0000dbf17$export$c8306e720e213c0f)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M (date, token) {
        const month = date.getMonth();
        return token === "M" ? String(month + 1) : (0, $95876af0000dbf17$export$c8306e720e213c0f)(month + 1, 2);
    },
    // Day of the month
    d (date, token) {
        return (0, $95876af0000dbf17$export$c8306e720e213c0f)(date.getDate(), token.length);
    },
    // AM or PM
    a (date, token) {
        const dayPeriodEnumValue = date.getHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h (date, token) {
        return (0, $95876af0000dbf17$export$c8306e720e213c0f)(date.getHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H (date, token) {
        return (0, $95876af0000dbf17$export$c8306e720e213c0f)(date.getHours(), token.length);
    },
    // Minute
    m (date, token) {
        return (0, $95876af0000dbf17$export$c8306e720e213c0f)(date.getMinutes(), token.length);
    },
    // Second
    s (date, token) {
        return (0, $95876af0000dbf17$export$c8306e720e213c0f)(date.getSeconds(), token.length);
    },
    // Fraction of second
    S (date, token) {
        const numberOfDigits = token.length;
        const milliseconds = date.getMilliseconds();
        const fractionalSeconds = Math.trunc(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $95876af0000dbf17$export$c8306e720e213c0f)(fractionalSeconds, token.length);
    }
};


const $4b6345f265fce384$var$dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
const $4b6345f265fce384$export$fe98a034cfb96d55 = {
    // Era
    G: function(date, token, localize) {
        const era = date.getFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            const signedYear = date.getFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            const year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return (0, $f7de5855c1609b7d$export$b0d4b338e1516f13).y(date, token);
    },
    // Local week-numbering year
    Y: function(date, token, localize, options) {
        const signedWeekYear = (0, $3a863317cd2bc168$export$12d572480ceb6e58)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            const twoDigitYear = weekYear % 100;
            return (0, $95876af0000dbf17$export$c8306e720e213c0f)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, $95876af0000dbf17$export$c8306e720e213c0f)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function(date, token) {
        const isoWeekYear = (0, $f74efcf6cf1c76a4$export$3dbc52535f6f8fcc)(date);
        // Padding
        return (0, $95876af0000dbf17$export$c8306e720e213c0f)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(date, token) {
        const year = date.getFullYear();
        return (0, $95876af0000dbf17$export$c8306e720e213c0f)(year, token.length);
    },
    // Quarter
    Q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, $95876af0000dbf17$export$c8306e720e213c0f)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, $95876af0000dbf17$export$c8306e720e213c0f)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            case "M":
            case "MM":
                return (0, $f7de5855c1609b7d$export$b0d4b338e1516f13).M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, $95876af0000dbf17$export$c8306e720e213c0f)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function(date, token, localize, options) {
        const week = (0, $baea89970e06eb9a$export$efe19b760242b2fc)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, $95876af0000dbf17$export$c8306e720e213c0f)(week, token.length);
    },
    // ISO week of year
    I: function(date, token, localize) {
        const isoWeek = (0, $52193498aabd8019$export$7cabdc5698b63e2f)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, $95876af0000dbf17$export$c8306e720e213c0f)(isoWeek, token.length);
    },
    // Day of the month
    d: function(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getDate(), {
            unit: "date"
        });
        return (0, $f7de5855c1609b7d$export$b0d4b338e1516f13).d(date, token);
    },
    // Day of year
    D: function(date, token, localize) {
        const dayOfYear = (0, $bedc90cefbca22ba$export$d3b42cd8452deec)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, $95876af0000dbf17$export$c8306e720e213c0f)(dayOfYear, token.length);
    },
    // Day of week
    E: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, $95876af0000dbf17$export$c8306e720e213c0f)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, $95876af0000dbf17$export$c8306e720e213c0f)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        const isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, $95876af0000dbf17$export$c8306e720e213c0f)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function(date, token, localize) {
        const hours = date.getHours();
        const dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $4b6345f265fce384$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $4b6345f265fce384$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $4b6345f265fce384$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $4b6345f265fce384$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $4b6345f265fce384$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $4b6345f265fce384$var$dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function(date, token, localize) {
        if (token === "ho") {
            let hours = date.getHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return (0, $f7de5855c1609b7d$export$b0d4b338e1516f13).h(date, token);
    },
    // Hour [0-23]
    H: function(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getHours(), {
            unit: "hour"
        });
        return (0, $f7de5855c1609b7d$export$b0d4b338e1516f13).H(date, token);
    },
    // Hour [0-11]
    K: function(date, token, localize) {
        const hours = date.getHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $95876af0000dbf17$export$c8306e720e213c0f)(hours, token.length);
    },
    // Hour [1-24]
    k: function(date, token, localize) {
        let hours = date.getHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $95876af0000dbf17$export$c8306e720e213c0f)(hours, token.length);
    },
    // Minute
    m: function(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getMinutes(), {
            unit: "minute"
        });
        return (0, $f7de5855c1609b7d$export$b0d4b338e1516f13).m(date, token);
    },
    // Second
    s: function(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getSeconds(), {
            unit: "second"
        });
        return (0, $f7de5855c1609b7d$export$b0d4b338e1516f13).s(date, token);
    },
    // Fraction of second
    S: function(date, token) {
        return (0, $f7de5855c1609b7d$export$b0d4b338e1516f13).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return $4b6345f265fce384$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                return $4b6345f265fce384$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return $4b6345f265fce384$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return $4b6345f265fce384$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                return $4b6345f265fce384$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return $4b6345f265fce384$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $4b6345f265fce384$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + $4b6345f265fce384$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + $4b6345f265fce384$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + $4b6345f265fce384$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function(date, token, _localize) {
        const timestamp = Math.trunc(+date / 1000);
        return (0, $95876af0000dbf17$export$c8306e720e213c0f)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function(date, token, _localize) {
        return (0, $95876af0000dbf17$export$c8306e720e213c0f)(+date, token.length);
    }
};
function $4b6345f265fce384$var$formatTimezoneShort(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = Math.trunc(absOffset / 60);
    const minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    return sign + String(hours) + delimiter + (0, $95876af0000dbf17$export$c8306e720e213c0f)(minutes, 2);
}
function $4b6345f265fce384$var$formatTimezoneWithOptionalMinutes(offset, delimiter) {
    if (offset % 60 === 0) {
        const sign = offset > 0 ? "-" : "+";
        return sign + (0, $95876af0000dbf17$export$c8306e720e213c0f)(Math.abs(offset) / 60, 2);
    }
    return $4b6345f265fce384$var$formatTimezone(offset, delimiter);
}
function $4b6345f265fce384$var$formatTimezone(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = (0, $95876af0000dbf17$export$c8306e720e213c0f)(Math.trunc(absOffset / 60), 2);
    const minutes = (0, $95876af0000dbf17$export$c8306e720e213c0f)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}


const $d2a00aabe10bd762$var$dateLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
const $d2a00aabe10bd762$var$timeLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
const $d2a00aabe10bd762$var$dateTimeLongFormatter = (pattern, formatLong)=>{
    const matchResult = pattern.match(/(P+)(p+)?/) || [];
    const datePattern = matchResult[1];
    const timePattern = matchResult[2];
    if (!timePattern) return $d2a00aabe10bd762$var$dateLongFormatter(pattern, formatLong);
    let dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $d2a00aabe10bd762$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $d2a00aabe10bd762$var$timeLongFormatter(timePattern, formatLong));
};
const $d2a00aabe10bd762$export$70cc8fd02856fd58 = {
    p: $d2a00aabe10bd762$var$timeLongFormatter,
    P: $d2a00aabe10bd762$var$dateTimeLongFormatter
};


const $abbfbf913ae779f8$var$dayOfYearTokenRE = /^D+$/;
const $abbfbf913ae779f8$var$weekYearTokenRE = /^Y+$/;
const $abbfbf913ae779f8$var$throwTokens = [
    "D",
    "DD",
    "YY",
    "YYYY"
];
function $abbfbf913ae779f8$export$c6cc36aa33304772(token) {
    return $abbfbf913ae779f8$var$dayOfYearTokenRE.test(token);
}
function $abbfbf913ae779f8$export$c6b49d6dceb604a1(token) {
    return $abbfbf913ae779f8$var$weekYearTokenRE.test(token);
}
function $abbfbf913ae779f8$export$f5f38f90ecaaf879(token, format, input) {
    const _message = $abbfbf913ae779f8$var$message(token, format, input);
    console.warn(_message);
    if ($abbfbf913ae779f8$var$throwTokens.includes(token)) throw new RangeError(_message);
}
function $abbfbf913ae779f8$var$message(token, format, input) {
    const subject = token[0] === "Y" ? "years" : "days of the month";
    return `Use \`${token.toLowerCase()}\` instead of \`${token}\` (in \`${format}\`) for formatting ${subject} to the input \`${input}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}


/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param value - The value to check
 *
 * @returns True if the given value is a date
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */ function $ffd9ea5b580152f8$export$871608497c498473(value) {
    return value instanceof Date || typeof value === "object" && Object.prototype.toString.call(value) === "[object Date]";
}
var // Fallback for modularized imports:
$ffd9ea5b580152f8$export$2e2bcd8739ae039 = $ffd9ea5b580152f8$export$871608497c498473;



function $c082c553d4c367ee$export$1ea939691cdc45b8(date) {
    return !(!(0, $ffd9ea5b580152f8$export$871608497c498473)(date) && typeof date !== "number" || isNaN(+(0, $189325ccd94be08c$export$e67a095c620b86fe)(date)));
}
var // Fallback for modularized imports:
$c082c553d4c367ee$export$2e2bcd8739ae039 = $c082c553d4c367ee$export$1ea939691cdc45b8;



// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $9ba9f62958b08ac9$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const $9ba9f62958b08ac9$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const $9ba9f62958b08ac9$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $9ba9f62958b08ac9$var$doubleQuoteRegExp = /''/g;
const $9ba9f62958b08ac9$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $9ba9f62958b08ac9$export$d9468344d3651243(date, formatStr, options) {
    const defaultOptions = (0, $1f6f737b74a6aaae$export$430a3269e24b912e)();
    const locale = options?.locale ?? defaultOptions.locale ?? (0, $5a150a3bcfb37384$export$137380d9ce54f7f);
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const originalDate = (0, $189325ccd94be08c$export$e67a095c620b86fe)(date, options?.in);
    if (!(0, $c082c553d4c367ee$export$1ea939691cdc45b8)(originalDate)) throw new RangeError("Invalid time value");
    let parts = formatStr.match($9ba9f62958b08ac9$var$longFormattingTokensRegExp).map((substring)=>{
        const firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            const longFormatter = (0, $d2a00aabe10bd762$export$70cc8fd02856fd58)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($9ba9f62958b08ac9$var$formattingTokensRegExp).map((substring)=>{
        // Replace two single quote characters with one single quote character
        if (substring === "''") return {
            isToken: false,
            value: "'"
        };
        const firstCharacter = substring[0];
        if (firstCharacter === "'") return {
            isToken: false,
            value: $9ba9f62958b08ac9$var$cleanEscapedString(substring)
        };
        if ((0, $4b6345f265fce384$export$fe98a034cfb96d55)[firstCharacter]) return {
            isToken: true,
            value: substring
        };
        if (firstCharacter.match($9ba9f62958b08ac9$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return {
            isToken: false,
            value: substring
        };
    });
    // invoke localize preprocessor (only for french locales at the moment)
    if (locale.localize.preprocessor) parts = locale.localize.preprocessor(originalDate, parts);
    const formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    return parts.map((part)=>{
        if (!part.isToken) return part.value;
        const token = part.value;
        if (!options?.useAdditionalWeekYearTokens && (0, $abbfbf913ae779f8$export$c6b49d6dceb604a1)(token) || !options?.useAdditionalDayOfYearTokens && (0, $abbfbf913ae779f8$export$c6cc36aa33304772)(token)) (0, $abbfbf913ae779f8$export$f5f38f90ecaaf879)(token, formatStr, String(date));
        const formatter = (0, $4b6345f265fce384$export$fe98a034cfb96d55)[token[0]];
        return formatter(originalDate, token, locale.localize, formatterOptions);
    }).join("");
}
function $9ba9f62958b08ac9$var$cleanEscapedString(input) {
    const matched = input.match($9ba9f62958b08ac9$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($9ba9f62958b08ac9$var$doubleQuoteRegExp, "'");
}
var // Fallback for modularized imports:
$9ba9f62958b08ac9$export$2e2bcd8739ae039 = $9ba9f62958b08ac9$export$d9468344d3651243;


/** Retourne une date et heure formatée avec le pattern fourni
 * @param dateToFormat: Date
 * @param pattern: string
 * @returns: string
 */ function $00c47c7740afd024$var$formatDateWithPattern(dateToFormat, pattern) {
    return (0, $9ba9f62958b08ac9$export$2e2bcd8739ae039)(dateToFormat, pattern);
}
/** Retourne une date et heure au format 'dd/MM/yyyy HH:mm'
 * @param dateToFormat: Date
 * @returns: string
 */ function $00c47c7740afd024$var$formatDateTime(dateToFormat) {
    return $00c47c7740afd024$var$formatDateWithPattern(dateToFormat, "dd/MM/yyyy HH:mm");
}
function $00c47c7740afd024$export$cc23f907e4acb548(dateToFormat) {
    return $00c47c7740afd024$var$formatDateWithPattern(dateToFormat, "yyyy-MM-dd HH:mm");
}
function $00c47c7740afd024$export$3ae94a2503e890a1(dateToFormat) {
    return $00c47c7740afd024$var$formatDateWithPattern(dateToFormat, "dd/MM/yyyy");
}
function $00c47c7740afd024$export$c74325cff954054e(dateToFormat) {
    return $00c47c7740afd024$var$formatDateWithPattern(dateToFormat, "dd/MM/yyyy \xe0 HH:mm");
}
function $00c47c7740afd024$export$c6834cb9c1260d15(dateToFormat) {
    return $00c47c7740afd024$var$formatDateWithPattern(dateToFormat, "yyyy-MM-dd");
}
function $00c47c7740afd024$export$1bea58d51b4f086c(dateStr) {
    if (!dateStr || typeof dateStr !== "string") return "-";
    // Ex: 0025-02-04 10:04:39.000 +0100
    const match = dateStr.match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})/);
    if (!match) return "-";
    const [, yyyy, MM, dd, HH, mm] = match;
    return `${dd}/${MM}/${yyyy} ${HH}:${mm}`;
}
function $00c47c7740afd024$export$f41e7157aee91892(dateStr) {
    if (!dateStr || typeof dateStr !== "string") return "-";
    const match = dateStr.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (!match) return "-";
    const [, yyyy, MM, dd] = match;
    return `${dd}/${MM}/${yyyy}`;
}
function $00c47c7740afd024$export$beb50dcdba5b8943(date) {
    try {
        return $00c47c7740afd024$export$3ae94a2503e890a1(typeof date === "string" ? new Date(date) : date);
    } catch  {
        try {
            return $00c47c7740afd024$export$f41e7157aee91892(typeof date === "string" ? date : date.toString());
        } catch  {
            return "";
        }
    }
}
var $00c47c7740afd024$export$2e2bcd8739ae039 = $00c47c7740afd024$var$formatDateTime;





const $43f579690a1c166d$var$CustomLinkButton = ({ className: className, disabled: disabled = false, pathname: pathname, children: children, state: state, variant: variant = "link", onClick: onClick, search: search })=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $d4b7ea36fcb7fe56$export$2e2bcd8739ae039), {
        variant: variant,
        classname: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))("text-decoration-none", className),
        search: search,
        disabled: disabled,
        pathname: pathname,
        state: state,
        onClick: onClick,
        children: children
    });
};
var $43f579690a1c166d$export$2e2bcd8739ae039 = $43f579690a1c166d$var$CustomLinkButton;



/**
 * Permet d'afficher un module dans la page d'accueil
 */ const $a9754922f4c67d47$var$ModuleRemocra = ({ moduleId: moduleId, type: type, titre: titre, image: image, contenuHtml: contenuHtml, listeLink: listeLink, listeDocument: listeDocument })=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
        className: "bg-light border rounded",
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                className: "fw-bold text-center p-2 fs-5",
                children: titre
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: [
                    image && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        md: "3",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ad18c81fdcf37de8$export$2e2bcd8739ae039), {
                            src: image,
                            alt: titre,
                            fluid: true
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: [
                            (type === "DOCUMENT" || type === "COURRIER") && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($a9754922f4c67d47$var$ModuleDocumentCourrier, {
                                listeDocument: listeDocument,
                                moduleId: moduleId,
                                moduleType: type
                            }),
                            listeLink && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($a9754922f4c67d47$var$BuildLinks, {
                                listeLink: listeLink
                            }),
                            contenuHtml && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                dangerouslySetInnerHTML: {
                                    __html: contenuHtml
                                }
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $a9754922f4c67d47$var$ModuleDocumentCourrier = ({ listeDocument: listeDocument, moduleId: moduleId, moduleType: moduleType })=>{
    const isTypeDocument = moduleType === "DOCUMENT";
    const majWidth = isTypeDocument ? 100 : 150;
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $13de46b4dfcc473f$export$2e2bcd8739ae039), {
                bordered: true,
                striped: true,
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("thead", {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("th", {
                                    children: isTypeDocument ? "Libell\xe9" : "R\xe9f\xe9rence"
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("th", {
                                    width: majWidth,
                                    children: "Mise \xe0 jour"
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("th", {
                                    width: 50
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("tbody", {
                        children: listeDocument?.map((e, index)=>{
                            return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("td", {
                                        children: isTypeDocument ? e.libelle : e.reference
                                    }),
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("td", {
                                        width: majWidth,
                                        children: e.date && (isTypeDocument ? (0, $00c47c7740afd024$export$3ae94a2503e890a1)(e.date) : (0, $00c47c7740afd024$export$2e2bcd8739ae039)(e.date))
                                    }),
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("td", {
                                        width: 50,
                                        className: "p-0 m-0",
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                                            variant: "link",
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))("p-0 m-0", "text-decoration-none text-primary"),
                                            href: moduleType === "DOCUMENT" ? (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/document-habilitable/telecharger/` + e.id : (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/documents/telecharger/` + e.id,
                                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$4a5ccdc9878f4668), {})
                                        })
                                    })
                                ]
                            }, index);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $43f579690a1c166d$export$2e2bcd8739ae039), {
                variant: "link",
                pathname: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_MODULE_DOCUMENT_COURRIER(moduleType, moduleId),
                children: "Voir plus"
            })
        ]
    });
};
const $a9754922f4c67d47$var$BuildLinks = ({ listeLink: listeLink })=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
        children: listeLink.map((e, key)=>{
            if (e.aLeDroit === true) return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $43f579690a1c166d$export$2e2bcd8739ae039), {
                    className: "text-underline",
                    pathname: e.link,
                    children: e.label
                })
            }, key);
        })
    });
};
var $a9754922f4c67d47$export$2e2bcd8739ae039 = $a9754922f4c67d47$var$ModuleRemocra;
var $a9754922f4c67d47$export$ef88b514e4bfff34 = /*#__PURE__*/ function(TypeModuleRemocra) {
    TypeModuleRemocra["DECI"] = "DECI";
    TypeModuleRemocra["COUVERTURE_HYDRAULIQUE"] = "COUVERTURE_HYDRAULIQUE";
    TypeModuleRemocra["CARTOGRAPHIE_PERSONNALISEE"] = "CARTOGRAPHIE_PERSONNALISEE";
    TypeModuleRemocra["OLDEBS"] = "OLDEBS";
    TypeModuleRemocra["PERMIS"] = "PERMIS";
    TypeModuleRemocra["RCI"] = "RCI";
    TypeModuleRemocra["DFCI"] = "DFCI";
    TypeModuleRemocra["SIGNALEMENTS"] = "SIGNALEMENTS";
    TypeModuleRemocra["RISQUES"] = "RISQUES";
    TypeModuleRemocra["ADMIN"] = "ADMIN";
    TypeModuleRemocra["COURRIER"] = "COURRIER";
    TypeModuleRemocra["DOCUMENT"] = "DOCUMENT";
    TypeModuleRemocra["RAPPORT_PERSONNALISE"] = "RAPPORT_PERSONNALISE";
    TypeModuleRemocra["PEI_PRESCRIT"] = "PEI_PRESCRIT";
    TypeModuleRemocra["PERSONNALISE"] = "PERSONNALISE";
    TypeModuleRemocra["DASHBOARD"] = "DASHBOARD";
    TypeModuleRemocra["OPERATIONS_DIVERSES"] = "OPERATIONS_DIVERSES";
    TypeModuleRemocra["CRISE"] = "CRISE";
    return TypeModuleRemocra;
}({});




const $f740b0d032822ba6$export$ea1a29af61241729 = "EPSG:4326"; // WGS84 utilisé par l'étendue fournie par le serveur
const $f740b0d032822ba6$export$3eb968b6a9f43207 = "EPSG:3857"; // Web Mercator pour l'affichage
const $f740b0d032822ba6$export$8c8e0799e4488510 = "SYSTEME";
const $f740b0d032822ba6$export$6d46ce388c67cc70 = "POINT_EAU";
const $f740b0d032822ba6$export$7d12e57bbc4af0df = "RCI";
const $f740b0d032822ba6$export$3ad03f8706c2f84c = "RCCI"; //Code la couche RCCI et de son groupe pour gérer son affichage dans le front
const $f740b0d032822ba6$export$aa1e784cdd98af28 = 0.29858214173896974; // Correspond au niveau de zoom, utilisé pour le zoom sur les toponymies
const $f740b0d032822ba6$export$c12542e899d17513 = [
    10,
    15,
    25,
    50,
    100
];
const $f740b0d032822ba6$export$910193943608ef65 = 15; // Nombre d'éléments par page pour les tableaux
const $f740b0d032822ba6$export$b0c557648079337a = "AUCUNE_TOURNEE"; // Valeur de filtre pour les PEIs sans tournée associée
const $f740b0d032822ba6$export$43e6e1d03cd3f2e7 = 12;


function $c066b242635c27a6$var$isEmptyOrNull(value) {
    return value == null || value.trim().length === 0;
}
var $c066b242635c27a6$export$2e2bcd8739ae039 = $c066b242635c27a6$var$isEmptyOrNull;
function $c066b242635c27a6$export$b139bd30bc162c86(str, maxLength) {
    if (str.length > maxLength) return str.substring(0, maxLength) + "...";
    else return str;
}
function $c066b242635c27a6$export$40ef1f64c11ebe55(enumParam, keyParam) {
    return Object.keys(enumParam).find((key)=>enumParam[key] === keyParam);
}
function $c066b242635c27a6$export$9cca65ea339c61b4(urlApi, myObject, fileName, successToastMessage, successToast, errorToast) {
    // On doit passer par un POST pour pouvoir envoyer la liste des paramètres
    fetch((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`${urlApi}`, (0, $fbd4d34e07af0ac7$export$b163ec2f884327db)({
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: myObject
    })).then((response)=>{
        if (!response.ok) return response.text().then((text)=>{
            errorToast(text);
            throw new Error(text);
        });
        return response.blob();
    }).then((blob)=>{
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName; // Nom du fichier à télécharger
        a.click();
        window.URL.revokeObjectURL(url); // Libération de la mémoire
        successToast(successToastMessage);
    });
}
function $c066b242635c27a6$export$e37953fa8ba80500(location, navigate, urlRetour) {
    if (location.state?.from?.slice(-1)[0]) navigate(location.state.from.slice(-1)[0], {
        state: {
            ...location.state,
            from: location.state.from.slice(0, -1)
        }
    });
    else if (urlRetour) navigate(urlRetour);
    else navigate((0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).ACCUEIL);
}
function $c066b242635c27a6$export$791e4878d721fae8(typeModule) {
    switch(typeModule){
        case (0, $a9754922f4c67d47$export$ef88b514e4bfff34).DECI:
            return 0, $f740b0d032822ba6$export$6d46ce388c67cc70;
        case (0, $a9754922f4c67d47$export$ef88b514e4bfff34).RCI:
            return 0, $f740b0d032822ba6$export$7d12e57bbc4af0df;
        case (0, $a9754922f4c67d47$export$ef88b514e4bfff34).COUVERTURE_HYDRAULIQUE:
        case (0, $a9754922f4c67d47$export$ef88b514e4bfff34).CARTOGRAPHIE_PERSONNALISEE:
        case (0, $a9754922f4c67d47$export$ef88b514e4bfff34).OPERATIONS_DIVERSES:
        case (0, $a9754922f4c67d47$export$ef88b514e4bfff34).DFCI:
        case (0, $a9754922f4c67d47$export$ef88b514e4bfff34).OLDEBS:
        case (0, $a9754922f4c67d47$export$ef88b514e4bfff34).PERMIS:
        case (0, $a9754922f4c67d47$export$ef88b514e4bfff34).SIGNALEMENTS:
        case (0, $a9754922f4c67d47$export$ef88b514e4bfff34).RISQUES:
        case (0, $a9754922f4c67d47$export$ef88b514e4bfff34).CRISE:
        case (0, $a9754922f4c67d47$export$ef88b514e4bfff34).ADMIN:
        case (0, $a9754922f4c67d47$export$ef88b514e4bfff34).COURRIER:
        case (0, $a9754922f4c67d47$export$ef88b514e4bfff34).DOCUMENT:
        case (0, $a9754922f4c67d47$export$ef88b514e4bfff34).RAPPORT_PERSONNALISE:
        case (0, $a9754922f4c67d47$export$ef88b514e4bfff34).PEI_PRESCRIT:
        case (0, $a9754922f4c67d47$export$ef88b514e4bfff34).PERSONNALISE:
        case (0, $a9754922f4c67d47$export$ef88b514e4bfff34).DASHBOARD:
        default:
            return 0, $f740b0d032822ba6$export$6d46ce388c67cc70;
    }
}
function $c066b242635c27a6$export$e19edaf2912e7bf(values) {
    const filterBilan = (styles)=>values?.bilanVerifications?.filter((e)=>styles.includes(e.bilanStyle));
    const nbValides = filterBilan([
        "OK",
        "WARNING"
    ])?.length;
    const nbValidesWarn = filterBilan([
        "WARNING"
    ])?.length;
    const nbRejetes = filterBilan([
        "ERROR",
        "INFO"
    ])?.length;
    const nbRejetesNR = filterBilan([
        "INFO"
    ])?.length;
    return {
        nbValides: nbValides,
        nbValidesWarn: nbValidesWarn,
        nbRejetes: nbRejetes,
        nbRejetesNR: nbRejetesNR
    };
}
function $c066b242635c27a6$export$194a7b9973b5160e(disposition, nomFichierParDefaut) {
    if (!disposition || !disposition.includes("filename=")) return nomFichierParDefaut;
    return disposition.split("filename=")[1].split(";")[0].replace(/["']/g, "").trim();
}



const $751ac88b6dffd6cc$var$PageTitle = ({ title: title, icon: icon, right: right, displayReturnButton: displayReturnButton = true, urlRetour: urlRetour })=>{
    const navigate = (0, $7a844823b04d4282$export$9770f232ac06a008)();
    const location = (0, $7a844823b04d4282$export$45d76561a5302f2b)();
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        className: "ps-0",
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
            className: "mb-4 mt-3 mx-0 ps-0 noprint",
            children: [
                displayReturnButton && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                    xs: "auto",
                    className: "ps-0",
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                        variant: "link",
                        className: "text-decoration-none text-sm font-weight-bold ps-0",
                        onClick: ()=>{
                            (0, $c066b242635c27a6$export$e37953fa8ba80500)(location, navigate, urlRetour);
                        },
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$41884575254a94be), {}),
                            " Retour"
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                    xs: "auto",
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("h1", {
                        className: "fw-bold",
                        children: [
                            icon,
                            " ",
                            title
                        ]
                    })
                }),
                right ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                    className: "ms-auto",
                    sm: "auto",
                    children: right
                }) : ""
            ]
        })
    });
};
var $751ac88b6dffd6cc$export$2e2bcd8739ae039 = $751ac88b6dffd6cc$var$PageTitle;





const $eebfdd72ecf3e7e5$var$FilterInput = ({ type: type, name: name, onChange: onChangeCallback, value: value })=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Control, {
        type: type,
        id: name,
        name: name,
        value: value,
        onChange: (e)=>{
            onChangeCallback({
                name: name,
                value: e.target.value
            });
        }
    });
};
var $eebfdd72ecf3e7e5$export$2e2bcd8739ae039 = $eebfdd72ecf3e7e5$var$FilterInput;



function $edd369f856d5b0b3$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $edd369f856d5b0b3$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $edd369f856d5b0b3$export$2e2bcd8739ae039(o);
}



function $8ad5ed6008435ac7$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $edd369f856d5b0b3$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $edd369f856d5b0b3$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $a72a9325d605837f$export$2e2bcd8739ae039(t) {
    var i = (0, $8ad5ed6008435ac7$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $edd369f856d5b0b3$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $d8f5e6158ecd1aab$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $a72a9325d605837f$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}


function $7018b41fa193028d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7018b41fa193028d$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7018b41fa193028d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $d8f5e6158ecd1aab$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7018b41fa193028d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}


function $3d061c79fe535319$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}


function $26ce98c6b4657ff1$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}


function $ae8206a272ba3b20$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}


function $37f08cfaac5a1491$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $ae8206a272ba3b20$export$2e2bcd8739ae039)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $ae8206a272ba3b20$export$2e2bcd8739ae039)(r, a) : void 0;
    }
}


function $184d4418ed4065fe$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $e32bce0b6486f581$export$2e2bcd8739ae039(r, e) {
    return (0, $3d061c79fe535319$export$2e2bcd8739ae039)(r) || (0, $26ce98c6b4657ff1$export$2e2bcd8739ae039)(r, e) || (0, $37f08cfaac5a1491$export$2e2bcd8739ae039)(r, e) || (0, $184d4418ed4065fe$export$2e2bcd8739ae039)();
}



function $fefdef73d5b2b1c6$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $5643d0ce020fb17f$export$2e2bcd8739ae039)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}



var $kc00y = parcelRequire("kc00y");
var $13021495c1d5bd05$var$_excluded = [
    "defaultInputValue",
    "defaultMenuIsOpen",
    "defaultValue",
    "inputValue",
    "menuIsOpen",
    "onChange",
    "onInputChange",
    "onMenuClose",
    "onMenuOpen",
    "value"
];
function $13021495c1d5bd05$export$3b14a55fb2447963(_ref) {
    var _ref$defaultInputValu = _ref.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? '' : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref.inputValue, propsMenuIsOpen = _ref.menuIsOpen, propsOnChange = _ref.onChange, propsOnInputChange = _ref.onInputChange, propsOnMenuClose = _ref.onMenuClose, propsOnMenuOpen = _ref.onMenuOpen, propsValue = _ref.value, restSelectProps = (0, $fefdef73d5b2b1c6$export$2e2bcd8739ae039)(_ref, $13021495c1d5bd05$var$_excluded);
    var _useState = (0, $kc00y.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue), _useState2 = (0, $e32bce0b6486f581$export$2e2bcd8739ae039)(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
    var _useState3 = (0, $kc00y.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = (0, $e32bce0b6486f581$export$2e2bcd8739ae039)(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
    var _useState5 = (0, $kc00y.useState)(propsValue !== undefined ? propsValue : defaultValue), _useState6 = (0, $e32bce0b6486f581$export$2e2bcd8739ae039)(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
    var onChange = (0, $kc00y.useCallback)(function(value, actionMeta) {
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    var onInputChange = (0, $kc00y.useCallback)(function(value, actionMeta) {
        var newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    var onMenuOpen = (0, $kc00y.useCallback)(function() {
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    var onMenuClose = (0, $kc00y.useCallback)(function() {
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    return (0, $7018b41fa193028d$export$2e2bcd8739ae039)((0, $7018b41fa193028d$export$2e2bcd8739ae039)({}, restSelectProps), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    });
}




var $kc00y = parcelRequire("kc00y");


function $6bf37624bc91922d$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}



function $aadd4372416ec2f2$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $a72a9325d605837f$export$2e2bcd8739ae039)(o.key), o);
    }
}
function $aadd4372416ec2f2$export$2e2bcd8739ae039(e, r, t) {
    return r && $aadd4372416ec2f2$var$_defineProperties(e.prototype, r), t && $aadd4372416ec2f2$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}



function $e641cec65e374bd1$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $fa18464dbdd601aa$export$2e2bcd8739ae039)(t, e);
}


function $a6b135ba5b9f3850$export$2e2bcd8739ae039(t) {
    return $a6b135ba5b9f3850$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $a6b135ba5b9f3850$export$2e2bcd8739ae039(t);
}


function $0c3b1a627100fd12$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($0c3b1a627100fd12$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}



function $83799a442ebf2b68$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}


function $594192c53952fdd8$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $edd369f856d5b0b3$export$2e2bcd8739ae039)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $83799a442ebf2b68$export$2e2bcd8739ae039)(t);
}


function $2405f8bb9d24fc8e$export$2e2bcd8739ae039(t) {
    var r = (0, $0c3b1a627100fd12$export$2e2bcd8739ae039)();
    return function() {
        var e, o = (0, $a6b135ba5b9f3850$export$2e2bcd8739ae039)(t);
        if (r) {
            var s = (0, $a6b135ba5b9f3850$export$2e2bcd8739ae039)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $594192c53952fdd8$export$2e2bcd8739ae039)(this, e);
    };
}



function $199f9c14216dc199$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $ae8206a272ba3b20$export$2e2bcd8739ae039)(r);
}


function $743ef7f3ff7bcd2c$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}



function $b2aab6461fb2c999$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $32ec1eca796f107d$export$2e2bcd8739ae039(r) {
    return (0, $199f9c14216dc199$export$2e2bcd8739ae039)(r) || (0, $743ef7f3ff7bcd2c$export$2e2bcd8739ae039)(r) || (0, $37f08cfaac5a1491$export$2e2bcd8739ae039)(r) || (0, $b2aab6461fb2c999$export$2e2bcd8739ae039)();
}



var $kc00y = parcelRequire("kc00y");



var $kc00y = parcelRequire("kc00y");
var $86343868ad58ebd9$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $86343868ad58ebd9$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $86343868ad58ebd9$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $86343868ad58ebd9$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$86343868ad58ebd9$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($86343868ad58ebd9$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $86343868ad58ebd9$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();


/**
 * @param {number}
 * @return {number}
 */ var $f440b47df9b89d27$export$2335f513bbd82c6d = Math.abs;
var $f440b47df9b89d27$export$6788812c4e6611e6 = String.fromCharCode;
var $f440b47df9b89d27$export$e6e34fd1f2686227 = Object.assign;
function $f440b47df9b89d27$export$d6af199866bfb566(value, length) {
    return $f440b47df9b89d27$export$a9db5e087081082d(value, 0) ^ 45 ? (((length << 2 ^ $f440b47df9b89d27$export$a9db5e087081082d(value, 0)) << 2 ^ $f440b47df9b89d27$export$a9db5e087081082d(value, 1)) << 2 ^ $f440b47df9b89d27$export$a9db5e087081082d(value, 2)) << 2 ^ $f440b47df9b89d27$export$a9db5e087081082d(value, 3) : 0;
}
function $f440b47df9b89d27$export$87c2784dc9fc4ab(value) {
    return value.trim();
}
function $f440b47df9b89d27$export$4659b591c19bdf3d(value, pattern) {
    return (value = pattern.exec(value)) ? value[0] : value;
}
function $f440b47df9b89d27$export$77ad94ebf1c2b9ed(value, pattern, replacement) {
    return value.replace(pattern, replacement);
}
function $f440b47df9b89d27$export$f8e21b1e77979a08(value, search) {
    return value.indexOf(search);
}
function $f440b47df9b89d27$export$a9db5e087081082d(value, index) {
    return value.charCodeAt(index) | 0;
}
function $f440b47df9b89d27$export$2f35ab04d2335697(value, begin, end) {
    return value.slice(begin, end);
}
function $f440b47df9b89d27$export$36776f635604f274(value) {
    return value.length;
}
function $f440b47df9b89d27$export$f9084667e487ed46(value) {
    return value.length;
}
function $f440b47df9b89d27$export$10d8903dec122b9d(value, array) {
    return array.push(value), value;
}
function $f440b47df9b89d27$export$1be1fc439b849fdf(array, callback) {
    return array.map(callback).join('');
}


var $02641fb936e9e0af$export$53f1d5ea8de3d7c = 1;
var $02641fb936e9e0af$export$4e0c71f277ca26b3 = 1;
var $02641fb936e9e0af$export$f24224f1c91d8156 = 0;
var $02641fb936e9e0af$export$5880b8b5730aff45 = 0;
var $02641fb936e9e0af$export$c0306caf338ac095 = 0;
var $02641fb936e9e0af$export$30a86d91af8ff6e6 = '';
function $02641fb936e9e0af$export$35059013cd4a06db(value, root, parent, type, props, children, length) {
    return {
        value: value,
        root: root,
        parent: parent,
        type: type,
        props: props,
        children: children,
        line: $02641fb936e9e0af$export$53f1d5ea8de3d7c,
        column: $02641fb936e9e0af$export$4e0c71f277ca26b3,
        length: length,
        return: ''
    };
}
function $02641fb936e9e0af$export$784d13d8ee351f07(root, props) {
    return (0, $f440b47df9b89d27$export$e6e34fd1f2686227)($02641fb936e9e0af$export$35059013cd4a06db('', null, null, '', null, null, 0), root, {
        length: -root.length
    }, props);
}
function $02641fb936e9e0af$export$eba6f6f03b0a92e7() {
    return $02641fb936e9e0af$export$c0306caf338ac095;
}
function $02641fb936e9e0af$export$232faf9add678146() {
    $02641fb936e9e0af$export$c0306caf338ac095 = $02641fb936e9e0af$export$5880b8b5730aff45 > 0 ? (0, $f440b47df9b89d27$export$a9db5e087081082d)($02641fb936e9e0af$export$30a86d91af8ff6e6, --$02641fb936e9e0af$export$5880b8b5730aff45) : 0;
    if ($02641fb936e9e0af$export$4e0c71f277ca26b3--, $02641fb936e9e0af$export$c0306caf338ac095 === 10) $02641fb936e9e0af$export$4e0c71f277ca26b3 = 1, $02641fb936e9e0af$export$53f1d5ea8de3d7c--;
    return $02641fb936e9e0af$export$c0306caf338ac095;
}
function $02641fb936e9e0af$export$48cfd1e771a65c4f() {
    $02641fb936e9e0af$export$c0306caf338ac095 = $02641fb936e9e0af$export$5880b8b5730aff45 < $02641fb936e9e0af$export$f24224f1c91d8156 ? (0, $f440b47df9b89d27$export$a9db5e087081082d)($02641fb936e9e0af$export$30a86d91af8ff6e6, $02641fb936e9e0af$export$5880b8b5730aff45++) : 0;
    if ($02641fb936e9e0af$export$4e0c71f277ca26b3++, $02641fb936e9e0af$export$c0306caf338ac095 === 10) $02641fb936e9e0af$export$4e0c71f277ca26b3 = 1, $02641fb936e9e0af$export$53f1d5ea8de3d7c++;
    return $02641fb936e9e0af$export$c0306caf338ac095;
}
function $02641fb936e9e0af$export$4d3fb11e950abb9e() {
    return (0, $f440b47df9b89d27$export$a9db5e087081082d)($02641fb936e9e0af$export$30a86d91af8ff6e6, $02641fb936e9e0af$export$5880b8b5730aff45);
}
function $02641fb936e9e0af$export$e88cb2efb12ae807() {
    return $02641fb936e9e0af$export$5880b8b5730aff45;
}
function $02641fb936e9e0af$export$58adb3bec8346d0f(begin, end) {
    return (0, $f440b47df9b89d27$export$2f35ab04d2335697)($02641fb936e9e0af$export$30a86d91af8ff6e6, begin, end);
}
function $02641fb936e9e0af$export$9e1725a4cfeada27(type) {
    switch(type){
        // \0 \t \n \r \s whitespace token
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        // ! + , / > @ ~ isolate token
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        // ; { } breakpoint token
        case 59:
        case 123:
        case 125:
            return 4;
        // : accompanied token
        case 58:
            return 3;
        // " ' ( [ opening delimit token
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        // ) ] closing delimit token
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $02641fb936e9e0af$export$2de70f21292aac9e(value) {
    return $02641fb936e9e0af$export$53f1d5ea8de3d7c = $02641fb936e9e0af$export$4e0c71f277ca26b3 = 1, $02641fb936e9e0af$export$f24224f1c91d8156 = (0, $f440b47df9b89d27$export$36776f635604f274)($02641fb936e9e0af$export$30a86d91af8ff6e6 = value), $02641fb936e9e0af$export$5880b8b5730aff45 = 0, [];
}
function $02641fb936e9e0af$export$45918ac1574455b1(value) {
    return $02641fb936e9e0af$export$30a86d91af8ff6e6 = '', value;
}
function $02641fb936e9e0af$export$410ac95b9ec204b8(type) {
    return (0, $f440b47df9b89d27$export$87c2784dc9fc4ab)($02641fb936e9e0af$export$58adb3bec8346d0f($02641fb936e9e0af$export$5880b8b5730aff45 - 1, $02641fb936e9e0af$export$c889f2fcc19dbf12(type === 91 ? type + 2 : type === 40 ? type + 1 : type)));
}
function $02641fb936e9e0af$export$660b2ee2d4fb4eff(value) {
    return $02641fb936e9e0af$export$45918ac1574455b1($02641fb936e9e0af$export$5f8c09e3ae6f64e1($02641fb936e9e0af$export$2de70f21292aac9e(value)));
}
function $02641fb936e9e0af$export$7af1228ff777d175(type) {
    while($02641fb936e9e0af$export$c0306caf338ac095 = $02641fb936e9e0af$export$4d3fb11e950abb9e())if ($02641fb936e9e0af$export$c0306caf338ac095 < 33) $02641fb936e9e0af$export$48cfd1e771a65c4f();
    else break;
    return $02641fb936e9e0af$export$9e1725a4cfeada27(type) > 2 || $02641fb936e9e0af$export$9e1725a4cfeada27($02641fb936e9e0af$export$c0306caf338ac095) > 3 ? '' : ' ';
}
function $02641fb936e9e0af$export$5f8c09e3ae6f64e1(children) {
    while($02641fb936e9e0af$export$48cfd1e771a65c4f())switch($02641fb936e9e0af$export$9e1725a4cfeada27($02641fb936e9e0af$export$c0306caf338ac095)){
        case 0:
            (0, $f440b47df9b89d27$export$10d8903dec122b9d)($02641fb936e9e0af$export$c2ab62c7bf24634($02641fb936e9e0af$export$5880b8b5730aff45 - 1), children);
            break;
        case 2:
            (0, $f440b47df9b89d27$export$10d8903dec122b9d)($02641fb936e9e0af$export$410ac95b9ec204b8($02641fb936e9e0af$export$c0306caf338ac095), children);
            break;
        default:
            (0, $f440b47df9b89d27$export$10d8903dec122b9d)((0, $f440b47df9b89d27$export$6788812c4e6611e6)($02641fb936e9e0af$export$c0306caf338ac095), children);
    }
    return children;
}
function $02641fb936e9e0af$export$955ba06d119e085e(index, count) {
    while(--count && $02641fb936e9e0af$export$48cfd1e771a65c4f())// not 0-9 A-F a-f
    if ($02641fb936e9e0af$export$c0306caf338ac095 < 48 || $02641fb936e9e0af$export$c0306caf338ac095 > 102 || $02641fb936e9e0af$export$c0306caf338ac095 > 57 && $02641fb936e9e0af$export$c0306caf338ac095 < 65 || $02641fb936e9e0af$export$c0306caf338ac095 > 70 && $02641fb936e9e0af$export$c0306caf338ac095 < 97) break;
    return $02641fb936e9e0af$export$58adb3bec8346d0f(index, $02641fb936e9e0af$export$e88cb2efb12ae807() + (count < 6 && $02641fb936e9e0af$export$4d3fb11e950abb9e() == 32 && $02641fb936e9e0af$export$48cfd1e771a65c4f() == 32));
}
function $02641fb936e9e0af$export$c889f2fcc19dbf12(type) {
    while($02641fb936e9e0af$export$48cfd1e771a65c4f())switch($02641fb936e9e0af$export$c0306caf338ac095){
        // ] ) " '
        case type:
            return $02641fb936e9e0af$export$5880b8b5730aff45;
        // " '
        case 34:
        case 39:
            if (type !== 34 && type !== 39) $02641fb936e9e0af$export$c889f2fcc19dbf12($02641fb936e9e0af$export$c0306caf338ac095);
            break;
        // (
        case 40:
            if (type === 41) $02641fb936e9e0af$export$c889f2fcc19dbf12(type);
            break;
        // \
        case 92:
            $02641fb936e9e0af$export$48cfd1e771a65c4f();
            break;
    }
    return $02641fb936e9e0af$export$5880b8b5730aff45;
}
function $02641fb936e9e0af$export$4254d4e2b3745c4c(type, index) {
    while($02641fb936e9e0af$export$48cfd1e771a65c4f())// //
    if (type + $02641fb936e9e0af$export$c0306caf338ac095 === 57) break;
    else if (type + $02641fb936e9e0af$export$c0306caf338ac095 === 84 && $02641fb936e9e0af$export$4d3fb11e950abb9e() === 47) break;
    return '/*' + $02641fb936e9e0af$export$58adb3bec8346d0f(index, $02641fb936e9e0af$export$5880b8b5730aff45 - 1) + '*' + (0, $f440b47df9b89d27$export$6788812c4e6611e6)(type === 47 ? type : $02641fb936e9e0af$export$48cfd1e771a65c4f());
}
function $02641fb936e9e0af$export$c2ab62c7bf24634(index) {
    while(!$02641fb936e9e0af$export$9e1725a4cfeada27($02641fb936e9e0af$export$4d3fb11e950abb9e()))$02641fb936e9e0af$export$48cfd1e771a65c4f();
    return $02641fb936e9e0af$export$58adb3bec8346d0f(index, $02641fb936e9e0af$export$5880b8b5730aff45);
}

var $ab2caaed88da1d7c$export$71ad59f2e432cfe8 = '-ms-';
var $ab2caaed88da1d7c$export$2c0f367103c8d01c = '-moz-';
var $ab2caaed88da1d7c$export$39dfd62a25e0fe93 = '-webkit-';
var $ab2caaed88da1d7c$export$a29989082612d0d9 = 'comm';
var $ab2caaed88da1d7c$export$aa3a2e812ca8570d = 'rule';
var $ab2caaed88da1d7c$export$527d108ccf083c2b = 'decl';
var $ab2caaed88da1d7c$export$d3d35020fa5b54f0 = '@page';
var $ab2caaed88da1d7c$export$500415a86c544f73 = '@media';
var $ab2caaed88da1d7c$export$a763edbf796b780a = '@import';
var $ab2caaed88da1d7c$export$2790aeb8b4e5c826 = '@charset';
var $ab2caaed88da1d7c$export$1cc683e23b84b133 = '@viewport';
var $ab2caaed88da1d7c$export$9447a5efea57e862 = '@supports';
var $ab2caaed88da1d7c$export$ef011b4e114b1fba = '@document';
var $ab2caaed88da1d7c$export$6aad947bda0f3f46 = '@namespace';
var $ab2caaed88da1d7c$export$b44a8529a35fcb60 = '@keyframes';
var $ab2caaed88da1d7c$export$2c16de31893252e6 = '@font-face';
var $ab2caaed88da1d7c$export$3d846dd52e150c6f = '@counter-style';
var $ab2caaed88da1d7c$export$22314bfbb57653fe = '@font-feature-values';
var $ab2caaed88da1d7c$export$d773506282b3cfe6 = '@layer';




function $a3fb0592d93b5ebd$export$ef7acd7185315e22(value) {
    return (0, $02641fb936e9e0af$export$45918ac1574455b1)($a3fb0592d93b5ebd$export$98e6a39c04603d36('', null, null, null, [
        ''
    ], value = (0, $02641fb936e9e0af$export$2de70f21292aac9e)(value), 0, [
        0
    ], value));
}
function $a3fb0592d93b5ebd$export$98e6a39c04603d36(value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
    var index = 0;
    var offset = 0;
    var length = pseudo;
    var atrule = 0;
    var property = 0;
    var previous = 0;
    var variable = 1;
    var scanning = 1;
    var ampersand = 1;
    var character = 0;
    var type = '';
    var props = rules;
    var children = rulesets;
    var reference = rule;
    var characters = type;
    while(scanning)switch(previous = character, character = (0, $02641fb936e9e0af$export$48cfd1e771a65c4f)()){
        // (
        case 40:
            if (previous != 108 && (0, $f440b47df9b89d27$export$a9db5e087081082d)(characters, length - 1) == 58) {
                if ((0, $f440b47df9b89d27$export$f8e21b1e77979a08)(characters += (0, $f440b47df9b89d27$export$77ad94ebf1c2b9ed)((0, $02641fb936e9e0af$export$410ac95b9ec204b8)(character), '&', '&\f'), '&\f') != -1) ampersand = -1;
                break;
            }
        // " ' [
        case 34:
        case 39:
        case 91:
            characters += (0, $02641fb936e9e0af$export$410ac95b9ec204b8)(character);
            break;
        // \t \n \r \s
        case 9:
        case 10:
        case 13:
        case 32:
            characters += (0, $02641fb936e9e0af$export$7af1228ff777d175)(previous);
            break;
        // \
        case 92:
            characters += (0, $02641fb936e9e0af$export$955ba06d119e085e)((0, $02641fb936e9e0af$export$e88cb2efb12ae807)() - 1, 7);
            continue;
        // /
        case 47:
            switch((0, $02641fb936e9e0af$export$4d3fb11e950abb9e)()){
                case 42:
                case 47:
                    (0, $f440b47df9b89d27$export$10d8903dec122b9d)($a3fb0592d93b5ebd$export$4a34f930e789283c((0, $02641fb936e9e0af$export$4254d4e2b3745c4c)((0, $02641fb936e9e0af$export$48cfd1e771a65c4f)(), (0, $02641fb936e9e0af$export$e88cb2efb12ae807)()), root, parent), declarations);
                    break;
                default:
                    characters += '/';
            }
            break;
        // {
        case 123 * variable:
            points[index++] = (0, $f440b47df9b89d27$export$36776f635604f274)(characters) * ampersand;
        // } ; \0
        case 125 * variable:
        case 59:
        case 0:
            switch(character){
                // \0 }
                case 0:
                case 125:
                    scanning = 0;
                // ;
                case 59 + offset:
                    if (ampersand == -1) characters = (0, $f440b47df9b89d27$export$77ad94ebf1c2b9ed)(characters, /\f/g, '');
                    if (property > 0 && (0, $f440b47df9b89d27$export$36776f635604f274)(characters) - length) (0, $f440b47df9b89d27$export$10d8903dec122b9d)(property > 32 ? $a3fb0592d93b5ebd$export$f8483753829ec8f3(characters + ';', rule, parent, length - 1) : $a3fb0592d93b5ebd$export$f8483753829ec8f3((0, $f440b47df9b89d27$export$77ad94ebf1c2b9ed)(characters, ' ', '') + ';', rule, parent, length - 2), declarations);
                    break;
                // @ ;
                case 59:
                    characters += ';';
                // { rule/at-rule
                default:
                    (0, $f440b47df9b89d27$export$10d8903dec122b9d)(reference = $a3fb0592d93b5ebd$export$3307ffa7023ede1e(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets);
                    if (character === 123) {
                        if (offset === 0) $a3fb0592d93b5ebd$export$98e6a39c04603d36(characters, root, reference, reference, props, rulesets, length, points, children);
                        else switch(atrule === 99 && (0, $f440b47df9b89d27$export$a9db5e087081082d)(characters, 3) === 110 ? 100 : atrule){
                            // d l m s
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $a3fb0592d93b5ebd$export$98e6a39c04603d36(value, reference, reference, rule && (0, $f440b47df9b89d27$export$10d8903dec122b9d)($a3fb0592d93b5ebd$export$3307ffa7023ede1e(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children);
                                break;
                            default:
                                $a3fb0592d93b5ebd$export$98e6a39c04603d36(characters, reference, reference, reference, [
                                    ''
                                ], children, 0, points, children);
                        }
                    }
            }
            index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo;
            break;
        // :
        case 58:
            length = 1 + (0, $f440b47df9b89d27$export$36776f635604f274)(characters), property = previous;
        default:
            if (variable < 1) {
                if (character == 123) --variable;
                else if (character == 125 && variable++ == 0 && (0, $02641fb936e9e0af$export$232faf9add678146)() == 125) continue;
            }
            switch(characters += (0, $f440b47df9b89d27$export$6788812c4e6611e6)(character), character * variable){
                // &
                case 38:
                    ampersand = offset > 0 ? 1 : (characters += '\f', -1);
                    break;
                // ,
                case 44:
                    points[index++] = ((0, $f440b47df9b89d27$export$36776f635604f274)(characters) - 1) * ampersand, ampersand = 1;
                    break;
                // @
                case 64:
                    // -
                    if ((0, $02641fb936e9e0af$export$4d3fb11e950abb9e)() === 45) characters += (0, $02641fb936e9e0af$export$410ac95b9ec204b8)((0, $02641fb936e9e0af$export$48cfd1e771a65c4f)());
                    atrule = (0, $02641fb936e9e0af$export$4d3fb11e950abb9e)(), offset = length = (0, $f440b47df9b89d27$export$36776f635604f274)(type = characters += (0, $02641fb936e9e0af$export$c2ab62c7bf24634)((0, $02641fb936e9e0af$export$e88cb2efb12ae807)())), character++;
                    break;
                // -
                case 45:
                    if (previous === 45 && (0, $f440b47df9b89d27$export$36776f635604f274)(characters) == 2) variable = 0;
            }
    }
    return rulesets;
}
function $a3fb0592d93b5ebd$export$3307ffa7023ede1e(value, root, parent, index, offset, rules, points, type, props, children, length) {
    var post = offset - 1;
    var rule = offset === 0 ? rules : [
        ''
    ];
    var size = (0, $f440b47df9b89d27$export$f9084667e487ed46)(rule);
    for(var i = 0, j = 0, k = 0; i < index; ++i)for(var x = 0, y = (0, $f440b47df9b89d27$export$2f35ab04d2335697)(value, post + 1, post = (0, $f440b47df9b89d27$export$2335f513bbd82c6d)(j = points[i])), z = value; x < size; ++x)if (z = (0, $f440b47df9b89d27$export$87c2784dc9fc4ab)(j > 0 ? rule[x] + ' ' + y : (0, $f440b47df9b89d27$export$77ad94ebf1c2b9ed)(y, /&\f/g, rule[x]))) props[k++] = z;
    return (0, $02641fb936e9e0af$export$35059013cd4a06db)(value, root, parent, offset === 0 ? (0, $ab2caaed88da1d7c$export$aa3a2e812ca8570d) : type, props, children, length);
}
function $a3fb0592d93b5ebd$export$4a34f930e789283c(value, root, parent) {
    return (0, $02641fb936e9e0af$export$35059013cd4a06db)(value, root, parent, (0, $ab2caaed88da1d7c$export$a29989082612d0d9), (0, $f440b47df9b89d27$export$6788812c4e6611e6)((0, $02641fb936e9e0af$export$eba6f6f03b0a92e7)()), (0, $f440b47df9b89d27$export$2f35ab04d2335697)(value, 2, -2), 0);
}
function $a3fb0592d93b5ebd$export$f8483753829ec8f3(value, root, parent, length) {
    return (0, $02641fb936e9e0af$export$35059013cd4a06db)(value, root, parent, (0, $ab2caaed88da1d7c$export$527d108ccf083c2b), (0, $f440b47df9b89d27$export$2f35ab04d2335697)(value, 0, length), (0, $f440b47df9b89d27$export$2f35ab04d2335697)(value, length + 1, -1), length);
}






function $acf764232e4cc723$export$dfdc1655ccc5b9cb(children, callback) {
    var output = '';
    var length = (0, $f440b47df9b89d27$export$f9084667e487ed46)(children);
    for(var i = 0; i < length; i++)output += callback(children[i], i, children, callback) || '';
    return output;
}
function $acf764232e4cc723$export$fac44ee5b035f737(element, index, children, callback) {
    switch(element.type){
        case 0, $ab2caaed88da1d7c$export$d773506282b3cfe6:
            if (element.children.length) break;
        case 0, $ab2caaed88da1d7c$export$a763edbf796b780a:
        case 0, $ab2caaed88da1d7c$export$527d108ccf083c2b:
            return element.return = element.return || element.value;
        case 0, $ab2caaed88da1d7c$export$a29989082612d0d9:
            return '';
        case 0, $ab2caaed88da1d7c$export$b44a8529a35fcb60:
            return element.return = element.value + '{' + $acf764232e4cc723$export$dfdc1655ccc5b9cb(element.children, callback) + '}';
        case 0, $ab2caaed88da1d7c$export$aa3a2e812ca8570d:
            element.value = element.props.join(',');
    }
    return (0, $f440b47df9b89d27$export$36776f635604f274)(children = $acf764232e4cc723$export$dfdc1655ccc5b9cb(element.children, callback)) ? element.return = element.value + '{' + children + '}' : '';
}




function $8b8981babef92bf3$export$82e9f45cca5ba907(value, length, children) {
    switch((0, $f440b47df9b89d27$export$d6af199866bfb566)(value, length)){
        // color-adjust
        case 5103:
            return (0, $ab2caaed88da1d7c$export$39dfd62a25e0fe93) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $ab2caaed88da1d7c$export$39dfd62a25e0fe93) + value + value;
        // tab-size
        case 4789:
            return (0, $ab2caaed88da1d7c$export$2c0f367103c8d01c) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $ab2caaed88da1d7c$export$39dfd62a25e0fe93) + value + (0, $ab2caaed88da1d7c$export$2c0f367103c8d01c) + value + (0, $ab2caaed88da1d7c$export$71ad59f2e432cfe8) + value + value;
        // writing-mode
        case 5936:
            switch((0, $f440b47df9b89d27$export$a9db5e087081082d)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $ab2caaed88da1d7c$export$39dfd62a25e0fe93) + value + (0, $ab2caaed88da1d7c$export$71ad59f2e432cfe8) + (0, $f440b47df9b89d27$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $ab2caaed88da1d7c$export$39dfd62a25e0fe93) + value + (0, $ab2caaed88da1d7c$export$71ad59f2e432cfe8) + (0, $f440b47df9b89d27$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $ab2caaed88da1d7c$export$39dfd62a25e0fe93) + value + (0, $ab2caaed88da1d7c$export$71ad59f2e432cfe8) + (0, $f440b47df9b89d27$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
        // flex, flex-direction, scroll-snap-type, writing-mode
        case 6828:
        case 4268:
        case 2903:
            return (0, $ab2caaed88da1d7c$export$39dfd62a25e0fe93) + value + (0, $ab2caaed88da1d7c$export$71ad59f2e432cfe8) + value + value;
        // order
        case 6165:
            return (0, $ab2caaed88da1d7c$export$39dfd62a25e0fe93) + value + (0, $ab2caaed88da1d7c$export$71ad59f2e432cfe8) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $ab2caaed88da1d7c$export$39dfd62a25e0fe93) + value + (0, $f440b47df9b89d27$export$77ad94ebf1c2b9ed)(value, /(\w+).+(:[^]+)/, (0, $ab2caaed88da1d7c$export$39dfd62a25e0fe93) + 'box-$1$2' + (0, $ab2caaed88da1d7c$export$71ad59f2e432cfe8) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $ab2caaed88da1d7c$export$39dfd62a25e0fe93) + value + (0, $ab2caaed88da1d7c$export$71ad59f2e432cfe8) + 'flex-item-' + (0, $f440b47df9b89d27$export$77ad94ebf1c2b9ed)(value, /flex-|-self/g, '') + (!(0, $f440b47df9b89d27$export$4659b591c19bdf3d)(value, /flex-|baseline/) ? (0, $ab2caaed88da1d7c$export$71ad59f2e432cfe8) + 'grid-row-' + (0, $f440b47df9b89d27$export$77ad94ebf1c2b9ed)(value, /flex-|-self/g, '') : '') + value;
        // align-content
        case 4675:
            return (0, $ab2caaed88da1d7c$export$39dfd62a25e0fe93) + value + (0, $ab2caaed88da1d7c$export$71ad59f2e432cfe8) + 'flex-line-pack' + (0, $f440b47df9b89d27$export$77ad94ebf1c2b9ed)(value, /align-content|flex-|-self/g, '') + value;
        // flex-shrink
        case 5548:
            return (0, $ab2caaed88da1d7c$export$39dfd62a25e0fe93) + value + (0, $ab2caaed88da1d7c$export$71ad59f2e432cfe8) + (0, $f440b47df9b89d27$export$77ad94ebf1c2b9ed)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $ab2caaed88da1d7c$export$39dfd62a25e0fe93) + value + (0, $ab2caaed88da1d7c$export$71ad59f2e432cfe8) + (0, $f440b47df9b89d27$export$77ad94ebf1c2b9ed)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $ab2caaed88da1d7c$export$39dfd62a25e0fe93) + 'box-' + (0, $f440b47df9b89d27$export$77ad94ebf1c2b9ed)(value, '-grow', '') + (0, $ab2caaed88da1d7c$export$39dfd62a25e0fe93) + value + (0, $ab2caaed88da1d7c$export$71ad59f2e432cfe8) + (0, $f440b47df9b89d27$export$77ad94ebf1c2b9ed)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $ab2caaed88da1d7c$export$39dfd62a25e0fe93) + (0, $f440b47df9b89d27$export$77ad94ebf1c2b9ed)(value, /([^-])(transform)/g, '$1' + (0, $ab2caaed88da1d7c$export$39dfd62a25e0fe93) + '$2') + value;
        // cursor
        case 6187:
            return (0, $f440b47df9b89d27$export$77ad94ebf1c2b9ed)((0, $f440b47df9b89d27$export$77ad94ebf1c2b9ed)((0, $f440b47df9b89d27$export$77ad94ebf1c2b9ed)(value, /(zoom-|grab)/, (0, $ab2caaed88da1d7c$export$39dfd62a25e0fe93) + '$1'), /(image-set)/, (0, $ab2caaed88da1d7c$export$39dfd62a25e0fe93) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $f440b47df9b89d27$export$77ad94ebf1c2b9ed)(value, /(image-set\([^]*)/, (0, $ab2caaed88da1d7c$export$39dfd62a25e0fe93) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $f440b47df9b89d27$export$77ad94ebf1c2b9ed)((0, $f440b47df9b89d27$export$77ad94ebf1c2b9ed)(value, /(.+:)(flex-)?(.*)/, (0, $ab2caaed88da1d7c$export$39dfd62a25e0fe93) + 'box-pack:$3' + (0, $ab2caaed88da1d7c$export$71ad59f2e432cfe8) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $ab2caaed88da1d7c$export$39dfd62a25e0fe93) + value + value;
        // justify-self
        case 4200:
            if (!(0, $f440b47df9b89d27$export$4659b591c19bdf3d)(value, /flex-|baseline/)) return (0, $ab2caaed88da1d7c$export$71ad59f2e432cfe8) + 'grid-column-align' + (0, $f440b47df9b89d27$export$2f35ab04d2335697)(value, length) + value;
            break;
        // grid-template-(columns|rows)
        case 2592:
        case 3360:
            return (0, $ab2caaed88da1d7c$export$71ad59f2e432cfe8) + (0, $f440b47df9b89d27$export$77ad94ebf1c2b9ed)(value, 'template-', '') + value;
        // grid-(row|column)-start
        case 4384:
        case 3616:
            if (children && children.some(function(element, index) {
                return length = index, (0, $f440b47df9b89d27$export$4659b591c19bdf3d)(element.props, /grid-\w+-end/);
            })) return ~(0, $f440b47df9b89d27$export$f8e21b1e77979a08)(value + (children = children[length].value), 'span') ? value : (0, $ab2caaed88da1d7c$export$71ad59f2e432cfe8) + (0, $f440b47df9b89d27$export$77ad94ebf1c2b9ed)(value, '-start', '') + value + (0, $ab2caaed88da1d7c$export$71ad59f2e432cfe8) + 'grid-row-span:' + (~(0, $f440b47df9b89d27$export$f8e21b1e77979a08)(children, 'span') ? (0, $f440b47df9b89d27$export$4659b591c19bdf3d)(children, /\d+/) : +(0, $f440b47df9b89d27$export$4659b591c19bdf3d)(children, /\d+/) - +(0, $f440b47df9b89d27$export$4659b591c19bdf3d)(value, /\d+/)) + ';';
            return (0, $ab2caaed88da1d7c$export$71ad59f2e432cfe8) + (0, $f440b47df9b89d27$export$77ad94ebf1c2b9ed)(value, '-start', '') + value;
        // grid-(row|column)-end
        case 4896:
        case 4128:
            return children && children.some(function(element) {
                return (0, $f440b47df9b89d27$export$4659b591c19bdf3d)(element.props, /grid-\w+-start/);
            }) ? value : (0, $ab2caaed88da1d7c$export$71ad59f2e432cfe8) + (0, $f440b47df9b89d27$export$77ad94ebf1c2b9ed)((0, $f440b47df9b89d27$export$77ad94ebf1c2b9ed)(value, '-end', '-span'), 'span ', '') + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $f440b47df9b89d27$export$77ad94ebf1c2b9ed)(value, /(.+)-inline(.+)/, (0, $ab2caaed88da1d7c$export$39dfd62a25e0fe93) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $f440b47df9b89d27$export$36776f635604f274)(value) - 1 - length > 6) switch((0, $f440b47df9b89d27$export$a9db5e087081082d)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $f440b47df9b89d27$export$a9db5e087081082d)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $f440b47df9b89d27$export$77ad94ebf1c2b9ed)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $ab2caaed88da1d7c$export$39dfd62a25e0fe93) + '$2-$3' + '$1' + (0, $ab2caaed88da1d7c$export$2c0f367103c8d01c) + ((0, $f440b47df9b89d27$export$a9db5e087081082d)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $f440b47df9b89d27$export$f8e21b1e77979a08)(value, 'stretch') ? $8b8981babef92bf3$export$82e9f45cca5ba907((0, $f440b47df9b89d27$export$77ad94ebf1c2b9ed)(value, 'stretch', 'fill-available'), length, children) + value : value;
            }
            break;
        // grid-(column|row)
        case 5152:
        case 5920:
            return (0, $f440b47df9b89d27$export$77ad94ebf1c2b9ed)(value, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(_, a, b, c, d, e, f) {
                return (0, $ab2caaed88da1d7c$export$71ad59f2e432cfe8) + a + ':' + b + f + (c ? (0, $ab2caaed88da1d7c$export$71ad59f2e432cfe8) + a + '-span:' + (d ? e : +e - +b) + f : '') + value;
            });
        // position: sticky
        case 4949:
            // stick(y)?
            if ((0, $f440b47df9b89d27$export$a9db5e087081082d)(value, length + 6) === 121) return (0, $f440b47df9b89d27$export$77ad94ebf1c2b9ed)(value, ':', ':' + (0, $ab2caaed88da1d7c$export$39dfd62a25e0fe93)) + value;
            break;
        // display: (flex|inline-flex|grid|inline-grid)
        case 6444:
            switch((0, $f440b47df9b89d27$export$a9db5e087081082d)(value, (0, $f440b47df9b89d27$export$a9db5e087081082d)(value, 14) === 45 ? 18 : 11)){
                // (inline-)?fle(x)
                case 120:
                    return (0, $f440b47df9b89d27$export$77ad94ebf1c2b9ed)(value, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, '$1' + (0, $ab2caaed88da1d7c$export$39dfd62a25e0fe93) + ((0, $f440b47df9b89d27$export$a9db5e087081082d)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $ab2caaed88da1d7c$export$39dfd62a25e0fe93) + '$2$3' + '$1' + (0, $ab2caaed88da1d7c$export$71ad59f2e432cfe8) + '$2box$3') + value;
                // (inline-)?gri(d)
                case 100:
                    return (0, $f440b47df9b89d27$export$77ad94ebf1c2b9ed)(value, ':', ':' + (0, $ab2caaed88da1d7c$export$71ad59f2e432cfe8)) + value;
            }
            break;
        // scroll-margin, scroll-margin-(top|right|bottom|left)
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return (0, $f440b47df9b89d27$export$77ad94ebf1c2b9ed)(value, 'scroll-', 'scroll-snap-') + value;
    }
    return value;
}


function $f708a927327be8d0$export$5a7767152ae0305f(collection) {
    var length = (0, $f440b47df9b89d27$export$f9084667e487ed46)(collection);
    return function(element, index, children, callback) {
        var output = '';
        for(var i = 0; i < length; i++)output += collection[i](element, index, children, callback) || '';
        return output;
    };
}
function $f708a927327be8d0$export$38bcb760f1d4871c(callback) {
    return function(element) {
        if (!element.root) {
            if (element = element.return) callback(element);
        }
    };
}
function $f708a927327be8d0$export$e08c7d021b829b7a(element, index, children, callback) {
    if (element.length > -1) {
        if (!element.return) switch(element.type){
            case 0, $ab2caaed88da1d7c$export$527d108ccf083c2b:
                element.return = (0, $8b8981babef92bf3$export$82e9f45cca5ba907)(element.value, element.length, children);
                return;
            case 0, $ab2caaed88da1d7c$export$b44a8529a35fcb60:
                return (0, $acf764232e4cc723$export$dfdc1655ccc5b9cb)([
                    (0, $02641fb936e9e0af$export$784d13d8ee351f07)(element, {
                        value: (0, $f440b47df9b89d27$export$77ad94ebf1c2b9ed)(element.value, '@', '@' + (0, $ab2caaed88da1d7c$export$39dfd62a25e0fe93))
                    })
                ], callback);
            case 0, $ab2caaed88da1d7c$export$aa3a2e812ca8570d:
                if (element.length) return (0, $f440b47df9b89d27$export$1be1fc439b849fdf)(element.props, function(value) {
                    switch((0, $f440b47df9b89d27$export$4659b591c19bdf3d)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $acf764232e4cc723$export$dfdc1655ccc5b9cb)([
                                (0, $02641fb936e9e0af$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $f440b47df9b89d27$export$77ad94ebf1c2b9ed)(value, /:(read-\w+)/, ':' + (0, $ab2caaed88da1d7c$export$2c0f367103c8d01c) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $acf764232e4cc723$export$dfdc1655ccc5b9cb)([
                                (0, $02641fb936e9e0af$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $f440b47df9b89d27$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $ab2caaed88da1d7c$export$39dfd62a25e0fe93) + 'input-$1')
                                    ]
                                }),
                                (0, $02641fb936e9e0af$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $f440b47df9b89d27$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $ab2caaed88da1d7c$export$2c0f367103c8d01c) + '$1')
                                    ]
                                }),
                                (0, $02641fb936e9e0af$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $f440b47df9b89d27$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, (0, $ab2caaed88da1d7c$export$71ad59f2e432cfe8) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
}
function $f708a927327be8d0$export$76a88f7de6507443(element) {
    switch(element.type){
        case 0, $ab2caaed88da1d7c$export$aa3a2e812ca8570d:
            element.props = element.props.map(function(value) {
                return (0, $f440b47df9b89d27$export$1be1fc439b849fdf)((0, $02641fb936e9e0af$export$660b2ee2d4fb4eff)(value), function(value, index, children) {
                    switch((0, $f440b47df9b89d27$export$a9db5e087081082d)(value, 0)){
                        // \f
                        case 12:
                            return (0, $f440b47df9b89d27$export$2f35ab04d2335697)(value, 1, (0, $f440b47df9b89d27$export$36776f635604f274)(value));
                        // \0 ( + > ~
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return value;
                        // :
                        case 58:
                            if (children[++index] === 'global') children[index] = '', children[++index] = '\f' + (0, $f440b47df9b89d27$export$2f35ab04d2335697)(children[index], index = 1, -1);
                        // \s
                        case 32:
                            return index === 1 ? '' : value;
                        default:
                            switch(index){
                                case 0:
                                    element = value;
                                    return (0, $f440b47df9b89d27$export$f9084667e487ed46)(children) > 1 ? '' : value;
                                case index = (0, $f440b47df9b89d27$export$f9084667e487ed46)(children) - 1:
                                case 2:
                                    return index === 2 ? value + element + element : value + element;
                                default:
                                    return value;
                            }
                    }
                });
            });
    }
}


var $ee91aa5afa82e349$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};


function $c5e7e751a75c9674$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $a2c3ce2d1937b0cd$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $02641fb936e9e0af$export$4d3fb11e950abb9e)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $02641fb936e9e0af$export$9e1725a4cfeada27)(character)) break;
        (0, $02641fb936e9e0af$export$48cfd1e771a65c4f)();
    }
    return (0, $02641fb936e9e0af$export$58adb3bec8346d0f)(begin, (0, $02641fb936e9e0af$export$5880b8b5730aff45));
};
var $a2c3ce2d1937b0cd$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $02641fb936e9e0af$export$9e1725a4cfeada27)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $02641fb936e9e0af$export$4d3fb11e950abb9e)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $a2c3ce2d1937b0cd$var$identifierWithPointTracking((0, $02641fb936e9e0af$export$5880b8b5730aff45) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $02641fb936e9e0af$export$410ac95b9ec204b8)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $02641fb936e9e0af$export$4d3fb11e950abb9e)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $f440b47df9b89d27$export$6788812c4e6611e6)(character);
    }
    while (character = (0, $02641fb936e9e0af$export$48cfd1e771a65c4f)());
    return parsed;
};
var $a2c3ce2d1937b0cd$var$getRules = function getRules(value, points) {
    return (0, $02641fb936e9e0af$export$45918ac1574455b1)($a2c3ce2d1937b0cd$var$toRules((0, $02641fb936e9e0af$export$2de70f21292aac9e)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $a2c3ce2d1937b0cd$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $a2c3ce2d1937b0cd$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$a2c3ce2d1937b0cd$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $a2c3ce2d1937b0cd$var$fixedElements.set(element, true);
    var points = [];
    var rules = $a2c3ce2d1937b0cd$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $a2c3ce2d1937b0cd$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $a2c3ce2d1937b0cd$var$prefix(value, length) {
    switch((0, $f440b47df9b89d27$export$d6af199866bfb566)(value, length)){
        // color-adjust
        case 5103:
            return (0, $ab2caaed88da1d7c$export$39dfd62a25e0fe93) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $ab2caaed88da1d7c$export$39dfd62a25e0fe93) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $ab2caaed88da1d7c$export$39dfd62a25e0fe93) + value + (0, $ab2caaed88da1d7c$export$2c0f367103c8d01c) + value + (0, $ab2caaed88da1d7c$export$71ad59f2e432cfe8) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $ab2caaed88da1d7c$export$39dfd62a25e0fe93) + value + (0, $ab2caaed88da1d7c$export$71ad59f2e432cfe8) + value + value;
        // order
        case 6165:
            return (0, $ab2caaed88da1d7c$export$39dfd62a25e0fe93) + value + (0, $ab2caaed88da1d7c$export$71ad59f2e432cfe8) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $ab2caaed88da1d7c$export$39dfd62a25e0fe93) + value + (0, $f440b47df9b89d27$export$77ad94ebf1c2b9ed)(value, /(\w+).+(:[^]+)/, (0, $ab2caaed88da1d7c$export$39dfd62a25e0fe93) + 'box-$1$2' + (0, $ab2caaed88da1d7c$export$71ad59f2e432cfe8) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $ab2caaed88da1d7c$export$39dfd62a25e0fe93) + value + (0, $ab2caaed88da1d7c$export$71ad59f2e432cfe8) + 'flex-item-' + (0, $f440b47df9b89d27$export$77ad94ebf1c2b9ed)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $ab2caaed88da1d7c$export$39dfd62a25e0fe93) + value + (0, $ab2caaed88da1d7c$export$71ad59f2e432cfe8) + 'flex-line-pack' + (0, $f440b47df9b89d27$export$77ad94ebf1c2b9ed)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $ab2caaed88da1d7c$export$39dfd62a25e0fe93) + value + (0, $ab2caaed88da1d7c$export$71ad59f2e432cfe8) + (0, $f440b47df9b89d27$export$77ad94ebf1c2b9ed)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $ab2caaed88da1d7c$export$39dfd62a25e0fe93) + value + (0, $ab2caaed88da1d7c$export$71ad59f2e432cfe8) + (0, $f440b47df9b89d27$export$77ad94ebf1c2b9ed)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $ab2caaed88da1d7c$export$39dfd62a25e0fe93) + 'box-' + (0, $f440b47df9b89d27$export$77ad94ebf1c2b9ed)(value, '-grow', '') + (0, $ab2caaed88da1d7c$export$39dfd62a25e0fe93) + value + (0, $ab2caaed88da1d7c$export$71ad59f2e432cfe8) + (0, $f440b47df9b89d27$export$77ad94ebf1c2b9ed)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $ab2caaed88da1d7c$export$39dfd62a25e0fe93) + (0, $f440b47df9b89d27$export$77ad94ebf1c2b9ed)(value, /([^-])(transform)/g, '$1' + (0, $ab2caaed88da1d7c$export$39dfd62a25e0fe93) + '$2') + value;
        // cursor
        case 6187:
            return (0, $f440b47df9b89d27$export$77ad94ebf1c2b9ed)((0, $f440b47df9b89d27$export$77ad94ebf1c2b9ed)((0, $f440b47df9b89d27$export$77ad94ebf1c2b9ed)(value, /(zoom-|grab)/, (0, $ab2caaed88da1d7c$export$39dfd62a25e0fe93) + '$1'), /(image-set)/, (0, $ab2caaed88da1d7c$export$39dfd62a25e0fe93) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $f440b47df9b89d27$export$77ad94ebf1c2b9ed)(value, /(image-set\([^]*)/, (0, $ab2caaed88da1d7c$export$39dfd62a25e0fe93) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $f440b47df9b89d27$export$77ad94ebf1c2b9ed)((0, $f440b47df9b89d27$export$77ad94ebf1c2b9ed)(value, /(.+:)(flex-)?(.*)/, (0, $ab2caaed88da1d7c$export$39dfd62a25e0fe93) + 'box-pack:$3' + (0, $ab2caaed88da1d7c$export$71ad59f2e432cfe8) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $ab2caaed88da1d7c$export$39dfd62a25e0fe93) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $f440b47df9b89d27$export$77ad94ebf1c2b9ed)(value, /(.+)-inline(.+)/, (0, $ab2caaed88da1d7c$export$39dfd62a25e0fe93) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $f440b47df9b89d27$export$36776f635604f274)(value) - 1 - length > 6) switch((0, $f440b47df9b89d27$export$a9db5e087081082d)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $f440b47df9b89d27$export$a9db5e087081082d)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $f440b47df9b89d27$export$77ad94ebf1c2b9ed)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $ab2caaed88da1d7c$export$39dfd62a25e0fe93) + '$2-$3' + '$1' + (0, $ab2caaed88da1d7c$export$2c0f367103c8d01c) + ((0, $f440b47df9b89d27$export$a9db5e087081082d)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $f440b47df9b89d27$export$f8e21b1e77979a08)(value, 'stretch') ? $a2c3ce2d1937b0cd$var$prefix((0, $f440b47df9b89d27$export$77ad94ebf1c2b9ed)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $f440b47df9b89d27$export$a9db5e087081082d)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $f440b47df9b89d27$export$a9db5e087081082d)(value, (0, $f440b47df9b89d27$export$36776f635604f274)(value) - 3 - (~(0, $f440b47df9b89d27$export$f8e21b1e77979a08)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $f440b47df9b89d27$export$77ad94ebf1c2b9ed)(value, ':', ':' + (0, $ab2caaed88da1d7c$export$39dfd62a25e0fe93)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $f440b47df9b89d27$export$77ad94ebf1c2b9ed)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $ab2caaed88da1d7c$export$39dfd62a25e0fe93) + ((0, $f440b47df9b89d27$export$a9db5e087081082d)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $ab2caaed88da1d7c$export$39dfd62a25e0fe93) + '$2$3' + '$1' + (0, $ab2caaed88da1d7c$export$71ad59f2e432cfe8) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $f440b47df9b89d27$export$a9db5e087081082d)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $ab2caaed88da1d7c$export$39dfd62a25e0fe93) + value + (0, $ab2caaed88da1d7c$export$71ad59f2e432cfe8) + (0, $f440b47df9b89d27$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $ab2caaed88da1d7c$export$39dfd62a25e0fe93) + value + (0, $ab2caaed88da1d7c$export$71ad59f2e432cfe8) + (0, $f440b47df9b89d27$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $ab2caaed88da1d7c$export$39dfd62a25e0fe93) + value + (0, $ab2caaed88da1d7c$export$71ad59f2e432cfe8) + (0, $f440b47df9b89d27$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $ab2caaed88da1d7c$export$39dfd62a25e0fe93) + value + (0, $ab2caaed88da1d7c$export$71ad59f2e432cfe8) + value + value;
    }
    return value;
}
var $a2c3ce2d1937b0cd$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $ab2caaed88da1d7c$export$527d108ccf083c2b:
                element["return"] = $a2c3ce2d1937b0cd$var$prefix(element.value, element.length);
                break;
            case 0, $ab2caaed88da1d7c$export$b44a8529a35fcb60:
                return (0, $acf764232e4cc723$export$dfdc1655ccc5b9cb)([
                    (0, $02641fb936e9e0af$export$784d13d8ee351f07)(element, {
                        value: (0, $f440b47df9b89d27$export$77ad94ebf1c2b9ed)(element.value, '@', '@' + (0, $ab2caaed88da1d7c$export$39dfd62a25e0fe93))
                    })
                ], callback);
            case 0, $ab2caaed88da1d7c$export$aa3a2e812ca8570d:
                if (element.length) return (0, $f440b47df9b89d27$export$1be1fc439b849fdf)(element.props, function(value) {
                    switch((0, $f440b47df9b89d27$export$4659b591c19bdf3d)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $acf764232e4cc723$export$dfdc1655ccc5b9cb)([
                                (0, $02641fb936e9e0af$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $f440b47df9b89d27$export$77ad94ebf1c2b9ed)(value, /:(read-\w+)/, ':' + (0, $ab2caaed88da1d7c$export$2c0f367103c8d01c) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $acf764232e4cc723$export$dfdc1655ccc5b9cb)([
                                (0, $02641fb936e9e0af$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $f440b47df9b89d27$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $ab2caaed88da1d7c$export$39dfd62a25e0fe93) + 'input-$1')
                                    ]
                                }),
                                (0, $02641fb936e9e0af$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $f440b47df9b89d27$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $ab2caaed88da1d7c$export$2c0f367103c8d01c) + '$1')
                                    ]
                                }),
                                (0, $02641fb936e9e0af$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $f440b47df9b89d27$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, (0, $ab2caaed88da1d7c$export$71ad59f2e432cfe8) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $a2c3ce2d1937b0cd$var$defaultStylisPlugins = [
    $a2c3ce2d1937b0cd$var$prefixer
];
var $a2c3ce2d1937b0cd$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if (key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $a2c3ce2d1937b0cd$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
        var attrib = node.getAttribute("data-emotion").split(' ');
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $a2c3ce2d1937b0cd$var$compat,
        $a2c3ce2d1937b0cd$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $acf764232e4cc723$export$fac44ee5b035f737),
        (0, $f708a927327be8d0$export$38bcb760f1d4871c)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $f708a927327be8d0$export$5a7767152ae0305f)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $acf764232e4cc723$export$dfdc1655ccc5b9cb)((0, $a3fb0592d93b5ebd$export$ef7acd7185315e22)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $86343868ad58ebd9$export$9d753cd7ae895cce)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};





var $j8Bf6 = parcelRequire("j8Bf6");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $de3305c547a0c400$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($j8Bf6)))(targetComponent, sourceComponent);
};


var $bab85c04ce1ab715$var$isBrowser = true;
function $bab85c04ce1ab715$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $bab85c04ce1ab715$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $bab85c04ce1ab715$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $bab85c04ce1ab715$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $bab85c04ce1ab715$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};


/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $47965a6342ae9429$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}


var $28d7c88e62c97f40$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};



var $75b61c9548bf65c5$var$isDevelopment = false;
var $75b61c9548bf65c5$var$hyphenateRegex = /[A-Z]|^ms/g;
var $75b61c9548bf65c5$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $75b61c9548bf65c5$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $75b61c9548bf65c5$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $75b61c9548bf65c5$var$processStyleName = /* #__PURE__ */ (0, $c5e7e751a75c9674$export$2e2bcd8739ae039)(function(styleName) {
    return $75b61c9548bf65c5$var$isCustomProperty(styleName) ? styleName : styleName.replace($75b61c9548bf65c5$var$hyphenateRegex, '-$&').toLowerCase();
});
var $75b61c9548bf65c5$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($75b61c9548bf65c5$var$animationRegex, function(match, p1, p2) {
                $75b61c9548bf65c5$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $75b61c9548bf65c5$var$cursor
                };
                return p1;
            });
    }
    if ((0, $28d7c88e62c97f40$export$2e2bcd8739ae039)[key] !== 1 && !$75b61c9548bf65c5$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $75b61c9548bf65c5$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $75b61c9548bf65c5$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $75b61c9548bf65c5$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $75b61c9548bf65c5$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $75b61c9548bf65c5$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $75b61c9548bf65c5$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $75b61c9548bf65c5$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $75b61c9548bf65c5$var$cursor;
                var result = interpolation(mergedProps);
                $75b61c9548bf65c5$var$cursor = previousCursor;
                return $75b61c9548bf65c5$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $75b61c9548bf65c5$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $75b61c9548bf65c5$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($75b61c9548bf65c5$var$isProcessableValue(asString)) string += $75b61c9548bf65c5$var$processStyleName(key) + ":" + $75b61c9548bf65c5$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $75b61c9548bf65c5$var$isDevelopment) throw new Error($75b61c9548bf65c5$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($75b61c9548bf65c5$var$isProcessableValue(value[_i])) string += $75b61c9548bf65c5$var$processStyleName(key) + ":" + $75b61c9548bf65c5$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $75b61c9548bf65c5$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $75b61c9548bf65c5$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $75b61c9548bf65c5$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $75b61c9548bf65c5$var$cursor;
function $75b61c9548bf65c5$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $75b61c9548bf65c5$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $75b61c9548bf65c5$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $75b61c9548bf65c5$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $75b61c9548bf65c5$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $75b61c9548bf65c5$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $47965a6342ae9429$export$2e2bcd8739ae039)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $75b61c9548bf65c5$var$cursor
    };
}



var $kc00y = parcelRequire("kc00y");
var $a99c2c9549e4a8fd$var$syncFallback = function syncFallback(create) {
    return create();
};
var $a99c2c9549e4a8fd$var$useInsertionEffect = $kc00y.useInsertionEffect ? $kc00y.useInsertionEffect : false;
var $a99c2c9549e4a8fd$export$db21c7ffa21794e7 = $a99c2c9549e4a8fd$var$useInsertionEffect || $a99c2c9549e4a8fd$var$syncFallback;
var $a99c2c9549e4a8fd$export$811a713a7276cb9d = $a99c2c9549e4a8fd$var$useInsertionEffect || $kc00y.useLayoutEffect;


var $c3711714c7fb2f16$export$23f2a1d2818174ef = false;
var $c3711714c7fb2f16$var$EmotionCacheContext = /* #__PURE__ */ $kc00y.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $a2c3ce2d1937b0cd$export$2e2bcd8739ae039)({
    key: 'css'
}) : null);
var $c3711714c7fb2f16$export$e7094788287c5e9b = $c3711714c7fb2f16$var$EmotionCacheContext.Provider;
var $c3711714c7fb2f16$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $kc00y.useContext)($c3711714c7fb2f16$var$EmotionCacheContext);
};
var $c3711714c7fb2f16$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return /*#__PURE__*/ (0, $kc00y.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $kc00y.useContext)($c3711714c7fb2f16$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
var $c3711714c7fb2f16$export$971d5caa766a69d7 = /* #__PURE__ */ $kc00y.createContext({});
var $c3711714c7fb2f16$export$3b14a55fb2447963 = function useTheme() {
    return $kc00y.useContext($c3711714c7fb2f16$export$971d5caa766a69d7);
};
var $c3711714c7fb2f16$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $93c14b0a090563ae$export$2e2bcd8739ae039)({}, outerTheme, theme);
};
var $c3711714c7fb2f16$var$createCacheWithTheme = /* #__PURE__ */ (0, $ee91aa5afa82e349$export$2e2bcd8739ae039)(function(outerTheme) {
    return (0, $ee91aa5afa82e349$export$2e2bcd8739ae039)(function(theme) {
        return $c3711714c7fb2f16$var$getTheme(outerTheme, theme);
    });
});
var $c3711714c7fb2f16$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = $kc00y.useContext($c3711714c7fb2f16$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $c3711714c7fb2f16$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $kc00y.createElement($c3711714c7fb2f16$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $c3711714c7fb2f16$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var WithTheme = /*#__PURE__*/ $kc00y.forwardRef(function render(props, ref) {
        var theme = $kc00y.useContext($c3711714c7fb2f16$export$971d5caa766a69d7);
        return /*#__PURE__*/ $kc00y.createElement(Component, (0, $93c14b0a090563ae$export$2e2bcd8739ae039)({
            theme: theme,
            ref: ref
        }, props));
    });
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $de3305c547a0c400$export$2e2bcd8739ae039)(WithTheme, Component);
}
var $c3711714c7fb2f16$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $c3711714c7fb2f16$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $c3711714c7fb2f16$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var _key in props)if ($c3711714c7fb2f16$export$dda1d9f60106f0e9.call(props, _key)) newProps[_key] = props[_key];
    newProps[$c3711714c7fb2f16$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $c3711714c7fb2f16$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $bab85c04ce1ab715$export$580009a5da2a8b4b)(cache, serialized, isStringTag);
    (0, $a99c2c9549e4a8fd$export$db21c7ffa21794e7)(function() {
        return (0, $bab85c04ce1ab715$export$6f077d94b33a01aa)(cache, serialized, isStringTag);
    });
    return null;
};
var $c3711714c7fb2f16$var$Emotion = /* #__PURE__ */ $c3711714c7fb2f16$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$c3711714c7fb2f16$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $bab85c04ce1ab715$export$95d99596f328fd52)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $75b61c9548bf65c5$export$6321afa313b251b5)(registeredStyles, undefined, $kc00y.useContext($c3711714c7fb2f16$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var _key2 in props)if ($c3711714c7fb2f16$export$dda1d9f60106f0e9.call(props, _key2) && _key2 !== 'css' && _key2 !== $c3711714c7fb2f16$var$typePropName && !$c3711714c7fb2f16$export$23f2a1d2818174ef) newProps[_key2] = props[_key2];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $kc00y.createElement($kc00y.Fragment, null, /*#__PURE__*/ $kc00y.createElement($c3711714c7fb2f16$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $kc00y.createElement(WrappedComponent, newProps));
});
var $c3711714c7fb2f16$export$a9c23c6ac3fc3eca = $c3711714c7fb2f16$var$Emotion;



var $kc00y = parcelRequire("kc00y");







parcelRequire("j8Bf6");
var $61ec135b17ced9bd$export$c8a8987d4410bf2d = function jsx(type, props) {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments;
    if (props == null || !(0, $c3711714c7fb2f16$export$dda1d9f60106f0e9).call(props, 'css')) return $kc00y.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $c3711714c7fb2f16$export$a9c23c6ac3fc3eca);
    createElementArgArray[1] = (0, $c3711714c7fb2f16$export$db3b6bfb95261072)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $kc00y.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
    var JSX;
    JSX || (JSX = _jsx.JSX || (_jsx.JSX = {}));
})($61ec135b17ced9bd$export$c8a8987d4410bf2d || ($61ec135b17ced9bd$export$c8a8987d4410bf2d = {}));
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $61ec135b17ced9bd$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $c3711714c7fb2f16$export$efccba1c4a2ef57b)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $75b61c9548bf65c5$export$6321afa313b251b5)([
        styles
    ], undefined, $kc00y.useContext((0, $c3711714c7fb2f16$export$971d5caa766a69d7)));
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $kc00y.useRef();
    (0, $a99c2c9549e4a8fd$export$811a713a7276cb9d)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $a99c2c9549e4a8fd$export$811a713a7276cb9d)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $bab85c04ce1ab715$export$6f077d94b33a01aa)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $61ec135b17ced9bd$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $75b61c9548bf65c5$export$6321afa313b251b5)(args);
}
function $61ec135b17ced9bd$export$d25ddfdf17c3ad3e() {
    var insertable = $61ec135b17ced9bd$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
}
var $61ec135b17ced9bd$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $61ec135b17ced9bd$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $bab85c04ce1ab715$export$95d99596f328fd52)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $61ec135b17ced9bd$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, $a99c2c9549e4a8fd$export$db21c7ffa21794e7)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, $bab85c04ce1ab715$export$6f077d94b33a01aa)(cache, serializedArr[i], false);
    });
    return null;
};
var $61ec135b17ced9bd$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $c3711714c7fb2f16$export$efccba1c4a2ef57b)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $c3711714c7fb2f16$export$23f2a1d2818174ef)) throw new Error('css can only be used during render');
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $75b61c9548bf65c5$export$6321afa313b251b5)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $bab85c04ce1ab715$export$580009a5da2a8b4b)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $c3711714c7fb2f16$export$23f2a1d2818174ef)) throw new Error('cx can only be used during render');
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $61ec135b17ced9bd$var$merge(cache.registered, css, $61ec135b17ced9bd$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $kc00y.useContext((0, $c3711714c7fb2f16$export$971d5caa766a69d7))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $kc00y.createElement($kc00y.Fragment, null, /*#__PURE__*/ $kc00y.createElement($61ec135b17ced9bd$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});





function $45d0570c5a25fbbe$export$2e2bcd8739ae039(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}




var $kc00y = parcelRequire("kc00y");

/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $6c97b354b9b30c70$export$832b6fa47fa053d2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $6c97b354b9b30c70$export$27b07d8a310ed8b5 = [
    'start',
    'end'
];
const $6c97b354b9b30c70$export$803cd8101b6c182b = /*#__PURE__*/ $6c97b354b9b30c70$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $6c97b354b9b30c70$export$27b07d8a310ed8b5[0], side + "-" + $6c97b354b9b30c70$export$27b07d8a310ed8b5[1]), []);
const $6c97b354b9b30c70$export$96ec731ed4dcb222 = Math.min;
const $6c97b354b9b30c70$export$8960430cfd85939f = Math.max;
const $6c97b354b9b30c70$export$2077e0241d6afd3c = Math.round;
const $6c97b354b9b30c70$export$a3fe094919f356fd = Math.floor;
const $6c97b354b9b30c70$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $6c97b354b9b30c70$var$oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $6c97b354b9b30c70$export$7d15b64cf5a3a4c4(start, value, end) {
    return $6c97b354b9b30c70$export$8960430cfd85939f(start, $6c97b354b9b30c70$export$96ec731ed4dcb222(value, end));
}
function $6c97b354b9b30c70$export$fef61f332f2c0afc(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function $6c97b354b9b30c70$export$3c915306cb7fc97a(placement) {
    return placement.split('-')[0];
}
function $6c97b354b9b30c70$export$f0989780f32bfcda(placement) {
    return placement.split('-')[1];
}
function $6c97b354b9b30c70$export$8a000a963141ac32(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function $6c97b354b9b30c70$export$320bd9d53520c68a(axis) {
    return axis === 'y' ? 'height' : 'width';
}
function $6c97b354b9b30c70$export$f28e8f882010718a(placement) {
    const firstChar = placement[0];
    return firstChar === 't' || firstChar === 'b' ? 'y' : 'x';
}
function $6c97b354b9b30c70$export$2b57e0052a6d6d4c(placement) {
    return $6c97b354b9b30c70$export$8a000a963141ac32($6c97b354b9b30c70$export$f28e8f882010718a(placement));
}
function $6c97b354b9b30c70$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $6c97b354b9b30c70$export$f0989780f32bfcda(placement);
    const alignmentAxis = $6c97b354b9b30c70$export$2b57e0052a6d6d4c(placement);
    const length = $6c97b354b9b30c70$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $6c97b354b9b30c70$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $6c97b354b9b30c70$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $6c97b354b9b30c70$export$496432a3699e50b1(placement) {
    const oppositePlacement = $6c97b354b9b30c70$export$9c5e28bad23365fa(placement);
    return [
        $6c97b354b9b30c70$export$2b182c584985588b(placement),
        oppositePlacement,
        $6c97b354b9b30c70$export$2b182c584985588b(oppositePlacement)
    ];
}
function $6c97b354b9b30c70$export$2b182c584985588b(placement) {
    return placement.includes('start') ? placement.replace('start', 'end') : placement.replace('end', 'start');
}
const $6c97b354b9b30c70$var$lrPlacement = [
    'left',
    'right'
];
const $6c97b354b9b30c70$var$rlPlacement = [
    'right',
    'left'
];
const $6c97b354b9b30c70$var$tbPlacement = [
    'top',
    'bottom'
];
const $6c97b354b9b30c70$var$btPlacement = [
    'bottom',
    'top'
];
function $6c97b354b9b30c70$var$getSideList(side, isStart, rtl) {
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? $6c97b354b9b30c70$var$rlPlacement : $6c97b354b9b30c70$var$lrPlacement;
            return isStart ? $6c97b354b9b30c70$var$lrPlacement : $6c97b354b9b30c70$var$rlPlacement;
        case 'left':
        case 'right':
            return isStart ? $6c97b354b9b30c70$var$tbPlacement : $6c97b354b9b30c70$var$btPlacement;
        default:
            return [];
    }
}
function $6c97b354b9b30c70$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $6c97b354b9b30c70$export$f0989780f32bfcda(placement);
    let list = $6c97b354b9b30c70$var$getSideList($6c97b354b9b30c70$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($6c97b354b9b30c70$export$2b182c584985588b));
    }
    return list;
}
function $6c97b354b9b30c70$export$9c5e28bad23365fa(placement) {
    const side = $6c97b354b9b30c70$export$3c915306cb7fc97a(placement);
    return $6c97b354b9b30c70$var$oppositeSideMap[side] + placement.slice(side.length);
}
function $6c97b354b9b30c70$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $6c97b354b9b30c70$export$598c291c29bc2e71(padding) {
    return typeof padding !== 'number' ? $6c97b354b9b30c70$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $6c97b354b9b30c70$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}


function $029d4f444dd339f5$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $6c97b354b9b30c70$export$f28e8f882010718a)(placement);
    const alignmentAxis = (0, $6c97b354b9b30c70$export$2b57e0052a6d6d4c)(placement);
    const alignLength = (0, $6c97b354b9b30c70$export$320bd9d53520c68a)(alignmentAxis);
    const side = (0, $6c97b354b9b30c70$export$3c915306cb7fc97a)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $6c97b354b9b30c70$export$f0989780f32bfcda)(placement)){
        case 'start':
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case 'end':
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $029d4f444dd339f5$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, $6c97b354b9b30c70$export$fef61f332f2c0afc)(options, state);
    const paddingObject = (0, $6c97b354b9b30c70$export$598c291c29bc2e71)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $6c97b354b9b30c70$export$ee05aea0aeecbad4)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === 'floating' ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $6c97b354b9b30c70$export$ee05aea0aeecbad4)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
// Maximum number of resets that can occur before bailing to avoid infinite reset loops.
const $029d4f444dd339f5$var$MAX_RESET_COUNT = 50;
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $029d4f444dd339f5$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
    const platformWithDetectOverflow = platform.detectOverflow ? platform : {
        ...platform,
        detectOverflow: $029d4f444dd339f5$export$37b6bde19b108ecc
    };
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $029d4f444dd339f5$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let resetCount = 0;
    const middlewareData = {};
    for(let i = 0; i < middleware.length; i++){
        const currentMiddleware = middleware[i];
        if (!currentMiddleware) continue;
        const { name: name, fn: fn } = currentMiddleware;
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platformWithDetectOverflow,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData[name] = {
            ...middlewareData[name],
            ...data
        };
        if (reset && resetCount < $029d4f444dd339f5$var$MAX_RESET_COUNT) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $029d4f444dd339f5$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $029d4f444dd339f5$export$f2120bbfa5450bd2 = (options)=>({
        name: 'arrow',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $6c97b354b9b30c70$export$fef61f332f2c0afc)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $6c97b354b9b30c70$export$598c291c29bc2e71)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $6c97b354b9b30c70$export$2b57e0052a6d6d4c)(placement);
            const length = (0, $6c97b354b9b30c70$export$320bd9d53520c68a)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $6c97b354b9b30c70$export$96ec731ed4dcb222)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $6c97b354b9b30c70$export$96ec731ed4dcb222)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $6c97b354b9b30c70$export$7d15b64cf5a3a4c4)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $6c97b354b9b30c70$export$f0989780f32bfcda)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $029d4f444dd339f5$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $6c97b354b9b30c70$export$f0989780f32bfcda)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $6c97b354b9b30c70$export$f0989780f32bfcda)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $6c97b354b9b30c70$export$3c915306cb7fc97a)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $6c97b354b9b30c70$export$f0989780f32bfcda)(placement) === alignment || (autoAlignment ? (0, $6c97b354b9b30c70$export$2b182c584985588b)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $029d4f444dd339f5$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $6c97b354b9b30c70$export$803cd8101b6c182b), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $6c97b354b9b30c70$export$fef61f332f2c0afc)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $6c97b354b9b30c70$export$803cd8101b6c182b) ? $029d4f444dd339f5$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $6c97b354b9b30c70$export$be42861551f17911)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $6c97b354b9b30c70$export$3c915306cb7fc97a)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $6c97b354b9b30c70$export$f0989780f32bfcda)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $6c97b354b9b30c70$export$f0989780f32bfcda)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $029d4f444dd339f5$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $6c97b354b9b30c70$export$fef61f332f2c0afc)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $6c97b354b9b30c70$export$3c915306cb7fc97a)(placement);
            const initialSideAxis = (0, $6c97b354b9b30c70$export$f28e8f882010718a)(initialPlacement);
            const isBasePlacement = (0, $6c97b354b9b30c70$export$3c915306cb7fc97a)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $6c97b354b9b30c70$export$9c5e28bad23365fa)(initialPlacement)
            ] : (0, $6c97b354b9b30c70$export$496432a3699e50b1)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $6c97b354b9b30c70$export$a9b6fb18fd92c3ec)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $6c97b354b9b30c70$export$be42861551f17911)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) {
                    const ignoreCrossAxisOverflow = checkCrossAxis === 'alignment' ? initialSideAxis !== (0, $6c97b354b9b30c70$export$f28e8f882010718a)(nextPlacement) : false;
                    if (!ignoreCrossAxisOverflow || // We leave the current main axis only if every placement on that axis
                    // overflows the main axis.
                    overflowsData.every((d)=>(0, $6c97b354b9b30c70$export$f28e8f882010718a)(d.placement) === initialSideAxis ? d.overflows[0] > 0 : true)) // Try next placement and re-run the lifecycle.
                    return {
                        data: {
                            index: nextIndex,
                            overflows: overflowsData
                        },
                        reset: {
                            placement: nextPlacement
                        }
                    };
                }
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $6c97b354b9b30c70$export$f28e8f882010718a)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === 'y';
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $029d4f444dd339f5$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $029d4f444dd339f5$var$isAnySideFullyClipped(overflow) {
    return (0, $6c97b354b9b30c70$export$832b6fa47fa053d2).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $029d4f444dd339f5$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options: options,
        async fn (state) {
            const { rects: rects, platform: platform } = state;
            const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, $6c97b354b9b30c70$export$fef61f332f2c0afc)(options, state);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await platform.detectOverflow(state, {
                            ...detectOverflowOptions,
                            elementContext: 'reference'
                        });
                        const offsets = $029d4f444dd339f5$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $029d4f444dd339f5$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await platform.detectOverflow(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $029d4f444dd339f5$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $029d4f444dd339f5$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $029d4f444dd339f5$var$getBoundingRect(rects) {
    const minX = (0, $6c97b354b9b30c70$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.left));
    const minY = (0, $6c97b354b9b30c70$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.top));
    const maxX = (0, $6c97b354b9b30c70$export$8960430cfd85939f)(...rects.map((rect)=>rect.right));
    const maxY = (0, $6c97b354b9b30c70$export$8960430cfd85939f)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $029d4f444dd339f5$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $6c97b354b9b30c70$export$ee05aea0aeecbad4)($029d4f444dd339f5$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $029d4f444dd339f5$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $6c97b354b9b30c70$export$fef61f332f2c0afc)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $029d4f444dd339f5$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $6c97b354b9b30c70$export$ee05aea0aeecbad4)($029d4f444dd339f5$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $6c97b354b9b30c70$export$598c291c29bc2e71)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $6c97b354b9b30c70$export$f28e8f882010718a)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $6c97b354b9b30c70$export$3c915306cb7fc97a)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $6c97b354b9b30c70$export$3c915306cb7fc97a)(placement) === 'left';
                    const maxRight = (0, $6c97b354b9b30c70$export$8960430cfd85939f)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $6c97b354b9b30c70$export$96ec731ed4dcb222)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
const $029d4f444dd339f5$var$originSides = /*#__PURE__*/ new Set([
    'left',
    'top'
]);
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $029d4f444dd339f5$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $6c97b354b9b30c70$export$3c915306cb7fc97a)(placement);
    const alignment = (0, $6c97b354b9b30c70$export$f0989780f32bfcda)(placement);
    const isVertical = (0, $6c97b354b9b30c70$export$f28e8f882010718a)(placement) === 'y';
    const mainAxisMulti = $029d4f444dd339f5$var$originSides.has(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $6c97b354b9b30c70$export$fef61f332f2c0afc)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $029d4f444dd339f5$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $029d4f444dd339f5$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $029d4f444dd339f5$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, platform: platform } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $6c97b354b9b30c70$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const crossAxis = (0, $6c97b354b9b30c70$export$f28e8f882010718a)((0, $6c97b354b9b30c70$export$3c915306cb7fc97a)(placement));
            const mainAxis = (0, $6c97b354b9b30c70$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === 'y' ? 'top' : 'left';
                const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $6c97b354b9b30c70$export$7d15b64cf5a3a4c4)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === 'y' ? 'top' : 'left';
                const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $6c97b354b9b30c70$export$7d15b64cf5a3a4c4)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $029d4f444dd339f5$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $6c97b354b9b30c70$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $6c97b354b9b30c70$export$f28e8f882010718a)(placement);
            const mainAxis = (0, $6c97b354b9b30c70$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $6c97b354b9b30c70$export$fef61f332f2c0afc)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = $029d4f444dd339f5$var$originSides.has((0, $6c97b354b9b30c70$export$3c915306cb7fc97a)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $029d4f444dd339f5$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $6c97b354b9b30c70$export$fef61f332f2c0afc)(options, state);
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const side = (0, $6c97b354b9b30c70$export$3c915306cb7fc97a)(placement);
            const alignment = (0, $6c97b354b9b30c70$export$f0989780f32bfcda)(placement);
            const isYAxis = (0, $6c97b354b9b30c70$export$f28e8f882010718a)(placement) === 'y';
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $6c97b354b9b30c70$export$96ec731ed4dcb222)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $6c97b354b9b30c70$export$96ec731ed4dcb222)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $6c97b354b9b30c70$export$8960430cfd85939f)(overflow.left, 0);
                const xMax = (0, $6c97b354b9b30c70$export$8960430cfd85939f)(overflow.right, 0);
                const yMin = (0, $6c97b354b9b30c70$export$8960430cfd85939f)(overflow.top, 0);
                const yMax = (0, $6c97b354b9b30c70$export$8960430cfd85939f)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $6c97b354b9b30c70$export$8960430cfd85939f)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $6c97b354b9b30c70$export$8960430cfd85939f)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};



function $bae5d0a6e8d19500$var$hasWindow() {
    return typeof window !== 'undefined';
}
function $bae5d0a6e8d19500$export$651544f548703224(node) {
    if ($bae5d0a6e8d19500$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function $bae5d0a6e8d19500$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $bae5d0a6e8d19500$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($bae5d0a6e8d19500$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $bae5d0a6e8d19500$export$8ee0fc9ee280b4ee(value) {
    if (!$bae5d0a6e8d19500$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $bae5d0a6e8d19500$export$38b2d434cce3ea22(value).Node;
}
function $bae5d0a6e8d19500$export$45a5e7f76e0caa8d(value) {
    if (!$bae5d0a6e8d19500$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $bae5d0a6e8d19500$export$38b2d434cce3ea22(value).Element;
}
function $bae5d0a6e8d19500$export$1b3bfaa9684536aa(value) {
    if (!$bae5d0a6e8d19500$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $bae5d0a6e8d19500$export$38b2d434cce3ea22(value).HTMLElement;
}
function $bae5d0a6e8d19500$export$af51f0f06c0f328a(value) {
    if (!$bae5d0a6e8d19500$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof $bae5d0a6e8d19500$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $bae5d0a6e8d19500$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $bae5d0a6e8d19500$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && display !== 'inline' && display !== 'contents';
}
function $bae5d0a6e8d19500$export$71535ffaa902797f(element) {
    return /^(table|td|th)$/.test($bae5d0a6e8d19500$export$651544f548703224(element));
}
function $bae5d0a6e8d19500$export$89e651af02346cd4(element) {
    try {
        if (element.matches(':popover-open')) return true;
    } catch (_e) {
    // no-op
    }
    try {
        return element.matches(':modal');
    } catch (_e) {
        return false;
    }
}
const $bae5d0a6e8d19500$var$willChangeRe = /transform|translate|scale|rotate|perspective|filter/;
const $bae5d0a6e8d19500$var$containRe = /paint|layout|strict|content/;
const $bae5d0a6e8d19500$var$isNotNone = (value)=>!!value && value !== 'none';
let $bae5d0a6e8d19500$var$isWebKitValue;
function $bae5d0a6e8d19500$export$d6c4e8150c35fed1(elementOrCss) {
    const css = $bae5d0a6e8d19500$export$45a5e7f76e0caa8d(elementOrCss) ? $bae5d0a6e8d19500$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    // https://drafts.csswg.org/css-transforms-2/#individual-transforms
    return $bae5d0a6e8d19500$var$isNotNone(css.transform) || $bae5d0a6e8d19500$var$isNotNone(css.translate) || $bae5d0a6e8d19500$var$isNotNone(css.scale) || $bae5d0a6e8d19500$var$isNotNone(css.rotate) || $bae5d0a6e8d19500$var$isNotNone(css.perspective) || !$bae5d0a6e8d19500$export$78551043582a6a98() && ($bae5d0a6e8d19500$var$isNotNone(css.backdropFilter) || $bae5d0a6e8d19500$var$isNotNone(css.filter)) || $bae5d0a6e8d19500$var$willChangeRe.test(css.willChange || '') || $bae5d0a6e8d19500$var$containRe.test(css.contain || '');
}
function $bae5d0a6e8d19500$export$940d8225183e1404(element) {
    let currentNode = $bae5d0a6e8d19500$export$4e12058fc4d51d56(element);
    while($bae5d0a6e8d19500$export$1b3bfaa9684536aa(currentNode) && !$bae5d0a6e8d19500$export$d1162fb0b6d4cd51(currentNode)){
        if ($bae5d0a6e8d19500$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($bae5d0a6e8d19500$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $bae5d0a6e8d19500$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $bae5d0a6e8d19500$export$78551043582a6a98() {
    if ($bae5d0a6e8d19500$var$isWebKitValue == null) $bae5d0a6e8d19500$var$isWebKitValue = typeof CSS !== 'undefined' && CSS.supports && CSS.supports('-webkit-backdrop-filter', 'none');
    return $bae5d0a6e8d19500$var$isWebKitValue;
}
function $bae5d0a6e8d19500$export$d1162fb0b6d4cd51(node) {
    return /^(html|body|#document)$/.test($bae5d0a6e8d19500$export$651544f548703224(node));
}
function $bae5d0a6e8d19500$export$3735103072e4a80(element) {
    return $bae5d0a6e8d19500$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $bae5d0a6e8d19500$export$dc8fc79fa2800137(element) {
    if ($bae5d0a6e8d19500$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $bae5d0a6e8d19500$export$4e12058fc4d51d56(node) {
    if ($bae5d0a6e8d19500$export$651544f548703224(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $bae5d0a6e8d19500$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $bae5d0a6e8d19500$export$e495491855dc5418(node);
    return $bae5d0a6e8d19500$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $bae5d0a6e8d19500$export$7cd01a57c8ca906c(node) {
    const parentNode = $bae5d0a6e8d19500$export$4e12058fc4d51d56(node);
    if ($bae5d0a6e8d19500$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($bae5d0a6e8d19500$export$1b3bfaa9684536aa(parentNode) && $bae5d0a6e8d19500$export$989e911fa9af580a(parentNode)) return parentNode;
    return $bae5d0a6e8d19500$export$7cd01a57c8ca906c(parentNode);
}
function $bae5d0a6e8d19500$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $bae5d0a6e8d19500$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $bae5d0a6e8d19500$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $bae5d0a6e8d19500$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $bae5d0a6e8d19500$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $bae5d0a6e8d19500$export$3b57c1601291186b(frameElement) : []);
    } else return list.concat(scrollableAncestor, $bae5d0a6e8d19500$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $bae5d0a6e8d19500$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}


function $d8c489c11b48936b$var$getCssDimensions(element) {
    const css = (0, $bae5d0a6e8d19500$export$3735103072e4a80)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $bae5d0a6e8d19500$export$1b3bfaa9684536aa)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $6c97b354b9b30c70$export$2077e0241d6afd3c)(width) !== offsetWidth || (0, $6c97b354b9b30c70$export$2077e0241d6afd3c)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $d8c489c11b48936b$var$unwrapElement(element) {
    return !(0, $bae5d0a6e8d19500$export$45a5e7f76e0caa8d)(element) ? element.contextElement : element;
}
function $d8c489c11b48936b$var$getScale(element) {
    const domElement = $d8c489c11b48936b$var$unwrapElement(element);
    if (!(0, $bae5d0a6e8d19500$export$1b3bfaa9684536aa)(domElement)) return (0, $6c97b354b9b30c70$export$a397704b5e280835)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $d8c489c11b48936b$var$getCssDimensions(domElement);
    let x = ($ ? (0, $6c97b354b9b30c70$export$2077e0241d6afd3c)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $6c97b354b9b30c70$export$2077e0241d6afd3c)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $d8c489c11b48936b$var$noOffsets = /*#__PURE__*/ (0, $6c97b354b9b30c70$export$a397704b5e280835)(0);
function $d8c489c11b48936b$var$getVisualOffsets(element) {
    const win = (0, $bae5d0a6e8d19500$export$38b2d434cce3ea22)(element);
    if (!(0, $bae5d0a6e8d19500$export$78551043582a6a98)() || !win.visualViewport) return $d8c489c11b48936b$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $d8c489c11b48936b$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $bae5d0a6e8d19500$export$38b2d434cce3ea22)(element)) return false;
    return isFixed;
}
function $d8c489c11b48936b$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $d8c489c11b48936b$var$unwrapElement(element);
    let scale = (0, $6c97b354b9b30c70$export$a397704b5e280835)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $bae5d0a6e8d19500$export$45a5e7f76e0caa8d)(offsetParent)) scale = $d8c489c11b48936b$var$getScale(offsetParent);
        } else scale = $d8c489c11b48936b$var$getScale(element);
    }
    const visualOffsets = $d8c489c11b48936b$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $d8c489c11b48936b$var$getVisualOffsets(domElement) : (0, $6c97b354b9b30c70$export$a397704b5e280835)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $bae5d0a6e8d19500$export$38b2d434cce3ea22)(domElement);
        const offsetWin = offsetParent && (0, $bae5d0a6e8d19500$export$45a5e7f76e0caa8d)(offsetParent) ? (0, $bae5d0a6e8d19500$export$38b2d434cce3ea22)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $bae5d0a6e8d19500$export$7bf1f8740e3e34af)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $d8c489c11b48936b$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $bae5d0a6e8d19500$export$3735103072e4a80)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $bae5d0a6e8d19500$export$38b2d434cce3ea22)(currentIFrame);
            currentIFrame = (0, $bae5d0a6e8d19500$export$7bf1f8740e3e34af)(currentWin);
        }
    }
    return (0, $6c97b354b9b30c70$export$ee05aea0aeecbad4)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $d8c489c11b48936b$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $bae5d0a6e8d19500$export$dc8fc79fa2800137)(element).scrollLeft;
    if (!rect) return $d8c489c11b48936b$var$getBoundingClientRect((0, $bae5d0a6e8d19500$export$e495491855dc5418)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function $d8c489c11b48936b$var$getHTMLOffset(documentElement, scroll) {
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - $d8c489c11b48936b$var$getWindowScrollBarX(documentElement, htmlRect);
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x: x,
        y: y
    };
}
function $d8c489c11b48936b$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, $bae5d0a6e8d19500$export$e495491855dc5418)(offsetParent);
    const topLayer = elements ? (0, $bae5d0a6e8d19500$export$89e651af02346cd4)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $6c97b354b9b30c70$export$a397704b5e280835)(1);
    const offsets = (0, $6c97b354b9b30c70$export$a397704b5e280835)(0);
    const isOffsetParentAnElement = (0, $bae5d0a6e8d19500$export$1b3bfaa9684536aa)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $bae5d0a6e8d19500$export$651544f548703224)(offsetParent) !== 'body' || (0, $bae5d0a6e8d19500$export$989e911fa9af580a)(documentElement)) scroll = (0, $bae5d0a6e8d19500$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $d8c489c11b48936b$var$getBoundingClientRect(offsetParent);
            scale = $d8c489c11b48936b$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $d8c489c11b48936b$var$getHTMLOffset(documentElement, scroll) : (0, $6c97b354b9b30c70$export$a397704b5e280835)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function $d8c489c11b48936b$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $d8c489c11b48936b$var$getDocumentRect(element) {
    const html = (0, $bae5d0a6e8d19500$export$e495491855dc5418)(element);
    const scroll = (0, $bae5d0a6e8d19500$export$dc8fc79fa2800137)(element);
    const body = element.ownerDocument.body;
    const width = (0, $6c97b354b9b30c70$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $6c97b354b9b30c70$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $d8c489c11b48936b$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $bae5d0a6e8d19500$export$3735103072e4a80)(body).direction === 'rtl') x += (0, $6c97b354b9b30c70$export$8960430cfd85939f)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Safety check: ensure the scrollbar space is reasonable in case this
// calculation is affected by unusual styles.
// Most scrollbars leave 15-18px of space.
const $d8c489c11b48936b$var$SCROLLBAR_MAX = 25;
function $d8c489c11b48936b$var$getViewportRect(element, strategy) {
    const win = (0, $bae5d0a6e8d19500$export$38b2d434cce3ea22)(element);
    const html = (0, $bae5d0a6e8d19500$export$e495491855dc5418)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $bae5d0a6e8d19500$export$78551043582a6a98)();
        if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    const windowScrollbarX = $d8c489c11b48936b$var$getWindowScrollBarX(html);
    // <html> `overflow: hidden` + `scrollbar-gutter: stable` reduces the
    // visual width of the <html> but this is not considered in the size
    // of `html.clientWidth`.
    if (windowScrollbarX <= 0) {
        const doc = html.ownerDocument;
        const body = doc.body;
        const bodyStyles = getComputedStyle(body);
        const bodyMarginInline = doc.compatMode === 'CSS1Compat' ? parseFloat(bodyStyles.marginLeft) + parseFloat(bodyStyles.marginRight) || 0 : 0;
        const clippingStableScrollbarWidth = Math.abs(html.clientWidth - body.clientWidth - bodyMarginInline);
        if (clippingStableScrollbarWidth <= $d8c489c11b48936b$var$SCROLLBAR_MAX) width -= clippingStableScrollbarWidth;
    } else if (windowScrollbarX <= $d8c489c11b48936b$var$SCROLLBAR_MAX) // If the <body> scrollbar is on the left, the width needs to be extended
    // by the scrollbar amount so there isn't extra space on the right.
    width += windowScrollbarX;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $d8c489c11b48936b$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $d8c489c11b48936b$var$getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $bae5d0a6e8d19500$export$1b3bfaa9684536aa)(element) ? $d8c489c11b48936b$var$getScale(element) : (0, $6c97b354b9b30c70$export$a397704b5e280835)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $d8c489c11b48936b$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport') rect = $d8c489c11b48936b$var$getViewportRect(element, strategy);
    else if (clippingAncestor === 'document') rect = $d8c489c11b48936b$var$getDocumentRect((0, $bae5d0a6e8d19500$export$e495491855dc5418)(element));
    else if ((0, $bae5d0a6e8d19500$export$45a5e7f76e0caa8d)(clippingAncestor)) rect = $d8c489c11b48936b$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $d8c489c11b48936b$var$getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, $6c97b354b9b30c70$export$ee05aea0aeecbad4)(rect);
}
function $d8c489c11b48936b$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $bae5d0a6e8d19500$export$4e12058fc4d51d56)(element);
    if (parentNode === stopNode || !(0, $bae5d0a6e8d19500$export$45a5e7f76e0caa8d)(parentNode) || (0, $bae5d0a6e8d19500$export$d1162fb0b6d4cd51)(parentNode)) return false;
    return (0, $bae5d0a6e8d19500$export$3735103072e4a80)(parentNode).position === 'fixed' || $d8c489c11b48936b$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $d8c489c11b48936b$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $bae5d0a6e8d19500$export$3b57c1601291186b)(element, [], false).filter((el)=>(0, $bae5d0a6e8d19500$export$45a5e7f76e0caa8d)(el) && (0, $bae5d0a6e8d19500$export$651544f548703224)(el) !== 'body');
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $bae5d0a6e8d19500$export$3735103072e4a80)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, $bae5d0a6e8d19500$export$4e12058fc4d51d56)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $bae5d0a6e8d19500$export$45a5e7f76e0caa8d)(currentNode) && !(0, $bae5d0a6e8d19500$export$d1162fb0b6d4cd51)(currentNode)){
        const computedStyle = (0, $bae5d0a6e8d19500$export$3735103072e4a80)(currentNode);
        const currentNodeIsContaining = (0, $bae5d0a6e8d19500$export$d6c4e8150c35fed1)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && (currentContainingBlockComputedStyle.position === 'absolute' || currentContainingBlockComputedStyle.position === 'fixed') || (0, $bae5d0a6e8d19500$export$989e911fa9af580a)(currentNode) && !currentNodeIsContaining && $d8c489c11b48936b$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $bae5d0a6e8d19500$export$4e12058fc4d51d56)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $d8c489c11b48936b$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, $bae5d0a6e8d19500$export$89e651af02346cd4)(element) ? [] : $d8c489c11b48936b$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstRect = $d8c489c11b48936b$var$getClientRectFromClippingAncestor(element, clippingAncestors[0], strategy);
    let top = firstRect.top;
    let right = firstRect.right;
    let bottom = firstRect.bottom;
    let left = firstRect.left;
    for(let i = 1; i < clippingAncestors.length; i++){
        const rect = $d8c489c11b48936b$var$getClientRectFromClippingAncestor(element, clippingAncestors[i], strategy);
        top = (0, $6c97b354b9b30c70$export$8960430cfd85939f)(rect.top, top);
        right = (0, $6c97b354b9b30c70$export$96ec731ed4dcb222)(rect.right, right);
        bottom = (0, $6c97b354b9b30c70$export$96ec731ed4dcb222)(rect.bottom, bottom);
        left = (0, $6c97b354b9b30c70$export$8960430cfd85939f)(rect.left, left);
    }
    return {
        width: right - left,
        height: bottom - top,
        x: left,
        y: top
    };
}
function $d8c489c11b48936b$var$getDimensions(element) {
    const { width: width, height: height } = $d8c489c11b48936b$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $d8c489c11b48936b$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $bae5d0a6e8d19500$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $bae5d0a6e8d19500$export$e495491855dc5418)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = $d8c489c11b48936b$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $6c97b354b9b30c70$export$a397704b5e280835)(0);
    // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
    // Firefox with layout.scrollbar.side = 3 in about:config to test this.
    function setLeftRTLScrollbarOffset() {
        offsets.x = $d8c489c11b48936b$var$getWindowScrollBarX(documentElement);
    }
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $bae5d0a6e8d19500$export$651544f548703224)(offsetParent) !== 'body' || (0, $bae5d0a6e8d19500$export$989e911fa9af580a)(documentElement)) scroll = (0, $bae5d0a6e8d19500$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $d8c489c11b48936b$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) setLeftRTLScrollbarOffset();
    }
    if (isFixed && !isOffsetParentAnElement && documentElement) setLeftRTLScrollbarOffset();
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $d8c489c11b48936b$var$getHTMLOffset(documentElement, scroll) : (0, $6c97b354b9b30c70$export$a397704b5e280835)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $d8c489c11b48936b$var$isStaticPositioned(element) {
    return (0, $bae5d0a6e8d19500$export$3735103072e4a80)(element).position === 'static';
}
function $d8c489c11b48936b$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $bae5d0a6e8d19500$export$1b3bfaa9684536aa)(element) || (0, $bae5d0a6e8d19500$export$3735103072e4a80)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $bae5d0a6e8d19500$export$e495491855dc5418)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $d8c489c11b48936b$var$getOffsetParent(element, polyfill) {
    const win = (0, $bae5d0a6e8d19500$export$38b2d434cce3ea22)(element);
    if ((0, $bae5d0a6e8d19500$export$89e651af02346cd4)(element)) return win;
    if (!(0, $bae5d0a6e8d19500$export$1b3bfaa9684536aa)(element)) {
        let svgOffsetParent = (0, $bae5d0a6e8d19500$export$4e12058fc4d51d56)(element);
        while(svgOffsetParent && !(0, $bae5d0a6e8d19500$export$d1162fb0b6d4cd51)(svgOffsetParent)){
            if ((0, $bae5d0a6e8d19500$export$45a5e7f76e0caa8d)(svgOffsetParent) && !$d8c489c11b48936b$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $bae5d0a6e8d19500$export$4e12058fc4d51d56)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $d8c489c11b48936b$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $bae5d0a6e8d19500$export$71535ffaa902797f)(offsetParent) && $d8c489c11b48936b$var$isStaticPositioned(offsetParent))offsetParent = $d8c489c11b48936b$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $bae5d0a6e8d19500$export$d1162fb0b6d4cd51)(offsetParent) && $d8c489c11b48936b$var$isStaticPositioned(offsetParent) && !(0, $bae5d0a6e8d19500$export$d6c4e8150c35fed1)(offsetParent)) return win;
    return offsetParent || (0, $bae5d0a6e8d19500$export$940d8225183e1404)(element) || win;
}
const $d8c489c11b48936b$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $d8c489c11b48936b$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $d8c489c11b48936b$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $d8c489c11b48936b$var$isRTL(element) {
    return (0, $bae5d0a6e8d19500$export$3735103072e4a80)(element).direction === 'rtl';
}
const $d8c489c11b48936b$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $d8c489c11b48936b$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $bae5d0a6e8d19500$export$e495491855dc5418,
    getClippingRect: $d8c489c11b48936b$var$getClippingRect,
    getOffsetParent: $d8c489c11b48936b$var$getOffsetParent,
    getElementRects: $d8c489c11b48936b$var$getElementRects,
    getClientRects: $d8c489c11b48936b$var$getClientRects,
    getDimensions: $d8c489c11b48936b$var$getDimensions,
    getScale: $d8c489c11b48936b$var$getScale,
    isElement: $bae5d0a6e8d19500$export$45a5e7f76e0caa8d,
    isRTL: $d8c489c11b48936b$var$isRTL
};
function $d8c489c11b48936b$var$rectsAreEqual(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
// https://samthor.au/2021/observing-dom/
function $d8c489c11b48936b$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $bae5d0a6e8d19500$export$e495491855dc5418)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const elementRectForRootMargin = element.getBoundingClientRect();
        const { left: left, top: top, width: width, height: height } = elementRectForRootMargin;
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $6c97b354b9b30c70$export$a3fe094919f356fd)(top);
        const insetRight = (0, $6c97b354b9b30c70$export$a3fe094919f356fd)(root.clientWidth - (left + width));
        const insetBottom = (0, $6c97b354b9b30c70$export$a3fe094919f356fd)(root.clientHeight - (top + height));
        const insetLeft = (0, $6c97b354b9b30c70$export$a3fe094919f356fd)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $6c97b354b9b30c70$export$8960430cfd85939f)(0, (0, $6c97b354b9b30c70$export$96ec731ed4dcb222)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            if (ratio === 1 && !$d8c489c11b48936b$var$rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) // It's possible that even though the ratio is reported as 1, the
            // element is not actually fully within the IntersectionObserver's root
            // area anymore. This can happen under performance constraints. This may
            // be a bug in the browser's IntersectionObserver implementation. To
            // work around this, we compare the element's bounding rect now with
            // what it was at the time we created the IntersectionObserver. If they
            // are not equal then the element moved, so we refresh.
            refresh();
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (_e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $d8c489c11b48936b$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
    const referenceEl = $d8c489c11b48936b$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $bae5d0a6e8d19500$export$3b57c1601291186b)(referenceEl) : [],
        ...floating ? (0, $bae5d0a6e8d19500$export$3b57c1601291186b)(floating) : []
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? $d8c489c11b48936b$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver && floating) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        if (floating) resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $d8c489c11b48936b$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $d8c489c11b48936b$var$getBoundingClientRect(reference);
        if (prevRefRect && !$d8c489c11b48936b$var$rectsAreEqual(prevRefRect, nextRefRect)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $d8c489c11b48936b$export$37b6bde19b108ecc = (0, $029d4f444dd339f5$export$37b6bde19b108ecc);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $d8c489c11b48936b$export$cc800923e997bb8 = (0, $029d4f444dd339f5$export$cc800923e997bb8);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $d8c489c11b48936b$export$91fb6ecbd551914 = (0, $029d4f444dd339f5$export$91fb6ecbd551914);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $d8c489c11b48936b$export$fba63a578e423eb = (0, $029d4f444dd339f5$export$fba63a578e423eb);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $d8c489c11b48936b$export$8a83211c878a3f1f = (0, $029d4f444dd339f5$export$8a83211c878a3f1f);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $d8c489c11b48936b$export$346677f925de839c = (0, $029d4f444dd339f5$export$346677f925de839c);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $d8c489c11b48936b$export$fe8985bb6374093c = (0, $029d4f444dd339f5$export$fe8985bb6374093c);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $d8c489c11b48936b$export$f2120bbfa5450bd2 = (0, $029d4f444dd339f5$export$f2120bbfa5450bd2);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $d8c489c11b48936b$export$18c8ad048e32c7d5 = (0, $029d4f444dd339f5$export$18c8ad048e32c7d5);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $d8c489c11b48936b$export$7bf07e38f3dc4b69 = (0, $029d4f444dd339f5$export$7bf07e38f3dc4b69);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $d8c489c11b48936b$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $d8c489c11b48936b$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $029d4f444dd339f5$export$48a53dcb22e581d0)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};



var $kc00y = parcelRequire("kc00y");
var $1b4e289d81b1b97d$export$2e2bcd8739ae039 = (0, $kc00y.useLayoutEffect);


var $24a11043b38fb627$var$_excluded$4 = [
    "className",
    "clearValue",
    "cx",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue",
    "theme"
];
// ==============================
// NO OP
// ==============================
var $24a11043b38fb627$export$b4171a6734a65d42 = function noop() {};
// ==============================
// Class Name Prefixer
// ==============================
/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/ function $24a11043b38fb627$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function $24a11043b38fb627$export$a9c23c6ac3fc3eca(prefix, state) {
    for(var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)classNameList[_key - 2] = arguments[_key];
    var arr = [].concat(classNameList);
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat($24a11043b38fb627$var$applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(' ');
}
// ==============================
// Clean Value
// ==============================
var $24a11043b38fb627$export$7f8ddf7c7c20b3cd = function cleanValue(value) {
    if ($24a11043b38fb627$var$isArray(value)) return value.filter(Boolean);
    if ((0, $edd369f856d5b0b3$export$2e2bcd8739ae039)(value) === 'object' && value !== null) return [
        value
    ];
    return [];
};
// ==============================
// Clean Common Props
// ==============================
var $24a11043b38fb627$var$cleanCommonProps = function cleanCommonProps(props) {
    //className
    props.className;
    props.clearValue;
    props.cx;
    props.getStyles;
    props.getClassNames;
    props.getValue;
    props.hasValue;
    props.isMulti;
    props.isRtl;
    props.options;
    props.selectOption;
    props.selectProps;
    props.setValue;
    props.theme;
    var innerProps = (0, $fefdef73d5b2b1c6$export$2e2bcd8739ae039)(props, $24a11043b38fb627$var$_excluded$4);
    return (0, $7018b41fa193028d$export$2e2bcd8739ae039)({}, innerProps);
};
// ==============================
// Get Style Props
// ==============================
var $24a11043b38fb627$var$getStyleProps = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};
// ==============================
// Handle Input Change
// ==============================
function $24a11043b38fb627$export$61196ced6d74a310(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var _newValue = onInputChange(inputValue, actionMeta);
        if (typeof _newValue === 'string') return _newValue;
    }
    return inputValue;
}
// ==============================
// Scroll Helpers
// ==============================
function $24a11043b38fb627$export$2329c99376c9d0a4(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
// Normalized Scroll Top
// ------------------------------
function $24a11043b38fb627$var$normalizedHeight(el) {
    if ($24a11043b38fb627$export$2329c99376c9d0a4(el)) return window.innerHeight;
    return el.clientHeight;
}
// Normalized scrollTo & scrollTop
// ------------------------------
function $24a11043b38fb627$var$getScrollTop(el) {
    if ($24a11043b38fb627$export$2329c99376c9d0a4(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $24a11043b38fb627$var$scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($24a11043b38fb627$export$2329c99376c9d0a4(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
// Get Scroll Parent
// ------------------------------
function $24a11043b38fb627$var$getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === 'absolute';
    var overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/ function $24a11043b38fb627$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $24a11043b38fb627$var$animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $24a11043b38fb627$export$b4171a6734a65d42;
    var start = $24a11043b38fb627$var$getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = $24a11043b38fb627$var$easeOutCubic(currentTime, start, change, duration);
        $24a11043b38fb627$var$scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
// Scroll Into View
// ------------------------------
function $24a11043b38fb627$export$9bb611d729802a56(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $24a11043b38fb627$var$scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $24a11043b38fb627$var$scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
// ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect
function $24a11043b38fb627$var$getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
// ==============================
// Touch Capability Detector
// ==============================
function $24a11043b38fb627$export$df995fae86a55f06() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch (e) {
        return false;
    }
}
// ==============================
// Mobile Device Detector
// ==============================
function $24a11043b38fb627$export$ebd11618f299a286() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var $24a11043b38fb627$var$passiveOptionAccessed = false;
var $24a11043b38fb627$var$options = {
    get passive () {
        return $24a11043b38fb627$var$passiveOptionAccessed = true;
    }
};
// check for SSR
var $24a11043b38fb627$var$w = typeof window !== 'undefined' ? window : {};
if ($24a11043b38fb627$var$w.addEventListener && $24a11043b38fb627$var$w.removeEventListener) {
    $24a11043b38fb627$var$w.addEventListener('p', $24a11043b38fb627$export$b4171a6734a65d42, $24a11043b38fb627$var$options);
    $24a11043b38fb627$var$w.removeEventListener('p', $24a11043b38fb627$export$b4171a6734a65d42, false);
}
var $24a11043b38fb627$export$2408f22a0fab9ae5 = $24a11043b38fb627$var$passiveOptionAccessed;
function $24a11043b38fb627$export$3466f893ebf79586(item) {
    return item != null;
}
function $24a11043b38fb627$var$isArray(arg) {
    return Array.isArray(arg);
}
function $24a11043b38fb627$export$96f57966bedc81b4(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $24a11043b38fb627$export$e7094788287c5e9b(singleValue) {
    return singleValue;
}
function $24a11043b38fb627$export$ef35774e6d314e91(multiValue) {
    return multiValue;
}
var $24a11043b38fb627$export$43caf9889c228507 = function removeProps(propsObj) {
    for(var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)properties[_key2 - 1] = arguments[_key2];
    var propsMap = Object.entries(propsObj).filter(function(_ref) {
        var _ref2 = (0, $e32bce0b6486f581$export$2e2bcd8739ae039)(_ref, 1), key = _ref2[0];
        return !properties.includes(key);
    });
    return propsMap.reduce(function(newProps, _ref3) {
        var _ref4 = (0, $e32bce0b6486f581$export$2e2bcd8739ae039)(_ref3, 2), key = _ref4[0], val = _ref4[1];
        newProps[key] = val;
        return newProps;
    }, {});
};
var $24a11043b38fb627$var$_excluded$3 = [
    "children",
    "innerProps"
], $24a11043b38fb627$var$_excluded2$1 = [
    "children",
    "innerProps"
];
function $24a11043b38fb627$var$getMenuPlacement(_ref) {
    var preferredMaxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, preferredPlacement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, controlHeight = _ref.controlHeight;
    var scrollParent = $24a11043b38fb627$var$getScrollParent(menuEl);
    var defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = isFixedPosition ? window.innerHeight : $24a11043b38fb627$var$normalizedHeight(scrollParent);
    var scrollTop = $24a11043b38fb627$var$getScrollTop(scrollParent);
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTop;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $24a11043b38fb627$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) $24a11043b38fb627$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = preferredMaxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) $24a11043b38fb627$var$scrollTo(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $24a11043b38fb627$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) $24a11043b38fb627$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight2
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error("Invalid placement provided \"".concat(preferredPlacement, "\"."));
    }
    return defaultState;
}
// Menu Component
// ------------------------------
function $24a11043b38fb627$var$alignToControl(placement) {
    var placementToCSSProp = {
        bottom: 'top',
        top: 'bottom'
    };
    return placement ? placementToCSSProp[placement] : 'bottom';
}
var $24a11043b38fb627$var$coercePlacement = function coercePlacement(p) {
    return p === 'auto' ? 'bottom' : p;
};
var $24a11043b38fb627$export$953cecd6e717a553 = function menuCSS(_ref2, unstyled) {
    var _objectSpread2;
    var placement = _ref2.placement, _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, spacing = _ref2$theme.spacing, colors = _ref2$theme.colors;
    return (0, $7018b41fa193028d$export$2e2bcd8739ae039)((_objectSpread2 = {
        label: 'menu'
    }, (0, $d8f5e6158ecd1aab$export$2e2bcd8739ae039)(_objectSpread2, $24a11043b38fb627$var$alignToControl(placement), '100%'), (0, $d8f5e6158ecd1aab$export$2e2bcd8739ae039)(_objectSpread2, "position", 'absolute'), (0, $d8f5e6158ecd1aab$export$2e2bcd8739ae039)(_objectSpread2, "width", '100%'), (0, $d8f5e6158ecd1aab$export$2e2bcd8739ae039)(_objectSpread2, "zIndex", 1), _objectSpread2), unstyled ? {} : {
        backgroundColor: colors.neutral0,
        borderRadius: borderRadius,
        boxShadow: '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)',
        marginBottom: spacing.menuGutter,
        marginTop: spacing.menuGutter
    });
};
var $24a11043b38fb627$var$PortalPlacementContext = /*#__PURE__*/ (0, $kc00y.createContext)(null);
// NOTE: internal only
var $24a11043b38fb627$export$3a1a48c8f6ef640e = function MenuPlacer(props) {
    var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView, theme = props.theme;
    var _ref3 = (0, $kc00y.useContext)($24a11043b38fb627$var$PortalPlacementContext) || {}, setPortalPlacement = _ref3.setPortalPlacement;
    var ref = (0, $kc00y.useRef)(null);
    var _useState = (0, $kc00y.useState)(maxMenuHeight), _useState2 = (0, $e32bce0b6486f581$export$2e2bcd8739ae039)(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
    var _useState3 = (0, $kc00y.useState)(null), _useState4 = (0, $e32bce0b6486f581$export$2e2bcd8739ae039)(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
    var controlHeight = theme.spacing.controlHeight;
    (0, $1b4e289d81b1b97d$export$2e2bcd8739ae039)(function() {
        var menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        var isFixedPosition = menuPosition === 'fixed';
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = $24a11043b38fb627$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: (0, $7018b41fa193028d$export$2e2bcd8739ae039)((0, $7018b41fa193028d$export$2e2bcd8739ae039)({}, props), {}, {
            placement: placement || $24a11043b38fb627$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        })
    });
};
var $24a11043b38fb627$var$Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $61ec135b17ced9bd$export$c8a8987d4410bf2d)("div", (0, $93c14b0a090563ae$export$2e2bcd8739ae039)({}, $24a11043b38fb627$var$getStyleProps(props, 'menu', {
        menu: true
    }), {
        ref: innerRef
    }, innerProps), children);
};
var $24a11043b38fb627$var$Menu$1 = $24a11043b38fb627$var$Menu;
// ==============================
// Menu List
// ==============================
var $24a11043b38fb627$export$7ccc53e8f1e7dfc5 = function menuListCSS(_ref4, unstyled) {
    var maxHeight = _ref4.maxHeight, baseUnit = _ref4.theme.spacing.baseUnit;
    return (0, $7018b41fa193028d$export$2e2bcd8739ae039)({
        maxHeight: maxHeight,
        overflowY: 'auto',
        position: 'relative',
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: 'touch'
    }, unstyled ? {} : {
        paddingBottom: baseUnit,
        paddingTop: baseUnit
    });
};
var $24a11043b38fb627$var$MenuList = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti;
    return (0, $61ec135b17ced9bd$export$c8a8987d4410bf2d)("div", (0, $93c14b0a090563ae$export$2e2bcd8739ae039)({}, $24a11043b38fb627$var$getStyleProps(props, 'menuList', {
        'menu-list': true,
        'menu-list--is-multi': isMulti
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu Notices
// ==============================
var $24a11043b38fb627$var$noticeCSS = function noticeCSS(_ref5, unstyled) {
    var _ref5$theme = _ref5.theme, baseUnit = _ref5$theme.spacing.baseUnit, colors = _ref5$theme.colors;
    return (0, $7018b41fa193028d$export$2e2bcd8739ae039)({
        textAlign: 'center'
    }, unstyled ? {} : {
        color: colors.neutral40,
        padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px")
    });
};
var $24a11043b38fb627$export$3b14a55fb2447963 = $24a11043b38fb627$var$noticeCSS;
var $24a11043b38fb627$export$342063e11d6c3cad = $24a11043b38fb627$var$noticeCSS;
var $24a11043b38fb627$var$NoOptionsMessage = function NoOptionsMessage(_ref6) {
    var _ref6$children = _ref6.children, children = _ref6$children === void 0 ? 'No options' : _ref6$children, innerProps = _ref6.innerProps, restProps = (0, $fefdef73d5b2b1c6$export$2e2bcd8739ae039)(_ref6, $24a11043b38fb627$var$_excluded$3);
    return (0, $61ec135b17ced9bd$export$c8a8987d4410bf2d)("div", (0, $93c14b0a090563ae$export$2e2bcd8739ae039)({}, $24a11043b38fb627$var$getStyleProps((0, $7018b41fa193028d$export$2e2bcd8739ae039)((0, $7018b41fa193028d$export$2e2bcd8739ae039)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), 'noOptionsMessage', {
        'menu-notice': true,
        'menu-notice--no-options': true
    }), innerProps), children);
};
var $24a11043b38fb627$var$LoadingMessage = function LoadingMessage(_ref7) {
    var _ref7$children = _ref7.children, children = _ref7$children === void 0 ? 'Loading...' : _ref7$children, innerProps = _ref7.innerProps, restProps = (0, $fefdef73d5b2b1c6$export$2e2bcd8739ae039)(_ref7, $24a11043b38fb627$var$_excluded2$1);
    return (0, $61ec135b17ced9bd$export$c8a8987d4410bf2d)("div", (0, $93c14b0a090563ae$export$2e2bcd8739ae039)({}, $24a11043b38fb627$var$getStyleProps((0, $7018b41fa193028d$export$2e2bcd8739ae039)((0, $7018b41fa193028d$export$2e2bcd8739ae039)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), 'loadingMessage', {
        'menu-notice': true,
        'menu-notice--loading': true
    }), innerProps), children);
};
// ==============================
// Menu Portal
// ==============================
var $24a11043b38fb627$export$ae1af26003f05816 = function menuPortalCSS(_ref8) {
    var rect = _ref8.rect, offset = _ref8.offset, position = _ref8.position;
    return {
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    };
};
var $24a11043b38fb627$var$MenuPortal = function MenuPortal(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition;
    var menuPortalRef = (0, $kc00y.useRef)(null);
    var cleanupRef = (0, $kc00y.useRef)(null);
    var _useState5 = (0, $kc00y.useState)($24a11043b38fb627$var$coercePlacement(menuPlacement)), _useState6 = (0, $e32bce0b6486f581$export$2e2bcd8739ae039)(_useState5, 2), placement = _useState6[0], setPortalPlacement = _useState6[1];
    var portalPlacementContext = (0, $kc00y.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState7 = (0, $kc00y.useState)(null), _useState8 = (0, $e32bce0b6486f581$export$2e2bcd8739ae039)(_useState7, 2), computedPosition = _useState8[0], setComputedPosition = _useState8[1];
    var updateComputedPosition = (0, $kc00y.useCallback)(function() {
        if (!controlElement) return;
        var rect = $24a11043b38fb627$var$getBoundingClientObj(controlElement);
        var scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, $1b4e289d81b1b97d$export$2e2bcd8739ae039)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, $kc00y.useCallback)(function() {
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $d8c489c11b48936b$export$deee3a793edee05f)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $1b4e289d81b1b97d$export$2e2bcd8739ae039)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, $kc00y.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    // same wrapper element whether fixed or portalled
    var menuWrapper = (0, $61ec135b17ced9bd$export$c8a8987d4410bf2d)("div", (0, $93c14b0a090563ae$export$2e2bcd8739ae039)({
        ref: setMenuPortalElement
    }, $24a11043b38fb627$var$getStyleProps((0, $7018b41fa193028d$export$2e2bcd8739ae039)((0, $7018b41fa193028d$export$2e2bcd8739ae039)({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), 'menuPortal', {
        'menu-portal': true
    }), innerProps), children);
    return (0, $61ec135b17ced9bd$export$c8a8987d4410bf2d)($24a11043b38fb627$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $9018fd8b87cabbb7$exports.createPortal)(menuWrapper, appendTo) : menuWrapper);
};
// ==============================
// Root Container
// ==============================
var $24a11043b38fb627$export$8b22cf2602fb60ce = function containerCSS(_ref) {
    var isDisabled = _ref.isDisabled, isRtl = _ref.isRtl;
    return {
        label: 'container',
        direction: isRtl ? 'rtl' : undefined,
        pointerEvents: isDisabled ? 'none' : undefined,
        // cancel mouse events when disabled
        position: 'relative'
    };
};
var $24a11043b38fb627$var$SelectContainer = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl;
    return (0, $61ec135b17ced9bd$export$c8a8987d4410bf2d)("div", (0, $93c14b0a090563ae$export$2e2bcd8739ae039)({}, $24a11043b38fb627$var$getStyleProps(props, 'container', {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
    }), innerProps), children);
};
// ==============================
// Value Container
// ==============================
var $24a11043b38fb627$export$4a5767248b18ef41 = function valueContainerCSS(_ref2, unstyled) {
    var spacing = _ref2.theme.spacing, isMulti = _ref2.isMulti, hasValue = _ref2.hasValue, controlShouldRenderValue = _ref2.selectProps.controlShouldRenderValue;
    return (0, $7018b41fa193028d$export$2e2bcd8739ae039)({
        alignItems: 'center',
        display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
        flex: 1,
        flexWrap: 'wrap',
        WebkitOverflowScrolling: 'touch',
        position: 'relative',
        overflow: 'hidden'
    }, unstyled ? {} : {
        padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px")
    });
};
var $24a11043b38fb627$var$ValueContainer = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue;
    return (0, $61ec135b17ced9bd$export$c8a8987d4410bf2d)("div", (0, $93c14b0a090563ae$export$2e2bcd8739ae039)({}, $24a11043b38fb627$var$getStyleProps(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    }), innerProps), children);
};
// ==============================
// Indicator Container
// ==============================
var $24a11043b38fb627$export$23f2a1d2818174ef = function indicatorsContainerCSS() {
    return {
        alignItems: 'center',
        alignSelf: 'stretch',
        display: 'flex',
        flexShrink: 0
    };
};
var $24a11043b38fb627$var$IndicatorsContainer = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $61ec135b17ced9bd$export$c8a8987d4410bf2d)("div", (0, $93c14b0a090563ae$export$2e2bcd8739ae039)({}, $24a11043b38fb627$var$getStyleProps(props, 'indicatorsContainer', {
        indicators: true
    }), innerProps), children);
};
var $24a11043b38fb627$var$_templateObject;
var $24a11043b38fb627$var$_excluded$2 = [
    "size"
], $24a11043b38fb627$var$_excluded2 = [
    "innerProps",
    "isRtl",
    "size"
];
function $24a11043b38fb627$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// ==============================
// Dropdown & Clear Icons
// ==============================
var $24a11043b38fb627$var$_ref2 = {
    name: "8mmkcg",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
};
var $24a11043b38fb627$var$Svg = function Svg(_ref) {
    var size = _ref.size, props = (0, $fefdef73d5b2b1c6$export$2e2bcd8739ae039)(_ref, $24a11043b38fb627$var$_excluded$2);
    return (0, $61ec135b17ced9bd$export$c8a8987d4410bf2d)("svg", (0, $93c14b0a090563ae$export$2e2bcd8739ae039)({
        height: size,
        width: size,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: $24a11043b38fb627$var$_ref2
    }, props));
};
var $24a11043b38fb627$var$CrossIcon = function CrossIcon(props) {
    return (0, $61ec135b17ced9bd$export$c8a8987d4410bf2d)($24a11043b38fb627$var$Svg, (0, $93c14b0a090563ae$export$2e2bcd8739ae039)({
        size: 20
    }, props), (0, $61ec135b17ced9bd$export$c8a8987d4410bf2d)("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
};
var $24a11043b38fb627$var$DownChevron = function DownChevron(props) {
    return (0, $61ec135b17ced9bd$export$c8a8987d4410bf2d)($24a11043b38fb627$var$Svg, (0, $93c14b0a090563ae$export$2e2bcd8739ae039)({
        size: 20
    }, props), (0, $61ec135b17ced9bd$export$c8a8987d4410bf2d)("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
};
// ==============================
// Dropdown & Clear Buttons
// ==============================
var $24a11043b38fb627$var$baseCSS = function baseCSS(_ref3, unstyled) {
    var isFocused = _ref3.isFocused, _ref3$theme = _ref3.theme, baseUnit = _ref3$theme.spacing.baseUnit, colors = _ref3$theme.colors;
    return (0, $7018b41fa193028d$export$2e2bcd8739ae039)({
        label: 'indicatorContainer',
        display: 'flex',
        transition: 'color 150ms'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2,
        ':hover': {
            color: isFocused ? colors.neutral80 : colors.neutral40
        }
    });
};
var $24a11043b38fb627$export$f1e1789686576879 = $24a11043b38fb627$var$baseCSS;
var $24a11043b38fb627$var$DropdownIndicator = function DropdownIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $61ec135b17ced9bd$export$c8a8987d4410bf2d)("div", (0, $93c14b0a090563ae$export$2e2bcd8739ae039)({}, $24a11043b38fb627$var$getStyleProps(props, 'dropdownIndicator', {
        indicator: true,
        'dropdown-indicator': true
    }), innerProps), children || (0, $61ec135b17ced9bd$export$c8a8987d4410bf2d)($24a11043b38fb627$var$DownChevron, null));
};
var $24a11043b38fb627$export$407448d2b89b1813 = $24a11043b38fb627$var$baseCSS;
var $24a11043b38fb627$var$ClearIndicator = function ClearIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $61ec135b17ced9bd$export$c8a8987d4410bf2d)("div", (0, $93c14b0a090563ae$export$2e2bcd8739ae039)({}, $24a11043b38fb627$var$getStyleProps(props, 'clearIndicator', {
        indicator: true,
        'clear-indicator': true
    }), innerProps), children || (0, $61ec135b17ced9bd$export$c8a8987d4410bf2d)($24a11043b38fb627$var$CrossIcon, null));
};
// ==============================
// Separator
// ==============================
var $24a11043b38fb627$export$dda1d9f60106f0e9 = function indicatorSeparatorCSS(_ref4, unstyled) {
    var isDisabled = _ref4.isDisabled, _ref4$theme = _ref4.theme, baseUnit = _ref4$theme.spacing.baseUnit, colors = _ref4$theme.colors;
    return (0, $7018b41fa193028d$export$2e2bcd8739ae039)({
        label: 'indicatorSeparator',
        alignSelf: 'stretch',
        width: 1
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
        marginBottom: baseUnit * 2,
        marginTop: baseUnit * 2
    });
};
var $24a11043b38fb627$var$IndicatorSeparator = function IndicatorSeparator(props) {
    var innerProps = props.innerProps;
    return (0, $61ec135b17ced9bd$export$c8a8987d4410bf2d)("span", (0, $93c14b0a090563ae$export$2e2bcd8739ae039)({}, innerProps, $24a11043b38fb627$var$getStyleProps(props, 'indicatorSeparator', {
        'indicator-separator': true
    })));
};
// ==============================
// Loading
// ==============================
var $24a11043b38fb627$var$loadingDotAnimations = (0, $61ec135b17ced9bd$export$d25ddfdf17c3ad3e)($24a11043b38fb627$var$_templateObject || ($24a11043b38fb627$var$_templateObject = (0, $45d0570c5a25fbbe$export$2e2bcd8739ae039)([
    "\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"
])));
var $24a11043b38fb627$export$882b5998b3b9117c = function loadingIndicatorCSS(_ref5, unstyled) {
    var isFocused = _ref5.isFocused, size = _ref5.size, _ref5$theme = _ref5.theme, colors = _ref5$theme.colors, baseUnit = _ref5$theme.spacing.baseUnit;
    return (0, $7018b41fa193028d$export$2e2bcd8739ae039)({
        label: 'loadingIndicator',
        display: 'flex',
        transition: 'color 150ms',
        alignSelf: 'center',
        fontSize: size,
        lineHeight: 1,
        marginRight: size,
        textAlign: 'center',
        verticalAlign: 'middle'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2
    });
};
var $24a11043b38fb627$var$LoadingDot = function LoadingDot(_ref6) {
    var delay = _ref6.delay, offset = _ref6.offset;
    return (0, $61ec135b17ced9bd$export$c8a8987d4410bf2d)("span", {
        css: /*#__PURE__*/ (0, $61ec135b17ced9bd$export$dbf350e5966cf602)({
            animation: "".concat($24a11043b38fb627$var$loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
            backgroundColor: 'currentColor',
            borderRadius: '1em',
            display: 'inline-block',
            marginLeft: offset ? '1em' : undefined,
            height: '1em',
            verticalAlign: 'top',
            width: '1em'
        }, "", "")
    });
};
var $24a11043b38fb627$var$LoadingIndicator = function LoadingIndicator(_ref7) {
    var innerProps = _ref7.innerProps, isRtl = _ref7.isRtl, _ref7$size = _ref7.size, size = _ref7$size === void 0 ? 4 : _ref7$size, restProps = (0, $fefdef73d5b2b1c6$export$2e2bcd8739ae039)(_ref7, $24a11043b38fb627$var$_excluded2);
    return (0, $61ec135b17ced9bd$export$c8a8987d4410bf2d)("div", (0, $93c14b0a090563ae$export$2e2bcd8739ae039)({}, $24a11043b38fb627$var$getStyleProps((0, $7018b41fa193028d$export$2e2bcd8739ae039)((0, $7018b41fa193028d$export$2e2bcd8739ae039)({}, restProps), {}, {
        innerProps: innerProps,
        isRtl: isRtl,
        size: size
    }), 'loadingIndicator', {
        indicator: true,
        'loading-indicator': true
    }), innerProps), (0, $61ec135b17ced9bd$export$c8a8987d4410bf2d)($24a11043b38fb627$var$LoadingDot, {
        delay: 0,
        offset: isRtl
    }), (0, $61ec135b17ced9bd$export$c8a8987d4410bf2d)($24a11043b38fb627$var$LoadingDot, {
        delay: 160,
        offset: true
    }), (0, $61ec135b17ced9bd$export$c8a8987d4410bf2d)($24a11043b38fb627$var$LoadingDot, {
        delay: 320,
        offset: !isRtl
    }));
};
var $24a11043b38fb627$export$4368d992c4eafac0 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, _ref$theme = _ref.theme, colors = _ref$theme.colors, borderRadius = _ref$theme.borderRadius, spacing = _ref$theme.spacing;
    return (0, $7018b41fa193028d$export$2e2bcd8739ae039)({
        label: 'control',
        alignItems: 'center',
        cursor: 'default',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        minHeight: spacing.controlHeight,
        outline: '0 !important',
        position: 'relative',
        transition: 'all 100ms'
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
        borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
        borderRadius: borderRadius,
        borderStyle: 'solid',
        borderWidth: 1,
        boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : undefined,
        '&:hover': {
            borderColor: isFocused ? colors.primary : colors.neutral30
        }
    });
};
var $24a11043b38fb627$var$Control = function Control(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen;
    return (0, $61ec135b17ced9bd$export$c8a8987d4410bf2d)("div", (0, $93c14b0a090563ae$export$2e2bcd8739ae039)({
        ref: innerRef
    }, $24a11043b38fb627$var$getStyleProps(props, 'control', {
        control: true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused,
        'control--menu-is-open': menuIsOpen
    }), innerProps, {
        "aria-disabled": isDisabled || undefined
    }), children);
};
var $24a11043b38fb627$var$Control$1 = $24a11043b38fb627$var$Control;
var $24a11043b38fb627$var$_excluded$1 = [
    "data"
];
var $24a11043b38fb627$export$39b482c5e57630a8 = function groupCSS(_ref, unstyled) {
    var spacing = _ref.theme.spacing;
    return unstyled ? {} : {
        paddingBottom: spacing.baseUnit * 2,
        paddingTop: spacing.baseUnit * 2
    };
};
var $24a11043b38fb627$var$Group = function Group(props) {
    var children = props.children, cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, theme = props.theme, selectProps = props.selectProps;
    return (0, $61ec135b17ced9bd$export$c8a8987d4410bf2d)("div", (0, $93c14b0a090563ae$export$2e2bcd8739ae039)({}, $24a11043b38fb627$var$getStyleProps(props, 'group', {
        group: true
    }), innerProps), (0, $61ec135b17ced9bd$export$c8a8987d4410bf2d)(Heading, (0, $93c14b0a090563ae$export$2e2bcd8739ae039)({}, headingProps, {
        selectProps: selectProps,
        theme: theme,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: cx
    }), label), (0, $61ec135b17ced9bd$export$c8a8987d4410bf2d)("div", null, children));
};
var $24a11043b38fb627$export$2d1720544b23b823 = function groupHeadingCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, colors = _ref2$theme.colors, spacing = _ref2$theme.spacing;
    return (0, $7018b41fa193028d$export$2e2bcd8739ae039)({
        label: 'group',
        cursor: 'default',
        display: 'block'
    }, unstyled ? {} : {
        color: colors.neutral40,
        fontSize: '75%',
        fontWeight: 500,
        marginBottom: '0.25em',
        paddingLeft: spacing.baseUnit * 3,
        paddingRight: spacing.baseUnit * 3,
        textTransform: 'uppercase'
    });
};
var $24a11043b38fb627$var$GroupHeading = function GroupHeading(props) {
    var _cleanCommonProps = $24a11043b38fb627$var$cleanCommonProps(props);
    _cleanCommonProps.data;
    var innerProps = (0, $fefdef73d5b2b1c6$export$2e2bcd8739ae039)(_cleanCommonProps, $24a11043b38fb627$var$_excluded$1);
    return (0, $61ec135b17ced9bd$export$c8a8987d4410bf2d)("div", (0, $93c14b0a090563ae$export$2e2bcd8739ae039)({}, $24a11043b38fb627$var$getStyleProps(props, 'groupHeading', {
        'group-heading': true
    }), innerProps));
};
var $24a11043b38fb627$var$Group$1 = $24a11043b38fb627$var$Group;
var $24a11043b38fb627$var$_excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName"
];
var $24a11043b38fb627$export$35e795649ee09318 = function inputCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, value = _ref.value, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $7018b41fa193028d$export$2e2bcd8739ae039)((0, $7018b41fa193028d$export$2e2bcd8739ae039)({
        visibility: isDisabled ? 'hidden' : 'visible',
        // force css to recompute when value change due to @emotion bug.
        // We can remove it whenever the bug is fixed.
        transform: value ? 'translateZ(0)' : ''
    }, $24a11043b38fb627$var$containerStyle), unstyled ? {} : {
        margin: spacing.baseUnit / 2,
        paddingBottom: spacing.baseUnit / 2,
        paddingTop: spacing.baseUnit / 2,
        color: colors.neutral80
    });
};
var $24a11043b38fb627$var$spacingStyle = {
    gridArea: '1 / 2',
    font: 'inherit',
    minWidth: '2px',
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
};
var $24a11043b38fb627$var$containerStyle = {
    flex: '1 1 auto',
    display: 'inline-grid',
    gridArea: '1 / 1 / 2 / 3',
    gridTemplateColumns: '0 min-content',
    '&:after': (0, $7018b41fa193028d$export$2e2bcd8739ae039)({
        content: 'attr(data-value) " "',
        visibility: 'hidden',
        whiteSpace: 'pre'
    }, $24a11043b38fb627$var$spacingStyle)
};
var $24a11043b38fb627$var$inputStyle = function inputStyle(isHidden) {
    return (0, $7018b41fa193028d$export$2e2bcd8739ae039)({
        label: 'input',
        color: 'inherit',
        background: 0,
        opacity: isHidden ? 0 : 1,
        width: '100%'
    }, $24a11043b38fb627$var$spacingStyle);
};
var $24a11043b38fb627$var$Input = function Input(props) {
    var cx = props.cx, value = props.value;
    var _cleanCommonProps = $24a11043b38fb627$var$cleanCommonProps(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, innerProps = (0, $fefdef73d5b2b1c6$export$2e2bcd8739ae039)(_cleanCommonProps, $24a11043b38fb627$var$_excluded);
    return (0, $61ec135b17ced9bd$export$c8a8987d4410bf2d)("div", (0, $93c14b0a090563ae$export$2e2bcd8739ae039)({}, $24a11043b38fb627$var$getStyleProps(props, 'input', {
        'input-container': true
    }), {
        "data-value": value || ''
    }), (0, $61ec135b17ced9bd$export$c8a8987d4410bf2d)("input", (0, $93c14b0a090563ae$export$2e2bcd8739ae039)({
        className: cx({
            input: true
        }, inputClassName),
        ref: innerRef,
        style: $24a11043b38fb627$var$inputStyle(isHidden),
        disabled: isDisabled
    }, innerProps)));
};
var $24a11043b38fb627$var$Input$1 = $24a11043b38fb627$var$Input;
var $24a11043b38fb627$export$ffb5f4729a158638 = function multiValueCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, borderRadius = _ref$theme.borderRadius, colors = _ref$theme.colors;
    return (0, $7018b41fa193028d$export$2e2bcd8739ae039)({
        label: 'multiValue',
        display: 'flex',
        minWidth: 0
    }, unstyled ? {} : {
        backgroundColor: colors.neutral10,
        borderRadius: borderRadius / 2,
        margin: spacing.baseUnit / 2
    });
};
var $24a11043b38fb627$export$9e5f44173e64f162 = function multiValueLabelCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, colors = _ref2$theme.colors, cropWithEllipsis = _ref2.cropWithEllipsis;
    return (0, $7018b41fa193028d$export$2e2bcd8739ae039)({
        overflow: 'hidden',
        textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        color: colors.neutral80,
        fontSize: '85%',
        padding: 3,
        paddingLeft: 6
    });
};
var $24a11043b38fb627$export$625550452a3fa3ec = function multiValueRemoveCSS(_ref3, unstyled) {
    var _ref3$theme = _ref3.theme, spacing = _ref3$theme.spacing, borderRadius = _ref3$theme.borderRadius, colors = _ref3$theme.colors, isFocused = _ref3.isFocused;
    return (0, $7018b41fa193028d$export$2e2bcd8739ae039)({
        alignItems: 'center',
        display: 'flex'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        backgroundColor: isFocused ? colors.dangerLight : undefined,
        paddingLeft: spacing.baseUnit,
        paddingRight: spacing.baseUnit,
        ':hover': {
            backgroundColor: colors.dangerLight,
            color: colors.danger
        }
    });
};
var $24a11043b38fb627$var$MultiValueGeneric = function MultiValueGeneric(_ref4) {
    var children = _ref4.children, innerProps = _ref4.innerProps;
    return (0, $61ec135b17ced9bd$export$c8a8987d4410bf2d)("div", innerProps, children);
};
var $24a11043b38fb627$var$MultiValueContainer = $24a11043b38fb627$var$MultiValueGeneric;
var $24a11043b38fb627$var$MultiValueLabel = $24a11043b38fb627$var$MultiValueGeneric;
function $24a11043b38fb627$var$MultiValueRemove(_ref5) {
    var children = _ref5.children, innerProps = _ref5.innerProps;
    return (0, $61ec135b17ced9bd$export$c8a8987d4410bf2d)("div", (0, $93c14b0a090563ae$export$2e2bcd8739ae039)({
        role: "button"
    }, innerProps), children || (0, $61ec135b17ced9bd$export$c8a8987d4410bf2d)($24a11043b38fb627$var$CrossIcon, {
        size: 14
    }));
}
var $24a11043b38fb627$var$MultiValue = function MultiValue(props) {
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, removeProps = props.removeProps, selectProps = props.selectProps;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    return (0, $61ec135b17ced9bd$export$c8a8987d4410bf2d)(Container, {
        data: data,
        innerProps: (0, $7018b41fa193028d$export$2e2bcd8739ae039)((0, $7018b41fa193028d$export$2e2bcd8739ae039)({}, $24a11043b38fb627$var$getStyleProps(props, 'multiValue', {
            'multi-value': true,
            'multi-value--is-disabled': isDisabled
        })), innerProps),
        selectProps: selectProps
    }, (0, $61ec135b17ced9bd$export$c8a8987d4410bf2d)(Label, {
        data: data,
        innerProps: (0, $7018b41fa193028d$export$2e2bcd8739ae039)({}, $24a11043b38fb627$var$getStyleProps(props, 'multiValueLabel', {
            'multi-value__label': true
        })),
        selectProps: selectProps
    }, children), (0, $61ec135b17ced9bd$export$c8a8987d4410bf2d)(Remove, {
        data: data,
        innerProps: (0, $7018b41fa193028d$export$2e2bcd8739ae039)((0, $7018b41fa193028d$export$2e2bcd8739ae039)({}, $24a11043b38fb627$var$getStyleProps(props, 'multiValueRemove', {
            'multi-value__remove': true
        })), {}, {
            'aria-label': "Remove ".concat(children || 'option')
        }, removeProps),
        selectProps: selectProps
    }));
};
var $24a11043b38fb627$var$MultiValue$1 = $24a11043b38fb627$var$MultiValue;
var $24a11043b38fb627$export$90a7f3efeed30595 = function optionCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, isSelected = _ref.isSelected, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $7018b41fa193028d$export$2e2bcd8739ae039)({
        label: 'option',
        cursor: 'default',
        display: 'block',
        fontSize: 'inherit',
        width: '100%',
        userSelect: 'none',
        WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)'
    }, unstyled ? {} : {
        backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
        color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
        padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
        // provide some affordance on touch devices
        ':active': {
            backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
        }
    });
};
var $24a11043b38fb627$var$Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $61ec135b17ced9bd$export$c8a8987d4410bf2d)("div", (0, $93c14b0a090563ae$export$2e2bcd8739ae039)({}, $24a11043b38fb627$var$getStyleProps(props, 'option', {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    }), {
        ref: innerRef,
        "aria-disabled": isDisabled
    }, innerProps), children);
};
var $24a11043b38fb627$var$Option$1 = $24a11043b38fb627$var$Option;
var $24a11043b38fb627$export$efccba1c4a2ef57b = function placeholderCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $7018b41fa193028d$export$2e2bcd8739ae039)({
        label: 'placeholder',
        gridArea: '1 / 1 / 2 / 3'
    }, unstyled ? {} : {
        color: colors.neutral50,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $24a11043b38fb627$var$Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $61ec135b17ced9bd$export$c8a8987d4410bf2d)("div", (0, $93c14b0a090563ae$export$2e2bcd8739ae039)({}, $24a11043b38fb627$var$getStyleProps(props, 'placeholder', {
        placeholder: true
    }), innerProps), children);
};
var $24a11043b38fb627$var$Placeholder$1 = $24a11043b38fb627$var$Placeholder;
var $24a11043b38fb627$export$d141bba7fdc215a3 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $7018b41fa193028d$export$2e2bcd8739ae039)({
        label: 'singleValue',
        gridArea: '1 / 1 / 2 / 3',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        color: isDisabled ? colors.neutral40 : colors.neutral80,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $24a11043b38fb627$var$SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps;
    return (0, $61ec135b17ced9bd$export$c8a8987d4410bf2d)("div", (0, $93c14b0a090563ae$export$2e2bcd8739ae039)({}, $24a11043b38fb627$var$getStyleProps(props, 'singleValue', {
        'single-value': true,
        'single-value--is-disabled': isDisabled
    }), innerProps), children);
};
var $24a11043b38fb627$var$SingleValue$1 = $24a11043b38fb627$var$SingleValue;
var $24a11043b38fb627$export$db3b6bfb95261072 = {
    ClearIndicator: $24a11043b38fb627$var$ClearIndicator,
    Control: $24a11043b38fb627$var$Control$1,
    DropdownIndicator: $24a11043b38fb627$var$DropdownIndicator,
    DownChevron: $24a11043b38fb627$var$DownChevron,
    CrossIcon: $24a11043b38fb627$var$CrossIcon,
    Group: $24a11043b38fb627$var$Group$1,
    GroupHeading: $24a11043b38fb627$var$GroupHeading,
    IndicatorsContainer: $24a11043b38fb627$var$IndicatorsContainer,
    IndicatorSeparator: $24a11043b38fb627$var$IndicatorSeparator,
    Input: $24a11043b38fb627$var$Input$1,
    LoadingIndicator: $24a11043b38fb627$var$LoadingIndicator,
    Menu: $24a11043b38fb627$var$Menu$1,
    MenuList: $24a11043b38fb627$var$MenuList,
    MenuPortal: $24a11043b38fb627$var$MenuPortal,
    LoadingMessage: $24a11043b38fb627$var$LoadingMessage,
    NoOptionsMessage: $24a11043b38fb627$var$NoOptionsMessage,
    MultiValue: $24a11043b38fb627$var$MultiValue$1,
    MultiValueContainer: $24a11043b38fb627$var$MultiValueContainer,
    MultiValueLabel: $24a11043b38fb627$var$MultiValueLabel,
    MultiValueRemove: $24a11043b38fb627$var$MultiValueRemove,
    Option: $24a11043b38fb627$var$Option$1,
    Placeholder: $24a11043b38fb627$var$Placeholder$1,
    SelectContainer: $24a11043b38fb627$var$SelectContainer,
    SingleValue: $24a11043b38fb627$var$SingleValue$1,
    ValueContainer: $24a11043b38fb627$var$ValueContainer
};
var $24a11043b38fb627$export$d66501df72047452 = function defaultComponents(props) {
    return (0, $7018b41fa193028d$export$2e2bcd8739ae039)((0, $7018b41fa193028d$export$2e2bcd8739ae039)({}, $24a11043b38fb627$export$db3b6bfb95261072), props.components);
};



var $15f2d30d717d6fe1$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === 'number' && value !== value;
};
function $15f2d30d717d6fe1$var$isEqual(first, second) {
    if (first === second) return true;
    if ($15f2d30d717d6fe1$var$safeIsNaN(first) && $15f2d30d717d6fe1$var$safeIsNaN(second)) return true;
    return false;
}
function $15f2d30d717d6fe1$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$15f2d30d717d6fe1$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $15f2d30d717d6fe1$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $15f2d30d717d6fe1$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}



function $aa2db46ed739bc62$var$_EMOTION_STRINGIFIED_CSS_ERROR__$2() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Assistive text to describe visual elements. Hidden for sighted users.
var $aa2db46ed739bc62$var$_ref = {
    name: "7pg0cj-a11yText",
    styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
};
var $aa2db46ed739bc62$var$A11yText = function A11yText(props) {
    return (0, $61ec135b17ced9bd$export$c8a8987d4410bf2d)("span", (0, $93c14b0a090563ae$export$2e2bcd8739ae039)({
        css: $aa2db46ed739bc62$var$_ref
    }, props));
};
var $aa2db46ed739bc62$var$A11yText$1 = $aa2db46ed739bc62$var$A11yText;
var $aa2db46ed739bc62$var$defaultAriaLiveMessages = {
    guidance: function guidance(props) {
        var isSearchable = props.isSearchable, isMulti = props.isMulti, tabSelectsValue = props.tabSelectsValue, context = props.context, isInitialFocus = props.isInitialFocus;
        switch(context){
            case 'menu':
                return "Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu".concat(tabSelectsValue ? ', press Tab to select the option and exit the menu' : '', ".");
            case 'input':
                return isInitialFocus ? "".concat(props['aria-label'] || 'Select', " is focused ").concat(isSearchable ? ',type to refine list' : '', ", press Down to open the menu, ").concat(isMulti ? ' press left to focus selected values' : '') : '';
            case 'value':
                return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
            default:
                return '';
        }
    },
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? '' : _props$label, labels = props.labels, isDisabled = props.isDisabled;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return "option ".concat(label, ", deselected.");
            case 'clear':
                return 'All selected options have been cleared.';
            case 'initial-input-focus':
                return "option".concat(labels.length > 1 ? 's' : '', " ").concat(labels.join(','), ", selected.");
            case 'select-option':
                return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
            default:
                return '';
        }
    },
    onFocus: function onFocus(props) {
        var context = props.context, focused = props.focused, options = props.options, _props$label2 = props.label, label = _props$label2 === void 0 ? '' : _props$label2, selectValue = props.selectValue, isDisabled = props.isDisabled, isSelected = props.isSelected, isAppleDevice = props.isAppleDevice;
        var getArrayIndex = function getArrayIndex(arr, item) {
            return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : '';
        };
        if (context === 'value' && selectValue) return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
        if (context === 'menu' && isAppleDevice) {
            var disabled = isDisabled ? ' disabled' : '';
            var status = "".concat(isSelected ? ' selected' : '').concat(disabled);
            return "".concat(label).concat(status, ", ").concat(getArrayIndex(options, focused), ".");
        }
        return '';
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return "".concat(resultsMessage).concat(inputValue ? ' for search term ' + inputValue : '', ".");
    }
};
var $aa2db46ed739bc62$var$LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusedOption = props.focusedOption, focusedValue = props.focusedValue, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id, isAppleDevice = props.isAppleDevice;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isMulti = selectProps.isMulti, isOptionDisabled = selectProps.isOptionDisabled, isSearchable = selectProps.isSearchable, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, tabSelectsValue = selectProps.tabSelectsValue, isLoading = selectProps.isLoading;
    var ariaLabel = selectProps['aria-label'];
    var ariaLive = selectProps['aria-live'];
    // Update aria live message configuration when prop changes
    var messages = (0, $kc00y.useMemo)(function() {
        return (0, $7018b41fa193028d$export$2e2bcd8739ae039)((0, $7018b41fa193028d$export$2e2bcd8739ae039)({}, $aa2db46ed739bc62$var$defaultAriaLiveMessages), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    var ariaSelected = (0, $kc00y.useMemo)(function() {
        var message = '';
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
            // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            // If there is just one item from the action then get its label
            var selected = removedValue || option || asOption(value);
            var label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            var multiSelected = selectedOptions || removedValues || undefined;
            var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            var onChangeProps = (0, $7018b41fa193028d$export$2e2bcd8739ae039)({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel
    ]);
    var ariaFocused = (0, $kc00y.useMemo)(function() {
        var focusMsg = '';
        var focused = focusedOption || focusedValue;
        var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (focused && messages.onFocus) {
            var onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? 'menu' : 'value',
                selectValue: selectValue,
                isAppleDevice: isAppleDevice
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        return focusMsg;
    }, [
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue,
        isAppleDevice
    ]);
    var ariaResults = (0, $kc00y.useMemo)(function() {
        var resultsMsg = '';
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus';
    var ariaGuidance = (0, $kc00y.useMemo)(function() {
        var guidanceMsg = '';
        if (messages.guidance) {
            var context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
            guidanceMsg = messages.guidance({
                'aria-label': ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue,
                isInitialFocus: isInitialFocus
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue,
        isInitialFocus
    ]);
    var ScreenReaderText = (0, $61ec135b17ced9bd$export$c8a8987d4410bf2d)((0, $kc00y.Fragment), null, (0, $61ec135b17ced9bd$export$c8a8987d4410bf2d)("span", {
        id: "aria-selection"
    }, ariaSelected), (0, $61ec135b17ced9bd$export$c8a8987d4410bf2d)("span", {
        id: "aria-focused"
    }, ariaFocused), (0, $61ec135b17ced9bd$export$c8a8987d4410bf2d)("span", {
        id: "aria-results"
    }, ariaResults), (0, $61ec135b17ced9bd$export$c8a8987d4410bf2d)("span", {
        id: "aria-guidance"
    }, ariaGuidance));
    return (0, $61ec135b17ced9bd$export$c8a8987d4410bf2d)((0, $kc00y.Fragment), null, (0, $61ec135b17ced9bd$export$c8a8987d4410bf2d)($aa2db46ed739bc62$var$A11yText$1, {
        id: id
    }, isInitialFocus && ScreenReaderText), (0, $61ec135b17ced9bd$export$c8a8987d4410bf2d)($aa2db46ed739bc62$var$A11yText$1, {
        "aria-live": ariaLive,
        "aria-atomic": "false",
        "aria-relevant": "additions text",
        role: "log"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var $aa2db46ed739bc62$var$LiveRegion$1 = $aa2db46ed739bc62$var$LiveRegion;
var $aa2db46ed739bc62$var$diacritics = [
    {
        base: 'A',
        letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: 'AA',
        letters: "\uA732"
    },
    {
        base: 'AE',
        letters: "\xC6\u01FC\u01E2"
    },
    {
        base: 'AO',
        letters: "\uA734"
    },
    {
        base: 'AU',
        letters: "\uA736"
    },
    {
        base: 'AV',
        letters: "\uA738\uA73A"
    },
    {
        base: 'AY',
        letters: "\uA73C"
    },
    {
        base: 'B',
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: 'C',
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: 'D',
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: 'DZ',
        letters: "\u01F1\u01C4"
    },
    {
        base: 'Dz',
        letters: "\u01F2\u01C5"
    },
    {
        base: 'E',
        letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: 'F',
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: 'G',
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: 'H',
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: 'I',
        letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: 'J',
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: 'K',
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: 'L',
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: 'LJ',
        letters: "\u01C7"
    },
    {
        base: 'Lj',
        letters: "\u01C8"
    },
    {
        base: 'M',
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: 'N',
        letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: 'NJ',
        letters: "\u01CA"
    },
    {
        base: 'Nj',
        letters: "\u01CB"
    },
    {
        base: 'O',
        letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: 'OI',
        letters: "\u01A2"
    },
    {
        base: 'OO',
        letters: "\uA74E"
    },
    {
        base: 'OU',
        letters: "\u0222"
    },
    {
        base: 'P',
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: 'Q',
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: 'R',
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: 'S',
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: 'T',
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: 'TZ',
        letters: "\uA728"
    },
    {
        base: 'U',
        letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: 'V',
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: 'VY',
        letters: "\uA760"
    },
    {
        base: 'W',
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: 'X',
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: 'Y',
        letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: 'Z',
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: 'a',
        letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: 'aa',
        letters: "\uA733"
    },
    {
        base: 'ae',
        letters: "\xE6\u01FD\u01E3"
    },
    {
        base: 'ao',
        letters: "\uA735"
    },
    {
        base: 'au',
        letters: "\uA737"
    },
    {
        base: 'av',
        letters: "\uA739\uA73B"
    },
    {
        base: 'ay',
        letters: "\uA73D"
    },
    {
        base: 'b',
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: 'c',
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: 'd',
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: 'dz',
        letters: "\u01F3\u01C6"
    },
    {
        base: 'e',
        letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: 'f',
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: 'g',
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: 'h',
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: 'hv',
        letters: "\u0195"
    },
    {
        base: 'i',
        letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: 'j',
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: 'k',
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: 'l',
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: 'lj',
        letters: "\u01C9"
    },
    {
        base: 'm',
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: 'n',
        letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: 'nj',
        letters: "\u01CC"
    },
    {
        base: 'o',
        letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: 'oi',
        letters: "\u01A3"
    },
    {
        base: 'ou',
        letters: "\u0223"
    },
    {
        base: 'oo',
        letters: "\uA74F"
    },
    {
        base: 'p',
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: 'q',
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: 'r',
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: 's',
        letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: 't',
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: 'tz',
        letters: "\uA729"
    },
    {
        base: 'u',
        letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: 'v',
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: 'vy',
        letters: "\uA761"
    },
    {
        base: 'w',
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: 'x',
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: 'y',
        letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: 'z',
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $aa2db46ed739bc62$var$anyDiacritic = new RegExp('[' + $aa2db46ed739bc62$var$diacritics.map(function(d) {
    return d.letters;
}).join('') + ']', 'g');
var $aa2db46ed739bc62$var$diacriticToBase = {};
for(var $aa2db46ed739bc62$var$i = 0; $aa2db46ed739bc62$var$i < $aa2db46ed739bc62$var$diacritics.length; $aa2db46ed739bc62$var$i++){
    var $aa2db46ed739bc62$var$diacritic = $aa2db46ed739bc62$var$diacritics[$aa2db46ed739bc62$var$i];
    for(var $aa2db46ed739bc62$var$j = 0; $aa2db46ed739bc62$var$j < $aa2db46ed739bc62$var$diacritic.letters.length; $aa2db46ed739bc62$var$j++)$aa2db46ed739bc62$var$diacriticToBase[$aa2db46ed739bc62$var$diacritic.letters[$aa2db46ed739bc62$var$j]] = $aa2db46ed739bc62$var$diacritic.base;
}
var $aa2db46ed739bc62$var$stripDiacritics = function stripDiacritics(str) {
    return str.replace($aa2db46ed739bc62$var$anyDiacritic, function(match) {
        return $aa2db46ed739bc62$var$diacriticToBase[match];
    });
};
var $aa2db46ed739bc62$var$memoizedStripDiacriticsForInput = (0, $15f2d30d717d6fe1$export$2e2bcd8739ae039)($aa2db46ed739bc62$var$stripDiacritics);
var $aa2db46ed739bc62$var$trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, '');
};
var $aa2db46ed739bc62$var$defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var $aa2db46ed739bc62$export$db3b6bfb95261072 = function createFilter(config) {
    return function(option, rawInput) {
        // eslint-disable-next-line no-underscore-dangle
        if (option.data.__isNew__) return true;
        var _ignoreCase$ignoreAcc = (0, $7018b41fa193028d$export$2e2bcd8739ae039)({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $aa2db46ed739bc62$var$defaultStringify,
            trim: true,
            matchFrom: 'any'
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? $aa2db46ed739bc62$var$trimString(rawInput) : rawInput;
        var candidate = trim ? $aa2db46ed739bc62$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $aa2db46ed739bc62$var$memoizedStripDiacriticsForInput(input);
            candidate = $aa2db46ed739bc62$var$stripDiacritics(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};
var $aa2db46ed739bc62$var$_excluded = [
    "innerRef"
];
function $aa2db46ed739bc62$var$DummyInput(_ref) {
    var innerRef = _ref.innerRef, props = (0, $fefdef73d5b2b1c6$export$2e2bcd8739ae039)(_ref, $aa2db46ed739bc62$var$_excluded);
    // Remove animation props not meant for HTML elements
    var filteredProps = (0, $24a11043b38fb627$export$43caf9889c228507)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    return (0, $61ec135b17ced9bd$export$c8a8987d4410bf2d)("input", (0, $93c14b0a090563ae$export$2e2bcd8739ae039)({
        ref: innerRef
    }, filteredProps, {
        css: /*#__PURE__*/ (0, $61ec135b17ced9bd$export$dbf350e5966cf602)({
            label: 'dummyInput',
            // get rid of any default styles
            background: 0,
            border: 0,
            // important! this hides the flashing cursor
            caretColor: 'transparent',
            fontSize: 'inherit',
            gridArea: '1 / 1 / 2 / 3',
            outline: 0,
            padding: 0,
            // important! without `width` browsers won't allow focus
            width: 1,
            // remove cursor on desktop
            color: 'transparent',
            // remove cursor on mobile whilst maintaining "scroll into view" behaviour
            left: -100,
            opacity: 0,
            position: 'relative',
            transform: 'scale(.01)'
        }, "", "")
    }));
}
var $aa2db46ed739bc62$var$cancelScroll = function cancelScroll(event) {
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function $aa2db46ed739bc62$var$useScrollCapture(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, $kc00y.useRef)(false);
    var isTop = (0, $kc00y.useRef)(false);
    var touchStart = (0, $kc00y.useRef)(0);
    var scrollTarget = (0, $kc00y.useRef)(null);
    var handleEventDelta = (0, $kc00y.useCallback)(function(event, delta) {
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $aa2db46ed739bc62$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    var onWheel = (0, $kc00y.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, $kc00y.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, $kc00y.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, $kc00y.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, $24a11043b38fb627$export$2408f22a0fab9ae5) ? {
            passive: false
        } : false;
        el.addEventListener('wheel', onWheel, notPassive);
        el.addEventListener('touchstart', onTouchStart, notPassive);
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, $kc00y.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return;
        el.removeEventListener('wheel', onWheel, false);
        el.removeEventListener('touchstart', onTouchStart, false);
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $kc00y.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
var $aa2db46ed739bc62$var$STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
var $aa2db46ed739bc62$var$LOCK_STYLES = {
    boxSizing: 'border-box',
    // account for possible declaration `width: 100%;` on body
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function $aa2db46ed739bc62$var$preventTouchMove(e) {
    if (e.cancelable) e.preventDefault();
}
function $aa2db46ed739bc62$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $aa2db46ed739bc62$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $aa2db46ed739bc62$var$isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
var $aa2db46ed739bc62$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var $aa2db46ed739bc62$var$activeScrollLocks = 0;
var $aa2db46ed739bc62$var$listenerOptions = {
    capture: false,
    passive: false
};
function $aa2db46ed739bc62$var$useScrollLock(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, $kc00y.useRef)({});
    var scrollTarget = (0, $kc00y.useRef)(null);
    var addScrollLock = (0, $kc00y.useCallback)(function(touchScrollTarget) {
        if (!$aa2db46ed739bc62$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $aa2db46ed739bc62$var$STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $aa2db46ed739bc62$var$activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($aa2db46ed739bc62$var$LOCK_STYLES).forEach(function(key) {
                var val = $aa2db46ed739bc62$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
        // account for touch devices
        if (target && $aa2db46ed739bc62$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            target.addEventListener('touchmove', $aa2db46ed739bc62$var$preventTouchMove, $aa2db46ed739bc62$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                touchScrollTarget.addEventListener('touchstart', $aa2db46ed739bc62$var$preventInertiaScroll, $aa2db46ed739bc62$var$listenerOptions);
                touchScrollTarget.addEventListener('touchmove', $aa2db46ed739bc62$var$allowTouchMove, $aa2db46ed739bc62$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $aa2db46ed739bc62$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    var removeScrollLock = (0, $kc00y.useCallback)(function(touchScrollTarget) {
        if (!$aa2db46ed739bc62$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        // safely decrement active scroll locks
        $aa2db46ed739bc62$var$activeScrollLocks = Math.max($aa2db46ed739bc62$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $aa2db46ed739bc62$var$activeScrollLocks < 1) $aa2db46ed739bc62$var$STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $aa2db46ed739bc62$var$isTouchDevice()) {
            target.removeEventListener('touchmove', $aa2db46ed739bc62$var$preventTouchMove, $aa2db46ed739bc62$var$listenerOptions);
            if (touchScrollTarget) {
                touchScrollTarget.removeEventListener('touchstart', $aa2db46ed739bc62$var$preventInertiaScroll, $aa2db46ed739bc62$var$listenerOptions);
                touchScrollTarget.removeEventListener('touchmove', $aa2db46ed739bc62$var$allowTouchMove, $aa2db46ed739bc62$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $kc00y.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
function $aa2db46ed739bc62$var$_EMOTION_STRINGIFIED_CSS_ERROR__$1() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $aa2db46ed739bc62$var$blurSelectInput = function blurSelectInput(event) {
    var element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
var $aa2db46ed739bc62$var$_ref2$1 = {
    name: "1kfdb0e",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0"
};
function $aa2db46ed739bc62$var$ScrollManager(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = $aa2db46ed739bc62$var$useScrollCapture({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = $aa2db46ed739bc62$var$useScrollLock({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return (0, $61ec135b17ced9bd$export$c8a8987d4410bf2d)((0, $kc00y.Fragment), null, lockEnabled && (0, $61ec135b17ced9bd$export$c8a8987d4410bf2d)("div", {
        onClick: $aa2db46ed739bc62$var$blurSelectInput,
        css: $aa2db46ed739bc62$var$_ref2$1
    }), children(targetRef));
}
function $aa2db46ed739bc62$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $aa2db46ed739bc62$var$_ref2 = {
    name: "1a0ro4n-requiredInput",
    styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
};
var $aa2db46ed739bc62$var$RequiredInput = function RequiredInput(_ref) {
    var name = _ref.name, onFocus = _ref.onFocus;
    return (0, $61ec135b17ced9bd$export$c8a8987d4410bf2d)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        css: $aa2db46ed739bc62$var$_ref2,
        value: "",
        onChange: function onChange() {}
    });
};
var $aa2db46ed739bc62$var$RequiredInput$1 = $aa2db46ed739bc62$var$RequiredInput;
/// <reference types="user-agent-data-types" />
function $aa2db46ed739bc62$var$testPlatform(re) {
    var _window$navigator$use;
    return typeof window !== 'undefined' && window.navigator != null ? re.test(((_window$navigator$use = window.navigator['userAgentData']) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.platform) || window.navigator.platform) : false;
}
function $aa2db46ed739bc62$var$isIPhone() {
    return $aa2db46ed739bc62$var$testPlatform(/^iPhone/i);
}
function $aa2db46ed739bc62$var$isMac() {
    return $aa2db46ed739bc62$var$testPlatform(/^Mac/i);
}
function $aa2db46ed739bc62$var$isIPad() {
    return $aa2db46ed739bc62$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $aa2db46ed739bc62$var$isMac() && navigator.maxTouchPoints > 1;
}
function $aa2db46ed739bc62$var$isIOS() {
    return $aa2db46ed739bc62$var$isIPhone() || $aa2db46ed739bc62$var$isIPad();
}
function $aa2db46ed739bc62$var$isAppleDevice() {
    return $aa2db46ed739bc62$var$isMac() || $aa2db46ed739bc62$var$isIOS();
}
var $aa2db46ed739bc62$var$formatGroupLabel = function formatGroupLabel(group) {
    return group.label;
};
var $aa2db46ed739bc62$export$8b22cf2602fb60ce = function getOptionLabel(option) {
    return option.label;
};
var $aa2db46ed739bc62$export$39b482c5e57630a8 = function getOptionValue(option) {
    return option.value;
};
var $aa2db46ed739bc62$var$isOptionDisabled = function isOptionDisabled(option) {
    return !!option.isDisabled;
};
var $aa2db46ed739bc62$var$defaultStyles = {
    clearIndicator: (0, $24a11043b38fb627$export$407448d2b89b1813),
    container: (0, $24a11043b38fb627$export$8b22cf2602fb60ce),
    control: (0, $24a11043b38fb627$export$4368d992c4eafac0),
    dropdownIndicator: (0, $24a11043b38fb627$export$f1e1789686576879),
    group: (0, $24a11043b38fb627$export$39b482c5e57630a8),
    groupHeading: (0, $24a11043b38fb627$export$2d1720544b23b823),
    indicatorsContainer: (0, $24a11043b38fb627$export$23f2a1d2818174ef),
    indicatorSeparator: (0, $24a11043b38fb627$export$dda1d9f60106f0e9),
    input: (0, $24a11043b38fb627$export$35e795649ee09318),
    loadingIndicator: (0, $24a11043b38fb627$export$882b5998b3b9117c),
    loadingMessage: (0, $24a11043b38fb627$export$342063e11d6c3cad),
    menu: (0, $24a11043b38fb627$export$953cecd6e717a553),
    menuList: (0, $24a11043b38fb627$export$7ccc53e8f1e7dfc5),
    menuPortal: (0, $24a11043b38fb627$export$ae1af26003f05816),
    multiValue: (0, $24a11043b38fb627$export$ffb5f4729a158638),
    multiValueLabel: (0, $24a11043b38fb627$export$9e5f44173e64f162),
    multiValueRemove: (0, $24a11043b38fb627$export$625550452a3fa3ec),
    noOptionsMessage: (0, $24a11043b38fb627$export$3b14a55fb2447963),
    option: (0, $24a11043b38fb627$export$90a7f3efeed30595),
    placeholder: (0, $24a11043b38fb627$export$efccba1c4a2ef57b),
    singleValue: (0, $24a11043b38fb627$export$d141bba7fdc215a3),
    valueContainer: (0, $24a11043b38fb627$export$4a5767248b18ef41)
};
// Merge Utility
// Allows consumers to extend a base Select with additional styles
function $aa2db46ed739bc62$export$953cecd6e717a553(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = (0, $7018b41fa193028d$export$2e2bcd8739ae039)({}, source);
    // massage in target styles
    Object.keys(target).forEach(function(keyAsString) {
        var key = keyAsString;
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
var $aa2db46ed739bc62$var$colors = {
    primary: '#2684FF',
    primary75: '#4C9AFF',
    primary50: '#B2D4FF',
    primary25: '#DEEBFF',
    danger: '#DE350B',
    dangerLight: '#FFBDAD',
    neutral0: 'hsl(0, 0%, 100%)',
    neutral5: 'hsl(0, 0%, 95%)',
    neutral10: 'hsl(0, 0%, 90%)',
    neutral20: 'hsl(0, 0%, 80%)',
    neutral30: 'hsl(0, 0%, 70%)',
    neutral40: 'hsl(0, 0%, 60%)',
    neutral50: 'hsl(0, 0%, 50%)',
    neutral60: 'hsl(0, 0%, 40%)',
    neutral70: 'hsl(0, 0%, 30%)',
    neutral80: 'hsl(0, 0%, 20%)',
    neutral90: 'hsl(0, 0%, 10%)'
};
var $aa2db46ed739bc62$var$borderRadius = 4;
// Used to calculate consistent margin/padding on elements
var $aa2db46ed739bc62$var$baseUnit = 4;
// The minimum height of the control
var $aa2db46ed739bc62$var$controlHeight = 38;
// The amount of space between the control and menu */
var $aa2db46ed739bc62$var$menuGutter = $aa2db46ed739bc62$var$baseUnit * 2;
var $aa2db46ed739bc62$var$spacing = {
    baseUnit: $aa2db46ed739bc62$var$baseUnit,
    controlHeight: $aa2db46ed739bc62$var$controlHeight,
    menuGutter: $aa2db46ed739bc62$var$menuGutter
};
var $aa2db46ed739bc62$export$4368d992c4eafac0 = {
    borderRadius: $aa2db46ed739bc62$var$borderRadius,
    colors: $aa2db46ed739bc62$var$colors,
    spacing: $aa2db46ed739bc62$var$spacing
};
var $aa2db46ed739bc62$export$407448d2b89b1813 = {
    'aria-live': 'polite',
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $24a11043b38fb627$export$df995fae86a55f06)(),
    captureMenuScroll: !(0, $24a11043b38fb627$export$df995fae86a55f06)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: $aa2db46ed739bc62$export$db3b6bfb95261072(),
    formatGroupLabel: $aa2db46ed739bc62$var$formatGroupLabel,
    getOptionLabel: $aa2db46ed739bc62$export$8b22cf2602fb60ce,
    getOptionValue: $aa2db46ed739bc62$export$39b482c5e57630a8,
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: $aa2db46ed739bc62$var$isOptionDisabled,
    loadingMessage: function loadingMessage() {
        return 'Loading...';
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $24a11043b38fb627$export$ebd11618f299a286)(),
    noOptionsMessage: function noOptionsMessage() {
        return 'No options';
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    unstyled: false
};
function $aa2db46ed739bc62$var$toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = $aa2db46ed739bc62$var$_isOptionDisabled(props, option, selectValue);
    var isSelected = $aa2db46ed739bc62$var$_isOptionSelected(props, option, selectValue);
    var label = $aa2db46ed739bc62$var$getOptionLabel(props, option);
    var value = $aa2db46ed739bc62$var$getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $aa2db46ed739bc62$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        if ('options' in groupOrOption) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return $aa2db46ed739bc62$var$toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return $aa2db46ed739bc62$var$isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = $aa2db46ed739bc62$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $aa2db46ed739bc62$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $24a11043b38fb627$export$3466f893ebf79586));
}
function $aa2db46ed739bc62$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, $32ec1eca796f107d$export$2e2bcd8739ae039)(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $aa2db46ed739bc62$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, $32ec1eca796f107d$export$2e2bcd8739ae039)(categorizedOption.options.map(function(option) {
            return {
                data: option.data,
                id: "".concat(optionId, "-").concat(categorizedOption.index, "-").concat(option.index)
            };
        })));
        else optionsAccumulator.push({
            data: categorizedOption.data,
            id: "".concat(optionId, "-").concat(categorizedOption.index)
        });
        return optionsAccumulator;
    }, []);
}
function $aa2db46ed739bc62$var$buildFocusableOptions(props, selectValue) {
    return $aa2db46ed739bc62$var$buildFocusableOptionsFromCategorizedOptions($aa2db46ed739bc62$var$buildCategorizedOptions(props, selectValue));
}
function $aa2db46ed739bc62$var$isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? '' : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!$aa2db46ed739bc62$var$shouldHideSelectedOptions(props) || !isSelected) && $aa2db46ed739bc62$var$_filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $aa2db46ed739bc62$var$getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $aa2db46ed739bc62$var$getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var $aa2db46ed739bc62$var$getFocusedOptionId = function getFocusedOptionId(focusableOptionsWithIds, focusedOption) {
    var _focusableOptionsWith;
    var focusedOptionId = (_focusableOptionsWith = focusableOptionsWithIds.find(function(option) {
        return option.data === focusedOption;
    })) === null || _focusableOptionsWith === void 0 ? void 0 : _focusableOptionsWith.id;
    return focusedOptionId || null;
};
var $aa2db46ed739bc62$var$getOptionLabel = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var $aa2db46ed739bc62$var$getOptionValue = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function $aa2db46ed739bc62$var$_isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function $aa2db46ed739bc62$var$_isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    var candidate = $aa2db46ed739bc62$var$getOptionValue(props, option);
    return selectValue.some(function(i) {
        return $aa2db46ed739bc62$var$getOptionValue(props, i) === candidate;
    });
}
function $aa2db46ed739bc62$var$_filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var $aa2db46ed739bc62$var$shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var $aa2db46ed739bc62$var$instanceId = 1;
var $aa2db46ed739bc62$export$25ce5a424b770e84 = /*#__PURE__*/ function(_Component) {
    (0, $e641cec65e374bd1$export$2e2bcd8739ae039)(Select, _Component);
    var _super = (0, $2405f8bb9d24fc8e$export$2e2bcd8739ae039)(Select);
    // Misc. Instance Properties
    // ------------------------------
    // TODO
    // Refs
    // ------------------------------
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, $6bf37624bc91922d$export$2e2bcd8739ae039)(this, Select);
        _this = _super.call(this, _props);
        _this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedOptionId: null,
            focusableOptionsWithIds: [],
            focusedValue: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined,
            instancePrefix: '',
            isAppleDevice: false
        };
        _this.blockOptionHover = false;
        _this.isComposing = false;
        _this.commonProps = void 0;
        _this.initialTouchX = 0;
        _this.initialTouchY = 0;
        _this.openAfterFocus = false;
        _this.scrollToFocusedOptionOnUpdate = false;
        _this.userIsDragging = void 0;
        _this.controlRef = null;
        _this.getControlRef = function(ref) {
            _this.controlRef = ref;
        };
        _this.focusedOptionRef = null;
        _this.getFocusedOptionRef = function(ref) {
            _this.focusedOptionRef = ref;
        };
        _this.menuListRef = null;
        _this.getMenuListRef = function(ref) {
            _this.menuListRef = ref;
        };
        _this.inputRef = null;
        _this.getInputRef = function(ref) {
            _this.inputRef = ref;
        };
        _this.focus = _this.focusInput;
        _this.blur = _this.blurInput;
        _this.onChange = function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        };
        _this.setValue = function(newValue, action, option) {
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue;
            _this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        _this.selectOption = function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue((0, $24a11043b38fb627$export$ef35774e6d314e91)(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                })), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue((0, $24a11043b38fb627$export$ef35774e6d314e91)([].concat((0, $32ec1eca796f107d$export$2e2bcd8739ae039)(selectValue), [
                    newValue
                ])), 'select-option', newValue);
                else _this.setValue((0, $24a11043b38fb627$export$e7094788287c5e9b)(newValue), 'select-option');
            } else {
                _this.ariaOnChange((0, $24a11043b38fb627$export$e7094788287c5e9b)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        };
        _this.removeValue = function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = (0, $24a11043b38fb627$export$96f57966bedc81b4)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            _this.focusInput();
        };
        _this.clearValue = function() {
            var selectValue = _this.state.selectValue;
            _this.onChange((0, $24a11043b38fb627$export$96f57966bedc81b4)(_this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        };
        _this.popValue = function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = (0, $24a11043b38fb627$export$96f57966bedc81b4)(isMulti, newValueArray, newValueArray[0] || null);
            if (lastSelectedValue) _this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        };
        _this.getFocusedOptionId = function(focusedOption) {
            return $aa2db46ed739bc62$var$getFocusedOptionId(_this.state.focusableOptionsWithIds, focusedOption);
        };
        _this.getFocusableOptionsWithIds = function() {
            return $aa2db46ed739bc62$var$buildFocusableOptionsWithIds($aa2db46ed739bc62$var$buildCategorizedOptions(_this.props, _this.state.selectValue), _this.getElementId('option'));
        };
        _this.getValue = function() {
            return _this.state.selectValue;
        };
        _this.cx = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, $24a11043b38fb627$export$a9c23c6ac3fc3eca).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        };
        _this.getOptionLabel = function(data) {
            return $aa2db46ed739bc62$var$getOptionLabel(_this.props, data);
        };
        _this.getOptionValue = function(data) {
            return $aa2db46ed739bc62$var$getOptionValue(_this.props, data);
        };
        _this.getStyles = function(key, props) {
            var unstyled = _this.props.unstyled;
            var base = $aa2db46ed739bc62$var$defaultStyles[key](props, unstyled);
            base.boxSizing = 'border-box';
            var custom = _this.props.styles[key];
            return custom ? custom(base, props) : base;
        };
        _this.getClassNames = function(key, props) {
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        };
        _this.getElementId = function(element) {
            return "".concat(_this.state.instancePrefix, "-").concat(element);
        };
        _this.getComponents = function() {
            return (0, $24a11043b38fb627$export$d66501df72047452)(_this.props);
        };
        _this.buildCategorizedOptions = function() {
            return $aa2db46ed739bc62$var$buildCategorizedOptions(_this.props, _this.state.selectValue);
        };
        _this.getCategorizedOptions = function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        };
        _this.buildFocusableOptions = function() {
            return $aa2db46ed739bc62$var$buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        };
        _this.getFocusableOptions = function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        };
        _this.ariaOnChange = function(value, actionMeta) {
            _this.setState({
                ariaSelection: (0, $7018b41fa193028d$export$2e2bcd8739ae039)({
                    value: value
                }, actionMeta)
            });
        };
        _this.onMenuMouseDown = function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        };
        _this.onMenuMouseMove = function(event) {
            _this.blockOptionHover = false;
        };
        _this.onControlMouseDown = function(event) {
            // Event captured by dropdown indicator
            if (event.defaultPrevented) return;
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') _this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        };
        _this.onDropdownIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu('first');
            event.preventDefault();
        };
        _this.onClearIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            _this.clearValue();
            event.preventDefault();
            _this.openAfterFocus = false;
            if (event.type === 'touchend') _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        };
        _this.onScroll = function(event) {
            if (typeof _this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, $24a11043b38fb627$export$2329c99376c9d0a4)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === 'function') {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        };
        _this.onCompositionStart = function() {
            _this.isComposing = true;
        };
        _this.onCompositionEnd = function() {
            _this.isComposing = false;
        };
        _this.onTouchStart = function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        };
        _this.onTouchMove = function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        _this.onTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
            // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        };
        _this.onControlTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        };
        _this.onClearIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        };
        _this.onDropdownIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        };
        _this.handleInputChange = function(event) {
            var prevInputValue = _this.props.inputValue;
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        };
        _this.onInputFocus = function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu('first');
            _this.openAfterFocus = false;
        };
        _this.onInputBlur = function(event) {
            var prevInputValue = _this.props.inputValue;
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        _this.onOptionHover = function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            var options = _this.getFocusableOptions();
            var focusedOptionIndex = options.indexOf(focusedOption);
            _this.setState({
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionIndex > -1 ? _this.getFocusedOptionId(focusedOption) : null
            });
        };
        _this.shouldHideSelectedOptions = function() {
            return $aa2db46ed739bc62$var$shouldHideSelectedOptions(_this.props);
        };
        _this.onValueInputFocus = function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.focus();
        };
        _this.onKeyDown = function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        _this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case ' ':
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) _this.focusOption('up');
                    else _this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) _this.focusOption('down');
                    else _this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    _this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    _this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    _this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    _this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        _this.state.instancePrefix = 'react-select-' + (_this.props.instanceId || ++$aa2db46ed739bc62$var$instanceId);
        _this.state.selectValue = (0, $24a11043b38fb627$export$7f8ddf7c7c20b3cd)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen && _this.state.selectValue.length) {
            var focusableOptionsWithIds = _this.getFocusableOptionsWithIds();
            var focusableOptions = _this.buildFocusableOptions();
            var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
            _this.state.focusableOptionsWithIds = focusableOptionsWithIds;
            _this.state.focusedOption = focusableOptions[optionIndex];
            _this.state.focusedOptionId = $aa2db46ed739bc62$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
        }
        return _this;
    }
    (0, $aadd4372416ec2f2$export$2e2bcd8739ae039)(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                document.addEventListener('scroll', this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
                // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
                if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $24a11043b38fb627$export$9bb611d729802a56)(this.menuListRef, this.focusedOptionRef);
                if ($aa2db46ed739bc62$var$isAppleDevice()) // eslint-disable-next-line react/no-did-mount-set-state
                this.setState({
                    isAppleDevice: true
                });
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (// ensure focus is restored correctly when the control becomes enabled
                isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: true
                });
                // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    (0, $24a11043b38fb627$export$9bb611d729802a56)(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                document.removeEventListener('scroll', this.onScroll, true);
            }
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange('', {
                    action: 'menu-close',
                    prevInputValue: this.props.inputValue
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            }
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            }
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                }
                // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusableOptions[openAtIndex],
                    focusedOptionId: this.getFocusedOptionId(focusableOptions[openAtIndex])
                }, function() {
                    return _this2.onMenuOpen();
                });
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
                // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case 'previous':
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case 'next':
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus]
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === 'pageup') {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === 'pagedown') {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === 'last') nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null,
                    focusedOptionId: this.getFocusedOptionId(options[nextFocus])
                });
            }
        },
        {
            key: "getTheme",
            value: // ==============================
            // Getters
            // ==============================
            function getTheme() {
                // Use the default theme if there are no customisations.
                if (!this.props.theme) return $aa2db46ed739bc62$export$4368d992c4eafac0;
                // If the theme prop is a function, assume the function
                // knows how to merge the passed-in default theme with
                // its own modifications.
                if (typeof this.props.theme === 'function') return this.props.theme($aa2db46ed739bc62$export$4368d992c4eafac0);
                // Otherwise, if a plain theme object was passed in,
                // overlay it with the default theme.
                return (0, $7018b41fa193028d$export$2e2bcd8739ae039)((0, $7018b41fa193028d$export$2e2bcd8739ae039)({}, $aa2db46ed739bc62$export$4368d992c4eafac0), this.props.theme);
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getClassNames: getClassNames,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue,
                    theme: this.getTheme()
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti;
                // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return $aa2db46ed739bc62$var$_isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return $aa2db46ed739bc62$var$_isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return $aa2db46ed739bc62$var$_filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                if (typeof this.props.formatOptionLabel === 'function') {
                    var _inputValue = this.props.inputValue;
                    var _selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: _inputValue,
                        selectValue: _selectValue
                    });
                } else return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            }
        },
        {
            key: "startListeningComposition",
            value: // ==============================
            // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    document.addEventListener('compositionstart', this.onCompositionStart, false);
                    document.addEventListener('compositionend', this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('compositionstart', this.onCompositionStart);
                    document.removeEventListener('compositionend', this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // ==============================
            // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    document.addEventListener('touchstart', this.onTouchStart, false);
                    document.addEventListener('touchmove', this.onTouchMove, false);
                    document.addEventListener('touchend', this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('touchstart', this.onTouchStart);
                    document.removeEventListener('touchmove', this.onTouchMove);
                    document.removeEventListener('touchend', this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // ==============================
            // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, isDisabled = _this$props8.isDisabled, isSearchable = _this$props8.isSearchable, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, tabIndex = _this$props8.tabIndex, form = _this$props8.form, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var _this$state4 = this.state, inputIsHidden = _this$state4.inputIsHidden, ariaSelection = _this$state4.ariaSelection;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId('input');
                // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = (0, $7018b41fa193028d$export$2e2bcd8739ae039)((0, $7018b41fa193028d$export$2e2bcd8739ae039)((0, $7018b41fa193028d$export$2e2bcd8739ae039)({
                    'aria-autocomplete': 'list',
                    'aria-expanded': menuIsOpen,
                    'aria-haspopup': true,
                    'aria-errormessage': this.props['aria-errormessage'],
                    'aria-invalid': this.props['aria-invalid'],
                    'aria-label': this.props['aria-label'],
                    'aria-labelledby': this.props['aria-labelledby'],
                    'aria-required': required,
                    role: 'combobox',
                    'aria-activedescendant': this.state.isAppleDevice ? undefined : this.state.focusedOptionId || ''
                }, menuIsOpen && {
                    'aria-controls': this.getElementId('listbox')
                }), !isSearchable && {
                    'aria-readonly': true
                }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus' && {
                    'aria-describedby': this.getElementId('live-region')
                } : {
                    'aria-describedby': this.getElementId('placeholder')
                });
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ $kc00y.createElement($aa2db46ed739bc62$var$DummyInput, (0, $93c14b0a090563ae$export$2e2bcd8739ae039)({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: (0, $24a11043b38fb627$export$b4171a6734a65d42),
                    onFocus: this.onInputFocus,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    inputMode: "none",
                    form: form,
                    value: ""
                }, ariaAttributes));
                return /*#__PURE__*/ $kc00y.createElement(Input, (0, $93c14b0a090563ae$export$2e2bcd8739ae039)({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this3 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder;
                var _this$state5 = this.state, selectValue = _this$state5.selectValue, focusedValue = _this$state5.focusedValue, isFocused = _this$state5.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ $kc00y.createElement(Placeholder, (0, $93c14b0a090563ae$export$2e2bcd8739ae039)({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    innerProps: {
                        id: this.getElementId('placeholder')
                    }
                }), placeholder);
                if (isMulti) return selectValue.map(function(opt, index) {
                    var isOptionFocused = opt === focusedValue;
                    var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
                    return /*#__PURE__*/ $kc00y.createElement(MultiValue, (0, $93c14b0a090563ae$export$2e2bcd8739ae039)({}, commonProps, {
                        components: {
                            Container: MultiValueContainer,
                            Label: MultiValueLabel,
                            Remove: MultiValueRemove
                        },
                        isFocused: isOptionFocused,
                        isDisabled: isDisabled,
                        key: key,
                        index: index,
                        removeProps: {
                            onClick: function onClick() {
                                return _this3.removeValue(opt);
                            },
                            onTouchEnd: function onTouchEnd() {
                                return _this3.removeValue(opt);
                            },
                            onMouseDown: function onMouseDown(e) {
                                e.preventDefault();
                            }
                        },
                        data: opt
                    }), _this3.formatOptionLabel(opt, 'value'));
                });
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ $kc00y.createElement(SingleValue, (0, $93c14b0a090563ae$export$2e2bcd8739ae039)({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled
                }), this.formatOptionLabel(singleValue, 'value'));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, isLoading = _this$props10.isLoading;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = {
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $kc00y.createElement(ClearIndicator, (0, $93c14b0a090563ae$export$2e2bcd8739ae039)({}, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props11 = this.props, isDisabled = _this$props11.isDisabled, isLoading = _this$props11.isLoading;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var innerProps = {
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $kc00y.createElement(LoadingIndicator, (0, $93c14b0a090563ae$export$2e2bcd8739ae039)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderIndicatorSeparator",
            value: function renderIndicatorSeparator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator, IndicatorSeparator = _this$getComponents5.IndicatorSeparator;
                // separator doesn't make sense without the dropdown indicator
                if (!DropdownIndicator || !IndicatorSeparator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                return /*#__PURE__*/ $kc00y.createElement(IndicatorSeparator, (0, $93c14b0a090563ae$export$2e2bcd8739ae039)({}, commonProps, {
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents6 = this.getComponents(), DropdownIndicator = _this$getComponents6.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                var innerProps = {
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $kc00y.createElement(DropdownIndicator, (0, $93c14b0a090563ae$export$2e2bcd8739ae039)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this4 = this;
                var _this$getComponents7 = this.getComponents(), Group = _this$getComponents7.Group, GroupHeading = _this$getComponents7.GroupHeading, Menu = _this$getComponents7.Menu, MenuList = _this$getComponents7.MenuList, MenuPortal = _this$getComponents7.MenuPortal, LoadingMessage = _this$getComponents7.LoadingMessage, NoOptionsMessage = _this$getComponents7.NoOptionsMessage, Option = _this$getComponents7.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props12 = this.props, captureMenuScroll = _this$props12.captureMenuScroll, inputValue = _this$props12.inputValue, isLoading = _this$props12.isLoading, loadingMessage = _this$props12.loadingMessage, minMenuHeight = _this$props12.minMenuHeight, maxMenuHeight = _this$props12.maxMenuHeight, menuIsOpen = _this$props12.menuIsOpen, menuPlacement = _this$props12.menuPlacement, menuPosition = _this$props12.menuPosition, menuPortalTarget = _this$props12.menuPortalTarget, menuShouldBlockScroll = _this$props12.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView, noOptionsMessage = _this$props12.noOptionsMessage, onMenuScrollToTop = _this$props12.onMenuScrollToTop, onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
                if (!menuIsOpen) return null;
                // TODO: Internal Option Type here
                var render = function render(props, id) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this4.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this4.selectOption(data);
                    };
                    var optionId = "".concat(_this4.getElementId('option'), "-").concat(id);
                    var innerProps = {
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        tabIndex: -1,
                        role: 'option',
                        'aria-selected': _this4.state.isAppleDevice ? undefined : isSelected // is not supported on Apple devices
                    };
                    return /*#__PURE__*/ $kc00y.createElement(Option, (0, $93c14b0a090563ae$export$2e2bcd8739ae039)({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
                    }), _this4.formatOptionLabel(props.data, 'menu'));
                };
                var menuUI;
                if (this.hasOptions()) menuUI = this.getCategorizedOptions().map(function(item) {
                    if (item.type === 'group') {
                        var _data = item.data, options = item.options, groupIndex = item.index;
                        var groupId = "".concat(_this4.getElementId('group'), "-").concat(groupIndex);
                        var headingId = "".concat(groupId, "-heading");
                        return /*#__PURE__*/ $kc00y.createElement(Group, (0, $93c14b0a090563ae$export$2e2bcd8739ae039)({}, commonProps, {
                            key: groupId,
                            data: _data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: _this4.formatGroupLabel(item.data)
                        }), item.options.map(function(option) {
                            return render(option, "".concat(groupIndex, "-").concat(option.index));
                        }));
                    } else if (item.type === 'option') return render(item, "".concat(item.index));
                });
                else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ $kc00y.createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ $kc00y.createElement(NoOptionsMessage, commonProps, _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ $kc00y.createElement((0, $24a11043b38fb627$export$3a1a48c8f6ef640e), (0, $93c14b0a090563ae$export$2e2bcd8739ae039)({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ $kc00y.createElement(Menu, (0, $93c14b0a090563ae$export$2e2bcd8739ae039)({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: {
                            onMouseDown: _this4.onMenuMouseDown,
                            onMouseMove: _this4.onMenuMouseMove
                        },
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ $kc00y.createElement($aa2db46ed739bc62$var$ScrollManager, {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        return /*#__PURE__*/ $kc00y.createElement(MenuList, (0, $93c14b0a090563ae$export$2e2bcd8739ae039)({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this4.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            innerProps: {
                                role: 'listbox',
                                'aria-multiselectable': commonProps.isMulti,
                                id: _this4.getElementId('listbox')
                            },
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), menuUI);
                    }));
                });
                // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/ $kc00y.createElement(MenuPortal, (0, $93c14b0a090563ae$export$2e2bcd8739ae039)({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this5 = this;
                var _this$props13 = this.props, delimiter = _this$props13.delimiter, isDisabled = _this$props13.isDisabled, isMulti = _this$props13.isMulti, name = _this$props13.name, required = _this$props13.required;
                var selectValue = this.state.selectValue;
                if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ $kc00y.createElement($aa2db46ed739bc62$var$RequiredInput$1, {
                    name: name,
                    onFocus: this.onValueInputFocus
                });
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this5.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ $kc00y.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ $kc00y.createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this5.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ $kc00y.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: ""
                        });
                        return /*#__PURE__*/ $kc00y.createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
                    return /*#__PURE__*/ $kc00y.createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state6 = this.state, ariaSelection = _this$state6.ariaSelection, focusedOption = _this$state6.focusedOption, focusedValue = _this$state6.focusedValue, isFocused = _this$state6.isFocused, selectValue = _this$state6.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ $kc00y.createElement($aa2db46ed739bc62$var$LiveRegion$1, (0, $93c14b0a090563ae$export$2e2bcd8739ae039)({}, commonProps, {
                    id: this.getElementId('live-region'),
                    ariaSelection: ariaSelection,
                    focusedOption: focusedOption,
                    focusedValue: focusedValue,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions,
                    isAppleDevice: this.state.isAppleDevice
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents8 = this.getComponents(), Control = _this$getComponents8.Control, IndicatorsContainer = _this$getComponents8.IndicatorsContainer, SelectContainer = _this$getComponents8.SelectContainer, ValueContainer = _this$getComponents8.ValueContainer;
                var _this$props14 = this.props, className = _this$props14.className, id = _this$props14.id, isDisabled = _this$props14.isDisabled, menuIsOpen = _this$props14.menuIsOpen;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                return /*#__PURE__*/ $kc00y.createElement(SelectContainer, (0, $93c14b0a090563ae$export$2e2bcd8739ae039)({}, commonProps, {
                    className: className,
                    innerProps: {
                        id: id,
                        onKeyDown: this.onKeyDown
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), /*#__PURE__*/ $kc00y.createElement(Control, (0, $93c14b0a090563ae$export$2e2bcd8739ae039)({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen
                }), /*#__PURE__*/ $kc00y.createElement(ValueContainer, (0, $93c14b0a090563ae$export$2e2bcd8739ae039)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ $kc00y.createElement(IndicatorsContainer, (0, $93c14b0a090563ae$export$2e2bcd8739ae039)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused, instancePrefix = state.instancePrefix;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
                var selectValue = (0, $24a11043b38fb627$export$7f8ddf7c7c20b3cd)(value);
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var focusableOptions = menuIsOpen ? $aa2db46ed739bc62$var$buildFocusableOptions(props, selectValue) : [];
                    var focusableOptionsWithIds = menuIsOpen ? $aa2db46ed739bc62$var$buildFocusableOptionsWithIds($aa2db46ed739bc62$var$buildCategorizedOptions(props, selectValue), "".concat(instancePrefix, "-option")) : [];
                    var focusedValue = clearFocusValueOnUpdate ? $aa2db46ed739bc62$var$getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = $aa2db46ed739bc62$var$getNextFocusedOption(state, focusableOptions);
                    var focusedOptionId = $aa2db46ed739bc62$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedOptionId: focusedOptionId,
                        focusableOptionsWithIds: focusableOptionsWithIds,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                }
                // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                var newAriaSelection = ariaSelection;
                var hasKeptFocus = isFocused && prevWasFocused;
                if (isFocused && !hasKeptFocus) {
                    // If `value` or `defaultValue` props are not empty then announce them
                    // when the Select is initially focused
                    newAriaSelection = {
                        value: (0, $24a11043b38fb627$export$96f57966bedc81b4)(isMulti, selectValue, selectValue[0] || null),
                        options: selectValue,
                        action: 'initial-input-focus'
                    };
                    hasKeptFocus = !prevWasFocused;
                }
                // If the 'initial-input-focus' action has been set already
                // then reset the ariaSelection to null
                if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus') newAriaSelection = null;
                return (0, $7018b41fa193028d$export$2e2bcd8739ae039)((0, $7018b41fa193028d$export$2e2bcd8739ae039)((0, $7018b41fa193028d$export$2e2bcd8739ae039)({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props,
                    ariaSelection: newAriaSelection,
                    prevWasFocused: hasKeptFocus
                });
            }
        }
    ]);
    return Select;
}((0, $kc00y.Component));
$aa2db46ed739bc62$export$25ce5a424b770e84.defaultProps = $aa2db46ed739bc62$export$407448d2b89b1813;




















var $ac15ab874ad2390c$var$StateManagedSelect = /*#__PURE__*/ (0, $kc00y.forwardRef)(function(props, ref) {
    var baseSelectProps = (0, $13021495c1d5bd05$export$3b14a55fb2447963)(props);
    return /*#__PURE__*/ $kc00y.createElement((0, $aa2db46ed739bc62$export$25ce5a424b770e84), (0, $93c14b0a090563ae$export$2e2bcd8739ae039)({
        ref: ref
    }, baseSelectProps));
});
var $ac15ab874ad2390c$export$2e2bcd8739ae039 = $ac15ab874ad2390c$var$StateManagedSelect;
var $ac15ab874ad2390c$export$a7deb1594c5ce10e = function(_ref) {
    var nonce = _ref.nonce, children = _ref.children, cacheKey = _ref.cacheKey;
    var emotionCache = (0, $kc00y.useMemo)(function() {
        return (0, $a2c3ce2d1937b0cd$export$2e2bcd8739ae039)({
            key: cacheKey,
            nonce: nonce
        });
    }, [
        cacheKey,
        nonce
    ]);
    return /*#__PURE__*/ $kc00y.createElement((0, $c3711714c7fb2f16$export$e7094788287c5e9b), {
        value: emotionCache
    }, children);
};


const $cc51f773cf7126a7$var$selectStyle = {
    control: (provided)=>({
            ...provided,
            minWidth: 100,
            // Largeur fixe en pixels
            margin: "0 auto"
        }),
    menu: (provided)=>({
            ...provided,
            width: 300 // Largeur du menu déroulant
        })
};
var $cc51f773cf7126a7$export$2e2bcd8739ae039 = $cc51f773cf7126a7$var$selectStyle;


/**
 * Composant Select pour les enums.
 *
 * @param {Object} options - Les options à afficher dans le menu déroulant, sous forme de paires clé-valeur (enum).
 * @param {string} name - Le nom attribué au composant de sélection.
 * @param {Function} onChange - Fonction de rappel pour gérer les changements de sélection.
 * @typedef {Object} OptionSelectType - Représente une option avec une valeur et un libellé.
 * @property {string} value - La valeur de l'option.
 * @property {string} libelle - Le libellé à afficher pour l'option.
 */ function $eed37ff3d3e1f28c$var$SelectEnumOption({ options: options, name: name, onChange: onChangeCallback, value: value }) {
    const optionsArray = [];
    optionsArray.push({
        value: "",
        libelle: "Tous"
    });
    for(const key in options)// eslint-disable-next-line no-prototype-builtins
    if (Object.hasOwn(options, key)) optionsArray.push({
        value: key,
        libelle: options[key]
    });
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ac15ab874ad2390c$export$2e2bcd8739ae039), {
        styles: (0, $cc51f773cf7126a7$export$2e2bcd8739ae039),
        placeholder: "Tous",
        noOptionsMessage: ()=>"Aucune donn\xe9e trouv\xe9e",
        name: name,
        value: optionsArray.find((e)=>e.value === value),
        options: optionsArray,
        getOptionValue: (t)=>t.value,
        getOptionLabel: (t)=>t.libelle,
        onChange: (data)=>{
            onChangeCallback({
                name: name,
                value: data.value
            });
        }
    });
}
var $eed37ff3d3e1f28c$export$2e2bcd8739ae039 = $eed37ff3d3e1f28c$var$SelectEnumOption;










var $bkJfK = parcelRequire("bkJfK");

var $kc00y = parcelRequire("kc00y");





var $kc00y = parcelRequire("kc00y");
function $d054b7aa3e6e48aa$export$e70e6da722faba05(e, u, c, i) {
    var l = this, a = (0, $kc00y.useRef)(null), o = (0, $kc00y.useRef)(0), f = (0, $kc00y.useRef)(0), v = (0, $kc00y.useRef)(null), d = (0, $kc00y.useRef)([]), s = (0, $kc00y.useRef)(), m = (0, $kc00y.useRef)(), h = (0, $kc00y.useRef)(e), g = (0, $kc00y.useRef)(!0), x = (0, $kc00y.useRef)(), E = (0, $kc00y.useRef)();
    h.current = e;
    var b = "undefined" != typeof window, p = !u && 0 !== u && b;
    if ("function" != typeof e) throw new TypeError("Expected a function");
    u = +u || 0;
    var y = !!(c = c || {}).leading, w = !("trailing" in c) || !!c.trailing, T = !!c.flushOnExit && w, O = "maxWait" in c, F = "debounceOnServer" in c && !!c.debounceOnServer, L = O ? Math.max(+c.maxWait || 0, u) : null, A = (0, $kc00y.useMemo)(function() {
        var r = function(r) {
            var n = d.current, t = s.current;
            return d.current = s.current = null, o.current = r, f.current = f.current || r, m.current = h.current.apply(t, n);
        }, n = function(r, n) {
            p && cancelAnimationFrame(v.current), v.current = p ? requestAnimationFrame(r) : setTimeout(r, n);
        }, t = function(r) {
            if (!g.current) return !1;
            var n = r - a.current;
            return !a.current || n >= u || n < 0 || O && r - o.current >= L;
        }, e = function(n) {
            return v.current = null, w && d.current ? r(n) : (d.current = s.current = null, m.current);
        }, c = function r() {
            var c = Date.now();
            if (y && f.current === o.current && A(), t(c)) return e(c);
            if (g.current) {
                var i = u - (c - a.current), l = O ? Math.min(i, L - (c - o.current)) : i;
                n(r, l);
            }
        }, A = function() {
            i && i({});
        }, D = function() {
            if (b || F) {
                var e, i = Date.now(), f = t(i);
                if (d.current = [].slice.call(arguments), s.current = l, a.current = i, T && !x.current && (x.current = function() {
                    var r;
                    "hidden" === (null == (r = globalThis.document) ? void 0 : r.visibilityState) && E.current.flush();
                }, null == (e = globalThis.document) || null == e.addEventListener || e.addEventListener("visibilitychange", x.current)), f) {
                    if (!v.current && g.current) return o.current = a.current, n(c, u), y ? r(a.current) : m.current;
                    if (O) return n(c, u), r(a.current);
                }
                return v.current || n(c, u), m.current;
            }
        };
        return D.cancel = function() {
            var r = v.current;
            r && (p ? cancelAnimationFrame(v.current) : clearTimeout(v.current)), o.current = 0, d.current = a.current = s.current = v.current = null, r && i && i({});
        }, D.isPending = function() {
            return !!v.current;
        }, D.flush = function() {
            return v.current ? e(Date.now()) : m.current;
        }, D;
    }, [
        y,
        O,
        u,
        L,
        w,
        T,
        p,
        b,
        F,
        i
    ]);
    return E.current = A, (0, $kc00y.useEffect)(function() {
        return g.current = !0, function() {
            var r;
            T && E.current.flush(), x.current && (null == (r = globalThis.document) || null == r.removeEventListener || r.removeEventListener("visibilitychange", x.current), x.current = null), g.current = !1;
        };
    }, [
        T
    ]), A;
}
function $d054b7aa3e6e48aa$var$i(r, n) {
    return r === n;
}
function $d054b7aa3e6e48aa$export$21805fee57372823(n, t, l) {
    var a = l && l.equalityFn || $d054b7aa3e6e48aa$var$i, o = (0, $kc00y.useRef)(n), f = (0, $kc00y.useState)({})[1], v = $d054b7aa3e6e48aa$export$e70e6da722faba05((0, $kc00y.useCallback)(function(r) {
        o.current = r, f({});
    }, [
        f
    ]), t, l, f), d = (0, $kc00y.useRef)(n);
    return a(d.current, n) || (v(n), d.current = n), [
        o.current,
        v
    ];
}
function $d054b7aa3e6e48aa$export$7158785e55df0693(r, n, t) {
    var e = void 0 === t ? {} : t, u = e.leading, i = e.trailing, l = e.flushOnExit;
    return $d054b7aa3e6e48aa$export$e70e6da722faba05(r, n, {
        maxWait: n,
        leading: void 0 === u || u,
        trailing: void 0 === i || i,
        flushOnExit: void 0 !== l && l
    });
}





const $1a6f6d44ade81356$var$useQueryParams = ()=>{
    const { search: search } = (0, $7a844823b04d4282$export$45d76561a5302f2b)();
    const searchParams = new URLSearchParams(search);
    const res = {};
    searchParams.forEach((value, key)=>{
        let val;
        try {
            val = JSON.parse(value);
        } catch (_e) {
            val = value;
        }
        res[key] = val;
    });
    return res;
};
var $1a6f6d44ade81356$export$2e2bcd8739ae039 = $1a6f6d44ade81356$var$useQueryParams;





var $kc00y = parcelRequire("kc00y");



/**
 * Décore un entier pour l'afficher sous forme "naturelle"
 * @param value Number
 */ function $2d713d1c368e19d2$var$decorateInteger(value) {
    return new Intl.NumberFormat("fr-fr", {
        useGrouping: true
    }).format(value);
}
var $2d713d1c368e19d2$export$2e2bcd8739ae039 = $2d713d1c368e19d2$var$decorateInteger;




var $f078ed68da323eee$exports = {};

$parcel$export($f078ed68da323eee$exports, "cssPrimary", () => $f078ed68da323eee$export$a14f91ed79640f0e, (v) => $f078ed68da323eee$export$a14f91ed79640f0e = v);
$parcel$export($f078ed68da323eee$exports, "cssBlueDark", () => $f078ed68da323eee$export$a95f64d66bf81dfe, (v) => $f078ed68da323eee$export$a95f64d66bf81dfe = v);
$parcel$export($f078ed68da323eee$exports, "cssGrayDark", () => $f078ed68da323eee$export$978a4270fe822353, (v) => $f078ed68da323eee$export$978a4270fe822353 = v);
$parcel$export($f078ed68da323eee$exports, "cssGrayLight", () => $f078ed68da323eee$export$2e4179520a9fd187, (v) => $f078ed68da323eee$export$2e4179520a9fd187 = v);
$parcel$export($f078ed68da323eee$exports, "cssWhite", () => $f078ed68da323eee$export$82958aac2ce2121c, (v) => $f078ed68da323eee$export$82958aac2ce2121c = v);
$parcel$export($f078ed68da323eee$exports, "flexBasisForCenterPaginationBlock", () => $f078ed68da323eee$export$943c71b1bda9aceb, (v) => $f078ed68da323eee$export$943c71b1bda9aceb = v);
$parcel$export($f078ed68da323eee$exports, "pagination", () => $f078ed68da323eee$export$22fa394f3ba39578, (v) => $f078ed68da323eee$export$22fa394f3ba39578 = v);
$parcel$export($f078ed68da323eee$exports, "resultsDisplayed", () => $f078ed68da323eee$export$ac45ee1695a98816, (v) => $f078ed68da323eee$export$ac45ee1695a98816 = v);
$parcel$export($f078ed68da323eee$exports, "paginationBlock", () => $f078ed68da323eee$export$2f588562fd8b106c, (v) => $f078ed68da323eee$export$2f588562fd8b106c = v);
$parcel$export($f078ed68da323eee$exports, "pageSizeOptions", () => $f078ed68da323eee$export$5e848d0f0b9d35d3, (v) => $f078ed68da323eee$export$5e848d0f0b9d35d3 = v);
$parcel$export($f078ed68da323eee$exports, "navigate", () => $f078ed68da323eee$export$ff7962acd6052c28, (v) => $f078ed68da323eee$export$ff7962acd6052c28 = v);
$parcel$export($f078ed68da323eee$exports, "navigateDisable", () => $f078ed68da323eee$export$716d724ac4b9b0bb, (v) => $f078ed68da323eee$export$716d724ac4b9b0bb = v);
$parcel$export($f078ed68da323eee$exports, "center", () => $f078ed68da323eee$export$3481c78889e8fbe8, (v) => $f078ed68da323eee$export$3481c78889e8fbe8 = v);
$parcel$export($f078ed68da323eee$exports, "pointille", () => $f078ed68da323eee$export$ccdd9dc094b7bbfc, (v) => $f078ed68da323eee$export$ccdd9dc094b7bbfc = v);
$parcel$export($f078ed68da323eee$exports, "linkA", () => $f078ed68da323eee$export$a816aac1accc5e89, (v) => $f078ed68da323eee$export$a816aac1accc5e89 = v);
$parcel$export($f078ed68da323eee$exports, "active", () => $f078ed68da323eee$export$89da14300d534261, (v) => $f078ed68da323eee$export$89da14300d534261 = v);
$parcel$export($f078ed68da323eee$exports, "disabled", () => $f078ed68da323eee$export$683472f6198a076e, (v) => $f078ed68da323eee$export$683472f6198a076e = v);
$parcel$export($f078ed68da323eee$exports, "paginationLabel", () => $f078ed68da323eee$export$a941b4b1b0ba7fbd, (v) => $f078ed68da323eee$export$a941b4b1b0ba7fbd = v);
$parcel$export($f078ed68da323eee$exports, "itemPerPage", () => $f078ed68da323eee$export$2be7d4251b278816, (v) => $f078ed68da323eee$export$2be7d4251b278816 = v);
var $f078ed68da323eee$export$a14f91ed79640f0e;
var $f078ed68da323eee$export$a95f64d66bf81dfe;
var $f078ed68da323eee$export$978a4270fe822353;
var $f078ed68da323eee$export$2e4179520a9fd187;
var $f078ed68da323eee$export$82958aac2ce2121c;
var $f078ed68da323eee$export$943c71b1bda9aceb;
var $f078ed68da323eee$export$22fa394f3ba39578;
var $f078ed68da323eee$export$ac45ee1695a98816;
var $f078ed68da323eee$export$2f588562fd8b106c;
var $f078ed68da323eee$export$5e848d0f0b9d35d3;
var $f078ed68da323eee$export$ff7962acd6052c28;
var $f078ed68da323eee$export$716d724ac4b9b0bb;
var $f078ed68da323eee$export$3481c78889e8fbe8;
var $f078ed68da323eee$export$ccdd9dc094b7bbfc;
var $f078ed68da323eee$export$a816aac1accc5e89;
var $f078ed68da323eee$export$89da14300d534261;
var $f078ed68da323eee$export$683472f6198a076e;
var $f078ed68da323eee$export$a941b4b1b0ba7fbd;
var $f078ed68da323eee$export$2be7d4251b278816;
$f078ed68da323eee$export$a14f91ed79640f0e = "undefined";
$f078ed68da323eee$export$a95f64d66bf81dfe = "undefined";
$f078ed68da323eee$export$978a4270fe822353 = "undefined";
$f078ed68da323eee$export$2e4179520a9fd187 = "undefined";
$f078ed68da323eee$export$82958aac2ce2121c = "#ffffff";
$f078ed68da323eee$export$943c71b1bda9aceb = "400px";
$f078ed68da323eee$export$22fa394f3ba39578 = "pagination_3238f1";
$f078ed68da323eee$export$ac45ee1695a98816 = "resultsDisplayed_3238f1";
$f078ed68da323eee$export$2f588562fd8b106c = "paginationBlock_3238f1";
$f078ed68da323eee$export$5e848d0f0b9d35d3 = "pageSizeOptions_3238f1";
$f078ed68da323eee$export$ff7962acd6052c28 = "navigate_3238f1";
$f078ed68da323eee$export$716d724ac4b9b0bb = "navigateDisable_3238f1";
$f078ed68da323eee$export$3481c78889e8fbe8 = "center_3238f1";
$f078ed68da323eee$export$ccdd9dc094b7bbfc = "pointille_3238f1";
$f078ed68da323eee$export$a816aac1accc5e89 = "linkA_3238f1";
$f078ed68da323eee$export$89da14300d534261 = "active_3238f1";
$f078ed68da323eee$export$683472f6198a076e = "disabled_3238f1";
$f078ed68da323eee$export$a941b4b1b0ba7fbd = "paginationLabel_3238f1";
$f078ed68da323eee$export$2be7d4251b278816 = "itemPerPage_3238f1";


const $6ba5340bec609b1f$var$PAGINATION_DEFAULT = (0, $f740b0d032822ba6$export$910193943608ef65).toString();
const $6ba5340bec609b1f$var$PAGINATION_KEY = "itemsPerPage";
const $6ba5340bec609b1f$var$PAGINATION_VALUES = (0, $f740b0d032822ba6$export$c12542e899d17513).map((data)=>{
    return {
        value: data,
        label: data
    };
});
const $6ba5340bec609b1f$var$usePaginationInLocalStorage = ()=>{
    const [itemsPerPage, setItemsPerPage] = (0, $kc00y.useState)(parseInt(localStorage.getItem($6ba5340bec609b1f$var$PAGINATION_KEY) || $6ba5340bec609b1f$var$PAGINATION_DEFAULT));
    (0, $kc00y.useEffect)(()=>{
        localStorage.setItem($6ba5340bec609b1f$var$PAGINATION_KEY, itemsPerPage.toString());
    }, [
        itemsPerPage
    ]);
    return [
        itemsPerPage,
        setItemsPerPage
    ];
};
const $6ba5340bec609b1f$export$f9468bb008747ceb = ()=>{
    const { limit: l, offset: o = 0 } = (0, $1a6f6d44ade81356$export$2e2bcd8739ae039)();
    let val = l;
    if (l === undefined) val = parseInt(localStorage.getItem($6ba5340bec609b1f$var$PAGINATION_KEY) || $6ba5340bec609b1f$var$PAGINATION_DEFAULT);
    const [pagination, setPagination] = (0, $kc00y.useState)({
        limit: val,
        offset: o
    });
    const setValue = ({ limit: limit, offset: offset })=>{
        const l = limit;
        const o = offset;
        setPagination({
            limit: !isNaN(l) ? l : parseInt(localStorage.getItem($6ba5340bec609b1f$var$PAGINATION_KEY) || $6ba5340bec609b1f$var$PAGINATION_DEFAULT),
            offset: !isNaN(o) ? o : 0
        });
    };
    return [
        pagination,
        setValue
    ];
};
const $6ba5340bec609b1f$export$f80c710216eae131 = ({ total: total = 0, offset: offset = 0 })=>{
    const [itemsPerPage, setItemsPerPage] = $6ba5340bec609b1f$var$usePaginationInLocalStorage();
    const maxPage = Math.ceil(total / itemsPerPage);
    const currentPage = Math.trunc(offset / itemsPerPage);
    return {
        itemsPerPage: itemsPerPage,
        setItemsPerPage: setItemsPerPage,
        currentPage: currentPage,
        total: total,
        canPrevious: currentPage > 0,
        canNext: currentPage < maxPage - 1,
        getVisiblePages () {
            if (maxPage < 7) return [
                1,
                2,
                3,
                4,
                5,
                6
            ].filter((page)=>page <= maxPage);
            else {
                if (currentPage >= 0 && currentPage > 3 && currentPage + 2 < maxPage) return [
                    1,
                    currentPage,
                    currentPage + 1,
                    currentPage + 2,
                    maxPage
                ];
                else if (currentPage >= 0 && currentPage > 4 && currentPage + 2 >= maxPage) return [
                    1,
                    maxPage - 3,
                    maxPage - 2,
                    maxPage - 1,
                    maxPage
                ];
                else return [
                    1,
                    2,
                    3,
                    4,
                    5,
                    maxPage
                ];
            }
        }
    };
};
const $6ba5340bec609b1f$export$12d7c70bb59bfd22 = (search, itemsPerPage, offset)=>{
    const searchParams = new URLSearchParams(search);
    searchParams.set("offset", offset < 0 ? 0 : offset);
    searchParams.set("limit", itemsPerPage);
    return decodeURIComponent(searchParams.toString());
};
const $6ba5340bec609b1f$var$Pagination = ({ className: className, isLoading: isLoading, previousText: previousText = /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$41884575254a94be), {}), nextText: nextText = /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$3213a407ffb0559), {}), count: count = 0, paginationState: paginationState, dataLength: dataLength = 0 })=>{
    const [pagination, setPagination] = paginationState;
    const { canPrevious: canPrevious, canNext: canNext, getVisiblePages: getVisiblePages, currentPage: currentPage, itemsPerPage: itemsPerPage, setItemsPerPage: setItemsPerPage } = $6ba5340bec609b1f$export$f80c710216eae131({
        total: count,
        offset: pagination.offset
    });
    const [inputPage, setInputPage] = (0, $kc00y.useState)(currentPage + 1);
    /**
   * Synchronise le champ de saisie `inputPage` avec la page actuelle (`currentPage`).
   *
   * Ce cas se produit si la page change par un autre moyen que le champ (ex : clic sur les boutons Précédent/Suivant).
   * On met alors à jour le champ pour qu'il reflète bien la nouvelle page.
   *
   * Note : on ajoute 1, car `currentPage` est basé sur un index 0, même si l'affichage commence à 1.
   */ (0, $kc00y.useEffect)(()=>{
        setInputPage(currentPage + 1); // synchronise champ si currentPage change ailleurs
    }, [
        currentPage
    ]);
    /**
   * Met à jour la pagination avec un petit délai (500ms) après la dernière saisie.
   *
   * Cela évite d'exécuter une requête à chaque frappe lorsque l'utilisateur tape un numéro de page.
   * Exemple : si l'utilisateur tape "123", on attend qu'il ait terminé (ou qu'il s'arrête un court moment)
   * avant de lancer le setPagination — sinon on aurait 3 appels pour "1", "12", "123".
   *
   * Si le champ est vide ou contient une valeur invalide (ex: lettres), la pagination n'est pas déclenchée.
   */ (0, $kc00y.useEffect)(()=>{
        const timeout = setTimeout(()=>{
            if (inputPage === "" || isNaN(Number(inputPage))) return;
            const offset = itemsPerPage * (Number(inputPage) - 1);
            if (pagination.limit !== itemsPerPage || pagination.offset !== offset) setPagination({
                limit: itemsPerPage,
                offset: offset
            });
            if (count > 0 && pagination.offset >= count) setPagination({
                offset: 0,
                limit: pagination.limit
            });
        }, 500); // délai de 500ms
        return ()=>clearTimeout(timeout);
    }, [
        inputPage,
        itemsPerPage,
        setPagination,
        pagination,
        count
    ]); // déclenche seulement si inputPage change
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, (0, (/*@__PURE__*/$parcel$interopDefault($f078ed68da323eee$exports))).pagination),
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($f078ed68da323eee$exports))).resultsDisplayed,
                children: dataLength > 0 && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                    children: [
                        "Affichage des r\xe9sultats",
                        " ",
                        (0, $2d713d1c368e19d2$export$2e2bcd8739ae039)(itemsPerPage * currentPage + 1),
                        " \xe0",
                        " ",
                        (0, $2d713d1c368e19d2$export$2e2bcd8739ae039)(currentPage > 0 ? itemsPerPage * (currentPage + 1) - (itemsPerPage - dataLength) : dataLength),
                        "\xa0sur ",
                        (0, $2d713d1c368e19d2$export$2e2bcd8739ae039)(count)
                    ]
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($f078ed68da323eee$exports))).paginationBlock,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                    className: "d-flex align-items-center gap-2 flex-wrap",
                    children: [
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($6ba5340bec609b1f$var$InputPage, {
                            page: inputPage,
                            onChange: (e)=>{
                                const value = e.target.value;
                                /**
           * Autorise uniquement :
           * - une chaîne vide (pour laisser l'utilisateur effacer)
           * - un entier positif ≤ au nombre total de pages
           *
           * Empêche la saisie de lettres ou d'une page hors limites.
           */ if (value === "" || /^\d+$/.test(value) && value <= Math.ceil(count / itemsPerPage)) setInputPage(value === "" ? "" : Number(value));
                            }
                        }),
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                            variant: "outline-primary",
                            size: "sm",
                            className: "border-0",
                            disabled: !canPrevious || isLoading,
                            onClick: ()=>{
                                setPagination({
                                    limit: itemsPerPage,
                                    offset: pagination.offset - itemsPerPage
                                });
                            },
                            children: previousText
                        }),
                        getVisiblePages().map((val, i, array)=>{
                            const page = val - 1;
                            const showDots = i > 0 && array[i - 1] + 1 < val;
                            return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                                className: "d-flex align-items-center",
                                children: [
                                    showDots && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("span", {
                                        className: "mx-1 text-muted",
                                        children: "\u2026"
                                    }),
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                                        variant: currentPage === page ? "info" : "outline-primary",
                                        size: "sm",
                                        className: "border-0",
                                        onClick: ()=>setPagination({
                                                limit: itemsPerPage,
                                                offset: itemsPerPage * page
                                            }),
                                        children: val
                                    })
                                ]
                            }, i);
                        }),
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                            variant: "outline-primary",
                            className: "border-0",
                            size: "sm",
                            disabled: !canNext || isLoading,
                            onClick: ()=>{
                                setPagination({
                                    limit: itemsPerPage,
                                    offset: pagination.offset + itemsPerPage
                                });
                            },
                            children: nextText
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($f078ed68da323eee$exports))).pageSizeOptions,
                children: dataLength > 0 && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($f078ed68da323eee$exports))).paginationLabel,
                    children: [
                        "R\xe9sultats par page :",
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ac15ab874ad2390c$export$2e2bcd8739ae039), {
                            menuPlacement: "auto",
                            className: "ms-2",
                            value: $6ba5340bec609b1f$var$PAGINATION_VALUES.find((data)=>data.value === itemsPerPage) || {
                                value: itemsPerPage,
                                label: itemsPerPage
                            },
                            options: $6ba5340bec609b1f$var$PAGINATION_VALUES,
                            onChange: ({ value: value })=>{
                                setItemsPerPage(value);
                                setPagination({
                                    limit: value,
                                    offset: 0
                                });
                            },
                            closeMenuOnSelect: true,
                            isClearable: false
                        })
                    ]
                })
            })
        ]
    });
};
const $6ba5340bec609b1f$var$InputPage = ({ onChange: onChange, page: page = 1 })=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $64fb4d6c077c0e42$export$2e2bcd8739ae039), {
        controlId: "floatingPage",
        label: "Page",
        style: {
            width: "70px"
        },
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Control, {
            type: "number",
            step: 1,
            min: 1,
            value: page,
            onChange: onChange,
            size: "sm",
            placeholder: "Page"
        })
    });
};
var $6ba5340bec609b1f$export$2e2bcd8739ae039 = $6ba5340bec609b1f$var$Pagination;


var $cd31b042207f25f7$exports = {};

$parcel$export($cd31b042207f25f7$exports, "sort", () => $cd31b042207f25f7$export$97db5808d8f88186, (v) => $cd31b042207f25f7$export$97db5808d8f88186 = v);
$parcel$export($cd31b042207f25f7$exports, "sortActive", () => $cd31b042207f25f7$export$455a77922391a8cc, (v) => $cd31b042207f25f7$export$455a77922391a8cc = v);
var $cd31b042207f25f7$export$97db5808d8f88186;
var $cd31b042207f25f7$export$455a77922391a8cc;
$cd31b042207f25f7$export$97db5808d8f88186 = `ziAJ3W_sort`;
$cd31b042207f25f7$export$455a77922391a8cc = `ziAJ3W_sortActive`;


const $9a9eebc3462fba73$export$769dcabd4dad14b5 = ()=>{
    const { sortBy: init = {} } = (0, $1a6f6d44ade81356$export$2e2bcd8739ae039)();
    const [sortBy, setSortBy] = (0, $kc00y.useState)(init);
    return [
        sortBy,
        setSortBy
    ];
};
const $9a9eebc3462fba73$export$396ef541d9951d45 = (initialValues)=>{
    const { filterBy: filterBy } = (0, $1a6f6d44ade81356$export$2e2bcd8739ae039)();
    const formik = (0, $bkJfK.useFormik)({
        initialValues: filterBy ?? initialValues,
        onSubmit: (values)=>{
            alert(JSON.stringify(values, null, 2));
        },
        validateOnChange: false,
        validateOnBlur: true
    });
    const { values: values, setValues: setValues, setFieldValue: setFieldValue } = {
        values: formik.values,
        setValues: formik.setValues,
        setFieldValue: formik.setFieldValue
    };
    const handleChange = (e)=>{
        formik.handleChange(e);
    };
    return {
        values: values,
        setValues: setValues,
        formik: formik,
        handleChange: handleChange,
        setFieldValue: setFieldValue
    };
};
function $9a9eebc3462fba73$var$QueryTable({ query: query, queryParams: queryParams, asyncOptions: asyncOptions, getList: getList = (data)=>data?.list, getCount: getCount = (data)=>data?.count, columns: columns = [], idName: idName = "id", displayNone: displayNone = false, className: className, trClassName: trClassName, filterContext: filterContext = {}, filterValuesToVariable: filterValuesToVariable = (values)=>values }) {
    const { formik: formik, setValues: setValues } = filterContext;
    const [tableState, setTableState] = (0, $kc00y.useState)([]);
    const getIdForKey = (row, append = "")=>row[idName] + "" + append;
    const navigate = (0, $7a844823b04d4282$export$9770f232ac06a008)();
    const { filterBy: initialFilterBy } = (0, $1a6f6d44ade81356$export$2e2bcd8739ae039)();
    const location = (0, $7a844823b04d4282$export$45d76561a5302f2b)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [sortBy, setSortBy] = $9a9eebc3462fba73$export$769dcabd4dad14b5();
    const [pagination, setPaginationTemp] = (0, $6ba5340bec609b1f$export$f9468bb008747ceb)(); // eslint-disable-line react-hooks/rules-of-hooks
    let setPagination = setPaginationTemp;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    setPagination = ({ offset: offset, limit: limit })=>{
        setPaginationTemp({
            limit: limit,
            offset: offset
        });
        navigate({
            search: (0, $6ba5340bec609b1f$export$12d7c70bb59bfd22)(document.location.search, limit, offset)
        }, {
            state: location.state
        });
    };
    const [filterBy, setFilterBy] = (0, $kc00y.useState)(filterValuesToVariable(initialFilterBy ?? {}));
    // Fonction de mise à jour de l'URL
    const historyPushSync = ()=>{
        const f = filterValuesToVariable(formik?.values);
        const filter = Object.values(f).filter(Boolean).length ? JSON.stringify(f) : null;
        const sort = Object.values(sortBy).filter(Boolean).length ? JSON.stringify(sortBy) : null;
        const searchParams = new URLSearchParams(location?.search);
        if (filter !== searchParams.get("filterBy") || sort !== searchParams.get("sortBy")) {
            if (filter) searchParams.set("filterBy", filter);
            else searchParams.delete("filterBy");
            if (sort) searchParams.set("sortBy", sort);
            else searchParams.delete("sortBy");
            searchParams.set("limit", pagination.limit);
            searchParams.set("offset", pagination.offset ?? "0");
            navigate({
                search: decodeURIComponent(searchParams.toString())
            }, {
                state: location.state
            });
            setFilterBy(filterValuesToVariable(formik?.values));
            // Si on change de filtres, on se remet à la première page
            setPagination({
                offset: 0,
                limit: pagination.limit
            });
        } else if (searchParams.get("offset") !== pagination.offset.toString() || searchParams.get("limit") !== pagination.limit.toString()) {
            searchParams.set("limit", pagination.limit);
            searchParams.set("offset", pagination.offset ?? "0");
            navigate({
                search: decodeURIComponent(searchParams.toString())
            }, {
                state: location.state
            });
        }
    };
    const debounceSearch = (0, $d054b7aa3e6e48aa$export$e70e6da722faba05)(()=>{
        historyPushSync();
    }, 500);
    // Quand les filtres changent, on debounce la mise à jour de l'URL
    // Quand le tri change, on met à jour immédiatement
    // biome-ignore lint/correctness/useExhaustiveDependencies: historyPushSync est une fonction recréée à chaque render, on ne veut pas l'ajouter comme dépendance
    (0, $kc00y.useEffect)(()=>{
        historyPushSync();
    }, [
        sortBy
    ]);
    // biome-ignore lint/correctness/useExhaustiveDependencies: debounceSearch est stable et appelle toujours la dernière version de historyPushSync
    (0, $kc00y.useEffect)(()=>{
        debounceSearch();
    }, [
        formik?.values
    ]);
    const { isRejected: isRejected, isLoading: isLoading, data: data, run: run } = (0, $8d9ebd8892d8a5f5$export$9158e33c8d0ca687)(queryParams ? query + "?" + (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`${queryParams}` : query, asyncOptions);
    const firstMount = (0, $kc00y.useRef)(true);
    (0, $kc00y.useEffect)(()=>{
        const fetchData = ()=>{
            // on ne veut pas relancer un chargement immédiatement si on passe un state parent
            if (firstMount.current) firstMount.current = false;
            if (JSON.stringify(tableState) !== JSON.stringify([
                filterBy,
                sortBy,
                pagination.limit,
                pagination.offset
            ])) {
                setTableState([
                    filterBy,
                    sortBy,
                    pagination.limit,
                    pagination.offset
                ]);
                if (pagination.limit >= 0 && pagination.offset >= 0) run({
                    limit: pagination.limit,
                    offset: pagination.offset,
                    filterBy: filterBy,
                    sortBy: sortBy
                });
            }
        };
        fetchData();
    }, [
        filterBy,
        sortBy,
        pagination.limit,
        pagination.offset,
        run,
        tableState
    ]);
    if (isRejected) return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
        children: "Une erreur est survenue."
    });
    const makeRow = (row)=>{
        return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("tr", {
            className: trClassName,
            children: columns.map((column, j)=>makeCell(column, row, getIdForKey(row, j.toString())))
        }, getIdForKey(row));
    };
    const makeCell = (column, row, key)=>{
        const { Cell: Cell, accessor: accessor } = column;
        let res = null;
        let acc = null;
        if (typeof accessor === "function") acc = accessor(row);
        else acc = row[accessor];
        if (Cell) res = /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)(Cell, {
            value: acc,
            original: row
        });
        else res = acc;
        return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("td", {
            className: "m-0 p-0 ps-1",
            style: {
                verticalAlign: "middle",
                lineHeight: "normal"
            },
            children: res
        }, key);
    };
    const makeHeader = (column, key)=>{
        const { Header: Header, sortField: sortField, classNameHeader: classNameHeader, width: width, Filter: Filter } = column;
        const isSortedAsc = sortBy[sortField] < 0;
        const isSortedDesc = sortBy[sortField] > 0;
        const toggleSort = ()=>{
            if (!sortField) return;
            setSortBy((prevSortBy)=>{
                const newSortBy = {
                    ...prevSortBy
                };
                const sortFields = Object.keys(newSortBy).filter((field)=>field !== sortField);
                // Determine if current field is being sorted
                const isAsc = newSortBy[sortField] > 0;
                const isDesc = newSortBy[sortField] < 0;
                if (isAsc) {
                    // From ASC to DESC
                    sortFields.push(sortField);
                    newSortBy[sortField] = `-${sortFields.length}`;
                } else if (isDesc) // Remove sort field
                delete newSortBy[sortField];
                else {
                    // Add as ASC at the end
                    sortFields.push(sortField);
                    newSortBy[sortField] = `${sortFields.length}`;
                }
                // Recalculate all weights in order
                const finalSortBy = {};
                let i = 1;
                for (const field of Object.keys(newSortBy)){
                    const isNegative = newSortBy[field] < 0;
                    finalSortBy[field] = `${isNegative ? "-" : ""}${i}`;
                    i++;
                }
                return finalSortBy;
            });
        };
        return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("th", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))("text-center", classNameHeader),
            style: {
                width: width,
                verticalAlign: "top"
            },
            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                className: "d-flex flex-column h-100",
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                        className: "p-1",
                        onClick: toggleSort,
                        style: {
                            cursor: "pointer"
                        },
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                            xs: 12,
                            className: "align-self-start text-nowrap",
                            children: [
                                Header,
                                sortField && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("span", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($cd31b042207f25f7$exports))).sort, {
                                        [(0, (/*@__PURE__*/$parcel$interopDefault($cd31b042207f25f7$exports))).sortActive]: isSortedAsc || isSortedDesc
                                    }, "m-1"),
                                    children: isSortedAsc ? "\u25B2" : isSortedDesc ? "\u25BC" : "\u2B0D"
                                })
                            ]
                        })
                    }),
                    Filter && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                            xs: 12,
                            children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).cloneElement(Filter, {
                                onChange: ({ name: name, value: value })=>formik.setFieldValue(name, value),
                                onBlur: formik.handleBlur,
                                defaultValue: formik?.values[Filter?.props?.name] || "",
                                value: formik?.values[Filter?.props?.name] || ""
                            })
                        })
                    })
                ]
            })
        }, key);
    };
    return !displayNone && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                className: "d-flex justify-content-end mb-2",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                    variant: "danger",
                    className: "text-light",
                    onClick: ()=>{
                        const searchParams = new URLSearchParams(location?.search);
                        searchParams.delete("filterBy");
                        // Réinitialiser tous les filtres
                        setFilterBy({});
                        setSortBy({});
                        setValues({});
                        formik.setValues({});
                        formik.resetForm({
                            values: {}
                        });
                        // On remet la pagination à zéro
                        setPagination({
                            offset: 0,
                            limit: pagination.limit
                        });
                        // On met à jour l'URL
                        navigate({
                            search: decodeURIComponent(searchParams.toString())
                        }, {
                            state: location.state
                        });
                    },
                    children: "Effacer les filtres"
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $13de46b4dfcc473f$export$2e2bcd8739ae039), {
                striped: true,
                bordered: true,
                hover: true,
                className: className,
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("thead", {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("tr", {
                            children: columns.map((column, i)=>makeHeader(column, i.toString()))
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("tbody", {
                        children: isLoading ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("tr", {
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("td", {
                                children: "Chargement en cours"
                            })
                        }) : getList(data)?.length === 0 ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("tr", {
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("td", {
                                children: "Aucune donn\xe9e"
                            })
                        }) : /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
                            children: getList?.(data)?.map(makeRow)
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $6ba5340bec609b1f$export$2e2bcd8739ae039), {
                isLoading: isLoading,
                count: getCount(data),
                paginationState: [
                    pagination,
                    setPagination
                ],
                dataLength: getList(data)?.length,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))({
                    "d-none": displayNone
                })
            })
        ]
    });
}
var $9a9eebc3462fba73$export$2e2bcd8739ae039 = $9a9eebc3462fba73$var$QueryTable;




var $bkJfK = parcelRequire("bkJfK");

var $kc00y = parcelRequire("kc00y");


var $e8a2c985711dfc19$var$FILTER_PAGE = /*#__PURE__*/ function(FILTER_PAGE) {
    FILTER_PAGE[FILTER_PAGE["INDISPONIBILITE_TEMPORAIRE"] = 0] = "INDISPONIBILITE_TEMPORAIRE";
    FILTER_PAGE[FILTER_PAGE["TOURNEE"] = 1] = "TOURNEE";
    FILTER_PAGE[FILTER_PAGE["PEI_LONGUE_INDISPO"] = 2] = "PEI_LONGUE_INDISPO";
    return FILTER_PAGE;
}($e8a2c985711dfc19$var$FILTER_PAGE || {});
var $e8a2c985711dfc19$export$2e2bcd8739ae039 = $e8a2c985711dfc19$var$FILTER_PAGE;


/**
 * Les types possibles de données en cache à demander au endpoint nomenclatures/list
 */ var $0d1c1a6d7932bf75$export$9a2acd5fd49b44db = /*#__PURE__*/ function(NOMENCLATURE) {
    NOMENCLATURE["SIGNALEMENT_TYPE_ANOMALIE"] = "signalement_type_anomalie";
    NOMENCLATURE["SIGNALEMENT_TYPE_ELEMENT"] = "signalement_type_element";
    NOMENCLATURE["ANOMALIE"] = "anomalie";
    NOMENCLATURE["ANOMALIE_CATEGORIE"] = "anomalie_categorie";
    NOMENCLATURE["EVENEMENT_CATEGORIE"] = "evenement_categorie";
    NOMENCLATURE["DIAMETRE"] = "diametre";
    NOMENCLATURE["DOMAINE"] = "domaine";
    NOMENCLATURE["FONCTION_CONTACT"] = "fonction_contact";
    NOMENCLATURE["NATURE"] = "nature";
    NOMENCLATURE["NATURE_PIBI"] = "nature_pibi";
    NOMENCLATURE["NATURE_PENA"] = "nature_pena";
    NOMENCLATURE["NATURE_DECI"] = "nature_deci";
    NOMENCLATURE["MARQUE_PIBI"] = "marque_pibi";
    NOMENCLATURE["MATERIAU"] = "materiau";
    NOMENCLATURE["MODELE_PIBI"] = "modele_pibi";
    NOMENCLATURE["NIVEAU"] = "niveau";
    NOMENCLATURE["RESERVOIR"] = "reservoir";
    NOMENCLATURE["PROFIL_ORGANISME"] = "profil_organisme";
    NOMENCLATURE["PROFIL_UTILISATEUR"] = "profil_utilisateur";
    NOMENCLATURE["ROLE_CONTACT"] = "role_contact";
    NOMENCLATURE["THEMATIQUE"] = "thematique";
    NOMENCLATURE["RCCI_INDICE_ROTHERMEL"] = "rcci_indice_rothermel";
    NOMENCLATURE["RCCI_TYPE_PROMETHEE_FAMILLE"] = "rcci_type_promethee_famille";
    NOMENCLATURE["RCCI_TYPE_PROMETHEE_PARTITION"] = "rcci_type_promethee_partition";
    NOMENCLATURE["RCCI_TYPE_PROMETHEE_CATEGORIE"] = "rcci_type_promethee_categorie";
    NOMENCLATURE["RCCI_TYPE_DEGRE_CERTITUDE"] = "rcci_type_degre_certitude";
    NOMENCLATURE["RCCI_TYPE_ORIGINE_ALERTE"] = "rcci_type_origine_alerte";
    NOMENCLATURE["DIRECTION"] = "direction";
    NOMENCLATURE["TYPE_ENGIN"] = "type_engin";
    NOMENCLATURE["TYPE_ETUDE"] = "type_etude";
    NOMENCLATURE["TYPE_CANALISATION"] = "type_canalisation";
    NOMENCLATURE["TYPE_CRISE"] = "type_crise";
    NOMENCLATURE["TYPE_ORGANISME"] = "type_organisme";
    NOMENCLATURE["TYPE_PENA_ASPIRATION"] = "type_pena_aspiration";
    NOMENCLATURE["TYPE_RESEAU"] = "type_reseau";
    NOMENCLATURE["OLDEB_TYPE_ACTION"] = "oldeb_type_action";
    NOMENCLATURE["OLDEB_TYPE_AVIS"] = "oldeb_type_avis";
    NOMENCLATURE["OLDEB_TYPE_DEBROUSSAILLEMENT"] = "oldeb_type_debroussaillement";
    NOMENCLATURE["OLDEB_TYPE_ANOMALIE"] = "oldeb_type_anomalie";
    NOMENCLATURE["OLDEB_TYPE_CATEGORIE_ANOMALIE"] = "oldeb_type_categorie_anomalie";
    NOMENCLATURE["OLDEB_TYPE_ACCES"] = "oldeb_type_acces";
    NOMENCLATURE["OLDEB_TYPE_RESIDENCE"] = "oldeb_type_residence";
    NOMENCLATURE["OLDEB_TYPE_SUITE"] = "oldeb_type_suite";
    NOMENCLATURE["OLDEB_TYPE_ZONE_URBANISME"] = "oldeb_type_zone_urbanisme";
    NOMENCLATURE["OLDEB_TYPE_CARACTERISTIQUE"] = "oldeb_type_caracteristique";
    NOMENCLATURE["OLDEB_TYPE_CATEGORIE_CARACTERISTIQUE"] = "oldeb_type_categorie_caracteristique";
    return NOMENCLATURE;
}({});
var $0d1c1a6d7932bf75$export$1d91abf8b407cf2e = /*#__PURE__*/ function(NOMENCLATURE_ORGANISME) {
    NOMENCLATURE_ORGANISME["SERVICE_PUBLIC_DECI"] = "servicePublicDeci";
    NOMENCLATURE_ORGANISME["AUTORITE_DECI"] = "autoriteDeci";
    return NOMENCLATURE_ORGANISME;
}({});
var $0d1c1a6d7932bf75$export$2e2bcd8739ae039 = $0d1c1a6d7932bf75$export$9a2acd5fd49b44db;


/**
 * Énumération des paramètres de configuration
 */ var $ee297f06e8568bf4$var$PARAMETRE = /*#__PURE__*/ function(PARAMETRE) {
    PARAMETRE["SIGNALEMENT_DELIBERATION_CORPS_EMAIL"] = "SIGNALEMENT_DELIBERATION_CORPS_EMAIL";
    PARAMETRE["SIGNALEMENT_DELIBERATION_DESTINATAIRE_EMAIL"] = "SIGNALEMENT_DELIBERATION_DESTINATAIRE_EMAIL";
    PARAMETRE["SIGNALEMENT_DELIBERATION_OBJET_EMAIL"] = "SIGNALEMENT_DELIBERATION_OBJET_EMAIL";
    PARAMETRE["AFFICHAGE_INDISPO"] = "AFFICHAGE_INDISPO";
    PARAMETRE["AFFICHAGE_SYMBOLES_NORMALISES"] = "AFFICHAGE_SYMBOLES_NORMALISES";
    PARAMETRE["ACCUEIL_PUBLIC"] = "ACCUEIL_PUBLIC";
    PARAMETRE["BAN_CODE_DEPARTEMENT"] = "BAN_CODE_DEPARTEMENT";
    PARAMETRE["BRIDAGE_PHOTO"] = "BRIDAGE_PHOTO";
    PARAMETRE["BUFFER_CARTE"] = "BUFFER_CARTE";
    PARAMETRE["CARACTERISTIQUE_PENA"] = "CARACTERISTIQUE_PENA";
    PARAMETRE["CARACTERISTIQUE_PIBI"] = "CARACTERISTIQUE_PIBI";
    PARAMETRE["CARACTERISTIQUES_PENA_TOOLTIP_WEB"] = "CARACTERISTIQUES_PENA_TOOLTIP_WEB";
    PARAMETRE["CARACTERISTIQUES_PIBI_TOOLTIP_WEB"] = "CARACTERISTIQUES_PIBI_TOOLTIP_WEB";
    PARAMETRE["COORDONNEES_FORMAT_AFFICHAGE"] = "COORDONNEES_FORMAT_AFFICHAGE";
    PARAMETRE["COURRIER_RESTRICTION_ZC"] = "COURRIER_RESTRICTION_ZC";
    PARAMETRE["CREATION_PEI_MOBILE"] = "CREATION_PEI_MOBILE";
    PARAMETRE["DECI_DISTANCE_MAX_PARCOURS"] = "DECI_DISTANCE_MAX_PARCOURS";
    PARAMETRE["DECI_ISODISTANCES"] = "DECI_ISODISTANCES";
    PARAMETRE["DECLARATION_PEI_DESTINATAIRE_EMAIL"] = "DECLARATION_PEI_DESTINATAIRE_EMAIL";
    PARAMETRE["DECLARATION_PEI_OBJET_EMAIL"] = "DECLARATION_PEI_OBJET_EMAIL";
    PARAMETRE["DECLARATION_PEI_CORPS_EMAIL"] = "DECLARATION_PEI_CORPS_EMAIL";
    PARAMETRE["DFCI_TRAVAUX_DESTINATAIRE_EMAIL"] = "DFCI_TRAVAUX_DESTINATAIRE_EMAIL";
    PARAMETRE["DFCI_TRAVAUX_OBJET_EMAIL"] = "DFCI_TRAVAUX_OBJET_EMAIL";
    PARAMETRE["DFCI_TRAVAUX_CORPS_EMAIL"] = "DFCI_TRAVAUX_CORPS_EMAIL";
    PARAMETRE["DFCI_TOLERANCE_DFCI_PISTE_METRES"] = "DFCI_TOLERANCE_DFCI_PISTE_METRES";
    PARAMETRE["DFCI_LISTE_COUCHE"] = "DFCI_LISTE_COUCHE";
    PARAMETRE["DUREE_VALIDITE_TOKEN"] = "DUREE_VALIDITE_TOKEN";
    PARAMETRE["EMPRISE_NATIVE"] = "EMPRISE_NATIVE";
    PARAMETRE["GESTION_AGENT"] = "GESTION_AGENT";
    PARAMETRE["MDP_ADMINISTRATEUR"] = "MDP_ADMINISTRATEUR";
    PARAMETRE["MENTION_CNIL"] = "MENTION_CNIL";
    PARAMETRE["MESSAGE_ENTETE"] = "MESSAGE_ENTETE";
    PARAMETRE["MODE_DECONNECTE"] = "MODE_DECONNECTE";
    PARAMETRE["PEI_COLONNES"] = "PEI_COLONNES";
    PARAMETRE["PEI_DELAI_CTRL_URGENT"] = "PEI_DELAI_CTRL_URGENT";
    PARAMETRE["PEI_DELAI_CTRL_WARN"] = "PEI_DELAI_CTRL_WARN";
    PARAMETRE["PEI_DELAI_RECO_URGENT"] = "PEI_DELAI_RECO_URGENT";
    PARAMETRE["PEI_DELAI_RECO_WARN"] = "PEI_DELAI_RECO_WARN";
    PARAMETRE["PEI_DEPLACEMENT_DIST_WARN"] = "PEI_DEPLACEMENT_DIST_WARN";
    PARAMETRE["PEI_GENERATION_CARTE_TOURNEE"] = "PEI_GENERATION_CARTE_TOURNEE";
    PARAMETRE["PEI_HIGHLIGHT_DUREE"] = "PEI_HIGHLIGHT_DUREE";
    PARAMETRE["PEI_HIGHLIGHT_COULEUR"] = "PEI_HIGHLIGHT_COULEUR";
    PARAMETRE["PEI_HIGHLIGHT_RAYON"] = "PEI_HIGHLIGHT_RAYON";
    PARAMETRE["PEI_HIGHLIGHT_LARGEUR"] = "PEI_HIGHLIGHT_LARGEUR";
    PARAMETRE["PEI_SELECTION_COULEUR"] = "PEI_SELECTION_COULEUR";
    PARAMETRE["PEI_SELECTION_RAYON"] = "PEI_SELECTION_RAYON";
    PARAMETRE["PEI_SELECTION_LARGEUR"] = "PEI_SELECTION_LARGEUR";
    PARAMETRE["PEI_METHODE_TRI_ALPHANUMERIQUE"] = "PEI_METHODE_TRI_ALPHANUMERIQUE";
    PARAMETRE["PEI_NOMBRE_HISTORIQUE"] = "PEI_NOMBRE_HISTORIQUE";
    PARAMETRE["PEI_ROUTE_HISTORIQUE"] = "PEI_ROUTE_HISTORIQUE";
    PARAMETRE["PEI_RENOUVELLEMENT_CTRL_PRIVE"] = "PEI_RENOUVELLEMENT_CTRL_PRIVE";
    PARAMETRE["PEI_RENOUVELLEMENT_CTRL_PUBLIC"] = "PEI_RENOUVELLEMENT_CTRL_PUBLIC";
    PARAMETRE["PEI_RENOUVELLEMENT_CTRL_ICPE"] = "PEI_RENOUVELLEMENT_CTRL_ICPE";
    PARAMETRE["PEI_RENOUVELLEMENT_CTRL_ICPE_CONVENTIONNE"] = "PEI_RENOUVELLEMENT_CTRL_ICPE_CONVENTIONNE";
    PARAMETRE["PEI_RENOUVELLEMENT_CTRL_CONVENTIONNE"] = "PEI_RENOUVELLEMENT_CTRL_CONVENTIONNE";
    PARAMETRE["PEI_RENOUVELLEMENT_RECO_PRIVE"] = "PEI_RENOUVELLEMENT_RECO_PRIVE";
    PARAMETRE["PEI_RENOUVELLEMENT_RECO_PUBLIC"] = "PEI_RENOUVELLEMENT_RECO_PUBLIC";
    PARAMETRE["PEI_RENOUVELLEMENT_RECO_ICPE"] = "PEI_RENOUVELLEMENT_RECO_ICPE";
    PARAMETRE["PEI_RENOUVELLEMENT_RECO_ICPE_CONVENTIONNE"] = "PEI_RENOUVELLEMENT_RECO_ICPE_CONVENTIONNE";
    PARAMETRE["PEI_RENOUVELLEMENT_RECO_CONVENTIONNE"] = "PEI_RENOUVELLEMENT_RECO_CONVENTIONNE";
    PARAMETRE["PEI_RENUMEROTATION_INTERNE_AUTO"] = "PEI_RENUMEROTATION_INTERNE_AUTO";
    PARAMETRE["PEI_TOLERANCE_COMMUNE_METRES"] = "PEI_TOLERANCE_COMMUNE_METRES";
    PARAMETRE["PEI_FICHE_RESUME_STANDALONE"] = "PEI_FICHE_RESUME_STANDALONE";
    PARAMETRE["PEI_DISPLAY_IDENTIFIANT_GESTIONNAIRE"] = "PEI_DISPLAY_IDENTIFIANT_GESTIONNAIRE";
    PARAMETRE["PEI_DISPLAY_TYPE_ENGIN"] = "PEI_DISPLAY_TYPE_ENGIN";
    PARAMETRE["PEI_LIBELLE_NON_CONFORME"] = "PEI_LIBELLE_NON_CONFORME";
    PARAMETRE["PERMIS_TOLERANCE_CHARGEMENT_METRES"] = "PERMIS_TOLERANCE_CHARGEMENT_METRES";
    PARAMETRE["PROFONDEUR_COUVERTURE"] = "PROFONDEUR_COUVERTURE";
    PARAMETRE["RECEPTION_RECO_INIT_OBLIGATOIRE"] = "RECEPTION_RECO_INIT_OBLIGATOIRE";
    PARAMETRE["VALEUR_HAUTE_MINIMALE_HISTOGRAMME"] = "VALEUR_HAUTE_MINIMALE_HISTOGRAMME";
    PARAMETRE["TITRE_PAGE"] = "TITRE_PAGE";
    PARAMETRE["TOLERANCE_VOIES_METRES"] = "TOLERANCE_VOIES_METRES";
    PARAMETRE["TYPE_VISITE_CDP"] = "TYPE_VISITE_CDP";
    PARAMETRE["VITESSE_EAU"] = "VITESSE_EAU";
    PARAMETRE["VOIE_SAISIE_LIBRE"] = "VOIE_SAISIE_LIBRE";
    PARAMETRE["ORGANISME_DEFAUT"] = "ORGANISME_DEFAUT";
    PARAMETRE["PROFIL_UTILISATEUR_DEFAUT"] = "PROFIL_UTILISATEUR_DEFAUT";
    PARAMETRE["CONSERVER_OBSERVATION_VISITE"] = "CONSERVER_OBSERVATION_VISITE";
    PARAMETRE["RECHERCHE_BAN"] = "RECHERCHE_BAN";
    return PARAMETRE;
}($ee297f06e8568bf4$var$PARAMETRE || {});
var $ee297f06e8568bf4$export$2e2bcd8739ae039 = $ee297f06e8568bf4$var$PARAMETRE;





var $f808952c311684ce$var$DISPONIBILITE_PEI = /*#__PURE__*/ function(DISPONIBILITE_PEI) {
    DISPONIBILITE_PEI["DISPONIBLE"] = "DISPONIBLE";
    DISPONIBILITE_PEI["INDISPONIBLE"] = "INDISPONIBLE";
    DISPONIBILITE_PEI["NON_CONFORME"] = "NON_CONFORME";
    return DISPONIBILITE_PEI;
}($f808952c311684ce$var$DISPONIBILITE_PEI || {});
function $f808952c311684ce$export$b068bae00425e27d(libelleNonConforme) {
    return [
        {
            id: "DISPONIBLE",
            libelle: "Disponible"
        },
        {
            id: "INDISPONIBLE",
            libelle: "Indisponible"
        },
        {
            id: "NON_CONFORME",
            libelle: libelleNonConforme
        }
    ];
}
var $f808952c311684ce$export$2e2bcd8739ae039 = $f808952c311684ce$var$DISPONIBILITE_PEI;



const $8d53d795ab637b7e$export$f391aae8aa487f18 = (filter)=>{
    const values = {
        ...filter
    };
    // Si on a peiDisponibiliteTerrestre=INDISPONIBLE + hasIndispoTemp=true
    // on doit transformer en INDISPONIBLE_TEMPORAIRE pour l'affichage
    if (values.peiDisponibiliteTerrestre === (0, $f808952c311684ce$export$2e2bcd8739ae039).INDISPONIBLE && (values.hasIndispoTemp === true || values.hasIndispoTemp === "true")) values.peiDisponibiliteTerrestre = "INDISPONIBLE_TEMPORAIRE";
    // Permet de remettre correctement le filtre "AUCUNE_TOURNEE" dans le filter input
    if (values.hasNoTournee === true) values.tourneeId = (0, $f740b0d032822ba6$export$b0c557648079337a);
    return values;
};
const $8d53d795ab637b7e$export$6f2fda70fe261d2e = ({ peiNumeroComplet: peiNumeroComplet, peiNumeroInterne: peiNumeroInterne, communeId: communeId, natureId: natureId, peiDisponibiliteTerrestre: peiDisponibiliteTerrestre, penaDisponibiliteHbe: penaDisponibiliteHbe, typePei: typePei, natureDeci: natureDeci, autoriteDeci: autoriteDeci, servicePublicDeci: servicePublicDeci, anomalieId: anomalieId, adresse: adresse, prochaineDateRop: prochaineDateRop, prochaineDateCtp: prochaineDateCtp, tourneeId: tourneeId, gestionnaireId: gestionnaireId, hasIndispoTemp: hasIndispoTemp, diametreNominalId: diametreNominalId })=>{
    const filter = {};
    if (peiNumeroComplet != null && peiNumeroComplet.trim() !== "") filter.peiNumeroComplet = peiNumeroComplet;
    if (communeId != null && communeId.trim() !== "") filter.communeId = communeId;
    if (typePei != null && typePei.trim() !== "") filter.typePei = typePei;
    if (natureDeci != null && natureDeci.trim() !== "") filter.natureDeci = natureDeci;
    if (autoriteDeci != null && autoriteDeci.trim() !== "") filter.autoriteDeci = autoriteDeci;
    if (servicePublicDeci != null && servicePublicDeci.trim() !== "") filter.servicePublicDeci = servicePublicDeci;
    if (natureId != null && natureId.trim() !== "") filter.natureId = natureId;
    if (peiDisponibiliteTerrestre != null && peiDisponibiliteTerrestre.trim() !== "") {
        if (peiDisponibiliteTerrestre === "INDISPONIBLE_TEMPORAIRE" || peiDisponibiliteTerrestre === (0, $f808952c311684ce$export$2e2bcd8739ae039).INDISPONIBLE && hasIndispoTemp === true) {
            // Filtre pour "Indisponible temporairement"
            filter.peiDisponibiliteTerrestre = (0, $f808952c311684ce$export$2e2bcd8739ae039).INDISPONIBLE;
            filter.hasIndispoTemp = true;
        } else if (peiDisponibiliteTerrestre === (0, $f808952c311684ce$export$2e2bcd8739ae039).INDISPONIBLE) // Filtre pour "Indisponible" uniquement (pas temporaire)
        filter.peiDisponibiliteTerrestre = (0, $f808952c311684ce$export$2e2bcd8739ae039).INDISPONIBLE;
        else // Tous les autres filtres (Disponible, Non conforme, etc.)
        filter.peiDisponibiliteTerrestre = peiDisponibiliteTerrestre;
    }
    if (penaDisponibiliteHbe != null && penaDisponibiliteHbe.trim() !== "") filter.penaDisponibiliteHbe = penaDisponibiliteHbe;
    if (peiNumeroInterne != null && peiNumeroInterne !== "") filter.peiNumeroInterne = peiNumeroInterne;
    if (anomalieId != null && anomalieId !== "") filter.anomalieId = anomalieId;
    if (adresse != null && adresse !== "") filter.adresse = adresse;
    if (prochaineDateRop != null && prochaineDateRop.trim() !== "") filter.prochaineDateRop = prochaineDateRop;
    if (prochaineDateCtp != null && prochaineDateCtp.trim() !== "") filter.prochaineDateCtp = prochaineDateCtp;
    if (tourneeId != null && tourneeId.trim() !== "" && tourneeId !== (0, $f740b0d032822ba6$export$b0c557648079337a)) filter.tourneeId = tourneeId;
    if (tourneeId === (0, $f740b0d032822ba6$export$b0c557648079337a)) {
        filter.tourneeId = undefined;
        filter.hasNoTournee = true;
    }
    if (gestionnaireId != null && gestionnaireId.trim() !== "") filter.gestionnaireId = gestionnaireId;
    if (diametreNominalId != null && diametreNominalId.trim() !== "") filter.diametreNominalId = diametreNominalId;
    return filter;
};
const $8d53d795ab637b7e$var$FilterPei = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Text, {});
};
var $8d53d795ab637b7e$export$2e2bcd8739ae039 = $8d53d795ab637b7e$var$FilterPei;




var $bkJfK = parcelRequire("bkJfK");

var $kc00y = parcelRequire("kc00y");


var $kc00y = parcelRequire("kc00y");




var $kc00y = parcelRequire("kc00y");




"use client";
const $3b0ad1ed2e82f3b3$var$DivStyledAsH4 = (0, $b5bbb0b2ce1c31b6$export$2e2bcd8739ae039)('h4');
$3b0ad1ed2e82f3b3$var$DivStyledAsH4.displayName = 'DivStyledAsH4';
const $3b0ad1ed2e82f3b3$var$AlertHeading = /*#__PURE__*/ $kc00y.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = $3b0ad1ed2e82f3b3$var$DivStyledAsH4, ...props }, ref)=>{
    bsPrefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(bsPrefix, 'alert-heading');
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, bsPrefix),
        ...props
    });
});
$3b0ad1ed2e82f3b3$var$AlertHeading.displayName = 'AlertHeading';
var $3b0ad1ed2e82f3b3$export$2e2bcd8739ae039 = $3b0ad1ed2e82f3b3$var$AlertHeading;



var $kc00y = parcelRequire("kc00y");


var $kc00y = parcelRequire("kc00y");




var $kc00y = parcelRequire("kc00y");

function $3107b4995425ddd1$export$2e2bcd8739ae039(eventTarget, event, listener, capture = false) {
    const handler = (0, $0261b276e783eb4f$export$2e2bcd8739ae039)(listener);
    (0, $kc00y.useEffect)(()=>{
        const target = typeof eventTarget === 'function' ? eventTarget() : eventTarget;
        target.addEventListener(event, handler, capture);
        return ()=>target.removeEventListener(event, handler, capture);
    }, [
        eventTarget
    ]);
}




var $kc00y = parcelRequire("kc00y");
function $a155844e2feca7e2$export$2e2bcd8739ae039(event, handler, capture = false) {
    const documentTarget = (0, $kc00y.useCallback)(()=>document, []);
    return (0, $3107b4995425ddd1$export$2e2bcd8739ae039)(documentTarget, event, handler, capture);
}



var $kc00y = parcelRequire("kc00y");

/**
 * Creates a `setInterval` that is properly cleaned up when a component unmounted
 *
 * ```tsx
 *  function Timer() {
 *    const [timer, setTimer] = useState(0)
 *    useInterval(() => setTimer(i => i + 1), 1000)
 *
 *    return <span>{timer} seconds past</span>
 *  }
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 */ /**
 * Creates a pausable `setInterval` that is properly cleaned up when a component unmounted
 *
 * ```tsx
 *  const [paused, setPaused] = useState(false)
 *  const [timer, setTimer] = useState(0)
 *
 *  useInterval(() => setTimer(i => i + 1), 1000, paused)
 *
 *  return (
 *    <span>
 *      {timer} seconds past
 *
 *      <button onClick={() => setPaused(p => !p)}>{paused ? 'Play' : 'Pause' }</button>
 *    </span>
 * )
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 * @param paused Whether or not the interval is currently running
 */ /**
 * Creates a pausable `setInterval` that _fires_ immediately and is
 * properly cleaned up when a component unmounted
 *
 * ```tsx
 *  const [timer, setTimer] = useState(-1)
 *  useInterval(() => setTimer(i => i + 1), 1000, false, true)
 *
 *  // will update to 0 on the first effect
 *  return <span>{timer} seconds past</span>
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 * @param paused Whether or not the interval is currently running
 * @param runImmediately Whether to run the function immediately on mount or unpause
 * rather than waiting for the first interval to elapse
 *

 */ function $040528394278e62d$var$useInterval(fn, ms, paused = false, runImmediately = false) {
    let handle;
    const fnRef = (0, $52026e7d7af8fa9c$export$2e2bcd8739ae039)(fn);
    // this ref is necessary b/c useEffect will sometimes miss a paused toggle
    // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.
    const pausedRef = (0, $52026e7d7af8fa9c$export$2e2bcd8739ae039)(paused);
    const tick = ()=>{
        if (pausedRef.current) return;
        fnRef.current();
        schedule(); // eslint-disable-line no-use-before-define
    };
    const schedule = ()=>{
        clearTimeout(handle);
        handle = setTimeout(tick, ms);
    };
    (0, $kc00y.useEffect)(()=>{
        if (runImmediately) tick();
        else schedule();
        return ()=>clearTimeout(handle);
    }, [
        paused,
        runImmediately
    ]);
}
var $040528394278e62d$export$2e2bcd8739ae039 = $040528394278e62d$var$useInterval;



var $kc00y = parcelRequire("kc00y");

function $e7438a627059cc89$var$useRafInterval(fn, ms, paused = false) {
    let handle;
    let start = new Date().getTime();
    const fnRef = (0, $52026e7d7af8fa9c$export$2e2bcd8739ae039)(fn);
    // this ref is necessary b/c useEffect will sometimes miss a paused toggle
    // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.
    const pausedRef = (0, $52026e7d7af8fa9c$export$2e2bcd8739ae039)(paused);
    function loop() {
        const current = new Date().getTime();
        const delta = current - start;
        if (pausedRef.current) return;
        if (delta >= ms && fnRef.current) {
            fnRef.current();
            start = new Date().getTime();
        }
        cancelAnimationFrame(handle);
        handle = requestAnimationFrame(loop);
    }
    (0, $kc00y.useEffect)(()=>{
        handle = requestAnimationFrame(loop);
        return ()=>cancelAnimationFrame(handle);
    }, []);
}
var $e7438a627059cc89$export$2e2bcd8739ae039 = $e7438a627059cc89$var$useRafInterval;



var $kc00y = parcelRequire("kc00y");
function $670574595cb78357$export$2e2bcd8739ae039(initialState) {
    const [state, setState] = (0, $kc00y.useState)(initialState);
    const updater = (0, $kc00y.useCallback)((update)=>{
        if (update === null) return;
        if (typeof update === 'function') setState((state)=>{
            const nextState = update(state);
            return nextState == null ? state : Object.assign({}, state, nextState);
        });
        else setState((state)=>Object.assign({}, state, update));
    }, [
        setState
    ]);
    return [
        state,
        updater
    ];
}



function $6a8bfd0a91c9b125$export$2e2bcd8739ae039(props, gDSFP, initialState) {
    const [state, setState] = (0, $670574595cb78357$export$2e2bcd8739ae039)(initialState);
    const nextState = gDSFP(props, state);
    if (nextState !== null) setState(nextState);
    return [
        state,
        setState
    ];
}





var $kc00y = parcelRequire("kc00y");
function $8da6e633b8f4394d$export$2e2bcd8739ae039(imageOrUrl, crossOrigin) {
    const [state, setState] = (0, $kc00y.useState)({
        image: null,
        error: null
    });
    (0, $kc00y.useEffect)(()=>{
        if (!imageOrUrl) return undefined;
        let image;
        if (typeof imageOrUrl === 'string') {
            image = new Image();
            if (crossOrigin) image.crossOrigin = crossOrigin;
            image.src = imageOrUrl;
        } else {
            image = imageOrUrl;
            if (image.complete && image.naturalHeight > 0) {
                setState({
                    image: image,
                    error: null
                });
                return;
            }
        }
        function onLoad() {
            setState({
                image: image,
                error: null
            });
        }
        function onError(error) {
            setState({
                image: image,
                error: error
            });
        }
        image.addEventListener('load', onLoad);
        image.addEventListener('error', onError);
        return ()=>{
            image.removeEventListener('load', onLoad);
            image.removeEventListener('error', onError);
        };
    }, [
        imageOrUrl,
        crossOrigin
    ]);
    return state;
}



var $kc00y = parcelRequire("kc00y");

const $036c64a9b0b57596$var$targetMap = new WeakMap();
let $036c64a9b0b57596$var$resizeObserver;
function $036c64a9b0b57596$var$getResizeObserver() {
    // eslint-disable-next-line no-return-assign
    return $036c64a9b0b57596$var$resizeObserver = $036c64a9b0b57596$var$resizeObserver || new window.ResizeObserver((entries)=>{
        entries.forEach((entry)=>{
            const handler = $036c64a9b0b57596$var$targetMap.get(entry.target);
            if (handler) handler(entry.contentRect);
        });
    });
}
function $036c64a9b0b57596$export$2e2bcd8739ae039(element) {
    const [rect, setRect] = (0, $kc00y.useState)(null);
    (0, $c09ab3415be1be37$export$2e2bcd8739ae039)(()=>{
        if (!element) return;
        $036c64a9b0b57596$var$getResizeObserver().observe(element);
        setRect(element.getBoundingClientRect());
        $036c64a9b0b57596$var$targetMap.set(element, (rect)=>{
            setRect(rect);
        });
        return ()=>{
            $036c64a9b0b57596$var$targetMap.delete(element);
        };
    }, [
        element
    ]);
    return rect;
}






const $68efbe85ab599b20$var$_excluded = [
    "onKeyDown"
];
function $68efbe85ab599b20$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $68efbe85ab599b20$export$72369ab2cc99204b(href) {
    return !href || href.trim() === '#';
}
/**
 * An generic `<a>` component that covers a few A11y cases, ensuring that
 * cases where the `href` is missing or trivial like "#" are treated like buttons.
 */ const $68efbe85ab599b20$var$Anchor = /*#__PURE__*/ $kc00y.forwardRef((_ref, ref)=>{
    let { onKeyDown: onKeyDown } = _ref, props = $68efbe85ab599b20$var$_objectWithoutPropertiesLoose(_ref, $68efbe85ab599b20$var$_excluded);
    const [buttonProps] = (0, $cdcc2451955840fb$export$a0ee72f2c720a5c3)(Object.assign({
        tagName: 'a'
    }, props));
    const handleKeyDown = (0, $0261b276e783eb4f$export$2e2bcd8739ae039)((e)=>{
        buttonProps.onKeyDown(e);
        onKeyDown == null || onKeyDown(e);
    });
    if ($68efbe85ab599b20$export$72369ab2cc99204b(props.href) || props.role === 'button') return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("a", Object.assign({
        ref: ref
    }, props, buttonProps, {
        onKeyDown: handleKeyDown
    }));
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("a", Object.assign({
        ref: ref
    }, props, {
        onKeyDown: onKeyDown
    }));
});
$68efbe85ab599b20$var$Anchor.displayName = 'Anchor';
var $68efbe85ab599b20$export$2e2bcd8739ae039 = $68efbe85ab599b20$var$Anchor;




"use client";
const $1c71f359ea55864e$var$AlertLink = /*#__PURE__*/ $kc00y.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = (0, $68efbe85ab599b20$export$2e2bcd8739ae039), ...props }, ref)=>{
    bsPrefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(bsPrefix, 'alert-link');
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, bsPrefix),
        ...props
    });
});
$1c71f359ea55864e$var$AlertLink.displayName = 'AlertLink';
var $1c71f359ea55864e$export$2e2bcd8739ae039 = $1c71f359ea55864e$var$AlertLink;





"use client";
const $8598ca69ed8b9dca$var$Alert = /*#__PURE__*/ $kc00y.forwardRef((uncontrolledProps, ref)=>{
    const { bsPrefix: bsPrefix, show: show = true, closeLabel: closeLabel = 'Close alert', closeVariant: closeVariant, className: className, children: children, variant: variant = 'primary', onClose: onClose, dismissible: dismissible, transition: transition = (0, $25d8c693c355530c$export$2e2bcd8739ae039), ...props } = (0, $b0582fd40c314767$export$2e2bcd8739ae039)(uncontrolledProps, {
        show: 'onClose'
    });
    const prefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(bsPrefix, 'alert');
    const handleClose = (0, $4655b62db0931f1e$export$2e2bcd8739ae039)((e)=>{
        if (onClose) onClose(false, e);
    });
    const Transition = transition === true ? (0, $25d8c693c355530c$export$2e2bcd8739ae039) : transition;
    const alert = /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
        role: "alert",
        ...!Transition ? props : undefined,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, prefix, variant && `${prefix}-${variant}`, dismissible && `${prefix}-dismissible`),
        children: [
            dismissible && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $80bef9dfc5e82bc1$export$2e2bcd8739ae039), {
                onClick: handleClose,
                "aria-label": closeLabel,
                variant: closeVariant
            }),
            children
        ]
    });
    if (!Transition) return show ? alert : null;
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)(Transition, {
        unmountOnExit: true,
        ...props,
        ref: undefined,
        in: show,
        children: alert
    });
});
$8598ca69ed8b9dca$var$Alert.displayName = 'Alert';
var $8598ca69ed8b9dca$export$2e2bcd8739ae039 = Object.assign($8598ca69ed8b9dca$var$Alert, {
    Link: (0, $1c71f359ea55864e$export$2e2bcd8739ae039),
    Heading: (0, $3b0ad1ed2e82f3b3$export$2e2bcd8739ae039)
});


var $5bc14c0fe9940240$exports = {};
/**
 * Based on Kendo UI Core expression code <https://github.com/telerik/kendo-ui-core#license-information>
 */ 'use strict';
function $5bc14c0fe9940240$var$Cache(maxSize) {
    this._maxSize = maxSize;
    this.clear();
}
$5bc14c0fe9940240$var$Cache.prototype.clear = function() {
    this._size = 0;
    this._values = Object.create(null);
};
$5bc14c0fe9940240$var$Cache.prototype.get = function(key) {
    return this._values[key];
};
$5bc14c0fe9940240$var$Cache.prototype.set = function(key, value) {
    this._size >= this._maxSize && this.clear();
    if (!(key in this._values)) this._size++;
    return this._values[key] = value;
};
var $5bc14c0fe9940240$var$SPLIT_REGEX = /[^.^\]^[]+|(?=\[\]|\.\.)/g, $5bc14c0fe9940240$var$DIGIT_REGEX = /^\d+$/, $5bc14c0fe9940240$var$LEAD_DIGIT_REGEX = /^\d/, $5bc14c0fe9940240$var$SPEC_CHAR_REGEX = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g, $5bc14c0fe9940240$var$CLEAN_QUOTES_REGEX = /^\s*(['"]?)(.*?)(\1)\s*$/, $5bc14c0fe9940240$var$MAX_CACHE_SIZE = 512;
var $5bc14c0fe9940240$var$pathCache = new $5bc14c0fe9940240$var$Cache($5bc14c0fe9940240$var$MAX_CACHE_SIZE), $5bc14c0fe9940240$var$setCache = new $5bc14c0fe9940240$var$Cache($5bc14c0fe9940240$var$MAX_CACHE_SIZE), $5bc14c0fe9940240$var$getCache = new $5bc14c0fe9940240$var$Cache($5bc14c0fe9940240$var$MAX_CACHE_SIZE);
var $5bc14c0fe9940240$var$config;
$5bc14c0fe9940240$exports = {
    Cache: $5bc14c0fe9940240$var$Cache,
    split: $5bc14c0fe9940240$var$split,
    normalizePath: $5bc14c0fe9940240$var$normalizePath,
    setter: function(path) {
        var parts = $5bc14c0fe9940240$var$normalizePath(path);
        return $5bc14c0fe9940240$var$setCache.get(path) || $5bc14c0fe9940240$var$setCache.set(path, function setter(obj, value) {
            var index = 0;
            var len = parts.length;
            var data = obj;
            while(index < len - 1){
                var part = parts[index];
                if (part === '__proto__' || part === 'constructor' || part === 'prototype') return obj;
                data = data[parts[index++]];
            }
            data[parts[index]] = value;
        });
    },
    getter: function(path, safe) {
        var parts = $5bc14c0fe9940240$var$normalizePath(path);
        return $5bc14c0fe9940240$var$getCache.get(path) || $5bc14c0fe9940240$var$getCache.set(path, function getter(data) {
            var index = 0, len = parts.length;
            while(index < len){
                if (data != null || !safe) data = data[parts[index++]];
                else return;
            }
            return data;
        });
    },
    join: function(segments) {
        return segments.reduce(function(path, part) {
            return path + ($5bc14c0fe9940240$var$isQuoted(part) || $5bc14c0fe9940240$var$DIGIT_REGEX.test(part) ? '[' + part + ']' : (path ? '.' : '') + part);
        }, '');
    },
    forEach: function(path, cb, thisArg) {
        $5bc14c0fe9940240$var$forEach(Array.isArray(path) ? path : $5bc14c0fe9940240$var$split(path), cb, thisArg);
    }
};
function $5bc14c0fe9940240$var$normalizePath(path) {
    return $5bc14c0fe9940240$var$pathCache.get(path) || $5bc14c0fe9940240$var$pathCache.set(path, $5bc14c0fe9940240$var$split(path).map(function(part) {
        return part.replace($5bc14c0fe9940240$var$CLEAN_QUOTES_REGEX, '$2');
    }));
}
function $5bc14c0fe9940240$var$split(path) {
    return path.match($5bc14c0fe9940240$var$SPLIT_REGEX) || [
        ''
    ];
}
function $5bc14c0fe9940240$var$forEach(parts, iter, thisArg) {
    var len = parts.length, part, idx, isArray, isBracket;
    for(idx = 0; idx < len; idx++){
        part = parts[idx];
        if (part) {
            if ($5bc14c0fe9940240$var$shouldBeQuoted(part)) part = '"' + part + '"';
            isBracket = $5bc14c0fe9940240$var$isQuoted(part);
            isArray = !isBracket && /^\d+$/.test(part);
            iter.call(thisArg, part, isBracket, isArray, idx, parts);
        }
    }
}
function $5bc14c0fe9940240$var$isQuoted(str) {
    return typeof str === 'string' && str && [
        "'",
        '"'
    ].indexOf(str.charAt(0)) !== -1;
}
function $5bc14c0fe9940240$var$hasLeadingNumber(part) {
    return part.match($5bc14c0fe9940240$var$LEAD_DIGIT_REGEX) && !part.match($5bc14c0fe9940240$var$DIGIT_REGEX);
}
function $5bc14c0fe9940240$var$hasSpecialChars(part) {
    return $5bc14c0fe9940240$var$SPEC_CHAR_REGEX.test(part);
}
function $5bc14c0fe9940240$var$shouldBeQuoted(part) {
    return !$5bc14c0fe9940240$var$isQuoted(part) && ($5bc14c0fe9940240$var$hasLeadingNumber(part) || $5bc14c0fe9940240$var$hasSpecialChars(part));
}


var $d756e36230d17d6d$exports = {};
const $d756e36230d17d6d$var$reWords = /[A-Z\xc0-\xd6\xd8-\xde]?[a-z\xdf-\xf6\xf8-\xff]+(?:['’](?:d|ll|m|re|s|t|ve))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde]|$)|(?:[A-Z\xc0-\xd6\xd8-\xde]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:D|LL|M|RE|S|T|VE))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde](?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])|$)|[A-Z\xc0-\xd6\xd8-\xde]?(?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:d|ll|m|re|s|t|ve))?|[A-Z\xc0-\xd6\xd8-\xde]+(?:['’](?:D|LL|M|RE|S|T|VE))?|\d*(?:1ST|2ND|3RD|(?![123])\dTH)(?=\b|[a-z_])|\d*(?:1st|2nd|3rd|(?![123])\dth)(?=\b|[A-Z_])|\d+|(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?)*/g;
const $d756e36230d17d6d$var$words = (str)=>str.match($d756e36230d17d6d$var$reWords) || [];
const $d756e36230d17d6d$var$upperFirst = (str)=>str[0].toUpperCase() + str.slice(1);
const $d756e36230d17d6d$var$join = (str, d)=>$d756e36230d17d6d$var$words(str).join(d).toLowerCase();
const $d756e36230d17d6d$var$camelCase = (str)=>$d756e36230d17d6d$var$words(str).reduce((acc, next)=>`${acc}${!acc ? next.toLowerCase() : next[0].toUpperCase() + next.slice(1).toLowerCase()}`, '');
const $d756e36230d17d6d$var$pascalCase = (str)=>$d756e36230d17d6d$var$upperFirst($d756e36230d17d6d$var$camelCase(str));
const $d756e36230d17d6d$var$snakeCase = (str)=>$d756e36230d17d6d$var$join(str, '_');
const $d756e36230d17d6d$var$kebabCase = (str)=>$d756e36230d17d6d$var$join(str, '-');
const $d756e36230d17d6d$var$sentenceCase = (str)=>$d756e36230d17d6d$var$upperFirst($d756e36230d17d6d$var$join(str, ' '));
const $d756e36230d17d6d$var$titleCase = (str)=>$d756e36230d17d6d$var$words(str).map($d756e36230d17d6d$var$upperFirst).join(' ');
$d756e36230d17d6d$exports = {
    words: $d756e36230d17d6d$var$words,
    upperFirst: $d756e36230d17d6d$var$upperFirst,
    camelCase: $d756e36230d17d6d$var$camelCase,
    pascalCase: $d756e36230d17d6d$var$pascalCase,
    snakeCase: $d756e36230d17d6d$var$snakeCase,
    kebabCase: $d756e36230d17d6d$var$kebabCase,
    sentenceCase: $d756e36230d17d6d$var$sentenceCase,
    titleCase: $d756e36230d17d6d$var$titleCase
};


var $e1f9876d5f29f67a$exports = {};
/**
 * Topological sorting function
 *
 * @param {Array} edges
 * @returns {Array}
 */ $e1f9876d5f29f67a$exports = function(edges) {
    return $e1f9876d5f29f67a$var$toposort($e1f9876d5f29f67a$var$uniqueNodes(edges), edges);
};
$e1f9876d5f29f67a$exports.array = $e1f9876d5f29f67a$var$toposort;
function $e1f9876d5f29f67a$var$toposort(nodes, edges) {
    var cursor = nodes.length, sorted = new Array(cursor), visited = {}, i = cursor, outgoingEdges = $e1f9876d5f29f67a$var$makeOutgoingEdges(edges), nodesHash = $e1f9876d5f29f67a$var$makeNodesHash(nodes);
    // check for unknown nodes
    edges.forEach(function(edge) {
        if (!nodesHash.has(edge[0]) || !nodesHash.has(edge[1])) throw new Error('Unknown node. There is an unknown node in the supplied edges.');
    });
    while(i--)if (!visited[i]) visit(nodes[i], i, new Set());
    return sorted;
    function visit(node, i, predecessors) {
        if (predecessors.has(node)) {
            var nodeRep;
            try {
                nodeRep = ", node was:" + JSON.stringify(node);
            } catch (e) {
                nodeRep = "";
            }
            throw new Error('Cyclic dependency' + nodeRep);
        }
        if (!nodesHash.has(node)) throw new Error('Found unknown node. Make sure to provided all involved nodes. Unknown node: ' + JSON.stringify(node));
        if (visited[i]) return;
        visited[i] = true;
        var outgoing = outgoingEdges.get(node) || new Set();
        outgoing = Array.from(outgoing);
        if (i = outgoing.length) {
            predecessors.add(node);
            do {
                var child = outgoing[--i];
                visit(child, nodesHash.get(child), predecessors);
            }while (i);
            predecessors.delete(node);
        }
        sorted[--cursor] = node;
    }
}
function $e1f9876d5f29f67a$var$uniqueNodes(arr) {
    var res = new Set();
    for(var i = 0, len = arr.length; i < len; i++){
        var edge = arr[i];
        res.add(edge[0]);
        res.add(edge[1]);
    }
    return Array.from(res);
}
function $e1f9876d5f29f67a$var$makeOutgoingEdges(arr) {
    var edges = new Map();
    for(var i = 0, len = arr.length; i < len; i++){
        var edge = arr[i];
        if (!edges.has(edge[0])) edges.set(edge[0], new Set());
        if (!edges.has(edge[1])) edges.set(edge[1], new Set());
        edges.get(edge[0]).add(edge[1]);
    }
    return edges;
}
function $e1f9876d5f29f67a$var$makeNodesHash(arr) {
    var res = new Map();
    for(var i = 0, len = arr.length; i < len; i++)res.set(arr[i], i);
    return res;
}


const $ce4de947442b2ab1$var$toString = Object.prototype.toString;
const $ce4de947442b2ab1$var$errorToString = Error.prototype.toString;
const $ce4de947442b2ab1$var$regExpToString = RegExp.prototype.toString;
const $ce4de947442b2ab1$var$symbolToString = typeof Symbol !== 'undefined' ? Symbol.prototype.toString : ()=>'';
const $ce4de947442b2ab1$var$SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;
function $ce4de947442b2ab1$var$printNumber(val) {
    if (val != +val) return 'NaN';
    const isNegativeZero = val === 0 && 1 / val < 0;
    return isNegativeZero ? '-0' : '' + val;
}
function $ce4de947442b2ab1$var$printSimpleValue(val, quoteStrings = false) {
    if (val == null || val === true || val === false) return '' + val;
    const typeOf = typeof val;
    if (typeOf === 'number') return $ce4de947442b2ab1$var$printNumber(val);
    if (typeOf === 'string') return quoteStrings ? `"${val}"` : val;
    if (typeOf === 'function') return '[Function ' + (val.name || 'anonymous') + ']';
    if (typeOf === 'symbol') return $ce4de947442b2ab1$var$symbolToString.call(val).replace($ce4de947442b2ab1$var$SYMBOL_REGEXP, 'Symbol($1)');
    const tag = $ce4de947442b2ab1$var$toString.call(val).slice(8, -1);
    if (tag === 'Date') return isNaN(val.getTime()) ? '' + val : val.toISOString(val);
    if (tag === 'Error' || val instanceof Error) return '[' + $ce4de947442b2ab1$var$errorToString.call(val) + ']';
    if (tag === 'RegExp') return $ce4de947442b2ab1$var$regExpToString.call(val);
    return null;
}
function $ce4de947442b2ab1$export$5790025c6e6c2ba6(value, quoteStrings) {
    let result = $ce4de947442b2ab1$var$printSimpleValue(value, quoteStrings);
    if (result !== null) return result;
    return JSON.stringify(value, function(key, value) {
        let result = $ce4de947442b2ab1$var$printSimpleValue(this[key], quoteStrings);
        if (result !== null) return result;
        return value;
    }, 2);
}
function $ce4de947442b2ab1$var$toArray(value) {
    return value == null ? [] : [].concat(value);
}
let $ce4de947442b2ab1$var$_Symbol$toStringTag, $ce4de947442b2ab1$var$_Symbol$hasInstance, $ce4de947442b2ab1$var$_Symbol$toStringTag2;
let $ce4de947442b2ab1$var$strReg = /\$\{\s*(\w+)\s*\}/g;
$ce4de947442b2ab1$var$_Symbol$toStringTag = Symbol.toStringTag;
class $ce4de947442b2ab1$var$ValidationErrorNoStack {
    constructor(errorOrErrors, value, field, type){
        this.name = void 0;
        this.message = void 0;
        this.value = void 0;
        this.path = void 0;
        this.type = void 0;
        this.params = void 0;
        this.errors = void 0;
        this.inner = void 0;
        this[$ce4de947442b2ab1$var$_Symbol$toStringTag] = 'Error';
        this.name = 'ValidationError';
        this.value = value;
        this.path = field;
        this.type = type;
        this.errors = [];
        this.inner = [];
        $ce4de947442b2ab1$var$toArray(errorOrErrors).forEach((err)=>{
            if ($ce4de947442b2ab1$export$2191b9da168c6cf0.isError(err)) {
                this.errors.push(...err.errors);
                const innerErrors = err.inner.length ? err.inner : [
                    err
                ];
                this.inner.push(...innerErrors);
            } else this.errors.push(err);
        });
        this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0];
    }
}
$ce4de947442b2ab1$var$_Symbol$hasInstance = Symbol.hasInstance;
$ce4de947442b2ab1$var$_Symbol$toStringTag2 = Symbol.toStringTag;
class $ce4de947442b2ab1$export$2191b9da168c6cf0 extends Error {
    static formatError(message, params) {
        // Attempt to make the path more friendly for error message interpolation.
        const path = params.label || params.path || 'this';
        // Store the original path under `originalPath` so it isn't lost to custom
        // message functions; e.g., ones provided in `setLocale()` calls.
        params = Object.assign({}, params, {
            path: path,
            originalPath: params.path
        });
        if (typeof message === 'string') return message.replace($ce4de947442b2ab1$var$strReg, (_, key)=>$ce4de947442b2ab1$export$5790025c6e6c2ba6(params[key]));
        if (typeof message === 'function') return message(params);
        return message;
    }
    static isError(err) {
        return err && err.name === 'ValidationError';
    }
    constructor(errorOrErrors, value, field, type, disableStack){
        const errorNoStack = new $ce4de947442b2ab1$var$ValidationErrorNoStack(errorOrErrors, value, field, type);
        if (disableStack) return errorNoStack;
        super();
        this.value = void 0;
        this.path = void 0;
        this.type = void 0;
        this.params = void 0;
        this.errors = [];
        this.inner = [];
        this[$ce4de947442b2ab1$var$_Symbol$toStringTag2] = 'Error';
        this.name = errorNoStack.name;
        this.message = errorNoStack.message;
        this.type = errorNoStack.type;
        this.value = errorNoStack.value;
        this.path = errorNoStack.path;
        this.errors = errorNoStack.errors;
        this.inner = errorNoStack.inner;
        if (Error.captureStackTrace) Error.captureStackTrace(this, $ce4de947442b2ab1$export$2191b9da168c6cf0);
    }
    static [$ce4de947442b2ab1$var$_Symbol$hasInstance](inst) {
        return $ce4de947442b2ab1$var$ValidationErrorNoStack[Symbol.hasInstance](inst) || super[Symbol.hasInstance](inst);
    }
}
let $ce4de947442b2ab1$var$mixed = {
    default: '${path} is invalid',
    required: '${path} is a required field',
    defined: '${path} must be defined',
    notNull: '${path} cannot be null',
    oneOf: '${path} must be one of the following values: ${values}',
    notOneOf: '${path} must not be one of the following values: ${values}',
    notType: ({ path: path, type: type, value: value, originalValue: originalValue })=>{
        const castMsg = originalValue != null && originalValue !== value ? ` (cast from the value \`${$ce4de947442b2ab1$export$5790025c6e6c2ba6(originalValue, true)}\`).` : '.';
        return type !== 'mixed' ? `${path} must be a \`${type}\` type, ` + `but the final value was: \`${$ce4de947442b2ab1$export$5790025c6e6c2ba6(value, true)}\`` + castMsg : `${path} must match the configured type. ` + `The validated value was: \`${$ce4de947442b2ab1$export$5790025c6e6c2ba6(value, true)}\`` + castMsg;
    }
};
let $ce4de947442b2ab1$var$string = {
    length: '${path} must be exactly ${length} characters',
    min: '${path} must be at least ${min} characters',
    max: '${path} must be at most ${max} characters',
    matches: '${path} must match the following: "${regex}"',
    email: '${path} must be a valid email',
    url: '${path} must be a valid URL',
    uuid: '${path} must be a valid UUID',
    datetime: '${path} must be a valid ISO date-time',
    datetime_precision: '${path} must be a valid ISO date-time with a sub-second precision of exactly ${precision} digits',
    datetime_offset: '${path} must be a valid ISO date-time with UTC "Z" timezone',
    trim: '${path} must be a trimmed string',
    lowercase: '${path} must be a lowercase string',
    uppercase: '${path} must be a upper case string'
};
let $ce4de947442b2ab1$var$number = {
    min: '${path} must be greater than or equal to ${min}',
    max: '${path} must be less than or equal to ${max}',
    lessThan: '${path} must be less than ${less}',
    moreThan: '${path} must be greater than ${more}',
    positive: '${path} must be a positive number',
    negative: '${path} must be a negative number',
    integer: '${path} must be an integer'
};
let $ce4de947442b2ab1$var$date = {
    min: '${path} field must be later than ${min}',
    max: '${path} field must be at earlier than ${max}'
};
let $ce4de947442b2ab1$var$boolean = {
    isValue: '${path} field must be ${value}'
};
let $ce4de947442b2ab1$var$object = {
    noUnknown: '${path} field has unspecified keys: ${unknown}',
    exact: '${path} object contains unknown properties: ${properties}'
};
let $ce4de947442b2ab1$var$array = {
    min: '${path} field must have at least ${min} items',
    max: '${path} field must have less than or equal to ${max} items',
    length: '${path} must have ${length} items'
};
let $ce4de947442b2ab1$var$tuple = {
    notType: (params)=>{
        const { path: path, value: value, spec: spec } = params;
        const typeLen = spec.types.length;
        if (Array.isArray(value)) {
            if (value.length < typeLen) return `${path} tuple value has too few items, expected a length of ${typeLen} but got ${value.length} for value: \`${$ce4de947442b2ab1$export$5790025c6e6c2ba6(value, true)}\``;
            if (value.length > typeLen) return `${path} tuple value has too many items, expected a length of ${typeLen} but got ${value.length} for value: \`${$ce4de947442b2ab1$export$5790025c6e6c2ba6(value, true)}\``;
        }
        return $ce4de947442b2ab1$export$2191b9da168c6cf0.formatError($ce4de947442b2ab1$var$mixed.notType, params);
    }
};
var $ce4de947442b2ab1$export$d7f512c98c859244 = Object.assign(Object.create(null), {
    mixed: $ce4de947442b2ab1$var$mixed,
    string: $ce4de947442b2ab1$var$string,
    number: $ce4de947442b2ab1$var$number,
    date: $ce4de947442b2ab1$var$date,
    object: $ce4de947442b2ab1$var$object,
    array: $ce4de947442b2ab1$var$array,
    boolean: $ce4de947442b2ab1$var$boolean,
    tuple: $ce4de947442b2ab1$var$tuple
});
const $ce4de947442b2ab1$export$213e2a3e7c4f326e = (obj)=>obj && obj.__isYupSchema__;
class $ce4de947442b2ab1$var$Condition {
    static fromOptions(refs, config) {
        if (!config.then && !config.otherwise) throw new TypeError('either `then:` or `otherwise:` is required for `when()` conditions');
        let { is: is, then: then, otherwise: otherwise } = config;
        let check = typeof is === 'function' ? is : (...values)=>values.every((value)=>value === is);
        return new $ce4de947442b2ab1$var$Condition(refs, (values, schema)=>{
            var _branch;
            let branch = check(...values) ? then : otherwise;
            return (_branch = branch == null ? void 0 : branch(schema)) != null ? _branch : schema;
        });
    }
    constructor(refs, builder){
        this.fn = void 0;
        this.refs = refs;
        this.refs = refs;
        this.fn = builder;
    }
    resolve(base, options) {
        let values = this.refs.map((ref)=>// TODO: ? operator here?
            ref.getValue(options == null ? void 0 : options.value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context));
        let schema = this.fn(values, base, options);
        if (schema === undefined || // @ts-ignore this can be base
        schema === base) return base;
        if (!$ce4de947442b2ab1$export$213e2a3e7c4f326e(schema)) throw new TypeError('conditions must return a schema object');
        return schema.resolve(options);
    }
}
const $ce4de947442b2ab1$var$prefixes = {
    context: '$',
    value: '.'
};
function $ce4de947442b2ab1$export$eff4d24c3ff7876e(key, options) {
    return new $ce4de947442b2ab1$var$Reference(key, options);
}
class $ce4de947442b2ab1$var$Reference {
    constructor(key, options = {}){
        this.key = void 0;
        this.isContext = void 0;
        this.isValue = void 0;
        this.isSibling = void 0;
        this.path = void 0;
        this.getter = void 0;
        this.map = void 0;
        if (typeof key !== 'string') throw new TypeError('ref must be a string, got: ' + key);
        this.key = key.trim();
        if (key === '') throw new TypeError('ref must be a non-empty string');
        this.isContext = this.key[0] === $ce4de947442b2ab1$var$prefixes.context;
        this.isValue = this.key[0] === $ce4de947442b2ab1$var$prefixes.value;
        this.isSibling = !this.isContext && !this.isValue;
        let prefix = this.isContext ? $ce4de947442b2ab1$var$prefixes.context : this.isValue ? $ce4de947442b2ab1$var$prefixes.value : '';
        this.path = this.key.slice(prefix.length);
        this.getter = this.path && (0, $5bc14c0fe9940240$exports.getter)(this.path, true);
        this.map = options.map;
    }
    getValue(value, parent, context) {
        let result = this.isContext ? context : this.isValue ? value : parent;
        if (this.getter) result = this.getter(result || {});
        if (this.map) result = this.map(result);
        return result;
    }
    /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */ cast(value, options) {
        return this.getValue(value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context);
    }
    resolve() {
        return this;
    }
    describe() {
        return {
            type: 'ref',
            key: this.key
        };
    }
    toString() {
        return `Ref(${this.key})`;
    }
    static isRef(value) {
        return value && value.__isYupRef;
    }
}
// @ts-ignore
$ce4de947442b2ab1$var$Reference.prototype.__isYupRef = true;
const $ce4de947442b2ab1$var$isAbsent = (value)=>value == null;
function $ce4de947442b2ab1$var$createValidation(config) {
    function validate({ value: value, path: path = '', options: options, originalValue: originalValue, schema: schema }, panic, next) {
        const { name: name, test: test, params: params, message: message, skipAbsent: skipAbsent } = config;
        let { parent: parent, context: context, abortEarly: abortEarly = schema.spec.abortEarly, disableStackTrace: disableStackTrace = schema.spec.disableStackTrace } = options;
        const resolveOptions = {
            value: value,
            parent: parent,
            context: context
        };
        function createError(overrides = {}) {
            const nextParams = $ce4de947442b2ab1$var$resolveParams(Object.assign({
                value: value,
                originalValue: originalValue,
                label: schema.spec.label,
                path: overrides.path || path,
                spec: schema.spec,
                disableStackTrace: overrides.disableStackTrace || disableStackTrace
            }, params, overrides.params), resolveOptions);
            const error = new $ce4de947442b2ab1$export$2191b9da168c6cf0($ce4de947442b2ab1$export$2191b9da168c6cf0.formatError(overrides.message || message, nextParams), value, nextParams.path, overrides.type || name, nextParams.disableStackTrace);
            error.params = nextParams;
            return error;
        }
        const invalid = abortEarly ? panic : next;
        let ctx = {
            path: path,
            parent: parent,
            type: name,
            from: options.from,
            createError: createError,
            resolve (item) {
                return $ce4de947442b2ab1$var$resolveMaybeRef(item, resolveOptions);
            },
            options: options,
            originalValue: originalValue,
            schema: schema
        };
        const handleResult = (validOrError)=>{
            if ($ce4de947442b2ab1$export$2191b9da168c6cf0.isError(validOrError)) invalid(validOrError);
            else if (!validOrError) invalid(createError());
            else next(null);
        };
        const handleError = (err)=>{
            if ($ce4de947442b2ab1$export$2191b9da168c6cf0.isError(err)) invalid(err);
            else panic(err);
        };
        const shouldSkip = skipAbsent && $ce4de947442b2ab1$var$isAbsent(value);
        if (shouldSkip) return handleResult(true);
        let result;
        try {
            var _result;
            result = test.call(ctx, value, ctx);
            if (typeof ((_result = result) == null ? void 0 : _result.then) === 'function') {
                if (options.sync) throw new Error(`Validation test of type: "${ctx.type}" returned a Promise during a synchronous validate. ` + `This test will finish after the validate call has returned`);
                return Promise.resolve(result).then(handleResult, handleError);
            }
        } catch (err) {
            handleError(err);
            return;
        }
        handleResult(result);
    }
    validate.OPTIONS = config;
    return validate;
}
// Warning: mutates the input
function $ce4de947442b2ab1$var$resolveParams(params, options) {
    if (!params) return params;
    for (const key of Object.keys(params))params[key] = $ce4de947442b2ab1$var$resolveMaybeRef(params[key], options);
    return params;
}
function $ce4de947442b2ab1$var$resolveMaybeRef(item, options) {
    return $ce4de947442b2ab1$var$Reference.isRef(item) ? item.getValue(options.value, options.parent, options.context) : item;
}
function $ce4de947442b2ab1$export$c52e5867d5879e24(schema, path, value, context = value) {
    let parent, lastPart, lastPartDebug;
    // root path: ''
    if (!path) return {
        parent: parent,
        parentPath: path,
        schema: schema
    };
    (0, $5bc14c0fe9940240$exports.forEach)(path, (_part, isBracket, isArray)=>{
        let part = isBracket ? _part.slice(1, _part.length - 1) : _part;
        schema = schema.resolve({
            context: context,
            parent: parent,
            value: value
        });
        let isTuple = schema.type === 'tuple';
        let idx = isArray ? parseInt(part, 10) : 0;
        if (schema.innerType || isTuple) {
            if (isTuple && !isArray) throw new Error(`Yup.reach cannot implicitly index into a tuple type. the path part "${lastPartDebug}" must contain an index to the tuple element, e.g. "${lastPartDebug}[0]"`);
            if (value && idx >= value.length) throw new Error(`Yup.reach cannot resolve an array item at index: ${_part}, in the path: ${path}. ` + `because there is no value at that index. `);
            parent = value;
            value = value && value[idx];
            schema = isTuple ? schema.spec.types[idx] : schema.innerType;
        }
        // sometimes the array index part of a path doesn't exist: "nested.arr.child"
        // in these cases the current part is the next schema and should be processed
        // in this iteration. For cases where the index signature is included this
        // check will fail and we'll handle the `child` part on the next iteration like normal
        if (!isArray) {
            if (!schema.fields || !schema.fields[part]) throw new Error(`The schema does not contain the path: ${path}. ` + `(failed at: ${lastPartDebug} which is a type: "${schema.type}")`);
            parent = value;
            value = value && value[part];
            schema = schema.fields[part];
        }
        lastPart = part;
        lastPartDebug = isBracket ? '[' + _part + ']' : '.' + _part;
    });
    return {
        schema: schema,
        parent: parent,
        parentPath: lastPart
    };
}
function $ce4de947442b2ab1$export$cfedb76369cc7782(obj, path, value, context) {
    return $ce4de947442b2ab1$export$c52e5867d5879e24(obj, path, value, context).schema;
}
class $ce4de947442b2ab1$var$ReferenceSet extends Set {
    describe() {
        const description = [];
        for (const item of this.values())description.push($ce4de947442b2ab1$var$Reference.isRef(item) ? item.describe() : item);
        return description;
    }
    resolveAll(resolve) {
        let result = [];
        for (const item of this.values())result.push(resolve(item));
        return result;
    }
    clone() {
        return new $ce4de947442b2ab1$var$ReferenceSet(this.values());
    }
    merge(newItems, removeItems) {
        const next = this.clone();
        newItems.forEach((value)=>next.add(value));
        removeItems.forEach((value)=>next.delete(value));
        return next;
    }
}
// tweaked from https://github.com/Kelin2025/nanoclone/blob/0abeb7635bda9b68ef2277093f76dbe3bf3948e1/src/index.js
function $ce4de947442b2ab1$var$clone(src, seen = new Map()) {
    if ($ce4de947442b2ab1$export$213e2a3e7c4f326e(src) || !src || typeof src !== 'object') return src;
    if (seen.has(src)) return seen.get(src);
    let copy;
    if (src instanceof Date) {
        // Date
        copy = new Date(src.getTime());
        seen.set(src, copy);
    } else if (src instanceof RegExp) {
        // RegExp
        copy = new RegExp(src);
        seen.set(src, copy);
    } else if (Array.isArray(src)) {
        // Array
        copy = new Array(src.length);
        seen.set(src, copy);
        for(let i = 0; i < src.length; i++)copy[i] = $ce4de947442b2ab1$var$clone(src[i], seen);
    } else if (src instanceof Map) {
        // Map
        copy = new Map();
        seen.set(src, copy);
        for (const [k, v] of src.entries())copy.set(k, $ce4de947442b2ab1$var$clone(v, seen));
    } else if (src instanceof Set) {
        // Set
        copy = new Set();
        seen.set(src, copy);
        for (const v of src)copy.add($ce4de947442b2ab1$var$clone(v, seen));
    } else if (src instanceof Object) {
        // Object
        copy = {};
        seen.set(src, copy);
        for (const [k, v] of Object.entries(src))copy[k] = $ce4de947442b2ab1$var$clone(v, seen);
    } else throw Error(`Unable to clone ${src}`);
    return copy;
}
/**
 * Copied from @standard-schema/spec to avoid having a dependency on it.
 * https://github.com/standard-schema/standard-schema/blob/main/packages/spec/src/index.ts
 */ function $ce4de947442b2ab1$var$createStandardPath(path) {
    if (!(path != null && path.length)) return undefined;
    // Array to store the final path segments
    const segments = [];
    // Buffer for building the current segment
    let currentSegment = '';
    // Track if we're inside square brackets (array/property access)
    let inBrackets = false;
    // Track if we're inside quotes (for property names with special chars)
    let inQuotes = false;
    for(let i = 0; i < path.length; i++){
        const char = path[i];
        if (char === '[' && !inQuotes) {
            // When entering brackets, push any accumulated segment after splitting on dots
            if (currentSegment) {
                segments.push(...currentSegment.split('.').filter(Boolean));
                currentSegment = '';
            }
            inBrackets = true;
            continue;
        }
        if (char === ']' && !inQuotes) {
            if (currentSegment) {
                // Handle numeric indices (e.g. arr[0])
                if (/^\d+$/.test(currentSegment)) segments.push(currentSegment);
                else // Handle quoted property names (e.g. obj["foo.bar"])
                segments.push(currentSegment.replace(/^"|"$/g, ''));
                currentSegment = '';
            }
            inBrackets = false;
            continue;
        }
        if (char === '"') {
            // Toggle quote state for handling quoted property names
            inQuotes = !inQuotes;
            continue;
        }
        if (char === '.' && !inBrackets && !inQuotes) {
            // On dots outside brackets/quotes, push current segment
            if (currentSegment) {
                segments.push(currentSegment);
                currentSegment = '';
            }
            continue;
        }
        currentSegment += char;
    }
    // Push any remaining segment after splitting on dots
    if (currentSegment) segments.push(...currentSegment.split('.').filter(Boolean));
    return segments;
}
function $ce4de947442b2ab1$var$createStandardIssues(error, parentPath) {
    const path = parentPath ? `${parentPath}.${error.path}` : error.path;
    return error.errors.map((err)=>({
            message: err,
            path: $ce4de947442b2ab1$var$createStandardPath(path)
        }));
}
function $ce4de947442b2ab1$var$issuesFromValidationError(error, parentPath) {
    var _error$inner;
    if (!((_error$inner = error.inner) != null && _error$inner.length) && error.errors.length) return $ce4de947442b2ab1$var$createStandardIssues(error, parentPath);
    const path = parentPath ? `${parentPath}.${error.path}` : error.path;
    return error.inner.flatMap((err)=>$ce4de947442b2ab1$var$issuesFromValidationError(err, path));
}
// If `CustomSchemaMeta` isn't extended with any keys, we'll fall back to a
// loose Record definition allowing free form usage.
class $ce4de947442b2ab1$export$19342e026b58ebb7 {
    constructor(options){
        this.type = void 0;
        this.deps = [];
        this.tests = void 0;
        this.transforms = void 0;
        this.conditions = [];
        this._mutate = void 0;
        this.internalTests = {};
        this._whitelist = new $ce4de947442b2ab1$var$ReferenceSet();
        this._blacklist = new $ce4de947442b2ab1$var$ReferenceSet();
        this.exclusiveTests = Object.create(null);
        this._typeCheck = void 0;
        this.spec = void 0;
        this.tests = [];
        this.transforms = [];
        this.withMutation(()=>{
            this.typeError($ce4de947442b2ab1$var$mixed.notType);
        });
        this.type = options.type;
        this._typeCheck = options.check;
        this.spec = Object.assign({
            strip: false,
            strict: false,
            abortEarly: true,
            recursive: true,
            disableStackTrace: false,
            nullable: false,
            optional: true,
            coerce: true
        }, options == null ? void 0 : options.spec);
        this.withMutation((s)=>{
            s.nonNullable();
        });
    }
    // TODO: remove
    get _type() {
        return this.type;
    }
    clone(spec) {
        if (this._mutate) {
            if (spec) Object.assign(this.spec, spec);
            return this;
        }
        // if the nested value is a schema we can skip cloning, since
        // they are already immutable
        const next = Object.create(Object.getPrototypeOf(this));
        // @ts-expect-error this is readonly
        next.type = this.type;
        next._typeCheck = this._typeCheck;
        next._whitelist = this._whitelist.clone();
        next._blacklist = this._blacklist.clone();
        next.internalTests = Object.assign({}, this.internalTests);
        next.exclusiveTests = Object.assign({}, this.exclusiveTests);
        // @ts-expect-error this is readonly
        next.deps = [
            ...this.deps
        ];
        next.conditions = [
            ...this.conditions
        ];
        next.tests = [
            ...this.tests
        ];
        next.transforms = [
            ...this.transforms
        ];
        next.spec = $ce4de947442b2ab1$var$clone(Object.assign({}, this.spec, spec));
        return next;
    }
    label(label) {
        let next = this.clone();
        next.spec.label = label;
        return next;
    }
    meta(...args) {
        if (args.length === 0) return this.spec.meta;
        let next = this.clone();
        next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
        return next;
    }
    withMutation(fn) {
        let before = this._mutate;
        this._mutate = true;
        let result = fn(this);
        this._mutate = before;
        return result;
    }
    concat(schema) {
        if (!schema || schema === this) return this;
        if (schema.type !== this.type && this.type !== 'mixed') throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${schema.type}`);
        let base = this;
        let combined = schema.clone();
        const mergedSpec = Object.assign({}, base.spec, combined.spec);
        combined.spec = mergedSpec;
        combined.internalTests = Object.assign({}, base.internalTests, combined.internalTests);
        // manually merge the blacklist/whitelist (the other `schema` takes
        // precedence in case of conflicts)
        combined._whitelist = base._whitelist.merge(schema._whitelist, schema._blacklist);
        combined._blacklist = base._blacklist.merge(schema._blacklist, schema._whitelist);
        // start with the current tests
        combined.tests = base.tests;
        combined.exclusiveTests = base.exclusiveTests;
        // manually add the new tests to ensure
        // the deduping logic is consistent
        combined.withMutation((next)=>{
            schema.tests.forEach((fn)=>{
                next.test(fn.OPTIONS);
            });
        });
        combined.transforms = [
            ...base.transforms,
            ...combined.transforms
        ];
        return combined;
    }
    isType(v) {
        if (v == null) {
            if (this.spec.nullable && v === null) return true;
            if (this.spec.optional && v === undefined) return true;
            return false;
        }
        return this._typeCheck(v);
    }
    resolve(options) {
        let schema = this;
        if (schema.conditions.length) {
            let conditions = schema.conditions;
            schema = schema.clone();
            schema.conditions = [];
            schema = conditions.reduce((prevSchema, condition)=>condition.resolve(prevSchema, options), schema);
            schema = schema.resolve(options);
        }
        return schema;
    }
    resolveOptions(options) {
        var _options$strict, _options$abortEarly, _options$recursive, _options$disableStack;
        return Object.assign({}, options, {
            from: options.from || [],
            strict: (_options$strict = options.strict) != null ? _options$strict : this.spec.strict,
            abortEarly: (_options$abortEarly = options.abortEarly) != null ? _options$abortEarly : this.spec.abortEarly,
            recursive: (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive,
            disableStackTrace: (_options$disableStack = options.disableStackTrace) != null ? _options$disableStack : this.spec.disableStackTrace
        });
    }
    /**
   * Run the configured transform pipeline over an input value.
   */ cast(value, options = {}) {
        let resolvedSchema = this.resolve(Object.assign({}, options, {
            value: value
        }));
        let allowOptionality = options.assert === 'ignore-optionality';
        let result = resolvedSchema._cast(value, options);
        if (options.assert !== false && !resolvedSchema.isType(result)) {
            if (allowOptionality && $ce4de947442b2ab1$var$isAbsent(result)) return result;
            let formattedValue = $ce4de947442b2ab1$export$5790025c6e6c2ba6(value);
            let formattedResult = $ce4de947442b2ab1$export$5790025c6e6c2ba6(result);
            throw new TypeError(`The value of ${options.path || 'field'} could not be cast to a value ` + `that satisfies the schema type: "${resolvedSchema.type}". \n\n` + `attempted value: ${formattedValue} \n` + (formattedResult !== formattedValue ? `result of cast: ${formattedResult}` : ''));
        }
        return result;
    }
    _cast(rawValue, options) {
        let value = rawValue === undefined ? rawValue : this.transforms.reduce((prevValue, fn)=>fn.call(this, prevValue, rawValue, this, options), rawValue);
        if (value === undefined) value = this.getDefault(options);
        return value;
    }
    _validate(_value, options = {}, panic, next) {
        let { path: path, originalValue: originalValue = _value, strict: strict = this.spec.strict } = options;
        let value = _value;
        if (!strict) value = this._cast(value, Object.assign({
            assert: false
        }, options));
        let initialTests = [];
        for (let test of Object.values(this.internalTests))if (test) initialTests.push(test);
        this.runTests({
            path: path,
            value: value,
            originalValue: originalValue,
            options: options,
            tests: initialTests
        }, panic, (initialErrors)=>{
            // even if we aren't ending early we can't proceed further if the types aren't correct
            if (initialErrors.length) return next(initialErrors, value);
            this.runTests({
                path: path,
                value: value,
                originalValue: originalValue,
                options: options,
                tests: this.tests
            }, panic, next);
        });
    }
    /**
   * Executes a set of validations, either schema, produced Tests or a nested
   * schema validate result.
   */ runTests(runOptions, panic, next) {
        let fired = false;
        let { tests: tests, value: value, originalValue: originalValue, path: path, options: options } = runOptions;
        let panicOnce = (arg)=>{
            if (fired) return;
            fired = true;
            panic(arg, value);
        };
        let nextOnce = (arg)=>{
            if (fired) return;
            fired = true;
            next(arg, value);
        };
        let count = tests.length;
        let nestedErrors = [];
        if (!count) return nextOnce([]);
        let args = {
            value: value,
            originalValue: originalValue,
            path: path,
            options: options,
            schema: this
        };
        for(let i = 0; i < tests.length; i++){
            const test = tests[i];
            test(args, panicOnce, function finishTestRun(err) {
                if (err) Array.isArray(err) ? nestedErrors.push(...err) : nestedErrors.push(err);
                if (--count <= 0) nextOnce(nestedErrors);
            });
        }
    }
    asNestedTest({ key: key, index: index, parent: parent, parentPath: parentPath, originalParent: originalParent, options: options }) {
        const k = key != null ? key : index;
        if (k == null) throw TypeError('Must include `key` or `index` for nested validations');
        const isIndex = typeof k === 'number';
        let value = parent[k];
        const testOptions = Object.assign({}, options, {
            // Nested validations fields are always strict:
            //    1. parent isn't strict so the casting will also have cast inner values
            //    2. parent is strict in which case the nested values weren't cast either
            strict: true,
            parent: parent,
            value: value,
            originalValue: originalParent[k],
            // FIXME: tests depend on `index` being passed around deeply,
            //   we should not let the options.key/index bleed through
            key: undefined,
            // index: undefined,
            [isIndex ? 'index' : 'key']: k,
            path: isIndex || k.includes('.') ? `${parentPath || ''}[${isIndex ? k : `"${k}"`}]` : (parentPath ? `${parentPath}.` : '') + key
        });
        return (_, panic, next)=>this.resolve(testOptions)._validate(value, testOptions, panic, next);
    }
    validate(value, options) {
        var _options$disableStack2;
        let schema = this.resolve(Object.assign({}, options, {
            value: value
        }));
        let disableStackTrace = (_options$disableStack2 = options == null ? void 0 : options.disableStackTrace) != null ? _options$disableStack2 : schema.spec.disableStackTrace;
        return new Promise((resolve, reject)=>schema._validate(value, options, (error, parsed)=>{
                if ($ce4de947442b2ab1$export$2191b9da168c6cf0.isError(error)) error.value = parsed;
                reject(error);
            }, (errors, validated)=>{
                if (errors.length) reject(new $ce4de947442b2ab1$export$2191b9da168c6cf0(errors, validated, undefined, undefined, disableStackTrace));
                else resolve(validated);
            }));
    }
    validateSync(value, options) {
        var _options$disableStack3;
        let schema = this.resolve(Object.assign({}, options, {
            value: value
        }));
        let result;
        let disableStackTrace = (_options$disableStack3 = options == null ? void 0 : options.disableStackTrace) != null ? _options$disableStack3 : schema.spec.disableStackTrace;
        schema._validate(value, Object.assign({}, options, {
            sync: true
        }), (error, parsed)=>{
            if ($ce4de947442b2ab1$export$2191b9da168c6cf0.isError(error)) error.value = parsed;
            throw error;
        }, (errors, validated)=>{
            if (errors.length) throw new $ce4de947442b2ab1$export$2191b9da168c6cf0(errors, value, undefined, undefined, disableStackTrace);
            result = validated;
        });
        return result;
    }
    isValid(value, options) {
        return this.validate(value, options).then(()=>true, (err)=>{
            if ($ce4de947442b2ab1$export$2191b9da168c6cf0.isError(err)) return false;
            throw err;
        });
    }
    isValidSync(value, options) {
        try {
            this.validateSync(value, options);
            return true;
        } catch (err) {
            if ($ce4de947442b2ab1$export$2191b9da168c6cf0.isError(err)) return false;
            throw err;
        }
    }
    _getDefault(options) {
        let defaultValue = this.spec.default;
        if (defaultValue == null) return defaultValue;
        return typeof defaultValue === 'function' ? defaultValue.call(this, options) : $ce4de947442b2ab1$var$clone(defaultValue);
    }
    getDefault(options) {
        let schema = this.resolve(options || {});
        return schema._getDefault(options);
    }
    default(def) {
        if (arguments.length === 0) return this._getDefault();
        let next = this.clone({
            default: def
        });
        return next;
    }
    strict(isStrict = true) {
        return this.clone({
            strict: isStrict
        });
    }
    nullability(nullable, message) {
        const next = this.clone({
            nullable: nullable
        });
        next.internalTests.nullable = $ce4de947442b2ab1$var$createValidation({
            message: message,
            name: 'nullable',
            test (value) {
                return value === null ? this.schema.spec.nullable : true;
            }
        });
        return next;
    }
    optionality(optional, message) {
        const next = this.clone({
            optional: optional
        });
        next.internalTests.optionality = $ce4de947442b2ab1$var$createValidation({
            message: message,
            name: 'optionality',
            test (value) {
                return value === undefined ? this.schema.spec.optional : true;
            }
        });
        return next;
    }
    optional() {
        return this.optionality(true);
    }
    defined(message = $ce4de947442b2ab1$var$mixed.defined) {
        return this.optionality(false, message);
    }
    nullable() {
        return this.nullability(true);
    }
    nonNullable(message = $ce4de947442b2ab1$var$mixed.notNull) {
        return this.nullability(false, message);
    }
    required(message = $ce4de947442b2ab1$var$mixed.required) {
        return this.clone().withMutation((next)=>next.nonNullable(message).defined(message));
    }
    notRequired() {
        return this.clone().withMutation((next)=>next.nullable().optional());
    }
    transform(fn) {
        let next = this.clone();
        next.transforms.push(fn);
        return next;
    }
    /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */ test(...args) {
        let opts;
        if (args.length === 1) {
            if (typeof args[0] === 'function') opts = {
                test: args[0]
            };
            else opts = args[0];
        } else if (args.length === 2) opts = {
            name: args[0],
            test: args[1]
        };
        else opts = {
            name: args[0],
            message: args[1],
            test: args[2]
        };
        if (opts.message === undefined) opts.message = $ce4de947442b2ab1$var$mixed.default;
        if (typeof opts.test !== 'function') throw new TypeError('`test` is a required parameters');
        let next = this.clone();
        let validate = $ce4de947442b2ab1$var$createValidation(opts);
        let isExclusive = opts.exclusive || opts.name && next.exclusiveTests[opts.name] === true;
        if (opts.exclusive) {
            if (!opts.name) throw new TypeError('Exclusive tests must provide a unique `name` identifying the test');
        }
        if (opts.name) next.exclusiveTests[opts.name] = !!opts.exclusive;
        next.tests = next.tests.filter((fn)=>{
            if (fn.OPTIONS.name === opts.name) {
                if (isExclusive) return false;
                if (fn.OPTIONS.test === validate.OPTIONS.test) return false;
            }
            return true;
        });
        next.tests.push(validate);
        return next;
    }
    when(keys, options) {
        if (!Array.isArray(keys) && typeof keys !== 'string') {
            options = keys;
            keys = '.';
        }
        let next = this.clone();
        let deps = $ce4de947442b2ab1$var$toArray(keys).map((key)=>new $ce4de947442b2ab1$var$Reference(key));
        deps.forEach((dep)=>{
            // @ts-ignore readonly array
            if (dep.isSibling) next.deps.push(dep.key);
        });
        next.conditions.push(typeof options === 'function' ? new $ce4de947442b2ab1$var$Condition(deps, options) : $ce4de947442b2ab1$var$Condition.fromOptions(deps, options));
        return next;
    }
    typeError(message) {
        let next = this.clone();
        next.internalTests.typeError = $ce4de947442b2ab1$var$createValidation({
            message: message,
            name: 'typeError',
            skipAbsent: true,
            test (value) {
                if (!this.schema._typeCheck(value)) return this.createError({
                    params: {
                        type: this.schema.type
                    }
                });
                return true;
            }
        });
        return next;
    }
    oneOf(enums, message = $ce4de947442b2ab1$var$mixed.oneOf) {
        let next = this.clone();
        enums.forEach((val)=>{
            next._whitelist.add(val);
            next._blacklist.delete(val);
        });
        next.internalTests.whiteList = $ce4de947442b2ab1$var$createValidation({
            message: message,
            name: 'oneOf',
            skipAbsent: true,
            test (value) {
                let valids = this.schema._whitelist;
                let resolved = valids.resolveAll(this.resolve);
                return resolved.includes(value) ? true : this.createError({
                    params: {
                        values: Array.from(valids).join(', '),
                        resolved: resolved
                    }
                });
            }
        });
        return next;
    }
    notOneOf(enums, message = $ce4de947442b2ab1$var$mixed.notOneOf) {
        let next = this.clone();
        enums.forEach((val)=>{
            next._blacklist.add(val);
            next._whitelist.delete(val);
        });
        next.internalTests.blacklist = $ce4de947442b2ab1$var$createValidation({
            message: message,
            name: 'notOneOf',
            test (value) {
                let invalids = this.schema._blacklist;
                let resolved = invalids.resolveAll(this.resolve);
                if (resolved.includes(value)) return this.createError({
                    params: {
                        values: Array.from(invalids).join(', '),
                        resolved: resolved
                    }
                });
                return true;
            }
        });
        return next;
    }
    strip(strip = true) {
        let next = this.clone();
        next.spec.strip = strip;
        return next;
    }
    /**
   * Return a serialized description of the schema including validations, flags, types etc.
   *
   * @param options Provide any needed context for resolving runtime schema alterations (lazy, when conditions, etc).
   */ describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const { label: label, meta: meta, optional: optional, nullable: nullable } = next.spec;
        const description = {
            meta: meta,
            label: label,
            optional: optional,
            nullable: nullable,
            default: next.getDefault(options),
            type: next.type,
            oneOf: next._whitelist.describe(),
            notOneOf: next._blacklist.describe(),
            tests: next.tests.filter((n, idx, list)=>list.findIndex((c)=>c.OPTIONS.name === n.OPTIONS.name) === idx).map((fn)=>{
                const params = fn.OPTIONS.params && options ? $ce4de947442b2ab1$var$resolveParams(Object.assign({}, fn.OPTIONS.params), options) : fn.OPTIONS.params;
                return {
                    name: fn.OPTIONS.name,
                    params: params
                };
            })
        };
        return description;
    }
    get ['~standard']() {
        const schema = this;
        const standard = {
            version: 1,
            vendor: 'yup',
            async validate (value) {
                try {
                    const result = await schema.validate(value, {
                        abortEarly: false
                    });
                    return {
                        value: result
                    };
                } catch (err) {
                    if (err instanceof $ce4de947442b2ab1$export$2191b9da168c6cf0) return {
                        issues: $ce4de947442b2ab1$var$issuesFromValidationError(err)
                    };
                    throw err;
                }
            }
        };
        return standard;
    }
}
// @ts-expect-error
$ce4de947442b2ab1$export$19342e026b58ebb7.prototype.__isYupSchema__ = true;
for (const method of [
    'validate',
    'validateSync'
])$ce4de947442b2ab1$export$19342e026b58ebb7.prototype[`${method}At`] = function(path, value, options = {}) {
    const { parent: parent, parentPath: parentPath, schema: schema } = $ce4de947442b2ab1$export$c52e5867d5879e24(this, path, value, options.context);
    return schema[method](parent && parent[parentPath], Object.assign({}, options, {
        parent: parent,
        path: path
    }));
};
for (const alias of [
    'equals',
    'is'
])$ce4de947442b2ab1$export$19342e026b58ebb7.prototype[alias] = $ce4de947442b2ab1$export$19342e026b58ebb7.prototype.oneOf;
for (const alias of [
    'not',
    'nope'
])$ce4de947442b2ab1$export$19342e026b58ebb7.prototype[alias] = $ce4de947442b2ab1$export$19342e026b58ebb7.prototype.notOneOf;
const $ce4de947442b2ab1$var$returnsTrue = ()=>true;
function $ce4de947442b2ab1$export$9b30b6294c1449a8(spec) {
    return new $ce4de947442b2ab1$export$1e88358c94ddec71(spec);
}
class $ce4de947442b2ab1$export$1e88358c94ddec71 extends $ce4de947442b2ab1$export$19342e026b58ebb7 {
    constructor(spec){
        super(typeof spec === 'function' ? {
            type: 'mixed',
            check: spec
        } : Object.assign({
            type: 'mixed',
            check: $ce4de947442b2ab1$var$returnsTrue
        }, spec));
    }
}
$ce4de947442b2ab1$export$9b30b6294c1449a8.prototype = $ce4de947442b2ab1$export$1e88358c94ddec71.prototype;
function $ce4de947442b2ab1$export$87b259aa03e3d267() {
    return new $ce4de947442b2ab1$export$c7980688f11e1f49();
}
class $ce4de947442b2ab1$export$c7980688f11e1f49 extends $ce4de947442b2ab1$export$19342e026b58ebb7 {
    constructor(){
        super({
            type: 'boolean',
            check (v) {
                if (v instanceof Boolean) v = v.valueOf();
                return typeof v === 'boolean';
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw)=>{
                if (this.spec.coerce && !this.isType(value)) {
                    if (/^(true|1)$/i.test(String(value))) return true;
                    if (/^(false|0)$/i.test(String(value))) return false;
                }
                return value;
            });
        });
    }
    isTrue(message = $ce4de947442b2ab1$var$boolean.isValue) {
        return this.test({
            message: message,
            name: 'is-value',
            exclusive: true,
            params: {
                value: 'true'
            },
            test (value) {
                return $ce4de947442b2ab1$var$isAbsent(value) || value === true;
            }
        });
    }
    isFalse(message = $ce4de947442b2ab1$var$boolean.isValue) {
        return this.test({
            message: message,
            name: 'is-value',
            exclusive: true,
            params: {
                value: 'false'
            },
            test (value) {
                return $ce4de947442b2ab1$var$isAbsent(value) || value === false;
            }
        });
    }
    default(def) {
        return super.default(def);
    }
    defined(msg) {
        return super.defined(msg);
    }
    optional() {
        return super.optional();
    }
    required(msg) {
        return super.required(msg);
    }
    notRequired() {
        return super.notRequired();
    }
    nullable() {
        return super.nullable();
    }
    nonNullable(msg) {
        return super.nonNullable(msg);
    }
    strip(v) {
        return super.strip(v);
    }
}
$ce4de947442b2ab1$export$87b259aa03e3d267.prototype = $ce4de947442b2ab1$export$c7980688f11e1f49.prototype;
/**
 * This file is a modified version of the file from the following repository:
 * Date.parse with progressive enhancement for ISO 8601 <https://github.com/csnover/js-iso8601>
 * NON-CONFORMANT EDITION.
 * © 2011 Colin Snover <http://zetafleet.com>
 * Released under MIT license.
 */ // prettier-ignore
//                1 YYYY                2 MM        3 DD              4 HH     5 mm        6 ss           7 msec         8 Z 9 ±   10 tzHH    11 tzmm
const $ce4de947442b2ab1$var$isoReg = /^(\d{4}|[+-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,.](\d{1,}))?)?(?:(Z)|([+-])(\d{2})(?::?(\d{2}))?)?)?$/;
function $ce4de947442b2ab1$var$parseIsoDate(date) {
    const struct = $ce4de947442b2ab1$var$parseDateStruct(date);
    if (!struct) return Date.parse ? Date.parse(date) : Number.NaN;
    // timestamps without timezone identifiers should be considered local time
    if (struct.z === undefined && struct.plusMinus === undefined) return new Date(struct.year, struct.month, struct.day, struct.hour, struct.minute, struct.second, struct.millisecond).valueOf();
    let totalMinutesOffset = 0;
    if (struct.z !== 'Z' && struct.plusMinus !== undefined) {
        totalMinutesOffset = struct.hourOffset * 60 + struct.minuteOffset;
        if (struct.plusMinus === '+') totalMinutesOffset = 0 - totalMinutesOffset;
    }
    return Date.UTC(struct.year, struct.month, struct.day, struct.hour, struct.minute + totalMinutesOffset, struct.second, struct.millisecond);
}
function $ce4de947442b2ab1$var$parseDateStruct(date) {
    var _regexResult$7$length, _regexResult$;
    const regexResult = $ce4de947442b2ab1$var$isoReg.exec(date);
    if (!regexResult) return null;
    // use of toNumber() avoids NaN timestamps caused by “undefined”
    // values being passed to Date constructor
    return {
        year: $ce4de947442b2ab1$var$toNumber(regexResult[1]),
        month: $ce4de947442b2ab1$var$toNumber(regexResult[2], 1) - 1,
        day: $ce4de947442b2ab1$var$toNumber(regexResult[3], 1),
        hour: $ce4de947442b2ab1$var$toNumber(regexResult[4]),
        minute: $ce4de947442b2ab1$var$toNumber(regexResult[5]),
        second: $ce4de947442b2ab1$var$toNumber(regexResult[6]),
        millisecond: regexResult[7] ? // allow arbitrary sub-second precision beyond milliseconds
        $ce4de947442b2ab1$var$toNumber(regexResult[7].substring(0, 3)) : 0,
        precision: (_regexResult$7$length = (_regexResult$ = regexResult[7]) == null ? void 0 : _regexResult$.length) != null ? _regexResult$7$length : undefined,
        z: regexResult[8] || undefined,
        plusMinus: regexResult[9] || undefined,
        hourOffset: $ce4de947442b2ab1$var$toNumber(regexResult[10]),
        minuteOffset: $ce4de947442b2ab1$var$toNumber(regexResult[11])
    };
}
function $ce4de947442b2ab1$var$toNumber(str, defaultValue = 0) {
    return Number(str) || defaultValue;
}
// Taken from HTML spec: https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address
let $ce4de947442b2ab1$var$rEmail = // eslint-disable-next-line
/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
let $ce4de947442b2ab1$var$rUrl = // eslint-disable-next-line
/^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i;
// eslint-disable-next-line
let $ce4de947442b2ab1$var$rUUID = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
let $ce4de947442b2ab1$var$yearMonthDay = '^\\d{4}-\\d{2}-\\d{2}';
let $ce4de947442b2ab1$var$hourMinuteSecond = '\\d{2}:\\d{2}:\\d{2}';
let $ce4de947442b2ab1$var$zOrOffset = '(([+-]\\d{2}(:?\\d{2})?)|Z)';
let $ce4de947442b2ab1$var$rIsoDateTime = new RegExp(`${$ce4de947442b2ab1$var$yearMonthDay}T${$ce4de947442b2ab1$var$hourMinuteSecond}(\\.\\d+)?${$ce4de947442b2ab1$var$zOrOffset}$`);
let $ce4de947442b2ab1$var$isTrimmed = (value)=>$ce4de947442b2ab1$var$isAbsent(value) || value === value.trim();
let $ce4de947442b2ab1$var$objStringTag = ({}).toString();
function $ce4de947442b2ab1$export$22b082955e083ec3() {
    return new $ce4de947442b2ab1$export$49bf8b2ede5138eb();
}
class $ce4de947442b2ab1$export$49bf8b2ede5138eb extends $ce4de947442b2ab1$export$19342e026b58ebb7 {
    constructor(){
        super({
            type: 'string',
            check (value) {
                if (value instanceof String) value = value.valueOf();
                return typeof value === 'string';
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw)=>{
                if (!this.spec.coerce || this.isType(value)) return value;
                // don't ever convert arrays
                if (Array.isArray(value)) return value;
                const strValue = value != null && value.toString ? value.toString() : value;
                // no one wants plain objects converted to [Object object]
                if (strValue === $ce4de947442b2ab1$var$objStringTag) return value;
                return strValue;
            });
        });
    }
    required(message) {
        return super.required(message).withMutation((schema)=>schema.test({
                message: message || $ce4de947442b2ab1$var$mixed.required,
                name: 'required',
                skipAbsent: true,
                test: (value)=>!!value.length
            }));
    }
    notRequired() {
        return super.notRequired().withMutation((schema)=>{
            schema.tests = schema.tests.filter((t)=>t.OPTIONS.name !== 'required');
            return schema;
        });
    }
    length(length, message = $ce4de947442b2ab1$var$string.length) {
        return this.test({
            message: message,
            name: 'length',
            exclusive: true,
            params: {
                length: length
            },
            skipAbsent: true,
            test (value) {
                return value.length === this.resolve(length);
            }
        });
    }
    min(min, message = $ce4de947442b2ab1$var$string.min) {
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            test (value) {
                return value.length >= this.resolve(min);
            }
        });
    }
    max(max, message = $ce4de947442b2ab1$var$string.max) {
        return this.test({
            name: 'max',
            exclusive: true,
            message: message,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value.length <= this.resolve(max);
            }
        });
    }
    matches(regex, options) {
        let excludeEmptyString = false;
        let message;
        let name;
        if (options) {
            if (typeof options === 'object') ({ excludeEmptyString: excludeEmptyString = false, message: message, name: name } = options);
            else message = options;
        }
        return this.test({
            name: name || 'matches',
            message: message || $ce4de947442b2ab1$var$string.matches,
            params: {
                regex: regex
            },
            skipAbsent: true,
            test: (value)=>value === '' && excludeEmptyString || value.search(regex) !== -1
        });
    }
    email(message = $ce4de947442b2ab1$var$string.email) {
        return this.matches($ce4de947442b2ab1$var$rEmail, {
            name: 'email',
            message: message,
            excludeEmptyString: true
        });
    }
    url(message = $ce4de947442b2ab1$var$string.url) {
        return this.matches($ce4de947442b2ab1$var$rUrl, {
            name: 'url',
            message: message,
            excludeEmptyString: true
        });
    }
    uuid(message = $ce4de947442b2ab1$var$string.uuid) {
        return this.matches($ce4de947442b2ab1$var$rUUID, {
            name: 'uuid',
            message: message,
            excludeEmptyString: false
        });
    }
    datetime(options) {
        let message = '';
        let allowOffset;
        let precision;
        if (options) {
            if (typeof options === 'object') ({ message: message = '', allowOffset: allowOffset = false, precision: precision } = options);
            else message = options;
        }
        return this.matches($ce4de947442b2ab1$var$rIsoDateTime, {
            name: 'datetime',
            message: message || $ce4de947442b2ab1$var$string.datetime,
            excludeEmptyString: true
        }).test({
            name: 'datetime_offset',
            message: message || $ce4de947442b2ab1$var$string.datetime_offset,
            params: {
                allowOffset: allowOffset
            },
            skipAbsent: true,
            test: (value)=>{
                if (!value || allowOffset) return true;
                const struct = $ce4de947442b2ab1$var$parseDateStruct(value);
                if (!struct) return false;
                return !!struct.z;
            }
        }).test({
            name: 'datetime_precision',
            message: message || $ce4de947442b2ab1$var$string.datetime_precision,
            params: {
                precision: precision
            },
            skipAbsent: true,
            test: (value)=>{
                if (!value || precision == undefined) return true;
                const struct = $ce4de947442b2ab1$var$parseDateStruct(value);
                if (!struct) return false;
                return struct.precision === precision;
            }
        });
    }
    //-- transforms --
    ensure() {
        return this.default('').transform((val)=>val === null ? '' : val);
    }
    trim(message = $ce4de947442b2ab1$var$string.trim) {
        return this.transform((val)=>val != null ? val.trim() : val).test({
            message: message,
            name: 'trim',
            test: $ce4de947442b2ab1$var$isTrimmed
        });
    }
    lowercase(message = $ce4de947442b2ab1$var$string.lowercase) {
        return this.transform((value)=>!$ce4de947442b2ab1$var$isAbsent(value) ? value.toLowerCase() : value).test({
            message: message,
            name: 'string_case',
            exclusive: true,
            skipAbsent: true,
            test: (value)=>$ce4de947442b2ab1$var$isAbsent(value) || value === value.toLowerCase()
        });
    }
    uppercase(message = $ce4de947442b2ab1$var$string.uppercase) {
        return this.transform((value)=>!$ce4de947442b2ab1$var$isAbsent(value) ? value.toUpperCase() : value).test({
            message: message,
            name: 'string_case',
            exclusive: true,
            skipAbsent: true,
            test: (value)=>$ce4de947442b2ab1$var$isAbsent(value) || value === value.toUpperCase()
        });
    }
}
$ce4de947442b2ab1$export$22b082955e083ec3.prototype = $ce4de947442b2ab1$export$49bf8b2ede5138eb.prototype;
//
// String Interfaces
//
let $ce4de947442b2ab1$var$isNaN$1 = (value)=>value != +value;
function $ce4de947442b2ab1$export$98e628dec113755e() {
    return new $ce4de947442b2ab1$export$f192ec5e9228ab19();
}
class $ce4de947442b2ab1$export$f192ec5e9228ab19 extends $ce4de947442b2ab1$export$19342e026b58ebb7 {
    constructor(){
        super({
            type: 'number',
            check (value) {
                if (value instanceof Number) value = value.valueOf();
                return typeof value === 'number' && !$ce4de947442b2ab1$var$isNaN$1(value);
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw)=>{
                if (!this.spec.coerce) return value;
                let parsed = value;
                if (typeof parsed === 'string') {
                    parsed = parsed.replace(/\s/g, '');
                    if (parsed === '') return NaN;
                    // don't use parseFloat to avoid positives on alpha-numeric strings
                    parsed = +parsed;
                }
                // null -> NaN isn't useful; treat all nulls as null and let it fail on
                // nullability check vs TypeErrors
                if (this.isType(parsed) || parsed === null) return parsed;
                return parseFloat(parsed);
            });
        });
    }
    min(min, message = $ce4de947442b2ab1$var$number.min) {
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            test (value) {
                return value >= this.resolve(min);
            }
        });
    }
    max(max, message = $ce4de947442b2ab1$var$number.max) {
        return this.test({
            message: message,
            name: 'max',
            exclusive: true,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value <= this.resolve(max);
            }
        });
    }
    lessThan(less, message = $ce4de947442b2ab1$var$number.lessThan) {
        return this.test({
            message: message,
            name: 'max',
            exclusive: true,
            params: {
                less: less
            },
            skipAbsent: true,
            test (value) {
                return value < this.resolve(less);
            }
        });
    }
    moreThan(more, message = $ce4de947442b2ab1$var$number.moreThan) {
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                more: more
            },
            skipAbsent: true,
            test (value) {
                return value > this.resolve(more);
            }
        });
    }
    positive(msg = $ce4de947442b2ab1$var$number.positive) {
        return this.moreThan(0, msg);
    }
    negative(msg = $ce4de947442b2ab1$var$number.negative) {
        return this.lessThan(0, msg);
    }
    integer(message = $ce4de947442b2ab1$var$number.integer) {
        return this.test({
            name: 'integer',
            message: message,
            skipAbsent: true,
            test: (val)=>Number.isInteger(val)
        });
    }
    truncate() {
        return this.transform((value)=>!$ce4de947442b2ab1$var$isAbsent(value) ? value | 0 : value);
    }
    round(method) {
        var _method;
        let avail = [
            'ceil',
            'floor',
            'round',
            'trunc'
        ];
        method = ((_method = method) == null ? void 0 : _method.toLowerCase()) || 'round';
        // this exists for symemtry with the new Math.trunc
        if (method === 'trunc') return this.truncate();
        if (avail.indexOf(method.toLowerCase()) === -1) throw new TypeError('Only valid options for round() are: ' + avail.join(', '));
        return this.transform((value)=>!$ce4de947442b2ab1$var$isAbsent(value) ? Math[method](value) : value);
    }
}
$ce4de947442b2ab1$export$98e628dec113755e.prototype = $ce4de947442b2ab1$export$f192ec5e9228ab19.prototype;
//
// Number Interfaces
//
let $ce4de947442b2ab1$var$invalidDate = new Date('');
let $ce4de947442b2ab1$var$isDate = (obj)=>Object.prototype.toString.call(obj) === '[object Date]';
function $ce4de947442b2ab1$export$324d90190a8b822a() {
    return new $ce4de947442b2ab1$export$18ec3cc5a157503f();
}
class $ce4de947442b2ab1$export$18ec3cc5a157503f extends $ce4de947442b2ab1$export$19342e026b58ebb7 {
    constructor(){
        super({
            type: 'date',
            check (v) {
                return $ce4de947442b2ab1$var$isDate(v) && !isNaN(v.getTime());
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw)=>{
                // null -> InvalidDate isn't useful; treat all nulls as null and let it fail on
                // nullability check vs TypeErrors
                if (!this.spec.coerce || this.isType(value) || value === null) return value;
                value = $ce4de947442b2ab1$var$parseIsoDate(value);
                // 0 is a valid timestamp equivalent to 1970-01-01T00:00:00Z(unix epoch) or before.
                return !isNaN(value) ? new Date(value) : $ce4de947442b2ab1$export$18ec3cc5a157503f.INVALID_DATE;
            });
        });
    }
    prepareParam(ref, name) {
        let param;
        if (!$ce4de947442b2ab1$var$Reference.isRef(ref)) {
            let cast = this.cast(ref);
            if (!this._typeCheck(cast)) throw new TypeError(`\`${name}\` must be a Date or a value that can be \`cast()\` to a Date`);
            param = cast;
        } else param = ref;
        return param;
    }
    min(min, message = $ce4de947442b2ab1$var$date.min) {
        let limit = this.prepareParam(min, 'min');
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            test (value) {
                return value >= this.resolve(limit);
            }
        });
    }
    max(max, message = $ce4de947442b2ab1$var$date.max) {
        let limit = this.prepareParam(max, 'max');
        return this.test({
            message: message,
            name: 'max',
            exclusive: true,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value <= this.resolve(limit);
            }
        });
    }
}
$ce4de947442b2ab1$export$18ec3cc5a157503f.INVALID_DATE = $ce4de947442b2ab1$var$invalidDate;
$ce4de947442b2ab1$export$324d90190a8b822a.prototype = $ce4de947442b2ab1$export$18ec3cc5a157503f.prototype;
$ce4de947442b2ab1$export$324d90190a8b822a.INVALID_DATE = $ce4de947442b2ab1$var$invalidDate;
// @ts-expect-error
function $ce4de947442b2ab1$var$sortFields(fields, excludedEdges = []) {
    let edges = [];
    let nodes = new Set();
    let excludes = new Set(excludedEdges.map(([a, b])=>`${a}-${b}`));
    function addNode(depPath, key) {
        let node = (0, $5bc14c0fe9940240$exports.split)(depPath)[0];
        nodes.add(node);
        if (!excludes.has(`${key}-${node}`)) edges.push([
            key,
            node
        ]);
    }
    for (const key of Object.keys(fields)){
        let value = fields[key];
        nodes.add(key);
        if ($ce4de947442b2ab1$var$Reference.isRef(value) && value.isSibling) addNode(value.path, key);
        else if ($ce4de947442b2ab1$export$213e2a3e7c4f326e(value) && 'deps' in value) value.deps.forEach((path)=>addNode(path, key));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($e1f9876d5f29f67a$exports))).array(Array.from(nodes), edges).reverse();
}
function $ce4de947442b2ab1$var$findIndex(arr, err) {
    let idx = Infinity;
    arr.some((key, ii)=>{
        var _err$path;
        if ((_err$path = err.path) != null && _err$path.includes(key)) {
            idx = ii;
            return true;
        }
    });
    return idx;
}
function $ce4de947442b2ab1$var$sortByKeyOrder(keys) {
    return (a, b)=>{
        return $ce4de947442b2ab1$var$findIndex(keys, a) - $ce4de947442b2ab1$var$findIndex(keys, b);
    };
}
const $ce4de947442b2ab1$var$parseJson = (value, _, schema)=>{
    if (typeof value !== 'string') return value;
    let parsed = value;
    try {
        parsed = JSON.parse(value);
    } catch (err) {
    /* */ }
    return schema.isType(parsed) ? parsed : value;
};
// @ts-ignore
function $ce4de947442b2ab1$var$deepPartial(schema) {
    if ('fields' in schema) {
        const partial = {};
        for (const [key, fieldSchema] of Object.entries(schema.fields))partial[key] = $ce4de947442b2ab1$var$deepPartial(fieldSchema);
        return schema.setFields(partial);
    }
    if (schema.type === 'array') {
        const nextArray = schema.optional();
        if (nextArray.innerType) nextArray.innerType = $ce4de947442b2ab1$var$deepPartial(nextArray.innerType);
        return nextArray;
    }
    if (schema.type === 'tuple') return schema.optional().clone({
        types: schema.spec.types.map($ce4de947442b2ab1$var$deepPartial)
    });
    if ('optional' in schema) return schema.optional();
    return schema;
}
const $ce4de947442b2ab1$var$deepHas = (obj, p)=>{
    const path = [
        ...(0, $5bc14c0fe9940240$exports.normalizePath)(p)
    ];
    if (path.length === 1) return path[0] in obj;
    let last = path.pop();
    let parent = (0, $5bc14c0fe9940240$exports.getter)((0, $5bc14c0fe9940240$exports.join)(path), true)(obj);
    return !!(parent && last in parent);
};
let $ce4de947442b2ab1$var$isObject = (obj)=>Object.prototype.toString.call(obj) === '[object Object]';
function $ce4de947442b2ab1$var$unknown(ctx, value) {
    let known = Object.keys(ctx.fields);
    return Object.keys(value).filter((key)=>known.indexOf(key) === -1);
}
const $ce4de947442b2ab1$var$defaultSort = $ce4de947442b2ab1$var$sortByKeyOrder([]);
function $ce4de947442b2ab1$export$be5493f9613cbbe(spec) {
    return new $ce4de947442b2ab1$export$18b4fc70ec7eccf8(spec);
}
class $ce4de947442b2ab1$export$18b4fc70ec7eccf8 extends $ce4de947442b2ab1$export$19342e026b58ebb7 {
    constructor(spec){
        super({
            type: 'object',
            check (value) {
                return $ce4de947442b2ab1$var$isObject(value) || typeof value === 'function';
            }
        });
        this.fields = Object.create(null);
        this._sortErrors = $ce4de947442b2ab1$var$defaultSort;
        this._nodes = [];
        this._excludedEdges = [];
        this.withMutation(()=>{
            if (spec) this.shape(spec);
        });
    }
    _cast(_value, options = {}) {
        var _options$stripUnknown;
        let value = super._cast(_value, options);
        //should ignore nulls here
        if (value === undefined) return this.getDefault(options);
        if (!this._typeCheck(value)) return value;
        let fields = this.fields;
        let strip = (_options$stripUnknown = options.stripUnknown) != null ? _options$stripUnknown : this.spec.noUnknown;
        let props = [].concat(this._nodes, Object.keys(value).filter((v)=>!this._nodes.includes(v)));
        let intermediateValue = {}; // is filled during the transform below
        let innerOptions = Object.assign({}, options, {
            parent: intermediateValue,
            __validating: options.__validating || false
        });
        let isChanged = false;
        for (const prop of props){
            let field = fields[prop];
            let exists = prop in value;
            let inputValue = value[prop];
            if (field) {
                let fieldValue;
                // safe to mutate since this is fired in sequence
                innerOptions.path = (options.path ? `${options.path}.` : '') + prop;
                field = field.resolve({
                    value: inputValue,
                    context: options.context,
                    parent: intermediateValue
                });
                let fieldSpec = field instanceof $ce4de947442b2ab1$export$19342e026b58ebb7 ? field.spec : undefined;
                let strict = fieldSpec == null ? void 0 : fieldSpec.strict;
                if (fieldSpec != null && fieldSpec.strip) {
                    isChanged = isChanged || prop in value;
                    continue;
                }
                fieldValue = !options.__validating || !strict ? field.cast(inputValue, innerOptions) : inputValue;
                if (fieldValue !== undefined) intermediateValue[prop] = fieldValue;
            } else if (exists && !strip) intermediateValue[prop] = inputValue;
            if (exists !== prop in intermediateValue || intermediateValue[prop] !== inputValue) isChanged = true;
        }
        return isChanged ? intermediateValue : value;
    }
    _validate(_value, options = {}, panic, next) {
        let { from: from = [], originalValue: originalValue = _value, recursive: recursive = this.spec.recursive } = options;
        options.from = [
            {
                schema: this,
                value: originalValue
            },
            ...from
        ];
        // this flag is needed for handling `strict` correctly in the context of
        // validation vs just casting. e.g strict() on a field is only used when validating
        options.__validating = true;
        options.originalValue = originalValue;
        super._validate(_value, options, panic, (objectErrors, value)=>{
            if (!recursive || !$ce4de947442b2ab1$var$isObject(value)) {
                next(objectErrors, value);
                return;
            }
            originalValue = originalValue || value;
            let tests = [];
            for (let key of this._nodes){
                let field = this.fields[key];
                if (!field || $ce4de947442b2ab1$var$Reference.isRef(field)) continue;
                tests.push(field.asNestedTest({
                    options: options,
                    key: key,
                    parent: value,
                    parentPath: options.path,
                    originalParent: originalValue
                }));
            }
            this.runTests({
                tests: tests,
                value: value,
                originalValue: originalValue,
                options: options
            }, panic, (fieldErrors)=>{
                next(fieldErrors.sort(this._sortErrors).concat(objectErrors), value);
            });
        });
    }
    clone(spec) {
        const next = super.clone(spec);
        next.fields = Object.assign({}, this.fields);
        next._nodes = this._nodes;
        next._excludedEdges = this._excludedEdges;
        next._sortErrors = this._sortErrors;
        return next;
    }
    concat(schema) {
        let next = super.concat(schema);
        let nextFields = next.fields;
        for (let [field, schemaOrRef] of Object.entries(this.fields)){
            const target = nextFields[field];
            nextFields[field] = target === undefined ? schemaOrRef : target;
        }
        return next.withMutation((s)=>// XXX: excludes here is wrong
            s.setFields(nextFields, [
                ...this._excludedEdges,
                ...schema._excludedEdges
            ]));
    }
    _getDefault(options) {
        if ('default' in this.spec) return super._getDefault(options);
        // if there is no default set invent one
        if (!this._nodes.length) return undefined;
        let dft = {};
        this._nodes.forEach((key)=>{
            var _innerOptions;
            const field = this.fields[key];
            let innerOptions = options;
            if ((_innerOptions = innerOptions) != null && _innerOptions.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[key]
            });
            dft[key] = field && 'getDefault' in field ? field.getDefault(innerOptions) : undefined;
        });
        return dft;
    }
    setFields(shape, excludedEdges) {
        let next = this.clone();
        next.fields = shape;
        next._nodes = $ce4de947442b2ab1$var$sortFields(shape, excludedEdges);
        next._sortErrors = $ce4de947442b2ab1$var$sortByKeyOrder(Object.keys(shape));
        // XXX: this carries over edges which may not be what you want
        if (excludedEdges) next._excludedEdges = excludedEdges;
        return next;
    }
    shape(additions, excludes = []) {
        return this.clone().withMutation((next)=>{
            let edges = next._excludedEdges;
            if (excludes.length) {
                if (!Array.isArray(excludes[0])) excludes = [
                    excludes
                ];
                edges = [
                    ...next._excludedEdges,
                    ...excludes
                ];
            }
            // XXX: excludes here is wrong
            return next.setFields(Object.assign(next.fields, additions), edges);
        });
    }
    partial() {
        const partial = {};
        for (const [key, schema] of Object.entries(this.fields))partial[key] = 'optional' in schema && schema.optional instanceof Function ? schema.optional() : schema;
        return this.setFields(partial);
    }
    deepPartial() {
        const next = $ce4de947442b2ab1$var$deepPartial(this);
        return next;
    }
    pick(keys) {
        const picked = {};
        for (const key of keys)if (this.fields[key]) picked[key] = this.fields[key];
        return this.setFields(picked, this._excludedEdges.filter(([a, b])=>keys.includes(a) && keys.includes(b)));
    }
    omit(keys) {
        const remaining = [];
        for (const key of Object.keys(this.fields)){
            if (keys.includes(key)) continue;
            remaining.push(key);
        }
        return this.pick(remaining);
    }
    from(from, to, alias) {
        let fromGetter = (0, $5bc14c0fe9940240$exports.getter)(from, true);
        return this.transform((obj)=>{
            if (!obj) return obj;
            let newObj = obj;
            if ($ce4de947442b2ab1$var$deepHas(obj, from)) {
                newObj = Object.assign({}, obj);
                if (!alias) delete newObj[from];
                newObj[to] = fromGetter(obj);
            }
            return newObj;
        });
    }
    /** Parse an input JSON string to an object */ json() {
        return this.transform($ce4de947442b2ab1$var$parseJson);
    }
    /**
   * Similar to `noUnknown` but only validates that an object is the right shape without stripping the unknown keys
   */ exact(message) {
        return this.test({
            name: 'exact',
            exclusive: true,
            message: message || $ce4de947442b2ab1$var$object.exact,
            test (value) {
                if (value == null) return true;
                const unknownKeys = $ce4de947442b2ab1$var$unknown(this.schema, value);
                return unknownKeys.length === 0 || this.createError({
                    params: {
                        properties: unknownKeys.join(', ')
                    }
                });
            }
        });
    }
    stripUnknown() {
        return this.clone({
            noUnknown: true
        });
    }
    noUnknown(noAllow = true, message = $ce4de947442b2ab1$var$object.noUnknown) {
        if (typeof noAllow !== 'boolean') {
            message = noAllow;
            noAllow = true;
        }
        let next = this.test({
            name: 'noUnknown',
            exclusive: true,
            message: message,
            test (value) {
                if (value == null) return true;
                const unknownKeys = $ce4de947442b2ab1$var$unknown(this.schema, value);
                return !noAllow || unknownKeys.length === 0 || this.createError({
                    params: {
                        unknown: unknownKeys.join(', ')
                    }
                });
            }
        });
        next.spec.noUnknown = noAllow;
        return next;
    }
    unknown(allow = true, message = $ce4de947442b2ab1$var$object.noUnknown) {
        return this.noUnknown(!allow, message);
    }
    transformKeys(fn) {
        return this.transform((obj)=>{
            if (!obj) return obj;
            const result = {};
            for (const key of Object.keys(obj))result[fn(key)] = obj[key];
            return result;
        });
    }
    camelCase() {
        return this.transformKeys((0, $d756e36230d17d6d$exports.camelCase));
    }
    snakeCase() {
        return this.transformKeys((0, $d756e36230d17d6d$exports.snakeCase));
    }
    constantCase() {
        return this.transformKeys((key)=>(0, $d756e36230d17d6d$exports.snakeCase)(key).toUpperCase());
    }
    describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const base = super.describe(options);
        base.fields = {};
        for (const [key, value] of Object.entries(next.fields)){
            var _innerOptions2;
            let innerOptions = options;
            if ((_innerOptions2 = innerOptions) != null && _innerOptions2.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[key]
            });
            base.fields[key] = value.describe(innerOptions);
        }
        return base;
    }
}
$ce4de947442b2ab1$export$be5493f9613cbbe.prototype = $ce4de947442b2ab1$export$18b4fc70ec7eccf8.prototype;
function $ce4de947442b2ab1$export$2f23118c22fb2630(type) {
    return new $ce4de947442b2ab1$export$4347112b8447a7d(type);
}
class $ce4de947442b2ab1$export$4347112b8447a7d extends $ce4de947442b2ab1$export$19342e026b58ebb7 {
    constructor(type){
        super({
            type: 'array',
            spec: {
                types: type
            },
            check (v) {
                return Array.isArray(v);
            }
        });
        // `undefined` specifically means uninitialized, as opposed to "no subtype"
        this.innerType = void 0;
        this.innerType = type;
    }
    _cast(_value, _opts) {
        const value = super._cast(_value, _opts);
        // should ignore nulls here
        if (!this._typeCheck(value) || !this.innerType) return value;
        let isChanged = false;
        const castArray = value.map((v, idx)=>{
            const castElement = this.innerType.cast(v, Object.assign({}, _opts, {
                path: `${_opts.path || ''}[${idx}]`,
                parent: value,
                originalValue: v,
                value: v,
                index: idx
            }));
            if (castElement !== v) isChanged = true;
            return castElement;
        });
        return isChanged ? castArray : value;
    }
    _validate(_value, options = {}, panic, next) {
        var _options$recursive;
        // let sync = options.sync;
        // let path = options.path;
        let innerType = this.innerType;
        // let endEarly = options.abortEarly ?? this.spec.abortEarly;
        let recursive = (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive;
        options.originalValue != null ? options.originalValue : _value;
        super._validate(_value, options, panic, (arrayErrors, value)=>{
            var _options$originalValu2;
            if (!recursive || !innerType || !this._typeCheck(value)) {
                next(arrayErrors, value);
                return;
            }
            // #950 Ensure that sparse array empty slots are validated
            let tests = new Array(value.length);
            for(let index = 0; index < value.length; index++){
                var _options$originalValu;
                tests[index] = innerType.asNestedTest({
                    options: options,
                    index: index,
                    parent: value,
                    parentPath: options.path,
                    originalParent: (_options$originalValu = options.originalValue) != null ? _options$originalValu : _value
                });
            }
            this.runTests({
                value: value,
                tests: tests,
                originalValue: (_options$originalValu2 = options.originalValue) != null ? _options$originalValu2 : _value,
                options: options
            }, panic, (innerTypeErrors)=>next(innerTypeErrors.concat(arrayErrors), value));
        });
    }
    clone(spec) {
        const next = super.clone(spec);
        // @ts-expect-error readonly
        next.innerType = this.innerType;
        return next;
    }
    /** Parse an input JSON string to an object */ json() {
        return this.transform($ce4de947442b2ab1$var$parseJson);
    }
    concat(schema) {
        let next = super.concat(schema);
        // @ts-expect-error readonly
        next.innerType = this.innerType;
        if (schema.innerType) // @ts-expect-error readonly
        next.innerType = next.innerType ? // @ts-expect-error Lazy doesn't have concat and will break
        next.innerType.concat(schema.innerType) : schema.innerType;
        return next;
    }
    of(schema) {
        // FIXME: this should return a new instance of array without the default to be
        let next = this.clone();
        if (!$ce4de947442b2ab1$export$213e2a3e7c4f326e(schema)) throw new TypeError('`array.of()` sub-schema must be a valid yup schema not: ' + $ce4de947442b2ab1$export$5790025c6e6c2ba6(schema));
        // @ts-expect-error readonly
        next.innerType = schema;
        next.spec = Object.assign({}, next.spec, {
            types: schema
        });
        return next;
    }
    length(length, message = $ce4de947442b2ab1$var$array.length) {
        return this.test({
            message: message,
            name: 'length',
            exclusive: true,
            params: {
                length: length
            },
            skipAbsent: true,
            test (value) {
                return value.length === this.resolve(length);
            }
        });
    }
    min(min, message) {
        message = message || $ce4de947442b2ab1$var$array.min;
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            // FIXME(ts): Array<typeof T>
            test (value) {
                return value.length >= this.resolve(min);
            }
        });
    }
    max(max, message) {
        message = message || $ce4de947442b2ab1$var$array.max;
        return this.test({
            message: message,
            name: 'max',
            exclusive: true,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value.length <= this.resolve(max);
            }
        });
    }
    ensure() {
        return this.default(()=>[]).transform((val, original)=>{
            // We don't want to return `null` for nullable schema
            if (this._typeCheck(val)) return val;
            return original == null ? [] : [].concat(original);
        });
    }
    compact(rejector) {
        let reject = !rejector ? (v)=>!!v : (v, i, a)=>!rejector(v, i, a);
        return this.transform((values)=>values != null ? values.filter(reject) : values);
    }
    describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const base = super.describe(options);
        if (next.innerType) {
            var _innerOptions;
            let innerOptions = options;
            if ((_innerOptions = innerOptions) != null && _innerOptions.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[0]
            });
            base.innerType = next.innerType.describe(innerOptions);
        }
        return base;
    }
}
$ce4de947442b2ab1$export$2f23118c22fb2630.prototype = $ce4de947442b2ab1$export$4347112b8447a7d.prototype;
// @ts-ignore
function $ce4de947442b2ab1$export$65e3907585753458(schemas) {
    return new $ce4de947442b2ab1$export$411c3b3687e8ecc8(schemas);
}
class $ce4de947442b2ab1$export$411c3b3687e8ecc8 extends $ce4de947442b2ab1$export$19342e026b58ebb7 {
    constructor(schemas){
        super({
            type: 'tuple',
            spec: {
                types: schemas
            },
            check (v) {
                const types = this.spec.types;
                return Array.isArray(v) && v.length === types.length;
            }
        });
        this.withMutation(()=>{
            this.typeError($ce4de947442b2ab1$var$tuple.notType);
        });
    }
    _cast(inputValue, options) {
        const { types: types } = this.spec;
        const value = super._cast(inputValue, options);
        if (!this._typeCheck(value)) return value;
        let isChanged = false;
        const castArray = types.map((type, idx)=>{
            const castElement = type.cast(value[idx], Object.assign({}, options, {
                path: `${options.path || ''}[${idx}]`,
                parent: value,
                originalValue: value[idx],
                value: value[idx],
                index: idx
            }));
            if (castElement !== value[idx]) isChanged = true;
            return castElement;
        });
        return isChanged ? castArray : value;
    }
    _validate(_value, options = {}, panic, next) {
        let itemTypes = this.spec.types;
        super._validate(_value, options, panic, (tupleErrors, value)=>{
            var _options$originalValu2;
            // intentionally not respecting recursive
            if (!this._typeCheck(value)) {
                next(tupleErrors, value);
                return;
            }
            let tests = [];
            for (let [index, itemSchema] of itemTypes.entries()){
                var _options$originalValu;
                tests[index] = itemSchema.asNestedTest({
                    options: options,
                    index: index,
                    parent: value,
                    parentPath: options.path,
                    originalParent: (_options$originalValu = options.originalValue) != null ? _options$originalValu : _value
                });
            }
            this.runTests({
                value: value,
                tests: tests,
                originalValue: (_options$originalValu2 = options.originalValue) != null ? _options$originalValu2 : _value,
                options: options
            }, panic, (innerTypeErrors)=>next(innerTypeErrors.concat(tupleErrors), value));
        });
    }
    describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const base = super.describe(options);
        base.innerType = next.spec.types.map((schema, index)=>{
            var _innerOptions;
            let innerOptions = options;
            if ((_innerOptions = innerOptions) != null && _innerOptions.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[index]
            });
            return schema.describe(innerOptions);
        });
        return base;
    }
}
$ce4de947442b2ab1$export$65e3907585753458.prototype = $ce4de947442b2ab1$export$411c3b3687e8ecc8.prototype;
function $ce4de947442b2ab1$export$488013bae63b21da(builder) {
    return new $ce4de947442b2ab1$export$71117d144d3091c9(builder);
}
function $ce4de947442b2ab1$var$catchValidationError(fn) {
    try {
        return fn();
    } catch (err) {
        if ($ce4de947442b2ab1$export$2191b9da168c6cf0.isError(err)) return Promise.reject(err);
        throw err;
    }
}
class $ce4de947442b2ab1$export$71117d144d3091c9 {
    constructor(builder){
        this.type = 'lazy';
        this.__isYupSchema__ = true;
        this.spec = void 0;
        this._resolve = (value, options = {})=>{
            let schema = this.builder(value, options);
            if (!$ce4de947442b2ab1$export$213e2a3e7c4f326e(schema)) throw new TypeError('lazy() functions must return a valid schema');
            if (this.spec.optional) schema = schema.optional();
            return schema.resolve(options);
        };
        this.builder = builder;
        this.spec = {
            meta: undefined,
            optional: false
        };
    }
    clone(spec) {
        const next = new $ce4de947442b2ab1$export$71117d144d3091c9(this.builder);
        next.spec = Object.assign({}, this.spec, spec);
        return next;
    }
    optionality(optional) {
        const next = this.clone({
            optional: optional
        });
        return next;
    }
    optional() {
        return this.optionality(true);
    }
    resolve(options) {
        return this._resolve(options.value, options);
    }
    cast(value, options) {
        return this._resolve(value, options).cast(value, options);
    }
    asNestedTest(config) {
        let { key: key, index: index, parent: parent, options: options } = config;
        let value = parent[index != null ? index : key];
        return this._resolve(value, Object.assign({}, options, {
            value: value,
            parent: parent
        })).asNestedTest(config);
    }
    validate(value, options) {
        return $ce4de947442b2ab1$var$catchValidationError(()=>this._resolve(value, options).validate(value, options));
    }
    validateSync(value, options) {
        return this._resolve(value, options).validateSync(value, options);
    }
    validateAt(path, value, options) {
        return $ce4de947442b2ab1$var$catchValidationError(()=>this._resolve(value, options).validateAt(path, value, options));
    }
    validateSyncAt(path, value, options) {
        return this._resolve(value, options).validateSyncAt(path, value, options);
    }
    isValid(value, options) {
        try {
            return this._resolve(value, options).isValid(value, options);
        } catch (err) {
            if ($ce4de947442b2ab1$export$2191b9da168c6cf0.isError(err)) return Promise.resolve(false);
            throw err;
        }
    }
    isValidSync(value, options) {
        return this._resolve(value, options).isValidSync(value, options);
    }
    describe(options) {
        return options ? this.resolve(options).describe(options) : {
            type: 'lazy',
            meta: this.spec.meta,
            label: undefined
        };
    }
    meta(...args) {
        if (args.length === 0) return this.spec.meta;
        let next = this.clone();
        next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
        return next;
    }
    get ['~standard']() {
        const schema = this;
        const standard = {
            version: 1,
            vendor: 'yup',
            async validate (value) {
                try {
                    const result = await schema.validate(value, {
                        abortEarly: false
                    });
                    return {
                        value: result
                    };
                } catch (err) {
                    if ($ce4de947442b2ab1$export$2191b9da168c6cf0.isError(err)) return {
                        issues: $ce4de947442b2ab1$var$issuesFromValidationError(err)
                    };
                    throw err;
                }
            }
        };
        return standard;
    }
}
function $ce4de947442b2ab1$export$c8aadf3621e41efb(custom) {
    Object.keys(custom).forEach((type)=>{
        // @ts-ignore
        Object.keys(custom[type]).forEach((method)=>{
            // @ts-ignore
            $ce4de947442b2ab1$export$d7f512c98c859244[type][method] = custom[type][method];
        });
    });
}
function $ce4de947442b2ab1$export$20be359f745f973c(schemaType, name, fn) {
    if (!schemaType || !$ce4de947442b2ab1$export$213e2a3e7c4f326e(schemaType.prototype)) throw new TypeError('You must provide a yup schema constructor function');
    if (typeof name !== 'string') throw new TypeError('A Method name must be provided');
    if (typeof fn !== 'function') throw new TypeError('Method function must be provided');
    schemaType.prototype[name] = fn;
}







var $bkJfK = parcelRequire("bkJfK");



// Components


var $kc00y = parcelRequire("kc00y");



var $86e8801aa2e44725$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $86e8801aa2e44725$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used as references for various `Number` constants. */ var $86e8801aa2e44725$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $86e8801aa2e44725$var$symbolTag = '[object Symbol]';
/** Used to match leading and trailing whitespace. */ var $86e8801aa2e44725$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $86e8801aa2e44725$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $86e8801aa2e44725$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $86e8801aa2e44725$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $86e8801aa2e44725$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $86e8801aa2e44725$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $86e8801aa2e44725$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $86e8801aa2e44725$var$root = $86e8801aa2e44725$var$freeGlobal || $86e8801aa2e44725$var$freeSelf || Function('return this')();
/** Used for built-in method references. */ var $86e8801aa2e44725$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $86e8801aa2e44725$var$objectToString = $86e8801aa2e44725$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $86e8801aa2e44725$var$nativeMax = Math.max, $86e8801aa2e44725$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $86e8801aa2e44725$var$now = function() {
    return $86e8801aa2e44725$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $86e8801aa2e44725$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($86e8801aa2e44725$var$FUNC_ERROR_TEXT);
    wait = $86e8801aa2e44725$var$toNumber(wait) || 0;
    if ($86e8801aa2e44725$var$isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $86e8801aa2e44725$var$nativeMax($86e8801aa2e44725$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $86e8801aa2e44725$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $86e8801aa2e44725$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($86e8801aa2e44725$var$now());
    }
    function debounced() {
        var time = $86e8801aa2e44725$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $86e8801aa2e44725$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $86e8801aa2e44725$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $86e8801aa2e44725$var$isSymbol(value) {
    return typeof value == 'symbol' || $86e8801aa2e44725$var$isObjectLike(value) && $86e8801aa2e44725$var$objectToString.call(value) == $86e8801aa2e44725$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $86e8801aa2e44725$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($86e8801aa2e44725$var$isSymbol(value)) return $86e8801aa2e44725$var$NAN;
    if ($86e8801aa2e44725$var$isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $86e8801aa2e44725$var$isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace($86e8801aa2e44725$var$reTrim, '');
    var isBinary = $86e8801aa2e44725$var$reIsBinary.test(value);
    return isBinary || $86e8801aa2e44725$var$reIsOctal.test(value) ? $86e8801aa2e44725$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $86e8801aa2e44725$var$reIsBadHex.test(value) ? $86e8801aa2e44725$var$NAN : +value;
}
$86e8801aa2e44725$exports = $86e8801aa2e44725$var$debounce;



var $lCkAA = parcelRequire("lCkAA");

var $kc00y = parcelRequire("kc00y");

var $kc00y = parcelRequire("kc00y");
function $dd42c91cf8c97a50$export$2e2bcd8739ae039() {
    // The toggling state value is designed to defeat React optimizations for skipping
    // updates when they are strictly equal to the last state value
    const [, dispatch] = (0, $kc00y.useReducer)((state)=>!state, false);
    return dispatch;
}



var $kc00y = parcelRequire("kc00y");
function $48cc33a11e6b1421$export$2e2bcd8739ae039(value) {
    const ref = (0, $kc00y.useRef)(null);
    (0, $kc00y.useEffect)(()=>{
        ref.current = value;
    });
    return ref.current;
}




var $lCkAA = parcelRequire("lCkAA");
var $da01923d9bfe8832$export$54df5a921294d7ab = [
    'justify',
    'left',
    'right'
];
var $da01923d9bfe8832$export$365087e449b345ed = 'label';
var $da01923d9bfe8832$export$57732b6846a8df7c = [
    'lg',
    'sm'
];




function $de8def7e701779cb$export$2e2bcd8739ae039(labelKey) {
    return typeof labelKey === 'string' ? labelKey : (0, $da01923d9bfe8832$export$365087e449b345ed);
}


/**
 * Check if an object has the given property in a type-safe way.
 */ function $3a3a9b23896102ee$export$2e2bcd8739ae039(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}


var $06626226287de840$var$idCounter = 0;
function $06626226287de840$export$f6e2535fb5126e54(value) {
    return typeof value === 'function';
}
function $06626226287de840$export$844ec244b1367d54(value) {
    return typeof value === 'string';
}
function $06626226287de840$export$8793edee2d425525() {}
function $06626226287de840$export$357523c63a2253b9(obj, keys) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var result = {};
    keys.forEach(function(key) {
        result[key] = obj[key];
    });
    return result;
}
function $06626226287de840$export$8b15d37bc3f197d4(prefix) {
    $06626226287de840$var$idCounter += 1;
    return (prefix == null ? '' : String(prefix)) + $06626226287de840$var$idCounter;
}


/**
 * Retrieves the display string from an option. Options can be the string
 * themselves, or an object with a defined display string. Anything else throws
 * an error.
 */ function $d7e9821c80905e56$var$getOptionLabel(option, labelKey) {
    // Handle internally created options first.
    if (!(0, $06626226287de840$export$844ec244b1367d54)(option) && ((0, $3a3a9b23896102ee$export$2e2bcd8739ae039)(option, 'paginationOption') || (0, $3a3a9b23896102ee$export$2e2bcd8739ae039)(option, 'customOption'))) return option[(0, $de8def7e701779cb$export$2e2bcd8739ae039)(labelKey)];
    var optionLabel;
    if ((0, $06626226287de840$export$f6e2535fb5126e54)(labelKey)) optionLabel = labelKey(option);
    else if ((0, $06626226287de840$export$844ec244b1367d54)(option)) optionLabel = option;
    else // `option` is an object and `labelKey` is a string.
    optionLabel = option[labelKey];
    !(0, $06626226287de840$export$844ec244b1367d54)(optionLabel) && (0, (/*@__PURE__*/$parcel$interopDefault($dd7e63b9f56b8b40$exports)))(false);
    return optionLabel;
}
var $d7e9821c80905e56$export$2e2bcd8739ae039 = $d7e9821c80905e56$var$getOptionLabel;



function $26df127f0c91cd7c$var$addCustomOption(results, props) {
    var allowNew = props.allowNew, labelKey = props.labelKey, text = props.text;
    if (!allowNew || !text.trim()) return false;
    // If the consumer has provided a callback, use that to determine whether or
    // not to add the custom option.
    if ((0, $06626226287de840$export$f6e2535fb5126e54)(allowNew)) return allowNew(results, props);
    // By default, don't add the custom option if there is an exact text match
    // with an existing option.
    return !results.some(function(o) {
        return (0, $d7e9821c80905e56$export$2e2bcd8739ae039)(o, labelKey) === text;
    });
}
var $26df127f0c91cd7c$export$2e2bcd8739ae039 = $26df127f0c91cd7c$var$addCustomOption;


var $7b40b513af0ed011$exports = {};
'use strict';
// do not edit .js files directly - edit src/index.jst
$7b40b513af0ed011$exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};



function $cc5834112252bc97$export$2e2bcd8739ae039(option, key) {
    if ((0, $06626226287de840$export$844ec244b1367d54)(option)) return undefined;
    return option[key];
}



// prettier-ignore
var $01b5fe436920cc50$var$map = [
    {
        base: 'A',
        letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: 'AA',
        letters: "\uA732"
    },
    {
        base: 'AE',
        letters: "\xC6\u01FC\u01E2"
    },
    {
        base: 'AO',
        letters: "\uA734"
    },
    {
        base: 'AU',
        letters: "\uA736"
    },
    {
        base: 'AV',
        letters: "\uA738\uA73A"
    },
    {
        base: 'AY',
        letters: "\uA73C"
    },
    {
        base: 'B',
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: 'C',
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: 'D',
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779\xD0"
    },
    {
        base: 'DZ',
        letters: "\u01F1\u01C4"
    },
    {
        base: 'Dz',
        letters: "\u01F2\u01C5"
    },
    {
        base: 'E',
        letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: 'F',
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: 'G',
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: 'H',
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: 'I',
        letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: 'J',
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: 'K',
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: 'L',
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: 'LJ',
        letters: "\u01C7"
    },
    {
        base: 'Lj',
        letters: "\u01C8"
    },
    {
        base: 'M',
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: 'N',
        letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: 'NJ',
        letters: "\u01CA"
    },
    {
        base: 'Nj',
        letters: "\u01CB"
    },
    {
        base: 'O',
        letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: 'OI',
        letters: "\u01A2"
    },
    {
        base: 'OO',
        letters: "\uA74E"
    },
    {
        base: 'OU',
        letters: "\u0222"
    },
    {
        base: 'OE',
        letters: "\x8C\u0152"
    },
    {
        base: 'oe',
        letters: "\x9C\u0153"
    },
    {
        base: 'P',
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: 'Q',
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: 'R',
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: 'S',
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: 'T',
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: 'TZ',
        letters: "\uA728"
    },
    {
        base: 'U',
        letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: 'V',
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: 'VY',
        letters: "\uA760"
    },
    {
        base: 'W',
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: 'X',
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: 'Y',
        letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: 'Z',
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: 'a',
        letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: 'aa',
        letters: "\uA733"
    },
    {
        base: 'ae',
        letters: "\xE6\u01FD\u01E3"
    },
    {
        base: 'ao',
        letters: "\uA735"
    },
    {
        base: 'au',
        letters: "\uA737"
    },
    {
        base: 'av',
        letters: "\uA739\uA73B"
    },
    {
        base: 'ay',
        letters: "\uA73D"
    },
    {
        base: 'b',
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: 'c',
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: 'd',
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: 'dz',
        letters: "\u01F3\u01C6"
    },
    {
        base: 'e',
        letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: 'f',
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: 'g',
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: 'h',
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: 'hv',
        letters: "\u0195"
    },
    {
        base: 'i',
        letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: 'j',
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: 'k',
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: 'l',
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: 'lj',
        letters: "\u01C9"
    },
    {
        base: 'm',
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: 'n',
        letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: 'nj',
        letters: "\u01CC"
    },
    {
        base: 'o',
        letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: 'oi',
        letters: "\u01A3"
    },
    {
        base: 'ou',
        letters: "\u0223"
    },
    {
        base: 'oo',
        letters: "\uA74F"
    },
    {
        base: 'p',
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: 'q',
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: 'r',
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: 's',
        letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: 't',
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: 'tz',
        letters: "\uA729"
    },
    {
        base: 'u',
        letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: 'v',
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: 'vy',
        letters: "\uA761"
    },
    {
        base: 'w',
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: 'x',
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: 'y',
        letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: 'z',
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
].reduce(function(acc, _ref) {
    var base = _ref.base, letters = _ref.letters;
    letters.split('').forEach(function(letter) {
        acc[letter] = base;
    });
    return acc;
}, {});
// Combining marks
var $01b5fe436920cc50$var$latin = "\u0300-\u036F";
var $01b5fe436920cc50$var$japanese = "\u3099\u309A";
function $01b5fe436920cc50$export$2e2bcd8739ae039(str) {
    return str.normalize('NFD')// Remove combining diacritics
    .replace(new RegExp("[".concat($01b5fe436920cc50$var$latin).concat($01b5fe436920cc50$var$japanese, "]"), 'g'), '')/* eslint-disable-next-line no-control-regex */ .replace(/[^\u0000-\u007E]/g, function(a) {
        return $01b5fe436920cc50$var$map[a] || a;
    });
}



var $5ff45b7b5c008bba$var$warned = {};
function $5ff45b7b5c008bba$export$2e2bcd8739ae039(falseToWarn, message) {
    // Only issue deprecation warnings once.
    if (!falseToWarn && message.indexOf('deprecated') !== -1) {
        if ($5ff45b7b5c008bba$var$warned[message]) return;
        $5ff45b7b5c008bba$var$warned[message] = true;
    }
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    (0, (/*@__PURE__*/$parcel$interopDefault($61fad0cb6b7e8586$exports))).apply(void 0, [
        falseToWarn,
        "[react-bootstrap-typeahead] ".concat(message)
    ].concat(args));
}
function $5ff45b7b5c008bba$export$60eef1277fe463e4() {
    $5ff45b7b5c008bba$var$warned = {};
}


function $0243c3e624f10d7b$var$isMatch(input, string, props) {
    var searchStr = input;
    var str = string;
    if (!props.caseSensitive) {
        searchStr = searchStr.toLowerCase();
        str = str.toLowerCase();
    }
    if (props.ignoreDiacritics) {
        searchStr = (0, $01b5fe436920cc50$export$2e2bcd8739ae039)(searchStr);
        str = (0, $01b5fe436920cc50$export$2e2bcd8739ae039)(str);
    }
    return str.indexOf(searchStr) !== -1;
}
function $0243c3e624f10d7b$export$2e2bcd8739ae039(option, props) {
    var filterBy = props.filterBy, labelKey = props.labelKey, multiple = props.multiple, selected = props.selected, text = props.text;
    // Don't show selected options in the menu for the multi-select case.
    if (multiple && selected.some(function(o) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($7b40b513af0ed011$exports)))(o, option);
    })) return false;
    if ((0, $06626226287de840$export$f6e2535fb5126e54)(labelKey)) return $0243c3e624f10d7b$var$isMatch(text, labelKey(option), props);
    var fields = filterBy.slice();
    if ((0, $06626226287de840$export$844ec244b1367d54)(labelKey)) // Add the `labelKey` field to the list of fields if it isn't already there.
    {
        if (fields.indexOf(labelKey) === -1) fields.unshift(labelKey);
    }
    if ((0, $06626226287de840$export$844ec244b1367d54)(option)) {
        (0, $5ff45b7b5c008bba$export$2e2bcd8739ae039)(fields.length <= 1, 'You cannot filter by properties when `option` is a string.');
        return $0243c3e624f10d7b$var$isMatch(text, option, props);
    }
    return fields.some(function(field) {
        var value = (0, $cc5834112252bc97$export$2e2bcd8739ae039)(option, field);
        if (!(0, $06626226287de840$export$844ec244b1367d54)(value)) {
            (0, $5ff45b7b5c008bba$export$2e2bcd8739ae039)(false, "Fields passed to `filterBy` should have string values. Value will be converted to a string; results may be unexpected.");
            value = String(value);
        }
        return $0243c3e624f10d7b$var$isMatch(text, value, props);
    });
}


/**
 * Check if an input type is selectable, based on WHATWG spec.
 *
 * See:
 *  - https://stackoverflow.com/questions/21177489/selectionstart-selectionend-on-input-type-number-no-longer-allowed-in-chrome/24175357
 *  - https://html.spec.whatwg.org/multipage/input.html#do-not-apply
 */ function $851efee6990588f8$export$2e2bcd8739ae039(inputNode) {
    return inputNode.selectionStart != null;
}


function $ee80c3087717cf88$export$2e2bcd8739ae039(e, selectHint) {
    var shouldSelectHint = false;
    if (e.key === 'ArrowRight') // For selectable input types ("text", "search"), only select the hint if
    // it's at the end of the input value. For non-selectable types ("email",
    // "number"), always select the hint.
    shouldSelectHint = (0, $851efee6990588f8$export$2e2bcd8739ae039)(e.currentTarget) ? e.currentTarget.selectionStart === e.currentTarget.value.length : true;
    if (e.key === 'Tab') {
        // Prevent input from blurring on TAB.
        e.preventDefault();
        shouldSelectHint = true;
    }
    return selectHint ? selectHint(shouldSelectHint, e) : shouldSelectHint;
}


// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $5e4757182651cd07$export$2e2bcd8739ae039(Component) {
    return Component.displayName || Component.name || 'Component';
}




var $bdafdf0fadefc619$var$CASE_INSENSITIVE = 'i';
var $bdafdf0fadefc619$var$COMBINING_MARKS = /[\u0300-\u036F]/;
function $bdafdf0fadefc619$export$691f87e685a5fa78(str) {
    !(typeof str === 'string') && (0, (/*@__PURE__*/$parcel$interopDefault($dd7e63b9f56b8b40$exports)))(false);
    // Escape characters with special meaning either inside or outside character
    // sets. Use a simple backslash escape when it’s always valid, and a \unnnn
    // escape when the simpler form would be disallowed by Unicode patterns’
    // stricter grammar.
    return str.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
}
function $bdafdf0fadefc619$export$2e2bcd8739ae039(subject, str) {
    var search = new RegExp($bdafdf0fadefc619$export$691f87e685a5fa78((0, $01b5fe436920cc50$export$2e2bcd8739ae039)(str)), $bdafdf0fadefc619$var$CASE_INSENSITIVE);
    var matches = search.exec((0, $01b5fe436920cc50$export$2e2bcd8739ae039)(subject));
    if (!matches) return null;
    var start = matches.index;
    var matchLength = matches[0].length;
    // Account for combining marks, which changes the indices.
    if ($bdafdf0fadefc619$var$COMBINING_MARKS.test(subject)) {
        // Starting at the beginning of the subject string, check for the number of
        // combining marks and increment the start index whenever one is found.
        for(var ii = 0; ii <= start; ii++)if ($bdafdf0fadefc619$var$COMBINING_MARKS.test(subject[ii])) start += 1;
        // Similarly, increment the length of the match string if it contains a
        // combining mark.
        for(var _ii = start; _ii <= start + matchLength; _ii++)if ($bdafdf0fadefc619$var$COMBINING_MARKS.test(subject[_ii])) matchLength += 1;
    }
    return {
        end: start + matchLength,
        start: start
    };
}





function $8416ce077ebdd44c$var$getHintText(_ref) {
    var activeIndex = _ref.activeIndex, initialItem = _ref.initialItem, isFocused = _ref.isFocused, isMenuShown = _ref.isMenuShown, labelKey = _ref.labelKey, multiple = _ref.multiple, selected = _ref.selected, text = _ref.text;
    // Don't display a hint under the following conditions:
    if (// No text entered.
    !text || // The input is not focused.
    !isFocused || // The menu is hidden.
    !isMenuShown || // No item in the menu.
    !initialItem || // The initial item is a custom option.
    !(0, $06626226287de840$export$844ec244b1367d54)(initialItem) && (0, $3a3a9b23896102ee$export$2e2bcd8739ae039)(initialItem, 'customOption') || // The initial item is disabled
    !(0, $06626226287de840$export$844ec244b1367d54)(initialItem) && initialItem.disabled || // One of the menu items is active.
    activeIndex > -1 || // There's already a selection in single-select mode.
    !!selected.length && !multiple) return '';
    var initialItemStr = (0, $d7e9821c80905e56$export$2e2bcd8739ae039)(initialItem, labelKey);
    var bounds = (0, $bdafdf0fadefc619$export$2e2bcd8739ae039)(initialItemStr.toLowerCase(), text.toLowerCase());
    if (!(bounds && bounds.start === 0)) return '';
    // Text matching is case- and accent-insensitive, so to display the hint
    // correctly, splice the input string with the hint string.
    return text + initialItemStr.slice(bounds.end, initialItemStr.length);
}
var $8416ce077ebdd44c$export$2e2bcd8739ae039 = $8416ce077ebdd44c$var$getHintText;





function $5c5eb1b23d7aeb46$export$2e2bcd8739ae039() {
    var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var position = arguments.length > 1 ? arguments[1] : undefined;
    return "".concat(id, "-item-").concat(position);
}



var $defb6d407200d166$var$_excluded = [
    "activeIndex",
    "id",
    "isFocused",
    "isMenuShown",
    "multiple",
    "onClick",
    "onFocus",
    "placeholder"
];
function $defb6d407200d166$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $defb6d407200d166$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $defb6d407200d166$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $d8f5e6158ecd1aab$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $defb6d407200d166$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $defb6d407200d166$var$getInputProps = function getInputProps(_ref) {
    var activeIndex = _ref.activeIndex, id = _ref.id, isFocused = _ref.isFocused, isMenuShown = _ref.isMenuShown, multiple = _ref.multiple, onClick = _ref.onClick, onFocus = _ref.onFocus, placeholder = _ref.placeholder, props = (0, $fefdef73d5b2b1c6$export$2e2bcd8739ae039)(_ref, $defb6d407200d166$var$_excluded);
    return function() {
        var _cx;
        var inputProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var className = (0, $3a3a9b23896102ee$export$2e2bcd8739ae039)(inputProps, 'className') ? String(inputProps.className) : undefined;
        return $defb6d407200d166$var$_objectSpread($defb6d407200d166$var$_objectSpread($defb6d407200d166$var$_objectSpread($defb6d407200d166$var$_objectSpread({
            // These props can be overridden by values in `inputProps`.
            autoComplete: 'off',
            placeholder: placeholder,
            type: 'text'
        }, inputProps), props), {}, {
            'aria-activedescendant': activeIndex >= 0 ? (0, $5c5eb1b23d7aeb46$export$2e2bcd8739ae039)(id, activeIndex) : undefined,
            'aria-autocomplete': 'both',
            'aria-expanded': isMenuShown,
            'aria-haspopup': 'listbox',
            'aria-multiselectable': multiple || undefined,
            'aria-owns': isMenuShown ? id : undefined,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))((_cx = {}, (0, $d8f5e6158ecd1aab$export$2e2bcd8739ae039)(_cx, className || '', !multiple), (0, $d8f5e6158ecd1aab$export$2e2bcd8739ae039)(_cx, "focus", isFocused), _cx))
        }, multiple && {
            inputClassName: className
        }), {}, {
            onClick: onClick,
            onFocus: onFocus,
            role: 'combobox'
        });
    };
};
var $defb6d407200d166$export$2e2bcd8739ae039 = $defb6d407200d166$var$getInputProps;



function $3c15e93888f0532e$var$getInputText(props) {
    var activeItem = props.activeItem, labelKey = props.labelKey, multiple = props.multiple, selected = props.selected, text = props.text;
    if (activeItem) // Display the input value if the pagination item is active.
    return (0, $d7e9821c80905e56$export$2e2bcd8739ae039)(activeItem, labelKey);
    if (!multiple && selected.length && selected[0]) return (0, $d7e9821c80905e56$export$2e2bcd8739ae039)(selected[0], labelKey);
    return text;
}
var $3c15e93888f0532e$export$2e2bcd8739ae039 = $3c15e93888f0532e$var$getInputText;



function $46573ce281764b64$var$getIsOnlyResult(props) {
    var allowNew = props.allowNew, highlightOnlyResult = props.highlightOnlyResult, results = props.results;
    if (!highlightOnlyResult || allowNew) return false;
    return results.length === 1 && !(0, $cc5834112252bc97$export$2e2bcd8739ae039)(results[0], 'disabled');
}
var $46573ce281764b64$export$2e2bcd8739ae039 = $46573ce281764b64$var$getIsOnlyResult;







/**
 * Truncates the result set based on `maxResults` and returns the new set.
 */ function $0744409029472d71$var$getTruncatedOptions(options, maxResults) {
    if (!maxResults || maxResults >= options.length) return options;
    return options.slice(0, maxResults);
}
var $0744409029472d71$export$2e2bcd8739ae039 = $0744409029472d71$var$getTruncatedOptions;



function $0111ffb532477f60$export$30acd1b3e7561a3(index, items) {
    var option = items[index];
    return !!option && !!(0, $cc5834112252bc97$export$2e2bcd8739ae039)(option, 'disabled');
}
function $0111ffb532477f60$export$3b2e82793fda938f(currentIndex, key, items) {
    var newIndex = currentIndex;
    while($0111ffb532477f60$export$30acd1b3e7561a3(newIndex, items))newIndex += key === 'ArrowUp' ? -1 : 1;
    return newIndex;
}
function $0111ffb532477f60$export$2e2bcd8739ae039(currentIndex, key, items) {
    var newIndex = currentIndex;
    // Increment or decrement index based on user keystroke.
    newIndex += key === 'ArrowUp' ? -1 : 1;
    // Skip over any disabled options.
    newIndex = $0111ffb532477f60$export$3b2e82793fda938f(newIndex, key, items);
    // If we've reached the end, go back to the beginning or vice-versa.
    if (newIndex === items.length) newIndex = -1;
    else if (newIndex === -2) {
        newIndex = items.length - 1;
        // Skip over any disabled options.
        newIndex = $0111ffb532477f60$export$3b2e82793fda938f(newIndex, key, items);
    }
    return newIndex;
}




function $d77fd8b1a9dad437$export$2e2bcd8739ae039(_ref) {
    var open = _ref.open, minLength = _ref.minLength, showMenu = _ref.showMenu, text = _ref.text;
    // If menu visibility is controlled via props, that value takes precedence.
    if (open || open === false) return open;
    if (text.length < minLength) return false;
    return showMenu;
}



/**
 * Prevent the main input from blurring when a menu item or the clear button is
 * clicked. (#226 & #310)
 */ function $be3b8f28c4a47481$export$2e2bcd8739ae039(e) {
    e.preventDefault();
}





function $49777a0839183c16$export$650961c52e438122(size) {
    return size === 'lg';
}
function $49777a0839183c16$export$93100e6f8d8c0365(size) {
    return size === 'sm';
}


var $12a6aa6de8ed10be$var$_excluded = [
    "className",
    "isInvalid",
    "isValid",
    "size"
];
function $12a6aa6de8ed10be$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $12a6aa6de8ed10be$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $12a6aa6de8ed10be$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $d8f5e6158ecd1aab$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $12a6aa6de8ed10be$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $12a6aa6de8ed10be$export$2e2bcd8739ae039(_ref) {
    var className = _ref.className, isInvalid = _ref.isInvalid, isValid = _ref.isValid, size = _ref.size, props = (0, $fefdef73d5b2b1c6$export$2e2bcd8739ae039)(_ref, $12a6aa6de8ed10be$var$_excluded);
    return $12a6aa6de8ed10be$var$_objectSpread($12a6aa6de8ed10be$var$_objectSpread({}, props), {}, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))('form-control', 'rbt-input', {
            'form-control-lg': (0, $49777a0839183c16$export$650961c52e438122)(size),
            'form-control-sm': (0, $49777a0839183c16$export$93100e6f8d8c0365)(size),
            'is-invalid': isInvalid,
            'is-valid': isValid
        }, className)
    });
}





function $12254a1747f5d042$export$2e2bcd8739ae039(prevSelected, selected) {
    var uncontrolledToControlled = !prevSelected && selected;
    var controlledToUncontrolled = prevSelected && !selected;
    var from, to, precedent;
    if (uncontrolledToControlled) {
        from = 'uncontrolled';
        to = 'controlled';
        precedent = 'an';
    } else {
        from = 'controlled';
        to = 'uncontrolled';
        precedent = 'a';
    }
    var message = "You are changing ".concat(precedent, " ").concat(from, " typeahead to be ").concat(to, ". ") + "Input elements should not switch from ".concat(from, " to ").concat(to, " (or vice versa). ") + 'Decide between using a controlled or uncontrolled element for the ' + 'lifetime of the component.';
    (0, $5ff45b7b5c008bba$export$2e2bcd8739ae039)(!(uncontrolledToControlled || controlledToUncontrolled), message);
}





var $5fc1e2ca177b79bd$var$INPUT_PROPS_BLACKLIST = [
    {
        alt: 'onBlur',
        prop: 'onBlur'
    },
    {
        alt: 'onInputChange',
        prop: 'onChange'
    },
    {
        alt: 'onFocus',
        prop: 'onFocus'
    },
    {
        alt: 'onKeyDown',
        prop: 'onKeyDown'
    }
];
var $5fc1e2ca177b79bd$export$9ae6167e9ee9e6d0 = (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).oneOf((0, $da01923d9bfe8832$export$57732b6846a8df7c));
function $5fc1e2ca177b79bd$export$1c8c72d28a0627d2(validator, callback) {
    return function(props, propName, componentName) {
        (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).checkPropTypes((0, $d8f5e6158ecd1aab$export$2e2bcd8739ae039)({}, propName, validator), props, 'prop', componentName);
        (0, $06626226287de840$export$f6e2535fb5126e54)(callback) && callback(props, propName, componentName);
    };
}
function $5fc1e2ca177b79bd$export$8a831d0ae116fbcd(props) {
    var caseSensitive = props.caseSensitive, filterBy = props.filterBy;
    (0, $5ff45b7b5c008bba$export$2e2bcd8739ae039)(!caseSensitive || typeof filterBy !== 'function', 'Your `filterBy` function will override the `caseSensitive` prop.');
}
function $5fc1e2ca177b79bd$export$cdd73fc4100a6ef4(validator, reason) {
    return function(props, propName, componentName) {
        if (props[propName] != null) (0, $5ff45b7b5c008bba$export$2e2bcd8739ae039)(false, "The `".concat(propName, "` prop is deprecated. ").concat(reason));
        return (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).checkPropTypes((0, $d8f5e6158ecd1aab$export$2e2bcd8739ae039)({}, propName, validator), props, 'prop', componentName);
    };
}
function $5fc1e2ca177b79bd$export$5534cbfe725ae92a(props) {
    var defaultInputValue = props.defaultInputValue, defaultSelected = props.defaultSelected, multiple = props.multiple, selected = props.selected;
    var name = defaultSelected.length ? 'defaultSelected' : 'selected';
    (0, $5ff45b7b5c008bba$export$2e2bcd8739ae039)(!(!multiple && defaultInputValue && (defaultSelected.length || selected && selected.length)), "`defaultInputValue` will be overridden by the value from `".concat(name, "`."));
}
function $5fc1e2ca177b79bd$export$79f4757fa6baab77(props) {
    var defaultSelected = props.defaultSelected, multiple = props.multiple;
    (0, $5ff45b7b5c008bba$export$2e2bcd8739ae039)(multiple || defaultSelected.length <= 1, "You are passing multiple options to the `defaultSelected` prop of a Typeahead in single-select mode. The selections will be truncated to a single selection.");
}
function $5fc1e2ca177b79bd$export$f8e54140ea7ea3a8(_ref) {
    var allowNew = _ref.allowNew, highlightOnlyResult = _ref.highlightOnlyResult;
    (0, $5ff45b7b5c008bba$export$2e2bcd8739ae039)(!(highlightOnlyResult && allowNew), '`highlightOnlyResult` will not work with `allowNew`.');
}
function $5fc1e2ca177b79bd$export$9b9aee2bc2e2973d(props) {
    var filterBy = props.filterBy, ignoreDiacritics = props.ignoreDiacritics;
    (0, $5ff45b7b5c008bba$export$2e2bcd8739ae039)(ignoreDiacritics || typeof filterBy !== 'function', 'Your `filterBy` function will override the `ignoreDiacritics` prop.');
}
function $5fc1e2ca177b79bd$export$82c0eddbd071e45f(_ref2) {
    var inputProps = _ref2.inputProps;
    if (!(inputProps && Object.prototype.toString.call(inputProps) === '[object Object]')) return;
    // Blacklisted properties.
    $5fc1e2ca177b79bd$var$INPUT_PROPS_BLACKLIST.forEach(function(_ref3) {
        var alt = _ref3.alt, prop = _ref3.prop;
        var msg = alt ? " Use the top-level `".concat(alt, "` prop instead.") : null;
        (0, $5ff45b7b5c008bba$export$2e2bcd8739ae039)(!inputProps[prop], "The `".concat(prop, "` property of `inputProps` will be ignored.").concat(msg));
    });
}
function $5fc1e2ca177b79bd$export$50bb8c440cf2a42c(props, propName, componentName) {
    (0, $5ff45b7b5c008bba$export$2e2bcd8739ae039)(props[propName] != null, "The prop `".concat(propName, "` is required to make `").concat(componentName, "` ") + 'accessible for users of assistive technologies such as screen readers.');
}
function $5fc1e2ca177b79bd$export$8ae4524d34467ed5(_ref4) {
    var allowNew = _ref4.allowNew, labelKey = _ref4.labelKey;
    (0, $5ff45b7b5c008bba$export$2e2bcd8739ae039)(!((0, $06626226287de840$export$f6e2535fb5126e54)(labelKey) && allowNew), '`labelKey` must be a string when `allowNew={true}`.');
}
var $5fc1e2ca177b79bd$export$7de5fae3688fa523 = (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).object,
    (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).string
]);
function $5fc1e2ca177b79bd$export$1f1343c4475956f4(_ref5) {
    var multiple = _ref5.multiple, onChange = _ref5.onChange, selected = _ref5.selected;
    (0, $5ff45b7b5c008bba$export$2e2bcd8739ae039)(multiple || !selected || selected.length <= 1, "You are passing multiple options to the `selected` prop of a Typeahead in single-select mode. This may lead to unexpected behaviors or errors.");
    (0, $5ff45b7b5c008bba$export$2e2bcd8739ae039)(!selected || selected && (0, $06626226287de840$export$f6e2535fb5126e54)(onChange), "You provided a `selected` prop without an `onChange` handler. If you want the typeahead to be uncontrolled, use `defaultSelected`. Otherwise, set `onChange`.");
}



var $c4b3689eca620d46$var$_excluded = [
    "allowNew",
    "delay",
    "emptyLabel",
    "isLoading",
    "minLength",
    "onInputChange",
    "onSearch",
    "options",
    "promptText",
    "searchText",
    "useCache"
];
function $c4b3689eca620d46$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c4b3689eca620d46$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c4b3689eca620d46$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $d8f5e6158ecd1aab$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c4b3689eca620d46$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $c4b3689eca620d46$var$propTypes = {
    /**
   * Delay, in milliseconds, before performing search.
   */ delay: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).number,
    /**
   * Whether or not a request is currently pending. Necessary for the
   * container to know when new results are available.
   */ isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).bool.isRequired,
    /**
   * Number of input characters that must be entered before showing results.
   */ minLength: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).number,
    /**
   * Callback to perform when the search is executed.
   */ onSearch: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).func.isRequired,
    /**
   * Options to be passed to the typeahead. Will typically be the query
   * results, but can also be initial default options.
   */ options: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).arrayOf((0, $5fc1e2ca177b79bd$export$7de5fae3688fa523)),
    /**
   * Message displayed in the menu when there is no user input.
   */ promptText: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).node,
    /**
   * Message displayed in the menu while the request is pending.
   */ searchText: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).node,
    /**
   * Whether or not the component should cache query results.
   */ useCache: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).bool
};
function $c4b3689eca620d46$export$cdf1dc76b55502e3(props) {
    var allowNew = props.allowNew, _props$delay = props.delay, delay = _props$delay === void 0 ? 200 : _props$delay, emptyLabel = props.emptyLabel, isLoading = props.isLoading, _props$minLength = props.minLength, minLength = _props$minLength === void 0 ? 2 : _props$minLength, onInputChange = props.onInputChange, onSearch = props.onSearch, _props$options = props.options, options = _props$options === void 0 ? [] : _props$options, _props$promptText = props.promptText, promptText = _props$promptText === void 0 ? 'Type to search...' : _props$promptText, _props$searchText = props.searchText, searchText = _props$searchText === void 0 ? 'Searching...' : _props$searchText, _props$useCache = props.useCache, useCache = _props$useCache === void 0 ? true : _props$useCache, otherProps = (0, $fefdef73d5b2b1c6$export$2e2bcd8739ae039)(props, $c4b3689eca620d46$var$_excluded);
    var cacheRef = (0, $kc00y.useRef)({});
    var handleSearchDebouncedRef = (0, $kc00y.useRef)(null);
    var queryRef = (0, $kc00y.useRef)(props.defaultInputValue || '');
    var forceUpdate = (0, $dd42c91cf8c97a50$export$2e2bcd8739ae039)();
    var prevProps = (0, $48cc33a11e6b1421$export$2e2bcd8739ae039)(props);
    var handleSearch = (0, $kc00y.useCallback)(function(query) {
        queryRef.current = query;
        if (!query || minLength && query.length < minLength) return;
        // Use cached results, if applicable.
        if (useCache && cacheRef.current[query]) {
            // Re-render the component with the cached results.
            forceUpdate();
            return;
        }
        // Perform the search.
        onSearch(query);
    }, [
        forceUpdate,
        minLength,
        onSearch,
        useCache
    ]);
    // Set the debounced search function.
    (0, $kc00y.useEffect)(function() {
        handleSearchDebouncedRef.current = (0, (/*@__PURE__*/$parcel$interopDefault($86e8801aa2e44725$exports)))(handleSearch, delay);
        return function() {
            handleSearchDebouncedRef.current && handleSearchDebouncedRef.current.cancel();
        };
    }, [
        delay,
        handleSearch
    ]);
    (0, $kc00y.useEffect)(function() {
        // Ensure that we've gone from a loading to a completed state. Otherwise
        // an empty response could get cached if the component updates during the
        // request (eg: if the parent re-renders for some reason).
        if (!isLoading && prevProps && prevProps.isLoading && useCache) cacheRef.current[queryRef.current] = options;
    });
    var getEmptyLabel = function getEmptyLabel() {
        if (!queryRef.current.length) return promptText;
        if (isLoading) return searchText;
        return emptyLabel;
    };
    var handleInputChange = (0, $kc00y.useCallback)(function(query, e) {
        onInputChange && onInputChange(query, e);
        handleSearchDebouncedRef.current && handleSearchDebouncedRef.current(query);
    }, [
        onInputChange
    ]);
    var cachedQuery = cacheRef.current[queryRef.current];
    return $c4b3689eca620d46$var$_objectSpread($c4b3689eca620d46$var$_objectSpread({}, otherProps), {}, {
        // Disable custom selections during a search if `allowNew` isn't a function.
        allowNew: (0, $06626226287de840$export$f6e2535fb5126e54)(allowNew) ? allowNew : allowNew && !isLoading,
        emptyLabel: getEmptyLabel(),
        isLoading: isLoading,
        minLength: minLength,
        onInputChange: handleInputChange,
        options: useCache && cachedQuery ? cachedQuery : options
    });
}
function $c4b3689eca620d46$export$3523553ee0bc32a8(Component) {
    (0, $5ff45b7b5c008bba$export$2e2bcd8739ae039)(false, "Warning: `withAsync` is deprecated and will be removed in the next major version. Use `useAsync` instead.");
    var AsyncTypeahead = /*#__PURE__*/ (0, $kc00y.forwardRef)(function(props, ref) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement(Component, (0, $93c14b0a090563ae$export$2e2bcd8739ae039)({}, props, $c4b3689eca620d46$export$cdf1dc76b55502e3(props), {
            ref: ref
        }));
    });
    AsyncTypeahead.displayName = "withAsync(".concat((0, $5e4757182651cd07$export$2e2bcd8739ae039)(Component), ")");
    // @ts-ignore
    AsyncTypeahead.propTypes = $c4b3689eca620d46$var$propTypes;
    return AsyncTypeahead;
}












var $lCkAA = parcelRequire("lCkAA");

var $kc00y = parcelRequire("kc00y");











var $lCkAA = parcelRequire("lCkAA");

var $kc00y = parcelRequire("kc00y");


var $kc00y = parcelRequire("kc00y");

var $kc00y = parcelRequire("kc00y");

var $b698e0c93634fae9$export$2fba198b5b2e37fa = {
    activeIndex: -1,
    hintText: '',
    id: '',
    initialItem: null,
    inputNode: null,
    isOnlyResult: false,
    onActiveItemChange: (0, $06626226287de840$export$8793edee2d425525),
    onAdd: (0, $06626226287de840$export$8793edee2d425525),
    onInitialItemChange: (0, $06626226287de840$export$8793edee2d425525),
    onMenuItemClick: (0, $06626226287de840$export$8793edee2d425525),
    setItem: (0, $06626226287de840$export$8793edee2d425525)
};
var $b698e0c93634fae9$export$b86a312c9066f850 = /*#__PURE__*/ (0, $kc00y.createContext)($b698e0c93634fae9$export$2fba198b5b2e37fa);
var $b698e0c93634fae9$export$20418b9b18662c6c = function useTypeaheadContext() {
    return (0, $kc00y.useContext)($b698e0c93634fae9$export$b86a312c9066f850);
};



function $d0e93450cd5996fa$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d0e93450cd5996fa$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d0e93450cd5996fa$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $d8f5e6158ecd1aab$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d0e93450cd5996fa$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $d0e93450cd5996fa$var$inputPropKeys = [
    'activeIndex',
    'disabled',
    'id',
    'inputRef',
    'isFocused',
    'isMenuShown',
    'multiple',
    'onBlur',
    'onChange',
    'onClick',
    'onFocus',
    'onKeyDown',
    'placeholder'
];
var $d0e93450cd5996fa$var$propKeys = [
    'activeIndex',
    'hideMenu',
    'isMenuShown',
    'labelKey',
    'onClear',
    'onHide',
    'onRemove',
    'results',
    'selected',
    'text',
    'toggleMenu'
];
var $d0e93450cd5996fa$var$contextKeys = [
    'activeIndex',
    'id',
    'initialItem',
    'inputNode',
    'onActiveItemChange',
    'onAdd',
    'onInitialItemChange',
    'onMenuItemClick',
    'setItem'
];
var $d0e93450cd5996fa$var$TypeaheadManager = function TypeaheadManager(props) {
    var allowNew = props.allowNew, children = props.children, initialItem = props.initialItem, isMenuShown = props.isMenuShown, onAdd = props.onAdd, onInitialItemChange = props.onInitialItemChange, onKeyDown = props.onKeyDown, onMenuToggle = props.onMenuToggle, results = props.results, selectHint = props.selectHint;
    var hintText = (0, $8416ce077ebdd44c$export$2e2bcd8739ae039)(props);
    (0, $kc00y.useEffect)(function() {
        // Clear the initial item when there are no results.
        if (!(allowNew || results.length)) onInitialItemChange();
    });
    var isInitialRender = (0, $kc00y.useRef)(true);
    (0, $kc00y.useEffect)(function() {
        if (isInitialRender.current) {
            isInitialRender.current = false;
            return;
        }
        onMenuToggle(isMenuShown);
    }, [
        isMenuShown,
        onMenuToggle
    ]);
    var handleKeyDown = function handleKeyDown(e) {
        onKeyDown(e);
        if (!initialItem) return;
        var addOnlyResult = e.key === 'Enter' && (0, $46573ce281764b64$export$2e2bcd8739ae039)(props);
        var shouldSelectHint = hintText && (0, $ee80c3087717cf88$export$2e2bcd8739ae039)(e, selectHint);
        if (addOnlyResult || shouldSelectHint) onAdd(initialItem);
    };
    var childProps = $d0e93450cd5996fa$var$_objectSpread($d0e93450cd5996fa$var$_objectSpread({}, (0, $06626226287de840$export$357523c63a2253b9)(props, $d0e93450cd5996fa$var$propKeys)), {}, {
        getInputProps: (0, $defb6d407200d166$export$2e2bcd8739ae039)($d0e93450cd5996fa$var$_objectSpread($d0e93450cd5996fa$var$_objectSpread({}, (0, $06626226287de840$export$357523c63a2253b9)(props, $d0e93450cd5996fa$var$inputPropKeys)), {}, {
            onKeyDown: handleKeyDown,
            value: (0, $3c15e93888f0532e$export$2e2bcd8739ae039)(props)
        }))
    });
    var contextValue = $d0e93450cd5996fa$var$_objectSpread($d0e93450cd5996fa$var$_objectSpread({}, (0, $06626226287de840$export$357523c63a2253b9)(props, $d0e93450cd5996fa$var$contextKeys)), {}, {
        hintText: hintText,
        isOnlyResult: (0, $46573ce281764b64$export$2e2bcd8739ae039)(props)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement((0, $b698e0c93634fae9$export$b86a312c9066f850).Provider, {
        value: contextValue
    }, (0, $06626226287de840$export$f6e2535fb5126e54)(children) ? children(childProps) : children);
};
var $d0e93450cd5996fa$export$2e2bcd8739ae039 = $d0e93450cd5996fa$var$TypeaheadManager;




function $8c50bd30f1b5b9e2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8c50bd30f1b5b9e2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8c50bd30f1b5b9e2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $d8f5e6158ecd1aab$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8c50bd30f1b5b9e2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $8c50bd30f1b5b9e2$export$53ac33307b5acee9(props) {
    var defaultInputValue = props.defaultInputValue, defaultOpen = props.defaultOpen, defaultSelected = props.defaultSelected, maxResults = props.maxResults, multiple = props.multiple;
    var selected = props.selected ? props.selected.slice() : defaultSelected.slice();
    var text = defaultInputValue;
    if (!multiple && selected.length) {
        // Set the text if an initial selection is passed in.
        text = (0, $d7e9821c80905e56$export$2e2bcd8739ae039)(selected[0], props.labelKey);
        if (selected.length > 1) // Limit to 1 selection in single-select mode.
        selected = selected.slice(0, 1);
    }
    return {
        activeIndex: -1,
        activeItem: undefined,
        initialItem: undefined,
        isFocused: false,
        selected: selected,
        showMenu: defaultOpen,
        shownResults: maxResults,
        text: text
    };
}
function $8c50bd30f1b5b9e2$export$df98f41f85652e52(state, props) {
    return $8c50bd30f1b5b9e2$var$_objectSpread($8c50bd30f1b5b9e2$var$_objectSpread({}, $8c50bd30f1b5b9e2$export$53ac33307b5acee9(props)), {}, {
        isFocused: state.isFocused,
        selected: [],
        text: ''
    });
}
function $8c50bd30f1b5b9e2$export$81b416d1310f34c8(state) {
    return $8c50bd30f1b5b9e2$var$_objectSpread($8c50bd30f1b5b9e2$var$_objectSpread({}, state), {}, {
        isFocused: true,
        showMenu: true
    });
}
function $8c50bd30f1b5b9e2$export$cdf0b0ed532145ff(state, props) {
    var _getInitialState = $8c50bd30f1b5b9e2$export$53ac33307b5acee9(props), activeIndex = _getInitialState.activeIndex, activeItem = _getInitialState.activeItem, initialItem = _getInitialState.initialItem, shownResults = _getInitialState.shownResults;
    return $8c50bd30f1b5b9e2$var$_objectSpread($8c50bd30f1b5b9e2$var$_objectSpread({}, state), {}, {
        activeIndex: activeIndex,
        activeItem: activeItem,
        initialItem: initialItem,
        showMenu: false,
        shownResults: shownResults
    });
}
function $8c50bd30f1b5b9e2$export$ac262bcf0e49db26(state, props) {
    return state.showMenu ? $8c50bd30f1b5b9e2$export$cdf0b0ed532145ff(state, props) : $8c50bd30f1b5b9e2$var$_objectSpread($8c50bd30f1b5b9e2$var$_objectSpread({}, state), {}, {
        showMenu: true
    });
}





var $38fa812282eed912$var$_excluded = [
    "onChange"
];
function $38fa812282eed912$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $38fa812282eed912$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $38fa812282eed912$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $d8f5e6158ecd1aab$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $38fa812282eed912$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $38fa812282eed912$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $38fa812282eed912$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $a6b135ba5b9f3850$export$2e2bcd8739ae039)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $a6b135ba5b9f3850$export$2e2bcd8739ae039)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $594192c53952fdd8$export$2e2bcd8739ae039)(this, result);
    };
}
function $38fa812282eed912$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $38fa812282eed912$var$propTypes = {
    /**
   * Allows the creation of new selections on the fly. Note that any new items
   * will be added to the list of selections, but not the list of original
   * options unless handled as such by `Typeahead`'s parent.
   *
   * If a function is specified, it will be used to determine whether a custom
   * option should be included. The return value should be true or false.
   */ allowNew: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).func
    ]),
    /**
   * Autofocus the input when the component initially mounts.
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).bool,
    /**
   * Whether or not filtering should be case-sensitive.
   */ caseSensitive: (0, $5fc1e2ca177b79bd$export$1c8c72d28a0627d2)((0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).bool, (0, $5fc1e2ca177b79bd$export$8a831d0ae116fbcd)),
    /**
   * The initial value displayed in the text input.
   */ defaultInputValue: (0, $5fc1e2ca177b79bd$export$1c8c72d28a0627d2)((0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).string, (0, $5fc1e2ca177b79bd$export$5534cbfe725ae92a)),
    /**
   * Whether or not the menu is displayed upon initial render.
   */ defaultOpen: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).bool,
    /**
   * Specify any pre-selected options. Use only if you want the component to
   * be uncontrolled.
   */ defaultSelected: (0, $5fc1e2ca177b79bd$export$1c8c72d28a0627d2)((0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).arrayOf((0, $5fc1e2ca177b79bd$export$7de5fae3688fa523)), (0, $5fc1e2ca177b79bd$export$79f4757fa6baab77)),
    /**
   * Either an array of fields in `option` to search, or a custom filtering
   * callback.
   */ filterBy: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).string.isRequired),
        (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).func
    ]),
    /**
   * Highlights the menu item if there is only one result and allows selecting
   * that item by hitting enter. Does not work with `allowNew`.
   */ highlightOnlyResult: (0, $5fc1e2ca177b79bd$export$1c8c72d28a0627d2)((0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).bool, (0, $5fc1e2ca177b79bd$export$f8e54140ea7ea3a8)),
    /**
   * An html id attribute, required for assistive technologies such as screen
   * readers.
   */ id: (0, $5fc1e2ca177b79bd$export$1c8c72d28a0627d2)((0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).string
    ]), (0, $5fc1e2ca177b79bd$export$50bb8c440cf2a42c)),
    /**
   * Whether the filter should ignore accents and other diacritical marks.
   */ ignoreDiacritics: (0, $5fc1e2ca177b79bd$export$1c8c72d28a0627d2)((0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).bool, (0, $5fc1e2ca177b79bd$export$9b9aee2bc2e2973d)),
    /**
   * Specify the option key to use for display or a function returning the
   * display string. By default, the selector will use the `label` key.
   */ labelKey: (0, $5fc1e2ca177b79bd$export$1c8c72d28a0627d2)((0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).func
    ]), (0, $5fc1e2ca177b79bd$export$8ae4524d34467ed5)),
    /**
   * Maximum number of results to display by default. Mostly done for
   * performance reasons so as not to render too many DOM nodes in the case of
   * large data sets.
   */ maxResults: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).number,
    /**
   * Number of input characters that must be entered before showing results.
   */ minLength: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).number,
    /**
   * Whether or not multiple selections are allowed.
   */ multiple: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).bool,
    /**
   * Invoked when the input is blurred. Receives an event.
   */ onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).func,
    /**
   * Invoked whenever items are added or removed. Receives an array of the
   * selected options.
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).func,
    /**
   * Invoked when the input is focused. Receives an event.
   */ onFocus: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).func,
    /**
   * Invoked when the input value changes. Receives the string value of the
   * input.
   */ onInputChange: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).func,
    /**
   * Invoked when a key is pressed. Receives an event.
   */ onKeyDown: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).func,
    /**
   * Invoked when menu visibility changes.
   */ onMenuToggle: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).func,
    /**
   * Invoked when the pagination menu item is clicked. Receives an event.
   */ onPaginate: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).func,
    /**
   * Whether or not the menu should be displayed. `undefined` allows the
   * component to control visibility, while `true` and `false` show and hide
   * the menu, respectively.
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).bool,
    /**
   * Full set of options, including pre-selected options. Must either be an
   * array of objects (recommended) or strings.
   */ options: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).arrayOf((0, $5fc1e2ca177b79bd$export$7de5fae3688fa523)).isRequired,
    /**
   * Give user the ability to display additional results if the number of
   * results exceeds `maxResults`.
   */ paginate: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).bool,
    /**
   * The selected option(s) displayed in the input. Use this prop if you want
   * to control the component via its parent.
   */ selected: (0, $5fc1e2ca177b79bd$export$1c8c72d28a0627d2)((0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).arrayOf((0, $5fc1e2ca177b79bd$export$7de5fae3688fa523)), (0, $5fc1e2ca177b79bd$export$1f1343c4475956f4))
};
var $38fa812282eed912$var$defaultProps = {
    allowNew: false,
    autoFocus: false,
    caseSensitive: false,
    defaultInputValue: '',
    defaultOpen: false,
    defaultSelected: [],
    filterBy: [],
    highlightOnlyResult: false,
    ignoreDiacritics: true,
    labelKey: (0, $da01923d9bfe8832$export$365087e449b345ed),
    maxResults: 100,
    minLength: 0,
    multiple: false,
    onBlur: (0, $06626226287de840$export$8793edee2d425525),
    onFocus: (0, $06626226287de840$export$8793edee2d425525),
    onInputChange: (0, $06626226287de840$export$8793edee2d425525),
    onKeyDown: (0, $06626226287de840$export$8793edee2d425525),
    onMenuToggle: (0, $06626226287de840$export$8793edee2d425525),
    onPaginate: (0, $06626226287de840$export$8793edee2d425525),
    paginate: true
};
/**
 * Manually trigger the input's change event.
 * https://stackoverflow.com/questions/23892547/what-is-the-best-way-to-trigger-onchange-event-in-react-js/46012210#46012210
 */ function $38fa812282eed912$var$triggerInputChange(input, value) {
    var inputValue = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value');
    inputValue && inputValue.set && inputValue.set.call(input, value);
    var e = new Event('input', {
        bubbles: true
    });
    input.dispatchEvent(e);
}
var $38fa812282eed912$var$Typeahead = /*#__PURE__*/ function(_React$Component) {
    (0, $e641cec65e374bd1$export$2e2bcd8739ae039)(Typeahead, _React$Component);
    var _super = $38fa812282eed912$var$_createSuper(Typeahead);
    function Typeahead() {
        var _this;
        (0, $6bf37624bc91922d$export$2e2bcd8739ae039)(this, Typeahead);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $d8f5e6158ecd1aab$export$2e2bcd8739ae039)((0, $83799a442ebf2b68$export$2e2bcd8739ae039)(_this), "state", (0, $8c50bd30f1b5b9e2$export$53ac33307b5acee9)(_this.props));
        (0, $d8f5e6158ecd1aab$export$2e2bcd8739ae039)((0, $83799a442ebf2b68$export$2e2bcd8739ae039)(_this), "inputNode", null);
        (0, $d8f5e6158ecd1aab$export$2e2bcd8739ae039)((0, $83799a442ebf2b68$export$2e2bcd8739ae039)(_this), "isMenuShown", false);
        // Keeps track of actual items displayed in the menu, after sorting,
        // truncating, grouping, etc.
        (0, $d8f5e6158ecd1aab$export$2e2bcd8739ae039)((0, $83799a442ebf2b68$export$2e2bcd8739ae039)(_this), "items", []);
        (0, $d8f5e6158ecd1aab$export$2e2bcd8739ae039)((0, $83799a442ebf2b68$export$2e2bcd8739ae039)(_this), "blur", function() {
            _this.inputNode && _this.inputNode.blur();
            _this.hideMenu();
        });
        (0, $d8f5e6158ecd1aab$export$2e2bcd8739ae039)((0, $83799a442ebf2b68$export$2e2bcd8739ae039)(_this), "clear", function() {
            _this.setState((0, $8c50bd30f1b5b9e2$export$df98f41f85652e52));
        });
        (0, $d8f5e6158ecd1aab$export$2e2bcd8739ae039)((0, $83799a442ebf2b68$export$2e2bcd8739ae039)(_this), "focus", function() {
            _this.inputNode && _this.inputNode.focus();
        });
        (0, $d8f5e6158ecd1aab$export$2e2bcd8739ae039)((0, $83799a442ebf2b68$export$2e2bcd8739ae039)(_this), "getInput", function() {
            return _this.inputNode;
        });
        (0, $d8f5e6158ecd1aab$export$2e2bcd8739ae039)((0, $83799a442ebf2b68$export$2e2bcd8739ae039)(_this), "inputRef", function(inputNode) {
            _this.inputNode = inputNode;
        });
        (0, $d8f5e6158ecd1aab$export$2e2bcd8739ae039)((0, $83799a442ebf2b68$export$2e2bcd8739ae039)(_this), "setItem", function(item, position) {
            _this.items[position] = item;
        });
        (0, $d8f5e6158ecd1aab$export$2e2bcd8739ae039)((0, $83799a442ebf2b68$export$2e2bcd8739ae039)(_this), "hideMenu", function() {
            _this.setState((0, $8c50bd30f1b5b9e2$export$cdf0b0ed532145ff));
        });
        (0, $d8f5e6158ecd1aab$export$2e2bcd8739ae039)((0, $83799a442ebf2b68$export$2e2bcd8739ae039)(_this), "toggleMenu", function() {
            _this.setState((0, $8c50bd30f1b5b9e2$export$ac262bcf0e49db26));
        });
        (0, $d8f5e6158ecd1aab$export$2e2bcd8739ae039)((0, $83799a442ebf2b68$export$2e2bcd8739ae039)(_this), "_handleActiveIndexChange", function(activeIndex) {
            _this.setState(function(state) {
                return {
                    activeIndex: activeIndex,
                    activeItem: activeIndex >= 0 ? state.activeItem : undefined
                };
            });
        });
        (0, $d8f5e6158ecd1aab$export$2e2bcd8739ae039)((0, $83799a442ebf2b68$export$2e2bcd8739ae039)(_this), "_handleActiveItemChange", function(activeItem) {
            // Don't update the active item if it hasn't changed.
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($7b40b513af0ed011$exports)))(activeItem, _this.state.activeItem)) _this.setState({
                activeItem: activeItem
            });
        });
        (0, $d8f5e6158ecd1aab$export$2e2bcd8739ae039)((0, $83799a442ebf2b68$export$2e2bcd8739ae039)(_this), "_handleBlur", function(e) {
            e.persist();
            _this.setState({
                isFocused: false
            }, function() {
                return _this.props.onBlur(e);
            });
        });
        (0, $d8f5e6158ecd1aab$export$2e2bcd8739ae039)((0, $83799a442ebf2b68$export$2e2bcd8739ae039)(_this), "_handleChange", function(selected) {
            _this.props.onChange && _this.props.onChange(selected);
        });
        (0, $d8f5e6158ecd1aab$export$2e2bcd8739ae039)((0, $83799a442ebf2b68$export$2e2bcd8739ae039)(_this), "_handleClear", function() {
            _this.inputNode && $38fa812282eed912$var$triggerInputChange(_this.inputNode, '');
            _this.setState((0, $8c50bd30f1b5b9e2$export$df98f41f85652e52), function() {
                // Change handler is automatically triggered for single selections but
                // not multi-selections.
                if (_this.props.multiple) _this._handleChange([]);
            });
        });
        (0, $d8f5e6158ecd1aab$export$2e2bcd8739ae039)((0, $83799a442ebf2b68$export$2e2bcd8739ae039)(_this), "_handleClick", function(e) {
            var _this$props$inputProp;
            e.persist();
            var onClick = (_this$props$inputProp = _this.props.inputProps) === null || _this$props$inputProp === void 0 ? void 0 : _this$props$inputProp.onClick;
            _this.setState((0, $8c50bd30f1b5b9e2$export$81b416d1310f34c8), function() {
                return (0, $06626226287de840$export$f6e2535fb5126e54)(onClick) && onClick(e);
            });
        });
        (0, $d8f5e6158ecd1aab$export$2e2bcd8739ae039)((0, $83799a442ebf2b68$export$2e2bcd8739ae039)(_this), "_handleFocus", function(e) {
            e.persist();
            _this.setState((0, $8c50bd30f1b5b9e2$export$81b416d1310f34c8), function() {
                return _this.props.onFocus(e);
            });
        });
        (0, $d8f5e6158ecd1aab$export$2e2bcd8739ae039)((0, $83799a442ebf2b68$export$2e2bcd8739ae039)(_this), "_handleInitialItemChange", function(initialItem) {
            // Don't update the initial item if it hasn't changed.
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($7b40b513af0ed011$exports)))(initialItem, _this.state.initialItem)) _this.setState({
                initialItem: initialItem
            });
        });
        (0, $d8f5e6158ecd1aab$export$2e2bcd8739ae039)((0, $83799a442ebf2b68$export$2e2bcd8739ae039)(_this), "_handleInputChange", function(e) {
            e.persist();
            var text = e.currentTarget.value;
            var _this$props = _this.props, multiple = _this$props.multiple, onInputChange = _this$props.onInputChange;
            // Clear selections when the input value changes in single-select mode.
            var shouldClearSelections = _this.state.selected.length && !multiple;
            _this.setState(function(state, props) {
                var _getInitialState = (0, $8c50bd30f1b5b9e2$export$53ac33307b5acee9)(props), activeIndex = _getInitialState.activeIndex, activeItem = _getInitialState.activeItem, shownResults = _getInitialState.shownResults;
                return {
                    activeIndex: activeIndex,
                    activeItem: activeItem,
                    selected: shouldClearSelections ? [] : state.selected,
                    showMenu: true,
                    shownResults: shownResults,
                    text: text
                };
            }, function() {
                onInputChange(text, e);
                shouldClearSelections && _this._handleChange([]);
            });
        });
        (0, $d8f5e6158ecd1aab$export$2e2bcd8739ae039)((0, $83799a442ebf2b68$export$2e2bcd8739ae039)(_this), "_handleKeyDown", function(e) {
            var activeItem = _this.state.activeItem;
            // Skip most actions when the menu is hidden.
            if (!_this.isMenuShown) {
                if (e.key === 'ArrowUp' || e.key === 'ArrowDown') _this.setState({
                    showMenu: true
                });
                _this.props.onKeyDown(e);
                return;
            }
            switch(e.key){
                case 'ArrowUp':
                case 'ArrowDown':
                    // Prevent input cursor from going to the beginning when pressing up.
                    e.preventDefault();
                    _this._handleActiveIndexChange((0, $0111ffb532477f60$export$2e2bcd8739ae039)(_this.state.activeIndex, e.key, _this.items));
                    break;
                case 'Enter':
                    // Prevent form submission while menu is open.
                    e.preventDefault();
                    activeItem && _this._handleMenuItemSelect(activeItem, e);
                    break;
                case 'Escape':
                case 'Tab':
                    // ESC simply hides the menu. TAB will blur the input and move focus to
                    // the next item; hide the menu so it doesn't gain focus.
                    _this.hideMenu();
                    break;
                default:
                    break;
            }
            _this.props.onKeyDown(e);
        });
        (0, $d8f5e6158ecd1aab$export$2e2bcd8739ae039)((0, $83799a442ebf2b68$export$2e2bcd8739ae039)(_this), "_handleMenuItemSelect", function(option, e) {
            if ((0, $cc5834112252bc97$export$2e2bcd8739ae039)(option, 'paginationOption')) _this._handlePaginate(e);
            else _this._handleSelectionAdd(option);
        });
        (0, $d8f5e6158ecd1aab$export$2e2bcd8739ae039)((0, $83799a442ebf2b68$export$2e2bcd8739ae039)(_this), "_handlePaginate", function(e) {
            e.persist();
            _this.setState(function(state, props) {
                return {
                    shownResults: state.shownResults + props.maxResults
                };
            }, function() {
                return _this.props.onPaginate(e, _this.state.shownResults);
            });
        });
        (0, $d8f5e6158ecd1aab$export$2e2bcd8739ae039)((0, $83799a442ebf2b68$export$2e2bcd8739ae039)(_this), "_handleSelectionAdd", function(option) {
            var _this$props2 = _this.props, multiple = _this$props2.multiple, labelKey = _this$props2.labelKey;
            var selected;
            var selection = option;
            var text;
            // Add a unique id to the custom selection. Avoid doing this in `render` so
            // the id doesn't increment every time.
            if (!(0, $06626226287de840$export$844ec244b1367d54)(selection) && selection.customOption) selection = $38fa812282eed912$var$_objectSpread($38fa812282eed912$var$_objectSpread({}, selection), {}, {
                id: (0, $06626226287de840$export$8b15d37bc3f197d4)('new-id-')
            });
            if (multiple) {
                // If multiple selections are allowed, add the new selection to the
                // existing selections.
                selected = _this.state.selected.concat(selection);
                text = '';
            } else {
                // If only a single selection is allowed, replace the existing selection
                // with the new one.
                selected = [
                    selection
                ];
                text = (0, $d7e9821c80905e56$export$2e2bcd8739ae039)(selection, labelKey);
            }
            _this.setState(function(state, props) {
                return $38fa812282eed912$var$_objectSpread($38fa812282eed912$var$_objectSpread({}, (0, $8c50bd30f1b5b9e2$export$cdf0b0ed532145ff)(state, props)), {}, {
                    initialItem: selection,
                    selected: selected,
                    text: text
                });
            }, function() {
                return _this._handleChange(selected);
            });
        });
        (0, $d8f5e6158ecd1aab$export$2e2bcd8739ae039)((0, $83799a442ebf2b68$export$2e2bcd8739ae039)(_this), "_handleSelectionRemove", function(selection) {
            var selected = _this.state.selected.filter(function(option) {
                return !(0, (/*@__PURE__*/$parcel$interopDefault($7b40b513af0ed011$exports)))(option, selection);
            });
            // Make sure the input stays focused after the item is removed.
            _this.focus();
            _this.setState(function(state, props) {
                return $38fa812282eed912$var$_objectSpread($38fa812282eed912$var$_objectSpread({}, (0, $8c50bd30f1b5b9e2$export$cdf0b0ed532145ff)(state, props)), {}, {
                    selected: selected
                });
            }, function() {
                return _this._handleChange(selected);
            });
        });
        return _this;
    }
    (0, $aadd4372416ec2f2$export$2e2bcd8739ae039)(Typeahead, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.props.autoFocus && this.focus();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                var _this$props3 = this.props, labelKey = _this$props3.labelKey, multiple = _this$props3.multiple, selected = _this$props3.selected;
                (0, $12254a1747f5d042$export$2e2bcd8739ae039)(selected, prevProps.selected);
                // Sync selections in state with those in props.
                if (selected && !(0, (/*@__PURE__*/$parcel$interopDefault($7b40b513af0ed011$exports)))(selected, prevState.selected)) {
                    this.setState({
                        selected: selected
                    });
                    if (!multiple) this.setState({
                        text: selected.length ? (0, $d7e9821c80905e56$export$2e2bcd8739ae039)(selected[0], labelKey) : ''
                    });
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props4 = this.props, onChange = _this$props4.onChange, props = (0, $fefdef73d5b2b1c6$export$2e2bcd8739ae039)(_this$props4, $38fa812282eed912$var$_excluded);
                var mergedPropsAndState = $38fa812282eed912$var$_objectSpread($38fa812282eed912$var$_objectSpread({}, props), this.state);
                var filterBy = mergedPropsAndState.filterBy, labelKey = mergedPropsAndState.labelKey, options = mergedPropsAndState.options, paginate = mergedPropsAndState.paginate, shownResults = mergedPropsAndState.shownResults, text = mergedPropsAndState.text;
                this.isMenuShown = (0, $d77fd8b1a9dad437$export$2e2bcd8739ae039)(mergedPropsAndState);
                this.items = []; // Reset items on re-render.
                var results = [];
                if (this.isMenuShown) {
                    var cb = (0, $06626226287de840$export$f6e2535fb5126e54)(filterBy) ? filterBy : (0, $0243c3e624f10d7b$export$2e2bcd8739ae039);
                    results = options.filter(function(option) {
                        return cb(option, mergedPropsAndState);
                    });
                    // This must come before results are truncated.
                    var shouldPaginate = paginate && results.length > shownResults;
                    // Truncate results if necessary.
                    results = (0, $0744409029472d71$export$2e2bcd8739ae039)(results, shownResults);
                    // Add the custom option if necessary.
                    if ((0, $26df127f0c91cd7c$export$2e2bcd8739ae039)(results, mergedPropsAndState)) results.push((0, $d8f5e6158ecd1aab$export$2e2bcd8739ae039)({
                        customOption: true
                    }, (0, $de8def7e701779cb$export$2e2bcd8739ae039)(labelKey), text));
                    // Add the pagination item if necessary.
                    if (shouldPaginate) {
                        var _results$push2;
                        results.push((_results$push2 = {}, (0, $d8f5e6158ecd1aab$export$2e2bcd8739ae039)(_results$push2, (0, $de8def7e701779cb$export$2e2bcd8739ae039)(labelKey), ''), (0, $d8f5e6158ecd1aab$export$2e2bcd8739ae039)(_results$push2, "paginationOption", true), _results$push2));
                    }
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement((0, $d0e93450cd5996fa$export$2e2bcd8739ae039), (0, $93c14b0a090563ae$export$2e2bcd8739ae039)({}, mergedPropsAndState, {
                    hideMenu: this.hideMenu,
                    inputNode: this.inputNode,
                    inputRef: this.inputRef,
                    isMenuShown: this.isMenuShown,
                    onActiveItemChange: this._handleActiveItemChange,
                    onAdd: this._handleSelectionAdd,
                    onBlur: this._handleBlur,
                    onChange: this._handleInputChange,
                    onClear: this._handleClear,
                    onClick: this._handleClick,
                    onFocus: this._handleFocus,
                    onHide: this.hideMenu,
                    onInitialItemChange: this._handleInitialItemChange,
                    onKeyDown: this._handleKeyDown,
                    onMenuItemClick: this._handleMenuItemSelect,
                    onRemove: this._handleSelectionRemove,
                    results: results,
                    setItem: this.setItem,
                    toggleMenu: this.toggleMenu
                }));
            }
        }
    ]);
    return Typeahead;
}((0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).Component);
(0, $d8f5e6158ecd1aab$export$2e2bcd8739ae039)($38fa812282eed912$var$Typeahead, "propTypes", $38fa812282eed912$var$propTypes);
(0, $d8f5e6158ecd1aab$export$2e2bcd8739ae039)($38fa812282eed912$var$Typeahead, "defaultProps", $38fa812282eed912$var$defaultProps);
var $38fa812282eed912$export$2e2bcd8739ae039 = $38fa812282eed912$var$Typeahead;






var $lCkAA = parcelRequire("lCkAA");

var $kc00y = parcelRequire("kc00y");


var $7cf25a1a3328dbab$var$_excluded = [
    "className",
    "label",
    "onClick",
    "onKeyDown",
    "size"
];
var $7cf25a1a3328dbab$var$propTypes = {
    label: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).string,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).func,
    onKeyDown: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).func,
    size: (0, $5fc1e2ca177b79bd$export$9ae6167e9ee9e6d0)
};
/**
 * ClearButton
 *
 * http://getbootstrap.com/css/#helper-classes-close
 */ var $7cf25a1a3328dbab$var$ClearButton = function ClearButton(_ref) {
    var className = _ref.className, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Clear' : _ref$label, _onClick = _ref.onClick, _onKeyDown = _ref.onKeyDown, size = _ref.size, props = (0, $fefdef73d5b2b1c6$export$2e2bcd8739ae039)(_ref, $7cf25a1a3328dbab$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement("button", (0, $93c14b0a090563ae$export$2e2bcd8739ae039)({}, props, {
        "aria-label": label,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))('close', 'btn-close', 'rbt-close', {
            'rbt-close-lg': (0, $49777a0839183c16$export$650961c52e438122)(size),
            'rbt-close-sm': (0, $49777a0839183c16$export$93100e6f8d8c0365)(size)
        }, className),
        onClick: function onClick(e) {
            e.stopPropagation();
            _onClick && _onClick(e);
        },
        onKeyDown: function onKeyDown(e) {
            // Prevent browser from navigating back.
            if (e.key === 'Backspace') e.preventDefault();
            _onKeyDown && _onKeyDown(e);
        },
        type: "button"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement("span", {
        "aria-hidden": "true",
        className: "rbt-close-content"
    }, "\xD7"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement("span", {
        className: "sr-only visually-hidden"
    }, label));
};
$7cf25a1a3328dbab$var$ClearButton.propTypes = $7cf25a1a3328dbab$var$propTypes;
var $7cf25a1a3328dbab$export$2e2bcd8739ae039 = $7cf25a1a3328dbab$var$ClearButton;





var $lCkAA = parcelRequire("lCkAA");

var $kc00y = parcelRequire("kc00y");
var $28bada3e11e49f60$var$propTypes = {
    label: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).string
};
var $28bada3e11e49f60$var$Loader = function Loader(_ref) {
    var _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loading...' : _ref$label;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement("div", {
        className: "rbt-loader spinner-border spinner-border-sm",
        role: "status"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement("span", {
        className: "sr-only visually-hidden"
    }, label));
};
$28bada3e11e49f60$var$Loader.propTypes = $28bada3e11e49f60$var$propTypes;
var $28bada3e11e49f60$export$2e2bcd8739ae039 = $28bada3e11e49f60$var$Loader;






var $lCkAA = parcelRequire("lCkAA");



var $kc00y = parcelRequire("kc00y");

var $23fb56439ed03fc7$var$isClient = typeof document !== 'undefined';
var $23fb56439ed03fc7$var$noop = function noop() {};
var $23fb56439ed03fc7$var$index = $23fb56439ed03fc7$var$isClient ? (0, $kc00y.useLayoutEffect) : $23fb56439ed03fc7$var$noop;
// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function $23fb56439ed03fc7$var$deepEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (typeof a === 'function' && a.toString() === b.toString()) return true;
    let length;
    let i;
    let keys;
    if (a && b && typeof a === 'object') {
        if (Array.isArray(a)) {
            length = a.length;
            if (length !== b.length) return false;
            for(i = length; i-- !== 0;){
                if (!$23fb56439ed03fc7$var$deepEqual(a[i], b[i])) return false;
            }
            return true;
        }
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;){
            if (!({}).hasOwnProperty.call(b, keys[i])) return false;
        }
        for(i = length; i-- !== 0;){
            const key = keys[i];
            if (key === '_owner' && a.$$typeof) continue;
            if (!$23fb56439ed03fc7$var$deepEqual(a[key], b[key])) return false;
        }
        return true;
    }
    return a !== a && b !== b;
}
function $23fb56439ed03fc7$var$getDPR(element) {
    if (typeof window === 'undefined') return 1;
    const win = element.ownerDocument.defaultView || window;
    return win.devicePixelRatio || 1;
}
function $23fb56439ed03fc7$var$roundByDPR(element, value) {
    const dpr = $23fb56439ed03fc7$var$getDPR(element);
    return Math.round(value * dpr) / dpr;
}
function $23fb56439ed03fc7$var$useLatestRef(value) {
    const ref = $kc00y.useRef(value);
    $23fb56439ed03fc7$var$index(()=>{
        ref.current = value;
    });
    return ref;
}
/**
 * Provides data to position a floating element.
 * @see https://floating-ui.com/docs/useFloating
 */ function $23fb56439ed03fc7$export$4e02a5c1d08bac65(options) {
    if (options === void 0) options = {};
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform, elements: { reference: externalReference, floating: externalFloating } = {}, transform: transform = true, whileElementsMounted: whileElementsMounted, open: open } = options;
    const [data, setData] = $kc00y.useState({
        x: 0,
        y: 0,
        strategy: strategy,
        placement: placement,
        middlewareData: {},
        isPositioned: false
    });
    const [latestMiddleware, setLatestMiddleware] = $kc00y.useState(middleware);
    if (!$23fb56439ed03fc7$var$deepEqual(latestMiddleware, middleware)) setLatestMiddleware(middleware);
    const [_reference, _setReference] = $kc00y.useState(null);
    const [_floating, _setFloating] = $kc00y.useState(null);
    const setReference = $kc00y.useCallback((node)=>{
        if (node !== referenceRef.current) {
            referenceRef.current = node;
            _setReference(node);
        }
    }, []);
    const setFloating = $kc00y.useCallback((node)=>{
        if (node !== floatingRef.current) {
            floatingRef.current = node;
            _setFloating(node);
        }
    }, []);
    const referenceEl = externalReference || _reference;
    const floatingEl = externalFloating || _floating;
    const referenceRef = $kc00y.useRef(null);
    const floatingRef = $kc00y.useRef(null);
    const dataRef = $kc00y.useRef(data);
    const hasWhileElementsMounted = whileElementsMounted != null;
    const whileElementsMountedRef = $23fb56439ed03fc7$var$useLatestRef(whileElementsMounted);
    const platformRef = $23fb56439ed03fc7$var$useLatestRef(platform);
    const openRef = $23fb56439ed03fc7$var$useLatestRef(open);
    const update = $kc00y.useCallback(()=>{
        if (!referenceRef.current || !floatingRef.current) return;
        const config = {
            placement: placement,
            strategy: strategy,
            middleware: latestMiddleware
        };
        if (platformRef.current) config.platform = platformRef.current;
        (0, $d8c489c11b48936b$export$48a53dcb22e581d0)(referenceRef.current, floatingRef.current, config).then((data)=>{
            const fullData = {
                ...data,
                // The floating element's position may be recomputed while it's closed
                // but still mounted (such as when transitioning out). To ensure
                // `isPositioned` will be `false` initially on the next open, avoid
                // setting it to `true` when `open === false` (must be specified).
                isPositioned: openRef.current !== false
            };
            if (isMountedRef.current && !$23fb56439ed03fc7$var$deepEqual(dataRef.current, fullData)) {
                dataRef.current = fullData;
                $9018fd8b87cabbb7$exports.flushSync(()=>{
                    setData(fullData);
                });
            }
        });
    }, [
        latestMiddleware,
        placement,
        strategy,
        platformRef,
        openRef
    ]);
    $23fb56439ed03fc7$var$index(()=>{
        if (open === false && dataRef.current.isPositioned) {
            dataRef.current.isPositioned = false;
            setData((data)=>({
                    ...data,
                    isPositioned: false
                }));
        }
    }, [
        open
    ]);
    const isMountedRef = $kc00y.useRef(false);
    $23fb56439ed03fc7$var$index(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    $23fb56439ed03fc7$var$index(()=>{
        if (referenceEl) referenceRef.current = referenceEl;
        if (floatingEl) floatingRef.current = floatingEl;
        if (referenceEl && floatingEl) {
            if (whileElementsMountedRef.current) return whileElementsMountedRef.current(referenceEl, floatingEl, update);
            update();
        }
    }, [
        referenceEl,
        floatingEl,
        update,
        whileElementsMountedRef,
        hasWhileElementsMounted
    ]);
    const refs = $kc00y.useMemo(()=>({
            reference: referenceRef,
            floating: floatingRef,
            setReference: setReference,
            setFloating: setFloating
        }), [
        setReference,
        setFloating
    ]);
    const elements = $kc00y.useMemo(()=>({
            reference: referenceEl,
            floating: floatingEl
        }), [
        referenceEl,
        floatingEl
    ]);
    const floatingStyles = $kc00y.useMemo(()=>{
        const initialStyles = {
            position: strategy,
            left: 0,
            top: 0
        };
        if (!elements.floating) return initialStyles;
        const x = $23fb56439ed03fc7$var$roundByDPR(elements.floating, data.x);
        const y = $23fb56439ed03fc7$var$roundByDPR(elements.floating, data.y);
        if (transform) return {
            ...initialStyles,
            transform: "translate(" + x + "px, " + y + "px)",
            ...$23fb56439ed03fc7$var$getDPR(elements.floating) >= 1.5 && {
                willChange: 'transform'
            }
        };
        return {
            position: strategy,
            left: x,
            top: y
        };
    }, [
        strategy,
        transform,
        elements.floating,
        data.x,
        data.y
    ]);
    return $kc00y.useMemo(()=>({
            ...data,
            update: update,
            refs: refs,
            elements: elements,
            floatingStyles: floatingStyles
        }), [
        data,
        update,
        refs,
        elements,
        floatingStyles
    ]);
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $23fb56439ed03fc7$var$arrow$1 = (options)=>{
    function isRef(value) {
        return ({}).hasOwnProperty.call(value, 'current');
    }
    return {
        name: 'arrow',
        options: options,
        fn (state) {
            const { element: element, padding: padding } = typeof options === 'function' ? options(state) : options;
            if (element && isRef(element)) {
                if (element.current != null) return (0, $d8c489c11b48936b$export$f2120bbfa5450bd2)({
                    element: element.current,
                    padding: padding
                }).fn(state);
                return {};
            }
            if (element) return (0, $d8c489c11b48936b$export$f2120bbfa5450bd2)({
                element: element,
                padding: padding
            }).fn(state);
            return {};
        }
    };
};
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $23fb56439ed03fc7$export$cc800923e997bb8 = (options, deps)=>{
    const result = (0, $d8c489c11b48936b$export$cc800923e997bb8)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $23fb56439ed03fc7$export$fba63a578e423eb = (options, deps)=>{
    const result = (0, $d8c489c11b48936b$export$fba63a578e423eb)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $23fb56439ed03fc7$export$7bf07e38f3dc4b69 = (options, deps)=>{
    const result = (0, $d8c489c11b48936b$export$7bf07e38f3dc4b69)(options);
    return {
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $23fb56439ed03fc7$export$8a83211c878a3f1f = (options, deps)=>{
    const result = (0, $d8c489c11b48936b$export$8a83211c878a3f1f)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $23fb56439ed03fc7$export$346677f925de839c = (options, deps)=>{
    const result = (0, $d8c489c11b48936b$export$346677f925de839c)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $23fb56439ed03fc7$export$91fb6ecbd551914 = (options, deps)=>{
    const result = (0, $d8c489c11b48936b$export$91fb6ecbd551914)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $23fb56439ed03fc7$export$fe8985bb6374093c = (options, deps)=>{
    const result = (0, $d8c489c11b48936b$export$fe8985bb6374093c)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $23fb56439ed03fc7$export$18c8ad048e32c7d5 = (options, deps)=>{
    const result = (0, $d8c489c11b48936b$export$18c8ad048e32c7d5)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $23fb56439ed03fc7$export$f2120bbfa5450bd2 = (options, deps)=>{
    const result = $23fb56439ed03fc7$var$arrow$1(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};



var $kc00y = parcelRequire("kc00y");
function $a7ea272fd3d5c39f$export$e2eb4c264cf71a83(props) {
    var middleware = [];
    if (props.flip) middleware.push((0, $23fb56439ed03fc7$export$8a83211c878a3f1f)());
    if (props.align !== 'right' && props.align !== 'left') middleware.push((0, $23fb56439ed03fc7$export$346677f925de839c)({
        apply: function apply(_ref) {
            var rects = _ref.rects, elements = _ref.elements;
            Object.assign(elements.floating.style, {
                width: "".concat(rects.reference.width, "px")
            });
        }
    }));
    return middleware;
}
function $a7ea272fd3d5c39f$export$a9fe23cfa43a7b55(props) {
    var x = props.align === 'right' ? 'end' : 'start';
    var y = props.dropup ? 'top' : 'bottom';
    return "".concat(y, "-").concat(x);
}
function $a7ea272fd3d5c39f$export$ea8f71083e90600f(referenceElement, options) {
    var _useState = (0, $kc00y.useState)(null), _useState2 = (0, $e32bce0b6486f581$export$2e2bcd8739ae039)(_useState, 2), floatingElement = _useState2[0], attachRef = _useState2[1];
    var _useFloating = (0, $23fb56439ed03fc7$export$4e02a5c1d08bac65)({
        elements: {
            floating: floatingElement,
            reference: referenceElement
        },
        middleware: $a7ea272fd3d5c39f$export$e2eb4c264cf71a83(options),
        placement: $a7ea272fd3d5c39f$export$a9fe23cfa43a7b55(options),
        strategy: options.positionFixed ? 'fixed' : 'absolute',
        whileElementsMounted: (0, $d8c489c11b48936b$export$deee3a793edee05f)
    }), floatingStyles = _useFloating.floatingStyles;
    return {
        innerRef: attachRef,
        style: floatingStyles
    };
}
var $a7ea272fd3d5c39f$export$2e2bcd8739ae039 = $a7ea272fd3d5c39f$export$ea8f71083e90600f;




var $ac5f651d59c07eb8$var$_excluded = [
    "referenceElement",
    "isMenuShown"
];
// `Element` is not defined during server-side rendering, so shim it here.
/* istanbul ignore next */ var $ac5f651d59c07eb8$var$SafeElement = typeof Element === 'undefined' ? (0, $06626226287de840$export$8793edee2d425525) : Element;
var $ac5f651d59c07eb8$var$propTypes = {
    /**
   * Specify menu alignment. The default value is `justify`, which makes the
   * menu as wide as the input and truncates long values. Specifying `left`
   * or `right` will align the menu to that side and the width will be
   * determined by the length of menu item values.
   */ align: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).oneOf((0, $da01923d9bfe8832$export$54df5a921294d7ab)),
    children: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).func.isRequired,
    /**
   * Specify whether the menu should appear above the input.
   */ dropup: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).bool,
    /**
   * Whether or not to automatically adjust the position of the menu when it
   * reaches the viewport boundaries.
   */ flip: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).bool,
    isMenuShown: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).bool,
    positionFixed: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).bool,
    // @ts-ignore
    referenceElement: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).instanceOf($ac5f651d59c07eb8$var$SafeElement)
};
var $ac5f651d59c07eb8$var$Overlay = function Overlay(_ref) {
    var referenceElement = _ref.referenceElement, isMenuShown = _ref.isMenuShown, props = (0, $fefdef73d5b2b1c6$export$2e2bcd8739ae039)(_ref, $ac5f651d59c07eb8$var$_excluded);
    var overlayProps = (0, $a7ea272fd3d5c39f$export$2e2bcd8739ae039)(referenceElement, props);
    if (!isMenuShown) return null;
    return props.children(overlayProps);
};
$ac5f651d59c07eb8$var$Overlay.propTypes = $ac5f651d59c07eb8$var$propTypes;
var $ac5f651d59c07eb8$export$2e2bcd8739ae039 = $ac5f651d59c07eb8$var$Overlay;







var $kc00y = parcelRequire("kc00y");

function $77eca0ea71b6ba3e$var$useRootClose(onRootClose, options) {
    var ref = (0, $kc00y.useRef)(null);
    (0, $fd37908a5c2d91e4$export$2e2bcd8739ae039)(ref, onRootClose, options);
    return ref;
}
var $77eca0ea71b6ba3e$export$2e2bcd8739ae039 = $77eca0ea71b6ba3e$var$useRootClose;


var $0162e611f4458d95$var$_excluded = [
    "children",
    "onRootClose"
];
function $0162e611f4458d95$var$RootClose(_ref) {
    var children = _ref.children, onRootClose = _ref.onRootClose, props = (0, $fefdef73d5b2b1c6$export$2e2bcd8739ae039)(_ref, $0162e611f4458d95$var$_excluded);
    var rootRef = (0, $77eca0ea71b6ba3e$export$2e2bcd8739ae039)(onRootClose, props);
    return children(rootRef);
}
var $0162e611f4458d95$export$2e2bcd8739ae039 = $0162e611f4458d95$var$RootClose;










var $kc00y = parcelRequire("kc00y");






var $lCkAA = parcelRequire("lCkAA");

var $kc00y = parcelRequire("kc00y");



var $f4660d977bfc0393$var$_excluded = [
    "onBlur",
    "onClick",
    "onFocus",
    "onRemove",
    "option"
];
function $f4660d977bfc0393$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f4660d977bfc0393$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f4660d977bfc0393$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $d8f5e6158ecd1aab$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f4660d977bfc0393$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f4660d977bfc0393$var$propTypes = {
    onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).func,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).func,
    onFocus: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).func,
    onRemove: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).func,
    option: (0, $5fc1e2ca177b79bd$export$7de5fae3688fa523).isRequired
};
function $f4660d977bfc0393$export$31dcd79391e423fe(_ref) {
    var onBlur = _ref.onBlur, onClick = _ref.onClick, onFocus = _ref.onFocus, onRemove = _ref.onRemove, option = _ref.option, props = (0, $fefdef73d5b2b1c6$export$2e2bcd8739ae039)(_ref, $f4660d977bfc0393$var$_excluded);
    var _useState = (0, $kc00y.useState)(false), _useState2 = (0, $e32bce0b6486f581$export$2e2bcd8739ae039)(_useState, 2), active = _useState2[0], setActive = _useState2[1];
    var handleBlur = function handleBlur(e) {
        setActive(false);
        onBlur && onBlur(e);
    };
    var handleClick = function handleClick(e) {
        setActive(true);
        onClick && onClick(e);
    };
    var handleFocus = function handleFocus(e) {
        setActive(true);
        onFocus && onFocus(e);
    };
    var handleRemove = function handleRemove() {
        onRemove && onRemove(option);
    };
    var handleKeyDown = function handleKeyDown(e) {
        if (e.key === 'Backspace' && active) {
            // Prevent browser from going back.
            e.preventDefault();
            handleRemove();
        }
    };
    var attachRef = (0, $77eca0ea71b6ba3e$export$2e2bcd8739ae039)(handleBlur, $f4660d977bfc0393$var$_objectSpread($f4660d977bfc0393$var$_objectSpread({}, props), {}, {
        disabled: !active
    }));
    return {
        active: active,
        onBlur: handleBlur,
        onClick: handleClick,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onRemove: (0, $06626226287de840$export$f6e2535fb5126e54)(onRemove) ? handleRemove : undefined,
        ref: attachRef
    };
}
function $f4660d977bfc0393$export$f6f0dceccdb6a70d(Component) {
    (0, $5ff45b7b5c008bba$export$2e2bcd8739ae039)(false, "Warning: `withToken` is deprecated and will be removed in the next major version. Use `useToken` instead.");
    var displayName = "withToken(".concat((0, $5e4757182651cd07$export$2e2bcd8739ae039)(Component), ")");
    var WrappedToken = function WrappedToken(props) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement(Component, (0, $93c14b0a090563ae$export$2e2bcd8739ae039)({}, props, $f4660d977bfc0393$export$31dcd79391e423fe(props)));
    };
    WrappedToken.displayName = displayName;
    WrappedToken.propTypes = $f4660d977bfc0393$var$propTypes;
    return WrappedToken;
}



var $61fcaf19425bf9e5$var$_excluded = [
    "active",
    "children",
    "className",
    "onRemove",
    "tabIndex"
], $61fcaf19425bf9e5$var$_excluded2 = [
    "children",
    "option",
    "readOnly"
], $61fcaf19425bf9e5$var$_excluded3 = [
    "ref"
];
function $61fcaf19425bf9e5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $61fcaf19425bf9e5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $61fcaf19425bf9e5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $d8f5e6158ecd1aab$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $61fcaf19425bf9e5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $61fcaf19425bf9e5$var$InteractiveToken = /*#__PURE__*/ (0, $kc00y.forwardRef)(function(_ref, ref) {
    var active = _ref.active, children = _ref.children, className = _ref.className, onRemove = _ref.onRemove, tabIndex = _ref.tabIndex, props = (0, $fefdef73d5b2b1c6$export$2e2bcd8739ae039)(_ref, $61fcaf19425bf9e5$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement("div", (0, $93c14b0a090563ae$export$2e2bcd8739ae039)({}, props, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))('rbt-token', 'rbt-token-removeable', {
            'rbt-token-active': !!active
        }, className),
        ref: ref,
        tabIndex: tabIndex || 0
    }), children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement((0, $7cf25a1a3328dbab$export$2e2bcd8739ae039), {
        className: "rbt-token-remove-button",
        label: "Remove",
        onClick: onRemove,
        tabIndex: -1
    }));
});
var $61fcaf19425bf9e5$var$StaticToken = function StaticToken(_ref2) {
    var children = _ref2.children, className = _ref2.className, disabled = _ref2.disabled, href = _ref2.href;
    var classnames = (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))('rbt-token', {
        'rbt-token-disabled': disabled
    }, className);
    if (href && !disabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement("a", {
        className: classnames,
        href: href
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement("div", {
        className: classnames
    }, children);
};
/**
 * Individual token component, generally displayed within the
 * `TypeaheadInputMulti` component, but can also be rendered on its own.
 */ var $61fcaf19425bf9e5$var$Token = function Token(_ref3) {
    var children = _ref3.children, option = _ref3.option, readOnly = _ref3.readOnly, props = (0, $fefdef73d5b2b1c6$export$2e2bcd8739ae039)(_ref3, $61fcaf19425bf9e5$var$_excluded2);
    var _useToken = (0, $f4660d977bfc0393$export$31dcd79391e423fe)($61fcaf19425bf9e5$var$_objectSpread($61fcaf19425bf9e5$var$_objectSpread({}, props), {}, {
        option: option
    })), ref = _useToken.ref, tokenProps = (0, $fefdef73d5b2b1c6$export$2e2bcd8739ae039)(_useToken, $61fcaf19425bf9e5$var$_excluded3);
    var child = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement("div", {
        className: "rbt-token-label"
    }, children);
    return !props.disabled && !readOnly && (0, $06626226287de840$export$f6e2535fb5126e54)(tokenProps.onRemove) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement($61fcaf19425bf9e5$var$InteractiveToken, (0, $93c14b0a090563ae$export$2e2bcd8739ae039)({}, props, tokenProps, {
        ref: ref
    }), child) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement($61fcaf19425bf9e5$var$StaticToken, props, child);
};
var $61fcaf19425bf9e5$export$2e2bcd8739ae039 = $61fcaf19425bf9e5$var$Token;






var $kc00y = parcelRequire("kc00y");

var $kc00y = parcelRequire("kc00y");

// IE doesn't seem to get the composite computed value (eg: 'padding',
// 'borderStyle', etc.), so generate these from the individual values.
function $fd2137ed8f4c3cf0$var$interpolateStyle(styles, attr) {
    var subattr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    // Title-case the sub-attribute.
    if (subattr) /* eslint-disable-next-line no-param-reassign */ subattr = subattr.replace(subattr[0], subattr[0].toUpperCase());
    return [
        'Top',
        'Right',
        'Bottom',
        'Left'
    ].map(function(dir) {
        return styles["".concat(attr).concat(dir).concat(subattr)];
    }).join(' ');
}
function $fd2137ed8f4c3cf0$var$copyStyles(inputNode, hintNode) {
    var inputStyle = window.getComputedStyle(inputNode);
    /* eslint-disable no-param-reassign */ hintNode.style.borderStyle = $fd2137ed8f4c3cf0$var$interpolateStyle(inputStyle, 'border', 'style');
    hintNode.style.borderWidth = $fd2137ed8f4c3cf0$var$interpolateStyle(inputStyle, 'border', 'width');
    hintNode.style.fontSize = inputStyle.fontSize;
    hintNode.style.fontWeight = inputStyle.fontWeight;
    hintNode.style.height = inputStyle.height;
    hintNode.style.lineHeight = inputStyle.lineHeight;
    hintNode.style.margin = $fd2137ed8f4c3cf0$var$interpolateStyle(inputStyle, 'margin');
    hintNode.style.padding = $fd2137ed8f4c3cf0$var$interpolateStyle(inputStyle, 'padding');
/* eslint-enable no-param-reassign */ }
var $fd2137ed8f4c3cf0$export$efccc994a079cdc8 = function useHint() {
    var _useTypeaheadContext = (0, $b698e0c93634fae9$export$20418b9b18662c6c)(), hintText = _useTypeaheadContext.hintText, inputNode = _useTypeaheadContext.inputNode;
    var hintRef = (0, $kc00y.useRef)(null);
    (0, $kc00y.useEffect)(function() {
        // Scroll hint input when the text input is scrolling.
        var handleInputScroll = function handleInputScroll() {
            if (hintRef.current && inputNode) hintRef.current.scrollLeft = inputNode.scrollLeft;
        };
        inputNode === null || inputNode === void 0 || inputNode.addEventListener('scroll', handleInputScroll);
        return function() {
            inputNode === null || inputNode === void 0 || inputNode.removeEventListener('scroll', handleInputScroll);
        };
    }, [
        inputNode
    ]);
    (0, $kc00y.useEffect)(function() {
        if (inputNode && hintRef.current) $fd2137ed8f4c3cf0$var$copyStyles(inputNode, hintRef.current);
    });
    return {
        hintRef: hintRef,
        hintText: hintText
    };
};
var $fd2137ed8f4c3cf0$var$Hint = function Hint(_ref) {
    var children = _ref.children, className = _ref.className;
    var _useHint = $fd2137ed8f4c3cf0$export$efccc994a079cdc8(), hintRef = _useHint.hintRef, hintText = _useHint.hintText;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement("div", {
        className: className,
        style: {
            display: 'flex',
            flex: 1,
            height: '100%',
            position: 'relative'
        }
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement("input", {
        "aria-hidden": true,
        className: "rbt-input-hint",
        ref: hintRef,
        readOnly: true,
        style: {
            backgroundColor: 'transparent',
            borderColor: 'transparent',
            boxShadow: 'none',
            color: 'rgba(0, 0, 0, 0.54)',
            left: 0,
            pointerEvents: 'none',
            position: 'absolute',
            top: 0,
            width: '100%'
        },
        tabIndex: -1,
        value: hintText
    }));
};
var $fd2137ed8f4c3cf0$export$2e2bcd8739ae039 = $fd2137ed8f4c3cf0$var$Hint;







var $kc00y = parcelRequire("kc00y");
var $dd493f561a8bc6f5$var$Input = /*#__PURE__*/ (0, $kc00y.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement("input", (0, $93c14b0a090563ae$export$2e2bcd8739ae039)({}, props, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))('rbt-input-main', props.className),
        ref: ref
    }));
});
var $dd493f561a8bc6f5$export$2e2bcd8739ae039 = $dd493f561a8bc6f5$var$Input;





var $37d0e5fce42ac16e$var$_excluded = [
    "children",
    "className",
    "inputClassName",
    "inputRef",
    "referenceElementRef",
    "selected"
];
function $37d0e5fce42ac16e$var$TypeaheadInputMulti(props) {
    var wrapperRef = (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).useRef(null);
    var inputElem = (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).useRef(null);
    var _propsWithBsClassName = (0, $12a6aa6de8ed10be$export$2e2bcd8739ae039)(props), children = _propsWithBsClassName.children, className = _propsWithBsClassName.className, inputClassName = _propsWithBsClassName.inputClassName, inputRef = _propsWithBsClassName.inputRef, referenceElementRef = _propsWithBsClassName.referenceElementRef, selected = _propsWithBsClassName.selected, rest = (0, $fefdef73d5b2b1c6$export$2e2bcd8739ae039)(_propsWithBsClassName, $37d0e5fce42ac16e$var$_excluded);
    function getInputRef(input) {
        inputElem.current = input;
        props.inputRef(input);
    }
    /**
   * Forward click or focus events on the container element to the input.
   */ function handleContainerClickOrFocus(e) {
        // Don't focus the input if it's disabled.
        if (props.disabled) {
            e.currentTarget.blur();
            return;
        }
        var inputNode = inputElem.current;
        if (!inputNode || // Ignore if the clicked element is a child of the container, ie: a token
        // or the input itself.
        e.currentTarget.contains(e.target) && e.currentTarget !== e.target) return;
        if ((0, $851efee6990588f8$export$2e2bcd8739ae039)(inputNode)) // Move cursor to the end if the user clicks outside the actual input.
        inputNode.selectionStart = inputNode.value.length;
        inputNode.focus();
    }
    function handleKeyDown(e) {
        if (e.key === 'Backspace' && selected.length && !props.value) {
            var _wrapperRef$current;
            // Prevent browser from going back.
            e.preventDefault();
            // If the input is selected and there is no text, focus the last
            // token when the user hits backspace.
            var wrapperChildren = (_wrapperRef$current = wrapperRef.current) === null || _wrapperRef$current === void 0 ? void 0 : _wrapperRef$current.children;
            if (wrapperChildren !== null && wrapperChildren !== void 0 && wrapperChildren.length) {
                var lastToken = wrapperChildren[wrapperChildren.length - 2];
                lastToken === null || lastToken === void 0 || lastToken.focus();
            }
        }
        props.onKeyDown && props.onKeyDown(e);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))('rbt-input-multi', {
            disabled: props.disabled
        }, className),
        onClick: handleContainerClickOrFocus,
        onFocus: handleContainerClickOrFocus,
        ref: referenceElementRef,
        tabIndex: -1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement("div", {
        className: "rbt-input-wrapper",
        ref: wrapperRef
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement((0, $fd2137ed8f4c3cf0$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement((0, $dd493f561a8bc6f5$export$2e2bcd8739ae039), (0, $93c14b0a090563ae$export$2e2bcd8739ae039)({}, rest, {
        className: inputClassName,
        onKeyDown: handleKeyDown,
        ref: getInputRef,
        style: {
            backgroundColor: 'transparent',
            border: 0,
            boxShadow: 'none',
            cursor: 'inherit',
            outline: 'none',
            padding: 0,
            width: '100%',
            zIndex: 1
        }
    })))));
}
var $37d0e5fce42ac16e$export$2e2bcd8739ae039 = $37d0e5fce42ac16e$var$TypeaheadInputMulti;







var $kc00y = parcelRequire("kc00y");



var $891dca39bb1cfa72$var$_excluded = [
    "inputRef",
    "referenceElementRef"
];
var $891dca39bb1cfa72$var$TypeaheadInputSingle = function TypeaheadInputSingle(_ref) {
    var inputRef = _ref.inputRef, referenceElementRef = _ref.referenceElementRef, props = (0, $fefdef73d5b2b1c6$export$2e2bcd8739ae039)(_ref, $891dca39bb1cfa72$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement((0, $fd2137ed8f4c3cf0$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement((0, $dd493f561a8bc6f5$export$2e2bcd8739ae039), (0, $93c14b0a090563ae$export$2e2bcd8739ae039)({}, (0, $12a6aa6de8ed10be$export$2e2bcd8739ae039)(props), {
        ref: function ref(node) {
            inputRef(node);
            referenceElementRef(node);
        }
    })));
};
var $891dca39bb1cfa72$export$2e2bcd8739ae039 = $891dca39bb1cfa72$var$TypeaheadInputSingle;







var $lCkAA = parcelRequire("lCkAA");

var $kc00y = parcelRequire("kc00y");

var $lCkAA = parcelRequire("lCkAA");

var $kc00y = parcelRequire("kc00y");

var $7126d836ce01cb4e$var$propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).string.isRequired,
    highlightClassName: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).string,
    search: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).string.isRequired
};
/**
 * Stripped-down version of https://github.com/helior/react-highlighter
 *
 * Results are already filtered by the time the component is used internally so
 * we can safely ignore case and diacritical marks for the purposes of matching.
 */ var $7126d836ce01cb4e$var$Highlighter = function Highlighter(_ref) {
    var children = _ref.children, _ref$highlightClassNa = _ref.highlightClassName, highlightClassName = _ref$highlightClassNa === void 0 ? 'rbt-highlight-text' : _ref$highlightClassNa, search = _ref.search;
    if (!search || !children) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).Fragment, null, children);
    var matchCount = 0;
    var remaining = children;
    var highlighterChildren = [];
    while(remaining){
        var bounds = (0, $bdafdf0fadefc619$export$2e2bcd8739ae039)(remaining, search);
        // No match anywhere in the remaining string, stop.
        if (!bounds) {
            highlighterChildren.push(remaining);
            break;
        }
        // Capture the string that leads up to a match.
        var nonMatch = remaining.slice(0, bounds.start);
        if (nonMatch) highlighterChildren.push(nonMatch);
        // Capture the matching string.
        var match = remaining.slice(bounds.start, bounds.end);
        highlighterChildren.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement("mark", {
            className: highlightClassName,
            key: matchCount
        }, match));
        matchCount += 1;
        // And if there's anything left over, continue the loop.
        remaining = remaining.slice(bounds.end);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).Fragment, null, highlighterChildren);
};
$7126d836ce01cb4e$var$Highlighter.propTypes = $7126d836ce01cb4e$var$propTypes;
var $7126d836ce01cb4e$export$2e2bcd8739ae039 = $7126d836ce01cb4e$var$Highlighter;









var $lCkAA = parcelRequire("lCkAA");

var $kc00y = parcelRequire("kc00y");




var $kc00y = parcelRequire("kc00y");




var $lCkAA = parcelRequire("lCkAA");

var $kc00y = parcelRequire("kc00y");
const $f8c8367d87b91745$var$t = (t)=>"object" == typeof t && null != t && 1 === t.nodeType, $f8c8367d87b91745$var$e = (t, e)=>(!e || "hidden" !== t) && "visible" !== t && "clip" !== t, $f8c8367d87b91745$var$n = (t, n)=>{
    if (t.clientHeight < t.scrollHeight || t.clientWidth < t.scrollWidth) {
        const o = getComputedStyle(t, null);
        return $f8c8367d87b91745$var$e(o.overflowY, n) || $f8c8367d87b91745$var$e(o.overflowX, n) || ((t)=>{
            const e = ((t)=>{
                if (!t.ownerDocument || !t.ownerDocument.defaultView) return null;
                try {
                    return t.ownerDocument.defaultView.frameElement;
                } catch (t) {
                    return null;
                }
            })(t);
            return !!e && (e.clientHeight < t.scrollHeight || e.clientWidth < t.scrollWidth);
        })(t);
    }
    return !1;
}, $f8c8367d87b91745$var$o = (t, e, n, o, l, r, i, s)=>r < t && i > e || r > t && i < e ? 0 : r <= t && s <= n || i >= e && s >= n ? r - t - o : i > e && s < n || r < t && s > n ? i - e + l : 0, $f8c8367d87b91745$var$l = (t)=>{
    const e = t.parentElement;
    return null == e ? t.getRootNode().host || null : e;
}, $f8c8367d87b91745$export$3b12cb22b12b954b = (e, r)=>{
    var i, s, d, h;
    if ("undefined" == typeof document) return [];
    const { scrollMode: c, block: f, inline: u, boundary: a, skipOverflowHiddenElements: g } = r, p = "function" == typeof a ? a : (t)=>t !== a;
    if (!$f8c8367d87b91745$var$t(e)) throw new TypeError("Invalid target");
    const m = document.scrollingElement || document.documentElement, w = [];
    let W = e;
    for(; $f8c8367d87b91745$var$t(W) && p(W);){
        if (W = $f8c8367d87b91745$var$l(W), W === m) {
            w.push(W);
            break;
        }
        null != W && W === document.body && $f8c8367d87b91745$var$n(W) && !$f8c8367d87b91745$var$n(document.documentElement) || null != W && $f8c8367d87b91745$var$n(W, g) && w.push(W);
    }
    const b = null != (s = null == (i = window.visualViewport) ? void 0 : i.width) ? s : innerWidth, H = null != (h = null == (d = window.visualViewport) ? void 0 : d.height) ? h : innerHeight, { scrollX: y, scrollY: M } = window, { height: v, width: E, top: x, right: C, bottom: I, left: R } = e.getBoundingClientRect(), { top: T, right: B, bottom: F, left: V } = ((t)=>{
        const e = window.getComputedStyle(t);
        return {
            top: parseFloat(e.scrollMarginTop) || 0,
            right: parseFloat(e.scrollMarginRight) || 0,
            bottom: parseFloat(e.scrollMarginBottom) || 0,
            left: parseFloat(e.scrollMarginLeft) || 0
        };
    })(e);
    let k = "start" === f || "nearest" === f ? x - T : "end" === f ? I + F : x + v / 2 - T + F, D = "center" === u ? R + E / 2 - V + B : "end" === u ? C + B : R - V;
    const L = [];
    for(let t = 0; t < w.length; t++){
        const e = w[t], { height: l, width: r, top: i, right: s, bottom: d, left: h } = e.getBoundingClientRect();
        if ("if-needed" === c && x >= 0 && R >= 0 && I <= H && C <= b && (e === m && !$f8c8367d87b91745$var$n(e) || x >= i && I <= d && R >= h && C <= s)) return L;
        const a = getComputedStyle(e), g = parseInt(a.borderLeftWidth, 10), p = parseInt(a.borderTopWidth, 10), W = parseInt(a.borderRightWidth, 10), T = parseInt(a.borderBottomWidth, 10);
        let B = 0, F = 0;
        const V = "offsetWidth" in e ? e.offsetWidth - e.clientWidth - g - W : 0, S = "offsetHeight" in e ? e.offsetHeight - e.clientHeight - p - T : 0, X = "offsetWidth" in e ? 0 === e.offsetWidth ? 0 : r / e.offsetWidth : 0, Y = "offsetHeight" in e ? 0 === e.offsetHeight ? 0 : l / e.offsetHeight : 0;
        if (m === e) B = "start" === f ? k : "end" === f ? k - H : "nearest" === f ? $f8c8367d87b91745$var$o(M, M + H, H, p, T, M + k, M + k + v, v) : k - H / 2, F = "start" === u ? D : "center" === u ? D - b / 2 : "end" === u ? D - b : $f8c8367d87b91745$var$o(y, y + b, b, g, W, y + D, y + D + E, E), B = Math.max(0, B + M), F = Math.max(0, F + y);
        else {
            B = "start" === f ? k - i - p : "end" === f ? k - d + T + S : "nearest" === f ? $f8c8367d87b91745$var$o(i, d, l, p, T + S, k, k + v, v) : k - (i + l / 2) + S / 2, F = "start" === u ? D - h - g : "center" === u ? D - (h + r / 2) + V / 2 : "end" === u ? D - s + W + V : $f8c8367d87b91745$var$o(h, s, r, g, W + V, D, D + E, E);
            const { scrollLeft: t, scrollTop: n } = e;
            B = 0 === Y ? 0 : Math.max(0, Math.min(n + B / Y, e.scrollHeight - l / Y + S)), F = 0 === X ? 0 : Math.max(0, Math.min(t + F / X, e.scrollWidth - r / X + V)), k += n - B, D += t - F;
        }
        L.push({
            el: e,
            top: B,
            left: F
        });
    }
    return L;
};


const $8354f387a72099d6$var$o = (t)=>!1 === t ? {
        block: "end",
        inline: "nearest"
    } : ((t)=>t === Object(t) && 0 !== Object.keys(t).length)(t) ? t : {
        block: "start",
        inline: "nearest"
    };
function $8354f387a72099d6$export$2e2bcd8739ae039(e, r) {
    if (!e.isConnected || !((t)=>{
        let o = t;
        for(; o && o.parentNode;){
            if (o.parentNode === document) return !0;
            o = o.parentNode instanceof ShadowRoot ? o.parentNode.host : o.parentNode;
        }
        return !1;
    })(e)) return;
    const n = ((t)=>{
        const o = window.getComputedStyle(t);
        return {
            top: parseFloat(o.scrollMarginTop) || 0,
            right: parseFloat(o.scrollMarginRight) || 0,
            bottom: parseFloat(o.scrollMarginBottom) || 0,
            left: parseFloat(o.scrollMarginLeft) || 0
        };
    })(e);
    if (((t)=>"object" == typeof t && "function" == typeof t.behavior)(r)) return r.behavior((0, $f8c8367d87b91745$export$3b12cb22b12b954b)(e, r));
    const l = "boolean" == typeof r || null == r ? void 0 : r.behavior;
    for (const { el: a, top: i, left: s } of (0, $f8c8367d87b91745$export$3b12cb22b12b954b)(e, $8354f387a72099d6$var$o(r))){
        const t = i - n.top + n.bottom, o = s - n.left + n.right;
        a.scroll({
            top: t,
            left: o,
            behavior: l
        });
    }
}





var $cc276e9ef8c6d95c$var$_excluded = [
    "label",
    "onClick",
    "option",
    "position"
];
function $cc276e9ef8c6d95c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cc276e9ef8c6d95c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cc276e9ef8c6d95c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $d8f5e6158ecd1aab$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cc276e9ef8c6d95c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $cc276e9ef8c6d95c$var$propTypes = {
    option: (0, $5fc1e2ca177b79bd$export$7de5fae3688fa523).isRequired,
    position: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).number
};
function $cc276e9ef8c6d95c$export$9842ce616dcc8723(_ref) {
    var label = _ref.label, onClick = _ref.onClick, option = _ref.option, position = _ref.position, props = (0, $fefdef73d5b2b1c6$export$2e2bcd8739ae039)(_ref, $cc276e9ef8c6d95c$var$_excluded);
    var _useTypeaheadContext = (0, $b698e0c93634fae9$export$20418b9b18662c6c)(), activeIndex = _useTypeaheadContext.activeIndex, id = _useTypeaheadContext.id, isOnlyResult = _useTypeaheadContext.isOnlyResult, onActiveItemChange = _useTypeaheadContext.onActiveItemChange, onInitialItemChange = _useTypeaheadContext.onInitialItemChange, onMenuItemClick = _useTypeaheadContext.onMenuItemClick, setItem = _useTypeaheadContext.setItem;
    var itemRef = (0, $kc00y.useRef)(null);
    (0, $kc00y.useEffect)(function() {
        if (position === 0) onInitialItemChange(option);
    });
    (0, $kc00y.useEffect)(function() {
        if (position === activeIndex) {
            onActiveItemChange(option);
            // Automatically scroll the menu as the user keys through it.
            var node = itemRef.current;
            node && (0, $8354f387a72099d6$export$2e2bcd8739ae039)(node, {
                boundary: node.parentNode,
                scrollMode: 'if-needed'
            });
        }
    }, [
        activeIndex,
        onActiveItemChange,
        option,
        position
    ]);
    var handleClick = (0, $kc00y.useCallback)(function(e) {
        onMenuItemClick(option, e);
        onClick && onClick(e);
    }, [
        onClick,
        onMenuItemClick,
        option
    ]);
    var active = isOnlyResult || activeIndex === position;
    // Update the item's position in the item stack.
    setItem(option, position);
    return $cc276e9ef8c6d95c$var$_objectSpread($cc276e9ef8c6d95c$var$_objectSpread({}, props), {}, {
        active: active,
        'aria-label': label,
        'aria-selected': active,
        id: (0, $5c5eb1b23d7aeb46$export$2e2bcd8739ae039)(id, position),
        onClick: handleClick,
        onMouseDown: (0, $be3b8f28c4a47481$export$2e2bcd8739ae039),
        ref: itemRef,
        role: 'option'
    });
}
function $cc276e9ef8c6d95c$export$a3a500069effb440(Component) {
    (0, $5ff45b7b5c008bba$export$2e2bcd8739ae039)(false, "Warning: `withItem` is deprecated and will be removed in the next major version. Use `useItem` instead.");
    var WrappedMenuItem = function WrappedMenuItem(props) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement(Component, (0, $93c14b0a090563ae$export$2e2bcd8739ae039)({}, props, $cc276e9ef8c6d95c$export$9842ce616dcc8723(props)));
    };
    WrappedMenuItem.displayName = "withItem(".concat((0, $5e4757182651cd07$export$2e2bcd8739ae039)(Component), ")");
    WrappedMenuItem.propTypes = $cc276e9ef8c6d95c$var$propTypes;
    return WrappedMenuItem;
}


var $a1d5daa6454a8ba1$var$_excluded = [
    "active",
    "children",
    "className",
    "disabled",
    "onClick"
];
var $a1d5daa6454a8ba1$export$2ddca9041350239b = /*#__PURE__*/ (0, $kc00y.forwardRef)(function(_ref, ref) {
    var active = _ref.active, children = _ref.children, className = _ref.className, disabled = _ref.disabled, _onClick = _ref.onClick, props = (0, $fefdef73d5b2b1c6$export$2e2bcd8739ae039)(_ref, $a1d5daa6454a8ba1$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement("a", (0, $93c14b0a090563ae$export$2e2bcd8739ae039)({}, props, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))('dropdown-item', {
            active: active,
            disabled: disabled
        }, className),
        href: props.href || '#',
        onClick: function onClick(e) {
            e.preventDefault();
            !disabled && _onClick && _onClick(e);
        },
        ref: ref
    }), children);
});
function $a1d5daa6454a8ba1$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement($a1d5daa6454a8ba1$export$2ddca9041350239b, (0, $cc276e9ef8c6d95c$export$9842ce616dcc8723)(props));
}






var $95f54f5c0594edbb$var$_excluded = [
    "emptyLabel",
    "innerRef",
    "maxHeight",
    "style"
];
function $95f54f5c0594edbb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $95f54f5c0594edbb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $95f54f5c0594edbb$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $d8f5e6158ecd1aab$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $95f54f5c0594edbb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $95f54f5c0594edbb$var$MenuDivider = function MenuDivider() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement("div", {
        className: "dropdown-divider",
        role: "separator"
    });
};
var $95f54f5c0594edbb$var$MenuHeader = function MenuHeader(props) {
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
    (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement("div", (0, $93c14b0a090563ae$export$2e2bcd8739ae039)({}, props, {
        className: "dropdown-header",
        role: "heading"
    })));
};
var $95f54f5c0594edbb$var$propTypes = {
    'aria-label': (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).string,
    /**
   * Message to display in the menu if there are no valid results.
   */ emptyLabel: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).node,
    /**
   * Needed for accessibility.
   */ id: (0, $5fc1e2ca177b79bd$export$1c8c72d28a0627d2)((0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).string
    ]), (0, $5fc1e2ca177b79bd$export$50bb8c440cf2a42c)),
    /**
   * Maximum height of the dropdown menu.
   */ maxHeight: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).string
};
/**
 * Menu component that handles empty state when passed a set of results.
 */ var $95f54f5c0594edbb$var$Menu = function Menu(_ref) {
    var _ref$emptyLabel = _ref.emptyLabel, emptyLabel = _ref$emptyLabel === void 0 ? 'No matches found.' : _ref$emptyLabel, innerRef = _ref.innerRef, _ref$maxHeight = _ref.maxHeight, maxHeight = _ref$maxHeight === void 0 ? '300px' : _ref$maxHeight, style = _ref.style, props = (0, $fefdef73d5b2b1c6$export$2e2bcd8739ae039)(_ref, $95f54f5c0594edbb$var$_excluded);
    var children = (0, $kc00y.Children).count(props.children) === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement((0, $a1d5daa6454a8ba1$export$2ddca9041350239b), {
        disabled: true,
        role: "option"
    }, emptyLabel) : props.children;
    return /*#__PURE__*/ /* eslint-disable jsx-a11y/interactive-supports-focus */ (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement("div", (0, $93c14b0a090563ae$export$2e2bcd8739ae039)({}, props, {
        "aria-label": props['aria-label'] || 'menu-options',
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))('rbt-menu', 'dropdown-menu', 'show', props.className),
        onMouseDown: // Prevent input from blurring when clicking on the menu scrollbar.
        (0, $be3b8f28c4a47481$export$2e2bcd8739ae039),
        ref: innerRef,
        role: "listbox",
        style: $95f54f5c0594edbb$var$_objectSpread($95f54f5c0594edbb$var$_objectSpread({}, style), {}, {
            display: 'block',
            maxHeight: maxHeight,
            overflow: 'auto'
        })
    }), children);
};
$95f54f5c0594edbb$var$Menu.propTypes = $95f54f5c0594edbb$var$propTypes;
$95f54f5c0594edbb$var$Menu.Divider = $95f54f5c0594edbb$var$MenuDivider;
$95f54f5c0594edbb$var$Menu.Header = $95f54f5c0594edbb$var$MenuHeader;
var $95f54f5c0594edbb$export$2e2bcd8739ae039 = $95f54f5c0594edbb$var$Menu;






var $ca642a24d86a2675$var$_excluded = [
    "labelKey",
    "newSelectionPrefix",
    "options",
    "paginationText",
    "renderMenuItemChildren",
    "text"
];
var $ca642a24d86a2675$var$propTypes = {
    /**
   * Provides the ability to specify a prefix before the user-entered text to
   * indicate that the selection will be new. No-op unless `allowNew={true}`.
   */ newSelectionPrefix: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).node,
    /**
   * Prompt displayed when large data sets are paginated.
   */ paginationText: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).node,
    /**
   * Provides a hook for customized rendering of menu item contents.
   */ renderMenuItemChildren: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).func
};
function $ca642a24d86a2675$var$renderMenuItemChildrenFn(option, props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement((0, $7126d836ce01cb4e$export$2e2bcd8739ae039), {
        search: props.text
    }, (0, $d7e9821c80905e56$export$2e2bcd8739ae039)(option, props.labelKey));
}
var $ca642a24d86a2675$var$TypeaheadMenu = function TypeaheadMenu(props) {
    var labelKey = props.labelKey, _props$newSelectionPr = props.newSelectionPrefix, newSelectionPrefix = _props$newSelectionPr === void 0 ? 'New selection: ' : _props$newSelectionPr, options = props.options, _props$paginationText = props.paginationText, paginationText = _props$paginationText === void 0 ? 'Display additional results...' : _props$paginationText, _props$renderMenuItem = props.renderMenuItemChildren, renderMenuItemChildren = _props$renderMenuItem === void 0 ? $ca642a24d86a2675$var$renderMenuItemChildrenFn : _props$renderMenuItem, text = props.text, menuProps = (0, $fefdef73d5b2b1c6$export$2e2bcd8739ae039)(props, $ca642a24d86a2675$var$_excluded);
    var renderMenuItem = function renderMenuItem(option, position) {
        var label = (0, $d7e9821c80905e56$export$2e2bcd8739ae039)(option, labelKey);
        var menuItemProps = {
            disabled: !!(0, $cc5834112252bc97$export$2e2bcd8739ae039)(option, 'disabled'),
            label: label,
            option: option,
            position: position
        };
        if ((0, $cc5834112252bc97$export$2e2bcd8739ae039)(option, 'customOption')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement((0, $a1d5daa6454a8ba1$export$2e2bcd8739ae039), (0, $93c14b0a090563ae$export$2e2bcd8739ae039)({}, menuItemProps, {
            className: "rbt-menu-custom-option",
            key: position,
            label: label
        }), newSelectionPrefix, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement((0, $7126d836ce01cb4e$export$2e2bcd8739ae039), {
            search: text
        }, label));
        if ((0, $cc5834112252bc97$export$2e2bcd8739ae039)(option, 'paginationOption')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).Fragment, {
            key: "pagination-option-divider"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement((0, $95f54f5c0594edbb$export$2e2bcd8739ae039).Divider, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement((0, $a1d5daa6454a8ba1$export$2e2bcd8739ae039), (0, $93c14b0a090563ae$export$2e2bcd8739ae039)({}, menuItemProps, {
            className: "rbt-menu-pagination-option",
            label: // TODO: Fix how (aria-)labels are passed to `MenuItem`.
            // `paginationText` can be a ReactNode.
            (0, $06626226287de840$export$844ec244b1367d54)(paginationText) ? paginationText : ''
        }), paginationText));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement((0, $a1d5daa6454a8ba1$export$2e2bcd8739ae039), (0, $93c14b0a090563ae$export$2e2bcd8739ae039)({}, menuItemProps, {
            key: position
        }), renderMenuItemChildren(option, props, position));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement((0, $95f54f5c0594edbb$export$2e2bcd8739ae039), (0, $93c14b0a090563ae$export$2e2bcd8739ae039)({}, menuProps, {
        key: // Force a re-render if the text changes to ensure that menu
        // positioning updates correctly.
        text
    }), options.map(renderMenuItem));
};
$ca642a24d86a2675$var$TypeaheadMenu.propTypes = $ca642a24d86a2675$var$propTypes;
var $ca642a24d86a2675$export$2e2bcd8739ae039 = $ca642a24d86a2675$var$TypeaheadMenu;






function $eebed64cbd00f9c2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $eebed64cbd00f9c2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $eebed64cbd00f9c2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $d8f5e6158ecd1aab$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $eebed64cbd00f9c2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $eebed64cbd00f9c2$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $eebed64cbd00f9c2$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $a6b135ba5b9f3850$export$2e2bcd8739ae039)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $a6b135ba5b9f3850$export$2e2bcd8739ae039)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $594192c53952fdd8$export$2e2bcd8739ae039)(this, result);
    };
}
function $eebed64cbd00f9c2$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $eebed64cbd00f9c2$var$propTypes = {
    /**
   * Displays a button to clear the input when there are selections.
   */ clearButton: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).bool,
    /**
   * Props to be applied directly to the input. `onBlur`, `onChange`,
   * `onFocus`, and `onKeyDown` are ignored.
   */ inputProps: (0, $5fc1e2ca177b79bd$export$1c8c72d28a0627d2)((0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).object, (0, $5fc1e2ca177b79bd$export$82c0eddbd071e45f)),
    /**
   * Bootstrap 4 only. Adds the `is-invalid` classname to the `form-control`.
   */ isInvalid: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).bool,
    /**
   * Indicate whether an asynchronous data fetch is happening.
   */ isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).bool,
    /**
   * Bootstrap 4 only. Adds the `is-valid` classname to the `form-control`.
   */ isValid: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).bool,
    /**
   * Callback for custom input rendering.
   */ renderInput: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).func,
    /**
   * Callback for custom menu rendering.
   */ renderMenu: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).func,
    /**
   * Callback for custom menu rendering.
   */ renderToken: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).func,
    /**
   * Specifies the size of the input.
   */ size: (0, $5fc1e2ca177b79bd$export$9ae6167e9ee9e6d0)
};
var $eebed64cbd00f9c2$var$defaultProps = {
    isLoading: false
};
var $eebed64cbd00f9c2$var$defaultRenderMenu = function defaultRenderMenu(results, menuProps, props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement((0, $ca642a24d86a2675$export$2e2bcd8739ae039), (0, $93c14b0a090563ae$export$2e2bcd8739ae039)({}, menuProps, {
        labelKey: props.labelKey,
        options: results,
        text: props.text
    }));
};
var $eebed64cbd00f9c2$var$defaultRenderToken = function defaultRenderToken(option, props, idx) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement((0, $61fcaf19425bf9e5$export$2e2bcd8739ae039), {
        disabled: props.disabled,
        key: idx,
        onRemove: props.onRemove,
        option: option,
        tabIndex: props.tabIndex
    }, (0, $d7e9821c80905e56$export$2e2bcd8739ae039)(option, props.labelKey));
};
var $eebed64cbd00f9c2$var$overlayPropKeys = [
    'align',
    'dropup',
    'flip',
    'positionFixed'
];
function $eebed64cbd00f9c2$var$getOverlayProps(props) {
    return (0, $06626226287de840$export$357523c63a2253b9)(props, $eebed64cbd00f9c2$var$overlayPropKeys);
}
var $eebed64cbd00f9c2$var$TypeaheadComponent = /*#__PURE__*/ function(_React$Component) {
    (0, $e641cec65e374bd1$export$2e2bcd8739ae039)(TypeaheadComponent, _React$Component);
    var _super = $eebed64cbd00f9c2$var$_createSuper(TypeaheadComponent);
    function TypeaheadComponent() {
        var _this;
        (0, $6bf37624bc91922d$export$2e2bcd8739ae039)(this, TypeaheadComponent);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $d8f5e6158ecd1aab$export$2e2bcd8739ae039)((0, $83799a442ebf2b68$export$2e2bcd8739ae039)(_this), "_referenceElement", null);
        (0, $d8f5e6158ecd1aab$export$2e2bcd8739ae039)((0, $83799a442ebf2b68$export$2e2bcd8739ae039)(_this), "referenceElementRef", function(referenceElement) {
            _this._referenceElement = referenceElement;
        });
        (0, $d8f5e6158ecd1aab$export$2e2bcd8739ae039)((0, $83799a442ebf2b68$export$2e2bcd8739ae039)(_this), "_renderInput", function(inputProps, props) {
            var _this$props = _this.props, isInvalid = _this$props.isInvalid, isValid = _this$props.isValid, multiple = _this$props.multiple, renderInput = _this$props.renderInput, renderToken = _this$props.renderToken, size = _this$props.size;
            if ((0, $06626226287de840$export$f6e2535fb5126e54)(renderInput)) return renderInput(inputProps, props);
            var commonProps = $eebed64cbd00f9c2$var$_objectSpread($eebed64cbd00f9c2$var$_objectSpread({}, inputProps), {}, {
                isInvalid: isInvalid,
                isValid: isValid,
                size: size
            });
            if (!multiple) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement((0, $891dca39bb1cfa72$export$2e2bcd8739ae039), commonProps);
            var labelKey = props.labelKey, onRemove = props.onRemove, selected = props.selected;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement((0, $37d0e5fce42ac16e$export$2e2bcd8739ae039), (0, $93c14b0a090563ae$export$2e2bcd8739ae039)({}, commonProps, {
                placeholder: selected.length ? '' : inputProps.placeholder,
                selected: selected
            }), selected.map(function(option, idx) {
                return (renderToken || $eebed64cbd00f9c2$var$defaultRenderToken)(option, $eebed64cbd00f9c2$var$_objectSpread($eebed64cbd00f9c2$var$_objectSpread({}, commonProps), {}, {
                    labelKey: labelKey,
                    onRemove: onRemove
                }), idx);
            }));
        });
        (0, $d8f5e6158ecd1aab$export$2e2bcd8739ae039)((0, $83799a442ebf2b68$export$2e2bcd8739ae039)(_this), "_renderMenu", function(results, menuProps, props) {
            var _this$props2 = _this.props, emptyLabel = _this$props2.emptyLabel, id = _this$props2.id, maxHeight = _this$props2.maxHeight, newSelectionPrefix = _this$props2.newSelectionPrefix, paginationText = _this$props2.paginationText, renderMenu = _this$props2.renderMenu, renderMenuItemChildren = _this$props2.renderMenuItemChildren;
            return (renderMenu || $eebed64cbd00f9c2$var$defaultRenderMenu)(results, $eebed64cbd00f9c2$var$_objectSpread($eebed64cbd00f9c2$var$_objectSpread({}, menuProps), {}, {
                emptyLabel: emptyLabel,
                id: id,
                maxHeight: maxHeight,
                newSelectionPrefix: newSelectionPrefix,
                paginationText: paginationText,
                renderMenuItemChildren: renderMenuItemChildren
            }), props);
        });
        (0, $d8f5e6158ecd1aab$export$2e2bcd8739ae039)((0, $83799a442ebf2b68$export$2e2bcd8739ae039)(_this), "_renderAux", function(_ref) {
            var onClear = _ref.onClear, selected = _ref.selected;
            var _this$props3 = _this.props, clearButton = _this$props3.clearButton, disabled = _this$props3.disabled, isLoading = _this$props3.isLoading, size = _this$props3.size;
            var content;
            if (isLoading) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement((0, $28bada3e11e49f60$export$2e2bcd8739ae039), null);
            else if (clearButton && !disabled && selected.length) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement((0, $7cf25a1a3328dbab$export$2e2bcd8739ae039), {
                onClick: onClear,
                onMouseDown: (0, $be3b8f28c4a47481$export$2e2bcd8739ae039),
                size: size
            });
            return content ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))('rbt-aux', {
                    'rbt-aux-lg': (0, $49777a0839183c16$export$650961c52e438122)(size)
                })
            }, content) : null;
        });
        return _this;
    }
    (0, $aadd4372416ec2f2$export$2e2bcd8739ae039)(TypeaheadComponent, [
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props4 = this.props, children = _this$props4.children, className = _this$props4.className, instanceRef = _this$props4.instanceRef, open = _this$props4.open, options = _this$props4.options, style = _this$props4.style;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement((0, $38fa812282eed912$export$2e2bcd8739ae039), (0, $93c14b0a090563ae$export$2e2bcd8739ae039)({}, this.props, {
                    options: options,
                    ref: instanceRef
                }), function(props) {
                    var hideMenu = props.hideMenu, isMenuShown = props.isMenuShown, results = props.results;
                    var auxContent = _this2._renderAux(props);
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement((0, $0162e611f4458d95$export$2e2bcd8739ae039), {
                        disabled: open || !isMenuShown,
                        onRootClose: hideMenu
                    }, function(ref) {
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))('rbt', {
                                'has-aux': !!auxContent,
                                'is-invalid': _this2.props.isInvalid,
                                'is-valid': _this2.props.isValid
                            }, className),
                            ref: ref,
                            style: $eebed64cbd00f9c2$var$_objectSpread($eebed64cbd00f9c2$var$_objectSpread({}, style), {}, {
                                outline: 'none',
                                position: 'relative'
                            }),
                            tabIndex: -1
                        }, _this2._renderInput($eebed64cbd00f9c2$var$_objectSpread($eebed64cbd00f9c2$var$_objectSpread({}, props.getInputProps(_this2.props.inputProps)), {}, {
                            referenceElementRef: _this2.referenceElementRef
                        }), props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement((0, $ac5f651d59c07eb8$export$2e2bcd8739ae039), (0, $93c14b0a090563ae$export$2e2bcd8739ae039)({}, $eebed64cbd00f9c2$var$getOverlayProps(_this2.props), {
                            isMenuShown: isMenuShown,
                            referenceElement: _this2._referenceElement
                        }), function(menuProps) {
                            return _this2._renderMenu(results, menuProps, props);
                        }), auxContent, (0, $06626226287de840$export$f6e2535fb5126e54)(children) ? children(props) : children);
                    });
                });
            }
        }
    ]);
    return TypeaheadComponent;
}((0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).Component);
(0, $d8f5e6158ecd1aab$export$2e2bcd8739ae039)($eebed64cbd00f9c2$var$TypeaheadComponent, "propTypes", $eebed64cbd00f9c2$var$propTypes);
(0, $d8f5e6158ecd1aab$export$2e2bcd8739ae039)($eebed64cbd00f9c2$var$TypeaheadComponent, "defaultProps", $eebed64cbd00f9c2$var$defaultProps);
var $eebed64cbd00f9c2$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $kc00y.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement($eebed64cbd00f9c2$var$TypeaheadComponent, (0, $93c14b0a090563ae$export$2e2bcd8739ae039)({}, props, {
        instanceRef: ref
    }));
});




var $64bc064c742d3abb$var$AsyncTypeahead = /*#__PURE__*/ (0, $kc00y.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement((0, $eebed64cbd00f9c2$export$2e2bcd8739ae039), (0, $93c14b0a090563ae$export$2e2bcd8739ae039)({}, (0, $c4b3689eca620d46$export$cdf1dc76b55502e3)(props), {
        ref: ref
    }));
});
var $64bc064c742d3abb$export$2e2bcd8739ae039 = $64bc064c742d3abb$var$AsyncTypeahead;






























const $1c0a8d1838dcbbd7$export$f06621d9ad29af97 = (props)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $bkJfK.Form), {
        ...props
    });
const $1c0a8d1838dcbbd7$export$3e4181949bece6a4 = ({ error: error, innerRef: innerRef, children: children, ...rest })=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
        ...rest,
        ref: innerRef,
        children: [
            children,
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                className: "text-danger",
                children: error
            })
        ]
    });
const $1c0a8d1838dcbbd7$export$842aba50ed0ce9d7 = ({ name: name, label: label, className: className, required: required = true, disabled: disabled = false, tooltipText: tooltipText, visibleMap: visibleMap = true })=>{
    return label && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Label, {
                htmlFor: name,
                className: !disabled ? "fw-bold mt-2 " + className : "text-muted mt-2 " + className,
                children: [
                    label,
                    " ",
                    required === true && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("span", {
                        className: "text-danger",
                        children: "*"
                    })
                ]
            }),
            tooltipText && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                tooltipText: tooltipText,
                tooltipId: name,
                visibleMap: visibleMap,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$340bfce9b4df026b), {})
            })
        ]
    });
};
const $1c0a8d1838dcbbd7$export$c86715117507e8e5 = ({ name: name, label: label, required: required = true, readOnly: readOnly = false, disabled: disabled = false, value: value, placeholder: placeholder, tooltipText: tooltipText, password: password = false, onChange: onChange, onBlur: onBlur, visibleMap: visibleMap = true })=>{
    const [field, meta] = (0, $bkJfK.useField)(name);
    const error = meta.touched ? meta.error : null;
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)($1c0a8d1838dcbbd7$export$3e4181949bece6a4, {
        name: name,
        error: error,
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($1c0a8d1838dcbbd7$export$842aba50ed0ce9d7, {
                label: label,
                required: required,
                tooltipText: tooltipText,
                name: name,
                visibleMap: visibleMap
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Control, {
                id: name,
                required: required,
                type: password ? "password" : "text",
                readOnly: readOnly,
                disabled: disabled,
                defaultValue: value ?? "",
                placeholder: placeholder,
                ...field,
                onBlur: (v)=>onBlur ? onBlur(v) : field.onBlur(v),
                onChange: (v)=>onChange ? onChange(v) : field.onChange(v)
            }),
            password && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("button", {
                type: "button",
                style: {
                    position: "absolute",
                    right: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    padding: "0"
                }
            })
        ]
    });
};
const $1c0a8d1838dcbbd7$export$5a1d7ca0a925d9c2 = ({ name: name, label: label, required: required = false, disabled: disabled = false, value: value, tooltipText: tooltipText, onChange: onChange })=>{
    const [field, meta] = (0, $bkJfK.useField)(name);
    const error = meta.touched ? meta.error : null;
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)($1c0a8d1838dcbbd7$export$3e4181949bece6a4, {
        name: name,
        error: error,
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($1c0a8d1838dcbbd7$export$842aba50ed0ce9d7, {
                label: label,
                required: required,
                tooltipText: tooltipText,
                name: name
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Control, {
                id: name,
                required: required,
                type: "color",
                disabled: disabled,
                defaultValue: value ?? "#000000",
                ...field,
                onChange: (v)=>onChange ? onChange(v) : field.onChange(v)
            })
        ]
    });
};
const $1c0a8d1838dcbbd7$export$ce9b1cc0c34506d0 = ({ name: name, label: label, required: required = true, readOnly: readOnly = false, disabled: disabled = false, value: value, tooltipText: tooltipText, onChange: onChange, rows: rows = 3, hint: hint })=>{
    const [field, meta] = (0, $bkJfK.useField)(name);
    const error = meta.touched ? meta.error : null;
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)($1c0a8d1838dcbbd7$export$3e4181949bece6a4, {
        name: name,
        error: error,
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($1c0a8d1838dcbbd7$export$842aba50ed0ce9d7, {
                label: label,
                required: required,
                tooltipText: tooltipText,
                name: name
            }),
            hint && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                className: "mb-1",
                children: hint
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Control, {
                id: name,
                required: required,
                as: "textarea",
                rows: rows,
                readOnly: readOnly,
                disabled: disabled,
                defaultValue: value ?? "",
                ...field,
                onChange: (v)=>onChange ? onChange(v) : field.onChange(v)
            })
        ]
    });
};
const $1c0a8d1838dcbbd7$export$b0def9349e7d1439 = ({ id: id, name: name, label: label, disabled: disabled = false, checked: checked = false, tooltipText: tooltipText, onChange: onChange, visibleMap: visibleMap = true })=>{
    const [field, meta] = (0, $bkJfK.useField)(name);
    const error = meta.touched ? meta.error : null;
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)($1c0a8d1838dcbbd7$export$3e4181949bece6a4, {
        name: name,
        error: error,
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $bkJfK.Field), {
                id: id ?? name,
                name: name,
                type: "checkbox",
                disabled: disabled,
                onChange: (v)=>onChange ? onChange(v) : field.onChange(v),
                checked: field.value ?? checked,
                className: "mb-3 checkbox-custom"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("label", {
                htmlFor: id ?? name,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))("mx-0 mt-0 p-0", disabled ? "text-muted" : ""),
                children: [
                    label,
                    tooltipText && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                        tooltipText: tooltipText,
                        tooltipId: name,
                        visibleMap: visibleMap,
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$340bfce9b4df026b), {})
                    })
                ]
            })
        ]
    });
};
const $1c0a8d1838dcbbd7$export$83a1b8e4fcf0dd8e = ({ name: name, label: label, value: value, required: required = false, disabled: disabled = false, tooltipText: tooltipText })=>{
    const [, meta] = (0, $bkJfK.useField)(name);
    const error = meta.touched ? meta.error : null;
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)($1c0a8d1838dcbbd7$export$3e4181949bece6a4, {
        name: name,
        error: error,
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $bkJfK.Field), {
                name: name,
                type: "radio",
                value: value,
                disabled: disabled
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($1c0a8d1838dcbbd7$export$842aba50ed0ce9d7, {
                className: "p-1",
                label: label,
                required: required,
                disabled: disabled,
                tooltipText: tooltipText,
                name: name
            })
        ]
    });
};
const $1c0a8d1838dcbbd7$export$b57af79a4ab2a1c6 = ({ name: name, label: label, required: required = true, readOnly: readOnly = false, disabled: disabled = false, accept: accept, onChange: onChange, tooltipText: tooltipText, multiple: multiple = false })=>{
    const [, meta] = (0, $bkJfK.useField)(name);
    const error = meta.touched ? meta.error : null;
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)($1c0a8d1838dcbbd7$export$3e4181949bece6a4, {
        name: name,
        error: error,
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($1c0a8d1838dcbbd7$export$842aba50ed0ce9d7, {
                label: label,
                required: required,
                tooltipText: tooltipText,
                name: name
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Control, {
                id: name,
                required: required,
                type: "file",
                accept: accept,
                readOnly: readOnly,
                disabled: disabled,
                onChange: onChange,
                multiple: multiple
            })
        ]
    });
};
const $1c0a8d1838dcbbd7$export$6bf0cd3a219bbade = ({ name: name, label: label, required: required = true, readOnly: readOnly = false, value: value, tooltipText: tooltipText, min: min, step: step, max: max, visibleMap: visibleMap = true, ...rest })=>{
    const [field, meta] = (0, $bkJfK.useField)(name);
    const error = meta.touched ? meta.error : null;
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)($1c0a8d1838dcbbd7$export$3e4181949bece6a4, {
        name: name,
        error: error,
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($1c0a8d1838dcbbd7$export$842aba50ed0ce9d7, {
                label: label,
                required: required,
                tooltipText: tooltipText,
                name: name,
                visibleMap: visibleMap
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Control, {
                id: name,
                type: "number",
                required: required,
                min: min ?? 1,
                step: step ?? 0.1,
                readOnly: readOnly,
                defaultValue: value ?? "",
                max: max ?? undefined,
                ...field,
                ...rest
            })
        ]
    });
};
const $1c0a8d1838dcbbd7$var$PositiveNumberInput = ({ name: name, label: label, required: required = true, readOnly: readOnly = false, value: value, tooltipText: tooltipText, ...rest })=>{
    const handleBlur = (e)=>{
        if (e.currentTarget.value === "0") e.currentTarget.value = "1";
    };
    const handleKeypress = (e)=>{
        const characterCode = e.key;
        if (characterCode === "Backspace") return;
        const characterNumber = Number(characterCode);
        if (characterNumber >= 0 && characterNumber <= 9 || characterCode === "." || characterCode === ",") {
            if (e.currentTarget.value && e.currentTarget.value.length) return;
            else if (characterNumber === 0) e.preventDefault();
        } else e.preventDefault();
    };
    const [field, meta] = (0, $bkJfK.useField)(name);
    const error = meta.touched ? meta.error : null;
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)($1c0a8d1838dcbbd7$export$3e4181949bece6a4, {
        name: name,
        error: error,
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($1c0a8d1838dcbbd7$export$842aba50ed0ce9d7, {
                label: label,
                required: required,
                tooltipText: tooltipText,
                name: name
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Control, {
                id: name,
                type: "number",
                onKeyDown: handleKeypress,
                onBlur: handleBlur,
                min: rest.min ?? 1,
                step: rest.step ?? 1,
                readOnly: readOnly,
                defaultValue: value ?? "",
                required: required,
                ...field,
                ...rest
            })
        ]
    });
};
var $1c0a8d1838dcbbd7$export$2e2bcd8739ae039 = $1c0a8d1838dcbbd7$var$PositiveNumberInput;
const $1c0a8d1838dcbbd7$export$7edc06cf1783b30f = (props)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($1c0a8d1838dcbbd7$export$183478aa40b5df1, {
        dateType: "date",
        ...props
    });
const $1c0a8d1838dcbbd7$export$f5603a09670563b9 = ({ name: name, label: label, min: min, max: max, step: step, required: required = false, disabled: disabled = false, tooltipText: tooltipText })=>{
    const [field, meta] = (0, $bkJfK.useField)(name);
    const error = meta.touched ? meta.error : null;
    const currentValue = field.value !== undefined && field.value !== null ? Number(field.value) : min;
    const percentage = (currentValue - min) / (max - min) * 100;
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)($1c0a8d1838dcbbd7$export$3e4181949bece6a4, {
        name: name,
        error: error,
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($1c0a8d1838dcbbd7$export$842aba50ed0ce9d7, {
                className: "p-1",
                label: label,
                required: required,
                disabled: disabled,
                tooltipText: tooltipText,
                name: name
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                style: {
                    position: "relative"
                },
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $fb281c3c0e7b8a11$export$2e2bcd8739ae039), {
                        ...field,
                        id: name,
                        name: name,
                        required: required,
                        min: min,
                        max: max,
                        step: step,
                        disabled: disabled
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                        className: "position-absolute bg-primary text-white px-2 py-1 rounded fw-bold text-nowrap",
                        style: {
                            left: `${percentage}%`,
                            top: "-30px",
                            transform: "translateX(-50%)",
                            fontSize: "0.85rem"
                        },
                        children: currentValue.toFixed(2)
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                        className: "d-flex justify-content-between mb-2",
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("span", {
                                className: "text-muted",
                                children: min
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("span", {
                                className: "text-muted",
                                children: max
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $1c0a8d1838dcbbd7$export$183478aa40b5df1 = ({ name: name, label: label, required: required = true, readOnly: readOnly = false, tooltipText: tooltipText, dateType: dateType = "datetime-local", value: value, visibleMap: visibleMap = true, ...rest })=>{
    const [field, meta] = (0, $bkJfK.useField)(name);
    const error = meta.touched ? meta.error : null;
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)($1c0a8d1838dcbbd7$export$3e4181949bece6a4, {
        name: name,
        error: error,
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($1c0a8d1838dcbbd7$export$842aba50ed0ce9d7, {
                    label: label,
                    required: required,
                    className: "me-2",
                    tooltipText: tooltipText,
                    name: name,
                    visibleMap: visibleMap
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                className: "mx-1",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("input", {
                    id: name,
                    type: dateType,
                    required: required,
                    ...field,
                    ...rest,
                    disabled: readOnly,
                    value: value,
                    max: dateType === "date" ? "9999-12-31" : "9999-12-31T23:59"
                })
            })
        ]
    });
};
const $1c0a8d1838dcbbd7$export$eae70af4b4e3f197 = ({ name: name, label: label, options: options, getOptionValue: getOptionValue, getOptionLabel: getOptionLabel, value: value, isClearable: isClearable = false, required: required = true, readOnly: readOnly = false, onChange: onChange, tooltipText: tooltipText })=>{
    const [, meta] = (0, $bkJfK.useField)(name);
    const error = meta.touched ? meta.error : null;
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)($1c0a8d1838dcbbd7$export$3e4181949bece6a4, {
        name: name,
        error: error,
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($1c0a8d1838dcbbd7$export$842aba50ed0ce9d7, {
                label: label,
                required: required,
                tooltipText: tooltipText,
                name: name
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ac15ab874ad2390c$export$2e2bcd8739ae039), {
                id: name,
                isMulti: true,
                placeholder: "S\xe9lectionnez",
                name: name,
                required: required,
                options: options,
                getOptionValue: getOptionValue,
                getOptionLabel: getOptionLabel,
                isClearable: isClearable,
                value: value,
                onChange: onChange,
                isDisabled: readOnly,
                noOptionsMessage: ()=>"Aucune donn\xe9e trouv\xe9e"
            })
        ]
    });
};
const $1c0a8d1838dcbbd7$export$d6701e98ab1a6725 = ({ name: name, label: label, options: options, getOptionValue: getOptionValue, getOptionLabel: getOptionLabel, isClearable: isClearable = false, required: required = true, readOnly: readOnly = false, defaultValue: defaultValue, tooltipText: tooltipText, onChange: onChange, disabled: disabled = false, noOptionsMessage: noOptionsMessage = "Aucune donn\xe9e trouv\xe9e", visibleMap: visibleMap = true })=>{
    const [, meta] = (0, $bkJfK.useField)(name);
    const error = meta.touched ? meta.error : null;
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)($1c0a8d1838dcbbd7$export$3e4181949bece6a4, {
        name: name,
        error: error,
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($1c0a8d1838dcbbd7$export$842aba50ed0ce9d7, {
                label: label,
                required: required,
                tooltipText: tooltipText,
                name: name,
                visibleMap: visibleMap
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ac15ab874ad2390c$export$2e2bcd8739ae039), {
                id: name,
                isMulti: false,
                placeholder: "S\xe9lectionnez",
                options: options,
                getOptionValue: getOptionValue,
                getOptionLabel: getOptionLabel,
                isClearable: isClearable,
                value: defaultValue,
                onChange: onChange,
                required: required,
                isDisabled: readOnly || disabled,
                name: name,
                noOptionsMessage: ()=>noOptionsMessage
            })
        ]
    });
};
const $1c0a8d1838dcbbd7$export$dc7fb17466c6914d = ({ onChange: onChange, url: url, disabled: disabled = false, labelKey: labelKey = "libelle" })=>{
    const stateData = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)(url);
    const { isResolved: isResolvedListData, // eslint-disable-next-line no-empty-pattern
    data: listData = {} } = stateData;
    if (!isResolvedListData) return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $c21b1c237cfa1d94$export$2e2bcd8739ae039), {});
    else return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebed64cbd00f9c2$export$2e2bcd8739ae039), {
        className: "d-flex",
        placeholder: "S\xe9lectionnez...",
        size: "sm",
        options: listData,
        labelKey: labelKey,
        onChange: (data)=>{
            onChange(data && data[0]);
        },
        defaultSelected: [],
        clearButton: true,
        disabled: disabled
    });
};
const $1c0a8d1838dcbbd7$export$f76670b5e5897c33 = ({ title: title, children: children })=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("fieldset", {
        children: [
            title && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("legend", {
                children: title
            }),
            children
        ]
    });
};




var $bkJfK = parcelRequire("bkJfK");

var $kc00y = parcelRequire("kc00y");






const $034ce07d723030fb$var$ResolveReject = (onSubmit, setErrorMessage, successToastMessage = "L'\xe9l\xe9ment a bien \xe9t\xe9 enregistr\xe9", errorToastMessage = "L'\xe9l\xe9ment n'a pas \xe9t\xe9 enregistr\xe9", warningToastMessage = "Les informations fournies sont incompl\xe8tes ou erron\xe9es", redirectFn, isPartialSuccess = ()=>false)=>{
    const { success: successToast, warning: warningToast, error: errorToast } = (0, $6bdae0bad7b05751$export$91b3d218c74c79e4)();
    return {
        onResolve: (result)=>{
            setErrorMessage(null);
            isPartialSuccess(result) ? warningToast(warningToastMessage) : successToast(successToastMessage);
            onSubmit?.(result);
            redirectFn?.();
        },
        onReject: async (error)=>{
            setErrorMessage(await error.text());
            errorToast(errorToastMessage);
        }
    };
};
const $034ce07d723030fb$export$61e814e08207f1c5 = (submitUrl, isPost, onSubmit, redirectUrl, isMultipartFormData, isPartialSuccess, successToastMessage, errorToastMessage, warningToastMessage)=>{
    const [errorMessage, setErrorMessage] = (0, $kc00y.useState)(null);
    const navigate = (0, $7a844823b04d4282$export$9770f232ac06a008)();
    const location = (0, $7a844823b04d4282$export$45d76561a5302f2b)();
    const redirectFn = redirectUrl ? ()=>{
        // Si on a la page retour, on retourne dans l'état précédent
        // Sinon, on va à la page mentionnée
        (0, $c066b242635c27a6$export$e37953fa8ba80500)(location, navigate, redirectUrl);
    } : null;
    const postState = (0, $8d9ebd8892d8a5f5$export$9158e33c8d0ca687)(submitUrl, $034ce07d723030fb$var$ResolveReject(onSubmit, setErrorMessage, successToastMessage, errorToastMessage, warningToastMessage, redirectFn, isPartialSuccess), isMultipartFormData);
    const putState = (0, $8d9ebd8892d8a5f5$export$f378150f39d4621f)(submitUrl, $034ce07d723030fb$var$ResolveReject(onSubmit, setErrorMessage, successToastMessage, errorToastMessage, warningToastMessage, redirectFn, isPartialSuccess), isMultipartFormData);
    return {
        submitState: isPost ? postState : putState,
        errorMessage: errorMessage
    };
};
const $034ce07d723030fb$var$MyFormik = (props)=>{
    const { submitState: submitState, errorMessage: errorMessage } = $034ce07d723030fb$export$61e814e08207f1c5(props.submitUrl, props.isPost, props.onSubmit, props.redirectUrl, props.isMultipartFormData ?? false, props.isPartialSuccess, props.successToastMessage, props.errorToastMessage, props.warningToastMessage, props.fluid ?? false);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $bkJfK.Formik), {
        innerRef: props.innerRef,
        enableReinitialize: true,
        initialValues: props.initialValues,
        initialStatus: props.initialStatus,
        validationSchema: props.validationSchema,
        onSubmit: (values, { setSubmitting: setSubmitting })=>{
            const variables = props.prepareVariables ? props.prepareVariables(values) : values;
            submitState.run(variables, {
                setSubmitting: setSubmitting
            });
        },
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
                    fluid: props.fluid,
                    children: [
                        errorMessage && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                            className: "text-danger",
                            children: errorMessage
                        }),
                        props.children
                    ]
                }),
                submitState.isPending && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $c21b1c237cfa1d94$export$2e2bcd8739ae039), {})
            ]
        })
    });
};
var $034ce07d723030fb$export$2e2bcd8739ae039 = $034ce07d723030fb$var$MyFormik;




var $bkJfK = parcelRequire("bkJfK");





const $db9b0e6fdb142a4c$var$SubmitFormButtons = ({ returnLink: returnLink, onSecondaryActionClick: onSecondaryActionClick, secondaryActionTitle: secondaryActionTitle, onClick: onClick, disabledValide: disabledValide = false, submitTitle: submitTitle = "Enregistrer", beforeReturn: beforeReturn })=>{
    const formik = (0, $bkJfK.useFormikContext)();
    const navigate = (0, $7a844823b04d4282$export$9770f232ac06a008)();
    const location = (0, $7a844823b04d4282$export$45d76561a5302f2b)();
    //Quand pas de formik/myformik (liste drag et drop), on se base uniquement sur le disableValide
    const isDisabled = formik?.isSubmitting || disabledValide;
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
        className: "my-3 d-flex justify-content-center",
        children: [
            onSecondaryActionClick && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                sm: "auto",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                    variant: "secondary",
                    onClick: onSecondaryActionClick,
                    children: secondaryActionTitle
                })
            }),
            returnLink && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                sm: "auto",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                    variant: "light",
                    className: "btn-light",
                    onClick: ()=>{
                        beforeReturn && beforeReturn();
                        (0, $c066b242635c27a6$export$e37953fa8ba80500)(location, navigate);
                    },
                    children: "Retour"
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                sm: "auto",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                    type: "submit",
                    variant: "primary",
                    onClick: onClick,
                    disabled: isDisabled,
                    children: submitTitle
                })
            })
        ]
    });
};
var $db9b0e6fdb142a4c$export$2e2bcd8739ae039 = $db9b0e6fdb142a4c$var$SubmitFormButtons;












/**
 * Composant Select qui attend un Endpoint renvoyant un objet de type List<IdLibelleData>
 *     pour faire un select avec toutes ces données.
 *
 * @param {Function} onChange - Fonction de rappel pour gérer les changements de sélection.
 * @param {string} name - Nom du composant de sélection.
 * @param {list} listIdCodeLibelle - Liste ayant des objets id-Libellé.
 */ const $cc7cbb0460865818$var$MultiSelectFilterFromList = ({ onChange: onChange, name: name, listIdCodeLibelle: listIdCodeLibelle, value: value })=>{
    const customStyles = {
        control: (provided)=>({
                ...provided,
                width: "100%"
            }),
        menu: (provided)=>({
                ...provided,
                width: "100%"
            })
    };
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ac15ab874ad2390c$export$2e2bcd8739ae039), {
            styles: customStyles,
            isMulti: true,
            placeholder: "S\xe9lectionnez",
            noOptionsMessage: ()=>"Aucune donn\xe9e trouv\xe9e",
            name: name,
            options: listIdCodeLibelle,
            value: value !== "" ? value?.map((e)=>listIdCodeLibelle?.find((r)=>r.id === e)) : [],
            getOptionValue: (t)=>t.id,
            getOptionLabel: (t)=>t.libelle,
            onChange: (data)=>{
                onChange({
                    name: name,
                    value: data.map((e)=>e?.id)
                });
            }
        })
    });
};
var $cc7cbb0460865818$export$2e2bcd8739ae039 = $cc7cbb0460865818$var$MultiSelectFilterFromList;








/**
 * Composant Select qui attend un Endpoint renvoyant un objet de type List<IdLibelleData>
 *     pour faire un select avec toutes ces données.
 *
 * @param {Function} onChange - Fonction de rappel pour gérer les changements de sélection.
 * @param {string} name - Nom du composant de sélection.
 * @param {list} listIdLibelle - Liste ayant des objets id-Libellé.
 * @param {IdCodeLibelleType} value - Value sélectionnée par défaut.
 * @param {string} label - Label du select.
 * @param {boolean} required - Valeur obligatoire ?
 */ const $3744b2a772efdf44$var$SelectFilterFromList = ({ onChange: onChange, name: name, listIdCodeLibelle: listIdCodeLibelle, value: value, disabled: disabled = false, isClearable: isClearable = false })=>{
    const defaultValueTous = {
        id: "",
        code: "",
        libelle: "Tous"
    };
    const data = [
        defaultValueTous
    ].concat(listIdCodeLibelle);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ac15ab874ad2390c$export$2e2bcd8739ae039), {
            styles: (0, $cc51f773cf7126a7$export$2e2bcd8739ae039),
            placeholder: "Tous",
            noOptionsMessage: ()=>"Aucune donn\xe9e trouv\xe9e",
            name: name,
            options: data,
            value: data.find((e)=>e?.id === value),
            getOptionValue: (t)=>t.id,
            getOptionLabel: (t)=>t.libelle,
            onChange: (data)=>{
                onChange({
                    name: name,
                    value: data?.id
                });
            },
            isDisabled: disabled,
            isClearable: isClearable
        })
    });
};
var $3744b2a772efdf44$export$2e2bcd8739ae039 = $3744b2a772efdf44$var$SelectFilterFromList;


/**
 * Composant Select qui attend un Endpoint renvoyant un objet de type List<IdLibelleData>
 *     pour faire un select avec toutes ces données.
 *
 * @param {Function} onChange - Fonction de rappel pour gérer les changements de sélection.
 * @param {string} name - Nom du composant de sélection.
 * @param url
 */ const $dd08a763d100724f$var$SelectFilterFromUrl = ({ onChange: onChange, name: name, url: url, defaultValue: defaultValue, disabled: disabled = false })=>{
    const stateData = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)(url);
    const { isResolved: isResolvedListData, // eslint-disable-next-line no-empty-pattern
    data: listData = {} } = stateData;
    if (!isResolvedListData) return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $c21b1c237cfa1d94$export$2e2bcd8739ae039), {});
    else return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $3744b2a772efdf44$export$2e2bcd8739ae039), {
        name: name,
        listIdCodeLibelle: listData,
        onChange: onChange,
        disabled: disabled,
        value: defaultValue
    });
};
var $dd08a763d100724f$export$2e2bcd8739ae039 = $dd08a763d100724f$var$SelectFilterFromUrl;






/**
 * Composant de sélection pour les nomenclatures.
 *
 * @param {Function} onChange - Fonction de rappel pour gérer les changements de sélection.
 * @param {string} name - Nom du composant de sélection.
 * @param {NOMENCLATURE} nomenclature - La nomenclature voulue
 */ const $bcc3791b22f76942$var$SelectNomenclaturesFilter = ({ onChange: onChange, name: name, nomenclature: nomenclature, value: value })=>{
    const response = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/nomenclatures/list/` + nomenclature);
    return response.data && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $3744b2a772efdf44$export$2e2bcd8739ae039), {
        name: name,
        listIdCodeLibelle: response.data,
        onChange: onChange,
        value: value
    });
};
var $bcc3791b22f76942$export$2e2bcd8739ae039 = $bcc3791b22f76942$var$SelectNomenclaturesFilter;





const $07ae31d99fcf5a0d$var$SelectIdLibelleDataFromList = ({ onChange: onChange, name: name, listIdCodeLibelle: listIdCodeLibelle, value: value })=>{
    const defaultValue = {
        id: undefined,
        code: undefined,
        libelle: "Tous"
    };
    const data = [
        defaultValue
    ].concat((listIdCodeLibelle || []).map((item)=>({
            id: item.id,
            code: item.code ?? item.id,
            libelle: item.libelle
        })));
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ac15ab874ad2390c$export$2e2bcd8739ae039), {
        placeholder: "S\xe9lectionnez",
        noOptionsMessage: ()=>"Aucune donn\xe9e trouv\xe9e",
        name: name,
        options: data,
        value: data.find((e)=>e?.id === value),
        getOptionValue: (t)=>t.id,
        getOptionLabel: (t)=>t.libelle,
        onChange: (selected)=>{
            onChange({
                name: name,
                value: selected?.id
            });
        }
    });
};
var $07ae31d99fcf5a0d$export$2e2bcd8739ae039 = $07ae31d99fcf5a0d$var$SelectIdLibelleDataFromList;



/**
 * @module ol/format/WKT
 */ /**
 * @module ol/Feature
 */ /**
 * @module ol/Object
 */ /**
 * @module ol/ObjectEventType
 */ /**
 * @enum {string}
 */ var $ff212aeaa481a85e$export$2e2bcd8739ae039 /**
 * @typedef {'propertychange'} Types
 */  = {
    /**
   * Triggered when a property is changed.
   * @event module:ol/Object.ObjectEvent#propertychange
   * @api
   */ PROPERTYCHANGE: 'propertychange'
};


/**
 * @module ol/Observable
 */ /**
 * @module ol/events/EventType
 */ /**
 * @enum {string}
 * @const
 */ var $b5fa963342da4935$export$2e2bcd8739ae039 = {
    /**
   * Generic change event. Triggered when the revision counter is increased.
   * @event module:ol/events/Event~BaseEvent#change
   * @api
   */ CHANGE: 'change',
    /**
   * Generic error event. Triggered when an error occurs.
   * @event module:ol/events/Event~BaseEvent#error
   * @api
   */ ERROR: 'error',
    BLUR: 'blur',
    CLEAR: 'clear',
    CONTEXTMENU: 'contextmenu',
    CLICK: 'click',
    DBLCLICK: 'dblclick',
    DRAGENTER: 'dragenter',
    DRAGOVER: 'dragover',
    DROP: 'drop',
    FOCUS: 'focus',
    KEYDOWN: 'keydown',
    KEYPRESS: 'keypress',
    LOAD: 'load',
    RESIZE: 'resize',
    TOUCHMOVE: 'touchmove',
    WHEEL: 'wheel'
};


/**
 * @module ol/events/Target
 */ /**
 * @module ol/Disposable
 */ /**
 * @classdesc
 * Objects that need to clean up after themselves.
 */ class $1f0239b94d40ee35$var$Disposable {
    constructor(){
        /**
     * The object has already been disposed.
     * @type {boolean}
     * @protected
     */ this.disposed = false;
    }
    /**
   * Clean up.
   */ dispose() {
        if (!this.disposed) {
            this.disposed = true;
            this.disposeInternal();
        }
    }
    /**
   * Extension point for disposable objects.
   * @protected
   */ disposeInternal() {}
}
var $1f0239b94d40ee35$export$2e2bcd8739ae039 = $1f0239b94d40ee35$var$Disposable;


/**
 * @module ol/functions
 */ /**
 * @module ol/array
 */ /**
 * Performs a binary search on the provided sorted list and returns the index of the item if found. If it can't be found it'll return -1.
 * https://github.com/darkskyapp/binary-search
 *
 * @param {Array<*>} haystack Items to search through.
 * @param {*} needle The item to look for.
 * @param {Function} [comparator] Comparator function.
 * @return {number} The index of the item if found, -1 if not.
 */ function $49313fcb0fc32abe$export$2e0ae67339d5f1ac(haystack, needle, comparator) {
    let mid, cmp;
    comparator = comparator || $49313fcb0fc32abe$export$fcb633242ef15540;
    let low = 0;
    let high = haystack.length;
    let found = false;
    while(low < high){
        /* Note that "(low + high) >>> 1" may overflow, and results in a typecast
     * to double (which gives the wrong results). */ mid = low + (high - low >> 1);
        cmp = +comparator(haystack[mid], needle);
        if (cmp < 0.0) /* Too low. */ low = mid + 1;
        else {
            /* Key found or too high */ high = mid;
            found = !cmp;
        }
    }
    /* Key not found. */ return found ? low : ~low;
}
function $49313fcb0fc32abe$export$fcb633242ef15540(a, b) {
    return a > b ? 1 : a < b ? -1 : 0;
}
function $49313fcb0fc32abe$export$4fa3190a997c3d8f(a, b) {
    return a < b ? 1 : a > b ? -1 : 0;
}
function $49313fcb0fc32abe$export$8a3786cc03fdb777(arr, target, direction) {
    if (arr[0] <= target) return 0;
    const n = arr.length;
    if (target <= arr[n - 1]) return n - 1;
    if (typeof direction === 'function') {
        for(let i = 1; i < n; ++i){
            const candidate = arr[i];
            if (candidate === target) return i;
            if (candidate < target) {
                if (direction(target, arr[i - 1], candidate) > 0) return i - 1;
                return i;
            }
        }
        return n - 1;
    }
    if (direction > 0) {
        for(let i = 1; i < n; ++i){
            if (arr[i] < target) return i - 1;
        }
        return n - 1;
    }
    if (direction < 0) {
        for(let i = 1; i < n; ++i){
            if (arr[i] <= target) return i;
        }
        return n - 1;
    }
    for(let i = 1; i < n; ++i){
        if (arr[i] == target) return i;
        if (arr[i] < target) {
            if (arr[i - 1] - target < target - arr[i]) return i - 1;
            return i;
        }
    }
    return n - 1;
}
function $49313fcb0fc32abe$export$292cfa960964f0e0(arr, begin, end) {
    while(begin < end){
        const tmp = arr[begin];
        arr[begin] = arr[end];
        arr[end] = tmp;
        ++begin;
        --end;
    }
}
function $49313fcb0fc32abe$export$8b58be045bf06082(arr, data) {
    const extension = Array.isArray(data) ? data : [
        data
    ];
    const length = extension.length;
    for(let i = 0; i < length; i++)arr[arr.length] = extension[i];
}
function $49313fcb0fc32abe$export$cd7f480d6b8286c3(arr, obj) {
    const i = arr.indexOf(obj);
    const found = i > -1;
    if (found) arr.splice(i, 1);
    return found;
}
function $49313fcb0fc32abe$export$e9bab7fafb253603(arr1, arr2) {
    const len1 = arr1.length;
    if (len1 !== arr2.length) return false;
    for(let i = 0; i < len1; i++){
        if (arr1[i] !== arr2[i]) return false;
    }
    return true;
}
function $49313fcb0fc32abe$export$c7d3d1f96a700512(arr, compareFnc) {
    const length = arr.length;
    const tmp = Array(arr.length);
    let i;
    for(i = 0; i < length; i++)tmp[i] = {
        index: i,
        value: arr[i]
    };
    tmp.sort(function(a, b) {
        return compareFnc(a.value, b.value) || a.index - b.index;
    });
    for(i = 0; i < arr.length; i++)arr[i] = tmp[i].value;
}
function $49313fcb0fc32abe$export$efa610630f9e181(arr, func, strict) {
    const compare = func || $49313fcb0fc32abe$export$fcb633242ef15540;
    return arr.every(function(currentVal, index) {
        if (index === 0) return true;
        const res = compare(arr[index - 1], currentVal);
        return !(res > 0 || strict && res === 0);
    });
}


function $bc15bca7780ad95b$export$22e23a2304399231() {
    return true;
}
function $bc15bca7780ad95b$export$8f11cee4bdc7e668() {
    return false;
}
function $bc15bca7780ad95b$export$1cd1943b3a73bbe8() {}
function $bc15bca7780ad95b$export$ff83df6f9971435f(fn) {
    /** @type {ReturnType} */ let lastResult;
    /** @type {Array<any>|undefined} */ let lastArgs;
    let lastThis;
    /**
   * @this {*} Only need to know if `this` changed, don't care what type
   * @return {ReturnType} Memoized value
   */ return function() {
        const nextArgs = Array.prototype.slice.call(arguments);
        if (!lastArgs || this !== lastThis || !(0, $49313fcb0fc32abe$export$e9bab7fafb253603)(nextArgs, lastArgs)) {
            lastThis = this;
            lastArgs = nextArgs;
            lastResult = fn.apply(this, arguments);
        }
        return lastResult;
    };
}
function $bc15bca7780ad95b$export$4dbaaf6c79705e6c(getter) {
    function promiseGetter() {
        let value;
        try {
            value = getter();
        } catch (err) {
            return Promise.reject(err);
        }
        if (value instanceof Promise) return value;
        return Promise.resolve(value);
    }
    return promiseGetter();
}



/**
 * @module ol/events/Event
 */ /**
 * @classdesc
 * Stripped down implementation of the W3C DOM Level 2 Event interface.
 * See https://www.w3.org/TR/DOM-Level-2-Events/events.html#Events-interface.
 *
 * This implementation only provides `type` and `target` properties, and
 * `stopPropagation` and `preventDefault` methods. It is meant as base class
 * for higher level events defined in the library, and works with
 * {@link module:ol/events/Target~Target}.
 */ class $5c6b0a43c077a98f$var$BaseEvent {
    /**
   * @param {string} type Type.
   */ constructor(type){
        /**
     * @type {boolean}
     */ this.propagationStopped;
        /**
     * @type {boolean}
     */ this.defaultPrevented;
        /**
     * The event type.
     * @type {string}
     * @api
     */ this.type = type;
        /**
     * The event target.
     * @type {Object}
     * @api
     */ this.target = null;
    }
    /**
   * Prevent default. This means that no emulated `click`, `singleclick` or `doubleclick` events
   * will be fired.
   * @api
   */ preventDefault() {
        this.defaultPrevented = true;
    }
    /**
   * Stop event propagation.
   * @api
   */ stopPropagation() {
        this.propagationStopped = true;
    }
}
function $5c6b0a43c077a98f$export$51134cce184326b9(evt) {
    evt.stopPropagation();
}
function $5c6b0a43c077a98f$export$fa3b29edae795ef4(evt) {
    evt.preventDefault();
}
var $5c6b0a43c077a98f$export$2e2bcd8739ae039 = $5c6b0a43c077a98f$var$BaseEvent;


/**
 * @typedef {EventTarget|Target} EventTargetLike
 */ /**
 * @classdesc
 * A simplified implementation of the W3C DOM Level 2 EventTarget interface.
 * See https://www.w3.org/TR/2000/REC-DOM-Level-2-Events-20001113/events.html#Events-EventTarget.
 *
 * There are two important simplifications compared to the specification:
 *
 * 1. The handling of `useCapture` in `addEventListener` and
 *    `removeEventListener`. There is no real capture model.
 * 2. The handling of `stopPropagation` and `preventDefault` on `dispatchEvent`.
 *    There is no event target hierarchy. When a listener calls
 *    `stopPropagation` or `preventDefault` on an event object, it means that no
 *    more listeners after this one will be called. Same as when the listener
 *    returns false.
 */ class $272b64a21016b61a$var$Target extends (0, $1f0239b94d40ee35$export$2e2bcd8739ae039) {
    /**
   * @param {*} [target] Default event target for dispatched events.
   */ constructor(target){
        super();
        /**
     * @private
     * @type {*}
     */ this.eventTarget_ = target;
        /**
     * @private
     * @type {Object<string, number>|null}
     */ this.pendingRemovals_ = null;
        /**
     * @private
     * @type {Object<string, number>|null}
     */ this.dispatching_ = null;
        /**
     * @private
     * @type {Object<string, Array<import("../events.js").Listener>>|null}
     */ this.listeners_ = null;
    }
    /**
   * @param {string} type Type.
   * @param {import("../events.js").Listener} listener Listener.
   */ addEventListener(type, listener) {
        if (!type || !listener) return;
        const listeners = this.listeners_ || (this.listeners_ = {});
        const listenersForType = listeners[type] || (listeners[type] = []);
        if (!listenersForType.includes(listener)) listenersForType.push(listener);
    }
    /**
   * Dispatches an event and calls all listeners listening for events
   * of this type. The event parameter can either be a string or an
   * Object with a `type` property.
   *
   * @param {import("./Event.js").default|string} event Event object.
   * @return {boolean|undefined} `false` if anyone called preventDefault on the
   *     event object or if any of the listeners returned false.
   * @api
   */ dispatchEvent(event) {
        const isString = typeof event === 'string';
        const type = isString ? event : event.type;
        const listeners = this.listeners_ && this.listeners_[type];
        if (!listeners) return;
        const evt = isString ? new (0, $5c6b0a43c077a98f$export$2e2bcd8739ae039)(event) : /** @type {Event} */ event;
        if (!evt.target) evt.target = this.eventTarget_ || this;
        const dispatching = this.dispatching_ || (this.dispatching_ = {});
        const pendingRemovals = this.pendingRemovals_ || (this.pendingRemovals_ = {});
        if (!(type in dispatching)) {
            dispatching[type] = 0;
            pendingRemovals[type] = 0;
        }
        ++dispatching[type];
        let propagate;
        for(let i = 0, ii = listeners.length; i < ii; ++i){
            if ('handleEvent' in listeners[i]) propagate = /** @type {import("../events.js").ListenerObject} */ listeners[i].handleEvent(evt);
            else propagate = /** @type {import("../events.js").ListenerFunction} */ listeners[i].call(this, evt);
            if (propagate === false || evt.propagationStopped) {
                propagate = false;
                break;
            }
        }
        if (--dispatching[type] === 0) {
            let pr = pendingRemovals[type];
            delete pendingRemovals[type];
            while(pr--)this.removeEventListener(type, (0, $bc15bca7780ad95b$export$1cd1943b3a73bbe8));
            delete dispatching[type];
        }
        return propagate;
    }
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        this.listeners_ && (0, $9f2b61a1df00e9b3$export$42ffd38884aecdac)(this.listeners_);
    }
    /**
   * Get the listeners for a specified event type. Listeners are returned in the
   * order that they will be called in.
   *
   * @param {string} type Type.
   * @return {Array<import("../events.js").Listener>|undefined} Listeners.
   */ getListeners(type) {
        return this.listeners_ && this.listeners_[type] || undefined;
    }
    /**
   * @param {string} [type] Type. If not provided,
   *     `true` will be returned if this event target has any listeners.
   * @return {boolean} Has listeners.
   */ hasListener(type) {
        if (!this.listeners_) return false;
        return type ? type in this.listeners_ : Object.keys(this.listeners_).length > 0;
    }
    /**
   * @param {string} type Type.
   * @param {import("../events.js").Listener} listener Listener.
   */ removeEventListener(type, listener) {
        if (!this.listeners_) return;
        const listeners = this.listeners_[type];
        if (!listeners) return;
        const index = listeners.indexOf(listener);
        if (index !== -1) {
            if (this.pendingRemovals_ && type in this.pendingRemovals_) {
                // make listener a no-op, and remove later in #dispatchEvent()
                listeners[index] = (0, $bc15bca7780ad95b$export$1cd1943b3a73bbe8);
                ++this.pendingRemovals_[type];
            } else {
                listeners.splice(index, 1);
                if (listeners.length === 0) delete this.listeners_[type];
            }
        }
    }
}
var $272b64a21016b61a$export$2e2bcd8739ae039 = $272b64a21016b61a$var$Target;


/**
 * @module ol/events
 */ 
function $63963d09e0c49405$export$63174c828edd6ff8(target, type, listener, thisArg, once) {
    if (once) {
        const originalListener = listener;
        /**
     * @param {Event|import('./events/Event.js').default} event The event
     * @return {void|boolean} When the function returns `false`, event propagation will stop.
     * @this {typeof target}
     */ listener = function(event) {
            target.removeEventListener(type, listener);
            return originalListener.call(thisArg ?? this, event);
        };
    } else if (thisArg && thisArg !== target) listener = listener.bind(thisArg);
    const eventsKey = {
        target: target,
        type: type,
        listener: listener
    };
    target.addEventListener(type, listener);
    return eventsKey;
}
function $63963d09e0c49405$export$8d2a95bc11b44725(target, type, listener, thisArg) {
    return $63963d09e0c49405$export$63174c828edd6ff8(target, type, listener, thisArg, true);
}
function $63963d09e0c49405$export$b0a21c8b3c1c921(key) {
    if (key && key.target) {
        key.target.removeEventListener(key.type, key.listener);
        (0, $9f2b61a1df00e9b3$export$42ffd38884aecdac)(key);
    }
}


/***
 * @template {string} Type
 * @template {Event|import("./events/Event.js").default} EventClass
 * @template Return
 * @typedef {(type: Type, listener: (event: EventClass) => ?) => Return} OnSignature
 */ /***
 * @template {string} Type
 * @template Return
 * @typedef {(type: Type[], listener: (event: Event|import("./events/Event").default) => ?) => Return extends void ? void : Return[]} CombinedOnSignature
 */ /**
 * @typedef {'change'|'error'} EventTypes
 */ /***
 * @template Return
 * @typedef {OnSignature<EventTypes, import("./events/Event.js").default, Return> & CombinedOnSignature<EventTypes, Return>} ObservableOnSignature
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * An event target providing convenient methods for listener registration
 * and unregistration. A generic `change` event is always available through
 * {@link module:ol/Observable~Observable#changed}.
 *
 * @fires import("./events/Event.js").default
 * @api
 */ class $a8e855f7c93fe402$var$Observable extends (0, $272b64a21016b61a$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.on = /** @type {ObservableOnSignature<import("./events").EventsKey>} */ this.onInternal;
        this.once = /** @type {ObservableOnSignature<import("./events").EventsKey>} */ this.onceInternal;
        this.un = /** @type {ObservableOnSignature<void>} */ this.unInternal;
        /**
     * @private
     * @type {number}
     */ this.revision_ = 0;
    }
    /**
   * Increases the revision counter and dispatches a 'change' event.
   * @api
   */ changed() {
        ++this.revision_;
        this.dispatchEvent((0, $b5fa963342da4935$export$2e2bcd8739ae039).CHANGE);
    }
    /**
   * Get the version number for this object.  Each time the object is modified,
   * its version number will be incremented.
   * @return {number} Revision.
   * @api
   */ getRevision() {
        return this.revision_;
    }
    /**
   * @param {string|Array<string>} type Type.
   * @param {function((Event|import("./events/Event").default)): ?} listener Listener.
   * @return {import("./events.js").EventsKey|Array<import("./events.js").EventsKey>} Event key.
   * @protected
   */ onInternal(type, listener) {
        if (Array.isArray(type)) {
            const len = type.length;
            const keys = new Array(len);
            for(let i = 0; i < len; ++i)keys[i] = (0, $63963d09e0c49405$export$63174c828edd6ff8)(this, type[i], listener);
            return keys;
        }
        return (0, $63963d09e0c49405$export$63174c828edd6ff8)(this, /** @type {string} */ type, listener);
    }
    /**
   * @param {string|Array<string>} type Type.
   * @param {function((Event|import("./events/Event").default)): ?} listener Listener.
   * @return {import("./events.js").EventsKey|Array<import("./events.js").EventsKey>} Event key.
   * @protected
   */ onceInternal(type, listener) {
        let key;
        if (Array.isArray(type)) {
            const len = type.length;
            key = new Array(len);
            for(let i = 0; i < len; ++i)key[i] = (0, $63963d09e0c49405$export$8d2a95bc11b44725)(this, type[i], listener);
        } else key = (0, $63963d09e0c49405$export$8d2a95bc11b44725)(this, /** @type {string} */ type, listener);
        /** @type {Object} */ listener.ol_key = key;
        return key;
    }
    /**
   * Unlisten for a certain type of event.
   * @param {string|Array<string>} type Type.
   * @param {function((Event|import("./events/Event").default)): ?} listener Listener.
   * @protected
   */ unInternal(type, listener) {
        const key = /** @type {Object} */ listener.ol_key;
        if (key) $a8e855f7c93fe402$export$b7ef3f8527533384(key);
        else if (Array.isArray(type)) for(let i = 0, ii = type.length; i < ii; ++i)this.removeEventListener(type[i], listener);
        else this.removeEventListener(type, listener);
    }
}
/**
 * Listen for a certain type of event.
 * @function
 * @param {string|Array<string>} type The event type or array of event types.
 * @param {function((Event|import("./events/Event").default)): ?} listener The listener function.
 * @return {import("./events.js").EventsKey|Array<import("./events.js").EventsKey>} Unique key for the listener. If
 *     called with an array of event types as the first argument, the return
 *     will be an array of keys.
 * @api
 */ $a8e855f7c93fe402$var$Observable.prototype.on;
/**
 * Listen once for a certain type of event.
 * @function
 * @param {string|Array<string>} type The event type or array of event types.
 * @param {function((Event|import("./events/Event").default)): ?} listener The listener function.
 * @return {import("./events.js").EventsKey|Array<import("./events.js").EventsKey>} Unique key for the listener. If
 *     called with an array of event types as the first argument, the return
 *     will be an array of keys.
 * @api
 */ $a8e855f7c93fe402$var$Observable.prototype.once;
/**
 * Unlisten for a certain type of event.
 * @function
 * @param {string|Array<string>} type The event type or array of event types.
 * @param {function((Event|import("./events/Event").default)): ?} listener The listener function.
 * @api
 */ $a8e855f7c93fe402$var$Observable.prototype.un;
function $a8e855f7c93fe402$export$b7ef3f8527533384(key) {
    if (Array.isArray(key)) for(let i = 0, ii = key.length; i < ii; ++i)(0, $63963d09e0c49405$export$b0a21c8b3c1c921)(key[i]);
    else (0, $63963d09e0c49405$export$b0a21c8b3c1c921)(/** @type {import("./events.js").EventsKey} */ key);
}
var $a8e855f7c93fe402$export$2e2bcd8739ae039 = $a8e855f7c93fe402$var$Observable;




/**
 * @module ol/util
 */ /**
 * @return {never} Any return.
 */ function $fd76d391cc228565$export$817eb92a8194bab0() {
    throw new Error('Unimplemented abstract method.');
}
/**
 * Counter for getUid.
 * @type {number}
 * @private
 */ let $fd76d391cc228565$var$uidCounter_ = 0;
function $fd76d391cc228565$export$5e82334337e0f204(obj) {
    return obj.ol_uid || (obj.ol_uid = String(++$fd76d391cc228565$var$uidCounter_));
}
const $fd76d391cc228565$export$a4ad2735b021c132 = '10.8.0';


class $4862cdcc23257f5b$export$cf395d7c4a2d5a17 extends (0, $5c6b0a43c077a98f$export$2e2bcd8739ae039) {
    /**
   * @param {string} type The event type.
   * @param {string} key The property name.
   * @param {*} oldValue The old value for `key`.
   */ constructor(type, key, oldValue){
        super(type);
        /**
     * The name of the property whose value is changing.
     * @type {string}
     * @api
     */ this.key = key;
        /**
     * The old value. To get the new value use `e.target.get(e.key)` where
     * `e` is the event object.
     * @type {*}
     * @api
     */ this.oldValue = oldValue;
    }
}
/***
 * @template Return
 * @typedef {import("./Observable").OnSignature<import("./Observable").EventTypes, import("./events/Event.js").default, Return> &
 *    import("./Observable").OnSignature<import("./ObjectEventType").Types, ObjectEvent, Return> &
 *    import("./Observable").CombinedOnSignature<import("./Observable").EventTypes|import("./ObjectEventType").Types, Return>} ObjectOnSignature
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Most non-trivial classes inherit from this.
 *
 * This extends {@link module:ol/Observable~Observable} with observable
 * properties, where each property is observable as well as the object as a
 * whole.
 *
 * Classes that inherit from this have pre-defined properties, to which you can
 * add your owns. The pre-defined properties are listed in this documentation as
 * 'Observable Properties', and have their own accessors; for example,
 * {@link module:ol/Map~Map} has a `target` property, accessed with
 * `getTarget()` and changed with `setTarget()`. Not all properties are however
 * settable. There are also general-purpose accessors `get()` and `set()`. For
 * example, `get('target')` is equivalent to `getTarget()`.
 *
 * The `set` accessors trigger a change event, and you can monitor this by
 * registering a listener. For example, {@link module:ol/View~View} has a
 * `center` property, so `view.on('change:center', function(evt) {...});` would
 * call the function whenever the value of the center property changes. Within
 * the function, `evt.target` would be the view, so `evt.target.getCenter()`
 * would return the new center.
 *
 * You can add your own observable properties with
 * `object.set('prop', 'value')`, and retrieve that with `object.get('prop')`.
 * You can listen for changes on that property value with
 * `object.on('change:prop', listener)`. You can get a list of all
 * properties with {@link module:ol/Object~BaseObject#getProperties}.
 *
 * Note that the observable properties are separate from standard JS properties.
 * You can, for example, give your map object a title with
 * `map.title='New title'` and with `map.set('title', 'Another title')`. The
 * first will be a `hasOwnProperty`; the second will appear in
 * `getProperties()`. Only the second is observable.
 *
 * Properties can be deleted by using the unset method. E.g.
 * object.unset('foo').
 *
 * @fires ObjectEvent
 * @template {Object<string, *>} [Properties=Object<string, *>]
 * @api
 */ class $4862cdcc23257f5b$var$BaseObject extends (0, $a8e855f7c93fe402$export$2e2bcd8739ae039) {
    /**
   * @param {NoInfer<Properties>} [values] An object with key-value pairs.
   */ constructor(values){
        super();
        /***
     * @type {ObjectOnSignature<import("./events").EventsKey>}
     */ this.on;
        /***
     * @type {ObjectOnSignature<import("./events").EventsKey>}
     */ this.once;
        /***
     * @type {ObjectOnSignature<void>}
     */ this.un;
        // Call {@link module:ol/util.getUid} to ensure that the order of objects' ids is
        // the same as the order in which they were created.  This also helps to
        // ensure that object properties are always added in the same order, which
        // helps many JavaScript engines generate faster code.
        (0, $fd76d391cc228565$export$5e82334337e0f204)(this);
        /**
     * @private
     * @type {Partial<NoInfer<Properties>>|null}
     */ this.values_ = null;
        if (values !== undefined) this.setProperties(values);
    }
    /**
   * Gets a value.
   * @param {string} key Key name.
   * @return {*} Value.
   * @api
   */ get(key) {
        let value;
        if (this.values_ && this.values_.hasOwnProperty(key)) value = this.values_[key];
        return value;
    }
    /**
   * Get a list of object property names.
   * @return {Array<string>} List of property names.
   * @api
   */ getKeys() {
        return this.values_ && Object.keys(this.values_) || [];
    }
    /**
   * Get an object of all property names and values.
   * @return {NoInfer<Properties>} Object.
   * @api
   */ getProperties() {
        return /** @type {NoInfer<Properties>} */ this.values_ && Object.assign({}, this.values_) || {};
    }
    /**
   * Get an object of all property names and values.
   * @return {Partial<NoInfer<Properties>>?} Object.
   */ getPropertiesInternal() {
        return this.values_;
    }
    /**
   * @return {boolean} The object has properties.
   */ hasProperties() {
        return !!this.values_;
    }
    /**
   * @param {string} key Key name.
   * @param {*} oldValue Old value.
   */ notify(key, oldValue) {
        let eventType;
        eventType = `change:${key}`;
        if (this.hasListener(eventType)) this.dispatchEvent(new $4862cdcc23257f5b$export$cf395d7c4a2d5a17(eventType, key, oldValue));
        eventType = (0, $ff212aeaa481a85e$export$2e2bcd8739ae039).PROPERTYCHANGE;
        if (this.hasListener(eventType)) this.dispatchEvent(new $4862cdcc23257f5b$export$cf395d7c4a2d5a17(eventType, key, oldValue));
    }
    /**
   * @param {string} key Key name.
   * @param {import("./events.js").Listener} listener Listener.
   */ addChangeListener(key, listener) {
        this.addEventListener(`change:${key}`, listener);
    }
    /**
   * @param {string} key Key name.
   * @param {import("./events.js").Listener} listener Listener.
   */ removeChangeListener(key, listener) {
        this.removeEventListener(`change:${key}`, listener);
    }
    /**
   * Sets a value.
   * @param {string} key Key name.
   * @param {*} value Value.
   * @param {boolean} [silent] Update without triggering an event.
   * @api
   */ set(key, value, silent) {
        const values = this.values_ || (this.values_ = {});
        if (silent) values[key] = value;
        else {
            const oldValue = values[key];
            values[key] = value;
            if (oldValue !== value) this.notify(key, oldValue);
        }
    }
    /**
   * Sets a collection of key-value pairs.  Note that this changes any existing
   * properties and adds new ones (it does not remove any existing properties).
   * @param {Partial<NoInfer<Properties>>} values Values.
   * @param {boolean} [silent] Update without triggering an event.
   * @api
   */ setProperties(values, silent) {
        for(const key in values)this.set(key, values[key], silent);
    }
    /**
   * Apply any properties from another object without triggering events.
   * @param {BaseObject} source The source object.
   * @protected
   */ applyProperties(source) {
        if (!source.values_) return;
        Object.assign(this.values_ || (this.values_ = {}), source.values_);
    }
    /**
   * Unsets a property.
   * @param {string} key Key name.
   * @param {boolean} [silent] Unset without triggering an event.
   * @api
   */ unset(key, silent) {
        if (this.values_ && key in this.values_) {
            const oldValue = this.values_[key];
            delete this.values_[key];
            if ((0, $9f2b61a1df00e9b3$export$dd1bc94b04021eeb)(this.values_)) this.values_ = null;
            if (!silent) this.notify(key, oldValue);
        }
    }
}
var $4862cdcc23257f5b$export$2e2bcd8739ae039 = $4862cdcc23257f5b$var$BaseObject;


/**
 * @module ol/asserts
 */ /**
 * @param {*} assertion Assertion we expected to be truthy.
 * @param {string} errorMessage Error message.
 */ function $71eb897bda873684$export$a7a9523472993e97(assertion, errorMessage) {
    if (!assertion) throw new Error(errorMessage);
}




/**
 * @typedef {typeof Feature|typeof import("./render/Feature.js").default} FeatureClass
 */ /**
 * @typedef {Feature|import("./render/Feature.js").default} FeatureLike
 */ /***
 * @template Return
 * @typedef {import("./Observable").OnSignature<import("./Observable").EventTypes, import("./events/Event.js").default, Return> &
 *   import("./Observable").OnSignature<import("./ObjectEventType").Types|'change:geometry', import("./Object").ObjectEvent, Return> &
 *   import("./Observable").CombinedOnSignature<import("./Observable").EventTypes|import("./ObjectEventType").Types
 *     |'change:geometry', Return>} FeatureOnSignature
 */ /***
 * @template {import("./geom/Geometry.js").default} [Geometry=import("./geom/Geometry.js").default]
 * @template {Object<string, *>} [Properties=Object<string, *>]
 * @typedef {Properties & { geometry?: Geometry }} ObjectWithGeometry
 */ /**
 * @classdesc
 * A vector object for geographic features with a geometry and other
 * attribute properties, similar to the features in vector file formats like
 * GeoJSON.
 *
 * Features can be styled individually with `setStyle`; otherwise they use the
 * style of their vector layer.
 *
 * Note that attribute properties are set as {@link module:ol/Object~BaseObject} properties on
 * the feature object, so they are observable, and have get/set accessors.
 *
 * Typically, a feature has a single geometry property. You can set the
 * geometry using the `setGeometry` method and get it with `getGeometry`.
 * It is possible to store more than one geometry on a feature using attribute
 * properties. By default, the geometry used for rendering is identified by
 * the property name `geometry`. If you want to use another geometry property
 * for rendering, use the `setGeometryName` method to change the attribute
 * property associated with the geometry for the feature.  For example:
 *
 * ```js
 *
 * import Feature from 'ol/Feature.js';
 * import Polygon from 'ol/geom/Polygon.js';
 * import Point from 'ol/geom/Point.js';
 *
 * const feature = new Feature({
 *   geometry: new Polygon(polyCoords),
 *   labelPoint: new Point(labelCoords),
 *   name: 'My Polygon',
 * });
 *
 * // get the polygon geometry
 * const poly = feature.getGeometry();
 *
 * // Render the feature as a point using the coordinates from labelPoint
 * feature.setGeometryName('labelPoint');
 *
 * // get the point geometry
 * const point = feature.getGeometry();
 * ```
 *
 * @api
 * @template {import("./geom/Geometry.js").default} [Geometry=import("./geom/Geometry.js").default]
 * @template {Object<string, *>} [Properties=Object<string, *>]
 * @extends {BaseObject<NoInfer<Properties>>}
 */ class $df26d2327ced1fa9$var$Feature extends (0, $4862cdcc23257f5b$export$2e2bcd8739ae039) {
    /**
   * @param {Geometry|ObjectWithGeometry<Geometry, NoInfer<Properties>>} [geometryOrProperties]
   *     You may pass a Geometry object directly, or an object literal containing
   *     properties. If you pass an object literal, you may include a Geometry
   *     associated with a `geometry` key.
   */ constructor(geometryOrProperties){
        super();
        /***
     * @type {FeatureOnSignature<import("./events").EventsKey>}
     */ this.on;
        /***
     * @type {FeatureOnSignature<import("./events").EventsKey>}
     */ this.once;
        /***
     * @type {FeatureOnSignature<void>}
     */ this.un;
        /**
     * @private
     * @type {number|string|undefined}
     */ this.id_ = undefined;
        /**
     * @type {string}
     * @private
     */ this.geometryName_ = 'geometry';
        /**
     * User provided style.
     * @private
     * @type {import("./style/Style.js").StyleLike}
     */ this.style_ = null;
        /**
     * @private
     * @type {import("./style/Style.js").StyleFunction|undefined}
     */ this.styleFunction_ = undefined;
        /**
     * @private
     * @type {?import("./events.js").EventsKey}
     */ this.geometryChangeKey_ = null;
        this.addChangeListener(this.geometryName_, this.handleGeometryChanged_);
        if (geometryOrProperties) {
            if (typeof /** @type {?} */ geometryOrProperties.getSimplifiedGeometry === 'function') {
                const geometry = /** @type {Geometry} */ geometryOrProperties;
                this.setGeometry(geometry);
            } else {
                /** @type {?} */ const properties = geometryOrProperties;
                this.setProperties(properties);
            }
        }
    }
    /**
   * Clone this feature. If the original feature has a geometry it
   * is also cloned. The feature id is not set in the clone.
   * @return {Feature<Geometry>} The clone.
   * @api
   */ clone() {
        const clone = /** @type {Feature<Geometry>} */ new $df26d2327ced1fa9$var$Feature(this.hasProperties() ? this.getProperties() : null);
        clone.setGeometryName(this.getGeometryName());
        const geometry = this.getGeometry();
        if (geometry) clone.setGeometry(/** @type {Geometry} */ geometry.clone());
        const style = this.getStyle();
        if (style) clone.setStyle(style);
        return clone;
    }
    /**
   * Get the feature's default geometry.  A feature may have any number of named
   * geometries.  The "default" geometry (the one that is rendered by default) is
   * set when calling {@link module:ol/Feature~Feature#setGeometry}.
   * @return {Geometry|undefined} The default geometry for the feature.
   * @api
   * @observable
   */ getGeometry() {
        return /** @type {Geometry|undefined} */ this.get(this.geometryName_);
    }
    /**
   * Get the feature identifier.  This is a stable identifier for the feature and
   * is either set when reading data from a remote source or set explicitly by
   * calling {@link module:ol/Feature~Feature#setId}.
   * @return {number|string|undefined} Id.
   * @api
   */ getId() {
        return this.id_;
    }
    /**
   * Get the name of the feature's default geometry.  By default, the default
   * geometry is named `geometry`.
   * @return {string} Get the property name associated with the default geometry
   *     for this feature.
   * @api
   */ getGeometryName() {
        return this.geometryName_;
    }
    /**
   * Get the feature's style. Will return what was provided to the
   * {@link module:ol/Feature~Feature#setStyle} method.
   * @return {import("./style/Style.js").StyleLike|undefined} The feature style.
   * @api
   */ getStyle() {
        return this.style_;
    }
    /**
   * Get the feature's style function.
   * @return {import("./style/Style.js").StyleFunction|undefined} Return a function
   * representing the current style of this feature.
   * @api
   */ getStyleFunction() {
        return this.styleFunction_;
    }
    /**
   * @private
   */ handleGeometryChange_() {
        this.changed();
    }
    /**
   * @private
   */ handleGeometryChanged_() {
        if (this.geometryChangeKey_) {
            (0, $63963d09e0c49405$export$b0a21c8b3c1c921)(this.geometryChangeKey_);
            this.geometryChangeKey_ = null;
        }
        const geometry = this.getGeometry();
        if (geometry) this.geometryChangeKey_ = (0, $63963d09e0c49405$export$63174c828edd6ff8)(geometry, (0, $b5fa963342da4935$export$2e2bcd8739ae039).CHANGE, this.handleGeometryChange_, this);
        this.changed();
    }
    /**
   * Set the default geometry for the feature.  This will update the property
   * with the name returned by {@link module:ol/Feature~Feature#getGeometryName}.
   * @param {Geometry|undefined} geometry The new geometry.
   * @api
   * @observable
   */ setGeometry(geometry) {
        this.set(this.geometryName_, geometry);
    }
    /**
   * Set the style for the feature to override the layer style.  This can be a
   * single style object, an array of styles, or a function that takes a
   * resolution and returns an array of styles. To unset the feature style, call
   * `setStyle()` without arguments or a falsey value.
   * @param {import("./style/Style.js").StyleLike} [style] Style for this feature.
   * @api
   * @fires module:ol/events/Event~BaseEvent#event:change
   */ setStyle(style) {
        this.style_ = style;
        this.styleFunction_ = !style ? undefined : $df26d2327ced1fa9$export$bb06ddfd5d66e02e(style);
        this.changed();
    }
    /**
   * Set the feature id.  The feature id is considered stable and may be used when
   * requesting features or comparing identifiers returned from a remote source.
   * The feature id can be used with the
   * {@link module:ol/source/Vector~VectorSource#getFeatureById} method.
   * @param {number|string|undefined} id The feature id.
   * @api
   * @fires module:ol/events/Event~BaseEvent#event:change
   */ setId(id) {
        this.id_ = id;
        this.changed();
    }
    /**
   * Set the property name to be used when getting the feature's default geometry.
   * When calling {@link module:ol/Feature~Feature#getGeometry}, the value of the property with
   * this name will be returned.
   * @param {string} name The property name of the default geometry.
   * @api
   */ setGeometryName(name) {
        this.removeChangeListener(this.geometryName_, this.handleGeometryChanged_);
        this.geometryName_ = name;
        this.addChangeListener(this.geometryName_, this.handleGeometryChanged_);
        this.handleGeometryChanged_();
    }
}
function $df26d2327ced1fa9$export$bb06ddfd5d66e02e(obj) {
    if (typeof obj === 'function') return obj;
    /**
   * @type {Array<import("./style/Style.js").default>}
   */ let styles;
    if (Array.isArray(obj)) styles = obj;
    else {
        (0, $71eb897bda873684$export$a7a9523472993e97)(typeof /** @type {?} */ obj.getZIndex === 'function', 'Expected an `ol/style/Style` or an array of `ol/style/Style.js`');
        const style = /** @type {import("./style/Style.js").default} */ obj;
        styles = [
            style
        ];
    }
    return function() {
        return styles;
    };
}
var $df26d2327ced1fa9$export$2e2bcd8739ae039 = $df26d2327ced1fa9$var$Feature;


/**
 * @module ol/geom/GeometryCollection
 */ 


/**
 * @module ol/geom/Geometry
 */ 



/**
 * @module ol/transform
 */ 
/**
 * An array representing an affine 2d transformation for use with
 * {@link module:ol/transform} functions. The array has 6 elements.
 * @typedef {!Array<number>} Transform
 * @api
 */ /**
 * Collection of affine 2d transformation functions. The functions work on an
 * array of 6 elements. The element order is compatible with the [SVGMatrix
 * interface](https://developer.mozilla.org/en-US/docs/Web/API/SVGMatrix) and is
 * a subset (elements a to f) of a 3×3 matrix:
 * ```
 * [ a c e ]
 * [ b d f ]
 * [ 0 0 1 ]
 * ```
 */ /**
 * @private
 * @type {Transform}
 */ const $dff5a03e015694d8$var$tmp_ = new Array(6);
function $dff5a03e015694d8$export$185802fd694ee1f5() {
    return [
        1,
        0,
        0,
        1,
        0,
        0
    ];
}
function $dff5a03e015694d8$export$aad8462122ac592b(transform) {
    return $dff5a03e015694d8$export$adaa4cf7ef1b65be(transform, 1, 0, 0, 1, 0, 0);
}
function $dff5a03e015694d8$export$2060d2db72cce88f(transform1, transform2) {
    const a1 = transform1[0];
    const b1 = transform1[1];
    const c1 = transform1[2];
    const d1 = transform1[3];
    const e1 = transform1[4];
    const f1 = transform1[5];
    const a2 = transform2[0];
    const b2 = transform2[1];
    const c2 = transform2[2];
    const d2 = transform2[3];
    const e2 = transform2[4];
    const f2 = transform2[5];
    transform1[0] = a1 * a2 + c1 * b2;
    transform1[1] = b1 * a2 + d1 * b2;
    transform1[2] = a1 * c2 + c1 * d2;
    transform1[3] = b1 * c2 + d1 * d2;
    transform1[4] = a1 * e2 + c1 * f2 + e1;
    transform1[5] = b1 * e2 + d1 * f2 + f1;
    return transform1;
}
function $dff5a03e015694d8$export$adaa4cf7ef1b65be(transform, a, b, c, d, e, f) {
    transform[0] = a;
    transform[1] = b;
    transform[2] = c;
    transform[3] = d;
    transform[4] = e;
    transform[5] = f;
    return transform;
}
function $dff5a03e015694d8$export$42b4187a82d80ed0(transform1, transform2) {
    transform1[0] = transform2[0];
    transform1[1] = transform2[1];
    transform1[2] = transform2[2];
    transform1[3] = transform2[3];
    transform1[4] = transform2[4];
    transform1[5] = transform2[5];
    return transform1;
}
function $dff5a03e015694d8$export$5635d7ef4b8fee1c(transform, coordinate) {
    const x = coordinate[0];
    const y = coordinate[1];
    coordinate[0] = transform[0] * x + transform[2] * y + transform[4];
    coordinate[1] = transform[1] * x + transform[3] * y + transform[5];
    return coordinate;
}
function $dff5a03e015694d8$export$bb628a54ab399bc9(transform, angle) {
    const cos = Math.cos(angle);
    const sin = Math.sin(angle);
    return $dff5a03e015694d8$export$2060d2db72cce88f(transform, $dff5a03e015694d8$export$adaa4cf7ef1b65be($dff5a03e015694d8$var$tmp_, cos, sin, -sin, cos, 0, 0));
}
function $dff5a03e015694d8$export$dcdf75081b88279d(transform, x, y) {
    return $dff5a03e015694d8$export$2060d2db72cce88f(transform, $dff5a03e015694d8$export$adaa4cf7ef1b65be($dff5a03e015694d8$var$tmp_, x, 0, 0, y, 0, 0));
}
function $dff5a03e015694d8$export$3e4e33ea14aeb531(target, x, y) {
    return $dff5a03e015694d8$export$adaa4cf7ef1b65be(target, x, 0, 0, y, 0, 0);
}
function $dff5a03e015694d8$export$d73ee8ef04f5226a(transform, dx, dy) {
    return $dff5a03e015694d8$export$2060d2db72cce88f(transform, $dff5a03e015694d8$export$adaa4cf7ef1b65be($dff5a03e015694d8$var$tmp_, 1, 0, 0, 1, dx, dy));
}
function $dff5a03e015694d8$export$f672e0b6f7222cd7(transform, dx1, dy1, sx, sy, angle, dx2, dy2) {
    const sin = Math.sin(angle);
    const cos = Math.cos(angle);
    transform[0] = sx * cos;
    transform[1] = sy * sin;
    transform[2] = -sx * sin;
    transform[3] = sy * cos;
    transform[4] = dx2 * sx * cos - dy2 * sx * sin + dx1;
    transform[5] = dx2 * sy * sin + dy2 * sy * cos + dy1;
    return transform;
}
function $dff5a03e015694d8$export$12a96a1aaf5558e3(dx1, dy1, sx, sy, angle, dx2, dy2) {
    return $dff5a03e015694d8$export$f84e8e69fd4488a5($dff5a03e015694d8$export$f672e0b6f7222cd7($dff5a03e015694d8$export$185802fd694ee1f5(), dx1, dy1, sx, sy, angle, dx2, dy2));
}
function $dff5a03e015694d8$export$6897c284b6f9f4dc(source) {
    return $dff5a03e015694d8$export$bd70ea2a93c0fa4(source, source);
}
function $dff5a03e015694d8$export$bd70ea2a93c0fa4(target, source) {
    const det = $dff5a03e015694d8$export$a04698f914c55ed9(source);
    (0, $71eb897bda873684$export$a7a9523472993e97)(det !== 0, 'Transformation matrix cannot be inverted');
    const a = source[0];
    const b = source[1];
    const c = source[2];
    const d = source[3];
    const e = source[4];
    const f = source[5];
    target[0] = d / det;
    target[1] = -b / det;
    target[2] = -c / det;
    target[3] = a / det;
    target[4] = (c * f - d * e) / det;
    target[5] = -(a * f - b * e) / det;
    return target;
}
function $dff5a03e015694d8$export$a04698f914c55ed9(mat) {
    return mat[0] * mat[3] - mat[1] * mat[2];
}
/**
 * @type {Array}
 */ const $dff5a03e015694d8$var$matrixPrecision = [
    1e5,
    1e5,
    1e5,
    1e5,
    2,
    2
];
function $dff5a03e015694d8$export$f84e8e69fd4488a5(mat) {
    const transformString = 'matrix(' + mat.join(', ') + ')';
    return transformString;
}
function $dff5a03e015694d8$export$3004f64547af360e(cssTransform) {
    const values = cssTransform.substring(7, cssTransform.length - 1).split(',');
    return values.map(parseFloat);
}
function $dff5a03e015694d8$export$fe091d73a555748b(cssTransform1, cssTransform2) {
    const mat1 = $dff5a03e015694d8$export$3004f64547af360e(cssTransform1);
    const mat2 = $dff5a03e015694d8$export$3004f64547af360e(cssTransform2);
    for(let i = 0; i < 6; ++i){
        if (Math.round((mat1[i] - mat2[i]) * $dff5a03e015694d8$var$matrixPrecision[i]) !== 0) return false;
    }
    return true;
}



/**
 * @module ol/geom/flat/transform
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {import("../../transform.js").Transform} transform Transform.
 * @param {Array<number>} [dest] Destination.
 * @param {number} [destinationStride] Stride of destination coordinates; if unspecified, assumed to be 2.
 * @return {Array<number>} Transformed coordinates.
 */ function $d95a11593b39996c$export$b92b2dedcfff79de(flatCoordinates, offset, end, stride, transform, dest, destinationStride) {
    dest = dest ? dest : [];
    destinationStride = destinationStride ? destinationStride : 2;
    let i = 0;
    for(let j = offset; j < end; j += stride){
        const x = flatCoordinates[j];
        const y = flatCoordinates[j + 1];
        dest[i++] = transform[0] * x + transform[2] * y + transform[4];
        dest[i++] = transform[1] * x + transform[3] * y + transform[5];
        for(let k = 2; k < destinationStride; k++)dest[i++] = flatCoordinates[j + k];
    }
    if (dest && dest.length != i) dest.length = i;
    return dest;
}
function $d95a11593b39996c$export$bb628a54ab399bc9(flatCoordinates, offset, end, stride, angle, anchor, dest) {
    dest = dest ? dest : [];
    const cos = Math.cos(angle);
    const sin = Math.sin(angle);
    const anchorX = anchor[0];
    const anchorY = anchor[1];
    let i = 0;
    for(let j = offset; j < end; j += stride){
        const deltaX = flatCoordinates[j] - anchorX;
        const deltaY = flatCoordinates[j + 1] - anchorY;
        dest[i++] = anchorX + deltaX * cos - deltaY * sin;
        dest[i++] = anchorY + deltaX * sin + deltaY * cos;
        for(let k = j + 2; k < j + stride; ++k)dest[i++] = flatCoordinates[k];
    }
    if (dest && dest.length != i) dest.length = i;
    return dest;
}
function $d95a11593b39996c$export$dcdf75081b88279d(flatCoordinates, offset, end, stride, sx, sy, anchor, dest) {
    dest = dest ? dest : [];
    const anchorX = anchor[0];
    const anchorY = anchor[1];
    let i = 0;
    for(let j = offset; j < end; j += stride){
        const deltaX = flatCoordinates[j] - anchorX;
        const deltaY = flatCoordinates[j + 1] - anchorY;
        dest[i++] = anchorX + sx * deltaX;
        dest[i++] = anchorY + sy * deltaY;
        for(let k = j + 2; k < j + stride; ++k)dest[i++] = flatCoordinates[k];
    }
    if (dest && dest.length != i) dest.length = i;
    return dest;
}
function $d95a11593b39996c$export$d73ee8ef04f5226a(flatCoordinates, offset, end, stride, deltaX, deltaY, dest) {
    dest = dest ? dest : [];
    let i = 0;
    for(let j = offset; j < end; j += stride){
        dest[i++] = flatCoordinates[j] + deltaX;
        dest[i++] = flatCoordinates[j + 1] + deltaY;
        for(let k = j + 2; k < j + stride; ++k)dest[i++] = flatCoordinates[k];
    }
    if (dest && dest.length != i) dest.length = i;
    return dest;
}


/**
 * @typedef {'XY' | 'XYZ' | 'XYM' | 'XYZM'} GeometryLayout
 * The coordinate layout for geometries, indicating whether a 3rd or 4th z ('Z')
 * or measure ('M') coordinate is available.
 */ /**
 * @typedef {'Point' | 'LineString' | 'LinearRing' | 'Polygon' | 'MultiPoint' | 'MultiLineString' | 'MultiPolygon' | 'GeometryCollection' | 'Circle'} Type
 * The geometry type.  One of `'Point'`, `'LineString'`, `'LinearRing'`,
 * `'Polygon'`, `'MultiPoint'`, `'MultiLineString'`, `'MultiPolygon'`,
 * `'GeometryCollection'`, or `'Circle'`.
 */ /**
 * @type {import("../transform.js").Transform}
 */ const $9866af2a06d7b59c$var$tmpTransform = (0, $dff5a03e015694d8$export$185802fd694ee1f5)();
/** @type {import('../coordinate.js').Coordinate} */ const $9866af2a06d7b59c$var$tmpPoint = [
    NaN,
    NaN
];
/**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Base class for vector geometries.
 *
 * To get notified of changes to the geometry, register a listener for the
 * generic `change` event on your geometry instance.
 *
 * @abstract
 * @api
 */ class $9866af2a06d7b59c$var$Geometry extends (0, $4862cdcc23257f5b$export$2e2bcd8739ae039) {
    constructor(){
        super();
        /**
     * @private
     * @type {import("../extent.js").Extent}
     */ this.extent_ = (0, $dea65c2f666fa450$export$fe201bb3bbe031e9)();
        /**
     * @private
     * @type {number}
     */ this.extentRevision_ = -1;
        /**
     * @protected
     * @type {number}
     */ this.simplifiedGeometryMaxMinSquaredTolerance = 0;
        /**
     * @protected
     * @type {number}
     */ this.simplifiedGeometryRevision = 0;
        /**
     * Get a transformed and simplified version of the geometry.
     * @abstract
     * @param {number} revision The geometry revision.
     * @param {number} squaredTolerance Squared tolerance.
     * @param {import("../proj.js").TransformFunction} [transform] Optional transform function.
     * @return {Geometry} Simplified geometry.
     */ this.simplifyTransformedInternal = (0, $bc15bca7780ad95b$export$ff83df6f9971435f)((revision, squaredTolerance, transform)=>{
            if (!transform) return this.getSimplifiedGeometry(squaredTolerance);
            const clone = this.clone();
            clone.applyTransform(transform);
            return clone.getSimplifiedGeometry(squaredTolerance);
        });
    }
    /**
   * Get a transformed and simplified version of the geometry.
   * @abstract
   * @param {number} squaredTolerance Squared tolerance.
   * @param {import("../proj.js").TransformFunction} [transform] Optional transform function.
   * @return {Geometry} Simplified geometry.
   */ simplifyTransformed(squaredTolerance, transform) {
        return this.simplifyTransformedInternal(this.getRevision(), squaredTolerance, transform);
    }
    /**
   * Make a complete copy of the geometry.
   * @abstract
   * @return {!Geometry} Clone.
   */ clone() {
        return (0, $fd76d391cc228565$export$817eb92a8194bab0)();
    }
    /**
   * @abstract
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        return (0, $fd76d391cc228565$export$817eb92a8194bab0)();
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @return {boolean} Contains (x, y).
   */ containsXY(x, y) {
        return this.closestPointXY(x, y, $9866af2a06d7b59c$var$tmpPoint, Number.MIN_VALUE) === 0;
    }
    /**
   * Return the closest point of the geometry to the passed point as
   * {@link module:ol/coordinate~Coordinate coordinate}.
   * @param {import("../coordinate.js").Coordinate} point Point.
   * @param {import("../coordinate.js").Coordinate} [closestPoint] Closest point.
   * @return {import("../coordinate.js").Coordinate} Closest point.
   * @api
   */ getClosestPoint(point, closestPoint) {
        closestPoint = closestPoint ? closestPoint : [
            NaN,
            NaN
        ];
        this.closestPointXY(point[0], point[1], closestPoint, Infinity);
        return closestPoint;
    }
    /**
   * Returns true if this geometry includes the specified coordinate. If the
   * coordinate is on the boundary of the geometry, returns false.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @return {boolean} Contains coordinate.
   * @api
   */ intersectsCoordinate(coordinate) {
        return this.containsXY(coordinate[0], coordinate[1]);
    }
    /**
   * @abstract
   * @param {import("../extent.js").Extent} extent Extent.
   * @protected
   * @return {import("../extent.js").Extent} extent Extent.
   */ computeExtent(extent) {
        return (0, $fd76d391cc228565$export$817eb92a8194bab0)();
    }
    /**
   * Get the extent of the geometry.
   * @param {import("../extent.js").Extent} [extent] Extent.
   * @return {import("../extent.js").Extent} extent Extent.
   * @api
   */ getExtent(extent) {
        if (this.extentRevision_ != this.getRevision()) {
            const extent = this.computeExtent(this.extent_);
            if (isNaN(extent[0]) || isNaN(extent[1])) (0, $dea65c2f666fa450$export$3e2152b047719fa1)(extent);
            this.extentRevision_ = this.getRevision();
        }
        return (0, $dea65c2f666fa450$export$6a4fe494c558c238)(this.extent_, extent);
    }
    /**
   * Rotate the geometry around a given coordinate. This modifies the geometry
   * coordinates in place.
   * @abstract
   * @param {number} angle Rotation angle in radians.
   * @param {import("../coordinate.js").Coordinate} anchor The rotation center.
   * @api
   */ rotate(angle, anchor) {
        (0, $fd76d391cc228565$export$817eb92a8194bab0)();
    }
    /**
   * Scale the geometry (with an optional origin).  This modifies the geometry
   * coordinates in place.
   * @abstract
   * @param {number} sx The scaling factor in the x-direction.
   * @param {number} [sy] The scaling factor in the y-direction (defaults to sx).
   * @param {import("../coordinate.js").Coordinate} [anchor] The scale origin (defaults to the center
   *     of the geometry extent).
   * @api
   */ scale(sx, sy, anchor) {
        (0, $fd76d391cc228565$export$817eb92a8194bab0)();
    }
    /**
   * Create a simplified version of this geometry.  For linestrings, this uses
   * the [Douglas Peucker](https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm)
   * algorithm.  For polygons, a quantization-based
   * simplification is used to preserve topology.
   * @param {number} tolerance The tolerance distance for simplification.
   * @return {Geometry} A new, simplified version of the original geometry.
   * @api
   */ simplify(tolerance) {
        return this.getSimplifiedGeometry(tolerance * tolerance);
    }
    /**
   * Create a simplified version of this geometry using the Douglas Peucker
   * algorithm.
   * See https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm.
   * @abstract
   * @param {number} squaredTolerance Squared tolerance.
   * @return {Geometry} Simplified geometry.
   */ getSimplifiedGeometry(squaredTolerance) {
        return (0, $fd76d391cc228565$export$817eb92a8194bab0)();
    }
    /**
   * Get the type of this geometry.
   * @abstract
   * @return {Type} Geometry type.
   */ getType() {
        return (0, $fd76d391cc228565$export$817eb92a8194bab0)();
    }
    /**
   * Apply a transform function to the coordinates of the geometry.
   * The geometry is modified in place.
   * If you do not want the geometry modified in place, first `clone()` it and
   * then use this function on the clone.
   * @abstract
   * @param {import("../proj.js").TransformFunction} transformFn Transform function.
   * Called with a flat array of geometry coordinates.
   */ applyTransform(transformFn) {
        (0, $fd76d391cc228565$export$817eb92a8194bab0)();
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @abstract
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   */ intersectsExtent(extent) {
        return (0, $fd76d391cc228565$export$817eb92a8194bab0)();
    }
    /**
   * Translate the geometry.  This modifies the geometry coordinates in place.  If
   * instead you want a new geometry, first `clone()` this geometry.
   * @abstract
   * @param {number} deltaX Delta X.
   * @param {number} deltaY Delta Y.
   * @api
   */ translate(deltaX, deltaY) {
        (0, $fd76d391cc228565$export$817eb92a8194bab0)();
    }
    /**
   * Transform each coordinate of the geometry from one coordinate reference
   * system to another. The geometry is modified in place.
   * For example, a line will be transformed to a line and a circle to a circle.
   * If you do not want the geometry modified in place, first `clone()` it and
   * then use this function on the clone.
   *
   * @param {import("../proj.js").ProjectionLike} source The current projection.  Can be a
   *     string identifier or a {@link module:ol/proj/Projection~Projection} object.
   * @param {import("../proj.js").ProjectionLike} destination The desired projection.  Can be a
   *     string identifier or a {@link module:ol/proj/Projection~Projection} object.
   * @return {this} This geometry.  Note that original geometry is
   *     modified in place.
   * @api
   */ transform(source, destination) {
        /** @type {import("../proj/Projection.js").default} */ const sourceProj = (0, $a86eee1c28205a05$export$3988ae62b71be9a3)(source);
        const transformFn = sourceProj.getUnits() == 'tile-pixels' ? function(inCoordinates, outCoordinates, stride) {
            const pixelExtent = sourceProj.getExtent();
            const projectedExtent = sourceProj.getWorldExtent();
            const scale = (0, $dea65c2f666fa450$export$c08559766941f856)(projectedExtent) / (0, $dea65c2f666fa450$export$c08559766941f856)(pixelExtent);
            (0, $dff5a03e015694d8$export$f672e0b6f7222cd7)($9866af2a06d7b59c$var$tmpTransform, projectedExtent[0], projectedExtent[3], scale, -scale, 0, 0, 0);
            const transformed = (0, $d95a11593b39996c$export$b92b2dedcfff79de)(inCoordinates, 0, inCoordinates.length, stride, $9866af2a06d7b59c$var$tmpTransform, outCoordinates);
            const projTransform = (0, $a86eee1c28205a05$export$fce0c6cfca85ed96)(sourceProj, destination);
            if (projTransform) return projTransform(transformed, transformed, stride);
            return transformed;
        } : (0, $a86eee1c28205a05$export$fce0c6cfca85ed96)(sourceProj, destination);
        this.applyTransform(transformFn);
        return this;
    }
}
var $9866af2a06d7b59c$export$2e2bcd8739ae039 = $9866af2a06d7b59c$var$Geometry;


/**
 * @classdesc
 * An array of {@link module:ol/geom/Geometry~Geometry} objects.
 *
 * @api
 */ class $83009074668f36ff$var$GeometryCollection extends (0, $9866af2a06d7b59c$export$2e2bcd8739ae039) {
    /**
   * @param {Array<Geometry>} geometries Geometries.
   */ constructor(geometries){
        super();
        /**
     * @private
     * @type {Array<Geometry>}
     */ this.geometries_ = geometries;
        /**
     * @private
     * @type {Array<import("../events.js").EventsKey>}
     */ this.changeEventsKeys_ = [];
        this.listenGeometriesChange_();
    }
    /**
   * @private
   */ unlistenGeometriesChange_() {
        this.changeEventsKeys_.forEach((0, $63963d09e0c49405$export$b0a21c8b3c1c921));
        this.changeEventsKeys_.length = 0;
    }
    /**
   * @private
   */ listenGeometriesChange_() {
        const geometries = this.geometries_;
        for(let i = 0, ii = geometries.length; i < ii; ++i)this.changeEventsKeys_.push((0, $63963d09e0c49405$export$63174c828edd6ff8)(geometries[i], (0, $b5fa963342da4935$export$2e2bcd8739ae039).CHANGE, this.changed, this));
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!GeometryCollection} Clone.
   * @api
   * @override
   */ clone() {
        const geometryCollection = new $83009074668f36ff$var$GeometryCollection($83009074668f36ff$var$cloneGeometries(this.geometries_));
        geometryCollection.applyProperties(this);
        return geometryCollection;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   * @override
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, $dea65c2f666fa450$export$cbe64c389534206f)(this.getExtent(), x, y)) return minSquaredDistance;
        const geometries = this.geometries_;
        for(let i = 0, ii = geometries.length; i < ii; ++i)minSquaredDistance = geometries[i].closestPointXY(x, y, closestPoint, minSquaredDistance);
        return minSquaredDistance;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @return {boolean} Contains (x, y).
   * @override
   */ containsXY(x, y) {
        const geometries = this.geometries_;
        for(let i = 0, ii = geometries.length; i < ii; ++i){
            if (geometries[i].containsXY(x, y)) return true;
        }
        return false;
    }
    /**
   * @param {import("../extent.js").Extent} extent Extent.
   * @protected
   * @return {import("../extent.js").Extent} extent Extent.
   * @override
   */ computeExtent(extent) {
        (0, $dea65c2f666fa450$export$3e2152b047719fa1)(extent);
        const geometries = this.geometries_;
        for(let i = 0, ii = geometries.length; i < ii; ++i)(0, $dea65c2f666fa450$export$8b58be045bf06082)(extent, geometries[i].getExtent());
        return extent;
    }
    /**
   * Return the geometries that make up this geometry collection.
   * @return {Array<Geometry>} Geometries.
   * @api
   */ getGeometries() {
        return $83009074668f36ff$var$cloneGeometries(this.geometries_);
    }
    /**
   * @return {Array<Geometry>} Geometries.
   */ getGeometriesArray() {
        return this.geometries_;
    }
    /**
   * @return {Array<Geometry>} Geometries.
   */ getGeometriesArrayRecursive() {
        /** @type {Array<Geometry>} */ let geometriesArray = [];
        const geometries = this.geometries_;
        for(let i = 0, ii = geometries.length; i < ii; ++i)if (geometries[i].getType() === this.getType()) geometriesArray = geometriesArray.concat(/** @type {GeometryCollection} */ geometries[i].getGeometriesArrayRecursive());
        else geometriesArray.push(geometries[i]);
        return geometriesArray;
    }
    /**
   * Create a simplified version of this geometry using the Douglas Peucker algorithm.
   * @param {number} squaredTolerance Squared tolerance.
   * @return {GeometryCollection} Simplified GeometryCollection.
   * @override
   */ getSimplifiedGeometry(squaredTolerance) {
        if (this.simplifiedGeometryRevision !== this.getRevision()) {
            this.simplifiedGeometryMaxMinSquaredTolerance = 0;
            this.simplifiedGeometryRevision = this.getRevision();
        }
        if (squaredTolerance < 0 || this.simplifiedGeometryMaxMinSquaredTolerance !== 0 && squaredTolerance < this.simplifiedGeometryMaxMinSquaredTolerance) return this;
        const simplifiedGeometries = [];
        const geometries = this.geometries_;
        let simplified = false;
        for(let i = 0, ii = geometries.length; i < ii; ++i){
            const geometry = geometries[i];
            const simplifiedGeometry = geometry.getSimplifiedGeometry(squaredTolerance);
            simplifiedGeometries.push(simplifiedGeometry);
            if (simplifiedGeometry !== geometry) simplified = true;
        }
        if (simplified) {
            const simplifiedGeometryCollection = new $83009074668f36ff$var$GeometryCollection(simplifiedGeometries);
            return simplifiedGeometryCollection;
        }
        this.simplifiedGeometryMaxMinSquaredTolerance = squaredTolerance;
        return this;
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   * @override
   */ getType() {
        return 'GeometryCollection';
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   * @override
   */ intersectsExtent(extent) {
        const geometries = this.geometries_;
        for(let i = 0, ii = geometries.length; i < ii; ++i){
            if (geometries[i].intersectsExtent(extent)) return true;
        }
        return false;
    }
    /**
   * @return {boolean} Is empty.
   */ isEmpty() {
        return this.geometries_.length === 0;
    }
    /**
   * Rotate the geometry around a given coordinate. This modifies the geometry
   * coordinates in place.
   * @param {number} angle Rotation angle in radians.
   * @param {import("../coordinate.js").Coordinate} anchor The rotation center.
   * @api
   * @override
   */ rotate(angle, anchor) {
        const geometries = this.geometries_;
        for(let i = 0, ii = geometries.length; i < ii; ++i)geometries[i].rotate(angle, anchor);
        this.changed();
    }
    /**
   * Scale the geometry (with an optional origin).  This modifies the geometry
   * coordinates in place.
   * @abstract
   * @param {number} sx The scaling factor in the x-direction.
   * @param {number} [sy] The scaling factor in the y-direction (defaults to sx).
   * @param {import("../coordinate.js").Coordinate} [anchor] The scale origin (defaults to the center
   *     of the geometry extent).
   * @api
   * @override
   */ scale(sx, sy, anchor) {
        if (!anchor) anchor = (0, $dea65c2f666fa450$export$c91255cadecfe081)(this.getExtent());
        const geometries = this.geometries_;
        for(let i = 0, ii = geometries.length; i < ii; ++i)geometries[i].scale(sx, sy, anchor);
        this.changed();
    }
    /**
   * Set the geometries that make up this geometry collection.
   * @param {Array<Geometry>} geometries Geometries.
   * @api
   */ setGeometries(geometries) {
        this.setGeometriesArray($83009074668f36ff$var$cloneGeometries(geometries));
    }
    /**
   * @param {Array<Geometry>} geometries Geometries.
   */ setGeometriesArray(geometries) {
        this.unlistenGeometriesChange_();
        this.geometries_ = geometries;
        this.listenGeometriesChange_();
        this.changed();
    }
    /**
   * Apply a transform function to the coordinates of the geometry.
   * The geometry is modified in place.
   * If you do not want the geometry modified in place, first `clone()` it and
   * then use this function on the clone.
   * @param {import("../proj.js").TransformFunction} transformFn Transform function.
   * Called with a flat array of geometry coordinates.
   * @api
   * @override
   */ applyTransform(transformFn) {
        const geometries = this.geometries_;
        for(let i = 0, ii = geometries.length; i < ii; ++i)geometries[i].applyTransform(transformFn);
        this.changed();
    }
    /**
   * Translate the geometry.  This modifies the geometry coordinates in place.  If
   * instead you want a new geometry, first `clone()` this geometry.
   * @param {number} deltaX Delta X.
   * @param {number} deltaY Delta Y.
   * @api
   * @override
   */ translate(deltaX, deltaY) {
        const geometries = this.geometries_;
        for(let i = 0, ii = geometries.length; i < ii; ++i)geometries[i].translate(deltaX, deltaY);
        this.changed();
    }
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        this.unlistenGeometriesChange_();
        super.disposeInternal();
    }
}
/**
 * @param {Array<Geometry>} geometries Geometries.
 * @return {Array<Geometry>} Cloned geometries.
 */ function $83009074668f36ff$var$cloneGeometries(geometries) {
    return geometries.map((geometry)=>geometry.clone());
}
var $83009074668f36ff$export$2e2bcd8739ae039 = $83009074668f36ff$var$GeometryCollection;


/**
 * @module ol/geom/LineString
 */ 

/**
 * @module ol/geom/SimpleGeometry
 */ 



/**
 * @classdesc
 * Abstract base class; only used for creating subclasses; do not instantiate
 * in apps, as cannot be rendered.
 *
 * @abstract
 * @api
 */ class $6773c3d7448f46a9$var$SimpleGeometry extends (0, $9866af2a06d7b59c$export$2e2bcd8739ae039) {
    constructor(){
        super();
        /**
     * @protected
     * @type {import("./Geometry.js").GeometryLayout}
     */ this.layout = 'XY';
        /**
     * @protected
     * @type {number}
     */ this.stride = 2;
        /**
     * @protected
     * @type {Array<number>}
     */ this.flatCoordinates;
    }
    /**
   * @param {import("../extent.js").Extent} extent Extent.
   * @protected
   * @return {import("../extent.js").Extent} extent Extent.
   * @override
   */ computeExtent(extent) {
        return (0, $dea65c2f666fa450$export$be0ab0bf96ca59ca)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, extent);
    }
    /**
   * @abstract
   * @return {Array<*> | null} Coordinates.
   */ getCoordinates() {
        return (0, $fd76d391cc228565$export$817eb92a8194bab0)();
    }
    /**
   * Return the first coordinate of the geometry.
   * @return {import("../coordinate.js").Coordinate} First coordinate.
   * @api
   */ getFirstCoordinate() {
        return this.flatCoordinates.slice(0, this.stride);
    }
    /**
   * @return {Array<number>} Flat coordinates.
   */ getFlatCoordinates() {
        return this.flatCoordinates;
    }
    /**
   * Return the last coordinate of the geometry.
   * @return {import("../coordinate.js").Coordinate} Last point.
   * @api
   */ getLastCoordinate() {
        return this.flatCoordinates.slice(this.flatCoordinates.length - this.stride);
    }
    /**
   * Return the {@link import("./Geometry.js").GeometryLayout layout} of the geometry.
   * @return {import("./Geometry.js").GeometryLayout} Layout.
   * @api
   */ getLayout() {
        return this.layout;
    }
    /**
   * Create a simplified version of this geometry using the Douglas Peucker algorithm.
   * @param {number} squaredTolerance Squared tolerance.
   * @return {SimpleGeometry} Simplified geometry.
   * @override
   */ getSimplifiedGeometry(squaredTolerance) {
        if (this.simplifiedGeometryRevision !== this.getRevision()) {
            this.simplifiedGeometryMaxMinSquaredTolerance = 0;
            this.simplifiedGeometryRevision = this.getRevision();
        }
        // If squaredTolerance is negative or if we know that simplification will not
        // have any effect then just return this.
        if (squaredTolerance < 0 || this.simplifiedGeometryMaxMinSquaredTolerance !== 0 && squaredTolerance <= this.simplifiedGeometryMaxMinSquaredTolerance) return this;
        const simplifiedGeometry = this.getSimplifiedGeometryInternal(squaredTolerance);
        const simplifiedFlatCoordinates = simplifiedGeometry.getFlatCoordinates();
        if (simplifiedFlatCoordinates.length < this.flatCoordinates.length) return simplifiedGeometry;
        // Simplification did not actually remove any coordinates.  We now know
        // that any calls to getSimplifiedGeometry with a squaredTolerance less
        // than or equal to the current squaredTolerance will also not have any
        // effect.  This allows us to short circuit simplification (saving CPU
        // cycles) and prevents the cache of simplified geometries from filling
        // up with useless identical copies of this geometry (saving memory).
        this.simplifiedGeometryMaxMinSquaredTolerance = squaredTolerance;
        return this;
    }
    /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {SimpleGeometry} Simplified geometry.
   * @protected
   */ getSimplifiedGeometryInternal(squaredTolerance) {
        return this;
    }
    /**
   * @return {number} Stride.
   */ getStride() {
        return this.stride;
    }
    /**
   * @param {import("./Geometry.js").GeometryLayout} layout Layout.
   * @param {Array<number>} flatCoordinates Flat coordinates.
   */ setFlatCoordinates(layout, flatCoordinates) {
        this.stride = $6773c3d7448f46a9$export$6af0c1b4a8549a43(layout);
        this.layout = layout;
        this.flatCoordinates = flatCoordinates;
    }
    /**
   * @abstract
   * @param {!Array<*>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   */ setCoordinates(coordinates, layout) {
        (0, $fd76d391cc228565$export$817eb92a8194bab0)();
    }
    /**
   * @param {import("./Geometry.js").GeometryLayout|undefined} layout Layout.
   * @param {Array<*>} coordinates Coordinates.
   * @param {number} nesting Nesting.
   * @protected
   */ setLayout(layout, coordinates, nesting) {
        let stride;
        if (layout) stride = $6773c3d7448f46a9$export$6af0c1b4a8549a43(layout);
        else {
            for(let i = 0; i < nesting; ++i){
                if (coordinates.length === 0) {
                    this.layout = 'XY';
                    this.stride = 2;
                    return;
                }
                coordinates = /** @type {Array<unknown>} */ coordinates[0];
            }
            stride = coordinates.length;
            layout = $6773c3d7448f46a9$export$61bb6938093db2c8(stride);
        }
        this.layout = layout;
        this.stride = stride;
    }
    /**
   * Apply a transform function to the coordinates of the geometry.
   * The geometry is modified in place.
   * If you do not want the geometry modified in place, first `clone()` it and
   * then use this function on the clone.
   * @param {import("../proj.js").TransformFunction} transformFn Transform function.
   * Called with a flat array of geometry coordinates.
   * @api
   * @override
   */ applyTransform(transformFn) {
        if (this.flatCoordinates) {
            transformFn(this.flatCoordinates, this.flatCoordinates, this.layout.startsWith('XYZ') ? 3 : 2, this.stride);
            this.changed();
        }
    }
    /**
   * Rotate the geometry around a given coordinate. This modifies the geometry
   * coordinates in place.
   * @param {number} angle Rotation angle in counter-clockwise radians.
   * @param {import("../coordinate.js").Coordinate} anchor The rotation center.
   * @api
   * @override
   */ rotate(angle, anchor) {
        const flatCoordinates = this.getFlatCoordinates();
        if (flatCoordinates) {
            const stride = this.getStride();
            (0, $d95a11593b39996c$export$bb628a54ab399bc9)(flatCoordinates, 0, flatCoordinates.length, stride, angle, anchor, flatCoordinates);
            this.changed();
        }
    }
    /**
   * Scale the geometry (with an optional origin).  This modifies the geometry
   * coordinates in place.
   * @param {number} sx The scaling factor in the x-direction.
   * @param {number} [sy] The scaling factor in the y-direction (defaults to sx).
   * @param {import("../coordinate.js").Coordinate} [anchor] The scale origin (defaults to the center
   *     of the geometry extent).
   * @api
   * @override
   */ scale(sx, sy, anchor) {
        if (sy === undefined) sy = sx;
        if (!anchor) anchor = (0, $dea65c2f666fa450$export$c91255cadecfe081)(this.getExtent());
        const flatCoordinates = this.getFlatCoordinates();
        if (flatCoordinates) {
            const stride = this.getStride();
            (0, $d95a11593b39996c$export$dcdf75081b88279d)(flatCoordinates, 0, flatCoordinates.length, stride, sx, sy, anchor, flatCoordinates);
            this.changed();
        }
    }
    /**
   * Translate the geometry.  This modifies the geometry coordinates in place.  If
   * instead you want a new geometry, first `clone()` this geometry.
   * @param {number} deltaX Delta X.
   * @param {number} deltaY Delta Y.
   * @api
   * @override
   */ translate(deltaX, deltaY) {
        const flatCoordinates = this.getFlatCoordinates();
        if (flatCoordinates) {
            const stride = this.getStride();
            (0, $d95a11593b39996c$export$d73ee8ef04f5226a)(flatCoordinates, 0, flatCoordinates.length, stride, deltaX, deltaY, flatCoordinates);
            this.changed();
        }
    }
}
function $6773c3d7448f46a9$export$61bb6938093db2c8(stride) {
    let layout;
    if (stride == 2) layout = 'XY';
    else if (stride == 3) layout = 'XYZ';
    else if (stride == 4) layout = 'XYZM';
    return /** @type {import("./Geometry.js").GeometryLayout} */ layout;
}
function $6773c3d7448f46a9$export$6af0c1b4a8549a43(layout) {
    let stride;
    if (layout == 'XY') stride = 2;
    else if (layout == 'XYZ' || layout == 'XYM') stride = 3;
    else if (layout == 'XYZM') stride = 4;
    return /** @type {number} */ stride;
}
function $6773c3d7448f46a9$export$a3767472617c7861(simpleGeometry, transform, dest) {
    const flatCoordinates = simpleGeometry.getFlatCoordinates();
    if (!flatCoordinates) return null;
    const stride = simpleGeometry.getStride();
    return (0, $d95a11593b39996c$export$b92b2dedcfff79de)(flatCoordinates, 0, flatCoordinates.length, stride, transform, dest);
}
var $6773c3d7448f46a9$export$2e2bcd8739ae039 = $6773c3d7448f46a9$var$SimpleGeometry;


/**
 * @module ol/geom/flat/closest
 */ 
/**
 * Returns the point on the 2D line segment flatCoordinates[offset1] to
 * flatCoordinates[offset2] that is closest to the point (x, y).  Extra
 * dimensions are linearly interpolated.
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset1 Offset 1.
 * @param {number} offset2 Offset 2.
 * @param {number} stride Stride.
 * @param {number} x X.
 * @param {number} y Y.
 * @param {Array<number>} closestPoint Closest point.
 */ function $41ec661db9892eae$var$assignClosest(flatCoordinates, offset1, offset2, stride, x, y, closestPoint) {
    const x1 = flatCoordinates[offset1];
    const y1 = flatCoordinates[offset1 + 1];
    const dx = flatCoordinates[offset2] - x1;
    const dy = flatCoordinates[offset2 + 1] - y1;
    let offset;
    if (dx === 0 && dy === 0) offset = offset1;
    else {
        const t = ((x - x1) * dx + (y - y1) * dy) / (dx * dx + dy * dy);
        if (t > 1) offset = offset2;
        else if (t > 0) {
            for(let i = 0; i < stride; ++i)closestPoint[i] = (0, $6a95bd76d7103f37$export$3a89f8d6f6bf6c9f)(flatCoordinates[offset1 + i], flatCoordinates[offset2 + i], t);
            closestPoint.length = stride;
            return;
        } else offset = offset1;
    }
    for(let i = 0; i < stride; ++i)closestPoint[i] = flatCoordinates[offset + i];
    closestPoint.length = stride;
}
function $41ec661db9892eae$export$bc2eb611ddf80103(flatCoordinates, offset, end, stride, max) {
    let x1 = flatCoordinates[offset];
    let y1 = flatCoordinates[offset + 1];
    for(offset += stride; offset < end; offset += stride){
        const x2 = flatCoordinates[offset];
        const y2 = flatCoordinates[offset + 1];
        const squaredDelta = (0, $6a95bd76d7103f37$export$88e6ebb4fe54f538)(x1, y1, x2, y2);
        if (squaredDelta > max) max = squaredDelta;
        x1 = x2;
        y1 = y2;
    }
    return max;
}
function $41ec661db9892eae$export$fbf31c8f2668ed5a(flatCoordinates, offset, ends, stride, max) {
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        max = $41ec661db9892eae$export$bc2eb611ddf80103(flatCoordinates, offset, end, stride, max);
        offset = end;
    }
    return max;
}
function $41ec661db9892eae$export$37c18e6e7d50501a(flatCoordinates, offset, endss, stride, max) {
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        max = $41ec661db9892eae$export$fbf31c8f2668ed5a(flatCoordinates, offset, ends, stride, max);
        offset = ends[ends.length - 1];
    }
    return max;
}
function $41ec661db9892eae$export$4adc8e5135fb44c(flatCoordinates, offset, end, stride, maxDelta, isRing, x, y, closestPoint, minSquaredDistance, tmpPoint) {
    if (offset == end) return minSquaredDistance;
    let i, squaredDistance;
    if (maxDelta === 0) {
        // All points are identical, so just test the first point.
        squaredDistance = (0, $6a95bd76d7103f37$export$88e6ebb4fe54f538)(x, y, flatCoordinates[offset], flatCoordinates[offset + 1]);
        if (squaredDistance < minSquaredDistance) {
            for(i = 0; i < stride; ++i)closestPoint[i] = flatCoordinates[offset + i];
            closestPoint.length = stride;
            return squaredDistance;
        }
        return minSquaredDistance;
    }
    tmpPoint = tmpPoint ? tmpPoint : [
        NaN,
        NaN
    ];
    let index = offset + stride;
    while(index < end){
        $41ec661db9892eae$var$assignClosest(flatCoordinates, index - stride, index, stride, x, y, tmpPoint);
        squaredDistance = (0, $6a95bd76d7103f37$export$88e6ebb4fe54f538)(x, y, tmpPoint[0], tmpPoint[1]);
        if (squaredDistance < minSquaredDistance) {
            minSquaredDistance = squaredDistance;
            for(i = 0; i < stride; ++i)closestPoint[i] = tmpPoint[i];
            closestPoint.length = stride;
            index += stride;
        } else // Skip ahead multiple points, because we know that all the skipped
        // points cannot be any closer than the closest point we have found so
        // far.  We know this because we know how close the current point is, how
        // close the closest point we have found so far is, and the maximum
        // distance between consecutive points.  For example, if we're currently
        // at distance 10, the best we've found so far is 3, and that the maximum
        // distance between consecutive points is 2, then we'll need to skip at
        // least (10 - 3) / 2 == 3 (rounded down) points to have any chance of
        // finding a closer point.  We use Math.max(..., 1) to ensure that we
        // always advance at least one point, to avoid an infinite loop.
        index += stride * Math.max((Math.sqrt(squaredDistance) - Math.sqrt(minSquaredDistance)) / maxDelta | 0, 1);
    }
    if (isRing) {
        // Check the closing segment.
        $41ec661db9892eae$var$assignClosest(flatCoordinates, end - stride, offset, stride, x, y, tmpPoint);
        squaredDistance = (0, $6a95bd76d7103f37$export$88e6ebb4fe54f538)(x, y, tmpPoint[0], tmpPoint[1]);
        if (squaredDistance < minSquaredDistance) {
            minSquaredDistance = squaredDistance;
            for(i = 0; i < stride; ++i)closestPoint[i] = tmpPoint[i];
            closestPoint.length = stride;
        }
    }
    return minSquaredDistance;
}
function $41ec661db9892eae$export$5a48a0eefcf14992(flatCoordinates, offset, ends, stride, maxDelta, isRing, x, y, closestPoint, minSquaredDistance, tmpPoint) {
    tmpPoint = tmpPoint ? tmpPoint : [
        NaN,
        NaN
    ];
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        minSquaredDistance = $41ec661db9892eae$export$4adc8e5135fb44c(flatCoordinates, offset, end, stride, maxDelta, isRing, x, y, closestPoint, minSquaredDistance, tmpPoint);
        offset = end;
    }
    return minSquaredDistance;
}
function $41ec661db9892eae$export$60e067685eb8f9c4(flatCoordinates, offset, endss, stride, maxDelta, isRing, x, y, closestPoint, minSquaredDistance, tmpPoint) {
    tmpPoint = tmpPoint ? tmpPoint : [
        NaN,
        NaN
    ];
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        minSquaredDistance = $41ec661db9892eae$export$5a48a0eefcf14992(flatCoordinates, offset, ends, stride, maxDelta, isRing, x, y, closestPoint, minSquaredDistance, tmpPoint);
        offset = ends[ends.length - 1];
    }
    return minSquaredDistance;
}


/**
 * @module ol/geom/flat/deflate
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
 * @param {number} stride Stride.
 * @return {number} offset Offset.
 */ function $f96815e1fef680b1$export$60815ead40ec79ab(flatCoordinates, offset, coordinate, stride) {
    for(let i = 0, ii = coordinate.length; i < ii; ++i)flatCoordinates[offset++] = coordinate[i];
    return offset;
}
function $f96815e1fef680b1$export$5c4daf67e03c190f(flatCoordinates, offset, coordinates, stride) {
    for(let i = 0, ii = coordinates.length; i < ii; ++i){
        const coordinate = coordinates[i];
        for(let j = 0; j < stride; ++j)flatCoordinates[offset++] = coordinate[j];
    }
    return offset;
}
function $f96815e1fef680b1$export$47c3746a74384d45(flatCoordinates, offset, coordinatess, stride, ends) {
    ends = ends ? ends : [];
    let i = 0;
    for(let j = 0, jj = coordinatess.length; j < jj; ++j){
        const end = $f96815e1fef680b1$export$5c4daf67e03c190f(flatCoordinates, offset, coordinatess[j], stride);
        ends[i++] = end;
        offset = end;
    }
    ends.length = i;
    return ends;
}
function $f96815e1fef680b1$export$f9f2bb59da4accd3(flatCoordinates, offset, coordinatesss, stride, endss) {
    endss = endss ? endss : [];
    let i = 0;
    for(let j = 0, jj = coordinatesss.length; j < jj; ++j){
        const ends = $f96815e1fef680b1$export$47c3746a74384d45(flatCoordinates, offset, coordinatesss[j], stride, endss[i]);
        if (ends.length === 0) ends[0] = offset;
        endss[i++] = ends;
        offset = ends[ends.length - 1];
    }
    endss.length = i;
    return endss;
}


/**
 * @module ol/geom/flat/inflate
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {Array<import("../../coordinate.js").Coordinate>} [coordinates] Coordinates.
 * @return {Array<import("../../coordinate.js").Coordinate>} Coordinates.
 */ function $610a33d138e2ac41$export$9c0934e4e9c3f61e(flatCoordinates, offset, end, stride, coordinates) {
    coordinates = coordinates !== undefined ? coordinates : [];
    let i = 0;
    for(let j = offset; j < end; j += stride)coordinates[i++] = flatCoordinates.slice(j, j + stride);
    coordinates.length = i;
    return coordinates;
}
function $610a33d138e2ac41$export$cbb9596fc0f40db2(flatCoordinates, offset, ends, stride, coordinatess) {
    coordinatess = coordinatess !== undefined ? coordinatess : [];
    let i = 0;
    for(let j = 0, jj = ends.length; j < jj; ++j){
        const end = ends[j];
        coordinatess[i++] = $610a33d138e2ac41$export$9c0934e4e9c3f61e(flatCoordinates, offset, end, stride, coordinatess[i]);
        offset = end;
    }
    coordinatess.length = i;
    return coordinatess;
}
function $610a33d138e2ac41$export$915c7058aeb4dfeb(flatCoordinates, offset, endss, stride, coordinatesss) {
    coordinatesss = coordinatesss !== undefined ? coordinatesss : [];
    let i = 0;
    for(let j = 0, jj = endss.length; j < jj; ++j){
        const ends = endss[j];
        coordinatesss[i++] = ends.length === 1 && ends[0] === offset ? [] : $610a33d138e2ac41$export$cbb9596fc0f40db2(flatCoordinates, offset, ends, stride, coordinatesss[i]);
        offset = ends[ends.length - 1];
    }
    coordinatesss.length = i;
    return coordinatesss;
}


/**
 * @module ol/geom/flat/interpolate
 */ 

function $f6e4cfe5a0164691$export$687ff82efd78795b(flatCoordinates, offset, end, stride, fraction, dest, dimension) {
    let o, t;
    const n = (end - offset) / stride;
    if (n === 1) o = offset;
    else if (n === 2) {
        o = offset;
        t = fraction;
    } else if (n !== 0) {
        let x1 = flatCoordinates[offset];
        let y1 = flatCoordinates[offset + 1];
        let length = 0;
        const cumulativeLengths = [
            0
        ];
        for(let i = offset + stride; i < end; i += stride){
            const x2 = flatCoordinates[i];
            const y2 = flatCoordinates[i + 1];
            length += Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
            cumulativeLengths.push(length);
            x1 = x2;
            y1 = y2;
        }
        const target = fraction * length;
        const index = (0, $49313fcb0fc32abe$export$2e0ae67339d5f1ac)(cumulativeLengths, target);
        if (index < 0) {
            t = (target - cumulativeLengths[-index - 2]) / (cumulativeLengths[-index - 1] - cumulativeLengths[-index - 2]);
            o = offset + (-index - 2) * stride;
        } else o = offset + index * stride;
    }
    dimension = dimension > 1 ? dimension : 2;
    dest = dest ? dest : new Array(dimension);
    for(let i = 0; i < dimension; ++i)dest[i] = o === undefined ? NaN : t === undefined ? flatCoordinates[o + i] : (0, $6a95bd76d7103f37$export$3a89f8d6f6bf6c9f)(flatCoordinates[o + i], flatCoordinates[o + stride + i], t);
    return dest;
}
function $f6e4cfe5a0164691$export$8f44c3c220ef6f09(flatCoordinates, offset, end, stride, m, extrapolate) {
    if (end == offset) return null;
    let coordinate;
    if (m < flatCoordinates[offset + stride - 1]) {
        if (extrapolate) {
            coordinate = flatCoordinates.slice(offset, offset + stride);
            coordinate[stride - 1] = m;
            return coordinate;
        }
        return null;
    }
    if (flatCoordinates[end - 1] < m) {
        if (extrapolate) {
            coordinate = flatCoordinates.slice(end - stride, end);
            coordinate[stride - 1] = m;
            return coordinate;
        }
        return null;
    }
    // FIXME use O(1) search
    if (m == flatCoordinates[offset + stride - 1]) return flatCoordinates.slice(offset, offset + stride);
    let lo = offset / stride;
    let hi = end / stride;
    while(lo < hi){
        const mid = lo + hi >> 1;
        if (m < flatCoordinates[(mid + 1) * stride - 1]) hi = mid;
        else lo = mid + 1;
    }
    const m0 = flatCoordinates[lo * stride - 1];
    if (m == m0) return flatCoordinates.slice((lo - 1) * stride, (lo - 1) * stride + stride);
    const m1 = flatCoordinates[(lo + 1) * stride - 1];
    const t = (m - m0) / (m1 - m0);
    coordinate = [];
    for(let i = 0; i < stride - 1; ++i)coordinate.push((0, $6a95bd76d7103f37$export$3a89f8d6f6bf6c9f)(flatCoordinates[(lo - 1) * stride + i], flatCoordinates[lo * stride + i], t));
    coordinate.push(m);
    return coordinate;
}
function $f6e4cfe5a0164691$export$6a3300857e9ef453(flatCoordinates, offset, ends, stride, m, extrapolate, interpolate) {
    if (interpolate) return $f6e4cfe5a0164691$export$8f44c3c220ef6f09(flatCoordinates, offset, ends[ends.length - 1], stride, m, extrapolate);
    let coordinate;
    if (m < flatCoordinates[stride - 1]) {
        if (extrapolate) {
            coordinate = flatCoordinates.slice(0, stride);
            coordinate[stride - 1] = m;
            return coordinate;
        }
        return null;
    }
    if (flatCoordinates[flatCoordinates.length - 1] < m) {
        if (extrapolate) {
            coordinate = flatCoordinates.slice(flatCoordinates.length - stride);
            coordinate[stride - 1] = m;
            return coordinate;
        }
        return null;
    }
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        if (offset == end) continue;
        if (m < flatCoordinates[offset + stride - 1]) return null;
        if (m <= flatCoordinates[end - 1]) return $f6e4cfe5a0164691$export$8f44c3c220ef6f09(flatCoordinates, offset, end, stride, m, false);
        offset = end;
    }
    return null;
}


/**
 * @module ol/geom/flat/intersectsextent
 */ 
/**
 * @module ol/geom/flat/contains
 */ 
function $e804011d1880db52$export$cedabedc7ac0e138(flatCoordinates, offset, end, stride, extent) {
    const outside = (0, $dea65c2f666fa450$export$f9ed8a3d123a08e2)(extent, /**
     * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
     * @return {boolean} Contains (x, y).
     */ function(coordinate) {
        return !$e804011d1880db52$export$949a7a3a4b6f34fa(flatCoordinates, offset, end, stride, coordinate[0], coordinate[1]);
    });
    return !outside;
}
function $e804011d1880db52$export$949a7a3a4b6f34fa(flatCoordinates, offset, end, stride, x, y) {
    // https://web.archive.org/web/20210504233957/http://geomalgorithms.com/a03-_inclusion.html
    // Copyright 2000 softSurfer, 2012 Dan Sunday
    // This code may be freely used and modified for any purpose
    // providing that this copyright notice is included with it.
    // SoftSurfer makes no warranty for this code, and cannot be held
    // liable for any real or imagined damage resulting from its use.
    // Users of this code must verify correctness for their application.
    let wn = 0;
    let x1 = flatCoordinates[end - stride];
    let y1 = flatCoordinates[end - stride + 1];
    for(; offset < end; offset += stride){
        const x2 = flatCoordinates[offset];
        const y2 = flatCoordinates[offset + 1];
        if (y1 <= y) {
            if (y2 > y && (x2 - x1) * (y - y1) - (x - x1) * (y2 - y1) > 0) wn++;
        } else if (y2 <= y && (x2 - x1) * (y - y1) - (x - x1) * (y2 - y1) < 0) wn--;
        x1 = x2;
        y1 = y2;
    }
    return wn !== 0;
}
function $e804011d1880db52$export$ae868c0f6acc3355(flatCoordinates, offset, ends, stride, x, y) {
    if (ends.length === 0) return false;
    if (!$e804011d1880db52$export$949a7a3a4b6f34fa(flatCoordinates, offset, ends[0], stride, x, y)) return false;
    for(let i = 1, ii = ends.length; i < ii; ++i){
        if ($e804011d1880db52$export$949a7a3a4b6f34fa(flatCoordinates, ends[i - 1], ends[i], stride, x, y)) return false;
    }
    return true;
}
function $e804011d1880db52$export$c760d9d16cf92043(flatCoordinates, offset, endss, stride, x, y) {
    if (endss.length === 0) return false;
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        if ($e804011d1880db52$export$ae868c0f6acc3355(flatCoordinates, offset, ends, stride, x, y)) return true;
        offset = ends[ends.length - 1];
    }
    return false;
}


/**
 * @module ol/geom/flat/segments
 */ /**
 * This function calls `callback` for each segment of the flat coordinates
 * array. If the callback returns a truthy value the function returns that
 * value immediately. Otherwise the function returns `false`.
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {function(import("../../coordinate.js").Coordinate, import("../../coordinate.js").Coordinate): T} callback Function
 *     called for each segment.
 * @return {T|boolean} Value.
 * @template T
 */ function $1810d616409094a3$export$4b80e395e36b5a56(flatCoordinates, offset, end, stride, callback) {
    let ret;
    offset += stride;
    for(; offset < end; offset += stride){
        ret = callback(flatCoordinates.slice(offset - stride, offset), flatCoordinates.slice(offset, offset + stride));
        if (ret) return ret;
    }
    return false;
}
function $1810d616409094a3$export$3f024338373820dc(segment1, segment2) {
    const [a, b] = segment1;
    const [c, d] = segment2;
    const t = ((a[0] - c[0]) * (c[1] - d[1]) - (a[1] - c[1]) * (c[0] - d[0])) / ((a[0] - b[0]) * (c[1] - d[1]) - (a[1] - b[1]) * (c[0] - d[0]));
    const u = ((a[0] - c[0]) * (a[1] - b[1]) - (a[1] - c[1]) * (a[0] - b[0])) / ((a[0] - b[0]) * (c[1] - d[1]) - (a[1] - b[1]) * (c[0] - d[0]));
    // Check if lines actually intersect
    if (0 <= t && t <= 1 && 0 <= u && u <= 1) return [
        a[0] + t * (b[0] - a[0]),
        a[1] + t * (b[1] - a[1])
    ];
    return undefined;
}


function $a3da3236b4fb8b80$export$40d8d71841a3d779(flatCoordinates, offset, end, stride, extent, coordinatesExtent) {
    coordinatesExtent = coordinatesExtent ?? (0, $dea65c2f666fa450$export$30570204156ffd18)((0, $dea65c2f666fa450$export$fe201bb3bbe031e9)(), flatCoordinates, offset, end, stride);
    if (!(0, $dea65c2f666fa450$export$7b0a31e10bbff018)(extent, coordinatesExtent)) return false;
    if (coordinatesExtent[0] >= extent[0] && coordinatesExtent[2] <= extent[2] || coordinatesExtent[1] >= extent[1] && coordinatesExtent[3] <= extent[3]) return true;
    return (0, $1810d616409094a3$export$4b80e395e36b5a56)(flatCoordinates, offset, end, stride, /**
     * @param {import("../../coordinate.js").Coordinate} point1 Start point.
     * @param {import("../../coordinate.js").Coordinate} point2 End point.
     * @return {boolean} `true` if the segment and the extent intersect,
     *     `false` otherwise.
     */ function(point1, point2) {
        return (0, $dea65c2f666fa450$export$a6a5a7a461419425)(extent, point1, point2);
    });
}
function $a3da3236b4fb8b80$export$fdb1d8e850bf7937(flatCoordinates, offset, ends, stride, extent) {
    for(let i = 0, ii = ends.length; i < ii; ++i){
        if ($a3da3236b4fb8b80$export$40d8d71841a3d779(flatCoordinates, offset, ends[i], stride, extent)) return true;
        offset = ends[i];
    }
    return false;
}
function $a3da3236b4fb8b80$export$830a0dafbb2ef1c5(flatCoordinates, offset, end, stride, extent) {
    if ($a3da3236b4fb8b80$export$40d8d71841a3d779(flatCoordinates, offset, end, stride, extent)) return true;
    if ((0, $e804011d1880db52$export$949a7a3a4b6f34fa)(flatCoordinates, offset, end, stride, extent[0], extent[1])) return true;
    if ((0, $e804011d1880db52$export$949a7a3a4b6f34fa)(flatCoordinates, offset, end, stride, extent[0], extent[3])) return true;
    if ((0, $e804011d1880db52$export$949a7a3a4b6f34fa)(flatCoordinates, offset, end, stride, extent[2], extent[1])) return true;
    if ((0, $e804011d1880db52$export$949a7a3a4b6f34fa)(flatCoordinates, offset, end, stride, extent[2], extent[3])) return true;
    return false;
}
function $a3da3236b4fb8b80$export$76dcd8f8f83b6ddb(flatCoordinates, offset, ends, stride, extent) {
    if (!$a3da3236b4fb8b80$export$830a0dafbb2ef1c5(flatCoordinates, offset, ends[0], stride, extent)) return false;
    if (ends.length === 1) return true;
    for(let i = 1, ii = ends.length; i < ii; ++i)if ((0, $e804011d1880db52$export$cedabedc7ac0e138)(flatCoordinates, ends[i - 1], ends[i], stride, extent)) {
        if (!$a3da3236b4fb8b80$export$40d8d71841a3d779(flatCoordinates, ends[i - 1], ends[i], stride, extent)) return false;
    }
    return true;
}
function $a3da3236b4fb8b80$export$77b72fa3792f5bf0(flatCoordinates, offset, endss, stride, extent) {
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        if ($a3da3236b4fb8b80$export$76dcd8f8f83b6ddb(flatCoordinates, offset, ends, stride, extent)) return true;
        offset = ends[ends.length - 1];
    }
    return false;
}


/**
 * @module ol/geom/flat/length
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @return {number} Length.
 */ function $7fdf1ddee27e7a60$export$153f8c6b4d8caebc(flatCoordinates, offset, end, stride) {
    let x1 = flatCoordinates[offset];
    let y1 = flatCoordinates[offset + 1];
    let length = 0;
    for(let i = offset + stride; i < end; i += stride){
        const x2 = flatCoordinates[i];
        const y2 = flatCoordinates[i + 1];
        length += Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
        x1 = x2;
        y1 = y2;
    }
    return length;
}
function $7fdf1ddee27e7a60$export$2bbb4f6f727a75c2(flatCoordinates, offset, end, stride) {
    let perimeter = $7fdf1ddee27e7a60$export$153f8c6b4d8caebc(flatCoordinates, offset, end, stride);
    const dx = flatCoordinates[end - stride] - flatCoordinates[offset];
    const dy = flatCoordinates[end - stride + 1] - flatCoordinates[offset + 1];
    perimeter += Math.sqrt(dx * dx + dy * dy);
    return perimeter;
}



/**
 * @module ol/geom/flat/simplify
 */ // Based on simplify-js https://github.com/mourner/simplify-js
// Copyright (c) 2012, Vladimir Agafonkin
// All rights reserved.
//
// Redistribution and use in source and binary forms, with or without
// modification, are permitted provided that the following conditions are met:
//
//    1. Redistributions of source code must retain the above copyright notice,
//       this list of conditions and the following disclaimer.
//
//    2. Redistributions in binary form must reproduce the above copyright
//       notice, this list of conditions and the following disclaimer in the
//       documentation and/or other materials provided with the distribution.
//
// THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
// AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
// IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
// ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE
// LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
// CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
// SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
// INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
// CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
// ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
// POSSIBILITY OF SUCH DAMAGE.

function $ef1b6889b1cd47c7$export$2cbbcce9030b8734(flatCoordinates, offset, end, stride, squaredTolerance, highQuality, simplifiedFlatCoordinates) {
    simplifiedFlatCoordinates = simplifiedFlatCoordinates !== undefined ? simplifiedFlatCoordinates : [];
    if (!highQuality) {
        end = $ef1b6889b1cd47c7$export$46dba205a0107e9e(flatCoordinates, offset, end, stride, squaredTolerance, simplifiedFlatCoordinates, 0);
        flatCoordinates = simplifiedFlatCoordinates;
        offset = 0;
        stride = 2;
    }
    simplifiedFlatCoordinates.length = $ef1b6889b1cd47c7$export$ef693d1572e64fb8(flatCoordinates, offset, end, stride, squaredTolerance, simplifiedFlatCoordinates, 0);
    return simplifiedFlatCoordinates;
}
function $ef1b6889b1cd47c7$export$ef693d1572e64fb8(flatCoordinates, offset, end, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset) {
    const n = (end - offset) / stride;
    if (n < 3) {
        for(; offset < end; offset += stride){
            simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset];
            simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset + 1];
        }
        return simplifiedOffset;
    }
    /** @type {Array<number>} */ const markers = new Array(n);
    markers[0] = 1;
    markers[n - 1] = 1;
    /** @type {Array<number>} */ const stack = [
        offset,
        end - stride
    ];
    let index = 0;
    while(stack.length > 0){
        const last = stack.pop();
        const first = stack.pop();
        let maxSquaredDistance = 0;
        const x1 = flatCoordinates[first];
        const y1 = flatCoordinates[first + 1];
        const x2 = flatCoordinates[last];
        const y2 = flatCoordinates[last + 1];
        for(let i = first + stride; i < last; i += stride){
            const x = flatCoordinates[i];
            const y = flatCoordinates[i + 1];
            const squaredDistance = (0, $6a95bd76d7103f37$export$251bb0a9cef172e6)(x, y, x1, y1, x2, y2);
            if (squaredDistance > maxSquaredDistance) {
                index = i;
                maxSquaredDistance = squaredDistance;
            }
        }
        if (maxSquaredDistance > squaredTolerance) {
            markers[(index - offset) / stride] = 1;
            if (first + stride < index) stack.push(first, index);
            if (index + stride < last) stack.push(index, last);
        }
    }
    for(let i = 0; i < n; ++i)if (markers[i]) {
        simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset + i * stride];
        simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset + i * stride + 1];
    }
    return simplifiedOffset;
}
function $ef1b6889b1cd47c7$export$cedb9900c0b225c2(flatCoordinates, offset, ends, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEnds) {
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        simplifiedOffset = $ef1b6889b1cd47c7$export$ef693d1572e64fb8(flatCoordinates, offset, end, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset);
        simplifiedEnds.push(simplifiedOffset);
        offset = end;
    }
    return simplifiedOffset;
}
function $ef1b6889b1cd47c7$export$5d74fb54bb752ea0(flatCoordinates, offset, endss, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEndss) {
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        /** @type {Array<number>} */ const simplifiedEnds = [];
        simplifiedOffset = $ef1b6889b1cd47c7$export$cedb9900c0b225c2(flatCoordinates, offset, ends, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEnds);
        simplifiedEndss.push(simplifiedEnds);
        offset = ends[ends.length - 1];
    }
    return simplifiedOffset;
}
function $ef1b6889b1cd47c7$export$46dba205a0107e9e(flatCoordinates, offset, end, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset) {
    if (end <= offset + stride) {
        // zero or one point, no simplification possible, so copy and return
        for(; offset < end; offset += stride){
            simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset];
            simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset + 1];
        }
        return simplifiedOffset;
    }
    let x1 = flatCoordinates[offset];
    let y1 = flatCoordinates[offset + 1];
    // copy first point
    simplifiedFlatCoordinates[simplifiedOffset++] = x1;
    simplifiedFlatCoordinates[simplifiedOffset++] = y1;
    let x2 = x1;
    let y2 = y1;
    for(offset += stride; offset < end; offset += stride){
        x2 = flatCoordinates[offset];
        y2 = flatCoordinates[offset + 1];
        if ((0, $6a95bd76d7103f37$export$88e6ebb4fe54f538)(x1, y1, x2, y2) > squaredTolerance) {
            // copy point at offset
            simplifiedFlatCoordinates[simplifiedOffset++] = x2;
            simplifiedFlatCoordinates[simplifiedOffset++] = y2;
            x1 = x2;
            y1 = y2;
        }
    }
    if (x2 != x1 || y2 != y1) {
        // copy last point
        simplifiedFlatCoordinates[simplifiedOffset++] = x2;
        simplifiedFlatCoordinates[simplifiedOffset++] = y2;
    }
    return simplifiedOffset;
}
function $ef1b6889b1cd47c7$export$51a0620f7a28532b(value, tolerance) {
    return tolerance * Math.round(value / tolerance);
}
function $ef1b6889b1cd47c7$export$b84e8d2c4920a0c6(flatCoordinates, offset, end, stride, tolerance, simplifiedFlatCoordinates, simplifiedOffset) {
    // do nothing if the line is empty
    if (offset == end) return simplifiedOffset;
    // snap the first coordinate (P1)
    let x1 = $ef1b6889b1cd47c7$export$51a0620f7a28532b(flatCoordinates[offset], tolerance);
    let y1 = $ef1b6889b1cd47c7$export$51a0620f7a28532b(flatCoordinates[offset + 1], tolerance);
    offset += stride;
    // add the first coordinate to the output
    simplifiedFlatCoordinates[simplifiedOffset++] = x1;
    simplifiedFlatCoordinates[simplifiedOffset++] = y1;
    // find the next coordinate that does not snap to the same value as the first
    // coordinate (P2)
    let x2, y2;
    do {
        x2 = $ef1b6889b1cd47c7$export$51a0620f7a28532b(flatCoordinates[offset], tolerance);
        y2 = $ef1b6889b1cd47c7$export$51a0620f7a28532b(flatCoordinates[offset + 1], tolerance);
        offset += stride;
        if (offset == end) {
            // all coordinates snap to the same value, the line collapses to a point
            // push the last snapped value anyway to ensure that the output contains
            // at least two points
            // FIXME should we really return at least two points anyway?
            simplifiedFlatCoordinates[simplifiedOffset++] = x2;
            simplifiedFlatCoordinates[simplifiedOffset++] = y2;
            return simplifiedOffset;
        }
    }while (x2 == x1 && y2 == y1);
    while(offset < end){
        // snap the next coordinate (P3)
        const x3 = $ef1b6889b1cd47c7$export$51a0620f7a28532b(flatCoordinates[offset], tolerance);
        const y3 = $ef1b6889b1cd47c7$export$51a0620f7a28532b(flatCoordinates[offset + 1], tolerance);
        offset += stride;
        // skip P3 if it is equal to P2
        if (x3 == x2 && y3 == y2) continue;
        // calculate the delta between P1 and P2
        const dx1 = x2 - x1;
        const dy1 = y2 - y1;
        // calculate the delta between P3 and P1
        const dx2 = x3 - x1;
        const dy2 = y3 - y1;
        // if P1, P2, and P3 are colinear and P3 is further from P1 than P2 is from
        // P1 in the same direction then P2 is on the straight line between P1 and
        // P3
        if (dx1 * dy2 == dy1 * dx2 && (dx1 < 0 && dx2 < dx1 || dx1 == dx2 || dx1 > 0 && dx2 > dx1) && (dy1 < 0 && dy2 < dy1 || dy1 == dy2 || dy1 > 0 && dy2 > dy1)) {
            // discard P2 and set P2 = P3
            x2 = x3;
            y2 = y3;
            continue;
        }
        // either P1, P2, and P3 are not colinear, or they are colinear but P3 is
        // between P3 and P1 or on the opposite half of the line to P2.  add P2,
        // and continue with P1 = P2 and P2 = P3
        simplifiedFlatCoordinates[simplifiedOffset++] = x2;
        simplifiedFlatCoordinates[simplifiedOffset++] = y2;
        x1 = x2;
        y1 = y2;
        x2 = x3;
        y2 = y3;
    }
    // add the last point (P2)
    simplifiedFlatCoordinates[simplifiedOffset++] = x2;
    simplifiedFlatCoordinates[simplifiedOffset++] = y2;
    return simplifiedOffset;
}
function $ef1b6889b1cd47c7$export$60a9904b67f8d51b(flatCoordinates, offset, ends, stride, tolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEnds) {
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        simplifiedOffset = $ef1b6889b1cd47c7$export$b84e8d2c4920a0c6(flatCoordinates, offset, end, stride, tolerance, simplifiedFlatCoordinates, simplifiedOffset);
        simplifiedEnds.push(simplifiedOffset);
        offset = end;
    }
    return simplifiedOffset;
}
function $ef1b6889b1cd47c7$export$b9acf67ef05cd17c(flatCoordinates, offset, endss, stride, tolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEndss) {
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        /** @type {Array<number>} */ const simplifiedEnds = [];
        simplifiedOffset = $ef1b6889b1cd47c7$export$60a9904b67f8d51b(flatCoordinates, offset, ends, stride, tolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEnds);
        simplifiedEndss.push(simplifiedEnds);
        offset = ends[ends.length - 1];
    }
    return simplifiedOffset;
}


/**
 * @classdesc
 * Linestring geometry.
 *
 * @api
 */ class $197b31f867e63891$var$LineString extends (0, $6773c3d7448f46a9$export$2e2bcd8739ae039) {
    /**
   * @param {Array<import("../coordinate.js").Coordinate>|Array<number>} coordinates Coordinates.
   *     For internal use, flat coordinates in combination with `layout` are also accepted.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   */ constructor(coordinates, layout){
        super();
        /**
     * @private
     * @type {import("../coordinate.js").Coordinate|null}
     */ this.flatMidpoint_ = null;
        /**
     * @private
     * @type {number}
     */ this.flatMidpointRevision_ = -1;
        /**
     * @private
     * @type {number}
     */ this.maxDelta_ = -1;
        /**
     * @private
     * @type {number}
     */ this.maxDeltaRevision_ = -1;
        if (layout !== undefined && !Array.isArray(coordinates[0])) this.setFlatCoordinates(layout, /** @type {Array<number>} */ coordinates);
        else this.setCoordinates(/** @type {Array<import("../coordinate.js").Coordinate>} */ coordinates, layout);
    }
    /**
   * Append the passed coordinate to the coordinates of the linestring.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @api
   */ appendCoordinate(coordinate) {
        (0, $49313fcb0fc32abe$export$8b58be045bf06082)(this.flatCoordinates, coordinate);
        this.changed();
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!LineString} Clone.
   * @api
   * @override
   */ clone() {
        const lineString = new $197b31f867e63891$var$LineString(this.flatCoordinates.slice(), this.layout);
        lineString.applyProperties(this);
        return lineString;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   * @override
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, $dea65c2f666fa450$export$cbe64c389534206f)(this.getExtent(), x, y)) return minSquaredDistance;
        if (this.maxDeltaRevision_ != this.getRevision()) {
            this.maxDelta_ = Math.sqrt((0, $41ec661db9892eae$export$bc2eb611ddf80103)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, 0));
            this.maxDeltaRevision_ = this.getRevision();
        }
        return (0, $41ec661db9892eae$export$4adc8e5135fb44c)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, this.maxDelta_, false, x, y, closestPoint, minSquaredDistance);
    }
    /**
   * Iterate over each segment, calling the provided callback.
   * If the callback returns a truthy value the function returns that
   * value immediately. Otherwise the function returns `false`.
   *
   * @param {function(this: S, import("../coordinate.js").Coordinate, import("../coordinate.js").Coordinate): T} callback Function
   *     called for each segment. The function will receive two arguments, the start and end coordinates of the segment.
   * @return {T|boolean} Value.
   * @template T,S
   * @api
   */ forEachSegment(callback) {
        return (0, $1810d616409094a3$export$4b80e395e36b5a56)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, callback);
    }
    /**
   * Returns the coordinate at `m` using linear interpolation, or `null` if no
   * such coordinate exists.
   *
   * `extrapolate` controls extrapolation beyond the range of Ms in the
   * MultiLineString. If `extrapolate` is `true` then Ms less than the first
   * M will return the first coordinate and Ms greater than the last M will
   * return the last coordinate.
   *
   * @param {number} m M.
   * @param {boolean} [extrapolate] Extrapolate. Default is `false`.
   * @return {import("../coordinate.js").Coordinate|null} Coordinate.
   * @api
   */ getCoordinateAtM(m, extrapolate) {
        if (this.layout != 'XYM' && this.layout != 'XYZM') return null;
        extrapolate = extrapolate !== undefined ? extrapolate : false;
        return (0, $f6e4cfe5a0164691$export$8f44c3c220ef6f09)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, m, extrapolate);
    }
    /**
   * Return the coordinates of the linestring.
   * @return {Array<import("../coordinate.js").Coordinate>} Coordinates.
   * @api
   * @override
   */ getCoordinates() {
        return (0, $610a33d138e2ac41$export$9c0934e4e9c3f61e)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
    }
    /**
   * Return the coordinate at the provided fraction along the linestring.
   * The `fraction` is a number between 0 and 1, where 0 is the start of the
   * linestring and 1 is the end.
   * @param {number} fraction Fraction.
   * @param {import("../coordinate.js").Coordinate} [dest] Optional coordinate whose values will
   *     be modified. If not provided, a new coordinate will be returned.
   * @return {import("../coordinate.js").Coordinate} Coordinate of the interpolated point.
   * @api
   */ getCoordinateAt(fraction, dest) {
        return (0, $f6e4cfe5a0164691$export$687ff82efd78795b)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, fraction, dest, this.stride);
    }
    /**
   * Return the length of the linestring on projected plane.
   * @return {number} Length (on projected plane).
   * @api
   */ getLength() {
        return (0, $7fdf1ddee27e7a60$export$153f8c6b4d8caebc)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
    }
    /**
   * @return {Array<number>} Flat midpoint.
   */ getFlatMidpoint() {
        if (this.flatMidpointRevision_ != this.getRevision()) {
            this.flatMidpoint_ = this.getCoordinateAt(0.5, this.flatMidpoint_ ?? undefined);
            this.flatMidpointRevision_ = this.getRevision();
        }
        return /** @type {Array<number>} */ this.flatMidpoint_;
    }
    /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {LineString} Simplified LineString.
   * @protected
   * @override
   */ getSimplifiedGeometryInternal(squaredTolerance) {
        /** @type {Array<number>} */ const simplifiedFlatCoordinates = [];
        simplifiedFlatCoordinates.length = (0, $ef1b6889b1cd47c7$export$ef693d1572e64fb8)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, squaredTolerance, simplifiedFlatCoordinates, 0);
        return new $197b31f867e63891$var$LineString(simplifiedFlatCoordinates, 'XY');
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   * @override
   */ getType() {
        return 'LineString';
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   * @override
   */ intersectsExtent(extent) {
        return (0, $a3da3236b4fb8b80$export$40d8d71841a3d779)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, extent, this.getExtent());
    }
    /**
   * Set the coordinates of the linestring.
   * @param {!Array<import("../coordinate.js").Coordinate>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   * @override
   */ setCoordinates(coordinates, layout) {
        this.setLayout(layout, coordinates, 1);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        this.flatCoordinates.length = (0, $f96815e1fef680b1$export$5c4daf67e03c190f)(this.flatCoordinates, 0, coordinates, this.stride);
        this.changed();
    }
}
var $197b31f867e63891$export$2e2bcd8739ae039 = $197b31f867e63891$var$LineString;


/**
 * @module ol/geom/MultiLineString
 */ 










/**
 * @classdesc
 * Multi-linestring geometry.
 *
 * @api
 */ class $96d2138ace1f7d2d$var$MultiLineString extends (0, $6773c3d7448f46a9$export$2e2bcd8739ae039) {
    /**
   * @param {Array<Array<import("../coordinate.js").Coordinate>|LineString>|Array<number>} coordinates
   *     Coordinates or LineString geometries. (For internal use, flat coordinates in
   *     combination with `layout` and `ends` are also accepted.)
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @param {Array<number>} [ends] Flat coordinate ends for internal use.
   */ constructor(coordinates, layout, ends){
        super();
        /**
     * @type {Array<number>}
     * @private
     */ this.ends_ = [];
        /**
     * @private
     * @type {number}
     */ this.maxDelta_ = -1;
        /**
     * @private
     * @type {number}
     */ this.maxDeltaRevision_ = -1;
        if (Array.isArray(coordinates[0])) this.setCoordinates(/** @type {Array<Array<import("../coordinate.js").Coordinate>>} */ coordinates, layout);
        else if (layout !== undefined && ends) {
            this.setFlatCoordinates(layout, /** @type {Array<number>} */ coordinates);
            this.ends_ = ends;
        } else {
            const lineStrings = /** @type {Array<LineString>} */ coordinates;
            /** @type {Array<number>} */ const flatCoordinates = [];
            const ends = [];
            for(let i = 0, ii = lineStrings.length; i < ii; ++i){
                const lineString = lineStrings[i];
                (0, $49313fcb0fc32abe$export$8b58be045bf06082)(flatCoordinates, lineString.getFlatCoordinates());
                ends.push(flatCoordinates.length);
            }
            const layout = lineStrings.length === 0 ? this.getLayout() : lineStrings[0].getLayout();
            this.setFlatCoordinates(layout, flatCoordinates);
            this.ends_ = ends;
        }
    }
    /**
   * Append the passed linestring to the multilinestring.
   * @param {LineString} lineString LineString.
   * @api
   */ appendLineString(lineString) {
        (0, $49313fcb0fc32abe$export$8b58be045bf06082)(this.flatCoordinates, lineString.getFlatCoordinates().slice());
        this.ends_.push(this.flatCoordinates.length);
        this.changed();
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!MultiLineString} Clone.
   * @api
   * @override
   */ clone() {
        const multiLineString = new $96d2138ace1f7d2d$var$MultiLineString(this.flatCoordinates.slice(), this.layout, this.ends_.slice());
        multiLineString.applyProperties(this);
        return multiLineString;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   * @override
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, $dea65c2f666fa450$export$cbe64c389534206f)(this.getExtent(), x, y)) return minSquaredDistance;
        if (this.maxDeltaRevision_ != this.getRevision()) {
            this.maxDelta_ = Math.sqrt((0, $41ec661db9892eae$export$fbf31c8f2668ed5a)(this.flatCoordinates, 0, this.ends_, this.stride, 0));
            this.maxDeltaRevision_ = this.getRevision();
        }
        return (0, $41ec661db9892eae$export$5a48a0eefcf14992)(this.flatCoordinates, 0, this.ends_, this.stride, this.maxDelta_, false, x, y, closestPoint, minSquaredDistance);
    }
    /**
   * Returns the coordinate at `m` using linear interpolation, or `null` if no
   * such coordinate exists.
   *
   * `extrapolate` controls extrapolation beyond the range of Ms in the
   * MultiLineString. If `extrapolate` is `true` then Ms less than the first
   * M will return the first coordinate and Ms greater than the last M will
   * return the last coordinate.
   *
   * `interpolate` controls interpolation between consecutive LineStrings
   * within the MultiLineString. If `interpolate` is `true` the coordinates
   * will be linearly interpolated between the last coordinate of one LineString
   * and the first coordinate of the next LineString.  If `interpolate` is
   * `false` then the function will return `null` for Ms falling between
   * LineStrings.
   *
   * @param {number} m M.
   * @param {boolean} [extrapolate] Extrapolate. Default is `false`.
   * @param {boolean} [interpolate] Interpolate. Default is `false`.
   * @return {import("../coordinate.js").Coordinate|null} Coordinate.
   * @api
   */ getCoordinateAtM(m, extrapolate, interpolate) {
        if (this.layout != 'XYM' && this.layout != 'XYZM' || this.flatCoordinates.length === 0) return null;
        extrapolate = extrapolate !== undefined ? extrapolate : false;
        interpolate = interpolate !== undefined ? interpolate : false;
        return (0, $f6e4cfe5a0164691$export$6a3300857e9ef453)(this.flatCoordinates, 0, this.ends_, this.stride, m, extrapolate, interpolate);
    }
    /**
   * Return the coordinates of the multilinestring.
   * @return {Array<Array<import("../coordinate.js").Coordinate>>} Coordinates.
   * @api
   * @override
   */ getCoordinates() {
        return (0, $610a33d138e2ac41$export$cbb9596fc0f40db2)(this.flatCoordinates, 0, this.ends_, this.stride);
    }
    /**
   * @return {Array<number>} Ends.
   */ getEnds() {
        return this.ends_;
    }
    /**
   * Return the linestring at the specified index.
   * @param {number} index Index.
   * @return {LineString} LineString.
   * @api
   */ getLineString(index) {
        if (index < 0 || this.ends_.length <= index) return null;
        return new (0, $197b31f867e63891$export$2e2bcd8739ae039)(this.flatCoordinates.slice(index === 0 ? 0 : this.ends_[index - 1], this.ends_[index]), this.layout);
    }
    /**
   * Return the linestrings of this multilinestring.
   * @return {Array<LineString>} LineStrings.
   * @api
   */ getLineStrings() {
        const flatCoordinates = this.flatCoordinates;
        const ends = this.ends_;
        const layout = this.layout;
        /** @type {Array<LineString>} */ const lineStrings = [];
        let offset = 0;
        for(let i = 0, ii = ends.length; i < ii; ++i){
            const end = ends[i];
            const lineString = new (0, $197b31f867e63891$export$2e2bcd8739ae039)(flatCoordinates.slice(offset, end), layout);
            lineStrings.push(lineString);
            offset = end;
        }
        return lineStrings;
    }
    /**
   * Return the sum of all line string lengths
   * @return {number} Length (on projected plane).
   * @api
   */ getLength() {
        const ends = this.ends_;
        let start = 0;
        let length = 0;
        for(let i = 0, ii = ends.length; i < ii; ++i){
            length += (0, $7fdf1ddee27e7a60$export$153f8c6b4d8caebc)(this.flatCoordinates, start, ends[i], this.stride);
            start = ends[i];
        }
        return length;
    }
    /**
   * @return {Array<number>} Flat midpoints.
   */ getFlatMidpoints() {
        /** @type {Array<number>} */ const midpoints = [];
        const flatCoordinates = this.flatCoordinates;
        let offset = 0;
        const ends = this.ends_;
        const stride = this.stride;
        for(let i = 0, ii = ends.length; i < ii; ++i){
            const end = ends[i];
            const midpoint = (0, $f6e4cfe5a0164691$export$687ff82efd78795b)(flatCoordinates, offset, end, stride, 0.5);
            (0, $49313fcb0fc32abe$export$8b58be045bf06082)(midpoints, midpoint);
            offset = end;
        }
        return midpoints;
    }
    /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {MultiLineString} Simplified MultiLineString.
   * @protected
   * @override
   */ getSimplifiedGeometryInternal(squaredTolerance) {
        /** @type {Array<number>} */ const simplifiedFlatCoordinates = [];
        /** @type {Array<number>} */ const simplifiedEnds = [];
        simplifiedFlatCoordinates.length = (0, $ef1b6889b1cd47c7$export$cedb9900c0b225c2)(this.flatCoordinates, 0, this.ends_, this.stride, squaredTolerance, simplifiedFlatCoordinates, 0, simplifiedEnds);
        return new $96d2138ace1f7d2d$var$MultiLineString(simplifiedFlatCoordinates, 'XY', simplifiedEnds);
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   * @override
   */ getType() {
        return 'MultiLineString';
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   * @override
   */ intersectsExtent(extent) {
        return (0, $a3da3236b4fb8b80$export$fdb1d8e850bf7937)(this.flatCoordinates, 0, this.ends_, this.stride, extent);
    }
    /**
   * Set the coordinates of the multilinestring.
   * @param {!Array<Array<import("../coordinate.js").Coordinate>>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   * @override
   */ setCoordinates(coordinates, layout) {
        this.setLayout(layout, coordinates, 2);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        const ends = (0, $f96815e1fef680b1$export$47c3746a74384d45)(this.flatCoordinates, 0, coordinates, this.stride, this.ends_);
        this.flatCoordinates.length = ends.length === 0 ? 0 : ends[ends.length - 1];
        this.changed();
    }
}
var $96d2138ace1f7d2d$export$2e2bcd8739ae039 = $96d2138ace1f7d2d$var$MultiLineString;


/**
 * @module ol/geom/MultiPoint
 */ 


/**
 * @module ol/geom/Point
 */ 



/**
 * @classdesc
 * Point geometry.
 *
 * @api
 */ class $3153df5f3993c8ca$var$Point extends (0, $6773c3d7448f46a9$export$2e2bcd8739ae039) {
    /**
   * @param {import("../coordinate.js").Coordinate} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   */ constructor(coordinates, layout){
        super();
        this.setCoordinates(coordinates, layout);
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!Point} Clone.
   * @api
   * @override
   */ clone() {
        const point = new $3153df5f3993c8ca$var$Point(this.flatCoordinates.slice(), this.layout);
        point.applyProperties(this);
        return point;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   * @override
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        const flatCoordinates = this.flatCoordinates;
        const squaredDistance = (0, $6a95bd76d7103f37$export$88e6ebb4fe54f538)(x, y, flatCoordinates[0], flatCoordinates[1]);
        if (squaredDistance < minSquaredDistance) {
            const stride = this.stride;
            for(let i = 0; i < stride; ++i)closestPoint[i] = flatCoordinates[i];
            closestPoint.length = stride;
            return squaredDistance;
        }
        return minSquaredDistance;
    }
    /**
   * Return the coordinate of the point.
   * @return {import("../coordinate.js").Coordinate} Coordinates.
   * @api
   * @override
   */ getCoordinates() {
        return this.flatCoordinates.slice();
    }
    /**
   * @param {import("../extent.js").Extent} extent Extent.
   * @protected
   * @return {import("../extent.js").Extent} extent Extent.
   * @override
   */ computeExtent(extent) {
        return (0, $dea65c2f666fa450$export$4838bf78d04a9440)(this.flatCoordinates, extent);
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   * @override
   */ getType() {
        return 'Point';
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   * @override
   */ intersectsExtent(extent) {
        return (0, $dea65c2f666fa450$export$805bdfd6d6690e97)(extent, this.flatCoordinates[0], this.flatCoordinates[1]);
    }
    /**
   * @param {!Array<*>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   * @override
   */ setCoordinates(coordinates, layout) {
        this.setLayout(layout, coordinates, 0);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        this.flatCoordinates.length = (0, $f96815e1fef680b1$export$60815ead40ec79ab)(this.flatCoordinates, 0, coordinates, this.stride);
        this.changed();
    }
}
var $3153df5f3993c8ca$export$2e2bcd8739ae039 = $3153df5f3993c8ca$var$Point;





/**
 * @classdesc
 * Multi-point geometry.
 *
 * @api
 */ class $1a0594f8edc26022$var$MultiPoint extends (0, $6773c3d7448f46a9$export$2e2bcd8739ae039) {
    /**
   * @param {Array<import("../coordinate.js").Coordinate>|Array<number>} coordinates Coordinates.
   *     For internal use, flat coordinates in combination with `layout` are also accepted.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   */ constructor(coordinates, layout){
        super();
        if (layout && !Array.isArray(coordinates[0])) this.setFlatCoordinates(layout, /** @type {Array<number>} */ coordinates);
        else this.setCoordinates(/** @type {Array<import("../coordinate.js").Coordinate>} */ coordinates, layout);
    }
    /**
   * Append the passed point to this multipoint.
   * @param {Point} point Point.
   * @api
   */ appendPoint(point) {
        (0, $49313fcb0fc32abe$export$8b58be045bf06082)(this.flatCoordinates, point.getFlatCoordinates());
        this.changed();
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!MultiPoint} Clone.
   * @api
   * @override
   */ clone() {
        const multiPoint = new $1a0594f8edc26022$var$MultiPoint(this.flatCoordinates.slice(), this.layout);
        multiPoint.applyProperties(this);
        return multiPoint;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   * @override
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, $dea65c2f666fa450$export$cbe64c389534206f)(this.getExtent(), x, y)) return minSquaredDistance;
        const flatCoordinates = this.flatCoordinates;
        const stride = this.stride;
        for(let i = 0, ii = flatCoordinates.length; i < ii; i += stride){
            const squaredDistance = (0, $6a95bd76d7103f37$export$88e6ebb4fe54f538)(x, y, flatCoordinates[i], flatCoordinates[i + 1]);
            if (squaredDistance < minSquaredDistance) {
                minSquaredDistance = squaredDistance;
                for(let j = 0; j < stride; ++j)closestPoint[j] = flatCoordinates[i + j];
                closestPoint.length = stride;
            }
        }
        return minSquaredDistance;
    }
    /**
   * Return the coordinates of the multipoint.
   * @return {Array<import("../coordinate.js").Coordinate>} Coordinates.
   * @api
   * @override
   */ getCoordinates() {
        return (0, $610a33d138e2ac41$export$9c0934e4e9c3f61e)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
    }
    /**
   * Return the point at the specified index.
   * @param {number} index Index.
   * @return {Point} Point.
   * @api
   */ getPoint(index) {
        const n = this.flatCoordinates.length / this.stride;
        if (index < 0 || n <= index) return null;
        return new (0, $3153df5f3993c8ca$export$2e2bcd8739ae039)(this.flatCoordinates.slice(index * this.stride, (index + 1) * this.stride), this.layout);
    }
    /**
   * Return the points of this multipoint.
   * @return {Array<Point>} Points.
   * @api
   */ getPoints() {
        const flatCoordinates = this.flatCoordinates;
        const layout = this.layout;
        const stride = this.stride;
        /** @type {Array<Point>} */ const points = [];
        for(let i = 0, ii = flatCoordinates.length; i < ii; i += stride){
            const point = new (0, $3153df5f3993c8ca$export$2e2bcd8739ae039)(flatCoordinates.slice(i, i + stride), layout);
            points.push(point);
        }
        return points;
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   * @override
   */ getType() {
        return 'MultiPoint';
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   * @override
   */ intersectsExtent(extent) {
        const flatCoordinates = this.flatCoordinates;
        const stride = this.stride;
        for(let i = 0, ii = flatCoordinates.length; i < ii; i += stride){
            const x = flatCoordinates[i];
            const y = flatCoordinates[i + 1];
            if ((0, $dea65c2f666fa450$export$805bdfd6d6690e97)(extent, x, y)) return true;
        }
        return false;
    }
    /**
   * Set the coordinates of the multipoint.
   * @param {!Array<import("../coordinate.js").Coordinate>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   * @override
   */ setCoordinates(coordinates, layout) {
        this.setLayout(layout, coordinates, 1);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        this.flatCoordinates.length = (0, $f96815e1fef680b1$export$5c4daf67e03c190f)(this.flatCoordinates, 0, coordinates, this.stride);
        this.changed();
    }
}
var $1a0594f8edc26022$export$2e2bcd8739ae039 = $1a0594f8edc26022$var$MultiPoint;


/**
 * @module ol/geom/MultiPolygon
 */ 


/**
 * @module ol/geom/Polygon
 */ 



/**
 * @module ol/geom/LinearRing
 */ 

/**
 * @module ol/geom/flat/area
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @return {number} Area.
 */ function $d8ea9706eb1df367$export$3c5e1905f889266e(flatCoordinates, offset, end, stride) {
    let twiceArea = 0;
    const x0 = flatCoordinates[end - stride];
    const y0 = flatCoordinates[end - stride + 1];
    let dx1 = 0;
    let dy1 = 0;
    for(; offset < end; offset += stride){
        const dx2 = flatCoordinates[offset] - x0;
        const dy2 = flatCoordinates[offset + 1] - y0;
        twiceArea += dy1 * dx2 - dx1 * dy2;
        dx1 = dx2;
        dy1 = dy2;
    }
    return twiceArea / 2;
}
function $d8ea9706eb1df367$export$7a8ee541dfdf2ed5(flatCoordinates, offset, ends, stride) {
    let area = 0;
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        area += $d8ea9706eb1df367$export$3c5e1905f889266e(flatCoordinates, offset, end, stride);
        offset = end;
    }
    return area;
}
function $d8ea9706eb1df367$export$78e139679ca7205(flatCoordinates, offset, endss, stride) {
    let area = 0;
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        area += $d8ea9706eb1df367$export$7a8ee541dfdf2ed5(flatCoordinates, offset, ends, stride);
        offset = ends[ends.length - 1];
    }
    return area;
}






/**
 * @classdesc
 * Linear ring geometry. Only used as part of polygon; cannot be rendered
 * on its own.
 *
 * @api
 */ class $8903322e1c6b4e74$var$LinearRing extends (0, $6773c3d7448f46a9$export$2e2bcd8739ae039) {
    /**
   * @param {Array<import("../coordinate.js").Coordinate>|Array<number>} coordinates Coordinates.
   *     For internal use, flat coordinates in combination with `layout` are also accepted.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   */ constructor(coordinates, layout){
        super();
        /**
     * @private
     * @type {number}
     */ this.maxDelta_ = -1;
        /**
     * @private
     * @type {number}
     */ this.maxDeltaRevision_ = -1;
        if (layout !== undefined && !Array.isArray(coordinates[0])) this.setFlatCoordinates(layout, /** @type {Array<number>} */ coordinates);
        else this.setCoordinates(/** @type {Array<import("../coordinate.js").Coordinate>} */ coordinates, layout);
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!LinearRing} Clone.
   * @api
   * @override
   */ clone() {
        return new $8903322e1c6b4e74$var$LinearRing(this.flatCoordinates.slice(), this.layout);
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   * @override
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, $dea65c2f666fa450$export$cbe64c389534206f)(this.getExtent(), x, y)) return minSquaredDistance;
        if (this.maxDeltaRevision_ != this.getRevision()) {
            this.maxDelta_ = Math.sqrt((0, $41ec661db9892eae$export$bc2eb611ddf80103)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, 0));
            this.maxDeltaRevision_ = this.getRevision();
        }
        return (0, $41ec661db9892eae$export$4adc8e5135fb44c)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, this.maxDelta_, true, x, y, closestPoint, minSquaredDistance);
    }
    /**
   * Return the area of the linear ring on projected plane.
   * @return {number} Area (on projected plane).
   * @api
   */ getArea() {
        return (0, $d8ea9706eb1df367$export$3c5e1905f889266e)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
    }
    /**
   * Return the coordinates of the linear ring.
   * @return {Array<import("../coordinate.js").Coordinate>} Coordinates.
   * @api
   * @override
   */ getCoordinates() {
        return (0, $610a33d138e2ac41$export$9c0934e4e9c3f61e)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
    }
    /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {LinearRing} Simplified LinearRing.
   * @protected
   * @override
   */ getSimplifiedGeometryInternal(squaredTolerance) {
        /** @type {Array<number>} */ const simplifiedFlatCoordinates = [];
        simplifiedFlatCoordinates.length = (0, $ef1b6889b1cd47c7$export$ef693d1572e64fb8)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, squaredTolerance, simplifiedFlatCoordinates, 0);
        return new $8903322e1c6b4e74$var$LinearRing(simplifiedFlatCoordinates, 'XY');
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   * @override
   */ getType() {
        return 'LinearRing';
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   * @override
   */ intersectsExtent(extent) {
        return false;
    }
    /**
   * Set the coordinates of the linear ring.
   * @param {!Array<import("../coordinate.js").Coordinate>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   * @override
   */ setCoordinates(coordinates, layout) {
        this.setLayout(layout, coordinates, 1);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        this.flatCoordinates.length = (0, $f96815e1fef680b1$export$5c4daf67e03c190f)(this.flatCoordinates, 0, coordinates, this.stride);
        this.changed();
    }
}
var $8903322e1c6b4e74$export$2e2bcd8739ae039 = $8903322e1c6b4e74$var$LinearRing;









/**
 * @module ol/geom/flat/interiorpoint
 */ 

function $f9f97325685b7fc5$export$50e3b25928a5e892(flatCoordinates, offset, ends, stride, flatCenters, flatCentersOffset, dest) {
    let i, ii, x, x1, x2, y1, y2;
    const y = flatCenters[flatCentersOffset + 1];
    /** @type {Array<number>} */ const intersections = [];
    // Calculate intersections with the horizontal line
    for(let r = 0, rr = ends.length; r < rr; ++r){
        const end = ends[r];
        x1 = flatCoordinates[end - stride];
        y1 = flatCoordinates[end - stride + 1];
        for(i = offset; i < end; i += stride){
            x2 = flatCoordinates[i];
            y2 = flatCoordinates[i + 1];
            if (y <= y1 && y2 <= y || y1 <= y && y <= y2) {
                x = (y - y1) / (y2 - y1) * (x2 - x1) + x1;
                intersections.push(x);
            }
            x1 = x2;
            y1 = y2;
        }
    }
    // Find the longest segment of the horizontal line that has its center point
    // inside the linear ring.
    let pointX = NaN;
    let maxSegmentLength = -Infinity;
    intersections.sort((0, $49313fcb0fc32abe$export$fcb633242ef15540));
    x1 = intersections[0];
    for(i = 1, ii = intersections.length; i < ii; ++i){
        x2 = intersections[i];
        const segmentLength = Math.abs(x2 - x1);
        if (segmentLength > maxSegmentLength) {
            x = (x1 + x2) / 2;
            if ((0, $e804011d1880db52$export$ae868c0f6acc3355)(flatCoordinates, offset, ends, stride, x, y)) {
                pointX = x;
                maxSegmentLength = segmentLength;
            }
        }
        x1 = x2;
    }
    if (isNaN(pointX)) // There is no horizontal line that has its center point inside the linear
    // ring.  Use the center of the the linear ring's extent.
    pointX = flatCenters[flatCentersOffset];
    if (dest) {
        dest.push(pointX, y, maxSegmentLength);
        return dest;
    }
    return [
        pointX,
        y,
        maxSegmentLength
    ];
}
function $f9f97325685b7fc5$export$11463803eda8a372(flatCoordinates, offset, endss, stride, flatCenters) {
    /** @type {Array<number>} */ let interiorPoints = [];
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        interiorPoints = $f9f97325685b7fc5$export$50e3b25928a5e892(flatCoordinates, offset, ends, stride, flatCenters, 2 * i, interiorPoints);
        offset = ends[ends.length - 1];
    }
    return interiorPoints;
}



/**
 * @module ol/geom/flat/orient
 */ /**
 * @module ol/geom/flat/reverse
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 */ function $a0c3442dfe2d78d0$export$741858880c96b18c(flatCoordinates, offset, end, stride) {
    while(offset < end - stride){
        for(let i = 0; i < stride; ++i){
            const tmp = flatCoordinates[offset + i];
            flatCoordinates[offset + i] = flatCoordinates[end - stride + i];
            flatCoordinates[end - stride + i] = tmp;
        }
        offset += stride;
        end -= stride;
    }
}


function $b3d5fb016ac290e8$export$318f2842ed17e094(flatCoordinates, offset, end, stride) {
    // https://stackoverflow.com/q/1165647/clockwise-method#1165943
    // https://github.com/OSGeo/gdal/blob/master/gdal/ogr/ogrlinearring.cpp
    let edge = 0;
    let x1 = flatCoordinates[end - stride];
    let y1 = flatCoordinates[end - stride + 1];
    for(; offset < end; offset += stride){
        const x2 = flatCoordinates[offset];
        const y2 = flatCoordinates[offset + 1];
        edge += (x2 - x1) * (y2 + y1);
        x1 = x2;
        y1 = y2;
    }
    return edge === 0 ? undefined : edge > 0;
}
function $b3d5fb016ac290e8$export$f27cd06e85f4ba28(flatCoordinates, offset, ends, stride, right) {
    right = right !== undefined ? right : false;
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        const isClockwise = $b3d5fb016ac290e8$export$318f2842ed17e094(flatCoordinates, offset, end, stride);
        if (i === 0) {
            if (right && isClockwise || !right && !isClockwise) return false;
        } else {
            if (right && !isClockwise || !right && isClockwise) return false;
        }
        offset = end;
    }
    return true;
}
function $b3d5fb016ac290e8$export$a1d138f4bd85f4b4(flatCoordinates, offset, endss, stride, right) {
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        if (!$b3d5fb016ac290e8$export$f27cd06e85f4ba28(flatCoordinates, offset, ends, stride, right)) return false;
        if (ends.length) offset = ends[ends.length - 1];
    }
    return true;
}
function $b3d5fb016ac290e8$export$b71b604ddfc778c7(flatCoordinates, offset, ends, stride, right) {
    right = right !== undefined ? right : false;
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        const isClockwise = $b3d5fb016ac290e8$export$318f2842ed17e094(flatCoordinates, offset, end, stride);
        const reverse = i === 0 ? right && isClockwise || !right && !isClockwise : right && !isClockwise || !right && isClockwise;
        if (reverse) (0, $a0c3442dfe2d78d0$export$741858880c96b18c)(flatCoordinates, offset, end, stride);
        offset = end;
    }
    return offset;
}
function $b3d5fb016ac290e8$export$ea9ed55fc2a85010(flatCoordinates, offset, endss, stride, right) {
    for(let i = 0, ii = endss.length; i < ii; ++i)offset = $b3d5fb016ac290e8$export$b71b604ddfc778c7(flatCoordinates, offset, endss[i], stride, right);
    return offset;
}
function $b3d5fb016ac290e8$export$cb72ae403d6e78e6(flatCoordinates, ends) {
    const endss = [];
    let offset = 0;
    let prevEndIndex = 0;
    let startOrientation;
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        // classifies an array of rings into polygons with outer rings and holes
        const orientation = $b3d5fb016ac290e8$export$318f2842ed17e094(flatCoordinates, offset, end, 2);
        if (startOrientation === undefined) startOrientation = orientation;
        if (orientation === startOrientation) endss.push(ends.slice(prevEndIndex, i + 1));
        else {
            if (endss.length === 0) continue;
            endss[endss.length - 1].push(ends[prevEndIndex]);
        }
        prevEndIndex = i + 1;
        offset = end;
    }
    return endss;
}



/**
 * @classdesc
 * Polygon geometry.
 *
 * @api
 */ class $52cb54ac72de6b07$var$Polygon extends (0, $6773c3d7448f46a9$export$2e2bcd8739ae039) {
    /**
   * @param {!Array<Array<import("../coordinate.js").Coordinate>>|!Array<number>} coordinates
   *     Array of linear rings that define the polygon. The first linear ring of the
   *     array defines the outer-boundary or surface of the polygon. Each subsequent
   *     linear ring defines a hole in the surface of the polygon. A linear ring is
   *     an array of vertices' coordinates where the first coordinate and the last are
   *     equivalent. (For internal use, flat coordinates in combination with
   *     `layout` and `ends` are also accepted.)
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @param {Array<number>} [ends] Ends (for internal use with flat coordinates).
   */ constructor(coordinates, layout, ends){
        super();
        /**
     * @type {Array<number>}
     * @private
     */ this.ends_ = [];
        /**
     * @private
     * @type {number}
     */ this.flatInteriorPointRevision_ = -1;
        /**
     * @private
     * @type {import("../coordinate.js").Coordinate|null}
     */ this.flatInteriorPoint_ = null;
        /**
     * @private
     * @type {number}
     */ this.maxDelta_ = -1;
        /**
     * @private
     * @type {number}
     */ this.maxDeltaRevision_ = -1;
        /**
     * @private
     * @type {number}
     */ this.orientedRevision_ = -1;
        /**
     * @private
     * @type {Array<number>|null}
     */ this.orientedFlatCoordinates_ = null;
        if (layout !== undefined && ends) {
            this.setFlatCoordinates(layout, /** @type {Array<number>} */ coordinates);
            this.ends_ = ends;
        } else this.setCoordinates(/** @type {Array<Array<import("../coordinate.js").Coordinate>>} */ coordinates, layout);
    }
    /**
   * Append the passed linear ring to this polygon.
   * @param {LinearRing} linearRing Linear ring.
   * @api
   */ appendLinearRing(linearRing) {
        if (!this.flatCoordinates) this.flatCoordinates = linearRing.getFlatCoordinates().slice();
        else (0, $49313fcb0fc32abe$export$8b58be045bf06082)(this.flatCoordinates, linearRing.getFlatCoordinates());
        this.ends_.push(this.flatCoordinates.length);
        this.changed();
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!Polygon} Clone.
   * @api
   * @override
   */ clone() {
        const polygon = new $52cb54ac72de6b07$var$Polygon(this.flatCoordinates.slice(), this.layout, this.ends_.slice());
        polygon.applyProperties(this);
        return polygon;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   * @override
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, $dea65c2f666fa450$export$cbe64c389534206f)(this.getExtent(), x, y)) return minSquaredDistance;
        if (this.maxDeltaRevision_ != this.getRevision()) {
            this.maxDelta_ = Math.sqrt((0, $41ec661db9892eae$export$fbf31c8f2668ed5a)(this.flatCoordinates, 0, this.ends_, this.stride, 0));
            this.maxDeltaRevision_ = this.getRevision();
        }
        return (0, $41ec661db9892eae$export$5a48a0eefcf14992)(this.flatCoordinates, 0, this.ends_, this.stride, this.maxDelta_, true, x, y, closestPoint, minSquaredDistance);
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @return {boolean} Contains (x, y).
   * @override
   */ containsXY(x, y) {
        return (0, $e804011d1880db52$export$ae868c0f6acc3355)(this.getOrientedFlatCoordinates(), 0, this.ends_, this.stride, x, y);
    }
    /**
   * Return the area of the polygon on projected plane.
   * @return {number} Area (on projected plane).
   * @api
   */ getArea() {
        return (0, $d8ea9706eb1df367$export$7a8ee541dfdf2ed5)(this.getOrientedFlatCoordinates(), 0, this.ends_, this.stride);
    }
    /**
   * Get the coordinate array for this geometry.  This array has the structure
   * of a GeoJSON coordinate array for polygons.
   *
   * @param {boolean} [right] Orient coordinates according to the right-hand
   *     rule (counter-clockwise for exterior and clockwise for interior rings).
   *     If `false`, coordinates will be oriented according to the left-hand rule
   *     (clockwise for exterior and counter-clockwise for interior rings).
   *     By default, coordinate orientation will depend on how the geometry was
   *     constructed.
   * @return {Array<Array<import("../coordinate.js").Coordinate>>} Coordinates.
   * @api
   * @override
   */ getCoordinates(right) {
        let flatCoordinates;
        if (right !== undefined) {
            flatCoordinates = this.getOrientedFlatCoordinates().slice();
            (0, $b3d5fb016ac290e8$export$b71b604ddfc778c7)(flatCoordinates, 0, this.ends_, this.stride, right);
        } else flatCoordinates = this.flatCoordinates;
        return (0, $610a33d138e2ac41$export$cbb9596fc0f40db2)(flatCoordinates, 0, this.ends_, this.stride);
    }
    /**
   * @return {Array<number>} Ends.
   */ getEnds() {
        return this.ends_;
    }
    /**
   * @return {Array<number>} Interior point.
   */ getFlatInteriorPoint() {
        if (this.flatInteriorPointRevision_ != this.getRevision()) {
            const flatCenter = (0, $dea65c2f666fa450$export$c91255cadecfe081)(this.getExtent());
            this.flatInteriorPoint_ = (0, $f9f97325685b7fc5$export$50e3b25928a5e892)(this.getOrientedFlatCoordinates(), 0, this.ends_, this.stride, flatCenter, 0);
            this.flatInteriorPointRevision_ = this.getRevision();
        }
        return /** @type {import("../coordinate.js").Coordinate} */ this.flatInteriorPoint_;
    }
    /**
   * Return an interior point of the polygon.
   * @return {Point} Interior point as XYM coordinate, where M is the
   * length of the horizontal intersection that the point belongs to.
   * @api
   */ getInteriorPoint() {
        return new (0, $3153df5f3993c8ca$export$2e2bcd8739ae039)(this.getFlatInteriorPoint(), 'XYM');
    }
    /**
   * Return the number of rings of the polygon,  this includes the exterior
   * ring and any interior rings.
   *
   * @return {number} Number of rings.
   * @api
   */ getLinearRingCount() {
        return this.ends_.length;
    }
    /**
   * Return the Nth linear ring of the polygon geometry. Return `null` if the
   * given index is out of range.
   * The exterior linear ring is available at index `0` and the interior rings
   * at index `1` and beyond.
   *
   * @param {number} index Index.
   * @return {LinearRing|null} Linear ring.
   * @api
   */ getLinearRing(index) {
        if (index < 0 || this.ends_.length <= index) return null;
        return new (0, $8903322e1c6b4e74$export$2e2bcd8739ae039)(this.flatCoordinates.slice(index === 0 ? 0 : this.ends_[index - 1], this.ends_[index]), this.layout);
    }
    /**
   * Return the linear rings of the polygon.
   * @return {Array<LinearRing>} Linear rings.
   * @api
   */ getLinearRings() {
        const layout = this.layout;
        const flatCoordinates = this.flatCoordinates;
        const ends = this.ends_;
        const linearRings = [];
        let offset = 0;
        for(let i = 0, ii = ends.length; i < ii; ++i){
            const end = ends[i];
            const linearRing = new (0, $8903322e1c6b4e74$export$2e2bcd8739ae039)(flatCoordinates.slice(offset, end), layout);
            linearRings.push(linearRing);
            offset = end;
        }
        return linearRings;
    }
    /**
   * @return {Array<number>} Oriented flat coordinates.
   */ getOrientedFlatCoordinates() {
        if (this.orientedRevision_ != this.getRevision()) {
            const flatCoordinates = this.flatCoordinates;
            if ((0, $b3d5fb016ac290e8$export$f27cd06e85f4ba28)(flatCoordinates, 0, this.ends_, this.stride)) this.orientedFlatCoordinates_ = flatCoordinates;
            else {
                this.orientedFlatCoordinates_ = flatCoordinates.slice();
                this.orientedFlatCoordinates_.length = (0, $b3d5fb016ac290e8$export$b71b604ddfc778c7)(this.orientedFlatCoordinates_, 0, this.ends_, this.stride);
            }
            this.orientedRevision_ = this.getRevision();
        }
        return /** @type {Array<number>} */ this.orientedFlatCoordinates_;
    }
    /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {Polygon} Simplified Polygon.
   * @protected
   * @override
   */ getSimplifiedGeometryInternal(squaredTolerance) {
        /** @type {Array<number>} */ const simplifiedFlatCoordinates = [];
        /** @type {Array<number>} */ const simplifiedEnds = [];
        simplifiedFlatCoordinates.length = (0, $ef1b6889b1cd47c7$export$60a9904b67f8d51b)(this.flatCoordinates, 0, this.ends_, this.stride, Math.sqrt(squaredTolerance), simplifiedFlatCoordinates, 0, simplifiedEnds);
        return new $52cb54ac72de6b07$var$Polygon(simplifiedFlatCoordinates, 'XY', simplifiedEnds);
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   * @override
   */ getType() {
        return 'Polygon';
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   * @override
   */ intersectsExtent(extent) {
        return (0, $a3da3236b4fb8b80$export$76dcd8f8f83b6ddb)(this.getOrientedFlatCoordinates(), 0, this.ends_, this.stride, extent);
    }
    /**
   * Set the coordinates of the polygon.
   * @param {!Array<Array<import("../coordinate.js").Coordinate>>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   * @override
   */ setCoordinates(coordinates, layout) {
        this.setLayout(layout, coordinates, 2);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        const ends = (0, $f96815e1fef680b1$export$47c3746a74384d45)(this.flatCoordinates, 0, coordinates, this.stride, this.ends_);
        this.flatCoordinates.length = ends.length === 0 ? 0 : ends[ends.length - 1];
        this.changed();
    }
}
var $52cb54ac72de6b07$export$2e2bcd8739ae039 = $52cb54ac72de6b07$var$Polygon;
function $52cb54ac72de6b07$export$f99d756c6d81ae3f(center, radius, n, sphereRadius) {
    n = n ? n : 32;
    /** @type {Array<number>} */ const flatCoordinates = [];
    for(let i = 0; i < n; ++i)(0, $49313fcb0fc32abe$export$8b58be045bf06082)(flatCoordinates, (0, $42da4f557dd38010$export$cc800923e997bb8)(center, radius, 2 * Math.PI * i / n, sphereRadius));
    flatCoordinates.push(flatCoordinates[0], flatCoordinates[1]);
    return new $52cb54ac72de6b07$var$Polygon(flatCoordinates, 'XY', [
        flatCoordinates.length
    ]);
}
function $52cb54ac72de6b07$export$c16b671815801c75(extent) {
    if ((0, $dea65c2f666fa450$export$dd1bc94b04021eeb)(extent)) throw new Error('Cannot create polygon from empty extent');
    const minX = extent[0];
    const minY = extent[1];
    const maxX = extent[2];
    const maxY = extent[3];
    const flatCoordinates = [
        minX,
        minY,
        minX,
        maxY,
        maxX,
        maxY,
        maxX,
        minY,
        minX,
        minY
    ];
    return new $52cb54ac72de6b07$var$Polygon(flatCoordinates, 'XY', [
        flatCoordinates.length
    ]);
}
function $52cb54ac72de6b07$export$2451009d645fb8c2(circle, sides, angle) {
    sides = sides ? sides : 32;
    const stride = circle.getStride();
    const layout = circle.getLayout();
    const center = circle.getCenter();
    const arrayLength = stride * (sides + 1);
    const flatCoordinates = new Array(arrayLength);
    for(let i = 0; i < arrayLength; i += stride){
        flatCoordinates[i] = 0;
        flatCoordinates[i + 1] = 0;
        for(let j = 2; j < stride; j++)flatCoordinates[i + j] = center[j];
    }
    const ends = [
        flatCoordinates.length
    ];
    const polygon = new $52cb54ac72de6b07$var$Polygon(flatCoordinates, layout, ends);
    $52cb54ac72de6b07$export$87d6a1539a56e47f(polygon, center, circle.getRadius(), angle);
    return polygon;
}
function $52cb54ac72de6b07$export$87d6a1539a56e47f(polygon, center, radius, angle) {
    const flatCoordinates = polygon.getFlatCoordinates();
    const stride = polygon.getStride();
    const sides = flatCoordinates.length / stride - 1;
    const startAngle = angle ? angle : 0;
    for(let i = 0; i <= sides; ++i){
        const offset = i * stride;
        const angle = startAngle + (0, $6a95bd76d7103f37$export$ba467bec01d66def)(i, sides) * 2 * Math.PI / sides;
        flatCoordinates[offset] = center[0] + radius * Math.cos(angle);
        flatCoordinates[offset + 1] = center[1] + radius * Math.sin(angle);
    }
    polygon.changed();
}




/**
 * @module ol/geom/flat/center
 */ 
function $a6eabf68a211b76c$export$78e139679ca7205(flatCoordinates, offset, endss, stride) {
    const flatCenters = [];
    let extent = (0, $dea65c2f666fa450$export$fe201bb3bbe031e9)();
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        extent = (0, $dea65c2f666fa450$export$be0ab0bf96ca59ca)(flatCoordinates, offset, ends[0], stride);
        flatCenters.push((extent[0] + extent[2]) / 2, (extent[1] + extent[3]) / 2);
        offset = ends[ends.length - 1];
    }
    return flatCenters;
}










/**
 * @classdesc
 * Multi-polygon geometry.
 *
 * @api
 */ class $71dd1c600460678c$var$MultiPolygon extends (0, $6773c3d7448f46a9$export$2e2bcd8739ae039) {
    /**
   * @param {Array<Array<Array<import("../coordinate.js").Coordinate>>|Polygon>|Array<number>} coordinates Coordinates.
   *     For internal use, flat coordinates in combination with `layout` and `endss` are also accepted.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @param {Array<Array<number>>} [endss] Array of ends for internal use with flat coordinates.
   */ constructor(coordinates, layout, endss){
        super();
        /**
     * @type {Array<Array<number>>}
     * @private
     */ this.endss_ = [];
        /**
     * @private
     * @type {number}
     */ this.flatInteriorPointsRevision_ = -1;
        /**
     * @private
     * @type {Array<number>|null}
     */ this.flatInteriorPoints_ = null;
        /**
     * @private
     * @type {number}
     */ this.maxDelta_ = -1;
        /**
     * @private
     * @type {number}
     */ this.maxDeltaRevision_ = -1;
        /**
     * @private
     * @type {number}
     */ this.orientedRevision_ = -1;
        /**
     * @private
     * @type {Array<number>|null}
     */ this.orientedFlatCoordinates_ = null;
        if (!endss && !Array.isArray(coordinates[0])) {
            const polygons = /** @type {Array<Polygon>} */ coordinates;
            /** @type {Array<number>} */ const flatCoordinates = [];
            const thisEndss = [];
            for(let i = 0, ii = polygons.length; i < ii; ++i){
                const polygon = polygons[i];
                const offset = flatCoordinates.length;
                const ends = polygon.getEnds();
                for(let j = 0, jj = ends.length; j < jj; ++j)ends[j] += offset;
                (0, $49313fcb0fc32abe$export$8b58be045bf06082)(flatCoordinates, polygon.getFlatCoordinates());
                thisEndss.push(ends);
            }
            layout = polygons.length === 0 ? this.getLayout() : polygons[0].getLayout();
            coordinates = flatCoordinates;
            endss = thisEndss;
        }
        if (layout !== undefined && endss) {
            this.setFlatCoordinates(layout, /** @type {Array<number>} */ coordinates);
            this.endss_ = endss;
        } else this.setCoordinates(/** @type {Array<Array<Array<import("../coordinate.js").Coordinate>>>} */ coordinates, layout);
    }
    /**
   * Append the passed polygon to this multipolygon.
   * @param {Polygon} polygon Polygon.
   * @api
   */ appendPolygon(polygon) {
        /** @type {Array<number>} */ let ends;
        if (!this.flatCoordinates) {
            this.flatCoordinates = polygon.getFlatCoordinates().slice();
            ends = polygon.getEnds().slice();
            this.endss_.push();
        } else {
            const offset = this.flatCoordinates.length;
            (0, $49313fcb0fc32abe$export$8b58be045bf06082)(this.flatCoordinates, polygon.getFlatCoordinates());
            ends = polygon.getEnds().slice();
            for(let i = 0, ii = ends.length; i < ii; ++i)ends[i] += offset;
        }
        this.endss_.push(ends);
        this.changed();
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!MultiPolygon} Clone.
   * @api
   * @override
   */ clone() {
        const len = this.endss_.length;
        const newEndss = new Array(len);
        for(let i = 0; i < len; ++i)newEndss[i] = this.endss_[i].slice();
        const multiPolygon = new $71dd1c600460678c$var$MultiPolygon(this.flatCoordinates.slice(), this.layout, newEndss);
        multiPolygon.applyProperties(this);
        return multiPolygon;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   * @override
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, $dea65c2f666fa450$export$cbe64c389534206f)(this.getExtent(), x, y)) return minSquaredDistance;
        if (this.maxDeltaRevision_ != this.getRevision()) {
            this.maxDelta_ = Math.sqrt((0, $41ec661db9892eae$export$37c18e6e7d50501a)(this.flatCoordinates, 0, this.endss_, this.stride, 0));
            this.maxDeltaRevision_ = this.getRevision();
        }
        return (0, $41ec661db9892eae$export$60e067685eb8f9c4)(this.getOrientedFlatCoordinates(), 0, this.endss_, this.stride, this.maxDelta_, true, x, y, closestPoint, minSquaredDistance);
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @return {boolean} Contains (x, y).
   * @override
   */ containsXY(x, y) {
        return (0, $e804011d1880db52$export$c760d9d16cf92043)(this.getOrientedFlatCoordinates(), 0, this.endss_, this.stride, x, y);
    }
    /**
   * Return the area of the multipolygon on projected plane.
   * @return {number} Area (on projected plane).
   * @api
   */ getArea() {
        return (0, $d8ea9706eb1df367$export$78e139679ca7205)(this.getOrientedFlatCoordinates(), 0, this.endss_, this.stride);
    }
    /**
   * Get the coordinate array for this geometry.  This array has the structure
   * of a GeoJSON coordinate array for multi-polygons.
   *
   * @param {boolean} [right] Orient coordinates according to the right-hand
   *     rule (counter-clockwise for exterior and clockwise for interior rings).
   *     If `false`, coordinates will be oriented according to the left-hand rule
   *     (clockwise for exterior and counter-clockwise for interior rings).
   *     By default, coordinate orientation will depend on how the geometry was
   *     constructed.
   * @return {Array<Array<Array<import("../coordinate.js").Coordinate>>>} Coordinates.
   * @api
   * @override
   */ getCoordinates(right) {
        let flatCoordinates;
        if (right !== undefined) {
            flatCoordinates = this.getOrientedFlatCoordinates().slice();
            (0, $b3d5fb016ac290e8$export$ea9ed55fc2a85010)(flatCoordinates, 0, this.endss_, this.stride, right);
        } else flatCoordinates = this.flatCoordinates;
        return (0, $610a33d138e2ac41$export$915c7058aeb4dfeb)(flatCoordinates, 0, this.endss_, this.stride);
    }
    /**
   * @return {Array<Array<number>>} Endss.
   */ getEndss() {
        return this.endss_;
    }
    /**
   * @return {Array<number>} Flat interior points.
   */ getFlatInteriorPoints() {
        if (this.flatInteriorPointsRevision_ != this.getRevision()) {
            const flatCenters = (0, $a6eabf68a211b76c$export$78e139679ca7205)(this.flatCoordinates, 0, this.endss_, this.stride);
            this.flatInteriorPoints_ = (0, $f9f97325685b7fc5$export$11463803eda8a372)(this.getOrientedFlatCoordinates(), 0, this.endss_, this.stride, flatCenters);
            this.flatInteriorPointsRevision_ = this.getRevision();
        }
        return /** @type {Array<number>} */ this.flatInteriorPoints_;
    }
    /**
   * Return the interior points as {@link module:ol/geom/MultiPoint~MultiPoint multipoint}.
   * @return {MultiPoint} Interior points as XYM coordinates, where M is
   * the length of the horizontal intersection that the point belongs to.
   * @api
   */ getInteriorPoints() {
        return new (0, $1a0594f8edc26022$export$2e2bcd8739ae039)(this.getFlatInteriorPoints().slice(), 'XYM');
    }
    /**
   * @return {Array<number>} Oriented flat coordinates.
   */ getOrientedFlatCoordinates() {
        if (this.orientedRevision_ != this.getRevision()) {
            const flatCoordinates = this.flatCoordinates;
            if ((0, $b3d5fb016ac290e8$export$a1d138f4bd85f4b4)(flatCoordinates, 0, this.endss_, this.stride)) this.orientedFlatCoordinates_ = flatCoordinates;
            else {
                this.orientedFlatCoordinates_ = flatCoordinates.slice();
                this.orientedFlatCoordinates_.length = (0, $b3d5fb016ac290e8$export$ea9ed55fc2a85010)(this.orientedFlatCoordinates_, 0, this.endss_, this.stride);
            }
            this.orientedRevision_ = this.getRevision();
        }
        return /** @type {Array<number>} */ this.orientedFlatCoordinates_;
    }
    /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {MultiPolygon} Simplified MultiPolygon.
   * @protected
   * @override
   */ getSimplifiedGeometryInternal(squaredTolerance) {
        /** @type {Array<number>} */ const simplifiedFlatCoordinates = [];
        /** @type {Array<Array<number>>} */ const simplifiedEndss = [];
        simplifiedFlatCoordinates.length = (0, $ef1b6889b1cd47c7$export$b9acf67ef05cd17c)(this.flatCoordinates, 0, this.endss_, this.stride, Math.sqrt(squaredTolerance), simplifiedFlatCoordinates, 0, simplifiedEndss);
        return new $71dd1c600460678c$var$MultiPolygon(simplifiedFlatCoordinates, 'XY', simplifiedEndss);
    }
    /**
   * Return the polygon at the specified index.
   * @param {number} index Index.
   * @return {Polygon} Polygon.
   * @api
   */ getPolygon(index) {
        if (index < 0 || this.endss_.length <= index) return null;
        let offset;
        if (index === 0) offset = 0;
        else {
            const prevEnds = this.endss_[index - 1];
            offset = prevEnds[prevEnds.length - 1];
        }
        const ends = this.endss_[index].slice();
        const end = ends[ends.length - 1];
        if (offset !== 0) for(let i = 0, ii = ends.length; i < ii; ++i)ends[i] -= offset;
        return new (0, $52cb54ac72de6b07$export$2e2bcd8739ae039)(this.flatCoordinates.slice(offset, end), this.layout, ends);
    }
    /**
   * Return the polygons of this multipolygon.
   * @return {Array<Polygon>} Polygons.
   * @api
   */ getPolygons() {
        const layout = this.layout;
        const flatCoordinates = this.flatCoordinates;
        const endss = this.endss_;
        const polygons = [];
        let offset = 0;
        for(let i = 0, ii = endss.length; i < ii; ++i){
            const ends = endss[i].slice();
            const end = ends[ends.length - 1];
            if (offset !== 0) for(let j = 0, jj = ends.length; j < jj; ++j)ends[j] -= offset;
            const polygon = new (0, $52cb54ac72de6b07$export$2e2bcd8739ae039)(flatCoordinates.slice(offset, end), layout, ends);
            polygons.push(polygon);
            offset = end;
        }
        return polygons;
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   * @override
   */ getType() {
        return 'MultiPolygon';
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   * @override
   */ intersectsExtent(extent) {
        return (0, $a3da3236b4fb8b80$export$77b72fa3792f5bf0)(this.getOrientedFlatCoordinates(), 0, this.endss_, this.stride, extent);
    }
    /**
   * Set the coordinates of the multipolygon.
   * @param {!Array<Array<Array<import("../coordinate.js").Coordinate>>>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   * @override
   */ setCoordinates(coordinates, layout) {
        this.setLayout(layout, coordinates, 3);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        const endss = (0, $f96815e1fef680b1$export$f9f2bb59da4accd3)(this.flatCoordinates, 0, coordinates, this.stride, this.endss_);
        if (endss.length === 0) this.flatCoordinates.length = 0;
        else {
            const lastEnds = endss[endss.length - 1];
            this.flatCoordinates.length = lastEnds.length === 0 ? 0 : lastEnds[lastEnds.length - 1];
        }
        this.changed();
    }
}
var $71dd1c600460678c$export$2e2bcd8739ae039 = $71dd1c600460678c$var$MultiPolygon;




/**
 * @module ol/format/Feature
 */ 



/**
 * @module ol/render/Feature
 */ 












/**
 * @typedef {'Point' | 'LineString' | 'LinearRing' | 'Polygon' | 'MultiPoint' | 'MultiLineString'} Type
 * The geometry type.  One of `'Point'`, `'LineString'`, `'LinearRing'`,
 * `'Polygon'`, `'MultiPoint'` or 'MultiLineString'`.
 */ /**
 * @type {import("../transform.js").Transform}
 */ const $e5b428c112c9c5d6$var$tmpTransform = (0, $dff5a03e015694d8$export$185802fd694ee1f5)();
/**
 * Lightweight, read-only, {@link module:ol/Feature~Feature} and {@link module:ol/geom/Geometry~Geometry} like
 * structure, optimized for vector tile rendering and styling. Geometry access
 * through the API is limited to getting the type and extent of the geometry.
 */ class $e5b428c112c9c5d6$var$RenderFeature {
    /**
   * @param {Type} type Geometry type.
   * @param {Array<number>} flatCoordinates Flat coordinates. These always need
   *     to be right-handed for polygons.
   * @param {Array<number>} ends Ends.
   * @param {number} stride Stride.
   * @param {Object<string, *>} properties Properties.
   * @param {number|string|undefined} id Feature id.
   */ constructor(type, flatCoordinates, ends, stride, properties, id){
        /**
     * @type {import("../style/Style.js").StyleFunction|undefined}
     */ this.styleFunction;
        /**
     * @private
     * @type {import("../extent.js").Extent|undefined}
     */ this.extent_;
        /**
     * @private
     * @type {number|string|undefined}
     */ this.id_ = id;
        /**
     * @private
     * @type {Type}
     */ this.type_ = type;
        /**
     * @private
     * @type {Array<number>}
     */ this.flatCoordinates_ = flatCoordinates;
        /**
     * @private
     * @type {Array<number>}
     */ this.flatInteriorPoints_ = null;
        /**
     * @private
     * @type {Array<number>}
     */ this.flatMidpoints_ = null;
        /**
     * @private
     * @type {Array<number>|null}
     */ this.ends_ = ends || null;
        /**
     * @private
     * @type {Object<string, *>}
     */ this.properties_ = properties;
        /**
     * @private
     * @type {number}
     */ this.squaredTolerance_;
        /**
     * @private
     * @type {number}
     */ this.stride_ = stride;
        /**
     * @private
     * @type {RenderFeature}
     */ this.simplifiedGeometry_;
    }
    /**
   * Get a feature property by its key.
   * @param {string} key Key
   * @return {*} Value for the requested key.
   * @api
   */ get(key) {
        return this.properties_[key];
    }
    /**
   * Get the extent of this feature's geometry.
   * @return {import("../extent.js").Extent} Extent.
   * @api
   */ getExtent() {
        if (!this.extent_) this.extent_ = this.type_ === 'Point' ? (0, $dea65c2f666fa450$export$4838bf78d04a9440)(this.flatCoordinates_) : (0, $dea65c2f666fa450$export$be0ab0bf96ca59ca)(this.flatCoordinates_, 0, this.flatCoordinates_.length, 2);
        return this.extent_;
    }
    /**
   * @return {Array<number>} Flat interior points.
   */ getFlatInteriorPoint() {
        if (!this.flatInteriorPoints_) {
            const flatCenter = (0, $dea65c2f666fa450$export$c91255cadecfe081)(this.getExtent());
            this.flatInteriorPoints_ = (0, $f9f97325685b7fc5$export$50e3b25928a5e892)(this.flatCoordinates_, 0, this.ends_, 2, flatCenter, 0);
        }
        return this.flatInteriorPoints_;
    }
    /**
   * @return {Array<number>} Flat interior points.
   */ getFlatInteriorPoints() {
        if (!this.flatInteriorPoints_) {
            const ends = (0, $b3d5fb016ac290e8$export$cb72ae403d6e78e6)(this.flatCoordinates_, this.ends_);
            const flatCenters = (0, $a6eabf68a211b76c$export$78e139679ca7205)(this.flatCoordinates_, 0, ends, 2);
            this.flatInteriorPoints_ = (0, $f9f97325685b7fc5$export$11463803eda8a372)(this.flatCoordinates_, 0, ends, 2, flatCenters);
        }
        return this.flatInteriorPoints_;
    }
    /**
   * @return {Array<number>} Flat midpoint.
   */ getFlatMidpoint() {
        if (!this.flatMidpoints_) this.flatMidpoints_ = (0, $f6e4cfe5a0164691$export$687ff82efd78795b)(this.flatCoordinates_, 0, this.flatCoordinates_.length, 2, 0.5);
        return this.flatMidpoints_;
    }
    /**
   * @return {Array<number>} Flat midpoints.
   */ getFlatMidpoints() {
        if (!this.flatMidpoints_) {
            this.flatMidpoints_ = [];
            const flatCoordinates = this.flatCoordinates_;
            let offset = 0;
            const ends = /** @type {Array<number>} */ this.ends_;
            for(let i = 0, ii = ends.length; i < ii; ++i){
                const end = ends[i];
                const midpoint = (0, $f6e4cfe5a0164691$export$687ff82efd78795b)(flatCoordinates, offset, end, 2, 0.5);
                (0, $49313fcb0fc32abe$export$8b58be045bf06082)(this.flatMidpoints_, midpoint);
                offset = end;
            }
        }
        return this.flatMidpoints_;
    }
    /**
   * Get the feature identifier.  This is a stable identifier for the feature and
   * is set when reading data from a remote source.
   * @return {number|string|undefined} Id.
   * @api
   */ getId() {
        return this.id_;
    }
    /**
   * @return {Array<number>} Flat coordinates.
   */ getOrientedFlatCoordinates() {
        return this.flatCoordinates_;
    }
    /**
   * For API compatibility with {@link module:ol/Feature~Feature}, this method is useful when
   * determining the geometry type in style function (see {@link #getType}).
   * @return {RenderFeature} Feature.
   * @api
   */ getGeometry() {
        return this;
    }
    /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {RenderFeature} Simplified geometry.
   */ getSimplifiedGeometry(squaredTolerance) {
        return this;
    }
    /**
   * Get a transformed and simplified version of the geometry.
   * @param {number} squaredTolerance Squared tolerance.
   * @param {import("../proj.js").TransformFunction} [transform] Optional transform function.
   * @return {RenderFeature} Simplified geometry.
   */ simplifyTransformed(squaredTolerance, transform) {
        return this;
    }
    /**
   * Get the feature properties.
   * @return {Object<string, *>} Feature properties.
   * @api
   */ getProperties() {
        return this.properties_;
    }
    /**
   * Get an object of all property names and values.  This has the same behavior as getProperties,
   * but is here to conform with the {@link module:ol/Feature~Feature} interface.
   * @return {Object<string, *>?} Object.
   */ getPropertiesInternal() {
        return this.properties_;
    }
    /**
   * @return {number} Stride.
   */ getStride() {
        return this.stride_;
    }
    /**
   * @return {import('../style/Style.js').StyleFunction|undefined} Style
   */ getStyleFunction() {
        return this.styleFunction;
    }
    /**
   * Get the type of this feature's geometry.
   * @return {Type} Geometry type.
   * @api
   */ getType() {
        return this.type_;
    }
    /**
   * Transform geometry coordinates from tile pixel space to projected.
   *
   * @param {import("../proj.js").ProjectionLike} projection The data projection
   */ transform(projection) {
        projection = (0, $a86eee1c28205a05$export$3988ae62b71be9a3)(projection);
        const pixelExtent = projection.getExtent();
        const projectedExtent = projection.getWorldExtent();
        if (pixelExtent && projectedExtent) {
            const scale = (0, $dea65c2f666fa450$export$c08559766941f856)(projectedExtent) / (0, $dea65c2f666fa450$export$c08559766941f856)(pixelExtent);
            (0, $dff5a03e015694d8$export$f672e0b6f7222cd7)($e5b428c112c9c5d6$var$tmpTransform, projectedExtent[0], projectedExtent[3], scale, -scale, 0, 0, 0);
            (0, $d95a11593b39996c$export$b92b2dedcfff79de)(this.flatCoordinates_, 0, this.flatCoordinates_.length, 2, $e5b428c112c9c5d6$var$tmpTransform, this.flatCoordinates_);
        }
    }
    /**
   * Apply a transform function to the coordinates of the geometry.
   * The geometry is modified in place.
   * If you do not want the geometry modified in place, first `clone()` it and
   * then use this function on the clone.
   * @param {import("../proj.js").TransformFunction} transformFn Transform function.
   */ applyTransform(transformFn) {
        transformFn(this.flatCoordinates_, this.flatCoordinates_, this.stride_);
    }
    /**
   * @return {RenderFeature} A cloned render feature.
   */ clone() {
        return new $e5b428c112c9c5d6$var$RenderFeature(this.type_, this.flatCoordinates_.slice(), this.ends_?.slice(), this.stride_, Object.assign({}, this.properties_), this.id_);
    }
    /**
   * @return {Array<number>|null} Ends.
   */ getEnds() {
        return this.ends_;
    }
    /**
   * Add transform and resolution based geometry simplification to this instance.
   * @return {RenderFeature} This render feature.
   */ enableSimplifyTransformed() {
        this.simplifyTransformed = (0, $bc15bca7780ad95b$export$ff83df6f9971435f)((squaredTolerance, transform)=>{
            if (squaredTolerance === this.squaredTolerance_) return this.simplifiedGeometry_;
            this.simplifiedGeometry_ = this.clone();
            if (transform) this.simplifiedGeometry_.applyTransform(transform);
            const simplifiedFlatCoordinates = this.simplifiedGeometry_.getFlatCoordinates();
            let simplifiedEnds;
            switch(this.type_){
                case 'LineString':
                    simplifiedFlatCoordinates.length = (0, $ef1b6889b1cd47c7$export$ef693d1572e64fb8)(simplifiedFlatCoordinates, 0, this.simplifiedGeometry_.flatCoordinates_.length, this.simplifiedGeometry_.stride_, squaredTolerance, simplifiedFlatCoordinates, 0);
                    simplifiedEnds = [
                        simplifiedFlatCoordinates.length
                    ];
                    break;
                case 'MultiLineString':
                    simplifiedEnds = [];
                    simplifiedFlatCoordinates.length = (0, $ef1b6889b1cd47c7$export$cedb9900c0b225c2)(simplifiedFlatCoordinates, 0, this.simplifiedGeometry_.ends_, this.simplifiedGeometry_.stride_, squaredTolerance, simplifiedFlatCoordinates, 0, simplifiedEnds);
                    break;
                case 'Polygon':
                    simplifiedEnds = [];
                    simplifiedFlatCoordinates.length = (0, $ef1b6889b1cd47c7$export$60a9904b67f8d51b)(simplifiedFlatCoordinates, 0, this.simplifiedGeometry_.ends_, this.simplifiedGeometry_.stride_, Math.sqrt(squaredTolerance), simplifiedFlatCoordinates, 0, simplifiedEnds);
                    break;
                default:
            }
            if (simplifiedEnds) this.simplifiedGeometry_ = new $e5b428c112c9c5d6$var$RenderFeature(this.type_, simplifiedFlatCoordinates, simplifiedEnds, 2, this.properties_, this.id_);
            this.squaredTolerance_ = squaredTolerance;
            return this.simplifiedGeometry_;
        });
        return this;
    }
}
/**
 * @return {Array<number>} Flat coordinates.
 */ $e5b428c112c9c5d6$var$RenderFeature.prototype.getFlatCoordinates = $e5b428c112c9c5d6$var$RenderFeature.prototype.getOrientedFlatCoordinates;
function $e5b428c112c9c5d6$export$b89ab3d1d30dec84(renderFeature) {
    const geometryType = renderFeature.getType();
    switch(geometryType){
        case 'Point':
            return new (0, $3153df5f3993c8ca$export$2e2bcd8739ae039)(renderFeature.getFlatCoordinates());
        case 'MultiPoint':
            return new (0, $1a0594f8edc26022$export$2e2bcd8739ae039)(renderFeature.getFlatCoordinates(), 'XY');
        case 'LineString':
            return new (0, $197b31f867e63891$export$2e2bcd8739ae039)(renderFeature.getFlatCoordinates(), 'XY');
        case 'MultiLineString':
            return new (0, $96d2138ace1f7d2d$export$2e2bcd8739ae039)(renderFeature.getFlatCoordinates(), 'XY', /** @type {Array<number>} */ renderFeature.getEnds());
        case 'Polygon':
            const flatCoordinates = renderFeature.getFlatCoordinates();
            const ends = renderFeature.getEnds();
            const endss = (0, $b3d5fb016ac290e8$export$cb72ae403d6e78e6)(flatCoordinates, ends);
            return endss.length > 1 ? new (0, $71dd1c600460678c$export$2e2bcd8739ae039)(flatCoordinates, 'XY', endss) : new (0, $52cb54ac72de6b07$export$2e2bcd8739ae039)(flatCoordinates, 'XY', ends);
        default:
            throw new Error('Invalid geometry type:' + geometryType);
    }
}
function $e5b428c112c9c5d6$export$ab19ba60efd1c4b5(renderFeature, geometryName) {
    const id = renderFeature.getId();
    const geometry = $e5b428c112c9c5d6$export$b89ab3d1d30dec84(renderFeature);
    const properties = renderFeature.getProperties();
    const feature = new (0, $df26d2327ced1fa9$export$2e2bcd8739ae039)();
    if (geometryName !== undefined) feature.setGeometryName(geometryName);
    feature.setGeometry(geometry);
    if (id !== undefined) feature.setId(id);
    feature.setProperties(properties, true);
    return feature;
}
var $e5b428c112c9c5d6$export$2e2bcd8739ae039 = $e5b428c112c9c5d6$var$RenderFeature;



/**
 * @typedef {Object} ReadOptions
 * @property {import("../proj.js").ProjectionLike} [dataProjection] Projection of the data we are reading.
 * If not provided, the projection will be derived from the data (where possible) or
 * the `dataProjection` of the format is assigned (where set). If the projection
 * can not be derived from the data and if no `dataProjection` is set for a format,
 * the features will not be reprojected.
 * @property {import("../extent.js").Extent} [extent] Tile extent in map units of the tile being read.
 * This is only required when reading data with tile pixels as geometry units. When configured,
 * a `dataProjection` with `TILE_PIXELS` as `units` and the tile's pixel extent as `extent` needs to be
 * provided.
 * @property {import("../proj.js").ProjectionLike} [featureProjection] Projection of the feature geometries
 * created by the format reader. If not provided, features will be returned in the
 * `dataProjection`.
 */ /**
 * @typedef {Object} WriteOptions
 * @property {import("../proj.js").ProjectionLike} [dataProjection] Projection of the data we are writing.
 * If not provided, the `dataProjection` of the format is assigned (where set).
 * If no `dataProjection` is set for a format, the features will be returned
 * in the `featureProjection`.
 * @property {import("../proj.js").ProjectionLike} [featureProjection] Projection of the feature geometries
 * that will be serialized by the format writer. If not provided, geometries are assumed
 * to be in the `dataProjection` if that is set; in other words, they are not transformed.
 * @property {boolean} [rightHanded] When writing geometries, follow the right-hand
 * rule for linear ring orientation.  This means that polygons will have counter-clockwise
 * exterior rings and clockwise interior rings.  By default, coordinates are serialized
 * as they are provided at construction.  If `true`, the right-hand rule will
 * be applied.  If `false`, the left-hand rule will be applied (clockwise for
 * exterior and counter-clockwise for interior rings).  Note that not all
 * formats support this.  The GeoJSON format does use this property when writing
 * geometries.
 * @property {number} [decimals] Maximum number of decimal places for coordinates.
 * Coordinates are stored internally as floats, but floating-point arithmetic can create
 * coordinates with a large number of decimal places, not generally wanted on output.
 * Set a number here to round coordinates. Can also be used to ensure that
 * coordinates read in can be written back out with the same number of decimals.
 * Default is no rounding.
 */ /**
 * @typedef {'arraybuffer' | 'json' | 'text' | 'xml'} Type
 */ /**
 * @typedef {Object} SimpleGeometryObject
 * @property {import('../geom/Geometry.js').Type} type Type.
 * @property {Array<number>} flatCoordinates Flat coordinates.
 * @property {Array<number>|Array<Array<number>>} [ends] Ends or endss.
 * @property {import('../geom/Geometry.js').GeometryLayout} [layout] Layout.
 */ /**
 * @typedef {Array<GeometryObject>} GeometryCollectionObject
 */ /**
 * @typedef {SimpleGeometryObject|GeometryCollectionObject} GeometryObject
 */ /**
 * @typedef {Object} FeatureObject
 * @property {string|number} [id] Id.
 * @property {GeometryObject} [geometry] Geometry.
 * @property {Object<string, *>} [properties] Properties.
 */ /***
 * @template {import('../Feature.js').FeatureLike} T
 * @typedef {T extends RenderFeature ? typeof RenderFeature : typeof Feature} FeatureToFeatureClass
 */ /***
 * @template {import("../Feature.js").FeatureClass} T
 * @typedef {T[keyof T] extends RenderFeature ? RenderFeature : Feature} FeatureClassToFeature
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Base class for feature formats.
 * {@link module:ol/format/Feature~FeatureFormat} subclasses provide the ability to decode and encode
 * {@link module:ol/Feature~Feature} objects from a variety of commonly used geospatial
 * file formats.  See the documentation for each format for more details.
 *
 * @template {import('../Feature.js').FeatureLike} [FeatureType=import("../Feature.js").default]
 * @abstract
 * @api
 */ class $6510197ad3cc0360$var$FeatureFormat {
    constructor(){
        /**
     * @protected
     * @type {import("../proj/Projection.js").default|undefined}
     */ this.dataProjection = undefined;
        /**
     * @protected
     * @type {import("../proj/Projection.js").default|undefined}
     */ this.defaultFeatureProjection = undefined;
        /**
     * @protected
     * @type {FeatureToFeatureClass<FeatureType>}
     */ this.featureClass = /** @type {FeatureToFeatureClass<FeatureType>} */ (0, $df26d2327ced1fa9$export$2e2bcd8739ae039);
        /**
     * A list media types supported by the format in descending order of preference.
     * @type {Array<string>}
     */ this.supportedMediaTypes = null;
    }
    /**
   * Adds the data projection to the read options.
   * @param {Document|Element|Object|string} source Source.
   * @param {ReadOptions} [options] Options.
   * @return {ReadOptions|undefined} Options.
   * @protected
   */ getReadOptions(source, options) {
        if (options) {
            let dataProjection = options.dataProjection ? (0, $a86eee1c28205a05$export$3988ae62b71be9a3)(options.dataProjection) : this.readProjection(source);
            if (options.extent && dataProjection && dataProjection.getUnits() === 'tile-pixels') {
                dataProjection = (0, $a86eee1c28205a05$export$3988ae62b71be9a3)(dataProjection);
                dataProjection.setWorldExtent(options.extent);
            }
            options = {
                dataProjection: dataProjection,
                featureProjection: options.featureProjection
            };
        }
        return this.adaptOptions(options);
    }
    /**
   * Sets the `dataProjection` on the options, if no `dataProjection`
   * is set.
   * @param {WriteOptions|ReadOptions|undefined} options
   *     Options.
   * @protected
   * @return {WriteOptions|ReadOptions|undefined}
   *     Updated options.
   */ adaptOptions(options) {
        return Object.assign({
            dataProjection: this.dataProjection,
            featureProjection: this.defaultFeatureProjection,
            featureClass: this.featureClass
        }, options);
    }
    /**
   * @abstract
   * @return {Type} The format type.
   */ getType() {
        return (0, $fd76d391cc228565$export$817eb92a8194bab0)();
    }
    /**
   * Read a single feature from a source.
   *
   * @abstract
   * @param {Document|Element|Object|string} source Source.
   * @param {ReadOptions} [options] Read options.
   * @return {FeatureType|Array<FeatureType>} Feature.
   */ readFeature(source, options) {
        return (0, $fd76d391cc228565$export$817eb92a8194bab0)();
    }
    /**
   * Read all features from a source.
   *
   * @abstract
   * @param {Document|Element|ArrayBuffer|Object|string} source Source.
   * @param {ReadOptions} [options] Read options.
   * @return {Array<FeatureType>} Features.
   */ readFeatures(source, options) {
        return (0, $fd76d391cc228565$export$817eb92a8194bab0)();
    }
    /**
   * Read a single geometry from a source.
   *
   * @abstract
   * @param {Document|Element|Object|string} source Source.
   * @param {ReadOptions} [options] Read options.
   * @return {import("../geom/Geometry.js").default} Geometry.
   */ readGeometry(source, options) {
        return (0, $fd76d391cc228565$export$817eb92a8194bab0)();
    }
    /**
   * Read the projection from a source.
   *
   * @abstract
   * @param {Document|Element|Object|string} source Source.
   * @return {import("../proj/Projection.js").default|undefined} Projection.
   */ readProjection(source) {
        return (0, $fd76d391cc228565$export$817eb92a8194bab0)();
    }
    /**
   * Encode a feature in this format.
   *
   * @abstract
   * @param {Feature} feature Feature.
   * @param {WriteOptions} [options] Write options.
   * @return {string|ArrayBuffer} Result.
   */ writeFeature(feature, options) {
        return (0, $fd76d391cc228565$export$817eb92a8194bab0)();
    }
    /**
   * Encode an array of features in this format.
   *
   * @abstract
   * @param {Array<Feature>} features Features.
   * @param {WriteOptions} [options] Write options.
   * @return {string|ArrayBuffer} Result.
   */ writeFeatures(features, options) {
        return (0, $fd76d391cc228565$export$817eb92a8194bab0)();
    }
    /**
   * Write a single geometry in this format.
   *
   * @abstract
   * @param {import("../geom/Geometry.js").default} geometry Geometry.
   * @param {WriteOptions} [options] Write options.
   * @return {string|ArrayBuffer} Result.
   */ writeGeometry(geometry, options) {
        return (0, $fd76d391cc228565$export$817eb92a8194bab0)();
    }
}
var $6510197ad3cc0360$export$2e2bcd8739ae039 = $6510197ad3cc0360$var$FeatureFormat;
function $6510197ad3cc0360$export$7beeea566b560d4(geometry, write, options) {
    const featureProjection = options ? (0, $a86eee1c28205a05$export$3988ae62b71be9a3)(options.featureProjection) : null;
    const dataProjection = options ? (0, $a86eee1c28205a05$export$3988ae62b71be9a3)(options.dataProjection) : null;
    let transformed = geometry;
    if (featureProjection && dataProjection && !(0, $a86eee1c28205a05$export$fe091d73a555748b)(featureProjection, dataProjection)) {
        if (write) transformed = /** @type {T} */ geometry.clone();
        const fromProjection = write ? featureProjection : dataProjection;
        const toProjection = write ? dataProjection : featureProjection;
        if (fromProjection.getUnits() === 'tile-pixels') transformed.transform(fromProjection, toProjection);
        else transformed.applyTransform((0, $a86eee1c28205a05$export$fce0c6cfca85ed96)(fromProjection, toProjection));
    }
    if (write && options && /** @type {WriteOptions} */ options.decimals !== undefined) {
        const power = Math.pow(10, /** @type {WriteOptions} */ options.decimals);
        // if decimals option on write, round each coordinate appropriately
        /**
     * @param {Array<number>} coordinates Coordinates.
     * @return {Array<number>} Transformed coordinates.
     */ const transform = function(coordinates) {
            for(let i = 0, ii = coordinates.length; i < ii; ++i)coordinates[i] = Math.round(coordinates[i] * power) / power;
            return coordinates;
        };
        if (transformed === geometry) transformed = /** @type {T} */ geometry.clone();
        transformed.applyTransform(transform);
    }
    return transformed;
}
function $6510197ad3cc0360$export$d3e9e4b1c7f2405c(extent, options) {
    const featureProjection = options ? (0, $a86eee1c28205a05$export$3988ae62b71be9a3)(options.featureProjection) : null;
    const dataProjection = options ? (0, $a86eee1c28205a05$export$3988ae62b71be9a3)(options.dataProjection) : null;
    if (featureProjection && dataProjection && !(0, $a86eee1c28205a05$export$fe091d73a555748b)(featureProjection, dataProjection)) return (0, $a86eee1c28205a05$export$751c68e0e0efff79)(extent, dataProjection, featureProjection);
    return extent;
}
const $6510197ad3cc0360$var$GeometryConstructor = {
    Point: (0, $3153df5f3993c8ca$export$2e2bcd8739ae039),
    LineString: (0, $197b31f867e63891$export$2e2bcd8739ae039),
    Polygon: (0, $52cb54ac72de6b07$export$2e2bcd8739ae039),
    MultiPoint: (0, $1a0594f8edc26022$export$2e2bcd8739ae039),
    MultiLineString: (0, $96d2138ace1f7d2d$export$2e2bcd8739ae039),
    MultiPolygon: (0, $71dd1c600460678c$export$2e2bcd8739ae039)
};
function $6510197ad3cc0360$var$orientFlatCoordinates(flatCoordinates, ends, stride) {
    if (Array.isArray(ends[0])) {
        // MultiPolagon
        if (!(0, $b3d5fb016ac290e8$export$a1d138f4bd85f4b4)(flatCoordinates, 0, ends, stride)) {
            flatCoordinates = flatCoordinates.slice();
            (0, $b3d5fb016ac290e8$export$ea9ed55fc2a85010)(flatCoordinates, 0, ends, stride);
        }
        return flatCoordinates;
    }
    if (!(0, $b3d5fb016ac290e8$export$f27cd06e85f4ba28)(flatCoordinates, 0, ends, stride)) {
        flatCoordinates = flatCoordinates.slice();
        (0, $b3d5fb016ac290e8$export$b71b604ddfc778c7)(flatCoordinates, 0, ends, stride);
    }
    return flatCoordinates;
}
function $6510197ad3cc0360$export$f935e77582b330a(object, options) {
    const geometry = object.geometry;
    if (!geometry) return [];
    if (Array.isArray(geometry)) return geometry.map((geometry)=>$6510197ad3cc0360$export$f935e77582b330a({
            ...object,
            geometry: geometry
        })).flat();
    const geometryType = geometry.type === 'MultiPolygon' ? 'Polygon' : geometry.type;
    if (geometryType === 'GeometryCollection' || geometryType === 'Circle') throw new Error('Unsupported geometry type: ' + geometryType);
    const stride = geometry.layout.length;
    return $6510197ad3cc0360$export$7beeea566b560d4(new (0, $e5b428c112c9c5d6$export$2e2bcd8739ae039)(geometryType, geometryType === 'Polygon' ? $6510197ad3cc0360$var$orientFlatCoordinates(geometry.flatCoordinates, geometry.ends, stride) : geometry.flatCoordinates, geometry.ends?.flat(), stride, object.properties || {}, object.id).enableSimplifyTransformed(), false, options);
}
function $6510197ad3cc0360$export$322c9678d8c47bf(object, options) {
    if (!object) return null;
    if (Array.isArray(object)) {
        const geometries = object.map((geometry)=>$6510197ad3cc0360$export$322c9678d8c47bf(geometry, options));
        return new (0, $83009074668f36ff$export$2e2bcd8739ae039)(geometries);
    }
    const Geometry = $6510197ad3cc0360$var$GeometryConstructor[object.type];
    return $6510197ad3cc0360$export$7beeea566b560d4(new Geometry(object.flatCoordinates, object.layout || 'XY', object.ends), false, options);
}


/**
 * @module ol/format/TextFeature
 */ 

/**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Base class for text feature formats.
 *
 * @abstract
 */ class $431b79c30beb7d35$var$TextFeature extends (0, $6510197ad3cc0360$export$2e2bcd8739ae039) {
    constructor(){
        super();
    }
    /**
   * @return {import("./Feature.js").Type} Format.
   * @override
   */ getType() {
        return 'text';
    }
    /**
   * Read the feature from the source.
   *
   * @param {Document|Element|Object|string} source Source.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @return {import("../Feature.js").default} Feature.
   * @api
   * @override
   */ readFeature(source, options) {
        return this.readFeatureFromText($431b79c30beb7d35$var$getText(source), this.adaptOptions(options));
    }
    /**
   * @abstract
   * @param {string} text Text.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @protected
   * @return {import("../Feature.js").default} Feature.
   */ readFeatureFromText(text, options) {
        return (0, $fd76d391cc228565$export$817eb92a8194bab0)();
    }
    /**
   * Read the features from the source.
   *
   * @param {Document|Element|Object|string} source Source.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @return {Array<import("../Feature.js").default>} Features.
   * @api
   * @override
   */ readFeatures(source, options) {
        return this.readFeaturesFromText($431b79c30beb7d35$var$getText(source), this.adaptOptions(options));
    }
    /**
   * @abstract
   * @param {string} text Text.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @protected
   * @return {Array<import("../Feature.js").default>} Features.
   */ readFeaturesFromText(text, options) {
        return (0, $fd76d391cc228565$export$817eb92a8194bab0)();
    }
    /**
   * Read the geometry from the source.
   *
   * @param {Document|Element|Object|string} source Source.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @return {import("../geom/Geometry.js").default} Geometry.
   * @api
   * @override
   */ readGeometry(source, options) {
        return this.readGeometryFromText($431b79c30beb7d35$var$getText(source), this.adaptOptions(options));
    }
    /**
   * @abstract
   * @param {string} text Text.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @protected
   * @return {import("../geom/Geometry.js").default} Geometry.
   */ readGeometryFromText(text, options) {
        return (0, $fd76d391cc228565$export$817eb92a8194bab0)();
    }
    /**
   * Read the projection from the source.
   *
   * @param {Document|Element|Object|string} source Source.
   * @return {import("../proj/Projection.js").default|undefined} Projection.
   * @api
   * @override
   */ readProjection(source) {
        return this.readProjectionFromText($431b79c30beb7d35$var$getText(source));
    }
    /**
   * @param {string} text Text.
   * @protected
   * @return {import("../proj/Projection.js").default|undefined} Projection.
   */ readProjectionFromText(text) {
        return this.dataProjection;
    }
    /**
   * Encode a feature as a string.
   *
   * @param {import("../Feature.js").default} feature Feature.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {string} Encoded feature.
   * @api
   * @override
   */ writeFeature(feature, options) {
        return this.writeFeatureText(feature, this.adaptOptions(options));
    }
    /**
   * @abstract
   * @param {import("../Feature.js").default} feature Features.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @protected
   * @return {string} Text.
   */ writeFeatureText(feature, options) {
        return (0, $fd76d391cc228565$export$817eb92a8194bab0)();
    }
    /**
   * Encode an array of features as string.
   *
   * @param {Array<import("../Feature.js").default>} features Features.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {string} Encoded features.
   * @api
   * @override
   */ writeFeatures(features, options) {
        return this.writeFeaturesText(features, this.adaptOptions(options));
    }
    /**
   * @abstract
   * @param {Array<import("../Feature.js").default>} features Features.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @protected
   * @return {string} Text.
   */ writeFeaturesText(features, options) {
        return (0, $fd76d391cc228565$export$817eb92a8194bab0)();
    }
    /**
   * Write a single geometry.
   *
   * @param {import("../geom/Geometry.js").default} geometry Geometry.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {string} Geometry.
   * @api
   * @override
   */ writeGeometry(geometry, options) {
        return this.writeGeometryText(geometry, this.adaptOptions(options));
    }
    /**
   * @abstract
   * @param {import("../geom/Geometry.js").default} geometry Geometry.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @protected
   * @return {string} Text.
   */ writeGeometryText(geometry, options) {
        return (0, $fd76d391cc228565$export$817eb92a8194bab0)();
    }
}
/**
 * @param {Document|Element|Object|string} source Source.
 * @return {string} Text.
 */ function $431b79c30beb7d35$var$getText(source) {
    if (typeof source === 'string') return source;
    return '';
}
var $431b79c30beb7d35$export$2e2bcd8739ae039 = $431b79c30beb7d35$var$TextFeature;


/**
 * Geometry constructors
 * @enum {function (new:import("../geom/Geometry.js").default, Array, import("../geom/Geometry.js").GeometryLayout)}
 */ const $15a985d09649bdc2$var$GeometryConstructor = {
    'POINT': (0, $3153df5f3993c8ca$export$2e2bcd8739ae039),
    'LINESTRING': (0, $197b31f867e63891$export$2e2bcd8739ae039),
    'POLYGON': (0, $52cb54ac72de6b07$export$2e2bcd8739ae039),
    'MULTIPOINT': (0, $1a0594f8edc26022$export$2e2bcd8739ae039),
    'MULTILINESTRING': (0, $96d2138ace1f7d2d$export$2e2bcd8739ae039),
    'MULTIPOLYGON': (0, $71dd1c600460678c$export$2e2bcd8739ae039)
};
/**
 * @typedef {Object} Options
 * @property {boolean} [splitCollection=false] Whether to split GeometryCollections into
 * multiple features on reading.
 */ /**
 * @typedef {Object} Token
 * @property {number} type Type.
 * @property {number|string} [value] Value.
 * @property {number} position Position.
 */ /**
 * @const
 * @type {string}
 */ const $15a985d09649bdc2$var$EMPTY = 'EMPTY';
/**
 * @const
 * @type {string}
 */ const $15a985d09649bdc2$var$Z = 'Z';
/**
 * @const
 * @type {string}
 */ const $15a985d09649bdc2$var$M = 'M';
/**
 * @const
 * @type {string}
 */ const $15a985d09649bdc2$var$ZM = 'ZM';
/**
 * @const
 * @enum {number}
 */ const $15a985d09649bdc2$var$TokenType = {
    START: 0,
    TEXT: 1,
    LEFT_PAREN: 2,
    RIGHT_PAREN: 3,
    NUMBER: 4,
    COMMA: 5,
    EOF: 6
};
/**
 * @type {Object<import("../geom/Geometry.js").Type, string>}
 */ const $15a985d09649bdc2$var$wktTypeLookup = {
    Point: 'POINT',
    LineString: 'LINESTRING',
    Polygon: 'POLYGON',
    MultiPoint: 'MULTIPOINT',
    MultiLineString: 'MULTILINESTRING',
    MultiPolygon: 'MULTIPOLYGON',
    GeometryCollection: 'GEOMETRYCOLLECTION',
    Circle: 'CIRCLE'
};
/**
 * Class to tokenize a WKT string.
 */ class $15a985d09649bdc2$var$Lexer {
    /**
   * @param {string} wkt WKT string.
   */ constructor(wkt){
        /**
     * @type {string}
     */ this.wkt = wkt;
        /**
     * @type {number}
     * @private
     */ this.index_ = -1;
    }
    /**
   * @param {string} c Character.
   * @return {boolean} Whether the character is alphabetic.
   * @private
   */ isAlpha_(c) {
        return c >= 'a' && c <= 'z' || c >= 'A' && c <= 'Z';
    }
    /**
   * @param {string} c Character.
   * @param {boolean} [decimal] Whether the string number
   *     contains a dot, i.e. is a decimal number.
   * @return {boolean} Whether the character is numeric.
   * @private
   */ isNumeric_(c, decimal) {
        decimal = decimal !== undefined ? decimal : false;
        return c >= '0' && c <= '9' || c == '.' && !decimal;
    }
    /**
   * @param {string} c Character.
   * @return {boolean} Whether the character is whitespace.
   * @private
   */ isWhiteSpace_(c) {
        return c == ' ' || c == '\t' || c == '\r' || c == '\n';
    }
    /**
   * @return {string} Next string character.
   * @private
   */ nextChar_() {
        return this.wkt.charAt(++this.index_);
    }
    /**
   * Fetch and return the next token.
   * @return {Token} Next string token.
   */ nextToken() {
        const c = this.nextChar_();
        const position = this.index_;
        /** @type {number|string} */ let value = c;
        let type;
        if (c == '(') type = $15a985d09649bdc2$var$TokenType.LEFT_PAREN;
        else if (c == ',') type = $15a985d09649bdc2$var$TokenType.COMMA;
        else if (c == ')') type = $15a985d09649bdc2$var$TokenType.RIGHT_PAREN;
        else if (this.isNumeric_(c) || c == '-') {
            type = $15a985d09649bdc2$var$TokenType.NUMBER;
            value = this.readNumber_();
        } else if (this.isAlpha_(c)) {
            type = $15a985d09649bdc2$var$TokenType.TEXT;
            value = this.readText_();
        } else if (this.isWhiteSpace_(c)) return this.nextToken();
        else if (c === '') type = $15a985d09649bdc2$var$TokenType.EOF;
        else throw new Error('Unexpected character: ' + c);
        return {
            position: position,
            value: value,
            type: type
        };
    }
    /**
   * @return {number} Numeric token value.
   * @private
   */ readNumber_() {
        let c;
        const index = this.index_;
        let decimal = false;
        let scientificNotation = false;
        do {
            if (c == '.') decimal = true;
            else if (c == 'e' || c == 'E') scientificNotation = true;
            c = this.nextChar_();
        }while (this.isNumeric_(c, decimal) || // if we haven't detected a scientific number before, 'e' or 'E'
        // hint that we should continue to read
        !scientificNotation && (c == 'e' || c == 'E') || // once we know that we have a scientific number, both '-' and '+'
        // are allowed
        scientificNotation && (c == '-' || c == '+'));
        return parseFloat(this.wkt.substring(index, this.index_--));
    }
    /**
   * @return {string} String token value.
   * @private
   */ readText_() {
        let c;
        const index = this.index_;
        do c = this.nextChar_();
        while (this.isAlpha_(c));
        return this.wkt.substring(index, this.index_--).toUpperCase();
    }
}
/**
 * Class to parse the tokens from the WKT string.
 */ class $15a985d09649bdc2$var$Parser {
    /**
   * @param {Lexer} lexer The lexer.
   */ constructor(lexer){
        /**
     * @type {Lexer}
     * @private
     */ this.lexer_ = lexer;
        /**
     * @type {Token}
     * @private
     */ this.token_ = {
            position: 0,
            type: $15a985d09649bdc2$var$TokenType.START
        };
        /**
     * @type {import("../geom/Geometry.js").GeometryLayout}
     * @private
     */ this.layout_ = 'XY';
    }
    /**
   * Fetch the next token form the lexer and replace the active token.
   * @private
   */ consume_() {
        this.token_ = this.lexer_.nextToken();
    }
    /**
   * Tests if the given type matches the type of the current token.
   * @param {TokenType} type Token type.
   * @return {boolean} Whether the token matches the given type.
   */ isTokenType(type) {
        return this.token_.type == type;
    }
    /**
   * If the given type matches the current token, consume it.
   * @param {TokenType} type Token type.
   * @return {boolean} Whether the token matches the given type.
   */ match(type) {
        const isMatch = this.isTokenType(type);
        if (isMatch) this.consume_();
        return isMatch;
    }
    /**
   * Try to parse the tokens provided by the lexer.
   * @return {import("../geom/Geometry.js").default} The geometry.
   */ parse() {
        this.consume_();
        return this.parseGeometry_();
    }
    /**
   * Try to parse the dimensional info.
   * @return {import("../geom/Geometry.js").GeometryLayout} The layout.
   * @private
   */ parseGeometryLayout_() {
        /** @type {import("../geom/Geometry.js").GeometryLayout} */ let layout = 'XY';
        const dimToken = this.token_;
        if (this.isTokenType($15a985d09649bdc2$var$TokenType.TEXT)) {
            const dimInfo = dimToken.value;
            if (dimInfo === $15a985d09649bdc2$var$Z) layout = 'XYZ';
            else if (dimInfo === $15a985d09649bdc2$var$M) layout = 'XYM';
            else if (dimInfo === $15a985d09649bdc2$var$ZM) layout = 'XYZM';
            if (layout !== 'XY') this.consume_();
        }
        return layout;
    }
    /**
   * @return {Array<import("../geom/Geometry.js").default>} A collection of geometries.
   * @private
   */ parseGeometryCollectionText_() {
        if (this.match($15a985d09649bdc2$var$TokenType.LEFT_PAREN)) {
            const geometries = [];
            do geometries.push(this.parseGeometry_());
            while (this.match($15a985d09649bdc2$var$TokenType.COMMA));
            if (this.match($15a985d09649bdc2$var$TokenType.RIGHT_PAREN)) return geometries;
        }
        throw new Error(this.formatErrorMessage_());
    }
    /**
   * @return {Array<number>} All values in a point.
   * @private
   */ parsePointText_() {
        if (this.match($15a985d09649bdc2$var$TokenType.LEFT_PAREN)) {
            const coordinates = this.parsePoint_();
            if (this.match($15a985d09649bdc2$var$TokenType.RIGHT_PAREN)) return coordinates;
        }
        throw new Error(this.formatErrorMessage_());
    }
    /**
   * @return {Array<Array<number>>} All points in a linestring.
   * @private
   */ parseLineStringText_() {
        if (this.match($15a985d09649bdc2$var$TokenType.LEFT_PAREN)) {
            const coordinates = this.parsePointList_();
            if (this.match($15a985d09649bdc2$var$TokenType.RIGHT_PAREN)) return coordinates;
        }
        throw new Error(this.formatErrorMessage_());
    }
    /**
   * @return {Array<Array<Array<number>>>} All points in a polygon.
   * @private
   */ parsePolygonText_() {
        if (this.match($15a985d09649bdc2$var$TokenType.LEFT_PAREN)) {
            const coordinates = this.parseLineStringTextList_();
            if (this.match($15a985d09649bdc2$var$TokenType.RIGHT_PAREN)) return coordinates;
        }
        throw new Error(this.formatErrorMessage_());
    }
    /**
   * @return {Array<Array<number>>} All points in a multipoint.
   * @private
   */ parseMultiPointText_() {
        if (this.match($15a985d09649bdc2$var$TokenType.LEFT_PAREN)) {
            let coordinates;
            if (this.token_.type == $15a985d09649bdc2$var$TokenType.LEFT_PAREN) coordinates = this.parsePointTextList_();
            else coordinates = this.parsePointList_();
            if (this.match($15a985d09649bdc2$var$TokenType.RIGHT_PAREN)) return coordinates;
        }
        throw new Error(this.formatErrorMessage_());
    }
    /**
   * @return {Array<Array<Array<number>>>} All linestring points
   *                                          in a multilinestring.
   * @private
   */ parseMultiLineStringText_() {
        if (this.match($15a985d09649bdc2$var$TokenType.LEFT_PAREN)) {
            const coordinates = this.parseLineStringTextList_();
            if (this.match($15a985d09649bdc2$var$TokenType.RIGHT_PAREN)) return coordinates;
        }
        throw new Error(this.formatErrorMessage_());
    }
    /**
   * @return {Array<Array<Array<Array<number>>>>} All polygon points in a multipolygon.
   * @private
   */ parseMultiPolygonText_() {
        if (this.match($15a985d09649bdc2$var$TokenType.LEFT_PAREN)) {
            const coordinates = this.parsePolygonTextList_();
            if (this.match($15a985d09649bdc2$var$TokenType.RIGHT_PAREN)) return coordinates;
        }
        throw new Error(this.formatErrorMessage_());
    }
    /**
   * @return {Array<number>} A point.
   * @private
   */ parsePoint_() {
        const coordinates = [];
        const dimensions = this.layout_.length;
        for(let i = 0; i < dimensions; ++i){
            const token = this.token_;
            if (this.match($15a985d09649bdc2$var$TokenType.NUMBER)) coordinates.push(/** @type {number} */ token.value);
            else break;
        }
        if (coordinates.length == dimensions) return coordinates;
        throw new Error(this.formatErrorMessage_());
    }
    /**
   * @return {Array<Array<number>>} An array of points.
   * @private
   */ parsePointList_() {
        const coordinates = [
            this.parsePoint_()
        ];
        while(this.match($15a985d09649bdc2$var$TokenType.COMMA))coordinates.push(this.parsePoint_());
        return coordinates;
    }
    /**
   * @return {Array<Array<number>>} An array of points.
   * @private
   */ parsePointTextList_() {
        const coordinates = [
            this.parsePointText_()
        ];
        while(this.match($15a985d09649bdc2$var$TokenType.COMMA))coordinates.push(this.parsePointText_());
        return coordinates;
    }
    /**
   * @return {Array<Array<Array<number>>>} An array of points.
   * @private
   */ parseLineStringTextList_() {
        const coordinates = [
            this.parseLineStringText_()
        ];
        while(this.match($15a985d09649bdc2$var$TokenType.COMMA))coordinates.push(this.parseLineStringText_());
        return coordinates;
    }
    /**
   * @return {Array<Array<Array<Array<number>>>>} An array of points.
   * @private
   */ parsePolygonTextList_() {
        const coordinates = [
            this.parsePolygonText_()
        ];
        while(this.match($15a985d09649bdc2$var$TokenType.COMMA))coordinates.push(this.parsePolygonText_());
        return coordinates;
    }
    /**
   * @return {boolean} Whether the token implies an empty geometry.
   * @private
   */ isEmptyGeometry_() {
        const isEmpty = this.isTokenType($15a985d09649bdc2$var$TokenType.TEXT) && this.token_.value == $15a985d09649bdc2$var$EMPTY;
        if (isEmpty) this.consume_();
        return isEmpty;
    }
    /**
   * Create an error message for an unexpected token error.
   * @return {string} Error message.
   * @private
   */ formatErrorMessage_() {
        return 'Unexpected `' + this.token_.value + '` at position ' + this.token_.position + ' in `' + this.lexer_.wkt + '`';
    }
    /**
   * @return {import("../geom/Geometry.js").default} The geometry.
   * @private
   */ parseGeometry_() {
        const token = this.token_;
        if (this.match($15a985d09649bdc2$var$TokenType.TEXT)) {
            const geomType = /** @type {string} */ token.value;
            this.layout_ = this.parseGeometryLayout_();
            const isEmpty = this.isEmptyGeometry_();
            if (geomType == 'GEOMETRYCOLLECTION') {
                if (isEmpty) return new (0, $83009074668f36ff$export$2e2bcd8739ae039)([]);
                const geometries = this.parseGeometryCollectionText_();
                return new (0, $83009074668f36ff$export$2e2bcd8739ae039)(geometries);
            }
            const ctor = $15a985d09649bdc2$var$GeometryConstructor[geomType];
            if (!ctor) throw new Error('Invalid geometry type: ' + geomType);
            let coordinates;
            if (isEmpty) {
                if (geomType == 'POINT') coordinates = [
                    NaN,
                    NaN
                ];
                else coordinates = [];
            } else switch(geomType){
                case 'POINT':
                    coordinates = this.parsePointText_();
                    break;
                case 'LINESTRING':
                    coordinates = this.parseLineStringText_();
                    break;
                case 'POLYGON':
                    coordinates = this.parsePolygonText_();
                    break;
                case 'MULTIPOINT':
                    coordinates = this.parseMultiPointText_();
                    break;
                case 'MULTILINESTRING':
                    coordinates = this.parseMultiLineStringText_();
                    break;
                case 'MULTIPOLYGON':
                    coordinates = this.parseMultiPolygonText_();
                    break;
                default:
                    break;
            }
            return new ctor(coordinates, this.layout_);
        }
        throw new Error(this.formatErrorMessage_());
    }
}
/**
 * @classdesc
 * Geometry format for reading and writing data in the `WellKnownText` (WKT)
 * format.
 *
 * @api
 */ class $15a985d09649bdc2$var$WKT extends (0, $431b79c30beb7d35$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        super();
        options = options ? options : {};
        /**
     * Split GeometryCollection into multiple features.
     * @type {boolean}
     * @private
     */ this.splitCollection_ = options.splitCollection !== undefined ? options.splitCollection : false;
    }
    /**
   * Parse a WKT string.
   * @param {string} wkt WKT string.
   * @return {import("../geom/Geometry.js").default}
   *     The geometry created.
   * @private
   */ parse_(wkt) {
        const lexer = new $15a985d09649bdc2$var$Lexer(wkt);
        const parser = new $15a985d09649bdc2$var$Parser(lexer);
        return parser.parse();
    }
    /**
   * @protected
   * @param {string} text Text.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @return {import("../Feature.js").default} Feature.
   * @override
   */ readFeatureFromText(text, options) {
        const geom = this.readGeometryFromText(text, options);
        const feature = new (0, $df26d2327ced1fa9$export$2e2bcd8739ae039)();
        feature.setGeometry(geom);
        return feature;
    }
    /**
   * @param {string} text Text.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @protected
   * @return {Array<Feature>} Features.
   * @override
   */ readFeaturesFromText(text, options) {
        let geometries = [];
        const geometry = this.readGeometryFromText(text, options);
        if (this.splitCollection_ && geometry.getType() == 'GeometryCollection') geometries = /** @type {GeometryCollection} */ geometry.getGeometriesArray();
        else geometries = [
            geometry
        ];
        const features = [];
        for(let i = 0, ii = geometries.length; i < ii; ++i){
            const feature = new (0, $df26d2327ced1fa9$export$2e2bcd8739ae039)();
            feature.setGeometry(geometries[i]);
            features.push(feature);
        }
        return features;
    }
    /**
   * @param {string} text Text.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @protected
   * @return {import("../geom/Geometry.js").default} Geometry.
   * @override
   */ readGeometryFromText(text, options) {
        const geometry = this.parse_(text);
        return (0, $6510197ad3cc0360$export$7beeea566b560d4)(geometry, false, options);
    }
    /**
   * @param {import("../Feature.js").default} feature Features.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @protected
   * @return {string} Text.
   * @override
   */ writeFeatureText(feature, options) {
        const geometry = feature.getGeometry();
        if (geometry) return this.writeGeometryText(geometry, options);
        return '';
    }
    /**
   * @param {Array<import("../Feature.js").default>} features Features.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @protected
   * @return {string} Text.
   * @override
   */ writeFeaturesText(features, options) {
        if (features.length == 1) return this.writeFeatureText(features[0], options);
        const geometries = [];
        for(let i = 0, ii = features.length; i < ii; ++i)geometries.push(features[i].getGeometry());
        const collection = new (0, $83009074668f36ff$export$2e2bcd8739ae039)(geometries);
        return this.writeGeometryText(collection, options);
    }
    /**
   * @param {import("../geom/Geometry.js").default} geometry Geometry.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @protected
   * @return {string} Text.
   * @override
   */ writeGeometryText(geometry, options) {
        return $15a985d09649bdc2$var$encode((0, $6510197ad3cc0360$export$7beeea566b560d4)(geometry, true, options));
    }
}
/**
 * @param {Point} geom Point geometry.
 * @return {string} Coordinates part of Point as WKT.
 */ function $15a985d09649bdc2$var$encodePointGeometry(geom) {
    const coordinates = geom.getCoordinates();
    if (coordinates.length === 0) return '';
    return coordinates.join(' ');
}
/**
 * @param {MultiPoint} geom MultiPoint geometry.
 * @return {string} Coordinates part of MultiPoint as WKT.
 */ function $15a985d09649bdc2$var$encodeMultiPointGeometry(geom) {
    const array = [];
    const components = geom.getPoints();
    for(let i = 0, ii = components.length; i < ii; ++i)array.push('(' + $15a985d09649bdc2$var$encodePointGeometry(components[i]) + ')');
    return array.join(',');
}
/**
 * @param {GeometryCollection} geom GeometryCollection geometry.
 * @return {string} Coordinates part of GeometryCollection as WKT.
 */ function $15a985d09649bdc2$var$encodeGeometryCollectionGeometry(geom) {
    const array = [];
    const geoms = geom.getGeometries();
    for(let i = 0, ii = geoms.length; i < ii; ++i)array.push($15a985d09649bdc2$var$encode(geoms[i]));
    return array.join(',');
}
/**
 * @param {LineString|import("../geom/LinearRing.js").default} geom LineString geometry.
 * @return {string} Coordinates part of LineString as WKT.
 */ function $15a985d09649bdc2$var$encodeLineStringGeometry(geom) {
    const coordinates = geom.getCoordinates();
    const array = [];
    for(let i = 0, ii = coordinates.length; i < ii; ++i)array.push(coordinates[i].join(' '));
    return array.join(',');
}
/**
 * @param {MultiLineString} geom MultiLineString geometry.
 * @return {string} Coordinates part of MultiLineString as WKT.
 */ function $15a985d09649bdc2$var$encodeMultiLineStringGeometry(geom) {
    const array = [];
    const components = geom.getLineStrings();
    for(let i = 0, ii = components.length; i < ii; ++i)array.push('(' + $15a985d09649bdc2$var$encodeLineStringGeometry(components[i]) + ')');
    return array.join(',');
}
/**
 * @param {Polygon} geom Polygon geometry.
 * @return {string} Coordinates part of Polygon as WKT.
 */ function $15a985d09649bdc2$var$encodePolygonGeometry(geom) {
    const array = [];
    const rings = geom.getLinearRings();
    for(let i = 0, ii = rings.length; i < ii; ++i)array.push('(' + $15a985d09649bdc2$var$encodeLineStringGeometry(rings[i]) + ')');
    return array.join(',');
}
/**
 * @param {MultiPolygon} geom MultiPolygon geometry.
 * @return {string} Coordinates part of MultiPolygon as WKT.
 */ function $15a985d09649bdc2$var$encodeMultiPolygonGeometry(geom) {
    const array = [];
    const components = geom.getPolygons();
    for(let i = 0, ii = components.length; i < ii; ++i)array.push('(' + $15a985d09649bdc2$var$encodePolygonGeometry(components[i]) + ')');
    return array.join(',');
}
/**
 * @param {import("../geom/SimpleGeometry.js").default} geom SimpleGeometry geometry.
 * @return {string} Potential dimensional information for WKT type.
 */ function $15a985d09649bdc2$var$encodeGeometryLayout(geom) {
    const layout = geom.getLayout();
    let dimInfo = '';
    if (layout === 'XYZ' || layout === 'XYZM') dimInfo += $15a985d09649bdc2$var$Z;
    if (layout === 'XYM' || layout === 'XYZM') dimInfo += $15a985d09649bdc2$var$M;
    return dimInfo;
}
/**
 * @const
 * @type {Object<string, function(import("../geom/Geometry.js").default): string>}
 */ const $15a985d09649bdc2$var$GeometryEncoder = {
    'Point': $15a985d09649bdc2$var$encodePointGeometry,
    'LineString': $15a985d09649bdc2$var$encodeLineStringGeometry,
    'Polygon': $15a985d09649bdc2$var$encodePolygonGeometry,
    'MultiPoint': $15a985d09649bdc2$var$encodeMultiPointGeometry,
    'MultiLineString': $15a985d09649bdc2$var$encodeMultiLineStringGeometry,
    'MultiPolygon': $15a985d09649bdc2$var$encodeMultiPolygonGeometry,
    'GeometryCollection': $15a985d09649bdc2$var$encodeGeometryCollectionGeometry
};
/**
 * Encode a geometry as WKT.
 * @param {import("../geom/Geometry.js").default} geom The geometry to encode.
 * @return {string} WKT string for the geometry.
 */ function $15a985d09649bdc2$var$encode(geom) {
    const type = geom.getType();
    const geometryEncoder = $15a985d09649bdc2$var$GeometryEncoder[type];
    const enc = geometryEncoder(geom);
    let wktType = $15a985d09649bdc2$var$wktTypeLookup[type];
    if (typeof /** @type {?} */ geom.getFlatCoordinates === 'function') {
        const dimInfo = $15a985d09649bdc2$var$encodeGeometryLayout(/** @type {import("../geom/SimpleGeometry.js").default} */ geom);
        if (dimInfo.length > 0) wktType += ' ' + dimInfo;
    }
    if (enc.length === 0) return wktType + ' ' + $15a985d09649bdc2$var$EMPTY;
    return wktType + '(' + enc + ')';
}
var $15a985d09649bdc2$export$2e2bcd8739ae039 = $15a985d09649bdc2$var$WKT;





var $kc00y = parcelRequire("kc00y");



var $a178c3075f0f40bb$export$970c58a942355206 = /*#__PURE__*/ function(GET_TYPE_GEOMETRY) {
    GET_TYPE_GEOMETRY["COMMUNE"] = "/api/commune";
    GET_TYPE_GEOMETRY["COMMUNE_ETUDE"] = "/api/couverture-hydraulique/etude";
    GET_TYPE_GEOMETRY["COMMUNE_CRISE"] = "/api/crise";
    GET_TYPE_GEOMETRY["TOURNEE"] = "/api/tournee";
    GET_TYPE_GEOMETRY["PEI"] = "/api/pei";
    GET_TYPE_GEOMETRY["VOIE"] = "/api/voie";
    GET_TYPE_GEOMETRY["INDISPONIBILITE_TEMP"] = "/api/indisponibilite-temporaire";
    GET_TYPE_GEOMETRY["OLDEB"] = "/api/oldeb";
    GET_TYPE_GEOMETRY["DFCI_AIRE"] = "/api/dfci-aires";
    GET_TYPE_GEOMETRY["DFCI_PISTE"] = "/api/dfci-pistes";
    GET_TYPE_GEOMETRY["DFCI_DEB"] = "/api/dfci-deb";
    GET_TYPE_GEOMETRY["DFCI_PANNEAU"] = "/api/dfci-panneau";
    return GET_TYPE_GEOMETRY;
}({});
const $a178c3075f0f40bb$var$BUFFER_LOCALISATION = 100;
const $a178c3075f0f40bb$var$parseGeometry = (raw)=>{
    const [rawSrid, rawFeature] = raw.split(";");
    const srid = rawSrid.split("=").pop();
    const geometry = new (0, $15a985d09649bdc2$export$2e2bcd8739ae039)().readGeometry(rawFeature);
    return {
        geometry: geometry,
        srid: srid
    };
};
const $a178c3075f0f40bb$var$bufferExtent = (extent, buffer)=>{
    return [
        extent[0] - buffer,
        extent[1] - buffer,
        extent[2] + buffer,
        extent[3] + buffer
    ];
};
const $a178c3075f0f40bb$var$getGeometryData = (geometryData)=>{
    const { geometry: geometry, srid: srid } = $a178c3075f0f40bb$var$parseGeometry(geometryData);
    return {
        extent: $a178c3075f0f40bb$var$bufferExtent(geometry.getExtent(), $a178c3075f0f40bb$var$BUFFER_LOCALISATION),
        srid: srid
    };
};
const $a178c3075f0f40bb$export$d1a1b15ef15cfb13 = ()=>{
    const { pathname: currentPathname, search: search } = (0, $7a844823b04d4282$export$45d76561a5302f2b)();
    const fetchMapGeometry = (0, $kc00y.useCallback)((obj, map)=>{
        if (obj) {
            const { extent: extent, srid: srid } = $a178c3075f0f40bb$var$getGeometryData(obj.geometry);
            localStorage.setItem(currentPathname, search);
            map.getView().fit((0, $a86eee1c28205a05$export$751c68e0e0efff79)(extent, `EPSG:${srid}`, map.getView().getProjection()), {
                size: map.getSize()
            });
        }
    }, [
        currentPathname,
        search
    ]);
    return {
        fetchMapGeometry: fetchMapGeometry
    };
};
/**
 * Permet de localiser les PEI, les tournées ou les communes et voie
 */ const $a178c3075f0f40bb$var$useLocalisation = ()=>{
    const navigate = (0, $7a844823b04d4282$export$9770f232ac06a008)();
    const { pathname: currentPathname, search: search, state: currentState } = (0, $7a844823b04d4282$export$45d76561a5302f2b)();
    const fetchGeometry = (0, $kc00y.useCallback)(async (typeGeometry, idType, urlDestination = (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).DECI_CARTE)=>{
        let listePeiId;
        (await fetch((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`${typeGeometry}/${idType}/geometrie`, (0, $fbd4d34e07af0ac7$export$b163ec2f884327db)({
            method: "GET"
        }))).json().then((resData)=>{
            let extent, srid;
            switch(typeGeometry){
                case "/api/pei":
                    {
                        const { geometry: geometry, srid: parsedSrid } = $a178c3075f0f40bb$var$parseGeometry(resData);
                        extent = geometry.getExtent();
                        srid = parsedSrid;
                        listePeiId = [
                            idType
                        ];
                        break;
                    }
                case "/api/tournee":
                case "/api/indisponibilite-temporaire":
                    {
                        const geometries = resData.map((pei)=>$a178c3075f0f40bb$var$parseGeometry(pei.peiGeometrie).geometry);
                        srid = $a178c3075f0f40bb$var$parseGeometry(resData[0].peiGeometrie).srid;
                        extent = $a178c3075f0f40bb$var$bufferExtent(new (0, $83009074668f36ff$export$2e2bcd8739ae039)(geometries).getExtent(), $a178c3075f0f40bb$var$BUFFER_LOCALISATION);
                        listePeiId = resData.map((e)=>e.peiId);
                        break;
                    }
                case "/api/commune":
                    {
                        const { geometry: geometry, srid: parsedSrid } = $a178c3075f0f40bb$var$parseGeometry(resData.communeGeometry);
                        extent = $a178c3075f0f40bb$var$bufferExtent(geometry.getExtent(), $a178c3075f0f40bb$var$BUFFER_LOCALISATION);
                        srid = parsedSrid;
                        break;
                    }
                case "/api/couverture-hydraulique/etude":
                case "/api/crise":
                    {
                        const geometries = resData.map((commune)=>$a178c3075f0f40bb$var$parseGeometry(commune).geometry);
                        srid = $a178c3075f0f40bb$var$parseGeometry(resData[0]).srid;
                        extent = $a178c3075f0f40bb$var$bufferExtent(new (0, $83009074668f36ff$export$2e2bcd8739ae039)(geometries).getExtent(), $a178c3075f0f40bb$var$BUFFER_LOCALISATION);
                        break;
                    }
                case "/api/voie":
                    {
                        const { geometry: geometry, srid: parsedSrid } = $a178c3075f0f40bb$var$parseGeometry(resData.voieGeometry);
                        extent = $a178c3075f0f40bb$var$bufferExtent(geometry.getExtent(), $a178c3075f0f40bb$var$BUFFER_LOCALISATION);
                        srid = parsedSrid;
                        break;
                    }
                case "/api/oldeb":
                    {
                        const { geometry: geometry, srid: parsedSrid } = $a178c3075f0f40bb$var$parseGeometry(resData.geometrie);
                        extent = $a178c3075f0f40bb$var$bufferExtent(geometry.getExtent(), $a178c3075f0f40bb$var$BUFFER_LOCALISATION);
                        srid = parsedSrid;
                        break;
                    }
                case "/api/dfci-aires":
                    {
                        const { geometry: geometry, srid: parsedSrid } = $a178c3075f0f40bb$var$parseGeometry(resData.geometrie);
                        extent = $a178c3075f0f40bb$var$bufferExtent(geometry.getExtent(), $a178c3075f0f40bb$var$BUFFER_LOCALISATION);
                        srid = parsedSrid;
                        break;
                    }
                case "/api/dfci-pistes":
                    {
                        const { geometry: geometry, srid: parsedSrid } = $a178c3075f0f40bb$var$parseGeometry(resData.geometrie);
                        extent = $a178c3075f0f40bb$var$bufferExtent(geometry.getExtent(), $a178c3075f0f40bb$var$BUFFER_LOCALISATION);
                        srid = parsedSrid;
                        break;
                    }
                case "/api/dfci-deb":
                    {
                        const { geometry: geometry, srid: parsedSrid } = $a178c3075f0f40bb$var$parseGeometry(resData.geometrie);
                        extent = $a178c3075f0f40bb$var$bufferExtent(geometry.getExtent(), $a178c3075f0f40bb$var$BUFFER_LOCALISATION);
                        srid = parsedSrid;
                        break;
                    }
                case "/api/dfci-panneau":
                    {
                        const { geometry: geometry, srid: parsedSrid } = $a178c3075f0f40bb$var$parseGeometry(resData.geometrie);
                        extent = $a178c3075f0f40bb$var$bufferExtent(geometry.getExtent(), $a178c3075f0f40bb$var$BUFFER_LOCALISATION);
                        srid = parsedSrid;
                        break;
                    }
            }
            // On sauvegarde les nouveaux search de la page courrante dans le localStorage
            localStorage.setItem(currentPathname, search);
            navigate(urlDestination, {
                state: {
                    ...currentState,
                    from: [
                        ...currentState?.from ?? [],
                        `${currentPathname}${search}`
                    ],
                    listePeiId: listePeiId,
                    target: {
                        extent: extent,
                        srid: srid
                    }
                }
            });
        });
    }, [
        navigate,
        currentState,
        currentPathname,
        search
    ]);
    return {
        fetchGeometry: fetchGeometry
    };
};
var $a178c3075f0f40bb$export$2e2bcd8739ae039 = $a178c3075f0f40bb$var$useLocalisation;






var $kc00y = parcelRequire("kc00y");

const $6db3fd3479b0e545$var$useDeleteButtonEnabled = ()=>{
    const { visible: visible, ref: ref, show: show, close: close } = (0, $ca8671088139af49$export$2e2bcd8739ae039)();
    const [isDeleteEnabled, setIsDeleteEnabled] = (0, $kc00y.useState)(true);
    const openDeleteModal = (0, $kc00y.useCallback)(()=>{
        setIsDeleteEnabled(false);
        show();
    }, [
        show
    ]);
    const closeDeleteModalAndReset = (0, $kc00y.useCallback)(()=>{
        close();
        setIsDeleteEnabled(true);
    }, [
        close
    ]);
    const closeDeleteModalSuccess = (0, $kc00y.useCallback)(()=>{
        close();
    }, [
        close
    ]);
    return {
        visible: visible,
        ref: ref,
        isDeleteEnabled: isDeleteEnabled,
        openDeleteModal: openDeleteModal,
        closeDeleteModalCancel: closeDeleteModalAndReset,
        closeDeleteModalError: closeDeleteModalAndReset,
        closeDeleteModalSuccess: closeDeleteModalSuccess
    };
};
var $6db3fd3479b0e545$export$2e2bcd8739ae039 = $6db3fd3479b0e545$var$useDeleteButtonEnabled;










const $791e7ee3b0d1ae7e$var$DeleteModalBody = ({ query: query, id: id, onCancel: onCancel, onSuccess: onSuccess, onError: onError, onDelete: onDelete, content: content, successLibelle: successLibelle })=>{
    const { success: successToast, error: errorToast } = (0, $6bdae0bad7b05751$export$91b3d218c74c79e4)();
    const del = (0, $8d9ebd8892d8a5f5$export$60acb8fd13afd60d)(id ? `${query}/${id}` : `${query}`, {
        onResolve: (res)=>{
            onDelete && onDelete(res);
            successToast(successLibelle ?? "L'\xe9l\xe9ment a bien \xe9t\xe9 supprim\xe9");
            onSuccess();
        },
        onReject: async (error)=>{
            errorToast(`Erreur lors de l'ex\xe9cution de l'action : ${await error.text()}`);
            onError();
        }
    });
    const isSubmitting = del.isPending || del.isLoading;
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $8e1f7dde30da3bf6$export$2e2bcd8739ae039).Body, {
                children: [
                    content,
                    isSubmitting && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                        className: "d-flex flex-column align-items-center mt-3 gap-2",
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $c21b1c237cfa1d94$export$2e2bcd8739ae039), {
                                className: "py-2"
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                children: "Suppression en cours\u2026"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $8e1f7dde30da3bf6$export$2e2bcd8739ae039).Footer, {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                        variant: "secondary",
                        onClick: onCancel,
                        disabled: isSubmitting,
                        children: "Annuler"
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                        variant: "primary",
                        disabled: isSubmitting,
                        onClick: async ()=>{
                            if (isSubmitting) return;
                            try {
                                await del.run();
                            } catch (e) {
                                (0, $958d7290af97c4cf$export$2e2bcd8739ae039)({
                                    content: `Erreur lors de la suppression de l'\xe9l\xe9ment : ${e.message}`,
                                    variant: "danger"
                                });
                            }
                        },
                        children: "Valider"
                    })
                ]
            })
        ]
    });
};
const $791e7ee3b0d1ae7e$var$DeleteModal = ({ ref: ref, visible: visible, onCancel: onCancel, onSuccess: onSuccess, onError: onError, header: header = "Suppression d'un \xe9l\xe9ment", query: query, id: id, onDelete: onDelete, content: content = "Voulez-vous supprimer cet \xe9l\xe9ment ?", successLibelle: successLibelle })=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $8e1f7dde30da3bf6$export$2e2bcd8739ae039), {
        show: visible,
        onHide: onCancel,
        ref: ref,
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8e1f7dde30da3bf6$export$2e2bcd8739ae039).Header, {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8e1f7dde30da3bf6$export$2e2bcd8739ae039).Title, {
                    children: header
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($791e7ee3b0d1ae7e$var$DeleteModalBody, {
                query: query,
                id: id,
                onCancel: onCancel,
                onSuccess: onSuccess,
                onError: onError,
                onDelete: onDelete,
                content: content,
                successLibelle: successLibelle
            })
        ]
    });
};
var $791e7ee3b0d1ae7e$export$2e2bcd8739ae039 = $791e7ee3b0d1ae7e$var$DeleteModal;







var $kc00y = parcelRequire("kc00y");



var $kc00y = parcelRequire("kc00y");

var $kc00y = parcelRequire("kc00y");
function $dc977c09674889c6$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $dc977c09674889c6$var$_toPropertyKey(arg) {
    var key = $dc977c09674889c6$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $dc977c09674889c6$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $dc977c09674889c6$export$26cbf8c37e721e67(key) {
    return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}
function $dc977c09674889c6$export$2ee51287a16ca325(propValue, defaultValue, handler) {
    const wasPropRef = (0, $kc00y.useRef)(propValue !== undefined);
    const [stateValue, setState] = (0, $kc00y.useState)(defaultValue);
    const isProp = propValue !== undefined;
    const wasProp = wasPropRef.current;
    wasPropRef.current = isProp;
    /**
   * If a prop switches from controlled to Uncontrolled
   * reset its value to the defaultValue
   */ if (!isProp && wasProp && stateValue !== defaultValue) setState(defaultValue);
    return [
        isProp ? propValue : stateValue,
        (0, $kc00y.useCallback)((...args)=>{
            const [value, ...rest] = args;
            let returnValue = handler == null ? void 0 : handler(value, ...rest);
            setState(value);
            return returnValue;
        }, [
            handler
        ])
    ];
}
function $dc977c09674889c6$export$ec55e9daaf703a7d(props, config) {
    return Object.keys(config).reduce((result, fieldName)=>{
        const _ref = result, _defaultKey = $dc977c09674889c6$export$26cbf8c37e721e67(fieldName), { [_defaultKey]: defaultValue, [fieldName]: propsValue } = _ref, rest = $dc977c09674889c6$var$_objectWithoutPropertiesLoose(_ref, [
            _defaultKey,
            fieldName
        ].map($dc977c09674889c6$var$_toPropertyKey));
        const handlerName = config[fieldName];
        const [value, handler] = $dc977c09674889c6$export$2ee51287a16ca325(propsValue, defaultValue, props[handlerName]);
        return Object.assign({}, rest, {
            [fieldName]: value,
            [handlerName]: handler
        });
    }, props);
}




var $kc00y = parcelRequire("kc00y");
function $38e2134995fe8a16$export$2e2bcd8739ae039() {
    // The toggling state value is designed to defeat React optimizations for skipping
    // updates when they are strictly equal to the last state value
    const [, dispatch] = (0, $kc00y.useReducer)((revision)=>revision + 1, 0);
    return dispatch;
}





var $kc00y = parcelRequire("kc00y");
const $d8e1b2c6e408de69$var$DropdownContext = /*#__PURE__*/ $kc00y.createContext(null);
var $d8e1b2c6e408de69$export$2e2bcd8739ae039 = $d8e1b2c6e408de69$var$DropdownContext;



var $kc00y = parcelRequire("kc00y");






const $fd14cf6a1acf58cd$var$_excluded = [
    "children",
    "usePopper"
];
function $fd14cf6a1acf58cd$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
const $fd14cf6a1acf58cd$var$noop = ()=>{};
function $fd14cf6a1acf58cd$export$133c4d08f3775d64(options = {}) {
    const context = (0, $kc00y.useContext)((0, $d8e1b2c6e408de69$export$2e2bcd8739ae039));
    const [arrowElement, attachArrowRef] = (0, $076d41a58396540c$export$2e2bcd8739ae039)();
    const hasShownRef = (0, $kc00y.useRef)(false);
    const { flip: flip, offset: offset, rootCloseEvent: rootCloseEvent, fixed: fixed = false, placement: placementOverride, popperConfig: popperConfig = {}, enableEventListeners: enableEventListeners = true, usePopper: shouldUsePopper = !!context } = options;
    const show = (context == null ? void 0 : context.show) == null ? !!options.show : context.show;
    if (show && !hasShownRef.current) hasShownRef.current = true;
    const handleClose = (e)=>{
        context == null || context.toggle(false, e);
    };
    const { placement: placement, setMenu: setMenu, menuElement: menuElement, toggleElement: toggleElement } = context || {};
    const popper = (0, $24ab08ee897405f9$export$2e2bcd8739ae039)(toggleElement, menuElement, (0, $fbf0dea5f10fe2a4$export$2e2bcd8739ae039)({
        placement: placementOverride || placement || 'bottom-start',
        enabled: shouldUsePopper,
        enableEvents: enableEventListeners == null ? show : enableEventListeners,
        offset: offset,
        flip: flip,
        fixed: fixed,
        arrowElement: arrowElement,
        popperConfig: popperConfig
    }));
    const menuProps = Object.assign({
        ref: setMenu || $fd14cf6a1acf58cd$var$noop,
        'aria-labelledby': toggleElement == null ? void 0 : toggleElement.id
    }, popper.attributes.popper, {
        style: popper.styles.popper
    });
    const metadata = {
        show: show,
        placement: placement,
        hasShown: hasShownRef.current,
        toggle: context == null ? void 0 : context.toggle,
        popper: shouldUsePopper ? popper : null,
        arrowProps: shouldUsePopper ? Object.assign({
            ref: attachArrowRef
        }, popper.attributes.arrow, {
            style: popper.styles.arrow
        }) : {}
    };
    (0, $cba6c8f98b365b95$export$2e2bcd8739ae039)(menuElement, handleClose, {
        clickTrigger: rootCloseEvent,
        disabled: !show
    });
    return [
        menuProps,
        metadata
    ];
}
/**
 * Also exported as `<Dropdown.Menu>` from `Dropdown`.
 *
 * @displayName DropdownMenu
 * @memberOf Dropdown
 */ function $fd14cf6a1acf58cd$var$DropdownMenu(_ref) {
    let { children: children, usePopper: usePopperProp = true } = _ref, options = $fd14cf6a1acf58cd$var$_objectWithoutPropertiesLoose(_ref, $fd14cf6a1acf58cd$var$_excluded);
    const [props, meta] = $fd14cf6a1acf58cd$export$133c4d08f3775d64(Object.assign({}, options, {
        usePopper: usePopperProp
    }));
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
        children: children(props, meta)
    });
}
$fd14cf6a1acf58cd$var$DropdownMenu.displayName = 'DropdownMenu';
var /** @component */ $fd14cf6a1acf58cd$export$2e2bcd8739ae039 = $fd14cf6a1acf58cd$var$DropdownMenu;



var $kc00y = parcelRequire("kc00y");

var $kc00y = parcelRequire("kc00y");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // We must avoid a circular dependency with @react-aria/utils, and this useLayoutEffect is
// guarded by a check that it only runs on the client side.
// eslint-disable-next-line rulesdir/useLayoutEffectRule
// Default context value to use in case there is no SSRProvider. This is fine for
// client-only apps. In order to support multiple copies of React Aria potentially
// being on the page at once, the prefix is set to a random number. SSRProvider
// will reset this to zero for consistency between server and client, so in the
// SSR case multiple copies of React Aria is not supported.
const $ee9ef19153721bae$var$$b5e257d569688ac6$var$defaultContext = {
    prefix: String(Math.round(Math.random() * 10000000000)),
    current: 0
};
const $ee9ef19153721bae$var$$b5e257d569688ac6$var$SSRContext = (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createContext($ee9ef19153721bae$var$$b5e257d569688ac6$var$defaultContext);
const $ee9ef19153721bae$var$$b5e257d569688ac6$var$IsSSRContext = (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createContext(false);
// This is only used in React < 18.
function $ee9ef19153721bae$var$$b5e257d569688ac6$var$LegacySSRProvider(props) {
    let cur = (0, $kc00y.useContext)($ee9ef19153721bae$var$$b5e257d569688ac6$var$SSRContext);
    let counter = $ee9ef19153721bae$var$$b5e257d569688ac6$var$useCounter(cur === $ee9ef19153721bae$var$$b5e257d569688ac6$var$defaultContext);
    let [isSSR, setIsSSR] = (0, $kc00y.useState)(true);
    let value = (0, $kc00y.useMemo)(()=>({
            // If this is the first SSRProvider, start with an empty string prefix, otherwise
            // append and increment the counter.
            prefix: cur === $ee9ef19153721bae$var$$b5e257d569688ac6$var$defaultContext ? '' : `${cur.prefix}-${counter}`,
            current: 0
        }), [
        cur,
        counter
    ]);
    // If on the client, and the component was initially server rendered,
    // then schedule a layout effect to update the component after hydration.
    if (typeof document !== 'undefined') (0, $kc00y.useLayoutEffect)(()=>{
        setIsSSR(false);
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement($ee9ef19153721bae$var$$b5e257d569688ac6$var$SSRContext.Provider, {
        value: value
    }, (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement($ee9ef19153721bae$var$$b5e257d569688ac6$var$IsSSRContext.Provider, {
        value: isSSR
    }, props.children));
}
let $ee9ef19153721bae$var$$b5e257d569688ac6$var$warnedAboutSSRProvider = false;
function $ee9ef19153721bae$export$9f8ac96af4b1b2ae(props) {
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($kc00y)))['useId'] === 'function') return (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).Fragment, null, props.children);
    return (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement($ee9ef19153721bae$var$$b5e257d569688ac6$var$LegacySSRProvider, props);
}
let $ee9ef19153721bae$var$$b5e257d569688ac6$var$canUseDOM = Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
let $ee9ef19153721bae$var$$b5e257d569688ac6$var$componentIds = new WeakMap();
function $ee9ef19153721bae$var$$b5e257d569688ac6$var$useCounter(isDisabled = false) {
    let ctx = (0, $kc00y.useContext)($ee9ef19153721bae$var$$b5e257d569688ac6$var$SSRContext);
    let ref = (0, $kc00y.useRef)(null);
    // eslint-disable-next-line rulesdir/pure-render
    if (ref.current === null && !isDisabled) {
        var _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner, _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
        // In strict mode, React renders components twice, and the ref will be reset to null on the second render.
        // This means our id counter will be incremented twice instead of once. This is a problem because on the
        // server, components are only rendered once and so ids generated on the server won't match the client.
        // In React 18, useId was introduced to solve this, but it is not available in older versions. So to solve this
        // we need to use some React internals to access the underlying Fiber instance, which is stable between renders.
        // This is exposed as ReactCurrentOwner in development, which is all we need since StrictMode only runs in development.
        // To ensure that we only increment the global counter once, we store the starting id for this component in
        // a weak map associated with the Fiber. On the second render, we reset the global counter to this value.
        // Since React runs the second render immediately after the first, this is safe.
        // @ts-ignore
        let currentOwner = (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED === void 0 ? void 0 : (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner = _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner === void 0 ? void 0 : _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner.current;
        if (currentOwner) {
            let prevComponentValue = $ee9ef19153721bae$var$$b5e257d569688ac6$var$componentIds.get(currentOwner);
            if (prevComponentValue == null) $ee9ef19153721bae$var$$b5e257d569688ac6$var$componentIds.set(currentOwner, {
                id: ctx.current,
                state: currentOwner.memoizedState
            });
            else if (currentOwner.memoizedState !== prevComponentValue.state) {
                // On the second render, the memoizedState gets reset by React.
                // Reset the counter, and remove from the weak map so we don't
                // do this for subsequent useId calls.
                ctx.current = prevComponentValue.id;
                $ee9ef19153721bae$var$$b5e257d569688ac6$var$componentIds.delete(currentOwner);
            }
        }
        // eslint-disable-next-line rulesdir/pure-render
        ref.current = ++ctx.current;
    }
    // eslint-disable-next-line rulesdir/pure-render
    return ref.current;
}
function $ee9ef19153721bae$var$$b5e257d569688ac6$var$useLegacySSRSafeId(defaultId) {
    let ctx = (0, $kc00y.useContext)($ee9ef19153721bae$var$$b5e257d569688ac6$var$SSRContext);
    // If we are rendering in a non-DOM environment, and there's no SSRProvider,
    // provide a warning to hint to the developer to add one.
    ctx === $ee9ef19153721bae$var$$b5e257d569688ac6$var$defaultContext && $ee9ef19153721bae$var$$b5e257d569688ac6$var$canUseDOM;
    let counter = $ee9ef19153721bae$var$$b5e257d569688ac6$var$useCounter(!!defaultId);
    let prefix = `react-aria${ctx.prefix}`;
    return defaultId || `${prefix}-${counter}`;
}
function $ee9ef19153721bae$var$$b5e257d569688ac6$var$useModernSSRSafeId(defaultId) {
    let id = (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).useId();
    let [didSSR] = (0, $kc00y.useState)($ee9ef19153721bae$export$535bd6ca7f90a273());
    let prefix = didSSR || false ? 'react-aria' : `react-aria${$ee9ef19153721bae$var$$b5e257d569688ac6$var$defaultContext.prefix}`;
    return defaultId || `${prefix}-${id}`;
}
const $ee9ef19153721bae$export$619500959fc48b26 = typeof (0, (/*@__PURE__*/$parcel$interopDefault($kc00y)))['useId'] === 'function' ? $ee9ef19153721bae$var$$b5e257d569688ac6$var$useModernSSRSafeId : $ee9ef19153721bae$var$$b5e257d569688ac6$var$useLegacySSRSafeId;
function $ee9ef19153721bae$var$$b5e257d569688ac6$var$getSnapshot() {
    return false;
}
function $ee9ef19153721bae$var$$b5e257d569688ac6$var$getServerSnapshot() {
    return true;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function $ee9ef19153721bae$var$$b5e257d569688ac6$var$subscribe(onStoreChange) {
    // noop
    return ()=>{};
}
function $ee9ef19153721bae$export$535bd6ca7f90a273() {
    // In React 18, we can use useSyncExternalStore to detect if we're server rendering or hydrating.
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($kc00y)))['useSyncExternalStore'] === 'function') return (0, (/*@__PURE__*/$parcel$interopDefault($kc00y)))['useSyncExternalStore']($ee9ef19153721bae$var$$b5e257d569688ac6$var$subscribe, $ee9ef19153721bae$var$$b5e257d569688ac6$var$getSnapshot, $ee9ef19153721bae$var$$b5e257d569688ac6$var$getServerSnapshot);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $kc00y.useContext)($ee9ef19153721bae$var$$b5e257d569688ac6$var$IsSSRContext);
}




const $bec0f45f791cab43$export$386b1213cf9779d8 = (el)=>{
    var _el$getAttribute;
    return ((_el$getAttribute = el.getAttribute('role')) == null ? void 0 : _el$getAttribute.toLowerCase()) === 'menu';
};
const $bec0f45f791cab43$var$noop = ()=>{};
function $bec0f45f791cab43$export$96df6c7c5036b9a2() {
    const id = (0, $ee9ef19153721bae$export$619500959fc48b26)();
    const { show: show = false, toggle: toggle = $bec0f45f791cab43$var$noop, setToggle: setToggle, menuElement: menuElement } = (0, $kc00y.useContext)((0, $d8e1b2c6e408de69$export$2e2bcd8739ae039)) || {};
    const handleClick = (0, $kc00y.useCallback)((e)=>{
        toggle(!show, e);
    }, [
        show,
        toggle
    ]);
    const props = {
        id: id,
        ref: setToggle || $bec0f45f791cab43$var$noop,
        onClick: handleClick,
        'aria-expanded': !!show
    };
    // This is maybe better down in an effect, but
    // the component is going to update anyway when the menu element
    // is set so might return new props.
    if (menuElement && $bec0f45f791cab43$export$386b1213cf9779d8(menuElement)) props['aria-haspopup'] = true;
    return [
        props,
        {
            show: show,
            toggle: toggle
        }
    ];
}
/**
 * Also exported as `<Dropdown.Toggle>` from `Dropdown`.
 *
 * @displayName DropdownToggle
 * @memberOf Dropdown
 */ function $bec0f45f791cab43$var$DropdownToggle({ children: children }) {
    const [props, meta] = $bec0f45f791cab43$export$96df6c7c5036b9a2();
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
        children: children(props, meta)
    });
}
$bec0f45f791cab43$var$DropdownToggle.displayName = 'DropdownToggle';
var /** @component */ $bec0f45f791cab43$export$2e2bcd8739ae039 = $bec0f45f791cab43$var$DropdownToggle;



var $kc00y = parcelRequire("kc00y");


var $kc00y = parcelRequire("kc00y");
const $218ada47f6b11566$var$SelectableContext = /*#__PURE__*/ $kc00y.createContext(null);
const $218ada47f6b11566$export$eef49b42fde998a3 = (eventKey, href = null)=>{
    if (eventKey != null) return String(eventKey);
    return href || null;
};
var $218ada47f6b11566$export$2e2bcd8739ae039 = $218ada47f6b11566$var$SelectableContext;



var $kc00y = parcelRequire("kc00y");
const $f9fd81e390080730$var$NavContext = /*#__PURE__*/ $kc00y.createContext(null);
$f9fd81e390080730$var$NavContext.displayName = 'NavContext';
var $f9fd81e390080730$export$2e2bcd8739ae039 = $f9fd81e390080730$var$NavContext;





const $29338e8fd49336d2$var$_excluded = [
    "eventKey",
    "disabled",
    "onClick",
    "active",
    "as"
];
function $29338e8fd49336d2$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $29338e8fd49336d2$export$522d7e1e4e0e22b2({ key: key, href: href, active: active, disabled: disabled, onClick: onClick }) {
    const onSelectCtx = (0, $kc00y.useContext)((0, $218ada47f6b11566$export$2e2bcd8739ae039));
    const navContext = (0, $kc00y.useContext)((0, $f9fd81e390080730$export$2e2bcd8739ae039));
    const { activeKey: activeKey } = navContext || {};
    const eventKey = (0, $218ada47f6b11566$export$eef49b42fde998a3)(key, href);
    const isActive = active == null && key != null ? (0, $218ada47f6b11566$export$eef49b42fde998a3)(activeKey) === eventKey : active;
    const handleClick = (0, $0261b276e783eb4f$export$2e2bcd8739ae039)((event)=>{
        if (disabled) return;
        onClick == null || onClick(event);
        if (onSelectCtx && !event.isPropagationStopped()) onSelectCtx(eventKey, event);
    });
    return [
        {
            onClick: handleClick,
            'aria-disabled': disabled || undefined,
            'aria-selected': isActive,
            [(0, $53889a51b2c4b977$export$5cc3b7b83e34ade7)('dropdown-item')]: ''
        },
        {
            isActive: isActive
        }
    ];
}
const $29338e8fd49336d2$var$DropdownItem = /*#__PURE__*/ $kc00y.forwardRef((_ref, ref)=>{
    let { eventKey: eventKey, disabled: disabled, onClick: onClick, active: active, as: Component = (0, $cdcc2451955840fb$export$2e2bcd8739ae039) } = _ref, props = $29338e8fd49336d2$var$_objectWithoutPropertiesLoose(_ref, $29338e8fd49336d2$var$_excluded);
    const [dropdownItemProps] = $29338e8fd49336d2$export$522d7e1e4e0e22b2({
        key: eventKey,
        href: props.href,
        disabled: disabled,
        onClick: onClick,
        active: active
    });
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)(Component, Object.assign({}, props, {
        ref: ref
    }, dropdownItemProps));
});
$29338e8fd49336d2$var$DropdownItem.displayName = 'DropdownItem';
var $29338e8fd49336d2$export$2e2bcd8739ae039 = $29338e8fd49336d2$var$DropdownItem;






function $0e40634e2b71fc85$var$useRefWithUpdate() {
    const forceUpdate = (0, $38e2134995fe8a16$export$2e2bcd8739ae039)();
    const ref = (0, $kc00y.useRef)(null);
    const attachRef = (0, $kc00y.useCallback)((element)=>{
        ref.current = element;
        // ensure that a menu set triggers an update for consumers
        forceUpdate();
    }, [
        forceUpdate
    ]);
    return [
        ref,
        attachRef
    ];
}
/**
 * @displayName Dropdown
 * @public
 */ function $0e40634e2b71fc85$var$Dropdown({ defaultShow: defaultShow, show: rawShow, onSelect: onSelect, onToggle: rawOnToggle, itemSelector: itemSelector = `* [${(0, $53889a51b2c4b977$export$5cc3b7b83e34ade7)('dropdown-item')}]`, focusFirstItemOnShow: focusFirstItemOnShow, placement: placement = 'bottom-start', children: children }) {
    const window = (0, $4cbb0ff85b062c6d$export$2e2bcd8739ae039)();
    const [show, onToggle] = (0, $dc977c09674889c6$export$2ee51287a16ca325)(rawShow, defaultShow, rawOnToggle);
    // We use normal refs instead of useCallbackRef in order to populate the
    // the value as quickly as possible, otherwise the effect to focus the element
    // may run before the state value is set
    const [menuRef, setMenu] = $0e40634e2b71fc85$var$useRefWithUpdate();
    const menuElement = menuRef.current;
    const [toggleRef, setToggle] = $0e40634e2b71fc85$var$useRefWithUpdate();
    const toggleElement = toggleRef.current;
    const lastShow = (0, $5c0ae6e770e05919$export$2e2bcd8739ae039)(show);
    const lastSourceEvent = (0, $kc00y.useRef)(null);
    const focusInDropdown = (0, $kc00y.useRef)(false);
    const onSelectCtx = (0, $kc00y.useContext)((0, $218ada47f6b11566$export$2e2bcd8739ae039));
    const toggle = (0, $kc00y.useCallback)((nextShow, event, source = event == null ? void 0 : event.type)=>{
        onToggle(nextShow, {
            originalEvent: event,
            source: source
        });
    }, [
        onToggle
    ]);
    const handleSelect = (0, $0261b276e783eb4f$export$2e2bcd8739ae039)((key, event)=>{
        onSelect == null || onSelect(key, event);
        toggle(false, event, 'select');
        if (!event.isPropagationStopped()) onSelectCtx == null || onSelectCtx(key, event);
    });
    const context = (0, $kc00y.useMemo)(()=>({
            toggle: toggle,
            placement: placement,
            show: show,
            menuElement: menuElement,
            toggleElement: toggleElement,
            setMenu: setMenu,
            setToggle: setToggle
        }), [
        toggle,
        placement,
        show,
        menuElement,
        toggleElement,
        setMenu,
        setToggle
    ]);
    if (menuElement && lastShow && !show) focusInDropdown.current = menuElement.contains(menuElement.ownerDocument.activeElement);
    const focusToggle = (0, $0261b276e783eb4f$export$2e2bcd8739ae039)(()=>{
        if (toggleElement && toggleElement.focus) toggleElement.focus();
    });
    const maybeFocusFirst = (0, $0261b276e783eb4f$export$2e2bcd8739ae039)(()=>{
        const type = lastSourceEvent.current;
        let focusType = focusFirstItemOnShow;
        if (focusType == null) focusType = menuRef.current && (0, $bec0f45f791cab43$export$386b1213cf9779d8)(menuRef.current) ? 'keyboard' : false;
        if (focusType === false || focusType === 'keyboard' && !/^key.+$/.test(type)) return;
        const first = (0, $f666525aadfce5dc$export$2e2bcd8739ae039)(menuRef.current, itemSelector)[0];
        if (first && first.focus) first.focus();
    });
    (0, $kc00y.useEffect)(()=>{
        if (show) maybeFocusFirst();
        else if (focusInDropdown.current) {
            focusInDropdown.current = false;
            focusToggle();
        }
    // only `show` should be changing
    }, [
        show,
        focusInDropdown,
        focusToggle,
        maybeFocusFirst
    ]);
    (0, $kc00y.useEffect)(()=>{
        lastSourceEvent.current = null;
    });
    const getNextFocusedChild = (current, offset)=>{
        if (!menuRef.current) return null;
        const items = (0, $f666525aadfce5dc$export$2e2bcd8739ae039)(menuRef.current, itemSelector);
        let index = items.indexOf(current) + offset;
        index = Math.max(0, Math.min(index, items.length));
        return items[index];
    };
    (0, $3107b4995425ddd1$export$2e2bcd8739ae039)((0, $kc00y.useCallback)(()=>window.document, [
        window
    ]), 'keydown', (event)=>{
        var _menuRef$current, _toggleRef$current;
        const { key: key } = event;
        const target = event.target;
        const fromMenu = (_menuRef$current = menuRef.current) == null ? void 0 : _menuRef$current.contains(target);
        const fromToggle = (_toggleRef$current = toggleRef.current) == null ? void 0 : _toggleRef$current.contains(target);
        // Second only to https://github.com/twbs/bootstrap/blob/8cfbf6933b8a0146ac3fbc369f19e520bd1ebdac/js/src/dropdown.js#L400
        // in inscrutability
        const isInput = /input|textarea/i.test(target.tagName);
        if (isInput && (key === ' ' || key !== 'Escape' && fromMenu || key === 'Escape' && target.type === 'search')) return;
        if (!fromMenu && !fromToggle) return;
        if (key === 'Tab' && (!menuRef.current || !show)) return;
        lastSourceEvent.current = event.type;
        const meta = {
            originalEvent: event,
            source: event.type
        };
        switch(key){
            case 'ArrowUp':
                {
                    const next = getNextFocusedChild(target, -1);
                    if (next && next.focus) next.focus();
                    event.preventDefault();
                    return;
                }
            case 'ArrowDown':
                event.preventDefault();
                if (!show) onToggle(true, meta);
                else {
                    const next = getNextFocusedChild(target, 1);
                    if (next && next.focus) next.focus();
                }
                return;
            case 'Tab':
                // on keydown the target is the element being tabbed FROM, we need that
                // to know if this event is relevant to this dropdown (e.g. in this menu).
                // On `keyup` the target is the element being tagged TO which we use to check
                // if focus has left the menu
                (0, $c414e224cd570c88$export$2e2bcd8739ae039)(target.ownerDocument, 'keyup', (e)=>{
                    var _menuRef$current2;
                    if (e.key === 'Tab' && !e.target || !((_menuRef$current2 = menuRef.current) != null && _menuRef$current2.contains(e.target))) onToggle(false, meta);
                }, {
                    once: true
                });
                break;
            case 'Escape':
                if (key === 'Escape') {
                    event.preventDefault();
                    event.stopPropagation();
                }
                onToggle(false, meta);
                break;
            default:
        }
    });
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $218ada47f6b11566$export$2e2bcd8739ae039).Provider, {
        value: handleSelect,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $d8e1b2c6e408de69$export$2e2bcd8739ae039).Provider, {
            value: context,
            children: children
        })
    });
}
$0e40634e2b71fc85$var$Dropdown.displayName = 'Dropdown';
$0e40634e2b71fc85$var$Dropdown.Menu = (0, $fd14cf6a1acf58cd$export$2e2bcd8739ae039);
$0e40634e2b71fc85$var$Dropdown.Toggle = (0, $bec0f45f791cab43$export$2e2bcd8739ae039);
$0e40634e2b71fc85$var$Dropdown.Item = (0, $29338e8fd49336d2$export$2e2bcd8739ae039);
var $0e40634e2b71fc85$export$2e2bcd8739ae039 = $0e40634e2b71fc85$var$Dropdown;





var $kc00y = parcelRequire("kc00y");
"use client";
const $ff69affc6803807d$var$DropdownContext = /*#__PURE__*/ $kc00y.createContext({});
$ff69affc6803807d$var$DropdownContext.displayName = 'DropdownContext';
var $ff69affc6803807d$export$2e2bcd8739ae039 = $ff69affc6803807d$var$DropdownContext;



var $kc00y = parcelRequire("kc00y");



"use client";
const $527c0dc9eb214207$var$DropdownDivider = /*#__PURE__*/ $kc00y.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'hr', role: role = 'separator', ...props }, ref)=>{
    bsPrefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(bsPrefix, 'dropdown-divider');
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, bsPrefix),
        role: role,
        ...props
    });
});
$527c0dc9eb214207$var$DropdownDivider.displayName = 'DropdownDivider';
var $527c0dc9eb214207$export$2e2bcd8739ae039 = $527c0dc9eb214207$var$DropdownDivider;



var $kc00y = parcelRequire("kc00y");



"use client";
const $ae87f17c4b02854e$var$DropdownHeader = /*#__PURE__*/ $kc00y.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', role: role = 'heading', ...props }, ref)=>{
    bsPrefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(bsPrefix, 'dropdown-header');
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, bsPrefix),
        role: role,
        ...props
    });
});
$ae87f17c4b02854e$var$DropdownHeader.displayName = 'DropdownHeader';
var $ae87f17c4b02854e$export$2e2bcd8739ae039 = $ae87f17c4b02854e$var$DropdownHeader;




var $kc00y = parcelRequire("kc00y");




"use client";
const $5b26f3448ff266e1$var$DropdownItem = /*#__PURE__*/ $kc00y.forwardRef(({ bsPrefix: bsPrefix, className: className, eventKey: eventKey, disabled: disabled = false, onClick: onClick, active: active, as: Component = (0, $68efbe85ab599b20$export$2e2bcd8739ae039), ...props }, ref)=>{
    const prefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(bsPrefix, 'dropdown-item');
    const [dropdownItemProps, meta] = (0, $29338e8fd49336d2$export$522d7e1e4e0e22b2)({
        key: eventKey,
        href: props.href,
        disabled: disabled,
        onClick: onClick,
        active: active
    });
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)(Component, {
        ...props,
        ...dropdownItemProps,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, prefix, meta.isActive && 'active', disabled && 'disabled')
    });
});
$5b26f3448ff266e1$var$DropdownItem.displayName = 'DropdownItem';
var $5b26f3448ff266e1$export$2e2bcd8739ae039 = $5b26f3448ff266e1$var$DropdownItem;



var $kc00y = parcelRequire("kc00y");



"use client";
const $9c1f86c51f5483d4$var$DropdownItemText = /*#__PURE__*/ $kc00y.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'span', ...props }, ref)=>{
    bsPrefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(bsPrefix, 'dropdown-item-text');
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, bsPrefix),
        ...props
    });
});
$9c1f86c51f5483d4$var$DropdownItemText.displayName = 'DropdownItemText';
var $9c1f86c51f5483d4$export$2e2bcd8739ae039 = $9c1f86c51f5483d4$var$DropdownItemText;




var $kc00y = parcelRequire("kc00y");






var $kc00y = parcelRequire("kc00y");
"use client";
const $bb90c81eb1eb23cc$var$context = /*#__PURE__*/ $kc00y.createContext(null);
$bb90c81eb1eb23cc$var$context.displayName = 'InputGroupContext';
var $bb90c81eb1eb23cc$export$2e2bcd8739ae039 = $bb90c81eb1eb23cc$var$context;



var $kc00y = parcelRequire("kc00y");
"use client";
// TODO: check
const $2a05085c6ba59499$var$context = /*#__PURE__*/ $kc00y.createContext(null);
$2a05085c6ba59499$var$context.displayName = 'NavbarContext';
var $2a05085c6ba59499$export$2e2bcd8739ae039 = $2a05085c6ba59499$var$context;




parcelRequire("kc00y");

function $14376c41f96000bc$export$2e2bcd8739ae039(ref, componentName) {
    return ref;
}




"use client";
function $940a0f4833ea142a$export$a2c648e264f4a946(alignEnd, dropDirection, isRTL) {
    const topStart = isRTL ? 'top-end' : 'top-start';
    const topEnd = isRTL ? 'top-start' : 'top-end';
    const bottomStart = isRTL ? 'bottom-end' : 'bottom-start';
    const bottomEnd = isRTL ? 'bottom-start' : 'bottom-end';
    const leftStart = isRTL ? 'right-start' : 'left-start';
    const leftEnd = isRTL ? 'right-end' : 'left-end';
    const rightStart = isRTL ? 'left-start' : 'right-start';
    const rightEnd = isRTL ? 'left-end' : 'right-end';
    let placement = alignEnd ? bottomEnd : bottomStart;
    if (dropDirection === 'up') placement = alignEnd ? topEnd : topStart;
    else if (dropDirection === 'end') placement = alignEnd ? rightEnd : rightStart;
    else if (dropDirection === 'start') placement = alignEnd ? leftEnd : leftStart;
    else if (dropDirection === 'down-centered') placement = 'bottom';
    else if (dropDirection === 'up-centered') placement = 'top';
    return placement;
}
const $940a0f4833ea142a$var$DropdownMenu = /*#__PURE__*/ $kc00y.forwardRef(({ bsPrefix: bsPrefix, className: className, align: align, rootCloseEvent: rootCloseEvent, flip: flip = true, show: showProps, renderOnMount: renderOnMount, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', popperConfig: popperConfig, variant: variant, ...props }, ref)=>{
    let alignEnd = false;
    const isNavbar = (0, $kc00y.useContext)((0, $2a05085c6ba59499$export$2e2bcd8739ae039));
    const prefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(bsPrefix, 'dropdown-menu');
    const { align: contextAlign, drop: drop, isRTL: isRTL } = (0, $kc00y.useContext)((0, $ff69affc6803807d$export$2e2bcd8739ae039));
    align = align || contextAlign;
    const isInputGroup = (0, $kc00y.useContext)((0, $bb90c81eb1eb23cc$export$2e2bcd8739ae039));
    const alignClasses = [];
    if (align) {
        if (typeof align === 'object') {
            const keys = Object.keys(align);
            if (keys.length) {
                const brkPoint = keys[0];
                const direction = align[brkPoint];
                // .dropdown-menu-end is required for responsively aligning
                // left in addition to align left classes.
                alignEnd = direction === 'start';
                alignClasses.push(`${prefix}-${brkPoint}-${direction}`);
            }
        } else if (align === 'end') alignEnd = true;
    }
    const placement = $940a0f4833ea142a$export$a2c648e264f4a946(alignEnd, drop, isRTL);
    const [menuProps, { hasShown: hasShown, popper: popper, show: show, toggle: toggle }] = (0, $fd14cf6a1acf58cd$export$133c4d08f3775d64)({
        flip: flip,
        rootCloseEvent: rootCloseEvent,
        show: showProps,
        usePopper: !isNavbar && alignClasses.length === 0,
        offset: [
            0,
            2
        ],
        popperConfig: popperConfig,
        placement: placement
    });
    menuProps.ref = (0, $950969aa8a9dbb93$export$2e2bcd8739ae039)((0, $14376c41f96000bc$export$2e2bcd8739ae039)(ref, 'DropdownMenu'), menuProps.ref);
    (0, $a72fb555b4b57bff$export$2e2bcd8739ae039)(()=>{
        // Popper's initial position for the menu is incorrect when
        // renderOnMount=true. Need to call update() to correct it.
        if (show) popper == null || popper.update();
    }, [
        show
    ]);
    if (!hasShown && !renderOnMount && !isInputGroup) return null;
    // For custom components provide additional, non-DOM, props;
    if (typeof Component !== 'string') {
        menuProps.show = show;
        menuProps.close = ()=>toggle == null ? void 0 : toggle(false);
        menuProps.align = align;
    }
    let style = props.style;
    if (popper != null && popper.placement) {
        // we don't need the default popper style,
        // menus are display: none when not shown.
        style = {
            ...props.style,
            ...menuProps.style
        };
        props['x-placement'] = popper.placement;
    }
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)(Component, {
        ...props,
        ...menuProps,
        style: style,
        ...(alignClasses.length || isNavbar) && {
            'data-bs-popper': 'static'
        },
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, prefix, show && 'show', alignEnd && `${prefix}-end`, variant && `${prefix}-${variant}`, ...alignClasses)
    });
});
$940a0f4833ea142a$var$DropdownMenu.displayName = 'DropdownMenu';
var $940a0f4833ea142a$export$2e2bcd8739ae039 = $940a0f4833ea142a$var$DropdownMenu;







var $kc00y = parcelRequire("kc00y");




"use client";
const $8d06adcc891f0390$var$DropdownToggle = /*#__PURE__*/ $kc00y.forwardRef(({ bsPrefix: bsPrefix, split: split, className: className, childBsPrefix: childBsPrefix, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = (0, $ec326a924dcbf351$export$2e2bcd8739ae039), ...props }, ref)=>{
    const prefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(bsPrefix, 'dropdown-toggle');
    const dropdownContext = (0, $kc00y.useContext)((0, $d8e1b2c6e408de69$export$2e2bcd8739ae039));
    if (childBsPrefix !== undefined) props.bsPrefix = childBsPrefix;
    const [toggleProps] = (0, $bec0f45f791cab43$export$96df6c7c5036b9a2)();
    toggleProps.ref = (0, $950969aa8a9dbb93$export$2e2bcd8739ae039)(toggleProps.ref, (0, $14376c41f96000bc$export$2e2bcd8739ae039)(ref, 'DropdownToggle'));
    // This intentionally forwards size and variant (if set) to the
    // underlying component, to allow it to render size and style variants.
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)(Component, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, prefix, split && `${prefix}-split`, (dropdownContext == null ? void 0 : dropdownContext.show) && 'show'),
        ...toggleProps,
        ...props
    });
});
$8d06adcc891f0390$var$DropdownToggle.displayName = 'DropdownToggle';
var $8d06adcc891f0390$export$2e2bcd8739ae039 = $8d06adcc891f0390$var$DropdownToggle;






"use client";
const $943025b58510539f$var$Dropdown = /*#__PURE__*/ $kc00y.forwardRef((pProps, ref)=>{
    const { bsPrefix: bsPrefix, drop: drop = 'down', show: show, className: className, align: align = 'start', onSelect: onSelect, onToggle: onToggle, focusFirstItemOnShow: focusFirstItemOnShow, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div', navbar: _4, autoClose: autoClose = true, ...props } = (0, $b0582fd40c314767$export$2e2bcd8739ae039)(pProps, {
        show: 'onToggle'
    });
    const isInputGroup = (0, $kc00y.useContext)((0, $bb90c81eb1eb23cc$export$2e2bcd8739ae039));
    const prefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(bsPrefix, 'dropdown');
    const isRTL = (0, $6c3886f519efe212$export$35e511eefa30ac5a)();
    const isClosingPermitted = (source)=>{
        // autoClose=false only permits close on button click
        if (autoClose === false) return source === 'click';
        // autoClose=inside doesn't permit close on rootClose
        if (autoClose === 'inside') return source !== 'rootClose';
        // autoClose=outside doesn't permit close on select
        if (autoClose === 'outside') return source !== 'select';
        return true;
    };
    const handleToggle = (0, $4655b62db0931f1e$export$2e2bcd8739ae039)((nextShow, meta)=>{
        var _meta$originalEvent;
        /** Checking if target of event is ToggleButton,
     * if it is then nullify mousedown event
     */ const isToggleButton = (_meta$originalEvent = meta.originalEvent) == null || (_meta$originalEvent = _meta$originalEvent.target) == null ? void 0 : _meta$originalEvent.classList.contains('dropdown-toggle');
        if (isToggleButton && meta.source === 'mousedown') return;
        if (meta.originalEvent.currentTarget === document && (meta.source !== 'keydown' || meta.originalEvent.key === 'Escape')) meta.source = 'rootClose';
        if (isClosingPermitted(meta.source)) onToggle == null || onToggle(nextShow, meta);
    });
    const alignEnd = align === 'end';
    const placement = (0, $940a0f4833ea142a$export$a2c648e264f4a946)(alignEnd, drop, isRTL);
    const contextValue = (0, $kc00y.useMemo)(()=>({
            align: align,
            drop: drop,
            isRTL: isRTL
        }), [
        align,
        drop,
        isRTL
    ]);
    const directionClasses = {
        down: prefix,
        'down-centered': `${prefix}-center`,
        up: 'dropup',
        'up-centered': 'dropup-center dropup',
        end: 'dropend',
        start: 'dropstart'
    };
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ff69affc6803807d$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $0e40634e2b71fc85$export$2e2bcd8739ae039), {
            placement: placement,
            show: show,
            onSelect: onSelect,
            onToggle: handleToggle,
            focusFirstItemOnShow: focusFirstItemOnShow,
            itemSelector: `.${prefix}-item:not(.disabled):not(:disabled)`,
            children: isInputGroup ? props.children : /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)(Component, {
                ...props,
                ref: ref,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, show && 'show', directionClasses[drop])
            })
        })
    });
});
$943025b58510539f$var$Dropdown.displayName = 'Dropdown';
var $943025b58510539f$export$2e2bcd8739ae039 = Object.assign($943025b58510539f$var$Dropdown, {
    Toggle: (0, $8d06adcc891f0390$export$2e2bcd8739ae039),
    Menu: (0, $940a0f4833ea142a$export$2e2bcd8739ae039),
    Item: (0, $5b26f3448ff266e1$export$2e2bcd8739ae039),
    ItemText: (0, $9c1f86c51f5483d4$export$2e2bcd8739ae039),
    Divider: (0, $527c0dc9eb214207$export$2e2bcd8739ae039),
    Header: (0, $ae87f17c4b02854e$export$2e2bcd8739ae039)
});









const $eda4eaeb791cb8f1$export$89b68a1a5a6d2b69 = ({ closeModal: closeModal, content: content, confirmButtonText: confirmButtonText })=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8e1f7dde30da3bf6$export$2e2bcd8739ae039).Body, {
                children: content
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8e1f7dde30da3bf6$export$2e2bcd8739ae039).Footer, {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                    variant: "primary",
                    onClick: closeModal,
                    children: confirmButtonText ?? "Fermer"
                })
            })
        ]
    });
};
const $eda4eaeb791cb8f1$var$SimpleModal = ({ ref: ref, visible: visible, closeModal: closeModal, header: header, content: content })=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $8e1f7dde30da3bf6$export$2e2bcd8739ae039), {
        show: visible,
        onHide: closeModal,
        ref: ref,
        size: "xl",
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8e1f7dde30da3bf6$export$2e2bcd8739ae039).Header, {
                closeButton: true,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8e1f7dde30da3bf6$export$2e2bcd8739ae039).Title, {
                    children: header
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($eda4eaeb791cb8f1$export$89b68a1a5a6d2b69, {
                closeModal: closeModal,
                content: content
            })
        ]
    });
};
var $eda4eaeb791cb8f1$export$2e2bcd8739ae039 = $eda4eaeb791cb8f1$var$SimpleModal;



const $e2b95e917adfa742$var$ButtonWithSimpleModal = ({ icon: icon, disabled: disabled = false, classEnable: classEnable, textDisable: textDisable, textEnable: textEnable, tooltipId: tooltipId, header: header, content: content })=>{
    const { visible: visible, show: show, close: close, ref: ref } = (0, $ca8671088139af49$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                tooltipText: disabled ? textDisable : textEnable,
                tooltipId: tooltipId,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                    variant: "link",
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))("p-0 m-0", disabled ? "text-decoration-none text-muted" : "text-decoration-none text-" + classEnable),
                    disabled: disabled,
                    onClick: ()=>show(),
                    children: icon
                })
            }),
            !disabled && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eda4eaeb791cb8f1$export$2e2bcd8739ae039), {
                visible: visible,
                closeModal: close,
                ref: ref,
                content: content,
                header: header
            })
        ]
    });
};
var $e2b95e917adfa742$export$2e2bcd8739ae039 = $e2b95e917adfa742$var$ButtonWithSimpleModal;







const $c094b74d2be2aa67$var$DeleteButton = ({ className: className = "text-danger", disabled: disabled, onClick: onClick, title: title })=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
        variant: "link",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, "text-decoration-none"),
        disabled: disabled,
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$4d4e10ce882b8153), {}),
            " ",
            title
        ]
    });
};
var $c094b74d2be2aa67$export$2e2bcd8739ae039 = $c094b74d2be2aa67$var$DeleteButton;













const $c738870e8199ea0b$var$EditModalBody = ({ prepareVariables: prepareVariables, getInitialValues: getInitialValues, query: query, id: id, validationSchema: validationSchema, canModify: canModify, onSubmit: onSubmit, closeModal: closeModal, children: children, submitLabel: submitLabel, value: value, isMultipartFormData: isMultipartFormData = false })=>{
    const isAdd = id == null;
    const submitUrl = query + "/" + (id ? id : "");
    const editState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)(isAdd ? null : submitUrl, {});
    const { isLoading: isLoading, isResolved: isResolved, data: data = {} } = editState;
    let initialData = {};
    if (!isAdd) {
        if (isLoading) return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $c21b1c237cfa1d94$export$2e2bcd8739ae039), {});
        if (!isResolved) closeModal(); // FIXME : mettre un message d'erreur ?
        if (!data) {
            (0, $958d7290af97c4cf$export$2e2bcd8739ae039)({
                content: `Une erreur est survenue lors de la r\xe9cup\xe9ration des donn\xe9es.`,
                variant: "danger"
            });
            closeModal();
        }
        initialData = data;
    }
    if (isAdd && value) initialData = value;
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
        validationSchema: validationSchema,
        isPost: isAdd,
        initialValues: getInitialValues ? getInitialValues(initialData) : initialData,
        submitUrl: submitUrl,
        onSubmit: (values)=>{
            onSubmit && onSubmit(values);
            closeModal();
        },
        prepareVariables: (values)=>prepareVariables(values),
        isMultipartFormData: isMultipartFormData,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
            noValidate: true,
            children: [
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8e1f7dde30da3bf6$export$2e2bcd8739ae039).Body, {
                    children: children
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8e1f7dde30da3bf6$export$2e2bcd8739ae039).Footer, {
                    children: canModify ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                                variant: "secondary",
                                onClick: (e)=>{
                                    e.preventDefault();
                                    closeModal();
                                },
                                children: "Annuler"
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                                variant: "primary",
                                type: "submit",
                                children: submitLabel
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                        variant: "secondary",
                        onClick: closeModal,
                        children: "Fermer"
                    })
                })
            ]
        })
    });
};
const $c738870e8199ea0b$var$EditModal = ({ visible: visible, closeModal: closeModal, header: header, query: query, id: id, children: children, validationSchema: validationSchema, onSubmit: onSubmit, prepareVariables: prepareVariables = (values)=>({
        values: values
    }), getInitialValues: getInitialValues, canModify: canModify = true, submitLabel: submitLabel = "Valider", value: value = {}, isMultipartFormData: isMultipartFormData = false })=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $8e1f7dde30da3bf6$export$2e2bcd8739ae039), {
        show: visible,
        onHide: closeModal,
        size: "xl",
        backdrop: false,
        /*
        Ajoute la tooltips au composant map-container si il existe pour qu'elle s'affiche
        aussi en fullscreen
    */ container: document.getElementById("map-container"),
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8e1f7dde30da3bf6$export$2e2bcd8739ae039).Header, {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8e1f7dde30da3bf6$export$2e2bcd8739ae039).Title, {
                    children: header
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($c738870e8199ea0b$var$EditModalBody, {
                canModify: canModify,
                query: query,
                id: id,
                validationSchema: validationSchema,
                onSubmit: onSubmit,
                closeModal: closeModal,
                prepareVariables: prepareVariables,
                getInitialValues: getInitialValues,
                submitLabel: submitLabel,
                value: value,
                isMultipartFormData: isMultipartFormData,
                children: children
            })
        ]
    });
};
var $c738870e8199ea0b$export$2e2bcd8739ae039 = $c738870e8199ea0b$var$EditModal;




const $dd99a466fda4f852$var$TableActionColumn = ({ row: row, disabled: disabled = false, textDisable: textDisable, textEnable: textEnable, classEnable: classEnable = "primary", deleteModal: deleteModal = null, editModal: editModal = null, confirmModal: confirmModal = null, simpleModal: simpleModal = null, isPost: isPost = true, reload: reload, icon: icon, pathname: pathname, hide: hide = ()=>false, onClick: onClick, isLink: isLink = true, state: state, search: search })=>{
    return !hide || !hide(row.original) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
        xs: 1,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
            children: editModal != null ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $c738870e8199ea0b$export$2e2bcd8739ae039), {
                        closeModal: editModal.close,
                        header: editModal.header,
                        ref: editModal.ref,
                        visible: editModal.visible,
                        query: editModal.path,
                        prepareVariables: editModal.prepareVariable,
                        value: editModal.value,
                        onSubmit: ()=>reload ? reload() : window.location.reload(false),
                        children: editModal.content
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                        tooltipText: disabled ? textDisable : textEnable,
                        tooltipId: row.value,
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                            variant: "link",
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))("p-0 m-0", disabled ? "text-decoration-none text-muted" : "text-decoration-none text-" + classEnable),
                            disabled: disabled,
                            onClick: editModal?.show,
                            children: icon
                        })
                    })
                ]
            }) : deleteModal != null ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                        tooltipText: disabled ? textDisable : textEnable,
                        tooltipId: row.value,
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $c094b74d2be2aa67$export$2e2bcd8739ae039), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))("p-0 m-0", disabled ? "text-muted" : "text-" + classEnable),
                            disabled: disabled,
                            onClick: ()=>deleteModal?.show?.()
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $791e7ee3b0d1ae7e$export$2e2bcd8739ae039), {
                        visible: !!deleteModal.visible,
                        onCancel: deleteModal.onCancel ?? (()=>null),
                        onError: deleteModal.onError ?? (()=>null),
                        onSuccess: deleteModal.onSuccess ?? (()=>null),
                        query: pathname,
                        ref: deleteModal.ref,
                        onDelete: ()=>reload ? reload() : window.location.reload(false),
                        header: deleteModal.header,
                        content: deleteModal.content
                    })
                ]
            }) : confirmModal != null ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $4c9f3f4d48e33e9a$export$2e2bcd8739ae039), {
                path: pathname,
                icon: icon,
                disabled: disabled,
                classEnable: classEnable,
                textDisable: textDisable,
                textEnable: textEnable,
                tooltipId: row.value,
                isPost: isPost,
                header: confirmModal.header,
                content: confirmModal.content
            }) : simpleModal != null ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e2b95e917adfa742$export$2e2bcd8739ae039), {
                icon: icon,
                disabled: disabled,
                classEnable: classEnable,
                textDisable: textDisable,
                textEnable: textEnable,
                tooltipId: row.value,
                header: simpleModal.header,
                content: simpleModal.content
            }) : isLink ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                tooltipText: disabled ? textDisable : textEnable,
                tooltipId: row.value,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $43f579690a1c166d$export$2e2bcd8739ae039), {
                        search: search,
                        variant: "link",
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))("p-0 m-0", "text-decoration-none", disabled ? "text-muted" : "text-" + classEnable),
                        disabled: disabled,
                        pathname: pathname,
                        onClick: onClick,
                        state: state,
                        children: icon
                    })
                })
            }) : /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                tooltipText: disabled ? textDisable : textEnable,
                tooltipId: row.value,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                    variant: "link",
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))("p-0 m-0", "text-decoration-none", disabled ? "text-muted" : "text-" + classEnable),
                    disabled: disabled,
                    href: pathname,
                    onClick: onClick,
                    children: icon
                })
            })
        })
    });
};
const $dd99a466fda4f852$export$cfc7921d29ef7b80 = ({ buttons: buttons, row: row })=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
        className: "d-flex flex-row",
        children: buttons.map((_button, key)=>{
            switch(_button.type){
                case 0:
                    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($dd99a466fda4f852$var$DeleteButtonPrivate, {
                        _button: _button,
                        row: row
                    }, key);
                case 1:
                    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($dd99a466fda4f852$var$ConfirmButtonPrivate, {
                        _button: _button,
                        row: row
                    }, key);
                case 2:
                    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($dd99a466fda4f852$var$SimpleModalButtonPrivate, {
                        _button: _button,
                        row: row
                    }, key);
                case 7:
                    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($dd99a466fda4f852$var$EditModalButtonPrivate, {
                        _button: _button,
                        row: row
                    }, key);
                case 8:
                    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($dd99a466fda4f852$var$DropdownButtonPrivate, {
                        _button: _button,
                        row: row
                    }, key);
                case 3:
                    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($dd99a466fda4f852$var$TableActionColumn, {
                        row: row,
                        textEnable: _button.textEnable ?? "Modifier",
                        icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$b51dd496211ae105), {}),
                        classEnable: "info",
                        textDisable: _button.textDisable,
                        disabled: _button.disable ? _button.disable(row) : false,
                        pathname: _button.route?.(row.value),
                        onClick: ()=>_button.onClick?.(row.value, row.original),
                        state: _button.state,
                        isLink: true
                    }, key);
                case 4:
                    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($dd99a466fda4f852$var$TableActionColumn, {
                        row: row,
                        textEnable: _button.textEnable ?? "Voir plus",
                        icon: _button.icon ?? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$8bb46d5eef767d7), {}),
                        pathname: _button.route?.(row.value)
                    }, key);
                case 5:
                    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($dd99a466fda4f852$var$TableActionColumn, {
                        row: row,
                        textEnable: _button.textEnable,
                        icon: _button.icon,
                        pathname: _button.route?.(row.value),
                        onClick: ()=>_button.onClick?.(row.value, row.original),
                        hide: _button.hide,
                        disabled: _button.disable ? _button.disable(row) : false,
                        classEnable: _button.classEnable,
                        confirmModal: _button.confirmModal,
                        reload: _button.reload,
                        textDisable: _button.textDisable,
                        search: _button.search?.(row),
                        state: _button.state?.(row)
                    }, key);
                case 6:
                    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($dd99a466fda4f852$var$TableActionColumn, {
                        row: row,
                        textEnable: _button.textEnable,
                        icon: _button.icon,
                        pathname: _button.route?.(row.value),
                        onClick: ()=>_button.onClick?.(row.value, row.original),
                        hide: _button.hide,
                        disabled: _button.disable ? _button.disable(row) : false,
                        classEnable: _button.classEnable,
                        confirmModal: _button.confirmModal,
                        reload: _button.reload,
                        textDisable: _button.textDisable,
                        isLink: false
                    }, key);
            }
        })
    });
};
var $dd99a466fda4f852$export$324d92f8c11376d5 = /*#__PURE__*/ function(TYPE_BUTTON) {
    TYPE_BUTTON[TYPE_BUTTON["DELETE"] = 0] = "DELETE";
    TYPE_BUTTON[TYPE_BUTTON["CONFIRM"] = 1] = "CONFIRM";
    TYPE_BUTTON[TYPE_BUTTON["SIMPLE_MODAL"] = 2] = "SIMPLE_MODAL";
    TYPE_BUTTON[TYPE_BUTTON["UPDATE"] = 3] = "UPDATE";
    TYPE_BUTTON[TYPE_BUTTON["SEE"] = 4] = "SEE";
    TYPE_BUTTON[TYPE_BUTTON["LINK"] = 5] = "LINK";
    TYPE_BUTTON[TYPE_BUTTON["BUTTON"] = 6] = "BUTTON";
    TYPE_BUTTON[TYPE_BUTTON["EDIT_MODAL"] = 7] = "EDIT_MODAL";
    TYPE_BUTTON[TYPE_BUTTON["DROPDOWN"] = 8] = "DROPDOWN";
    return TYPE_BUTTON;
}({});
const $dd99a466fda4f852$var$EditModalButtonPrivate = ({ row: row, _button: _button })=>{
    const { visible: visible, show: show, close: close, ref: ref } = (0, $ca8671088139af49$export$2e2bcd8739ae039)();
    const editModal = {
        close: close,
        ref: ref,
        show: show,
        visible: visible,
        content: _button.editModal?.content(row.value),
        header: _button.editModal?.header(row),
        path: _button.editModal.path(row),
        prepareVariable: _button.editModal.prepareVariable,
        value: _button.editModal.value
    };
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($dd99a466fda4f852$var$TableActionColumn, {
        row: row,
        disabled: _button.disable ? _button.disable(row) : false,
        editModal: editModal,
        textDisable: _button.textDisable,
        textEnable: _button.textEnable ?? "Editer",
        icon: _button.icon ?? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$e04bcc6127e699bf), {})
    });
};
const $dd99a466fda4f852$var$DeleteButtonPrivate = ({ row: row, _button: _button })=>{
    const { visible: visible, ref: ref, isDeleteEnabled: isDeleteEnabled, openDeleteModal: openDeleteModal, closeDeleteModalCancel: closeDeleteModalCancel, closeDeleteModalError: closeDeleteModalError, closeDeleteModalSuccess: closeDeleteModalSuccess } = (0, $6db3fd3479b0e545$export$2e2bcd8739ae039)();
    const businessDisabled = _button.disable ? _button.disable(row) : false;
    const isDisabled = businessDisabled || !isDeleteEnabled;
    const textDisable = !isDeleteEnabled ? "\xc9l\xe9ment d\xe9j\xe0 supprim\xe9" : _button.textDisable ?? _button.textDisableFunction?.(row);
    const deleteModal = {
        onCancel: closeDeleteModalCancel,
        onError: closeDeleteModalError,
        onSuccess: closeDeleteModalSuccess,
        ref: ref,
        show: openDeleteModal,
        visible: visible,
        header: _button.header ? _button.header(row) : undefined,
        content: _button.content ? _button.content(row) : undefined
    };
    let computedPathname = "";
    if (typeof _button.pathname === "function") computedPathname = _button.pathname(row);
    else if (typeof _button.pathname === "string") computedPathname = `${_button.pathname}${row.value ?? ""}`;
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($dd99a466fda4f852$var$TableActionColumn, {
        row: row,
        disabled: isDisabled,
        textDisable: textDisable,
        textEnable: _button.textEnable ?? "Supprimer",
        classEnable: "danger",
        deleteModal: deleteModal,
        icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$4d4e10ce882b8153), {}),
        pathname: computedPathname
    });
};
const $dd99a466fda4f852$var$ConfirmButtonPrivate = ({ row: row, _button: _button })=>{
    const confirmModal = {
        header: typeof _button.confirmModal?.header === "function" ? _button.confirmModal.header(row) : _button.confirmModal?.header ?? "Confirmer ?",
        content: typeof _button.confirmModal?.content === "function" ? _button.confirmModal.content(row.value, row) : _button.confirmModal?.content ?? "Confirmer ?"
    };
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($dd99a466fda4f852$var$TableActionColumn, {
        isPost: _button.isPost,
        row: row,
        disabled: _button.disable ? _button.disable(row) : false,
        textDisable: _button.textDisable ?? _button.conditionnalTextDisable?.(row),
        hide: _button.hide,
        textEnable: _button.textEnable,
        classEnable: _button.classEnable,
        confirmModal: confirmModal,
        icon: _button.icon ?? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$e04bcc6127e699bf), {}),
        pathname: `${_button.pathname}${row.value}`
    });
};
const $dd99a466fda4f852$var$SimpleModalButtonPrivate = ({ row: row, _button: _button })=>{
    const contentValue = typeof _button.simpleModal?.content === "function" ? _button.simpleModal.content(row.value, row) : _button.simpleModal?.content;
    const headerValue = typeof _button.simpleModal?.header === "function" ? _button.simpleModal.header(row) : _button.simpleModal?.header;
    const simpleModal = {
        content: contentValue,
        header: headerValue || ""
    };
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($dd99a466fda4f852$var$TableActionColumn, {
        row: row,
        simpleModal: simpleModal,
        textEnable: _button.textEnable ?? "Voir plus",
        icon: _button.icon ?? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$e04bcc6127e699bf), {}),
        disabled: _button.disable ? _button.disable(row) : false,
        textDisable: _button.textDisable
    });
};
const $dd99a466fda4f852$var$DropdownButtonPrivate = ({ row: row, _button: _button })=>{
    const isHidden = _button.hide ? _button.hide(row) : false;
    if (isHidden) return null;
    const items = (_button.children ?? []).filter((child)=>child.hide ? !child.hide(row) : true);
    if (items.length === 0) return null;
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
        xs: 1,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $943025b58510539f$export$2e2bcd8739ae039), {
            align: "end",
            children: [
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                    tooltipText: _button.textEnable,
                    tooltipId: `dropdown-${row.value}`,
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $943025b58510539f$export$2e2bcd8739ae039).Toggle, {
                        variant: "link",
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))("p-0 m-0", "text-decoration-none", _button.classEnable ? `text-${_button.classEnable}` : "text-primary"),
                        children: _button.icon ?? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$8bb46d5eef767d7), {})
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $943025b58510539f$export$2e2bcd8739ae039).Menu, {
                    children: items.map((child, idx)=>{
                        const disabled = child.disable ? child.disable(row) : false;
                        const key = `${row.value}-child-${idx}`;
                        const label = child.textEnable ?? "Action";
                        const icon = child.icon;
                        if (child.type === 5) {
                            const pathname = child.route?.(row.value);
                            return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $943025b58510539f$export$2e2bcd8739ae039).Item, {
                                as: "span",
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(disabled && "disabled"),
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $43f579690a1c166d$export$2e2bcd8739ae039), {
                                    variant: "link",
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))("p-0 m-0", disabled ? "text-muted" : ""),
                                    disabled: disabled,
                                    pathname: pathname ?? "#",
                                    onClick: ()=>child.onClick?.(row.value, row.original),
                                    state: child.state,
                                    search: child.search?.(row) ?? undefined,
                                    children: [
                                        icon,
                                        "\xa0",
                                        label
                                    ]
                                })
                            }, key);
                        }
                        if (child.type === 1) {
                            const confirmHeader = typeof child.confirmModal?.header === "function" ? child.confirmModal.header(row) : child.confirmModal?.header ?? "Confirmer ?";
                            const confirmContent = typeof child.confirmModal?.content === "function" ? child.confirmModal.content(row.value, row) : child.confirmModal?.content ?? "";
                            const pathname = typeof child.pathname === "function" ? child.pathname(row) : `${child.pathname ?? ""}${row.value ?? ""}`;
                            return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $943025b58510539f$export$2e2bcd8739ae039).Item, {
                                as: "span",
                                className: "p-0",
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $4c9f3f4d48e33e9a$export$2e2bcd8739ae039), {
                                    path: pathname,
                                    reload: child.reload,
                                    icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("span", {
                                        className: "d-flex align-items-center",
                                        children: [
                                            icon,
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("span", {
                                                className: "ms-2",
                                                children: label
                                            })
                                        ]
                                    }),
                                    disabled: disabled,
                                    classEnable: child.classEnable ?? "primary",
                                    textDisable: child.textDisable ?? child.conditionnalTextDisable?.(row),
                                    textEnable: label,
                                    tooltipId: key,
                                    isPost: child.isPost ?? true,
                                    header: confirmHeader,
                                    content: confirmContent,
                                    variant: "link",
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))("dropdown-item d-flex align-items-center w-100 px-3 py-1 text-start", disabled && "disabled")
                                })
                            }, key);
                        }
                        return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $943025b58510539f$export$2e2bcd8739ae039).Item, {
                            as: "button",
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))("d-flex align-items-center", disabled && "disabled"),
                            disabled: disabled,
                            onClick: ()=>child.onClick?.(row.value, row.original),
                            children: [
                                icon,
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("span", {
                                    className: "ms-2",
                                    children: label
                                })
                            ]
                        }, key);
                    })
                })
            ]
        })
    });
};


const $b82b937cc97f6f18$export$4a828bd35aa40c49 = 28;
const $b82b937cc97f6f18$var$EditColumn = ({ to: to, title: title = true, disabled: disabled = false, disable: disable = ()=>false, textDisable: textDisable = "", ...option })=>({
        // eslint-disable-next-line react/display-name
        Cell: (row)=>{
            return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                    tooltipText: !(disable(row) || disabled) ? "Modifier" : textDisable,
                    tooltipId: row.value,
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                        variant: "link",
                        href: to(row.value),
                        disabled: disabled || disable(row),
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$b51dd496211ae105), {}),
                            title && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
                                children: "\xa0Modifier"
                            })
                        ]
                    })
                })
            });
        },
        width: title ? 140 : 90,
        ...option
    });
var $b82b937cc97f6f18$export$2e2bcd8739ae039 = $b82b937cc97f6f18$var$EditColumn;
const $b82b937cc97f6f18$export$82633536c9b7c49a = ({ to: to, title: title = "", icon: icon, disabled: disabled = false, disable: disable = ()=>false, tooltipText: tooltipText = "", textDisable: textDisable = "", ...option })=>({
        // eslint-disable-next-line react/display-name
        Cell: (row)=>{
            const titleIsNotEmpty = title?.trim().length > 0;
            return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                    tooltipText: !(disable(row) || disabled) ? tooltipText : textDisable,
                    tooltipId: row.value,
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                        variant: "link",
                        href: to(row.value),
                        disabled: disabled || disable(row),
                        children: [
                            icon,
                            titleIsNotEmpty && title
                        ]
                    })
                })
            });
        },
        width: title ? 140 : 90,
        ...option
    });
const $b82b937cc97f6f18$export$ad76ec2c15e9c66f = ({ path: path, reload: reload, title: title = true, disabled: disabled = false, disable: disable = ()=>false, textDisable: textDisable = "", ...options })=>({
        // eslint-disable-next-line react/display-name
        Cell: (row)=>{
            const { visible: visible, ref: ref, isDeleteEnabled: isDeleteEnabled, openDeleteModal: openDeleteModal, closeDeleteModalCancel: closeDeleteModalCancel, closeDeleteModalError: closeDeleteModalError, closeDeleteModalSuccess: closeDeleteModalSuccess } = (0, $6db3fd3479b0e545$export$2e2bcd8739ae039)();
            const query = `${path}${row.value}`;
            const isDisabled = disabled || disable(row) || !isDeleteEnabled;
            const computedTextDisable = !isDeleteEnabled ? "\xc9l\xe9ment d\xe9j\xe0 supprim\xe9" : textDisable;
            return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                        tooltipText: isDisabled ? computedTextDisable : "Supprimer",
                        tooltipId: row.value,
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                            variant: "link",
                            className: isDisabled ? "" : "text-danger",
                            disabled: isDisabled,
                            onClick: openDeleteModal,
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$4d4e10ce882b8153), {}),
                                title && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
                                    children: "\xa0Supprimer"
                                })
                            ]
                        })
                    }),
                    !disable(row) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $791e7ee3b0d1ae7e$export$2e2bcd8739ae039), {
                        visible: visible,
                        onCancel: closeDeleteModalCancel,
                        onError: closeDeleteModalError,
                        onSuccess: closeDeleteModalSuccess,
                        query: query,
                        ref: ref,
                        onDelete: ()=>reload ? reload() : window.location.reload()
                    })
                ]
            });
        },
        width: title ? 160 : 90,
        ...options
    });
const $b82b937cc97f6f18$export$36e9f5a475c9f6fc = ({ Header: Header, accessor: accessor, sortField: sortField, buttons: buttons, width: width = 200, ...options })=>({
        // eslint-disable-next-line react/display-name
        Header: Header,
        accessor: accessor,
        Cell: (row)=>{
            return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $dd99a466fda4f852$export$cfc7921d29ef7b80), {
                buttons: buttons,
                row: row
            });
        },
        sortField: sortField,
        width: (buttons?.length * $b82b937cc97f6f18$export$4a828bd35aa40c49) ?? width,
        ...options
    });
const $b82b937cc97f6f18$export$38dcf858d3ede0e9 = ({ Header: Header, accessor: accessor, sortField: sortField, ...options })=>({
        // eslint-disable-next-line react/display-name
        Header: Header,
        accessor: accessor,
        Cell: (value)=>{
            return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                className: "text-center",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Check, {
                    type: "checkbox",
                    disabled: true,
                    checked: value.value === true
                })
            });
        },
        sortField: sortField,
        ...options
    });
const $b82b937cc97f6f18$export$4f228b0e0fb17419 = ({ Header: Header, accessor: accessor, sortField: sortField, ...options })=>({
        // eslint-disable-next-line react/display-name
        Header: Header,
        accessor: accessor,
        Cell: (value)=>{
            return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                    className: "text-center",
                    children: value.value ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$bfc5043f33fb4eee), {}) : /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$40e1334ac13dc359), {})
                })
            });
        },
        sortField: sortField,
        ...options
    });














var $kc00y = parcelRequire("kc00y");



var $kc00y = parcelRequire("kc00y");





var $kc00y = parcelRequire("kc00y");
const $26ddc764548e04cb$var$TabContext = /*#__PURE__*/ $kc00y.createContext(null);
var $26ddc764548e04cb$export$2e2bcd8739ae039 = $26ddc764548e04cb$var$TabContext;




var $kc00y = parcelRequire("kc00y");







const $fef4535ccedac40e$var$_excluded = [
    "as",
    "active",
    "eventKey"
];
function $fef4535ccedac40e$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $fef4535ccedac40e$export$d7a68693710982a({ key: key, onClick: onClick, active: active, id: id, role: role, disabled: disabled }) {
    const parentOnSelect = (0, $kc00y.useContext)((0, $218ada47f6b11566$export$2e2bcd8739ae039));
    const navContext = (0, $kc00y.useContext)((0, $f9fd81e390080730$export$2e2bcd8739ae039));
    const tabContext = (0, $kc00y.useContext)((0, $26ddc764548e04cb$export$2e2bcd8739ae039));
    let isActive = active;
    const props = {
        role: role
    };
    if (navContext) {
        if (!role && navContext.role === 'tablist') props.role = 'tab';
        const contextControllerId = navContext.getControllerId(key != null ? key : null);
        const contextControlledId = navContext.getControlledId(key != null ? key : null);
        // @ts-ignore
        props[(0, $53889a51b2c4b977$export$5cc3b7b83e34ade7)('event-key')] = key;
        props.id = contextControllerId || id;
        isActive = active == null && key != null ? navContext.activeKey === key : active;
        /**
     * Simplified scenario for `mountOnEnter`.
     *
     * While it would make sense to keep 'aria-controls' for tabs that have been mounted at least
     * once, it would also complicate the code quite a bit, for very little gain.
     * The following implementation is probably good enough.
     *
     * @see https://github.com/react-restart/ui/pull/40#issuecomment-1009971561
     */ if (isActive || !(tabContext != null && tabContext.unmountOnExit) && !(tabContext != null && tabContext.mountOnEnter)) props['aria-controls'] = contextControlledId;
    }
    if (props.role === 'tab') {
        props['aria-selected'] = isActive;
        if (!isActive) props.tabIndex = -1;
        if (disabled) {
            props.tabIndex = -1;
            props['aria-disabled'] = true;
        }
    }
    props.onClick = (0, $0261b276e783eb4f$export$2e2bcd8739ae039)((e)=>{
        if (disabled) return;
        onClick == null || onClick(e);
        if (key == null) return;
        if (parentOnSelect && !e.isPropagationStopped()) parentOnSelect(key, e);
    });
    return [
        props,
        {
            isActive: isActive
        }
    ];
}
const $fef4535ccedac40e$var$NavItem = /*#__PURE__*/ $kc00y.forwardRef((_ref, ref)=>{
    let { as: Component = (0, $cdcc2451955840fb$export$2e2bcd8739ae039), active: active, eventKey: eventKey } = _ref, options = $fef4535ccedac40e$var$_objectWithoutPropertiesLoose(_ref, $fef4535ccedac40e$var$_excluded);
    const [props, meta] = $fef4535ccedac40e$export$d7a68693710982a(Object.assign({
        key: (0, $218ada47f6b11566$export$eef49b42fde998a3)(eventKey, options.href),
        active: active
    }, options));
    // @ts-ignore
    props[(0, $53889a51b2c4b977$export$5cc3b7b83e34ade7)('active')] = meta.isActive;
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)(Component, Object.assign({}, options, props, {
        ref: ref
    }));
});
$fef4535ccedac40e$var$NavItem.displayName = 'NavItem';
var $fef4535ccedac40e$export$2e2bcd8739ae039 = $fef4535ccedac40e$var$NavItem;



const $9c61fab88f8a2080$var$_excluded = [
    "as",
    "onSelect",
    "activeKey",
    "role",
    "onKeyDown"
];
function $9c61fab88f8a2080$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $9c61fab88f8a2080$var$noop = ()=>{};
const $9c61fab88f8a2080$var$EVENT_KEY_ATTR = (0, $53889a51b2c4b977$export$5cc3b7b83e34ade7)('event-key');
const $9c61fab88f8a2080$var$Nav = /*#__PURE__*/ $kc00y.forwardRef((_ref, ref)=>{
    let { // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div', onSelect: onSelect, activeKey: activeKey, role: role, onKeyDown: onKeyDown } = _ref, props = $9c61fab88f8a2080$var$_objectWithoutPropertiesLoose(_ref, $9c61fab88f8a2080$var$_excluded);
    // A ref and forceUpdate for refocus, b/c we only want to trigger when needed
    // and don't want to reset the set in the effect
    const forceUpdate = (0, $38e2134995fe8a16$export$2e2bcd8739ae039)();
    const needsRefocusRef = (0, $kc00y.useRef)(false);
    const parentOnSelect = (0, $kc00y.useContext)((0, $218ada47f6b11566$export$2e2bcd8739ae039));
    const tabContext = (0, $kc00y.useContext)((0, $26ddc764548e04cb$export$2e2bcd8739ae039));
    let getControlledId, getControllerId;
    if (tabContext) {
        role = role || 'tablist';
        activeKey = tabContext.activeKey;
        // TODO: do we need to duplicate these?
        getControlledId = tabContext.getControlledId;
        getControllerId = tabContext.getControllerId;
    }
    const listNode = (0, $kc00y.useRef)(null);
    const getNextActiveTab = (offset)=>{
        const currentListNode = listNode.current;
        if (!currentListNode) return null;
        const items = (0, $f666525aadfce5dc$export$2e2bcd8739ae039)(currentListNode, `[${$9c61fab88f8a2080$var$EVENT_KEY_ATTR}]:not([aria-disabled=true])`);
        const activeChild = currentListNode.querySelector('[aria-selected=true]');
        if (!activeChild || activeChild !== document.activeElement) return null;
        const index = items.indexOf(activeChild);
        if (index === -1) return null;
        let nextIndex = index + offset;
        if (nextIndex >= items.length) nextIndex = 0;
        if (nextIndex < 0) nextIndex = items.length - 1;
        return items[nextIndex];
    };
    const handleSelect = (key, event)=>{
        if (key == null) return;
        onSelect == null || onSelect(key, event);
        parentOnSelect == null || parentOnSelect(key, event);
    };
    const handleKeyDown = (event)=>{
        onKeyDown == null || onKeyDown(event);
        if (!tabContext) return;
        let nextActiveChild;
        switch(event.key){
            case 'ArrowLeft':
            case 'ArrowUp':
                nextActiveChild = getNextActiveTab(-1);
                break;
            case 'ArrowRight':
            case 'ArrowDown':
                nextActiveChild = getNextActiveTab(1);
                break;
            default:
                return;
        }
        if (!nextActiveChild) return;
        event.preventDefault();
        handleSelect(nextActiveChild.dataset[(0, $53889a51b2c4b977$export$7776c0a7cd2eb3e0)('EventKey')] || null, event);
        needsRefocusRef.current = true;
        forceUpdate();
    };
    (0, $kc00y.useEffect)(()=>{
        if (listNode.current && needsRefocusRef.current) {
            const activeChild = listNode.current.querySelector(`[${$9c61fab88f8a2080$var$EVENT_KEY_ATTR}][aria-selected=true]`);
            activeChild == null || activeChild.focus();
        }
        needsRefocusRef.current = false;
    });
    const mergedRef = (0, $e83f66af48ac0793$export$2e2bcd8739ae039)(ref, listNode);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $218ada47f6b11566$export$2e2bcd8739ae039).Provider, {
        value: handleSelect,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $f9fd81e390080730$export$2e2bcd8739ae039).Provider, {
            value: {
                role: role,
                // used by NavLink to determine it's role
                activeKey: (0, $218ada47f6b11566$export$eef49b42fde998a3)(activeKey),
                getControlledId: getControlledId || $9c61fab88f8a2080$var$noop,
                getControllerId: getControllerId || $9c61fab88f8a2080$var$noop
            },
            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)(Component, Object.assign({}, props, {
                onKeyDown: handleKeyDown,
                ref: mergedRef,
                role: role
            }))
        })
    });
});
$9c61fab88f8a2080$var$Nav.displayName = 'Nav';
var $9c61fab88f8a2080$export$2e2bcd8739ae039 = Object.assign($9c61fab88f8a2080$var$Nav, {
    Item: (0, $fef4535ccedac40e$export$2e2bcd8739ae039)
});





var $kc00y = parcelRequire("kc00y");
"use client";
const $e568e6bef19b3ebd$var$context = /*#__PURE__*/ $kc00y.createContext(null);
$e568e6bef19b3ebd$var$context.displayName = 'CardHeaderContext';
var $e568e6bef19b3ebd$export$2e2bcd8739ae039 = $e568e6bef19b3ebd$var$context;



var $kc00y = parcelRequire("kc00y");



"use client";
const $436178a401adbb7f$var$NavItem = /*#__PURE__*/ $kc00y.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(bsPrefix, 'nav-item');
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, bsPrefix),
        ...props
    });
});
$436178a401adbb7f$var$NavItem.displayName = 'NavItem';
var $436178a401adbb7f$export$2e2bcd8739ae039 = $436178a401adbb7f$var$NavItem;




var $kc00y = parcelRequire("kc00y");





"use client";
const $37ba031b10fc30fb$var$NavLink = /*#__PURE__*/ $kc00y.forwardRef(({ bsPrefix: bsPrefix, className: className, as: Component = (0, $68efbe85ab599b20$export$2e2bcd8739ae039), active: active, eventKey: eventKey, disabled: disabled = false, ...props }, ref)=>{
    bsPrefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(bsPrefix, 'nav-link');
    const [navItemProps, meta] = (0, $fef4535ccedac40e$export$d7a68693710982a)({
        key: (0, $218ada47f6b11566$export$eef49b42fde998a3)(eventKey, props.href),
        active: active,
        disabled: disabled,
        ...props
    });
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)(Component, {
        ...props,
        ...navItemProps,
        ref: ref,
        disabled: disabled,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, bsPrefix, disabled && 'disabled', meta.isActive && 'active')
    });
});
$37ba031b10fc30fb$var$NavLink.displayName = 'NavLink';
var $37ba031b10fc30fb$export$2e2bcd8739ae039 = $37ba031b10fc30fb$var$NavLink;



"use client";
const $b9d4d12a3c294259$var$Nav = /*#__PURE__*/ $kc00y.forwardRef((uncontrolledProps, ref)=>{
    const { as: as = 'div', bsPrefix: initialBsPrefix, variant: variant, fill: fill = false, justify: justify = false, navbar: navbar, navbarScroll: navbarScroll, className: className, activeKey: activeKey, ...props } = (0, $b0582fd40c314767$export$2e2bcd8739ae039)(uncontrolledProps, {
        activeKey: 'onSelect'
    });
    const bsPrefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(initialBsPrefix, 'nav');
    let navbarBsPrefix;
    let cardHeaderBsPrefix;
    let isNavbar = false;
    const navbarContext = (0, $kc00y.useContext)((0, $2a05085c6ba59499$export$2e2bcd8739ae039));
    const cardHeaderContext = (0, $kc00y.useContext)((0, $e568e6bef19b3ebd$export$2e2bcd8739ae039));
    if (navbarContext) {
        navbarBsPrefix = navbarContext.bsPrefix;
        isNavbar = navbar == null ? true : navbar;
    } else if (cardHeaderContext) ({ cardHeaderBsPrefix: cardHeaderBsPrefix } = cardHeaderContext);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $9c61fab88f8a2080$export$2e2bcd8739ae039), {
        as: as,
        ref: ref,
        activeKey: activeKey,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, {
            [bsPrefix]: !isNavbar,
            [`${navbarBsPrefix}-nav`]: isNavbar,
            [`${navbarBsPrefix}-nav-scroll`]: isNavbar && navbarScroll,
            [`${cardHeaderBsPrefix}-${variant}`]: !!cardHeaderBsPrefix,
            [`${bsPrefix}-${variant}`]: !!variant,
            [`${bsPrefix}-fill`]: fill,
            [`${bsPrefix}-justified`]: justify
        }),
        ...props
    });
});
$b9d4d12a3c294259$var$Nav.displayName = 'Nav';
var $b9d4d12a3c294259$export$2e2bcd8739ae039 = Object.assign($b9d4d12a3c294259$var$Nav, {
    Item: (0, $436178a401adbb7f$export$2e2bcd8739ae039),
    Link: (0, $37ba031b10fc30fb$export$2e2bcd8739ae039)
});




var $kc00y = parcelRequire("kc00y");




var $kc00y = parcelRequire("kc00y");


"use client";
const $3fc539fdd3c2b070$var$NavbarBrand = /*#__PURE__*/ $kc00y.forwardRef(({ bsPrefix: bsPrefix, className: className, as: as, ...props }, ref)=>{
    bsPrefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(bsPrefix, 'navbar-brand');
    const Component = as || (props.href ? 'a' : 'span');
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, bsPrefix)
    });
});
$3fc539fdd3c2b070$var$NavbarBrand.displayName = 'NavbarBrand';
var $3fc539fdd3c2b070$export$2e2bcd8739ae039 = $3fc539fdd3c2b070$var$NavbarBrand;



var $kc00y = parcelRequire("kc00y");



var $kc00y = parcelRequire("kc00y");



/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */ function $813a26e23ea25782$var$createChainedFunction(...funcs) {
    return funcs.filter((f)=>f != null).reduce((acc, f)=>{
        if (typeof f !== 'function') throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
        if (acc === null) return f;
        return function chainedFunction(...args) {
            // @ts-expect-error ignore "this" error
            acc.apply(this, args);
            // @ts-expect-error ignore "this" error
            f.apply(this, args);
        };
    }, null);
}
var $813a26e23ea25782$export$2e2bcd8739ae039 = $813a26e23ea25782$var$createChainedFunction;





const $0a86e6f0571c7093$var$MARGINS = {
    height: [
        'marginTop',
        'marginBottom'
    ],
    width: [
        'marginLeft',
        'marginRight'
    ]
};
function $0a86e6f0571c7093$var$getDefaultDimensionValue(dimension, elem) {
    const offset = `offset${dimension[0].toUpperCase()}${dimension.slice(1)}`;
    const value = elem[offset];
    const margins = $0a86e6f0571c7093$var$MARGINS[dimension];
    return value + // @ts-expect-error TODO
    parseInt((0, $8f85a640dc294d7f$export$2e2bcd8739ae039)(elem, margins[0]), 10) + // @ts-expect-error TODO
    parseInt((0, $8f85a640dc294d7f$export$2e2bcd8739ae039)(elem, margins[1]), 10);
}
const $0a86e6f0571c7093$var$collapseStyles = {
    [(0, $92dadb5ebc6bf1cd$export$84cbff306f539230)]: 'collapse',
    [(0, $92dadb5ebc6bf1cd$export$4aacc83d4d59139f)]: 'collapsing',
    [(0, $92dadb5ebc6bf1cd$export$df38205c966be359)]: 'collapsing',
    [(0, $92dadb5ebc6bf1cd$export$78e9e6e3e014d60a)]: 'collapse show'
};
const $0a86e6f0571c7093$var$Collapse = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).forwardRef(({ onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, className: className, children: children, dimension: dimension = 'height', in: inProp = false, timeout: timeout = 300, mountOnEnter: mountOnEnter = false, unmountOnExit: unmountOnExit = false, appear: appear = false, getDimensionValue: getDimensionValue = $0a86e6f0571c7093$var$getDefaultDimensionValue, ...props }, ref)=>{
    /* Compute dimension */ const computedDimension = typeof dimension === 'function' ? dimension() : dimension;
    /* -- Expanding -- */ const handleEnter = (0, $kc00y.useMemo)(()=>(0, $813a26e23ea25782$export$2e2bcd8739ae039)((elem)=>{
            elem.style[computedDimension] = '0';
        }, onEnter), [
        computedDimension,
        onEnter
    ]);
    const handleEntering = (0, $kc00y.useMemo)(()=>(0, $813a26e23ea25782$export$2e2bcd8739ae039)((elem)=>{
            const scroll = `scroll${computedDimension[0].toUpperCase()}${computedDimension.slice(1)}`;
            elem.style[computedDimension] = `${elem[scroll]}px`;
        }, onEntering), [
        computedDimension,
        onEntering
    ]);
    const handleEntered = (0, $kc00y.useMemo)(()=>(0, $813a26e23ea25782$export$2e2bcd8739ae039)((elem)=>{
            elem.style[computedDimension] = null;
        }, onEntered), [
        computedDimension,
        onEntered
    ]);
    /* -- Collapsing -- */ const handleExit = (0, $kc00y.useMemo)(()=>(0, $813a26e23ea25782$export$2e2bcd8739ae039)((elem)=>{
            elem.style[computedDimension] = `${getDimensionValue(computedDimension, elem)}px`;
            (0, $15b2c193227448e6$export$2e2bcd8739ae039)(elem);
        }, onExit), [
        onExit,
        getDimensionValue,
        computedDimension
    ]);
    const handleExiting = (0, $kc00y.useMemo)(()=>(0, $813a26e23ea25782$export$2e2bcd8739ae039)((elem)=>{
            elem.style[computedDimension] = null;
        }, onExiting), [
        computedDimension,
        onExiting
    ]);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $401bdd4c2cc04a2e$export$2e2bcd8739ae039), {
        ref: ref,
        addEndListener: (0, $d81af195f4d05992$export$2e2bcd8739ae039),
        ...props,
        "aria-expanded": props.role ? inProp : null,
        onEnter: handleEnter,
        onEntering: handleEntering,
        onEntered: handleEntered,
        onExit: handleExit,
        onExiting: handleExiting,
        childRef: (0, $91d5586e687d56e1$export$87943f2672146d57)(children),
        in: inProp,
        timeout: timeout,
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit,
        appear: appear,
        children: (state, innerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).cloneElement(children, {
                ...innerProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, children.props.className, $0a86e6f0571c7093$var$collapseStyles[state], computedDimension === 'width' && 'collapse-horizontal')
            })
    });
});
$0a86e6f0571c7093$var$Collapse.displayName = 'Collapse';
var $0a86e6f0571c7093$export$2e2bcd8739ae039 = $0a86e6f0571c7093$var$Collapse;





"use client";
const $781192ed02a277a7$var$NavbarCollapse = /*#__PURE__*/ $kc00y.forwardRef(({ children: children, bsPrefix: bsPrefix, ...props }, ref)=>{
    bsPrefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(bsPrefix, 'navbar-collapse');
    const context = (0, $kc00y.useContext)((0, $2a05085c6ba59499$export$2e2bcd8739ae039));
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $0a86e6f0571c7093$export$2e2bcd8739ae039), {
        in: !!(context && context.expanded),
        ...props,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
            ref: ref,
            className: bsPrefix,
            children: children
        })
    });
});
$781192ed02a277a7$var$NavbarCollapse.displayName = 'NavbarCollapse';
var $781192ed02a277a7$export$2e2bcd8739ae039 = $781192ed02a277a7$var$NavbarCollapse;




var $kc00y = parcelRequire("kc00y");




"use client";
const $40619a2b69c40197$var$NavbarToggle = /*#__PURE__*/ $kc00y.forwardRef(({ bsPrefix: bsPrefix, className: className, children: children, label: label = 'Toggle navigation', // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'button', onClick: onClick, ...props }, ref)=>{
    bsPrefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(bsPrefix, 'navbar-toggler');
    const { onToggle: onToggle, expanded: expanded } = (0, $kc00y.useContext)((0, $2a05085c6ba59499$export$2e2bcd8739ae039)) || {};
    const handleClick = (0, $4655b62db0931f1e$export$2e2bcd8739ae039)((e)=>{
        if (onClick) onClick(e);
        if (onToggle) onToggle();
    });
    if (Component === 'button') props.type = 'button';
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)(Component, {
        ...props,
        ref: ref,
        onClick: handleClick,
        "aria-label": label,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, bsPrefix, !expanded && 'collapsed'),
        children: children || /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("span", {
            className: `${bsPrefix}-icon`
        })
    });
});
$40619a2b69c40197$var$NavbarToggle.displayName = 'NavbarToggle';
var $40619a2b69c40197$export$2e2bcd8739ae039 = $40619a2b69c40197$var$NavbarToggle;



var $kc00y = parcelRequire("kc00y");




var $kc00y = parcelRequire("kc00y");
const $1e87d300a4887e16$var$matchersByWindow = new WeakMap();
const $1e87d300a4887e16$var$getMatcher = (query, targetWindow)=>{
    if (!query || !targetWindow) return undefined;
    const matchers = $1e87d300a4887e16$var$matchersByWindow.get(targetWindow) || new Map();
    $1e87d300a4887e16$var$matchersByWindow.set(targetWindow, matchers);
    let mql = matchers.get(query);
    if (!mql) {
        mql = targetWindow.matchMedia(query);
        mql.refCount = 0;
        matchers.set(mql.media, mql);
    }
    return mql;
};
function $1e87d300a4887e16$export$2e2bcd8739ae039(query, targetWindow = typeof window === 'undefined' ? undefined : window) {
    const mql = $1e87d300a4887e16$var$getMatcher(query, targetWindow);
    const [matches, setMatches] = (0, $kc00y.useState)(()=>mql ? mql.matches : false);
    (0, $a72fb555b4b57bff$export$2e2bcd8739ae039)(()=>{
        let mql = $1e87d300a4887e16$var$getMatcher(query, targetWindow);
        if (!mql) return setMatches(false);
        let matchers = $1e87d300a4887e16$var$matchersByWindow.get(targetWindow);
        const handleChange = ()=>{
            setMatches(mql.matches);
        };
        mql.refCount++;
        mql.addListener(handleChange);
        handleChange();
        return ()=>{
            mql.removeListener(handleChange);
            mql.refCount--;
            if (mql.refCount <= 0) matchers == null || matchers.delete(mql.media);
            mql = undefined;
        };
    }, [
        query
    ]);
    return matches;
}



var $kc00y = parcelRequire("kc00y");
function $078b90bdabe1bd78$export$9c6950edc251641e(breakpointValues) {
    const names = Object.keys(breakpointValues);
    function and(query, next) {
        if (query === next) return next;
        return query ? `${query} and ${next}` : next;
    }
    function getNext(breakpoint) {
        return names[Math.min(names.indexOf(breakpoint) + 1, names.length - 1)];
    }
    function getMaxQuery(breakpoint) {
        const next = getNext(breakpoint);
        let value = breakpointValues[next];
        if (typeof value === 'number') value = `${value - 0.2}px`;
        else value = `calc(${value} - 0.2px)`;
        return `(max-width: ${value})`;
    }
    function getMinQuery(breakpoint) {
        let value = breakpointValues[breakpoint];
        if (typeof value === 'number') value = `${value}px`;
        return `(min-width: ${value})`;
    }
    /**
   * Match a set of breakpoints
   *
   * ```tsx
   * const MidSizeOnly = () => {
   *   const isMid = useBreakpoint({ lg: 'down', sm: 'up' });
   *
   *   if (isMid) return <div>On a Reasonable sized Screen!</div>
   *   return null;
   * }
   * ```
   * @param breakpointMap An object map of breakpoints and directions, queries are constructed using "and" to join
   * breakpoints together
   * @param window Optionally specify the target window to match against (useful when rendering into iframes)
   */ /**
   * Match a single breakpoint exactly, up, or down.
   *
   * ```tsx
   * const PhoneOnly = () => {
   *   const isSmall = useBreakpoint('sm', 'down');
   *
   *   if (isSmall) return <div>On a Small Screen!</div>
   *   return null;
   * }
   * ```
   *
   * @param breakpoint The breakpoint key
   * @param direction A direction 'up' for a max, 'down' for min, true to match only the breakpoint
   * @param window Optionally specify the target window to match against (useful when rendering into iframes)
   */ function useBreakpoint(breakpointOrMap, direction, window) {
        let breakpointMap;
        if (typeof breakpointOrMap === 'object') {
            breakpointMap = breakpointOrMap;
            window = direction;
            direction = true;
        } else {
            direction = direction || true;
            breakpointMap = {
                [breakpointOrMap]: direction
            };
        }
        let query = (0, $kc00y.useMemo)(()=>Object.entries(breakpointMap).reduce((query, [key, direction])=>{
                if (direction === 'up' || direction === true) query = and(query, getMinQuery(key));
                if (direction === 'down' || direction === true) query = and(query, getMaxQuery(key));
                return query;
            }, ''), [
            JSON.stringify(breakpointMap)
        ]);
        return (0, $1e87d300a4887e16$export$2e2bcd8739ae039)(query, window);
    }
    return useBreakpoint;
}
const $078b90bdabe1bd78$var$useBreakpoint = $078b90bdabe1bd78$export$9c6950edc251641e({
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1400
});
var $078b90bdabe1bd78$export$2e2bcd8739ae039 = $078b90bdabe1bd78$var$useBreakpoint;




var $kc00y = parcelRequire("kc00y");



var $kc00y = parcelRequire("kc00y");



"use client";
const $39ae6bc66e0a7488$var$OffcanvasBody = /*#__PURE__*/ $kc00y.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(bsPrefix, 'offcanvas-body');
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, bsPrefix),
        ...props
    });
});
$39ae6bc66e0a7488$var$OffcanvasBody.displayName = 'OffcanvasBody';
var $39ae6bc66e0a7488$export$2e2bcd8739ae039 = $39ae6bc66e0a7488$var$OffcanvasBody;




var $kc00y = parcelRequire("kc00y");






"use client";
const $6c3bdbee5d466e04$var$transitionStyles = {
    [(0, $92dadb5ebc6bf1cd$export$df38205c966be359)]: 'show',
    [(0, $92dadb5ebc6bf1cd$export$78e9e6e3e014d60a)]: 'show'
};
const $6c3bdbee5d466e04$var$OffcanvasToggling = /*#__PURE__*/ $kc00y.forwardRef(({ bsPrefix: bsPrefix, className: className, children: children, in: inProp = false, mountOnEnter: mountOnEnter = false, unmountOnExit: unmountOnExit = false, appear: appear = false, ...props }, ref)=>{
    bsPrefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(bsPrefix, 'offcanvas');
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $401bdd4c2cc04a2e$export$2e2bcd8739ae039), {
        ref: ref,
        addEndListener: (0, $d81af195f4d05992$export$2e2bcd8739ae039),
        in: inProp,
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit,
        appear: appear,
        ...props,
        childRef: (0, $91d5586e687d56e1$export$87943f2672146d57)(children),
        children: (status, innerProps)=>/*#__PURE__*/ $kc00y.cloneElement(children, {
                ...innerProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, children.props.className, (status === (0, $92dadb5ebc6bf1cd$export$df38205c966be359) || status === (0, $92dadb5ebc6bf1cd$export$4aacc83d4d59139f)) && `${bsPrefix}-toggling`, $6c3bdbee5d466e04$var$transitionStyles[status])
            })
    });
});
$6c3bdbee5d466e04$var$OffcanvasToggling.displayName = 'OffcanvasToggling';
var $6c3bdbee5d466e04$export$2e2bcd8739ae039 = $6c3bdbee5d466e04$var$OffcanvasToggling;





var $kc00y = parcelRequire("kc00y");



"use client";
const $e3ba43b10f9f2449$var$OffcanvasHeader = /*#__PURE__*/ $kc00y.forwardRef(({ bsPrefix: bsPrefix, className: className, closeLabel: closeLabel = 'Close', closeButton: closeButton = false, ...props }, ref)=>{
    bsPrefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(bsPrefix, 'offcanvas-header');
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $63ee3d51f3ee506e$export$2e2bcd8739ae039), {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, bsPrefix),
        closeLabel: closeLabel,
        closeButton: closeButton
    });
});
$e3ba43b10f9f2449$var$OffcanvasHeader.displayName = 'OffcanvasHeader';
var $e3ba43b10f9f2449$export$2e2bcd8739ae039 = $e3ba43b10f9f2449$var$OffcanvasHeader;



var $kc00y = parcelRequire("kc00y");




"use client";
const $98745385afdc82ea$var$DivStyledAsH5 = (0, $b5bbb0b2ce1c31b6$export$2e2bcd8739ae039)('h5');
const $98745385afdc82ea$var$OffcanvasTitle = /*#__PURE__*/ $kc00y.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = $98745385afdc82ea$var$DivStyledAsH5, ...props }, ref)=>{
    bsPrefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(bsPrefix, 'offcanvas-title');
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, bsPrefix),
        ...props
    });
});
$98745385afdc82ea$var$OffcanvasTitle.displayName = 'OffcanvasTitle';
var $98745385afdc82ea$export$2e2bcd8739ae039 = $98745385afdc82ea$var$OffcanvasTitle;





"use client";
function $43efda4f21201843$var$DialogTransition(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $6c3bdbee5d466e04$export$2e2bcd8739ae039), {
        ...props
    });
}
function $43efda4f21201843$var$BackdropTransition(props) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $25d8c693c355530c$export$2e2bcd8739ae039), {
        ...props
    });
}
const $43efda4f21201843$var$Offcanvas = /*#__PURE__*/ $kc00y.forwardRef(({ bsPrefix: bsPrefix, className: className, children: children, 'aria-labelledby': ariaLabelledby, placement: placement = 'start', responsive: responsive, show: /* BaseModal props */ show = false, backdrop: backdrop = true, keyboard: keyboard = true, scroll: scroll = false, onEscapeKeyDown: onEscapeKeyDown, onShow: onShow, onHide: onHide, container: container, autoFocus: autoFocus = true, enforceFocus: enforceFocus = true, restoreFocus: restoreFocus = true, restoreFocusOptions: restoreFocusOptions, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onExited: onExited, backdropClassName: backdropClassName, manager: propsManager, renderStaticNode: renderStaticNode = false, ...props }, ref)=>{
    const modalManager = (0, $kc00y.useRef)();
    bsPrefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(bsPrefix, 'offcanvas');
    const [showOffcanvas, setShowOffcanvas] = (0, $kc00y.useState)(false);
    const handleHide = (0, $4655b62db0931f1e$export$2e2bcd8739ae039)(onHide);
    const hideResponsiveOffcanvas = (0, $078b90bdabe1bd78$export$2e2bcd8739ae039)(responsive || 'xs', 'up');
    (0, $kc00y.useEffect)(()=>{
        // Handles the case where screen is resized while the responsive
        // offcanvas is shown. If `responsive` not provided, just use `show`.
        setShowOffcanvas(responsive ? show && !hideResponsiveOffcanvas : show);
    }, [
        show,
        responsive,
        hideResponsiveOffcanvas
    ]);
    const modalContext = (0, $kc00y.useMemo)(()=>({
            onHide: handleHide
        }), [
        handleHide
    ]);
    function getModalManager() {
        if (propsManager) return propsManager;
        if (scroll) {
            // Have to use a different modal manager since the shared
            // one handles overflow.
            if (!modalManager.current) modalManager.current = new (0, $51c7d6344e391079$export$2e2bcd8739ae039)({
                handleContainerOverflow: false
            });
            return modalManager.current;
        }
        return (0, $51c7d6344e391079$export$a03641438014b436)();
    }
    const handleEnter = (node, ...args)=>{
        if (node) node.style.visibility = 'visible';
        onEnter == null || onEnter(node, ...args);
    };
    const handleExited = (node, ...args)=>{
        if (node) node.style.visibility = '';
        onExited == null || onExited(...args);
    };
    const renderBackdrop = (0, $kc00y.useCallback)((backdropProps)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
            ...backdropProps,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(`${bsPrefix}-backdrop`, backdropClassName)
        }), [
        backdropClassName,
        bsPrefix
    ]);
    const renderDialog = (dialogProps)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
            ...dialogProps,
            ...props,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, responsive ? `${bsPrefix}-${responsive}` : bsPrefix, `${bsPrefix}-${placement}`),
            "aria-labelledby": ariaLabelledby,
            children: children
        });
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            !showOffcanvas && (responsive || renderStaticNode) && renderDialog({}),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $515e095cb5609dfa$export$2e2bcd8739ae039).Provider, {
                value: modalContext,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $38ebb733d4e3053f$export$2e2bcd8739ae039), {
                    show: showOffcanvas,
                    ref: ref,
                    backdrop: backdrop,
                    container: container,
                    keyboard: keyboard,
                    autoFocus: autoFocus,
                    enforceFocus: enforceFocus && !scroll,
                    restoreFocus: restoreFocus,
                    restoreFocusOptions: restoreFocusOptions,
                    onEscapeKeyDown: onEscapeKeyDown,
                    onShow: onShow,
                    onHide: handleHide,
                    onEnter: handleEnter,
                    onEntering: onEntering,
                    onEntered: onEntered,
                    onExit: onExit,
                    onExiting: onExiting,
                    onExited: handleExited,
                    manager: getModalManager(),
                    transition: $43efda4f21201843$var$DialogTransition,
                    backdropTransition: $43efda4f21201843$var$BackdropTransition,
                    renderBackdrop: renderBackdrop,
                    renderDialog: renderDialog
                })
            })
        ]
    });
});
$43efda4f21201843$var$Offcanvas.displayName = 'Offcanvas';
var $43efda4f21201843$export$2e2bcd8739ae039 = Object.assign($43efda4f21201843$var$Offcanvas, {
    Body: (0, $39ae6bc66e0a7488$export$2e2bcd8739ae039),
    Header: (0, $e3ba43b10f9f2449$export$2e2bcd8739ae039),
    Title: (0, $98745385afdc82ea$export$2e2bcd8739ae039)
});




"use client";
const $894fdc980916dfb3$var$NavbarOffcanvas = /*#__PURE__*/ $kc00y.forwardRef(({ onHide: onHide, ...props }, ref)=>{
    const context = (0, $kc00y.useContext)((0, $2a05085c6ba59499$export$2e2bcd8739ae039));
    const handleHide = (0, $4655b62db0931f1e$export$2e2bcd8739ae039)(()=>{
        context == null || context.onToggle == null || context.onToggle();
        onHide == null || onHide();
    });
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $43efda4f21201843$export$2e2bcd8739ae039), {
        ref: ref,
        show: !!(context != null && context.expanded),
        ...props,
        renderStaticNode: true,
        onHide: handleHide
    });
});
$894fdc980916dfb3$var$NavbarOffcanvas.displayName = 'NavbarOffcanvas';
var $894fdc980916dfb3$export$2e2bcd8739ae039 = $894fdc980916dfb3$var$NavbarOffcanvas;





var $kc00y = parcelRequire("kc00y");



"use client";
const $8b4c6a67b1f7446a$var$NavbarText = /*#__PURE__*/ $kc00y.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'span', ...props }, ref)=>{
    bsPrefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(bsPrefix, 'navbar-text');
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, bsPrefix),
        ...props
    });
});
$8b4c6a67b1f7446a$var$NavbarText.displayName = 'NavbarText';
var $8b4c6a67b1f7446a$export$2e2bcd8739ae039 = $8b4c6a67b1f7446a$var$NavbarText;



"use client";
const $019826a46adda10a$var$Navbar = /*#__PURE__*/ $kc00y.forwardRef((props, ref)=>{
    const { bsPrefix: initialBsPrefix, expand: expand = true, variant: variant = 'light', bg: bg, fixed: fixed, sticky: sticky, className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'nav', expanded: expanded, onToggle: onToggle, onSelect: onSelect, collapseOnSelect: collapseOnSelect = false, ...controlledProps } = (0, $b0582fd40c314767$export$2e2bcd8739ae039)(props, {
        expanded: 'onToggle'
    });
    const bsPrefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(initialBsPrefix, 'navbar');
    const handleCollapse = (0, $kc00y.useCallback)((...args)=>{
        onSelect == null || onSelect(...args);
        if (collapseOnSelect && expanded) onToggle == null || onToggle(false);
    }, [
        onSelect,
        collapseOnSelect,
        expanded,
        onToggle
    ]);
    // will result in some false positives but that seems better
    // than false negatives. strict `undefined` check allows explicit
    // "nulling" of the role if the user really doesn't want one
    if (controlledProps.role === undefined && Component !== 'nav') controlledProps.role = 'navigation';
    let expandClass = `${bsPrefix}-expand`;
    if (typeof expand === 'string') expandClass = `${expandClass}-${expand}`;
    const navbarContext = (0, $kc00y.useMemo)(()=>({
            onToggle: ()=>onToggle == null ? void 0 : onToggle(!expanded),
            bsPrefix: bsPrefix,
            expanded: !!expanded,
            expand: expand
        }), [
        bsPrefix,
        expanded,
        expand,
        onToggle
    ]);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2a05085c6ba59499$export$2e2bcd8739ae039).Provider, {
        value: navbarContext,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $218ada47f6b11566$export$2e2bcd8739ae039).Provider, {
            value: handleCollapse,
            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)(Component, {
                ref: ref,
                ...controlledProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, bsPrefix, expand && expandClass, variant && `${bsPrefix}-${variant}`, bg && `bg-${bg}`, sticky && `sticky-${sticky}`, fixed && `fixed-${fixed}`)
            })
        })
    });
});
$019826a46adda10a$var$Navbar.displayName = 'Navbar';
var $019826a46adda10a$export$2e2bcd8739ae039 = Object.assign($019826a46adda10a$var$Navbar, {
    Brand: (0, $3fc539fdd3c2b070$export$2e2bcd8739ae039),
    Collapse: (0, $781192ed02a277a7$export$2e2bcd8739ae039),
    Offcanvas: (0, $894fdc980916dfb3$export$2e2bcd8739ae039),
    Text: (0, $8b4c6a67b1f7446a$export$2e2bcd8739ae039),
    Toggle: (0, $40619a2b69c40197$export$2e2bcd8739ae039)
});









const $5de16d9a2066fdee$var$NavTo = ({ path: path, label: label, aLeDroit: aLeDroit })=>{
    return aLeDroit && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b9d4d12a3c294259$export$2e2bcd8739ae039).Item, {
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $d4b7ea36fcb7fe56$export$2e2bcd8739ae039), {
            pathname: path,
            classname: "nav-link",
            children: label
        })
    });
};
const $5de16d9a2066fdee$var$Header = ({ links: links })=>{
    const { user: user } = (0, $e787cde576104469$export$fdc397e486fa83e7)();
    const listeParametre = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/parametres?${{
        listeParametreCode: JSON.stringify([
            (0, $ee297f06e8568bf4$export$2e2bcd8739ae039).MESSAGE_ENTETE
        ])
    }}`);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $019826a46adda10a$export$2e2bcd8739ae039), {
            className: "mb-3",
            expand: "lg",
            bg: "primary",
            "data-bs-theme": "dark",
            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $019826a46adda10a$export$2e2bcd8739ae039).Brand, {
                        href: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).ACCUEIL,
                        children: "REMOcRA"
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $019826a46adda10a$export$2e2bcd8739ae039).Toggle, {
                        "aria-controls": "basic-navbar-nav"
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $019826a46adda10a$export$2e2bcd8739ae039).Collapse, {
                        id: "basic-navbar-nav",
                        children: [
                            !links && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("p", {
                                className: "h3 text-light mx-auto text-center align-self-end",
                                children: listeParametre.data?.[(0, $ee297f06e8568bf4$export$2e2bcd8739ae039).MESSAGE_ENTETE].parametreValeur
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b9d4d12a3c294259$export$2e2bcd8739ae039), {
                                className: "me-auto",
                                children: links?.map((item, index)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($5de16d9a2066fdee$var$NavTo, {
                                        path: item.path,
                                        label: item.label,
                                        aLeDroit: item.aLeDroit
                                    }, index))
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b9d4d12a3c294259$export$2e2bcd8739ae039), {
                                children: user != null ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("p", {
                                            className: "d-flex m-0 align-items-center text-light pe-3",
                                            children: (()=>{
                                                const hasName = user.prenom || user.nom;
                                                const namePart = [
                                                    user.prenom,
                                                    user.nom
                                                ].filter(Boolean).join(" ");
                                                if (user.username) {
                                                    if (hasName) return `${namePart} (${user.username})`;
                                                    else return user.username;
                                                }
                                                return namePart;
                                            })()
                                        }),
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("form", {
                                            method: "post",
                                            action: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LOGOUT,
                                            onSubmit: ()=>{
                                                localStorage.clear();
                                            },
                                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                                                type: "submit",
                                                className: "btn-light",
                                                children: "D\xe9connexion"
                                            })
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("form", {
                                        method: "post",
                                        action: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LOGIN,
                                        onSubmit: ()=>{
                                            localStorage.clear();
                                        },
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                                            type: "submit",
                                            className: "btn-light",
                                            children: "Connexion"
                                        })
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var $5de16d9a2066fdee$export$2e2bcd8739ae039 = $5de16d9a2066fdee$var$Header;




var $kc00y = parcelRequire("kc00y");





var $kc00y = parcelRequire("kc00y");


"use client";
const $98f55aa78fbaf278$var$Badge = /*#__PURE__*/ $kc00y.forwardRef(({ bsPrefix: bsPrefix, bg: bg = 'primary', pill: pill = false, text: text, className: className, as: Component = 'span', ...props }, ref)=>{
    const prefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(bsPrefix, 'badge');
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, prefix, pill && `rounded-pill`, text && `text-${text}`, bg && `bg-${bg}`)
    });
});
$98f55aa78fbaf278$var$Badge.displayName = 'Badge';
var $98f55aa78fbaf278$export$2e2bcd8739ae039 = $98f55aa78fbaf278$var$Badge;




var $aed817c9e7c95158$exports = {};
$aed817c9e7c95158$exports = $parcel$resolve("aF9ma");


var $29783b588184fcbe$exports = {};
$29783b588184fcbe$exports = $parcel$resolve("aZ5qj");


var $37607d5231e889f4$exports = {};
$37607d5231e889f4$exports = $parcel$resolve("ljb8U");


var $487be133f29b9ee2$exports = {};
$487be133f29b9ee2$exports = $parcel$resolve("lH6OC");




const $f3d7bf020b0864fd$var$Footer = ({ mentionCnil: mentionCnil })=>{
    const version = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/app-settings/version`);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
        className: "bg-primary h-100",
        id: "footer",
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                className: "h-100 text-light",
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ad18c81fdcf37de8$export$2e2bcd8739ae039), {
                        className: "h-100 p-1",
                        fluid: true,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($37607d5231e889f4$exports)))
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ad18c81fdcf37de8$export$2e2bcd8739ae039), {
                        className: "h-100 p-1",
                        fluid: true,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($487be133f29b9ee2$exports)))
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ad18c81fdcf37de8$export$2e2bcd8739ae039), {
                        className: "h-100 p-1",
                        fluid: true,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($29783b588184fcbe$exports)))
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ad18c81fdcf37de8$export$2e2bcd8739ae039), {
                        className: "h-100 p-1",
                        fluid: true,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($aed817c9e7c95158$exports)))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                xs: "auto",
                className: "ms-auto me-2 text-light",
                children: version.value && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $98f55aa78fbaf278$export$2e2bcd8739ae039), {
                    pill: true,
                    bg: "info",
                    children: version.value.version
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                xs: "auto",
                className: "text-light",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("p", {
                    className: "copyright mb-2 text-end",
                    children: [
                        mentionCnil && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                            children: [
                                mentionCnil,
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {})
                            ]
                        }),
                        "Uicons by",
                        " ",
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("a", {
                            className: "text-light",
                            href: "https://www.flaticon.com/uicons",
                            children: "Flaticon"
                        }),
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                        "Copyright \xa9 2015 SDIS 83"
                    ]
                })
            })
        ]
    });
};
var $f3d7bf020b0864fd$export$2e2bcd8739ae039 = $f3d7bf020b0864fd$var$Footer;




var $kc00y = parcelRequire("kc00y");



const $bd92516d15b21a96$var$GoTopButton = ()=>{
    const [showButton, setShowButton] = (0, $kc00y.useState)(false);
    (0, $kc00y.useEffect)(()=>{
        const handleScroll = ()=>{
            setShowButton(window.scrollY > 600);
        };
        window.addEventListener("scroll", handleScroll);
        return ()=>{
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    const scrollToTop = ()=>{
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };
    return showButton && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
            xs: "auto",
            className: "go-top-wrapper bounce-on-hover",
            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                onClick: scrollToTop,
                size: "lg",
                variant: "transparent",
                className: "opacity-75",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$3577c0003511ce2d), {})
            })
        })
    });
};
var $bd92516d15b21a96$export$2e2bcd8739ae039 = $bd92516d15b21a96$var$GoTopButton;




var $kc00y = parcelRequire("kc00y");



var $8023beb6b41cc273$var$TYPE_ENVIRONNEMENT = /*#__PURE__*/ function(TYPE_ENVIRONNEMENT) {
    /** Environnement de développement - infrastructure Atol uniquement */ TYPE_ENVIRONNEMENT[TYPE_ENVIRONNEMENT["DEVELOPPEMENT"] = 0] = "DEVELOPPEMENT";
    /** Environnement de formation - infrastructure Atol uniquement */ TYPE_ENVIRONNEMENT[TYPE_ENVIRONNEMENT["FORMATION"] = 1] = "FORMATION";
    /** Environnement de recette - tester la dernière version et co-construction de modules avec Atol  */ TYPE_ENVIRONNEMENT[TYPE_ENVIRONNEMENT["RECETTE"] = 2] = "RECETTE";
    /** Environnement de pré-production - qualifier le bon fonctionnement de la mise en production et certains traitements sensibles */ TYPE_ENVIRONNEMENT[TYPE_ENVIRONNEMENT["PREPRODUCTION"] = 3] = "PREPRODUCTION";
    /** Environnement de production - aucun bridage particulier */ TYPE_ENVIRONNEMENT[TYPE_ENVIRONNEMENT["PRODUCTION"] = 4] = "PRODUCTION";
    return TYPE_ENVIRONNEMENT;
}($8023beb6b41cc273$var$TYPE_ENVIRONNEMENT || {});
var $8023beb6b41cc273$export$2e2bcd8739ae039 = $8023beb6b41cc273$var$TYPE_ENVIRONNEMENT;




// Affiche les images seulement si elles existent
const $b53a5553b443ce1e$var$ImageIfExists = ({ imageSrc: imageSrc, alt: alt })=>{
    const [exists, setExists] = (0, $kc00y.useState)(null);
    (0, $kc00y.useEffect)(()=>{
        const img = new window.Image();
        img.onload = ()=>setExists(true);
        img.onerror = ()=>setExists(false);
        img.src = imageSrc;
    }, [
        imageSrc
    ]);
    if (!exists) return null;
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ad18c81fdcf37de8$export$2e2bcd8739ae039), {
        fluid: true,
        alt: alt,
        src: imageSrc
    });
};
const $b53a5553b443ce1e$var$BanniereHeader = ({ messageEntete: messageEntete })=>{
    const typeEnvironment = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/app-settings/environment`);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
        className: "bg-primary h-100 p-0",
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                xs: 1,
                className: "d-flex justify-content-center align-items-center",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($b53a5553b443ce1e$var$ImageIfExists, {
                    imageSrc: "images/logo",
                    alt: "Logo"
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                className: "position-relative text-center",
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("p", {
                        className: "h3 text-light col-12 position-absolute bottom-0 start-50 translate-middle-x",
                        children: messageEntete
                    }),
                    typeEnvironment && (0, $8023beb6b41cc273$export$2e2bcd8739ae039)[typeEnvironment.value] !== (0, $8023beb6b41cc273$export$2e2bcd8739ae039).PRODUCTION && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("p", {
                        className: "fs-4 m-2 position-absolute top-0 end-0",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $98f55aa78fbaf278$export$2e2bcd8739ae039), {
                            pill: true,
                            bg: $b53a5553b443ce1e$var$getBadgeEnvironment(typeEnvironment.value)?.bg,
                            children: $b53a5553b443ce1e$var$getBadgeEnvironment(typeEnvironment.value)?.libelle
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($b53a5553b443ce1e$var$ImageIfExists, {
                        imageSrc: "/images/banniere",
                        alt: "Bandeau d'En-t\xeate"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                xs: 1,
                className: "mt-3 text-center"
            })
        ]
    });
};
function $b53a5553b443ce1e$var$getBadgeEnvironment(typeEnvironement) {
    switch((0, $8023beb6b41cc273$export$2e2bcd8739ae039)[typeEnvironement]){
        case (0, $8023beb6b41cc273$export$2e2bcd8739ae039).DEVELOPPEMENT:
            return {
                bg: "success",
                libelle: "D\xe9veloppement"
            };
        case (0, $8023beb6b41cc273$export$2e2bcd8739ae039).RECETTE:
            return {
                bg: "success",
                libelle: "Recette"
            };
        case (0, $8023beb6b41cc273$export$2e2bcd8739ae039).PREPRODUCTION:
            return {
                bg: "warning",
                libelle: "Pr\xe9prod"
            };
        case (0, $8023beb6b41cc273$export$2e2bcd8739ae039).FORMATION:
            return {
                bg: "info",
                libelle: "Formation"
            };
    }
}
var $b53a5553b443ce1e$export$2e2bcd8739ae039 = $b53a5553b443ce1e$var$BanniereHeader;




const $a0064658a8399ad3$var$SquelettePage = ({ children: children, navbar: navbar, fluid: fluid = true, banner: banner = false })=>{
    const listeParametre = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/parametres?${{
        listeParametreCode: JSON.stringify([
            (0, $ee297f06e8568bf4$export$2e2bcd8739ae039).MENTION_CNIL,
            (0, $ee297f06e8568bf4$export$2e2bcd8739ae039).MESSAGE_ENTETE,
            (0, $ee297f06e8568bf4$export$2e2bcd8739ae039).TITRE_PAGE
        ])
    }}`);
    const mentionCnil = listeParametre.data?.[(0, $ee297f06e8568bf4$export$2e2bcd8739ae039).MENTION_CNIL].parametreValeur;
    const titrePage = listeParametre.data?.[(0, $ee297f06e8568bf4$export$2e2bcd8739ae039).TITRE_PAGE].parametreValeur;
    (0, $kc00y.useEffect)(()=>{
        if (titrePage) document.title = titrePage;
    }, [
        titrePage
    ]);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
        id: "page",
        children: [
            banner && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
                fluid: true,
                id: "banner",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b53a5553b443ce1e$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
                fluid: true,
                id: "navbar",
                children: navbar
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
                fluid: fluid,
                id: "main",
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                        className: "d-flex flex-column h-100 pb-2",
                        children: children
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $bd92516d15b21a96$export$2e2bcd8739ae039), {})
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
                fluid: true,
                id: "footer",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $f3d7bf020b0864fd$export$2e2bcd8739ae039), {
                    mentionCnil: mentionCnil
                })
            })
        ]
    });
};
var $a0064658a8399ad3$export$2e2bcd8739ae039 = $a0064658a8399ad3$var$SquelettePage;



const $e3b8d60f4bb99483$export$552522b64eb5db81 = ({ Component: Component, droits: droits, isPublic: isPublic = false }, props)=>{
    const { user: user } = (0, $e787cde576104469$export$fdc397e486fa83e7)();
    const location = (0, $7a844823b04d4282$export$45d76561a5302f2b)();
    if (!user && !isPublic) return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $7a844823b04d4282$export$444b3ab0cb9aec40), {
        to: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).ACCUEIL,
        state: location.state,
        replace: true
    });
    if (isPublic || user && $e3b8d60f4bb99483$export$4f612ab7b7b1d133(user, droits ?? [])) return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)(Component, {
        ...props
    });
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $a0064658a8399ad3$export$2e2bcd8739ae039), {
            navbar: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $5de16d9a2066fdee$export$2e2bcd8739ae039), {}),
            fluid: true,
            banner: true,
            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($e3b8d60f4bb99483$export$19e402bf0a6cad34, {})
        })
    });
};
function $e3b8d60f4bb99483$export$4f612ab7b7b1d133(user, droits) {
    return user ? droits.some((droit)=>$e3b8d60f4bb99483$export$6a5b32721de9ef11(user, droit)) : false;
}
function $e3b8d60f4bb99483$export$6a5b32721de9ef11(user, droit) {
    return user ? user.droits.includes(droit) : false;
}
const $e3b8d60f4bb99483$export$19e402bf0a6cad34 = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
        children: "Vous n'avez pas le droit d'acc\xe9der \xe0 cette page"
    });
};


/**
 * Enumération définissant les colonnes affichables pour le tableau des PEI
 */ var $7232829592627b50$var$COLUMN_INDISPONIBILITE_TEMPORAIRE = /*#__PURE__*/ function(COLUMN_INDISPONIBILITE_TEMPORAIRE) {
    COLUMN_INDISPONIBILITE_TEMPORAIRE["MOTIF"] = "MOTIF";
    COLUMN_INDISPONIBILITE_TEMPORAIRE["DATE_DEBUT"] = "DATE_DEBUT";
    COLUMN_INDISPONIBILITE_TEMPORAIRE["DATE_FIN"] = "DATE_FIN";
    COLUMN_INDISPONIBILITE_TEMPORAIRE["STATUT"] = "STATUT";
    COLUMN_INDISPONIBILITE_TEMPORAIRE["AUTO_DISPONIBLE"] = "AUTO_DISPONIBLE";
    COLUMN_INDISPONIBILITE_TEMPORAIRE["AUTO_INDISPONIBLE"] = "AUTO_INDISPONIBLE";
    COLUMN_INDISPONIBILITE_TEMPORAIRE["MAIL_AVANT"] = "MAIL_AVANT";
    COLUMN_INDISPONIBILITE_TEMPORAIRE["MAIL_APRES"] = "MAIL_APRES";
    COLUMN_INDISPONIBILITE_TEMPORAIRE["LIST_PEI"] = "LIST_PEI";
    COLUMN_INDISPONIBILITE_TEMPORAIRE["DESCRIPTION"] = "DESCRIPTION";
    COLUMN_INDISPONIBILITE_TEMPORAIRE["COMMUNE"] = "COMMUNE";
    return COLUMN_INDISPONIBILITE_TEMPORAIRE;
}($7232829592627b50$var$COLUMN_INDISPONIBILITE_TEMPORAIRE || {});
var $7232829592627b50$export$2e2bcd8739ae039 = $7232829592627b50$var$COLUMN_INDISPONIBILITE_TEMPORAIRE;


/**
 * Enumération définissant les colonnes affichables pour le tableau des PEI
 */ var $c22d20d038ee5de2$var$COLUMN_PEI = /*#__PURE__*/ function(COLUMN_PEI) {
    COLUMN_PEI["NUMERO_COMPLET"] = "NUMERO_COMPLET";
    COLUMN_PEI["NUMERO_INTERNE"] = "NUMERO_INTERNE";
    COLUMN_PEI["TYPE_PEI"] = "TYPE_PEI";
    COLUMN_PEI["DISPONIBILITE_TERRESTRE"] = "DISPONIBILITE_TERRESTRE";
    COLUMN_PEI["DISPONIBILITE_HBE"] = "DISPONIBILITE_HBE";
    COLUMN_PEI["NATURE"] = "NATURE";
    COLUMN_PEI["COMMUNE"] = "COMMUNE";
    COLUMN_PEI["NATURE_DECI"] = "NATURE_DECI";
    COLUMN_PEI["AUTORITE_DECI"] = "AUTORITE_DECI";
    COLUMN_PEI["SERVICE_PUBLIC_DECI"] = "SERVICE_PUBLIC_DECI";
    COLUMN_PEI["ANOMALIES"] = "ANOMALIES";
    COLUMN_PEI["PEI_NEXT_ROP"] = "PEI_NEXT_ROP";
    COLUMN_PEI["PEI_NEXT_CTP"] = "PEI_NEXT_CTP";
    COLUMN_PEI["TOURNEE_LIBELLE"] = "TOURNEE_LIBELLE";
    COLUMN_PEI["PEI_ADRESSE"] = "ADRESSE";
    COLUMN_PEI["GESTIONNAIRE"] = "GESTIONNAIRE";
    COLUMN_PEI["DIAMETRE_NOMINAL"] = "DIAMETRE_NOMINAL";
    return COLUMN_PEI;
}($c22d20d038ee5de2$var$COLUMN_PEI || {});
var $c22d20d038ee5de2$export$2e2bcd8739ae039 = $c22d20d038ee5de2$var$COLUMN_PEI;
const $c22d20d038ee5de2$export$afdedc74bb5d98bb = [
    {
        id: "NUMERO_COMPLET",
        libelle: "Num\xe9ro complet"
    },
    {
        id: "NUMERO_INTERNE",
        libelle: "Num\xe9ro interne"
    },
    {
        id: "TYPE_PEI",
        libelle: "Type PEI (PIBI, PENA)"
    },
    {
        id: "DISPONIBILITE_TERRESTRE",
        libelle: "Disponibilit\xe9 terrestre"
    },
    {
        id: "DISPONIBILITE_HBE",
        libelle: "Disponibilit\xe9 HBE"
    },
    {
        id: "NATURE",
        libelle: "Nature"
    },
    {
        id: "COMMUNE",
        libelle: "Commune"
    },
    {
        id: "NATURE_DECI",
        libelle: "Nature DECI"
    },
    {
        id: "AUTORITE_DECI",
        libelle: "Autorit\xe9 DECI"
    },
    {
        id: "SERVICE_PUBLIC_DECI",
        libelle: "Service public DECI"
    },
    {
        id: "ANOMALIES",
        libelle: "Anomalies"
    },
    {
        id: "PEI_NEXT_ROP",
        libelle: "Date de la prochaine ROP"
    },
    {
        id: "PEI_NEXT_CTP",
        libelle: "Date du prochain CTP"
    },
    {
        id: "TOURNEE_LIBELLE",
        libelle: "Libell\xe9 de la tourn\xe9e"
    },
    {
        id: "ADRESSE",
        libelle: "Adresse"
    },
    {
        id: "GESTIONNAIRE",
        libelle: "Gestionnaire"
    },
    {
        id: "DIAMETRE_NOMINAL",
        libelle: "Diam\xe8tre nominal"
    }
];



var $7680c94ec9779ccd$var$TYPE_DROIT = /*#__PURE__*/ function(TYPE_DROIT) {
    TYPE_DROIT["ADMIN_ANOMALIES"] = "ADMIN_ANOMALIES";
    TYPE_DROIT["ADMIN_API"] = "ADMIN_API";
    TYPE_DROIT["ADMIN_COUCHE_CARTOGRAPHIQUE"] = "ADMIN_COUCHE_CARTOGRAPHIQUE";
    TYPE_DROIT["ADMIN_COURRIER"] = "ADMIN_COURRIER";
    TYPE_DROIT["ADMIN_DROITS"] = "ADMIN_DROITS";
    TYPE_DROIT["ADMIN_NOMENCLATURE"] = "ADMIN_NOMENCLATURE";
    TYPE_DROIT["ADMIN_ORGANISME_A"] = "ADMIN_ORGANISME_A";
    TYPE_DROIT["ADMIN_ORGANISME_R"] = "ADMIN_ORGANISME_R";
    TYPE_DROIT["ADMIN_PARAM_APPLI"] = "ADMIN_PARAM_APPLI";
    TYPE_DROIT["ADMIN_PARAM_APPLI_MOBILE"] = "ADMIN_PARAM_APPLI_MOBILE";
    TYPE_DROIT["ADMIN_PARAM_TRAITEMENTS"] = "ADMIN_PARAM_TRAITEMENTS";
    TYPE_DROIT["ADMIN_RAPPORTS_PERSO"] = "ADMIN_RAPPORTS_PERSO";
    TYPE_DROIT["ADMIN_ROP_A"] = "ADMIN_ROP_A";
    TYPE_DROIT["ADMIN_ROLE_CONTACT"] = "ADMIN_ROLE_CONTACT";
    TYPE_DROIT["ADMIN_TYPE_ETUDE"] = "ADMIN_TYPE_ETUDE";
    TYPE_DROIT["ADMIN_UTILISATEURS_A"] = "ADMIN_UTILISATEURS_A";
    TYPE_DROIT["ADMIN_UTILISATEURS_ORGA_A"] = "ADMIN_UTILISATEURS_ORGA_A";
    TYPE_DROIT["ORGANISME_CONTACT_A"] = "ORGANISME_CONTACT_A";
    TYPE_DROIT["ADMIN_UTILISATEURS_ORGA_R"] = "ADMIN_UTILISATEURS_ORGA_R";
    TYPE_DROIT["ADMIN_UTILISATEURS_R"] = "ADMIN_UTILISATEURS_R";
    TYPE_DROIT["ADMIN_ZONE_COMPETENCE"] = "ADMIN_ZONE_COMPETENCE";
    TYPE_DROIT["ATLAS_A"] = "ATLAS_A";
    TYPE_DROIT["ATLAS_C"] = "ATLAS_C";
    TYPE_DROIT["ATLAS_D"] = "ATLAS_D";
    TYPE_DROIT["SIGNALEMENTS_C"] = "SIGNALEMENTS_C";
    TYPE_DROIT["CARTOGRAPHIES_E"] = "CARTOGRAPHIES_E";
    TYPE_DROIT["CARTO_METADATA_A"] = "CARTO_METADATA_A";
    TYPE_DROIT["COURRIER_ADMIN_R"] = "COURRIER_ADMIN_R";
    TYPE_DROIT["COURRIER_C"] = "COURRIER_C";
    TYPE_DROIT["COURRIER_ORGANISME_R"] = "COURRIER_ORGANISME_R";
    TYPE_DROIT["COURRIER_UTILISATEUR_R"] = "COURRIER_UTILISATEUR_R";
    TYPE_DROIT["CRISE_C"] = "CRISE_C";
    TYPE_DROIT["CRISE_D"] = "CRISE_D";
    TYPE_DROIT["CRISE_R"] = "CRISE_R";
    TYPE_DROIT["CRISE_U"] = "CRISE_U";
    TYPE_DROIT["DASHBOARD_A"] = "DASHBOARD_A";
    TYPE_DROIT["DASHBOARD_R"] = "DASHBOARD_R";
    TYPE_DROIT["DEBITS_SIMULTANES_A"] = "DEBITS_SIMULTANES_A";
    TYPE_DROIT["DEBITS_SIMULTANES_R"] = "DEBITS_SIMULTANES_R";
    TYPE_DROIT["DECLARATION_PEI"] = "DECLARATION_PEI";
    TYPE_DROIT["DEPOT_DELIB_C"] = "DEPOT_DELIB_C";
    TYPE_DROIT["DFCI_EXPORTATLAS_C"] = "DFCI_EXPORTATLAS_C";
    TYPE_DROIT["DFCI_R"] = "DFCI_R";
    TYPE_DROIT["DFCI_RECEPTRAVAUX_C"] = "DFCI_RECEPTRAVAUX_C";
    TYPE_DROIT["DFCI_AIRE_U"] = "DFCI_AIRE_U";
    TYPE_DROIT["DFCI_PISTE_U"] = "DFCI_PISTE_U";
    TYPE_DROIT["DFCI_DEB_U"] = "DFCI_DEB_U";
    TYPE_DROIT["DFCI_PANNEAU_U"] = "DFCI_PANNEAU_U";
    TYPE_DROIT["DFCI_GESTION_CONFLITS_R"] = "DFCI_GESTION_CONFLITS_R";
    TYPE_DROIT["DFCI_GESTION_CONFLITS_A"] = "DFCI_GESTION_CONFLITS_A";
    TYPE_DROIT["DOCUMENTS_A"] = "DOCUMENTS_A";
    TYPE_DROIT["DOCUMENTS_R"] = "DOCUMENTS_R";
    TYPE_DROIT["ETUDE_C"] = "ETUDE_C";
    TYPE_DROIT["ETUDE_D"] = "ETUDE_D";
    TYPE_DROIT["ETUDE_R"] = "ETUDE_R";
    TYPE_DROIT["ETUDE_U"] = "ETUDE_U";
    TYPE_DROIT["GENERER_CANEVAS_ROP_A"] = "GENERER_CANEVAS_ROP_A";
    TYPE_DROIT["GEST_CONTACT_A"] = "GEST_CONTACT_A";
    TYPE_DROIT["GEST_SITE_A"] = "GEST_SITE_A";
    TYPE_DROIT["GEST_SITE_R"] = "GEST_SITE_R";
    TYPE_DROIT["IMPORT_CTP_A"] = "IMPORT_CTP_A";
    TYPE_DROIT["IMPORT_CTP_PEI_DEPLACEMENT_U"] = "IMPORT_CTP_PEI_DEPLACEMENT_U";
    TYPE_DROIT["IMPORT_UTILISATEUR_A"] = "IMPORT_UTILISATEUR_A";
    TYPE_DROIT["INDISPO_TEMP_C"] = "INDISPO_TEMP_C";
    TYPE_DROIT["INDISPO_TEMP_D"] = "INDISPO_TEMP_D";
    TYPE_DROIT["INDISPO_TEMP_R"] = "INDISPO_TEMP_R";
    TYPE_DROIT["INDISPO_TEMP_U"] = "INDISPO_TEMP_U";
    TYPE_DROIT["MOBILE_DEPLACER_PEI_U"] = "MOBILE_DEPLACER_PEI_U";
    TYPE_DROIT["MOBILE_GESTIONNAIRE_C"] = "MOBILE_GESTIONNAIRE_C";
    TYPE_DROIT["MOBILE_PEI_C"] = "MOBILE_PEI_C";
    TYPE_DROIT["OLDEB_C"] = "OLDEB_C";
    TYPE_DROIT["OLDEB_D"] = "OLDEB_D";
    TYPE_DROIT["OLDEB_R"] = "OLDEB_R";
    TYPE_DROIT["OLDEB_U"] = "OLDEB_U";
    TYPE_DROIT["OPERATIONS_DIVERSES_E"] = "OPERATIONS_DIVERSES_E";
    TYPE_DROIT["PEI_ADRESSE_C"] = "PEI_ADRESSE_C";
    TYPE_DROIT["PEI_C"] = "PEI_C";
    TYPE_DROIT["PEI_CARACTERISTIQUES_U"] = "PEI_CARACTERISTIQUES_U";
    TYPE_DROIT["PEI_D"] = "PEI_D";
    TYPE_DROIT["PEI_DEPLACEMENT_U"] = "PEI_DEPLACEMENT_U";
    TYPE_DROIT["PEI_NUMERO_INTERNE_U"] = "PEI_NUMERO_INTERNE_U";
    TYPE_DROIT["PEI_PRESCRIT_A"] = "PEI_PRESCRIT_A";
    TYPE_DROIT["PEI_PRESCRIT_R"] = "PEI_PRESCRIT_R";
    TYPE_DROIT["PEI_R"] = "PEI_R";
    TYPE_DROIT["PEI_U"] = "PEI_U";
    TYPE_DROIT["PERMIS_A"] = "PERMIS_A";
    TYPE_DROIT["PERMIS_DOCUMENTS_C"] = "PERMIS_DOCUMENTS_C";
    TYPE_DROIT["PERMIS_R"] = "PERMIS_R";
    TYPE_DROIT["RAPPORT_PERSONNALISE_E"] = "RAPPORT_PERSONNALISE_E";
    TYPE_DROIT["RAZ_MES_ROP_E"] = "RAZ_MES_ROP_E";
    TYPE_DROIT["RCCI_A"] = "RCCI_A";
    TYPE_DROIT["RCCI_R"] = "RCCI_R";
    TYPE_DROIT["RISQUE_R"] = "RISQUE_R";
    TYPE_DROIT["RISQUE_EXPRESS_A"] = "RISQUE_EXPRESS_A";
    TYPE_DROIT["TOURNEE_A"] = "TOURNEE_A";
    TYPE_DROIT["TOURNEE_DESAFFECTER_U"] = "TOURNEE_DESAFFECTER_U";
    TYPE_DROIT["TOURNEE_FORCER_POURCENTAGE_E"] = "TOURNEE_FORCER_POURCENTAGE_E";
    TYPE_DROIT["TOURNEE_ORDRE_PEIS_U"] = "TOURNEE_ORDRE_PEIS_U";
    TYPE_DROIT["TOURNEE_R"] = "TOURNEE_R";
    TYPE_DROIT["TOURNEE_RESERVATION_D"] = "TOURNEE_RESERVATION_D";
    TYPE_DROIT["TRAITEMENTS_E"] = "TRAITEMENTS_E";
    TYPE_DROIT["VISITE_CONTROLE_TECHNIQUE_C"] = "VISITE_CONTROLE_TECHNIQUE_C";
    TYPE_DROIT["VISITE_CTP_D"] = "VISITE_CTP_D";
    TYPE_DROIT["VISITE_NON_PROGRAMME_C"] = "VISITE_NON_PROGRAMME_C";
    TYPE_DROIT["VISITE_NP_D"] = "VISITE_NP_D";
    TYPE_DROIT["VISITE_R"] = "VISITE_R";
    TYPE_DROIT["VISITE_RECEP_C"] = "VISITE_RECEP_C";
    TYPE_DROIT["VISITE_RECEP_D"] = "VISITE_RECEP_D";
    TYPE_DROIT["VISITE_RECO_C"] = "VISITE_RECO_C";
    TYPE_DROIT["VISITE_RECO_D"] = "VISITE_RECO_D";
    TYPE_DROIT["VISITE_RECO_INIT_C"] = "VISITE_RECO_INIT_C";
    TYPE_DROIT["VISITE_RECO_INIT_D"] = "VISITE_RECO_INIT_D";
    TYPE_DROIT["ZOOM_LIEU_R"] = "ZOOM_LIEU_R";
    return TYPE_DROIT;
}($7680c94ec9779ccd$var$TYPE_DROIT || {});
var $7680c94ec9779ccd$export$2e2bcd8739ae039 = $7680c94ec9779ccd$var$TYPE_DROIT;
var $7680c94ec9779ccd$export$f1e8c3b59bb3ef17 = /*#__PURE__*/ function(SECTION_DROIT) {
    SECTION_DROIT["SIGNALEMENT"] = "Signalements";
    SECTION_DROIT["CARTO"] = "Cartographie";
    SECTION_DROIT["COUVERTURE_HYDRAULIQUE"] = "Couverture hydraulique";
    SECTION_DROIT["CRISE"] = "Gestion de crise";
    SECTION_DROIT["DFCI"] = "DFCI";
    SECTION_DROIT["GENERAL"] = "G\xe9n\xe9ral";
    SECTION_DROIT["GESTIONNAIRE"] = "Gestionnaire";
    SECTION_DROIT["MOBILE"] = "Application mobile";
    SECTION_DROIT["OLDEB"] = "Obligation L\xe9gale de D\xe9broussaillement (OLDEB)";
    SECTION_DROIT["PEI"] = "Point d'eau";
    SECTION_DROIT["PEI_PRESCRIT"] = "Point d'eau prescrit";
    SECTION_DROIT["PERMIS"] = "Permis";
    SECTION_DROIT["RCCI"] = "Recherche des Causes et des Circonstances d'Incendie (RCCI)";
    SECTION_DROIT["RISQUE"] = "Risques";
    SECTION_DROIT["TOURNEE"] = "Tourn\xe9es";
    return SECTION_DROIT;
}({});
const $7680c94ec9779ccd$export$e595ee2d27cbfb8c = new Map([
    [
        "ADMIN_ANOMALIES",
        "G\xe9n\xe9ral"
    ],
    [
        "ADMIN_API",
        "G\xe9n\xe9ral"
    ],
    [
        "ADMIN_COUCHE_CARTOGRAPHIQUE",
        "G\xe9n\xe9ral"
    ],
    [
        "ADMIN_COURRIER",
        "G\xe9n\xe9ral"
    ],
    [
        "ADMIN_DROITS",
        "G\xe9n\xe9ral"
    ],
    [
        "ADMIN_NOMENCLATURE",
        "G\xe9n\xe9ral"
    ],
    [
        "ADMIN_PARAM_APPLI",
        "G\xe9n\xe9ral"
    ],
    [
        "ADMIN_PARAM_APPLI_MOBILE",
        "Application mobile"
    ],
    [
        "ADMIN_PARAM_TRAITEMENTS",
        "G\xe9n\xe9ral"
    ],
    [
        "ADMIN_RAPPORTS_PERSO",
        "G\xe9n\xe9ral"
    ],
    [
        "ADMIN_ROLE_CONTACT",
        "G\xe9n\xe9ral"
    ],
    [
        "ADMIN_ROP_A",
        "Tourn\xe9es"
    ],
    [
        "ADMIN_TYPE_ETUDE",
        "G\xe9n\xe9ral"
    ],
    [
        "ADMIN_ORGANISME_R",
        "G\xe9n\xe9ral"
    ],
    [
        "ADMIN_ORGANISME_A",
        "G\xe9n\xe9ral"
    ],
    [
        "ORGANISME_CONTACT_A",
        "G\xe9n\xe9ral"
    ],
    [
        "ADMIN_UTILISATEURS_A",
        "G\xe9n\xe9ral"
    ],
    [
        "ADMIN_UTILISATEURS_R",
        "G\xe9n\xe9ral"
    ],
    [
        "ADMIN_UTILISATEURS_ORGA_A",
        "G\xe9n\xe9ral"
    ],
    [
        "ADMIN_UTILISATEURS_ORGA_R",
        "G\xe9n\xe9ral"
    ],
    [
        "IMPORT_UTILISATEUR_A",
        "G\xe9n\xe9ral"
    ],
    [
        "ADMIN_ZONE_COMPETENCE",
        "G\xe9n\xe9ral"
    ],
    [
        "ATLAS_A",
        "DFCI"
    ],
    [
        "ATLAS_C",
        "DFCI"
    ],
    [
        "ATLAS_D",
        "DFCI"
    ],
    [
        "SIGNALEMENTS_C",
        "Signalements"
    ],
    [
        "CARTOGRAPHIES_E",
        "Cartographie"
    ],
    [
        "CARTO_METADATA_A",
        "Cartographie"
    ],
    [
        "COURRIER_C",
        "G\xe9n\xe9ral"
    ],
    [
        "COURRIER_ADMIN_R",
        "G\xe9n\xe9ral"
    ],
    [
        "COURRIER_ORGANISME_R",
        "G\xe9n\xe9ral"
    ],
    [
        "COURRIER_UTILISATEUR_R",
        "G\xe9n\xe9ral"
    ],
    [
        "CRISE_C",
        "Gestion de crise"
    ],
    [
        "CRISE_D",
        "Gestion de crise"
    ],
    [
        "CRISE_R",
        "Gestion de crise"
    ],
    [
        "CRISE_U",
        "Gestion de crise"
    ],
    [
        "DASHBOARD_A",
        "G\xe9n\xe9ral"
    ],
    [
        "DASHBOARD_R",
        "G\xe9n\xe9ral"
    ],
    [
        "DEBITS_SIMULTANES_A",
        "Point d'eau"
    ],
    [
        "DEBITS_SIMULTANES_R",
        "Point d'eau"
    ],
    [
        "DECLARATION_PEI",
        "Point d'eau"
    ],
    [
        "DEPOT_DELIB_C",
        "Signalements"
    ],
    [
        "DFCI_EXPORTATLAS_C",
        "DFCI"
    ],
    [
        "DFCI_R",
        "DFCI"
    ],
    [
        "DFCI_RECEPTRAVAUX_C",
        "DFCI"
    ],
    [
        "DFCI_AIRE_U",
        "DFCI"
    ],
    [
        "DFCI_PISTE_U",
        "DFCI"
    ],
    [
        "DFCI_DEB_U",
        "DFCI"
    ],
    [
        "DFCI_PANNEAU_U",
        "DFCI"
    ],
    [
        "DFCI_GESTION_CONFLITS_R",
        "DFCI"
    ],
    [
        "DFCI_GESTION_CONFLITS_A",
        "DFCI"
    ],
    [
        "DOCUMENTS_A",
        "G\xe9n\xe9ral"
    ],
    [
        "DOCUMENTS_R",
        "G\xe9n\xe9ral"
    ],
    [
        "ETUDE_C",
        "Couverture hydraulique"
    ],
    [
        "ETUDE_D",
        "Couverture hydraulique"
    ],
    [
        "ETUDE_R",
        "Couverture hydraulique"
    ],
    [
        "ETUDE_U",
        "Couverture hydraulique"
    ],
    [
        "GENERER_CANEVAS_ROP_A",
        "Tourn\xe9es"
    ],
    [
        "GEST_CONTACT_A",
        "Gestionnaire"
    ],
    [
        "GEST_SITE_A",
        "Gestionnaire"
    ],
    [
        "GEST_SITE_R",
        "Gestionnaire"
    ],
    [
        "IMPORT_CTP_A",
        "Point d'eau"
    ],
    [
        "IMPORT_CTP_PEI_DEPLACEMENT_U",
        "Point d'eau"
    ],
    [
        "INDISPO_TEMP_C",
        "Point d'eau"
    ],
    [
        "INDISPO_TEMP_D",
        "Point d'eau"
    ],
    [
        "INDISPO_TEMP_R",
        "Point d'eau"
    ],
    [
        "INDISPO_TEMP_U",
        "Point d'eau"
    ],
    [
        "MOBILE_DEPLACER_PEI_U",
        "Application mobile"
    ],
    [
        "MOBILE_GESTIONNAIRE_C",
        "Application mobile"
    ],
    [
        "MOBILE_PEI_C",
        "Application mobile"
    ],
    [
        "OLDEB_C",
        "Obligation L\xe9gale de D\xe9broussaillement (OLDEB)"
    ],
    [
        "OLDEB_D",
        "Obligation L\xe9gale de D\xe9broussaillement (OLDEB)"
    ],
    [
        "OLDEB_R",
        "Obligation L\xe9gale de D\xe9broussaillement (OLDEB)"
    ],
    [
        "OLDEB_U",
        "Obligation L\xe9gale de D\xe9broussaillement (OLDEB)"
    ],
    [
        "OPERATIONS_DIVERSES_E",
        "G\xe9n\xe9ral"
    ],
    [
        "PEI_ADRESSE_C",
        "Point d'eau"
    ],
    [
        "PEI_C",
        "Point d'eau"
    ],
    [
        "PEI_CARACTERISTIQUES_U",
        "Point d'eau"
    ],
    [
        "PEI_D",
        "Point d'eau"
    ],
    [
        "PEI_DEPLACEMENT_U",
        "Point d'eau"
    ],
    [
        "PEI_NUMERO_INTERNE_U",
        "Point d'eau"
    ],
    [
        "PEI_PRESCRIT_A",
        "Point d'eau prescrit"
    ],
    [
        "PEI_PRESCRIT_R",
        "Point d'eau prescrit"
    ],
    [
        "PEI_R",
        "Point d'eau"
    ],
    [
        "PEI_U",
        "Point d'eau"
    ],
    [
        "PERMIS_A",
        "Permis"
    ],
    [
        "PERMIS_DOCUMENTS_C",
        "Permis"
    ],
    [
        "PERMIS_R",
        "Permis"
    ],
    [
        "RAPPORT_PERSONNALISE_E",
        "G\xe9n\xe9ral"
    ],
    [
        "RAZ_MES_ROP_E",
        "Tourn\xe9es"
    ],
    [
        "RCCI_A",
        "Recherche des Causes et des Circonstances d'Incendie (RCCI)"
    ],
    [
        "RCCI_R",
        "Recherche des Causes et des Circonstances d'Incendie (RCCI)"
    ],
    [
        "RISQUE_R",
        "Risques"
    ],
    [
        "RISQUE_EXPRESS_A",
        "Risques"
    ],
    [
        "TOURNEE_A",
        "Tourn\xe9es"
    ],
    [
        "TOURNEE_DESAFFECTER_U",
        "Tourn\xe9es"
    ],
    [
        "TOURNEE_FORCER_POURCENTAGE_E",
        "Tourn\xe9es"
    ],
    [
        "TOURNEE_ORDRE_PEIS_U",
        "Tourn\xe9es"
    ],
    [
        "TOURNEE_R",
        "Tourn\xe9es"
    ],
    [
        "TOURNEE_RESERVATION_D",
        "Tourn\xe9es"
    ],
    [
        "TRAITEMENTS_E",
        "G\xe9n\xe9ral"
    ],
    [
        "VISITE_R",
        "Point d'eau"
    ],
    [
        "VISITE_CONTROLE_TECHNIQUE_C",
        "Point d'eau"
    ],
    [
        "VISITE_CTP_D",
        "Point d'eau"
    ],
    [
        "VISITE_NON_PROGRAMME_C",
        "Point d'eau"
    ],
    [
        "VISITE_NP_D",
        "Point d'eau"
    ],
    [
        "VISITE_RECEP_C",
        "Point d'eau"
    ],
    [
        "VISITE_RECEP_D",
        "Point d'eau"
    ],
    [
        "VISITE_RECO_C",
        "Point d'eau"
    ],
    [
        "VISITE_RECO_D",
        "Point d'eau"
    ],
    [
        "VISITE_RECO_INIT_C",
        "Point d'eau"
    ],
    [
        "VISITE_RECO_INIT_D",
        "Point d'eau"
    ],
    [
        "ZOOM_LIEU_R",
        "G\xe9n\xe9ral"
    ]
]);
const $7680c94ec9779ccd$export$4a72a1b27496d2fa = new Map([
    [
        "ADMIN_ANOMALIES",
        "Administrer les anomalies"
    ],
    [
        "ADMIN_API",
        "Administrer l'API"
    ],
    [
        "ADMIN_COUCHE_CARTOGRAPHIQUE",
        "Administrer les couches cartographiques"
    ],
    [
        "ADMIN_COURRIER",
        "Administrer les mod\xe8les de courrier"
    ],
    [
        "ADMIN_DROITS",
        "Gestion des droits"
    ],
    [
        "ADMIN_NOMENCLATURE",
        "Gestion des nomenclatures"
    ],
    [
        "ADMIN_PARAM_APPLI",
        "Administrer les param\xe8tres de l'application"
    ],
    [
        "ADMIN_PARAM_APPLI_MOBILE",
        "Administrer les param\xe8tres de l'application mobile"
    ],
    [
        "ADMIN_PARAM_TRAITEMENTS",
        "Administrer les transferts automatis\xe9s"
    ],
    [
        "ADMIN_RAPPORTS_PERSO",
        "Administrer les rapports personnalis\xe9s"
    ],
    [
        "ADMIN_ROLE_CONTACT",
        "Administrer les r\xf4les de contact"
    ],
    [
        "ADMIN_ROP_A",
        "G\xe9rer le cycle de vie des ROP"
    ],
    [
        "ADMIN_TYPE_ETUDE",
        "Administrer les types d'\xe9tude"
    ],
    [
        "ADMIN_UTILISATEURS_A",
        "Administrer tous les utilisateurs"
    ],
    [
        "ADMIN_ORGANISME_A",
        "Administrer tous les organismes"
    ],
    [
        "ADMIN_ORGANISME_R",
        "Consulter tous les organismes"
    ],
    [
        "ADMIN_UTILISATEURS_R",
        "Consulter tous les utilisateurs"
    ],
    [
        "ADMIN_UTILISATEURS_ORGA_A",
        "Administrer les utilisateurs de son organisme"
    ],
    [
        "ORGANISME_CONTACT_A",
        "Administrer les organismes et leurs contacts"
    ],
    [
        "ADMIN_UTILISATEURS_ORGA_R",
        "Consulter les utilisateurs de son organisme"
    ],
    [
        "ADMIN_ZONE_COMPETENCE",
        "Importer, \xe9diter les zones de comp\xe9tences"
    ],
    [
        "ATLAS_A",
        "Administrer l'Atlas"
    ],
    [
        "ATLAS_C",
        "\xc9diter les documents de l'Atlas"
    ],
    [
        "ATLAS_D",
        "Supprimer des documents dans l'Atlas"
    ],
    [
        "SIGNALEMENTS_C",
        "Cr\xe9er, \xe9diter les signalements"
    ],
    [
        "CARTOGRAPHIES_E",
        "Acc\xe9der au module cartographie"
    ],
    [
        "CARTO_METADATA_A",
        "Administrer les m\xe9tadonn\xe9es des couches"
    ],
    [
        "COURRIER_C",
        "Cr\xe9er, \xe9diter des courriers"
    ],
    [
        "COURRIER_ADMIN_R",
        "Consulter tous les courriers"
    ],
    [
        "COURRIER_ORGANISME_R",
        "Consulter les courriers de son organisme et de ses enfants"
    ],
    [
        "COURRIER_UTILISATEUR_R",
        "Consulter ses courriers"
    ],
    [
        "CRISE_C",
        "Cr\xe9er une nouvelle crise"
    ],
    [
        "CRISE_D",
        "Supprimer une crise"
    ],
    [
        "CRISE_R",
        "Lister les crises"
    ],
    [
        "CRISE_U",
        "Modifier les informations associ\xe9es \xe0 une crise"
    ],
    [
        "DASHBOARD_A",
        "Administrer les tableaux de bord"
    ],
    [
        "DASHBOARD_R",
        "Consulter le tableau de bord"
    ],
    [
        "DEBITS_SIMULTANES_A",
        "Cr\xe9er, \xe9diter les d\xe9bits simultan\xe9s"
    ],
    [
        "DEBITS_SIMULTANES_R",
        "Consulter les d\xe9bits simultan\xe9s"
    ],
    [
        "DECLARATION_PEI",
        "D\xe9poser un dossier de d\xe9claration de PEI"
    ],
    [
        "DEPOT_DELIB_C",
        "D\xe9poser des d\xe9lib\xe9rations"
    ],
    [
        "DFCI_EXPORTATLAS_C",
        "T\xe9l\xe9charger l'Atlas DFCI"
    ],
    [
        "DFCI_R",
        "Consulter la carte DFCI"
    ],
    [
        "DFCI_RECEPTRAVAUX_C",
        "D\xe9poser des dossiers de r\xe9ception de travaux"
    ],
    [
        "DFCI_AIRE_U",
        "Modifier les informations des aires DFCI"
    ],
    [
        "DFCI_PISTE_U",
        "Modifier les informations des pistes DFCI"
    ],
    [
        "DFCI_DEB_U",
        "Modifier les informations des d\xe9broussaillements DFCI"
    ],
    [
        "DFCI_PANNEAU_U",
        "Modifier les informations des panneaux DFCI"
    ],
    [
        "DFCI_GESTION_CONFLITS_R",
        "Voir les conflits de donn\xe9es DFCI"
    ],
    [
        "DFCI_GESTION_CONFLITS_A",
        "Mettre \xe0 jour les conflits de donn\xe9es DFCI"
    ],
    [
        "DOCUMENTS_A",
        "Administrer les documents"
    ],
    [
        "DOCUMENTS_R",
        "Consulter les documents"
    ],
    [
        "ETUDE_C",
        "Cr\xe9er une \xe9tude"
    ],
    [
        "ETUDE_D",
        "Clore une \xe9tude"
    ],
    [
        "ETUDE_R",
        "Consulter une \xe9tude"
    ],
    [
        "ETUDE_U",
        "Modifier une \xe9tude"
    ],
    [
        "GENERER_CANEVAS_ROP_A",
        "G\xe9n\xe9rer les canevas de ROP"
    ],
    [
        "GEST_CONTACT_A",
        "Administrer les contacts des gestionnaires"
    ],
    [
        "GEST_SITE_A",
        "Administrer les gestionnaires et leurs sites"
    ],
    [
        "GEST_SITE_R",
        "Consulter les gestionnaires et leurs sites"
    ],
    [
        "IMPORT_CTP_A",
        "Importer des fichiers CTP"
    ],
    [
        "IMPORT_CTP_PEI_DEPLACEMENT_U",
        "Modification des coordonn\xe9es dans l'import des CTP"
    ],
    [
        "IMPORT_UTILISATEUR_A",
        "Importer des utilisateurs"
    ],
    [
        "INDISPO_TEMP_C",
        "Cr\xe9er des indisponibilit\xe9s temporaires (soumis au territoire, organis\xe9 par commune)"
    ],
    [
        "INDISPO_TEMP_D",
        "Supprimer des indisponibilit\xe9s temporaires (soumis au territoire, organis\xe9 par commune)"
    ],
    [
        "INDISPO_TEMP_R",
        "Consulter les indisponibilit\xe9s temporaires (soumis au territoire, organis\xe9 par commune)"
    ],
    [
        "INDISPO_TEMP_U",
        "Activer/lever des indisponibilit\xe9s temporaires (soumis au territoire, organis\xe9 par commune)"
    ],
    [
        "MOBILE_DEPLACER_PEI_U",
        "D\xe9placer un PEI"
    ],
    [
        "MOBILE_GESTIONNAIRE_C",
        "Cr\xe9er, \xe9diter les gestionnaires"
    ],
    [
        "MOBILE_PEI_C",
        "Cr\xe9er, \xe9diter un PEI"
    ],
    [
        "OLDEB_C",
        "Cr\xe9er des obligations"
    ],
    [
        "OLDEB_D",
        "Supprimer des obligations"
    ],
    [
        "OLDEB_R",
        "Consulter des obligations"
    ],
    [
        "OLDEB_U",
        "Modifier des obligations"
    ],
    [
        "OPERATIONS_DIVERSES_E",
        "Acc\xe9der au module des op\xe9rations diverses"
    ],
    [
        "PEI_ADRESSE_C",
        "Cr\xe9er, \xe9diter l'adresse des PEI"
    ],
    [
        "PEI_C",
        "Cr\xe9er un PEI"
    ],
    [
        "PEI_CARACTERISTIQUES_U",
        "Modifier les caract\xe9ristiques techniques"
    ],
    [
        "PEI_D",
        "Supprimer des PEI"
    ],
    [
        "PEI_DEPLACEMENT_U",
        "D\xe9placer des PEI"
    ],
    [
        "PEI_NUMERO_INTERNE_U",
        "Saisir le num\xe9ro interne d'un PEI"
    ],
    [
        "PEI_PRESCRIT_A",
        "Cr\xe9er, \xe9diter, supprimer les points d'eau prescrits"
    ],
    [
        "PEI_PRESCRIT_R",
        "Consulter les points d'eau prescrits"
    ],
    [
        "PEI_R",
        "Consulter les PEI"
    ],
    [
        "PEI_U",
        "Modification des informations g\xe9n\xe9rales, de l'adresse et des documents d'un PEI"
    ],
    [
        "PERMIS_A",
        "Cr\xe9er, \xe9diter, supprimer les permis"
    ],
    [
        "PERMIS_DOCUMENTS_C",
        "D\xe9poser des documents rattach\xe9s \xe0 un permis"
    ],
    [
        "PERMIS_R",
        "Consulter les permis (carte et recherches)"
    ],
    [
        "RAZ_MES_ROP_E",
        "Remettre \xe0 z\xe9ro l'\xe9tat des ROP de son organisme"
    ],
    [
        "RAPPORT_PERSONNALISE_E",
        "Ex\xe9cuter des rapports personnalis\xe9s"
    ],
    [
        "RCCI_A",
        "Cr\xe9er, \xe9diter, supprimer les RCCI"
    ],
    [
        "RCCI_R",
        "Consulter les RCCI"
    ],
    [
        "RISQUE_R",
        "Acc\xe9der au module de risque"
    ],
    [
        "RISQUE_EXPRESS_A",
        "Administrer la couche 'Risques express'"
    ],
    [
        "TOURNEE_A",
        "Cr\xe9er, \xe9diter, supprimer des tourn\xe9es"
    ],
    [
        "TOURNEE_DESAFFECTER_U",
        "D\xe9saffecter des PEI \xe0 des tourn\xe9es"
    ],
    [
        "TOURNEE_FORCER_POURCENTAGE_E",
        "Forcer le pourcentage des tourn\xe9es"
    ],
    [
        "TOURNEE_ORDRE_PEIS_U",
        "Modifier l'ordre des PEI dans une tourn\xe9e"
    ],
    [
        "TOURNEE_R",
        "Consulter les tourn\xe9es"
    ],
    [
        "TOURNEE_RESERVATION_D",
        "Supprimer la r\xe9servation d'une tourn\xe9e"
    ],
    [
        "TRAITEMENTS_E",
        "Ex\xe9cuter des traitements  "
    ],
    [
        "VISITE_R",
        "Consulter les visites"
    ],
    [
        "VISITE_CONTROLE_TECHNIQUE_C",
        "R\xe9aliser des contr\xf4les techniques p\xe9riodiques"
    ],
    [
        "VISITE_CTP_D",
        "Supprimer des contr\xf4les techniques p\xe9riodiques"
    ],
    [
        "VISITE_NON_PROGRAMME_C",
        "R\xe9aliser des visites non programm\xe9es"
    ],
    [
        "VISITE_NP_D",
        "Supprimer des visites non programm\xe9es"
    ],
    [
        "VISITE_RECEP_C",
        "R\xe9aliser des visites de r\xe9ception"
    ],
    [
        "VISITE_RECEP_D",
        "Supprimer des visites de r\xe9ception "
    ],
    [
        "VISITE_RECO_C",
        "R\xe9aliser des visites de reconnaissance op\xe9rationnelle p\xe9riodique"
    ],
    [
        "VISITE_RECO_D",
        "Supprimer des visites de reconnaissance op\xe9rationnelle p\xe9riodique"
    ],
    [
        "VISITE_RECO_INIT_C",
        "R\xe9aliser des visites de reconnaissance op\xe9rationnelle initiale"
    ],
    [
        "VISITE_RECO_INIT_D",
        "Supprimer des visites de reconnaissance op\xe9rationnelle initiale"
    ],
    [
        "ZOOM_LIEU_R",
        "Zoomer sur un lieu"
    ]
]);
const $7680c94ec9779ccd$export$77886d1025bbf60d = new Map([
    [
        "PEI_NUMERO_INTERNE_U",
        "Si le param\xe8tre 'Activer la renum\xe9rotation interne automatique des PEI' est activ\xe9, l'utilisateur ne pourra pas modifier le num\xe9ro interne d'un PEI m\xeame si le droit est coch\xe9."
    ],
    [
        "COURRIER_ADMIN_R",
        "L'utilisateur peut consulter l'ensemble des courriers sans aucun filtre."
    ],
    [
        "COURRIER_ORGANISME_R",
        "L'utilisateur peut consulter tous les courriers envoy\xe9s et re\xe7us par son organisme ainsi que par ses organismes enfants."
    ],
    [
        "COURRIER_UTILISATEUR_R",
        "L'utilisateur connect\xe9 peut consulter ses propres courriers re\xe7us. Si un contact de gestionnaire ou d'organisme poss\xe8de la m\xeame adresse mail que l'utilisateur, il peut \xe9galement consulter les courriers re\xe7us par ce contact."
    ]
]);
var $7680c94ec9779ccd$export$7afc20a3b0894f44 = /*#__PURE__*/ function(TYPE_DROIT_API) {
    TYPE_DROIT_API["ADMINISTRER"] = "ADMINISTRER";
    TYPE_DROIT_API["RECEVOIR"] = "RECEVOIR";
    TYPE_DROIT_API["TRANSMETTRE"] = "TRANSMETTRE";
    return TYPE_DROIT_API;
}({});
const $7680c94ec9779ccd$export$2f28434219a14e94 = new Map([
    [
        "ADMINISTRER",
        "Permet d'administer les donn\xe9es ind\xe9pendamment de la zone de comp\xe9tence de l'organisme."
    ],
    [
        "RECEVOIR",
        "Donne \xe0 l'organisme concern\xe9 les droits d'acc\xe8s aux informations en lecture seule sur sa zone de comp\xe9tence"
    ],
    [
        "TRANSMETTRE",
        "Permet \xe0 l'organisme concern\xe9 de modifier des informations sur sa zone de comp\xe9tence"
    ]
]);



var $70f33b4ac8b2af85$var$PROCHAINE_DATE_ENUM = /*#__PURE__*/ function(PROCHAINE_DATE_ENUM) {
    PROCHAINE_DATE_ENUM["DATE_PASSEE"] = "Date pass\xe9e";
    PROCHAINE_DATE_ENUM["INFERIEUR_1_MOIS"] = "< 1 mois";
    PROCHAINE_DATE_ENUM["INFERIEUR_2_MOIS"] = "< 2 mois";
    PROCHAINE_DATE_ENUM["INFERIEUR_6_MOIS"] = "< 6 mois";
    PROCHAINE_DATE_ENUM["INFERIEUR_12_MOIS"] = "< 12 mois";
    PROCHAINE_DATE_ENUM["INFERIEUR_24_MOIS"] = "< 24 mois";
    PROCHAINE_DATE_ENUM["INFERIEUR_36_MOIS"] = "< 36 mois";
    return PROCHAINE_DATE_ENUM;
}($70f33b4ac8b2af85$var$PROCHAINE_DATE_ENUM || {});
var $70f33b4ac8b2af85$export$2e2bcd8739ae039 = $70f33b4ac8b2af85$var$PROCHAINE_DATE_ENUM;
var $70f33b4ac8b2af85$export$d1513a971ccb2ea8 = /*#__PURE__*/ function(INTERVALLE_DATE_PROCHE_ENUM) {
    INTERVALLE_DATE_PROCHE_ENUM["INFERIEUR_1_JOUR"] = "< 1 jour";
    INTERVALLE_DATE_PROCHE_ENUM["INFERIEUR_1_SEMAINE"] = "< 1 semaine";
    INTERVALLE_DATE_PROCHE_ENUM["INFERIEUR_1_MOIS"] = "< 1 mois";
    INTERVALLE_DATE_PROCHE_ENUM["INFERIEUR_3_MOIS"] = "< 3 mois";
    INTERVALLE_DATE_PROCHE_ENUM["INFERIEUR_6_MOIS"] = "< 6 mois";
    return INTERVALLE_DATE_PROCHE_ENUM;
}({});


var $4a8fc6d624905721$var$STATUT_INDISPONIBILITE_TEMPORAIRE = /*#__PURE__*/ function(STATUT_INDISPONIBILITE_TEMPORAIRE) {
    STATUT_INDISPONIBILITE_TEMPORAIRE["EN_COURS_PLANIFIEE"] = "En cours / Planifi\xe9e";
    STATUT_INDISPONIBILITE_TEMPORAIRE["EN_COURS"] = "En cours";
    STATUT_INDISPONIBILITE_TEMPORAIRE["PLANIFIEE"] = "Planifi\xe9e";
    STATUT_INDISPONIBILITE_TEMPORAIRE["TERMINEE"] = "Termin\xe9e";
    return STATUT_INDISPONIBILITE_TEMPORAIRE;
}($4a8fc6d624905721$var$STATUT_INDISPONIBILITE_TEMPORAIRE || {});
var $4a8fc6d624905721$export$2e2bcd8739ae039 = $4a8fc6d624905721$var$STATUT_INDISPONIBILITE_TEMPORAIRE;


/**
 * Enumération définissant les types PEI
 */ var $f31f748b1c9fd0fb$var$TYPE_PEI = /*#__PURE__*/ function(TYPE_PEI) {
    TYPE_PEI["PIBI"] = "PIBI";
    TYPE_PEI["PENA"] = "PENA";
    return TYPE_PEI;
}($f31f748b1c9fd0fb$var$TYPE_PEI || {});
var $f31f748b1c9fd0fb$export$2e2bcd8739ae039 = $f31f748b1c9fd0fb$var$TYPE_PEI;


var $a4f278cac9030fb1$var$VRAI_FAUX = /*#__PURE__*/ function(VRAI_FAUX) {
    VRAI_FAUX["true"] = "Vrai";
    VRAI_FAUX["false"] = "Faux";
    return VRAI_FAUX;
}($a4f278cac9030fb1$var$VRAI_FAUX || {});
var $a4f278cac9030fb1$export$2e2bcd8739ae039 = $a4f278cac9030fb1$var$VRAI_FAUX;








const $e7b5be6e16761684$var$DocumentPei = ({ peiId: peiId, titre: titre = null })=>{
    const documentsPei = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/documents/pei/${peiId}`);
    if (!documentsPei.isResolved) return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $c21b1c237cfa1d94$export$2e2bcd8739ae039), {});
    const LinkDocument = ({ documentId: documentId, documentNomFichier: documentNomFichier })=>{
        return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("a", {
            className: "fs-6",
            href: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/documents/telecharger/${documentId}`,
            target: "_blank",
            rel: "noopener noreferrer",
            children: documentNomFichier
        });
    };
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            titre && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("h1", {
                children: titre
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
                children: documentsPei.data && (()=>{
                    const docs = documentsPei.data;
                    const photoDoc = docs.find((doc)=>doc.isPhotoPei);
                    const otherDocs = docs.filter((doc)=>!doc.isPhotoPei);
                    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                        children: [
                            photoDoc && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                                className: "p-3 mb-3 bg-light border rounded d-flex align-items-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("span", {
                                        className: "fw-bold fs-6",
                                        children: "Photo du PEI :"
                                    }),
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)(LinkDocument, {
                                        documentId: photoDoc.documentId,
                                        documentNomFichier: photoDoc.documentNomFichier
                                    })
                                ]
                            }),
                            otherDocs.length > 0 && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("ul", {
                                className: "fs-6",
                                children: otherDocs.map((doc)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("li", {
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)(LinkDocument, {
                                            documentId: doc.documentId,
                                            documentNomFichier: doc.documentNomFichier
                                        })
                                    }, doc.documentId))
                            })
                        ]
                    });
                })()
            })
        ]
    });
};
var $e7b5be6e16761684$export$2e2bcd8739ae039 = $e7b5be6e16761684$var$DocumentPei;






var $kc00y = parcelRequire("kc00y");
function $328c1c2632e2f292$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $328c1c2632e2f292$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $328c1c2632e2f292$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $328c1c2632e2f292$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $328c1c2632e2f292$export$2e2bcd8739ae039 = $328c1c2632e2f292$export$4f5d2d50c9deca37;



var $kc00y = parcelRequire("kc00y");


var $kc00y = parcelRequire("kc00y");
var $17b5e9a14cb04dec$var$EventKeys = [
    'dangerouslySetInnerHTML',
    'onCopy',
    'onCopyCapture',
    'onCut',
    'onCutCapture',
    'onPaste',
    'onPasteCapture',
    'onCompositionEnd',
    'onCompositionEndCapture',
    'onCompositionStart',
    'onCompositionStartCapture',
    'onCompositionUpdate',
    'onCompositionUpdateCapture',
    'onFocus',
    'onFocusCapture',
    'onBlur',
    'onBlurCapture',
    'onChange',
    'onChangeCapture',
    'onBeforeInput',
    'onBeforeInputCapture',
    'onInput',
    'onInputCapture',
    'onReset',
    'onResetCapture',
    'onSubmit',
    'onSubmitCapture',
    'onInvalid',
    'onInvalidCapture',
    'onLoad',
    'onLoadCapture',
    'onError',
    'onErrorCapture',
    'onKeyDown',
    'onKeyDownCapture',
    'onKeyPress',
    'onKeyPressCapture',
    'onKeyUp',
    'onKeyUpCapture',
    'onAbort',
    'onAbortCapture',
    'onCanPlay',
    'onCanPlayCapture',
    'onCanPlayThrough',
    'onCanPlayThroughCapture',
    'onDurationChange',
    'onDurationChangeCapture',
    'onEmptied',
    'onEmptiedCapture',
    'onEncrypted',
    'onEncryptedCapture',
    'onEnded',
    'onEndedCapture',
    'onLoadedData',
    'onLoadedDataCapture',
    'onLoadedMetadata',
    'onLoadedMetadataCapture',
    'onLoadStart',
    'onLoadStartCapture',
    'onPause',
    'onPauseCapture',
    'onPlay',
    'onPlayCapture',
    'onPlaying',
    'onPlayingCapture',
    'onProgress',
    'onProgressCapture',
    'onRateChange',
    'onRateChangeCapture',
    'onSeeked',
    'onSeekedCapture',
    'onSeeking',
    'onSeekingCapture',
    'onStalled',
    'onStalledCapture',
    'onSuspend',
    'onSuspendCapture',
    'onTimeUpdate',
    'onTimeUpdateCapture',
    'onVolumeChange',
    'onVolumeChangeCapture',
    'onWaiting',
    'onWaitingCapture',
    'onAuxClick',
    'onAuxClickCapture',
    'onClick',
    'onClickCapture',
    'onContextMenu',
    'onContextMenuCapture',
    'onDoubleClick',
    'onDoubleClickCapture',
    'onDrag',
    'onDragCapture',
    'onDragEnd',
    'onDragEndCapture',
    'onDragEnter',
    'onDragEnterCapture',
    'onDragExit',
    'onDragExitCapture',
    'onDragLeave',
    'onDragLeaveCapture',
    'onDragOver',
    'onDragOverCapture',
    'onDragStart',
    'onDragStartCapture',
    'onDrop',
    'onDropCapture',
    'onMouseDown',
    'onMouseDownCapture',
    'onMouseEnter',
    'onMouseLeave',
    'onMouseMove',
    'onMouseMoveCapture',
    'onMouseOut',
    'onMouseOutCapture',
    'onMouseOver',
    'onMouseOverCapture',
    'onMouseUp',
    'onMouseUpCapture',
    'onSelect',
    'onSelectCapture',
    'onTouchCancel',
    'onTouchCancelCapture',
    'onTouchEnd',
    'onTouchEndCapture',
    'onTouchMove',
    'onTouchMoveCapture',
    'onTouchStart',
    'onTouchStartCapture',
    'onPointerDown',
    'onPointerDownCapture',
    'onPointerMove',
    'onPointerMoveCapture',
    'onPointerUp',
    'onPointerUpCapture',
    'onPointerCancel',
    'onPointerCancelCapture',
    'onPointerEnter',
    'onPointerEnterCapture',
    'onPointerLeave',
    'onPointerLeaveCapture',
    'onPointerOver',
    'onPointerOverCapture',
    'onPointerOut',
    'onPointerOutCapture',
    'onGotPointerCapture',
    'onGotPointerCaptureCapture',
    'onLostPointerCapture',
    'onLostPointerCaptureCapture',
    'onScroll',
    'onScrollCapture',
    'onWheel',
    'onWheelCapture',
    'onAnimationStart',
    'onAnimationStartCapture',
    'onAnimationEnd',
    'onAnimationEndCapture',
    'onAnimationIteration',
    'onAnimationIterationCapture',
    'onTransitionEnd',
    'onTransitionEndCapture'
];
function $17b5e9a14cb04dec$export$7d045284457d8577(key) {
    if (typeof key !== 'string') return false;
    var allowedEventKeys = $17b5e9a14cb04dec$var$EventKeys;
    return allowedEventKeys.includes(key);
}



var $kc00y = parcelRequire("kc00y");
var $34cf66bbb2aff04f$var$SVGElementPropKeys = [
    'aria-activedescendant',
    'aria-atomic',
    'aria-autocomplete',
    'aria-busy',
    'aria-checked',
    'aria-colcount',
    'aria-colindex',
    'aria-colspan',
    'aria-controls',
    'aria-current',
    'aria-describedby',
    'aria-details',
    'aria-disabled',
    'aria-errormessage',
    'aria-expanded',
    'aria-flowto',
    'aria-haspopup',
    'aria-hidden',
    'aria-invalid',
    'aria-keyshortcuts',
    'aria-label',
    'aria-labelledby',
    'aria-level',
    'aria-live',
    'aria-modal',
    'aria-multiline',
    'aria-multiselectable',
    'aria-orientation',
    'aria-owns',
    'aria-placeholder',
    'aria-posinset',
    'aria-pressed',
    'aria-readonly',
    'aria-relevant',
    'aria-required',
    'aria-roledescription',
    'aria-rowcount',
    'aria-rowindex',
    'aria-rowspan',
    'aria-selected',
    'aria-setsize',
    'aria-sort',
    'aria-valuemax',
    'aria-valuemin',
    'aria-valuenow',
    'aria-valuetext',
    'className',
    'color',
    'height',
    'id',
    'lang',
    'max',
    'media',
    'method',
    'min',
    'name',
    'style',
    /*
 * removed 'type' SVGElementPropKey because we do not currently use any SVG elements
 * that can use it, and it conflicts with the recharts prop 'type'
 * https://github.com/recharts/recharts/pull/3327
 * https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/type
 */ // 'type',
    'target',
    'width',
    'role',
    'tabIndex',
    'accentHeight',
    'accumulate',
    'additive',
    'alignmentBaseline',
    'allowReorder',
    'alphabetic',
    'amplitude',
    'arabicForm',
    'ascent',
    'attributeName',
    'attributeType',
    'autoReverse',
    'azimuth',
    'baseFrequency',
    'baselineShift',
    'baseProfile',
    'bbox',
    'begin',
    'bias',
    'by',
    'calcMode',
    'capHeight',
    'clip',
    'clipPath',
    'clipPathUnits',
    'clipRule',
    'colorInterpolation',
    'colorInterpolationFilters',
    'colorProfile',
    'colorRendering',
    'contentScriptType',
    'contentStyleType',
    'cursor',
    'cx',
    'cy',
    'd',
    'decelerate',
    'descent',
    'diffuseConstant',
    'direction',
    'display',
    'divisor',
    'dominantBaseline',
    'dur',
    'dx',
    'dy',
    'edgeMode',
    'elevation',
    'enableBackground',
    'end',
    'exponent',
    'externalResourcesRequired',
    'fill',
    'fillOpacity',
    'fillRule',
    'filter',
    'filterRes',
    'filterUnits',
    'floodColor',
    'floodOpacity',
    'focusable',
    'fontFamily',
    'fontSize',
    'fontSizeAdjust',
    'fontStretch',
    'fontStyle',
    'fontVariant',
    'fontWeight',
    'format',
    'from',
    'fx',
    'fy',
    'g1',
    'g2',
    'glyphName',
    'glyphOrientationHorizontal',
    'glyphOrientationVertical',
    'glyphRef',
    'gradientTransform',
    'gradientUnits',
    'hanging',
    'horizAdvX',
    'horizOriginX',
    'href',
    'ideographic',
    'imageRendering',
    'in2',
    'in',
    'intercept',
    'k1',
    'k2',
    'k3',
    'k4',
    'k',
    'kernelMatrix',
    'kernelUnitLength',
    'kerning',
    'keyPoints',
    'keySplines',
    'keyTimes',
    'lengthAdjust',
    'letterSpacing',
    'lightingColor',
    'limitingConeAngle',
    'local',
    'markerEnd',
    'markerHeight',
    'markerMid',
    'markerStart',
    'markerUnits',
    'markerWidth',
    'mask',
    'maskContentUnits',
    'maskUnits',
    'mathematical',
    'mode',
    'numOctaves',
    'offset',
    'opacity',
    'operator',
    'order',
    'orient',
    'orientation',
    'origin',
    'overflow',
    'overlinePosition',
    'overlineThickness',
    'paintOrder',
    'panose1',
    'pathLength',
    'patternContentUnits',
    'patternTransform',
    'patternUnits',
    'pointerEvents',
    'pointsAtX',
    'pointsAtY',
    'pointsAtZ',
    'preserveAlpha',
    'preserveAspectRatio',
    'primitiveUnits',
    'r',
    'radius',
    'refX',
    'refY',
    'renderingIntent',
    'repeatCount',
    'repeatDur',
    'requiredExtensions',
    'requiredFeatures',
    'restart',
    'result',
    'rotate',
    'rx',
    'ry',
    'seed',
    'shapeRendering',
    'slope',
    'spacing',
    'specularConstant',
    'specularExponent',
    'speed',
    'spreadMethod',
    'startOffset',
    'stdDeviation',
    'stemh',
    'stemv',
    'stitchTiles',
    'stopColor',
    'stopOpacity',
    'strikethroughPosition',
    'strikethroughThickness',
    'string',
    'stroke',
    'strokeDasharray',
    'strokeDashoffset',
    'strokeLinecap',
    'strokeLinejoin',
    'strokeMiterlimit',
    'strokeOpacity',
    'strokeWidth',
    'surfaceScale',
    'systemLanguage',
    'tableValues',
    'targetX',
    'targetY',
    'textAnchor',
    'textDecoration',
    'textLength',
    'textRendering',
    'to',
    'transform',
    'u1',
    'u2',
    'underlinePosition',
    'underlineThickness',
    'unicode',
    'unicodeBidi',
    'unicodeRange',
    'unitsPerEm',
    'vAlphabetic',
    'values',
    'vectorEffect',
    'version',
    'vertAdvY',
    'vertOriginX',
    'vertOriginY',
    'vHanging',
    'vIdeographic',
    'viewTarget',
    'visibility',
    'vMathematical',
    'widths',
    'wordSpacing',
    'writingMode',
    'x1',
    'x2',
    'x',
    'xChannelSelector',
    'xHeight',
    'xlinkActuate',
    'xlinkArcrole',
    'xlinkHref',
    'xlinkRole',
    'xlinkShow',
    'xlinkTitle',
    'xlinkType',
    'xmlBase',
    'xmlLang',
    'xmlns',
    'xmlnsXlink',
    'xmlSpace',
    'y1',
    'y2',
    'y',
    'yChannelSelector',
    'z',
    'zoomAndPan',
    'ref',
    'key',
    'angle'
];
var $34cf66bbb2aff04f$var$SVGElementPropKeySet = new Set($34cf66bbb2aff04f$var$SVGElementPropKeys);
function $34cf66bbb2aff04f$export$b73d29c2a6d3ff97(key) {
    if (typeof key !== 'string') return false;
    return $34cf66bbb2aff04f$var$SVGElementPropKeySet.has(key);
}
function $34cf66bbb2aff04f$export$904e03d0a8b085df(key) {
    return typeof key === 'string' && key.startsWith('data-');
}
function $34cf66bbb2aff04f$export$8b56257912140094(obj) {
    if (typeof obj !== 'object' || obj === null) return {};
    var result = {};
    for(var key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            if ($34cf66bbb2aff04f$export$b73d29c2a6d3ff97(key) || $34cf66bbb2aff04f$export$904e03d0a8b085df(key)) result[key] = obj[key];
        }
    }
    return result;
}
function $34cf66bbb2aff04f$export$6d5921c09aa671a9(input) {
    if (input == null) return null;
    if (/*#__PURE__*/ (0, $kc00y.isValidElement)(input) && typeof input.props === 'object' && input.props !== null) {
        var p = input.props;
        return $34cf66bbb2aff04f$export$8b56257912140094(p);
    }
    if (typeof input === 'object' && !Array.isArray(input)) return $34cf66bbb2aff04f$export$8b56257912140094(input);
    return null;
}


function $976509d5bd74ee3b$export$67f8fc03e57e2747(obj) {
    var result = {};
    // for ... in loop is 10x faster than Object.entries + filter + Object.fromEntries in Chrome
    for(var key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            if ((0, $34cf66bbb2aff04f$export$b73d29c2a6d3ff97)(key) || (0, $34cf66bbb2aff04f$export$904e03d0a8b085df)(key) || (0, $17b5e9a14cb04dec$export$7d045284457d8577)(key)) result[key] = obj[key];
        }
    }
    return result;
}
function $976509d5bd74ee3b$export$87ef3d7bc7cd0706(input) {
    if (input == null) return null;
    if (/*#__PURE__*/ (0, $kc00y.isValidElement)(input)) // @ts-expect-error we can't type this better because input can be any React element
    return $976509d5bd74ee3b$export$67f8fc03e57e2747(input.props);
    if (typeof input === 'object' && !Array.isArray(input)) return $976509d5bd74ee3b$export$67f8fc03e57e2747(input);
    return null;
}


var $553c02c7047f2968$var$_excluded = [
    "children",
    "className"
];
function $553c02c7047f2968$var$_extends() {
    return $553c02c7047f2968$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $553c02c7047f2968$var$_extends.apply(null, arguments);
}
function $553c02c7047f2968$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $553c02c7047f2968$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $553c02c7047f2968$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $553c02c7047f2968$export$936d0764594b6eb3 = /*#__PURE__*/ $kc00y.forwardRef((props, ref)=>{
    var { children: children, className: className } = props, others = $553c02c7047f2968$var$_objectWithoutProperties(props, $553c02c7047f2968$var$_excluded);
    var layerClass = (0, $328c1c2632e2f292$export$4f5d2d50c9deca37)('recharts-layer', className);
    return /*#__PURE__*/ $kc00y.createElement("g", $553c02c7047f2968$var$_extends({
        className: layerClass
    }, (0, $976509d5bd74ee3b$export$67f8fc03e57e2747)(others), {
        ref: ref
    }), children);
});


/**
 * Cell component used to define colors and styles of chart elements.
 *
 * This component is now deprecated and will be removed in Recharts 4.0.
 *
 * Please use the `shape` prop or `content` prop on the respective chart components
 * to customize the rendering of chart elements instead of using `Cell`.
 *
 * @see {@link https://recharts.github.io/en-US/guide/cell/ Guide: Migrate from Cell component to shape prop}
 *
 * @deprecated
 * @consumes CellReader
 */ var $af579bd742156f26$export$f6f0c3fe4ec306ea = (_props)=>null;
$af579bd742156f26$export$f6f0c3fe4ec306ea.displayName = 'Cell';



var $kc00y = parcelRequire("kc00y");

var $kc00y = parcelRequire("kc00y");


var $kc00y = parcelRequire("kc00y");

var $c09fe069b4c20e1b$exports = {};

$c09fe069b4c20e1b$exports = (parcelRequire("a9nNI")).get;


// if you go lower than 3, wild wild things happen during rendering
var $ff2870262f58b24e$var$defaultRoundPrecision = 4;
function $ff2870262f58b24e$export$2077e0241d6afd3c(num) {
    var roundPrecision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $ff2870262f58b24e$var$defaultRoundPrecision;
    var factor = 10 ** roundPrecision;
    var rounded = Math.round(num * factor) / factor;
    if (Object.is(rounded, -0)) return 0;
    return rounded;
}
function $ff2870262f58b24e$export$f8a24ecc3d6c26c3(strings) {
    for(var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)values[_key - 1] = arguments[_key];
    return strings.reduce((result, string, i)=>{
        var value = values[i - 1];
        if (typeof value === 'string') return result + value + string;
        if (value !== undefined) return result + $ff2870262f58b24e$export$2077e0241d6afd3c(value) + string;
        return result + string;
    }, '');
}


var $7e613228d3a31273$export$9d334328eb75e624 = (value)=>{
    if (value === 0) return 0;
    if (value > 0) return 1;
    return -1;
};
var $7e613228d3a31273$export$e426a261f3212d7d = (value)=>{
    // eslint-disable-next-line eqeqeq
    return typeof value == 'number' && value != +value;
};
var $7e613228d3a31273$export$e50269385c77c348 = (value)=>typeof value === 'string' && value.indexOf('%') === value.length - 1;
var $7e613228d3a31273$export$7e4aa119212bc614 = (value)=>(typeof value === 'number' || value instanceof Number) && !$7e613228d3a31273$export$e426a261f3212d7d(value);
var $7e613228d3a31273$export$402a499e1ea44294 = (value)=>$7e613228d3a31273$export$7e4aa119212bc614(value) || typeof value === 'string';
var $7e613228d3a31273$var$idCounter = 0;
var $7e613228d3a31273$export$8b15d37bc3f197d4 = (prefix)=>{
    var id = ++$7e613228d3a31273$var$idCounter;
    return "".concat(prefix || '').concat(id);
};
var $7e613228d3a31273$export$476354dbf49bdff6 = function getPercentValue(percent, totalValue) {
    var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var validate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    if (!$7e613228d3a31273$export$7e4aa119212bc614(percent) && typeof percent !== 'string') return defaultValue;
    var value;
    if ($7e613228d3a31273$export$e50269385c77c348(percent)) {
        if (totalValue == null) return defaultValue;
        var index = percent.indexOf('%');
        value = totalValue * parseFloat(percent.slice(0, index)) / 100;
    } else value = +percent;
    if ($7e613228d3a31273$export$e426a261f3212d7d(value)) value = defaultValue;
    if (validate && totalValue != null && value > totalValue) value = totalValue;
    return value;
};
var $7e613228d3a31273$export$732baf6a98f122 = (ary)=>{
    if (!Array.isArray(ary)) return false;
    var len = ary.length;
    var cache = {};
    for(var i = 0; i < len; i++){
        if (!cache[String(ary[i])]) cache[String(ary[i])] = true;
        else return true;
    }
    return false;
};
function $7e613228d3a31273$export$89e29e4ab65e70a9(start, end, t) {
    if ($7e613228d3a31273$export$7e4aa119212bc614(start) && $7e613228d3a31273$export$7e4aa119212bc614(end)) return (0, $ff2870262f58b24e$export$2077e0241d6afd3c)(start + t * (end - start));
    return end;
}
function $7e613228d3a31273$export$66950d3869f5cc67(ary, specifiedKey, specifiedValue) {
    if (!ary || !ary.length) return undefined;
    return ary.find((entry)=>entry && (typeof specifiedKey === 'function' ? specifiedKey(entry) : (0, (/*@__PURE__*/$parcel$interopDefault($c09fe069b4c20e1b$exports)))(entry, specifiedKey)) === specifiedValue);
}
var $7e613228d3a31273$export$484982720961754e = (data)=>{
    var len = data.length;
    var xsum = 0;
    var ysum = 0;
    var xysum = 0;
    var xxsum = 0;
    var xmin = Infinity;
    var xmax = -Infinity;
    var xcurrent = 0;
    var ycurrent = 0;
    for(var i = 0; i < len; i++){
        var _data$i, _data$i2;
        xcurrent = ((_data$i = data[i]) === null || _data$i === void 0 ? void 0 : _data$i.cx) || 0;
        ycurrent = ((_data$i2 = data[i]) === null || _data$i2 === void 0 ? void 0 : _data$i2.cy) || 0;
        xsum += xcurrent;
        ysum += ycurrent;
        xysum += xcurrent * ycurrent;
        xxsum += xcurrent * xcurrent;
        xmin = Math.min(xmin, xcurrent);
        xmax = Math.max(xmax, xcurrent);
    }
    var a = len * xxsum !== xsum * xsum ? (len * xysum - xsum * ysum) / (len * xxsum - xsum * xsum) : 0;
    return {
        xmin: xmin,
        xmax: xmax,
        a: a,
        b: (ysum - a * xsum) / len
    };
};
var $7e613228d3a31273$export$b931b78cbb3caf86 = (value)=>{
    return value === null || typeof value === 'undefined';
};
var $7e613228d3a31273$export$3061f22cd819074d = (value)=>{
    if ($7e613228d3a31273$export$b931b78cbb3caf86(value)) return value;
    return "".concat(value.charAt(0).toUpperCase()).concat(value.slice(1));
};
function $7e613228d3a31273$export$7e515ab5fbd92bef(value) {
    return value != null;
}
function $7e613228d3a31273$export$8793edee2d425525() {}


var $21ceeda12d85451c$var$parseIsSsrByDefault = ()=>!(typeof window !== 'undefined' && window.document && Boolean(window.document.createElement) && window.setTimeout);
var $21ceeda12d85451c$export$98f03c5d19621d70 = {
    devToolsEnabled: true,
    isSsr: $21ceeda12d85451c$var$parseIsSsrByDefault()
};



function $6e6d0c352076c825$var$_defineProperty(e, r, t) {
    return (r = $6e6d0c352076c825$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $6e6d0c352076c825$var$_toPropertyKey(t) {
    var i = $6e6d0c352076c825$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $6e6d0c352076c825$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
class $6e6d0c352076c825$export$182500e6725aad9a {
    constructor(maxSize){
        $6e6d0c352076c825$var$_defineProperty(this, "cache", new Map());
        this.maxSize = maxSize;
    }
    get(key) {
        var value = this.cache.get(key);
        if (value !== undefined) {
            this.cache.delete(key);
            this.cache.set(key, value);
        }
        return value;
    }
    set(key, value) {
        if (this.cache.has(key)) this.cache.delete(key);
        else if (this.cache.size >= this.maxSize) {
            var firstKey = this.cache.keys().next().value;
            if (firstKey != null) this.cache.delete(firstKey);
        }
        this.cache.set(key, value);
    }
    clear() {
        this.cache.clear();
    }
    size() {
        return this.cache.size;
    }
}


function $10a1fdf426ed2330$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $10a1fdf426ed2330$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $10a1fdf426ed2330$var$ownKeys(Object(t), !0).forEach(function(r) {
            $10a1fdf426ed2330$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $10a1fdf426ed2330$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $10a1fdf426ed2330$var$_defineProperty(e, r, t) {
    return (r = $10a1fdf426ed2330$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $10a1fdf426ed2330$var$_toPropertyKey(t) {
    var i = $10a1fdf426ed2330$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $10a1fdf426ed2330$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $10a1fdf426ed2330$var$defaultConfig = {
    cacheSize: 2000,
    enableCache: true
};
var $10a1fdf426ed2330$var$currentConfig = $10a1fdf426ed2330$var$_objectSpread({}, $10a1fdf426ed2330$var$defaultConfig);
var $10a1fdf426ed2330$var$stringCache = new (0, $6e6d0c352076c825$export$182500e6725aad9a)($10a1fdf426ed2330$var$currentConfig.cacheSize);
var $10a1fdf426ed2330$var$SPAN_STYLE = {
    position: 'absolute',
    top: '-20000px',
    left: 0,
    padding: 0,
    margin: 0,
    border: 'none',
    whiteSpace: 'pre'
};
var $10a1fdf426ed2330$var$MEASUREMENT_SPAN_ID = 'recharts_measurement_span';
function $10a1fdf426ed2330$var$createCacheKey(text, style) {
    // Simple string concatenation for better performance than JSON.stringify
    var fontSize = style.fontSize || '';
    var fontFamily = style.fontFamily || '';
    var fontWeight = style.fontWeight || '';
    var fontStyle = style.fontStyle || '';
    var letterSpacing = style.letterSpacing || '';
    var textTransform = style.textTransform || '';
    return "".concat(text, "|").concat(fontSize, "|").concat(fontFamily, "|").concat(fontWeight, "|").concat(fontStyle, "|").concat(letterSpacing, "|").concat(textTransform);
}
/**
 * Measure text using DOM (accurate but slower)
 * @param text - The text to measure
 * @param style - CSS style properties to apply
 * @returns The size of the text
 */ var $10a1fdf426ed2330$var$measureTextWithDOM = (text, style)=>{
    try {
        var measurementSpan = document.getElementById($10a1fdf426ed2330$var$MEASUREMENT_SPAN_ID);
        if (!measurementSpan) {
            measurementSpan = document.createElement('span');
            measurementSpan.setAttribute('id', $10a1fdf426ed2330$var$MEASUREMENT_SPAN_ID);
            measurementSpan.setAttribute('aria-hidden', 'true');
            document.body.appendChild(measurementSpan);
        }
        // Apply styles directly without unnecessary object creation
        Object.assign(measurementSpan.style, $10a1fdf426ed2330$var$SPAN_STYLE, style);
        measurementSpan.textContent = "".concat(text);
        var rect = measurementSpan.getBoundingClientRect();
        return {
            width: rect.width,
            height: rect.height
        };
    } catch (_unused) {
        return {
            width: 0,
            height: 0
        };
    }
};
var $10a1fdf426ed2330$export$e5560531f057ad5d = function getStringSize(text) {
    var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (text === undefined || text === null || (0, $21ceeda12d85451c$export$98f03c5d19621d70).isSsr) return {
        width: 0,
        height: 0
    };
    // If caching is disabled, measure directly
    if (!$10a1fdf426ed2330$var$currentConfig.enableCache) return $10a1fdf426ed2330$var$measureTextWithDOM(text, style);
    var cacheKey = $10a1fdf426ed2330$var$createCacheKey(text, style);
    var cachedResult = $10a1fdf426ed2330$var$stringCache.get(cacheKey);
    if (cachedResult) return cachedResult;
    // Measure using DOM
    var result = $10a1fdf426ed2330$var$measureTextWithDOM(text, style);
    // Store in LRU cache
    $10a1fdf426ed2330$var$stringCache.set(cacheKey, result);
    return result;
};
var $10a1fdf426ed2330$export$24830ea431eb8e34 = (config)=>{
    var newConfig = $10a1fdf426ed2330$var$_objectSpread($10a1fdf426ed2330$var$_objectSpread({}, $10a1fdf426ed2330$var$currentConfig), config);
    if (newConfig.cacheSize !== $10a1fdf426ed2330$var$currentConfig.cacheSize) $10a1fdf426ed2330$var$stringCache = new (0, $6e6d0c352076c825$export$182500e6725aad9a)(newConfig.cacheSize);
    $10a1fdf426ed2330$var$currentConfig = newConfig;
};
var $10a1fdf426ed2330$export$1340d8ffb2cb9b2 = ()=>$10a1fdf426ed2330$var$_objectSpread({}, $10a1fdf426ed2330$var$currentConfig);
var $10a1fdf426ed2330$export$dbfda59986504510 = ()=>{
    $10a1fdf426ed2330$var$stringCache.clear();
};
var $10a1fdf426ed2330$export$5941b2b80425c12f = ()=>({
        size: $10a1fdf426ed2330$var$stringCache.size(),
        maxSize: $10a1fdf426ed2330$var$currentConfig.cacheSize
    });



var $f7d731bd41799df5$var$_DecimalCSS;
function $f7d731bd41799df5$var$_defineProperty(e, r, t) {
    return (r = $f7d731bd41799df5$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $f7d731bd41799df5$var$_toPropertyKey(t) {
    var i = $f7d731bd41799df5$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $f7d731bd41799df5$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $f7d731bd41799df5$var$MULTIPLY_OR_DIVIDE_REGEX = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([*/])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/;
var $f7d731bd41799df5$var$ADD_OR_SUBTRACT_REGEX = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([+-])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/;
var $f7d731bd41799df5$var$CSS_LENGTH_UNIT_REGEX = /^(px|cm|vh|vw|em|rem|%|mm|in|pt|pc|ex|ch|vmin|vmax|Q)$/;
var $f7d731bd41799df5$var$NUM_SPLIT_REGEX = /(-?\d+(?:\.\d+)?)([a-zA-Z%]+)?/;
var $f7d731bd41799df5$var$CONVERSION_RATES = {
    cm: 96 / 2.54,
    mm: 96 / 25.4,
    pt: 96 / 72,
    pc: 16,
    in: 96,
    Q: 96 / 101.6,
    px: 1
};
var $f7d731bd41799df5$var$FIXED_CSS_LENGTH_UNITS = [
    'cm',
    'mm',
    'pt',
    'pc',
    'in',
    'Q',
    'px'
];
function $f7d731bd41799df5$var$isSupportedUnit(unit) {
    return $f7d731bd41799df5$var$FIXED_CSS_LENGTH_UNITS.includes(unit);
}
var $f7d731bd41799df5$var$STR_NAN = 'NaN';
function $f7d731bd41799df5$var$convertToPx(value, unit) {
    return value * $f7d731bd41799df5$var$CONVERSION_RATES[unit];
}
class $f7d731bd41799df5$var$DecimalCSS {
    static parse(str) {
        var _NUM_SPLIT_REGEX$exec;
        var [, numStr, unit] = (_NUM_SPLIT_REGEX$exec = $f7d731bd41799df5$var$NUM_SPLIT_REGEX.exec(str)) !== null && _NUM_SPLIT_REGEX$exec !== void 0 ? _NUM_SPLIT_REGEX$exec : [];
        if (numStr == null) return $f7d731bd41799df5$var$DecimalCSS.NaN;
        return new $f7d731bd41799df5$var$DecimalCSS(parseFloat(numStr), unit !== null && unit !== void 0 ? unit : '');
    }
    constructor(num, unit){
        this.num = num;
        this.unit = unit;
        this.num = num;
        this.unit = unit;
        if ((0, $7e613228d3a31273$export$e426a261f3212d7d)(num)) this.unit = '';
        if (unit !== '' && !$f7d731bd41799df5$var$CSS_LENGTH_UNIT_REGEX.test(unit)) {
            this.num = NaN;
            this.unit = '';
        }
        if ($f7d731bd41799df5$var$isSupportedUnit(unit)) {
            this.num = $f7d731bd41799df5$var$convertToPx(num, unit);
            this.unit = 'px';
        }
    }
    add(other) {
        if (this.unit !== other.unit) return new $f7d731bd41799df5$var$DecimalCSS(NaN, '');
        return new $f7d731bd41799df5$var$DecimalCSS(this.num + other.num, this.unit);
    }
    subtract(other) {
        if (this.unit !== other.unit) return new $f7d731bd41799df5$var$DecimalCSS(NaN, '');
        return new $f7d731bd41799df5$var$DecimalCSS(this.num - other.num, this.unit);
    }
    multiply(other) {
        if (this.unit !== '' && other.unit !== '' && this.unit !== other.unit) return new $f7d731bd41799df5$var$DecimalCSS(NaN, '');
        return new $f7d731bd41799df5$var$DecimalCSS(this.num * other.num, this.unit || other.unit);
    }
    divide(other) {
        if (this.unit !== '' && other.unit !== '' && this.unit !== other.unit) return new $f7d731bd41799df5$var$DecimalCSS(NaN, '');
        return new $f7d731bd41799df5$var$DecimalCSS(this.num / other.num, this.unit || other.unit);
    }
    toString() {
        return "".concat(this.num).concat(this.unit);
    }
    isNaN() {
        return (0, $7e613228d3a31273$export$e426a261f3212d7d)(this.num);
    }
}
$f7d731bd41799df5$var$_DecimalCSS = $f7d731bd41799df5$var$DecimalCSS;
$f7d731bd41799df5$var$_defineProperty($f7d731bd41799df5$var$DecimalCSS, "NaN", new $f7d731bd41799df5$var$_DecimalCSS(NaN, ''));
function $f7d731bd41799df5$var$calculateArithmetic(expr) {
    if (expr == null || expr.includes($f7d731bd41799df5$var$STR_NAN)) return $f7d731bd41799df5$var$STR_NAN;
    var newExpr = expr;
    while(newExpr.includes('*') || newExpr.includes('/')){
        var _MULTIPLY_OR_DIVIDE_R;
        var [, leftOperand, operator, rightOperand] = (_MULTIPLY_OR_DIVIDE_R = $f7d731bd41799df5$var$MULTIPLY_OR_DIVIDE_REGEX.exec(newExpr)) !== null && _MULTIPLY_OR_DIVIDE_R !== void 0 ? _MULTIPLY_OR_DIVIDE_R : [];
        var lTs = $f7d731bd41799df5$var$DecimalCSS.parse(leftOperand !== null && leftOperand !== void 0 ? leftOperand : '');
        var rTs = $f7d731bd41799df5$var$DecimalCSS.parse(rightOperand !== null && rightOperand !== void 0 ? rightOperand : '');
        var result = operator === '*' ? lTs.multiply(rTs) : lTs.divide(rTs);
        if (result.isNaN()) return $f7d731bd41799df5$var$STR_NAN;
        newExpr = newExpr.replace($f7d731bd41799df5$var$MULTIPLY_OR_DIVIDE_REGEX, result.toString());
    }
    while(newExpr.includes('+') || /.-\d+(?:\.\d+)?/.test(newExpr)){
        var _ADD_OR_SUBTRACT_REGE;
        var [, _leftOperand, _operator, _rightOperand] = (_ADD_OR_SUBTRACT_REGE = $f7d731bd41799df5$var$ADD_OR_SUBTRACT_REGEX.exec(newExpr)) !== null && _ADD_OR_SUBTRACT_REGE !== void 0 ? _ADD_OR_SUBTRACT_REGE : [];
        var _lTs = $f7d731bd41799df5$var$DecimalCSS.parse(_leftOperand !== null && _leftOperand !== void 0 ? _leftOperand : '');
        var _rTs = $f7d731bd41799df5$var$DecimalCSS.parse(_rightOperand !== null && _rightOperand !== void 0 ? _rightOperand : '');
        var _result = _operator === '+' ? _lTs.add(_rTs) : _lTs.subtract(_rTs);
        if (_result.isNaN()) return $f7d731bd41799df5$var$STR_NAN;
        newExpr = newExpr.replace($f7d731bd41799df5$var$ADD_OR_SUBTRACT_REGEX, _result.toString());
    }
    return newExpr;
}
var $f7d731bd41799df5$var$PARENTHESES_REGEX = /\(([^()]*)\)/;
function $f7d731bd41799df5$var$calculateParentheses(expr) {
    var newExpr = expr;
    var match;
    // eslint-disable-next-line no-cond-assign
    while((match = $f7d731bd41799df5$var$PARENTHESES_REGEX.exec(newExpr)) != null){
        var [, parentheticalExpression] = match;
        newExpr = newExpr.replace($f7d731bd41799df5$var$PARENTHESES_REGEX, $f7d731bd41799df5$var$calculateArithmetic(parentheticalExpression));
    }
    return newExpr;
}
function $f7d731bd41799df5$var$evaluateExpression(expression) {
    var newExpr = expression.replace(/\s+/g, '');
    newExpr = $f7d731bd41799df5$var$calculateParentheses(newExpr);
    newExpr = $f7d731bd41799df5$var$calculateArithmetic(newExpr);
    return newExpr;
}
function $f7d731bd41799df5$export$c891f73c9c6d00c9(expression) {
    try {
        return $f7d731bd41799df5$var$evaluateExpression(expression);
    } catch (_unused) {
        return $f7d731bd41799df5$var$STR_NAN;
    }
}
function $f7d731bd41799df5$export$254eac204f89fd7d(expression) {
    var result = $f7d731bd41799df5$export$c891f73c9c6d00c9(expression.slice(5, -1));
    if (result === $f7d731bd41799df5$var$STR_NAN) return '';
    return result;
}



function $4cc2299923ef69c7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4cc2299923ef69c7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4cc2299923ef69c7$var$ownKeys(Object(t), !0).forEach(function(r) {
            $4cc2299923ef69c7$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4cc2299923ef69c7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $4cc2299923ef69c7$var$_defineProperty(e, r, t) {
    return (r = $4cc2299923ef69c7$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $4cc2299923ef69c7$var$_toPropertyKey(t) {
    var i = $4cc2299923ef69c7$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $4cc2299923ef69c7$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $4cc2299923ef69c7$export$45004cc70a390ee8(realProps, defaultProps) {
    /*
   * To avoid mutating the original `realProps` object passed to the function, create a shallow copy of it.
   * `resolvedProps` will be modified directly with the defaults.
   */ var resolvedProps = $4cc2299923ef69c7$var$_objectSpread({}, realProps);
    /*
   * Since the function guarantees `D extends Partial<T>`, this assignment is safe.
   * It allows TypeScript to work with the well-defined `Partial<T>` type inside the loop,
   * making subsequent type inference (especially for `dp[key]`) much more straightforward for the compiler.
   * This is a key step to improve type safety *without* value assertions later.
   */ var dp = defaultProps;
    /*
   * `Object.keys` doesn't preserve strong key types - it always returns Array<string>.
   * However, due to the `D extends Partial<T>` constraint,
   * we know these keys *must* also be valid keys of `T`.
   * This assertion informs TypeScript of this relationship, avoiding type errors when using `key` to index `acc` (type T).
   *
   * Type assertions are not sound but in this case it's necessary
   * as `Object.keys` does not do what we want it to do.
   */ var keys = Object.keys(defaultProps);
    var withDefaults = keys.reduce((acc, key)=>{
        if (acc[key] === undefined && dp[key] !== undefined) acc[key] = dp[key];
        return acc;
    }, resolvedProps);
    /*
   * And again type assertions are not safe but here we have done the runtime work
   * so let's bypass the lack of static type safety and tell the compiler what happened.
   */ return withDefaults;
} /**
 * Helper type to extract the keys of T that are required.
 * It iterates through each key K in T. If Pick<T, K> cannot be assigned an empty object {},
 * it means K is required, so we keep K; otherwise, we discard it (never).
 * [keyof T] at the end creates a union of the kept keys.
 */  /**
 * Helper type to extract the keys of T that are optional.
 * It iterates through each key K in T. If Pick<T, K> can be assigned an empty object {},
 * it means K is optional (or potentially missing), so we keep K; otherwise, we discard it (never).
 * [keyof T] at the end creates a union of the kept keys.
 */  /**
 * Helper type to ensure keys of D exist in T.
 * For each key K in D, if K is also a key of T, keep the type D[K].
 * If K is NOT a key of T, map it to type `never`.
 * An object cannot have a property of type `never`, effectively disallowing extra keys.
 */  /**
 * This type will take a source type `Props` and a default type `Defaults` and will return a new type
 * where all properties that are optional in `Props` but required in `Defaults` are made required in the result.
 * Properties that are required in `Props` and optional in `Defaults` will remain required.
 * Properties that are optional in both `Props` and `Defaults` will remain optional.
 *
 * This is useful for creating a type that represents the resolved props of a component with default props.
 */ 


function $22869ac8a5888437$export$f8a8fc612ced9bb0(n) {
    return Number.isFinite(n);
}
function $22869ac8a5888437$export$5374bb854d0e41c8(n) {
    return typeof n === 'number' && n > 0 && Number.isFinite(n);
}


var $0f46b46b80ac2f75$var$_excluded = [
    "x",
    "y",
    "lineHeight",
    "capHeight",
    "fill",
    "scaleToFit",
    "textAnchor",
    "verticalAnchor"
], $0f46b46b80ac2f75$var$_excluded2 = [
    "dx",
    "dy",
    "angle",
    "className",
    "breakAll"
];
function $0f46b46b80ac2f75$var$_extends() {
    return $0f46b46b80ac2f75$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $0f46b46b80ac2f75$var$_extends.apply(null, arguments);
}
function $0f46b46b80ac2f75$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $0f46b46b80ac2f75$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $0f46b46b80ac2f75$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $0f46b46b80ac2f75$var$BREAKING_SPACES = /[ \f\n\r\t\v\u2028\u2029]+/;
var $0f46b46b80ac2f75$var$calculateWordWidths = (_ref)=>{
    var { children: children, breakAll: breakAll, style: style } = _ref;
    try {
        var words = [];
        if (!(0, $7e613228d3a31273$export$b931b78cbb3caf86)(children)) {
            if (breakAll) words = children.toString().split('');
            else words = children.toString().split($0f46b46b80ac2f75$var$BREAKING_SPACES);
        }
        var wordsWithComputedWidth = words.map((word)=>({
                word: word,
                width: (0, $10a1fdf426ed2330$export$e5560531f057ad5d)(word, style).width
            }));
        var spaceWidth = breakAll ? 0 : (0, $10a1fdf426ed2330$export$e5560531f057ad5d)('\u00A0', style).width;
        return {
            wordsWithComputedWidth: wordsWithComputedWidth,
            spaceWidth: spaceWidth
        };
    } catch (_unused) {
        return null;
    }
};
function $0f46b46b80ac2f75$export$ae5e6c08954aa63c(value) {
    return value === 'start' || value === 'middle' || value === 'end' || value === 'inherit';
}
function $0f46b46b80ac2f75$export$16c73a52b3ef3edd(val) {
    return (0, $7e613228d3a31273$export$b931b78cbb3caf86)(val) || typeof val === 'string' || typeof val === 'number' || typeof val === 'boolean';
}
var $0f46b46b80ac2f75$var$calculate = (words, lineWidth, spaceWidth, scaleToFit)=>words.reduce((result, _ref2)=>{
        var { word: word, width: width } = _ref2;
        var currentLine = result[result.length - 1];
        if (currentLine && width != null && (lineWidth == null || scaleToFit || currentLine.width + width + spaceWidth < Number(lineWidth))) {
            // Word can be added to an existing line
            currentLine.words.push(word);
            currentLine.width += width + spaceWidth;
        } else {
            // Add first word to line or word is too long to scaleToFit on existing line
            var newLine = {
                words: [
                    word
                ],
                width: width
            };
            result.push(newLine);
        }
        return result;
    }, []);
var $0f46b46b80ac2f75$var$findLongestLine = (words)=>words.reduce((a, b)=>a.width > b.width ? a : b);
var $0f46b46b80ac2f75$var$suffix = "\u2026";
var $0f46b46b80ac2f75$var$checkOverflow = (text, index, breakAll, style, maxLines, lineWidth, spaceWidth, scaleToFit)=>{
    var tempText = text.slice(0, index);
    var words = $0f46b46b80ac2f75$var$calculateWordWidths({
        breakAll: breakAll,
        style: style,
        children: tempText + $0f46b46b80ac2f75$var$suffix
    });
    if (!words) return [
        false,
        []
    ];
    var result = $0f46b46b80ac2f75$var$calculate(words.wordsWithComputedWidth, lineWidth, spaceWidth, scaleToFit);
    var doesOverflow = result.length > maxLines || $0f46b46b80ac2f75$var$findLongestLine(result).width > Number(lineWidth);
    return [
        doesOverflow,
        result
    ];
};
var $0f46b46b80ac2f75$var$calculateWordsByLines = (_ref3, initialWordsWithComputedWith, spaceWidth, lineWidth, scaleToFit)=>{
    var { maxLines: maxLines, children: children, style: style, breakAll: breakAll } = _ref3;
    var shouldLimitLines = (0, $7e613228d3a31273$export$7e4aa119212bc614)(maxLines);
    var text = String(children);
    var originalResult = $0f46b46b80ac2f75$var$calculate(initialWordsWithComputedWith, lineWidth, spaceWidth, scaleToFit);
    if (!shouldLimitLines || scaleToFit) return originalResult;
    var overflows = originalResult.length > maxLines || $0f46b46b80ac2f75$var$findLongestLine(originalResult).width > Number(lineWidth);
    if (!overflows) return originalResult;
    var start = 0;
    var end = text.length - 1;
    var iterations = 0;
    var trimmedResult;
    while(start <= end && iterations <= text.length - 1){
        var middle = Math.floor((start + end) / 2);
        var prev = middle - 1;
        var [doesPrevOverflow, result] = $0f46b46b80ac2f75$var$checkOverflow(text, prev, breakAll, style, maxLines, lineWidth, spaceWidth, scaleToFit);
        var [doesMiddleOverflow] = $0f46b46b80ac2f75$var$checkOverflow(text, middle, breakAll, style, maxLines, lineWidth, spaceWidth, scaleToFit);
        if (!doesPrevOverflow && !doesMiddleOverflow) start = middle + 1;
        if (doesPrevOverflow && doesMiddleOverflow) end = middle - 1;
        if (!doesPrevOverflow && doesMiddleOverflow) {
            trimmedResult = result;
            break;
        }
        iterations++;
    }
    // Fallback to originalResult (result without trimming) if we cannot find the
    // where to trim.  This should not happen :tm:
    return trimmedResult || originalResult;
};
var $0f46b46b80ac2f75$var$getWordsWithoutCalculate = (children)=>{
    var words = !(0, $7e613228d3a31273$export$b931b78cbb3caf86)(children) ? children.toString().split($0f46b46b80ac2f75$var$BREAKING_SPACES) : [];
    return [
        {
            words: words,
            width: undefined
        }
    ];
};
var $0f46b46b80ac2f75$export$86ba3bfd091ebe4f = (_ref4)=>{
    var { width: width, scaleToFit: scaleToFit, children: children, style: style, breakAll: breakAll, maxLines: maxLines } = _ref4;
    // Only perform calculations if using features that require them (multiline, scaleToFit)
    if ((width || scaleToFit) && !(0, $21ceeda12d85451c$export$98f03c5d19621d70).isSsr) {
        var wordsWithComputedWidth, spaceWidth;
        var wordWidths = $0f46b46b80ac2f75$var$calculateWordWidths({
            breakAll: breakAll,
            children: children,
            style: style
        });
        if (wordWidths) {
            var { wordsWithComputedWidth: wcw, spaceWidth: sw } = wordWidths;
            wordsWithComputedWidth = wcw;
            spaceWidth = sw;
        } else return $0f46b46b80ac2f75$var$getWordsWithoutCalculate(children);
        return $0f46b46b80ac2f75$var$calculateWordsByLines({
            breakAll: breakAll,
            children: children,
            maxLines: maxLines,
            style: style
        }, wordsWithComputedWidth, spaceWidth, width, Boolean(scaleToFit));
    }
    return $0f46b46b80ac2f75$var$getWordsWithoutCalculate(children);
};
var $0f46b46b80ac2f75$var$DEFAULT_FILL = '#808080';
var $0f46b46b80ac2f75$export$beb103ac5cf1498b = {
    angle: 0,
    breakAll: false,
    // Magic number from d3
    capHeight: '0.71em',
    fill: $0f46b46b80ac2f75$var$DEFAULT_FILL,
    lineHeight: '1em',
    scaleToFit: false,
    textAnchor: 'start',
    // Maintain compat with existing charts / default SVG behavior
    verticalAnchor: 'end',
    x: 0,
    y: 0
};
var $0f46b46b80ac2f75$export$5f1af8db9871e1d6 = /*#__PURE__*/ (0, $kc00y.forwardRef)((outsideProps, ref)=>{
    var _resolveDefaultProps = (0, $4cc2299923ef69c7$export$45004cc70a390ee8)(outsideProps, $0f46b46b80ac2f75$export$beb103ac5cf1498b), { x: propsX, y: propsY, lineHeight: lineHeight, capHeight: capHeight, fill: fill, scaleToFit: scaleToFit, textAnchor: textAnchor, verticalAnchor: verticalAnchor } = _resolveDefaultProps, props = $0f46b46b80ac2f75$var$_objectWithoutProperties(_resolveDefaultProps, $0f46b46b80ac2f75$var$_excluded);
    var wordsByLines = (0, $kc00y.useMemo)(()=>{
        return $0f46b46b80ac2f75$export$86ba3bfd091ebe4f({
            breakAll: props.breakAll,
            children: props.children,
            maxLines: props.maxLines,
            scaleToFit: scaleToFit,
            style: props.style,
            width: props.width
        });
    }, [
        props.breakAll,
        props.children,
        props.maxLines,
        scaleToFit,
        props.style,
        props.width
    ]);
    var { dx: dx, dy: dy, angle: angle, className: className, breakAll: breakAll } = props, textProps = $0f46b46b80ac2f75$var$_objectWithoutProperties(props, $0f46b46b80ac2f75$var$_excluded2);
    if (!(0, $7e613228d3a31273$export$402a499e1ea44294)(propsX) || !(0, $7e613228d3a31273$export$402a499e1ea44294)(propsY) || wordsByLines.length === 0) return null;
    var x = Number(propsX) + ((0, $7e613228d3a31273$export$7e4aa119212bc614)(dx) ? dx : 0);
    var y = Number(propsY) + ((0, $7e613228d3a31273$export$7e4aa119212bc614)(dy) ? dy : 0);
    if (!(0, $22869ac8a5888437$export$f8a8fc612ced9bb0)(x) || !(0, $22869ac8a5888437$export$f8a8fc612ced9bb0)(y)) return null;
    var startDy;
    switch(verticalAnchor){
        case 'start':
            startDy = (0, $f7d731bd41799df5$export$254eac204f89fd7d)("calc(".concat(capHeight, ")"));
            break;
        case 'middle':
            startDy = (0, $f7d731bd41799df5$export$254eac204f89fd7d)("calc(".concat((wordsByLines.length - 1) / 2, " * -").concat(lineHeight, " + (").concat(capHeight, " / 2))"));
            break;
        default:
            startDy = (0, $f7d731bd41799df5$export$254eac204f89fd7d)("calc(".concat(wordsByLines.length - 1, " * -").concat(lineHeight, ")"));
            break;
    }
    var transforms = [];
    var firstLine = wordsByLines[0];
    if (scaleToFit && firstLine != null) {
        var lineWidth = firstLine.width;
        var { width: width } = props;
        transforms.push("scale(".concat((0, $7e613228d3a31273$export$7e4aa119212bc614)(width) && (0, $7e613228d3a31273$export$7e4aa119212bc614)(lineWidth) ? width / lineWidth : 1, ")"));
    }
    if (angle) transforms.push("rotate(".concat(angle, ", ").concat(x, ", ").concat(y, ")"));
    if (transforms.length) textProps.transform = transforms.join(' ');
    return /*#__PURE__*/ $kc00y.createElement("text", $0f46b46b80ac2f75$var$_extends({}, (0, $976509d5bd74ee3b$export$67f8fc03e57e2747)(textProps), {
        ref: ref,
        x: x,
        y: y,
        className: (0, $328c1c2632e2f292$export$4f5d2d50c9deca37)('recharts-text', className),
        textAnchor: textAnchor,
        fill: fill.includes('url') ? $0f46b46b80ac2f75$var$DEFAULT_FILL : fill
    }), wordsByLines.map((line, index)=>{
        var words = line.words.join(breakAll ? '' : ' ');
        return(/*#__PURE__*/ // duplicate words will cause duplicate keys which is why we add the array index here
        $kc00y.createElement("tspan", {
            x: x,
            dy: index === 0 ? startDy : lineHeight,
            key: "".concat(words, "-").concat(index)
        }, words));
    }));
});
$0f46b46b80ac2f75$export$5f1af8db9871e1d6.displayName = 'Text';



function $68befda7de8b3621$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $68befda7de8b3621$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $68befda7de8b3621$var$ownKeys(Object(t), !0).forEach(function(r) {
            $68befda7de8b3621$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $68befda7de8b3621$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $68befda7de8b3621$var$_defineProperty(e, r, t) {
    return (r = $68befda7de8b3621$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $68befda7de8b3621$var$_toPropertyKey(t) {
    var i = $68befda7de8b3621$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $68befda7de8b3621$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $68befda7de8b3621$export$d74e8f7e9cc3fed3 = Math.PI / 180;
var $68befda7de8b3621$export$4f2c4f194778dcbb = (angle)=>angle * Math.PI / 180;
var $68befda7de8b3621$export$1c20e104e3e29a0a = (angleInRadian)=>angleInRadian * 180 / Math.PI;
var $68befda7de8b3621$export$5c9a959bb3fc7749 = (cx, cy, radius, angle)=>({
        x: cx + Math.cos(-$68befda7de8b3621$export$d74e8f7e9cc3fed3 * angle) * radius,
        y: cy + Math.sin(-$68befda7de8b3621$export$d74e8f7e9cc3fed3 * angle) * radius
    });
var $68befda7de8b3621$export$ad5c48602371adfa = function getMaxRadius(width, height) {
    var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        width: 0,
        height: 0,
        brushBottom: 0
    };
    return Math.min(Math.abs(width - (offset.left || 0) - (offset.right || 0)), Math.abs(height - (offset.top || 0) - (offset.bottom || 0))) / 2;
};
var $68befda7de8b3621$var$distanceBetweenPoints = (point, anotherPoint)=>{
    var { x: x1, y: y1 } = point;
    var { x: x2, y: y2 } = anotherPoint;
    return Math.sqrt((x1 - x2) ** 2 + (y1 - y2) ** 2);
};
var $68befda7de8b3621$var$getAngleOfPoint = (_ref, _ref2)=>{
    var { x: x, y: y } = _ref;
    var { cx: cx, cy: cy } = _ref2;
    var radius = $68befda7de8b3621$var$distanceBetweenPoints({
        x: x,
        y: y
    }, {
        x: cx,
        y: cy
    });
    if (radius <= 0) return {
        radius: radius,
        angle: 0
    };
    var cos = (x - cx) / radius;
    var angleInRadian = Math.acos(cos);
    if (y > cy) angleInRadian = 2 * Math.PI - angleInRadian;
    return {
        radius: radius,
        angle: $68befda7de8b3621$export$1c20e104e3e29a0a(angleInRadian),
        angleInRadian: angleInRadian
    };
};
var $68befda7de8b3621$var$formatAngleOfSector = (_ref3)=>{
    var { startAngle: startAngle, endAngle: endAngle } = _ref3;
    var startCnt = Math.floor(startAngle / 360);
    var endCnt = Math.floor(endAngle / 360);
    var min = Math.min(startCnt, endCnt);
    return {
        startAngle: startAngle - min * 360,
        endAngle: endAngle - min * 360
    };
};
var $68befda7de8b3621$var$reverseFormatAngleOfSector = (angle, _ref4)=>{
    var { startAngle: startAngle, endAngle: endAngle } = _ref4;
    var startCnt = Math.floor(startAngle / 360);
    var endCnt = Math.floor(endAngle / 360);
    var min = Math.min(startCnt, endCnt);
    return angle + min * 360;
};
var $68befda7de8b3621$export$e85a2bf8cd31c504 = (_ref5, viewBox)=>{
    var { relativeX: x, relativeY: y } = _ref5;
    var { radius: radius, angle: angle } = $68befda7de8b3621$var$getAngleOfPoint({
        x: x,
        y: y
    }, viewBox);
    var { innerRadius: innerRadius, outerRadius: outerRadius } = viewBox;
    if (radius < innerRadius || radius > outerRadius) return null;
    if (radius === 0) return null;
    var { startAngle: startAngle, endAngle: endAngle } = $68befda7de8b3621$var$formatAngleOfSector(viewBox);
    var formatAngle = angle;
    var inRange;
    if (startAngle <= endAngle) {
        while(formatAngle > endAngle)formatAngle -= 360;
        while(formatAngle < startAngle)formatAngle += 360;
        inRange = formatAngle >= startAngle && formatAngle <= endAngle;
    } else {
        while(formatAngle > startAngle)formatAngle -= 360;
        while(formatAngle < endAngle)formatAngle += 360;
        inRange = formatAngle >= endAngle && formatAngle <= startAngle;
    }
    if (inRange) return $68befda7de8b3621$var$_objectSpread($68befda7de8b3621$var$_objectSpread({}, viewBox), {}, {
        radius: radius,
        angle: $68befda7de8b3621$var$reverseFormatAngleOfSector(formatAngle, viewBox)
    });
    return null;
};



var $kc00y = parcelRequire("kc00y");
var $d67286c377b4aa8a$exports = {};
'use strict';

$d67286c377b4aa8a$exports = (parcelRequire("iKKQu"));



var $kc00y = parcelRequire("kc00y");

var $kc00y = parcelRequire("kc00y");
var $bf89e112b0848c51$export$876ef70bc88b13cb = /*#__PURE__*/ (0, $kc00y.createContext)(null);


var $a441e801d1b41b52$var$noopDispatch = (a)=>a;
var $a441e801d1b41b52$export$f51d452c10d5b956 = ()=>{
    var context = (0, $kc00y.useContext)((0, $bf89e112b0848c51$export$876ef70bc88b13cb));
    if (context) return context.store.dispatch;
    return $a441e801d1b41b52$var$noopDispatch;
};
var $a441e801d1b41b52$var$noop = ()=>{};
var $a441e801d1b41b52$var$addNestedSubNoop = ()=>$a441e801d1b41b52$var$noop;
var $a441e801d1b41b52$var$refEquality = (a, b)=>a === b;
function $a441e801d1b41b52$export$a7347740d65f620b(selector) {
    var context = (0, $kc00y.useContext)((0, $bf89e112b0848c51$export$876ef70bc88b13cb));
    var outOfContextSelector = (0, $kc00y.useMemo)(()=>{
        if (!context) return $a441e801d1b41b52$var$noop;
        return (state)=>{
            if (state == null) return undefined;
            return selector(state);
        };
    }, [
        context,
        selector
    ]);
    return (0, $d67286c377b4aa8a$exports.useSyncExternalStoreWithSelector)(context ? context.subscription.addNestedSub : $a441e801d1b41b52$var$addNestedSubNoop, context ? context.store.getState : $a441e801d1b41b52$var$noop, context ? context.store.getState : $a441e801d1b41b52$var$noop, outOfContextSelector, $a441e801d1b41b52$var$refEquality);
}


// src/index.ts
// src/utils/formatProdErrorMessage.ts
function $6c2d3c9c387cb6cd$var$formatProdErrorMessage(code) {
    return `Minified Redux error #${code}; visit https://redux.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}
// src/utils/symbol-observable.ts
var $6c2d3c9c387cb6cd$var$$$observable = /* @__PURE__ */ (()=>typeof Symbol === "function" && Symbol.observable || "@@observable")();
var $6c2d3c9c387cb6cd$var$symbol_observable_default = $6c2d3c9c387cb6cd$var$$$observable;
// src/utils/actionTypes.ts
var $6c2d3c9c387cb6cd$var$randomString = ()=>Math.random().toString(36).substring(7).split("").join(".");
var $6c2d3c9c387cb6cd$var$ActionTypes = {
    INIT: `@@redux/INIT${$6c2d3c9c387cb6cd$var$randomString()}`,
    REPLACE: `@@redux/REPLACE${$6c2d3c9c387cb6cd$var$randomString()}`,
    PROBE_UNKNOWN_ACTION: ()=>`@@redux/PROBE_UNKNOWN_ACTION${$6c2d3c9c387cb6cd$var$randomString()}`
};
var $6c2d3c9c387cb6cd$export$4219e499db7ca678 = $6c2d3c9c387cb6cd$var$ActionTypes;
// src/utils/isPlainObject.ts
function $6c2d3c9c387cb6cd$export$53b83ca8eaab0383(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null;
}
// src/utils/kindOf.ts
function $6c2d3c9c387cb6cd$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    const type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($6c2d3c9c387cb6cd$var$isDate(val)) return "date";
    if ($6c2d3c9c387cb6cd$var$isError(val)) return "error";
    const constructorName = $6c2d3c9c387cb6cd$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    }
    return Object.prototype.toString.call(val).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $6c2d3c9c387cb6cd$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $6c2d3c9c387cb6cd$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $6c2d3c9c387cb6cd$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $6c2d3c9c387cb6cd$var$kindOf(val) {
    let typeOfVal = typeof val;
    return typeOfVal;
}
// src/createStore.ts
function $6c2d3c9c387cb6cd$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    if (typeof reducer !== "function") throw new Error($6c2d3c9c387cb6cd$var$formatProdErrorMessage(2));
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($6c2d3c9c387cb6cd$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = void 0;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($6c2d3c9c387cb6cd$var$formatProdErrorMessage(1));
        return enhancer($6c2d3c9c387cb6cd$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    let currentReducer = reducer;
    let currentState = preloadedState;
    let currentListeners = /* @__PURE__ */ new Map();
    let nextListeners = currentListeners;
    let listenerIdCounter = 0;
    let isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) {
            nextListeners = /* @__PURE__ */ new Map();
            currentListeners.forEach((listener, key)=>{
                nextListeners.set(key, listener);
            });
        }
    }
    function getState() {
        if (isDispatching) throw new Error($6c2d3c9c387cb6cd$var$formatProdErrorMessage(3));
        return currentState;
    }
    function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($6c2d3c9c387cb6cd$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($6c2d3c9c387cb6cd$var$formatProdErrorMessage(5));
        let isSubscribed = true;
        ensureCanMutateNextListeners();
        const listenerId = listenerIdCounter++;
        nextListeners.set(listenerId, listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($6c2d3c9c387cb6cd$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            nextListeners.delete(listenerId);
            currentListeners = null;
        };
    }
    function dispatch(action) {
        if (!$6c2d3c9c387cb6cd$export$53b83ca8eaab0383(action)) throw new Error($6c2d3c9c387cb6cd$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($6c2d3c9c387cb6cd$var$formatProdErrorMessage(8));
        if (typeof action.type !== "string") throw new Error($6c2d3c9c387cb6cd$var$formatProdErrorMessage(17));
        if (isDispatching) throw new Error($6c2d3c9c387cb6cd$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        const listeners = currentListeners = nextListeners;
        listeners.forEach((listener)=>{
            listener();
        });
        return action;
    }
    function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($6c2d3c9c387cb6cd$var$formatProdErrorMessage(10));
        currentReducer = nextReducer;
        dispatch({
            type: $6c2d3c9c387cb6cd$export$4219e499db7ca678.REPLACE
        });
    }
    function observable() {
        const outerSubscribe = subscribe;
        return {
            /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe (observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($6c2d3c9c387cb6cd$var$formatProdErrorMessage(11));
                function observeState() {
                    const observerAsObserver = observer;
                    if (observerAsObserver.next) observerAsObserver.next(getState());
                }
                observeState();
                const unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            },
            [$6c2d3c9c387cb6cd$var$symbol_observable_default] () {
                return this;
            }
        };
    }
    dispatch({
        type: $6c2d3c9c387cb6cd$export$4219e499db7ca678.INIT
    });
    const store = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer,
        [$6c2d3c9c387cb6cd$var$symbol_observable_default]: observable
    };
    return store;
}
function $6c2d3c9c387cb6cd$export$8928921ea2d3b126(reducer, preloadedState, enhancer) {
    return $6c2d3c9c387cb6cd$export$f51a9068ac82ea43(reducer, preloadedState, enhancer);
}
// src/utils/warning.ts
function $6c2d3c9c387cb6cd$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/combineReducers.ts
function $6c2d3c9c387cb6cd$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    const reducerKeys = Object.keys(reducers);
    const argumentName = action && action.type === $6c2d3c9c387cb6cd$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$6c2d3c9c387cb6cd$export$53b83ca8eaab0383(inputState)) return `The ${argumentName} has unexpected type of "${$6c2d3c9c387cb6cd$var$kindOf(inputState)}". Expected argument to be an object with the following keys: "${reducerKeys.join('", "')}"`;
    const unexpectedKeys = Object.keys(inputState).filter((key)=>!reducers.hasOwnProperty(key) && !unexpectedKeyCache[key]);
    unexpectedKeys.forEach((key)=>{
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $6c2d3c9c387cb6cd$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return `Unexpected ${unexpectedKeys.length > 1 ? "keys" : "key"} "${unexpectedKeys.join('", "')}" found in ${argumentName}. Expected to find one of the known reducer keys instead: "${reducerKeys.join('", "')}". Unexpected keys will be ignored.`;
}
function $6c2d3c9c387cb6cd$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach((key)=>{
        const reducer = reducers[key];
        const initialState = reducer(void 0, {
            type: $6c2d3c9c387cb6cd$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($6c2d3c9c387cb6cd$var$formatProdErrorMessage(12));
        if (typeof reducer(void 0, {
            type: $6c2d3c9c387cb6cd$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($6c2d3c9c387cb6cd$var$formatProdErrorMessage(13));
    });
}
function $6c2d3c9c387cb6cd$export$66e4520cdb265d18(reducers) {
    const reducerKeys = Object.keys(reducers);
    const finalReducers = {};
    for(let i = 0; i < reducerKeys.length; i++){
        const key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    const finalReducerKeys = Object.keys(finalReducers);
    let unexpectedKeyCache;
    let shapeAssertionError;
    try {
        $6c2d3c9c387cb6cd$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state = {}, action) {
        if (shapeAssertionError) throw shapeAssertionError;
        let hasChanged = false;
        const nextState = {};
        for(let i = 0; i < finalReducerKeys.length; i++){
            const key = finalReducerKeys[i];
            const reducer = finalReducers[key];
            const previousStateForKey = state[key];
            const nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                const actionType = action && action.type;
                throw new Error($6c2d3c9c387cb6cd$var$formatProdErrorMessage(14));
            }
            nextState[key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
// src/bindActionCreators.ts
function $6c2d3c9c387cb6cd$var$bindActionCreator(actionCreator, dispatch) {
    return function(...args) {
        return dispatch(actionCreator.apply(this, args));
    };
}
function $6c2d3c9c387cb6cd$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $6c2d3c9c387cb6cd$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($6c2d3c9c387cb6cd$var$formatProdErrorMessage(16));
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $6c2d3c9c387cb6cd$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
// src/compose.ts
function $6c2d3c9c387cb6cd$export$f672e0b6f7222cd7(...funcs) {
    if (funcs.length === 0) return (arg)=>arg;
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce((a, b)=>(...args)=>a(b(...args)));
}
// src/applyMiddleware.ts
function $6c2d3c9c387cb6cd$export$9ff26e0402cc7b7(...middlewares) {
    return (createStore2)=>(reducer, preloadedState)=>{
            const store = createStore2(reducer, preloadedState);
            let dispatch = ()=>{
                throw new Error($6c2d3c9c387cb6cd$var$formatProdErrorMessage(15));
            };
            const middlewareAPI = {
                getState: store.getState,
                dispatch: (action, ...args)=>dispatch(action, ...args)
            };
            const chain = middlewares.map((middleware)=>middleware(middlewareAPI));
            dispatch = $6c2d3c9c387cb6cd$export$f672e0b6f7222cd7(...chain)(store.dispatch);
            return {
                ...store,
                dispatch: dispatch
            };
        };
}
// src/utils/isAction.ts
function $6c2d3c9c387cb6cd$export$b956e38827fca970(action) {
    return $6c2d3c9c387cb6cd$export$53b83ca8eaab0383(action) && "type" in action && typeof action.type === "string";
}


// src/utils/env.ts
var $e922645e3176d997$export$45b790e32b2810ee = Symbol.for("immer-nothing");
var $e922645e3176d997$export$6ee2082928bcb0ee = Symbol.for("immer-draftable");
var $e922645e3176d997$var$DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var $e922645e3176d997$var$errors = [];
function $e922645e3176d997$var$die(error, ...args) {
    throw new Error(`[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`);
}
// src/utils/common.ts
var $e922645e3176d997$var$O = Object;
var $e922645e3176d997$var$getPrototypeOf = $e922645e3176d997$var$O.getPrototypeOf;
var $e922645e3176d997$var$CONSTRUCTOR = "constructor";
var $e922645e3176d997$var$PROTOTYPE = "prototype";
var $e922645e3176d997$var$CONFIGURABLE = "configurable";
var $e922645e3176d997$var$ENUMERABLE = "enumerable";
var $e922645e3176d997$var$WRITABLE = "writable";
var $e922645e3176d997$var$VALUE = "value";
var $e922645e3176d997$export$541ac630993a4c84 = (value)=>!!value && !!value[$e922645e3176d997$var$DRAFT_STATE];
function $e922645e3176d997$export$16e3aed3edb85946(value) {
    if (!value) return false;
    return $e922645e3176d997$var$isPlainObject(value) || $e922645e3176d997$var$isArray(value) || !!value[$e922645e3176d997$export$6ee2082928bcb0ee] || !!value[$e922645e3176d997$var$CONSTRUCTOR]?.[$e922645e3176d997$export$6ee2082928bcb0ee] || $e922645e3176d997$var$isMap(value) || $e922645e3176d997$var$isSet(value);
}
var $e922645e3176d997$var$objectCtorString = $e922645e3176d997$var$O[$e922645e3176d997$var$PROTOTYPE][$e922645e3176d997$var$CONSTRUCTOR].toString();
var $e922645e3176d997$var$cachedCtorStrings = /* @__PURE__ */ new WeakMap();
function $e922645e3176d997$var$isPlainObject(value) {
    if (!value || !$e922645e3176d997$var$isObjectish(value)) return false;
    const proto = $e922645e3176d997$var$getPrototypeOf(value);
    if (proto === null || proto === $e922645e3176d997$var$O[$e922645e3176d997$var$PROTOTYPE]) return true;
    const Ctor = $e922645e3176d997$var$O.hasOwnProperty.call(proto, $e922645e3176d997$var$CONSTRUCTOR) && proto[$e922645e3176d997$var$CONSTRUCTOR];
    if (Ctor === Object) return true;
    if (!$e922645e3176d997$var$isFunction(Ctor)) return false;
    let ctorString = $e922645e3176d997$var$cachedCtorStrings.get(Ctor);
    if (ctorString === void 0) {
        ctorString = Function.toString.call(Ctor);
        $e922645e3176d997$var$cachedCtorStrings.set(Ctor, ctorString);
    }
    return ctorString === $e922645e3176d997$var$objectCtorString;
}
function $e922645e3176d997$export$22e8af3f75a010e3(value) {
    if (!$e922645e3176d997$export$541ac630993a4c84(value)) $e922645e3176d997$var$die(15, value);
    return value[$e922645e3176d997$var$DRAFT_STATE].base_;
}
function $e922645e3176d997$var$each(obj, iter, strict = true) {
    if ($e922645e3176d997$var$getArchtype(obj) === 0 /* Object */ ) {
        const keys = strict ? Reflect.ownKeys(obj) : $e922645e3176d997$var$O.keys(obj);
        keys.forEach((key)=>{
            iter(key, obj[key], obj);
        });
    } else obj.forEach((entry, index)=>iter(index, entry, obj));
}
function $e922645e3176d997$var$getArchtype(thing) {
    const state = thing[$e922645e3176d997$var$DRAFT_STATE];
    return state ? state.type_ : $e922645e3176d997$var$isArray(thing) ? 1 /* Array */  : $e922645e3176d997$var$isMap(thing) ? 2 /* Map */  : $e922645e3176d997$var$isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
var $e922645e3176d997$var$has = (thing, prop, type = $e922645e3176d997$var$getArchtype(thing))=>type === 2 /* Map */  ? thing.has(prop) : $e922645e3176d997$var$O[$e922645e3176d997$var$PROTOTYPE].hasOwnProperty.call(thing, prop);
var $e922645e3176d997$var$get = (thing, prop, type = $e922645e3176d997$var$getArchtype(thing))=>// @ts-ignore
    type === 2 /* Map */  ? thing.get(prop) : thing[prop];
var $e922645e3176d997$var$set = (thing, propOrOldValue, value, type = $e922645e3176d997$var$getArchtype(thing))=>{
    if (type === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (type === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
};
function $e922645e3176d997$var$is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
var $e922645e3176d997$var$isArray = Array.isArray;
var $e922645e3176d997$var$isMap = (target)=>target instanceof Map;
var $e922645e3176d997$var$isSet = (target)=>target instanceof Set;
var $e922645e3176d997$var$isObjectish = (target)=>typeof target === "object";
var $e922645e3176d997$var$isFunction = (target)=>typeof target === "function";
var $e922645e3176d997$var$isBoolean = (target)=>typeof target === "boolean";
function $e922645e3176d997$var$isArrayIndex(value) {
    const n = +value;
    return Number.isInteger(n) && String(n) === value;
}
var $e922645e3176d997$var$getProxyDraft = (value)=>{
    if (!$e922645e3176d997$var$isObjectish(value)) return null;
    return value?.[$e922645e3176d997$var$DRAFT_STATE];
};
var $e922645e3176d997$var$latest = (state)=>state.copy_ || state.base_;
var $e922645e3176d997$var$getValue = (value)=>{
    const proxyDraft = $e922645e3176d997$var$getProxyDraft(value);
    return proxyDraft ? proxyDraft.copy_ ?? proxyDraft.base_ : value;
};
var $e922645e3176d997$var$getFinalValue = (state)=>state.modified_ ? state.copy_ : state.base_;
function $e922645e3176d997$var$shallowCopy(base, strict) {
    if ($e922645e3176d997$var$isMap(base)) return new Map(base);
    if ($e922645e3176d997$var$isSet(base)) return new Set(base);
    if ($e922645e3176d997$var$isArray(base)) return Array[$e922645e3176d997$var$PROTOTYPE].slice.call(base);
    const isPlain = $e922645e3176d997$var$isPlainObject(base);
    if (strict === true || strict === "class_only" && !isPlain) {
        const descriptors = $e922645e3176d997$var$O.getOwnPropertyDescriptors(base);
        delete descriptors[$e922645e3176d997$var$DRAFT_STATE];
        let keys = Reflect.ownKeys(descriptors);
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            const desc = descriptors[key];
            if (desc[$e922645e3176d997$var$WRITABLE] === false) {
                desc[$e922645e3176d997$var$WRITABLE] = true;
                desc[$e922645e3176d997$var$CONFIGURABLE] = true;
            }
            if (desc.get || desc.set) descriptors[key] = {
                [$e922645e3176d997$var$CONFIGURABLE]: true,
                [$e922645e3176d997$var$WRITABLE]: true,
                // could live with !!desc.set as well here...
                [$e922645e3176d997$var$ENUMERABLE]: desc[$e922645e3176d997$var$ENUMERABLE],
                [$e922645e3176d997$var$VALUE]: base[key]
            };
        }
        return $e922645e3176d997$var$O.create($e922645e3176d997$var$getPrototypeOf(base), descriptors);
    } else {
        const proto = $e922645e3176d997$var$getPrototypeOf(base);
        if (proto !== null && isPlain) return {
            ...base
        };
        const obj = $e922645e3176d997$var$O.create(proto);
        return $e922645e3176d997$var$O.assign(obj, base);
    }
}
function $e922645e3176d997$export$792f3d81ea979f55(obj, deep = false) {
    if ($e922645e3176d997$var$isFrozen(obj) || $e922645e3176d997$export$541ac630993a4c84(obj) || !$e922645e3176d997$export$16e3aed3edb85946(obj)) return obj;
    if ($e922645e3176d997$var$getArchtype(obj) > 1) $e922645e3176d997$var$O.defineProperties(obj, {
        set: $e922645e3176d997$var$dontMutateMethodOverride,
        add: $e922645e3176d997$var$dontMutateMethodOverride,
        clear: $e922645e3176d997$var$dontMutateMethodOverride,
        delete: $e922645e3176d997$var$dontMutateMethodOverride
    });
    $e922645e3176d997$var$O.freeze(obj);
    if (deep) $e922645e3176d997$var$each(obj, (_key, value)=>{
        $e922645e3176d997$export$792f3d81ea979f55(value, true);
    }, false);
    return obj;
}
function $e922645e3176d997$var$dontMutateFrozenCollections() {
    $e922645e3176d997$var$die(2);
}
var $e922645e3176d997$var$dontMutateMethodOverride = {
    [$e922645e3176d997$var$VALUE]: $e922645e3176d997$var$dontMutateFrozenCollections
};
function $e922645e3176d997$var$isFrozen(obj) {
    if (obj === null || !$e922645e3176d997$var$isObjectish(obj)) return true;
    return $e922645e3176d997$var$O.isFrozen(obj);
}
// src/utils/plugins.ts
var $e922645e3176d997$var$PluginMapSet = "MapSet";
var $e922645e3176d997$var$PluginPatches = "Patches";
var $e922645e3176d997$var$PluginArrayMethods = "ArrayMethods";
var $e922645e3176d997$var$plugins = {};
function $e922645e3176d997$var$getPlugin(pluginKey) {
    const plugin = $e922645e3176d997$var$plugins[pluginKey];
    if (!plugin) $e922645e3176d997$var$die(0, pluginKey);
    return plugin;
}
var $e922645e3176d997$var$isPluginLoaded = (pluginKey)=>!!$e922645e3176d997$var$plugins[pluginKey];
function $e922645e3176d997$var$loadPlugin(pluginKey, implementation) {
    if (!$e922645e3176d997$var$plugins[pluginKey]) $e922645e3176d997$var$plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var $e922645e3176d997$var$currentScope;
var $e922645e3176d997$var$getCurrentScope = ()=>$e922645e3176d997$var$currentScope;
var $e922645e3176d997$var$createScope = (parent_, immer_)=>({
        drafts_: [],
        parent_: parent_,
        immer_: immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0,
        handledSet_: /* @__PURE__ */ new Set(),
        processedForPatches_: /* @__PURE__ */ new Set(),
        mapSetPlugin_: $e922645e3176d997$var$isPluginLoaded($e922645e3176d997$var$PluginMapSet) ? $e922645e3176d997$var$getPlugin($e922645e3176d997$var$PluginMapSet) : void 0,
        arrayMethodsPlugin_: $e922645e3176d997$var$isPluginLoaded($e922645e3176d997$var$PluginArrayMethods) ? $e922645e3176d997$var$getPlugin($e922645e3176d997$var$PluginArrayMethods) : void 0
    });
function $e922645e3176d997$var$usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        scope.patchPlugin_ = $e922645e3176d997$var$getPlugin($e922645e3176d997$var$PluginPatches);
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function $e922645e3176d997$var$revokeScope(scope) {
    $e922645e3176d997$var$leaveScope(scope);
    scope.drafts_.forEach($e922645e3176d997$var$revokeDraft);
    scope.drafts_ = null;
}
function $e922645e3176d997$var$leaveScope(scope) {
    if (scope === $e922645e3176d997$var$currentScope) $e922645e3176d997$var$currentScope = scope.parent_;
}
var $e922645e3176d997$var$enterScope = (immer2)=>$e922645e3176d997$var$currentScope = $e922645e3176d997$var$createScope($e922645e3176d997$var$currentScope, immer2);
function $e922645e3176d997$var$revokeDraft(draft) {
    const state = draft[$e922645e3176d997$var$DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function $e922645e3176d997$var$processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    const baseDraft = scope.drafts_[0];
    const isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[$e922645e3176d997$var$DRAFT_STATE].modified_) {
            $e922645e3176d997$var$revokeScope(scope);
            $e922645e3176d997$var$die(4);
        }
        if ($e922645e3176d997$export$16e3aed3edb85946(result)) result = $e922645e3176d997$var$finalize(scope, result);
        const { patchPlugin_: patchPlugin_ } = scope;
        if (patchPlugin_) patchPlugin_.generateReplacementPatches_(baseDraft[$e922645e3176d997$var$DRAFT_STATE].base_, result, scope);
    } else result = $e922645e3176d997$var$finalize(scope, baseDraft);
    $e922645e3176d997$var$maybeFreeze(scope, result, true);
    $e922645e3176d997$var$revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== $e922645e3176d997$export$45b790e32b2810ee ? result : void 0;
}
function $e922645e3176d997$var$finalize(rootScope, value) {
    if ($e922645e3176d997$var$isFrozen(value)) return value;
    const state = value[$e922645e3176d997$var$DRAFT_STATE];
    if (!state) {
        const finalValue = $e922645e3176d997$var$handleValue(value, rootScope.handledSet_, rootScope);
        return finalValue;
    }
    if (!$e922645e3176d997$var$isSameScope(state, rootScope)) return value;
    if (!state.modified_) return state.base_;
    if (!state.finalized_) {
        const { callbacks_: callbacks_ } = state;
        if (callbacks_) while(callbacks_.length > 0){
            const callback = callbacks_.pop();
            callback(rootScope);
        }
        $e922645e3176d997$var$generatePatchesAndFinalize(state, rootScope);
    }
    return state.copy_;
}
function $e922645e3176d997$var$maybeFreeze(scope, value, deep = false) {
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) $e922645e3176d997$export$792f3d81ea979f55(value, deep);
}
function $e922645e3176d997$var$markStateFinalized(state) {
    state.finalized_ = true;
    state.scope_.unfinalizedDrafts_--;
}
var $e922645e3176d997$var$isSameScope = (state, rootScope)=>state.scope_ === rootScope;
var $e922645e3176d997$var$EMPTY_LOCATIONS_RESULT = [];
function $e922645e3176d997$var$updateDraftInParent(parent, draftValue, finalizedValue, originalKey) {
    const parentCopy = $e922645e3176d997$var$latest(parent);
    const parentType = parent.type_;
    if (originalKey !== void 0) {
        const currentValue = $e922645e3176d997$var$get(parentCopy, originalKey, parentType);
        if (currentValue === draftValue) {
            $e922645e3176d997$var$set(parentCopy, originalKey, finalizedValue, parentType);
            return;
        }
    }
    if (!parent.draftLocations_) {
        const draftLocations = parent.draftLocations_ = /* @__PURE__ */ new Map();
        $e922645e3176d997$var$each(parentCopy, (key, value)=>{
            if ($e922645e3176d997$export$541ac630993a4c84(value)) {
                const keys = draftLocations.get(value) || [];
                keys.push(key);
                draftLocations.set(value, keys);
            }
        });
    }
    const locations = parent.draftLocations_.get(draftValue) ?? $e922645e3176d997$var$EMPTY_LOCATIONS_RESULT;
    for (const location of locations)$e922645e3176d997$var$set(parentCopy, location, finalizedValue, parentType);
}
function $e922645e3176d997$var$registerChildFinalizationCallback(parent, child, key) {
    parent.callbacks_.push(function childCleanup(rootScope) {
        const state = child;
        if (!state || !$e922645e3176d997$var$isSameScope(state, rootScope)) return;
        rootScope.mapSetPlugin_?.fixSetContents(state);
        const finalizedValue = $e922645e3176d997$var$getFinalValue(state);
        $e922645e3176d997$var$updateDraftInParent(parent, state.draft_ ?? state, finalizedValue, key);
        $e922645e3176d997$var$generatePatchesAndFinalize(state, rootScope);
    });
}
function $e922645e3176d997$var$generatePatchesAndFinalize(state, rootScope) {
    const shouldFinalize = state.modified_ && !state.finalized_ && (state.type_ === 3 /* Set */  || state.type_ === 1 /* Array */  && state.allIndicesReassigned_ || (state.assigned_?.size ?? 0) > 0);
    if (shouldFinalize) {
        const { patchPlugin_: patchPlugin_ } = rootScope;
        if (patchPlugin_) {
            const basePath = patchPlugin_.getPath(state);
            if (basePath) patchPlugin_.generatePatches_(state, basePath, rootScope);
        }
        $e922645e3176d997$var$markStateFinalized(state);
    }
}
function $e922645e3176d997$var$handleCrossReference(target, key, value) {
    const { scope_: scope_ } = target;
    if ($e922645e3176d997$export$541ac630993a4c84(value)) {
        const state = value[$e922645e3176d997$var$DRAFT_STATE];
        if ($e922645e3176d997$var$isSameScope(state, scope_)) state.callbacks_.push(function crossReferenceCleanup() {
            $e922645e3176d997$var$prepareCopy(target);
            const finalizedValue = $e922645e3176d997$var$getFinalValue(state);
            $e922645e3176d997$var$updateDraftInParent(target, value, finalizedValue, key);
        });
    } else if ($e922645e3176d997$export$16e3aed3edb85946(value)) target.callbacks_.push(function nestedDraftCleanup() {
        const targetCopy = $e922645e3176d997$var$latest(target);
        if (target.type_ === 3 /* Set */ ) {
            if (targetCopy.has(value)) $e922645e3176d997$var$handleValue(value, scope_.handledSet_, scope_);
        } else {
            if ($e922645e3176d997$var$get(targetCopy, key, target.type_) === value) {
                if (scope_.drafts_.length > 1 && (target.assigned_.get(key) ?? false) === true && target.copy_) $e922645e3176d997$var$handleValue($e922645e3176d997$var$get(target.copy_, key, target.type_), scope_.handledSet_, scope_);
            }
        }
    });
}
function $e922645e3176d997$var$handleValue(target, handledSet, rootScope) {
    if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return target;
    if ($e922645e3176d997$export$541ac630993a4c84(target) || handledSet.has(target) || !$e922645e3176d997$export$16e3aed3edb85946(target) || $e922645e3176d997$var$isFrozen(target)) return target;
    handledSet.add(target);
    $e922645e3176d997$var$each(target, (key, value)=>{
        if ($e922645e3176d997$export$541ac630993a4c84(value)) {
            const state = value[$e922645e3176d997$var$DRAFT_STATE];
            if ($e922645e3176d997$var$isSameScope(state, rootScope)) {
                const updatedValue = $e922645e3176d997$var$getFinalValue(state);
                $e922645e3176d997$var$set(target, key, updatedValue, target.type_);
                $e922645e3176d997$var$markStateFinalized(state);
            }
        } else if ($e922645e3176d997$export$16e3aed3edb85946(value)) $e922645e3176d997$var$handleValue(value, handledSet, rootScope);
    });
    return target;
}
// src/core/proxy.ts
function $e922645e3176d997$var$createProxyProxy(base, parent) {
    const baseIsArray = $e922645e3176d997$var$isArray(base);
    const state = {
        type_: baseIsArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : $e922645e3176d997$var$getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        // actually instantiated in `prepareCopy()`
        assigned_: void 0,
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false,
        // `callbacks` actually gets assigned in `createProxy`
        callbacks_: void 0
    };
    let target = state;
    let traps = $e922645e3176d997$var$objectTraps;
    if (baseIsArray) {
        target = [
            state
        ];
        traps = $e922645e3176d997$var$arrayTraps;
    }
    const { revoke: revoke, proxy: proxy } = Proxy.revocable(target, traps);
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return [
        proxy,
        state
    ];
}
var $e922645e3176d997$var$objectTraps = {
    get (state, prop) {
        if (prop === $e922645e3176d997$var$DRAFT_STATE) return state;
        let arrayPlugin = state.scope_.arrayMethodsPlugin_;
        const isArrayWithStringProp = state.type_ === 1 /* Array */  && typeof prop === "string";
        if (isArrayWithStringProp) {
            if (arrayPlugin?.isArrayOperationMethod(prop)) return arrayPlugin.createMethodInterceptor(state, prop);
        }
        const source = $e922645e3176d997$var$latest(state);
        if (!$e922645e3176d997$var$has(source, prop, state.type_)) return $e922645e3176d997$var$readPropFromProto(state, source, prop);
        const value = source[prop];
        if (state.finalized_ || !$e922645e3176d997$export$16e3aed3edb85946(value)) return value;
        if (isArrayWithStringProp && state.operationMethod && arrayPlugin?.isMutatingArrayMethod(state.operationMethod) && $e922645e3176d997$var$isArrayIndex(prop)) return value;
        if (value === $e922645e3176d997$var$peek(state.base_, prop)) {
            $e922645e3176d997$var$prepareCopy(state);
            const childKey = state.type_ === 1 /* Array */  ? +prop : prop;
            const childDraft = $e922645e3176d997$var$createProxy(state.scope_, value, state, childKey);
            return state.copy_[childKey] = childDraft;
        }
        return value;
    },
    has (state, prop) {
        return prop in $e922645e3176d997$var$latest(state);
    },
    ownKeys (state) {
        return Reflect.ownKeys($e922645e3176d997$var$latest(state));
    },
    set (state, prop, value) {
        const desc = $e922645e3176d997$var$getDescriptorFromProto($e922645e3176d997$var$latest(state), prop);
        if (desc?.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            const current2 = $e922645e3176d997$var$peek($e922645e3176d997$var$latest(state), prop);
            const currentState = current2?.[$e922645e3176d997$var$DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_.set(prop, false);
                return true;
            }
            if ($e922645e3176d997$var$is(value, current2) && (value !== void 0 || $e922645e3176d997$var$has(state.base_, prop, state.type_))) return true;
            $e922645e3176d997$var$prepareCopy(state);
            $e922645e3176d997$var$markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || prop in state.copy_) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_.set(prop, true);
        $e922645e3176d997$var$handleCrossReference(state, prop, value);
        return true;
    },
    deleteProperty (state, prop) {
        $e922645e3176d997$var$prepareCopy(state);
        if ($e922645e3176d997$var$peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_.set(prop, false);
            $e922645e3176d997$var$markChanged(state);
        } else state.assigned_.delete(prop);
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor (state, prop) {
        const owner = $e922645e3176d997$var$latest(state);
        const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            [$e922645e3176d997$var$WRITABLE]: true,
            [$e922645e3176d997$var$CONFIGURABLE]: state.type_ !== 1 /* Array */  || prop !== "length",
            [$e922645e3176d997$var$ENUMERABLE]: desc[$e922645e3176d997$var$ENUMERABLE],
            [$e922645e3176d997$var$VALUE]: owner[prop]
        };
    },
    defineProperty () {
        $e922645e3176d997$var$die(11);
    },
    getPrototypeOf (state) {
        return $e922645e3176d997$var$getPrototypeOf(state.base_);
    },
    setPrototypeOf () {
        $e922645e3176d997$var$die(12);
    }
};
var $e922645e3176d997$var$arrayTraps = {};
for(let key in $e922645e3176d997$var$objectTraps){
    let fn = $e922645e3176d997$var$objectTraps[key];
    $e922645e3176d997$var$arrayTraps[key] = function() {
        const args = arguments;
        args[0] = args[0][0];
        return fn.apply(this, args);
    };
}
$e922645e3176d997$var$arrayTraps.deleteProperty = function(state, prop) {
    return $e922645e3176d997$var$arrayTraps.set.call(this, state, prop, void 0);
};
$e922645e3176d997$var$arrayTraps.set = function(state, prop, value) {
    return $e922645e3176d997$var$objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function $e922645e3176d997$var$peek(draft, prop) {
    const state = draft[$e922645e3176d997$var$DRAFT_STATE];
    const source = state ? $e922645e3176d997$var$latest(state) : draft;
    return source[prop];
}
function $e922645e3176d997$var$readPropFromProto(state, source, prop) {
    const desc = $e922645e3176d997$var$getDescriptorFromProto(source, prop);
    return desc ? $e922645e3176d997$var$VALUE in desc ? desc[$e922645e3176d997$var$VALUE] : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    desc.get?.call(state.draft_) : void 0;
}
function $e922645e3176d997$var$getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    let proto = $e922645e3176d997$var$getPrototypeOf(source);
    while(proto){
        const desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = $e922645e3176d997$var$getPrototypeOf(proto);
    }
    return void 0;
}
function $e922645e3176d997$var$markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) $e922645e3176d997$var$markChanged(state.parent_);
    }
}
function $e922645e3176d997$var$prepareCopy(state) {
    if (!state.copy_) {
        state.assigned_ = /* @__PURE__ */ new Map();
        state.copy_ = $e922645e3176d997$var$shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
    }
}
// src/core/immerClass.ts
var $e922645e3176d997$export$aaadc6ff0f822719 = class {
    constructor(config){
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        this.useStrictIteration_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = (base, recipe, patchListener)=>{
            if ($e922645e3176d997$var$isFunction(base) && !$e922645e3176d997$var$isFunction(recipe)) {
                const defaultBase = recipe;
                recipe = base;
                const self = this;
                return function curriedProduce(base2 = defaultBase, ...args) {
                    return self.produce(base2, (draft)=>recipe.call(this, draft, ...args));
                };
            }
            if (!$e922645e3176d997$var$isFunction(recipe)) $e922645e3176d997$var$die(6);
            if (patchListener !== void 0 && !$e922645e3176d997$var$isFunction(patchListener)) $e922645e3176d997$var$die(7);
            let result;
            if ($e922645e3176d997$export$16e3aed3edb85946(base)) {
                const scope = $e922645e3176d997$var$enterScope(this);
                const proxy = $e922645e3176d997$var$createProxy(scope, base, void 0);
                let hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) $e922645e3176d997$var$revokeScope(scope);
                    else $e922645e3176d997$var$leaveScope(scope);
                }
                $e922645e3176d997$var$usePatchesInScope(scope, patchListener);
                return $e922645e3176d997$var$processResult(result, scope);
            } else if (!base || !$e922645e3176d997$var$isObjectish(base)) {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === $e922645e3176d997$export$45b790e32b2810ee) result = void 0;
                if (this.autoFreeze_) $e922645e3176d997$export$792f3d81ea979f55(result, true);
                if (patchListener) {
                    const p = [];
                    const ip = [];
                    $e922645e3176d997$var$getPlugin($e922645e3176d997$var$PluginPatches).generateReplacementPatches_(base, result, {
                        patches_: p,
                        inversePatches_: ip
                    });
                    patchListener(p, ip);
                }
                return result;
            } else $e922645e3176d997$var$die(1, base);
        };
        this.produceWithPatches = (base, recipe)=>{
            if ($e922645e3176d997$var$isFunction(base)) return (state, ...args)=>this.produceWithPatches(state, (draft)=>base(draft, ...args));
            let patches, inversePatches;
            const result = this.produce(base, recipe, (p, ip)=>{
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if ($e922645e3176d997$var$isBoolean(config?.autoFreeze)) this.setAutoFreeze(config.autoFreeze);
        if ($e922645e3176d997$var$isBoolean(config?.useStrictShallowCopy)) this.setUseStrictShallowCopy(config.useStrictShallowCopy);
        if ($e922645e3176d997$var$isBoolean(config?.useStrictIteration)) this.setUseStrictIteration(config.useStrictIteration);
    }
    createDraft(base) {
        if (!$e922645e3176d997$export$16e3aed3edb85946(base)) $e922645e3176d997$var$die(8);
        if ($e922645e3176d997$export$541ac630993a4c84(base)) base = $e922645e3176d997$export$97aac956da55dae9(base);
        const scope = $e922645e3176d997$var$enterScope(this);
        const proxy = $e922645e3176d997$var$createProxy(scope, base, void 0);
        proxy[$e922645e3176d997$var$DRAFT_STATE].isManual_ = true;
        $e922645e3176d997$var$leaveScope(scope);
        return proxy;
    }
    finishDraft(draft, patchListener) {
        const state = draft && draft[$e922645e3176d997$var$DRAFT_STATE];
        if (!state || !state.isManual_) $e922645e3176d997$var$die(9);
        const { scope_: scope } = state;
        $e922645e3176d997$var$usePatchesInScope(scope, patchListener);
        return $e922645e3176d997$var$processResult(void 0, scope);
    }
    /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ setAutoFreeze(value) {
        this.autoFreeze_ = value;
    }
    /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ setUseStrictShallowCopy(value) {
        this.useStrictShallowCopy_ = value;
    }
    /**
   * Pass false to use faster iteration that skips non-enumerable properties
   * but still handles symbols for compatibility.
   *
   * By default, strict iteration is enabled (includes all own properties).
   */ setUseStrictIteration(value) {
        this.useStrictIteration_ = value;
    }
    shouldUseStrictIteration() {
        return this.useStrictIteration_;
    }
    applyPatches(base, patches) {
        let i;
        for(i = patches.length - 1; i >= 0; i--){
            const patch = patches[i];
            if (patch.path.length === 0 && patch.op === "replace") {
                base = patch.value;
                break;
            }
        }
        if (i > -1) patches = patches.slice(i + 1);
        const applyPatchesImpl = $e922645e3176d997$var$getPlugin($e922645e3176d997$var$PluginPatches).applyPatches_;
        if ($e922645e3176d997$export$541ac630993a4c84(base)) return applyPatchesImpl(base, patches);
        return this.produce(base, (draft)=>applyPatchesImpl(draft, patches));
    }
};
function $e922645e3176d997$var$createProxy(rootScope, value, parent, key) {
    const [draft, state] = $e922645e3176d997$var$isMap(value) ? $e922645e3176d997$var$getPlugin($e922645e3176d997$var$PluginMapSet).proxyMap_(value, parent) : $e922645e3176d997$var$isSet(value) ? $e922645e3176d997$var$getPlugin($e922645e3176d997$var$PluginMapSet).proxySet_(value, parent) : $e922645e3176d997$var$createProxyProxy(value, parent);
    const scope = parent?.scope_ ?? $e922645e3176d997$var$getCurrentScope();
    scope.drafts_.push(draft);
    state.callbacks_ = parent?.callbacks_ ?? [];
    state.key_ = key;
    if (parent && key !== void 0) $e922645e3176d997$var$registerChildFinalizationCallback(parent, state, key);
    else state.callbacks_.push(function rootDraftCleanup(rootScope2) {
        rootScope2.mapSetPlugin_?.fixSetContents(state);
        const { patchPlugin_: patchPlugin_ } = rootScope2;
        if (state.modified_ && patchPlugin_) patchPlugin_.generatePatches_(state, [], rootScope2);
    });
    return draft;
}
// src/core/current.ts
function $e922645e3176d997$export$97aac956da55dae9(value) {
    if (!$e922645e3176d997$export$541ac630993a4c84(value)) $e922645e3176d997$var$die(10, value);
    return $e922645e3176d997$var$currentImpl(value);
}
function $e922645e3176d997$var$currentImpl(value) {
    if (!$e922645e3176d997$export$16e3aed3edb85946(value) || $e922645e3176d997$var$isFrozen(value)) return value;
    const state = value[$e922645e3176d997$var$DRAFT_STATE];
    let copy;
    let strict = true;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = $e922645e3176d997$var$shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
        strict = state.scope_.immer_.shouldUseStrictIteration();
    } else copy = $e922645e3176d997$var$shallowCopy(value, true);
    $e922645e3176d997$var$each(copy, (key, childValue)=>{
        $e922645e3176d997$var$set(copy, key, $e922645e3176d997$var$currentImpl(childValue));
    }, strict);
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function $e922645e3176d997$export$d3a6659991a0696c() {
    const errorOffset = 16;
    function getPath(state, path = []) {
        if (state.key_ !== void 0) {
            const parentCopy = state.parent_.copy_ ?? state.parent_.base_;
            const proxyDraft = $e922645e3176d997$var$getProxyDraft($e922645e3176d997$var$get(parentCopy, state.key_));
            const valueAtKey = $e922645e3176d997$var$get(parentCopy, state.key_);
            if (valueAtKey === void 0) return null;
            if (valueAtKey !== state.draft_ && valueAtKey !== state.base_ && valueAtKey !== state.copy_) return null;
            if (proxyDraft != null && proxyDraft.base_ !== state.base_) return null;
            const isSet2 = state.parent_.type_ === 3 /* Set */ ;
            let key;
            if (isSet2) {
                const setParent = state.parent_;
                key = Array.from(setParent.drafts_.keys()).indexOf(state.key_);
            } else key = state.key_;
            if (!(isSet2 && parentCopy.size > key || $e922645e3176d997$var$has(parentCopy, key))) return null;
            path.push(key);
        }
        if (state.parent_) return getPath(state.parent_, path);
        path.reverse();
        try {
            resolvePath(state.copy_, path);
        } catch (e) {
            return null;
        }
        return path;
    }
    function resolvePath(base, path) {
        let current2 = base;
        for(let i = 0; i < path.length - 1; i++){
            const key = path[i];
            current2 = $e922645e3176d997$var$get(current2, key);
            if (!$e922645e3176d997$var$isObjectish(current2) || current2 === null) throw new Error(`Cannot resolve path at '${path.join("/")}'`);
        }
        return current2;
    }
    const REPLACE = "replace";
    const ADD = "add";
    const REMOVE = "remove";
    function generatePatches_(state, basePath, scope) {
        if (state.scope_.processedForPatches_.has(state)) return;
        state.scope_.processedForPatches_.add(state);
        const { patches_: patches_, inversePatches_: inversePatches_ } = scope;
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches_, inversePatches_);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches_, inversePatches_);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches_, inversePatches_);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, assigned_: assigned_ } = state;
        let copy_ = state.copy_;
        if (copy_.length < base_.length) {
            [base_, copy_] = [
                copy_,
                base_
            ];
            [patches, inversePatches] = [
                inversePatches,
                patches
            ];
        }
        const allReassigned = state.allIndicesReassigned_ === true;
        for(let i = 0; i < base_.length; i++){
            const copiedItem = copy_[i];
            const baseItem = base_[i];
            const isAssigned = allReassigned || assigned_?.get(i.toString());
            if (isAssigned && copiedItem !== baseItem) {
                const childState = copiedItem?.[$e922645e3176d997$var$DRAFT_STATE];
                if (childState && childState.modified_) continue;
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REPLACE,
                    path: path,
                    // Need to maybe clone it, as it can in fact be the original value
                    // due to the base/copy inversion at the start of this function
                    value: clonePatchValueIfNeeded(copiedItem)
                });
                inversePatches.push({
                    op: REPLACE,
                    path: path,
                    value: clonePatchValueIfNeeded(baseItem)
                });
            }
        }
        for(let i = base_.length; i < copy_.length; i++){
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: ADD,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
        }
        for(let i = copy_.length - 1; base_.length <= i; --i){
            const path = basePath.concat([
                i
            ]);
            inversePatches.push({
                op: REMOVE,
                path: path
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        const { base_: base_, copy_: copy_, type_: type_ } = state;
        $e922645e3176d997$var$each(state.assigned_, (key, assignedValue)=>{
            const origValue = $e922645e3176d997$var$get(base_, key, type_);
            const value = $e922645e3176d997$var$get(copy_, key, type_);
            const op = !assignedValue ? REMOVE : $e922645e3176d997$var$has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            const path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op: op,
                path: path
            } : {
                op: op,
                path: path,
                value: clonePatchValueIfNeeded(value)
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path: path
            } : op === REMOVE ? {
                op: ADD,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, copy_: copy_ } = state;
        let i = 0;
        base_.forEach((value)=>{
            if (!copy_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: ADD,
                    path: path,
                    value: value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach((value)=>{
            if (!base_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path: path,
                    value: value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, scope) {
        const { patches_: patches_, inversePatches_: inversePatches_ } = scope;
        patches_.push({
            op: REPLACE,
            path: [],
            value: replacement === $e922645e3176d997$export$45b790e32b2810ee ? void 0 : replacement
        });
        inversePatches_.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach((patch)=>{
            const { path: path, op: op } = patch;
            let base = draft;
            for(let i = 0; i < path.length - 1; i++){
                const parentType = $e922645e3176d997$var$getArchtype(base);
                let p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === $e922645e3176d997$var$CONSTRUCTOR)) $e922645e3176d997$var$die(errorOffset + 3);
                if ($e922645e3176d997$var$isFunction(base) && p === $e922645e3176d997$var$PROTOTYPE) $e922645e3176d997$var$die(errorOffset + 3);
                base = $e922645e3176d997$var$get(base, p);
                if (!$e922645e3176d997$var$isObjectish(base)) $e922645e3176d997$var$die(errorOffset + 2, path.join("/"));
            }
            const type = $e922645e3176d997$var$getArchtype(base);
            const value = deepClonePatchValue(patch.value);
            const key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            $e922645e3176d997$var$die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    $e922645e3176d997$var$die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!$e922645e3176d997$export$16e3aed3edb85946(obj)) return obj;
        if ($e922645e3176d997$var$isArray(obj)) return obj.map(deepClonePatchValue);
        if ($e922645e3176d997$var$isMap(obj)) return new Map(Array.from(obj.entries()).map(([k, v])=>[
                k,
                deepClonePatchValue(v)
            ]));
        if ($e922645e3176d997$var$isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        const cloned = Object.create($e922645e3176d997$var$getPrototypeOf(obj));
        for(const key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if ($e922645e3176d997$var$has(obj, $e922645e3176d997$export$6ee2082928bcb0ee)) cloned[$e922645e3176d997$export$6ee2082928bcb0ee] = obj[$e922645e3176d997$export$6ee2082928bcb0ee];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if ($e922645e3176d997$export$541ac630993a4c84(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    $e922645e3176d997$var$loadPlugin($e922645e3176d997$var$PluginPatches, {
        applyPatches_: applyPatches_,
        generatePatches_: generatePatches_,
        generateReplacementPatches_: generateReplacementPatches_,
        getPath: getPath
    });
}
// src/plugins/mapset.ts
function $e922645e3176d997$export$7d9f65390203b435() {
    class DraftMap extends Map {
        constructor(target, parent){
            super();
            this[$e922645e3176d997$var$DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $e922645e3176d997$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: this,
                isManual_: false,
                revoked_: false,
                callbacks_: []
            };
        }
        get size() {
            return $e922645e3176d997$var$latest(this[$e922645e3176d997$var$DRAFT_STATE]).size;
        }
        has(key) {
            return $e922645e3176d997$var$latest(this[$e922645e3176d997$var$DRAFT_STATE]).has(key);
        }
        set(key, value) {
            const state = this[$e922645e3176d997$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!$e922645e3176d997$var$latest(state).has(key) || $e922645e3176d997$var$latest(state).get(key) !== value) {
                prepareMapCopy(state);
                $e922645e3176d997$var$markChanged(state);
                state.assigned_.set(key, true);
                state.copy_.set(key, value);
                state.assigned_.set(key, true);
                $e922645e3176d997$var$handleCrossReference(state, key, value);
            }
            return this;
        }
        delete(key) {
            if (!this.has(key)) return false;
            const state = this[$e922645e3176d997$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareMapCopy(state);
            $e922645e3176d997$var$markChanged(state);
            if (state.base_.has(key)) state.assigned_.set(key, false);
            else state.assigned_.delete(key);
            state.copy_.delete(key);
            return true;
        }
        clear() {
            const state = this[$e922645e3176d997$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($e922645e3176d997$var$latest(state).size) {
                prepareMapCopy(state);
                $e922645e3176d997$var$markChanged(state);
                state.assigned_ = /* @__PURE__ */ new Map();
                $e922645e3176d997$var$each(state.base_, (key)=>{
                    state.assigned_.set(key, false);
                });
                state.copy_.clear();
            }
        }
        forEach(cb, thisArg) {
            const state = this[$e922645e3176d997$var$DRAFT_STATE];
            $e922645e3176d997$var$latest(state).forEach((_value, key, _map)=>{
                cb.call(thisArg, this.get(key), key, this);
            });
        }
        get(key) {
            const state = this[$e922645e3176d997$var$DRAFT_STATE];
            assertUnrevoked(state);
            const value = $e922645e3176d997$var$latest(state).get(key);
            if (state.finalized_ || !$e922645e3176d997$export$16e3aed3edb85946(value)) return value;
            if (value !== state.base_.get(key)) return value;
            const draft = $e922645e3176d997$var$createProxy(state.scope_, value, state, key);
            prepareMapCopy(state);
            state.copy_.set(key, draft);
            return draft;
        }
        keys() {
            return $e922645e3176d997$var$latest(this[$e922645e3176d997$var$DRAFT_STATE]).keys();
        }
        values() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.values(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: value
                    };
                }
            };
        }
        entries() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.entries(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: [
                            r.value,
                            value
                        ]
                    };
                }
            };
        }
        [($e922645e3176d997$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.entries();
        }
    }
    function proxyMap_(target, parent) {
        const map = new DraftMap(target, parent);
        return [
            map,
            map[$e922645e3176d997$var$DRAFT_STATE]
        ];
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    class DraftSet extends Set {
        constructor(target, parent){
            super();
            this[$e922645e3176d997$var$DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $e922645e3176d997$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false,
                assigned_: void 0,
                callbacks_: []
            };
        }
        get size() {
            return $e922645e3176d997$var$latest(this[$e922645e3176d997$var$DRAFT_STATE]).size;
        }
        has(value) {
            const state = this[$e922645e3176d997$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!state.copy_) return state.base_.has(value);
            if (state.copy_.has(value)) return true;
            if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
            return false;
        }
        add(value) {
            const state = this[$e922645e3176d997$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!this.has(value)) {
                prepareSetCopy(state);
                $e922645e3176d997$var$markChanged(state);
                state.copy_.add(value);
                $e922645e3176d997$var$handleCrossReference(state, value, value);
            }
            return this;
        }
        delete(value) {
            if (!this.has(value)) return false;
            const state = this[$e922645e3176d997$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            $e922645e3176d997$var$markChanged(state);
            return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
        }
        clear() {
            const state = this[$e922645e3176d997$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($e922645e3176d997$var$latest(state).size) {
                prepareSetCopy(state);
                $e922645e3176d997$var$markChanged(state);
                state.copy_.clear();
            }
        }
        values() {
            const state = this[$e922645e3176d997$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.values();
        }
        entries() {
            const state = this[$e922645e3176d997$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.entries();
        }
        keys() {
            return this.values();
        }
        [($e922645e3176d997$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.values();
        }
        forEach(cb, thisArg) {
            const iterator = this.values();
            let result = iterator.next();
            while(!result.done){
                cb.call(thisArg, result.value, result.value, this);
                result = iterator.next();
            }
        }
    }
    function proxySet_(target, parent) {
        const set2 = new DraftSet(target, parent);
        return [
            set2,
            set2[$e922645e3176d997$var$DRAFT_STATE]
        ];
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach((value)=>{
                if ($e922645e3176d997$export$16e3aed3edb85946(value)) {
                    const draft = $e922645e3176d997$var$createProxy(state.scope_, value, state, value);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) $e922645e3176d997$var$die(3, JSON.stringify($e922645e3176d997$var$latest(state)));
    }
    function fixSetContents(target) {
        if (target.type_ === 3 /* Set */  && target.copy_) {
            const copy = new Set(target.copy_);
            target.copy_.clear();
            copy.forEach((value)=>{
                target.copy_.add($e922645e3176d997$var$getValue(value));
            });
        }
    }
    $e922645e3176d997$var$loadPlugin($e922645e3176d997$var$PluginMapSet, {
        proxyMap_: proxyMap_,
        proxySet_: proxySet_,
        fixSetContents: fixSetContents
    });
}
// src/plugins/arrayMethods.ts
function $e922645e3176d997$export$5ecc5ed53f504cc5() {
    const SHIFTING_METHODS = /* @__PURE__ */ new Set([
        "shift",
        "unshift"
    ]);
    const QUEUE_METHODS = /* @__PURE__ */ new Set([
        "push",
        "pop"
    ]);
    const RESULT_RETURNING_METHODS = /* @__PURE__ */ new Set([
        ...QUEUE_METHODS,
        ...SHIFTING_METHODS
    ]);
    const REORDERING_METHODS = /* @__PURE__ */ new Set([
        "reverse",
        "sort"
    ]);
    const MUTATING_METHODS = /* @__PURE__ */ new Set([
        ...RESULT_RETURNING_METHODS,
        ...REORDERING_METHODS,
        "splice"
    ]);
    const FIND_METHODS = /* @__PURE__ */ new Set([
        "find",
        "findLast"
    ]);
    const NON_MUTATING_METHODS = /* @__PURE__ */ new Set([
        "filter",
        "slice",
        "concat",
        "flat",
        ...FIND_METHODS,
        "findIndex",
        "findLastIndex",
        "some",
        "every",
        "indexOf",
        "lastIndexOf",
        "includes",
        "join",
        "toString",
        "toLocaleString"
    ]);
    function isMutatingArrayMethod(method) {
        return MUTATING_METHODS.has(method);
    }
    function isNonMutatingArrayMethod(method) {
        return NON_MUTATING_METHODS.has(method);
    }
    function isArrayOperationMethod(method) {
        return isMutatingArrayMethod(method) || isNonMutatingArrayMethod(method);
    }
    function enterOperation(state, method) {
        state.operationMethod = method;
    }
    function exitOperation(state) {
        state.operationMethod = void 0;
    }
    function executeArrayMethod(state, operation, markLength = true) {
        $e922645e3176d997$var$prepareCopy(state);
        const result = operation();
        $e922645e3176d997$var$markChanged(state);
        if (markLength) state.assigned_.set("length", true);
        return result;
    }
    function markAllIndicesReassigned(state) {
        state.allIndicesReassigned_ = true;
    }
    function normalizeSliceIndex(index, length) {
        if (index < 0) return Math.max(length + index, 0);
        return Math.min(index, length);
    }
    function handleInsertedValues(state, startIndex, values) {
        for(let i = 0; i < values.length; i++){
            const index = startIndex + i;
            state.assigned_.set(index, true);
            $e922645e3176d997$var$handleCrossReference(state, index, values[i]);
        }
    }
    function handleSimpleOperation(state, method, args) {
        return executeArrayMethod(state, ()=>{
            const lengthBefore = state.copy_.length;
            const result = state.copy_[method](...args);
            if (SHIFTING_METHODS.has(method)) markAllIndicesReassigned(state);
            if (method === "push" && args.length > 0) handleInsertedValues(state, lengthBefore, args);
            else if (method === "unshift" && args.length > 0) handleInsertedValues(state, 0, args);
            return RESULT_RETURNING_METHODS.has(method) ? result : state.draft_;
        });
    }
    function handleReorderingOperation(state, method, args) {
        return executeArrayMethod(state, ()=>{
            state.copy_[method](...args);
            markAllIndicesReassigned(state);
            return state.draft_;
        }, false);
    }
    function createMethodInterceptor(state, originalMethod) {
        return function interceptedMethod(...args) {
            const method = originalMethod;
            enterOperation(state, method);
            try {
                if (isMutatingArrayMethod(method)) {
                    if (RESULT_RETURNING_METHODS.has(method)) return handleSimpleOperation(state, method, args);
                    if (REORDERING_METHODS.has(method)) return handleReorderingOperation(state, method, args);
                    if (method === "splice") {
                        const res = executeArrayMethod(state, ()=>state.copy_.splice(...args));
                        markAllIndicesReassigned(state);
                        if (args.length > 2) {
                            const startIndex = normalizeSliceIndex(args[0] ?? 0, state.copy_.length);
                            handleInsertedValues(state, startIndex, args.slice(2));
                        }
                        return res;
                    }
                } else return handleNonMutatingOperation(state, method, args);
            } finally{
                exitOperation(state);
            }
        };
    }
    function handleNonMutatingOperation(state, method, args) {
        const source = $e922645e3176d997$var$latest(state);
        if (method === "filter") {
            const predicate = args[0];
            const result = [];
            for(let i = 0; i < source.length; i++)if (predicate(source[i], i, source)) result.push(state.draft_[i]);
            return result;
        }
        if (FIND_METHODS.has(method)) {
            const predicate = args[0];
            const isForward = method === "find";
            const step = isForward ? 1 : -1;
            const start = isForward ? 0 : source.length - 1;
            for(let i = start; i >= 0 && i < source.length; i += step){
                if (predicate(source[i], i, source)) return state.draft_[i];
            }
            return void 0;
        }
        if (method === "slice") {
            const rawStart = args[0] ?? 0;
            const rawEnd = args[1] ?? source.length;
            const start = normalizeSliceIndex(rawStart, source.length);
            const end = normalizeSliceIndex(rawEnd, source.length);
            const result = [];
            for(let i = start; i < end; i++)result.push(state.draft_[i]);
            return result;
        }
        return source[method](...args);
    }
    $e922645e3176d997$var$loadPlugin($e922645e3176d997$var$PluginArrayMethods, {
        createMethodInterceptor: createMethodInterceptor,
        isArrayOperationMethod: isArrayOperationMethod,
        isMutatingArrayMethod: isMutatingArrayMethod
    });
}
// src/immer.ts
var $e922645e3176d997$var$immer = new $e922645e3176d997$export$aaadc6ff0f822719();
var $e922645e3176d997$export$b46cabe22e78bc00 = $e922645e3176d997$var$immer.produce;
var $e922645e3176d997$export$4da66d41c9492c78 = /* @__PURE__ */ $e922645e3176d997$var$immer.produceWithPatches.bind($e922645e3176d997$var$immer);
var $e922645e3176d997$export$573f26f60825c493 = /* @__PURE__ */ $e922645e3176d997$var$immer.setAutoFreeze.bind($e922645e3176d997$var$immer);
var $e922645e3176d997$export$333ce65961cbe047 = /* @__PURE__ */ $e922645e3176d997$var$immer.setUseStrictShallowCopy.bind($e922645e3176d997$var$immer);
var $e922645e3176d997$export$1045b3be3904c489 = /* @__PURE__ */ $e922645e3176d997$var$immer.setUseStrictIteration.bind($e922645e3176d997$var$immer);
var $e922645e3176d997$export$a8b8e03e6bbe5473 = /* @__PURE__ */ $e922645e3176d997$var$immer.applyPatches.bind($e922645e3176d997$var$immer);
var $e922645e3176d997$export$3c3214997190395f = /* @__PURE__ */ $e922645e3176d997$var$immer.createDraft.bind($e922645e3176d997$var$immer);
var $e922645e3176d997$export$c60f5e69c521b528 = /* @__PURE__ */ $e922645e3176d997$var$immer.finishDraft.bind($e922645e3176d997$var$immer);
var $e922645e3176d997$export$c05b21e3257751e5 = (value)=>value;
var $e922645e3176d997$export$20f911b3f8cf0b74 = (value)=>value;


// src/devModeChecks/identityFunctionCheck.ts
var $757e1d271f969f78$var$runIdentityFunctionCheck = (resultFunc, inputSelectorsResults, outputSelectorResult)=>{
    if (inputSelectorsResults.length === 1 && inputSelectorsResults[0] === outputSelectorResult) {
        let isInputSameAsOutput = false;
        try {
            const emptyObject = {};
            if (resultFunc(emptyObject) === emptyObject) isInputSameAsOutput = true;
        } catch  {}
        if (isInputSameAsOutput) {
            let stack = void 0;
            try {
                throw new Error();
            } catch (e) {
                ({ stack: stack } = e);
            }
            console.warn("The result function returned its own inputs without modification. e.g\n`createSelector([state => state.todos], todos => todos)`\nThis could lead to inefficient memoization and unnecessary re-renders.\nEnsure transformation logic is in the result function, and extraction logic is in the input selectors.", {
                stack: stack
            });
        }
    }
};
// src/devModeChecks/inputStabilityCheck.ts
var $757e1d271f969f78$var$runInputStabilityCheck = (inputSelectorResultsObject, options, inputSelectorArgs)=>{
    const { memoize: memoize, memoizeOptions: memoizeOptions } = options;
    const { inputSelectorResults: inputSelectorResults, inputSelectorResultsCopy: inputSelectorResultsCopy } = inputSelectorResultsObject;
    const createAnEmptyObject = memoize(()=>({}), ...memoizeOptions);
    const areInputSelectorResultsEqual = createAnEmptyObject.apply(null, inputSelectorResults) === createAnEmptyObject.apply(null, inputSelectorResultsCopy);
    if (!areInputSelectorResultsEqual) {
        let stack = void 0;
        try {
            throw new Error();
        } catch (e) {
            ({ stack: stack } = e);
        }
        console.warn("An input selector returned a different result when passed same arguments.\nThis means your output selector will likely run more frequently than intended.\nAvoid returning a new reference inside your input selector, e.g.\n`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)`", {
            arguments: inputSelectorArgs,
            firstInputs: inputSelectorResults,
            secondInputs: inputSelectorResultsCopy,
            stack: stack
        });
    }
};
// src/devModeChecks/setGlobalDevModeChecks.ts
var $757e1d271f969f78$var$globalDevModeChecks = {
    inputStabilityCheck: "once",
    identityFunctionCheck: "once"
};
var $757e1d271f969f78$export$1e290349de99e28c = (devModeChecks)=>{
    Object.assign($757e1d271f969f78$var$globalDevModeChecks, devModeChecks);
};
// src/utils.ts
var $757e1d271f969f78$var$NOT_FOUND = /* @__PURE__ */ Symbol("NOT_FOUND");
function $757e1d271f969f78$var$assertIsFunction(func, errorMessage = `expected a function, instead received ${typeof func}`) {
    if (typeof func !== "function") throw new TypeError(errorMessage);
}
function $757e1d271f969f78$var$assertIsObject(object, errorMessage = `expected an object, instead received ${typeof object}`) {
    if (typeof object !== "object") throw new TypeError(errorMessage);
}
function $757e1d271f969f78$var$assertIsArrayOfFunctions(array, errorMessage = `expected all items to be functions, instead received the following types: `) {
    if (!array.every((item)=>typeof item === "function")) {
        const itemTypes = array.map((item)=>typeof item === "function" ? `function ${item.name || "unnamed"}()` : typeof item).join(", ");
        throw new TypeError(`${errorMessage}[${itemTypes}]`);
    }
}
var $757e1d271f969f78$var$ensureIsArray = (item)=>{
    return Array.isArray(item) ? item : [
        item
    ];
};
function $757e1d271f969f78$var$getDependencies(createSelectorArgs) {
    const dependencies = Array.isArray(createSelectorArgs[0]) ? createSelectorArgs[0] : createSelectorArgs;
    $757e1d271f969f78$var$assertIsArrayOfFunctions(dependencies, `createSelector expects all input-selectors to be functions, but received the following types: `);
    return dependencies;
}
function $757e1d271f969f78$var$collectInputSelectorResults(dependencies, inputSelectorArgs) {
    const inputSelectorResults = [];
    const { length: length } = dependencies;
    for(let i = 0; i < length; i++)inputSelectorResults.push(dependencies[i].apply(null, inputSelectorArgs));
    return inputSelectorResults;
}
var $757e1d271f969f78$var$getDevModeChecksExecutionInfo = (firstRun, devModeChecks)=>{
    const { identityFunctionCheck: identityFunctionCheck, inputStabilityCheck: inputStabilityCheck } = {
        ...$757e1d271f969f78$var$globalDevModeChecks,
        ...devModeChecks
    };
    return {
        identityFunctionCheck: {
            shouldRun: identityFunctionCheck === "always" || identityFunctionCheck === "once" && firstRun,
            run: $757e1d271f969f78$var$runIdentityFunctionCheck
        },
        inputStabilityCheck: {
            shouldRun: inputStabilityCheck === "always" || inputStabilityCheck === "once" && firstRun,
            run: $757e1d271f969f78$var$runInputStabilityCheck
        }
    };
};
// src/autotrackMemoize/autotracking.ts
var $757e1d271f969f78$var$$REVISION = 0;
var $757e1d271f969f78$var$CURRENT_TRACKER = null;
var $757e1d271f969f78$var$Cell = class {
    revision = $757e1d271f969f78$var$$REVISION;
    _value;
    _lastValue;
    _isEqual = $757e1d271f969f78$var$tripleEq;
    constructor(initialValue, isEqual = $757e1d271f969f78$var$tripleEq){
        this._value = this._lastValue = initialValue;
        this._isEqual = isEqual;
    }
    // Whenever a storage value is read, it'll add itself to the current tracker if
    // one exists, entangling its state with that cache.
    get value() {
        $757e1d271f969f78$var$CURRENT_TRACKER?.add(this);
        return this._value;
    }
    // Whenever a storage value is updated, we bump the global revision clock,
    // assign the revision for this storage to the new value, _and_ we schedule a
    // rerender. This is important, and it's what makes autotracking  _pull_
    // based. We don't actively tell the caches which depend on the storage that
    // anything has happened. Instead, we recompute the caches when needed.
    set value(newValue) {
        if (this.value === newValue) return;
        this._value = newValue;
        this.revision = ++$757e1d271f969f78$var$$REVISION;
    }
};
function $757e1d271f969f78$var$tripleEq(a, b) {
    return a === b;
}
var $757e1d271f969f78$var$TrackingCache = class {
    _cachedValue;
    _cachedRevision = -1;
    _deps = [];
    hits = 0;
    fn;
    constructor(fn){
        this.fn = fn;
    }
    clear() {
        this._cachedValue = void 0;
        this._cachedRevision = -1;
        this._deps = [];
        this.hits = 0;
    }
    get value() {
        if (this.revision > this._cachedRevision) {
            const { fn: fn } = this;
            const currentTracker = /* @__PURE__ */ new Set();
            const prevTracker = $757e1d271f969f78$var$CURRENT_TRACKER;
            $757e1d271f969f78$var$CURRENT_TRACKER = currentTracker;
            this._cachedValue = fn();
            $757e1d271f969f78$var$CURRENT_TRACKER = prevTracker;
            this.hits++;
            this._deps = Array.from(currentTracker);
            this._cachedRevision = this.revision;
        }
        $757e1d271f969f78$var$CURRENT_TRACKER?.add(this);
        return this._cachedValue;
    }
    get revision() {
        return Math.max(...this._deps.map((d)=>d.revision), 0);
    }
};
function $757e1d271f969f78$var$getValue(cell) {
    if (!(cell instanceof $757e1d271f969f78$var$Cell)) console.warn("Not a valid cell! ", cell);
    return cell.value;
}
function $757e1d271f969f78$var$setValue(storage, value) {
    if (!(storage instanceof $757e1d271f969f78$var$Cell)) throw new TypeError("setValue must be passed a tracked store created with `createStorage`.");
    storage.value = storage._lastValue = value;
}
function $757e1d271f969f78$var$createCell(initialValue, isEqual = $757e1d271f969f78$var$tripleEq) {
    return new $757e1d271f969f78$var$Cell(initialValue, isEqual);
}
function $757e1d271f969f78$var$createCache(fn) {
    $757e1d271f969f78$var$assertIsFunction(fn, "the first parameter to `createCache` must be a function");
    return new $757e1d271f969f78$var$TrackingCache(fn);
}
// src/autotrackMemoize/tracking.ts
var $757e1d271f969f78$var$neverEq = (a, b)=>false;
function $757e1d271f969f78$var$createTag() {
    return $757e1d271f969f78$var$createCell(null, $757e1d271f969f78$var$neverEq);
}
function $757e1d271f969f78$var$dirtyTag(tag, value) {
    $757e1d271f969f78$var$setValue(tag, value);
}
var $757e1d271f969f78$var$consumeCollection = (node)=>{
    let tag = node.collectionTag;
    if (tag === null) tag = node.collectionTag = $757e1d271f969f78$var$createTag();
    $757e1d271f969f78$var$getValue(tag);
};
var $757e1d271f969f78$var$dirtyCollection = (node)=>{
    const tag = node.collectionTag;
    if (tag !== null) $757e1d271f969f78$var$dirtyTag(tag, null);
};
// src/autotrackMemoize/proxy.ts
var $757e1d271f969f78$var$REDUX_PROXY_LABEL = Symbol();
var $757e1d271f969f78$var$nextId = 0;
var $757e1d271f969f78$var$proto = Object.getPrototypeOf({});
var $757e1d271f969f78$var$ObjectTreeNode = class {
    constructor(value){
        this.value = value;
        this.value = value;
        this.tag.value = value;
    }
    proxy = new Proxy(this, $757e1d271f969f78$var$objectProxyHandler);
    tag = $757e1d271f969f78$var$createTag();
    tags = {};
    children = {};
    collectionTag = null;
    id = $757e1d271f969f78$var$nextId++;
};
var $757e1d271f969f78$var$objectProxyHandler = {
    get (node, key) {
        function calculateResult() {
            const { value: value } = node;
            const childValue = Reflect.get(value, key);
            if (typeof key === "symbol") return childValue;
            if (key in $757e1d271f969f78$var$proto) return childValue;
            if (typeof childValue === "object" && childValue !== null) {
                let childNode = node.children[key];
                if (childNode === void 0) childNode = node.children[key] = $757e1d271f969f78$var$createNode(childValue);
                if (childNode.tag) $757e1d271f969f78$var$getValue(childNode.tag);
                return childNode.proxy;
            } else {
                let tag = node.tags[key];
                if (tag === void 0) {
                    tag = node.tags[key] = $757e1d271f969f78$var$createTag();
                    tag.value = childValue;
                }
                $757e1d271f969f78$var$getValue(tag);
                return childValue;
            }
        }
        const res = calculateResult();
        return res;
    },
    ownKeys (node) {
        $757e1d271f969f78$var$consumeCollection(node);
        return Reflect.ownKeys(node.value);
    },
    getOwnPropertyDescriptor (node, prop) {
        return Reflect.getOwnPropertyDescriptor(node.value, prop);
    },
    has (node, prop) {
        return Reflect.has(node.value, prop);
    }
};
var $757e1d271f969f78$var$ArrayTreeNode = class {
    constructor(value){
        this.value = value;
        this.value = value;
        this.tag.value = value;
    }
    proxy = new Proxy([
        this
    ], $757e1d271f969f78$var$arrayProxyHandler);
    tag = $757e1d271f969f78$var$createTag();
    tags = {};
    children = {};
    collectionTag = null;
    id = $757e1d271f969f78$var$nextId++;
};
var $757e1d271f969f78$var$arrayProxyHandler = {
    get ([node], key) {
        if (key === "length") $757e1d271f969f78$var$consumeCollection(node);
        return $757e1d271f969f78$var$objectProxyHandler.get(node, key);
    },
    ownKeys ([node]) {
        return $757e1d271f969f78$var$objectProxyHandler.ownKeys(node);
    },
    getOwnPropertyDescriptor ([node], prop) {
        return $757e1d271f969f78$var$objectProxyHandler.getOwnPropertyDescriptor(node, prop);
    },
    has ([node], prop) {
        return $757e1d271f969f78$var$objectProxyHandler.has(node, prop);
    }
};
function $757e1d271f969f78$var$createNode(value) {
    if (Array.isArray(value)) return new $757e1d271f969f78$var$ArrayTreeNode(value);
    return new $757e1d271f969f78$var$ObjectTreeNode(value);
}
function $757e1d271f969f78$var$updateNode(node, newValue) {
    const { value: value, tags: tags, children: children } = node;
    node.value = newValue;
    if (Array.isArray(value) && Array.isArray(newValue) && value.length !== newValue.length) $757e1d271f969f78$var$dirtyCollection(node);
    else if (value !== newValue) {
        let oldKeysSize = 0;
        let newKeysSize = 0;
        let anyKeysAdded = false;
        for(const _key in value)oldKeysSize++;
        for(const key in newValue){
            newKeysSize++;
            if (!(key in value)) {
                anyKeysAdded = true;
                break;
            }
        }
        const isDifferent = anyKeysAdded || oldKeysSize !== newKeysSize;
        if (isDifferent) $757e1d271f969f78$var$dirtyCollection(node);
    }
    for(const key in tags){
        const childValue = value[key];
        const newChildValue = newValue[key];
        if (childValue !== newChildValue) {
            $757e1d271f969f78$var$dirtyCollection(node);
            $757e1d271f969f78$var$dirtyTag(tags[key], newChildValue);
        }
        if (typeof newChildValue === "object" && newChildValue !== null) delete tags[key];
    }
    for(const key in children){
        const childNode = children[key];
        const newChildValue = newValue[key];
        const childValue = childNode.value;
        if (childValue === newChildValue) continue;
        else if (typeof newChildValue === "object" && newChildValue !== null) $757e1d271f969f78$var$updateNode(childNode, newChildValue);
        else {
            $757e1d271f969f78$var$deleteNode(childNode);
            delete children[key];
        }
    }
}
function $757e1d271f969f78$var$deleteNode(node) {
    if (node.tag) $757e1d271f969f78$var$dirtyTag(node.tag, null);
    $757e1d271f969f78$var$dirtyCollection(node);
    for(const key in node.tags)$757e1d271f969f78$var$dirtyTag(node.tags[key], null);
    for(const key in node.children)$757e1d271f969f78$var$deleteNode(node.children[key]);
}
// src/lruMemoize.ts
function $757e1d271f969f78$var$createSingletonCache(equals) {
    let entry;
    return {
        get (key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $757e1d271f969f78$var$NOT_FOUND;
        },
        put (key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries () {
            return entry ? [
                entry
            ] : [];
        },
        clear () {
            entry = void 0;
        }
    };
}
function $757e1d271f969f78$var$createLruCache(maxSize, equals) {
    let entries = [];
    function get(key) {
        const cacheIndex = entries.findIndex((entry)=>equals(key, entry.key));
        if (cacheIndex > -1) {
            const entry = entries[cacheIndex];
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        }
        return $757e1d271f969f78$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $757e1d271f969f78$var$NOT_FOUND) {
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $757e1d271f969f78$export$3f025202a230c6dd = (a, b)=>a === b;
function $757e1d271f969f78$var$createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
        const { length: length } = prev;
        for(let i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $757e1d271f969f78$export$d8ead1d92249919b(func, equalityCheckOrOptions) {
    const providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    const { equalityCheck: equalityCheck = $757e1d271f969f78$export$3f025202a230c6dd, maxSize: maxSize = 1, resultEqualityCheck: resultEqualityCheck } = providedOptions;
    const comparator = $757e1d271f969f78$var$createCacheKeyComparator(equalityCheck);
    let resultsCount = 0;
    const cache = maxSize <= 1 ? $757e1d271f969f78$var$createSingletonCache(comparator) : $757e1d271f969f78$var$createLruCache(maxSize, comparator);
    function memoized() {
        let value = cache.get(arguments);
        if (value === $757e1d271f969f78$var$NOT_FOUND) {
            value = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const entries = cache.getEntries();
                const matchingEntry = entries.find((entry)=>resultEqualityCheck(entry.value, value));
                if (matchingEntry) {
                    value = matchingEntry.value;
                    resultsCount !== 0 && resultsCount--;
                }
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = ()=>{
        cache.clear();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/autotrackMemoize/autotrackMemoize.ts
function $757e1d271f969f78$export$c8f9cf88d9fdee55(func) {
    const node = $757e1d271f969f78$var$createNode([]);
    let lastArgs = null;
    const shallowEqual = $757e1d271f969f78$var$createCacheKeyComparator($757e1d271f969f78$export$3f025202a230c6dd);
    const cache = $757e1d271f969f78$var$createCache(()=>{
        const res = func.apply(null, node.proxy);
        return res;
    });
    function memoized() {
        if (!shallowEqual(lastArgs, arguments)) {
            $757e1d271f969f78$var$updateNode(node, arguments);
            lastArgs = arguments;
        }
        return cache.value;
    }
    memoized.clearCache = ()=>{
        return cache.clear();
    };
    return memoized;
}
// src/weakMapMemoize.ts
var $757e1d271f969f78$var$StrongRef = class {
    constructor(value){
        this.value = value;
    }
    deref() {
        return this.value;
    }
};
var $757e1d271f969f78$var$Ref = typeof WeakRef !== "undefined" ? WeakRef : $757e1d271f969f78$var$StrongRef;
var $757e1d271f969f78$var$UNTERMINATED = 0;
var $757e1d271f969f78$var$TERMINATED = 1;
function $757e1d271f969f78$var$createCacheNode() {
    return {
        s: $757e1d271f969f78$var$UNTERMINATED,
        v: void 0,
        o: null,
        p: null
    };
}
function $757e1d271f969f78$export$8402dc26d96f6902(func, options = {}) {
    let fnNode = $757e1d271f969f78$var$createCacheNode();
    const { resultEqualityCheck: resultEqualityCheck } = options;
    let lastResult;
    let resultsCount = 0;
    function memoized() {
        let cacheNode = fnNode;
        const { length: length } = arguments;
        for(let i = 0, l = length; i < l; i++){
            const arg = arguments[i];
            if (typeof arg === "function" || typeof arg === "object" && arg !== null) {
                let objectCache = cacheNode.o;
                if (objectCache === null) cacheNode.o = objectCache = /* @__PURE__ */ new WeakMap();
                const objectNode = objectCache.get(arg);
                if (objectNode === void 0) {
                    cacheNode = $757e1d271f969f78$var$createCacheNode();
                    objectCache.set(arg, cacheNode);
                } else cacheNode = objectNode;
            } else {
                let primitiveCache = cacheNode.p;
                if (primitiveCache === null) cacheNode.p = primitiveCache = /* @__PURE__ */ new Map();
                const primitiveNode = primitiveCache.get(arg);
                if (primitiveNode === void 0) {
                    cacheNode = $757e1d271f969f78$var$createCacheNode();
                    primitiveCache.set(arg, cacheNode);
                } else cacheNode = primitiveNode;
            }
        }
        const terminatedNode = cacheNode;
        let result;
        if (cacheNode.s === $757e1d271f969f78$var$TERMINATED) result = cacheNode.v;
        else {
            result = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const lastResultValue = lastResult?.deref?.() ?? lastResult;
                if (lastResultValue != null && resultEqualityCheck(lastResultValue, result)) {
                    result = lastResultValue;
                    resultsCount !== 0 && resultsCount--;
                }
                const needsWeakRef = typeof result === "object" && result !== null || typeof result === "function";
                lastResult = needsWeakRef ? new $757e1d271f969f78$var$Ref(result) : result;
            }
        }
        terminatedNode.s = $757e1d271f969f78$var$TERMINATED;
        terminatedNode.v = result;
        return result;
    }
    memoized.clearCache = ()=>{
        fnNode = $757e1d271f969f78$var$createCacheNode();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/createSelectorCreator.ts
function $757e1d271f969f78$export$5943f4447f6ef248(memoizeOrOptions, ...memoizeOptionsFromArgs) {
    const createSelectorCreatorOptions = typeof memoizeOrOptions === "function" ? {
        memoize: memoizeOrOptions,
        memoizeOptions: memoizeOptionsFromArgs
    } : memoizeOrOptions;
    const createSelector2 = (...createSelectorArgs)=>{
        let recomputations = 0;
        let dependencyRecomputations = 0;
        let lastResult;
        let directlyPassedOptions = {};
        let resultFunc = createSelectorArgs.pop();
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc;
            resultFunc = createSelectorArgs.pop();
        }
        $757e1d271f969f78$var$assertIsFunction(resultFunc, `createSelector expects an output function after the inputs, but received: [${typeof resultFunc}]`);
        const combinedOptions = {
            ...createSelectorCreatorOptions,
            ...directlyPassedOptions
        };
        const { memoize: memoize, memoizeOptions: memoizeOptions = [], argsMemoize: argsMemoize = $757e1d271f969f78$export$8402dc26d96f6902, argsMemoizeOptions: argsMemoizeOptions = [], devModeChecks: devModeChecks = {} } = combinedOptions;
        const finalMemoizeOptions = $757e1d271f969f78$var$ensureIsArray(memoizeOptions);
        const finalArgsMemoizeOptions = $757e1d271f969f78$var$ensureIsArray(argsMemoizeOptions);
        const dependencies = $757e1d271f969f78$var$getDependencies(createSelectorArgs);
        const memoizedResultFunc = memoize(function recomputationWrapper() {
            recomputations++;
            return resultFunc.apply(null, arguments);
        }, ...finalMemoizeOptions);
        let firstRun = true;
        const selector = argsMemoize(function dependenciesChecker() {
            dependencyRecomputations++;
            const inputSelectorResults = $757e1d271f969f78$var$collectInputSelectorResults(dependencies, arguments);
            lastResult = memoizedResultFunc.apply(null, inputSelectorResults);
            return lastResult;
        }, ...finalArgsMemoizeOptions);
        return Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            dependencyRecomputations: ()=>dependencyRecomputations,
            resetDependencyRecomputations: ()=>{
                dependencyRecomputations = 0;
            },
            lastResult: ()=>lastResult,
            recomputations: ()=>recomputations,
            resetRecomputations: ()=>{
                recomputations = 0;
            },
            memoize: memoize,
            argsMemoize: argsMemoize
        });
    };
    Object.assign(createSelector2, {
        withTypes: ()=>createSelector2
    });
    return createSelector2;
}
var $757e1d271f969f78$export$595d22ed68ca2841 = /* @__PURE__ */ $757e1d271f969f78$export$5943f4447f6ef248($757e1d271f969f78$export$8402dc26d96f6902);
// src/createStructuredSelector.ts
var $757e1d271f969f78$export$75979cfcd91bf38f = Object.assign((inputSelectorsObject, selectorCreator = $757e1d271f969f78$export$595d22ed68ca2841)=>{
    $757e1d271f969f78$var$assertIsObject(inputSelectorsObject, `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof inputSelectorsObject}`);
    const inputSelectorKeys = Object.keys(inputSelectorsObject);
    const dependencies = inputSelectorKeys.map((key)=>inputSelectorsObject[key]);
    const structuredSelector = selectorCreator(dependencies, (...inputSelectorResults)=>{
        return inputSelectorResults.reduce((composition, value, index)=>{
            composition[inputSelectorKeys[index]] = value;
            return composition;
        }, {});
    });
    return structuredSelector;
}, {
    withTypes: ()=>$757e1d271f969f78$export$75979cfcd91bf38f
});


// src/index.ts
function $69ff0e6811992ee0$var$createThunkMiddleware(extraArgument) {
    const middleware = ({ dispatch: dispatch, getState: getState })=>(next)=>(action)=>{
                if (typeof action === "function") return action(dispatch, getState, extraArgument);
                return next(action);
            };
    return middleware;
}
var $69ff0e6811992ee0$export$dd164f5517779f15 = $69ff0e6811992ee0$var$createThunkMiddleware();
var $69ff0e6811992ee0$export$16d06542a1949d9e = $69ff0e6811992ee0$var$createThunkMiddleware;


// src/createDraftSafeSelector.ts
var $df8b6ce3f4df1ba5$export$aab6de9e3dbb1473 = (...args)=>{
    const createSelector2 = (0, $757e1d271f969f78$export$5943f4447f6ef248)(...args);
    const createDraftSafeSelector2 = Object.assign((...args2)=>{
        const selector = createSelector2(...args2);
        const wrappedSelector = (value, ...rest)=>selector((0, $e922645e3176d997$export$541ac630993a4c84)(value) ? (0, $e922645e3176d997$export$97aac956da55dae9)(value) : value, ...rest);
        Object.assign(wrappedSelector, selector);
        return wrappedSelector;
    }, {
        withTypes: ()=>createDraftSafeSelector2
    });
    return createDraftSafeSelector2;
};
var $df8b6ce3f4df1ba5$export$a5d3c27355e35910 = /* @__PURE__ */ $df8b6ce3f4df1ba5$export$aab6de9e3dbb1473((0, $757e1d271f969f78$export$8402dc26d96f6902));
// src/devtoolsExtension.ts
var $df8b6ce3f4df1ba5$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $6c2d3c9c387cb6cd$export$f672e0b6f7222cd7;
    return (0, $6c2d3c9c387cb6cd$export$f672e0b6f7222cd7).apply(null, arguments);
};
var $df8b6ce3f4df1ba5$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop3) {
        return noop3;
    };
};
// src/tsHelpers.ts
var $df8b6ce3f4df1ba5$var$hasMatchFunction = (v)=>{
    return v && typeof v.match === "function";
};
// src/createAction.ts
function $df8b6ce3f4df1ba5$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator(...args) {
        if (prepareAction) {
            let prepared = prepareAction(...args);
            if (!prepared) throw new Error($df8b6ce3f4df1ba5$export$378fa86b259c0280(0));
            return {
                type: type,
                payload: prepared.payload,
                ..."meta" in prepared && {
                    meta: prepared.meta
                },
                ..."error" in prepared && {
                    error: prepared.error
                }
            };
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = ()=>`${type}`;
    actionCreator.type = type;
    actionCreator.match = (action)=>(0, $6c2d3c9c387cb6cd$export$b956e38827fca970)(action) && action.type === type;
    return actionCreator;
}
function $df8b6ce3f4df1ba5$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && // hasMatchFunction only wants Matchers but I don't see the point in rewriting it
    $df8b6ce3f4df1ba5$var$hasMatchFunction(action);
}
function $df8b6ce3f4df1ba5$export$ebd532f9034651f3(action) {
    return (0, $6c2d3c9c387cb6cd$export$b956e38827fca970)(action) && Object.keys(action).every($df8b6ce3f4df1ba5$var$isValidKey);
}
function $df8b6ce3f4df1ba5$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
// src/actionCreatorInvariantMiddleware.ts
function $df8b6ce3f4df1ba5$var$getMessage(type) {
    const splitType = type ? `${type}`.split("/") : [];
    const actionName = splitType[splitType.length - 1] || "actionCreator";
    return `Detected an action creator with type "${type || "unknown"}" being dispatched. 
Make sure you're calling the action creator before dispatching, i.e. \`dispatch(${actionName}())\` instead of \`dispatch(${actionName})\`. This is necessary even if the action has no payload.`;
}
function $df8b6ce3f4df1ba5$export$6a1fcb4ceef578f(options = {}) {
    var next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/utils.ts
function $df8b6ce3f4df1ba5$var$getTimeMeasureUtils(maxDelay, fnName) {
    let elapsed = 0;
    return {
        measureTime (fn) {
            const started = Date.now();
            try {
                return fn();
            } finally{
                const finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded () {
            if (elapsed > maxDelay) console.warn(`${fnName} took ${elapsed}ms, which is more than the warning threshold of ${maxDelay}ms. 
If your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.
It is disabled in production builds, so you don't need to worry about that.`);
        }
    };
}
var $df8b6ce3f4df1ba5$export$1908877435b1d5e9 = class _Tuple extends Array {
    constructor(...items){
        super(...items);
        Object.setPrototypeOf(this, _Tuple.prototype);
    }
    static get [Symbol.species]() {
        return _Tuple;
    }
    concat(...arr) {
        return super.concat.apply(this, arr);
    }
    prepend(...arr) {
        if (arr.length === 1 && Array.isArray(arr[0])) return new _Tuple(...arr[0].concat(this));
        return new _Tuple(...arr.concat(this));
    }
};
function $df8b6ce3f4df1ba5$var$freezeDraftable(val) {
    return (0, $e922645e3176d997$export$16e3aed3edb85946)(val) ? (0, $e922645e3176d997$export$b46cabe22e78bc00)(val, ()=>{}) : val;
}
function $df8b6ce3f4df1ba5$var$getOrInsertComputed(map, key, compute) {
    if (map.has(key)) return map.get(key);
    return map.set(key, compute(key)).get(key);
}
// src/immutableStateInvariantMiddleware.ts
function $df8b6ce3f4df1ba5$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $df8b6ce3f4df1ba5$var$trackForMutations(isImmutable, ignoredPaths, obj) {
    const trackedProperties = $df8b6ce3f4df1ba5$var$trackProperties(isImmutable, ignoredPaths, obj);
    return {
        detectMutations () {
            return $df8b6ce3f4df1ba5$var$detectMutations(isImmutable, ignoredPaths, trackedProperties, obj);
        }
    };
}
function $df8b6ce3f4df1ba5$var$trackProperties(isImmutable, ignoredPaths = [], obj, path = "", checkedObjects = /* @__PURE__ */ new Set()) {
    const tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        const hasIgnoredPaths = ignoredPaths.length > 0;
        for(const key in obj){
            const nestedPath = path ? path + "." + key : key;
            if (hasIgnoredPaths) {
                const hasMatches = ignoredPaths.some((ignored)=>{
                    if (ignored instanceof RegExp) return ignored.test(nestedPath);
                    return nestedPath === ignored;
                });
                if (hasMatches) continue;
            }
            tracked.children[key] = $df8b6ce3f4df1ba5$var$trackProperties(isImmutable, ignoredPaths, obj[key], nestedPath);
        }
    }
    return tracked;
}
function $df8b6ce3f4df1ba5$var$detectMutations(isImmutable, ignoredPaths = [], trackedProperty, obj, sameParentRef = false, path = "") {
    const prevObj = trackedProperty ? trackedProperty.value : void 0;
    const sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    const keysToDetect = {};
    for(let key in trackedProperty.children)keysToDetect[key] = true;
    for(let key in obj)keysToDetect[key] = true;
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for(let key in keysToDetect){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        const result = $df8b6ce3f4df1ba5$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return result;
    }
    return {
        wasMutated: false
    };
}
function $df8b6ce3f4df1ba5$export$9181bb1a5474289(options = {}) {
    var stringify, getSerialize, getState, next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/serializableStateInvariantMiddleware.ts
function $df8b6ce3f4df1ba5$export$77670485918dab4e(val) {
    const type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || (0, $6c2d3c9c387cb6cd$export$53b83ca8eaab0383)(val);
}
function $df8b6ce3f4df1ba5$export$ada5dca0b571bc7(value, path = "", isSerializable = $df8b6ce3f4df1ba5$export$77670485918dab4e, getEntries, ignoredPaths = [], cache) {
    let foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache?.has(value)) return false;
    const entries = getEntries != null ? getEntries(value) : Object.entries(value);
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for (const [key, nestedValue] of entries){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        if (!isSerializable(nestedValue)) return {
            keyPath: nestedPath,
            value: nestedValue
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $df8b6ce3f4df1ba5$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return foundNestedSerializable;
        }
    }
    if (cache && $df8b6ce3f4df1ba5$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $df8b6ce3f4df1ba5$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for (const nestedValue of Object.values(value)){
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!$df8b6ce3f4df1ba5$var$isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function $df8b6ce3f4df1ba5$export$6dea1aad6dac5ac2(options = {}) {
    var storeAPI, next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/getDefaultMiddleware.ts
function $df8b6ce3f4df1ba5$var$isBoolean(x) {
    return typeof x === "boolean";
}
var $df8b6ce3f4df1ba5$var$buildGetDefaultMiddleware = ()=>function getDefaultMiddleware(options) {
        const { thunk: thunk = true, immutableCheck: immutableCheck = true, serializableCheck: serializableCheck = true, actionCreatorCheck: actionCreatorCheck = true } = options ?? {};
        let middlewareArray = new $df8b6ce3f4df1ba5$export$1908877435b1d5e9();
        if (thunk) {
            if ($df8b6ce3f4df1ba5$var$isBoolean(thunk)) middlewareArray.push((0, $69ff0e6811992ee0$export$dd164f5517779f15));
            else middlewareArray.push((0, $69ff0e6811992ee0$export$16d06542a1949d9e)(thunk.extraArgument));
        }
        return middlewareArray;
    };
// src/autoBatchEnhancer.ts
var $df8b6ce3f4df1ba5$export$8fb31c0f05df007b = "RTK_autoBatch";
var $df8b6ce3f4df1ba5$export$39fcd5145ec5e4e2 = ()=>(payload)=>({
            payload: payload,
            meta: {
                [$df8b6ce3f4df1ba5$export$8fb31c0f05df007b]: true
            }
        });
var $df8b6ce3f4df1ba5$var$createQueueWithTimer = (timeout)=>{
    return (notify)=>{
        setTimeout(notify, timeout);
    };
};
var $df8b6ce3f4df1ba5$export$676277d7dca0f396 = (options = {
    type: "raf"
})=>(next)=>(...args)=>{
            const store = next(...args);
            let notifying = true;
            let shouldNotifyAtEndOfTick = false;
            let notificationQueued = false;
            const listeners = /* @__PURE__ */ new Set();
            const queueCallback = options.type === "tick" ? queueMicrotask : options.type === "raf" ? // requestAnimationFrame won't exist in SSR environments. Fall back to a vague approximation just to keep from erroring.
            typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $df8b6ce3f4df1ba5$var$createQueueWithTimer(10) : options.type === "callback" ? options.queueNotification : $df8b6ce3f4df1ba5$var$createQueueWithTimer(options.timeout);
            const notifyListeners = ()=>{
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach((l)=>l());
                }
            };
            return Object.assign({}, store, {
                // Override the base `store.subscribe` method to keep original listeners
                // from running if we're delaying notifications
                subscribe (listener2) {
                    const wrappedListener = ()=>notifying && listener2();
                    const unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return ()=>{
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                // Override the base `store.dispatch` method so that we can check actions
                // for the `shouldAutoBatch` flag and determine if batching is active
                dispatch (action) {
                    try {
                        notifying = !action?.meta?.[$df8b6ce3f4df1ba5$export$8fb31c0f05df007b];
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
// src/getDefaultEnhancers.ts
var $df8b6ce3f4df1ba5$var$buildGetDefaultEnhancers = (middlewareEnhancer)=>function getDefaultEnhancers(options) {
        const { autoBatch: autoBatch = true } = options ?? {};
        let enhancerArray = new $df8b6ce3f4df1ba5$export$1908877435b1d5e9(middlewareEnhancer);
        if (autoBatch) enhancerArray.push($df8b6ce3f4df1ba5$export$676277d7dca0f396(typeof autoBatch === "object" ? autoBatch : void 0));
        return enhancerArray;
    };
// src/configureStore.ts
function $df8b6ce3f4df1ba5$export$7d8a5b498da695ac(options) {
    const getDefaultMiddleware = $df8b6ce3f4df1ba5$var$buildGetDefaultMiddleware();
    const { reducer: reducer, middleware: middleware, devTools: devTools = true, duplicateMiddlewareCheck: duplicateMiddlewareCheck = true, preloadedState: preloadedState, enhancers: enhancers } = options || {};
    let rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ((0, $6c2d3c9c387cb6cd$export$53b83ca8eaab0383)(reducer)) rootReducer = (0, $6c2d3c9c387cb6cd$export$66e4520cdb265d18)(reducer);
    else throw new Error($df8b6ce3f4df1ba5$export$378fa86b259c0280(1));
    let finalMiddleware;
    if (typeof middleware === "function") finalMiddleware = middleware(getDefaultMiddleware);
    else finalMiddleware = getDefaultMiddleware();
    var middleware2;
    let finalCompose = (0, $6c2d3c9c387cb6cd$export$f672e0b6f7222cd7);
    if (devTools) finalCompose = $df8b6ce3f4df1ba5$var$composeWithDevTools({
        // Enable capture of stack traces for dispatched Redux actions
        trace: false,
        ...typeof devTools === "object" && devTools
    });
    const middlewareEnhancer = (0, $6c2d3c9c387cb6cd$export$9ff26e0402cc7b7)(...finalMiddleware);
    const getDefaultEnhancers = $df8b6ce3f4df1ba5$var$buildGetDefaultEnhancers(middlewareEnhancer);
    let storeEnhancers = typeof enhancers === "function" ? enhancers(getDefaultEnhancers) : getDefaultEnhancers();
    const composedEnhancer = finalCompose(...storeEnhancers);
    return (0, $6c2d3c9c387cb6cd$export$f51a9068ac82ea43)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function $df8b6ce3f4df1ba5$var$executeReducerBuilderCallback(builderCallback) {
    const actionsMap = {};
    const actionMatchers = [];
    let defaultCaseReducer;
    const builder = {
        addCase (typeOrActionCreator, reducer) {
            const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error($df8b6ce3f4df1ba5$export$378fa86b259c0280(28));
            if (type in actionsMap) throw new Error($df8b6ce3f4df1ba5$export$378fa86b259c0280(29));
            actionsMap[type] = reducer;
            return builder;
        },
        addAsyncThunk (asyncThunk, reducers) {
            if (reducers.pending) actionsMap[asyncThunk.pending.type] = reducers.pending;
            if (reducers.rejected) actionsMap[asyncThunk.rejected.type] = reducers.rejected;
            if (reducers.fulfilled) actionsMap[asyncThunk.fulfilled.type] = reducers.fulfilled;
            if (reducers.settled) actionMatchers.push({
                matcher: asyncThunk.settled,
                reducer: reducers.settled
            });
            return builder;
        },
        addMatcher (matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase (reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $df8b6ce3f4df1ba5$var$isStateFunction(x) {
    return typeof x === "function";
}
function $df8b6ce3f4df1ba5$export$473eb76d322d0290(initialState, mapOrBuilderCallback) {
    let [actionsMap, finalActionMatchers, finalDefaultCaseReducer] = $df8b6ce3f4df1ba5$var$executeReducerBuilderCallback(mapOrBuilderCallback);
    let getInitialState;
    if ($df8b6ce3f4df1ba5$var$isStateFunction(initialState)) getInitialState = ()=>$df8b6ce3f4df1ba5$var$freezeDraftable(initialState());
    else {
        const frozenInitialState = $df8b6ce3f4df1ba5$var$freezeDraftable(initialState);
        getInitialState = ()=>frozenInitialState;
    }
    function reducer(state = getInitialState(), action) {
        let caseReducers = [
            actionsMap[action.type],
            ...finalActionMatchers.filter(({ matcher: matcher })=>matcher(action)).map(({ reducer: reducer2 })=>reducer2)
        ];
        if (caseReducers.filter((cr)=>!!cr).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce((previousState, caseReducer)=>{
            if (caseReducer) {
                if ((0, $e922645e3176d997$export$541ac630993a4c84)(previousState)) {
                    const draft = previousState;
                    const result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $e922645e3176d997$export$16e3aed3edb85946)(previousState)) {
                    const result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                } else return (0, $e922645e3176d997$export$b46cabe22e78bc00)(previousState, (draft)=>{
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/matchers.ts
var $df8b6ce3f4df1ba5$var$matches = (matcher, action)=>{
    if ($df8b6ce3f4df1ba5$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $df8b6ce3f4df1ba5$export$2c3435c7647f7b0d(...matchers) {
    return (action)=>{
        return matchers.some((matcher)=>$df8b6ce3f4df1ba5$var$matches(matcher, action));
    };
}
function $df8b6ce3f4df1ba5$export$9dd1fb32974da385(...matchers) {
    return (action)=>{
        return matchers.every((matcher)=>$df8b6ce3f4df1ba5$var$matches(matcher, action));
    };
}
function $df8b6ce3f4df1ba5$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    const hasValidRequestId = typeof action.meta.requestId === "string";
    const hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $df8b6ce3f4df1ba5$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $df8b6ce3f4df1ba5$export$872dec21e9a69476(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$df8b6ce3f4df1ba5$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    if (!$df8b6ce3f4df1ba5$var$isAsyncThunkArray(asyncThunks)) return $df8b6ce3f4df1ba5$export$872dec21e9a69476()(asyncThunks[0]);
    return $df8b6ce3f4df1ba5$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.pending));
}
function $df8b6ce3f4df1ba5$export$a5c5d27e3994c5be(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$df8b6ce3f4df1ba5$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    if (!$df8b6ce3f4df1ba5$var$isAsyncThunkArray(asyncThunks)) return $df8b6ce3f4df1ba5$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return $df8b6ce3f4df1ba5$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.rejected));
}
function $df8b6ce3f4df1ba5$export$fcc3388fb56de601(...asyncThunks) {
    const hasFlag = (action)=>{
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return $df8b6ce3f4df1ba5$export$9dd1fb32974da385($df8b6ce3f4df1ba5$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
    if (!$df8b6ce3f4df1ba5$var$isAsyncThunkArray(asyncThunks)) return $df8b6ce3f4df1ba5$export$fcc3388fb56de601()(asyncThunks[0]);
    return $df8b6ce3f4df1ba5$export$9dd1fb32974da385($df8b6ce3f4df1ba5$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
}
function $df8b6ce3f4df1ba5$export$1da80a6ef1307441(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$df8b6ce3f4df1ba5$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    if (!$df8b6ce3f4df1ba5$var$isAsyncThunkArray(asyncThunks)) return $df8b6ce3f4df1ba5$export$1da80a6ef1307441()(asyncThunks[0]);
    return $df8b6ce3f4df1ba5$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.fulfilled));
}
function $df8b6ce3f4df1ba5$export$6aa4142d99c1abce(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$df8b6ce3f4df1ba5$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    if (!$df8b6ce3f4df1ba5$var$isAsyncThunkArray(asyncThunks)) return $df8b6ce3f4df1ba5$export$6aa4142d99c1abce()(asyncThunks[0]);
    return $df8b6ce3f4df1ba5$export$2c3435c7647f7b0d(...asyncThunks.flatMap((asyncThunk)=>[
            asyncThunk.pending,
            asyncThunk.rejected,
            asyncThunk.fulfilled
        ]));
}
// src/nanoid.ts
var $df8b6ce3f4df1ba5$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $df8b6ce3f4df1ba5$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = "";
    let i = size;
    while(i--)id += $df8b6ce3f4df1ba5$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var $df8b6ce3f4df1ba5$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $df8b6ce3f4df1ba5$var$RejectWithValue = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
    }
    /*
  type-only property to distinguish between RejectWithValue and FulfillWithMeta
  does not exist at runtime
  */ _type;
};
var $df8b6ce3f4df1ba5$var$FulfillWithMeta = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
    }
    /*
  type-only property to distinguish between RejectWithValue and FulfillWithMeta
  does not exist at runtime
  */ _type;
};
var $df8b6ce3f4df1ba5$export$c97c53d0b2d5d81e = (value)=>{
    if (typeof value === "object" && value !== null) {
        const simpleError = {};
        for (const property of $df8b6ce3f4df1ba5$var$commonProperties)if (typeof value[property] === "string") simpleError[property] = value[property];
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $df8b6ce3f4df1ba5$var$externalAbortMessage = "External signal was aborted";
var $df8b6ce3f4df1ba5$export$6abd22dc03e5063f = /* @__PURE__ */ (()=>{
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        const fulfilled = $df8b6ce3f4df1ba5$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", (payload, requestId, arg, meta)=>({
                payload: payload,
                meta: {
                    ...meta || {},
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                }
            }));
        const pending = $df8b6ce3f4df1ba5$export$309c7a02b0b0bc62(typePrefix + "/pending", (requestId, arg, meta)=>({
                payload: void 0,
                meta: {
                    ...meta || {},
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                }
            }));
        const rejected = $df8b6ce3f4df1ba5$export$309c7a02b0b0bc62(typePrefix + "/rejected", (error, requestId, arg, payload, meta)=>({
                payload: payload,
                error: (options && options.serializeError || $df8b6ce3f4df1ba5$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: {
                    ...meta || {},
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: error?.name === "AbortError",
                    condition: error?.name === "ConditionError"
                }
            }));
        function actionCreator(arg, { signal: signal } = {}) {
            return (dispatch, getState, extra)=>{
                const requestId = options?.idGenerator ? options.idGenerator(arg) : $df8b6ce3f4df1ba5$export$ac4959f4f1338dfc();
                const abortController = new AbortController();
                let abortHandler;
                let abortReason;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                if (signal) {
                    if (signal.aborted) abort($df8b6ce3f4df1ba5$var$externalAbortMessage);
                    else signal.addEventListener("abort", ()=>abort($df8b6ce3f4df1ba5$var$externalAbortMessage), {
                        once: true
                    });
                }
                const promise = async function() {
                    let finalAction;
                    try {
                        let conditionResult = options?.condition?.(arg, {
                            getState: getState,
                            extra: extra
                        });
                        if ($df8b6ce3f4df1ba5$var$isThenable(conditionResult)) conditionResult = await conditionResult;
                        if (conditionResult === false || abortController.signal.aborted) throw {
                            name: "ConditionError",
                            message: "Aborted due to condition callback returning false."
                        };
                        const abortedPromise = new Promise((_, reject)=>{
                            abortHandler = ()=>{
                                reject({
                                    name: "AbortError",
                                    message: abortReason || "Aborted"
                                });
                            };
                            abortController.signal.addEventListener("abort", abortHandler, {
                                once: true
                            });
                        });
                        dispatch(pending(requestId, arg, options?.getPendingMeta?.({
                            requestId: requestId,
                            arg: arg
                        }, {
                            getState: getState,
                            extra: extra
                        })));
                        finalAction = await Promise.race([
                            abortedPromise,
                            Promise.resolve(payloadCreator(arg, {
                                dispatch: dispatch,
                                getState: getState,
                                extra: extra,
                                requestId: requestId,
                                signal: abortController.signal,
                                abort: abort,
                                rejectWithValue: (value, meta)=>{
                                    return new $df8b6ce3f4df1ba5$var$RejectWithValue(value, meta);
                                },
                                fulfillWithValue: (value, meta)=>{
                                    return new $df8b6ce3f4df1ba5$var$FulfillWithMeta(value, meta);
                                }
                            })).then((result)=>{
                                if (result instanceof $df8b6ce3f4df1ba5$var$RejectWithValue) throw result;
                                if (result instanceof $df8b6ce3f4df1ba5$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                return fulfilled(result, requestId, arg);
                            })
                        ]);
                    } catch (err) {
                        finalAction = err instanceof $df8b6ce3f4df1ba5$var$RejectWithValue ? rejected(null, requestId, arg, err.payload, err.meta) : rejected(err, requestId, arg);
                    } finally{
                        if (abortHandler) abortController.signal.removeEventListener("abort", abortHandler);
                    }
                    const skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                    if (!skipDispatch) dispatch(finalAction);
                    return finalAction;
                }();
                return Object.assign(promise, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap () {
                        return promise.then($df8b6ce3f4df1ba5$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            settled: $df8b6ce3f4df1ba5$export$2c3435c7647f7b0d(rejected, fulfilled),
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = ()=>createAsyncThunk2;
    return createAsyncThunk2;
})();
function $df8b6ce3f4df1ba5$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $df8b6ce3f4df1ba5$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/createSlice.ts
var $df8b6ce3f4df1ba5$var$asyncThunkSymbol = /* @__PURE__ */ Symbol.for("rtk-slice-createasyncthunk");
var $df8b6ce3f4df1ba5$export$343355ed40c51c46 = {
    [$df8b6ce3f4df1ba5$var$asyncThunkSymbol]: $df8b6ce3f4df1ba5$export$6abd22dc03e5063f
};
var $df8b6ce3f4df1ba5$export$23a094319a4b586 = /* @__PURE__ */ ((ReducerType2)=>{
    ReducerType2["reducer"] = "reducer";
    ReducerType2["reducerWithPrepare"] = "reducerWithPrepare";
    ReducerType2["asyncThunk"] = "asyncThunk";
    return ReducerType2;
})($df8b6ce3f4df1ba5$export$23a094319a4b586 || {});
function $df8b6ce3f4df1ba5$var$getType(slice, actionKey) {
    return `${slice}/${actionKey}`;
}
function $df8b6ce3f4df1ba5$export$affdea4146de9cf5({ creators: creators } = {}) {
    const cAT = creators?.asyncThunk?.[$df8b6ce3f4df1ba5$var$asyncThunkSymbol];
    return function createSlice2(options) {
        const { name: name, reducerPath: reducerPath = name } = options;
        if (!name) throw new Error($df8b6ce3f4df1ba5$export$378fa86b259c0280(11));
        const reducers = (typeof options.reducers === "function" ? options.reducers($df8b6ce3f4df1ba5$var$buildReducerCreators()) : options.reducers) || {};
        const reducerNames = Object.keys(reducers);
        const context = {
            sliceCaseReducersByName: {},
            sliceCaseReducersByType: {},
            actionCreators: {},
            sliceMatchers: []
        };
        const contextMethods = {
            addCase (typeOrActionCreator, reducer2) {
                const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
                if (!type) throw new Error($df8b6ce3f4df1ba5$export$378fa86b259c0280(12));
                if (type in context.sliceCaseReducersByType) throw new Error($df8b6ce3f4df1ba5$export$378fa86b259c0280(13));
                context.sliceCaseReducersByType[type] = reducer2;
                return contextMethods;
            },
            addMatcher (matcher, reducer2) {
                context.sliceMatchers.push({
                    matcher: matcher,
                    reducer: reducer2
                });
                return contextMethods;
            },
            exposeAction (name2, actionCreator) {
                context.actionCreators[name2] = actionCreator;
                return contextMethods;
            },
            exposeCaseReducer (name2, reducer2) {
                context.sliceCaseReducersByName[name2] = reducer2;
                return contextMethods;
            }
        };
        reducerNames.forEach((reducerName)=>{
            const reducerDefinition = reducers[reducerName];
            const reducerDetails = {
                reducerName: reducerName,
                type: $df8b6ce3f4df1ba5$var$getType(name, reducerName),
                createNotation: typeof options.reducers === "function"
            };
            if ($df8b6ce3f4df1ba5$var$isAsyncThunkSliceReducerDefinition(reducerDefinition)) $df8b6ce3f4df1ba5$var$handleThunkCaseReducerDefinition(reducerDetails, reducerDefinition, contextMethods, cAT);
            else $df8b6ce3f4df1ba5$var$handleNormalReducerDefinition(reducerDetails, reducerDefinition, contextMethods);
        });
        function buildReducer() {
            const [extraReducers = {}, actionMatchers = [], defaultCaseReducer] = typeof options.extraReducers === "function" ? $df8b6ce3f4df1ba5$var$executeReducerBuilderCallback(options.extraReducers) : [
                options.extraReducers
            ];
            const finalCaseReducers = {
                ...extraReducers,
                ...context.sliceCaseReducersByType
            };
            return $df8b6ce3f4df1ba5$export$473eb76d322d0290(options.initialState, (builder)=>{
                for(let key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
                for (let sM of context.sliceMatchers)builder.addMatcher(sM.matcher, sM.reducer);
                for (let m of actionMatchers)builder.addMatcher(m.matcher, m.reducer);
                if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
            });
        }
        const selectSelf = (state)=>state;
        const injectedSelectorCache = /* @__PURE__ */ new Map();
        const injectedStateCache = /* @__PURE__ */ new WeakMap();
        let _reducer;
        function reducer(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        }
        function getInitialState() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
        function makeSelectorProps(reducerPath2, injected = false) {
            function selectSlice(state) {
                let sliceState = state[reducerPath2];
                if (typeof sliceState === "undefined") {
                    if (injected) sliceState = $df8b6ce3f4df1ba5$var$getOrInsertComputed(injectedStateCache, selectSlice, getInitialState);
                }
                return sliceState;
            }
            function getSelectors(selectState = selectSelf) {
                const selectorCache = $df8b6ce3f4df1ba5$var$getOrInsertComputed(injectedSelectorCache, injected, ()=>/* @__PURE__ */ new WeakMap());
                return $df8b6ce3f4df1ba5$var$getOrInsertComputed(selectorCache, selectState, ()=>{
                    const map = {};
                    for (const [name2, selector] of Object.entries(options.selectors ?? {}))map[name2] = $df8b6ce3f4df1ba5$var$wrapSelector(selector, selectState, ()=>$df8b6ce3f4df1ba5$var$getOrInsertComputed(injectedStateCache, selectState, getInitialState), injected);
                    return map;
                });
            }
            return {
                reducerPath: reducerPath2,
                getSelectors: getSelectors,
                get selectors () {
                    return getSelectors(selectSlice);
                },
                selectSlice: selectSlice
            };
        }
        const slice = {
            name: name,
            reducer: reducer,
            actions: context.actionCreators,
            caseReducers: context.sliceCaseReducersByName,
            getInitialState: getInitialState,
            ...makeSelectorProps(reducerPath),
            injectInto (injectable, { reducerPath: pathOpt, ...config } = {}) {
                const newReducerPath = pathOpt ?? reducerPath;
                injectable.inject({
                    reducerPath: newReducerPath,
                    reducer: reducer
                }, config);
                return {
                    ...slice,
                    ...makeSelectorProps(newReducerPath, true)
                };
            }
        };
        return slice;
    };
}
function $df8b6ce3f4df1ba5$var$wrapSelector(selector, selectState, getInitialState, injected) {
    function wrapper(rootState, ...args) {
        let sliceState = selectState(rootState);
        if (typeof sliceState === "undefined") {
            if (injected) sliceState = getInitialState();
        }
        return selector(sliceState, ...args);
    }
    wrapper.unwrapped = selector;
    return wrapper;
}
var $df8b6ce3f4df1ba5$export$4d8d9bd83c24ae8b = /* @__PURE__ */ $df8b6ce3f4df1ba5$export$affdea4146de9cf5();
function $df8b6ce3f4df1ba5$var$buildReducerCreators() {
    function asyncThunk(payloadCreator, config) {
        return {
            _reducerDefinitionType: "asyncThunk" /* asyncThunk */ ,
            payloadCreator: payloadCreator,
            ...config
        };
    }
    asyncThunk.withTypes = ()=>asyncThunk;
    return {
        reducer (caseReducer) {
            return Object.assign({
                // hack so the wrapping function has the same name as the original
                // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
                [caseReducer.name] (...args) {
                    return caseReducer(...args);
                }
            }[caseReducer.name], {
                _reducerDefinitionType: "reducer" /* reducer */ 
            });
        },
        preparedReducer (prepare, reducer) {
            return {
                _reducerDefinitionType: "reducerWithPrepare" /* reducerWithPrepare */ ,
                prepare: prepare,
                reducer: reducer
            };
        },
        asyncThunk: asyncThunk
    };
}
function $df8b6ce3f4df1ba5$var$handleNormalReducerDefinition({ type: type, reducerName: reducerName, createNotation: createNotation }, maybeReducerWithPrepare, context) {
    let caseReducer;
    let prepareCallback;
    if ("reducer" in maybeReducerWithPrepare) {
        if (createNotation && !$df8b6ce3f4df1ba5$var$isCaseReducerWithPrepareDefinition(maybeReducerWithPrepare)) throw new Error($df8b6ce3f4df1ba5$export$378fa86b259c0280(17));
        caseReducer = maybeReducerWithPrepare.reducer;
        prepareCallback = maybeReducerWithPrepare.prepare;
    } else caseReducer = maybeReducerWithPrepare;
    context.addCase(type, caseReducer).exposeCaseReducer(reducerName, caseReducer).exposeAction(reducerName, prepareCallback ? $df8b6ce3f4df1ba5$export$309c7a02b0b0bc62(type, prepareCallback) : $df8b6ce3f4df1ba5$export$309c7a02b0b0bc62(type));
}
function $df8b6ce3f4df1ba5$var$isAsyncThunkSliceReducerDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "asyncThunk" /* asyncThunk */ ;
}
function $df8b6ce3f4df1ba5$var$isCaseReducerWithPrepareDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "reducerWithPrepare" /* reducerWithPrepare */ ;
}
function $df8b6ce3f4df1ba5$var$handleThunkCaseReducerDefinition({ type: type, reducerName: reducerName }, reducerDefinition, context, cAT) {
    if (!cAT) throw new Error($df8b6ce3f4df1ba5$export$378fa86b259c0280(18));
    const { payloadCreator: payloadCreator, fulfilled: fulfilled, pending: pending, rejected: rejected, settled: settled, options: options } = reducerDefinition;
    const thunk = cAT(type, payloadCreator, options);
    context.exposeAction(reducerName, thunk);
    if (fulfilled) context.addCase(thunk.fulfilled, fulfilled);
    if (pending) context.addCase(thunk.pending, pending);
    if (rejected) context.addCase(thunk.rejected, rejected);
    if (settled) context.addMatcher(thunk.settled, settled);
    context.exposeCaseReducer(reducerName, {
        fulfilled: fulfilled || $df8b6ce3f4df1ba5$var$noop,
        pending: pending || $df8b6ce3f4df1ba5$var$noop,
        rejected: rejected || $df8b6ce3f4df1ba5$var$noop,
        settled: settled || $df8b6ce3f4df1ba5$var$noop
    });
}
function $df8b6ce3f4df1ba5$var$noop() {}
// src/entities/entity_state.ts
function $df8b6ce3f4df1ba5$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $df8b6ce3f4df1ba5$var$createInitialStateFactory(stateAdapter) {
    function getInitialState(additionalState = {}, entities) {
        const state = Object.assign($df8b6ce3f4df1ba5$var$getInitialEntityState(), additionalState);
        return entities ? stateAdapter.setAll(state, entities) : state;
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $df8b6ce3f4df1ba5$var$createSelectorsFactory() {
    function getSelectors(selectState, options = {}) {
        const { createSelector: createSelector2 = $df8b6ce3f4df1ba5$export$a5d3c27355e35910 } = options;
        const selectIds = (state)=>state.ids;
        const selectEntities = (state)=>state.entities;
        const selectAll = createSelector2(selectIds, selectEntities, (ids, entities)=>ids.map((id)=>entities[id]));
        const selectId = (_, id)=>id;
        const selectById = (entities, id)=>entities[id];
        const selectTotal = createSelector2(selectIds, (ids)=>ids.length);
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: createSelector2(selectEntities, selectId, selectById)
        };
        const selectGlobalizedEntities = createSelector2(selectState, selectEntities);
        return {
            selectIds: createSelector2(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: createSelector2(selectState, selectAll),
            selectTotal: createSelector2(selectState, selectTotal),
            selectById: createSelector2(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
// src/entities/state_adapter.ts
var $df8b6ce3f4df1ba5$var$isDraftTyped = (0, $e922645e3176d997$export$541ac630993a4c84);
function $df8b6ce3f4df1ba5$var$createSingleArgumentStateOperator(mutator) {
    const operator = $df8b6ce3f4df1ba5$var$createStateOperator((_, state)=>mutator(state));
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $df8b6ce3f4df1ba5$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $df8b6ce3f4df1ba5$export$ebd532f9034651f3(arg2);
        }
        const runMutator = (draft)=>{
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ($df8b6ce3f4df1ba5$var$isDraftTyped(state)) {
            runMutator(state);
            return state;
        }
        return (0, $e922645e3176d997$export$b46cabe22e78bc00)(state, runMutator);
    };
}
// src/entities/utils.ts
function $df8b6ce3f4df1ba5$var$selectIdValue(entity, selectId) {
    const key = selectId(entity);
    return key;
}
function $df8b6ce3f4df1ba5$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $df8b6ce3f4df1ba5$var$getCurrent(value) {
    return (0, $e922645e3176d997$export$541ac630993a4c84)(value) ? (0, $e922645e3176d997$export$97aac956da55dae9)(value) : value;
}
function $df8b6ce3f4df1ba5$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $df8b6ce3f4df1ba5$var$ensureEntitiesArray(newEntities);
    const existingIdsArray = $df8b6ce3f4df1ba5$var$getCurrent(state.ids);
    const existingIds = new Set(existingIdsArray);
    const added = [];
    const addedIds = /* @__PURE__ */ new Set([]);
    const updated = [];
    for (const entity of newEntities){
        const id = $df8b6ce3f4df1ba5$var$selectIdValue(entity, selectId);
        if (existingIds.has(id) || addedIds.has(id)) updated.push({
            id: id,
            changes: entity
        });
        else {
            addedIds.add(id);
            added.push(entity);
        }
    }
    return [
        added,
        updated,
        existingIdsArray
    ];
}
// src/entities/unsorted_state_adapter.ts
function $df8b6ce3f4df1ba5$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        const key = $df8b6ce3f4df1ba5$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $df8b6ce3f4df1ba5$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)addOneMutably(entity, state);
    }
    function setOneMutably(entity, state) {
        const key = $df8b6ce3f4df1ba5$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $df8b6ce3f4df1ba5$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)setOneMutably(entity, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $df8b6ce3f4df1ba5$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        let didMutate = false;
        keys.forEach((key)=>{
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter((id)=>id in state.entities);
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        const original3 = state.entities[update.id];
        if (original3 === void 0) return false;
        const updated = Object.assign({}, original3, update.changes);
        const newKey = $df8b6ce3f4df1ba5$var$selectIdValue(updated, selectId);
        const hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        const newKeys = {};
        const updatesPerEntity = {};
        updates.forEach((update)=>{
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                // Spreads ignore falsy values, so this works even if there isn't
                // an existing update already at this key
                changes: {
                    ...updatesPerEntity[update.id]?.changes,
                    ...update.changes
                }
            };
        });
        updates = Object.values(updatesPerEntity);
        const didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            const didMutateIds = updates.filter((update)=>takeNewKey(newKeys, update, state)).length > 0;
            if (didMutateIds) state.ids = Object.values(state.entities).map((e)=>$df8b6ce3f4df1ba5$var$selectIdValue(e, selectId));
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated] = $df8b6ce3f4df1ba5$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        addManyMutably(added, state);
        updateManyMutably(updated, state);
    }
    return {
        removeAll: $df8b6ce3f4df1ba5$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $df8b6ce3f4df1ba5$var$createStateOperator(addOneMutably),
        addMany: $df8b6ce3f4df1ba5$var$createStateOperator(addManyMutably),
        setOne: $df8b6ce3f4df1ba5$var$createStateOperator(setOneMutably),
        setMany: $df8b6ce3f4df1ba5$var$createStateOperator(setManyMutably),
        setAll: $df8b6ce3f4df1ba5$var$createStateOperator(setAllMutably),
        updateOne: $df8b6ce3f4df1ba5$var$createStateOperator(updateOneMutably),
        updateMany: $df8b6ce3f4df1ba5$var$createStateOperator(updateManyMutably),
        upsertOne: $df8b6ce3f4df1ba5$var$createStateOperator(upsertOneMutably),
        upsertMany: $df8b6ce3f4df1ba5$var$createStateOperator(upsertManyMutably),
        removeOne: $df8b6ce3f4df1ba5$var$createStateOperator(removeOneMutably),
        removeMany: $df8b6ce3f4df1ba5$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $df8b6ce3f4df1ba5$var$findInsertIndex(sortedItems, item, comparisonFunction) {
    let lowIndex = 0;
    let highIndex = sortedItems.length;
    while(lowIndex < highIndex){
        let middleIndex = lowIndex + highIndex >>> 1;
        const currentItem = sortedItems[middleIndex];
        const res = comparisonFunction(item, currentItem);
        if (res >= 0) lowIndex = middleIndex + 1;
        else highIndex = middleIndex;
    }
    return lowIndex;
}
function $df8b6ce3f4df1ba5$var$insert(sortedItems, item, comparisonFunction) {
    const insertAtIndex = $df8b6ce3f4df1ba5$var$findInsertIndex(sortedItems, item, comparisonFunction);
    sortedItems.splice(insertAtIndex, 0, item);
    return sortedItems;
}
function $df8b6ce3f4df1ba5$var$createSortedStateAdapter(selectId, comparer) {
    const { removeOne: removeOne, removeMany: removeMany, removeAll: removeAll } = $df8b6ce3f4df1ba5$var$createUnsortedStateAdapter(selectId);
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state, existingIds) {
        newEntities = $df8b6ce3f4df1ba5$var$ensureEntitiesArray(newEntities);
        const existingKeys = new Set(existingIds ?? $df8b6ce3f4df1ba5$var$getCurrent(state.ids));
        const addedKeys = /* @__PURE__ */ new Set();
        const models = newEntities.filter((model)=>{
            const modelId = $df8b6ce3f4df1ba5$var$selectIdValue(model, selectId);
            const notAdded = !addedKeys.has(modelId);
            if (notAdded) addedKeys.add(modelId);
            return !existingKeys.has(modelId) && notAdded;
        });
        if (models.length !== 0) mergeFunction(state, models);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        let deduplicatedEntities = {};
        newEntities = $df8b6ce3f4df1ba5$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) {
            for (const item of newEntities){
                const entityId = selectId(item);
                deduplicatedEntities[entityId] = item;
                delete state.entities[entityId];
            }
            newEntities = $df8b6ce3f4df1ba5$var$ensureEntitiesArray(deduplicatedEntities);
            mergeFunction(state, newEntities);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $df8b6ce3f4df1ba5$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state, []);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        let appliedUpdates = false;
        let replacedIds = false;
        for (let update of updates){
            const entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            const newId = selectId(entity);
            if (update.id !== newId) {
                replacedIds = true;
                delete state.entities[update.id];
                const oldIndex = state.ids.indexOf(update.id);
                state.ids[oldIndex] = newId;
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) mergeFunction(state, [], appliedUpdates, replacedIds);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated, existingIdsArray] = $df8b6ce3f4df1ba5$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        if (added.length) addManyMutably(added, state, existingIdsArray);
        if (updated.length) updateManyMutably(updated, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    const mergeFunction = (state, addedItems, appliedUpdates, replacedIds)=>{
        const currentEntities = $df8b6ce3f4df1ba5$var$getCurrent(state.entities);
        const currentIds = $df8b6ce3f4df1ba5$var$getCurrent(state.ids);
        const stateEntities = state.entities;
        let ids = currentIds;
        if (replacedIds) ids = new Set(currentIds);
        let sortedEntities = [];
        for (const id of ids){
            const entity = currentEntities[id];
            if (entity) sortedEntities.push(entity);
        }
        const wasPreviouslyEmpty = sortedEntities.length === 0;
        for (const item of addedItems){
            stateEntities[selectId(item)] = item;
            if (!wasPreviouslyEmpty) $df8b6ce3f4df1ba5$var$insert(sortedEntities, item, comparer);
        }
        if (wasPreviouslyEmpty) sortedEntities = addedItems.slice().sort(comparer);
        else if (appliedUpdates) sortedEntities.sort(comparer);
        const newSortedIds = sortedEntities.map(selectId);
        if (!areArraysEqual(currentIds, newSortedIds)) state.ids = newSortedIds;
    };
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $df8b6ce3f4df1ba5$var$createStateOperator(addOneMutably),
        updateOne: $df8b6ce3f4df1ba5$var$createStateOperator(updateOneMutably),
        upsertOne: $df8b6ce3f4df1ba5$var$createStateOperator(upsertOneMutably),
        setOne: $df8b6ce3f4df1ba5$var$createStateOperator(setOneMutably),
        setMany: $df8b6ce3f4df1ba5$var$createStateOperator(setManyMutably),
        setAll: $df8b6ce3f4df1ba5$var$createStateOperator(setAllMutably),
        addMany: $df8b6ce3f4df1ba5$var$createStateOperator(addManyMutably),
        updateMany: $df8b6ce3f4df1ba5$var$createStateOperator(updateManyMutably),
        upsertMany: $df8b6ce3f4df1ba5$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $df8b6ce3f4df1ba5$export$abcf4037b41e0df(options = {}) {
    const { selectId: selectId, sortComparer: sortComparer } = {
        sortComparer: false,
        selectId: (instance)=>instance.id,
        ...options
    };
    const stateAdapter = sortComparer ? $df8b6ce3f4df1ba5$var$createSortedStateAdapter(selectId, sortComparer) : $df8b6ce3f4df1ba5$var$createUnsortedStateAdapter(selectId);
    const stateFactory = $df8b6ce3f4df1ba5$var$createInitialStateFactory(stateAdapter);
    const selectorsFactory = $df8b6ce3f4df1ba5$var$createSelectorsFactory();
    return {
        selectId: selectId,
        sortComparer: sortComparer,
        ...stateFactory,
        ...selectorsFactory,
        ...stateAdapter
    };
}
// src/listenerMiddleware/exceptions.ts
var $df8b6ce3f4df1ba5$var$task = "task";
var $df8b6ce3f4df1ba5$var$listener = "listener";
var $df8b6ce3f4df1ba5$var$completed = "completed";
var $df8b6ce3f4df1ba5$var$cancelled = "cancelled";
var $df8b6ce3f4df1ba5$var$taskCancelled = `task-${$df8b6ce3f4df1ba5$var$cancelled}`;
var $df8b6ce3f4df1ba5$var$taskCompleted = `task-${$df8b6ce3f4df1ba5$var$completed}`;
var $df8b6ce3f4df1ba5$var$listenerCancelled = `${$df8b6ce3f4df1ba5$var$listener}-${$df8b6ce3f4df1ba5$var$cancelled}`;
var $df8b6ce3f4df1ba5$var$listenerCompleted = `${$df8b6ce3f4df1ba5$var$listener}-${$df8b6ce3f4df1ba5$var$completed}`;
var $df8b6ce3f4df1ba5$export$cb1bdac908fed7f = class {
    constructor(code){
        this.code = code;
        this.message = `${$df8b6ce3f4df1ba5$var$task} ${$df8b6ce3f4df1ba5$var$cancelled} (reason: ${code})`;
    }
    name = "TaskAbortError";
    message;
};
// src/listenerMiddleware/utils.ts
var $df8b6ce3f4df1ba5$var$assertFunction = (func, expected)=>{
    if (typeof func !== "function") throw new TypeError($df8b6ce3f4df1ba5$export$378fa86b259c0280(32));
};
var $df8b6ce3f4df1ba5$var$noop2 = ()=>{};
var $df8b6ce3f4df1ba5$var$catchRejection = (promise, onError = $df8b6ce3f4df1ba5$var$noop2)=>{
    promise.catch(onError);
    return promise;
};
var $df8b6ce3f4df1ba5$var$addAbortSignalListener = (abortSignal, callback)=>{
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return ()=>abortSignal.removeEventListener("abort", callback);
};
// src/listenerMiddleware/task.ts
var $df8b6ce3f4df1ba5$var$validateActive = (signal)=>{
    if (signal.aborted) throw new $df8b6ce3f4df1ba5$export$cb1bdac908fed7f(signal.reason);
};
function $df8b6ce3f4df1ba5$var$raceWithSignal(signal, promise) {
    let cleanup = $df8b6ce3f4df1ba5$var$noop2;
    return new Promise((resolve, reject)=>{
        const notifyRejection = ()=>reject(new $df8b6ce3f4df1ba5$export$cb1bdac908fed7f(signal.reason));
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $df8b6ce3f4df1ba5$var$addAbortSignalListener(signal, notifyRejection);
        promise.finally(()=>cleanup()).then(resolve, reject);
    }).finally(()=>{
        cleanup = $df8b6ce3f4df1ba5$var$noop2;
    });
}
var $df8b6ce3f4df1ba5$var$runTask = async (task2, cleanUp)=>{
    try {
        await Promise.resolve();
        const value = await task2();
        return {
            status: "ok",
            value: value
        };
    } catch (error) {
        return {
            status: error instanceof $df8b6ce3f4df1ba5$export$cb1bdac908fed7f ? "cancelled" : "rejected",
            error: error
        };
    } finally{
        cleanUp?.();
    }
};
var $df8b6ce3f4df1ba5$var$createPause = (signal)=>{
    return (promise)=>{
        return $df8b6ce3f4df1ba5$var$catchRejection($df8b6ce3f4df1ba5$var$raceWithSignal(signal, promise).then((output)=>{
            $df8b6ce3f4df1ba5$var$validateActive(signal);
            return output;
        }));
    };
};
var $df8b6ce3f4df1ba5$var$createDelay = (signal)=>{
    const pause = $df8b6ce3f4df1ba5$var$createPause(signal);
    return (timeoutMs)=>{
        return pause(new Promise((resolve)=>setTimeout(resolve, timeoutMs)));
    };
};
// src/listenerMiddleware/index.ts
var { assign: $df8b6ce3f4df1ba5$var$assign } = Object;
var $df8b6ce3f4df1ba5$var$INTERNAL_NIL_TOKEN = {};
var $df8b6ce3f4df1ba5$var$alm = "listenerMiddleware";
var $df8b6ce3f4df1ba5$var$createFork = (parentAbortSignal, parentBlockingPromises)=>{
    const linkControllers = (controller)=>$df8b6ce3f4df1ba5$var$addAbortSignalListener(parentAbortSignal, ()=>controller.abort(parentAbortSignal.reason));
    return (taskExecutor, opts)=>{
        $df8b6ce3f4df1ba5$var$assertFunction(taskExecutor, "taskExecutor");
        const childAbortController = new AbortController();
        linkControllers(childAbortController);
        const result = $df8b6ce3f4df1ba5$var$runTask(async ()=>{
            $df8b6ce3f4df1ba5$var$validateActive(parentAbortSignal);
            $df8b6ce3f4df1ba5$var$validateActive(childAbortController.signal);
            const result2 = await taskExecutor({
                pause: $df8b6ce3f4df1ba5$var$createPause(childAbortController.signal),
                delay: $df8b6ce3f4df1ba5$var$createDelay(childAbortController.signal),
                signal: childAbortController.signal
            });
            $df8b6ce3f4df1ba5$var$validateActive(childAbortController.signal);
            return result2;
        }, ()=>childAbortController.abort($df8b6ce3f4df1ba5$var$taskCompleted));
        if (opts?.autoJoin) parentBlockingPromises.push(result.catch($df8b6ce3f4df1ba5$var$noop2));
        return {
            result: $df8b6ce3f4df1ba5$var$createPause(parentAbortSignal)(result),
            cancel () {
                childAbortController.abort($df8b6ce3f4df1ba5$var$taskCancelled);
            }
        };
    };
};
var $df8b6ce3f4df1ba5$var$createTakePattern = (startListening, signal)=>{
    const take = async (predicate, timeout)=>{
        $df8b6ce3f4df1ba5$var$validateActive(signal);
        let unsubscribe = ()=>{};
        const tuplePromise = new Promise((resolve, reject)=>{
            let stopListening = startListening({
                predicate: predicate,
                effect: (action, listenerApi)=>{
                    listenerApi.unsubscribe();
                    resolve([
                        action,
                        listenerApi.getState(),
                        listenerApi.getOriginalState()
                    ]);
                }
            });
            unsubscribe = ()=>{
                stopListening();
                reject();
            };
        });
        const promises = [
            tuplePromise
        ];
        if (timeout != null) promises.push(new Promise((resolve)=>setTimeout(resolve, timeout, null)));
        try {
            const output = await $df8b6ce3f4df1ba5$var$raceWithSignal(signal, Promise.race(promises));
            $df8b6ce3f4df1ba5$var$validateActive(signal);
            return output;
        } finally{
            unsubscribe();
        }
    };
    return (predicate, timeout)=>$df8b6ce3f4df1ba5$var$catchRejection(take(predicate, timeout));
};
var $df8b6ce3f4df1ba5$var$getListenerEntryPropsFrom = (options)=>{
    let { type: type, actionCreator: actionCreator, matcher: matcher, predicate: predicate, effect: effect } = options;
    if (type) predicate = $df8b6ce3f4df1ba5$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error($df8b6ce3f4df1ba5$export$378fa86b259c0280(21));
    $df8b6ce3f4df1ba5$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $df8b6ce3f4df1ba5$var$createListenerEntry = /* @__PURE__ */ $df8b6ce3f4df1ba5$var$assign((options)=>{
    const { type: type, predicate: predicate, effect: effect } = $df8b6ce3f4df1ba5$var$getListenerEntryPropsFrom(options);
    const entry = {
        id: $df8b6ce3f4df1ba5$export$ac4959f4f1338dfc(),
        effect: effect,
        type: type,
        predicate: predicate,
        pending: /* @__PURE__ */ new Set(),
        unsubscribe: ()=>{
            throw new Error($df8b6ce3f4df1ba5$export$378fa86b259c0280(22));
        }
    };
    return entry;
}, {
    withTypes: ()=>$df8b6ce3f4df1ba5$var$createListenerEntry
});
var $df8b6ce3f4df1ba5$var$findListenerEntry = (listenerMap, options)=>{
    const { type: type, effect: effect, predicate: predicate } = $df8b6ce3f4df1ba5$var$getListenerEntryPropsFrom(options);
    return Array.from(listenerMap.values()).find((entry)=>{
        const matchPredicateOrType = typeof type === "string" ? entry.type === type : entry.predicate === predicate;
        return matchPredicateOrType && entry.effect === effect;
    });
};
var $df8b6ce3f4df1ba5$var$cancelActiveListeners = (entry)=>{
    entry.pending.forEach((controller)=>{
        controller.abort($df8b6ce3f4df1ba5$var$listenerCancelled);
    });
};
var $df8b6ce3f4df1ba5$var$createClearListenerMiddleware = (listenerMap, executingListeners)=>{
    return ()=>{
        for (const listener2 of executingListeners.keys())$df8b6ce3f4df1ba5$var$cancelActiveListeners(listener2);
        listenerMap.clear();
    };
};
var $df8b6ce3f4df1ba5$var$safelyNotifyError = (errorHandler, errorToNotify, errorInfo)=>{
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(()=>{
            throw errorHandlerError;
        }, 0);
    }
};
var $df8b6ce3f4df1ba5$export$f03a6b845d3fb58b = /* @__PURE__ */ $df8b6ce3f4df1ba5$var$assign(/* @__PURE__ */ $df8b6ce3f4df1ba5$export$309c7a02b0b0bc62(`${$df8b6ce3f4df1ba5$var$alm}/add`), {
    withTypes: ()=>$df8b6ce3f4df1ba5$export$f03a6b845d3fb58b
});
var $df8b6ce3f4df1ba5$export$b1b8022855fb2b71 = /* @__PURE__ */ $df8b6ce3f4df1ba5$export$309c7a02b0b0bc62(`${$df8b6ce3f4df1ba5$var$alm}/removeAll`);
var $df8b6ce3f4df1ba5$export$b03e9483f936dccb = /* @__PURE__ */ $df8b6ce3f4df1ba5$var$assign(/* @__PURE__ */ $df8b6ce3f4df1ba5$export$309c7a02b0b0bc62(`${$df8b6ce3f4df1ba5$var$alm}/remove`), {
    withTypes: ()=>$df8b6ce3f4df1ba5$export$b03e9483f936dccb
});
var $df8b6ce3f4df1ba5$var$defaultErrorHandler = (...args)=>{
    console.error(`${$df8b6ce3f4df1ba5$var$alm}/error`, ...args);
};
var $df8b6ce3f4df1ba5$export$1228acebbbcb485b = (middlewareOptions = {})=>{
    const listenerMap = /* @__PURE__ */ new Map();
    const executingListeners = /* @__PURE__ */ new Map();
    const trackExecutingListener = (entry)=>{
        const count = executingListeners.get(entry) ?? 0;
        executingListeners.set(entry, count + 1);
    };
    const untrackExecutingListener = (entry)=>{
        const count = executingListeners.get(entry) ?? 1;
        if (count === 1) executingListeners.delete(entry);
        else executingListeners.set(entry, count - 1);
    };
    const { extra: extra, onError: onError = $df8b6ce3f4df1ba5$var$defaultErrorHandler } = middlewareOptions;
    $df8b6ce3f4df1ba5$var$assertFunction(onError, "onError");
    const insertEntry = (entry)=>{
        entry.unsubscribe = ()=>listenerMap.delete(entry.id);
        listenerMap.set(entry.id, entry);
        return (cancelOptions)=>{
            entry.unsubscribe();
            if (cancelOptions?.cancelActive) $df8b6ce3f4df1ba5$var$cancelActiveListeners(entry);
        };
    };
    const startListening = (options)=>{
        const entry = $df8b6ce3f4df1ba5$var$findListenerEntry(listenerMap, options) ?? $df8b6ce3f4df1ba5$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    $df8b6ce3f4df1ba5$var$assign(startListening, {
        withTypes: ()=>startListening
    });
    const stopListening = (options)=>{
        const entry = $df8b6ce3f4df1ba5$var$findListenerEntry(listenerMap, options);
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $df8b6ce3f4df1ba5$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    $df8b6ce3f4df1ba5$var$assign(stopListening, {
        withTypes: ()=>stopListening
    });
    const notifyListener = async (entry, action, api, getOriginalState)=>{
        const internalTaskController = new AbortController();
        const take = $df8b6ce3f4df1ba5$var$createTakePattern(startListening, internalTaskController.signal);
        const autoJoinPromises = [];
        try {
            entry.pending.add(internalTaskController);
            trackExecutingListener(entry);
            await Promise.resolve(entry.effect(action, // Use assign() rather than ... to avoid extra helper functions added to bundle
            $df8b6ce3f4df1ba5$var$assign({}, api, {
                getOriginalState: getOriginalState,
                condition: (predicate, timeout)=>take(predicate, timeout).then(Boolean),
                take: take,
                delay: $df8b6ce3f4df1ba5$var$createDelay(internalTaskController.signal),
                pause: $df8b6ce3f4df1ba5$var$createPause(internalTaskController.signal),
                extra: extra,
                signal: internalTaskController.signal,
                fork: $df8b6ce3f4df1ba5$var$createFork(internalTaskController.signal, autoJoinPromises),
                unsubscribe: entry.unsubscribe,
                subscribe: ()=>{
                    listenerMap.set(entry.id, entry);
                },
                cancelActiveListeners: ()=>{
                    entry.pending.forEach((controller, _, set)=>{
                        if (controller !== internalTaskController) {
                            controller.abort($df8b6ce3f4df1ba5$var$listenerCancelled);
                            set.delete(controller);
                        }
                    });
                },
                cancel: ()=>{
                    internalTaskController.abort($df8b6ce3f4df1ba5$var$listenerCancelled);
                    entry.pending.delete(internalTaskController);
                },
                throwIfCancelled: ()=>{
                    $df8b6ce3f4df1ba5$var$validateActive(internalTaskController.signal);
                }
            })));
        } catch (listenerError) {
            if (!(listenerError instanceof $df8b6ce3f4df1ba5$export$cb1bdac908fed7f)) $df8b6ce3f4df1ba5$var$safelyNotifyError(onError, listenerError, {
                raisedBy: "effect"
            });
        } finally{
            await Promise.all(autoJoinPromises);
            internalTaskController.abort($df8b6ce3f4df1ba5$var$listenerCompleted);
            untrackExecutingListener(entry);
            entry.pending.delete(internalTaskController);
        }
    };
    const clearListenerMiddleware = $df8b6ce3f4df1ba5$var$createClearListenerMiddleware(listenerMap, executingListeners);
    const middleware = (api)=>(next)=>(action)=>{
                if (!(0, $6c2d3c9c387cb6cd$export$b956e38827fca970)(action)) return next(action);
                if ($df8b6ce3f4df1ba5$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($df8b6ce3f4df1ba5$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($df8b6ce3f4df1ba5$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                let originalState = api.getState();
                const getOriginalState = ()=>{
                    if (originalState === $df8b6ce3f4df1ba5$var$INTERNAL_NIL_TOKEN) throw new Error($df8b6ce3f4df1ba5$export$378fa86b259c0280(23));
                    return originalState;
                };
                let result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        const currentState = api.getState();
                        const listenerEntries = Array.from(listenerMap.values());
                        for (const entry of listenerEntries){
                            let runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $df8b6ce3f4df1ba5$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $df8b6ce3f4df1ba5$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
};
// src/dynamicMiddleware/index.ts
var $df8b6ce3f4df1ba5$var$createMiddlewareEntry = (middleware)=>({
        middleware: middleware,
        applied: /* @__PURE__ */ new Map()
    });
var $df8b6ce3f4df1ba5$var$matchInstance = (instanceId)=>(action)=>action?.meta?.instanceId === instanceId;
var $df8b6ce3f4df1ba5$export$4bb1606a79445586 = ()=>{
    const instanceId = $df8b6ce3f4df1ba5$export$ac4959f4f1338dfc();
    const middlewareMap = /* @__PURE__ */ new Map();
    const withMiddleware = Object.assign($df8b6ce3f4df1ba5$export$309c7a02b0b0bc62("dynamicMiddleware/add", (...middlewares)=>({
            payload: middlewares,
            meta: {
                instanceId: instanceId
            }
        })), {
        withTypes: ()=>withMiddleware
    });
    const addMiddleware = Object.assign(function addMiddleware2(...middlewares) {
        middlewares.forEach((middleware2)=>{
            $df8b6ce3f4df1ba5$var$getOrInsertComputed(middlewareMap, middleware2, $df8b6ce3f4df1ba5$var$createMiddlewareEntry);
        });
    }, {
        withTypes: ()=>addMiddleware
    });
    const getFinalMiddleware = (api)=>{
        const appliedMiddleware = Array.from(middlewareMap.values()).map((entry)=>$df8b6ce3f4df1ba5$var$getOrInsertComputed(entry.applied, api, entry.middleware));
        return (0, $6c2d3c9c387cb6cd$export$f672e0b6f7222cd7)(...appliedMiddleware);
    };
    const isWithMiddleware = $df8b6ce3f4df1ba5$export$9dd1fb32974da385(withMiddleware, $df8b6ce3f4df1ba5$var$matchInstance(instanceId));
    const middleware = (api)=>(next)=>(action)=>{
                if (isWithMiddleware(action)) {
                    addMiddleware(...action.payload);
                    return api.dispatch;
                }
                return getFinalMiddleware(api)(next)(action);
            };
    return {
        middleware: middleware,
        addMiddleware: addMiddleware,
        withMiddleware: withMiddleware,
        instanceId: instanceId
    };
};
var $df8b6ce3f4df1ba5$var$isSliceLike = (maybeSliceLike)=>"reducerPath" in maybeSliceLike && typeof maybeSliceLike.reducerPath === "string";
var $df8b6ce3f4df1ba5$var$getReducers = (slices)=>slices.flatMap((sliceOrMap)=>$df8b6ce3f4df1ba5$var$isSliceLike(sliceOrMap) ? [
            [
                sliceOrMap.reducerPath,
                sliceOrMap.reducer
            ]
        ] : Object.entries(sliceOrMap));
var $df8b6ce3f4df1ba5$var$ORIGINAL_STATE = Symbol.for("rtk-state-proxy-original");
var $df8b6ce3f4df1ba5$var$isStateProxy = (value)=>!!value && !!value[$df8b6ce3f4df1ba5$var$ORIGINAL_STATE];
var $df8b6ce3f4df1ba5$var$stateProxyMap = /* @__PURE__ */ new WeakMap();
var $df8b6ce3f4df1ba5$var$createStateProxy = (state, reducerMap, initialStateCache)=>$df8b6ce3f4df1ba5$var$getOrInsertComputed($df8b6ce3f4df1ba5$var$stateProxyMap, state, ()=>new Proxy(state, {
            get: (target, prop, receiver)=>{
                if (prop === $df8b6ce3f4df1ba5$var$ORIGINAL_STATE) return target;
                const result = Reflect.get(target, prop, receiver);
                if (typeof result === "undefined") {
                    const cached = initialStateCache[prop];
                    if (typeof cached !== "undefined") return cached;
                    const reducer = reducerMap[prop];
                    if (reducer) {
                        const reducerResult = reducer(void 0, {
                            type: $df8b6ce3f4df1ba5$export$ac4959f4f1338dfc()
                        });
                        if (typeof reducerResult === "undefined") throw new Error($df8b6ce3f4df1ba5$export$378fa86b259c0280(24));
                        initialStateCache[prop] = reducerResult;
                        return reducerResult;
                    }
                }
                return result;
            }
        }));
var $df8b6ce3f4df1ba5$var$original = (state)=>{
    if (!$df8b6ce3f4df1ba5$var$isStateProxy(state)) throw new Error($df8b6ce3f4df1ba5$export$378fa86b259c0280(25));
    return state[$df8b6ce3f4df1ba5$var$ORIGINAL_STATE];
};
var $df8b6ce3f4df1ba5$var$emptyObject = {};
var $df8b6ce3f4df1ba5$var$noopReducer = (state = $df8b6ce3f4df1ba5$var$emptyObject)=>state;
function $df8b6ce3f4df1ba5$export$a3734c7614660b9(...slices) {
    const reducerMap = Object.fromEntries($df8b6ce3f4df1ba5$var$getReducers(slices));
    const getReducer = ()=>Object.keys(reducerMap).length ? (0, $6c2d3c9c387cb6cd$export$66e4520cdb265d18)(reducerMap) : $df8b6ce3f4df1ba5$var$noopReducer;
    let reducer = getReducer();
    function combinedReducer(state, action) {
        return reducer(state, action);
    }
    combinedReducer.withLazyLoadedSlices = ()=>combinedReducer;
    const initialStateCache = {};
    const inject = (slice, config = {})=>{
        const { reducerPath: reducerPath, reducer: reducerToInject } = slice;
        const currentReducer = reducerMap[reducerPath];
        if (!config.overrideExisting && currentReducer && currentReducer !== reducerToInject) return combinedReducer;
        if (config.overrideExisting && currentReducer !== reducerToInject) delete initialStateCache[reducerPath];
        reducerMap[reducerPath] = reducerToInject;
        reducer = getReducer();
        return combinedReducer;
    };
    const selector = Object.assign(function makeSelector(selectorFn, selectState) {
        return function selector2(state, ...args) {
            return selectorFn($df8b6ce3f4df1ba5$var$createStateProxy(selectState ? selectState(state, ...args) : state, reducerMap, initialStateCache), ...args);
        };
    }, {
        original: $df8b6ce3f4df1ba5$var$original
    });
    return Object.assign(combinedReducer, {
        inject: inject,
        selector: selector
    });
}
// src/formatProdErrorMessage.ts
function $df8b6ce3f4df1ba5$export$378fa86b259c0280(code) {
    return `Minified Redux Toolkit error #${code}; visit https://redux-toolkit.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}


var $a3abdcf7f5febb61$var$initialState = {
    layoutType: 'horizontal',
    width: 0,
    height: 0,
    margin: {
        top: 5,
        right: 5,
        bottom: 5,
        left: 5
    },
    scale: 1
};
var $a3abdcf7f5febb61$var$chartLayoutSlice = (0, $df8b6ce3f4df1ba5$export$4d8d9bd83c24ae8b)({
    name: 'chartLayout',
    initialState: $a3abdcf7f5febb61$var$initialState,
    reducers: {
        setLayout (state, action) {
            state.layoutType = action.payload;
        },
        setChartSize (state, action) {
            state.width = action.payload.width;
            state.height = action.payload.height;
        },
        setMargin (state, action) {
            var _action$payload$top, _action$payload$right, _action$payload$botto, _action$payload$left;
            state.margin.top = (_action$payload$top = action.payload.top) !== null && _action$payload$top !== void 0 ? _action$payload$top : 0;
            state.margin.right = (_action$payload$right = action.payload.right) !== null && _action$payload$right !== void 0 ? _action$payload$right : 0;
            state.margin.bottom = (_action$payload$botto = action.payload.bottom) !== null && _action$payload$botto !== void 0 ? _action$payload$botto : 0;
            state.margin.left = (_action$payload$left = action.payload.left) !== null && _action$payload$left !== void 0 ? _action$payload$left : 0;
        },
        setScale (state, action) {
            state.scale = action.payload;
        }
    }
});
var { setMargin: $a3abdcf7f5febb61$export$3f8f25b83912855f, setLayout: $a3abdcf7f5febb61$export$e8437af1f2483b8e, setChartSize: $a3abdcf7f5febb61$export$136b7feefeae481a, setScale: $a3abdcf7f5febb61$export$4dc523f7f9b3edd6 } = $a3abdcf7f5febb61$var$chartLayoutSlice.actions;
var $a3abdcf7f5febb61$export$701395c4acfabc85 = $a3abdcf7f5febb61$var$chartLayoutSlice.reducer;




var $ce976de4b913f215$exports = {};

$ce976de4b913f215$exports = (parcelRequire("6UrPn")).sortBy;


var $3a89fcd13152106d$export$1d27a9e667f67593 = (state)=>state.legend.settings;
var $3a89fcd13152106d$export$c9c2b00a34f852e5 = (state)=>state.legend.size;
var $3a89fcd13152106d$var$selectAllLegendPayload2DArray = (state)=>state.legend.payload;
var $3a89fcd13152106d$export$9a6de64b691a7304 = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $3a89fcd13152106d$var$selectAllLegendPayload2DArray,
    $3a89fcd13152106d$export$1d27a9e667f67593
], (payloads, _ref)=>{
    var { itemSorter: itemSorter } = _ref;
    var flat = payloads.flat(1);
    return itemSorter ? (0, (/*@__PURE__*/$parcel$interopDefault($ce976de4b913f215$exports)))(flat, itemSorter) : flat;
});




// `victory-vendor/d3-shape` (ESM)
// See upstream license: https://github.com/d3/d3-shape/blob/main/LICENSE
//
// Our ESM package uses the underlying installed dependencies of `node_modules/d3-shape`
var $54f161826605c42a$export$58adb3bec8346d0f = Array.prototype.slice;
function $54f161826605c42a$export$2e2bcd8739ae039(x) {
    return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
     : Array.from(x); // Map, Set, iterable, string, or anything else
}


function $d6e59e50048c1129$export$2e2bcd8739ae039(x) {
    return function constant() {
        return x;
    };
}


function $d8de2f04944e454f$var$Linear(context) {
    this._context = context;
}
$d8de2f04944e454f$var$Linear.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2; // falls through
            default:
                this._context.lineTo(x, y);
                break;
        }
    }
};
function $d8de2f04944e454f$export$2e2bcd8739ae039(context) {
    return new $d8de2f04944e454f$var$Linear(context);
}





const $97a93b76cd34afcf$var$pi = Math.PI, $97a93b76cd34afcf$var$tau = 2 * $97a93b76cd34afcf$var$pi, $97a93b76cd34afcf$var$epsilon = 1e-6, $97a93b76cd34afcf$var$tauEpsilon = $97a93b76cd34afcf$var$tau - $97a93b76cd34afcf$var$epsilon;
function $97a93b76cd34afcf$var$append(strings) {
    this._ += strings[0];
    for(let i = 1, n = strings.length; i < n; ++i)this._ += arguments[i] + strings[i];
}
function $97a93b76cd34afcf$var$appendRound(digits) {
    let d = Math.floor(digits);
    if (!(d >= 0)) throw new Error(`invalid digits: ${digits}`);
    if (d > 15) return $97a93b76cd34afcf$var$append;
    const k = 10 ** d;
    return function(strings) {
        this._ += strings[0];
        for(let i = 1, n = strings.length; i < n; ++i)this._ += Math.round(arguments[i] * k) / k + strings[i];
    };
}
class $97a93b76cd34afcf$export$4b2950bdac9b6ee9 {
    constructor(digits){
        this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
        this._ = "";
        this._append = digits == null ? $97a93b76cd34afcf$var$append : $97a93b76cd34afcf$var$appendRound(digits);
    }
    moveTo(x, y) {
        this._append`M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}`;
    }
    closePath() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._append`Z`;
        }
    }
    lineTo(x, y) {
        this._append`L${this._x1 = +x},${this._y1 = +y}`;
    }
    quadraticCurveTo(x1, y1, x, y) {
        this._append`Q${+x1},${+y1},${this._x1 = +x},${this._y1 = +y}`;
    }
    bezierCurveTo(x1, y1, x2, y2, x, y) {
        this._append`C${+x1},${+y1},${+x2},${+y2},${this._x1 = +x},${this._y1 = +y}`;
    }
    arcTo(x1, y1, x2, y2, r) {
        x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
        // Is the radius negative? Error.
        if (r < 0) throw new Error(`negative radius: ${r}`);
        let x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01;
        // Is this path empty? Move to (x1,y1).
        if (this._x1 === null) this._append`M${this._x1 = x1},${this._y1 = y1}`;
        else if (!(l01_2 > $97a93b76cd34afcf$var$epsilon)) ;
        else if (!(Math.abs(y01 * x21 - y21 * x01) > $97a93b76cd34afcf$var$epsilon) || !r) this._append`L${this._x1 = x1},${this._y1 = y1}`;
        else {
            let x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan(($97a93b76cd34afcf$var$pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21;
            // If the start tangent is not coincident with (x0,y0), line to.
            if (Math.abs(t01 - 1) > $97a93b76cd34afcf$var$epsilon) this._append`L${x1 + t01 * x01},${y1 + t01 * y01}`;
            this._append`A${r},${r},0,0,${+(y01 * x20 > x01 * y20)},${this._x1 = x1 + t21 * x21},${this._y1 = y1 + t21 * y21}`;
        }
    }
    arc(x, y, r, a0, a1, ccw) {
        x = +x, y = +y, r = +r, ccw = !!ccw;
        // Is the radius negative? Error.
        if (r < 0) throw new Error(`negative radius: ${r}`);
        let dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x + dx, y0 = y + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0;
        // Is this path empty? Move to (x0,y0).
        if (this._x1 === null) this._append`M${x0},${y0}`;
        else if (Math.abs(this._x1 - x0) > $97a93b76cd34afcf$var$epsilon || Math.abs(this._y1 - y0) > $97a93b76cd34afcf$var$epsilon) this._append`L${x0},${y0}`;
        // Is this arc empty? We’re done.
        if (!r) return;
        // Does the angle go the wrong way? Flip the direction.
        if (da < 0) da = da % $97a93b76cd34afcf$var$tau + $97a93b76cd34afcf$var$tau;
        // Is this a complete circle? Draw two arcs to complete the circle.
        if (da > $97a93b76cd34afcf$var$tauEpsilon) this._append`A${r},${r},0,1,${cw},${x - dx},${y - dy}A${r},${r},0,1,${cw},${this._x1 = x0},${this._y1 = y0}`;
        else if (da > $97a93b76cd34afcf$var$epsilon) this._append`A${r},${r},0,${+(da >= $97a93b76cd34afcf$var$pi)},${cw},${this._x1 = x + r * Math.cos(a1)},${this._y1 = y + r * Math.sin(a1)}`;
    }
    rect(x, y, w, h) {
        this._append`M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}h${w = +w}v${+h}h${-w}Z`;
    }
    toString() {
        return this._;
    }
}
function $97a93b76cd34afcf$export$bb654e07daaf8c3a() {
    return new $97a93b76cd34afcf$export$4b2950bdac9b6ee9;
}
// Allow instanceof d3.path
$97a93b76cd34afcf$export$bb654e07daaf8c3a.prototype = $97a93b76cd34afcf$export$4b2950bdac9b6ee9.prototype;
function $97a93b76cd34afcf$export$e181c6ece8d9cc5f(digits = 3) {
    return new $97a93b76cd34afcf$export$4b2950bdac9b6ee9(+digits);
}


function $c5bbe85e3fd75d0a$export$fb6e83118a5dcd45(shape) {
    let digits = 3;
    shape.digits = function(_) {
        if (!arguments.length) return digits;
        if (_ == null) digits = null;
        else {
            const d = Math.floor(_);
            if (!(d >= 0)) throw new RangeError(`invalid digits: ${_}`);
            digits = d;
        }
        return shape;
    };
    return ()=>new (0, $97a93b76cd34afcf$export$4b2950bdac9b6ee9)(digits);
}


function $b0cdbc4b900c08dd$export$d141bba7fdc215a3(p) {
    return p[0];
}
function $b0cdbc4b900c08dd$export$4a5767248b18ef41(p) {
    return p[1];
}


function $8b3a009f69133aa3$export$2e2bcd8739ae039(x, y) {
    var defined = (0, $d6e59e50048c1129$export$2e2bcd8739ae039)(true), context = null, curve = (0, $d8de2f04944e454f$export$2e2bcd8739ae039), output = null, path = (0, $c5bbe85e3fd75d0a$export$fb6e83118a5dcd45)(line);
    x = typeof x === "function" ? x : x === undefined ? (0, $b0cdbc4b900c08dd$export$d141bba7fdc215a3) : (0, $d6e59e50048c1129$export$2e2bcd8739ae039)(x);
    y = typeof y === "function" ? y : y === undefined ? (0, $b0cdbc4b900c08dd$export$4a5767248b18ef41) : (0, $d6e59e50048c1129$export$2e2bcd8739ae039)(y);
    function line(data) {
        var i, n = (data = (0, $54f161826605c42a$export$2e2bcd8739ae039)(data)).length, d, defined0 = false, buffer;
        if (context == null) output = curve(buffer = path());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) output.lineStart();
                else output.lineEnd();
            }
            if (defined0) output.point(+x(d, i, data), +y(d, i, data));
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    line.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $d6e59e50048c1129$export$2e2bcd8739ae039)(+_), line) : x;
    };
    line.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $d6e59e50048c1129$export$2e2bcd8739ae039)(+_), line) : y;
    };
    line.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $d6e59e50048c1129$export$2e2bcd8739ae039)(!!_), line) : defined;
    };
    line.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
    };
    line.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
    };
    return line;
}




function $cc30502eae8058df$export$2e2bcd8739ae039(x0, y0, y1) {
    var x1 = null, defined = (0, $d6e59e50048c1129$export$2e2bcd8739ae039)(true), context = null, curve = (0, $d8de2f04944e454f$export$2e2bcd8739ae039), output = null, path = (0, $c5bbe85e3fd75d0a$export$fb6e83118a5dcd45)(area);
    x0 = typeof x0 === "function" ? x0 : x0 === undefined ? (0, $b0cdbc4b900c08dd$export$d141bba7fdc215a3) : (0, $d6e59e50048c1129$export$2e2bcd8739ae039)(+x0);
    y0 = typeof y0 === "function" ? y0 : y0 === undefined ? (0, $d6e59e50048c1129$export$2e2bcd8739ae039)(0) : (0, $d6e59e50048c1129$export$2e2bcd8739ae039)(+y0);
    y1 = typeof y1 === "function" ? y1 : y1 === undefined ? (0, $b0cdbc4b900c08dd$export$4a5767248b18ef41) : (0, $d6e59e50048c1129$export$2e2bcd8739ae039)(+y1);
    function area(data) {
        var i, j, k, n = (data = (0, $54f161826605c42a$export$2e2bcd8739ae039)(data)).length, d, defined0 = false, buffer, x0z = new Array(n), y0z = new Array(n);
        if (context == null) output = curve(buffer = path());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) {
                    j = i;
                    output.areaStart();
                    output.lineStart();
                } else {
                    output.lineEnd();
                    output.lineStart();
                    for(k = i - 1; k >= j; --k)output.point(x0z[k], y0z[k]);
                    output.lineEnd();
                    output.areaEnd();
                }
            }
            if (defined0) {
                x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
                output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
            }
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    function arealine() {
        return (0, $8b3a009f69133aa3$export$2e2bcd8739ae039)().defined(defined).curve(curve).context(context);
    }
    area.x = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $d6e59e50048c1129$export$2e2bcd8739ae039)(+_), x1 = null, area) : x0;
    };
    area.x0 = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $d6e59e50048c1129$export$2e2bcd8739ae039)(+_), area) : x0;
    };
    area.x1 = function(_) {
        return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : (0, $d6e59e50048c1129$export$2e2bcd8739ae039)(+_), area) : x1;
    };
    area.y = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $d6e59e50048c1129$export$2e2bcd8739ae039)(+_), y1 = null, area) : y0;
    };
    area.y0 = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $d6e59e50048c1129$export$2e2bcd8739ae039)(+_), area) : y0;
    };
    area.y1 = function(_) {
        return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : (0, $d6e59e50048c1129$export$2e2bcd8739ae039)(+_), area) : y1;
    };
    area.lineX0 = area.lineY0 = function() {
        return arealine().x(x0).y(y0);
    };
    area.lineY1 = function() {
        return arealine().x(x0).y(y1);
    };
    area.lineX1 = function() {
        return arealine().x(x1).y(y0);
    };
    area.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $d6e59e50048c1129$export$2e2bcd8739ae039)(!!_), area) : defined;
    };
    area.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
    };
    area.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
    };
    return area;
}

function $67656591682391bd$export$105684a3041cb6f3(that, x, y) {
    that._context.bezierCurveTo((2 * that._x0 + that._x1) / 3, (2 * that._y0 + that._y1) / 3, (that._x0 + 2 * that._x1) / 3, (that._y0 + 2 * that._y1) / 3, (that._x0 + 4 * that._x1 + x) / 6, (that._y0 + 4 * that._y1 + y) / 6);
}
function $67656591682391bd$export$957f7263e89bedd2(context) {
    this._context = context;
}
$67656591682391bd$export$957f7263e89bedd2.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 3:
                $67656591682391bd$export$105684a3041cb6f3(this, this._x1, this._y1); // falls through
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // falls through
            default:
                $67656591682391bd$export$105684a3041cb6f3(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $67656591682391bd$export$2e2bcd8739ae039(context) {
    return new $67656591682391bd$export$957f7263e89bedd2(context);
}

function $2b81a6619c37d079$export$2e2bcd8739ae039() {}



function $3f51c10e496e6580$var$BasisClosed(context) {
    this._context = context;
}
$3f51c10e496e6580$var$BasisClosed.prototype = {
    areaStart: (0, $2b81a6619c37d079$export$2e2bcd8739ae039),
    areaEnd: (0, $2b81a6619c37d079$export$2e2bcd8739ae039),
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x2, this._y2);
                this._context.closePath();
                break;
            case 2:
                this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
                this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x2, this._y2);
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x2 = x, this._y2 = y;
                break;
            case 1:
                this._point = 2;
                this._x3 = x, this._y3 = y;
                break;
            case 2:
                this._point = 3;
                this._x4 = x, this._y4 = y;
                this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6);
                break;
            default:
                (0, $67656591682391bd$export$105684a3041cb6f3)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $3f51c10e496e6580$export$2e2bcd8739ae039(context) {
    return new $3f51c10e496e6580$var$BasisClosed(context);
}


function $5463950ad1a5ebab$var$BasisOpen(context) {
    this._context = context;
}
$5463950ad1a5ebab$var$BasisOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6;
                this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0);
                break;
            case 3:
                this._point = 4; // falls through
            default:
                (0, $67656591682391bd$export$105684a3041cb6f3)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $5463950ad1a5ebab$export$2e2bcd8739ae039(context) {
    return new $5463950ad1a5ebab$var$BasisOpen(context);
}

function $bdb7ed38ffd7555d$export$2e2bcd8739ae039(x, y) {
    return [
        (y = +y) * Math.cos(x -= Math.PI / 2),
        y * Math.sin(x)
    ];
}


class $aa272852b3320cba$var$Bump {
    constructor(context, x){
        this._context = context;
        this._x = x;
    }
    areaStart() {
        this._line = 0;
    }
    areaEnd() {
        this._line = NaN;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    }
    point(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                if (this._line) this._context.lineTo(x, y);
                else this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2; // falls through
            default:
                if (this._x) this._context.bezierCurveTo(this._x0 = (this._x0 + x) / 2, this._y0, this._x0, y, x, y);
                else this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + y) / 2, x, this._y0, x, y);
                break;
        }
        this._x0 = x, this._y0 = y;
    }
}
class $aa272852b3320cba$var$BumpRadial {
    constructor(context){
        this._context = context;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {}
    point(x, y) {
        x = +x, y = +y;
        if (this._point === 0) this._point = 1;
        else {
            const p0 = (0, $bdb7ed38ffd7555d$export$2e2bcd8739ae039)(this._x0, this._y0);
            const p1 = (0, $bdb7ed38ffd7555d$export$2e2bcd8739ae039)(this._x0, this._y0 = (this._y0 + y) / 2);
            const p2 = (0, $bdb7ed38ffd7555d$export$2e2bcd8739ae039)(x, this._y0);
            const p3 = (0, $bdb7ed38ffd7555d$export$2e2bcd8739ae039)(x, y);
            this._context.moveTo(...p0);
            this._context.bezierCurveTo(...p1, ...p2, ...p3);
        }
        this._x0 = x, this._y0 = y;
    }
}
function $aa272852b3320cba$export$2c099b5096f70ce6(context) {
    return new $aa272852b3320cba$var$Bump(context, true);
}
function $aa272852b3320cba$export$908da9dfa54cbed6(context) {
    return new $aa272852b3320cba$var$Bump(context, false);
}
function $aa272852b3320cba$export$8c82a77a5061b331(context) {
    return new $aa272852b3320cba$var$BumpRadial(context);
}


function $c042af09362cfa07$var$LinearClosed(context) {
    this._context = context;
}
$c042af09362cfa07$var$LinearClosed.prototype = {
    areaStart: (0, $2b81a6619c37d079$export$2e2bcd8739ae039),
    areaEnd: (0, $2b81a6619c37d079$export$2e2bcd8739ae039),
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._point) this._context.closePath();
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) this._context.lineTo(x, y);
        else this._point = 1, this._context.moveTo(x, y);
    }
};
function $c042af09362cfa07$export$2e2bcd8739ae039(context) {
    return new $c042af09362cfa07$var$LinearClosed(context);
}

function $afccb685e7d2163d$var$sign(x) {
    return x < 0 ? -1 : 1;
}
// Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function $afccb685e7d2163d$var$slope3(that, x2, y2) {
    var h0 = that._x1 - that._x0, h1 = x2 - that._x1, s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0), s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0), p = (s0 * h1 + s1 * h0) / (h0 + h1);
    return ($afccb685e7d2163d$var$sign(s0) + $afccb685e7d2163d$var$sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
}
// Calculate a one-sided slope.
function $afccb685e7d2163d$var$slope2(that, t) {
    var h = that._x1 - that._x0;
    return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
}
// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function $afccb685e7d2163d$var$point(that, t0, t1) {
    var x0 = that._x0, y0 = that._y0, x1 = that._x1, y1 = that._y1, dx = (x1 - x0) / 3;
    that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}
function $afccb685e7d2163d$var$MonotoneX(context) {
    this._context = context;
}
$afccb685e7d2163d$var$MonotoneX.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
            case 3:
                $afccb685e7d2163d$var$point(this, this._t0, $afccb685e7d2163d$var$slope2(this, this._t0));
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        var t1 = NaN;
        x = +x, y = +y;
        if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                $afccb685e7d2163d$var$point(this, $afccb685e7d2163d$var$slope2(this, t1 = $afccb685e7d2163d$var$slope3(this, x, y)), t1);
                break;
            default:
                $afccb685e7d2163d$var$point(this, this._t0, t1 = $afccb685e7d2163d$var$slope3(this, x, y));
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
        this._t0 = t1;
    }
};
function $afccb685e7d2163d$var$MonotoneY(context) {
    this._context = new $afccb685e7d2163d$var$ReflectContext(context);
}
($afccb685e7d2163d$var$MonotoneY.prototype = Object.create($afccb685e7d2163d$var$MonotoneX.prototype)).point = function(x, y) {
    $afccb685e7d2163d$var$MonotoneX.prototype.point.call(this, y, x);
};
function $afccb685e7d2163d$var$ReflectContext(context) {
    this._context = context;
}
$afccb685e7d2163d$var$ReflectContext.prototype = {
    moveTo: function(x, y) {
        this._context.moveTo(y, x);
    },
    closePath: function() {
        this._context.closePath();
    },
    lineTo: function(x, y) {
        this._context.lineTo(y, x);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._context.bezierCurveTo(y1, x1, y2, x2, y, x);
    }
};
function $afccb685e7d2163d$export$99563b5420dbdc55(context) {
    return new $afccb685e7d2163d$var$MonotoneX(context);
}
function $afccb685e7d2163d$export$8b5360456d6bdb88(context) {
    return new $afccb685e7d2163d$var$MonotoneY(context);
}

function $008b7d2588675efe$var$Natural(context) {
    this._context = context;
}
$008b7d2588675efe$var$Natural.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = [];
        this._y = [];
    },
    lineEnd: function() {
        var x = this._x, y = this._y, n = x.length;
        if (n) {
            this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
            if (n === 2) this._context.lineTo(x[1], y[1]);
            else {
                var px = $008b7d2588675efe$var$controlPoints(x), py = $008b7d2588675efe$var$controlPoints(y);
                for(var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1)this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
            }
        }
        if (this._line || this._line !== 0 && n === 1) this._context.closePath();
        this._line = 1 - this._line;
        this._x = this._y = null;
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function $008b7d2588675efe$var$controlPoints(x) {
    var i, n = x.length - 1, m, a = new Array(n), b = new Array(n), r = new Array(n);
    a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
    for(i = 1; i < n - 1; ++i)a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
    a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
    for(i = 1; i < n; ++i)m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
    a[n - 1] = r[n - 1] / b[n - 1];
    for(i = n - 2; i >= 0; --i)a[i] = (r[i] - a[i + 1]) / b[i];
    b[n - 1] = (x[n] + a[n - 1]) / 2;
    for(i = 0; i < n - 1; ++i)b[i] = 2 * x[i + 1] - a[i + 1];
    return [
        a,
        b
    ];
}
function $008b7d2588675efe$export$2e2bcd8739ae039(context) {
    return new $008b7d2588675efe$var$Natural(context);
}

function $89adf66c31c27895$var$Step(context, t) {
    this._context = context;
    this._t = t;
}
$89adf66c31c27895$var$Step.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = this._y = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2; // falls through
            default:
                if (this._t <= 0) {
                    this._context.lineTo(this._x, y);
                    this._context.lineTo(x, y);
                } else {
                    var x1 = this._x * (1 - this._t) + x * this._t;
                    this._context.lineTo(x1, this._y);
                    this._context.lineTo(x1, y);
                }
                break;
        }
        this._x = x, this._y = y;
    }
};
function $89adf66c31c27895$export$2e2bcd8739ae039(context) {
    return new $89adf66c31c27895$var$Step(context, 0.5);
}
function $89adf66c31c27895$export$10eafa5b7478b343(context) {
    return new $89adf66c31c27895$var$Step(context, 0);
}
function $89adf66c31c27895$export$793b3db073781cbb(context) {
    return new $89adf66c31c27895$var$Step(context, 1);
}



function $9775ddd394e37b76$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 1)) return;
    for(var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i){
        s0 = s1, s1 = series[order[i]];
        for(j = 0; j < m; ++j)s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
}


function $d456a60f207888a6$export$2e2bcd8739ae039(series) {
    var n = series.length, o = new Array(n);
    while(--n >= 0)o[n] = n;
    return o;
}


function $3414b636b1e1bb0c$var$stackValue(d, key) {
    return d[key];
}
function $3414b636b1e1bb0c$var$stackSeries(key) {
    const series = [];
    series.key = key;
    return series;
}
function $3414b636b1e1bb0c$export$2e2bcd8739ae039() {
    var keys = (0, $d6e59e50048c1129$export$2e2bcd8739ae039)([]), order = (0, $d456a60f207888a6$export$2e2bcd8739ae039), offset = (0, $9775ddd394e37b76$export$2e2bcd8739ae039), value = $3414b636b1e1bb0c$var$stackValue;
    function stack(data) {
        var sz = Array.from(keys.apply(this, arguments), $3414b636b1e1bb0c$var$stackSeries), i, n = sz.length, j = -1, oz;
        for (const d of data)for(i = 0, ++j; i < n; ++i)(sz[i][j] = [
            0,
            +value(d, sz[i].key, j, data)
        ]).data = d;
        for(i = 0, oz = (0, $54f161826605c42a$export$2e2bcd8739ae039)(order(sz)); i < n; ++i)sz[oz[i]].index = i;
        offset(sz, oz);
        return sz;
    }
    stack.keys = function(_) {
        return arguments.length ? (keys = typeof _ === "function" ? _ : (0, $d6e59e50048c1129$export$2e2bcd8739ae039)(Array.from(_)), stack) : keys;
    };
    stack.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $d6e59e50048c1129$export$2e2bcd8739ae039)(+_), stack) : value;
    };
    stack.order = function(_) {
        return arguments.length ? (order = _ == null ? (0, $d456a60f207888a6$export$2e2bcd8739ae039) : typeof _ === "function" ? _ : (0, $d6e59e50048c1129$export$2e2bcd8739ae039)(Array.from(_)), stack) : order;
    };
    stack.offset = function(_) {
        return arguments.length ? (offset = _ == null ? (0, $9775ddd394e37b76$export$2e2bcd8739ae039) : _, stack) : offset;
    };
    return stack;
}


function $8c4136bb2d530ad8$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, n, j = 0, m = series[0].length, y; j < m; ++j){
        for(y = i = 0; i < n; ++i)y += series[i][j][1] || 0;
        if (y) for(i = 0; i < n; ++i)series[i][j][1] /= y;
    }
    (0, $9775ddd394e37b76$export$2e2bcd8739ae039)(series, order);
}


function $3f2df7b7e1210a6d$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j){
        for(var i = 0, y = 0; i < n; ++i)y += series[i][j][1] || 0;
        s0[j][1] += s0[j][0] = -y / 2;
    }
    (0, $9775ddd394e37b76$export$2e2bcd8739ae039)(series, order);
}


function $846ffeb5bf8a78c6$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
    for(var y = 0, j = 1, s0, m, n; j < m; ++j){
        for(var i = 0, s1 = 0, s2 = 0; i < n; ++i){
            var si = series[order[i]], sij0 = si[j][1] || 0, sij1 = si[j - 1][1] || 0, s3 = (sij0 - sij1) / 2;
            for(var k = 0; k < i; ++k){
                var sk = series[order[k]], skj0 = sk[j][1] || 0, skj1 = sk[j - 1][1] || 0;
                s3 += skj0 - skj1;
            }
            s1 += sij0, s2 += s3 * sij0;
        }
        s0[j - 1][1] += s0[j - 1][0] = y;
        if (s1) y -= s2 / s1;
    }
    s0[j - 1][1] += s0[j - 1][0] = y;
    (0, $9775ddd394e37b76$export$2e2bcd8739ae039)(series, order);
}



const $d628e6e00ecb4c6b$export$2335f513bbd82c6d = Math.abs;
const $d628e6e00ecb4c6b$export$b8b770ee6a0d9760 = Math.atan2;
const $d628e6e00ecb4c6b$export$50d414a77b60d802 = Math.cos;
const $d628e6e00ecb4c6b$export$8960430cfd85939f = Math.max;
const $d628e6e00ecb4c6b$export$96ec731ed4dcb222 = Math.min;
const $d628e6e00ecb4c6b$export$5de3937cb4b592ed = Math.sin;
const $d628e6e00ecb4c6b$export$eba8049fb5020b81 = Math.sqrt;
const $d628e6e00ecb4c6b$export$6c421550c66a327d = 1e-12;
const $d628e6e00ecb4c6b$export$18c7bea995a110f = Math.PI;
const $d628e6e00ecb4c6b$export$e51408a300e8929a = $d628e6e00ecb4c6b$export$18c7bea995a110f / 2;
const $d628e6e00ecb4c6b$export$a4b4b4d4d776fe92 = 2 * $d628e6e00ecb4c6b$export$18c7bea995a110f;
function $d628e6e00ecb4c6b$export$fd6306be3fde5b04(x) {
    return x > 1 ? 0 : x < -1 ? $d628e6e00ecb4c6b$export$18c7bea995a110f : Math.acos(x);
}
function $d628e6e00ecb4c6b$export$41726bdb1fc63f(x) {
    return x >= 1 ? $d628e6e00ecb4c6b$export$e51408a300e8929a : x <= -1 ? -$d628e6e00ecb4c6b$export$e51408a300e8929a : Math.asin(x);
}


const $6f4cdea82ed92b44$var$sqrt3 = (0, $d628e6e00ecb4c6b$export$eba8049fb5020b81)(3);
var $6f4cdea82ed92b44$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $d628e6e00ecb4c6b$export$eba8049fb5020b81)(size + (0, $d628e6e00ecb4c6b$export$96ec731ed4dcb222)(size / 28, 0.75)) * 0.59436;
        const t = r / 2;
        const u = t * $6f4cdea82ed92b44$var$sqrt3;
        context.moveTo(0, r);
        context.lineTo(0, -r);
        context.moveTo(-u, -t);
        context.lineTo(u, t);
        context.moveTo(-u, t);
        context.lineTo(u, -t);
    }
};



var $c8882fdadeb362fe$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $d628e6e00ecb4c6b$export$eba8049fb5020b81)(size / (0, $d628e6e00ecb4c6b$export$18c7bea995a110f));
        context.moveTo(r, 0);
        context.arc(0, 0, r, 0, (0, $d628e6e00ecb4c6b$export$a4b4b4d4d776fe92));
    }
};



var $79ca076583b28339$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $d628e6e00ecb4c6b$export$eba8049fb5020b81)(size / 5) / 2;
        context.moveTo(-3 * r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, -3 * r);
        context.lineTo(r, -3 * r);
        context.lineTo(r, -r);
        context.lineTo(3 * r, -r);
        context.lineTo(3 * r, r);
        context.lineTo(r, r);
        context.lineTo(r, 3 * r);
        context.lineTo(-r, 3 * r);
        context.lineTo(-r, r);
        context.lineTo(-3 * r, r);
        context.closePath();
    }
};



const $164bf7863e3e7933$var$tan30 = (0, $d628e6e00ecb4c6b$export$eba8049fb5020b81)(1 / 3);
const $164bf7863e3e7933$var$tan30_2 = $164bf7863e3e7933$var$tan30 * 2;
var $164bf7863e3e7933$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const y = (0, $d628e6e00ecb4c6b$export$eba8049fb5020b81)(size / $164bf7863e3e7933$var$tan30_2);
        const x = y * $164bf7863e3e7933$var$tan30;
        context.moveTo(0, -y);
        context.lineTo(x, 0);
        context.lineTo(0, y);
        context.lineTo(-x, 0);
        context.closePath();
    }
};



var $f577b528d297a34b$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $d628e6e00ecb4c6b$export$eba8049fb5020b81)(size) * 0.62625;
        context.moveTo(0, -r);
        context.lineTo(r, 0);
        context.lineTo(0, r);
        context.lineTo(-r, 0);
        context.closePath();
    }
};



var $3f0dbb17eb0e8030$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $d628e6e00ecb4c6b$export$eba8049fb5020b81)(size - (0, $d628e6e00ecb4c6b$export$96ec731ed4dcb222)(size / 7, 2)) * 0.87559;
        context.moveTo(-r, 0);
        context.lineTo(r, 0);
        context.moveTo(0, r);
        context.lineTo(0, -r);
    }
};



var $fa4fa3288f6b6774$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const w = (0, $d628e6e00ecb4c6b$export$eba8049fb5020b81)(size);
        const x = -w / 2;
        context.rect(x, x, w, w);
    }
};



var $a8ca1fd45655a710$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $d628e6e00ecb4c6b$export$eba8049fb5020b81)(size) * 0.4431;
        context.moveTo(r, r);
        context.lineTo(r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, r);
        context.closePath();
    }
};



const $6be529173db11894$var$ka = 0.89081309152928522810;
const $6be529173db11894$var$kr = (0, $d628e6e00ecb4c6b$export$5de3937cb4b592ed)((0, $d628e6e00ecb4c6b$export$18c7bea995a110f) / 10) / (0, $d628e6e00ecb4c6b$export$5de3937cb4b592ed)(7 * (0, $d628e6e00ecb4c6b$export$18c7bea995a110f) / 10);
const $6be529173db11894$var$kx = (0, $d628e6e00ecb4c6b$export$5de3937cb4b592ed)((0, $d628e6e00ecb4c6b$export$a4b4b4d4d776fe92) / 10) * $6be529173db11894$var$kr;
const $6be529173db11894$var$ky = -(0, $d628e6e00ecb4c6b$export$50d414a77b60d802)((0, $d628e6e00ecb4c6b$export$a4b4b4d4d776fe92) / 10) * $6be529173db11894$var$kr;
var $6be529173db11894$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $d628e6e00ecb4c6b$export$eba8049fb5020b81)(size * $6be529173db11894$var$ka);
        const x = $6be529173db11894$var$kx * r;
        const y = $6be529173db11894$var$ky * r;
        context.moveTo(0, -r);
        context.lineTo(x, y);
        for(let i = 1; i < 5; ++i){
            const a = (0, $d628e6e00ecb4c6b$export$a4b4b4d4d776fe92) * i / 5;
            const c = (0, $d628e6e00ecb4c6b$export$50d414a77b60d802)(a);
            const s = (0, $d628e6e00ecb4c6b$export$5de3937cb4b592ed)(a);
            context.lineTo(s * r, -c * r);
            context.lineTo(c * x - s * y, s * x + c * y);
        }
        context.closePath();
    }
};



const $614f5ceb002dd477$var$sqrt3 = (0, $d628e6e00ecb4c6b$export$eba8049fb5020b81)(3);
var $614f5ceb002dd477$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const y = -(0, $d628e6e00ecb4c6b$export$eba8049fb5020b81)(size / ($614f5ceb002dd477$var$sqrt3 * 3));
        context.moveTo(0, y * 2);
        context.lineTo(-$614f5ceb002dd477$var$sqrt3 * y, -y);
        context.lineTo($614f5ceb002dd477$var$sqrt3 * y, -y);
        context.closePath();
    }
};



const $b40f3ac23a1a69ed$var$sqrt3 = (0, $d628e6e00ecb4c6b$export$eba8049fb5020b81)(3);
var $b40f3ac23a1a69ed$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const s = (0, $d628e6e00ecb4c6b$export$eba8049fb5020b81)(size) * 0.6824;
        const t = s / 2;
        const u = s * $b40f3ac23a1a69ed$var$sqrt3 / 2; // cos(Math.PI / 6)
        context.moveTo(0, -s);
        context.lineTo(u, t);
        context.lineTo(-u, t);
        context.closePath();
    }
};



const $e6bac68a16fbfab8$var$c = -0.5;
const $e6bac68a16fbfab8$var$s = (0, $d628e6e00ecb4c6b$export$eba8049fb5020b81)(3) / 2;
const $e6bac68a16fbfab8$var$k = 1 / (0, $d628e6e00ecb4c6b$export$eba8049fb5020b81)(12);
const $e6bac68a16fbfab8$var$a = ($e6bac68a16fbfab8$var$k / 2 + 1) * 3;
var $e6bac68a16fbfab8$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $d628e6e00ecb4c6b$export$eba8049fb5020b81)(size / $e6bac68a16fbfab8$var$a);
        const x0 = r / 2, y0 = r * $e6bac68a16fbfab8$var$k;
        const x1 = x0, y1 = r * $e6bac68a16fbfab8$var$k + r;
        const x2 = -x1, y2 = y1;
        context.moveTo(x0, y0);
        context.lineTo(x1, y1);
        context.lineTo(x2, y2);
        context.lineTo($e6bac68a16fbfab8$var$c * x0 - $e6bac68a16fbfab8$var$s * y0, $e6bac68a16fbfab8$var$s * x0 + $e6bac68a16fbfab8$var$c * y0);
        context.lineTo($e6bac68a16fbfab8$var$c * x1 - $e6bac68a16fbfab8$var$s * y1, $e6bac68a16fbfab8$var$s * x1 + $e6bac68a16fbfab8$var$c * y1);
        context.lineTo($e6bac68a16fbfab8$var$c * x2 - $e6bac68a16fbfab8$var$s * y2, $e6bac68a16fbfab8$var$s * x2 + $e6bac68a16fbfab8$var$c * y2);
        context.lineTo($e6bac68a16fbfab8$var$c * x0 + $e6bac68a16fbfab8$var$s * y0, $e6bac68a16fbfab8$var$c * y0 - $e6bac68a16fbfab8$var$s * x0);
        context.lineTo($e6bac68a16fbfab8$var$c * x1 + $e6bac68a16fbfab8$var$s * y1, $e6bac68a16fbfab8$var$c * y1 - $e6bac68a16fbfab8$var$s * x1);
        context.lineTo($e6bac68a16fbfab8$var$c * x2 + $e6bac68a16fbfab8$var$s * y2, $e6bac68a16fbfab8$var$c * y2 - $e6bac68a16fbfab8$var$s * x2);
        context.closePath();
    }
};



var $bd7da5e5fa0c161c$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $d628e6e00ecb4c6b$export$eba8049fb5020b81)(size - (0, $d628e6e00ecb4c6b$export$96ec731ed4dcb222)(size / 6, 1.7)) * 0.6189;
        context.moveTo(-r, -r);
        context.lineTo(r, r);
        context.moveTo(-r, r);
        context.lineTo(r, -r);
    }
};


const $dc048593b18773f6$export$19158c96a6700c15 = [
    (0, $c8882fdadeb362fe$export$2e2bcd8739ae039),
    (0, $79ca076583b28339$export$2e2bcd8739ae039),
    (0, $164bf7863e3e7933$export$2e2bcd8739ae039),
    (0, $fa4fa3288f6b6774$export$2e2bcd8739ae039),
    (0, $6be529173db11894$export$2e2bcd8739ae039),
    (0, $614f5ceb002dd477$export$2e2bcd8739ae039),
    (0, $e6bac68a16fbfab8$export$2e2bcd8739ae039)
];
const $dc048593b18773f6$export$915e06de6acf8fe = [
    (0, $c8882fdadeb362fe$export$2e2bcd8739ae039),
    (0, $3f0dbb17eb0e8030$export$2e2bcd8739ae039),
    (0, $bd7da5e5fa0c161c$export$2e2bcd8739ae039),
    (0, $b40f3ac23a1a69ed$export$2e2bcd8739ae039),
    (0, $6f4cdea82ed92b44$export$2e2bcd8739ae039),
    (0, $a8ca1fd45655a710$export$2e2bcd8739ae039),
    (0, $f577b528d297a34b$export$2e2bcd8739ae039)
];
function $dc048593b18773f6$export$2e2bcd8739ae039(type, size) {
    let context = null, path = (0, $c5bbe85e3fd75d0a$export$fb6e83118a5dcd45)(symbol);
    type = typeof type === "function" ? type : (0, $d6e59e50048c1129$export$2e2bcd8739ae039)(type || (0, $c8882fdadeb362fe$export$2e2bcd8739ae039));
    size = typeof size === "function" ? size : (0, $d6e59e50048c1129$export$2e2bcd8739ae039)(size === undefined ? 64 : +size);
    function symbol() {
        let buffer;
        if (!context) context = buffer = path();
        type.apply(this, arguments).draw(context, +size.apply(this, arguments));
        if (buffer) return context = null, buffer + "" || null;
    }
    symbol.type = function(_) {
        return arguments.length ? (type = typeof _ === "function" ? _ : (0, $d6e59e50048c1129$export$2e2bcd8739ae039)(_), symbol) : type;
    };
    symbol.size = function(_) {
        return arguments.length ? (size = typeof _ === "function" ? _ : (0, $d6e59e50048c1129$export$2e2bcd8739ae039)(+_), symbol) : size;
    };
    symbol.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, symbol) : context;
    };
    return symbol;
}





function $d395578883b2cbe6$export$238176e5211cdc1a(arr, startIndex, endIndex) {
    if (!Array.isArray(arr)) return arr;
    if (arr && startIndex + endIndex !== 0) return arr.slice(startIndex, endIndex + 1);
    return arr;
}



function $d5958b0668c58531$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d5958b0668c58531$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d5958b0668c58531$var$ownKeys(Object(t), !0).forEach(function(r) {
            $d5958b0668c58531$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d5958b0668c58531$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $d5958b0668c58531$var$_defineProperty(e, r, t) {
    return (r = $d5958b0668c58531$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $d5958b0668c58531$var$_toPropertyKey(t) {
    var i = $d5958b0668c58531$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $d5958b0668c58531$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $d5958b0668c58531$export$f97fc4a450f29a(obj, dataKey, defaultValue) {
    if ((0, $7e613228d3a31273$export$b931b78cbb3caf86)(obj) || (0, $7e613228d3a31273$export$b931b78cbb3caf86)(dataKey)) return defaultValue;
    if ((0, $7e613228d3a31273$export$402a499e1ea44294)(dataKey)) return (0, (/*@__PURE__*/$parcel$interopDefault($c09fe069b4c20e1b$exports)))(obj, dataKey, defaultValue);
    if (typeof dataKey === 'function') return dataKey(obj);
    return defaultValue;
}
var $d5958b0668c58531$export$3a657a8c9f789617 = (offset, legendSettings, legendSize)=>{
    if (legendSettings && legendSize) {
        var { width: boxWidth, height: boxHeight } = legendSize;
        var { align: align, verticalAlign: verticalAlign, layout: layout } = legendSettings;
        if ((layout === 'vertical' || layout === 'horizontal' && verticalAlign === 'middle') && align !== 'center' && (0, $7e613228d3a31273$export$7e4aa119212bc614)(offset[align])) return $d5958b0668c58531$var$_objectSpread($d5958b0668c58531$var$_objectSpread({}, offset), {}, {
            [align]: offset[align] + (boxWidth || 0)
        });
        if ((layout === 'horizontal' || layout === 'vertical' && align === 'center') && verticalAlign !== 'middle' && (0, $7e613228d3a31273$export$7e4aa119212bc614)(offset[verticalAlign])) return $d5958b0668c58531$var$_objectSpread($d5958b0668c58531$var$_objectSpread({}, offset), {}, {
            [verticalAlign]: offset[verticalAlign] + (boxHeight || 0)
        });
    }
    return offset;
};
var $d5958b0668c58531$export$9fc1baaa6c6368b = (layout, axisType)=>layout === 'horizontal' && axisType === 'xAxis' || layout === 'vertical' && axisType === 'yAxis' || layout === 'centric' && axisType === 'angleAxis' || layout === 'radial' && axisType === 'radiusAxis';
var $d5958b0668c58531$export$846dc5ac5fecff74 = (ticks, minValue, maxValue, syncWithTicks)=>{
    if (syncWithTicks) return ticks.map((entry)=>entry.coordinate);
    var hasMin, hasMax;
    var values = ticks.map((entry)=>{
        if (entry.coordinate === minValue) hasMin = true;
        if (entry.coordinate === maxValue) hasMax = true;
        return entry.coordinate;
    });
    if (!hasMin) values.push(minValue);
    if (!hasMax) values.push(maxValue);
    return values;
};
var $d5958b0668c58531$export$c829ee42daf7f66d = (axis, isGrid, isAll)=>{
    if (!axis) return null;
    var { duplicateDomain: duplicateDomain, type: type, range: range, scale: scale, realScaleType: realScaleType, isCategorical: isCategorical, categoricalDomain: categoricalDomain, tickCount: tickCount, ticks: ticks, niceTicks: niceTicks, axisType: axisType } = axis;
    if (!scale) return null;
    var offsetForBand = realScaleType === 'scaleBand' && scale.bandwidth ? scale.bandwidth() / 2 : 2;
    var offset = (isGrid || isAll) && type === 'category' && scale.bandwidth ? scale.bandwidth() / offsetForBand : 0;
    offset = axisType === 'angleAxis' && range && range.length >= 2 ? (0, $7e613228d3a31273$export$9d334328eb75e624)(range[0] - range[1]) * 2 * offset : offset;
    // The ticks set by user should only affect the ticks adjacent to axis line
    if (isGrid && (ticks || niceTicks)) {
        var result = (ticks || niceTicks || []).map((entry, index)=>{
            var scaleContent = duplicateDomain ? duplicateDomain.indexOf(entry) : entry;
            var scaled = scale.map(scaleContent);
            if (!(0, $22869ac8a5888437$export$f8a8fc612ced9bb0)(scaled)) return null;
            return {
                // If the scaleContent is not a number, the coordinate will be NaN.
                // That could be the case for example with a PointScale and a string as domain.
                coordinate: scaled + offset,
                value: entry,
                offset: offset,
                index: index
            };
        }).filter((0, $7e613228d3a31273$export$7e515ab5fbd92bef));
        return result;
    }
    // When axis is a categorical axis, but the type of axis is number or the scale of axis is not "auto"
    // For type='number' with niceTicks available, skip this branch so ticks are evenly spaced (GitHub issue #4271)
    if (isCategorical && categoricalDomain) return categoricalDomain.map((entry, index)=>{
        var scaled = scale.map(entry);
        if (!(0, $22869ac8a5888437$export$f8a8fc612ced9bb0)(scaled)) return null;
        return {
            coordinate: scaled + offset,
            value: entry,
            index: index,
            offset: offset
        };
    }).filter((0, $7e613228d3a31273$export$7e515ab5fbd92bef));
    if (scale.ticks && !isAll && tickCount != null) return scale.ticks(tickCount).map((entry, index)=>{
        var scaled = scale.map(entry);
        if (!(0, $22869ac8a5888437$export$f8a8fc612ced9bb0)(scaled)) return null;
        return {
            coordinate: scaled + offset,
            value: entry,
            index: index,
            offset: offset
        };
    }).filter((0, $7e613228d3a31273$export$7e515ab5fbd92bef));
    // When axis has duplicated text, serial numbers are used to generate scale
    return scale.domain().map((entry, index)=>{
        var scaled = scale.map(entry);
        if (!(0, $22869ac8a5888437$export$f8a8fc612ced9bb0)(scaled)) return null;
        return {
            coordinate: scaled + offset,
            // @ts-expect-error can't use Date as an index
            value: duplicateDomain ? duplicateDomain[entry] : entry,
            index: index,
            offset: offset
        };
    }).filter((0, $7e613228d3a31273$export$7e515ab5fbd92bef));
};
var $d5958b0668c58531$export$c7ec0fa96d0c462e = (value, domain)=>{
    if (!domain || domain.length !== 2 || !(0, $7e613228d3a31273$export$7e4aa119212bc614)(domain[0]) || !(0, $7e613228d3a31273$export$7e4aa119212bc614)(domain[1])) return value;
    var minValue = Math.min(domain[0], domain[1]);
    var maxValue = Math.max(domain[0], domain[1]);
    var result = [
        value[0],
        value[1]
    ];
    if (!(0, $7e613228d3a31273$export$7e4aa119212bc614)(value[0]) || value[0] < minValue) result[0] = minValue;
    if (!(0, $7e613228d3a31273$export$7e4aa119212bc614)(value[1]) || value[1] > maxValue) result[1] = maxValue;
    if (result[0] > maxValue) result[0] = maxValue;
    if (result[1] < minValue) result[1] = minValue;
    return result;
};
var $d5958b0668c58531$export$3104c513558164c1 = (series)=>{
    var _series$;
    var n = series.length;
    if (n <= 0) return;
    var m = (_series$ = series[0]) === null || _series$ === void 0 ? void 0 : _series$.length;
    if (m == null || m <= 0) return;
    for(var j = 0; j < m; ++j){
        var positive = 0;
        var negative = 0;
        for(var i = 0; i < n; ++i){
            var row = series[i];
            var col = row === null || row === void 0 ? void 0 : row[j];
            if (col == null) continue;
            var series1 = col[1];
            var series0 = col[0];
            var value = (0, $7e613228d3a31273$export$e426a261f3212d7d)(series1) ? series0 : series1;
            if (value >= 0) {
                col[0] = positive;
                positive += value;
                col[1] = positive;
            } else {
                col[0] = negative;
                negative += value;
                col[1] = negative;
            }
        }
    }
};
var $d5958b0668c58531$export$9f2c6ead70935022 = (series)=>{
    var _series$2;
    var n = series.length;
    if (n <= 0) return;
    var m = (_series$2 = series[0]) === null || _series$2 === void 0 ? void 0 : _series$2.length;
    if (m == null || m <= 0) return;
    for(var j = 0; j < m; ++j){
        var positive = 0;
        for(var i = 0; i < n; ++i){
            var row = series[i];
            var col = row === null || row === void 0 ? void 0 : row[j];
            if (col == null) continue;
            var value = (0, $7e613228d3a31273$export$e426a261f3212d7d)(col[1]) ? col[0] : col[1];
            if (value >= 0) {
                col[0] = positive;
                positive += value;
                col[1] = positive;
            } else {
                col[0] = 0;
                col[1] = 0;
            }
        }
    }
};
/**
 * Function type to compute offset for stacked data.
 *
 * d3-shape has something fishy going on with its types.
 * In @definitelytyped/d3-shape, this function (the offset accessor) is typed as Series<> => void.
 * However! When I actually open the storybook I can see that the offset accessor actually receives Array<Series<>>.
 * The same I can see in the source code itself:
 * https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/66042
 * That one unfortunately has no types but we can tell it passes three-dimensional array.
 *
 * Which leads me to believe that definitelytyped is wrong on this one.
 * There's open discussion on this topic without much attention:
 * https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/66042
 */ var $d5958b0668c58531$var$STACK_OFFSET_MAP = {
    sign: $d5958b0668c58531$export$3104c513558164c1,
    // @ts-expect-error definitelytyped types are incorrect
    expand: (0, $8c4136bb2d530ad8$export$2e2bcd8739ae039),
    // @ts-expect-error definitelytyped types are incorrect
    none: (0, $9775ddd394e37b76$export$2e2bcd8739ae039),
    // @ts-expect-error definitelytyped types are incorrect
    silhouette: (0, $3f2df7b7e1210a6d$export$2e2bcd8739ae039),
    // @ts-expect-error definitelytyped types are incorrect
    wiggle: (0, $846ffeb5bf8a78c6$export$2e2bcd8739ae039),
    positive: $d5958b0668c58531$export$9f2c6ead70935022
};
var $d5958b0668c58531$export$c2170542cfc0177c = (data, dataKeys, offsetType)=>{
    var _STACK_OFFSET_MAP$off;
    var offsetAccessor = (_STACK_OFFSET_MAP$off = $d5958b0668c58531$var$STACK_OFFSET_MAP[offsetType]) !== null && _STACK_OFFSET_MAP$off !== void 0 ? _STACK_OFFSET_MAP$off : (0, $9775ddd394e37b76$export$2e2bcd8739ae039);
    var stack = (0, $3414b636b1e1bb0c$export$2e2bcd8739ae039)().keys(dataKeys).value((d, key)=>Number($d5958b0668c58531$export$f97fc4a450f29a(d, key, 0))).order((0, $d456a60f207888a6$export$2e2bcd8739ae039))// @ts-expect-error definitelytyped types are incorrect
    .offset(offsetAccessor);
    var result = stack(data);
    // Post-process ranged data: if value is an array of two numbers, use them directly without stacking
    result.forEach((series, seriesIndex)=>{
        series.forEach((point, pointIndex)=>{
            var value = $d5958b0668c58531$export$f97fc4a450f29a(data[pointIndex], dataKeys[seriesIndex], 0);
            if (Array.isArray(value) && value.length === 2 && (0, $7e613228d3a31273$export$7e4aa119212bc614)(value[0]) && (0, $7e613228d3a31273$export$7e4aa119212bc614)(value[1])) {
                // eslint-disable-next-line prefer-destructuring,no-param-reassign
                point[0] = value[0];
                // eslint-disable-next-line prefer-destructuring,no-param-reassign
                point[1] = value[1];
            }
        });
    });
    return result;
};
function $d5958b0668c58531$export$f0871da41ca7fc82(publicStackId) {
    return publicStackId == null ? undefined : String(publicStackId);
}
function $d5958b0668c58531$export$6e87f3defb83c3f(_ref) {
    var { axis: axis, ticks: ticks, bandSize: bandSize, entry: entry, index: index, dataKey: dataKey } = _ref;
    if (axis.type === 'category') {
        // find coordinate of category axis by the value of category
        // @ts-expect-error why does this use direct object access instead of getValueByDataKey?
        if (!axis.allowDuplicatedCategory && axis.dataKey && !(0, $7e613228d3a31273$export$b931b78cbb3caf86)(entry[axis.dataKey])) {
            // @ts-expect-error why does this use direct object access instead of getValueByDataKey?
            var matchedTick = (0, $7e613228d3a31273$export$66950d3869f5cc67)(ticks, 'value', entry[axis.dataKey]);
            if (matchedTick) return matchedTick.coordinate + bandSize / 2;
        }
        return ticks !== null && ticks !== void 0 && ticks[index] ? ticks[index].coordinate + bandSize / 2 : null;
    }
    var value = $d5958b0668c58531$export$f97fc4a450f29a(entry, !(0, $7e613228d3a31273$export$b931b78cbb3caf86)(dataKey) ? dataKey : axis.dataKey);
    var scaled = axis.scale.map(value);
    if (!(0, $7e613228d3a31273$export$7e4aa119212bc614)(scaled)) return null;
    return scaled;
}
var $d5958b0668c58531$export$8abb9e87422f3a0c = (_ref2)=>{
    var { axis: axis, ticks: ticks, offset: offset, bandSize: bandSize, entry: entry, index: index } = _ref2;
    if (axis.type === 'category') return ticks[index] ? ticks[index].coordinate + offset : null;
    // getValueByDataKey does not validate the output type
    var value = $d5958b0668c58531$export$f97fc4a450f29a(entry, axis.dataKey, axis.scale.domain()[index]);
    if ((0, $7e613228d3a31273$export$b931b78cbb3caf86)(value)) return null;
    var scaled = axis.scale.map(value);
    if (!(0, $7e613228d3a31273$export$7e4aa119212bc614)(scaled)) return null;
    return scaled - bandSize / 2 + offset;
};
var $d5958b0668c58531$export$54f3200dd4a8a235 = (_ref3)=>{
    var { numericAxis: numericAxis } = _ref3;
    var domain = numericAxis.scale.domain();
    if (numericAxis.type === 'number') {
        // @ts-expect-error type number means the domain has numbers in it but this relationship is not known to typescript
        var minValue = Math.min(domain[0], domain[1]);
        // @ts-expect-error type number means the domain has numbers in it but this relationship is not known to typescript
        var maxValue = Math.max(domain[0], domain[1]);
        if (minValue <= 0 && maxValue >= 0) return 0;
        if (maxValue < 0) return maxValue;
        return minValue;
    }
    return domain[0];
};
var $d5958b0668c58531$var$getDomainOfSingle = (data)=>{
    var flat = data.flat(2).filter((0, $7e613228d3a31273$export$7e4aa119212bc614));
    return [
        Math.min(...flat),
        Math.max(...flat)
    ];
};
var $d5958b0668c58531$var$makeDomainFinite = (domain)=>{
    return [
        domain[0] === Infinity ? 0 : domain[0],
        domain[1] === -Infinity ? 0 : domain[1]
    ];
};
var $d5958b0668c58531$export$26522b779eb5497c = (stackGroups, startIndex, endIndex)=>{
    if (stackGroups == null) return undefined;
    return $d5958b0668c58531$var$makeDomainFinite(Object.keys(stackGroups).reduce((result, stackId)=>{
        var group = stackGroups[stackId];
        if (!group) return result;
        var { stackedData: stackedData } = group;
        var domain = stackedData.reduce((res, entry)=>{
            var sliced = (0, $d395578883b2cbe6$export$238176e5211cdc1a)(entry, startIndex, endIndex);
            var s = $d5958b0668c58531$var$getDomainOfSingle(sliced);
            if (!(0, $22869ac8a5888437$export$f8a8fc612ced9bb0)(s[0]) || !(0, $22869ac8a5888437$export$f8a8fc612ced9bb0)(s[1])) return res;
            return [
                Math.min(res[0], s[0]),
                Math.max(res[1], s[1])
            ];
        }, [
            Infinity,
            -Infinity
        ]);
        return [
            Math.min(domain[0], result[0]),
            Math.max(domain[1], result[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]));
};
var $d5958b0668c58531$export$75a7b23ff266dfa1 = /^dataMin[\s]*-[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
var $d5958b0668c58531$export$19c111ec8ad6c644 = /^dataMax[\s]*\+[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
var $d5958b0668c58531$export$212ec45c42fe68a7 = (axis, ticks, isBar)=>{
    if (axis && axis.scale && axis.scale.bandwidth) {
        var bandWidth = axis.scale.bandwidth();
        if (!isBar || bandWidth > 0) return bandWidth;
    }
    if (axis && ticks && ticks.length >= 2) {
        var orderedTicks = (0, (/*@__PURE__*/$parcel$interopDefault($ce976de4b913f215$exports)))(ticks, (o)=>o.coordinate);
        var bandSize = Infinity;
        for(var i = 1, len = orderedTicks.length; i < len; i++){
            var cur = orderedTicks[i];
            var prev = orderedTicks[i - 1];
            bandSize = Math.min(((cur === null || cur === void 0 ? void 0 : cur.coordinate) || 0) - ((prev === null || prev === void 0 ? void 0 : prev.coordinate) || 0), bandSize);
        }
        return bandSize === Infinity ? 0 : bandSize;
    }
    return isBar ? undefined : 0;
};
function $d5958b0668c58531$export$3c1b390368bb3561(_ref4) {
    var { tooltipEntrySettings: tooltipEntrySettings, dataKey: dataKey, payload: payload, value: value, name: name } = _ref4;
    return $d5958b0668c58531$var$_objectSpread($d5958b0668c58531$var$_objectSpread({}, tooltipEntrySettings), {}, {
        dataKey: dataKey,
        payload: payload,
        value: value,
        name: name
    });
}
function $d5958b0668c58531$export$d3207de44081d2b3(nameFromItem, dataKey) {
    if (nameFromItem) return String(nameFromItem);
    if (typeof dataKey === 'string') return dataKey;
    return undefined;
}
var $d5958b0668c58531$export$f29fac779ccd75bc = (coordinate, layout)=>{
    if (layout === 'horizontal') return coordinate.relativeX;
    if (layout === 'vertical') return coordinate.relativeY;
    return undefined;
};
var $d5958b0668c58531$export$fb2b0f76aa25d837 = (rangeObj, layout)=>{
    if (layout === 'centric') return rangeObj.angle;
    return rangeObj.radius;
};


var $0b675d94b376aa83$export$771ef0ac044f724d = (state)=>state.layout.width;
var $0b675d94b376aa83$export$5856a7d94c109505 = (state)=>state.layout.height;
var $0b675d94b376aa83$export$317b55dda5fb5617 = (state)=>state.layout.scale;
var $0b675d94b376aa83$export$aa3aa1fbf76377f0 = (state)=>state.layout.margin;



var $22dcbe180c9a8d3a$export$bd320344232f30af = (0, $757e1d271f969f78$export$595d22ed68ca2841)((state)=>state.cartesianAxis.xAxis, (xAxisMap)=>{
    return Object.values(xAxisMap);
});
var $22dcbe180c9a8d3a$export$e22adabb0128cf25 = (0, $757e1d271f969f78$export$595d22ed68ca2841)((state)=>state.cartesianAxis.yAxis, (yAxisMap)=>{
    return Object.values(yAxisMap);
});


var $868751348c5652f4$export$db34c3e22d611955 = [
    '#1890FF',
    '#66B5FF',
    '#41D9C7',
    '#2FC25B',
    '#6EDB8F',
    '#9AE65C',
    '#FACC14',
    '#E6965C',
    '#57AD71',
    '#223273',
    '#738AE6',
    '#7564CC',
    '#8543E0',
    '#A877ED',
    '#5C8EE6',
    '#13C2C2',
    '#70E0E0',
    '#5CA3E6',
    '#3436C7',
    '#8082FF',
    '#DD81E6',
    '#F04864',
    '#FA7D92',
    '#D598D9'
];
var $868751348c5652f4$export$c0f3d78d63b3e065 = 'data-recharts-item-index';
var $868751348c5652f4$export$5c80c48c1d137460 = 'data-recharts-item-id';
var $868751348c5652f4$export$fb6ee82c8ee2faf8 = 60;


function $cd6092f0bbb953fd$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cd6092f0bbb953fd$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cd6092f0bbb953fd$var$ownKeys(Object(t), !0).forEach(function(r) {
            $cd6092f0bbb953fd$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cd6092f0bbb953fd$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $cd6092f0bbb953fd$var$_defineProperty(e, r, t) {
    return (r = $cd6092f0bbb953fd$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $cd6092f0bbb953fd$var$_toPropertyKey(t) {
    var i = $cd6092f0bbb953fd$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $cd6092f0bbb953fd$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $cd6092f0bbb953fd$export$2d0a7adecb2afc9c = (state)=>state.brush.height;
function $cd6092f0bbb953fd$var$selectLeftAxesOffset(state) {
    var yAxes = (0, $22dcbe180c9a8d3a$export$e22adabb0128cf25)(state);
    return yAxes.reduce((result, entry)=>{
        if (entry.orientation === 'left' && !entry.mirror && !entry.hide) {
            var width = typeof entry.width === 'number' ? entry.width : (0, $868751348c5652f4$export$fb6ee82c8ee2faf8);
            return result + width;
        }
        return result;
    }, 0);
}
function $cd6092f0bbb953fd$var$selectRightAxesOffset(state) {
    var yAxes = (0, $22dcbe180c9a8d3a$export$e22adabb0128cf25)(state);
    return yAxes.reduce((result, entry)=>{
        if (entry.orientation === 'right' && !entry.mirror && !entry.hide) {
            var width = typeof entry.width === 'number' ? entry.width : (0, $868751348c5652f4$export$fb6ee82c8ee2faf8);
            return result + width;
        }
        return result;
    }, 0);
}
function $cd6092f0bbb953fd$var$selectTopAxesOffset(state) {
    var xAxes = (0, $22dcbe180c9a8d3a$export$bd320344232f30af)(state);
    return xAxes.reduce((result, entry)=>{
        if (entry.orientation === 'top' && !entry.mirror && !entry.hide) return result + entry.height;
        return result;
    }, 0);
}
function $cd6092f0bbb953fd$var$selectBottomAxesOffset(state) {
    var xAxes = (0, $22dcbe180c9a8d3a$export$bd320344232f30af)(state);
    return xAxes.reduce((result, entry)=>{
        if (entry.orientation === 'bottom' && !entry.mirror && !entry.hide) return result + entry.height;
        return result;
    }, 0);
}
var $cd6092f0bbb953fd$export$1e34c8efb0bc9b3b = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    (0, $0b675d94b376aa83$export$771ef0ac044f724d),
    (0, $0b675d94b376aa83$export$5856a7d94c109505),
    (0, $0b675d94b376aa83$export$aa3aa1fbf76377f0),
    $cd6092f0bbb953fd$export$2d0a7adecb2afc9c,
    $cd6092f0bbb953fd$var$selectLeftAxesOffset,
    $cd6092f0bbb953fd$var$selectRightAxesOffset,
    $cd6092f0bbb953fd$var$selectTopAxesOffset,
    $cd6092f0bbb953fd$var$selectBottomAxesOffset,
    (0, $3a89fcd13152106d$export$1d27a9e667f67593),
    (0, $3a89fcd13152106d$export$c9c2b00a34f852e5)
], (chartWidth, chartHeight, margin, brushHeight, leftAxesOffset, rightAxesOffset, topAxesOffset, bottomAxesOffset, legendSettings, legendSize)=>{
    var offsetH = {
        left: (margin.left || 0) + leftAxesOffset,
        right: (margin.right || 0) + rightAxesOffset
    };
    var offsetV = {
        top: (margin.top || 0) + topAxesOffset,
        bottom: (margin.bottom || 0) + bottomAxesOffset
    };
    var offset = $cd6092f0bbb953fd$var$_objectSpread($cd6092f0bbb953fd$var$_objectSpread({}, offsetV), offsetH);
    var brushBottom = offset.bottom;
    offset.bottom += brushHeight;
    offset = (0, $d5958b0668c58531$export$3a657a8c9f789617)(offset, legendSettings, legendSize);
    var offsetWidth = chartWidth - offset.left - offset.right;
    var offsetHeight = chartHeight - offset.top - offset.bottom;
    return $cd6092f0bbb953fd$var$_objectSpread($cd6092f0bbb953fd$var$_objectSpread({
        brushBottom: brushBottom
    }, offset), {}, {
        // never return negative values for height and width
        width: Math.max(offsetWidth, 0),
        height: Math.max(offsetHeight, 0)
    });
});
var $cd6092f0bbb953fd$export$fb5e3eb7f8167ce7 = (0, $757e1d271f969f78$export$595d22ed68ca2841)($cd6092f0bbb953fd$export$1e34c8efb0bc9b3b, (offset)=>({
        x: offset.left,
        y: offset.top,
        width: offset.width,
        height: offset.height
    }));
var $cd6092f0bbb953fd$export$32c8e778bac69ce4 = (0, $757e1d271f969f78$export$595d22ed68ca2841)((0, $0b675d94b376aa83$export$771ef0ac044f724d), (0, $0b675d94b376aa83$export$5856a7d94c109505), (width, height)=>({
        x: 0,
        y: 0,
        width: width,
        height: height
    }));




var $kc00y = parcelRequire("kc00y");
var $10d1d693b6b228cd$var$PanoramaContext = /*#__PURE__*/ (0, $kc00y.createContext)(null);
var $10d1d693b6b228cd$export$4b0c59f8845ba920 = ()=>(0, $kc00y.useContext)($10d1d693b6b228cd$var$PanoramaContext) != null;
var $10d1d693b6b228cd$export$415fcedf1e191db0 = (_ref)=>{
    var { children: children } = _ref;
    return /*#__PURE__*/ $kc00y.createElement($10d1d693b6b228cd$var$PanoramaContext.Provider, {
        value: true
    }, children);
};






var $2f2a17d106b4d13b$export$5ba94b496f8dc52e = (state)=>state.brush;
var $2f2a17d106b4d13b$export$3b81e97eae001823 = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $2f2a17d106b4d13b$export$5ba94b496f8dc52e,
    (0, $cd6092f0bbb953fd$export$1e34c8efb0bc9b3b),
    (0, $0b675d94b376aa83$export$aa3aa1fbf76377f0)
], (brushSettings, offset, margin)=>({
        height: brushSettings.height,
        x: (0, $7e613228d3a31273$export$7e4aa119212bc614)(brushSettings.x) ? brushSettings.x : offset.left,
        y: (0, $7e613228d3a31273$export$7e4aa119212bc614)(brushSettings.y) ? brushSettings.y : offset.top + offset.height + offset.brushBottom - ((margin === null || margin === void 0 ? void 0 : margin.bottom) || 0),
        width: (0, $7e613228d3a31273$export$7e4aa119212bc614)(brushSettings.width) ? brushSettings.width : offset.width
    }));




var $kc00y = parcelRequire("kc00y");
var $f0809ba095341794$exports = {};

$f0809ba095341794$exports = (parcelRequire("cBmIv")).throttle;



/* eslint no-console: 0 */ var $f9eea56c612dc516$var$isDev = true;
var $f9eea56c612dc516$export$c106dd0671a0fc2d = function warn(condition, format) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    if ($f9eea56c612dc516$var$isDev && typeof console !== 'undefined' && console.warn) {
        if (format === undefined) console.warn('LogUtils requires an error message argument');
        if (!condition) {
            if (format === undefined) console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
            else {
                var argIndex = 0;
                console.warn(format.replace(/%s/g, ()=>args[argIndex++]));
            }
        }
    }
};



var $a92cfa4d9584e956$export$5beeeca5506dd945 = {
    width: '100%',
    height: '100%',
    debounce: 0,
    minWidth: 0,
    initialDimension: {
        width: -1,
        height: -1
    }
};
var $a92cfa4d9584e956$export$83d33ab1950e2a9 = (containerWidth, containerHeight, props)=>{
    var { width: width = $a92cfa4d9584e956$export$5beeeca5506dd945.width, height: height = $a92cfa4d9584e956$export$5beeeca5506dd945.height, aspect: aspect, maxHeight: maxHeight } = props;
    /*
   * The containerWidth and containerHeight are already percentage based because it's set as that percentage in CSS.
   * Means we don't have to calculate percentages here.
   */ var calculatedWidth = (0, $7e613228d3a31273$export$e50269385c77c348)(width) ? containerWidth : Number(width);
    var calculatedHeight = (0, $7e613228d3a31273$export$e50269385c77c348)(height) ? containerHeight : Number(height);
    if (aspect && aspect > 0) {
        // Preserve the desired aspect ratio
        if (calculatedWidth) // Will default to using width for aspect ratio
        calculatedHeight = calculatedWidth / aspect;
        else if (calculatedHeight) // But we should also take height into consideration
        calculatedWidth = calculatedHeight * aspect;
        // if maxHeight is set, overwrite if calculatedHeight is greater than maxHeight
        if (maxHeight && calculatedHeight != null && calculatedHeight > maxHeight) calculatedHeight = maxHeight;
    }
    return {
        calculatedWidth: calculatedWidth,
        calculatedHeight: calculatedHeight
    };
};
var $a92cfa4d9584e956$var$bothOverflow = {
    width: 0,
    height: 0,
    overflow: 'visible'
};
var $a92cfa4d9584e956$var$overflowX = {
    width: 0,
    overflowX: 'visible'
};
var $a92cfa4d9584e956$var$overflowY = {
    height: 0,
    overflowY: 'visible'
};
var $a92cfa4d9584e956$var$noStyle = {};
var $a92cfa4d9584e956$export$d36bc8432d8d3f9d = (props)=>{
    var { width: width, height: height } = props;
    var isWidthPercent = (0, $7e613228d3a31273$export$e50269385c77c348)(width);
    var isHeightPercent = (0, $7e613228d3a31273$export$e50269385c77c348)(height);
    if (isWidthPercent && isHeightPercent) return $a92cfa4d9584e956$var$bothOverflow;
    if (isWidthPercent) return $a92cfa4d9584e956$var$overflowX;
    if (isHeightPercent) return $a92cfa4d9584e956$var$overflowY;
    return $a92cfa4d9584e956$var$noStyle;
};
function $a92cfa4d9584e956$export$f717eb32fd8d3af5(_ref) {
    var { width: width, height: height, aspect: aspect } = _ref;
    var calculatedWidth = width;
    var calculatedHeight = height;
    if (calculatedWidth === undefined && calculatedHeight === undefined) {
        calculatedWidth = $a92cfa4d9584e956$export$5beeeca5506dd945.width;
        calculatedHeight = $a92cfa4d9584e956$export$5beeeca5506dd945.height;
    } else if (calculatedWidth === undefined) calculatedWidth = aspect && aspect > 0 ? undefined : $a92cfa4d9584e956$export$5beeeca5506dd945.width;
    else if (calculatedHeight === undefined) calculatedHeight = aspect && aspect > 0 ? undefined : $a92cfa4d9584e956$export$5beeeca5506dd945.height;
    return {
        width: calculatedWidth,
        height: calculatedHeight
    };
}



function $ffea1da660acf881$var$_extends() {
    return $ffea1da660acf881$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ffea1da660acf881$var$_extends.apply(null, arguments);
}
function $ffea1da660acf881$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ffea1da660acf881$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ffea1da660acf881$var$ownKeys(Object(t), !0).forEach(function(r) {
            $ffea1da660acf881$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ffea1da660acf881$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ffea1da660acf881$var$_defineProperty(e, r, t) {
    return (r = $ffea1da660acf881$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $ffea1da660acf881$var$_toPropertyKey(t) {
    var i = $ffea1da660acf881$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $ffea1da660acf881$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $ffea1da660acf881$var$ResponsiveContainerContext = /*#__PURE__*/ (0, $kc00y.createContext)((0, $a92cfa4d9584e956$export$5beeeca5506dd945).initialDimension);
function $ffea1da660acf881$var$isAcceptableSize(size) {
    return (0, $22869ac8a5888437$export$5374bb854d0e41c8)(size.width) && (0, $22869ac8a5888437$export$5374bb854d0e41c8)(size.height);
}
function $ffea1da660acf881$var$ResponsiveContainerContextProvider(_ref) {
    var { children: children, width: width, height: height } = _ref;
    var size = (0, $kc00y.useMemo)(()=>({
            width: width,
            height: height
        }), [
        width,
        height
    ]);
    if (!$ffea1da660acf881$var$isAcceptableSize(size)) /*
     * Don't render the container if width or height is non-positive because
     * in that case the chart will not be rendered properly anyway.
     * We will instead wait for the next resize event to provide the correct dimensions.
     */ return null;
    return /*#__PURE__*/ $kc00y.createElement($ffea1da660acf881$var$ResponsiveContainerContext.Provider, {
        value: size
    }, children);
}
var $ffea1da660acf881$export$4ec9972d4f677af6 = ()=>(0, $kc00y.useContext)($ffea1da660acf881$var$ResponsiveContainerContext);
var $ffea1da660acf881$var$SizeDetectorContainer = /*#__PURE__*/ (0, $kc00y.forwardRef)((_ref2, ref)=>{
    var { aspect: aspect, initialDimension: initialDimension = (0, $a92cfa4d9584e956$export$5beeeca5506dd945).initialDimension, width: width, height: height, minWidth: /*
     * default min-width to 0 if not specified - 'auto' causes issues with flexbox
     * https://github.com/recharts/recharts/issues/172
     */ minWidth = (0, $a92cfa4d9584e956$export$5beeeca5506dd945).minWidth, minHeight: minHeight, maxHeight: maxHeight, children: children, debounce: debounce = (0, $a92cfa4d9584e956$export$5beeeca5506dd945).debounce, id: id, className: className, onResize: onResize, style: style = {} } = _ref2;
    var containerRef = (0, $kc00y.useRef)(null);
    /*
   * We are using a ref to avoid re-creating the ResizeObserver when the onResize function changes.
   * The ref is updated on every render, so the latest onResize function is always available in the effect.
   */ var onResizeRef = (0, $kc00y.useRef)();
    onResizeRef.current = onResize;
    (0, $kc00y.useImperativeHandle)(ref, ()=>containerRef.current);
    var [sizes, setSizes] = (0, $kc00y.useState)({
        containerWidth: initialDimension.width,
        containerHeight: initialDimension.height
    });
    var setContainerSize = (0, $kc00y.useCallback)((newWidth, newHeight)=>{
        setSizes((prevState)=>{
            var roundedWidth = Math.round(newWidth);
            var roundedHeight = Math.round(newHeight);
            if (prevState.containerWidth === roundedWidth && prevState.containerHeight === roundedHeight) return prevState;
            return {
                containerWidth: roundedWidth,
                containerHeight: roundedHeight
            };
        });
    }, []);
    (0, $kc00y.useEffect)(()=>{
        if (containerRef.current == null || typeof ResizeObserver === 'undefined') return 0, $7e613228d3a31273$export$8793edee2d425525;
        var callback = (entries)=>{
            var _onResizeRef$current;
            var entry = entries[0];
            if (entry == null) return;
            var { width: containerWidth, height: containerHeight } = entry.contentRect;
            setContainerSize(containerWidth, containerHeight);
            (_onResizeRef$current = onResizeRef.current) === null || _onResizeRef$current === void 0 || _onResizeRef$current.call(onResizeRef, containerWidth, containerHeight);
        };
        if (debounce > 0) callback = (0, (/*@__PURE__*/$parcel$interopDefault($f0809ba095341794$exports)))(callback, debounce, {
            trailing: true,
            leading: false
        });
        var observer = new ResizeObserver(callback);
        var { width: containerWidth, height: containerHeight } = containerRef.current.getBoundingClientRect();
        setContainerSize(containerWidth, containerHeight);
        observer.observe(containerRef.current);
        return ()=>{
            observer.disconnect();
        };
    }, [
        setContainerSize,
        debounce
    ]);
    var { containerWidth: containerWidth, containerHeight: containerHeight } = sizes;
    (0, $f9eea56c612dc516$export$c106dd0671a0fc2d)(!aspect || aspect > 0, 'The aspect(%s) must be greater than zero.', aspect);
    var { calculatedWidth: calculatedWidth, calculatedHeight: calculatedHeight } = (0, $a92cfa4d9584e956$export$83d33ab1950e2a9)(containerWidth, containerHeight, {
        width: width,
        height: height,
        aspect: aspect,
        maxHeight: maxHeight
    });
    (0, $f9eea56c612dc516$export$c106dd0671a0fc2d)(calculatedWidth != null && calculatedWidth > 0 || calculatedHeight != null && calculatedHeight > 0, "The width(%s) and height(%s) of chart should be greater than 0,\n       please check the style of container, or the props width(%s) and height(%s),\n       or add a minWidth(%s) or minHeight(%s) or use aspect(%s) to control the\n       height and width.", calculatedWidth, calculatedHeight, width, height, minWidth, minHeight, aspect);
    return /*#__PURE__*/ $kc00y.createElement("div", {
        id: id ? "".concat(id) : undefined,
        className: (0, $328c1c2632e2f292$export$4f5d2d50c9deca37)('recharts-responsive-container', className),
        style: $ffea1da660acf881$var$_objectSpread($ffea1da660acf881$var$_objectSpread({}, style), {}, {
            width: width,
            height: height,
            minWidth: minWidth,
            minHeight: minHeight,
            maxHeight: maxHeight
        }),
        ref: containerRef
    }, /*#__PURE__*/ $kc00y.createElement("div", {
        style: (0, $a92cfa4d9584e956$export$d36bc8432d8d3f9d)({
            width: width,
            height: height
        })
    }, /*#__PURE__*/ $kc00y.createElement($ffea1da660acf881$var$ResponsiveContainerContextProvider, {
        width: calculatedWidth,
        height: calculatedHeight
    }, children)));
});
var $ffea1da660acf881$export$e60a4704009a0009 = /*#__PURE__*/ (0, $kc00y.forwardRef)((props, ref)=>{
    var responsiveContainerContext = $ffea1da660acf881$export$4ec9972d4f677af6();
    if ((0, $22869ac8a5888437$export$5374bb854d0e41c8)(responsiveContainerContext.width) && (0, $22869ac8a5888437$export$5374bb854d0e41c8)(responsiveContainerContext.height)) /*
     * If we detect that we are already inside another ResponsiveContainer,
     * we do not attempt to add another layer of responsiveness.
     */ return props.children;
    var { width: width, height: height } = (0, $a92cfa4d9584e956$export$f717eb32fd8d3af5)({
        width: props.width,
        height: props.height,
        aspect: props.aspect
    });
    /*
   * Let's try to get the calculated dimensions without having the div container set up.
   * Sometimes this does produce fixed, positive dimensions. If so, we can skip rendering the div and monitoring its size.
   */ var { calculatedWidth: calculatedWidth, calculatedHeight: calculatedHeight } = (0, $a92cfa4d9584e956$export$83d33ab1950e2a9)(undefined, undefined, {
        width: width,
        height: height,
        aspect: props.aspect,
        maxHeight: props.maxHeight
    });
    if ((0, $7e613228d3a31273$export$7e4aa119212bc614)(calculatedWidth) && (0, $7e613228d3a31273$export$7e4aa119212bc614)(calculatedHeight)) /*
     * If it just so happens that the combination of width, height, and aspect ratio
     * results in fixed dimensions, then we don't need to monitor the container's size.
     * We can just provide these fixed dimensions to the context.
     *
     * Note that here we are not checking for positive numbers;
     * if the user provides a zero or negative width/height, we will just pass that along
     * as whatever size we detect won't be helping anyway.
     */ return /*#__PURE__*/ $kc00y.createElement($ffea1da660acf881$var$ResponsiveContainerContextProvider, {
        width: calculatedWidth,
        height: calculatedHeight
    }, props.children);
    /*
   * Static analysis did not produce fixed dimensions,
   * so we need to render a special div and monitor its size.
   */ return /*#__PURE__*/ $kc00y.createElement($ffea1da660acf881$var$SizeDetectorContainer, $ffea1da660acf881$var$_extends({}, props, {
        width: width,
        height: height,
        ref: ref
    }));
});



function $f4c9341f05a18477$export$94a03fc5d61f2504(box) {
    if (!box) return undefined;
    return {
        x: box.x,
        y: box.y,
        upperWidth: 'upperWidth' in box ? box.upperWidth : box.width,
        lowerWidth: 'lowerWidth' in box ? box.lowerWidth : box.width,
        width: box.width,
        height: box.height
    };
}
var $f4c9341f05a18477$export$76b29bb074e0c45a = ()=>{
    var _useAppSelector;
    var panorama = (0, $10d1d693b6b228cd$export$4b0c59f8845ba920)();
    var rootViewBox = (0, $a441e801d1b41b52$export$a7347740d65f620b)((0, $cd6092f0bbb953fd$export$fb5e3eb7f8167ce7));
    var brushDimensions = (0, $a441e801d1b41b52$export$a7347740d65f620b)((0, $2f2a17d106b4d13b$export$3b81e97eae001823));
    var brushPadding = (_useAppSelector = (0, $a441e801d1b41b52$export$a7347740d65f620b)((0, $2f2a17d106b4d13b$export$5ba94b496f8dc52e))) === null || _useAppSelector === void 0 ? void 0 : _useAppSelector.padding;
    if (!panorama || !brushDimensions || !brushPadding) return rootViewBox;
    return {
        width: brushDimensions.width - brushPadding.left - brushPadding.right,
        height: brushDimensions.height - brushPadding.top - brushPadding.bottom,
        x: brushPadding.left,
        y: brushPadding.top
    };
};
var $f4c9341f05a18477$var$manyComponentsThrowErrorsIfOffsetIsUndefined = {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    width: 0,
    height: 0,
    brushBottom: 0
};
var $f4c9341f05a18477$export$10605f61bef2858a = ()=>{
    var _useAppSelector2;
    return (_useAppSelector2 = (0, $a441e801d1b41b52$export$a7347740d65f620b)((0, $cd6092f0bbb953fd$export$1e34c8efb0bc9b3b))) !== null && _useAppSelector2 !== void 0 ? _useAppSelector2 : $f4c9341f05a18477$var$manyComponentsThrowErrorsIfOffsetIsUndefined;
};
var $f4c9341f05a18477$export$8854f7ece606854b = ()=>{
    return (0, $a441e801d1b41b52$export$a7347740d65f620b)((0, $0b675d94b376aa83$export$771ef0ac044f724d));
};
var $f4c9341f05a18477$export$369ae257969c6f9f = ()=>{
    return (0, $a441e801d1b41b52$export$a7347740d65f620b)((0, $0b675d94b376aa83$export$5856a7d94c109505));
};
var $f4c9341f05a18477$export$58ac794108fd8ca = ()=>{
    return (0, $a441e801d1b41b52$export$a7347740d65f620b)((state)=>state.layout.margin);
};
var $f4c9341f05a18477$export$8426b6d9af801dee = (state)=>state.layout.layoutType;
var $f4c9341f05a18477$export$970c79ecc7081cc = ()=>(0, $a441e801d1b41b52$export$a7347740d65f620b)($f4c9341f05a18477$export$8426b6d9af801dee);
var $f4c9341f05a18477$export$c9942bdfc7f2781c = ()=>{
    var layout = $f4c9341f05a18477$export$970c79ecc7081cc();
    if (layout === 'horizontal' || layout === 'vertical') return layout;
    return undefined;
};
var $f4c9341f05a18477$export$d7a0004f3c7f5ca0 = (state)=>{
    var layout = state.layout.layoutType;
    if (layout === 'centric' || layout === 'radial') return layout;
    return undefined;
};
var $f4c9341f05a18477$export$a5f9dd11254d5e7e = ()=>{
    return (0, $a441e801d1b41b52$export$a7347740d65f620b)($f4c9341f05a18477$export$d7a0004f3c7f5ca0);
};
var $f4c9341f05a18477$export$a3faf3c7b8f19073 = ()=>{
    /*
   * All charts provide a layout type in the chart context.
   * If we have a layout type, we are in a chart context.
   */ var layout = $f4c9341f05a18477$export$970c79ecc7081cc();
    return layout !== undefined;
};
var $f4c9341f05a18477$export$80ea82e77fb424e1 = (props)=>{
    var dispatch = (0, $a441e801d1b41b52$export$f51d452c10d5b956)();
    /*
   * Skip dispatching properties in panorama chart for two reasons:
   * 1. The root chart should be deciding on these properties, and
   * 2. Brush reads these properties from redux store, and so they must remain stable
   *      to avoid circular dependency and infinite re-rendering.
   */ var isPanorama = (0, $10d1d693b6b228cd$export$4b0c59f8845ba920)();
    var { width: widthFromProps, height: heightFromProps } = props;
    var responsiveContainerCalculations = (0, $ffea1da660acf881$export$4ec9972d4f677af6)();
    var width = widthFromProps;
    var height = heightFromProps;
    if (responsiveContainerCalculations) {
        /*
     * In case we receive width and height from ResponsiveContainer,
     * we will always prefer those.
     * Only in case ResponsiveContainer does not provide width or height,
     * we will fall back to the explicitly provided width and height.
     *
     * This to me feels backwards - we should allow override by the more specific props on individual charts, right?
     * But this is 3.x behaviour, so let's keep it for backwards compatibility.
     *
     * We can change this in 4.x if we want to.
     */ width = responsiveContainerCalculations.width > 0 ? responsiveContainerCalculations.width : widthFromProps;
        height = responsiveContainerCalculations.height > 0 ? responsiveContainerCalculations.height : heightFromProps;
    }
    (0, $kc00y.useEffect)(()=>{
        if (!isPanorama && (0, $22869ac8a5888437$export$5374bb854d0e41c8)(width) && (0, $22869ac8a5888437$export$5374bb854d0e41c8)(height)) dispatch((0, $a3abdcf7f5febb61$export$136b7feefeae481a)({
            width: width,
            height: height
        }));
    }, [
        dispatch,
        isPanorama,
        width,
        height
    ]);
    return null;
};
var $f4c9341f05a18477$export$19a41f515e2a12ff = (_ref)=>{
    var { margin: margin } = _ref;
    var dispatch = (0, $a441e801d1b41b52$export$f51d452c10d5b956)();
    (0, $kc00y.useEffect)(()=>{
        dispatch((0, $a3abdcf7f5febb61$export$3f8f25b83912855f)(margin));
    }, [
        dispatch,
        margin
    ]);
    return null;
};








/**
 * A collection of all default zIndex values used by Recharts.
 *
 * You can reuse these, or you can define your own.
 */ var $2d4105c5b5d94e8f$export$96df16b28aa32702 = {
    /**
   * CartesianGrid and PolarGrid
   */ grid: -100,
    /**
   * Background of Bar and RadialBar.
   * This is not visible by default but can be enabled by setting background={true} on Bar or RadialBar.
   */ barBackground: -50,
    /*
   * other chart elements or custom elements without specific zIndex
   * render in here, at zIndex 0
   */ /**
   * Area, Pie, Radar, and ReferenceArea
   */ area: 100,
    /**
   * Cursor is embedded inside Tooltip and controlled by it.
   * The Tooltip itself has a separate portal and is not included in the zIndex system;
   * Cursor is the decoration inside the chart area. CursorRectangle is a rectangle box.
   * It renders below bar so that in a stacked bar chart the cursor rectangle does not hide the other bars.
   */ cursorRectangle: 200,
    /**
   * Bar and RadialBar
   */ bar: 300,
    /**
   * Line and ReferenceLine, and ErrorBor
   */ line: 400,
    /**
   * XAxis and YAxis and PolarAngleAxis and PolarRadiusAxis ticks and lines and children
   */ axis: 500,
    /**
   * Scatter and ReferenceDot,
   * and Dots of Line and Area and Radar if they have dot=true
   */ scatter: 600,
    /**
   * Hovering over a Bar or RadialBar renders a highlight rectangle
   */ activeBar: 1000,
    /**
   * Cursor is embedded inside Tooltip and controlled by it.
   * The Tooltip itself has a separate portal and is not included in the zIndex system;
   * Cursor is the decoration inside the chart area, usually a cross or a box.
   * CursorLine is a line cursor rendered in Line, Area, Scatter, Radar charts.
   * It renders above the Line and Scatter so that it is always visible.
   * It renders below active dot so that the dot is always visible and shows the current point.
   * We're also assuming that the active dot is small enough that it does not fully cover the cursor line.
   *
   * This also applies to the radial cursor in RadialBarChart.
   */ cursorLine: 1100,
    /**
   * Hovering over a Point in Line, Area, Scatter, Radar renders a highlight dot
   */ activeDot: 1200,
    /**
   * LabelList and Label, including Axis labels
   */ label: 2000
};


var $d9d69896a3a17ac1$export$969183d9e860c26e = {
    allowDecimals: false,
    allowDuplicatedCategory: true,
    // if I set this to false then Tooltip synchronisation stops working in Radar, wtf
    allowDataOverflow: false,
    angle: 0,
    angleAxisId: 0,
    axisLine: true,
    axisLineType: 'polygon',
    cx: 0,
    cy: 0,
    hide: false,
    includeHidden: false,
    label: false,
    niceTicks: 'auto',
    orientation: 'outer',
    reversed: false,
    scale: 'auto',
    tick: true,
    tickLine: true,
    tickSize: 8,
    type: 'auto',
    zIndex: (0, $2d4105c5b5d94e8f$export$96df16b28aa32702).axis
};



var $2b0971b37723a4cd$export$1a08e61551a7e57d = {
    allowDataOverflow: false,
    allowDecimals: false,
    allowDuplicatedCategory: true,
    angle: 0,
    axisLine: true,
    includeHidden: false,
    hide: false,
    niceTicks: 'auto',
    label: false,
    orientation: 'right',
    radiusAxisId: 0,
    reversed: false,
    scale: 'auto',
    stroke: '#ccc',
    tick: true,
    tickCount: 5,
    tickLine: true,
    type: 'auto',
    zIndex: (0, $2d4105c5b5d94e8f$export$96df16b28aa32702).axis
};


var $250f5d8c249e6c87$export$3f7e30291950e694 = (axisSettings, axisRange)=>{
    if (!axisSettings || !axisRange) return undefined;
    if (axisSettings !== null && axisSettings !== void 0 && axisSettings.reversed) return [
        axisRange[1],
        axisRange[0]
    ];
    return axisRange;
};




function $d03caba6cdf30c20$export$c71ab14baba33626(layout, axisType, axisDomainType) {
    if (axisDomainType !== 'auto') return axisDomainType;
    if (layout == null) return undefined;
    return (0, $d5958b0668c58531$export$9fc1baaa6c6368b)(layout, axisType) ? 'category' : 'number';
}


function $792f72abcce61010$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $792f72abcce61010$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $792f72abcce61010$var$ownKeys(Object(t), !0).forEach(function(r) {
            $792f72abcce61010$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $792f72abcce61010$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $792f72abcce61010$var$_defineProperty(e, r, t) {
    return (r = $792f72abcce61010$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $792f72abcce61010$var$_toPropertyKey(t) {
    var i = $792f72abcce61010$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $792f72abcce61010$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $792f72abcce61010$export$7489bacc62c76b42 = {
    allowDataOverflow: (0, $d9d69896a3a17ac1$export$969183d9e860c26e).allowDataOverflow,
    allowDecimals: (0, $d9d69896a3a17ac1$export$969183d9e860c26e).allowDecimals,
    allowDuplicatedCategory: false,
    // defaultPolarAngleAxisProps.allowDuplicatedCategory has it set to true but the actual axis rendering ignores the prop because reasons,
    dataKey: undefined,
    domain: undefined,
    id: (0, $d9d69896a3a17ac1$export$969183d9e860c26e).angleAxisId,
    includeHidden: false,
    name: undefined,
    reversed: (0, $d9d69896a3a17ac1$export$969183d9e860c26e).reversed,
    scale: (0, $d9d69896a3a17ac1$export$969183d9e860c26e).scale,
    tick: (0, $d9d69896a3a17ac1$export$969183d9e860c26e).tick,
    tickCount: undefined,
    ticks: undefined,
    type: (0, $d9d69896a3a17ac1$export$969183d9e860c26e).type,
    unit: undefined,
    niceTicks: 'auto'
};
var $792f72abcce61010$export$31037ebc9a4d24a3 = {
    allowDataOverflow: (0, $2b0971b37723a4cd$export$1a08e61551a7e57d).allowDataOverflow,
    allowDecimals: (0, $2b0971b37723a4cd$export$1a08e61551a7e57d).allowDecimals,
    allowDuplicatedCategory: (0, $2b0971b37723a4cd$export$1a08e61551a7e57d).allowDuplicatedCategory,
    dataKey: undefined,
    domain: undefined,
    id: (0, $2b0971b37723a4cd$export$1a08e61551a7e57d).radiusAxisId,
    includeHidden: (0, $2b0971b37723a4cd$export$1a08e61551a7e57d).includeHidden,
    name: undefined,
    reversed: (0, $2b0971b37723a4cd$export$1a08e61551a7e57d).reversed,
    scale: (0, $2b0971b37723a4cd$export$1a08e61551a7e57d).scale,
    tick: (0, $2b0971b37723a4cd$export$1a08e61551a7e57d).tick,
    tickCount: (0, $2b0971b37723a4cd$export$1a08e61551a7e57d).tickCount,
    ticks: undefined,
    type: (0, $2b0971b37723a4cd$export$1a08e61551a7e57d).type,
    unit: undefined,
    niceTicks: 'auto'
};
var $792f72abcce61010$var$selectAngleAxisNoDefaults = (state, angleAxisId)=>{
    if (angleAxisId == null) return undefined;
    return state.polarAxis.angleAxis[angleAxisId];
};
var $792f72abcce61010$export$2d9ff7eb66def0da = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $792f72abcce61010$var$selectAngleAxisNoDefaults,
    (0, $f4c9341f05a18477$export$d7a0004f3c7f5ca0)
], (angleAxisSettings, layout)=>{
    var _getAxisTypeBasedOnLa;
    if (angleAxisSettings != null) return angleAxisSettings;
    var evaluatedType = (_getAxisTypeBasedOnLa = (0, $d03caba6cdf30c20$export$c71ab14baba33626)(layout, 'angleAxis', $792f72abcce61010$export$7489bacc62c76b42.type)) !== null && _getAxisTypeBasedOnLa !== void 0 ? _getAxisTypeBasedOnLa : 'category';
    return $792f72abcce61010$var$_objectSpread($792f72abcce61010$var$_objectSpread({}, $792f72abcce61010$export$7489bacc62c76b42), {}, {
        type: evaluatedType
    });
});
var $792f72abcce61010$var$selectRadiusAxisNoDefaults = (state, radiusAxisId)=>{
    return state.polarAxis.radiusAxis[radiusAxisId];
};
var $792f72abcce61010$export$74b0499accddabe1 = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $792f72abcce61010$var$selectRadiusAxisNoDefaults,
    (0, $f4c9341f05a18477$export$d7a0004f3c7f5ca0)
], (radiusAxisSettings, layout)=>{
    var _getAxisTypeBasedOnLa2;
    if (radiusAxisSettings != null) return radiusAxisSettings;
    var evaluatedType = (_getAxisTypeBasedOnLa2 = (0, $d03caba6cdf30c20$export$c71ab14baba33626)(layout, 'radiusAxis', $792f72abcce61010$export$31037ebc9a4d24a3.type)) !== null && _getAxisTypeBasedOnLa2 !== void 0 ? _getAxisTypeBasedOnLa2 : 'category';
    return $792f72abcce61010$var$_objectSpread($792f72abcce61010$var$_objectSpread({}, $792f72abcce61010$export$31037ebc9a4d24a3), {}, {
        type: evaluatedType
    });
});
var $792f72abcce61010$export$a743f010244424e8 = (state)=>state.polarOptions;
var $792f72abcce61010$export$53b653c1c5d6829b = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    (0, $0b675d94b376aa83$export$771ef0ac044f724d),
    (0, $0b675d94b376aa83$export$5856a7d94c109505),
    (0, $cd6092f0bbb953fd$export$1e34c8efb0bc9b3b)
], (0, $68befda7de8b3621$export$ad5c48602371adfa));
var $792f72abcce61010$var$selectInnerRadius = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $792f72abcce61010$export$a743f010244424e8,
    $792f72abcce61010$export$53b653c1c5d6829b
], (polarChartOptions, maxRadius)=>{
    if (polarChartOptions == null) return undefined;
    return (0, $7e613228d3a31273$export$476354dbf49bdff6)(polarChartOptions.innerRadius, maxRadius, 0);
});
var $792f72abcce61010$export$32a1ec2f6eaad494 = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $792f72abcce61010$export$a743f010244424e8,
    $792f72abcce61010$export$53b653c1c5d6829b
], (polarChartOptions, maxRadius)=>{
    if (polarChartOptions == null) return undefined;
    return (0, $7e613228d3a31273$export$476354dbf49bdff6)(polarChartOptions.outerRadius, maxRadius, maxRadius * 0.8);
});
var $792f72abcce61010$var$combineAngleAxisRange = (polarOptions)=>{
    if (polarOptions == null) return [
        0,
        0
    ];
    var { startAngle: startAngle, endAngle: endAngle } = polarOptions;
    return [
        startAngle,
        endAngle
    ];
};
var $792f72abcce61010$export$d00c8e94622c940 = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $792f72abcce61010$export$a743f010244424e8
], $792f72abcce61010$var$combineAngleAxisRange);
var $792f72abcce61010$export$15ccd32b0dd865d2 = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $792f72abcce61010$export$2d9ff7eb66def0da,
    $792f72abcce61010$export$d00c8e94622c940
], (0, $250f5d8c249e6c87$export$3f7e30291950e694));
var $792f72abcce61010$export$e13d847e4d4f833f = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $792f72abcce61010$export$53b653c1c5d6829b,
    $792f72abcce61010$var$selectInnerRadius,
    $792f72abcce61010$export$32a1ec2f6eaad494
], (maxRadius, innerRadius, outerRadius)=>{
    if (maxRadius == null || innerRadius == null || outerRadius == null) return undefined;
    return [
        innerRadius,
        outerRadius
    ];
});
var $792f72abcce61010$export$2b324c38f06972bb = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $792f72abcce61010$export$74b0499accddabe1,
    $792f72abcce61010$export$e13d847e4d4f833f
], (0, $250f5d8c249e6c87$export$3f7e30291950e694));
var $792f72abcce61010$export$57f4101c1e20bd95 = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    (0, $f4c9341f05a18477$export$8426b6d9af801dee),
    $792f72abcce61010$export$a743f010244424e8,
    $792f72abcce61010$var$selectInnerRadius,
    $792f72abcce61010$export$32a1ec2f6eaad494,
    (0, $0b675d94b376aa83$export$771ef0ac044f724d),
    (0, $0b675d94b376aa83$export$5856a7d94c109505)
], (layout, polarOptions, innerRadius, outerRadius, width, height)=>{
    if (layout !== 'centric' && layout !== 'radial' || polarOptions == null || innerRadius == null || outerRadius == null) return undefined;
    var { cx: cx, cy: cy, startAngle: startAngle, endAngle: endAngle } = polarOptions;
    return {
        cx: (0, $7e613228d3a31273$export$476354dbf49bdff6)(cx, width, width / 2),
        cy: (0, $7e613228d3a31273$export$476354dbf49bdff6)(cy, height, height / 2),
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        startAngle: startAngle,
        endAngle: endAngle,
        clockWise: false // this property look useful, why not use it?
    };
});





var $kc00y = parcelRequire("kc00y");



/**
 * Checks if two arrays are equal, treating empty arrays as equal regardless of reference.
 * If both arrays are non-empty, it checks for reference equality.
 * @param a
 * @param b
 */ function $a931610653760bd0$export$dcc34c4213e7f4c(a, b) {
    if (Array.isArray(a) && Array.isArray(b) && a.length === 0 && b.length === 0) // empty arrays are always equal, regardless of reference
    return true;
    return a === b;
}
function $a931610653760bd0$export$4f42c64323a69d96(a, b) {
    if (a.length === b.length) {
        for(var i = 0; i < a.length; i++){
            if (a[i] !== b[i]) return false;
        }
        return true;
    }
    return false;
}



var $3af473174a59f367$export$30b3c9504f8bc181 = (0, $757e1d271f969f78$export$595d22ed68ca2841)((state)=>state.zIndex.zIndexMap, (_, zIndex)=>zIndex, (_, _zIndex, isPanorama)=>isPanorama, (zIndexMap, zIndex, isPanorama)=>{
    if (zIndex == null) return undefined;
    var entry = zIndexMap[zIndex];
    if (entry == null) return undefined;
    if (isPanorama) return entry.panoramaElement;
    return entry.element;
});
var $3af473174a59f367$export$7967bffce127e19c = (0, $757e1d271f969f78$export$595d22ed68ca2841)((state)=>state.zIndex.zIndexMap, (zIndexMap)=>{
    var allNumbers = Object.keys(zIndexMap).map((zIndexStr)=>parseInt(zIndexStr, 10)).concat(Object.values((0, $2d4105c5b5d94e8f$export$96df16b28aa32702)));
    var uniqueNumbers = Array.from(new Set(allNumbers));
    return uniqueNumbers.sort((a, b)=>a - b);
}, {
    memoizeOptions: {
        resultEqualityCheck: (0, $a931610653760bd0$export$4f42c64323a69d96)
    }
});



// src/utils/env.ts
var $808ce0820c1669b6$export$45b790e32b2810ee = Symbol.for("immer-nothing");
var $808ce0820c1669b6$export$6ee2082928bcb0ee = Symbol.for("immer-draftable");
var $808ce0820c1669b6$var$DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var $808ce0820c1669b6$var$errors = [];
function $808ce0820c1669b6$var$die(error, ...args) {
    throw new Error(`[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`);
}
// src/utils/common.ts
var $808ce0820c1669b6$var$getPrototypeOf = Object.getPrototypeOf;
function $808ce0820c1669b6$export$541ac630993a4c84(value) {
    return !!value && !!value[$808ce0820c1669b6$var$DRAFT_STATE];
}
function $808ce0820c1669b6$export$16e3aed3edb85946(value) {
    if (!value) return false;
    return $808ce0820c1669b6$var$isPlainObject(value) || Array.isArray(value) || !!value[$808ce0820c1669b6$export$6ee2082928bcb0ee] || !!value.constructor?.[$808ce0820c1669b6$export$6ee2082928bcb0ee] || $808ce0820c1669b6$var$isMap(value) || $808ce0820c1669b6$var$isSet(value);
}
var $808ce0820c1669b6$var$objectCtorString = Object.prototype.constructor.toString();
var $808ce0820c1669b6$var$cachedCtorStrings = /* @__PURE__ */ new WeakMap();
function $808ce0820c1669b6$var$isPlainObject(value) {
    if (!value || typeof value !== "object") return false;
    const proto = Object.getPrototypeOf(value);
    if (proto === null || proto === Object.prototype) return true;
    const Ctor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    if (Ctor === Object) return true;
    if (typeof Ctor !== "function") return false;
    let ctorString = $808ce0820c1669b6$var$cachedCtorStrings.get(Ctor);
    if (ctorString === void 0) {
        ctorString = Function.toString.call(Ctor);
        $808ce0820c1669b6$var$cachedCtorStrings.set(Ctor, ctorString);
    }
    return ctorString === $808ce0820c1669b6$var$objectCtorString;
}
function $808ce0820c1669b6$export$22e8af3f75a010e3(value) {
    if (!$808ce0820c1669b6$export$541ac630993a4c84(value)) $808ce0820c1669b6$var$die(15, value);
    return value[$808ce0820c1669b6$var$DRAFT_STATE].base_;
}
function $808ce0820c1669b6$var$each(obj, iter, strict = true) {
    if ($808ce0820c1669b6$var$getArchtype(obj) === 0 /* Object */ ) {
        const keys = strict ? Reflect.ownKeys(obj) : Object.keys(obj);
        keys.forEach((key)=>{
            iter(key, obj[key], obj);
        });
    } else obj.forEach((entry, index)=>iter(index, entry, obj));
}
function $808ce0820c1669b6$var$getArchtype(thing) {
    const state = thing[$808ce0820c1669b6$var$DRAFT_STATE];
    return state ? state.type_ : Array.isArray(thing) ? 1 /* Array */  : $808ce0820c1669b6$var$isMap(thing) ? 2 /* Map */  : $808ce0820c1669b6$var$isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
function $808ce0820c1669b6$var$has(thing, prop) {
    return $808ce0820c1669b6$var$getArchtype(thing) === 2 /* Map */  ? thing.has(prop) : Object.prototype.hasOwnProperty.call(thing, prop);
}
function $808ce0820c1669b6$var$get(thing, prop) {
    return $808ce0820c1669b6$var$getArchtype(thing) === 2 /* Map */  ? thing.get(prop) : thing[prop];
}
function $808ce0820c1669b6$var$set(thing, propOrOldValue, value) {
    const t = $808ce0820c1669b6$var$getArchtype(thing);
    if (t === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (t === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
}
function $808ce0820c1669b6$var$is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $808ce0820c1669b6$var$isMap(target) {
    return target instanceof Map;
}
function $808ce0820c1669b6$var$isSet(target) {
    return target instanceof Set;
}
function $808ce0820c1669b6$var$latest(state) {
    return state.copy_ || state.base_;
}
function $808ce0820c1669b6$var$shallowCopy(base, strict) {
    if ($808ce0820c1669b6$var$isMap(base)) return new Map(base);
    if ($808ce0820c1669b6$var$isSet(base)) return new Set(base);
    if (Array.isArray(base)) return Array.prototype.slice.call(base);
    const isPlain = $808ce0820c1669b6$var$isPlainObject(base);
    if (strict === true || strict === "class_only" && !isPlain) {
        const descriptors = Object.getOwnPropertyDescriptors(base);
        delete descriptors[$808ce0820c1669b6$var$DRAFT_STATE];
        let keys = Reflect.ownKeys(descriptors);
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            const desc = descriptors[key];
            if (desc.writable === false) {
                desc.writable = true;
                desc.configurable = true;
            }
            if (desc.get || desc.set) descriptors[key] = {
                configurable: true,
                writable: true,
                // could live with !!desc.set as well here...
                enumerable: desc.enumerable,
                value: base[key]
            };
        }
        return Object.create($808ce0820c1669b6$var$getPrototypeOf(base), descriptors);
    } else {
        const proto = $808ce0820c1669b6$var$getPrototypeOf(base);
        if (proto !== null && isPlain) return {
            ...base
        };
        const obj = Object.create(proto);
        return Object.assign(obj, base);
    }
}
function $808ce0820c1669b6$export$792f3d81ea979f55(obj, deep = false) {
    if ($808ce0820c1669b6$var$isFrozen(obj) || $808ce0820c1669b6$export$541ac630993a4c84(obj) || !$808ce0820c1669b6$export$16e3aed3edb85946(obj)) return obj;
    if ($808ce0820c1669b6$var$getArchtype(obj) > 1) Object.defineProperties(obj, {
        set: $808ce0820c1669b6$var$dontMutateMethodOverride,
        add: $808ce0820c1669b6$var$dontMutateMethodOverride,
        clear: $808ce0820c1669b6$var$dontMutateMethodOverride,
        delete: $808ce0820c1669b6$var$dontMutateMethodOverride
    });
    Object.freeze(obj);
    if (deep) Object.values(obj).forEach((value)=>$808ce0820c1669b6$export$792f3d81ea979f55(value, true));
    return obj;
}
function $808ce0820c1669b6$var$dontMutateFrozenCollections() {
    $808ce0820c1669b6$var$die(2);
}
var $808ce0820c1669b6$var$dontMutateMethodOverride = {
    value: $808ce0820c1669b6$var$dontMutateFrozenCollections
};
function $808ce0820c1669b6$var$isFrozen(obj) {
    if (obj === null || typeof obj !== "object") return true;
    return Object.isFrozen(obj);
}
// src/utils/plugins.ts
var $808ce0820c1669b6$var$plugins = {};
function $808ce0820c1669b6$var$getPlugin(pluginKey) {
    const plugin = $808ce0820c1669b6$var$plugins[pluginKey];
    if (!plugin) $808ce0820c1669b6$var$die(0, pluginKey);
    return plugin;
}
function $808ce0820c1669b6$var$loadPlugin(pluginKey, implementation) {
    if (!$808ce0820c1669b6$var$plugins[pluginKey]) $808ce0820c1669b6$var$plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var $808ce0820c1669b6$var$currentScope;
function $808ce0820c1669b6$var$getCurrentScope() {
    return $808ce0820c1669b6$var$currentScope;
}
function $808ce0820c1669b6$var$createScope(parent_, immer_) {
    return {
        drafts_: [],
        parent_: parent_,
        immer_: immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0
    };
}
function $808ce0820c1669b6$var$usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        $808ce0820c1669b6$var$getPlugin("Patches");
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function $808ce0820c1669b6$var$revokeScope(scope) {
    $808ce0820c1669b6$var$leaveScope(scope);
    scope.drafts_.forEach($808ce0820c1669b6$var$revokeDraft);
    scope.drafts_ = null;
}
function $808ce0820c1669b6$var$leaveScope(scope) {
    if (scope === $808ce0820c1669b6$var$currentScope) $808ce0820c1669b6$var$currentScope = scope.parent_;
}
function $808ce0820c1669b6$var$enterScope(immer2) {
    return $808ce0820c1669b6$var$currentScope = $808ce0820c1669b6$var$createScope($808ce0820c1669b6$var$currentScope, immer2);
}
function $808ce0820c1669b6$var$revokeDraft(draft) {
    const state = draft[$808ce0820c1669b6$var$DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function $808ce0820c1669b6$var$processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    const baseDraft = scope.drafts_[0];
    const isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[$808ce0820c1669b6$var$DRAFT_STATE].modified_) {
            $808ce0820c1669b6$var$revokeScope(scope);
            $808ce0820c1669b6$var$die(4);
        }
        if ($808ce0820c1669b6$export$16e3aed3edb85946(result)) {
            result = $808ce0820c1669b6$var$finalize(scope, result);
            if (!scope.parent_) $808ce0820c1669b6$var$maybeFreeze(scope, result);
        }
        if (scope.patches_) $808ce0820c1669b6$var$getPlugin("Patches").generateReplacementPatches_(baseDraft[$808ce0820c1669b6$var$DRAFT_STATE].base_, result, scope.patches_, scope.inversePatches_);
    } else result = $808ce0820c1669b6$var$finalize(scope, baseDraft, []);
    $808ce0820c1669b6$var$revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== $808ce0820c1669b6$export$45b790e32b2810ee ? result : void 0;
}
function $808ce0820c1669b6$var$finalize(rootScope, value, path) {
    if ($808ce0820c1669b6$var$isFrozen(value)) return value;
    const useStrictIteration = rootScope.immer_.shouldUseStrictIteration();
    const state = value[$808ce0820c1669b6$var$DRAFT_STATE];
    if (!state) {
        $808ce0820c1669b6$var$each(value, (key, childValue)=>$808ce0820c1669b6$var$finalizeProperty(rootScope, state, value, key, childValue, path), useStrictIteration);
        return value;
    }
    if (state.scope_ !== rootScope) return value;
    if (!state.modified_) {
        $808ce0820c1669b6$var$maybeFreeze(rootScope, state.base_, true);
        return state.base_;
    }
    if (!state.finalized_) {
        state.finalized_ = true;
        state.scope_.unfinalizedDrafts_--;
        const result = state.copy_;
        let resultEach = result;
        let isSet2 = false;
        if (state.type_ === 3 /* Set */ ) {
            resultEach = new Set(result);
            result.clear();
            isSet2 = true;
        }
        $808ce0820c1669b6$var$each(resultEach, (key, childValue)=>$808ce0820c1669b6$var$finalizeProperty(rootScope, state, result, key, childValue, path, isSet2), useStrictIteration);
        $808ce0820c1669b6$var$maybeFreeze(rootScope, result, false);
        if (path && rootScope.patches_) $808ce0820c1669b6$var$getPlugin("Patches").generatePatches_(state, path, rootScope.patches_, rootScope.inversePatches_);
    }
    return state.copy_;
}
function $808ce0820c1669b6$var$finalizeProperty(rootScope, parentState, targetObject, prop, childValue, rootPath, targetIsSet) {
    if (childValue == null) return;
    if (typeof childValue !== "object" && !targetIsSet) return;
    const childIsFrozen = $808ce0820c1669b6$var$isFrozen(childValue);
    if (childIsFrozen && !targetIsSet) return;
    if ($808ce0820c1669b6$export$541ac630993a4c84(childValue)) {
        const path = rootPath && parentState && parentState.type_ !== 3 /* Set */  && // Set objects are atomic since they have no keys.
        !$808ce0820c1669b6$var$has(parentState.assigned_, prop) ? rootPath.concat(prop) : void 0;
        const res = $808ce0820c1669b6$var$finalize(rootScope, childValue, path);
        $808ce0820c1669b6$var$set(targetObject, prop, res);
        if ($808ce0820c1669b6$export$541ac630993a4c84(res)) rootScope.canAutoFreeze_ = false;
        else return;
    } else if (targetIsSet) targetObject.add(childValue);
    if ($808ce0820c1669b6$export$16e3aed3edb85946(childValue) && !childIsFrozen) {
        if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return;
        if (parentState && parentState.base_ && parentState.base_[prop] === childValue && childIsFrozen) return;
        $808ce0820c1669b6$var$finalize(rootScope, childValue);
        if ((!parentState || !parentState.scope_.parent_) && typeof prop !== "symbol" && ($808ce0820c1669b6$var$isMap(targetObject) ? targetObject.has(prop) : Object.prototype.propertyIsEnumerable.call(targetObject, prop))) $808ce0820c1669b6$var$maybeFreeze(rootScope, childValue);
    }
}
function $808ce0820c1669b6$var$maybeFreeze(scope, value, deep = false) {
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) $808ce0820c1669b6$export$792f3d81ea979f55(value, deep);
}
// src/core/proxy.ts
function $808ce0820c1669b6$var$createProxyProxy(base, parent) {
    const isArray = Array.isArray(base);
    const state = {
        type_: isArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : $808ce0820c1669b6$var$getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        assigned_: {},
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false
    };
    let target = state;
    let traps = $808ce0820c1669b6$var$objectTraps;
    if (isArray) {
        target = [
            state
        ];
        traps = $808ce0820c1669b6$var$arrayTraps;
    }
    const { revoke: revoke, proxy: proxy } = Proxy.revocable(target, traps);
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return proxy;
}
var $808ce0820c1669b6$var$objectTraps = {
    get (state, prop) {
        if (prop === $808ce0820c1669b6$var$DRAFT_STATE) return state;
        const source = $808ce0820c1669b6$var$latest(state);
        if (!$808ce0820c1669b6$var$has(source, prop)) return $808ce0820c1669b6$var$readPropFromProto(state, source, prop);
        const value = source[prop];
        if (state.finalized_ || !$808ce0820c1669b6$export$16e3aed3edb85946(value)) return value;
        if (value === $808ce0820c1669b6$var$peek(state.base_, prop)) {
            $808ce0820c1669b6$var$prepareCopy(state);
            return state.copy_[prop] = $808ce0820c1669b6$var$createProxy(value, state);
        }
        return value;
    },
    has (state, prop) {
        return prop in $808ce0820c1669b6$var$latest(state);
    },
    ownKeys (state) {
        return Reflect.ownKeys($808ce0820c1669b6$var$latest(state));
    },
    set (state, prop, value) {
        const desc = $808ce0820c1669b6$var$getDescriptorFromProto($808ce0820c1669b6$var$latest(state), prop);
        if (desc?.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            const current2 = $808ce0820c1669b6$var$peek($808ce0820c1669b6$var$latest(state), prop);
            const currentState = current2?.[$808ce0820c1669b6$var$DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_[prop] = false;
                return true;
            }
            if ($808ce0820c1669b6$var$is(value, current2) && (value !== void 0 || $808ce0820c1669b6$var$has(state.base_, prop))) return true;
            $808ce0820c1669b6$var$prepareCopy(state);
            $808ce0820c1669b6$var$markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || prop in state.copy_) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_[prop] = true;
        return true;
    },
    deleteProperty (state, prop) {
        if ($808ce0820c1669b6$var$peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_[prop] = false;
            $808ce0820c1669b6$var$prepareCopy(state);
            $808ce0820c1669b6$var$markChanged(state);
        } else delete state.assigned_[prop];
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor (state, prop) {
        const owner = $808ce0820c1669b6$var$latest(state);
        const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            writable: true,
            configurable: state.type_ !== 1 /* Array */  || prop !== "length",
            enumerable: desc.enumerable,
            value: owner[prop]
        };
    },
    defineProperty () {
        $808ce0820c1669b6$var$die(11);
    },
    getPrototypeOf (state) {
        return $808ce0820c1669b6$var$getPrototypeOf(state.base_);
    },
    setPrototypeOf () {
        $808ce0820c1669b6$var$die(12);
    }
};
var $808ce0820c1669b6$var$arrayTraps = {};
$808ce0820c1669b6$var$each($808ce0820c1669b6$var$objectTraps, (key, fn)=>{
    $808ce0820c1669b6$var$arrayTraps[key] = function() {
        arguments[0] = arguments[0][0];
        return fn.apply(this, arguments);
    };
});
$808ce0820c1669b6$var$arrayTraps.deleteProperty = function(state, prop) {
    return $808ce0820c1669b6$var$arrayTraps.set.call(this, state, prop, void 0);
};
$808ce0820c1669b6$var$arrayTraps.set = function(state, prop, value) {
    return $808ce0820c1669b6$var$objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function $808ce0820c1669b6$var$peek(draft, prop) {
    const state = draft[$808ce0820c1669b6$var$DRAFT_STATE];
    const source = state ? $808ce0820c1669b6$var$latest(state) : draft;
    return source[prop];
}
function $808ce0820c1669b6$var$readPropFromProto(state, source, prop) {
    const desc = $808ce0820c1669b6$var$getDescriptorFromProto(source, prop);
    return desc ? `value` in desc ? desc.value : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    desc.get?.call(state.draft_) : void 0;
}
function $808ce0820c1669b6$var$getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    let proto = $808ce0820c1669b6$var$getPrototypeOf(source);
    while(proto){
        const desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = $808ce0820c1669b6$var$getPrototypeOf(proto);
    }
    return void 0;
}
function $808ce0820c1669b6$var$markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) $808ce0820c1669b6$var$markChanged(state.parent_);
    }
}
function $808ce0820c1669b6$var$prepareCopy(state) {
    if (!state.copy_) state.copy_ = $808ce0820c1669b6$var$shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
}
// src/core/immerClass.ts
var $808ce0820c1669b6$export$aaadc6ff0f822719 = class {
    constructor(config){
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        this.useStrictIteration_ = true;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = (base, recipe, patchListener)=>{
            if (typeof base === "function" && typeof recipe !== "function") {
                const defaultBase = recipe;
                recipe = base;
                const self = this;
                return function curriedProduce(base2 = defaultBase, ...args) {
                    return self.produce(base2, (draft)=>recipe.call(this, draft, ...args));
                };
            }
            if (typeof recipe !== "function") $808ce0820c1669b6$var$die(6);
            if (patchListener !== void 0 && typeof patchListener !== "function") $808ce0820c1669b6$var$die(7);
            let result;
            if ($808ce0820c1669b6$export$16e3aed3edb85946(base)) {
                const scope = $808ce0820c1669b6$var$enterScope(this);
                const proxy = $808ce0820c1669b6$var$createProxy(base, void 0);
                let hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) $808ce0820c1669b6$var$revokeScope(scope);
                    else $808ce0820c1669b6$var$leaveScope(scope);
                }
                $808ce0820c1669b6$var$usePatchesInScope(scope, patchListener);
                return $808ce0820c1669b6$var$processResult(result, scope);
            } else if (!base || typeof base !== "object") {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === $808ce0820c1669b6$export$45b790e32b2810ee) result = void 0;
                if (this.autoFreeze_) $808ce0820c1669b6$export$792f3d81ea979f55(result, true);
                if (patchListener) {
                    const p = [];
                    const ip = [];
                    $808ce0820c1669b6$var$getPlugin("Patches").generateReplacementPatches_(base, result, p, ip);
                    patchListener(p, ip);
                }
                return result;
            } else $808ce0820c1669b6$var$die(1, base);
        };
        this.produceWithPatches = (base, recipe)=>{
            if (typeof base === "function") return (state, ...args)=>this.produceWithPatches(state, (draft)=>base(draft, ...args));
            let patches, inversePatches;
            const result = this.produce(base, recipe, (p, ip)=>{
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if (typeof config?.autoFreeze === "boolean") this.setAutoFreeze(config.autoFreeze);
        if (typeof config?.useStrictShallowCopy === "boolean") this.setUseStrictShallowCopy(config.useStrictShallowCopy);
        if (typeof config?.useStrictIteration === "boolean") this.setUseStrictIteration(config.useStrictIteration);
    }
    createDraft(base) {
        if (!$808ce0820c1669b6$export$16e3aed3edb85946(base)) $808ce0820c1669b6$var$die(8);
        if ($808ce0820c1669b6$export$541ac630993a4c84(base)) base = $808ce0820c1669b6$export$97aac956da55dae9(base);
        const scope = $808ce0820c1669b6$var$enterScope(this);
        const proxy = $808ce0820c1669b6$var$createProxy(base, void 0);
        proxy[$808ce0820c1669b6$var$DRAFT_STATE].isManual_ = true;
        $808ce0820c1669b6$var$leaveScope(scope);
        return proxy;
    }
    finishDraft(draft, patchListener) {
        const state = draft && draft[$808ce0820c1669b6$var$DRAFT_STATE];
        if (!state || !state.isManual_) $808ce0820c1669b6$var$die(9);
        const { scope_: scope } = state;
        $808ce0820c1669b6$var$usePatchesInScope(scope, patchListener);
        return $808ce0820c1669b6$var$processResult(void 0, scope);
    }
    /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ setAutoFreeze(value) {
        this.autoFreeze_ = value;
    }
    /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ setUseStrictShallowCopy(value) {
        this.useStrictShallowCopy_ = value;
    }
    /**
   * Pass false to use faster iteration that skips non-enumerable properties
   * but still handles symbols for compatibility.
   *
   * By default, strict iteration is enabled (includes all own properties).
   */ setUseStrictIteration(value) {
        this.useStrictIteration_ = value;
    }
    shouldUseStrictIteration() {
        return this.useStrictIteration_;
    }
    applyPatches(base, patches) {
        let i;
        for(i = patches.length - 1; i >= 0; i--){
            const patch = patches[i];
            if (patch.path.length === 0 && patch.op === "replace") {
                base = patch.value;
                break;
            }
        }
        if (i > -1) patches = patches.slice(i + 1);
        const applyPatchesImpl = $808ce0820c1669b6$var$getPlugin("Patches").applyPatches_;
        if ($808ce0820c1669b6$export$541ac630993a4c84(base)) return applyPatchesImpl(base, patches);
        return this.produce(base, (draft)=>applyPatchesImpl(draft, patches));
    }
};
function $808ce0820c1669b6$var$createProxy(value, parent) {
    const draft = $808ce0820c1669b6$var$isMap(value) ? $808ce0820c1669b6$var$getPlugin("MapSet").proxyMap_(value, parent) : $808ce0820c1669b6$var$isSet(value) ? $808ce0820c1669b6$var$getPlugin("MapSet").proxySet_(value, parent) : $808ce0820c1669b6$var$createProxyProxy(value, parent);
    const scope = parent ? parent.scope_ : $808ce0820c1669b6$var$getCurrentScope();
    scope.drafts_.push(draft);
    return draft;
}
// src/core/current.ts
function $808ce0820c1669b6$export$97aac956da55dae9(value) {
    if (!$808ce0820c1669b6$export$541ac630993a4c84(value)) $808ce0820c1669b6$var$die(10, value);
    return $808ce0820c1669b6$var$currentImpl(value);
}
function $808ce0820c1669b6$var$currentImpl(value) {
    if (!$808ce0820c1669b6$export$16e3aed3edb85946(value) || $808ce0820c1669b6$var$isFrozen(value)) return value;
    const state = value[$808ce0820c1669b6$var$DRAFT_STATE];
    let copy;
    let strict = true;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = $808ce0820c1669b6$var$shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
        strict = state.scope_.immer_.shouldUseStrictIteration();
    } else copy = $808ce0820c1669b6$var$shallowCopy(value, true);
    $808ce0820c1669b6$var$each(copy, (key, childValue)=>{
        $808ce0820c1669b6$var$set(copy, key, $808ce0820c1669b6$var$currentImpl(childValue));
    }, strict);
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function $808ce0820c1669b6$export$d3a6659991a0696c() {
    const errorOffset = 16;
    const REPLACE = "replace";
    const ADD = "add";
    const REMOVE = "remove";
    function generatePatches_(state, basePath, patches, inversePatches) {
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches, inversePatches);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches, inversePatches);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches, inversePatches);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, assigned_: assigned_ } = state;
        let copy_ = state.copy_;
        if (copy_.length < base_.length) {
            [base_, copy_] = [
                copy_,
                base_
            ];
            [patches, inversePatches] = [
                inversePatches,
                patches
            ];
        }
        for(let i = 0; i < base_.length; i++)if (assigned_[i] && copy_[i] !== base_[i]) {
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: REPLACE,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
            inversePatches.push({
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(base_[i])
            });
        }
        for(let i = base_.length; i < copy_.length; i++){
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: ADD,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
        }
        for(let i = copy_.length - 1; base_.length <= i; --i){
            const path = basePath.concat([
                i
            ]);
            inversePatches.push({
                op: REMOVE,
                path: path
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        const { base_: base_, copy_: copy_ } = state;
        $808ce0820c1669b6$var$each(state.assigned_, (key, assignedValue)=>{
            const origValue = $808ce0820c1669b6$var$get(base_, key);
            const value = $808ce0820c1669b6$var$get(copy_, key);
            const op = !assignedValue ? REMOVE : $808ce0820c1669b6$var$has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            const path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op: op,
                path: path
            } : {
                op: op,
                path: path,
                value: value
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path: path
            } : op === REMOVE ? {
                op: ADD,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, copy_: copy_ } = state;
        let i = 0;
        base_.forEach((value)=>{
            if (!copy_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: ADD,
                    path: path,
                    value: value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach((value)=>{
            if (!base_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path: path,
                    value: value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, patches, inversePatches) {
        patches.push({
            op: REPLACE,
            path: [],
            value: replacement === $808ce0820c1669b6$export$45b790e32b2810ee ? void 0 : replacement
        });
        inversePatches.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach((patch)=>{
            const { path: path, op: op } = patch;
            let base = draft;
            for(let i = 0; i < path.length - 1; i++){
                const parentType = $808ce0820c1669b6$var$getArchtype(base);
                let p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === "constructor")) $808ce0820c1669b6$var$die(errorOffset + 3);
                if (typeof base === "function" && p === "prototype") $808ce0820c1669b6$var$die(errorOffset + 3);
                base = $808ce0820c1669b6$var$get(base, p);
                if (typeof base !== "object") $808ce0820c1669b6$var$die(errorOffset + 2, path.join("/"));
            }
            const type = $808ce0820c1669b6$var$getArchtype(base);
            const value = deepClonePatchValue(patch.value);
            const key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            $808ce0820c1669b6$var$die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    $808ce0820c1669b6$var$die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!$808ce0820c1669b6$export$16e3aed3edb85946(obj)) return obj;
        if (Array.isArray(obj)) return obj.map(deepClonePatchValue);
        if ($808ce0820c1669b6$var$isMap(obj)) return new Map(Array.from(obj.entries()).map(([k, v])=>[
                k,
                deepClonePatchValue(v)
            ]));
        if ($808ce0820c1669b6$var$isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        const cloned = Object.create($808ce0820c1669b6$var$getPrototypeOf(obj));
        for(const key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if ($808ce0820c1669b6$var$has(obj, $808ce0820c1669b6$export$6ee2082928bcb0ee)) cloned[$808ce0820c1669b6$export$6ee2082928bcb0ee] = obj[$808ce0820c1669b6$export$6ee2082928bcb0ee];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if ($808ce0820c1669b6$export$541ac630993a4c84(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    $808ce0820c1669b6$var$loadPlugin("Patches", {
        applyPatches_: applyPatches_,
        generatePatches_: generatePatches_,
        generateReplacementPatches_: generateReplacementPatches_
    });
}
// src/plugins/mapset.ts
function $808ce0820c1669b6$export$7d9f65390203b435() {
    class DraftMap extends Map {
        constructor(target, parent){
            super();
            this[$808ce0820c1669b6$var$DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $808ce0820c1669b6$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: this,
                isManual_: false,
                revoked_: false
            };
        }
        get size() {
            return $808ce0820c1669b6$var$latest(this[$808ce0820c1669b6$var$DRAFT_STATE]).size;
        }
        has(key) {
            return $808ce0820c1669b6$var$latest(this[$808ce0820c1669b6$var$DRAFT_STATE]).has(key);
        }
        set(key, value) {
            const state = this[$808ce0820c1669b6$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!$808ce0820c1669b6$var$latest(state).has(key) || $808ce0820c1669b6$var$latest(state).get(key) !== value) {
                prepareMapCopy(state);
                $808ce0820c1669b6$var$markChanged(state);
                state.assigned_.set(key, true);
                state.copy_.set(key, value);
                state.assigned_.set(key, true);
            }
            return this;
        }
        delete(key) {
            if (!this.has(key)) return false;
            const state = this[$808ce0820c1669b6$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareMapCopy(state);
            $808ce0820c1669b6$var$markChanged(state);
            if (state.base_.has(key)) state.assigned_.set(key, false);
            else state.assigned_.delete(key);
            state.copy_.delete(key);
            return true;
        }
        clear() {
            const state = this[$808ce0820c1669b6$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($808ce0820c1669b6$var$latest(state).size) {
                prepareMapCopy(state);
                $808ce0820c1669b6$var$markChanged(state);
                state.assigned_ = /* @__PURE__ */ new Map();
                $808ce0820c1669b6$var$each(state.base_, (key)=>{
                    state.assigned_.set(key, false);
                });
                state.copy_.clear();
            }
        }
        forEach(cb, thisArg) {
            const state = this[$808ce0820c1669b6$var$DRAFT_STATE];
            $808ce0820c1669b6$var$latest(state).forEach((_value, key, _map)=>{
                cb.call(thisArg, this.get(key), key, this);
            });
        }
        get(key) {
            const state = this[$808ce0820c1669b6$var$DRAFT_STATE];
            assertUnrevoked(state);
            const value = $808ce0820c1669b6$var$latest(state).get(key);
            if (state.finalized_ || !$808ce0820c1669b6$export$16e3aed3edb85946(value)) return value;
            if (value !== state.base_.get(key)) return value;
            const draft = $808ce0820c1669b6$var$createProxy(value, state);
            prepareMapCopy(state);
            state.copy_.set(key, draft);
            return draft;
        }
        keys() {
            return $808ce0820c1669b6$var$latest(this[$808ce0820c1669b6$var$DRAFT_STATE]).keys();
        }
        values() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.values(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: value
                    };
                }
            };
        }
        entries() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.entries(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: [
                            r.value,
                            value
                        ]
                    };
                }
            };
        }
        [($808ce0820c1669b6$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.entries();
        }
    }
    function proxyMap_(target, parent) {
        return new DraftMap(target, parent);
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    class DraftSet extends Set {
        constructor(target, parent){
            super();
            this[$808ce0820c1669b6$var$DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $808ce0820c1669b6$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false
            };
        }
        get size() {
            return $808ce0820c1669b6$var$latest(this[$808ce0820c1669b6$var$DRAFT_STATE]).size;
        }
        has(value) {
            const state = this[$808ce0820c1669b6$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!state.copy_) return state.base_.has(value);
            if (state.copy_.has(value)) return true;
            if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
            return false;
        }
        add(value) {
            const state = this[$808ce0820c1669b6$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!this.has(value)) {
                prepareSetCopy(state);
                $808ce0820c1669b6$var$markChanged(state);
                state.copy_.add(value);
            }
            return this;
        }
        delete(value) {
            if (!this.has(value)) return false;
            const state = this[$808ce0820c1669b6$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            $808ce0820c1669b6$var$markChanged(state);
            return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
        }
        clear() {
            const state = this[$808ce0820c1669b6$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($808ce0820c1669b6$var$latest(state).size) {
                prepareSetCopy(state);
                $808ce0820c1669b6$var$markChanged(state);
                state.copy_.clear();
            }
        }
        values() {
            const state = this[$808ce0820c1669b6$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.values();
        }
        entries() {
            const state = this[$808ce0820c1669b6$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.entries();
        }
        keys() {
            return this.values();
        }
        [($808ce0820c1669b6$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.values();
        }
        forEach(cb, thisArg) {
            const iterator = this.values();
            let result = iterator.next();
            while(!result.done){
                cb.call(thisArg, result.value, result.value, this);
                result = iterator.next();
            }
        }
    }
    function proxySet_(target, parent) {
        return new DraftSet(target, parent);
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach((value)=>{
                if ($808ce0820c1669b6$export$16e3aed3edb85946(value)) {
                    const draft = $808ce0820c1669b6$var$createProxy(value, state);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) $808ce0820c1669b6$var$die(3, JSON.stringify($808ce0820c1669b6$var$latest(state)));
    }
    $808ce0820c1669b6$var$loadPlugin("MapSet", {
        proxyMap_: proxyMap_,
        proxySet_: proxySet_
    });
}
// src/immer.ts
var $808ce0820c1669b6$var$immer = new $808ce0820c1669b6$export$aaadc6ff0f822719();
var $808ce0820c1669b6$export$b46cabe22e78bc00 = $808ce0820c1669b6$var$immer.produce;
var $808ce0820c1669b6$export$4da66d41c9492c78 = /* @__PURE__ */ $808ce0820c1669b6$var$immer.produceWithPatches.bind($808ce0820c1669b6$var$immer);
var $808ce0820c1669b6$export$573f26f60825c493 = /* @__PURE__ */ $808ce0820c1669b6$var$immer.setAutoFreeze.bind($808ce0820c1669b6$var$immer);
var $808ce0820c1669b6$export$333ce65961cbe047 = /* @__PURE__ */ $808ce0820c1669b6$var$immer.setUseStrictShallowCopy.bind($808ce0820c1669b6$var$immer);
var $808ce0820c1669b6$export$1045b3be3904c489 = /* @__PURE__ */ $808ce0820c1669b6$var$immer.setUseStrictIteration.bind($808ce0820c1669b6$var$immer);
var $808ce0820c1669b6$export$a8b8e03e6bbe5473 = /* @__PURE__ */ $808ce0820c1669b6$var$immer.applyPatches.bind($808ce0820c1669b6$var$immer);
var $808ce0820c1669b6$export$3c3214997190395f = /* @__PURE__ */ $808ce0820c1669b6$var$immer.createDraft.bind($808ce0820c1669b6$var$immer);
var $808ce0820c1669b6$export$c60f5e69c521b528 = /* @__PURE__ */ $808ce0820c1669b6$var$immer.finishDraft.bind($808ce0820c1669b6$var$immer);
function $808ce0820c1669b6$export$c05b21e3257751e5(value) {
    return value;
}
function $808ce0820c1669b6$export$20f911b3f8cf0b74(value) {
    return value;
}



function $987558efef597e2e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $987558efef597e2e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $987558efef597e2e$var$ownKeys(Object(t), !0).forEach(function(r) {
            $987558efef597e2e$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $987558efef597e2e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $987558efef597e2e$var$_defineProperty(e, r, t) {
    return (r = $987558efef597e2e$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $987558efef597e2e$var$_toPropertyKey(t) {
    var i = $987558efef597e2e$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $987558efef597e2e$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $987558efef597e2e$var$seed = {};
var $987558efef597e2e$var$initialState = {
    zIndexMap: Object.values((0, $2d4105c5b5d94e8f$export$96df16b28aa32702)).reduce((acc, current)=>$987558efef597e2e$var$_objectSpread($987558efef597e2e$var$_objectSpread({}, acc), {}, {
            [current]: {
                element: undefined,
                panoramaElement: undefined,
                consumers: 0
            }
        }), $987558efef597e2e$var$seed)
};
var $987558efef597e2e$var$defaultZIndexSet = new Set(Object.values((0, $2d4105c5b5d94e8f$export$96df16b28aa32702)));
function $987558efef597e2e$var$isDefaultZIndex(zIndex) {
    return $987558efef597e2e$var$defaultZIndexSet.has(zIndex);
}
var $987558efef597e2e$var$zIndexSlice = (0, $df8b6ce3f4df1ba5$export$4d8d9bd83c24ae8b)({
    name: 'zIndex',
    initialState: $987558efef597e2e$var$initialState,
    reducers: {
        registerZIndexPortal: {
            reducer: (state, action)=>{
                var { zIndex: zIndex } = action.payload;
                if (state.zIndexMap[zIndex]) state.zIndexMap[zIndex].consumers += 1;
                else state.zIndexMap[zIndex] = {
                    consumers: 1,
                    element: undefined,
                    panoramaElement: undefined
                };
            },
            prepare: (0, $df8b6ce3f4df1ba5$export$39fcd5145ec5e4e2)()
        },
        unregisterZIndexPortal: {
            reducer: (state, action)=>{
                var { zIndex: zIndex } = action.payload;
                if (state.zIndexMap[zIndex]) {
                    state.zIndexMap[zIndex].consumers -= 1;
                    /*
           * Garbage collect unused z-index entries, except for default z-indexes.
           * Default z-indexes are always rendered, regardless of whether there are consumers or not.
           * And because of that, even if we delete this entry, the ZIndexPortal provider will still be rendered
           * and React is not going to re-create it, and it won't re-register the element ID.
           * So let's not delete default z-index entries.
           */ if (state.zIndexMap[zIndex].consumers <= 0 && !$987558efef597e2e$var$isDefaultZIndex(zIndex)) delete state.zIndexMap[zIndex];
                }
            },
            prepare: (0, $df8b6ce3f4df1ba5$export$39fcd5145ec5e4e2)()
        },
        registerZIndexPortalElement: {
            reducer: (state, action)=>{
                var { zIndex: zIndex, element: element, isPanorama: isPanorama } = action.payload;
                if (state.zIndexMap[zIndex]) {
                    if (isPanorama) state.zIndexMap[zIndex].panoramaElement = (0, $808ce0820c1669b6$export$c05b21e3257751e5)(element);
                    else state.zIndexMap[zIndex].element = (0, $808ce0820c1669b6$export$c05b21e3257751e5)(element);
                } else state.zIndexMap[zIndex] = {
                    consumers: 0,
                    element: isPanorama ? undefined : (0, $808ce0820c1669b6$export$c05b21e3257751e5)(element),
                    panoramaElement: isPanorama ? (0, $808ce0820c1669b6$export$c05b21e3257751e5)(element) : undefined
                };
            },
            prepare: (0, $df8b6ce3f4df1ba5$export$39fcd5145ec5e4e2)()
        },
        unregisterZIndexPortalElement: {
            reducer: (state, action)=>{
                var { zIndex: zIndex } = action.payload;
                if (state.zIndexMap[zIndex]) {
                    if (action.payload.isPanorama) state.zIndexMap[zIndex].panoramaElement = undefined;
                    else state.zIndexMap[zIndex].element = undefined;
                }
            },
            prepare: (0, $df8b6ce3f4df1ba5$export$39fcd5145ec5e4e2)()
        }
    }
});
var { registerZIndexPortal: $987558efef597e2e$export$8fe155db96cddace, unregisterZIndexPortal: $987558efef597e2e$export$230718bd38635ccb, registerZIndexPortalElement: $987558efef597e2e$export$2e6026208075bd4f, unregisterZIndexPortalElement: $987558efef597e2e$export$b735943939e8125 } = $987558efef597e2e$var$zIndexSlice.actions;
var $987558efef597e2e$export$a34096cdea3a022a = $987558efef597e2e$var$zIndexSlice.reducer;




function $a6cde822fe24aa10$export$b37befaf92aba9f1(_ref) {
    var { zIndex: zIndex, children: children } = _ref;
    /*
   * If we are outside of chart, then we can't rely on the zIndex portal state,
   * so we just render normally.
   */ var isInChartContext = (0, $f4c9341f05a18477$export$a3faf3c7b8f19073)();
    /*
   * If zIndex is undefined then we render normally without portals.
   * Also, if zIndex is 0, we render normally without portals,
   * because 0 is the default layer that does not need a portal.
   */ var shouldRenderInPortal = isInChartContext && zIndex !== undefined && zIndex !== 0;
    var isPanorama = (0, $10d1d693b6b228cd$export$4b0c59f8845ba920)();
    /**
   * When zIndex changes, the new portal element is not immediately available because
   * it requires a full render cycle through AllZIndexPortals → ZIndexSvgPortal.
   * During this transition we keep rendering into the previous portal element
   * to avoid an unmount/remount cycle that would cause children to briefly disappear.
   *
   * `registeredZIndexesRef` tracks every zIndex we have registered so that
   * we can defer unregistration of old values until the new portal is ready.
   * `lastPortalElementRef` caches the most recent valid portal DOM node.
   */ var lastPortalElementRef = (0, $kc00y.useRef)(undefined);
    var registeredZIndexesRef = (0, $kc00y.useRef)(new Set());
    var dispatch = (0, $a441e801d1b41b52$export$f51d452c10d5b956)();
    var portalElement = (0, $a441e801d1b41b52$export$a7347740d65f620b)((state)=>(0, $3af473174a59f367$export$30b3c9504f8bc181)(state, zIndex, isPanorama));
    /*
   * Lifecycle effect — handles both registration and deferred cleanup.
   *
   * Registration: when zIndex changes we register the new value WITHOUT
   * immediately unregistering the old one. This keeps the old <g> element
   * alive in the DOM so `lastPortalElementRef` remains a valid render target.
   *
   * Deferred cleanup: once `portalElement` for the *new* zIndex becomes
   * available we unregister every stale zIndex that is no longer needed.
   */ (0, $kc00y.useLayoutEffect)(()=>{
        if (!shouldRenderInPortal) {
            // Portal rendering was disabled — clean up any stale registrations
            var registered = registeredZIndexesRef.current;
            registered.forEach((z)=>{
                dispatch((0, $987558efef597e2e$export$230718bd38635ccb)({
                    zIndex: z
                }));
            });
            registered.clear();
            lastPortalElementRef.current = undefined;
            return;
        }
        /*
     * Because zIndexes are dynamic (meaning, we're not working with a predefined set of layers,
     * but we allow users to define any zIndex at any time), we need to register
     * the requested zIndex in the global store. This way, the ZIndexPortals component
     * can render the corresponding portals and only the requested ones.
     */ // Register the current zIndex (idempotent — skips if already registered)
        if (!registeredZIndexesRef.current.has(zIndex)) {
            dispatch((0, $987558efef597e2e$export$8fe155db96cddace)({
                zIndex: zIndex
            }));
            registeredZIndexesRef.current.add(zIndex);
        }
        // When the new portal element is ready, retire old zIndex registrations
        if (portalElement) {
            lastPortalElementRef.current = portalElement;
            var _registered = registeredZIndexesRef.current;
            _registered.forEach((z)=>{
                if (z !== zIndex) {
                    dispatch((0, $987558efef597e2e$export$230718bd38635ccb)({
                        zIndex: z
                    }));
                    _registered.delete(z);
                }
            });
        }
    }, [
        dispatch,
        zIndex,
        shouldRenderInPortal,
        portalElement
    ]);
    // Unmount-only cleanup — unregister everything when the component is removed
    (0, $kc00y.useLayoutEffect)(()=>{
        var registered = registeredZIndexesRef.current;
        return ()=>{
            registered.forEach((z)=>{
                dispatch((0, $987558efef597e2e$export$230718bd38635ccb)({
                    zIndex: z
                }));
            });
            registered.clear();
        };
    }, [
        dispatch
    ]);
    if (!shouldRenderInPortal) return children;
    // Prefer the current portal; fall back to the cached one during transitions
    var targetElement = portalElement !== null && portalElement !== void 0 ? portalElement : lastPortalElementRef.current;
    if (!targetElement) // Very first render — no portal has ever been registered yet
    return null;
    return /*#__PURE__*/ (0, $9018fd8b87cabbb7$exports.createPortal)(children, targetElement);
}





function $6aca0478e19471f7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6aca0478e19471f7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6aca0478e19471f7$var$ownKeys(Object(t), !0).forEach(function(r) {
            $6aca0478e19471f7$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6aca0478e19471f7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $6aca0478e19471f7$var$_defineProperty(e, r, t) {
    return (r = $6aca0478e19471f7$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $6aca0478e19471f7$var$_toPropertyKey(t) {
    var i = $6aca0478e19471f7$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $6aca0478e19471f7$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $6aca0478e19471f7$export$524d3fb4d123c796 = (options)=>{
    var { viewBox: viewBox, position: position, offset: offset = 0, parentViewBox: parentViewBoxFromOptions, clamp: clamp } = options;
    var { x: x, y: y, height: height, upperWidth: upperWidth, lowerWidth: lowerWidth } = (0, $f4c9341f05a18477$export$94a03fc5d61f2504)(viewBox);
    // Funnel.tsx provides a viewBox where `x` is the top-left of the trapezoid shape.
    var upperX = x;
    // The trapezoid is centered, so we can calculate the other corners from the top-left.
    var lowerX = x + (upperWidth - lowerWidth) / 2;
    // middleX is the x-coordinate of the left edge at the vertical midpoint of the trapezoid.
    var middleX = (upperX + lowerX) / 2;
    // The width of the trapezoid at its vertical midpoint.
    var midHeightWidth = (upperWidth + lowerWidth) / 2;
    // The center x-coordinate is constant for the entire height of the trapezoid.
    var centerX = upperX + upperWidth / 2;
    // Define vertical offsets and position inverts based on the value being positive or negative.
    // This allows labels to be positioned correctly for bars with negative height.
    var verticalSign = height >= 0 ? 1 : -1;
    var verticalOffset = verticalSign * offset;
    var verticalEnd = verticalSign > 0 ? 'end' : 'start';
    var verticalStart = verticalSign > 0 ? 'start' : 'end';
    // Define horizontal offsets and position inverts based on the value being positive or negative.
    // This allows labels to be positioned correctly for bars with negative width.
    var horizontalSign = upperWidth >= 0 ? 1 : -1;
    var horizontalOffset = horizontalSign * offset;
    var horizontalEnd = horizontalSign > 0 ? 'end' : 'start';
    var horizontalStart = horizontalSign > 0 ? 'start' : 'end';
    // We assume parentViewBox is generic if provided.
    // The user has asserted that parentViewBox will be CartesianViewBoxRequired if present.
    var parentViewBox = parentViewBoxFromOptions;
    if (position === 'top') {
        var result = {
            x: upperX + upperWidth / 2,
            y: y - verticalOffset,
            horizontalAnchor: 'middle',
            verticalAnchor: verticalEnd
        };
        if (clamp && parentViewBox) {
            result.height = Math.max(y - parentViewBox.y, 0);
            result.width = upperWidth;
        }
        return result;
    }
    if (position === 'bottom') {
        var _result = {
            x: lowerX + lowerWidth / 2,
            y: y + height + verticalOffset,
            horizontalAnchor: 'middle',
            verticalAnchor: verticalStart
        };
        if (clamp && parentViewBox) {
            _result.height = Math.max(parentViewBox.y + parentViewBox.height - (y + height), 0);
            _result.width = lowerWidth;
        }
        return _result;
    }
    if (position === 'left') {
        var _result2 = {
            x: middleX - horizontalOffset,
            y: y + height / 2,
            horizontalAnchor: horizontalEnd,
            verticalAnchor: 'middle'
        };
        if (clamp && parentViewBox) {
            _result2.width = Math.max(_result2.x - parentViewBox.x, 0);
            _result2.height = height;
        }
        return _result2;
    }
    if (position === 'right') {
        var _result3 = {
            x: middleX + midHeightWidth + horizontalOffset,
            y: y + height / 2,
            horizontalAnchor: horizontalStart,
            verticalAnchor: 'middle'
        };
        if (clamp && parentViewBox) {
            _result3.width = Math.max(parentViewBox.x + parentViewBox.width - _result3.x, 0);
            _result3.height = height;
        }
        return _result3;
    }
    var sizeAttrs = clamp && parentViewBox ? {
        width: midHeightWidth,
        height: height
    } : {};
    if (position === 'insideLeft') return $6aca0478e19471f7$var$_objectSpread({
        x: middleX + horizontalOffset,
        y: y + height / 2,
        horizontalAnchor: horizontalStart,
        verticalAnchor: 'middle'
    }, sizeAttrs);
    if (position === 'insideRight') return $6aca0478e19471f7$var$_objectSpread({
        x: middleX + midHeightWidth - horizontalOffset,
        y: y + height / 2,
        horizontalAnchor: horizontalEnd,
        verticalAnchor: 'middle'
    }, sizeAttrs);
    if (position === 'insideTop') return $6aca0478e19471f7$var$_objectSpread({
        x: upperX + upperWidth / 2,
        y: y + verticalOffset,
        horizontalAnchor: 'middle',
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === 'insideBottom') return $6aca0478e19471f7$var$_objectSpread({
        x: lowerX + lowerWidth / 2,
        y: y + height - verticalOffset,
        horizontalAnchor: 'middle',
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if (position === 'insideTopLeft') return $6aca0478e19471f7$var$_objectSpread({
        x: upperX + horizontalOffset,
        y: y + verticalOffset,
        horizontalAnchor: horizontalStart,
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === 'insideTopRight') return $6aca0478e19471f7$var$_objectSpread({
        x: upperX + upperWidth - horizontalOffset,
        y: y + verticalOffset,
        horizontalAnchor: horizontalEnd,
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === 'insideBottomLeft') return $6aca0478e19471f7$var$_objectSpread({
        x: lowerX + horizontalOffset,
        y: y + height - verticalOffset,
        horizontalAnchor: horizontalStart,
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if (position === 'insideBottomRight') return $6aca0478e19471f7$var$_objectSpread({
        x: lowerX + lowerWidth - horizontalOffset,
        y: y + height - verticalOffset,
        horizontalAnchor: horizontalEnd,
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if (!!position && typeof position === 'object' && ((0, $7e613228d3a31273$export$7e4aa119212bc614)(position.x) || (0, $7e613228d3a31273$export$e50269385c77c348)(position.x)) && ((0, $7e613228d3a31273$export$7e4aa119212bc614)(position.y) || (0, $7e613228d3a31273$export$e50269385c77c348)(position.y))) // TODO: This is not quite right. The width of the trapezoid changes with y.
    // A percentage-based x should be relative to the width at that y.
    // For now, we use the mid-height width as a reasonable approximation.
    return $6aca0478e19471f7$var$_objectSpread({
        x: x + (0, $7e613228d3a31273$export$476354dbf49bdff6)(position.x, midHeightWidth),
        y: y + (0, $7e613228d3a31273$export$476354dbf49bdff6)(position.y, height),
        horizontalAnchor: 'end',
        verticalAnchor: 'end'
    }, sizeAttrs);
    return $6aca0478e19471f7$var$_objectSpread({
        x: centerX,
        y: y + height / 2,
        horizontalAnchor: 'middle',
        verticalAnchor: 'middle'
    }, sizeAttrs);
};


var $ef6535e0015ddc73$var$_excluded = [
    "labelRef"
], $ef6535e0015ddc73$var$_excluded2 = [
    "content"
];
function $ef6535e0015ddc73$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $ef6535e0015ddc73$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $ef6535e0015ddc73$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $ef6535e0015ddc73$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ef6535e0015ddc73$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ef6535e0015ddc73$var$ownKeys(Object(t), !0).forEach(function(r) {
            $ef6535e0015ddc73$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ef6535e0015ddc73$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ef6535e0015ddc73$var$_defineProperty(e, r, t) {
    return (r = $ef6535e0015ddc73$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $ef6535e0015ddc73$var$_toPropertyKey(t) {
    var i = $ef6535e0015ddc73$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $ef6535e0015ddc73$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $ef6535e0015ddc73$var$_extends() {
    return $ef6535e0015ddc73$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ef6535e0015ddc73$var$_extends.apply(null, arguments);
}
/**
 * @inline
 */ /**
 * @inline
 */ /**
 * @inline
 */ var $ef6535e0015ddc73$var$CartesianLabelContext = /*#__PURE__*/ (0, $kc00y.createContext)(null);
var $ef6535e0015ddc73$export$3b4df77eaec10b03 = (_ref)=>{
    var { x: x, y: y, upperWidth: upperWidth, lowerWidth: lowerWidth, width: width, height: height, children: children } = _ref;
    var viewBox = (0, $kc00y.useMemo)(()=>({
            x: x,
            y: y,
            upperWidth: upperWidth,
            lowerWidth: lowerWidth,
            width: width,
            height: height
        }), [
        x,
        y,
        upperWidth,
        lowerWidth,
        width,
        height
    ]);
    return /*#__PURE__*/ $kc00y.createElement($ef6535e0015ddc73$var$CartesianLabelContext.Provider, {
        value: viewBox
    }, children);
};
var $ef6535e0015ddc73$var$useCartesianLabelContext = ()=>{
    var labelChildContext = (0, $kc00y.useContext)($ef6535e0015ddc73$var$CartesianLabelContext);
    var chartContext = (0, $f4c9341f05a18477$export$76b29bb074e0c45a)();
    return labelChildContext || (chartContext ? (0, $f4c9341f05a18477$export$94a03fc5d61f2504)(chartContext) : undefined);
};
var $ef6535e0015ddc73$var$PolarLabelContext = /*#__PURE__*/ (0, $kc00y.createContext)(null);
var $ef6535e0015ddc73$export$cd0d7ffccbd95e6d = (_ref2)=>{
    var { cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius, startAngle: startAngle, endAngle: endAngle, clockWise: clockWise, children: children } = _ref2;
    var viewBox = (0, $kc00y.useMemo)(()=>({
            cx: cx,
            cy: cy,
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            startAngle: startAngle,
            endAngle: endAngle,
            clockWise: clockWise
        }), [
        cx,
        cy,
        innerRadius,
        outerRadius,
        startAngle,
        endAngle,
        clockWise
    ]);
    return /*#__PURE__*/ $kc00y.createElement($ef6535e0015ddc73$var$PolarLabelContext.Provider, {
        value: viewBox
    }, children);
};
var $ef6535e0015ddc73$export$6f334acae8be4776 = ()=>{
    var labelChildContext = (0, $kc00y.useContext)($ef6535e0015ddc73$var$PolarLabelContext);
    var chartContext = (0, $a441e801d1b41b52$export$a7347740d65f620b)((0, $792f72abcce61010$export$57f4101c1e20bd95));
    return labelChildContext || chartContext;
};
var $ef6535e0015ddc73$var$getLabel = (props)=>{
    var { value: value, formatter: formatter } = props;
    var label = (0, $7e613228d3a31273$export$b931b78cbb3caf86)(props.children) ? value : props.children;
    if (typeof formatter === 'function') return formatter(label);
    return label;
};
var $ef6535e0015ddc73$export$96a48941c06f377f = (content)=>{
    return content != null && typeof content === 'function';
};
var $ef6535e0015ddc73$var$getDeltaAngle = (startAngle, endAngle)=>{
    var sign = (0, $7e613228d3a31273$export$9d334328eb75e624)(endAngle - startAngle);
    var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
    return sign * deltaAngle;
};
var $ef6535e0015ddc73$var$renderRadialLabel = (labelProps, position, label, attrs, viewBox)=>{
    var { offset: offset, className: className } = labelProps;
    var { cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius, startAngle: startAngle, endAngle: endAngle, clockWise: clockWise } = viewBox;
    var radius = (innerRadius + outerRadius) / 2;
    var deltaAngle = $ef6535e0015ddc73$var$getDeltaAngle(startAngle, endAngle);
    var sign = deltaAngle >= 0 ? 1 : -1;
    var labelAngle, direction;
    switch(position){
        case 'insideStart':
            labelAngle = startAngle + sign * offset;
            direction = clockWise;
            break;
        case 'insideEnd':
            labelAngle = endAngle - sign * offset;
            direction = !clockWise;
            break;
        case 'end':
            labelAngle = endAngle + sign * offset;
            direction = clockWise;
            break;
        default:
            throw new Error("Unsupported position ".concat(position));
    }
    direction = deltaAngle <= 0 ? direction : !direction;
    var startPoint = (0, $68befda7de8b3621$export$5c9a959bb3fc7749)(cx, cy, radius, labelAngle);
    var endPoint = (0, $68befda7de8b3621$export$5c9a959bb3fc7749)(cx, cy, radius, labelAngle + (direction ? 1 : -1) * 359);
    var path = "M".concat(startPoint.x, ",").concat(startPoint.y, "\n    A").concat(radius, ",").concat(radius, ",0,1,").concat(direction ? 0 : 1, ",\n    ").concat(endPoint.x, ",").concat(endPoint.y);
    var id = (0, $7e613228d3a31273$export$b931b78cbb3caf86)(labelProps.id) ? (0, $7e613228d3a31273$export$8b15d37bc3f197d4)('recharts-radial-line-') : labelProps.id;
    return /*#__PURE__*/ $kc00y.createElement("text", $ef6535e0015ddc73$var$_extends({}, attrs, {
        dominantBaseline: "central",
        className: (0, $328c1c2632e2f292$export$4f5d2d50c9deca37)('recharts-radial-bar-label', className)
    }), /*#__PURE__*/ $kc00y.createElement("defs", null, /*#__PURE__*/ $kc00y.createElement("path", {
        id: id,
        d: path
    })), /*#__PURE__*/ $kc00y.createElement("textPath", {
        xlinkHref: "#".concat(id)
    }, label));
};
var $ef6535e0015ddc73$var$getAttrsOfPolarLabel = (viewBox, offset, position)=>{
    var { cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius, startAngle: startAngle, endAngle: endAngle } = viewBox;
    var midAngle = (startAngle + endAngle) / 2;
    if (position === 'outside') {
        var { x: _x, y: _y } = (0, $68befda7de8b3621$export$5c9a959bb3fc7749)(cx, cy, outerRadius + offset, midAngle);
        return {
            x: _x,
            y: _y,
            textAnchor: _x >= cx ? 'start' : 'end',
            verticalAnchor: 'middle'
        };
    }
    if (position === 'center') return {
        x: cx,
        y: cy,
        textAnchor: 'middle',
        verticalAnchor: 'middle'
    };
    if (position === 'centerTop') return {
        x: cx,
        y: cy,
        textAnchor: 'middle',
        verticalAnchor: 'start'
    };
    if (position === 'centerBottom') return {
        x: cx,
        y: cy,
        textAnchor: 'middle',
        verticalAnchor: 'end'
    };
    var r = (innerRadius + outerRadius) / 2;
    var { x: x, y: y } = (0, $68befda7de8b3621$export$5c9a959bb3fc7749)(cx, cy, r, midAngle);
    return {
        x: x,
        y: y,
        textAnchor: 'middle',
        verticalAnchor: 'middle'
    };
};
var $ef6535e0015ddc73$var$isPolar = (viewBox)=>viewBox != null && 'cx' in viewBox && (0, $7e613228d3a31273$export$7e4aa119212bc614)(viewBox.cx);
var $ef6535e0015ddc73$export$b1c389a57ef19225 = {
    angle: 0,
    offset: 5,
    zIndex: (0, $2d4105c5b5d94e8f$export$96df16b28aa32702).label,
    position: 'middle',
    textBreakAll: false
};
function $ef6535e0015ddc73$var$polarViewBoxToTrapezoid(viewBox) {
    if (!$ef6535e0015ddc73$var$isPolar(viewBox)) return viewBox;
    var { cx: cx, cy: cy, outerRadius: outerRadius } = viewBox;
    var diameter = outerRadius * 2;
    return {
        x: cx - outerRadius,
        y: cy - outerRadius,
        width: diameter,
        upperWidth: diameter,
        lowerWidth: diameter,
        height: diameter
    };
}
function $ef6535e0015ddc73$export$b04be29aa201d4f5(outerProps) {
    var props = (0, $4cc2299923ef69c7$export$45004cc70a390ee8)(outerProps, $ef6535e0015ddc73$export$b1c389a57ef19225);
    var { viewBox: viewBoxFromProps, parentViewBox: parentViewBox, position: position, value: value, children: children, content: content, className: className = '', textBreakAll: textBreakAll, labelRef: labelRef } = props;
    var polarViewBox = $ef6535e0015ddc73$export$6f334acae8be4776();
    var cartesianViewBox = $ef6535e0015ddc73$var$useCartesianLabelContext();
    /*
   * I am not proud about this solution, but it's a quick fix for https://github.com/recharts/recharts/issues/6030#issuecomment-3155352460.
   * What we should really do is split Label into two components: CartesianLabel and PolarLabel and then handle their respective viewBoxes separately.
   * Also other components should set its own viewBox in a context so that we can fix https://github.com/recharts/recharts/issues/6156
   */ var resolvedViewBox = position === 'center' ? cartesianViewBox : polarViewBox !== null && polarViewBox !== void 0 ? polarViewBox : cartesianViewBox;
    var viewBox, label, positionAttrs;
    if (viewBoxFromProps == null) viewBox = resolvedViewBox;
    else if ($ef6535e0015ddc73$var$isPolar(viewBoxFromProps)) viewBox = viewBoxFromProps;
    else viewBox = (0, $f4c9341f05a18477$export$94a03fc5d61f2504)(viewBoxFromProps);
    var cartesianBox = $ef6535e0015ddc73$var$polarViewBoxToTrapezoid(viewBox);
    if (!viewBox || (0, $7e613228d3a31273$export$b931b78cbb3caf86)(value) && (0, $7e613228d3a31273$export$b931b78cbb3caf86)(children) && !/*#__PURE__*/ (0, $kc00y.isValidElement)(content) && typeof content !== 'function') return null;
    var propsWithViewBox = $ef6535e0015ddc73$var$_objectSpread($ef6535e0015ddc73$var$_objectSpread({}, props), {}, {
        viewBox: viewBox
    });
    if (/*#__PURE__*/ (0, $kc00y.isValidElement)(content)) {
        var { labelRef: _ } = propsWithViewBox, propsWithoutLabelRef = $ef6535e0015ddc73$var$_objectWithoutProperties(propsWithViewBox, $ef6535e0015ddc73$var$_excluded);
        return /*#__PURE__*/ (0, $kc00y.cloneElement)(content, propsWithoutLabelRef);
    }
    if (typeof content === 'function') {
        var { content: _2 } = propsWithViewBox, propsForContent = $ef6535e0015ddc73$var$_objectWithoutProperties(propsWithViewBox, $ef6535e0015ddc73$var$_excluded2);
        // @ts-expect-error we're not checking if the content component returns something that Text is able to render
        label = /*#__PURE__*/ (0, $kc00y.createElement)(content, propsForContent);
        if (/*#__PURE__*/ (0, $kc00y.isValidElement)(label)) return label;
    } else label = $ef6535e0015ddc73$var$getLabel(props);
    var attrs = (0, $976509d5bd74ee3b$export$67f8fc03e57e2747)(props);
    if ($ef6535e0015ddc73$var$isPolar(viewBox)) {
        // TODO: Generic Polar Hook
        if (position === 'insideStart' || position === 'insideEnd' || position === 'end') return $ef6535e0015ddc73$var$renderRadialLabel(props, position, label, attrs, viewBox);
        positionAttrs = $ef6535e0015ddc73$var$getAttrsOfPolarLabel(viewBox, props.offset, props.position);
    } else {
        if (!cartesianBox) return null;
        var cartesianResult = (0, $6aca0478e19471f7$export$524d3fb4d123c796)({
            viewBox: cartesianBox,
            position: position,
            offset: props.offset,
            parentViewBox: $ef6535e0015ddc73$var$isPolar(parentViewBox) ? undefined : parentViewBox,
            clamp: true
        });
        positionAttrs = $ef6535e0015ddc73$var$_objectSpread($ef6535e0015ddc73$var$_objectSpread({
            x: cartesianResult.x,
            y: cartesianResult.y,
            textAnchor: cartesianResult.horizontalAnchor,
            verticalAnchor: cartesianResult.verticalAnchor
        }, cartesianResult.width !== undefined ? {
            width: cartesianResult.width
        } : {}), cartesianResult.height !== undefined ? {
            height: cartesianResult.height
        } : {});
    }
    return /*#__PURE__*/ $kc00y.createElement((0, $a6cde822fe24aa10$export$b37befaf92aba9f1), {
        zIndex: props.zIndex
    }, /*#__PURE__*/ $kc00y.createElement((0, $0f46b46b80ac2f75$export$5f1af8db9871e1d6), $ef6535e0015ddc73$var$_extends({
        ref: labelRef,
        className: (0, $328c1c2632e2f292$export$4f5d2d50c9deca37)('recharts-label', className)
    }, attrs, positionAttrs, {
        /*
     * textAnchor is decided by default based on the `position`
     * but we allow overriding via props for precise control.
     */ textAnchor: (0, $0f46b46b80ac2f75$export$ae5e6c08954aa63c)(attrs.textAnchor) ? attrs.textAnchor : positionAttrs.textAnchor,
        breakAll: textBreakAll
    }), label));
}
$ef6535e0015ddc73$export$b04be29aa201d4f5.displayName = 'Label';
var $ef6535e0015ddc73$var$parseLabel = (label, viewBox, labelRef)=>{
    if (!label) return null;
    var commonProps = {
        viewBox: viewBox,
        labelRef: labelRef
    };
    if (label === true) return /*#__PURE__*/ $kc00y.createElement($ef6535e0015ddc73$export$b04be29aa201d4f5, $ef6535e0015ddc73$var$_extends({
        key: "label-implicit"
    }, commonProps));
    if ((0, $7e613228d3a31273$export$402a499e1ea44294)(label)) return /*#__PURE__*/ $kc00y.createElement($ef6535e0015ddc73$export$b04be29aa201d4f5, $ef6535e0015ddc73$var$_extends({
        key: "label-implicit",
        value: label
    }, commonProps));
    if (/*#__PURE__*/ (0, $kc00y.isValidElement)(label)) {
        if (label.type === $ef6535e0015ddc73$export$b04be29aa201d4f5) return /*#__PURE__*/ (0, $kc00y.cloneElement)(label, $ef6535e0015ddc73$var$_objectSpread({
            key: 'label-implicit'
        }, commonProps));
        return /*#__PURE__*/ $kc00y.createElement($ef6535e0015ddc73$export$b04be29aa201d4f5, $ef6535e0015ddc73$var$_extends({
            key: "label-implicit",
            content: label
        }, commonProps));
    }
    if ($ef6535e0015ddc73$export$96a48941c06f377f(label)) return /*#__PURE__*/ $kc00y.createElement($ef6535e0015ddc73$export$b04be29aa201d4f5, $ef6535e0015ddc73$var$_extends({
        key: "label-implicit",
        content: label
    }, commonProps));
    if (label && typeof label === 'object') return /*#__PURE__*/ $kc00y.createElement($ef6535e0015ddc73$export$b04be29aa201d4f5, $ef6535e0015ddc73$var$_extends({}, label, {
        key: "label-implicit"
    }, commonProps));
    return null;
};
function $ef6535e0015ddc73$export$3c82c3a3704539d8(_ref3) {
    var { label: label, labelRef: labelRef } = _ref3;
    var viewBox = $ef6535e0015ddc73$var$useCartesianLabelContext();
    return $ef6535e0015ddc73$var$parseLabel(label, viewBox, labelRef) || null;
}
function $ef6535e0015ddc73$export$24b42d9a68417c83(_ref4) {
    var { label: label } = _ref4;
    var viewBox = $ef6535e0015ddc73$export$6f334acae8be4776();
    return $ef6535e0015ddc73$var$parseLabel(label, viewBox) || null;
}









var $acfbbd67802b75bf$var$_excluded = [
    "valueAccessor"
], $acfbbd67802b75bf$var$_excluded2 = [
    "dataKey",
    "clockWise",
    "id",
    "textBreakAll",
    "zIndex"
];
function $acfbbd67802b75bf$var$_extends() {
    return $acfbbd67802b75bf$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $acfbbd67802b75bf$var$_extends.apply(null, arguments);
}
function $acfbbd67802b75bf$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $acfbbd67802b75bf$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $acfbbd67802b75bf$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
/**
 * This is public API because we expose it as the valueAccessor parameter.
 *
 * The properties of "viewBox" are repeated as the root props of the entry object.
 * So it doesn't matter if you read entry.x or entry.viewBox.x, they are the same.
 *
 * It's not necessary to pass redundant data, but we keep it for backward compatibility.
 */ /**
 * LabelList props do not allow refs because the same props are reused in multiple elements so we don't have a good single place to ref to.
 */ /**
 * This is the type accepted for the `label` prop on various graphical items.
 * It accepts:
 *
 * boolean:
 *    true = labels show,
 *    false = labels don't show
 * React element:
 *    will be cloned with extra props
 * function:
 *    is used as <Label content={function} />, so this will be called once for each individual label (so typically once for each data point)
 * object:
 *    the props to be passed to a LabelList component
 *
 * @inline
 */ var $acfbbd67802b75bf$var$defaultAccessor = (entry)=>{
    var val = Array.isArray(entry.value) ? entry.value[entry.value.length - 1] : entry.value;
    if ((0, $0f46b46b80ac2f75$export$16c73a52b3ef3edd)(val)) return val;
    return undefined;
};
var $acfbbd67802b75bf$var$CartesianLabelListContext = /*#__PURE__*/ (0, $kc00y.createContext)(undefined);
var $acfbbd67802b75bf$export$64e384eac5db53f7 = $acfbbd67802b75bf$var$CartesianLabelListContext.Provider;
var $acfbbd67802b75bf$var$PolarLabelListContext = /*#__PURE__*/ (0, $kc00y.createContext)(undefined);
var $acfbbd67802b75bf$export$38a852d7976af0fe = $acfbbd67802b75bf$var$PolarLabelListContext.Provider;
function $acfbbd67802b75bf$var$useCartesianLabelListContext() {
    return (0, $kc00y.useContext)($acfbbd67802b75bf$var$CartesianLabelListContext);
}
function $acfbbd67802b75bf$var$usePolarLabelListContext() {
    return (0, $kc00y.useContext)($acfbbd67802b75bf$var$PolarLabelListContext);
}
function $acfbbd67802b75bf$export$835fcf23ab7bf88(_ref) {
    var { valueAccessor: valueAccessor = $acfbbd67802b75bf$var$defaultAccessor } = _ref, restProps = $acfbbd67802b75bf$var$_objectWithoutProperties(_ref, $acfbbd67802b75bf$var$_excluded);
    var { dataKey: dataKey, clockWise: clockWise, id: id, textBreakAll: textBreakAll, zIndex: zIndex } = restProps, others = $acfbbd67802b75bf$var$_objectWithoutProperties(restProps, $acfbbd67802b75bf$var$_excluded2);
    var cartesianData = $acfbbd67802b75bf$var$useCartesianLabelListContext();
    var polarData = $acfbbd67802b75bf$var$usePolarLabelListContext();
    var data = cartesianData || polarData;
    if (!data || !data.length) return null;
    return /*#__PURE__*/ $kc00y.createElement((0, $a6cde822fe24aa10$export$b37befaf92aba9f1), {
        zIndex: zIndex !== null && zIndex !== void 0 ? zIndex : (0, $2d4105c5b5d94e8f$export$96df16b28aa32702).label
    }, /*#__PURE__*/ $kc00y.createElement((0, $553c02c7047f2968$export$936d0764594b6eb3), {
        className: "recharts-label-list"
    }, data.map((entry, index)=>{
        var _restProps$fill;
        var value = (0, $7e613228d3a31273$export$b931b78cbb3caf86)(dataKey) ? valueAccessor(entry, index) : (0, $d5958b0668c58531$export$f97fc4a450f29a)(entry.payload, dataKey);
        var idProps = (0, $7e613228d3a31273$export$b931b78cbb3caf86)(id) ? {} : {
            id: "".concat(id, "-").concat(index)
        };
        return /*#__PURE__*/ $kc00y.createElement((0, $ef6535e0015ddc73$export$b04be29aa201d4f5), $acfbbd67802b75bf$var$_extends({
            key: "label-".concat(index)
        }, (0, $976509d5bd74ee3b$export$67f8fc03e57e2747)(entry), others, idProps, {
            /*
       * Prefer to use the explicit fill from LabelList props.
       * Only in an absence of that, fall back to the fill of the entry.
       * The entry fill can be quite difficult to see especially in Bar, Pie, RadialBar in inside positions.
       * On the other hand it's quite convenient in Scatter, Line, or when the position is outside the Bar, Pie filled shapes.
       */ fill: (_restProps$fill = restProps.fill) !== null && _restProps$fill !== void 0 ? _restProps$fill : entry.fill,
            parentViewBox: entry.parentViewBox,
            value: value,
            textBreakAll: textBreakAll,
            viewBox: entry.viewBox,
            index: index,
            zIndex: 0
        }));
    })));
}
$acfbbd67802b75bf$export$835fcf23ab7bf88.displayName = 'LabelList';
function $acfbbd67802b75bf$export$9a402bc8de2b410e(_ref2) {
    var { label: label } = _ref2;
    if (!label) return null;
    if (label === true) return /*#__PURE__*/ $kc00y.createElement($acfbbd67802b75bf$export$835fcf23ab7bf88, {
        key: "labelList-implicit"
    });
    if (/*#__PURE__*/ $kc00y.isValidElement(label) || (0, $ef6535e0015ddc73$export$96a48941c06f377f)(label)) return /*#__PURE__*/ $kc00y.createElement($acfbbd67802b75bf$export$835fcf23ab7bf88, {
        key: "labelList-implicit",
        content: label
    });
    if (typeof label === 'object') return /*#__PURE__*/ $kc00y.createElement($acfbbd67802b75bf$export$835fcf23ab7bf88, $acfbbd67802b75bf$var$_extends({
        key: "labelList-implicit"
    }, label, {
        type: String(label.type)
    }));
    return null;
}





var $kc00y = parcelRequire("kc00y");
var $741e834b6fbf0475$exports = {};
'use strict';

$741e834b6fbf0475$exports = (parcelRequire("qpdRJ"));



var $b54930f6e6643156$export$e65e0ff8d3882b46 = [
    'auto',
    'linear',
    'pow',
    'sqrt',
    'log',
    'identity',
    'time',
    'band',
    'point',
    'ordinal',
    'quantile',
    'quantize',
    'utc',
    'sequential',
    'threshold'
];
var $b54930f6e6643156$export$be63e0664592e141 = (Comp)=>{
    if (typeof Comp === 'string') return Comp;
    if (!Comp) return '';
    return Comp.displayName || Comp.name || 'Component';
};
// `toArray` gets called multiple times during the render
// so we can memoize last invocation (since reference to `children` is the same)
var $b54930f6e6643156$var$lastChildren = null;
var $b54930f6e6643156$var$lastResult = null;
var $b54930f6e6643156$export$45b10814cc054894 = (children)=>{
    if (children === $b54930f6e6643156$var$lastChildren && Array.isArray($b54930f6e6643156$var$lastResult)) return $b54930f6e6643156$var$lastResult;
    var result = [];
    (0, $kc00y.Children).forEach(children, (child)=>{
        if ((0, $7e613228d3a31273$export$b931b78cbb3caf86)(child)) return;
        if ((0, $741e834b6fbf0475$exports.isFragment)(child)) result = result.concat($b54930f6e6643156$export$45b10814cc054894(child.props.children));
        else // @ts-expect-error this could still be Iterable<ReactNode> and TS does not like that
        result.push(child);
    });
    $b54930f6e6643156$var$lastResult = result;
    $b54930f6e6643156$var$lastChildren = children;
    return result;
};
function $b54930f6e6643156$export$fdd5e64c0e8495bb(children, type) {
    var result = [];
    var types = [];
    if (Array.isArray(type)) types = type.map((t)=>$b54930f6e6643156$export$be63e0664592e141(t));
    else types = [
        $b54930f6e6643156$export$be63e0664592e141(type)
    ];
    $b54930f6e6643156$export$45b10814cc054894(children).forEach((child)=>{
        // @ts-expect-error toArray and lodash.get are not compatible. Let's get rid of the whole findAllByType function
        var childType = (0, (/*@__PURE__*/$parcel$interopDefault($c09fe069b4c20e1b$exports)))(child, 'type.displayName') || (0, (/*@__PURE__*/$parcel$interopDefault($c09fe069b4c20e1b$exports)))(child, 'type.name');
        if (childType && types.indexOf(childType) !== -1) result.push(child);
    });
    return result;
}
var $b54930f6e6643156$export$28c0c718114c1a2e = (dot)=>{
    if (dot && typeof dot === 'object' && 'clipDot' in dot) return Boolean(dot.clipDot);
    return true;
};




var $kc00y = parcelRequire("kc00y");

var $435e27a3bdb96447$export$b8cdb4ab1d25db49 = (c)=>{
    return 'radius' in c && 'startAngle' in c && 'endAngle' in c;
};
var $435e27a3bdb96447$export$7c4c290a4a9c1b1e = (props, newHandler)=>{
    if (!props || typeof props === 'function' || typeof props === 'boolean') return null;
    var inputProps = props;
    if (/*#__PURE__*/ (0, $kc00y.isValidElement)(props)) inputProps = props.props;
    if (typeof inputProps !== 'object' && typeof inputProps !== 'function') return null;
    var out = {};
    Object.keys(inputProps).forEach((key)=>{
        if ((0, $17b5e9a14cb04dec$export$7d045284457d8577)(key) && typeof inputProps[key] === 'function') out[key] = newHandler || ((e)=>inputProps[key](inputProps, e));
    });
    return out;
};
var $435e27a3bdb96447$var$getEventHandlerOfChild = (originalHandler, data, index)=>(e)=>{
        originalHandler(data, index, e);
        return null;
    };
var $435e27a3bdb96447$export$ca62be0d67a3158c = (props, data, index)=>{
    if (props === null || typeof props !== 'object' && typeof props !== 'function') return null;
    var out = null;
    Object.keys(props).forEach((key)=>{
        var item = props[key];
        if ((0, $17b5e9a14cb04dec$export$7d045284457d8577)(key) && typeof item === 'function') {
            if (!out) out = {};
            out[key] = $435e27a3bdb96447$var$getEventHandlerOfChild(item, data, index);
        }
    });
    return out;
};
var $435e27a3bdb96447$export$d307f5934e447d0e = (arr)=>{
    return Array.isArray(arr) && arr.length > 0;
};



var $kc00y = parcelRequire("kc00y");
var $5e5c9f2b3ce253bc$var$isProduction = true;
var $5e5c9f2b3ce253bc$var$prefix = 'Invariant failed';
function $5e5c9f2b3ce253bc$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($5e5c9f2b3ce253bc$var$isProduction) throw new Error($5e5c9f2b3ce253bc$var$prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat($5e5c9f2b3ce253bc$var$prefix, ": ").concat(provided) : $5e5c9f2b3ce253bc$var$prefix;
    throw new Error(value);
}



var $kc00y = parcelRequire("kc00y");
var $5a1c73d780a13b61$exports = {};

$5a1c73d780a13b61$exports = (parcelRequire("h9BkM")).isPlainObject;



var $kc00y = parcelRequire("kc00y");



var $kc00y = parcelRequire("kc00y");


function $9353be12f729c74c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9353be12f729c74c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9353be12f729c74c$var$ownKeys(Object(t), !0).forEach(function(r) {
            $9353be12f729c74c$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9353be12f729c74c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $9353be12f729c74c$var$_defineProperty(e, r, t) {
    return (r = $9353be12f729c74c$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $9353be12f729c74c$var$_toPropertyKey(t) {
    var i = $9353be12f729c74c$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $9353be12f729c74c$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $9353be12f729c74c$export$51610fddbf64bc9d = (name)=>name.replace(/([A-Z])/g, (v)=>"-".concat(v.toLowerCase()));
var $9353be12f729c74c$export$1594c78389ee3429 = (props, duration, easing)=>props.map((prop)=>"".concat($9353be12f729c74c$export$51610fddbf64bc9d(prop), " ").concat(duration, "ms ").concat(easing)).join(',');
var $9353be12f729c74c$export$59e29973723da0b3 = (preObj, nextObj)=>[
        Object.keys(preObj),
        Object.keys(nextObj)
    ].reduce((a, b)=>a.filter((c)=>b.includes(c)));
var $9353be12f729c74c$export$d6051a0f7a227332 = (fn, obj)=>Object.keys(obj).reduce((res, key)=>$9353be12f729c74c$var$_objectSpread($9353be12f729c74c$var$_objectSpread({}, res), {}, {
            [key]: fn(key, obj[key])
        }), {});


function $7556f6f2e34a01eb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7556f6f2e34a01eb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7556f6f2e34a01eb$var$ownKeys(Object(t), !0).forEach(function(r) {
            $7556f6f2e34a01eb$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7556f6f2e34a01eb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $7556f6f2e34a01eb$var$_defineProperty(e, r, t) {
    return (r = $7556f6f2e34a01eb$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $7556f6f2e34a01eb$var$_toPropertyKey(t) {
    var i = $7556f6f2e34a01eb$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $7556f6f2e34a01eb$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $7556f6f2e34a01eb$export$58f0f39f63f3cf42 = (begin, end, k)=>begin + (end - begin) * k;
var $7556f6f2e34a01eb$var$needContinue = (_ref)=>{
    var { from: from, to: to } = _ref;
    return from !== to;
};
/*
 * @description: cal new from value and velocity in each stepper
 * @return: { [styleProperty]: { from, to, velocity } }
 */ var $7556f6f2e34a01eb$var$calStepperVals = (easing, preVals, steps)=>{
    var nextStepVals = (0, $9353be12f729c74c$export$d6051a0f7a227332)((key, val)=>{
        if ($7556f6f2e34a01eb$var$needContinue(val)) {
            var [newX, newV] = easing(val.from, val.to, val.velocity);
            return $7556f6f2e34a01eb$var$_objectSpread($7556f6f2e34a01eb$var$_objectSpread({}, val), {}, {
                from: newX,
                velocity: newV
            });
        }
        return val;
    }, preVals);
    if (steps < 1) return (0, $9353be12f729c74c$export$d6051a0f7a227332)((key, val)=>{
        if ($7556f6f2e34a01eb$var$needContinue(val) && nextStepVals[key] != null) return $7556f6f2e34a01eb$var$_objectSpread($7556f6f2e34a01eb$var$_objectSpread({}, val), {}, {
            velocity: $7556f6f2e34a01eb$export$58f0f39f63f3cf42(val.velocity, nextStepVals[key].velocity, steps),
            from: $7556f6f2e34a01eb$export$58f0f39f63f3cf42(val.from, nextStepVals[key].from, steps)
        });
        return val;
    }, preVals);
    return $7556f6f2e34a01eb$var$calStepperVals(easing, nextStepVals, steps - 1);
};
function $7556f6f2e34a01eb$var$createStepperUpdate(from, to, easing, interKeys, render, timeoutController) {
    var preTime;
    var stepperStyle = interKeys.reduce((res, key)=>$7556f6f2e34a01eb$var$_objectSpread($7556f6f2e34a01eb$var$_objectSpread({}, res), {}, {
            [key]: {
                from: from[key],
                velocity: 0,
                to: to[key]
            }
        }), {});
    var getCurrStyle = ()=>(0, $9353be12f729c74c$export$d6051a0f7a227332)((key, val)=>val.from, stepperStyle);
    var shouldStopAnimation = ()=>!Object.values(stepperStyle).filter($7556f6f2e34a01eb$var$needContinue).length;
    var stopAnimation = null;
    var stepperUpdate = (now)=>{
        if (!preTime) preTime = now;
        var deltaTime = now - preTime;
        var steps = deltaTime / easing.dt;
        stepperStyle = $7556f6f2e34a01eb$var$calStepperVals(easing, stepperStyle, steps);
        // get union set and add compatible prefix
        render($7556f6f2e34a01eb$var$_objectSpread($7556f6f2e34a01eb$var$_objectSpread($7556f6f2e34a01eb$var$_objectSpread({}, from), to), getCurrStyle()));
        preTime = now;
        if (!shouldStopAnimation()) stopAnimation = timeoutController.setTimeout(stepperUpdate);
    };
    // return start animation method
    return ()=>{
        stopAnimation = timeoutController.setTimeout(stepperUpdate);
        // return stop animation method
        return ()=>{
            var _stopAnimation;
            (_stopAnimation = stopAnimation) === null || _stopAnimation === void 0 || _stopAnimation();
        };
    };
}
function $7556f6f2e34a01eb$var$createTimingUpdate(from, to, easing, duration, interKeys, render, timeoutController) {
    var stopAnimation = null;
    var timingStyle = interKeys.reduce((res, key)=>{
        var fromElement = from[key];
        var toElement = to[key];
        if (fromElement == null || toElement == null) return res;
        return $7556f6f2e34a01eb$var$_objectSpread($7556f6f2e34a01eb$var$_objectSpread({}, res), {}, {
            [key]: [
                fromElement,
                toElement
            ]
        });
    }, {});
    var beginTime;
    var timingUpdate = (now)=>{
        if (!beginTime) beginTime = now;
        var t = (now - beginTime) / duration;
        var currStyle = (0, $9353be12f729c74c$export$d6051a0f7a227332)((key, val)=>$7556f6f2e34a01eb$export$58f0f39f63f3cf42(...val, easing(t)), timingStyle);
        // get union set and add compatible prefix
        render($7556f6f2e34a01eb$var$_objectSpread($7556f6f2e34a01eb$var$_objectSpread($7556f6f2e34a01eb$var$_objectSpread({}, from), to), currStyle));
        if (t < 1) stopAnimation = timeoutController.setTimeout(timingUpdate);
        else {
            var finalStyle = (0, $9353be12f729c74c$export$d6051a0f7a227332)((key, val)=>$7556f6f2e34a01eb$export$58f0f39f63f3cf42(...val, easing(1)), timingStyle);
            render($7556f6f2e34a01eb$var$_objectSpread($7556f6f2e34a01eb$var$_objectSpread($7556f6f2e34a01eb$var$_objectSpread({}, from), to), finalStyle));
        }
    };
    // return start animation method
    return ()=>{
        stopAnimation = timeoutController.setTimeout(timingUpdate);
        // return stop animation method
        return ()=>{
            var _stopAnimation2;
            (_stopAnimation2 = stopAnimation) === null || _stopAnimation2 === void 0 || _stopAnimation2();
        };
    };
}
var // configure update function
// eslint-disable-next-line import/no-default-export
$7556f6f2e34a01eb$export$2e2bcd8739ae039 = (from, to, easing, duration, render, timeoutController)=>{
    var interKeys = (0, $9353be12f729c74c$export$59e29973723da0b3)(from, to);
    if (easing == null) // no animation, just set to final state
    return ()=>{
        render($7556f6f2e34a01eb$var$_objectSpread($7556f6f2e34a01eb$var$_objectSpread({}, from), to));
        return ()=>{};
    };
    return easing.isStepper === true ? $7556f6f2e34a01eb$var$createStepperUpdate(from, to, easing, interKeys, render, timeoutController) : $7556f6f2e34a01eb$var$createTimingUpdate(from, to, easing, duration, interKeys, render, timeoutController);
};


var $f7e754ce1246d9c7$export$73dea3ad38069b0e = 1e-4;
var $f7e754ce1246d9c7$var$cubicBezierFactor = (c1, c2)=>[
        0,
        3 * c1,
        3 * c2 - 6 * c1,
        3 * c1 - 3 * c2 + 1
    ];
var $f7e754ce1246d9c7$var$evaluatePolynomial = (params, t)=>params.map((param, i)=>param * t ** i).reduce((pre, curr)=>pre + curr);
var $f7e754ce1246d9c7$var$cubicBezier = (c1, c2)=>(t)=>{
        var params = $f7e754ce1246d9c7$var$cubicBezierFactor(c1, c2);
        return $f7e754ce1246d9c7$var$evaluatePolynomial(params, t);
    };
var $f7e754ce1246d9c7$var$derivativeCubicBezier = (c1, c2)=>(t)=>{
        var params = $f7e754ce1246d9c7$var$cubicBezierFactor(c1, c2);
        var newParams = [
            ...params.map((param, i)=>param * i).slice(1),
            0
        ];
        return $f7e754ce1246d9c7$var$evaluatePolynomial(newParams, t);
    };
var $f7e754ce1246d9c7$var$parseCubicBezier = (easing)=>{
    var _easingParts$;
    var easingParts = easing.split('(');
    if (easingParts.length !== 2 || easingParts[0] !== 'cubic-bezier') return null;
    var numbers = (_easingParts$ = easingParts[1]) === null || _easingParts$ === void 0 || (_easingParts$ = _easingParts$.split(')')[0]) === null || _easingParts$ === void 0 ? void 0 : _easingParts$.split(',');
    if (numbers == null || numbers.length !== 4) return null;
    var coords = numbers.map((x)=>parseFloat(x));
    return [
        coords[0],
        coords[1],
        coords[2],
        coords[3]
    ];
};
var $f7e754ce1246d9c7$var$getBezierCoordinates = function getBezierCoordinates() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    if (args.length === 1) switch(args[0]){
        case 'linear':
            return [
                0.0,
                0.0,
                1.0,
                1.0
            ];
        case 'ease':
            return [
                0.25,
                0.1,
                0.25,
                1.0
            ];
        case 'ease-in':
            return [
                0.42,
                0.0,
                1.0,
                1.0
            ];
        case 'ease-out':
            return [
                0.42,
                0.0,
                0.58,
                1.0
            ];
        case 'ease-in-out':
            return [
                0.0,
                0.0,
                0.58,
                1.0
            ];
        default:
            var easing = $f7e754ce1246d9c7$var$parseCubicBezier(args[0]);
            if (easing) return easing;
    }
    if (args.length === 4) return args;
    // Fallback for invalid inputs. The previous implementation was buggy and would lead to NaN.
    // Returning linear easing is a safe default.
    return [
        0.0,
        0.0,
        1.0,
        1.0
    ];
};
var $f7e754ce1246d9c7$var$createBezierEasing = (x1, y1, x2, y2)=>{
    var curveX = $f7e754ce1246d9c7$var$cubicBezier(x1, x2);
    var curveY = $f7e754ce1246d9c7$var$cubicBezier(y1, y2);
    var derCurveX = $f7e754ce1246d9c7$var$derivativeCubicBezier(x1, x2);
    var rangeValue = (value)=>{
        if (value > 1) return 1;
        if (value < 0) return 0;
        return value;
    };
    var bezier = (_t)=>{
        var t = _t > 1 ? 1 : _t;
        var x = t;
        for(var i = 0; i < 8; ++i){
            var evalT = curveX(x) - t;
            var derVal = derCurveX(x);
            if (Math.abs(evalT - t) < $f7e754ce1246d9c7$export$73dea3ad38069b0e || derVal < $f7e754ce1246d9c7$export$73dea3ad38069b0e) return curveY(x);
            x = rangeValue(x - evalT / derVal);
        }
        return curveY(x);
    };
    bezier.isStepper = false;
    return bezier;
};
var $f7e754ce1246d9c7$export$56c51296f72f0592 = function configBezier() {
    return $f7e754ce1246d9c7$var$createBezierEasing(...$f7e754ce1246d9c7$var$getBezierCoordinates(...arguments));
};
var $f7e754ce1246d9c7$export$12fc25daf62b865a = function configSpring() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var { stiff: stiff = 100, damping: damping = 8, dt: dt = 17 } = config;
    var stepper = (currX, destX, currV)=>{
        var FSpring = -(currX - destX) * stiff;
        var FDamping = currV * damping;
        var newV = currV + (FSpring - FDamping) * dt / 1000;
        var newX = currV * dt / 1000 + currX;
        if (Math.abs(newX - destX) < $f7e754ce1246d9c7$export$73dea3ad38069b0e && Math.abs(newV) < $f7e754ce1246d9c7$export$73dea3ad38069b0e) return [
            destX,
            0
        ];
        return [
            newX,
            newV
        ];
    };
    stepper.isStepper = true;
    stepper.dt = dt;
    return stepper;
};
var $f7e754ce1246d9c7$export$e3e04925801e5434 = (easing)=>{
    if (typeof easing === 'string') switch(easing){
        case 'ease':
        case 'ease-in-out':
        case 'ease-out':
        case 'ease-in':
        case 'linear':
            return $f7e754ce1246d9c7$export$56c51296f72f0592(easing);
        case 'spring':
            return $f7e754ce1246d9c7$export$12fc25daf62b865a();
        default:
            if (easing.split('(')[0] === 'cubic-bezier') return $f7e754ce1246d9c7$export$56c51296f72f0592(easing);
    }
    if (typeof easing === 'function') return easing;
    return null;
};



var $kc00y = parcelRequire("kc00y");
/**
 * Represents a single item in the ReactSmoothQueue.
 * The item can be:
 * - A number representing a delay in milliseconds.
 * - An object representing a style change
 * - A StartAnimationFunction that starts eased transition and calls different render
 *      because of course in Recharts we have to have three ways to do everything
 * - An arbitrary function to be executed
 */ function $751913a719051f99$export$26646f0bb02941d1(timeoutController) {
    var currStyle;
    var handleChange = ()=>null;
    var shouldStop = false;
    var cancelTimeout = null;
    var setStyle = (_style)=>{
        if (shouldStop) return;
        if (Array.isArray(_style)) {
            if (!_style.length) return;
            var styles = _style;
            var [curr, ...restStyles] = styles;
            if (typeof curr === 'number') {
                cancelTimeout = timeoutController.setTimeout(setStyle.bind(null, restStyles), curr);
                return;
            }
            setStyle(curr);
            cancelTimeout = timeoutController.setTimeout(setStyle.bind(null, restStyles));
            return;
        }
        if (typeof _style === 'string') {
            currStyle = _style;
            handleChange(currStyle);
        }
        if (typeof _style === 'object') {
            currStyle = _style;
            handleChange(currStyle);
        }
        if (typeof _style === 'function') _style();
    };
    return {
        stop: ()=>{
            shouldStop = true;
        },
        start: (style)=>{
            shouldStop = false;
            if (cancelTimeout) {
                cancelTimeout();
                cancelTimeout = null;
            }
            setStyle(style);
        },
        subscribe: (_handleChange)=>{
            handleChange = _handleChange;
            return ()=>{
                handleChange = ()=>null;
            };
        },
        getTimeoutController: ()=>timeoutController
    };
}


/**
 * Callback type for the timeout function.
 * Receives current time in milliseconds as an argument.
 */ /**
 * A function that, when called, cancels the timeout.
 */ class $3251efbbaa54fbff$export$fa255b8f41b568c2 {
    setTimeout(callback) {
        var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var startTime = performance.now();
        var requestId = null;
        var executeCallback = (now)=>{
            if (now - startTime >= delay) callback(now);
            else if (typeof requestAnimationFrame === 'function') requestId = requestAnimationFrame(executeCallback);
        };
        requestId = requestAnimationFrame(executeCallback);
        return ()=>{
            if (requestId != null) cancelAnimationFrame(requestId);
        };
    }
}


function $f07fd500bd7650a9$export$a649b7dd21ebb400() {
    return (0, $751913a719051f99$export$26646f0bb02941d1)(new (0, $3251efbbaa54fbff$export$fa255b8f41b568c2)());
}


var $b7c00190cf2eac5d$export$ec4cae1386f040b6 = /*#__PURE__*/ (0, $kc00y.createContext)((0, $f07fd500bd7650a9$export$a649b7dd21ebb400));
function $b7c00190cf2eac5d$export$996cb06187bf3507(animationId, animationManagerFromProps) {
    var contextAnimationManager = (0, $kc00y.useContext)($b7c00190cf2eac5d$export$ec4cae1386f040b6);
    return (0, $kc00y.useMemo)(()=>animationManagerFromProps !== null && animationManagerFromProps !== void 0 ? animationManagerFromProps : contextAnimationManager(animationId), [
        animationId,
        animationManagerFromProps,
        contextAnimationManager
    ]);
}




var $kc00y = parcelRequire("kc00y");

function $8b3ba1cd1d15cc53$export$c170580b40c8999d() {
    var [prefersReducedMotion, setPrefersReducedMotion] = (0, $kc00y.useState)(()=>{
        if ((0, $21ceeda12d85451c$export$98f03c5d19621d70).isSsr) return false;
        if (!window.matchMedia) return false;
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    });
    (0, $kc00y.useEffect)(()=>{
        if (!window.matchMedia) return;
        var mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        var handleChange = ()=>{
            setPrefersReducedMotion(mediaQuery.matches);
        };
        mediaQuery.addEventListener('change', handleChange);
        // eslint-disable-next-line consistent-return
        return ()=>{
            mediaQuery.removeEventListener('change', handleChange);
        };
    }, []);
    return prefersReducedMotion;
}


var $a2871794a7a679f0$var$defaultJavascriptAnimateProps = {
    begin: 0,
    duration: 1000,
    easing: 'ease',
    isActive: true,
    canBegin: true,
    onAnimationEnd: ()=>{},
    onAnimationStart: ()=>{}
};
var $a2871794a7a679f0$var$from = {
    t: 0
};
var $a2871794a7a679f0$var$to = {
    t: 1
};
function $a2871794a7a679f0$export$5d41821894c47c52(outsideProps) {
    var props = (0, $4cc2299923ef69c7$export$45004cc70a390ee8)(outsideProps, $a2871794a7a679f0$var$defaultJavascriptAnimateProps);
    var { isActive: isActiveProp, canBegin: canBegin, duration: duration, easing: easing, begin: begin, onAnimationEnd: onAnimationEnd, onAnimationStart: onAnimationStart, children: children } = props;
    var prefersReducedMotion = (0, $8b3ba1cd1d15cc53$export$c170580b40c8999d)();
    var isActive = isActiveProp === 'auto' ? !(0, $21ceeda12d85451c$export$98f03c5d19621d70).isSsr && !prefersReducedMotion : isActiveProp;
    var animationManager = (0, $b7c00190cf2eac5d$export$996cb06187bf3507)(props.animationId, props.animationManager);
    var [style, setStyle] = (0, $kc00y.useState)(isActive ? $a2871794a7a679f0$var$from : $a2871794a7a679f0$var$to);
    var stopJSAnimation = (0, $kc00y.useRef)(null);
    (0, $kc00y.useEffect)(()=>{
        if (!isActive) setStyle($a2871794a7a679f0$var$to);
    }, [
        isActive
    ]);
    (0, $kc00y.useEffect)(()=>{
        if (!isActive || !canBegin) return 0, $7e613228d3a31273$export$8793edee2d425525;
        var startAnimation = (0, $7556f6f2e34a01eb$export$2e2bcd8739ae039)($a2871794a7a679f0$var$from, $a2871794a7a679f0$var$to, (0, $f7e754ce1246d9c7$export$e3e04925801e5434)(easing), duration, setStyle, animationManager.getTimeoutController());
        var onAnimationActive = ()=>{
            stopJSAnimation.current = startAnimation();
        };
        animationManager.start([
            onAnimationStart,
            begin,
            onAnimationActive,
            duration,
            onAnimationEnd
        ]);
        return ()=>{
            animationManager.stop();
            if (stopJSAnimation.current) stopJSAnimation.current();
            onAnimationEnd();
        };
    }, [
        isActive,
        canBegin,
        duration,
        easing,
        begin,
        onAnimationStart,
        onAnimationEnd,
        animationManager
    ]);
    return children(style.t);
}




var $kc00y = parcelRequire("kc00y");

function $706e1fa6aaf57212$export$e1042b2944b80b7f(input) {
    var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'animation-';
    var animationId = (0, $kc00y.useRef)((0, $7e613228d3a31273$export$8b15d37bc3f197d4)(prefix));
    var prevProps = (0, $kc00y.useRef)(input);
    if (prevProps.current !== input) {
        animationId.current = (0, $7e613228d3a31273$export$8b15d37bc3f197d4)(prefix);
        prevProps.current = input;
    }
    return animationId.current;
}





var $94f5b831b08677d3$var$_excluded = [
    "radius"
], $94f5b831b08677d3$var$_excluded2 = [
    "radius"
];
var $94f5b831b08677d3$var$_templateObject, $94f5b831b08677d3$var$_templateObject2, $94f5b831b08677d3$var$_templateObject3, $94f5b831b08677d3$var$_templateObject4, $94f5b831b08677d3$var$_templateObject5, $94f5b831b08677d3$var$_templateObject6, $94f5b831b08677d3$var$_templateObject7, $94f5b831b08677d3$var$_templateObject8, $94f5b831b08677d3$var$_templateObject9, $94f5b831b08677d3$var$_templateObject0;
function $94f5b831b08677d3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $94f5b831b08677d3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $94f5b831b08677d3$var$ownKeys(Object(t), !0).forEach(function(r) {
            $94f5b831b08677d3$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $94f5b831b08677d3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $94f5b831b08677d3$var$_defineProperty(e, r, t) {
    return (r = $94f5b831b08677d3$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $94f5b831b08677d3$var$_toPropertyKey(t) {
    var i = $94f5b831b08677d3$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $94f5b831b08677d3$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $94f5b831b08677d3$var$_extends() {
    return $94f5b831b08677d3$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $94f5b831b08677d3$var$_extends.apply(null, arguments);
}
function $94f5b831b08677d3$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $94f5b831b08677d3$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $94f5b831b08677d3$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $94f5b831b08677d3$var$_taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
/**
 * @inline
 */ var $94f5b831b08677d3$var$getRectanglePath = (x, y, width, height, radius)=>{
    var roundedWidth = (0, $ff2870262f58b24e$export$2077e0241d6afd3c)(width);
    var roundedHeight = (0, $ff2870262f58b24e$export$2077e0241d6afd3c)(height);
    var maxRadius = Math.min(Math.abs(roundedWidth) / 2, Math.abs(roundedHeight) / 2);
    var ySign = roundedHeight >= 0 ? 1 : -1;
    var xSign = roundedWidth >= 0 ? 1 : -1;
    var clockWise = roundedHeight >= 0 && roundedWidth >= 0 || roundedHeight < 0 && roundedWidth < 0 ? 1 : 0;
    var path;
    if (maxRadius > 0 && Array.isArray(radius)) {
        var newRadius = [
            0,
            0,
            0,
            0
        ];
        for(var i = 0, len = 4; i < len; i++){
            var _radius$i;
            var r = (_radius$i = radius[i]) !== null && _radius$i !== void 0 ? _radius$i : 0;
            newRadius[i] = r > maxRadius ? maxRadius : r;
        }
        path = (0, $ff2870262f58b24e$export$f8a24ecc3d6c26c3)($94f5b831b08677d3$var$_templateObject || ($94f5b831b08677d3$var$_templateObject = $94f5b831b08677d3$var$_taggedTemplateLiteral([
            "M",
            ",",
            ""
        ])), x, y + ySign * newRadius[0]);
        if (newRadius[0] > 0) path += (0, $ff2870262f58b24e$export$f8a24ecc3d6c26c3)($94f5b831b08677d3$var$_templateObject2 || ($94f5b831b08677d3$var$_templateObject2 = $94f5b831b08677d3$var$_taggedTemplateLiteral([
            "A ",
            ",",
            ",0,0,",
            ",",
            ",",
            ""
        ])), newRadius[0], newRadius[0], clockWise, x + xSign * newRadius[0], y);
        path += (0, $ff2870262f58b24e$export$f8a24ecc3d6c26c3)($94f5b831b08677d3$var$_templateObject3 || ($94f5b831b08677d3$var$_templateObject3 = $94f5b831b08677d3$var$_taggedTemplateLiteral([
            "L ",
            ",",
            ""
        ])), x + width - xSign * newRadius[1], y);
        if (newRadius[1] > 0) path += (0, $ff2870262f58b24e$export$f8a24ecc3d6c26c3)($94f5b831b08677d3$var$_templateObject4 || ($94f5b831b08677d3$var$_templateObject4 = $94f5b831b08677d3$var$_taggedTemplateLiteral([
            "A ",
            ",",
            ",0,0,",
            ",\n        ",
            ",",
            ""
        ])), newRadius[1], newRadius[1], clockWise, x + width, y + ySign * newRadius[1]);
        path += (0, $ff2870262f58b24e$export$f8a24ecc3d6c26c3)($94f5b831b08677d3$var$_templateObject5 || ($94f5b831b08677d3$var$_templateObject5 = $94f5b831b08677d3$var$_taggedTemplateLiteral([
            "L ",
            ",",
            ""
        ])), x + width, y + height - ySign * newRadius[2]);
        if (newRadius[2] > 0) path += (0, $ff2870262f58b24e$export$f8a24ecc3d6c26c3)($94f5b831b08677d3$var$_templateObject6 || ($94f5b831b08677d3$var$_templateObject6 = $94f5b831b08677d3$var$_taggedTemplateLiteral([
            "A ",
            ",",
            ",0,0,",
            ",\n        ",
            ",",
            ""
        ])), newRadius[2], newRadius[2], clockWise, x + width - xSign * newRadius[2], y + height);
        path += (0, $ff2870262f58b24e$export$f8a24ecc3d6c26c3)($94f5b831b08677d3$var$_templateObject7 || ($94f5b831b08677d3$var$_templateObject7 = $94f5b831b08677d3$var$_taggedTemplateLiteral([
            "L ",
            ",",
            ""
        ])), x + xSign * newRadius[3], y + height);
        if (newRadius[3] > 0) path += (0, $ff2870262f58b24e$export$f8a24ecc3d6c26c3)($94f5b831b08677d3$var$_templateObject8 || ($94f5b831b08677d3$var$_templateObject8 = $94f5b831b08677d3$var$_taggedTemplateLiteral([
            "A ",
            ",",
            ",0,0,",
            ",\n        ",
            ",",
            ""
        ])), newRadius[3], newRadius[3], clockWise, x, y + height - ySign * newRadius[3]);
        path += 'Z';
    } else if (maxRadius > 0 && radius === +radius && radius > 0) {
        var _newRadius = Math.min(maxRadius, radius);
        path = (0, $ff2870262f58b24e$export$f8a24ecc3d6c26c3)($94f5b831b08677d3$var$_templateObject9 || ($94f5b831b08677d3$var$_templateObject9 = $94f5b831b08677d3$var$_taggedTemplateLiteral([
            "M ",
            ",",
            "\n            A ",
            ",",
            ",0,0,",
            ",",
            ",",
            "\n            L ",
            ",",
            "\n            A ",
            ",",
            ",0,0,",
            ",",
            ",",
            "\n            L ",
            ",",
            "\n            A ",
            ",",
            ",0,0,",
            ",",
            ",",
            "\n            L ",
            ",",
            "\n            A ",
            ",",
            ",0,0,",
            ",",
            ",",
            " Z"
        ])), x, y + ySign * _newRadius, _newRadius, _newRadius, clockWise, x + xSign * _newRadius, y, x + width - xSign * _newRadius, y, _newRadius, _newRadius, clockWise, x + width, y + ySign * _newRadius, x + width, y + height - ySign * _newRadius, _newRadius, _newRadius, clockWise, x + width - xSign * _newRadius, y + height, x + xSign * _newRadius, y + height, _newRadius, _newRadius, clockWise, x, y + height - ySign * _newRadius);
    } else path = (0, $ff2870262f58b24e$export$f8a24ecc3d6c26c3)($94f5b831b08677d3$var$_templateObject0 || ($94f5b831b08677d3$var$_templateObject0 = $94f5b831b08677d3$var$_taggedTemplateLiteral([
        "M ",
        ",",
        " h ",
        " v ",
        " h ",
        " Z"
    ])), x, y, width, height, -width);
    return path;
};
var $94f5b831b08677d3$export$90e429de6eb3e62f = {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    radius: 0,
    isAnimationActive: false,
    isUpdateAnimationActive: false,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: 'ease'
};
var $94f5b831b08677d3$export$4617fb02663045ef = (rectangleProps)=>{
    var props = (0, $4cc2299923ef69c7$export$45004cc70a390ee8)(rectangleProps, $94f5b831b08677d3$export$90e429de6eb3e62f);
    var pathRef = (0, $kc00y.useRef)(null);
    var [totalLength, setTotalLength] = (0, $kc00y.useState)(-1);
    (0, $kc00y.useEffect)(()=>{
        if (pathRef.current && pathRef.current.getTotalLength) try {
            var pathTotalLength = pathRef.current.getTotalLength();
            if (pathTotalLength) setTotalLength(pathTotalLength);
        } catch (_unused) {
        // calculate total length error
        }
    }, []);
    var { x: x, y: y, width: width, height: height, radius: radius, className: className } = props;
    var { animationEasing: animationEasing, animationDuration: animationDuration, animationBegin: animationBegin, isAnimationActive: isAnimationActive, isUpdateAnimationActive: isUpdateAnimationActive } = props;
    var prevWidthRef = (0, $kc00y.useRef)(width);
    var prevHeightRef = (0, $kc00y.useRef)(height);
    var prevXRef = (0, $kc00y.useRef)(x);
    var prevYRef = (0, $kc00y.useRef)(y);
    var animationIdInput = (0, $kc00y.useMemo)(()=>({
            x: x,
            y: y,
            width: width,
            height: height,
            radius: radius
        }), [
        x,
        y,
        width,
        height,
        radius
    ]);
    var animationId = (0, $706e1fa6aaf57212$export$e1042b2944b80b7f)(animationIdInput, 'rectangle-');
    if (x !== +x || y !== +y || width !== +width || height !== +height || width === 0 || height === 0) return null;
    var layerClass = (0, $328c1c2632e2f292$export$4f5d2d50c9deca37)('recharts-rectangle', className);
    if (!isUpdateAnimationActive) {
        var _svgPropertiesAndEven = (0, $976509d5bd74ee3b$export$67f8fc03e57e2747)(props), { radius: _ } = _svgPropertiesAndEven, otherPathProps = $94f5b831b08677d3$var$_objectWithoutProperties(_svgPropertiesAndEven, $94f5b831b08677d3$var$_excluded);
        return /*#__PURE__*/ $kc00y.createElement("path", $94f5b831b08677d3$var$_extends({}, otherPathProps, {
            x: (0, $ff2870262f58b24e$export$2077e0241d6afd3c)(x),
            y: (0, $ff2870262f58b24e$export$2077e0241d6afd3c)(y),
            width: (0, $ff2870262f58b24e$export$2077e0241d6afd3c)(width),
            height: (0, $ff2870262f58b24e$export$2077e0241d6afd3c)(height),
            radius: typeof radius === 'number' ? radius : undefined,
            className: layerClass,
            d: $94f5b831b08677d3$var$getRectanglePath(x, y, width, height, radius)
        }));
    }
    var prevWidth = prevWidthRef.current;
    var prevHeight = prevHeightRef.current;
    var prevX = prevXRef.current;
    var prevY = prevYRef.current;
    var from = "0px ".concat(totalLength === -1 ? 1 : totalLength, "px");
    var to = "".concat(totalLength, "px ").concat(totalLength, "px");
    var transition = (0, $9353be12f729c74c$export$1594c78389ee3429)([
        'strokeDasharray'
    ], animationDuration, typeof animationEasing === 'string' ? animationEasing : $94f5b831b08677d3$export$90e429de6eb3e62f.animationEasing);
    return /*#__PURE__*/ $kc00y.createElement((0, $a2871794a7a679f0$export$5d41821894c47c52), {
        animationId: animationId,
        key: animationId,
        canBegin: totalLength > 0,
        duration: animationDuration,
        easing: animationEasing,
        isActive: isUpdateAnimationActive,
        begin: animationBegin
    }, (t)=>{
        var currWidth = (0, $7e613228d3a31273$export$89e29e4ab65e70a9)(prevWidth, width, t);
        var currHeight = (0, $7e613228d3a31273$export$89e29e4ab65e70a9)(prevHeight, height, t);
        var currX = (0, $7e613228d3a31273$export$89e29e4ab65e70a9)(prevX, x, t);
        var currY = (0, $7e613228d3a31273$export$89e29e4ab65e70a9)(prevY, y, t);
        if (pathRef.current) {
            prevWidthRef.current = currWidth;
            prevHeightRef.current = currHeight;
            prevXRef.current = currX;
            prevYRef.current = currY;
        }
        var animationStyle;
        if (!isAnimationActive) animationStyle = {
            strokeDasharray: to
        };
        else if (t > 0) animationStyle = {
            transition: transition,
            strokeDasharray: to
        };
        else animationStyle = {
            strokeDasharray: from
        };
        var _svgPropertiesAndEven2 = (0, $976509d5bd74ee3b$export$67f8fc03e57e2747)(props), { radius: _ } = _svgPropertiesAndEven2, otherPathProps = $94f5b831b08677d3$var$_objectWithoutProperties(_svgPropertiesAndEven2, $94f5b831b08677d3$var$_excluded2);
        return /*#__PURE__*/ $kc00y.createElement("path", $94f5b831b08677d3$var$_extends({}, otherPathProps, {
            radius: typeof radius === 'number' ? radius : undefined,
            className: layerClass,
            d: $94f5b831b08677d3$var$getRectanglePath(currX, currY, currWidth, currHeight, radius),
            ref: pathRef,
            style: $94f5b831b08677d3$var$_objectSpread($94f5b831b08677d3$var$_objectSpread({}, animationStyle), props.style)
        }));
    });
};



var $kc00y = parcelRequire("kc00y");








var $d91d30173234abcb$var$_templateObject, $d91d30173234abcb$var$_templateObject2, $d91d30173234abcb$var$_templateObject3, $d91d30173234abcb$var$_templateObject4, $d91d30173234abcb$var$_templateObject5;
function $d91d30173234abcb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d91d30173234abcb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d91d30173234abcb$var$ownKeys(Object(t), !0).forEach(function(r) {
            $d91d30173234abcb$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d91d30173234abcb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $d91d30173234abcb$var$_defineProperty(e, r, t) {
    return (r = $d91d30173234abcb$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $d91d30173234abcb$var$_toPropertyKey(t) {
    var i = $d91d30173234abcb$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $d91d30173234abcb$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $d91d30173234abcb$var$_extends() {
    return $d91d30173234abcb$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $d91d30173234abcb$var$_extends.apply(null, arguments);
}
function $d91d30173234abcb$var$_taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
var $d91d30173234abcb$var$getTrapezoidPath = (x, y, upperWidth, lowerWidth, height)=>{
    var widthGap = upperWidth - lowerWidth;
    var path;
    path = (0, $ff2870262f58b24e$export$f8a24ecc3d6c26c3)($d91d30173234abcb$var$_templateObject || ($d91d30173234abcb$var$_templateObject = $d91d30173234abcb$var$_taggedTemplateLiteral([
        "M ",
        ",",
        ""
    ])), x, y);
    path += (0, $ff2870262f58b24e$export$f8a24ecc3d6c26c3)($d91d30173234abcb$var$_templateObject2 || ($d91d30173234abcb$var$_templateObject2 = $d91d30173234abcb$var$_taggedTemplateLiteral([
        "L ",
        ",",
        ""
    ])), x + upperWidth, y);
    path += (0, $ff2870262f58b24e$export$f8a24ecc3d6c26c3)($d91d30173234abcb$var$_templateObject3 || ($d91d30173234abcb$var$_templateObject3 = $d91d30173234abcb$var$_taggedTemplateLiteral([
        "L ",
        ",",
        ""
    ])), x + upperWidth - widthGap / 2, y + height);
    path += (0, $ff2870262f58b24e$export$f8a24ecc3d6c26c3)($d91d30173234abcb$var$_templateObject4 || ($d91d30173234abcb$var$_templateObject4 = $d91d30173234abcb$var$_taggedTemplateLiteral([
        "L ",
        ",",
        ""
    ])), x + upperWidth - widthGap / 2 - lowerWidth, y + height);
    path += (0, $ff2870262f58b24e$export$f8a24ecc3d6c26c3)($d91d30173234abcb$var$_templateObject5 || ($d91d30173234abcb$var$_templateObject5 = $d91d30173234abcb$var$_taggedTemplateLiteral([
        "L ",
        ",",
        " Z"
    ])), x, y);
    return path;
};
var $d91d30173234abcb$export$d414f170eb9e3706 = {
    x: 0,
    y: 0,
    upperWidth: 0,
    lowerWidth: 0,
    height: 0,
    isUpdateAnimationActive: false,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: 'ease'
};
var $d91d30173234abcb$export$d1ed33dc592f5337 = (outsideProps)=>{
    var trapezoidProps = (0, $4cc2299923ef69c7$export$45004cc70a390ee8)(outsideProps, $d91d30173234abcb$export$d414f170eb9e3706);
    var { x: x, y: y, upperWidth: upperWidth, lowerWidth: lowerWidth, height: height, className: className } = trapezoidProps;
    var { animationEasing: animationEasing, animationDuration: animationDuration, animationBegin: animationBegin, isUpdateAnimationActive: isUpdateAnimationActive } = trapezoidProps;
    var pathRef = (0, $kc00y.useRef)(null);
    var [totalLength, setTotalLength] = (0, $kc00y.useState)(-1);
    var prevUpperWidthRef = (0, $kc00y.useRef)(upperWidth);
    var prevLowerWidthRef = (0, $kc00y.useRef)(lowerWidth);
    var prevHeightRef = (0, $kc00y.useRef)(height);
    var prevXRef = (0, $kc00y.useRef)(x);
    var prevYRef = (0, $kc00y.useRef)(y);
    var animationId = (0, $706e1fa6aaf57212$export$e1042b2944b80b7f)(outsideProps, 'trapezoid-');
    (0, $kc00y.useEffect)(()=>{
        if (pathRef.current && pathRef.current.getTotalLength) try {
            var pathTotalLength = pathRef.current.getTotalLength();
            if (pathTotalLength) setTotalLength(pathTotalLength);
        } catch (_unused) {
        // calculate total length error
        }
    }, []);
    if (x !== +x || y !== +y || upperWidth !== +upperWidth || lowerWidth !== +lowerWidth || height !== +height || upperWidth === 0 && lowerWidth === 0 || height === 0) return null;
    var layerClass = (0, $328c1c2632e2f292$export$4f5d2d50c9deca37)('recharts-trapezoid', className);
    if (!isUpdateAnimationActive) return /*#__PURE__*/ $kc00y.createElement("g", null, /*#__PURE__*/ $kc00y.createElement("path", $d91d30173234abcb$var$_extends({}, (0, $976509d5bd74ee3b$export$67f8fc03e57e2747)(trapezoidProps), {
        className: layerClass,
        d: $d91d30173234abcb$var$getTrapezoidPath(x, y, upperWidth, lowerWidth, height)
    })));
    var prevUpperWidth = prevUpperWidthRef.current;
    var prevLowerWidth = prevLowerWidthRef.current;
    var prevHeight = prevHeightRef.current;
    var prevX = prevXRef.current;
    var prevY = prevYRef.current;
    var from = "0px ".concat(totalLength === -1 ? 1 : totalLength, "px");
    var to = "".concat(totalLength, "px ").concat(totalLength, "px");
    var transition = (0, $9353be12f729c74c$export$1594c78389ee3429)([
        'strokeDasharray'
    ], animationDuration, animationEasing);
    return /*#__PURE__*/ $kc00y.createElement((0, $a2871794a7a679f0$export$5d41821894c47c52), {
        animationId: animationId,
        key: animationId,
        canBegin: totalLength > 0,
        duration: animationDuration,
        easing: animationEasing,
        isActive: isUpdateAnimationActive,
        begin: animationBegin
    }, (t)=>{
        var currUpperWidth = (0, $7e613228d3a31273$export$89e29e4ab65e70a9)(prevUpperWidth, upperWidth, t);
        var currLowerWidth = (0, $7e613228d3a31273$export$89e29e4ab65e70a9)(prevLowerWidth, lowerWidth, t);
        var currHeight = (0, $7e613228d3a31273$export$89e29e4ab65e70a9)(prevHeight, height, t);
        var currX = (0, $7e613228d3a31273$export$89e29e4ab65e70a9)(prevX, x, t);
        var currY = (0, $7e613228d3a31273$export$89e29e4ab65e70a9)(prevY, y, t);
        if (pathRef.current) {
            prevUpperWidthRef.current = currUpperWidth;
            prevLowerWidthRef.current = currLowerWidth;
            prevHeightRef.current = currHeight;
            prevXRef.current = currX;
            prevYRef.current = currY;
        }
        var animationStyle = t > 0 ? {
            transition: transition,
            strokeDasharray: to
        } : {
            strokeDasharray: from
        };
        return /*#__PURE__*/ $kc00y.createElement("path", $d91d30173234abcb$var$_extends({}, (0, $976509d5bd74ee3b$export$67f8fc03e57e2747)(trapezoidProps), {
            className: layerClass,
            d: $d91d30173234abcb$var$getTrapezoidPath(currX, currY, currUpperWidth, currLowerWidth, currHeight),
            ref: pathRef,
            style: $d91d30173234abcb$var$_objectSpread($d91d30173234abcb$var$_objectSpread({}, animationStyle), trapezoidProps.style)
        }));
    });
};



var $kc00y = parcelRequire("kc00y");






var $704464b332847712$var$_templateObject, $704464b332847712$var$_templateObject2, $704464b332847712$var$_templateObject3, $704464b332847712$var$_templateObject4, $704464b332847712$var$_templateObject5, $704464b332847712$var$_templateObject6, $704464b332847712$var$_templateObject7;
function $704464b332847712$var$_extends() {
    return $704464b332847712$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $704464b332847712$var$_extends.apply(null, arguments);
}
function $704464b332847712$var$_taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
var $704464b332847712$var$getDeltaAngle = (startAngle, endAngle)=>{
    var sign = (0, $7e613228d3a31273$export$9d334328eb75e624)(endAngle - startAngle);
    var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 359.999);
    return sign * deltaAngle;
};
var $704464b332847712$var$getTangentCircle = (_ref)=>{
    var { cx: cx, cy: cy, radius: radius, angle: angle, sign: sign, isExternal: isExternal, cornerRadius: cornerRadius, cornerIsExternal: cornerIsExternal } = _ref;
    var centerRadius = cornerRadius * (isExternal ? 1 : -1) + radius;
    var theta = Math.asin(cornerRadius / centerRadius) / (0, $68befda7de8b3621$export$d74e8f7e9cc3fed3);
    var centerAngle = cornerIsExternal ? angle : angle + sign * theta;
    var center = (0, $68befda7de8b3621$export$5c9a959bb3fc7749)(cx, cy, centerRadius, centerAngle);
    // The coordinate of point which is tangent to the circle
    var circleTangency = (0, $68befda7de8b3621$export$5c9a959bb3fc7749)(cx, cy, radius, centerAngle);
    // The coordinate of point which is tangent to the radius line
    var lineTangencyAngle = cornerIsExternal ? angle - sign * theta : angle;
    var lineTangency = (0, $68befda7de8b3621$export$5c9a959bb3fc7749)(cx, cy, centerRadius * Math.cos(theta * (0, $68befda7de8b3621$export$d74e8f7e9cc3fed3)), lineTangencyAngle);
    return {
        center: center,
        circleTangency: circleTangency,
        lineTangency: lineTangency,
        theta: theta
    };
};
var $704464b332847712$var$getSectorPath = (_ref2)=>{
    var { cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius, startAngle: startAngle, endAngle: endAngle } = _ref2;
    var angle = $704464b332847712$var$getDeltaAngle(startAngle, endAngle);
    // When the angle of sector equals to 360, star point and end point coincide
    var tempEndAngle = startAngle + angle;
    var outerStartPoint = (0, $68befda7de8b3621$export$5c9a959bb3fc7749)(cx, cy, outerRadius, startAngle);
    var outerEndPoint = (0, $68befda7de8b3621$export$5c9a959bb3fc7749)(cx, cy, outerRadius, tempEndAngle);
    var path = (0, $ff2870262f58b24e$export$f8a24ecc3d6c26c3)($704464b332847712$var$_templateObject || ($704464b332847712$var$_templateObject = $704464b332847712$var$_taggedTemplateLiteral([
        "M ",
        ",",
        "\n    A ",
        ",",
        ",0,\n    ",
        ",",
        ",\n    ",
        ",",
        "\n  "
    ])), outerStartPoint.x, outerStartPoint.y, outerRadius, outerRadius, +(Math.abs(angle) > 180), +(startAngle > tempEndAngle), outerEndPoint.x, outerEndPoint.y);
    if (innerRadius > 0) {
        var innerStartPoint = (0, $68befda7de8b3621$export$5c9a959bb3fc7749)(cx, cy, innerRadius, startAngle);
        var innerEndPoint = (0, $68befda7de8b3621$export$5c9a959bb3fc7749)(cx, cy, innerRadius, tempEndAngle);
        path += (0, $ff2870262f58b24e$export$f8a24ecc3d6c26c3)($704464b332847712$var$_templateObject2 || ($704464b332847712$var$_templateObject2 = $704464b332847712$var$_taggedTemplateLiteral([
            "L ",
            ",",
            "\n            A ",
            ",",
            ",0,\n            ",
            ",",
            ",\n            ",
            ",",
            " Z"
        ])), innerEndPoint.x, innerEndPoint.y, innerRadius, innerRadius, +(Math.abs(angle) > 180), +(startAngle <= tempEndAngle), innerStartPoint.x, innerStartPoint.y);
    } else path += (0, $ff2870262f58b24e$export$f8a24ecc3d6c26c3)($704464b332847712$var$_templateObject3 || ($704464b332847712$var$_templateObject3 = $704464b332847712$var$_taggedTemplateLiteral([
        "L ",
        ",",
        " Z"
    ])), cx, cy);
    return path;
};
var $704464b332847712$var$getSectorWithCorner = (_ref3)=>{
    var { cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius, cornerRadius: cornerRadius, forceCornerRadius: forceCornerRadius, cornerIsExternal: cornerIsExternal, startAngle: startAngle, endAngle: endAngle } = _ref3;
    var sign = (0, $7e613228d3a31273$export$9d334328eb75e624)(endAngle - startAngle);
    var { circleTangency: soct, lineTangency: solt, theta: sot } = $704464b332847712$var$getTangentCircle({
        cx: cx,
        cy: cy,
        radius: outerRadius,
        angle: startAngle,
        sign: sign,
        cornerRadius: cornerRadius,
        cornerIsExternal: cornerIsExternal
    });
    var { circleTangency: eoct, lineTangency: eolt, theta: eot } = $704464b332847712$var$getTangentCircle({
        cx: cx,
        cy: cy,
        radius: outerRadius,
        angle: endAngle,
        sign: -sign,
        cornerRadius: cornerRadius,
        cornerIsExternal: cornerIsExternal
    });
    var outerArcAngle = cornerIsExternal ? Math.abs(startAngle - endAngle) : Math.abs(startAngle - endAngle) - sot - eot;
    if (outerArcAngle < 0) {
        if (forceCornerRadius) return (0, $ff2870262f58b24e$export$f8a24ecc3d6c26c3)($704464b332847712$var$_templateObject4 || ($704464b332847712$var$_templateObject4 = $704464b332847712$var$_taggedTemplateLiteral([
            "M ",
            ",",
            "\n        a",
            ",",
            ",0,0,1,",
            ",0\n        a",
            ",",
            ",0,0,1,",
            ",0\n      "
        ])), solt.x, solt.y, cornerRadius, cornerRadius, cornerRadius * 2, cornerRadius, cornerRadius, -cornerRadius * 2);
        return $704464b332847712$var$getSectorPath({
            cx: cx,
            cy: cy,
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            startAngle: startAngle,
            endAngle: endAngle
        });
    }
    var path = (0, $ff2870262f58b24e$export$f8a24ecc3d6c26c3)($704464b332847712$var$_templateObject5 || ($704464b332847712$var$_templateObject5 = $704464b332847712$var$_taggedTemplateLiteral([
        "M ",
        ",",
        "\n    A",
        ",",
        ",0,0,",
        ",",
        ",",
        "\n    A",
        ",",
        ",0,",
        ",",
        ",",
        ",",
        "\n    A",
        ",",
        ",0,0,",
        ",",
        ",",
        "\n  "
    ])), solt.x, solt.y, cornerRadius, cornerRadius, +(sign < 0), soct.x, soct.y, outerRadius, outerRadius, +(outerArcAngle > 180), +(sign < 0), eoct.x, eoct.y, cornerRadius, cornerRadius, +(sign < 0), eolt.x, eolt.y);
    if (innerRadius > 0) {
        var { circleTangency: sict, lineTangency: silt, theta: sit } = $704464b332847712$var$getTangentCircle({
            cx: cx,
            cy: cy,
            radius: innerRadius,
            angle: startAngle,
            sign: sign,
            isExternal: true,
            cornerRadius: cornerRadius,
            cornerIsExternal: cornerIsExternal
        });
        var { circleTangency: eict, lineTangency: eilt, theta: eit } = $704464b332847712$var$getTangentCircle({
            cx: cx,
            cy: cy,
            radius: innerRadius,
            angle: endAngle,
            sign: -sign,
            isExternal: true,
            cornerRadius: cornerRadius,
            cornerIsExternal: cornerIsExternal
        });
        var innerArcAngle = cornerIsExternal ? Math.abs(startAngle - endAngle) : Math.abs(startAngle - endAngle) - sit - eit;
        if (innerArcAngle < 0 && cornerRadius === 0) return "".concat(path, "L").concat(cx, ",").concat(cy, "Z");
        path += (0, $ff2870262f58b24e$export$f8a24ecc3d6c26c3)($704464b332847712$var$_templateObject6 || ($704464b332847712$var$_templateObject6 = $704464b332847712$var$_taggedTemplateLiteral([
            "L",
            ",",
            "\n      A",
            ",",
            ",0,0,",
            ",",
            ",",
            "\n      A",
            ",",
            ",0,",
            ",",
            ",",
            ",",
            "\n      A",
            ",",
            ",0,0,",
            ",",
            ",",
            "Z"
        ])), eilt.x, eilt.y, cornerRadius, cornerRadius, +(sign < 0), eict.x, eict.y, innerRadius, innerRadius, +(innerArcAngle > 180), +(sign > 0), sict.x, sict.y, cornerRadius, cornerRadius, +(sign < 0), silt.x, silt.y);
    } else path += (0, $ff2870262f58b24e$export$f8a24ecc3d6c26c3)($704464b332847712$var$_templateObject7 || ($704464b332847712$var$_templateObject7 = $704464b332847712$var$_taggedTemplateLiteral([
        "L",
        ",",
        "Z"
    ])), cx, cy);
    return path;
};
var $704464b332847712$export$1d63e9c2e020b2a7 = {
    cx: 0,
    cy: 0,
    innerRadius: 0,
    outerRadius: 0,
    startAngle: 0,
    endAngle: 0,
    cornerRadius: 0,
    forceCornerRadius: false,
    cornerIsExternal: false
};
var $704464b332847712$export$e98c2c7eb2b14f45 = (sectorProps)=>{
    var props = (0, $4cc2299923ef69c7$export$45004cc70a390ee8)(sectorProps, $704464b332847712$export$1d63e9c2e020b2a7);
    var { cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius, cornerRadius: cornerRadius, forceCornerRadius: forceCornerRadius, cornerIsExternal: cornerIsExternal, startAngle: startAngle, endAngle: endAngle, className: className } = props;
    if (outerRadius < innerRadius || startAngle === endAngle) return null;
    var layerClass = (0, $328c1c2632e2f292$export$4f5d2d50c9deca37)('recharts-sector', className);
    var deltaRadius = outerRadius - innerRadius;
    var cr = (0, $7e613228d3a31273$export$476354dbf49bdff6)(cornerRadius, deltaRadius, 0, true);
    var path;
    if (cr > 0 && Math.abs(startAngle - endAngle) < 360) path = $704464b332847712$var$getSectorWithCorner({
        cx: cx,
        cy: cy,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        cornerRadius: Math.min(cr, deltaRadius / 2),
        forceCornerRadius: forceCornerRadius,
        cornerIsExternal: cornerIsExternal,
        startAngle: startAngle,
        endAngle: endAngle
    });
    else path = $704464b332847712$var$getSectorPath({
        cx: cx,
        cy: cy,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        startAngle: startAngle,
        endAngle: endAngle
    });
    return /*#__PURE__*/ $kc00y.createElement("path", $704464b332847712$var$_extends({}, (0, $976509d5bd74ee3b$export$67f8fc03e57e2747)(props), {
        className: layerClass,
        d: path
    }));
};




var $kc00y = parcelRequire("kc00y");




var $351bfb356f5de2bf$var$_excluded = [
    "type",
    "size",
    "sizeType"
];
function $351bfb356f5de2bf$var$_extends() {
    return $351bfb356f5de2bf$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $351bfb356f5de2bf$var$_extends.apply(null, arguments);
}
function $351bfb356f5de2bf$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $351bfb356f5de2bf$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $351bfb356f5de2bf$var$ownKeys(Object(t), !0).forEach(function(r) {
            $351bfb356f5de2bf$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $351bfb356f5de2bf$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $351bfb356f5de2bf$var$_defineProperty(e, r, t) {
    return (r = $351bfb356f5de2bf$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $351bfb356f5de2bf$var$_toPropertyKey(t) {
    var i = $351bfb356f5de2bf$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $351bfb356f5de2bf$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $351bfb356f5de2bf$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $351bfb356f5de2bf$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $351bfb356f5de2bf$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $351bfb356f5de2bf$var$symbolFactories = {
    symbolCircle: $c8882fdadeb362fe$export$2e2bcd8739ae039,
    symbolCross: $79ca076583b28339$export$2e2bcd8739ae039,
    symbolDiamond: $164bf7863e3e7933$export$2e2bcd8739ae039,
    symbolSquare: $fa4fa3288f6b6774$export$2e2bcd8739ae039,
    symbolStar: $6be529173db11894$export$2e2bcd8739ae039,
    symbolTriangle: $614f5ceb002dd477$export$2e2bcd8739ae039,
    symbolWye: $e6bac68a16fbfab8$export$2e2bcd8739ae039
};
var $351bfb356f5de2bf$var$RADIAN = Math.PI / 180;
var $351bfb356f5de2bf$var$getSymbolFactory = (type)=>{
    var name = "symbol".concat((0, $7e613228d3a31273$export$3061f22cd819074d)(type));
    return $351bfb356f5de2bf$var$symbolFactories[name] || (0, $c8882fdadeb362fe$export$2e2bcd8739ae039);
};
var $351bfb356f5de2bf$var$calculateAreaSize = (size, sizeType, type)=>{
    if (sizeType === 'area') return size;
    switch(type){
        case 'cross':
            return 5 * size * size / 9;
        case 'diamond':
            return 0.5 * size * size / Math.sqrt(3);
        case 'square':
            return size * size;
        case 'star':
            var angle = 18 * $351bfb356f5de2bf$var$RADIAN;
            return 1.25 * size * size * (Math.tan(angle) - Math.tan(angle * 2) * Math.tan(angle) ** 2);
        case 'triangle':
            return Math.sqrt(3) * size * size / 4;
        case 'wye':
            return (21 - 10 * Math.sqrt(3)) * size * size / 8;
        default:
            return Math.PI * size * size / 4;
    }
};
var $351bfb356f5de2bf$var$registerSymbol = (key, factory)=>{
    $351bfb356f5de2bf$var$symbolFactories["symbol".concat((0, $7e613228d3a31273$export$3061f22cd819074d)(key))] = factory;
};
var $351bfb356f5de2bf$export$fa456266707bf4e4 = (_ref)=>{
    var { type: type = 'circle', size: size = 64, sizeType: sizeType = 'area' } = _ref, rest = $351bfb356f5de2bf$var$_objectWithoutProperties(_ref, $351bfb356f5de2bf$var$_excluded);
    var props = $351bfb356f5de2bf$var$_objectSpread($351bfb356f5de2bf$var$_objectSpread({}, rest), {}, {
        type: type,
        size: size,
        sizeType: sizeType
    });
    var realType = 'circle';
    if (typeof type === 'string') /*
     * Our type guard is not as strong as it could be (i.e. non-existent),
     * and so despite the typescript type saying that `type` is a `SymbolType`,
     * we can get numbers or really anything, so let's have a runtime check here to fix the exception.
     *
     * https://github.com/recharts/recharts/issues/6197
     */ realType = type;
    /**
   * Calculate the path of curve
   * @return {String} path
   */ var getPath = ()=>{
        var symbolFactory = $351bfb356f5de2bf$var$getSymbolFactory(realType);
        var symbol = (0, $dc048593b18773f6$export$2e2bcd8739ae039)().type(symbolFactory).size($351bfb356f5de2bf$var$calculateAreaSize(size, sizeType, realType));
        var s = symbol();
        if (s === null) return undefined;
        return s;
    };
    var { className: className, cx: cx, cy: cy } = props;
    var filteredProps = (0, $976509d5bd74ee3b$export$67f8fc03e57e2747)(props);
    if ((0, $7e613228d3a31273$export$7e4aa119212bc614)(cx) && (0, $7e613228d3a31273$export$7e4aa119212bc614)(cy) && (0, $7e613228d3a31273$export$7e4aa119212bc614)(size)) return /*#__PURE__*/ $kc00y.createElement("path", $351bfb356f5de2bf$var$_extends({}, filteredProps, {
        className: (0, $328c1c2632e2f292$export$4f5d2d50c9deca37)('recharts-symbols', className),
        transform: "translate(".concat(cx, ", ").concat(cy, ")"),
        d: getPath()
    }));
    return null;
};
$351bfb356f5de2bf$export$fa456266707bf4e4.registerSymbol = $351bfb356f5de2bf$var$registerSymbol;



var $kc00y = parcelRequire("kc00y");







function $75a56cb375d58ce0$var$_extends() {
    return $75a56cb375d58ce0$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $75a56cb375d58ce0$var$_extends.apply(null, arguments);
}
function $75a56cb375d58ce0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $75a56cb375d58ce0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $75a56cb375d58ce0$var$ownKeys(Object(t), !0).forEach(function(r) {
            $75a56cb375d58ce0$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $75a56cb375d58ce0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $75a56cb375d58ce0$var$_defineProperty(e, r, t) {
    return (r = $75a56cb375d58ce0$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $75a56cb375d58ce0$var$_toPropertyKey(t) {
    var i = $75a56cb375d58ce0$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $75a56cb375d58ce0$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $75a56cb375d58ce0$var$CURVE_FACTORIES = {
    curveBasisClosed: $3f51c10e496e6580$export$2e2bcd8739ae039,
    curveBasisOpen: $5463950ad1a5ebab$export$2e2bcd8739ae039,
    curveBasis: $67656591682391bd$export$2e2bcd8739ae039,
    curveBumpX: $aa272852b3320cba$export$2c099b5096f70ce6,
    curveBumpY: $aa272852b3320cba$export$908da9dfa54cbed6,
    curveLinearClosed: $c042af09362cfa07$export$2e2bcd8739ae039,
    curveLinear: $d8de2f04944e454f$export$2e2bcd8739ae039,
    curveMonotoneX: $afccb685e7d2163d$export$99563b5420dbdc55,
    curveMonotoneY: $afccb685e7d2163d$export$8b5360456d6bdb88,
    curveNatural: $008b7d2588675efe$export$2e2bcd8739ae039,
    curveStep: $89adf66c31c27895$export$2e2bcd8739ae039,
    curveStepAfter: $89adf66c31c27895$export$793b3db073781cbb,
    curveStepBefore: $89adf66c31c27895$export$10eafa5b7478b343
};
/**
 * @inline
 */ /**
 * @inline
 */ var $75a56cb375d58ce0$var$defined = (p)=>(0, $22869ac8a5888437$export$f8a8fc612ced9bb0)(p.x) && (0, $22869ac8a5888437$export$f8a8fc612ced9bb0)(p.y);
var $75a56cb375d58ce0$var$areaDefined = (d)=>d.base != null && $75a56cb375d58ce0$var$defined(d.base) && $75a56cb375d58ce0$var$defined(d);
var $75a56cb375d58ce0$var$getX = (p)=>p.x;
var $75a56cb375d58ce0$var$getY = (p)=>p.y;
var $75a56cb375d58ce0$var$getCurveFactory = (type, layout)=>{
    if (typeof type === 'function') return type;
    var name = "curve".concat((0, $7e613228d3a31273$export$3061f22cd819074d)(type));
    if ((name === 'curveMonotone' || name === 'curveBump') && layout) {
        var factory = $75a56cb375d58ce0$var$CURVE_FACTORIES["".concat(name).concat(layout === 'vertical' ? 'Y' : 'X')];
        if (factory) return factory;
    }
    return $75a56cb375d58ce0$var$CURVE_FACTORIES[name] || (0, $d8de2f04944e454f$export$2e2bcd8739ae039);
};
var $75a56cb375d58ce0$export$4ad7f9093e086ed7 = {
    connectNulls: false,
    type: 'linear'
};
var $75a56cb375d58ce0$export$2aa3fd96c49a84a8 = (_ref)=>{
    var { type: type = $75a56cb375d58ce0$export$4ad7f9093e086ed7.type, points: points = [], baseLine: baseLine, layout: layout, connectNulls: connectNulls = $75a56cb375d58ce0$export$4ad7f9093e086ed7.connectNulls } = _ref;
    var curveFactory = $75a56cb375d58ce0$var$getCurveFactory(type, layout);
    var formatPoints = connectNulls ? points.filter($75a56cb375d58ce0$var$defined) : points;
    // When dealing with an area chart (where `baseLine` is an array),
    // we need to pair points with their corresponding `baseLine` points first.
    // This is to ensure that we filter points and their baseline counterparts together,
    // preventing errors from mismatched array lengths and ensuring `defined` checks both.
    if (Array.isArray(baseLine)) {
        var _lineFunction;
        var areaPoints = points.map((entry, index)=>$75a56cb375d58ce0$var$_objectSpread($75a56cb375d58ce0$var$_objectSpread({}, entry), {}, {
                base: baseLine[index]
            }));
        if (layout === 'vertical') _lineFunction = (0, $cc30502eae8058df$export$2e2bcd8739ae039)().y($75a56cb375d58ce0$var$getY).x1($75a56cb375d58ce0$var$getX).x0((d)=>d.base.x);
        else _lineFunction = (0, $cc30502eae8058df$export$2e2bcd8739ae039)().x($75a56cb375d58ce0$var$getX).y1($75a56cb375d58ce0$var$getY).y0((d)=>d.base.y);
        /*
     * What happens here is that the `.defined()` call will make it so that this function can accept
     * nullable points, and internally it will filter them out and skip when generating the path.
     * So on the input it accepts NullableCoordinate, but it never calls getX/getY on null points because of the defined() filter.
     *
     * The d3 type definition has only one generic so it doesn't allow to describe this properly.
     * However. d3 types are mutable, but we can pretend that they are not, and we can pretend
     * that calling defined() returns a new function with a different generic type.
     */ // @ts-expect-error the defined call changes the generic type internally but d3 types don't reflect that
        var _nullableLineFunction = _lineFunction.defined($75a56cb375d58ce0$var$areaDefined).curve(curveFactory);
        var finalPoints = connectNulls ? areaPoints.filter($75a56cb375d58ce0$var$areaDefined) : areaPoints;
        return _nullableLineFunction(finalPoints);
    }
    var lineFunction;
    if (layout === 'vertical' && (0, $7e613228d3a31273$export$7e4aa119212bc614)(baseLine)) lineFunction = (0, $cc30502eae8058df$export$2e2bcd8739ae039)().y($75a56cb375d58ce0$var$getY).x1($75a56cb375d58ce0$var$getX).x0(baseLine);
    else if ((0, $7e613228d3a31273$export$7e4aa119212bc614)(baseLine)) lineFunction = (0, $cc30502eae8058df$export$2e2bcd8739ae039)().x($75a56cb375d58ce0$var$getX).y1($75a56cb375d58ce0$var$getY).y0(baseLine);
    else lineFunction = (0, $8b3a009f69133aa3$export$2e2bcd8739ae039)().x($75a56cb375d58ce0$var$getX).y($75a56cb375d58ce0$var$getY);
    // @ts-expect-error the defined call changes the generic type internally but d3 types don't reflect that
    var nullableLineFunction = lineFunction.defined($75a56cb375d58ce0$var$defined).curve(curveFactory);
    return nullableLineFunction(formatPoints);
};
var $75a56cb375d58ce0$export$b0e83c3ef8d2db1 = (props)=>{
    var { className: className, points: points, path: path, pathRef: pathRef } = props;
    var layout = (0, $f4c9341f05a18477$export$970c79ecc7081cc)();
    if ((!points || !points.length) && !path) return null;
    var getPathInput = {
        type: props.type,
        points: props.points,
        baseLine: props.baseLine,
        layout: props.layout || layout,
        connectNulls: props.connectNulls
    };
    var realPath = points && points.length ? $75a56cb375d58ce0$export$2aa3fd96c49a84a8(getPathInput) : path;
    return /*#__PURE__*/ $kc00y.createElement("path", $75a56cb375d58ce0$var$_extends({}, (0, $34cf66bbb2aff04f$export$8b56257912140094)(props), (0, $435e27a3bdb96447$export$7c4c290a4a9c1b1e)(props), {
        className: (0, $328c1c2632e2f292$export$4f5d2d50c9deca37)('recharts-curve', className),
        d: realPath === null ? undefined : realPath,
        ref: pathRef
    }));
};


var $92586c98c87e3a95$var$_excluded = [
    "option",
    "shapeType",
    "activeClassName",
    "inActiveClassName"
];
function $92586c98c87e3a95$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $92586c98c87e3a95$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $92586c98c87e3a95$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $92586c98c87e3a95$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $92586c98c87e3a95$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $92586c98c87e3a95$var$ownKeys(Object(t), !0).forEach(function(r) {
            $92586c98c87e3a95$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $92586c98c87e3a95$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $92586c98c87e3a95$var$_defineProperty(e, r, t) {
    return (r = $92586c98c87e3a95$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $92586c98c87e3a95$var$_toPropertyKey(t) {
    var i = $92586c98c87e3a95$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $92586c98c87e3a95$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
/**
 * This is an abstraction for rendering a user defined prop for a customized shape in several forms.
 *
 * <Shape /> is the root and will handle taking in:
 *  - an object of svg properties
 *  - a boolean
 *  - a render prop(inline function that returns jsx)
 *  - a React element
 *
 * <ShapeSelector /> is a subcomponent of <Shape /> and used to match a component
 * to the value of props.shapeType that is passed to the root.
 *
 */ function $92586c98c87e3a95$var$defaultPropTransformer(option, props) {
    return $92586c98c87e3a95$var$_objectSpread($92586c98c87e3a95$var$_objectSpread({}, props), option);
}
function $92586c98c87e3a95$var$isSymbolsProps(shapeType, _elementProps) {
    return shapeType === 'symbols';
}
function $92586c98c87e3a95$var$ShapeSelector(_ref) {
    var { shapeType: shapeType, elementProps: elementProps } = _ref;
    switch(shapeType){
        case 'rectangle':
            return /*#__PURE__*/ $kc00y.createElement((0, $94f5b831b08677d3$export$4617fb02663045ef), elementProps);
        case 'trapezoid':
            return /*#__PURE__*/ $kc00y.createElement((0, $d91d30173234abcb$export$d1ed33dc592f5337), elementProps);
        case 'sector':
            return /*#__PURE__*/ $kc00y.createElement((0, $704464b332847712$export$e98c2c7eb2b14f45), elementProps);
        case 'symbols':
            if ($92586c98c87e3a95$var$isSymbolsProps(shapeType, elementProps)) return /*#__PURE__*/ $kc00y.createElement((0, $351bfb356f5de2bf$export$fa456266707bf4e4), elementProps);
            break;
        case 'curve':
            return /*#__PURE__*/ $kc00y.createElement((0, $75a56cb375d58ce0$export$b0e83c3ef8d2db1), elementProps);
        default:
            return null;
    }
}
function $92586c98c87e3a95$export$33c4f706a443da24(option) {
    if (/*#__PURE__*/ (0, $kc00y.isValidElement)(option)) return option.props;
    return option;
}
function $92586c98c87e3a95$export$6428a7f2611ef1fa(_ref2) {
    var { option: option, shapeType: shapeType, activeClassName: activeClassName = 'recharts-active-shape', inActiveClassName: inActiveClassName = 'recharts-shape' } = _ref2, props = $92586c98c87e3a95$var$_objectWithoutProperties(_ref2, $92586c98c87e3a95$var$_excluded);
    var shape;
    if (/*#__PURE__*/ (0, $kc00y.isValidElement)(option)) // @ts-expect-error we can't know the type of cloned element props
    shape = /*#__PURE__*/ (0, $kc00y.cloneElement)(option, $92586c98c87e3a95$var$_objectSpread($92586c98c87e3a95$var$_objectSpread({}, props), $92586c98c87e3a95$export$33c4f706a443da24(option)));
    else if (typeof option === 'function') shape = option(props, props.index);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($5a1c73d780a13b61$exports)))(option) && typeof option !== 'boolean') {
        var nextProps = $92586c98c87e3a95$var$defaultPropTransformer(option, props);
        shape = /*#__PURE__*/ $kc00y.createElement($92586c98c87e3a95$var$ShapeSelector, {
            shapeType: shapeType,
            elementProps: nextProps
        });
    } else {
        var elementProps = props;
        shape = /*#__PURE__*/ $kc00y.createElement($92586c98c87e3a95$var$ShapeSelector, {
            shapeType: shapeType,
            elementProps: elementProps
        });
    }
    if (props.isActive) return /*#__PURE__*/ $kc00y.createElement((0, $553c02c7047f2968$export$936d0764594b6eb3), {
        className: activeClassName
    }, shape);
    return /*#__PURE__*/ $kc00y.createElement((0, $553c02c7047f2968$export$936d0764594b6eb3), {
        className: inActiveClassName
    }, shape);
}



function $4b9606aec568c4dd$var$_extends() {
    return $4b9606aec568c4dd$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $4b9606aec568c4dd$var$_extends.apply(null, arguments);
}
function $4b9606aec568c4dd$export$f19074a6842f9217(props) {
    return /*#__PURE__*/ $kc00y.createElement((0, $92586c98c87e3a95$export$6428a7f2611ef1fa), $4b9606aec568c4dd$var$_extends({
        shapeType: "rectangle",
        activeClassName: "recharts-active-bar",
        inActiveClassName: "recharts-inactive-bar"
    }, props));
}
var $4b9606aec568c4dd$export$c20d73790de171f0 = function minPointSizeCallback(minPointSize) {
    var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return (value, index)=>{
        if ((0, $7e613228d3a31273$export$7e4aa119212bc614)(minPointSize)) return minPointSize;
        var isValueNumberOrNil = (0, $7e613228d3a31273$export$7e4aa119212bc614)(value) || (0, $7e613228d3a31273$export$b931b78cbb3caf86)(value);
        if (isValueNumberOrNil) return minPointSize(value, index);
        !isValueNumberOrNil && (0, $5e5c9f2b3ce253bc$export$2e2bcd8739ae039)(false, "minPointSize callback function received a value with type of ".concat(typeof value, ". Currently only numbers or null/undefined are supported."));
        return defaultValue;
    };
};





var $2bfb679c145bcb6f$export$66f2ad380b6acece = {
    active: false,
    index: null,
    dataKey: undefined,
    graphicalItemId: undefined,
    coordinate: undefined
};
var $2bfb679c145bcb6f$export$d4c72bab9d6cc13a = {
    itemInteraction: {
        click: $2bfb679c145bcb6f$export$66f2ad380b6acece,
        hover: $2bfb679c145bcb6f$export$66f2ad380b6acece
    },
    axisInteraction: {
        click: $2bfb679c145bcb6f$export$66f2ad380b6acece,
        hover: $2bfb679c145bcb6f$export$66f2ad380b6acece
    },
    keyboardInteraction: $2bfb679c145bcb6f$export$66f2ad380b6acece,
    syncInteraction: {
        active: false,
        index: null,
        dataKey: undefined,
        label: undefined,
        coordinate: undefined,
        sourceViewBox: undefined,
        graphicalItemId: undefined
    },
    tooltipItemPayloads: [],
    settings: {
        shared: undefined,
        trigger: 'hover',
        axisId: 0,
        active: false,
        defaultIndex: undefined
    }
};
/**
 * This is the event we get when user is interacting with a specific graphical item.
 */ /**
 * Keyboard interaction payload has no graphical item ID,
 * and no dataKey, because keyboard interaction is always
 * with the whole chart, not with a specific graphical item.
 */ var $2bfb679c145bcb6f$var$tooltipSlice = (0, $df8b6ce3f4df1ba5$export$4d8d9bd83c24ae8b)({
    name: 'tooltip',
    initialState: $2bfb679c145bcb6f$export$d4c72bab9d6cc13a,
    reducers: {
        addTooltipEntrySettings: {
            reducer (state, action) {
                state.tooltipItemPayloads.push((0, $808ce0820c1669b6$export$c05b21e3257751e5)(action.payload));
            },
            prepare: (0, $df8b6ce3f4df1ba5$export$39fcd5145ec5e4e2)()
        },
        replaceTooltipEntrySettings: {
            reducer (state, action) {
                var { prev: prev, next: next } = action.payload;
                var index = (0, $e922645e3176d997$export$97aac956da55dae9)(state).tooltipItemPayloads.indexOf((0, $808ce0820c1669b6$export$c05b21e3257751e5)(prev));
                if (index > -1) state.tooltipItemPayloads[index] = (0, $808ce0820c1669b6$export$c05b21e3257751e5)(next);
            },
            prepare: (0, $df8b6ce3f4df1ba5$export$39fcd5145ec5e4e2)()
        },
        removeTooltipEntrySettings: {
            reducer (state, action) {
                var index = (0, $e922645e3176d997$export$97aac956da55dae9)(state).tooltipItemPayloads.indexOf((0, $808ce0820c1669b6$export$c05b21e3257751e5)(action.payload));
                if (index > -1) state.tooltipItemPayloads.splice(index, 1);
            },
            prepare: (0, $df8b6ce3f4df1ba5$export$39fcd5145ec5e4e2)()
        },
        setTooltipSettingsState (state, action) {
            state.settings = action.payload;
        },
        setActiveMouseOverItemIndex (state, action) {
            state.syncInteraction.active = false;
            state.syncInteraction.sourceViewBox = undefined;
            state.keyboardInteraction.active = false;
            state.itemInteraction.hover.active = true;
            state.itemInteraction.hover.index = action.payload.activeIndex;
            state.itemInteraction.hover.dataKey = action.payload.activeDataKey;
            state.itemInteraction.hover.graphicalItemId = action.payload.activeGraphicalItemId;
            state.itemInteraction.hover.coordinate = action.payload.activeCoordinate;
        },
        mouseLeaveChart (state) {
            /*
       * Clear only the active flags. Why?
       * 1. Keep Coordinate to preserve animation - next time the Tooltip appears, we want to render it from
       * the last place where it was when it disappeared.
       * 2. We want to keep all the properties anyway just in case the tooltip has `active=true` prop
       * and continues being visible even after the mouse has left the chart.
       */ state.itemInteraction.hover.active = false;
            state.axisInteraction.hover.active = false;
        },
        mouseLeaveItem (state) {
            state.itemInteraction.hover.active = false;
        },
        setActiveClickItemIndex (state, action) {
            state.syncInteraction.active = false;
            state.syncInteraction.sourceViewBox = undefined;
            state.itemInteraction.click.active = true;
            state.keyboardInteraction.active = false;
            state.itemInteraction.click.index = action.payload.activeIndex;
            state.itemInteraction.click.dataKey = action.payload.activeDataKey;
            state.itemInteraction.click.graphicalItemId = action.payload.activeGraphicalItemId;
            state.itemInteraction.click.coordinate = action.payload.activeCoordinate;
        },
        setMouseOverAxisIndex (state, action) {
            state.syncInteraction.active = false;
            state.syncInteraction.sourceViewBox = undefined;
            state.axisInteraction.hover.active = true;
            state.keyboardInteraction.active = false;
            state.axisInteraction.hover.index = action.payload.activeIndex;
            state.axisInteraction.hover.dataKey = action.payload.activeDataKey;
            state.axisInteraction.hover.coordinate = action.payload.activeCoordinate;
        },
        setMouseClickAxisIndex (state, action) {
            state.syncInteraction.active = false;
            state.syncInteraction.sourceViewBox = undefined;
            state.keyboardInteraction.active = false;
            state.axisInteraction.click.active = true;
            state.axisInteraction.click.index = action.payload.activeIndex;
            state.axisInteraction.click.dataKey = action.payload.activeDataKey;
            state.axisInteraction.click.coordinate = action.payload.activeCoordinate;
        },
        setSyncInteraction (state, action) {
            state.syncInteraction = action.payload;
        },
        setKeyboardInteraction (state, action) {
            state.keyboardInteraction.active = action.payload.active;
            state.keyboardInteraction.index = action.payload.activeIndex;
            state.keyboardInteraction.coordinate = action.payload.activeCoordinate;
        }
    }
});
var { addTooltipEntrySettings: $2bfb679c145bcb6f$export$2eaa1babb4725485, replaceTooltipEntrySettings: $2bfb679c145bcb6f$export$7333cdb61d5073d3, removeTooltipEntrySettings: $2bfb679c145bcb6f$export$29793cde90169929, setTooltipSettingsState: $2bfb679c145bcb6f$export$8d517a53c4528750, setActiveMouseOverItemIndex: $2bfb679c145bcb6f$export$c78abbb2450f6b44, mouseLeaveItem: $2bfb679c145bcb6f$export$68742311289b8f85, mouseLeaveChart: $2bfb679c145bcb6f$export$73879bed3f2eef71, setActiveClickItemIndex: $2bfb679c145bcb6f$export$99be2464250d8cae, setMouseOverAxisIndex: $2bfb679c145bcb6f$export$a7277636863fc703, setMouseClickAxisIndex: $2bfb679c145bcb6f$export$d2b1af5c3a560528, setSyncInteraction: $2bfb679c145bcb6f$export$f2efc99b98e50938, setKeyboardInteraction: $2bfb679c145bcb6f$export$820c94985c9eba3f } = $2bfb679c145bcb6f$var$tooltipSlice.actions;
var $2bfb679c145bcb6f$export$cadd4678b967dba6 = $2bfb679c145bcb6f$var$tooltipSlice.reducer;


var $757384ec7d27bd7d$export$6162f642d41f88ea = (onMouseEnterFromProps, dataKey, graphicalItemId)=>{
    var dispatch = (0, $a441e801d1b41b52$export$f51d452c10d5b956)();
    return (data, index)=>(event)=>{
            onMouseEnterFromProps === null || onMouseEnterFromProps === void 0 || onMouseEnterFromProps(data, index, event);
            dispatch((0, $2bfb679c145bcb6f$export$c78abbb2450f6b44)({
                activeIndex: String(index),
                activeDataKey: dataKey,
                activeCoordinate: data.tooltipPosition,
                activeGraphicalItemId: graphicalItemId
            }));
        };
};
var $757384ec7d27bd7d$export$27cbf444bf0be2d0 = (onMouseLeaveFromProps)=>{
    var dispatch = (0, $a441e801d1b41b52$export$f51d452c10d5b956)();
    return (data, index)=>(event)=>{
            onMouseLeaveFromProps === null || onMouseLeaveFromProps === void 0 || onMouseLeaveFromProps(data, index, event);
            dispatch((0, $2bfb679c145bcb6f$export$68742311289b8f85)());
        };
};
var $757384ec7d27bd7d$export$c9154937ad8393fc = (onMouseClickFromProps, dataKey, graphicalItemId)=>{
    var dispatch = (0, $a441e801d1b41b52$export$f51d452c10d5b956)();
    return (data, index)=>(event)=>{
            onMouseClickFromProps === null || onMouseClickFromProps === void 0 || onMouseClickFromProps(data, index, event);
            dispatch((0, $2bfb679c145bcb6f$export$99be2464250d8cae)({
                activeIndex: String(index),
                activeDataKey: dataKey,
                activeCoordinate: data.tooltipPosition,
                activeGraphicalItemId: graphicalItemId
            }));
        };
};



var $kc00y = parcelRequire("kc00y");



function $1cd65dea66eb2265$export$7fa09c17ce18f3e8(_ref) {
    var { tooltipEntrySettings: tooltipEntrySettings } = _ref;
    var dispatch = (0, $a441e801d1b41b52$export$f51d452c10d5b956)();
    var isPanorama = (0, $10d1d693b6b228cd$export$4b0c59f8845ba920)();
    var prevSettingsRef = (0, $kc00y.useRef)(null);
    (0, $kc00y.useLayoutEffect)(()=>{
        if (isPanorama) // Panorama graphical items should never contribute to Tooltip payload.
        return;
        if (prevSettingsRef.current === null) dispatch((0, $2bfb679c145bcb6f$export$2eaa1babb4725485)(tooltipEntrySettings));
        else if (prevSettingsRef.current !== tooltipEntrySettings) dispatch((0, $2bfb679c145bcb6f$export$7333cdb61d5073d3)({
            prev: prevSettingsRef.current,
            next: tooltipEntrySettings
        }));
        prevSettingsRef.current = tooltipEntrySettings;
    }, [
        tooltipEntrySettings,
        dispatch,
        isPanorama
    ]);
    (0, $kc00y.useLayoutEffect)(()=>{
        return ()=>{
            if (prevSettingsRef.current) {
                dispatch((0, $2bfb679c145bcb6f$export$29793cde90169929)(prevSettingsRef.current));
                prevSettingsRef.current = null;
            }
        };
    }, [
        dispatch
    ]);
    return null;
}



var $kc00y = parcelRequire("kc00y");

/**
 * ErrorBars have lot more settings but all the others are scoped to the component itself.
 * Only some of them required to be reported to the global store because XAxis and YAxis need to know
 * if the error bar is contributing to extending the axis domain.
 */ var $9068acbf45b5ed3a$var$initialState = {};
var $9068acbf45b5ed3a$var$errorBarSlice = (0, $df8b6ce3f4df1ba5$export$4d8d9bd83c24ae8b)({
    name: 'errorBars',
    initialState: $9068acbf45b5ed3a$var$initialState,
    reducers: {
        addErrorBar: (state, action)=>{
            var { itemId: itemId, errorBar: errorBar } = action.payload;
            if (!state[itemId]) state[itemId] = [];
            state[itemId].push(errorBar);
        },
        replaceErrorBar: (state, action)=>{
            var { itemId: itemId, prev: prev, next: next } = action.payload;
            if (state[itemId]) state[itemId] = state[itemId].map((e)=>e.dataKey === prev.dataKey && e.direction === prev.direction ? next : e);
        },
        removeErrorBar: (state, action)=>{
            var { itemId: itemId, errorBar: errorBar } = action.payload;
            if (state[itemId]) state[itemId] = state[itemId].filter((e)=>e.dataKey !== errorBar.dataKey || e.direction !== errorBar.direction);
        }
    }
});
var { addErrorBar: $9068acbf45b5ed3a$export$155912f95c88abac, replaceErrorBar: $9068acbf45b5ed3a$export$f1ebd3b9f70a9f5f, removeErrorBar: $9068acbf45b5ed3a$export$b0d2fb6a7d9d3b45 } = $9068acbf45b5ed3a$var$errorBarSlice.actions;
var $9068acbf45b5ed3a$export$6dda85fa3c67ca19 = $9068acbf45b5ed3a$var$errorBarSlice.reducer;




var $kc00y = parcelRequire("kc00y");

var $kc00y = parcelRequire("kc00y");

var $de94cdb39c3249cc$var$_ref;
var $de94cdb39c3249cc$export$bf86633db292cdb4 = ()=>{
    var [id] = $kc00y.useState(()=>(0, $7e613228d3a31273$export$8b15d37bc3f197d4)('uid-'));
    return id;
};
var $de94cdb39c3249cc$export$f680877a34711e37 = ($de94cdb39c3249cc$var$_ref = $kc00y['useId'.toString()]) !== null && $de94cdb39c3249cc$var$_ref !== void 0 ? $de94cdb39c3249cc$var$_ref : $de94cdb39c3249cc$export$bf86633db292cdb4;


function $6e5ec7ed2dc8f476$export$c485849f2e393253(prefix, customId) {
    /*
   * We have to call this hook here even if we don't use the result because
   * rules of hooks demand that hooks are never called conditionally.
   */ var generatedId = (0, $de94cdb39c3249cc$export$f680877a34711e37)();
    // If a custom ID is provided, it always takes precedence.
    if (customId) return customId;
    // Apply the prefix if one was provided.
    return prefix ? "".concat(prefix, "-").concat(generatedId) : generatedId;
} /**
 * The useUniqueId hook returns a unique ID that is either reused from external props or generated internally.
 * Either way the ID is now guaranteed to be present so no more nulls or undefined.
 */ 


var $f34dba1288eb5faf$var$GraphicalItemIdContext = /*#__PURE__*/ (0, $kc00y.createContext)(undefined);
var $f34dba1288eb5faf$export$8c2f307ff93f02ba = (_ref)=>{
    var { id: id, type: type, children: children } = _ref;
    var resolvedId = (0, $6e5ec7ed2dc8f476$export$c485849f2e393253)("recharts-".concat(type), id);
    return /*#__PURE__*/ $kc00y.createElement($f34dba1288eb5faf$var$GraphicalItemIdContext.Provider, {
        value: resolvedId
    }, children(resolvedId));
};
function $f34dba1288eb5faf$export$e24f341c4ff41691() {
    return (0, $kc00y.useContext)($f34dba1288eb5faf$var$GraphicalItemIdContext);
}


var $e0c673dc3502801b$var$_excluded = [
    "children"
];
function $e0c673dc3502801b$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $e0c673dc3502801b$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $e0c673dc3502801b$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $e0c673dc3502801b$var$initialContextState = {
    data: [],
    xAxisId: 'xAxis-0',
    yAxisId: 'yAxis-0',
    dataPointFormatter: ()=>({
            x: 0,
            y: 0,
            value: 0
        }),
    errorBarOffset: 0
};
var $e0c673dc3502801b$var$ErrorBarContext = /*#__PURE__*/ (0, $kc00y.createContext)($e0c673dc3502801b$var$initialContextState);
function $e0c673dc3502801b$export$fcd6ba6fb4bc66e7(props) {
    var { children: children } = props, rest = $e0c673dc3502801b$var$_objectWithoutProperties(props, $e0c673dc3502801b$var$_excluded);
    return /*#__PURE__*/ $kc00y.createElement($e0c673dc3502801b$var$ErrorBarContext.Provider, {
        value: rest
    }, children);
}
var $e0c673dc3502801b$export$ce29452bff119c97 = ()=>(0, $kc00y.useContext)($e0c673dc3502801b$var$ErrorBarContext);
function $e0c673dc3502801b$export$18dc5be7c8cb3008(props) {
    var dispatch = (0, $a441e801d1b41b52$export$f51d452c10d5b956)();
    var graphicalItemId = (0, $f34dba1288eb5faf$export$e24f341c4ff41691)();
    var prevPropsRef = (0, $kc00y.useRef)(null);
    (0, $kc00y.useEffect)(()=>{
        if (graphicalItemId == null) // ErrorBar outside a graphical item context does not do anything.
        return;
        if (prevPropsRef.current === null) dispatch((0, $9068acbf45b5ed3a$export$155912f95c88abac)({
            itemId: graphicalItemId,
            errorBar: props
        }));
        else if (prevPropsRef.current !== props) dispatch((0, $9068acbf45b5ed3a$export$f1ebd3b9f70a9f5f)({
            itemId: graphicalItemId,
            prev: prevPropsRef.current,
            next: props
        }));
        prevPropsRef.current = props;
    }, [
        dispatch,
        graphicalItemId,
        props
    ]);
    (0, $kc00y.useEffect)(()=>{
        return ()=>{
            if (prevPropsRef.current != null && graphicalItemId != null) {
                dispatch((0, $9068acbf45b5ed3a$export$b0d2fb6a7d9d3b45)({
                    itemId: graphicalItemId,
                    errorBar: prevPropsRef.current
                }));
                prevPropsRef.current = null;
            }
        };
    }, [
        dispatch,
        graphicalItemId
    ]);
    return null;
}



var $kc00y = parcelRequire("kc00y");


var $5511469aa65513f7$exports = {};

$5511469aa65513f7$exports = (parcelRequire("6SGPV")).range;





var $8c22b3d5bf36186c$export$519edd692222520 = (state)=>state.chartData;
var $8c22b3d5bf36186c$export$3b10e41b7db2c36 = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $8c22b3d5bf36186c$export$519edd692222520
], (dataState)=>{
    var dataEndIndex = dataState.chartData != null ? dataState.chartData.length - 1 : 0;
    return {
        chartData: dataState.chartData,
        computedData: dataState.computedData,
        dataEndIndex: dataEndIndex,
        dataStartIndex: 0
    };
});
var $8c22b3d5bf36186c$export$fe05134c2701d897 = (state, _unused1, _unused2, isPanorama)=>{
    if (isPanorama) return $8c22b3d5bf36186c$export$3b10e41b7db2c36(state);
    return $8c22b3d5bf36186c$export$519edd692222520(state);
};
var $8c22b3d5bf36186c$export$46bf9459876c0e0c = (state, _unused1, isPanorama)=>{
    if (isPanorama) return $8c22b3d5bf36186c$export$3b10e41b7db2c36(state);
    return $8c22b3d5bf36186c$export$519edd692222520(state);
};
var $8c22b3d5bf36186c$export$7a294fd94385f1e2 = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $8c22b3d5bf36186c$export$fe05134c2701d897
], (_ref)=>{
    var { chartData: chartData, dataStartIndex: dataStartIndex, dataEndIndex: dataEndIndex } = _ref;
    return chartData != null ? chartData.slice(dataStartIndex, dataEndIndex + 1) : [];
});
var $8c22b3d5bf36186c$export$e6f0a66ed1f5780f = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $8c22b3d5bf36186c$export$3b10e41b7db2c36
], (_ref2)=>{
    var { chartData: chartData, dataStartIndex: dataStartIndex, dataEndIndex: dataEndIndex } = _ref2;
    return chartData != null ? chartData.slice(dataStartIndex, dataEndIndex + 1) : [];
});
var $8c22b3d5bf36186c$export$562e7f818eadc746 = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $8c22b3d5bf36186c$export$519edd692222520
], (_ref3)=>{
    var { chartData: chartData, dataStartIndex: dataStartIndex, dataEndIndex: dataEndIndex } = _ref3;
    return chartData != null ? chartData.slice(dataStartIndex, dataEndIndex + 1) : [];
});





function $5bcc5341b7e18f2a$export$ba29b24e2a92eb58(v) {
    if (Array.isArray(v) && v.length === 2) {
        var [min, max] = v;
        if ((0, $22869ac8a5888437$export$f8a8fc612ced9bb0)(min) && (0, $22869ac8a5888437$export$f8a8fc612ced9bb0)(max)) return true;
    }
    return false;
}
function $5bcc5341b7e18f2a$export$15a9d37c57dafeb9(providedDomain, boundaryDomain, allowDataOverflow) {
    if (allowDataOverflow) // If the data are allowed to overflow - we're fine with whatever user provided
    return providedDomain;
    /*
   * If the data are not allowed to overflow - we need to extend the domain.
   * Means that effectively the user is allowed to make the domain larger
   * but not smaller.
   */ return [
        Math.min(providedDomain[0], boundaryDomain[0]),
        Math.max(providedDomain[1], boundaryDomain[1])
    ];
}
function $5bcc5341b7e18f2a$export$fcbf88d4627b24df(userDomain, allowDataOverflow) {
    if (!allowDataOverflow) // Cannot compute data overflow if the data is not provided
    return undefined;
    if (typeof userDomain === 'function') // The user function expects the data to be provided as an argument
    return undefined;
    if (Array.isArray(userDomain) && userDomain.length === 2) {
        var [providedMin, providedMax] = userDomain;
        var finalMin, finalMax;
        if ((0, $22869ac8a5888437$export$f8a8fc612ced9bb0)(providedMin)) finalMin = providedMin;
        else if (typeof providedMin === 'function') // The user function expects the data to be provided as an argument
        return undefined;
        if ((0, $22869ac8a5888437$export$f8a8fc612ced9bb0)(providedMax)) finalMax = providedMax;
        else if (typeof providedMax === 'function') // The user function expects the data to be provided as an argument
        return undefined;
        var candidate = [
            finalMin,
            finalMax
        ];
        if ($5bcc5341b7e18f2a$export$ba29b24e2a92eb58(candidate)) return candidate;
    }
    return undefined;
}
function $5bcc5341b7e18f2a$export$3f87aa7a53437a70(userDomain, dataDomain, allowDataOverflow) {
    if (!allowDataOverflow && dataDomain == null) // Cannot compute data overflow if the data is not provided
    return undefined;
    if (typeof userDomain === 'function' && dataDomain != null) try {
        var result = userDomain(dataDomain, allowDataOverflow);
        if ($5bcc5341b7e18f2a$export$ba29b24e2a92eb58(result)) return $5bcc5341b7e18f2a$export$15a9d37c57dafeb9(result, dataDomain, allowDataOverflow);
    } catch (_unused) {
    /* ignore the exception and compute domain from data later */ }
    if (Array.isArray(userDomain) && userDomain.length === 2) {
        var [providedMin, providedMax] = userDomain;
        var finalMin, finalMax;
        if (providedMin === 'auto') {
            if (dataDomain != null) finalMin = Math.min(...dataDomain);
        } else if ((0, $7e613228d3a31273$export$7e4aa119212bc614)(providedMin)) finalMin = providedMin;
        else if (typeof providedMin === 'function') try {
            if (dataDomain != null) finalMin = providedMin(dataDomain === null || dataDomain === void 0 ? void 0 : dataDomain[0]);
        } catch (_unused2) {
        /* ignore the exception and compute domain from data later */ }
        else if (typeof providedMin === 'string' && (0, $d5958b0668c58531$export$75a7b23ff266dfa1).test(providedMin)) {
            var match = (0, $d5958b0668c58531$export$75a7b23ff266dfa1).exec(providedMin);
            if (match == null || match[1] == null || dataDomain == null) finalMin = undefined;
            else {
                var value = +match[1];
                finalMin = dataDomain[0] - value;
            }
        } else finalMin = dataDomain === null || dataDomain === void 0 ? void 0 : dataDomain[0];
        if (providedMax === 'auto') {
            if (dataDomain != null) finalMax = Math.max(...dataDomain);
        } else if ((0, $7e613228d3a31273$export$7e4aa119212bc614)(providedMax)) finalMax = providedMax;
        else if (typeof providedMax === 'function') try {
            if (dataDomain != null) finalMax = providedMax(dataDomain === null || dataDomain === void 0 ? void 0 : dataDomain[1]);
        } catch (_unused3) {
        /* ignore the exception and compute domain from data later */ }
        else if (typeof providedMax === 'string' && (0, $d5958b0668c58531$export$19c111ec8ad6c644).test(providedMax)) {
            var _match = (0, $d5958b0668c58531$export$19c111ec8ad6c644).exec(providedMax);
            if (_match == null || _match[1] == null || dataDomain == null) finalMax = undefined;
            else {
                var _value = +_match[1];
                finalMax = dataDomain[1] + _value;
            }
        } else finalMax = dataDomain === null || dataDomain === void 0 ? void 0 : dataDomain[1];
        var candidate = [
            finalMin,
            finalMax
        ];
        if ($5bcc5341b7e18f2a$export$ba29b24e2a92eb58(candidate)) {
            if (dataDomain == null) return candidate;
            return $5bcc5341b7e18f2a$export$15a9d37c57dafeb9(candidate, dataDomain, allowDataOverflow);
        }
    }
    return undefined;
}




/**
 * @fileOverview calculate tick values of scale
 * @author xile611, arcthur
 * @date 2015-09-17
 */ var $219758f2ddabdf68$exports = {};
/*! decimal.js-light v2.5.1 https://github.com/MikeMcl/decimal.js-light/LICENCE */ (function(globalScope) {
    'use strict';
    /*
   *  decimal.js-light v2.5.1
   *  An arbitrary-precision Decimal type for JavaScript.
   *  https://github.com/MikeMcl/decimal.js-light
   *  Copyright (c) 2020 Michael Mclaughlin <M8ch88l@gmail.com>
   *  MIT Expat Licence
   */ // -----------------------------------  EDITABLE DEFAULTS  ------------------------------------ //
    // The limit on the value of `precision`, and on the value of the first argument to
    // `toDecimalPlaces`, `toExponential`, `toFixed`, `toPrecision` and `toSignificantDigits`.
    var MAX_DIGITS = 1e9, // The initial configuration properties of the Decimal constructor.
    Decimal = {
        // These values must be integers within the stated ranges (inclusive).
        // Most of these values can be changed during run-time using `Decimal.config`.
        // The maximum number of significant digits of the result of a calculation or base conversion.
        // E.g. `Decimal.config({ precision: 20 });`
        precision: 20,
        // The rounding mode used by default by `toInteger`, `toDecimalPlaces`, `toExponential`,
        // `toFixed`, `toPrecision` and `toSignificantDigits`.
        //
        // ROUND_UP         0 Away from zero.
        // ROUND_DOWN       1 Towards zero.
        // ROUND_CEIL       2 Towards +Infinity.
        // ROUND_FLOOR      3 Towards -Infinity.
        // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
        // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
        // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
        // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
        // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
        //
        // E.g.
        // `Decimal.rounding = 4;`
        // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
        rounding: 4,
        // The exponent value at and beneath which `toString` returns exponential notation.
        // JavaScript numbers: -7
        toExpNeg: -7,
        // The exponent value at and above which `toString` returns exponential notation.
        // JavaScript numbers: 21
        toExpPos: 21,
        // The natural logarithm of 10.
        // 115 digits
        LN10: '2.302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286'
    }, // ----------------------------------- END OF EDITABLE DEFAULTS ------------------------------- //
    external = true, decimalError = '[DecimalError] ', invalidArgument = decimalError + 'Invalid argument: ', exponentOutOfRange = decimalError + 'Exponent out of range: ', mathfloor = Math.floor, mathpow = Math.pow, isDecimal = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, ONE, BASE = 1e7, LOG_BASE = 7, MAX_SAFE_INTEGER = 9007199254740991, MAX_E = mathfloor(MAX_SAFE_INTEGER / LOG_BASE), // Decimal.prototype object
    P = {};
    // Decimal prototype methods
    /*
   *  absoluteValue                       abs
   *  comparedTo                          cmp
   *  decimalPlaces                       dp
   *  dividedBy                           div
   *  dividedToIntegerBy                  idiv
   *  equals                              eq
   *  exponent
   *  greaterThan                         gt
   *  greaterThanOrEqualTo                gte
   *  isInteger                           isint
   *  isNegative                          isneg
   *  isPositive                          ispos
   *  isZero
   *  lessThan                            lt
   *  lessThanOrEqualTo                   lte
   *  logarithm                           log
   *  minus                               sub
   *  modulo                              mod
   *  naturalExponential                  exp
   *  naturalLogarithm                    ln
   *  negated                             neg
   *  plus                                add
   *  precision                           sd
   *  squareRoot                          sqrt
   *  times                               mul
   *  toDecimalPlaces                     todp
   *  toExponential
   *  toFixed
   *  toInteger                           toint
   *  toNumber
   *  toPower                             pow
   *  toPrecision
   *  toSignificantDigits                 tosd
   *  toString
   *  valueOf                             val
   */ /*
   * Return a new Decimal whose value is the absolute value of this Decimal.
   *
   */ P.absoluteValue = P.abs = function() {
        var x = new this.constructor(this);
        if (x.s) x.s = 1;
        return x;
    };
    /*
   * Return
   *   1    if the value of this Decimal is greater than the value of `y`,
   *  -1    if the value of this Decimal is less than the value of `y`,
   *   0    if they have the same value
   *
   */ P.comparedTo = P.cmp = function(y) {
        var i, j, xdL, ydL, x = this;
        y = new x.constructor(y);
        // Signs differ?
        if (x.s !== y.s) return x.s || -y.s;
        // Compare exponents.
        if (x.e !== y.e) return x.e > y.e ^ x.s < 0 ? 1 : -1;
        xdL = x.d.length;
        ydL = y.d.length;
        // Compare digit by digit.
        for(i = 0, j = xdL < ydL ? xdL : ydL; i < j; ++i){
            if (x.d[i] !== y.d[i]) return x.d[i] > y.d[i] ^ x.s < 0 ? 1 : -1;
        }
        // Compare lengths.
        return xdL === ydL ? 0 : xdL > ydL ^ x.s < 0 ? 1 : -1;
    };
    /*
   * Return the number of decimal places of the value of this Decimal.
   *
   */ P.decimalPlaces = P.dp = function() {
        var x = this, w = x.d.length - 1, dp = (w - x.e) * LOG_BASE;
        // Subtract the number of trailing zeros of the last word.
        w = x.d[w];
        if (w) for(; w % 10 == 0; w /= 10)dp--;
        return dp < 0 ? 0 : dp;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal divided by `y`, truncated to
   * `precision` significant digits.
   *
   */ P.dividedBy = P.div = function(y) {
        return divide(this, new this.constructor(y));
    };
    /*
   * Return a new Decimal whose value is the integer part of dividing the value of this Decimal
   * by the value of `y`, truncated to `precision` significant digits.
   *
   */ P.dividedToIntegerBy = P.idiv = function(y) {
        var x = this, Ctor = x.constructor;
        return round(divide(x, new Ctor(y), 0, 1), Ctor.precision);
    };
    /*
   * Return true if the value of this Decimal is equal to the value of `y`, otherwise return false.
   *
   */ P.equals = P.eq = function(y) {
        return !this.cmp(y);
    };
    /*
   * Return the (base 10) exponent value of this Decimal (this.e is the base 10000000 exponent).
   *
   */ P.exponent = function() {
        return getBase10Exponent(this);
    };
    /*
   * Return true if the value of this Decimal is greater than the value of `y`, otherwise return
   * false.
   *
   */ P.greaterThan = P.gt = function(y) {
        return this.cmp(y) > 0;
    };
    /*
   * Return true if the value of this Decimal is greater than or equal to the value of `y`,
   * otherwise return false.
   *
   */ P.greaterThanOrEqualTo = P.gte = function(y) {
        return this.cmp(y) >= 0;
    };
    /*
   * Return true if the value of this Decimal is an integer, otherwise return false.
   *
   */ P.isInteger = P.isint = function() {
        return this.e > this.d.length - 2;
    };
    /*
   * Return true if the value of this Decimal is negative, otherwise return false.
   *
   */ P.isNegative = P.isneg = function() {
        return this.s < 0;
    };
    /*
   * Return true if the value of this Decimal is positive, otherwise return false.
   *
   */ P.isPositive = P.ispos = function() {
        return this.s > 0;
    };
    /*
   * Return true if the value of this Decimal is 0, otherwise return false.
   *
   */ P.isZero = function() {
        return this.s === 0;
    };
    /*
   * Return true if the value of this Decimal is less than `y`, otherwise return false.
   *
   */ P.lessThan = P.lt = function(y) {
        return this.cmp(y) < 0;
    };
    /*
   * Return true if the value of this Decimal is less than or equal to `y`, otherwise return false.
   *
   */ P.lessThanOrEqualTo = P.lte = function(y) {
        return this.cmp(y) < 1;
    };
    /*
   * Return the logarithm of the value of this Decimal to the specified base, truncated to
   * `precision` significant digits.
   *
   * If no base is specified, return log[10](x).
   *
   * log[base](x) = ln(x) / ln(base)
   *
   * The maximum error of the result is 1 ulp (unit in the last place).
   *
   * [base] {number|string|Decimal} The base of the logarithm.
   *
   */ P.logarithm = P.log = function(base) {
        var r, x = this, Ctor = x.constructor, pr = Ctor.precision, wpr = pr + 5;
        // Default base is 10.
        if (base === void 0) base = new Ctor(10);
        else {
            base = new Ctor(base);
            // log[-b](x) = NaN
            // log[0](x)  = NaN
            // log[1](x)  = NaN
            if (base.s < 1 || base.eq(ONE)) throw Error(decimalError + 'NaN');
        }
        // log[b](-x) = NaN
        // log[b](0) = -Infinity
        if (x.s < 1) throw Error(decimalError + (x.s ? 'NaN' : '-Infinity'));
        // log[b](1) = 0
        if (x.eq(ONE)) return new Ctor(0);
        external = false;
        r = divide(ln(x, wpr), ln(base, wpr), wpr);
        external = true;
        return round(r, pr);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal minus `y`, truncated to
   * `precision` significant digits.
   *
   */ P.minus = P.sub = function(y) {
        var x = this;
        y = new x.constructor(y);
        return x.s == y.s ? subtract(x, y) : add(x, (y.s = -y.s, y));
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal modulo `y`, truncated to
   * `precision` significant digits.
   *
   */ P.modulo = P.mod = function(y) {
        var q, x = this, Ctor = x.constructor, pr = Ctor.precision;
        y = new Ctor(y);
        // x % 0 = NaN
        if (!y.s) throw Error(decimalError + 'NaN');
        // Return x if x is 0.
        if (!x.s) return round(new Ctor(x), pr);
        // Prevent rounding of intermediate calculations.
        external = false;
        q = divide(x, y, 0, 1).times(y);
        external = true;
        return x.minus(q);
    };
    /*
   * Return a new Decimal whose value is the natural exponential of the value of this Decimal,
   * i.e. the base e raised to the power the value of this Decimal, truncated to `precision`
   * significant digits.
   *
   */ P.naturalExponential = P.exp = function() {
        return exp(this);
    };
    /*
   * Return a new Decimal whose value is the natural logarithm of the value of this Decimal,
   * truncated to `precision` significant digits.
   *
   */ P.naturalLogarithm = P.ln = function() {
        return ln(this);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal negated, i.e. as if multiplied by
   * -1.
   *
   */ P.negated = P.neg = function() {
        var x = new this.constructor(this);
        x.s = -x.s || 0;
        return x;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal plus `y`, truncated to
   * `precision` significant digits.
   *
   */ P.plus = P.add = function(y) {
        var x = this;
        y = new x.constructor(y);
        return x.s == y.s ? add(x, y) : subtract(x, (y.s = -y.s, y));
    };
    /*
   * Return the number of significant digits of the value of this Decimal.
   *
   * [z] {boolean|number} Whether to count integer-part trailing zeros: true, false, 1 or 0.
   *
   */ P.precision = P.sd = function(z) {
        var e, sd, w, x = this;
        if (z !== void 0 && z !== !!z && z !== 1 && z !== 0) throw Error(invalidArgument + z);
        e = getBase10Exponent(x) + 1;
        w = x.d.length - 1;
        sd = w * LOG_BASE + 1;
        w = x.d[w];
        // If non-zero...
        if (w) {
            // Subtract the number of trailing zeros of the last word.
            for(; w % 10 == 0; w /= 10)sd--;
            // Add the number of digits of the first word.
            for(w = x.d[0]; w >= 10; w /= 10)sd++;
        }
        return z && e > sd ? e : sd;
    };
    /*
   * Return a new Decimal whose value is the square root of this Decimal, truncated to `precision`
   * significant digits.
   *
   */ P.squareRoot = P.sqrt = function() {
        var e, n, pr, r, s, t, wpr, x = this, Ctor = x.constructor;
        // Negative or zero?
        if (x.s < 1) {
            if (!x.s) return new Ctor(0);
            // sqrt(-x) = NaN
            throw Error(decimalError + 'NaN');
        }
        e = getBase10Exponent(x);
        external = false;
        // Initial estimate.
        s = Math.sqrt(+x);
        // Math.sqrt underflow/overflow?
        // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
        if (s == 0 || s == 1 / 0) {
            n = digitsToString(x.d);
            if ((n.length + e) % 2 == 0) n += '0';
            s = Math.sqrt(n);
            e = mathfloor((e + 1) / 2) - (e < 0 || e % 2);
            if (s == 1 / 0) n = '5e' + e;
            else {
                n = s.toExponential();
                n = n.slice(0, n.indexOf('e') + 1) + e;
            }
            r = new Ctor(n);
        } else r = new Ctor(s.toString());
        pr = Ctor.precision;
        s = wpr = pr + 3;
        // Newton-Raphson iteration.
        for(;;){
            t = r;
            r = t.plus(divide(x, t, wpr + 2)).times(0.5);
            if (digitsToString(t.d).slice(0, wpr) === (n = digitsToString(r.d)).slice(0, wpr)) {
                n = n.slice(wpr - 3, wpr + 1);
                // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or
                // 4999, i.e. approaching a rounding boundary, continue the iteration.
                if (s == wpr && n == '4999') {
                    // On the first iteration only, check to see if rounding up gives the exact result as the
                    // nines may infinitely repeat.
                    round(t, pr + 1, 0);
                    if (t.times(t).eq(x)) {
                        r = t;
                        break;
                    }
                } else if (n != '9999') break;
                wpr += 4;
            }
        }
        external = true;
        return round(r, pr);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal times `y`, truncated to
   * `precision` significant digits.
   *
   */ P.times = P.mul = function(y) {
        var carry, e, i, k, r, rL, t, xdL, ydL, x = this, Ctor = x.constructor, xd = x.d, yd = (y = new Ctor(y)).d;
        // Return 0 if either is 0.
        if (!x.s || !y.s) return new Ctor(0);
        y.s *= x.s;
        e = x.e + y.e;
        xdL = xd.length;
        ydL = yd.length;
        // Ensure xd points to the longer array.
        if (xdL < ydL) {
            r = xd;
            xd = yd;
            yd = r;
            rL = xdL;
            xdL = ydL;
            ydL = rL;
        }
        // Initialise the result array with zeros.
        r = [];
        rL = xdL + ydL;
        for(i = rL; i--;)r.push(0);
        // Multiply!
        for(i = ydL; --i >= 0;){
            carry = 0;
            for(k = xdL + i; k > i;){
                t = r[k] + yd[i] * xd[k - i - 1] + carry;
                r[k--] = t % BASE | 0;
                carry = t / BASE | 0;
            }
            r[k] = (r[k] + carry) % BASE | 0;
        }
        // Remove trailing zeros.
        for(; !r[--rL];)r.pop();
        if (carry) ++e;
        else r.shift();
        y.d = r;
        y.e = e;
        return external ? round(y, Ctor.precision) : y;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `dp`
   * decimal places using rounding mode `rm` or `rounding` if `rm` is omitted.
   *
   * If `dp` is omitted, return a new Decimal whose value is the value of this Decimal.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toDecimalPlaces = P.todp = function(dp, rm) {
        var x = this, Ctor = x.constructor;
        x = new Ctor(x);
        if (dp === void 0) return x;
        checkInt32(dp, 0, MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);
        return round(x, dp + getBase10Exponent(x) + 1, rm);
    };
    /*
   * Return a string representing the value of this Decimal in exponential notation rounded to
   * `dp` fixed decimal places using rounding mode `rounding`.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toExponential = function(dp, rm) {
        var str, x = this, Ctor = x.constructor;
        if (dp === void 0) str = toString(x, true);
        else {
            checkInt32(dp, 0, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = round(new Ctor(x), dp + 1, rm);
            str = toString(x, true, dp + 1);
        }
        return str;
    };
    /*
   * Return a string representing the value of this Decimal in normal (fixed-point) notation to
   * `dp` fixed decimal places and rounded using rounding mode `rm` or `rounding` if `rm` is
   * omitted.
   *
   * As with JavaScript numbers, (-0).toFixed(0) is '0', but e.g. (-0.00001).toFixed(0) is '-0'.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * (-0).toFixed(0) is '0', but (-0.1).toFixed(0) is '-0'.
   * (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
   * (-0).toFixed(3) is '0.000'.
   * (-0.5).toFixed(0) is '-0'.
   *
   */ P.toFixed = function(dp, rm) {
        var str, y, x = this, Ctor = x.constructor;
        if (dp === void 0) return toString(x);
        checkInt32(dp, 0, MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);
        y = round(new Ctor(x), dp + getBase10Exponent(x) + 1, rm);
        str = toString(y.abs(), false, dp + getBase10Exponent(y) + 1);
        // To determine whether to add the minus sign look at the value before it was rounded,
        // i.e. look at `x` rather than `y`.
        return x.isneg() && !x.isZero() ? '-' + str : str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number using
   * rounding mode `rounding`.
   *
   */ P.toInteger = P.toint = function() {
        var x = this, Ctor = x.constructor;
        return round(new Ctor(x), getBase10Exponent(x) + 1, Ctor.rounding);
    };
    /*
   * Return the value of this Decimal converted to a number primitive.
   *
   */ P.toNumber = function() {
        return +this;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal raised to the power `y`,
   * truncated to `precision` significant digits.
   *
   * For non-integer or very large exponents pow(x, y) is calculated using
   *
   *   x^y = exp(y*ln(x))
   *
   * The maximum error is 1 ulp (unit in last place).
   *
   * y {number|string|Decimal} The power to which to raise this Decimal.
   *
   */ P.toPower = P.pow = function(y) {
        var e, k, pr, r, sign, yIsInt, x = this, Ctor = x.constructor, guard = 12, yn = +(y = new Ctor(y));
        // pow(x, 0) = 1
        if (!y.s) return new Ctor(ONE);
        x = new Ctor(x);
        // pow(0, y > 0) = 0
        // pow(0, y < 0) = Infinity
        if (!x.s) {
            if (y.s < 1) throw Error(decimalError + 'Infinity');
            return x;
        }
        // pow(1, y) = 1
        if (x.eq(ONE)) return x;
        pr = Ctor.precision;
        // pow(x, 1) = x
        if (y.eq(ONE)) return round(x, pr);
        e = y.e;
        k = y.d.length - 1;
        yIsInt = e >= k;
        sign = x.s;
        if (!yIsInt) {
            // pow(x < 0, y non-integer) = NaN
            if (sign < 0) throw Error(decimalError + 'NaN');
        // If y is a small integer use the 'exponentiation by squaring' algorithm.
        } else if ((k = yn < 0 ? -yn : yn) <= MAX_SAFE_INTEGER) {
            r = new Ctor(ONE);
            // Max k of 9007199254740991 takes 53 loop iterations.
            // Maximum digits array length; leaves [28, 34] guard digits.
            e = Math.ceil(pr / LOG_BASE + 4);
            external = false;
            for(;;){
                if (k % 2) {
                    r = r.times(x);
                    truncate(r.d, e);
                }
                k = mathfloor(k / 2);
                if (k === 0) break;
                x = x.times(x);
                truncate(x.d, e);
            }
            external = true;
            return y.s < 0 ? new Ctor(ONE).div(r) : round(r, pr);
        }
        // Result is negative if x is negative and the last digit of integer y is odd.
        sign = sign < 0 && y.d[Math.max(e, k)] & 1 ? -1 : 1;
        x.s = 1;
        external = false;
        r = y.times(ln(x, pr + guard));
        external = true;
        r = exp(r);
        r.s = sign;
        return r;
    };
    /*
   * Return a string representing the value of this Decimal rounded to `sd` significant digits
   * using rounding mode `rounding`.
   *
   * Return exponential notation if `sd` is less than the number of digits necessary to represent
   * the integer part of the value in normal notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toPrecision = function(sd, rm) {
        var e, str, x = this, Ctor = x.constructor;
        if (sd === void 0) {
            e = getBase10Exponent(x);
            str = toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
        } else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = round(new Ctor(x), sd, rm);
            e = getBase10Exponent(x);
            str = toString(x, sd <= e || e <= Ctor.toExpNeg, sd);
        }
        return str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `sd`
   * significant digits using rounding mode `rm`, or to `precision` and `rounding` respectively if
   * omitted.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toSignificantDigits = P.tosd = function(sd, rm) {
        var x = this, Ctor = x.constructor;
        if (sd === void 0) {
            sd = Ctor.precision;
            rm = Ctor.rounding;
        } else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
        }
        return round(new Ctor(x), sd, rm);
    };
    /*
   * Return a string representing the value of this Decimal.
   *
   * Return exponential notation if this Decimal has a positive exponent equal to or greater than
   * `toExpPos`, or a negative exponent equal to or less than `toExpNeg`.
   *
   */ P.toString = P.valueOf = P.val = P.toJSON = function() {
        var x = this, e = getBase10Exponent(x), Ctor = x.constructor;
        return toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
    };
    // Helper functions for Decimal.prototype (P) and/or Decimal methods, and their callers.
    /*
   *  add                 P.minus, P.plus
   *  checkInt32          P.todp, P.toExponential, P.toFixed, P.toPrecision, P.tosd
   *  digitsToString      P.log, P.sqrt, P.pow, toString, exp, ln
   *  divide              P.div, P.idiv, P.log, P.mod, P.sqrt, exp, ln
   *  exp                 P.exp, P.pow
   *  getBase10Exponent   P.exponent, P.sd, P.toint, P.sqrt, P.todp, P.toFixed, P.toPrecision,
   *                      P.toString, divide, round, toString, exp, ln
   *  getLn10             P.log, ln
   *  getZeroString       digitsToString, toString
   *  ln                  P.log, P.ln, P.pow, exp
   *  parseDecimal        Decimal
   *  round               P.abs, P.idiv, P.log, P.minus, P.mod, P.neg, P.plus, P.toint, P.sqrt,
   *                      P.times, P.todp, P.toExponential, P.toFixed, P.pow, P.toPrecision, P.tosd,
   *                      divide, getLn10, exp, ln
   *  subtract            P.minus, P.plus
   *  toString            P.toExponential, P.toFixed, P.toPrecision, P.toString, P.valueOf
   *  truncate            P.pow
   *
   *  Throws:             P.log, P.mod, P.sd, P.sqrt, P.pow,  checkInt32, divide, round,
   *                      getLn10, exp, ln, parseDecimal, Decimal, config
   */ function add(x, y) {
        var carry, d, e, i, k, len, xd, yd, Ctor = x.constructor, pr = Ctor.precision;
        // If either is zero...
        if (!x.s || !y.s) {
            // Return x if y is zero.
            // Return y if y is non-zero.
            if (!y.s) y = new Ctor(x);
            return external ? round(y, pr) : y;
        }
        xd = x.d;
        yd = y.d;
        // x and y are finite, non-zero numbers with the same sign.
        k = x.e;
        e = y.e;
        xd = xd.slice();
        i = k - e;
        // If base 1e7 exponents differ...
        if (i) {
            if (i < 0) {
                d = xd;
                i = -i;
                len = yd.length;
            } else {
                d = yd;
                e = k;
                len = xd.length;
            }
            // Limit number of zeros prepended to max(ceil(pr / LOG_BASE), len) + 1.
            k = Math.ceil(pr / LOG_BASE);
            len = k > len ? k + 1 : len + 1;
            if (i > len) {
                i = len;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents. Note: Faster to use reverse then do unshifts.
            d.reverse();
            for(; i--;)d.push(0);
            d.reverse();
        }
        len = xd.length;
        i = yd.length;
        // If yd is longer than xd, swap xd and yd so xd points to the longer array.
        if (len - i < 0) {
            i = len;
            d = yd;
            yd = xd;
            xd = d;
        }
        // Only start adding at yd.length - 1 as the further digits of xd can be left as they are.
        for(carry = 0; i;){
            carry = (xd[--i] = xd[i] + yd[i] + carry) / BASE | 0;
            xd[i] %= BASE;
        }
        if (carry) {
            xd.unshift(carry);
            ++e;
        }
        // Remove trailing zeros.
        // No need to check for zero, as +x + +y != 0 && -x + -y != 0
        for(len = xd.length; xd[--len] == 0;)xd.pop();
        y.d = xd;
        y.e = e;
        return external ? round(y, pr) : y;
    }
    function checkInt32(i, min, max) {
        if (i !== ~~i || i < min || i > max) throw Error(invalidArgument + i);
    }
    function digitsToString(d) {
        var i, k, ws, indexOfLastWord = d.length - 1, str = '', w = d[0];
        if (indexOfLastWord > 0) {
            str += w;
            for(i = 1; i < indexOfLastWord; i++){
                ws = d[i] + '';
                k = LOG_BASE - ws.length;
                if (k) str += getZeroString(k);
                str += ws;
            }
            w = d[i];
            ws = w + '';
            k = LOG_BASE - ws.length;
            if (k) str += getZeroString(k);
        } else if (w === 0) return '0';
        // Remove trailing zeros of last w.
        for(; w % 10 === 0;)w /= 10;
        return str + w;
    }
    var divide = function() {
        // Assumes non-zero x and k, and hence non-zero result.
        function multiplyInteger(x, k) {
            var temp, carry = 0, i = x.length;
            for(x = x.slice(); i--;){
                temp = x[i] * k + carry;
                x[i] = temp % BASE | 0;
                carry = temp / BASE | 0;
            }
            if (carry) x.unshift(carry);
            return x;
        }
        function compare(a, b, aL, bL) {
            var i, r;
            if (aL != bL) r = aL > bL ? 1 : -1;
            else {
                for(i = r = 0; i < aL; i++)if (a[i] != b[i]) {
                    r = a[i] > b[i] ? 1 : -1;
                    break;
                }
            }
            return r;
        }
        function subtract(a, b, aL) {
            var i = 0;
            // Subtract b from a.
            for(; aL--;){
                a[aL] -= i;
                i = a[aL] < b[aL] ? 1 : 0;
                a[aL] = i * BASE + a[aL] - b[aL];
            }
            // Remove leading zeros.
            for(; !a[0] && a.length > 1;)a.shift();
        }
        return function(x, y, pr, dp) {
            var cmp, e, i, k, prod, prodL, q, qd, rem, remL, rem0, sd, t, xi, xL, yd0, yL, yz, Ctor = x.constructor, sign = x.s == y.s ? 1 : -1, xd = x.d, yd = y.d;
            // Either 0?
            if (!x.s) return new Ctor(x);
            if (!y.s) throw Error(decimalError + 'Division by zero');
            e = x.e - y.e;
            yL = yd.length;
            xL = xd.length;
            q = new Ctor(sign);
            qd = q.d = [];
            // Result exponent may be one less than e.
            for(i = 0; yd[i] == (xd[i] || 0);)++i;
            if (yd[i] > (xd[i] || 0)) --e;
            if (pr == null) sd = pr = Ctor.precision;
            else if (dp) sd = pr + (getBase10Exponent(x) - getBase10Exponent(y)) + 1;
            else sd = pr;
            if (sd < 0) return new Ctor(0);
            // Convert precision in number of base 10 digits to base 1e7 digits.
            sd = sd / LOG_BASE + 2 | 0;
            i = 0;
            // divisor < 1e7
            if (yL == 1) {
                k = 0;
                yd = yd[0];
                sd++;
                // k is the carry.
                for(; (i < xL || k) && sd--; i++){
                    t = k * BASE + (xd[i] || 0);
                    qd[i] = t / yd | 0;
                    k = t % yd | 0;
                }
            // divisor >= 1e7
            } else {
                // Normalise xd and yd so highest order digit of yd is >= BASE/2
                k = BASE / (yd[0] + 1) | 0;
                if (k > 1) {
                    yd = multiplyInteger(yd, k);
                    xd = multiplyInteger(xd, k);
                    yL = yd.length;
                    xL = xd.length;
                }
                xi = yL;
                rem = xd.slice(0, yL);
                remL = rem.length;
                // Add zeros to make remainder as long as divisor.
                for(; remL < yL;)rem[remL++] = 0;
                yz = yd.slice();
                yz.unshift(0);
                yd0 = yd[0];
                if (yd[1] >= BASE / 2) ++yd0;
                do {
                    k = 0;
                    // Compare divisor and remainder.
                    cmp = compare(yd, rem, yL, remL);
                    // If divisor < remainder.
                    if (cmp < 0) {
                        // Calculate trial digit, k.
                        rem0 = rem[0];
                        if (yL != remL) rem0 = rem0 * BASE + (rem[1] || 0);
                        // k will be how many times the divisor goes into the current remainder.
                        k = rem0 / yd0 | 0;
                        //  Algorithm:
                        //  1. product = divisor * trial digit (k)
                        //  2. if product > remainder: product -= divisor, k--
                        //  3. remainder -= product
                        //  4. if product was < remainder at 2:
                        //    5. compare new remainder and divisor
                        //    6. If remainder > divisor: remainder -= divisor, k++
                        if (k > 1) {
                            if (k >= BASE) k = BASE - 1;
                            // product = divisor * trial digit.
                            prod = multiplyInteger(yd, k);
                            prodL = prod.length;
                            remL = rem.length;
                            // Compare product and remainder.
                            cmp = compare(prod, rem, prodL, remL);
                            // product > remainder.
                            if (cmp == 1) {
                                k--;
                                // Subtract divisor from product.
                                subtract(prod, yL < prodL ? yz : yd, prodL);
                            }
                        } else {
                            // cmp is -1.
                            // If k is 0, there is no need to compare yd and rem again below, so change cmp to 1
                            // to avoid it. If k is 1 there is a need to compare yd and rem again below.
                            if (k == 0) cmp = k = 1;
                            prod = yd.slice();
                        }
                        prodL = prod.length;
                        if (prodL < remL) prod.unshift(0);
                        // Subtract product from remainder.
                        subtract(rem, prod, remL);
                        // If product was < previous remainder.
                        if (cmp == -1) {
                            remL = rem.length;
                            // Compare divisor and new remainder.
                            cmp = compare(yd, rem, yL, remL);
                            // If divisor < new remainder, subtract divisor from remainder.
                            if (cmp < 1) {
                                k++;
                                // Subtract divisor from remainder.
                                subtract(rem, yL < remL ? yz : yd, remL);
                            }
                        }
                        remL = rem.length;
                    } else if (cmp === 0) {
                        k++;
                        rem = [
                            0
                        ];
                    } // if cmp === 1, k will be 0
                    // Add the next digit, k, to the result array.
                    qd[i++] = k;
                    // Update the remainder.
                    if (cmp && rem[0]) rem[remL++] = xd[xi] || 0;
                    else {
                        rem = [
                            xd[xi]
                        ];
                        remL = 1;
                    }
                }while ((xi++ < xL || rem[0] !== void 0) && sd--);
            }
            // Leading zero?
            if (!qd[0]) qd.shift();
            q.e = e;
            return round(q, dp ? pr + getBase10Exponent(q) + 1 : pr);
        };
    }();
    /*
   * Return a new Decimal whose value is the natural exponential of `x` truncated to `sd`
   * significant digits.
   *
   * Taylor/Maclaurin series.
   *
   * exp(x) = x^0/0! + x^1/1! + x^2/2! + x^3/3! + ...
   *
   * Argument reduction:
   *   Repeat x = x / 32, k += 5, until |x| < 0.1
   *   exp(x) = exp(x / 2^k)^(2^k)
   *
   * Previously, the argument was initially reduced by
   * exp(x) = exp(r) * 10^k  where r = x - k * ln10, k = floor(x / ln10)
   * to first put r in the range [0, ln10], before dividing by 32 until |x| < 0.1, but this was
   * found to be slower than just dividing repeatedly by 32 as above.
   *
   * (Math object integer min/max: Math.exp(709) = 8.2e+307, Math.exp(-745) = 5e-324)
   *
   *  exp(x) is non-terminating for any finite, non-zero x.
   *
   */ function exp(x, sd) {
        var denominator, guard, pow, sum, t, wpr, i = 0, k = 0, Ctor = x.constructor, pr = Ctor.precision;
        if (getBase10Exponent(x) > 16) throw Error(exponentOutOfRange + getBase10Exponent(x));
        // exp(0) = 1
        if (!x.s) return new Ctor(ONE);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        t = new Ctor(0.03125);
        while(x.abs().gte(0.1)){
            x = x.times(t); // x = x / 2^5
            k += 5;
        }
        // Estimate the precision increase necessary to ensure the first 4 rounding digits are correct.
        guard = Math.log(mathpow(2, k)) / Math.LN10 * 2 + 5 | 0;
        wpr += guard;
        denominator = pow = sum = new Ctor(ONE);
        Ctor.precision = wpr;
        for(;;){
            pow = round(pow.times(x), wpr);
            denominator = denominator.times(++i);
            t = sum.plus(divide(pow, denominator, wpr));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                while(k--)sum = round(sum.times(sum), wpr);
                Ctor.precision = pr;
                return sd == null ? (external = true, round(sum, pr)) : sum;
            }
            sum = t;
        }
    }
    // Calculate the base 10 exponent from the base 1e7 exponent.
    function getBase10Exponent(x) {
        var e = x.e * LOG_BASE, w = x.d[0];
        // Add the number of digits of the first word of the digits array.
        for(; w >= 10; w /= 10)e++;
        return e;
    }
    function getLn10(Ctor, sd, pr) {
        if (sd > Ctor.LN10.sd()) {
            // Reset global state in case the exception is caught.
            external = true;
            if (pr) Ctor.precision = pr;
            throw Error(decimalError + 'LN10 precision limit exceeded');
        }
        return round(new Ctor(Ctor.LN10), sd);
    }
    function getZeroString(k) {
        var zs = '';
        for(; k--;)zs += '0';
        return zs;
    }
    /*
   * Return a new Decimal whose value is the natural logarithm of `x` truncated to `sd` significant
   * digits.
   *
   *  ln(n) is non-terminating (n != 1)
   *
   */ function ln(y, sd) {
        var c, c0, denominator, e, numerator, sum, t, wpr, x2, n = 1, guard = 10, x = y, xd = x.d, Ctor = x.constructor, pr = Ctor.precision;
        // ln(-x) = NaN
        // ln(0) = -Infinity
        if (x.s < 1) throw Error(decimalError + (x.s ? 'NaN' : '-Infinity'));
        // ln(1) = 0
        if (x.eq(ONE)) return new Ctor(0);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        if (x.eq(10)) {
            if (sd == null) external = true;
            return getLn10(Ctor, wpr);
        }
        wpr += guard;
        Ctor.precision = wpr;
        c = digitsToString(xd);
        c0 = c.charAt(0);
        e = getBase10Exponent(x);
        if (Math.abs(e) < 1.5e15) {
            // Argument reduction.
            // The series converges faster the closer the argument is to 1, so using
            // ln(a^b) = b * ln(a),   ln(a) = ln(a^b) / b
            // multiply the argument by itself until the leading digits of the significand are 7, 8, 9,
            // 10, 11, 12 or 13, recording the number of multiplications so the sum of the series can
            // later be divided by this number, then separate out the power of 10 using
            // ln(a*10^b) = ln(a) + b*ln(10).
            // max n is 21 (gives 0.9, 1.0 or 1.1) (9e15 / 21 = 4.2e14).
            //while (c0 < 9 && c0 != 1 || c0 == 1 && c.charAt(1) > 1) {
            // max n is 6 (gives 0.7 - 1.3)
            while(c0 < 7 && c0 != 1 || c0 == 1 && c.charAt(1) > 3){
                x = x.times(y);
                c = digitsToString(x.d);
                c0 = c.charAt(0);
                n++;
            }
            e = getBase10Exponent(x);
            if (c0 > 1) {
                x = new Ctor('0.' + c);
                e++;
            } else x = new Ctor(c0 + '.' + c.slice(1));
        } else {
            // The argument reduction method above may result in overflow if the argument y is a massive
            // number with exponent >= 1500000000000000 (9e15 / 6 = 1.5e15), so instead recall this
            // function using ln(x*10^e) = ln(x) + e*ln(10).
            t = getLn10(Ctor, wpr + 2, pr).times(e + '');
            x = ln(new Ctor(c0 + '.' + c.slice(1)), wpr - guard).plus(t);
            Ctor.precision = pr;
            return sd == null ? (external = true, round(x, pr)) : x;
        }
        // x is reduced to a value near 1.
        // Taylor series.
        // ln(y) = ln((1 + x)/(1 - x)) = 2(x + x^3/3 + x^5/5 + x^7/7 + ...)
        // where x = (y - 1)/(y + 1)    (|x| < 1)
        sum = numerator = x = divide(x.minus(ONE), x.plus(ONE), wpr);
        x2 = round(x.times(x), wpr);
        denominator = 3;
        for(;;){
            numerator = round(numerator.times(x2), wpr);
            t = sum.plus(divide(numerator, new Ctor(denominator), wpr));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                sum = sum.times(2);
                // Reverse the argument reduction.
                if (e !== 0) sum = sum.plus(getLn10(Ctor, wpr + 2, pr).times(e + ''));
                sum = divide(sum, new Ctor(n), wpr);
                Ctor.precision = pr;
                return sd == null ? (external = true, round(sum, pr)) : sum;
            }
            sum = t;
            denominator += 2;
        }
    }
    /*
   * Parse the value of a new Decimal `x` from string `str`.
   */ function parseDecimal(x, str) {
        var e, i, len;
        // Decimal point?
        if ((e = str.indexOf('.')) > -1) str = str.replace('.', '');
        // Exponential form?
        if ((i = str.search(/e/i)) > 0) {
            // Determine exponent.
            if (e < 0) e = i;
            e += +str.slice(i + 1);
            str = str.substring(0, i);
        } else if (e < 0) // Integer.
        e = str.length;
        // Determine leading zeros.
        for(i = 0; str.charCodeAt(i) === 48;)++i;
        // Determine trailing zeros.
        for(len = str.length; str.charCodeAt(len - 1) === 48;)--len;
        str = str.slice(i, len);
        if (str) {
            len -= i;
            e = e - i - 1;
            x.e = mathfloor(e / LOG_BASE);
            x.d = [];
            // Transform base
            // e is the base 10 exponent.
            // i is where to slice str to get the first word of the digits array.
            i = (e + 1) % LOG_BASE;
            if (e < 0) i += LOG_BASE;
            if (i < len) {
                if (i) x.d.push(+str.slice(0, i));
                for(len -= LOG_BASE; i < len;)x.d.push(+str.slice(i, i += LOG_BASE));
                str = str.slice(i);
                i = LOG_BASE - str.length;
            } else i -= len;
            for(; i--;)str += '0';
            x.d.push(+str);
            if (external && (x.e > MAX_E || x.e < -MAX_E)) throw Error(exponentOutOfRange + e);
        } else {
            // Zero.
            x.s = 0;
            x.e = 0;
            x.d = [
                0
            ];
        }
        return x;
    }
    /*
   * Round `x` to `sd` significant digits, using rounding mode `rm` if present (truncate otherwise).
   */ function round(x, sd, rm) {
        var i, j, k, n, rd, doRound, w, xdi, xd = x.d;
        // rd: the rounding digit, i.e. the digit after the digit that may be rounded up.
        // w: the word of xd which contains the rounding digit, a base 1e7 number.
        // xdi: the index of w within xd.
        // n: the number of digits of w.
        // i: what would be the index of rd within w if all the numbers were 7 digits long (i.e. if
        // they had leading zeros)
        // j: if > 0, the actual index of rd within w (if < 0, rd is a leading zero).
        // Get the length of the first word of the digits array xd.
        for(n = 1, k = xd[0]; k >= 10; k /= 10)n++;
        i = sd - n;
        // Is the rounding digit in the first word of xd?
        if (i < 0) {
            i += LOG_BASE;
            j = sd;
            w = xd[xdi = 0];
        } else {
            xdi = Math.ceil((i + 1) / LOG_BASE);
            k = xd.length;
            if (xdi >= k) return x;
            w = k = xd[xdi];
            // Get the number of digits of w.
            for(n = 1; k >= 10; k /= 10)n++;
            // Get the index of rd within w.
            i %= LOG_BASE;
            // Get the index of rd within w, adjusted for leading zeros.
            // The number of leading zeros of w is given by LOG_BASE - n.
            j = i - LOG_BASE + n;
        }
        if (rm !== void 0) {
            k = mathpow(10, n - j - 1);
            // Get the rounding digit at index j of w.
            rd = w / k % 10 | 0;
            // Are there any non-zero digits after the rounding digit?
            doRound = sd < 0 || xd[xdi + 1] !== void 0 || w % k;
            // The expression `w % mathpow(10, n - j - 1)` returns all the digits of w to the right of the
            // digit at (left-to-right) index j, e.g. if w is 908714 and j is 2, the expression will give
            // 714.
            doRound = rm < 4 ? (rd || doRound) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || doRound || rm == 6 && (i > 0 ? j > 0 ? w / mathpow(10, n - j) : 0 : xd[xdi - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
        }
        if (sd < 1 || !xd[0]) {
            if (doRound) {
                k = getBase10Exponent(x);
                xd.length = 1;
                // Convert sd to decimal places.
                sd = sd - k - 1;
                // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                xd[0] = mathpow(10, (LOG_BASE - sd % LOG_BASE) % LOG_BASE);
                x.e = mathfloor(-sd / LOG_BASE) || 0;
            } else {
                xd.length = 1;
                // Zero.
                xd[0] = x.e = x.s = 0;
            }
            return x;
        }
        // Remove excess digits.
        if (i == 0) {
            xd.length = xdi;
            k = 1;
            xdi--;
        } else {
            xd.length = xdi + 1;
            k = mathpow(10, LOG_BASE - i);
            // E.g. 56700 becomes 56000 if 7 is the rounding digit.
            // j > 0 means i > number of leading zeros of w.
            xd[xdi] = j > 0 ? (w / mathpow(10, n - j) % mathpow(10, j) | 0) * k : 0;
        }
        if (doRound) {
            for(;;)// Is the digit to be rounded up in the first word of xd?
            if (xdi == 0) {
                if ((xd[0] += k) == BASE) {
                    xd[0] = 1;
                    ++x.e;
                }
                break;
            } else {
                xd[xdi] += k;
                if (xd[xdi] != BASE) break;
                xd[xdi--] = 0;
                k = 1;
            }
        }
        // Remove trailing zeros.
        for(i = xd.length; xd[--i] === 0;)xd.pop();
        if (external && (x.e > MAX_E || x.e < -MAX_E)) throw Error(exponentOutOfRange + getBase10Exponent(x));
        return x;
    }
    function subtract(x, y) {
        var d, e, i, j, k, len, xd, xe, xLTy, yd, Ctor = x.constructor, pr = Ctor.precision;
        // Return y negated if x is zero.
        // Return x if y is zero and x is non-zero.
        if (!x.s || !y.s) {
            if (y.s) y.s = -y.s;
            else y = new Ctor(x);
            return external ? round(y, pr) : y;
        }
        xd = x.d;
        yd = y.d;
        // x and y are non-zero numbers with the same sign.
        e = y.e;
        xe = x.e;
        xd = xd.slice();
        k = xe - e;
        // If exponents differ...
        if (k) {
            xLTy = k < 0;
            if (xLTy) {
                d = xd;
                k = -k;
                len = yd.length;
            } else {
                d = yd;
                e = xe;
                len = xd.length;
            }
            // Numbers with massively different exponents would result in a very high number of zeros
            // needing to be prepended, but this can be avoided while still ensuring correct rounding by
            // limiting the number of zeros to `Math.ceil(pr / LOG_BASE) + 2`.
            i = Math.max(Math.ceil(pr / LOG_BASE), len) + 2;
            if (k > i) {
                k = i;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents.
            d.reverse();
            for(i = k; i--;)d.push(0);
            d.reverse();
        // Base 1e7 exponents equal.
        } else {
            // Check digits to determine which is the bigger number.
            i = xd.length;
            len = yd.length;
            xLTy = i < len;
            if (xLTy) len = i;
            for(i = 0; i < len; i++)if (xd[i] != yd[i]) {
                xLTy = xd[i] < yd[i];
                break;
            }
            k = 0;
        }
        if (xLTy) {
            d = xd;
            xd = yd;
            yd = d;
            y.s = -y.s;
        }
        len = xd.length;
        // Append zeros to xd if shorter.
        // Don't add zeros to yd if shorter as subtraction only needs to start at yd length.
        for(i = yd.length - len; i > 0; --i)xd[len++] = 0;
        // Subtract yd from xd.
        for(i = yd.length; i > k;){
            if (xd[--i] < yd[i]) {
                for(j = i; j && xd[--j] === 0;)xd[j] = BASE - 1;
                --xd[j];
                xd[i] += BASE;
            }
            xd[i] -= yd[i];
        }
        // Remove trailing zeros.
        for(; xd[--len] === 0;)xd.pop();
        // Remove leading zeros and adjust exponent accordingly.
        for(; xd[0] === 0; xd.shift())--e;
        // Zero?
        if (!xd[0]) return new Ctor(0);
        y.d = xd;
        y.e = e;
        //return external && xd.length >= pr / LOG_BASE ? round(y, pr) : y;
        return external ? round(y, pr) : y;
    }
    function toString(x, isExp, sd) {
        var k, e = getBase10Exponent(x), str = digitsToString(x.d), len = str.length;
        if (isExp) {
            if (sd && (k = sd - len) > 0) str = str.charAt(0) + '.' + str.slice(1) + getZeroString(k);
            else if (len > 1) str = str.charAt(0) + '.' + str.slice(1);
            str = str + (e < 0 ? 'e' : 'e+') + e;
        } else if (e < 0) {
            str = '0.' + getZeroString(-e - 1) + str;
            if (sd && (k = sd - len) > 0) str += getZeroString(k);
        } else if (e >= len) {
            str += getZeroString(e + 1 - len);
            if (sd && (k = sd - e - 1) > 0) str = str + '.' + getZeroString(k);
        } else {
            if ((k = e + 1) < len) str = str.slice(0, k) + '.' + str.slice(k);
            if (sd && (k = sd - len) > 0) {
                if (e + 1 === len) str += '.';
                str += getZeroString(k);
            }
        }
        return x.s < 0 ? '-' + str : str;
    }
    // Does not strip trailing zeros.
    function truncate(arr, len) {
        if (arr.length > len) {
            arr.length = len;
            return true;
        }
    }
    // Decimal methods
    /*
   *  clone
   *  config/set
   */ /*
   * Create and return a Decimal constructor with the same configuration properties as this Decimal
   * constructor.
   *
   */ function clone(obj) {
        var i, p, ps;
        /*
     * The Decimal constructor and exported function.
     * Return a new Decimal instance.
     *
     * value {number|string|Decimal} A numeric value.
     *
     */ function Decimal(value) {
            var x = this;
            // Decimal called without new.
            if (!(x instanceof Decimal)) return new Decimal(value);
            // Retain a reference to this Decimal constructor, and shadow Decimal.prototype.constructor
            // which points to Object.
            x.constructor = Decimal;
            // Duplicate.
            if (value instanceof Decimal) {
                x.s = value.s;
                x.e = value.e;
                x.d = (value = value.d) ? value.slice() : value;
                return;
            }
            if (typeof value === 'number') {
                // Reject Infinity/NaN.
                if (value * 0 !== 0) throw Error(invalidArgument + value);
                if (value > 0) x.s = 1;
                else if (value < 0) {
                    value = -value;
                    x.s = -1;
                } else {
                    x.s = 0;
                    x.e = 0;
                    x.d = [
                        0
                    ];
                    return;
                }
                // Fast path for small integers.
                if (value === ~~value && value < 1e7) {
                    x.e = 0;
                    x.d = [
                        value
                    ];
                    return;
                }
                return parseDecimal(x, value.toString());
            } else if (typeof value !== 'string') throw Error(invalidArgument + value);
            // Minus sign?
            if (value.charCodeAt(0) === 45) {
                value = value.slice(1);
                x.s = -1;
            } else x.s = 1;
            if (isDecimal.test(value)) parseDecimal(x, value);
            else throw Error(invalidArgument + value);
        }
        Decimal.prototype = P;
        Decimal.ROUND_UP = 0;
        Decimal.ROUND_DOWN = 1;
        Decimal.ROUND_CEIL = 2;
        Decimal.ROUND_FLOOR = 3;
        Decimal.ROUND_HALF_UP = 4;
        Decimal.ROUND_HALF_DOWN = 5;
        Decimal.ROUND_HALF_EVEN = 6;
        Decimal.ROUND_HALF_CEIL = 7;
        Decimal.ROUND_HALF_FLOOR = 8;
        Decimal.clone = clone;
        Decimal.config = Decimal.set = config;
        if (obj === void 0) obj = {};
        if (obj) {
            ps = [
                'precision',
                'rounding',
                'toExpNeg',
                'toExpPos',
                'LN10'
            ];
            for(i = 0; i < ps.length;)if (!obj.hasOwnProperty(p = ps[i++])) obj[p] = this[p];
        }
        Decimal.config(obj);
        return Decimal;
    }
    /*
   * Configure global settings for a Decimal constructor.
   *
   * `obj` is an object with one or more of the following properties,
   *
   *   precision  {number}
   *   rounding   {number}
   *   toExpNeg   {number}
   *   toExpPos   {number}
   *
   * E.g. Decimal.config({ precision: 20, rounding: 4 })
   *
   */ function config(obj) {
        if (!obj || typeof obj !== 'object') throw Error(decimalError + 'Object expected');
        var i, p, v, ps = [
            'precision',
            1,
            MAX_DIGITS,
            'rounding',
            0,
            8,
            'toExpNeg',
            -1 / 0,
            0,
            'toExpPos',
            0,
            1 / 0
        ];
        for(i = 0; i < ps.length; i += 3)if ((v = obj[p = ps[i]]) !== void 0) {
            if (mathfloor(v) === v && v >= ps[i + 1] && v <= ps[i + 2]) this[p] = v;
            else throw Error(invalidArgument + p + ': ' + v);
        }
        if ((v = obj[p = 'LN10']) !== void 0) {
            if (v == Math.LN10) this[p] = new this(v);
            else throw Error(invalidArgument + p + ': ' + v);
        }
        return this;
    }
    // Create and configure initial Decimal constructor.
    Decimal = clone(Decimal);
    Decimal['default'] = Decimal.Decimal = Decimal;
    // Internal constant.
    ONE = new Decimal(1);
    // Export.
    // AMD.
    if (typeof define == 'function' && define.amd) define(function() {
        return Decimal;
    });
    else if ($219758f2ddabdf68$exports) $219758f2ddabdf68$exports = Decimal;
    else {
        if (!globalScope) globalScope = typeof self != 'undefined' && self && self.self == self ? self : Function('return this')();
        globalScope.Decimal = Decimal;
    }
})($219758f2ddabdf68$exports);


/**
 * @fileOverview Some common arithmetic methods
 * @author xile611
 * @date 2015-09-17
 */ 
/**
 * Get the digit count of a number.
 * If the absolute value is in the interval [0.1, 1), the result is 0.
 * If the absolute value is in the interval [0.01, 0.1), the digit count is -1.
 * If the absolute value is in the interval [0.001, 0.01), the digit count is -2.
 *
 * @param  {Number} value The number
 * @return {Integer}      Digit count
 */ function $a00234b9eba2da75$export$c21fa0a8c666ce01(value) {
    var result;
    if (value === 0) result = 1;
    else result = Math.floor(new (0, (/*@__PURE__*/$parcel$interopDefault($219758f2ddabdf68$exports)))(value).abs().log(10).toNumber()) + 1;
    return result;
}
/**
 * Get the data in the interval [start, end) with a fixed step.
 * Also handles JS calculation precision issues.
 *
 * @param  {Decimal} start Start point
 * @param  {Decimal} end   End point, not included
 * @param  {Decimal} step  Step size
 * @return {Array}         Array of numbers
 */ function $a00234b9eba2da75$export$85207d4610782ccb(start, end, step) {
    var num = new (0, (/*@__PURE__*/$parcel$interopDefault($219758f2ddabdf68$exports)))(start);
    var i = 0;
    var result = [];
    // magic number to prevent infinite loop
    while(num.lt(end) && i < 100000){
        result.push(num.toNumber());
        num = num.add(step);
        i++;
    }
    return result;
}


var $751892f5774e0212$export$9fcf9e98b0fc6c13 = (_ref)=>{
    var [min, max] = _ref;
    var [validMin, validMax] = [
        min,
        max
    ];
    // exchange
    if (min > max) [validMin, validMax] = [
        max,
        min
    ];
    return [
        validMin,
        validMax
    ];
};
var $751892f5774e0212$export$2e59d63884599fab = (roughStep, allowDecimals, correctionFactor)=>{
    if (roughStep.lte(0)) return new (0, (/*@__PURE__*/$parcel$interopDefault($219758f2ddabdf68$exports)))(0);
    var digitCount = (0, $a00234b9eba2da75$export$c21fa0a8c666ce01)(roughStep.toNumber());
    // The ratio between the rough step and the smallest number which has a bigger
    // order of magnitudes than the rough step
    var digitCountValue = new (0, (/*@__PURE__*/$parcel$interopDefault($219758f2ddabdf68$exports)))(10).pow(digitCount);
    var stepRatio = roughStep.div(digitCountValue);
    // When an integer and a float multiplied, the accuracy of result may be wrong
    var stepRatioScale = digitCount !== 1 ? 0.05 : 0.1;
    var amendStepRatio = new (0, (/*@__PURE__*/$parcel$interopDefault($219758f2ddabdf68$exports)))(Math.ceil(stepRatio.div(stepRatioScale).toNumber())).add(correctionFactor).mul(stepRatioScale);
    var formatStep = amendStepRatio.mul(digitCountValue);
    return allowDecimals ? new (0, (/*@__PURE__*/$parcel$interopDefault($219758f2ddabdf68$exports)))(formatStep.toNumber()) : new (0, (/*@__PURE__*/$parcel$interopDefault($219758f2ddabdf68$exports)))(Math.ceil(formatStep.toNumber()));
};
var $751892f5774e0212$export$2247094b407efa80 = (roughStep, allowDecimals, correctionFactor)=>{
    var _NICE_STEPS$niceIdx;
    if (roughStep.lte(0)) return new (0, (/*@__PURE__*/$parcel$interopDefault($219758f2ddabdf68$exports)))(0);
    var NICE_STEPS = [
        1,
        2,
        2.5,
        5
    ];
    var roughNum = roughStep.toNumber();
    var exponent = Math.floor(new (0, (/*@__PURE__*/$parcel$interopDefault($219758f2ddabdf68$exports)))(roughNum).abs().log(10).toNumber());
    var magnitude = new (0, (/*@__PURE__*/$parcel$interopDefault($219758f2ddabdf68$exports)))(10).pow(exponent);
    // normalized is in the range [1, 10)
    var normalized = roughStep.div(magnitude).toNumber();
    // Find the smallest nice step >= normalized (ceiling)
    var niceIdx = NICE_STEPS.findIndex((s)=>s >= normalized - 1e-10);
    if (niceIdx === -1) {
        // normalized > 5 (e.g. 7.3), move to next order of magnitude
        magnitude = magnitude.mul(10);
        niceIdx = 0;
    }
    // Apply correction factor by stepping through the nice number sequence
    niceIdx += correctionFactor;
    if (niceIdx >= NICE_STEPS.length) {
        var extraMag = Math.floor(niceIdx / NICE_STEPS.length);
        niceIdx %= NICE_STEPS.length;
        magnitude = magnitude.mul(new (0, (/*@__PURE__*/$parcel$interopDefault($219758f2ddabdf68$exports)))(10).pow(extraMag));
    }
    var niceStep = (_NICE_STEPS$niceIdx = NICE_STEPS[niceIdx]) !== null && _NICE_STEPS$niceIdx !== void 0 ? _NICE_STEPS$niceIdx : 1;
    var formatStep = new (0, (/*@__PURE__*/$parcel$interopDefault($219758f2ddabdf68$exports)))(niceStep).mul(magnitude);
    return allowDecimals ? formatStep : new (0, (/*@__PURE__*/$parcel$interopDefault($219758f2ddabdf68$exports)))(Math.ceil(formatStep.toNumber()));
};
var $751892f5774e0212$export$8913aec4ff751b4d = (value, tickCount, allowDecimals)=>{
    var step = new (0, (/*@__PURE__*/$parcel$interopDefault($219758f2ddabdf68$exports)))(1);
    // calculate the middle value of ticks
    var middle = new (0, (/*@__PURE__*/$parcel$interopDefault($219758f2ddabdf68$exports)))(value);
    if (!middle.isint() && allowDecimals) {
        var absVal = Math.abs(value);
        if (absVal < 1) {
            // The step should be a float number when the difference is smaller than 1
            step = new (0, (/*@__PURE__*/$parcel$interopDefault($219758f2ddabdf68$exports)))(10).pow((0, $a00234b9eba2da75$export$c21fa0a8c666ce01)(value) - 1);
            middle = new (0, (/*@__PURE__*/$parcel$interopDefault($219758f2ddabdf68$exports)))(Math.floor(middle.div(step).toNumber())).mul(step);
        } else if (absVal > 1) // Return the maximum integer which is smaller than 'value' when 'value' is greater than 1
        middle = new (0, (/*@__PURE__*/$parcel$interopDefault($219758f2ddabdf68$exports)))(Math.floor(value));
    } else if (value === 0) middle = new (0, (/*@__PURE__*/$parcel$interopDefault($219758f2ddabdf68$exports)))(Math.floor((tickCount - 1) / 2));
    else if (!allowDecimals) middle = new (0, (/*@__PURE__*/$parcel$interopDefault($219758f2ddabdf68$exports)))(Math.floor(value));
    var middleIndex = Math.floor((tickCount - 1) / 2);
    var ticks = [];
    for(var i = 0; i < tickCount; i++)ticks.push(middle.add(new (0, (/*@__PURE__*/$parcel$interopDefault($219758f2ddabdf68$exports)))(i - middleIndex).mul(step)).toNumber());
    return ticks;
};
/**
 * Calculate the step
 *
 * @param  min              The minimum value of an interval
 * @param  max              The maximum value of an interval
 * @param  tickCount        The count of ticks
 * @param  allowDecimals    Allow the ticks to be decimals or not
 * @param  correctionFactor A correction factor
 * @return The step, minimum value of ticks, maximum value of ticks
 */ var $751892f5774e0212$export$ca78fcd978995194 = function calculateStep(min, max, tickCount, allowDecimals) {
    var correctionFactor = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
    var stepFn = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : $751892f5774e0212$export$2e59d63884599fab;
    // dirty hack (for recharts' test)
    if (!Number.isFinite((max - min) / (tickCount - 1))) return {
        step: new (0, (/*@__PURE__*/$parcel$interopDefault($219758f2ddabdf68$exports)))(0),
        tickMin: new (0, (/*@__PURE__*/$parcel$interopDefault($219758f2ddabdf68$exports)))(0),
        tickMax: new (0, (/*@__PURE__*/$parcel$interopDefault($219758f2ddabdf68$exports)))(0)
    };
    // The step which is easy to understand between two ticks
    var step = stepFn(new (0, (/*@__PURE__*/$parcel$interopDefault($219758f2ddabdf68$exports)))(max).sub(min).div(tickCount - 1), allowDecimals, correctionFactor);
    // A medial value of ticks
    var middle;
    // When 0 is inside the interval, 0 should be a tick
    if (min <= 0 && max >= 0) middle = new (0, (/*@__PURE__*/$parcel$interopDefault($219758f2ddabdf68$exports)))(0);
    else {
        // calculate the middle value
        middle = new (0, (/*@__PURE__*/$parcel$interopDefault($219758f2ddabdf68$exports)))(min).add(max).div(2);
        // minus modulo value
        middle = middle.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($219758f2ddabdf68$exports)))(middle).mod(step));
    }
    var belowCount = Math.ceil(middle.sub(min).div(step).toNumber());
    var upCount = Math.ceil(new (0, (/*@__PURE__*/$parcel$interopDefault($219758f2ddabdf68$exports)))(max).sub(middle).div(step).toNumber());
    var scaleCount = belowCount + upCount + 1;
    if (scaleCount > tickCount) // When more ticks need to cover the interval, step should be bigger.
    return $751892f5774e0212$export$ca78fcd978995194(min, max, tickCount, allowDecimals, correctionFactor + 1, stepFn);
    if (scaleCount < tickCount) {
        // When less ticks can cover the interval, we should add some additional ticks
        upCount = max > 0 ? upCount + (tickCount - scaleCount) : upCount;
        belowCount = max > 0 ? belowCount : belowCount + (tickCount - scaleCount);
    }
    return {
        step: step,
        tickMin: middle.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($219758f2ddabdf68$exports)))(belowCount).mul(step)),
        tickMax: middle.add(new (0, (/*@__PURE__*/$parcel$interopDefault($219758f2ddabdf68$exports)))(upCount).mul(step))
    };
};
var $751892f5774e0212$export$b84e75ccbfe6a612 = function getNiceTickValues(_ref2) {
    var [min, max] = _ref2;
    var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var niceTicksMode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'auto';
    // More than two ticks should be return
    var count = Math.max(tickCount, 2);
    var [cormin, cormax] = $751892f5774e0212$export$9fcf9e98b0fc6c13([
        min,
        max
    ]);
    if (cormin === -Infinity || cormax === Infinity) {
        var _values = cormax === Infinity ? [
            cormin,
            ...Array(tickCount - 1).fill(Infinity)
        ] : [
            ...Array(tickCount - 1).fill(-Infinity),
            cormax
        ];
        return min > max ? _values.reverse() : _values;
    }
    if (cormin === cormax) return $751892f5774e0212$export$8913aec4ff751b4d(cormin, tickCount, allowDecimals);
    var stepFn = niceTicksMode === 'snap125' ? $751892f5774e0212$export$2247094b407efa80 : $751892f5774e0212$export$2e59d63884599fab;
    // Get the step between two ticks
    var { step: step, tickMin: tickMin, tickMax: tickMax } = $751892f5774e0212$export$ca78fcd978995194(cormin, cormax, count, allowDecimals, 0, stepFn);
    var values = (0, $a00234b9eba2da75$export$85207d4610782ccb)(tickMin, tickMax.add(new (0, (/*@__PURE__*/$parcel$interopDefault($219758f2ddabdf68$exports)))(0.1).mul(step)), step);
    return min > max ? values.reverse() : values;
};
var $751892f5774e0212$export$e9d28da780436e98 = function getTickValuesFixedDomain(_ref3, tickCount) {
    var [min, max] = _ref3;
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var niceTicksMode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'auto';
    // More than two ticks should be return
    var [cormin, cormax] = $751892f5774e0212$export$9fcf9e98b0fc6c13([
        min,
        max
    ]);
    if (cormin === -Infinity || cormax === Infinity) return [
        min,
        max
    ];
    if (cormin === cormax) return [
        cormin
    ];
    var stepFn = niceTicksMode === 'snap125' ? $751892f5774e0212$export$2247094b407efa80 : $751892f5774e0212$export$2e59d63884599fab;
    var count = Math.max(tickCount, 2);
    var step = stepFn(new (0, (/*@__PURE__*/$parcel$interopDefault($219758f2ddabdf68$exports)))(cormax).sub(cormin).div(count - 1), allowDecimals, 0);
    var values = [
        ...(0, $a00234b9eba2da75$export$85207d4610782ccb)(new (0, (/*@__PURE__*/$parcel$interopDefault($219758f2ddabdf68$exports)))(cormin), new (0, (/*@__PURE__*/$parcel$interopDefault($219758f2ddabdf68$exports)))(cormax), step),
        cormax
    ];
    if (allowDecimals === false) /*
     * allowDecimals is false means that we want to have integer ticks.
     * The step is guaranteed to be an integer in the code above which is great start
     * but when the first step is not an integer, it will start stepping from a decimal value anyway.
     * So we need to round all the values to integers after the fact.
     */ values = values.map((value)=>Math.round(value));
    return min > max ? values.reverse() : values;
};






var $1728a742f9386be1$export$db43f3089e0ec1e9 = (state)=>state.rootProps.maxBarSize;
var $1728a742f9386be1$export$9b8e3d53e72fb7a8 = (state)=>state.rootProps.barGap;
var $1728a742f9386be1$export$a73f9d39b015942a = (state)=>state.rootProps.barCategoryGap;
var $1728a742f9386be1$export$be00206a4a82272f = (state)=>state.rootProps.barSize;
var $1728a742f9386be1$export$73aff39176364def = (state)=>state.rootProps.stackOffset;
var $1728a742f9386be1$export$ec830dc49707c6da = (state)=>state.rootProps.reverseStackOrder;
var $1728a742f9386be1$export$3247769c9dbde559 = (state)=>state.options.chartName;
var $1728a742f9386be1$export$d3b88e5c88540018 = (state)=>state.rootProps.syncId;
var $1728a742f9386be1$export$f3cbf53653105e96 = (state)=>state.rootProps.syncMethod;
var $1728a742f9386be1$export$b89defd58e84e980 = (state)=>state.options.eventEmitter;
var $1728a742f9386be1$export$a1ad1f48be8d5def = (state)=>state.rootProps.baseValue;



var $0356005269dcff20$export$8a7d579879340d98 = (_state, axisType)=>axisType;


var $8a59510828e5484a$export$6a2efa106dc9c8f6 = (_state, _axisType, axisId)=>axisId;




/**
 * Returns identifier for stack series which is one individual graphical item in the stack.
 * @param graphicalItem - The graphical item representing the series in the stack.
 * @return The identifier for the series in the stack
 */ function $a7f2a68891925785$export$58b095b87bc46727(graphicalItem) {
    return graphicalItem === null || graphicalItem === void 0 ? void 0 : graphicalItem.id;
}




function $c20d7381b4964aa5$export$ae6c77e7720cddf9(stackedGraphicalItems, _ref, tooltipAxisSettings) {
    var { chartData: chartData = [] } = _ref;
    var { allowDuplicatedCategory: allowDuplicatedCategory, dataKey: tooltipDataKey } = tooltipAxisSettings;
    // A map of tooltip data keys to the stacked data points
    var knownItemsByDataKey = new Map();
    stackedGraphicalItems.forEach((item)=>{
        var _item$data;
        // If there is no data on the individual item then we use the root chart data
        var resolvedData = (_item$data = item.data) !== null && _item$data !== void 0 ? _item$data : chartData;
        if (resolvedData == null || resolvedData.length === 0) // if that doesn't work then we skip this item
        return;
        var stackIdentifier = (0, $a7f2a68891925785$export$58b095b87bc46727)(item);
        resolvedData.forEach((entry, index)=>{
            var tooltipValue = tooltipDataKey == null || allowDuplicatedCategory ? index : String((0, $d5958b0668c58531$export$f97fc4a450f29a)(entry, tooltipDataKey, null));
            var numericValue = (0, $d5958b0668c58531$export$f97fc4a450f29a)(entry, item.dataKey, 0);
            var curr;
            if (knownItemsByDataKey.has(tooltipValue)) curr = knownItemsByDataKey.get(tooltipValue);
            else curr = {};
            Object.assign(curr, {
                [stackIdentifier]: numericValue
            });
            knownItemsByDataKey.set(tooltipValue, curr);
        });
    });
    return Array.from(knownItemsByDataKey.values());
}


/**
 * Some graphical items allow data stacking. The stacks are optional,
 * so all props here are optional too.
 */ /**
 * Some graphical items allow data stacking.
 * This interface is used to represent the items that are stacked
 * because the user has provided the stackId and dataKey properties.
 */ function $66614bffc4581796$export$2335dd91cc88053e(graphicalItem) {
    return 'stackId' in graphicalItem && graphicalItem.stackId != null && graphicalItem.dataKey != null;
}


var $30bf67e96df5a044$export$45c01007b107f1a6 = (a, b)=>{
    if (a === b) return true;
    if (a == null || b == null) return false;
    return a[0] === b[0] && a[1] === b[1];
};




var $ab8db2d9eb83d918$export$898d3dfd98fb482 = (state)=>{
    var layout = (0, $f4c9341f05a18477$export$8426b6d9af801dee)(state);
    if (layout === 'horizontal') return 'xAxis';
    if (layout === 'vertical') return 'yAxis';
    if (layout === 'centric') return 'angleAxis';
    return 'radiusAxis';
};


var $cbdc2e68b6a9737d$export$eeffdb10daff095d = (state)=>state.tooltip.settings.axisId;


/**
 * This is internal representation of scale used in Recharts.
 * Users will provide CustomScaleDefinition or a string, which we will parse into RechartsScale.
 * Most importantly, RechartsScale is fully immutable - there are no setters that mutate the scale in place.
 * This is important for React integration - if the scale changes, we want to trigger re-renders.
 * Mutating the scale in place would not trigger re-renders, leading to stale UI.
 */ /**
 * Position within a band for banded scales.
 * In scales that are not banded, this parameter is ignored.
 *
 * @inline
 */ function $3ec4ee43aef296c2$export$5501a52df751e5ca(d3Scale) {
    if (d3Scale == null) return undefined;
    var ticksFn = d3Scale.ticks;
    var bandwidthFn = d3Scale.bandwidth;
    var d3Range = d3Scale.range();
    var range = [
        Math.min(...d3Range),
        Math.max(...d3Range)
    ];
    return {
        domain: ()=>d3Scale.domain(),
        range: function(_range) {
            function range() {
                return _range.apply(this, arguments);
            }
            range.toString = function() {
                return _range.toString();
            };
            return range;
        }(()=>range),
        rangeMin: ()=>range[0],
        rangeMax: ()=>range[1],
        isInRange (value) {
            var first = range[0];
            var last = range[1];
            return first <= last ? value >= first && value <= last : value >= last && value <= first;
        },
        bandwidth: bandwidthFn ? ()=>bandwidthFn.call(d3Scale) : undefined,
        ticks: ticksFn ? (count)=>ticksFn.call(d3Scale, count) : undefined,
        map: (input, options)=>{
            var baseValue = d3Scale(input);
            if (baseValue == null) return undefined;
            if (d3Scale.bandwidth && options !== null && options !== void 0 && options.position) {
                var bandWidth = d3Scale.bandwidth();
                switch(options.position){
                    case 'middle':
                        baseValue += bandWidth / 2;
                        break;
                    case 'end':
                        baseValue += bandWidth;
                        break;
                    default:
                        break;
                }
            }
            return baseValue;
        }
    };
}




var $37a0c522921b7bfa$export$cd6ce636c480934e = (realScaleType, axisDomain)=>{
    if (axisDomain == null) return undefined;
    switch(realScaleType){
        case 'linear':
            /*
         * linear scale only reads the first two numbers in the domain, and ignores everything else.
         * So if it happens that someone somehow gave us a bigger domain,
         * let's pick the min and max from it.
         */ if (!(0, $5bcc5341b7e18f2a$export$ba29b24e2a92eb58)(axisDomain)) {
                var min, max;
                for(var i = 0; i < axisDomain.length; i++){
                    var value = axisDomain[i];
                    if (!(0, $22869ac8a5888437$export$f8a8fc612ced9bb0)(value)) continue;
                    if (min === undefined || value < min) min = value;
                    if (max === undefined || value > max) max = value;
                }
                if (min !== undefined && max !== undefined) return [
                    min,
                    max
                ];
                return undefined;
            }
            return axisDomain;
        default:
            return axisDomain;
    }
};


var $e2b5351039fefa1b$exports = {};
// `victory-vendor/d3-scale` (ESM)
// See upstream license: https://github.com/d3/d3-scale/blob/main/LICENSE
//
// Our ESM package uses the underlying installed dependencies of `node_modules/d3-scale`
var $1af815627d835c18$exports = {};

$parcel$export($1af815627d835c18$exports, "scaleBand", () => $6a7ad823f9207e2a$export$2e2bcd8739ae039);
$parcel$export($1af815627d835c18$exports, "scalePoint", () => $6a7ad823f9207e2a$export$105684a3041cb6f3);
$parcel$export($1af815627d835c18$exports, "scaleIdentity", () => $94472f1dbbe6a48b$export$2e2bcd8739ae039);
$parcel$export($1af815627d835c18$exports, "scaleLinear", () => $7369c722765cb59f$export$2e2bcd8739ae039);
$parcel$export($1af815627d835c18$exports, "scaleLog", () => $659bacbca617da2e$export$2e2bcd8739ae039);
$parcel$export($1af815627d835c18$exports, "scaleSymlog", () => $6d6ed92c9022be1f$export$2e2bcd8739ae039);
$parcel$export($1af815627d835c18$exports, "scaleOrdinal", () => $0aa20bd3a7f361d1$export$2e2bcd8739ae039);
$parcel$export($1af815627d835c18$exports, "scaleImplicit", () => $0aa20bd3a7f361d1$export$e4f898ab14d9d460);
$parcel$export($1af815627d835c18$exports, "scalePow", () => $ddc8211c8a258942$export$2e2bcd8739ae039);
$parcel$export($1af815627d835c18$exports, "scaleSqrt", () => $ddc8211c8a258942$export$eba8049fb5020b81);
$parcel$export($1af815627d835c18$exports, "scaleRadial", () => $73de4f14fa79df42$export$2e2bcd8739ae039);
$parcel$export($1af815627d835c18$exports, "scaleQuantile", () => $e239697f987de752$export$2e2bcd8739ae039);
$parcel$export($1af815627d835c18$exports, "scaleQuantize", () => $b3675204aae59040$export$2e2bcd8739ae039);
$parcel$export($1af815627d835c18$exports, "scaleThreshold", () => $feeb64ed89911bb5$export$2e2bcd8739ae039);
$parcel$export($1af815627d835c18$exports, "scaleTime", () => $bd770533f55a6231$export$2e2bcd8739ae039);
$parcel$export($1af815627d835c18$exports, "scaleUtc", () => $81433a1ec5a018a0$export$2e2bcd8739ae039);
$parcel$export($1af815627d835c18$exports, "scaleSequential", () => $be828bbb873b60e2$export$2e2bcd8739ae039);
$parcel$export($1af815627d835c18$exports, "scaleSequentialLog", () => $be828bbb873b60e2$export$6843e08bf2ff981f);
$parcel$export($1af815627d835c18$exports, "scaleSequentialPow", () => $be828bbb873b60e2$export$de9f78581b4f2405);
$parcel$export($1af815627d835c18$exports, "scaleSequentialSqrt", () => $be828bbb873b60e2$export$413d935127ed466e);
$parcel$export($1af815627d835c18$exports, "scaleSequentialSymlog", () => $be828bbb873b60e2$export$9d4af4de62c81941);
$parcel$export($1af815627d835c18$exports, "scaleSequentialQuantile", () => $3b6da429b3438544$export$2e2bcd8739ae039);
$parcel$export($1af815627d835c18$exports, "scaleDiverging", () => $d66475b85a502928$export$2e2bcd8739ae039);
$parcel$export($1af815627d835c18$exports, "scaleDivergingLog", () => $d66475b85a502928$export$5f0266a9159c47fb);
$parcel$export($1af815627d835c18$exports, "scaleDivergingPow", () => $d66475b85a502928$export$d6cedcc63bf26e7e);
$parcel$export($1af815627d835c18$exports, "scaleDivergingSqrt", () => $d66475b85a502928$export$33ddefb5c4ab9e9c);
$parcel$export($1af815627d835c18$exports, "scaleDivergingSymlog", () => $d66475b85a502928$export$50b3da713cf557c6);
$parcel$export($1af815627d835c18$exports, "tickFormat", () => $1d26b38b0d516dab$export$2e2bcd8739ae039);
function $dec4059bb47a5e6a$export$2e2bcd8739ae039(start, stop, step) {
    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
    var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
    while(++i < n)range[i] = start + i * step;
    return range;
}


function $1f5f05714ccdd883$export$23c7bb9e6558da2a(domain, range) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.range(domain);
            break;
        default:
            this.range(range).domain(domain);
            break;
    }
    return this;
}
function $1f5f05714ccdd883$export$7d6b419e59e83f3d(domain, interpolator) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            if (typeof domain === "function") this.interpolator(domain);
            else this.range(domain);
            break;
        default:
            this.domain(domain);
            if (typeof interpolator === "function") this.interpolator(interpolator);
            else this.range(interpolator);
            break;
    }
    return this;
}


class $2884b9e357b5db36$export$dcc6fb7d82b5bc7b extends Map {
    constructor(entries, key = $2884b9e357b5db36$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (entries != null) for (const [key, value] of entries)this.set(key, value);
    }
    get(key) {
        return super.get($2884b9e357b5db36$var$intern_get(this, key));
    }
    has(key) {
        return super.has($2884b9e357b5db36$var$intern_get(this, key));
    }
    set(key, value) {
        return super.set($2884b9e357b5db36$var$intern_set(this, key), value);
    }
    delete(key) {
        return super.delete($2884b9e357b5db36$var$intern_delete(this, key));
    }
}
class $2884b9e357b5db36$export$55278c3294239828 extends Set {
    constructor(values, key = $2884b9e357b5db36$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (values != null) for (const value of values)this.add(value);
    }
    has(value) {
        return super.has($2884b9e357b5db36$var$intern_get(this, value));
    }
    add(value) {
        return super.add($2884b9e357b5db36$var$intern_set(this, value));
    }
    delete(value) {
        return super.delete($2884b9e357b5db36$var$intern_delete(this, value));
    }
}
function $2884b9e357b5db36$var$intern_get({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    return _intern.has(key) ? _intern.get(key) : value;
}
function $2884b9e357b5db36$var$intern_set({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) return _intern.get(key);
    _intern.set(key, value);
    return value;
}
function $2884b9e357b5db36$var$intern_delete({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) {
        value = _intern.get(key);
        _intern.delete(key);
    }
    return value;
}
function $2884b9e357b5db36$var$keyof(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}



const $0aa20bd3a7f361d1$export$e4f898ab14d9d460 = Symbol("implicit");
function $0aa20bd3a7f361d1$export$2e2bcd8739ae039() {
    var index = new (0, $2884b9e357b5db36$export$dcc6fb7d82b5bc7b)(), domain = [], range = [], unknown = $0aa20bd3a7f361d1$export$e4f898ab14d9d460;
    function scale(d) {
        let i = index.get(d);
        if (i === undefined) {
            if (unknown !== $0aa20bd3a7f361d1$export$e4f898ab14d9d460) return unknown;
            index.set(d, i = domain.push(d) - 1);
        }
        return range[i % range.length];
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [], index = new (0, $2884b9e357b5db36$export$dcc6fb7d82b5bc7b)();
        for (const value of _){
            if (index.has(value)) continue;
            index.set(value, domain.push(value) - 1);
        }
        return scale;
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), scale) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $0aa20bd3a7f361d1$export$2e2bcd8739ae039(domain, range).unknown(unknown);
    };
    (0, $1f5f05714ccdd883$export$23c7bb9e6558da2a).apply(scale, arguments);
    return scale;
}


function $6a7ad823f9207e2a$export$2e2bcd8739ae039() {
    var scale = (0, $0aa20bd3a7f361d1$export$2e2bcd8739ae039)().unknown(undefined), domain = scale.domain, ordinalRange = scale.range, r0 = 0, r1 = 1, step, bandwidth, round = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
    delete scale.unknown;
    function rescale() {
        var n = domain().length, reverse = r1 < r0, start = reverse ? r1 : r0, stop = reverse ? r0 : r1;
        step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
        if (round) step = Math.floor(step);
        start += (stop - start - step * (n - paddingInner)) * align;
        bandwidth = step * (1 - paddingInner);
        if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
        var values = (0, $dec4059bb47a5e6a$export$2e2bcd8739ae039)(n).map(function(i) {
            return start + step * i;
        });
        return ordinalRange(reverse ? values.reverse() : values);
    }
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.range = function(_) {
        return arguments.length ? ([r0, r1] = _, r0 = +r0, r1 = +r1, rescale()) : [
            r0,
            r1
        ];
    };
    scale.rangeRound = function(_) {
        return [r0, r1] = _, r0 = +r0, r1 = +r1, round = true, rescale();
    };
    scale.bandwidth = function() {
        return bandwidth;
    };
    scale.step = function() {
        return step;
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, rescale()) : round;
    };
    scale.padding = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
    };
    scale.paddingInner = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
    };
    scale.paddingOuter = function(_) {
        return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
    };
    scale.align = function(_) {
        return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
    };
    scale.copy = function() {
        return $6a7ad823f9207e2a$export$2e2bcd8739ae039(domain(), [
            r0,
            r1
        ]).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
    };
    return (0, $1f5f05714ccdd883$export$23c7bb9e6558da2a).apply(rescale(), arguments);
}
function $6a7ad823f9207e2a$var$pointish(scale) {
    var copy = scale.copy;
    scale.padding = scale.paddingOuter;
    delete scale.paddingInner;
    delete scale.paddingOuter;
    scale.copy = function() {
        return $6a7ad823f9207e2a$var$pointish(copy());
    };
    return scale;
}
function $6a7ad823f9207e2a$export$105684a3041cb6f3() {
    return $6a7ad823f9207e2a$var$pointish($6a7ad823f9207e2a$export$2e2bcd8739ae039.apply(null, arguments).paddingInner(1));
}


const $8e8b0ab7237daf36$var$e10 = Math.sqrt(50), $8e8b0ab7237daf36$var$e5 = Math.sqrt(10), $8e8b0ab7237daf36$var$e2 = Math.sqrt(2);
function $8e8b0ab7237daf36$var$tickSpec(start, stop, count) {
    const step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log10(step)), error = step / Math.pow(10, power), factor = error >= $8e8b0ab7237daf36$var$e10 ? 10 : error >= $8e8b0ab7237daf36$var$e5 ? 5 : error >= $8e8b0ab7237daf36$var$e2 ? 2 : 1;
    let i1, i2, inc;
    if (power < 0) {
        inc = Math.pow(10, -power) / factor;
        i1 = Math.round(start * inc);
        i2 = Math.round(stop * inc);
        if (i1 / inc < start) ++i1;
        if (i2 / inc > stop) --i2;
        inc = -inc;
    } else {
        inc = Math.pow(10, power) * factor;
        i1 = Math.round(start / inc);
        i2 = Math.round(stop / inc);
        if (i1 * inc < start) ++i1;
        if (i2 * inc > stop) --i2;
    }
    if (i2 < i1 && 0.5 <= count && count < 2) return $8e8b0ab7237daf36$var$tickSpec(start, stop, count * 2);
    return [
        i1,
        i2,
        inc
    ];
}
function $8e8b0ab7237daf36$export$2e2bcd8739ae039(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    if (!(count > 0)) return [];
    if (start === stop) return [
        start
    ];
    const reverse = stop < start, [i1, i2, inc] = reverse ? $8e8b0ab7237daf36$var$tickSpec(stop, start, count) : $8e8b0ab7237daf36$var$tickSpec(start, stop, count);
    if (!(i2 >= i1)) return [];
    const n = i2 - i1 + 1, ticks = new Array(n);
    if (reverse) {
        if (inc < 0) for(let i = 0; i < n; ++i)ticks[i] = (i2 - i) / -inc;
        else for(let i = 0; i < n; ++i)ticks[i] = (i2 - i) * inc;
    } else {
        if (inc < 0) for(let i = 0; i < n; ++i)ticks[i] = (i1 + i) / -inc;
        else for(let i = 0; i < n; ++i)ticks[i] = (i1 + i) * inc;
    }
    return ticks;
}
function $8e8b0ab7237daf36$export$bc64d00cc98e7e95(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    return $8e8b0ab7237daf36$var$tickSpec(start, stop, count)[2];
}
function $8e8b0ab7237daf36$export$81087d9b915d4ede(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    const reverse = stop < start, inc = reverse ? $8e8b0ab7237daf36$export$bc64d00cc98e7e95(stop, start, count) : $8e8b0ab7237daf36$export$bc64d00cc98e7e95(start, stop, count);
    return (reverse ? -1 : 1) * (inc < 0 ? 1 / -inc : inc);
}


function $8bcd8071d2010e24$export$2e2bcd8739ae039(a, b) {
    return a == null || b == null ? NaN : a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}



function $8496a43cc06258e3$export$2e2bcd8739ae039(a, b) {
    return a == null || b == null ? NaN : b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}


function $7dc99ea5c1b76bf9$export$2e2bcd8739ae039(f) {
    let compare1, compare2, delta;
    // If an accessor is specified, promote it to a comparator. In this case we
    // can test whether the search value is (self-) comparable. We can’t do this
    // for a comparator (except for specific, known comparators) because we can’t
    // tell if the comparator is symmetric, and an asymmetric comparator can’t be
    // used to test whether a single value is comparable.
    if (f.length !== 2) {
        compare1 = (0, $8bcd8071d2010e24$export$2e2bcd8739ae039);
        compare2 = (d, x)=>(0, $8bcd8071d2010e24$export$2e2bcd8739ae039)(f(d), x);
        delta = (d, x)=>f(d) - x;
    } else {
        compare1 = f === (0, $8bcd8071d2010e24$export$2e2bcd8739ae039) || f === (0, $8496a43cc06258e3$export$2e2bcd8739ae039) ? f : $7dc99ea5c1b76bf9$var$zero;
        compare2 = f;
        delta = f;
    }
    function left(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) < 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function right(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) <= 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function center(a, x, lo = 0, hi = a.length) {
        const i = left(a, x, lo, hi - 1);
        return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
    }
    return {
        left: left,
        center: center,
        right: right
    };
}
function $7dc99ea5c1b76bf9$var$zero() {
    return 0;
}


function $09e73fc7c4df1c9a$export$2e2bcd8739ae039(x) {
    return x === null ? NaN : +x;
}
function* $09e73fc7c4df1c9a$export$1f6c9cc012ebacae(values, valueof) {
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) yield value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) yield value;
    }
}


const $7bf4b402f40c3a05$var$ascendingBisect = (0, $7dc99ea5c1b76bf9$export$2e2bcd8739ae039)((0, $8bcd8071d2010e24$export$2e2bcd8739ae039));
const $7bf4b402f40c3a05$export$4d945ad3ad5751b0 = $7bf4b402f40c3a05$var$ascendingBisect.right;
const $7bf4b402f40c3a05$export$df7d25c84ebd12a5 = $7bf4b402f40c3a05$var$ascendingBisect.left;
const $7bf4b402f40c3a05$export$c1cb828b1117c77b = (0, $7dc99ea5c1b76bf9$export$2e2bcd8739ae039)((0, $09e73fc7c4df1c9a$export$2e2bcd8739ae039)).center;
var $7bf4b402f40c3a05$export$2e2bcd8739ae039 = $7bf4b402f40c3a05$export$4d945ad3ad5751b0;



var $92NOe = parcelRequire("92NOe");

var $92NOe = parcelRequire("92NOe");
function $ff63ad9b60e1889f$export$4e41033bfeec1a4c(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function $ff63ad9b60e1889f$export$2e2bcd8739ae039(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return $ff63ad9b60e1889f$export$4e41033bfeec1a4c((t - i / n) * n, v0, v1, v2, v3);
    };
}



function $9305906caa76b45c$export$2e2bcd8739ae039(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, $ff63ad9b60e1889f$export$4e41033bfeec1a4c)((t - i / n) * n, v0, v1, v2, v3);
    };
}


var $8adf38f81b9cb824$export$2e2bcd8739ae039 = (x)=>()=>x;


function $80f33d13ec87ed93$var$linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function $80f33d13ec87ed93$var$exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function $80f33d13ec87ed93$export$97d7b0c7ddb78dcf(a, b) {
    var d = b - a;
    return d ? $80f33d13ec87ed93$var$linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, $8adf38f81b9cb824$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
}
function $80f33d13ec87ed93$export$a7ebe8cc6aaf8d37(y) {
    return (y = +y) === 1 ? $80f33d13ec87ed93$export$2e2bcd8739ae039 : function(a, b) {
        return b - a ? $80f33d13ec87ed93$var$exponential(a, b, y) : (0, $8adf38f81b9cb824$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
    };
}
function $80f33d13ec87ed93$export$2e2bcd8739ae039(a, b) {
    var d = b - a;
    return d ? $80f33d13ec87ed93$var$linear(a, d) : (0, $8adf38f81b9cb824$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
}


var $c834592b2d455d70$export$2e2bcd8739ae039 = function rgbGamma(y) {
    var color = (0, $80f33d13ec87ed93$export$a7ebe8cc6aaf8d37)(y);
    function rgb(start, end) {
        var r = color((start = (0, $92NOe.rgb)(start)).r, (end = (0, $92NOe.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, $80f33d13ec87ed93$export$2e2bcd8739ae039)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
function $c834592b2d455d70$var$rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, $92NOe.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var $c834592b2d455d70$export$2c0e28f2e2852d3f = $c834592b2d455d70$var$rgbSpline((0, $ff63ad9b60e1889f$export$2e2bcd8739ae039));
var $c834592b2d455d70$export$53d5214f625ccd4c = $c834592b2d455d70$var$rgbSpline((0, $9305906caa76b45c$export$2e2bcd8739ae039));



function $2911ccaa33776e7c$export$2e2bcd8739ae039(a, b) {
    if (!b) b = [];
    var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
    return function(t) {
        for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
        return c;
    };
}
function $2911ccaa33776e7c$export$5cd576d1827d40c8(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}


function $fb921966b2583178$export$2e2bcd8739ae039(a, b) {
    return ((0, $2911ccaa33776e7c$export$5cd576d1827d40c8)(b) ? (0, $2911ccaa33776e7c$export$2e2bcd8739ae039) : $fb921966b2583178$export$15d09067c6a5ee49)(a, b);
}
function $fb921966b2583178$export$15d09067c6a5ee49(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, $9df523648b668b48$export$2e2bcd8739ae039)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}


function $ed18876a09938d23$export$2e2bcd8739ae039(a, b) {
    var d = new Date;
    return a = +a, b = +b, function(t) {
        return d.setTime(a * (1 - t) + b * t), d;
    };
}


function $00ad65050bd6bdb2$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}



function $546b51826b6d8401$export$2e2bcd8739ae039(a, b) {
    var i = {}, c = {}, k;
    if (a === null || typeof a !== "object") a = {};
    if (b === null || typeof b !== "object") b = {};
    for(k in b)if (k in a) i[k] = (0, $9df523648b668b48$export$2e2bcd8739ae039)(a[k], b[k]);
    else c[k] = b[k];
    return function(t) {
        for(k in i)c[k] = i[k](t);
        return c;
    };
}



var $5aa0389fcdd18855$var$reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $5aa0389fcdd18855$var$reB = new RegExp($5aa0389fcdd18855$var$reA.source, "g");
function $5aa0389fcdd18855$var$zero(b) {
    return function() {
        return b;
    };
}
function $5aa0389fcdd18855$var$one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function $5aa0389fcdd18855$export$2e2bcd8739ae039(a, b) {
    var bi = $5aa0389fcdd18855$var$reA.lastIndex = $5aa0389fcdd18855$var$reB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + "";
    // Interpolate pairs of numbers in a & b.
    while((am = $5aa0389fcdd18855$var$reA.exec(a)) && (bm = $5aa0389fcdd18855$var$reB.exec(b))){
        if ((bs = bm.index) > bi) {
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            s[++i] = null;
            q.push({
                i: i,
                x: (0, $00ad65050bd6bdb2$export$2e2bcd8739ae039)(am, bm)
            });
        }
        bi = $5aa0389fcdd18855$var$reB.lastIndex;
    }
    // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    }
    // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? $5aa0389fcdd18855$var$one(q[0].x) : $5aa0389fcdd18855$var$zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}




function $9df523648b668b48$export$2e2bcd8739ae039(a, b) {
    var t = typeof b, c;
    return b == null || t === "boolean" ? (0, $8adf38f81b9cb824$export$2e2bcd8739ae039)(b) : (t === "number" ? (0, $00ad65050bd6bdb2$export$2e2bcd8739ae039) : t === "string" ? (c = (0, $92NOe.default)(b)) ? (b = c, $c834592b2d455d70$export$2e2bcd8739ae039) : (0, $5aa0389fcdd18855$export$2e2bcd8739ae039) : b instanceof (0, $92NOe.default) ? (0, $c834592b2d455d70$export$2e2bcd8739ae039) : b instanceof Date ? (0, $ed18876a09938d23$export$2e2bcd8739ae039) : (0, $2911ccaa33776e7c$export$5cd576d1827d40c8)(b) ? (0, $2911ccaa33776e7c$export$2e2bcd8739ae039) : Array.isArray(b) ? (0, $fb921966b2583178$export$15d09067c6a5ee49) : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? (0, $546b51826b6d8401$export$2e2bcd8739ae039) : (0, $00ad65050bd6bdb2$export$2e2bcd8739ae039))(a, b);
}

function $01a150189dfd6613$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return Math.round(a * (1 - t) + b * t);
    };
}


function $ff0459af053c5f81$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}


function $d2205860023cec4b$export$2e2bcd8739ae039(x) {
    return +x;
}


var $ff5ec137a7df2572$var$unit = [
    0,
    1
];
function $ff5ec137a7df2572$export$f0954fd7d5368655(x) {
    return x;
}
function $ff5ec137a7df2572$var$normalize(a, b) {
    return (b -= a = +a) ? function(x) {
        return (x - a) / b;
    } : (0, $ff0459af053c5f81$export$2e2bcd8739ae039)(isNaN(b) ? NaN : 0.5);
}
function $ff5ec137a7df2572$var$clamper(a, b) {
    var t;
    if (a > b) t = a, a = b, b = t;
    return function(x) {
        return Math.max(a, Math.min(b, x));
    };
}
// normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function $ff5ec137a7df2572$var$bimap(domain, range, interpolate) {
    var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
    if (d1 < d0) d0 = $ff5ec137a7df2572$var$normalize(d1, d0), r0 = interpolate(r1, r0);
    else d0 = $ff5ec137a7df2572$var$normalize(d0, d1), r0 = interpolate(r0, r1);
    return function(x) {
        return r0(d0(x));
    };
}
function $ff5ec137a7df2572$var$polymap(domain, range, interpolate) {
    var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1;
    // Reverse descending domains.
    if (domain[j] < domain[0]) {
        domain = domain.slice().reverse();
        range = range.slice().reverse();
    }
    while(++i < j){
        d[i] = $ff5ec137a7df2572$var$normalize(domain[i], domain[i + 1]);
        r[i] = interpolate(range[i], range[i + 1]);
    }
    return function(x) {
        var i = (0, $7bf4b402f40c3a05$export$2e2bcd8739ae039)(domain, x, 1, j) - 1;
        return r[i](d[i](x));
    };
}
function $ff5ec137a7df2572$export$784d13d8ee351f07(source, target) {
    return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function $ff5ec137a7df2572$export$6b468dcfb64c653c() {
    var domain = $ff5ec137a7df2572$var$unit, range = $ff5ec137a7df2572$var$unit, interpolate = (0, $9df523648b668b48$export$2e2bcd8739ae039), transform, untransform, unknown, clamp = $ff5ec137a7df2572$export$f0954fd7d5368655, piecewise, output, input;
    function rescale() {
        var n = Math.min(domain.length, range.length);
        if (clamp !== $ff5ec137a7df2572$export$f0954fd7d5368655) clamp = $ff5ec137a7df2572$var$clamper(domain[0], domain[n - 1]);
        piecewise = n > 2 ? $ff5ec137a7df2572$var$polymap : $ff5ec137a7df2572$var$bimap;
        output = input = null;
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
    }
    scale.invert = function(y) {
        return clamp(untransform((input || (input = piecewise(range, domain.map(transform), (0, $00ad65050bd6bdb2$export$2e2bcd8739ae039))))(y)));
    };
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_, (0, $d2205860023cec4b$export$2e2bcd8739ae039)), rescale()) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = Array.from(_), interpolate = (0, $01a150189dfd6613$export$2e2bcd8739ae039), rescale();
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = _ ? true : $ff5ec137a7df2572$export$f0954fd7d5368655, rescale()) : clamp !== $ff5ec137a7df2572$export$f0954fd7d5368655;
    };
    scale.interpolate = function(_) {
        return arguments.length ? (interpolate = _, rescale()) : interpolate;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t, u) {
        transform = t, untransform = u;
        return rescale();
    };
}
function $ff5ec137a7df2572$export$2e2bcd8739ae039() {
    return $ff5ec137a7df2572$export$6b468dcfb64c653c()($ff5ec137a7df2572$export$f0954fd7d5368655, $ff5ec137a7df2572$export$f0954fd7d5368655);
}




function $3d45e7c502c1a687$export$2e2bcd8739ae039(x) {
    return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
}
function $3d45e7c502c1a687$export$8f8e23dd27dc19f5(x, p) {
    if (!isFinite(x) || x === 0) return null; // NaN, ±Infinity, ±0
    var i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e"), coefficient = x.slice(0, i);
    // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}


function $59713d42ec972bff$export$2e2bcd8739ae039(x) {
    return x = (0, $3d45e7c502c1a687$export$8f8e23dd27dc19f5)(Math.abs(x)), x ? x[1] : NaN;
}


function $a2e3534954c9bfbc$export$2e2bcd8739ae039(grouping, thousands) {
    return function(value, width) {
        var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
        while(i > 0 && g > 0){
            if (length + g + 1 > width) g = Math.max(1, width - length);
            t.push(value.substring(i -= g, i + g));
            if ((length += g + 1) > width) break;
            g = grouping[j = (j + 1) % grouping.length];
        }
        return t.reverse().join(thousands);
    };
}


function $19738b807c3fada8$export$2e2bcd8739ae039(numerals) {
    return function(value) {
        return value.replace(/[0-9]/g, function(i) {
            return numerals[+i];
        });
    };
}


// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var $9ffb27d98f181094$var$re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function $9ffb27d98f181094$export$2e2bcd8739ae039(specifier) {
    if (!(match = $9ffb27d98f181094$var$re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match;
    return new $9ffb27d98f181094$export$963aac351db36ed4({
        fill: match[1],
        align: match[2],
        sign: match[3],
        symbol: match[4],
        zero: match[5],
        width: match[6],
        comma: match[7],
        precision: match[8] && match[8].slice(1),
        trim: match[9],
        type: match[10]
    });
}
$9ffb27d98f181094$export$2e2bcd8739ae039.prototype = $9ffb27d98f181094$export$963aac351db36ed4.prototype; // instanceof
function $9ffb27d98f181094$export$963aac351db36ed4(specifier) {
    this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
    this.align = specifier.align === undefined ? ">" : specifier.align + "";
    this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
    this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
    this.zero = !!specifier.zero;
    this.width = specifier.width === undefined ? undefined : +specifier.width;
    this.comma = !!specifier.comma;
    this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
    this.trim = !!specifier.trim;
    this.type = specifier.type === undefined ? "" : specifier.type + "";
}
$9ffb27d98f181094$export$963aac351db36ed4.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};


// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function $5e0d61884c6b2601$export$2e2bcd8739ae039(s) {
    out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
        case ".":
            i0 = i1 = i;
            break;
        case "0":
            if (i0 === 0) i0 = i;
            i1 = i;
            break;
        default:
            if (!+s[i]) break out;
            if (i0 > 0) i0 = 0;
            break;
    }
    return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}




var $91a6926e03957700$export$6863724d9a42263;
function $91a6926e03957700$export$2e2bcd8739ae039(x, p) {
    var d = (0, $3d45e7c502c1a687$export$8f8e23dd27dc19f5)(x, p);
    if (!d) return $91a6926e03957700$export$6863724d9a42263 = undefined, x.toPrecision(p);
    var coefficient = d[0], exponent = d[1], i = exponent - ($91a6926e03957700$export$6863724d9a42263 = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
    return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, $3d45e7c502c1a687$export$8f8e23dd27dc19f5)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}



function $6b7e9b19818ceaca$export$2e2bcd8739ae039(x, p) {
    var d = (0, $3d45e7c502c1a687$export$8f8e23dd27dc19f5)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1];
    return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}


var $6aaa390b95b92e7b$export$2e2bcd8739ae039 = {
    "%": (x, p)=>(x * 100).toFixed(p),
    "b": (x)=>Math.round(x).toString(2),
    "c": (x)=>x + "",
    "d": (0, $3d45e7c502c1a687$export$2e2bcd8739ae039),
    "e": (x, p)=>x.toExponential(p),
    "f": (x, p)=>x.toFixed(p),
    "g": (x, p)=>x.toPrecision(p),
    "o": (x)=>Math.round(x).toString(8),
    "p": (x, p)=>(0, $6b7e9b19818ceaca$export$2e2bcd8739ae039)(x * 100, p),
    "r": (0, $6b7e9b19818ceaca$export$2e2bcd8739ae039),
    "s": (0, $91a6926e03957700$export$2e2bcd8739ae039),
    "X": (x)=>Math.round(x).toString(16).toUpperCase(),
    "x": (x)=>Math.round(x).toString(16)
};



function $ca19761f5e9183af$export$2e2bcd8739ae039(x) {
    return x;
}


var $ceb40a8ad4f5ec00$var$map = Array.prototype.map, $ceb40a8ad4f5ec00$var$prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];
function $ceb40a8ad4f5ec00$export$2e2bcd8739ae039(locale) {
    var group = locale.grouping === undefined || locale.thousands === undefined ? (0, $ca19761f5e9183af$export$2e2bcd8739ae039) : (0, $a2e3534954c9bfbc$export$2e2bcd8739ae039)($ceb40a8ad4f5ec00$var$map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? (0, $ca19761f5e9183af$export$2e2bcd8739ae039) : (0, $19738b807c3fada8$export$2e2bcd8739ae039)($ceb40a8ad4f5ec00$var$map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "\u2212" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
    function newFormat(specifier, options) {
        specifier = (0, $9ffb27d98f181094$export$2e2bcd8739ae039)(specifier);
        var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type;
        // The "n" type is an alias for ",g".
        if (type === "n") comma = true, type = "g";
        else if (!(0, $6aaa390b95b92e7b$export$2e2bcd8739ae039)[type]) precision === undefined && (precision = 12), trim = true, type = "g";
        // If zero fill is specified, padding goes after sign and before digits.
        if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "=";
        // Compute the prefix and suffix.
        // For SI-prefix, the suffix is lazily computed.
        var prefix = (options && options.prefix !== undefined ? options.prefix : "") + (symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : ""), suffix = (symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "") + (options && options.suffix !== undefined ? options.suffix : "");
        // What format function should we use?
        // Is this an integer type?
        // Can this type generate exponential notation?
        var formatType = (0, $6aaa390b95b92e7b$export$2e2bcd8739ae039)[type], maybeSuffix = /[defgprs%]/.test(type);
        // Set the default precision if not specified,
        // or clamp the specified precision to the supported range.
        // For significant precision, it must be in [1, 21].
        // For fixed precision, it must be in [0, 20].
        precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
        function format(value) {
            var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
            if (type === "c") {
                valueSuffix = formatType(value) + valueSuffix;
                value = "";
            } else {
                value = +value;
                // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                var valueNegative = value < 0 || 1 / value < 0;
                // Perform the initial formatting.
                value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
                // Trim insignificant zeros.
                if (trim) value = (0, $5e0d61884c6b2601$export$2e2bcd8739ae039)(value);
                // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;
                // Compute the prefix and suffix.
                valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                valueSuffix = (type === "s" && !isNaN(value) && (0, $91a6926e03957700$export$6863724d9a42263) !== undefined ? $ceb40a8ad4f5ec00$var$prefixes[8 + (0, $91a6926e03957700$export$6863724d9a42263) / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
                // Break the formatted value into the integer “value” part that can be
                // grouped, and fractional or exponential “suffix” part that is not.
                if (maybeSuffix) {
                    i = -1, n = value.length;
                    while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                        valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                        value = value.slice(0, i);
                        break;
                    }
                }
            }
            // If the fill character is not "0", grouping is applied before padding.
            if (comma && !zero) value = group(value, Infinity);
            // Compute the padding.
            var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : "";
            // If the fill character is "0", grouping is applied after padding.
            if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
            // Reconstruct the final output based on the desired alignment.
            switch(align){
                case "<":
                    value = valuePrefix + value + valueSuffix + padding;
                    break;
                case "=":
                    value = valuePrefix + padding + value + valueSuffix;
                    break;
                case "^":
                    value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                    break;
                default:
                    value = padding + valuePrefix + value + valueSuffix;
                    break;
            }
            return numerals(value);
        }
        format.toString = function() {
            return specifier + "";
        };
        return format;
    }
    function formatPrefix(specifier, value) {
        var e = Math.max(-8, Math.min(8, Math.floor((0, $59713d42ec972bff$export$2e2bcd8739ae039)(value) / 3))) * 3, k = Math.pow(10, -e), f = newFormat((specifier = (0, $9ffb27d98f181094$export$2e2bcd8739ae039)(specifier), specifier.type = "f", specifier), {
            suffix: $ceb40a8ad4f5ec00$var$prefixes[8 + e / 3]
        });
        return function(value) {
            return f(k * value);
        };
    }
    return {
        format: newFormat,
        formatPrefix: formatPrefix
    };
}


var $0a15521d64adccb1$var$locale;
var $0a15521d64adccb1$export$d9468344d3651243;
var $0a15521d64adccb1$export$8d85692a469dde6f;
$0a15521d64adccb1$export$2e2bcd8739ae039({
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ]
});
function $0a15521d64adccb1$export$2e2bcd8739ae039(definition) {
    $0a15521d64adccb1$var$locale = (0, $ceb40a8ad4f5ec00$export$2e2bcd8739ae039)(definition);
    $0a15521d64adccb1$export$d9468344d3651243 = $0a15521d64adccb1$var$locale.format;
    $0a15521d64adccb1$export$8d85692a469dde6f = $0a15521d64adccb1$var$locale.formatPrefix;
    return $0a15521d64adccb1$var$locale;
}


function $1b3a5235d2c75c40$export$2e2bcd8739ae039(step) {
    return Math.max(0, -(0, $59713d42ec972bff$export$2e2bcd8739ae039)(Math.abs(step)));
}


function $83fffb2a3328219d$export$2e2bcd8739ae039(step, value) {
    return Math.max(0, Math.max(-8, Math.min(8, Math.floor((0, $59713d42ec972bff$export$2e2bcd8739ae039)(value) / 3))) * 3 - (0, $59713d42ec972bff$export$2e2bcd8739ae039)(Math.abs(step)));
}


function $801a2bdee2f9f999$export$2e2bcd8739ae039(step, max) {
    step = Math.abs(step), max = Math.abs(max) - step;
    return Math.max(0, (0, $59713d42ec972bff$export$2e2bcd8739ae039)(max) - (0, $59713d42ec972bff$export$2e2bcd8739ae039)(step)) + 1;
}


function $1d26b38b0d516dab$export$2e2bcd8739ae039(start, stop, count, specifier) {
    var step = (0, $8e8b0ab7237daf36$export$81087d9b915d4ede)(start, stop, count), precision;
    specifier = (0, $9ffb27d98f181094$export$2e2bcd8739ae039)(specifier == null ? ",f" : specifier);
    switch(specifier.type){
        case "s":
            var value = Math.max(Math.abs(start), Math.abs(stop));
            if (specifier.precision == null && !isNaN(precision = (0, $83fffb2a3328219d$export$2e2bcd8739ae039)(step, value))) specifier.precision = precision;
            return (0, $0a15521d64adccb1$export$8d85692a469dde6f)(specifier, value);
        case "":
        case "e":
        case "g":
        case "p":
        case "r":
            if (specifier.precision == null && !isNaN(precision = (0, $801a2bdee2f9f999$export$2e2bcd8739ae039)(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
            break;
        case "f":
        case "%":
            if (specifier.precision == null && !isNaN(precision = (0, $1b3a5235d2c75c40$export$2e2bcd8739ae039)(step))) specifier.precision = precision - (specifier.type === "%") * 2;
            break;
    }
    return (0, $0a15521d64adccb1$export$d9468344d3651243)(specifier);
}


function $7369c722765cb59f$export$16a5d4b4a61a274d(scale) {
    var domain = scale.domain;
    scale.ticks = function(count) {
        var d = domain();
        return (0, $8e8b0ab7237daf36$export$2e2bcd8739ae039)(d[0], d[d.length - 1], count == null ? 10 : count);
    };
    scale.tickFormat = function(count, specifier) {
        var d = domain();
        return (0, $1d26b38b0d516dab$export$2e2bcd8739ae039)(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
    };
    scale.nice = function(count) {
        if (count == null) count = 10;
        var d = domain();
        var i0 = 0;
        var i1 = d.length - 1;
        var start = d[i0];
        var stop = d[i1];
        var prestep;
        var step;
        var maxIter = 10;
        if (stop < start) {
            step = start, start = stop, stop = step;
            step = i0, i0 = i1, i1 = step;
        }
        while(maxIter-- > 0){
            step = (0, $8e8b0ab7237daf36$export$bc64d00cc98e7e95)(start, stop, count);
            if (step === prestep) {
                d[i0] = start;
                d[i1] = stop;
                return domain(d);
            } else if (step > 0) {
                start = Math.floor(start / step) * step;
                stop = Math.ceil(stop / step) * step;
            } else if (step < 0) {
                start = Math.ceil(start * step) / step;
                stop = Math.floor(stop * step) / step;
            } else break;
            prestep = step;
        }
        return scale;
    };
    return scale;
}
function $7369c722765cb59f$export$2e2bcd8739ae039() {
    var scale = (0, $ff5ec137a7df2572$export$2e2bcd8739ae039)();
    scale.copy = function() {
        return (0, $ff5ec137a7df2572$export$784d13d8ee351f07)(scale, $7369c722765cb59f$export$2e2bcd8739ae039());
    };
    (0, $1f5f05714ccdd883$export$23c7bb9e6558da2a).apply(scale, arguments);
    return $7369c722765cb59f$export$16a5d4b4a61a274d(scale);
}



function $94472f1dbbe6a48b$export$2e2bcd8739ae039(domain) {
    var unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : x;
    }
    scale.invert = scale;
    scale.domain = scale.range = function(_) {
        return arguments.length ? (domain = Array.from(_, (0, $d2205860023cec4b$export$2e2bcd8739ae039)), scale) : domain.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $94472f1dbbe6a48b$export$2e2bcd8739ae039(domain).unknown(unknown);
    };
    domain = arguments.length ? Array.from(domain, (0, $d2205860023cec4b$export$2e2bcd8739ae039)) : [
        0,
        1
    ];
    return (0, $7369c722765cb59f$export$16a5d4b4a61a274d)(scale);
}





function $ea53a5a9978b0e3a$export$2e2bcd8739ae039(domain, interval) {
    domain = domain.slice();
    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t;
    if (x1 < x0) {
        t = i0, i0 = i1, i1 = t;
        t = x0, x0 = x1, x1 = t;
    }
    domain[i0] = interval.floor(x0);
    domain[i1] = interval.ceil(x1);
    return domain;
}




function $659bacbca617da2e$var$transformLog(x) {
    return Math.log(x);
}
function $659bacbca617da2e$var$transformExp(x) {
    return Math.exp(x);
}
function $659bacbca617da2e$var$transformLogn(x) {
    return -Math.log(-x);
}
function $659bacbca617da2e$var$transformExpn(x) {
    return -Math.exp(-x);
}
function $659bacbca617da2e$var$pow10(x) {
    return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}
function $659bacbca617da2e$var$powp(base) {
    return base === 10 ? $659bacbca617da2e$var$pow10 : base === Math.E ? Math.exp : (x)=>Math.pow(base, x);
}
function $659bacbca617da2e$var$logp(base) {
    return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), (x)=>Math.log(x) / base);
}
function $659bacbca617da2e$var$reflect(f) {
    return (x, k)=>-f(-x, k);
}
function $659bacbca617da2e$export$860836db074028f0(transform) {
    const scale = transform($659bacbca617da2e$var$transformLog, $659bacbca617da2e$var$transformExp);
    const domain = scale.domain;
    let base = 10;
    let logs;
    let pows;
    function rescale() {
        logs = $659bacbca617da2e$var$logp(base), pows = $659bacbca617da2e$var$powp(base);
        if (domain()[0] < 0) {
            logs = $659bacbca617da2e$var$reflect(logs), pows = $659bacbca617da2e$var$reflect(pows);
            transform($659bacbca617da2e$var$transformLogn, $659bacbca617da2e$var$transformExpn);
        } else transform($659bacbca617da2e$var$transformLog, $659bacbca617da2e$var$transformExp);
        return scale;
    }
    scale.base = function(_) {
        return arguments.length ? (base = +_, rescale()) : base;
    };
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.ticks = (count)=>{
        const d = domain();
        let u = d[0];
        let v = d[d.length - 1];
        const r = v < u;
        if (r) [u, v] = [
            v,
            u
        ];
        let i = logs(u);
        let j = logs(v);
        let k;
        let t;
        const n = count == null ? 10 : +count;
        let z = [];
        if (!(base % 1) && j - i < n) {
            i = Math.floor(i), j = Math.ceil(j);
            if (u > 0) for(; i <= j; ++i)for(k = 1; k < base; ++k){
                t = i < 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            else for(; i <= j; ++i)for(k = base - 1; k >= 1; --k){
                t = i > 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            if (z.length * 2 < n) z = (0, $8e8b0ab7237daf36$export$2e2bcd8739ae039)(u, v, n);
        } else z = (0, $8e8b0ab7237daf36$export$2e2bcd8739ae039)(i, j, Math.min(j - i, n)).map(pows);
        return r ? z.reverse() : z;
    };
    scale.tickFormat = (count, specifier)=>{
        if (count == null) count = 10;
        if (specifier == null) specifier = base === 10 ? "s" : ",";
        if (typeof specifier !== "function") {
            if (!(base % 1) && (specifier = (0, $9ffb27d98f181094$export$2e2bcd8739ae039)(specifier)).precision == null) specifier.trim = true;
            specifier = (0, $0a15521d64adccb1$export$d9468344d3651243)(specifier);
        }
        if (count === Infinity) return specifier;
        const k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
        return (d)=>{
            let i = d / pows(Math.round(logs(d)));
            if (i * base < base - 0.5) i *= base;
            return i <= k ? specifier(d) : "";
        };
    };
    scale.nice = ()=>{
        return domain((0, $ea53a5a9978b0e3a$export$2e2bcd8739ae039)(domain(), {
            floor: (x)=>pows(Math.floor(logs(x))),
            ceil: (x)=>pows(Math.ceil(logs(x)))
        }));
    };
    return scale;
}
function $659bacbca617da2e$export$2e2bcd8739ae039() {
    const scale = $659bacbca617da2e$export$860836db074028f0((0, $ff5ec137a7df2572$export$6b468dcfb64c653c)()).domain([
        1,
        10
    ]);
    scale.copy = ()=>(0, $ff5ec137a7df2572$export$784d13d8ee351f07)(scale, $659bacbca617da2e$export$2e2bcd8739ae039()).base(scale.base());
    (0, $1f5f05714ccdd883$export$23c7bb9e6558da2a).apply(scale, arguments);
    return scale;
}





function $6d6ed92c9022be1f$var$transformSymlog(c) {
    return function(x) {
        return Math.sign(x) * Math.log1p(Math.abs(x / c));
    };
}
function $6d6ed92c9022be1f$var$transformSymexp(c) {
    return function(x) {
        return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
    };
}
function $6d6ed92c9022be1f$export$4602684e614eba38(transform) {
    var c = 1, scale = transform($6d6ed92c9022be1f$var$transformSymlog(c), $6d6ed92c9022be1f$var$transformSymexp(c));
    scale.constant = function(_) {
        return arguments.length ? transform($6d6ed92c9022be1f$var$transformSymlog(c = +_), $6d6ed92c9022be1f$var$transformSymexp(c)) : c;
    };
    return (0, $7369c722765cb59f$export$16a5d4b4a61a274d)(scale);
}
function $6d6ed92c9022be1f$export$2e2bcd8739ae039() {
    var scale = $6d6ed92c9022be1f$export$4602684e614eba38((0, $ff5ec137a7df2572$export$6b468dcfb64c653c)());
    scale.copy = function() {
        return (0, $ff5ec137a7df2572$export$784d13d8ee351f07)(scale, $6d6ed92c9022be1f$export$2e2bcd8739ae039()).constant(scale.constant());
    };
    return (0, $1f5f05714ccdd883$export$23c7bb9e6558da2a).apply(scale, arguments);
}






function $ddc8211c8a258942$var$transformPow(exponent) {
    return function(x) {
        return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
    };
}
function $ddc8211c8a258942$var$transformSqrt(x) {
    return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
}
function $ddc8211c8a258942$var$transformSquare(x) {
    return x < 0 ? -x * x : x * x;
}
function $ddc8211c8a258942$export$34695211ec403a46(transform) {
    var scale = transform((0, $ff5ec137a7df2572$export$f0954fd7d5368655), (0, $ff5ec137a7df2572$export$f0954fd7d5368655)), exponent = 1;
    function rescale() {
        return exponent === 1 ? transform((0, $ff5ec137a7df2572$export$f0954fd7d5368655), (0, $ff5ec137a7df2572$export$f0954fd7d5368655)) : exponent === 0.5 ? transform($ddc8211c8a258942$var$transformSqrt, $ddc8211c8a258942$var$transformSquare) : transform($ddc8211c8a258942$var$transformPow(exponent), $ddc8211c8a258942$var$transformPow(1 / exponent));
    }
    scale.exponent = function(_) {
        return arguments.length ? (exponent = +_, rescale()) : exponent;
    };
    return (0, $7369c722765cb59f$export$16a5d4b4a61a274d)(scale);
}
function $ddc8211c8a258942$export$2e2bcd8739ae039() {
    var scale = $ddc8211c8a258942$export$34695211ec403a46((0, $ff5ec137a7df2572$export$6b468dcfb64c653c)());
    scale.copy = function() {
        return (0, $ff5ec137a7df2572$export$784d13d8ee351f07)(scale, $ddc8211c8a258942$export$2e2bcd8739ae039()).exponent(scale.exponent());
    };
    (0, $1f5f05714ccdd883$export$23c7bb9e6558da2a).apply(scale, arguments);
    return scale;
}
function $ddc8211c8a258942$export$eba8049fb5020b81() {
    return $ddc8211c8a258942$export$2e2bcd8739ae039.apply(null, arguments).exponent(0.5);
}






function $73de4f14fa79df42$var$square(x) {
    return Math.sign(x) * x * x;
}
function $73de4f14fa79df42$var$unsquare(x) {
    return Math.sign(x) * Math.sqrt(Math.abs(x));
}
function $73de4f14fa79df42$export$2e2bcd8739ae039() {
    var squared = (0, $ff5ec137a7df2572$export$2e2bcd8739ae039)(), range = [
        0,
        1
    ], round = false, unknown;
    function scale(x) {
        var y = $73de4f14fa79df42$var$unsquare(squared(x));
        return isNaN(y) ? unknown : round ? Math.round(y) : y;
    }
    scale.invert = function(y) {
        return squared.invert($73de4f14fa79df42$var$square(y));
    };
    scale.domain = function(_) {
        return arguments.length ? (squared.domain(_), scale) : squared.domain();
    };
    scale.range = function(_) {
        return arguments.length ? (squared.range((range = Array.from(_, (0, $d2205860023cec4b$export$2e2bcd8739ae039))).map($73de4f14fa79df42$var$square)), scale) : range.slice();
    };
    scale.rangeRound = function(_) {
        return scale.range(_).round(true);
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, scale) : round;
    };
    scale.clamp = function(_) {
        return arguments.length ? (squared.clamp(_), scale) : squared.clamp();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $73de4f14fa79df42$export$2e2bcd8739ae039(squared.domain(), range).round(round).clamp(squared.clamp()).unknown(unknown);
    };
    (0, $1f5f05714ccdd883$export$23c7bb9e6558da2a).apply(scale, arguments);
    return (0, $7369c722765cb59f$export$16a5d4b4a61a274d)(scale);
}


function $a6aca3903583d73a$export$2e2bcd8739ae039(values, valueof) {
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (max < value || max === undefined && value >= value)) max = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value;
    }
    return max;
}


function $a681fd6fe744d7a6$export$2e2bcd8739ae039(values, valueof) {
    let max;
    let maxIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    return maxIndex;
}


function $1f82fa378f2b23d1$export$2e2bcd8739ae039(values, valueof) {
    let min;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (min > value || min === undefined && value >= value)) min = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value;
    }
    return min;
}


function $22da665998860fa1$export$2e2bcd8739ae039(values, valueof) {
    let min;
    let minIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    return minIndex;
}



function $aa09bd00aea7b6fb$export$2e2bcd8739ae039(source, keys) {
    return Array.from(keys, (key)=>source[key]);
}


function $e507e05d65cdedb8$export$2e2bcd8739ae039(values, ...F) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    values = Array.from(values);
    let [f] = F;
    if (f && f.length !== 2 || F.length > 1) {
        const index = Uint32Array.from(values, (d, i)=>i);
        if (F.length > 1) {
            F = F.map((f)=>values.map(f));
            index.sort((i, j)=>{
                for (const f of F){
                    const c = $e507e05d65cdedb8$export$686e14b8469efec4(f[i], f[j]);
                    if (c) return c;
                }
            });
        } else {
            f = values.map(f);
            index.sort((i, j)=>$e507e05d65cdedb8$export$686e14b8469efec4(f[i], f[j]));
        }
        return (0, $aa09bd00aea7b6fb$export$2e2bcd8739ae039)(values, index);
    }
    return values.sort($e507e05d65cdedb8$export$5708b2c031939e56(f));
}
function $e507e05d65cdedb8$export$5708b2c031939e56(compare = (0, $8bcd8071d2010e24$export$2e2bcd8739ae039)) {
    if (compare === (0, $8bcd8071d2010e24$export$2e2bcd8739ae039)) return $e507e05d65cdedb8$export$686e14b8469efec4;
    if (typeof compare !== "function") throw new TypeError("compare is not a function");
    return (a, b)=>{
        const x = compare(a, b);
        if (x || x === 0) return x;
        return (compare(b, b) === 0) - (compare(a, a) === 0);
    };
}
function $e507e05d65cdedb8$export$686e14b8469efec4(a, b) {
    return (a == null || !(a >= a)) - (b == null || !(b >= b)) || (a < b ? -1 : a > b ? 1 : 0);
}


function $53c0bdfb99cd736b$export$2e2bcd8739ae039(array, k, left = 0, right = Infinity, compare) {
    k = Math.floor(k);
    left = Math.floor(Math.max(0, left));
    right = Math.floor(Math.min(array.length - 1, right));
    if (!(left <= k && k <= right)) return array;
    compare = compare === undefined ? (0, $e507e05d65cdedb8$export$686e14b8469efec4) : (0, $e507e05d65cdedb8$export$5708b2c031939e56)(compare);
    while(right > left){
        if (right - left > 600) {
            const n = right - left + 1;
            const m = k - left + 1;
            const z = Math.log(n);
            const s = 0.5 * Math.exp(2 * z / 3);
            const sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
            const newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
            const newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
            $53c0bdfb99cd736b$export$2e2bcd8739ae039(array, k, newLeft, newRight, compare);
        }
        const t = array[k];
        let i = left;
        let j = right;
        $53c0bdfb99cd736b$var$swap(array, left, k);
        if (compare(array[right], t) > 0) $53c0bdfb99cd736b$var$swap(array, left, right);
        while(i < j){
            $53c0bdfb99cd736b$var$swap(array, i, j), ++i, --j;
            while(compare(array[i], t) < 0)++i;
            while(compare(array[j], t) > 0)--j;
        }
        if (compare(array[left], t) === 0) $53c0bdfb99cd736b$var$swap(array, left, j);
        else ++j, $53c0bdfb99cd736b$var$swap(array, j, right);
        if (j <= k) left = j + 1;
        if (k <= j) right = j - 1;
    }
    return array;
}
function $53c0bdfb99cd736b$var$swap(array, i, j) {
    const t = array[i];
    array[i] = array[j];
    array[j] = t;
}





function $c59251bfb80076c2$export$2e2bcd8739ae039(values, compare = (0, $8bcd8071d2010e24$export$2e2bcd8739ae039)) {
    let max;
    let defined = false;
    if (compare.length === 1) {
        let maxValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, $8bcd8071d2010e24$export$2e2bcd8739ae039)(value, maxValue) > 0 : (0, $8bcd8071d2010e24$export$2e2bcd8739ae039)(value, value) === 0) {
                max = element;
                maxValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, max) > 0 : compare(value, value) === 0) {
            max = value;
            defined = true;
        }
    }
    return max;
}


function $35ba05910c022a97$export$2e2bcd8739ae039(values, p, valueof) {
    values = Float64Array.from((0, $09e73fc7c4df1c9a$export$1f6c9cc012ebacae)(values, valueof));
    if (!(n = values.length) || isNaN(p = +p)) return;
    if (p <= 0 || n < 2) return (0, $1f82fa378f2b23d1$export$2e2bcd8739ae039)(values);
    if (p >= 1) return (0, $a6aca3903583d73a$export$2e2bcd8739ae039)(values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = (0, $a6aca3903583d73a$export$2e2bcd8739ae039)((0, $53c0bdfb99cd736b$export$2e2bcd8739ae039)(values, i0).subarray(0, i0 + 1)), value1 = (0, $1f82fa378f2b23d1$export$2e2bcd8739ae039)(values.subarray(i0 + 1));
    return value0 + (value1 - value0) * (i - i0);
}
function $35ba05910c022a97$export$f924a6cad778dddb(values, p, valueof = (0, $09e73fc7c4df1c9a$export$2e2bcd8739ae039)) {
    if (!(n = values.length) || isNaN(p = +p)) return;
    if (p <= 0 || n < 2) return +valueof(values[0], 0, values);
    if (p >= 1) return +valueof(values[n - 1], n - 1, values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = +valueof(values[i0], i0, values), value1 = +valueof(values[i0 + 1], i0 + 1, values);
    return value0 + (value1 - value0) * (i - i0);
}
function $35ba05910c022a97$export$f1fcc854ecc6ce55(values, p, valueof = (0, $09e73fc7c4df1c9a$export$2e2bcd8739ae039)) {
    if (isNaN(p = +p)) return;
    numbers = Float64Array.from(values, (_, i)=>(0, $09e73fc7c4df1c9a$export$2e2bcd8739ae039)(valueof(values[i], i, values)));
    if (p <= 0) return (0, $22da665998860fa1$export$2e2bcd8739ae039)(numbers);
    if (p >= 1) return (0, $a681fd6fe744d7a6$export$2e2bcd8739ae039)(numbers);
    var numbers, index = Uint32Array.from(values, (_, i)=>i), j = numbers.length - 1, i = Math.floor(j * p);
    (0, $53c0bdfb99cd736b$export$2e2bcd8739ae039)(index, i, 0, j, (i, j)=>(0, $e507e05d65cdedb8$export$686e14b8469efec4)(numbers[i], numbers[j]));
    i = (0, $c59251bfb80076c2$export$2e2bcd8739ae039)(index.subarray(0, i + 1), (i)=>numbers[i]);
    return i >= 0 ? i : -1;
}



function $e239697f987de752$export$2e2bcd8739ae039() {
    var domain = [], range = [], thresholds = [], unknown;
    function rescale() {
        var i = 0, n = Math.max(1, range.length);
        thresholds = new Array(n - 1);
        while(++i < n)thresholds[i - 1] = (0, $35ba05910c022a97$export$f924a6cad778dddb)(domain, i / n);
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : range[(0, $7bf4b402f40c3a05$export$2e2bcd8739ae039)(thresholds, x)];
    }
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : [
            i > 0 ? thresholds[i - 1] : domain[0],
            i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
        ];
    };
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort((0, $8bcd8071d2010e24$export$2e2bcd8739ae039));
        return rescale();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.quantiles = function() {
        return thresholds.slice();
    };
    scale.copy = function() {
        return $e239697f987de752$export$2e2bcd8739ae039().domain(domain).range(range).unknown(unknown);
    };
    return (0, $1f5f05714ccdd883$export$23c7bb9e6558da2a).apply(scale, arguments);
}





function $b3675204aae59040$export$2e2bcd8739ae039() {
    var x0 = 0, x1 = 1, n = 1, domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown;
    function scale(x) {
        return x != null && x <= x ? range[(0, $7bf4b402f40c3a05$export$2e2bcd8739ae039)(domain, x, 0, n)] : unknown;
    }
    function rescale() {
        var i = -1;
        domain = new Array(n);
        while(++i < n)domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
        return scale;
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, x0 = +x0, x1 = +x1, rescale()) : [
            x0,
            x1
        ];
    };
    scale.range = function(_) {
        return arguments.length ? (n = (range = Array.from(_)).length - 1, rescale()) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : i < 1 ? [
            x0,
            domain[0]
        ] : i >= n ? [
            domain[n - 1],
            x1
        ] : [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : scale;
    };
    scale.thresholds = function() {
        return domain.slice();
    };
    scale.copy = function() {
        return $b3675204aae59040$export$2e2bcd8739ae039().domain([
            x0,
            x1
        ]).range(range).unknown(unknown);
    };
    return (0, $1f5f05714ccdd883$export$23c7bb9e6558da2a).apply((0, $7369c722765cb59f$export$16a5d4b4a61a274d)(scale), arguments);
}




function $feeb64ed89911bb5$export$2e2bcd8739ae039() {
    var domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown, n = 1;
    function scale(x) {
        return x != null && x <= x ? range[(0, $7bf4b402f40c3a05$export$2e2bcd8739ae039)(domain, x, 0, n)] : unknown;
    }
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $feeb64ed89911bb5$export$2e2bcd8739ae039().domain(domain).range(range).unknown(unknown);
    };
    return (0, $1f5f05714ccdd883$export$23c7bb9e6558da2a).apply(scale, arguments);
}


const $5e6227bfcf3a33f0$var$t0 = new Date, $5e6227bfcf3a33f0$var$t1 = new Date;
function $5e6227bfcf3a33f0$export$1a539c8b2950ab40(floori, offseti, count, field) {
    function interval(date) {
        return floori(date = arguments.length === 0 ? new Date : new Date(+date)), date;
    }
    interval.floor = (date)=>{
        return floori(date = new Date(+date)), date;
    };
    interval.ceil = (date)=>{
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
    interval.round = (date)=>{
        const d0 = interval(date), d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
    };
    interval.offset = (date, step)=>{
        return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
    interval.range = (start, stop, step)=>{
        const range = [];
        start = interval.ceil(start);
        step = step == null ? 1 : Math.floor(step);
        if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
        let previous;
        do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
        while (previous < start && start < stop);
        return range;
    };
    interval.filter = (test)=>{
        return $5e6227bfcf3a33f0$export$1a539c8b2950ab40((date)=>{
            if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
        }, (date, step)=>{
            if (date >= date) {
                if (step < 0) while(++step <= 0){
                    while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                }
                else while(--step >= 0){
                    while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                }
            }
        });
    };
    if (count) {
        interval.count = (start, end)=>{
            $5e6227bfcf3a33f0$var$t0.setTime(+start), $5e6227bfcf3a33f0$var$t1.setTime(+end);
            floori($5e6227bfcf3a33f0$var$t0), floori($5e6227bfcf3a33f0$var$t1);
            return Math.floor(count($5e6227bfcf3a33f0$var$t0, $5e6227bfcf3a33f0$var$t1));
        };
        interval.every = (step)=>{
            step = Math.floor(step);
            return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? (d)=>field(d) % step === 0 : (d)=>interval.count(0, d) % step === 0);
        };
    }
    return interval;
}


const $1d0582d0535eaf29$export$79ef0e34099623dc = 1000;
const $1d0582d0535eaf29$export$683905d551c33fa9 = $1d0582d0535eaf29$export$79ef0e34099623dc * 60;
const $1d0582d0535eaf29$export$4157bf0c8e241659 = $1d0582d0535eaf29$export$683905d551c33fa9 * 60;
const $1d0582d0535eaf29$export$353686095f4fbf45 = $1d0582d0535eaf29$export$4157bf0c8e241659 * 24;
const $1d0582d0535eaf29$export$c241eb88520d5016 = $1d0582d0535eaf29$export$353686095f4fbf45 * 7;
const $1d0582d0535eaf29$export$ab95684df7020b26 = $1d0582d0535eaf29$export$353686095f4fbf45 * 30;
const $1d0582d0535eaf29$export$61f8ee2d834c6959 = $1d0582d0535eaf29$export$353686095f4fbf45 * 365;


const $9b6201972b2c40bf$export$8888529b966033e5 = (0, $5e6227bfcf3a33f0$export$1a539c8b2950ab40)((date)=>date.setHours(0, 0, 0, 0), (date, step)=>date.setDate(date.getDate() + step), (start, end)=>(end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, $1d0582d0535eaf29$export$683905d551c33fa9)) / (0, $1d0582d0535eaf29$export$353686095f4fbf45), (date)=>date.getDate() - 1);
const $9b6201972b2c40bf$export$6657a54f3034cf45 = $9b6201972b2c40bf$export$8888529b966033e5.range;
const $9b6201972b2c40bf$export$c8cbc42cefd47140 = (0, $5e6227bfcf3a33f0$export$1a539c8b2950ab40)((date)=>{
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCDate(date.getUTCDate() + step);
}, (start, end)=>{
    return (end - start) / (0, $1d0582d0535eaf29$export$353686095f4fbf45);
}, (date)=>{
    return date.getUTCDate() - 1;
});
const $9b6201972b2c40bf$export$d277e198508549a1 = $9b6201972b2c40bf$export$c8cbc42cefd47140.range;
const $9b6201972b2c40bf$export$fb065be2d7ea4a71 = (0, $5e6227bfcf3a33f0$export$1a539c8b2950ab40)((date)=>{
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCDate(date.getUTCDate() + step);
}, (start, end)=>{
    return (end - start) / (0, $1d0582d0535eaf29$export$353686095f4fbf45);
}, (date)=>{
    return Math.floor(date / (0, $1d0582d0535eaf29$export$353686095f4fbf45));
});
const $9b6201972b2c40bf$export$a491caaf5e9481aa = $9b6201972b2c40bf$export$fb065be2d7ea4a71.range;



const $71c4886b43888898$export$46c68a5833bc315b = (0, $5e6227bfcf3a33f0$export$1a539c8b2950ab40)((date)=>{
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, $1d0582d0535eaf29$export$79ef0e34099623dc) - date.getMinutes() * (0, $1d0582d0535eaf29$export$683905d551c33fa9));
}, (date, step)=>{
    date.setTime(+date + step * (0, $1d0582d0535eaf29$export$4157bf0c8e241659));
}, (start, end)=>{
    return (end - start) / (0, $1d0582d0535eaf29$export$4157bf0c8e241659);
}, (date)=>{
    return date.getHours();
});
const $71c4886b43888898$export$fb843f9087cd5235 = $71c4886b43888898$export$46c68a5833bc315b.range;
const $71c4886b43888898$export$31f6f2b3c63ac75e = (0, $5e6227bfcf3a33f0$export$1a539c8b2950ab40)((date)=>{
    date.setUTCMinutes(0, 0, 0);
}, (date, step)=>{
    date.setTime(+date + step * (0, $1d0582d0535eaf29$export$4157bf0c8e241659));
}, (start, end)=>{
    return (end - start) / (0, $1d0582d0535eaf29$export$4157bf0c8e241659);
}, (date)=>{
    return date.getUTCHours();
});
const $71c4886b43888898$export$6e7a76cd5f50b719 = $71c4886b43888898$export$31f6f2b3c63ac75e.range;



const $fa3a3bd5293506be$export$a7e4c34a52f0576 = (0, $5e6227bfcf3a33f0$export$1a539c8b2950ab40)((date)=>{
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, $1d0582d0535eaf29$export$79ef0e34099623dc));
}, (date, step)=>{
    date.setTime(+date + step * (0, $1d0582d0535eaf29$export$683905d551c33fa9));
}, (start, end)=>{
    return (end - start) / (0, $1d0582d0535eaf29$export$683905d551c33fa9);
}, (date)=>{
    return date.getMinutes();
});
const $fa3a3bd5293506be$export$186d65358374c0a2 = $fa3a3bd5293506be$export$a7e4c34a52f0576.range;
const $fa3a3bd5293506be$export$efe6712d6003761b = (0, $5e6227bfcf3a33f0$export$1a539c8b2950ab40)((date)=>{
    date.setUTCSeconds(0, 0);
}, (date, step)=>{
    date.setTime(+date + step * (0, $1d0582d0535eaf29$export$683905d551c33fa9));
}, (start, end)=>{
    return (end - start) / (0, $1d0582d0535eaf29$export$683905d551c33fa9);
}, (date)=>{
    return date.getUTCMinutes();
});
const $fa3a3bd5293506be$export$cedd563624e8ee50 = $fa3a3bd5293506be$export$efe6712d6003761b.range;


const $57986bc5a9893c7d$export$7e1084fb688591c1 = (0, $5e6227bfcf3a33f0$export$1a539c8b2950ab40)((date)=>{
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setMonth(date.getMonth() + step);
}, (start, end)=>{
    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, (date)=>{
    return date.getMonth();
});
const $57986bc5a9893c7d$export$3e24aa839cd0f1c4 = $57986bc5a9893c7d$export$7e1084fb688591c1.range;
const $57986bc5a9893c7d$export$cd49b3d2bcfe50d5 = (0, $5e6227bfcf3a33f0$export$1a539c8b2950ab40)((date)=>{
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCMonth(date.getUTCMonth() + step);
}, (start, end)=>{
    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, (date)=>{
    return date.getUTCMonth();
});
const $57986bc5a9893c7d$export$49159f585997498 = $57986bc5a9893c7d$export$cd49b3d2bcfe50d5.range;



const $8f8e7aff3b0769cd$export$3d3c77ce7df7d30d = (0, $5e6227bfcf3a33f0$export$1a539c8b2950ab40)((date)=>{
    date.setTime(date - date.getMilliseconds());
}, (date, step)=>{
    date.setTime(+date + step * (0, $1d0582d0535eaf29$export$79ef0e34099623dc));
}, (start, end)=>{
    return (end - start) / (0, $1d0582d0535eaf29$export$79ef0e34099623dc);
}, (date)=>{
    return date.getUTCSeconds();
});
const $8f8e7aff3b0769cd$export$4792e48abc550fa1 = $8f8e7aff3b0769cd$export$3d3c77ce7df7d30d.range;




const $723360f54160612b$export$edc5e5cb87280477 = (0, $5e6227bfcf3a33f0$export$1a539c8b2950ab40)(()=>{
// noop
}, (date, step)=>{
    date.setTime(+date + step);
}, (start, end)=>{
    return end - start;
});
// An optimized implementation for this simple case.
$723360f54160612b$export$edc5e5cb87280477.every = (k)=>{
    k = Math.floor(k);
    if (!isFinite(k) || !(k > 0)) return null;
    if (!(k > 1)) return $723360f54160612b$export$edc5e5cb87280477;
    return (0, $5e6227bfcf3a33f0$export$1a539c8b2950ab40)((date)=>{
        date.setTime(Math.floor(date / k) * k);
    }, (date, step)=>{
        date.setTime(+date + step * k);
    }, (start, end)=>{
        return (end - start) / k;
    });
};
const $723360f54160612b$export$9a27fac83d67afd3 = $723360f54160612b$export$edc5e5cb87280477.range;








function $7b30ce921ff0ee22$var$timeWeekday(i) {
    return (0, $5e6227bfcf3a33f0$export$1a539c8b2950ab40)((date)=>{
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
        date.setHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setDate(date.getDate() + step * 7);
    }, (start, end)=>{
        return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, $1d0582d0535eaf29$export$683905d551c33fa9)) / (0, $1d0582d0535eaf29$export$c241eb88520d5016);
    });
}
const $7b30ce921ff0ee22$export$22ee6205b762968c = $7b30ce921ff0ee22$var$timeWeekday(0);
const $7b30ce921ff0ee22$export$e79bbe0177cf1b01 = $7b30ce921ff0ee22$var$timeWeekday(1);
const $7b30ce921ff0ee22$export$57c0658c29f77708 = $7b30ce921ff0ee22$var$timeWeekday(2);
const $7b30ce921ff0ee22$export$3fbeef226c256e43 = $7b30ce921ff0ee22$var$timeWeekday(3);
const $7b30ce921ff0ee22$export$608689422d5cf9f4 = $7b30ce921ff0ee22$var$timeWeekday(4);
const $7b30ce921ff0ee22$export$548e5227aa183dca = $7b30ce921ff0ee22$var$timeWeekday(5);
const $7b30ce921ff0ee22$export$c56a3ad248908e19 = $7b30ce921ff0ee22$var$timeWeekday(6);
const $7b30ce921ff0ee22$export$eac514c8a8674eba = $7b30ce921ff0ee22$export$22ee6205b762968c.range;
const $7b30ce921ff0ee22$export$f7219b1481948356 = $7b30ce921ff0ee22$export$e79bbe0177cf1b01.range;
const $7b30ce921ff0ee22$export$77e22b12c5bed05b = $7b30ce921ff0ee22$export$57c0658c29f77708.range;
const $7b30ce921ff0ee22$export$b85d407a471809e8 = $7b30ce921ff0ee22$export$3fbeef226c256e43.range;
const $7b30ce921ff0ee22$export$c1bc1c49254c8855 = $7b30ce921ff0ee22$export$608689422d5cf9f4.range;
const $7b30ce921ff0ee22$export$3691a1557fff46f1 = $7b30ce921ff0ee22$export$548e5227aa183dca.range;
const $7b30ce921ff0ee22$export$b755452d02cba8d2 = $7b30ce921ff0ee22$export$c56a3ad248908e19.range;
function $7b30ce921ff0ee22$var$utcWeekday(i) {
    return (0, $5e6227bfcf3a33f0$export$1a539c8b2950ab40)((date)=>{
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
        date.setUTCHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setUTCDate(date.getUTCDate() + step * 7);
    }, (start, end)=>{
        return (end - start) / (0, $1d0582d0535eaf29$export$c241eb88520d5016);
    });
}
const $7b30ce921ff0ee22$export$4898b06303a92011 = $7b30ce921ff0ee22$var$utcWeekday(0);
const $7b30ce921ff0ee22$export$9cfc53b9cfafd080 = $7b30ce921ff0ee22$var$utcWeekday(1);
const $7b30ce921ff0ee22$export$2a6d545f77eceb15 = $7b30ce921ff0ee22$var$utcWeekday(2);
const $7b30ce921ff0ee22$export$a5c25d8ed64433c4 = $7b30ce921ff0ee22$var$utcWeekday(3);
const $7b30ce921ff0ee22$export$1db08111baec2f53 = $7b30ce921ff0ee22$var$utcWeekday(4);
const $7b30ce921ff0ee22$export$29265e34dd5921f7 = $7b30ce921ff0ee22$var$utcWeekday(5);
const $7b30ce921ff0ee22$export$85b74dad05049604 = $7b30ce921ff0ee22$var$utcWeekday(6);
const $7b30ce921ff0ee22$export$6f3e1c2b0f7d7880 = $7b30ce921ff0ee22$export$4898b06303a92011.range;
const $7b30ce921ff0ee22$export$1d2d8b858bb366f9 = $7b30ce921ff0ee22$export$9cfc53b9cfafd080.range;
const $7b30ce921ff0ee22$export$1d5f6785fc7f30f8 = $7b30ce921ff0ee22$export$2a6d545f77eceb15.range;
const $7b30ce921ff0ee22$export$7a75faf0e37ef4af = $7b30ce921ff0ee22$export$a5c25d8ed64433c4.range;
const $7b30ce921ff0ee22$export$417eb959611b2f2f = $7b30ce921ff0ee22$export$1db08111baec2f53.range;
const $7b30ce921ff0ee22$export$59d308db7af08c64 = $7b30ce921ff0ee22$export$29265e34dd5921f7.range;
const $7b30ce921ff0ee22$export$a124108a0a7f34c8 = $7b30ce921ff0ee22$export$85b74dad05049604.range;




const $52e844f3ca08f4ae$export$cd17cfe45df0c046 = (0, $5e6227bfcf3a33f0$export$1a539c8b2950ab40)((date)=>{
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setFullYear(date.getFullYear() + step);
}, (start, end)=>{
    return end.getFullYear() - start.getFullYear();
}, (date)=>{
    return date.getFullYear();
});
// An optimized implementation for this simple case.
$52e844f3ca08f4ae$export$cd17cfe45df0c046.every = (k)=>{
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $5e6227bfcf3a33f0$export$1a539c8b2950ab40)((date)=>{
        date.setFullYear(Math.floor(date.getFullYear() / k) * k);
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setFullYear(date.getFullYear() + step * k);
    });
};
const $52e844f3ca08f4ae$export$69a4e90dd2cc3bd1 = $52e844f3ca08f4ae$export$cd17cfe45df0c046.range;
const $52e844f3ca08f4ae$export$d5c3802e389714c4 = (0, $5e6227bfcf3a33f0$export$1a539c8b2950ab40)((date)=>{
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCFullYear(date.getUTCFullYear() + step);
}, (start, end)=>{
    return end.getUTCFullYear() - start.getUTCFullYear();
}, (date)=>{
    return date.getUTCFullYear();
});
// An optimized implementation for this simple case.
$52e844f3ca08f4ae$export$d5c3802e389714c4.every = (k)=>{
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $5e6227bfcf3a33f0$export$1a539c8b2950ab40)((date)=>{
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
};
const $52e844f3ca08f4ae$export$3e24d311e17f5802 = $52e844f3ca08f4ae$export$d5c3802e389714c4.range;


function $8050a8e9c01903df$var$ticker(year, month, week, day, hour, minute) {
    const tickIntervals = [
        [
            (0, $8f8e7aff3b0769cd$export$3d3c77ce7df7d30d),
            1,
            (0, $1d0582d0535eaf29$export$79ef0e34099623dc)
        ],
        [
            (0, $8f8e7aff3b0769cd$export$3d3c77ce7df7d30d),
            5,
            5 * (0, $1d0582d0535eaf29$export$79ef0e34099623dc)
        ],
        [
            (0, $8f8e7aff3b0769cd$export$3d3c77ce7df7d30d),
            15,
            15 * (0, $1d0582d0535eaf29$export$79ef0e34099623dc)
        ],
        [
            (0, $8f8e7aff3b0769cd$export$3d3c77ce7df7d30d),
            30,
            30 * (0, $1d0582d0535eaf29$export$79ef0e34099623dc)
        ],
        [
            minute,
            1,
            (0, $1d0582d0535eaf29$export$683905d551c33fa9)
        ],
        [
            minute,
            5,
            5 * (0, $1d0582d0535eaf29$export$683905d551c33fa9)
        ],
        [
            minute,
            15,
            15 * (0, $1d0582d0535eaf29$export$683905d551c33fa9)
        ],
        [
            minute,
            30,
            30 * (0, $1d0582d0535eaf29$export$683905d551c33fa9)
        ],
        [
            hour,
            1,
            (0, $1d0582d0535eaf29$export$4157bf0c8e241659)
        ],
        [
            hour,
            3,
            3 * (0, $1d0582d0535eaf29$export$4157bf0c8e241659)
        ],
        [
            hour,
            6,
            6 * (0, $1d0582d0535eaf29$export$4157bf0c8e241659)
        ],
        [
            hour,
            12,
            12 * (0, $1d0582d0535eaf29$export$4157bf0c8e241659)
        ],
        [
            day,
            1,
            (0, $1d0582d0535eaf29$export$353686095f4fbf45)
        ],
        [
            day,
            2,
            2 * (0, $1d0582d0535eaf29$export$353686095f4fbf45)
        ],
        [
            week,
            1,
            (0, $1d0582d0535eaf29$export$c241eb88520d5016)
        ],
        [
            month,
            1,
            (0, $1d0582d0535eaf29$export$ab95684df7020b26)
        ],
        [
            month,
            3,
            3 * (0, $1d0582d0535eaf29$export$ab95684df7020b26)
        ],
        [
            year,
            1,
            (0, $1d0582d0535eaf29$export$61f8ee2d834c6959)
        ]
    ];
    function ticks(start, stop, count) {
        const reverse = stop < start;
        if (reverse) [start, stop] = [
            stop,
            start
        ];
        const interval = count && typeof count.range === "function" ? count : tickInterval(start, stop, count);
        const ticks = interval ? interval.range(start, +stop + 1) : []; // inclusive stop
        return reverse ? ticks.reverse() : ticks;
    }
    function tickInterval(start, stop, count) {
        const target = Math.abs(stop - start) / count;
        const i = (0, $7dc99ea5c1b76bf9$export$2e2bcd8739ae039)(([, , step])=>step).right(tickIntervals, target);
        if (i === tickIntervals.length) return year.every((0, $8e8b0ab7237daf36$export$81087d9b915d4ede)(start / (0, $1d0582d0535eaf29$export$61f8ee2d834c6959), stop / (0, $1d0582d0535eaf29$export$61f8ee2d834c6959), count));
        if (i === 0) return (0, $723360f54160612b$export$edc5e5cb87280477).every(Math.max((0, $8e8b0ab7237daf36$export$81087d9b915d4ede)(start, stop, count), 1));
        const [t, step] = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        return t.every(step);
    }
    return [
        ticks,
        tickInterval
    ];
}
const [$8050a8e9c01903df$export$826ba5ae907e9767, $8050a8e9c01903df$export$6262d8d056ea44c4] = $8050a8e9c01903df$var$ticker((0, $52e844f3ca08f4ae$export$d5c3802e389714c4), (0, $57986bc5a9893c7d$export$cd49b3d2bcfe50d5), (0, $7b30ce921ff0ee22$export$4898b06303a92011), (0, $9b6201972b2c40bf$export$fb065be2d7ea4a71), (0, $71c4886b43888898$export$31f6f2b3c63ac75e), (0, $fa3a3bd5293506be$export$efe6712d6003761b));
const [$8050a8e9c01903df$export$60c76498552d28a6, $8050a8e9c01903df$export$69511150134dd174] = $8050a8e9c01903df$var$ticker((0, $52e844f3ca08f4ae$export$cd17cfe45df0c046), (0, $57986bc5a9893c7d$export$7e1084fb688591c1), (0, $7b30ce921ff0ee22$export$22ee6205b762968c), (0, $9b6201972b2c40bf$export$8888529b966033e5), (0, $71c4886b43888898$export$46c68a5833bc315b), (0, $fa3a3bd5293506be$export$a7e4c34a52f0576));



function $7f278ea4ef55f5c1$var$localDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
        date.setFullYear(d.y);
        return date;
    }
    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function $7f278ea4ef55f5c1$var$utcDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
        date.setUTCFullYear(d.y);
        return date;
    }
    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function $7f278ea4ef55f5c1$var$newDate(y, m, d) {
    return {
        y: y,
        m: m,
        d: d,
        H: 0,
        M: 0,
        S: 0,
        L: 0
    };
}
function $7f278ea4ef55f5c1$export$2e2bcd8739ae039(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    var periodRe = $7f278ea4ef55f5c1$var$formatRe(locale_periods), periodLookup = $7f278ea4ef55f5c1$var$formatLookup(locale_periods), weekdayRe = $7f278ea4ef55f5c1$var$formatRe(locale_weekdays), weekdayLookup = $7f278ea4ef55f5c1$var$formatLookup(locale_weekdays), shortWeekdayRe = $7f278ea4ef55f5c1$var$formatRe(locale_shortWeekdays), shortWeekdayLookup = $7f278ea4ef55f5c1$var$formatLookup(locale_shortWeekdays), monthRe = $7f278ea4ef55f5c1$var$formatRe(locale_months), monthLookup = $7f278ea4ef55f5c1$var$formatLookup(locale_months), shortMonthRe = $7f278ea4ef55f5c1$var$formatRe(locale_shortMonths), shortMonthLookup = $7f278ea4ef55f5c1$var$formatLookup(locale_shortMonths);
    var formats = {
        "a": formatShortWeekday,
        "A": formatWeekday,
        "b": formatShortMonth,
        "B": formatMonth,
        "c": null,
        "d": $7f278ea4ef55f5c1$var$formatDayOfMonth,
        "e": $7f278ea4ef55f5c1$var$formatDayOfMonth,
        "f": $7f278ea4ef55f5c1$var$formatMicroseconds,
        "g": $7f278ea4ef55f5c1$var$formatYearISO,
        "G": $7f278ea4ef55f5c1$var$formatFullYearISO,
        "H": $7f278ea4ef55f5c1$var$formatHour24,
        "I": $7f278ea4ef55f5c1$var$formatHour12,
        "j": $7f278ea4ef55f5c1$var$formatDayOfYear,
        "L": $7f278ea4ef55f5c1$var$formatMilliseconds,
        "m": $7f278ea4ef55f5c1$var$formatMonthNumber,
        "M": $7f278ea4ef55f5c1$var$formatMinutes,
        "p": formatPeriod,
        "q": formatQuarter,
        "Q": $7f278ea4ef55f5c1$var$formatUnixTimestamp,
        "s": $7f278ea4ef55f5c1$var$formatUnixTimestampSeconds,
        "S": $7f278ea4ef55f5c1$var$formatSeconds,
        "u": $7f278ea4ef55f5c1$var$formatWeekdayNumberMonday,
        "U": $7f278ea4ef55f5c1$var$formatWeekNumberSunday,
        "V": $7f278ea4ef55f5c1$var$formatWeekNumberISO,
        "w": $7f278ea4ef55f5c1$var$formatWeekdayNumberSunday,
        "W": $7f278ea4ef55f5c1$var$formatWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $7f278ea4ef55f5c1$var$formatYear,
        "Y": $7f278ea4ef55f5c1$var$formatFullYear,
        "Z": $7f278ea4ef55f5c1$var$formatZone,
        "%": $7f278ea4ef55f5c1$var$formatLiteralPercent
    };
    var utcFormats = {
        "a": formatUTCShortWeekday,
        "A": formatUTCWeekday,
        "b": formatUTCShortMonth,
        "B": formatUTCMonth,
        "c": null,
        "d": $7f278ea4ef55f5c1$var$formatUTCDayOfMonth,
        "e": $7f278ea4ef55f5c1$var$formatUTCDayOfMonth,
        "f": $7f278ea4ef55f5c1$var$formatUTCMicroseconds,
        "g": $7f278ea4ef55f5c1$var$formatUTCYearISO,
        "G": $7f278ea4ef55f5c1$var$formatUTCFullYearISO,
        "H": $7f278ea4ef55f5c1$var$formatUTCHour24,
        "I": $7f278ea4ef55f5c1$var$formatUTCHour12,
        "j": $7f278ea4ef55f5c1$var$formatUTCDayOfYear,
        "L": $7f278ea4ef55f5c1$var$formatUTCMilliseconds,
        "m": $7f278ea4ef55f5c1$var$formatUTCMonthNumber,
        "M": $7f278ea4ef55f5c1$var$formatUTCMinutes,
        "p": formatUTCPeriod,
        "q": formatUTCQuarter,
        "Q": $7f278ea4ef55f5c1$var$formatUnixTimestamp,
        "s": $7f278ea4ef55f5c1$var$formatUnixTimestampSeconds,
        "S": $7f278ea4ef55f5c1$var$formatUTCSeconds,
        "u": $7f278ea4ef55f5c1$var$formatUTCWeekdayNumberMonday,
        "U": $7f278ea4ef55f5c1$var$formatUTCWeekNumberSunday,
        "V": $7f278ea4ef55f5c1$var$formatUTCWeekNumberISO,
        "w": $7f278ea4ef55f5c1$var$formatUTCWeekdayNumberSunday,
        "W": $7f278ea4ef55f5c1$var$formatUTCWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $7f278ea4ef55f5c1$var$formatUTCYear,
        "Y": $7f278ea4ef55f5c1$var$formatUTCFullYear,
        "Z": $7f278ea4ef55f5c1$var$formatUTCZone,
        "%": $7f278ea4ef55f5c1$var$formatLiteralPercent
    };
    var parses = {
        "a": parseShortWeekday,
        "A": parseWeekday,
        "b": parseShortMonth,
        "B": parseMonth,
        "c": parseLocaleDateTime,
        "d": $7f278ea4ef55f5c1$var$parseDayOfMonth,
        "e": $7f278ea4ef55f5c1$var$parseDayOfMonth,
        "f": $7f278ea4ef55f5c1$var$parseMicroseconds,
        "g": $7f278ea4ef55f5c1$var$parseYear,
        "G": $7f278ea4ef55f5c1$var$parseFullYear,
        "H": $7f278ea4ef55f5c1$var$parseHour24,
        "I": $7f278ea4ef55f5c1$var$parseHour24,
        "j": $7f278ea4ef55f5c1$var$parseDayOfYear,
        "L": $7f278ea4ef55f5c1$var$parseMilliseconds,
        "m": $7f278ea4ef55f5c1$var$parseMonthNumber,
        "M": $7f278ea4ef55f5c1$var$parseMinutes,
        "p": parsePeriod,
        "q": $7f278ea4ef55f5c1$var$parseQuarter,
        "Q": $7f278ea4ef55f5c1$var$parseUnixTimestamp,
        "s": $7f278ea4ef55f5c1$var$parseUnixTimestampSeconds,
        "S": $7f278ea4ef55f5c1$var$parseSeconds,
        "u": $7f278ea4ef55f5c1$var$parseWeekdayNumberMonday,
        "U": $7f278ea4ef55f5c1$var$parseWeekNumberSunday,
        "V": $7f278ea4ef55f5c1$var$parseWeekNumberISO,
        "w": $7f278ea4ef55f5c1$var$parseWeekdayNumberSunday,
        "W": $7f278ea4ef55f5c1$var$parseWeekNumberMonday,
        "x": parseLocaleDate,
        "X": parseLocaleTime,
        "y": $7f278ea4ef55f5c1$var$parseYear,
        "Y": $7f278ea4ef55f5c1$var$parseFullYear,
        "Z": $7f278ea4ef55f5c1$var$parseZone,
        "%": $7f278ea4ef55f5c1$var$parseLiteralPercent
    };
    // These recursive directive definitions must be deferred.
    formats.x = newFormat(locale_date, formats);
    formats.X = newFormat(locale_time, formats);
    formats.c = newFormat(locale_dateTime, formats);
    utcFormats.x = newFormat(locale_date, utcFormats);
    utcFormats.X = newFormat(locale_time, utcFormats);
    utcFormats.c = newFormat(locale_dateTime, utcFormats);
    function newFormat(specifier, formats) {
        return function(date) {
            var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
            if (!(date instanceof Date)) date = new Date(+date);
            while(++i < n)if (specifier.charCodeAt(i) === 37) {
                string.push(specifier.slice(j, i));
                if ((pad = $7f278ea4ef55f5c1$var$pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                else pad = c === "e" ? " " : "0";
                if (format = formats[c]) c = format(date, pad);
                string.push(c);
                j = i + 1;
            }
            string.push(specifier.slice(j, i));
            return string.join("");
        };
    }
    function newParse(specifier, Z) {
        return function(string) {
            var d = $7f278ea4ef55f5c1$var$newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
            if (i != string.length) return null;
            // If a UNIX timestamp is specified, return it.
            if ("Q" in d) return new Date(d.Q);
            if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));
            // If this is utcParse, never use the local timezone.
            if (Z && !("Z" in d)) d.Z = 0;
            // The am-pm flag is 0 for AM, and 1 for PM.
            if ("p" in d) d.H = d.H % 12 + d.p * 12;
            // If the month was not specified, inherit from the quarter.
            if (d.m === undefined) d.m = "q" in d ? d.q : 0;
            // Convert day-of-week and week-of-year to day-of-year.
            if ("V" in d) {
                if (d.V < 1 || d.V > 53) return null;
                if (!("w" in d)) d.w = 1;
                if ("Z" in d) {
                    week = $7f278ea4ef55f5c1$var$utcDate($7f278ea4ef55f5c1$var$newDate(d.y, 0, 1)), day = week.getUTCDay();
                    week = day > 4 || day === 0 ? (0, $7b30ce921ff0ee22$export$9cfc53b9cfafd080).ceil(week) : (0, $7b30ce921ff0ee22$export$9cfc53b9cfafd080)(week);
                    week = (0, $9b6201972b2c40bf$export$c8cbc42cefd47140).offset(week, (d.V - 1) * 7);
                    d.y = week.getUTCFullYear();
                    d.m = week.getUTCMonth();
                    d.d = week.getUTCDate() + (d.w + 6) % 7;
                } else {
                    week = $7f278ea4ef55f5c1$var$localDate($7f278ea4ef55f5c1$var$newDate(d.y, 0, 1)), day = week.getDay();
                    week = day > 4 || day === 0 ? (0, $7b30ce921ff0ee22$export$e79bbe0177cf1b01).ceil(week) : (0, $7b30ce921ff0ee22$export$e79bbe0177cf1b01)(week);
                    week = (0, $9b6201972b2c40bf$export$8888529b966033e5).offset(week, (d.V - 1) * 7);
                    d.y = week.getFullYear();
                    d.m = week.getMonth();
                    d.d = week.getDate() + (d.w + 6) % 7;
                }
            } else if ("W" in d || "U" in d) {
                if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                day = "Z" in d ? $7f278ea4ef55f5c1$var$utcDate($7f278ea4ef55f5c1$var$newDate(d.y, 0, 1)).getUTCDay() : $7f278ea4ef55f5c1$var$localDate($7f278ea4ef55f5c1$var$newDate(d.y, 0, 1)).getDay();
                d.m = 0;
                d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
            }
            // If a time zone is specified, all fields are interpreted as UTC and then
            // offset according to the specified time zone.
            if ("Z" in d) {
                d.H += d.Z / 100 | 0;
                d.M += d.Z % 100;
                return $7f278ea4ef55f5c1$var$utcDate(d);
            }
            // Otherwise, all fields are in local time.
            return $7f278ea4ef55f5c1$var$localDate(d);
        };
    }
    function parseSpecifier(d, specifier, string, j) {
        var i = 0, n = specifier.length, m = string.length, c, parse;
        while(i < n){
            if (j >= m) return -1;
            c = specifier.charCodeAt(i++);
            if (c === 37) {
                c = specifier.charAt(i++);
                parse = parses[c in $7f278ea4ef55f5c1$var$pads ? specifier.charAt(i++) : c];
                if (!parse || (j = parse(d, string, j)) < 0) return -1;
            } else if (c != string.charCodeAt(j++)) return -1;
        }
        return j;
    }
    function parsePeriod(d, string, i) {
        var n = periodRe.exec(string.slice(i));
        return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortWeekday(d, string, i) {
        var n = shortWeekdayRe.exec(string.slice(i));
        return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseWeekday(d, string, i) {
        var n = weekdayRe.exec(string.slice(i));
        return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortMonth(d, string, i) {
        var n = shortMonthRe.exec(string.slice(i));
        return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseMonth(d, string, i) {
        var n = monthRe.exec(string.slice(i));
        return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseLocaleDateTime(d, string, i) {
        return parseSpecifier(d, locale_dateTime, string, i);
    }
    function parseLocaleDate(d, string, i) {
        return parseSpecifier(d, locale_date, string, i);
    }
    function parseLocaleTime(d, string, i) {
        return parseSpecifier(d, locale_time, string, i);
    }
    function formatShortWeekday(d) {
        return locale_shortWeekdays[d.getDay()];
    }
    function formatWeekday(d) {
        return locale_weekdays[d.getDay()];
    }
    function formatShortMonth(d) {
        return locale_shortMonths[d.getMonth()];
    }
    function formatMonth(d) {
        return locale_months[d.getMonth()];
    }
    function formatPeriod(d) {
        return locale_periods[+(d.getHours() >= 12)];
    }
    function formatQuarter(d) {
        return 1 + ~~(d.getMonth() / 3);
    }
    function formatUTCShortWeekday(d) {
        return locale_shortWeekdays[d.getUTCDay()];
    }
    function formatUTCWeekday(d) {
        return locale_weekdays[d.getUTCDay()];
    }
    function formatUTCShortMonth(d) {
        return locale_shortMonths[d.getUTCMonth()];
    }
    function formatUTCMonth(d) {
        return locale_months[d.getUTCMonth()];
    }
    function formatUTCPeriod(d) {
        return locale_periods[+(d.getUTCHours() >= 12)];
    }
    function formatUTCQuarter(d) {
        return 1 + ~~(d.getUTCMonth() / 3);
    }
    return {
        format: function(specifier) {
            var f = newFormat(specifier += "", formats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        parse: function(specifier) {
            var p = newParse(specifier += "", false);
            p.toString = function() {
                return specifier;
            };
            return p;
        },
        utcFormat: function(specifier) {
            var f = newFormat(specifier += "", utcFormats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        utcParse: function(specifier) {
            var p = newParse(specifier += "", true);
            p.toString = function() {
                return specifier;
            };
            return p;
        }
    };
}
var $7f278ea4ef55f5c1$var$pads = {
    "-": "",
    "_": " ",
    "0": "0"
}, $7f278ea4ef55f5c1$var$numberRe = /^\s*\d+/, $7f278ea4ef55f5c1$var$percentRe = /^%/, $7f278ea4ef55f5c1$var$requoteRe = /[\\^$*+?|[\]().{}]/g;
function $7f278ea4ef55f5c1$var$pad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function $7f278ea4ef55f5c1$var$requote(s) {
    return s.replace($7f278ea4ef55f5c1$var$requoteRe, "\\$&");
}
function $7f278ea4ef55f5c1$var$formatRe(names) {
    return new RegExp("^(?:" + names.map($7f278ea4ef55f5c1$var$requote).join("|") + ")", "i");
}
function $7f278ea4ef55f5c1$var$formatLookup(names) {
    return new Map(names.map((name, i)=>[
            name.toLowerCase(),
            i
        ]));
}
function $7f278ea4ef55f5c1$var$parseWeekdayNumberSunday(d, string, i) {
    var n = $7f278ea4ef55f5c1$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function $7f278ea4ef55f5c1$var$parseWeekdayNumberMonday(d, string, i) {
    var n = $7f278ea4ef55f5c1$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function $7f278ea4ef55f5c1$var$parseWeekNumberSunday(d, string, i) {
    var n = $7f278ea4ef55f5c1$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function $7f278ea4ef55f5c1$var$parseWeekNumberISO(d, string, i) {
    var n = $7f278ea4ef55f5c1$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function $7f278ea4ef55f5c1$var$parseWeekNumberMonday(d, string, i) {
    var n = $7f278ea4ef55f5c1$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function $7f278ea4ef55f5c1$var$parseFullYear(d, string, i) {
    var n = $7f278ea4ef55f5c1$var$numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function $7f278ea4ef55f5c1$var$parseYear(d, string, i) {
    var n = $7f278ea4ef55f5c1$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}
function $7f278ea4ef55f5c1$var$parseZone(d, string, i) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function $7f278ea4ef55f5c1$var$parseQuarter(d, string, i) {
    var n = $7f278ea4ef55f5c1$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function $7f278ea4ef55f5c1$var$parseMonthNumber(d, string, i) {
    var n = $7f278ea4ef55f5c1$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function $7f278ea4ef55f5c1$var$parseDayOfMonth(d, string, i) {
    var n = $7f278ea4ef55f5c1$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function $7f278ea4ef55f5c1$var$parseDayOfYear(d, string, i) {
    var n = $7f278ea4ef55f5c1$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function $7f278ea4ef55f5c1$var$parseHour24(d, string, i) {
    var n = $7f278ea4ef55f5c1$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function $7f278ea4ef55f5c1$var$parseMinutes(d, string, i) {
    var n = $7f278ea4ef55f5c1$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function $7f278ea4ef55f5c1$var$parseSeconds(d, string, i) {
    var n = $7f278ea4ef55f5c1$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function $7f278ea4ef55f5c1$var$parseMilliseconds(d, string, i) {
    var n = $7f278ea4ef55f5c1$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function $7f278ea4ef55f5c1$var$parseMicroseconds(d, string, i) {
    var n = $7f278ea4ef55f5c1$var$numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}
function $7f278ea4ef55f5c1$var$parseLiteralPercent(d, string, i) {
    var n = $7f278ea4ef55f5c1$var$percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
}
function $7f278ea4ef55f5c1$var$parseUnixTimestamp(d, string, i) {
    var n = $7f278ea4ef55f5c1$var$numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function $7f278ea4ef55f5c1$var$parseUnixTimestampSeconds(d, string, i) {
    var n = $7f278ea4ef55f5c1$var$numberRe.exec(string.slice(i));
    return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function $7f278ea4ef55f5c1$var$formatDayOfMonth(d, p) {
    return $7f278ea4ef55f5c1$var$pad(d.getDate(), p, 2);
}
function $7f278ea4ef55f5c1$var$formatHour24(d, p) {
    return $7f278ea4ef55f5c1$var$pad(d.getHours(), p, 2);
}
function $7f278ea4ef55f5c1$var$formatHour12(d, p) {
    return $7f278ea4ef55f5c1$var$pad(d.getHours() % 12 || 12, p, 2);
}
function $7f278ea4ef55f5c1$var$formatDayOfYear(d, p) {
    return $7f278ea4ef55f5c1$var$pad(1 + (0, $9b6201972b2c40bf$export$8888529b966033e5).count((0, $52e844f3ca08f4ae$export$cd17cfe45df0c046)(d), d), p, 3);
}
function $7f278ea4ef55f5c1$var$formatMilliseconds(d, p) {
    return $7f278ea4ef55f5c1$var$pad(d.getMilliseconds(), p, 3);
}
function $7f278ea4ef55f5c1$var$formatMicroseconds(d, p) {
    return $7f278ea4ef55f5c1$var$formatMilliseconds(d, p) + "000";
}
function $7f278ea4ef55f5c1$var$formatMonthNumber(d, p) {
    return $7f278ea4ef55f5c1$var$pad(d.getMonth() + 1, p, 2);
}
function $7f278ea4ef55f5c1$var$formatMinutes(d, p) {
    return $7f278ea4ef55f5c1$var$pad(d.getMinutes(), p, 2);
}
function $7f278ea4ef55f5c1$var$formatSeconds(d, p) {
    return $7f278ea4ef55f5c1$var$pad(d.getSeconds(), p, 2);
}
function $7f278ea4ef55f5c1$var$formatWeekdayNumberMonday(d) {
    var day = d.getDay();
    return day === 0 ? 7 : day;
}
function $7f278ea4ef55f5c1$var$formatWeekNumberSunday(d, p) {
    return $7f278ea4ef55f5c1$var$pad((0, $7b30ce921ff0ee22$export$22ee6205b762968c).count((0, $52e844f3ca08f4ae$export$cd17cfe45df0c046)(d) - 1, d), p, 2);
}
function $7f278ea4ef55f5c1$var$dISO(d) {
    var day = d.getDay();
    return day >= 4 || day === 0 ? (0, $7b30ce921ff0ee22$export$608689422d5cf9f4)(d) : (0, $7b30ce921ff0ee22$export$608689422d5cf9f4).ceil(d);
}
function $7f278ea4ef55f5c1$var$formatWeekNumberISO(d, p) {
    d = $7f278ea4ef55f5c1$var$dISO(d);
    return $7f278ea4ef55f5c1$var$pad((0, $7b30ce921ff0ee22$export$608689422d5cf9f4).count((0, $52e844f3ca08f4ae$export$cd17cfe45df0c046)(d), d) + ((0, $52e844f3ca08f4ae$export$cd17cfe45df0c046)(d).getDay() === 4), p, 2);
}
function $7f278ea4ef55f5c1$var$formatWeekdayNumberSunday(d) {
    return d.getDay();
}
function $7f278ea4ef55f5c1$var$formatWeekNumberMonday(d, p) {
    return $7f278ea4ef55f5c1$var$pad((0, $7b30ce921ff0ee22$export$e79bbe0177cf1b01).count((0, $52e844f3ca08f4ae$export$cd17cfe45df0c046)(d) - 1, d), p, 2);
}
function $7f278ea4ef55f5c1$var$formatYear(d, p) {
    return $7f278ea4ef55f5c1$var$pad(d.getFullYear() % 100, p, 2);
}
function $7f278ea4ef55f5c1$var$formatYearISO(d, p) {
    d = $7f278ea4ef55f5c1$var$dISO(d);
    return $7f278ea4ef55f5c1$var$pad(d.getFullYear() % 100, p, 2);
}
function $7f278ea4ef55f5c1$var$formatFullYear(d, p) {
    return $7f278ea4ef55f5c1$var$pad(d.getFullYear() % 10000, p, 4);
}
function $7f278ea4ef55f5c1$var$formatFullYearISO(d, p) {
    var day = d.getDay();
    d = day >= 4 || day === 0 ? (0, $7b30ce921ff0ee22$export$608689422d5cf9f4)(d) : (0, $7b30ce921ff0ee22$export$608689422d5cf9f4).ceil(d);
    return $7f278ea4ef55f5c1$var$pad(d.getFullYear() % 10000, p, 4);
}
function $7f278ea4ef55f5c1$var$formatZone(d) {
    var z = d.getTimezoneOffset();
    return (z > 0 ? "-" : (z *= -1, "+")) + $7f278ea4ef55f5c1$var$pad(z / 60 | 0, "0", 2) + $7f278ea4ef55f5c1$var$pad(z % 60, "0", 2);
}
function $7f278ea4ef55f5c1$var$formatUTCDayOfMonth(d, p) {
    return $7f278ea4ef55f5c1$var$pad(d.getUTCDate(), p, 2);
}
function $7f278ea4ef55f5c1$var$formatUTCHour24(d, p) {
    return $7f278ea4ef55f5c1$var$pad(d.getUTCHours(), p, 2);
}
function $7f278ea4ef55f5c1$var$formatUTCHour12(d, p) {
    return $7f278ea4ef55f5c1$var$pad(d.getUTCHours() % 12 || 12, p, 2);
}
function $7f278ea4ef55f5c1$var$formatUTCDayOfYear(d, p) {
    return $7f278ea4ef55f5c1$var$pad(1 + (0, $9b6201972b2c40bf$export$c8cbc42cefd47140).count((0, $52e844f3ca08f4ae$export$d5c3802e389714c4)(d), d), p, 3);
}
function $7f278ea4ef55f5c1$var$formatUTCMilliseconds(d, p) {
    return $7f278ea4ef55f5c1$var$pad(d.getUTCMilliseconds(), p, 3);
}
function $7f278ea4ef55f5c1$var$formatUTCMicroseconds(d, p) {
    return $7f278ea4ef55f5c1$var$formatUTCMilliseconds(d, p) + "000";
}
function $7f278ea4ef55f5c1$var$formatUTCMonthNumber(d, p) {
    return $7f278ea4ef55f5c1$var$pad(d.getUTCMonth() + 1, p, 2);
}
function $7f278ea4ef55f5c1$var$formatUTCMinutes(d, p) {
    return $7f278ea4ef55f5c1$var$pad(d.getUTCMinutes(), p, 2);
}
function $7f278ea4ef55f5c1$var$formatUTCSeconds(d, p) {
    return $7f278ea4ef55f5c1$var$pad(d.getUTCSeconds(), p, 2);
}
function $7f278ea4ef55f5c1$var$formatUTCWeekdayNumberMonday(d) {
    var dow = d.getUTCDay();
    return dow === 0 ? 7 : dow;
}
function $7f278ea4ef55f5c1$var$formatUTCWeekNumberSunday(d, p) {
    return $7f278ea4ef55f5c1$var$pad((0, $7b30ce921ff0ee22$export$4898b06303a92011).count((0, $52e844f3ca08f4ae$export$d5c3802e389714c4)(d) - 1, d), p, 2);
}
function $7f278ea4ef55f5c1$var$UTCdISO(d) {
    var day = d.getUTCDay();
    return day >= 4 || day === 0 ? (0, $7b30ce921ff0ee22$export$1db08111baec2f53)(d) : (0, $7b30ce921ff0ee22$export$1db08111baec2f53).ceil(d);
}
function $7f278ea4ef55f5c1$var$formatUTCWeekNumberISO(d, p) {
    d = $7f278ea4ef55f5c1$var$UTCdISO(d);
    return $7f278ea4ef55f5c1$var$pad((0, $7b30ce921ff0ee22$export$1db08111baec2f53).count((0, $52e844f3ca08f4ae$export$d5c3802e389714c4)(d), d) + ((0, $52e844f3ca08f4ae$export$d5c3802e389714c4)(d).getUTCDay() === 4), p, 2);
}
function $7f278ea4ef55f5c1$var$formatUTCWeekdayNumberSunday(d) {
    return d.getUTCDay();
}
function $7f278ea4ef55f5c1$var$formatUTCWeekNumberMonday(d, p) {
    return $7f278ea4ef55f5c1$var$pad((0, $7b30ce921ff0ee22$export$9cfc53b9cfafd080).count((0, $52e844f3ca08f4ae$export$d5c3802e389714c4)(d) - 1, d), p, 2);
}
function $7f278ea4ef55f5c1$var$formatUTCYear(d, p) {
    return $7f278ea4ef55f5c1$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $7f278ea4ef55f5c1$var$formatUTCYearISO(d, p) {
    d = $7f278ea4ef55f5c1$var$UTCdISO(d);
    return $7f278ea4ef55f5c1$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $7f278ea4ef55f5c1$var$formatUTCFullYear(d, p) {
    return $7f278ea4ef55f5c1$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $7f278ea4ef55f5c1$var$formatUTCFullYearISO(d, p) {
    var day = d.getUTCDay();
    d = day >= 4 || day === 0 ? (0, $7b30ce921ff0ee22$export$1db08111baec2f53)(d) : (0, $7b30ce921ff0ee22$export$1db08111baec2f53).ceil(d);
    return $7f278ea4ef55f5c1$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $7f278ea4ef55f5c1$var$formatUTCZone() {
    return "+0000";
}
function $7f278ea4ef55f5c1$var$formatLiteralPercent() {
    return "%";
}
function $7f278ea4ef55f5c1$var$formatUnixTimestamp(d) {
    return +d;
}
function $7f278ea4ef55f5c1$var$formatUnixTimestampSeconds(d) {
    return Math.floor(+d / 1000);
}


var $9a379d43128a049f$var$locale;
var $9a379d43128a049f$export$94f4d87fad5dcf9a;
var $9a379d43128a049f$export$32b9cd16e1b8c8d2;
var $9a379d43128a049f$export$1a08fe38f63ebbbb;
var $9a379d43128a049f$export$3edae9cf8e233729;
$9a379d43128a049f$export$2e2bcd8739ae039({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: [
        "AM",
        "PM"
    ],
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    shortDays: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    shortMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]
});
function $9a379d43128a049f$export$2e2bcd8739ae039(definition) {
    $9a379d43128a049f$var$locale = (0, $7f278ea4ef55f5c1$export$2e2bcd8739ae039)(definition);
    $9a379d43128a049f$export$94f4d87fad5dcf9a = $9a379d43128a049f$var$locale.format;
    $9a379d43128a049f$export$32b9cd16e1b8c8d2 = $9a379d43128a049f$var$locale.parse;
    $9a379d43128a049f$export$1a08fe38f63ebbbb = $9a379d43128a049f$var$locale.utcFormat;
    $9a379d43128a049f$export$3edae9cf8e233729 = $9a379d43128a049f$var$locale.utcParse;
    return $9a379d43128a049f$var$locale;
}





function $bd770533f55a6231$var$date(t) {
    return new Date(t);
}
function $bd770533f55a6231$var$number(t) {
    return t instanceof Date ? +t : +new Date(+t);
}
function $bd770533f55a6231$export$56bbcdb8aca31149(ticks, tickInterval, year, month, week, day, hour, minute, second, format) {
    var scale = (0, $ff5ec137a7df2572$export$2e2bcd8739ae039)(), invert = scale.invert, domain = scale.domain;
    var formatMillisecond = format(".%L"), formatSecond = format(":%S"), formatMinute = format("%I:%M"), formatHour = format("%I %p"), formatDay = format("%a %d"), formatWeek = format("%b %d"), formatMonth = format("%B"), formatYear = format("%Y");
    function tickFormat(date) {
        return (second(date) < date ? formatMillisecond : minute(date) < date ? formatSecond : hour(date) < date ? formatMinute : day(date) < date ? formatHour : month(date) < date ? week(date) < date ? formatDay : formatWeek : year(date) < date ? formatMonth : formatYear)(date);
    }
    scale.invert = function(y) {
        return new Date(invert(y));
    };
    scale.domain = function(_) {
        return arguments.length ? domain(Array.from(_, $bd770533f55a6231$var$number)) : domain().map($bd770533f55a6231$var$date);
    };
    scale.ticks = function(interval) {
        var d = domain();
        return ticks(d[0], d[d.length - 1], interval == null ? 10 : interval);
    };
    scale.tickFormat = function(count, specifier) {
        return specifier == null ? tickFormat : format(specifier);
    };
    scale.nice = function(interval) {
        var d = domain();
        if (!interval || typeof interval.range !== "function") interval = tickInterval(d[0], d[d.length - 1], interval == null ? 10 : interval);
        return interval ? domain((0, $ea53a5a9978b0e3a$export$2e2bcd8739ae039)(d, interval)) : scale;
    };
    scale.copy = function() {
        return (0, $ff5ec137a7df2572$export$784d13d8ee351f07)(scale, $bd770533f55a6231$export$56bbcdb8aca31149(ticks, tickInterval, year, month, week, day, hour, minute, second, format));
    };
    return scale;
}
function $bd770533f55a6231$export$2e2bcd8739ae039() {
    return (0, $1f5f05714ccdd883$export$23c7bb9e6558da2a).apply($bd770533f55a6231$export$56bbcdb8aca31149((0, $8050a8e9c01903df$export$60c76498552d28a6), (0, $8050a8e9c01903df$export$69511150134dd174), (0, $52e844f3ca08f4ae$export$cd17cfe45df0c046), (0, $57986bc5a9893c7d$export$7e1084fb688591c1), (0, $7b30ce921ff0ee22$export$22ee6205b762968c), (0, $9b6201972b2c40bf$export$8888529b966033e5), (0, $71c4886b43888898$export$46c68a5833bc315b), (0, $fa3a3bd5293506be$export$a7e4c34a52f0576), (0, $8f8e7aff3b0769cd$export$3d3c77ce7df7d30d), (0, $9a379d43128a049f$export$94f4d87fad5dcf9a)).domain([
        new Date(2000, 0, 1),
        new Date(2000, 0, 2)
    ]), arguments);
}






function $81433a1ec5a018a0$export$2e2bcd8739ae039() {
    return (0, $1f5f05714ccdd883$export$23c7bb9e6558da2a).apply((0, $bd770533f55a6231$export$56bbcdb8aca31149)((0, $8050a8e9c01903df$export$826ba5ae907e9767), (0, $8050a8e9c01903df$export$6262d8d056ea44c4), (0, $52e844f3ca08f4ae$export$d5c3802e389714c4), (0, $57986bc5a9893c7d$export$cd49b3d2bcfe50d5), (0, $7b30ce921ff0ee22$export$4898b06303a92011), (0, $9b6201972b2c40bf$export$c8cbc42cefd47140), (0, $71c4886b43888898$export$31f6f2b3c63ac75e), (0, $fa3a3bd5293506be$export$efe6712d6003761b), (0, $8f8e7aff3b0769cd$export$3d3c77ce7df7d30d), (0, $9a379d43128a049f$export$1a08fe38f63ebbbb)).domain([
        Date.UTC(2000, 0, 1),
        Date.UTC(2000, 0, 2)
    ]), arguments);
}









function $be828bbb873b60e2$var$transformer() {
    var x0 = 0, x1 = 1, t0, t1, k10, transform, interpolator = (0, $ff5ec137a7df2572$export$f0954fd7d5368655), clamp = false, unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [
            x0,
            x1
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1;
            return arguments.length ? ([r0, r1] = _, interpolator = interpolate(r0, r1), scale) : [
                interpolator(0),
                interpolator(1)
            ];
        };
    }
    scale.range = range((0, $9df523648b668b48$export$2e2bcd8739ae039));
    scale.rangeRound = range((0, $01a150189dfd6613$export$2e2bcd8739ae039));
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
        return scale;
    };
}
function $be828bbb873b60e2$export$784d13d8ee351f07(source, target) {
    return target.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());
}
function $be828bbb873b60e2$export$2e2bcd8739ae039() {
    var scale = (0, $7369c722765cb59f$export$16a5d4b4a61a274d)($be828bbb873b60e2$var$transformer()((0, $ff5ec137a7df2572$export$f0954fd7d5368655)));
    scale.copy = function() {
        return $be828bbb873b60e2$export$784d13d8ee351f07(scale, $be828bbb873b60e2$export$2e2bcd8739ae039());
    };
    return (0, $1f5f05714ccdd883$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $be828bbb873b60e2$export$6843e08bf2ff981f() {
    var scale = (0, $659bacbca617da2e$export$860836db074028f0)($be828bbb873b60e2$var$transformer()).domain([
        1,
        10
    ]);
    scale.copy = function() {
        return $be828bbb873b60e2$export$784d13d8ee351f07(scale, $be828bbb873b60e2$export$6843e08bf2ff981f()).base(scale.base());
    };
    return (0, $1f5f05714ccdd883$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $be828bbb873b60e2$export$9d4af4de62c81941() {
    var scale = (0, $6d6ed92c9022be1f$export$4602684e614eba38)($be828bbb873b60e2$var$transformer());
    scale.copy = function() {
        return $be828bbb873b60e2$export$784d13d8ee351f07(scale, $be828bbb873b60e2$export$9d4af4de62c81941()).constant(scale.constant());
    };
    return (0, $1f5f05714ccdd883$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $be828bbb873b60e2$export$de9f78581b4f2405() {
    var scale = (0, $ddc8211c8a258942$export$34695211ec403a46)($be828bbb873b60e2$var$transformer());
    scale.copy = function() {
        return $be828bbb873b60e2$export$784d13d8ee351f07(scale, $be828bbb873b60e2$export$de9f78581b4f2405()).exponent(scale.exponent());
    };
    return (0, $1f5f05714ccdd883$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $be828bbb873b60e2$export$413d935127ed466e() {
    return $be828bbb873b60e2$export$de9f78581b4f2405.apply(null, arguments).exponent(0.5);
}





function $3b6da429b3438544$export$2e2bcd8739ae039() {
    var domain = [], interpolator = (0, $ff5ec137a7df2572$export$f0954fd7d5368655);
    function scale(x) {
        if (x != null && !isNaN(x = +x)) return interpolator(((0, $7bf4b402f40c3a05$export$2e2bcd8739ae039)(domain, x, 1) - 1) / (domain.length - 1));
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort((0, $8bcd8071d2010e24$export$2e2bcd8739ae039));
        return scale;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    scale.range = function() {
        return domain.map((d, i)=>interpolator(i / (domain.length - 1)));
    };
    scale.quantiles = function(n) {
        return Array.from({
            length: n + 1
        }, (_, i)=>(0, $35ba05910c022a97$export$2e2bcd8739ae039)(domain, i / n));
    };
    scale.copy = function() {
        return $3b6da429b3438544$export$2e2bcd8739ae039(interpolator).domain(domain);
    };
    return (0, $1f5f05714ccdd883$export$7d6b419e59e83f3d).apply(scale, arguments);
}



function $c08287fcb29df120$export$2e2bcd8739ae039(interpolate, values) {
    if (values === undefined) values = interpolate, interpolate = (0, $9df523648b668b48$export$2e2bcd8739ae039);
    var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
    while(i < n)I[i] = interpolate(v, v = values[++i]);
    return function(t) {
        var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
        return I[i](t - i);
    };
}









function $d66475b85a502928$var$transformer() {
    var x0 = 0, x1 = 0.5, x2 = 1, s = 1, t0, t1, t2, k10, k21, interpolator = (0, $ff5ec137a7df2572$export$f0954fd7d5368655), transform, clamp = false, unknown;
    function scale(x) {
        return isNaN(x = +x) ? unknown : (x = 0.5 + ((x = +transform(x)) - t1) * (s * x < s * t1 ? k10 : k21), interpolator(clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1, x2] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), t2 = transform(x2 = +x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1, scale) : [
            x0,
            x1,
            x2
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1, r2;
            return arguments.length ? ([r0, r1, r2] = _, interpolator = (0, $c08287fcb29df120$export$2e2bcd8739ae039)(interpolate, [
                r0,
                r1,
                r2
            ]), scale) : [
                interpolator(0),
                interpolator(0.5),
                interpolator(1)
            ];
        };
    }
    scale.range = range((0, $9df523648b668b48$export$2e2bcd8739ae039));
    scale.rangeRound = range((0, $01a150189dfd6613$export$2e2bcd8739ae039));
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), t2 = t(x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1;
        return scale;
    };
}
function $d66475b85a502928$export$2e2bcd8739ae039() {
    var scale = (0, $7369c722765cb59f$export$16a5d4b4a61a274d)($d66475b85a502928$var$transformer()((0, $ff5ec137a7df2572$export$f0954fd7d5368655)));
    scale.copy = function() {
        return (0, $be828bbb873b60e2$export$784d13d8ee351f07)(scale, $d66475b85a502928$export$2e2bcd8739ae039());
    };
    return (0, $1f5f05714ccdd883$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $d66475b85a502928$export$5f0266a9159c47fb() {
    var scale = (0, $659bacbca617da2e$export$860836db074028f0)($d66475b85a502928$var$transformer()).domain([
        0.1,
        1,
        10
    ]);
    scale.copy = function() {
        return (0, $be828bbb873b60e2$export$784d13d8ee351f07)(scale, $d66475b85a502928$export$5f0266a9159c47fb()).base(scale.base());
    };
    return (0, $1f5f05714ccdd883$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $d66475b85a502928$export$50b3da713cf557c6() {
    var scale = (0, $6d6ed92c9022be1f$export$4602684e614eba38)($d66475b85a502928$var$transformer());
    scale.copy = function() {
        return (0, $be828bbb873b60e2$export$784d13d8ee351f07)(scale, $d66475b85a502928$export$50b3da713cf557c6()).constant(scale.constant());
    };
    return (0, $1f5f05714ccdd883$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $d66475b85a502928$export$d6cedcc63bf26e7e() {
    var scale = (0, $ddc8211c8a258942$export$34695211ec403a46)($d66475b85a502928$var$transformer());
    scale.copy = function() {
        return (0, $be828bbb873b60e2$export$784d13d8ee351f07)(scale, $d66475b85a502928$export$d6cedcc63bf26e7e()).exponent(scale.exponent());
    };
    return (0, $1f5f05714ccdd883$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $d66475b85a502928$export$33ddefb5c4ab9e9c() {
    return $d66475b85a502928$export$d6cedcc63bf26e7e.apply(null, arguments).exponent(0.5);
}





$parcel$exportWildcard($e2b5351039fefa1b$exports, $1af815627d835c18$exports);



function $a49f0acc2976fd6a$var$getD3ScaleFromType(realScaleType) {
    var scales = $e2b5351039fefa1b$exports;
    if (realScaleType in scales && typeof scales[realScaleType] === 'function') return scales[realScaleType]();
    var name = "scale".concat((0, $7e613228d3a31273$export$3061f22cd819074d)(realScaleType));
    if (name in scales && typeof scales[name] === 'function') return scales[name]();
    return undefined;
}
function $a49f0acc2976fd6a$export$b5d21797d2d3275f(scale, axisDomain, axisRange) {
    if (typeof scale === 'function') return scale.copy().domain(axisDomain).range(axisRange);
    if (scale == null) return undefined;
    var d3ScaleFunction = $a49f0acc2976fd6a$var$getD3ScaleFromType(scale);
    if (d3ScaleFunction == null) return undefined;
    d3ScaleFunction.domain(axisDomain).range(axisRange);
    return d3ScaleFunction;
}
function $a49f0acc2976fd6a$export$24f70d56c780d8f0(axis, realScaleType, axisDomain, axisRange) {
    if (axisDomain == null || axisRange == null) return undefined;
    if (typeof axis.scale === 'function') return $a49f0acc2976fd6a$export$b5d21797d2d3275f(axis.scale, axisDomain, axisRange);
    return $a49f0acc2976fd6a$export$b5d21797d2d3275f(realScaleType, axisDomain, axisRange);
}




function $2772e85521d4b2a0$var$getD3ScaleName(name) {
    return "scale".concat((0, $7e613228d3a31273$export$3061f22cd819074d)(name));
}
function $2772e85521d4b2a0$var$isSupportedScaleName(name) {
    return $2772e85521d4b2a0$var$getD3ScaleName(name) in $e2b5351039fefa1b$exports;
}
var $2772e85521d4b2a0$export$bebec32544750591 = (axisConfig, hasBar, chartType)=>{
    if (axisConfig == null) return undefined;
    var { scale: scale, type: type } = axisConfig;
    if (scale === 'auto') {
        if (type === 'category' && chartType && (chartType.indexOf('LineChart') >= 0 || chartType.indexOf('AreaChart') >= 0 || chartType.indexOf('ComposedChart') >= 0 && !hasBar)) return 'point';
        if (type === 'category') return 'band';
        return 'linear';
    }
    if (typeof scale === 'string') return $2772e85521d4b2a0$var$isSupportedScaleName(scale) ? scale : 'point';
    return undefined;
};


/**
 * Binary search to find the index where x would fit in array a.
 * Works for arrays that are sorted both ascending and descending.
 *
 * Unlike d3.bisect, this implementation handles both ascending and descending arrays.
 *
 * @param haystack Sorted array of numbers
 * @param needle Number to find the insertion index for
 * @returns Index where x would fit in array a
 */ function $fdcfc9136938d122$export$a668c821d9678ea6(haystack, needle) {
    var lo = 0;
    var hi = haystack.length;
    var ascending = haystack[0] < haystack[haystack.length - 1];
    while(lo < hi){
        var mid = Math.floor((lo + hi) / 2);
        if (ascending ? haystack[mid] < needle : haystack[mid] > needle) lo = mid + 1;
        else hi = mid;
    }
    return lo;
}
function $fdcfc9136938d122$export$e954f4783a2f3ac0(scale, allDataPointsOnAxis) {
    if (!scale) return undefined;
    var domain = allDataPointsOnAxis !== null && allDataPointsOnAxis !== void 0 ? allDataPointsOnAxis : scale.domain();
    // Build an array of pixel positions for each domain value
    // @ts-expect-error we're attempting to scale unknown without having guarantee that it is a Domain type
    var pixelPositions = domain.map((d)=>{
        var _scale;
        return (_scale = scale(d)) !== null && _scale !== void 0 ? _scale : 0;
    });
    var range = scale.range();
    if (domain.length === 0 || range.length < 2) return undefined;
    return (pixelValue)=>{
        var _pixelPositions, _pixelPositions$index;
        // Find the closest domain value using bisect
        var index = $fdcfc9136938d122$export$a668c821d9678ea6(pixelPositions, pixelValue);
        // Clamp to valid range
        if (index <= 0) return domain[0];
        if (index >= domain.length) return domain[domain.length - 1];
        // Check which neighbor is closer
        var leftPixel = (_pixelPositions = pixelPositions[index - 1]) !== null && _pixelPositions !== void 0 ? _pixelPositions : 0;
        var rightPixel = (_pixelPositions$index = pixelPositions[index]) !== null && _pixelPositions$index !== void 0 ? _pixelPositions$index : 0;
        if (Math.abs(pixelValue - leftPixel) <= Math.abs(pixelValue - rightPixel)) return domain[index - 1];
        return domain[index];
    };
}



function $657a9330a7224194$export$757040754bd60df5(configuredScale) {
    if (configuredScale == null) return undefined;
    if ('invert' in configuredScale && typeof configuredScale.invert === 'function') return configuredScale.invert.bind(configuredScale);
    return (0, $fdcfc9136938d122$export$e954f4783a2f3ac0)(configuredScale, undefined);
}


function $223cdb002ac9c48b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $223cdb002ac9c48b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $223cdb002ac9c48b$var$ownKeys(Object(t), !0).forEach(function(r) {
            $223cdb002ac9c48b$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $223cdb002ac9c48b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $223cdb002ac9c48b$var$_defineProperty(e, r, t) {
    return (r = $223cdb002ac9c48b$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $223cdb002ac9c48b$var$_toPropertyKey(t) {
    var i = $223cdb002ac9c48b$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $223cdb002ac9c48b$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $223cdb002ac9c48b$export$a012a4dce80491c2 = [
    0,
    'auto'
];
var $223cdb002ac9c48b$export$21aec091b6ac8422 = {
    allowDataOverflow: false,
    allowDecimals: true,
    allowDuplicatedCategory: true,
    angle: 0,
    dataKey: undefined,
    domain: undefined,
    height: 30,
    hide: true,
    id: 0,
    includeHidden: false,
    interval: 'preserveEnd',
    minTickGap: 5,
    mirror: false,
    name: undefined,
    orientation: 'bottom',
    padding: {
        left: 0,
        right: 0
    },
    reversed: false,
    scale: 'auto',
    tick: true,
    tickCount: 5,
    tickFormatter: undefined,
    ticks: undefined,
    type: 'category',
    unit: undefined,
    niceTicks: 'auto'
};
var $223cdb002ac9c48b$export$8079b33b4a6a2ac5 = (state, axisId)=>{
    return state.cartesianAxis.xAxis[axisId];
};
var $223cdb002ac9c48b$export$d6895d8ddb4cee5 = (state, axisId)=>{
    var axis = $223cdb002ac9c48b$export$8079b33b4a6a2ac5(state, axisId);
    if (axis == null) return $223cdb002ac9c48b$export$21aec091b6ac8422;
    return axis;
};
var $223cdb002ac9c48b$export$397148de2ecdec3c = {
    allowDataOverflow: false,
    allowDecimals: true,
    allowDuplicatedCategory: true,
    angle: 0,
    dataKey: undefined,
    domain: $223cdb002ac9c48b$export$a012a4dce80491c2,
    hide: true,
    id: 0,
    includeHidden: false,
    interval: 'preserveEnd',
    minTickGap: 5,
    mirror: false,
    name: undefined,
    orientation: 'left',
    padding: {
        top: 0,
        bottom: 0
    },
    reversed: false,
    scale: 'auto',
    tick: true,
    tickCount: 5,
    tickFormatter: undefined,
    ticks: undefined,
    type: 'number',
    unit: undefined,
    niceTicks: 'auto',
    width: (0, $868751348c5652f4$export$fb6ee82c8ee2faf8)
};
var $223cdb002ac9c48b$export$d0970661da76c14c = (state, axisId)=>{
    return state.cartesianAxis.yAxis[axisId];
};
var $223cdb002ac9c48b$export$1f472705a332f1c9 = (state, axisId)=>{
    var axis = $223cdb002ac9c48b$export$d0970661da76c14c(state, axisId);
    if (axis == null) return $223cdb002ac9c48b$export$397148de2ecdec3c;
    return axis;
};
var $223cdb002ac9c48b$export$73a439a535d82503 = {
    domain: [
        0,
        'auto'
    ],
    includeHidden: false,
    reversed: false,
    allowDataOverflow: false,
    allowDuplicatedCategory: false,
    dataKey: undefined,
    id: 0,
    name: '',
    range: [
        64,
        64
    ],
    scale: 'auto',
    type: 'number',
    unit: ''
};
var $223cdb002ac9c48b$export$26eadf639b453d0f = (state, axisId)=>{
    var axis = state.cartesianAxis.zAxis[axisId];
    if (axis == null) return $223cdb002ac9c48b$export$73a439a535d82503;
    return axis;
};
var $223cdb002ac9c48b$export$fc14c3706e09c50c = (state, axisType, axisId)=>{
    switch(axisType){
        case 'xAxis':
            return $223cdb002ac9c48b$export$d6895d8ddb4cee5(state, axisId);
        case 'yAxis':
            return $223cdb002ac9c48b$export$1f472705a332f1c9(state, axisId);
        case 'zAxis':
            return $223cdb002ac9c48b$export$26eadf639b453d0f(state, axisId);
        case 'angleAxis':
            return (0, $792f72abcce61010$export$2d9ff7eb66def0da)(state, axisId);
        case 'radiusAxis':
            return (0, $792f72abcce61010$export$74b0499accddabe1)(state, axisId);
        default:
            throw new Error("Unexpected axis type: ".concat(axisType));
    }
};
var $223cdb002ac9c48b$var$selectCartesianAxisSettings = (state, axisType, axisId)=>{
    switch(axisType){
        case 'xAxis':
            return $223cdb002ac9c48b$export$d6895d8ddb4cee5(state, axisId);
        case 'yAxis':
            return $223cdb002ac9c48b$export$1f472705a332f1c9(state, axisId);
        default:
            throw new Error("Unexpected axis type: ".concat(axisType));
    }
};
var $223cdb002ac9c48b$export$f5176fa96b596697 = (state, axisType, axisId)=>{
    switch(axisType){
        case 'xAxis':
            return $223cdb002ac9c48b$export$d6895d8ddb4cee5(state, axisId);
        case 'yAxis':
            return $223cdb002ac9c48b$export$1f472705a332f1c9(state, axisId);
        case 'angleAxis':
            return (0, $792f72abcce61010$export$2d9ff7eb66def0da)(state, axisId);
        case 'radiusAxis':
            return (0, $792f72abcce61010$export$74b0499accddabe1)(state, axisId);
        default:
            throw new Error("Unexpected axis type: ".concat(axisType));
    }
};
var $223cdb002ac9c48b$export$1c7798b82c8010cd = (state)=>state.graphicalItems.cartesianItems.some((item)=>item.type === 'bar') || state.graphicalItems.polarItems.some((item)=>item.type === 'radialBar');
function $223cdb002ac9c48b$export$a3923f321c6572c3(axisType, axisId) {
    return (item)=>{
        switch(axisType){
            case 'xAxis':
                // This is sensitive to the data type, as 0 !== '0'. I wonder if we should be more flexible. How does 2.x branch behave? TODO write test for that
                return 'xAxisId' in item && item.xAxisId === axisId;
            case 'yAxis':
                return 'yAxisId' in item && item.yAxisId === axisId;
            case 'zAxis':
                return 'zAxisId' in item && item.zAxisId === axisId;
            case 'angleAxis':
                return 'angleAxisId' in item && item.angleAxisId === axisId;
            case 'radiusAxis':
                return 'radiusAxisId' in item && item.radiusAxisId === axisId;
            default:
                return false;
        }
    };
}
var $223cdb002ac9c48b$export$f67c737adf41a3af = (state)=>state.graphicalItems.cartesianItems;
var $223cdb002ac9c48b$var$selectAxisPredicate = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    (0, $0356005269dcff20$export$8a7d579879340d98),
    (0, $8a59510828e5484a$export$6a2efa106dc9c8f6)
], $223cdb002ac9c48b$export$a3923f321c6572c3);
var $223cdb002ac9c48b$export$ad35679ce4582010 = (graphicalItems, axisSettings, axisPredicate)=>graphicalItems.filter(axisPredicate).filter((item)=>{
        if ((axisSettings === null || axisSettings === void 0 ? void 0 : axisSettings.includeHidden) === true) return true;
        return !item.hide;
    });
var $223cdb002ac9c48b$export$533d13f911334c9d = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $223cdb002ac9c48b$export$f67c737adf41a3af,
    $223cdb002ac9c48b$export$fc14c3706e09c50c,
    $223cdb002ac9c48b$var$selectAxisPredicate
], $223cdb002ac9c48b$export$ad35679ce4582010, {
    memoizeOptions: {
        resultEqualityCheck: (0, $a931610653760bd0$export$dcc34c4213e7f4c)
    }
});
var $223cdb002ac9c48b$export$58ad06f71246a0da = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $223cdb002ac9c48b$export$533d13f911334c9d
], (cartesianItems)=>{
    return cartesianItems.filter((item)=>item.type === 'area' || item.type === 'bar').filter((0, $66614bffc4581796$export$2335dd91cc88053e));
});
var $223cdb002ac9c48b$export$a61da86823382adc = (cartesianItems)=>cartesianItems.filter((item)=>!('stackId' in item) || item.stackId === undefined);
var $223cdb002ac9c48b$var$selectCartesianItemsSettingsExceptStacked = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $223cdb002ac9c48b$export$533d13f911334c9d
], $223cdb002ac9c48b$export$a61da86823382adc);
var $223cdb002ac9c48b$export$d945cee965d266f0 = (cartesianItems)=>cartesianItems.map((item)=>item.data).filter(Boolean).flat(1);
var $223cdb002ac9c48b$export$19d147541685480 = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $223cdb002ac9c48b$export$533d13f911334c9d
], (items)=>items.some((item)=>!item.data));
var $223cdb002ac9c48b$export$f2151bebfd9ae457 = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $223cdb002ac9c48b$export$533d13f911334c9d
], $223cdb002ac9c48b$export$d945cee965d266f0, {
    memoizeOptions: {
        resultEqualityCheck: (0, $a931610653760bd0$export$dcc34c4213e7f4c)
    }
});
var $223cdb002ac9c48b$export$c2c6d012cffe2c75 = (graphicalItemsData, _ref)=>{
    var { chartData: chartData = [], dataStartIndex: dataStartIndex, dataEndIndex: dataEndIndex } = _ref;
    if (graphicalItemsData.length > 0) /*
     * There is no slicing when data is defined on graphical items. Why?
     * Because Brush ignores data defined on graphical items,
     * and does not render.
     * So Brush will never show up in a Scatter chart for example.
     * This is something we will need to fix.
     *
     * Now, when the root chart data is not defined, the dataEndIndex is 0,
     * which means the itemsData will be sliced to an empty array anyway.
     * But that's an implementation detail, and we can fix that too.
     *
     * Also, in absence of Axis dataKey, we use the dataKey from each item, respectively.
     * This is the usual pattern for numerical axis, that is the one where bars go up:
     * users don't specify any dataKey by default and expect the axis to "just match the data".
     */ return graphicalItemsData;
    return chartData.slice(dataStartIndex, dataEndIndex + 1);
};
var $223cdb002ac9c48b$export$6099ba314905f0c4 = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $223cdb002ac9c48b$export$f2151bebfd9ae457,
    (0, $8c22b3d5bf36186c$export$fe05134c2701d897)
], $223cdb002ac9c48b$export$c2c6d012cffe2c75);
var $223cdb002ac9c48b$export$3051da2013ba9cfe = (data, axisSettings, items)=>{
    if ((axisSettings === null || axisSettings === void 0 ? void 0 : axisSettings.dataKey) != null) return data.map((item)=>({
            value: (0, $d5958b0668c58531$export$f97fc4a450f29a)(item, axisSettings.dataKey)
        }));
    if (items.length > 0) return items.map((item)=>item.dataKey).flatMap((dataKey)=>data.map((entry)=>({
                value: (0, $d5958b0668c58531$export$f97fc4a450f29a)(entry, dataKey)
            })));
    return data.map((entry)=>({
            value: entry
        }));
};
var $223cdb002ac9c48b$export$48831dc762d7b6ad = (displayedData, axisSettings, items, _ref2, anyItemUsesChartData, graphicalItemsData)=>{
    var { chartData: chartData = [], dataStartIndex: dataStartIndex, dataEndIndex: dataEndIndex } = _ref2;
    var appliedValues = $223cdb002ac9c48b$export$3051da2013ba9cfe(displayedData, axisSettings, items);
    if (anyItemUsesChartData && (axisSettings === null || axisSettings === void 0 ? void 0 : axisSettings.dataKey) != null && graphicalItemsData.length > 0) {
        var chartDataSlice = chartData.slice(dataStartIndex, dataEndIndex + 1);
        var chartAppliedValues = chartDataSlice.map((item)=>({
                value: (0, $d5958b0668c58531$export$f97fc4a450f29a)(item, axisSettings.dataKey)
            })).filter((av)=>av.value != null);
        return [
            ...chartAppliedValues,
            ...appliedValues
        ];
    }
    return appliedValues;
};
var $223cdb002ac9c48b$export$9cea618b690f07b7 = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $223cdb002ac9c48b$export$6099ba314905f0c4,
    $223cdb002ac9c48b$export$fc14c3706e09c50c,
    $223cdb002ac9c48b$export$533d13f911334c9d,
    (0, $8c22b3d5bf36186c$export$fe05134c2701d897),
    $223cdb002ac9c48b$export$19d147541685480,
    $223cdb002ac9c48b$export$f2151bebfd9ae457
], $223cdb002ac9c48b$export$48831dc762d7b6ad);
function $223cdb002ac9c48b$var$makeNumber(val) {
    if ((0, $7e613228d3a31273$export$402a499e1ea44294)(val) || val instanceof Date) {
        var n = Number(val);
        if ((0, $22869ac8a5888437$export$f8a8fc612ced9bb0)(n)) return n;
    }
    return undefined;
}
function $223cdb002ac9c48b$var$makeDomain(val) {
    if (Array.isArray(val)) {
        var attempt = [
            $223cdb002ac9c48b$var$makeNumber(val[0]),
            $223cdb002ac9c48b$var$makeNumber(val[1])
        ];
        if ((0, $5bcc5341b7e18f2a$export$ba29b24e2a92eb58)(attempt)) return attempt;
        return undefined;
    }
    var n = $223cdb002ac9c48b$var$makeNumber(val);
    if (n == null) return undefined;
    return [
        n,
        n
    ];
}
function $223cdb002ac9c48b$var$onlyAllowNumbers(data) {
    return data.map($223cdb002ac9c48b$var$makeNumber).filter((0, $7e613228d3a31273$export$7e515ab5fbd92bef));
}
function $223cdb002ac9c48b$var$sortBy(a, b) {
    var aNum = $223cdb002ac9c48b$var$makeNumber(a);
    var bNum = $223cdb002ac9c48b$var$makeNumber(b);
    if (aNum == null && bNum == null) return 0;
    if (aNum == null) return -1;
    if (bNum == null) return 1;
    return aNum - bNum;
}
var $223cdb002ac9c48b$export$23eb57bf0bace166 = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $223cdb002ac9c48b$export$9cea618b690f07b7
], (appliedData)=>{
    return appliedData === null || appliedData === void 0 ? void 0 : appliedData.map((item)=>item.value).sort($223cdb002ac9c48b$var$sortBy);
});
function $223cdb002ac9c48b$export$8b0eb5a8c39b724f(axisType, errorBar) {
    switch(axisType){
        case 'xAxis':
            return errorBar.direction === 'x';
        case 'yAxis':
            return errorBar.direction === 'y';
        default:
            return false;
    }
}
function $223cdb002ac9c48b$export$25971beae035f58a(entry, appliedValue, relevantErrorBars) {
    if (!relevantErrorBars) return [];
    if (!relevantErrorBars.length) return [];
    var appliedNumericValue;
    if (typeof appliedValue === 'number' && !(0, $7e613228d3a31273$export$e426a261f3212d7d)(appliedValue)) appliedNumericValue = appliedValue;
    else if (Array.isArray(appliedValue)) {
        var numericRangeValues = $223cdb002ac9c48b$var$onlyAllowNumbers(appliedValue);
        if (numericRangeValues.length > 0) appliedNumericValue = Math.max(...numericRangeValues);
    }
    if (appliedNumericValue == null) return [];
    return $223cdb002ac9c48b$var$onlyAllowNumbers(relevantErrorBars.flatMap((eb)=>{
        var errorValue = (0, $d5958b0668c58531$export$f97fc4a450f29a)(entry, eb.dataKey);
        var lowBound, highBound;
        if (Array.isArray(errorValue)) [lowBound, highBound] = errorValue;
        else lowBound = highBound = errorValue;
        if (!(0, $22869ac8a5888437$export$f8a8fc612ced9bb0)(lowBound) || !(0, $22869ac8a5888437$export$f8a8fc612ced9bb0)(highBound)) return undefined;
        return [
            appliedNumericValue - lowBound,
            appliedNumericValue + highBound
        ];
    }));
}
var $223cdb002ac9c48b$export$27d9004292294cd7 = (state)=>{
    var axisType = (0, $ab8db2d9eb83d918$export$898d3dfd98fb482)(state);
    var axisId = (0, $cbdc2e68b6a9737d$export$eeffdb10daff095d)(state);
    return $223cdb002ac9c48b$export$f5176fa96b596697(state, axisType, axisId);
};
var $223cdb002ac9c48b$export$bf8397fefbaa3617 = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $223cdb002ac9c48b$export$27d9004292294cd7
], (axis)=>axis === null || axis === void 0 ? void 0 : axis.dataKey);
var $223cdb002ac9c48b$export$b329ef9482661e60 = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $223cdb002ac9c48b$export$58ad06f71246a0da,
    (0, $8c22b3d5bf36186c$export$fe05134c2701d897),
    $223cdb002ac9c48b$export$27d9004292294cd7
], (0, $c20d7381b4964aa5$export$ae6c77e7720cddf9));
var $223cdb002ac9c48b$export$9312914d13496409 = (displayedData, items, stackOffsetType, reverseStackOrder)=>{
    var initialItemsGroups = {};
    var itemsGroup = items.reduce((acc, item)=>{
        if (item.stackId == null) return acc;
        var stack = acc[item.stackId];
        if (stack == null) stack = [];
        stack.push(item);
        acc[item.stackId] = stack;
        return acc;
    }, initialItemsGroups);
    return Object.fromEntries(Object.entries(itemsGroup).map((_ref3)=>{
        var [stackId, graphicalItems] = _ref3;
        var orderedGraphicalItems = reverseStackOrder ? [
            ...graphicalItems
        ].reverse() : graphicalItems;
        var dataKeys = orderedGraphicalItems.map((0, $a7f2a68891925785$export$58b095b87bc46727));
        return [
            stackId,
            {
                // @ts-expect-error getStackedData requires that the input is array of objects, Recharts does not test for that
                stackedData: (0, $d5958b0668c58531$export$c2170542cfc0177c)(displayedData, dataKeys, stackOffsetType),
                graphicalItems: orderedGraphicalItems
            }
        ];
    }));
};
var $223cdb002ac9c48b$export$af2278e5e47fc440 = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $223cdb002ac9c48b$export$b329ef9482661e60,
    $223cdb002ac9c48b$export$58ad06f71246a0da,
    (0, $1728a742f9386be1$export$73aff39176364def),
    (0, $1728a742f9386be1$export$ec830dc49707c6da)
], $223cdb002ac9c48b$export$9312914d13496409);
var $223cdb002ac9c48b$export$3286b8ea6ff06720 = (stackGroups, _ref4, axisType, domainFromUserPreference)=>{
    var { dataStartIndex: dataStartIndex, dataEndIndex: dataEndIndex } = _ref4;
    if (domainFromUserPreference != null) // User has specified a domain, so we respect that and we can skip computing anything else
    return undefined;
    if (axisType === 'zAxis') // ZAxis ignores stacks
    return undefined;
    var domainOfStackGroups = (0, $d5958b0668c58531$export$26522b779eb5497c)(stackGroups, dataStartIndex, dataEndIndex);
    if (domainOfStackGroups != null && domainOfStackGroups[0] === 0 && domainOfStackGroups[1] === 0) return undefined;
    return domainOfStackGroups;
};
var $223cdb002ac9c48b$var$selectAllowsDataOverflow = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $223cdb002ac9c48b$export$fc14c3706e09c50c
], (axisSettings)=>axisSettings.allowDataOverflow);
var $223cdb002ac9c48b$export$2e6262b6c952ab02 = (axisSettings)=>{
    var _axisSettings$domain;
    if (axisSettings == null || !('domain' in axisSettings)) return $223cdb002ac9c48b$export$a012a4dce80491c2;
    if (axisSettings.domain != null) return axisSettings.domain;
    if ('ticks' in axisSettings && axisSettings.ticks != null) {
        if (axisSettings.type === 'number') {
            var allValues = $223cdb002ac9c48b$var$onlyAllowNumbers(axisSettings.ticks);
            return [
                Math.min(...allValues),
                Math.max(...allValues)
            ];
        }
        if (axisSettings.type === 'category') return axisSettings.ticks.map(String);
    }
    return (_axisSettings$domain = axisSettings === null || axisSettings === void 0 ? void 0 : axisSettings.domain) !== null && _axisSettings$domain !== void 0 ? _axisSettings$domain : $223cdb002ac9c48b$export$a012a4dce80491c2;
};
var $223cdb002ac9c48b$export$5d46410c3f089eb2 = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $223cdb002ac9c48b$export$fc14c3706e09c50c
], $223cdb002ac9c48b$export$2e6262b6c952ab02);
var $223cdb002ac9c48b$export$c21dc69ecce61f8a = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $223cdb002ac9c48b$export$5d46410c3f089eb2,
    $223cdb002ac9c48b$var$selectAllowsDataOverflow
], (0, $5bcc5341b7e18f2a$export$fcbf88d4627b24df));
var $223cdb002ac9c48b$export$969bc8d84122c036 = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $223cdb002ac9c48b$export$af2278e5e47fc440,
    (0, $8c22b3d5bf36186c$export$519edd692222520),
    (0, $0356005269dcff20$export$8a7d579879340d98),
    $223cdb002ac9c48b$export$c21dc69ecce61f8a
], $223cdb002ac9c48b$export$3286b8ea6ff06720, {
    memoizeOptions: {
        resultEqualityCheck: (0, $30bf67e96df5a044$export$45c01007b107f1a6)
    }
});
var $223cdb002ac9c48b$export$9429ab4550237b6d = (state)=>state.errorBars;
var $223cdb002ac9c48b$var$combineRelevantErrorBarSettings = (cartesianItemsSettings, allErrorBarSettings, axisType)=>{
    return cartesianItemsSettings.flatMap((item)=>{
        return allErrorBarSettings[item.id];
    }).filter(Boolean).filter((e)=>{
        return $223cdb002ac9c48b$export$8b0eb5a8c39b724f(axisType, e);
    });
};
var $223cdb002ac9c48b$export$9c8185c6eda0fb0d = function mergeDomains() {
    for(var _len = arguments.length, domains = new Array(_len), _key = 0; _key < _len; _key++)domains[_key] = arguments[_key];
    var allDomains = domains.filter(Boolean);
    if (allDomains.length === 0) return undefined;
    var allValues = allDomains.flat();
    var min = Math.min(...allValues);
    var max = Math.max(...allValues);
    return [
        min,
        max
    ];
};
var $223cdb002ac9c48b$export$df56c8e9a3e45e65 = function combineDomainOfAllAppliedNumericalValuesIncludingErrorValues(displayedData, axisSettings, items, errorBars, axisType) {
    var chartDataSlice = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
    var lowerEnd, upperEnd;
    if (items.length > 0) /*
     * Iterate item-first so each item can use its own `data` prop when present,
     * falling back to the chart-level data slice for items that rely on it.
     * This ensures that mixing items with and without own data (e.g. Bar reading
     * chart-level data alongside a Scatter with its own outlier data) produces a
     * domain that covers all values from all sources.
     */ items.forEach((item)=>{
        var _errorBars$item$id;
        var itemData = item.data != null ? [
            ...item.data
        ] : chartDataSlice;
        var relevantErrorBars = (_errorBars$item$id = errorBars[item.id]) === null || _errorBars$item$id === void 0 ? void 0 : _errorBars$item$id.filter((errorBar)=>$223cdb002ac9c48b$export$8b0eb5a8c39b724f(axisType, errorBar));
        itemData.forEach((entry)=>{
            var _axisSettings$dataKey;
            var valueByDataKey = (0, $d5958b0668c58531$export$f97fc4a450f29a)(entry, (_axisSettings$dataKey = axisSettings.dataKey) !== null && _axisSettings$dataKey !== void 0 ? _axisSettings$dataKey : item.dataKey);
            var errorDomain = $223cdb002ac9c48b$export$25971beae035f58a(entry, valueByDataKey, relevantErrorBars);
            if (errorDomain.length >= 2) {
                var localLower = Math.min(...errorDomain);
                var localUpper = Math.max(...errorDomain);
                if (lowerEnd == null || localLower < lowerEnd) lowerEnd = localLower;
                if (upperEnd == null || localUpper > upperEnd) upperEnd = localUpper;
            }
            var dataValueDomain = $223cdb002ac9c48b$var$makeDomain(valueByDataKey);
            if (dataValueDomain != null) {
                lowerEnd = lowerEnd == null ? dataValueDomain[0] : Math.min(lowerEnd, dataValueDomain[0]);
                upperEnd = upperEnd == null ? dataValueDomain[1] : Math.max(upperEnd, dataValueDomain[1]);
            }
        });
    });
    if ((axisSettings === null || axisSettings === void 0 ? void 0 : axisSettings.dataKey) != null && items.length === 0) // When there are no items, fall back to the displayed data (chart-level or graphical item data).
    displayedData.forEach((item)=>{
        var dataValueDomain = $223cdb002ac9c48b$var$makeDomain((0, $d5958b0668c58531$export$f97fc4a450f29a)(item, axisSettings.dataKey));
        if (dataValueDomain != null) {
            lowerEnd = lowerEnd == null ? dataValueDomain[0] : Math.min(lowerEnd, dataValueDomain[0]);
            upperEnd = upperEnd == null ? dataValueDomain[1] : Math.max(upperEnd, dataValueDomain[1]);
        }
    });
    if ((0, $22869ac8a5888437$export$f8a8fc612ced9bb0)(lowerEnd) && (0, $22869ac8a5888437$export$f8a8fc612ced9bb0)(upperEnd)) return [
        lowerEnd,
        upperEnd
    ];
    return undefined;
};
var $223cdb002ac9c48b$var$selectDomainOfAllAppliedNumericalValuesIncludingErrorValues = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $223cdb002ac9c48b$export$6099ba314905f0c4,
    $223cdb002ac9c48b$export$fc14c3706e09c50c,
    $223cdb002ac9c48b$var$selectCartesianItemsSettingsExceptStacked,
    $223cdb002ac9c48b$export$9429ab4550237b6d,
    (0, $0356005269dcff20$export$8a7d579879340d98),
    (0, $8c22b3d5bf36186c$export$7a294fd94385f1e2)
], $223cdb002ac9c48b$export$df56c8e9a3e45e65, {
    memoizeOptions: {
        resultEqualityCheck: (0, $30bf67e96df5a044$export$45c01007b107f1a6)
    }
});
function $223cdb002ac9c48b$var$onlyAllowNumbersAndStringsAndDates(item) {
    var { value: value } = item;
    if ((0, $7e613228d3a31273$export$402a499e1ea44294)(value) || value instanceof Date) return value;
    return undefined;
}
var $223cdb002ac9c48b$var$computeDomainOfTypeCategory = (allDataSquished, axisSettings, isCategorical)=>{
    var categoricalDomain = allDataSquished.map($223cdb002ac9c48b$var$onlyAllowNumbersAndStringsAndDates).filter((v)=>v != null);
    if (isCategorical && (axisSettings.dataKey == null || axisSettings.allowDuplicatedCategory && (0, $7e613228d3a31273$export$732baf6a98f122)(categoricalDomain))) /*
     * 1. In an absence of dataKey, Recharts will use array indexes as its categorical domain
     * 2. When category axis has duplicated text, serial numbers are used to generate scale
     */ return (0, (/*@__PURE__*/$parcel$interopDefault($5511469aa65513f7$exports)))(0, allDataSquished.length);
    if (axisSettings.allowDuplicatedCategory) return categoricalDomain;
    return Array.from(new Set(categoricalDomain));
};
var $223cdb002ac9c48b$export$71580de5ed38161a = (state)=>state.referenceElements.dots;
var $223cdb002ac9c48b$export$2829d12117d2002f = (elements, axisType, axisId)=>{
    return elements.filter((el)=>el.ifOverflow === 'extendDomain').filter((el)=>{
        if (axisType === 'xAxis') return el.xAxisId === axisId;
        return el.yAxisId === axisId;
    });
};
var $223cdb002ac9c48b$export$dc267b7b9026caca = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $223cdb002ac9c48b$export$71580de5ed38161a,
    (0, $0356005269dcff20$export$8a7d579879340d98),
    (0, $8a59510828e5484a$export$6a2efa106dc9c8f6)
], $223cdb002ac9c48b$export$2829d12117d2002f);
var $223cdb002ac9c48b$export$c7e152cb7f10c1a6 = (state)=>state.referenceElements.areas;
var $223cdb002ac9c48b$export$699de899b7bc81a9 = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $223cdb002ac9c48b$export$c7e152cb7f10c1a6,
    (0, $0356005269dcff20$export$8a7d579879340d98),
    (0, $8a59510828e5484a$export$6a2efa106dc9c8f6)
], $223cdb002ac9c48b$export$2829d12117d2002f);
var $223cdb002ac9c48b$export$8fe2a49ce63c5348 = (state)=>state.referenceElements.lines;
var $223cdb002ac9c48b$export$29b80feb73eec2b3 = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $223cdb002ac9c48b$export$8fe2a49ce63c5348,
    (0, $0356005269dcff20$export$8a7d579879340d98),
    (0, $8a59510828e5484a$export$6a2efa106dc9c8f6)
], $223cdb002ac9c48b$export$2829d12117d2002f);
var $223cdb002ac9c48b$export$5da0b79fd816ec4b = (dots, axisType)=>{
    if (dots == null) return undefined;
    var allCoords = $223cdb002ac9c48b$var$onlyAllowNumbers(dots.map((dot)=>axisType === 'xAxis' ? dot.x : dot.y));
    if (allCoords.length === 0) return undefined;
    return [
        Math.min(...allCoords),
        Math.max(...allCoords)
    ];
};
var $223cdb002ac9c48b$var$selectReferenceDotsDomain = (0, $757e1d271f969f78$export$595d22ed68ca2841)($223cdb002ac9c48b$export$dc267b7b9026caca, (0, $0356005269dcff20$export$8a7d579879340d98), $223cdb002ac9c48b$export$5da0b79fd816ec4b);
var $223cdb002ac9c48b$export$7b27918cf5e1fc19 = (areas, axisType)=>{
    if (areas == null) return undefined;
    var allCoords = $223cdb002ac9c48b$var$onlyAllowNumbers(areas.flatMap((area)=>[
            axisType === 'xAxis' ? area.x1 : area.y1,
            axisType === 'xAxis' ? area.x2 : area.y2
        ]));
    if (allCoords.length === 0) return undefined;
    return [
        Math.min(...allCoords),
        Math.max(...allCoords)
    ];
};
var $223cdb002ac9c48b$var$selectReferenceAreasDomain = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $223cdb002ac9c48b$export$699de899b7bc81a9,
    (0, $0356005269dcff20$export$8a7d579879340d98)
], $223cdb002ac9c48b$export$7b27918cf5e1fc19);
function $223cdb002ac9c48b$var$extractXCoordinates(line) {
    var _line$segment;
    if (line.x != null) return $223cdb002ac9c48b$var$onlyAllowNumbers([
        line.x
    ]);
    var segmentCoordinates = (_line$segment = line.segment) === null || _line$segment === void 0 ? void 0 : _line$segment.map((s)=>s.x);
    if (segmentCoordinates == null || segmentCoordinates.length === 0) return [];
    return $223cdb002ac9c48b$var$onlyAllowNumbers(segmentCoordinates);
}
function $223cdb002ac9c48b$var$extractYCoordinates(line) {
    var _line$segment2;
    if (line.y != null) return $223cdb002ac9c48b$var$onlyAllowNumbers([
        line.y
    ]);
    var segmentCoordinates = (_line$segment2 = line.segment) === null || _line$segment2 === void 0 ? void 0 : _line$segment2.map((s)=>s.y);
    if (segmentCoordinates == null || segmentCoordinates.length === 0) return [];
    return $223cdb002ac9c48b$var$onlyAllowNumbers(segmentCoordinates);
}
var $223cdb002ac9c48b$export$f1d17aebd11953eb = (lines, axisType)=>{
    if (lines == null) return undefined;
    var allCoords = lines.flatMap((line)=>axisType === 'xAxis' ? $223cdb002ac9c48b$var$extractXCoordinates(line) : $223cdb002ac9c48b$var$extractYCoordinates(line));
    if (allCoords.length === 0) return undefined;
    return [
        Math.min(...allCoords),
        Math.max(...allCoords)
    ];
};
var $223cdb002ac9c48b$var$selectReferenceLinesDomain = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $223cdb002ac9c48b$export$29b80feb73eec2b3,
    (0, $0356005269dcff20$export$8a7d579879340d98)
], $223cdb002ac9c48b$export$f1d17aebd11953eb);
var $223cdb002ac9c48b$var$selectReferenceElementsDomain = (0, $757e1d271f969f78$export$595d22ed68ca2841)($223cdb002ac9c48b$var$selectReferenceDotsDomain, $223cdb002ac9c48b$var$selectReferenceLinesDomain, $223cdb002ac9c48b$var$selectReferenceAreasDomain, (dotsDomain, linesDomain, areasDomain)=>{
    return $223cdb002ac9c48b$export$9c8185c6eda0fb0d(dotsDomain, areasDomain, linesDomain);
});
var $223cdb002ac9c48b$export$b9eca0fd568f66a4 = (axisSettings, domainDefinition, domainFromUserPreference, domainOfStackGroups, dataAndErrorBarsDomain, referenceElementsDomain, layout, axisType)=>{
    if (domainFromUserPreference != null) // We're done! No need to compute anything else.
    return domainFromUserPreference;
    var shouldIncludeDomainOfStackGroups = layout === 'vertical' && axisType === 'xAxis' || layout === 'horizontal' && axisType === 'yAxis';
    var mergedDomains = shouldIncludeDomainOfStackGroups ? $223cdb002ac9c48b$export$9c8185c6eda0fb0d(domainOfStackGroups, referenceElementsDomain, dataAndErrorBarsDomain) : $223cdb002ac9c48b$export$9c8185c6eda0fb0d(referenceElementsDomain, dataAndErrorBarsDomain);
    return (0, $5bcc5341b7e18f2a$export$3f87aa7a53437a70)(domainDefinition, mergedDomains, axisSettings.allowDataOverflow);
};
var $223cdb002ac9c48b$export$2a64502fccb4dfa6 = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $223cdb002ac9c48b$export$fc14c3706e09c50c,
    $223cdb002ac9c48b$export$5d46410c3f089eb2,
    $223cdb002ac9c48b$export$c21dc69ecce61f8a,
    $223cdb002ac9c48b$export$969bc8d84122c036,
    $223cdb002ac9c48b$var$selectDomainOfAllAppliedNumericalValuesIncludingErrorValues,
    $223cdb002ac9c48b$var$selectReferenceElementsDomain,
    (0, $f4c9341f05a18477$export$8426b6d9af801dee),
    (0, $0356005269dcff20$export$8a7d579879340d98)
], $223cdb002ac9c48b$export$b9eca0fd568f66a4, {
    memoizeOptions: {
        resultEqualityCheck: (0, $30bf67e96df5a044$export$45c01007b107f1a6)
    }
});
/**
 * Expand by design maps everything between 0 and 1,
 * there is nothing to compute.
 * See https://d3js.org/d3-shape/stack#stack-offsets
 */ var $223cdb002ac9c48b$var$expandDomain = [
    0,
    1
];
var $223cdb002ac9c48b$export$70e6ef68424edf74 = (axisSettings, layout, displayedData, allAppliedValues, stackOffsetType, axisType, numericalDomain)=>{
    if ((axisSettings == null || displayedData == null || displayedData.length === 0) && numericalDomain === undefined) return undefined;
    var { dataKey: dataKey, type: type } = axisSettings;
    var isCategorical = (0, $d5958b0668c58531$export$9fc1baaa6c6368b)(layout, axisType);
    if (isCategorical && dataKey == null) {
        var _displayedData$length;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5511469aa65513f7$exports)))(0, (_displayedData$length = displayedData === null || displayedData === void 0 ? void 0 : displayedData.length) !== null && _displayedData$length !== void 0 ? _displayedData$length : 0);
    }
    if (type === 'category') return $223cdb002ac9c48b$var$computeDomainOfTypeCategory(allAppliedValues, axisSettings, isCategorical);
    if (stackOffsetType === 'expand' && !isCategorical) return $223cdb002ac9c48b$var$expandDomain;
    return numericalDomain;
};
var $223cdb002ac9c48b$export$4fc5ecb5227dd744 = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $223cdb002ac9c48b$export$fc14c3706e09c50c,
    (0, $f4c9341f05a18477$export$8426b6d9af801dee),
    $223cdb002ac9c48b$export$6099ba314905f0c4,
    $223cdb002ac9c48b$export$9cea618b690f07b7,
    (0, $1728a742f9386be1$export$73aff39176364def),
    (0, $0356005269dcff20$export$8a7d579879340d98),
    $223cdb002ac9c48b$export$2a64502fccb4dfa6
], $223cdb002ac9c48b$export$70e6ef68424edf74);
var $223cdb002ac9c48b$export$a1a58ca78bb13ce7 = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $223cdb002ac9c48b$export$fc14c3706e09c50c,
    $223cdb002ac9c48b$export$1c7798b82c8010cd,
    (0, $1728a742f9386be1$export$3247769c9dbde559)
], (0, $2772e85521d4b2a0$export$bebec32544750591));
var $223cdb002ac9c48b$export$aa1ef6c8f610e48c = (axisDomain, axisSettings, realScaleType)=>{
    var { niceTicks: niceTicks } = axisSettings;
    if (niceTicks === 'none') return undefined;
    var domainDefinition = $223cdb002ac9c48b$export$2e6262b6c952ab02(axisSettings);
    var hasDomainAutoKeyword = Array.isArray(domainDefinition) && (domainDefinition[0] === 'auto' || domainDefinition[1] === 'auto');
    if ((niceTicks === 'snap125' || niceTicks === 'adaptive') && axisSettings != null && axisSettings.tickCount && (0, $5bcc5341b7e18f2a$export$ba29b24e2a92eb58)(axisDomain)) {
        if (hasDomainAutoKeyword) return (0, $751892f5774e0212$export$b84e75ccbfe6a612)(axisDomain, axisSettings.tickCount, axisSettings.allowDecimals, niceTicks);
        if (axisSettings.type === 'number') return (0, $751892f5774e0212$export$e9d28da780436e98)(axisDomain, axisSettings.tickCount, axisSettings.allowDecimals, niceTicks);
    }
    if (niceTicks === 'auto' && realScaleType === 'linear' && axisSettings != null && axisSettings.tickCount) {
        // Current magic-selector behaviour: apply nice ticks when the domain contains
        // an 'auto' keyword (may extend the domain), or for any fixed number-type axis.
        // Always uses the space-efficient algorithm (adaptive).
        if (hasDomainAutoKeyword && (0, $5bcc5341b7e18f2a$export$ba29b24e2a92eb58)(axisDomain)) return (0, $751892f5774e0212$export$b84e75ccbfe6a612)(axisDomain, axisSettings.tickCount, axisSettings.allowDecimals, 'adaptive');
        if (axisSettings.type === 'number' && (0, $5bcc5341b7e18f2a$export$ba29b24e2a92eb58)(axisDomain)) return (0, $751892f5774e0212$export$e9d28da780436e98)(axisDomain, axisSettings.tickCount, axisSettings.allowDecimals, 'adaptive');
    }
    return undefined;
};
var $223cdb002ac9c48b$export$2efb9b5d95659d33 = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $223cdb002ac9c48b$export$4fc5ecb5227dd744,
    $223cdb002ac9c48b$export$f5176fa96b596697,
    $223cdb002ac9c48b$export$a1a58ca78bb13ce7
], $223cdb002ac9c48b$export$aa1ef6c8f610e48c);
var $223cdb002ac9c48b$export$3a4530026b1860ff = (axisSettings, domain, niceTicks, axisType)=>{
    if (/*
   * Angle axis for some reason uses nice ticks when rendering axis tick labels,
   * but doesn't use nice ticks for extending domain like all the other axes do.
   * Not really sure why? Is there a good reason,
   * or is it just because someone added support for nice ticks to the other axes and forgot this one?
   */ axisType !== 'angleAxis' && (axisSettings === null || axisSettings === void 0 ? void 0 : axisSettings.type) === 'number' && (0, $5bcc5341b7e18f2a$export$ba29b24e2a92eb58)(domain) && Array.isArray(niceTicks) && niceTicks.length > 0) {
        var _niceTicks$, _niceTicks;
        var minFromDomain = domain[0];
        var minFromTicks = (_niceTicks$ = niceTicks[0]) !== null && _niceTicks$ !== void 0 ? _niceTicks$ : 0;
        var maxFromDomain = domain[1];
        var maxFromTicks = (_niceTicks = niceTicks[niceTicks.length - 1]) !== null && _niceTicks !== void 0 ? _niceTicks : 0;
        return [
            Math.min(minFromDomain, minFromTicks),
            Math.max(maxFromDomain, maxFromTicks)
        ];
    }
    return domain;
};
var $223cdb002ac9c48b$export$af7761c6ea30fae4 = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $223cdb002ac9c48b$export$fc14c3706e09c50c,
    $223cdb002ac9c48b$export$4fc5ecb5227dd744,
    $223cdb002ac9c48b$export$2efb9b5d95659d33,
    (0, $0356005269dcff20$export$8a7d579879340d98)
], $223cdb002ac9c48b$export$3a4530026b1860ff);
var $223cdb002ac9c48b$export$a1013ea99dfe6af9 = (0, $757e1d271f969f78$export$595d22ed68ca2841)($223cdb002ac9c48b$export$9cea618b690f07b7, $223cdb002ac9c48b$export$fc14c3706e09c50c, (allDataSquished, axisSettings)=>{
    if (!axisSettings || axisSettings.type !== 'number') return undefined;
    var smallestDistanceBetweenValues = Infinity;
    var sortedValues = Array.from($223cdb002ac9c48b$var$onlyAllowNumbers(allDataSquished.map((d)=>d.value))).sort((a, b)=>a - b);
    var first = sortedValues[0];
    var last = sortedValues[sortedValues.length - 1];
    if (first == null || last == null) return Infinity;
    var diff = last - first;
    if (diff === 0) return Infinity;
    // Only do n - 1 distance calculations because there's only n - 1 distances between n values.
    for(var i = 0; i < sortedValues.length - 1; i++){
        var curr = sortedValues[i];
        var next = sortedValues[i + 1];
        if (curr == null || next == null) continue;
        var distance = next - curr;
        smallestDistanceBetweenValues = Math.min(smallestDistanceBetweenValues, distance);
    }
    return smallestDistanceBetweenValues / diff;
});
var $223cdb002ac9c48b$var$selectCalculatedPadding = (0, $757e1d271f969f78$export$595d22ed68ca2841)($223cdb002ac9c48b$export$a1013ea99dfe6af9, (0, $f4c9341f05a18477$export$8426b6d9af801dee), (0, $1728a742f9386be1$export$a73f9d39b015942a), (0, $cd6092f0bbb953fd$export$1e34c8efb0bc9b3b), (_1, _2, _3, _4, padding)=>padding, (smallestDistanceInPercent, layout, barCategoryGap, offset, padding)=>{
    if (!(0, $22869ac8a5888437$export$f8a8fc612ced9bb0)(smallestDistanceInPercent)) return 0;
    var rangeWidth = layout === 'vertical' ? offset.height : offset.width;
    if (padding === 'gap') return smallestDistanceInPercent * rangeWidth / 2;
    if (padding === 'no-gap') {
        var gap = (0, $7e613228d3a31273$export$476354dbf49bdff6)(barCategoryGap, smallestDistanceInPercent * rangeWidth);
        var halfBand = smallestDistanceInPercent * rangeWidth / 2;
        return halfBand - gap - (halfBand - gap) / rangeWidth * gap;
    }
    return 0;
});
var $223cdb002ac9c48b$export$29cb35c3432eef0e = (state, axisId, isPanorama)=>{
    var xAxisSettings = $223cdb002ac9c48b$export$d6895d8ddb4cee5(state, axisId);
    if (xAxisSettings == null || typeof xAxisSettings.padding !== 'string') return 0;
    return $223cdb002ac9c48b$var$selectCalculatedPadding(state, 'xAxis', axisId, isPanorama, xAxisSettings.padding);
};
var $223cdb002ac9c48b$export$689bf02345b2d857 = (state, axisId, isPanorama)=>{
    var yAxisSettings = $223cdb002ac9c48b$export$1f472705a332f1c9(state, axisId);
    if (yAxisSettings == null || typeof yAxisSettings.padding !== 'string') return 0;
    return $223cdb002ac9c48b$var$selectCalculatedPadding(state, 'yAxis', axisId, isPanorama, yAxisSettings.padding);
};
var $223cdb002ac9c48b$var$selectXAxisPadding = (0, $757e1d271f969f78$export$595d22ed68ca2841)($223cdb002ac9c48b$export$d6895d8ddb4cee5, $223cdb002ac9c48b$export$29cb35c3432eef0e, (xAxisSettings, calculated)=>{
    var _padding$left, _padding$right;
    if (xAxisSettings == null) return {
        left: 0,
        right: 0
    };
    var { padding: padding } = xAxisSettings;
    if (typeof padding === 'string') return {
        left: calculated,
        right: calculated
    };
    return {
        left: ((_padding$left = padding.left) !== null && _padding$left !== void 0 ? _padding$left : 0) + calculated,
        right: ((_padding$right = padding.right) !== null && _padding$right !== void 0 ? _padding$right : 0) + calculated
    };
});
var $223cdb002ac9c48b$var$selectYAxisPadding = (0, $757e1d271f969f78$export$595d22ed68ca2841)($223cdb002ac9c48b$export$1f472705a332f1c9, $223cdb002ac9c48b$export$689bf02345b2d857, (yAxisSettings, calculated)=>{
    var _padding$top, _padding$bottom;
    if (yAxisSettings == null) return {
        top: 0,
        bottom: 0
    };
    var { padding: padding } = yAxisSettings;
    if (typeof padding === 'string') return {
        top: calculated,
        bottom: calculated
    };
    return {
        top: ((_padding$top = padding.top) !== null && _padding$top !== void 0 ? _padding$top : 0) + calculated,
        bottom: ((_padding$bottom = padding.bottom) !== null && _padding$bottom !== void 0 ? _padding$bottom : 0) + calculated
    };
});
var $223cdb002ac9c48b$export$ad97ad38bffcee71 = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    (0, $cd6092f0bbb953fd$export$1e34c8efb0bc9b3b),
    $223cdb002ac9c48b$var$selectXAxisPadding,
    (0, $2f2a17d106b4d13b$export$3b81e97eae001823),
    (0, $2f2a17d106b4d13b$export$5ba94b496f8dc52e),
    (_state, _axisId, isPanorama)=>isPanorama
], (offset, padding, brushDimensions, _ref5, isPanorama)=>{
    var { padding: brushPadding } = _ref5;
    if (isPanorama) return [
        brushPadding.left,
        brushDimensions.width - brushPadding.right
    ];
    return [
        offset.left + padding.left,
        offset.left + offset.width - padding.right
    ];
});
var $223cdb002ac9c48b$export$e20c6b0368220a6a = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    (0, $cd6092f0bbb953fd$export$1e34c8efb0bc9b3b),
    (0, $f4c9341f05a18477$export$8426b6d9af801dee),
    $223cdb002ac9c48b$var$selectYAxisPadding,
    (0, $2f2a17d106b4d13b$export$3b81e97eae001823),
    (0, $2f2a17d106b4d13b$export$5ba94b496f8dc52e),
    (_state, _axisId, isPanorama)=>isPanorama
], (offset, layout, padding, brushDimensions, _ref6, isPanorama)=>{
    var { padding: brushPadding } = _ref6;
    if (isPanorama) return [
        brushDimensions.height - brushPadding.bottom,
        brushPadding.top
    ];
    if (layout === 'horizontal') return [
        offset.top + offset.height - padding.bottom,
        offset.top + padding.top
    ];
    return [
        offset.top + padding.top,
        offset.top + offset.height - padding.bottom
    ];
});
var $223cdb002ac9c48b$export$3506ed461810cc8f = (state, axisType, axisId, isPanorama)=>{
    var _selectZAxisSettings;
    switch(axisType){
        case 'xAxis':
            return $223cdb002ac9c48b$export$ad97ad38bffcee71(state, axisId, isPanorama);
        case 'yAxis':
            return $223cdb002ac9c48b$export$e20c6b0368220a6a(state, axisId, isPanorama);
        case 'zAxis':
            return (_selectZAxisSettings = $223cdb002ac9c48b$export$26eadf639b453d0f(state, axisId)) === null || _selectZAxisSettings === void 0 ? void 0 : _selectZAxisSettings.range;
        case 'angleAxis':
            return (0, $792f72abcce61010$export$d00c8e94622c940)(state);
        case 'radiusAxis':
            return (0, $792f72abcce61010$export$e13d847e4d4f833f)(state, axisId);
        default:
            return undefined;
    }
};
var $223cdb002ac9c48b$export$d6d5faff23feedea = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $223cdb002ac9c48b$export$fc14c3706e09c50c,
    $223cdb002ac9c48b$export$3506ed461810cc8f
], (0, $250f5d8c249e6c87$export$3f7e30291950e694));
var $223cdb002ac9c48b$export$18099cdfb97d7dcd = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $223cdb002ac9c48b$export$a1a58ca78bb13ce7,
    $223cdb002ac9c48b$export$af7761c6ea30fae4
], (0, $37a0c522921b7bfa$export$cd6ce636c480934e));
var $223cdb002ac9c48b$var$selectConfiguredScale = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $223cdb002ac9c48b$export$fc14c3706e09c50c,
    $223cdb002ac9c48b$export$a1a58ca78bb13ce7,
    $223cdb002ac9c48b$export$18099cdfb97d7dcd,
    $223cdb002ac9c48b$export$d6d5faff23feedea
], (0, $a49f0acc2976fd6a$export$24f70d56c780d8f0));
var $223cdb002ac9c48b$export$911ef47868c9ab07 = (layout, appliedValues, axis, axisType)=>{
    if (axis == null || axis.dataKey == null) return undefined;
    var { type: type, scale: scale } = axis;
    var isCategorical = (0, $d5958b0668c58531$export$9fc1baaa6c6368b)(layout, axisType);
    if (isCategorical && (type === 'number' || scale !== 'auto')) return appliedValues.map((d)=>d.value);
    return undefined;
};
var $223cdb002ac9c48b$export$a6a79e7a5412631c = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    (0, $f4c9341f05a18477$export$8426b6d9af801dee),
    $223cdb002ac9c48b$export$9cea618b690f07b7,
    $223cdb002ac9c48b$export$f5176fa96b596697,
    (0, $0356005269dcff20$export$8a7d579879340d98)
], $223cdb002ac9c48b$export$911ef47868c9ab07);
var $223cdb002ac9c48b$export$22e8e5f8924724ea = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $223cdb002ac9c48b$var$selectConfiguredScale
], (0, $3ec4ee43aef296c2$export$5501a52df751e5ca));
var $223cdb002ac9c48b$export$657c51a9a0740206 = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $223cdb002ac9c48b$var$selectConfiguredScale
], (0, $657a9330a7224194$export$757040754bd60df5));
var $223cdb002ac9c48b$export$ddc8d5321a023350 = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $223cdb002ac9c48b$var$selectConfiguredScale,
    $223cdb002ac9c48b$export$23eb57bf0bace166
], (0, $fdcfc9136938d122$export$e954f4783a2f3ac0));
var $223cdb002ac9c48b$export$565b9812b1d7c04f = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $223cdb002ac9c48b$export$533d13f911334c9d,
    $223cdb002ac9c48b$export$9429ab4550237b6d,
    (0, $0356005269dcff20$export$8a7d579879340d98)
], $223cdb002ac9c48b$var$combineRelevantErrorBarSettings);
function $223cdb002ac9c48b$var$compareIds(a, b) {
    if (a.id < b.id) return -1;
    if (a.id > b.id) return 1;
    return 0;
}
var $223cdb002ac9c48b$var$pickAxisOrientation = (_state, orientation)=>orientation;
var $223cdb002ac9c48b$var$pickMirror = (_state, _orientation, mirror)=>mirror;
var $223cdb002ac9c48b$var$selectAllXAxesWithOffsetType = (0, $757e1d271f969f78$export$595d22ed68ca2841)((0, $22dcbe180c9a8d3a$export$bd320344232f30af), $223cdb002ac9c48b$var$pickAxisOrientation, $223cdb002ac9c48b$var$pickMirror, (allAxes, orientation, mirror)=>allAxes.filter((axis)=>axis.orientation === orientation).filter((axis)=>axis.mirror === mirror).sort($223cdb002ac9c48b$var$compareIds));
var $223cdb002ac9c48b$var$selectAllYAxesWithOffsetType = (0, $757e1d271f969f78$export$595d22ed68ca2841)((0, $22dcbe180c9a8d3a$export$e22adabb0128cf25), $223cdb002ac9c48b$var$pickAxisOrientation, $223cdb002ac9c48b$var$pickMirror, (allAxes, orientation, mirror)=>allAxes.filter((axis)=>axis.orientation === orientation).filter((axis)=>axis.mirror === mirror).sort($223cdb002ac9c48b$var$compareIds));
var $223cdb002ac9c48b$var$getXAxisSize = (offset, axisSettings)=>{
    return {
        width: offset.width,
        height: axisSettings.height
    };
};
var $223cdb002ac9c48b$var$getYAxisSize = (offset, axisSettings)=>{
    var width = typeof axisSettings.width === 'number' ? axisSettings.width : (0, $868751348c5652f4$export$fb6ee82c8ee2faf8);
    return {
        width: width,
        height: offset.height
    };
};
var $223cdb002ac9c48b$export$50d4085c87c19b12 = (0, $757e1d271f969f78$export$595d22ed68ca2841)((0, $cd6092f0bbb953fd$export$1e34c8efb0bc9b3b), $223cdb002ac9c48b$export$d6895d8ddb4cee5, $223cdb002ac9c48b$var$getXAxisSize);
var $223cdb002ac9c48b$var$combineXAxisPositionStartingPoint = (offset, orientation, chartHeight)=>{
    switch(orientation){
        case 'top':
            return offset.top;
        case 'bottom':
            return chartHeight - offset.bottom;
        default:
            return 0;
    }
};
var $223cdb002ac9c48b$var$combineYAxisPositionStartingPoint = (offset, orientation, chartWidth)=>{
    switch(orientation){
        case 'left':
            return offset.left;
        case 'right':
            return chartWidth - offset.right;
        default:
            return 0;
    }
};
var $223cdb002ac9c48b$export$6cb04966ad155e81 = (0, $757e1d271f969f78$export$595d22ed68ca2841)((0, $0b675d94b376aa83$export$5856a7d94c109505), (0, $cd6092f0bbb953fd$export$1e34c8efb0bc9b3b), $223cdb002ac9c48b$var$selectAllXAxesWithOffsetType, $223cdb002ac9c48b$var$pickAxisOrientation, $223cdb002ac9c48b$var$pickMirror, (chartHeight, offset, allAxesWithSameOffsetType, orientation, mirror)=>{
    var steps = {};
    var position;
    allAxesWithSameOffsetType.forEach((axis)=>{
        var axisSize = $223cdb002ac9c48b$var$getXAxisSize(offset, axis);
        if (position == null) position = $223cdb002ac9c48b$var$combineXAxisPositionStartingPoint(offset, orientation, chartHeight);
        var needSpace = orientation === 'top' && !mirror || orientation === 'bottom' && mirror;
        steps[axis.id] = position - Number(needSpace) * axisSize.height;
        position += (needSpace ? -1 : 1) * axisSize.height;
    });
    return steps;
});
var $223cdb002ac9c48b$export$edba808018e1c207 = (0, $757e1d271f969f78$export$595d22ed68ca2841)((0, $0b675d94b376aa83$export$771ef0ac044f724d), (0, $cd6092f0bbb953fd$export$1e34c8efb0bc9b3b), $223cdb002ac9c48b$var$selectAllYAxesWithOffsetType, $223cdb002ac9c48b$var$pickAxisOrientation, $223cdb002ac9c48b$var$pickMirror, (chartWidth, offset, allAxesWithSameOffsetType, orientation, mirror)=>{
    var steps = {};
    var position;
    allAxesWithSameOffsetType.forEach((axis)=>{
        var axisSize = $223cdb002ac9c48b$var$getYAxisSize(offset, axis);
        if (position == null) position = $223cdb002ac9c48b$var$combineYAxisPositionStartingPoint(offset, orientation, chartWidth);
        var needSpace = orientation === 'left' && !mirror || orientation === 'right' && mirror;
        steps[axis.id] = position - Number(needSpace) * axisSize.width;
        position += (needSpace ? -1 : 1) * axisSize.width;
    });
    return steps;
});
var $223cdb002ac9c48b$var$selectXAxisOffsetSteps = (state, axisId)=>{
    var axisSettings = $223cdb002ac9c48b$export$d6895d8ddb4cee5(state, axisId);
    if (axisSettings == null) return undefined;
    return $223cdb002ac9c48b$export$6cb04966ad155e81(state, axisSettings.orientation, axisSettings.mirror);
};
var $223cdb002ac9c48b$export$92fdc590d2371053 = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    (0, $cd6092f0bbb953fd$export$1e34c8efb0bc9b3b),
    $223cdb002ac9c48b$export$d6895d8ddb4cee5,
    $223cdb002ac9c48b$var$selectXAxisOffsetSteps,
    (_, axisId)=>axisId
], (offset, axisSettings, allSteps, axisId)=>{
    if (axisSettings == null) return undefined;
    var stepOfThisAxis = allSteps === null || allSteps === void 0 ? void 0 : allSteps[axisId];
    if (stepOfThisAxis == null) return {
        x: offset.left,
        y: 0
    };
    return {
        x: offset.left,
        y: stepOfThisAxis
    };
});
var $223cdb002ac9c48b$var$selectYAxisOffsetSteps = (state, axisId)=>{
    var axisSettings = $223cdb002ac9c48b$export$1f472705a332f1c9(state, axisId);
    if (axisSettings == null) return undefined;
    return $223cdb002ac9c48b$export$edba808018e1c207(state, axisSettings.orientation, axisSettings.mirror);
};
var $223cdb002ac9c48b$export$e67a320452ebcaef = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    (0, $cd6092f0bbb953fd$export$1e34c8efb0bc9b3b),
    $223cdb002ac9c48b$export$1f472705a332f1c9,
    $223cdb002ac9c48b$var$selectYAxisOffsetSteps,
    (_, axisId)=>axisId
], (offset, axisSettings, allSteps, axisId)=>{
    if (axisSettings == null) return undefined;
    var stepOfThisAxis = allSteps === null || allSteps === void 0 ? void 0 : allSteps[axisId];
    if (stepOfThisAxis == null) return {
        x: 0,
        y: offset.top
    };
    return {
        x: stepOfThisAxis,
        y: offset.top
    };
});
var $223cdb002ac9c48b$export$249bec756af8ac39 = (0, $757e1d271f969f78$export$595d22ed68ca2841)((0, $cd6092f0bbb953fd$export$1e34c8efb0bc9b3b), $223cdb002ac9c48b$export$1f472705a332f1c9, (offset, axisSettings)=>{
    var width = typeof axisSettings.width === 'number' ? axisSettings.width : (0, $868751348c5652f4$export$fb6ee82c8ee2faf8);
    return {
        width: width,
        height: offset.height
    };
});
var $223cdb002ac9c48b$export$6d6e642aa7a0ae10 = (state, axisType, axisId)=>{
    switch(axisType){
        case 'xAxis':
            return $223cdb002ac9c48b$export$50d4085c87c19b12(state, axisId).width;
        case 'yAxis':
            return $223cdb002ac9c48b$export$249bec756af8ac39(state, axisId).height;
        default:
            return undefined;
    }
};
var $223cdb002ac9c48b$export$bb1ebf56a37bd899 = (chartLayout, appliedValues, axis, axisType)=>{
    if (axis == null) return undefined;
    var { allowDuplicatedCategory: allowDuplicatedCategory, type: type, dataKey: dataKey } = axis;
    var isCategorical = (0, $d5958b0668c58531$export$9fc1baaa6c6368b)(chartLayout, axisType);
    var allData = appliedValues.map((av)=>av.value);
    var validData = allData.filter((v)=>v != null);
    if (dataKey && isCategorical && type === 'category' && allowDuplicatedCategory && (0, $7e613228d3a31273$export$732baf6a98f122)(validData)) return allData;
    return undefined;
};
var $223cdb002ac9c48b$export$4fc6aadcd9e9157c = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    (0, $f4c9341f05a18477$export$8426b6d9af801dee),
    $223cdb002ac9c48b$export$9cea618b690f07b7,
    $223cdb002ac9c48b$export$fc14c3706e09c50c,
    (0, $0356005269dcff20$export$8a7d579879340d98)
], $223cdb002ac9c48b$export$bb1ebf56a37bd899);
var $223cdb002ac9c48b$export$45cd57660792dd31 = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    (0, $f4c9341f05a18477$export$8426b6d9af801dee),
    $223cdb002ac9c48b$var$selectCartesianAxisSettings,
    $223cdb002ac9c48b$export$a1a58ca78bb13ce7,
    $223cdb002ac9c48b$export$22e8e5f8924724ea,
    $223cdb002ac9c48b$export$4fc6aadcd9e9157c,
    $223cdb002ac9c48b$export$a6a79e7a5412631c,
    $223cdb002ac9c48b$export$3506ed461810cc8f,
    $223cdb002ac9c48b$export$2efb9b5d95659d33,
    (0, $0356005269dcff20$export$8a7d579879340d98)
], (layout, axis, realScaleType, scale, duplicateDomain, categoricalDomain, axisRange, niceTicks, axisType)=>{
    if (axis == null) return undefined;
    var isCategorical = (0, $d5958b0668c58531$export$9fc1baaa6c6368b)(layout, axisType);
    return {
        angle: axis.angle,
        interval: axis.interval,
        minTickGap: axis.minTickGap,
        orientation: axis.orientation,
        tick: axis.tick,
        tickCount: axis.tickCount,
        tickFormatter: axis.tickFormatter,
        ticks: axis.ticks,
        type: axis.type,
        unit: axis.unit,
        axisType: axisType,
        categoricalDomain: categoricalDomain,
        duplicateDomain: duplicateDomain,
        isCategorical: isCategorical,
        niceTicks: niceTicks,
        range: axisRange,
        realScaleType: realScaleType,
        scale: scale
    };
});
var $223cdb002ac9c48b$export$d033262fd214bffb = (layout, axis, realScaleType, scale, niceTicks, axisRange, duplicateDomain, categoricalDomain, axisType)=>{
    if (axis == null || scale == null) return undefined;
    var isCategorical = (0, $d5958b0668c58531$export$9fc1baaa6c6368b)(layout, axisType);
    var { type: type, ticks: ticks, tickCount: tickCount } = axis;
    var offsetForBand = // @ts-expect-error This is testing for `scaleBand` but for band axis the type is reported as `band` so this looks like a dead code with a workaround elsewhere?
    realScaleType === 'scaleBand' && typeof scale.bandwidth === 'function' ? scale.bandwidth() / 2 : 2;
    var offset = type === 'category' && scale.bandwidth ? scale.bandwidth() / offsetForBand : 0;
    offset = axisType === 'angleAxis' && axisRange != null && axisRange.length >= 2 ? (0, $7e613228d3a31273$export$9d334328eb75e624)(axisRange[0] - axisRange[1]) * 2 * offset : offset;
    // The ticks set by user should only affect the ticks adjacent to axis line
    var ticksOrNiceTicks = ticks || niceTicks;
    if (ticksOrNiceTicks) return ticksOrNiceTicks.map((entry, index)=>{
        var scaleContent = duplicateDomain ? duplicateDomain.indexOf(entry) : entry;
        var scaled = scale.map(scaleContent);
        if (!(0, $22869ac8a5888437$export$f8a8fc612ced9bb0)(scaled)) return null;
        return {
            index: index,
            coordinate: scaled + offset,
            value: entry,
            offset: offset
        };
    }).filter((0, $7e613228d3a31273$export$7e515ab5fbd92bef));
    // When axis is a categorical axis, but the type of axis is not number and scale is not "auto"
    // For type='number' with linear scale (where niceTicks are available), skip this branch
    // so ticks are evenly spaced instead of placed at data positions (GitHub issue #4271)
    if (isCategorical && categoricalDomain) return categoricalDomain.map((entry, index)=>{
        var scaled = scale.map(entry);
        if (!(0, $22869ac8a5888437$export$f8a8fc612ced9bb0)(scaled)) return null;
        return {
            coordinate: scaled + offset,
            value: entry,
            index: index,
            offset: offset
        };
    }).filter((0, $7e613228d3a31273$export$7e515ab5fbd92bef));
    if (scale.ticks) return scale.ticks(tickCount).map((entry, index)=>{
        var scaled = scale.map(entry);
        if (!(0, $22869ac8a5888437$export$f8a8fc612ced9bb0)(scaled)) return null;
        return {
            coordinate: scaled + offset,
            value: entry,
            index: index,
            offset: offset
        };
    }).filter((0, $7e613228d3a31273$export$7e515ab5fbd92bef));
    // When axis has duplicated text, serial numbers are used to generate scale
    return scale.domain().map((entry, index)=>{
        var scaled = scale.map(entry);
        if (!(0, $22869ac8a5888437$export$f8a8fc612ced9bb0)(scaled)) return null;
        return {
            coordinate: scaled + offset,
            // @ts-expect-error can't use Date as index
            value: duplicateDomain ? duplicateDomain[entry] : entry,
            index: index,
            offset: offset
        };
    }).filter((0, $7e613228d3a31273$export$7e515ab5fbd92bef));
};
var $223cdb002ac9c48b$export$f0d85e8287c47657 = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    (0, $f4c9341f05a18477$export$8426b6d9af801dee),
    $223cdb002ac9c48b$export$f5176fa96b596697,
    $223cdb002ac9c48b$export$a1a58ca78bb13ce7,
    $223cdb002ac9c48b$export$22e8e5f8924724ea,
    $223cdb002ac9c48b$export$2efb9b5d95659d33,
    $223cdb002ac9c48b$export$3506ed461810cc8f,
    $223cdb002ac9c48b$export$4fc6aadcd9e9157c,
    $223cdb002ac9c48b$export$a6a79e7a5412631c,
    (0, $0356005269dcff20$export$8a7d579879340d98)
], $223cdb002ac9c48b$export$d033262fd214bffb);
var $223cdb002ac9c48b$export$453d0e9212f0369b = (layout, axis, scale, axisRange, duplicateDomain, categoricalDomain, axisType)=>{
    if (axis == null || scale == null || axisRange == null || axisRange[0] === axisRange[1]) return undefined;
    var isCategorical = (0, $d5958b0668c58531$export$9fc1baaa6c6368b)(layout, axisType);
    var { tickCount: tickCount } = axis;
    var offset = 0;
    offset = axisType === 'angleAxis' && (axisRange === null || axisRange === void 0 ? void 0 : axisRange.length) >= 2 ? (0, $7e613228d3a31273$export$9d334328eb75e624)(axisRange[0] - axisRange[1]) * 2 * offset : offset;
    // When axis is a categorical axis, but the type of axis is number or the scale of axis is not "auto"
    if (isCategorical && categoricalDomain) return categoricalDomain.map((entry, index)=>{
        var scaled = scale.map(entry);
        if (!(0, $22869ac8a5888437$export$f8a8fc612ced9bb0)(scaled)) return null;
        return {
            coordinate: scaled + offset,
            value: entry,
            index: index,
            offset: offset
        };
    }).filter((0, $7e613228d3a31273$export$7e515ab5fbd92bef));
    if (scale.ticks) return scale.ticks(tickCount).map((entry, index)=>{
        var scaled = scale.map(entry);
        if (!(0, $22869ac8a5888437$export$f8a8fc612ced9bb0)(scaled)) return null;
        return {
            coordinate: scaled + offset,
            value: entry,
            index: index,
            offset: offset
        };
    }).filter((0, $7e613228d3a31273$export$7e515ab5fbd92bef));
    // When axis has duplicated text, serial numbers are used to generate scale
    return scale.domain().map((entry, index)=>{
        var scaled = scale.map(entry);
        if (!(0, $22869ac8a5888437$export$f8a8fc612ced9bb0)(scaled)) return null;
        return {
            coordinate: scaled + offset,
            // @ts-expect-error can't use unknown as index
            value: duplicateDomain ? duplicateDomain[entry] : entry,
            index: index,
            offset: offset
        };
    }).filter((0, $7e613228d3a31273$export$7e515ab5fbd92bef));
};
var $223cdb002ac9c48b$export$b894cb5d8586b43d = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    (0, $f4c9341f05a18477$export$8426b6d9af801dee),
    $223cdb002ac9c48b$export$f5176fa96b596697,
    $223cdb002ac9c48b$export$22e8e5f8924724ea,
    $223cdb002ac9c48b$export$3506ed461810cc8f,
    $223cdb002ac9c48b$export$4fc6aadcd9e9157c,
    $223cdb002ac9c48b$export$a6a79e7a5412631c,
    (0, $0356005269dcff20$export$8a7d579879340d98)
], $223cdb002ac9c48b$export$453d0e9212f0369b);
var $223cdb002ac9c48b$export$db36c2f3bfe5c9d7 = (0, $757e1d271f969f78$export$595d22ed68ca2841)($223cdb002ac9c48b$export$fc14c3706e09c50c, $223cdb002ac9c48b$export$22e8e5f8924724ea, (axis, scale)=>{
    if (axis == null || scale == null) return undefined;
    return $223cdb002ac9c48b$var$_objectSpread($223cdb002ac9c48b$var$_objectSpread({}, axis), {}, {
        scale: scale
    });
});
var $223cdb002ac9c48b$var$selectZAxisConfiguredScale = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $223cdb002ac9c48b$export$fc14c3706e09c50c,
    $223cdb002ac9c48b$export$a1a58ca78bb13ce7,
    $223cdb002ac9c48b$export$4fc5ecb5227dd744,
    $223cdb002ac9c48b$export$d6d5faff23feedea
], (0, $a49f0acc2976fd6a$export$24f70d56c780d8f0));
var $223cdb002ac9c48b$var$selectZAxisScale = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $223cdb002ac9c48b$var$selectZAxisConfiguredScale
], (0, $3ec4ee43aef296c2$export$5501a52df751e5ca));
var $223cdb002ac9c48b$export$4dab5213d1420bb3 = (0, $757e1d271f969f78$export$595d22ed68ca2841)((state, _axisType, axisId)=>$223cdb002ac9c48b$export$26eadf639b453d0f(state, axisId), $223cdb002ac9c48b$var$selectZAxisScale, (axis, scale)=>{
    if (axis == null || scale == null) return undefined;
    return $223cdb002ac9c48b$var$_objectSpread($223cdb002ac9c48b$var$_objectSpread({}, axis), {}, {
        scale: scale
    });
});
var $223cdb002ac9c48b$export$430d623a94added7 = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    (0, $f4c9341f05a18477$export$8426b6d9af801dee),
    (0, $22dcbe180c9a8d3a$export$bd320344232f30af),
    (0, $22dcbe180c9a8d3a$export$e22adabb0128cf25)
], (layout, allXAxes, allYAxes)=>{
    switch(layout){
        case 'horizontal':
            return allXAxes.some((axis)=>axis.reversed) ? 'right-to-left' : 'left-to-right';
        case 'vertical':
            return allYAxes.some((axis)=>axis.reversed) ? 'bottom-to-top' : 'top-to-bottom';
        // TODO: make this better. For now, right arrow triggers "forward", left arrow "back"
        // however, the tooltip moves an unintuitive direction because of how the indices are rendered
        case 'centric':
        case 'radial':
            return 'left-to-right';
        default:
            return undefined;
    }
});
var $223cdb002ac9c48b$export$9cc7232c10fac9e = (state, axisType, axisId)=>{
    var _state$renderedTicks$;
    return (_state$renderedTicks$ = state.renderedTicks[axisType]) === null || _state$renderedTicks$ === void 0 ? void 0 : _state$renderedTicks$[axisId];
};
var $223cdb002ac9c48b$export$767aec070f996e73 = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $223cdb002ac9c48b$export$9cc7232c10fac9e
], (ticks)=>{
    if (!ticks || ticks.length === 0) return undefined;
    return (pixelValue)=>{
        var _closestTick;
        // Find the tick with the closest coordinate to pixelValue
        var minDistance = Infinity;
        var closestTick = ticks[0];
        for (var tick of ticks){
            var distance = Math.abs(tick.coordinate - pixelValue);
            if (distance < minDistance) {
                minDistance = distance;
                closestTick = tick;
            }
        }
        return (_closestTick = closestTick) === null || _closestTick === void 0 ? void 0 : _closestTick.value;
    };
});




function $c24339571f507656$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c24339571f507656$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c24339571f507656$var$ownKeys(Object(t), !0).forEach(function(r) {
            $c24339571f507656$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c24339571f507656$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $c24339571f507656$var$_defineProperty(e, r, t) {
    return (r = $c24339571f507656$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $c24339571f507656$var$_toPropertyKey(t) {
    var i = $c24339571f507656$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $c24339571f507656$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $c24339571f507656$export$e43f7367e579f53d = 0;
/**
 * Properties shared in X, Y, and Z axes.
 * User defined axis settings, coming from props.
 */ /**
 * Controls how Recharts calculates "nice" tick values for numerical axes.
 *
 * - `'none'`: Recharts does not apply any tick-rounding algorithm; tick positions are
 *   determined entirely by d3, evenly spaced but not rounded to human-friendly numbers.
 *   There is no domain-extension logic applied in this mode.
 *
 * - `'auto'` *(default)*: Recharts automatically decides whether and how to apply tick
 *   niceties based on the domain definition. When the domain contains an `'auto'` keyword,
 *   Recharts uses the `'adaptive'` algorithm and may extend the domain slightly to
 *   produce clean tick labels. Otherwise, it applies the same algorithm while keeping
 *   ticks within the fixed domain. This mirrors the default behavior from Recharts v2.
 *
 * - `'adaptive'`: Always applies the space-efficient algorithm (`getAdaptiveStep`),
 *   which fills the available range as densely as possible while still rounding steps
 *   to reasonable numbers (e.g. 10, 20, 25). May produce less "round-looking" labels
 *   than `'snap125'`, but wastes less space. The domain-extension logic still applies
 *   when the domain contains an `'auto'` keyword.
 *
 * - `'snap125'`: Always applies the round-numbers algorithm (`getSnap125Step`), which
 *   snaps step sizes to values from the set {1, 2, 2.5, 5} × 10ⁿ. Produces very
 *   human-friendly labels (e.g. 0, 5, 10, 15, 20) but may leave blank space at the
 *   edges of the chart. The domain-extension logic still applies when the domain
 *   contains an `'auto'` keyword.
 *
 * @see {@link https://recharts.github.io/guide/axisTicks/}
 * @inline
 */ /**
 * These are the external props, visible for users as they set them using our public API.
 * There is all sorts of internal computed things based on these, but they will come through selectors.
 *
 * Properties shared between X and Y axes
 */ /**
 * Z axis is special because it's never displayed. It controls the size of Scatter dots,
 * but it never displays ticks anywhere.
 */ var $c24339571f507656$var$initialState = {
    xAxis: {},
    yAxis: {},
    zAxis: {}
};
/**
 * This is the slice where each individual Axis element pushes its own configuration.
 * Prefer to use this one instead of axisSlice.
 */ var $c24339571f507656$var$cartesianAxisSlice = (0, $df8b6ce3f4df1ba5$export$4d8d9bd83c24ae8b)({
    name: 'cartesianAxis',
    initialState: $c24339571f507656$var$initialState,
    reducers: {
        addXAxis: {
            reducer (state, action) {
                state.xAxis[action.payload.id] = (0, $808ce0820c1669b6$export$c05b21e3257751e5)(action.payload);
            },
            prepare: (0, $df8b6ce3f4df1ba5$export$39fcd5145ec5e4e2)()
        },
        replaceXAxis: {
            reducer (state, action) {
                var { prev: prev, next: next } = action.payload;
                if (state.xAxis[prev.id] !== undefined) {
                    if (prev.id !== next.id) delete state.xAxis[prev.id];
                    state.xAxis[next.id] = (0, $808ce0820c1669b6$export$c05b21e3257751e5)(next);
                }
            },
            prepare: (0, $df8b6ce3f4df1ba5$export$39fcd5145ec5e4e2)()
        },
        removeXAxis: {
            reducer (state, action) {
                delete state.xAxis[action.payload.id];
            },
            prepare: (0, $df8b6ce3f4df1ba5$export$39fcd5145ec5e4e2)()
        },
        addYAxis: {
            reducer (state, action) {
                state.yAxis[action.payload.id] = (0, $808ce0820c1669b6$export$c05b21e3257751e5)(action.payload);
            },
            prepare: (0, $df8b6ce3f4df1ba5$export$39fcd5145ec5e4e2)()
        },
        replaceYAxis: {
            reducer (state, action) {
                var { prev: prev, next: next } = action.payload;
                if (state.yAxis[prev.id] !== undefined) {
                    if (prev.id !== next.id) delete state.yAxis[prev.id];
                    state.yAxis[next.id] = (0, $808ce0820c1669b6$export$c05b21e3257751e5)(next);
                }
            },
            prepare: (0, $df8b6ce3f4df1ba5$export$39fcd5145ec5e4e2)()
        },
        removeYAxis: {
            reducer (state, action) {
                delete state.yAxis[action.payload.id];
            },
            prepare: (0, $df8b6ce3f4df1ba5$export$39fcd5145ec5e4e2)()
        },
        addZAxis: {
            reducer (state, action) {
                state.zAxis[action.payload.id] = (0, $808ce0820c1669b6$export$c05b21e3257751e5)(action.payload);
            },
            prepare: (0, $df8b6ce3f4df1ba5$export$39fcd5145ec5e4e2)()
        },
        replaceZAxis: {
            reducer (state, action) {
                var { prev: prev, next: next } = action.payload;
                if (state.zAxis[prev.id] !== undefined) {
                    if (prev.id !== next.id) delete state.zAxis[prev.id];
                    state.zAxis[next.id] = (0, $808ce0820c1669b6$export$c05b21e3257751e5)(next);
                }
            },
            prepare: (0, $df8b6ce3f4df1ba5$export$39fcd5145ec5e4e2)()
        },
        removeZAxis: {
            reducer (state, action) {
                delete state.zAxis[action.payload.id];
            },
            prepare: (0, $df8b6ce3f4df1ba5$export$39fcd5145ec5e4e2)()
        },
        updateYAxisWidth (state, action) {
            var { id: id, width: width } = action.payload;
            var axis = state.yAxis[id];
            if (axis) {
                var _history$;
                var history = axis.widthHistory || [];
                // An oscillation is detected when the new width is the same as the width before the last one.
                // This is a simple A -> B -> A pattern. If the next width is B, and the difference is less than 1 pixel, we ignore it.
                if (history.length === 3 && history[0] === history[2] && width === history[1] && width !== axis.width && Math.abs(width - ((_history$ = history[0]) !== null && _history$ !== void 0 ? _history$ : 0)) <= 1) return;
                var newHistory = [
                    ...history,
                    width
                ].slice(-3);
                state.yAxis[id] = $c24339571f507656$var$_objectSpread($c24339571f507656$var$_objectSpread({}, axis), {}, {
                    width: width,
                    widthHistory: newHistory
                });
            }
        }
    }
});
var { addXAxis: $c24339571f507656$export$add6226ad7812fc8, replaceXAxis: $c24339571f507656$export$40aac341c282a543, removeXAxis: $c24339571f507656$export$f408189458c6a79b, addYAxis: $c24339571f507656$export$4ed10a19d7febea1, replaceYAxis: $c24339571f507656$export$58b7fa4a7d4572f6, removeYAxis: $c24339571f507656$export$79db5e9bd25f14c4, addZAxis: $c24339571f507656$export$1c8a1319a1571880, replaceZAxis: $c24339571f507656$export$ad147e7505520476, removeZAxis: $c24339571f507656$export$d823f07ec1da7041, updateYAxisWidth: $c24339571f507656$export$6e42dbbf4e5a5faa } = $c24339571f507656$var$cartesianAxisSlice.actions;
var $c24339571f507656$export$c8ae79f5f6ae07c6 = $c24339571f507656$var$cartesianAxisSlice.reducer;














var $1e9e9b3c1f2abdf7$export$877d2dd8db5f51fd = (state)=>state.options.defaultTooltipEventType;
var $1e9e9b3c1f2abdf7$export$7f95a7e594fa7911 = (state)=>state.options.validateTooltipEventTypes;
function $1e9e9b3c1f2abdf7$export$d419a1f58b445a8f(shared, defaultTooltipEventType, validateTooltipEventTypes) {
    if (shared == null) return defaultTooltipEventType;
    var eventType = shared ? 'axis' : 'item';
    if (validateTooltipEventTypes == null) return defaultTooltipEventType;
    return validateTooltipEventTypes.includes(eventType) ? eventType : defaultTooltipEventType;
}
function $1e9e9b3c1f2abdf7$export$53af65c2db668fac(state, shared) {
    var defaultTooltipEventType = $1e9e9b3c1f2abdf7$export$877d2dd8db5f51fd(state);
    var validateTooltipEventTypes = $1e9e9b3c1f2abdf7$export$7f95a7e594fa7911(state);
    return $1e9e9b3c1f2abdf7$export$d419a1f58b445a8f(shared, defaultTooltipEventType, validateTooltipEventTypes);
}
function $1e9e9b3c1f2abdf7$export$7ac1fe18a92be318(shared) {
    return (0, $a441e801d1b41b52$export$a7347740d65f620b)((state)=>$1e9e9b3c1f2abdf7$export$53af65c2db668fac(state, shared));
}



var $c06897a9b2abaf8e$export$3213c4688ceb4c80 = (tooltipTicks, activeIndex)=>{
    var _tooltipTicks$n;
    var n = Number(activeIndex);
    if ((0, $7e613228d3a31273$export$e426a261f3212d7d)(n) || activeIndex == null) return undefined;
    return n >= 0 ? tooltipTicks === null || tooltipTicks === void 0 || (_tooltipTicks$n = tooltipTicks[n]) === null || _tooltipTicks$n === void 0 ? void 0 : _tooltipTicks$n.value : undefined;
};


var $926bac99cf6cfcba$export$26d1e95fb7dea02 = (state)=>state.tooltip.settings;



function $2c79ab71c40f52be$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2c79ab71c40f52be$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2c79ab71c40f52be$var$ownKeys(Object(t), !0).forEach(function(r) {
            $2c79ab71c40f52be$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2c79ab71c40f52be$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $2c79ab71c40f52be$var$_defineProperty(e, r, t) {
    return (r = $2c79ab71c40f52be$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $2c79ab71c40f52be$var$_toPropertyKey(t) {
    var i = $2c79ab71c40f52be$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $2c79ab71c40f52be$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $2c79ab71c40f52be$var$chooseAppropriateMouseInteraction(tooltipState, tooltipEventType, trigger) {
    if (tooltipEventType === 'axis') {
        if (trigger === 'click') return tooltipState.axisInteraction.click;
        return tooltipState.axisInteraction.hover;
    }
    if (trigger === 'click') return tooltipState.itemInteraction.click;
    return tooltipState.itemInteraction.hover;
}
function $2c79ab71c40f52be$var$hasBeenActivePreviously(tooltipInteractionState) {
    return tooltipInteractionState.index != null;
}
var $2c79ab71c40f52be$export$d759c39cacfacf6a = (tooltipState, tooltipEventType, trigger, defaultIndex)=>{
    if (tooltipEventType == null) return 0, $2bfb679c145bcb6f$export$66f2ad380b6acece;
    var appropriateMouseInteraction = $2c79ab71c40f52be$var$chooseAppropriateMouseInteraction(tooltipState, tooltipEventType, trigger);
    if (appropriateMouseInteraction == null) return 0, $2bfb679c145bcb6f$export$66f2ad380b6acece;
    if (appropriateMouseInteraction.active) return appropriateMouseInteraction;
    if (tooltipState.keyboardInteraction.active) return tooltipState.keyboardInteraction;
    if (tooltipState.syncInteraction.active && tooltipState.syncInteraction.index != null) return tooltipState.syncInteraction;
    var activeFromProps = tooltipState.settings.active === true;
    if ($2c79ab71c40f52be$var$hasBeenActivePreviously(appropriateMouseInteraction)) {
        if (activeFromProps) return $2c79ab71c40f52be$var$_objectSpread($2c79ab71c40f52be$var$_objectSpread({}, appropriateMouseInteraction), {}, {
            active: true
        });
    } else if (defaultIndex != null) return {
        active: true,
        coordinate: undefined,
        dataKey: undefined,
        index: defaultIndex,
        graphicalItemId: undefined
    };
    return $2c79ab71c40f52be$var$_objectSpread($2c79ab71c40f52be$var$_objectSpread({}, (0, $2bfb679c145bcb6f$export$66f2ad380b6acece)), {}, {
        coordinate: appropriateMouseInteraction.coordinate
    });
};





function $616bfe7b3ded2280$var$toFiniteNumber(value) {
    if (typeof value === 'number') return Number.isFinite(value) ? value : undefined;
    if (value instanceof Date) {
        var numericValue = value.valueOf();
        return Number.isFinite(numericValue) ? numericValue : undefined;
    }
    var parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : undefined;
}
function $616bfe7b3ded2280$var$isValueWithinNumberDomain(value, domain) {
    var numericValue = $616bfe7b3ded2280$var$toFiniteNumber(value);
    var lowerBound = domain[0];
    var upperBound = domain[1];
    if (numericValue === undefined) return false;
    var min = Math.min(lowerBound, upperBound);
    var max = Math.max(lowerBound, upperBound);
    return numericValue >= min && numericValue <= max;
}
function $616bfe7b3ded2280$var$isValueWithinDomain(entry, axisDataKey, domain) {
    if (domain == null || axisDataKey == null) return true;
    var value = (0, $d5958b0668c58531$export$f97fc4a450f29a)(entry, axisDataKey);
    if (value == null) return true;
    if (!(0, $5bcc5341b7e18f2a$export$ba29b24e2a92eb58)(domain)) return true;
    return $616bfe7b3ded2280$var$isValueWithinNumberDomain(value, domain);
}
var $616bfe7b3ded2280$export$32df4b03a0962e46 = (tooltipInteraction, chartData, axisDataKey, domain)=>{
    var desiredIndex = tooltipInteraction === null || tooltipInteraction === void 0 ? void 0 : tooltipInteraction.index;
    if (desiredIndex == null) return null;
    var indexAsNumber = Number(desiredIndex);
    if (!(0, $22869ac8a5888437$export$f8a8fc612ced9bb0)(indexAsNumber)) // this is for charts like Sankey and Treemap that do not support numerical indexes. We need a proper solution for this before we can start supporting keyboard events on these charts.
    return desiredIndex;
    /*
   * Zero is a trivial limit for single-dimensional charts like Line and Area,
   * but this also needs a support for multidimensional charts like Sankey and Treemap! TODO
   */ var lowerLimit = 0;
    var upperLimit = Infinity;
    if (chartData.length > 0) upperLimit = chartData.length - 1;
    // now let's clamp the desiredIndex between the limits
    var clampedIndex = Math.max(lowerLimit, Math.min(indexAsNumber, upperLimit));
    var entry = chartData[clampedIndex];
    if (entry == null) return String(clampedIndex);
    if (!$616bfe7b3ded2280$var$isValueWithinDomain(entry, axisDataKey, domain)) return null;
    return String(clampedIndex);
};


var $a27882997ab1ddd6$export$c2cbc37a7546bbd0 = (width, height, layout, offset, tooltipTicks, defaultIndex, tooltipConfigurations)=>{
    if (defaultIndex == null) return undefined;
    /*
   * With defaultIndex alone, we don't have enough information to decide _which_ of the multiple tooltips to display.
   * Maybe one day we could add new prop `activeGraphicalItemId` to the chart to help with that.
   * Until then, we choose the first one.
   */ var firstConfiguration = tooltipConfigurations[0];
    var maybePosition = firstConfiguration === null || firstConfiguration === void 0 ? void 0 : firstConfiguration.getPosition(defaultIndex);
    if (maybePosition != null) return maybePosition;
    var tick = tooltipTicks === null || tooltipTicks === void 0 ? void 0 : tooltipTicks[Number(defaultIndex)];
    if (!tick) return undefined;
    switch(layout){
        case 'horizontal':
            return {
                x: tick.coordinate,
                y: (offset.top + height) / 2
            };
        default:
            // This logic is not super sound - it conflates vertical, radial, centric layouts into just one. TODO improve!
            return {
                x: (offset.left + width) / 2,
                y: tick.coordinate
            };
    }
};




var $4ea745cac09f05e3$export$45044aaa79c0cddb = (tooltipState, tooltipEventType, trigger, defaultIndex)=>{
    // if tooltip reacts to axis interaction, then we display all items at the same time.
    if (tooltipEventType === 'axis') return tooltipState.tooltipItemPayloads;
    /*
   * By now we already know that tooltipEventType is 'item', so we can only search in itemInteractions.
   * item means that only the hovered or clicked item will be present in the tooltip.
   */ if (tooltipState.tooltipItemPayloads.length === 0) // No point filtering if the payload is empty
    return [];
    var filterByGraphicalItemId;
    if (trigger === 'hover') filterByGraphicalItemId = tooltipState.itemInteraction.hover.graphicalItemId;
    else filterByGraphicalItemId = tooltipState.itemInteraction.click.graphicalItemId;
    if (tooltipState.syncInteraction.active && filterByGraphicalItemId == null) /*
     * When a tooltip is synchronised from another chart, the local itemInteraction
     * has no graphicalItemId because the user hasn't hovered over this chart.
     * In that case we show all tooltip items so the receiving chart can display
     * its own data at the synced index — matching the behaviour of axis-type tooltips.
     */ return tooltipState.tooltipItemPayloads;
    if (filterByGraphicalItemId == null && (defaultIndex != null || tooltipState.keyboardInteraction.active)) {
        /*
     * So when we use `defaultIndex` - we don't have a dataKey to filter by because user did not hover over anything yet.
     * In that case let's display the first item in the tooltip; after all, this is `item` interaction case,
     * so we should display only one item at a time instead of all.
     */ var firstItemPayload = tooltipState.tooltipItemPayloads[0];
        if (firstItemPayload != null) return [
            firstItemPayload
        ];
        return [];
    }
    return tooltipState.tooltipItemPayloads.filter((tpc)=>{
        var _tpc$settings;
        return ((_tpc$settings = tpc.settings) === null || _tpc$settings === void 0 ? void 0 : _tpc$settings.graphicalItemId) === filterByGraphicalItemId;
    });
};


var $e90b5e71a23643c7$export$6ae1ee94e6fa88a7 = (state)=>state.options.tooltipPayloadSearcher;


var $4f20250cfa418037$export$703b585bc92b5bae = (state)=>state.tooltip;





function $1efda367f97cd466$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1efda367f97cd466$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1efda367f97cd466$var$ownKeys(Object(t), !0).forEach(function(r) {
            $1efda367f97cd466$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1efda367f97cd466$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1efda367f97cd466$var$_defineProperty(e, r, t) {
    return (r = $1efda367f97cd466$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $1efda367f97cd466$var$_toPropertyKey(t) {
    var i = $1efda367f97cd466$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $1efda367f97cd466$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $1efda367f97cd466$var$parseName(value) {
    if (typeof value === 'string' || typeof value === 'number') return value;
    return undefined;
}
function $1efda367f97cd466$var$parseUnit(value) {
    if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') return value;
    return undefined;
}
function $1efda367f97cd466$var$parseDataKey(value) {
    if (typeof value === 'string' || typeof value === 'number') return value;
    if (typeof value === 'function') return (obj)=>value(obj);
    return undefined;
}
function $1efda367f97cd466$var$parseColor(value) {
    if (typeof value === 'string') return value;
    return undefined;
}
function $1efda367f97cd466$var$parseTooltipPayloadItem(item) {
    if (item == null || typeof item !== 'object') return undefined;
    var name = 'name' in item ? $1efda367f97cd466$var$parseName(item.name) : undefined;
    var unit = 'unit' in item ? $1efda367f97cd466$var$parseUnit(item.unit) : undefined;
    var dataKey = 'dataKey' in item ? $1efda367f97cd466$var$parseDataKey(item.dataKey) : undefined;
    var payload = 'payload' in item ? item.payload : undefined;
    var color = 'color' in item ? $1efda367f97cd466$var$parseColor(item.color) : undefined;
    var fill = 'fill' in item ? $1efda367f97cd466$var$parseColor(item.fill) : undefined;
    return {
        name: name,
        unit: unit,
        dataKey: dataKey,
        payload: payload,
        color: color,
        fill: fill
    };
}
function $1efda367f97cd466$var$selectFinalData(dataDefinedOnItem, dataDefinedOnChart) {
    /*
   * If a payload has data specified directly from the graphical item, prefer that.
   * Otherwise, fill in data from the chart level, using the same index.
   */ if (dataDefinedOnItem != null) return dataDefinedOnItem;
    return dataDefinedOnChart;
}
var $1efda367f97cd466$export$e50d50655fe0e7ab = (tooltipPayloadConfigurations, activeIndex, chartDataState, tooltipAxisDataKey, activeLabel, tooltipPayloadSearcher, tooltipEventType)=>{
    if (activeIndex == null || tooltipPayloadSearcher == null) return undefined;
    var { chartData: chartData, computedData: computedData, dataStartIndex: dataStartIndex, dataEndIndex: dataEndIndex } = chartDataState;
    var init = [];
    return tooltipPayloadConfigurations.reduce((agg, _ref)=>{
        var _settings$dataKey;
        var { dataDefinedOnItem: dataDefinedOnItem, settings: settings } = _ref;
        var finalData = $1efda367f97cd466$var$selectFinalData(dataDefinedOnItem, chartData);
        var sliced = Array.isArray(finalData) ? (0, $d395578883b2cbe6$export$238176e5211cdc1a)(finalData, dataStartIndex, dataEndIndex) : finalData;
        var finalDataKey = (_settings$dataKey = settings === null || settings === void 0 ? void 0 : settings.dataKey) !== null && _settings$dataKey !== void 0 ? _settings$dataKey : tooltipAxisDataKey;
        // BaseAxisProps does not support nameKey but it could!
        var finalNameKey = settings === null || settings === void 0 ? void 0 : settings.nameKey; // ?? tooltipAxis?.nameKey;
        var tooltipPayload;
        if (tooltipAxisDataKey && Array.isArray(sliced) && /*
     * findEntryInArray won't work for Scatter because Scatter provides an array of arrays
     * as tooltip payloads and findEntryInArray is not prepared to handle that.
     * Sad but also ScatterChart only allows 'item' tooltipEventType
     * and also this is only a problem if there are multiple Scatters and each has its own data array
     * so let's fix that some other time.
     */ !Array.isArray(sliced[0]) && /*
     * If the tooltipEventType is 'axis', we should search for the dataKey in the sliced data
     * because thanks to allowDuplicatedCategory=false, the order of elements in the array
     * no longer matches the order of elements in the original data
     * and so we need to search by the active dataKey + label rather than by index.
     *
     * The same happens if multiple graphical items are present in the chart
     * and each of them has its own data array. Those arrays get concatenated
     * and again the tooltip index no longer matches the original data.
     *
     * On the other hand the tooltipEventType 'item' should always search by index
     * because we get the index from interacting over the individual elements
     * which is always accurate, irrespective of the allowDuplicatedCategory setting.
     */ tooltipEventType === 'axis') tooltipPayload = (0, $7e613228d3a31273$export$66950d3869f5cc67)(sliced, tooltipAxisDataKey, activeLabel);
        else /*
       * This is a problem because it assumes that the index is pointing to the displayed data
       * which it isn't because the index is pointing to the tooltip ticks array.
       * The above approach (with findEntryInArray) is the correct one, but it only works
       * if the axis dataKey is defined explicitly, and if the data is an array of objects.
       */ tooltipPayload = tooltipPayloadSearcher(sliced, activeIndex, computedData, finalNameKey);
        if (Array.isArray(tooltipPayload)) tooltipPayload.forEach((item)=>{
            var _parsedItem$color, _parsedItem$fill;
            var parsedItem = $1efda367f97cd466$var$parseTooltipPayloadItem(item);
            var itemName = parsedItem === null || parsedItem === void 0 ? void 0 : parsedItem.name;
            var itemDataKey = parsedItem === null || parsedItem === void 0 ? void 0 : parsedItem.dataKey;
            var itemPayload = parsedItem === null || parsedItem === void 0 ? void 0 : parsedItem.payload;
            var newSettings = $1efda367f97cd466$var$_objectSpread($1efda367f97cd466$var$_objectSpread({}, settings), {}, {
                name: itemName,
                unit: parsedItem === null || parsedItem === void 0 ? void 0 : parsedItem.unit,
                // Preserve item-level color/fill from graphical items.
                color: (_parsedItem$color = parsedItem === null || parsedItem === void 0 ? void 0 : parsedItem.color) !== null && _parsedItem$color !== void 0 ? _parsedItem$color : settings === null || settings === void 0 ? void 0 : settings.color,
                fill: (_parsedItem$fill = parsedItem === null || parsedItem === void 0 ? void 0 : parsedItem.fill) !== null && _parsedItem$fill !== void 0 ? _parsedItem$fill : settings === null || settings === void 0 ? void 0 : settings.fill
            });
            agg.push((0, $d5958b0668c58531$export$3c1b390368bb3561)({
                tooltipEntrySettings: newSettings,
                dataKey: itemDataKey,
                payload: itemPayload,
                value: (0, $d5958b0668c58531$export$f97fc4a450f29a)(itemPayload, itemDataKey),
                name: itemName == null ? undefined : String(itemName)
            }));
        });
        else {
            var _getValueByDataKey;
            // I am not quite sure why these two branches (Array vs Array of Arrays) have to behave differently - I imagine we should unify these. 3.x breaking change?
            agg.push((0, $d5958b0668c58531$export$3c1b390368bb3561)({
                tooltipEntrySettings: settings,
                dataKey: finalDataKey,
                payload: tooltipPayload,
                // getValueByDataKey does not validate the output type
                value: (0, $d5958b0668c58531$export$f97fc4a450f29a)(tooltipPayload, finalDataKey),
                // getValueByDataKey does not validate the output type
                name: (_getValueByDataKey = (0, $d5958b0668c58531$export$f97fc4a450f29a)(tooltipPayload, finalNameKey)) !== null && _getValueByDataKey !== void 0 ? _getValueByDataKey : settings === null || settings === void 0 ? void 0 : settings.name
            }));
        }
        return agg;
    }, init);
};













var $dbde609d2e66e7f4$export$221021c57c593b2 = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    (0, $223cdb002ac9c48b$export$27d9004292294cd7),
    (0, $223cdb002ac9c48b$export$1c7798b82c8010cd),
    (0, $1728a742f9386be1$export$3247769c9dbde559)
], (0, $2772e85521d4b2a0$export$bebec32544750591));
var $dbde609d2e66e7f4$export$4751149f4d54cbbf = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    (state)=>state.graphicalItems.cartesianItems,
    (state)=>state.graphicalItems.polarItems
], (cartesianItems, polarItems)=>[
        ...cartesianItems,
        ...polarItems
    ]);
var $dbde609d2e66e7f4$var$selectTooltipAxisPredicate = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    (0, $ab8db2d9eb83d918$export$898d3dfd98fb482),
    (0, $cbdc2e68b6a9737d$export$eeffdb10daff095d)
], (0, $223cdb002ac9c48b$export$a3923f321c6572c3));
var $dbde609d2e66e7f4$export$645965005f643e6f = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $dbde609d2e66e7f4$export$4751149f4d54cbbf,
    (0, $223cdb002ac9c48b$export$27d9004292294cd7),
    $dbde609d2e66e7f4$var$selectTooltipAxisPredicate
], (0, $223cdb002ac9c48b$export$ad35679ce4582010), {
    memoizeOptions: {
        resultEqualityCheck: (0, $a931610653760bd0$export$dcc34c4213e7f4c)
    }
});
var $dbde609d2e66e7f4$var$selectAllStackedGraphicalItemsSettings = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $dbde609d2e66e7f4$export$645965005f643e6f
], (graphicalItems)=>graphicalItems.filter((0, $66614bffc4581796$export$2335dd91cc88053e)));
var $dbde609d2e66e7f4$export$b3f948fbed0299f1 = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $dbde609d2e66e7f4$export$645965005f643e6f
], (0, $223cdb002ac9c48b$export$d945cee965d266f0), {
    memoizeOptions: {
        resultEqualityCheck: (0, $a931610653760bd0$export$dcc34c4213e7f4c)
    }
});
var $dbde609d2e66e7f4$var$selectAnyTooltipItemUsesChartData = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $dbde609d2e66e7f4$export$645965005f643e6f
], (items)=>items.some((item)=>!item.data));
var $dbde609d2e66e7f4$export$5a8beccc8250d20e = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $dbde609d2e66e7f4$export$b3f948fbed0299f1,
    (0, $8c22b3d5bf36186c$export$519edd692222520)
], (0, $223cdb002ac9c48b$export$c2c6d012cffe2c75));
var $dbde609d2e66e7f4$var$selectTooltipStackedData = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $dbde609d2e66e7f4$var$selectAllStackedGraphicalItemsSettings,
    (0, $8c22b3d5bf36186c$export$519edd692222520),
    (0, $223cdb002ac9c48b$export$27d9004292294cd7)
], (0, $c20d7381b4964aa5$export$ae6c77e7720cddf9));
var $dbde609d2e66e7f4$var$selectAllTooltipAppliedValues = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $dbde609d2e66e7f4$export$5a8beccc8250d20e,
    (0, $223cdb002ac9c48b$export$27d9004292294cd7),
    $dbde609d2e66e7f4$export$645965005f643e6f,
    (0, $8c22b3d5bf36186c$export$519edd692222520),
    $dbde609d2e66e7f4$var$selectAnyTooltipItemUsesChartData,
    $dbde609d2e66e7f4$export$b3f948fbed0299f1
], (0, $223cdb002ac9c48b$export$48831dc762d7b6ad));
var $dbde609d2e66e7f4$var$selectTooltipAxisDomainDefinition = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    (0, $223cdb002ac9c48b$export$27d9004292294cd7)
], (0, $223cdb002ac9c48b$export$2e6262b6c952ab02));
var $dbde609d2e66e7f4$var$selectTooltipDataOverflow = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    (0, $223cdb002ac9c48b$export$27d9004292294cd7)
], (axisSettings)=>axisSettings.allowDataOverflow);
var $dbde609d2e66e7f4$var$selectTooltipDomainFromUserPreferences = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $dbde609d2e66e7f4$var$selectTooltipAxisDomainDefinition,
    $dbde609d2e66e7f4$var$selectTooltipDataOverflow
], (0, $5bcc5341b7e18f2a$export$fcbf88d4627b24df));
var $dbde609d2e66e7f4$var$selectAllStackedGraphicalItems = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $dbde609d2e66e7f4$export$645965005f643e6f
], (graphicalItems)=>graphicalItems.filter((0, $66614bffc4581796$export$2335dd91cc88053e)));
var $dbde609d2e66e7f4$var$selectTooltipStackGroups = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $dbde609d2e66e7f4$var$selectTooltipStackedData,
    $dbde609d2e66e7f4$var$selectAllStackedGraphicalItems,
    (0, $1728a742f9386be1$export$73aff39176364def),
    (0, $1728a742f9386be1$export$ec830dc49707c6da)
], (0, $223cdb002ac9c48b$export$9312914d13496409));
var $dbde609d2e66e7f4$var$selectTooltipDomainOfStackGroups = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $dbde609d2e66e7f4$var$selectTooltipStackGroups,
    (0, $8c22b3d5bf36186c$export$519edd692222520),
    (0, $ab8db2d9eb83d918$export$898d3dfd98fb482),
    $dbde609d2e66e7f4$var$selectTooltipDomainFromUserPreferences
], (0, $223cdb002ac9c48b$export$3286b8ea6ff06720));
var $dbde609d2e66e7f4$var$selectTooltipItemsSettingsExceptStacked = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $dbde609d2e66e7f4$export$645965005f643e6f
], (0, $223cdb002ac9c48b$export$a61da86823382adc));
var $dbde609d2e66e7f4$var$selectDomainOfAllAppliedNumericalValuesIncludingErrorValues = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $dbde609d2e66e7f4$export$5a8beccc8250d20e,
    (0, $223cdb002ac9c48b$export$27d9004292294cd7),
    $dbde609d2e66e7f4$var$selectTooltipItemsSettingsExceptStacked,
    (0, $223cdb002ac9c48b$export$9429ab4550237b6d),
    (0, $ab8db2d9eb83d918$export$898d3dfd98fb482),
    (0, $8c22b3d5bf36186c$export$562e7f818eadc746)
], (0, $223cdb002ac9c48b$export$df56c8e9a3e45e65), {
    memoizeOptions: {
        resultEqualityCheck: (0, $30bf67e96df5a044$export$45c01007b107f1a6)
    }
});
var $dbde609d2e66e7f4$var$selectReferenceDotsByTooltipAxis = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    (0, $223cdb002ac9c48b$export$71580de5ed38161a),
    (0, $ab8db2d9eb83d918$export$898d3dfd98fb482),
    (0, $cbdc2e68b6a9737d$export$eeffdb10daff095d)
], (0, $223cdb002ac9c48b$export$2829d12117d2002f));
var $dbde609d2e66e7f4$var$selectTooltipReferenceDotsDomain = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $dbde609d2e66e7f4$var$selectReferenceDotsByTooltipAxis,
    (0, $ab8db2d9eb83d918$export$898d3dfd98fb482)
], (0, $223cdb002ac9c48b$export$5da0b79fd816ec4b));
var $dbde609d2e66e7f4$var$selectReferenceAreasByTooltipAxis = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    (0, $223cdb002ac9c48b$export$c7e152cb7f10c1a6),
    (0, $ab8db2d9eb83d918$export$898d3dfd98fb482),
    (0, $cbdc2e68b6a9737d$export$eeffdb10daff095d)
], (0, $223cdb002ac9c48b$export$2829d12117d2002f));
var $dbde609d2e66e7f4$var$selectTooltipReferenceAreasDomain = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $dbde609d2e66e7f4$var$selectReferenceAreasByTooltipAxis,
    (0, $ab8db2d9eb83d918$export$898d3dfd98fb482)
], (0, $223cdb002ac9c48b$export$7b27918cf5e1fc19));
var $dbde609d2e66e7f4$var$selectReferenceLinesByTooltipAxis = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    (0, $223cdb002ac9c48b$export$8fe2a49ce63c5348),
    (0, $ab8db2d9eb83d918$export$898d3dfd98fb482),
    (0, $cbdc2e68b6a9737d$export$eeffdb10daff095d)
], (0, $223cdb002ac9c48b$export$2829d12117d2002f));
var $dbde609d2e66e7f4$var$selectTooltipReferenceLinesDomain = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $dbde609d2e66e7f4$var$selectReferenceLinesByTooltipAxis,
    (0, $ab8db2d9eb83d918$export$898d3dfd98fb482)
], (0, $223cdb002ac9c48b$export$f1d17aebd11953eb));
var $dbde609d2e66e7f4$var$selectTooltipReferenceElementsDomain = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $dbde609d2e66e7f4$var$selectTooltipReferenceDotsDomain,
    $dbde609d2e66e7f4$var$selectTooltipReferenceLinesDomain,
    $dbde609d2e66e7f4$var$selectTooltipReferenceAreasDomain
], (0, $223cdb002ac9c48b$export$9c8185c6eda0fb0d));
var $dbde609d2e66e7f4$var$selectTooltipNumericalDomain = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    (0, $223cdb002ac9c48b$export$27d9004292294cd7),
    $dbde609d2e66e7f4$var$selectTooltipAxisDomainDefinition,
    $dbde609d2e66e7f4$var$selectTooltipDomainFromUserPreferences,
    $dbde609d2e66e7f4$var$selectTooltipDomainOfStackGroups,
    $dbde609d2e66e7f4$var$selectDomainOfAllAppliedNumericalValuesIncludingErrorValues,
    $dbde609d2e66e7f4$var$selectTooltipReferenceElementsDomain,
    (0, $f4c9341f05a18477$export$8426b6d9af801dee),
    (0, $ab8db2d9eb83d918$export$898d3dfd98fb482)
], (0, $223cdb002ac9c48b$export$b9eca0fd568f66a4));
var $dbde609d2e66e7f4$export$76f7a1975f60ccf1 = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    (0, $223cdb002ac9c48b$export$27d9004292294cd7),
    (0, $f4c9341f05a18477$export$8426b6d9af801dee),
    $dbde609d2e66e7f4$export$5a8beccc8250d20e,
    $dbde609d2e66e7f4$var$selectAllTooltipAppliedValues,
    (0, $1728a742f9386be1$export$73aff39176364def),
    (0, $ab8db2d9eb83d918$export$898d3dfd98fb482),
    $dbde609d2e66e7f4$var$selectTooltipNumericalDomain
], (0, $223cdb002ac9c48b$export$70e6ef68424edf74));
var $dbde609d2e66e7f4$var$selectTooltipNiceTicks = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $dbde609d2e66e7f4$export$76f7a1975f60ccf1,
    (0, $223cdb002ac9c48b$export$27d9004292294cd7),
    $dbde609d2e66e7f4$export$221021c57c593b2
], (0, $223cdb002ac9c48b$export$aa1ef6c8f610e48c));
var $dbde609d2e66e7f4$export$90be38154e4228b2 = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    (0, $223cdb002ac9c48b$export$27d9004292294cd7),
    $dbde609d2e66e7f4$export$76f7a1975f60ccf1,
    $dbde609d2e66e7f4$var$selectTooltipNiceTicks,
    (0, $ab8db2d9eb83d918$export$898d3dfd98fb482)
], (0, $223cdb002ac9c48b$export$3a4530026b1860ff));
var $dbde609d2e66e7f4$var$selectTooltipAxisRange = (state)=>{
    var axisType = (0, $ab8db2d9eb83d918$export$898d3dfd98fb482)(state);
    var axisId = (0, $cbdc2e68b6a9737d$export$eeffdb10daff095d)(state);
    var isPanorama = false; // Tooltip never displays in panorama so this is safe to assume
    return (0, $223cdb002ac9c48b$export$3506ed461810cc8f)(state, axisType, axisId, isPanorama);
};
var $dbde609d2e66e7f4$export$cf4d6dfce3a76af3 = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    (0, $223cdb002ac9c48b$export$27d9004292294cd7),
    $dbde609d2e66e7f4$var$selectTooltipAxisRange
], (0, $250f5d8c249e6c87$export$3f7e30291950e694));
var $dbde609d2e66e7f4$var$selectTooltipConfiguredScale = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    (0, $223cdb002ac9c48b$export$27d9004292294cd7),
    $dbde609d2e66e7f4$export$221021c57c593b2,
    $dbde609d2e66e7f4$export$90be38154e4228b2,
    $dbde609d2e66e7f4$export$cf4d6dfce3a76af3
], (0, $a49f0acc2976fd6a$export$24f70d56c780d8f0));
var $dbde609d2e66e7f4$export$cdeccbbdd343ae59 = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $dbde609d2e66e7f4$var$selectTooltipConfiguredScale
], (0, $3ec4ee43aef296c2$export$5501a52df751e5ca));
var $dbde609d2e66e7f4$var$selectTooltipDuplicateDomain = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    (0, $f4c9341f05a18477$export$8426b6d9af801dee),
    $dbde609d2e66e7f4$var$selectAllTooltipAppliedValues,
    (0, $223cdb002ac9c48b$export$27d9004292294cd7),
    (0, $ab8db2d9eb83d918$export$898d3dfd98fb482)
], (0, $223cdb002ac9c48b$export$bb1ebf56a37bd899));
var $dbde609d2e66e7f4$export$f7665d13a99c934c = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    (0, $f4c9341f05a18477$export$8426b6d9af801dee),
    $dbde609d2e66e7f4$var$selectAllTooltipAppliedValues,
    (0, $223cdb002ac9c48b$export$27d9004292294cd7),
    (0, $ab8db2d9eb83d918$export$898d3dfd98fb482)
], (0, $223cdb002ac9c48b$export$911ef47868c9ab07));
var $dbde609d2e66e7f4$var$combineTicksOfTooltipAxis = (layout, axis, realScaleType, scale, range, duplicateDomain, categoricalDomain, axisType)=>{
    if (!axis) return undefined;
    var { type: type } = axis;
    var isCategorical = (0, $d5958b0668c58531$export$9fc1baaa6c6368b)(layout, axisType);
    if (!scale) return undefined;
    var offsetForBand = realScaleType === 'scaleBand' && scale.bandwidth ? scale.bandwidth() / 2 : 2;
    var offset = type === 'category' && scale.bandwidth ? scale.bandwidth() / offsetForBand : 0;
    offset = axisType === 'angleAxis' && range != null && (range === null || range === void 0 ? void 0 : range.length) >= 2 ? (0, $7e613228d3a31273$export$9d334328eb75e624)(range[0] - range[1]) * 2 * offset : offset;
    // When axis is a categorical axis, but the type of axis is number or the scale of axis is not "auto"
    if (isCategorical && categoricalDomain) return categoricalDomain.map((entry, index)=>{
        var scaled = scale.map(entry);
        if (!(0, $22869ac8a5888437$export$f8a8fc612ced9bb0)(scaled)) return null;
        return {
            coordinate: scaled + offset,
            value: entry,
            index: index,
            offset: offset
        };
    }).filter((0, $7e613228d3a31273$export$7e515ab5fbd92bef));
    // When axis has duplicated text, serial numbers are used to generate scale
    return scale.domain().map((entry, index)=>{
        var scaled = scale.map(entry);
        if (!(0, $22869ac8a5888437$export$f8a8fc612ced9bb0)(scaled)) return null;
        return {
            coordinate: scaled + offset,
            // @ts-expect-error can't use Date as an index
            value: duplicateDomain ? duplicateDomain[entry] : entry,
            index: index,
            offset: offset
        };
    }).filter((0, $7e613228d3a31273$export$7e515ab5fbd92bef));
};
var $dbde609d2e66e7f4$export$ffe0e60f8c88c05a = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    (0, $f4c9341f05a18477$export$8426b6d9af801dee),
    (0, $223cdb002ac9c48b$export$27d9004292294cd7),
    $dbde609d2e66e7f4$export$221021c57c593b2,
    $dbde609d2e66e7f4$export$cdeccbbdd343ae59,
    $dbde609d2e66e7f4$var$selectTooltipAxisRange,
    $dbde609d2e66e7f4$var$selectTooltipDuplicateDomain,
    $dbde609d2e66e7f4$export$f7665d13a99c934c,
    (0, $ab8db2d9eb83d918$export$898d3dfd98fb482)
], $dbde609d2e66e7f4$var$combineTicksOfTooltipAxis);
var $dbde609d2e66e7f4$var$selectTooltipEventType = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    (0, $1e9e9b3c1f2abdf7$export$877d2dd8db5f51fd),
    (0, $1e9e9b3c1f2abdf7$export$7f95a7e594fa7911),
    (0, $926bac99cf6cfcba$export$26d1e95fb7dea02)
], (defaultTooltipEventType, validateTooltipEventType, settings)=>(0, $1e9e9b3c1f2abdf7$export$d419a1f58b445a8f)(settings.shared, defaultTooltipEventType, validateTooltipEventType));
var $dbde609d2e66e7f4$var$selectTooltipTrigger = (state)=>state.tooltip.settings.trigger;
var $dbde609d2e66e7f4$var$selectDefaultIndex = (state)=>state.tooltip.settings.defaultIndex;
var $dbde609d2e66e7f4$var$selectTooltipInteractionState = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    (0, $4f20250cfa418037$export$703b585bc92b5bae),
    $dbde609d2e66e7f4$var$selectTooltipEventType,
    $dbde609d2e66e7f4$var$selectTooltipTrigger,
    $dbde609d2e66e7f4$var$selectDefaultIndex
], (0, $2c79ab71c40f52be$export$d759c39cacfacf6a));
var $dbde609d2e66e7f4$export$8b2762260f5891c9 = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $dbde609d2e66e7f4$var$selectTooltipInteractionState,
    $dbde609d2e66e7f4$export$5a8beccc8250d20e,
    (0, $223cdb002ac9c48b$export$bf8397fefbaa3617),
    $dbde609d2e66e7f4$export$76f7a1975f60ccf1
], (0, $616bfe7b3ded2280$export$32df4b03a0962e46));
var $dbde609d2e66e7f4$export$400c35cc3b9a0487 = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $dbde609d2e66e7f4$export$ffe0e60f8c88c05a,
    $dbde609d2e66e7f4$export$8b2762260f5891c9
], (0, $c06897a9b2abaf8e$export$3213c4688ceb4c80));
var $dbde609d2e66e7f4$export$999f7a7ced063fab = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $dbde609d2e66e7f4$var$selectTooltipInteractionState
], (tooltipInteraction)=>{
    if (!tooltipInteraction) return undefined;
    return tooltipInteraction.dataKey;
});
var $dbde609d2e66e7f4$export$3bddf33d79812741 = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $dbde609d2e66e7f4$var$selectTooltipInteractionState
], (tooltipInteraction)=>{
    if (!tooltipInteraction) return undefined;
    return tooltipInteraction.graphicalItemId;
});
var $dbde609d2e66e7f4$var$selectTooltipPayloadConfigurations = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    (0, $4f20250cfa418037$export$703b585bc92b5bae),
    $dbde609d2e66e7f4$var$selectTooltipEventType,
    $dbde609d2e66e7f4$var$selectTooltipTrigger,
    $dbde609d2e66e7f4$var$selectDefaultIndex
], (0, $4ea745cac09f05e3$export$45044aaa79c0cddb));
var $dbde609d2e66e7f4$var$selectTooltipCoordinateForDefaultIndex = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    (0, $0b675d94b376aa83$export$771ef0ac044f724d),
    (0, $0b675d94b376aa83$export$5856a7d94c109505),
    (0, $f4c9341f05a18477$export$8426b6d9af801dee),
    (0, $cd6092f0bbb953fd$export$1e34c8efb0bc9b3b),
    $dbde609d2e66e7f4$export$ffe0e60f8c88c05a,
    $dbde609d2e66e7f4$var$selectDefaultIndex,
    $dbde609d2e66e7f4$var$selectTooltipPayloadConfigurations
], (0, $a27882997ab1ddd6$export$c2cbc37a7546bbd0));
var $dbde609d2e66e7f4$export$90c565a5b196e427 = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $dbde609d2e66e7f4$var$selectTooltipInteractionState,
    $dbde609d2e66e7f4$var$selectTooltipCoordinateForDefaultIndex
], (tooltipInteractionState, defaultIndexCoordinate)=>{
    if (tooltipInteractionState !== null && tooltipInteractionState !== void 0 && tooltipInteractionState.coordinate) return tooltipInteractionState.coordinate;
    return defaultIndexCoordinate;
});
var $dbde609d2e66e7f4$export$c8884ed37796034a = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $dbde609d2e66e7f4$var$selectTooltipInteractionState
], (tooltipInteractionState)=>{
    var _tooltipInteractionSt;
    return (_tooltipInteractionSt = tooltipInteractionState === null || tooltipInteractionState === void 0 ? void 0 : tooltipInteractionState.active) !== null && _tooltipInteractionSt !== void 0 ? _tooltipInteractionSt : false;
});
var $dbde609d2e66e7f4$export$a2bb5be6e87cbb86 = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $dbde609d2e66e7f4$var$selectTooltipPayloadConfigurations,
    $dbde609d2e66e7f4$export$8b2762260f5891c9,
    (0, $8c22b3d5bf36186c$export$519edd692222520),
    (0, $223cdb002ac9c48b$export$bf8397fefbaa3617),
    $dbde609d2e66e7f4$export$400c35cc3b9a0487,
    (0, $e90b5e71a23643c7$export$6ae1ee94e6fa88a7),
    $dbde609d2e66e7f4$var$selectTooltipEventType
], (0, $1efda367f97cd466$export$e50d50655fe0e7ab));
var $dbde609d2e66e7f4$export$1a5b9bd341ad5f0e = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $dbde609d2e66e7f4$export$a2bb5be6e87cbb86
], (payload)=>{
    if (payload == null) return undefined;
    var dataPoints = payload.map((p)=>p.payload).filter((p)=>p != null);
    return Array.from(new Set(dataPoints));
});




var $6033e98ef2b10d0f$export$623d7e312118b313 = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    (0, $cd6092f0bbb953fd$export$1e34c8efb0bc9b3b)
], (offsetInternal)=>{
    return {
        top: offsetInternal.top,
        bottom: offsetInternal.bottom,
        left: offsetInternal.left,
        right: offsetInternal.right
    };
});





var $dc9550783f23448f$export$8a921ed356911d9a = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    (0, $6033e98ef2b10d0f$export$623d7e312118b313),
    (0, $0b675d94b376aa83$export$771ef0ac044f724d),
    (0, $0b675d94b376aa83$export$5856a7d94c109505)
], (offset, chartWidth, chartHeight)=>{
    if (!offset || chartWidth == null || chartHeight == null) return undefined;
    return {
        x: offset.left,
        y: offset.top,
        width: Math.max(0, chartWidth - offset.left - offset.right),
        height: Math.max(0, chartHeight - offset.top - offset.bottom)
    };
});


var $1a51fe639a3ac8a2$export$5acf30f46eb8262f = (xAxisId)=>{
    var isPanorama = (0, $10d1d693b6b228cd$export$4b0c59f8845ba920)();
    return (0, $a441e801d1b41b52$export$a7347740d65f620b)((state)=>(0, $223cdb002ac9c48b$export$db36c2f3bfe5c9d7)(state, 'xAxis', xAxisId, isPanorama));
};
var $1a51fe639a3ac8a2$export$db526816f6980005 = (yAxisId)=>{
    var isPanorama = (0, $10d1d693b6b228cd$export$4b0c59f8845ba920)();
    return (0, $a441e801d1b41b52$export$a7347740d65f620b)((state)=>(0, $223cdb002ac9c48b$export$db36c2f3bfe5c9d7)(state, 'yAxis', yAxisId, isPanorama));
};
var $1a51fe639a3ac8a2$export$19e28dcc217b2190 = function useXAxisScale() {
    var xAxisId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $c24339571f507656$export$e43f7367e579f53d);
    var isPanorama = (0, $10d1d693b6b228cd$export$4b0c59f8845ba920)();
    var scale = (0, $a441e801d1b41b52$export$a7347740d65f620b)((state)=>(0, $223cdb002ac9c48b$export$22e8e5f8924724ea)(state, 'xAxis', xAxisId, isPanorama));
    return scale === null || scale === void 0 ? void 0 : scale.map;
};
var $1a51fe639a3ac8a2$export$ec25c907e4f5439d = function useYAxisScale() {
    var yAxisId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $c24339571f507656$export$e43f7367e579f53d);
    var isPanorama = (0, $10d1d693b6b228cd$export$4b0c59f8845ba920)();
    var scale = (0, $a441e801d1b41b52$export$a7347740d65f620b)((state)=>(0, $223cdb002ac9c48b$export$22e8e5f8924724ea)(state, 'yAxis', yAxisId, isPanorama));
    return scale === null || scale === void 0 ? void 0 : scale.map;
};
var $1a51fe639a3ac8a2$export$fd3d11ca2ad63a3f = function useXAxisInverseScale() {
    var xAxisId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $c24339571f507656$export$e43f7367e579f53d);
    var isPanorama = (0, $10d1d693b6b228cd$export$4b0c59f8845ba920)();
    return (0, $a441e801d1b41b52$export$a7347740d65f620b)((state)=>(0, $223cdb002ac9c48b$export$657c51a9a0740206)(state, 'xAxis', xAxisId, isPanorama));
};
var $1a51fe639a3ac8a2$export$96c080ead68608cb = function useXAxisInverseDataSnapScale() {
    var xAxisId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $c24339571f507656$export$e43f7367e579f53d);
    var isPanorama = (0, $10d1d693b6b228cd$export$4b0c59f8845ba920)();
    return (0, $a441e801d1b41b52$export$a7347740d65f620b)((state)=>(0, $223cdb002ac9c48b$export$ddc8d5321a023350)(state, 'xAxis', xAxisId, isPanorama));
};
var $1a51fe639a3ac8a2$export$51280985698120cd = function useXAxisInverseTickSnapScale() {
    var xAxisId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $c24339571f507656$export$e43f7367e579f53d);
    return (0, $a441e801d1b41b52$export$a7347740d65f620b)((state)=>(0, $223cdb002ac9c48b$export$767aec070f996e73)(state, 'xAxis', xAxisId));
};
var $1a51fe639a3ac8a2$export$e507e736eefa0bae = function useYAxisInverseScale() {
    var yAxisId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $c24339571f507656$export$e43f7367e579f53d);
    var isPanorama = (0, $10d1d693b6b228cd$export$4b0c59f8845ba920)();
    return (0, $a441e801d1b41b52$export$a7347740d65f620b)((state)=>(0, $223cdb002ac9c48b$export$657c51a9a0740206)(state, 'yAxis', yAxisId, isPanorama));
};
var $1a51fe639a3ac8a2$export$d13c0d73d999f5c9 = function useYAxisInverseDataSnapScale() {
    var yAxisId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $c24339571f507656$export$e43f7367e579f53d);
    var isPanorama = (0, $10d1d693b6b228cd$export$4b0c59f8845ba920)();
    return (0, $a441e801d1b41b52$export$a7347740d65f620b)((state)=>(0, $223cdb002ac9c48b$export$ddc8d5321a023350)(state, 'yAxis', yAxisId, isPanorama));
};
var $1a51fe639a3ac8a2$export$c7e1bd05a239c2a7 = function useYAxisInverseTickSnapScale() {
    var yAxisId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $c24339571f507656$export$e43f7367e579f53d);
    return (0, $a441e801d1b41b52$export$a7347740d65f620b)((state)=>(0, $223cdb002ac9c48b$export$767aec070f996e73)(state, 'yAxis', yAxisId));
};
var $1a51fe639a3ac8a2$export$eb960b8a53294a1c = function useXAxisTicks() {
    var xAxisId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $c24339571f507656$export$e43f7367e579f53d);
    return (0, $a441e801d1b41b52$export$a7347740d65f620b)((state)=>(0, $223cdb002ac9c48b$export$9cc7232c10fac9e)(state, 'xAxis', xAxisId));
};
var $1a51fe639a3ac8a2$export$df446d79e69ba5d3 = function useYAxisTicks() {
    var yAxisId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $c24339571f507656$export$e43f7367e579f53d);
    return (0, $a441e801d1b41b52$export$a7347740d65f620b)((state)=>(0, $223cdb002ac9c48b$export$9cc7232c10fac9e)(state, 'yAxis', yAxisId));
};
var $1a51fe639a3ac8a2$export$9f4a01b20b9d273d = function useCartesianScale(dataPoint) {
    var xAxisId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $c24339571f507656$export$e43f7367e579f53d);
    var yAxisId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, $c24339571f507656$export$e43f7367e579f53d);
    var xScale = $1a51fe639a3ac8a2$export$19e28dcc217b2190(xAxisId);
    var yScale = $1a51fe639a3ac8a2$export$ec25c907e4f5439d(yAxisId);
    if (xScale == null || yScale == null) return undefined;
    var pixelX = xScale(dataPoint.x);
    var pixelY = yScale(dataPoint.y);
    if (pixelX == null || pixelY == null) return undefined;
    return {
        x: pixelX,
        y: pixelY
    };
};
var $1a51fe639a3ac8a2$export$44023ffa3b5a8134 = ()=>{
    return (0, $a441e801d1b41b52$export$a7347740d65f620b)((0, $dbde609d2e66e7f4$export$400c35cc3b9a0487));
};
var $1a51fe639a3ac8a2$export$99e5207fa7e69f17 = ()=>{
    return (0, $a441e801d1b41b52$export$a7347740d65f620b)((0, $6033e98ef2b10d0f$export$623d7e312118b313));
};
var $1a51fe639a3ac8a2$export$f1ef8efc9ef6fe0c = ()=>{
    return (0, $a441e801d1b41b52$export$a7347740d65f620b)((0, $dc9550783f23448f$export$8a921ed356911d9a));
};
var $1a51fe639a3ac8a2$export$a5935a9f8709ac28 = ()=>{
    return (0, $a441e801d1b41b52$export$a7347740d65f620b)((0, $dbde609d2e66e7f4$export$1a5b9bd341ad5f0e));
};
var $1a51fe639a3ac8a2$export$fef606eda509da71 = function useXAxisDomain() {
    var xAxisId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $c24339571f507656$export$e43f7367e579f53d);
    var isPanorama = (0, $10d1d693b6b228cd$export$4b0c59f8845ba920)();
    return (0, $a441e801d1b41b52$export$a7347740d65f620b)((state)=>(0, $223cdb002ac9c48b$export$4fc5ecb5227dd744)(state, 'xAxis', xAxisId, isPanorama));
};
var $1a51fe639a3ac8a2$export$530156bda5a6e0b8 = function useYAxisDomain() {
    var yAxisId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $c24339571f507656$export$e43f7367e579f53d);
    var isPanorama = (0, $10d1d693b6b228cd$export$4b0c59f8845ba920)();
    return (0, $a441e801d1b41b52$export$a7347740d65f620b)((state)=>(0, $223cdb002ac9c48b$export$4fc5ecb5227dd744)(state, 'yAxis', yAxisId, isPanorama));
};
var $1a51fe639a3ac8a2$export$664a603ccf171b5e = ()=>{
    var _useAppSelector;
    return (_useAppSelector = (0, $a441e801d1b41b52$export$a7347740d65f620b)((0, $dbde609d2e66e7f4$export$c8884ed37796034a))) !== null && _useAppSelector !== void 0 ? _useAppSelector : false;
};
var $1a51fe639a3ac8a2$export$c6c562f11dfccde2 = ()=>{
    var coordinate = (0, $a441e801d1b41b52$export$a7347740d65f620b)((0, $dbde609d2e66e7f4$export$90c565a5b196e427));
    if (coordinate == null) return undefined;
    return {
        x: coordinate.x,
        y: coordinate.y
    };
};


function $a81188c028cebd88$export$79e142f66441c204(xAxisId, yAxisId) {
    var _xAxis$allowDataOverf, _yAxis$allowDataOverf;
    var xAxis = (0, $a441e801d1b41b52$export$a7347740d65f620b)((state)=>(0, $223cdb002ac9c48b$export$d6895d8ddb4cee5)(state, xAxisId));
    var yAxis = (0, $a441e801d1b41b52$export$a7347740d65f620b)((state)=>(0, $223cdb002ac9c48b$export$1f472705a332f1c9)(state, yAxisId));
    var needClipX = (_xAxis$allowDataOverf = xAxis === null || xAxis === void 0 ? void 0 : xAxis.allowDataOverflow) !== null && _xAxis$allowDataOverf !== void 0 ? _xAxis$allowDataOverf : (0, $223cdb002ac9c48b$export$21aec091b6ac8422).allowDataOverflow;
    var needClipY = (_yAxis$allowDataOverf = yAxis === null || yAxis === void 0 ? void 0 : yAxis.allowDataOverflow) !== null && _yAxis$allowDataOverf !== void 0 ? _yAxis$allowDataOverf : (0, $223cdb002ac9c48b$export$397148de2ecdec3c).allowDataOverflow;
    var needClip = needClipX || needClipY;
    return {
        needClip: needClip,
        needClipX: needClipX,
        needClipY: needClipY
    };
}
function $a81188c028cebd88$export$d65f7a7dd82fbb63(_ref) {
    var { xAxisId: xAxisId, yAxisId: yAxisId, clipPathId: clipPathId } = _ref;
    var plotArea = (0, $1a51fe639a3ac8a2$export$f1ef8efc9ef6fe0c)();
    var { needClipX: needClipX, needClipY: needClipY, needClip: needClip } = $a81188c028cebd88$export$79e142f66441c204(xAxisId, yAxisId);
    if (!needClip || !plotArea) return null;
    var { x: x, y: y, width: width, height: height } = plotArea;
    return /*#__PURE__*/ $kc00y.createElement("clipPath", {
        id: "clipPath-".concat(clipPathId)
    }, /*#__PURE__*/ $kc00y.createElement("rect", {
        x: needClipX ? x : x - width / 2,
        y: needClipY ? y : y - height / 2,
        width: needClipX ? width : width * 2,
        height: needClipY ? height : height * 2
    }));
}














var $2ef485fd0463b63f$var$getBarSize = (globalSize, totalSize, selfSize)=>{
    var barSize = selfSize !== null && selfSize !== void 0 ? selfSize : globalSize;
    if ((0, $7e613228d3a31273$export$b931b78cbb3caf86)(barSize)) return undefined;
    return (0, $7e613228d3a31273$export$476354dbf49bdff6)(barSize, totalSize, 0);
};
var $2ef485fd0463b63f$export$fa5aca2cbc42e692 = (allBars, globalSize, totalSize)=>{
    var initialValue = {};
    var stackedBars = allBars.filter((0, $66614bffc4581796$export$2335dd91cc88053e));
    var unstackedBars = allBars.filter((b)=>b.stackId == null);
    var groupByStack = stackedBars.reduce((acc, bar)=>{
        var s = acc[bar.stackId];
        if (s == null) s = [];
        s.push(bar);
        acc[bar.stackId] = s;
        return acc;
    }, initialValue);
    var stackedSizeList = Object.entries(groupByStack).map((_ref)=>{
        var _bars$;
        var [stackId, bars] = _ref;
        var dataKeys = bars.map((b)=>b.dataKey);
        var barSize = $2ef485fd0463b63f$var$getBarSize(globalSize, totalSize, (_bars$ = bars[0]) === null || _bars$ === void 0 ? void 0 : _bars$.barSize);
        return {
            stackId: stackId,
            dataKeys: dataKeys,
            barSize: barSize
        };
    });
    var unstackedSizeList = unstackedBars.map((b)=>{
        var dataKeys = [
            b.dataKey
        ].filter((dk)=>dk != null);
        var barSize = $2ef485fd0463b63f$var$getBarSize(globalSize, totalSize, b.barSize);
        return {
            stackId: undefined,
            dataKeys: dataKeys,
            barSize: barSize
        };
    });
    return [
        ...stackedSizeList,
        ...unstackedSizeList
    ];
};




function $6340ca09d368e860$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6340ca09d368e860$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6340ca09d368e860$var$ownKeys(Object(t), !0).forEach(function(r) {
            $6340ca09d368e860$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6340ca09d368e860$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $6340ca09d368e860$var$_defineProperty(e, r, t) {
    return (r = $6340ca09d368e860$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $6340ca09d368e860$var$_toPropertyKey(t) {
    var i = $6340ca09d368e860$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $6340ca09d368e860$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $6340ca09d368e860$var$getBarPositions(barGap, barCategoryGap, bandSize, sizeList, maxBarSize) {
    var _sizeList$;
    var len = sizeList.length;
    if (len < 1) return undefined;
    var realBarGap = (0, $7e613228d3a31273$export$476354dbf49bdff6)(barGap, bandSize, 0, true);
    var result;
    var initialValue = [];
    // whether is barSize set by user
    // Okay but why does it check only for the first element? What if the first element is set but others are not?
    if ((0, $22869ac8a5888437$export$f8a8fc612ced9bb0)((_sizeList$ = sizeList[0]) === null || _sizeList$ === void 0 ? void 0 : _sizeList$.barSize)) {
        var useFull = false;
        var fullBarSize = bandSize / len;
        var sum = sizeList.reduce((res, entry)=>res + (entry.barSize || 0), 0);
        sum += (len - 1) * realBarGap;
        if (sum >= bandSize) {
            sum -= (len - 1) * realBarGap;
            realBarGap = 0;
        }
        if (sum >= bandSize && fullBarSize > 0) {
            useFull = true;
            fullBarSize *= 0.9;
            sum = len * fullBarSize;
        }
        var offset = (bandSize - sum) / 2 >> 0;
        var prev = {
            offset: offset - realBarGap,
            size: 0
        };
        result = sizeList.reduce((res, entry)=>{
            var _entry$barSize;
            var newPosition = {
                stackId: entry.stackId,
                dataKeys: entry.dataKeys,
                position: {
                    offset: prev.offset + prev.size + realBarGap,
                    size: useFull ? fullBarSize : (_entry$barSize = entry.barSize) !== null && _entry$barSize !== void 0 ? _entry$barSize : 0
                }
            };
            var newRes = [
                ...res,
                newPosition
            ];
            prev = newPosition.position;
            return newRes;
        }, initialValue);
    } else {
        var _offset = (0, $7e613228d3a31273$export$476354dbf49bdff6)(barCategoryGap, bandSize, 0, true);
        if (bandSize - 2 * _offset - (len - 1) * realBarGap <= 0) realBarGap = 0;
        var originalSize = (bandSize - 2 * _offset - (len - 1) * realBarGap) / len;
        if (originalSize > 1) originalSize >>= 0;
        var size = (0, $22869ac8a5888437$export$f8a8fc612ced9bb0)(maxBarSize) ? Math.min(originalSize, maxBarSize) : originalSize;
        result = sizeList.reduce((res, entry, i)=>[
                ...res,
                {
                    stackId: entry.stackId,
                    dataKeys: entry.dataKeys,
                    position: {
                        offset: _offset + (originalSize + realBarGap) * i + (originalSize - size) / 2,
                        size: size
                    }
                }
            ], initialValue);
    }
    return result;
}
var $6340ca09d368e860$export$5068ec6da13c95bb = (sizeList, globalMaxBarSize, barGap, barCategoryGap, barBandSize, bandSize, childMaxBarSize)=>{
    var maxBarSize = (0, $7e613228d3a31273$export$b931b78cbb3caf86)(childMaxBarSize) ? globalMaxBarSize : childMaxBarSize;
    var allBarPositions = $6340ca09d368e860$var$getBarPositions(barGap, barCategoryGap, barBandSize !== bandSize ? barBandSize : bandSize, sizeList, maxBarSize);
    if (barBandSize !== bandSize && allBarPositions != null) allBarPositions = allBarPositions.map((pos)=>$6340ca09d368e860$var$_objectSpread($6340ca09d368e860$var$_objectSpread({}, pos), {}, {
            position: $6340ca09d368e860$var$_objectSpread($6340ca09d368e860$var$_objectSpread({}, pos.position), {}, {
                offset: pos.position.offset - barBandSize / 2
            })
        }));
    return allBarPositions;
};



var $627de1d9c7288a05$export$66625d959aa66f0f = (stackGroups, barSettings)=>{
    var stackSeriesIdentifier = (0, $a7f2a68891925785$export$58b095b87bc46727)(barSettings);
    if (!stackGroups || stackSeriesIdentifier == null || barSettings == null) return undefined;
    var { stackId: stackId } = barSettings;
    if (stackId == null) return undefined;
    var stackGroup = stackGroups[stackId];
    if (!stackGroup) return undefined;
    var { stackedData: stackedData } = stackGroup;
    if (!stackedData) return undefined;
    return stackedData.find((sd)=>sd.key === stackSeriesIdentifier);
};



function $7d6f720c9fc9a7a0$export$eea16fee3026d9cf(state, id) {
    var _state$graphicalItems, _state$graphicalItems2;
    return (_state$graphicalItems = (_state$graphicalItems2 = state.graphicalItems.cartesianItems.find((item)=>item.id === id)) === null || _state$graphicalItems2 === void 0 ? void 0 : _state$graphicalItems2.xAxisId) !== null && _state$graphicalItems !== void 0 ? _state$graphicalItems : (0, $c24339571f507656$export$e43f7367e579f53d);
}
function $7d6f720c9fc9a7a0$export$5babc813f7c13fff(state, id) {
    var _state$graphicalItems3, _state$graphicalItems4;
    return (_state$graphicalItems3 = (_state$graphicalItems4 = state.graphicalItems.cartesianItems.find((item)=>item.id === id)) === null || _state$graphicalItems4 === void 0 ? void 0 : _state$graphicalItems4.yAxisId) !== null && _state$graphicalItems3 !== void 0 ? _state$graphicalItems3 : (0, $c24339571f507656$export$e43f7367e579f53d);
}


var $755c88b161afa59d$export$77fea8543499527d = (allBarPositions, barSettings)=>{
    if (allBarPositions == null || barSettings == null) return undefined;
    var position = allBarPositions.find((p)=>p.stackId === barSettings.stackId && barSettings.dataKey != null && p.dataKeys.includes(barSettings.dataKey));
    if (position == null) return undefined;
    return position.position;
};


var $f7cdddd408b98c5e$var$pickIsPanorama = (_state, _id, isPanorama)=>isPanorama;
var $f7cdddd408b98c5e$var$pickBarId = (_state, id)=>id;
var $f7cdddd408b98c5e$var$selectSynchronisedBarSettings = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    (0, $223cdb002ac9c48b$export$f67c737adf41a3af),
    $f7cdddd408b98c5e$var$pickBarId
], (graphicalItems, id)=>graphicalItems.filter((item)=>item.type === 'bar').find((item)=>item.id === id));
var $f7cdddd408b98c5e$export$50baca3091205310 = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $f7cdddd408b98c5e$var$selectSynchronisedBarSettings
], (barSettings)=>barSettings === null || barSettings === void 0 ? void 0 : barSettings.maxBarSize);
var $f7cdddd408b98c5e$var$pickCells = (_state, _id, _isPanorama, cells)=>cells;
var $f7cdddd408b98c5e$export$bf2e7c2f01f3feee = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    (0, $f4c9341f05a18477$export$8426b6d9af801dee),
    (0, $223cdb002ac9c48b$export$f67c737adf41a3af),
    (0, $7d6f720c9fc9a7a0$export$eea16fee3026d9cf),
    (0, $7d6f720c9fc9a7a0$export$5babc813f7c13fff),
    $f7cdddd408b98c5e$var$pickIsPanorama
], (layout, allItems, xAxisId, yAxisId, isPanorama)=>allItems.filter((i)=>{
        if (layout === 'horizontal') return i.xAxisId === xAxisId;
        return i.yAxisId === yAxisId;
    }).filter((i)=>i.isPanorama === isPanorama).filter((i)=>i.hide === false).filter((i)=>i.type === 'bar'));
var $f7cdddd408b98c5e$var$selectBarStackGroups = (state, id, isPanorama)=>{
    var layout = (0, $f4c9341f05a18477$export$8426b6d9af801dee)(state);
    var xAxisId = (0, $7d6f720c9fc9a7a0$export$eea16fee3026d9cf)(state, id);
    var yAxisId = (0, $7d6f720c9fc9a7a0$export$5babc813f7c13fff)(state, id);
    if (xAxisId == null || yAxisId == null) return undefined;
    if (layout === 'horizontal') return (0, $223cdb002ac9c48b$export$af2278e5e47fc440)(state, 'yAxis', yAxisId, isPanorama);
    return (0, $223cdb002ac9c48b$export$af2278e5e47fc440)(state, 'xAxis', xAxisId, isPanorama);
};
var $f7cdddd408b98c5e$export$d463f1583eab6c4c = (state, id)=>{
    var layout = (0, $f4c9341f05a18477$export$8426b6d9af801dee)(state);
    var xAxisId = (0, $7d6f720c9fc9a7a0$export$eea16fee3026d9cf)(state, id);
    var yAxisId = (0, $7d6f720c9fc9a7a0$export$5babc813f7c13fff)(state, id);
    if (xAxisId == null || yAxisId == null) return undefined;
    if (layout === 'horizontal') return (0, $223cdb002ac9c48b$export$6d6e642aa7a0ae10)(state, 'xAxis', xAxisId);
    return (0, $223cdb002ac9c48b$export$6d6e642aa7a0ae10)(state, 'yAxis', yAxisId);
};
var $f7cdddd408b98c5e$export$2ef868bbad239fe0 = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $f7cdddd408b98c5e$export$bf2e7c2f01f3feee,
    (0, $1728a742f9386be1$export$be00206a4a82272f),
    $f7cdddd408b98c5e$export$d463f1583eab6c4c
], (0, $2ef485fd0463b63f$export$fa5aca2cbc42e692));
var $f7cdddd408b98c5e$export$32ce49801f050c73 = (state, id, isPanorama)=>{
    var _ref, _getBandSizeOfAxis;
    var barSettings = $f7cdddd408b98c5e$var$selectSynchronisedBarSettings(state, id);
    if (barSettings == null) return 0;
    var xAxisId = (0, $7d6f720c9fc9a7a0$export$eea16fee3026d9cf)(state, id);
    var yAxisId = (0, $7d6f720c9fc9a7a0$export$5babc813f7c13fff)(state, id);
    if (xAxisId == null || yAxisId == null) return 0;
    var layout = (0, $f4c9341f05a18477$export$8426b6d9af801dee)(state);
    var globalMaxBarSize = (0, $1728a742f9386be1$export$db43f3089e0ec1e9)(state);
    var { maxBarSize: childMaxBarSize } = barSettings;
    var maxBarSize = (0, $7e613228d3a31273$export$b931b78cbb3caf86)(childMaxBarSize) ? globalMaxBarSize : childMaxBarSize;
    var axis, ticks;
    if (layout === 'horizontal') {
        axis = (0, $223cdb002ac9c48b$export$db36c2f3bfe5c9d7)(state, 'xAxis', xAxisId, isPanorama);
        ticks = (0, $223cdb002ac9c48b$export$b894cb5d8586b43d)(state, 'xAxis', xAxisId, isPanorama);
    } else {
        axis = (0, $223cdb002ac9c48b$export$db36c2f3bfe5c9d7)(state, 'yAxis', yAxisId, isPanorama);
        ticks = (0, $223cdb002ac9c48b$export$b894cb5d8586b43d)(state, 'yAxis', yAxisId, isPanorama);
    }
    return (_ref = (_getBandSizeOfAxis = (0, $d5958b0668c58531$export$212ec45c42fe68a7)(axis, ticks, true)) !== null && _getBandSizeOfAxis !== void 0 ? _getBandSizeOfAxis : maxBarSize) !== null && _ref !== void 0 ? _ref : 0;
};
var $f7cdddd408b98c5e$export$bc27c715442861c7 = (state, id, isPanorama)=>{
    var layout = (0, $f4c9341f05a18477$export$8426b6d9af801dee)(state);
    var xAxisId = (0, $7d6f720c9fc9a7a0$export$eea16fee3026d9cf)(state, id);
    var yAxisId = (0, $7d6f720c9fc9a7a0$export$5babc813f7c13fff)(state, id);
    if (xAxisId == null || yAxisId == null) return undefined;
    var axis, ticks;
    if (layout === 'horizontal') {
        axis = (0, $223cdb002ac9c48b$export$db36c2f3bfe5c9d7)(state, 'xAxis', xAxisId, isPanorama);
        ticks = (0, $223cdb002ac9c48b$export$b894cb5d8586b43d)(state, 'xAxis', xAxisId, isPanorama);
    } else {
        axis = (0, $223cdb002ac9c48b$export$db36c2f3bfe5c9d7)(state, 'yAxis', yAxisId, isPanorama);
        ticks = (0, $223cdb002ac9c48b$export$b894cb5d8586b43d)(state, 'yAxis', yAxisId, isPanorama);
    }
    return (0, $d5958b0668c58531$export$212ec45c42fe68a7)(axis, ticks);
};
var $f7cdddd408b98c5e$export$d5f086f9524dc338 = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $f7cdddd408b98c5e$export$2ef868bbad239fe0,
    (0, $1728a742f9386be1$export$db43f3089e0ec1e9),
    (0, $1728a742f9386be1$export$9b8e3d53e72fb7a8),
    (0, $1728a742f9386be1$export$a73f9d39b015942a),
    $f7cdddd408b98c5e$export$32ce49801f050c73,
    $f7cdddd408b98c5e$export$bc27c715442861c7,
    $f7cdddd408b98c5e$export$50baca3091205310
], (0, $6340ca09d368e860$export$5068ec6da13c95bb));
var $f7cdddd408b98c5e$var$selectXAxisWithScale = (state, id, isPanorama)=>{
    var xAxisId = (0, $7d6f720c9fc9a7a0$export$eea16fee3026d9cf)(state, id);
    if (xAxisId == null) return undefined;
    return (0, $223cdb002ac9c48b$export$db36c2f3bfe5c9d7)(state, 'xAxis', xAxisId, isPanorama);
};
var $f7cdddd408b98c5e$var$selectYAxisWithScale = (state, id, isPanorama)=>{
    var yAxisId = (0, $7d6f720c9fc9a7a0$export$5babc813f7c13fff)(state, id);
    if (yAxisId == null) return undefined;
    return (0, $223cdb002ac9c48b$export$db36c2f3bfe5c9d7)(state, 'yAxis', yAxisId, isPanorama);
};
var $f7cdddd408b98c5e$var$selectXAxisTicks = (state, id, isPanorama)=>{
    var xAxisId = (0, $7d6f720c9fc9a7a0$export$eea16fee3026d9cf)(state, id);
    if (xAxisId == null) return undefined;
    return (0, $223cdb002ac9c48b$export$b894cb5d8586b43d)(state, 'xAxis', xAxisId, isPanorama);
};
var $f7cdddd408b98c5e$var$selectYAxisTicks = (state, id, isPanorama)=>{
    var yAxisId = (0, $7d6f720c9fc9a7a0$export$5babc813f7c13fff)(state, id);
    if (yAxisId == null) return undefined;
    return (0, $223cdb002ac9c48b$export$b894cb5d8586b43d)(state, 'yAxis', yAxisId, isPanorama);
};
var $f7cdddd408b98c5e$export$713ac88b203ac3be = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $f7cdddd408b98c5e$export$d5f086f9524dc338,
    $f7cdddd408b98c5e$var$selectSynchronisedBarSettings
], (0, $755c88b161afa59d$export$77fea8543499527d));
var $f7cdddd408b98c5e$export$bb6e63f631e695ca = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $f7cdddd408b98c5e$var$selectBarStackGroups,
    $f7cdddd408b98c5e$var$selectSynchronisedBarSettings
], (0, $627de1d9c7288a05$export$66625d959aa66f0f));
var $f7cdddd408b98c5e$export$bb89ca2d15dbced9 = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    (0, $cd6092f0bbb953fd$export$1e34c8efb0bc9b3b),
    (0, $cd6092f0bbb953fd$export$32c8e778bac69ce4),
    $f7cdddd408b98c5e$var$selectXAxisWithScale,
    $f7cdddd408b98c5e$var$selectYAxisWithScale,
    $f7cdddd408b98c5e$var$selectXAxisTicks,
    $f7cdddd408b98c5e$var$selectYAxisTicks,
    $f7cdddd408b98c5e$export$713ac88b203ac3be,
    (0, $f4c9341f05a18477$export$8426b6d9af801dee),
    (0, $8c22b3d5bf36186c$export$46bf9459876c0e0c),
    $f7cdddd408b98c5e$export$bc27c715442861c7,
    $f7cdddd408b98c5e$export$bb6e63f631e695ca,
    $f7cdddd408b98c5e$var$selectSynchronisedBarSettings,
    $f7cdddd408b98c5e$var$pickCells
], (offset, axisViewBox, xAxis, yAxis, xAxisTicks, yAxisTicks, pos, layout, _ref2, bandSize, stackedData, barSettings, cells)=>{
    var { chartData: chartData, dataStartIndex: dataStartIndex, dataEndIndex: dataEndIndex } = _ref2;
    if (barSettings == null || pos == null || axisViewBox == null || layout !== 'horizontal' && layout !== 'vertical' || xAxis == null || yAxis == null || xAxisTicks == null || yAxisTicks == null || bandSize == null) return undefined;
    var { data: data } = barSettings;
    var displayedData;
    if (data != null && data.length > 0) displayedData = data;
    else displayedData = chartData === null || chartData === void 0 ? void 0 : chartData.slice(dataStartIndex, dataEndIndex + 1);
    if (displayedData == null) return undefined;
    return (0, $ec65bf22e0d120c5$export$3b2ba7a38b022e)({
        layout: layout,
        barSettings: barSettings,
        pos: pos,
        parentViewBox: axisViewBox,
        bandSize: bandSize,
        xAxis: xAxis,
        yAxis: yAxis,
        xAxisTicks: xAxisTicks,
        yAxisTicks: yAxisTicks,
        stackedData: stackedData,
        displayedData: displayedData,
        offset: offset,
        cells: cells,
        dataStartIndex: dataStartIndex
    });
});






var $kc00y = parcelRequire("kc00y");





/**
 * The properties inside this state update independently of each other and quite often.
 * When selecting, never select the whole state because you are going to get
 * unnecessary re-renders. Select only the properties you need.
 *
 * This is why this state type is not exported - don't use it directly.
 */ var $9cbabae4d819cbf3$var$initialState = {
    settings: {
        layout: 'horizontal',
        align: 'center',
        verticalAlign: 'middle',
        itemSorter: 'value'
    },
    size: {
        width: 0,
        height: 0
    },
    payload: []
};
var $9cbabae4d819cbf3$var$legendSlice = (0, $df8b6ce3f4df1ba5$export$4d8d9bd83c24ae8b)({
    name: 'legend',
    initialState: $9cbabae4d819cbf3$var$initialState,
    reducers: {
        setLegendSize (state, action) {
            state.size.width = action.payload.width;
            state.size.height = action.payload.height;
        },
        setLegendSettings (state, action) {
            state.settings.align = action.payload.align;
            state.settings.layout = action.payload.layout;
            state.settings.verticalAlign = action.payload.verticalAlign;
            state.settings.itemSorter = action.payload.itemSorter;
        },
        addLegendPayload: {
            reducer (state, action) {
                state.payload.push((0, $808ce0820c1669b6$export$c05b21e3257751e5)(action.payload));
            },
            prepare: (0, $df8b6ce3f4df1ba5$export$39fcd5145ec5e4e2)()
        },
        replaceLegendPayload: {
            reducer (state, action) {
                var { prev: prev, next: next } = action.payload;
                var index = (0, $e922645e3176d997$export$97aac956da55dae9)(state).payload.indexOf((0, $808ce0820c1669b6$export$c05b21e3257751e5)(prev));
                if (index > -1) state.payload[index] = (0, $808ce0820c1669b6$export$c05b21e3257751e5)(next);
            },
            prepare: (0, $df8b6ce3f4df1ba5$export$39fcd5145ec5e4e2)()
        },
        removeLegendPayload: {
            reducer (state, action) {
                var index = (0, $e922645e3176d997$export$97aac956da55dae9)(state).payload.indexOf((0, $808ce0820c1669b6$export$c05b21e3257751e5)(action.payload));
                if (index > -1) state.payload.splice(index, 1);
            },
            prepare: (0, $df8b6ce3f4df1ba5$export$39fcd5145ec5e4e2)()
        }
    }
});
var { setLegendSize: $9cbabae4d819cbf3$export$f9ba9ab9b90c340e, setLegendSettings: $9cbabae4d819cbf3$export$a1a647a9c0dcc839, addLegendPayload: $9cbabae4d819cbf3$export$236fd33b6ffe3f4b, replaceLegendPayload: $9cbabae4d819cbf3$export$379d42d798953c3d, removeLegendPayload: $9cbabae4d819cbf3$export$337e5f2bb3b9e128 } = $9cbabae4d819cbf3$var$legendSlice.actions;
var $9cbabae4d819cbf3$export$8d8dfb8d5acf8179 = $9cbabae4d819cbf3$var$legendSlice.reducer;


function $969c2df561fbe708$export$34b61b169492c008(_ref) {
    var { legendPayload: legendPayload } = _ref;
    var dispatch = (0, $a441e801d1b41b52$export$f51d452c10d5b956)();
    var isPanorama = (0, $10d1d693b6b228cd$export$4b0c59f8845ba920)();
    var prevPayloadRef = (0, $kc00y.useRef)(null);
    (0, $kc00y.useLayoutEffect)(()=>{
        if (isPanorama) return;
        if (prevPayloadRef.current === null) dispatch((0, $9cbabae4d819cbf3$export$236fd33b6ffe3f4b)(legendPayload));
        else if (prevPayloadRef.current !== legendPayload) dispatch((0, $9cbabae4d819cbf3$export$379d42d798953c3d)({
            prev: prevPayloadRef.current,
            next: legendPayload
        }));
        prevPayloadRef.current = legendPayload;
    }, [
        dispatch,
        isPanorama,
        legendPayload
    ]);
    (0, $kc00y.useLayoutEffect)(()=>{
        return ()=>{
            if (prevPayloadRef.current) {
                dispatch((0, $9cbabae4d819cbf3$export$337e5f2bb3b9e128)(prevPayloadRef.current));
                prevPayloadRef.current = null;
            }
        };
    }, [
        dispatch
    ]);
    return null;
}
function $969c2df561fbe708$export$eb937fedea4aab3a(_ref2) {
    var { legendPayload: legendPayload } = _ref2;
    var dispatch = (0, $a441e801d1b41b52$export$f51d452c10d5b956)();
    var layout = (0, $a441e801d1b41b52$export$a7347740d65f620b)((0, $f4c9341f05a18477$export$8426b6d9af801dee));
    var prevPayloadRef = (0, $kc00y.useRef)(null);
    (0, $kc00y.useLayoutEffect)(()=>{
        if (layout !== 'centric' && layout !== 'radial') return;
        if (prevPayloadRef.current === null) dispatch((0, $9cbabae4d819cbf3$export$236fd33b6ffe3f4b)(legendPayload));
        else if (prevPayloadRef.current !== legendPayload) dispatch((0, $9cbabae4d819cbf3$export$379d42d798953c3d)({
            prev: prevPayloadRef.current,
            next: legendPayload
        }));
        prevPayloadRef.current = legendPayload;
    }, [
        dispatch,
        layout,
        legendPayload
    ]);
    (0, $kc00y.useLayoutEffect)(()=>{
        return ()=>{
            if (prevPayloadRef.current) {
                dispatch((0, $9cbabae4d819cbf3$export$337e5f2bb3b9e128)(prevPayloadRef.current));
                prevPayloadRef.current = null;
            }
        };
    }, [
        dispatch
    ]);
    return null;
}






var $kc00y = parcelRequire("kc00y");



/**
 * Unique ID of the graphical item.
 * This is used to identify the graphical item in the state and in the React tree.
 * This is required for every graphical item - it's either provided by the user or generated automatically.
 */ var $fe3ae76395e8f2af$var$initialState = {
    cartesianItems: [],
    polarItems: []
};
var $fe3ae76395e8f2af$var$graphicalItemsSlice = (0, $df8b6ce3f4df1ba5$export$4d8d9bd83c24ae8b)({
    name: 'graphicalItems',
    initialState: $fe3ae76395e8f2af$var$initialState,
    reducers: {
        addCartesianGraphicalItem: {
            reducer (state, action) {
                state.cartesianItems.push((0, $808ce0820c1669b6$export$c05b21e3257751e5)(action.payload));
            },
            prepare: (0, $df8b6ce3f4df1ba5$export$39fcd5145ec5e4e2)()
        },
        replaceCartesianGraphicalItem: {
            reducer (state, action) {
                var { prev: prev, next: next } = action.payload;
                var index = (0, $e922645e3176d997$export$97aac956da55dae9)(state).cartesianItems.indexOf((0, $808ce0820c1669b6$export$c05b21e3257751e5)(prev));
                if (index > -1) state.cartesianItems[index] = (0, $808ce0820c1669b6$export$c05b21e3257751e5)(next);
            },
            prepare: (0, $df8b6ce3f4df1ba5$export$39fcd5145ec5e4e2)()
        },
        removeCartesianGraphicalItem: {
            reducer (state, action) {
                var index = (0, $e922645e3176d997$export$97aac956da55dae9)(state).cartesianItems.indexOf((0, $808ce0820c1669b6$export$c05b21e3257751e5)(action.payload));
                if (index > -1) state.cartesianItems.splice(index, 1);
            },
            prepare: (0, $df8b6ce3f4df1ba5$export$39fcd5145ec5e4e2)()
        },
        addPolarGraphicalItem: {
            reducer (state, action) {
                state.polarItems.push((0, $808ce0820c1669b6$export$c05b21e3257751e5)(action.payload));
            },
            prepare: (0, $df8b6ce3f4df1ba5$export$39fcd5145ec5e4e2)()
        },
        removePolarGraphicalItem: {
            reducer (state, action) {
                var index = (0, $e922645e3176d997$export$97aac956da55dae9)(state).polarItems.indexOf((0, $808ce0820c1669b6$export$c05b21e3257751e5)(action.payload));
                if (index > -1) state.polarItems.splice(index, 1);
            },
            prepare: (0, $df8b6ce3f4df1ba5$export$39fcd5145ec5e4e2)()
        },
        replacePolarGraphicalItem: {
            reducer (state, action) {
                var { prev: prev, next: next } = action.payload;
                var index = (0, $e922645e3176d997$export$97aac956da55dae9)(state).polarItems.indexOf((0, $808ce0820c1669b6$export$c05b21e3257751e5)(prev));
                if (index > -1) state.polarItems[index] = (0, $808ce0820c1669b6$export$c05b21e3257751e5)(next);
            },
            prepare: (0, $df8b6ce3f4df1ba5$export$39fcd5145ec5e4e2)()
        }
    }
});
var { addCartesianGraphicalItem: $fe3ae76395e8f2af$export$3f947cc833f5129c, replaceCartesianGraphicalItem: $fe3ae76395e8f2af$export$5e4d82f2e2775795, removeCartesianGraphicalItem: $fe3ae76395e8f2af$export$cc47a48755a91e1a, addPolarGraphicalItem: $fe3ae76395e8f2af$export$468d47d44d0e088f, removePolarGraphicalItem: $fe3ae76395e8f2af$export$77442a5b47e92750, replacePolarGraphicalItem: $fe3ae76395e8f2af$export$bf660020894c8833 } = $fe3ae76395e8f2af$var$graphicalItemsSlice.actions;
var $fe3ae76395e8f2af$export$183eecd5cb7dbb38 = $fe3ae76395e8f2af$var$graphicalItemsSlice.reducer;


var $b22a299c3f7b2080$var$SetCartesianGraphicalItemImpl = (props)=>{
    var dispatch = (0, $a441e801d1b41b52$export$f51d452c10d5b956)();
    var prevPropsRef = (0, $kc00y.useRef)(null);
    (0, $kc00y.useLayoutEffect)(()=>{
        if (prevPropsRef.current === null) dispatch((0, $fe3ae76395e8f2af$export$3f947cc833f5129c)(props));
        else if (prevPropsRef.current !== props) dispatch((0, $fe3ae76395e8f2af$export$5e4d82f2e2775795)({
            prev: prevPropsRef.current,
            next: props
        }));
        prevPropsRef.current = props;
    }, [
        dispatch,
        props
    ]);
    (0, $kc00y.useLayoutEffect)(()=>{
        return ()=>{
            if (prevPropsRef.current) {
                dispatch((0, $fe3ae76395e8f2af$export$cc47a48755a91e1a)(prevPropsRef.current));
                /*
         * Here we have to reset the ref to null because in StrictMode, the effect will run twice,
         * but it will keep the same ref value from the first render.
         *
         * In browser, React will clear the ref after the first effect cleanup,
         * so that wouldn't be an issue.
         *
         * In StrictMode, however, the ref is kept,
         * and in the hook above the code checks for `prevPropsRef.current === null`
         * which would be false so it would not dispatch the `addCartesianGraphicalItem` action again.
         *
         * https://github.com/recharts/recharts/issues/6022
         */ prevPropsRef.current = null;
            }
        };
    }, [
        dispatch
    ]);
    return null;
};
var $b22a299c3f7b2080$export$b600bf9c1966a9c2 = /*#__PURE__*/ (0, $kc00y.memo)($b22a299c3f7b2080$var$SetCartesianGraphicalItemImpl);
var $b22a299c3f7b2080$var$SetPolarGraphicalItemImpl = (props)=>{
    var dispatch = (0, $a441e801d1b41b52$export$f51d452c10d5b956)();
    var prevPropsRef = (0, $kc00y.useRef)(null);
    (0, $kc00y.useLayoutEffect)(()=>{
        if (prevPropsRef.current === null) dispatch((0, $fe3ae76395e8f2af$export$468d47d44d0e088f)(props));
        else if (prevPropsRef.current !== props) dispatch((0, $fe3ae76395e8f2af$export$bf660020894c8833)({
            prev: prevPropsRef.current,
            next: props
        }));
        prevPropsRef.current = props;
    }, [
        dispatch,
        props
    ]);
    (0, $kc00y.useLayoutEffect)(()=>{
        return ()=>{
            if (prevPropsRef.current) {
                dispatch((0, $fe3ae76395e8f2af$export$77442a5b47e92750)(prevPropsRef.current));
                prevPropsRef.current = null;
            }
        };
    }, [
        dispatch
    ]);
    return null;
};
var $b22a299c3f7b2080$export$8d7124402ca6b71c = /*#__PURE__*/ (0, $kc00y.memo)($b22a299c3f7b2080$var$SetPolarGraphicalItemImpl);







function $8449b02e7702819c$export$384f306fbc0d3ce9(input, defaultZIndex) {
    if (input && typeof input === 'object' && 'zIndex' in input && typeof input.zIndex === 'number' && (0, $22869ac8a5888437$export$f8a8fc612ced9bb0)(input.zIndex)) return input.zIndex;
    return defaultZIndex;
}


// src/utils/react.ts

var $kc00y = parcelRequire("kc00y");
var $ea95c15f9ecd74f1$exports = {};
'use strict';

$ea95c15f9ecd74f1$exports = (parcelRequire("8Ce7t"));


// src/utils/react-is.ts
var $5b96f91a609769a4$var$IS_REACT_19 = /* @__PURE__ */ $kc00y.version.startsWith("19");
var $5b96f91a609769a4$var$REACT_ELEMENT_TYPE = /* @__PURE__ */ Symbol.for($5b96f91a609769a4$var$IS_REACT_19 ? "react.transitional.element" : "react.element");
var $5b96f91a609769a4$var$REACT_PORTAL_TYPE = /* @__PURE__ */ Symbol.for("react.portal");
var $5b96f91a609769a4$var$REACT_FRAGMENT_TYPE = /* @__PURE__ */ Symbol.for("react.fragment");
var $5b96f91a609769a4$var$REACT_STRICT_MODE_TYPE = /* @__PURE__ */ Symbol.for("react.strict_mode");
var $5b96f91a609769a4$var$REACT_PROFILER_TYPE = /* @__PURE__ */ Symbol.for("react.profiler");
var $5b96f91a609769a4$var$REACT_CONSUMER_TYPE = /* @__PURE__ */ Symbol.for("react.consumer");
var $5b96f91a609769a4$var$REACT_CONTEXT_TYPE = /* @__PURE__ */ Symbol.for("react.context");
var $5b96f91a609769a4$var$REACT_FORWARD_REF_TYPE = /* @__PURE__ */ Symbol.for("react.forward_ref");
var $5b96f91a609769a4$var$REACT_SUSPENSE_TYPE = /* @__PURE__ */ Symbol.for("react.suspense");
var $5b96f91a609769a4$var$REACT_SUSPENSE_LIST_TYPE = /* @__PURE__ */ Symbol.for("react.suspense_list");
var $5b96f91a609769a4$var$REACT_MEMO_TYPE = /* @__PURE__ */ Symbol.for("react.memo");
var $5b96f91a609769a4$var$REACT_LAZY_TYPE = /* @__PURE__ */ Symbol.for("react.lazy");
var $5b96f91a609769a4$var$REACT_OFFSCREEN_TYPE = /* @__PURE__ */ Symbol.for("react.offscreen");
var $5b96f91a609769a4$var$REACT_CLIENT_REFERENCE = /* @__PURE__ */ Symbol.for("react.client.reference");
var $5b96f91a609769a4$var$ForwardRef = $5b96f91a609769a4$var$REACT_FORWARD_REF_TYPE;
var $5b96f91a609769a4$var$Memo = $5b96f91a609769a4$var$REACT_MEMO_TYPE;
function $5b96f91a609769a4$var$isValidElementType(type) {
    return typeof type === "string" || typeof type === "function" || type === $5b96f91a609769a4$var$REACT_FRAGMENT_TYPE || type === $5b96f91a609769a4$var$REACT_PROFILER_TYPE || type === $5b96f91a609769a4$var$REACT_STRICT_MODE_TYPE || type === $5b96f91a609769a4$var$REACT_SUSPENSE_TYPE || type === $5b96f91a609769a4$var$REACT_SUSPENSE_LIST_TYPE || type === $5b96f91a609769a4$var$REACT_OFFSCREEN_TYPE || typeof type === "object" && type !== null && (type.$$typeof === $5b96f91a609769a4$var$REACT_LAZY_TYPE || type.$$typeof === $5b96f91a609769a4$var$REACT_MEMO_TYPE || type.$$typeof === $5b96f91a609769a4$var$REACT_CONTEXT_TYPE || type.$$typeof === $5b96f91a609769a4$var$REACT_CONSUMER_TYPE || type.$$typeof === $5b96f91a609769a4$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $5b96f91a609769a4$var$REACT_CLIENT_REFERENCE || type.getModuleId !== void 0) ? true : false;
}
function $5b96f91a609769a4$var$typeOf(object) {
    if (typeof object === "object" && object !== null) {
        const { $$typeof: $$typeof } = object;
        switch($$typeof){
            case $5b96f91a609769a4$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $5b96f91a609769a4$var$REACT_FRAGMENT_TYPE:
                    case $5b96f91a609769a4$var$REACT_PROFILER_TYPE:
                    case $5b96f91a609769a4$var$REACT_STRICT_MODE_TYPE:
                    case $5b96f91a609769a4$var$REACT_SUSPENSE_TYPE:
                    case $5b96f91a609769a4$var$REACT_SUSPENSE_LIST_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $5b96f91a609769a4$var$REACT_CONTEXT_TYPE:
                            case $5b96f91a609769a4$var$REACT_FORWARD_REF_TYPE:
                            case $5b96f91a609769a4$var$REACT_LAZY_TYPE:
                            case $5b96f91a609769a4$var$REACT_MEMO_TYPE:
                                return object;
                            case $5b96f91a609769a4$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $5b96f91a609769a4$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
function $5b96f91a609769a4$var$isContextConsumer(object) {
    return $5b96f91a609769a4$var$IS_REACT_19 ? $5b96f91a609769a4$var$typeOf(object) === $5b96f91a609769a4$var$REACT_CONSUMER_TYPE : $5b96f91a609769a4$var$typeOf(object) === $5b96f91a609769a4$var$REACT_CONTEXT_TYPE;
}
function $5b96f91a609769a4$var$isMemo(object) {
    return $5b96f91a609769a4$var$typeOf(object) === $5b96f91a609769a4$var$REACT_MEMO_TYPE;
}
// src/utils/warning.ts
function $5b96f91a609769a4$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/connect/verifySubselectors.ts
function $5b96f91a609769a4$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) $5b96f91a609769a4$var$warning(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $5b96f91a609769a4$var$verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps) {
    $5b96f91a609769a4$var$verify(mapStateToProps, "mapStateToProps");
    $5b96f91a609769a4$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $5b96f91a609769a4$var$verify(mergeProps, "mergeProps");
}
// src/connect/selectorFactory.ts
function $5b96f91a609769a4$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $5b96f91a609769a4$var$finalPropsSelectorFactory(dispatch, { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps, ...options }) {
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $5b96f91a609769a4$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
// src/utils/bindActionCreators.ts
function $5b96f91a609769a4$var$bindActionCreators(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}
// src/utils/isPlainObject.ts
function $5b96f91a609769a4$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    const proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/utils/verifyPlainObject.ts
function $5b96f91a609769a4$var$verifyPlainObject(value, displayName, methodName) {
    if (!$5b96f91a609769a4$var$isPlainObject(value)) $5b96f91a609769a4$var$warning(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}
// src/connect/wrapMapToProps.ts
function $5b96f91a609769a4$var$wrapMapToPropsConstant(getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
}
function $5b96f91a609769a4$var$getDependsOnOwnProps(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function $5b96f91a609769a4$var$wrapMapToPropsFunc(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, void 0);
        };
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $5b96f91a609769a4$var$getDependsOnOwnProps(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $5b96f91a609769a4$var$getDependsOnOwnProps(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}
// src/connect/invalidArgFactory.ts
function $5b96f91a609769a4$var$createInvalidArgFactory(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}
// src/connect/mapDispatchToProps.ts
function $5b96f91a609769a4$var$mapDispatchToPropsFactory(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? $5b96f91a609769a4$var$wrapMapToPropsConstant((dispatch)=>// @ts-ignore
        $5b96f91a609769a4$var$bindActionCreators(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? $5b96f91a609769a4$var$wrapMapToPropsConstant((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === "function" ? // @ts-ignore
    $5b96f91a609769a4$var$wrapMapToPropsFunc(mapDispatchToProps, "mapDispatchToProps") : $5b96f91a609769a4$var$createInvalidArgFactory(mapDispatchToProps, "mapDispatchToProps");
}
// src/connect/mapStateToProps.ts
function $5b96f91a609769a4$var$mapStateToPropsFactory(mapStateToProps) {
    return !mapStateToProps ? $5b96f91a609769a4$var$wrapMapToPropsConstant(()=>({})) : typeof mapStateToProps === "function" ? // @ts-ignore
    $5b96f91a609769a4$var$wrapMapToPropsFunc(mapStateToProps, "mapStateToProps") : $5b96f91a609769a4$var$createInvalidArgFactory(mapStateToProps, "mapStateToProps");
}
// src/connect/mergeProps.ts
function $5b96f91a609769a4$var$defaultMergeProps(stateProps, dispatchProps, ownProps) {
    return {
        ...ownProps,
        ...stateProps,
        ...dispatchProps
    };
}
function $5b96f91a609769a4$var$wrapMergePropsFunc(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $5b96f91a609769a4$var$mergePropsFactory(mergeProps) {
    return !mergeProps ? ()=>$5b96f91a609769a4$var$defaultMergeProps : typeof mergeProps === "function" ? $5b96f91a609769a4$var$wrapMergePropsFunc(mergeProps) : $5b96f91a609769a4$var$createInvalidArgFactory(mergeProps, "mergeProps");
}
// src/utils/batch.ts
function $5b96f91a609769a4$var$defaultNoopBatch(callback) {
    callback();
}
// src/utils/Subscription.ts
function $5b96f91a609769a4$var$createListenerCollection() {
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            $5b96f91a609769a4$var$defaultNoopBatch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            const listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            const listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $5b96f91a609769a4$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $5b96f91a609769a4$var$createSubscription(store, parentSub) {
    let unsubscribe;
    let listeners = $5b96f91a609769a4$var$nullListeners;
    let subscriptionsAmount = 0;
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener);
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $5b96f91a609769a4$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = void 0;
            listeners.clear();
            listeners = $5b96f91a609769a4$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}
// src/utils/useIsomorphicLayoutEffect.ts
var $5b96f91a609769a4$var$canUseDOM = ()=>!!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
var $5b96f91a609769a4$var$isDOM = /* @__PURE__ */ $5b96f91a609769a4$var$canUseDOM();
var $5b96f91a609769a4$var$isRunningInReactNative = ()=>typeof navigator !== "undefined" && navigator.product === "ReactNative";
var $5b96f91a609769a4$var$isReactNative = /* @__PURE__ */ $5b96f91a609769a4$var$isRunningInReactNative();
var $5b96f91a609769a4$var$getUseIsomorphicLayoutEffect = ()=>$5b96f91a609769a4$var$isDOM || $5b96f91a609769a4$var$isReactNative ? $kc00y.useLayoutEffect : $kc00y.useEffect;
var $5b96f91a609769a4$var$useIsomorphicLayoutEffect = /* @__PURE__ */ $5b96f91a609769a4$var$getUseIsomorphicLayoutEffect();
// src/utils/shallowEqual.ts
function $5b96f91a609769a4$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $5b96f91a609769a4$export$d36bdfa510afb180(objA, objB) {
    if ($5b96f91a609769a4$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$5b96f91a609769a4$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
// src/utils/hoistStatics.ts
var $5b96f91a609769a4$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $5b96f91a609769a4$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $5b96f91a609769a4$var$FORWARD_REF_STATICS = {
    $$typeof: true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $5b96f91a609769a4$var$MEMO_STATICS = {
    $$typeof: true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $5b96f91a609769a4$var$TYPE_STATICS = {
    [$5b96f91a609769a4$var$ForwardRef]: $5b96f91a609769a4$var$FORWARD_REF_STATICS,
    [$5b96f91a609769a4$var$Memo]: $5b96f91a609769a4$var$MEMO_STATICS
};
function $5b96f91a609769a4$var$getStatics(component) {
    if ($5b96f91a609769a4$var$isMemo(component)) return $5b96f91a609769a4$var$MEMO_STATICS;
    return $5b96f91a609769a4$var$TYPE_STATICS[component["$$typeof"]] || $5b96f91a609769a4$var$REACT_STATICS;
}
var $5b96f91a609769a4$var$defineProperty = Object.defineProperty;
var $5b96f91a609769a4$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $5b96f91a609769a4$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $5b96f91a609769a4$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $5b96f91a609769a4$var$getPrototypeOf = Object.getPrototypeOf;
var $5b96f91a609769a4$var$objectPrototype = Object.prototype;
function $5b96f91a609769a4$var$hoistNonReactStatics(targetComponent, sourceComponent) {
    if (typeof sourceComponent !== "string") {
        if ($5b96f91a609769a4$var$objectPrototype) {
            const inheritedComponent = $5b96f91a609769a4$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $5b96f91a609769a4$var$objectPrototype) $5b96f91a609769a4$var$hoistNonReactStatics(targetComponent, inheritedComponent);
        }
        let keys = $5b96f91a609769a4$var$getOwnPropertyNames(sourceComponent);
        if ($5b96f91a609769a4$var$getOwnPropertySymbols) keys = keys.concat($5b96f91a609769a4$var$getOwnPropertySymbols(sourceComponent));
        const targetStatics = $5b96f91a609769a4$var$getStatics(targetComponent);
        const sourceStatics = $5b96f91a609769a4$var$getStatics(sourceComponent);
        for(let i = 0; i < keys.length; ++i){
            const key = keys[i];
            if (!$5b96f91a609769a4$var$KNOWN_STATICS[key] && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                const descriptor = $5b96f91a609769a4$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    $5b96f91a609769a4$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
// src/components/Context.ts
var $5b96f91a609769a4$var$ContextKey = /* @__PURE__ */ Symbol.for(`react-redux-context`);
var $5b96f91a609769a4$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $5b96f91a609769a4$var$getContext() {
    if (!$kc00y.createContext) return {};
    const contextMap = $5b96f91a609769a4$var$gT[$5b96f91a609769a4$var$ContextKey] ??= /* @__PURE__ */ new Map();
    let realContext = contextMap.get($kc00y.createContext);
    if (!realContext) {
        realContext = $kc00y.createContext(null);
        contextMap.set($kc00y.createContext, realContext);
    }
    return realContext;
}
var $5b96f91a609769a4$export$cc80c08dc91f1c00 = /* @__PURE__ */ $5b96f91a609769a4$var$getContext();
// src/components/connect.tsx
var $5b96f91a609769a4$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $5b96f91a609769a4$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $5b96f91a609769a4$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    $5b96f91a609769a4$var$useIsomorphicLayoutEffect(()=>effectFunc(...effectArgs), dependencies);
}
function $5b96f91a609769a4$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false;
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $5b96f91a609769a4$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    if (!shouldHandleStateChanges) return ()=>{};
    let didUnsubscribe = false;
    let lastThrownError = null;
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) return;
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true;
            additionalSubscribeListener();
        }
    };
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) throw lastThrownError;
    };
    return unsubscribeWrapper;
}
function $5b96f91a609769a4$var$strictEqual(a, b) {
    return a === b;
}
var $5b96f91a609769a4$var$hasWarnedAboutDeprecatedPureOption = false;
function $5b96f91a609769a4$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $5b96f91a609769a4$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = $5b96f91a609769a4$export$d36bdfa510afb180, areStatePropsEqual: areStatePropsEqual = $5b96f91a609769a4$export$d36bdfa510afb180, areMergedPropsEqual: areMergedPropsEqual = $5b96f91a609769a4$export$d36bdfa510afb180, forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = $5b96f91a609769a4$export$cc80c08dc91f1c00 } = {}) {
    const Context = context;
    const initMapStateToProps = $5b96f91a609769a4$var$mapStateToPropsFactory(mapStateToProps);
    const initMapDispatchToProps = $5b96f91a609769a4$var$mapDispatchToPropsFactory(mapDispatchToProps);
    const initMergeProps = $5b96f91a609769a4$var$mergePropsFactory(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $kc00y.useMemo(()=>{
                const { reactReduxForwardedRef: reactReduxForwardedRef2, ...wrapperProps2 } = props;
                return [
                    props.context,
                    reactReduxForwardedRef2,
                    wrapperProps2
                ];
            }, [
                props
            ]);
            const ContextToUse = $kc00y.useMemo(()=>{
                let ResultContext = Context;
                propsContext?.Consumer;
                return ResultContext;
            }, [
                propsContext,
                Context
            ]);
            const contextValue = $kc00y.useContext(ContextToUse);
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $kc00y.useMemo(()=>{
                return $5b96f91a609769a4$var$finalPropsSelectorFactory(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $kc00y.useMemo(()=>{
                if (!shouldHandleStateChanges) return $5b96f91a609769a4$var$NO_SUBSCRIPTION_ARRAY;
                const subscription2 = $5b96f91a609769a4$var$createSubscription(store, didStoreComeFromProps ? void 0 : contextValue.subscription);
                const notifyNestedSubs2 = subscription2.notifyNestedSubs.bind(subscription2);
                return [
                    subscription2,
                    notifyNestedSubs2
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]);
            const overriddenContextValue = $kc00y.useMemo(()=>{
                if (didStoreComeFromProps) return contextValue;
                return {
                    ...contextValue,
                    subscription: subscription
                };
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]);
            const lastChildProps = $kc00y.useRef(void 0);
            const lastWrapperProps = $kc00y.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $kc00y.useRef(void 0);
            const renderIsScheduled = $kc00y.useRef(false);
            const isMounted = $kc00y.useRef(false);
            const latestSubscriptionCallbackError = $kc00y.useRef(void 0);
            $5b96f91a609769a4$var$useIsomorphicLayoutEffect(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $kc00y.useMemo(()=>{
                const selector = ()=>{
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]);
            const subscribeForReact = $kc00y.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $5b96f91a609769a4$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, // @ts-ignore
                    childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $5b96f91a609769a4$var$useIsomorphicLayoutEffectWithArgs($5b96f91a609769a4$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $kc00y.useSyncExternalStore(// TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
                subscribeForReact, // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
                // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `
The error may be correlated with this previous error:
${latestSubscriptionCallbackError.current.stack}

`;
                throw err;
            }
            $5b96f91a609769a4$var$useIsomorphicLayoutEffect(()=>{
                latestSubscriptionCallbackError.current = void 0;
                childPropsFromStoreUpdate.current = void 0;
                lastChildProps.current = actualChildProps;
            });
            const renderedWrappedComponent = $kc00y.useMemo(()=>{
                return(// @ts-ignore
                /* @__PURE__ */ $kc00y.createElement(WrappedComponent, {
                    ...actualChildProps,
                    ref: reactReduxForwardedRef
                }));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]);
            const renderedChild = $kc00y.useMemo(()=>{
                if (shouldHandleStateChanges) return /* @__PURE__ */ $kc00y.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $kc00y.memo(ConnectFunction);
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $kc00y.forwardRef(function forwardConnectRef(props, ref) {
                return /* @__PURE__ */ $kc00y.createElement(Connect, {
                    ...props,
                    reactReduxForwardedRef: ref
                });
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return /* @__PURE__ */ $5b96f91a609769a4$var$hoistNonReactStatics(forwarded, WrappedComponent);
        }
        return /* @__PURE__ */ $5b96f91a609769a4$var$hoistNonReactStatics(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $5b96f91a609769a4$export$64605811ab45167f = $5b96f91a609769a4$var$connect;
// src/components/Provider.tsx
function $5b96f91a609769a4$var$Provider(providerProps) {
    const { children: children, context: context, serverState: serverState, store: store } = providerProps;
    const contextValue = $kc00y.useMemo(()=>{
        const subscription = $5b96f91a609769a4$var$createSubscription(store);
        const baseContextValue = {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : void 0
        };
        return baseContextValue;
    }, [
        store,
        serverState
    ]);
    const previousState = $kc00y.useMemo(()=>store.getState(), [
        store
    ]);
    $5b96f91a609769a4$var$useIsomorphicLayoutEffect(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = void 0;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || $5b96f91a609769a4$export$cc80c08dc91f1c00;
    return /* @__PURE__ */ $kc00y.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $5b96f91a609769a4$export$2881499e37b75b9a = $5b96f91a609769a4$var$Provider;
// src/hooks/useReduxContext.ts
function $5b96f91a609769a4$var$createReduxContextHook(context = $5b96f91a609769a4$export$cc80c08dc91f1c00) {
    return function useReduxContext2() {
        const contextValue = $kc00y.useContext(context);
        return contextValue;
    };
}
var $5b96f91a609769a4$var$useReduxContext = /* @__PURE__ */ $5b96f91a609769a4$var$createReduxContextHook();
// src/hooks/useStore.ts
function $5b96f91a609769a4$export$671dba69185d0304(context = $5b96f91a609769a4$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $5b96f91a609769a4$export$cc80c08dc91f1c00 ? $5b96f91a609769a4$var$useReduxContext : // @ts-ignore
    $5b96f91a609769a4$var$createReduxContextHook(context);
    const useStore2 = ()=>{
        const { store: store } = useReduxContext2();
        return store;
    };
    Object.assign(useStore2, {
        withTypes: ()=>useStore2
    });
    return useStore2;
}
var $5b96f91a609769a4$export$6ccbb43953eebf8 = /* @__PURE__ */ $5b96f91a609769a4$export$671dba69185d0304();
// src/hooks/useDispatch.ts
function $5b96f91a609769a4$export$bc9b55530897c558(context = $5b96f91a609769a4$export$cc80c08dc91f1c00) {
    const useStore2 = context === $5b96f91a609769a4$export$cc80c08dc91f1c00 ? $5b96f91a609769a4$export$6ccbb43953eebf8 : $5b96f91a609769a4$export$671dba69185d0304(context);
    const useDispatch2 = ()=>{
        const store = useStore2();
        return store.dispatch;
    };
    Object.assign(useDispatch2, {
        withTypes: ()=>useDispatch2
    });
    return useDispatch2;
}
var $5b96f91a609769a4$export$8ad76b76a4c905f8 = /* @__PURE__ */ $5b96f91a609769a4$export$bc9b55530897c558();
var $5b96f91a609769a4$var$refEquality = (a, b)=>a === b;
function $5b96f91a609769a4$export$2b53f90d2bd1cbfb(context = $5b96f91a609769a4$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $5b96f91a609769a4$export$cc80c08dc91f1c00 ? $5b96f91a609769a4$var$useReduxContext : $5b96f91a609769a4$var$createReduxContextHook(context);
    const useSelector2 = (selector, equalityFnOrOptions = {})=>{
        const { equalityFn: equalityFn = $5b96f91a609769a4$var$refEquality } = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const reduxContext = useReduxContext2();
        const { store: store, subscription: subscription, getServerState: getServerState } = reduxContext;
        const firstRun = $kc00y.useRef(true);
        const wrappedSelector = $kc00y.useCallback({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector
        ]);
        const selectedState = (0, $ea95c15f9ecd74f1$exports.useSyncExternalStoreWithSelector)(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        $kc00y.useDebugValue(selectedState);
        return selectedState;
    };
    Object.assign(useSelector2, {
        withTypes: ()=>useSelector2
    });
    return useSelector2;
}
var $5b96f91a609769a4$export$2105062e25df4afe = /* @__PURE__ */ $5b96f91a609769a4$export$2b53f90d2bd1cbfb();
// src/exports.ts
var $5b96f91a609769a4$export$712ea50be43a7858 = $5b96f91a609769a4$var$defaultNoopBatch;


var $13251e7ce0459d7b$var$propsToShallowCompare = new Set([
    'axisLine',
    'tickLine',
    'activeBar',
    'activeDot',
    'activeLabel',
    'activeShape',
    'allowEscapeViewBox',
    'background',
    'cursor',
    'dot',
    'label',
    'line',
    'margin',
    'padding',
    'position',
    'shape',
    'style',
    'tick',
    'wrapperStyle',
    // radius can be an array of 4 numbers, easy to compare shallowly
    'radius',
    'throttledEvents'
]);
/**
 * When comparing two values, returns true if they are the same value or
 * are both NaN.
 *
 * If we used just a simple triple equals, we would get false negatives for two NaNs
 * which could cause extra re-renders so let's have this instead.
 *
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Equality_comparisons_and_sameness#same-value-zero_equality
 *
 * @param x first value to compare
 * @param y second value to compare
 * return true if the same, false if different
 */ function $13251e7ce0459d7b$var$sameValueZero(x, y) {
    if (x == null && y == null) /*
     * treat null and undefined as equal. Internally in Recharts we make no difference between these two
     * so there is no need to re-render.
     */ return true;
    if (typeof x === 'number' && typeof y === 'number') // x and y are equal (this is true for -0 and 0) or they are both NaN
    // eslint-disable-next-line no-self-compare
    return x === y || x !== x && y !== y;
    return x === y;
}
function $13251e7ce0459d7b$export$b8f09df787c278d9(prevProps, nextProps) {
    var allKeys = new Set([
        ...Object.keys(prevProps),
        ...Object.keys(nextProps)
    ]);
    for (var key of allKeys){
        /*
     * If a key is on a special allowlist, go one level deeper
     * and do a shallow comparison of the values.
     */ if ($13251e7ce0459d7b$var$propsToShallowCompare.has(key)) {
            if (prevProps[key] == null && nextProps[key] == null) continue;
            if (!(0, $5b96f91a609769a4$export$d36bdfa510afb180)(prevProps[key], nextProps[key])) return false;
        /*
       * Otherwise do a simple same-value comparison (with NaN support).
       */ } else if (!$13251e7ce0459d7b$var$sameValueZero(prevProps[key], nextProps[key])) return false;
    }
    return true;
}



var $kc00y = parcelRequire("kc00y");







var $8b16701216b7b344$var$pickStackId = (state, stackId)=>stackId;
var $8b16701216b7b344$var$pickIsPanorama = (state, stackId, isPanorama)=>isPanorama;
var $8b16701216b7b344$export$7f05d1a8fbacd727 = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $8b16701216b7b344$var$pickStackId,
    (0, $223cdb002ac9c48b$export$f67c737adf41a3af),
    $8b16701216b7b344$var$pickIsPanorama
], (stackId, allItems, isPanorama)=>{
    return allItems.filter((i)=>i.type === 'bar').filter((i)=>i.stackId === stackId).filter((i)=>i.isPanorama === isPanorama).filter((i)=>!i.hide);
});
var $8b16701216b7b344$var$selectAllBarIdsInStack = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $8b16701216b7b344$export$7f05d1a8fbacd727
], (allBars)=>{
    return allBars.map((bar)=>bar.id);
});
var $8b16701216b7b344$export$54063602295685e1 = (rect1, rect2)=>{
    if (!rect1) return rect2;
    if (!rect2) return rect1;
    var x = Math.min(rect1.x, rect1.x + rect1.width, rect2.x, rect2.x + rect2.width);
    var y = Math.min(rect1.y, rect1.y + rect1.height, rect2.y, rect2.y + rect2.height);
    var maxX = Math.max(rect1.x, rect1.x + rect1.width, rect2.x, rect2.x + rect2.width);
    var maxY = Math.max(rect1.y, rect1.y + rect1.height, rect2.y, rect2.y + rect2.height);
    var width = maxX - x;
    var height = maxY - y;
    return {
        x: x,
        y: y,
        width: width,
        height: height
    };
};
var $8b16701216b7b344$var$combineStackRects = (state, stackId, isPanorama)=>{
    var allBarIds = $8b16701216b7b344$var$selectAllBarIdsInStack(state, stackId, isPanorama);
    var stackRects = [];
    allBarIds.forEach((barId)=>{
        var rectangles = (0, $f7cdddd408b98c5e$export$bb89ca2d15dbced9)(state, barId, isPanorama, undefined);
        rectangles === null || rectangles === void 0 || rectangles.forEach((rect)=>{
            var rectIndex = rect.originalDataIndex;
            stackRects[rectIndex] = $8b16701216b7b344$export$54063602295685e1(stackRects[rectIndex], rect);
        });
    });
    return stackRects;
};
var $8b16701216b7b344$export$7518e012f9c78033 = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    (state)=>state,
    $8b16701216b7b344$var$pickStackId,
    $8b16701216b7b344$var$pickIsPanorama
], $8b16701216b7b344$var$combineStackRects);






var $ae845200f5e42186$var$_excluded = [
    "index"
];
function $ae845200f5e42186$var$_extends() {
    return $ae845200f5e42186$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ae845200f5e42186$var$_extends.apply(null, arguments);
}
function $ae845200f5e42186$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $ae845200f5e42186$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $ae845200f5e42186$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $ae845200f5e42186$var$BarStackContext = /*#__PURE__*/ (0, $kc00y.createContext)(undefined);
var $ae845200f5e42186$export$837efb24f50d011e = (childStackId)=>{
    var stackSettings = (0, $kc00y.useContext)($ae845200f5e42186$var$BarStackContext);
    if (stackSettings != null) return stackSettings.stackId;
    if (childStackId == null) return undefined;
    return (0, $d5958b0668c58531$export$f0871da41ca7fc82)(childStackId);
};
var $ae845200f5e42186$export$49f633eb2d560a47 = {
    radius: 0
};
var $ae845200f5e42186$var$getClipPathId = (stackId, index)=>{
    return "recharts-bar-stack-clip-path-".concat(stackId, "-").concat(index);
};
var $ae845200f5e42186$export$7c5499b8b81f5acf = (index)=>{
    var barStackContext = (0, $kc00y.useContext)($ae845200f5e42186$var$BarStackContext);
    if (barStackContext == null) return undefined;
    var { stackId: stackId } = barStackContext;
    return "url(#".concat($ae845200f5e42186$var$getClipPathId(stackId, index), ")");
};
var $ae845200f5e42186$export$6374d9b2eea9076f = (_ref)=>{
    var { index: index } = _ref, rest = $ae845200f5e42186$var$_objectWithoutProperties(_ref, $ae845200f5e42186$var$_excluded);
    var clipPathUrl = $ae845200f5e42186$export$7c5499b8b81f5acf(index);
    return /*#__PURE__*/ $kc00y.createElement((0, $553c02c7047f2968$export$936d0764594b6eb3), $ae845200f5e42186$var$_extends({
        className: "recharts-bar-stack-layer",
        clipPath: clipPathUrl
    }, rest));
};
/**
 * This React component will render a clipPath that the individual bars in the stack will reference
 * to achieve rounded corners for the entire stack.
 */ var $ae845200f5e42186$var$BarStackClipPath = (_ref2)=>{
    var { stackId: stackId, radius: radius } = _ref2;
    var isPanorama = (0, $10d1d693b6b228cd$export$4b0c59f8845ba920)();
    var positions = (0, $a441e801d1b41b52$export$a7347740d65f620b)((state)=>(0, $8b16701216b7b344$export$7518e012f9c78033)(state, stackId, isPanorama));
    if (positions == null || positions.length === 0) return null;
    /*
   * Render one clipPath per rectangle in the stack.
   * Each rectangle corresponds to one data entry in the chart.
   */ return /*#__PURE__*/ $kc00y.createElement("defs", null, positions.map((pos, index)=>{
        if (pos == null) return null;
        var clipPathId = $ae845200f5e42186$var$getClipPathId(stackId, index);
        return /*#__PURE__*/ $kc00y.createElement("clipPath", {
            key: clipPathId,
            id: clipPathId
        }, /*#__PURE__*/ $kc00y.createElement((0, $94f5b831b08677d3$export$4617fb02663045ef), {
            isAnimationActive: false,
            isUpdateAnimationActive: false,
            x: pos.x,
            y: pos.y,
            width: pos.width,
            height: pos.height,
            radius: radius
        }));
    }));
};
var $ae845200f5e42186$var$BarStackImpl = (props)=>{
    var resolvedStackId = (0, $6e5ec7ed2dc8f476$export$c485849f2e393253)('recharts-bar-stack', (0, $d5958b0668c58531$export$f0871da41ca7fc82)(props.stackId));
    var { children: children, radius: radius } = (0, $4cc2299923ef69c7$export$45004cc70a390ee8)(props, $ae845200f5e42186$export$49f633eb2d560a47);
    var context = (0, $kc00y.useMemo)(()=>({
            stackId: resolvedStackId,
            radius: radius
        }), [
        resolvedStackId,
        radius
    ]);
    return /*#__PURE__*/ $kc00y.createElement($ae845200f5e42186$var$BarStackContext.Provider, {
        value: context
    }, /*#__PURE__*/ $kc00y.createElement($ae845200f5e42186$var$BarStackClipPath, {
        stackId: resolvedStackId,
        radius: radius
    }), children);
};
var $ae845200f5e42186$export$ebd6167c687e5b8b = /*#__PURE__*/ $kc00y.memo($ae845200f5e42186$var$BarStackImpl, (0, $13251e7ce0459d7b$export$b8f09df787c278d9));


var $ec65bf22e0d120c5$var$_excluded = [
    "onMouseEnter",
    "onMouseLeave",
    "onClick"
], $ec65bf22e0d120c5$var$_excluded2 = [
    "value",
    "background",
    "tooltipPosition"
], $ec65bf22e0d120c5$var$_excluded3 = [
    "id"
], $ec65bf22e0d120c5$var$_excluded4 = [
    "onMouseEnter",
    "onClick",
    "onMouseLeave"
];
function $ec65bf22e0d120c5$var$_extends() {
    return $ec65bf22e0d120c5$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ec65bf22e0d120c5$var$_extends.apply(null, arguments);
}
function $ec65bf22e0d120c5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ec65bf22e0d120c5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ec65bf22e0d120c5$var$ownKeys(Object(t), !0).forEach(function(r) {
            $ec65bf22e0d120c5$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ec65bf22e0d120c5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ec65bf22e0d120c5$var$_defineProperty(e, r, t) {
    return (r = $ec65bf22e0d120c5$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $ec65bf22e0d120c5$var$_toPropertyKey(t) {
    var i = $ec65bf22e0d120c5$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $ec65bf22e0d120c5$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $ec65bf22e0d120c5$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $ec65bf22e0d120c5$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $ec65bf22e0d120c5$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $ec65bf22e0d120c5$var$computeLegendPayloadFromBarData = (props)=>{
    var { dataKey: dataKey, name: name, fill: fill, legendType: legendType, hide: hide } = props;
    return [
        {
            inactive: hide,
            dataKey: dataKey,
            type: legendType,
            color: fill,
            value: (0, $d5958b0668c58531$export$d3207de44081d2b3)(name, dataKey),
            payload: props
        }
    ];
};
var $ec65bf22e0d120c5$var$SetBarTooltipEntrySettings = /*#__PURE__*/ $kc00y.memo((_ref)=>{
    var { dataKey: dataKey, stroke: stroke, strokeWidth: strokeWidth, fill: fill, name: name, hide: hide, unit: unit, tooltipType: tooltipType, id: id } = _ref;
    var tooltipEntrySettings = {
        dataDefinedOnItem: undefined,
        getPosition: (0, $7e613228d3a31273$export$8793edee2d425525),
        settings: {
            stroke: stroke,
            strokeWidth: strokeWidth,
            fill: fill,
            dataKey: dataKey,
            nameKey: undefined,
            name: (0, $d5958b0668c58531$export$d3207de44081d2b3)(name, dataKey),
            hide: hide,
            type: tooltipType,
            color: fill,
            unit: unit,
            graphicalItemId: id
        }
    };
    return /*#__PURE__*/ $kc00y.createElement((0, $1cd65dea66eb2265$export$7fa09c17ce18f3e8), {
        tooltipEntrySettings: tooltipEntrySettings
    });
});
function $ec65bf22e0d120c5$var$BarBackground(props) {
    var activeIndex = (0, $a441e801d1b41b52$export$a7347740d65f620b)((0, $dbde609d2e66e7f4$export$8b2762260f5891c9));
    var { data: data, dataKey: dataKey, background: backgroundFromProps, allOtherBarProps: allOtherBarProps } = props;
    var { onMouseEnter: onMouseEnterFromProps, onMouseLeave: onMouseLeaveFromProps, onClick: onItemClickFromProps } = allOtherBarProps, restOfAllOtherProps = $ec65bf22e0d120c5$var$_objectWithoutProperties(allOtherBarProps, $ec65bf22e0d120c5$var$_excluded);
    var onMouseEnterFromContext = (0, $757384ec7d27bd7d$export$6162f642d41f88ea)(onMouseEnterFromProps, dataKey, allOtherBarProps.id);
    var onMouseLeaveFromContext = (0, $757384ec7d27bd7d$export$27cbf444bf0be2d0)(onMouseLeaveFromProps);
    var onClickFromContext = (0, $757384ec7d27bd7d$export$c9154937ad8393fc)(onItemClickFromProps, dataKey, allOtherBarProps.id);
    if (!backgroundFromProps || data == null) return null;
    var backgroundProps = (0, $34cf66bbb2aff04f$export$6d5921c09aa671a9)(backgroundFromProps);
    return /*#__PURE__*/ $kc00y.createElement((0, $a6cde822fe24aa10$export$b37befaf92aba9f1), {
        zIndex: (0, $8449b02e7702819c$export$384f306fbc0d3ce9)(backgroundFromProps, (0, $2d4105c5b5d94e8f$export$96df16b28aa32702).barBackground)
    }, data.map((entry, i)=>{
        var { value: value, background: backgroundFromDataEntry, tooltipPosition: tooltipPosition } = entry, rest = $ec65bf22e0d120c5$var$_objectWithoutProperties(entry, $ec65bf22e0d120c5$var$_excluded2);
        if (!backgroundFromDataEntry) return null;
        var onMouseEnter = onMouseEnterFromContext(entry, i);
        var onMouseLeave = onMouseLeaveFromContext(entry, i);
        var onClick = onClickFromContext(entry, i);
        var barRectangleProps = $ec65bf22e0d120c5$var$_objectSpread($ec65bf22e0d120c5$var$_objectSpread($ec65bf22e0d120c5$var$_objectSpread($ec65bf22e0d120c5$var$_objectSpread($ec65bf22e0d120c5$var$_objectSpread({
            option: backgroundFromProps,
            isActive: String(i) === activeIndex
        }, rest), {}, {
            // @ts-expect-error backgroundProps is contributing unknown props
            fill: '#eee'
        }, backgroundFromDataEntry), backgroundProps), (0, $435e27a3bdb96447$export$ca62be0d67a3158c)(restOfAllOtherProps, entry, i)), {}, {
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onClick: onClick,
            dataKey: dataKey,
            index: i,
            className: 'recharts-bar-background-rectangle'
        });
        return /*#__PURE__*/ $kc00y.createElement((0, $4b9606aec568c4dd$export$f19074a6842f9217), $ec65bf22e0d120c5$var$_extends({
            key: "background-bar-".concat(i)
        }, barRectangleProps));
    }));
}
function $ec65bf22e0d120c5$var$BarLabelListProvider(_ref2) {
    var { showLabels: showLabels, children: children, rects: rects } = _ref2;
    var labelListEntries = rects === null || rects === void 0 ? void 0 : rects.map((entry)=>{
        var viewBox = {
            x: entry.x,
            y: entry.y,
            width: entry.width,
            lowerWidth: entry.width,
            upperWidth: entry.width,
            height: entry.height
        };
        return $ec65bf22e0d120c5$var$_objectSpread($ec65bf22e0d120c5$var$_objectSpread({}, viewBox), {}, {
            value: entry.value,
            payload: entry.payload,
            parentViewBox: entry.parentViewBox,
            viewBox: viewBox,
            fill: entry.fill
        });
    });
    return /*#__PURE__*/ $kc00y.createElement((0, $acfbbd67802b75bf$export$64e384eac5db53f7), {
        value: showLabels ? labelListEntries : undefined
    }, children);
}
function $ec65bf22e0d120c5$var$BarRectangleWithActiveState(props) {
    var { shape: shape, activeBar: activeBar, baseProps: baseProps, entry: entry, index: index, dataKey: dataKey } = props;
    var activeIndex = (0, $a441e801d1b41b52$export$a7347740d65f620b)((0, $dbde609d2e66e7f4$export$8b2762260f5891c9));
    var activeDataKey = (0, $a441e801d1b41b52$export$a7347740d65f620b)((0, $dbde609d2e66e7f4$export$999f7a7ced063fab));
    /*
   * Bars support stacking, meaning that there can be multiple bars at the same x value.
   * With Tooltip shared=false we only want to highlight the currently active Bar, not all.
   *
   * Also, if the tooltip is shared, we want to highlight all bars at the same x value
   * regardless of the dataKey.
   *
   * With shared Tooltip, the activeDataKey is undefined.
   *
   * We use entry.originalDataIndex to match against activeIndex because the render index parameter
   * is based on the filtered array, while activeIndex is based on the pre-filter displayed data slice.
   * When entries are filtered out (for example null/zero-dimension bars), these indices can differ.
   */ var isActive = activeBar && String(entry.originalDataIndex) === activeIndex && (activeDataKey == null || dataKey === activeDataKey);
    var [stayInLayer, setStayInLayer] = (0, $kc00y.useState)(false);
    var [hasMountedActive, setHasMountedActive] = (0, $kc00y.useState)(false);
    (0, $kc00y.useEffect)(()=>{
        var rafId;
        if (isActive) {
            // 1. Enter the layer immediately
            setStayInLayer(true);
            // 2. Wait for the browser to paint the "inactive" state in the new layer,
            // then switch to active to trigger the CSS transition (width grow).
            rafId = requestAnimationFrame(()=>{
                setHasMountedActive(true);
            });
        } else setHasMountedActive(false);
        return ()=>{
            cancelAnimationFrame(rafId);
        };
    }, [
        isActive
    ]);
    var handleTransitionEnd = (0, $kc00y.useCallback)(()=>{
        // 4. Leave the layer only when the exit transition finishes
        if (!isActive) setStayInLayer(false);
    }, [
        isActive
    ]);
    // Determine props:
    // - If entering (isActive=true) but not mounted yet (hasMountedActive=false), pass isActive=false (inactive size).
    // - If exiting (isActive=false), pass isActive=false (inactive size).
    var isVisuallyActive = isActive && hasMountedActive;
    // Render in ZIndexLayer if active OR if we are waiting for exit transition
    var shouldRenderInLayer = isActive || stayInLayer;
    var option;
    if (isActive) {
        if (activeBar === true) option = shape;
        else option = activeBar;
    } else option = shape;
    var content = /*#__PURE__*/ $kc00y.createElement((0, $4b9606aec568c4dd$export$f19074a6842f9217), $ec65bf22e0d120c5$var$_extends({}, baseProps, {
        name: String(baseProps.name)
    }, entry, {
        isActive: isVisuallyActive,
        option: option,
        index: index,
        dataKey: dataKey,
        onTransitionEnd: handleTransitionEnd
    }));
    if (shouldRenderInLayer) return /*#__PURE__*/ $kc00y.createElement((0, $a6cde822fe24aa10$export$b37befaf92aba9f1), {
        zIndex: (0, $2d4105c5b5d94e8f$export$96df16b28aa32702).activeBar
    }, /*#__PURE__*/ $kc00y.createElement((0, $ae845200f5e42186$export$6374d9b2eea9076f), {
        index: entry.originalDataIndex
    }, content));
    return content;
}
function $ec65bf22e0d120c5$var$BarRectangleNeverActive(props) {
    var { shape: shape, baseProps: baseProps, entry: entry, index: index, dataKey: dataKey } = props;
    return /*#__PURE__*/ $kc00y.createElement((0, $4b9606aec568c4dd$export$f19074a6842f9217), $ec65bf22e0d120c5$var$_extends({}, baseProps, {
        name: String(baseProps.name)
    }, entry, {
        isActive: false,
        option: shape,
        index: index,
        dataKey: dataKey
    }));
}
function $ec65bf22e0d120c5$var$BarRectangles(_ref3) {
    var _svgPropertiesNoEvent;
    var { data: data, props: props } = _ref3;
    var _ref4 = (_svgPropertiesNoEvent = (0, $34cf66bbb2aff04f$export$8b56257912140094)(props)) !== null && _svgPropertiesNoEvent !== void 0 ? _svgPropertiesNoEvent : {}, { id: id } = _ref4, baseProps = $ec65bf22e0d120c5$var$_objectWithoutProperties(_ref4, $ec65bf22e0d120c5$var$_excluded3);
    var { shape: shape, dataKey: dataKey, activeBar: activeBar } = props;
    var { onMouseEnter: onMouseEnterFromProps, onClick: onItemClickFromProps, onMouseLeave: onMouseLeaveFromProps } = props, restOfAllOtherProps = $ec65bf22e0d120c5$var$_objectWithoutProperties(props, $ec65bf22e0d120c5$var$_excluded4);
    var onMouseEnterFromContext = (0, $757384ec7d27bd7d$export$6162f642d41f88ea)(onMouseEnterFromProps, dataKey, id);
    var onMouseLeaveFromContext = (0, $757384ec7d27bd7d$export$27cbf444bf0be2d0)(onMouseLeaveFromProps);
    var onClickFromContext = (0, $757384ec7d27bd7d$export$c9154937ad8393fc)(onItemClickFromProps, dataKey, id);
    if (!data) return null;
    return /*#__PURE__*/ $kc00y.createElement($kc00y.Fragment, null, data.map((entry, i)=>{
        return /*#__PURE__*/ $kc00y.createElement((0, $ae845200f5e42186$export$6374d9b2eea9076f), $ec65bf22e0d120c5$var$_extends({
            index: entry.originalDataIndex,
            key: "rectangle-".concat(entry === null || entry === void 0 ? void 0 : entry.x, "-").concat(entry === null || entry === void 0 ? void 0 : entry.y, "-").concat(entry === null || entry === void 0 ? void 0 : entry.value, "-").concat(i),
            className: "recharts-bar-rectangle"
        }, (0, $435e27a3bdb96447$export$ca62be0d67a3158c)(restOfAllOtherProps, entry, i), {
            onMouseEnter: onMouseEnterFromContext(entry, i),
            onMouseLeave: onMouseLeaveFromContext(entry, i),
            onClick: onClickFromContext(entry, i)
        }), activeBar ? /*#__PURE__*/ $kc00y.createElement($ec65bf22e0d120c5$var$BarRectangleWithActiveState, {
            shape: shape,
            activeBar: activeBar,
            baseProps: baseProps,
            entry: entry,
            index: i,
            dataKey: dataKey
        }) : /*#__PURE__*/ /*
     * If the `activeBar` prop is falsy, then let's call the variant without hooks.
     * Using the `selectActiveTooltipIndex` selector is usually fast
     * but in charts with large-ish amount of data even the few nanoseconds add up to a noticeable jank.
     * If the activeBar is false then we don't need to know which index is active - because we won't use it anyway.
     * So let's just skip the hooks altogether. That way, React can skip rendering the component,
     * and can skip the tree reconciliation for its children too.
     * Because we can't call hooks conditionally, we need to have a separate component for that.
     */ $kc00y.createElement($ec65bf22e0d120c5$var$BarRectangleNeverActive, {
            shape: shape,
            baseProps: baseProps,
            entry: entry,
            index: i,
            dataKey: dataKey
        }));
    }));
}
function $ec65bf22e0d120c5$var$RectanglesWithAnimation(_ref5) {
    var { props: props, previousRectanglesRef: previousRectanglesRef } = _ref5;
    var { data: data, layout: layout, isAnimationActive: isAnimationActive, animationBegin: animationBegin, animationDuration: animationDuration, animationEasing: animationEasing, onAnimationEnd: onAnimationEnd, onAnimationStart: onAnimationStart } = props;
    var prevData = previousRectanglesRef.current;
    var animationId = (0, $706e1fa6aaf57212$export$e1042b2944b80b7f)(props, 'recharts-bar-');
    var [isAnimating, setIsAnimating] = (0, $kc00y.useState)(false);
    var showLabels = !isAnimating;
    var handleAnimationEnd = (0, $kc00y.useCallback)(()=>{
        if (typeof onAnimationEnd === 'function') onAnimationEnd();
        setIsAnimating(false);
    }, [
        onAnimationEnd
    ]);
    var handleAnimationStart = (0, $kc00y.useCallback)(()=>{
        if (typeof onAnimationStart === 'function') onAnimationStart();
        setIsAnimating(true);
    }, [
        onAnimationStart
    ]);
    return /*#__PURE__*/ $kc00y.createElement($ec65bf22e0d120c5$var$BarLabelListProvider, {
        showLabels: showLabels,
        rects: data
    }, /*#__PURE__*/ $kc00y.createElement((0, $a2871794a7a679f0$export$5d41821894c47c52), {
        animationId: animationId,
        begin: animationBegin,
        duration: animationDuration,
        isActive: isAnimationActive,
        easing: animationEasing,
        onAnimationEnd: handleAnimationEnd,
        onAnimationStart: handleAnimationStart,
        key: animationId
    }, (t)=>{
        var stepData = t === 1 ? data : data === null || data === void 0 ? void 0 : data.map((entry, index)=>{
            var prev = prevData && prevData[index];
            if (prev) return $ec65bf22e0d120c5$var$_objectSpread($ec65bf22e0d120c5$var$_objectSpread({}, entry), {}, {
                x: (0, $7e613228d3a31273$export$89e29e4ab65e70a9)(prev.x, entry.x, t),
                y: (0, $7e613228d3a31273$export$89e29e4ab65e70a9)(prev.y, entry.y, t),
                width: (0, $7e613228d3a31273$export$89e29e4ab65e70a9)(prev.width, entry.width, t),
                height: (0, $7e613228d3a31273$export$89e29e4ab65e70a9)(prev.height, entry.height, t)
            });
            if (layout === 'horizontal') {
                var height = (0, $7e613228d3a31273$export$89e29e4ab65e70a9)(0, entry.height, t);
                var y = (0, $7e613228d3a31273$export$89e29e4ab65e70a9)(entry.stackedBarStart, entry.y, t);
                return $ec65bf22e0d120c5$var$_objectSpread($ec65bf22e0d120c5$var$_objectSpread({}, entry), {}, {
                    y: y,
                    height: height
                });
            }
            var w = (0, $7e613228d3a31273$export$89e29e4ab65e70a9)(0, entry.width, t);
            var x = (0, $7e613228d3a31273$export$89e29e4ab65e70a9)(entry.stackedBarStart, entry.x, t);
            return $ec65bf22e0d120c5$var$_objectSpread($ec65bf22e0d120c5$var$_objectSpread({}, entry), {}, {
                width: w,
                x: x
            });
        });
        if (t > 0) // eslint-disable-next-line no-param-reassign
        previousRectanglesRef.current = stepData !== null && stepData !== void 0 ? stepData : null;
        if (stepData == null) return null;
        return /*#__PURE__*/ $kc00y.createElement((0, $553c02c7047f2968$export$936d0764594b6eb3), null, /*#__PURE__*/ $kc00y.createElement($ec65bf22e0d120c5$var$BarRectangles, {
            props: props,
            data: stepData
        }));
    }), /*#__PURE__*/ $kc00y.createElement((0, $acfbbd67802b75bf$export$9a402bc8de2b410e), {
        label: props.label
    }), props.children);
}
function $ec65bf22e0d120c5$var$RenderRectangles(props) {
    var previousRectanglesRef = (0, $kc00y.useRef)(null);
    return /*#__PURE__*/ $kc00y.createElement($ec65bf22e0d120c5$var$RectanglesWithAnimation, {
        previousRectanglesRef: previousRectanglesRef,
        props: props
    });
}
var $ec65bf22e0d120c5$var$defaultMinPointSize = 0;
var $ec65bf22e0d120c5$var$errorBarDataPointFormatter = (dataPoint, dataKey)=>{
    /**
   * if the value coming from `selectBarRectangles` is an array then this is a stacked bar chart.
   * arr[1] represents end value of the bar since the data is in the form of [startValue, endValue].
   * */ var value = Array.isArray(dataPoint.value) ? dataPoint.value[1] : dataPoint.value;
    return {
        x: dataPoint.x,
        y: dataPoint.y,
        value: value,
        // getValueByDataKey does not validate the output type
        errorVal: (0, $d5958b0668c58531$export$f97fc4a450f29a)(dataPoint, dataKey)
    };
};
class $ec65bf22e0d120c5$var$BarWithState extends (0, $kc00y.PureComponent) {
    render() {
        var { hide: hide, data: data, dataKey: dataKey, className: className, xAxisId: xAxisId, yAxisId: yAxisId, needClip: needClip, background: background, id: id } = this.props;
        if (hide || data == null) return null;
        var layerClass = (0, $328c1c2632e2f292$export$4f5d2d50c9deca37)('recharts-bar', className);
        var clipPathId = id;
        return /*#__PURE__*/ $kc00y.createElement((0, $553c02c7047f2968$export$936d0764594b6eb3), {
            className: layerClass,
            id: id
        }, needClip && /*#__PURE__*/ $kc00y.createElement("defs", null, /*#__PURE__*/ $kc00y.createElement((0, $a81188c028cebd88$export$d65f7a7dd82fbb63), {
            clipPathId: clipPathId,
            xAxisId: xAxisId,
            yAxisId: yAxisId
        })), /*#__PURE__*/ $kc00y.createElement((0, $553c02c7047f2968$export$936d0764594b6eb3), {
            className: "recharts-bar-rectangles",
            clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : undefined
        }, /*#__PURE__*/ $kc00y.createElement($ec65bf22e0d120c5$var$BarBackground, {
            data: data,
            dataKey: dataKey,
            background: background,
            allOtherBarProps: this.props
        }), /*#__PURE__*/ $kc00y.createElement($ec65bf22e0d120c5$var$RenderRectangles, this.props)));
    }
}
var $ec65bf22e0d120c5$export$ae0fe71c3c345c68 = {
    activeBar: false,
    animationBegin: 0,
    animationDuration: 400,
    animationEasing: 'ease',
    background: false,
    hide: false,
    isAnimationActive: 'auto',
    label: false,
    legendType: 'rect',
    minPointSize: $ec65bf22e0d120c5$var$defaultMinPointSize,
    xAxisId: 0,
    yAxisId: 0,
    zIndex: (0, $2d4105c5b5d94e8f$export$96df16b28aa32702).bar
};
function $ec65bf22e0d120c5$var$BarImpl(props) {
    var { xAxisId: xAxisId, yAxisId: yAxisId, hide: hide, legendType: legendType, minPointSize: minPointSize, activeBar: activeBar, animationBegin: animationBegin, animationDuration: animationDuration, animationEasing: animationEasing, isAnimationActive: isAnimationActive } = props;
    var { needClip: needClip } = (0, $a81188c028cebd88$export$79e142f66441c204)(xAxisId, yAxisId);
    var layout = (0, $f4c9341f05a18477$export$970c79ecc7081cc)();
    var isPanorama = (0, $10d1d693b6b228cd$export$4b0c59f8845ba920)();
    var cells = (0, $b54930f6e6643156$export$fdd5e64c0e8495bb)(props.children, (0, $af579bd742156f26$export$f6f0c3fe4ec306ea));
    var rects = (0, $a441e801d1b41b52$export$a7347740d65f620b)((state)=>(0, $f7cdddd408b98c5e$export$bb89ca2d15dbced9)(state, props.id, isPanorama, cells));
    if (layout !== 'vertical' && layout !== 'horizontal') return null;
    var errorBarOffset;
    var firstDataPoint = rects === null || rects === void 0 ? void 0 : rects[0];
    if (firstDataPoint == null || firstDataPoint.height == null || firstDataPoint.width == null) errorBarOffset = 0;
    else errorBarOffset = layout === 'vertical' ? firstDataPoint.height / 2 : firstDataPoint.width / 2;
    return /*#__PURE__*/ $kc00y.createElement((0, $e0c673dc3502801b$export$fcd6ba6fb4bc66e7), {
        xAxisId: xAxisId,
        yAxisId: yAxisId,
        data: rects,
        dataPointFormatter: $ec65bf22e0d120c5$var$errorBarDataPointFormatter,
        errorBarOffset: errorBarOffset
    }, /*#__PURE__*/ $kc00y.createElement($ec65bf22e0d120c5$var$BarWithState, $ec65bf22e0d120c5$var$_extends({}, props, {
        layout: layout,
        needClip: needClip,
        data: rects,
        xAxisId: xAxisId,
        yAxisId: yAxisId,
        hide: hide,
        legendType: legendType,
        minPointSize: minPointSize,
        activeBar: activeBar,
        animationBegin: animationBegin,
        animationDuration: animationDuration,
        animationEasing: animationEasing,
        isAnimationActive: isAnimationActive
    })));
}
function $ec65bf22e0d120c5$export$3b2ba7a38b022e(_ref6) {
    var { layout: layout, barSettings: { dataKey: dataKey, minPointSize: minPointSizeProp, hasCustomShape: hasCustomShape }, pos: pos, bandSize: bandSize, xAxis: xAxis, yAxis: yAxis, xAxisTicks: xAxisTicks, yAxisTicks: yAxisTicks, stackedData: stackedData, displayedData: displayedData, offset: offset, cells: cells, parentViewBox: parentViewBox, dataStartIndex: dataStartIndex } = _ref6;
    var numericAxis = layout === 'horizontal' ? yAxis : xAxis;
    // @ts-expect-error this assumes that the domain is always numeric, but doesn't check for it
    var stackedDomain = stackedData ? numericAxis.scale.domain() : null;
    var baseValue = (0, $d5958b0668c58531$export$54f3200dd4a8a235)({
        numericAxis: numericAxis
    });
    var stackedBarStart = numericAxis.scale.map(baseValue);
    return displayedData.map((entry, index)=>{
        var value, x, y, width, height, background;
        if (stackedData) {
            // Use dataStartIndex to access the correct element in the full stackedData array
            var untruncatedValue = stackedData[index + dataStartIndex];
            if (untruncatedValue == null) return null;
            value = (0, $d5958b0668c58531$export$c7ec0fa96d0c462e)(untruncatedValue, stackedDomain);
        } else {
            value = (0, $d5958b0668c58531$export$f97fc4a450f29a)(entry, dataKey);
            if (!Array.isArray(value)) value = [
                baseValue,
                value
            ];
        }
        var minPointSize = (0, $4b9606aec568c4dd$export$c20d73790de171f0)(minPointSizeProp, $ec65bf22e0d120c5$var$defaultMinPointSize)(value[1], index);
        if (layout === 'horizontal') {
            var _ref7;
            var baseValueScale = yAxis.scale.map(value[0]);
            var currentValueScale = yAxis.scale.map(value[1]);
            if (baseValueScale == null || currentValueScale == null) return null;
            x = (0, $d5958b0668c58531$export$8abb9e87422f3a0c)({
                axis: xAxis,
                ticks: xAxisTicks,
                bandSize: bandSize,
                offset: pos.offset,
                entry: entry,
                index: index
            });
            y = (_ref7 = currentValueScale !== null && currentValueScale !== void 0 ? currentValueScale : baseValueScale) !== null && _ref7 !== void 0 ? _ref7 : undefined;
            width = pos.size;
            var computedHeight = baseValueScale - currentValueScale;
            height = (0, $7e613228d3a31273$export$e426a261f3212d7d)(computedHeight) ? 0 : computedHeight;
            background = {
                x: x,
                y: offset.top,
                width: width,
                height: offset.height
            };
            if (Math.abs(minPointSize) > 0 && Math.abs(height) < Math.abs(minPointSize)) {
                var delta = (0, $7e613228d3a31273$export$9d334328eb75e624)(height || minPointSize) * (Math.abs(minPointSize) - Math.abs(height));
                y -= delta;
                height += delta;
            }
        } else {
            var _baseValueScale = xAxis.scale.map(value[0]);
            var _currentValueScale = xAxis.scale.map(value[1]);
            if (_baseValueScale == null || _currentValueScale == null) return null;
            x = _baseValueScale;
            y = (0, $d5958b0668c58531$export$8abb9e87422f3a0c)({
                axis: yAxis,
                ticks: yAxisTicks,
                bandSize: bandSize,
                offset: pos.offset,
                entry: entry,
                index: index
            });
            width = _currentValueScale - _baseValueScale;
            height = pos.size;
            background = {
                x: offset.left,
                y: y,
                width: offset.width,
                height: height
            };
            if (Math.abs(minPointSize) > 0 && Math.abs(width) < Math.abs(minPointSize)) {
                var _delta = (0, $7e613228d3a31273$export$9d334328eb75e624)(width || minPointSize) * (Math.abs(minPointSize) - Math.abs(width));
                width += _delta;
            }
        }
        /*
     * Filter out 0-dimension rectangles early to avoid creating unnecessary component trees.
     * BarStack clip-paths use originalDataIndex, so sparse filtered arrays remain index-stable.
     * Bars with a custom shape are not filtered out: the custom renderer may still draw something
     * visible at zero-dimension positions (e.g. horizontal lines in a BoxPlot).
     */ if (x == null || y == null || width == null || height == null || !hasCustomShape && (width === 0 || height === 0)) return null;
        var barRectangleItem = $ec65bf22e0d120c5$var$_objectSpread($ec65bf22e0d120c5$var$_objectSpread({}, entry), {}, {
            stackedBarStart: stackedBarStart,
            x: x,
            y: y,
            width: width,
            height: height,
            value: stackedData ? value : value[1],
            payload: entry,
            background: background,
            tooltipPosition: {
                x: x + width / 2,
                y: y + height / 2
            },
            parentViewBox: parentViewBox,
            originalDataIndex: index
        }, cells && cells[index] && cells[index].props);
        return barRectangleItem;
    }).filter(Boolean);
}
function $ec65bf22e0d120c5$var$BarFn(outsideProps) {
    var props = (0, $4cc2299923ef69c7$export$45004cc70a390ee8)(outsideProps, $ec65bf22e0d120c5$export$ae0fe71c3c345c68);
    // stackId may arrive from props or from BarStack context
    var stackId = (0, $ae845200f5e42186$export$837efb24f50d011e)(props.stackId);
    var isPanorama = (0, $10d1d693b6b228cd$export$4b0c59f8845ba920)();
    // Report all props to Redux store first, before calling any hooks, to avoid circular dependencies.
    return /*#__PURE__*/ $kc00y.createElement((0, $f34dba1288eb5faf$export$8c2f307ff93f02ba), {
        id: props.id,
        type: "bar"
    }, (id)=>/*#__PURE__*/ $kc00y.createElement($kc00y.Fragment, null, /*#__PURE__*/ $kc00y.createElement((0, $969c2df561fbe708$export$34b61b169492c008), {
            legendPayload: $ec65bf22e0d120c5$var$computeLegendPayloadFromBarData(props)
        }), /*#__PURE__*/ $kc00y.createElement($ec65bf22e0d120c5$var$SetBarTooltipEntrySettings, {
            dataKey: props.dataKey,
            stroke: props.stroke,
            strokeWidth: props.strokeWidth,
            fill: props.fill,
            name: props.name,
            hide: props.hide,
            unit: props.unit,
            tooltipType: props.tooltipType,
            id: id
        }), /*#__PURE__*/ $kc00y.createElement((0, $b22a299c3f7b2080$export$b600bf9c1966a9c2), {
            type: "bar",
            id: id,
            data: undefined,
            xAxisId: props.xAxisId,
            yAxisId: props.yAxisId,
            zAxisId: 0,
            dataKey: props.dataKey,
            stackId: stackId,
            hide: props.hide,
            barSize: props.barSize,
            minPointSize: props.minPointSize,
            maxBarSize: props.maxBarSize,
            isPanorama: isPanorama,
            hasCustomShape: props.shape != null
        }), /*#__PURE__*/ $kc00y.createElement((0, $a6cde822fe24aa10$export$b37befaf92aba9f1), {
            zIndex: props.zIndex
        }, /*#__PURE__*/ $kc00y.createElement($ec65bf22e0d120c5$var$BarImpl, $ec65bf22e0d120c5$var$_extends({}, props, {
            id: id
        })))));
}
var $ec65bf22e0d120c5$export$bbc6c6369b38e3d1 = /*#__PURE__*/ $kc00y.memo($ec65bf22e0d120c5$var$BarFn, (0, $13251e7ce0459d7b$export$b8f09df787c278d9));
// @ts-expect-error we need to set the displayName for debugging purposes
$ec65bf22e0d120c5$export$bbc6c6369b38e3d1.displayName = 'Bar';


var $kc00y = parcelRequire("kc00y");


var $06bd4d083c59b4ed$export$3d996ff386c7802d = (data, strIndex)=>{
    if (!strIndex) return undefined;
    if (!Array.isArray(data)) return undefined;
    var numIndex = Number.parseInt(strIndex, 10);
    if ((0, $7e613228d3a31273$export$e426a261f3212d7d)(numIndex)) return undefined;
    return data[numIndex];
};
var $06bd4d083c59b4ed$var$initialState = {
    chartName: '',
    tooltipPayloadSearcher: ()=>undefined,
    eventEmitter: undefined,
    defaultTooltipEventType: 'axis'
};
var $06bd4d083c59b4ed$var$optionsSlice = (0, $df8b6ce3f4df1ba5$export$4d8d9bd83c24ae8b)({
    name: 'options',
    initialState: $06bd4d083c59b4ed$var$initialState,
    reducers: {
        createEventEmitter: (state)=>{
            if (state.eventEmitter == null) state.eventEmitter = Symbol('rechartsEventEmitter');
        }
    }
});
var $06bd4d083c59b4ed$export$81a3ba457dd82bec = $06bd4d083c59b4ed$var$optionsSlice.reducer;
var { createEventEmitter: $06bd4d083c59b4ed$export$abfecd6a8e6070c1 } = $06bd4d083c59b4ed$var$optionsSlice.actions;



var $kc00y = parcelRequire("kc00y");

var $kc00y = parcelRequire("kc00y");






var $013669191ef6e95a$export$7285b50bc333b067 = {
    chartData: undefined,
    computedData: undefined,
    dataStartIndex: 0,
    dataEndIndex: 0
};
var $013669191ef6e95a$var$chartDataSlice = (0, $df8b6ce3f4df1ba5$export$4d8d9bd83c24ae8b)({
    name: 'chartData',
    initialState: $013669191ef6e95a$export$7285b50bc333b067,
    reducers: {
        setChartData (state, action) {
            state.chartData = (0, $808ce0820c1669b6$export$c05b21e3257751e5)(action.payload);
            if (action.payload == null) {
                state.dataStartIndex = 0;
                state.dataEndIndex = 0;
                return;
            }
            if (action.payload.length > 0 && state.dataEndIndex !== action.payload.length - 1) state.dataEndIndex = action.payload.length - 1;
        },
        setComputedData (state, action) {
            state.computedData = action.payload;
        },
        setDataStartEndIndexes (state, action) {
            var { startIndex: startIndex, endIndex: endIndex } = action.payload;
            if (startIndex != null) state.dataStartIndex = startIndex;
            if (endIndex != null) state.dataEndIndex = endIndex;
        }
    }
});
var { setChartData: $013669191ef6e95a$export$624c47d88733f253, setDataStartEndIndexes: $013669191ef6e95a$export$427d605cc4e3bbdd, setComputedData: $013669191ef6e95a$export$9b2e7f4962514250 } = $013669191ef6e95a$var$chartDataSlice.actions;
var $013669191ef6e95a$export$52973ca5fce0a5d5 = $013669191ef6e95a$var$chartDataSlice.reducer;






























function $0e8a4c5292f77c49$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0e8a4c5292f77c49$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0e8a4c5292f77c49$var$ownKeys(Object(t), !0).forEach(function(r) {
            $0e8a4c5292f77c49$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0e8a4c5292f77c49$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $0e8a4c5292f77c49$var$_defineProperty(e, r, t) {
    return (r = $0e8a4c5292f77c49$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $0e8a4c5292f77c49$var$_toPropertyKey(t) {
    var i = $0e8a4c5292f77c49$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $0e8a4c5292f77c49$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $0e8a4c5292f77c49$export$cfad5721ad1fe55 = (layout, tooltipTicks, activeIndex, pointer)=>{
    var entry = tooltipTicks.find((tick)=>tick && tick.index === activeIndex);
    if (entry) {
        if (layout === 'horizontal') return {
            x: entry.coordinate,
            y: pointer.relativeY
        };
        if (layout === 'vertical') return {
            x: pointer.relativeX,
            y: entry.coordinate
        };
    }
    return {
        x: 0,
        y: 0
    };
};
var $0e8a4c5292f77c49$export$6bc723868198544 = (layout, tooltipTicks, activeIndex, rangeObj)=>{
    var entry = tooltipTicks.find((tick)=>tick && tick.index === activeIndex);
    if (entry) {
        if (layout === 'centric') {
            var _angle = entry.coordinate;
            var { radius: _radius } = rangeObj;
            return $0e8a4c5292f77c49$var$_objectSpread($0e8a4c5292f77c49$var$_objectSpread($0e8a4c5292f77c49$var$_objectSpread({}, rangeObj), (0, $68befda7de8b3621$export$5c9a959bb3fc7749)(rangeObj.cx, rangeObj.cy, _radius, _angle)), {}, {
                angle: _angle,
                radius: _radius
            });
        }
        var radius = entry.coordinate;
        var { angle: angle } = rangeObj;
        return $0e8a4c5292f77c49$var$_objectSpread($0e8a4c5292f77c49$var$_objectSpread($0e8a4c5292f77c49$var$_objectSpread({}, rangeObj), (0, $68befda7de8b3621$export$5c9a959bb3fc7749)(rangeObj.cx, rangeObj.cy, radius, angle)), {}, {
            angle: angle,
            radius: radius
        });
    }
    return {
        angle: 0,
        clockWise: false,
        cx: 0,
        cy: 0,
        endAngle: 0,
        innerRadius: 0,
        outerRadius: 0,
        radius: 0,
        startAngle: 0,
        x: 0,
        y: 0
    };
};
function $0e8a4c5292f77c49$export$215f974420919247(pointer, offset) {
    var { relativeX: x, relativeY: y } = pointer;
    return x >= offset.left && x <= offset.left + offset.width && y >= offset.top && y <= offset.top + offset.height;
}
var $0e8a4c5292f77c49$export$3071d39cc844078e = (coordinate, ticks, unsortedTicks, axisType, range)=>{
    var _ticks$length;
    var len = (_ticks$length = ticks === null || ticks === void 0 ? void 0 : ticks.length) !== null && _ticks$length !== void 0 ? _ticks$length : 0;
    // if there are 1 or fewer ticks or if there is no coordinate then the active tick is at index 0
    if (len <= 1 || coordinate == null) return 0;
    if (axisType === 'angleAxis' && range != null && Math.abs(Math.abs(range[1] - range[0]) - 360) <= 1e-6) // ticks are distributed in a circle
    for(var i = 0; i < len; i++){
        var _unsortedTicks, _unsortedTicks2, _unsortedTicks$i, _unsortedTicks$, _unsortedTicks3;
        var before = i > 0 ? (_unsortedTicks = unsortedTicks[i - 1]) === null || _unsortedTicks === void 0 ? void 0 : _unsortedTicks.coordinate : (_unsortedTicks2 = unsortedTicks[len - 1]) === null || _unsortedTicks2 === void 0 ? void 0 : _unsortedTicks2.coordinate;
        var cur = (_unsortedTicks$i = unsortedTicks[i]) === null || _unsortedTicks$i === void 0 ? void 0 : _unsortedTicks$i.coordinate;
        var after = i >= len - 1 ? (_unsortedTicks$ = unsortedTicks[0]) === null || _unsortedTicks$ === void 0 ? void 0 : _unsortedTicks$.coordinate : (_unsortedTicks3 = unsortedTicks[i + 1]) === null || _unsortedTicks3 === void 0 ? void 0 : _unsortedTicks3.coordinate;
        var sameDirectionCoord = void 0;
        if (before == null || cur == null || after == null) continue;
        if ((0, $7e613228d3a31273$export$9d334328eb75e624)(cur - before) !== (0, $7e613228d3a31273$export$9d334328eb75e624)(after - cur)) {
            var diffInterval = [];
            if ((0, $7e613228d3a31273$export$9d334328eb75e624)(after - cur) === (0, $7e613228d3a31273$export$9d334328eb75e624)(range[1] - range[0])) {
                sameDirectionCoord = after;
                var curInRange = cur + range[1] - range[0];
                diffInterval[0] = Math.min(curInRange, (curInRange + before) / 2);
                diffInterval[1] = Math.max(curInRange, (curInRange + before) / 2);
            } else {
                sameDirectionCoord = before;
                var afterInRange = after + range[1] - range[0];
                diffInterval[0] = Math.min(cur, (afterInRange + cur) / 2);
                diffInterval[1] = Math.max(cur, (afterInRange + cur) / 2);
            }
            var sameInterval = [
                Math.min(cur, (sameDirectionCoord + cur) / 2),
                Math.max(cur, (sameDirectionCoord + cur) / 2)
            ];
            if (coordinate > sameInterval[0] && coordinate <= sameInterval[1] || coordinate >= diffInterval[0] && coordinate <= diffInterval[1]) {
                var _unsortedTicks$i2;
                return (_unsortedTicks$i2 = unsortedTicks[i]) === null || _unsortedTicks$i2 === void 0 ? void 0 : _unsortedTicks$i2.index;
            }
        } else {
            var minValue = Math.min(before, after);
            var maxValue = Math.max(before, after);
            if (coordinate > (minValue + cur) / 2 && coordinate <= (maxValue + cur) / 2) {
                var _unsortedTicks$i3;
                return (_unsortedTicks$i3 = unsortedTicks[i]) === null || _unsortedTicks$i3 === void 0 ? void 0 : _unsortedTicks$i3.index;
            }
        }
    }
    else if (ticks) // ticks are distributed in a single direction
    for(var _i = 0; _i < len; _i++){
        var curr = ticks[_i];
        if (curr == null) continue;
        var next = ticks[_i + 1];
        var prev = ticks[_i - 1];
        if (_i === 0 && next != null && coordinate <= (curr.coordinate + next.coordinate) / 2) return curr.index;
        if (_i === len - 1 && prev != null && coordinate > (curr.coordinate + prev.coordinate) / 2) return curr.index;
        if (_i > 0 && _i < len - 1 && prev != null && next != null && coordinate > (curr.coordinate + prev.coordinate) / 2 && coordinate <= (curr.coordinate + next.coordinate) / 2) return curr.index;
    }
    return -1;
};



var $f310c8c70271e4da$export$ed30b3372172c46c = ()=>{
    return (0, $a441e801d1b41b52$export$a7347740d65f620b)((0, $1728a742f9386be1$export$3247769c9dbde559));
};
var $f310c8c70271e4da$var$pickTooltipEventType = (_state, tooltipEventType)=>tooltipEventType;
var $f310c8c70271e4da$var$pickTrigger = (_state, _tooltipEventType, trigger)=>trigger;
var $f310c8c70271e4da$var$pickDefaultIndex = (_state, _tooltipEventType, _trigger, defaultIndex)=>defaultIndex;
var $f310c8c70271e4da$export$e133bec3c93a9247 = (0, $757e1d271f969f78$export$595d22ed68ca2841)((0, $dbde609d2e66e7f4$export$ffe0e60f8c88c05a), (ticks)=>(0, (/*@__PURE__*/$parcel$interopDefault($ce976de4b913f215$exports)))(ticks, (o)=>o.coordinate));
var $f310c8c70271e4da$export$1288ff5c64c4ac42 = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    (0, $4f20250cfa418037$export$703b585bc92b5bae),
    $f310c8c70271e4da$var$pickTooltipEventType,
    $f310c8c70271e4da$var$pickTrigger,
    $f310c8c70271e4da$var$pickDefaultIndex
], (0, $2c79ab71c40f52be$export$d759c39cacfacf6a));
var $f310c8c70271e4da$export$95fb15d7bb7a8a94 = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $f310c8c70271e4da$export$1288ff5c64c4ac42,
    (0, $dbde609d2e66e7f4$export$5a8beccc8250d20e),
    (0, $223cdb002ac9c48b$export$bf8397fefbaa3617),
    (0, $dbde609d2e66e7f4$export$76f7a1975f60ccf1)
], (0, $616bfe7b3ded2280$export$32df4b03a0962e46));
var $f310c8c70271e4da$export$faa2b8b92235e5bd = (state, tooltipEventType, trigger)=>{
    if (tooltipEventType == null) return undefined;
    var tooltipState = (0, $4f20250cfa418037$export$703b585bc92b5bae)(state);
    if (tooltipEventType === 'axis') {
        if (trigger === 'hover') return tooltipState.axisInteraction.hover.dataKey;
        return tooltipState.axisInteraction.click.dataKey;
    }
    if (trigger === 'hover') return tooltipState.itemInteraction.hover.dataKey;
    return tooltipState.itemInteraction.click.dataKey;
};
var $f310c8c70271e4da$export$8ff07a725463bd5 = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    (0, $4f20250cfa418037$export$703b585bc92b5bae),
    $f310c8c70271e4da$var$pickTooltipEventType,
    $f310c8c70271e4da$var$pickTrigger,
    $f310c8c70271e4da$var$pickDefaultIndex
], (0, $4ea745cac09f05e3$export$45044aaa79c0cddb));
var $f310c8c70271e4da$export$7dbe424d18defe7d = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    (0, $0b675d94b376aa83$export$771ef0ac044f724d),
    (0, $0b675d94b376aa83$export$5856a7d94c109505),
    (0, $f4c9341f05a18477$export$8426b6d9af801dee),
    (0, $cd6092f0bbb953fd$export$1e34c8efb0bc9b3b),
    (0, $dbde609d2e66e7f4$export$ffe0e60f8c88c05a),
    $f310c8c70271e4da$var$pickDefaultIndex,
    $f310c8c70271e4da$export$8ff07a725463bd5
], (0, $a27882997ab1ddd6$export$c2cbc37a7546bbd0));
var $f310c8c70271e4da$export$392a0083df9bfd7c = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $f310c8c70271e4da$export$1288ff5c64c4ac42,
    $f310c8c70271e4da$export$7dbe424d18defe7d
], (tooltipInteractionState, defaultIndexCoordinate)=>{
    var _tooltipInteractionSt;
    return (_tooltipInteractionSt = tooltipInteractionState.coordinate) !== null && _tooltipInteractionSt !== void 0 ? _tooltipInteractionSt : defaultIndexCoordinate;
});
var $f310c8c70271e4da$export$400c35cc3b9a0487 = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    (0, $dbde609d2e66e7f4$export$ffe0e60f8c88c05a),
    $f310c8c70271e4da$export$95fb15d7bb7a8a94
], (0, $c06897a9b2abaf8e$export$3213c4688ceb4c80));
var $f310c8c70271e4da$export$529676bfdba08611 = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $f310c8c70271e4da$export$8ff07a725463bd5,
    $f310c8c70271e4da$export$95fb15d7bb7a8a94,
    (0, $8c22b3d5bf36186c$export$519edd692222520),
    (0, $223cdb002ac9c48b$export$bf8397fefbaa3617),
    $f310c8c70271e4da$export$400c35cc3b9a0487,
    (0, $e90b5e71a23643c7$export$6ae1ee94e6fa88a7),
    $f310c8c70271e4da$var$pickTooltipEventType
], (0, $1efda367f97cd466$export$e50d50655fe0e7ab));
var $f310c8c70271e4da$export$c8884ed37796034a = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $f310c8c70271e4da$export$1288ff5c64c4ac42,
    $f310c8c70271e4da$export$95fb15d7bb7a8a94
], (tooltipInteractionState, activeIndex)=>{
    return {
        isActive: tooltipInteractionState.active && activeIndex != null,
        activeIndex: activeIndex
    };
});
var $f310c8c70271e4da$var$combineActiveCartesianProps = (chartEvent, layout, tooltipAxisType, tooltipAxisRange, tooltipTicks, orderedTooltipTicks, offset)=>{
    if (!chartEvent || !tooltipAxisType || !tooltipAxisRange || !tooltipTicks) return undefined;
    if (!(0, $0e8a4c5292f77c49$export$215f974420919247)(chartEvent, offset)) return undefined;
    var pos = (0, $d5958b0668c58531$export$f29fac779ccd75bc)(chartEvent, layout);
    var activeIndex = (0, $0e8a4c5292f77c49$export$3071d39cc844078e)(pos, orderedTooltipTicks, tooltipTicks, tooltipAxisType, tooltipAxisRange);
    var activeCoordinate = (0, $0e8a4c5292f77c49$export$cfad5721ad1fe55)(layout, tooltipTicks, activeIndex, chartEvent);
    return {
        activeIndex: String(activeIndex),
        activeCoordinate: activeCoordinate
    };
};
var $f310c8c70271e4da$var$combineActivePolarProps = (chartEvent, layout, polarViewBox, tooltipAxisType, tooltipAxisRange, tooltipTicks, orderedTooltipTicks)=>{
    if (!chartEvent || !tooltipAxisType || !tooltipAxisRange || !tooltipTicks || !polarViewBox) return undefined;
    var rangeObj = (0, $68befda7de8b3621$export$e85a2bf8cd31c504)(chartEvent, polarViewBox);
    if (!rangeObj) return undefined;
    var pos = (0, $d5958b0668c58531$export$fb2b0f76aa25d837)(rangeObj, layout);
    var activeIndex = (0, $0e8a4c5292f77c49$export$3071d39cc844078e)(pos, orderedTooltipTicks, tooltipTicks, tooltipAxisType, tooltipAxisRange);
    var activeCoordinate = (0, $0e8a4c5292f77c49$export$6bc723868198544)(layout, tooltipTicks, activeIndex, rangeObj);
    return {
        activeIndex: String(activeIndex),
        activeCoordinate: activeCoordinate
    };
};
var $f310c8c70271e4da$export$e1c9f959fffb37b4 = (chartEvent, layout, polarViewBox, tooltipAxisType, tooltipAxisRange, tooltipTicks, orderedTooltipTicks, offset)=>{
    if (!chartEvent || !layout || !tooltipAxisType || !tooltipAxisRange || !tooltipTicks) return undefined;
    if (layout === 'horizontal' || layout === 'vertical') return $f310c8c70271e4da$var$combineActiveCartesianProps(chartEvent, layout, tooltipAxisType, tooltipAxisRange, tooltipTicks, orderedTooltipTicks, offset);
    return $f310c8c70271e4da$var$combineActivePolarProps(chartEvent, layout, polarViewBox, tooltipAxisType, tooltipAxisRange, tooltipTicks, orderedTooltipTicks);
};




var $912ccca734443a3b$var$pickChartPointer = (_state, chartPointer)=>chartPointer;
var $912ccca734443a3b$export$2cfb761a54690867 = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $912ccca734443a3b$var$pickChartPointer,
    (0, $f4c9341f05a18477$export$8426b6d9af801dee),
    (0, $792f72abcce61010$export$57f4101c1e20bd95),
    (0, $ab8db2d9eb83d918$export$898d3dfd98fb482),
    (0, $dbde609d2e66e7f4$export$cf4d6dfce3a76af3),
    (0, $dbde609d2e66e7f4$export$ffe0e60f8c88c05a),
    (0, $f310c8c70271e4da$export$e133bec3c93a9247),
    (0, $cd6092f0bbb953fd$export$1e34c8efb0bc9b3b)
], (0, $f310c8c70271e4da$export$e1c9f959fffb37b4));



/**
 * Type guard to check if the pointer event is from an SVG element.
 */ function $f87ceae7e349c2cc$var$isSvgPointer(pointer) {
    return 'getBBox' in pointer.currentTarget && typeof pointer.currentTarget.getBBox === 'function';
}
function $f87ceae7e349c2cc$export$4f29f8e5290cb0bb(event) {
    var rect = event.currentTarget.getBoundingClientRect();
    var scaleX, scaleY;
    if ($f87ceae7e349c2cc$var$isSvgPointer(event)) {
        // For SVG elements, use getBBox() to get the intrinsic size in SVG coordinates
        var bbox = event.currentTarget.getBBox();
        scaleX = bbox.width > 0 ? rect.width / bbox.width : 1;
        scaleY = bbox.height > 0 ? rect.height / bbox.height : 1;
    } else {
        // For HTML elements, use offsetWidth/offsetHeight
        var element = event.currentTarget;
        scaleX = element.offsetWidth > 0 ? rect.width / element.offsetWidth : 1;
        scaleY = element.offsetHeight > 0 ? rect.height / element.offsetHeight : 1;
    }
    var getCoordinates = (clientX, clientY)=>({
            /*
     * Here it's important to use:
     * - event.clientX and event.clientY to get the mouse position relative to the viewport, including scroll.
     * - pageX and pageY are not used because they are relative to the whole document, and ignore scroll.
     * - rect.left and rect.top are used to get the position of the chart relative to the viewport.
     * - offsetX and offsetY are not used because they are relative to the offset parent
     *  which may or may not be the same as the clientX and clientY, depending on the position of the chart in the DOM
     *  and surrounding element styles. CSS position: relative, absolute, fixed, will change the offset parent.
     * - scaleX and scaleY are necessary for when the chart element is scaled using CSS `transform: scale(N)`.
     */ relativeX: Math.round((clientX - rect.left) / scaleX),
            relativeY: Math.round((clientY - rect.top) / scaleY)
        });
    if ('touches' in event) return Array.from(event.touches).map((touch)=>getCoordinates(touch.clientX, touch.clientY));
    return getCoordinates(event.clientX, event.clientY);
}


var $18f6e3b3e4e52774$export$f06e14b484aecafc = (0, $df8b6ce3f4df1ba5$export$309c7a02b0b0bc62)('mouseClick');
var $18f6e3b3e4e52774$export$fb3df626ae9864a = (0, $df8b6ce3f4df1ba5$export$1228acebbbcb485b)();
// TODO: there's a bug here when you click the chart the activeIndex resets to zero
$18f6e3b3e4e52774$export$fb3df626ae9864a.startListening({
    actionCreator: $18f6e3b3e4e52774$export$f06e14b484aecafc,
    effect: (action, listenerApi)=>{
        var mousePointer = action.payload;
        var activeProps = (0, $912ccca734443a3b$export$2cfb761a54690867)(listenerApi.getState(), (0, $f87ceae7e349c2cc$export$4f29f8e5290cb0bb)(mousePointer));
        if ((activeProps === null || activeProps === void 0 ? void 0 : activeProps.activeIndex) != null) listenerApi.dispatch((0, $2bfb679c145bcb6f$export$d2b1af5c3a560528)({
            activeIndex: activeProps.activeIndex,
            activeDataKey: undefined,
            activeCoordinate: activeProps.activeCoordinate
        }));
    }
});
var $18f6e3b3e4e52774$export$f9de213dbfb2e32c = (0, $df8b6ce3f4df1ba5$export$309c7a02b0b0bc62)('mouseMove');
var $18f6e3b3e4e52774$export$b7e1b38eb227944a = (0, $df8b6ce3f4df1ba5$export$1228acebbbcb485b)();
/*
 * This single rafId is safe because:
 * 1. Each chart has its own Redux store instance with its own middleware
 * 2. mouseMoveAction only fires from one DOM element (the chart wrapper)
 * 3. Rapid mousemove events from the same element SHOULD debounce - we only care about the latest position
 * This is different from externalEventsMiddleware which handles multiple event types
 * (click, mouseenter, mouseleave, etc.) that should NOT cancel each other.
 */ var $18f6e3b3e4e52774$var$rafId = null;
var $18f6e3b3e4e52774$var$timeoutId = null;
var $18f6e3b3e4e52774$var$latestChartPointer = null;
$18f6e3b3e4e52774$export$b7e1b38eb227944a.startListening({
    actionCreator: $18f6e3b3e4e52774$export$f9de213dbfb2e32c,
    effect: (action, listenerApi)=>{
        var mousePointer = action.payload;
        var state = listenerApi.getState();
        var { throttleDelay: throttleDelay, throttledEvents: throttledEvents } = state.eventSettings;
        var isThrottled = throttledEvents === 'all' || (throttledEvents === null || throttledEvents === void 0 ? void 0 : throttledEvents.includes('mousemove'));
        // Cancel any pending execution
        if ($18f6e3b3e4e52774$var$rafId !== null) {
            cancelAnimationFrame($18f6e3b3e4e52774$var$rafId);
            $18f6e3b3e4e52774$var$rafId = null;
        }
        if ($18f6e3b3e4e52774$var$timeoutId !== null && (typeof throttleDelay !== 'number' || !isThrottled)) {
            clearTimeout($18f6e3b3e4e52774$var$timeoutId);
            $18f6e3b3e4e52774$var$timeoutId = null;
        }
        /*
     * Here it is important to resolve the chart pointer _before_ the callback,
     * because once we leave the current event loop, the mousePointer event object will lose
     * reference to currentTarget which getRelativeCoordinate uses.
     */ $18f6e3b3e4e52774$var$latestChartPointer = (0, $f87ceae7e349c2cc$export$4f29f8e5290cb0bb)(mousePointer);
        var callback = ()=>{
            /*
       * Here we read a fresh state again inside the callback to ensure we have the latest state values
       * after any potential actions that may have been dispatched between the original event and this callback.
       */ var currentState = listenerApi.getState();
            var tooltipEventType = (0, $1e9e9b3c1f2abdf7$export$53af65c2db668fac)(currentState, currentState.tooltip.settings.shared);
            if (!$18f6e3b3e4e52774$var$latestChartPointer) {
                $18f6e3b3e4e52774$var$rafId = null;
                $18f6e3b3e4e52774$var$timeoutId = null;
                return;
            }
            /*
       * This functionality only applies to charts that have axes.
       * Graphical items have its own mouse events handling mechanism where they attach events directly to the items.
       */ if (tooltipEventType === 'axis') {
                var activeProps = (0, $912ccca734443a3b$export$2cfb761a54690867)(currentState, $18f6e3b3e4e52774$var$latestChartPointer);
                if ((activeProps === null || activeProps === void 0 ? void 0 : activeProps.activeIndex) != null) listenerApi.dispatch((0, $2bfb679c145bcb6f$export$a7277636863fc703)({
                    activeIndex: activeProps.activeIndex,
                    activeDataKey: undefined,
                    activeCoordinate: activeProps.activeCoordinate
                }));
                else // this is needed to clear tooltip state when the mouse moves out of the inRange (svg - offset) function, but not yet out of the svg
                listenerApi.dispatch((0, $2bfb679c145bcb6f$export$73879bed3f2eef71)());
            }
            $18f6e3b3e4e52774$var$rafId = null;
            $18f6e3b3e4e52774$var$timeoutId = null;
        };
        if (!isThrottled) {
            callback();
            return;
        }
        if (throttleDelay === 'raf') $18f6e3b3e4e52774$var$rafId = requestAnimationFrame(callback);
        else if (typeof throttleDelay === 'number') {
            if ($18f6e3b3e4e52774$var$timeoutId === null) $18f6e3b3e4e52774$var$timeoutId = setTimeout(callback, throttleDelay);
        }
    }
});


function $1e37570c816feffb$export$b5f053baf756345f(key, value) {
    if (value instanceof HTMLElement) return "HTMLElement <".concat(value.tagName, " class=\"").concat(value.className, "\">");
    if (value === window) return 'global.window';
    if (key === 'children' && typeof value === 'object' && value !== null) return '<<CHILDREN>>';
    return value;
}






var $bf04bdacfe1441a0$var$initialState = {
    dots: [],
    areas: [],
    lines: []
};
var $bf04bdacfe1441a0$export$cbde679baaad2c79 = (0, $df8b6ce3f4df1ba5$export$4d8d9bd83c24ae8b)({
    name: 'referenceElements',
    initialState: $bf04bdacfe1441a0$var$initialState,
    reducers: {
        addDot: (state, action)=>{
            state.dots.push(action.payload);
        },
        removeDot: (state, action)=>{
            var index = (0, $e922645e3176d997$export$97aac956da55dae9)(state).dots.findIndex((dot)=>dot === action.payload);
            if (index !== -1) state.dots.splice(index, 1);
        },
        addArea: (state, action)=>{
            state.areas.push(action.payload);
        },
        removeArea: (state, action)=>{
            var index = (0, $e922645e3176d997$export$97aac956da55dae9)(state).areas.findIndex((area)=>area === action.payload);
            if (index !== -1) state.areas.splice(index, 1);
        },
        addLine: (state, action)=>{
            state.lines.push((0, $808ce0820c1669b6$export$c05b21e3257751e5)(action.payload));
        },
        removeLine: (state, action)=>{
            var index = (0, $e922645e3176d997$export$97aac956da55dae9)(state).lines.findIndex((line)=>line === action.payload);
            if (index !== -1) state.lines.splice(index, 1);
        }
    }
});
var { addDot: $bf04bdacfe1441a0$export$9be8ef3add1f8c1e, removeDot: $bf04bdacfe1441a0$export$57ff7495ce685163, addArea: $bf04bdacfe1441a0$export$d604a18565cfc1b3, removeArea: $bf04bdacfe1441a0$export$a8da2ad4123475fe, addLine: $bf04bdacfe1441a0$export$a9ce8e8146745e3e, removeLine: $bf04bdacfe1441a0$export$fd7919a5491769ec } = $bf04bdacfe1441a0$export$cbde679baaad2c79.actions;
var $bf04bdacfe1441a0$export$f30a87c263d1acf8 = $bf04bdacfe1441a0$export$cbde679baaad2c79.reducer;



/**
 * From all Brush properties, only height has a default value and will always be defined.
 * Other properties are nullable and will be computed from offsets and margins if they are not set.
 */ var $cf600f0a4dd7eb42$var$initialState = {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    padding: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    }
};
var $cf600f0a4dd7eb42$export$d64e835ef4b0c23a = (0, $df8b6ce3f4df1ba5$export$4d8d9bd83c24ae8b)({
    name: 'brush',
    initialState: $cf600f0a4dd7eb42$var$initialState,
    reducers: {
        setBrushSettings (_state, action) {
            if (action.payload == null) return $cf600f0a4dd7eb42$var$initialState;
            return action.payload;
        }
    }
});
var { setBrushSettings: $cf600f0a4dd7eb42$export$1860ec7d971c6a5b } = $cf600f0a4dd7eb42$export$d64e835ef4b0c23a.actions;
var $cf600f0a4dd7eb42$export$b8c9ca32ee9dbf92 = $cf600f0a4dd7eb42$export$d64e835ef4b0c23a.reducer;




var $f381b9d454141104$export$d4c72bab9d6cc13a = {
    accessibilityLayer: true,
    barCategoryGap: '10%',
    barGap: 4,
    barSize: undefined,
    className: undefined,
    maxBarSize: undefined,
    stackOffset: 'none',
    syncId: undefined,
    syncMethod: 'index',
    baseValue: undefined,
    reverseStackOrder: false
};
var $f381b9d454141104$var$rootPropsSlice = (0, $df8b6ce3f4df1ba5$export$4d8d9bd83c24ae8b)({
    name: 'rootProps',
    initialState: $f381b9d454141104$export$d4c72bab9d6cc13a,
    reducers: {
        updateOptions: (state, action)=>{
            var _action$payload$barGa;
            state.accessibilityLayer = action.payload.accessibilityLayer;
            state.barCategoryGap = action.payload.barCategoryGap;
            state.barGap = (_action$payload$barGa = action.payload.barGap) !== null && _action$payload$barGa !== void 0 ? _action$payload$barGa : $f381b9d454141104$export$d4c72bab9d6cc13a.barGap;
            state.barSize = action.payload.barSize;
            state.maxBarSize = action.payload.maxBarSize;
            state.stackOffset = action.payload.stackOffset;
            state.syncId = action.payload.syncId;
            state.syncMethod = action.payload.syncMethod;
            state.className = action.payload.className;
            state.baseValue = action.payload.baseValue;
            state.reverseStackOrder = action.payload.reverseStackOrder;
        }
    }
});
var $f381b9d454141104$export$291d6468e221147e = $f381b9d454141104$var$rootPropsSlice.reducer;
var { updateOptions: $f381b9d454141104$export$c6fe4049d20353ac } = $f381b9d454141104$var$rootPropsSlice.actions;




var $0770b0782450c114$var$initialState = {
    radiusAxis: {},
    angleAxis: {}
};
var $0770b0782450c114$var$polarAxisSlice = (0, $df8b6ce3f4df1ba5$export$4d8d9bd83c24ae8b)({
    name: 'polarAxis',
    initialState: $0770b0782450c114$var$initialState,
    reducers: {
        addRadiusAxis (state, action) {
            state.radiusAxis[action.payload.id] = (0, $808ce0820c1669b6$export$c05b21e3257751e5)(action.payload);
        },
        removeRadiusAxis (state, action) {
            delete state.radiusAxis[action.payload.id];
        },
        addAngleAxis (state, action) {
            state.angleAxis[action.payload.id] = (0, $808ce0820c1669b6$export$c05b21e3257751e5)(action.payload);
        },
        removeAngleAxis (state, action) {
            delete state.angleAxis[action.payload.id];
        }
    }
});
var { addRadiusAxis: $0770b0782450c114$export$3555d359361c9fe3, removeRadiusAxis: $0770b0782450c114$export$104b2ce9f0baf86f, addAngleAxis: $0770b0782450c114$export$bf871b0db8674238, removeAngleAxis: $0770b0782450c114$export$d540ed209cfbb147 } = $0770b0782450c114$var$polarAxisSlice.actions;
var $0770b0782450c114$export$97e65520f1278b5 = $0770b0782450c114$var$polarAxisSlice.reducer;



var $0632eb616bc08bfd$var$initialState = null;
var $0632eb616bc08bfd$var$reducers = {
    updatePolarOptions: (state, action)=>{
        if (state === null) return action.payload;
        state.startAngle = action.payload.startAngle;
        state.endAngle = action.payload.endAngle;
        state.cx = action.payload.cx;
        state.cy = action.payload.cy;
        state.innerRadius = action.payload.innerRadius;
        state.outerRadius = action.payload.outerRadius;
        return state;
    }
};
var $0632eb616bc08bfd$var$polarOptionsSlice = (0, $df8b6ce3f4df1ba5$export$4d8d9bd83c24ae8b)({
    name: 'polarOptions',
    initialState: $0632eb616bc08bfd$var$initialState,
    reducers: $0632eb616bc08bfd$var$reducers
});
var { updatePolarOptions: $0632eb616bc08bfd$export$5dfe4dcb848af93f } = $0632eb616bc08bfd$var$polarOptionsSlice.actions;
var $0632eb616bc08bfd$export$8d4054f1936f7f4d = $0632eb616bc08bfd$var$polarOptionsSlice.reducer;









var $b0c870d135750371$export$4839538efb7414c = (0, $df8b6ce3f4df1ba5$export$309c7a02b0b0bc62)('keyDown');
var $b0c870d135750371$export$d95192eee5865567 = (0, $df8b6ce3f4df1ba5$export$309c7a02b0b0bc62)('focus');
var $b0c870d135750371$export$af52bfdff6fb5bd7 = (0, $df8b6ce3f4df1ba5$export$309c7a02b0b0bc62)('blur');
var $b0c870d135750371$export$b4d762ee62ea3f99 = (0, $df8b6ce3f4df1ba5$export$1228acebbbcb485b)();
var $b0c870d135750371$var$rafId = null;
var $b0c870d135750371$var$timeoutId = null;
var $b0c870d135750371$var$latestKeyboardActionPayload = null;
$b0c870d135750371$export$b4d762ee62ea3f99.startListening({
    actionCreator: $b0c870d135750371$export$4839538efb7414c,
    effect: (action, listenerApi)=>{
        $b0c870d135750371$var$latestKeyboardActionPayload = action.payload;
        if ($b0c870d135750371$var$rafId !== null) {
            cancelAnimationFrame($b0c870d135750371$var$rafId);
            $b0c870d135750371$var$rafId = null;
        }
        var state = listenerApi.getState();
        var { throttleDelay: throttleDelay, throttledEvents: throttledEvents } = state.eventSettings;
        var isThrottled = throttledEvents === 'all' || throttledEvents.includes('keydown');
        if ($b0c870d135750371$var$timeoutId !== null && (typeof throttleDelay !== 'number' || !isThrottled)) {
            clearTimeout($b0c870d135750371$var$timeoutId);
            $b0c870d135750371$var$timeoutId = null;
        }
        var callback = ()=>{
            try {
                var currentState = listenerApi.getState();
                var accessibilityLayerIsActive = currentState.rootProps.accessibilityLayer !== false;
                if (!accessibilityLayerIsActive) return;
                var { keyboardInteraction: keyboardInteraction } = currentState.tooltip;
                var key = $b0c870d135750371$var$latestKeyboardActionPayload;
                if (key !== 'ArrowRight' && key !== 'ArrowLeft' && key !== 'Enter') return;
                // TODO this is lacking index for charts that do not support numeric indexes
                var resolvedIndex = (0, $616bfe7b3ded2280$export$32df4b03a0962e46)(keyboardInteraction, (0, $dbde609d2e66e7f4$export$5a8beccc8250d20e)(currentState), (0, $223cdb002ac9c48b$export$bf8397fefbaa3617)(currentState), (0, $dbde609d2e66e7f4$export$76f7a1975f60ccf1)(currentState));
                var currentIndex = resolvedIndex == null ? -1 : Number(resolvedIndex);
                var isOutsideDomain = !Number.isFinite(currentIndex) || currentIndex < 0;
                var tooltipTicks = (0, $dbde609d2e66e7f4$export$ffe0e60f8c88c05a)(currentState);
                var displayedData = (0, $dbde609d2e66e7f4$export$5a8beccc8250d20e)(currentState);
                var tooltipEventType = (0, $1e9e9b3c1f2abdf7$export$53af65c2db668fac)(currentState, currentState.tooltip.settings.shared);
                if (key === 'Enter') {
                    if (isOutsideDomain) return;
                    var _coordinate = (0, $f310c8c70271e4da$export$7dbe424d18defe7d)(currentState, tooltipEventType, 'hover', String(keyboardInteraction.index));
                    listenerApi.dispatch((0, $2bfb679c145bcb6f$export$820c94985c9eba3f)({
                        active: !keyboardInteraction.active,
                        activeIndex: keyboardInteraction.index,
                        activeCoordinate: _coordinate
                    }));
                    return;
                }
                var direction = (0, $223cdb002ac9c48b$export$430d623a94added7)(currentState);
                var directionMultiplier = direction === 'left-to-right' ? 1 : -1;
                var movement = key === 'ArrowRight' ? 1 : -1;
                var nextIndex;
                if (isOutsideDomain) {
                    var axisDataKey = (0, $223cdb002ac9c48b$export$bf8397fefbaa3617)(currentState);
                    var domain = (0, $dbde609d2e66e7f4$export$76f7a1975f60ccf1)(currentState);
                    var effectiveMovement = movement * directionMultiplier;
                    // Build a minimal TooltipInteractionState for the candidate-index check.
                    var mkInteraction = (i)=>({
                            active: false,
                            index: String(i),
                            dataKey: undefined,
                            graphicalItemId: undefined,
                            coordinate: undefined
                        });
                    nextIndex = -1;
                    if (effectiveMovement > 0) {
                        for(var i = 0; i < displayedData.length; i++)if ((0, $616bfe7b3ded2280$export$32df4b03a0962e46)(mkInteraction(i), displayedData, axisDataKey, domain) != null) {
                            nextIndex = i;
                            break;
                        }
                    } else {
                        for(var _i = displayedData.length - 1; _i >= 0; _i--)if ((0, $616bfe7b3ded2280$export$32df4b03a0962e46)(mkInteraction(_i), displayedData, axisDataKey, domain) != null) {
                            nextIndex = _i;
                            break;
                        }
                    }
                    if (nextIndex < 0) return;
                } else {
                    nextIndex = currentIndex + movement * directionMultiplier;
                    var dataLength = (tooltipTicks === null || tooltipTicks === void 0 ? void 0 : tooltipTicks.length) || displayedData.length;
                    if (dataLength === 0 || nextIndex >= dataLength || nextIndex < 0) return;
                }
                var coordinate = (0, $f310c8c70271e4da$export$7dbe424d18defe7d)(currentState, tooltipEventType, 'hover', String(nextIndex));
                listenerApi.dispatch((0, $2bfb679c145bcb6f$export$820c94985c9eba3f)({
                    active: true,
                    activeIndex: nextIndex.toString(),
                    activeCoordinate: coordinate
                }));
            } finally{
                $b0c870d135750371$var$rafId = null;
                $b0c870d135750371$var$timeoutId = null;
            }
        };
        if (!isThrottled) {
            callback();
            return;
        }
        if (throttleDelay === 'raf') $b0c870d135750371$var$rafId = requestAnimationFrame(callback);
        else if (typeof throttleDelay === 'number') {
            if ($b0c870d135750371$var$timeoutId === null) {
                callback();
                $b0c870d135750371$var$latestKeyboardActionPayload = null;
                $b0c870d135750371$var$timeoutId = setTimeout(()=>{
                    if ($b0c870d135750371$var$latestKeyboardActionPayload) callback();
                    else {
                        $b0c870d135750371$var$timeoutId = null;
                        $b0c870d135750371$var$rafId = null;
                    }
                }, throttleDelay);
            }
        }
    }
});
$b0c870d135750371$export$b4d762ee62ea3f99.startListening({
    actionCreator: $b0c870d135750371$export$d95192eee5865567,
    effect: (_action, listenerApi)=>{
        var state = listenerApi.getState();
        var accessibilityLayerIsActive = state.rootProps.accessibilityLayer !== false;
        if (!accessibilityLayerIsActive) return;
        var { keyboardInteraction: keyboardInteraction } = state.tooltip;
        if (keyboardInteraction.active) return;
        if (keyboardInteraction.index == null) {
            var nextIndex = '0';
            var tooltipEventType = (0, $1e9e9b3c1f2abdf7$export$53af65c2db668fac)(state, state.tooltip.settings.shared);
            var coordinate = (0, $f310c8c70271e4da$export$7dbe424d18defe7d)(state, tooltipEventType, 'hover', String(nextIndex));
            listenerApi.dispatch((0, $2bfb679c145bcb6f$export$820c94985c9eba3f)({
                active: true,
                activeIndex: nextIndex,
                activeCoordinate: coordinate
            }));
        }
    }
});
$b0c870d135750371$export$b4d762ee62ea3f99.startListening({
    actionCreator: $b0c870d135750371$export$af52bfdff6fb5bd7,
    effect: (_action, listenerApi)=>{
        var state = listenerApi.getState();
        var accessibilityLayerIsActive = state.rootProps.accessibilityLayer !== false;
        if (!accessibilityLayerIsActive) return;
        var { keyboardInteraction: keyboardInteraction } = state.tooltip;
        if (keyboardInteraction.active) listenerApi.dispatch((0, $2bfb679c145bcb6f$export$820c94985c9eba3f)({
            active: false,
            activeIndex: keyboardInteraction.index,
            activeCoordinate: keyboardInteraction.coordinate
        }));
    }
});




function $c9533e505b706b61$export$5c057f9c005183bb(reactEvent) {
    reactEvent.persist();
    var { currentTarget: currentTarget } = reactEvent;
    return new Proxy(reactEvent, {
        get: (target, prop)=>{
            if (prop === 'currentTarget') return currentTarget;
            var value = Reflect.get(target, prop);
            if (typeof value === 'function') return value.bind(target);
            return value;
        }
    });
}


var $9b16f680853ef197$export$1d0268b9f89859f0 = (0, $df8b6ce3f4df1ba5$export$309c7a02b0b0bc62)('externalEvent');
var $9b16f680853ef197$export$3c5d447f046d0ec3 = (0, $df8b6ce3f4df1ba5$export$1228acebbbcb485b)();
/*
 * We need a Map keyed by event type because this middleware handles MULTIPLE different event types
 * (click, mouseenter, mouseleave, mousedown, mouseup, contextmenu, dblclick, touchstart, touchmove, touchend)
 * from the same DOM element. Different event types should NOT cancel each other's animation frames.
 * For example, a click event and a mousemove event can happen in quick succession and both should be processed.
 * This is different from mouseMoveMiddleware which only handles one event type and uses a single rafId.
 */ var $9b16f680853ef197$var$rafIdMap = new Map();
var $9b16f680853ef197$var$timeoutIdMap = new Map();
var $9b16f680853ef197$var$latestEventMap = new Map();
$9b16f680853ef197$export$3c5d447f046d0ec3.startListening({
    actionCreator: $9b16f680853ef197$export$1d0268b9f89859f0,
    effect: (action, listenerApi)=>{
        var { handler: handler, reactEvent: reactEvent } = action.payload;
        if (handler == null) return;
        var eventType = reactEvent.type;
        var eventProxy = (0, $c9533e505b706b61$export$5c057f9c005183bb)(reactEvent);
        $9b16f680853ef197$var$latestEventMap.set(eventType, {
            handler: handler,
            reactEvent: eventProxy
        });
        // Cancel any pending execution for this event type
        var existingRafId = $9b16f680853ef197$var$rafIdMap.get(eventType);
        if (existingRafId !== undefined) {
            cancelAnimationFrame(existingRafId);
            $9b16f680853ef197$var$rafIdMap.delete(eventType);
        }
        var state = listenerApi.getState();
        var { throttleDelay: throttleDelay, throttledEvents: throttledEvents } = state.eventSettings;
        /*
     * reactEvent.type gives us the event type as a string, e.g., 'click', 'mousemove', etc.
     * which is the same as the names used in throttledEvents array
     * but that array is strictly typed as ReadonlyArray<keyof GlobalEventHandlersEventMap> | 'all' | undefined
     * so that we can have relevant autocomplete and type checking elsewhere.
     * This makes TypeScript panic because it refuses to call .includes() on ReadonlyArray<keyof GlobalEventHandlersEventMap>
     * with a string argument.
     * To satisfy TypeScript, we need to explicitly typecast throttledEvents here.
     */ var eventListAsString = throttledEvents;
        // Check if this event type should be throttled
        // throttledEvents can be 'all' or an array of event names
        var isThrottled = eventListAsString === 'all' || (eventListAsString === null || eventListAsString === void 0 ? void 0 : eventListAsString.includes(eventType));
        var existingTimeoutId = $9b16f680853ef197$var$timeoutIdMap.get(eventType);
        if (existingTimeoutId !== undefined && (typeof throttleDelay !== 'number' || !isThrottled)) {
            clearTimeout(existingTimeoutId);
            $9b16f680853ef197$var$timeoutIdMap.delete(eventType);
        }
        var callback = ()=>{
            var latestAction = $9b16f680853ef197$var$latestEventMap.get(eventType);
            try {
                if (!latestAction) // This happens if the event was consumed by the leading edge and no new event came in
                return;
                var { handler: latestHandler, reactEvent: latestEvent } = latestAction;
                var currentState = listenerApi.getState();
                var nextState = {
                    activeCoordinate: (0, $dbde609d2e66e7f4$export$90c565a5b196e427)(currentState),
                    activeDataKey: (0, $dbde609d2e66e7f4$export$999f7a7ced063fab)(currentState),
                    activeIndex: (0, $dbde609d2e66e7f4$export$8b2762260f5891c9)(currentState),
                    activeLabel: (0, $dbde609d2e66e7f4$export$400c35cc3b9a0487)(currentState),
                    activeTooltipIndex: (0, $dbde609d2e66e7f4$export$8b2762260f5891c9)(currentState),
                    isTooltipActive: (0, $dbde609d2e66e7f4$export$c8884ed37796034a)(currentState)
                };
                if (latestHandler) latestHandler(nextState, latestEvent);
            } finally{
                $9b16f680853ef197$var$rafIdMap.delete(eventType);
                $9b16f680853ef197$var$timeoutIdMap.delete(eventType);
                $9b16f680853ef197$var$latestEventMap.delete(eventType);
            }
        };
        if (!isThrottled) {
            // Execute immediately
            callback();
            return;
        }
        if (throttleDelay === 'raf') {
            var rafId = requestAnimationFrame(callback);
            $9b16f680853ef197$var$rafIdMap.set(eventType, rafId);
        } else if (typeof throttleDelay === 'number') {
            if (!$9b16f680853ef197$var$timeoutIdMap.has(eventType)) {
                /*
         * Leading edge execution - execute immediately on the first event
         * and then start the cooldown period to throttle subsequent events.
         */ callback();
                // Start cooldown
                var timeoutId = setTimeout(callback, throttleDelay);
                $9b16f680853ef197$var$timeoutIdMap.set(eventType, timeoutId);
            }
        } else // Should not happen based on type, but fallback to immediate
        callback();
    }
});










var $4c839f249dfabbc2$var$selectAllTooltipPayloadConfiguration = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    (0, $4f20250cfa418037$export$703b585bc92b5bae)
], (tooltipState)=>tooltipState.tooltipItemPayloads);
var $4c839f249dfabbc2$export$4e32c9da1f3ea7ce = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $4c839f249dfabbc2$var$selectAllTooltipPayloadConfiguration,
    (_state, tooltipIndex)=>tooltipIndex,
    (_state, _tooltipIndex, graphicalItemId)=>graphicalItemId
], (allTooltipConfigurations, tooltipIndex, graphicalItemId)=>{
    if (tooltipIndex == null) return undefined;
    var mostRelevantTooltipConfiguration = allTooltipConfigurations.find((tooltipConfiguration)=>{
        return tooltipConfiguration.settings.graphicalItemId === graphicalItemId;
    });
    if (mostRelevantTooltipConfiguration == null) return undefined;
    var { getPosition: getPosition } = mostRelevantTooltipConfiguration;
    if (getPosition == null) return undefined;
    return getPosition(tooltipIndex);
});




var $98b87fa8a2a1620a$export$ba46b5fda0e2985f = (0, $df8b6ce3f4df1ba5$export$309c7a02b0b0bc62)('touchMove');
var $98b87fa8a2a1620a$export$923ceddc5a79736a = (0, $df8b6ce3f4df1ba5$export$1228acebbbcb485b)();
var $98b87fa8a2a1620a$var$rafId = null;
var $98b87fa8a2a1620a$var$timeoutId = null;
var $98b87fa8a2a1620a$var$latestChartPointers = null;
var $98b87fa8a2a1620a$var$latestTouchEvent = null;
$98b87fa8a2a1620a$export$923ceddc5a79736a.startListening({
    actionCreator: $98b87fa8a2a1620a$export$ba46b5fda0e2985f,
    effect: (action, listenerApi)=>{
        var touchEvent = action.payload;
        if (touchEvent.touches == null || touchEvent.touches.length === 0) return;
        $98b87fa8a2a1620a$var$latestTouchEvent = (0, $c9533e505b706b61$export$5c057f9c005183bb)(touchEvent);
        var state = listenerApi.getState();
        var { throttleDelay: throttleDelay, throttledEvents: throttledEvents } = state.eventSettings;
        var isThrottled = throttledEvents === 'all' || throttledEvents.includes('touchmove');
        if ($98b87fa8a2a1620a$var$rafId !== null) {
            cancelAnimationFrame($98b87fa8a2a1620a$var$rafId);
            $98b87fa8a2a1620a$var$rafId = null;
        }
        if ($98b87fa8a2a1620a$var$timeoutId !== null && (typeof throttleDelay !== 'number' || !isThrottled)) {
            clearTimeout($98b87fa8a2a1620a$var$timeoutId);
            $98b87fa8a2a1620a$var$timeoutId = null;
        }
        $98b87fa8a2a1620a$var$latestChartPointers = Array.from(touchEvent.touches).map((touch)=>(0, $f87ceae7e349c2cc$export$4f29f8e5290cb0bb)({
                clientX: touch.clientX,
                clientY: touch.clientY,
                currentTarget: touchEvent.currentTarget
            }));
        var callback = ()=>{
            if ($98b87fa8a2a1620a$var$latestTouchEvent == null) return;
            var currentState = listenerApi.getState();
            var tooltipEventType = (0, $1e9e9b3c1f2abdf7$export$53af65c2db668fac)(currentState, currentState.tooltip.settings.shared);
            if (tooltipEventType === 'axis') {
                var _latestChartPointers;
                var latestTouchPointer = (_latestChartPointers = $98b87fa8a2a1620a$var$latestChartPointers) === null || _latestChartPointers === void 0 ? void 0 : _latestChartPointers[0];
                if (latestTouchPointer == null) {
                    $98b87fa8a2a1620a$var$rafId = null;
                    $98b87fa8a2a1620a$var$timeoutId = null;
                    return;
                }
                var activeProps = (0, $912ccca734443a3b$export$2cfb761a54690867)(currentState, latestTouchPointer);
                if ((activeProps === null || activeProps === void 0 ? void 0 : activeProps.activeIndex) != null) listenerApi.dispatch((0, $2bfb679c145bcb6f$export$a7277636863fc703)({
                    activeIndex: activeProps.activeIndex,
                    activeDataKey: undefined,
                    activeCoordinate: activeProps.activeCoordinate
                }));
            } else if (tooltipEventType === 'item') {
                var _target$getAttribute;
                var touch = $98b87fa8a2a1620a$var$latestTouchEvent.touches[0];
                if (document.elementFromPoint == null || touch == null) return;
                var target = document.elementFromPoint(touch.clientX, touch.clientY);
                if (!target || !target.getAttribute) return;
                var itemIndex = target.getAttribute((0, $868751348c5652f4$export$c0f3d78d63b3e065));
                var graphicalItemId = (_target$getAttribute = target.getAttribute((0, $868751348c5652f4$export$5c80c48c1d137460))) !== null && _target$getAttribute !== void 0 ? _target$getAttribute : undefined;
                var settings = (0, $dbde609d2e66e7f4$export$645965005f643e6f)(currentState).find((item)=>item.id === graphicalItemId);
                if (itemIndex == null || settings == null || graphicalItemId == null) return;
                var { dataKey: dataKey } = settings;
                var coordinate = (0, $4c839f249dfabbc2$export$4e32c9da1f3ea7ce)(currentState, itemIndex, graphicalItemId);
                listenerApi.dispatch((0, $2bfb679c145bcb6f$export$c78abbb2450f6b44)({
                    activeDataKey: dataKey,
                    activeIndex: itemIndex,
                    activeCoordinate: coordinate,
                    activeGraphicalItemId: graphicalItemId
                }));
            }
            $98b87fa8a2a1620a$var$rafId = null;
            $98b87fa8a2a1620a$var$timeoutId = null;
        };
        if (!isThrottled) {
            callback();
            return;
        }
        if (throttleDelay === 'raf') $98b87fa8a2a1620a$var$rafId = requestAnimationFrame(callback);
        else if (typeof throttleDelay === 'number') {
            if ($98b87fa8a2a1620a$var$timeoutId === null) {
                callback();
                $98b87fa8a2a1620a$var$latestTouchEvent = null;
                $98b87fa8a2a1620a$var$timeoutId = setTimeout(()=>{
                    if ($98b87fa8a2a1620a$var$latestTouchEvent) callback();
                    else {
                        $98b87fa8a2a1620a$var$timeoutId = null;
                        $98b87fa8a2a1620a$var$rafId = null;
                    }
                }, throttleDelay);
            }
        }
    }
});







var $a6ede7080be43fb0$export$b8b957c7b621f147 = {
    throttleDelay: 'raf',
    throttledEvents: [
        'mousemove',
        'touchmove',
        'pointermove',
        'scroll',
        'wheel'
    ]
};
var $a6ede7080be43fb0$var$eventSettingsSlice = (0, $df8b6ce3f4df1ba5$export$4d8d9bd83c24ae8b)({
    name: 'eventSettings',
    initialState: $a6ede7080be43fb0$export$b8b957c7b621f147,
    reducers: {
        setEventSettings: (state, action)=>{
            if (action.payload.throttleDelay != null) state.throttleDelay = action.payload.throttleDelay;
            if (action.payload.throttledEvents != null) state.throttledEvents = (0, $808ce0820c1669b6$export$c05b21e3257751e5)(action.payload.throttledEvents);
        }
    }
});
var { setEventSettings: $a6ede7080be43fb0$export$ebdc8cd28e946f60 } = $a6ede7080be43fb0$var$eventSettingsSlice.actions;
var $a6ede7080be43fb0$export$8631319549a0b15 = $a6ede7080be43fb0$var$eventSettingsSlice.reducer;


/**
 * @fileOverview this stores actually rendered ticks.
 *
 * What we do is that we have the domain -> ticks mapping in the cartesianSlice,
 * which is fine but the result then goes to CartesianAxis where we use DOM measurement
 * to decide which ticks to actually render.
 *
 * This renderedTickSlice stores those actually rendered ticks so that we can return them from a hook later.
 */ 

var $60ba75757d61b083$var$initialState = {
    xAxis: {},
    yAxis: {}
};
var $60ba75757d61b083$export$f4a9a56f402a7d3b = (0, $df8b6ce3f4df1ba5$export$4d8d9bd83c24ae8b)({
    name: 'renderedTicks',
    initialState: $60ba75757d61b083$var$initialState,
    reducers: {
        setRenderedTicks: (state, action)=>{
            var { axisType: axisType, axisId: axisId, ticks: ticks } = action.payload;
            state[axisType][axisId] = (0, $808ce0820c1669b6$export$c05b21e3257751e5)(ticks);
        },
        removeRenderedTicks: (state, action)=>{
            var { axisType: axisType, axisId: axisId } = action.payload;
            delete state[axisType][axisId];
        }
    }
});
var { setRenderedTicks: $60ba75757d61b083$export$9b96437af9e57ebe, removeRenderedTicks: $60ba75757d61b083$export$d8f6326ec092e260 } = $60ba75757d61b083$export$f4a9a56f402a7d3b.actions;
var $60ba75757d61b083$export$596b92009d4d7ccc = $60ba75757d61b083$export$f4a9a56f402a7d3b.reducer;


var $13fddcd5471a80db$var$rootReducer = (0, $6c2d3c9c387cb6cd$export$66e4520cdb265d18)({
    brush: (0, $cf600f0a4dd7eb42$export$b8c9ca32ee9dbf92),
    cartesianAxis: (0, $c24339571f507656$export$c8ae79f5f6ae07c6),
    chartData: (0, $013669191ef6e95a$export$52973ca5fce0a5d5),
    errorBars: (0, $9068acbf45b5ed3a$export$6dda85fa3c67ca19),
    eventSettings: (0, $a6ede7080be43fb0$export$8631319549a0b15),
    graphicalItems: (0, $fe3ae76395e8f2af$export$183eecd5cb7dbb38),
    layout: (0, $a3abdcf7f5febb61$export$701395c4acfabc85),
    legend: (0, $9cbabae4d819cbf3$export$8d8dfb8d5acf8179),
    options: (0, $06bd4d083c59b4ed$export$81a3ba457dd82bec),
    polarAxis: (0, $0770b0782450c114$export$97e65520f1278b5),
    polarOptions: (0, $0632eb616bc08bfd$export$8d4054f1936f7f4d),
    referenceElements: (0, $bf04bdacfe1441a0$export$f30a87c263d1acf8),
    renderedTicks: (0, $60ba75757d61b083$export$596b92009d4d7ccc),
    rootProps: (0, $f381b9d454141104$export$291d6468e221147e),
    tooltip: (0, $2bfb679c145bcb6f$export$cadd4678b967dba6),
    zIndex: (0, $987558efef597e2e$export$a34096cdea3a022a)
});
var $13fddcd5471a80db$export$a4383593d58e8efa = function createRechartsStore(preloadedState) {
    var chartName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Chart';
    return (0, $df8b6ce3f4df1ba5$export$7d8a5b498da695ac)({
        reducer: $13fddcd5471a80db$var$rootReducer,
        // redux-toolkit v1 types are unhappy with the preloadedState type. Remove the `as any` when bumping to v2
        preloadedState: preloadedState,
        // @ts-expect-error redux-toolkit v1 types are unhappy with the middleware array. Remove this comment when bumping to v2
        middleware: (getDefaultMiddleware)=>{
            var _process$env$NODE_ENV;
            return getDefaultMiddleware({
                serializableCheck: false,
                immutableCheck: ![
                    'commonjs',
                    'es6',
                    'production'
                ].includes((_process$env$NODE_ENV = "es6", _process$env$NODE_ENV !== void 0) ? _process$env$NODE_ENV : '')
            }).concat([
                (0, $18f6e3b3e4e52774$export$fb3df626ae9864a).middleware,
                (0, $18f6e3b3e4e52774$export$b7e1b38eb227944a).middleware,
                (0, $b0c870d135750371$export$b4d762ee62ea3f99).middleware,
                (0, $9b16f680853ef197$export$3c5d447f046d0ec3).middleware,
                (0, $98b87fa8a2a1620a$export$923ceddc5a79736a).middleware
            ]);
        },
        /*
     * I can't find out how to satisfy typescript here.
     * We return `EnhancerArray<[StoreEnhancer<{}, {}>, StoreEnhancer]>` from this function,
     * but the types say we should return `EnhancerArray<StoreEnhancer<{}, {}>`.
     * Looks like it's badly inferred generics, but it won't allow me to provide the correct type manually either.
     * So let's just ignore the error for now.
     */ // @ts-expect-error mismatched generics
        enhancers: (getDefaultEnhancers)=>{
            var enhancers = getDefaultEnhancers;
            if (typeof getDefaultEnhancers === 'function') /*
         * In RTK v2 this is always a function, but in v1 it is an array.
         * Because we have @types/redux-toolkit v1 as a dependency, typescript is going to flag this as an error.
         * We support both RTK v1 and v2, so we need to do this check.
         * https://redux-toolkit.js.org/usage/migrating-rtk-2#configurestoreenhancers-must-be-a-callback
         */ // @ts-expect-error RTK v2 behaviour on RTK v1 types
            enhancers = getDefaultEnhancers();
            return enhancers.concat((0, $df8b6ce3f4df1ba5$export$676277d7dca0f396)({
                type: 'raf'
            }));
        },
        devTools: (0, $21ceeda12d85451c$export$98f03c5d19621d70).devToolsEnabled && {
            serialize: {
                replacer: (0, $1e37570c816feffb$export$b5f053baf756345f)
            },
            name: "recharts-".concat(chartName)
        }
    });
};




function $a0ffcc501bd4818e$export$debe87639f2707f9(_ref) {
    var { preloadedState: preloadedState, children: children, reduxStoreName: reduxStoreName } = _ref;
    var isPanorama = (0, $10d1d693b6b228cd$export$4b0c59f8845ba920)();
    /*
   * Why the ref? Redux official documentation recommends to use store as a singleton,
   * and reuse that everywhere: https://redux-toolkit.js.org/api/configureStore#basic-example
   *
   * Which is correct! Except that is considering deploying Redux in an app.
   * Recharts as a library supports multiple charts on the same page.
   * And each of these charts needs its own store independent of others!
   *
   * The alternative is to have everything in the store keyed by the chart id.
   * Which would make working with everything a little bit more painful because we need the chart id everywhere.
   */ var storeRef = (0, $kc00y.useRef)(null);
    /*
   * Panorama means that this chart is not its own chart, it's only a "preview"
   * being rendered as a child of Brush.
   * In such case, it should not have a store on its own - it should implicitly inherit
   * whatever data is in the "parent" or "root" chart.
   * Which here is represented by not having a Provider at all. All selectors will use the root store by default.
   */ if (isPanorama) return children;
    if (storeRef.current == null) storeRef.current = (0, $13fddcd5471a80db$export$a4383593d58e8efa)(preloadedState, reduxStoreName);
    // @ts-expect-error React-Redux types demand that the context internal value is not null, but we have that as default.
    var nonNullContext = (0, $bf89e112b0848c51$export$876ef70bc88b13cb);
    return /*#__PURE__*/ $kc00y.createElement((0, $5b96f91a609769a4$export$2881499e37b75b9a), {
        context: nonNullContext,
        store: storeRef.current
    }, children);
}



var $kc00y = parcelRequire("kc00y");



var $2fbac5019ff11bb3$export$2100a1dedbca0238 = (props)=>{
    var { chartData: chartData } = props;
    var dispatch = (0, $a441e801d1b41b52$export$f51d452c10d5b956)();
    var isPanorama = (0, $10d1d693b6b228cd$export$4b0c59f8845ba920)();
    (0, $kc00y.useEffect)(()=>{
        if (isPanorama) // Panorama mode reuses data from the main chart, so we must not overwrite it here.
        return ()=>{
        // there is nothing to clean up
        };
        dispatch((0, $013669191ef6e95a$export$624c47d88733f253)(chartData));
        return ()=>{
            dispatch((0, $013669191ef6e95a$export$624c47d88733f253)(undefined));
        };
    }, [
        chartData,
        dispatch,
        isPanorama
    ]);
    return null;
};
var $2fbac5019ff11bb3$export$91a155b0e28498ba = (props)=>{
    var { computedData: computedData } = props;
    var dispatch = (0, $a441e801d1b41b52$export$f51d452c10d5b956)();
    (0, $kc00y.useEffect)(()=>{
        dispatch((0, $013669191ef6e95a$export$9b2e7f4962514250)(computedData));
        return ()=>{
            dispatch((0, $013669191ef6e95a$export$624c47d88733f253)(undefined));
        };
    }, [
        computedData,
        dispatch
    ]);
    return null;
};
var $2fbac5019ff11bb3$var$selectChartData = (state)=>state.chartData.chartData;
var $2fbac5019ff11bb3$export$551a2a6f7431b8ad = ()=>(0, $a441e801d1b41b52$export$a7347740d65f620b)($2fbac5019ff11bb3$var$selectChartData);
var $2fbac5019ff11bb3$var$selectDataIndex = (state)=>{
    var { dataStartIndex: dataStartIndex, dataEndIndex: dataEndIndex } = state.chartData;
    return {
        startIndex: dataStartIndex,
        endIndex: dataEndIndex
    };
};
var $2fbac5019ff11bb3$export$824568c74ea1faec = ()=>{
    return (0, $a441e801d1b41b52$export$a7347740d65f620b)($2fbac5019ff11bb3$var$selectDataIndex);
};



var $kc00y = parcelRequire("kc00y");




/**
 * "Main" props are props that are only accepted on the main chart,
 * as opposed to the small panorama chart inside a Brush.
 */ function $62df92852f2f4482$var$ReportMainChartPropsImpl(_ref) {
    var { layout: layout, margin: margin } = _ref;
    var dispatch = (0, $a441e801d1b41b52$export$f51d452c10d5b956)();
    /*
   * Skip dispatching properties in panorama chart for two reasons:
   * 1. The root chart should be deciding on these properties, and
   * 2. Brush reads these properties from redux store, and so they must remain stable
   *      to avoid circular dependency and infinite re-rendering.
   */ var isPanorama = (0, $10d1d693b6b228cd$export$4b0c59f8845ba920)();
    /*
   * useEffect here is required to avoid the "Cannot update a component while rendering a different component" error.
   * https://github.com/facebook/react/issues/18178
   *
   * Reported in https://github.com/recharts/recharts/issues/5514
   */ (0, $kc00y.useEffect)(()=>{
        if (!isPanorama) {
            dispatch((0, $a3abdcf7f5febb61$export$e8437af1f2483b8e)(layout));
            dispatch((0, $a3abdcf7f5febb61$export$3f8f25b83912855f)(margin));
        }
    }, [
        dispatch,
        isPanorama,
        layout,
        margin
    ]);
    return null;
}
var $62df92852f2f4482$export$6faeaad6e02c2e9d = /*#__PURE__*/ (0, $kc00y.memo)($62df92852f2f4482$var$ReportMainChartPropsImpl, (0, $13251e7ce0459d7b$export$b8f09df787c278d9));



var $kc00y = parcelRequire("kc00y");


function $a435dfd6f3838af8$export$6fabfb9ba230d12b(props) {
    var dispatch = (0, $a441e801d1b41b52$export$f51d452c10d5b956)();
    (0, $kc00y.useEffect)(()=>{
        dispatch((0, $f381b9d454141104$export$c6fe4049d20353ac)(props));
    }, [
        dispatch,
        props
    ]);
    return null;
}



var $kc00y = parcelRequire("kc00y");



var $f463b6c2910c27e9$var$ReportEventSettingsImpl = (props)=>{
    var dispatch = (0, $a441e801d1b41b52$export$f51d452c10d5b956)();
    (0, $kc00y.useEffect)(()=>{
        dispatch((0, $a6ede7080be43fb0$export$ebdc8cd28e946f60)(props));
    }, [
        dispatch,
        props
    ]);
    return null;
};
var $f463b6c2910c27e9$export$dcb02be33c78f8ab = /*#__PURE__*/ (0, $kc00y.memo)($f463b6c2910c27e9$var$ReportEventSettingsImpl, (0, $13251e7ce0459d7b$export$b8f09df787c278d9));



var $kc00y = parcelRequire("kc00y");

var $kc00y = parcelRequire("kc00y");


var $b254816100b9e8bd$export$276788f18f24cad3 = ()=>{
    var _useAppSelector;
    return (_useAppSelector = (0, $a441e801d1b41b52$export$a7347740d65f620b)((state)=>state.rootProps.accessibilityLayer)) !== null && _useAppSelector !== void 0 ? _useAppSelector : true;
};




var $kc00y = parcelRequire("kc00y");


var $3069fadfb06768fe$var$_excluded = [
    "children",
    "width",
    "height",
    "viewBox",
    "className",
    "style",
    "title",
    "desc"
];
function $3069fadfb06768fe$var$_extends() {
    return $3069fadfb06768fe$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $3069fadfb06768fe$var$_extends.apply(null, arguments);
}
function $3069fadfb06768fe$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $3069fadfb06768fe$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $3069fadfb06768fe$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $3069fadfb06768fe$export$7b92b459e668cb21 = /*#__PURE__*/ (0, $kc00y.forwardRef)((props, ref)=>{
    var { children: children, width: width, height: height, viewBox: viewBox, className: className, style: style, title: title, desc: desc } = props, others = $3069fadfb06768fe$var$_objectWithoutProperties(props, $3069fadfb06768fe$var$_excluded);
    var svgView = viewBox || {
        width: width,
        height: height,
        x: 0,
        y: 0
    };
    var layerClass = (0, $328c1c2632e2f292$export$4f5d2d50c9deca37)('recharts-surface', className);
    return /*#__PURE__*/ $kc00y.createElement("svg", $3069fadfb06768fe$var$_extends({}, (0, $976509d5bd74ee3b$export$67f8fc03e57e2747)(others), {
        className: layerClass,
        width: width,
        height: height,
        style: style,
        viewBox: "".concat(svgView.x, " ").concat(svgView.y, " ").concat(svgView.width, " ").concat(svgView.height),
        ref: ref
    }), /*#__PURE__*/ $kc00y.createElement("title", null, title), /*#__PURE__*/ $kc00y.createElement("desc", null, desc), children);
});






var $kc00y = parcelRequire("kc00y");



function $df8030e9b0319c2f$var$ZIndexSvgPortal(_ref) {
    var { zIndex: zIndex, isPanorama: isPanorama } = _ref;
    var ref = (0, $kc00y.useRef)(null);
    var dispatch = (0, $a441e801d1b41b52$export$f51d452c10d5b956)();
    (0, $kc00y.useLayoutEffect)(()=>{
        if (ref.current) dispatch((0, $987558efef597e2e$export$2e6026208075bd4f)({
            zIndex: zIndex,
            element: ref.current,
            isPanorama: isPanorama
        }));
        return ()=>{
            dispatch((0, $987558efef597e2e$export$b735943939e8125)({
                zIndex: zIndex,
                isPanorama: isPanorama
            }));
        };
    }, [
        dispatch,
        zIndex,
        isPanorama
    ]);
    // these g elements should not be tabbable
    return /*#__PURE__*/ $kc00y.createElement("g", {
        tabIndex: -1,
        ref: ref,
        className: "recharts-zIndex-layer_".concat(zIndex)
    });
}
function $df8030e9b0319c2f$export$7a76624f8e4da531(_ref2) {
    var { children: children, isPanorama: isPanorama } = _ref2;
    var allRegisteredZIndexes = (0, $a441e801d1b41b52$export$a7347740d65f620b)((0, $3af473174a59f367$export$7967bffce127e19c));
    if (!allRegisteredZIndexes || allRegisteredZIndexes.length === 0) return children;
    var allNegativeZIndexes = allRegisteredZIndexes.filter((zIndex)=>zIndex < 0);
    // We exclude zero on purpose - that is the default layer, and it doesn't need a portal.
    var allPositiveZIndexes = allRegisteredZIndexes.filter((zIndex)=>zIndex > 0);
    return /*#__PURE__*/ $kc00y.createElement($kc00y.Fragment, null, allNegativeZIndexes.map((zIndex)=>/*#__PURE__*/ $kc00y.createElement($df8030e9b0319c2f$var$ZIndexSvgPortal, {
            key: zIndex,
            zIndex: zIndex,
            isPanorama: isPanorama
        })), children, allPositiveZIndexes.map((zIndex)=>/*#__PURE__*/ $kc00y.createElement($df8030e9b0319c2f$var$ZIndexSvgPortal, {
            key: zIndex,
            zIndex: zIndex,
            isPanorama: isPanorama
        })));
}


var $3358e06e32bdbfb7$var$_excluded = [
    "children"
];
function $3358e06e32bdbfb7$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $3358e06e32bdbfb7$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $3358e06e32bdbfb7$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $3358e06e32bdbfb7$var$_extends() {
    return $3358e06e32bdbfb7$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $3358e06e32bdbfb7$var$_extends.apply(null, arguments);
}
var $3358e06e32bdbfb7$var$FULL_WIDTH_AND_HEIGHT = {
    width: '100%',
    height: '100%',
    /*
   * display: block is necessary here because the default for an SVG is display: inline,
   * which in some browsers (Chrome) adds a little bit of extra space above and below the SVG
   * to make space for the descender of letters like "g" and "y". This throws off the height calculation
   * and causes the container to grow indefinitely on each render with responsive=true.
   * Display: block removes that extra space.
   *
   * Interestingly, Firefox does not have this problem, but it doesn't hurt to add the style anyway.
   */ display: 'block'
};
var $3358e06e32bdbfb7$var$MainChartSurface = /*#__PURE__*/ (0, $kc00y.forwardRef)((props, ref)=>{
    var width = (0, $f4c9341f05a18477$export$8854f7ece606854b)();
    var height = (0, $f4c9341f05a18477$export$369ae257969c6f9f)();
    var hasAccessibilityLayer = (0, $b254816100b9e8bd$export$276788f18f24cad3)();
    if (!(0, $22869ac8a5888437$export$5374bb854d0e41c8)(width) || !(0, $22869ac8a5888437$export$5374bb854d0e41c8)(height)) return null;
    var { children: children, otherAttributes: otherAttributes, title: title, desc: desc } = props;
    var tabIndex, role;
    if (otherAttributes != null) {
        if (typeof otherAttributes.tabIndex === 'number') tabIndex = otherAttributes.tabIndex;
        else tabIndex = hasAccessibilityLayer ? 0 : undefined;
        if (typeof otherAttributes.role === 'string') role = otherAttributes.role;
        else role = hasAccessibilityLayer ? 'application' : undefined;
    }
    return /*#__PURE__*/ $kc00y.createElement((0, $3069fadfb06768fe$export$7b92b459e668cb21), $3358e06e32bdbfb7$var$_extends({}, otherAttributes, {
        title: title,
        desc: desc,
        role: role,
        tabIndex: tabIndex,
        width: width,
        height: height,
        style: $3358e06e32bdbfb7$var$FULL_WIDTH_AND_HEIGHT,
        ref: ref
    }), children);
});
var $3358e06e32bdbfb7$var$BrushPanoramaSurface = (_ref)=>{
    var { children: children } = _ref;
    var brushDimensions = (0, $a441e801d1b41b52$export$a7347740d65f620b)((0, $2f2a17d106b4d13b$export$3b81e97eae001823));
    if (!brushDimensions) return null;
    var { width: width, height: height, y: y, x: x } = brushDimensions;
    return /*#__PURE__*/ $kc00y.createElement((0, $3069fadfb06768fe$export$7b92b459e668cb21), {
        width: width,
        height: height,
        x: x,
        y: y
    }, children);
};
var $3358e06e32bdbfb7$export$b6c051d2e0bcd3e9 = /*#__PURE__*/ (0, $kc00y.forwardRef)((_ref2, ref)=>{
    var { children: children } = _ref2, rest = $3358e06e32bdbfb7$var$_objectWithoutProperties(_ref2, $3358e06e32bdbfb7$var$_excluded);
    var isPanorama = (0, $10d1d693b6b228cd$export$4b0c59f8845ba920)();
    if (isPanorama) return /*#__PURE__*/ $kc00y.createElement($3358e06e32bdbfb7$var$BrushPanoramaSurface, null, /*#__PURE__*/ $kc00y.createElement((0, $df8030e9b0319c2f$export$7a76624f8e4da531), {
        isPanorama: true
    }, children));
    return /*#__PURE__*/ $kc00y.createElement($3358e06e32bdbfb7$var$MainChartSurface, $3358e06e32bdbfb7$var$_extends({
        ref: ref
    }, rest), /*#__PURE__*/ $kc00y.createElement((0, $df8030e9b0319c2f$export$7a76624f8e4da531), {
        isPanorama: false
    }, children));
});



var $kc00y = parcelRequire("kc00y");





var $kc00y = parcelRequire("kc00y");


var $285eaebe8058f646$exports = {};
'use strict';
var $285eaebe8058f646$var$has = Object.prototype.hasOwnProperty, $285eaebe8058f646$var$prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $285eaebe8058f646$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $285eaebe8058f646$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $285eaebe8058f646$var$Events().__proto__) $285eaebe8058f646$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $285eaebe8058f646$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $285eaebe8058f646$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new $285eaebe8058f646$var$EE(fn, context || emitter, once), evt = $285eaebe8058f646$var$prefix ? $285eaebe8058f646$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $285eaebe8058f646$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $285eaebe8058f646$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $285eaebe8058f646$var$EventEmitter() {
    this._events = new $285eaebe8058f646$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $285eaebe8058f646$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($285eaebe8058f646$var$has.call(events, name)) names.push($285eaebe8058f646$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $285eaebe8058f646$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $285eaebe8058f646$var$prefix ? $285eaebe8058f646$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $285eaebe8058f646$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $285eaebe8058f646$var$prefix ? $285eaebe8058f646$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $285eaebe8058f646$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $285eaebe8058f646$var$prefix ? $285eaebe8058f646$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $285eaebe8058f646$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $285eaebe8058f646$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $285eaebe8058f646$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $285eaebe8058f646$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $285eaebe8058f646$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $285eaebe8058f646$var$prefix ? $285eaebe8058f646$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $285eaebe8058f646$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $285eaebe8058f646$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $285eaebe8058f646$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $285eaebe8058f646$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $285eaebe8058f646$var$prefix ? $285eaebe8058f646$var$prefix + event : event;
        if (this._events[evt]) $285eaebe8058f646$var$clearEvent(this, evt);
    } else {
        this._events = new $285eaebe8058f646$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$285eaebe8058f646$var$EventEmitter.prototype.off = $285eaebe8058f646$var$EventEmitter.prototype.removeListener;
$285eaebe8058f646$var$EventEmitter.prototype.addListener = $285eaebe8058f646$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$285eaebe8058f646$var$EventEmitter.prefixed = $285eaebe8058f646$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$285eaebe8058f646$var$EventEmitter.EventEmitter = $285eaebe8058f646$var$EventEmitter;
$285eaebe8058f646$exports = $285eaebe8058f646$var$EventEmitter;


var $5c9a247c367ad3ca$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($285eaebe8058f646$exports)));


var $134a82241e4a1ce5$export$9bcdfe5f29bb33 = new (0, $5c9a247c367ad3ca$export$2e2bcd8739ae039)();
var $134a82241e4a1ce5$export$e2631176295fd79b = 'recharts.syncEvent.tooltip';
var $134a82241e4a1ce5$export$5069141294af4ee8 = 'recharts.syncEvent.brush';






function $8aa8f67197a2a4db$export$54e3aed0d8d4a717(state) {
    return state.tooltip.syncInteraction;
}





var $15ff7f54334e269c$var$_excluded = [
    "x",
    "y"
];
function $15ff7f54334e269c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $15ff7f54334e269c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $15ff7f54334e269c$var$ownKeys(Object(t), !0).forEach(function(r) {
            $15ff7f54334e269c$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $15ff7f54334e269c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $15ff7f54334e269c$var$_defineProperty(e, r, t) {
    return (r = $15ff7f54334e269c$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $15ff7f54334e269c$var$_toPropertyKey(t) {
    var i = $15ff7f54334e269c$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $15ff7f54334e269c$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $15ff7f54334e269c$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $15ff7f54334e269c$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $15ff7f54334e269c$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
/**
 * Listens for tooltip sync events from other charts and dispatches the appropriate
 * sync interaction state based on the current chart's syncMethod.
 *
 * Handles three sync methods:
 * - 'index': passes through the tooltip index with coordinate scaling between chart viewBoxes
 * - 'value': matches the incoming label against this chart's axis ticks by string comparison
 * - function: delegates tick resolution to a user-provided callback
 *
 * When a synced label has no matching tick (e.g. sparse chart), the tooltip is hidden
 * but sourceViewBox is preserved to prevent counter-emission cascades.
 */ function $15ff7f54334e269c$var$useTooltipSyncEventsListener() {
    var mySyncId = (0, $a441e801d1b41b52$export$a7347740d65f620b)((0, $1728a742f9386be1$export$d3b88e5c88540018));
    var myEventEmitter = (0, $a441e801d1b41b52$export$a7347740d65f620b)((0, $1728a742f9386be1$export$b89defd58e84e980));
    var dispatch = (0, $a441e801d1b41b52$export$f51d452c10d5b956)();
    var syncMethod = (0, $a441e801d1b41b52$export$a7347740d65f620b)((0, $1728a742f9386be1$export$f3cbf53653105e96));
    var tooltipTicks = (0, $a441e801d1b41b52$export$a7347740d65f620b)((0, $dbde609d2e66e7f4$export$ffe0e60f8c88c05a));
    var layout = (0, $f4c9341f05a18477$export$970c79ecc7081cc)();
    var viewBox = (0, $f4c9341f05a18477$export$76b29bb074e0c45a)();
    var className = (0, $a441e801d1b41b52$export$a7347740d65f620b)((state)=>state.rootProps.className);
    (0, $kc00y.useEffect)(()=>{
        if (mySyncId == null) // This chart is not synchronised with any other chart so we don't need to listen for any events.
        return 0, $7e613228d3a31273$export$8793edee2d425525;
        var listener = (incomingSyncId, action, emitter)=>{
            if (myEventEmitter === emitter) // We don't want to dispatch actions that we sent ourselves.
            return;
            if (mySyncId !== incomingSyncId) // This event is not for this chart
            return;
            /*
       * Handle source chart deactivation (mouseLeave) for ALL sync methods.
       * This must be checked before any syncMethod-specific logic to ensure
       * sourceViewBox is cleared, which allows isReceivingSynchronisation
       * to become false and lets the normal emission flow resume.
       */ if (action.payload.active === false) {
                dispatch((0, $2bfb679c145bcb6f$export$f2efc99b98e50938)({
                    active: false,
                    coordinate: undefined,
                    dataKey: undefined,
                    index: null,
                    label: undefined,
                    sourceViewBox: undefined,
                    graphicalItemId: undefined
                }));
                return;
            }
            if (syncMethod === 'index') {
                var _action$payload;
                if (viewBox && action !== null && action !== void 0 && (_action$payload = action.payload) !== null && _action$payload !== void 0 && _action$payload.coordinate && action.payload.sourceViewBox) {
                    var _action$payload$coord = action.payload.coordinate, { x: _x, y: _y } = _action$payload$coord, otherCoordinateProps = $15ff7f54334e269c$var$_objectWithoutProperties(_action$payload$coord, $15ff7f54334e269c$var$_excluded);
                    var { x: sourceX, y: sourceY, width: sourceWidth, height: sourceHeight } = action.payload.sourceViewBox;
                    var scaledCoordinate = $15ff7f54334e269c$var$_objectSpread($15ff7f54334e269c$var$_objectSpread({}, otherCoordinateProps), {}, {
                        x: viewBox.x + (sourceWidth ? (_x - sourceX) / sourceWidth : 0) * viewBox.width,
                        y: viewBox.y + (sourceHeight ? (_y - sourceY) / sourceHeight : 0) * viewBox.height
                    });
                    dispatch($15ff7f54334e269c$var$_objectSpread($15ff7f54334e269c$var$_objectSpread({}, action), {}, {
                        payload: $15ff7f54334e269c$var$_objectSpread($15ff7f54334e269c$var$_objectSpread({}, action.payload), {}, {
                            coordinate: scaledCoordinate
                        })
                    }));
                } else dispatch(action);
                return;
            }
            if (tooltipTicks == null) // for the other two sync methods, we need the ticks to be available
            return;
            var activeTick;
            if (typeof syncMethod === 'function') {
                /*
         * This is what the data shape in 2.x CategoricalChartState used to look like.
         * In 3.x we store things differently but let's try to keep the old shape for compatibility.
         */ var syncMethodParam = {
                    activeTooltipIndex: action.payload.index == null ? undefined : Number(action.payload.index),
                    isTooltipActive: action.payload.active,
                    activeIndex: action.payload.index == null ? undefined : Number(action.payload.index),
                    activeLabel: action.payload.label,
                    activeDataKey: action.payload.dataKey,
                    activeCoordinate: action.payload.coordinate
                };
                // Call a callback function. If there is an application specific algorithm
                var activeTooltipIndex = syncMethod(tooltipTicks, syncMethodParam);
                activeTick = tooltipTicks[activeTooltipIndex];
            } else if (syncMethod === 'value') // labels are always strings, tick.value might be a string or a number, depending on axis type
            activeTick = tooltipTicks.find((tick)=>String(tick.value) === action.payload.label);
            var { coordinate: coordinate } = action.payload;
            if (coordinate == null || viewBox == null) {
                dispatch((0, $2bfb679c145bcb6f$export$f2efc99b98e50938)({
                    active: false,
                    coordinate: undefined,
                    dataKey: undefined,
                    index: null,
                    label: undefined,
                    sourceViewBox: undefined,
                    graphicalItemId: undefined
                }));
                return;
            }
            if (activeTick == null) {
                /*
         * The label from the source chart doesn't match any tick in this chart.
         * This happens when synced charts have different data arrays
         * (e.g., one chart has 3 data points while another has 252).
         *
         * We set active: false so the tooltip hides (correct — no data for this date),
         * but we keep sourceViewBox set to signal that we're still receiving sync events.
         * The emission guard in useTooltipChartSynchronisation checks sourceViewBox
         * (not active) to decide whether to suppress outgoing sync events.
         * Without this, the chart would emit a counter-sync event with active: false,
         * cascading to clear tooltips on ALL other synced charts.
         */ dispatch((0, $2bfb679c145bcb6f$export$f2efc99b98e50938)({
                    active: false,
                    coordinate: undefined,
                    dataKey: undefined,
                    index: null,
                    label: undefined,
                    sourceViewBox: action.payload.sourceViewBox,
                    graphicalItemId: undefined
                }));
                return;
            }
            var { x: x, y: y } = coordinate;
            var validateChartX = Math.min(x, viewBox.x + viewBox.width);
            var validateChartY = Math.min(y, viewBox.y + viewBox.height);
            var activeCoordinate = {
                x: layout === 'horizontal' ? activeTick.coordinate : validateChartX,
                y: layout === 'horizontal' ? validateChartY : activeTick.coordinate
            };
            var syncAction = (0, $2bfb679c145bcb6f$export$f2efc99b98e50938)({
                active: action.payload.active,
                coordinate: activeCoordinate,
                dataKey: action.payload.dataKey,
                index: String(activeTick.index),
                label: action.payload.label,
                sourceViewBox: action.payload.sourceViewBox,
                graphicalItemId: action.payload.graphicalItemId
            });
            dispatch(syncAction);
        };
        (0, $134a82241e4a1ce5$export$9bcdfe5f29bb33).on((0, $134a82241e4a1ce5$export$e2631176295fd79b), listener);
        return ()=>{
            (0, $134a82241e4a1ce5$export$9bcdfe5f29bb33).off((0, $134a82241e4a1ce5$export$e2631176295fd79b), listener);
        };
    }, [
        className,
        dispatch,
        myEventEmitter,
        mySyncId,
        syncMethod,
        tooltipTicks,
        layout,
        viewBox
    ]);
}
/**
 * Listens for brush sync events from other charts and updates this chart's
 * data start/end indexes to match, keeping brush positions synchronised.
 */ function $15ff7f54334e269c$var$useBrushSyncEventsListener() {
    var mySyncId = (0, $a441e801d1b41b52$export$a7347740d65f620b)((0, $1728a742f9386be1$export$d3b88e5c88540018));
    var myEventEmitter = (0, $a441e801d1b41b52$export$a7347740d65f620b)((0, $1728a742f9386be1$export$b89defd58e84e980));
    var dispatch = (0, $a441e801d1b41b52$export$f51d452c10d5b956)();
    (0, $kc00y.useEffect)(()=>{
        if (mySyncId == null) // This chart is not synchronised with any other chart so we don't need to listen for any events.
        return 0, $7e613228d3a31273$export$8793edee2d425525;
        var listener = (incomingSyncId, action, emitter)=>{
            if (myEventEmitter === emitter) // We don't want to dispatch actions that we sent ourselves.
            return;
            if (mySyncId === incomingSyncId) dispatch((0, $013669191ef6e95a$export$427d605cc4e3bbdd)(action));
        };
        (0, $134a82241e4a1ce5$export$9bcdfe5f29bb33).on((0, $134a82241e4a1ce5$export$5069141294af4ee8), listener);
        return ()=>{
            (0, $134a82241e4a1ce5$export$9bcdfe5f29bb33).off((0, $134a82241e4a1ce5$export$5069141294af4ee8), listener);
        };
    }, [
        dispatch,
        myEventEmitter,
        mySyncId
    ]);
}
function $15ff7f54334e269c$export$3a6efefeed76accf() {
    var dispatch = (0, $a441e801d1b41b52$export$f51d452c10d5b956)();
    (0, $kc00y.useEffect)(()=>{
        dispatch((0, $06bd4d083c59b4ed$export$abfecd6a8e6070c1)());
    }, [
        dispatch
    ]);
    $15ff7f54334e269c$var$useTooltipSyncEventsListener();
    $15ff7f54334e269c$var$useBrushSyncEventsListener();
}
function $15ff7f54334e269c$export$21f8394fb189b529(tooltipEventType, trigger, activeCoordinate, activeLabel, activeIndex, isTooltipActive) {
    var activeDataKey = (0, $a441e801d1b41b52$export$a7347740d65f620b)((state)=>(0, $f310c8c70271e4da$export$faa2b8b92235e5bd)(state, tooltipEventType, trigger));
    var activeGraphicalItemId = (0, $a441e801d1b41b52$export$a7347740d65f620b)((0, $dbde609d2e66e7f4$export$3bddf33d79812741));
    var eventEmitterSymbol = (0, $a441e801d1b41b52$export$a7347740d65f620b)((0, $1728a742f9386be1$export$b89defd58e84e980));
    var syncId = (0, $a441e801d1b41b52$export$a7347740d65f620b)((0, $1728a742f9386be1$export$d3b88e5c88540018));
    var syncMethod = (0, $a441e801d1b41b52$export$a7347740d65f620b)((0, $1728a742f9386be1$export$f3cbf53653105e96));
    var tooltipState = (0, $a441e801d1b41b52$export$a7347740d65f620b)((0, $8aa8f67197a2a4db$export$54e3aed0d8d4a717));
    /*
   * Use sourceViewBox (not active) to determine if we're receiving sync events.
   * sourceViewBox is set whenever another chart sends a sync event to us — even when
   * our own tooltip is inactive (because the label didn't match our data).
   * This prevents charts with sparse data from emitting counter-sync events
   * that would clear tooltips on all other synced charts.
   */ var isReceivingSynchronisation = (tooltipState === null || tooltipState === void 0 ? void 0 : tooltipState.sourceViewBox) != null;
    var viewBox = (0, $f4c9341f05a18477$export$76b29bb074e0c45a)();
    (0, $kc00y.useEffect)(()=>{
        if (isReceivingSynchronisation) /*
       * This chart is currently receiving synchronisation events from another chart.
       * Let's not send any outgoing synchronisation events while that's happening
       * to avoid infinite loops and cascading tooltip clears.
       */ return;
        if (syncId == null) /*
       * syncId is not set, means that this chart is not synchronised with any other chart,
       * means we don't need to send synchronisation events
       */ return;
        if (eventEmitterSymbol == null) /*
       * When using Recharts internal hooks and selectors outside charts context,
       * these properties will be undefined. Let's return silently instead of throwing an error.
       */ return;
        var syncAction = (0, $2bfb679c145bcb6f$export$f2efc99b98e50938)({
            active: isTooltipActive,
            coordinate: activeCoordinate,
            dataKey: activeDataKey,
            index: activeIndex,
            label: typeof activeLabel === 'number' ? String(activeLabel) : activeLabel,
            sourceViewBox: viewBox,
            graphicalItemId: activeGraphicalItemId
        });
        (0, $134a82241e4a1ce5$export$9bcdfe5f29bb33).emit((0, $134a82241e4a1ce5$export$e2631176295fd79b), syncId, syncAction, eventEmitterSymbol);
    }, [
        isReceivingSynchronisation,
        activeCoordinate,
        activeDataKey,
        activeGraphicalItemId,
        activeIndex,
        activeLabel,
        eventEmitterSymbol,
        syncId,
        syncMethod,
        isTooltipActive,
        viewBox
    ]);
}
function $15ff7f54334e269c$export$d3c93a99675de51f() {
    var syncId = (0, $a441e801d1b41b52$export$a7347740d65f620b)((0, $1728a742f9386be1$export$d3b88e5c88540018));
    var eventEmitterSymbol = (0, $a441e801d1b41b52$export$a7347740d65f620b)((0, $1728a742f9386be1$export$b89defd58e84e980));
    var brushStartIndex = (0, $a441e801d1b41b52$export$a7347740d65f620b)((state)=>state.chartData.dataStartIndex);
    var brushEndIndex = (0, $a441e801d1b41b52$export$a7347740d65f620b)((state)=>state.chartData.dataEndIndex);
    (0, $kc00y.useEffect)(()=>{
        if (syncId == null || brushStartIndex == null || brushEndIndex == null || eventEmitterSymbol == null) return;
        var syncAction = {
            startIndex: brushStartIndex,
            endIndex: brushEndIndex
        };
        (0, $134a82241e4a1ce5$export$9bcdfe5f29bb33).emit((0, $134a82241e4a1ce5$export$5069141294af4ee8), syncId, syncAction, eventEmitterSymbol);
    }, [
        brushEndIndex,
        brushStartIndex,
        eventEmitterSymbol,
        syncId
    ]);
}




var $kc00y = parcelRequire("kc00y");




function $fdd8b072471bdf75$export$20f53c2c914d2da0() {
    var dispatch = (0, $a441e801d1b41b52$export$f51d452c10d5b956)();
    var [ref, setRef] = (0, $kc00y.useState)(null);
    var scale = (0, $a441e801d1b41b52$export$a7347740d65f620b)((0, $0b675d94b376aa83$export$317b55dda5fb5617));
    (0, $kc00y.useEffect)(()=>{
        if (ref == null) return;
        var rect = ref.getBoundingClientRect();
        var newScale = rect.width / ref.offsetWidth;
        if ((0, $22869ac8a5888437$export$f8a8fc612ced9bb0)(newScale) && newScale !== scale) dispatch((0, $a3abdcf7f5febb61$export$4dc523f7f9b3edd6)(newScale));
    }, [
        ref,
        dispatch,
        scale
    ]);
    return setRef;
}





var $kc00y = parcelRequire("kc00y");
var $58efe4c06d55fa88$export$cf22c67346dd99a4 = /*#__PURE__*/ (0, $kc00y.createContext)(null);
var $58efe4c06d55fa88$export$2842d70d9d62127a = ()=>(0, $kc00y.useContext)($58efe4c06d55fa88$export$cf22c67346dd99a4);



var $kc00y = parcelRequire("kc00y");
var $91084920e544d800$export$63a23315bebc1b2 = /*#__PURE__*/ (0, $kc00y.createContext)(null);
var $91084920e544d800$export$36ebc0838785d4af = ()=>(0, $kc00y.useContext)($91084920e544d800$export$63a23315bebc1b2);




function $fceb88e164567d33$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fceb88e164567d33$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fceb88e164567d33$var$ownKeys(Object(t), !0).forEach(function(r) {
            $fceb88e164567d33$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fceb88e164567d33$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $fceb88e164567d33$var$_defineProperty(e, r, t) {
    return (r = $fceb88e164567d33$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $fceb88e164567d33$var$_toPropertyKey(t) {
    var i = $fceb88e164567d33$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $fceb88e164567d33$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $fceb88e164567d33$var$_extends() {
    return $fceb88e164567d33$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $fceb88e164567d33$var$_extends.apply(null, arguments);
}
var $fceb88e164567d33$var$EventSynchronizer = ()=>{
    (0, $15ff7f54334e269c$export$3a6efefeed76accf)();
    return null;
};
function $fceb88e164567d33$var$getNumberOrZero(value) {
    if (typeof value === 'number') return value;
    if (typeof value === 'string') {
        var parsed = parseFloat(value);
        if (!Number.isNaN(parsed)) return parsed;
    }
    return 0;
}
var $fceb88e164567d33$var$ResponsiveDiv = /*#__PURE__*/ (0, $kc00y.forwardRef)((props, ref)=>{
    var _props$style, _props$style2;
    var observerRef = (0, $kc00y.useRef)(null);
    var [sizes, setSizes] = (0, $kc00y.useState)({
        containerWidth: $fceb88e164567d33$var$getNumberOrZero((_props$style = props.style) === null || _props$style === void 0 ? void 0 : _props$style.width),
        containerHeight: $fceb88e164567d33$var$getNumberOrZero((_props$style2 = props.style) === null || _props$style2 === void 0 ? void 0 : _props$style2.height)
    });
    var setContainerSize = (0, $kc00y.useCallback)((newWidth, newHeight)=>{
        setSizes((prevState)=>{
            var roundedWidth = Math.round(newWidth);
            var roundedHeight = Math.round(newHeight);
            if (prevState.containerWidth === roundedWidth && prevState.containerHeight === roundedHeight) return prevState;
            return {
                containerWidth: roundedWidth,
                containerHeight: roundedHeight
            };
        });
    }, []);
    var innerRef = (0, $kc00y.useCallback)((node)=>{
        // 1. First, call the external ref if it was provided
        if (typeof ref === 'function') ref(node);
        // 2. Disconnect any previously active ResizeObserver instance to prevent memory leaks
        if (observerRef.current != null) {
            observerRef.current.disconnect();
            observerRef.current = null;
        }
        // 3. Initiate a new ResizeObserver on the valid DOM node
        if (node != null && typeof ResizeObserver !== 'undefined') {
            var { width: containerWidth, height: containerHeight } = node.getBoundingClientRect();
            setContainerSize(containerWidth, containerHeight);
            var callback = (entries)=>{
                var entry = entries[0];
                if (entry == null) return;
                var { width: width, height: height } = entry.contentRect;
                setContainerSize(width, height);
            };
            var observer = new ResizeObserver(callback);
            observer.observe(node);
            observerRef.current = observer;
        }
    }, [
        ref,
        setContainerSize
    ]);
    (0, $kc00y.useEffect)(()=>{
        return ()=>{
            var observer = observerRef.current;
            if (observer != null) observer.disconnect();
        };
    }, [
        setContainerSize
    ]);
    return /*#__PURE__*/ $kc00y.createElement($kc00y.Fragment, null, /*#__PURE__*/ $kc00y.createElement((0, $f4c9341f05a18477$export$80ea82e77fb424e1), {
        width: sizes.containerWidth,
        height: sizes.containerHeight
    }), /*#__PURE__*/ $kc00y.createElement("div", $fceb88e164567d33$var$_extends({
        ref: innerRef
    }, props)));
});
var $fceb88e164567d33$var$ReadSizeOnceDiv = /*#__PURE__*/ (0, $kc00y.forwardRef)((props, ref)=>{
    var { width: width, height: height } = props;
    var [sizes, setSizes] = (0, $kc00y.useState)({
        containerWidth: $fceb88e164567d33$var$getNumberOrZero(width),
        containerHeight: $fceb88e164567d33$var$getNumberOrZero(height)
    });
    var setContainerSize = (0, $kc00y.useCallback)((newWidth, newHeight)=>{
        setSizes((prevState)=>{
            var roundedWidth = Math.round(newWidth);
            var roundedHeight = Math.round(newHeight);
            if (prevState.containerWidth === roundedWidth && prevState.containerHeight === roundedHeight) return prevState;
            return {
                containerWidth: roundedWidth,
                containerHeight: roundedHeight
            };
        });
    }, []);
    var innerRef = (0, $kc00y.useCallback)((node)=>{
        if (typeof ref === 'function') ref(node);
        if (node != null) {
            var { width: containerWidth, height: containerHeight } = node.getBoundingClientRect();
            setContainerSize(containerWidth, containerHeight);
        }
    }, [
        ref,
        setContainerSize
    ]);
    return /*#__PURE__*/ $kc00y.createElement($kc00y.Fragment, null, /*#__PURE__*/ $kc00y.createElement((0, $f4c9341f05a18477$export$80ea82e77fb424e1), {
        width: sizes.containerWidth,
        height: sizes.containerHeight
    }), /*#__PURE__*/ $kc00y.createElement("div", $fceb88e164567d33$var$_extends({
        ref: innerRef
    }, props)));
});
var $fceb88e164567d33$var$StaticDiv = /*#__PURE__*/ (0, $kc00y.forwardRef)((props, ref)=>{
    var { width: width, height: height } = props;
    return /*#__PURE__*/ $kc00y.createElement($kc00y.Fragment, null, /*#__PURE__*/ $kc00y.createElement((0, $f4c9341f05a18477$export$80ea82e77fb424e1), {
        width: width,
        height: height
    }), /*#__PURE__*/ $kc00y.createElement("div", $fceb88e164567d33$var$_extends({
        ref: ref
    }, props)));
});
var $fceb88e164567d33$var$NonResponsiveDiv = /*#__PURE__*/ (0, $kc00y.forwardRef)((props, ref)=>{
    var { width: width, height: height } = props;
    // When width or height are percentages or CSS short names, read size from DOM once
    if (typeof width === 'string' || typeof height === 'string') return /*#__PURE__*/ $kc00y.createElement($fceb88e164567d33$var$ReadSizeOnceDiv, $fceb88e164567d33$var$_extends({}, props, {
        ref: ref
    }));
    // When both are numbers, use them directly
    if (typeof width === 'number' && typeof height === 'number') return /*#__PURE__*/ $kc00y.createElement($fceb88e164567d33$var$StaticDiv, $fceb88e164567d33$var$_extends({}, props, {
        width: width,
        height: height,
        ref: ref
    }));
    // When width/height are undefined, render wrapper div without reporting size
    // This results in no SVG being rendered (intentional for backwards compatibility)
    return /*#__PURE__*/ $kc00y.createElement($kc00y.Fragment, null, /*#__PURE__*/ $kc00y.createElement((0, $f4c9341f05a18477$export$80ea82e77fb424e1), {
        width: width,
        height: height
    }), /*#__PURE__*/ $kc00y.createElement("div", $fceb88e164567d33$var$_extends({
        ref: ref
    }, props)));
});
function $fceb88e164567d33$var$getWrapperDivComponent(responsive) {
    return responsive ? $fceb88e164567d33$var$ResponsiveDiv : $fceb88e164567d33$var$NonResponsiveDiv;
}
var $fceb88e164567d33$export$81bb7974a33f88b = /*#__PURE__*/ (0, $kc00y.forwardRef)((props, ref)=>{
    var { children: children, className: className, height: heightFromProps, onClick: onClick, onContextMenu: onContextMenu, onDoubleClick: onDoubleClick, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseMove: onMouseMove, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, style: style, width: widthFromProps, responsive: responsive, dispatchTouchEvents: dispatchTouchEvents = true } = props;
    var containerRef = (0, $kc00y.useRef)(null);
    var dispatch = (0, $a441e801d1b41b52$export$f51d452c10d5b956)();
    var [tooltipPortal, setTooltipPortal] = (0, $kc00y.useState)(null);
    var [legendPortal, setLegendPortal] = (0, $kc00y.useState)(null);
    var setScaleRef = (0, $fdd8b072471bdf75$export$20f53c2c914d2da0)();
    var responsiveContainerCalculations = (0, $ffea1da660acf881$export$4ec9972d4f677af6)();
    var width = (responsiveContainerCalculations === null || responsiveContainerCalculations === void 0 ? void 0 : responsiveContainerCalculations.width) > 0 ? responsiveContainerCalculations.width : widthFromProps;
    var height = (responsiveContainerCalculations === null || responsiveContainerCalculations === void 0 ? void 0 : responsiveContainerCalculations.height) > 0 ? responsiveContainerCalculations.height : heightFromProps;
    var innerRef = (0, $kc00y.useCallback)((node)=>{
        setScaleRef(node);
        if (typeof ref === 'function') ref(node);
        setTooltipPortal(node);
        setLegendPortal(node);
        if (node != null) containerRef.current = node;
    }, [
        setScaleRef,
        ref,
        setTooltipPortal,
        setLegendPortal
    ]);
    var myOnClick = (0, $kc00y.useCallback)((e)=>{
        dispatch((0, $18f6e3b3e4e52774$export$f06e14b484aecafc)(e));
        dispatch((0, $9b16f680853ef197$export$1d0268b9f89859f0)({
            handler: onClick,
            reactEvent: e
        }));
    }, [
        dispatch,
        onClick
    ]);
    var myOnMouseEnter = (0, $kc00y.useCallback)((e)=>{
        dispatch((0, $18f6e3b3e4e52774$export$f9de213dbfb2e32c)(e));
        dispatch((0, $9b16f680853ef197$export$1d0268b9f89859f0)({
            handler: onMouseEnter,
            reactEvent: e
        }));
    }, [
        dispatch,
        onMouseEnter
    ]);
    var myOnMouseLeave = (0, $kc00y.useCallback)((e)=>{
        dispatch((0, $2bfb679c145bcb6f$export$73879bed3f2eef71)());
        dispatch((0, $9b16f680853ef197$export$1d0268b9f89859f0)({
            handler: onMouseLeave,
            reactEvent: e
        }));
    }, [
        dispatch,
        onMouseLeave
    ]);
    var myOnMouseMove = (0, $kc00y.useCallback)((e)=>{
        dispatch((0, $18f6e3b3e4e52774$export$f9de213dbfb2e32c)(e));
        dispatch((0, $9b16f680853ef197$export$1d0268b9f89859f0)({
            handler: onMouseMove,
            reactEvent: e
        }));
    }, [
        dispatch,
        onMouseMove
    ]);
    var onFocus = (0, $kc00y.useCallback)(()=>{
        dispatch((0, $b0c870d135750371$export$d95192eee5865567)());
    }, [
        dispatch
    ]);
    var onBlur = (0, $kc00y.useCallback)(()=>{
        dispatch((0, $b0c870d135750371$export$af52bfdff6fb5bd7)());
    }, [
        dispatch
    ]);
    var onKeyDown = (0, $kc00y.useCallback)((e)=>{
        dispatch((0, $b0c870d135750371$export$4839538efb7414c)(e.key));
    }, [
        dispatch
    ]);
    var myOnContextMenu = (0, $kc00y.useCallback)((e)=>{
        dispatch((0, $9b16f680853ef197$export$1d0268b9f89859f0)({
            handler: onContextMenu,
            reactEvent: e
        }));
    }, [
        dispatch,
        onContextMenu
    ]);
    var myOnDoubleClick = (0, $kc00y.useCallback)((e)=>{
        dispatch((0, $9b16f680853ef197$export$1d0268b9f89859f0)({
            handler: onDoubleClick,
            reactEvent: e
        }));
    }, [
        dispatch,
        onDoubleClick
    ]);
    var myOnMouseDown = (0, $kc00y.useCallback)((e)=>{
        dispatch((0, $9b16f680853ef197$export$1d0268b9f89859f0)({
            handler: onMouseDown,
            reactEvent: e
        }));
    }, [
        dispatch,
        onMouseDown
    ]);
    var myOnMouseUp = (0, $kc00y.useCallback)((e)=>{
        dispatch((0, $9b16f680853ef197$export$1d0268b9f89859f0)({
            handler: onMouseUp,
            reactEvent: e
        }));
    }, [
        dispatch,
        onMouseUp
    ]);
    var myOnTouchStart = (0, $kc00y.useCallback)((e)=>{
        dispatch((0, $9b16f680853ef197$export$1d0268b9f89859f0)({
            handler: onTouchStart,
            reactEvent: e
        }));
    }, [
        dispatch,
        onTouchStart
    ]);
    /*
   * onTouchMove is special because it behaves different from mouse events.
   * Mouse events have 'enter' + 'leave' combo that notify us when the mouse is over
   * a certain element. Touch events don't have that; touch only gives us
   * start (finger down), end (finger up) and move (finger moving).
   * So we need to figure out which element the user is touching
   * ourselves. Fortunately, there's a convenient method for that:
   * https://developer.mozilla.org/en-US/docs/Web/API/Document/elementFromPoint
   */ var myOnTouchMove = (0, $kc00y.useCallback)((e)=>{
        if (dispatchTouchEvents) dispatch((0, $98b87fa8a2a1620a$export$ba46b5fda0e2985f)(e));
        dispatch((0, $9b16f680853ef197$export$1d0268b9f89859f0)({
            handler: onTouchMove,
            reactEvent: e
        }));
    }, [
        dispatch,
        dispatchTouchEvents,
        onTouchMove
    ]);
    var myOnTouchEnd = (0, $kc00y.useCallback)((e)=>{
        dispatch((0, $9b16f680853ef197$export$1d0268b9f89859f0)({
            handler: onTouchEnd,
            reactEvent: e
        }));
    }, [
        dispatch,
        onTouchEnd
    ]);
    var WrapperDiv = $fceb88e164567d33$var$getWrapperDivComponent(responsive);
    return /*#__PURE__*/ $kc00y.createElement((0, $58efe4c06d55fa88$export$cf22c67346dd99a4).Provider, {
        value: tooltipPortal
    }, /*#__PURE__*/ $kc00y.createElement((0, $91084920e544d800$export$63a23315bebc1b2).Provider, {
        value: legendPortal
    }, /*#__PURE__*/ $kc00y.createElement(WrapperDiv, {
        width: width !== null && width !== void 0 ? width : style === null || style === void 0 ? void 0 : style.width,
        height: height !== null && height !== void 0 ? height : style === null || style === void 0 ? void 0 : style.height,
        className: (0, $328c1c2632e2f292$export$4f5d2d50c9deca37)('recharts-wrapper', className),
        style: $fceb88e164567d33$var$_objectSpread({
            position: 'relative',
            cursor: 'default',
            width: width,
            height: height
        }, style),
        onClick: myOnClick,
        onContextMenu: myOnContextMenu,
        onDoubleClick: myOnDoubleClick,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyDown: onKeyDown,
        onMouseDown: myOnMouseDown,
        onMouseEnter: myOnMouseEnter,
        onMouseLeave: myOnMouseLeave,
        onMouseMove: myOnMouseMove,
        onMouseUp: myOnMouseUp,
        onTouchEnd: myOnTouchEnd,
        onTouchMove: myOnTouchMove,
        onTouchStart: myOnTouchStart,
        ref: innerRef
    }, /*#__PURE__*/ $kc00y.createElement($fceb88e164567d33$var$EventSynchronizer, null), children)));
});



var $kc00y = parcelRequire("kc00y");


var $dca5c408371f3cf1$var$ClipPathIdContext = /*#__PURE__*/ (0, $kc00y.createContext)(undefined);
var $dca5c408371f3cf1$export$8b42b9b49a38ca72 = (_ref)=>{
    var { children: children } = _ref;
    var [clipPathId] = (0, $kc00y.useState)("".concat((0, $7e613228d3a31273$export$8b15d37bc3f197d4)('recharts'), "-clip"));
    var plotArea = (0, $1a51fe639a3ac8a2$export$f1ef8efc9ef6fe0c)();
    if (plotArea == null) return null;
    var { x: x, y: y, width: width, height: height } = plotArea;
    return /*#__PURE__*/ $kc00y.createElement($dca5c408371f3cf1$var$ClipPathIdContext.Provider, {
        value: clipPathId
    }, /*#__PURE__*/ $kc00y.createElement("defs", null, /*#__PURE__*/ $kc00y.createElement("clipPath", {
        id: clipPathId
    }, /*#__PURE__*/ $kc00y.createElement("rect", {
        x: x,
        y: y,
        height: height,
        width: width
    }))), children);
};
var $dca5c408371f3cf1$export$71e825c43eae6ca6 = ()=>{
    return (0, $kc00y.useContext)($dca5c408371f3cf1$var$ClipPathIdContext);
};




var $f6c0644c6a73bda5$var$_excluded = [
    "width",
    "height",
    "responsive",
    "children",
    "className",
    "style",
    "compact",
    "title",
    "desc"
];
function $f6c0644c6a73bda5$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $f6c0644c6a73bda5$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $f6c0644c6a73bda5$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $f6c0644c6a73bda5$export$d49e03133b3316a9 = /*#__PURE__*/ (0, $kc00y.forwardRef)((props, ref)=>{
    var { width: width, height: height, responsive: responsive, children: children, className: className, style: style, compact: compact, title: title, desc: desc } = props, others = $f6c0644c6a73bda5$var$_objectWithoutProperties(props, $f6c0644c6a73bda5$var$_excluded);
    var attrs = (0, $34cf66bbb2aff04f$export$8b56257912140094)(others);
    /*
   * The "compact" mode is used as the panorama within Brush.
   * However because `compact` is a public prop, let's assume that it can render outside of Brush too.
   */ if (compact) return /*#__PURE__*/ $kc00y.createElement($kc00y.Fragment, null, /*#__PURE__*/ $kc00y.createElement((0, $f4c9341f05a18477$export$80ea82e77fb424e1), {
        width: width,
        height: height
    }), /*#__PURE__*/ $kc00y.createElement((0, $3358e06e32bdbfb7$export$b6c051d2e0bcd3e9), {
        otherAttributes: attrs,
        title: title,
        desc: desc
    }, children));
    return /*#__PURE__*/ $kc00y.createElement((0, $fceb88e164567d33$export$81bb7974a33f88b), {
        className: className,
        style: style,
        width: width,
        height: height,
        responsive: responsive !== null && responsive !== void 0 ? responsive : false,
        onClick: props.onClick,
        onMouseLeave: props.onMouseLeave,
        onMouseEnter: props.onMouseEnter,
        onMouseMove: props.onMouseMove,
        onMouseDown: props.onMouseDown,
        onMouseUp: props.onMouseUp,
        onContextMenu: props.onContextMenu,
        onDoubleClick: props.onDoubleClick,
        onTouchStart: props.onTouchStart,
        onTouchMove: props.onTouchMove,
        onTouchEnd: props.onTouchEnd
    }, /*#__PURE__*/ $kc00y.createElement((0, $3358e06e32bdbfb7$export$b6c051d2e0bcd3e9), {
        otherAttributes: attrs,
        title: title,
        desc: desc,
        ref: ref
    }, /*#__PURE__*/ $kc00y.createElement((0, $dca5c408371f3cf1$export$8b42b9b49a38ca72), null, children)));
});




function $aa2611a6e326dbb9$var$_extends() {
    return $aa2611a6e326dbb9$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $aa2611a6e326dbb9$var$_extends.apply(null, arguments);
}
function $aa2611a6e326dbb9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $aa2611a6e326dbb9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $aa2611a6e326dbb9$var$ownKeys(Object(t), !0).forEach(function(r) {
            $aa2611a6e326dbb9$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $aa2611a6e326dbb9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $aa2611a6e326dbb9$var$_defineProperty(e, r, t) {
    return (r = $aa2611a6e326dbb9$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $aa2611a6e326dbb9$var$_toPropertyKey(t) {
    var i = $aa2611a6e326dbb9$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $aa2611a6e326dbb9$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $aa2611a6e326dbb9$var$defaultMargin = {
    top: 5,
    right: 5,
    bottom: 5,
    left: 5
};
var $aa2611a6e326dbb9$export$2663cf0965a16cf2 = $aa2611a6e326dbb9$var$_objectSpread({
    accessibilityLayer: true,
    barCategoryGap: '10%',
    barGap: 4,
    layout: 'horizontal',
    margin: $aa2611a6e326dbb9$var$defaultMargin,
    responsive: false,
    reverseStackOrder: false,
    stackOffset: 'none',
    syncMethod: 'index'
}, (0, $a6ede7080be43fb0$export$b8b957c7b621f147));
var $aa2611a6e326dbb9$export$855bb85b2910abc9 = /*#__PURE__*/ (0, $kc00y.forwardRef)(function CartesianChart(props, ref) {
    var _categoricalChartProp;
    var rootChartProps = (0, $4cc2299923ef69c7$export$45004cc70a390ee8)(props.categoricalChartProps, $aa2611a6e326dbb9$export$2663cf0965a16cf2);
    var { chartName: chartName, defaultTooltipEventType: defaultTooltipEventType, validateTooltipEventTypes: validateTooltipEventTypes, tooltipPayloadSearcher: tooltipPayloadSearcher, categoricalChartProps: categoricalChartProps } = props;
    var options = {
        chartName: chartName,
        defaultTooltipEventType: defaultTooltipEventType,
        validateTooltipEventTypes: validateTooltipEventTypes,
        tooltipPayloadSearcher: tooltipPayloadSearcher,
        eventEmitter: undefined
    };
    return /*#__PURE__*/ $kc00y.createElement((0, $a0ffcc501bd4818e$export$debe87639f2707f9), {
        preloadedState: {
            options: options
        },
        reduxStoreName: (_categoricalChartProp = categoricalChartProps.id) !== null && _categoricalChartProp !== void 0 ? _categoricalChartProp : chartName
    }, /*#__PURE__*/ $kc00y.createElement((0, $2fbac5019ff11bb3$export$2100a1dedbca0238), {
        chartData: categoricalChartProps.data
    }), /*#__PURE__*/ $kc00y.createElement((0, $62df92852f2f4482$export$6faeaad6e02c2e9d), {
        layout: rootChartProps.layout,
        margin: rootChartProps.margin
    }), /*#__PURE__*/ $kc00y.createElement((0, $f463b6c2910c27e9$export$dcb02be33c78f8ab), {
        throttleDelay: rootChartProps.throttleDelay,
        throttledEvents: rootChartProps.throttledEvents
    }), /*#__PURE__*/ $kc00y.createElement((0, $a435dfd6f3838af8$export$6fabfb9ba230d12b), {
        baseValue: rootChartProps.baseValue,
        accessibilityLayer: rootChartProps.accessibilityLayer,
        barCategoryGap: rootChartProps.barCategoryGap,
        maxBarSize: rootChartProps.maxBarSize,
        stackOffset: rootChartProps.stackOffset,
        barGap: rootChartProps.barGap,
        barSize: rootChartProps.barSize,
        syncId: rootChartProps.syncId,
        syncMethod: rootChartProps.syncMethod,
        className: rootChartProps.className,
        reverseStackOrder: rootChartProps.reverseStackOrder
    }), /*#__PURE__*/ $kc00y.createElement((0, $f6c0644c6a73bda5$export$d49e03133b3316a9), $aa2611a6e326dbb9$var$_extends({}, rootChartProps, {
        ref: ref
    })));
});


var $67563287da1fa124$var$allowedTooltipTypes = [
    'axis',
    'item'
];
var $67563287da1fa124$export$94aefc399ef206a9 = /*#__PURE__*/ (0, $kc00y.forwardRef)((props, ref)=>{
    return /*#__PURE__*/ $kc00y.createElement((0, $aa2611a6e326dbb9$export$855bb85b2910abc9), {
        chartName: "BarChart",
        defaultTooltipEventType: "axis",
        validateTooltipEventTypes: $67563287da1fa124$var$allowedTooltipTypes,
        tooltipPayloadSearcher: (0, $06bd4d083c59b4ed$export$3d996ff386c7802d),
        categoricalChartProps: props,
        ref: ref
    });
});


var $kc00y = parcelRequire("kc00y");






var $db33454bda932a01$export$c7964a5b9439ae62 = (_ref, _ref2)=>{
    var { x: x1, y: y1 } = _ref;
    var { x: x2, y: y2 } = _ref2;
    return {
        x: Math.min(x1, x2),
        y: Math.min(y1, y2),
        width: Math.abs(x2 - x1),
        height: Math.abs(y2 - y1)
    };
};
var $db33454bda932a01$export$6df2062b9e15eec0 = (_ref3)=>{
    var { x1: x1, y1: y1, x2: x2, y2: y2 } = _ref3;
    return $db33454bda932a01$export$c7964a5b9439ae62({
        x: x1,
        y: y1
    }, {
        x: x2,
        y: y2
    });
};
function $db33454bda932a01$export$e3df76cf4464bc81(angle) {
    return (angle % 180 + 180) % 180;
}
var $db33454bda932a01$export$3ee78d51cffc2b68 = function getAngledRectangleWidth(_ref4) {
    var { width: width, height: height } = _ref4;
    var angle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Ensure angle is >= 0 && < 180
    var normalizedAngle = $db33454bda932a01$export$e3df76cf4464bc81(angle);
    var angleRadians = normalizedAngle * Math.PI / 180;
    /* Depending on the height and width of the rectangle, we may need to use different formulas to calculate the angled
   * width. This threshold defines when each formula should kick in. */ var angleThreshold = Math.atan(height / width);
    var angledWidth = angleRadians > angleThreshold && angleRadians < Math.PI - angleThreshold ? height / Math.sin(angleRadians) : width / Math.cos(angleRadians);
    return Math.abs(angledWidth);
};


/**
 * Given an array and a number N, return a new array which contains every nTh
 * element of the input array. For n below 1, an empty array is returned.
 * For n equal to 1, the input array is returned as is.
 * For n greater than the length of the array, an array containing the first element
 * and every nTh element after that (if any) is returned.
 *
 * @param array An input array.
 * @param n A number specifying which elements to take.
 * @returns The result array of the same type as the input array.
 */ function $9ecb4e6794c72bd8$export$c0c2f0af9f98bc62(array, n) {
    if (n < 1) return [];
    if (n === 1) return array;
    var result = [];
    for(var i = 0; i < array.length; i += n){
        var item = array[i];
        if (item !== undefined) result.push(item);
    }
    return result;
}


function $b0cc7ba789b8a338$export$a1966f4ad955c82b(contentSize, unitSize, angle) {
    var size = {
        width: contentSize.width + unitSize.width,
        height: contentSize.height + unitSize.height
    };
    return (0, $db33454bda932a01$export$3ee78d51cffc2b68)(size, angle);
}
function $b0cc7ba789b8a338$export$a257eb8806d5033d(viewBox, sign, sizeKey) {
    var isWidth = sizeKey === 'width';
    var { x: x, y: y, width: width, height: height } = viewBox;
    if (sign === 1) return {
        start: isWidth ? x : y,
        end: isWidth ? x + width : y + height
    };
    return {
        start: isWidth ? x + width : y + height,
        end: isWidth ? x : y
    };
}
function $b0cc7ba789b8a338$export$795910f5f15a9633(sign, tickPosition, getSize, start, end) {
    /* Since getSize() is expensive (it reads the ticks' size from the DOM), we do this check first to avoid calculating
   * the tick's size. */ if (sign * tickPosition < sign * start || sign * tickPosition > sign * end) return false;
    var size = getSize();
    return sign * (tickPosition - sign * size / 2 - start) >= 0 && sign * (tickPosition + sign * size / 2 - end) <= 0;
}
function $b0cc7ba789b8a338$export$beeebbe3ff1b306b(ticks, interval) {
    return (0, $9ecb4e6794c72bd8$export$c0c2f0af9f98bc62)(ticks, interval + 1);
}




function $8bbec28e108d48df$export$77bf2ab5711b7f99(sign, boundaries, getTickSize, ticks, minTickGap) {
    // If the ticks are readonly, then the slice might not be necessary
    var result = (ticks || []).slice();
    var { start: initialStart, end: end } = boundaries;
    var index = 0;
    // Premature optimisation idea 1: Estimate a lower bound, and start from there.
    // For now, start from every tick
    var stepsize = 1;
    var start = initialStart;
    var _loop = function _loop() {
        // Given stepsize, evaluate whether every stepsize-th tick can be shown.
        // If it can not, then increase the stepsize by 1, and try again.
        var entry = ticks === null || ticks === void 0 ? void 0 : ticks[index];
        // Break condition - If we have evaluated all the ticks, then we are done.
        if (entry === undefined) return {
            v: (0, $9ecb4e6794c72bd8$export$c0c2f0af9f98bc62)(ticks, stepsize)
        };
        // Check if the element collides with the next element
        var i = index;
        var size;
        var getSize = ()=>{
            if (size === undefined) size = getTickSize(entry, i);
            return size;
        };
        var tickCoord = entry.coordinate;
        // We will always show the first tick.
        var isShow = index === 0 || (0, $b0cc7ba789b8a338$export$795910f5f15a9633)(sign, tickCoord, getSize, start, end);
        if (!isShow) {
            // Start all over with a larger stepsize
            index = 0;
            start = initialStart;
            stepsize += 1;
        }
        if (isShow) {
            // If it can be shown, update the start
            start = tickCoord + sign * (getSize() / 2 + minTickGap);
            index += stepsize;
        }
    }, _ret;
    while(stepsize <= result.length){
        _ret = _loop();
        if (_ret) return _ret.v;
    }
    return [];
}
function $8bbec28e108d48df$export$635ece29a4bbdfac(sign, boundaries, getTickSize, ticks, minTickGap) {
    // If the ticks are readonly, then the slice might not be necessary
    // Reworked logic for getEquidistantPreserveEndTicks
    var result = (ticks || []).slice();
    var len = result.length;
    if (len === 0) return [];
    var { start: initialStart, end: end } = boundaries;
    // Start with stepsize = 1 (every tick) up to the maximum possible stepsize (len)
    for(var stepsize = 1; stepsize <= len; stepsize++){
        // 1. Calculate the offset so the last tick (index len - 1) is always included in the sequence.
        var offset = (len - 1) % stepsize;
        var start = initialStart; // `start` tracks the coordinate of the last successfully drawn tick + gap
        var ok = true;
        // 2. Iterate through the end-anchored sequence: offset, offset + stepsize, ..., len - 1
        var _loop2 = function _loop2() {
            var entry = ticks[index];
            if (entry == null) return 0; // continue
            var i = index;
            var size;
            // Use a function to get size, as in the original code
            var getSize = ()=>{
                if (size === undefined) size = getTickSize(entry, i);
                return size;
            };
            var tickCoord = entry.coordinate;
            // 3. Apply visibility logic (including the first tick special case)
            // The reviewer says *not* to unconditionally bypass checks for the last tick.
            var isShow = index === offset || (0, $b0cc7ba789b8a338$export$795910f5f15a9633)(sign, tickCoord, getSize, start, end);
            if (!isShow) {
                // If any tick in this end-anchored sequence fails visibility/collision,
                // reject this stepsize and move to the next iteration (larger stepsize).
                ok = false;
                return 1; // break
            }
            // 4. If showable, update the 'start' coordinate for the next collision check
            if (isShow) start = tickCoord + sign * (getSize() / 2 + minTickGap);
        }, _ret2;
        for(var index = offset; index < len; index += stepsize){
            _ret2 = _loop2();
            if (_ret2 === 0) continue;
            if (_ret2 === 1) break;
        }
        // 5. If the entire sequence for this stepsize passed the visibility check, return the result
        if (ok) {
            // Build the final result array explicitly using the validated stepsize and offset.
            var finalTicks = [];
            for(var _index = offset; _index < len; _index += stepsize){
                var tick = ticks[_index];
                if (tick != null) finalTicks.push(tick);
            }
            return finalTicks;
        }
    }
    // If no stepsize works (this shouldn't happen unless minTickGap is huge), return an empty array.
    return [];
}


function $eee5f9677a72ba23$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $eee5f9677a72ba23$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $eee5f9677a72ba23$var$ownKeys(Object(t), !0).forEach(function(r) {
            $eee5f9677a72ba23$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $eee5f9677a72ba23$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $eee5f9677a72ba23$var$_defineProperty(e, r, t) {
    return (r = $eee5f9677a72ba23$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $eee5f9677a72ba23$var$_toPropertyKey(t) {
    var i = $eee5f9677a72ba23$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $eee5f9677a72ba23$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $eee5f9677a72ba23$var$getTicksEnd(sign, boundaries, getTickSize, ticks, minTickGap) {
    var result = (ticks || []).slice();
    var len = result.length;
    var { start: start } = boundaries;
    var { end: end } = boundaries;
    var _loop = function _loop(i) {
        var initialEntry = result[i];
        if (initialEntry == null) return 1; // continue
        var entry = initialEntry;
        var size;
        var getSize = ()=>{
            if (size === undefined) size = getTickSize(initialEntry, i);
            return size;
        };
        if (i === len - 1) {
            var gap = sign * (entry.coordinate + sign * getSize() / 2 - end);
            result[i] = entry = $eee5f9677a72ba23$var$_objectSpread($eee5f9677a72ba23$var$_objectSpread({}, entry), {}, {
                tickCoord: gap > 0 ? entry.coordinate - gap * sign : entry.coordinate
            });
        } else result[i] = entry = $eee5f9677a72ba23$var$_objectSpread($eee5f9677a72ba23$var$_objectSpread({}, entry), {}, {
            tickCoord: entry.coordinate
        });
        if (entry.tickCoord != null) {
            var isShow = (0, $b0cc7ba789b8a338$export$795910f5f15a9633)(sign, entry.tickCoord, getSize, start, end);
            if (isShow) {
                end = entry.tickCoord - sign * (getSize() / 2 + minTickGap);
                result[i] = $eee5f9677a72ba23$var$_objectSpread($eee5f9677a72ba23$var$_objectSpread({}, entry), {}, {
                    isShow: true
                });
            }
        }
    };
    for(var i = len - 1; i >= 0; i--){
        if (_loop(i)) continue;
    }
    return result;
}
function $eee5f9677a72ba23$var$getTicksStart(sign, boundaries, getTickSize, ticks, minTickGap, preserveEnd) {
    // This method is mutating the array so clone is indeed necessary here
    var result = (ticks || []).slice();
    var len = result.length;
    var { start: start, end: end } = boundaries;
    if (preserveEnd) {
        // Try to guarantee the tail to be displayed
        var tail = ticks[len - 1];
        if (tail != null) {
            var tailSize = getTickSize(tail, len - 1);
            var tailGap = sign * (tail.coordinate + sign * tailSize / 2 - end);
            result[len - 1] = tail = $eee5f9677a72ba23$var$_objectSpread($eee5f9677a72ba23$var$_objectSpread({}, tail), {}, {
                tickCoord: tailGap > 0 ? tail.coordinate - tailGap * sign : tail.coordinate
            });
            if (tail.tickCoord != null) {
                var isTailShow = (0, $b0cc7ba789b8a338$export$795910f5f15a9633)(sign, tail.tickCoord, ()=>tailSize, start, end);
                if (isTailShow) {
                    end = tail.tickCoord - sign * (tailSize / 2 + minTickGap);
                    result[len - 1] = $eee5f9677a72ba23$var$_objectSpread($eee5f9677a72ba23$var$_objectSpread({}, tail), {}, {
                        isShow: true
                    });
                }
            }
        }
    }
    var count = preserveEnd ? len - 1 : len;
    var _loop2 = function _loop2(i) {
        var initialEntry = result[i];
        if (initialEntry == null) return 1; // continue
        var entry = initialEntry;
        var size;
        var getSize = ()=>{
            if (size === undefined) size = getTickSize(initialEntry, i);
            return size;
        };
        if (i === 0) {
            var gap = sign * (entry.coordinate - sign * getSize() / 2 - start);
            result[i] = entry = $eee5f9677a72ba23$var$_objectSpread($eee5f9677a72ba23$var$_objectSpread({}, entry), {}, {
                tickCoord: gap < 0 ? entry.coordinate - gap * sign : entry.coordinate
            });
        } else result[i] = entry = $eee5f9677a72ba23$var$_objectSpread($eee5f9677a72ba23$var$_objectSpread({}, entry), {}, {
            tickCoord: entry.coordinate
        });
        if (entry.tickCoord != null) {
            var isShow = (0, $b0cc7ba789b8a338$export$795910f5f15a9633)(sign, entry.tickCoord, getSize, start, end);
            if (isShow) {
                start = entry.tickCoord + sign * (getSize() / 2 + minTickGap);
                result[i] = $eee5f9677a72ba23$var$_objectSpread($eee5f9677a72ba23$var$_objectSpread({}, entry), {}, {
                    isShow: true
                });
            }
        }
    };
    for(var i = 0; i < count; i++){
        if (_loop2(i)) continue;
    }
    return result;
}
function $eee5f9677a72ba23$export$3d27d42b1034de5c(props, fontSize, letterSpacing) {
    var { tick: tick, ticks: ticks, viewBox: viewBox, minTickGap: minTickGap, orientation: orientation, interval: interval, tickFormatter: tickFormatter, unit: unit, angle: angle } = props;
    if (!ticks || !ticks.length || !tick) return [];
    if ((0, $7e613228d3a31273$export$7e4aa119212bc614)(interval) || (0, $21ceeda12d85451c$export$98f03c5d19621d70).isSsr) {
        var _getNumberIntervalTic;
        return (_getNumberIntervalTic = (0, $b0cc7ba789b8a338$export$beeebbe3ff1b306b)(ticks, (0, $7e613228d3a31273$export$7e4aa119212bc614)(interval) ? interval : 0)) !== null && _getNumberIntervalTic !== void 0 ? _getNumberIntervalTic : [];
    }
    var candidates = [];
    var sizeKey = orientation === 'top' || orientation === 'bottom' ? 'width' : 'height';
    var unitSize = unit && sizeKey === 'width' ? (0, $10a1fdf426ed2330$export$e5560531f057ad5d)(unit, {
        fontSize: fontSize,
        letterSpacing: letterSpacing
    }) : {
        width: 0,
        height: 0
    };
    var getTickSize = (content, index)=>{
        var value = typeof tickFormatter === 'function' ? tickFormatter(content.value, index) : content.value;
        // Recharts only supports angles when sizeKey === 'width'
        return sizeKey === 'width' ? (0, $b0cc7ba789b8a338$export$a1966f4ad955c82b)((0, $10a1fdf426ed2330$export$e5560531f057ad5d)(value, {
            fontSize: fontSize,
            letterSpacing: letterSpacing
        }), unitSize, angle) : (0, $10a1fdf426ed2330$export$e5560531f057ad5d)(value, {
            fontSize: fontSize,
            letterSpacing: letterSpacing
        })[sizeKey];
    };
    var tick0 = ticks[0];
    var tick1 = ticks[1];
    var sign = ticks.length >= 2 && tick0 != null && tick1 != null ? (0, $7e613228d3a31273$export$9d334328eb75e624)(tick1.coordinate - tick0.coordinate) : 1;
    var boundaries = (0, $b0cc7ba789b8a338$export$a257eb8806d5033d)(viewBox, sign, sizeKey);
    if (interval === 'equidistantPreserveStart') return (0, $8bbec28e108d48df$export$77bf2ab5711b7f99)(sign, boundaries, getTickSize, ticks, minTickGap);
    if (interval === 'equidistantPreserveEnd') return (0, $8bbec28e108d48df$export$635ece29a4bbdfac)(sign, boundaries, getTickSize, ticks, minTickGap);
    if (interval === 'preserveStart' || interval === 'preserveStartEnd') candidates = $eee5f9677a72ba23$var$getTicksStart(sign, boundaries, getTickSize, ticks, minTickGap, interval === 'preserveStartEnd');
    else candidates = $eee5f9677a72ba23$var$getTicksEnd(sign, boundaries, getTickSize, ticks, minTickGap);
    return candidates.filter((entry)=>entry.isShow);
}



var $kc00y = parcelRequire("kc00y");









/**
 * Calculates the width of the Y-axis based on the tick labels and the axis label.
 * @param params - The parameters object.
 * @param [params.ticks] - An array-like object of tick elements, each with a `getBoundingClientRect` method.
 * @param [params.label] - The axis label element, with a `getBoundingClientRect` method.
 * @param [params.labelGapWithTick=5] - The gap between the label and the tick.
 * @param [params.tickSize=0] - The length of the tick line.
 * @param [params.tickMargin=0] - The margin between the tick line and the tick text.
 * @returns The calculated width of the Y-axis.
 */ var $48b9d8780ff65997$export$b70f70a4fdbed242 = (_ref)=>{
    var { ticks: ticks, label: label, labelGapWithTick: labelGapWithTick = 5, tickSize: // Default gap between label and tick
    tickSize = 0, tickMargin: tickMargin = 0 } = _ref;
    // find the max width of the tick labels
    var maxTickWidth = 0;
    if (ticks) {
        Array.from(ticks).forEach((tickNode)=>{
            if (tickNode) {
                var bbox = tickNode.getBoundingClientRect();
                if (bbox.width > maxTickWidth) maxTickWidth = bbox.width;
            }
        });
        // calculate width of the axis label
        var labelWidth = label ? label.getBoundingClientRect().width : 0;
        var tickWidth = tickSize + tickMargin;
        // calculate the updated width of the y-axis
        var updatedYAxisWidth = maxTickWidth + tickWidth + labelWidth + (label ? labelGapWithTick : 0);
        return Math.round(updatedYAxisWidth);
    }
    return 0;
};





function $cb92b2c01b9bd3ed$export$154498af6dc3c303(u) {
    if (u && typeof u === 'object' && 'className' in u && typeof u.className === 'string') return u.className;
    return '';
}




var $a8b1d7a6bebb8331$var$_excluded = [
    "axisLine",
    "width",
    "height",
    "className",
    "hide",
    "ticks",
    "axisType",
    "axisId"
];
function $a8b1d7a6bebb8331$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $a8b1d7a6bebb8331$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $a8b1d7a6bebb8331$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $a8b1d7a6bebb8331$var$_extends() {
    return $a8b1d7a6bebb8331$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a8b1d7a6bebb8331$var$_extends.apply(null, arguments);
}
function $a8b1d7a6bebb8331$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a8b1d7a6bebb8331$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a8b1d7a6bebb8331$var$ownKeys(Object(t), !0).forEach(function(r) {
            $a8b1d7a6bebb8331$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a8b1d7a6bebb8331$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $a8b1d7a6bebb8331$var$_defineProperty(e, r, t) {
    return (r = $a8b1d7a6bebb8331$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $a8b1d7a6bebb8331$var$_toPropertyKey(t) {
    var i = $a8b1d7a6bebb8331$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $a8b1d7a6bebb8331$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $a8b1d7a6bebb8331$export$179c35154a9748c0 = {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    viewBox: {
        x: 0,
        y: 0,
        width: 0,
        height: 0
    },
    // The orientation of axis
    orientation: 'bottom',
    // The ticks
    ticks: [],
    stroke: '#666',
    tickLine: true,
    axisLine: true,
    tick: true,
    mirror: false,
    minTickGap: 5,
    // The width or height of tick
    tickSize: 6,
    tickMargin: 2,
    interval: 'preserveEnd',
    zIndex: (0, $2d4105c5b5d94e8f$export$96df16b28aa32702).axis
};
/*
 * `viewBox` and `scale` are SVG attributes.
 * Recharts however - unfortunately - has its own attributes named `viewBox` and `scale`
 * that are completely different data shape and different purpose.
 */ function $a8b1d7a6bebb8331$var$AxisLine(axisLineProps) {
    var { x: x, y: y, width: width, height: height, orientation: orientation, mirror: mirror, axisLine: axisLine, otherSvgProps: otherSvgProps } = axisLineProps;
    if (!axisLine) return null;
    var props = $a8b1d7a6bebb8331$var$_objectSpread($a8b1d7a6bebb8331$var$_objectSpread($a8b1d7a6bebb8331$var$_objectSpread({}, otherSvgProps), (0, $34cf66bbb2aff04f$export$8b56257912140094)(axisLine)), {}, {
        fill: 'none'
    });
    if (orientation === 'top' || orientation === 'bottom') {
        var needHeight = +(orientation === 'top' && !mirror || orientation === 'bottom' && mirror);
        props = $a8b1d7a6bebb8331$var$_objectSpread($a8b1d7a6bebb8331$var$_objectSpread({}, props), {}, {
            x1: x,
            y1: y + needHeight * height,
            x2: x + width,
            y2: y + needHeight * height
        });
    } else {
        var needWidth = +(orientation === 'left' && !mirror || orientation === 'right' && mirror);
        props = $a8b1d7a6bebb8331$var$_objectSpread($a8b1d7a6bebb8331$var$_objectSpread({}, props), {}, {
            x1: x + needWidth * width,
            y1: y,
            x2: x + needWidth * width,
            y2: y + height
        });
    }
    return /*#__PURE__*/ $kc00y.createElement("line", $a8b1d7a6bebb8331$var$_extends({}, props, {
        className: (0, $328c1c2632e2f292$export$4f5d2d50c9deca37)('recharts-cartesian-axis-line', (0, (/*@__PURE__*/$parcel$interopDefault($c09fe069b4c20e1b$exports)))(axisLine, 'className'))
    }));
}
/**
 * Calculate the coordinates of endpoints in ticks.
 * @param data The data of a simple tick.
 * @param x The x-coordinate of the axis.
 * @param y The y-coordinate of the axis.
 * @param width The width of the axis.
 * @param height The height of the axis.
 * @param orientation The orientation of the axis.
 * @param tickSize The length of the tick line.
 * @param mirror If true, the ticks are mirrored.
 * @param tickMargin The margin between the tick line and the tick text.
 * @returns An object with `line` and `tick` coordinates.
 * `line` is the coordinates for the tick line, and `tick` is the coordinate for the tick text.
 */ function $a8b1d7a6bebb8331$var$getTickLineCoord(data, x, y, width, height, orientation, tickSize, mirror, tickMargin) {
    var x1, x2, y1, y2, tx, ty;
    var sign = mirror ? -1 : 1;
    var finalTickSize = data.tickSize || tickSize;
    var tickCoord = (0, $7e613228d3a31273$export$7e4aa119212bc614)(data.tickCoord) ? data.tickCoord : data.coordinate;
    switch(orientation){
        case 'top':
            x1 = x2 = data.coordinate;
            y2 = y + +!mirror * height;
            y1 = y2 - sign * finalTickSize;
            ty = y1 - sign * tickMargin;
            tx = tickCoord;
            break;
        case 'left':
            y1 = y2 = data.coordinate;
            x2 = x + +!mirror * width;
            x1 = x2 - sign * finalTickSize;
            tx = x1 - sign * tickMargin;
            ty = tickCoord;
            break;
        case 'right':
            y1 = y2 = data.coordinate;
            x2 = x + +mirror * width;
            x1 = x2 + sign * finalTickSize;
            tx = x1 + sign * tickMargin;
            ty = tickCoord;
            break;
        default:
            x1 = x2 = data.coordinate;
            y2 = y + +mirror * height;
            y1 = y2 + sign * finalTickSize;
            ty = y1 + sign * tickMargin;
            tx = tickCoord;
            break;
    }
    return {
        line: {
            x1: x1,
            y1: y1,
            x2: x2,
            y2: y2
        },
        tick: {
            x: tx,
            y: ty
        }
    };
}
/**
 * @param orientation The orientation of the axis.
 * @param mirror If true, the ticks are mirrored.
 * @returns The text anchor of the tick.
 */ function $a8b1d7a6bebb8331$var$getTickTextAnchor(orientation, mirror) {
    switch(orientation){
        case 'left':
            return mirror ? 'start' : 'end';
        case 'right':
            return mirror ? 'end' : 'start';
        default:
            return 'middle';
    }
}
/**
 * @param orientation The orientation of the axis.
 * @param mirror If true, the ticks are mirrored.
 * @returns The vertical text anchor of the tick.
 */ function $a8b1d7a6bebb8331$var$getTickVerticalAnchor(orientation, mirror) {
    switch(orientation){
        case 'left':
        case 'right':
            return 'middle';
        case 'top':
            return mirror ? 'start' : 'end';
        default:
            return mirror ? 'end' : 'start';
    }
}
function $a8b1d7a6bebb8331$var$TickItem(props) {
    var { option: option, tickProps: tickProps, value: value } = props;
    var tickItem;
    var combinedClassName = (0, $328c1c2632e2f292$export$4f5d2d50c9deca37)(tickProps.className, 'recharts-cartesian-axis-tick-value');
    if (/*#__PURE__*/ $kc00y.isValidElement(option)) // @ts-expect-error element cloning is not typed
    tickItem = /*#__PURE__*/ $kc00y.cloneElement(option, $a8b1d7a6bebb8331$var$_objectSpread($a8b1d7a6bebb8331$var$_objectSpread({}, tickProps), {}, {
        className: combinedClassName
    }));
    else if (typeof option === 'function') tickItem = option($a8b1d7a6bebb8331$var$_objectSpread($a8b1d7a6bebb8331$var$_objectSpread({}, tickProps), {}, {
        className: combinedClassName
    }));
    else {
        var className = 'recharts-cartesian-axis-tick-value';
        if (typeof option !== 'boolean') className = (0, $328c1c2632e2f292$export$4f5d2d50c9deca37)(className, (0, $cb92b2c01b9bd3ed$export$154498af6dc3c303)(option));
        tickItem = /*#__PURE__*/ $kc00y.createElement((0, $0f46b46b80ac2f75$export$5f1af8db9871e1d6), $a8b1d7a6bebb8331$var$_extends({}, tickProps, {
            className: className
        }), value);
    }
    return tickItem;
}
function $a8b1d7a6bebb8331$var$RenderedTicksReporter(_ref) {
    var { ticks: ticks, axisType: axisType, axisId: axisId } = _ref;
    var dispatch = (0, $a441e801d1b41b52$export$f51d452c10d5b956)();
    (0, $kc00y.useEffect)(()=>{
        if (axisId == null || axisType == null) return 0, $7e613228d3a31273$export$8793edee2d425525;
        // Filter out irrelevant internal properties before exposing externally
        var tickItems = ticks.map((tick)=>({
                value: tick.value,
                coordinate: tick.coordinate,
                offset: tick.offset,
                index: tick.index
            }));
        dispatch((0, $60ba75757d61b083$export$9b96437af9e57ebe)({
            ticks: tickItems,
            axisId: axisId,
            axisType: axisType
        }));
        return ()=>{
            dispatch((0, $60ba75757d61b083$export$d8f6326ec092e260)({
                axisId: axisId,
                axisType: axisType
            }));
        };
    }, [
        dispatch,
        ticks,
        axisId,
        axisType
    ]);
    return null;
}
var $a8b1d7a6bebb8331$var$Ticks = /*#__PURE__*/ (0, $kc00y.forwardRef)((props, ref)=>{
    var { ticks: ticks = [], tick: tick, tickLine: tickLine, stroke: stroke, tickFormatter: tickFormatter, unit: unit, padding: padding, tickTextProps: tickTextProps, orientation: orientation, mirror: mirror, x: x, y: y, width: width, height: height, tickSize: tickSize, tickMargin: tickMargin, fontSize: fontSize, letterSpacing: letterSpacing, getTicksConfig: getTicksConfig, events: events, axisType: axisType, axisId: axisId } = props;
    // @ts-expect-error some properties are optional in props but required in getTicks
    var finalTicks = (0, $eee5f9677a72ba23$export$3d27d42b1034de5c)($a8b1d7a6bebb8331$var$_objectSpread($a8b1d7a6bebb8331$var$_objectSpread({}, getTicksConfig), {}, {
        ticks: ticks
    }), fontSize, letterSpacing);
    var axisProps = (0, $34cf66bbb2aff04f$export$8b56257912140094)(getTicksConfig);
    var customTickProps = (0, $34cf66bbb2aff04f$export$6d5921c09aa671a9)(tick);
    // Use user-provided textAnchor if available, otherwise calculate from orientation/mirror
    var textAnchor = (0, $0f46b46b80ac2f75$export$ae5e6c08954aa63c)(axisProps.textAnchor) ? axisProps.textAnchor : $a8b1d7a6bebb8331$var$getTickTextAnchor(orientation, mirror);
    var verticalAnchor = $a8b1d7a6bebb8331$var$getTickVerticalAnchor(orientation, mirror);
    var tickLinePropsObject = {};
    if (typeof tickLine === 'object') tickLinePropsObject = tickLine;
    var tickLineProps = $a8b1d7a6bebb8331$var$_objectSpread($a8b1d7a6bebb8331$var$_objectSpread({}, axisProps), {}, {
        fill: 'none'
    }, tickLinePropsObject);
    var tickLineCoords = finalTicks.map((entry)=>$a8b1d7a6bebb8331$var$_objectSpread({
            entry: entry
        }, $a8b1d7a6bebb8331$var$getTickLineCoord(entry, x, y, width, height, orientation, tickSize, mirror, tickMargin)));
    var tickLines = tickLineCoords.map((_ref2)=>{
        var { entry: entry, line: lineCoord } = _ref2;
        return /*#__PURE__*/ $kc00y.createElement((0, $553c02c7047f2968$export$936d0764594b6eb3), {
            className: "recharts-cartesian-axis-tick",
            key: "tick-".concat(entry.value, "-").concat(entry.coordinate, "-").concat(entry.tickCoord)
        }, tickLine && /*#__PURE__*/ $kc00y.createElement("line", $a8b1d7a6bebb8331$var$_extends({}, tickLineProps, lineCoord, {
            className: (0, $328c1c2632e2f292$export$4f5d2d50c9deca37)('recharts-cartesian-axis-tick-line', (0, (/*@__PURE__*/$parcel$interopDefault($c09fe069b4c20e1b$exports)))(tickLine, 'className'))
        })));
    });
    var tickLabels = tickLineCoords.map((_ref3, i)=>{
        var _ref4, _tickTextProps$angle;
        var { entry: entry, tick: tickCoord } = _ref3;
        // @ts-expect-error we're not checking that padding and orientation types are in sync
        var tickProps = $a8b1d7a6bebb8331$var$_objectSpread($a8b1d7a6bebb8331$var$_objectSpread($a8b1d7a6bebb8331$var$_objectSpread($a8b1d7a6bebb8331$var$_objectSpread({
            verticalAnchor: verticalAnchor
        }, axisProps), {}, {
            textAnchor: textAnchor,
            stroke: 'none',
            fill: stroke
        }, tickCoord), {}, {
            index: i,
            payload: entry,
            visibleTicksCount: finalTicks.length,
            tickFormatter: tickFormatter,
            padding: padding
        }, tickTextProps), {}, {
            angle: (_ref4 = (_tickTextProps$angle = tickTextProps === null || tickTextProps === void 0 ? void 0 : tickTextProps.angle) !== null && _tickTextProps$angle !== void 0 ? _tickTextProps$angle : axisProps.angle) !== null && _ref4 !== void 0 ? _ref4 : 0
        });
        // @ts-expect-error customTickProps is contributing unknown props which we don't type properly
        var finalTickProps = $a8b1d7a6bebb8331$var$_objectSpread($a8b1d7a6bebb8331$var$_objectSpread({}, tickProps), customTickProps);
        return /*#__PURE__*/ $kc00y.createElement((0, $553c02c7047f2968$export$936d0764594b6eb3), $a8b1d7a6bebb8331$var$_extends({
            className: "recharts-cartesian-axis-tick-label",
            key: "tick-label-".concat(entry.value, "-").concat(entry.coordinate, "-").concat(entry.tickCoord)
        }, (0, $435e27a3bdb96447$export$ca62be0d67a3158c)(events, entry, i)), tick && /*#__PURE__*/ $kc00y.createElement($a8b1d7a6bebb8331$var$TickItem, {
            option: tick,
            tickProps: finalTickProps,
            value: "".concat(typeof tickFormatter === 'function' ? tickFormatter(entry.value, i) : entry.value).concat(unit || '')
        }));
    });
    return /*#__PURE__*/ $kc00y.createElement("g", {
        className: "recharts-cartesian-axis-ticks recharts-".concat(axisType, "-ticks")
    }, /*#__PURE__*/ $kc00y.createElement($a8b1d7a6bebb8331$var$RenderedTicksReporter, {
        ticks: finalTicks,
        axisId: axisId,
        axisType: axisType
    }), tickLabels.length > 0 && /*#__PURE__*/ $kc00y.createElement((0, $a6cde822fe24aa10$export$b37befaf92aba9f1), {
        zIndex: (0, $2d4105c5b5d94e8f$export$96df16b28aa32702).label
    }, /*#__PURE__*/ $kc00y.createElement("g", {
        className: "recharts-cartesian-axis-tick-labels recharts-".concat(axisType, "-tick-labels"),
        ref: ref
    }, tickLabels)), tickLines.length > 0 && /*#__PURE__*/ $kc00y.createElement("g", {
        className: "recharts-cartesian-axis-tick-lines recharts-".concat(axisType, "-tick-lines")
    }, tickLines));
});
var $a8b1d7a6bebb8331$var$CartesianAxisComponent = /*#__PURE__*/ (0, $kc00y.forwardRef)((props, ref)=>{
    var { axisLine: axisLine, width: width, height: height, className: className, hide: hide, ticks: ticks, axisType: axisType, axisId: axisId } = props, rest = $a8b1d7a6bebb8331$var$_objectWithoutProperties(props, $a8b1d7a6bebb8331$var$_excluded);
    var [fontSize, setFontSize] = (0, $kc00y.useState)('');
    var [letterSpacing, setLetterSpacing] = (0, $kc00y.useState)('');
    var tickRefs = (0, $kc00y.useRef)(null);
    (0, $kc00y.useImperativeHandle)(ref, ()=>({
            getCalculatedWidth: ()=>{
                var _props$labelRef;
                return (0, $48b9d8780ff65997$export$b70f70a4fdbed242)({
                    ticks: tickRefs.current,
                    label: (_props$labelRef = props.labelRef) === null || _props$labelRef === void 0 ? void 0 : _props$labelRef.current,
                    labelGapWithTick: 5,
                    tickSize: props.tickSize,
                    tickMargin: props.tickMargin
                });
            }
        }));
    var layerRef = (0, $kc00y.useCallback)((el)=>{
        if (el) {
            var tickNodes = el.getElementsByClassName('recharts-cartesian-axis-tick-value');
            tickRefs.current = tickNodes;
            var tick = tickNodes[0];
            if (tick) {
                var computedStyle = window.getComputedStyle(tick);
                var calculatedFontSize = computedStyle.fontSize;
                var calculatedLetterSpacing = computedStyle.letterSpacing;
                if (calculatedFontSize !== fontSize || calculatedLetterSpacing !== letterSpacing) {
                    setFontSize(calculatedFontSize);
                    setLetterSpacing(calculatedLetterSpacing);
                }
            }
        }
    }, [
        fontSize,
        letterSpacing
    ]);
    if (hide) return null;
    /*
   * This is different condition from what validateWidthHeight is doing;
   * the CartesianAxis does allow width or height to be undefined.
   */ if (width != null && width <= 0 || height != null && height <= 0) return null;
    return /*#__PURE__*/ $kc00y.createElement((0, $a6cde822fe24aa10$export$b37befaf92aba9f1), {
        zIndex: props.zIndex
    }, /*#__PURE__*/ $kc00y.createElement((0, $553c02c7047f2968$export$936d0764594b6eb3), {
        className: (0, $328c1c2632e2f292$export$4f5d2d50c9deca37)('recharts-cartesian-axis', className)
    }, /*#__PURE__*/ $kc00y.createElement($a8b1d7a6bebb8331$var$AxisLine, {
        x: props.x,
        y: props.y,
        width: width,
        height: height,
        orientation: props.orientation,
        mirror: props.mirror,
        axisLine: axisLine,
        otherSvgProps: (0, $34cf66bbb2aff04f$export$8b56257912140094)(props)
    }), /*#__PURE__*/ $kc00y.createElement($a8b1d7a6bebb8331$var$Ticks, {
        ref: layerRef,
        axisType: axisType,
        events: rest,
        fontSize: fontSize,
        getTicksConfig: props,
        height: props.height,
        letterSpacing: letterSpacing,
        mirror: props.mirror,
        orientation: props.orientation,
        padding: props.padding,
        stroke: props.stroke,
        tick: props.tick,
        tickFormatter: props.tickFormatter,
        tickLine: props.tickLine,
        tickMargin: props.tickMargin,
        tickSize: props.tickSize,
        tickTextProps: props.tickTextProps,
        ticks: ticks,
        unit: props.unit,
        width: props.width,
        x: props.x,
        y: props.y,
        axisId: axisId
    }), /*#__PURE__*/ $kc00y.createElement((0, $ef6535e0015ddc73$export$3b4df77eaec10b03), {
        x: props.x,
        y: props.y,
        width: props.width,
        height: props.height,
        lowerWidth: props.width,
        upperWidth: props.width
    }, /*#__PURE__*/ $kc00y.createElement((0, $ef6535e0015ddc73$export$3c82c3a3704539d8), {
        label: props.label,
        labelRef: props.labelRef
    }), props.children)));
});
var $a8b1d7a6bebb8331$export$bdd99f2cdf352bae = /*#__PURE__*/ $kc00y.forwardRef((outsideProps, ref)=>{
    var props = (0, $4cc2299923ef69c7$export$45004cc70a390ee8)(outsideProps, $a8b1d7a6bebb8331$export$179c35154a9748c0);
    return /*#__PURE__*/ $kc00y.createElement($a8b1d7a6bebb8331$var$CartesianAxisComponent, $a8b1d7a6bebb8331$var$_extends({}, props, {
        ref: ref
    }));
});
$a8b1d7a6bebb8331$export$bdd99f2cdf352bae.displayName = 'CartesianAxis';











var $25891dc342f401f2$var$_excluded = [
    "x1",
    "y1",
    "x2",
    "y2",
    "key"
], $25891dc342f401f2$var$_excluded2 = [
    "offset"
], $25891dc342f401f2$var$_excluded3 = [
    "xAxisId",
    "yAxisId"
], $25891dc342f401f2$var$_excluded4 = [
    "xAxisId",
    "yAxisId"
];
function $25891dc342f401f2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $25891dc342f401f2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $25891dc342f401f2$var$ownKeys(Object(t), !0).forEach(function(r) {
            $25891dc342f401f2$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $25891dc342f401f2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $25891dc342f401f2$var$_defineProperty(e, r, t) {
    return (r = $25891dc342f401f2$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $25891dc342f401f2$var$_toPropertyKey(t) {
    var i = $25891dc342f401f2$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $25891dc342f401f2$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $25891dc342f401f2$var$_extends() {
    return $25891dc342f401f2$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $25891dc342f401f2$var$_extends.apply(null, arguments);
}
function $25891dc342f401f2$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $25891dc342f401f2$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $25891dc342f401f2$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
/**
 * The <CartesianGrid horizontal
 */ var $25891dc342f401f2$var$Background = (props)=>{
    var { fill: fill } = props;
    if (!fill || fill === 'none') return null;
    var { fillOpacity: fillOpacity, x: x, y: y, width: width, height: height, ry: ry } = props;
    return /*#__PURE__*/ $kc00y.createElement("rect", {
        x: x,
        y: y,
        ry: ry,
        width: width,
        height: height,
        stroke: "none",
        fill: fill,
        fillOpacity: fillOpacity,
        className: "recharts-cartesian-grid-bg"
    });
};
function $25891dc342f401f2$var$LineItem(_ref) {
    var { option: option, lineItemProps: lineItemProps } = _ref;
    var lineItem;
    if (/*#__PURE__*/ $kc00y.isValidElement(option)) // @ts-expect-error typescript does not see the props type when cloning an element
    lineItem = /*#__PURE__*/ $kc00y.cloneElement(option, lineItemProps);
    else if (typeof option === 'function') lineItem = option(lineItemProps);
    else {
        var _svgPropertiesNoEvent;
        var { x1: x1, y1: y1, x2: x2, y2: y2, key: key } = lineItemProps, others = $25891dc342f401f2$var$_objectWithoutProperties(lineItemProps, $25891dc342f401f2$var$_excluded);
        var _ref2 = (_svgPropertiesNoEvent = (0, $34cf66bbb2aff04f$export$8b56257912140094)(others)) !== null && _svgPropertiesNoEvent !== void 0 ? _svgPropertiesNoEvent : {}, { offset: __ } = _ref2, restOfFilteredProps = $25891dc342f401f2$var$_objectWithoutProperties(_ref2, $25891dc342f401f2$var$_excluded2);
        lineItem = /*#__PURE__*/ $kc00y.createElement("line", $25891dc342f401f2$var$_extends({}, restOfFilteredProps, {
            x1: x1,
            y1: y1,
            x2: x2,
            y2: y2,
            fill: "none",
            key: key
        }));
    }
    return lineItem;
}
function $25891dc342f401f2$var$HorizontalGridLines(props) {
    var { x: x, width: width, horizontal: horizontal = true, horizontalPoints: horizontalPoints } = props;
    if (!horizontal || !horizontalPoints || !horizontalPoints.length) return null;
    var { xAxisId: xAxisId, yAxisId: yAxisId } = props, otherLineItemProps = $25891dc342f401f2$var$_objectWithoutProperties(props, $25891dc342f401f2$var$_excluded3);
    var items = horizontalPoints.map((entry, i)=>{
        var lineItemProps = $25891dc342f401f2$var$_objectSpread($25891dc342f401f2$var$_objectSpread({}, otherLineItemProps), {}, {
            x1: x,
            y1: entry,
            x2: x + width,
            y2: entry,
            key: "line-".concat(i),
            index: i
        });
        return /*#__PURE__*/ $kc00y.createElement($25891dc342f401f2$var$LineItem, {
            key: "line-".concat(i),
            option: horizontal,
            lineItemProps: lineItemProps
        });
    });
    return /*#__PURE__*/ $kc00y.createElement("g", {
        className: "recharts-cartesian-grid-horizontal"
    }, items);
}
function $25891dc342f401f2$var$VerticalGridLines(props) {
    var { y: y, height: height, vertical: vertical = true, verticalPoints: verticalPoints } = props;
    if (!vertical || !verticalPoints || !verticalPoints.length) return null;
    var { xAxisId: xAxisId, yAxisId: yAxisId } = props, otherLineItemProps = $25891dc342f401f2$var$_objectWithoutProperties(props, $25891dc342f401f2$var$_excluded4);
    var items = verticalPoints.map((entry, i)=>{
        var lineItemProps = $25891dc342f401f2$var$_objectSpread($25891dc342f401f2$var$_objectSpread({}, otherLineItemProps), {}, {
            x1: entry,
            y1: y,
            x2: entry,
            y2: y + height,
            key: "line-".concat(i),
            index: i
        });
        return /*#__PURE__*/ $kc00y.createElement($25891dc342f401f2$var$LineItem, {
            option: vertical,
            lineItemProps: lineItemProps,
            key: "line-".concat(i)
        });
    });
    return /*#__PURE__*/ $kc00y.createElement("g", {
        className: "recharts-cartesian-grid-vertical"
    }, items);
}
function $25891dc342f401f2$var$HorizontalStripes(props) {
    var { horizontalFill: horizontalFill, fillOpacity: fillOpacity, x: x, y: y, width: width, height: height, horizontalPoints: horizontalPoints, horizontal: horizontal = true } = props;
    if (!horizontal || !horizontalFill || !horizontalFill.length || horizontalPoints == null) return null;
    var roundedSortedHorizontalPoints = horizontalPoints.map((e)=>Math.round(e + y - y)).sort((a, b)=>a - b);
    // Why is this condition `!==` instead of `<=` ?
    if (y !== roundedSortedHorizontalPoints[0]) roundedSortedHorizontalPoints.unshift(0);
    var items = roundedSortedHorizontalPoints.map((entry, i)=>{
        // Why do we strip only the last stripe if it is invisible, and not all invisible stripes?
        var nextPoint = roundedSortedHorizontalPoints[i + 1];
        var lastStripe = nextPoint == null;
        var lineHeight = lastStripe ? y + height - entry : nextPoint - entry;
        if (lineHeight <= 0) return null;
        var colorIndex = i % horizontalFill.length;
        return /*#__PURE__*/ $kc00y.createElement("rect", {
            key: "react-".concat(i),
            y: entry,
            x: x,
            height: lineHeight,
            width: width,
            stroke: "none",
            fill: horizontalFill[colorIndex],
            fillOpacity: fillOpacity,
            className: "recharts-cartesian-grid-bg"
        });
    });
    return /*#__PURE__*/ $kc00y.createElement("g", {
        className: "recharts-cartesian-gridstripes-horizontal"
    }, items);
}
function $25891dc342f401f2$var$VerticalStripes(props) {
    var { vertical: vertical = true, verticalFill: verticalFill, fillOpacity: fillOpacity, x: x, y: y, width: width, height: height, verticalPoints: verticalPoints } = props;
    if (!vertical || !verticalFill || !verticalFill.length) return null;
    var roundedSortedVerticalPoints = verticalPoints.map((e)=>Math.round(e + x - x)).sort((a, b)=>a - b);
    if (x !== roundedSortedVerticalPoints[0]) roundedSortedVerticalPoints.unshift(0);
    var items = roundedSortedVerticalPoints.map((entry, i)=>{
        var nextPoint = roundedSortedVerticalPoints[i + 1];
        var lastStripe = nextPoint == null;
        var lineWidth = lastStripe ? x + width - entry : nextPoint - entry;
        if (lineWidth <= 0) return null;
        var colorIndex = i % verticalFill.length;
        return /*#__PURE__*/ $kc00y.createElement("rect", {
            key: "react-".concat(i),
            x: entry,
            y: y,
            width: lineWidth,
            height: height,
            stroke: "none",
            fill: verticalFill[colorIndex],
            fillOpacity: fillOpacity,
            className: "recharts-cartesian-grid-bg"
        });
    });
    return /*#__PURE__*/ $kc00y.createElement("g", {
        className: "recharts-cartesian-gridstripes-vertical"
    }, items);
}
var $25891dc342f401f2$var$defaultVerticalCoordinatesGenerator = (_ref3, syncWithTicks)=>{
    var { xAxis: xAxis, width: width, height: height, offset: offset } = _ref3;
    return (0, $d5958b0668c58531$export$846dc5ac5fecff74)((0, $eee5f9677a72ba23$export$3d27d42b1034de5c)($25891dc342f401f2$var$_objectSpread($25891dc342f401f2$var$_objectSpread($25891dc342f401f2$var$_objectSpread({}, (0, $a8b1d7a6bebb8331$export$179c35154a9748c0)), xAxis), {}, {
        ticks: (0, $d5958b0668c58531$export$c829ee42daf7f66d)(xAxis, true),
        viewBox: {
            x: 0,
            y: 0,
            width: width,
            height: height
        }
    })), offset.left, offset.left + offset.width, syncWithTicks);
};
var $25891dc342f401f2$var$defaultHorizontalCoordinatesGenerator = (_ref4, syncWithTicks)=>{
    var { yAxis: yAxis, width: width, height: height, offset: offset } = _ref4;
    return (0, $d5958b0668c58531$export$846dc5ac5fecff74)((0, $eee5f9677a72ba23$export$3d27d42b1034de5c)($25891dc342f401f2$var$_objectSpread($25891dc342f401f2$var$_objectSpread($25891dc342f401f2$var$_objectSpread({}, (0, $a8b1d7a6bebb8331$export$179c35154a9748c0)), yAxis), {}, {
        ticks: (0, $d5958b0668c58531$export$c829ee42daf7f66d)(yAxis, true),
        viewBox: {
            x: 0,
            y: 0,
            width: width,
            height: height
        }
    })), offset.top, offset.top + offset.height, syncWithTicks);
};
var $25891dc342f401f2$export$58f1dfa394f98e54 = {
    horizontal: true,
    vertical: true,
    // The ordinates of horizontal grid lines
    horizontalPoints: [],
    // The abscissas of vertical grid lines
    verticalPoints: [],
    stroke: '#ccc',
    fill: 'none',
    // The fill of colors of grid lines
    verticalFill: [],
    horizontalFill: [],
    xAxisId: 0,
    yAxisId: 0,
    syncWithTicks: false,
    zIndex: (0, $2d4105c5b5d94e8f$export$96df16b28aa32702).grid
};
function $25891dc342f401f2$export$6440e27b9f186856(props) {
    var chartWidth = (0, $f4c9341f05a18477$export$8854f7ece606854b)();
    var chartHeight = (0, $f4c9341f05a18477$export$369ae257969c6f9f)();
    var offset = (0, $f4c9341f05a18477$export$10605f61bef2858a)();
    var propsIncludingDefaults = $25891dc342f401f2$var$_objectSpread($25891dc342f401f2$var$_objectSpread({}, (0, $4cc2299923ef69c7$export$45004cc70a390ee8)(props, $25891dc342f401f2$export$58f1dfa394f98e54)), {}, {
        x: (0, $7e613228d3a31273$export$7e4aa119212bc614)(props.x) ? props.x : offset.left,
        y: (0, $7e613228d3a31273$export$7e4aa119212bc614)(props.y) ? props.y : offset.top,
        width: (0, $7e613228d3a31273$export$7e4aa119212bc614)(props.width) ? props.width : offset.width,
        height: (0, $7e613228d3a31273$export$7e4aa119212bc614)(props.height) ? props.height : offset.height
    });
    var { xAxisId: xAxisId, yAxisId: yAxisId, x: x, y: y, width: width, height: height, syncWithTicks: syncWithTicks, horizontalValues: horizontalValues, verticalValues: verticalValues } = propsIncludingDefaults;
    var isPanorama = (0, $10d1d693b6b228cd$export$4b0c59f8845ba920)();
    var xAxis = (0, $a441e801d1b41b52$export$a7347740d65f620b)((state)=>(0, $223cdb002ac9c48b$export$45cd57660792dd31)(state, 'xAxis', xAxisId, isPanorama));
    var yAxis = (0, $a441e801d1b41b52$export$a7347740d65f620b)((state)=>(0, $223cdb002ac9c48b$export$45cd57660792dd31)(state, 'yAxis', yAxisId, isPanorama));
    if (!(0, $22869ac8a5888437$export$5374bb854d0e41c8)(width) || !(0, $22869ac8a5888437$export$5374bb854d0e41c8)(height) || !(0, $7e613228d3a31273$export$7e4aa119212bc614)(x) || !(0, $7e613228d3a31273$export$7e4aa119212bc614)(y)) return null;
    /*
   * verticalCoordinatesGenerator and horizontalCoordinatesGenerator are defined
   * outside the propsIncludingDefaults because they were never part of the original props
   * and they were never passed as a prop down to horizontal/vertical custom elements.
   * If we add these two to propsIncludingDefaults then we are changing public API.
   * Not a bad thing per se but also not necessary.
   */ var verticalCoordinatesGenerator = propsIncludingDefaults.verticalCoordinatesGenerator || $25891dc342f401f2$var$defaultVerticalCoordinatesGenerator;
    var horizontalCoordinatesGenerator = propsIncludingDefaults.horizontalCoordinatesGenerator || $25891dc342f401f2$var$defaultHorizontalCoordinatesGenerator;
    var { horizontalPoints: horizontalPoints, verticalPoints: verticalPoints } = propsIncludingDefaults;
    // No horizontal points are specified
    if ((!horizontalPoints || !horizontalPoints.length) && typeof horizontalCoordinatesGenerator === 'function') {
        var isHorizontalValues = horizontalValues && horizontalValues.length;
        var generatorResult = horizontalCoordinatesGenerator({
            yAxis: yAxis ? $25891dc342f401f2$var$_objectSpread($25891dc342f401f2$var$_objectSpread({}, yAxis), {}, {
                ticks: isHorizontalValues ? horizontalValues : yAxis.ticks
            }) : undefined,
            width: chartWidth !== null && chartWidth !== void 0 ? chartWidth : width,
            height: chartHeight !== null && chartHeight !== void 0 ? chartHeight : height,
            offset: offset
        }, isHorizontalValues ? true : syncWithTicks);
        (0, $f9eea56c612dc516$export$c106dd0671a0fc2d)(Array.isArray(generatorResult), "horizontalCoordinatesGenerator should return Array but instead it returned [".concat(typeof generatorResult, "]"));
        if (Array.isArray(generatorResult)) horizontalPoints = generatorResult;
    }
    // No vertical points are specified
    if ((!verticalPoints || !verticalPoints.length) && typeof verticalCoordinatesGenerator === 'function') {
        var isVerticalValues = verticalValues && verticalValues.length;
        var _generatorResult = verticalCoordinatesGenerator({
            xAxis: xAxis ? $25891dc342f401f2$var$_objectSpread($25891dc342f401f2$var$_objectSpread({}, xAxis), {}, {
                ticks: isVerticalValues ? verticalValues : xAxis.ticks
            }) : undefined,
            width: chartWidth !== null && chartWidth !== void 0 ? chartWidth : width,
            height: chartHeight !== null && chartHeight !== void 0 ? chartHeight : height,
            offset: offset
        }, isVerticalValues ? true : syncWithTicks);
        (0, $f9eea56c612dc516$export$c106dd0671a0fc2d)(Array.isArray(_generatorResult), "verticalCoordinatesGenerator should return Array but instead it returned [".concat(typeof _generatorResult, "]"));
        if (Array.isArray(_generatorResult)) verticalPoints = _generatorResult;
    }
    return /*#__PURE__*/ $kc00y.createElement((0, $a6cde822fe24aa10$export$b37befaf92aba9f1), {
        zIndex: propsIncludingDefaults.zIndex
    }, /*#__PURE__*/ $kc00y.createElement("g", {
        className: "recharts-cartesian-grid"
    }, /*#__PURE__*/ $kc00y.createElement($25891dc342f401f2$var$Background, {
        fill: propsIncludingDefaults.fill,
        fillOpacity: propsIncludingDefaults.fillOpacity,
        x: propsIncludingDefaults.x,
        y: propsIncludingDefaults.y,
        width: propsIncludingDefaults.width,
        height: propsIncludingDefaults.height,
        ry: propsIncludingDefaults.ry
    }), /*#__PURE__*/ $kc00y.createElement($25891dc342f401f2$var$HorizontalStripes, $25891dc342f401f2$var$_extends({}, propsIncludingDefaults, {
        horizontalPoints: horizontalPoints
    })), /*#__PURE__*/ $kc00y.createElement($25891dc342f401f2$var$VerticalStripes, $25891dc342f401f2$var$_extends({}, propsIncludingDefaults, {
        verticalPoints: verticalPoints
    })), /*#__PURE__*/ $kc00y.createElement($25891dc342f401f2$var$HorizontalGridLines, $25891dc342f401f2$var$_extends({}, propsIncludingDefaults, {
        offset: offset,
        horizontalPoints: horizontalPoints,
        xAxis: xAxis,
        yAxis: yAxis
    })), /*#__PURE__*/ $kc00y.createElement($25891dc342f401f2$var$VerticalGridLines, $25891dc342f401f2$var$_extends({}, propsIncludingDefaults, {
        offset: offset,
        verticalPoints: verticalPoints,
        xAxis: xAxis,
        yAxis: yAxis
    }))));
}
$25891dc342f401f2$export$6440e27b9f186856.displayName = 'CartesianGrid';


var $kc00y = parcelRequire("kc00y");



var $kc00y = parcelRequire("kc00y");





function $c7a3fb98f2194bd5$var$_extends() {
    return $c7a3fb98f2194bd5$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c7a3fb98f2194bd5$var$_extends.apply(null, arguments);
}
function $c7a3fb98f2194bd5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c7a3fb98f2194bd5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c7a3fb98f2194bd5$var$ownKeys(Object(t), !0).forEach(function(r) {
            $c7a3fb98f2194bd5$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c7a3fb98f2194bd5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $c7a3fb98f2194bd5$var$_defineProperty(e, r, t) {
    return (r = $c7a3fb98f2194bd5$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $c7a3fb98f2194bd5$var$_toPropertyKey(t) {
    var i = $c7a3fb98f2194bd5$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $c7a3fb98f2194bd5$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $c7a3fb98f2194bd5$var$SIZE = 32;
var $c7a3fb98f2194bd5$export$5f326afbc3112b7 = {
    align: 'center',
    iconSize: 14,
    inactiveColor: '#ccc',
    layout: 'horizontal',
    verticalAlign: 'middle',
    labelStyle: {}
};
function $c7a3fb98f2194bd5$var$getStrokeDasharray(input) {
    if (typeof input === 'object' && input !== null && 'strokeDasharray' in input) return String(input.strokeDasharray);
    return undefined;
}
function $c7a3fb98f2194bd5$var$Icon(_ref) {
    var { data: data, iconType: iconType, inactiveColor: inactiveColor } = _ref;
    var halfSize = $c7a3fb98f2194bd5$var$SIZE / 2;
    var sixthSize = $c7a3fb98f2194bd5$var$SIZE / 6;
    var thirdSize = $c7a3fb98f2194bd5$var$SIZE / 3;
    var color = data.inactive ? inactiveColor : data.color;
    var preferredIcon = iconType !== null && iconType !== void 0 ? iconType : data.type;
    if (preferredIcon === 'none') return null;
    if (preferredIcon === 'plainline') return /*#__PURE__*/ $kc00y.createElement("line", {
        strokeWidth: 4,
        fill: "none",
        stroke: color,
        strokeDasharray: $c7a3fb98f2194bd5$var$getStrokeDasharray(data.payload),
        x1: 0,
        y1: halfSize,
        x2: $c7a3fb98f2194bd5$var$SIZE,
        y2: halfSize,
        className: "recharts-legend-icon"
    });
    if (preferredIcon === 'line') return /*#__PURE__*/ $kc00y.createElement("path", {
        strokeWidth: 4,
        fill: "none",
        stroke: color,
        d: "M0,".concat(halfSize, "h").concat(thirdSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(2 * thirdSize, ",").concat(halfSize, "\n            H").concat($c7a3fb98f2194bd5$var$SIZE, "M").concat(2 * thirdSize, ",").concat(halfSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(thirdSize, ",").concat(halfSize),
        className: "recharts-legend-icon"
    });
    if (preferredIcon === 'rect') return /*#__PURE__*/ $kc00y.createElement("path", {
        stroke: "none",
        fill: color,
        d: "M0,".concat($c7a3fb98f2194bd5$var$SIZE / 8, "h").concat($c7a3fb98f2194bd5$var$SIZE, "v").concat($c7a3fb98f2194bd5$var$SIZE * 3 / 4, "h").concat(-$c7a3fb98f2194bd5$var$SIZE, "z"),
        className: "recharts-legend-icon"
    });
    if (/*#__PURE__*/ $kc00y.isValidElement(data.legendIcon)) {
        var iconProps = $c7a3fb98f2194bd5$var$_objectSpread({}, data);
        delete iconProps.legendIcon;
        return /*#__PURE__*/ $kc00y.cloneElement(data.legendIcon, iconProps);
    }
    return /*#__PURE__*/ $kc00y.createElement((0, $351bfb356f5de2bf$export$fa456266707bf4e4), {
        fill: color,
        cx: halfSize,
        cy: halfSize,
        size: $c7a3fb98f2194bd5$var$SIZE,
        sizeType: "diameter",
        type: preferredIcon
    });
}
function $c7a3fb98f2194bd5$var$Items(props) {
    var { payload: payload, iconSize: iconSize, layout: layout, formatter: formatter, inactiveColor: inactiveColor, iconType: iconType, labelStyle: labelStyle } = props;
    var viewBox = {
        x: 0,
        y: 0,
        width: $c7a3fb98f2194bd5$var$SIZE,
        height: $c7a3fb98f2194bd5$var$SIZE
    };
    var itemStyle = {
        display: layout === 'horizontal' ? 'inline-block' : 'block',
        marginRight: 10
    };
    var svgStyle = {
        display: 'inline-block',
        verticalAlign: 'middle',
        marginRight: 4
    };
    return payload.map((entry, i)=>{
        var finalFormatter = entry.formatter || formatter;
        var className = (0, $328c1c2632e2f292$export$4f5d2d50c9deca37)({
            'recharts-legend-item': true,
            ["legend-item-".concat(i)]: true,
            inactive: entry.inactive
        });
        if (entry.type === 'none') return null;
        var finalLabelStyle = typeof labelStyle === 'object' ? $c7a3fb98f2194bd5$var$_objectSpread({}, labelStyle) : {};
        finalLabelStyle.color = entry.inactive ? inactiveColor : finalLabelStyle.color || entry.color;
        var finalValue = finalFormatter ? finalFormatter(entry.value, entry, i) : entry.value;
        return /*#__PURE__*/ $kc00y.createElement("li", $c7a3fb98f2194bd5$var$_extends({
            className: className,
            style: itemStyle,
            key: "legend-item-".concat(i)
        }, (0, $435e27a3bdb96447$export$ca62be0d67a3158c)(props, entry, i)), /*#__PURE__*/ $kc00y.createElement((0, $3069fadfb06768fe$export$7b92b459e668cb21), {
            width: iconSize,
            height: iconSize,
            viewBox: viewBox,
            style: svgStyle,
            "aria-label": "".concat(entry.value, " legend icon")
        }, /*#__PURE__*/ $kc00y.createElement($c7a3fb98f2194bd5$var$Icon, {
            data: entry,
            iconType: iconType,
            inactiveColor: inactiveColor
        })), /*#__PURE__*/ $kc00y.createElement("span", {
            className: "recharts-legend-item-text",
            style: finalLabelStyle
        }, finalValue));
    });
}
var $c7a3fb98f2194bd5$export$99f8d96ed0cededa = (outsideProps)=>{
    var props = (0, $4cc2299923ef69c7$export$45004cc70a390ee8)(outsideProps, $c7a3fb98f2194bd5$export$5f326afbc3112b7);
    var { payload: payload, layout: layout, align: align } = props;
    if (!payload || !payload.length) return null;
    var finalStyle = {
        padding: 0,
        margin: 0,
        textAlign: layout === 'horizontal' ? align : 'left'
    };
    return /*#__PURE__*/ $kc00y.createElement("ul", {
        className: "recharts-default-legend",
        style: finalStyle
    }, /*#__PURE__*/ $kc00y.createElement($c7a3fb98f2194bd5$var$Items, $c7a3fb98f2194bd5$var$_extends({}, props, {
        payload: payload
    })));
};


var $383d61fc5f944bab$exports = {};

$383d61fc5f944bab$exports = (parcelRequire("gSMnB")).uniqBy;


function $21fdbfbc5d144563$export$b67e33c2fb1535fa(payload, option, defaultUniqBy) {
    if (option === true) return (0, (/*@__PURE__*/$parcel$interopDefault($383d61fc5f944bab$exports)))(payload, defaultUniqBy);
    if (typeof option === 'function') return (0, (/*@__PURE__*/$parcel$interopDefault($383d61fc5f944bab$exports)))(payload, option);
    return payload;
}




function $c1187e4532757a34$export$5e7711dbef7c() {
    return (0, $a441e801d1b41b52$export$a7347740d65f620b)((0, $3a89fcd13152106d$export$9a6de64b691a7304));
}



var $kc00y = parcelRequire("kc00y");
var $f7cdf13691cf736e$var$EPS = 1;
function $f7cdf13691cf736e$export$35f58fcda6094144() {
    var extraDependencies = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var [lastBoundingBox, setLastBoundingBox] = (0, $kc00y.useState)({
        height: 0,
        left: 0,
        top: 0,
        width: 0
    });
    var updateBoundingBox = (0, $kc00y.useCallback)((node)=>{
        if (node != null) {
            var rect = node.getBoundingClientRect();
            var box = {
                height: rect.height,
                left: rect.left,
                top: rect.top,
                width: rect.width
            };
            if (Math.abs(box.height - lastBoundingBox.height) > $f7cdf13691cf736e$var$EPS || Math.abs(box.left - lastBoundingBox.left) > $f7cdf13691cf736e$var$EPS || Math.abs(box.top - lastBoundingBox.top) > $f7cdf13691cf736e$var$EPS || Math.abs(box.width - lastBoundingBox.width) > $f7cdf13691cf736e$var$EPS) setLastBoundingBox({
                height: box.height,
                left: box.left,
                top: box.top,
                width: box.width
            });
        }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        lastBoundingBox.width,
        lastBoundingBox.height,
        lastBoundingBox.top,
        lastBoundingBox.left,
        ...extraDependencies
    ]);
    return [
        lastBoundingBox,
        updateBoundingBox
    ];
}







var $2865094c59f6e421$var$_excluded = [
    "contextPayload"
];
function $2865094c59f6e421$var$_extends() {
    return $2865094c59f6e421$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $2865094c59f6e421$var$_extends.apply(null, arguments);
}
function $2865094c59f6e421$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2865094c59f6e421$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2865094c59f6e421$var$ownKeys(Object(t), !0).forEach(function(r) {
            $2865094c59f6e421$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2865094c59f6e421$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $2865094c59f6e421$var$_defineProperty(e, r, t) {
    return (r = $2865094c59f6e421$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $2865094c59f6e421$var$_toPropertyKey(t) {
    var i = $2865094c59f6e421$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $2865094c59f6e421$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $2865094c59f6e421$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $2865094c59f6e421$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $2865094c59f6e421$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $2865094c59f6e421$var$defaultUniqBy(entry) {
    return entry.value;
}
function $2865094c59f6e421$var$LegendContent(props) {
    var { contextPayload: contextPayload } = props, otherProps = $2865094c59f6e421$var$_objectWithoutProperties(props, $2865094c59f6e421$var$_excluded);
    var finalPayload = (0, $21fdbfbc5d144563$export$b67e33c2fb1535fa)(contextPayload, props.payloadUniqBy, $2865094c59f6e421$var$defaultUniqBy);
    var contentProps = $2865094c59f6e421$var$_objectSpread($2865094c59f6e421$var$_objectSpread({}, otherProps), {}, {
        payload: finalPayload
    });
    if (/*#__PURE__*/ $kc00y.isValidElement(props.content)) return /*#__PURE__*/ $kc00y.cloneElement(props.content, contentProps);
    if (typeof props.content === 'function') return /*#__PURE__*/ $kc00y.createElement(props.content, contentProps);
    return /*#__PURE__*/ $kc00y.createElement((0, $c7a3fb98f2194bd5$export$99f8d96ed0cededa), contentProps);
}
function $2865094c59f6e421$var$getDefaultPosition(style, props, margin, chartWidth, chartHeight, box) {
    var { layout: layout, align: align, verticalAlign: verticalAlign } = props;
    var hPos, vPos;
    if (!style || (style.left === undefined || style.left === null) && (style.right === undefined || style.right === null)) {
        if (align === 'center' && layout === 'vertical') hPos = {
            left: ((chartWidth || 0) - box.width) / 2
        };
        else hPos = align === 'right' ? {
            right: margin && margin.right || 0
        } : {
            left: margin && margin.left || 0
        };
    }
    if (!style || (style.top === undefined || style.top === null) && (style.bottom === undefined || style.bottom === null)) {
        if (verticalAlign === 'middle') vPos = {
            top: ((chartHeight || 0) - box.height) / 2
        };
        else vPos = verticalAlign === 'bottom' ? {
            bottom: margin && margin.bottom || 0
        } : {
            top: margin && margin.top || 0
        };
    }
    return $2865094c59f6e421$var$_objectSpread($2865094c59f6e421$var$_objectSpread({}, hPos), vPos);
}
function $2865094c59f6e421$var$LegendSettingsDispatcher(props) {
    var dispatch = (0, $a441e801d1b41b52$export$f51d452c10d5b956)();
    (0, $kc00y.useEffect)(()=>{
        dispatch((0, $9cbabae4d819cbf3$export$a1a647a9c0dcc839)(props));
    }, [
        dispatch,
        props
    ]);
    return null;
}
function $2865094c59f6e421$var$LegendSizeDispatcher(props) {
    var dispatch = (0, $a441e801d1b41b52$export$f51d452c10d5b956)();
    (0, $kc00y.useEffect)(()=>{
        dispatch((0, $9cbabae4d819cbf3$export$f9ba9ab9b90c340e)(props));
        return ()=>{
            dispatch((0, $9cbabae4d819cbf3$export$f9ba9ab9b90c340e)({
                width: 0,
                height: 0
            }));
        };
    }, [
        dispatch,
        props
    ]);
    return null;
}
function $2865094c59f6e421$var$getWidthOrHeight(layout, height, width, maxWidth) {
    if (layout === 'vertical' && height != null) return {
        height: height
    };
    if (layout === 'horizontal') return {
        width: width || maxWidth
    };
    return null;
}
var $2865094c59f6e421$export$af43120f4eb40347 = {
    align: 'center',
    iconSize: 14,
    inactiveColor: '#ccc',
    itemSorter: 'value',
    layout: 'horizontal',
    verticalAlign: 'bottom'
};
/**
 * @consumes CartesianChartContext
 * @consumes PolarChartContext
 */ function $2865094c59f6e421$var$LegendImpl(outsideProps) {
    var props = (0, $4cc2299923ef69c7$export$45004cc70a390ee8)(outsideProps, $2865094c59f6e421$export$af43120f4eb40347);
    var contextPayload = (0, $c1187e4532757a34$export$5e7711dbef7c)();
    var legendPortalFromContext = (0, $91084920e544d800$export$36ebc0838785d4af)();
    var margin = (0, $f4c9341f05a18477$export$58ac794108fd8ca)();
    var { width: widthFromProps, height: heightFromProps, wrapperStyle: wrapperStyle, portal: portalFromProps } = props;
    // The contextPayload is not used directly inside the hook, but we need the onBBoxUpdate call
    // when the payload changes, therefore it's here as a dependency.
    var [lastBoundingBox, updateBoundingBox] = (0, $f7cdf13691cf736e$export$35f58fcda6094144)([
        contextPayload
    ]);
    var chartWidth = (0, $f4c9341f05a18477$export$8854f7ece606854b)();
    var chartHeight = (0, $f4c9341f05a18477$export$369ae257969c6f9f)();
    if (chartWidth == null || chartHeight == null) return null;
    var maxWidth = chartWidth - ((margin === null || margin === void 0 ? void 0 : margin.left) || 0) - ((margin === null || margin === void 0 ? void 0 : margin.right) || 0);
    var widthOrHeight = $2865094c59f6e421$var$getWidthOrHeight(props.layout, heightFromProps, widthFromProps, maxWidth);
    // if the user supplies their own portal, only use their defined wrapper styles
    var outerStyle = portalFromProps ? wrapperStyle : $2865094c59f6e421$var$_objectSpread($2865094c59f6e421$var$_objectSpread({
        position: 'absolute',
        width: (widthOrHeight === null || widthOrHeight === void 0 ? void 0 : widthOrHeight.width) || widthFromProps || 'auto',
        height: (widthOrHeight === null || widthOrHeight === void 0 ? void 0 : widthOrHeight.height) || heightFromProps || 'auto'
    }, $2865094c59f6e421$var$getDefaultPosition(wrapperStyle, props, margin, chartWidth, chartHeight, lastBoundingBox)), wrapperStyle);
    var legendPortal = portalFromProps !== null && portalFromProps !== void 0 ? portalFromProps : legendPortalFromContext;
    if (legendPortal == null || contextPayload == null) return null;
    var legendElement = /*#__PURE__*/ $kc00y.createElement("div", {
        className: "recharts-legend-wrapper",
        style: outerStyle,
        ref: updateBoundingBox
    }, /*#__PURE__*/ $kc00y.createElement($2865094c59f6e421$var$LegendSettingsDispatcher, {
        layout: props.layout,
        align: props.align,
        verticalAlign: props.verticalAlign,
        itemSorter: props.itemSorter
    }), !portalFromProps && /*#__PURE__*/ $kc00y.createElement($2865094c59f6e421$var$LegendSizeDispatcher, {
        width: lastBoundingBox.width,
        height: lastBoundingBox.height
    }), /*#__PURE__*/ $kc00y.createElement($2865094c59f6e421$var$LegendContent, $2865094c59f6e421$var$_extends({}, props, widthOrHeight, {
        margin: margin,
        chartWidth: chartWidth,
        chartHeight: chartHeight,
        contextPayload: contextPayload
    })));
    return /*#__PURE__*/ (0, $9018fd8b87cabbb7$exports.createPortal)(legendElement, legendPortal);
}
var $2865094c59f6e421$export$ed247974535929c7 = /*#__PURE__*/ $kc00y.memo($2865094c59f6e421$var$LegendImpl, (0, $13251e7ce0459d7b$export$b8f09df787c278d9));
$2865094c59f6e421$export$ed247974535929c7.displayName = 'Legend';


var $kc00y = parcelRequire("kc00y");


var $kc00y = parcelRequire("kc00y");



function $03e0c2d3251d6167$var$_extends() {
    return $03e0c2d3251d6167$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $03e0c2d3251d6167$var$_extends.apply(null, arguments);
}
function $03e0c2d3251d6167$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $03e0c2d3251d6167$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $03e0c2d3251d6167$var$ownKeys(Object(t), !0).forEach(function(r) {
            $03e0c2d3251d6167$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $03e0c2d3251d6167$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $03e0c2d3251d6167$var$_defineProperty(e, r, t) {
    return (r = $03e0c2d3251d6167$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $03e0c2d3251d6167$var$_toPropertyKey(t) {
    var i = $03e0c2d3251d6167$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $03e0c2d3251d6167$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $03e0c2d3251d6167$var$defaultFormatter(value) {
    return Array.isArray(value) && (0, $7e613228d3a31273$export$402a499e1ea44294)(value[0]) && (0, $7e613228d3a31273$export$402a499e1ea44294)(value[1]) ? value.join(' ~ ') : value;
}
var $03e0c2d3251d6167$export$b002681d77efe9ac = {
    separator: ' : ',
    contentStyle: {
        margin: 0,
        padding: 10,
        backgroundColor: '#fff',
        border: '1px solid #ccc',
        whiteSpace: 'nowrap'
    },
    itemStyle: {
        display: 'block',
        paddingTop: 4,
        paddingBottom: 4,
        color: '#000'
    },
    labelStyle: {},
    accessibilityLayer: false
};
function $03e0c2d3251d6167$var$lodashLikeSortBy(array, itemSorter) {
    if (itemSorter == null) return array;
    // @ts-expect-error sortBy types somehow are returning a number type.
    return (0, (/*@__PURE__*/$parcel$interopDefault($ce976de4b913f215$exports)))(array, itemSorter);
}
var $03e0c2d3251d6167$export$6fe33945eebf9ac8 = (props)=>{
    var { separator: separator = $03e0c2d3251d6167$export$b002681d77efe9ac.separator, contentStyle: contentStyle, itemStyle: itemStyle, labelStyle: labelStyle = $03e0c2d3251d6167$export$b002681d77efe9ac.labelStyle, payload: payload, formatter: formatter, itemSorter: itemSorter, wrapperClassName: wrapperClassName, labelClassName: labelClassName, label: label, labelFormatter: labelFormatter, accessibilityLayer: accessibilityLayer = $03e0c2d3251d6167$export$b002681d77efe9ac.accessibilityLayer } = props;
    var renderContent = ()=>{
        if (payload && payload.length) {
            var listStyle = {
                padding: 0,
                margin: 0
            };
            var sortedPayload = $03e0c2d3251d6167$var$lodashLikeSortBy(payload, itemSorter);
            var items = sortedPayload.map((entry, i)=>{
                if (!entry || entry.type === 'none') return null;
                var finalFormatter = entry.formatter || formatter || $03e0c2d3251d6167$var$defaultFormatter;
                var { value: value, name: name } = entry;
                var finalValue = value;
                var finalName = name;
                if (finalFormatter) {
                    var formatted = finalFormatter(value, name, entry, i, payload);
                    if (Array.isArray(formatted)) [finalValue, finalName] = formatted;
                    else if (formatted != null) finalValue = formatted;
                    else return null;
                }
                var finalItemStyle = $03e0c2d3251d6167$var$_objectSpread($03e0c2d3251d6167$var$_objectSpread({}, $03e0c2d3251d6167$export$b002681d77efe9ac.itemStyle), {}, {
                    color: entry.color || $03e0c2d3251d6167$export$b002681d77efe9ac.itemStyle.color
                }, itemStyle);
                return /*#__PURE__*/ $kc00y.createElement("li", {
                    className: "recharts-tooltip-item",
                    key: "tooltip-item-".concat(i),
                    style: finalItemStyle
                }, (0, $7e613228d3a31273$export$402a499e1ea44294)(finalName) ? /*#__PURE__*/ $kc00y.createElement("span", {
                    className: "recharts-tooltip-item-name"
                }, finalName) : null, (0, $7e613228d3a31273$export$402a499e1ea44294)(finalName) ? /*#__PURE__*/ $kc00y.createElement("span", {
                    className: "recharts-tooltip-item-separator"
                }, separator) : null, /*#__PURE__*/ $kc00y.createElement("span", {
                    className: "recharts-tooltip-item-value"
                }, finalValue), /*#__PURE__*/ $kc00y.createElement("span", {
                    className: "recharts-tooltip-item-unit"
                }, entry.unit || ''));
            });
            return /*#__PURE__*/ $kc00y.createElement("ul", {
                className: "recharts-tooltip-item-list",
                style: listStyle
            }, items);
        }
        return null;
    };
    var finalStyle = $03e0c2d3251d6167$var$_objectSpread($03e0c2d3251d6167$var$_objectSpread({}, $03e0c2d3251d6167$export$b002681d77efe9ac.contentStyle), contentStyle);
    var finalLabelStyle = $03e0c2d3251d6167$var$_objectSpread({
        margin: 0
    }, labelStyle);
    var hasLabel = !(0, $7e613228d3a31273$export$b931b78cbb3caf86)(label);
    var finalLabel = hasLabel ? label : '';
    var wrapperCN = (0, $328c1c2632e2f292$export$4f5d2d50c9deca37)('recharts-default-tooltip', wrapperClassName);
    var labelCN = (0, $328c1c2632e2f292$export$4f5d2d50c9deca37)('recharts-tooltip-label', labelClassName);
    if (hasLabel && labelFormatter && payload !== undefined && payload !== null) finalLabel = labelFormatter(label, payload);
    var accessibilityAttributes = accessibilityLayer ? {
        role: 'status',
        'aria-live': 'assertive'
    } : {};
    return /*#__PURE__*/ $kc00y.createElement("div", $03e0c2d3251d6167$var$_extends({
        className: wrapperCN,
        style: finalStyle
    }, accessibilityAttributes), /*#__PURE__*/ $kc00y.createElement("p", {
        className: labelCN,
        style: finalLabelStyle
    }, /*#__PURE__*/ $kc00y.isValidElement(finalLabel) ? finalLabel : "".concat(finalLabel)), renderContent());
};



var $kc00y = parcelRequire("kc00y");


var $1d22f23f719b542b$var$CSS_CLASS_PREFIX = 'recharts-tooltip-wrapper';
var $1d22f23f719b542b$var$TOOLTIP_HIDDEN = {
    visibility: 'hidden'
};
function $1d22f23f719b542b$export$46aee7ef09f78756(_ref) {
    var { coordinate: coordinate, translateX: translateX, translateY: translateY } = _ref;
    return (0, $328c1c2632e2f292$export$4f5d2d50c9deca37)($1d22f23f719b542b$var$CSS_CLASS_PREFIX, {
        ["".concat($1d22f23f719b542b$var$CSS_CLASS_PREFIX, "-right")]: (0, $7e613228d3a31273$export$7e4aa119212bc614)(translateX) && coordinate && (0, $7e613228d3a31273$export$7e4aa119212bc614)(coordinate.x) && translateX >= coordinate.x,
        ["".concat($1d22f23f719b542b$var$CSS_CLASS_PREFIX, "-left")]: (0, $7e613228d3a31273$export$7e4aa119212bc614)(translateX) && coordinate && (0, $7e613228d3a31273$export$7e4aa119212bc614)(coordinate.x) && translateX < coordinate.x,
        ["".concat($1d22f23f719b542b$var$CSS_CLASS_PREFIX, "-bottom")]: (0, $7e613228d3a31273$export$7e4aa119212bc614)(translateY) && coordinate && (0, $7e613228d3a31273$export$7e4aa119212bc614)(coordinate.y) && translateY >= coordinate.y,
        ["".concat($1d22f23f719b542b$var$CSS_CLASS_PREFIX, "-top")]: (0, $7e613228d3a31273$export$7e4aa119212bc614)(translateY) && coordinate && (0, $7e613228d3a31273$export$7e4aa119212bc614)(coordinate.y) && translateY < coordinate.y
    });
}
function $1d22f23f719b542b$export$4cccba03fe0eccc6(_ref2) {
    var { allowEscapeViewBox: allowEscapeViewBox, coordinate: coordinate, key: key, offset: offset, position: position, reverseDirection: reverseDirection, tooltipDimension: tooltipDimension, viewBox: viewBox, viewBoxDimension: viewBoxDimension } = _ref2;
    if (position && (0, $7e613228d3a31273$export$7e4aa119212bc614)(position[key])) return position[key];
    var negative = coordinate[key] - tooltipDimension - (offset > 0 ? offset : 0);
    var positive = coordinate[key] + offset;
    if (allowEscapeViewBox[key]) return reverseDirection[key] ? negative : positive;
    var viewBoxKey = viewBox[key];
    if (viewBoxKey == null) return 0;
    if (reverseDirection[key]) {
        var _tooltipBoundary = negative;
        var _viewBoxBoundary = viewBoxKey;
        if (_tooltipBoundary < _viewBoxBoundary) return Math.max(positive, viewBoxKey);
        return Math.max(negative, viewBoxKey);
    }
    if (viewBoxDimension == null) return 0;
    var tooltipBoundary = positive + tooltipDimension;
    var viewBoxBoundary = viewBoxKey + viewBoxDimension;
    if (tooltipBoundary > viewBoxBoundary) return Math.max(negative, viewBoxKey);
    return Math.max(positive, viewBoxKey);
}
function $1d22f23f719b542b$export$4fe0982879780f9b(_ref3) {
    var { translateX: translateX, translateY: translateY, useTranslate3d: useTranslate3d } = _ref3;
    return {
        transform: useTranslate3d ? "translate3d(".concat(translateX, "px, ").concat(translateY, "px, 0)") : "translate(".concat(translateX, "px, ").concat(translateY, "px)")
    };
}
function $1d22f23f719b542b$export$25e3b0ae21503056(_ref4) {
    var { allowEscapeViewBox: allowEscapeViewBox, coordinate: coordinate, offsetTop: offsetTop, offsetLeft: offsetLeft, position: position, reverseDirection: reverseDirection, tooltipBox: tooltipBox, useTranslate3d: useTranslate3d, viewBox: viewBox } = _ref4;
    var cssProperties, translateX, translateY;
    if (tooltipBox.height > 0 && tooltipBox.width > 0 && coordinate) {
        translateX = $1d22f23f719b542b$export$4cccba03fe0eccc6({
            allowEscapeViewBox: allowEscapeViewBox,
            coordinate: coordinate,
            key: 'x',
            offset: offsetLeft,
            position: position,
            reverseDirection: reverseDirection,
            tooltipDimension: tooltipBox.width,
            viewBox: viewBox,
            viewBoxDimension: viewBox.width
        });
        translateY = $1d22f23f719b542b$export$4cccba03fe0eccc6({
            allowEscapeViewBox: allowEscapeViewBox,
            coordinate: coordinate,
            key: 'y',
            offset: offsetTop,
            position: position,
            reverseDirection: reverseDirection,
            tooltipDimension: tooltipBox.height,
            viewBox: viewBox,
            viewBoxDimension: viewBox.height
        });
        cssProperties = $1d22f23f719b542b$export$4fe0982879780f9b({
            translateX: translateX,
            translateY: translateY,
            useTranslate3d: useTranslate3d
        });
    } else cssProperties = $1d22f23f719b542b$var$TOOLTIP_HIDDEN;
    return {
        cssProperties: cssProperties,
        cssClasses: $1d22f23f719b542b$export$46aee7ef09f78756({
            translateX: translateX,
            translateY: translateY,
            coordinate: coordinate
        })
    };
}



function $b7f61d1d2dbd392c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b7f61d1d2dbd392c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b7f61d1d2dbd392c$var$ownKeys(Object(t), !0).forEach(function(r) {
            $b7f61d1d2dbd392c$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b7f61d1d2dbd392c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b7f61d1d2dbd392c$var$_defineProperty(e, r, t) {
    return (r = $b7f61d1d2dbd392c$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $b7f61d1d2dbd392c$var$_toPropertyKey(t) {
    var i = $b7f61d1d2dbd392c$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $b7f61d1d2dbd392c$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $b7f61d1d2dbd392c$var$resolveTransitionProperty(args) {
    if (args.prefersReducedMotion && args.isAnimationActive === 'auto') return undefined;
    if (args.isAnimationActive && args.active) return "transform ".concat(args.animationDuration, "ms ").concat(args.animationEasing);
    return undefined;
}
function $b7f61d1d2dbd392c$var$TooltipBoundingBoxImpl(props) {
    var _props$coordinate3, _props$coordinate4, _props$coordinate$x2, _props$coordinate5, _props$coordinate$y2, _props$coordinate6;
    var prefersReducedMotion = (0, $8b3ba1cd1d15cc53$export$c170580b40c8999d)();
    var [state, setState] = $kc00y.useState(()=>({
            dismissed: false,
            dismissedAtCoordinate: {
                x: 0,
                y: 0
            }
        }));
    $kc00y.useEffect(()=>{
        var handleKeyDown = (event)=>{
            if (event.key === 'Escape') {
                var _props$coordinate$x, _props$coordinate, _props$coordinate$y, _props$coordinate2;
                setState({
                    dismissed: true,
                    dismissedAtCoordinate: {
                        x: (_props$coordinate$x = (_props$coordinate = props.coordinate) === null || _props$coordinate === void 0 ? void 0 : _props$coordinate.x) !== null && _props$coordinate$x !== void 0 ? _props$coordinate$x : 0,
                        y: (_props$coordinate$y = (_props$coordinate2 = props.coordinate) === null || _props$coordinate2 === void 0 ? void 0 : _props$coordinate2.y) !== null && _props$coordinate$y !== void 0 ? _props$coordinate$y : 0
                    }
                });
            }
        };
        document.addEventListener('keydown', handleKeyDown);
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        (_props$coordinate3 = props.coordinate) === null || _props$coordinate3 === void 0 ? void 0 : _props$coordinate3.x,
        (_props$coordinate4 = props.coordinate) === null || _props$coordinate4 === void 0 ? void 0 : _props$coordinate4.y
    ]);
    if (state.dismissed && (((_props$coordinate$x2 = (_props$coordinate5 = props.coordinate) === null || _props$coordinate5 === void 0 ? void 0 : _props$coordinate5.x) !== null && _props$coordinate$x2 !== void 0 ? _props$coordinate$x2 : 0) !== state.dismissedAtCoordinate.x || ((_props$coordinate$y2 = (_props$coordinate6 = props.coordinate) === null || _props$coordinate6 === void 0 ? void 0 : _props$coordinate6.y) !== null && _props$coordinate$y2 !== void 0 ? _props$coordinate$y2 : 0) !== state.dismissedAtCoordinate.y)) setState($b7f61d1d2dbd392c$var$_objectSpread($b7f61d1d2dbd392c$var$_objectSpread({}, state), {}, {
        dismissed: false
    }));
    var { cssClasses: cssClasses, cssProperties: cssProperties } = (0, $1d22f23f719b542b$export$25e3b0ae21503056)({
        allowEscapeViewBox: props.allowEscapeViewBox,
        coordinate: props.coordinate,
        offsetLeft: typeof props.offset === 'number' ? props.offset : props.offset.x,
        offsetTop: typeof props.offset === 'number' ? props.offset : props.offset.y,
        position: props.position,
        reverseDirection: props.reverseDirection,
        tooltipBox: {
            height: props.lastBoundingBox.height,
            width: props.lastBoundingBox.width
        },
        useTranslate3d: props.useTranslate3d,
        viewBox: props.viewBox
    });
    var positionStyle = props.hasPortalFromProps ? {} : $b7f61d1d2dbd392c$var$_objectSpread($b7f61d1d2dbd392c$var$_objectSpread({
        transition: $b7f61d1d2dbd392c$var$resolveTransitionProperty({
            prefersReducedMotion: prefersReducedMotion,
            isAnimationActive: props.isAnimationActive,
            active: props.active,
            animationDuration: props.animationDuration,
            animationEasing: props.animationEasing
        })
    }, cssProperties), {}, {
        pointerEvents: 'none',
        position: 'absolute',
        top: 0,
        left: 0
    });
    var outerStyle = $b7f61d1d2dbd392c$var$_objectSpread($b7f61d1d2dbd392c$var$_objectSpread({}, positionStyle), {}, {
        visibility: !state.dismissed && props.active && props.hasPayload ? 'visible' : 'hidden'
    }, props.wrapperStyle);
    return /*#__PURE__*/ $kc00y.createElement("div", {
        // @ts-expect-error typescript library does not recognize xmlns attribute, but it's required for an HTML chunk inside SVG.
        xmlns: "http://www.w3.org/1999/xhtml",
        tabIndex: -1,
        className: cssClasses,
        style: outerStyle,
        ref: props.innerRef
    }, props.children);
}
var $b7f61d1d2dbd392c$export$9e6cee7b86551b9c = /*#__PURE__*/ $kc00y.memo($b7f61d1d2dbd392c$var$TooltipBoundingBoxImpl);







var $kc00y = parcelRequire("kc00y");




var $kc00y = parcelRequire("kc00y");



var $c480cbfa9b17ec09$var$_excluded = [
    "x",
    "y",
    "top",
    "left",
    "width",
    "height",
    "className"
];
function $c480cbfa9b17ec09$var$_extends() {
    return $c480cbfa9b17ec09$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c480cbfa9b17ec09$var$_extends.apply(null, arguments);
}
function $c480cbfa9b17ec09$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c480cbfa9b17ec09$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c480cbfa9b17ec09$var$ownKeys(Object(t), !0).forEach(function(r) {
            $c480cbfa9b17ec09$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c480cbfa9b17ec09$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $c480cbfa9b17ec09$var$_defineProperty(e, r, t) {
    return (r = $c480cbfa9b17ec09$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $c480cbfa9b17ec09$var$_toPropertyKey(t) {
    var i = $c480cbfa9b17ec09$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $c480cbfa9b17ec09$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $c480cbfa9b17ec09$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $c480cbfa9b17ec09$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $c480cbfa9b17ec09$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $c480cbfa9b17ec09$var$getPath = (x, y, width, height, top, left)=>{
    return "M".concat(x, ",").concat(top, "v").concat(height, "M").concat(left, ",").concat(y, "h").concat(width);
};
var $c480cbfa9b17ec09$export$3c877bb842c36952 = (_ref)=>{
    var { x: x = 0, y: y = 0, top: top = 0, left: left = 0, width: width = 0, height: height = 0, className: className } = _ref, rest = $c480cbfa9b17ec09$var$_objectWithoutProperties(_ref, $c480cbfa9b17ec09$var$_excluded);
    var props = $c480cbfa9b17ec09$var$_objectSpread({
        x: x,
        y: y,
        top: top,
        left: left,
        width: width,
        height: height
    }, rest);
    if (!(0, $7e613228d3a31273$export$7e4aa119212bc614)(x) || !(0, $7e613228d3a31273$export$7e4aa119212bc614)(y) || !(0, $7e613228d3a31273$export$7e4aa119212bc614)(width) || !(0, $7e613228d3a31273$export$7e4aa119212bc614)(height) || !(0, $7e613228d3a31273$export$7e4aa119212bc614)(top) || !(0, $7e613228d3a31273$export$7e4aa119212bc614)(left)) return null;
    return /*#__PURE__*/ $kc00y.createElement("path", $c480cbfa9b17ec09$var$_extends({}, (0, $976509d5bd74ee3b$export$67f8fc03e57e2747)(props), {
        className: (0, $328c1c2632e2f292$export$4f5d2d50c9deca37)('recharts-cross', className),
        d: $c480cbfa9b17ec09$var$getPath(x, y, width, height, top, left)
    }));
};


function $6f3b3bfa2921f486$export$f84ec1ecc69a13c9(layout, activeCoordinate, offset, tooltipAxisBandSize) {
    var halfSize = tooltipAxisBandSize / 2;
    return {
        stroke: 'none',
        fill: '#ccc',
        x: layout === 'horizontal' ? activeCoordinate.x - halfSize : offset.left + 0.5,
        y: layout === 'horizontal' ? offset.top + 0.5 : activeCoordinate.y - halfSize,
        width: layout === 'horizontal' ? tooltipAxisBandSize : offset.width - 1,
        height: layout === 'horizontal' ? offset.height - 1 : tooltipAxisBandSize
    };
}




function $a0f5191f71aeb9b5$export$ad661ef85a042a4f(activeCoordinate) {
    var { cx: cx, cy: cy, radius: radius, startAngle: startAngle, endAngle: endAngle } = activeCoordinate;
    var startPoint = (0, $68befda7de8b3621$export$5c9a959bb3fc7749)(cx, cy, radius, startAngle);
    var endPoint = (0, $68befda7de8b3621$export$5c9a959bb3fc7749)(cx, cy, radius, endAngle);
    return {
        points: [
            startPoint,
            endPoint
        ],
        cx: cx,
        cy: cy,
        radius: radius,
        startAngle: startAngle,
        endAngle: endAngle
    };
}






function $309fcad37bea37a4$export$56e1305620ce5745(layout, activeCoordinate, offset) {
    if (layout === 'horizontal') return [
        {
            x: activeCoordinate.x,
            y: offset.top
        },
        {
            x: activeCoordinate.x,
            y: offset.top + offset.height
        }
    ];
    if (layout === 'vertical') return [
        {
            x: offset.left,
            y: activeCoordinate.y
        },
        {
            x: offset.left + offset.width,
            y: activeCoordinate.y
        }
    ];
    if ((0, $435e27a3bdb96447$export$b8cdb4ab1d25db49)(activeCoordinate)) {
        if (layout === 'centric') {
            var { cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius, angle: angle } = activeCoordinate;
            var innerPoint = (0, $68befda7de8b3621$export$5c9a959bb3fc7749)(cx, cy, innerRadius, angle);
            var outerPoint = (0, $68befda7de8b3621$export$5c9a959bb3fc7749)(cx, cy, outerRadius, angle);
            return [
                {
                    x: innerPoint.x,
                    y: innerPoint.y
                },
                {
                    x: outerPoint.x,
                    y: outerPoint.y
                }
            ];
        }
        return (0, $a0f5191f71aeb9b5$export$ad661ef85a042a4f)(activeCoordinate);
    }
    return undefined;
}







function $731f98feed877a5e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $731f98feed877a5e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $731f98feed877a5e$var$ownKeys(Object(t), !0).forEach(function(r) {
            $731f98feed877a5e$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $731f98feed877a5e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $731f98feed877a5e$var$_defineProperty(e, r, t) {
    return (r = $731f98feed877a5e$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $731f98feed877a5e$var$_toPropertyKey(t) {
    var i = $731f98feed877a5e$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $731f98feed877a5e$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $731f98feed877a5e$export$952de9be87065336 = ()=>(0, $a441e801d1b41b52$export$a7347740d65f620b)((0, $223cdb002ac9c48b$export$27d9004292294cd7));
var $731f98feed877a5e$export$fd17f57c33e9d17e = ()=>{
    var tooltipAxis = $731f98feed877a5e$export$952de9be87065336();
    var tooltipTicks = (0, $a441e801d1b41b52$export$a7347740d65f620b)((0, $dbde609d2e66e7f4$export$ffe0e60f8c88c05a));
    var tooltipAxisScale = (0, $a441e801d1b41b52$export$a7347740d65f620b)((0, $dbde609d2e66e7f4$export$cdeccbbdd343ae59));
    if (!tooltipAxis || !tooltipAxisScale) return (0, $d5958b0668c58531$export$212ec45c42fe68a7)(undefined, tooltipTicks);
    return (0, $d5958b0668c58531$export$212ec45c42fe68a7)($731f98feed877a5e$var$_objectSpread($731f98feed877a5e$var$_objectSpread({}, tooltipAxis), {}, {
        scale: tooltipAxisScale
    }), tooltipTicks);
};






function $145600aa10a88490$var$_extends() {
    return $145600aa10a88490$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $145600aa10a88490$var$_extends.apply(null, arguments);
}
function $145600aa10a88490$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $145600aa10a88490$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $145600aa10a88490$var$ownKeys(Object(t), !0).forEach(function(r) {
            $145600aa10a88490$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $145600aa10a88490$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $145600aa10a88490$var$_defineProperty(e, r, t) {
    return (r = $145600aa10a88490$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $145600aa10a88490$var$_toPropertyKey(t) {
    var i = $145600aa10a88490$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $145600aa10a88490$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
/**
 * If set false, no cursor will be drawn when tooltip is active.
 * If set an object, the option is the configuration of cursor.
 * If set a React element, the option is the custom react element of drawing cursor
 */ function $145600aa10a88490$var$RenderCursor(_ref) {
    var { cursor: cursor, cursorComp: cursorComp, cursorProps: cursorProps } = _ref;
    if (/*#__PURE__*/ (0, $kc00y.isValidElement)(cursor)) return /*#__PURE__*/ (0, $kc00y.cloneElement)(cursor, cursorProps);
    return /*#__PURE__*/ (0, $kc00y.createElement)(cursorComp, cursorProps);
}
function $145600aa10a88490$export$3ea3a57cbaeb6b4e(props) {
    var _props$zIndex;
    var { coordinate: coordinate, payload: payload, index: index, offset: offset, tooltipAxisBandSize: tooltipAxisBandSize, layout: layout, cursor: cursor, tooltipEventType: tooltipEventType, chartName: chartName } = props;
    // The cursor is a part of the Tooltip, and it should be shown (by default) when the Tooltip is active.
    var activeCoordinate = coordinate;
    var activePayload = payload;
    var activeTooltipIndex = index;
    if (!cursor || !activeCoordinate || chartName !== 'ScatterChart' && tooltipEventType !== 'axis') return null;
    var restProps, cursorComp, preferredZIndex;
    if (chartName === 'ScatterChart') {
        restProps = activeCoordinate;
        cursorComp = (0, $c480cbfa9b17ec09$export$3c877bb842c36952);
        preferredZIndex = (0, $2d4105c5b5d94e8f$export$96df16b28aa32702).cursorLine;
    } else if (chartName === 'BarChart') {
        restProps = (0, $6f3b3bfa2921f486$export$f84ec1ecc69a13c9)(layout, activeCoordinate, offset, tooltipAxisBandSize);
        cursorComp = (0, $94f5b831b08677d3$export$4617fb02663045ef);
        preferredZIndex = (0, $2d4105c5b5d94e8f$export$96df16b28aa32702).cursorRectangle;
    } else if (layout === 'radial' && (0, $435e27a3bdb96447$export$b8cdb4ab1d25db49)(activeCoordinate)) {
        var { cx: cx, cy: cy, radius: radius, startAngle: startAngle, endAngle: endAngle } = (0, $a0f5191f71aeb9b5$export$ad661ef85a042a4f)(activeCoordinate);
        restProps = {
            cx: cx,
            cy: cy,
            startAngle: startAngle,
            endAngle: endAngle,
            innerRadius: radius,
            outerRadius: radius
        };
        cursorComp = (0, $704464b332847712$export$e98c2c7eb2b14f45);
        preferredZIndex = (0, $2d4105c5b5d94e8f$export$96df16b28aa32702).cursorLine;
    } else {
        restProps = {
            points: (0, $309fcad37bea37a4$export$56e1305620ce5745)(layout, activeCoordinate, offset)
        };
        cursorComp = (0, $75a56cb375d58ce0$export$b0e83c3ef8d2db1);
        preferredZIndex = (0, $2d4105c5b5d94e8f$export$96df16b28aa32702).cursorLine;
    }
    var extraClassName = typeof cursor === 'object' && 'className' in cursor ? cursor.className : undefined;
    var cursorProps = $145600aa10a88490$var$_objectSpread($145600aa10a88490$var$_objectSpread($145600aa10a88490$var$_objectSpread($145600aa10a88490$var$_objectSpread({
        stroke: '#ccc',
        pointerEvents: 'none'
    }, offset), restProps), (0, $34cf66bbb2aff04f$export$6d5921c09aa671a9)(cursor)), {}, {
        payload: activePayload,
        payloadIndex: activeTooltipIndex,
        className: (0, $328c1c2632e2f292$export$4f5d2d50c9deca37)('recharts-tooltip-cursor', extraClassName)
    });
    return /*#__PURE__*/ $kc00y.createElement((0, $a6cde822fe24aa10$export$b37befaf92aba9f1), {
        zIndex: (_props$zIndex = props.zIndex) !== null && _props$zIndex !== void 0 ? _props$zIndex : preferredZIndex
    }, /*#__PURE__*/ $kc00y.createElement($145600aa10a88490$var$RenderCursor, {
        cursor: cursor,
        cursorComp: cursorComp,
        cursorProps: cursorProps
    }));
}
function $145600aa10a88490$export$b6a79797ad180576(props) {
    var tooltipAxisBandSize = (0, $731f98feed877a5e$export$fd17f57c33e9d17e)();
    var offset = (0, $f4c9341f05a18477$export$10605f61bef2858a)();
    var layout = (0, $f4c9341f05a18477$export$970c79ecc7081cc)();
    var chartName = (0, $f310c8c70271e4da$export$ed30b3372172c46c)();
    if (tooltipAxisBandSize == null || offset == null || layout == null || chartName == null) return null;
    return /*#__PURE__*/ $kc00y.createElement($145600aa10a88490$export$3ea3a57cbaeb6b4e, $145600aa10a88490$var$_extends({}, props, {
        offset: offset,
        layout: layout,
        tooltipAxisBandSize: tooltipAxisBandSize,
        chartName: chartName
    }));
}









function $0bd1ee086eb8e81c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0bd1ee086eb8e81c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0bd1ee086eb8e81c$var$ownKeys(Object(t), !0).forEach(function(r) {
            $0bd1ee086eb8e81c$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0bd1ee086eb8e81c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $0bd1ee086eb8e81c$var$_defineProperty(e, r, t) {
    return (r = $0bd1ee086eb8e81c$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $0bd1ee086eb8e81c$var$_toPropertyKey(t) {
    var i = $0bd1ee086eb8e81c$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $0bd1ee086eb8e81c$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $0bd1ee086eb8e81c$var$defaultUniqBy(entry) {
    return entry.dataKey;
}
function $0bd1ee086eb8e81c$var$renderContent(content, props) {
    if (/*#__PURE__*/ $kc00y.isValidElement(content)) return /*#__PURE__*/ $kc00y.cloneElement(content, props);
    if (typeof content === 'function') return /*#__PURE__*/ $kc00y.createElement(content, props);
    return /*#__PURE__*/ $kc00y.createElement((0, $03e0c2d3251d6167$export$6fe33945eebf9ac8), props);
}
var $0bd1ee086eb8e81c$var$emptyPayload = [];
var $0bd1ee086eb8e81c$export$3e858c907a5012de = {
    allowEscapeViewBox: {
        x: false,
        y: false
    },
    animationDuration: 400,
    animationEasing: 'ease',
    axisId: 0,
    contentStyle: {},
    cursor: true,
    filterNull: true,
    includeHidden: false,
    isAnimationActive: 'auto',
    itemSorter: 'name',
    itemStyle: {},
    labelStyle: {},
    offset: 10,
    reverseDirection: {
        x: false,
        y: false
    },
    separator: ' : ',
    trigger: 'hover',
    useTranslate3d: false,
    wrapperStyle: {}
};
function $0bd1ee086eb8e81c$export$28c660c63b792dea(outsideProps) {
    var _useAppSelector, _ref;
    var props = (0, $4cc2299923ef69c7$export$45004cc70a390ee8)(outsideProps, $0bd1ee086eb8e81c$export$3e858c907a5012de);
    var { active: activeFromProps, allowEscapeViewBox: allowEscapeViewBox, animationDuration: animationDuration, animationEasing: animationEasing, content: content, filterNull: filterNull, isAnimationActive: isAnimationActive, offset: offset, payloadUniqBy: payloadUniqBy, position: position, reverseDirection: reverseDirection, useTranslate3d: useTranslate3d, wrapperStyle: wrapperStyle, cursor: cursor, shared: shared, trigger: trigger, defaultIndex: defaultIndex, portal: portalFromProps, axisId: axisId } = props;
    var dispatch = (0, $a441e801d1b41b52$export$f51d452c10d5b956)();
    var defaultIndexAsString = typeof defaultIndex === 'number' ? String(defaultIndex) : defaultIndex;
    (0, $kc00y.useEffect)(()=>{
        dispatch((0, $2bfb679c145bcb6f$export$8d517a53c4528750)({
            shared: shared,
            trigger: trigger,
            axisId: axisId,
            active: activeFromProps,
            defaultIndex: defaultIndexAsString
        }));
    }, [
        dispatch,
        shared,
        trigger,
        axisId,
        activeFromProps,
        defaultIndexAsString
    ]);
    var viewBox = (0, $f4c9341f05a18477$export$76b29bb074e0c45a)();
    var accessibilityLayer = (0, $b254816100b9e8bd$export$276788f18f24cad3)();
    var tooltipEventType = (0, $1e9e9b3c1f2abdf7$export$7ac1fe18a92be318)(shared);
    var { activeIndex: activeIndex, isActive: isActive } = (_useAppSelector = (0, $a441e801d1b41b52$export$a7347740d65f620b)((state)=>(0, $f310c8c70271e4da$export$c8884ed37796034a)(state, tooltipEventType, trigger, defaultIndexAsString))) !== null && _useAppSelector !== void 0 ? _useAppSelector : {};
    var payloadFromRedux = (0, $a441e801d1b41b52$export$a7347740d65f620b)((state)=>(0, $f310c8c70271e4da$export$529676bfdba08611)(state, tooltipEventType, trigger, defaultIndexAsString));
    var labelFromRedux = (0, $a441e801d1b41b52$export$a7347740d65f620b)((state)=>(0, $f310c8c70271e4da$export$400c35cc3b9a0487)(state, tooltipEventType, trigger, defaultIndexAsString));
    var coordinate = (0, $a441e801d1b41b52$export$a7347740d65f620b)((state)=>(0, $f310c8c70271e4da$export$392a0083df9bfd7c)(state, tooltipEventType, trigger, defaultIndexAsString));
    var payload = payloadFromRedux;
    var tooltipPortalFromContext = (0, $58efe4c06d55fa88$export$2842d70d9d62127a)();
    /*
   * The user can set `active=true` on the Tooltip in which case the Tooltip will stay always active,
   * or `active=false` in which case the Tooltip never shows.
   *
   * If the `active` prop is not defined then it will show and hide based on mouse or keyboard activity.
   */ var finalIsActive = (_ref = activeFromProps !== null && activeFromProps !== void 0 ? activeFromProps : isActive) !== null && _ref !== void 0 ? _ref : false;
    var [lastBoundingBox, updateBoundingBox] = (0, $f7cdf13691cf736e$export$35f58fcda6094144)([
        payload,
        finalIsActive
    ]);
    var finalLabel = tooltipEventType === 'axis' ? labelFromRedux : undefined;
    (0, $15ff7f54334e269c$export$21f8394fb189b529)(tooltipEventType, trigger, coordinate, finalLabel, activeIndex, finalIsActive);
    var tooltipPortal = portalFromProps !== null && portalFromProps !== void 0 ? portalFromProps : tooltipPortalFromContext;
    if (tooltipPortal == null || viewBox == null || tooltipEventType == null) return null;
    var finalPayload = payload !== null && payload !== void 0 ? payload : $0bd1ee086eb8e81c$var$emptyPayload;
    if (!finalIsActive) finalPayload = $0bd1ee086eb8e81c$var$emptyPayload;
    if (filterNull && finalPayload.length) finalPayload = (0, $21fdbfbc5d144563$export$b67e33c2fb1535fa)(finalPayload.filter((entry)=>entry.value != null && (entry.hide !== true || props.includeHidden)), payloadUniqBy, $0bd1ee086eb8e81c$var$defaultUniqBy);
    var hasPayload = finalPayload.length > 0;
    var tooltipContentProps = $0bd1ee086eb8e81c$var$_objectSpread($0bd1ee086eb8e81c$var$_objectSpread({}, props), {}, {
        payload: finalPayload,
        label: finalLabel,
        active: finalIsActive,
        activeIndex: activeIndex,
        coordinate: coordinate,
        accessibilityLayer: accessibilityLayer
    });
    var tooltipElement = /*#__PURE__*/ $kc00y.createElement((0, $b7f61d1d2dbd392c$export$9e6cee7b86551b9c), {
        allowEscapeViewBox: allowEscapeViewBox,
        animationDuration: animationDuration,
        animationEasing: animationEasing,
        isAnimationActive: isAnimationActive,
        active: finalIsActive,
        coordinate: coordinate,
        hasPayload: hasPayload,
        offset: offset,
        position: position,
        reverseDirection: reverseDirection,
        useTranslate3d: useTranslate3d,
        viewBox: viewBox,
        wrapperStyle: wrapperStyle,
        lastBoundingBox: lastBoundingBox,
        innerRef: updateBoundingBox,
        hasPortalFromProps: Boolean(portalFromProps)
    }, $0bd1ee086eb8e81c$var$renderContent(content, tooltipContentProps));
    return /*#__PURE__*/ $kc00y.createElement($kc00y.Fragment, null, /*#__PURE__*/ (0, $9018fd8b87cabbb7$exports.createPortal)(tooltipElement, tooltipPortal), finalIsActive && /*#__PURE__*/ $kc00y.createElement((0, $145600aa10a88490$export$b6a79797ad180576), {
        cursor: cursor,
        tooltipEventType: tooltipEventType,
        coordinate: coordinate,
        payload: finalPayload,
        index: activeIndex
    }));
}


var $kc00y = parcelRequire("kc00y");









var $7b023303453eb867$var$_excluded = [
    "domain",
    "range"
], $7b023303453eb867$var$_excluded2 = [
    "domain",
    "range"
];
function $7b023303453eb867$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $7b023303453eb867$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $7b023303453eb867$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $7b023303453eb867$var$shortArraysAreEqual(arr1, arr2) {
    if (arr1 === arr2) return true;
    if (Array.isArray(arr1) && arr1.length === 2 && Array.isArray(arr2) && arr2.length === 2) return arr1[0] === arr2[0] && arr1[1] === arr2[1];
    return false;
}
function $7b023303453eb867$export$a803260e379f3736(prevProps, nextProps) {
    if (prevProps === nextProps) return true;
    var { domain: prevDomain, range: prevRange } = prevProps, prevRest = $7b023303453eb867$var$_objectWithoutProperties(prevProps, $7b023303453eb867$var$_excluded);
    var { domain: nextDomain, range: nextRange } = nextProps, nextRest = $7b023303453eb867$var$_objectWithoutProperties(nextProps, $7b023303453eb867$var$_excluded2);
    if (!$7b023303453eb867$var$shortArraysAreEqual(prevDomain, nextDomain)) return false;
    if (!$7b023303453eb867$var$shortArraysAreEqual(prevRange, nextRange)) return false;
    return (0, $13251e7ce0459d7b$export$b8f09df787c278d9)(prevRest, nextRest);
}




var $f743299137566a63$var$_excluded = [
    "type"
], $f743299137566a63$var$_excluded2 = [
    "dangerouslySetInnerHTML",
    "ticks",
    "scale"
], $f743299137566a63$var$_excluded3 = [
    "id",
    "scale"
];
function $f743299137566a63$var$_extends() {
    return $f743299137566a63$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f743299137566a63$var$_extends.apply(null, arguments);
}
function $f743299137566a63$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f743299137566a63$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f743299137566a63$var$ownKeys(Object(t), !0).forEach(function(r) {
            $f743299137566a63$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f743299137566a63$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $f743299137566a63$var$_defineProperty(e, r, t) {
    return (r = $f743299137566a63$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $f743299137566a63$var$_toPropertyKey(t) {
    var i = $f743299137566a63$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $f743299137566a63$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $f743299137566a63$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $f743299137566a63$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $f743299137566a63$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $f743299137566a63$var$SetXAxisSettings(props) {
    var dispatch = (0, $a441e801d1b41b52$export$f51d452c10d5b956)();
    var prevSettingsRef = (0, $kc00y.useRef)(null);
    var layout = (0, $f4c9341f05a18477$export$c9942bdfc7f2781c)();
    var { type: typeFromProps } = props, restProps = $f743299137566a63$var$_objectWithoutProperties(props, $f743299137566a63$var$_excluded);
    var evaluatedType = (0, $d03caba6cdf30c20$export$c71ab14baba33626)(layout, 'xAxis', typeFromProps);
    var settings = (0, $kc00y.useMemo)(()=>{
        if (evaluatedType == null) return undefined;
        return $f743299137566a63$var$_objectSpread($f743299137566a63$var$_objectSpread({}, restProps), {}, {
            type: evaluatedType
        });
    }, [
        restProps,
        evaluatedType
    ]);
    (0, $kc00y.useLayoutEffect)(()=>{
        if (settings == null) return;
        if (prevSettingsRef.current === null) dispatch((0, $c24339571f507656$export$add6226ad7812fc8)(settings));
        else if (prevSettingsRef.current !== settings) dispatch((0, $c24339571f507656$export$40aac341c282a543)({
            prev: prevSettingsRef.current,
            next: settings
        }));
        prevSettingsRef.current = settings;
    }, [
        settings,
        dispatch
    ]);
    (0, $kc00y.useLayoutEffect)(()=>{
        return ()=>{
            if (prevSettingsRef.current) {
                dispatch((0, $c24339571f507656$export$f408189458c6a79b)(prevSettingsRef.current));
                prevSettingsRef.current = null;
            }
        };
    }, [
        dispatch
    ]);
    return null;
}
var $f743299137566a63$var$XAxisImpl = (props)=>{
    var { xAxisId: xAxisId, className: className } = props;
    var viewBox = (0, $a441e801d1b41b52$export$a7347740d65f620b)((0, $cd6092f0bbb953fd$export$32c8e778bac69ce4));
    var isPanorama = (0, $10d1d693b6b228cd$export$4b0c59f8845ba920)();
    var axisType = 'xAxis';
    var cartesianTickItems = (0, $a441e801d1b41b52$export$a7347740d65f620b)((state)=>(0, $223cdb002ac9c48b$export$f0d85e8287c47657)(state, axisType, xAxisId, isPanorama));
    var axisSize = (0, $a441e801d1b41b52$export$a7347740d65f620b)((state)=>(0, $223cdb002ac9c48b$export$50d4085c87c19b12)(state, xAxisId));
    var position = (0, $a441e801d1b41b52$export$a7347740d65f620b)((state)=>(0, $223cdb002ac9c48b$export$92fdc590d2371053)(state, xAxisId));
    /*
   * Here we select settings from the store and prefer to use them instead of the actual props
   * so that the chart is consistent. If we used the props directly, some components will use axis settings
   * from state and some from props and because there is a render step between these two, they might be showing different things.
   * https://github.com/recharts/recharts/issues/6257
   */ var synchronizedSettings = (0, $a441e801d1b41b52$export$a7347740d65f620b)((state)=>(0, $223cdb002ac9c48b$export$8079b33b4a6a2ac5)(state, xAxisId));
    if (axisSize == null || position == null || synchronizedSettings == null) return null;
    var { dangerouslySetInnerHTML: dangerouslySetInnerHTML, ticks: ticks, scale: del } = props, allOtherProps = $f743299137566a63$var$_objectWithoutProperties(props, $f743299137566a63$var$_excluded2);
    var { id: id, scale: del2 } = synchronizedSettings, restSynchronizedSettings = $f743299137566a63$var$_objectWithoutProperties(synchronizedSettings, $f743299137566a63$var$_excluded3);
    return /*#__PURE__*/ $kc00y.createElement((0, $a8b1d7a6bebb8331$export$bdd99f2cdf352bae), $f743299137566a63$var$_extends({}, allOtherProps, restSynchronizedSettings, {
        x: position.x,
        y: position.y,
        width: axisSize.width,
        height: axisSize.height,
        className: (0, $328c1c2632e2f292$export$4f5d2d50c9deca37)("recharts-".concat(axisType, " ").concat(axisType), className),
        viewBox: viewBox,
        ticks: cartesianTickItems,
        axisType: axisType,
        axisId: xAxisId
    }));
};
var $f743299137566a63$export$bf921d6fd02045a0 = {
    allowDataOverflow: (0, $223cdb002ac9c48b$export$21aec091b6ac8422).allowDataOverflow,
    allowDecimals: (0, $223cdb002ac9c48b$export$21aec091b6ac8422).allowDecimals,
    allowDuplicatedCategory: (0, $223cdb002ac9c48b$export$21aec091b6ac8422).allowDuplicatedCategory,
    angle: (0, $223cdb002ac9c48b$export$21aec091b6ac8422).angle,
    axisLine: (0, $a8b1d7a6bebb8331$export$179c35154a9748c0).axisLine,
    height: (0, $223cdb002ac9c48b$export$21aec091b6ac8422).height,
    hide: false,
    includeHidden: (0, $223cdb002ac9c48b$export$21aec091b6ac8422).includeHidden,
    interval: (0, $223cdb002ac9c48b$export$21aec091b6ac8422).interval,
    label: false,
    minTickGap: (0, $223cdb002ac9c48b$export$21aec091b6ac8422).minTickGap,
    mirror: (0, $223cdb002ac9c48b$export$21aec091b6ac8422).mirror,
    orientation: (0, $223cdb002ac9c48b$export$21aec091b6ac8422).orientation,
    padding: (0, $223cdb002ac9c48b$export$21aec091b6ac8422).padding,
    reversed: (0, $223cdb002ac9c48b$export$21aec091b6ac8422).reversed,
    scale: (0, $223cdb002ac9c48b$export$21aec091b6ac8422).scale,
    tick: (0, $223cdb002ac9c48b$export$21aec091b6ac8422).tick,
    tickCount: (0, $223cdb002ac9c48b$export$21aec091b6ac8422).tickCount,
    tickLine: (0, $a8b1d7a6bebb8331$export$179c35154a9748c0).tickLine,
    tickSize: (0, $a8b1d7a6bebb8331$export$179c35154a9748c0).tickSize,
    type: (0, $223cdb002ac9c48b$export$21aec091b6ac8422).type,
    niceTicks: (0, $223cdb002ac9c48b$export$21aec091b6ac8422).niceTicks,
    xAxisId: 0
};
var $f743299137566a63$var$XAxisSettingsDispatcher = (outsideProps)=>{
    var props = (0, $4cc2299923ef69c7$export$45004cc70a390ee8)(outsideProps, $f743299137566a63$export$bf921d6fd02045a0);
    return /*#__PURE__*/ $kc00y.createElement($kc00y.Fragment, null, /*#__PURE__*/ $kc00y.createElement($f743299137566a63$var$SetXAxisSettings, {
        allowDataOverflow: props.allowDataOverflow,
        allowDecimals: props.allowDecimals,
        allowDuplicatedCategory: props.allowDuplicatedCategory,
        angle: props.angle,
        dataKey: props.dataKey,
        domain: props.domain,
        height: props.height,
        hide: props.hide,
        id: props.xAxisId,
        includeHidden: props.includeHidden,
        interval: props.interval,
        minTickGap: props.minTickGap,
        mirror: props.mirror,
        name: props.name,
        orientation: props.orientation,
        padding: props.padding,
        reversed: props.reversed,
        scale: props.scale,
        tick: props.tick,
        tickCount: props.tickCount,
        tickFormatter: props.tickFormatter,
        ticks: props.ticks,
        type: props.type,
        unit: props.unit,
        niceTicks: props.niceTicks
    }), /*#__PURE__*/ $kc00y.createElement($f743299137566a63$var$XAxisImpl, props));
};
var $f743299137566a63$export$ea77231de273b52d = /*#__PURE__*/ $kc00y.memo($f743299137566a63$var$XAxisSettingsDispatcher, (0, $7b023303453eb867$export$a803260e379f3736));
// @ts-expect-error we need to set the displayName for debugging purposes
$f743299137566a63$export$ea77231de273b52d.displayName = 'XAxis';


var $kc00y = parcelRequire("kc00y");












var $a1266b4e1aea7f0c$var$_excluded = [
    "type"
], $a1266b4e1aea7f0c$var$_excluded2 = [
    "dangerouslySetInnerHTML",
    "ticks",
    "scale"
], $a1266b4e1aea7f0c$var$_excluded3 = [
    "id",
    "scale"
];
function $a1266b4e1aea7f0c$var$_extends() {
    return $a1266b4e1aea7f0c$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a1266b4e1aea7f0c$var$_extends.apply(null, arguments);
}
function $a1266b4e1aea7f0c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a1266b4e1aea7f0c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a1266b4e1aea7f0c$var$ownKeys(Object(t), !0).forEach(function(r) {
            $a1266b4e1aea7f0c$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a1266b4e1aea7f0c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $a1266b4e1aea7f0c$var$_defineProperty(e, r, t) {
    return (r = $a1266b4e1aea7f0c$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $a1266b4e1aea7f0c$var$_toPropertyKey(t) {
    var i = $a1266b4e1aea7f0c$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $a1266b4e1aea7f0c$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $a1266b4e1aea7f0c$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $a1266b4e1aea7f0c$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $a1266b4e1aea7f0c$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $a1266b4e1aea7f0c$var$SetYAxisSettings(props) {
    var dispatch = (0, $a441e801d1b41b52$export$f51d452c10d5b956)();
    var prevSettingsRef = (0, $kc00y.useRef)(null);
    var layout = (0, $f4c9341f05a18477$export$c9942bdfc7f2781c)();
    var { type: typeFromProps } = props, restProps = $a1266b4e1aea7f0c$var$_objectWithoutProperties(props, $a1266b4e1aea7f0c$var$_excluded);
    var evaluatedType = (0, $d03caba6cdf30c20$export$c71ab14baba33626)(layout, 'yAxis', typeFromProps);
    var settings = (0, $kc00y.useMemo)(()=>{
        if (evaluatedType == null) return undefined;
        return $a1266b4e1aea7f0c$var$_objectSpread($a1266b4e1aea7f0c$var$_objectSpread({}, restProps), {}, {
            type: evaluatedType
        });
    }, [
        evaluatedType,
        restProps
    ]);
    (0, $kc00y.useLayoutEffect)(()=>{
        if (settings == null) return;
        if (prevSettingsRef.current === null) dispatch((0, $c24339571f507656$export$4ed10a19d7febea1)(settings));
        else if (prevSettingsRef.current !== settings) dispatch((0, $c24339571f507656$export$58b7fa4a7d4572f6)({
            prev: prevSettingsRef.current,
            next: settings
        }));
        prevSettingsRef.current = settings;
    }, [
        settings,
        dispatch
    ]);
    (0, $kc00y.useLayoutEffect)(()=>{
        return ()=>{
            if (prevSettingsRef.current) {
                dispatch((0, $c24339571f507656$export$79db5e9bd25f14c4)(prevSettingsRef.current));
                prevSettingsRef.current = null;
            }
        };
    }, [
        dispatch
    ]);
    return null;
}
function $a1266b4e1aea7f0c$var$YAxisImpl(props) {
    var { yAxisId: yAxisId, className: className, width: width, label: label } = props;
    var cartesianAxisRef = (0, $kc00y.useRef)(null);
    var labelRef = (0, $kc00y.useRef)(null);
    var viewBox = (0, $a441e801d1b41b52$export$a7347740d65f620b)((0, $cd6092f0bbb953fd$export$32c8e778bac69ce4));
    var isPanorama = (0, $10d1d693b6b228cd$export$4b0c59f8845ba920)();
    var dispatch = (0, $a441e801d1b41b52$export$f51d452c10d5b956)();
    var axisType = 'yAxis';
    var axisSize = (0, $a441e801d1b41b52$export$a7347740d65f620b)((state)=>(0, $223cdb002ac9c48b$export$249bec756af8ac39)(state, yAxisId));
    var position = (0, $a441e801d1b41b52$export$a7347740d65f620b)((state)=>(0, $223cdb002ac9c48b$export$e67a320452ebcaef)(state, yAxisId));
    var cartesianTickItems = (0, $a441e801d1b41b52$export$a7347740d65f620b)((state)=>(0, $223cdb002ac9c48b$export$f0d85e8287c47657)(state, axisType, yAxisId, isPanorama));
    /*
   * Here we select settings from the store and prefer to use them instead of the actual props
   * so that the chart is consistent. If we used the props directly, some components will use axis settings
   * from state and some from props and because there is a render step between these two, they might be showing different things.
   * https://github.com/recharts/recharts/issues/6257
   */ var synchronizedSettings = (0, $a441e801d1b41b52$export$a7347740d65f620b)((state)=>(0, $223cdb002ac9c48b$export$d0970661da76c14c)(state, yAxisId));
    (0, $kc00y.useLayoutEffect)(()=>{
        // No dynamic width calculation is done when width !== 'auto'
        // or when a function/react element is used for label
        if (width !== 'auto' || !axisSize || (0, $ef6535e0015ddc73$export$96a48941c06f377f)(label) || /*#__PURE__*/ (0, $kc00y.isValidElement)(label) || synchronizedSettings == null) return;
        var axisComponent = cartesianAxisRef.current;
        if (!axisComponent) return;
        var updatedYAxisWidth = axisComponent.getCalculatedWidth();
        // if the width has changed, dispatch an action to update the width
        if (Math.round(axisSize.width) !== Math.round(updatedYAxisWidth)) dispatch((0, $c24339571f507656$export$6e42dbbf4e5a5faa)({
            id: yAxisId,
            width: updatedYAxisWidth
        }));
    }, [
        // The dependency on cartesianAxisRef.current is not needed because useLayoutEffect will run after every render.
        // The ref will be populated by then.
        // To re-run this effect when ticks change, we can depend on the ticks array from the store.
        cartesianTickItems,
        axisSize,
        dispatch,
        label,
        yAxisId,
        width,
        synchronizedSettings
    ]);
    if (axisSize == null || position == null || synchronizedSettings == null) return null;
    var { dangerouslySetInnerHTML: dangerouslySetInnerHTML, ticks: ticks, scale: del } = props, allOtherProps = $a1266b4e1aea7f0c$var$_objectWithoutProperties(props, $a1266b4e1aea7f0c$var$_excluded2);
    var { id: id, scale: del2 } = synchronizedSettings, restSynchronizedSettings = $a1266b4e1aea7f0c$var$_objectWithoutProperties(synchronizedSettings, $a1266b4e1aea7f0c$var$_excluded3);
    return /*#__PURE__*/ $kc00y.createElement((0, $a8b1d7a6bebb8331$export$bdd99f2cdf352bae), $a1266b4e1aea7f0c$var$_extends({}, allOtherProps, restSynchronizedSettings, {
        ref: cartesianAxisRef,
        labelRef: labelRef,
        x: position.x,
        y: position.y,
        tickTextProps: width === 'auto' ? {
            width: undefined
        } : {
            width: width
        },
        width: axisSize.width,
        height: axisSize.height,
        className: (0, $328c1c2632e2f292$export$4f5d2d50c9deca37)("recharts-".concat(axisType, " ").concat(axisType), className),
        viewBox: viewBox,
        ticks: cartesianTickItems,
        axisType: axisType,
        axisId: yAxisId
    }));
}
var $a1266b4e1aea7f0c$export$299ffbfed5267dce = {
    allowDataOverflow: (0, $223cdb002ac9c48b$export$397148de2ecdec3c).allowDataOverflow,
    allowDecimals: (0, $223cdb002ac9c48b$export$397148de2ecdec3c).allowDecimals,
    allowDuplicatedCategory: (0, $223cdb002ac9c48b$export$397148de2ecdec3c).allowDuplicatedCategory,
    angle: (0, $223cdb002ac9c48b$export$397148de2ecdec3c).angle,
    axisLine: (0, $a8b1d7a6bebb8331$export$179c35154a9748c0).axisLine,
    hide: false,
    includeHidden: (0, $223cdb002ac9c48b$export$397148de2ecdec3c).includeHidden,
    interval: (0, $223cdb002ac9c48b$export$397148de2ecdec3c).interval,
    label: false,
    minTickGap: (0, $223cdb002ac9c48b$export$397148de2ecdec3c).minTickGap,
    mirror: (0, $223cdb002ac9c48b$export$397148de2ecdec3c).mirror,
    orientation: (0, $223cdb002ac9c48b$export$397148de2ecdec3c).orientation,
    padding: (0, $223cdb002ac9c48b$export$397148de2ecdec3c).padding,
    reversed: (0, $223cdb002ac9c48b$export$397148de2ecdec3c).reversed,
    scale: (0, $223cdb002ac9c48b$export$397148de2ecdec3c).scale,
    tick: (0, $223cdb002ac9c48b$export$397148de2ecdec3c).tick,
    tickCount: (0, $223cdb002ac9c48b$export$397148de2ecdec3c).tickCount,
    tickLine: (0, $a8b1d7a6bebb8331$export$179c35154a9748c0).tickLine,
    tickSize: (0, $a8b1d7a6bebb8331$export$179c35154a9748c0).tickSize,
    type: (0, $223cdb002ac9c48b$export$397148de2ecdec3c).type,
    niceTicks: (0, $223cdb002ac9c48b$export$397148de2ecdec3c).niceTicks,
    width: (0, $223cdb002ac9c48b$export$397148de2ecdec3c).width,
    yAxisId: 0
};
var $a1266b4e1aea7f0c$var$YAxisSettingsDispatcher = (outsideProps)=>{
    var props = (0, $4cc2299923ef69c7$export$45004cc70a390ee8)(outsideProps, $a1266b4e1aea7f0c$export$299ffbfed5267dce);
    return /*#__PURE__*/ $kc00y.createElement($kc00y.Fragment, null, /*#__PURE__*/ $kc00y.createElement($a1266b4e1aea7f0c$var$SetYAxisSettings, {
        interval: props.interval,
        id: props.yAxisId,
        scale: props.scale,
        type: props.type,
        domain: props.domain,
        allowDataOverflow: props.allowDataOverflow,
        dataKey: props.dataKey,
        allowDuplicatedCategory: props.allowDuplicatedCategory,
        allowDecimals: props.allowDecimals,
        tickCount: props.tickCount,
        padding: props.padding,
        includeHidden: props.includeHidden,
        reversed: props.reversed,
        ticks: props.ticks,
        width: props.width,
        orientation: props.orientation,
        mirror: props.mirror,
        hide: props.hide,
        unit: props.unit,
        name: props.name,
        angle: props.angle,
        minTickGap: props.minTickGap,
        tick: props.tick,
        tickFormatter: props.tickFormatter,
        niceTicks: props.niceTicks
    }), /*#__PURE__*/ $kc00y.createElement($a1266b4e1aea7f0c$var$YAxisImpl, props));
};
var $a1266b4e1aea7f0c$export$f96c4024c52de8f4 = /*#__PURE__*/ $kc00y.memo($a1266b4e1aea7f0c$var$YAxisSettingsDispatcher, (0, $7b023303453eb867$export$a803260e379f3736));
// @ts-expect-error we need to set the displayName for debugging purposes
$a1266b4e1aea7f0c$export$f96c4024c52de8f4.displayName = 'YAxis';










var $885a1319eb55a499$var$TYPE_RESUME_ELEMENT = /*#__PURE__*/ function(TYPE_RESUME_ELEMENT) {
    TYPE_RESUME_ELEMENT["ANOMALIES"] = "ANOMALIES";
    TYPE_RESUME_ELEMENT["CARACTERISTIQUES"] = "CARACTERISTIQUES";
    TYPE_RESUME_ELEMENT["CASERNE"] = "CASERNE";
    TYPE_RESUME_ELEMENT["CIS"] = "CIS";
    TYPE_RESUME_ELEMENT["DISPONIBILITE"] = "DISPONIBILITE";
    TYPE_RESUME_ELEMENT["GESTIONNAIRE"] = "GESTIONNAIRE";
    TYPE_RESUME_ELEMENT["LOCALISATION"] = "LOCALISATION";
    TYPE_RESUME_ELEMENT["OBSERVATION"] = "OBSERVATION";
    TYPE_RESUME_ELEMENT["TOURNEE"] = "TOURNEE";
    return TYPE_RESUME_ELEMENT;
}($885a1319eb55a499$var$TYPE_RESUME_ELEMENT || {});
var $885a1319eb55a499$export$2e2bcd8739ae039 = $885a1319eb55a499$var$TYPE_RESUME_ELEMENT;


const $35b7fac87e83d899$var$typeRouteHistoriquePei = [
    {
        id: "HISTORIQUE_OPERATIONS",
        libelle: "Historique des op\xe9rations"
    },
    {
        id: "RAPPORT_PERSO",
        libelle: "Rapport personnalis\xe9"
    }
];
var $35b7fac87e83d899$export$df7474bca285ff54 = /*#__PURE__*/ function(TYPE_ROUTE_HISTORIQUE_PEI) {
    TYPE_ROUTE_HISTORIQUE_PEI["HISTORIQUE_OPERATIONS"] = "HISTORIQUE_OPERATIONS";
    TYPE_ROUTE_HISTORIQUE_PEI["RAPPORT_PERSO"] = "RAPPORT_PERSO";
    return TYPE_ROUTE_HISTORIQUE_PEI;
}({});
var $35b7fac87e83d899$export$2e2bcd8739ae039 = $35b7fac87e83d899$var$typeRouteHistoriquePei;





const $4c401fa322fe4af6$var$FicheResume = ({ peiId: peiId, peiNumeroComplet: peiNumeroComplet, titre: titre = "" })=>{
    const elementFicheResumeState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/fiche-resume/${peiId}`);
    const { user: user } = (0, $e787cde576104469$export$fdc397e486fa83e7)();
    if (!elementFicheResumeState.isResolved) return;
    const mapColonneRow = Object.groupBy(elementFicheResumeState?.data, (item)=>item.colonne);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            titre.trim().length > 0 && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("h1", {
                children: titre
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                        children: Object.entries(mapColonneRow).map(([key, values])=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                className: "mx-0 px-0",
                                children: Array.from(values ?? []).map((e, key)=>{
                                    return (e.type !== (0, $885a1319eb55a499$export$2e2bcd8739ae039).GESTIONNAIRE || e.data.gestionnaireId) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                        className: "mx-0 my-3",
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($4c401fa322fe4af6$var$ElementResume, {
                                            titre: e.titre,
                                            value: e.data,
                                            typeResumeElement: e.type,
                                            user: user
                                        })
                                    }, key);
                                })
                            }, key))
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($4c401fa322fe4af6$var$HistoriqueDebitPression, {
                            pibiId: peiId
                        })
                    }),
                    ((0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).OPERATIONS_DIVERSES_E) || (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).RAPPORT_PERSONNALISE_E)) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($4c401fa322fe4af6$var$VoirHistoriquePei, {
                        peiId: peiId,
                        peiNumeroComplet: peiNumeroComplet,
                        user: user
                    })
                ]
            })
        ]
    });
};
const $4c401fa322fe4af6$var$ElementResume = ({ titre: titre, value: value, typeResumeElement: typeResumeElement, user: user })=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
        className: "mx-0 px-0",
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                className: "h2",
                children: titre
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                    xs: "auto",
                    children: typeResumeElement === (0, $885a1319eb55a499$export$2e2bcd8739ae039).DISPONIBILITE ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($4c401fa322fe4af6$var$ElementResumeDisponibilite, {
                        value: value
                    }) : typeResumeElement === (0, $885a1319eb55a499$export$2e2bcd8739ae039).ANOMALIES ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($4c401fa322fe4af6$var$ElementResumeAnomalie, {
                        value: value
                    }) : typeResumeElement === (0, $885a1319eb55a499$export$2e2bcd8739ae039).GESTIONNAIRE ? value.gestionnaireId != null && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($4c401fa322fe4af6$var$ElementResumeGestionnaire, {
                        value: value,
                        user: user
                    }) : value?.split("\n").map((ligne, key)=>{
                        return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                            children: ligne
                        }, key);
                    })
                })
            })
        ]
    });
};
const $4c401fa322fe4af6$var$ElementResumeDisponibilite = ({ value: value })=>{
    let libelleNonConforme = "";
    const listeParametre = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/parametres?${{
        listeParametreCode: JSON.stringify([
            (0, $ee297f06e8568bf4$export$2e2bcd8739ae039).PEI_LIBELLE_NON_CONFORME
        ])
    }}`);
    if (listeParametre.isResolved) libelleNonConforme = listeParametre?.data?.[(0, $ee297f06e8568bf4$export$2e2bcd8739ae039).PEI_LIBELLE_NON_CONFORME].parametreValeur.toUpperCase();
    return (0, $f808952c311684ce$export$2e2bcd8739ae039)[value.disponibilite] === (0, $f808952c311684ce$export$2e2bcd8739ae039).DISPONIBLE ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("p", {
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("span", {
            className: "text-white bg-success rounded p-2 text-nowrap",
            children: [
                " ",
                "OUI",
                " "
            ]
        })
    }) : (0, $f808952c311684ce$export$2e2bcd8739ae039)[value.disponibilite] === (0, $f808952c311684ce$export$2e2bcd8739ae039).NON_CONFORME ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("p", {
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("span", {
            className: "text-white bg-warning rounded p-2 text-nowrap",
            children: libelleNonConforme
        })
    }) : /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("p", {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("span", {
                    className: "text-white bg-danger rounded p-2 text-nowrap",
                    children: [
                        "NON ",
                        value.hasIndispoTemp ? "- Indisponibilit\xe9 temporaire" : ""
                    ]
                })
            }),
            value.hasIndispoTemp && value.list.length > 0 && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("ul", {
                className: "mt-2 list-disc list-inside text-sm",
                children: value.list.map((indispo, index)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("li", {
                        className: "mb-2",
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("strong", {
                                    children: [
                                        "date d\xe9but : ",
                                        indispo.startDate,
                                        indispo.endDate && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                                                "date fin : ",
                                                indispo.endDate
                                            ]
                                        })
                                    ]
                                })
                            }),
                            indispo.motif && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                                className: "text-red-800 italic mt-1 md:mt-0 md:ml-4",
                                children: [
                                    "motif : ",
                                    indispo.motif
                                ]
                            })
                        ]
                    }, index))
            })
        ]
    });
};
const $4c401fa322fe4af6$var$ElementResumeAnomalie = ({ value: value })=>{
    return value.length > 0 ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            value.map((e, key)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(e.valIndispoTerrestre === 5 && "fw-bold", e.valIndispoHbe === 5 && "text-decoration-underline", e.rendNonConforme && "text-warning fw-bold"),
                    children: e.anomalieLibelle
                }, key)),
            " "
        ]
    }) : "Aucune anomalie pour ce PEI.";
};
const $4c401fa322fe4af6$var$ElementResumeGestionnaire = ({ value: value, user: user })=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                children: [
                    "Gestionnaire : ",
                    value.gestionnaireLibelle
                ]
            }),
            value.siteLibelle && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                children: [
                    "Site : ",
                    value.siteLibelle
                ]
            }),
            ((0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).GEST_SITE_R) || (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_DROITS)) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $43f579690a1c166d$export$2e2bcd8739ae039), {
                pathname: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_CONTACT(value.gestionnaireId, "gestionnaire"),
                variant: "link",
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$8bb46d5eef767d7), {}),
                    " ",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("span", {
                        style: {
                            fontSize: ".85rem"
                        },
                        children: "Voir les contacts"
                    })
                ]
            })
        ]
    });
var $4c401fa322fe4af6$export$2e2bcd8739ae039 = $4c401fa322fe4af6$var$FicheResume;
const $4c401fa322fe4af6$var$HistoriqueDebitPression = ({ pibiId: pibiId })=>{
    const { data: data } = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/pibi/historique/` + pibiId);
    const primary = "#00293E";
    const listeParametre = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/parametres?${{
        listeParametreCode: JSON.stringify([
            (0, $ee297f06e8568bf4$export$2e2bcd8739ae039).VALEUR_HAUTE_MINIMALE_HISTOGRAMME
        ])
    }}`);
    // Trie uniquement pour le chart
    const chartData = data && data.data.length > 0 ? [
        ...data.data
    ].sort((a, b)=>new Date(a.visiteDate).getTime() - new Date(b.visiteDate).getTime()) : [];
    return data && data.data.length !== 0 && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("h4", {
                children: "Historique des mesures"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        xs: 7,
                        className: "mx-auto",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ffea1da660acf881$export$e60a4704009a0009), {
                            width: "100%",
                            aspect: 1.5,
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $67563287da1fa124$export$94aefc399ef206a9), {
                                width: 500,
                                height: 300,
                                data: chartData,
                                responsive: true,
                                margin: {
                                    top: 5,
                                    right: 30,
                                    left: 20,
                                    bottom: 5
                                },
                                children: [
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $25891dc342f401f2$export$6440e27b9f186856), {
                                        strokeDasharray: "3 3"
                                    }),
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $f743299137566a63$export$ea77231de273b52d), {
                                        dataKey: "visiteDate",
                                        tickFormatter: (0, $00c47c7740afd024$export$3ae94a2503e890a1)
                                    }),
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $a1266b4e1aea7f0c$export$f96c4024c52de8f4), {
                                        domain: [
                                            0,
                                            (dataMax)=>Math.max(listeParametre?.data?.[(0, $ee297f06e8568bf4$export$2e2bcd8739ae039).VALEUR_HAUTE_MINIMALE_HISTOGRAMME]?.parametreValeur ?? dataMax, dataMax)
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $0bd1ee086eb8e81c$export$28c660c63b792dea), {}),
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2865094c59f6e421$export$ed247974535929c7), {}),
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec65bf22e0d120c5$export$bbc6c6369b38e3d1), {
                                        name: "D\xe9bit",
                                        dataKey: "debit",
                                        fill: primary,
                                        activeBar: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $94f5b831b08677d3$export$4617fb02663045ef), {
                                            fill: primary,
                                            stroke: "dark"
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        xs: 12,
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $13de46b4dfcc473f$export$2e2bcd8739ae039), {
                            bordered: true,
                            striped: true,
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("th", {
                                                children: "Date de contr\xf4le"
                                            }),
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("th", {
                                                children: "Pression statique (bar)"
                                            }),
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("th", {
                                                children: "Pression dynamique au d\xe9bit nominal (bar)"
                                            }),
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("th", {
                                                children: "D\xe9bit \xe0 1 bar (m\xb3/h)"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("tbody", {
                                    children: data.data.map((e, index)=>{
                                        return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("td", {
                                                    children: (0, $00c47c7740afd024$export$2e2bcd8739ae039)(e.visiteDate)
                                                }),
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("td", {
                                                    children: e.pression
                                                }),
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("td", {
                                                    children: e.pressionDyn
                                                }),
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("td", {
                                                    children: e.debit
                                                })
                                            ]
                                        }, index);
                                    })
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("tfoot", {
                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("td", {
                                                className: "fw-bold",
                                                children: "Moyenne"
                                            }),
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("td", {
                                                children: data.moyennePression
                                            }),
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("td", {
                                                children: data.moyennePressionDyn
                                            }),
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("td", {
                                                children: data.moyenneDebit
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
const $4c401fa322fe4af6$var$VoirHistoriquePei = ({ user: user, peiId: peiId, peiNumeroComplet: peiNumeroComplet })=>{
    const parametreRouteHistorique = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/parametres?${{
        listeParametreCode: JSON.stringify([
            (0, $ee297f06e8568bf4$export$2e2bcd8739ae039).PEI_ROUTE_HISTORIQUE
        ])
    }}`);
    const routeHistorique = parametreRouteHistorique?.data?.[(0, $ee297f06e8568bf4$export$2e2bcd8739ae039).PEI_ROUTE_HISTORIQUE]?.parametreValeur;
    return (routeHistorique === (0, $35b7fac87e83d899$export$df7474bca285ff54).HISTORIQUE_OPERATIONS && (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).OPERATIONS_DIVERSES_E) || routeHistorique === (0, $35b7fac87e83d899$export$df7474bca285ff54).RAPPORT_PERSO && (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).RAPPORT_PERSONNALISE_E)) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
        className: "mt-2",
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("h4", {
                children: "Historique du PEI"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("p", {
                            className: "text-muted",
                            children: "Le bouton ci-dessous vous permet de consulter l'historique complet des op\xe9rations effectu\xe9es sur ce Point d'Eau Incendie (PEI). Cette section vous donne acc\xe8s \xe0 :"
                        }),
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("ul", {
                            className: "text-muted",
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("li", {
                                    children: "L'ensemble des modifications apport\xe9es au PEI au fil du temps"
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("li", {
                                    children: "Les informations sur les auteurs de chaque changement"
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("li", {
                                    children: "Les dates pr\xe9cises de chaque intervention"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                    className: "text-center mt-2",
                    children: routeHistorique === (0, $35b7fac87e83d899$export$df7474bca285ff54).HISTORIQUE_OPERATIONS ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($4c401fa322fe4af6$var$HistoriqueOperationsPei, {
                        peiId: peiId
                    }) : /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($4c401fa322fe4af6$var$RapportPersonnaliseHistoriquePei, {
                        peiNumeroComplet: peiNumeroComplet
                    })
                })
            })
        ]
    });
};
const $4c401fa322fe4af6$var$RapportPersonnaliseHistoriquePei = ({ peiNumeroComplet: peiNumeroComplet })=>{
    const rapportHistoriqueState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/rapport-personnalise/get-id-rapport-historique-pei`);
    const rapportPersonnaliseId = rapportHistoriqueState?.data;
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $43f579690a1c166d$export$2e2bcd8739ae039), {
        pathname: `/rapport-personnalise/execute`,
        state: {
            rapportPersonnaliseId: rapportPersonnaliseId,
            peiNumeroComplet: peiNumeroComplet
        },
        variant: "primary",
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$16fcff7afd79949), {}),
            " Voir l'historique personnalis\xe9 du PEI"
        ]
    });
};
const $4c401fa322fe4af6$var$HistoriqueOperationsPei = ({ peiId: peiId })=>{
    const searchParams = new URLSearchParams({
        typeObjet: "PEI",
        objetId: peiId
    });
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $43f579690a1c166d$export$2e2bcd8739ae039), {
        pathname: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).HISTORIQUE_OPERATIONS,
        search: searchParams.toString(),
        variant: "primary",
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$16fcff7afd79949), {}),
            " Voir l'historique des op\xe9rations sur ce PEI"
        ]
    });
};



function $e16185eb091c73b9$var$getStringListeAnomalie(listeAnomaliesPresent, listeAnomaliePossible) {
    if (listeAnomaliePossible === undefined) return;
    return listeAnomaliePossible?.filter((ano)=>listeAnomaliesPresent?.includes(ano.id)).map((e)=>e.libelle).join(", ");
}
var $e16185eb091c73b9$export$2e2bcd8739ae039 = $e16185eb091c73b9$var$getStringListeAnomalie;




/**
 * Composant filtre pour la disponibilité des PEI
 * Gère la logique spécifique de "Indisponible temporairement" qui met à jour 2 champs
 */ const $491b746883a2d098$var$DisponibiliteTerrrestreFilter = ({ onChange: onChange, value: value, libelleNonConforme: libelleNonConforme, ...otherProps })=>{
    const defaultValue = {
        id: undefined,
        code: undefined,
        libelle: "Tous"
    };
    const listIdCodeLibelle = [
        {
            id: (0, $f808952c311684ce$export$2e2bcd8739ae039).DISPONIBLE,
            code: (0, $f808952c311684ce$export$2e2bcd8739ae039).DISPONIBLE,
            libelle: "Disponible"
        },
        {
            id: (0, $f808952c311684ce$export$2e2bcd8739ae039).INDISPONIBLE,
            code: (0, $f808952c311684ce$export$2e2bcd8739ae039).INDISPONIBLE,
            libelle: "Indisponible"
        },
        {
            id: "INDISPONIBLE_TEMPORAIRE",
            code: "INDISPONIBLE_TEMPORAIRE",
            libelle: "Indisponible temporairement"
        },
        {
            id: (0, $f808952c311684ce$export$2e2bcd8739ae039).NON_CONFORME,
            code: (0, $f808952c311684ce$export$2e2bcd8739ae039).NON_CONFORME,
            libelle: libelleNonConforme
        }
    ];
    const data = [
        defaultValue
    ].concat((listIdCodeLibelle || []).map((item)=>({
            id: item.id,
            code: item.code ?? item.id,
            libelle: item.libelle
        })));
    const selectedOption = data.find((option)=>option.id === value) ?? defaultValue;
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ac15ab874ad2390c$export$2e2bcd8739ae039), {
        ...otherProps,
        placeholder: "S\xe9lectionnez",
        noOptionsMessage: ()=>"Aucune donn\xe9e trouv\xe9e",
        name: "peiDisponibiliteTerrestre",
        options: data,
        value: selectedOption,
        getOptionValue: (t)=>t.id ?? "",
        getOptionLabel: (t)=>t.libelle,
        onChange: (selected)=>{
            if (selected?.id === "INDISPONIBLE_TEMPORAIRE") {
                onChange({
                    name: "peiDisponibiliteTerrestre",
                    value: "INDISPONIBLE_TEMPORAIRE"
                });
                onChange({
                    name: "hasIndispoTemp",
                    value: true
                });
            } else {
                onChange({
                    name: "peiDisponibiliteTerrestre",
                    value: selected?.id
                });
                onChange({
                    name: "hasIndispoTemp",
                    value: false
                });
            }
        }
    });
};
/**
 * Composant filtre pour les tournées des PEI
 */ const $491b746883a2d098$var$TourneeFilter = ({ onChange: onChange, value: value, ...otherProps })=>{
    const defaultValue = {
        id: undefined,
        code: undefined,
        libelle: "Tous"
    };
    const nativeOptions = [
        defaultValue
    ].concat({
        id: (0, $f740b0d032822ba6$export$b0c557648079337a),
        code: (0, $f740b0d032822ba6$export$b0c557648079337a),
        libelle: "Aucune tourn\xe9e"
    });
    const { isResolved: isResolvedListData, data: listData } = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/tournee/get-libelle-tournee`);
    const options = nativeOptions.concat((listData || []).map((item)=>({
            id: item.id,
            code: item.id,
            libelle: item.libelle
        })));
    const selectedOption = options.find((option)=>option.id === value) ?? defaultValue;
    if (!isResolvedListData) return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $c21b1c237cfa1d94$export$2e2bcd8739ae039), {});
    else return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ac15ab874ad2390c$export$2e2bcd8739ae039), {
        ...otherProps,
        placeholder: "S\xe9lectionnez",
        noOptionsMessage: ()=>"Aucune donn\xe9e trouv\xe9e",
        name: "tourneeId",
        options: options,
        value: selectedOption,
        getOptionValue: (t)=>t.id ?? "",
        getOptionLabel: (t)=>t.libelle,
        onChange: (selected)=>{
            if (selected?.id === (0, $f740b0d032822ba6$export$b0c557648079337a)) {
                onChange({
                    name: "tourneeId",
                    value: (0, $f740b0d032822ba6$export$b0c557648079337a)
                });
                onChange({
                    name: "hasNoTournee",
                    value: true
                });
            } else {
                onChange({
                    name: "tourneeId",
                    value: selected?.id
                });
                onChange({
                    name: "hasNoTournee",
                    value: false
                });
            }
        }
    });
};
function $491b746883a2d098$var$getColumnPeiByStringArray(handleLeverIndispoTemp, user, parametres, listeAnomaliePossible, fetchGeometry, displayFicheResumeStandalone = false, delaisWarnCTP, delaisUrgentCTP, delaisWarnRECO, delaisUrgentRECO, libelleNonConforme) {
    const column = [];
    const [pagination] = (0, $6ba5340bec609b1f$export$f9468bb008747ceb)();
    parametres.forEach((_parametre)=>{
        switch(_parametre){
            case (0, $c22d20d038ee5de2$export$2e2bcd8739ae039).NUMERO_COMPLET:
                column.push({
                    Header: "Num\xe9ro",
                    accessor: "peiNumeroComplet",
                    sortField: "peiNumeroComplet",
                    Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                        type: "text",
                        name: "peiNumeroComplet"
                    }),
                    width: 125
                });
                break;
            case (0, $c22d20d038ee5de2$export$2e2bcd8739ae039).NUMERO_INTERNE:
                column.push({
                    Header: "N\xb0 interne",
                    accessor: "peiNumeroInterne",
                    sortField: "peiNumeroInterne",
                    Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                        type: "number",
                        name: "peiNumeroInterne"
                    }),
                    width: 125
                });
                break;
            case (0, $c22d20d038ee5de2$export$2e2bcd8739ae039).TYPE_PEI:
                column.push({
                    Header: "Type",
                    accessor: "peiTypePei",
                    sortField: "peiTypePei",
                    Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eed37ff3d3e1f28c$export$2e2bcd8739ae039), {
                        options: (0, $f31f748b1c9fd0fb$export$2e2bcd8739ae039),
                        name: "typePei"
                    })
                });
                break;
            case (0, $c22d20d038ee5de2$export$2e2bcd8739ae039).DISPONIBILITE_TERRESTRE:
                column.push({
                    Header: "Disponibilit\xe9",
                    accessor: (row)=>({
                            peiDisponibiliteTerrestre: row.peiDisponibiliteTerrestre,
                            hasIndispoTemp: row.hasIndispoTemp
                        }),
                    sortField: "peiDisponibiliteTerrestre",
                    Cell: (value)=>{
                        const dispo = (0, $f808952c311684ce$export$2e2bcd8739ae039)[value.value.peiDisponibiliteTerrestre] === (0, $f808952c311684ce$export$2e2bcd8739ae039).NON_CONFORME ? {
                            bg: "bg-warning",
                            value: libelleNonConforme
                        } : (0, $f808952c311684ce$export$2e2bcd8739ae039)[value.value.peiDisponibiliteTerrestre] === (0, $f808952c311684ce$export$2e2bcd8739ae039).DISPONIBLE ? {
                            bg: "",
                            value: "Disponible"
                        } : value.value.hasIndispoTemp ? {
                            bg: "bg-danger bg-hachure",
                            value: "Indisponible temporairement"
                        } : {
                            bg: "bg-danger",
                            value: "Indisponible"
                        };
                        return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(dispo.bg, "p-1", "rounded"),
                            children: dispo.value
                        });
                    },
                    Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($491b746883a2d098$var$DisponibiliteTerrrestreFilter, {
                        libelleNonConforme: libelleNonConforme,
                        name: "peiDisponibiliteTerrestre"
                    })
                });
                break;
            case (0, $c22d20d038ee5de2$export$2e2bcd8739ae039).DISPONIBILITE_HBE:
                column.push({
                    Header: "Disponibilit\xe9 HBE",
                    accessor: "penaDisponibiliteHbe",
                    sortField: "penaDisponibiliteHbe",
                    Cell: (value)=>{
                        const dispo = (0, $f808952c311684ce$export$2e2bcd8739ae039)[value.value] === (0, $f808952c311684ce$export$2e2bcd8739ae039).NON_CONFORME ? {
                            bg: "bg-warning",
                            value: libelleNonConforme
                        } : (0, $f808952c311684ce$export$2e2bcd8739ae039)[value.value] === (0, $f808952c311684ce$export$2e2bcd8739ae039).INDISPONIBLE ? {
                            bg: "bg-danger",
                            value: "Indispo"
                        } : {
                            bg: "",
                            value: "Dispo"
                        };
                        return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                            className: dispo.bg,
                            children: dispo.value
                        });
                    },
                    Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $07ae31d99fcf5a0d$export$2e2bcd8739ae039), {
                        listIdCodeLibelle: (0, $f808952c311684ce$export$b068bae00425e27d)(libelleNonConforme),
                        name: "penaDisponibiliteHbe"
                    })
                });
                break;
            case (0, $c22d20d038ee5de2$export$2e2bcd8739ae039).NATURE:
                column.push({
                    Header: "Nature",
                    accessor: "natureLibelle",
                    sortField: "natureLibelle",
                    Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $bcc3791b22f76942$export$2e2bcd8739ae039), {
                        name: "natureId",
                        nomenclature: (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).NATURE
                    })
                });
                break;
            case (0, $c22d20d038ee5de2$export$2e2bcd8739ae039).COMMUNE:
                column.push({
                    Header: "Commune",
                    accessor: "communeLibelle",
                    sortField: "communeLibelle",
                    Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $dd08a763d100724f$export$2e2bcd8739ae039), {
                        name: "communeId",
                        url: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/commune/get-libelle-commune`
                    }),
                    Cell: (value)=>{
                        return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                            tooltipText: value.value,
                            tooltipId: value,
                            maxWidth: 167,
                            children: value.value
                        });
                    },
                    width: 170
                });
                break;
            case (0, $c22d20d038ee5de2$export$2e2bcd8739ae039).NATURE_DECI:
                column.push({
                    Header: "Nature DECI",
                    accessor: "natureDeciLibelle",
                    sortField: "natureDeciLibelle",
                    Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $bcc3791b22f76942$export$2e2bcd8739ae039), {
                        name: "natureDeci",
                        nomenclature: (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).NATURE_DECI
                    })
                });
                break;
            case (0, $c22d20d038ee5de2$export$2e2bcd8739ae039).AUTORITE_DECI:
                column.push({
                    Header: "Autorit\xe9 DECI",
                    accessor: "autoriteDeci",
                    sortField: "autoriteDeci",
                    Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $dd08a763d100724f$export$2e2bcd8739ae039), {
                        name: "autoriteDeci",
                        url: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/organisme/get-list-` + (0, $0d1c1a6d7932bf75$export$1d91abf8b407cf2e).AUTORITE_DECI
                    }),
                    width: 150
                });
                break;
            case (0, $c22d20d038ee5de2$export$2e2bcd8739ae039).SERVICE_PUBLIC_DECI:
                column.push({
                    Header: "Service Public DECI",
                    accessor: "servicePublicDeci",
                    sortField: "servicePublicDeci",
                    Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $dd08a763d100724f$export$2e2bcd8739ae039), {
                        name: "servicePublicDeci",
                        url: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/organisme/get-list-` + (0, $0d1c1a6d7932bf75$export$1d91abf8b407cf2e).SERVICE_PUBLIC_DECI
                    })
                });
                break;
            case (0, $c22d20d038ee5de2$export$2e2bcd8739ae039).ANOMALIES:
                column.push({
                    Header: "Anomalies",
                    accessor: "listeAnomalie",
                    Cell: (value)=>{
                        return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                            children: (0, $e16185eb091c73b9$export$2e2bcd8739ae039)(value.value, listeAnomaliePossible)
                        });
                    },
                    Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $dd08a763d100724f$export$2e2bcd8739ae039), {
                        url: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/anomalie/get-libelle-anomalie`,
                        name: "anomalieId"
                    })
                });
                break;
            case (0, $c22d20d038ee5de2$export$2e2bcd8739ae039).PEI_NEXT_ROP:
                column.push({
                    Header: "Prochaine ROP",
                    accessor: "peiNextRop",
                    sortField: "peiNextRop",
                    Cell: (value)=>{
                        return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($491b746883a2d098$var$DateHighlightCell, {
                            date: value.value,
                            paramUrgent: delaisUrgentRECO,
                            paramWarning: delaisWarnRECO
                        });
                    },
                    Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eed37ff3d3e1f28c$export$2e2bcd8739ae039), {
                        options: (0, $70f33b4ac8b2af85$export$2e2bcd8739ae039),
                        name: "prochaineDateRop"
                    })
                });
                break;
            case (0, $c22d20d038ee5de2$export$2e2bcd8739ae039).PEI_NEXT_CTP:
                column.push({
                    Header: "Prochain CTP",
                    accessor: "peiNextCtp",
                    sortField: "peiNextCtp",
                    Cell: (value)=>{
                        return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($491b746883a2d098$var$DateHighlightCell, {
                            date: value.value,
                            paramUrgent: delaisUrgentCTP,
                            paramWarning: delaisWarnCTP
                        });
                    },
                    Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eed37ff3d3e1f28c$export$2e2bcd8739ae039), {
                        options: (0, $70f33b4ac8b2af85$export$2e2bcd8739ae039),
                        name: "prochaineDateCtp"
                    })
                });
                break;
            case (0, $c22d20d038ee5de2$export$2e2bcd8739ae039).TOURNEE_LIBELLE:
                column.push({
                    Header: "Tourn\xe9e",
                    accessor: "tourneeLibelle",
                    Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($491b746883a2d098$var$TourneeFilter, {
                        name: "tourneeId"
                    }),
                    width: 250,
                    Cell: (value)=>{
                        return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                            tooltipText: value.value,
                            tooltipId: value,
                            maxWidth: 247,
                            children: value.value
                        });
                    }
                });
                break;
            case (0, $c22d20d038ee5de2$export$2e2bcd8739ae039).PEI_ADRESSE:
                column.push({
                    Header: "Adresse",
                    accessor: "adresse",
                    sortField: "adresse",
                    Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                        type: "text",
                        name: "adresse"
                    }),
                    Cell: (value)=>{
                        return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                            tooltipText: value.value,
                            tooltipId: value,
                            maxWidth: 247,
                            children: value.value
                        });
                    },
                    width: 250
                });
                break;
            case (0, $c22d20d038ee5de2$export$2e2bcd8739ae039).GESTIONNAIRE:
                column.push({
                    Header: "Gestionnaire",
                    accessor: "gestionnaireLibelle",
                    sortField: "gestionnaireLibelle",
                    Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $dd08a763d100724f$export$2e2bcd8739ae039), {
                        url: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/gestionnaire/get-libelle`,
                        name: "gestionnaireId"
                    }),
                    width: 250,
                    Cell: (value)=>{
                        return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                            tooltipText: value.value,
                            tooltipId: value,
                            maxWidth: 247,
                            children: value.value
                        });
                    }
                });
                break;
            case (0, $c22d20d038ee5de2$export$2e2bcd8739ae039).DIAMETRE_NOMINAL:
                column.push({
                    Header: "Diam\xe8tre nominal",
                    accessor: "diametreNominalLibelle",
                    sortField: "diametreNominalLibelle",
                    Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $bcc3791b22f76942$export$2e2bcd8739ae039), {
                        name: "diametreNominalId",
                        nomenclature: (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).DIAMETRE
                    })
                });
                break;
            default:
                column.push({
                    Header: "Erreur",
                    accessor: "null",
                    sortField: "null"
                });
        }
    });
    {
        const listeButton = [];
        const canEditPei = (0, $e3b8d60f4bb99483$export$4f612ab7b7b1d133)(user, [
            (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).PEI_U,
            (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).PEI_CARACTERISTIQUES_U,
            (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).PEI_NUMERO_INTERNE_U,
            (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).PEI_DEPLACEMENT_U,
            (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).PEI_ADRESSE_C
        ]);
        if (displayFicheResumeStandalone === true && (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).PEI_R)) listeButton.push({
            row: (row)=>row,
            type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).SIMPLE_MODAL,
            icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$8bb46d5eef767d7), {}),
            textEnable: "Voir le r\xe9sum\xe9",
            simpleModal: {
                content: (peiId, row)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $4c401fa322fe4af6$export$2e2bcd8739ae039), {
                        peiId: peiId,
                        peiNumeroComplet: row.original.peiNumeroComplet
                    }),
                header: (row)=>"Fiche R\xe9sum\xe9 du PEI " + row.original.peiNumeroComplet
            }
        });
        // Si l'utilisateur ne peut pas update un PEI, on lui propose la fiche complète en lecture seule
        if (!canEditPei) listeButton.push({
            row: (row)=>row,
            type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).SEE,
            route: (idPei)=>(0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).UPDATE_PEI(idPei),
            icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$50a7b2527c056255), {}),
            textEnable: "Voir la fiche compl\xe8te du PEI"
        });
        if (canEditPei) listeButton.push({
            row: (row)=>row,
            type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).UPDATE,
            route: (idPei)=>(0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).UPDATE_PEI(idPei)
        });
        if ((0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).PEI_R)) listeButton.push({
            row: (row)=>{
                return row;
            },
            type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).SIMPLE_MODAL,
            icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$84ac927778fdc063), {}),
            textEnable: "Voir les documents",
            disable: (row)=>!row.original.hasDocuments,
            textDisable: "Aucun document pour ce pei",
            simpleModal: {
                content: (peiId)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e7b5be6e16761684$export$2e2bcd8739ae039), {
                        peiId: peiId
                    }),
                header: (row)=>"Documents du PEI " + row.original.peiNumeroComplet
            }
        });
        if ((0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).PEI_D)) listeButton.push({
            disable: (v)=>v.original.hasTourneeReservee,
            textDisable: "Impossible de supprimer un PEI affect\xe9 \xe0 une tourn\xe9e r\xe9serv\xe9e",
            row: (row)=>row,
            type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).DELETE,
            pathname: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/pei/delete/`,
            header: (row)=>"Suppression du PEI " + row.original.peiNumeroComplet,
            content: (row)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                    children: [
                        "\xcates-vous s\xfbr de vouloir supprimer le PEI",
                        " ",
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("b", {
                            children: row.original.peiNumeroComplet
                        }),
                        " ? Cette action est irr\xe9versible."
                    ]
                })
        });
        if ((0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).INDISPO_TEMP_U)) listeButton.push({
            disable: (row)=>!row.original.hasIndispoTemp,
            textDisable: "Aucune indisponibilit\xe9 temporaire \xe0 lever pour ce PEI",
            row: (row)=>row,
            type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).BUTTON,
            onClick: (row)=>handleLeverIndispoTemp(row),
            textEnable: "Lever une indisponibilit\xe9 temporaire",
            icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$37a0f4bc54062d1c), {})
        });
        if ((0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).VISITE_R)) listeButton.push({
            row: (row)=>row,
            route: (idPei)=>(0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).VISITE(idPei),
            type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).LINK,
            icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$931ba9c16d55112), {}),
            textEnable: "G\xe9rer les visites",
            classEnable: "warning"
        });
        if ((0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).TOURNEE_R)) listeButton.push({
            row: (row)=>row,
            type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).LINK,
            route: ()=>(0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).PEI_TOURNEE,
            search: (row)=>{
                const filter = JSON.stringify({
                    peiId: row.original.peiId
                });
                const searchParams = new URLSearchParams();
                searchParams.set("filterBy", filter);
                if (typeof pagination === "object" && pagination !== null && "limit" in pagination && "offset" in pagination) {
                    searchParams.set("limit", String(pagination.limit ?? ""));
                    searchParams.set("offset", String(pagination.offset ?? ""));
                }
                return searchParams.toString();
            },
            state: (row)=>({
                    peiNumeroComplet: row.original.peiNumeroComplet
                }),
            icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$527d32aa1785fdd4), {}),
            textEnable: "Voir les tourn\xe9es associ\xe9es"
        });
        if ((0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).PEI_U)) listeButton.push({
            row: (row)=>row,
            route: (idPei)=>(0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).UPDATE_PENA_ASPIRATION(idPei),
            type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).LINK,
            icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$f736853d852cc436), {}),
            textEnable: "G\xe9rer les aires d'aspirations",
            classEnable: "warning",
            hide: (original)=>{
                return original.peiTypePei !== (0, $f31f748b1c9fd0fb$export$2e2bcd8739ae039).PENA;
            }
        });
        listeButton.push({
            row: (row)=>row,
            onClick: (idPei)=>fetchGeometry((0, $a178c3075f0f40bb$export$970c58a942355206).PEI, idPei),
            type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).LINK,
            icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$cbe811cb8e919f27), {}),
            textEnable: "Localiser",
            classEnable: "primary"
        });
        column.push((0, $b82b937cc97f6f18$export$36e9f5a475c9f6fc)({
            Header: "Actions",
            accessor: "peiId",
            buttons: listeButton
        }));
    }
    return column;
}
function $491b746883a2d098$export$c8ab9661c12add29(indisponibiliteTemporaireDateDebut, indisponibiliteTemporaireDateFin) {
    const dateDebut = new Date(indisponibiliteTemporaireDateDebut);
    const dateFin = new Date(indisponibiliteTemporaireDateFin);
    const date = new Date();
    let statut = "";
    if (dateDebut < date && (!indisponibiliteTemporaireDateFin || dateFin > date)) statut = "En cours";
    else if (dateDebut > date) statut = "Planifi\xe9e";
    else if (dateFin < date) statut = "Termin\xe9e";
    return statut;
}
function $491b746883a2d098$export$876888025bdab36c({ user: user, parametres: parametres, fetchGeometry: fetchGeometry }) {
    const listePeiState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/pei/get-id-numero-indispos-temp`);
    const communeListState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/commune/get-libelle-commune`);
    const column = [];
    parametres.forEach((_parametre)=>{
        switch(_parametre){
            case (0, $7232829592627b50$export$2e2bcd8739ae039).MOTIF:
                column.push({
                    Header: "Motif",
                    accessor: "indisponibiliteTemporaireMotif",
                    sortField: "indisponibiliteTemporaireMotif",
                    Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                        type: "text",
                        name: "indisponibiliteTemporaireMotif"
                    })
                });
                break;
            case (0, $7232829592627b50$export$2e2bcd8739ae039).DESCRIPTION:
                column.push({
                    Header: "Observation",
                    accessor: "indisponibiliteTemporaireObservation",
                    sortField: "indisponibiliteTemporaireObservation",
                    Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                        type: "text",
                        name: "indisponibiliteTemporaireObservation"
                    })
                });
                break;
            case (0, $7232829592627b50$export$2e2bcd8739ae039).STATUT:
                column.push({
                    Header: "Statut",
                    accessor: ({ indisponibiliteTemporaireDateDebut: indisponibiliteTemporaireDateDebut, indisponibiliteTemporaireDateFin: indisponibiliteTemporaireDateFin })=>({
                            indisponibiliteTemporaireDateDebut: indisponibiliteTemporaireDateDebut,
                            indisponibiliteTemporaireDateFin: indisponibiliteTemporaireDateFin
                        }),
                    Cell: (value)=>{
                        return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                            children: $491b746883a2d098$export$c8ab9661c12add29(value.value.indisponibiliteTemporaireDateDebut, value.value.indisponibiliteTemporaireDateFin)
                        });
                    },
                    Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eed37ff3d3e1f28c$export$2e2bcd8739ae039), {
                        options: (0, $4a8fc6d624905721$export$2e2bcd8739ae039),
                        name: "indisponibiliteTemporaireStatut"
                    })
                });
                break;
            case (0, $7232829592627b50$export$2e2bcd8739ae039).MAIL_AVANT:
                column.push((0, $b82b937cc97f6f18$export$38dcf858d3ede0e9)({
                    Header: "Notification avant date d\xe9but",
                    accessor: "indisponibiliteTemporaireMailAvantIndisponibilite",
                    sortField: "indisponibiliteTemporaireMailAvantIndisponibilite",
                    Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eed37ff3d3e1f28c$export$2e2bcd8739ae039), {
                        options: (0, $a4f278cac9030fb1$export$2e2bcd8739ae039),
                        name: "indisponibiliteTemporaireMailAvantIndisponibilite"
                    })
                }));
                break;
            case (0, $7232829592627b50$export$2e2bcd8739ae039).MAIL_APRES:
                column.push((0, $b82b937cc97f6f18$export$38dcf858d3ede0e9)({
                    Header: "Notification avant date fin",
                    accessor: "indisponibiliteTemporaireMailApresIndisponibilite",
                    sortField: "indisponibiliteTemporaireMailApresIndisponibilite",
                    Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eed37ff3d3e1f28c$export$2e2bcd8739ae039), {
                        options: (0, $a4f278cac9030fb1$export$2e2bcd8739ae039),
                        name: "indisponibiliteTemporaireMailApresIndisponibilite"
                    })
                }));
                break;
            case (0, $7232829592627b50$export$2e2bcd8739ae039).LIST_PEI:
                column.push({
                    Header: "PEI concern\xe9s",
                    accessor: "listeNumeroPei",
                    sortField: "listeNumeroPei",
                    Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $cc7cbb0460865818$export$2e2bcd8739ae039), {
                        name: "listePeiId",
                        listIdCodeLibelle: listePeiState?.data?.map((e)=>({
                                id: e.peiId,
                                code: e.peiId,
                                libelle: e.peiNumeroComplet
                            }))
                    }),
                    width: 200
                });
                break;
            case (0, $7232829592627b50$export$2e2bcd8739ae039).DATE_DEBUT:
                column.push({
                    Header: "Date de d\xe9but",
                    accessor: "indisponibiliteTemporaireDateDebut",
                    sortField: "indisponibiliteTemporaireDateDebut",
                    Cell: (value)=>{
                        return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                            children: value.value ? (0, $00c47c7740afd024$export$2e2bcd8739ae039)(value.value) : ""
                        });
                    }
                });
                break;
            case (0, $7232829592627b50$export$2e2bcd8739ae039).DATE_FIN:
                column.push({
                    Header: "Date de fin",
                    accessor: "indisponibiliteTemporaireDateFin",
                    sortField: "indisponibiliteTemporaireDateFin",
                    Cell: (value)=>{
                        return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                            children: value.value ? (0, $00c47c7740afd024$export$2e2bcd8739ae039)(value.value) : ""
                        });
                    }
                });
                break;
            case (0, $7232829592627b50$export$2e2bcd8739ae039).COMMUNE:
                column.push({
                    Header: "Communes",
                    accessor: "listeCommunes",
                    Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $cc7cbb0460865818$export$2e2bcd8739ae039), {
                        name: "listeCommunes",
                        listIdCodeLibelle: communeListState?.data ?? []
                    }),
                    Cell: (value)=>{
                        let display = value.value;
                        if (Array.isArray(display)) display = display.join(", ");
                        return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                            tooltipText: display,
                            tooltipId: display,
                            maxWidth: 167,
                            children: display
                        });
                    },
                    width: 170
                });
                break;
            default:
        }
    });
    {
        const listeButton = [];
        listeButton.push({
            row: (row)=>{
                return row;
            },
            type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).LINK,
            route: (indisponibiliteTemporaireId)=>(0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).INDISPONIBILITE_TEMPORAIRE_LISTE_PEI(indisponibiliteTemporaireId),
            state: (row)=>({
                    peiNumeroComplet: row.original.peiNumeroComplet
                }),
            textEnable: "Lister les points d'eau",
            icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$527d32aa1785fdd4), {})
        });
        if ((0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).INDISPO_TEMP_U)) listeButton.push({
            row: (row)=>{
                return row;
            },
            type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).UPDATE,
            disable: (v)=>{
                return $491b746883a2d098$export$c8ab9661c12add29(v.original.indisponibiliteTemporaireDateDebut, v.original.indisponibiliteTemporaireDateFin) === (0, $4a8fc6d624905721$export$2e2bcd8739ae039).TERMINEE || !v.original.isModifiable;
            },
            textDisable: "L'indisponibilit\xe9 temporaire est termin\xe9e ou contient des PEI en dehors de votre zone de comp\xe9tence",
            route: (indisponibiliteTemporaireId)=>(0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).UPDATE_INDISPONIBILITE_TEMPORAIRE(indisponibiliteTemporaireId)
        });
        if ((0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).INDISPO_TEMP_D)) listeButton.push({
            row: (row)=>{
                return row;
            },
            type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).DELETE,
            disable: (v)=>{
                return $491b746883a2d098$export$c8ab9661c12add29(v.original.indisponibiliteTemporaireDateDebut, v.original.indisponibiliteTemporaireDateFin) === (0, $4a8fc6d624905721$export$2e2bcd8739ae039).EN_COURS || !v.original.isModifiable;
            },
            textDisable: "L'indisponibilit\xe9 temporaire est en cours ou contient des PEI en dehors de votre zone de comp\xe9tence",
            pathname: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/indisponibilite-temporaire/delete/`
        });
        if ((0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).INDISPO_TEMP_U)) listeButton.push({
            isPost: false,
            row: (row)=>{
                return row;
            },
            type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).CONFIRM,
            disable: (v)=>{
                return $491b746883a2d098$export$c8ab9661c12add29(v.original.indisponibiliteTemporaireDateDebut, v.original.indisponibiliteTemporaireDateFin) !== (0, $4a8fc6d624905721$export$2e2bcd8739ae039).EN_COURS;
            },
            confirmModal: {
                header: "Lever l'indisponibilit\xe9 temporaire ?",
                content: "Voulez-vous continuer ? "
            },
            textDisable: "Impossible de lever une indisponibilit\xe9 temporaire qui n'est pas en cours",
            textEnable: "Lever l'indisponibilit\xe9 temporaire",
            pathname: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/indisponibilite-temporaire/lever/`,
            icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$37a0f4bc54062d1c), {}),
            classEnable: "warning"
        });
        listeButton.push({
            row: (row)=>{
                return row;
            },
            onClick: (idIndisponibiliteTemporaire)=>fetchGeometry((0, $a178c3075f0f40bb$export$970c58a942355206).INDISPONIBILITE_TEMP, idIndisponibiliteTemporaire),
            type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).LINK,
            icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$cbe811cb8e919f27), {}),
            textEnable: "Localiser",
            classEnable: "primary"
        });
        column.push((0, $b82b937cc97f6f18$export$36e9f5a475c9f6fc)({
            Header: "Actions",
            accessor: "indisponibiliteTemporaireId",
            buttons: listeButton
        }));
    }
    return column;
}
/**
 * Composant React qui affiche une date stylisée selon son niveau d'urgence.
 *
 * La date est comparée à `now + paramUrgent` et `now + paramWarning` :
 * - Si elle est avant `now + paramUrgent`, elle est considérée comme urgente (texte en rouge)
 * - Si elle est avant `now + paramWarning`, elle est considérée comme un avertissement (texte en orange/jaune)
 * - Sinon, elle est affichée normalement
 */ const $491b746883a2d098$var$DateHighlightCell = ({ date: date, paramUrgent: paramUrgent, paramWarning: paramWarning })=>{
    const now = new Date();
    const dateUrgent = new Date(now);
    dateUrgent.setDate(now.getDate() + Number(paramUrgent));
    const dateWarning = new Date(now);
    dateWarning.setDate(now.getDate() + Number(paramWarning));
    const dateToCompare = new Date(date); // pour la mettre au même format que les autres peu importe l'entrée
    let isUrgent = false, isWarning = false;
    if (dateToCompare < dateUrgent) isUrgent = true;
    else if (dateToCompare < dateWarning) isWarning = true;
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))("text-center", isUrgent ? "text-danger" : isWarning ? "text-warning" : ""),
        children: date ? isUrgent || isWarning ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("b", {
            children: (0, $00c47c7740afd024$export$beb50dcdba5b8943)(date)
        }) : (0, $00c47c7740afd024$export$beb50dcdba5b8943)(date) : ""
    });
};
var $491b746883a2d098$export$2e2bcd8739ae039 = $491b746883a2d098$var$getColumnPeiByStringArray;



const $d41e9686ad2d2092$var$LeverIndispoTempsVolet = ({ idPei: idPei, closeVolet: closeVolet, onClick: onClick })=>{
    const [peiInfo, setPeiInfo] = (0, $kc00y.useState)(null);
    const { data: peiData } = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)(idPei ? (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/pei/${idPei}` : "");
    (0, $kc00y.useEffect)(()=>{
        if (peiData) setPeiInfo(peiData);
    }, [
        peiData
    ]);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                displayReturnButton: false,
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$37a0f4bc54062d1c), {}),
                title: "Lever une indisponibilit\xe9 temporaire pour le PEI " + (peiInfo ? peiInfo.peiNumeroComplet : "")
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                isPost: false,
                isMultipartFormData: false,
                submitUrl: `/api/indisponibilite-temporaire/lever-indispo-temp`,
                onSubmit: closeVolet,
                prepareVariables: (values)=>$d41e9686ad2d2092$export$f97400759cfd946(values),
                validationSchema: (0, $ce4de947442b2ab1$export$be5493f9613cbbe)(),
                initialValues: {
                    data: []
                },
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($d41e9686ad2d2092$var$LeverIndispoTempForm, {
                    idPei: idPei,
                    onClick: onClick
                })
            })
        ]
    });
};
const $d41e9686ad2d2092$var$LeverIndispoTempForm = ({ idPei: idPei, onClick: onClick })=>{
    const { setFieldValue: setFieldValue, values: values } = (0, $bkJfK.useFormikContext)();
    const [tableData, setTableData] = (0, $kc00y.useState)(null);
    const { data: indispos } = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)(idPei ? (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/pei/get-pei-indispo-temp/${idPei}` : "");
    (0, $kc00y.useEffect)(()=>{
        if (indispos && indispos.length > 0) {
            const enrichedData = indispos.map((item)=>({
                    ...item,
                    indisponibiliteTemporaireStatus: (0, $491b746883a2d098$export$c8ab9661c12add29)(item.indisponibiliteTemporaireDateDebut, item.indisponibiliteTemporaireDateFin)
                })).filter((item)=>item.indisponibiliteTemporaireStatus !== "Termin\xe9e");
            setTableData(enrichedData);
        }
    }, [
        indispos
    ]);
    const updateFieldValue = (indispoId, isSelected)=>{
        if (!tableData) return;
        setFieldValue("data", isSelected ? [
            ...values?.data || [],
            tableData?.find((indispo)=>indispo.indisponibiliteTemporaireId === indispoId)
        ] : values?.data?.filter((indispo)=>indispo.indisponibiliteTemporaireId !== indispoId));
    };
    const onSelectAll = (e)=>{
        if (!tableData) return;
        setFieldValue("data", e.target.checked ? tableData : []);
    };
    return tableData ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
            children: [
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $8598ca69ed8b9dca$export$2e2bcd8739ae039), {
                        variant: "warning",
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8598ca69ed8b9dca$export$2e2bcd8739ae039).Heading, {
                                children: "Attention"
                            }),
                            "Les indisponibilit\xe9s temporaires s\xe9lectionn\xe9es seront lev\xe9es pour",
                            " ",
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("b", {
                                children: "tous les PEI"
                            }),
                            " qui leurs sont associ\xe9es."
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $13de46b4dfcc473f$export$2e2bcd8739ae039), {
                    bordered: true,
                    responsive: true,
                    className: "mt-3",
                    children: [
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("thead", {
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("th", {
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $15ea91ee06c5121b$export$2e2bcd8739ae039), {
                                            type: "checkbox",
                                            label: "",
                                            onChange: onSelectAll,
                                            checked: values?.data?.length === tableData?.length && tableData.every((indispoTemp)=>values?.data?.some((val)=>val.indisponibiliteTemporaireId === indispoTemp.indisponibiliteTemporaireId))
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("th", {
                                        children: "Date de d\xe9but"
                                    }),
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("th", {
                                        children: "PEI concern\xe9s"
                                    }),
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("th", {
                                        children: "Statut"
                                    }),
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("th", {
                                        children: "Motif"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("tbody", {
                            children: tableData.map((row)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("td", {
                                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $15ea91ee06c5121b$export$2e2bcd8739ae039), {
                                                type: "checkbox",
                                                checked: values?.data?.some((val)=>val.indisponibiliteTemporaireId === row.indisponibiliteTemporaireId),
                                                onChange: ()=>updateFieldValue(row.indisponibiliteTemporaireId, !values?.data?.some((val)=>val.indisponibiliteTemporaireId === row.indisponibiliteTemporaireId))
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("td", {
                                            children: (0, $00c47c7740afd024$export$2e2bcd8739ae039)(row.indisponibiliteTemporaireDateDebut)
                                        }),
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("td", {
                                            children: row.listePei
                                        }),
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("td", {
                                            children: row.indisponibiliteTemporaireStatus
                                        }),
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("td", {
                                            children: row.indisponibiliteTemporaireMotif
                                        })
                                    ]
                                }, row.indisponibiliteTemporaireId))
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db9b0e6fdb142a4c$export$2e2bcd8739ae039), {
                    submitTitle: "Lever",
                    onClick: onClick,
                    disabledValide: !Array.isArray(values?.data) || values.data.length === 0
                })
            ]
        })
    }) : /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("p", {
        children: "Aucune donn\xe9e trouv\xe9e pour ce PEI."
    });
};
const $d41e9686ad2d2092$export$f97400759cfd946 = (val)=>{
    return val.data?.map((indispo)=>indispo.indisponibiliteTemporaireId);
};
var $d41e9686ad2d2092$export$2e2bcd8739ae039 = $d41e9686ad2d2092$var$LeverIndispoTempsVolet;








const $1eee265537f042a4$var$Volet = ({ show: show, handleClose: handleClose, className: className, backdrop: backdrop = false, title: title, children: children })=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $43efda4f21201843$export$2e2bcd8739ae039), {
        show: show,
        onHide: handleClose,
        placement: "end",
        className: className,
        scroll: true,
        backdrop: backdrop,
        autoFocus: true,
        /*
        Ajoute la tooltips au composant map-container si il existe pour qu'elle s'affiche
        aussi en fullscreen
    */ container: document.getElementById("map-container"),
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $43efda4f21201843$export$2e2bcd8739ae039).Header, {
                closeButton: true,
                children: title && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $43efda4f21201843$export$2e2bcd8739ae039).Title, {
                    children: title
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $43efda4f21201843$export$2e2bcd8739ae039).Body, {
                children: children
            })
        ]
    });
};
var $1eee265537f042a4$export$2e2bcd8739ae039 = $1eee265537f042a4$var$Volet;


const $20418e8270719735$var$useFilterContextPei = (initialValues)=>{
    const { filterBy: filterBy } = (0, $1a6f6d44ade81356$export$2e2bcd8739ae039)();
    const transformedFilterBy = (0, $8d53d795ab637b7e$export$f391aae8aa487f18)(filterBy ?? {});
    const formik = (0, $bkJfK.useFormik)({
        initialValues: transformedFilterBy ?? initialValues,
        validateOnChange: false,
        validateOnBlur: true,
        onSubmit: ()=>{
        // Le filtre s'applique automatiquement via le changement des valeurs
        // et la mise à jour des query params. Aucune action supplémentaire requise.
        }
    });
    return {
        values: formik.values,
        setValues: formik.setValues,
        setFieldValue: formik.setFieldValue,
        handleChange: formik.handleChange,
        formik: formik
    };
};
const $20418e8270719735$var$ListPei = ({ filterPage: filterPage, filterId: filterId, className: className, displayNone: displayNone })=>{
    const { user: user } = (0, $e787cde576104469$export$fdc397e486fa83e7)();
    const { fetchGeometry: fetchGeometry } = (0, $a178c3075f0f40bb$export$2e2bcd8739ae039)();
    const [indispoTempPei, setIndispoTempPei] = (0, $kc00y.useState)(null);
    const [showLeverIndispoTemp, setShowLeverIndispoTemp] = (0, $kc00y.useState)(false);
    const handleCloseLeverIndispoTemp = ()=>{
        setShowLeverIndispoTemp(false);
    };
    const { data: listeAnomaliePossible } = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/nomenclatures/list/` + (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).ANOMALIE);
    let peiColonnes = [];
    let isFicheResumeStandalone = false;
    let delaisWarnCTP, delaisUrgentCTP, delaisWarnRECO, delaisUrgentRECO, libelleNonConforme;
    const parametrePeiColonnes = (0, $ee297f06e8568bf4$export$2e2bcd8739ae039).PEI_COLONNES;
    const paramPeiFicheResumeStandalone = (0, $ee297f06e8568bf4$export$2e2bcd8739ae039).PEI_FICHE_RESUME_STANDALONE;
    const listeParametre = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/parametres?${{
        listeParametreCode: JSON.stringify([
            parametrePeiColonnes,
            paramPeiFicheResumeStandalone,
            (0, $ee297f06e8568bf4$export$2e2bcd8739ae039).PEI_DELAI_CTRL_URGENT,
            (0, $ee297f06e8568bf4$export$2e2bcd8739ae039).PEI_DELAI_CTRL_WARN,
            (0, $ee297f06e8568bf4$export$2e2bcd8739ae039).PEI_DELAI_RECO_URGENT,
            (0, $ee297f06e8568bf4$export$2e2bcd8739ae039).PEI_DELAI_RECO_WARN,
            (0, $ee297f06e8568bf4$export$2e2bcd8739ae039).PEI_LIBELLE_NON_CONFORME
        ])
    }}`);
    if (listeParametre.isResolved) {
        // Le résultat est un String, on le parse pour récupérer le tableau
        peiColonnes = listeParametre?.data?.[parametrePeiColonnes].parametreValeur ? JSON.parse(listeParametre?.data?.[parametrePeiColonnes].parametreValeur) : peiColonnes;
        isFicheResumeStandalone = JSON.parse(listeParametre?.data?.[paramPeiFicheResumeStandalone].parametreValeur);
        delaisWarnCTP = listeParametre?.data?.[(0, $ee297f06e8568bf4$export$2e2bcd8739ae039).PEI_DELAI_CTRL_WARN].parametreValeur;
        delaisUrgentCTP = listeParametre?.data?.[(0, $ee297f06e8568bf4$export$2e2bcd8739ae039).PEI_DELAI_CTRL_URGENT].parametreValeur;
        delaisWarnRECO = listeParametre?.data?.[(0, $ee297f06e8568bf4$export$2e2bcd8739ae039).PEI_DELAI_RECO_WARN].parametreValeur;
        delaisUrgentRECO = listeParametre?.data?.[(0, $ee297f06e8568bf4$export$2e2bcd8739ae039).PEI_DELAI_RECO_URGENT].parametreValeur;
        libelleNonConforme = listeParametre?.data?.[(0, $ee297f06e8568bf4$export$2e2bcd8739ae039).PEI_LIBELLE_NON_CONFORME].parametreValeur;
    }
    const filter = {
        peiNumeroComplet: "",
        peiNumeroInterne: "",
        communeId: "",
        natureId: "",
        peiDisponibiliteTerrestre: "",
        penaDisponibiliteHbe: "",
        typePei: "",
        natureDeci: "",
        autoriteDeci: "",
        servicePublicDeci: "",
        anomalieId: "",
        tourneeLibelle: "",
        adresse: "",
        prochaineDateRop: undefined,
        prochaineDateCtp: undefined
    };
    let urlTable;
    switch(filterPage){
        case (0, $e8a2c985711dfc19$export$2e2bcd8739ae039).INDISPONIBILITE_TEMPORAIRE:
            if (filterId == null) //filterId obligatoire quand filterPage est renseigné
            throw new Error("Le filterId est obligatoire si le filterPage est renseign\xe9");
            urlTable = (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/pei/get-by-indispo/` + filterId;
            break;
        case (0, $e8a2c985711dfc19$export$2e2bcd8739ae039).TOURNEE:
            if (filterId == null) //filterId obligatoire quand filterPage est renseigné
            throw new Error("Le filterId est obligatoire si le filterPage est renseign\xe9");
            urlTable = (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/pei/get-by-tournee/` + filterId;
            break;
        case (0, $e8a2c985711dfc19$export$2e2bcd8739ae039).PEI_LONGUE_INDISPO:
            urlTable = (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/message-pei-longue-indispo/pei`;
            break;
        default:
            urlTable = (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/pei`;
    }
    const queryTableFilterContext = $20418e8270719735$var$useFilterContextPei({
        filter: filter
    });
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $9a9eebc3462fba73$export$2e2bcd8739ae039), {
                displayNone: displayNone,
                className: className,
                query: urlTable,
                columns: (0, $491b746883a2d098$export$2e2bcd8739ae039)((value)=>{
                    setIndispoTempPei(value);
                    setShowLeverIndispoTemp(true);
                }, user, peiColonnes, listeAnomaliePossible, fetchGeometry, isFicheResumeStandalone, delaisWarnCTP, delaisUrgentCTP, delaisWarnRECO, delaisUrgentRECO, libelleNonConforme),
                idName: "PeiTable",
                filterValuesToVariable: (0, $8d53d795ab637b7e$export$6f2fda70fe261d2e),
                filterContext: queryTableFilterContext
            }),
            indispoTempPei && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1eee265537f042a4$export$2e2bcd8739ae039), {
                handleClose: handleCloseLeverIndispoTemp,
                show: showLeverIndispoTemp,
                className: "w-auto",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $d41e9686ad2d2092$export$2e2bcd8739ae039), {
                    idPei: indispoTempPei,
                    closeVolet: ()=>{
                        handleCloseLeverIndispoTemp();
                        window.location.reload();
                    }
                })
            })
        ]
    });
};
var $20418e8270719735$export$2e2bcd8739ae039 = $20418e8270719735$var$ListPei;


const $0e7b0f927316b537$var$QueryTableWithListingPei = ({ column: //pour le queryTable
column, query: query, idName: idName, filterValuesToVariable: filterValuesToVariable, useFilterContext: useFilterContext, filterPage: //pour le composant ListePei
filterPage, showTable: showTable, filterId: filterId = null, setShowTable: setShowTable, setFilterId: setFilterId })=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        fluid: true,
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $9a9eebc3462fba73$export$2e2bcd8739ae039), {
                displayNone: !showTable,
                query: query,
                columns: column,
                idName: idName,
                filterValuesToVariable: filterValuesToVariable,
                filterContext: useFilterContext
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                xs: "auto",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                    onClick: ()=>{
                        if (setShowTable) setShowTable(true);
                        if (setFilterId) setFilterId(null);
                    },
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))("mx-5 my-3 btn-secondary", {
                        "d-none": showTable
                    }),
                    children: "Retour \xe0 la liste pr\xe9c\xe9dente"
                })
            }),
            filterId != null && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $20418e8270719735$export$2e2bcd8739ae039), {
                displayNone: showTable,
                filterPage: filterPage,
                filterId: filterId
            })
        ]
    });
};
var $0e7b0f927316b537$export$2e2bcd8739ae039 = $0e7b0f927316b537$var$QueryTableWithListingPei;







/**
 * Enumération définissant les différentes valeurs applicables au filtrage sur une date
 */ var $da03082e5aa1cdcf$var$DELTA_DATE = /*#__PURE__*/ function(DELTA_DATE) {
    DELTA_DATE["DATE_PASSEE"] = "Date pass\xe9e";
    DELTA_DATE["INF_1_MOIS"] = "< 1 Mois";
    DELTA_DATE["INF_2_MOIS"] = "< 2 Mois";
    DELTA_DATE["INF_6_MOIS"] = "< 6 Mois";
    DELTA_DATE["INF_12_MOIS"] = "< 12 Mois";
    DELTA_DATE["INF_24_MOIS"] = "< 24 Mois";
    DELTA_DATE["INF_36_MOIS"] = "< 36 Mois";
    return DELTA_DATE;
}($da03082e5aa1cdcf$var$DELTA_DATE || {});
var $da03082e5aa1cdcf$export$2e2bcd8739ae039 = $da03082e5aa1cdcf$var$DELTA_DATE;











const $83d4063b961e44d6$export$6f2fda70fe261d2e = ({ tourneeLibelle: tourneeLibelle, tourneeOrganismeLibelle: tourneeOrganismeLibelle, tourneeUtilisateurReservationLibelle: tourneeUtilisateurReservationLibelle, tourneeDeltaDate: tourneeDeltaDate, peiId: peiId, tourneeNotifiee: tourneeNotifiee })=>{
    const filter = {};
    if (tourneeLibelle != null && tourneeLibelle.trim() !== "") filter.tourneeLibelle = tourneeLibelle;
    if (tourneeOrganismeLibelle != null && tourneeOrganismeLibelle.trim() !== "") filter.tourneeOrganismeLibelle = tourneeOrganismeLibelle;
    if (tourneeUtilisateurReservationLibelle != null && tourneeUtilisateurReservationLibelle.trim() !== "") filter.tourneeUtilisateurReservationLibelle = tourneeUtilisateurReservationLibelle;
    if (tourneeDeltaDate != null && tourneeDeltaDate.trim() !== "") filter.tourneeDeltaDate = tourneeDeltaDate;
    if (peiId != null && peiId.trim() !== "") filter.peiId = peiId;
    if (tourneeNotifiee?.trim().length > 0) filter.tourneeNotifiee = tourneeNotifiee;
    return filter;
};


const $32ff803568ba9e09$var$ListTournee = ({ peiId: peiId, peiNumeroComplet: peiNumeroComplet })=>{
    const { user: user } = (0, $e787cde576104469$export$fdc397e486fa83e7)();
    const { fetchGeometry: fetchGeometry } = (0, $a178c3075f0f40bb$export$2e2bcd8739ae039)();
    const { error: errorToast, persistent: persistentToast, removeToast: removeToast } = (0, $6bdae0bad7b05751$export$91b3d218c74c79e4)();
    const { data: incomingTournee } = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/tournee/incoming/`, {});
    const parametreGenerationCarteTournee = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/parametres?${{
        listeParametreCode: JSON.stringify((0, $ee297f06e8568bf4$export$2e2bcd8739ae039).PEI_GENERATION_CARTE_TOURNEE)
    }}`, {})?.data?.[(0, $ee297f06e8568bf4$export$2e2bcd8739ae039).PEI_GENERATION_CARTE_TOURNEE].parametreValeur;
    const canGenererRapportPostRop = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/courriers/modeles/exists-rapport-post-rop`, {})?.data === true && (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_ROP_A);
    const canGenererCanevasRop = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/courriers/modeles/exists-canevas-rop`, {})?.data === true && (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).GENERER_CANEVAS_ROP_A);
    /**
   * Constante permettant de savoir le nombre d'actions de génération de documents activées
   * (génération de la carte de la tournée, du rapport post ROP et/ou du canevas ROP)
   * Le libellé diffère, et on n'affiche un sous-menu que s'il y a plus d'une action possible
   */ const nbActionsGeneration = (canGenererRapportPostRop ? 1 : 0) + (canGenererCanevasRop ? 1 : 0) + (parametreGenerationCarteTournee === "true" ? 1 : 0);
    // Re-mount the QueryTable to trigger a fresh fetch when needed
    const [tableKey, setTableKey] = (0, $kc00y.useState)(0);
    const column = [
        {
            Header: "Nom",
            accessor: "tourneeLibelle",
            sortField: "tourneeLibelle",
            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                type: "text",
                name: "tourneeLibelle"
            })
        },
        {
            Header: "Nombre de PEI",
            accessor: "tourneeNbPei",
            sortField: "tourneeNbPei"
        },
        {
            Header: "Organisme",
            accessor: "organismeLibelle",
            sortField: "organismeLibelle",
            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                type: "text",
                name: "tourneeOrganismeLibelle"
            })
        },
        {
            Header: "Pourcentage d'avancement",
            accessor: "tourneePourcentageAvancement",
            sortField: "tourneePourcentageAvancement"
        },
        {
            Header: "R\xe9servation",
            accessor: "tourneeUtilisateurReservationLibelle",
            sortField: "tourneeUtilisateurReservationLibelle",
            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                type: "text",
                name: "tourneeUtilisateurReservationLibelle"
            })
        },
        {
            Header: "Prochaine ROP",
            accessor: ({ tourneeNextRopDate: tourneeNextRopDate })=>{
                return tourneeNextRopDate ? (0, $00c47c7740afd024$export$beb50dcdba5b8943)(tourneeNextRopDate) : "";
            },
            sortField: "tourneeNextRopDate",
            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eed37ff3d3e1f28c$export$2e2bcd8739ae039), {
                options: (0, $da03082e5aa1cdcf$export$2e2bcd8739ae039),
                name: "tourneeDeltaDate"
            })
        }
    ];
    // On affiche la colonne "Notifiée" uniquement si le rapport post ROP est configuré
    if (canGenererRapportPostRop) column.push({
        Header: "Notifi\xe9e",
        accessor: "tourneeNotifiee",
        Cell: (value)=>{
            return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                className: "text-center",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Check, {
                    type: "checkbox",
                    disabled: true,
                    checked: value.value === true
                })
            });
        },
        Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eed37ff3d3e1f28c$export$2e2bcd8739ae039), {
            options: (0, $a4f278cac9030fb1$export$2e2bcd8739ae039),
            name: "tourneeNotifiee"
        })
    });
    /***Constante permetant de gérer les états des composants "QueryTable" et "ListePei" *****/ const [showTable, setShowTable] = (0, $kc00y.useState)(true); // Contrôle de l'affichage du tableau
    const [idTournee, setIdTournee] = (0, $kc00y.useState)(null); // Variable à mettre à jour
    const listeButton = [];
    listeButton.push({
        row: (row)=>{
            return row;
        },
        type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).LINK,
        route: (tourneeId)=>(0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).TOURNEE_LISTE_PEI(tourneeId),
        state: (row)=>({
                tourneeLibelle: row.original.tourneeLibelle
            }),
        textEnable: "Lister les points d'eau",
        icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$527d32aa1785fdd4), {})
    });
    const textDisable = "La tourn\xe9e est r\xe9serv\xe9e ou contient des PEI qui sont en dehors de votre zone de comp\xe9tence";
    if ((0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).TOURNEE_A)) {
        listeButton.push({
            row: (row)=>{
                return row;
            },
            type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).UPDATE,
            disable: (v)=>{
                return isDisabled(v);
            },
            textEnable: "Renommer",
            route: (idTournee)=>(0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).UPDATE_TOURNEE(idTournee),
            textDisable: textDisable
        });
        listeButton.push({
            disable: (v)=>{
                return isDisabled(v);
            },
            textDisable: textDisable,
            row: (row)=>{
                return row;
            },
            type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).DELETE,
            pathname: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/tournee/`
        });
    }
    if ((0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).TOURNEE_ORDRE_PEIS_U) || (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).TOURNEE_A)) listeButton.push({
        row: (row)=>{
            return row;
        },
        route: (idTournee)=>(0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).TOURNEE_PEI(idTournee),
        type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).LINK,
        icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$94727896c77b7d99), {}),
        textEnable: (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).TOURNEE_A) ? "G\xe9rer les PEI et leur ordre dans la tourn\xe9e" : "G\xe9rer l'ordre des PEI dans la tourn\xe9e",
        textDisable: textDisable,
        classEnable: "warning",
        disable: (v)=>{
            return isDisabled(v);
        }
    });
    function isDisabled(v) {
        return v.original.tourneeUtilisateurReservationLibelle != null || !v.original.isModifiable;
    }
    // Bouton d'accès à la saisie en masse des visites
    const hasVisiteTourneeRight = (0, $e3b8d60f4bb99483$export$4f612ab7b7b1d133)(user, [
        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).TOURNEE_A,
        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).TOURNEE_R
    ]) && (0, $e3b8d60f4bb99483$export$4f612ab7b7b1d133)(user, [
        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).VISITE_RECEP_C,
        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).VISITE_RECO_INIT_C,
        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).VISITE_NON_PROGRAMME_C,
        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).VISITE_CONTROLE_TECHNIQUE_C,
        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).VISITE_RECO_C
    ]);
    if (hasVisiteTourneeRight) listeButton.push({
        row: (row)=>{
            return row;
        },
        route: (idTournee)=>(0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).TOURNEE_VISITE(idTournee),
        type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).LINK,
        icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$931ba9c16d55112), {}),
        textEnable: "Saisir toutes les visites de la tourn\xe9e",
        textDisable: textDisable,
        classEnable: "warning",
        disable: (v)=>{
            return isDisabled(v);
        }
    });
    // Bouton désaffectation de la tournée
    if ((0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).TOURNEE_RESERVATION_D)) listeButton.push({
        row: (row)=>{
            return row;
        },
        type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).CONFIRM,
        textEnable: "Retirer la r\xe9servation",
        pathname: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/tournee/desaffecter/`,
        icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$8a9b10ae77f54b81), {}),
        confirmModal: {
            header: "Retirer la r\xe9servation ?",
            content: "Voulez-vous continuer ? "
        },
        classEnable: "danger",
        textDisable: "La tourn\xe9e n'est pas r\xe9serv\xe9e.",
        disable: (v)=>{
            return v.original.tourneeUtilisateurReservationLibelle == null;
        }
    });
    // Bouton forcer l'avancement d'une tournée
    if ((0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).TOURNEE_FORCER_POURCENTAGE_E)) {
        // Forcer à 0%
        listeButton.push({
            row: (row)=>{
                return row;
            },
            type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).CONFIRM,
            conditionnalTextDisable: (row)=>{
                return row.original.tourneePourcentageAvancement === 0 ? "L'avancement de la tourn\xe9e est d\xe9j\xe0 \xe0 0%" : "Impossible de modifier une tourn\xe9e r\xe9serv\xe9e";
            },
            textEnable: "Forcer l'avancement de la tourn\xe9e \xe0 0",
            pathname: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/tournee/avancement-force-0/`,
            icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$c3f8793f0bc04c26), {}),
            confirmModal: {
                header: (row)=>`Forcer l'avancement de la tourn\xe9e ${row.original.tourneeLibelle} \xe0 0% ?`,
                content: "Voulez-vous continuer ? "
            },
            disable: (v)=>{
                return v.original.tourneePourcentageAvancement === 0 || isDisabled(v);
            },
            classEnable: "warning"
        });
        // Forcer à 100%
        listeButton.push({
            row: (row)=>{
                return row;
            },
            type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).CONFIRM,
            conditionnalTextDisable: (row)=>{
                return row.original.tourneePourcentageAvancement === 100 ? "L'avancement de la tourn\xe9e est d\xe9j\xe0 \xe0 100" : "Impossible de modifier une tourn\xe9e r\xe9serv\xe9e";
            },
            textEnable: "Forcer l'avancement de la tourn\xe9e  \xe0 100",
            pathname: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/tournee/avancement-force-100/`,
            confirmModal: {
                header: (row)=>`Forcer l'avancement de la tourn\xe9e ${row.original.tourneeLibelle} \xe0 100% ?`,
                content: "Voulez-vous continuer ? "
            },
            icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$c1a4ecc4992509c4), {}),
            disable: (v)=>{
                return v.original.tourneePourcentageAvancement === 100 || isDisabled(v);
            },
            classEnable: "warning"
        });
    }
    listeButton.push({
        row: (row)=>{
            return row;
        },
        onClick: (tourneeId)=>fetchGeometry((0, $a178c3075f0f40bb$export$970c58a942355206).TOURNEE, tourneeId),
        type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).LINK,
        icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$cbe811cb8e919f27), {}),
        textEnable: "Localiser",
        classEnable: "primary"
    });
    // Bouton génération de la carte de la tournée, activé sur paramétrage
    const carteTourneeButton = {
        row: (row)=>row,
        type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).BUTTON,
        icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$bcb90d01a22e14f9), {}),
        textEnable: nbActionsGeneration > 1 ? "Carte de la tourn\xe9e" : "G\xe9n\xe9rer la carte de la tourn\xe9e",
        classEnable: "success",
        onClick: async (tourneeId)=>{
            const toastId = persistentToast("G\xe9n\xe9ration de la carte de la tourn\xe9e", "G\xe9n\xe9ration de la carte en cours\u2026");
            try {
                const response = await fetch((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/tournee/genere-carte-tournee/${tourneeId}`);
                removeToast(toastId);
                if (!response.ok) {
                    if (response.status === 500) {
                        const errorText = await response.text();
                        errorToast(`${errorText}`);
                    }
                    return;
                }
                const contentType = response.headers.get("Content-Type");
                if (!contentType || !contentType.includes("application/pdf")) {
                    const errorText = await response.text();
                    errorToast(errorText || "Le fichier retourn\xe9 n'est pas un PDF.");
                    return;
                }
                const blob = await response.blob();
                const disposition = response.headers.get("Content-Disposition");
                const filename = (0, $c066b242635c27a6$export$194a7b9973b5160e)(disposition, "carte-tournee.pdf");
                const urlBlob = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = urlBlob;
                a.download = filename;
                document.body.appendChild(a);
                a.click();
                a.remove();
                window.URL.revokeObjectURL(urlBlob);
            } catch (_error) {
                removeToast(toastId);
                errorToast("Une erreur est survenue");
            }
        }
    };
    // Bouton génération du rapport post ROP, activé si le modèle de courrier correspondant existe
    const rapportPostRopButton = {
        row: (row)=>row,
        type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).CONFIRM,
        icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$84ac927778fdc063), {}),
        textEnable: nbActionsGeneration > 1 ? "Rapport post ROP" : "G\xe9n\xe9rer le rapport post ROP",
        textDisable: "La ROP a \xe9t\xe9 notifi\xe9e, impossible de g\xe9n\xe9rer le rapport post ROP.",
        disable: (v)=>{
            return v.original.tourneeNotifiee === true;
        },
        classEnable: "success",
        pathname: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/tournee/generer-rapport-post-rop/`,
        confirmModal: {
            header: "G\xe9n\xe9rer le rapport post ROP ?",
            content: (_, rowData)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                    children: [
                        "Etes-vous s\xfbr de vouloir g\xe9n\xe9rer le rapport post ROP pour cette tourn\xe9e ?",
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                        "Au cours de cette ann\xe9e, ",
                        rowData?.original.tourneeNbRopRealisee,
                        " PEI ont \xe9t\xe9 visit\xe9s sur les ",
                        rowData?.original.tourneeNbPei,
                        " qui composent cette tourn\xe9e."
                    ]
                })
        },
        reload: ()=>{
            setTableKey((k)=>k + 1);
        }
    };
    const canevasRopButton = {
        row: (row)=>row,
        type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).BUTTON,
        icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$84ac927778fdc063), {}),
        textEnable: nbActionsGeneration > 1 ? "Canevas ROP" : "G\xe9n\xe9rer le canevas ROP",
        classEnable: "success",
        onClick: async (tourneeId)=>{
            const toastId = persistentToast("G\xe9n\xe9ration du canevas ROP", "G\xe9n\xe9ration du canevas en cours\u2026");
            try {
                const response = await fetch((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/tournee/generer-canevas-rop/${tourneeId}`);
                removeToast(toastId);
                if (!response.ok) {
                    const errorText = await response.text();
                    errorToast(errorText || "Une erreur est survenue");
                    return;
                }
                const contentType = response.headers.get("Content-Type");
                if (!contentType || !contentType.includes("application/pdf")) {
                    const errorText = await response.text();
                    errorToast(errorText || "Le fichier retourn\xe9 n'est pas un PDF.");
                    return;
                }
                const blob = await response.blob();
                const disposition = response.headers.get("Content-Disposition");
                const filename = (0, $c066b242635c27a6$export$194a7b9973b5160e)(disposition, "canevas-rop.pdf");
                const urlBlob = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = urlBlob;
                a.download = filename;
                document.body.appendChild(a);
                a.click();
                a.remove();
                window.URL.revokeObjectURL(urlBlob);
            } catch (_error) {
                removeToast(toastId);
                errorToast("Une erreur est survenue");
            }
        }
    };
    const generationButtons = [];
    if (parametreGenerationCarteTournee === "true") generationButtons.push(carteTourneeButton);
    if (canGenererRapportPostRop) generationButtons.push(rapportPostRopButton);
    if (canGenererCanevasRop) generationButtons.push(canevasRopButton);
    if (generationButtons.length > 1) // Regroupe les actions de génération dans un sous-menu
    listeButton.push({
        row: (row)=>row,
        type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).DROPDOWN,
        icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$84ac927778fdc063), {}),
        textEnable: "G\xe9n\xe9rer un document",
        classEnable: "success",
        children: generationButtons
    });
    else if (generationButtons.length === 1) listeButton.push(generationButtons[0]);
    if (incomingTournee && incomingTournee.length > 0) listeButton.push({
        row: (row)=>{
            return row;
        },
        type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).CONFIRM,
        hide: (row)=>!row?.estDansIncoming,
        icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$c9bef5de7ad5da31), {}),
        textEnable: "R\xe9int\xe9grer la tourn\xe9e de incoming \xe0 REMOcRA",
        classEnable: "info",
        pathname: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/tournee/incoming/`,
        confirmModal: {
            header: "Relancer l'int\xe9gration de incoming \xe0 REMOcRA ?",
            content: "Vous allez relancer l'int\xe9gration de incoming \xe0 REMOcRA.\nVoulez-vous continuer ? "
        }
    });
    column.push((0, $b82b937cc97f6f18$export$36e9f5a475c9f6fc)({
        Header: "Actions",
        accessor: "tourneeId",
        buttons: listeButton
    }));
    const filterValuesToVariableWithPei = (values)=>{
        const base = (0, $83d4063b961e44d6$export$6f2fda70fe261d2e)(values); // logique actuelle
        if (peiId) base.peiId = peiId; // on impose le PEI sélectionné
        return base;
    };
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                    icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$5ee68ae963bf2bda), {}),
                    title: peiNumeroComplet ? `Liste des tourn\xe9es du point d'eau n\xb0 ${peiNumeroComplet}` : "Liste des tourn\xe9es",
                    displayReturnButton: true,
                    right: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                        children: [
                            user?.isSuperAdmin !== true && (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).RAZ_MES_ROP_E) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $4c9f3f4d48e33e9a$export$2e2bcd8739ae039), {
                                    path: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/tournee/raz-mes-rop`,
                                    icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$17f4bb5f559b3806), {}),
                                    disabled: false,
                                    variant: "primary",
                                    className: "p-auto",
                                    classEnable: "white",
                                    textDisable: undefined,
                                    textEnable: "Remettre \xe0 z\xe9ro l'avancement de mes tourn\xe9es de ROP",
                                    tooltipId: "resetTourneeProgress",
                                    isPost: true,
                                    header: "Remettre \xe0 z\xe9ro l'avancement de mes tourn\xe9es ?",
                                    content: "Voulez-vous vraiment remettre \xe0 z\xe9ro les tourn\xe9es ? Cette op\xe9ration effacera leur avancement."
                                })
                            }),
                            (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).TOURNEE_A) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8ad69b89456b65bc$export$2e2bcd8739ae039), {
                                    href: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).CREATE_TOURNEE,
                                    title: "Ajouter une tourn\xe9e"
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
                fluid: true,
                className: "px-5",
                children: //pas besoin de container il est dans le composant QueryTableWithListingPei
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $0e7b0f927316b537$export$2e2bcd8739ae039), {
                    column: column,
                    query: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/tournee`,
                    idName: "TourneeTable",
                    filterPage: (0, $e8a2c985711dfc19$export$2e2bcd8739ae039).TOURNEE,
                    showTable: showTable,
                    filterId: idTournee,
                    //on envoie les constantes au composant enfant pour qu'il mette à jour le composant parent
                    setFilterId: setIdTournee,
                    setShowTable: setShowTable,
                    filterValuesToVariable: filterValuesToVariableWithPei,
                    useFilterContext: (0, $9a9eebc3462fba73$export$396ef541d9951d45)({
                        tourneeLibelle: undefined,
                        tourneeOrganismeLibelle: undefined,
                        tourneeUtilisateurReservationLibelle: undefined,
                        peiId: peiId
                    })
                }, tableKey)
            })
        ]
    });
};
var $32ff803568ba9e09$export$2e2bcd8739ae039 = $32ff803568ba9e09$var$ListTournee;



const $d0b6210124247401$var$QueryTableTournee = ()=>{
    const location = (0, $7a844823b04d4282$export$45d76561a5302f2b)();
    const queryParams = (0, $1a6f6d44ade81356$export$2e2bcd8739ae039)();
    const filterBy = queryParams?.filterBy;
    const peiId = filterBy?.peiId || null;
    const peiNumeroComplet = location.state?.peiNumeroComplet || null;
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: peiId && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $32ff803568ba9e09$export$2e2bcd8739ae039), {
            peiId: peiId,
            peiNumeroComplet: peiNumeroComplet
        })
    });
};
var $d0b6210124247401$export$2e2bcd8739ae039 = $d0b6210124247401$var$QueryTableTournee;




var $kc00y = parcelRequire("kc00y");


var $5d863552eb3c939f$export$397a4e925c2f682d = /*#__PURE__*/ function(DFCI_LISTE_COUCHE) {
    DFCI_LISTE_COUCHE["DFCI_PISTE"] = "DFCI_PISTE";
    DFCI_LISTE_COUCHE["DFCI_AIRE"] = "DFCI_AIRE";
    DFCI_LISTE_COUCHE["DFCI_DEB"] = "DFCI_DEB";
    DFCI_LISTE_COUCHE["DFCI_PANNEAU"] = "DFCI_PANNEAU";
    return DFCI_LISTE_COUCHE;
}({});
const $5d863552eb3c939f$var$referenceDfciListeCouche = [
    {
        code: "DFCI_PISTE",
        libelle: "Piste"
    },
    {
        code: "DFCI_AIRE",
        libelle: "Aire"
    },
    {
        code: "DFCI_DEB",
        libelle: "D\xe9broussaillement"
    },
    {
        code: "DFCI_PANNEAU",
        libelle: "Panneau"
    }
];
var $5d863552eb3c939f$export$2e2bcd8739ae039 = $5d863552eb3c939f$var$referenceDfciListeCouche;
















/**
 * @module ol/control/MousePosition
 */ 

/**
 * @module ol/pointer/EventType
 */ /**
 * Constants for event names.
 * @enum {string}
 */ var $4b8b28c70a4b5328$export$2e2bcd8739ae039 = {
    POINTERMOVE: 'pointermove',
    POINTERDOWN: 'pointerdown',
    POINTERUP: 'pointerup',
    POINTEROVER: 'pointerover',
    POINTEROUT: 'pointerout',
    POINTERENTER: 'pointerenter',
    POINTERLEAVE: 'pointerleave',
    POINTERCANCEL: 'pointercancel'
};



/**
 * @module ol/control/Control
 */ /**
 * @module ol/MapEventType
 */ /**
 * @enum {string}
 */ var $13d83f941f2fce32$export$2e2bcd8739ae039 /***
 * @typedef {'postrender'|'movestart'|'moveend'|'loadstart'|'loadend'} Types
 */  = {
    /**
   * Triggered after a map frame is rendered.
   * @event module:ol/MapEvent~MapEvent#postrender
   * @api
   */ POSTRENDER: 'postrender',
    /**
   * Triggered when the map starts moving.
   * @event module:ol/MapEvent~MapEvent#movestart
   * @api
   */ MOVESTART: 'movestart',
    /**
   * Triggered after the map is moved.
   * @event module:ol/MapEvent~MapEvent#moveend
   * @api
   */ MOVEEND: 'moveend',
    /**
   * Triggered when loading of additional map data (tiles, images, features) starts.
   * @event module:ol/MapEvent~MapEvent#loadstart
   * @api
   */ LOADSTART: 'loadstart',
    /**
   * Triggered when loading of additional map data has completed.
   * @event module:ol/MapEvent~MapEvent#loadend
   * @api
   */ LOADEND: 'loadend'
};





/**
 * @typedef {Object} Options
 * @property {HTMLElement} [element] The element is the control's
 * container element. This only needs to be specified if you're developing
 * a custom control.
 * @property {function(import("../MapEvent.js").default):void} [render] Function called when
 * the control should be re-rendered. This is called in a `requestAnimationFrame`
 * callback.
 * @property {HTMLElement|string} [target] Specify a target if you want
 * the control to be rendered outside of the map's viewport.
 */ /**
 * @classdesc
 * A control is a visible widget with a DOM element in a fixed position on the
 * screen. They can involve user input (buttons), or be informational only;
 * the position is determined using CSS. By default these are placed in the
 * container with CSS class name `ol-overlaycontainer-stopevent`, but can use
 * any outside DOM element.
 *
 * This is the base class for controls. You can use it for simple custom
 * controls by creating the element with listeners, creating an instance:
 * ```js
 * const myControl = new Control({element: myElement});
 * ```
 * and then adding this to the map.
 *
 * The main advantage of having this as a control rather than a simple separate
 * DOM element is that preventing propagation is handled for you. Controls
 * will also be objects in a {@link module:ol/Collection~Collection}, so you can use their methods.
 *
 * You can also extend this base for your own control class. See
 * examples/custom-controls for an example of how to do this.
 *
 * @api
 */ class $18f514e2c8971ae5$var$Control extends (0, $4862cdcc23257f5b$export$2e2bcd8739ae039) {
    /**
   * @param {Options} options Control options.
   */ constructor(options){
        super();
        const element = options.element;
        if (element && !options.target && !element.style.pointerEvents) element.style.pointerEvents = 'auto';
        /**
     * @protected
     * @type {HTMLElement}
     */ this.element = element ? element : null;
        /**
     * @private
     * @type {HTMLElement}
     */ this.target_ = null;
        /**
     * @private
     * @type {import("../Map.js").default|null}
     */ this.map_ = null;
        /**
     * @protected
     * @type {!Array<import("../events.js").EventsKey>}
     */ this.listenerKeys = [];
        if (options.render) this.render = options.render;
        if (options.target) this.setTarget(options.target);
    }
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        this.element?.remove();
        super.disposeInternal();
    }
    /**
   * Get the map associated with this control.
   * @return {import("../Map.js").default|null} Map.
   * @api
   */ getMap() {
        return this.map_;
    }
    /**
   * Remove the control from its current map and attach it to the new map.
   * Pass `null` to just remove the control from the current map.
   * Subclasses may set up event handlers to get notified about changes to
   * the map here.
   * @param {import("../Map.js").default|null} map Map.
   * @api
   */ setMap(map) {
        if (this.map_) this.element?.remove();
        for(let i = 0, ii = this.listenerKeys.length; i < ii; ++i)(0, $63963d09e0c49405$export$b0a21c8b3c1c921)(this.listenerKeys[i]);
        this.listenerKeys.length = 0;
        this.map_ = map;
        if (map) {
            const target = this.target_ ?? map.getOverlayContainerStopEvent();
            if (this.element) target.appendChild(this.element);
            if (this.render !== (0, $bc15bca7780ad95b$export$1cd1943b3a73bbe8)) this.listenerKeys.push((0, $63963d09e0c49405$export$63174c828edd6ff8)(map, (0, $13d83f941f2fce32$export$2e2bcd8739ae039).POSTRENDER, this.render, this));
            map.render();
        }
    }
    /**
   * Renders the control.
   * @param {import("../MapEvent.js").default} mapEvent Map event.
   * @api
   */ render(mapEvent) {}
    /**
   * This function is used to set a target element for the control. It has no
   * effect if it is called after the control has been added to the map (i.e.
   * after `setMap` is called on the control). If no `target` is set in the
   * options passed to the control constructor and if `setTarget` is not called
   * then the control is added to the map's overlay container.
   * @param {HTMLElement|string} target Target.
   * @api
   */ setTarget(target) {
        this.target_ = typeof target === 'string' ? document.getElementById(target) : target;
    }
}
var $18f514e2c8971ae5$export$2e2bcd8739ae039 = $18f514e2c8971ae5$var$Control;


/**
 * @type {string}
 */ const $64a039ea82d24f6b$var$PROJECTION = 'projection';
/**
 * @type {string}
 */ const $64a039ea82d24f6b$var$COORDINATE_FORMAT = 'coordinateFormat';
/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types|
 *     'change:coordinateFormat'|'change:projection', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types|
 *     'change:coordinateFormat'|'change:projection', Return>} MousePositionOnSignature
 */ /**
 * @typedef {Object} Options
 * @property {string} [className='ol-mouse-position'] CSS class name.
 * @property {import("../coordinate.js").CoordinateFormat} [coordinateFormat] Coordinate format.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection. Default is the view projection.
 * @property {function(import("../MapEvent.js").default):void} [render] Function called when the
 * control should be re-rendered. This is called in a `requestAnimationFrame`
 * callback.
 * @property {HTMLElement|string} [target] Specify a target if you want the
 * control to be rendered outside of the map's viewport.
 * @property {string} [placeholder] Markup to show when the mouse position is not
 * available (e.g. when the pointer leaves the map viewport).  By default, a non-breaking space is rendered
 * initially and the last position is retained when the mouse leaves the viewport.
 * When a string is provided (e.g. `'no position'` or `''` for an empty string) it is used as a
 * placeholder.
 * @property {boolean} [wrapX=true] Wrap the world horizontally on the projection's antimeridian, if it
 * is a global projection.
 */ /**
 * @classdesc
 * A control to show the 2D coordinates of the mouse cursor. By default, these
 * are in the view projection, but can be in any supported projection.
 * By default the control is shown in the top right corner of the map, but this
 * can be changed by using the css selector `.ol-mouse-position`.
 *
 * On touch devices, which usually do not have a mouse cursor, the coordinates
 * of the currently touched position are shown.
 *
 * @api
 */ class $64a039ea82d24f6b$var$MousePosition extends (0, $18f514e2c8971ae5$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Mouse position options.
   */ constructor(options){
        options = options ? options : {};
        const element = document.createElement('div');
        element.className = options.className !== undefined ? options.className : 'ol-mouse-position';
        super({
            element: element,
            render: options.render,
            target: options.target
        });
        /***
     * @type {MousePositionOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {MousePositionOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {MousePositionOnSignature<void>}
     */ this.un;
        this.addChangeListener($64a039ea82d24f6b$var$PROJECTION, this.handleProjectionChanged_);
        if (options.coordinateFormat) this.setCoordinateFormat(options.coordinateFormat);
        if (options.projection) this.setProjection(options.projection);
        /**
     * @private
     * @type {boolean}
     */ this.renderOnMouseOut_ = options.placeholder !== undefined;
        /**
     * @private
     * @type {string}
     */ this.placeholder_ = this.renderOnMouseOut_ ? options.placeholder : '&#160;';
        /**
     * @private
     * @type {string}
     */ this.renderedHTML_ = element.innerHTML;
        /**
     * @private
     * @type {?import("../proj/Projection.js").default}
     */ this.mapProjection_ = null;
        /**
     * @private
     * @type {?import("../proj.js").TransformFunction}
     */ this.transform_ = null;
        /**
     * @private
     * @type {boolean}
     */ this.wrapX_ = options.wrapX === false ? false : true;
    }
    /**
   * @private
   */ handleProjectionChanged_() {
        this.transform_ = null;
    }
    /**
   * Return the coordinate format type used to render the current position or
   * undefined.
   * @return {import("../coordinate.js").CoordinateFormat|undefined} The format to render the current
   *     position in.
   * @observable
   * @api
   */ getCoordinateFormat() {
        return /** @type {import("../coordinate.js").CoordinateFormat|undefined} */ this.get($64a039ea82d24f6b$var$COORDINATE_FORMAT);
    }
    /**
   * Return the projection that is used to report the mouse position.
   * @return {import("../proj/Projection.js").default|undefined} The projection to report mouse
   *     position in.
   * @observable
   * @api
   */ getProjection() {
        return /** @type {import("../proj/Projection.js").default|undefined} */ this.get($64a039ea82d24f6b$var$PROJECTION);
    }
    /**
   * @param {MouseEvent} event Browser event.
   * @protected
   */ handleMouseMove(event) {
        const map = this.getMap();
        this.updateHTML_(map.getEventPixel(event));
    }
    /**
   * @param {Event} event Browser event.
   * @protected
   */ handleMouseOut(event) {
        this.updateHTML_(null);
    }
    /**
   * Remove the control from its current map and attach it to the new map.
   * Pass `null` to just remove the control from the current map.
   * Subclasses may set up event handlers to get notified about changes to
   * the map here.
   * @param {import("../Map.js").default|null} map Map.
   * @api
   * @override
   */ setMap(map) {
        super.setMap(map);
        if (map) {
            const viewport = map.getViewport();
            this.listenerKeys.push((0, $63963d09e0c49405$export$63174c828edd6ff8)(viewport, (0, $4b8b28c70a4b5328$export$2e2bcd8739ae039).POINTERMOVE, this.handleMouseMove, this));
            if (this.renderOnMouseOut_) this.listenerKeys.push((0, $63963d09e0c49405$export$63174c828edd6ff8)(viewport, (0, $4b8b28c70a4b5328$export$2e2bcd8739ae039).POINTEROUT, this.handleMouseOut, this));
            this.updateHTML_(null);
        }
    }
    /**
   * Set the coordinate format type used to render the current position.
   * @param {import("../coordinate.js").CoordinateFormat} format The format to render the current
   *     position in.
   * @observable
   * @api
   */ setCoordinateFormat(format) {
        this.set($64a039ea82d24f6b$var$COORDINATE_FORMAT, format);
    }
    /**
   * Set the projection that is used to report the mouse position.
   * @param {import("../proj.js").ProjectionLike} projection The projection to report mouse
   *     position in.
   * @observable
   * @api
   */ setProjection(projection) {
        this.set($64a039ea82d24f6b$var$PROJECTION, (0, $a86eee1c28205a05$export$3988ae62b71be9a3)(projection));
    }
    /**
   * @param {?import("../pixel.js").Pixel} pixel Pixel.
   * @private
   */ updateHTML_(pixel) {
        let html = this.placeholder_;
        if (pixel && this.mapProjection_) {
            if (!this.transform_) {
                const projection = this.getProjection();
                if (projection) this.transform_ = (0, $a86eee1c28205a05$export$e3c4995a701c26a3)(this.mapProjection_, projection);
                else this.transform_ = (0, $a86eee1c28205a05$export$83e8ab53904f8022);
            }
            const map = this.getMap();
            const coordinate = map.getCoordinateFromPixelInternal(pixel);
            if (coordinate) {
                const userProjection = (0, $a86eee1c28205a05$export$3973b77d5f6f2790)();
                if (userProjection) this.transform_ = (0, $a86eee1c28205a05$export$e3c4995a701c26a3)(this.mapProjection_, userProjection);
                this.transform_(coordinate, coordinate);
                if (this.wrapX_) {
                    const projection = userProjection || this.getProjection() || this.mapProjection_;
                    (0, $a6adb03fd2fbc071$export$39a9ce3624977b84)(coordinate, projection);
                }
                const coordinateFormat = this.getCoordinateFormat();
                if (coordinateFormat) html = coordinateFormat(coordinate);
                else html = coordinate.toString();
            }
        }
        if (!this.renderedHTML_ || html !== this.renderedHTML_) {
            this.element.innerHTML = html;
            this.renderedHTML_ = html;
        }
    }
    /**
   * Update the projection. Rendering of the coordinates is done in
   * `handleMouseMove` and `handleMouseUp`.
   * @param {import("../MapEvent.js").default} mapEvent Map event.
   * @override
   */ render(mapEvent) {
        const frameState = mapEvent.frameState;
        if (!frameState) this.mapProjection_ = null;
        else if (this.mapProjection_ != frameState.viewState.projection) {
            this.mapProjection_ = frameState.viewState.projection;
            this.transform_ = null;
        }
    }
}
var $64a039ea82d24f6b$export$2e2bcd8739ae039 = $64a039ea82d24f6b$var$MousePosition;

/**
 * @module ol/control/ScaleLine
 */ /**
 * @module ol/css
 */ /**
 * @typedef {Object} FontParameters
 * @property {string} style Style.
 * @property {string} variant Variant.
 * @property {string} weight Weight.
 * @property {string} size Size.
 * @property {string} lineHeight LineHeight.
 * @property {string} family Family.
 * @property {Array<string>} families Families.
 */ /**
 * The CSS class for hidden feature.
 *
 * @const
 * @type {string}
 */ const $d3be093641aea1c1$export$981241db82723ce2 = 'ol-hidden';
const $d3be093641aea1c1$export$99b49471b0394319 = 'ol-selectable';
const $d3be093641aea1c1$export$1afde3d6e16a7b29 = 'ol-unselectable';
const $d3be093641aea1c1$export$68eede0dd8c6c1da = 'ol-unsupported';
const $d3be093641aea1c1$export$4d4f8be70b656192 = 'ol-control';
const $d3be093641aea1c1$export$e16017ac68d14492 = 'ol-collapsed';
/**
 * From https://stackoverflow.com/questions/10135697/regex-to-parse-any-css-font
 * @type {RegExp}
 */ const $d3be093641aea1c1$var$fontRegEx = new RegExp([
    '^\\s*(?=(?:(?:[-a-z]+\\s*){0,2}(italic|oblique))?)',
    '(?=(?:(?:[-a-z]+\\s*){0,2}(small-caps))?)',
    '(?=(?:(?:[-a-z]+\\s*){0,2}(bold(?:er)?|lighter|[1-9]00 ))?)',
    '(?:(?:normal|\\1|\\2|\\3)\\s*){0,3}((?:xx?-)?',
    '(?:small|large)|medium|smaller|larger|[\\.\\d]+(?:\\%|in|[cem]m|ex|p[ctx]))',
    '(?:\\s*\\/\\s*(normal|[\\.\\d]+(?:\\%|in|[cem]m|ex|p[ctx])?))',
    '?\\s*([-,\\"\\\'\\sa-z0-9]+?)\\s*$'
].join(''), 'i');
/** @type {Array<'style'|'variant'|'weight'|'size'|'lineHeight'|'family'>} */ const $d3be093641aea1c1$var$fontRegExMatchIndex = [
    'style',
    'variant',
    'weight',
    'size',
    'lineHeight',
    'family'
];
const $d3be093641aea1c1$export$59230918eb9bd861 = {
    normal: 400,
    bold: 700
};
const $d3be093641aea1c1$export$5abde8a6aec4a131 = function(fontSpec) {
    const match = fontSpec.match($d3be093641aea1c1$var$fontRegEx);
    if (!match) return null;
    const style = /** @type {FontParameters} */ {
        lineHeight: 'normal',
        size: '1.2em',
        style: 'normal',
        weight: '400',
        variant: 'normal'
    };
    for(let i = 0, ii = $d3be093641aea1c1$var$fontRegExMatchIndex.length; i < ii; ++i){
        const value = match[i + 1];
        if (value !== undefined) style[$d3be093641aea1c1$var$fontRegExMatchIndex[i]] = typeof value === 'string' ? value.trim() : value;
    }
    if (isNaN(Number(style.weight)) && style.weight in $d3be093641aea1c1$export$59230918eb9bd861) style.weight = $d3be093641aea1c1$export$59230918eb9bd861[style.weight];
    style.families = style.family.split(/,\s?/).map((f)=>f.trim().replace(/^['"]|['"]$/g, ''));
    return style;
};




/**
 * @type {string}
 */ const $126e6859554e1a5d$var$UNITS_PROP = 'units';
/**
 * @typedef {'degrees' | 'imperial' | 'nautical' | 'metric' | 'us'} Units
 * Units for the scale line.
 */ /**
 * @const
 * @type {Array<number>}
 */ const $126e6859554e1a5d$var$LEADING_DIGITS = [
    1,
    2,
    5
];
/**
 * @const
 * @type {number}
 */ const $126e6859554e1a5d$var$DEFAULT_DPI = 25.4 / 0.28;
/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types|
 *     'change:units', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types
 *     |'change:units', Return>} ScaleLineOnSignature
 */ /**
 * @typedef {Object} Options
 * @property {string} [className] CSS class name. The default is `ol-scale-bar` when configured with
 * `bar: true`. Otherwise the default is `ol-scale-line`.
 * @property {number} [minWidth=64] Minimum width in pixels at the OGC default dpi. The width will be
 * adjusted to match the dpi used.
 * @property {number} [maxWidth] Maximum width in pixels at the OGC default dpi. The width will be
 * adjusted to match the dpi used.
 * @property {function(import("../MapEvent.js").default):void} [render] Function called when the control
 * should be re-rendered. This is called in a `requestAnimationFrame` callback.
 * @property {HTMLElement|string} [target] Specify a target if you want the control
 * to be rendered outside of the map's viewport.
 * @property {Units} [units='metric'] Units.
 * @property {boolean} [bar=false] Render scalebars instead of a line.
 * @property {number} [steps=4] Number of steps the scalebar should use. Use even numbers
 * for best results. Only applies when `bar` is `true`.
 * @property {boolean} [text=false] Render the text scale above of the scalebar. Only applies
 * when `bar` is `true`.
 * @property {number|undefined} [dpi=undefined] dpi of output device such as printer. Only applies
 * when `bar` is `true`. If undefined the OGC default screen pixel size of 0.28mm will be assumed.
 */ /**
 * @classdesc
 * A control displaying rough y-axis distances, calculated for the center of the
 * viewport. For conformal projections (e.g. EPSG:3857, the default view
 * projection in OpenLayers), the scale is valid for all directions.
 * No scale line will be shown when the y-axis distance of a pixel at the
 * viewport center cannot be calculated in the view projection.
 * By default the scale line will show in the bottom left portion of the map,
 * but this can be changed by using the css selector `.ol-scale-line`.
 * When specifying `bar` as `true`, a scalebar will be rendered instead
 * of a scaleline.
 * For cartesian measurements of the scaleline, you need to set the
 * `getPointResolution` method of your projection to simply return the input
 * value, e.g. `projection.setGetPointResolution(r => r);`
 *
 * @api
 */ class $126e6859554e1a5d$var$ScaleLine extends (0, $18f514e2c8971ae5$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Scale line options.
   */ constructor(options){
        options = options ? options : {};
        const element = document.createElement('div');
        element.style.pointerEvents = 'none';
        super({
            element: element,
            render: options.render,
            target: options.target
        });
        /***
     * @type {ScaleLineOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {ScaleLineOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {ScaleLineOnSignature<void>}
     */ this.un;
        const className = options.className !== undefined ? options.className : options.bar ? 'ol-scale-bar' : 'ol-scale-line';
        /**
     * @private
     * @type {HTMLElement}
     */ this.innerElement_ = document.createElement('div');
        this.innerElement_.className = className + '-inner';
        this.element.className = className + ' ' + (0, $d3be093641aea1c1$export$1afde3d6e16a7b29);
        this.element.appendChild(this.innerElement_);
        /**
     * @private
     * @type {?import("../View.js").State}
     */ this.viewState_ = null;
        /**
     * @private
     * @type {number}
     */ this.minWidth_ = options.minWidth !== undefined ? options.minWidth : 64;
        /**
     * @private
     * @type {number|undefined}
     */ this.maxWidth_ = options.maxWidth;
        /**
     * @private
     * @type {boolean}
     */ this.renderedVisible_ = false;
        /**
     * @private
     * @type {number|undefined}
     */ this.renderedWidth_ = undefined;
        /**
     * @private
     * @type {string}
     */ this.renderedHTML_ = '';
        this.addChangeListener($126e6859554e1a5d$var$UNITS_PROP, this.handleUnitsChanged_);
        this.setUnits(options.units || 'metric');
        /**
     * @private
     * @type {boolean}
     */ this.scaleBar_ = options.bar || false;
        /**
     * @private
     * @type {number}
     */ this.scaleBarSteps_ = options.steps || 4;
        /**
     * @private
     * @type {boolean}
     */ this.scaleBarText_ = options.text || false;
        /**
     * @private
     * @type {number|undefined}
     */ this.dpi_ = options.dpi || undefined;
    }
    /**
   * Return the units to use in the scale line.
   * @return {Units} The units
   * to use in the scale line.
   * @observable
   * @api
   */ getUnits() {
        return this.get($126e6859554e1a5d$var$UNITS_PROP);
    }
    /**
   * @private
   */ handleUnitsChanged_() {
        this.updateElement_();
    }
    /**
   * Set the units to use in the scale line.
   * @param {Units} units The units to use in the scale line.
   * @observable
   * @api
   */ setUnits(units) {
        this.set($126e6859554e1a5d$var$UNITS_PROP, units);
    }
    /**
   * Specify the dpi of output device such as printer.
   * @param {number|undefined} dpi The dpi of output device.
   * @api
   */ setDpi(dpi) {
        this.dpi_ = dpi;
    }
    /**
   * @private
   */ updateElement_() {
        const viewState = this.viewState_;
        if (!viewState) {
            if (this.renderedVisible_) {
                this.element.style.display = 'none';
                this.renderedVisible_ = false;
            }
            return;
        }
        const center = viewState.center;
        const projection = viewState.projection;
        const units = this.getUnits();
        const pointResolutionUnits = units == 'degrees' ? 'degrees' : 'm';
        let pointResolution = (0, $a86eee1c28205a05$export$2d8f7b4eec383d44)(projection, viewState.resolution, center, pointResolutionUnits);
        const minWidth = this.minWidth_ * (this.dpi_ || $126e6859554e1a5d$var$DEFAULT_DPI) / $126e6859554e1a5d$var$DEFAULT_DPI;
        const maxWidth = this.maxWidth_ !== undefined ? this.maxWidth_ * (this.dpi_ || $126e6859554e1a5d$var$DEFAULT_DPI) / $126e6859554e1a5d$var$DEFAULT_DPI : undefined;
        let nominalCount = minWidth * pointResolution;
        let suffix = '';
        if (units == 'degrees') {
            const metersPerDegree = (0, $9149a5943443441b$export$1482081eec883108).degrees;
            nominalCount *= metersPerDegree;
            if (nominalCount < metersPerDegree / 60) {
                suffix = '\u2033'; // seconds
                pointResolution *= 3600;
            } else if (nominalCount < metersPerDegree) {
                suffix = '\u2032'; // minutes
                pointResolution *= 60;
            } else suffix = '\u00b0'; // degrees
        } else if (units == 'imperial') {
            if (nominalCount < 0.9144) {
                suffix = 'in';
                pointResolution /= 0.0254;
            } else if (nominalCount < 1609.344) {
                suffix = 'ft';
                pointResolution /= 0.3048;
            } else {
                suffix = 'mi';
                pointResolution /= 1609.344;
            }
        } else if (units == 'nautical') {
            pointResolution /= 1852;
            suffix = 'NM';
        } else if (units == 'metric') {
            if (nominalCount < 1e-6) {
                suffix = 'nm';
                pointResolution *= 1e9;
            } else if (nominalCount < 0.001) {
                suffix = "\u03BCm";
                pointResolution *= 1000000;
            } else if (nominalCount < 1) {
                suffix = 'mm';
                pointResolution *= 1000;
            } else if (nominalCount < 1000) suffix = 'm';
            else {
                suffix = 'km';
                pointResolution /= 1000;
            }
        } else if (units == 'us') {
            if (nominalCount < 0.9144) {
                suffix = 'in';
                pointResolution *= 39.37;
            } else if (nominalCount < 1609.344) {
                suffix = 'ft';
                pointResolution /= 0.30480061;
            } else {
                suffix = 'mi';
                pointResolution /= 1609.3472;
            }
        } else throw new Error('Invalid units');
        let i = 3 * Math.floor(Math.log(minWidth * pointResolution) / Math.log(10));
        let count, width, decimalCount;
        let previousCount = 0;
        let previousWidth, previousDecimalCount;
        while(true){
            decimalCount = Math.floor(i / 3);
            const decimal = Math.pow(10, decimalCount);
            count = $126e6859554e1a5d$var$LEADING_DIGITS[(i % 3 + 3) % 3] * decimal;
            width = Math.round(count / pointResolution);
            if (isNaN(width)) {
                this.element.style.display = 'none';
                this.renderedVisible_ = false;
                return;
            }
            if (maxWidth !== undefined && width >= maxWidth) {
                count = previousCount;
                width = previousWidth;
                decimalCount = previousDecimalCount;
                break;
            } else if (width >= minWidth) break;
            previousCount = count;
            previousWidth = width;
            previousDecimalCount = decimalCount;
            ++i;
        }
        const html = this.scaleBar_ ? this.createScaleBar(width, count, suffix) : count.toFixed(decimalCount < 0 ? -decimalCount : 0) + ' ' + suffix;
        if (this.renderedHTML_ != html) {
            this.innerElement_.innerHTML = html;
            this.renderedHTML_ = html;
        }
        if (this.renderedWidth_ != width) {
            this.innerElement_.style.width = width + 'px';
            this.renderedWidth_ = width;
        }
        if (!this.renderedVisible_) {
            this.element.style.display = '';
            this.renderedVisible_ = true;
        }
    }
    /**
   * @private
   * @param {number} width The current width of the scalebar.
   * @param {number} scale The current scale.
   * @param {string} suffix The suffix to append to the scale text.
   * @return {string} The stringified HTML of the scalebar.
   */ createScaleBar(width, scale, suffix) {
        const resolutionScale = this.getScaleForResolution();
        const mapScale = resolutionScale < 1 ? Math.round(1 / resolutionScale).toLocaleString() + ' : 1' : '1 : ' + Math.round(resolutionScale).toLocaleString();
        const steps = this.scaleBarSteps_;
        const stepWidth = width / steps;
        const scaleSteps = [
            this.createMarker('absolute')
        ];
        for(let i = 0; i < steps; ++i){
            const cls = i % 2 === 0 ? 'ol-scale-singlebar-odd' : 'ol-scale-singlebar-even';
            scaleSteps.push("<div><div " + `class="ol-scale-singlebar ${cls}" ` + `style="width: ${stepWidth}px;"` + '>' + '</div>' + this.createMarker('relative') + // render text every second step, except when only 2 steps
            (i % 2 === 0 || steps === 2 ? this.createStepText(i, width, false, scale, suffix) : '') + '</div>');
        }
        // render text at the end
        scaleSteps.push(this.createStepText(steps, width, true, scale, suffix));
        const scaleBarText = this.scaleBarText_ ? `<div class="ol-scale-text" style="width: ${width}px;">` + mapScale + '</div>' : '';
        return scaleBarText + scaleSteps.join('');
    }
    /**
   * Creates a marker at given position
   * @param {'absolute'|'relative'} position The position, absolute or relative
   * @return {string} The stringified div containing the marker
   */ createMarker(position) {
        const top = position === 'absolute' ? 3 : -10;
        return '<div class="ol-scale-step-marker" ' + `style="position: ${position}; top: ${top}px;"` + '></div>';
    }
    /**
   * Creates the label for a marker marker at given position
   * @param {number} i The iterator
   * @param {number} width The width the scalebar will currently use
   * @param {boolean} isLast Flag indicating if we add the last step text
   * @param {number} scale The current scale for the whole scalebar
   * @param {string} suffix The suffix for the scale
   * @return {string} The stringified div containing the step text
   */ createStepText(i, width, isLast, scale, suffix) {
        const length = i === 0 ? 0 : Math.round(scale / this.scaleBarSteps_ * i * 100) / 100;
        const lengthString = length + (i === 0 ? '' : ' ' + suffix);
        const margin = i === 0 ? -3 : width / this.scaleBarSteps_ * -1;
        const minWidth = i === 0 ? 0 : width / this.scaleBarSteps_ * 2;
        return '<div class="ol-scale-step-text" style="' + `margin-left: ${margin}px;` + `text-align: ${i === 0 ? 'left' : 'center'};` + `min-width: ${minWidth}px;` + `left: ${isLast ? width + 'px' : 'unset'};` + '">' + lengthString + '</div>';
    }
    /**
   * Returns the appropriate scale for the given resolution and units.
   * @return {number} The appropriate scale.
   */ getScaleForResolution() {
        const resolution = (0, $a86eee1c28205a05$export$2d8f7b4eec383d44)(this.viewState_.projection, this.viewState_.resolution, this.viewState_.center, 'm');
        const dpi = this.dpi_ || $126e6859554e1a5d$var$DEFAULT_DPI;
        const inchesPerMeter = 1000 / 25.4;
        return resolution * inchesPerMeter * dpi;
    }
    /**
   * Update the scale line element.
   * @param {import("../MapEvent.js").default} mapEvent Map event.
   * @override
   */ render(mapEvent) {
        const frameState = mapEvent.frameState;
        if (!frameState) this.viewState_ = null;
        else this.viewState_ = frameState.viewState;
        this.updateElement_();
    }
}
var $126e6859554e1a5d$export$2e2bcd8739ae039 = $126e6859554e1a5d$var$ScaleLine;


/**
 * @module ol/control/defaults
 */ /**
 * @module ol/Collection
 */ /**
 * @module ol/CollectionEventType
 */ /**
 * @enum {string}
 */ var $ea71ddfe3b669b23$export$2e2bcd8739ae039 = {
    /**
   * Triggered when an item is added to the collection.
   * @event module:ol/Collection.CollectionEvent#add
   * @api
   */ ADD: 'add',
    /**
   * Triggered when an item is removed from the collection.
   * @event module:ol/Collection.CollectionEvent#remove
   * @api
   */ REMOVE: 'remove'
};




/**
 * @enum {string}
 * @private
 */ const $e1f99232eb9bff27$var$Property = {
    LENGTH: 'length'
};
class $e1f99232eb9bff27$export$a87ae6eb2761ec6d extends (0, $5c6b0a43c077a98f$export$2e2bcd8739ae039) {
    /**
   * @param {import("./CollectionEventType.js").default} type Type.
   * @param {T} element Element.
   * @param {number} index The index of the added or removed element.
   */ constructor(type, element, index){
        super(type);
        /**
     * The element that is added to or removed from the collection.
     * @type {T}
     * @api
     */ this.element = element;
        /**
     * The index of the added or removed element.
     * @type {number}
     * @api
     */ this.index = index;
    }
}
/***
 * @template T
 * @template Return
 * @typedef {import("./Observable").OnSignature<import("./Observable").EventTypes, import("./events/Event.js").default, Return> &
 *   import("./Observable").OnSignature<import("./ObjectEventType").Types|'change:length', import("./Object").ObjectEvent, Return> &
 *   import("./Observable").OnSignature<'add'|'remove', CollectionEvent<T>, Return> &
 *   import("./Observable").CombinedOnSignature<import("./Observable").EventTypes|import("./ObjectEventType").Types|
 *     'change:length'|'add'|'remove',Return>} CollectionOnSignature
 */ /**
 * @typedef {Object} Options
 * @property {boolean} [unique=false] Disallow the same item from being added to
 * the collection twice.
 */ /**
 * @classdesc
 * An expanded version of standard JS Array, adding convenience methods for
 * manipulation. Add and remove changes to the Collection trigger a Collection
 * event. Note that this does not cover changes to the objects _within_ the
 * Collection; they trigger events on the appropriate object, not on the
 * Collection as a whole.
 *
 * @fires CollectionEvent
 *
 * @template T
 * @api
 */ class $e1f99232eb9bff27$var$Collection extends (0, $4862cdcc23257f5b$export$2e2bcd8739ae039) {
    /**
   * @param {Array<T>} [array] Array.
   * @param {Options} [options] Collection options.
   */ constructor(array, options){
        super();
        /***
     * @type {CollectionOnSignature<T, import("./events").EventsKey>}
     */ this.on;
        /***
     * @type {CollectionOnSignature<T, import("./events").EventsKey>}
     */ this.once;
        /***
     * @type {CollectionOnSignature<T, void>}
     */ this.un;
        options = options || {};
        /**
     * @private
     * @type {boolean}
     */ this.unique_ = !!options.unique;
        /**
     * @private
     * @type {!Array<T>}
     */ this.array_ = array ?? [];
        if (this.unique_) for(let i = 1, ii = this.array_.length; i < ii; ++i)this.assertUnique_(this.array_[i], i);
        this.updateLength_();
    }
    /**
   * Remove all elements from the collection.
   * @api
   */ clear() {
        while(this.getLength() > 0)this.pop();
    }
    /**
   * Add elements to the collection.  This pushes each item in the provided array
   * to the end of the collection.
   * @param {!Array<T>} arr Array.
   * @return {Collection<T>} This collection.
   * @api
   */ extend(arr) {
        for(let i = 0, ii = arr.length; i < ii; ++i)this.push(arr[i]);
        return this;
    }
    /**
   * Iterate over each element, calling the provided callback.
   * @param {function(T, number, Array<T>): *} f The function to call
   *     for every element. This function takes 3 arguments (the element, the
   *     index and the array). The return value is ignored.
   * @api
   */ forEach(f) {
        const array = this.array_;
        for(let i = 0, ii = array.length; i < ii; ++i)f(array[i], i, array);
    }
    /**
   * Get a reference to the underlying Array object. Warning: if the array
   * is mutated, no events will be dispatched by the collection, and the
   * collection's "length" property won't be in sync with the actual length
   * of the array.
   * @return {!Array<T>} Array.
   * @api
   */ getArray() {
        return this.array_;
    }
    /**
   * Get the element at the provided index.
   * @param {number} index Index.
   * @return {T} Element.
   * @api
   */ item(index) {
        return this.array_[index];
    }
    /**
   * Get the length of this collection.
   * @return {number} The length of the array.
   * @observable
   * @api
   */ getLength() {
        return this.get($e1f99232eb9bff27$var$Property.LENGTH);
    }
    /**
   * Insert an element at the provided index.
   * @param {number} index Index.
   * @param {T} elem Element.
   * @api
   */ insertAt(index, elem) {
        if (index < 0 || index > this.getLength()) throw new Error('Index out of bounds: ' + index);
        if (this.unique_) this.assertUnique_(elem);
        this.array_.splice(index, 0, elem);
        this.updateLength_();
        this.dispatchEvent(new $e1f99232eb9bff27$export$a87ae6eb2761ec6d((0, $ea71ddfe3b669b23$export$2e2bcd8739ae039).ADD, elem, index));
    }
    /**
   * Remove the last element of the collection and return it.
   * Return `undefined` if the collection is empty.
   * @return {T|undefined} Element.
   * @api
   */ pop() {
        return this.removeAt(this.getLength() - 1);
    }
    /**
   * Insert the provided element at the end of the collection.
   * @param {T} elem Element.
   * @return {number} New length of the collection.
   * @api
   */ push(elem) {
        const n = this.getLength();
        this.insertAt(n, elem);
        return this.getLength();
    }
    /**
   * Remove the first occurrence of an element from the collection.
   * @param {T} elem Element.
   * @return {T|undefined} The removed element or undefined if none found.
   * @api
   */ remove(elem) {
        const arr = this.array_;
        for(let i = 0, ii = arr.length; i < ii; ++i){
            if (arr[i] === elem) return this.removeAt(i);
        }
        return undefined;
    }
    /**
   * Remove the element at the provided index and return it.
   * Return `undefined` if the collection does not contain this index.
   * @param {number} index Index.
   * @return {T|undefined} Value.
   * @api
   */ removeAt(index) {
        if (index < 0 || index >= this.getLength()) return undefined;
        const prev = this.array_[index];
        this.array_.splice(index, 1);
        this.updateLength_();
        this.dispatchEvent(/** @type {CollectionEvent<T>} */ new $e1f99232eb9bff27$export$a87ae6eb2761ec6d((0, $ea71ddfe3b669b23$export$2e2bcd8739ae039).REMOVE, prev, index));
        return prev;
    }
    /**
   * Set the element at the provided index.
   * @param {number} index Index.
   * @param {T} elem Element.
   * @api
   */ setAt(index, elem) {
        const n = this.getLength();
        if (index >= n) {
            this.insertAt(index, elem);
            return;
        }
        if (index < 0) throw new Error('Index out of bounds: ' + index);
        if (this.unique_) this.assertUnique_(elem, index);
        const prev = this.array_[index];
        this.array_[index] = elem;
        this.dispatchEvent(/** @type {CollectionEvent<T>} */ new $e1f99232eb9bff27$export$a87ae6eb2761ec6d((0, $ea71ddfe3b669b23$export$2e2bcd8739ae039).REMOVE, prev, index));
        this.dispatchEvent(/** @type {CollectionEvent<T>} */ new $e1f99232eb9bff27$export$a87ae6eb2761ec6d((0, $ea71ddfe3b669b23$export$2e2bcd8739ae039).ADD, elem, index));
    }
    /**
   * @private
   */ updateLength_() {
        this.set($e1f99232eb9bff27$var$Property.LENGTH, this.array_.length);
    }
    /**
   * @private
   * @param {T} elem Element.
   * @param {number} [except] Optional index to ignore.
   */ assertUnique_(elem, except) {
        const array = this.array_;
        for(let i = 0, ii = array.length; i < ii; ++i){
            if (array[i] === elem && i !== except) throw new Error('Duplicate item added to a unique collection');
        }
    }
}
var $e1f99232eb9bff27$export$2e2bcd8739ae039 = $e1f99232eb9bff27$var$Collection;


/**
 * @module ol/control/Attribution
 */ 

/**
 * @module ol/has
 */ const $32d41268b5f53567$var$ua = typeof navigator !== 'undefined' && typeof navigator.userAgent !== 'undefined' ? navigator.userAgent.toLowerCase() : '';
const $32d41268b5f53567$export$3227bfbdaa9275de = $32d41268b5f53567$var$ua.includes('safari') && !$32d41268b5f53567$var$ua.includes('chrom');
const $32d41268b5f53567$export$b23eed0e325a206a = $32d41268b5f53567$export$3227bfbdaa9275de && ($32d41268b5f53567$var$ua.includes('version/15.4') || /cpu (os|iphone os) 15_4 like mac os x/.test($32d41268b5f53567$var$ua));
const $32d41268b5f53567$export$39dfd62a25e0fe93 = $32d41268b5f53567$var$ua.includes('webkit') && !$32d41268b5f53567$var$ua.includes('edge');
const $32d41268b5f53567$export$76c0a3b101d93136 = $32d41268b5f53567$var$ua.includes('macintosh');
const $32d41268b5f53567$export$6b83a0446fc26f94 = typeof devicePixelRatio !== 'undefined' ? devicePixelRatio : 1;
const $32d41268b5f53567$export$98fcef3dc9973292 = typeof WorkerGlobalScope !== 'undefined' && typeof OffscreenCanvas !== 'undefined' && self instanceof WorkerGlobalScope; //eslint-disable-line
const $32d41268b5f53567$export$716f8695eedb9bad = typeof Image !== 'undefined' && Image.prototype.decode;
const $32d41268b5f53567$export$7478563940788376 = typeof createImageBitmap === 'function';
const $32d41268b5f53567$export$f751ce96c6c4e4fc = function() {
    let passive = false;
    try {
        const options = Object.defineProperty({}, 'passive', {
            get: function() {
                passive = true;
            }
        });
        // @ts-ignore Ignore invalid event type '_'
        window.addEventListener('_', null, options);
        // @ts-ignore Ignore invalid event type '_'
        window.removeEventListener('_', null, options);
    } catch  {
    // passive not supported
    }
    return passive;
}();


function $b6f6d442e8ff57e1$export$9e05d10eae75c464(width, height, canvasPool, settings) {
    /** @type {HTMLCanvasElement|OffscreenCanvas} */ let canvas;
    if (canvasPool && canvasPool.length) canvas = /** @type {HTMLCanvasElement} */ canvasPool.shift();
    else if (0, $32d41268b5f53567$export$98fcef3dc9973292) canvas = new class extends OffscreenCanvas {
        style = {};
    }(width ?? 300, height ?? 150);
    else canvas = document.createElement('canvas');
    if (width) canvas.width = width;
    if (height) canvas.height = height;
    return /** @type {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} */ canvas.getContext('2d', settings);
}
/**
 * @type {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D}
 */ let $b6f6d442e8ff57e1$var$sharedCanvasContext;
function $b6f6d442e8ff57e1$export$fcb72ce088a6632c() {
    if (!$b6f6d442e8ff57e1$var$sharedCanvasContext) $b6f6d442e8ff57e1$var$sharedCanvasContext = $b6f6d442e8ff57e1$export$9e05d10eae75c464(1, 1);
    return $b6f6d442e8ff57e1$var$sharedCanvasContext;
}
function $b6f6d442e8ff57e1$export$e918ac6a1026a12a(context) {
    const canvas = context.canvas;
    canvas.width = 1;
    canvas.height = 1;
    context.clearRect(0, 0, 1, 1);
}
function $b6f6d442e8ff57e1$export$e823f88e4111159a(element) {
    let width = element.offsetWidth;
    const style = getComputedStyle(element);
    width += parseInt(style.marginLeft, 10) + parseInt(style.marginRight, 10);
    return width;
}
function $b6f6d442e8ff57e1$export$fc5b8aac72846d1e(element) {
    let height = element.offsetHeight;
    const style = getComputedStyle(element);
    height += parseInt(style.marginTop, 10) + parseInt(style.marginBottom, 10);
    return height;
}
function $b6f6d442e8ff57e1$export$5542201de9311ab2(newNode, oldNode) {
    const parent = oldNode.parentNode;
    if (parent) parent.replaceChild(newNode, oldNode);
}
function $b6f6d442e8ff57e1$export$1e1c9bf5a4ffe0d1(node) {
    while(node.lastChild)node.lastChild.remove();
}
function $b6f6d442e8ff57e1$export$caeacfe04f52533a(node, children) {
    const oldChildren = node.childNodes;
    for(let i = 0;; ++i){
        const oldChild = oldChildren[i];
        const newChild = children[i];
        // check if our work is done
        if (!oldChild && !newChild) break;
        // check if children match
        if (oldChild === newChild) continue;
        // check if a new child needs to be added
        if (!oldChild) {
            node.appendChild(newChild);
            continue;
        }
        // check if an old child needs to be removed
        if (!newChild) {
            node.removeChild(oldChild);
            --i;
            continue;
        }
        // reorder
        node.insertBefore(newChild, oldChild);
    }
}
function $b6f6d442e8ff57e1$export$45b7f73d625b5cde() {
    const mockedDiv = new Proxy({
        /**
       * @type {Array<HTMLElement>}
       */ childNodes: [],
        /**
       * @param {HTMLElement} node html node.
       * @return {HTMLElement} html node.
       */ appendChild: function(node) {
            this.childNodes.push(node);
            return node;
        },
        /**
       * dummy function, as this structure is not supposed to have a parent.
       */ remove: function() {},
        /**
       * @param {HTMLElement} node html node.
       * @return {HTMLElement} html node.
       */ removeChild: function(node) {
            const index = this.childNodes.indexOf(node);
            if (index === -1) throw new Error('Node to remove was not found');
            this.childNodes.splice(index, 1);
            return node;
        },
        /**
       * @param {HTMLElement} newNode new html node.
       * @param {HTMLElement} referenceNode reference html node.
       * @return {HTMLElement} new html node.
       */ insertBefore: function(newNode, referenceNode) {
            const index = this.childNodes.indexOf(referenceNode);
            if (index === -1) throw new Error('Reference node not found');
            this.childNodes.splice(index, 0, newNode);
            return newNode;
        },
        style: {}
    }, {
        get (target, prop, receiver) {
            if (prop === 'firstElementChild') return target.childNodes.length > 0 ? target.childNodes[0] : null;
            return Reflect.get(target, prop, receiver);
        }
    });
    return /** @type {*} */ mockedDiv;
}
function $b6f6d442e8ff57e1$export$4b05d74c82e4c4d2(obj) {
    return typeof HTMLCanvasElement !== 'undefined' && obj instanceof HTMLCanvasElement || typeof OffscreenCanvas !== 'undefined' && obj instanceof OffscreenCanvas;
}





/**
 * @typedef {Object} Options
 * @property {string} [className='ol-attribution'] CSS class name.
 * @property {HTMLElement|string} [target] Specify a target if you
 * want the control to be rendered outside of the map's
 * viewport.
 * @property {boolean} [collapsible] Specify if attributions can
 * be collapsed. If not specified, sources control this behavior with their
 * `attributionsCollapsible` setting.
 * @property {boolean} [collapsed=true] Specify if attributions should
 * be collapsed at startup.
 * @property {string} [tipLabel='Attributions'] Text label to use for the button tip.
 * @property {string|HTMLElement} [label='i'] Text label to use for the
 * collapsed attributions button.
 * Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string} [expandClassName=className + '-expand'] CSS class name for the
 * collapsed attributions button.
 * @property {string|HTMLElement} [collapseLabel='›'] Text label to use
 * for the expanded attributions button.
 * Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string} [collapseClassName=className + '-collapse'] CSS class name for the
 * expanded attributions button.
 * @property {function(import("../MapEvent.js").default):void} [render] Function called when
 * the control should be re-rendered. This is called in a `requestAnimationFrame`
 * callback.
 * @property {string|Array<string>|undefined} [attributions] Optional attribution(s) that will always be
 * displayed regardless of the layers rendered.
 * **Caution:** Attributions are rendered dynamically using `innerHTML`, which can lead to potential
 * [**XSS (Cross-Site Scripting)**](https://en.wikipedia.org/wiki/Cross-site_scripting) vulnerabilities.
 * Use this feature only for trusted content
 * or ensure that the content is properly sanitized before inserting it.
 */ /**
 * @classdesc
 * Control to show all the attributions associated with the layer sources
 * in the map. This control is one of the default controls included in maps.
 * By default it will show in the bottom right portion of the map, but this can
 * be changed by using a css selector for `.ol-attribution`.
 *
 * @api
 */ class $f5077c1b2c2515ec$var$Attribution extends (0, $18f514e2c8971ae5$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Attribution options.
   */ constructor(options){
        options = options ? options : {};
        super({
            element: document.createElement('div'),
            render: options.render,
            target: options.target
        });
        /**
     * @private
     * @type {HTMLElement}
     */ this.ulElement_ = document.createElement('ul');
        /**
     * @private
     * @type {boolean}
     */ this.collapsed_ = options.collapsed !== undefined ? options.collapsed : true;
        /**
     * @private
     * @type {boolean}
     */ this.userCollapsed_ = this.collapsed_;
        /**
     * @private
     * @type {boolean}
     */ this.overrideCollapsible_ = options.collapsible !== undefined;
        /**
     * @private
     * @type {boolean}
     */ this.collapsible_ = options.collapsible !== undefined ? options.collapsible : true;
        if (!this.collapsible_) this.collapsed_ = false;
        /**
     * @private
     * @type {string | Array<string> | undefined}
     */ this.attributions_ = options.attributions;
        const className = options.className !== undefined ? options.className : 'ol-attribution';
        const tipLabel = options.tipLabel !== undefined ? options.tipLabel : 'Attributions';
        const expandClassName = options.expandClassName !== undefined ? options.expandClassName : className + '-expand';
        const collapseLabel = options.collapseLabel !== undefined ? options.collapseLabel : '\u203A';
        const collapseClassName = options.collapseClassName !== undefined ? options.collapseClassName : className + '-collapse';
        if (typeof collapseLabel === 'string') {
            /**
       * @private
       * @type {HTMLElement}
       */ this.collapseLabel_ = document.createElement('span');
            this.collapseLabel_.textContent = collapseLabel;
            this.collapseLabel_.className = collapseClassName;
        } else this.collapseLabel_ = collapseLabel;
        const label = options.label !== undefined ? options.label : 'i';
        if (typeof label === 'string') {
            /**
       * @private
       * @type {HTMLElement}
       */ this.label_ = document.createElement('span');
            this.label_.textContent = label;
            this.label_.className = expandClassName;
        } else this.label_ = label;
        const activeLabel = this.collapsible_ && !this.collapsed_ ? this.collapseLabel_ : this.label_;
        /**
     * @private
     * @type {HTMLElement}
     */ this.toggleButton_ = document.createElement('button');
        this.toggleButton_.setAttribute('type', 'button');
        this.toggleButton_.setAttribute('aria-expanded', String(!this.collapsed_));
        this.toggleButton_.title = tipLabel;
        this.toggleButton_.appendChild(activeLabel);
        this.toggleButton_.addEventListener((0, $b5fa963342da4935$export$2e2bcd8739ae039).CLICK, this.handleClick_.bind(this), false);
        const cssClasses = className + ' ' + (0, $d3be093641aea1c1$export$1afde3d6e16a7b29) + ' ' + (0, $d3be093641aea1c1$export$4d4f8be70b656192) + (this.collapsed_ && this.collapsible_ ? ' ' + (0, $d3be093641aea1c1$export$e16017ac68d14492) : '') + (this.collapsible_ ? '' : ' ol-uncollapsible');
        const element = this.element;
        element.className = cssClasses;
        element.appendChild(this.toggleButton_);
        element.appendChild(this.ulElement_);
        /**
     * A list of currently rendered resolutions.
     * @type {Array<string>}
     * @private
     */ this.renderedAttributions_ = [];
        /**
     * @private
     * @type {boolean}
     */ this.renderedVisible_ = true;
    }
    /**
   * Collect a list of visible attributions and set the collapsible state.
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @return {Array<string>} Attributions.
   * @private
   */ collectSourceAttributions_(frameState) {
        const layers = this.getMap().getAllLayers();
        const visibleAttributions = new Set(layers.flatMap((layer)=>layer.getAttributions(frameState)));
        if (this.attributions_ !== undefined) Array.isArray(this.attributions_) ? this.attributions_.forEach((item)=>visibleAttributions.add(item)) : visibleAttributions.add(this.attributions_);
        if (!this.overrideCollapsible_) {
            const collapsible = !layers.some((layer)=>layer.getSource()?.getAttributionsCollapsible() === false);
            this.setCollapsible(collapsible);
        }
        return Array.from(visibleAttributions);
    }
    /**
   * @private
   * @param {?import("../Map.js").FrameState} frameState Frame state.
   */ async updateElement_(frameState) {
        if (!frameState) {
            if (this.renderedVisible_) {
                this.element.style.display = 'none';
                this.renderedVisible_ = false;
            }
            return;
        }
        const attributions = await Promise.all(this.collectSourceAttributions_(frameState).map((attribution)=>(0, $bc15bca7780ad95b$export$4dbaaf6c79705e6c)(()=>attribution)));
        const visible = attributions.length > 0;
        if (this.renderedVisible_ != visible) {
            this.element.style.display = visible ? '' : 'none';
            this.renderedVisible_ = visible;
        }
        if ((0, $49313fcb0fc32abe$export$e9bab7fafb253603)(attributions, this.renderedAttributions_)) return;
        (0, $b6f6d442e8ff57e1$export$1e1c9bf5a4ffe0d1)(this.ulElement_);
        // append the attributions
        for(let i = 0, ii = attributions.length; i < ii; ++i){
            const element = document.createElement('li');
            element.innerHTML = attributions[i];
            this.ulElement_.appendChild(element);
        }
        this.renderedAttributions_ = attributions;
    }
    /**
   * @param {MouseEvent} event The event to handle
   * @private
   */ handleClick_(event) {
        event.preventDefault();
        this.handleToggle_();
        this.userCollapsed_ = this.collapsed_;
    }
    /**
   * @private
   */ handleToggle_() {
        this.element.classList.toggle((0, $d3be093641aea1c1$export$e16017ac68d14492));
        if (this.collapsed_) (0, $b6f6d442e8ff57e1$export$5542201de9311ab2)(this.collapseLabel_, this.label_);
        else (0, $b6f6d442e8ff57e1$export$5542201de9311ab2)(this.label_, this.collapseLabel_);
        this.collapsed_ = !this.collapsed_;
        this.toggleButton_.setAttribute('aria-expanded', String(!this.collapsed_));
    }
    /**
   * Return `true` if the attribution is collapsible, `false` otherwise.
   * @return {boolean} True if the widget is collapsible.
   * @api
   */ getCollapsible() {
        return this.collapsible_;
    }
    /**
   * Set whether the attribution should be collapsible.
   * @param {boolean} collapsible True if the widget is collapsible.
   * @api
   */ setCollapsible(collapsible) {
        if (this.collapsible_ === collapsible) return;
        this.collapsible_ = collapsible;
        this.element.classList.toggle('ol-uncollapsible');
        if (this.userCollapsed_) this.handleToggle_();
    }
    /**
   * Collapse or expand the attribution according to the passed parameter. Will
   * not do anything if the attribution isn't collapsible or if the current
   * collapsed state is already the one requested.
   * @param {boolean} collapsed True if the widget is collapsed.
   * @api
   */ setCollapsed(collapsed) {
        this.userCollapsed_ = collapsed;
        if (!this.collapsible_ || this.collapsed_ === collapsed) return;
        this.handleToggle_();
    }
    /**
   * Return `true` when the attribution is currently collapsed or `false`
   * otherwise.
   * @return {boolean} True if the widget is collapsed.
   * @api
   */ getCollapsed() {
        return this.collapsed_;
    }
    /**
   * Update the attribution element.
   * @param {import("../MapEvent.js").default} mapEvent Map event.
   * @override
   */ render(mapEvent) {
        this.updateElement_(mapEvent.frameState);
    }
}
var $f5077c1b2c2515ec$export$2e2bcd8739ae039 = $f5077c1b2c2515ec$var$Attribution;


/**
 * @module ol/control/Rotate
 */ 
/**
 * @module ol/easing
 */ /**
 * Start slow and speed up.
 * @param {number} t Input between 0 and 1.
 * @return {number} Output between 0 and 1.
 * @api
 */ function $386674cda6e01ace$export$929e5a82286172a6(t) {
    return Math.pow(t, 3);
}
function $386674cda6e01ace$export$57636bb43b1ccbb0(t) {
    return 1 - $386674cda6e01ace$export$929e5a82286172a6(1 - t);
}
function $386674cda6e01ace$export$9b47139b511b56e4(t) {
    return 3 * t * t - 2 * t * t * t;
}
function $386674cda6e01ace$export$45db2fc2f15997e7(t) {
    return t;
}
function $386674cda6e01ace$export$7f4472f6708afaf3(t) {
    if (t < 0.5) return $386674cda6e01ace$export$9b47139b511b56e4(2 * t);
    return 1 - $386674cda6e01ace$export$9b47139b511b56e4(2 * (t - 0.5));
}




/**
 * @typedef {Object} Options
 * @property {string} [className='ol-rotate'] CSS class name.
 * @property {string|HTMLElement} [label='⇧'] Text label to use for the rotate button.
 * Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string} [tipLabel='Reset rotation'] Text label to use for the rotate tip.
 * @property {string} [compassClassName='ol-compass'] CSS class name for the compass.
 * @property {number} [duration=250] Animation duration in milliseconds.
 * @property {boolean} [autoHide=true] Hide the control when rotation is 0.
 * @property {function(import("../MapEvent.js").default):void} [render] Function called when the control should
 * be re-rendered. This is called in a `requestAnimationFrame` callback.
 * @property {function():void} [resetNorth] Function called when the control is clicked.
 * This will override the default `resetNorth`.
 * @property {HTMLElement|string} [target] Specify a target if you want the control to be
 * rendered outside of the map's viewport.
 */ /**
 * @classdesc
 * A button control to reset rotation to 0.
 * To style this control use css selector `.ol-rotate`. A `.ol-hidden` css
 * selector is added to the button when the rotation is 0.
 *
 * @api
 */ class $c6d81e681f6102ed$var$Rotate extends (0, $18f514e2c8971ae5$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Rotate options.
   */ constructor(options){
        options = options ? options : {};
        super({
            element: document.createElement('div'),
            render: options.render,
            target: options.target
        });
        const className = options.className !== undefined ? options.className : 'ol-rotate';
        const label = options.label !== undefined ? options.label : '\u21E7';
        const compassClassName = options.compassClassName !== undefined ? options.compassClassName : 'ol-compass';
        /**
     * @type {HTMLElement}
     * @private
     */ this.label_ = null;
        if (typeof label === 'string') {
            this.label_ = document.createElement('span');
            this.label_.className = compassClassName;
            this.label_.textContent = label;
        } else {
            this.label_ = label;
            this.label_.classList.add(compassClassName);
        }
        const tipLabel = options.tipLabel ? options.tipLabel : 'Reset rotation';
        const button = document.createElement('button');
        button.className = className + '-reset';
        button.setAttribute('type', 'button');
        button.title = tipLabel;
        button.appendChild(this.label_);
        button.addEventListener((0, $b5fa963342da4935$export$2e2bcd8739ae039).CLICK, this.handleClick_.bind(this), false);
        const cssClasses = className + ' ' + (0, $d3be093641aea1c1$export$1afde3d6e16a7b29) + ' ' + (0, $d3be093641aea1c1$export$4d4f8be70b656192);
        const element = this.element;
        element.className = cssClasses;
        element.appendChild(button);
        /**
     * @private
     */ this.callResetNorth_ = options.resetNorth ? options.resetNorth : undefined;
        /**
     * @type {number}
     * @private
     */ this.duration_ = options.duration !== undefined ? options.duration : 250;
        /**
     * @type {boolean}
     * @private
     */ this.autoHide_ = options.autoHide !== undefined ? options.autoHide : true;
        /**
     * @private
     * @type {number|undefined}
     */ this.rotation_ = undefined;
        if (this.autoHide_) this.element.classList.add((0, $d3be093641aea1c1$export$981241db82723ce2));
    }
    /**
   * @param {MouseEvent} event The event to handle
   * @private
   */ handleClick_(event) {
        event.preventDefault();
        if (this.callResetNorth_ !== undefined) this.callResetNorth_();
        else this.resetNorth_();
    }
    /**
   * @private
   */ resetNorth_() {
        const map = this.getMap();
        const view = map.getView();
        if (!view) // the map does not have a view, so we can't act
        // upon it
        return;
        const rotation = view.getRotation();
        if (rotation !== undefined) {
            if (this.duration_ > 0 && rotation % (2 * Math.PI) !== 0) view.animate({
                rotation: 0,
                duration: this.duration_,
                easing: (0, $386674cda6e01ace$export$57636bb43b1ccbb0)
            });
            else view.setRotation(0);
        }
    }
    /**
   * Update the rotate control element.
   * @param {import("../MapEvent.js").default} mapEvent Map event.
   * @override
   */ render(mapEvent) {
        const frameState = mapEvent.frameState;
        if (!frameState) return;
        const rotation = frameState.viewState.rotation;
        if (rotation != this.rotation_) {
            const transform = 'rotate(' + rotation + 'rad)';
            if (this.autoHide_) {
                const contains = this.element.classList.contains((0, $d3be093641aea1c1$export$981241db82723ce2));
                if (!contains && rotation === 0) this.element.classList.add((0, $d3be093641aea1c1$export$981241db82723ce2));
                else if (contains && rotation !== 0) this.element.classList.remove((0, $d3be093641aea1c1$export$981241db82723ce2));
            }
            this.label_.style.transform = transform;
        }
        this.rotation_ = rotation;
    }
}
var $c6d81e681f6102ed$export$2e2bcd8739ae039 = $c6d81e681f6102ed$var$Rotate;


/**
 * @module ol/control/Zoom
 */ 



/**
 * @typedef {Object} Options
 * @property {number} [duration=250] Animation duration in milliseconds.
 * @property {string} [className='ol-zoom'] CSS class name.
 * @property {string} [zoomInClassName=className + '-in'] CSS class name for the zoom-in button.
 * @property {string} [zoomOutClassName=className + '-out'] CSS class name for the zoom-out button.
 * @property {string|HTMLElement} [zoomInLabel='+'] Text label to use for the zoom-in
 * button. Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string|HTMLElement} [zoomOutLabel='–'] Text label to use for the zoom-out button.
 * Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string} [zoomInTipLabel='Zoom in'] Text label to use for the button tip.
 * @property {string} [zoomOutTipLabel='Zoom out'] Text label to use for the button tip.
 * @property {number} [delta=1] The zoom delta applied on each click.
 * @property {HTMLElement|string} [target] Specify a target if you want the control to be
 * rendered outside of the map's viewport.
 */ /**
 * @classdesc
 * A control with 2 buttons, one for zoom in and one for zoom out.
 * This control is one of the default controls of a map. To style this control
 * use css selectors `.ol-zoom-in` and `.ol-zoom-out`.
 *
 * @api
 */ class $04a1ec6b1dba72e1$var$Zoom extends (0, $18f514e2c8971ae5$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Zoom options.
   */ constructor(options){
        options = options ? options : {};
        super({
            element: document.createElement('div'),
            target: options.target
        });
        const className = options.className !== undefined ? options.className : 'ol-zoom';
        const delta = options.delta !== undefined ? options.delta : 1;
        const zoomInClassName = options.zoomInClassName !== undefined ? options.zoomInClassName : className + '-in';
        const zoomOutClassName = options.zoomOutClassName !== undefined ? options.zoomOutClassName : className + '-out';
        const zoomInLabel = options.zoomInLabel !== undefined ? options.zoomInLabel : '+';
        const zoomOutLabel = options.zoomOutLabel !== undefined ? options.zoomOutLabel : '\u2013';
        const zoomInTipLabel = options.zoomInTipLabel !== undefined ? options.zoomInTipLabel : 'Zoom in';
        const zoomOutTipLabel = options.zoomOutTipLabel !== undefined ? options.zoomOutTipLabel : 'Zoom out';
        const inElement = document.createElement('button');
        inElement.className = zoomInClassName;
        inElement.setAttribute('type', 'button');
        inElement.title = zoomInTipLabel;
        inElement.appendChild(typeof zoomInLabel === 'string' ? document.createTextNode(zoomInLabel) : zoomInLabel);
        inElement.addEventListener((0, $b5fa963342da4935$export$2e2bcd8739ae039).CLICK, this.handleClick_.bind(this, delta), false);
        const outElement = document.createElement('button');
        outElement.className = zoomOutClassName;
        outElement.setAttribute('type', 'button');
        outElement.title = zoomOutTipLabel;
        outElement.appendChild(typeof zoomOutLabel === 'string' ? document.createTextNode(zoomOutLabel) : zoomOutLabel);
        outElement.addEventListener((0, $b5fa963342da4935$export$2e2bcd8739ae039).CLICK, this.handleClick_.bind(this, -delta), false);
        const cssClasses = className + ' ' + (0, $d3be093641aea1c1$export$1afde3d6e16a7b29) + ' ' + (0, $d3be093641aea1c1$export$4d4f8be70b656192);
        const element = this.element;
        element.className = cssClasses;
        element.appendChild(inElement);
        element.appendChild(outElement);
        /**
     * @type {number}
     * @private
     */ this.duration_ = options.duration !== undefined ? options.duration : 250;
    }
    /**
   * @param {number} delta Zoom delta.
   * @param {MouseEvent} event The event to handle
   * @private
   */ handleClick_(delta, event) {
        event.preventDefault();
        this.zoomByDelta_(delta);
    }
    /**
   * @param {number} delta Zoom delta.
   * @private
   */ zoomByDelta_(delta) {
        const map = this.getMap();
        const view = map.getView();
        if (!view) // the map does not have a view, so we can't act
        // upon it
        return;
        const currentZoom = view.getZoom();
        if (currentZoom !== undefined) {
            const newZoom = view.getConstrainedZoom(currentZoom + delta);
            if (this.duration_ > 0) {
                if (view.getAnimating()) view.cancelAnimations();
                view.animate({
                    zoom: newZoom,
                    duration: this.duration_,
                    easing: (0, $386674cda6e01ace$export$57636bb43b1ccbb0)
                });
            } else view.setZoom(newZoom);
        }
    }
}
var $04a1ec6b1dba72e1$export$2e2bcd8739ae039 = $04a1ec6b1dba72e1$var$Zoom;


function $ec4b8275865f52de$export$ebe90cb607ad99e(options) {
    options = options ? options : {};
    /** @type {Collection<import("./Control.js").default>} */ const controls = new (0, $e1f99232eb9bff27$export$2e2bcd8739ae039)();
    const zoomControl = options.zoom !== undefined ? options.zoom : true;
    if (zoomControl) controls.push(new (0, $04a1ec6b1dba72e1$export$2e2bcd8739ae039)(options.zoomOptions));
    const rotateControl = options.rotate !== undefined ? options.rotate : true;
    if (rotateControl) controls.push(new (0, $c6d81e681f6102ed$export$2e2bcd8739ae039)(options.rotateOptions));
    const attributionControl = options.attribution !== undefined ? options.attribution : true;
    if (attributionControl) controls.push(new (0, $f5077c1b2c2515ec$export$2e2bcd8739ae039)(options.attributionOptions));
    return controls;
}

/**
 * @module ol/control/FullScreen
 */ /**
 * @module ol/MapProperty
 */ /**
 * @enum {string}
 */ var $9ffbaa2d2202cd6d$export$2e2bcd8739ae039 = {
    LAYERGROUP: 'layergroup',
    SIZE: 'size',
    TARGET: 'target',
    VIEW: 'view'
};







const $5fb44d261f72cf9a$var$events = [
    'fullscreenchange',
    'webkitfullscreenchange'
];
/**
 * @enum {string}
 */ const $5fb44d261f72cf9a$var$FullScreenEventType = {
    /**
   * Triggered after the map entered fullscreen.
   * @event FullScreenEventType#enterfullscreen
   * @api
   */ ENTERFULLSCREEN: 'enterfullscreen',
    /**
   * Triggered after the map leave fullscreen.
   * @event FullScreenEventType#leavefullscreen
   * @api
   */ LEAVEFULLSCREEN: 'leavefullscreen'
};
/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes|
 *     'enterfullscreen'|'leavefullscreen', import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types, import("../Object").ObjectEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|
 *     'enterfullscreen'|'leavefullscreen'|import("../ObjectEventType").Types, Return>} FullScreenOnSignature
 */ /**
 * @typedef {Object} Options
 * @property {string} [className='ol-full-screen'] CSS class name.
 * @property {string|Text|HTMLElement} [label='\u2922'] Text label to use for the button.
 * Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string|Text|HTMLElement} [labelActive='\u00d7'] Text label to use for the
 * button when full-screen is active.
 * Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string} [activeClassName=className + '-true'] CSS class name for the button
 * when full-screen is active.
 * @property {string} [inactiveClassName=className + '-false'] CSS class name for the button
 * when full-screen is inactive.
 * @property {string} [tipLabel='Toggle full-screen'] Text label to use for the button tip.
 * @property {boolean} [keys=false] Full keyboard access.
 * @property {HTMLElement|string} [target] Specify a target if you want the
 * control to be rendered outside of the map's viewport.
 * @property {HTMLElement|string} [source] The element to be displayed
 * fullscreen. When not provided, the element containing the map viewport will
 * be displayed fullscreen.
 */ /**
 * @classdesc
 * Provides a button that when clicked fills up the full screen with the map.
 * The full screen source element is by default the element containing the map viewport unless
 * overridden by providing the `source` option. In which case, the dom
 * element introduced using this parameter will be displayed in full screen.
 *
 * When in full screen mode, a close button is shown to exit full screen mode.
 * The [Fullscreen API](https://www.w3.org/TR/fullscreen/) is used to
 * toggle the map in full screen mode.
 *
 * @fires FullScreenEventType#enterfullscreen
 * @fires FullScreenEventType#leavefullscreen
 * @api
 */ class $5fb44d261f72cf9a$var$FullScreen extends (0, $18f514e2c8971ae5$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        super({
            element: document.createElement('div'),
            target: options.target
        });
        /***
     * @type {FullScreenOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {FullScreenOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {FullScreenOnSignature<void>}
     */ this.un;
        /**
     * @private
     * @type {boolean}
     */ this.keys_ = options.keys !== undefined ? options.keys : false;
        /**
     * @private
     * @type {HTMLElement|string|undefined}
     */ this.source_ = options.source;
        /**
     * @type {boolean}
     * @private
     */ this.isInFullscreen_ = false;
        /**
     * @private
     */ this.boundHandleMapTargetChange_ = this.handleMapTargetChange_.bind(this);
        /**
     * @private
     * @type {string}
     */ this.cssClassName_ = options.className !== undefined ? options.className : 'ol-full-screen';
        /**
     * @private
     * @type {Array<import("../events.js").EventsKey>}
     */ this.documentListeners_ = [];
        /**
     * @private
     * @type {Array<string>}
     */ this.activeClassName_ = options.activeClassName !== undefined ? options.activeClassName.split(' ') : [
            this.cssClassName_ + '-true'
        ];
        /**
     * @private
     * @type {Array<string>}
     */ this.inactiveClassName_ = options.inactiveClassName !== undefined ? options.inactiveClassName.split(' ') : [
            this.cssClassName_ + '-false'
        ];
        const label = options.label !== undefined ? options.label : '\u2922';
        /**
     * @private
     * @type {Text|HTMLElement}
     */ this.labelNode_ = typeof label === 'string' ? document.createTextNode(label) : label;
        const labelActive = options.labelActive !== undefined ? options.labelActive : '\u00d7';
        /**
     * @private
     * @type {Text|HTMLElement}
     */ this.labelActiveNode_ = typeof labelActive === 'string' ? document.createTextNode(labelActive) : labelActive;
        const tipLabel = options.tipLabel ? options.tipLabel : 'Toggle full-screen';
        /**
     * @private
     * @type {HTMLElement}
     */ this.button_ = document.createElement('button');
        this.button_.title = tipLabel;
        this.button_.setAttribute('type', 'button');
        this.button_.appendChild(this.labelNode_);
        this.button_.addEventListener((0, $b5fa963342da4935$export$2e2bcd8739ae039).CLICK, this.handleClick_.bind(this), false);
        this.setClassName_(this.button_, this.isInFullscreen_);
        this.element.className = `${this.cssClassName_} ${0, $d3be093641aea1c1$export$1afde3d6e16a7b29} ${0, $d3be093641aea1c1$export$4d4f8be70b656192}`;
        this.element.appendChild(this.button_);
    }
    /**
   * @param {MouseEvent} event The event to handle
   * @private
   */ handleClick_(event) {
        event.preventDefault();
        this.handleFullScreen_();
    }
    /**
   * @private
   */ handleFullScreen_() {
        const map = this.getMap();
        if (!map) return;
        const doc = map.getOwnerDocument();
        if (!$5fb44d261f72cf9a$var$isFullScreenSupported(doc)) return;
        if ($5fb44d261f72cf9a$var$isFullScreen(doc)) $5fb44d261f72cf9a$var$exitFullScreen(doc);
        else {
            let element;
            if (this.source_) element = typeof this.source_ === 'string' ? doc.getElementById(this.source_) : this.source_;
            else element = map.getTargetElement();
            if (this.keys_) $5fb44d261f72cf9a$var$requestFullScreenWithKeys(element);
            else $5fb44d261f72cf9a$var$requestFullScreen(element);
        }
    }
    /**
   * @private
   */ handleFullScreenChange_() {
        const map = this.getMap();
        if (!map) return;
        const wasInFullscreen = this.isInFullscreen_;
        this.isInFullscreen_ = $5fb44d261f72cf9a$var$isFullScreen(map.getOwnerDocument());
        if (wasInFullscreen !== this.isInFullscreen_) {
            this.setClassName_(this.button_, this.isInFullscreen_);
            if (this.isInFullscreen_) {
                (0, $b6f6d442e8ff57e1$export$5542201de9311ab2)(this.labelActiveNode_, this.labelNode_);
                this.dispatchEvent($5fb44d261f72cf9a$var$FullScreenEventType.ENTERFULLSCREEN);
            } else {
                (0, $b6f6d442e8ff57e1$export$5542201de9311ab2)(this.labelNode_, this.labelActiveNode_);
                this.dispatchEvent($5fb44d261f72cf9a$var$FullScreenEventType.LEAVEFULLSCREEN);
            }
            map.updateSize();
        }
    }
    /**
   * @param {HTMLElement} element Target element
   * @param {boolean} fullscreen True if fullscreen class name should be active
   * @private
   */ setClassName_(element, fullscreen) {
        if (fullscreen) {
            element.classList.remove(...this.inactiveClassName_);
            element.classList.add(...this.activeClassName_);
        } else {
            element.classList.remove(...this.activeClassName_);
            element.classList.add(...this.inactiveClassName_);
        }
    }
    /**
   * Remove the control from its current map and attach it to the new map.
   * Pass `null` to just remove the control from the current map.
   * Subclasses may set up event handlers to get notified about changes to
   * the map here.
   * @param {import("../Map.js").default|null} map Map.
   * @api
   * @override
   */ setMap(map) {
        const oldMap = this.getMap();
        if (oldMap) oldMap.removeChangeListener((0, $9ffbaa2d2202cd6d$export$2e2bcd8739ae039).TARGET, this.boundHandleMapTargetChange_);
        super.setMap(map);
        this.handleMapTargetChange_();
        if (map) map.addChangeListener((0, $9ffbaa2d2202cd6d$export$2e2bcd8739ae039).TARGET, this.boundHandleMapTargetChange_);
    }
    /**
   * @private
   */ handleMapTargetChange_() {
        const listeners = this.documentListeners_;
        for(let i = 0, ii = listeners.length; i < ii; ++i)(0, $63963d09e0c49405$export$b0a21c8b3c1c921)(listeners[i]);
        listeners.length = 0;
        const map = this.getMap();
        if (map) {
            const doc = map.getOwnerDocument();
            if ($5fb44d261f72cf9a$var$isFullScreenSupported(doc)) this.element.classList.remove((0, $d3be093641aea1c1$export$68eede0dd8c6c1da));
            else this.element.classList.add((0, $d3be093641aea1c1$export$68eede0dd8c6c1da));
            for(let i = 0, ii = $5fb44d261f72cf9a$var$events.length; i < ii; ++i)listeners.push((0, $63963d09e0c49405$export$63174c828edd6ff8)(doc, $5fb44d261f72cf9a$var$events[i], this.handleFullScreenChange_, this));
            this.handleFullScreenChange_();
        }
    }
}
/**
 * @param {Document} doc The root document to check.
 * @return {boolean} Fullscreen is supported by the current platform.
 */ function $5fb44d261f72cf9a$var$isFullScreenSupported(doc) {
    const body = doc.body;
    return !!(body['webkitRequestFullscreen'] || body.requestFullscreen && doc.fullscreenEnabled);
}
/**
 * @param {Document} doc The root document to check.
 * @return {boolean} Element is currently in fullscreen.
 */ function $5fb44d261f72cf9a$var$isFullScreen(doc) {
    return !!(doc['webkitIsFullScreen'] || doc.fullscreenElement);
}
/**
 * Request to fullscreen an element.
 * @param {HTMLElement} element Element to request fullscreen
 */ function $5fb44d261f72cf9a$var$requestFullScreen(element) {
    if (element.requestFullscreen) element.requestFullscreen();
    else if (element['webkitRequestFullscreen']) element['webkitRequestFullscreen']();
}
/**
 * Request to fullscreen an element with keyboard input.
 * @param {HTMLElement} element Element to request fullscreen
 */ function $5fb44d261f72cf9a$var$requestFullScreenWithKeys(element) {
    if (element['webkitRequestFullscreen']) element['webkitRequestFullscreen']();
    else $5fb44d261f72cf9a$var$requestFullScreen(element);
}
/**
 * Exit fullscreen.
 * @param {Document} doc The document to exit fullscren from
 */ function $5fb44d261f72cf9a$var$exitFullScreen(doc) {
    if (doc.exitFullscreen) doc.exitFullscreen();
    else if (doc['webkitExitFullscreen']) doc['webkitExitFullscreen']();
}
var $5fb44d261f72cf9a$export$2e2bcd8739ae039 = $5fb44d261f72cf9a$var$FullScreen;




/**
 * @module ol/format/GeoJSON
 */ 






/**
 * @module ol/format/JSONFeature
 */ 

/**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Base class for JSON feature formats.
 *
 * @template {import('../Feature.js').FeatureLike} [FeatureType=import("../Feature.js").default]
 * @extends {FeatureFormat<FeatureType>}
 * @abstract
 */ class $669f76cf7e2c5e8a$var$JSONFeature extends (0, $6510197ad3cc0360$export$2e2bcd8739ae039) {
    constructor(){
        super();
    }
    /**
   * @return {import("./Feature.js").Type} Format.
   * @override
   */ getType() {
        return 'json';
    }
    /**
   * Read a feature.  Only works for a single feature. Use `readFeatures` to
   * read a feature collection.
   *
   * @param {ArrayBuffer|Document|Element|Object|string} source Source.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @return {FeatureType|Array<FeatureType>} Feature.
   * @api
   * @override
   */ readFeature(source, options) {
        return this.readFeatureFromObject($669f76cf7e2c5e8a$var$getObject(source), this.getReadOptions(source, options));
    }
    /**
   * Read all features.  Works with both a single feature and a feature
   * collection.
   *
   * @param {ArrayBuffer|Document|Element|Object|string} source Source.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @return {Array<FeatureType>} Features.
   * @api
   * @override
   */ readFeatures(source, options) {
        return this.readFeaturesFromObject($669f76cf7e2c5e8a$var$getObject(source), this.getReadOptions(source, options));
    }
    /**
   * @abstract
   * @param {Object} object Object.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @protected
   * @return {FeatureType|Array<FeatureType>} Feature.
   */ readFeatureFromObject(object, options) {
        return (0, $fd76d391cc228565$export$817eb92a8194bab0)();
    }
    /**
   * @abstract
   * @param {Object} object Object.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @protected
   * @return {Array<FeatureType>} Features.
   */ readFeaturesFromObject(object, options) {
        return (0, $fd76d391cc228565$export$817eb92a8194bab0)();
    }
    /**
   * Read a geometry.
   *
   * @param {ArrayBuffer|Document|Element|Object|string} source Source.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @return {import("../geom/Geometry.js").default} Geometry.
   * @api
   * @override
   */ readGeometry(source, options) {
        return this.readGeometryFromObject($669f76cf7e2c5e8a$var$getObject(source), this.getReadOptions(source, options));
    }
    /**
   * @abstract
   * @param {Object} object Object.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @protected
   * @return {import("../geom/Geometry.js").default} Geometry.
   */ readGeometryFromObject(object, options) {
        return (0, $fd76d391cc228565$export$817eb92a8194bab0)();
    }
    /**
   * Read the projection.
   *
   * @param {ArrayBuffer|Document|Element|Object|string} source Source.
   * @return {import("../proj/Projection.js").default} Projection.
   * @api
   * @override
   */ readProjection(source) {
        return this.readProjectionFromObject($669f76cf7e2c5e8a$var$getObject(source));
    }
    /**
   * @abstract
   * @param {Object} object Object.
   * @protected
   * @return {import("../proj/Projection.js").default} Projection.
   */ readProjectionFromObject(object) {
        return (0, $fd76d391cc228565$export$817eb92a8194bab0)();
    }
    /**
   * Encode a feature as string.
   *
   * @param {import("../Feature.js").default} feature Feature.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {string} Encoded feature.
   * @api
   * @override
   */ writeFeature(feature, options) {
        return JSON.stringify(this.writeFeatureObject(feature, options));
    }
    /**
   * @abstract
   * @param {import("../Feature.js").default} feature Feature.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {Object} Object.
   */ writeFeatureObject(feature, options) {
        return (0, $fd76d391cc228565$export$817eb92a8194bab0)();
    }
    /**
   * Encode an array of features as string.
   *
   * @param {Array<import("../Feature.js").default>} features Features.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {string} Encoded features.
   * @api
   * @override
   */ writeFeatures(features, options) {
        return JSON.stringify(this.writeFeaturesObject(features, options));
    }
    /**
   * @abstract
   * @param {Array<import("../Feature.js").default>} features Features.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {Object} Object.
   */ writeFeaturesObject(features, options) {
        return (0, $fd76d391cc228565$export$817eb92a8194bab0)();
    }
    /**
   * Encode a geometry as string.
   *
   * @param {import("../geom/Geometry.js").default} geometry Geometry.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {string} Encoded geometry.
   * @api
   * @override
   */ writeGeometry(geometry, options) {
        return JSON.stringify(this.writeGeometryObject(geometry, options));
    }
    /**
   * @abstract
   * @param {import("../geom/Geometry.js").default} geometry Geometry.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {Object} Object.
   */ writeGeometryObject(geometry, options) {
        return (0, $fd76d391cc228565$export$817eb92a8194bab0)();
    }
}
/**
 * @param {Document|Element|Object|string} source Source.
 * @return {Object} Object.
 */ function $669f76cf7e2c5e8a$var$getObject(source) {
    if (typeof source === 'string') {
        const object = JSON.parse(source);
        return object ? /** @type {Object} */ object : null;
    }
    if (source !== null) return source;
    return null;
}
var $669f76cf7e2c5e8a$export$2e2bcd8739ae039 = $669f76cf7e2c5e8a$var$JSONFeature;


/**
 * @typedef {import("geojson").GeoJSON} GeoJSONObject
 * @typedef {import("geojson").Feature} GeoJSONFeature
 * @typedef {import("geojson").FeatureCollection} GeoJSONFeatureCollection
 * @typedef {import("geojson").Geometry} GeoJSONGeometry
 * @typedef {import("geojson").Point} GeoJSONPoint
 * @typedef {import("geojson").LineString} GeoJSONLineString
 * @typedef {import("geojson").Polygon} GeoJSONPolygon
 * @typedef {import("geojson").MultiPoint} GeoJSONMultiPoint
 * @typedef {import("geojson").MultiLineString} GeoJSONMultiLineString
 * @typedef {import("geojson").MultiPolygon} GeoJSONMultiPolygon
 * @typedef {import("geojson").GeometryCollection} GeoJSONGeometryCollection
 */ /**
 * @template {import("../Feature.js").FeatureLike} [FeatureType=import("../Feature.js").default]
 * @typedef {Object} Options
 *
 * @property {import("../proj.js").ProjectionLike} [dataProjection='EPSG:4326'] Default data projection.
 * @property {import("../proj.js").ProjectionLike} [featureProjection] Projection for features read or
 * written by the format.  Options passed to read or write methods will take precedence.
 * @property {string} [geometryName] Geometry name to use when creating features.
 * @property {boolean} [extractGeometryName=false] Certain GeoJSON providers include
 * the geometry_name field in the feature GeoJSON. If set to `true` the GeoJSON reader
 * will look for that field to set the geometry name. If both this field is set to `true`
 * and a `geometryName` is provided, the `geometryName` will take precedence.
 * @property {import('./Feature.js').FeatureToFeatureClass<FeatureType>} [featureClass] Feature class
 * to be used when reading features. The default is {@link module:ol/Feature~Feature}. If performance is
 * the primary concern, and features are not going to be modified or round-tripped through the format,
 * consider using {@link module:ol/render/Feature~RenderFeature}
 */ /**
 * @classdesc
 * Feature format for reading and writing data in the GeoJSON format.
 *
 * @template {import('../Feature.js').FeatureLike} [FeatureType=import("../Feature.js").default]
 * @extends {JSONFeature<FeatureType>}
 * @api
 */ class $93342158ce8701e7$var$GeoJSON extends (0, $669f76cf7e2c5e8a$export$2e2bcd8739ae039) {
    /**
   * @param {Options<FeatureType>} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        super();
        /**
     * @type {import("../proj/Projection.js").default}
     */ this.dataProjection = (0, $a86eee1c28205a05$export$3988ae62b71be9a3)(options.dataProjection ? options.dataProjection : 'EPSG:4326');
        if (options.featureProjection) /**
       * @type {import("../proj/Projection.js").default}
       */ this.defaultFeatureProjection = (0, $a86eee1c28205a05$export$3988ae62b71be9a3)(options.featureProjection);
        if (options.featureClass) this.featureClass = options.featureClass;
        /**
     * Name of the geometry attribute for features.
     * @type {string|undefined}
     * @private
     */ this.geometryName_ = options.geometryName;
        /**
     * Look for the `geometry_name` in the feature GeoJSON
     * @type {boolean|undefined}
     * @private
     */ this.extractGeometryName_ = options.extractGeometryName;
        this.supportedMediaTypes = [
            'application/geo+json',
            'application/vnd.geo+json'
        ];
    }
    /**
   * @param {Object} object Object.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @protected
   * @return {FeatureType|Array<FeatureType>} Feature.
   * @override
   */ readFeatureFromObject(object, options) {
        /**
     * @type {GeoJSONFeature}
     */ let geoJSONFeature = null;
        if (object['type'] === 'Feature') geoJSONFeature = /** @type {GeoJSONFeature} */ object;
        else geoJSONFeature = {
            'type': 'Feature',
            'geometry': /** @type {GeoJSONGeometry} */ object,
            'properties': null
        };
        const geometry = $93342158ce8701e7$var$readGeometryInternal(geoJSONFeature['geometry'], options);
        if (this.featureClass === (0, $e5b428c112c9c5d6$export$2e2bcd8739ae039)) return /** @type {FeatureType|Array<FeatureType>} */ (0, $6510197ad3cc0360$export$f935e77582b330a)({
            geometry: geometry,
            id: geoJSONFeature['id'],
            properties: geoJSONFeature['properties']
        }, options);
        const feature = new (0, $df26d2327ced1fa9$export$2e2bcd8739ae039)();
        if (this.geometryName_) feature.setGeometryName(this.geometryName_);
        else if (this.extractGeometryName_ && geoJSONFeature['geometry_name']) feature.setGeometryName(geoJSONFeature['geometry_name']);
        feature.setGeometry((0, $6510197ad3cc0360$export$322c9678d8c47bf)(geometry, options));
        if ('id' in geoJSONFeature) feature.setId(geoJSONFeature['id']);
        if (geoJSONFeature['properties']) feature.setProperties(geoJSONFeature['properties'], true);
        return /** @type {FeatureType|Array<FeatureType>} */ feature;
    }
    /**
   * @param {Object} object Object.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @protected
   * @return {Array<FeatureType>} Features.
   * @override
   */ readFeaturesFromObject(object, options) {
        const geoJSONObject = /** @type {GeoJSONObject} */ object;
        let features = null;
        if (geoJSONObject['type'] === 'FeatureCollection') {
            const geoJSONFeatureCollection = /** @type {GeoJSONFeatureCollection} */ object;
            features = [];
            const geoJSONFeatures = geoJSONFeatureCollection['features'];
            for(let i = 0, ii = geoJSONFeatures.length; i < ii; ++i){
                const featureObject = this.readFeatureFromObject(geoJSONFeatures[i], options);
                if (!featureObject) continue;
                features.push(featureObject);
            }
        } else features = [
            this.readFeatureFromObject(object, options)
        ];
        return /** @type {Array<FeatureType>} */ features.flat();
    }
    /**
   * @param {GeoJSONGeometry} object Object.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @protected
   * @return {import("../geom/Geometry.js").default} Geometry.
   * @override
   */ readGeometryFromObject(object, options) {
        return $93342158ce8701e7$var$readGeometry(object, options);
    }
    /**
   * @param {Object} object Object.
   * @protected
   * @return {import("../proj/Projection.js").default} Projection.
   * @override
   */ readProjectionFromObject(object) {
        const crs = object['crs'];
        let projection;
        if (crs) {
            if (crs['type'] == 'name') projection = (0, $a86eee1c28205a05$export$3988ae62b71be9a3)(crs['properties']['name']);
            else if (crs['type'] === 'EPSG') projection = (0, $a86eee1c28205a05$export$3988ae62b71be9a3)('EPSG:' + crs['properties']['code']);
            else throw new Error('Unknown SRS type');
        } else projection = this.dataProjection;
        return /** @type {import("../proj/Projection.js").default} */ projection;
    }
    /**
   * Encode a feature as a GeoJSON Feature object.
   *
   * @param {import("../Feature.js").default} feature Feature.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {GeoJSONFeature} Object.
   * @api
   * @override
   */ writeFeatureObject(feature, options) {
        options = this.adaptOptions(options);
        /** @type {GeoJSONFeature} */ const object = {
            'type': 'Feature',
            geometry: null,
            properties: null
        };
        const id = feature.getId();
        if (id !== undefined) object.id = id;
        if (!feature.hasProperties()) return object;
        const properties = feature.getProperties();
        const geometry = feature.getGeometry();
        if (geometry) {
            object.geometry = $93342158ce8701e7$var$writeGeometry(geometry, options);
            delete properties[feature.getGeometryName()];
        }
        if (!(0, $9f2b61a1df00e9b3$export$dd1bc94b04021eeb)(properties)) object.properties = properties;
        return object;
    }
    /**
   * Encode an array of features as a GeoJSON object.
   *
   * @param {Array<import("../Feature.js").default>} features Features.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {GeoJSONFeatureCollection} GeoJSON Object.
   * @api
   * @override
   */ writeFeaturesObject(features, options) {
        options = this.adaptOptions(options);
        const objects = [];
        for(let i = 0, ii = features.length; i < ii; ++i)objects.push(this.writeFeatureObject(features[i], options));
        return {
            type: 'FeatureCollection',
            features: objects
        };
    }
    /**
   * Encode a geometry as a GeoJSON object.
   *
   * @param {import("../geom/Geometry.js").default} geometry Geometry.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {GeoJSONGeometry|GeoJSONGeometryCollection} Object.
   * @api
   * @override
   */ writeGeometryObject(geometry, options) {
        return $93342158ce8701e7$var$writeGeometry(geometry, this.adaptOptions(options));
    }
}
/**
 * @param {GeoJSONGeometry|GeoJSONGeometryCollection} object Object.
 * @param {import("./Feature.js").ReadOptions} [options] Read options.
 * @return {import("./Feature.js").GeometryObject} Geometry.
 */ function $93342158ce8701e7$var$readGeometryInternal(object, options) {
    if (!object) return null;
    /** @type {import("./Feature.js").GeometryObject} */ let geometry;
    switch(object['type']){
        case 'Point':
            geometry = $93342158ce8701e7$var$readPointGeometry(/** @type {GeoJSONPoint} */ object);
            break;
        case 'LineString':
            geometry = $93342158ce8701e7$var$readLineStringGeometry(/** @type {GeoJSONLineString} */ object);
            break;
        case 'Polygon':
            geometry = $93342158ce8701e7$var$readPolygonGeometry(/** @type {GeoJSONPolygon} */ object);
            break;
        case 'MultiPoint':
            geometry = $93342158ce8701e7$var$readMultiPointGeometry(/** @type {GeoJSONMultiPoint} */ object);
            break;
        case 'MultiLineString':
            geometry = $93342158ce8701e7$var$readMultiLineStringGeometry(/** @type {GeoJSONMultiLineString} */ object);
            break;
        case 'MultiPolygon':
            geometry = $93342158ce8701e7$var$readMultiPolygonGeometry(/** @type {GeoJSONMultiPolygon} */ object);
            break;
        case 'GeometryCollection':
            geometry = $93342158ce8701e7$var$readGeometryCollectionGeometry(/** @type {GeoJSONGeometryCollection} */ object);
            break;
        default:
            throw new Error('Unsupported GeoJSON type: ' + object['type']);
    }
    return geometry;
}
/**
 * @param {GeoJSONGeometry|GeoJSONGeometryCollection} object Object.
 * @param {import("./Feature.js").ReadOptions} [options] Read options.
 * @return {import("../geom/Geometry.js").default} Geometry.
 */ function $93342158ce8701e7$var$readGeometry(object, options) {
    const geometryObject = $93342158ce8701e7$var$readGeometryInternal(object, options);
    return (0, $6510197ad3cc0360$export$322c9678d8c47bf)(geometryObject, options);
}
/**
 * @param {GeoJSONGeometryCollection} object Object.
 * @param {import("./Feature.js").ReadOptions} [options] Read options.
 * @return {import("./Feature.js").GeometryCollectionObject} Geometry collection.
 */ function $93342158ce8701e7$var$readGeometryCollectionGeometry(object, options) {
    const geometries = object['geometries'].map(/**
     * @param {GeoJSONGeometry} geometry Geometry.
     * @return {import("./Feature.js").GeometryObject} geometry Geometry.
     */ function(geometry) {
        return $93342158ce8701e7$var$readGeometryInternal(geometry, options);
    });
    return geometries;
}
/**
 * @param {GeoJSONPoint} object Input object.
 * @return {import("./Feature.js").GeometryObject} Point geometry.
 */ function $93342158ce8701e7$var$readPointGeometry(object) {
    const flatCoordinates = object['coordinates'];
    return {
        type: 'Point',
        flatCoordinates: flatCoordinates,
        layout: (0, $6773c3d7448f46a9$export$61bb6938093db2c8)(flatCoordinates.length)
    };
}
/**
 * @param {GeoJSONLineString} object Object.
 * @return {import("./Feature.js").GeometryObject} LineString geometry.
 */ function $93342158ce8701e7$var$readLineStringGeometry(object) {
    const coordinates = object['coordinates'];
    const flatCoordinates = coordinates.flat();
    return {
        type: 'LineString',
        flatCoordinates: flatCoordinates,
        ends: [
            flatCoordinates.length
        ],
        layout: (0, $6773c3d7448f46a9$export$61bb6938093db2c8)(coordinates[0]?.length || 2)
    };
}
/**
 * @param {GeoJSONMultiLineString} object Object.
 * @return {import("./Feature.js").GeometryObject} MultiLineString geometry.
 */ function $93342158ce8701e7$var$readMultiLineStringGeometry(object) {
    const coordinates = object['coordinates'];
    const stride = coordinates[0]?.[0]?.length || 2;
    const flatCoordinates = [];
    const ends = (0, $f96815e1fef680b1$export$47c3746a74384d45)(flatCoordinates, 0, coordinates, stride);
    return {
        type: 'MultiLineString',
        flatCoordinates: flatCoordinates,
        ends: ends,
        layout: (0, $6773c3d7448f46a9$export$61bb6938093db2c8)(stride)
    };
}
/**
 * @param {GeoJSONMultiPoint} object Object.
 * @return {import("./Feature.js").GeometryObject} MultiPoint geometry.
 */ function $93342158ce8701e7$var$readMultiPointGeometry(object) {
    const coordinates = object['coordinates'];
    return {
        type: 'MultiPoint',
        flatCoordinates: coordinates.flat(),
        layout: (0, $6773c3d7448f46a9$export$61bb6938093db2c8)(coordinates[0]?.length || 2)
    };
}
/**
 * @param {GeoJSONMultiPolygon} object Object.
 * @return {import("./Feature.js").GeometryObject} MultiPolygon geometry.
 */ function $93342158ce8701e7$var$readMultiPolygonGeometry(object) {
    const coordinates = object['coordinates'];
    const flatCoordinates = [];
    const stride = coordinates[0]?.[0]?.[0].length || 2;
    const endss = (0, $f96815e1fef680b1$export$f9f2bb59da4accd3)(flatCoordinates, 0, coordinates, stride);
    return {
        type: 'MultiPolygon',
        flatCoordinates: flatCoordinates,
        ends: endss,
        layout: (0, $6773c3d7448f46a9$export$61bb6938093db2c8)(stride)
    };
}
/**
 * @param {GeoJSONPolygon} object Object.
 * @return {import("./Feature.js").GeometryObject} Polygon.
 */ function $93342158ce8701e7$var$readPolygonGeometry(object) {
    const coordinates = object['coordinates'];
    const flatCoordinates = [];
    const stride = coordinates[0]?.[0]?.length;
    const ends = (0, $f96815e1fef680b1$export$47c3746a74384d45)(flatCoordinates, 0, coordinates, stride);
    return {
        type: 'Polygon',
        flatCoordinates: flatCoordinates,
        ends: ends,
        layout: (0, $6773c3d7448f46a9$export$61bb6938093db2c8)(stride)
    };
}
/**
 * @param {import("../geom/Geometry.js").default} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [options] Write options.
 * @return {GeoJSONGeometry} GeoJSON geometry.
 */ function $93342158ce8701e7$var$writeGeometry(geometry, options) {
    geometry = (0, $6510197ad3cc0360$export$7beeea566b560d4)(geometry, true, options);
    const type = geometry.getType();
    /** @type {GeoJSONGeometry} */ let geoJSON;
    switch(type){
        case 'Point':
            geoJSON = $93342158ce8701e7$var$writePointGeometry(/** @type {import("../geom/Point.js").default} */ geometry, options);
            break;
        case 'LineString':
            geoJSON = $93342158ce8701e7$var$writeLineStringGeometry(/** @type {import("../geom/LineString.js").default} */ geometry, options);
            break;
        case 'Polygon':
            geoJSON = $93342158ce8701e7$var$writePolygonGeometry(/** @type {import("../geom/Polygon.js").default} */ geometry, options);
            break;
        case 'MultiPoint':
            geoJSON = $93342158ce8701e7$var$writeMultiPointGeometry(/** @type {import("../geom/MultiPoint.js").default} */ geometry, options);
            break;
        case 'MultiLineString':
            geoJSON = $93342158ce8701e7$var$writeMultiLineStringGeometry(/** @type {import("../geom/MultiLineString.js").default} */ geometry, options);
            break;
        case 'MultiPolygon':
            geoJSON = $93342158ce8701e7$var$writeMultiPolygonGeometry(/** @type {import("../geom/MultiPolygon.js").default} */ geometry, options);
            break;
        case 'GeometryCollection':
            geoJSON = $93342158ce8701e7$var$writeGeometryCollectionGeometry(/** @type {import("../geom/GeometryCollection.js").default} */ geometry, options);
            break;
        case 'Circle':
            geoJSON = {
                type: 'GeometryCollection',
                geometries: []
            };
            break;
        default:
            throw new Error('Unsupported geometry type: ' + type);
    }
    return geoJSON;
}
/**
 * @param {import("../geom/GeometryCollection.js").default} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [options] Write options.
 * @return {GeoJSONGeometryCollection} GeoJSON geometry collection.
 */ function $93342158ce8701e7$var$writeGeometryCollectionGeometry(geometry, options) {
    options = Object.assign({}, options);
    delete options.featureProjection;
    const geometries = geometry.getGeometriesArray().map(function(geometry) {
        return $93342158ce8701e7$var$writeGeometry(geometry, options);
    });
    return {
        type: 'GeometryCollection',
        geometries: geometries
    };
}
/**
 * @param {import("../geom/LineString.js").default} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [options] Write options.
 * @return {GeoJSONGeometry} GeoJSON geometry.
 */ function $93342158ce8701e7$var$writeLineStringGeometry(geometry, options) {
    return {
        type: 'LineString',
        coordinates: geometry.getCoordinates()
    };
}
/**
 * @param {import("../geom/MultiLineString.js").default} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [options] Write options.
 * @return {GeoJSONGeometry} GeoJSON geometry.
 */ function $93342158ce8701e7$var$writeMultiLineStringGeometry(geometry, options) {
    return {
        type: 'MultiLineString',
        coordinates: geometry.getCoordinates()
    };
}
/**
 * @param {import("../geom/MultiPoint.js").default} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [options] Write options.
 * @return {GeoJSONGeometry} GeoJSON geometry.
 */ function $93342158ce8701e7$var$writeMultiPointGeometry(geometry, options) {
    return {
        type: 'MultiPoint',
        coordinates: geometry.getCoordinates()
    };
}
/**
 * @param {import("../geom/MultiPolygon.js").default} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [options] Write options.
 * @return {GeoJSONGeometry} GeoJSON geometry.
 */ function $93342158ce8701e7$var$writeMultiPolygonGeometry(geometry, options) {
    let right;
    if (options) right = options.rightHanded;
    return {
        type: 'MultiPolygon',
        coordinates: geometry.getCoordinates(right)
    };
}
/**
 * @param {import("../geom/Point.js").default} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [options] Write options.
 * @return {GeoJSONGeometry} GeoJSON geometry.
 */ function $93342158ce8701e7$var$writePointGeometry(geometry, options) {
    return {
        type: 'Point',
        coordinates: geometry.getCoordinates()
    };
}
/**
 * @param {import("../geom/Polygon.js").default} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [options] Write options.
 * @return {GeoJSONGeometry} GeoJSON geometry.
 */ function $93342158ce8701e7$var$writePolygonGeometry(geometry, options) {
    let right;
    if (options) right = options.rightHanded;
    return {
        type: 'Polygon',
        coordinates: geometry.getCoordinates(right)
    };
}
var $93342158ce8701e7$export$2e2bcd8739ae039 = $93342158ce8701e7$var$GeoJSON;


/**
 * @module ol/interaction/MouseWheelZoom
 */ 
/**
 * @module ol/events/condition
 */ /**
 * @module ol/MapBrowserEventType
 */ 
var /**
 * Constants for event names.
 * @enum {string}
 */ $1b4cb51f4587f284$export$2e2bcd8739ae039 /***
 * @typedef {'singleclick'|'click'|'dblclick'|'pointerdrag'|'pointermove'} Types
 */  = {
    /**
   * A true single click with no dragging and no double click. Note that this
   * event is delayed by 250 ms to ensure that it is not a double click.
   * @event module:ol/MapBrowserEvent~MapBrowserEvent#singleclick
   * @api
   */ SINGLECLICK: 'singleclick',
    /**
   * A click with no dragging. A double click will fire two of this.
   * @event module:ol/MapBrowserEvent~MapBrowserEvent#click
   * @api
   */ CLICK: (0, $b5fa963342da4935$export$2e2bcd8739ae039).CLICK,
    /**
   * A true double click, with no dragging.
   * @event module:ol/MapBrowserEvent~MapBrowserEvent#dblclick
   * @api
   */ DBLCLICK: (0, $b5fa963342da4935$export$2e2bcd8739ae039).DBLCLICK,
    /**
   * Triggered when a pointer is dragged.
   * @event module:ol/MapBrowserEvent~MapBrowserEvent#pointerdrag
   * @api
   */ POINTERDRAG: 'pointerdrag',
    /**
   * Triggered when a pointer is moved. Note that on touch devices this is
   * triggered when the map is panned, so is not the same as mousemove.
   * @event module:ol/MapBrowserEvent~MapBrowserEvent#pointermove
   * @api
   */ POINTERMOVE: 'pointermove',
    POINTERDOWN: 'pointerdown',
    POINTERUP: 'pointerup',
    POINTEROVER: 'pointerover',
    POINTEROUT: 'pointerout',
    POINTERENTER: 'pointerenter',
    POINTERLEAVE: 'pointerleave',
    POINTERCANCEL: 'pointercancel'
};




function $638912a122b4daef$export$84bf76cd7afc7469(var_args) {
    const conditions = arguments;
    /**
   * @param {import("../MapBrowserEvent.js").default} event Event.
   * @return {boolean} All conditions passed.
   */ return function(event) {
        let pass = true;
        for(let i = 0, ii = conditions.length; i < ii; ++i){
            pass = pass && conditions[i](event);
            if (!pass) break;
        }
        return pass;
    };
}
const $638912a122b4daef$export$573409992e89967e = function(mapBrowserEvent) {
    const originalEvent = mapBrowserEvent.originalEvent;
    return originalEvent.altKey && !(originalEvent.metaKey || originalEvent.ctrlKey) && !originalEvent.shiftKey;
};
const $638912a122b4daef$export$4e5f01653f9f1f82 = function(mapBrowserEvent) {
    const originalEvent = mapBrowserEvent.originalEvent;
    return originalEvent.altKey && !(originalEvent.metaKey || originalEvent.ctrlKey) && originalEvent.shiftKey;
};
const $638912a122b4daef$export$d7ddd398f22d79ef = function(event) {
    const targetElement = event.map.getTargetElement();
    const rootNode = targetElement.getRootNode();
    const activeElement = event.map.getOwnerDocument().activeElement;
    return rootNode instanceof ShadowRoot ? rootNode.host.contains(activeElement) : targetElement.contains(activeElement);
};
const $638912a122b4daef$export$ae2cdf064e3b0c55 = function(event) {
    const targetElement = event.map.getTargetElement();
    const rootNode = targetElement.getRootNode();
    const tabIndexCandidate = rootNode instanceof ShadowRoot ? rootNode.host : targetElement;
    return tabIndexCandidate.hasAttribute('tabindex') ? $638912a122b4daef$export$d7ddd398f22d79ef(event) : true;
};
const $638912a122b4daef$export$ba9e5d519bc326ca = (0, $bc15bca7780ad95b$export$22e23a2304399231);
const $638912a122b4daef$export$64ef1bee2b9504c1 = function(mapBrowserEvent) {
    return mapBrowserEvent.type == (0, $1b4cb51f4587f284$export$2e2bcd8739ae039).CLICK;
};
const $638912a122b4daef$export$1238ad6b5e7fff70 = function(mapBrowserEvent) {
    const originalEvent = mapBrowserEvent.originalEvent;
    return 'pointerId' in originalEvent && originalEvent.button == 0 && !((0, $32d41268b5f53567$export$39dfd62a25e0fe93) && (0, $32d41268b5f53567$export$76c0a3b101d93136) && originalEvent.ctrlKey);
};
const $638912a122b4daef$export$b3e22bcfd64c1022 = (0, $bc15bca7780ad95b$export$8f11cee4bdc7e668);
const $638912a122b4daef$export$71eac0963f2c2f01 = function(mapBrowserEvent) {
    return mapBrowserEvent.type == 'pointermove';
};
const $638912a122b4daef$export$194df8bad091b401 = function(mapBrowserEvent) {
    return mapBrowserEvent.type == (0, $1b4cb51f4587f284$export$2e2bcd8739ae039).SINGLECLICK;
};
const $638912a122b4daef$export$c59d944dd10b3dc7 = function(mapBrowserEvent) {
    return mapBrowserEvent.type == (0, $1b4cb51f4587f284$export$2e2bcd8739ae039).DBLCLICK;
};
const $638912a122b4daef$export$fdc892d0d8fe3bfb = function(mapBrowserEvent) {
    const originalEvent = /** @type {KeyboardEvent|MouseEvent|TouchEvent} */ mapBrowserEvent.originalEvent;
    return !originalEvent.altKey && !(originalEvent.metaKey || originalEvent.ctrlKey) && !originalEvent.shiftKey;
};
const $638912a122b4daef$export$f3100d8d6292d638 = function(mapBrowserEvent) {
    const originalEvent = mapBrowserEvent.originalEvent;
    return !originalEvent.altKey && ((0, $32d41268b5f53567$export$76c0a3b101d93136) ? originalEvent.metaKey : originalEvent.ctrlKey) && !originalEvent.shiftKey;
};
const $638912a122b4daef$export$32603ad571dd22b5 = function(mapBrowserEvent) {
    const originalEvent = mapBrowserEvent.originalEvent;
    return (0, $32d41268b5f53567$export$76c0a3b101d93136) ? originalEvent.metaKey : originalEvent.ctrlKey;
};
const $638912a122b4daef$export$5d31fe68a477cfbb = function(mapBrowserEvent) {
    const originalEvent = mapBrowserEvent.originalEvent;
    return !originalEvent.altKey && !(originalEvent.metaKey || originalEvent.ctrlKey) && originalEvent.shiftKey;
};
const $638912a122b4daef$export$e5570ca80cd8fd54 = function(mapBrowserEvent) {
    const originalEvent = mapBrowserEvent.originalEvent;
    const tagName = /** @type {Element} */ originalEvent.target.tagName;
    return tagName !== 'INPUT' && tagName !== 'SELECT' && tagName !== 'TEXTAREA' && // `isContentEditable` is only available on `HTMLElement`, but it may also be a
    // different type like `SVGElement`.
    // @ts-ignore
    !originalEvent.target.isContentEditable;
};
const $638912a122b4daef$export$abb7acbfa76bf3c4 = function(mapBrowserEvent) {
    const pointerEvent = mapBrowserEvent.originalEvent;
    // see https://www.w3.org/TR/pointerevents/#widl-PointerEvent-pointerType
    return 'pointerId' in pointerEvent && pointerEvent.pointerType == 'mouse';
};
const $638912a122b4daef$export$e74de664a571d084 = function(mapBrowserEvent) {
    const pointerEvt = mapBrowserEvent.originalEvent;
    // see https://www.w3.org/TR/pointerevents/#widl-PointerEvent-pointerType
    return 'pointerId' in pointerEvt && pointerEvt.pointerType === 'touch';
};
const $638912a122b4daef$export$cd1707283a23f059 = function(mapBrowserEvent) {
    const pointerEvt = mapBrowserEvent.originalEvent;
    // see https://www.w3.org/TR/pointerevents/#widl-PointerEvent-pointerType
    return 'pointerId' in pointerEvt && pointerEvt.pointerType === 'pen';
};
const $638912a122b4daef$export$189f0d593022b199 = function(mapBrowserEvent) {
    const pointerEvent = mapBrowserEvent.originalEvent;
    return 'pointerId' in pointerEvent && pointerEvent.isPrimary && pointerEvent.button === 0;
};



/**
 * @module ol/interaction/Interaction
 */ 

/**
 * @module ol/interaction/Property
 */ /**
 * @enum {string}
 */ var $273e59fcc49a5e15$export$2e2bcd8739ae039 = {
    ACTIVE: 'active'
};


/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types|
 *     'change:active', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types|
 *     'change:active', Return>} InteractionOnSignature
 */ /**
 * Object literal with config options for interactions.
 * @typedef {Object} InteractionOptions
 * @property {function(import("../MapBrowserEvent.js").default):boolean} [handleEvent]
 * Method called by the map to notify the interaction that a browser event was
 * dispatched to the map. If the function returns a falsy value, propagation of
 * the event to other interactions in the map's interactions chain will be
 * prevented (this includes functions with no explicit return). The interactions
 * are traversed in reverse order of the interactions collection of the map.
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * User actions that change the state of the map. Some are similar to controls,
 * but are not associated with a DOM element.
 * For example, {@link module:ol/interaction/KeyboardZoom~KeyboardZoom} is
 * functionally the same as {@link module:ol/control/Zoom~Zoom}, but triggered
 * by a keyboard event not a button element event.
 * Although interactions do not have a DOM element, some of them do render
 * vectors and so are visible on the screen.
 * @api
 */ class $24f38e4defed3bcd$var$Interaction extends (0, $4862cdcc23257f5b$export$2e2bcd8739ae039) {
    /**
   * @param {InteractionOptions} [options] Options.
   */ constructor(options){
        super();
        /***
     * @type {InteractionOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {InteractionOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {InteractionOnSignature<void>}
     */ this.un;
        if (options && options.handleEvent) this.handleEvent = options.handleEvent;
        /**
     * @private
     * @type {import("../Map.js").default|null}
     */ this.map_ = null;
        this.setActive(true);
    }
    /**
   * Return whether the interaction is currently active.
   * @return {boolean} `true` if the interaction is active, `false` otherwise.
   * @observable
   * @api
   */ getActive() {
        return /** @type {boolean} */ this.get((0, $273e59fcc49a5e15$export$2e2bcd8739ae039).ACTIVE);
    }
    /**
   * Get the map associated with this interaction.
   * @return {import("../Map.js").default|null} Map.
   * @api
   */ getMap() {
        return this.map_;
    }
    /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event}.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @api
   */ handleEvent(mapBrowserEvent) {
        return true;
    }
    /**
   * Activate or deactivate the interaction.
   * @param {boolean} active Active.
   * @observable
   * @api
   */ setActive(active) {
        this.set((0, $273e59fcc49a5e15$export$2e2bcd8739ae039).ACTIVE, active);
    }
    /**
   * Remove the interaction from its current map and attach it to the new map.
   * Subclasses may set up event handlers to get notified about changes to
   * the map here.
   * @param {import("../Map.js").default|null} map Map.
   */ setMap(map) {
        this.map_ = map;
    }
}
function $24f38e4defed3bcd$export$4c486572e961a974(view, delta, duration) {
    const currentCenter = view.getCenterInternal();
    if (currentCenter) {
        const center = [
            currentCenter[0] + delta[0],
            currentCenter[1] + delta[1]
        ];
        view.animateInternal({
            duration: duration !== undefined ? duration : 250,
            easing: (0, $386674cda6e01ace$export$45db2fc2f15997e7),
            center: view.getConstrainedCenter(center)
        });
    }
}
function $24f38e4defed3bcd$export$ace321ff2a8016ef(view, delta, anchor, duration) {
    const currentZoom = view.getZoom();
    if (currentZoom === undefined) return;
    const newZoom = view.getConstrainedZoom(currentZoom + delta);
    const newResolution = view.getResolutionForZoom(newZoom);
    if (view.getAnimating()) view.cancelAnimations();
    view.animate({
        resolution: newResolution,
        anchor: anchor,
        duration: duration !== undefined ? duration : 250,
        easing: (0, $386674cda6e01ace$export$57636bb43b1ccbb0)
    });
}
var $24f38e4defed3bcd$export$2e2bcd8739ae039 = $24f38e4defed3bcd$var$Interaction;


/**
 * @typedef {'trackpad' | 'wheel'} Mode
 */ /**
 * @typedef {Object} Options
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled. Default is
 * {@link module:ol/events/condition.always}.
 * @property {boolean} [onFocusOnly=false] When the map's target has a `tabindex` attribute set,
 * the interaction will only handle events when the map has the focus.
 * @property {number} [maxDelta=1] Maximum mouse wheel delta.
 * @property {number} [duration=250] Animation duration in milliseconds.
 * @property {number} [timeout=80] Mouse wheel timeout duration in milliseconds.
 * @property {boolean} [useAnchor=true] Enable zooming using the mouse's
 * location as the anchor. When set to `false`, zooming in and out will zoom to
 * the center of the screen instead of zooming on the mouse's location.
 * @property {boolean} [constrainResolution=false] If true, the mouse wheel zoom
 * event will always animate to the closest zoom level after an interaction;
 * false means intermediary zoom levels are allowed.
 */ /**
 * Mutliplier for the DOM_DELTA_LINE delta value.
 * @type {number}
 */ const $f18552b5a876d636$var$DELTA_LINE_MULTIPLIER = 40;
/**
 * Mutliplier for the DOM_DELTA_PAGE delta value.
 * @type {number}
 */ const $f18552b5a876d636$var$DELTA_PAGE_MULTIPLIER = 300;
/**
 * @classdesc
 * Allows the user to zoom the map by scrolling the mouse wheel.
 * @api
 */ class $f18552b5a876d636$var$MouseWheelZoom extends (0, $24f38e4defed3bcd$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        super(/** @type {import("./Interaction.js").InteractionOptions} */ options);
        /**
     * @private
     * @type {number}
     */ this.totalDelta_ = 0;
        /**
     * @private
     * @type {number}
     */ this.lastDelta_ = 0;
        /**
     * @private
     * @type {number}
     */ this.maxDelta_ = options.maxDelta !== undefined ? options.maxDelta : 1;
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 250;
        /**
     * @private
     * @type {number}
     */ this.timeout_ = options.timeout !== undefined ? options.timeout : 80;
        /**
     * @private
     * @type {boolean}
     */ this.useAnchor_ = options.useAnchor !== undefined ? options.useAnchor : true;
        /**
     * @private
     * @type {boolean}
     */ this.constrainResolution_ = options.constrainResolution !== undefined ? options.constrainResolution : false;
        const condition = options.condition ? options.condition : (0, $638912a122b4daef$export$ba9e5d519bc326ca);
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.onFocusOnly ? (0, $638912a122b4daef$export$84bf76cd7afc7469)((0, $638912a122b4daef$export$ae2cdf064e3b0c55), condition) : condition;
        /**
     * @private
     * @type {?import("../pixel.js").Pixel}
     */ this.lastAnchor_ = null;
        /**
     * @private
     * @type {number|undefined}
     */ this.startTime_ = undefined;
        /**
     * @private
     * @type {ReturnType<typeof setTimeout>}
     */ this.timeoutId_;
        /**
     * @private
     * @type {Mode|undefined}
     */ this.mode_ = undefined;
        /**
     * Trackpad events separated by this delay will be considered separate
     * interactions.
     * @private
     * @type {number}
     */ this.trackpadEventGap_ = 400;
        /**
     * @private
     * @type {ReturnType<typeof setTimeout>}
     */ this.trackpadTimeoutId_;
        /**
     * The number of delta values per zoom level
     * @private
     * @type {number}
     */ this.deltaPerZoom_ = 300;
    }
    /**
   * @private
   */ endInteraction_() {
        this.trackpadTimeoutId_ = undefined;
        const map = this.getMap();
        if (!map) return;
        const view = map.getView();
        view.endInteraction(undefined, this.lastDelta_ ? this.lastDelta_ > 0 ? 1 : -1 : 0, this.lastAnchor_ ? map.getCoordinateFromPixel(this.lastAnchor_) : null);
    }
    /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} (if it was a mousewheel-event) and eventually
   * zooms the map.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @override
   */ handleEvent(mapBrowserEvent) {
        if (!this.condition_(mapBrowserEvent)) return true;
        const type = mapBrowserEvent.type;
        if (type !== (0, $b5fa963342da4935$export$2e2bcd8739ae039).WHEEL) return true;
        const map = mapBrowserEvent.map;
        const wheelEvent = /** @type {WheelEvent} */ mapBrowserEvent.originalEvent;
        wheelEvent.preventDefault();
        if (this.useAnchor_) this.lastAnchor_ = mapBrowserEvent.pixel;
        // Delta normalisation inspired by
        // https://github.com/mapbox/mapbox-gl-js/blob/001c7b9/js/ui/handler/scroll_zoom.js
        let delta = wheelEvent.deltaY;
        switch(wheelEvent.deltaMode){
            case WheelEvent.DOM_DELTA_LINE:
                delta *= $f18552b5a876d636$var$DELTA_LINE_MULTIPLIER;
                break;
            case WheelEvent.DOM_DELTA_PAGE:
                delta *= $f18552b5a876d636$var$DELTA_PAGE_MULTIPLIER;
                break;
            default:
        }
        if (delta === 0) return false;
        this.lastDelta_ = delta;
        const now = Date.now();
        if (this.startTime_ === undefined) this.startTime_ = now;
        if (!this.mode_ || now - this.startTime_ > this.trackpadEventGap_) this.mode_ = Math.abs(delta) < 4 ? 'trackpad' : 'wheel';
        const view = map.getView();
        if (this.mode_ === 'trackpad' && !(view.getConstrainResolution() || this.constrainResolution_)) {
            if (this.trackpadTimeoutId_) clearTimeout(this.trackpadTimeoutId_);
            else {
                if (view.getAnimating()) view.cancelAnimations();
                view.beginInteraction();
            }
            this.trackpadTimeoutId_ = setTimeout(this.endInteraction_.bind(this), this.timeout_);
            view.adjustZoom(-delta / this.deltaPerZoom_, this.lastAnchor_ ? map.getCoordinateFromPixel(this.lastAnchor_) : null);
            this.startTime_ = now;
            return false;
        }
        this.totalDelta_ += delta;
        const timeLeft = Math.max(this.timeout_ - (now - this.startTime_), 0);
        clearTimeout(this.timeoutId_);
        this.timeoutId_ = setTimeout(this.handleWheelZoom_.bind(this, map), timeLeft);
        return false;
    }
    /**
   * @private
   * @param {import("../Map.js").default} map Map.
   */ handleWheelZoom_(map) {
        const view = map.getView();
        if (view.getAnimating()) view.cancelAnimations();
        let delta = -(0, $6a95bd76d7103f37$export$7d15b64cf5a3a4c4)(this.totalDelta_, -this.maxDelta_ * this.deltaPerZoom_, this.maxDelta_ * this.deltaPerZoom_) / this.deltaPerZoom_;
        if (view.getConstrainResolution() || this.constrainResolution_) // view has a zoom constraint, zoom by 1
        delta = delta ? delta > 0 ? 1 : -1 : 0;
        (0, $24f38e4defed3bcd$export$ace321ff2a8016ef)(view, delta, this.lastAnchor_ ? map.getCoordinateFromPixel(this.lastAnchor_) : null, this.duration_);
        this.mode_ = undefined;
        this.totalDelta_ = 0;
        this.lastAnchor_ = null;
        this.startTime_ = undefined;
        this.timeoutId_ = undefined;
    }
    /**
   * Enable or disable using the mouse's location as an anchor when zooming
   * @param {boolean} useAnchor true to zoom to the mouse's location, false
   * to zoom to the center of the map
   * @api
   */ setMouseAnchor(useAnchor) {
        this.useAnchor_ = useAnchor;
        if (!useAnchor) this.lastAnchor_ = null;
    }
}
var $f18552b5a876d636$export$2e2bcd8739ae039 = $f18552b5a876d636$var$MouseWheelZoom;


/**
 * @module ol/layer/Tile
 */ /**
 * @module ol/renderer/canvas/TileLayer
 */ /**
 * @module ol/DataTile
 */ /**
 * @module ol/Tile
 */ /**
 * @module ol/TileState
 */ /**
 * @enum {number}
 */ var $79d423c0f6adbcbb$export$2e2bcd8739ae039 = {
    IDLE: 0,
    LOADING: 1,
    LOADED: 2,
    /**
   * Indicates that tile loading failed
   * @type {number}
   */ ERROR: 3,
    EMPTY: 4
};






/**
 * A function that takes a {@link module:ol/Tile~Tile} for the tile and a
 * `{string}` for the url as arguments. The default is
 * ```js
 * source.setTileLoadFunction(function(tile, src) {
 *   tile.getImage().src = src;
 * });
 * ```
 * For more fine grained control, the load function can use fetch or XMLHttpRequest and involve
 * error handling:
 *
 * ```js
 * import TileState from 'ol/TileState.js';
 *
 * source.setTileLoadFunction(function(tile, src) {
 *   const xhr = new XMLHttpRequest();
 *   xhr.responseType = 'blob';
 *   xhr.addEventListener('loadend', function (evt) {
 *     const data = this.response;
 *     if (data !== undefined) {
 *       tile.getImage().src = URL.createObjectURL(data);
 *     } else {
 *       tile.setState(TileState.ERROR);
 *     }
 *   });
 *   xhr.addEventListener('error', function () {
 *     tile.setState(TileState.ERROR);
 *   });
 *   xhr.open('GET', src);
 *   xhr.send();
 * });
 * ```
 *
 * @typedef {function(Tile, string): void} LoadFunction
 * @api
 */ /**
 * {@link module:ol/source/Tile~TileSource} sources use a function of this type to get
 * the url that provides a tile for a given tile coordinate.
 *
 * This function takes a {@link module:ol/tilecoord~TileCoord} for the tile
 * coordinate, a `{number}` representing the pixel ratio and a
 * {@link module:ol/proj/Projection~Projection} for the projection  as arguments
 * and returns a `{string}` representing the tile URL, or undefined if no tile
 * should be requested for the passed tile coordinate.
 *
 * @typedef {function(import("./tilecoord.js").TileCoord, number,
 *           import("./proj/Projection.js").default): (string|undefined)} UrlFunction
 * @api
 */ /**
 * @typedef {Object} Options
 * @property {number} [transition=250] A duration for tile opacity
 * transitions in milliseconds. A duration of 0 disables the opacity transition.
 * @property {boolean} [interpolate=false] Use interpolated values when resampling.  By default,
 * the nearest neighbor is used when resampling.
 * @api
 */ /**
 * @classdesc
 * Base class for tiles.
 *
 * @abstract
 */ class $9fb956e5836dc6e1$var$Tile extends (0, $272b64a21016b61a$export$2e2bcd8739ae039) {
    /**
   * @param {import("./tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {import("./TileState.js").default} state State.
   * @param {Options} [options] Tile options.
   */ constructor(tileCoord, state, options){
        super();
        options = options ? options : {};
        /**
     * @type {import("./tilecoord.js").TileCoord}
     */ this.tileCoord = tileCoord;
        /**
     * @protected
     * @type {import("./TileState.js").default}
     */ this.state = state;
        /**
     * A key assigned to the tile. This is used in conjunction with a source key
     * to determine if a cached version of this tile may be used by the renderer.
     * @type {string}
     */ this.key = '';
        /**
     * The duration for the opacity transition.
     * @private
     * @type {number}
     */ this.transition_ = options.transition === undefined ? 250 : options.transition;
        /**
     * Lookup of start times for rendering transitions.  If the start time is
     * equal to -1, the transition is complete.
     * @private
     * @type {Object<string, number>}
     */ this.transitionStarts_ = {};
        /**
     * @type {boolean}
     */ this.interpolate = !!options.interpolate;
    }
    /**
   * @protected
   */ changed() {
        this.dispatchEvent((0, $b5fa963342da4935$export$2e2bcd8739ae039).CHANGE);
    }
    /**
   * Called by the tile cache when the tile is removed from the cache due to expiry
   */ release() {
        // to remove the `change` listener on this tile in `ol/TileQueue#handleTileChange`
        this.setState((0, $79d423c0f6adbcbb$export$2e2bcd8739ae039).EMPTY);
    }
    /**
   * @return {string} Key.
   */ getKey() {
        return this.key + '/' + this.tileCoord;
    }
    /**
   * Get the tile coordinate for this tile.
   * @return {import("./tilecoord.js").TileCoord} The tile coordinate.
   * @api
   */ getTileCoord() {
        return this.tileCoord;
    }
    /**
   * @return {import("./TileState.js").default} State.
   */ getState() {
        return this.state;
    }
    /**
   * Sets the state of this tile. If you write your own {@link module:ol/Tile~LoadFunction tileLoadFunction} ,
   * it is important to set the state correctly to {@link module:ol/TileState~ERROR}
   * when the tile cannot be loaded. Otherwise the tile cannot be removed from
   * the tile queue and will block other requests.
   * @param {import("./TileState.js").default} state State.
   * @api
   */ setState(state) {
        if (this.state === (0, $79d423c0f6adbcbb$export$2e2bcd8739ae039).EMPTY) // no more state changes
        return;
        if (this.state !== (0, $79d423c0f6adbcbb$export$2e2bcd8739ae039).ERROR && this.state > state) throw new Error('Tile load sequence violation');
        this.state = state;
        this.changed();
    }
    /**
   * Load the image or retry if loading previously failed.
   * Loading is taken care of by the tile queue, and calling this method is
   * only needed for preloading or for reloading in case of an error.
   * @abstract
   * @api
   */ load() {
        (0, $fd76d391cc228565$export$817eb92a8194bab0)();
    }
    /**
   * Get the alpha value for rendering.
   * @param {string} id An id for the renderer.
   * @param {number} time The render frame time.
   * @return {number} A number between 0 and 1.
   */ getAlpha(id, time) {
        if (!this.transition_) return 1;
        let start = this.transitionStarts_[id];
        if (!start) {
            start = time;
            this.transitionStarts_[id] = start;
        } else if (start === -1) return 1;
        const delta = time - start + 1000 / 60; // avoid rendering at 0
        if (delta >= this.transition_) return 1;
        return (0, $386674cda6e01ace$export$929e5a82286172a6)(delta / this.transition_);
    }
    /**
   * Determine if a tile is in an alpha transition.  A tile is considered in
   * transition if tile.getAlpha() has not yet been called or has been called
   * and returned 1.
   * @param {string} id An id for the renderer.
   * @return {boolean} The tile is in transition.
   */ inTransition(id) {
        if (!this.transition_) return false;
        return this.transitionStarts_[id] !== -1;
    }
    /**
   * Mark a transition as complete.
   * @param {string} id An id for the renderer.
   */ endTransition(id) {
        if (this.transition_) this.transitionStarts_[id] = -1;
    }
    /**
   * @override
   */ disposeInternal() {
        this.release();
        super.disposeInternal();
    }
}
var $9fb956e5836dc6e1$export$2e2bcd8739ae039 = $9fb956e5836dc6e1$var$Tile;




function $98966536a4c579a6$export$3a7c913cb40dcb7d(data) {
    return data instanceof Image || data instanceof HTMLCanvasElement || data instanceof HTMLVideoElement || data instanceof ImageBitmap ? data : null;
}
function $98966536a4c579a6$export$7386cb0413f6b283(data) {
    return data instanceof Uint8Array || data instanceof Uint8ClampedArray || data instanceof Float32Array || data instanceof DataView ? data : null;
}
const $98966536a4c579a6$export$df4c617b86128e3e = new Error('disposed');
/**
 * @type {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D|null}
 */ let $98966536a4c579a6$var$sharedContext = null;
function $98966536a4c579a6$export$45b10814cc054894(image) {
    if (!$98966536a4c579a6$var$sharedContext) $98966536a4c579a6$var$sharedContext = (0, $b6f6d442e8ff57e1$export$9e05d10eae75c464)(image.width, image.height, undefined, {
        willReadFrequently: true
    });
    const canvas = $98966536a4c579a6$var$sharedContext.canvas;
    const width = image.width;
    if (canvas.width !== width) canvas.width = width;
    const height = image.height;
    if (canvas.height !== height) canvas.height = height;
    $98966536a4c579a6$var$sharedContext.clearRect(0, 0, width, height);
    $98966536a4c579a6$var$sharedContext.drawImage(image, 0, 0);
    return $98966536a4c579a6$var$sharedContext.getImageData(0, 0, width, height).data;
}
/**
 * @type {import('./size.js').Size}
 */ const $98966536a4c579a6$var$defaultSize = [
    256,
    256
];
/**
 * @typedef {Object} Options
 * @property {import("./tilecoord.js").TileCoord} tileCoord Tile coordinate.
 * @property {function(): Promise<Data>} loader Data loader.  For loaders that generate images,
 * the promise should not resolve until the image is loaded.
 * @property {number} [transition=250] A duration for tile opacity
 * transitions in milliseconds. A duration of 0 disables the opacity transition.
 * @property {boolean} [interpolate=false] Use interpolated values when resampling.  By default,
 * the nearest neighbor is used when resampling.
 * @property {import('./size.js').Size} [size=[256, 256]] Tile size.
 * @property {AbortController} [controller] An abort controller.
 * @api
 */ class $98966536a4c579a6$var$DataTile extends (0, $9fb956e5836dc6e1$export$2e2bcd8739ae039) {
    /**
   * @param {Options} options Tile options.
   */ constructor(options){
        const state = (0, $79d423c0f6adbcbb$export$2e2bcd8739ae039).IDLE;
        super(options.tileCoord, state, {
            transition: options.transition,
            interpolate: options.interpolate
        });
        /**
     * @type {function(): Promise<Data>}
     * @private
     */ this.loader_ = options.loader;
        /**
     * @type {Data}
     * @private
     */ this.data_ = null;
        /**
     * @type {Error}
     * @private
     */ this.error_ = null;
        /**
     * @type {import('./size.js').Size|null}
     * @private
     */ this.size_ = options.size || null;
        /**
     * @type {AbortController|null}
     * @private
     */ this.controller_ = options.controller || null;
    }
    /**
   * Get the tile size.
   * @return {import('./size.js').Size} Tile size.
   */ getSize() {
        if (this.size_) return this.size_;
        const imageData = $98966536a4c579a6$export$3a7c913cb40dcb7d(this.data_);
        if (imageData) return [
            imageData.width,
            imageData.height
        ];
        return $98966536a4c579a6$var$defaultSize;
    }
    /**
   * Get the data for the tile.
   * @return {Data} Tile data.
   * @api
   */ getData() {
        return this.data_;
    }
    /**
   * Get any loading error.
   * @return {Error} Loading error.
   * @api
   */ getError() {
        return this.error_;
    }
    /**
   * Load the tile data.
   * @api
   * @override
   */ load() {
        if (this.state !== (0, $79d423c0f6adbcbb$export$2e2bcd8739ae039).IDLE && this.state !== (0, $79d423c0f6adbcbb$export$2e2bcd8739ae039).ERROR) return;
        this.state = (0, $79d423c0f6adbcbb$export$2e2bcd8739ae039).LOADING;
        this.changed();
        const self = this;
        this.loader_().then(function(data) {
            self.data_ = data;
            self.state = (0, $79d423c0f6adbcbb$export$2e2bcd8739ae039).LOADED;
            self.changed();
        }).catch(function(error) {
            self.error_ = error;
            self.state = (0, $79d423c0f6adbcbb$export$2e2bcd8739ae039).ERROR;
            self.changed();
        });
    }
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        if (this.controller_) {
            this.controller_.abort($98966536a4c579a6$export$df4c617b86128e3e);
            this.controller_ = null;
        }
        super.disposeInternal();
    }
}
var $98966536a4c579a6$export$2e2bcd8739ae039 = $98966536a4c579a6$var$DataTile;


/**
 * @module ol/ImageTile
 */ /**
 * @module ol/Image
 */ /**
 * @module ol/ImageState
 */ /**
 * @enum {number}
 */ var $f217251b3f1483a0$export$2e2bcd8739ae039 = {
    IDLE: 0,
    LOADING: 1,
    LOADED: 2,
    ERROR: 3,
    EMPTY: 4
};







/**
 * A function that takes an {@link module:ol/Image~ImageWrapper} for the image and a
 * `{string}` for the src as arguments. It is supposed to make it so the
 * underlying image {@link module:ol/Image~ImageWrapper#getImage} is assigned the
 * content specified by the src. If not specified, the default is
 *
 *     function(image, src) {
 *       image.getImage().src = src;
 *     }
 *
 * Providing a custom `imageLoadFunction` can be useful to load images with
 * post requests or - in general - through XHR requests, where the src of the
 * image element would be set to a data URI when the content is loaded.
 *
 * @typedef {function(import("./Image.js").default, string): void} LoadFunction
 * @api
 */ /**
 * @typedef {Object} ImageObject
 * @property {import("./extent.js").Extent} [extent] Extent, if different from the requested one.
 * @property {import("./resolution.js").ResolutionLike} [resolution] Resolution, if different from the requested one.
 * When x and y resolution are different, use the array type (`[xResolution, yResolution]`).
 * @property {number} [pixelRatio] Pixel ratio, if different from the requested one.
 * @property {import('./DataTile.js').ImageLike} image Image.
 */ /**
 * Loader function used for image sources. Receives extent, resolution and pixel ratio as arguments.
 * For images that cover any extent and resolution (static images), the loader function should not accept
 * any arguments. The function returns an {@link import("./DataTile.js").ImageLike image}, an
 * {@link import("./Image.js").ImageObject image object}, or a promise for the same.
 * For loaders that generate images, the promise should not resolve until the image is loaded.
 * If the returned image does not match the extent, resolution or pixel ratio passed to the loader,
 * it has to return an {@link import("./Image.js").ImageObject image object} with the `image` and the
 * correct `extent`, `resolution` and `pixelRatio`.
 *
 * @typedef {function(import("./extent.js").Extent, number, number, (function(HTMLImageElement, string): void)=): import("./DataTile.js").ImageLike|ImageObject|Promise<import("./DataTile.js").ImageLike|ImageObject>} Loader
 * @api
 */ /**
 * Loader function used for image sources. Receives extent, resolution and pixel ratio as arguments.
 * The function returns a promise for an  {@link import("./Image.js").ImageObject image object}.
 *
 * @typedef {function(import("./extent.js").Extent, number, number, (function(HTMLImageElement, string): void)=): Promise<import("./DataTile.js").ImageLike|ImageObject>} ImageObjectPromiseLoader
 */ class $617ef54ed150e783$var$ImageWrapper extends (0, $272b64a21016b61a$export$2e2bcd8739ae039) {
    /**
   * @param {import("./extent.js").Extent} extent Extent.
   * @param {number|Array<number>|undefined} resolution Resolution. If provided as array, x and y
   * resolution will be assumed.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("./ImageState.js").default|Loader} stateOrLoader State.
   */ constructor(extent, resolution, pixelRatio, stateOrLoader){
        super();
        /**
     * @protected
     * @type {import("./extent.js").Extent}
     */ this.extent = extent;
        /**
     * @private
     * @type {number}
     */ this.pixelRatio_ = pixelRatio;
        /**
     * @protected
     * @type {number|Array<number>|undefined}
     */ this.resolution = resolution;
        /**
     * @protected
     * @type {import("./ImageState.js").default}
     */ this.state = typeof stateOrLoader === 'function' ? (0, $f217251b3f1483a0$export$2e2bcd8739ae039).IDLE : stateOrLoader;
        /**
     * @private
     * @type {import('./DataTile.js').ImageLike|null}
     */ this.image_ = null;
        /**
     * @protected
     * @type {Loader|null}
     */ this.loader = typeof stateOrLoader === 'function' ? stateOrLoader : null;
    }
    /**
   * @protected
   */ changed() {
        this.dispatchEvent((0, $b5fa963342da4935$export$2e2bcd8739ae039).CHANGE);
    }
    /**
   * @return {import("./extent.js").Extent} Extent.
   */ getExtent() {
        return this.extent;
    }
    /**
   * @return {import('./DataTile.js').ImageLike} Image.
   */ getImage() {
        return this.image_;
    }
    /**
   * @return {number} PixelRatio.
   */ getPixelRatio() {
        return this.pixelRatio_;
    }
    /**
   * @return {number|Array<number>} Resolution.
   */ getResolution() {
        return /** @type {number} */ this.resolution;
    }
    /**
   * @return {import("./ImageState.js").default} State.
   */ getState() {
        return this.state;
    }
    /**
   * Load not yet loaded URI.
   */ load() {
        if (this.state == (0, $f217251b3f1483a0$export$2e2bcd8739ae039).IDLE) {
            if (this.loader) {
                this.state = (0, $f217251b3f1483a0$export$2e2bcd8739ae039).LOADING;
                this.changed();
                const resolution = this.getResolution();
                const requestResolution = Array.isArray(resolution) ? resolution[0] : resolution;
                (0, $bc15bca7780ad95b$export$4dbaaf6c79705e6c)(()=>this.loader(this.getExtent(), requestResolution, this.getPixelRatio())).then((image)=>{
                    if ('image' in image) this.image_ = image.image;
                    if ('extent' in image) this.extent = image.extent;
                    if ('resolution' in image) this.resolution = image.resolution;
                    if ('pixelRatio' in image) this.pixelRatio_ = image.pixelRatio;
                    if (image instanceof HTMLImageElement || (0, $32d41268b5f53567$export$7478563940788376) && image instanceof ImageBitmap || image instanceof HTMLCanvasElement || image instanceof HTMLVideoElement) this.image_ = image;
                    this.state = (0, $f217251b3f1483a0$export$2e2bcd8739ae039).LOADED;
                }).catch((error)=>{
                    this.state = (0, $f217251b3f1483a0$export$2e2bcd8739ae039).ERROR;
                    console.error(error); // eslint-disable-line no-console
                }).finally(()=>this.changed());
            }
        }
    }
    /**
   * @param {import('./DataTile.js').ImageLike} image The image.
   */ setImage(image) {
        this.image_ = image;
    }
    /**
   * @param {number|Array<number>} resolution Resolution.
   */ setResolution(resolution) {
        this.resolution = resolution;
    }
}
function $617ef54ed150e783$export$bc96ecc7c2a50764(image, loadHandler, errorHandler) {
    const img = /** @type {HTMLImageElement} */ image;
    let listening = true;
    let decoding = false;
    let loaded = false;
    const listenerKeys = [
        (0, $63963d09e0c49405$export$8d2a95bc11b44725)(img, (0, $b5fa963342da4935$export$2e2bcd8739ae039).LOAD, function() {
            loaded = true;
            if (!decoding) loadHandler();
        })
    ];
    if (img.src && (0, $32d41268b5f53567$export$716f8695eedb9bad)) {
        decoding = true;
        img.decode().then(function() {
            if (listening) loadHandler();
        }).catch(function(error) {
            if (listening) {
                if (loaded) loadHandler();
                else errorHandler();
            }
        });
    } else listenerKeys.push((0, $63963d09e0c49405$export$8d2a95bc11b44725)(img, (0, $b5fa963342da4935$export$2e2bcd8739ae039).ERROR, errorHandler));
    return function unlisten() {
        listening = false;
        listenerKeys.forEach((0, $63963d09e0c49405$export$b0a21c8b3c1c921));
    };
}
function $617ef54ed150e783$export$11e63f7b0f3d9900(image, src) {
    return new Promise((resolve, reject)=>{
        function handleLoad() {
            unlisten();
            resolve(image);
        }
        function handleError() {
            unlisten();
            reject(new Error('Image load error'));
        }
        function unlisten() {
            image.removeEventListener('load', handleLoad);
            image.removeEventListener('error', handleError);
        }
        image.addEventListener('load', handleLoad);
        image.addEventListener('error', handleError);
        if (src) image.src = src;
    });
}
function $617ef54ed150e783$export$a9e5af241c1bd389(image, src) {
    if (src) image.src = src;
    return image.src && (0, $32d41268b5f53567$export$716f8695eedb9bad) ? new Promise((resolve, reject)=>image.decode().then(()=>resolve(image)).catch((e)=>image.complete && image.width ? resolve(image) : reject(e))) : $617ef54ed150e783$export$11e63f7b0f3d9900(image);
}
function $617ef54ed150e783$export$2f872c0f2117be69(image, src) {
    if (src) image.src = src;
    return image.src && (0, $32d41268b5f53567$export$716f8695eedb9bad) && (0, $32d41268b5f53567$export$7478563940788376) ? image.decode().then(()=>createImageBitmap(image)).catch((e)=>{
        if (image.complete && image.width) return image;
        throw e;
    }) : $617ef54ed150e783$export$a9e5af241c1bd389(image);
}
var $617ef54ed150e783$export$2e2bcd8739ae039 = $617ef54ed150e783$var$ImageWrapper;






class $af328a9781fa918b$var$ImageTile extends (0, $9fb956e5836dc6e1$export$2e2bcd8739ae039) {
    /**
   * @param {import("./tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {import("./TileState.js").default} state State.
   * @param {string} src Image source URI.
   * @param {import('./dom.js').ImageAttributes} imageAttributes Image attributes options.
   * @param {import("./Tile.js").LoadFunction} tileLoadFunction Tile load function.
   * @param {import("./Tile.js").Options} [options] Tile options.
   */ constructor(tileCoord, state, src, imageAttributes, tileLoadFunction, options){
        super(tileCoord, state, options);
        /**
     * @private
     * @type {?string}
     */ this.crossOrigin_ = imageAttributes?.crossOrigin;
        /**
     * @private
     * @type {ReferrerPolicy}
     */ this.referrerPolicy_ = imageAttributes?.referrerPolicy;
        /**
     * Image URI
     *
     * @private
     * @type {string}
     */ this.src_ = src;
        this.key = src;
        /**
     * @private
     * @type {HTMLImageElement|HTMLCanvasElement|OffscreenCanvas}
     */ this.image_;
        if (0, $32d41268b5f53567$export$98fcef3dc9973292) this.image_ = new OffscreenCanvas(1, 1);
        else {
            this.image_ = new Image();
            if (this.crossOrigin_ !== null) this.image_.crossOrigin = this.crossOrigin_;
            if (this.referrerPolicy_ !== undefined) this.image_.referrerPolicy = this.referrerPolicy_;
        }
        /**
     * @private
     * @type {?function():void}
     */ this.unlisten_ = null;
        /**
     * @private
     * @type {import("./Tile.js").LoadFunction}
     */ this.tileLoadFunction_ = tileLoadFunction;
    }
    /**
   * Get the HTML image element for this tile (may be a Canvas, OffscreenCanvas, Image, or Video).
   * @return {HTMLCanvasElement|OffscreenCanvas|HTMLImageElement|HTMLVideoElement} Image.
   * @api
   */ getImage() {
        return this.image_;
    }
    /**
   * Sets an HTML image element for this tile (may be a Canvas or preloaded Image).
   * @param {HTMLCanvasElement|OffscreenCanvas|HTMLImageElement} element Element.
   */ setImage(element) {
        this.image_ = element;
        this.state = (0, $79d423c0f6adbcbb$export$2e2bcd8739ae039).LOADED;
        this.unlistenImage_();
        this.changed();
    }
    /**
   * Get the cross origin of the ImageTile.
   * @return {string} Cross origin.
   */ getCrossOrigin() {
        return this.crossOrigin_;
    }
    /**
   * Get the referrer policy of the ImageTile.
   * @return {ReferrerPolicy} Referrer policy.
   */ getReferrerPolicy() {
        return this.referrerPolicy_;
    }
    /**
   * Tracks loading or read errors.
   *
   * @private
   */ handleImageError_() {
        this.state = (0, $79d423c0f6adbcbb$export$2e2bcd8739ae039).ERROR;
        this.unlistenImage_();
        this.image_ = $af328a9781fa918b$var$getBlankImage();
        this.changed();
    }
    /**
   * Tracks successful image load.
   *
   * @private
   */ handleImageLoad_() {
        if (0, $32d41268b5f53567$export$98fcef3dc9973292) // OffscreenCanvas does not have naturalWidth and naturalHeight
        this.state = (0, $79d423c0f6adbcbb$export$2e2bcd8739ae039).LOADED;
        else {
            const image = /** @type {HTMLImageElement} */ this.image_;
            if (image.naturalWidth && image.naturalHeight) this.state = (0, $79d423c0f6adbcbb$export$2e2bcd8739ae039).LOADED;
            else this.state = (0, $79d423c0f6adbcbb$export$2e2bcd8739ae039).EMPTY;
        }
        this.unlistenImage_();
        this.changed();
    }
    /**
   * Load the image or retry if loading previously failed.
   * Loading is taken care of by the tile queue, and calling this method is
   * only needed for preloading or for reloading in case of an error.
   *
   * To retry loading tiles on failed requests, use a custom `tileLoadFunction`
   * that checks for error status codes and reloads only when the status code is
   * 408, 429, 500, 502, 503 and 504, and only when not too many retries have been
   * made already:
   *
   * ```js
   * const retryCodes = [408, 429, 500, 502, 503, 504];
   * const retries = {};
   * source.setTileLoadFunction((tile, src) => {
   *   const image = tile.getImage();
   *   fetch(src)
   *     .then((response) => {
   *       if (retryCodes.includes(response.status)) {
   *         retries[src] = (retries[src] || 0) + 1;
   *         if (retries[src] <= 3) {
   *           setTimeout(() => tile.load(), retries[src] * 1000);
   *         }
   *         return Promise.reject();
   *       }
   *       return response.blob();
   *     })
   *     .then((blob) => {
   *       const imageUrl = URL.createObjectURL(blob);
   *       image.src = imageUrl;
   *       setTimeout(() => URL.revokeObjectURL(imageUrl), 5000);
   *     })
   *     .catch(() => tile.setState(3)); // error
   * });
   * ```
   * @api
   * @override
   */ load() {
        if (this.state == (0, $79d423c0f6adbcbb$export$2e2bcd8739ae039).ERROR) {
            this.state = (0, $79d423c0f6adbcbb$export$2e2bcd8739ae039).IDLE;
            this.image_ = new Image();
            if (this.crossOrigin_ !== null) this.image_.crossOrigin = this.crossOrigin_;
            if (this.referrerPolicy_ !== undefined) this.image_.referrerPolicy = this.referrerPolicy_;
        }
        if (this.state == (0, $79d423c0f6adbcbb$export$2e2bcd8739ae039).IDLE) {
            this.state = (0, $79d423c0f6adbcbb$export$2e2bcd8739ae039).LOADING;
            this.changed();
            this.tileLoadFunction_(this, this.src_);
            this.unlisten_ = (0, $617ef54ed150e783$export$bc96ecc7c2a50764)(this.image_, this.handleImageLoad_.bind(this), this.handleImageError_.bind(this));
        }
    }
    /**
   * Discards event handlers which listen for load completion or errors.
   *
   * @private
   */ unlistenImage_() {
        if (this.unlisten_) {
            this.unlisten_();
            this.unlisten_ = null;
        }
    }
    /**
   * @override
   */ disposeInternal() {
        this.unlistenImage_();
        this.image_ = null;
        super.disposeInternal();
    }
}
/**
 * Get a 1-pixel blank image.
 * @return {HTMLCanvasElement|OffscreenCanvas} Blank image.
 */ function $af328a9781fa918b$var$getBlankImage() {
    const ctx = (0, $b6f6d442e8ff57e1$export$9e05d10eae75c464)(1, 1);
    ctx.fillStyle = 'rgba(0,0,0,0)';
    ctx.fillRect(0, 0, 1, 1);
    return ctx.canvas;
}
var $af328a9781fa918b$export$2e2bcd8739ae039 = $af328a9781fa918b$var$ImageTile;


/**
 * @module ol/TileRange
 */ /**
 * A representation of a contiguous block of tiles.  A tile range is specified
 * by its min/max tile coordinates and is inclusive of coordinates.
 */ class $9d539d0e6964f568$var$TileRange {
    /**
   * @param {number} minX Minimum X.
   * @param {number} maxX Maximum X.
   * @param {number} minY Minimum Y.
   * @param {number} maxY Maximum Y.
   */ constructor(minX, maxX, minY, maxY){
        /**
     * @type {number}
     */ this.minX = minX;
        /**
     * @type {number}
     */ this.maxX = maxX;
        /**
     * @type {number}
     */ this.minY = minY;
        /**
     * @type {number}
     */ this.maxY = maxY;
    }
    /**
   * @param {import("./tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @return {boolean} Contains tile coordinate.
   */ contains(tileCoord) {
        return this.containsXY(tileCoord[1], tileCoord[2]);
    }
    /**
   * @param {TileRange} tileRange Tile range.
   * @return {boolean} Contains.
   */ containsTileRange(tileRange) {
        return this.minX <= tileRange.minX && tileRange.maxX <= this.maxX && this.minY <= tileRange.minY && tileRange.maxY <= this.maxY;
    }
    /**
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @return {boolean} Contains coordinate.
   */ containsXY(x, y) {
        return this.minX <= x && x <= this.maxX && this.minY <= y && y <= this.maxY;
    }
    /**
   * @param {TileRange} tileRange Tile range.
   * @return {boolean} Equals.
   */ equals(tileRange) {
        return this.minX == tileRange.minX && this.minY == tileRange.minY && this.maxX == tileRange.maxX && this.maxY == tileRange.maxY;
    }
    /**
   * @param {TileRange} tileRange Tile range.
   */ extend(tileRange) {
        if (tileRange.minX < this.minX) this.minX = tileRange.minX;
        if (tileRange.maxX > this.maxX) this.maxX = tileRange.maxX;
        if (tileRange.minY < this.minY) this.minY = tileRange.minY;
        if (tileRange.maxY > this.maxY) this.maxY = tileRange.maxY;
    }
    /**
   * @return {number} Height.
   */ getHeight() {
        return this.maxY - this.minY + 1;
    }
    /**
   * @return {import("./size.js").Size} Size.
   */ getSize() {
        return [
            this.getWidth(),
            this.getHeight()
        ];
    }
    /**
   * @return {number} Width.
   */ getWidth() {
        return this.maxX - this.minX + 1;
    }
    /**
   * @param {TileRange} tileRange Tile range.
   * @return {boolean} Intersects.
   */ intersects(tileRange) {
        return this.minX <= tileRange.maxX && this.maxX >= tileRange.minX && this.minY <= tileRange.maxY && this.maxY >= tileRange.minY;
    }
}
function $9d539d0e6964f568$export$958e3e1a02eac4b6(minX, maxX, minY, maxY, tileRange) {
    if (tileRange !== undefined) {
        tileRange.minX = minX;
        tileRange.maxX = maxX;
        tileRange.minY = minY;
        tileRange.maxY = maxY;
        return tileRange;
    }
    return new $9d539d0e6964f568$var$TileRange(minX, maxX, minY, maxY);
}
var $9d539d0e6964f568$export$2e2bcd8739ae039 = $9d539d0e6964f568$var$TileRange;






/**
 * @module ol/reproj/Tile
 */ 






/**
 * @module ol/reproj
 */ 



let $a414945bcb55714f$var$brokenDiagonalRendering_;
const $a414945bcb55714f$export$a166f0857c555517 = [];
/**
 * This draws a small triangle into a canvas by setting the triangle as the clip region
 * and then drawing a (too large) rectangle
 *
 * @param {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} ctx The context in which to draw the triangle
 * @param {number} u1 The x-coordinate of the second point. The first point is 0,0.
 * @param {number} v1 The y-coordinate of the second point.
 * @param {number} u2 The x-coordinate of the third point.
 * @param {number} v2 The y-coordinate of the third point.
 */ function $a414945bcb55714f$var$drawTestTriangle(ctx, u1, v1, u2, v2) {
    ctx.beginPath();
    ctx.moveTo(0, 0);
    ctx.lineTo(u1, v1);
    ctx.lineTo(u2, v2);
    ctx.closePath();
    ctx.save();
    ctx.clip();
    ctx.fillRect(0, 0, Math.max(u1, u2) + 1, Math.max(v1, v2));
    ctx.restore();
}
/**
 * Given the data from getImageData, see if the right values appear at the provided offset.
 * Returns true if either the color or transparency is off
 *
 * @param {Uint8ClampedArray} data The data returned from getImageData
 * @param {number} offset The pixel offset from the start of data.
 * @return {boolean} true if the diagonal rendering is broken
 */ function $a414945bcb55714f$var$verifyBrokenDiagonalRendering(data, offset) {
    // the values ought to be close to the rgba(210, 0, 0, 0.75)
    return Math.abs(data[offset * 4] - 210) > 2 || Math.abs(data[offset * 4 + 3] - 191.25) > 2;
}
/**
 * Determines if the current browser configuration can render triangular clip regions correctly.
 * This value is cached so the function is only expensive the first time called.
 * Firefox on Windows (as of now) does not if HWA is enabled. See https://bugzilla.mozilla.org/show_bug.cgi?id=1606976
 * Chrome works, and everything seems to work on OSX and Android. This function caches the
 * result. I suppose that it is conceivably possible that a browser might flip modes while the app is
 * running, but lets hope not.
 *
 * @return {boolean} true if the Diagonal Rendering is broken.
 */ function $a414945bcb55714f$var$isBrokenDiagonalRendering() {
    if ($a414945bcb55714f$var$brokenDiagonalRendering_ === undefined) {
        const ctx = (0, $b6f6d442e8ff57e1$export$9e05d10eae75c464)(6, 6, $a414945bcb55714f$export$a166f0857c555517);
        ctx.globalCompositeOperation = 'lighter';
        ctx.fillStyle = 'rgba(210, 0, 0, 0.75)';
        $a414945bcb55714f$var$drawTestTriangle(ctx, 4, 5, 4, 0);
        $a414945bcb55714f$var$drawTestTriangle(ctx, 4, 5, 0, 5);
        const data = ctx.getImageData(0, 0, 3, 3).data;
        $a414945bcb55714f$var$brokenDiagonalRendering_ = $a414945bcb55714f$var$verifyBrokenDiagonalRendering(data, 0) || $a414945bcb55714f$var$verifyBrokenDiagonalRendering(data, 4) || $a414945bcb55714f$var$verifyBrokenDiagonalRendering(data, 8);
        (0, $b6f6d442e8ff57e1$export$e918ac6a1026a12a)(ctx);
        $a414945bcb55714f$export$a166f0857c555517.push(ctx.canvas);
    }
    return $a414945bcb55714f$var$brokenDiagonalRendering_;
}
function $a414945bcb55714f$export$5fbb958059b7e71f(sourceProj, targetProj, targetCenter, targetResolution) {
    const sourceCenter = (0, $a86eee1c28205a05$export$51186ad6e864892a)(targetCenter, targetProj, sourceProj);
    // calculate the ideal resolution of the source data
    let sourceResolution = (0, $a86eee1c28205a05$export$2d8f7b4eec383d44)(targetProj, targetResolution, targetCenter);
    const targetMetersPerUnit = targetProj.getMetersPerUnit();
    if (targetMetersPerUnit !== undefined) sourceResolution *= targetMetersPerUnit;
    const sourceMetersPerUnit = sourceProj.getMetersPerUnit();
    if (sourceMetersPerUnit !== undefined) sourceResolution /= sourceMetersPerUnit;
    // Based on the projection properties, the point resolution at the specified
    // coordinates may be slightly different. We need to reverse-compensate this
    // in order to achieve optimal results.
    const sourceExtent = sourceProj.getExtent();
    if (!sourceExtent || (0, $dea65c2f666fa450$export$ac68c24d37ca240f)(sourceExtent, sourceCenter)) {
        const compensationFactor = (0, $a86eee1c28205a05$export$2d8f7b4eec383d44)(sourceProj, sourceResolution, sourceCenter) / sourceResolution;
        if (isFinite(compensationFactor) && compensationFactor > 0) sourceResolution /= compensationFactor;
    }
    return sourceResolution;
}
function $a414945bcb55714f$export$16d356211d01f1cc(sourceProj, targetProj, targetExtent, targetResolution) {
    const targetCenter = (0, $dea65c2f666fa450$export$c91255cadecfe081)(targetExtent);
    let sourceResolution = $a414945bcb55714f$export$5fbb958059b7e71f(sourceProj, targetProj, targetCenter, targetResolution);
    if (!isFinite(sourceResolution) || sourceResolution <= 0) (0, $dea65c2f666fa450$export$f9ed8a3d123a08e2)(targetExtent, function(corner) {
        sourceResolution = $a414945bcb55714f$export$5fbb958059b7e71f(sourceProj, targetProj, corner, targetResolution);
        return isFinite(sourceResolution) && sourceResolution > 0;
    });
    return sourceResolution;
}
function $a414945bcb55714f$export$b3890eb0ae9dca99(width, height, pixelRatio, sourceResolution, sourceExtent, targetResolution, targetExtent, triangulation, sources, gutter, renderEdges, interpolate, drawSingle, clipExtent) {
    const context = (0, $b6f6d442e8ff57e1$export$9e05d10eae75c464)(Math.round(pixelRatio * width), Math.round(pixelRatio * height), $a414945bcb55714f$export$a166f0857c555517);
    if (!interpolate) context.imageSmoothingEnabled = false;
    if (sources.length === 0) return context.canvas;
    context.scale(pixelRatio, pixelRatio);
    function pixelRound(value) {
        return Math.round(value * pixelRatio) / pixelRatio;
    }
    context.globalCompositeOperation = 'lighter';
    const sourceDataExtent = (0, $dea65c2f666fa450$export$fe201bb3bbe031e9)();
    sources.forEach(function(src, i, arr) {
        (0, $dea65c2f666fa450$export$8b58be045bf06082)(sourceDataExtent, src.extent);
    });
    let stitchContext;
    const stitchScale = pixelRatio / sourceResolution;
    // Round up Float32 scale values to prevent interpolation in Firefox.
    const inverseScale = (interpolate ? 1 : 1 + Math.pow(2, -24)) / stitchScale;
    if (!drawSingle || sources.length !== 1 || gutter !== 0) {
        stitchContext = (0, $b6f6d442e8ff57e1$export$9e05d10eae75c464)(Math.round((0, $dea65c2f666fa450$export$3c49c185de0c2bfc)(sourceDataExtent) * stitchScale), Math.round((0, $dea65c2f666fa450$export$c08559766941f856)(sourceDataExtent) * stitchScale), $a414945bcb55714f$export$a166f0857c555517);
        if (!interpolate) stitchContext.imageSmoothingEnabled = false;
        if (sourceExtent && clipExtent) {
            const xPos = (sourceExtent[0] - sourceDataExtent[0]) * stitchScale;
            const yPos = -(sourceExtent[3] - sourceDataExtent[3]) * stitchScale;
            const width = (0, $dea65c2f666fa450$export$3c49c185de0c2bfc)(sourceExtent) * stitchScale;
            const height = (0, $dea65c2f666fa450$export$c08559766941f856)(sourceExtent) * stitchScale;
            stitchContext.rect(xPos, yPos, width, height);
            stitchContext.clip();
        }
        sources.forEach(function(src, i, arr) {
            // This test should never fail -- but it does. Need to find a fix the upstream condition
            if (src.image.width > 0 && src.image.height > 0) {
                if (src.clipExtent) {
                    stitchContext.save();
                    const xPos = (src.clipExtent[0] - sourceDataExtent[0]) * stitchScale;
                    const yPos = -(src.clipExtent[3] - sourceDataExtent[3]) * stitchScale;
                    const width = (0, $dea65c2f666fa450$export$3c49c185de0c2bfc)(src.clipExtent) * stitchScale;
                    const height = (0, $dea65c2f666fa450$export$c08559766941f856)(src.clipExtent) * stitchScale;
                    stitchContext.rect(interpolate ? xPos : Math.round(xPos), interpolate ? yPos : Math.round(yPos), interpolate ? width : Math.round(xPos + width) - Math.round(xPos), interpolate ? height : Math.round(yPos + height) - Math.round(yPos));
                    stitchContext.clip();
                }
                const xPos = (src.extent[0] - sourceDataExtent[0]) * stitchScale;
                const yPos = -(src.extent[3] - sourceDataExtent[3]) * stitchScale;
                const srcWidth = (0, $dea65c2f666fa450$export$3c49c185de0c2bfc)(src.extent) * stitchScale;
                const srcHeight = (0, $dea65c2f666fa450$export$c08559766941f856)(src.extent) * stitchScale;
                stitchContext.drawImage(src.image, gutter, gutter, src.image.width - 2 * gutter, src.image.height - 2 * gutter, interpolate ? xPos : Math.round(xPos), interpolate ? yPos : Math.round(yPos), interpolate ? srcWidth : Math.round(xPos + srcWidth) - Math.round(xPos), interpolate ? srcHeight : Math.round(yPos + srcHeight) - Math.round(yPos));
                if (src.clipExtent) stitchContext.restore();
            }
        });
    }
    const targetTopLeft = (0, $dea65c2f666fa450$export$cb1538b07e6964ff)(targetExtent);
    triangulation.getTriangles().forEach(function(triangle, i, arr) {
        /* Calculate affine transform (src -> dst)
     * Resulting matrix can be used to transform coordinate
     * from `sourceProjection` to destination pixels.
     *
     * To optimize number of context calls and increase numerical stability,
     * we also do the following operations:
     * trans(-topLeftExtentCorner), scale(1 / targetResolution), scale(1, -1)
     * here before solving the linear system so [ui, vi] are pixel coordinates.
     *
     * Src points: xi, yi
     * Dst points: ui, vi
     * Affine coefficients: aij
     *
     * | x0 y0 1  0  0 0 |   |a00|   |u0|
     * | x1 y1 1  0  0 0 |   |a01|   |u1|
     * | x2 y2 1  0  0 0 | x |a02| = |u2|
     * |  0  0 0 x0 y0 1 |   |a10|   |v0|
     * |  0  0 0 x1 y1 1 |   |a11|   |v1|
     * |  0  0 0 x2 y2 1 |   |a12|   |v2|
     */ const source = triangle.source;
        const target = triangle.target;
        let x0 = source[0][0], y0 = source[0][1];
        let x1 = source[1][0], y1 = source[1][1];
        let x2 = source[2][0], y2 = source[2][1];
        // Make sure that everything is on pixel boundaries
        const u0 = pixelRound((target[0][0] - targetTopLeft[0]) / targetResolution);
        const v0 = pixelRound(-(target[0][1] - targetTopLeft[1]) / targetResolution);
        const u1 = pixelRound((target[1][0] - targetTopLeft[0]) / targetResolution);
        const v1 = pixelRound(-(target[1][1] - targetTopLeft[1]) / targetResolution);
        const u2 = pixelRound((target[2][0] - targetTopLeft[0]) / targetResolution);
        const v2 = pixelRound(-(target[2][1] - targetTopLeft[1]) / targetResolution);
        // Shift all the source points to improve numerical stability
        // of all the subsequent calculations. The [x0, y0] is used here.
        // This is also used to simplify the linear system.
        const sourceNumericalShiftX = x0;
        const sourceNumericalShiftY = y0;
        x0 = 0;
        y0 = 0;
        x1 -= sourceNumericalShiftX;
        y1 -= sourceNumericalShiftY;
        x2 -= sourceNumericalShiftX;
        y2 -= sourceNumericalShiftY;
        const augmentedMatrix = [
            [
                x1,
                y1,
                0,
                0,
                u1 - u0
            ],
            [
                x2,
                y2,
                0,
                0,
                u2 - u0
            ],
            [
                0,
                0,
                x1,
                y1,
                v1 - v0
            ],
            [
                0,
                0,
                x2,
                y2,
                v2 - v0
            ]
        ];
        const affineCoefs = (0, $6a95bd76d7103f37$export$8240f01c446270e6)(augmentedMatrix);
        if (!affineCoefs) return;
        context.save();
        context.beginPath();
        if ($a414945bcb55714f$var$isBrokenDiagonalRendering() || !interpolate) {
            // Make sure that all lines are horizontal or vertical
            context.moveTo(u1, v1);
            // This is the diagonal line. Do it in 4 steps
            const steps = 4;
            const ud = u0 - u1;
            const vd = v0 - v1;
            for(let step = 0; step < steps; step++){
                // Go horizontally
                context.lineTo(u1 + pixelRound((step + 1) * ud / steps), v1 + pixelRound(step * vd / (steps - 1)));
                // Go vertically
                if (step != steps - 1) context.lineTo(u1 + pixelRound((step + 1) * ud / steps), v1 + pixelRound((step + 1) * vd / (steps - 1)));
            }
            // We are almost at u0r, v0r
            context.lineTo(u2, v2);
        } else {
            context.moveTo(u1, v1);
            context.lineTo(u0, v0);
            context.lineTo(u2, v2);
        }
        context.clip();
        context.transform(affineCoefs[0], affineCoefs[2], affineCoefs[1], affineCoefs[3], u0, v0);
        context.translate(sourceDataExtent[0] - sourceNumericalShiftX, sourceDataExtent[3] - sourceNumericalShiftY);
        let image;
        if (stitchContext) {
            image = stitchContext.canvas;
            context.scale(inverseScale, -inverseScale);
        } else {
            const source = sources[0];
            const extent = source.extent;
            image = source.image;
            context.scale((0, $dea65c2f666fa450$export$3c49c185de0c2bfc)(extent) / image.width, -(0, $dea65c2f666fa450$export$c08559766941f856)(extent) / image.height);
        }
        context.drawImage(image, 0, 0);
        context.restore();
    });
    if (stitchContext) {
        (0, $b6f6d442e8ff57e1$export$e918ac6a1026a12a)(stitchContext);
        $a414945bcb55714f$export$a166f0857c555517.push(stitchContext.canvas);
    }
    if (renderEdges) {
        context.save();
        context.globalCompositeOperation = 'source-over';
        context.strokeStyle = 'black';
        context.lineWidth = 1;
        triangulation.getTriangles().forEach(function(triangle, i, arr) {
            const target = triangle.target;
            const u0 = (target[0][0] - targetTopLeft[0]) / targetResolution;
            const v0 = -(target[0][1] - targetTopLeft[1]) / targetResolution;
            const u1 = (target[1][0] - targetTopLeft[0]) / targetResolution;
            const v1 = -(target[1][1] - targetTopLeft[1]) / targetResolution;
            const u2 = (target[2][0] - targetTopLeft[0]) / targetResolution;
            const v2 = -(target[2][1] - targetTopLeft[1]) / targetResolution;
            context.beginPath();
            context.moveTo(u1, v1);
            context.lineTo(u0, v0);
            context.lineTo(u2, v2);
            context.closePath();
            context.stroke();
        });
        context.restore();
    }
    return context.canvas;
}


/**
 * @module ol/reproj/Triangulation
 */ 



/**
 * Single triangle; consists of 3 source points and 3 target points.
 * @typedef {Object} Triangle
 * @property {Array<import("../coordinate.js").Coordinate>} source Source.
 * @property {Array<import("../coordinate.js").Coordinate>} target Target.
 */ /**
 * Maximum number of subdivision steps during raster reprojection triangulation.
 * Prevents high memory usage and large number of proj4 calls (for certain
 * transformations and areas). At most `2*(2^this)` triangles are created for
 * each triangulated extent (tile/image).
 * @type {number}
 */ const $ac803fe94e8ac9e6$var$MAX_SUBDIVISION = 10;
/**
 * Maximum allowed size of triangle relative to world width. When transforming
 * corners of world extent between certain projections, the resulting
 * triangulation seems to have zero error and no subdivision is performed. If
 * the triangle width is more than this (relative to world width; 0-1),
 * subdivison is forced (up to `MAX_SUBDIVISION`). Default is `0.25`.
 * @type {number}
 */ const $ac803fe94e8ac9e6$var$MAX_TRIANGLE_WIDTH = 0.25;
/**
 * @classdesc
 * Class containing triangulation of the given target extent.
 * Used for determining source data and the reprojection itself.
 */ class $ac803fe94e8ac9e6$var$Triangulation {
    /**
   * @param {import("../proj/Projection.js").default} sourceProj Source projection.
   * @param {import("../proj/Projection.js").default} targetProj Target projection.
   * @param {import("../extent.js").Extent} targetExtent Target extent to triangulate.
   * @param {import("../extent.js").Extent} maxSourceExtent Maximal source extent that can be used.
   * @param {number} errorThreshold Acceptable error (in source units).
   * @param {?number} destinationResolution The (optional) resolution of the destination.
   * @param {import("../transform.js").Transform} [sourceMatrix] Source transform matrix.
   */ constructor(sourceProj, targetProj, targetExtent, maxSourceExtent, errorThreshold, destinationResolution, sourceMatrix){
        /**
     * @type {import("../proj/Projection.js").default}
     * @private
     */ this.sourceProj_ = sourceProj;
        /**
     * @type {import("../proj/Projection.js").default}
     * @private
     */ this.targetProj_ = targetProj;
        /** @type {!Object<string, import("../coordinate.js").Coordinate>} */ let transformInvCache = {};
        const transformInv = sourceMatrix ? (0, $a86eee1c28205a05$export$6b4aafd331159e0d)((input)=>(0, $dff5a03e015694d8$export$5635d7ef4b8fee1c)(sourceMatrix, (0, $a86eee1c28205a05$export$51186ad6e864892a)(input, this.targetProj_, this.sourceProj_))) : (0, $a86eee1c28205a05$export$fce0c6cfca85ed96)(this.targetProj_, this.sourceProj_);
        /**
     * @param {import("../coordinate.js").Coordinate} c A coordinate.
     * @return {import("../coordinate.js").Coordinate} Transformed coordinate.
     * @private
     */ this.transformInv_ = function(c) {
            const key = c[0] + '/' + c[1];
            if (!transformInvCache[key]) transformInvCache[key] = transformInv(c);
            return transformInvCache[key];
        };
        /**
     * @type {import("../extent.js").Extent}
     * @private
     */ this.maxSourceExtent_ = maxSourceExtent;
        /**
     * @type {number}
     * @private
     */ this.errorThresholdSquared_ = errorThreshold * errorThreshold;
        /**
     * @type {Array<Triangle>}
     * @private
     */ this.triangles_ = [];
        /**
     * Indicates that the triangulation crosses edge of the source projection.
     * @type {boolean}
     * @private
     */ this.wrapsXInSource_ = false;
        /**
     * @type {boolean}
     * @private
     */ this.canWrapXInSource_ = this.sourceProj_.canWrapX() && !!maxSourceExtent && !!this.sourceProj_.getExtent() && (0, $dea65c2f666fa450$export$3c49c185de0c2bfc)(maxSourceExtent) >= (0, $dea65c2f666fa450$export$3c49c185de0c2bfc)(this.sourceProj_.getExtent());
        /**
     * @type {?number}
     * @private
     */ this.sourceWorldWidth_ = this.sourceProj_.getExtent() ? (0, $dea65c2f666fa450$export$3c49c185de0c2bfc)(this.sourceProj_.getExtent()) : null;
        /**
     * @type {?number}
     * @private
     */ this.targetWorldWidth_ = this.targetProj_.getExtent() ? (0, $dea65c2f666fa450$export$3c49c185de0c2bfc)(this.targetProj_.getExtent()) : null;
        const destinationTopLeft = (0, $dea65c2f666fa450$export$cb1538b07e6964ff)(targetExtent);
        const destinationTopRight = (0, $dea65c2f666fa450$export$b84fa077c8b05295)(targetExtent);
        const destinationBottomRight = (0, $dea65c2f666fa450$export$e77c1cf70445e168)(targetExtent);
        const destinationBottomLeft = (0, $dea65c2f666fa450$export$8d09f5e2e1bf560d)(targetExtent);
        const sourceTopLeft = this.transformInv_(destinationTopLeft);
        const sourceTopRight = this.transformInv_(destinationTopRight);
        const sourceBottomRight = this.transformInv_(destinationBottomRight);
        const sourceBottomLeft = this.transformInv_(destinationBottomLeft);
        /*
     * The maxSubdivision controls how many splittings of the target area can
     * be done. The idea here is to do a linear mapping of the target areas
     * but the actual overall reprojection (can be) extremely non-linear. The
     * default value of MAX_SUBDIVISION was chosen based on mapping a 256x256
     * tile size. However this function is also called to remap canvas rendered
     * layers which can be much larger. This calculation increases the maxSubdivision
     * value by the right factor so that each 256x256 pixel area has
     * MAX_SUBDIVISION divisions.
     */ const maxSubdivision = $ac803fe94e8ac9e6$var$MAX_SUBDIVISION + (destinationResolution ? Math.max(0, Math.ceil(Math.log2((0, $dea65c2f666fa450$export$520c40045967cb15)(targetExtent) / (destinationResolution * destinationResolution * 65536)))) : 0);
        this.addQuad_(destinationTopLeft, destinationTopRight, destinationBottomRight, destinationBottomLeft, sourceTopLeft, sourceTopRight, sourceBottomRight, sourceBottomLeft, maxSubdivision);
        if (this.wrapsXInSource_) {
            let leftBound = Infinity;
            this.triangles_.forEach(function(triangle, i, arr) {
                leftBound = Math.min(leftBound, triangle.source[0][0], triangle.source[1][0], triangle.source[2][0]);
            });
            // Shift triangles to be as close to `leftBound` as possible
            // (if the distance is more than `worldWidth / 2` it can be closer.
            this.triangles_.forEach((triangle)=>{
                if (Math.max(triangle.source[0][0], triangle.source[1][0], triangle.source[2][0]) - leftBound > this.sourceWorldWidth_ / 2) {
                    const newTriangle = [
                        [
                            triangle.source[0][0],
                            triangle.source[0][1]
                        ],
                        [
                            triangle.source[1][0],
                            triangle.source[1][1]
                        ],
                        [
                            triangle.source[2][0],
                            triangle.source[2][1]
                        ]
                    ];
                    if (newTriangle[0][0] - leftBound > this.sourceWorldWidth_ / 2) newTriangle[0][0] -= this.sourceWorldWidth_;
                    if (newTriangle[1][0] - leftBound > this.sourceWorldWidth_ / 2) newTriangle[1][0] -= this.sourceWorldWidth_;
                    if (newTriangle[2][0] - leftBound > this.sourceWorldWidth_ / 2) newTriangle[2][0] -= this.sourceWorldWidth_;
                    // Rarely (if the extent contains both the dateline and prime meridian)
                    // the shift can in turn break some triangles.
                    // Detect this here and don't shift in such cases.
                    const minX = Math.min(newTriangle[0][0], newTriangle[1][0], newTriangle[2][0]);
                    const maxX = Math.max(newTriangle[0][0], newTriangle[1][0], newTriangle[2][0]);
                    if (maxX - minX < this.sourceWorldWidth_ / 2) triangle.source = newTriangle;
                }
            });
        }
        transformInvCache = {};
    }
    /**
   * Adds triangle to the triangulation.
   * @param {import("../coordinate.js").Coordinate} a The target a coordinate.
   * @param {import("../coordinate.js").Coordinate} b The target b coordinate.
   * @param {import("../coordinate.js").Coordinate} c The target c coordinate.
   * @param {import("../coordinate.js").Coordinate} aSrc The source a coordinate.
   * @param {import("../coordinate.js").Coordinate} bSrc The source b coordinate.
   * @param {import("../coordinate.js").Coordinate} cSrc The source c coordinate.
   * @private
   */ addTriangle_(a, b, c, aSrc, bSrc, cSrc) {
        this.triangles_.push({
            source: [
                aSrc,
                bSrc,
                cSrc
            ],
            target: [
                a,
                b,
                c
            ]
        });
    }
    /**
   * Adds quad (points in clock-wise order) to the triangulation
   * (and reprojects the vertices) if valid.
   * Performs quad subdivision if needed to increase precision.
   *
   * @param {import("../coordinate.js").Coordinate} a The target a coordinate.
   * @param {import("../coordinate.js").Coordinate} b The target b coordinate.
   * @param {import("../coordinate.js").Coordinate} c The target c coordinate.
   * @param {import("../coordinate.js").Coordinate} d The target d coordinate.
   * @param {import("../coordinate.js").Coordinate} aSrc The source a coordinate.
   * @param {import("../coordinate.js").Coordinate} bSrc The source b coordinate.
   * @param {import("../coordinate.js").Coordinate} cSrc The source c coordinate.
   * @param {import("../coordinate.js").Coordinate} dSrc The source d coordinate.
   * @param {number} maxSubdivision Maximal allowed subdivision of the quad.
   * @private
   */ addQuad_(a, b, c, d, aSrc, bSrc, cSrc, dSrc, maxSubdivision) {
        const sourceQuadExtent = (0, $dea65c2f666fa450$export$8aceca7c77505534)([
            aSrc,
            bSrc,
            cSrc,
            dSrc
        ]);
        const sourceCoverageX = this.sourceWorldWidth_ ? (0, $dea65c2f666fa450$export$3c49c185de0c2bfc)(sourceQuadExtent) / this.sourceWorldWidth_ : null;
        const sourceWorldWidth = /** @type {number} */ this.sourceWorldWidth_;
        // when the quad is wrapped in the source projection
        // it covers most of the projection extent, but not fully
        const wrapsX = this.sourceProj_.canWrapX() && sourceCoverageX > 0.5 && sourceCoverageX < 1;
        let needsSubdivision = false;
        if (maxSubdivision > 0) {
            if (this.targetProj_.isGlobal() && this.targetWorldWidth_) {
                const targetQuadExtent = (0, $dea65c2f666fa450$export$8aceca7c77505534)([
                    a,
                    b,
                    c,
                    d
                ]);
                const targetCoverageX = (0, $dea65c2f666fa450$export$3c49c185de0c2bfc)(targetQuadExtent) / this.targetWorldWidth_;
                needsSubdivision = targetCoverageX > $ac803fe94e8ac9e6$var$MAX_TRIANGLE_WIDTH || needsSubdivision;
            }
            if (!wrapsX && this.sourceProj_.isGlobal() && sourceCoverageX) needsSubdivision = sourceCoverageX > $ac803fe94e8ac9e6$var$MAX_TRIANGLE_WIDTH || needsSubdivision;
        }
        if (!needsSubdivision && this.maxSourceExtent_) {
            if (isFinite(sourceQuadExtent[0]) && isFinite(sourceQuadExtent[1]) && isFinite(sourceQuadExtent[2]) && isFinite(sourceQuadExtent[3])) {
                if (!(0, $dea65c2f666fa450$export$7b0a31e10bbff018)(sourceQuadExtent, this.maxSourceExtent_)) // whole quad outside source projection extent -> ignore
                return;
            }
        }
        let isNotFinite = 0;
        if (!needsSubdivision) {
            if (!isFinite(aSrc[0]) || !isFinite(aSrc[1]) || !isFinite(bSrc[0]) || !isFinite(bSrc[1]) || !isFinite(cSrc[0]) || !isFinite(cSrc[1]) || !isFinite(dSrc[0]) || !isFinite(dSrc[1])) {
                if (maxSubdivision > 0) needsSubdivision = true;
                else {
                    // It might be the case that only 1 of the points is infinite. In this case
                    // we can draw a single triangle with the other three points
                    isNotFinite = (!isFinite(aSrc[0]) || !isFinite(aSrc[1]) ? 8 : 0) + (!isFinite(bSrc[0]) || !isFinite(bSrc[1]) ? 4 : 0) + (!isFinite(cSrc[0]) || !isFinite(cSrc[1]) ? 2 : 0) + (!isFinite(dSrc[0]) || !isFinite(dSrc[1]) ? 1 : 0);
                    if (isNotFinite != 1 && isNotFinite != 2 && isNotFinite != 4 && isNotFinite != 8) return;
                }
            }
        }
        if (maxSubdivision > 0) {
            if (!needsSubdivision) {
                const center = [
                    (a[0] + c[0]) / 2,
                    (a[1] + c[1]) / 2
                ];
                const centerSrc = this.transformInv_(center);
                let dx;
                if (wrapsX) {
                    const centerSrcEstimX = ((0, $6a95bd76d7103f37$export$ba467bec01d66def)(aSrc[0], sourceWorldWidth) + (0, $6a95bd76d7103f37$export$ba467bec01d66def)(cSrc[0], sourceWorldWidth)) / 2;
                    dx = centerSrcEstimX - (0, $6a95bd76d7103f37$export$ba467bec01d66def)(centerSrc[0], sourceWorldWidth);
                } else dx = (aSrc[0] + cSrc[0]) / 2 - centerSrc[0];
                const dy = (aSrc[1] + cSrc[1]) / 2 - centerSrc[1];
                const centerSrcErrorSquared = dx * dx + dy * dy;
                needsSubdivision = centerSrcErrorSquared > this.errorThresholdSquared_;
            }
            if (needsSubdivision) {
                if (Math.abs(a[0] - c[0]) <= Math.abs(a[1] - c[1])) {
                    // split horizontally (top & bottom)
                    const bc = [
                        (b[0] + c[0]) / 2,
                        (b[1] + c[1]) / 2
                    ];
                    const bcSrc = this.transformInv_(bc);
                    const da = [
                        (d[0] + a[0]) / 2,
                        (d[1] + a[1]) / 2
                    ];
                    const daSrc = this.transformInv_(da);
                    this.addQuad_(a, b, bc, da, aSrc, bSrc, bcSrc, daSrc, maxSubdivision - 1);
                    this.addQuad_(da, bc, c, d, daSrc, bcSrc, cSrc, dSrc, maxSubdivision - 1);
                } else {
                    // split vertically (left & right)
                    const ab = [
                        (a[0] + b[0]) / 2,
                        (a[1] + b[1]) / 2
                    ];
                    const abSrc = this.transformInv_(ab);
                    const cd = [
                        (c[0] + d[0]) / 2,
                        (c[1] + d[1]) / 2
                    ];
                    const cdSrc = this.transformInv_(cd);
                    this.addQuad_(a, ab, cd, d, aSrc, abSrc, cdSrc, dSrc, maxSubdivision - 1);
                    this.addQuad_(ab, b, c, cd, abSrc, bSrc, cSrc, cdSrc, maxSubdivision - 1);
                }
                return;
            }
        }
        if (wrapsX) {
            if (!this.canWrapXInSource_) return;
            this.wrapsXInSource_ = true;
        }
        // Exactly zero or one of *Src is not finite
        // The triangles must have the diagonal line as the first side
        // This is to allow easy code in reproj.s to make it straight for broken
        // browsers that can't handle diagonal clipping
        if ((isNotFinite & 0xb) == 0) this.addTriangle_(a, c, d, aSrc, cSrc, dSrc);
        if ((isNotFinite & 0xe) == 0) this.addTriangle_(a, c, b, aSrc, cSrc, bSrc);
        if (isNotFinite) {
            // Try the other two triangles
            if ((isNotFinite & 0xd) == 0) this.addTriangle_(b, d, a, bSrc, dSrc, aSrc);
            if ((isNotFinite & 0x7) == 0) this.addTriangle_(b, d, c, bSrc, dSrc, cSrc);
        }
    }
    /**
   * Calculates extent of the `source` coordinates from all the triangles.
   *
   * @return {import("../extent.js").Extent} Calculated extent.
   */ calculateSourceExtent() {
        const extent = (0, $dea65c2f666fa450$export$fe201bb3bbe031e9)();
        this.triangles_.forEach(function(triangle, i, arr) {
            const src = triangle.source;
            (0, $dea65c2f666fa450$export$1f820e3920fa5715)(extent, src[0]);
            (0, $dea65c2f666fa450$export$1f820e3920fa5715)(extent, src[1]);
            (0, $dea65c2f666fa450$export$1f820e3920fa5715)(extent, src[2]);
        });
        return extent;
    }
    /**
   * @return {Array<Triangle>} Array of the calculated triangles.
   */ getTriangles() {
        return this.triangles_;
    }
}
var $ac803fe94e8ac9e6$export$2e2bcd8739ae039 = $ac803fe94e8ac9e6$var$Triangulation;


/**
 * @module ol/reproj/common
 */ /**
 * Default maximum allowed threshold  (in pixels) for reprojection
 * triangulation.
 * @type {number}
 */ const $8700c9c2fd379982$export$3ecb4bcfa5aae855 = 0.5;


/**
 * @typedef {function(number, number, number, number) : (import("../ImageTile.js").default)} FunctionType
 */ /**
 * @typedef {Object} TileOffset
 * @property {import("../ImageTile.js").default} [tile] Tile.
 * @property {function(): import("../ImageTile.js").default} getTile Tile getter.
 * @property {number} offset Offset.
 */ /**
 * @classdesc
 * Class encapsulating single reprojected tile.
 * See {@link module:ol/source/TileImage~TileImage}.
 *
 */ class $a9e17fc88997910c$var$ReprojTile extends (0, $9fb956e5836dc6e1$export$2e2bcd8739ae039) {
    /**
   * @param {import("../proj/Projection.js").default} sourceProj Source projection.
   * @param {import("../tilegrid/TileGrid.js").default} sourceTileGrid Source tile grid.
   * @param {import("../proj/Projection.js").default} targetProj Target projection.
   * @param {import("../tilegrid/TileGrid.js").default} targetTileGrid Target tile grid.
   * @param {import("../tilecoord.js").TileCoord} tileCoord Coordinate of the tile.
   * @param {import("../tilecoord.js").TileCoord} wrappedTileCoord Coordinate of the tile wrapped in X.
   * @param {number} pixelRatio Pixel ratio.
   * @param {number} gutter Gutter of the source tiles.
   * @param {FunctionType} getTileFunction
   *     Function returning source tiles (z, x, y, pixelRatio).
   * @param {number} [errorThreshold] Acceptable reprojection error (in px).
   * @param {boolean} [renderEdges] Render reprojection edges.
   * @param {import("../Tile.js").Options} [options] Tile options.
   */ constructor(sourceProj, sourceTileGrid, targetProj, targetTileGrid, tileCoord, wrappedTileCoord, pixelRatio, gutter, getTileFunction, errorThreshold, renderEdges, options){
        super(tileCoord, (0, $79d423c0f6adbcbb$export$2e2bcd8739ae039).IDLE, options);
        /**
     * @private
     * @type {boolean}
     */ this.renderEdges_ = renderEdges !== undefined ? renderEdges : false;
        /**
     * @private
     * @type {number}
     */ this.pixelRatio_ = pixelRatio;
        /**
     * @private
     * @type {number}
     */ this.gutter_ = gutter;
        /**
     * @private
     * @type {HTMLCanvasElement|OffscreenCanvas}
     */ this.canvas_ = null;
        /**
     * @private
     * @type {import("../tilegrid/TileGrid.js").default}
     */ this.sourceTileGrid_ = sourceTileGrid;
        /**
     * @private
     * @type {import("../tilegrid/TileGrid.js").default}
     */ this.targetTileGrid_ = targetTileGrid;
        /**
     * @private
     * @type {import("../tilecoord.js").TileCoord}
     */ this.wrappedTileCoord_ = wrappedTileCoord ? wrappedTileCoord : tileCoord;
        /**
     * @private
     * @type {!Array<TileOffset>}
     */ this.sourceTiles_ = [];
        /**
     * @private
     * @type {?Array<import("../events.js").EventsKey>}
     */ this.sourcesListenerKeys_ = null;
        /**
     * @private
     * @type {number}
     */ this.sourceZ_ = 0;
        /**
     * @private
     * @type {import("../extent.js").Extent}
     */ this.clipExtent_ = sourceProj.canWrapX() ? sourceProj.getExtent() : undefined;
        const targetExtent = targetTileGrid.getTileCoordExtent(this.wrappedTileCoord_);
        const maxTargetExtent = this.targetTileGrid_.getExtent();
        let maxSourceExtent = this.sourceTileGrid_.getExtent();
        const limitedTargetExtent = maxTargetExtent ? (0, $dea65c2f666fa450$export$72209efa88586d42)(targetExtent, maxTargetExtent) : targetExtent;
        if ((0, $dea65c2f666fa450$export$520c40045967cb15)(limitedTargetExtent) === 0) {
            // Tile is completely outside range -> EMPTY
            // TODO: is it actually correct that the source even creates the tile ?
            this.state = (0, $79d423c0f6adbcbb$export$2e2bcd8739ae039).EMPTY;
            return;
        }
        const sourceProjExtent = sourceProj.getExtent();
        if (sourceProjExtent) {
            if (!maxSourceExtent) maxSourceExtent = sourceProjExtent;
            else maxSourceExtent = (0, $dea65c2f666fa450$export$72209efa88586d42)(maxSourceExtent, sourceProjExtent);
        }
        const targetResolution = targetTileGrid.getResolution(this.wrappedTileCoord_[0]);
        const sourceResolution = (0, $a414945bcb55714f$export$16d356211d01f1cc)(sourceProj, targetProj, limitedTargetExtent, targetResolution);
        if (!isFinite(sourceResolution) || sourceResolution <= 0) {
            // invalid sourceResolution -> EMPTY
            // probably edges of the projections when no extent is defined
            this.state = (0, $79d423c0f6adbcbb$export$2e2bcd8739ae039).EMPTY;
            return;
        }
        const errorThresholdInPixels = errorThreshold !== undefined ? errorThreshold : (0, $8700c9c2fd379982$export$3ecb4bcfa5aae855);
        /**
     * @private
     * @type {!import("./Triangulation.js").default}
     */ this.triangulation_ = new (0, $ac803fe94e8ac9e6$export$2e2bcd8739ae039)(sourceProj, targetProj, limitedTargetExtent, maxSourceExtent, sourceResolution * errorThresholdInPixels, targetResolution);
        if (this.triangulation_.getTriangles().length === 0) {
            // no valid triangles -> EMPTY
            this.state = (0, $79d423c0f6adbcbb$export$2e2bcd8739ae039).EMPTY;
            return;
        }
        this.sourceZ_ = sourceTileGrid.getZForResolution(sourceResolution);
        let sourceExtent = this.triangulation_.calculateSourceExtent();
        if (maxSourceExtent) {
            if (sourceProj.canWrapX()) {
                sourceExtent[1] = (0, $6a95bd76d7103f37$export$7d15b64cf5a3a4c4)(sourceExtent[1], maxSourceExtent[1], maxSourceExtent[3]);
                sourceExtent[3] = (0, $6a95bd76d7103f37$export$7d15b64cf5a3a4c4)(sourceExtent[3], maxSourceExtent[1], maxSourceExtent[3]);
            } else sourceExtent = (0, $dea65c2f666fa450$export$72209efa88586d42)(sourceExtent, maxSourceExtent);
        }
        if (!(0, $dea65c2f666fa450$export$520c40045967cb15)(sourceExtent)) this.state = (0, $79d423c0f6adbcbb$export$2e2bcd8739ae039).EMPTY;
        else {
            let worldWidth = 0;
            let worldsAway = 0;
            if (sourceProj.canWrapX()) {
                worldWidth = (0, $dea65c2f666fa450$export$3c49c185de0c2bfc)(sourceProjExtent);
                worldsAway = Math.floor((sourceExtent[0] - sourceProjExtent[0]) / worldWidth);
            }
            const sourceExtents = (0, $dea65c2f666fa450$export$9031237f01de0947)(sourceExtent.slice(), sourceProj, true);
            sourceExtents.forEach((extent)=>{
                const sourceRange = sourceTileGrid.getTileRangeForExtentAndZ(extent, this.sourceZ_);
                for(let srcX = sourceRange.minX; srcX <= sourceRange.maxX; srcX++)for(let srcY = sourceRange.minY; srcY <= sourceRange.maxY; srcY++){
                    const offset = worldsAway * worldWidth;
                    this.sourceTiles_.push({
                        getTile: ()=>getTileFunction(this.sourceZ_, srcX, srcY, pixelRatio),
                        offset: offset
                    });
                }
                ++worldsAway;
            });
            if (this.sourceTiles_.length === 0) this.state = (0, $79d423c0f6adbcbb$export$2e2bcd8739ae039).EMPTY;
        }
    }
    /**
   * Get the HTML Canvas element for this tile.
   * @return {HTMLCanvasElement|OffscreenCanvas} Canvas.
   */ getImage() {
        return this.canvas_;
    }
    /**
   * @private
   */ reproject_() {
        const sources = [];
        this.sourceTiles_.forEach((source)=>{
            const tile = source.tile;
            if (tile && tile.getState() == (0, $79d423c0f6adbcbb$export$2e2bcd8739ae039).LOADED) {
                const extent = this.sourceTileGrid_.getTileCoordExtent(tile.tileCoord);
                extent[0] += source.offset;
                extent[2] += source.offset;
                const clipExtent = this.clipExtent_?.slice();
                if (clipExtent) {
                    clipExtent[0] += source.offset;
                    clipExtent[2] += source.offset;
                }
                sources.push({
                    extent: extent,
                    clipExtent: clipExtent,
                    image: tile.getImage()
                });
            }
        });
        this.sourceTiles_.length = 0;
        if (sources.length === 0) this.state = (0, $79d423c0f6adbcbb$export$2e2bcd8739ae039).ERROR;
        else {
            const z = this.wrappedTileCoord_[0];
            const size = this.targetTileGrid_.getTileSize(z);
            const width = typeof size === 'number' ? size : size[0];
            const height = typeof size === 'number' ? size : size[1];
            const targetResolution = this.targetTileGrid_.getResolution(z);
            const sourceResolution = this.sourceTileGrid_.getResolution(this.sourceZ_);
            const targetExtent = this.targetTileGrid_.getTileCoordExtent(this.wrappedTileCoord_);
            this.canvas_ = (0, $a414945bcb55714f$export$b3890eb0ae9dca99)(width, height, this.pixelRatio_, sourceResolution, this.sourceTileGrid_.getExtent(), targetResolution, targetExtent, this.triangulation_, sources, this.gutter_, this.renderEdges_, this.interpolate);
            this.state = (0, $79d423c0f6adbcbb$export$2e2bcd8739ae039).LOADED;
        }
        this.changed();
    }
    /**
   * Load not yet loaded URI.
   * @override
   */ load() {
        for (const sourceTile of this.sourceTiles_)sourceTile.tile = sourceTile.getTile();
        if (this.state == (0, $79d423c0f6adbcbb$export$2e2bcd8739ae039).IDLE) {
            this.state = (0, $79d423c0f6adbcbb$export$2e2bcd8739ae039).LOADING;
            this.changed();
            let leftToLoad = 0;
            this.sourcesListenerKeys_ = [];
            this.sourceTiles_.forEach(({ tile: tile })=>{
                const state = tile.getState();
                if (state == (0, $79d423c0f6adbcbb$export$2e2bcd8739ae039).IDLE || state == (0, $79d423c0f6adbcbb$export$2e2bcd8739ae039).LOADING) {
                    leftToLoad++;
                    const sourceListenKey = (0, $63963d09e0c49405$export$63174c828edd6ff8)(tile, (0, $b5fa963342da4935$export$2e2bcd8739ae039).CHANGE, (e)=>{
                        const state = tile.getState();
                        if (state == (0, $79d423c0f6adbcbb$export$2e2bcd8739ae039).LOADED || state == (0, $79d423c0f6adbcbb$export$2e2bcd8739ae039).ERROR || state == (0, $79d423c0f6adbcbb$export$2e2bcd8739ae039).EMPTY) {
                            (0, $63963d09e0c49405$export$b0a21c8b3c1c921)(sourceListenKey);
                            leftToLoad--;
                            if (leftToLoad === 0) {
                                this.unlistenSources_();
                                this.reproject_();
                            }
                        }
                    });
                    this.sourcesListenerKeys_.push(sourceListenKey);
                }
            });
            if (leftToLoad === 0) setTimeout(this.reproject_.bind(this), 0);
            else this.sourceTiles_.forEach(function({ tile: tile }, i, arr) {
                const state = tile.getState();
                if (state == (0, $79d423c0f6adbcbb$export$2e2bcd8739ae039).IDLE) tile.load();
            });
        }
    }
    /**
   * @private
   */ unlistenSources_() {
        this.sourcesListenerKeys_.forEach((0, $63963d09e0c49405$export$b0a21c8b3c1c921));
        this.sourcesListenerKeys_ = null;
    }
    /**
   * Remove from the cache due to expiry
   * @override
   */ release() {
        if (this.canvas_) {
            (0, $b6f6d442e8ff57e1$export$e918ac6a1026a12a)(/** @type {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} */ this.canvas_.getContext('2d'));
            (0, $a414945bcb55714f$export$a166f0857c555517).push(this.canvas_);
            this.canvas_ = null;
        }
        this.sourceTiles_.length = 0;
        super.release();
    }
}
var $a9e17fc88997910c$export$2e2bcd8739ae039 = $a9e17fc88997910c$var$ReprojTile;


/**
 * @module ol/size
 */ /**
 * An array of numbers representing a size: `[width, height]`.
 * @typedef {Array<number>} Size
 * @api
 */ /**
 * Returns a buffered size.
 * @param {Size} size Size.
 * @param {number} num The amount by which to buffer.
 * @param {Size} [dest] Optional reusable size array.
 * @return {Size} The buffered size.
 */ function $625e418aeada4c0d$export$ab1029bcae9ddb4a(size, num, dest) {
    if (dest === undefined) dest = [
        0,
        0
    ];
    dest[0] = size[0] + 2 * num;
    dest[1] = size[1] + 2 * num;
    return dest;
}
function $625e418aeada4c0d$export$622c471beb1693c7(size) {
    return size[0] > 0 && size[1] > 0;
}
function $625e418aeada4c0d$export$dcdf75081b88279d(size, ratio, dest) {
    if (dest === undefined) dest = [
        0,
        0
    ];
    dest[0] = size[0] * ratio + 0.5 | 0;
    dest[1] = size[1] * ratio + 0.5 | 0;
    return dest;
}
function $625e418aeada4c0d$export$a71a825ff42fb8e1(size, dest) {
    if (Array.isArray(size)) return size;
    if (dest === undefined) dest = [
        size,
        size
    ];
    else {
        dest[0] = size;
        dest[1] = size;
    }
    return dest;
}


/**
 * @module ol/structs/LRUCache
 */ 

/**
 * @typedef {Object} Entry
 * @property {string} key_ Key.
 * @property {Entry|null} newer Newer.
 * @property {Entry|null} older Older.
 * @property {*} value_ Value.
 */ /**
 * @classdesc
 * Implements a Least-Recently-Used cache where the keys do not conflict with
 * Object's properties (e.g. 'hasOwnProperty' is not allowed as a key). Expiring
 * items from the cache is the responsibility of the user.
 *
 * @fires import("../events/Event.js").default
 * @template T
 */ class $3ca2ce2767adc523$var$LRUCache {
    /**
   * @param {number} [highWaterMark] High water mark.
   */ constructor(highWaterMark){
        /**
     * Desired max cache size after expireCache(). If set to 0, no cache entries
     * will be pruned at all.
     * @type {number}
     */ this.highWaterMark = highWaterMark !== undefined ? highWaterMark : 2048;
        /**
     * @private
     * @type {number}
     */ this.count_ = 0;
        /**
     * @private
     * @type {!Object<string, Entry>}
     */ this.entries_ = {};
        /**
     * @private
     * @type {?Entry}
     */ this.oldest_ = null;
        /**
     * @private
     * @type {?Entry}
     */ this.newest_ = null;
    }
    deleteOldest() {
        const entry = this.pop();
        if (entry instanceof (0, $1f0239b94d40ee35$export$2e2bcd8739ae039)) entry.dispose();
    }
    /**
   * @return {boolean} Can expire cache.
   */ canExpireCache() {
        return this.highWaterMark > 0 && this.getCount() > this.highWaterMark;
    }
    /**
   * Expire the cache. When the cache entry is a {@link module:ol/Disposable~Disposable},
   * the entry will be disposed.
   * @param {!Object<string, boolean>} [keep] Keys to keep. To be implemented by subclasses.
   */ expireCache(keep) {
        while(this.canExpireCache())this.deleteOldest();
    }
    /**
   * FIXME empty description for jsdoc
   */ clear() {
        while(this.oldest_)this.deleteOldest();
    }
    /**
   * @param {string} key Key.
   * @return {boolean} Contains key.
   */ containsKey(key) {
        return this.entries_.hasOwnProperty(key);
    }
    /**
   * @param {function(T, string, LRUCache<T>): ?} f The function
   *     to call for every entry from the oldest to the newer. This function takes
   *     3 arguments (the entry value, the entry key and the LRUCache object).
   *     The return value is ignored.
   */ forEach(f) {
        let entry = this.oldest_;
        while(entry){
            f(entry.value_, entry.key_, this);
            entry = entry.newer;
        }
    }
    /**
   * @param {string} key Key.
   * @param {*} [options] Options (reserved for subclasses).
   * @return {T} Value.
   */ get(key, options) {
        const entry = this.entries_[key];
        (0, $71eb897bda873684$export$a7a9523472993e97)(entry !== undefined, 'Tried to get a value for a key that does not exist in the cache');
        if (entry === this.newest_) return entry.value_;
        if (entry === this.oldest_) {
            this.oldest_ = /** @type {Entry} */ this.oldest_.newer;
            this.oldest_.older = null;
        } else {
            entry.newer.older = entry.older;
            entry.older.newer = entry.newer;
        }
        entry.newer = null;
        entry.older = this.newest_;
        this.newest_.newer = entry;
        this.newest_ = entry;
        return entry.value_;
    }
    /**
   * Remove an entry from the cache.
   * @param {string} key The entry key.
   * @return {T} The removed entry.
   */ remove(key) {
        const entry = this.entries_[key];
        (0, $71eb897bda873684$export$a7a9523472993e97)(entry !== undefined, 'Tried to get a value for a key that does not exist in the cache');
        if (entry === this.newest_) {
            this.newest_ = /** @type {Entry} */ entry.older;
            if (this.newest_) this.newest_.newer = null;
        } else if (entry === this.oldest_) {
            this.oldest_ = /** @type {Entry} */ entry.newer;
            if (this.oldest_) this.oldest_.older = null;
        } else {
            entry.newer.older = entry.older;
            entry.older.newer = entry.newer;
        }
        delete this.entries_[key];
        --this.count_;
        return entry.value_;
    }
    /**
   * @return {number} Count.
   */ getCount() {
        return this.count_;
    }
    /**
   * @return {Array<string>} Keys.
   */ getKeys() {
        const keys = new Array(this.count_);
        let i = 0;
        let entry;
        for(entry = this.newest_; entry; entry = entry.older)keys[i++] = entry.key_;
        return keys;
    }
    /**
   * @return {Array<T>} Values.
   */ getValues() {
        const values = new Array(this.count_);
        let i = 0;
        let entry;
        for(entry = this.newest_; entry; entry = entry.older)values[i++] = entry.value_;
        return values;
    }
    /**
   * @return {T} Last value.
   */ peekLast() {
        return this.oldest_.value_;
    }
    /**
   * @return {string} Last key.
   */ peekLastKey() {
        return this.oldest_.key_;
    }
    /**
   * Get the key of the newest item in the cache.  Throws if the cache is empty.
   * @return {string} The newest key.
   */ peekFirstKey() {
        return this.newest_.key_;
    }
    /**
   * Return an entry without updating least recently used time.
   * @param {string} key Key.
   * @return {T|undefined} Value.
   */ peek(key) {
        return this.entries_[key]?.value_;
    }
    /**
   * @return {T} value Value.
   */ pop() {
        const entry = this.oldest_;
        delete this.entries_[entry.key_];
        if (entry.newer) entry.newer.older = null;
        this.oldest_ = /** @type {Entry} */ entry.newer;
        if (!this.oldest_) this.newest_ = null;
        --this.count_;
        return entry.value_;
    }
    /**
   * @param {string} key Key.
   * @param {T} value Value.
   */ replace(key, value) {
        this.get(key); // update `newest_`
        this.entries_[key].value_ = value;
    }
    /**
   * @param {string} key Key.
   * @param {T} value Value.
   */ set(key, value) {
        (0, $71eb897bda873684$export$a7a9523472993e97)(!(key in this.entries_), 'Tried to set a value for a key that is used already');
        const entry = {
            key_: key,
            newer: null,
            older: this.newest_,
            value_: value
        };
        if (!this.newest_) this.oldest_ = entry;
        else this.newest_.newer = entry;
        this.newest_ = entry;
        this.entries_[key] = entry;
        ++this.count_;
    }
    /**
   * Set a maximum number of entries for the cache.
   * @param {number} size Cache size.
   * @api
   */ setSize(size) {
        this.highWaterMark = size;
    }
}
var $3ca2ce2767adc523$export$2e2bcd8739ae039 = $3ca2ce2767adc523$var$LRUCache;


/**
 * @module ol/tilecoord
 */ 
function $8b203a265587842e$export$958e3e1a02eac4b6(z, x, y, tileCoord) {
    if (tileCoord !== undefined) {
        tileCoord[0] = z;
        tileCoord[1] = x;
        tileCoord[2] = y;
        return tileCoord;
    }
    return [
        z,
        x,
        y
    ];
}
function $8b203a265587842e$export$92d0df0f1d25c63c(z, x, y) {
    return z + '/' + x + '/' + y;
}
function $8b203a265587842e$export$a47fb462a08de82f(tileCoord) {
    return $8b203a265587842e$export$92d0df0f1d25c63c(tileCoord[0], tileCoord[1], tileCoord[2]);
}
function $8b203a265587842e$export$7f760414a8e3d2b5(tileKey) {
    const [z, x, y] = tileKey.substring(tileKey.lastIndexOf('/') + 1, tileKey.length).split(',').map(Number);
    return $8b203a265587842e$export$92d0df0f1d25c63c(z, x, y);
}
function $8b203a265587842e$export$611736262b635f8d(source, sourceKey, z, x, y) {
    return `${(0, $fd76d391cc228565$export$5e82334337e0f204)(source)},${sourceKey},${$8b203a265587842e$export$92d0df0f1d25c63c(z, x, y)}`;
}
function $8b203a265587842e$export$a807b7874eb66454(key) {
    return key.split('/').map(Number);
}
function $8b203a265587842e$export$d6af199866bfb566(tileCoord) {
    return $8b203a265587842e$export$731f79419750ccf7(tileCoord[0], tileCoord[1], tileCoord[2]);
}
function $8b203a265587842e$export$731f79419750ccf7(z, x, y) {
    return (x << z) + y;
}
function $8b203a265587842e$export$60bedf8e3e3c3dbe(tileCoord, tileGrid) {
    const z = tileCoord[0];
    const x = tileCoord[1];
    const y = tileCoord[2];
    if (tileGrid.getMinZoom() > z || z > tileGrid.getMaxZoom()) return false;
    const tileRange = tileGrid.getFullTileRange(z);
    if (!tileRange) return true;
    return tileRange.containsXY(x, y);
}




/**
 * @module ol/renderer/canvas/Layer
 */ 
/**
 * @module ol/color
 */ 

const $ebac9d8363fa165e$export$6c844c64a5efe1ee = [
    NaN,
    NaN,
    NaN,
    0
];
let $ebac9d8363fa165e$var$colorParseContext;
/**
 * @return {CanvasRenderingContext2D} The color parse context
 */ function $ebac9d8363fa165e$var$getColorParseContext() {
    if (!$ebac9d8363fa165e$var$colorParseContext) $ebac9d8363fa165e$var$colorParseContext = (0, $b6f6d442e8ff57e1$export$9e05d10eae75c464)(1, 1, undefined, {
        willReadFrequently: true,
        desynchronized: true
    });
    return $ebac9d8363fa165e$var$colorParseContext;
}
const $ebac9d8363fa165e$var$rgbModernRegEx = /^rgba?\(\s*(\d+%?)\s+(\d+%?)\s+(\d+%?)(?:\s*\/\s*(\d+%|\d*\.\d+|[01]))?\s*\)$/i;
const $ebac9d8363fa165e$var$rgbLegacyAbsoluteRegEx = /^rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)(?:\s*,\s*(\d+%|\d*\.\d+|[01]))?\s*\)$/i;
const $ebac9d8363fa165e$var$rgbLegacyPercentageRegEx = /^rgba?\(\s*(\d+%)\s*,\s*(\d+%)\s*,\s*(\d+%)(?:\s*,\s*(\d+%|\d*\.\d+|[01]))?\s*\)$/i;
const $ebac9d8363fa165e$var$hexRegEx = /^#([\da-f]{3,4}|[\da-f]{6}|[\da-f]{8})$/i;
/**
 * @param {string} s Color component as number or percentage.
 * @param {number} divider Divider for percentage.
 * @return {number} Color component.
 */ function $ebac9d8363fa165e$var$toColorComponent(s, divider) {
    return s.endsWith('%') ? Number(s.substring(0, s.length - 1)) / divider : Number(s);
}
/**
 * @param {string} color Color string.
 */ function $ebac9d8363fa165e$var$throwInvalidColor(color) {
    throw new Error('failed to parse "' + color + '" as color');
}
/**
 * @param {string} color Color string.
 * @return {Color} RGBa color array.
 */ function $ebac9d8363fa165e$var$parseRgba(color) {
    // Fast lane for rgb(a) colors
    if (color.toLowerCase().startsWith('rgb')) {
        const rgb = color.match($ebac9d8363fa165e$var$rgbLegacyAbsoluteRegEx) || color.match($ebac9d8363fa165e$var$rgbModernRegEx) || color.match($ebac9d8363fa165e$var$rgbLegacyPercentageRegEx);
        if (rgb) {
            const alpha = rgb[4];
            const rgbDivider = 100 / 255;
            return [
                (0, $6a95bd76d7103f37$export$7d15b64cf5a3a4c4)($ebac9d8363fa165e$var$toColorComponent(rgb[1], rgbDivider) + 0.5 | 0, 0, 255),
                (0, $6a95bd76d7103f37$export$7d15b64cf5a3a4c4)($ebac9d8363fa165e$var$toColorComponent(rgb[2], rgbDivider) + 0.5 | 0, 0, 255),
                (0, $6a95bd76d7103f37$export$7d15b64cf5a3a4c4)($ebac9d8363fa165e$var$toColorComponent(rgb[3], rgbDivider) + 0.5 | 0, 0, 255),
                alpha !== undefined ? (0, $6a95bd76d7103f37$export$7d15b64cf5a3a4c4)($ebac9d8363fa165e$var$toColorComponent(alpha, 100), 0, 1) : 1
            ];
        }
        $ebac9d8363fa165e$var$throwInvalidColor(color);
    }
    // Fast lane for hex colors (also with alpha)
    if (color.startsWith('#')) {
        if ($ebac9d8363fa165e$var$hexRegEx.test(color)) {
            const hex = color.substring(1);
            const step = hex.length <= 4 ? 1 : 2;
            const colorFromHex = [
                0,
                0,
                0,
                255
            ];
            for(let i = 0, ii = hex.length; i < ii; i += step){
                let colorComponent = parseInt(hex.substring(i, i + step), 16);
                if (step === 1) colorComponent += colorComponent << 4;
                colorFromHex[i / step] = colorComponent;
            }
            colorFromHex[3] = colorFromHex[3] / 255;
            return colorFromHex;
        }
        $ebac9d8363fa165e$var$throwInvalidColor(color);
    }
    // Use canvas color serialization to parse the color into hex or rgba
    // See https://www.w3.org/TR/2021/SPSD-2dcontext-20210128/#serialization-of-a-color
    const context = $ebac9d8363fa165e$var$getColorParseContext();
    context.fillStyle = '#abcdef';
    let invalidCheckFillStyle = context.fillStyle;
    context.fillStyle = color;
    if (context.fillStyle === invalidCheckFillStyle) {
        context.fillStyle = '#fedcba';
        invalidCheckFillStyle = context.fillStyle;
        context.fillStyle = color;
        if (context.fillStyle === invalidCheckFillStyle) $ebac9d8363fa165e$var$throwInvalidColor(color);
    }
    const colorString = context.fillStyle;
    if (colorString.startsWith('#') || colorString.startsWith('rgba')) return $ebac9d8363fa165e$var$parseRgba(colorString);
    context.clearRect(0, 0, 1, 1);
    context.fillRect(0, 0, 1, 1);
    const colorFromImage = Array.from(context.getImageData(0, 0, 1, 1).data);
    colorFromImage[3] = (0, $6a95bd76d7103f37$export$a81f732198733497)(colorFromImage[3] / 255, 3);
    return colorFromImage;
}
function $ebac9d8363fa165e$export$590567be997858b6(color) {
    if (typeof color === 'string') return color;
    return $ebac9d8363fa165e$export$f84e8e69fd4488a5(color);
}
/**
 * @type {number}
 */ const $ebac9d8363fa165e$var$MAX_CACHE_SIZE = 1024;
/**
 * We maintain a small cache of parsed strings.  Whenever the cache grows too large,
 * we delete an arbitrary set of the entries.
 *
 * @type {Object<string, Color>}
 */ const $ebac9d8363fa165e$var$cache = {};
/**
 * @type {number}
 */ let $ebac9d8363fa165e$var$cacheSize = 0;
function $ebac9d8363fa165e$export$138c09bdd6bd797c(color) {
    if (color.length === 4) return color;
    const output = color.slice();
    output[3] = 1;
    return output;
}
// The functions b1, b2, a1, a2, rgbaToLcha and lchaToRgba below are adapted from
// https://stackoverflow.com/a/67219995/2389327
/**
 * @param {number} v Input value.
 * @return {number} Output value.
 */ function $ebac9d8363fa165e$var$b1(v) {
    return v > 0.0031308 ? Math.pow(v, 1 / 2.4) * 269.025 - 14.025 : v * 3294.6;
}
/**
 * @param {number} v Input value.
 * @return {number} Output value.
 */ function $ebac9d8363fa165e$var$b2(v) {
    return v > 0.2068965 ? Math.pow(v, 3) : (v - 4 / 29) * (108 / 841);
}
/**
 * @param {number} v Input value.
 * @return {number} Output value.
 */ function $ebac9d8363fa165e$var$a1(v) {
    return v > 10.314724 ? Math.pow((v + 14.025) / 269.025, 2.4) : v / 3294.6;
}
/**
 * @param {number} v Input value.
 * @return {number} Output value.
 */ function $ebac9d8363fa165e$var$a2(v) {
    return v > 0.0088564 ? Math.pow(v, 1 / 3) : v / (108 / 841) + 4 / 29;
}
function $ebac9d8363fa165e$export$44fb54fa2e0c0d4(color) {
    const r = $ebac9d8363fa165e$var$a1(color[0]);
    const g = $ebac9d8363fa165e$var$a1(color[1]);
    const b = $ebac9d8363fa165e$var$a1(color[2]);
    const y = $ebac9d8363fa165e$var$a2(r * 0.222488403 + g * 0.716873169 + b * 0.06060791);
    const l = 500 * ($ebac9d8363fa165e$var$a2(r * 0.452247074 + g * 0.399439023 + b * 0.148375274) - y);
    const q = 200 * (y - $ebac9d8363fa165e$var$a2(r * 0.016863605 + g * 0.117638439 + b * 0.865350722));
    const h = Math.atan2(q, l) * (180 / Math.PI);
    return [
        116 * y - 16,
        Math.sqrt(l * l + q * q),
        h < 0 ? h + 360 : h,
        color[3]
    ];
}
function $ebac9d8363fa165e$export$27cc94530c050f00(color) {
    const l = (color[0] + 16) / 116;
    const c = color[1];
    const h = color[2] * Math.PI / 180;
    const y = $ebac9d8363fa165e$var$b2(l);
    const x = $ebac9d8363fa165e$var$b2(l + c / 500 * Math.cos(h));
    const z = $ebac9d8363fa165e$var$b2(l - c / 200 * Math.sin(h));
    const r = $ebac9d8363fa165e$var$b1(x * 3.021973625 - y * 1.617392459 - z * 0.404875592);
    const g = $ebac9d8363fa165e$var$b1(x * -0.943766287 + y * 1.916279586 + z * 0.027607165);
    const b = $ebac9d8363fa165e$var$b1(x * 0.069407491 - y * 0.22898585 + z * 1.159737864);
    return [
        (0, $6a95bd76d7103f37$export$7d15b64cf5a3a4c4)(r + 0.5 | 0, 0, 255),
        (0, $6a95bd76d7103f37$export$7d15b64cf5a3a4c4)(g + 0.5 | 0, 0, 255),
        (0, $6a95bd76d7103f37$export$7d15b64cf5a3a4c4)(b + 0.5 | 0, 0, 255),
        color[3]
    ];
}
function $ebac9d8363fa165e$export$3004f64547af360e(s) {
    if (s === 'none') return $ebac9d8363fa165e$export$6c844c64a5efe1ee;
    if ($ebac9d8363fa165e$var$cache.hasOwnProperty(s)) return $ebac9d8363fa165e$var$cache[s];
    if ($ebac9d8363fa165e$var$cacheSize >= $ebac9d8363fa165e$var$MAX_CACHE_SIZE) {
        let i = 0;
        for(const key in $ebac9d8363fa165e$var$cache)if ((i++ & 3) === 0) {
            delete $ebac9d8363fa165e$var$cache[key];
            --$ebac9d8363fa165e$var$cacheSize;
        }
    }
    const color = $ebac9d8363fa165e$var$parseRgba(s);
    if (color.length !== 4) $ebac9d8363fa165e$var$throwInvalidColor(s);
    for (const c of color)if (isNaN(c)) $ebac9d8363fa165e$var$throwInvalidColor(s);
    $ebac9d8363fa165e$var$cache[s] = color;
    ++$ebac9d8363fa165e$var$cacheSize;
    return color;
}
function $ebac9d8363fa165e$export$75093a47a9fa838d(color) {
    if (Array.isArray(color)) return color;
    return $ebac9d8363fa165e$export$3004f64547af360e(color);
}
function $ebac9d8363fa165e$export$f84e8e69fd4488a5(color) {
    let r = color[0];
    if (r != (r | 0)) r = r + 0.5 | 0;
    let g = color[1];
    if (g != (g | 0)) g = g + 0.5 | 0;
    let b = color[2];
    if (b != (b | 0)) b = b + 0.5 | 0;
    const a = color[3] === undefined ? 1 : Math.round(color[3] * 1000) / 1000;
    return 'rgba(' + r + ',' + g + ',' + b + ',' + a + ')';
}
function $ebac9d8363fa165e$export$40dd713d7775a0b1(s) {
    try {
        $ebac9d8363fa165e$export$3004f64547af360e(s);
        return true;
    } catch  {
        return false;
    }
}





/**
 * @module ol/render/Event
 */ 
class $e974dfa6f9f27b98$var$RenderEvent extends (0, $5c6b0a43c077a98f$export$2e2bcd8739ae039) {
    /**
   * @param {import("./EventType.js").default} type Type.
   * @param {import("../transform.js").Transform} [inversePixelTransform] Transform for
   *     CSS pixels to rendered pixels.
   * @param {import("../Map.js").FrameState} [frameState] Frame state.
   * @param {?(CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D|WebGLRenderingContext)} [context] Context.
   */ constructor(type, inversePixelTransform, frameState, context){
        super(type);
        /**
     * Transform from CSS pixels (relative to the top-left corner of the map viewport)
     * to rendered pixels on this event's `context`. Only available when a Canvas renderer is used, null otherwise.
     * @type {import("../transform.js").Transform|undefined}
     * @api
     */ this.inversePixelTransform = inversePixelTransform;
        /**
     * An object representing the current render frame state.
     * @type {import("../Map.js").FrameState|undefined}
     * @api
     */ this.frameState = frameState;
        /**
     * Canvas context. Not available when the event is dispatched by the map. For Canvas 2D layers,
     * the context will be the 2D rendering context.  For WebGL layers, the context will be the WebGL
     * context.
     * @type {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D|WebGLRenderingContext|undefined}
     * @api
     */ this.context = context;
    }
}
var $e974dfa6f9f27b98$export$2e2bcd8739ae039 = $e974dfa6f9f27b98$var$RenderEvent;


/**
 * @module ol/render/EventType
 */ /**
 * @enum {string}
 */ var $6e54630f610adff4$export$2e2bcd8739ae039 /**
 * @typedef {'postrender'|'precompose'|'postcompose'|'rendercomplete'} MapRenderEventTypes
 */  /**
 * @typedef {'postrender'|'prerender'} LayerRenderEventTypes
 */  = {
    /**
   * Triggered before a layer is rendered.
   * @event module:ol/render/Event~RenderEvent#prerender
   * @api
   */ PRERENDER: 'prerender',
    /**
   * Triggered after a layer is rendered.
   * @event module:ol/render/Event~RenderEvent#postrender
   * @api
   */ POSTRENDER: 'postrender',
    /**
   * Triggered before layers are composed.  When dispatched by the map, the event object will not have
   * a `context` set.  When dispatched by a layer, the event object will have a `context` set.  Only
   * WebGL layers currently dispatch this event.
   * @event module:ol/render/Event~RenderEvent#precompose
   * @api
   */ PRECOMPOSE: 'precompose',
    /**
   * Triggered after layers are composed.  When dispatched by the map, the event object will not have
   * a `context` set.  When dispatched by a layer, the event object will have a `context` set.  Only
   * WebGL layers currently dispatch this event.
   * @event module:ol/render/Event~RenderEvent#postcompose
   * @api
   */ POSTCOMPOSE: 'postcompose',
    /**
   * Triggered when rendering is complete, i.e. all sources and tiles have
   * finished loading for the current viewport, and all tiles are faded in.
   * The event object will not have a `context` set.
   * @event module:ol/render/Event~RenderEvent#rendercomplete
   * @api
   */ RENDERCOMPLETE: 'rendercomplete'
};


/**
 * @module ol/render/canvas/ZIndexContext
 */ 
/** @typedef {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D & {globalAlpha: any}} ZIndexContextProxy */ /**
 * @extends {CanvasRenderingContext2D}
 */ class $365b684a50cc23be$var$ZIndexContext {
    constructor(){
        /**
     * @private
     * @type {Array<Array<*>>}
     */ this.instructions_ = [];
        /**
     * @type {number}
     */ this.zIndex = 0;
        /**
     * @private
     * @type {number}
     */ this.offset_ = 0;
        /**
     * @private
     * @type {ZIndexContextProxy}
     */ this.context_ = /** @type {ZIndexContextProxy} */ new Proxy((0, $b6f6d442e8ff57e1$export$fcb72ce088a6632c)(), {
            get: (target, property)=>{
                if (typeof /** @type {*} */ (0, $b6f6d442e8ff57e1$export$fcb72ce088a6632c)()[property] !== 'function') // we only accept calling functions on the proxy, not accessing properties
                return undefined;
                this.push_(property);
                return this.pushMethodArgs_;
            },
            set: (target, property, value)=>{
                this.push_(property, value);
                return true;
            }
        });
    }
    /**
   * @param {...*} args Arguments to push to the instructions array.
   * @private
   */ push_(...args) {
        const instructions = this.instructions_;
        const index = this.zIndex + this.offset_;
        if (!instructions[index]) instructions[index] = [];
        instructions[index].push(...args);
    }
    /**
   * @private
   * @param {...*} args Args.
   * @return {ZIndexContext} This.
   */ pushMethodArgs_ = (...args)=>{
        this.push_(args);
        return this;
    };
    /**
   * Push a function that renders to the context directly.
   * @param {function(CanvasRenderingContext2D): void} render Function.
   */ pushFunction(render) {
        this.push_(render);
    }
    /**
   * Get a proxy for CanvasRenderingContext2D which does not support getting state
   * (e.g. `context.globalAlpha`, which will return `undefined`). To set state, if it relies on a
   * previous state (e.g. `context.globalAlpha = context.globalAlpha / 2`), set a function,
   * e.g. `context.globalAlpha = (context) => context.globalAlpha / 2`.
   * @return {ZIndexContextProxy} Context.
   */ getContext() {
        return this.context_;
    }
    /**
   * @param {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} context Context.
   */ draw(context) {
        this.instructions_.forEach((instructionsAtIndex)=>{
            for(let i = 0, ii = instructionsAtIndex.length; i < ii; ++i){
                const property = instructionsAtIndex[i];
                if (typeof property === 'function') {
                    property(context);
                    continue;
                }
                const instructionAtIndex = instructionsAtIndex[++i];
                if (typeof /** @type {*} */ context[property] === 'function') /** @type {*} */ context[property](...instructionAtIndex);
                else {
                    if (typeof instructionAtIndex === 'function') {
                        /** @type {*} */ context[property] = instructionAtIndex(context);
                        continue;
                    }
                    /** @type {*} */ context[property] = instructionAtIndex;
                }
            }
        });
    }
    clear() {
        this.instructions_.length = 0;
        this.zIndex = 0;
        this.offset_ = 0;
    }
    /**
   * Offsets the zIndex by the highest current zIndex. Useful for rendering multiple worlds or tiles, to
   * avoid conflicting context.clip() or context.save()/restore() calls.
   */ offset() {
        this.offset_ = this.instructions_.length;
        this.zIndex = 0;
    }
}
var $365b684a50cc23be$export$2e2bcd8739ae039 = $365b684a50cc23be$var$ZIndexContext;



/**
 * @module ol/renderer/Layer
 */ 



const $f39b6566d19a1a75$var$maxStaleKeys = 5;
/**
 * @template {import("../layer/Layer.js").default} LayerType
 */ class $f39b6566d19a1a75$var$LayerRenderer extends (0, $a8e855f7c93fe402$export$2e2bcd8739ae039) {
    /**
   * @param {LayerType} layer Layer.
   */ constructor(layer){
        super();
        /**
     * The renderer is initialized and ready to render.
     * @type {boolean}
     */ this.ready = true;
        /** @private */ this.boundHandleImageChange_ = this.handleImageChange_.bind(this);
        /**
     * @private
     * @type {LayerType}
     */ this.layer_ = layer;
        /**
     * @type {Array<string>}
     * @private
     */ this.staleKeys_ = new Array();
        /**
     * @type {number}
     * @protected
     */ this.maxStaleKeys = $f39b6566d19a1a75$var$maxStaleKeys;
    }
    /**
   * @return {Array<string>} Get the list of stale keys.
   */ getStaleKeys() {
        return this.staleKeys_;
    }
    /**
   * @param {string} key The new stale key.
   */ prependStaleKey(key) {
        this.staleKeys_.unshift(key);
        if (this.staleKeys_.length > this.maxStaleKeys) this.staleKeys_.length = this.maxStaleKeys;
    }
    /**
   * Asynchronous layer level hit detection.
   * @param {import("../pixel.js").Pixel} pixel Pixel.
   * @return {Promise<Array<import("../Feature").FeatureLike>>} Promise that resolves with
   * an array of features.
   */ getFeatures(pixel) {
        return (0, $fd76d391cc228565$export$817eb92a8194bab0)();
    }
    /**
   * @param {import("../pixel.js").Pixel} pixel Pixel.
   * @return {Uint8ClampedArray|Uint8Array|Float32Array|DataView|null} Pixel data.
   */ getData(pixel) {
        return null;
    }
    /**
   * Determine whether render should be called.
   * @abstract
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @return {boolean} Layer is ready to be rendered.
   */ prepareFrame(frameState) {
        return (0, $fd76d391cc228565$export$817eb92a8194bab0)();
    }
    /**
   * Render the layer.
   * @abstract
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @param {HTMLElement|null} target Target that may be used to render content to.
   * @return {HTMLElement} The rendered element.
   */ renderFrame(frameState, target) {
        return (0, $fd76d391cc228565$export$817eb92a8194bab0)();
    }
    /**
   * @abstract
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @param {import("./vector.js").FeatureCallback<T>} callback Feature callback.
   * @param {Array<import("./Map.js").HitMatch<T>>} matches The hit detected matches with tolerance.
   * @return {T|undefined} Callback result.
   * @template T
   */ forEachFeatureAtCoordinate(coordinate, frameState, hitTolerance, callback, matches) {
        return undefined;
    }
    /**
   * @return {LayerType} Layer.
   */ getLayer() {
        return this.layer_;
    }
    /**
   * Perform action necessary to get the layer rendered after new fonts have loaded
   * @abstract
   */ handleFontsChanged() {}
    /**
   * Handle changes in image state.
   * @param {import("../events/Event.js").default} event Image change event.
   * @private
   */ handleImageChange_(event) {
        const image = /** @type {import("../Image.js").default} */ event.target;
        if (image.getState() === (0, $f217251b3f1483a0$export$2e2bcd8739ae039).LOADED || image.getState() === (0, $f217251b3f1483a0$export$2e2bcd8739ae039).ERROR) this.renderIfReadyAndVisible();
    }
    /**
   * Load the image if not already loaded, and register the image change
   * listener if needed.
   * @param {import("../Image.js").default} image Image.
   * @return {boolean} `true` if the image is already loaded, `false` otherwise.
   * @protected
   */ loadImage(image) {
        let imageState = image.getState();
        if (imageState != (0, $f217251b3f1483a0$export$2e2bcd8739ae039).LOADED && imageState != (0, $f217251b3f1483a0$export$2e2bcd8739ae039).ERROR) image.addEventListener((0, $b5fa963342da4935$export$2e2bcd8739ae039).CHANGE, this.boundHandleImageChange_);
        if (imageState == (0, $f217251b3f1483a0$export$2e2bcd8739ae039).IDLE) {
            image.load();
            imageState = image.getState();
        }
        return imageState == (0, $f217251b3f1483a0$export$2e2bcd8739ae039).LOADED;
    }
    /**
   * @protected
   */ renderIfReadyAndVisible() {
        const layer = this.getLayer();
        if (layer && layer.getVisible() && layer.getSourceState() === 'ready') layer.changed();
    }
    /**
   * @param {import("../Map.js").FrameState} frameState Frame state.
   */ renderDeferred(frameState) {}
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        delete this.layer_;
        super.disposeInternal();
    }
}
var $f39b6566d19a1a75$export$2e2bcd8739ae039 = $f39b6566d19a1a75$var$LayerRenderer;


const $334f608456f9cc13$export$a166f0857c555517 = [];
/**
 * @type {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D}
 */ let $334f608456f9cc13$var$pixelContext = null;
function $334f608456f9cc13$var$createPixelContext() {
    $334f608456f9cc13$var$pixelContext = (0, $b6f6d442e8ff57e1$export$9e05d10eae75c464)(1, 1, undefined, {
        willReadFrequently: true
    });
}
/**
 * @abstract
 * @template {import("../../layer/Layer.js").default} LayerType
 * @extends {LayerRenderer<LayerType>}
 */ class $334f608456f9cc13$var$CanvasLayerRenderer extends (0, $f39b6566d19a1a75$export$2e2bcd8739ae039) {
    /**
   * @param {LayerType} layer Layer.
   */ constructor(layer){
        super(layer);
        /**
     * HTMLElement container for the layer to be rendered in.
     * @protected
     * @type {HTMLElement}
     */ this.container = null;
        /**
     * @protected
     * @type {number}
     */ this.renderedResolution;
        /**
     * A temporary transform.  The values in this transform should only be used in a
     * function that sets the values.
     * @protected
     * @type {import("../../transform.js").Transform}
     */ this.tempTransform = (0, $dff5a03e015694d8$export$185802fd694ee1f5)();
        /**
     * The transform for rendered pixels to viewport CSS pixels.  This transform must
     * be set when rendering a frame and may be used by other functions after rendering.
     * @protected
     * @type {import("../../transform.js").Transform}
     */ this.pixelTransform = (0, $dff5a03e015694d8$export$185802fd694ee1f5)();
        /**
     * The transform for viewport CSS pixels to rendered pixels.  This transform must
     * be set when rendering a frame and may be used by other functions after rendering.
     * @protected
     * @type {import("../../transform.js").Transform}
     */ this.inversePixelTransform = (0, $dff5a03e015694d8$export$185802fd694ee1f5)();
        /**
     * @type {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D}
     */ this.context = null;
        /**
     * @private
     * @type {ZIndexContext}
     */ this.deferredContext_ = null;
        /**
     * true if the container has been reused from the previous renderer
     * @type {boolean}
     */ this.containerReused = false;
        /**
     * @protected
     * @type {import("../../Map.js").FrameState|null}
     */ this.frameState = null;
    }
    /**
   * @param {import('../../DataTile.js').ImageLike} image Image.
   * @param {number} col The column index.
   * @param {number} row The row index.
   * @return {Uint8ClampedArray|null} The image data.
   */ getImageData(image, col, row) {
        if (!$334f608456f9cc13$var$pixelContext) $334f608456f9cc13$var$createPixelContext();
        $334f608456f9cc13$var$pixelContext.clearRect(0, 0, 1, 1);
        let data;
        try {
            $334f608456f9cc13$var$pixelContext.drawImage(image, col, row, 1, 1, 0, 0, 1, 1);
            data = $334f608456f9cc13$var$pixelContext.getImageData(0, 0, 1, 1).data;
        } catch  {
            $334f608456f9cc13$var$pixelContext = null;
            return null;
        }
        return data;
    }
    /**
   * @param {import('../../Map.js').FrameState} frameState Frame state.
   * @return {string} Background color.
   */ getBackground(frameState) {
        const layer = this.getLayer();
        let background = layer.getBackground();
        if (typeof background === 'function') background = background(frameState.viewState.resolution);
        return background || undefined;
    }
    /**
   * Get a rendering container from an existing target, if compatible.
   * @param {HTMLElement} target Potential render target.
   * @param {string} transform CSS transform matrix.
   * @param {string} [backgroundColor] Background color.
   */ useContainer(target, transform, backgroundColor) {
        // renderer canvas to target canvas
        const layerClassName = this.getLayer().getClassName();
        let container, context;
        if (target && target.className === layerClassName && (!backgroundColor || target && target.style.backgroundColor && (0, $49313fcb0fc32abe$export$e9bab7fafb253603)((0, $ebac9d8363fa165e$export$75093a47a9fa838d)(target.style.backgroundColor), (0, $ebac9d8363fa165e$export$75093a47a9fa838d)(backgroundColor)))) {
            const canvas = target.firstElementChild;
            if ((0, $b6f6d442e8ff57e1$export$4b05d74c82e4c4d2)(canvas)) context = canvas.getContext('2d');
        }
        if (context && (0, $dff5a03e015694d8$export$fe091d73a555748b)(context.canvas.style.transform, transform)) {
            // Container of the previous layer renderer can be used.
            this.container = target;
            this.context = context;
            this.containerReused = true;
        } else if (this.containerReused) {
            // Previously reused container cannot be used any more.
            this.container = null;
            this.context = null;
            this.containerReused = false;
        } else if (this.container) this.container.style.backgroundColor = null;
        if (!this.container) {
            container = (0, $32d41268b5f53567$export$98fcef3dc9973292) ? (0, $b6f6d442e8ff57e1$export$45b7f73d625b5cde)() : document.createElement('div');
            container.className = layerClassName;
            let style = container.style;
            style.position = 'absolute';
            style.width = '100%';
            style.height = '100%';
            context = (0, $b6f6d442e8ff57e1$export$9e05d10eae75c464)();
            const canvas = /** @type {HTMLCanvasElement} */ context.canvas;
            container.appendChild(canvas);
            style = canvas.style;
            style.position = 'absolute';
            style.left = '0';
            style.transformOrigin = 'top left';
            this.container = container;
            this.context = context;
        }
        if (!this.containerReused && backgroundColor && !this.container.style.backgroundColor) this.container.style.backgroundColor = backgroundColor;
    }
    /**
   * @param {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} context Context.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {import("../../extent.js").Extent} extent Clip extent.
   * @protected
   */ clipUnrotated(context, frameState, extent) {
        const topLeft = (0, $dea65c2f666fa450$export$cb1538b07e6964ff)(extent);
        const topRight = (0, $dea65c2f666fa450$export$b84fa077c8b05295)(extent);
        const bottomRight = (0, $dea65c2f666fa450$export$e77c1cf70445e168)(extent);
        const bottomLeft = (0, $dea65c2f666fa450$export$8d09f5e2e1bf560d)(extent);
        (0, $dff5a03e015694d8$export$5635d7ef4b8fee1c)(frameState.coordinateToPixelTransform, topLeft);
        (0, $dff5a03e015694d8$export$5635d7ef4b8fee1c)(frameState.coordinateToPixelTransform, topRight);
        (0, $dff5a03e015694d8$export$5635d7ef4b8fee1c)(frameState.coordinateToPixelTransform, bottomRight);
        (0, $dff5a03e015694d8$export$5635d7ef4b8fee1c)(frameState.coordinateToPixelTransform, bottomLeft);
        const inverted = this.inversePixelTransform;
        (0, $dff5a03e015694d8$export$5635d7ef4b8fee1c)(inverted, topLeft);
        (0, $dff5a03e015694d8$export$5635d7ef4b8fee1c)(inverted, topRight);
        (0, $dff5a03e015694d8$export$5635d7ef4b8fee1c)(inverted, bottomRight);
        (0, $dff5a03e015694d8$export$5635d7ef4b8fee1c)(inverted, bottomLeft);
        context.save();
        context.beginPath();
        context.moveTo(Math.round(topLeft[0]), Math.round(topLeft[1]));
        context.lineTo(Math.round(topRight[0]), Math.round(topRight[1]));
        context.lineTo(Math.round(bottomRight[0]), Math.round(bottomRight[1]));
        context.lineTo(Math.round(bottomLeft[0]), Math.round(bottomLeft[1]));
        context.clip();
    }
    /**
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {HTMLElement} target Target that may be used to render content to.
   * @protected
   */ prepareContainer(frameState, target) {
        const extent = frameState.extent;
        const resolution = frameState.viewState.resolution;
        const rotation = frameState.viewState.rotation;
        const pixelRatio = frameState.pixelRatio;
        const width = Math.round((0, $dea65c2f666fa450$export$3c49c185de0c2bfc)(extent) / resolution * pixelRatio);
        const height = Math.round((0, $dea65c2f666fa450$export$c08559766941f856)(extent) / resolution * pixelRatio);
        // set forward and inverse pixel transforms
        (0, $dff5a03e015694d8$export$f672e0b6f7222cd7)(this.pixelTransform, frameState.size[0] / 2, frameState.size[1] / 2, 1 / pixelRatio, 1 / pixelRatio, rotation, -width / 2, -height / 2);
        (0, $dff5a03e015694d8$export$bd70ea2a93c0fa4)(this.inversePixelTransform, this.pixelTransform);
        const canvasTransform = (0, $dff5a03e015694d8$export$f84e8e69fd4488a5)(this.pixelTransform);
        this.useContainer(target, canvasTransform, this.getBackground(frameState));
        if (!this.containerReused) {
            const canvas = this.context.canvas;
            if (canvas.width != width || canvas.height != height) {
                canvas.width = width;
                canvas.height = height;
            } else this.context.clearRect(0, 0, width, height);
            if (canvasTransform !== /** @type {HTMLCanvasElement} */ canvas.style.transform) /** @type {HTMLCanvasElement} */ canvas.style.transform = canvasTransform;
        }
    }
    /**
   * @param {import("../../render/EventType.js").default} type Event type.
   * @param {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} context Context.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @private
   */ dispatchRenderEvent_(type, context, frameState) {
        const layer = this.getLayer();
        if (layer.hasListener(type)) {
            const event = new (0, $e974dfa6f9f27b98$export$2e2bcd8739ae039)(type, this.inversePixelTransform, frameState, context);
            layer.dispatchEvent(event);
        }
    }
    /**
   * @param {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} context Context.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @protected
   */ preRender(context, frameState) {
        this.frameState = frameState;
        if (frameState.declutter) return;
        this.dispatchRenderEvent_((0, $6e54630f610adff4$export$2e2bcd8739ae039).PRERENDER, context, frameState);
    }
    /**
   * @param {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} context Context.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @protected
   */ postRender(context, frameState) {
        if (frameState.declutter) return;
        this.dispatchRenderEvent_((0, $6e54630f610adff4$export$2e2bcd8739ae039).POSTRENDER, context, frameState);
    }
    /**
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   */ renderDeferredInternal(frameState) {}
    /**
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @return {import('../../render/canvas/ZIndexContext.js').ZIndexContextProxy} Context.
   */ getRenderContext(frameState) {
        if (frameState.declutter && !this.deferredContext_) this.deferredContext_ = new (0, $365b684a50cc23be$export$2e2bcd8739ae039)();
        return frameState.declutter ? this.deferredContext_.getContext() : this.context;
    }
    /**
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @override
   */ renderDeferred(frameState) {
        if (!frameState.declutter) return;
        this.dispatchRenderEvent_((0, $6e54630f610adff4$export$2e2bcd8739ae039).PRERENDER, this.context, frameState);
        if (frameState.declutter && this.deferredContext_) {
            this.deferredContext_.draw(this.context);
            this.deferredContext_.clear();
        }
        this.renderDeferredInternal(frameState);
        this.dispatchRenderEvent_((0, $6e54630f610adff4$export$2e2bcd8739ae039).POSTRENDER, this.context, frameState);
    }
    /**
   * Creates a transform for rendering to an element that will be rotated after rendering.
   * @param {import("../../coordinate.js").Coordinate} center Center.
   * @param {number} resolution Resolution.
   * @param {number} rotation Rotation.
   * @param {number} pixelRatio Pixel ratio.
   * @param {number} width Width of the rendered element (in pixels).
   * @param {number} height Height of the rendered element (in pixels).
   * @param {number} offsetX Offset on the x-axis in view coordinates.
   * @protected
   * @return {!import("../../transform.js").Transform} Transform.
   */ getRenderTransform(center, resolution, rotation, pixelRatio, width, height, offsetX) {
        const dx1 = width / 2;
        const dy1 = height / 2;
        const sx = pixelRatio / resolution;
        const sy = -sx;
        const dx2 = -center[0] + offsetX;
        const dy2 = -center[1];
        return (0, $dff5a03e015694d8$export$f672e0b6f7222cd7)(this.tempTransform, dx1, dy1, sx, sy, -rotation, dx2, dy2);
    }
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        delete this.frameState;
        super.disposeInternal();
    }
}
var $334f608456f9cc13$export$2e2bcd8739ae039 = $334f608456f9cc13$var$CanvasLayerRenderer;


/**
 * @typedef {Object<number, Set<import("../../Tile.js").default>>} TileLookup
 */ /**
 * Add a tile to the lookup.
 * @param {TileLookup} tilesByZ Lookup of tiles by zoom level.
 * @param {import("../../Tile.js").default} tile A tile.
 * @param {number} z The zoom level.
 * @return {boolean} The tile was added to the lookup.
 */ function $f30d475df7f7c73d$var$addTileToLookup(tilesByZ, tile, z) {
    if (!(z in tilesByZ)) {
        tilesByZ[z] = new Set([
            tile
        ]);
        return true;
    }
    const set = tilesByZ[z];
    const existing = set.has(tile);
    if (!existing) set.add(tile);
    return !existing;
}
/**
 * Remove a tile from the lookup.
 * @param {TileLookup} tilesByZ Lookup of tiles by zoom level.
 * @param {import("../../Tile.js").default} tile A tile.
 * @param {number} z The zoom level.
 * @return {boolean} The tile was removed from the lookup.
 */ function $f30d475df7f7c73d$var$removeTileFromLookup(tilesByZ, tile, z) {
    const set = tilesByZ[z];
    if (set) return set.delete(tile);
    return false;
}
/**
 * @param {import("../../Map.js").FrameState} frameState Frame state.
 * @param {import("../../extent.js").Extent} extent The frame extent.
 * @return {import("../../extent.js").Extent} Frame extent intersected with layer extents.
 */ function $f30d475df7f7c73d$var$getRenderExtent(frameState, extent) {
    const layerState = frameState.layerStatesArray[frameState.layerIndex];
    if (layerState.extent) extent = (0, $dea65c2f666fa450$export$72209efa88586d42)(extent, (0, $a86eee1c28205a05$export$494be3a3a25689ca)(layerState.extent, frameState.viewState.projection));
    const source = /** @type {import("../../source/Tile.js").default} */ layerState.layer.getRenderSource();
    if (!source.getWrapX()) {
        const gridExtent = source.getTileGridForProjection(frameState.viewState.projection).getExtent();
        if (gridExtent) extent = (0, $dea65c2f666fa450$export$72209efa88586d42)(extent, gridExtent);
    }
    return extent;
}
/**
 * @typedef {Object} Options
 * @property {number} [cacheSize=512] The cache size.
 */ /**
 * @classdesc
 * Canvas renderer for tile layers.
 * @api
 * @template {import("../../layer/Tile.js").default|import("../../layer/VectorTile.js").default} [LayerType=import("../../layer/Tile.js").default<import("../../source/Tile.js").default>|import("../../layer/VectorTile.js").default]
 * @extends {CanvasLayerRenderer<LayerType>}
 */ class $f30d475df7f7c73d$var$CanvasTileLayerRenderer extends (0, $334f608456f9cc13$export$2e2bcd8739ae039) {
    /**
   * @param {LayerType} tileLayer Tile layer.
   * @param {Options} [options] Options.
   */ constructor(tileLayer, options){
        super(tileLayer);
        options = options || {};
        /**
     * Rendered extent has changed since the previous `renderFrame()` call
     * @type {boolean}
     */ this.extentChanged = true;
        /**
     * The last call to `renderFrame` was completed with all tiles loaded
     * @type {boolean}
     */ this.renderComplete = false;
        /**
     * @private
     * @type {?import("../../extent.js").Extent}
     */ this.renderedExtent_ = null;
        /**
     * @protected
     * @type {number}
     */ this.renderedPixelRatio;
        /**
     * @protected
     * @type {import("../../proj/Projection.js").default|null}
     */ this.renderedProjection = null;
        /**
     * @protected
     * @type {!Array<import("../../Tile.js").default>}
     */ this.renderedTiles = [];
        /**
     * @private
     * @type {string}
     */ this.renderedSourceKey_;
        /**
     * @private
     * @type {number}
     */ this.renderedSourceRevision_;
        /**
     * @protected
     * @type {import("../../extent.js").Extent}
     */ this.tempExtent = (0, $dea65c2f666fa450$export$fe201bb3bbe031e9)();
        /**
     * @private
     * @type {import("../../TileRange.js").default}
     */ this.tempTileRange_ = new (0, $9d539d0e6964f568$export$2e2bcd8739ae039)(0, 0, 0, 0);
        /**
     * @type {import("../../tilecoord.js").TileCoord}
     * @private
     */ this.tempTileCoord_ = (0, $8b203a265587842e$export$958e3e1a02eac4b6)(0, 0, 0);
        const cacheSize = options.cacheSize !== undefined ? options.cacheSize : 512;
        /**
     * @type {import("../../structs/LRUCache.js").default<import("../../Tile.js").default>}
     * @private
     */ this.tileCache_ = new (0, $3ca2ce2767adc523$export$2e2bcd8739ae039)(cacheSize);
        /**
     * @type {import("../../structs/LRUCache.js").default<import("../../Tile.js").default|null>}
     * @private
     */ this.sourceTileCache_ = null;
        this.maxStaleKeys = cacheSize * 0.5;
    }
    /**
   * @return {LRUCache} Tile cache.
   */ getTileCache() {
        return this.tileCache_;
    }
    /**
   * @return {LRUCache} Tile cache.
   */ getSourceTileCache() {
        if (!this.sourceTileCache_) this.sourceTileCache_ = new (0, $3ca2ce2767adc523$export$2e2bcd8739ae039)(512);
        return this.sourceTileCache_;
    }
    /**
   * Get a tile from the cache or create one if needed.
   *
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @return {import("../../Tile.js").default|null} Tile (or null if outside source extent).
   * @protected
   */ getOrCreateTile(z, x, y, frameState) {
        const tileCache = this.tileCache_;
        const tileLayer = this.getLayer();
        const tileSource = tileLayer.getSource();
        const cacheKey = (0, $8b203a265587842e$export$611736262b635f8d)(tileSource, tileSource.getKey(), z, x, y);
        /** @type {import("../../Tile.js").default} */ let tile;
        if (tileCache.containsKey(cacheKey)) tile = tileCache.get(cacheKey);
        else {
            const projection = frameState.viewState.projection;
            const sourceProjection = tileSource.getProjection();
            tile = tileSource.getTile(z, x, y, frameState.pixelRatio, projection, !sourceProjection || (0, $a86eee1c28205a05$export$fe091d73a555748b)(sourceProjection, projection) ? undefined : this.getSourceTileCache());
            if (!tile) return null;
            tileCache.set(cacheKey, tile);
        }
        return tile;
    }
    /**
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @return {import("../../Tile.js").default|null} Tile (or null if outside source extent).
   * @protected
   */ getTile(z, x, y, frameState) {
        const tile = this.getOrCreateTile(z, x, y, frameState);
        if (!tile) return null;
        return tile;
    }
    /**
   * @param {import("../../pixel.js").Pixel} pixel Pixel.
   * @return {Uint8ClampedArray} Data at the pixel location.
   * @override
   */ getData(pixel) {
        const frameState = this.frameState;
        if (!frameState) return null;
        const layer = this.getLayer();
        const coordinate = (0, $dff5a03e015694d8$export$5635d7ef4b8fee1c)(frameState.pixelToCoordinateTransform, pixel.slice());
        const layerExtent = layer.getExtent();
        if (layerExtent) {
            if (!(0, $dea65c2f666fa450$export$ac68c24d37ca240f)(layerExtent, coordinate)) return null;
        }
        const viewState = frameState.viewState;
        const source = layer.getRenderSource();
        const tileGrid = source.getTileGridForProjection(viewState.projection);
        const tilePixelRatio = source.getTilePixelRatio(frameState.pixelRatio);
        for(let z = tileGrid.getZForResolution(viewState.resolution); z >= tileGrid.getMinZoom(); --z){
            const tileCoord = tileGrid.getTileCoordForCoordAndZ(coordinate, z);
            const tile = this.getTile(z, tileCoord[1], tileCoord[2], frameState);
            if (!tile || tile.getState() !== (0, $79d423c0f6adbcbb$export$2e2bcd8739ae039).LOADED) continue;
            const tileOrigin = tileGrid.getOrigin(z);
            const tileSize = (0, $625e418aeada4c0d$export$a71a825ff42fb8e1)(tileGrid.getTileSize(z));
            const tileResolution = tileGrid.getResolution(z);
            /**
       * @type {import('../../DataTile.js').ImageLike}
       */ let image;
            if (tile instanceof (0, $af328a9781fa918b$export$2e2bcd8739ae039) || tile instanceof (0, $a9e17fc88997910c$export$2e2bcd8739ae039)) image = tile.getImage();
            else if (tile instanceof (0, $98966536a4c579a6$export$2e2bcd8739ae039)) {
                image = (0, $98966536a4c579a6$export$3a7c913cb40dcb7d)(tile.getData());
                if (!image) continue;
            } else continue;
            const col = Math.floor(tilePixelRatio * ((coordinate[0] - tileOrigin[0]) / tileResolution - tileCoord[1] * tileSize[0]));
            const row = Math.floor(tilePixelRatio * ((tileOrigin[1] - coordinate[1]) / tileResolution - tileCoord[2] * tileSize[1]));
            const gutter = Math.round(tilePixelRatio * source.getGutterForProjection(viewState.projection));
            return this.getImageData(image, col + gutter, row + gutter);
        }
        return null;
    }
    /**
   * Determine whether render should be called.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @return {boolean} Layer is ready to be rendered.
   * @override
   */ prepareFrame(frameState) {
        if (!this.renderedProjection) this.renderedProjection = frameState.viewState.projection;
        else if (frameState.viewState.projection !== this.renderedProjection) {
            this.tileCache_.clear();
            this.renderedProjection = frameState.viewState.projection;
        }
        const source = this.getLayer().getSource();
        if (!source) return false;
        const sourceRevision = source.getRevision();
        if (!this.renderedSourceRevision_) this.renderedSourceRevision_ = sourceRevision;
        else if (this.renderedSourceRevision_ !== sourceRevision) {
            this.renderedSourceRevision_ = sourceRevision;
            if (this.renderedSourceKey_ === source.getKey()) {
                this.tileCache_.clear();
                this.sourceTileCache_?.clear();
            }
        }
        return true;
    }
    /**
   * Determine whether tiles for next extent should be enqueued for rendering.
   * @return {boolean} Rendering tiles for next extent is supported.
   * @protected
   */ enqueueTilesForNextExtent() {
        return true;
    }
    /**
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {import("../../extent.js").Extent} extent The extent to be rendered.
   * @param {number} initialZ The zoom level.
   * @param {TileLookup} tilesByZ Lookup of tiles by zoom level.
   * @param {number} preload Number of additional levels to load.
   */ enqueueTiles(frameState, extent, initialZ, tilesByZ, preload) {
        const viewState = frameState.viewState;
        const tileLayer = this.getLayer();
        const tileSource = tileLayer.getRenderSource();
        const tileGrid = tileSource.getTileGridForProjection(viewState.projection);
        const tileSourceKey = (0, $fd76d391cc228565$export$5e82334337e0f204)(tileSource);
        if (!(tileSourceKey in frameState.wantedTiles)) frameState.wantedTiles[tileSourceKey] = {};
        const wantedTiles = frameState.wantedTiles[tileSourceKey];
        const map = tileLayer.getMapInternal();
        const minZ = Math.max(initialZ - preload, tileGrid.getMinZoom(), tileGrid.getZForResolution(Math.min(tileLayer.getMaxResolution(), map ? map.getView().getResolutionForZoom(Math.max(tileLayer.getMinZoom(), 0)) : tileGrid.getResolution(0)), tileSource.zDirection));
        const rotation = viewState.rotation;
        const viewport = rotation ? (0, $dea65c2f666fa450$export$4b7a6fb4002cd6ac)(viewState.center, viewState.resolution, rotation, frameState.size) : undefined;
        for(let z = initialZ; z >= minZ; --z){
            const tileRange = tileGrid.getTileRangeForExtentAndZ(extent, z, this.tempTileRange_);
            const tileResolution = tileGrid.getResolution(z);
            for(let x = tileRange.minX; x <= tileRange.maxX; ++x)for(let y = tileRange.minY; y <= tileRange.maxY; ++y){
                if (rotation && !tileGrid.tileCoordIntersectsViewport([
                    z,
                    x,
                    y
                ], viewport)) continue;
                const tile = this.getTile(z, x, y, frameState);
                if (!tile) continue;
                const added = $f30d475df7f7c73d$var$addTileToLookup(tilesByZ, tile, z);
                if (!added) continue;
                const tileQueueKey = tile.getKey();
                wantedTiles[tileQueueKey] = true;
                if (tile.getState() === (0, $79d423c0f6adbcbb$export$2e2bcd8739ae039).IDLE) {
                    if (!frameState.tileQueue.isKeyQueued(tileQueueKey)) {
                        const tileCoord = (0, $8b203a265587842e$export$958e3e1a02eac4b6)(z, x, y, this.tempTileCoord_);
                        frameState.tileQueue.enqueue([
                            tile,
                            tileSourceKey,
                            tileGrid.getTileCoordCenter(tileCoord),
                            tileResolution
                        ]);
                    }
                }
            }
        }
    }
    /**
   * Look for tiles covering the provided tile coordinate at an alternate
   * zoom level.  Loaded tiles will be added to the provided tile texture lookup.
   * @param {import("../../tilecoord.js").TileCoord} tileCoord The target tile coordinate.
   * @param {TileLookup} tilesByZ Lookup of tiles by zoom level.
   * @return {boolean} The tile coordinate is covered by loaded tiles at the alternate zoom level.
   * @private
   */ findStaleTile_(tileCoord, tilesByZ) {
        const tileCache = this.tileCache_;
        const z = tileCoord[0];
        const x = tileCoord[1];
        const y = tileCoord[2];
        const staleKeys = this.getStaleKeys();
        for(let i = 0; i < staleKeys.length; ++i){
            const cacheKey = (0, $8b203a265587842e$export$611736262b635f8d)(this.getLayer().getSource(), staleKeys[i], z, x, y);
            if (tileCache.containsKey(cacheKey)) {
                const tile = tileCache.peek(cacheKey);
                if (tile.getState() === (0, $79d423c0f6adbcbb$export$2e2bcd8739ae039).LOADED) {
                    tile.endTransition((0, $fd76d391cc228565$export$5e82334337e0f204)(this));
                    $f30d475df7f7c73d$var$addTileToLookup(tilesByZ, tile, z);
                    return true;
                }
            }
        }
        return false;
    }
    /**
   * Look for tiles covering the provided tile coordinate at an alternate
   * zoom level.  Loaded tiles will be added to the provided tile texture lookup.
   * @param {import("../../tilegrid/TileGrid.js").default} tileGrid The tile grid.
   * @param {import("../../tilecoord.js").TileCoord} tileCoord The target tile coordinate.
   * @param {number} altZ The alternate zoom level.
   * @param {TileLookup} tilesByZ Lookup of tiles by zoom level.
   * @return {boolean} The tile coordinate is covered by loaded tiles at the alternate zoom level.
   * @private
   */ findAltTiles_(tileGrid, tileCoord, altZ, tilesByZ) {
        const tileRange = tileGrid.getTileRangeForTileCoordAndZ(tileCoord, altZ, this.tempTileRange_);
        if (!tileRange) return false;
        let covered = true;
        const tileCache = this.tileCache_;
        const source = this.getLayer().getRenderSource();
        const sourceKey = source.getKey();
        for(let x = tileRange.minX; x <= tileRange.maxX; ++x)for(let y = tileRange.minY; y <= tileRange.maxY; ++y){
            const cacheKey = (0, $8b203a265587842e$export$611736262b635f8d)(source, sourceKey, altZ, x, y);
            let loaded = false;
            if (tileCache.containsKey(cacheKey)) {
                const tile = tileCache.peek(cacheKey);
                if (tile.getState() === (0, $79d423c0f6adbcbb$export$2e2bcd8739ae039).LOADED) {
                    $f30d475df7f7c73d$var$addTileToLookup(tilesByZ, tile, altZ);
                    loaded = true;
                }
            }
            if (!loaded) covered = false;
        }
        return covered;
    }
    /**
   * Render the layer.
   *
   * The frame rendering logic has three parts:
   *
   *  1. Enqueue tiles
   *  2. Find alt tiles for those that are not yet loaded
   *  3. Render loaded tiles
   *
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {HTMLElement} target Target that may be used to render content to.
   * @return {HTMLElement} The rendered element.
   * @override
   */ renderFrame(frameState, target) {
        this.renderComplete = true;
        /**
     * TODO:
     *  maybe skip transition when not fully opaque
     *  decide if this.renderComplete is useful
     */ const layerState = frameState.layerStatesArray[frameState.layerIndex];
        const viewState = frameState.viewState;
        const projection = viewState.projection;
        const viewResolution = viewState.resolution;
        const viewCenter = viewState.center;
        const pixelRatio = frameState.pixelRatio;
        const tileLayer = this.getLayer();
        const tileSource = tileLayer.getSource();
        const tileGrid = tileSource.getTileGridForProjection(projection);
        const z = tileGrid.getZForResolution(viewResolution, tileSource.zDirection);
        const tileResolution = tileGrid.getResolution(z);
        const sourceKey = tileSource.getKey();
        if (!this.renderedSourceKey_) this.renderedSourceKey_ = sourceKey;
        else if (this.renderedSourceKey_ !== sourceKey) {
            this.prependStaleKey(this.renderedSourceKey_);
            this.renderedSourceKey_ = sourceKey;
        }
        let frameExtent = frameState.extent;
        const tilePixelRatio = tileSource.getTilePixelRatio(pixelRatio);
        this.prepareContainer(frameState, target);
        // desired dimensions of the canvas in pixels
        const width = this.context.canvas.width;
        const height = this.context.canvas.height;
        const layerExtent = layerState.extent && (0, $a86eee1c28205a05$export$494be3a3a25689ca)(layerState.extent, projection);
        if (layerExtent) frameExtent = (0, $dea65c2f666fa450$export$72209efa88586d42)(frameExtent, (0, $a86eee1c28205a05$export$494be3a3a25689ca)(layerState.extent, projection));
        const dx = tileResolution * width / 2 / tilePixelRatio;
        const dy = tileResolution * height / 2 / tilePixelRatio;
        const canvasExtent = [
            viewCenter[0] - dx,
            viewCenter[1] - dy,
            viewCenter[0] + dx,
            viewCenter[1] + dy
        ];
        /**
     * @type {TileLookup}
     */ const tilesByZ = {};
        this.renderedTiles.length = 0;
        /**
     * Part 1: Enqueue tiles
     */ const preload = tileLayer.getPreload();
        if (frameState.nextExtent && this.enqueueTilesForNextExtent()) {
            const targetZ = tileGrid.getZForResolution(viewState.nextResolution, tileSource.zDirection);
            const nextExtent = $f30d475df7f7c73d$var$getRenderExtent(frameState, frameState.nextExtent);
            this.enqueueTiles(frameState, nextExtent, targetZ, tilesByZ, preload);
        }
        const renderExtent = $f30d475df7f7c73d$var$getRenderExtent(frameState, frameExtent);
        this.enqueueTiles(frameState, renderExtent, z, tilesByZ, 0);
        if (preload > 0) setTimeout(()=>{
            this.enqueueTiles(frameState, renderExtent, z - 1, tilesByZ, preload - 1);
        }, 0);
        if (!(z in tilesByZ)) return this.container;
        /**
     * Part 2: Find alt tiles for those that are not yet loaded
     */ const uid = (0, $fd76d391cc228565$export$5e82334337e0f204)(this);
        const time = frameState.time;
        // look for cached tiles to use if a target tile is not ready
        for (const tile of tilesByZ[z]){
            const tileState = tile.getState();
            if (tileState === (0, $79d423c0f6adbcbb$export$2e2bcd8739ae039).EMPTY) continue;
            const tileCoord = tile.tileCoord;
            if (tileState === (0, $79d423c0f6adbcbb$export$2e2bcd8739ae039).LOADED) {
                const alpha = tile.getAlpha(uid, time);
                if (alpha === 1) {
                    // no need to look for alt tiles
                    tile.endTransition(uid);
                    continue;
                }
            }
            if (tileState !== (0, $79d423c0f6adbcbb$export$2e2bcd8739ae039).ERROR) this.renderComplete = false;
            const hasStaleTile = this.findStaleTile_(tileCoord, tilesByZ);
            if (hasStaleTile) {
                // use the stale tile before the new tile's transition has completed
                $f30d475df7f7c73d$var$removeTileFromLookup(tilesByZ, tile, z);
                frameState.animate = true;
                continue;
            }
            // first look for child tiles (at z + 1)
            const coveredByChildren = this.findAltTiles_(tileGrid, tileCoord, z + 1, tilesByZ);
            if (coveredByChildren) continue;
            // next look for parent tiles
            const minZoom = tileGrid.getMinZoom();
            for(let parentZ = z - 1; parentZ >= minZoom; --parentZ){
                const coveredByParent = this.findAltTiles_(tileGrid, tileCoord, parentZ, tilesByZ);
                if (coveredByParent) break;
            }
        }
        /**
     * Part 3: Render loaded tiles
     */ const canvasScale = tileResolution / viewResolution * pixelRatio / tilePixelRatio;
        const context = this.getRenderContext(frameState);
        // set scale transform for calculating tile positions on the canvas
        (0, $dff5a03e015694d8$export$f672e0b6f7222cd7)(this.tempTransform, width / 2, height / 2, canvasScale, canvasScale, 0, -width / 2, -height / 2);
        if (layerState.extent) this.clipUnrotated(context, frameState, layerExtent);
        if (!tileSource.getInterpolate()) context.imageSmoothingEnabled = false;
        this.preRender(context, frameState);
        /** @type {Array<number>} */ const zs = Object.keys(tilesByZ).map(Number);
        zs.sort((0, $49313fcb0fc32abe$export$fcb633242ef15540));
        let currentClip;
        const clips = [];
        const clipZs = [];
        for(let i = zs.length - 1; i >= 0; --i){
            const currentZ = zs[i];
            const currentTilePixelSize = tileSource.getTilePixelSize(currentZ, pixelRatio, projection);
            const currentResolution = tileGrid.getResolution(currentZ);
            const currentScale = currentResolution / tileResolution;
            const dx = currentTilePixelSize[0] * currentScale * canvasScale;
            const dy = currentTilePixelSize[1] * currentScale * canvasScale;
            const originTileCoord = tileGrid.getTileCoordForCoordAndZ((0, $dea65c2f666fa450$export$cb1538b07e6964ff)(canvasExtent), currentZ);
            const originTileExtent = tileGrid.getTileCoordExtent(originTileCoord);
            const origin = (0, $dff5a03e015694d8$export$5635d7ef4b8fee1c)(this.tempTransform, [
                tilePixelRatio * (originTileExtent[0] - canvasExtent[0]) / tileResolution,
                tilePixelRatio * (canvasExtent[3] - originTileExtent[3]) / tileResolution
            ]);
            const tileGutter = tilePixelRatio * tileSource.getGutterForProjection(projection);
            for (const tile of tilesByZ[currentZ]){
                if (tile.getState() !== (0, $79d423c0f6adbcbb$export$2e2bcd8739ae039).LOADED) continue;
                const tileCoord = tile.tileCoord;
                // Calculate integer positions and sizes so that tiles align
                const xIndex = originTileCoord[1] - tileCoord[1];
                const nextX = Math.round(origin[0] - (xIndex - 1) * dx);
                const yIndex = originTileCoord[2] - tileCoord[2];
                const nextY = Math.round(origin[1] - (yIndex - 1) * dy);
                const x = Math.round(origin[0] - xIndex * dx);
                const y = Math.round(origin[1] - yIndex * dy);
                const w = nextX - x;
                const h = nextY - y;
                const transition = zs.length === 1;
                let contextSaved = false;
                // Clip mask for regions in this tile that already filled by a higher z tile
                currentClip = [
                    x,
                    y,
                    x + w,
                    y,
                    x + w,
                    y + h,
                    x,
                    y + h
                ];
                for(let i = 0, ii = clips.length; i < ii; ++i)if (!transition && currentZ < clipZs[i]) {
                    const clip = clips[i];
                    if ((0, $dea65c2f666fa450$export$7b0a31e10bbff018)([
                        x,
                        y,
                        x + w,
                        y + h
                    ], [
                        clip[0],
                        clip[3],
                        clip[4],
                        clip[7]
                    ])) {
                        if (!contextSaved) {
                            context.save();
                            contextSaved = true;
                        }
                        context.beginPath();
                        // counter-clockwise (outer ring) for current tile
                        context.moveTo(currentClip[0], currentClip[1]);
                        context.lineTo(currentClip[2], currentClip[3]);
                        context.lineTo(currentClip[4], currentClip[5]);
                        context.lineTo(currentClip[6], currentClip[7]);
                        // clockwise (inner ring) for higher z tile
                        context.moveTo(clip[6], clip[7]);
                        context.lineTo(clip[4], clip[5]);
                        context.lineTo(clip[2], clip[3]);
                        context.lineTo(clip[0], clip[1]);
                        context.clip();
                    }
                }
                clips.push(currentClip);
                clipZs.push(currentZ);
                this.drawTile(tile, frameState, x, y, w, h, tileGutter, transition);
                if (contextSaved) context.restore();
                this.renderedTiles.unshift(tile);
                // TODO: decide if this is necessary
                this.updateUsedTiles(frameState.usedTiles, tileSource, tile);
            }
        }
        this.renderedResolution = tileResolution;
        this.extentChanged = !this.renderedExtent_ || !(0, $dea65c2f666fa450$export$e9bab7fafb253603)(this.renderedExtent_, canvasExtent);
        this.renderedExtent_ = canvasExtent;
        this.renderedPixelRatio = pixelRatio;
        this.postRender(this.context, frameState);
        if (layerState.extent) context.restore();
        context.imageSmoothingEnabled = true;
        if (this.renderComplete) {
            /**
       * @param {import("../../Map.js").default} map Map.
       * @param {import("../../Map.js").FrameState} frameState Frame state.
       */ const postRenderFunction = (map, frameState)=>{
                const tileSourceKey = (0, $fd76d391cc228565$export$5e82334337e0f204)(tileSource);
                const wantedTiles = frameState.wantedTiles[tileSourceKey];
                const tilesCount = wantedTiles ? Object.keys(wantedTiles).length : 0;
                this.updateCacheSize(tilesCount);
                this.tileCache_.expireCache();
                this.sourceTileCache_?.expireCache();
            };
            frameState.postRenderFunctions.push(postRenderFunction);
        }
        // this normally is `div.ol-layer` and is a mocked div in worker
        return this.container;
    }
    /**
   * Increases the cache size if needed
   * @param {number} tileCount Minimum number of tiles needed.
   */ updateCacheSize(tileCount) {
        this.tileCache_.highWaterMark = Math.max(this.tileCache_.highWaterMark, tileCount * 2);
    }
    /**
   * @param {import("../../Tile.js").default} tile Tile.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {number} x Left of the tile.
   * @param {number} y Top of the tile.
   * @param {number} w Width of the tile.
   * @param {number} h Height of the tile.
   * @param {number} gutter Tile gutter.
   * @param {boolean} transition Apply an alpha transition.
   * @protected
   */ drawTile(tile, frameState, x, y, w, h, gutter, transition) {
        let image;
        if (tile instanceof (0, $98966536a4c579a6$export$2e2bcd8739ae039)) {
            image = (0, $98966536a4c579a6$export$3a7c913cb40dcb7d)(tile.getData());
            if (!image) throw new Error('Rendering array data is not yet supported');
        } else image = this.getTileImage(/** @type {import("../../ImageTile.js").default} */ tile);
        if (!image) return;
        const context = this.getRenderContext(frameState);
        const uid = (0, $fd76d391cc228565$export$5e82334337e0f204)(this);
        const layerState = frameState.layerStatesArray[frameState.layerIndex];
        const alpha = layerState.opacity * (transition ? tile.getAlpha(uid, frameState.time) : 1);
        const alphaChanged = alpha !== context.globalAlpha;
        if (alphaChanged) {
            context.save();
            context.globalAlpha = alpha;
        }
        context.drawImage(image, gutter, gutter, image.width - 2 * gutter, image.height - 2 * gutter, x, y, w, h);
        if (alphaChanged) context.restore();
        if (alpha !== layerState.opacity) frameState.animate = true;
        else if (transition) tile.endTransition(uid);
    }
    /**
   * @return {HTMLCanvasElement|OffscreenCanvas} Image
   */ getImage() {
        const context = this.context;
        return context ? context.canvas : null;
    }
    /**
   * Get the image from a tile.
   * @param {import("../../ImageTile.js").default} tile Tile.
   * @return {HTMLCanvasElement|OffscreenCanvas|HTMLImageElement|HTMLVideoElement} Image.
   * @protected
   */ getTileImage(tile) {
        return tile.getImage();
    }
    /**
   * @param {!Object<string, !Object<string, boolean>>} usedTiles Used tiles.
   * @param {import("../../source/Tile.js").default} tileSource Tile source.
   * @param {import('../../Tile.js').default} tile Tile.
   * @protected
   */ updateUsedTiles(usedTiles, tileSource, tile) {
        // FIXME should we use tilesToDrawByZ instead?
        const tileSourceKey = (0, $fd76d391cc228565$export$5e82334337e0f204)(tileSource);
        if (!(tileSourceKey in usedTiles)) usedTiles[tileSourceKey] = {};
        usedTiles[tileSourceKey][tile.getKey()] = true;
    }
}
var $f30d475df7f7c73d$export$2e2bcd8739ae039 = $f30d475df7f7c73d$var$CanvasTileLayerRenderer;


/**
 * @module ol/layer/BaseTile
 */ /**
 * @module ol/layer/Layer
 */ /**
 * @module ol/View
 */ 
/**
 * @module ol/ViewHint
 */ /**
 * @enum {number}
 */ var $e4565fb1c11da106$export$2e2bcd8739ae039 = {
    ANIMATING: 0,
    INTERACTING: 1
};


/**
 * @module ol/ViewProperty
 */ /**
 * @enum {string}
 */ var $1ae515d0c6239191$export$2e2bcd8739ae039 = {
    CENTER: 'center',
    RESOLUTION: 'resolution',
    ROTATION: 'rotation'
};




/**
 * @module ol/centerconstraint
 */ 
function $41d247de0d2bb35a$export$c2f0af2c946f6897(extent, onlyCenter, smooth) {
    return(/**
     * @param {import("./coordinate.js").Coordinate|undefined} center Center.
     * @param {number|undefined} resolution Resolution.
     * @param {import("./size.js").Size} size Viewport size; unused if `onlyCenter` was specified.
     * @param {boolean} [isMoving] True if an interaction or animation is in progress.
     * @param {Array<number>} [centerShift] Shift between map center and viewport center.
     * @return {import("./coordinate.js").Coordinate|undefined} Center.
     */ function(center, resolution, size, isMoving, centerShift) {
        if (!center) return undefined;
        if (!resolution && !onlyCenter) return center;
        const viewWidth = onlyCenter ? 0 : size[0] * resolution;
        const viewHeight = onlyCenter ? 0 : size[1] * resolution;
        const shiftX = centerShift ? centerShift[0] : 0;
        const shiftY = centerShift ? centerShift[1] : 0;
        let minX = extent[0] + viewWidth / 2 + shiftX;
        let maxX = extent[2] - viewWidth / 2 + shiftX;
        let minY = extent[1] + viewHeight / 2 + shiftY;
        let maxY = extent[3] - viewHeight / 2 + shiftY;
        // note: when zooming out of bounds, min and max values for x and y may
        // end up inverted (min > max); this has to be accounted for
        if (minX > maxX) {
            minX = (maxX + minX) / 2;
            maxX = minX;
        }
        if (minY > maxY) {
            minY = (maxY + minY) / 2;
            maxY = minY;
        }
        let x = (0, $6a95bd76d7103f37$export$7d15b64cf5a3a4c4)(center[0], minX, maxX);
        let y = (0, $6a95bd76d7103f37$export$7d15b64cf5a3a4c4)(center[1], minY, maxY);
        // during an interaction, allow some overscroll
        if (isMoving && smooth && resolution) {
            const ratio = 30 * resolution;
            x += -ratio * Math.log(1 + Math.max(0, minX - center[0]) / ratio) + ratio * Math.log(1 + Math.max(0, center[0] - maxX) / ratio);
            y += -ratio * Math.log(1 + Math.max(0, minY - center[1]) / ratio) + ratio * Math.log(1 + Math.max(0, center[1] - maxY) / ratio);
        }
        return [
            x,
            y
        ];
    });
}
function $41d247de0d2bb35a$export$f883a24d5edde77c(center) {
    return center;
}









/**
 * @module ol/resolutionconstraint
 */ 


/**
 * @typedef {function((number|undefined), number, import("./size.js").Size, boolean=): (number|undefined)} Type
 */ /**
 * Returns a modified resolution taking into account the viewport size and maximum
 * allowed extent.
 * @param {number} resolution Resolution
 * @param {import("./extent.js").Extent} maxExtent Maximum allowed extent.
 * @param {import("./size.js").Size} viewportSize Viewport size.
 * @param {boolean} showFullExtent Whether to show the full extent.
 * @return {number} Capped resolution.
 */ function $3a0ff1177a518ee8$var$getViewportClampedResolution(resolution, maxExtent, viewportSize, showFullExtent) {
    const xResolution = (0, $dea65c2f666fa450$export$3c49c185de0c2bfc)(maxExtent) / viewportSize[0];
    const yResolution = (0, $dea65c2f666fa450$export$c08559766941f856)(maxExtent) / viewportSize[1];
    if (showFullExtent) return Math.min(resolution, Math.max(xResolution, yResolution));
    return Math.min(resolution, Math.min(xResolution, yResolution));
}
/**
 * Returns a modified resolution to be between maxResolution and minResolution while
 * still allowing the value to be slightly out of bounds.
 * Note: the computation is based on the logarithm function (ln):
 *  - at 1, ln(x) is 0
 *  - above 1, ln(x) keeps increasing but at a much slower pace than x
 * The final result is clamped to prevent getting too far away from bounds.
 * @param {number} resolution Resolution.
 * @param {number} maxResolution Max resolution.
 * @param {number} minResolution Min resolution.
 * @return {number} Smoothed resolution.
 */ function $3a0ff1177a518ee8$var$getSmoothClampedResolution(resolution, maxResolution, minResolution) {
    let result = Math.min(resolution, maxResolution);
    const ratio = 50;
    result *= Math.log(1 + ratio * Math.max(0, resolution / maxResolution - 1)) / ratio + 1;
    if (minResolution) {
        result = Math.max(result, minResolution);
        result /= Math.log(1 + ratio * Math.max(0, minResolution / resolution - 1)) / ratio + 1;
    }
    return (0, $6a95bd76d7103f37$export$7d15b64cf5a3a4c4)(result, minResolution / 2, maxResolution * 2);
}
function $3a0ff1177a518ee8$export$d65a517690fc4385(resolutions, smooth, maxExtent, showFullExtent) {
    smooth = smooth !== undefined ? smooth : true;
    return(/**
     * @param {number|undefined} resolution Resolution.
     * @param {number} direction Direction.
     * @param {import("./size.js").Size} size Viewport size.
     * @param {boolean} [isMoving] True if an interaction or animation is in progress.
     * @return {number|undefined} Resolution.
     */ function(resolution, direction, size, isMoving) {
        if (resolution !== undefined) {
            const maxResolution = resolutions[0];
            const minResolution = resolutions[resolutions.length - 1];
            const cappedMaxRes = maxExtent ? $3a0ff1177a518ee8$var$getViewportClampedResolution(maxResolution, maxExtent, size, showFullExtent) : maxResolution;
            // during interacting or animating, allow intermediary values
            if (isMoving) {
                if (!smooth) return (0, $6a95bd76d7103f37$export$7d15b64cf5a3a4c4)(resolution, minResolution, cappedMaxRes);
                return $3a0ff1177a518ee8$var$getSmoothClampedResolution(resolution, cappedMaxRes, minResolution);
            }
            const capped = Math.min(cappedMaxRes, resolution);
            const z = Math.floor((0, $49313fcb0fc32abe$export$8a3786cc03fdb777)(resolutions, capped, direction));
            if (resolutions[z] > cappedMaxRes && z < resolutions.length - 1) return resolutions[z + 1];
            return resolutions[z];
        }
        return undefined;
    });
}
function $3a0ff1177a518ee8$export$22ac0f6b219de91a(power, maxResolution, minResolution, smooth, maxExtent, showFullExtent) {
    smooth = smooth !== undefined ? smooth : true;
    minResolution = minResolution !== undefined ? minResolution : 0;
    return(/**
     * @param {number|undefined} resolution Resolution.
     * @param {number} direction Direction.
     * @param {import("./size.js").Size} size Viewport size.
     * @param {boolean} [isMoving] True if an interaction or animation is in progress.
     * @return {number|undefined} Resolution.
     */ function(resolution, direction, size, isMoving) {
        if (resolution !== undefined) {
            const cappedMaxRes = maxExtent ? $3a0ff1177a518ee8$var$getViewportClampedResolution(maxResolution, maxExtent, size, showFullExtent) : maxResolution;
            // during interacting or animating, allow intermediary values
            if (isMoving) {
                if (!smooth) return (0, $6a95bd76d7103f37$export$7d15b64cf5a3a4c4)(resolution, minResolution, cappedMaxRes);
                return $3a0ff1177a518ee8$var$getSmoothClampedResolution(resolution, cappedMaxRes, minResolution);
            }
            const tolerance = 1e-9;
            const minZoomLevel = Math.ceil(Math.log(maxResolution / cappedMaxRes) / Math.log(power) - tolerance);
            const offset = -direction * (0.5 - tolerance) + 0.5;
            const capped = Math.min(cappedMaxRes, resolution);
            const cappedZoomLevel = Math.floor(Math.log(maxResolution / capped) / Math.log(power) + offset);
            const zoomLevel = Math.max(minZoomLevel, cappedZoomLevel);
            const newResolution = maxResolution / Math.pow(power, zoomLevel);
            return (0, $6a95bd76d7103f37$export$7d15b64cf5a3a4c4)(newResolution, minResolution, cappedMaxRes);
        }
        return undefined;
    });
}
function $3a0ff1177a518ee8$export$1c4e6da9b4b066fe(maxResolution, minResolution, smooth, maxExtent, showFullExtent) {
    smooth = smooth !== undefined ? smooth : true;
    return(/**
     * @param {number|undefined} resolution Resolution.
     * @param {number} direction Direction.
     * @param {import("./size.js").Size} size Viewport size.
     * @param {boolean} [isMoving] True if an interaction or animation is in progress.
     * @return {number|undefined} Resolution.
     */ function(resolution, direction, size, isMoving) {
        if (resolution !== undefined) {
            const cappedMaxRes = maxExtent ? $3a0ff1177a518ee8$var$getViewportClampedResolution(maxResolution, maxExtent, size, showFullExtent) : maxResolution;
            if (!smooth || !isMoving) return (0, $6a95bd76d7103f37$export$7d15b64cf5a3a4c4)(resolution, minResolution, cappedMaxRes);
            return $3a0ff1177a518ee8$var$getSmoothClampedResolution(resolution, cappedMaxRes, minResolution);
        }
        return undefined;
    });
}


/**
 * @module ol/rotationconstraint
 */ 
function $a4b2c7f4b045b17d$export$e20fbacbb41798b(rotation) {
    if (rotation !== undefined) return 0;
    return undefined;
}
function $a4b2c7f4b045b17d$export$f883a24d5edde77c(rotation) {
    if (rotation !== undefined) return rotation;
    return undefined;
}
function $a4b2c7f4b045b17d$export$9ba78806de831083(n) {
    const theta = 2 * Math.PI / n;
    return(/**
     * @param {number|undefined} rotation Rotation.
     * @param {boolean} [isMoving] True if an interaction or animation is in progress.
     * @return {number|undefined} Rotation.
     */ function(rotation, isMoving) {
        if (isMoving) return rotation;
        if (rotation !== undefined) {
            rotation = Math.floor(rotation / theta + 0.5) * theta;
            return rotation;
        }
        return undefined;
    });
}
function $a4b2c7f4b045b17d$export$17a6e6f3448b17e8(tolerance) {
    const t = tolerance === undefined ? (0, $6a95bd76d7103f37$export$cba01ba138429a1d)(5) : tolerance;
    return(/**
     * @param {number|undefined} rotation Rotation.
     * @param {boolean} [isMoving] True if an interaction or animation is in progress.
     * @return {number|undefined} Rotation.
     */ function(rotation, isMoving) {
        if (isMoving || rotation === undefined) return rotation;
        if (Math.abs(rotation) <= t) return 0;
        return rotation;
    });
}


/**
 * @module ol/tilegrid/common
 */ /**
 * Default maximum zoom for default tile grids.
 * @type {number}
 */ const $8d38b00f56572d28$export$e98a216cdcc847dc = 42;
const $8d38b00f56572d28$export$6b8cb5cd370bd90c = 256;


/**
 * An animation configuration
 *
 * @typedef {Object} Animation
 * @property {import("./coordinate.js").Coordinate} [sourceCenter] Source center.
 * @property {import("./coordinate.js").Coordinate} [targetCenter] Target center.
 * @property {number} [sourceResolution] Source resolution.
 * @property {number} [targetResolution] Target resolution.
 * @property {number} [sourceRotation] Source rotation.
 * @property {number} [targetRotation] Target rotation.
 * @property {import("./coordinate.js").Coordinate} [anchor] Anchor.
 * @property {number} start Start.
 * @property {number} duration Duration.
 * @property {boolean} complete Complete.
 * @property {function(number):number} easing Easing.
 * @property {function(boolean):void} callback Callback.
 */ /**
 * @typedef {Object} Constraints
 * @property {import("./centerconstraint.js").Type} center Center.
 * @property {import("./resolutionconstraint.js").Type} resolution Resolution.
 * @property {import("./rotationconstraint.js").Type} rotation Rotation.
 */ /**
 * @typedef {Object} FitOptions
 * @property {import("./size.js").Size} [size] The size in pixels of the box to
 * fit the extent into. Defaults to the size of the map the view is associated with.
 * If no map or multiple maps are connected to the view, provide the desired box size
 * (e.g. `map.getSize()`).
 * @property {!Array<number>} [padding=[0, 0, 0, 0]] Padding (in pixels) to be
 * cleared inside the view. Values in the array are top, right, bottom and left
 * padding.
 * @property {boolean} [nearest=false] If the view `constrainResolution` option is `true`,
 * get the nearest extent instead of the closest that actually fits the view.
 * @property {number} [minResolution=0] Minimum resolution that we zoom to.
 * @property {number} [maxZoom] Maximum zoom level that we zoom to. If
 * `minResolution` is given, this property is ignored.
 * @property {number} [duration] The duration of the animation in milliseconds.
 * By default, there is no animation to the target extent.
 * @property {function(number):number} [easing] The easing function used during
 * the animation (defaults to {@link module:ol/easing.inAndOut}).
 * The function will be called for each frame with a number representing a
 * fraction of the animation's duration.  The function should return a number
 * between 0 and 1 representing the progress toward the destination state.
 * @property {function(boolean):void} [callback] Function called when the view is in
 * its final position. The callback will be called with `true` if the animation
 * series completed on its own or `false` if it was cancelled.
 */ /**
 * @typedef {Object} ViewOptions
 * @property {import("./coordinate.js").Coordinate} [center] The initial center for
 * the view. If a user projection is not set, the coordinate system for the center is
 * specified with the `projection` option. Layer sources will not be fetched if this
 * is not set, but the center can be set later with {@link #setCenter}.
 * @property {boolean|number} [constrainRotation=true] Rotation constraint.
 * `false` means no constraint. `true` means no constraint, but snap to zero
 * near zero. A number constrains the rotation to that number of values. For
 * example, `4` will constrain the rotation to 0, 90, 180, and 270 degrees.
 * @property {boolean} [enableRotation=true] Enable rotation.
 * If `false`, a rotation constraint that always sets the rotation to zero is
 * used. The `constrainRotation` option has no effect if `enableRotation` is
 * `false`.
 * @property {import("./extent.js").Extent} [extent] The extent that constrains the
 * view, in other words, nothing outside of this extent can be visible on the map.
 * @property {boolean} [constrainOnlyCenter=false] If true, the extent
 * constraint will only apply to the view center and not the whole extent.
 * @property {boolean} [smoothExtentConstraint=true] If true, the extent
 * constraint will be applied smoothly, i.e. allow the view to go slightly outside
 * of the given `extent`.
 * @property {number} [maxResolution] The maximum resolution used to determine
 * the resolution constraint. It is used together with `minResolution` (or
 * `maxZoom`) and `zoomFactor`. If unspecified it is calculated in such a way
 * that the projection's validity extent fits in a 256x256 px tile. If the
 * projection is Spherical Mercator (the default) then `maxResolution` defaults
 * to `40075016.68557849 / 256 = 156543.03392804097`.
 * @property {number} [minResolution] The minimum resolution used to determine
 * the resolution constraint.  It is used together with `maxResolution` (or
 * `minZoom`) and `zoomFactor`.  If unspecified it is calculated assuming 29
 * zoom levels (with a factor of 2). If the projection is Spherical Mercator
 * (the default) then `minResolution` defaults to
 * `40075016.68557849 / 256 / Math.pow(2, 28) = 0.0005831682455839253`.
 * @property {number} [maxZoom=28] The maximum zoom level used to determine the
 * resolution constraint. It is used together with `minZoom` (or
 * `maxResolution`) and `zoomFactor`.  Note that if `minResolution` is also
 * provided, it is given precedence over `maxZoom`.
 * @property {number} [minZoom=0] The minimum zoom level used to determine the
 * resolution constraint. It is used together with `maxZoom` (or
 * `minResolution`) and `zoomFactor`.  Note that if `maxResolution` is also
 * provided, it is given precedence over `minZoom`.
 * @property {boolean} [multiWorld=false] If `false` the view is constrained so
 * only one world is visible, and you cannot pan off the edge.  If `true` the map
 * may show multiple worlds at low zoom levels.  Only used if the `projection` is
 * global.  Note that if `extent` is also provided it is given precedence.
 * @property {boolean} [constrainResolution=false] If true, the view will always
 * animate to the closest zoom level after an interaction; false means
 * intermediary zoom levels are allowed.
 * @property {boolean} [smoothResolutionConstraint=true] If true, the resolution
 * min/max values will be applied smoothly, i. e. allow the view to exceed slightly
 * the given resolution or zoom bounds.
 * @property {boolean} [showFullExtent=false] Allow the view to be zoomed out to
 * show the full configured extent. By default, when a view is configured with an
 * extent, users will not be able to zoom out so the viewport exceeds the extent in
 * either dimension. This means the full extent may not be visible if the viewport
 * is taller or wider than the aspect ratio of the configured extent. If
 * showFullExtent is true, the user will be able to zoom out so that the viewport
 * exceeds the height or width of the configured extent, but not both, allowing the
 * full extent to be shown.
 * @property {import("./proj.js").ProjectionLike} [projection='EPSG:3857'] The
 * projection. The default is Spherical Mercator.
 * @property {number} [resolution] The initial resolution for the view. The
 * units are `projection` units per pixel (e.g. meters per pixel). An
 * alternative to setting this is to set `zoom`. Layer sources will not be
 * fetched if neither this nor `zoom` are defined, but they can be set later
 * with {@link #setZoom} or {@link #setResolution}.
 * @property {Array<number>} [resolutions] Resolutions that determine the
 * zoom levels if specified. The index in the array corresponds to the zoom level,
 * therefore the resolution values have to be in descending order. It also constrains
 * the resolution by the minimum and maximum value. If set the `maxResolution`,
 * `minResolution`, `minZoom`, `maxZoom`, and `zoomFactor` options are ignored.
 * @property {number} [rotation=0] The initial rotation for the view in radians
 * (positive rotation clockwise, 0 means North).
 * @property {number} [zoom] Only used if `resolution` is not defined. Zoom
 * level used to calculate the initial resolution for the view.
 * @property {number} [zoomFactor=2] The zoom factor used to compute the
 * corresponding resolution.
 * @property {!Array<number>} [padding=[0, 0, 0, 0]] Padding (in css pixels).
 * If the map viewport is partially covered with other content (overlays) along
 * its edges, this setting allows to shift the center of the viewport away from
 * that content. The order of the values is top, right, bottom, left.
 */ /**
 * @typedef {Object} AnimationOptions
 * @property {import("./coordinate.js").Coordinate} [center] The center of the view at the end of
 * the animation.
 * @property {number} [zoom] The zoom level of the view at the end of the
 * animation. This takes precedence over `resolution`.
 * @property {number} [resolution] The resolution of the view at the end
 * of the animation.  If `zoom` is also provided, this option will be ignored.
 * @property {number} [rotation] The rotation of the view at the end of
 * the animation.
 * @property {import("./coordinate.js").Coordinate} [anchor] Optional anchor to remain fixed
 * during a rotation or resolution animation.
 * @property {number} [duration=1000] The duration of the animation in milliseconds.
 * @property {function(number):number} [easing] The easing function used
 * during the animation (defaults to {@link module:ol/easing.inAndOut}).
 * The function will be called for each frame with a number representing a
 * fraction of the animation's duration.  The function should return a number
 * between 0 and 1 representing the progress toward the destination state.
 */ /**
 * @typedef {Object} State
 * @property {import("./coordinate.js").Coordinate} center Center (in view projection coordinates).
 * @property {import("./proj/Projection.js").default} projection Projection.
 * @property {number} resolution Resolution.
 * @property {import("./coordinate.js").Coordinate} [nextCenter] The next center during an animation series.
 * @property {number} [nextResolution] The next resolution during an animation series.
 * @property {number} [nextRotation] The next rotation during an animation series.
 * @property {number} rotation Rotation.
 * @property {number} zoom Zoom.
 */ /**
 * Like {@link import("./Map.js").FrameState}, but just `viewState` and `extent`.
 * @typedef {Object} ViewStateLayerStateExtent
 * @property {State} viewState View state.
 * @property {import("./extent.js").Extent} extent Extent (in user projection coordinates).
 * @property {Array<import("./layer/Layer.js").State>} [layerStatesArray] Layer states.
 */ /**
 * Default min zoom level for the map view.
 * @type {number}
 */ const $22c5be3317ad81f4$var$DEFAULT_MIN_ZOOM = 0;
/**
 * @typedef {import("./ObjectEventType").Types|'change:center'|'change:resolution'|'change:rotation'} ViewObjectEventTypes
 */ /***
 * @template Return
 * @typedef {import("./Observable").OnSignature<import("./Observable").EventTypes, import("./events/Event.js").default, Return> &
 *   import("./Observable").OnSignature<ViewObjectEventTypes, import("./Object").ObjectEvent, Return> &
 *   import("./Observable").CombinedOnSignature<import("./Observable").EventTypes|ViewObjectEventTypes, Return>} ViewOnSignature
 */ /**
 * @classdesc
 * A View object represents a simple 2D view of the map.
 *
 * This is the object to act upon to change the center, resolution,
 * and rotation of the map.
 *
 * A View has a `projection`. The projection determines the
 * coordinate system of the center, and its units determine the units of the
 * resolution (projection units per pixel). The default projection is
 * Web Mercator (EPSG:3857).
 *
 * ### The view states
 *
 * A View is determined by three states: `center`, `resolution`,
 * and `rotation`. Each state has a corresponding getter and setter, e.g.
 * `getCenter` and `setCenter` for the `center` state.
 *
 * The `zoom` state is actually not saved on the view: all computations
 * internally use the `resolution` state. Still, the `setZoom` and `getZoom`
 * methods are available, as well as `getResolutionForZoom` and
 * `getZoomForResolution` to switch from one system to the other.
 *
 * ### The constraints
 *
 * `setCenter`, `setResolution` and `setRotation` can be used to change the
 * states of the view, but any constraint defined in the constructor will
 * be applied along the way.
 *
 * A View object can have a *resolution constraint*, a *rotation constraint*
 * and a *center constraint*.
 *
 * The *resolution constraint* typically restricts min/max values and
 * snaps to specific resolutions. It is determined by the following
 * options: `resolutions`, `maxResolution`, `maxZoom` and `zoomFactor`.
 * If `resolutions` is set, the other three options are ignored. See
 * documentation for each option for more information. By default, the view
 * only has a min/max restriction and allow intermediary zoom levels when
 * pinch-zooming for example.
 *
 * The *rotation constraint* snaps to specific angles. It is determined
 * by the following options: `enableRotation` and `constrainRotation`.
 * By default rotation is allowed and its value is snapped to zero when approaching the
 * horizontal.
 *
 * The *center constraint* is determined by the `extent` option. By
 * default the view center is not constrained at all.
 *
 * ### Changing the view state
 *
 * It is important to note that `setZoom`, `setResolution`, `setCenter` and
 * `setRotation` are subject to the above mentioned constraints. As such, it
 * may sometimes not be possible to know in advance the resulting state of the
 * View. For example, calling `setResolution(10)` does not guarantee that
 * `getResolution()` will return `10`.
 *
 * A consequence of this is that, when applying a delta on the view state, one
 * should use `adjustCenter`, `adjustRotation`, `adjustZoom` and `adjustResolution`
 * rather than the corresponding setters. This will let view do its internal
 * computations. Besides, the `adjust*` methods also take an `anchor`
 * argument which allows specifying an origin for the transformation.
 *
 * ### Interacting with the view
 *
 * View constraints are usually only applied when the view is *at rest*, meaning that
 * no interaction or animation is ongoing. As such, if the user puts the view in a
 * state that is not equivalent to a constrained one (e.g. rotating the view when
 * the snap angle is 0), an animation will be triggered at the interaction end to
 * put back the view to a stable state;
 *
 * @api
 * @extends {BaseObject<ViewOptions>}
 */ class $22c5be3317ad81f4$var$View extends (0, $4862cdcc23257f5b$export$2e2bcd8739ae039) {
    /**
   * @param {ViewOptions} [options] View options.
   */ constructor(options){
        super();
        /***
     * @type {ViewOnSignature<import("./events").EventsKey>}
     */ this.on;
        /***
     * @type {ViewOnSignature<import("./events").EventsKey>}
     */ this.once;
        /***
     * @type {ViewOnSignature<void>}
     */ this.un;
        options = Object.assign({}, options);
        /**
     * @private
     * @type {Array<number>}
     */ this.hints_ = [
            0,
            0
        ];
        /**
     * @private
     * @type {Array<Array<Animation>>}
     */ this.animations_ = [];
        /**
     * @private
     * @type {number|undefined}
     */ this.updateAnimationKey_;
        /**
     * @private
     * @const
     * @type {import("./proj/Projection.js").default}
     */ this.projection_ = (0, $a86eee1c28205a05$export$549167224996a0fb)(options.projection, 'EPSG:3857');
        /**
     * @private
     * @type {import("./size.js").Size}
     */ this.viewportSize_ = [
            100,
            100
        ];
        /**
     * @private
     * @type {import("./coordinate.js").Coordinate|undefined}
     */ this.targetCenter_ = null;
        /**
     * @private
     * @type {number|undefined}
     */ this.targetResolution_;
        /**
     * @private
     * @type {number|undefined}
     */ this.targetRotation_;
        /**
     * @private
     * @type {import("./coordinate.js").Coordinate}
     */ this.nextCenter_ = null;
        /**
     * @private
     * @type {number}
     */ this.nextResolution_;
        /**
     * @private
     * @type {number}
     */ this.nextRotation_;
        /**
     * @private
     * @type {import("./coordinate.js").Coordinate|undefined}
     */ this.cancelAnchor_ = undefined;
        if (options.projection) (0, $a86eee1c28205a05$export$ed949affbc7c4223)();
        if (options.center) options.center = (0, $a86eee1c28205a05$export$d4b8ec0b96db1ee2)(options.center, this.projection_);
        if (options.extent) options.extent = (0, $a86eee1c28205a05$export$494be3a3a25689ca)(options.extent, this.projection_);
        this.applyOptions_(options);
    }
    /**
   * Set up the view with the given options.
   * @param {ViewOptions} options View options.
   */ applyOptions_(options) {
        const properties = Object.assign({}, options);
        for(const key in 0, $1ae515d0c6239191$export$2e2bcd8739ae039)delete properties[key];
        this.setProperties(properties, true);
        const resolutionConstraintInfo = $22c5be3317ad81f4$export$c68d65f9148da196(options);
        /**
     * @private
     * @type {number}
     */ this.maxResolution_ = resolutionConstraintInfo.maxResolution;
        /**
     * @private
     * @type {number}
     */ this.minResolution_ = resolutionConstraintInfo.minResolution;
        /**
     * @private
     * @type {number}
     */ this.zoomFactor_ = resolutionConstraintInfo.zoomFactor;
        /**
     * @private
     * @type {Array<number>|undefined}
     */ this.resolutions_ = options.resolutions;
        /**
     * @type {Array<number>|undefined}
     * @private
     */ this.padding_ = options.padding;
        /**
     * @private
     * @type {number}
     */ this.minZoom_ = resolutionConstraintInfo.minZoom;
        const centerConstraint = $22c5be3317ad81f4$export$964345001ee9ac52(options);
        const resolutionConstraint = resolutionConstraintInfo.constraint;
        const rotationConstraint = $22c5be3317ad81f4$export$4eeaa08dd550e3c0(options);
        /**
     * @private
     * @type {Constraints}
     */ this.constraints_ = {
            center: centerConstraint,
            resolution: resolutionConstraint,
            rotation: rotationConstraint
        };
        this.setRotation(options.rotation !== undefined ? options.rotation : 0);
        this.setCenterInternal(options.center !== undefined ? options.center : null);
        if (options.resolution !== undefined) this.setResolution(options.resolution);
        else if (options.zoom !== undefined) this.setZoom(options.zoom);
    }
    /**
   * Padding (in css pixels).
   * If the map viewport is partially covered with other content (overlays) along
   * its edges, this setting allows to shift the center of the viewport away from that
   * content. The order of the values in the array is top, right, bottom, left.
   * The default is no padding, which is equivalent to `[0, 0, 0, 0]`.
   * @type {Array<number>|undefined}
   * @api
   */ get padding() {
        return this.padding_;
    }
    set padding(padding) {
        let oldPadding = this.padding_;
        this.padding_ = padding;
        const center = this.getCenterInternal();
        if (center) {
            const newPadding = padding || [
                0,
                0,
                0,
                0
            ];
            oldPadding = oldPadding || [
                0,
                0,
                0,
                0
            ];
            const resolution = this.getResolution();
            const offsetX = resolution / 2 * (newPadding[3] - oldPadding[3] + oldPadding[1] - newPadding[1]);
            const offsetY = resolution / 2 * (newPadding[0] - oldPadding[0] + oldPadding[2] - newPadding[2]);
            this.setCenterInternal([
                center[0] + offsetX,
                center[1] - offsetY
            ]);
        }
    }
    /**
   * Get an updated version of the view options used to construct the view.  The
   * current resolution (or zoom), center, and rotation are applied to any stored
   * options.  The provided options can be used to apply new min/max zoom or
   * resolution limits.
   * @param {ViewOptions} newOptions New options to be applied.
   * @return {ViewOptions} New options updated with the current view state.
   */ getUpdatedOptions_(newOptions) {
        const options = this.getProperties();
        // preserve resolution (or zoom)
        if (options.resolution !== undefined) options.resolution = this.getResolution();
        else options.zoom = this.getZoom();
        // preserve center
        options.center = this.getCenterInternal();
        // preserve rotation
        options.rotation = this.getRotation();
        return Object.assign({}, options, newOptions);
    }
    /**
   * Animate the view.  The view's center, zoom (or resolution), and rotation
   * can be animated for smooth transitions between view states.  For example,
   * to animate the view to a new zoom level:
   *
   *     view.animate({zoom: view.getZoom() + 1});
   *
   * By default, the animation lasts one second and uses in-and-out easing.  You
   * can customize this behavior by including `duration` (in milliseconds) and
   * `easing` options (see {@link module:ol/easing}).
   *
   * To chain together multiple animations, call the method with multiple
   * animation objects.  For example, to first zoom and then pan:
   *
   *     view.animate({zoom: 10}, {center: [0, 0]});
   *
   * If you provide a function as the last argument to the animate method, it
   * will get called at the end of an animation series.  The callback will be
   * called with `true` if the animation series completed on its own or `false`
   * if it was cancelled.
   *
   * Animations are cancelled by user interactions (e.g. dragging the map) or by
   * calling `view.setCenter()`, `view.setResolution()`, or `view.setRotation()`
   * (or another method that calls one of these).
   *
   * @param {...(AnimationOptions|function(boolean): void)} var_args Animation
   *     options.  Multiple animations can be run in series by passing multiple
   *     options objects.  To run multiple animations in parallel, call the method
   *     multiple times.  An optional callback can be provided as a final
   *     argument.  The callback will be called with a boolean indicating whether
   *     the animation completed without being cancelled.
   * @api
   */ animate(var_args) {
        if (this.isDef() && !this.getAnimating()) this.resolveConstraints(0);
        const args = new Array(arguments.length);
        for(let i = 0; i < args.length; ++i){
            let options = arguments[i];
            if (options.center) {
                options = Object.assign({}, options);
                options.center = (0, $a86eee1c28205a05$export$d4b8ec0b96db1ee2)(options.center, this.getProjection());
            }
            if (options.anchor) {
                options = Object.assign({}, options);
                options.anchor = (0, $a86eee1c28205a05$export$d4b8ec0b96db1ee2)(options.anchor, this.getProjection());
            }
            args[i] = options;
        }
        this.animateInternal.apply(this, args);
    }
    /**
   * @param {...(AnimationOptions|function(boolean): void)} var_args Animation options.
   */ animateInternal(var_args) {
        let animationCount = arguments.length;
        let callback;
        if (animationCount > 1 && typeof arguments[animationCount - 1] === 'function') {
            callback = arguments[animationCount - 1];
            --animationCount;
        }
        let i = 0;
        for(; i < animationCount && !this.isDef(); ++i){
            // if view properties are not yet set, shortcut to the final state
            const state = arguments[i];
            if (state.center) this.setCenterInternal(state.center);
            if (state.zoom !== undefined) this.setZoom(state.zoom);
            else if (state.resolution) this.setResolution(state.resolution);
            if (state.rotation !== undefined) this.setRotation(state.rotation);
        }
        if (i === animationCount) {
            if (callback) $22c5be3317ad81f4$var$animationCallback(callback, true);
            return;
        }
        let start = Date.now();
        let center = this.targetCenter_.slice();
        let resolution = this.targetResolution_;
        let rotation = this.targetRotation_;
        const series = [];
        for(; i < animationCount; ++i){
            const options = /** @type {AnimationOptions} */ arguments[i];
            const animation = {
                start: start,
                complete: false,
                anchor: options.anchor,
                duration: options.duration !== undefined ? options.duration : 1000,
                easing: options.easing || (0, $386674cda6e01ace$export$9b47139b511b56e4),
                callback: callback
            };
            if (options.center) {
                animation.sourceCenter = center;
                animation.targetCenter = options.center.slice();
                center = animation.targetCenter;
            }
            if (options.zoom !== undefined) {
                animation.sourceResolution = resolution;
                animation.targetResolution = this.getResolutionForZoom(options.zoom);
                resolution = animation.targetResolution;
            } else if (options.resolution) {
                animation.sourceResolution = resolution;
                animation.targetResolution = options.resolution;
                resolution = animation.targetResolution;
            }
            if (options.rotation !== undefined) {
                animation.sourceRotation = rotation;
                const delta = (0, $6a95bd76d7103f37$export$ba467bec01d66def)(options.rotation - rotation + Math.PI, 2 * Math.PI) - Math.PI;
                animation.targetRotation = rotation + delta;
                rotation = animation.targetRotation;
            }
            // check if animation is a no-op
            if ($22c5be3317ad81f4$export$ee75376562060184(animation)) animation.complete = true;
            else start += animation.duration;
            series.push(animation);
        }
        this.animations_.push(series);
        this.setHint((0, $e4565fb1c11da106$export$2e2bcd8739ae039).ANIMATING, 1);
        this.updateAnimations_();
    }
    /**
   * Determine if the view is being animated.
   * @return {boolean} The view is being animated.
   * @api
   */ getAnimating() {
        return this.hints_[(0, $e4565fb1c11da106$export$2e2bcd8739ae039).ANIMATING] > 0;
    }
    /**
   * Determine if the user is interacting with the view, such as panning or zooming.
   * @return {boolean} The view is being interacted with.
   * @api
   */ getInteracting() {
        return this.hints_[(0, $e4565fb1c11da106$export$2e2bcd8739ae039).INTERACTING] > 0;
    }
    /**
   * Cancel any ongoing animations.
   * @api
   */ cancelAnimations() {
        this.setHint((0, $e4565fb1c11da106$export$2e2bcd8739ae039).ANIMATING, -this.hints_[(0, $e4565fb1c11da106$export$2e2bcd8739ae039).ANIMATING]);
        let anchor;
        for(let i = 0, ii = this.animations_.length; i < ii; ++i){
            const series = this.animations_[i];
            if (series[0].callback) $22c5be3317ad81f4$var$animationCallback(series[0].callback, false);
            if (!anchor) for(let j = 0, jj = series.length; j < jj; ++j){
                const animation = series[j];
                if (!animation.complete) {
                    anchor = animation.anchor;
                    break;
                }
            }
        }
        this.animations_.length = 0;
        this.cancelAnchor_ = anchor;
        this.nextCenter_ = null;
        this.nextResolution_ = NaN;
        this.nextRotation_ = NaN;
    }
    /**
   * Update all animations.
   */ updateAnimations_() {
        if (this.updateAnimationKey_ !== undefined) {
            cancelAnimationFrame(this.updateAnimationKey_);
            this.updateAnimationKey_ = undefined;
        }
        if (!this.getAnimating()) return;
        const now = Date.now();
        let more = false;
        for(let i = this.animations_.length - 1; i >= 0; --i){
            const series = this.animations_[i];
            let seriesComplete = true;
            for(let j = 0, jj = series.length; j < jj; ++j){
                const animation = series[j];
                if (animation.complete) continue;
                const elapsed = now - animation.start;
                let fraction = animation.duration > 0 ? elapsed / animation.duration : 1;
                if (fraction >= 1) {
                    animation.complete = true;
                    fraction = 1;
                } else seriesComplete = false;
                const progress = animation.easing(fraction);
                if (animation.sourceCenter) {
                    const x0 = animation.sourceCenter[0];
                    const y0 = animation.sourceCenter[1];
                    const x1 = animation.targetCenter[0];
                    const y1 = animation.targetCenter[1];
                    this.nextCenter_ = animation.targetCenter;
                    const x = x0 + progress * (x1 - x0);
                    const y = y0 + progress * (y1 - y0);
                    this.targetCenter_ = [
                        x,
                        y
                    ];
                }
                if (animation.sourceResolution && animation.targetResolution) {
                    const resolution = progress === 1 ? animation.targetResolution : animation.sourceResolution + progress * (animation.targetResolution - animation.sourceResolution);
                    if (animation.anchor) {
                        const size = this.getViewportSize_(this.getRotation());
                        const constrainedResolution = this.constraints_.resolution(resolution, 0, size, true);
                        this.targetCenter_ = this.calculateCenterZoom(constrainedResolution, animation.anchor);
                    }
                    this.nextResolution_ = animation.targetResolution;
                    this.targetResolution_ = resolution;
                    this.applyTargetState_(true);
                }
                if (animation.sourceRotation !== undefined && animation.targetRotation !== undefined) {
                    const rotation = progress === 1 ? (0, $6a95bd76d7103f37$export$ba467bec01d66def)(animation.targetRotation + Math.PI, 2 * Math.PI) - Math.PI : animation.sourceRotation + progress * (animation.targetRotation - animation.sourceRotation);
                    if (animation.anchor) {
                        const constrainedRotation = this.constraints_.rotation(rotation, true);
                        this.targetCenter_ = this.calculateCenterRotate(constrainedRotation, animation.anchor);
                    }
                    this.nextRotation_ = animation.targetRotation;
                    this.targetRotation_ = rotation;
                }
                this.applyTargetState_(true);
                more = true;
                if (!animation.complete) break;
            }
            if (seriesComplete) {
                this.animations_[i] = null;
                this.setHint((0, $e4565fb1c11da106$export$2e2bcd8739ae039).ANIMATING, -1);
                this.nextCenter_ = null;
                this.nextResolution_ = NaN;
                this.nextRotation_ = NaN;
                const callback = series[0].callback;
                if (callback) $22c5be3317ad81f4$var$animationCallback(callback, true);
            }
        }
        // prune completed series
        this.animations_ = this.animations_.filter(Boolean);
        if (more && this.updateAnimationKey_ === undefined) this.updateAnimationKey_ = requestAnimationFrame(this.updateAnimations_.bind(this));
    }
    /**
   * @param {number} rotation Target rotation.
   * @param {import("./coordinate.js").Coordinate} anchor Rotation anchor.
   * @return {import("./coordinate.js").Coordinate|undefined} Center for rotation and anchor.
   */ calculateCenterRotate(rotation, anchor) {
        let center;
        const currentCenter = this.getCenterInternal();
        if (currentCenter !== undefined) {
            center = [
                currentCenter[0] - anchor[0],
                currentCenter[1] - anchor[1]
            ];
            (0, $a6adb03fd2fbc071$export$bb628a54ab399bc9)(center, rotation - this.getRotation());
            (0, $a6adb03fd2fbc071$export$e16d8520af44a096)(center, anchor);
        }
        return center;
    }
    /**
   * @param {number} resolution Target resolution.
   * @param {import("./coordinate.js").Coordinate} anchor Zoom anchor.
   * @return {import("./coordinate.js").Coordinate|undefined} Center for resolution and anchor.
   */ calculateCenterZoom(resolution, anchor) {
        let center;
        const currentCenter = this.getCenterInternal();
        const currentResolution = this.getResolution();
        if (currentCenter !== undefined && currentResolution !== undefined) {
            const x = anchor[0] - resolution * (anchor[0] - currentCenter[0]) / currentResolution;
            const y = anchor[1] - resolution * (anchor[1] - currentCenter[1]) / currentResolution;
            center = [
                x,
                y
            ];
        }
        return center;
    }
    /**
   * Returns the current viewport size.
   * @private
   * @param {number} [rotation] Take into account the rotation of the viewport when giving the size
   * @return {import("./size.js").Size} Viewport size or `[100, 100]` when no viewport is found.
   */ getViewportSize_(rotation) {
        const size = this.viewportSize_;
        if (rotation) {
            const w = size[0];
            const h = size[1];
            return [
                Math.abs(w * Math.cos(rotation)) + Math.abs(h * Math.sin(rotation)),
                Math.abs(w * Math.sin(rotation)) + Math.abs(h * Math.cos(rotation))
            ];
        }
        return size;
    }
    /**
   * Stores the viewport size on the view. The viewport size is not read every time from the DOM
   * to avoid performance hit and layout reflow.
   * This should be done on map size change.
   * Note: the constraints are not resolved during an animation to avoid stopping it
   * @param {import("./size.js").Size} [size] Viewport size; if undefined, [100, 100] is assumed
   */ setViewportSize(size) {
        this.viewportSize_ = Array.isArray(size) ? size.slice() : [
            100,
            100
        ];
        if (!this.getAnimating()) this.resolveConstraints(0);
    }
    /**
   * Get the view center.
   * @return {import("./coordinate.js").Coordinate|undefined} The center of the view.
   * @observable
   * @api
   */ getCenter() {
        const center = this.getCenterInternal();
        if (!center) return center;
        return (0, $a86eee1c28205a05$export$698f563af1ba02a5)(center, this.getProjection());
    }
    /**
   * Get the view center without transforming to user projection.
   * @return {import("./coordinate.js").Coordinate|undefined} The center of the view.
   */ getCenterInternal() {
        return /** @type {import("./coordinate.js").Coordinate|undefined} */ this.get((0, $1ae515d0c6239191$export$2e2bcd8739ae039).CENTER);
    }
    /**
   * @return {Constraints} Constraints.
   */ getConstraints() {
        return this.constraints_;
    }
    /**
   * @return {boolean} Resolution constraint is set
   */ getConstrainResolution() {
        return this.get('constrainResolution');
    }
    /**
   * @param {Array<number>} [hints] Destination array.
   * @return {Array<number>} Hint.
   */ getHints(hints) {
        if (hints !== undefined) {
            hints[0] = this.hints_[0];
            hints[1] = this.hints_[1];
            return hints;
        }
        return this.hints_.slice();
    }
    /**
   * Calculate the extent for the current view state and the passed box size.
   * @param {import("./size.js").Size} [size] The pixel dimensions of the box
   * into which the calculated extent should fit. Defaults to the size of the
   * map the view is associated with.
   * If no map or multiple maps are connected to the view, provide the desired
   * box size (e.g. `map.getSize()`).
   * @return {import("./extent.js").Extent} Extent.
   * @api
   */ calculateExtent(size) {
        const extent = this.calculateExtentInternal(size);
        return (0, $a86eee1c28205a05$export$96bfd09e2cffb006)(extent, this.getProjection());
    }
    /**
   * @param {import("./size.js").Size} [size] Box pixel size. If not provided,
   * the map's last known viewport size will be used.
   * @return {import("./extent.js").Extent} Extent.
   */ calculateExtentInternal(size) {
        size = size || this.getViewportSizeMinusPadding_();
        const center = /** @type {!import("./coordinate.js").Coordinate} */ this.getCenterInternal();
        (0, $71eb897bda873684$export$a7a9523472993e97)(center, 'The view center is not defined');
        const resolution = /** @type {!number} */ this.getResolution();
        (0, $71eb897bda873684$export$a7a9523472993e97)(resolution !== undefined, 'The view resolution is not defined');
        const rotation = /** @type {!number} */ this.getRotation();
        (0, $71eb897bda873684$export$a7a9523472993e97)(rotation !== undefined, 'The view rotation is not defined');
        return (0, $dea65c2f666fa450$export$13ba650faf8308)(center, resolution, rotation, size);
    }
    /**
   * Get the maximum resolution of the view.
   * @return {number} The maximum resolution of the view.
   * @api
   */ getMaxResolution() {
        return this.maxResolution_;
    }
    /**
   * Get the minimum resolution of the view.
   * @return {number} The minimum resolution of the view.
   * @api
   */ getMinResolution() {
        return this.minResolution_;
    }
    /**
   * Get the maximum zoom level for the view.
   * @return {number} The maximum zoom level.
   * @api
   */ getMaxZoom() {
        return /** @type {number} */ this.getZoomForResolution(this.minResolution_);
    }
    /**
   * Set a new maximum zoom level for the view.
   * @param {number} zoom The maximum zoom level.
   * @api
   */ setMaxZoom(zoom) {
        this.applyOptions_(this.getUpdatedOptions_({
            maxZoom: zoom
        }));
    }
    /**
   * Get the minimum zoom level for the view.
   * @return {number} The minimum zoom level.
   * @api
   */ getMinZoom() {
        return /** @type {number} */ this.getZoomForResolution(this.maxResolution_);
    }
    /**
   * Set a new minimum zoom level for the view.
   * @param {number} zoom The minimum zoom level.
   * @api
   */ setMinZoom(zoom) {
        this.applyOptions_(this.getUpdatedOptions_({
            minZoom: zoom
        }));
    }
    /**
   * Set whether the view should allow intermediary zoom levels.
   * @param {boolean} enabled Whether the resolution is constrained.
   * @api
   */ setConstrainResolution(enabled) {
        this.applyOptions_(this.getUpdatedOptions_({
            constrainResolution: enabled
        }));
    }
    /**
   * Get the view projection.
   * @return {import("./proj/Projection.js").default} The projection of the view.
   * @api
   */ getProjection() {
        return this.projection_;
    }
    /**
   * Get the view resolution.
   * @return {number|undefined} The resolution of the view.
   * @observable
   * @api
   */ getResolution() {
        return /** @type {number|undefined} */ this.get((0, $1ae515d0c6239191$export$2e2bcd8739ae039).RESOLUTION);
    }
    /**
   * Get the resolutions for the view. This returns the array of resolutions
   * passed to the constructor of the View, or undefined if none were given.
   * @return {Array<number>|undefined} The resolutions of the view.
   * @api
   */ getResolutions() {
        return this.resolutions_;
    }
    /**
   * Get the resolution for a provided extent (in map units) and size (in pixels).
   * @param {import("./extent.js").Extent} extent Extent.
   * @param {import("./size.js").Size} [size] Box pixel size.
   * @return {number} The resolution at which the provided extent will render at
   *     the given size.
   * @api
   */ getResolutionForExtent(extent, size) {
        return this.getResolutionForExtentInternal((0, $a86eee1c28205a05$export$494be3a3a25689ca)(extent, this.getProjection()), size);
    }
    /**
   * Get the resolution for a provided extent (in map units) and size (in pixels).
   * @param {import("./extent.js").Extent} extent Extent.
   * @param {import("./size.js").Size} [size] Box pixel size.
   * @return {number} The resolution at which the provided extent will render at
   *     the given size.
   */ getResolutionForExtentInternal(extent, size) {
        size = size || this.getViewportSizeMinusPadding_();
        const xResolution = (0, $dea65c2f666fa450$export$3c49c185de0c2bfc)(extent) / size[0];
        const yResolution = (0, $dea65c2f666fa450$export$c08559766941f856)(extent) / size[1];
        return Math.max(xResolution, yResolution);
    }
    /**
   * Return a function that returns a value between 0 and 1 for a
   * resolution. Exponential scaling is assumed.
   * @param {number} [power] Power.
   * @return {function(number): number} Resolution for value function.
   */ getResolutionForValueFunction(power) {
        power = power || 2;
        const maxResolution = this.getConstrainedResolution(this.maxResolution_);
        const minResolution = this.minResolution_;
        const max = Math.log(maxResolution / minResolution) / Math.log(power);
        return(/**
       * @param {number} value Value.
       * @return {number} Resolution.
       */ function(value) {
            const resolution = maxResolution / Math.pow(power, value * max);
            return resolution;
        });
    }
    /**
   * Get the view rotation.
   * @return {number} The rotation of the view in radians.
   * @observable
   * @api
   */ getRotation() {
        return /** @type {number} */ this.get((0, $1ae515d0c6239191$export$2e2bcd8739ae039).ROTATION);
    }
    /**
   * Return a function that returns a resolution for a value between
   * 0 and 1. Exponential scaling is assumed.
   * @param {number} [power] Power.
   * @return {function(number): number} Value for resolution function.
   */ getValueForResolutionFunction(power) {
        const logPower = Math.log(power || 2);
        const maxResolution = this.getConstrainedResolution(this.maxResolution_);
        const minResolution = this.minResolution_;
        const max = Math.log(maxResolution / minResolution) / logPower;
        return(/**
       * @param {number} resolution Resolution.
       * @return {number} Value.
       */ function(resolution) {
            const value = Math.log(maxResolution / resolution) / logPower / max;
            return value;
        });
    }
    /**
   * Returns the size of the viewport minus padding.
   * @private
   * @param {number} [rotation] Take into account the rotation of the viewport when giving the size
   * @return {import("./size.js").Size} Viewport size reduced by the padding.
   */ getViewportSizeMinusPadding_(rotation) {
        let size = this.getViewportSize_(rotation);
        const padding = this.padding_;
        if (padding) size = [
            size[0] - padding[1] - padding[3],
            size[1] - padding[0] - padding[2]
        ];
        return size;
    }
    /**
   * @return {State} View state.
   */ getState() {
        const projection = this.getProjection();
        const resolution = this.getResolution();
        const rotation = this.getRotation();
        let center = /** @type {import("./coordinate.js").Coordinate} */ this.getCenterInternal();
        const padding = this.padding_;
        if (padding) {
            const reducedSize = this.getViewportSizeMinusPadding_();
            center = $22c5be3317ad81f4$var$calculateCenterOn(center, this.getViewportSize_(), [
                reducedSize[0] / 2 + padding[3],
                reducedSize[1] / 2 + padding[0]
            ], resolution, rotation);
        }
        return {
            center: center.slice(0),
            projection: projection !== undefined ? projection : null,
            resolution: resolution,
            nextCenter: this.nextCenter_,
            nextResolution: this.nextResolution_,
            nextRotation: this.nextRotation_,
            rotation: rotation,
            zoom: this.getZoom()
        };
    }
    /**
   * @return {ViewStateLayerStateExtent} Like `FrameState`, but just `viewState` and `extent`.
   */ getViewStateAndExtent() {
        return {
            viewState: this.getState(),
            extent: this.calculateExtent()
        };
    }
    /**
   * Get the current zoom level. This method may return non-integer zoom levels
   * if the view does not constrain the resolution, or if an interaction or
   * animation is underway.
   * @return {number|undefined} Zoom.
   * @api
   */ getZoom() {
        let zoom;
        const resolution = this.getResolution();
        if (resolution !== undefined) zoom = this.getZoomForResolution(resolution);
        return zoom;
    }
    /**
   * Get the zoom level for a resolution.
   * @param {number} resolution The resolution.
   * @return {number|undefined} The zoom level for the provided resolution.
   * @api
   */ getZoomForResolution(resolution) {
        let offset = this.minZoom_ || 0;
        let max, zoomFactor;
        if (this.resolutions_) {
            const nearest = (0, $49313fcb0fc32abe$export$8a3786cc03fdb777)(this.resolutions_, resolution, 1);
            offset = nearest;
            max = this.resolutions_[nearest];
            if (nearest == this.resolutions_.length - 1) zoomFactor = 2;
            else zoomFactor = max / this.resolutions_[nearest + 1];
        } else {
            max = this.maxResolution_;
            zoomFactor = this.zoomFactor_;
        }
        return offset + Math.log(max / resolution) / Math.log(zoomFactor);
    }
    /**
   * Get the resolution for a zoom level.
   * @param {number} zoom Zoom level.
   * @return {number} The view resolution for the provided zoom level.
   * @api
   */ getResolutionForZoom(zoom) {
        if (this.resolutions_?.length) {
            if (this.resolutions_.length === 1) return this.resolutions_[0];
            const baseLevel = (0, $6a95bd76d7103f37$export$7d15b64cf5a3a4c4)(Math.floor(zoom), 0, this.resolutions_.length - 2);
            const zoomFactor = this.resolutions_[baseLevel] / this.resolutions_[baseLevel + 1];
            return this.resolutions_[baseLevel] / Math.pow(zoomFactor, (0, $6a95bd76d7103f37$export$7d15b64cf5a3a4c4)(zoom - baseLevel, 0, 1));
        }
        return this.maxResolution_ / Math.pow(this.zoomFactor_, zoom - this.minZoom_);
    }
    /**
   * Fit the given geometry or extent based on the given map size and border.
   * The size is pixel dimensions of the box to fit the extent into.
   * In most cases you will want to use the map size, that is `map.getSize()`.
   * Takes care of the map angle.
   * @param {import("./geom/SimpleGeometry.js").default|import("./extent.js").Extent} geometryOrExtent The geometry or
   *     extent to fit the view to.
   * @param {FitOptions} [options] Options.
   * @api
   */ fit(geometryOrExtent, options) {
        /** @type {import("./geom/SimpleGeometry.js").default} */ let geometry;
        (0, $71eb897bda873684$export$a7a9523472993e97)(Array.isArray(geometryOrExtent) || typeof /** @type {?} */ geometryOrExtent.getSimplifiedGeometry === 'function', 'Invalid extent or geometry provided as `geometry`');
        if (Array.isArray(geometryOrExtent)) {
            (0, $71eb897bda873684$export$a7a9523472993e97)(!(0, $dea65c2f666fa450$export$dd1bc94b04021eeb)(geometryOrExtent), 'Cannot fit empty extent provided as `geometry`');
            const extent = (0, $a86eee1c28205a05$export$494be3a3a25689ca)(geometryOrExtent, this.getProjection());
            geometry = (0, $52cb54ac72de6b07$export$c16b671815801c75)(extent);
        } else if (geometryOrExtent.getType() === 'Circle') {
            const extent = (0, $a86eee1c28205a05$export$494be3a3a25689ca)(geometryOrExtent.getExtent(), this.getProjection());
            geometry = (0, $52cb54ac72de6b07$export$c16b671815801c75)(extent);
            geometry.rotate(this.getRotation(), (0, $dea65c2f666fa450$export$c91255cadecfe081)(extent));
        } else {
            const userProjection = (0, $a86eee1c28205a05$export$3973b77d5f6f2790)();
            if (userProjection) geometry = /** @type {import("./geom/SimpleGeometry.js").default} */ geometryOrExtent.clone().transform(userProjection, this.getProjection());
            else geometry = geometryOrExtent;
        }
        this.fitInternal(geometry, options);
    }
    /**
   * Calculate rotated extent
   * @param {import("./geom/SimpleGeometry.js").default} geometry The geometry.
   * @return {import("./extent").Extent} The rotated extent for the geometry.
   */ rotatedExtentForGeometry(geometry) {
        const rotation = this.getRotation();
        const cosAngle = Math.cos(rotation);
        const sinAngle = Math.sin(-rotation);
        const coords = geometry.getFlatCoordinates();
        const stride = geometry.getStride();
        let minRotX = Infinity;
        let minRotY = Infinity;
        let maxRotX = -Infinity;
        let maxRotY = -Infinity;
        for(let i = 0, ii = coords.length; i < ii; i += stride){
            const rotX = coords[i] * cosAngle - coords[i + 1] * sinAngle;
            const rotY = coords[i] * sinAngle + coords[i + 1] * cosAngle;
            minRotX = Math.min(minRotX, rotX);
            minRotY = Math.min(minRotY, rotY);
            maxRotX = Math.max(maxRotX, rotX);
            maxRotY = Math.max(maxRotY, rotY);
        }
        return [
            minRotX,
            minRotY,
            maxRotX,
            maxRotY
        ];
    }
    /**
   * @param {import("./geom/SimpleGeometry.js").default} geometry The geometry.
   * @param {FitOptions} [options] Options.
   */ fitInternal(geometry, options) {
        options = options || {};
        let size = options.size;
        if (!size) size = this.getViewportSizeMinusPadding_();
        const padding = options.padding !== undefined ? options.padding : [
            0,
            0,
            0,
            0
        ];
        const nearest = options.nearest !== undefined ? options.nearest : false;
        let minResolution;
        if (options.minResolution !== undefined) minResolution = options.minResolution;
        else if (options.maxZoom !== undefined) minResolution = this.getResolutionForZoom(options.maxZoom);
        else minResolution = 0;
        const rotatedExtent = this.rotatedExtentForGeometry(geometry);
        // calculate resolution
        let resolution = this.getResolutionForExtentInternal(rotatedExtent, [
            size[0] - padding[1] - padding[3],
            size[1] - padding[0] - padding[2]
        ]);
        resolution = isNaN(resolution) ? minResolution : Math.max(resolution, minResolution);
        resolution = this.getConstrainedResolution(resolution, nearest ? 0 : 1);
        // calculate center
        const rotation = this.getRotation();
        const sinAngle = Math.sin(rotation);
        const cosAngle = Math.cos(rotation);
        const centerRot = (0, $dea65c2f666fa450$export$c91255cadecfe081)(rotatedExtent);
        centerRot[0] += (padding[1] - padding[3]) / 2 * resolution;
        centerRot[1] += (padding[0] - padding[2]) / 2 * resolution;
        const centerX = centerRot[0] * cosAngle - centerRot[1] * sinAngle;
        const centerY = centerRot[1] * cosAngle + centerRot[0] * sinAngle;
        const center = this.getConstrainedCenter([
            centerX,
            centerY
        ], resolution);
        const callback = options.callback ? options.callback : (0, $bc15bca7780ad95b$export$1cd1943b3a73bbe8);
        if (options.duration !== undefined) this.animateInternal({
            resolution: resolution,
            center: center,
            duration: options.duration,
            easing: options.easing
        }, callback);
        else {
            this.targetResolution_ = resolution;
            this.targetCenter_ = center;
            this.applyTargetState_(false, true);
            $22c5be3317ad81f4$var$animationCallback(callback, true);
        }
    }
    /**
   * Center on coordinate and view position.
   * @param {import("./coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("./size.js").Size} size Box pixel size.
   * @param {import("./pixel.js").Pixel} position Position on the view to center on.
   * @api
   */ centerOn(coordinate, size, position) {
        this.centerOnInternal((0, $a86eee1c28205a05$export$d4b8ec0b96db1ee2)(coordinate, this.getProjection()), size, position);
    }
    /**
   * @param {import("./coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("./size.js").Size} size Box pixel size.
   * @param {import("./pixel.js").Pixel} position Position on the view to center on.
   */ centerOnInternal(coordinate, size, position) {
        this.setCenterInternal($22c5be3317ad81f4$var$calculateCenterOn(coordinate, size, position, this.getResolution(), this.getRotation()));
    }
    /**
   * Calculates the shift between map and viewport center.
   * @param {import("./coordinate.js").Coordinate} center Center.
   * @param {number} resolution Resolution.
   * @param {number} rotation Rotation.
   * @param {import("./size.js").Size} size Size.
   * @return {Array<number>|undefined} Center shift.
   */ calculateCenterShift(center, resolution, rotation, size) {
        let centerShift;
        const padding = this.padding_;
        if (padding && center) {
            const reducedSize = this.getViewportSizeMinusPadding_(-rotation);
            const shiftedCenter = $22c5be3317ad81f4$var$calculateCenterOn(center, size, [
                reducedSize[0] / 2 + padding[3],
                reducedSize[1] / 2 + padding[0]
            ], resolution, rotation);
            centerShift = [
                center[0] - shiftedCenter[0],
                center[1] - shiftedCenter[1]
            ];
        }
        return centerShift;
    }
    /**
   * @return {boolean} Is defined.
   */ isDef() {
        return !!this.getCenterInternal() && this.getResolution() !== undefined;
    }
    /**
   * Adds relative coordinates to the center of the view. Any extent constraint will apply.
   * @param {import("./coordinate.js").Coordinate} deltaCoordinates Relative value to add.
   * @api
   */ adjustCenter(deltaCoordinates) {
        const center = (0, $a86eee1c28205a05$export$698f563af1ba02a5)(this.targetCenter_, this.getProjection());
        this.setCenter([
            center[0] + deltaCoordinates[0],
            center[1] + deltaCoordinates[1]
        ]);
    }
    /**
   * Adds relative coordinates to the center of the view. Any extent constraint will apply.
   * @param {import("./coordinate.js").Coordinate} deltaCoordinates Relative value to add.
   */ adjustCenterInternal(deltaCoordinates) {
        const center = this.targetCenter_;
        this.setCenterInternal([
            center[0] + deltaCoordinates[0],
            center[1] + deltaCoordinates[1]
        ]);
    }
    /**
   * Multiply the view resolution by a ratio, optionally using an anchor. Any resolution
   * constraint will apply.
   * @param {number} ratio The ratio to apply on the view resolution.
   * @param {import("./coordinate.js").Coordinate} [anchor] The origin of the transformation.
   * @api
   */ adjustResolution(ratio, anchor) {
        anchor = anchor && (0, $a86eee1c28205a05$export$d4b8ec0b96db1ee2)(anchor, this.getProjection());
        this.adjustResolutionInternal(ratio, anchor);
    }
    /**
   * Multiply the view resolution by a ratio, optionally using an anchor. Any resolution
   * constraint will apply.
   * @param {number} ratio The ratio to apply on the view resolution.
   * @param {import("./coordinate.js").Coordinate} [anchor] The origin of the transformation.
   */ adjustResolutionInternal(ratio, anchor) {
        const isMoving = this.getAnimating() || this.getInteracting();
        const size = this.getViewportSize_(this.getRotation());
        const newResolution = this.constraints_.resolution(this.targetResolution_ * ratio, 0, size, isMoving);
        if (anchor) this.targetCenter_ = this.calculateCenterZoom(newResolution, anchor);
        this.targetResolution_ *= ratio;
        this.applyTargetState_();
    }
    /**
   * Adds a value to the view zoom level, optionally using an anchor. Any resolution
   * constraint will apply.
   * @param {number} delta Relative value to add to the zoom level.
   * @param {import("./coordinate.js").Coordinate} [anchor] The origin of the transformation.
   * @api
   */ adjustZoom(delta, anchor) {
        this.adjustResolution(Math.pow(this.zoomFactor_, -delta), anchor);
    }
    /**
   * Adds a value to the view rotation, optionally using an anchor. Any rotation
   * constraint will apply.
   * @param {number} delta Relative value to add to the zoom rotation, in radians.
   * @param {import("./coordinate.js").Coordinate} [anchor] The rotation center.
   * @api
   */ adjustRotation(delta, anchor) {
        if (anchor) anchor = (0, $a86eee1c28205a05$export$d4b8ec0b96db1ee2)(anchor, this.getProjection());
        this.adjustRotationInternal(delta, anchor);
    }
    /**
   * @param {number} delta Relative value to add to the zoom rotation, in radians.
   * @param {import("./coordinate.js").Coordinate} [anchor] The rotation center.
   */ adjustRotationInternal(delta, anchor) {
        const isMoving = this.getAnimating() || this.getInteracting();
        const newRotation = this.constraints_.rotation(this.targetRotation_ + delta, isMoving);
        if (anchor) this.targetCenter_ = this.calculateCenterRotate(newRotation, anchor);
        this.targetRotation_ += delta;
        this.applyTargetState_();
    }
    /**
   * Set the center of the current view. Any extent constraint will apply.
   * @param {import("./coordinate.js").Coordinate|undefined} center The center of the view.
   * @observable
   * @api
   */ setCenter(center) {
        this.setCenterInternal(center ? (0, $a86eee1c28205a05$export$d4b8ec0b96db1ee2)(center, this.getProjection()) : center);
    }
    /**
   * Set the center using the view projection (not the user projection).
   * @param {import("./coordinate.js").Coordinate|undefined} center The center of the view.
   */ setCenterInternal(center) {
        this.targetCenter_ = center;
        this.applyTargetState_();
    }
    /**
   * @param {import("./ViewHint.js").default} hint Hint.
   * @param {number} delta Delta.
   * @return {number} New value.
   */ setHint(hint, delta) {
        this.hints_[hint] += delta;
        this.changed();
        return this.hints_[hint];
    }
    /**
   * Set the resolution for this view. Any resolution constraint will apply.
   * @param {number|undefined} resolution The resolution of the view.
   * @observable
   * @api
   */ setResolution(resolution) {
        this.targetResolution_ = resolution;
        this.applyTargetState_();
    }
    /**
   * Set the rotation for this view. Any rotation constraint will apply.
   * @param {number} rotation The rotation of the view in radians.
   * @observable
   * @api
   */ setRotation(rotation) {
        this.targetRotation_ = rotation;
        this.applyTargetState_();
    }
    /**
   * Zoom to a specific zoom level. Any resolution constrain will apply.
   * @param {number} zoom Zoom level.
   * @api
   */ setZoom(zoom) {
        this.setResolution(this.getResolutionForZoom(zoom));
    }
    /**
   * Recompute rotation/resolution/center based on target values.
   * Note: we have to compute rotation first, then resolution and center considering that
   * parameters can influence one another in case a view extent constraint is present.
   * @param {boolean} [doNotCancelAnims] Do not cancel animations.
   * @param {boolean} [forceMoving] Apply constraints as if the view is moving.
   * @private
   */ applyTargetState_(doNotCancelAnims, forceMoving) {
        const isMoving = this.getAnimating() || this.getInteracting() || forceMoving;
        // compute rotation
        const newRotation = this.constraints_.rotation(this.targetRotation_, isMoving);
        const size = this.getViewportSize_(newRotation);
        const newResolution = this.constraints_.resolution(this.targetResolution_, 0, size, isMoving);
        const newCenter = this.constraints_.center(this.targetCenter_, newResolution, size, isMoving, this.calculateCenterShift(this.targetCenter_, newResolution, newRotation, size));
        if (this.get((0, $1ae515d0c6239191$export$2e2bcd8739ae039).ROTATION) !== newRotation) this.set((0, $1ae515d0c6239191$export$2e2bcd8739ae039).ROTATION, newRotation);
        if (this.get((0, $1ae515d0c6239191$export$2e2bcd8739ae039).RESOLUTION) !== newResolution) {
            this.set((0, $1ae515d0c6239191$export$2e2bcd8739ae039).RESOLUTION, newResolution);
            this.set('zoom', this.getZoom(), true);
        }
        if (!newCenter || !this.get((0, $1ae515d0c6239191$export$2e2bcd8739ae039).CENTER) || !(0, $a6adb03fd2fbc071$export$e9bab7fafb253603)(this.get((0, $1ae515d0c6239191$export$2e2bcd8739ae039).CENTER), newCenter)) this.set((0, $1ae515d0c6239191$export$2e2bcd8739ae039).CENTER, newCenter);
        if (this.getAnimating() && !doNotCancelAnims) this.cancelAnimations();
        this.cancelAnchor_ = undefined;
    }
    /**
   * If any constraints need to be applied, an animation will be triggered.
   * This is typically done on interaction end.
   * Note: calling this with a duration of 0 will apply the constrained values straight away,
   * without animation.
   * @param {number} [duration] The animation duration in ms.
   * @param {number} [resolutionDirection] Which direction to zoom.
   * @param {import("./coordinate.js").Coordinate} [anchor] The origin of the transformation.
   */ resolveConstraints(duration, resolutionDirection, anchor) {
        duration = duration !== undefined ? duration : 200;
        const direction = resolutionDirection || 0;
        const newRotation = this.constraints_.rotation(this.targetRotation_);
        const size = this.getViewportSize_(newRotation);
        const newResolution = this.constraints_.resolution(this.targetResolution_, direction, size);
        const newCenter = this.constraints_.center(this.targetCenter_, newResolution, size, false, this.calculateCenterShift(this.targetCenter_, newResolution, newRotation, size));
        if (duration === 0 && !this.cancelAnchor_) {
            this.targetResolution_ = newResolution;
            this.targetRotation_ = newRotation;
            this.targetCenter_ = newCenter;
            this.applyTargetState_();
            return;
        }
        anchor = anchor || (duration === 0 ? this.cancelAnchor_ : undefined);
        this.cancelAnchor_ = undefined;
        if (this.getResolution() !== newResolution || this.getRotation() !== newRotation || !this.getCenterInternal() || !(0, $a6adb03fd2fbc071$export$e9bab7fafb253603)(this.getCenterInternal(), newCenter)) {
            if (this.getAnimating()) this.cancelAnimations();
            this.animateInternal({
                rotation: newRotation,
                center: newCenter,
                resolution: newResolution,
                duration: duration,
                easing: (0, $386674cda6e01ace$export$57636bb43b1ccbb0),
                anchor: anchor
            });
        }
    }
    /**
   * Notify the View that an interaction has started.
   * The view state will be resolved to a stable one if needed
   * (depending on its constraints).
   * @api
   */ beginInteraction() {
        this.resolveConstraints(0);
        this.setHint((0, $e4565fb1c11da106$export$2e2bcd8739ae039).INTERACTING, 1);
    }
    /**
   * Notify the View that an interaction has ended. The view state will be resolved
   * to a stable one if needed (depending on its constraints).
   * @param {number} [duration] Animation duration in ms.
   * @param {number} [resolutionDirection] Which direction to zoom.
   * @param {import("./coordinate.js").Coordinate} [anchor] The origin of the transformation.
   * @api
   */ endInteraction(duration, resolutionDirection, anchor) {
        anchor = anchor && (0, $a86eee1c28205a05$export$d4b8ec0b96db1ee2)(anchor, this.getProjection());
        this.endInteractionInternal(duration, resolutionDirection, anchor);
    }
    /**
   * Notify the View that an interaction has ended. The view state will be resolved
   * to a stable one if needed (depending on its constraints).
   * @param {number} [duration] Animation duration in ms.
   * @param {number} [resolutionDirection] Which direction to zoom.
   * @param {import("./coordinate.js").Coordinate} [anchor] The origin of the transformation.
   */ endInteractionInternal(duration, resolutionDirection, anchor) {
        if (!this.getInteracting()) return;
        this.setHint((0, $e4565fb1c11da106$export$2e2bcd8739ae039).INTERACTING, -1);
        this.resolveConstraints(duration, resolutionDirection, anchor);
    }
    /**
   * Get a valid position for the view center according to the current constraints.
   * @param {import("./coordinate.js").Coordinate|undefined} targetCenter Target center position.
   * @param {number} [targetResolution] Target resolution. If not supplied, the current one will be used.
   * This is useful to guess a valid center position at a different zoom level.
   * @return {import("./coordinate.js").Coordinate|undefined} Valid center position.
   */ getConstrainedCenter(targetCenter, targetResolution) {
        const size = this.getViewportSize_(this.getRotation());
        return this.constraints_.center(targetCenter, targetResolution || this.getResolution(), size);
    }
    /**
   * Get a valid zoom level according to the current view constraints.
   * @param {number|undefined} targetZoom Target zoom.
   * @param {number} [direction] Indicate which resolution should be used
   * by a renderer if the view resolution does not match any resolution of the tile source.
   * If 0, the nearest resolution will be used. If 1, the nearest lower resolution
   * will be used. If -1, the nearest higher resolution will be used.
   * @return {number|undefined} Valid zoom level.
   */ getConstrainedZoom(targetZoom, direction) {
        const targetRes = this.getResolutionForZoom(targetZoom);
        return this.getZoomForResolution(this.getConstrainedResolution(targetRes, direction));
    }
    /**
   * Get a valid resolution according to the current view constraints.
   * @param {number|undefined} targetResolution Target resolution.
   * @param {number} [direction] Indicate which resolution should be used
   * by a renderer if the view resolution does not match any resolution of the tile source.
   * If 0, the nearest resolution will be used. If 1, the nearest lower resolution
   * will be used. If -1, the nearest higher resolution will be used.
   * @return {number|undefined} Valid resolution.
   */ getConstrainedResolution(targetResolution, direction) {
        direction = direction || 0;
        const size = this.getViewportSize_(this.getRotation());
        return this.constraints_.resolution(targetResolution, direction, size);
    }
}
/**
 * @param {Function} callback Callback.
 * @param {*} returnValue Return value.
 */ function $22c5be3317ad81f4$var$animationCallback(callback, returnValue) {
    setTimeout(function() {
        callback(returnValue);
    }, 0);
}
function $22c5be3317ad81f4$export$964345001ee9ac52(options) {
    if (options.extent !== undefined) {
        const smooth = options.smoothExtentConstraint !== undefined ? options.smoothExtentConstraint : true;
        return (0, $41d247de0d2bb35a$export$c2f0af2c946f6897)(options.extent, options.constrainOnlyCenter, smooth);
    }
    const projection = (0, $a86eee1c28205a05$export$549167224996a0fb)(options.projection, 'EPSG:3857');
    if (options.multiWorld !== true && projection.isGlobal()) {
        const extent = projection.getExtent().slice();
        extent[0] = -Infinity;
        extent[2] = Infinity;
        return (0, $41d247de0d2bb35a$export$c2f0af2c946f6897)(extent, false, false);
    }
    return 0, $41d247de0d2bb35a$export$f883a24d5edde77c;
}
function $22c5be3317ad81f4$export$c68d65f9148da196(options) {
    let resolutionConstraint;
    let maxResolution;
    let minResolution;
    // TODO: move these to be ol constants
    // see https://github.com/openlayers/openlayers/issues/2076
    const defaultMaxZoom = 28;
    const defaultZoomFactor = 2;
    let minZoom = options.minZoom !== undefined ? options.minZoom : $22c5be3317ad81f4$var$DEFAULT_MIN_ZOOM;
    let maxZoom = options.maxZoom !== undefined ? options.maxZoom : defaultMaxZoom;
    const zoomFactor = options.zoomFactor !== undefined ? options.zoomFactor : defaultZoomFactor;
    const multiWorld = options.multiWorld !== undefined ? options.multiWorld : false;
    const smooth = options.smoothResolutionConstraint !== undefined ? options.smoothResolutionConstraint : true;
    const showFullExtent = options.showFullExtent !== undefined ? options.showFullExtent : false;
    const projection = (0, $a86eee1c28205a05$export$549167224996a0fb)(options.projection, 'EPSG:3857');
    const projExtent = projection.getExtent();
    let constrainOnlyCenter = options.constrainOnlyCenter;
    let extent = options.extent;
    if (!multiWorld && !extent && projection.isGlobal()) {
        constrainOnlyCenter = false;
        extent = projExtent;
    }
    if (options.resolutions !== undefined) {
        const resolutions = options.resolutions;
        maxResolution = resolutions[minZoom];
        minResolution = resolutions[maxZoom] !== undefined ? resolutions[maxZoom] : resolutions[resolutions.length - 1];
        if (options.constrainResolution) resolutionConstraint = (0, $3a0ff1177a518ee8$export$d65a517690fc4385)(resolutions, smooth, !constrainOnlyCenter && extent, showFullExtent);
        else resolutionConstraint = (0, $3a0ff1177a518ee8$export$1c4e6da9b4b066fe)(maxResolution, minResolution, smooth, !constrainOnlyCenter && extent, showFullExtent);
    } else {
        // calculate the default min and max resolution
        const size = !projExtent ? 360 * (0, $9149a5943443441b$export$1482081eec883108).degrees / projection.getMetersPerUnit() : Math.max((0, $dea65c2f666fa450$export$3c49c185de0c2bfc)(projExtent), (0, $dea65c2f666fa450$export$c08559766941f856)(projExtent));
        const defaultMaxResolution = size / (0, $8d38b00f56572d28$export$6b8cb5cd370bd90c) / Math.pow(defaultZoomFactor, $22c5be3317ad81f4$var$DEFAULT_MIN_ZOOM);
        const defaultMinResolution = defaultMaxResolution / Math.pow(defaultZoomFactor, defaultMaxZoom - $22c5be3317ad81f4$var$DEFAULT_MIN_ZOOM);
        // user provided maxResolution takes precedence
        maxResolution = options.maxResolution;
        if (maxResolution !== undefined) minZoom = 0;
        else maxResolution = defaultMaxResolution / Math.pow(zoomFactor, minZoom);
        // user provided minResolution takes precedence
        minResolution = options.minResolution;
        if (minResolution === undefined) {
            if (options.maxZoom !== undefined) {
                if (options.maxResolution !== undefined) minResolution = maxResolution / Math.pow(zoomFactor, maxZoom);
                else minResolution = defaultMaxResolution / Math.pow(zoomFactor, maxZoom);
            } else minResolution = defaultMinResolution;
        }
        // given discrete zoom levels, minResolution may be different than provided
        maxZoom = minZoom + Math.floor(Math.log(maxResolution / minResolution) / Math.log(zoomFactor));
        minResolution = maxResolution / Math.pow(zoomFactor, maxZoom - minZoom);
        if (options.constrainResolution) resolutionConstraint = (0, $3a0ff1177a518ee8$export$22ac0f6b219de91a)(zoomFactor, maxResolution, minResolution, smooth, !constrainOnlyCenter && extent, showFullExtent);
        else resolutionConstraint = (0, $3a0ff1177a518ee8$export$1c4e6da9b4b066fe)(maxResolution, minResolution, smooth, !constrainOnlyCenter && extent, showFullExtent);
    }
    return {
        constraint: resolutionConstraint,
        maxResolution: maxResolution,
        minResolution: minResolution,
        minZoom: minZoom,
        zoomFactor: zoomFactor
    };
}
function $22c5be3317ad81f4$export$4eeaa08dd550e3c0(options) {
    const enableRotation = options.enableRotation !== undefined ? options.enableRotation : true;
    if (enableRotation) {
        const constrainRotation = options.constrainRotation;
        if (constrainRotation === undefined || constrainRotation === true) return (0, $a4b2c7f4b045b17d$export$17a6e6f3448b17e8)();
        if (constrainRotation === false) return 0, $a4b2c7f4b045b17d$export$f883a24d5edde77c;
        if (typeof constrainRotation === 'number') return (0, $a4b2c7f4b045b17d$export$9ba78806de831083)(constrainRotation);
        return 0, $a4b2c7f4b045b17d$export$f883a24d5edde77c;
    }
    return 0, $a4b2c7f4b045b17d$export$e20fbacbb41798b;
}
function $22c5be3317ad81f4$export$ee75376562060184(animation) {
    if (animation.sourceCenter && animation.targetCenter) {
        if (!(0, $a6adb03fd2fbc071$export$e9bab7fafb253603)(animation.sourceCenter, animation.targetCenter)) return false;
    }
    if (animation.sourceResolution !== animation.targetResolution) return false;
    if (animation.sourceRotation !== animation.targetRotation) return false;
    return true;
}
/**
 * @param {import("./coordinate.js").Coordinate} coordinate Coordinate.
 * @param {import("./size.js").Size} size Box pixel size.
 * @param {import("./pixel.js").Pixel} position Position on the view to center on.
 * @param {number} resolution Resolution.
 * @param {number} rotation Rotation.
 * @return {import("./coordinate.js").Coordinate} Shifted center.
 */ function $22c5be3317ad81f4$var$calculateCenterOn(coordinate, size, position, resolution, rotation) {
    // calculate rotated position
    const cosAngle = Math.cos(-rotation);
    let sinAngle = Math.sin(-rotation);
    let rotX = coordinate[0] * cosAngle - coordinate[1] * sinAngle;
    let rotY = coordinate[1] * cosAngle + coordinate[0] * sinAngle;
    rotX += (size[0] / 2 - position[0]) * resolution;
    rotY += (position[1] - size[1] / 2) * resolution;
    // go back to original angle
    sinAngle = -sinAngle; // go back to original rotation
    const centerX = rotX * cosAngle - rotY * sinAngle;
    const centerY = rotY * cosAngle + rotX * sinAngle;
    return [
        centerX,
        centerY
    ];
}
var $22c5be3317ad81f4$export$2e2bcd8739ae039 = $22c5be3317ad81f4$var$View;
function $22c5be3317ad81f4$export$c25fb981a0c5b500(num) {
    return function(options) {
        if (!options.resolutions) return options;
        const resolutions = [
            ...options.resolutions
        ];
        const highest = resolutions[resolutions.length - 1];
        for(let i = 0; i < num; ++i)resolutions.push(highest / Math.pow(2, i + 1));
        return {
            ...options,
            resolutions: resolutions
        };
    };
}
function $22c5be3317ad81f4$export$bd7c975990ce76fa(num) {
    return function(options) {
        if (!options.resolutions) return options;
        const resolutions = [
            ...options.resolutions
        ];
        const lowest = resolutions[0];
        for(let i = 0; i < num; ++i)resolutions.unshift(lowest * Math.pow(2, i + 1));
        return {
            ...options,
            resolutions: resolutions
        };
    };
}
function $22c5be3317ad81f4$export$fa18f70fef5f1fab() {
    return function(options) {
        if (!options.extent) return options;
        const center = (0, $dea65c2f666fa450$export$c91255cadecfe081)(options.extent);
        const newOptions = {
            ...options,
            center: center
        };
        delete newOptions.extent;
        return newOptions;
    };
}
function $22c5be3317ad81f4$export$c8cdb1d588f29e82(z) {
    return function(options) {
        return {
            ...options,
            zoom: z
        };
    };
}
async function $22c5be3317ad81f4$export$513f42987b822fd7(source, ...transforms) {
    let config = await source.getView();
    for (const transform of transforms)config = transform(config);
    return config;
}







/**
 * @module ol/layer/Base
 */ 



/**
 * @module ol/layer/Property
 */ /**
 * @enum {string}
 */ var $93fc7a17d61ebb75$export$2e2bcd8739ae039 = {
    OPACITY: 'opacity',
    VISIBLE: 'visible',
    EXTENT: 'extent',
    Z_INDEX: 'zIndex',
    MAX_RESOLUTION: 'maxResolution',
    MIN_RESOLUTION: 'minResolution',
    MAX_ZOOM: 'maxZoom',
    MIN_ZOOM: 'minZoom',
    SOURCE: 'source',
    MAP: 'map'
};


/**
 * A css color, or a function called with a view resolution returning a css color.
 *
 * @typedef {string|function(number):string} BackgroundColor
 * @api
 */ /**
 * @typedef {import("../ObjectEventType").Types|'change:extent'|'change:maxResolution'|'change:maxZoom'|
 *    'change:minResolution'|'change:minZoom'|'change:opacity'|'change:visible'|'change:zIndex'} BaseLayerObjectEventTypes
 */ /***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<BaseLayerObjectEventTypes, import("../Object").ObjectEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|BaseLayerObjectEventTypes, Return>} BaseLayerOnSignature
 */ /**
 * @template {Object<string, *>} [Properties=Object<string, *>]
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number | undefined} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {BackgroundColor} [background] Background color for the layer. If not specified, no background
 * will be rendered.
 * @property {Properties} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Note that with {@link module:ol/layer/Base~BaseLayer} and all its subclasses, any property set in
 * the options is set as a {@link module:ol/Object~BaseObject} property on the layer object, so
 * is observable, and has get/set accessors.
 *
 * @api
 * @template {Object<string, *>} [Properties=Object<string, *>]
 * @extends {BaseObject<NoInfer<Properties> & Object<string, *>>}
 */ class $499e541616b1f6f1$var$BaseLayer extends (0, $4862cdcc23257f5b$export$2e2bcd8739ae039) {
    /**
   * @param {Options<NoInfer<Properties>>} options Layer options.
   */ constructor(options){
        super();
        /***
     * @type {BaseLayerOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {BaseLayerOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {BaseLayerOnSignature<void>}
     */ this.un;
        /**
     * @type {BackgroundColor|false}
     * @private
     */ this.background_ = options.background;
        /**
     * @type {?}
     */ const properties = Object.assign({}, options);
        if (typeof options.properties === 'object') {
            delete properties.properties;
            Object.assign(properties, options.properties);
        }
        properties[(0, $93fc7a17d61ebb75$export$2e2bcd8739ae039).OPACITY] = options.opacity !== undefined ? options.opacity : 1;
        (0, $71eb897bda873684$export$a7a9523472993e97)(typeof properties[(0, $93fc7a17d61ebb75$export$2e2bcd8739ae039).OPACITY] === 'number', 'Layer opacity must be a number');
        properties[(0, $93fc7a17d61ebb75$export$2e2bcd8739ae039).VISIBLE] = options.visible !== undefined ? options.visible : true;
        properties[(0, $93fc7a17d61ebb75$export$2e2bcd8739ae039).Z_INDEX] = options.zIndex;
        properties[(0, $93fc7a17d61ebb75$export$2e2bcd8739ae039).MAX_RESOLUTION] = options.maxResolution !== undefined ? options.maxResolution : Infinity;
        properties[(0, $93fc7a17d61ebb75$export$2e2bcd8739ae039).MIN_RESOLUTION] = options.minResolution !== undefined ? options.minResolution : 0;
        properties[(0, $93fc7a17d61ebb75$export$2e2bcd8739ae039).MIN_ZOOM] = options.minZoom !== undefined ? options.minZoom : -Infinity;
        properties[(0, $93fc7a17d61ebb75$export$2e2bcd8739ae039).MAX_ZOOM] = options.maxZoom !== undefined ? options.maxZoom : Infinity;
        /**
     * @type {string}
     * @private
     */ this.className_ = properties.className !== undefined ? properties.className : 'ol-layer';
        delete properties.className;
        this.setProperties(properties);
        /**
     * @type {import("./Layer.js").State}
     * @private
     */ this.state_ = null;
    }
    /**
   * Get the background for this layer.
   * @return {BackgroundColor|false} Layer background.
   */ getBackground() {
        return this.background_;
    }
    /**
   * @return {string} CSS class name.
   */ getClassName() {
        return this.className_;
    }
    /**
   * This method is not meant to be called by layers or layer renderers because the state
   * is incorrect if the layer is included in a layer group.
   *
   * @param {boolean} [managed] Layer is managed.
   * @return {import("./Layer.js").State} Layer state.
   */ getLayerState(managed) {
        /** @type {import("./Layer.js").State} */ const state = this.state_ || /** @type {?} */ {
            layer: this,
            managed: managed === undefined ? true : managed
        };
        const zIndex = this.getZIndex();
        state.opacity = (0, $6a95bd76d7103f37$export$7d15b64cf5a3a4c4)(Math.round(this.getOpacity() * 100) / 100, 0, 1);
        state.visible = this.getVisible();
        state.extent = this.getExtent();
        state.zIndex = zIndex === undefined && !state.managed ? Infinity : zIndex;
        state.maxResolution = this.getMaxResolution();
        state.minResolution = Math.max(this.getMinResolution(), 0);
        state.minZoom = this.getMinZoom();
        state.maxZoom = this.getMaxZoom();
        this.state_ = state;
        return state;
    }
    /**
   * @abstract
   * @param {Array<import("./Layer.js").default>} [array] Array of layers (to be
   *     modified in place).
   * @return {Array<import("./Layer.js").default>} Array of layers.
   */ getLayersArray(array) {
        return (0, $fd76d391cc228565$export$817eb92a8194bab0)();
    }
    /**
   * @abstract
   * @param {Array<import("./Layer.js").State>} [states] Optional list of layer
   *     states (to be modified in place).
   * @return {Array<import("./Layer.js").State>} List of layer states.
   */ getLayerStatesArray(states) {
        return (0, $fd76d391cc228565$export$817eb92a8194bab0)();
    }
    /**
   * Return the {@link module:ol/extent~Extent extent} of the layer or `undefined` if it
   * will be visible regardless of extent.
   * @return {import("../extent.js").Extent|undefined} The layer extent.
   * @observable
   * @api
   */ getExtent() {
        return /** @type {import("../extent.js").Extent|undefined} */ this.get((0, $93fc7a17d61ebb75$export$2e2bcd8739ae039).EXTENT);
    }
    /**
   * Return the maximum resolution of the layer. Returns Infinity if
   * the layer has no maximum resolution set.
   * @return {number} The maximum resolution of the layer.
   * @observable
   * @api
   */ getMaxResolution() {
        return /** @type {number} */ this.get((0, $93fc7a17d61ebb75$export$2e2bcd8739ae039).MAX_RESOLUTION);
    }
    /**
   * Return the minimum resolution of the layer. Returns 0 if
   * the layer has no minimum resolution set.
   * @return {number} The minimum resolution of the layer.
   * @observable
   * @api
   */ getMinResolution() {
        return /** @type {number} */ this.get((0, $93fc7a17d61ebb75$export$2e2bcd8739ae039).MIN_RESOLUTION);
    }
    /**
   * Return the minimum zoom level of the layer. Returns -Infinity if
   * the layer has no minimum zoom set.
   * @return {number} The minimum zoom level of the layer.
   * @observable
   * @api
   */ getMinZoom() {
        return /** @type {number} */ this.get((0, $93fc7a17d61ebb75$export$2e2bcd8739ae039).MIN_ZOOM);
    }
    /**
   * Return the maximum zoom level of the layer. Returns Infinity if
   * the layer has no maximum zoom set.
   * @return {number} The maximum zoom level of the layer.
   * @observable
   * @api
   */ getMaxZoom() {
        return /** @type {number} */ this.get((0, $93fc7a17d61ebb75$export$2e2bcd8739ae039).MAX_ZOOM);
    }
    /**
   * Return the opacity of the layer (between 0 and 1).
   * @return {number} The opacity of the layer.
   * @observable
   * @api
   */ getOpacity() {
        return /** @type {number} */ this.get((0, $93fc7a17d61ebb75$export$2e2bcd8739ae039).OPACITY);
    }
    /**
   * @abstract
   * @return {import("../source/Source.js").State} Source state.
   */ getSourceState() {
        return (0, $fd76d391cc228565$export$817eb92a8194bab0)();
    }
    /**
   * Return the value of this layer's `visible` property. To find out whether the layer
   * is visible on a map, use `isVisible()` instead.
   * @return {boolean} The value of the `visible` property of the layer.
   * @observable
   * @api
   */ getVisible() {
        return /** @type {boolean} */ this.get((0, $93fc7a17d61ebb75$export$2e2bcd8739ae039).VISIBLE);
    }
    /**
   * Return the Z-index of the layer, which is used to order layers before
   * rendering. Returns undefined if the layer is unmanaged.
   * @return {number|undefined} The Z-index of the layer.
   * @observable
   * @api
   */ getZIndex() {
        return /** @type {number|undefined} */ this.get((0, $93fc7a17d61ebb75$export$2e2bcd8739ae039).Z_INDEX);
    }
    /**
   * Sets the background color.
   * @param {BackgroundColor} [background] Background color.
   */ setBackground(background) {
        this.background_ = background;
        this.changed();
    }
    /**
   * Set the extent at which the layer is visible.  If `undefined`, the layer
   * will be visible at all extents.
   * @param {import("../extent.js").Extent|undefined} extent The extent of the layer.
   * @observable
   * @api
   */ setExtent(extent) {
        this.set((0, $93fc7a17d61ebb75$export$2e2bcd8739ae039).EXTENT, extent);
    }
    /**
   * Set the maximum resolution at which the layer is visible.
   * @param {number} maxResolution The maximum resolution of the layer.
   * @observable
   * @api
   */ setMaxResolution(maxResolution) {
        this.set((0, $93fc7a17d61ebb75$export$2e2bcd8739ae039).MAX_RESOLUTION, maxResolution);
    }
    /**
   * Set the minimum resolution at which the layer is visible.
   * @param {number} minResolution The minimum resolution of the layer.
   * @observable
   * @api
   */ setMinResolution(minResolution) {
        this.set((0, $93fc7a17d61ebb75$export$2e2bcd8739ae039).MIN_RESOLUTION, minResolution);
    }
    /**
   * Set the maximum zoom (exclusive) at which the layer is visible.
   * Note that the zoom levels for layer visibility are based on the
   * view zoom level, which may be different from a tile source zoom level.
   * @param {number} maxZoom The maximum zoom of the layer.
   * @observable
   * @api
   */ setMaxZoom(maxZoom) {
        this.set((0, $93fc7a17d61ebb75$export$2e2bcd8739ae039).MAX_ZOOM, maxZoom);
    }
    /**
   * Set the minimum zoom (inclusive) at which the layer is visible.
   * Note that the zoom levels for layer visibility are based on the
   * view zoom level, which may be different from a tile source zoom level.
   * @param {number} minZoom The minimum zoom of the layer.
   * @observable
   * @api
   */ setMinZoom(minZoom) {
        this.set((0, $93fc7a17d61ebb75$export$2e2bcd8739ae039).MIN_ZOOM, minZoom);
    }
    /**
   * Set the opacity of the layer, allowed values range from 0 to 1.
   * @param {number} opacity The opacity of the layer.
   * @observable
   * @api
   */ setOpacity(opacity) {
        (0, $71eb897bda873684$export$a7a9523472993e97)(typeof opacity === 'number', 'Layer opacity must be a number');
        this.set((0, $93fc7a17d61ebb75$export$2e2bcd8739ae039).OPACITY, opacity);
    }
    /**
   * Set the visibility of the layer (`true` or `false`).
   * @param {boolean} visible The visibility of the layer.
   * @observable
   * @api
   */ setVisible(visible) {
        this.set((0, $93fc7a17d61ebb75$export$2e2bcd8739ae039).VISIBLE, visible);
    }
    /**
   * Set Z-index of the layer, which is used to order layers before rendering.
   * The default Z-index is 0.
   * @param {number} zindex The z-index of the layer.
   * @observable
   * @api
   */ setZIndex(zindex) {
        this.set((0, $93fc7a17d61ebb75$export$2e2bcd8739ae039).Z_INDEX, zindex);
    }
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        if (this.state_) {
            this.state_.layer = null;
            this.state_ = null;
        }
        super.disposeInternal();
    }
}
var $499e541616b1f6f1$export$2e2bcd8739ae039 = $499e541616b1f6f1$var$BaseLayer;



/**
 * @typedef {function(import("../Map.js").FrameState):HTMLElement} RenderFunction
 */ /**
 * @typedef {'sourceready'|'change:source'} LayerEventType
 */ /***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("./Base").BaseLayerObjectEventTypes|
 *     LayerEventType, import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<import("../render/EventType").LayerRenderEventTypes, import("../render/Event").default, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("./Base").BaseLayerObjectEventTypes|LayerEventType|
 *     import("../render/EventType").LayerRenderEventTypes, Return>} LayerOnSignature
 */ /**
 * @template {import("../source/Source.js").default} [SourceType=import("../source/Source.js").default]
 * @template {Object<string, *>} [Properties=Object<string, *>]
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {SourceType} [source] Source for this layer.  If not provided to the constructor,
 * the source can be set by calling {@link module:ol/layer/Layer~Layer#setSource layer.setSource(source)} after
 * construction.
 * @property {import("../Map.js").default|null} [map] Map.
 * @property {RenderFunction} [render] Render function. Takes the frame state as input and is expected to return an
 * HTML element. Will overwrite the default rendering for the layer.
 * @property {Properties} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */ /**
 * @typedef {Object} State
 * @property {import("./Layer.js").default} layer Layer.
 * @property {number} opacity Opacity, the value is rounded to two digits to appear after the decimal point.
 * @property {boolean} visible Visible.
 * @property {boolean} managed Managed.
 * @property {import("../extent.js").Extent} [extent] Extent.
 * @property {number} zIndex ZIndex.
 * @property {number} maxResolution Maximum resolution.
 * @property {number} minResolution Minimum resolution.
 * @property {number} minZoom Minimum zoom.
 * @property {number} maxZoom Maximum zoom.
 */ /**
 * @classdesc
 * Base class from which all layer types are derived. This should only be instantiated
 * in the case where a custom layer is added to the map with a custom `render` function.
 * Such a function can be specified in the `options` object, and is expected to return an HTML element.
 *
 * A visual representation of raster or vector map data.
 * Layers group together those properties that pertain to how the data is to be
 * displayed, irrespective of the source of that data.
 *
 * Layers are usually added to a map with [map.addLayer()]{@link import("../Map.js").default#addLayer}.
 * Components like {@link module:ol/interaction/Draw~Draw} use unmanaged layers
 * internally. These unmanaged layers are associated with the map using
 * [layer.setMap()]{@link module:ol/layer/Layer~Layer#setMap} instead.
 *
 * A generic `change` event is fired when the state of the source changes.
 * A `sourceready` event is fired when the layer's source is ready.
 *
 * @fires import("../render/Event.js").RenderEvent#prerender
 * @fires import("../render/Event.js").RenderEvent#postrender
 * @fires import("../events/Event.js").BaseEvent#sourceready
 *
 * @template {import("../source/Source.js").default} [SourceType=import("../source/Source.js").default]
 * @template {import("../renderer/Layer.js").default} [RendererType=import("../renderer/Layer.js").default]
 * @template {Object<string, *>} [Properties=Object<string, *>]
 * @extends {BaseLayer<NoInfer<Properties>>}
 * @api
 */ class $af81f8f05dcf2037$var$Layer extends (0, $499e541616b1f6f1$export$2e2bcd8739ae039) {
    /**
   * @param {Options<SourceType, NoInfer<Properties>>} options Layer options.
   */ constructor(options){
        const baseOptions = Object.assign({}, options);
        delete baseOptions.source;
        super(baseOptions);
        /***
     * @type {LayerOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {LayerOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {LayerOnSignature<void>}
     */ this.un;
        /**
     * @private
     * @type {?import("../events.js").EventsKey}
     */ this.mapPrecomposeKey_ = null;
        /**
     * @private
     * @type {?import("../events.js").EventsKey}
     */ this.mapRenderKey_ = null;
        /**
     * @private
     * @type {?import("../events.js").EventsKey}
     */ this.sourceChangeKey_ = null;
        /**
     * @private
     * @type {RendererType}
     */ this.renderer_ = null;
        /**
     * @private
     * @type {boolean}
     */ this.sourceReady_ = false;
        /**
     * @protected
     * @type {boolean}
     */ this.rendered = false;
        // Overwrite default render method with a custom one
        if (options.render) this.render = options.render;
        if (options.map) this.setMap(options.map);
        this.addChangeListener((0, $93fc7a17d61ebb75$export$2e2bcd8739ae039).SOURCE, this.handleSourcePropertyChange_);
        const source = options.source ? /** @type {SourceType} */ options.source : null;
        this.setSource(source);
    }
    /**
   * @param {Array<import("./Layer.js").default>} [array] Array of layers (to be modified in place).
   * @return {Array<import("./Layer.js").default>} Array of layers.
   * @override
   */ getLayersArray(array) {
        array = array ? array : [];
        array.push(this);
        return array;
    }
    /**
   * @param {Array<import("./Layer.js").State>} [states] Optional list of layer states (to be modified in place).
   * @return {Array<import("./Layer.js").State>} List of layer states.
   * @override
   */ getLayerStatesArray(states) {
        states = states ? states : [];
        states.push(this.getLayerState());
        return states;
    }
    /**
   * Get the layer source.
   * @return {SourceType|null} The layer source (or `null` if not yet set).
   * @observable
   * @api
   */ getSource() {
        return /** @type {SourceType} */ this.get((0, $93fc7a17d61ebb75$export$2e2bcd8739ae039).SOURCE) || null;
    }
    /**
   * @return {SourceType|null} The source being rendered.
   */ getRenderSource() {
        return this.getSource();
    }
    /**
   * @return {import("../source/Source.js").State} Source state.
   * @override
   */ getSourceState() {
        const source = this.getSource();
        return !source ? 'undefined' : source.getState();
    }
    /**
   * @private
   */ handleSourceChange_() {
        this.changed();
        if (this.sourceReady_ || this.getSource().getState() !== 'ready') return;
        this.sourceReady_ = true;
        this.dispatchEvent('sourceready');
    }
    /**
   * @private
   */ handleSourcePropertyChange_() {
        if (this.sourceChangeKey_) {
            (0, $63963d09e0c49405$export$b0a21c8b3c1c921)(this.sourceChangeKey_);
            this.sourceChangeKey_ = null;
        }
        this.sourceReady_ = false;
        const source = this.getSource();
        if (source) {
            this.sourceChangeKey_ = (0, $63963d09e0c49405$export$63174c828edd6ff8)(source, (0, $b5fa963342da4935$export$2e2bcd8739ae039).CHANGE, this.handleSourceChange_, this);
            if (source.getState() === 'ready') {
                this.sourceReady_ = true;
                setTimeout(()=>{
                    this.dispatchEvent('sourceready');
                }, 0);
            }
        }
        this.changed();
    }
    /**
   * @param {import("../pixel").Pixel} pixel Pixel.
   * @return {Promise<Array<import("../Feature").FeatureLike>>} Promise that resolves with
   * an array of features.
   */ getFeatures(pixel) {
        if (!this.renderer_) return Promise.resolve([]);
        return this.renderer_.getFeatures(pixel);
    }
    /**
   * @param {import("../pixel").Pixel} pixel Pixel.
   * @return {Uint8ClampedArray|Uint8Array|Float32Array|DataView|null} Pixel data.
   */ getData(pixel) {
        if (!this.renderer_ || !this.rendered) return null;
        return this.renderer_.getData(pixel);
    }
    /**
   * The layer is visible on the map view, i.e. within its min/max resolution or zoom and
   * extent, not set to `visible: false`, and not inside a layer group that is set
   * to `visible: false`.
   * @param {View|import("../View.js").ViewStateLayerStateExtent} [view] View or {@link import("../Map.js").FrameState}.
   * Only required when the layer is not added to a map.
   * @return {boolean} The layer is visible in the map view.
   * @api
   */ isVisible(view) {
        let frameState;
        const map = this.getMapInternal();
        if (!view && map) view = map.getView();
        if (view instanceof (0, $22c5be3317ad81f4$export$2e2bcd8739ae039)) frameState = {
            viewState: view.getState(),
            extent: view.calculateExtent()
        };
        else frameState = view;
        if (!frameState.layerStatesArray && map) frameState.layerStatesArray = map.getLayerGroup().getLayerStatesArray();
        let layerState;
        if (frameState.layerStatesArray) {
            layerState = frameState.layerStatesArray.find((layerState)=>layerState.layer === this);
            if (!layerState) return false;
        } else layerState = this.getLayerState();
        const layerExtent = this.getExtent();
        return $af81f8f05dcf2037$export$acb1e9cb9ce4ca56(layerState, frameState.viewState) && (!layerExtent || (0, $dea65c2f666fa450$export$7b0a31e10bbff018)(layerExtent, frameState.extent));
    }
    /**
   * Get the attributions of the source of this layer for the given view.
   * @param {View|import("../View.js").ViewStateLayerStateExtent} [view] View or {@link import("../Map.js").FrameState}.
   * Only required when the layer is not added to a map.
   * @return {Array<string>} Attributions for this layer at the given view.
   * @api
   */ getAttributions(view) {
        if (!this.isVisible(view)) return [];
        const getAttributions = this.getSource()?.getAttributions();
        if (!getAttributions) return [];
        const frameState = view instanceof (0, $22c5be3317ad81f4$export$2e2bcd8739ae039) ? view.getViewStateAndExtent() : view;
        let attributions = getAttributions(frameState);
        if (!Array.isArray(attributions)) attributions = [
            attributions
        ];
        return attributions;
    }
    /**
   * In charge to manage the rendering of the layer. One layer type is
   * bounded with one layer renderer.
   * @param {?import("../Map.js").FrameState} frameState Frame state.
   * @param {HTMLElement} target Target which the renderer may (but need not) use
   * for rendering its content.
   * @return {HTMLElement|null} The rendered element.
   */ render(frameState, target) {
        const layerRenderer = this.getRenderer();
        if (layerRenderer.prepareFrame(frameState)) {
            this.rendered = true;
            return layerRenderer.renderFrame(frameState, target);
        }
        return null;
    }
    /**
   * Called when a layer is not visible during a map render.
   */ unrender() {
        this.rendered = false;
    }
    /** @return {string} Declutter */ getDeclutter() {
        return undefined;
    }
    /**
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @param {import("../layer/Layer.js").State} layerState Layer state.
   */ renderDeclutter(frameState, layerState) {}
    /**
   * When the renderer follows a layout -> render approach, do the final rendering here.
   * @param {import('../Map.js').FrameState} frameState Frame state
   */ renderDeferred(frameState) {
        const layerRenderer = this.getRenderer();
        if (!layerRenderer) return;
        layerRenderer.renderDeferred(frameState);
    }
    /**
   * For use inside the library only.
   * @param {import("../Map.js").default|null} map Map.
   */ setMapInternal(map) {
        if (!map) this.unrender();
        this.set((0, $93fc7a17d61ebb75$export$2e2bcd8739ae039).MAP, map);
    }
    /**
   * For use inside the library only.
   * @return {import("../Map.js").default|null} Map.
   */ getMapInternal() {
        return this.get((0, $93fc7a17d61ebb75$export$2e2bcd8739ae039).MAP);
    }
    /**
   * Sets the layer to be rendered on top of other layers on a map. The map will
   * not manage this layer in its layers collection. This
   * is useful for temporary layers. To remove an unmanaged layer from the map,
   * use `#setMap(null)`.
   *
   * To add the layer to a map and have it managed by the map, use
   * {@link module:ol/Map~Map#addLayer} instead.
   * @param {import("../Map.js").default|null} map Map.
   * @api
   */ setMap(map) {
        if (this.mapPrecomposeKey_) {
            (0, $63963d09e0c49405$export$b0a21c8b3c1c921)(this.mapPrecomposeKey_);
            this.mapPrecomposeKey_ = null;
        }
        if (!map) this.changed();
        if (this.mapRenderKey_) {
            (0, $63963d09e0c49405$export$b0a21c8b3c1c921)(this.mapRenderKey_);
            this.mapRenderKey_ = null;
        }
        if (map) {
            this.mapPrecomposeKey_ = (0, $63963d09e0c49405$export$63174c828edd6ff8)(map, (0, $6e54630f610adff4$export$2e2bcd8739ae039).PRECOMPOSE, this.handlePrecompose_, this);
            this.mapRenderKey_ = (0, $63963d09e0c49405$export$63174c828edd6ff8)(this, (0, $b5fa963342da4935$export$2e2bcd8739ae039).CHANGE, map.render, map);
            this.changed();
        }
    }
    /**
   * @param {import("../events/Event.js").default} renderEvent Render event
   * @private
   */ handlePrecompose_(renderEvent) {
        const layerStatesArray = /** @type {import("../render/Event.js").default} */ renderEvent.frameState.layerStatesArray;
        const layerState = this.getLayerState(false);
        (0, $71eb897bda873684$export$a7a9523472993e97)(!layerStatesArray.some((arrayLayerState)=>arrayLayerState.layer === layerState.layer), 'A layer can only be added to the map once. Use either `layer.setMap()` or `map.addLayer()`, not both.');
        layerStatesArray.push(layerState);
    }
    /**
   * Set the layer source.
   * @param {SourceType|null} source The layer source.
   * @observable
   * @api
   */ setSource(source) {
        this.set((0, $93fc7a17d61ebb75$export$2e2bcd8739ae039).SOURCE, source);
    }
    /**
   * Get the renderer for this layer.
   * @return {RendererType|null} The layer renderer.
   */ getRenderer() {
        if (!this.renderer_) this.renderer_ = this.createRenderer();
        return this.renderer_;
    }
    /**
   * @return {boolean} The layer has a renderer.
   */ hasRenderer() {
        return !!this.renderer_;
    }
    /**
   * Create a renderer for this layer.
   * @return {RendererType} A layer renderer.
   * @protected
   */ createRenderer() {
        return null;
    }
    /**
   * This will clear the renderer so that a new one can be created next time it is needed
   */ clearRenderer() {
        if (this.renderer_) {
            this.renderer_.dispose();
            delete this.renderer_;
        }
    }
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        this.clearRenderer();
        this.setSource(null);
        super.disposeInternal();
    }
}
function $af81f8f05dcf2037$export$acb1e9cb9ce4ca56(layerState, viewState) {
    if (!layerState.visible) return false;
    const resolution = viewState.resolution;
    if (resolution < layerState.minResolution || resolution >= layerState.maxResolution) return false;
    const zoom = viewState.zoom;
    return zoom > layerState.minZoom && zoom <= layerState.maxZoom;
}
var $af81f8f05dcf2037$export$2e2bcd8739ae039 = $af81f8f05dcf2037$var$Layer;


/**
 * @module ol/layer/TileProperty
 */ /**
 * @enum {string}
 */ var $4c090418ac8c5562$export$2e2bcd8739ae039 = {
    PRELOAD: 'preload',
    USE_INTERIM_TILES_ON_ERROR: 'useInterimTilesOnError'
};


/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("./Base").BaseLayerObjectEventTypes|
 *     import("./Layer.js").LayerEventType|'change:preload'|'change:useInterimTilesOnError', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<import("../render/EventType").LayerRenderEventTypes, import("../render/Event").default, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("./Base").BaseLayerObjectEventTypes|
 *   import("./Layer.js").LayerEventType|'change:preload'|'change:useInterimTilesOnError'|import("../render/EventType").LayerRenderEventTypes, Return>} BaseTileLayerOnSignature
 */ /**
 * @template {import("../source/Tile.js").default} TileSourceType
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {number} [preload=0] Preload. Load low-resolution tiles up to `preload` levels. `0`
 * means no preloading.
 * @property {TileSourceType} [source] Source for this layer.
 * @property {import("../Map.js").default} [map] Sets the layer as overlay on a map. The map will not manage
 * this layer in its layers collection, and the layer will be rendered on top. This is useful for
 * temporary layers. The standard way to add a layer to a map and have it managed by the map is to
 * use {@link import("../Map.js").default#addLayer map.addLayer()}.
 * @property {import("./Base.js").BackgroundColor} [background] Background color for the layer. If not specified, no background
 * will be rendered.
 * @property {boolean} [useInterimTilesOnError=true] Deprecated.  Use interim tiles on error.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 * @property {number} [cacheSize=512] The internal tile cache size.  This needs to be large enough to render
 * two zoom levels worth of tiles.
 */ /**
 * @classdesc
 * For layer sources that provide pre-rendered, tiled images in grids that are
 * organized by zoom levels for specific resolutions.
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @template {import("../source/Tile.js").default} TileSourceType
 * @template {import("../renderer/Layer.js").default} RendererType
 * @extends {Layer<TileSourceType, RendererType>}
 * @api
 */ class $246907f16f42fac2$var$BaseTileLayer extends (0, $af81f8f05dcf2037$export$2e2bcd8739ae039) {
    /**
   * @param {Options<TileSourceType>} [options] Tile layer options.
   */ constructor(options){
        options = options ? options : {};
        const baseOptions = Object.assign({}, options);
        const cacheSize = options.cacheSize;
        delete options.cacheSize;
        delete baseOptions.preload;
        delete baseOptions.useInterimTilesOnError;
        super(baseOptions);
        /***
     * @type {BaseTileLayerOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {BaseTileLayerOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {BaseTileLayerOnSignature<void>}
     */ this.un;
        /**
     * @type {number|undefined}
     * @private
     */ this.cacheSize_ = cacheSize;
        this.setPreload(options.preload !== undefined ? options.preload : 0);
        this.setUseInterimTilesOnError(options.useInterimTilesOnError !== undefined ? options.useInterimTilesOnError : true);
    }
    /**
   * @return {number|undefined} The suggested cache size
   * @protected
   */ getCacheSize() {
        return this.cacheSize_;
    }
    /**
   * Return the level as number to which we will preload tiles up to.
   * @return {number} The level to preload tiles up to.
   * @observable
   * @api
   */ getPreload() {
        return /** @type {number} */ this.get((0, $4c090418ac8c5562$export$2e2bcd8739ae039).PRELOAD);
    }
    /**
   * Set the level as number to which we will preload tiles up to.
   * @param {number} preload The level to preload tiles up to.
   * @observable
   * @api
   */ setPreload(preload) {
        this.set((0, $4c090418ac8c5562$export$2e2bcd8739ae039).PRELOAD, preload);
    }
    /**
   * Deprecated.  Whether we use interim tiles on error.
   * @return {boolean} Use interim tiles on error.
   * @observable
   * @api
   */ getUseInterimTilesOnError() {
        return /** @type {boolean} */ this.get((0, $4c090418ac8c5562$export$2e2bcd8739ae039).USE_INTERIM_TILES_ON_ERROR);
    }
    /**
   * Deprecated.  Set whether we use interim tiles on error.
   * @param {boolean} useInterimTilesOnError Use interim tiles on error.
   * @observable
   * @api
   */ setUseInterimTilesOnError(useInterimTilesOnError) {
        this.set((0, $4c090418ac8c5562$export$2e2bcd8739ae039).USE_INTERIM_TILES_ON_ERROR, useInterimTilesOnError);
    }
    /**
   * Get data for a pixel location.  The return type depends on the source data.  For image tiles,
   * a four element RGBA array will be returned.  For data tiles, the array length will match the
   * number of bands in the dataset.  For requests outside the layer extent, `null` will be returned.
   * Data for a image tiles can only be retrieved if the source's `crossOrigin` property is set.
   *
   * ```js
   * // display layer data on every pointer move
   * map.on('pointermove', (event) => {
   *   console.log(layer.getData(event.pixel));
   * });
   * ```
   * @param {import("../pixel").Pixel} pixel Pixel.
   * @return {Uint8ClampedArray|Uint8Array|Float32Array|DataView|null} Pixel data.
   * @api
   * @override
   */ getData(pixel) {
        return super.getData(pixel);
    }
}
var $246907f16f42fac2$export$2e2bcd8739ae039 = $246907f16f42fac2$var$BaseTileLayer;


/**
 * @classdesc
 * For layer sources that provide pre-rendered, tiled images in grids that are
 * organized by zoom levels for specific resolutions.
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @template {import("../source/Tile.js").default} [TileSourceType=import("../source/Tile.js").default]
 * @extends BaseTileLayer<TileSourceType, CanvasTileLayerRenderer>
 * @api
 */ class $db51b5c8e297e6ef$var$TileLayer extends (0, $246907f16f42fac2$export$2e2bcd8739ae039) {
    /**
   * @param {import("./BaseTile.js").Options<TileSourceType>} [options] Tile layer options.
   */ constructor(options){
        super(options);
    }
    /**
   * @override
   */ createRenderer() {
        return new (0, $f30d475df7f7c73d$export$2e2bcd8739ae039)(this, {
            cacheSize: this.getCacheSize()
        });
    }
}
var $db51b5c8e297e6ef$export$2e2bcd8739ae039 = $db51b5c8e297e6ef$var$TileLayer;


/**
 * @module ol/layer/Vector
 */ /**
 * @module ol/renderer/canvas/VectorLayer
 */ 






/**
 * @module ol/render/canvas/BuilderGroup
 */ /**
 * @module ol/render/canvas/Builder
 */ 
/**
 * @module ol/colorlike
 */ 


/**
 * @module ol/style/IconImage
 */ 





/**
 * @module ol/style/IconImageCache
 */ 


/**
 * @classdesc
 * Singleton class. Available through {@link module:ol/style/IconImageCache.shared}.
 */ class $3f062f3a3d0ff66a$var$IconImageCache {
    constructor(){
        /**
     * @type {!Object<string, import("./IconImage.js").default>}
     * @private
     */ this.cache_ = {};
        /**
     * @type {!Object<string, CanvasPattern>}
     * @private
     */ this.patternCache_ = {};
        /**
     * @type {number}
     * @private
     */ this.cacheSize_ = 0;
        /**
     * @type {number}
     * @private
     */ this.maxCacheSize_ = 1024;
    }
    /**
   * FIXME empty description for jsdoc
   */ clear() {
        this.cache_ = {};
        this.patternCache_ = {};
        this.cacheSize_ = 0;
    }
    /**
   * @return {boolean} Can expire cache.
   */ canExpireCache() {
        return this.cacheSize_ > this.maxCacheSize_;
    }
    /**
   * FIXME empty description for jsdoc
   */ expire() {
        if (this.canExpireCache()) {
            let i = 0;
            for(const key in this.cache_){
                const iconImage = this.cache_[key];
                if ((i++ & 3) === 0 && !iconImage.hasListener()) {
                    delete this.cache_[key];
                    delete this.patternCache_[key];
                    --this.cacheSize_;
                }
            }
        }
    }
    /**
   * @param {string} src Src.
   * @param {import("../color.js").Color|string|null} color Color.
   * @return {import("./IconImage.js").default} Icon image.
   */ get(src, color) {
        const key = $3f062f3a3d0ff66a$export$611736262b635f8d(src, color);
        const icon = key in this.cache_ ? this.cache_[key] : null;
        return icon;
    }
    /**
   * @param {string} src Src.
   * @param {import("../color.js").Color|string|null} color Color.
   * @return {CanvasPattern} Icon image.
   */ getPattern(src, color) {
        const key = $3f062f3a3d0ff66a$export$611736262b635f8d(src, color);
        return key in this.patternCache_ ? this.patternCache_[key] : null;
    }
    /**
   * @param {string} src Src.
   * @param {import("../color.js").Color|string|null} color Color.
   * @param {import("./IconImage.js").default|null} iconImage Icon image.
   * @param {boolean} [pattern] Also cache a `'repeat'` pattern with this `iconImage`.
   */ set(src, color, iconImage, pattern) {
        const key = $3f062f3a3d0ff66a$export$611736262b635f8d(src, color);
        const update = key in this.cache_;
        this.cache_[key] = iconImage;
        if (pattern) {
            if (iconImage.getImageState() === (0, $f217251b3f1483a0$export$2e2bcd8739ae039).IDLE) iconImage.load();
            if (iconImage.getImageState() === (0, $f217251b3f1483a0$export$2e2bcd8739ae039).LOADING) iconImage.ready().then(()=>{
                this.patternCache_[key] = (0, $b6f6d442e8ff57e1$export$fcb72ce088a6632c)().createPattern(iconImage.getImage(1), 'repeat');
            });
            else this.patternCache_[key] = (0, $b6f6d442e8ff57e1$export$fcb72ce088a6632c)().createPattern(iconImage.getImage(1), 'repeat');
        }
        if (!update) ++this.cacheSize_;
    }
    /**
   * Set the cache size of the icon cache. Default is `1024`. Change this value when
   * your map uses more than 1024 different icon images and you are not caching icon
   * styles on the application level.
   * @param {number} maxCacheSize Cache max size.
   * @api
   */ setSize(maxCacheSize) {
        this.maxCacheSize_ = maxCacheSize;
        this.expire();
    }
}
function $3f062f3a3d0ff66a$export$611736262b635f8d(src, color) {
    const colorString = color ? (0, $ebac9d8363fa165e$export$75093a47a9fa838d)(color) : 'null';
    return src + ':' + colorString;
}
var $3f062f3a3d0ff66a$export$2e2bcd8739ae039 = $3f062f3a3d0ff66a$var$IconImageCache;
const $3f062f3a3d0ff66a$export$747ccdf771a87ab8 = new $3f062f3a3d0ff66a$var$IconImageCache();


/**
 * @type {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D}
 */ let $671c623bccf16134$var$taintedTestContext = null;
class $671c623bccf16134$var$IconImage extends (0, $272b64a21016b61a$export$2e2bcd8739ae039) {
    /**
   * @param {HTMLImageElement|HTMLCanvasElement|OffscreenCanvas|ImageBitmap|null} image Image.
   * @param {string|undefined} src Src.
   * @param {import('../dom').ImageAttributes} imageAttributes Image attributes options.
   * @param {import("../ImageState.js").default|undefined} imageState Image state.
   * @param {import("../color.js").Color|string|null} color Color.
   */ constructor(image, src, imageAttributes, imageState, color){
        super();
        /**
     * @private
     * @type {HTMLImageElement|OffscreenCanvas|HTMLCanvasElement|ImageBitmap}
     */ this.hitDetectionImage_ = null;
        /**
     * @private
     * @type {HTMLImageElement|HTMLCanvasElement|OffscreenCanvas|ImageBitmap|null}
     */ this.image_ = image;
        /**
     * @private
     * @type {string|null}
     */ this.crossOrigin_ = imageAttributes?.crossOrigin;
        /**
     * @private
     * @type {ReferrerPolicy}
     */ this.referrerPolicy_ = imageAttributes?.referrerPolicy;
        /**
     * @private
     * @type {Object<number, HTMLCanvasElement|OffscreenCanvas>}
     */ this.canvas_ = {};
        /**
     * @private
     * @type {import("../color.js").Color|string|null}
     */ this.color_ = color;
        /**
     * @private
     * @type {import("../ImageState.js").default}
     */ this.imageState_ = imageState === undefined ? (0, $f217251b3f1483a0$export$2e2bcd8739ae039).IDLE : imageState;
        /**
     * @private
     * @type {import("../size.js").Size|null}
     */ this.size_ = image && image.width && image.height ? [
            image.width,
            image.height
        ] : null;
        /**
     * @private
     * @type {string|undefined}
     */ this.src_ = src;
        /**
     * @private
     */ this.tainted_;
        /**
     * @private
     * @type {Promise<void>|null}
     */ this.ready_ = null;
    }
    /**
   * @private
   */ initializeImage_() {
        this.image_ = new Image();
        if (this.crossOrigin_ !== null) this.image_.crossOrigin = this.crossOrigin_;
        if (this.referrerPolicy_ !== undefined) this.image_.referrerPolicy = this.referrerPolicy_;
    }
    /**
   * @private
   * @return {boolean} The image canvas is tainted.
   */ isTainted_() {
        if (this.tainted_ === undefined && this.imageState_ === (0, $f217251b3f1483a0$export$2e2bcd8739ae039).LOADED) {
            if (!$671c623bccf16134$var$taintedTestContext) $671c623bccf16134$var$taintedTestContext = (0, $b6f6d442e8ff57e1$export$9e05d10eae75c464)(1, 1, undefined, {
                willReadFrequently: true
            });
            $671c623bccf16134$var$taintedTestContext.drawImage(this.image_, 0, 0);
            try {
                $671c623bccf16134$var$taintedTestContext.getImageData(0, 0, 1, 1);
                this.tainted_ = false;
            } catch  {
                $671c623bccf16134$var$taintedTestContext = null;
                this.tainted_ = true;
            }
        }
        return this.tainted_ === true;
    }
    /**
   * @private
   */ dispatchChangeEvent_() {
        this.dispatchEvent((0, $b5fa963342da4935$export$2e2bcd8739ae039).CHANGE);
    }
    /**
   * @private
   */ handleImageError_() {
        this.imageState_ = (0, $f217251b3f1483a0$export$2e2bcd8739ae039).ERROR;
        this.dispatchChangeEvent_();
    }
    /**
   * @private
   */ handleImageLoad_() {
        this.imageState_ = (0, $f217251b3f1483a0$export$2e2bcd8739ae039).LOADED;
        this.size_ = [
            this.image_.width,
            this.image_.height
        ];
        this.dispatchChangeEvent_();
    }
    /**
   * @param {number} pixelRatio Pixel ratio.
   * @return {HTMLImageElement|HTMLCanvasElement|OffscreenCanvas|ImageBitmap} Image or Canvas element or image bitmap.
   */ getImage(pixelRatio) {
        if (!this.image_) this.initializeImage_();
        this.replaceColor_(pixelRatio);
        return this.canvas_[pixelRatio] ? this.canvas_[pixelRatio] : this.image_;
    }
    /**
   * @param {HTMLImageElement|HTMLCanvasElement|OffscreenCanvas|ImageBitmap} image Image.
   */ setImage(image) {
        this.image_ = image;
    }
    /**
   * @param {number} pixelRatio Pixel ratio.
   * @return {number} Image or Canvas element.
   */ getPixelRatio(pixelRatio) {
        this.replaceColor_(pixelRatio);
        return this.canvas_[pixelRatio] ? pixelRatio : 1;
    }
    /**
   * @return {import("../ImageState.js").default} Image state.
   */ getImageState() {
        return this.imageState_;
    }
    /**
   * @return {HTMLImageElement|HTMLCanvasElement|OffscreenCanvas|ImageBitmap} Image element.
   */ getHitDetectionImage() {
        if (!this.image_) this.initializeImage_();
        if (!this.hitDetectionImage_) {
            if (this.isTainted_()) {
                const width = this.size_[0];
                const height = this.size_[1];
                const context = (0, $b6f6d442e8ff57e1$export$9e05d10eae75c464)(width, height);
                context.fillRect(0, 0, width, height);
                this.hitDetectionImage_ = context.canvas;
            } else this.hitDetectionImage_ = this.image_;
        }
        return this.hitDetectionImage_;
    }
    /**
   * Get the size of the icon (in pixels).
   * @return {import("../size.js").Size} Image size.
   */ getSize() {
        return this.size_;
    }
    /**
   * @return {string|undefined} Image src.
   */ getSrc() {
        return this.src_;
    }
    /**
   * Load not yet loaded URI.
   */ load() {
        if (this.imageState_ !== (0, $f217251b3f1483a0$export$2e2bcd8739ae039).IDLE) return;
        if (!this.image_) this.initializeImage_();
        this.imageState_ = (0, $f217251b3f1483a0$export$2e2bcd8739ae039).LOADING;
        try {
            if (this.src_ !== undefined) /** @type {HTMLImageElement} */ this.image_.src = this.src_;
        } catch  {
            this.handleImageError_();
        }
        if (this.image_ instanceof HTMLImageElement) (0, $617ef54ed150e783$export$a9e5af241c1bd389)(this.image_, this.src_).then((image)=>{
            this.image_ = image;
            this.handleImageLoad_();
        }).catch(this.handleImageError_.bind(this));
    }
    /**
   * @param {number} pixelRatio Pixel ratio.
   * @private
   */ replaceColor_(pixelRatio) {
        if (!this.color_ || this.canvas_[pixelRatio] || this.imageState_ !== (0, $f217251b3f1483a0$export$2e2bcd8739ae039).LOADED) return;
        const image = this.image_;
        const ctx = (0, $b6f6d442e8ff57e1$export$9e05d10eae75c464)(Math.ceil(image.width * pixelRatio), Math.ceil(image.height * pixelRatio));
        const canvas = ctx.canvas;
        ctx.scale(pixelRatio, pixelRatio);
        ctx.drawImage(image, 0, 0);
        ctx.globalCompositeOperation = 'multiply';
        ctx.fillStyle = (0, $ebac9d8363fa165e$export$590567be997858b6)(this.color_);
        ctx.fillRect(0, 0, canvas.width / pixelRatio, canvas.height / pixelRatio);
        ctx.globalCompositeOperation = 'destination-in';
        ctx.drawImage(image, 0, 0);
        this.canvas_[pixelRatio] = canvas;
    }
    /**
   * @return {Promise<void>} Promise that resolves when the image is loaded.
   */ ready() {
        if (!this.ready_) this.ready_ = new Promise((resolve)=>{
            if (this.imageState_ === (0, $f217251b3f1483a0$export$2e2bcd8739ae039).LOADED || this.imageState_ === (0, $f217251b3f1483a0$export$2e2bcd8739ae039).ERROR) resolve();
            else {
                const onChange = ()=>{
                    if (this.imageState_ === (0, $f217251b3f1483a0$export$2e2bcd8739ae039).LOADED || this.imageState_ === (0, $f217251b3f1483a0$export$2e2bcd8739ae039).ERROR) {
                        this.removeEventListener((0, $b5fa963342da4935$export$2e2bcd8739ae039).CHANGE, onChange);
                        resolve();
                    }
                };
                this.addEventListener((0, $b5fa963342da4935$export$2e2bcd8739ae039).CHANGE, onChange);
            }
        });
        return this.ready_;
    }
}
function $671c623bccf16134$export$3988ae62b71be9a3(image, src, imageAttributes, imageState, color, pattern) {
    let iconImage = src === undefined ? undefined : (0, $3f062f3a3d0ff66a$export$747ccdf771a87ab8).get(src, color);
    if (!iconImage) {
        iconImage = new $671c623bccf16134$var$IconImage(image, image && 'src' in image ? image.src || undefined : src, imageAttributes, imageState, color);
        (0, $3f062f3a3d0ff66a$export$747ccdf771a87ab8).set(src, color, iconImage, pattern);
    }
    if (pattern && iconImage && !(0, $3f062f3a3d0ff66a$export$747ccdf771a87ab8).getPattern(src, color)) (0, $3f062f3a3d0ff66a$export$747ccdf771a87ab8).set(src, color, iconImage, pattern);
    return iconImage;
}
var $671c623bccf16134$export$2e2bcd8739ae039 = $671c623bccf16134$var$IconImage;



function $c236b40ac833efca$export$dc5b1400ac3a10a8(color) {
    if (!color) return null;
    if (Array.isArray(color)) return (0, $ebac9d8363fa165e$export$f84e8e69fd4488a5)(color);
    if (typeof color === 'object' && 'src' in color) return $c236b40ac833efca$var$asCanvasPattern(color);
    return color;
}
/**
 * @param {PatternDescriptor} pattern Pattern descriptor.
 * @return {CanvasPattern|null} Canvas pattern or null if the pattern referenced in the
 * PatternDescriptor was not found in the icon image cache.
 */ function $c236b40ac833efca$var$asCanvasPattern(pattern) {
    if (!pattern.offset || !pattern.size) return (0, $3f062f3a3d0ff66a$export$747ccdf771a87ab8).getPattern(pattern.src, pattern.color);
    const cacheKey = pattern.src + ':' + pattern.offset;
    const canvasPattern = (0, $3f062f3a3d0ff66a$export$747ccdf771a87ab8).getPattern(cacheKey, pattern.color);
    if (canvasPattern) return canvasPattern;
    const iconImage = (0, $3f062f3a3d0ff66a$export$747ccdf771a87ab8).get(pattern.src, null);
    if (iconImage.getImageState() !== (0, $f217251b3f1483a0$export$2e2bcd8739ae039).LOADED) return null;
    const patternCanvasContext = (0, $b6f6d442e8ff57e1$export$9e05d10eae75c464)(pattern.size[0], pattern.size[1]);
    patternCanvasContext.drawImage(iconImage.getImage(1), pattern.offset[0], pattern.offset[1], pattern.size[0], pattern.size[1], 0, 0, pattern.size[0], pattern.size[1]);
    (0, $671c623bccf16134$export$3988ae62b71be9a3)(patternCanvasContext.canvas, cacheKey, undefined, (0, $f217251b3f1483a0$export$2e2bcd8739ae039).LOADED, pattern.color, true);
    return (0, $3f062f3a3d0ff66a$export$747ccdf771a87ab8).getPattern(cacheKey, pattern.color);
}





/**
 * @module ol/render/VectorContext
 */ /**
 * @classdesc
 * Context for drawing geometries.  A vector context is available on render
 * events and does not need to be constructed directly.
 * @api
 */ class $5b3da3b7ea275d86$var$VectorContext {
    /**
   * Render a geometry with a custom renderer.
   *
   * @param {import("../geom/SimpleGeometry.js").default} geometry Geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {Function} renderer Renderer.
   * @param {Function} hitDetectionRenderer Renderer.
   * @param {number} [index] Render order index.
   */ drawCustom(geometry, feature, renderer, hitDetectionRenderer, index) {}
    /**
   * Render a geometry.
   *
   * @param {import("../geom/Geometry.js").default} geometry The geometry to render.
   */ drawGeometry(geometry) {}
    /**
   * Set the rendering style.
   *
   * @param {import("../style/Style.js").default} style The rendering style.
   */ setStyle(style) {}
    /**
   * @param {import("../geom/Circle.js").default} circleGeometry Circle geometry.
   * @param {import("../Feature.js").default} feature Feature.
   * @param {number} [index] Render order index.
   */ drawCircle(circleGeometry, feature, index) {}
    /**
   * @param {import("../Feature.js").default} feature Feature.
   * @param {import("../style/Style.js").default} style Style.
   * @param {number} [index] Render order index.
   */ drawFeature(feature, style, index) {}
    /**
   * @param {import("../geom/GeometryCollection.js").default} geometryCollectionGeometry Geometry collection.
   * @param {import("../Feature.js").default} feature Feature.
   * @param {number} [index] Render order index.
   */ drawGeometryCollection(geometryCollectionGeometry, feature, index) {}
    /**
   * @param {import("../geom/LineString.js").default|import("./Feature.js").default} lineStringGeometry Line string geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawLineString(lineStringGeometry, feature, index) {}
    /**
   * @param {import("../geom/MultiLineString.js").default|import("./Feature.js").default} multiLineStringGeometry MultiLineString geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawMultiLineString(multiLineStringGeometry, feature, index) {}
    /**
   * @param {import("../geom/MultiPoint.js").default|import("./Feature.js").default} multiPointGeometry MultiPoint geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawMultiPoint(multiPointGeometry, feature, index) {}
    /**
   * @param {import("../geom/MultiPolygon.js").default} multiPolygonGeometry MultiPolygon geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawMultiPolygon(multiPolygonGeometry, feature, index) {}
    /**
   * @param {import("../geom/Point.js").default|import("./Feature.js").default} pointGeometry Point geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawPoint(pointGeometry, feature, index) {}
    /**
   * @param {import("../geom/Polygon.js").default|import("./Feature.js").default} polygonGeometry Polygon geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawPolygon(polygonGeometry, feature, index) {}
    /**
   * @param {import("../geom/SimpleGeometry.js").default|import("./Feature.js").default} geometry Geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawText(geometry, feature, index) {}
    /**
   * @param {import("../style/Fill.js").default} fillStyle Fill style.
   * @param {import("../style/Stroke.js").default} strokeStyle Stroke style.
   */ setFillStrokeStyle(fillStyle, strokeStyle) {}
    /**
   * @param {import("../style/Image.js").default} imageStyle Image style.
   * @param {import("../render/canvas.js").DeclutterImageWithText} [declutterImageWithText] Shared data for combined decluttering with a text style.
   */ setImageStyle(imageStyle, declutterImageWithText) {}
    /**
   * @param {import("../style/Text.js").default} textStyle Text style.
   * @param {import("../render/canvas.js").DeclutterImageWithText} [declutterImageWithText] Shared data for combined decluttering with an image style.
   */ setTextStyle(textStyle, declutterImageWithText) {}
}
var $5b3da3b7ea275d86$export$2e2bcd8739ae039 = $5b3da3b7ea275d86$var$VectorContext;


/**
 * @module ol/render/canvas
 */ 




const $6a4acf19c5e548d6$export$3847dfea4f8d4dfa = '10px sans-serif';
const $6a4acf19c5e548d6$export$c495d52ee3fd74b2 = '#000';
const $6a4acf19c5e548d6$export$17bd0c38d6ae694e = 'round';
const $6a4acf19c5e548d6$export$e21b4112fdc612fc = [];
const $6a4acf19c5e548d6$export$e06efc2409049f76 = 0;
const $6a4acf19c5e548d6$export$365eb9648cf19bd0 = 'round';
const $6a4acf19c5e548d6$export$80c1c01844597b7b = 10;
const $6a4acf19c5e548d6$export$e010c2b9c075c7a1 = 0;
const $6a4acf19c5e548d6$export$1eb2eaecacf2031e = '#000';
const $6a4acf19c5e548d6$export$94d53b95641b5766 = 'center';
const $6a4acf19c5e548d6$export$cf2279a1bff62eb = 'middle';
const $6a4acf19c5e548d6$export$40a9eeef55665a40 = [
    0,
    0,
    0,
    0
];
const $6a4acf19c5e548d6$export$79661f132c62010e = 1;
const $6a4acf19c5e548d6$export$1d36981fcadac93b = new (0, $4862cdcc23257f5b$export$2e2bcd8739ae039)();
/**
 * @type {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D}
 */ let $6a4acf19c5e548d6$var$measureContext = null;
/**
 * @type {string}
 */ let $6a4acf19c5e548d6$var$measureFont;
const $6a4acf19c5e548d6$export$7fdcec604f0b1fa7 = {};
const $6a4acf19c5e548d6$var$genericFontFamilies = new Set([
    'serif',
    'sans-serif',
    'monospace',
    'cursive',
    'fantasy',
    'system-ui',
    'ui-serif',
    'ui-sans-serif',
    'ui-monospace',
    'ui-rounded',
    'emoji',
    'math',
    'fangsong'
]);
/**
 * @param {string} style Css font-style
 * @param {string} weight Css font-weight
 * @param {string} family Css font-family
 * @return {string} Font key.
 */ function $6a4acf19c5e548d6$var$getFontKey(style, weight, family) {
    return `${style} ${weight} 16px "${family}"`;
}
const $6a4acf19c5e548d6$export$a534074a28fa87ff = function() {
    const retries = 100;
    let timeout, fontFaceSet;
    /**
   * @param {string} fontSpec Css font spec
   * @return {Promise<boolean>} Font with style and weight is available
   */ async function isAvailable(fontSpec) {
        await fontFaceSet.ready;
        const fontFaces = await fontFaceSet.load(fontSpec);
        if (fontFaces.length === 0) return false;
        const font = (0, $d3be093641aea1c1$export$5abde8a6aec4a131)(fontSpec);
        const checkFamily = font.families[0].toLowerCase();
        const checkWeight = font.weight;
        return fontFaces.some(/**
       * @param {import('../css.js').FontParameters} f Font.
       * @return {boolean} Font matches.
       */ (f)=>{
            const family = f.family.replace(/^['"]|['"]$/g, '').toLowerCase();
            const weight = (0, $d3be093641aea1c1$export$59230918eb9bd861)[f.weight] || f.weight;
            return family === checkFamily && f.style === font.style && weight == checkWeight;
        });
    }
    async function check() {
        await fontFaceSet.ready;
        let done = true;
        const checkedFontsProperties = $6a4acf19c5e548d6$export$1d36981fcadac93b.getProperties();
        const fonts = Object.keys(checkedFontsProperties).filter((key)=>checkedFontsProperties[key] < retries);
        for(let i = fonts.length - 1; i >= 0; --i){
            const font = fonts[i];
            let currentRetries = checkedFontsProperties[font];
            if (currentRetries < retries) {
                if (await isAvailable(font)) {
                    (0, $9f2b61a1df00e9b3$export$42ffd38884aecdac)($6a4acf19c5e548d6$export$7fdcec604f0b1fa7);
                    $6a4acf19c5e548d6$export$1d36981fcadac93b.set(font, retries);
                } else {
                    currentRetries += 10;
                    $6a4acf19c5e548d6$export$1d36981fcadac93b.set(font, currentRetries, true);
                    if (currentRetries < retries) done = false;
                }
            }
        }
        timeout = undefined;
        if (!done) timeout = setTimeout(check, 100);
    }
    return async function(fontSpec) {
        if (!fontFaceSet) fontFaceSet = (0, $32d41268b5f53567$export$98fcef3dc9973292) ? self.fonts : document.fonts;
        const font = (0, $d3be093641aea1c1$export$5abde8a6aec4a131)(fontSpec);
        if (!font) return;
        const families = font.families;
        let needCheck = false;
        for (const family of families){
            if ($6a4acf19c5e548d6$var$genericFontFamilies.has(family)) continue;
            const key = $6a4acf19c5e548d6$var$getFontKey(font.style, font.weight, family);
            if ($6a4acf19c5e548d6$export$1d36981fcadac93b.get(key) !== undefined) continue;
            $6a4acf19c5e548d6$export$1d36981fcadac93b.set(key, 0, true);
            needCheck = true;
        }
        if (needCheck) {
            clearTimeout(timeout);
            timeout = setTimeout(check, 100);
        }
    };
}();
const $6a4acf19c5e548d6$export$4feaf6852ff92513 = function() {
    /**
   * @type {HTMLDivElement}
   */ let measureElement;
    return function(fontSpec) {
        let height = $6a4acf19c5e548d6$export$7fdcec604f0b1fa7[fontSpec];
        if (height == undefined) {
            if (0, $32d41268b5f53567$export$98fcef3dc9973292) {
                const font = (0, $d3be093641aea1c1$export$5abde8a6aec4a131)(fontSpec);
                const metrics = $6a4acf19c5e548d6$var$measureText(fontSpec, "\u017Dg");
                const lineHeight = isNaN(Number(font.lineHeight)) ? 1.2 : Number(font.lineHeight);
                height = lineHeight * (metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent);
            } else {
                if (!measureElement) {
                    measureElement = document.createElement('div');
                    measureElement.innerHTML = 'M';
                    measureElement.style.minHeight = '0';
                    measureElement.style.maxHeight = 'none';
                    measureElement.style.height = 'auto';
                    measureElement.style.padding = '0';
                    measureElement.style.border = 'none';
                    measureElement.style.position = 'absolute';
                    measureElement.style.display = 'block';
                    measureElement.style.left = '-99999px';
                }
                measureElement.style.font = fontSpec;
                document.body.appendChild(measureElement);
                height = measureElement.offsetHeight;
                document.body.removeChild(measureElement);
            }
            $6a4acf19c5e548d6$export$7fdcec604f0b1fa7[fontSpec] = height;
        }
        return height;
    };
}();
/**
 * @param {string} font Font.
 * @param {string} text Text.
 * @return {TextMetrics} Text metrics.
 */ function $6a4acf19c5e548d6$var$measureText(font, text) {
    if (!$6a4acf19c5e548d6$var$measureContext) $6a4acf19c5e548d6$var$measureContext = (0, $b6f6d442e8ff57e1$export$9e05d10eae75c464)(1, 1);
    if (font != $6a4acf19c5e548d6$var$measureFont) {
        $6a4acf19c5e548d6$var$measureContext.font = font;
        $6a4acf19c5e548d6$var$measureFont = $6a4acf19c5e548d6$var$measureContext.font;
    }
    return $6a4acf19c5e548d6$var$measureContext.measureText(text);
}
function $6a4acf19c5e548d6$export$4ea92329b673abd1(font, text) {
    return $6a4acf19c5e548d6$var$measureText(font, text).width;
}
function $6a4acf19c5e548d6$export$915c7ba51467308f(font, text, cache) {
    if (text in cache) return cache[text];
    const width = text.split('\n').reduce((prev, curr)=>Math.max(prev, $6a4acf19c5e548d6$export$4ea92329b673abd1(font, curr)), 0);
    cache[text] = width;
    return width;
}
function $6a4acf19c5e548d6$export$7d7c13020df1e791(baseStyle, chunks) {
    const widths = [];
    const heights = [];
    const lineWidths = [];
    let width = 0;
    let lineWidth = 0;
    let height = 0;
    let lineHeight = 0;
    for(let i = 0, ii = chunks.length; i <= ii; i += 2){
        const text = chunks[i];
        if (text === '\n' || i === ii) {
            width = Math.max(width, lineWidth);
            lineWidths.push(lineWidth);
            lineWidth = 0;
            height += lineHeight;
            lineHeight = 0;
            continue;
        }
        const font = chunks[i + 1] || baseStyle.font;
        const currentWidth = $6a4acf19c5e548d6$export$4ea92329b673abd1(font, text);
        widths.push(currentWidth);
        lineWidth += currentWidth;
        const currentHeight = $6a4acf19c5e548d6$export$4feaf6852ff92513(font);
        heights.push(currentHeight);
        lineHeight = Math.max(lineHeight, currentHeight);
    }
    return {
        width: width,
        height: height,
        widths: widths,
        heights: heights,
        lineWidths: lineWidths
    };
}
function $6a4acf19c5e548d6$export$8ac4d72be78047e6(context, rotation, offsetX, offsetY) {
    if (rotation !== 0) {
        context.translate(offsetX, offsetY);
        context.rotate(rotation);
        context.translate(-offsetX, -offsetY);
    }
}
function $6a4acf19c5e548d6$export$3cb6f3a6e49cc0ee(context, transform, opacity, labelOrImage, originX, originY, w, h, x, y, scale) {
    context.save();
    if (opacity !== 1) {
        if (context.globalAlpha === undefined) context.globalAlpha = (context)=>context.globalAlpha *= opacity;
        else context.globalAlpha *= opacity;
    }
    if (transform) context.transform.apply(context, transform);
    if (/** @type {*} */ labelOrImage.contextInstructions) {
        // label
        context.translate(x, y);
        context.scale(scale[0], scale[1]);
        $6a4acf19c5e548d6$var$executeLabelInstructions(/** @type {Label} */ labelOrImage, context);
    } else if (scale[0] < 0 || scale[1] < 0) {
        // flipped image
        context.translate(x, y);
        context.scale(scale[0], scale[1]);
        context.drawImage(/** @type {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} */ labelOrImage, originX, originY, w, h, 0, 0, w, h);
    } else // if image not flipped translate and scale can be avoided
    context.drawImage(/** @type {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} */ labelOrImage, originX, originY, w, h, x, y, w * scale[0], h * scale[1]);
    context.restore();
}
/**
 * @param {Label} label Label.
 * @param {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} context Context.
 */ function $6a4acf19c5e548d6$var$executeLabelInstructions(label, context) {
    const contextInstructions = label.contextInstructions;
    for(let i = 0, ii = contextInstructions.length; i < ii; i += 2)if (Array.isArray(contextInstructions[i + 1])) context[contextInstructions[i]].apply(context, contextInstructions[i + 1]);
    else context[contextInstructions[i]] = contextInstructions[i + 1];
}


/**
 * @module ol/render/canvas/Instruction
 */ /**
 * @enum {number}
 */ const $0502284914437a56$var$Instruction = {
    BEGIN_GEOMETRY: 0,
    BEGIN_PATH: 1,
    CIRCLE: 2,
    CLOSE_PATH: 3,
    CUSTOM: 4,
    DRAW_CHARS: 5,
    DRAW_IMAGE: 6,
    END_GEOMETRY: 7,
    FILL: 8,
    MOVE_TO_LINE_TO: 9,
    SET_FILL_STYLE: 10,
    SET_STROKE_STYLE: 11,
    STROKE: 12
};
const $0502284914437a56$export$f21891651e408226 = [
    $0502284914437a56$var$Instruction.FILL
];
const $0502284914437a56$export$7a98aa5364d62ba8 = [
    $0502284914437a56$var$Instruction.STROKE
];
const $0502284914437a56$export$9f746cc58a899a00 = [
    $0502284914437a56$var$Instruction.BEGIN_PATH
];
const $0502284914437a56$export$89b10f327e413e71 = [
    $0502284914437a56$var$Instruction.CLOSE_PATH
];
var $0502284914437a56$export$2e2bcd8739ae039 = $0502284914437a56$var$Instruction;


class $01e4df6bd3c09b14$var$CanvasBuilder extends (0, $5b3da3b7ea275d86$export$2e2bcd8739ae039) {
    /**
   * @param {number} tolerance Tolerance.
   * @param {import("../../extent.js").Extent} maxExtent Maximum extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   */ constructor(tolerance, maxExtent, resolution, pixelRatio){
        super();
        /**
     * @protected
     * @type {number}
     */ this.tolerance = tolerance;
        /**
     * @protected
     * @const
     * @type {import("../../extent.js").Extent}
     */ this.maxExtent = maxExtent;
        /**
     * @protected
     * @type {number}
     */ this.pixelRatio = pixelRatio;
        /**
     * @protected
     * @type {number}
     */ this.maxLineWidth = 0;
        /**
     * @protected
     * @const
     * @type {number}
     */ this.resolution = resolution;
        /**
     * @private
     * @type {Array<*>}
     */ this.beginGeometryInstruction1_ = null;
        /**
     * @private
     * @type {Array<*>}
     */ this.beginGeometryInstruction2_ = null;
        /**
     * @private
     * @type {import("../../extent.js").Extent}
     */ this.bufferedMaxExtent_ = null;
        /**
     * @protected
     * @type {Array<*>}
     */ this.instructions = [];
        /**
     * @protected
     * @type {Array<number>}
     */ this.coordinates = [];
        /**
     * @private
     * @type {import("../../coordinate.js").Coordinate}
     */ this.tmpCoordinate_ = [];
        /**
     * @protected
     * @type {Array<*>}
     */ this.hitDetectionInstructions = [];
        /**
     * @protected
     * @type {import("../canvas.js").FillStrokeState}
     */ this.state = /** @type {import("../canvas.js").FillStrokeState} */ {};
    }
    /**
   * @protected
   * @param {Array<number>} dashArray Dash array.
   * @return {Array<number>} Dash array with pixel ratio applied
   */ applyPixelRatio(dashArray) {
        const pixelRatio = this.pixelRatio;
        return pixelRatio == 1 ? dashArray : dashArray.map(function(dash) {
            return dash * pixelRatio;
        });
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} stride Stride.
   * @protected
   * @return {number} My end
   */ appendFlatPointCoordinates(flatCoordinates, stride) {
        const extent = this.getBufferedMaxExtent();
        const tmpCoord = this.tmpCoordinate_;
        const coordinates = this.coordinates;
        let myEnd = coordinates.length;
        for(let i = 0, ii = flatCoordinates.length; i < ii; i += stride){
            tmpCoord[0] = flatCoordinates[i];
            tmpCoord[1] = flatCoordinates[i + 1];
            if ((0, $dea65c2f666fa450$export$ac68c24d37ca240f)(extent, tmpCoord)) {
                coordinates[myEnd++] = tmpCoord[0];
                coordinates[myEnd++] = tmpCoord[1];
            }
        }
        return myEnd;
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {number} end End.
   * @param {number} stride Stride.
   * @param {boolean} closed Last input coordinate equals first.
   * @param {boolean} skipFirst Skip first coordinate.
   * @protected
   * @return {number} My end.
   */ appendFlatLineCoordinates(flatCoordinates, offset, end, stride, closed, skipFirst) {
        const coordinates = this.coordinates;
        let myEnd = coordinates.length;
        const extent = this.getBufferedMaxExtent();
        if (skipFirst) offset += stride;
        let lastXCoord = flatCoordinates[offset];
        let lastYCoord = flatCoordinates[offset + 1];
        const nextCoord = this.tmpCoordinate_;
        let skipped = true;
        let i, lastRel, nextRel;
        for(i = offset + stride; i < end; i += stride){
            nextCoord[0] = flatCoordinates[i];
            nextCoord[1] = flatCoordinates[i + 1];
            nextRel = (0, $dea65c2f666fa450$export$f97905ead28c61a8)(extent, nextCoord);
            if (nextRel !== lastRel) {
                if (skipped) {
                    coordinates[myEnd++] = lastXCoord;
                    coordinates[myEnd++] = lastYCoord;
                    skipped = false;
                }
                coordinates[myEnd++] = nextCoord[0];
                coordinates[myEnd++] = nextCoord[1];
            } else if (nextRel === (0, $6c0093e2f673fa5d$export$2e2bcd8739ae039).INTERSECTING) {
                coordinates[myEnd++] = nextCoord[0];
                coordinates[myEnd++] = nextCoord[1];
                skipped = false;
            } else skipped = true;
            lastXCoord = nextCoord[0];
            lastYCoord = nextCoord[1];
            lastRel = nextRel;
        }
        // Last coordinate equals first or only one point to append:
        if (closed && skipped || i === offset + stride) {
            coordinates[myEnd++] = lastXCoord;
            coordinates[myEnd++] = lastYCoord;
        }
        return myEnd;
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {Array<number>} ends Ends.
   * @param {number} stride Stride.
   * @param {Array<number>} builderEnds Builder ends.
   * @return {number} Offset.
   */ drawCustomCoordinates_(flatCoordinates, offset, ends, stride, builderEnds) {
        for(let i = 0, ii = ends.length; i < ii; ++i){
            const end = ends[i];
            const builderEnd = this.appendFlatLineCoordinates(flatCoordinates, offset, end, stride, false, false);
            builderEnds.push(builderEnd);
            offset = end;
        }
        return offset;
    }
    /**
   * @param {import("../../geom/SimpleGeometry.js").default} geometry Geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {Function} renderer Renderer.
   * @param {Function} hitDetectionRenderer Renderer.
   * @param {number} [index] Render order index.
   * @override
   */ drawCustom(geometry, feature, renderer, hitDetectionRenderer, index) {
        this.beginGeometry(geometry, feature, index);
        const type = geometry.getType();
        const stride = geometry.getStride();
        const builderBegin = this.coordinates.length;
        let flatCoordinates, builderEnd, builderEnds, builderEndss;
        let offset;
        switch(type){
            case 'MultiPolygon':
                flatCoordinates = /** @type {import("../../geom/MultiPolygon.js").default} */ geometry.getOrientedFlatCoordinates();
                builderEndss = [];
                const endss = /** @type {import("../../geom/MultiPolygon.js").default} */ geometry.getEndss();
                offset = 0;
                for(let i = 0, ii = endss.length; i < ii; ++i){
                    const myEnds = [];
                    offset = this.drawCustomCoordinates_(flatCoordinates, offset, endss[i], stride, myEnds);
                    builderEndss.push(myEnds);
                }
                this.instructions.push([
                    (0, $0502284914437a56$export$2e2bcd8739ae039).CUSTOM,
                    builderBegin,
                    builderEndss,
                    geometry,
                    renderer,
                    (0, $610a33d138e2ac41$export$915c7058aeb4dfeb),
                    index
                ]);
                this.hitDetectionInstructions.push([
                    (0, $0502284914437a56$export$2e2bcd8739ae039).CUSTOM,
                    builderBegin,
                    builderEndss,
                    geometry,
                    hitDetectionRenderer || renderer,
                    (0, $610a33d138e2ac41$export$915c7058aeb4dfeb),
                    index
                ]);
                break;
            case 'Polygon':
            case 'MultiLineString':
                builderEnds = [];
                flatCoordinates = type == 'Polygon' ? /** @type {import("../../geom/Polygon.js").default} */ geometry.getOrientedFlatCoordinates() : geometry.getFlatCoordinates();
                offset = this.drawCustomCoordinates_(flatCoordinates, 0, /** @type {import("../../geom/Polygon.js").default|import("../../geom/MultiLineString.js").default} */ geometry.getEnds(), stride, builderEnds);
                this.instructions.push([
                    (0, $0502284914437a56$export$2e2bcd8739ae039).CUSTOM,
                    builderBegin,
                    builderEnds,
                    geometry,
                    renderer,
                    (0, $610a33d138e2ac41$export$cbb9596fc0f40db2),
                    index
                ]);
                this.hitDetectionInstructions.push([
                    (0, $0502284914437a56$export$2e2bcd8739ae039).CUSTOM,
                    builderBegin,
                    builderEnds,
                    geometry,
                    hitDetectionRenderer || renderer,
                    (0, $610a33d138e2ac41$export$cbb9596fc0f40db2),
                    index
                ]);
                break;
            case 'LineString':
            case 'Circle':
                flatCoordinates = geometry.getFlatCoordinates();
                builderEnd = this.appendFlatLineCoordinates(flatCoordinates, 0, flatCoordinates.length, stride, false, false);
                this.instructions.push([
                    (0, $0502284914437a56$export$2e2bcd8739ae039).CUSTOM,
                    builderBegin,
                    builderEnd,
                    geometry,
                    renderer,
                    (0, $610a33d138e2ac41$export$9c0934e4e9c3f61e),
                    index
                ]);
                this.hitDetectionInstructions.push([
                    (0, $0502284914437a56$export$2e2bcd8739ae039).CUSTOM,
                    builderBegin,
                    builderEnd,
                    geometry,
                    hitDetectionRenderer || renderer,
                    (0, $610a33d138e2ac41$export$9c0934e4e9c3f61e),
                    index
                ]);
                break;
            case 'MultiPoint':
                flatCoordinates = geometry.getFlatCoordinates();
                builderEnd = this.appendFlatPointCoordinates(flatCoordinates, stride);
                if (builderEnd > builderBegin) {
                    this.instructions.push([
                        (0, $0502284914437a56$export$2e2bcd8739ae039).CUSTOM,
                        builderBegin,
                        builderEnd,
                        geometry,
                        renderer,
                        (0, $610a33d138e2ac41$export$9c0934e4e9c3f61e),
                        index
                    ]);
                    this.hitDetectionInstructions.push([
                        (0, $0502284914437a56$export$2e2bcd8739ae039).CUSTOM,
                        builderBegin,
                        builderEnd,
                        geometry,
                        hitDetectionRenderer || renderer,
                        (0, $610a33d138e2ac41$export$9c0934e4e9c3f61e),
                        index
                    ]);
                }
                break;
            case 'Point':
                flatCoordinates = geometry.getFlatCoordinates();
                this.coordinates.push(flatCoordinates[0], flatCoordinates[1]);
                builderEnd = this.coordinates.length;
                this.instructions.push([
                    (0, $0502284914437a56$export$2e2bcd8739ae039).CUSTOM,
                    builderBegin,
                    builderEnd,
                    geometry,
                    renderer,
                    undefined,
                    index
                ]);
                this.hitDetectionInstructions.push([
                    (0, $0502284914437a56$export$2e2bcd8739ae039).CUSTOM,
                    builderBegin,
                    builderEnd,
                    geometry,
                    hitDetectionRenderer || renderer,
                    undefined,
                    index
                ]);
                break;
            default:
        }
        this.endGeometry(feature);
    }
    /**
   * @protected
   * @param {import("../../geom/Geometry").default|import("../Feature.js").default} geometry The geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} index Render order index
   */ beginGeometry(geometry, feature, index) {
        this.beginGeometryInstruction1_ = [
            (0, $0502284914437a56$export$2e2bcd8739ae039).BEGIN_GEOMETRY,
            feature,
            0,
            geometry,
            index
        ];
        this.instructions.push(this.beginGeometryInstruction1_);
        this.beginGeometryInstruction2_ = [
            (0, $0502284914437a56$export$2e2bcd8739ae039).BEGIN_GEOMETRY,
            feature,
            0,
            geometry,
            index
        ];
        this.hitDetectionInstructions.push(this.beginGeometryInstruction2_);
    }
    /**
   * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
   */ finish() {
        return {
            instructions: this.instructions,
            hitDetectionInstructions: this.hitDetectionInstructions,
            coordinates: this.coordinates
        };
    }
    /**
   * Reverse the hit detection instructions.
   */ reverseHitDetectionInstructions() {
        const hitDetectionInstructions = this.hitDetectionInstructions;
        // step 1 - reverse array
        hitDetectionInstructions.reverse();
        // step 2 - reverse instructions within geometry blocks
        let i;
        const n = hitDetectionInstructions.length;
        let instruction;
        let type;
        let begin = -1;
        for(i = 0; i < n; ++i){
            instruction = hitDetectionInstructions[i];
            type = /** @type {import("./Instruction.js").default} */ instruction[0];
            if (type == (0, $0502284914437a56$export$2e2bcd8739ae039).END_GEOMETRY) begin = i;
            else if (type == (0, $0502284914437a56$export$2e2bcd8739ae039).BEGIN_GEOMETRY) {
                instruction[2] = i;
                (0, $49313fcb0fc32abe$export$292cfa960964f0e0)(this.hitDetectionInstructions, begin, i);
                begin = -1;
            }
        }
    }
    /**
   * @param {import("../../style/Fill.js").default} fillStyle Fill style.
   * @param {import('../canvas.js').FillStrokeState} [state] State.
   * @return {import('../canvas.js').FillStrokeState} State.
   */ fillStyleToState(fillStyle, state = /** @type {import('../canvas.js').FillStrokeState} */ {}) {
        if (fillStyle) {
            const fillStyleColor = fillStyle.getColor();
            state.fillPatternScale = fillStyleColor && typeof fillStyleColor === 'object' && 'src' in fillStyleColor ? this.pixelRatio : 1;
            state.fillStyle = (0, $c236b40ac833efca$export$dc5b1400ac3a10a8)(fillStyleColor ? fillStyleColor : (0, $6a4acf19c5e548d6$export$c495d52ee3fd74b2));
        } else state.fillStyle = undefined;
        return state;
    }
    /**
   * @param {import("../../style/Stroke.js").default} strokeStyle Stroke style.
   * @param {import("../canvas.js").FillStrokeState} state State.
   * @return {import("../canvas.js").FillStrokeState} State.
   */ strokeStyleToState(strokeStyle, state = /** @type {import('../canvas.js').FillStrokeState} */ {}) {
        if (strokeStyle) {
            const strokeStyleColor = strokeStyle.getColor();
            state.strokeStyle = (0, $c236b40ac833efca$export$dc5b1400ac3a10a8)(strokeStyleColor ? strokeStyleColor : (0, $6a4acf19c5e548d6$export$1eb2eaecacf2031e));
            const strokeStyleLineCap = strokeStyle.getLineCap();
            state.lineCap = strokeStyleLineCap !== undefined ? strokeStyleLineCap : (0, $6a4acf19c5e548d6$export$17bd0c38d6ae694e);
            const strokeStyleLineDash = strokeStyle.getLineDash();
            state.lineDash = strokeStyleLineDash ? strokeStyleLineDash.slice() : (0, $6a4acf19c5e548d6$export$e21b4112fdc612fc);
            const strokeStyleLineDashOffset = strokeStyle.getLineDashOffset();
            state.lineDashOffset = strokeStyleLineDashOffset ? strokeStyleLineDashOffset : (0, $6a4acf19c5e548d6$export$e06efc2409049f76);
            const strokeStyleLineJoin = strokeStyle.getLineJoin();
            state.lineJoin = strokeStyleLineJoin !== undefined ? strokeStyleLineJoin : (0, $6a4acf19c5e548d6$export$365eb9648cf19bd0);
            const strokeStyleWidth = strokeStyle.getWidth();
            state.lineWidth = strokeStyleWidth !== undefined ? strokeStyleWidth : (0, $6a4acf19c5e548d6$export$79661f132c62010e);
            const strokeStyleMiterLimit = strokeStyle.getMiterLimit();
            state.miterLimit = strokeStyleMiterLimit !== undefined ? strokeStyleMiterLimit : (0, $6a4acf19c5e548d6$export$80c1c01844597b7b);
            const strokeStyleOffset = strokeStyle.getOffset();
            state.strokeOffset = strokeStyleOffset ?? (0, $6a4acf19c5e548d6$export$e010c2b9c075c7a1);
            if (state.lineWidth > this.maxLineWidth) {
                this.maxLineWidth = state.lineWidth;
                // invalidate the buffered max extent cache
                this.bufferedMaxExtent_ = null;
            }
        } else {
            state.strokeStyle = undefined;
            state.lineCap = undefined;
            state.lineDash = null;
            state.lineDashOffset = undefined;
            state.lineJoin = undefined;
            state.lineWidth = undefined;
            state.miterLimit = undefined;
            state.strokeOffset = undefined;
        }
        return state;
    }
    /**
   * @param {import("../../style/Fill.js").default} fillStyle Fill style.
   * @param {import("../../style/Stroke.js").default} strokeStyle Stroke style.
   * @override
   */ setFillStrokeStyle(fillStyle, strokeStyle) {
        const state = this.state;
        this.fillStyleToState(fillStyle, state);
        this.strokeStyleToState(strokeStyle, state);
    }
    /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   * @return {Array<*>} Fill instruction.
   */ createFill(state) {
        const fillStyle = state.fillStyle;
        /** @type {Array<*>} */ const fillInstruction = [
            (0, $0502284914437a56$export$2e2bcd8739ae039).SET_FILL_STYLE,
            fillStyle
        ];
        if (typeof fillStyle !== 'string') // Fill is a pattern or gradient - align and scale it!
        fillInstruction.push(state.fillPatternScale);
        return fillInstruction;
    }
    /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   */ applyStroke(state) {
        this.instructions.push(this.createStroke(state));
    }
    /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   * @return {Array<*>} Stroke instruction.
   */ createStroke(state) {
        return [
            (0, $0502284914437a56$export$2e2bcd8739ae039).SET_STROKE_STYLE,
            state.strokeStyle,
            state.lineWidth * this.pixelRatio,
            state.lineCap,
            state.lineJoin,
            state.miterLimit,
            state.lineDash ? this.applyPixelRatio(state.lineDash) : null,
            state.lineDashOffset * this.pixelRatio
        ];
    }
    /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   * @param {function(this:CanvasBuilder, import("../canvas.js").FillStrokeState):Array<*>} createFill Create fill.
   */ updateFillStyle(state, createFill) {
        const fillStyle = state.fillStyle;
        if (typeof fillStyle !== 'string' || state.currentFillStyle != fillStyle) {
            this.instructions.push(createFill.call(this, state));
            state.currentFillStyle = fillStyle;
        }
    }
    /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   * @param {function(this:CanvasBuilder, import("../canvas.js").FillStrokeState): void} applyStroke Apply stroke.
   */ updateStrokeStyle(state, applyStroke) {
        const strokeStyle = state.strokeStyle;
        const lineCap = state.lineCap;
        const lineDash = state.lineDash;
        const lineDashOffset = state.lineDashOffset;
        const lineJoin = state.lineJoin;
        const lineWidth = state.lineWidth;
        const miterLimit = state.miterLimit;
        const strokeOffset = state.strokeOffset;
        if (state.currentStrokeStyle != strokeStyle || state.currentLineCap != lineCap || lineDash != state.currentLineDash && !(0, $49313fcb0fc32abe$export$e9bab7fafb253603)(state.currentLineDash, lineDash) || state.currentLineDashOffset != lineDashOffset || state.currentLineJoin != lineJoin || state.currentLineWidth != lineWidth || state.currentMiterLimit != miterLimit || state.currentStrokeOffset != strokeOffset) {
            applyStroke.call(this, state);
            state.currentStrokeStyle = strokeStyle;
            state.currentLineCap = lineCap;
            state.currentLineDash = lineDash;
            state.currentLineDashOffset = lineDashOffset;
            state.currentLineJoin = lineJoin;
            state.currentLineWidth = lineWidth;
            state.currentMiterLimit = miterLimit;
            state.currentStrokeOffset = strokeOffset;
        }
    }
    /**
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   */ endGeometry(feature) {
        this.beginGeometryInstruction1_[2] = this.instructions.length;
        this.beginGeometryInstruction1_ = null;
        this.beginGeometryInstruction2_[2] = this.hitDetectionInstructions.length;
        this.beginGeometryInstruction2_ = null;
        const endGeometryInstruction = [
            (0, $0502284914437a56$export$2e2bcd8739ae039).END_GEOMETRY,
            feature
        ];
        this.instructions.push(endGeometryInstruction);
        this.hitDetectionInstructions.push(endGeometryInstruction);
    }
    /**
   * Get the buffered rendering extent.  Rendering will be clipped to the extent
   * provided to the constructor.  To account for symbolizers that may intersect
   * this extent, we calculate a buffered extent (e.g. based on stroke width).
   * @return {import("../../extent.js").Extent} The buffered rendering extent.
   * @protected
   */ getBufferedMaxExtent() {
        if (!this.bufferedMaxExtent_) {
            this.bufferedMaxExtent_ = (0, $dea65c2f666fa450$export$9cd59f9826255e47)(this.maxExtent);
            if (this.maxLineWidth > 0) {
                const width = this.resolution * (this.maxLineWidth + 1) / 2;
                (0, $dea65c2f666fa450$export$ab1029bcae9ddb4a)(this.bufferedMaxExtent_, width, this.bufferedMaxExtent_);
            }
        }
        return this.bufferedMaxExtent_;
    }
}
var $01e4df6bd3c09b14$export$2e2bcd8739ae039 = $01e4df6bd3c09b14$var$CanvasBuilder;


/**
 * @module ol/render/canvas/ImageBuilder
 */ 


class $665a5e595556c6a0$var$CanvasImageBuilder extends (0, $01e4df6bd3c09b14$export$2e2bcd8739ae039) {
    /**
   * @param {number} tolerance Tolerance.
   * @param {import("../../extent.js").Extent} maxExtent Maximum extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   */ constructor(tolerance, maxExtent, resolution, pixelRatio){
        super(tolerance, maxExtent, resolution, pixelRatio);
        /**
     * @private
     * @type {import('../../DataTile.js').ImageLike}
     */ this.hitDetectionImage_ = null;
        /**
     * @private
     * @type {import('../../DataTile.js').ImageLike}
     */ this.image_ = null;
        /**
     * @private
     * @type {number|undefined}
     */ this.imagePixelRatio_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.anchorX_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.anchorY_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.height_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.opacity_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.originX_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.originY_ = undefined;
        /**
     * @private
     * @type {boolean|undefined}
     */ this.rotateWithView_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.rotation_ = undefined;
        /**
     * @private
     * @type {import("../../size.js").Size|undefined}
     */ this.scale_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.width_ = undefined;
        /**
     * @private
     * @type {import('../../style/Style.js').DeclutterMode}
     */ this.declutterMode_ = undefined;
        /**
     * Data shared with a text builder for combined decluttering.
     * @private
     * @type {import("../canvas.js").DeclutterImageWithText}
     */ this.declutterImageWithText_ = undefined;
    }
    /**
   * @param {import("../../geom/Point.js").default|import("../Feature.js").default} pointGeometry Point geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   * @override
   */ drawPoint(pointGeometry, feature, index) {
        if (!this.image_ || this.maxExtent && !(0, $dea65c2f666fa450$export$ac68c24d37ca240f)(this.maxExtent, pointGeometry.getFlatCoordinates())) return;
        this.beginGeometry(pointGeometry, feature, index);
        const flatCoordinates = pointGeometry.getFlatCoordinates();
        const stride = pointGeometry.getStride();
        const myBegin = this.coordinates.length;
        const myEnd = this.appendFlatPointCoordinates(flatCoordinates, stride);
        this.instructions.push([
            (0, $0502284914437a56$export$2e2bcd8739ae039).DRAW_IMAGE,
            myBegin,
            myEnd,
            this.image_,
            // Remaining arguments to DRAW_IMAGE are in alphabetical order
            this.anchorX_ * this.imagePixelRatio_,
            this.anchorY_ * this.imagePixelRatio_,
            Math.ceil(this.height_ * this.imagePixelRatio_),
            this.opacity_,
            this.originX_ * this.imagePixelRatio_,
            this.originY_ * this.imagePixelRatio_,
            this.rotateWithView_,
            this.rotation_,
            [
                this.scale_[0] * this.pixelRatio / this.imagePixelRatio_,
                this.scale_[1] * this.pixelRatio / this.imagePixelRatio_
            ],
            Math.ceil(this.width_ * this.imagePixelRatio_),
            this.declutterMode_,
            this.declutterImageWithText_
        ]);
        this.hitDetectionInstructions.push([
            (0, $0502284914437a56$export$2e2bcd8739ae039).DRAW_IMAGE,
            myBegin,
            myEnd,
            this.hitDetectionImage_,
            // Remaining arguments to DRAW_IMAGE are in alphabetical order
            this.anchorX_,
            this.anchorY_,
            this.height_,
            1,
            this.originX_,
            this.originY_,
            this.rotateWithView_,
            this.rotation_,
            this.scale_,
            this.width_,
            this.declutterMode_,
            this.declutterImageWithText_
        ]);
        this.endGeometry(feature);
    }
    /**
   * @param {import("../../geom/MultiPoint.js").default|import("../Feature.js").default} multiPointGeometry MultiPoint geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   * @override
   */ drawMultiPoint(multiPointGeometry, feature, index) {
        if (!this.image_) return;
        this.beginGeometry(multiPointGeometry, feature, index);
        const flatCoordinates = multiPointGeometry.getFlatCoordinates();
        const filteredFlatCoordinates = [];
        for(let i = 0, ii = flatCoordinates.length; i < ii; i += multiPointGeometry.getStride())if (!this.maxExtent || (0, $dea65c2f666fa450$export$ac68c24d37ca240f)(this.maxExtent, flatCoordinates.slice(i, i + 2))) filteredFlatCoordinates.push(flatCoordinates[i], flatCoordinates[i + 1]);
        const myBegin = this.coordinates.length;
        const myEnd = this.appendFlatPointCoordinates(filteredFlatCoordinates, 2);
        this.instructions.push([
            (0, $0502284914437a56$export$2e2bcd8739ae039).DRAW_IMAGE,
            myBegin,
            myEnd,
            this.image_,
            // Remaining arguments to DRAW_IMAGE are in alphabetical order
            this.anchorX_ * this.imagePixelRatio_,
            this.anchorY_ * this.imagePixelRatio_,
            Math.ceil(this.height_ * this.imagePixelRatio_),
            this.opacity_,
            this.originX_ * this.imagePixelRatio_,
            this.originY_ * this.imagePixelRatio_,
            this.rotateWithView_,
            this.rotation_,
            [
                this.scale_[0] * this.pixelRatio / this.imagePixelRatio_,
                this.scale_[1] * this.pixelRatio / this.imagePixelRatio_
            ],
            Math.ceil(this.width_ * this.imagePixelRatio_),
            this.declutterMode_,
            this.declutterImageWithText_
        ]);
        this.hitDetectionInstructions.push([
            (0, $0502284914437a56$export$2e2bcd8739ae039).DRAW_IMAGE,
            myBegin,
            myEnd,
            this.hitDetectionImage_,
            // Remaining arguments to DRAW_IMAGE are in alphabetical order
            this.anchorX_,
            this.anchorY_,
            this.height_,
            1,
            this.originX_,
            this.originY_,
            this.rotateWithView_,
            this.rotation_,
            this.scale_,
            this.width_,
            this.declutterMode_,
            this.declutterImageWithText_
        ]);
        this.endGeometry(feature);
    }
    /**
   * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
   * @override
   */ finish() {
        this.reverseHitDetectionInstructions();
        // FIXME this doesn't really protect us against further calls to draw*Geometry
        this.anchorX_ = undefined;
        this.anchorY_ = undefined;
        this.hitDetectionImage_ = null;
        this.image_ = null;
        this.imagePixelRatio_ = undefined;
        this.height_ = undefined;
        this.scale_ = undefined;
        this.opacity_ = undefined;
        this.originX_ = undefined;
        this.originY_ = undefined;
        this.rotateWithView_ = undefined;
        this.rotation_ = undefined;
        this.width_ = undefined;
        return super.finish();
    }
    /**
   * @param {import("../../style/Image.js").default} imageStyle Image style.
   * @param {Object} [sharedData] Shared data.
   * @override
   */ setImageStyle(imageStyle, sharedData) {
        const anchor = imageStyle.getAnchor();
        const size = imageStyle.getSize();
        const origin = imageStyle.getOrigin();
        this.imagePixelRatio_ = imageStyle.getPixelRatio(this.pixelRatio);
        this.anchorX_ = anchor[0];
        this.anchorY_ = anchor[1];
        this.hitDetectionImage_ = imageStyle.getHitDetectionImage();
        this.image_ = imageStyle.getImage(this.pixelRatio);
        this.height_ = size[1];
        this.opacity_ = imageStyle.getOpacity();
        this.originX_ = origin[0];
        this.originY_ = origin[1];
        this.rotateWithView_ = imageStyle.getRotateWithView();
        this.rotation_ = imageStyle.getRotation();
        this.scale_ = imageStyle.getScaleArray();
        this.width_ = size[0];
        this.declutterMode_ = imageStyle.getDeclutterMode();
        this.declutterImageWithText_ = sharedData;
    }
}
var $665a5e595556c6a0$export$2e2bcd8739ae039 = $665a5e595556c6a0$var$CanvasImageBuilder;


/**
 * @module ol/render/canvas/LineStringBuilder
 */ 


class $cf869edeee40aaa3$var$CanvasLineStringBuilder extends (0, $01e4df6bd3c09b14$export$2e2bcd8739ae039) {
    /**
   * @param {number} tolerance Tolerance.
   * @param {import("../../extent.js").Extent} maxExtent Maximum extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   */ constructor(tolerance, maxExtent, resolution, pixelRatio){
        super(tolerance, maxExtent, resolution, pixelRatio);
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {number} end End.
   * @param {number} stride Stride.
   * @param {number} [strokeOffset] Stroke Offset in pixels.
   * @private
   * @return {number} end.
   */ drawFlatCoordinates_(flatCoordinates, offset, end, stride, strokeOffset) {
        const myBegin = this.coordinates.length;
        const myEnd = this.appendFlatLineCoordinates(flatCoordinates, offset, end, stride, false, false);
        this.instructions.push([
            (0, $0502284914437a56$export$2e2bcd8739ae039).MOVE_TO_LINE_TO,
            myBegin,
            myEnd,
            strokeOffset * this.pixelRatio
        ]);
        this.hitDetectionInstructions.push([
            (0, $0502284914437a56$export$2e2bcd8739ae039).MOVE_TO_LINE_TO,
            myBegin,
            myEnd,
            strokeOffset
        ]);
        return end;
    }
    /**
   * @param {import("../../geom/LineString.js").default|import("../Feature.js").default} lineStringGeometry Line string geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   * @override
   */ drawLineString(lineStringGeometry, feature, index) {
        const state = this.state;
        const strokeStyle = state.strokeStyle;
        const lineWidth = state.lineWidth;
        const strokeOffset = state.strokeOffset;
        if (strokeStyle === undefined || lineWidth === undefined) return;
        this.updateStrokeStyle(state, this.applyStroke);
        this.beginGeometry(lineStringGeometry, feature, index);
        this.hitDetectionInstructions.push([
            (0, $0502284914437a56$export$2e2bcd8739ae039).SET_STROKE_STYLE,
            state.strokeStyle,
            state.lineWidth,
            state.lineCap,
            state.lineJoin,
            state.miterLimit,
            (0, $6a4acf19c5e548d6$export$e21b4112fdc612fc),
            (0, $6a4acf19c5e548d6$export$e06efc2409049f76)
        ], (0, $0502284914437a56$export$9f746cc58a899a00));
        const flatCoordinates = lineStringGeometry.getFlatCoordinates();
        const stride = lineStringGeometry.getStride();
        this.drawFlatCoordinates_(flatCoordinates, 0, flatCoordinates.length, stride, strokeOffset);
        this.hitDetectionInstructions.push((0, $0502284914437a56$export$7a98aa5364d62ba8));
        this.endGeometry(feature);
    }
    /**
   * @param {import("../../geom/MultiLineString.js").default|import("../Feature.js").default} multiLineStringGeometry MultiLineString geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   * @override
   */ drawMultiLineString(multiLineStringGeometry, feature, index) {
        const state = this.state;
        const strokeStyle = state.strokeStyle;
        const lineWidth = state.lineWidth;
        const strokeOffset = state.strokeOffset;
        if (strokeStyle === undefined || lineWidth === undefined) return;
        this.updateStrokeStyle(state, this.applyStroke);
        this.beginGeometry(multiLineStringGeometry, feature, index);
        this.hitDetectionInstructions.push([
            (0, $0502284914437a56$export$2e2bcd8739ae039).SET_STROKE_STYLE,
            state.strokeStyle,
            state.lineWidth,
            state.lineCap,
            state.lineJoin,
            state.miterLimit,
            (0, $6a4acf19c5e548d6$export$e21b4112fdc612fc),
            (0, $6a4acf19c5e548d6$export$e06efc2409049f76)
        ], (0, $0502284914437a56$export$9f746cc58a899a00));
        const ends = multiLineStringGeometry.getEnds();
        const flatCoordinates = multiLineStringGeometry.getFlatCoordinates();
        const stride = multiLineStringGeometry.getStride();
        let offset = 0;
        for(let i = 0, ii = ends.length; i < ii; ++i)offset = this.drawFlatCoordinates_(flatCoordinates, offset, /** @type {number} */ ends[i], stride, strokeOffset);
        this.hitDetectionInstructions.push((0, $0502284914437a56$export$7a98aa5364d62ba8));
        this.endGeometry(feature);
    }
    /**
   * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
   * @override
   */ finish() {
        const state = this.state;
        if (state.lastStroke != undefined && state.lastStroke != this.coordinates.length) this.instructions.push((0, $0502284914437a56$export$7a98aa5364d62ba8));
        this.reverseHitDetectionInstructions();
        this.state = null;
        return super.finish();
    }
    /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   * @override
   */ applyStroke(state) {
        if (state.lastStroke != undefined && state.lastStroke != this.coordinates.length) {
            this.instructions.push((0, $0502284914437a56$export$7a98aa5364d62ba8));
            state.lastStroke = this.coordinates.length;
        }
        state.lastStroke = 0;
        super.applyStroke(state);
        this.instructions.push((0, $0502284914437a56$export$9f746cc58a899a00));
    }
}
var $cf869edeee40aaa3$export$2e2bcd8739ae039 = $cf869edeee40aaa3$var$CanvasLineStringBuilder;


/**
 * @module ol/render/canvas/PolygonBuilder
 */ 



class $bf0781f39a04ac61$var$CanvasPolygonBuilder extends (0, $01e4df6bd3c09b14$export$2e2bcd8739ae039) {
    /**
   * @param {number} tolerance Tolerance.
   * @param {import("../../extent.js").Extent} maxExtent Maximum extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   */ constructor(tolerance, maxExtent, resolution, pixelRatio){
        super(tolerance, maxExtent, resolution, pixelRatio);
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {Array<number>} ends Ends.
   * @param {number} stride Stride.
   * @param {number} [strokeOffset] Stroke Offset in pixels.
   * @private
   * @return {number} End.
   */ drawFlatCoordinatess_(flatCoordinates, offset, ends, stride, strokeOffset) {
        const state = this.state;
        const fill = state.fillStyle !== undefined;
        const stroke = state.strokeStyle !== undefined;
        const numEnds = ends.length;
        this.instructions.push((0, $0502284914437a56$export$9f746cc58a899a00));
        this.hitDetectionInstructions.push((0, $0502284914437a56$export$9f746cc58a899a00));
        for(let i = 0; i < numEnds; ++i){
            const end = ends[i];
            const myBegin = this.coordinates.length;
            const myEnd = this.appendFlatLineCoordinates(flatCoordinates, offset, end, stride, true, !stroke);
            this.instructions.push([
                (0, $0502284914437a56$export$2e2bcd8739ae039).MOVE_TO_LINE_TO,
                myBegin,
                myEnd,
                strokeOffset * this.pixelRatio,
                true
            ]);
            this.hitDetectionInstructions.push([
                (0, $0502284914437a56$export$2e2bcd8739ae039).MOVE_TO_LINE_TO,
                myBegin,
                myEnd,
                strokeOffset,
                true
            ]);
            if (stroke) {
                // Performance optimization: only call closePath() when we have a stroke.
                // Otherwise the ring is closed already (see appendFlatLineCoordinates above).
                this.instructions.push((0, $0502284914437a56$export$89b10f327e413e71));
                this.hitDetectionInstructions.push((0, $0502284914437a56$export$89b10f327e413e71));
            }
            offset = end;
        }
        if (fill) {
            this.instructions.push((0, $0502284914437a56$export$f21891651e408226));
            this.hitDetectionInstructions.push((0, $0502284914437a56$export$f21891651e408226));
        }
        if (stroke) {
            this.instructions.push((0, $0502284914437a56$export$7a98aa5364d62ba8));
            this.hitDetectionInstructions.push((0, $0502284914437a56$export$7a98aa5364d62ba8));
        }
        return offset;
    }
    /**
   * @param {import("../../geom/Circle.js").default} circleGeometry Circle geometry.
   * @param {import("../../Feature.js").default} feature Feature.
   * @param {number} [index] Render order index.
   * @override
   */ drawCircle(circleGeometry, feature, index) {
        const state = this.state;
        const fillStyle = state.fillStyle;
        const strokeStyle = state.strokeStyle;
        const strokeOffset = state.strokeOffset;
        if (fillStyle === undefined && strokeStyle === undefined) return;
        if (this.handleStrokeOffset_(()=>this.drawCircle(circleGeometry, feature, index))) return;
        this.setFillStrokeStyles_();
        this.beginGeometry(circleGeometry, feature, index);
        if (state.fillStyle !== undefined) this.hitDetectionInstructions.push([
            (0, $0502284914437a56$export$2e2bcd8739ae039).SET_FILL_STYLE,
            (0, $6a4acf19c5e548d6$export$c495d52ee3fd74b2)
        ]);
        if (state.strokeStyle !== undefined) this.hitDetectionInstructions.push([
            (0, $0502284914437a56$export$2e2bcd8739ae039).SET_STROKE_STYLE,
            state.strokeStyle,
            state.lineWidth,
            state.lineCap,
            state.lineJoin,
            state.miterLimit,
            (0, $6a4acf19c5e548d6$export$e21b4112fdc612fc),
            (0, $6a4acf19c5e548d6$export$e06efc2409049f76)
        ]);
        const flatCoordinates = circleGeometry.getFlatCoordinates();
        const stride = circleGeometry.getStride();
        const myBegin = this.coordinates.length;
        this.appendFlatLineCoordinates(flatCoordinates, 0, flatCoordinates.length, stride, false, false);
        const circleInstruction = [
            (0, $0502284914437a56$export$2e2bcd8739ae039).CIRCLE,
            myBegin,
            strokeOffset
        ];
        this.instructions.push((0, $0502284914437a56$export$9f746cc58a899a00), circleInstruction);
        this.hitDetectionInstructions.push((0, $0502284914437a56$export$9f746cc58a899a00), circleInstruction);
        if (state.fillStyle !== undefined) {
            this.instructions.push((0, $0502284914437a56$export$f21891651e408226));
            this.hitDetectionInstructions.push((0, $0502284914437a56$export$f21891651e408226));
        }
        if (state.strokeStyle !== undefined) {
            this.instructions.push((0, $0502284914437a56$export$7a98aa5364d62ba8));
            this.hitDetectionInstructions.push((0, $0502284914437a56$export$7a98aa5364d62ba8));
        }
        this.endGeometry(feature);
    }
    /**
   * @param {import("../../geom/Polygon.js").default|import("../Feature.js").default} polygonGeometry Polygon geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   * @override
   */ drawPolygon(polygonGeometry, feature, index) {
        const state = this.state;
        const fillStyle = state.fillStyle;
        const strokeStyle = state.strokeStyle;
        const strokeOffset = state.strokeOffset;
        if (fillStyle === undefined && strokeStyle === undefined) return;
        if (this.handleStrokeOffset_(()=>this.drawPolygon(polygonGeometry, feature, index))) return;
        this.setFillStrokeStyles_();
        this.beginGeometry(polygonGeometry, feature, index);
        if (state.fillStyle !== undefined) this.hitDetectionInstructions.push([
            (0, $0502284914437a56$export$2e2bcd8739ae039).SET_FILL_STYLE,
            (0, $6a4acf19c5e548d6$export$c495d52ee3fd74b2)
        ]);
        if (state.strokeStyle !== undefined) this.hitDetectionInstructions.push([
            (0, $0502284914437a56$export$2e2bcd8739ae039).SET_STROKE_STYLE,
            state.strokeStyle,
            state.lineWidth,
            state.lineCap,
            state.lineJoin,
            state.miterLimit,
            (0, $6a4acf19c5e548d6$export$e21b4112fdc612fc),
            (0, $6a4acf19c5e548d6$export$e06efc2409049f76)
        ]);
        const ends = polygonGeometry.getEnds();
        const flatCoordinates = polygonGeometry.getOrientedFlatCoordinates();
        const stride = polygonGeometry.getStride();
        this.drawFlatCoordinatess_(flatCoordinates, 0, /** @type {Array<number>} */ ends, stride, strokeOffset);
        this.endGeometry(feature);
    }
    /**
   * @param {import("../../geom/MultiPolygon.js").default} multiPolygonGeometry MultiPolygon geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   * @override
   */ drawMultiPolygon(multiPolygonGeometry, feature, index) {
        const state = this.state;
        const fillStyle = state.fillStyle;
        const strokeStyle = state.strokeStyle;
        const strokeOffset = state.strokeOffset;
        if (fillStyle === undefined && strokeStyle === undefined) return;
        if (this.handleStrokeOffset_(()=>this.drawMultiPolygon(multiPolygonGeometry, feature, index))) return;
        this.setFillStrokeStyles_();
        this.beginGeometry(multiPolygonGeometry, feature, index);
        if (state.fillStyle !== undefined) this.hitDetectionInstructions.push([
            (0, $0502284914437a56$export$2e2bcd8739ae039).SET_FILL_STYLE,
            (0, $6a4acf19c5e548d6$export$c495d52ee3fd74b2)
        ]);
        if (state.strokeStyle !== undefined) this.hitDetectionInstructions.push([
            (0, $0502284914437a56$export$2e2bcd8739ae039).SET_STROKE_STYLE,
            state.strokeStyle,
            state.lineWidth,
            state.lineCap,
            state.lineJoin,
            state.miterLimit,
            (0, $6a4acf19c5e548d6$export$e21b4112fdc612fc),
            (0, $6a4acf19c5e548d6$export$e06efc2409049f76)
        ]);
        const endss = multiPolygonGeometry.getEndss();
        const flatCoordinates = multiPolygonGeometry.getOrientedFlatCoordinates();
        const stride = multiPolygonGeometry.getStride();
        let offset = 0;
        for(let i = 0, ii = endss.length; i < ii; ++i)offset = this.drawFlatCoordinatess_(flatCoordinates, offset, endss[i], stride, strokeOffset);
        this.endGeometry(feature);
    }
    /**
   * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
   * @override
   */ finish() {
        this.reverseHitDetectionInstructions();
        this.state = null;
        // We want to preserve topology when drawing polygons.  Polygons are
        // simplified using quantization and point elimination. However, we might
        // have received a mix of quantized and non-quantized geometries, so ensure
        // that all are quantized by quantizing all coordinates in the batch.
        const tolerance = this.tolerance;
        if (tolerance !== 0) {
            const coordinates = this.coordinates;
            for(let i = 0, ii = coordinates.length; i < ii; ++i)coordinates[i] = (0, $ef1b6889b1cd47c7$export$51a0620f7a28532b)(coordinates[i], tolerance);
        }
        return super.finish();
    }
    /**
   * @private
   */ setFillStrokeStyles_() {
        const state = this.state;
        this.updateFillStyle(state, this.createFill);
        this.updateStrokeStyle(state, this.applyStroke);
    }
    handleStrokeOffset_(drawGeometryCallback) {
        const state = this.state;
        const fillStyle = state.fillStyle;
        const strokeStyle = state.strokeStyle;
        const strokeOffset = state.strokeOffset;
        // In case both fill style and stroke style are defined and the stroke style has an offset,
        // the stroke and fill should be done in separate steps, because offset stroke shape will
        // be different from the original shape used for the fill.
        if (Math.abs(strokeOffset) > 0 && fillStyle !== undefined && strokeStyle !== undefined) {
            // First do only fill
            state.strokeStyle = undefined;
            state.strokeOffset = 0;
            drawGeometryCallback();
            // Now separately do the stroke
            state.fillStyle = undefined;
            state.strokeStyle = strokeStyle;
            state.strokeOffset = strokeOffset;
            drawGeometryCallback();
            // Reset the state to the original
            state.fillStyle = fillStyle;
            return true;
        }
        return false;
    }
}
var $bf0781f39a04ac61$export$2e2bcd8739ae039 = $bf0781f39a04ac61$var$CanvasPolygonBuilder;


/**
 * @module ol/render/canvas/TextBuilder
 */ 


function $ba3bd2fd2eac3789$export$f08272c6ff321e57(chunkLength, flatCoordinates, offset, end, stride) {
    const chunks = [];
    let cursor = offset;
    let chunkM = 0;
    let currentChunk = flatCoordinates.slice(offset, 2);
    while(chunkM < chunkLength && cursor + stride < end){
        const [x1, y1] = currentChunk.slice(-2);
        const x2 = flatCoordinates[cursor + stride];
        const y2 = flatCoordinates[cursor + stride + 1];
        const segmentLength = Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
        chunkM += segmentLength;
        if (chunkM >= chunkLength) {
            const m = (chunkLength - chunkM + segmentLength) / segmentLength;
            const x = (0, $6a95bd76d7103f37$export$3a89f8d6f6bf6c9f)(x1, x2, m);
            const y = (0, $6a95bd76d7103f37$export$3a89f8d6f6bf6c9f)(y1, y2, m);
            currentChunk.push(x, y);
            chunks.push(currentChunk);
            currentChunk = [
                x,
                y
            ];
            if (chunkM == chunkLength) cursor += stride;
            chunkM = 0;
        } else if (chunkM < chunkLength) {
            currentChunk.push(flatCoordinates[cursor + stride], flatCoordinates[cursor + stride + 1]);
            cursor += stride;
        } else {
            const missing = segmentLength - chunkM;
            const x = (0, $6a95bd76d7103f37$export$3a89f8d6f6bf6c9f)(x1, x2, missing / segmentLength);
            const y = (0, $6a95bd76d7103f37$export$3a89f8d6f6bf6c9f)(y1, y2, missing / segmentLength);
            currentChunk.push(x, y);
            chunks.push(currentChunk);
            currentChunk = [
                x,
                y
            ];
            chunkM = 0;
            cursor += stride;
        }
    }
    if (chunkM > 0) chunks.push(currentChunk);
    return chunks;
}


/**
 * @module ol/geom/flat/straightchunk
 */ /**
 * @param {number} maxAngle Maximum acceptable angle delta between segments.
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @return {Array<number>} Start and end of the first suitable chunk of the
 * given `flatCoordinates`.
 */ function $2b97a07eab5a47e2$export$ed6c897eea07a254(maxAngle, flatCoordinates, offset, end, stride) {
    let chunkStart = offset;
    let chunkEnd = offset;
    let chunkM = 0;
    let m = 0;
    let start = offset;
    let acos, i, m12, m23, x1, y1, x12, y12, x23, y23;
    for(i = offset; i < end; i += stride){
        const x2 = flatCoordinates[i];
        const y2 = flatCoordinates[i + 1];
        if (x1 !== undefined) {
            x23 = x2 - x1;
            y23 = y2 - y1;
            m23 = Math.sqrt(x23 * x23 + y23 * y23);
            if (x12 !== undefined) {
                m += m12;
                acos = Math.acos((x12 * x23 + y12 * y23) / (m12 * m23));
                if (acos > maxAngle) {
                    if (m > chunkM) {
                        chunkM = m;
                        chunkStart = start;
                        chunkEnd = i;
                    }
                    m = 0;
                    start = i - stride;
                }
            }
            m12 = m23;
            x12 = x23;
            y12 = y23;
        }
        x1 = x2;
        y1 = y2;
    }
    m += m23;
    return m > chunkM ? [
        start,
        i
    ] : [
        chunkStart,
        chunkEnd
    ];
}






const $3904307ab786898a$export$91a016276e4aee96 = {
    'left': 0,
    'center': 0.5,
    'right': 1,
    'top': 0,
    'middle': 0.5,
    'hanging': 0.2,
    'alphabetic': 0.8,
    'ideographic': 0.8,
    'bottom': 1
};
class $3904307ab786898a$var$CanvasTextBuilder extends (0, $01e4df6bd3c09b14$export$2e2bcd8739ae039) {
    /**
   * @param {number} tolerance Tolerance.
   * @param {import("../../extent.js").Extent} maxExtent Maximum extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   */ constructor(tolerance, maxExtent, resolution, pixelRatio){
        super(tolerance, maxExtent, resolution, pixelRatio);
        /**
     * @private
     * @type {Array<HTMLCanvasElement>}
     */ this.labels_ = null;
        /**
     * @private
     * @type {string|Array<string>}
     */ this.text_ = '';
        /**
     * @private
     * @type {number}
     */ this.textOffsetX_ = 0;
        /**
     * @private
     * @type {number}
     */ this.textOffsetY_ = 0;
        /**
     * @private
     * @type {boolean|undefined}
     */ this.textRotateWithView_ = undefined;
        /**
     * @private
     * @type {boolean|undefined}
     */ this.textKeepUpright_ = undefined;
        /**
     * @private
     * @type {number}
     */ this.textRotation_ = 0;
        /**
     * @private
     * @type {?import("../canvas.js").FillState}
     */ this.textFillState_ = null;
        /**
     * @type {!Object<string, import("../canvas.js").FillState>}
     */ this.fillStates = {};
        this.fillStates[0, $6a4acf19c5e548d6$export$c495d52ee3fd74b2] = {
            fillStyle: (0, $6a4acf19c5e548d6$export$c495d52ee3fd74b2)
        };
        /**
     * @private
     * @type {?import("../canvas.js").StrokeState}
     */ this.textStrokeState_ = null;
        /**
     * @type {!Object<string, import("../canvas.js").StrokeState>}
     */ this.strokeStates = {};
        /**
     * @private
     * @type {import("../canvas.js").TextState}
     */ this.textState_ = /** @type {import("../canvas.js").TextState} */ {};
        /**
     * @type {!Object<string, import("../canvas.js").TextState>}
     */ this.textStates = {};
        /**
     * @private
     * @type {string}
     */ this.textKey_ = '';
        /**
     * @private
     * @type {string}
     */ this.fillKey_ = '';
        /**
     * @private
     * @type {string}
     */ this.strokeKey_ = '';
        /**
     * @private
     * @type {import('../../style/Style.js').DeclutterMode}
     */ this.declutterMode_ = undefined;
        /**
     * Data shared with an image builder for combined decluttering.
     * @private
     * @type {import("../canvas.js").DeclutterImageWithText}
     */ this.declutterImageWithText_ = undefined;
    }
    /**
   * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
   * @override
   */ finish() {
        const instructions = super.finish();
        instructions.textStates = this.textStates;
        instructions.fillStates = this.fillStates;
        instructions.strokeStates = this.strokeStates;
        return instructions;
    }
    /**
   * @param {import("../../geom/SimpleGeometry.js").default|import("../Feature.js").default} geometry Geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   * @override
   */ drawText(geometry, feature, index) {
        const fillState = this.textFillState_;
        const strokeState = this.textStrokeState_;
        const textState = this.textState_;
        if (this.text_ === '' || !textState || !fillState && !strokeState) return;
        const coordinates = this.coordinates;
        let begin = coordinates.length;
        const geometryType = geometry.getType();
        let flatCoordinates = null;
        let stride = geometry.getStride();
        if (textState.placement === 'line' && (geometryType == 'LineString' || geometryType == 'MultiLineString' || geometryType == 'Polygon' || geometryType == 'MultiPolygon')) {
            if (!(0, $dea65c2f666fa450$export$7b0a31e10bbff018)(this.maxExtent, geometry.getExtent())) return;
            let ends;
            flatCoordinates = geometry.getFlatCoordinates();
            if (geometryType == 'LineString') ends = [
                flatCoordinates.length
            ];
            else if (geometryType == 'MultiLineString') ends = /** @type {import("../../geom/MultiLineString.js").default} */ geometry.getEnds();
            else if (geometryType == 'Polygon') ends = /** @type {import("../../geom/Polygon.js").default} */ geometry.getEnds().slice(0, 1);
            else if (geometryType == 'MultiPolygon') {
                const endss = /** @type {import("../../geom/MultiPolygon.js").default} */ geometry.getEndss();
                ends = [];
                for(let i = 0, ii = endss.length; i < ii; ++i)ends.push(endss[i][0]);
            }
            this.beginGeometry(geometry, feature, index);
            const repeat = textState.repeat;
            const textAlign = repeat ? undefined : textState.textAlign;
            // No `justify` support for line placement.
            let flatOffset = 0;
            for(let o = 0, oo = ends.length; o < oo; ++o){
                let chunks;
                if (repeat) chunks = (0, $ba3bd2fd2eac3789$export$f08272c6ff321e57)(repeat * this.resolution, flatCoordinates, flatOffset, ends[o], stride);
                else chunks = [
                    flatCoordinates.slice(flatOffset, ends[o])
                ];
                for(let c = 0, cc = chunks.length; c < cc; ++c){
                    const chunk = chunks[c];
                    let chunkBegin = 0;
                    let chunkEnd = chunk.length;
                    if (textAlign == undefined) {
                        const range = (0, $2b97a07eab5a47e2$export$ed6c897eea07a254)(textState.maxAngle, chunk, 0, chunk.length, 2);
                        chunkBegin = range[0];
                        chunkEnd = range[1];
                    }
                    for(let i = chunkBegin; i < chunkEnd; i += stride)coordinates.push(chunk[i], chunk[i + 1]);
                    const end = coordinates.length;
                    flatOffset = ends[o];
                    this.drawChars_(begin, end);
                    begin = end;
                }
            }
            this.endGeometry(feature);
        } else {
            let geometryWidths = textState.overflow ? null : [];
            switch(geometryType){
                case 'Point':
                case 'MultiPoint':
                    flatCoordinates = /** @type {import("../../geom/MultiPoint.js").default} */ geometry.getFlatCoordinates();
                    break;
                case 'LineString':
                    flatCoordinates = /** @type {import("../../geom/LineString.js").default} */ geometry.getFlatMidpoint();
                    break;
                case 'Circle':
                    flatCoordinates = /** @type {import("../../geom/Circle.js").default} */ geometry.getCenter();
                    break;
                case 'MultiLineString':
                    flatCoordinates = /** @type {import("../../geom/MultiLineString.js").default} */ geometry.getFlatMidpoints();
                    stride = 2;
                    break;
                case 'Polygon':
                    flatCoordinates = /** @type {import("../../geom/Polygon.js").default} */ geometry.getFlatInteriorPoint();
                    if (!textState.overflow) geometryWidths.push(flatCoordinates[2] / this.resolution);
                    stride = 3;
                    break;
                case 'MultiPolygon':
                    const interiorPoints = /** @type {import("../../geom/MultiPolygon.js").default} */ geometry.getFlatInteriorPoints();
                    flatCoordinates = [];
                    for(let i = 0, ii = interiorPoints.length; i < ii; i += 3){
                        if (!textState.overflow) geometryWidths.push(interiorPoints[i + 2] / this.resolution);
                        flatCoordinates.push(interiorPoints[i], interiorPoints[i + 1]);
                    }
                    if (flatCoordinates.length === 0) return;
                    stride = 2;
                    break;
                default:
            }
            const end = this.appendFlatPointCoordinates(flatCoordinates, stride);
            if (end === begin) return;
            if (geometryWidths && (end - begin) / 2 !== flatCoordinates.length / stride) {
                let beg = begin / 2;
                geometryWidths = geometryWidths.filter((w, i)=>{
                    const keep = coordinates[(beg + i) * 2] === flatCoordinates[i * stride] && coordinates[(beg + i) * 2 + 1] === flatCoordinates[i * stride + 1];
                    if (!keep) --beg;
                    return keep;
                });
            }
            this.saveTextStates_();
            const backgroundFill = textState.backgroundFill ? this.createFill(this.fillStyleToState(textState.backgroundFill)) : null;
            const backgroundStroke = textState.backgroundStroke ? this.createStroke(this.strokeStyleToState(textState.backgroundStroke)) : null;
            this.beginGeometry(geometry, feature, index);
            // adjust padding for negative scale
            let padding = textState.padding;
            if (padding != (0, $6a4acf19c5e548d6$export$40a9eeef55665a40) && (textState.scale[0] < 0 || textState.scale[1] < 0)) {
                let p0 = textState.padding[0];
                let p1 = textState.padding[1];
                let p2 = textState.padding[2];
                let p3 = textState.padding[3];
                if (textState.scale[0] < 0) {
                    p1 = -p1;
                    p3 = -p3;
                }
                if (textState.scale[1] < 0) {
                    p0 = -p0;
                    p2 = -p2;
                }
                padding = [
                    p0,
                    p1,
                    p2,
                    p3
                ];
            }
            // The image is unknown at this stage so we pass null; it will be computed at render time.
            // For clarity, we pass NaN for offsetX, offsetY, width and height, which will be computed at
            // render time.
            const pixelRatio = this.pixelRatio;
            this.instructions.push([
                (0, $0502284914437a56$export$2e2bcd8739ae039).DRAW_IMAGE,
                begin,
                end,
                null,
                NaN,
                NaN,
                NaN,
                1,
                0,
                0,
                this.textRotateWithView_,
                this.textRotation_,
                [
                    1,
                    1
                ],
                NaN,
                this.declutterMode_,
                this.declutterImageWithText_,
                padding == (0, $6a4acf19c5e548d6$export$40a9eeef55665a40) ? (0, $6a4acf19c5e548d6$export$40a9eeef55665a40) : padding.map(function(p) {
                    return p * pixelRatio;
                }),
                backgroundFill,
                backgroundStroke,
                this.text_,
                this.textKey_,
                this.strokeKey_,
                this.fillKey_,
                this.textOffsetX_,
                this.textOffsetY_,
                geometryWidths
            ]);
            const scale = 1 / pixelRatio;
            // Set default fill for hit detection background
            const hitDetectionBackgroundFill = backgroundFill ? backgroundFill.slice(0) : null;
            if (hitDetectionBackgroundFill) hitDetectionBackgroundFill[1] = (0, $6a4acf19c5e548d6$export$c495d52ee3fd74b2);
            this.hitDetectionInstructions.push([
                (0, $0502284914437a56$export$2e2bcd8739ae039).DRAW_IMAGE,
                begin,
                end,
                null,
                NaN,
                NaN,
                NaN,
                1,
                0,
                0,
                this.textRotateWithView_,
                this.textRotation_,
                [
                    scale,
                    scale
                ],
                NaN,
                this.declutterMode_,
                this.declutterImageWithText_,
                padding,
                hitDetectionBackgroundFill,
                backgroundStroke,
                this.text_,
                this.textKey_,
                this.strokeKey_,
                this.fillKey_ ? (0, $6a4acf19c5e548d6$export$c495d52ee3fd74b2) : this.fillKey_,
                this.textOffsetX_,
                this.textOffsetY_,
                geometryWidths
            ]);
            this.endGeometry(feature);
        }
    }
    /**
   * @private
   */ saveTextStates_() {
        const strokeState = this.textStrokeState_;
        const textState = this.textState_;
        const fillState = this.textFillState_;
        const strokeKey = this.strokeKey_;
        if (strokeState) {
            if (!(strokeKey in this.strokeStates)) this.strokeStates[strokeKey] = {
                strokeStyle: strokeState.strokeStyle,
                lineCap: strokeState.lineCap,
                lineDashOffset: strokeState.lineDashOffset,
                lineWidth: strokeState.lineWidth,
                lineJoin: strokeState.lineJoin,
                miterLimit: strokeState.miterLimit,
                lineDash: strokeState.lineDash
            };
        }
        const textKey = this.textKey_;
        if (!(textKey in this.textStates)) this.textStates[textKey] = {
            font: textState.font,
            textAlign: textState.textAlign || (0, $6a4acf19c5e548d6$export$94d53b95641b5766),
            justify: textState.justify,
            textBaseline: textState.textBaseline || (0, $6a4acf19c5e548d6$export$cf2279a1bff62eb),
            scale: textState.scale
        };
        const fillKey = this.fillKey_;
        if (fillState) {
            if (!(fillKey in this.fillStates)) this.fillStates[fillKey] = {
                fillStyle: fillState.fillStyle
            };
        }
    }
    /**
   * @private
   * @param {number} begin Begin.
   * @param {number} end End.
   */ drawChars_(begin, end) {
        const strokeState = this.textStrokeState_;
        const textState = this.textState_;
        const strokeKey = this.strokeKey_;
        const textKey = this.textKey_;
        const fillKey = this.fillKey_;
        this.saveTextStates_();
        const pixelRatio = this.pixelRatio;
        const baseline = $3904307ab786898a$export$91a016276e4aee96[textState.textBaseline];
        const offsetY = this.textOffsetY_ * pixelRatio;
        const text = this.text_;
        const strokeWidth = strokeState ? strokeState.lineWidth * Math.abs(textState.scale[0]) / 2 : 0;
        this.instructions.push([
            (0, $0502284914437a56$export$2e2bcd8739ae039).DRAW_CHARS,
            begin,
            end,
            baseline,
            textState.overflow,
            fillKey,
            textState.maxAngle,
            pixelRatio,
            offsetY,
            strokeKey,
            strokeWidth * pixelRatio,
            text,
            textKey,
            1,
            this.declutterMode_,
            this.textKeepUpright_
        ]);
        this.hitDetectionInstructions.push([
            (0, $0502284914437a56$export$2e2bcd8739ae039).DRAW_CHARS,
            begin,
            end,
            baseline,
            textState.overflow,
            fillKey ? (0, $6a4acf19c5e548d6$export$c495d52ee3fd74b2) : fillKey,
            textState.maxAngle,
            pixelRatio,
            offsetY,
            strokeKey,
            strokeWidth * pixelRatio,
            text,
            textKey,
            1 / pixelRatio,
            this.declutterMode_,
            this.textKeepUpright_
        ]);
    }
    /**
   * @param {import("../../style/Text.js").default} textStyle Text style.
   * @param {Object} [sharedData] Shared data.
   * @override
   */ setTextStyle(textStyle, sharedData) {
        let textState, fillState, strokeState;
        if (!textStyle) this.text_ = '';
        else {
            const textFillStyle = textStyle.getFill();
            if (!textFillStyle) {
                fillState = null;
                this.textFillState_ = fillState;
            } else {
                fillState = this.textFillState_;
                if (!fillState) {
                    fillState = /** @type {import("../canvas.js").FillState} */ {};
                    this.textFillState_ = fillState;
                }
                fillState.fillStyle = (0, $c236b40ac833efca$export$dc5b1400ac3a10a8)(textFillStyle.getColor() || (0, $6a4acf19c5e548d6$export$c495d52ee3fd74b2));
            }
            const textStrokeStyle = textStyle.getStroke();
            if (!textStrokeStyle) {
                strokeState = null;
                this.textStrokeState_ = strokeState;
            } else {
                strokeState = this.textStrokeState_;
                if (!strokeState) {
                    strokeState = /** @type {import("../canvas.js").StrokeState} */ {};
                    this.textStrokeState_ = strokeState;
                }
                const lineDash = textStrokeStyle.getLineDash();
                const lineDashOffset = textStrokeStyle.getLineDashOffset();
                const lineWidth = textStrokeStyle.getWidth();
                const miterLimit = textStrokeStyle.getMiterLimit();
                strokeState.lineCap = textStrokeStyle.getLineCap() || (0, $6a4acf19c5e548d6$export$17bd0c38d6ae694e);
                strokeState.lineDash = lineDash ? lineDash.slice() : (0, $6a4acf19c5e548d6$export$e21b4112fdc612fc);
                strokeState.lineDashOffset = lineDashOffset === undefined ? (0, $6a4acf19c5e548d6$export$e06efc2409049f76) : lineDashOffset;
                strokeState.lineJoin = textStrokeStyle.getLineJoin() || (0, $6a4acf19c5e548d6$export$365eb9648cf19bd0);
                strokeState.lineWidth = lineWidth === undefined ? (0, $6a4acf19c5e548d6$export$79661f132c62010e) : lineWidth;
                strokeState.miterLimit = miterLimit === undefined ? (0, $6a4acf19c5e548d6$export$80c1c01844597b7b) : miterLimit;
                strokeState.strokeStyle = (0, $c236b40ac833efca$export$dc5b1400ac3a10a8)(textStrokeStyle.getColor() || (0, $6a4acf19c5e548d6$export$1eb2eaecacf2031e));
            }
            textState = this.textState_;
            const font = textStyle.getFont() || (0, $6a4acf19c5e548d6$export$3847dfea4f8d4dfa);
            (0, $6a4acf19c5e548d6$export$a534074a28fa87ff)(font);
            const textScale = textStyle.getScaleArray();
            textState.overflow = textStyle.getOverflow();
            textState.font = font;
            textState.maxAngle = textStyle.getMaxAngle();
            textState.placement = textStyle.getPlacement();
            textState.textAlign = textStyle.getTextAlign();
            textState.repeat = textStyle.getRepeat();
            textState.justify = textStyle.getJustify();
            textState.textBaseline = textStyle.getTextBaseline() || (0, $6a4acf19c5e548d6$export$cf2279a1bff62eb);
            textState.backgroundFill = textStyle.getBackgroundFill();
            textState.backgroundStroke = textStyle.getBackgroundStroke();
            textState.padding = textStyle.getPadding() || (0, $6a4acf19c5e548d6$export$40a9eeef55665a40);
            textState.scale = textScale === undefined ? [
                1,
                1
            ] : textScale;
            const textOffsetX = textStyle.getOffsetX();
            const textOffsetY = textStyle.getOffsetY();
            const textRotateWithView = textStyle.getRotateWithView();
            const textKeepUpright = textStyle.getKeepUpright();
            const textRotation = textStyle.getRotation();
            this.text_ = textStyle.getText() || '';
            this.textOffsetX_ = textOffsetX === undefined ? 0 : textOffsetX;
            this.textOffsetY_ = textOffsetY === undefined ? 0 : textOffsetY;
            this.textRotateWithView_ = textRotateWithView === undefined ? false : textRotateWithView;
            this.textKeepUpright_ = textKeepUpright === undefined ? true : textKeepUpright;
            this.textRotation_ = textRotation === undefined ? 0 : textRotation;
            this.strokeKey_ = strokeState ? (typeof strokeState.strokeStyle == 'string' ? strokeState.strokeStyle : (0, $fd76d391cc228565$export$5e82334337e0f204)(strokeState.strokeStyle)) + strokeState.lineCap + strokeState.lineDashOffset + '|' + strokeState.lineWidth + strokeState.lineJoin + strokeState.miterLimit + '[' + strokeState.lineDash.join() + ']' : '';
            this.textKey_ = textState.font + textState.scale + (textState.textAlign || '?') + (textState.repeat || '?') + (textState.justify || '?') + (textState.textBaseline || '?');
            this.fillKey_ = fillState && fillState.fillStyle ? typeof fillState.fillStyle == 'string' ? fillState.fillStyle : '|' + (0, $fd76d391cc228565$export$5e82334337e0f204)(fillState.fillStyle) : '';
        }
        this.declutterMode_ = textStyle.getDeclutterMode();
        this.declutterImageWithText_ = sharedData;
    }
}
var $3904307ab786898a$export$2e2bcd8739ae039 = $3904307ab786898a$var$CanvasTextBuilder;


/**
 * @type {Object<import("../canvas.js").BuilderType, typeof Builder>}
 */ const $4ec4bc54afb0adab$var$BATCH_CONSTRUCTORS = {
    'Circle': (0, $bf0781f39a04ac61$export$2e2bcd8739ae039),
    'Default': (0, $01e4df6bd3c09b14$export$2e2bcd8739ae039),
    'Image': (0, $665a5e595556c6a0$export$2e2bcd8739ae039),
    'LineString': (0, $cf869edeee40aaa3$export$2e2bcd8739ae039),
    'Polygon': (0, $bf0781f39a04ac61$export$2e2bcd8739ae039),
    'Text': (0, $3904307ab786898a$export$2e2bcd8739ae039)
};
class $4ec4bc54afb0adab$var$BuilderGroup {
    /**
   * @param {number} tolerance Tolerance.
   * @param {import("../../extent.js").Extent} maxExtent Max extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   */ constructor(tolerance, maxExtent, resolution, pixelRatio){
        /**
     * @private
     * @type {number}
     */ this.tolerance_ = tolerance;
        /**
     * @private
     * @type {import("../../extent.js").Extent}
     */ this.maxExtent_ = maxExtent;
        /**
     * @private
     * @type {number}
     */ this.pixelRatio_ = pixelRatio;
        /**
     * @private
     * @type {number}
     */ this.resolution_ = resolution;
        /**
     * @private
     * @type {!Object<string, !Object<import("../canvas.js").BuilderType, Builder>>}
     */ this.buildersByZIndex_ = {};
    }
    /**
   * @return {!Object<string, !Object<import("../canvas.js").BuilderType, import("./Builder.js").SerializableInstructions>>} The serializable instructions
   */ finish() {
        const builderInstructions = {};
        for(const zKey in this.buildersByZIndex_){
            builderInstructions[zKey] = builderInstructions[zKey] || {};
            const builders = this.buildersByZIndex_[zKey];
            for(const builderKey in builders){
                const builderInstruction = builders[builderKey].finish();
                builderInstructions[zKey][builderKey] = builderInstruction;
            }
        }
        return builderInstructions;
    }
    /**
   * @param {number|undefined} zIndex Z index.
   * @param {import("../canvas.js").BuilderType} builderType Replay type.
   * @return {import("../VectorContext.js").default} Replay.
   */ getBuilder(zIndex, builderType) {
        const zIndexKey = zIndex !== undefined ? zIndex.toString() : '0';
        let replays = this.buildersByZIndex_[zIndexKey];
        if (replays === undefined) {
            replays = {};
            this.buildersByZIndex_[zIndexKey] = replays;
        }
        let replay = replays[builderType];
        if (replay === undefined) {
            const Constructor = $4ec4bc54afb0adab$var$BATCH_CONSTRUCTORS[builderType];
            replay = new Constructor(this.tolerance_, this.maxExtent_, this.resolution_, this.pixelRatio_);
            replays[builderType] = replay;
        }
        return replay;
    }
}
var $4ec4bc54afb0adab$export$2e2bcd8739ae039 = $4ec4bc54afb0adab$var$BuilderGroup;


/**
 * @module ol/render/canvas/ExecutorGroup
 */ 





/**
 * @module ol/render/canvas/Executor
 */ 



function $8783b79cc48761bc$export$a6b2441cc3fe7033(flatCoordinates, stride, offset, isClosedRing, dest, destinationStride) {
    dest = dest ?? [];
    destinationStride = destinationStride ?? stride;
    const firstPointX = flatCoordinates[0];
    const firstPointY = flatCoordinates[1];
    const secondToLastPointX = flatCoordinates[flatCoordinates.length - 4];
    const secondToLastPointY = flatCoordinates[flatCoordinates.length - 3];
    let x, y, prevX, prevY, nextX, nextY, offsetX, offsetY;
    let i = 0;
    for(let j = 0; j < flatCoordinates.length; j += stride){
        // 1. Detect previous and next coordinates of a current vertex
        prevX = x;
        prevY = y;
        nextX = undefined;
        nextY = undefined;
        if (j + stride < flatCoordinates.length) {
            nextX = flatCoordinates[j + stride];
            nextY = flatCoordinates[j + stride + 1];
        }
        // First coordinate of a closed ring -> previous coordinate is the second to last one
        if (isClosedRing && j === 0) {
            prevX = secondToLastPointX;
            prevY = secondToLastPointY;
        }
        // Last coordinate of a closed ring -> next coordinate is the first vertex of a line string
        if (isClosedRing && j === flatCoordinates.length - 2) {
            // last coordinate
            nextX = firstPointX;
            nextY = firstPointY;
        }
        // 2. Current vertex to offset
        x = flatCoordinates[j];
        y = flatCoordinates[j + 1];
        // 3. Offset the vertex
        [offsetX, offsetY] = $8783b79cc48761bc$export$1d816e12adb721de(x, y, prevX, prevY, nextX, nextY, offset);
        dest[i++] = offsetX;
        dest[i++] = offsetY;
        // 4. Copy over other dimension values if any
        for(let k = 2; k < destinationStride; k++)dest[i++] = flatCoordinates[j + k];
    }
    if (dest.length != i) dest.length = i;
    return dest;
}
function $8783b79cc48761bc$export$1d816e12adb721de(x, y, prevX, prevY, nextX, nextY, offset) {
    // Compute segment direction
    let nx, ny;
    if (prevX !== undefined && prevY !== undefined) {
        nx = x - prevX;
        ny = y - prevY;
    } else if (nextX !== undefined && nextY !== undefined) {
        nx = nextX - x;
        ny = nextY - y;
    } else {
        // no next, no previous point given -> just assume some default (horizontal) direction
        nx = 1;
        ny = 0;
    }
    // Normalize -> tangent
    const len = Math.hypot(nx, ny);
    const tx = nx / len;
    const ty = ny / len;
    // Rotate tangent 90° -> normal
    nx = -ty;
    ny = tx;
    // First / last vertex -> offset the point in the direction of the normal vector
    if (prevX === undefined || prevY === undefined) return [
        x + nx * offset,
        y + ny * offset
    ];
    if (nextX === undefined || nextY === undefined) return [
        x + nx * offset,
        y + ny * offset
    ];
    // Compute join angle - angle between 2 segments of the vertex.
    const joinAngle = (0, $a6adb03fd2fbc071$export$47cb7eb79666608a)([
        x,
        y
    ], [
        prevX,
        prevY
    ], [
        nextX,
        nextY
    ]);
    // Avoid huge or infinite miter joins for very sharp angles, offset in the segment direction in this case.
    if (Math.cos(joinAngle) > 0.998) return [
        x + tx * offset,
        y + ty * offset
    ];
    // Compute join offset direction.
    // We rotate the normal vector by half of the join angle.
    // This gives the direction of the miter at the vertex.
    const cos = Math.cos(joinAngle / 2);
    const sin = Math.sin(joinAngle / 2);
    // Rotate the normal vector (nx, ny) by half of the join angle.
    // bx/by = bisector direction before normalization
    const bx = sin * nx + cos * ny;
    const by = -cos * nx + sin * ny;
    // Scale the bisector so that moving along it preserves the correct offset distance.
    // Dividing by sin(half of angle) converts the bisector into the true miter vector.
    // (This expands the miter for sharp angles and shortens it for wide ones.)
    const dx = bx * (1 / sin);
    const dy = by * (1 / sin);
    // Offset final vertex along miter direction
    return [
        x + dx * offset,
        y + dy * offset
    ];
}


/**
 * @module ol/geom/flat/textpath
 */ 

function $85f10bfa11073e75$export$153a9a17ab3e949f(flatCoordinates, offset, end, stride, text, startM, maxAngle, scale, measureAndCacheTextWidth, font, cache, rotation, keepUpright = true) {
    let x2 = flatCoordinates[offset];
    let y2 = flatCoordinates[offset + 1];
    let x1 = 0;
    let y1 = 0;
    let segmentLength = 0;
    let segmentM = 0;
    function advance() {
        x1 = x2;
        y1 = y2;
        offset += stride;
        x2 = flatCoordinates[offset];
        y2 = flatCoordinates[offset + 1];
        segmentM += segmentLength;
        segmentLength = Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
    }
    do advance();
    while (offset < end - stride && segmentM + segmentLength < startM);
    let interpolate = segmentLength === 0 ? 0 : (startM - segmentM) / segmentLength;
    const beginX = (0, $6a95bd76d7103f37$export$3a89f8d6f6bf6c9f)(x1, x2, interpolate);
    const beginY = (0, $6a95bd76d7103f37$export$3a89f8d6f6bf6c9f)(y1, y2, interpolate);
    const startOffset = offset - stride;
    const startLength = segmentM;
    const endM = startM + scale * measureAndCacheTextWidth(font, text, cache);
    while(offset < end - stride && segmentM + segmentLength < endM)advance();
    interpolate = segmentLength === 0 ? 0 : (endM - segmentM) / segmentLength;
    const endX = (0, $6a95bd76d7103f37$export$3a89f8d6f6bf6c9f)(x1, x2, interpolate);
    const endY = (0, $6a95bd76d7103f37$export$3a89f8d6f6bf6c9f)(y1, y2, interpolate);
    // Keep text upright if the option is selected
    let reverse = false;
    if (keepUpright) {
        if (rotation) {
            const flat = [
                beginX,
                beginY,
                endX,
                endY
            ];
            (0, $d95a11593b39996c$export$bb628a54ab399bc9)(flat, 0, 4, 2, rotation, flat, flat);
            reverse = flat[0] > flat[2];
        } else reverse = beginX > endX;
    }
    const PI = Math.PI;
    const result = [];
    const singleSegment = startOffset + stride === offset;
    offset = startOffset;
    segmentLength = 0;
    segmentM = startLength;
    x2 = flatCoordinates[offset];
    y2 = flatCoordinates[offset + 1];
    let previousAngle;
    // All on the same segment
    if (singleSegment) {
        advance();
        previousAngle = Math.atan2(y2 - y1, x2 - x1);
        if (reverse) previousAngle += previousAngle > 0 ? -PI : PI;
        const x = (endX + beginX) / 2;
        const y = (endY + beginY) / 2;
        result[0] = [
            x,
            y,
            (endM - startM) / 2,
            previousAngle,
            text
        ];
        return result;
    }
    // rendering across line segments
    text = text.replace(/\n/g, ' '); // ensure rendering in single-line as all calculations below don't handle multi-lines
    for(let i = 0, ii = text.length; i < ii;){
        advance();
        let angle = Math.atan2(y2 - y1, x2 - x1);
        if (reverse) angle += angle > 0 ? -PI : PI;
        if (previousAngle !== undefined) {
            let delta = angle - previousAngle;
            delta += delta > PI ? -2 * PI : delta < -PI ? 2 * PI : 0;
            if (Math.abs(delta) > maxAngle) return null;
        }
        previousAngle = angle;
        const iStart = i;
        let charLength = 0;
        for(; i < ii; ++i){
            const index = reverse ? ii - i - 1 : i;
            const len = scale * measureAndCacheTextWidth(font, text[index], cache);
            if (offset + stride < end && segmentM + segmentLength < startM + charLength + len / 2) break;
            charLength += len;
        }
        if (i === iStart) continue;
        const chars = reverse ? text.substring(ii - iStart, ii - i) : text.substring(iStart, i);
        interpolate = segmentLength === 0 ? 0 : (startM + charLength / 2 - segmentM) / segmentLength;
        const x = (0, $6a95bd76d7103f37$export$3a89f8d6f6bf6c9f)(x1, x2, interpolate);
        const y = (0, $6a95bd76d7103f37$export$3a89f8d6f6bf6c9f)(y1, y2, interpolate);
        result.push([
            x,
            y,
            charLength / 2,
            angle,
            chars
        ]);
        startM += charLength;
    }
    return result;
}








/**
 * @typedef {import('../../structs/RBush.js').Entry<import('../../Feature.js').FeatureLike>} DeclutterEntry
 */ /**
 * @typedef {Object} ImageOrLabelDimensions
 * @property {number} drawImageX DrawImageX.
 * @property {number} drawImageY DrawImageY.
 * @property {number} drawImageW DrawImageW.
 * @property {number} drawImageH DrawImageH.
 * @property {number} originX OriginX.
 * @property {number} originY OriginY.
 * @property {Array<number>} scale Scale.
 * @property {DeclutterEntry} declutterBox DeclutterBox.
 * @property {import("../../transform.js").Transform} canvasTransform CanvasTransform.
 */ /**
 * @typedef {{0: CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D, 1: import('../../size.js').Size, 2: import("../canvas.js").Label|HTMLImageElement|HTMLCanvasElement|HTMLVideoElement, 3: ImageOrLabelDimensions, 4: number, 5: Array<*>, 6: Array<*>}} ReplayImageOrLabelArgs
 */ /**
 * @template T
 * @typedef {function(import("../../Feature.js").FeatureLike, import("../../geom/SimpleGeometry.js").default, import("../../style/Style.js").DeclutterMode): T} FeatureCallback
 */ /**
 * @type {import("../../extent.js").Extent}
 */ const $ffb724b6902a6567$var$tmpExtent = (0, $dea65c2f666fa450$export$fe201bb3bbe031e9)();
/** @type {import("../../coordinate.js").Coordinate} */ const $ffb724b6902a6567$var$p1 = [];
/** @type {import("../../coordinate.js").Coordinate} */ const $ffb724b6902a6567$var$p2 = [];
/** @type {import("../../coordinate.js").Coordinate} */ const $ffb724b6902a6567$var$p3 = [];
/** @type {import("../../coordinate.js").Coordinate} */ const $ffb724b6902a6567$var$p4 = [];
/**
 * @param {ReplayImageOrLabelArgs} replayImageOrLabelArgs Arguments to replayImageOrLabel
 * @return {DeclutterEntry} Declutter rbush entry.
 */ function $ffb724b6902a6567$var$getDeclutterBox(replayImageOrLabelArgs) {
    return replayImageOrLabelArgs[3].declutterBox;
}
const $ffb724b6902a6567$var$rtlRegEx = new RegExp(/* eslint-disable prettier/prettier */ '[' + String.fromCharCode(0x00591) + '-' + String.fromCharCode(0x008ff) + String.fromCharCode(0x0fb1d) + '-' + String.fromCharCode(0x0fdff) + String.fromCharCode(0x0fe70) + '-' + String.fromCharCode(0x0fefc) + String.fromCharCode(0x10800) + '-' + String.fromCharCode(0x10fff) + String.fromCharCode(0x1e800) + '-' + String.fromCharCode(0x1efff) + ']');
/**
 * @param {string} text Text.
 * @param {CanvasTextAlign} align Alignment.
 * @return {number} Text alignment.
 */ function $ffb724b6902a6567$var$horizontalTextAlign(text, align) {
    if (align === 'start') align = $ffb724b6902a6567$var$rtlRegEx.test(text) ? 'right' : 'left';
    else if (align === 'end') align = $ffb724b6902a6567$var$rtlRegEx.test(text) ? 'left' : 'right';
    return (0, $3904307ab786898a$export$91a016276e4aee96)[align];
}
/**
 * @param {Array<string>} acc Accumulator.
 * @param {string} line Line of text.
 * @param {number} i Index
 * @return {Array<string>} Accumulator.
 */ function $ffb724b6902a6567$var$createTextChunks(acc, line, i) {
    if (i > 0) acc.push('\n', '');
    acc.push(line, '');
    return acc;
}
/**
 * Converts rich text to plain text for text along lines.
 * @param {string} result The resulting plain text.
 * @param {string} part Item of the rich text array.
 * @param {number} index Index of the item in the rich text array.
 * @return {string} The resulting plain text.
 */ function $ffb724b6902a6567$var$richTextToPlainText(result, part, index) {
    if (index % 2 === 0) result += part;
    return result;
}
class $ffb724b6902a6567$var$Executor {
    /**
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   * @param {boolean} overlaps The replay can have overlapping geometries.
   * @param {import("../canvas.js").SerializableInstructions} instructions The serializable instructions.
   * @param {boolean} [deferredRendering] Enable deferred rendering.
   */ constructor(resolution, pixelRatio, overlaps, instructions, deferredRendering){
        /**
     * @protected
     * @type {boolean}
     */ this.overlaps = overlaps;
        /**
     * @protected
     * @type {number}
     */ this.pixelRatio = pixelRatio;
        /**
     * @protected
     * @const
     * @type {number}
     */ this.resolution = resolution;
        /**
     * @private
     * @type {number}
     */ this.alignAndScaleFill_;
        /**
     * @protected
     * @type {Array<*>}
     */ this.instructions = instructions.instructions;
        /**
     * @protected
     * @type {Array<number>}
     */ this.coordinates = instructions.coordinates;
        /**
     * @private
     * @type {!Object<number,import("../../coordinate.js").Coordinate|Array<import("../../coordinate.js").Coordinate>|Array<Array<import("../../coordinate.js").Coordinate>>>}
     */ this.coordinateCache_ = {};
        /**
     * @private
     * @type {!import("../../transform.js").Transform}
     */ this.renderedTransform_ = (0, $dff5a03e015694d8$export$185802fd694ee1f5)();
        /**
     * @protected
     * @type {Array<*>}
     */ this.hitDetectionInstructions = instructions.hitDetectionInstructions;
        /**
     * @private
     * @type {Array<number>}
     */ this.pixelCoordinates_ = null;
        /**
     * @private
     * @type {number}
     */ this.viewRotation_ = 0;
        /**
     * @type {!Object<string, import("../canvas.js").FillState>}
     */ this.fillStates = instructions.fillStates || {};
        /**
     * @type {!Object<string, import("../canvas.js").StrokeState>}
     */ this.strokeStates = instructions.strokeStates || {};
        /**
     * @type {!Object<string, import("../canvas.js").TextState>}
     */ this.textStates = instructions.textStates || {};
        /**
     * @private
     * @type {Object<string, Object<string, number>>}
     */ this.widths_ = {};
        /**
     * @private
     * @type {Object<string, import("../canvas.js").Label>}
     */ this.labels_ = {};
        /**
     * @private
     * @type {import("../canvas/ZIndexContext.js").default}
     */ this.zIndexContext_ = deferredRendering ? new (0, $365b684a50cc23be$export$2e2bcd8739ae039)() : null;
    }
    /**
   * @return {ZIndexContext} ZIndex context.
   */ getZIndexContext() {
        return this.zIndexContext_;
    }
    /**
   * @param {string|Array<string>} text Text.
   * @param {string} textKey Text style key.
   * @param {string} fillKey Fill style key.
   * @param {string} strokeKey Stroke style key.
   * @return {import("../canvas.js").Label} Label.
   */ createLabel(text, textKey, fillKey, strokeKey) {
        const key = text + textKey + fillKey + strokeKey;
        if (this.labels_[key]) return this.labels_[key];
        const strokeState = strokeKey ? this.strokeStates[strokeKey] : null;
        const fillState = fillKey ? this.fillStates[fillKey] : null;
        const textState = this.textStates[textKey];
        const pixelRatio = this.pixelRatio;
        const scale = [
            textState.scale[0] * pixelRatio,
            textState.scale[1] * pixelRatio
        ];
        const align = textState.justify ? (0, $3904307ab786898a$export$91a016276e4aee96)[textState.justify] : $ffb724b6902a6567$var$horizontalTextAlign(Array.isArray(text) ? text[0] : text, textState.textAlign || (0, $6a4acf19c5e548d6$export$94d53b95641b5766));
        const strokeWidth = strokeKey && strokeState.lineWidth ? strokeState.lineWidth : 0;
        const chunks = Array.isArray(text) ? text : String(text).split('\n').reduce($ffb724b6902a6567$var$createTextChunks, []);
        const { width: width, height: height, widths: widths, heights: heights, lineWidths: lineWidths } = (0, $6a4acf19c5e548d6$export$7d7c13020df1e791)(textState, chunks);
        const renderWidth = width + strokeWidth;
        const contextInstructions = [];
        // make canvas 2 pixels wider to account for italic text width measurement errors
        const w = (renderWidth + 2) * scale[0];
        const h = (height + strokeWidth) * scale[1];
        /** @type {import("../canvas.js").Label} */ const label = {
            width: w < 0 ? Math.floor(w) : Math.ceil(w),
            height: h < 0 ? Math.floor(h) : Math.ceil(h),
            contextInstructions: contextInstructions
        };
        if (scale[0] != 1 || scale[1] != 1) contextInstructions.push('scale', scale);
        if (strokeKey) {
            contextInstructions.push('strokeStyle', strokeState.strokeStyle);
            contextInstructions.push('lineWidth', strokeWidth);
            contextInstructions.push('lineCap', strokeState.lineCap);
            contextInstructions.push('lineJoin', strokeState.lineJoin);
            contextInstructions.push('miterLimit', strokeState.miterLimit);
            contextInstructions.push('setLineDash', [
                strokeState.lineDash
            ]);
            contextInstructions.push('lineDashOffset', strokeState.lineDashOffset);
        }
        if (fillKey) contextInstructions.push('fillStyle', fillState.fillStyle);
        contextInstructions.push('textBaseline', 'middle');
        contextInstructions.push('textAlign', 'center');
        const leftRight = 0.5 - align;
        let x = align * renderWidth + leftRight * strokeWidth;
        const strokeInstructions = [];
        const fillInstructions = [];
        let lineHeight = 0;
        let lineOffset = 0;
        let widthHeightIndex = 0;
        let lineWidthIndex = 0;
        let previousFont;
        for(let i = 0, ii = chunks.length; i < ii; i += 2){
            const text = chunks[i];
            if (text === '\n') {
                lineOffset += lineHeight;
                lineHeight = 0;
                x = align * renderWidth + leftRight * strokeWidth;
                ++lineWidthIndex;
                continue;
            }
            const font = chunks[i + 1] || textState.font;
            if (font !== previousFont) {
                if (strokeKey) strokeInstructions.push('font', font);
                if (fillKey) fillInstructions.push('font', font);
                previousFont = font;
            }
            lineHeight = Math.max(lineHeight, heights[widthHeightIndex]);
            const fillStrokeArgs = [
                text,
                x + leftRight * widths[widthHeightIndex] + align * (widths[widthHeightIndex] - lineWidths[lineWidthIndex]),
                0.5 * (strokeWidth + lineHeight) + lineOffset
            ];
            x += widths[widthHeightIndex];
            if (strokeKey) strokeInstructions.push('strokeText', fillStrokeArgs);
            if (fillKey) fillInstructions.push('fillText', fillStrokeArgs);
            ++widthHeightIndex;
        }
        Array.prototype.push.apply(contextInstructions, strokeInstructions);
        Array.prototype.push.apply(contextInstructions, fillInstructions);
        this.labels_[key] = label;
        return label;
    }
    /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../coordinate.js").Coordinate} p1 1st point of the background box.
   * @param {import("../../coordinate.js").Coordinate} p2 2nd point of the background box.
   * @param {import("../../coordinate.js").Coordinate} p3 3rd point of the background box.
   * @param {import("../../coordinate.js").Coordinate} p4 4th point of the background box.
   * @param {Array<*>} fillInstruction Fill instruction.
   * @param {Array<*>} strokeInstruction Stroke instruction.
   */ replayTextBackground_(context, p1, p2, p3, p4, fillInstruction, strokeInstruction) {
        context.beginPath();
        context.moveTo.apply(context, p1);
        context.lineTo.apply(context, p2);
        context.lineTo.apply(context, p3);
        context.lineTo.apply(context, p4);
        context.lineTo.apply(context, p1);
        if (fillInstruction) {
            this.alignAndScaleFill_ = /** @type {number} */ fillInstruction[2];
            context.fillStyle = /** @type {string} */ fillInstruction[1];
            this.fill_(context);
        }
        if (strokeInstruction) {
            this.setStrokeStyle_(context, /** @type {Array<*>} */ strokeInstruction);
            context.stroke();
        }
    }
    /**
   * @private
   * @param {number} sheetWidth Width of the sprite sheet.
   * @param {number} sheetHeight Height of the sprite sheet.
   * @param {number} centerX X.
   * @param {number} centerY Y.
   * @param {number} width Width.
   * @param {number} height Height.
   * @param {number} anchorX Anchor X.
   * @param {number} anchorY Anchor Y.
   * @param {number} originX Origin X.
   * @param {number} originY Origin Y.
   * @param {number} rotation Rotation.
   * @param {import("../../size.js").Size} scale Scale.
   * @param {boolean} snapToPixel Snap to pixel.
   * @param {Array<number>} padding Padding.
   * @param {boolean} fillStroke Background fill or stroke.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @return {ImageOrLabelDimensions} Dimensions for positioning and decluttering the image or label.
   */ calculateImageOrLabelDimensions_(sheetWidth, sheetHeight, centerX, centerY, width, height, anchorX, anchorY, originX, originY, rotation, scale, snapToPixel, padding, fillStroke, feature) {
        anchorX *= scale[0];
        anchorY *= scale[1];
        let x = centerX - anchorX;
        let y = centerY - anchorY;
        const w = width + originX > sheetWidth ? sheetWidth - originX : width;
        const h = height + originY > sheetHeight ? sheetHeight - originY : height;
        const boxW = padding[3] + w * scale[0] + padding[1];
        const boxH = padding[0] + h * scale[1] + padding[2];
        const boxX = x - padding[3];
        const boxY = y - padding[0];
        if (fillStroke || rotation !== 0) {
            $ffb724b6902a6567$var$p1[0] = boxX;
            $ffb724b6902a6567$var$p4[0] = boxX;
            $ffb724b6902a6567$var$p1[1] = boxY;
            $ffb724b6902a6567$var$p2[1] = boxY;
            $ffb724b6902a6567$var$p2[0] = boxX + boxW;
            $ffb724b6902a6567$var$p3[0] = $ffb724b6902a6567$var$p2[0];
            $ffb724b6902a6567$var$p3[1] = boxY + boxH;
            $ffb724b6902a6567$var$p4[1] = $ffb724b6902a6567$var$p3[1];
        }
        let transform;
        if (rotation !== 0) {
            transform = (0, $dff5a03e015694d8$export$f672e0b6f7222cd7)((0, $dff5a03e015694d8$export$185802fd694ee1f5)(), centerX, centerY, 1, 1, rotation, -centerX, -centerY);
            (0, $dff5a03e015694d8$export$5635d7ef4b8fee1c)(transform, $ffb724b6902a6567$var$p1);
            (0, $dff5a03e015694d8$export$5635d7ef4b8fee1c)(transform, $ffb724b6902a6567$var$p2);
            (0, $dff5a03e015694d8$export$5635d7ef4b8fee1c)(transform, $ffb724b6902a6567$var$p3);
            (0, $dff5a03e015694d8$export$5635d7ef4b8fee1c)(transform, $ffb724b6902a6567$var$p4);
            (0, $dea65c2f666fa450$export$958e3e1a02eac4b6)(Math.min($ffb724b6902a6567$var$p1[0], $ffb724b6902a6567$var$p2[0], $ffb724b6902a6567$var$p3[0], $ffb724b6902a6567$var$p4[0]), Math.min($ffb724b6902a6567$var$p1[1], $ffb724b6902a6567$var$p2[1], $ffb724b6902a6567$var$p3[1], $ffb724b6902a6567$var$p4[1]), Math.max($ffb724b6902a6567$var$p1[0], $ffb724b6902a6567$var$p2[0], $ffb724b6902a6567$var$p3[0], $ffb724b6902a6567$var$p4[0]), Math.max($ffb724b6902a6567$var$p1[1], $ffb724b6902a6567$var$p2[1], $ffb724b6902a6567$var$p3[1], $ffb724b6902a6567$var$p4[1]), $ffb724b6902a6567$var$tmpExtent);
        } else (0, $dea65c2f666fa450$export$958e3e1a02eac4b6)(Math.min(boxX, boxX + boxW), Math.min(boxY, boxY + boxH), Math.max(boxX, boxX + boxW), Math.max(boxY, boxY + boxH), $ffb724b6902a6567$var$tmpExtent);
        if (snapToPixel) {
            x = Math.round(x);
            y = Math.round(y);
        }
        return {
            drawImageX: x,
            drawImageY: y,
            drawImageW: w,
            drawImageH: h,
            originX: originX,
            originY: originY,
            declutterBox: {
                minX: $ffb724b6902a6567$var$tmpExtent[0],
                minY: $ffb724b6902a6567$var$tmpExtent[1],
                maxX: $ffb724b6902a6567$var$tmpExtent[2],
                maxY: $ffb724b6902a6567$var$tmpExtent[3],
                value: feature
            },
            canvasTransform: transform,
            scale: scale
        };
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import('../../size.js').Size} scaledCanvasSize Scaled canvas size.
   * @param {import("../canvas.js").Label|HTMLImageElement|HTMLCanvasElement|HTMLVideoElement} imageOrLabel Image.
   * @param {ImageOrLabelDimensions} dimensions Dimensions.
   * @param {number} opacity Opacity.
   * @param {Array<*>} fillInstruction Fill instruction.
   * @param {Array<*>} strokeInstruction Stroke instruction.
   * @return {boolean} The image or label was rendered.
   */ replayImageOrLabel_(context, scaledCanvasSize, imageOrLabel, dimensions, opacity, fillInstruction, strokeInstruction) {
        const fillStroke = !!(fillInstruction || strokeInstruction);
        const box = dimensions.declutterBox;
        const strokePadding = strokeInstruction ? strokeInstruction[2] * dimensions.scale[0] / 2 : 0;
        const intersects = box.minX - strokePadding <= scaledCanvasSize[0] && box.maxX + strokePadding >= 0 && box.minY - strokePadding <= scaledCanvasSize[1] && box.maxY + strokePadding >= 0;
        if (intersects) {
            if (fillStroke) this.replayTextBackground_(context, $ffb724b6902a6567$var$p1, $ffb724b6902a6567$var$p2, $ffb724b6902a6567$var$p3, $ffb724b6902a6567$var$p4, /** @type {Array<*>} */ fillInstruction, /** @type {Array<*>} */ strokeInstruction);
            (0, $6a4acf19c5e548d6$export$3cb6f3a6e49cc0ee)(context, dimensions.canvasTransform, opacity, imageOrLabel, dimensions.originX, dimensions.originY, dimensions.drawImageW, dimensions.drawImageH, dimensions.drawImageX, dimensions.drawImageY, dimensions.scale);
        }
        return true;
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} context Context.
   */ fill_(context) {
        const alignAndScale = this.alignAndScaleFill_;
        if (alignAndScale) {
            const origin = (0, $dff5a03e015694d8$export$5635d7ef4b8fee1c)(this.renderedTransform_, [
                0,
                0
            ]);
            const repeatSize = 512 * this.pixelRatio;
            context.save();
            context.translate(origin[0] % repeatSize, origin[1] % repeatSize);
            if (alignAndScale !== 1) context.scale(alignAndScale, alignAndScale);
        }
        context.fill();
        if (alignAndScale) context.restore();
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} context Context.
   * @param {Array<*>} instruction Instruction.
   */ setStrokeStyle_(context, instruction) {
        context.strokeStyle = /** @type {import("../../colorlike.js").ColorLike} */ instruction[1];
        if (!instruction[1]) return;
        context.lineWidth = /** @type {number} */ instruction[2];
        context.lineCap = /** @type {CanvasLineCap} */ instruction[3];
        context.lineJoin = /** @type {CanvasLineJoin} */ instruction[4];
        context.miterLimit = /** @type {number} */ instruction[5];
        context.lineDashOffset = /** @type {number} */ instruction[7];
        context.setLineDash(/** @type {Array<number>} */ instruction[6]);
    }
    /**
   * @private
   * @param {string|Array<string>} text The text to draw.
   * @param {string} textKey The key of the text state.
   * @param {string} strokeKey The key for the stroke state.
   * @param {string} fillKey The key for the fill state.
   * @return {{label: import("../canvas.js").Label, anchorX: number, anchorY: number}} The text image and its anchor.
   */ drawLabelWithPointPlacement_(text, textKey, strokeKey, fillKey) {
        const textState = this.textStates[textKey];
        const label = this.createLabel(text, textKey, fillKey, strokeKey);
        const strokeState = this.strokeStates[strokeKey];
        const pixelRatio = this.pixelRatio;
        const align = $ffb724b6902a6567$var$horizontalTextAlign(Array.isArray(text) ? text[0] : text, textState.textAlign || (0, $6a4acf19c5e548d6$export$94d53b95641b5766));
        const baseline = (0, $3904307ab786898a$export$91a016276e4aee96)[textState.textBaseline || (0, $6a4acf19c5e548d6$export$cf2279a1bff62eb)];
        const strokeWidth = strokeState && strokeState.lineWidth ? strokeState.lineWidth : 0;
        // Remove the 2 pixels we added in createLabel() for the anchor
        const width = label.width / pixelRatio - 2 * textState.scale[0];
        const anchorX = align * width + 2 * (0.5 - align) * strokeWidth;
        const anchorY = baseline * label.height / pixelRatio + 2 * (0.5 - baseline) * strokeWidth;
        return {
            label: label,
            anchorX: anchorX,
            anchorY: anchorY
        };
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} context Context.
   * @param {import('../../size.js').Size} scaledCanvasSize Scaled canvas size
   * @param {import("../../transform.js").Transform} transform Transform.
   * @param {Array<*>} instructions Instructions array.
   * @param {boolean} snapToPixel Snap point symbols and text to integer pixels.
   * @param {FeatureCallback<T>} [featureCallback] Feature callback.
   * @param {import("../../extent.js").Extent} [hitExtent] Only check
   *     features that intersect this extent.
   * @param {import("rbush").default<DeclutterEntry>} [declutterTree] Declutter tree.
   * @return {T|undefined} Callback result.
   * @template T
   */ execute_(context, scaledCanvasSize, transform, instructions, snapToPixel, featureCallback, hitExtent, declutterTree) {
        const zIndexContext = this.zIndexContext_;
        /** @type {Array<number>} */ let pixelCoordinates;
        if (this.pixelCoordinates_ && (0, $49313fcb0fc32abe$export$e9bab7fafb253603)(transform, this.renderedTransform_)) pixelCoordinates = this.pixelCoordinates_;
        else {
            if (!this.pixelCoordinates_) this.pixelCoordinates_ = [];
            pixelCoordinates = (0, $d95a11593b39996c$export$b92b2dedcfff79de)(this.coordinates, 0, this.coordinates.length, 2, transform, this.pixelCoordinates_);
            (0, $dff5a03e015694d8$export$42b4187a82d80ed0)(this.renderedTransform_, transform);
        }
        let i = 0; // instruction index
        const ii = instructions.length; // end of instructions
        let d = 0; // data index
        let dd; // end of per-instruction data
        let anchorX, anchorY, lineOffsetPx, /** @type {boolean} */ isClosedRing, /** @type {number} */ dStart, /** @type {import('../../style/Style.js').DeclutterMode} */ declutterMode, prevX, prevY, roundX, roundY, image, text, textKey, strokeKey, fillKey;
        let pendingFill = 0;
        let pendingStroke = 0;
        const coordinateCache = this.coordinateCache_;
        const viewRotation = this.viewRotation_;
        const viewRotationFromTransform = Math.round(Math.atan2(-transform[1], transform[0]) * 1e12) / 1e12;
        const state = /** @type {import("../../render.js").State} */ {
            context: context,
            pixelRatio: this.pixelRatio,
            resolution: this.resolution,
            rotation: viewRotation
        };
        // When the batch size gets too big, performance decreases. 200 is a good
        // balance between batch size and number of fill/stroke instructions.
        const batchSize = this.instructions != instructions || this.overlaps ? 0 : 200;
        let /** @type {import("../../Feature.js").FeatureLike} */ feature;
        let x, y, currentGeometry;
        while(i < ii){
            const instruction = instructions[i];
            const type = /** @type {import("./Instruction.js").default} */ instruction[0];
            switch(type){
                case (0, $0502284914437a56$export$2e2bcd8739ae039).BEGIN_GEOMETRY:
                    feature = /** @type {import("../../Feature.js").FeatureLike} */ instruction[1];
                    currentGeometry = instruction[3];
                    if (!feature.getGeometry()) i = /** @type {number} */ instruction[2];
                    else if (hitExtent !== undefined && !(0, $dea65c2f666fa450$export$7b0a31e10bbff018)(hitExtent, currentGeometry.getExtent())) i = /** @type {number} */ instruction[2] + 1;
                    else ++i;
                    if (zIndexContext) zIndexContext.zIndex = instruction[4];
                    break;
                case (0, $0502284914437a56$export$2e2bcd8739ae039).BEGIN_PATH:
                    if (pendingFill > batchSize) {
                        this.fill_(context);
                        pendingFill = 0;
                    }
                    if (pendingStroke > batchSize) {
                        context.stroke();
                        pendingStroke = 0;
                    }
                    if (!pendingFill && !pendingStroke) {
                        context.beginPath();
                        prevX = NaN;
                        prevY = NaN;
                    }
                    ++i;
                    break;
                case (0, $0502284914437a56$export$2e2bcd8739ae039).CIRCLE:
                    d = /** @type {number} */ instruction[1];
                    lineOffsetPx = /** @type {number} */ instruction[2] ?? 0;
                    const x1 = pixelCoordinates[d];
                    const y1 = pixelCoordinates[d + 1];
                    const x2 = pixelCoordinates[d + 2] - lineOffsetPx;
                    const y2 = pixelCoordinates[d + 3] - lineOffsetPx;
                    const dx = x2 - x1;
                    const dy = y2 - y1;
                    const r = Math.sqrt(dx * dx + dy * dy);
                    context.moveTo(x1 + r, y1);
                    context.arc(x1, y1, r, 0, 2 * Math.PI, true);
                    ++i;
                    break;
                case (0, $0502284914437a56$export$2e2bcd8739ae039).CLOSE_PATH:
                    context.closePath();
                    ++i;
                    break;
                case (0, $0502284914437a56$export$2e2bcd8739ae039).CUSTOM:
                    d = /** @type {number} */ instruction[1];
                    dd = instruction[2];
                    const geometry = /** @type {import("../../geom/SimpleGeometry.js").default} */ instruction[3];
                    const renderer = instruction[4];
                    const fn = instruction[5];
                    state.geometry = geometry;
                    state.feature = feature;
                    if (!(i in coordinateCache)) coordinateCache[i] = [];
                    const coords = coordinateCache[i];
                    if (fn) fn(pixelCoordinates, d, dd, 2, coords);
                    else {
                        coords[0] = pixelCoordinates[d];
                        coords[1] = pixelCoordinates[d + 1];
                        coords.length = 2;
                    }
                    if (zIndexContext) zIndexContext.zIndex = instruction[6];
                    renderer(coords, state);
                    ++i;
                    break;
                case (0, $0502284914437a56$export$2e2bcd8739ae039).DRAW_IMAGE:
                    d = /** @type {number} */ instruction[1];
                    dd = /** @type {number} */ instruction[2];
                    image = /** @type {HTMLCanvasElement|HTMLVideoElement|HTMLImageElement} */ instruction[3];
                    // Remaining arguments in DRAW_IMAGE are in alphabetical order
                    anchorX = /** @type {number} */ instruction[4];
                    anchorY = /** @type {number} */ instruction[5];
                    let height = /** @type {number} */ instruction[6];
                    const opacity = /** @type {number} */ instruction[7];
                    const originX = /** @type {number} */ instruction[8];
                    const originY = /** @type {number} */ instruction[9];
                    const rotateWithView = /** @type {boolean} */ instruction[10];
                    let rotation = /** @type {number} */ instruction[11];
                    const scale = /** @type {import("../../size.js").Size} */ instruction[12];
                    let width = /** @type {number} */ instruction[13];
                    declutterMode = instruction[14] || 'declutter';
                    const declutterImageWithText = /** @type {{args: import("../canvas.js").DeclutterImageWithText, declutterMode: import('../../style/Style.js').DeclutterMode}} */ instruction[15];
                    if (!image && instruction.length >= 20) {
                        // create label images
                        text = /** @type {string} */ instruction[19];
                        textKey = /** @type {string} */ instruction[20];
                        strokeKey = /** @type {string} */ instruction[21];
                        fillKey = /** @type {string} */ instruction[22];
                        const labelWithAnchor = this.drawLabelWithPointPlacement_(text, textKey, strokeKey, fillKey);
                        image = labelWithAnchor.label;
                        instruction[3] = image;
                        const textOffsetX = /** @type {number} */ instruction[23];
                        anchorX = (labelWithAnchor.anchorX - textOffsetX) * this.pixelRatio;
                        instruction[4] = anchorX;
                        const textOffsetY = /** @type {number} */ instruction[24];
                        anchorY = (labelWithAnchor.anchorY - textOffsetY) * this.pixelRatio;
                        instruction[5] = anchorY;
                        height = image.height;
                        instruction[6] = height;
                        width = image.width;
                        instruction[13] = width;
                    }
                    let geometryWidths;
                    if (instruction.length > 25) geometryWidths = /** @type {number} */ instruction[25];
                    let padding, backgroundFillInstruction, backgroundStrokeInstruction;
                    if (instruction.length > 17) {
                        padding = /** @type {Array<number>} */ instruction[16];
                        backgroundFillInstruction = /** @type {Array<*>} */ instruction[17];
                        backgroundStrokeInstruction = /** @type {Array<*>} */ instruction[18];
                    } else {
                        padding = (0, $6a4acf19c5e548d6$export$40a9eeef55665a40);
                        backgroundFillInstruction = null;
                        backgroundStrokeInstruction = null;
                    }
                    if (rotateWithView && viewRotationFromTransform) // Canvas is expected to be rotated to reverse view rotation.
                    rotation += viewRotation;
                    else if (!rotateWithView && !viewRotationFromTransform) // Canvas is not rotated, images need to be rotated back to be north-up.
                    rotation -= viewRotation;
                    let widthIndex = 0;
                    for(; d < dd; d += 2){
                        if (geometryWidths && geometryWidths[widthIndex++] < width / this.pixelRatio) continue;
                        const dimensions = this.calculateImageOrLabelDimensions_(image.width, image.height, pixelCoordinates[d], pixelCoordinates[d + 1], width, height, anchorX, anchorY, originX, originY, rotation, scale, snapToPixel, padding, !!backgroundFillInstruction || !!backgroundStrokeInstruction, feature);
                        /** @type {ReplayImageOrLabelArgs} */ const args = [
                            context,
                            scaledCanvasSize,
                            image,
                            dimensions,
                            opacity,
                            backgroundFillInstruction,
                            backgroundStrokeInstruction
                        ];
                        if (declutterTree) {
                            let imageArgs, imageDeclutterMode, imageDeclutterBox;
                            if (declutterImageWithText) {
                                const index = dd - d;
                                if (!declutterImageWithText[index]) {
                                    // We now have the image for an image+text combination.
                                    declutterImageWithText[index] = {
                                        args: args,
                                        declutterMode: declutterMode
                                    };
                                    continue;
                                }
                                const imageDeclutter = declutterImageWithText[index];
                                imageArgs = imageDeclutter.args;
                                imageDeclutterMode = imageDeclutter.declutterMode;
                                delete declutterImageWithText[index];
                                imageDeclutterBox = $ffb724b6902a6567$var$getDeclutterBox(imageArgs);
                            }
                            // We now have image and text for an image+text combination.
                            let renderImage, renderText;
                            if (imageArgs && (imageDeclutterMode !== 'declutter' || !declutterTree.collides(imageDeclutterBox))) renderImage = true;
                            if (declutterMode !== 'declutter' || !declutterTree.collides(dimensions.declutterBox)) renderText = true;
                            if (imageDeclutterMode === 'declutter' && declutterMode === 'declutter') {
                                const render = renderImage && renderText;
                                renderImage = render;
                                renderText = render;
                            }
                            if (renderImage) {
                                if (imageDeclutterMode !== 'none') declutterTree.insert(imageDeclutterBox);
                                this.replayImageOrLabel_.apply(this, imageArgs);
                            }
                            if (renderText) {
                                if (declutterMode !== 'none') declutterTree.insert(dimensions.declutterBox);
                                this.replayImageOrLabel_.apply(this, args);
                            }
                        } else this.replayImageOrLabel_.apply(this, args);
                    }
                    ++i;
                    break;
                case (0, $0502284914437a56$export$2e2bcd8739ae039).DRAW_CHARS:
                    const begin = /** @type {number} */ instruction[1];
                    const end = /** @type {number} */ instruction[2];
                    const baseline = /** @type {number} */ instruction[3];
                    const overflow = /** @type {number} */ instruction[4];
                    fillKey = /** @type {string} */ instruction[5];
                    const maxAngle = /** @type {number} */ instruction[6];
                    const measurePixelRatio = /** @type {number} */ instruction[7];
                    const offsetY = /** @type {number} */ instruction[8];
                    strokeKey = /** @type {string} */ instruction[9];
                    const strokeWidth = /** @type {number} */ instruction[10];
                    text = /** @type {string|Array<string>} */ instruction[11];
                    if (Array.isArray(text)) //FIXME Add support for rich text along lines
                    text = text.reduce($ffb724b6902a6567$var$richTextToPlainText, '');
                    textKey = /** @type {string} */ instruction[12];
                    const pixelRatioScale = [
                        /** @type {number} */ instruction[13],
                        /** @type {number} */ instruction[13]
                    ];
                    declutterMode = instruction[14] || 'declutter';
                    const textKeepUpright = /** @type {boolean} */ instruction[15];
                    const textState = this.textStates[textKey];
                    const font = textState.font;
                    const textScale = [
                        textState.scale[0] * measurePixelRatio,
                        textState.scale[1] * measurePixelRatio
                    ];
                    let cachedWidths;
                    if (font in this.widths_) cachedWidths = this.widths_[font];
                    else {
                        cachedWidths = {};
                        this.widths_[font] = cachedWidths;
                    }
                    const pathLength = (0, $7fdf1ddee27e7a60$export$153f8c6b4d8caebc)(pixelCoordinates, begin, end, 2);
                    const textLength = Math.abs(textScale[0]) * (0, $6a4acf19c5e548d6$export$915c7ba51467308f)(font, text, cachedWidths);
                    if (overflow || textLength <= pathLength) {
                        const textAlign = this.textStates[textKey].textAlign;
                        const startM = (pathLength - textLength) * $ffb724b6902a6567$var$horizontalTextAlign(text, textAlign);
                        const parts = (0, $85f10bfa11073e75$export$153a9a17ab3e949f)(pixelCoordinates, begin, end, 2, text, startM, maxAngle, Math.abs(textScale[0]), (0, $6a4acf19c5e548d6$export$915c7ba51467308f), font, cachedWidths, viewRotationFromTransform ? 0 : this.viewRotation_, textKeepUpright);
                        drawChars: if (parts) {
                            /** @type {Array<ReplayImageOrLabelArgs>} */ const replayImageOrLabelArgs = [];
                            let c, cc, chars, label, part;
                            if (strokeKey) for(c = 0, cc = parts.length; c < cc; ++c){
                                part = parts[c]; // x, y, anchorX, rotation, chunk
                                chars = /** @type {string} */ part[4];
                                label = this.createLabel(chars, textKey, '', strokeKey);
                                anchorX = /** @type {number} */ part[2] + (textScale[0] < 0 ? -strokeWidth : strokeWidth);
                                anchorY = baseline * label.height + (0.5 - baseline) * 2 * strokeWidth * textScale[1] / textScale[0] - offsetY;
                                const dimensions = this.calculateImageOrLabelDimensions_(label.width, label.height, part[0], part[1], label.width, label.height, anchorX, anchorY, 0, 0, part[3], pixelRatioScale, false, (0, $6a4acf19c5e548d6$export$40a9eeef55665a40), false, feature);
                                if (declutterTree && declutterMode === 'declutter' && declutterTree.collides(dimensions.declutterBox)) break drawChars;
                                replayImageOrLabelArgs.push([
                                    context,
                                    scaledCanvasSize,
                                    label,
                                    dimensions,
                                    1,
                                    null,
                                    null
                                ]);
                            }
                            if (fillKey) for(c = 0, cc = parts.length; c < cc; ++c){
                                part = parts[c]; // x, y, anchorX, rotation, chunk
                                chars = /** @type {string} */ part[4];
                                label = this.createLabel(chars, textKey, fillKey, '');
                                anchorX = /** @type {number} */ part[2];
                                anchorY = baseline * label.height - offsetY;
                                const dimensions = this.calculateImageOrLabelDimensions_(label.width, label.height, part[0], part[1], label.width, label.height, anchorX, anchorY, 0, 0, part[3], pixelRatioScale, false, (0, $6a4acf19c5e548d6$export$40a9eeef55665a40), false, feature);
                                if (declutterTree && declutterMode === 'declutter' && declutterTree.collides(dimensions.declutterBox)) break drawChars;
                                replayImageOrLabelArgs.push([
                                    context,
                                    scaledCanvasSize,
                                    label,
                                    dimensions,
                                    1,
                                    null,
                                    null
                                ]);
                            }
                            if (declutterTree && declutterMode !== 'none') declutterTree.load(replayImageOrLabelArgs.map($ffb724b6902a6567$var$getDeclutterBox));
                            for(let i = 0, ii = replayImageOrLabelArgs.length; i < ii; ++i)this.replayImageOrLabel_.apply(this, replayImageOrLabelArgs[i]);
                        }
                    }
                    ++i;
                    break;
                case (0, $0502284914437a56$export$2e2bcd8739ae039).END_GEOMETRY:
                    if (featureCallback !== undefined) {
                        feature = /** @type {import("../../Feature.js").FeatureLike} */ instruction[1];
                        const result = featureCallback(feature, currentGeometry, declutterMode);
                        if (result) return result;
                    }
                    ++i;
                    break;
                case (0, $0502284914437a56$export$2e2bcd8739ae039).FILL:
                    if (batchSize) pendingFill++;
                    else this.fill_(context);
                    ++i;
                    break;
                case (0, $0502284914437a56$export$2e2bcd8739ae039).MOVE_TO_LINE_TO:
                    d = /** @type {number} */ instruction[1];
                    dd = /** @type {number} */ instruction[2];
                    lineOffsetPx = /** @type {number|undefined} */ instruction[3];
                    isClosedRing = /** @type {boolean|undefined} */ instruction[4] ?? false;
                    x = pixelCoordinates[d];
                    y = pixelCoordinates[d + 1];
                    if (lineOffsetPx) {
                        dStart = d;
                        [x, y] = (0, $8783b79cc48761bc$export$1d816e12adb721de)(x, y, isClosedRing ? pixelCoordinates[dd - 4] : undefined, isClosedRing ? pixelCoordinates[dd - 3] : undefined, pixelCoordinates[d + 2], pixelCoordinates[d + 3], lineOffsetPx);
                    }
                    context.moveTo(x, y);
                    prevX = x + 0.5 | 0;
                    prevY = y + 0.5 | 0;
                    for(d += 2; d < dd; d += 2){
                        x = pixelCoordinates[d];
                        y = pixelCoordinates[d + 1];
                        roundX = x + 0.5 | 0;
                        roundY = y + 0.5 | 0;
                        if (d == dd - 2 || roundX !== prevX || roundY !== prevY) {
                            if (lineOffsetPx) {
                                if (d == dd - 2) // last coordinate
                                [x, y] = (0, $8783b79cc48761bc$export$1d816e12adb721de)(x, y, pixelCoordinates[d - 2], pixelCoordinates[d - 1], isClosedRing ? pixelCoordinates[dStart + 2] : undefined, isClosedRing ? pixelCoordinates[dStart + 3] : undefined, lineOffsetPx);
                                else [x, y] = (0, $8783b79cc48761bc$export$1d816e12adb721de)(x, y, pixelCoordinates[d - 2], pixelCoordinates[d - 1], pixelCoordinates[d + 2], pixelCoordinates[d + 3], lineOffsetPx);
                            }
                            context.lineTo(x, y);
                            prevX = roundX;
                            prevY = roundY;
                        }
                    }
                    ++i;
                    break;
                case (0, $0502284914437a56$export$2e2bcd8739ae039).SET_FILL_STYLE:
                    this.alignAndScaleFill_ = instruction[2];
                    if (pendingFill) {
                        this.fill_(context);
                        pendingFill = 0;
                        if (pendingStroke) {
                            context.stroke();
                            pendingStroke = 0;
                        }
                    }
                    /** @type {import("../../colorlike.js").ColorLike} */ context.fillStyle = instruction[1];
                    ++i;
                    break;
                case (0, $0502284914437a56$export$2e2bcd8739ae039).SET_STROKE_STYLE:
                    if (pendingStroke) {
                        context.stroke();
                        pendingStroke = 0;
                    }
                    this.setStrokeStyle_(context, /** @type {Array<*>} */ instruction);
                    ++i;
                    break;
                case (0, $0502284914437a56$export$2e2bcd8739ae039).STROKE:
                    if (batchSize) pendingStroke++;
                    else context.stroke();
                    ++i;
                    break;
                default:
                    ++i;
                    break;
            }
        }
        if (pendingFill) this.fill_(context);
        if (pendingStroke) context.stroke();
        return undefined;
    }
    /**
   * @param {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} context Context.
   * @param {import('../../size.js').Size} scaledCanvasSize Scaled canvas size.
   * @param {import("../../transform.js").Transform} transform Transform.
   * @param {number} viewRotation View rotation.
   * @param {boolean} snapToPixel Snap point symbols and text to integer pixels.
   * @param {import("rbush").default<DeclutterEntry>} [declutterTree] Declutter tree.
   */ execute(context, scaledCanvasSize, transform, viewRotation, snapToPixel, declutterTree) {
        this.viewRotation_ = viewRotation;
        this.execute_(context, scaledCanvasSize, transform, this.instructions, snapToPixel, undefined, undefined, declutterTree);
    }
    /**
   * @param {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} context Context.
   * @param {import("../../transform.js").Transform} transform Transform.
   * @param {number} viewRotation View rotation.
   * @param {FeatureCallback<T>} [featureCallback] Feature callback.
   * @param {import("../../extent.js").Extent} [hitExtent] Only check
   *     features that intersect this extent.
   * @return {T|undefined} Callback result.
   * @template T
   */ executeHitDetection(context, transform, viewRotation, featureCallback, hitExtent) {
        this.viewRotation_ = viewRotation;
        return this.execute_(context, [
            context.canvas.width,
            context.canvas.height
        ], transform, this.hitDetectionInstructions, true, featureCallback, hitExtent);
    }
}
var $ffb724b6902a6567$export$2e2bcd8739ae039 = $ffb724b6902a6567$var$Executor;


const $f47f8a04f904c35c$export$61b49a5ae59d663 = [
    'Polygon',
    'Circle',
    'LineString',
    'Image',
    'Text',
    'Default'
];
const $f47f8a04f904c35c$export$6195a93a6c97ce02 = [
    'Image',
    'Text'
];
const $f47f8a04f904c35c$export$d0fe61ccfaa1ca87 = $f47f8a04f904c35c$export$61b49a5ae59d663.filter((builderType)=>!$f47f8a04f904c35c$export$6195a93a6c97ce02.includes(builderType));
/** @type {boolean|undefined} */ let $f47f8a04f904c35c$var$willReadFrequently = false;
/** @type {boolean|undefined} */ let $f47f8a04f904c35c$var$canvasReadsBenchmarked = false;
/** Determine if canvas read operations are faster with willReadFrequently set to true or false */ function $f47f8a04f904c35c$var$benchmarkCanvasReads() {
    let bestResult = 0;
    /**
   * @param {boolean} willReadFrequently Will read frequently.
   * @return {number} Operation count.
   */ const measure = (willReadFrequently)=>{
        const context = (0, $b6f6d442e8ff57e1$export$9e05d10eae75c464)(1, 1, null, {
            willReadFrequently: willReadFrequently
        });
        let count = 0;
        const start = performance.now();
        for(; performance.now() - start < 50; ++count){
            context.fillStyle = `rgba(255,0,${count % 256},1)`;
            context.fillRect(0, 0, 1, 1);
            context.getImageData(0, 0, 1, 1);
        }
        bestResult = count > bestResult ? count : bestResult;
        return count;
    };
    const measures = {
        [measure(true)]: true,
        [measure(false)]: false,
        [measure(undefined)]: undefined
    };
    $f47f8a04f904c35c$var$willReadFrequently = measures[bestResult];
    $f47f8a04f904c35c$var$canvasReadsBenchmarked = true;
}
class $f47f8a04f904c35c$var$ExecutorGroup {
    /**
   * @param {import("../../extent.js").Extent} maxExtent Max extent for clipping. When a
   * `maxExtent` was set on the Builder for this executor group, the same `maxExtent`
   * should be set here, unless the target context does not exceed that extent (which
   * can be the case when rendering to tiles).
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   * @param {boolean} overlaps The executor group can have overlapping geometries.
   * @param {!Object<string, !Object<import("../canvas.js").BuilderType, import("../canvas.js").SerializableInstructions>>} allInstructions
   * The serializable instructions.
   * @param {number} [renderBuffer] Optional rendering buffer.
   * @param {boolean} [deferredRendering] Enable deferred rendering with renderDeferred().
   */ constructor(maxExtent, resolution, pixelRatio, overlaps, allInstructions, renderBuffer, deferredRendering){
        /**
     * @private
     * @type {import("../../extent.js").Extent}
     */ this.maxExtent_ = maxExtent;
        /**
     * @private
     * @type {boolean}
     */ this.overlaps_ = overlaps;
        /**
     * @private
     * @type {number}
     */ this.pixelRatio_ = pixelRatio;
        /**
     * @private
     * @type {number}
     */ this.resolution_ = resolution;
        /**
     * @private
     * @type {number|undefined}
     */ this.renderBuffer_ = renderBuffer;
        /**
     * @private
     * @type {!Object<string, !Object<string, import("./Executor").default>>}
     */ this.executorsByZIndex_ = {};
        /**
     * @private
     * @type {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D}
     */ this.hitDetectionContext_ = null;
        /**
     * @private
     * @type {import("../../transform.js").Transform}
     */ this.hitDetectionTransform_ = (0, $dff5a03e015694d8$export$185802fd694ee1f5)();
        /**
     * @private
     * @type {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D}
     */ this.renderedContext_ = null;
        /**
     * @private
     * @type {Object<number, Array<import("./ZIndexContext.js").default>>}
     */ this.deferredZIndexContexts_ = {};
        this.createExecutors_(allInstructions, deferredRendering);
    }
    /**
   * @param {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} context Context.
   * @param {import("../../transform.js").Transform} transform Transform.
   */ clip(context, transform) {
        const flatClipCoords = this.getClipCoords(transform);
        context.beginPath();
        context.moveTo(flatClipCoords[0], flatClipCoords[1]);
        context.lineTo(flatClipCoords[2], flatClipCoords[3]);
        context.lineTo(flatClipCoords[4], flatClipCoords[5]);
        context.lineTo(flatClipCoords[6], flatClipCoords[7]);
        context.clip();
    }
    /**
   * Create executors and populate them using the provided instructions.
   * @private
   * @param {!Object<string, !Object<string, import("../canvas.js").SerializableInstructions>>} allInstructions The serializable instructions
   * @param {boolean} deferredRendering Enable deferred rendering.
   */ createExecutors_(allInstructions, deferredRendering) {
        for(const zIndex in allInstructions){
            let executors = this.executorsByZIndex_[zIndex];
            if (executors === undefined) {
                executors = {};
                this.executorsByZIndex_[zIndex] = executors;
            }
            const instructionByZindex = allInstructions[zIndex];
            for(const builderType in instructionByZindex){
                const instructions = instructionByZindex[builderType];
                executors[builderType] = new (0, $ffb724b6902a6567$export$2e2bcd8739ae039)(this.resolution_, this.pixelRatio_, this.overlaps_, instructions, deferredRendering);
            }
        }
    }
    /**
   * @param {Array<import("../canvas.js").BuilderType>} executors Executors.
   * @return {boolean} Has executors of the provided types.
   */ hasExecutors(executors) {
        for(const zIndex in this.executorsByZIndex_){
            const candidates = this.executorsByZIndex_[zIndex];
            for(let i = 0, ii = executors.length; i < ii; ++i){
                if (executors[i] in candidates) return true;
            }
        }
        return false;
    }
    /**
   * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {number} resolution Resolution.
   * @param {number} rotation Rotation.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @param {function(import("../../Feature.js").FeatureLike, import("../../geom/SimpleGeometry.js").default, number): T} callback Feature callback.
   * @param {Array<import("../../Feature.js").FeatureLike>} declutteredFeatures Decluttered features.
   * @return {T|undefined} Callback result.
   * @template T
   */ forEachFeatureAtCoordinate(coordinate, resolution, rotation, hitTolerance, callback, declutteredFeatures) {
        if ($f47f8a04f904c35c$var$canvasReadsBenchmarked === false) $f47f8a04f904c35c$var$benchmarkCanvasReads();
        hitTolerance = Math.round(hitTolerance);
        const contextSize = hitTolerance * 2 + 1;
        const transform = (0, $dff5a03e015694d8$export$f672e0b6f7222cd7)(this.hitDetectionTransform_, hitTolerance + 0.5, hitTolerance + 0.5, 1 / resolution, -1 / resolution, -rotation, -coordinate[0], -coordinate[1]);
        const newContext = !this.hitDetectionContext_;
        if (newContext) this.hitDetectionContext_ = (0, $b6f6d442e8ff57e1$export$9e05d10eae75c464)(contextSize, contextSize, null, {
            willReadFrequently: $f47f8a04f904c35c$var$willReadFrequently
        });
        const context = this.hitDetectionContext_;
        if (context.canvas.width !== contextSize || context.canvas.height !== contextSize) {
            context.canvas.width = contextSize;
            context.canvas.height = contextSize;
        } else if (!newContext) context.clearRect(0, 0, contextSize, contextSize);
        /** @type {import("../../extent.js").Extent|undefined} */ let hitExtent;
        if (this.renderBuffer_ !== undefined) {
            hitExtent = (0, $dea65c2f666fa450$export$fe201bb3bbe031e9)();
            (0, $dea65c2f666fa450$export$1f820e3920fa5715)(hitExtent, coordinate);
            (0, $dea65c2f666fa450$export$ab1029bcae9ddb4a)(hitExtent, resolution * (this.renderBuffer_ + hitTolerance), hitExtent);
        }
        const indexes = $f47f8a04f904c35c$export$96fc84ea21b8269f(hitTolerance);
        /** @type {import("../canvas.js").BuilderType} */ let builderType;
        /**
     * @param {import("../../Feature.js").FeatureLike} feature Feature.
     * @param {import("../../geom/SimpleGeometry.js").default} geometry Geometry.
     * @param {import('../../style/Style.js').DeclutterMode} declutterMode Declutter mode.
     * @return {T|undefined} Callback result.
     */ function featureCallback(feature, geometry, declutterMode) {
            const imageData = context.getImageData(0, 0, contextSize, contextSize).data;
            for(let i = 0, ii = indexes.length; i < ii; i++)if (imageData[indexes[i]] > 0) {
                if (!declutteredFeatures || declutterMode === 'none' || builderType !== 'Image' && builderType !== 'Text' || declutteredFeatures.includes(feature)) {
                    const idx = (indexes[i] - 3) / 4;
                    const x = hitTolerance - idx % contextSize;
                    const y = hitTolerance - (idx / contextSize | 0);
                    const result = callback(feature, geometry, x * x + y * y);
                    if (result) return result;
                }
                context.clearRect(0, 0, contextSize, contextSize);
                break;
            }
            return undefined;
        }
        /** @type {Array<number>} */ const zs = Object.keys(this.executorsByZIndex_).map(Number);
        zs.sort((0, $49313fcb0fc32abe$export$fcb633242ef15540));
        let i, j, executors, executor, result;
        for(i = zs.length - 1; i >= 0; --i){
            const zIndexKey = zs[i].toString();
            executors = this.executorsByZIndex_[zIndexKey];
            for(j = $f47f8a04f904c35c$export$61b49a5ae59d663.length - 1; j >= 0; --j){
                builderType = $f47f8a04f904c35c$export$61b49a5ae59d663[j];
                executor = executors[builderType];
                if (executor !== undefined) {
                    result = executor.executeHitDetection(context, transform, rotation, featureCallback, hitExtent);
                    if (result) return result;
                }
            }
        }
        return undefined;
    }
    /**
   * @param {import("../../transform.js").Transform} transform Transform.
   * @return {Array<number>|null} Clip coordinates.
   */ getClipCoords(transform) {
        const maxExtent = this.maxExtent_;
        if (!maxExtent) return null;
        const minX = maxExtent[0];
        const minY = maxExtent[1];
        const maxX = maxExtent[2];
        const maxY = maxExtent[3];
        const flatClipCoords = [
            minX,
            minY,
            minX,
            maxY,
            maxX,
            maxY,
            maxX,
            minY
        ];
        (0, $d95a11593b39996c$export$b92b2dedcfff79de)(flatClipCoords, 0, 8, 2, transform, flatClipCoords);
        return flatClipCoords;
    }
    /**
   * @return {boolean} Is empty.
   */ isEmpty() {
        return (0, $9f2b61a1df00e9b3$export$dd1bc94b04021eeb)(this.executorsByZIndex_);
    }
    /**
   * @param {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} targetContext Context.
   * @param {import('../../size.js').Size} scaledCanvasSize Scale of the context.
   * @param {import("../../transform.js").Transform} transform Transform.
   * @param {number} viewRotation View rotation.
   * @param {boolean} snapToPixel Snap point symbols and test to integer pixel.
   * @param {Array<import("../canvas.js").BuilderType>} [builderTypes] Ordered replay types to replay.
   *     Default is {@link module:ol/render/replay~ALL}
   * @param {import("rbush").default<import('./Executor.js').DeclutterEntry>|null} [declutterTree] Declutter tree.
   *     When set to null, no decluttering is done, even when the executor group has a `ZIndexContext`.
   */ execute(targetContext, scaledCanvasSize, transform, viewRotation, snapToPixel, builderTypes, declutterTree) {
        const zs = Object.keys(this.executorsByZIndex_).map(Number);
        zs.sort(declutterTree ? (0, $49313fcb0fc32abe$export$4fa3190a997c3d8f) : (0, $49313fcb0fc32abe$export$fcb633242ef15540));
        builderTypes = builderTypes ? builderTypes : $f47f8a04f904c35c$export$61b49a5ae59d663;
        const maxBuilderTypes = $f47f8a04f904c35c$export$61b49a5ae59d663.length;
        for(let i = 0, ii = zs.length; i < ii; ++i){
            const zIndexKey = zs[i].toString();
            const replays = this.executorsByZIndex_[zIndexKey];
            for(let j = 0, jj = builderTypes.length; j < jj; ++j){
                const builderType = builderTypes[j];
                const replay = replays[builderType];
                if (replay !== undefined) {
                    const zIndexContext = declutterTree === null ? undefined : replay.getZIndexContext();
                    const context = zIndexContext ? zIndexContext.getContext() : targetContext;
                    const requireClip = this.maxExtent_ && builderType !== 'Image' && builderType !== 'Text';
                    if (requireClip) {
                        context.save();
                        // setup clipping so that the parts of over-simplified geometries are not
                        // visible outside the current extent when panning
                        this.clip(context, transform);
                    }
                    if (!zIndexContext || builderType === 'Text' || builderType === 'Image') replay.execute(context, scaledCanvasSize, transform, viewRotation, snapToPixel, declutterTree);
                    else zIndexContext.pushFunction((context)=>replay.execute(context, scaledCanvasSize, transform, viewRotation, snapToPixel, declutterTree));
                    if (requireClip) context.restore();
                    if (zIndexContext) {
                        zIndexContext.offset();
                        const index = zs[i] * maxBuilderTypes + $f47f8a04f904c35c$export$61b49a5ae59d663.indexOf(builderType);
                        if (!this.deferredZIndexContexts_[index]) this.deferredZIndexContexts_[index] = [];
                        this.deferredZIndexContexts_[index].push(zIndexContext);
                    }
                }
            }
        }
        this.renderedContext_ = targetContext;
    }
    getDeferredZIndexContexts() {
        return this.deferredZIndexContexts_;
    }
    getRenderedContext() {
        return this.renderedContext_;
    }
    renderDeferred() {
        const deferredZIndexContexts = this.deferredZIndexContexts_;
        const zs = Object.keys(deferredZIndexContexts).map(Number).sort((0, $49313fcb0fc32abe$export$fcb633242ef15540));
        for(let i = 0, ii = zs.length; i < ii; ++i){
            deferredZIndexContexts[zs[i]].forEach((zIndexContext)=>{
                zIndexContext.draw(this.renderedContext_); // FIXME Pass clip to replay for temporarily enabling clip
                zIndexContext.clear();
            });
            deferredZIndexContexts[zs[i]].length = 0;
        }
    }
}
/**
 * This cache is used to store arrays of indexes for calculated pixel circles
 * to increase performance.
 * It is a static property to allow each Replaygroup to access it.
 * @type {Object<number, Array<number>>}
 */ const $f47f8a04f904c35c$var$circlePixelIndexArrayCache = {};
function $f47f8a04f904c35c$export$96fc84ea21b8269f(radius) {
    if ($f47f8a04f904c35c$var$circlePixelIndexArrayCache[radius] !== undefined) return $f47f8a04f904c35c$var$circlePixelIndexArrayCache[radius];
    const size = radius * 2 + 1;
    const maxDistanceSq = radius * radius;
    const distances = new Array(maxDistanceSq + 1);
    for(let i = 0; i <= radius; ++i)for(let j = 0; j <= radius; ++j){
        const distanceSq = i * i + j * j;
        if (distanceSq > maxDistanceSq) break;
        let distance = distances[distanceSq];
        if (!distance) {
            distance = [];
            distances[distanceSq] = distance;
        }
        distance.push(((radius + i) * size + (radius + j)) * 4 + 3);
        if (i > 0) distance.push(((radius - i) * size + (radius + j)) * 4 + 3);
        if (j > 0) {
            distance.push(((radius + i) * size + (radius - j)) * 4 + 3);
            if (i > 0) distance.push(((radius - i) * size + (radius - j)) * 4 + 3);
        }
    }
    const pixelIndex = [];
    for(let i = 0, ii = distances.length; i < ii; ++i)if (distances[i]) pixelIndex.push(...distances[i]);
    $f47f8a04f904c35c$var$circlePixelIndexArrayCache[radius] = pixelIndex;
    return pixelIndex;
}
var $f47f8a04f904c35c$export$2e2bcd8739ae039 = $f47f8a04f904c35c$var$ExecutorGroup;


/**
 * @module ol/render/canvas/hitdetect
 */ 




/**
 * @module ol/style/Icon
 */ 





/**
 * @module ol/style/Image
 */ 

/**
 * @typedef {Object} Options
 * @property {number} opacity Opacity.
 * @property {boolean} rotateWithView If the image should get rotated with the view.
 * @property {number} rotation Rotation.
 * @property {number|import("../size.js").Size} scale Scale.
 * @property {Array<number>} displacement Displacement.
 * @property {import('../style/Style.js').DeclutterMode} declutterMode Declutter mode: `declutter`, `obstacle`, `none`.
 */ /**
 * @classdesc
 * A base class used for creating subclasses and not instantiated in
 * apps. Base class for {@link module:ol/style/Icon~Icon}, {@link module:ol/style/Circle~CircleStyle} and
 * {@link module:ol/style/RegularShape~RegularShape}.
 * @abstract
 * @api
 */ class $9c0b0593a7c9006d$var$ImageStyle {
    /**
   * @param {Options} options Options.
   */ constructor(options){
        /**
     * @private
     * @type {number}
     */ this.opacity_ = options.opacity;
        /**
     * @private
     * @type {boolean}
     */ this.rotateWithView_ = options.rotateWithView;
        /**
     * @private
     * @type {number}
     */ this.rotation_ = options.rotation;
        /**
     * @private
     * @type {number|import("../size.js").Size}
     */ this.scale_ = options.scale;
        /**
     * @private
     * @type {import("../size.js").Size}
     */ this.scaleArray_ = (0, $625e418aeada4c0d$export$a71a825ff42fb8e1)(options.scale);
        /**
     * @private
     * @type {Array<number>}
     */ this.displacement_ = options.displacement;
        /**
     * @private
     * @type {import('../style/Style.js').DeclutterMode}
     */ this.declutterMode_ = options.declutterMode;
    }
    /**
   * Clones the style.
   * @return {ImageStyle} The cloned style.
   * @api
   */ clone() {
        const scale = this.getScale();
        return new $9c0b0593a7c9006d$var$ImageStyle({
            opacity: this.getOpacity(),
            scale: Array.isArray(scale) ? scale.slice() : scale,
            rotation: this.getRotation(),
            rotateWithView: this.getRotateWithView(),
            displacement: this.getDisplacement().slice(),
            declutterMode: this.getDeclutterMode()
        });
    }
    /**
   * Get the symbolizer opacity.
   * @return {number} Opacity.
   * @api
   */ getOpacity() {
        return this.opacity_;
    }
    /**
   * Determine whether the symbolizer rotates with the map.
   * @return {boolean} Rotate with map.
   * @api
   */ getRotateWithView() {
        return this.rotateWithView_;
    }
    /**
   * Get the symoblizer rotation.
   * @return {number} Rotation.
   * @api
   */ getRotation() {
        return this.rotation_;
    }
    /**
   * Get the symbolizer scale.
   * @return {number|import("../size.js").Size} Scale.
   * @api
   */ getScale() {
        return this.scale_;
    }
    /**
   * Get the symbolizer scale array.
   * @return {import("../size.js").Size} Scale array.
   */ getScaleArray() {
        return this.scaleArray_;
    }
    /**
   * Get the displacement of the shape
   * @return {Array<number>} Shape's center displacement
   * @api
   */ getDisplacement() {
        return this.displacement_;
    }
    /**
   * Get the declutter mode of the shape
   * @return {import("./Style.js").DeclutterMode} Shape's declutter mode
   * @api
   */ getDeclutterMode() {
        return this.declutterMode_;
    }
    /**
   * Get the anchor point in pixels. The anchor determines the center point for the
   * symbolizer.
   * @abstract
   * @return {Array<number>} Anchor.
   */ getAnchor() {
        return (0, $fd76d391cc228565$export$817eb92a8194bab0)();
    }
    /**
   * Get the image element for the symbolizer.
   * @abstract
   * @param {number} pixelRatio Pixel ratio.
   * @return {import('../DataTile.js').ImageLike} Image element.
   */ getImage(pixelRatio) {
        return (0, $fd76d391cc228565$export$817eb92a8194bab0)();
    }
    /**
   * @abstract
   * @return {import('../DataTile.js').ImageLike} Image element.
   */ getHitDetectionImage() {
        return (0, $fd76d391cc228565$export$817eb92a8194bab0)();
    }
    /**
   * Get the image pixel ratio.
   * @param {number} pixelRatio Pixel ratio.
   * @return {number} Pixel ratio.
   */ getPixelRatio(pixelRatio) {
        return 1;
    }
    /**
   * @abstract
   * @return {import("../ImageState.js").default} Image state.
   */ getImageState() {
        return (0, $fd76d391cc228565$export$817eb92a8194bab0)();
    }
    /**
   * @abstract
   * @return {import("../size.js").Size} Image size.
   */ getImageSize() {
        return (0, $fd76d391cc228565$export$817eb92a8194bab0)();
    }
    /**
   * Get the origin of the symbolizer.
   * @abstract
   * @return {Array<number>} Origin.
   */ getOrigin() {
        return (0, $fd76d391cc228565$export$817eb92a8194bab0)();
    }
    /**
   * Get the size of the symbolizer (in pixels).
   * @abstract
   * @return {import("../size.js").Size} Size.
   */ getSize() {
        return (0, $fd76d391cc228565$export$817eb92a8194bab0)();
    }
    /**
   * Set the displacement.
   *
   * @param {Array<number>} displacement Displacement.
   * @api
   */ setDisplacement(displacement) {
        this.displacement_ = displacement;
    }
    /**
   * Set the opacity.
   *
   * @param {number} opacity Opacity.
   * @api
   */ setOpacity(opacity) {
        this.opacity_ = opacity;
    }
    /**
   * Set whether to rotate the style with the view.
   *
   * @param {boolean} rotateWithView Rotate with map.
   * @api
   */ setRotateWithView(rotateWithView) {
        this.rotateWithView_ = rotateWithView;
    }
    /**
   * Set the rotation.
   *
   * @param {number} rotation Rotation.
   * @api
   */ setRotation(rotation) {
        this.rotation_ = rotation;
    }
    /**
   * Set the scale.
   *
   * @param {number|import("../size.js").Size} scale Scale.
   * @api
   */ setScale(scale) {
        this.scale_ = scale;
        this.scaleArray_ = (0, $625e418aeada4c0d$export$a71a825ff42fb8e1)(scale);
    }
    /**
   * @abstract
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   */ listenImageChange(listener) {
        (0, $fd76d391cc228565$export$817eb92a8194bab0)();
    }
    /**
   * Load not yet loaded URI.
   * @abstract
   */ load() {
        (0, $fd76d391cc228565$export$817eb92a8194bab0)();
    }
    /**
   * @abstract
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   */ unlistenImageChange(listener) {
        (0, $fd76d391cc228565$export$817eb92a8194bab0)();
    }
    /**
   * @return {Promise<void>} `false` or Promise that resolves when the style is ready to use.
   */ ready() {
        return Promise.resolve();
    }
}
var $9c0b0593a7c9006d$export$2e2bcd8739ae039 = $9c0b0593a7c9006d$var$ImageStyle;


/**
 * @typedef {'fraction' | 'pixels'} IconAnchorUnits
 * Anchor unit can be either a fraction of the icon size or in pixels.
 */ /**
 * @typedef {'bottom-left' | 'bottom-right' | 'top-left' | 'top-right'} IconOrigin
 * Icon origin. One of 'bottom-left', 'bottom-right', 'top-left', 'top-right'.
 */ /**
 * @typedef {Object} Options
 * @property {Array<number>} [anchor=[0.5, 0.5]] Anchor. Default value is the icon center.
 * @property {IconOrigin} [anchorOrigin='top-left'] Origin of the anchor: `bottom-left`, `bottom-right`,
 * `top-left` or `top-right`.
 * @property {IconAnchorUnits} [anchorXUnits='fraction'] Units in which the anchor x value is
 * specified. A value of `'fraction'` indicates the x value is a fraction of the icon. A value of `'pixels'` indicates
 * the x value in pixels.
 * @property {IconAnchorUnits} [anchorYUnits='fraction'] Units in which the anchor y value is
 * specified. A value of `'fraction'` indicates the y value is a fraction of the icon. A value of `'pixels'` indicates
 * the y value in pixels.
 * @property {import("../color.js").Color|string} [color] Color to tint the icon. If not specified,
 * the icon will be left as is.
 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images. Note that you must provide a
 * `crossOrigin` value if you want to access pixel data with the Canvas renderer.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {ReferrerPolicy} [referrerPolicy] The `referrerPolicy` property for loaded images.
 * @property {HTMLImageElement|HTMLCanvasElement|OffscreenCanvas|ImageBitmap} [img] Image object for the icon.
 * @property {Array<number>} [displacement=[0, 0]] Displacement of the icon in pixels.
 * Positive values will shift the icon right and up.
 * @property {number} [opacity=1] Opacity of the icon.
 * @property {number} [width] The width of the icon in pixels. This can't be used together with `scale`.
 * @property {number} [height] The height of the icon in pixels. This can't be used together with `scale`.
 * @property {number|import("../size.js").Size} [scale=1] Scale.
 * @property {boolean} [rotateWithView=false] Whether to rotate the icon with the view.
 * @property {number} [rotation=0] Rotation in radians (positive rotation clockwise).
 * @property {Array<number>} [offset=[0, 0]] Offset which, together with `size` and `offsetOrigin`, defines the
 * sub-rectangle to use from the original (sprite) image.
 * @property {IconOrigin} [offsetOrigin='top-left'] Origin of the offset: `bottom-left`, `bottom-right`,
 * `top-left` or `top-right`.
 * @property {import("../size.js").Size} [size] Icon size in pixels. Used together with `offset` to define the
 * sub-rectangle to use from the original (sprite) image.
 * @property {string} [src] Image source URI.
 * @property {import("./Style.js").DeclutterMode} [declutterMode] Declutter mode.
 */ /**
 * @param {number} width The width.
 * @param {number} height The height.
 * @param {number|undefined} wantedWidth The wanted width.
 * @param {number|undefined} wantedHeight The wanted height.
 * @return {number|Array<number>} The scale.
 */ function $39b0ac330ad6f6e7$var$calculateScale(width, height, wantedWidth, wantedHeight) {
    if (wantedWidth !== undefined && wantedHeight !== undefined) return [
        wantedWidth / width,
        wantedHeight / height
    ];
    if (wantedWidth !== undefined) return wantedWidth / width;
    if (wantedHeight !== undefined) return wantedHeight / height;
    return 1;
}
/**
 * @classdesc
 * Set icon style for vector features.
 * @api
 */ class $39b0ac330ad6f6e7$var$Icon extends (0, $9c0b0593a7c9006d$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options || {};
        /**
     * @type {number}
     */ const opacity = options.opacity !== undefined ? options.opacity : 1;
        /**
     * @type {number}
     */ const rotation = options.rotation !== undefined ? options.rotation : 0;
        /**
     * @type {number|import("../size.js").Size}
     */ const scale = options.scale !== undefined ? options.scale : 1;
        /**
     * @type {boolean}
     */ const rotateWithView = options.rotateWithView !== undefined ? options.rotateWithView : false;
        super({
            opacity: opacity,
            rotation: rotation,
            scale: scale,
            displacement: options.displacement !== undefined ? options.displacement : [
                0,
                0
            ],
            rotateWithView: rotateWithView,
            declutterMode: options.declutterMode
        });
        /**
     * @private
     * @type {Array<number>}
     */ this.anchor_ = options.anchor !== undefined ? options.anchor : [
            0.5,
            0.5
        ];
        /**
     * @private
     * @type {Array<number>}
     */ this.normalizedAnchor_ = null;
        /**
     * @private
     * @type {IconOrigin}
     */ this.anchorOrigin_ = options.anchorOrigin !== undefined ? options.anchorOrigin : 'top-left';
        /**
     * @private
     * @type {IconAnchorUnits}
     */ this.anchorXUnits_ = options.anchorXUnits !== undefined ? options.anchorXUnits : 'fraction';
        /**
     * @private
     * @type {IconAnchorUnits}
     */ this.anchorYUnits_ = options.anchorYUnits !== undefined ? options.anchorYUnits : 'fraction';
        /**
     * @private
     * @type {?string}
     */ this.crossOrigin_ = options.crossOrigin !== undefined ? options.crossOrigin : null;
        /**
     * @private
     * @type {ReferrerPolicy}
     */ this.referrerPolicy_ = options.referrerPolicy;
        const image = options.img !== undefined ? options.img : null;
        let cacheKey = options.src;
        (0, $71eb897bda873684$export$a7a9523472993e97)(!(cacheKey !== undefined && image), '`image` and `src` cannot be provided at the same time');
        if ((cacheKey === undefined || cacheKey.length === 0) && image) cacheKey = /** @type {HTMLImageElement} */ image.src || (0, $fd76d391cc228565$export$5e82334337e0f204)(image);
        (0, $71eb897bda873684$export$a7a9523472993e97)(cacheKey !== undefined && cacheKey.length > 0, 'A defined and non-empty `src` or `image` must be provided');
        (0, $71eb897bda873684$export$a7a9523472993e97)(!((options.width !== undefined || options.height !== undefined) && options.scale !== undefined), '`width` or `height` cannot be provided together with `scale`');
        let imageState;
        if (options.src !== undefined) imageState = (0, $f217251b3f1483a0$export$2e2bcd8739ae039).IDLE;
        else if (image !== undefined) {
            if ('complete' in image) {
                if (image.complete) imageState = image.src ? (0, $f217251b3f1483a0$export$2e2bcd8739ae039).LOADED : (0, $f217251b3f1483a0$export$2e2bcd8739ae039).IDLE;
                else imageState = (0, $f217251b3f1483a0$export$2e2bcd8739ae039).LOADING;
            } else imageState = (0, $f217251b3f1483a0$export$2e2bcd8739ae039).LOADED;
        }
        /**
     * @private
     * @type {import("../color.js").Color}
     */ this.color_ = options.color !== undefined ? (0, $ebac9d8363fa165e$export$75093a47a9fa838d)(options.color) : null;
        /**
     * @private
     * @type {import("./IconImage.js").default}
     */ this.iconImage_ = (0, $671c623bccf16134$export$3988ae62b71be9a3)(image, /** @type {string} */ cacheKey, {
            crossOrigin: this.crossOrigin_,
            referrerPolicy: this.referrerPolicy_
        }, imageState, this.color_);
        /**
     * @private
     * @type {Array<number>}
     */ this.offset_ = options.offset !== undefined ? options.offset : [
            0,
            0
        ];
        /**
     * @private
     * @type {IconOrigin}
     */ this.offsetOrigin_ = options.offsetOrigin !== undefined ? options.offsetOrigin : 'top-left';
        /**
     * @private
     * @type {Array<number>}
     */ this.origin_ = null;
        /**
     * @private
     * @type {import("../size.js").Size}
     */ this.size_ = options.size !== undefined ? options.size : null;
        /**
     * @private
     */ this.initialOptions_;
        /**
     * Calculate the scale if width or height were given.
     */ if (options.width !== undefined || options.height !== undefined) {
            let width, height;
            if (options.size) [width, height] = options.size;
            else {
                const image = this.getImage(1);
                if (image.width && image.height) {
                    width = image.width;
                    height = image.height;
                } else if (image instanceof HTMLImageElement) {
                    this.initialOptions_ = options;
                    const onload = ()=>{
                        this.unlistenImageChange(onload);
                        if (!this.initialOptions_) return;
                        const imageSize = this.iconImage_.getSize();
                        this.setScale($39b0ac330ad6f6e7$var$calculateScale(imageSize[0], imageSize[1], options.width, options.height));
                    };
                    this.listenImageChange(onload);
                    return;
                }
            }
            if (width !== undefined) this.setScale($39b0ac330ad6f6e7$var$calculateScale(width, height, options.width, options.height));
        }
    }
    /**
   * Clones the style. The underlying Image/HTMLCanvasElement is not cloned.
   * @return {Icon} The cloned style.
   * @api
   * @override
   */ clone() {
        let scale, width, height;
        if (this.initialOptions_) {
            width = this.initialOptions_.width;
            height = this.initialOptions_.height;
        } else {
            scale = this.getScale();
            scale = Array.isArray(scale) ? scale.slice() : scale;
        }
        return new $39b0ac330ad6f6e7$var$Icon({
            anchor: this.anchor_.slice(),
            anchorOrigin: this.anchorOrigin_,
            anchorXUnits: this.anchorXUnits_,
            anchorYUnits: this.anchorYUnits_,
            color: this.color_ && this.color_.slice ? this.color_.slice() : this.color_ || undefined,
            crossOrigin: this.crossOrigin_,
            referrerPolicy: this.referrerPolicy_,
            offset: this.offset_.slice(),
            offsetOrigin: this.offsetOrigin_,
            opacity: this.getOpacity(),
            rotateWithView: this.getRotateWithView(),
            rotation: this.getRotation(),
            scale: scale,
            width: width,
            height: height,
            size: this.size_ !== null ? this.size_.slice() : undefined,
            src: this.getSrc(),
            displacement: this.getDisplacement().slice(),
            declutterMode: this.getDeclutterMode()
        });
    }
    /**
   * Get the anchor point in pixels. The anchor determines the center point for the
   * symbolizer.
   * @return {Array<number>} Anchor.
   * @api
   * @override
   */ getAnchor() {
        let anchor = this.normalizedAnchor_;
        if (!anchor) {
            anchor = this.anchor_;
            const size = this.getSize();
            if (this.anchorXUnits_ == 'fraction' || this.anchorYUnits_ == 'fraction') {
                if (!size) return null;
                anchor = this.anchor_.slice();
                if (this.anchorXUnits_ == 'fraction') anchor[0] *= size[0];
                if (this.anchorYUnits_ == 'fraction') anchor[1] *= size[1];
            }
            if (this.anchorOrigin_ != 'top-left') {
                if (!size) return null;
                if (anchor === this.anchor_) anchor = this.anchor_.slice();
                if (this.anchorOrigin_ == 'top-right' || this.anchorOrigin_ == 'bottom-right') anchor[0] = -anchor[0] + size[0];
                if (this.anchorOrigin_ == 'bottom-left' || this.anchorOrigin_ == 'bottom-right') anchor[1] = -anchor[1] + size[1];
            }
            this.normalizedAnchor_ = anchor;
        }
        const displacement = this.getDisplacement();
        const scale = this.getScaleArray();
        // anchor is scaled by renderer but displacement should not be scaled
        // so divide by scale here
        return [
            anchor[0] - displacement[0] / scale[0],
            anchor[1] + displacement[1] / scale[1]
        ];
    }
    /**
   * Set the anchor point. The anchor determines the center point for the
   * symbolizer.
   *
   * @param {Array<number>} anchor Anchor.
   * @api
   */ setAnchor(anchor) {
        this.anchor_ = anchor;
        this.normalizedAnchor_ = null;
    }
    /**
   * Get the icon color.
   * @return {import("../color.js").Color} Color.
   * @api
   */ getColor() {
        return this.color_;
    }
    /**
   * Set the icon color.
   *
   * Warning: Repeatedly setting the color on an icon style
   * causes the icon image to be re-created each time. This can have a
   * severe performance impact.
   *
   * @param {import("../color.js").Color|string|null|undefined} color Color.
   */ setColor(color) {
        const nextColor = color ? (0, $ebac9d8363fa165e$export$75093a47a9fa838d)(color) : null;
        if (this.color_ === nextColor || this.color_ && nextColor && this.color_.length === nextColor.length && this.color_.every((value, index)=>value === nextColor[index])) // Discard if the color hasn't changed.
        return;
        this.color_ = nextColor;
        const src = this.getSrc();
        const image = src !== undefined ? null : this.getHitDetectionImage();
        const imageState = src !== undefined ? (0, $f217251b3f1483a0$export$2e2bcd8739ae039).IDLE : this.iconImage_.getImageState();
        this.iconImage_ = (0, $671c623bccf16134$export$3988ae62b71be9a3)(image, src, {
            crossOrigin: this.crossOrigin_,
            referrerPolicy: this.referrerPolicy_
        }, imageState, this.color_);
    }
    /**
   * Get the image icon.
   * @param {number} pixelRatio Pixel ratio.
   * @return {HTMLImageElement|HTMLCanvasElement|OffscreenCanvas|ImageBitmap} Image or Canvas element. If the Icon
   * style was configured with `src` or with a not let loaded `img`, an `ImageBitmap` will be returned.
   * @api
   * @override
   */ getImage(pixelRatio) {
        return this.iconImage_.getImage(pixelRatio);
    }
    /**
   * Get the pixel ratio.
   * @param {number} pixelRatio Pixel ratio.
   * @return {number} The pixel ratio of the image.
   * @api
   * @override
   */ getPixelRatio(pixelRatio) {
        return this.iconImage_.getPixelRatio(pixelRatio);
    }
    /**
   * @return {import("../size.js").Size} Image size.
   * @override
   */ getImageSize() {
        return this.iconImage_.getSize();
    }
    /**
   * @return {import("../ImageState.js").default} Image state.
   * @override
   */ getImageState() {
        return this.iconImage_.getImageState();
    }
    /**
   * @return {HTMLImageElement|HTMLCanvasElement|OffscreenCanvas|ImageBitmap} Image element.
   * @override
   */ getHitDetectionImage() {
        return this.iconImage_.getHitDetectionImage();
    }
    /**
   * Get the origin of the symbolizer.
   * @return {Array<number>} Origin.
   * @api
   * @override
   */ getOrigin() {
        if (this.origin_) return this.origin_;
        let offset = this.offset_;
        if (this.offsetOrigin_ != 'top-left') {
            const size = this.getSize();
            const iconImageSize = this.iconImage_.getSize();
            if (!size || !iconImageSize) return null;
            offset = offset.slice();
            if (this.offsetOrigin_ == 'top-right' || this.offsetOrigin_ == 'bottom-right') offset[0] = iconImageSize[0] - size[0] - offset[0];
            if (this.offsetOrigin_ == 'bottom-left' || this.offsetOrigin_ == 'bottom-right') offset[1] = iconImageSize[1] - size[1] - offset[1];
        }
        this.origin_ = offset;
        return this.origin_;
    }
    /**
   * Get the image URL.
   * @return {string|undefined} Image src.
   * @api
   */ getSrc() {
        return this.iconImage_.getSrc();
    }
    /**
   * Set the image URI
   * @param {string} src Image source URI
   * @api
   */ setSrc(src) {
        this.iconImage_ = (0, $671c623bccf16134$export$3988ae62b71be9a3)(null, src, {
            crossOrigin: this.crossOrigin_,
            referrerPolicy: this.referrerPolicy_
        }, (0, $f217251b3f1483a0$export$2e2bcd8739ae039).IDLE, this.color_);
    }
    /**
   * Get the size of the icon (in pixels).
   * @return {import("../size.js").Size} Image size.
   * @api
   * @override
   */ getSize() {
        return !this.size_ ? this.iconImage_.getSize() : this.size_;
    }
    /**
   * Get the width of the icon (in pixels). Will return undefined when the icon image is not yet loaded.
   * @return {number} Icon width (in pixels).
   * @api
   */ getWidth() {
        const scale = this.getScaleArray();
        if (this.size_) return this.size_[0] * scale[0];
        if (this.iconImage_.getImageState() == (0, $f217251b3f1483a0$export$2e2bcd8739ae039).LOADED) return this.iconImage_.getSize()[0] * scale[0];
        return undefined;
    }
    /**
   * Get the height of the icon (in pixels). Will return undefined when the icon image is not yet loaded.
   * @return {number} Icon height (in pixels).
   * @api
   */ getHeight() {
        const scale = this.getScaleArray();
        if (this.size_) return this.size_[1] * scale[1];
        if (this.iconImage_.getImageState() == (0, $f217251b3f1483a0$export$2e2bcd8739ae039).LOADED) return this.iconImage_.getSize()[1] * scale[1];
        return undefined;
    }
    /**
   * Set the scale.
   *
   * @param {number|import("../size.js").Size} scale Scale.
   * @api
   * @override
   */ setScale(scale) {
        delete this.initialOptions_;
        super.setScale(scale);
    }
    /**
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   * @override
   */ listenImageChange(listener) {
        this.iconImage_.addEventListener((0, $b5fa963342da4935$export$2e2bcd8739ae039).CHANGE, listener);
    }
    /**
   * Load not yet loaded URI.
   * When rendering a feature with an icon style, the vector renderer will
   * automatically call this method. However, you might want to call this
   * method yourself for preloading or other purposes.
   * @api
   * @override
   */ load() {
        this.iconImage_.load();
    }
    /**
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   * @override
   */ unlistenImageChange(listener) {
        this.iconImage_.removeEventListener((0, $b5fa963342da4935$export$2e2bcd8739ae039).CHANGE, listener);
    }
    /**
   * @override
   */ ready() {
        return this.iconImage_.ready();
    }
}
var $39b0ac330ad6f6e7$export$2e2bcd8739ae039 = $39b0ac330ad6f6e7$var$Icon;


/**
 * @module ol/render/canvas/Immediate
 */ // FIXME test, especially polygons with holes and multipolygons
// FIXME need to handle large thick features (where pixel size matters)
// FIXME add offset and end to ol/geom/flat/transform~transform2D?










/**
 * @classdesc
 * A concrete subclass of {@link module:ol/render/VectorContext~VectorContext} that implements
 * direct rendering of features and geometries to an HTML5 Canvas context.
 * Instances of this class are created internally by the library and
 * provided to application code as vectorContext member of the
 * {@link module:ol/render/Event~RenderEvent} object associated with postcompose, precompose and
 * render events emitted by layers and maps.
 */ class $e0eb39101d76b2c3$var$CanvasImmediateRenderer extends (0, $5b3da3b7ea275d86$export$2e2bcd8739ae039) {
    /**
   * @param {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} context Context.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../../extent.js").Extent} extent Extent.
   * @param {import("../../transform.js").Transform} transform Transform.
   * @param {number} viewRotation View rotation.
   * @param {number} [squaredTolerance] Optional squared tolerance for simplification.
   * @param {import("../../proj.js").TransformFunction} [userTransform] Transform from user to view projection.
   */ constructor(context, pixelRatio, extent, transform, viewRotation, squaredTolerance, userTransform){
        super();
        /**
     * @private
     * @type {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D}
     */ this.context_ = context;
        /**
     * @private
     * @type {number}
     */ this.pixelRatio_ = pixelRatio;
        /**
     * @private
     * @type {import("../../extent.js").Extent}
     */ this.extent_ = extent;
        /**
     * @private
     * @type {import("../../transform.js").Transform}
     */ this.transform_ = transform;
        /**
     * @private
     * @type {number}
     */ this.transformRotation_ = transform ? (0, $6a95bd76d7103f37$export$a81f732198733497)(Math.atan2(transform[1], transform[0]), 10) : 0;
        /**
     * @private
     * @type {number}
     */ this.viewRotation_ = viewRotation;
        /**
     * @private
     * @type {number}
     */ this.squaredTolerance_ = squaredTolerance;
        /**
     * @private
     * @type {import("../../proj.js").TransformFunction}
     */ this.userTransform_ = userTransform;
        /**
     * @private
     * @type {?import("../canvas.js").FillState}
     */ this.contextFillState_ = null;
        /**
     * @private
     * @type {?import("../canvas.js").StrokeState}
     */ this.contextStrokeState_ = null;
        /**
     * @private
     * @type {?import("../canvas.js").TextState}
     */ this.contextTextState_ = null;
        /**
     * @private
     * @type {?import("../canvas.js").FillState}
     */ this.fillState_ = null;
        /**
     * @private
     * @type {?import("../canvas.js").StrokeState}
     */ this.strokeState_ = null;
        /**
     * @private
     * @type {import('../../DataTile.js').ImageLike}
     */ this.image_ = null;
        /**
     * @private
     * @type {number}
     */ this.imageAnchorX_ = 0;
        /**
     * @private
     * @type {number}
     */ this.imageAnchorY_ = 0;
        /**
     * @private
     * @type {number}
     */ this.imageHeight_ = 0;
        /**
     * @private
     * @type {number}
     */ this.imageOpacity_ = 0;
        /**
     * @private
     * @type {number}
     */ this.imageOriginX_ = 0;
        /**
     * @private
     * @type {number}
     */ this.imageOriginY_ = 0;
        /**
     * @private
     * @type {boolean}
     */ this.imageRotateWithView_ = false;
        /**
     * @private
     * @type {number}
     */ this.imageRotation_ = 0;
        /**
     * @private
     * @type {import("../../size.js").Size}
     */ this.imageScale_ = [
            0,
            0
        ];
        /**
     * @private
     * @type {number}
     */ this.imageWidth_ = 0;
        /**
     * @private
     * @type {string}
     */ this.text_ = '';
        /**
     * @private
     * @type {number}
     */ this.textOffsetX_ = 0;
        /**
     * @private
     * @type {number}
     */ this.textOffsetY_ = 0;
        /**
     * @private
     * @type {boolean}
     */ this.textRotateWithView_ = false;
        /**
     * @private
     * @type {number}
     */ this.textRotation_ = 0;
        /**
     * @private
     * @type {import("../../size.js").Size}
     */ this.textScale_ = [
            0,
            0
        ];
        /**
     * @private
     * @type {?import("../canvas.js").FillState}
     */ this.textFillState_ = null;
        /**
     * @private
     * @type {?import("../canvas.js").StrokeState}
     */ this.textStrokeState_ = null;
        /**
     * @private
     * @type {?import("../canvas.js").TextState}
     */ this.textState_ = null;
        /**
     * @private
     * @type {Array<number>}
     */ this.pixelCoordinates_ = [];
        /**
     * @private
     * @type {import("../../transform.js").Transform}
     */ this.tmpLocalTransform_ = (0, $dff5a03e015694d8$export$185802fd694ee1f5)();
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {number} end End.
   * @param {number} stride Stride.
   * @private
   */ drawImages_(flatCoordinates, offset, end, stride) {
        if (!this.image_) return;
        const pixelCoordinates = (0, $d95a11593b39996c$export$b92b2dedcfff79de)(flatCoordinates, offset, end, stride, this.transform_, this.pixelCoordinates_);
        const context = this.context_;
        const localTransform = this.tmpLocalTransform_;
        const alpha = context.globalAlpha;
        if (this.imageOpacity_ != 1) context.globalAlpha = alpha * this.imageOpacity_;
        let rotation = this.imageRotation_;
        if (this.transformRotation_ === 0) rotation -= this.viewRotation_;
        if (this.imageRotateWithView_) rotation += this.viewRotation_;
        for(let i = 0, ii = pixelCoordinates.length; i < ii; i += 2){
            const x = pixelCoordinates[i] - this.imageAnchorX_;
            const y = pixelCoordinates[i + 1] - this.imageAnchorY_;
            if (rotation !== 0 || this.imageScale_[0] != 1 || this.imageScale_[1] != 1) {
                const centerX = x + this.imageAnchorX_;
                const centerY = y + this.imageAnchorY_;
                (0, $dff5a03e015694d8$export$f672e0b6f7222cd7)(localTransform, centerX, centerY, 1, 1, rotation, -centerX, -centerY);
                context.save();
                context.transform.apply(context, localTransform);
                context.translate(centerX, centerY);
                context.scale(this.imageScale_[0], this.imageScale_[1]);
                context.drawImage(this.image_, this.imageOriginX_, this.imageOriginY_, this.imageWidth_, this.imageHeight_, -this.imageAnchorX_, -this.imageAnchorY_, this.imageWidth_, this.imageHeight_);
                context.restore();
            } else context.drawImage(this.image_, this.imageOriginX_, this.imageOriginY_, this.imageWidth_, this.imageHeight_, x, y, this.imageWidth_, this.imageHeight_);
        }
        if (this.imageOpacity_ != 1) context.globalAlpha = alpha;
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {number} end End.
   * @param {number} stride Stride.
   * @private
   */ drawText_(flatCoordinates, offset, end, stride) {
        if (!this.textState_ || this.text_ === '') return;
        if (this.textFillState_) this.setContextFillState_(this.textFillState_);
        if (this.textStrokeState_) this.setContextStrokeState_(this.textStrokeState_);
        this.setContextTextState_(this.textState_);
        const pixelCoordinates = (0, $d95a11593b39996c$export$b92b2dedcfff79de)(flatCoordinates, offset, end, stride, this.transform_, this.pixelCoordinates_);
        const context = this.context_;
        let rotation = this.textRotation_;
        if (this.transformRotation_ === 0) rotation -= this.viewRotation_;
        if (this.textRotateWithView_) rotation += this.viewRotation_;
        for(; offset < end; offset += stride){
            const x = pixelCoordinates[offset] + this.textOffsetX_;
            const y = pixelCoordinates[offset + 1] + this.textOffsetY_;
            if (rotation !== 0 || this.textScale_[0] != 1 || this.textScale_[1] != 1) {
                context.save();
                context.translate(x - this.textOffsetX_, y - this.textOffsetY_);
                context.rotate(rotation);
                context.translate(this.textOffsetX_, this.textOffsetY_);
                context.scale(this.textScale_[0], this.textScale_[1]);
                if (this.textStrokeState_) context.strokeText(this.text_, 0, 0);
                if (this.textFillState_) context.fillText(this.text_, 0, 0);
                context.restore();
            } else {
                if (this.textStrokeState_) context.strokeText(this.text_, x, y);
                if (this.textFillState_) context.fillText(this.text_, x, y);
            }
        }
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {number} end End.
   * @param {number} stride Stride.
   * @param {boolean} close Close.
   * @param {number} [strokeOffset] Stroke Offset.
   * @private
   * @return {number} end End.
   */ moveToLineTo_(flatCoordinates, offset, end, stride, close, strokeOffset) {
        const context = this.context_;
        let pixelCoordinates = (0, $d95a11593b39996c$export$b92b2dedcfff79de)(flatCoordinates, offset, end, stride, this.transform_, this.pixelCoordinates_);
        if (Math.abs(strokeOffset) > 0) pixelCoordinates = (0, $8783b79cc48761bc$export$a6b2441cc3fe7033)(pixelCoordinates, stride, strokeOffset, close, pixelCoordinates);
        context.moveTo(pixelCoordinates[0], pixelCoordinates[1]);
        let length = pixelCoordinates.length;
        if (close) length -= 2;
        for(let i = 2; i < length; i += 2)context.lineTo(pixelCoordinates[i], pixelCoordinates[i + 1]);
        if (close) context.closePath();
        return end;
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {Array<number>} ends Ends.
   * @param {number} stride Stride.
   * @param {number} [strokeOffset] Stroke Offset.
   * @private
   * @return {number} End.
   */ drawRings_(flatCoordinates, offset, ends, stride, strokeOffset) {
        for(let i = 0, ii = ends.length; i < ii; ++i)offset = this.moveToLineTo_(flatCoordinates, offset, ends[i], stride, true, strokeOffset);
        return offset;
    }
    /**
   * Render a circle geometry into the canvas.  Rendering is immediate and uses
   * the current fill and stroke styles.
   *
   * @param {import("../../geom/Circle.js").default} geometry Circle geometry.
   * @api
   * @override
   */ drawCircle(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/Circle.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        if (!(0, $dea65c2f666fa450$export$7b0a31e10bbff018)(this.extent_, geometry.getExtent())) return;
        if (this.fillState_ || this.strokeState_) {
            if (this.fillState_) this.setContextFillState_(this.fillState_);
            if (this.strokeState_) this.setContextStrokeState_(this.strokeState_);
            const pixelCoordinates = (0, $6773c3d7448f46a9$export$a3767472617c7861)(geometry, this.transform_, this.pixelCoordinates_);
            const dx = pixelCoordinates[2] - pixelCoordinates[0];
            const dy = pixelCoordinates[3] - pixelCoordinates[1];
            const radius = Math.sqrt(dx * dx + dy * dy);
            const context = this.context_;
            context.beginPath();
            context.arc(pixelCoordinates[0], pixelCoordinates[1], radius, 0, 2 * Math.PI);
            if (this.fillState_) context.fill();
            if (this.strokeState_) context.stroke();
        }
        if (this.text_ !== '') this.drawText_(geometry.getCenter(), 0, 2, 2);
    }
    /**
   * Set the rendering style.  Note that since this is an immediate rendering API,
   * any `zIndex` on the provided style will be ignored.
   *
   * @param {import("../../style/Style.js").default} style The rendering style.
   * @api
   * @override
   */ setStyle(style) {
        this.setFillStrokeStyle(style.getFill(), style.getStroke());
        this.setImageStyle(style.getImage());
        this.setTextStyle(style.getText());
    }
    /**
   * @param {import("../../transform.js").Transform} transform Transform.
   */ setTransform(transform) {
        this.transform_ = transform;
    }
    /**
   * Render a geometry into the canvas.  Call
   * {@link module:ol/render/canvas/Immediate~CanvasImmediateRenderer#setStyle renderer.setStyle()} first to set the rendering style.
   *
   * @param {import("../../geom/Geometry.js").default|import("../Feature.js").default} geometry The geometry to render.
   * @api
   * @override
   */ drawGeometry(geometry) {
        const type = geometry.getType();
        switch(type){
            case 'Point':
                this.drawPoint(/** @type {import("../../geom/Point.js").default} */ geometry);
                break;
            case 'LineString':
                this.drawLineString(/** @type {import("../../geom/LineString.js").default} */ geometry);
                break;
            case 'Polygon':
                this.drawPolygon(/** @type {import("../../geom/Polygon.js").default} */ geometry);
                break;
            case 'MultiPoint':
                this.drawMultiPoint(/** @type {import("../../geom/MultiPoint.js").default} */ geometry);
                break;
            case 'MultiLineString':
                this.drawMultiLineString(/** @type {import("../../geom/MultiLineString.js").default} */ geometry);
                break;
            case 'MultiPolygon':
                this.drawMultiPolygon(/** @type {import("../../geom/MultiPolygon.js").default} */ geometry);
                break;
            case 'GeometryCollection':
                this.drawGeometryCollection(/** @type {import("../../geom/GeometryCollection.js").default} */ geometry);
                break;
            case 'Circle':
                this.drawCircle(/** @type {import("../../geom/Circle.js").default} */ geometry);
                break;
            default:
        }
    }
    /**
   * Render a feature into the canvas.  Note that any `zIndex` on the provided
   * style will be ignored - features are rendered immediately in the order that
   * this method is called.  If you need `zIndex` support, you should be using an
   * {@link module:ol/layer/Vector~VectorLayer} instead.
   *
   * @param {import("../../Feature.js").default} feature Feature.
   * @param {import("../../style/Style.js").default} style Style.
   * @api
   * @override
   */ drawFeature(feature, style) {
        const geometry = style.getGeometryFunction()(feature);
        if (!geometry) return;
        this.setStyle(style);
        this.drawGeometry(geometry);
    }
    /**
   * Render a GeometryCollection to the canvas.  Rendering is immediate and
   * uses the current styles appropriate for each geometry in the collection.
   *
   * @param {import("../../geom/GeometryCollection.js").default} geometry Geometry collection.
   * @override
   */ drawGeometryCollection(geometry) {
        const geometries = geometry.getGeometriesArray();
        for(let i = 0, ii = geometries.length; i < ii; ++i)this.drawGeometry(geometries[i]);
    }
    /**
   * Render a Point geometry into the canvas.  Rendering is immediate and uses
   * the current style.
   *
   * @param {import("../../geom/Point.js").default|import("../Feature.js").default} geometry Point geometry.
   * @override
   */ drawPoint(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/Point.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        const flatCoordinates = geometry.getFlatCoordinates();
        const stride = geometry.getStride();
        if (this.image_) this.drawImages_(flatCoordinates, 0, flatCoordinates.length, stride);
        if (this.text_ !== '') this.drawText_(flatCoordinates, 0, flatCoordinates.length, stride);
    }
    /**
   * Render a MultiPoint geometry  into the canvas.  Rendering is immediate and
   * uses the current style.
   *
   * @param {import("../../geom/MultiPoint.js").default|import("../Feature.js").default} geometry MultiPoint geometry.
   * @override
   */ drawMultiPoint(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/MultiPoint.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        const flatCoordinates = geometry.getFlatCoordinates();
        const stride = geometry.getStride();
        if (this.image_) this.drawImages_(flatCoordinates, 0, flatCoordinates.length, stride);
        if (this.text_ !== '') this.drawText_(flatCoordinates, 0, flatCoordinates.length, stride);
    }
    /**
   * Render a LineString into the canvas.  Rendering is immediate and uses
   * the current style.
   *
   * @param {import("../../geom/LineString.js").default|import("../Feature.js").default} geometry LineString geometry.
   * @override
   */ drawLineString(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/LineString.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        if (!(0, $dea65c2f666fa450$export$7b0a31e10bbff018)(this.extent_, geometry.getExtent())) return;
        if (this.strokeState_) {
            this.setContextStrokeState_(this.strokeState_);
            const context = this.context_;
            const flatCoordinates = geometry.getFlatCoordinates();
            context.beginPath();
            this.moveToLineTo_(flatCoordinates, 0, flatCoordinates.length, geometry.getStride(), false, this.strokeState_.strokeOffset);
            context.stroke();
        }
        if (this.text_ !== '') {
            const flatMidpoint = geometry.getFlatMidpoint();
            this.drawText_(flatMidpoint, 0, 2, 2);
        }
    }
    /**
   * Render a MultiLineString geometry into the canvas.  Rendering is immediate
   * and uses the current style.
   *
   * @param {import("../../geom/MultiLineString.js").default|import("../Feature.js").default} geometry MultiLineString geometry.
   * @override
   */ drawMultiLineString(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/MultiLineString.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        const geometryExtent = geometry.getExtent();
        if (!(0, $dea65c2f666fa450$export$7b0a31e10bbff018)(this.extent_, geometryExtent)) return;
        if (this.strokeState_) {
            this.setContextStrokeState_(this.strokeState_);
            const context = this.context_;
            const flatCoordinates = geometry.getFlatCoordinates();
            let offset = 0;
            const ends = /** @type {Array<number>} */ geometry.getEnds();
            const stride = geometry.getStride();
            context.beginPath();
            for(let i = 0, ii = ends.length; i < ii; ++i)offset = this.moveToLineTo_(flatCoordinates, offset, ends[i], stride, false, this.strokeState_.strokeOffset);
            context.stroke();
        }
        if (this.text_ !== '') {
            const flatMidpoints = geometry.getFlatMidpoints();
            this.drawText_(flatMidpoints, 0, flatMidpoints.length, 2);
        }
    }
    /**
   * Render a Polygon geometry into the canvas.  Rendering is immediate and uses
   * the current style.
   *
   * @param {import("../../geom/Polygon.js").default|import("../Feature.js").default} geometry Polygon geometry.
   * @override
   */ drawPolygon(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/Polygon.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        if (!(0, $dea65c2f666fa450$export$7b0a31e10bbff018)(this.extent_, geometry.getExtent())) return;
        if (this.strokeState_ || this.fillState_) {
            if (this.fillState_) this.setContextFillState_(this.fillState_);
            if (this.strokeState_) this.setContextStrokeState_(this.strokeState_);
            const context = this.context_;
            context.beginPath();
            this.drawRings_(geometry.getOrientedFlatCoordinates(), 0, /** @type {Array<number>} */ geometry.getEnds(), geometry.getStride(), this.strokeState_?.strokeOffset);
            if (this.fillState_) context.fill();
            if (this.strokeState_) context.stroke();
        }
        if (this.text_ !== '') {
            const flatInteriorPoint = geometry.getFlatInteriorPoint();
            this.drawText_(flatInteriorPoint, 0, 2, 2);
        }
    }
    /**
   * Render MultiPolygon geometry into the canvas.  Rendering is immediate and
   * uses the current style.
   * @param {import("../../geom/MultiPolygon.js").default} geometry MultiPolygon geometry.
   * @override
   */ drawMultiPolygon(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/MultiPolygon.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        if (!(0, $dea65c2f666fa450$export$7b0a31e10bbff018)(this.extent_, geometry.getExtent())) return;
        if (this.strokeState_ || this.fillState_) {
            if (this.fillState_) this.setContextFillState_(this.fillState_);
            if (this.strokeState_) this.setContextStrokeState_(this.strokeState_);
            const context = this.context_;
            const flatCoordinates = geometry.getOrientedFlatCoordinates();
            let offset = 0;
            const endss = geometry.getEndss();
            const stride = geometry.getStride();
            context.beginPath();
            for(let i = 0, ii = endss.length; i < ii; ++i){
                const ends = endss[i];
                offset = this.drawRings_(flatCoordinates, offset, ends, stride, this.strokeState_?.strokeOffset);
            }
            if (this.fillState_) context.fill();
            if (this.strokeState_) context.stroke();
        }
        if (this.text_ !== '') {
            const flatInteriorPoints = geometry.getFlatInteriorPoints();
            this.drawText_(flatInteriorPoints, 0, flatInteriorPoints.length, 2);
        }
    }
    /**
   * @param {import("../canvas.js").FillState} fillState Fill state.
   * @private
   */ setContextFillState_(fillState) {
        const context = this.context_;
        const contextFillState = this.contextFillState_;
        if (!contextFillState) {
            context.fillStyle = fillState.fillStyle;
            this.contextFillState_ = {
                fillStyle: fillState.fillStyle
            };
        } else if (contextFillState.fillStyle != fillState.fillStyle) {
            contextFillState.fillStyle = fillState.fillStyle;
            context.fillStyle = fillState.fillStyle;
        }
    }
    /**
   * @param {import("../canvas.js").StrokeState} strokeState Stroke state.
   * @private
   */ setContextStrokeState_(strokeState) {
        const context = this.context_;
        const contextStrokeState = this.contextStrokeState_;
        if (!contextStrokeState) {
            context.lineCap = strokeState.lineCap;
            context.setLineDash(strokeState.lineDash);
            context.lineDashOffset = strokeState.lineDashOffset;
            context.lineJoin = strokeState.lineJoin;
            context.lineWidth = strokeState.lineWidth;
            context.miterLimit = strokeState.miterLimit;
            context.strokeStyle = strokeState.strokeStyle;
            this.contextStrokeState_ = {
                lineCap: strokeState.lineCap,
                lineDash: strokeState.lineDash,
                lineDashOffset: strokeState.lineDashOffset,
                lineJoin: strokeState.lineJoin,
                lineWidth: strokeState.lineWidth,
                miterLimit: strokeState.miterLimit,
                strokeStyle: strokeState.strokeStyle
            };
        } else {
            if (contextStrokeState.lineCap != strokeState.lineCap) {
                contextStrokeState.lineCap = strokeState.lineCap;
                context.lineCap = strokeState.lineCap;
            }
            if (!(0, $49313fcb0fc32abe$export$e9bab7fafb253603)(contextStrokeState.lineDash, strokeState.lineDash)) context.setLineDash(contextStrokeState.lineDash = strokeState.lineDash);
            if (contextStrokeState.lineDashOffset != strokeState.lineDashOffset) {
                contextStrokeState.lineDashOffset = strokeState.lineDashOffset;
                context.lineDashOffset = strokeState.lineDashOffset;
            }
            if (contextStrokeState.lineJoin != strokeState.lineJoin) {
                contextStrokeState.lineJoin = strokeState.lineJoin;
                context.lineJoin = strokeState.lineJoin;
            }
            if (contextStrokeState.lineWidth != strokeState.lineWidth) {
                contextStrokeState.lineWidth = strokeState.lineWidth;
                context.lineWidth = strokeState.lineWidth;
            }
            if (contextStrokeState.miterLimit != strokeState.miterLimit) {
                contextStrokeState.miterLimit = strokeState.miterLimit;
                context.miterLimit = strokeState.miterLimit;
            }
            if (contextStrokeState.strokeStyle != strokeState.strokeStyle) {
                contextStrokeState.strokeStyle = strokeState.strokeStyle;
                context.strokeStyle = strokeState.strokeStyle;
            }
        }
    }
    /**
   * @param {import("../canvas.js").TextState} textState Text state.
   * @private
   */ setContextTextState_(textState) {
        const context = this.context_;
        const contextTextState = this.contextTextState_;
        const textAlign = textState.textAlign ? textState.textAlign : (0, $6a4acf19c5e548d6$export$94d53b95641b5766);
        if (!contextTextState) {
            context.font = textState.font;
            context.textAlign = textAlign;
            context.textBaseline = textState.textBaseline;
            this.contextTextState_ = {
                font: textState.font,
                textAlign: textAlign,
                textBaseline: textState.textBaseline
            };
        } else {
            if (contextTextState.font != textState.font) {
                contextTextState.font = textState.font;
                context.font = textState.font;
            }
            if (contextTextState.textAlign != textAlign) {
                contextTextState.textAlign = textAlign;
                context.textAlign = textAlign;
            }
            if (contextTextState.textBaseline != textState.textBaseline) {
                contextTextState.textBaseline = textState.textBaseline;
                context.textBaseline = textState.textBaseline;
            }
        }
    }
    /**
   * Set the fill and stroke style for subsequent draw operations.  To clear
   * either fill or stroke styles, pass null for the appropriate parameter.
   *
   * @param {import("../../style/Fill.js").default} fillStyle Fill style.
   * @param {import("../../style/Stroke.js").default} strokeStyle Stroke style.
   * @override
   */ setFillStrokeStyle(fillStyle, strokeStyle) {
        if (!fillStyle) this.fillState_ = null;
        else {
            const fillStyleColor = fillStyle.getColor();
            this.fillState_ = {
                fillStyle: (0, $c236b40ac833efca$export$dc5b1400ac3a10a8)(fillStyleColor ? fillStyleColor : (0, $6a4acf19c5e548d6$export$c495d52ee3fd74b2))
            };
        }
        if (!strokeStyle) this.strokeState_ = null;
        else {
            const strokeStyleColor = strokeStyle.getColor();
            const strokeStyleLineCap = strokeStyle.getLineCap();
            const strokeStyleLineDash = strokeStyle.getLineDash();
            const strokeStyleLineDashOffset = strokeStyle.getLineDashOffset();
            const strokeStyleLineJoin = strokeStyle.getLineJoin();
            const strokeStyleWidth = strokeStyle.getWidth();
            const strokeStyleMiterLimit = strokeStyle.getMiterLimit();
            const lineDash = strokeStyleLineDash ? strokeStyleLineDash : (0, $6a4acf19c5e548d6$export$e21b4112fdc612fc);
            const strokeOffset = strokeStyle.getOffset();
            this.strokeState_ = {
                lineCap: strokeStyleLineCap !== undefined ? strokeStyleLineCap : (0, $6a4acf19c5e548d6$export$17bd0c38d6ae694e),
                lineDash: this.pixelRatio_ === 1 ? lineDash : lineDash.map((n)=>n * this.pixelRatio_),
                lineDashOffset: (strokeStyleLineDashOffset ? strokeStyleLineDashOffset : (0, $6a4acf19c5e548d6$export$e06efc2409049f76)) * this.pixelRatio_,
                lineJoin: strokeStyleLineJoin !== undefined ? strokeStyleLineJoin : (0, $6a4acf19c5e548d6$export$365eb9648cf19bd0),
                lineWidth: (strokeStyleWidth !== undefined ? strokeStyleWidth : (0, $6a4acf19c5e548d6$export$79661f132c62010e)) * this.pixelRatio_,
                miterLimit: strokeStyleMiterLimit !== undefined ? strokeStyleMiterLimit : (0, $6a4acf19c5e548d6$export$80c1c01844597b7b),
                strokeStyle: (0, $c236b40ac833efca$export$dc5b1400ac3a10a8)(strokeStyleColor ? strokeStyleColor : (0, $6a4acf19c5e548d6$export$1eb2eaecacf2031e)),
                strokeOffset: (strokeOffset ?? 0) * this.pixelRatio_
            };
        }
    }
    /**
   * Set the image style for subsequent draw operations.  Pass null to remove
   * the image style.
   *
   * @param {import("../../style/Image.js").default} imageStyle Image style.
   * @override
   */ setImageStyle(imageStyle) {
        let imageSize;
        if (!imageStyle || !(imageSize = imageStyle.getSize())) {
            this.image_ = null;
            return;
        }
        const imagePixelRatio = imageStyle.getPixelRatio(this.pixelRatio_);
        const imageAnchor = imageStyle.getAnchor();
        const imageOrigin = imageStyle.getOrigin();
        this.image_ = imageStyle.getImage(this.pixelRatio_);
        this.imageAnchorX_ = imageAnchor[0] * imagePixelRatio;
        this.imageAnchorY_ = imageAnchor[1] * imagePixelRatio;
        this.imageHeight_ = imageSize[1] * imagePixelRatio;
        this.imageOpacity_ = imageStyle.getOpacity();
        this.imageOriginX_ = imageOrigin[0];
        this.imageOriginY_ = imageOrigin[1];
        this.imageRotateWithView_ = imageStyle.getRotateWithView();
        this.imageRotation_ = imageStyle.getRotation();
        const imageScale = imageStyle.getScaleArray();
        this.imageScale_ = [
            imageScale[0] * this.pixelRatio_ / imagePixelRatio,
            imageScale[1] * this.pixelRatio_ / imagePixelRatio
        ];
        this.imageWidth_ = imageSize[0] * imagePixelRatio;
    }
    /**
   * Set the text style for subsequent draw operations.  Pass null to
   * remove the text style.
   *
   * @param {import("../../style/Text.js").default} textStyle Text style.
   * @override
   */ setTextStyle(textStyle) {
        if (!textStyle) this.text_ = '';
        else {
            const textFillStyle = textStyle.getFill();
            if (!textFillStyle) this.textFillState_ = null;
            else {
                const textFillStyleColor = textFillStyle.getColor();
                this.textFillState_ = {
                    fillStyle: (0, $c236b40ac833efca$export$dc5b1400ac3a10a8)(textFillStyleColor ? textFillStyleColor : (0, $6a4acf19c5e548d6$export$c495d52ee3fd74b2))
                };
            }
            const textStrokeStyle = textStyle.getStroke();
            if (!textStrokeStyle) this.textStrokeState_ = null;
            else {
                const textStrokeStyleColor = textStrokeStyle.getColor();
                const textStrokeStyleLineCap = textStrokeStyle.getLineCap();
                const textStrokeStyleLineDash = textStrokeStyle.getLineDash();
                const textStrokeStyleLineDashOffset = textStrokeStyle.getLineDashOffset();
                const textStrokeStyleLineJoin = textStrokeStyle.getLineJoin();
                const textStrokeStyleWidth = textStrokeStyle.getWidth();
                const textStrokeStyleMiterLimit = textStrokeStyle.getMiterLimit();
                this.textStrokeState_ = {
                    lineCap: textStrokeStyleLineCap !== undefined ? textStrokeStyleLineCap : (0, $6a4acf19c5e548d6$export$17bd0c38d6ae694e),
                    lineDash: textStrokeStyleLineDash ? textStrokeStyleLineDash : (0, $6a4acf19c5e548d6$export$e21b4112fdc612fc),
                    lineDashOffset: textStrokeStyleLineDashOffset ? textStrokeStyleLineDashOffset : (0, $6a4acf19c5e548d6$export$e06efc2409049f76),
                    lineJoin: textStrokeStyleLineJoin !== undefined ? textStrokeStyleLineJoin : (0, $6a4acf19c5e548d6$export$365eb9648cf19bd0),
                    lineWidth: textStrokeStyleWidth !== undefined ? textStrokeStyleWidth : (0, $6a4acf19c5e548d6$export$79661f132c62010e),
                    miterLimit: textStrokeStyleMiterLimit !== undefined ? textStrokeStyleMiterLimit : (0, $6a4acf19c5e548d6$export$80c1c01844597b7b),
                    strokeStyle: (0, $c236b40ac833efca$export$dc5b1400ac3a10a8)(textStrokeStyleColor ? textStrokeStyleColor : (0, $6a4acf19c5e548d6$export$1eb2eaecacf2031e))
                };
            }
            const textFont = textStyle.getFont();
            const textOffsetX = textStyle.getOffsetX();
            const textOffsetY = textStyle.getOffsetY();
            const textRotateWithView = textStyle.getRotateWithView();
            const textRotation = textStyle.getRotation();
            const textScale = textStyle.getScaleArray();
            const textText = textStyle.getText();
            const textTextAlign = textStyle.getTextAlign();
            const textTextBaseline = textStyle.getTextBaseline();
            this.textState_ = {
                font: textFont !== undefined ? textFont : (0, $6a4acf19c5e548d6$export$3847dfea4f8d4dfa),
                textAlign: textTextAlign !== undefined ? textTextAlign : (0, $6a4acf19c5e548d6$export$94d53b95641b5766),
                textBaseline: textTextBaseline !== undefined ? textTextBaseline : (0, $6a4acf19c5e548d6$export$cf2279a1bff62eb)
            };
            this.text_ = textText !== undefined ? Array.isArray(textText) ? textText.reduce((acc, t, i)=>acc += i % 2 ? ' ' : t, '') : textText : '';
            this.textOffsetX_ = textOffsetX !== undefined ? this.pixelRatio_ * textOffsetX : 0;
            this.textOffsetY_ = textOffsetY !== undefined ? this.pixelRatio_ * textOffsetY : 0;
            this.textRotateWithView_ = textRotateWithView !== undefined ? textRotateWithView : false;
            this.textRotation_ = textRotation !== undefined ? textRotation : 0;
            this.textScale_ = [
                this.pixelRatio_ * textScale[0],
                this.pixelRatio_ * textScale[1]
            ];
        }
    }
}
var $e0eb39101d76b2c3$export$2e2bcd8739ae039 = $e0eb39101d76b2c3$var$CanvasImmediateRenderer;


const $3a6a7a2994210734$export$ab51038298418f25 = 0.5;
function $3a6a7a2994210734$export$bd05e394339d469(size, transforms, features, styleFunction, extent, resolution, rotation, squaredTolerance, projection) {
    const userExtent = projection ? (0, $a86eee1c28205a05$export$96bfd09e2cffb006)(extent, projection) : extent;
    const width = size[0] * $3a6a7a2994210734$export$ab51038298418f25;
    const height = size[1] * $3a6a7a2994210734$export$ab51038298418f25;
    const context = (0, $b6f6d442e8ff57e1$export$9e05d10eae75c464)(width, height);
    context.imageSmoothingEnabled = false;
    const canvas = context.canvas;
    const renderer = new (0, $e0eb39101d76b2c3$export$2e2bcd8739ae039)(context, $3a6a7a2994210734$export$ab51038298418f25, extent, null, rotation, squaredTolerance, projection ? (0, $a86eee1c28205a05$export$e3c4995a701c26a3)((0, $a86eee1c28205a05$export$3973b77d5f6f2790)(), projection) : null);
    const featureCount = features.length;
    // Stretch hit detection index to use the whole available color range
    const indexFactor = Math.floor(16777215 / featureCount);
    const featuresByZIndex = {};
    for(let i = 1; i <= featureCount; ++i){
        const feature = features[i - 1];
        const featureStyleFunction = feature.getStyleFunction() || styleFunction;
        if (!featureStyleFunction) continue;
        let styles = featureStyleFunction(feature, resolution);
        if (!styles) continue;
        if (!Array.isArray(styles)) styles = [
            styles
        ];
        const index = i * indexFactor;
        const color = index.toString(16).padStart(7, '#00000');
        for(let j = 0, jj = styles.length; j < jj; ++j){
            const originalStyle = styles[j];
            const geometry = originalStyle.getGeometryFunction()(feature);
            if (!geometry || !(0, $dea65c2f666fa450$export$7b0a31e10bbff018)(userExtent, geometry.getExtent())) continue;
            const style = originalStyle.clone();
            const fill = style.getFill();
            if (fill) fill.setColor(color);
            const stroke = style.getStroke();
            if (stroke) {
                stroke.setColor(color);
                stroke.setLineDash(null);
            }
            style.setText(undefined);
            const image = originalStyle.getImage();
            if (image) {
                const imgSize = image.getImageSize();
                if (!imgSize) continue;
                const imgContext = (0, $b6f6d442e8ff57e1$export$9e05d10eae75c464)(imgSize[0], imgSize[1], undefined, {
                    alpha: false
                });
                const img = imgContext.canvas;
                imgContext.fillStyle = color;
                imgContext.fillRect(0, 0, img.width, img.height);
                style.setImage(new (0, $39b0ac330ad6f6e7$export$2e2bcd8739ae039)({
                    img: img,
                    anchor: image.getAnchor(),
                    anchorXUnits: 'pixels',
                    anchorYUnits: 'pixels',
                    offset: image.getOrigin(),
                    opacity: 1,
                    size: image.getSize(),
                    scale: image.getScale(),
                    rotation: image.getRotation(),
                    rotateWithView: image.getRotateWithView()
                }));
            }
            const zIndex = style.getZIndex() || 0;
            let byGeometryType = featuresByZIndex[zIndex];
            if (!byGeometryType) {
                byGeometryType = {};
                featuresByZIndex[zIndex] = byGeometryType;
                byGeometryType['Polygon'] = [];
                byGeometryType['Circle'] = [];
                byGeometryType['LineString'] = [];
                byGeometryType['Point'] = [];
            }
            const type = geometry.getType();
            if (type === 'GeometryCollection') {
                const geometries = /** @type {import("../../geom/GeometryCollection.js").default} */ geometry.getGeometriesArrayRecursive();
                for(let i = 0, ii = geometries.length; i < ii; ++i){
                    const geometry = geometries[i];
                    byGeometryType[geometry.getType().replace('Multi', '')].push(geometry, style);
                }
            } else byGeometryType[type.replace('Multi', '')].push(geometry, style);
        }
    }
    const zIndexKeys = Object.keys(featuresByZIndex).map(Number).sort((0, $49313fcb0fc32abe$export$fcb633242ef15540));
    for(let i = 0, ii = zIndexKeys.length; i < ii; ++i){
        const byGeometryType = featuresByZIndex[zIndexKeys[i]];
        for(const type in byGeometryType){
            const geomAndStyle = byGeometryType[type];
            for(let j = 0, jj = geomAndStyle.length; j < jj; j += 2){
                renderer.setStyle(geomAndStyle[j + 1]);
                for(let k = 0, kk = transforms.length; k < kk; ++k){
                    renderer.setTransform(transforms[k]);
                    renderer.drawGeometry(geomAndStyle[j]);
                }
            }
        }
    }
    return context.getImageData(0, 0, canvas.width, canvas.height);
}
function $3a6a7a2994210734$export$6d4d555ddbfffa32(pixel, features, imageData) {
    /** @type {Array<F>} */ const resultFeatures = [];
    if (imageData) {
        const x = Math.floor(Math.round(pixel[0]) * $3a6a7a2994210734$export$ab51038298418f25);
        const y = Math.floor(Math.round(pixel[1]) * $3a6a7a2994210734$export$ab51038298418f25);
        // The pixel coordinate is clamped down to the hit-detect canvas' size to account
        // for browsers returning coordinates slightly larger than the actual canvas size
        // due to a non-integer pixel ratio.
        const index = ((0, $6a95bd76d7103f37$export$7d15b64cf5a3a4c4)(x, 0, imageData.width - 1) + (0, $6a95bd76d7103f37$export$7d15b64cf5a3a4c4)(y, 0, imageData.height - 1) * imageData.width) * 4;
        const r = imageData.data[index];
        const g = imageData.data[index + 1];
        const b = imageData.data[index + 2];
        const i = b + 256 * (g + 256 * r);
        const indexFactor = Math.floor(16777215 / features.length);
        if (i && i % indexFactor === 0) resultFeatures.push(features[i / indexFactor - 1]);
    }
    return resultFeatures;
}



/**
 * @module ol/renderer/vector
 */ 

/**
 * Feature callback. The callback will be called with three arguments. The first
 * argument is one {@link module:ol/Feature~Feature feature} or {@link module:ol/render/Feature~RenderFeature render feature}
 * at the pixel, the second is the {@link module:ol/layer/Layer~Layer layer} of the feature and will be null for
 * unmanaged layers. The third is the {@link module:ol/geom/SimpleGeometry~SimpleGeometry} of the feature. For features
 * with a GeometryCollection geometry, it will be the first detected geometry from the collection.
 * @template T
 * @typedef {function(import("../Feature.js").FeatureLike, import("../layer/Layer.js").default<import("../source/Source").default>, import("../geom/SimpleGeometry.js").default): T} FeatureCallback
 */ /**
 * Tolerance for geometry simplification in device pixels.
 * @type {number}
 */ const $97dbb4a0b1172090$var$SIMPLIFY_TOLERANCE = 0.5;
/**
 * @const
 * @type {Object<import("../geom/Geometry.js").Type,
 *                function(import("../render/canvas/BuilderGroup.js").default, import("../geom/Geometry.js").default,
 *                         import("../style/Style.js").default, Object): void>}
 */ const $97dbb4a0b1172090$var$GEOMETRY_RENDERERS = {
    'Point': $97dbb4a0b1172090$var$renderPointGeometry,
    'LineString': $97dbb4a0b1172090$var$renderLineStringGeometry,
    'Polygon': $97dbb4a0b1172090$var$renderPolygonGeometry,
    'MultiPoint': $97dbb4a0b1172090$var$renderMultiPointGeometry,
    'MultiLineString': $97dbb4a0b1172090$var$renderMultiLineStringGeometry,
    'MultiPolygon': $97dbb4a0b1172090$var$renderMultiPolygonGeometry,
    'GeometryCollection': $97dbb4a0b1172090$var$renderGeometryCollectionGeometry,
    'Circle': $97dbb4a0b1172090$var$renderCircleGeometry
};
function $97dbb4a0b1172090$export$531ddd8416d52dfc(feature1, feature2) {
    return parseInt((0, $fd76d391cc228565$export$5e82334337e0f204)(feature1), 10) - parseInt((0, $fd76d391cc228565$export$5e82334337e0f204)(feature2), 10);
}
function $97dbb4a0b1172090$export$75084a70d324c1e6(resolution, pixelRatio) {
    const tolerance = $97dbb4a0b1172090$export$bdacc5b475012edb(resolution, pixelRatio);
    return tolerance * tolerance;
}
function $97dbb4a0b1172090$export$bdacc5b475012edb(resolution, pixelRatio) {
    return $97dbb4a0b1172090$var$SIMPLIFY_TOLERANCE * resolution / pixelRatio;
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Builder group.
 * @param {import("../geom/Circle.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").default} feature Feature.
 * @param {number} [index] Render order index.
 */ function $97dbb4a0b1172090$var$renderCircleGeometry(builderGroup, geometry, style, feature, index) {
    const fillStyle = style.getFill();
    const strokeStyle = style.getStroke();
    if (fillStyle || strokeStyle) {
        const circleReplay = builderGroup.getBuilder(style.getZIndex(), 'Circle');
        circleReplay.setFillStrokeStyle(fillStyle, strokeStyle);
        circleReplay.drawCircle(geometry, feature, index);
    }
    const textStyle = style.getText();
    if (textStyle && textStyle.getText()) {
        const textReplay = builderGroup.getBuilder(style.getZIndex(), 'Text');
        textReplay.setTextStyle(textStyle);
        textReplay.drawText(geometry, feature);
    }
}
function $97dbb4a0b1172090$export$36f470a33a42f413(replayGroup, feature, style, squaredTolerance, listener, transform, declutter, index) {
    const loadingPromises = [];
    const imageStyle = style.getImage();
    if (imageStyle) {
        let loading = true;
        const imageState = imageStyle.getImageState();
        if (imageState == (0, $f217251b3f1483a0$export$2e2bcd8739ae039).LOADED || imageState == (0, $f217251b3f1483a0$export$2e2bcd8739ae039).ERROR) loading = false;
        else if (imageState == (0, $f217251b3f1483a0$export$2e2bcd8739ae039).IDLE) imageStyle.load();
        if (loading) loadingPromises.push(imageStyle.ready());
    }
    const fillStyle = style.getFill();
    if (fillStyle && fillStyle.loading()) loadingPromises.push(fillStyle.ready());
    const loading = loadingPromises.length > 0;
    if (loading) Promise.all(loadingPromises).then(()=>listener(null));
    $97dbb4a0b1172090$var$renderFeatureInternal(replayGroup, feature, style, squaredTolerance, transform, declutter, index);
    return loading;
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} replayGroup Replay group.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {import("../style/Style.js").default} style Style.
 * @param {number} squaredTolerance Squared tolerance.
 * @param {import("../proj.js").TransformFunction} [transform] Optional transform function.
 * @param {boolean} [declutter] Enable decluttering.
 * @param {number} [index] Render order index..
 */ function $97dbb4a0b1172090$var$renderFeatureInternal(replayGroup, feature, style, squaredTolerance, transform, declutter, index) {
    const geometry = style.getGeometryFunction()(feature);
    if (!geometry) return;
    const simplifiedGeometry = geometry.simplifyTransformed(squaredTolerance, transform);
    const renderer = style.getRenderer();
    if (renderer) $97dbb4a0b1172090$var$renderGeometry(replayGroup, simplifiedGeometry, style, feature, index);
    else {
        const geometryRenderer = $97dbb4a0b1172090$var$GEOMETRY_RENDERERS[simplifiedGeometry.getType()];
        geometryRenderer(replayGroup, simplifiedGeometry, style, feature, index, declutter);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} replayGroup Replay group.
 * @param {import("../geom/Geometry.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {number} [index] Render order index.
 */ function $97dbb4a0b1172090$var$renderGeometry(replayGroup, geometry, style, feature, index) {
    if (geometry.getType() == 'GeometryCollection') {
        const geometries = /** @type {import("../geom/GeometryCollection.js").default} */ geometry.getGeometries();
        for(let i = 0, ii = geometries.length; i < ii; ++i)$97dbb4a0b1172090$var$renderGeometry(replayGroup, geometries[i], style, feature, index);
        return;
    }
    const replay = replayGroup.getBuilder(style.getZIndex(), 'Default');
    replay.drawCustom(/** @type {import("../geom/SimpleGeometry.js").default} */ geometry, feature, style.getRenderer(), style.getHitDetectionRenderer(), index);
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} replayGroup Replay group.
 * @param {import("../geom/GeometryCollection.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").default} feature Feature.
 * @param {import("../render/canvas/BuilderGroup.js").default} [declutterBuilderGroup] Builder for decluttering.
 * @param {number} [index] Render order index.
 */ function $97dbb4a0b1172090$var$renderGeometryCollectionGeometry(replayGroup, geometry, style, feature, declutterBuilderGroup, index) {
    const geometries = geometry.getGeometriesArray();
    let i, ii;
    for(i = 0, ii = geometries.length; i < ii; ++i){
        const geometryRenderer = $97dbb4a0b1172090$var$GEOMETRY_RENDERERS[geometries[i].getType()];
        geometryRenderer(replayGroup, geometries[i], style, feature, declutterBuilderGroup, index);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/LineString.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {number} [index] Render order index.
 */ function $97dbb4a0b1172090$var$renderLineStringGeometry(builderGroup, geometry, style, feature, index) {
    const strokeStyle = style.getStroke();
    if (strokeStyle) {
        const lineStringReplay = builderGroup.getBuilder(style.getZIndex(), 'LineString');
        lineStringReplay.setFillStrokeStyle(null, strokeStyle);
        lineStringReplay.drawLineString(geometry, feature, index);
    }
    const textStyle = style.getText();
    if (textStyle && textStyle.getText()) {
        const textReplay = builderGroup.getBuilder(style.getZIndex(), 'Text');
        textReplay.setTextStyle(textStyle);
        textReplay.drawText(geometry, feature, index);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/MultiLineString.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {number} [index] Render order index.
 */ function $97dbb4a0b1172090$var$renderMultiLineStringGeometry(builderGroup, geometry, style, feature, index) {
    const strokeStyle = style.getStroke();
    if (strokeStyle) {
        const lineStringReplay = builderGroup.getBuilder(style.getZIndex(), 'LineString');
        lineStringReplay.setFillStrokeStyle(null, strokeStyle);
        lineStringReplay.drawMultiLineString(geometry, feature, index);
    }
    const textStyle = style.getText();
    if (textStyle && textStyle.getText()) {
        const textReplay = builderGroup.getBuilder(style.getZIndex(), 'Text');
        textReplay.setTextStyle(textStyle);
        textReplay.drawText(geometry, feature, index);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/MultiPolygon.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").default} feature Feature.
 * @param {number} [index] Render order index.
 */ function $97dbb4a0b1172090$var$renderMultiPolygonGeometry(builderGroup, geometry, style, feature, index) {
    const fillStyle = style.getFill();
    const strokeStyle = style.getStroke();
    if (strokeStyle || fillStyle) {
        const polygonReplay = builderGroup.getBuilder(style.getZIndex(), 'Polygon');
        polygonReplay.setFillStrokeStyle(fillStyle, strokeStyle);
        polygonReplay.drawMultiPolygon(geometry, feature, index);
    }
    const textStyle = style.getText();
    if (textStyle && textStyle.getText()) {
        const textReplay = builderGroup.getBuilder(style.getZIndex(), 'Text');
        textReplay.setTextStyle(textStyle);
        textReplay.drawText(geometry, feature, index);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/Point.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {number} [index] Render order index.
 * @param {boolean} [declutter] Enable decluttering.
 */ function $97dbb4a0b1172090$var$renderPointGeometry(builderGroup, geometry, style, feature, index, declutter) {
    const imageStyle = style.getImage();
    const textStyle = style.getText();
    const hasText = textStyle && textStyle.getText();
    /** @type {import("../render/canvas.js").DeclutterImageWithText} */ const declutterImageWithText = declutter && imageStyle && hasText ? {} : undefined;
    if (imageStyle) {
        if (imageStyle.getImageState() != (0, $f217251b3f1483a0$export$2e2bcd8739ae039).LOADED) return;
        const imageReplay = builderGroup.getBuilder(style.getZIndex(), 'Image');
        imageReplay.setImageStyle(imageStyle, declutterImageWithText);
        imageReplay.drawPoint(geometry, feature, index);
    }
    if (hasText) {
        const textReplay = builderGroup.getBuilder(style.getZIndex(), 'Text');
        textReplay.setTextStyle(textStyle, declutterImageWithText);
        textReplay.drawText(geometry, feature, index);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/MultiPoint.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {number} [index] Render order index.
 * @param {boolean} [declutter] Enable decluttering.
 */ function $97dbb4a0b1172090$var$renderMultiPointGeometry(builderGroup, geometry, style, feature, index, declutter) {
    const imageStyle = style.getImage();
    const hasImage = imageStyle && imageStyle.getOpacity() !== 0;
    const textStyle = style.getText();
    const hasText = textStyle && textStyle.getText();
    /** @type {import("../render/canvas.js").DeclutterImageWithText} */ const declutterImageWithText = declutter && hasImage && hasText ? {} : undefined;
    if (hasImage) {
        if (imageStyle.getImageState() != (0, $f217251b3f1483a0$export$2e2bcd8739ae039).LOADED) return;
        const imageReplay = builderGroup.getBuilder(style.getZIndex(), 'Image');
        imageReplay.setImageStyle(imageStyle, declutterImageWithText);
        imageReplay.drawMultiPoint(geometry, feature, index);
    }
    if (hasText) {
        const textReplay = builderGroup.getBuilder(style.getZIndex(), 'Text');
        textReplay.setTextStyle(textStyle, declutterImageWithText);
        textReplay.drawText(geometry, feature, index);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/Polygon.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {number} [index] Render order index.
 */ function $97dbb4a0b1172090$var$renderPolygonGeometry(builderGroup, geometry, style, feature, index) {
    const fillStyle = style.getFill();
    const strokeStyle = style.getStroke();
    if (fillStyle || strokeStyle) {
        const polygonReplay = builderGroup.getBuilder(style.getZIndex(), 'Polygon');
        polygonReplay.setFillStrokeStyle(fillStyle, strokeStyle);
        polygonReplay.drawPolygon(geometry, feature, index);
    }
    const textStyle = style.getText();
    if (textStyle && textStyle.getText()) {
        const textReplay = builderGroup.getBuilder(style.getZIndex(), 'Text');
        textReplay.setTextStyle(textStyle);
        textReplay.drawText(geometry, feature, index);
    }
}



/**
 * @classdesc
 * Canvas renderer for vector layers.
 * @api
 */ class $c0bb897062f275b7$var$CanvasVectorLayerRenderer extends (0, $334f608456f9cc13$export$2e2bcd8739ae039) {
    /**
   * @param {import("../../layer/BaseVector.js").default} vectorLayer Vector layer.
   */ constructor(vectorLayer){
        super(vectorLayer);
        /** @private */ this.boundHandleStyleImageChange_ = this.handleStyleImageChange_.bind(this);
        /**
     * @private
     * @type {boolean}
     */ this.animatingOrInteracting_;
        /**
     * @private
     * @type {ImageData|null}
     */ this.hitDetectionImageData_ = null;
        /**
     * @private
     * @type {import("../../extent.js").Extent}
     */ this.clipExtent_ = null;
        /**
     * Do we need to extend the rendered area on the x-axis to handle
     * features that cross the antimeridian?
     * @private
     * @type {boolean}
     */ this.extendX_ = false;
        /**
     * @private
     * @type {Array<import("../../Feature.js").default>}
     */ this.renderedFeatures_ = null;
        /**
     * @private
     * @type {number}
     */ this.renderedRevision_ = -1;
        /**
     * @private
     * @type {number}
     */ this.renderedResolution_ = NaN;
        /**
     * @private
     * @type {import("../../extent.js").Extent}
     */ this.renderedExtent_ = (0, $dea65c2f666fa450$export$fe201bb3bbe031e9)();
        /**
     * @private
     * @type {import("../../extent.js").Extent}
     */ this.wrappedRenderedExtent_ = (0, $dea65c2f666fa450$export$fe201bb3bbe031e9)();
        /**
     * @private
     * @type {number}
     */ this.renderedRotation_;
        /**
     * @private
     * @type {import("../../coordinate").Coordinate}
     */ this.renderedCenter_ = null;
        /**
     * @private
     * @type {import("../../proj/Projection").default}
     */ this.renderedProjection_ = null;
        /**
     * @private
     * @type {number}
     */ this.renderedPixelRatio_ = 1;
        /**
     * @private
     * @type {import("../../render.js").OrderFunction|null}
     */ this.renderedRenderOrder_ = null;
        /**
     * @private
     * @type {boolean}
     */ this.renderedFrameDeclutter_;
        /**
     * @private
     * @type {import("../../render/canvas/ExecutorGroup").default}
     */ this.replayGroup_ = null;
        /**
     * A new replay group had to be created by `prepareFrame()`
     * @type {boolean}
     */ this.replayGroupChanged = true;
        /**
     * Clipping to be performed by `renderFrame()`
     * @type {boolean}
     */ this.clipping = true;
        /**
     * @private
     * @type {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D}
     */ this.targetContext_ = null;
        /**
     * @private
     * @type {number}
     */ this.opacity_ = 1;
    }
    /**
   * @param {ExecutorGroup} executorGroup Executor group.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {boolean} [declutterable] `true` to only render declutterable items,
   *     `false` to only render non-declutterable items, `undefined` to render all.
   */ renderWorlds(executorGroup, frameState, declutterable) {
        const extent = frameState.extent;
        const viewState = frameState.viewState;
        const center = viewState.center;
        const resolution = viewState.resolution;
        const projection = viewState.projection;
        const rotation = viewState.rotation;
        const projectionExtent = projection.getExtent();
        const vectorSource = this.getLayer().getSource();
        const declutter = this.getLayer().getDeclutter();
        const pixelRatio = frameState.pixelRatio;
        const viewHints = frameState.viewHints;
        const snapToPixel = !(viewHints[(0, $e4565fb1c11da106$export$2e2bcd8739ae039).ANIMATING] || viewHints[(0, $e4565fb1c11da106$export$2e2bcd8739ae039).INTERACTING]);
        const context = this.context;
        const width = Math.round((0, $dea65c2f666fa450$export$3c49c185de0c2bfc)(extent) / resolution * pixelRatio);
        const height = Math.round((0, $dea65c2f666fa450$export$c08559766941f856)(extent) / resolution * pixelRatio);
        const multiWorld = vectorSource.getWrapX() && projection.canWrapX();
        const worldWidth = multiWorld ? (0, $dea65c2f666fa450$export$3c49c185de0c2bfc)(projectionExtent) : null;
        const endWorld = multiWorld ? Math.ceil((extent[2] - projectionExtent[2]) / worldWidth) + (this.extendX_ ? 2 : 1) : 1;
        let world = multiWorld ? Math.floor((extent[0] - projectionExtent[0]) / worldWidth) - (this.extendX_ ? 1 : 0) : 0;
        do {
            let transform = this.getRenderTransform(center, resolution, 0, pixelRatio, width, height, world * worldWidth);
            if (frameState.declutter) transform = transform.slice(0);
            executorGroup.execute(context, [
                context.canvas.width,
                context.canvas.height
            ], transform, rotation, snapToPixel, declutterable === undefined ? (0, $f47f8a04f904c35c$export$61b49a5ae59d663) : declutterable ? (0, $f47f8a04f904c35c$export$6195a93a6c97ce02) : (0, $f47f8a04f904c35c$export$d0fe61ccfaa1ca87), declutterable ? declutter && frameState.declutter[declutter] : undefined);
        }while (++world < endWorld);
    }
    /**
   * @private
   */ setDrawContext_() {
        if (this.opacity_ !== 1) {
            this.targetContext_ = this.context;
            this.context = (0, $b6f6d442e8ff57e1$export$9e05d10eae75c464)(this.context.canvas.width, this.context.canvas.height, (0, $334f608456f9cc13$export$a166f0857c555517));
        }
    }
    /**
   * @private
   */ resetDrawContext_() {
        if (this.opacity_ !== 1 && this.targetContext_) {
            const alpha = this.targetContext_.globalAlpha;
            this.targetContext_.globalAlpha = this.opacity_;
            this.targetContext_.drawImage(this.context.canvas, 0, 0);
            this.targetContext_.globalAlpha = alpha;
            (0, $b6f6d442e8ff57e1$export$e918ac6a1026a12a)(this.context);
            (0, $334f608456f9cc13$export$a166f0857c555517).push(this.context.canvas);
            this.context = this.targetContext_;
            this.targetContext_ = null;
        }
    }
    /**
   * Render declutter items for this layer
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   */ renderDeclutter(frameState) {
        if (!this.replayGroup_ || !this.getLayer().getDeclutter()) return;
        this.renderWorlds(this.replayGroup_, frameState, true);
    }
    /**
   * Render deferred instructions.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @override
   */ renderDeferredInternal(frameState) {
        if (!this.replayGroup_) return;
        if (this.clipExtent_) this.clipUnrotated(this.context, frameState, this.clipExtent_);
        this.replayGroup_.renderDeferred();
        if (this.clipExtent_) {
            this.context.restore();
            this.clipExtent_ = null;
        }
        this.resetDrawContext_();
    }
    /**
   * Render the layer.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {HTMLElement|null} target Target that may be used to render content to.
   * @return {HTMLElement} The rendered element.
   * @override
   */ renderFrame(frameState, target) {
        const layerState = frameState.layerStatesArray[frameState.layerIndex];
        this.opacity_ = layerState.opacity;
        const viewState = frameState.viewState;
        this.prepareContainer(frameState, target);
        const context = this.context;
        const replayGroup = this.replayGroup_;
        let render = replayGroup && !replayGroup.isEmpty();
        if (!render) {
            const hasRenderListeners = this.getLayer().hasListener((0, $6e54630f610adff4$export$2e2bcd8739ae039).PRERENDER) || this.getLayer().hasListener((0, $6e54630f610adff4$export$2e2bcd8739ae039).POSTRENDER);
            if (!hasRenderListeners) return this.container;
        }
        this.setDrawContext_();
        this.preRender(context, frameState);
        const projection = viewState.projection;
        // clipped rendering if layer extent is set
        this.clipExtent_ = null;
        let clipped = false;
        if (render && layerState.extent && this.clipping) {
            const layerExtent = (0, $a86eee1c28205a05$export$494be3a3a25689ca)(layerState.extent, projection);
            render = (0, $dea65c2f666fa450$export$7b0a31e10bbff018)(layerExtent, frameState.extent);
            const needsClip = render && !(0, $dea65c2f666fa450$export$be866b1e0809b17e)(layerExtent, frameState.extent);
            if (needsClip) {
                if (frameState.declutter) // Store extent for deferred clipping
                this.clipExtent_ = layerExtent;
                else {
                    // Apply clipping immediately for non-declutter rendering
                    this.clipUnrotated(context, frameState, layerExtent);
                    clipped = true;
                }
            }
        }
        if (render) this.renderWorlds(replayGroup, frameState, this.getLayer().getDeclutter() ? false : undefined);
        if (clipped) context.restore();
        this.postRender(context, frameState);
        if (this.renderedRotation_ !== viewState.rotation) {
            this.renderedRotation_ = viewState.rotation;
            this.hitDetectionImageData_ = null;
        }
        if (!frameState.declutter) this.resetDrawContext_();
        return this.container;
    }
    /**
   * Asynchronous layer level hit detection.
   * @param {import("../../pixel.js").Pixel} pixel Pixel.
   * @return {Promise<Array<import("../../Feature").default>>} Promise
   * that resolves with an array of features.
   * @override
   */ getFeatures(pixel) {
        return new Promise((resolve)=>{
            if (this.frameState && !this.hitDetectionImageData_ && !this.animatingOrInteracting_) {
                const size = this.frameState.size.slice();
                const center = this.renderedCenter_;
                const resolution = this.renderedResolution_;
                const rotation = this.renderedRotation_;
                const projection = this.renderedProjection_;
                const extent = this.wrappedRenderedExtent_;
                const layer = this.getLayer();
                const transforms = [];
                const width = size[0] * (0, $3a6a7a2994210734$export$ab51038298418f25);
                const height = size[1] * (0, $3a6a7a2994210734$export$ab51038298418f25);
                transforms.push(this.getRenderTransform(center, resolution, rotation, (0, $3a6a7a2994210734$export$ab51038298418f25), width, height, 0).slice());
                const source = layer.getSource();
                const projectionExtent = projection.getExtent();
                if (source.getWrapX() && projection.canWrapX() && !(0, $dea65c2f666fa450$export$be866b1e0809b17e)(projectionExtent, extent)) {
                    let startX = extent[0];
                    const worldWidth = (0, $dea65c2f666fa450$export$3c49c185de0c2bfc)(projectionExtent);
                    let world = 0;
                    let offsetX;
                    while(startX < projectionExtent[0]){
                        --world;
                        offsetX = worldWidth * world;
                        transforms.push(this.getRenderTransform(center, resolution, rotation, (0, $3a6a7a2994210734$export$ab51038298418f25), width, height, offsetX).slice());
                        startX += worldWidth;
                    }
                    world = 0;
                    startX = extent[2];
                    while(startX > projectionExtent[2]){
                        ++world;
                        offsetX = worldWidth * world;
                        transforms.push(this.getRenderTransform(center, resolution, rotation, (0, $3a6a7a2994210734$export$ab51038298418f25), width, height, offsetX).slice());
                        startX -= worldWidth;
                    }
                }
                const userProjection = (0, $a86eee1c28205a05$export$3973b77d5f6f2790)();
                this.hitDetectionImageData_ = (0, $3a6a7a2994210734$export$bd05e394339d469)(size, transforms, this.renderedFeatures_, layer.getStyleFunction(), extent, resolution, rotation, (0, $97dbb4a0b1172090$export$75084a70d324c1e6)(resolution, this.renderedPixelRatio_), userProjection ? projection : null);
            }
            resolve((0, $3a6a7a2994210734$export$6d4d555ddbfffa32)(pixel, this.renderedFeatures_, this.hitDetectionImageData_));
        });
    }
    /**
   * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @param {import("../vector.js").FeatureCallback<T>} callback Feature callback.
   * @param {Array<import("../Map.js").HitMatch<T>>} matches The hit detected matches with tolerance.
   * @return {T|undefined} Callback result.
   * @template T
   * @override
   */ forEachFeatureAtCoordinate(coordinate, frameState, hitTolerance, callback, matches) {
        if (!this.replayGroup_) return undefined;
        const resolution = frameState.viewState.resolution;
        const rotation = frameState.viewState.rotation;
        const layer = this.getLayer();
        /** @type {!Object<string, import("../Map.js").HitMatch<T>|true>} */ const features = {};
        /**
     * @param {import("../../Feature.js").FeatureLike} feature Feature.
     * @param {import("../../geom/SimpleGeometry.js").default} geometry Geometry.
     * @param {number} distanceSq The squared distance to the click position
     * @return {T|undefined} Callback result.
     */ const featureCallback = function(feature, geometry, distanceSq) {
            const key = (0, $fd76d391cc228565$export$5e82334337e0f204)(feature);
            const match = features[key];
            if (!match) {
                if (distanceSq === 0) {
                    features[key] = true;
                    return callback(feature, layer, geometry);
                }
                matches.push(features[key] = {
                    feature: feature,
                    layer: layer,
                    geometry: geometry,
                    distanceSq: distanceSq,
                    callback: callback
                });
            } else if (match !== true && distanceSq < match.distanceSq) {
                if (distanceSq === 0) {
                    features[key] = true;
                    matches.splice(matches.lastIndexOf(match), 1);
                    return callback(feature, layer, geometry);
                }
                match.geometry = geometry;
                match.distanceSq = distanceSq;
            }
            return undefined;
        };
        const declutter = this.getLayer().getDeclutter();
        return this.replayGroup_.forEachFeatureAtCoordinate(coordinate, resolution, rotation, hitTolerance, featureCallback, declutter ? frameState.declutter?.[declutter]?.all().map((item)=>item.value) : null);
    }
    /**
   * Perform action necessary to get the layer rendered after new fonts have loaded
   * @override
   */ handleFontsChanged() {
        const layer = this.getLayer();
        if (layer.getVisible() && this.replayGroup_) layer.changed();
    }
    /**
   * Handle changes in image style state.
   * @param {import("../../events/Event.js").default} event Image style change event.
   * @private
   */ handleStyleImageChange_(event) {
        this.renderIfReadyAndVisible();
    }
    /**
   * Determine whether render should be called.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @return {boolean} Layer is ready to be rendered.
   * @override
   */ prepareFrame(frameState) {
        const vectorLayer = this.getLayer();
        const vectorSource = vectorLayer.getSource();
        if (!vectorSource) return false;
        const animating = frameState.viewHints[(0, $e4565fb1c11da106$export$2e2bcd8739ae039).ANIMATING];
        const interacting = frameState.viewHints[(0, $e4565fb1c11da106$export$2e2bcd8739ae039).INTERACTING];
        const updateWhileAnimating = vectorLayer.getUpdateWhileAnimating();
        const updateWhileInteracting = vectorLayer.getUpdateWhileInteracting();
        if (this.ready && !updateWhileAnimating && animating || !updateWhileInteracting && interacting) {
            this.animatingOrInteracting_ = true;
            return true;
        }
        this.animatingOrInteracting_ = false;
        const frameStateExtent = frameState.extent;
        const viewState = frameState.viewState;
        const projection = viewState.projection;
        const resolution = viewState.resolution;
        const pixelRatio = frameState.pixelRatio;
        const vectorLayerRevision = vectorLayer.getRevision();
        const vectorLayerRenderBuffer = vectorLayer.getRenderBuffer();
        let vectorLayerRenderOrder = vectorLayer.getRenderOrder();
        if (vectorLayerRenderOrder === undefined) vectorLayerRenderOrder = (0, $97dbb4a0b1172090$export$531ddd8416d52dfc);
        const center = viewState.center.slice();
        const extent = (0, $dea65c2f666fa450$export$ab1029bcae9ddb4a)(frameStateExtent, vectorLayerRenderBuffer * resolution);
        const renderedExtent = extent.slice();
        const loadExtents = [
            extent.slice()
        ];
        const projectionExtent = projection.getExtent();
        const canWrapX = vectorSource.getWrapX() && projection.canWrapX();
        this.extendX_ = false;
        if (canWrapX) {
            const sourceExtent = vectorSource.getExtent();
            if (sourceExtent && !(0, $dea65c2f666fa450$export$dd1bc94b04021eeb)(sourceExtent)) this.extendX_ = sourceExtent[0] < projectionExtent[0] || sourceExtent[2] > projectionExtent[2];
        }
        if (canWrapX && (!(0, $dea65c2f666fa450$export$be866b1e0809b17e)(projectionExtent, frameState.extent) || this.extendX_)) {
            // For the replay group, we need an extent that intersects the real world
            // (-180° to +180°). To support geometries in a coordinate range from -540°
            // to +540°, we add at least 1 world width on each side of the projection
            // extent. If the viewport is wider than the world, we need to add half of
            // the viewport width to make sure we cover the whole viewport.
            const worldWidth = (0, $dea65c2f666fa450$export$3c49c185de0c2bfc)(projectionExtent);
            const gutter = Math.max((0, $dea65c2f666fa450$export$3c49c185de0c2bfc)(extent) / 2, worldWidth);
            let projMinX = projectionExtent[0];
            let projMaxX = projectionExtent[2];
            if (this.extendX_) {
                projMinX -= worldWidth;
                projMaxX += worldWidth;
            }
            extent[0] = projMinX - gutter;
            extent[2] = projMaxX + gutter;
            (0, $a6adb03fd2fbc071$export$39a9ce3624977b84)(center, projection);
            const loadExtent = (0, $dea65c2f666fa450$export$39a9ce3624977b84)(loadExtents[0], projection);
            // If the extent crosses the date line, we load data for both edges of the worlds
            if (loadExtent[0] < projectionExtent[0] && loadExtent[2] < projectionExtent[2]) loadExtents.push([
                loadExtent[0] + worldWidth,
                loadExtent[1],
                loadExtent[2] + worldWidth,
                loadExtent[3]
            ]);
            else if (loadExtent[0] > projectionExtent[0] && loadExtent[2] > projectionExtent[2]) loadExtents.push([
                loadExtent[0] - worldWidth,
                loadExtent[1],
                loadExtent[2] - worldWidth,
                loadExtent[3]
            ]);
        }
        if (this.ready && this.renderedResolution_ == resolution && this.renderedPixelRatio_ === pixelRatio && this.renderedRevision_ == vectorLayerRevision && this.renderedRenderOrder_ == vectorLayerRenderOrder && this.renderedFrameDeclutter_ === !!frameState.declutter && (0, $dea65c2f666fa450$export$be866b1e0809b17e)(this.wrappedRenderedExtent_, extent)) {
            if (!(0, $49313fcb0fc32abe$export$e9bab7fafb253603)(this.renderedExtent_, renderedExtent)) {
                this.hitDetectionImageData_ = null;
                this.renderedExtent_ = renderedExtent;
            }
            this.renderedCenter_ = center;
            this.replayGroupChanged = false;
            return true;
        }
        this.replayGroup_ = null;
        const replayGroup = new (0, $4ec4bc54afb0adab$export$2e2bcd8739ae039)((0, $97dbb4a0b1172090$export$bdacc5b475012edb)(resolution, pixelRatio), extent, resolution, pixelRatio);
        const userProjection = (0, $a86eee1c28205a05$export$3973b77d5f6f2790)();
        let userTransform;
        if (userProjection) {
            for(let i = 0, ii = loadExtents.length; i < ii; ++i){
                const extent = loadExtents[i];
                const userExtent = (0, $a86eee1c28205a05$export$96bfd09e2cffb006)(extent, projection);
                vectorSource.loadFeatures(userExtent, (0, $a86eee1c28205a05$export$b56bb8ad8b3a00e9)(resolution, projection), userProjection);
            }
            userTransform = (0, $a86eee1c28205a05$export$e3c4995a701c26a3)(userProjection, projection);
        } else for(let i = 0, ii = loadExtents.length; i < ii; ++i)vectorSource.loadFeatures(loadExtents[i], resolution, projection);
        const squaredTolerance = (0, $97dbb4a0b1172090$export$75084a70d324c1e6)(resolution, pixelRatio);
        let ready = true;
        const render = /**
       * @param {import("../../Feature.js").default} feature Feature.
       * @param {number} index Index.
       */ (feature, index)=>{
            let styles;
            const styleFunction = feature.getStyleFunction() || vectorLayer.getStyleFunction();
            if (styleFunction) styles = styleFunction(feature, resolution);
            if (styles) {
                const dirty = this.renderFeature(feature, squaredTolerance, styles, replayGroup, userTransform, this.getLayer().getDeclutter(), index);
                ready = ready && !dirty;
            }
        };
        const userExtent = (0, $a86eee1c28205a05$export$96bfd09e2cffb006)(extent, projection);
        /** @type {Array<import("../../Feature.js").default>} */ const features = vectorSource.getFeaturesInExtent(userExtent);
        if (vectorLayerRenderOrder) features.sort(vectorLayerRenderOrder);
        for(let i = 0, ii = features.length; i < ii; ++i)render(features[i], i);
        this.renderedFeatures_ = features;
        this.ready = ready;
        const replayGroupInstructions = replayGroup.finish();
        const executorGroup = new (0, $f47f8a04f904c35c$export$2e2bcd8739ae039)(extent, resolution, pixelRatio, vectorSource.getOverlaps(), replayGroupInstructions, vectorLayer.getRenderBuffer(), !!frameState.declutter);
        this.renderedResolution_ = resolution;
        this.renderedRevision_ = vectorLayerRevision;
        this.renderedRenderOrder_ = vectorLayerRenderOrder;
        this.renderedFrameDeclutter_ = !!frameState.declutter;
        this.renderedExtent_ = renderedExtent;
        this.wrappedRenderedExtent_ = extent;
        this.renderedCenter_ = center;
        this.renderedProjection_ = projection;
        this.renderedPixelRatio_ = pixelRatio;
        this.replayGroup_ = executorGroup;
        this.hitDetectionImageData_ = null;
        this.replayGroupChanged = true;
        return true;
    }
    /**
   * @param {import("../../Feature.js").default} feature Feature.
   * @param {number} squaredTolerance Squared render tolerance.
   * @param {import("../../style/Style.js").default|Array<import("../../style/Style.js").default>} styles The style or array of styles.
   * @param {import("../../render/canvas/BuilderGroup.js").default} builderGroup Builder group.
   * @param {import("../../proj.js").TransformFunction} [transform] Transform from user to view projection.
   * @param {boolean} [declutter] Enable decluttering.
   * @param {number} [index] Render order index.
   * @return {boolean} `true` if an image is loading.
   */ renderFeature(feature, squaredTolerance, styles, builderGroup, transform, declutter, index) {
        if (!styles) return false;
        let loading = false;
        if (Array.isArray(styles)) for(let i = 0, ii = styles.length; i < ii; ++i)loading = (0, $97dbb4a0b1172090$export$36f470a33a42f413)(builderGroup, feature, styles[i], squaredTolerance, this.boundHandleStyleImageChange_, transform, declutter, index) || loading;
        else loading = (0, $97dbb4a0b1172090$export$36f470a33a42f413)(builderGroup, feature, styles, squaredTolerance, this.boundHandleStyleImageChange_, transform, declutter, index);
        return loading;
    }
}
var $c0bb897062f275b7$export$2e2bcd8739ae039 = $c0bb897062f275b7$var$CanvasVectorLayerRenderer;


/**
 * @module ol/layer/BaseVector
 */ /**
 * Rearranges items so that all items in the [left, k] are the smallest.
 * The k-th element will have the (k - left + 1)-th smallest value in [left, right].
 *
 * @template T
 * @param {T[]} arr the array to partially sort (in place)
 * @param {number} k middle index for partial sorting (as defined above)
 * @param {number} [left=0] left index of the range to sort
 * @param {number} [right=arr.length-1] right index
 * @param {(a: T, b: T) => number} [compare = (a, b) => a - b] compare function
 */ function $3489d8ae5823df50$export$2e2bcd8739ae039(arr, k, left = 0, right = arr.length - 1, compare = $3489d8ae5823df50$var$defaultCompare) {
    while(right > left){
        if (right - left > 600) {
            const n = right - left + 1;
            const m = k - left + 1;
            const z = Math.log(n);
            const s = 0.5 * Math.exp(2 * z / 3);
            const sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
            const newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
            const newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
            $3489d8ae5823df50$export$2e2bcd8739ae039(arr, k, newLeft, newRight, compare);
        }
        const t = arr[k];
        let i = left;
        /** @type {number} */ let j = right;
        $3489d8ae5823df50$var$swap(arr, left, k);
        if (compare(arr[right], t) > 0) $3489d8ae5823df50$var$swap(arr, left, right);
        while(i < j){
            $3489d8ae5823df50$var$swap(arr, i, j);
            i++;
            j--;
            while(compare(arr[i], t) < 0)i++;
            while(compare(arr[j], t) > 0)j--;
        }
        if (compare(arr[left], t) === 0) $3489d8ae5823df50$var$swap(arr, left, j);
        else {
            j++;
            $3489d8ae5823df50$var$swap(arr, j, right);
        }
        if (j <= k) left = j + 1;
        if (k <= j) right = j - 1;
    }
}
/**
 * @template T
 * @param {T[]} arr
 * @param {number} i
 * @param {number} j
 */ function $3489d8ae5823df50$var$swap(arr, i, j) {
    const tmp = arr[i];
    arr[i] = arr[j];
    arr[j] = tmp;
}
/**
 * @template T
 * @param {T} a
 * @param {T} b
 * @returns {number}
 */ function $3489d8ae5823df50$var$defaultCompare(a, b) {
    return a < b ? -1 : a > b ? 1 : 0;
}


class $fb66a48cf2a65dd1$export$2e2bcd8739ae039 {
    constructor(maxEntries = 9){
        // max entries in a node is 9 by default; min node fill is 40% for best performance
        this._maxEntries = Math.max(4, maxEntries);
        this._minEntries = Math.max(2, Math.ceil(this._maxEntries * 0.4));
        this.clear();
    }
    all() {
        return this._all(this.data, []);
    }
    search(bbox) {
        let node = this.data;
        const result = [];
        if (!$fb66a48cf2a65dd1$var$intersects(bbox, node)) return result;
        const toBBox = this.toBBox;
        const nodesToSearch = [];
        while(node){
            for(let i = 0; i < node.children.length; i++){
                const child = node.children[i];
                const childBBox = node.leaf ? toBBox(child) : child;
                if ($fb66a48cf2a65dd1$var$intersects(bbox, childBBox)) {
                    if (node.leaf) result.push(child);
                    else if ($fb66a48cf2a65dd1$var$contains(bbox, childBBox)) this._all(child, result);
                    else nodesToSearch.push(child);
                }
            }
            node = nodesToSearch.pop();
        }
        return result;
    }
    collides(bbox) {
        let node = this.data;
        if (!$fb66a48cf2a65dd1$var$intersects(bbox, node)) return false;
        const nodesToSearch = [];
        while(node){
            for(let i = 0; i < node.children.length; i++){
                const child = node.children[i];
                const childBBox = node.leaf ? this.toBBox(child) : child;
                if ($fb66a48cf2a65dd1$var$intersects(bbox, childBBox)) {
                    if (node.leaf || $fb66a48cf2a65dd1$var$contains(bbox, childBBox)) return true;
                    nodesToSearch.push(child);
                }
            }
            node = nodesToSearch.pop();
        }
        return false;
    }
    load(data) {
        if (!(data && data.length)) return this;
        if (data.length < this._minEntries) {
            for(let i = 0; i < data.length; i++)this.insert(data[i]);
            return this;
        }
        // recursively build the tree with the given data from scratch using OMT algorithm
        let node = this._build(data.slice(), 0, data.length - 1, 0);
        if (!this.data.children.length) // save as is if tree is empty
        this.data = node;
        else if (this.data.height === node.height) // split root if trees have the same height
        this._splitRoot(this.data, node);
        else {
            if (this.data.height < node.height) {
                // swap trees if inserted one is bigger
                const tmpNode = this.data;
                this.data = node;
                node = tmpNode;
            }
            // insert the small tree into the large tree at appropriate level
            this._insert(node, this.data.height - node.height - 1, true);
        }
        return this;
    }
    insert(item) {
        if (item) this._insert(item, this.data.height - 1);
        return this;
    }
    clear() {
        this.data = $fb66a48cf2a65dd1$var$createNode([]);
        return this;
    }
    remove(item, equalsFn) {
        if (!item) return this;
        let node = this.data;
        const bbox = this.toBBox(item);
        const path = [];
        const indexes = [];
        let i, parent, goingUp;
        // depth-first iterative tree traversal
        while(node || path.length){
            if (!node) {
                node = path.pop();
                parent = path[path.length - 1];
                i = indexes.pop();
                goingUp = true;
            }
            if (node.leaf) {
                const index = $fb66a48cf2a65dd1$var$findItem(item, node.children, equalsFn);
                if (index !== -1) {
                    // item found, remove the item and condense tree upwards
                    node.children.splice(index, 1);
                    path.push(node);
                    this._condense(path);
                    return this;
                }
            }
            if (!goingUp && !node.leaf && $fb66a48cf2a65dd1$var$contains(node, bbox)) {
                path.push(node);
                indexes.push(i);
                i = 0;
                parent = node;
                node = node.children[0];
            } else if (parent) {
                i++;
                node = parent.children[i];
                goingUp = false;
            } else node = null; // nothing found
        }
        return this;
    }
    toBBox(item) {
        return item;
    }
    compareMinX(a, b) {
        return a.minX - b.minX;
    }
    compareMinY(a, b) {
        return a.minY - b.minY;
    }
    toJSON() {
        return this.data;
    }
    fromJSON(data) {
        this.data = data;
        return this;
    }
    _all(node, result) {
        const nodesToSearch = [];
        while(node){
            if (node.leaf) result.push(...node.children);
            else nodesToSearch.push(...node.children);
            node = nodesToSearch.pop();
        }
        return result;
    }
    _build(items, left, right, height) {
        const N = right - left + 1;
        let M = this._maxEntries;
        let node;
        if (N <= M) {
            // reached leaf level; return leaf
            node = $fb66a48cf2a65dd1$var$createNode(items.slice(left, right + 1));
            $fb66a48cf2a65dd1$var$calcBBox(node, this.toBBox);
            return node;
        }
        if (!height) {
            // target height of the bulk-loaded tree
            height = Math.ceil(Math.log(N) / Math.log(M));
            // target number of root entries to maximize storage utilization
            M = Math.ceil(N / Math.pow(M, height - 1));
        }
        node = $fb66a48cf2a65dd1$var$createNode([]);
        node.leaf = false;
        node.height = height;
        // split the items into M mostly square tiles
        const N2 = Math.ceil(N / M);
        const N1 = N2 * Math.ceil(Math.sqrt(M));
        $fb66a48cf2a65dd1$var$multiSelect(items, left, right, N1, this.compareMinX);
        for(let i = left; i <= right; i += N1){
            const right2 = Math.min(i + N1 - 1, right);
            $fb66a48cf2a65dd1$var$multiSelect(items, i, right2, N2, this.compareMinY);
            for(let j = i; j <= right2; j += N2){
                const right3 = Math.min(j + N2 - 1, right2);
                // pack each entry recursively
                node.children.push(this._build(items, j, right3, height - 1));
            }
        }
        $fb66a48cf2a65dd1$var$calcBBox(node, this.toBBox);
        return node;
    }
    _chooseSubtree(bbox, node, level, path) {
        while(true){
            path.push(node);
            if (node.leaf || path.length - 1 === level) break;
            let minArea = Infinity;
            let minEnlargement = Infinity;
            let targetNode;
            for(let i = 0; i < node.children.length; i++){
                const child = node.children[i];
                const area = $fb66a48cf2a65dd1$var$bboxArea(child);
                const enlargement = $fb66a48cf2a65dd1$var$enlargedArea(bbox, child) - area;
                // choose entry with the least area enlargement
                if (enlargement < minEnlargement) {
                    minEnlargement = enlargement;
                    minArea = area < minArea ? area : minArea;
                    targetNode = child;
                } else if (enlargement === minEnlargement) // otherwise choose one with the smallest area
                {
                    if (area < minArea) {
                        minArea = area;
                        targetNode = child;
                    }
                }
            }
            node = targetNode || node.children[0];
        }
        return node;
    }
    _insert(item, level, isNode) {
        const bbox = isNode ? item : this.toBBox(item);
        const insertPath = [];
        // find the best node for accommodating the item, saving all nodes along the path too
        const node = this._chooseSubtree(bbox, this.data, level, insertPath);
        // put the item into the node
        node.children.push(item);
        $fb66a48cf2a65dd1$var$extend(node, bbox);
        // split on node overflow; propagate upwards if necessary
        while(level >= 0){
            if (insertPath[level].children.length > this._maxEntries) {
                this._split(insertPath, level);
                level--;
            } else break;
        }
        // adjust bboxes along the insertion path
        this._adjustParentBBoxes(bbox, insertPath, level);
    }
    // split overflowed node into two
    _split(insertPath, level) {
        const node = insertPath[level];
        const M = node.children.length;
        const m = this._minEntries;
        this._chooseSplitAxis(node, m, M);
        const splitIndex = this._chooseSplitIndex(node, m, M);
        const newNode = $fb66a48cf2a65dd1$var$createNode(node.children.splice(splitIndex, node.children.length - splitIndex));
        newNode.height = node.height;
        newNode.leaf = node.leaf;
        $fb66a48cf2a65dd1$var$calcBBox(node, this.toBBox);
        $fb66a48cf2a65dd1$var$calcBBox(newNode, this.toBBox);
        if (level) insertPath[level - 1].children.push(newNode);
        else this._splitRoot(node, newNode);
    }
    _splitRoot(node, newNode) {
        // split root node
        this.data = $fb66a48cf2a65dd1$var$createNode([
            node,
            newNode
        ]);
        this.data.height = node.height + 1;
        this.data.leaf = false;
        $fb66a48cf2a65dd1$var$calcBBox(this.data, this.toBBox);
    }
    _chooseSplitIndex(node, m, M) {
        let index;
        let minOverlap = Infinity;
        let minArea = Infinity;
        for(let i = m; i <= M - m; i++){
            const bbox1 = $fb66a48cf2a65dd1$var$distBBox(node, 0, i, this.toBBox);
            const bbox2 = $fb66a48cf2a65dd1$var$distBBox(node, i, M, this.toBBox);
            const overlap = $fb66a48cf2a65dd1$var$intersectionArea(bbox1, bbox2);
            const area = $fb66a48cf2a65dd1$var$bboxArea(bbox1) + $fb66a48cf2a65dd1$var$bboxArea(bbox2);
            // choose distribution with minimum overlap
            if (overlap < minOverlap) {
                minOverlap = overlap;
                index = i;
                minArea = area < minArea ? area : minArea;
            } else if (overlap === minOverlap) // otherwise choose distribution with minimum area
            {
                if (area < minArea) {
                    minArea = area;
                    index = i;
                }
            }
        }
        return index || M - m;
    }
    // sorts node children by the best axis for split
    _chooseSplitAxis(node, m, M) {
        const compareMinX = node.leaf ? this.compareMinX : $fb66a48cf2a65dd1$var$compareNodeMinX;
        const compareMinY = node.leaf ? this.compareMinY : $fb66a48cf2a65dd1$var$compareNodeMinY;
        const xMargin = this._allDistMargin(node, m, M, compareMinX);
        const yMargin = this._allDistMargin(node, m, M, compareMinY);
        // if total distributions margin value is minimal for x, sort by minX,
        // otherwise it's already sorted by minY
        if (xMargin < yMargin) node.children.sort(compareMinX);
    }
    // total margin of all possible split distributions where each node is at least m full
    _allDistMargin(node, m, M, compare) {
        node.children.sort(compare);
        const toBBox = this.toBBox;
        const leftBBox = $fb66a48cf2a65dd1$var$distBBox(node, 0, m, toBBox);
        const rightBBox = $fb66a48cf2a65dd1$var$distBBox(node, M - m, M, toBBox);
        let margin = $fb66a48cf2a65dd1$var$bboxMargin(leftBBox) + $fb66a48cf2a65dd1$var$bboxMargin(rightBBox);
        for(let i = m; i < M - m; i++){
            const child = node.children[i];
            $fb66a48cf2a65dd1$var$extend(leftBBox, node.leaf ? toBBox(child) : child);
            margin += $fb66a48cf2a65dd1$var$bboxMargin(leftBBox);
        }
        for(let i = M - m - 1; i >= m; i--){
            const child = node.children[i];
            $fb66a48cf2a65dd1$var$extend(rightBBox, node.leaf ? toBBox(child) : child);
            margin += $fb66a48cf2a65dd1$var$bboxMargin(rightBBox);
        }
        return margin;
    }
    _adjustParentBBoxes(bbox, path, level) {
        // adjust bboxes along the given tree path
        for(let i = level; i >= 0; i--)$fb66a48cf2a65dd1$var$extend(path[i], bbox);
    }
    _condense(path) {
        // go through the path, removing empty nodes and updating bboxes
        for(let i = path.length - 1, siblings; i >= 0; i--)if (path[i].children.length === 0) {
            if (i > 0) {
                siblings = path[i - 1].children;
                siblings.splice(siblings.indexOf(path[i]), 1);
            } else this.clear();
        } else $fb66a48cf2a65dd1$var$calcBBox(path[i], this.toBBox);
    }
}
function $fb66a48cf2a65dd1$var$findItem(item, items, equalsFn) {
    if (!equalsFn) return items.indexOf(item);
    for(let i = 0; i < items.length; i++){
        if (equalsFn(item, items[i])) return i;
    }
    return -1;
}
// calculate node's bbox from bboxes of its children
function $fb66a48cf2a65dd1$var$calcBBox(node, toBBox) {
    $fb66a48cf2a65dd1$var$distBBox(node, 0, node.children.length, toBBox, node);
}
// min bounding rectangle of node children from k to p-1
function $fb66a48cf2a65dd1$var$distBBox(node, k, p, toBBox, destNode) {
    if (!destNode) destNode = $fb66a48cf2a65dd1$var$createNode(null);
    destNode.minX = Infinity;
    destNode.minY = Infinity;
    destNode.maxX = -Infinity;
    destNode.maxY = -Infinity;
    for(let i = k; i < p; i++){
        const child = node.children[i];
        $fb66a48cf2a65dd1$var$extend(destNode, node.leaf ? toBBox(child) : child);
    }
    return destNode;
}
function $fb66a48cf2a65dd1$var$extend(a, b) {
    a.minX = Math.min(a.minX, b.minX);
    a.minY = Math.min(a.minY, b.minY);
    a.maxX = Math.max(a.maxX, b.maxX);
    a.maxY = Math.max(a.maxY, b.maxY);
    return a;
}
function $fb66a48cf2a65dd1$var$compareNodeMinX(a, b) {
    return a.minX - b.minX;
}
function $fb66a48cf2a65dd1$var$compareNodeMinY(a, b) {
    return a.minY - b.minY;
}
function $fb66a48cf2a65dd1$var$bboxArea(a) {
    return (a.maxX - a.minX) * (a.maxY - a.minY);
}
function $fb66a48cf2a65dd1$var$bboxMargin(a) {
    return a.maxX - a.minX + (a.maxY - a.minY);
}
function $fb66a48cf2a65dd1$var$enlargedArea(a, b) {
    return (Math.max(b.maxX, a.maxX) - Math.min(b.minX, a.minX)) * (Math.max(b.maxY, a.maxY) - Math.min(b.minY, a.minY));
}
function $fb66a48cf2a65dd1$var$intersectionArea(a, b) {
    const minX = Math.max(a.minX, b.minX);
    const minY = Math.max(a.minY, b.minY);
    const maxX = Math.min(a.maxX, b.maxX);
    const maxY = Math.min(a.maxY, b.maxY);
    return Math.max(0, maxX - minX) * Math.max(0, maxY - minY);
}
function $fb66a48cf2a65dd1$var$contains(a, b) {
    return a.minX <= b.minX && a.minY <= b.minY && b.maxX <= a.maxX && b.maxY <= a.maxY;
}
function $fb66a48cf2a65dd1$var$intersects(a, b) {
    return b.minX <= a.maxX && b.minY <= a.maxY && b.maxX >= a.minX && b.maxY >= a.minY;
}
function $fb66a48cf2a65dd1$var$createNode(children) {
    return {
        children: children,
        height: 1,
        leaf: true,
        minX: Infinity,
        minY: Infinity,
        maxX: -Infinity,
        maxY: -Infinity
    };
}
// sort an array so that items come in groups of n unsorted items, with groups sorted between each other;
// combines selection algorithm with binary divide & conquer approach
function $fb66a48cf2a65dd1$var$multiSelect(arr, left, right, n, compare) {
    const stack = [
        left,
        right
    ];
    while(stack.length){
        right = stack.pop();
        left = stack.pop();
        if (right - left <= n) continue;
        const mid = left + Math.ceil((right - left) / n / 2) * n;
        (0, $3489d8ae5823df50$export$2e2bcd8739ae039)(arr, mid, left, right, compare);
        stack.push(left, mid, mid, right);
    }
}


/**
 * @module ol/render/canvas/style
 */ 
/**
 * @module ol/expr/cpu
 */ 
/**
 * @module ol/expr/expression
 */ 


/**
 * @fileoverview This module includes types and functions for parsing array encoded expressions.
 * The result of parsing an encoded expression is one of the specific expression classes.
 * During parsing, information is added to the parsing context about the data accessed by the
 * expression.
 */ /**
 * Base type used for literal style parameters; can be a number literal or the output of an operator,
 * which in turns takes {@link import("./expression.js").ExpressionValue} arguments.
 *
 * See below for details on the available operators (with notes for those that are WebGL or Canvas only).
 *
 * Reading operators:
 *   * `['band', bandIndex, xOffset, yOffset]` For tile layers only. Fetches pixel values from band
 *     `bandIndex` of the source's data. The first `bandIndex` of the source data is `1`. Fetched values
 *     are in the 0..1 range. {@link import("../source/TileImage.js").default} sources have 4 bands: red,
 *     green, blue and alpha. {@link import("../source/DataTile.js").default} sources can have any number
 *     of bands, depending on the underlying data source and
 *     {@link import("../source/GeoTIFF.js").Options configuration}. `xOffset` and `yOffset` are optional
 *     and allow specifying pixel offsets for x and y. This is used for sampling data from neighboring pixels (WebGL only).
 *   * `['get', attributeName]` fetches a feature property value, similar to `feature.get('attributeName')`.
 *   * `['get', attributeName, keyOrArrayIndex, ...]` (Canvas only) Access nested properties and array items of a
 *     feature property. The result is `undefined` when there is nothing at the specified key or index.
 *   * `['geometry-type']` returns a feature's geometry type as string, either: 'LineString', 'Point' or 'Polygon'
 *     `Multi*` values are returned as their singular equivalent
 *     `Circle` geometries are returned as 'Polygon'
 *     `GeometryCollection` geometries are returned as the type of the first geometry found in the collection (WebGL only).
 *   * `['resolution']` returns the current resolution
 *   * `['time']` The time in seconds since the creation of the layer (WebGL only).
 *   * `['var', 'varName']` fetches a value from the style variables; will throw an error if that variable is undefined
 *   * `['zoom']` The current zoom level (WebGL only).
 *   * `['line-metric']` returns the M component of the current point on a line (WebGL only); in case where the geometry layout of the line
 *      does not contain an M component (e.g. XY or XYZ), 0 is returned; 0 is also returned for geometries other than lines.
 *      Please note that the M component will be linearly interpolated between the two points composing a segment.
 *
 * Math operators:
 *   * `['*', value1, value2, ...]` multiplies the values (either numbers or colors)
 *   * `['/', value1, value2]` divides `value1` by `value2`
 *   * `['+', value1, value2, ...]` adds the values
 *   * `['-', value1, value2]` subtracts `value2` from `value1`
 *   * `['clamp', value, low, high]` clamps `value` between `low` and `high`
 *   * `['%', value1, value2]` returns the result of `value1 % value2` (modulo)
 *   * `['^', value1, value2]` returns the value of `value1` raised to the `value2` power
 *   * `['abs', value1]` returns the absolute value of `value1`
 *   * `['floor', value1]` returns the nearest integer less than or equal to `value1`
 *   * `['round', value1]` returns the nearest integer to `value1`
 *   * `['ceil', value1]` returns the nearest integer greater than or equal to `value1`
 *   * `['sin', value1]` returns the sine of `value1`
 *   * `['cos', value1]` returns the cosine of `value1`
 *   * `['atan', value1, value2]` returns `atan2(value1, value2)`. If `value2` is not provided, returns `atan(value1)`
 *   * `['sqrt', value1]` returns the square root of `value1`
 *
 * * Transform operators:
 *   * `['case', condition1, output1, ...conditionN, outputN, fallback]` selects the first output whose corresponding
 *     condition evaluates to `true`. If no match is found, returns the `fallback` value.
 *     All conditions should be `boolean`, output and fallback can be any kind.
 *   * `['match', input, match1, output1, ...matchN, outputN, fallback]` compares the `input` value against all
 *     provided `matchX` values, returning the output associated with the first valid match. If no match is found,
 *     returns the `fallback` value.
 *     `input` and `matchX` values must all be of the same type, and can be `number` or `string`. `outputX` and
 *     `fallback` values must be of the same type, and can be of any kind.
 *   * `['interpolate', interpolation, input, stop1, output1, ...stopN, outputN]` returns a value by interpolating between
 *     pairs of inputs and outputs; `interpolation` can either be `['linear']` or `['exponential', base]` where `base` is
 *     the rate of increase from stop A to stop B (i.e. power to which the interpolation ratio is raised); a value
 *     of 1 is equivalent to `['linear']`.
 *     `input` and `stopX` values must all be of type `number`. `outputX` values can be `number` or `color` values.
 *     Note: `input` will be clamped between `stop1` and `stopN`, meaning that all output values will be comprised
 *     between `output1` and `outputN`.
 *   * `['string', value1, value2, ...]` returns the first value in the list that evaluates to a string.
 *     An example would be to provide a default value for get: `['string', ['get', 'propertyname'], 'default value']]`
 *     (Canvas only).
 *   * `['number', value1, value2, ...]` returns the first value in the list that evaluates to a number.
 *     An example would be to provide a default value for get: `['string', ['get', 'propertyname'], 42]]`
 *     (Canvas only).
 *   * `['coalesce', value1, value2, ...]` returns the first value in the list which is not null or undefined.
 *     An example would be to provide a default value for get: `['coalesce', ['get','propertyname'], 'default value']]`
 *     (Canvas only).
 *
 * * Logical operators:
 *   * `['<', value1, value2]` returns `true` if `value1` is strictly lower than `value2`, or `false` otherwise.
 *   * `['<=', value1, value2]` returns `true` if `value1` is lower than or equals `value2`, or `false` otherwise.
 *   * `['>', value1, value2]` returns `true` if `value1` is strictly greater than `value2`, or `false` otherwise.
 *   * `['>=', value1, value2]` returns `true` if `value1` is greater than or equals `value2`, or `false` otherwise.
 *   * `['==', value1, value2]` returns `true` if `value1` equals `value2`, or `false` otherwise.
 *   * `['!=', value1, value2]` returns `true` if `value1` does not equal `value2`, or `false` otherwise.
 *   * `['!', value1]` returns `false` if `value1` is `true` or greater than `0`, or `true` otherwise.
 *   * `['all', value1, value2, ...]` returns `true` if all the inputs are `true`, `false` otherwise.
 *   * `['any', value1, value2, ...]` returns `true` if any of the inputs are `true`, `false` otherwise.
 *   * `['has', attributeName, keyOrArrayIndex, ...]` returns `true` if feature properties include the (nested) key `attributeName`,
 *     `false` otherwise.
 *     Note that for WebGL layers, the hardcoded value `-9999999` is used to distinguish when a property is not defined.
 *   * `['between', value1, value2, value3]` returns `true` if `value1` is contained between `value2` and `value3`
 *     (inclusively), or `false` otherwise.
 *   * `['in', needle, haystack]` returns `true` if `needle` is found in `haystack`, and
 *     `false` otherwise.
 *     This operator has the following limitations:
 *     * `haystack` has to be an array of numbers or strings (searching for a substring in a string is not supported yet)
 *     * Only literal arrays are supported as `haystack` for now; this means that `haystack` cannot be the result of an
 *     expression. If `haystack` is an array of strings, use the `literal` operator to disambiguate from an expression:
 *     `['literal', ['abc', 'def', 'ghi']]`
 *
 * * Conversion operators:
 *   * `['array', value1, ...valueN]` creates a numerical array from `number` values; please note that the amount of
 *     values can currently only be 2, 3 or 4 (WebGL only).
 *   * `['color', red, green, blue, alpha]` or `['color', shade, alpha]` creates a `color` value from `number` values;
 *     the `alpha` parameter is optional; if not specified, it will be set to 1 (WebGL only).
 *     Note: `red`, `green` and `blue` or `shade` components must be values between 0 and 255; `alpha` between 0 and 1.
 *   * `['palette', index, colors]` picks a `color` value from an array of colors using the given index; the `index`
 *     expression must evaluate to a number; the items in the `colors` array must be strings with hex colors
 *     (e.g. `'#86A136'`), colors using the rgba[a] functional notation (e.g. `'rgb(134, 161, 54)'` or `'rgba(134, 161, 54, 1)'`),
 *     named colors (e.g. `'red'`), or array literals with 3 ([r, g, b]) or 4 ([r, g, b, a]) values (with r, g, and b
 *     in the 0-255 range and a in the 0-1 range) (WebGL only).
 *   * `['to-string', value]` converts the input value to a string. If the input is a boolean, the result is "true" or "false".
 *     If the input is a number, it is converted to a string as specified by the "NumberToString" algorithm of the ECMAScript
 *     Language Specification. If the input is a color, it is converted to a string of the form "rgba(r,g,b,a)". (Canvas only)
 *
 * Values can either be literals or another operator, as they will be evaluated recursively.
 * Literal values can be of the following types:
 * * `boolean`
 * * `number`
 * * `number[]` (number arrays can only have a length of 2, 3 or 4)
 * * `string`
 * * {@link module:ol/color~Color}
 *
 * @typedef {Array<*>|import("../color.js").Color|string|number|boolean} ExpressionValue
 * @api
 */ let $026a116c72f030b4$var$numTypes = 0;
const $026a116c72f030b4$export$267d7ad6fa96ffaf = 0;
const $026a116c72f030b4$export$240f7fffab1b25a0 = 1 << $026a116c72f030b4$var$numTypes++;
const $026a116c72f030b4$export$86a7aca748b1e260 = 1 << $026a116c72f030b4$var$numTypes++;
const $026a116c72f030b4$export$2b93044cbf134323 = 1 << $026a116c72f030b4$var$numTypes++;
const $026a116c72f030b4$export$2cd82751acc0e609 = 1 << $026a116c72f030b4$var$numTypes++;
const $026a116c72f030b4$export$d701d0e49f4bcb39 = 1 << $026a116c72f030b4$var$numTypes++;
const $026a116c72f030b4$export$52725c8a6d4c61d1 = 1 << $026a116c72f030b4$var$numTypes++;
const $026a116c72f030b4$export$ec4c9a150bae86cd = Math.pow(2, $026a116c72f030b4$var$numTypes) - 1;
const $026a116c72f030b4$var$typeNames = {
    [$026a116c72f030b4$export$240f7fffab1b25a0]: 'boolean',
    [$026a116c72f030b4$export$86a7aca748b1e260]: 'number',
    [$026a116c72f030b4$export$2b93044cbf134323]: 'string',
    [$026a116c72f030b4$export$2cd82751acc0e609]: 'color',
    [$026a116c72f030b4$export$d701d0e49f4bcb39]: 'number[]',
    [$026a116c72f030b4$export$52725c8a6d4c61d1]: 'size'
};
const $026a116c72f030b4$var$namedTypes = Object.keys($026a116c72f030b4$var$typeNames).map(Number).sort((0, $49313fcb0fc32abe$export$fcb633242ef15540));
/**
 * @param {number} type The type.
 * @return {boolean} The type is one of the specific types (not any or a union type).
 */ function $026a116c72f030b4$var$isSpecific(type) {
    return type in $026a116c72f030b4$var$typeNames;
}
function $026a116c72f030b4$export$b2afc7c96b2b4a45(type) {
    const names = [];
    for (const namedType of $026a116c72f030b4$var$namedTypes)if ($026a116c72f030b4$export$9fdcb8b441c4f2b4(type, namedType)) names.push($026a116c72f030b4$var$typeNames[namedType]);
    if (names.length === 0) return 'untyped';
    if (names.length < 3) return names.join(' or ');
    return names.slice(0, -1).join(', ') + ', or ' + names[names.length - 1];
}
function $026a116c72f030b4$export$9fdcb8b441c4f2b4(broad, specific) {
    return (broad & specific) === specific;
}
function $026a116c72f030b4$export$3252d368d784c970(oneType, otherType) {
    return !!(oneType & otherType);
}
function $026a116c72f030b4$export$26b9f946b448f23e(type, expected) {
    return type === expected;
}
class $026a116c72f030b4$export$eb63e96e0913dda4 {
    /**
   * @param {number} type The value type.
   * @param {LiteralValue} value The literal value.
   */ constructor(type, value){
        if (!$026a116c72f030b4$var$isSpecific(type)) throw new Error(`literal expressions must have a specific type, got ${$026a116c72f030b4$export$b2afc7c96b2b4a45(type)}`);
        this.type = type;
        this.value = value;
    }
}
class $026a116c72f030b4$export$6f3d80189eb72cd4 {
    /**
   * @param {number} type The return type.
   * @param {string} operator The operator.
   * @param {...Expression} args The arguments.
   */ constructor(type, operator, ...args){
        this.type = type;
        this.operator = operator;
        this.args = args;
    }
}
function $026a116c72f030b4$export$1c8b4c1584800354() {
    return {
        variables: new Set(),
        properties: new Set(),
        featureId: false,
        geometryType: false,
        mapState: false
    };
}
function $026a116c72f030b4$export$98e6a39c04603d36(encoded, expectedType, context) {
    switch(typeof encoded){
        case 'boolean':
            if ($026a116c72f030b4$export$26b9f946b448f23e(expectedType, $026a116c72f030b4$export$2b93044cbf134323)) return new $026a116c72f030b4$export$eb63e96e0913dda4($026a116c72f030b4$export$2b93044cbf134323, encoded ? 'true' : 'false');
            if (!$026a116c72f030b4$export$9fdcb8b441c4f2b4(expectedType, $026a116c72f030b4$export$240f7fffab1b25a0)) throw new Error(`got a boolean, but expected ${$026a116c72f030b4$export$b2afc7c96b2b4a45(expectedType)}`);
            return new $026a116c72f030b4$export$eb63e96e0913dda4($026a116c72f030b4$export$240f7fffab1b25a0, encoded);
        case 'number':
            if ($026a116c72f030b4$export$26b9f946b448f23e(expectedType, $026a116c72f030b4$export$52725c8a6d4c61d1)) return new $026a116c72f030b4$export$eb63e96e0913dda4($026a116c72f030b4$export$52725c8a6d4c61d1, (0, $625e418aeada4c0d$export$a71a825ff42fb8e1)(encoded));
            if ($026a116c72f030b4$export$26b9f946b448f23e(expectedType, $026a116c72f030b4$export$240f7fffab1b25a0)) return new $026a116c72f030b4$export$eb63e96e0913dda4($026a116c72f030b4$export$240f7fffab1b25a0, !!encoded);
            if ($026a116c72f030b4$export$26b9f946b448f23e(expectedType, $026a116c72f030b4$export$2b93044cbf134323)) return new $026a116c72f030b4$export$eb63e96e0913dda4($026a116c72f030b4$export$2b93044cbf134323, encoded.toString());
            if (!$026a116c72f030b4$export$9fdcb8b441c4f2b4(expectedType, $026a116c72f030b4$export$86a7aca748b1e260)) throw new Error(`got a number, but expected ${$026a116c72f030b4$export$b2afc7c96b2b4a45(expectedType)}`);
            return new $026a116c72f030b4$export$eb63e96e0913dda4($026a116c72f030b4$export$86a7aca748b1e260, encoded);
        case 'string':
            if ($026a116c72f030b4$export$26b9f946b448f23e(expectedType, $026a116c72f030b4$export$2cd82751acc0e609)) return new $026a116c72f030b4$export$eb63e96e0913dda4($026a116c72f030b4$export$2cd82751acc0e609, (0, $ebac9d8363fa165e$export$3004f64547af360e)(encoded));
            if ($026a116c72f030b4$export$26b9f946b448f23e(expectedType, $026a116c72f030b4$export$240f7fffab1b25a0)) return new $026a116c72f030b4$export$eb63e96e0913dda4($026a116c72f030b4$export$240f7fffab1b25a0, !!encoded);
            if (!$026a116c72f030b4$export$9fdcb8b441c4f2b4(expectedType, $026a116c72f030b4$export$2b93044cbf134323)) throw new Error(`got a string, but expected ${$026a116c72f030b4$export$b2afc7c96b2b4a45(expectedType)}`);
            return new $026a116c72f030b4$export$eb63e96e0913dda4($026a116c72f030b4$export$2b93044cbf134323, encoded);
        default:
    }
    if (!Array.isArray(encoded)) throw new Error('expression must be an array or a primitive value');
    if (encoded.length === 0) throw new Error('empty expression');
    if (typeof encoded[0] === 'string') return $026a116c72f030b4$var$parseCallExpression(encoded, expectedType, context);
    for (const item of encoded){
        if (typeof item !== 'number') throw new Error('expected an array of numbers');
    }
    if ($026a116c72f030b4$export$26b9f946b448f23e(expectedType, $026a116c72f030b4$export$52725c8a6d4c61d1)) {
        if (encoded.length !== 2) throw new Error(`expected an array of two values for a size, got ${encoded.length}`);
        return new $026a116c72f030b4$export$eb63e96e0913dda4($026a116c72f030b4$export$52725c8a6d4c61d1, encoded);
    }
    if ($026a116c72f030b4$export$26b9f946b448f23e(expectedType, $026a116c72f030b4$export$2cd82751acc0e609)) {
        if (encoded.length === 3) return new $026a116c72f030b4$export$eb63e96e0913dda4($026a116c72f030b4$export$2cd82751acc0e609, [
            ...encoded,
            1
        ]);
        if (encoded.length === 4) return new $026a116c72f030b4$export$eb63e96e0913dda4($026a116c72f030b4$export$2cd82751acc0e609, encoded);
        throw new Error(`expected an array of 3 or 4 values for a color, got ${encoded.length}`);
    }
    if (!$026a116c72f030b4$export$9fdcb8b441c4f2b4(expectedType, $026a116c72f030b4$export$d701d0e49f4bcb39)) throw new Error(`got an array of numbers, but expected ${$026a116c72f030b4$export$b2afc7c96b2b4a45(expectedType)}`);
    return new $026a116c72f030b4$export$eb63e96e0913dda4($026a116c72f030b4$export$d701d0e49f4bcb39, encoded);
}
const $026a116c72f030b4$export$2655e45458bc48f3 = {
    Get: 'get',
    Var: 'var',
    Concat: 'concat',
    GeometryType: 'geometry-type',
    LineMetric: 'line-metric',
    Any: 'any',
    All: 'all',
    Not: '!',
    Resolution: 'resolution',
    Zoom: 'zoom',
    Time: 'time',
    Equal: '==',
    NotEqual: '!=',
    GreaterThan: '>',
    GreaterThanOrEqualTo: '>=',
    LessThan: '<',
    LessThanOrEqualTo: '<=',
    Multiply: '*',
    Divide: '/',
    Add: '+',
    Subtract: '-',
    Clamp: 'clamp',
    Mod: '%',
    Pow: '^',
    Abs: 'abs',
    Floor: 'floor',
    Ceil: 'ceil',
    Round: 'round',
    Sin: 'sin',
    Cos: 'cos',
    Atan: 'atan',
    Sqrt: 'sqrt',
    Match: 'match',
    Between: 'between',
    Interpolate: 'interpolate',
    Coalesce: 'coalesce',
    Case: 'case',
    In: 'in',
    Number: 'number',
    String: 'string',
    Array: 'array',
    Color: 'color',
    Id: 'id',
    Band: 'band',
    Palette: 'palette',
    ToString: 'to-string',
    Has: 'has'
};
/**
 * @typedef {function(Array, number, ParsingContext):Expression} Parser
 *
 * Second argument is the expected type.
 */ /**
 * @type {Object<string, Parser>}
 */ const $026a116c72f030b4$var$parsers = {
    [$026a116c72f030b4$export$2655e45458bc48f3.Get]: $026a116c72f030b4$var$createCallExpressionParser($026a116c72f030b4$var$hasArgsCount(1, Infinity), $026a116c72f030b4$var$withGetArgs),
    [$026a116c72f030b4$export$2655e45458bc48f3.Var]: $026a116c72f030b4$var$createCallExpressionParser($026a116c72f030b4$var$hasArgsCount(1, 1), $026a116c72f030b4$var$withVarArgs),
    [$026a116c72f030b4$export$2655e45458bc48f3.Has]: $026a116c72f030b4$var$createCallExpressionParser($026a116c72f030b4$var$hasArgsCount(1, Infinity), $026a116c72f030b4$var$withGetArgs),
    [$026a116c72f030b4$export$2655e45458bc48f3.Id]: $026a116c72f030b4$var$createCallExpressionParser($026a116c72f030b4$var$usesFeatureId, $026a116c72f030b4$var$withNoArgs),
    [$026a116c72f030b4$export$2655e45458bc48f3.Concat]: $026a116c72f030b4$var$createCallExpressionParser($026a116c72f030b4$var$hasArgsCount(2, Infinity), $026a116c72f030b4$var$withArgsOfType($026a116c72f030b4$export$2b93044cbf134323)),
    [$026a116c72f030b4$export$2655e45458bc48f3.GeometryType]: $026a116c72f030b4$var$createCallExpressionParser($026a116c72f030b4$var$usesGeometryType, $026a116c72f030b4$var$withNoArgs),
    [$026a116c72f030b4$export$2655e45458bc48f3.LineMetric]: $026a116c72f030b4$var$createCallExpressionParser($026a116c72f030b4$var$withNoArgs),
    [$026a116c72f030b4$export$2655e45458bc48f3.Resolution]: $026a116c72f030b4$var$createCallExpressionParser($026a116c72f030b4$var$usesMapState, $026a116c72f030b4$var$withNoArgs),
    [$026a116c72f030b4$export$2655e45458bc48f3.Zoom]: $026a116c72f030b4$var$createCallExpressionParser($026a116c72f030b4$var$usesMapState, $026a116c72f030b4$var$withNoArgs),
    [$026a116c72f030b4$export$2655e45458bc48f3.Time]: $026a116c72f030b4$var$createCallExpressionParser($026a116c72f030b4$var$usesMapState, $026a116c72f030b4$var$withNoArgs),
    [$026a116c72f030b4$export$2655e45458bc48f3.Any]: $026a116c72f030b4$var$createCallExpressionParser($026a116c72f030b4$var$hasArgsCount(2, Infinity), $026a116c72f030b4$var$withArgsOfType($026a116c72f030b4$export$240f7fffab1b25a0)),
    [$026a116c72f030b4$export$2655e45458bc48f3.All]: $026a116c72f030b4$var$createCallExpressionParser($026a116c72f030b4$var$hasArgsCount(2, Infinity), $026a116c72f030b4$var$withArgsOfType($026a116c72f030b4$export$240f7fffab1b25a0)),
    [$026a116c72f030b4$export$2655e45458bc48f3.Not]: $026a116c72f030b4$var$createCallExpressionParser($026a116c72f030b4$var$hasArgsCount(1, 1), $026a116c72f030b4$var$withArgsOfType($026a116c72f030b4$export$240f7fffab1b25a0)),
    [$026a116c72f030b4$export$2655e45458bc48f3.Equal]: $026a116c72f030b4$var$createCallExpressionParser($026a116c72f030b4$var$hasArgsCount(2, 2), $026a116c72f030b4$var$withArgsOfType($026a116c72f030b4$export$ec4c9a150bae86cd)),
    [$026a116c72f030b4$export$2655e45458bc48f3.NotEqual]: $026a116c72f030b4$var$createCallExpressionParser($026a116c72f030b4$var$hasArgsCount(2, 2), $026a116c72f030b4$var$withArgsOfType($026a116c72f030b4$export$ec4c9a150bae86cd)),
    [$026a116c72f030b4$export$2655e45458bc48f3.GreaterThan]: $026a116c72f030b4$var$createCallExpressionParser($026a116c72f030b4$var$hasArgsCount(2, 2), $026a116c72f030b4$var$withArgsOfType($026a116c72f030b4$export$86a7aca748b1e260)),
    [$026a116c72f030b4$export$2655e45458bc48f3.GreaterThanOrEqualTo]: $026a116c72f030b4$var$createCallExpressionParser($026a116c72f030b4$var$hasArgsCount(2, 2), $026a116c72f030b4$var$withArgsOfType($026a116c72f030b4$export$86a7aca748b1e260)),
    [$026a116c72f030b4$export$2655e45458bc48f3.LessThan]: $026a116c72f030b4$var$createCallExpressionParser($026a116c72f030b4$var$hasArgsCount(2, 2), $026a116c72f030b4$var$withArgsOfType($026a116c72f030b4$export$86a7aca748b1e260)),
    [$026a116c72f030b4$export$2655e45458bc48f3.LessThanOrEqualTo]: $026a116c72f030b4$var$createCallExpressionParser($026a116c72f030b4$var$hasArgsCount(2, 2), $026a116c72f030b4$var$withArgsOfType($026a116c72f030b4$export$86a7aca748b1e260)),
    [$026a116c72f030b4$export$2655e45458bc48f3.Multiply]: $026a116c72f030b4$var$createCallExpressionParser($026a116c72f030b4$var$hasArgsCount(2, Infinity), $026a116c72f030b4$var$withArgsOfReturnType),
    [$026a116c72f030b4$export$2655e45458bc48f3.Coalesce]: $026a116c72f030b4$var$createCallExpressionParser($026a116c72f030b4$var$hasArgsCount(2, Infinity), $026a116c72f030b4$var$withArgsOfReturnType),
    [$026a116c72f030b4$export$2655e45458bc48f3.Divide]: $026a116c72f030b4$var$createCallExpressionParser($026a116c72f030b4$var$hasArgsCount(2, 2), $026a116c72f030b4$var$withArgsOfType($026a116c72f030b4$export$86a7aca748b1e260)),
    [$026a116c72f030b4$export$2655e45458bc48f3.Add]: $026a116c72f030b4$var$createCallExpressionParser($026a116c72f030b4$var$hasArgsCount(2, Infinity), $026a116c72f030b4$var$withArgsOfType($026a116c72f030b4$export$86a7aca748b1e260)),
    [$026a116c72f030b4$export$2655e45458bc48f3.Subtract]: $026a116c72f030b4$var$createCallExpressionParser($026a116c72f030b4$var$hasArgsCount(2, 2), $026a116c72f030b4$var$withArgsOfType($026a116c72f030b4$export$86a7aca748b1e260)),
    [$026a116c72f030b4$export$2655e45458bc48f3.Clamp]: $026a116c72f030b4$var$createCallExpressionParser($026a116c72f030b4$var$hasArgsCount(3, 3), $026a116c72f030b4$var$withArgsOfType($026a116c72f030b4$export$86a7aca748b1e260)),
    [$026a116c72f030b4$export$2655e45458bc48f3.Mod]: $026a116c72f030b4$var$createCallExpressionParser($026a116c72f030b4$var$hasArgsCount(2, 2), $026a116c72f030b4$var$withArgsOfType($026a116c72f030b4$export$86a7aca748b1e260)),
    [$026a116c72f030b4$export$2655e45458bc48f3.Pow]: $026a116c72f030b4$var$createCallExpressionParser($026a116c72f030b4$var$hasArgsCount(2, 2), $026a116c72f030b4$var$withArgsOfType($026a116c72f030b4$export$86a7aca748b1e260)),
    [$026a116c72f030b4$export$2655e45458bc48f3.Abs]: $026a116c72f030b4$var$createCallExpressionParser($026a116c72f030b4$var$hasArgsCount(1, 1), $026a116c72f030b4$var$withArgsOfType($026a116c72f030b4$export$86a7aca748b1e260)),
    [$026a116c72f030b4$export$2655e45458bc48f3.Floor]: $026a116c72f030b4$var$createCallExpressionParser($026a116c72f030b4$var$hasArgsCount(1, 1), $026a116c72f030b4$var$withArgsOfType($026a116c72f030b4$export$86a7aca748b1e260)),
    [$026a116c72f030b4$export$2655e45458bc48f3.Ceil]: $026a116c72f030b4$var$createCallExpressionParser($026a116c72f030b4$var$hasArgsCount(1, 1), $026a116c72f030b4$var$withArgsOfType($026a116c72f030b4$export$86a7aca748b1e260)),
    [$026a116c72f030b4$export$2655e45458bc48f3.Round]: $026a116c72f030b4$var$createCallExpressionParser($026a116c72f030b4$var$hasArgsCount(1, 1), $026a116c72f030b4$var$withArgsOfType($026a116c72f030b4$export$86a7aca748b1e260)),
    [$026a116c72f030b4$export$2655e45458bc48f3.Sin]: $026a116c72f030b4$var$createCallExpressionParser($026a116c72f030b4$var$hasArgsCount(1, 1), $026a116c72f030b4$var$withArgsOfType($026a116c72f030b4$export$86a7aca748b1e260)),
    [$026a116c72f030b4$export$2655e45458bc48f3.Cos]: $026a116c72f030b4$var$createCallExpressionParser($026a116c72f030b4$var$hasArgsCount(1, 1), $026a116c72f030b4$var$withArgsOfType($026a116c72f030b4$export$86a7aca748b1e260)),
    [$026a116c72f030b4$export$2655e45458bc48f3.Atan]: $026a116c72f030b4$var$createCallExpressionParser($026a116c72f030b4$var$hasArgsCount(1, 2), $026a116c72f030b4$var$withArgsOfType($026a116c72f030b4$export$86a7aca748b1e260)),
    [$026a116c72f030b4$export$2655e45458bc48f3.Sqrt]: $026a116c72f030b4$var$createCallExpressionParser($026a116c72f030b4$var$hasArgsCount(1, 1), $026a116c72f030b4$var$withArgsOfType($026a116c72f030b4$export$86a7aca748b1e260)),
    [$026a116c72f030b4$export$2655e45458bc48f3.Match]: $026a116c72f030b4$var$createCallExpressionParser($026a116c72f030b4$var$hasArgsCount(4, Infinity), $026a116c72f030b4$var$hasEvenArgs, $026a116c72f030b4$var$withMatchArgs),
    [$026a116c72f030b4$export$2655e45458bc48f3.Between]: $026a116c72f030b4$var$createCallExpressionParser($026a116c72f030b4$var$hasArgsCount(3, 3), $026a116c72f030b4$var$withArgsOfType($026a116c72f030b4$export$86a7aca748b1e260)),
    [$026a116c72f030b4$export$2655e45458bc48f3.Interpolate]: $026a116c72f030b4$var$createCallExpressionParser($026a116c72f030b4$var$hasArgsCount(6, Infinity), $026a116c72f030b4$var$hasEvenArgs, $026a116c72f030b4$var$withInterpolateArgs),
    [$026a116c72f030b4$export$2655e45458bc48f3.Case]: $026a116c72f030b4$var$createCallExpressionParser($026a116c72f030b4$var$hasArgsCount(3, Infinity), $026a116c72f030b4$var$hasOddArgs, $026a116c72f030b4$var$withCaseArgs),
    [$026a116c72f030b4$export$2655e45458bc48f3.In]: $026a116c72f030b4$var$createCallExpressionParser($026a116c72f030b4$var$hasArgsCount(2, 2), $026a116c72f030b4$var$withInArgs),
    [$026a116c72f030b4$export$2655e45458bc48f3.Number]: $026a116c72f030b4$var$createCallExpressionParser($026a116c72f030b4$var$hasArgsCount(1, Infinity), $026a116c72f030b4$var$withArgsOfType($026a116c72f030b4$export$ec4c9a150bae86cd)),
    [$026a116c72f030b4$export$2655e45458bc48f3.String]: $026a116c72f030b4$var$createCallExpressionParser($026a116c72f030b4$var$hasArgsCount(1, Infinity), $026a116c72f030b4$var$withArgsOfType($026a116c72f030b4$export$ec4c9a150bae86cd)),
    [$026a116c72f030b4$export$2655e45458bc48f3.Array]: $026a116c72f030b4$var$createCallExpressionParser($026a116c72f030b4$var$hasArgsCount(1, Infinity), $026a116c72f030b4$var$withArgsOfType($026a116c72f030b4$export$86a7aca748b1e260)),
    [$026a116c72f030b4$export$2655e45458bc48f3.Color]: $026a116c72f030b4$var$createCallExpressionParser($026a116c72f030b4$var$hasArgsCount(1, 4), $026a116c72f030b4$var$withArgsOfType($026a116c72f030b4$export$86a7aca748b1e260)),
    [$026a116c72f030b4$export$2655e45458bc48f3.Band]: $026a116c72f030b4$var$createCallExpressionParser($026a116c72f030b4$var$hasArgsCount(1, 3), $026a116c72f030b4$var$withArgsOfType($026a116c72f030b4$export$86a7aca748b1e260)),
    [$026a116c72f030b4$export$2655e45458bc48f3.Palette]: $026a116c72f030b4$var$createCallExpressionParser($026a116c72f030b4$var$hasArgsCount(2, 2), $026a116c72f030b4$var$withPaletteArgs),
    [$026a116c72f030b4$export$2655e45458bc48f3.ToString]: $026a116c72f030b4$var$createCallExpressionParser($026a116c72f030b4$var$hasArgsCount(1, 1), $026a116c72f030b4$var$withArgsOfType($026a116c72f030b4$export$240f7fffab1b25a0 | $026a116c72f030b4$export$86a7aca748b1e260 | $026a116c72f030b4$export$2b93044cbf134323 | $026a116c72f030b4$export$2cd82751acc0e609))
};
/**
 * @typedef {function(Array<EncodedExpression>, number, ParsingContext):Array<Expression>|void} ArgValidator
 *
 * An argument validator applies various checks to an encoded expression arguments and
 * returns the parsed arguments if any.  The second argument is the return type of the call expression.
 */ /**
 * @type {ArgValidator}
 */ function $026a116c72f030b4$var$withGetArgs(encoded, returnType, context) {
    const argsCount = encoded.length - 1;
    const args = new Array(argsCount);
    for(let i = 0; i < argsCount; ++i){
        const key = encoded[i + 1];
        switch(typeof key){
            case 'number':
                args[i] = new $026a116c72f030b4$export$eb63e96e0913dda4($026a116c72f030b4$export$86a7aca748b1e260, key);
                break;
            case 'string':
                args[i] = new $026a116c72f030b4$export$eb63e96e0913dda4($026a116c72f030b4$export$2b93044cbf134323, key);
                break;
            default:
                throw new Error(`expected a string key or numeric array index for a get operation, got ${key}`);
        }
        if (i === 0) context.properties.add(String(key));
    }
    return args;
}
/**
 * @type {ArgValidator}
 */ function $026a116c72f030b4$var$withVarArgs(encoded, returnType, context) {
    const name = encoded[1];
    if (typeof name !== 'string') throw new Error('expected a string argument for var operation');
    context.variables.add(name);
    return [
        new $026a116c72f030b4$export$eb63e96e0913dda4($026a116c72f030b4$export$2b93044cbf134323, name)
    ];
}
/**
 * @type {ArgValidator}
 */ function $026a116c72f030b4$var$usesFeatureId(encoded, returnType, context) {
    context.featureId = true;
}
/**
 * @type {ArgValidator}
 */ function $026a116c72f030b4$var$usesGeometryType(encoded, returnType, context) {
    context.geometryType = true;
}
/**
 * @type {ArgValidator}
 */ function $026a116c72f030b4$var$usesMapState(encoded, returnType, context) {
    context.mapState = true;
}
/**
 * @type {ArgValidator}
 */ function $026a116c72f030b4$var$withNoArgs(encoded, returnType, context) {
    const operation = encoded[0];
    if (encoded.length !== 1) throw new Error(`expected no arguments for ${operation} operation`);
    return [];
}
/**
 * @param {number} minArgs The minimum number of arguments.
 * @param {number} maxArgs The maximum number of arguments.
 * @return {ArgValidator} The argument validator
 */ function $026a116c72f030b4$var$hasArgsCount(minArgs, maxArgs) {
    return function(encoded, returnType, context) {
        const operation = encoded[0];
        const argCount = encoded.length - 1;
        if (minArgs === maxArgs) {
            if (argCount !== minArgs) {
                const plural = minArgs === 1 ? '' : 's';
                throw new Error(`expected ${minArgs} argument${plural} for ${operation}, got ${argCount}`);
            }
        } else if (argCount < minArgs || argCount > maxArgs) {
            const range = maxArgs === Infinity ? `${minArgs} or more` : `${minArgs} to ${maxArgs}`;
            throw new Error(`expected ${range} arguments for ${operation}, got ${argCount}`);
        }
    };
}
/**
 * @type {ArgValidator}
 */ function $026a116c72f030b4$var$withArgsOfReturnType(encoded, returnType, context) {
    const argCount = encoded.length - 1;
    /**
   * @type {Array<Expression>}
   */ const args = new Array(argCount);
    for(let i = 0; i < argCount; ++i){
        const expression = $026a116c72f030b4$export$98e6a39c04603d36(encoded[i + 1], returnType, context);
        args[i] = expression;
    }
    return args;
}
/**
 * @param {number} argType The argument type.
 * @return {ArgValidator} The argument validator
 */ function $026a116c72f030b4$var$withArgsOfType(argType) {
    return function(encoded, returnType, context) {
        const argCount = encoded.length - 1;
        /**
     * @type {Array<Expression>}
     */ const args = new Array(argCount);
        for(let i = 0; i < argCount; ++i){
            const expression = $026a116c72f030b4$export$98e6a39c04603d36(encoded[i + 1], argType, context);
            args[i] = expression;
        }
        return args;
    };
}
/**
 * @type {ArgValidator}
 */ function $026a116c72f030b4$var$hasOddArgs(encoded, returnType, context) {
    const operation = encoded[0];
    const argCount = encoded.length - 1;
    if (argCount % 2 === 0) throw new Error(`expected an odd number of arguments for ${operation}, got ${argCount} instead`);
}
/**
 * @type {ArgValidator}
 */ function $026a116c72f030b4$var$hasEvenArgs(encoded, returnType, context) {
    const operation = encoded[0];
    const argCount = encoded.length - 1;
    if (argCount % 2 === 1) throw new Error(`expected an even number of arguments for operation ${operation}, got ${argCount} instead`);
}
/**
 * @type {ArgValidator}
 */ function $026a116c72f030b4$var$withMatchArgs(encoded, returnType, context) {
    const argsCount = encoded.length - 1;
    const inputType = $026a116c72f030b4$export$2b93044cbf134323 | $026a116c72f030b4$export$86a7aca748b1e260 | $026a116c72f030b4$export$240f7fffab1b25a0;
    const input = $026a116c72f030b4$export$98e6a39c04603d36(encoded[1], inputType, context);
    const fallback = $026a116c72f030b4$export$98e6a39c04603d36(encoded[encoded.length - 1], returnType, context);
    const args = new Array(argsCount - 2);
    for(let i = 0; i < argsCount - 2; i += 2){
        try {
            const match = $026a116c72f030b4$export$98e6a39c04603d36(encoded[i + 2], input.type, context);
            args[i] = match;
        } catch (err) {
            throw new Error(`failed to parse argument ${i + 1} of match expression: ${err.message}`);
        }
        try {
            const output = $026a116c72f030b4$export$98e6a39c04603d36(encoded[i + 3], fallback.type, context);
            args[i + 1] = output;
        } catch (err) {
            throw new Error(`failed to parse argument ${i + 2} of match expression: ${err.message}`);
        }
    }
    return [
        input,
        ...args,
        fallback
    ];
}
/**
 * @type {ArgValidator}
 */ function $026a116c72f030b4$var$withInterpolateArgs(encoded, returnType, context) {
    const interpolationType = encoded[1];
    /**
   * @type {number}
   */ let base;
    switch(interpolationType[0]){
        case 'linear':
            base = 1;
            break;
        case 'exponential':
            const b = interpolationType[1];
            if (typeof b !== 'number' || b <= 0) throw new Error(`expected a number base for exponential interpolation` + `, got ${JSON.stringify(b)} instead`);
            base = b;
            break;
        default:
            throw new Error(`invalid interpolation type: ${JSON.stringify(interpolationType)}`);
    }
    const interpolation = new $026a116c72f030b4$export$eb63e96e0913dda4($026a116c72f030b4$export$86a7aca748b1e260, base);
    let input;
    try {
        input = $026a116c72f030b4$export$98e6a39c04603d36(encoded[2], $026a116c72f030b4$export$86a7aca748b1e260, context);
    } catch (err) {
        throw new Error(`failed to parse argument 1 in interpolate expression: ${err.message}`);
    }
    const args = new Array(encoded.length - 3);
    for(let i = 0; i < args.length; i += 2){
        try {
            const stop = $026a116c72f030b4$export$98e6a39c04603d36(encoded[i + 3], $026a116c72f030b4$export$86a7aca748b1e260, context);
            args[i] = stop;
        } catch (err) {
            throw new Error(`failed to parse argument ${i + 2} for interpolate expression: ${err.message}`);
        }
        try {
            const output = $026a116c72f030b4$export$98e6a39c04603d36(encoded[i + 4], returnType, context);
            args[i + 1] = output;
        } catch (err) {
            throw new Error(`failed to parse argument ${i + 3} for interpolate expression: ${err.message}`);
        }
    }
    return [
        interpolation,
        input,
        ...args
    ];
}
/**
 * @type {ArgValidator}
 */ function $026a116c72f030b4$var$withCaseArgs(encoded, returnType, context) {
    const fallback = $026a116c72f030b4$export$98e6a39c04603d36(encoded[encoded.length - 1], returnType, context);
    const args = new Array(encoded.length - 1);
    for(let i = 0; i < args.length - 1; i += 2){
        try {
            const condition = $026a116c72f030b4$export$98e6a39c04603d36(encoded[i + 1], $026a116c72f030b4$export$240f7fffab1b25a0, context);
            args[i] = condition;
        } catch (err) {
            throw new Error(`failed to parse argument ${i} of case expression: ${err.message}`);
        }
        try {
            const output = $026a116c72f030b4$export$98e6a39c04603d36(encoded[i + 2], fallback.type, context);
            args[i + 1] = output;
        } catch (err) {
            throw new Error(`failed to parse argument ${i + 1} of case expression: ${err.message}`);
        }
    }
    args[args.length - 1] = fallback;
    return args;
}
/**
 * @type {ArgValidator}
 */ function $026a116c72f030b4$var$withInArgs(encoded, returnType, context) {
    let haystack = encoded[2];
    if (!Array.isArray(haystack)) throw new Error(`the second argument for the "in" operator must be an array`);
    /**
   * @type {number}
   */ let needleType;
    if (typeof haystack[0] === 'string') {
        if (haystack[0] !== 'literal') throw new Error(`for the "in" operator, a string array should be wrapped in a "literal" operator to disambiguate from expressions`);
        if (!Array.isArray(haystack[1])) throw new Error(`failed to parse "in" expression: the literal operator must be followed by an array`);
        haystack = haystack[1];
        needleType = $026a116c72f030b4$export$2b93044cbf134323;
    } else needleType = $026a116c72f030b4$export$86a7aca748b1e260;
    const args = new Array(haystack.length);
    for(let i = 0; i < args.length; i++)try {
        const arg = $026a116c72f030b4$export$98e6a39c04603d36(haystack[i], needleType, context);
        args[i] = arg;
    } catch (err) {
        throw new Error(`failed to parse haystack item ${i} for "in" expression: ${err.message}`);
    }
    const needle = $026a116c72f030b4$export$98e6a39c04603d36(encoded[1], needleType, context);
    return [
        needle,
        ...args
    ];
}
/**
 * @type {ArgValidator}
 */ function $026a116c72f030b4$var$withPaletteArgs(encoded, returnType, context) {
    let index;
    try {
        index = $026a116c72f030b4$export$98e6a39c04603d36(encoded[1], $026a116c72f030b4$export$86a7aca748b1e260, context);
    } catch (err) {
        throw new Error(`failed to parse first argument in palette expression: ${err.message}`);
    }
    const colors = encoded[2];
    if (!Array.isArray(colors)) throw new Error('the second argument of palette must be an array');
    const parsedColors = new Array(colors.length);
    for(let i = 0; i < parsedColors.length; i++){
        let color;
        try {
            color = $026a116c72f030b4$export$98e6a39c04603d36(colors[i], $026a116c72f030b4$export$2cd82751acc0e609, context);
        } catch (err) {
            throw new Error(`failed to parse color at index ${i} in palette expression: ${err.message}`);
        }
        if (!(color instanceof $026a116c72f030b4$export$eb63e96e0913dda4)) throw new Error(`the palette color at index ${i} must be a literal value`);
        parsedColors[i] = color;
    }
    return [
        index,
        ...parsedColors
    ];
}
/**
 * @param {Array<ArgValidator>} validators A chain of argument validators.  The last validator is expected
 * to return the parsed arguments.
 * @return {Parser} The parser.
 */ function $026a116c72f030b4$var$createCallExpressionParser(...validators) {
    return function(encoded, returnType, context) {
        const operator = encoded[0];
        /**
     * @type {Array<Expression>}
     */ let args;
        for(let i = 0; i < validators.length; i++){
            const parsed = validators[i](encoded, returnType, context);
            if (i == validators.length - 1) {
                if (!parsed) throw new Error('expected last argument validator to return the parsed args');
                args = parsed;
            }
        }
        return new $026a116c72f030b4$export$6f3d80189eb72cd4(returnType, operator, ...args);
    };
}
/**
 * @param {Array} encoded The encoded expression.
 * @param {number} returnType The expected return type of the call expression.
 * @param {ParsingContext} context The parsing context.
 * @return {Expression} The parsed expression.
 */ function $026a116c72f030b4$var$parseCallExpression(encoded, returnType, context) {
    const operator = encoded[0];
    const parser = $026a116c72f030b4$var$parsers[operator];
    if (!parser) throw new Error(`unknown operator: ${operator}`);
    return parser(encoded, returnType, context);
}
function $026a116c72f030b4$export$8da88d86d10c1295(geometry) {
    if (!geometry) return '';
    const type = geometry.getType();
    switch(type){
        case 'Point':
        case 'LineString':
        case 'Polygon':
            return type;
        case 'MultiPoint':
        case 'MultiLineString':
        case 'MultiPolygon':
            return /** @type {'Point'|'LineString'|'Polygon'} */ type.substring(5);
        case 'Circle':
            return 'Polygon';
        case 'GeometryCollection':
            return $026a116c72f030b4$export$8da88d86d10c1295(/** @type {import("../geom/GeometryCollection.js").default} */ geometry.getGeometries()[0]);
        default:
            return '';
    }
}


function $a87b5daadb108525$export$c18f39f0e136c26() {
    return {
        variables: {},
        properties: {},
        resolution: NaN,
        featureId: null,
        geometryType: ''
    };
}
function $a87b5daadb108525$export$b5f535122a9211f0(encoded, type, context) {
    const expression = (0, $026a116c72f030b4$export$98e6a39c04603d36)(encoded, type, context);
    return $a87b5daadb108525$var$compileExpression(expression, context);
}
/**
 * @param {import("./expression.js").Expression} expression The expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {ExpressionEvaluator} The evaluator function.
 */ function $a87b5daadb108525$var$compileExpression(expression, context) {
    if (expression instanceof (0, $026a116c72f030b4$export$eb63e96e0913dda4)) {
        // convert colors to array if possible
        if (expression.type === (0, $026a116c72f030b4$export$2cd82751acc0e609) && typeof expression.value === 'string') {
            const colorValue = (0, $ebac9d8363fa165e$export$3004f64547af360e)(expression.value);
            return function() {
                return colorValue;
            };
        }
        return function() {
            return expression.value;
        };
    }
    const operator = expression.operator;
    switch(operator){
        case (0, $026a116c72f030b4$export$2655e45458bc48f3).Number:
        case (0, $026a116c72f030b4$export$2655e45458bc48f3).String:
        case (0, $026a116c72f030b4$export$2655e45458bc48f3).Coalesce:
            return $a87b5daadb108525$var$compileAssertionExpression(expression, context);
        case (0, $026a116c72f030b4$export$2655e45458bc48f3).Get:
        case (0, $026a116c72f030b4$export$2655e45458bc48f3).Var:
        case (0, $026a116c72f030b4$export$2655e45458bc48f3).Has:
            return $a87b5daadb108525$var$compileAccessorExpression(expression, context);
        case (0, $026a116c72f030b4$export$2655e45458bc48f3).Id:
            return (context)=>context.featureId;
        case (0, $026a116c72f030b4$export$2655e45458bc48f3).GeometryType:
            return (context)=>context.geometryType;
        case (0, $026a116c72f030b4$export$2655e45458bc48f3).Concat:
            {
                const args = expression.args.map((e)=>$a87b5daadb108525$var$compileExpression(e, context));
                return (context)=>''.concat(...args.map((arg)=>arg(context).toString()));
            }
        case (0, $026a116c72f030b4$export$2655e45458bc48f3).Resolution:
            return (context)=>context.resolution;
        case (0, $026a116c72f030b4$export$2655e45458bc48f3).Any:
        case (0, $026a116c72f030b4$export$2655e45458bc48f3).All:
        case (0, $026a116c72f030b4$export$2655e45458bc48f3).Between:
        case (0, $026a116c72f030b4$export$2655e45458bc48f3).In:
        case (0, $026a116c72f030b4$export$2655e45458bc48f3).Not:
            return $a87b5daadb108525$var$compileLogicalExpression(expression, context);
        case (0, $026a116c72f030b4$export$2655e45458bc48f3).Equal:
        case (0, $026a116c72f030b4$export$2655e45458bc48f3).NotEqual:
        case (0, $026a116c72f030b4$export$2655e45458bc48f3).LessThan:
        case (0, $026a116c72f030b4$export$2655e45458bc48f3).LessThanOrEqualTo:
        case (0, $026a116c72f030b4$export$2655e45458bc48f3).GreaterThan:
        case (0, $026a116c72f030b4$export$2655e45458bc48f3).GreaterThanOrEqualTo:
            return $a87b5daadb108525$var$compileComparisonExpression(expression, context);
        case (0, $026a116c72f030b4$export$2655e45458bc48f3).Multiply:
        case (0, $026a116c72f030b4$export$2655e45458bc48f3).Divide:
        case (0, $026a116c72f030b4$export$2655e45458bc48f3).Add:
        case (0, $026a116c72f030b4$export$2655e45458bc48f3).Subtract:
        case (0, $026a116c72f030b4$export$2655e45458bc48f3).Clamp:
        case (0, $026a116c72f030b4$export$2655e45458bc48f3).Mod:
        case (0, $026a116c72f030b4$export$2655e45458bc48f3).Pow:
        case (0, $026a116c72f030b4$export$2655e45458bc48f3).Abs:
        case (0, $026a116c72f030b4$export$2655e45458bc48f3).Floor:
        case (0, $026a116c72f030b4$export$2655e45458bc48f3).Ceil:
        case (0, $026a116c72f030b4$export$2655e45458bc48f3).Round:
        case (0, $026a116c72f030b4$export$2655e45458bc48f3).Sin:
        case (0, $026a116c72f030b4$export$2655e45458bc48f3).Cos:
        case (0, $026a116c72f030b4$export$2655e45458bc48f3).Atan:
        case (0, $026a116c72f030b4$export$2655e45458bc48f3).Sqrt:
            return $a87b5daadb108525$var$compileNumericExpression(expression, context);
        case (0, $026a116c72f030b4$export$2655e45458bc48f3).Case:
            return $a87b5daadb108525$var$compileCaseExpression(expression, context);
        case (0, $026a116c72f030b4$export$2655e45458bc48f3).Match:
            return $a87b5daadb108525$var$compileMatchExpression(expression, context);
        case (0, $026a116c72f030b4$export$2655e45458bc48f3).Interpolate:
            return $a87b5daadb108525$var$compileInterpolateExpression(expression, context);
        case (0, $026a116c72f030b4$export$2655e45458bc48f3).ToString:
            return $a87b5daadb108525$var$compileConvertExpression(expression, context);
        default:
            throw new Error(`Unsupported operator ${operator}`);
    }
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {ExpressionEvaluator} The evaluator function.
 */ function $a87b5daadb108525$var$compileAssertionExpression(expression, context) {
    const type = expression.operator;
    const length = expression.args.length;
    const args = new Array(length);
    for(let i = 0; i < length; ++i)args[i] = $a87b5daadb108525$var$compileExpression(expression.args[i], context);
    switch(type){
        case (0, $026a116c72f030b4$export$2655e45458bc48f3).Coalesce:
            return (context)=>{
                for(let i = 0; i < length; ++i){
                    const value = args[i](context);
                    if (typeof value !== 'undefined' && value !== null) return value;
                }
                throw new Error('Expected one of the values to be non-null');
            };
        case (0, $026a116c72f030b4$export$2655e45458bc48f3).Number:
        case (0, $026a116c72f030b4$export$2655e45458bc48f3).String:
            return (context)=>{
                for(let i = 0; i < length; ++i){
                    const value = args[i](context);
                    if (typeof value === type) return value;
                }
                throw new Error(`Expected one of the values to be a ${type}`);
            };
        default:
            throw new Error(`Unsupported assertion operator ${type}`);
    }
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {ExpressionEvaluator} The evaluator function.
 */ function $a87b5daadb108525$var$compileAccessorExpression(expression, context) {
    const nameExpression = /** @type {LiteralExpression} */ expression.args[0];
    const name = /** @type {string} */ nameExpression.value;
    switch(expression.operator){
        case (0, $026a116c72f030b4$export$2655e45458bc48f3).Get:
            return (context)=>{
                const args = expression.args;
                let value = context.properties[name];
                for(let i = 1, ii = args.length; i < ii; ++i){
                    const keyExpression = /** @type {LiteralExpression} */ args[i];
                    const key = /** @type {string|number} */ keyExpression.value;
                    value = value[key];
                }
                return value;
            };
        case (0, $026a116c72f030b4$export$2655e45458bc48f3).Var:
            return (context)=>context.variables[name];
        case (0, $026a116c72f030b4$export$2655e45458bc48f3).Has:
            return (context)=>{
                const args = expression.args;
                if (!(name in context.properties)) return false;
                let value = context.properties[name];
                for(let i = 1, ii = args.length; i < ii; ++i){
                    const keyExpression = /** @type {LiteralExpression} */ args[i];
                    const key = /** @type {string|number} */ keyExpression.value;
                    if (!value || !Object.hasOwn(value, key)) return false;
                    value = value[key];
                }
                return true;
            };
        default:
            throw new Error(`Unsupported accessor operator ${expression.operator}`);
    }
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {BooleanEvaluator} The evaluator function.
 */ function $a87b5daadb108525$var$compileComparisonExpression(expression, context) {
    const op = expression.operator;
    const left = $a87b5daadb108525$var$compileExpression(expression.args[0], context);
    const right = $a87b5daadb108525$var$compileExpression(expression.args[1], context);
    switch(op){
        case (0, $026a116c72f030b4$export$2655e45458bc48f3).Equal:
            return (context)=>left(context) === right(context);
        case (0, $026a116c72f030b4$export$2655e45458bc48f3).NotEqual:
            return (context)=>left(context) !== right(context);
        case (0, $026a116c72f030b4$export$2655e45458bc48f3).LessThan:
            return (context)=>left(context) < right(context);
        case (0, $026a116c72f030b4$export$2655e45458bc48f3).LessThanOrEqualTo:
            return (context)=>left(context) <= right(context);
        case (0, $026a116c72f030b4$export$2655e45458bc48f3).GreaterThan:
            return (context)=>left(context) > right(context);
        case (0, $026a116c72f030b4$export$2655e45458bc48f3).GreaterThanOrEqualTo:
            return (context)=>left(context) >= right(context);
        default:
            throw new Error(`Unsupported comparison operator ${op}`);
    }
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {BooleanEvaluator} The evaluator function.
 */ function $a87b5daadb108525$var$compileLogicalExpression(expression, context) {
    const op = expression.operator;
    const length = expression.args.length;
    const args = new Array(length);
    for(let i = 0; i < length; ++i)args[i] = $a87b5daadb108525$var$compileExpression(expression.args[i], context);
    switch(op){
        case (0, $026a116c72f030b4$export$2655e45458bc48f3).Any:
            return (context)=>{
                for(let i = 0; i < length; ++i){
                    if (args[i](context)) return true;
                }
                return false;
            };
        case (0, $026a116c72f030b4$export$2655e45458bc48f3).All:
            return (context)=>{
                for(let i = 0; i < length; ++i){
                    if (!args[i](context)) return false;
                }
                return true;
            };
        case (0, $026a116c72f030b4$export$2655e45458bc48f3).Between:
            return (context)=>{
                const value = args[0](context);
                const min = args[1](context);
                const max = args[2](context);
                return value >= min && value <= max;
            };
        case (0, $026a116c72f030b4$export$2655e45458bc48f3).In:
            return (context)=>{
                const value = args[0](context);
                for(let i = 1; i < length; ++i){
                    if (value === args[i](context)) return true;
                }
                return false;
            };
        case (0, $026a116c72f030b4$export$2655e45458bc48f3).Not:
            return (context)=>!args[0](context);
        default:
            throw new Error(`Unsupported logical operator ${op}`);
    }
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {NumberEvaluator} The evaluator function.
 */ function $a87b5daadb108525$var$compileNumericExpression(expression, context) {
    const op = expression.operator;
    const length = expression.args.length;
    const args = new Array(length);
    for(let i = 0; i < length; ++i)args[i] = $a87b5daadb108525$var$compileExpression(expression.args[i], context);
    switch(op){
        case (0, $026a116c72f030b4$export$2655e45458bc48f3).Multiply:
            return (context)=>{
                let value = 1;
                for(let i = 0; i < length; ++i)value *= args[i](context);
                return value;
            };
        case (0, $026a116c72f030b4$export$2655e45458bc48f3).Divide:
            return (context)=>args[0](context) / args[1](context);
        case (0, $026a116c72f030b4$export$2655e45458bc48f3).Add:
            return (context)=>{
                let value = 0;
                for(let i = 0; i < length; ++i)value += args[i](context);
                return value;
            };
        case (0, $026a116c72f030b4$export$2655e45458bc48f3).Subtract:
            return (context)=>args[0](context) - args[1](context);
        case (0, $026a116c72f030b4$export$2655e45458bc48f3).Clamp:
            return (context)=>{
                const value = args[0](context);
                const min = args[1](context);
                if (value < min) return min;
                const max = args[2](context);
                if (value > max) return max;
                return value;
            };
        case (0, $026a116c72f030b4$export$2655e45458bc48f3).Mod:
            return (context)=>args[0](context) % args[1](context);
        case (0, $026a116c72f030b4$export$2655e45458bc48f3).Pow:
            return (context)=>Math.pow(args[0](context), args[1](context));
        case (0, $026a116c72f030b4$export$2655e45458bc48f3).Abs:
            return (context)=>Math.abs(args[0](context));
        case (0, $026a116c72f030b4$export$2655e45458bc48f3).Floor:
            return (context)=>Math.floor(args[0](context));
        case (0, $026a116c72f030b4$export$2655e45458bc48f3).Ceil:
            return (context)=>Math.ceil(args[0](context));
        case (0, $026a116c72f030b4$export$2655e45458bc48f3).Round:
            return (context)=>Math.round(args[0](context));
        case (0, $026a116c72f030b4$export$2655e45458bc48f3).Sin:
            return (context)=>Math.sin(args[0](context));
        case (0, $026a116c72f030b4$export$2655e45458bc48f3).Cos:
            return (context)=>Math.cos(args[0](context));
        case (0, $026a116c72f030b4$export$2655e45458bc48f3).Atan:
            if (length === 2) return (context)=>Math.atan2(args[0](context), args[1](context));
            return (context)=>Math.atan(args[0](context));
        case (0, $026a116c72f030b4$export$2655e45458bc48f3).Sqrt:
            return (context)=>Math.sqrt(args[0](context));
        default:
            throw new Error(`Unsupported numeric operator ${op}`);
    }
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {ExpressionEvaluator} The evaluator function.
 */ function $a87b5daadb108525$var$compileCaseExpression(expression, context) {
    const length = expression.args.length;
    const args = new Array(length);
    for(let i = 0; i < length; ++i)args[i] = $a87b5daadb108525$var$compileExpression(expression.args[i], context);
    return (context)=>{
        for(let i = 0; i < length - 1; i += 2){
            const condition = args[i](context);
            if (condition) return args[i + 1](context);
        }
        return args[length - 1](context);
    };
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {ExpressionEvaluator} The evaluator function.
 */ function $a87b5daadb108525$var$compileMatchExpression(expression, context) {
    const length = expression.args.length;
    const args = new Array(length);
    for(let i = 0; i < length; ++i)args[i] = $a87b5daadb108525$var$compileExpression(expression.args[i], context);
    return (context)=>{
        const value = args[0](context);
        for(let i = 1; i < length - 1; i += 2){
            if (value === args[i](context)) return args[i + 1](context);
        }
        return args[length - 1](context);
    };
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {ExpressionEvaluator} The evaluator function.
 */ function $a87b5daadb108525$var$compileInterpolateExpression(expression, context) {
    const length = expression.args.length;
    const args = new Array(length);
    for(let i = 0; i < length; ++i)args[i] = $a87b5daadb108525$var$compileExpression(expression.args[i], context);
    return (context)=>{
        const base = args[0](context);
        const value = args[1](context);
        let previousInput;
        let previousOutput;
        for(let i = 2; i < length; i += 2){
            const input = args[i](context);
            let output = args[i + 1](context);
            const isColor = Array.isArray(output);
            if (isColor) output = (0, $ebac9d8363fa165e$export$138c09bdd6bd797c)(output);
            if (input >= value) {
                if (i === 2) return output;
                if (isColor) return $a87b5daadb108525$var$interpolateColor(base, value, previousInput, previousOutput, input, output);
                return $a87b5daadb108525$var$interpolateNumber(base, value, previousInput, previousOutput, input, output);
            }
            previousInput = input;
            previousOutput = output;
        }
        return previousOutput;
    };
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {ExpressionEvaluator} The evaluator function.
 */ function $a87b5daadb108525$var$compileConvertExpression(expression, context) {
    const op = expression.operator;
    const length = expression.args.length;
    const args = new Array(length);
    for(let i = 0; i < length; ++i)args[i] = $a87b5daadb108525$var$compileExpression(expression.args[i], context);
    switch(op){
        case (0, $026a116c72f030b4$export$2655e45458bc48f3).ToString:
            return (context)=>{
                const value = args[0](context);
                if (expression.args[0].type === (0, $026a116c72f030b4$export$2cd82751acc0e609)) return (0, $ebac9d8363fa165e$export$f84e8e69fd4488a5)(value);
                return value.toString();
            };
        default:
            throw new Error(`Unsupported convert operator ${op}`);
    }
}
/**
 * @param {number} base The base.
 * @param {number} value The value.
 * @param {number} input1 The first input value.
 * @param {number} output1 The first output value.
 * @param {number} input2 The second input value.
 * @param {number} output2 The second output value.
 * @return {number} The interpolated value.
 */ function $a87b5daadb108525$var$interpolateNumber(base, value, input1, output1, input2, output2) {
    const delta = input2 - input1;
    if (delta === 0) return output1;
    const along = value - input1;
    const factor = base === 1 ? along / delta : (Math.pow(base, along) - 1) / (Math.pow(base, delta) - 1);
    return output1 + factor * (output2 - output1);
}
/**
 * @param {number} base The base.
 * @param {number} value The value.
 * @param {number} input1 The first input value.
 * @param {import('../color.js').Color} rgba1 The first output value.
 * @param {number} input2 The second input value.
 * @param {import('../color.js').Color} rgba2 The second output value.
 * @return {import('../color.js').Color} The interpolated color.
 */ function $a87b5daadb108525$var$interpolateColor(base, value, input1, rgba1, input2, rgba2) {
    const delta = input2 - input1;
    if (delta === 0) return rgba1;
    const lcha1 = (0, $ebac9d8363fa165e$export$44fb54fa2e0c0d4)(rgba1);
    const lcha2 = (0, $ebac9d8363fa165e$export$44fb54fa2e0c0d4)(rgba2);
    let deltaHue = lcha2[2] - lcha1[2];
    if (deltaHue > 180) deltaHue -= 360;
    else if (deltaHue < -180) deltaHue += 360;
    const lcha = [
        $a87b5daadb108525$var$interpolateNumber(base, value, input1, lcha1[0], input2, lcha2[0]),
        $a87b5daadb108525$var$interpolateNumber(base, value, input1, lcha1[1], input2, lcha2[1]),
        lcha1[2] + $a87b5daadb108525$var$interpolateNumber(base, value, input1, 0, input2, deltaHue),
        $a87b5daadb108525$var$interpolateNumber(base, value, input1, rgba1[3], input2, rgba2[3])
    ];
    return (0, $ebac9d8363fa165e$export$27cc94530c050f00)(lcha);
}





/**
 * @module ol/style/Circle
 */ /**
 * @module ol/style/RegularShape
 */ 







/**
 * Specify radius for regular polygons, or both radius and radius2 for stars.
 * @typedef {Object} Options
 * @property {import("./Fill.js").default} [fill] Fill style.
 * @property {number} points Number of points for stars and regular polygons. In case of a polygon, the number of points
 * is the number of sides.
 * @property {number} radius Radius of a regular polygon.
 * @property {number} [radius2] Second radius to make a star instead of a regular polygon.
 * @property {number} [angle=0] Shape's angle in radians. A value of 0 will have one of the shape's points facing up.
 * @property {Array<number>} [displacement=[0, 0]] Displacement of the shape in pixels.
 * Positive values will shift the shape right and up.
 * @property {import("./Stroke.js").default} [stroke] Stroke style.
 * @property {number} [rotation=0] Rotation in radians (positive rotation clockwise).
 * @property {boolean} [rotateWithView=false] Whether to rotate the shape with the view.
 * @property {number|import("../size.js").Size} [scale=1] Scale. Unless two dimensional scaling is required a better
 * result may be obtained with appropriate settings for `radius` and `radius2`.
 * @property {import('./Style.js').DeclutterMode} [declutterMode] Declutter mode.
 */ /**
 * @typedef {Object} RenderOptions
 * @property {import("../colorlike.js").ColorLike|undefined} strokeStyle StrokeStyle.
 * @property {number} strokeWidth StrokeWidth.
 * @property {number} size Size.
 * @property {CanvasLineCap} lineCap LineCap.
 * @property {Array<number>|null} lineDash LineDash.
 * @property {number} lineDashOffset LineDashOffset.
 * @property {CanvasLineJoin} lineJoin LineJoin.
 * @property {number} miterLimit MiterLimit.
 */ /**
 * @classdesc
 * Set regular shape style for vector features. The resulting shape will be
 * a regular polygon when `radius` is provided, or a star when both `radius` and
 * `radius2` are provided.
 * @api
 */ class $48ca673e38ce3364$var$RegularShape extends (0, $9c0b0593a7c9006d$export$2e2bcd8739ae039) {
    /**
   * @param {Options} options Options.
   */ constructor(options){
        super({
            opacity: 1,
            rotateWithView: options.rotateWithView !== undefined ? options.rotateWithView : false,
            rotation: options.rotation !== undefined ? options.rotation : 0,
            scale: options.scale !== undefined ? options.scale : 1,
            displacement: options.displacement !== undefined ? options.displacement : [
                0,
                0
            ],
            declutterMode: options.declutterMode
        });
        /**
     * @private
     * @type {HTMLCanvasElement|OffscreenCanvas|null}
     */ this.hitDetectionCanvas_ = null;
        /**
     * @private
     * @type {import("./Fill.js").default|null}
     */ this.fill_ = options.fill !== undefined ? options.fill : null;
        /**
     * @private
     * @type {Array<number>}
     */ this.origin_ = [
            0,
            0
        ];
        /**
     * @private
     * @type {number}
     */ this.points_ = options.points;
        /**
     * @protected
     * @type {number}
     */ this.radius = options.radius;
        /**
     * @private
     * @type {number|undefined}
     */ this.radius2_ = options.radius2;
        /**
     * @private
     * @type {number}
     */ this.angle_ = options.angle !== undefined ? options.angle : 0;
        /**
     * @private
     * @type {import("./Stroke.js").default|null}
     */ this.stroke_ = options.stroke !== undefined ? options.stroke : null;
        /**
     * @private
     * @type {import("../size.js").Size}
     */ this.size_;
        /**
     * @private
     * @type {RenderOptions}
     */ this.renderOptions_;
        /**
     * @private
     */ this.imageState_ = this.fill_ && this.fill_.loading() ? (0, $f217251b3f1483a0$export$2e2bcd8739ae039).LOADING : (0, $f217251b3f1483a0$export$2e2bcd8739ae039).LOADED;
        if (this.imageState_ === (0, $f217251b3f1483a0$export$2e2bcd8739ae039).LOADING) this.ready().then(()=>this.imageState_ = (0, $f217251b3f1483a0$export$2e2bcd8739ae039).LOADED);
        this.render();
    }
    /**
   * Clones the style.
   * @return {RegularShape} The cloned style.
   * @api
   * @override
   */ clone() {
        const scale = this.getScale();
        const style = new $48ca673e38ce3364$var$RegularShape({
            fill: this.getFill() ? this.getFill().clone() : undefined,
            points: this.getPoints(),
            radius: this.getRadius(),
            radius2: this.getRadius2(),
            angle: this.getAngle(),
            stroke: this.getStroke() ? this.getStroke().clone() : undefined,
            rotation: this.getRotation(),
            rotateWithView: this.getRotateWithView(),
            scale: Array.isArray(scale) ? scale.slice() : scale,
            displacement: this.getDisplacement().slice(),
            declutterMode: this.getDeclutterMode()
        });
        style.setOpacity(this.getOpacity());
        return style;
    }
    /**
   * Get the anchor point in pixels. The anchor determines the center point for the
   * symbolizer.
   * @return {Array<number>} Anchor.
   * @api
   * @override
   */ getAnchor() {
        const size = this.size_;
        const displacement = this.getDisplacement();
        const scale = this.getScaleArray();
        // anchor is scaled by renderer but displacement should not be scaled
        // so divide by scale here
        return [
            size[0] / 2 - displacement[0] / scale[0],
            size[1] / 2 + displacement[1] / scale[1]
        ];
    }
    /**
   * Get the angle used in generating the shape.
   * @return {number} Shape's rotation in radians.
   * @api
   */ getAngle() {
        return this.angle_;
    }
    /**
   * Get the fill style for the shape.
   * @return {import("./Fill.js").default|null} Fill style.
   * @api
   */ getFill() {
        return this.fill_;
    }
    /**
   * Set the fill style.
   * @param {import("./Fill.js").default|null} fill Fill style.
   * @api
   */ setFill(fill) {
        this.fill_ = fill;
        this.render();
    }
    /**
   * @return {HTMLCanvasElement|OffscreenCanvas} Image element.
   * @override
   */ getHitDetectionImage() {
        if (!this.hitDetectionCanvas_) this.hitDetectionCanvas_ = this.createHitDetectionCanvas_(this.renderOptions_);
        return this.hitDetectionCanvas_;
    }
    /**
   * Get the image icon.
   * @param {number} pixelRatio Pixel ratio.
   * @return {HTMLCanvasElement|OffscreenCanvas} Image or Canvas element.
   * @api
   * @override
   */ getImage(pixelRatio) {
        const fillKey = this.fill_?.getKey();
        const cacheKey = `${pixelRatio},${this.angle_},${this.radius},${this.radius2_},${this.points_},${fillKey}` + Object.values(this.renderOptions_).join(',');
        let image = /** @type {HTMLCanvasElement|OffscreenCanvas} */ (0, $3f062f3a3d0ff66a$export$747ccdf771a87ab8).get(cacheKey, null)?.getImage(1);
        if (!image) {
            const renderOptions = this.renderOptions_;
            const size = Math.ceil(renderOptions.size * pixelRatio);
            const context = (0, $b6f6d442e8ff57e1$export$9e05d10eae75c464)(size, size);
            this.draw_(renderOptions, context, pixelRatio);
            image = context.canvas;
            const iconImage = new (0, $671c623bccf16134$export$2e2bcd8739ae039)(image, undefined, null, (0, $f217251b3f1483a0$export$2e2bcd8739ae039).LOADED, null);
            (0, $3f062f3a3d0ff66a$export$747ccdf771a87ab8).set(cacheKey, null, iconImage);
            // Update the image in place to an ImageBitmap for better performance and lower memory usage
            createImageBitmap(image).then((imageBitmap)=>{
                iconImage.setImage(imageBitmap);
            });
        }
        return image;
    }
    /**
   * Get the image pixel ratio.
   * @param {number} pixelRatio Pixel ratio.
   * @return {number} Pixel ratio.
   * @override
   */ getPixelRatio(pixelRatio) {
        return pixelRatio;
    }
    /**
   * @return {import("../size.js").Size} Image size.
   * @override
   */ getImageSize() {
        return this.size_;
    }
    /**
   * @return {import("../ImageState.js").default} Image state.
   * @override
   */ getImageState() {
        return this.imageState_;
    }
    /**
   * Get the origin of the symbolizer.
   * @return {Array<number>} Origin.
   * @api
   * @override
   */ getOrigin() {
        return this.origin_;
    }
    /**
   * Get the number of points for generating the shape.
   * @return {number} Number of points for stars and regular polygons.
   * @api
   */ getPoints() {
        return this.points_;
    }
    /**
   * Get the (primary) radius for the shape.
   * @return {number} Radius.
   * @api
   */ getRadius() {
        return this.radius;
    }
    /**
   * Set the (primary) radius for the shape.
   * @param {number} radius Radius.
   * @api
   */ setRadius(radius) {
        if (this.radius === radius) return;
        this.radius = radius;
        this.render();
    }
    /**
   * Get the secondary radius for the shape.
   * @return {number|undefined} Radius2.
   * @api
   */ getRadius2() {
        return this.radius2_;
    }
    /**
   * Set the secondary radius for the shape.
   * @param {number|undefined} radius2 Radius2.
   * @api
   */ setRadius2(radius2) {
        if (this.radius2_ === radius2) return;
        this.radius2_ = radius2;
        this.render();
    }
    /**
   * Get the size of the symbolizer (in pixels).
   * @return {import("../size.js").Size} Size.
   * @api
   * @override
   */ getSize() {
        return this.size_;
    }
    /**
   * Get the stroke style for the shape.
   * @return {import("./Stroke.js").default|null} Stroke style.
   * @api
   */ getStroke() {
        return this.stroke_;
    }
    /**
   * Set the stroke style.
   * @param {import("./Stroke.js").default|null} stroke Stroke style.
   * @api
   */ setStroke(stroke) {
        this.stroke_ = stroke;
        this.render();
    }
    /**
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   * @override
   */ listenImageChange(listener) {}
    /**
   * Load not yet loaded URI.
   * @override
   */ load() {}
    /**
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   * @override
   */ unlistenImageChange(listener) {}
    /**
   * Calculate additional canvas size needed for the miter.
   * @param {string} lineJoin Line join
   * @param {number} strokeWidth Stroke width
   * @param {number} miterLimit Miter limit
   * @return {number} Additional canvas size needed
   * @private
   */ calculateLineJoinSize_(lineJoin, strokeWidth, miterLimit) {
        if (strokeWidth === 0 || this.points_ === Infinity || lineJoin !== 'bevel' && lineJoin !== 'miter') return strokeWidth;
        // m  | ^
        // i  | |\                  .
        // t >|  #\
        // e  | |\ \              .
        // r      \s\
        //      |  \t\          .                 .
        //          \r\                      .   .
        //      |    \o\      .          .  . . .
        //          e \k\            .  .    . .
        //      |      \e\  .    .  .       . .
        //       d      \ \  .  .          . .
        //      | _ _a_ _\#  .            . .
        //   r1          / `             . .
        //      |                       . .
        //       b     /               . .
        //      |                     . .
        //           / r2            . .
        //      |                        .   .
        //         /                           .   .
        //      |α                                   .   .
        //       /                                         .   .
        //      ° center
        let r1 = this.radius;
        let r2 = this.radius2_ === undefined ? r1 : this.radius2_;
        if (r1 < r2) {
            const tmp = r1;
            r1 = r2;
            r2 = tmp;
        }
        const points = this.radius2_ === undefined ? this.points_ : this.points_ * 2;
        const alpha = 2 * Math.PI / points;
        const a = r2 * Math.sin(alpha);
        const b = Math.sqrt(r2 * r2 - a * a);
        const d = r1 - b;
        const e = Math.sqrt(a * a + d * d);
        const miterRatio = e / a;
        if (lineJoin === 'miter' && miterRatio <= miterLimit) return miterRatio * strokeWidth;
        // Calculate the distance from center to the stroke corner where
        // it was cut short because of the miter limit.
        //              l
        //        ----+---- <= distance from center to here is maxr
        //       /####|k ##\
        //      /#####^#####\
        //     /#### /+\# s #\
        //    /### h/+++\# t #\
        //   /### t/+++++\# r #\
        //  /### a/+++++++\# o #\
        // /### p/++ fill +\# k #\
        ///#### /+++++^+++++\# e #\
        //#####/+++++/+\+++++\#####\
        const k = strokeWidth / 2 / miterRatio;
        const l = strokeWidth / 2 * (d / e);
        const maxr = Math.sqrt((r1 + k) * (r1 + k) + l * l);
        const bevelAdd = maxr - r1;
        if (this.radius2_ === undefined || lineJoin === 'bevel') return bevelAdd * 2;
        // If outer miter is over the miter limit the inner miter may reach through the
        // center and be longer than the bevel, same calculation as above but swap r1 / r2.
        const aa = r1 * Math.sin(alpha);
        const bb = Math.sqrt(r1 * r1 - aa * aa);
        const dd = r2 - bb;
        const ee = Math.sqrt(aa * aa + dd * dd);
        const innerMiterRatio = ee / aa;
        if (innerMiterRatio <= miterLimit) {
            const innerLength = innerMiterRatio * strokeWidth / 2 - r2 - r1;
            return 2 * Math.max(bevelAdd, innerLength);
        }
        return bevelAdd * 2;
    }
    /**
   * @return {RenderOptions}  The render options
   * @protected
   */ createRenderOptions() {
        let lineCap = (0, $6a4acf19c5e548d6$export$17bd0c38d6ae694e);
        let lineJoin = (0, $6a4acf19c5e548d6$export$365eb9648cf19bd0);
        let miterLimit = 0;
        let lineDash = null;
        let lineDashOffset = 0;
        let strokeStyle;
        let strokeWidth = 0;
        if (this.stroke_) {
            strokeStyle = (0, $c236b40ac833efca$export$dc5b1400ac3a10a8)(this.stroke_.getColor() ?? (0, $6a4acf19c5e548d6$export$1eb2eaecacf2031e));
            strokeWidth = this.stroke_.getWidth() ?? (0, $6a4acf19c5e548d6$export$79661f132c62010e);
            lineDash = this.stroke_.getLineDash();
            lineDashOffset = this.stroke_.getLineDashOffset() ?? 0;
            lineJoin = this.stroke_.getLineJoin() ?? (0, $6a4acf19c5e548d6$export$365eb9648cf19bd0);
            lineCap = this.stroke_.getLineCap() ?? (0, $6a4acf19c5e548d6$export$17bd0c38d6ae694e);
            miterLimit = this.stroke_.getMiterLimit() ?? (0, $6a4acf19c5e548d6$export$80c1c01844597b7b);
        }
        const add = this.calculateLineJoinSize_(lineJoin, strokeWidth, miterLimit);
        const maxRadius = Math.max(this.radius, this.radius2_ || 0);
        const size = Math.ceil(2 * maxRadius + add);
        return {
            strokeStyle: strokeStyle,
            strokeWidth: strokeWidth,
            size: size,
            lineCap: lineCap,
            lineDash: lineDash,
            lineDashOffset: lineDashOffset,
            lineJoin: lineJoin,
            miterLimit: miterLimit
        };
    }
    /**
   * @protected
   */ render() {
        this.renderOptions_ = this.createRenderOptions();
        const size = this.renderOptions_.size;
        this.hitDetectionCanvas_ = null;
        this.size_ = [
            size,
            size
        ];
    }
    /**
   * @private
   * @param {RenderOptions} renderOptions Render options.
   * @param {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} context The rendering context.
   * @param {number} pixelRatio The pixel ratio.
   */ draw_(renderOptions, context, pixelRatio) {
        context.scale(pixelRatio, pixelRatio);
        // set origin to canvas center
        context.translate(renderOptions.size / 2, renderOptions.size / 2);
        this.createPath_(context);
        if (this.fill_) {
            let color = this.fill_.getColor();
            if (color === null) color = (0, $6a4acf19c5e548d6$export$c495d52ee3fd74b2);
            context.fillStyle = (0, $c236b40ac833efca$export$dc5b1400ac3a10a8)(color);
            context.fill();
        }
        if (renderOptions.strokeStyle) {
            context.strokeStyle = renderOptions.strokeStyle;
            context.lineWidth = renderOptions.strokeWidth;
            if (renderOptions.lineDash) {
                context.setLineDash(renderOptions.lineDash);
                context.lineDashOffset = renderOptions.lineDashOffset;
            }
            context.lineCap = renderOptions.lineCap;
            context.lineJoin = renderOptions.lineJoin;
            context.miterLimit = renderOptions.miterLimit;
            context.stroke();
        }
    }
    /**
   * @private
   * @param {RenderOptions} renderOptions Render options.
   * @return {HTMLCanvasElement|OffscreenCanvas} Canvas containing the icon
   */ createHitDetectionCanvas_(renderOptions) {
        let context;
        if (this.fill_) {
            let color = this.fill_.getColor();
            // determine if fill is transparent (or pattern or gradient)
            let opacity = 0;
            if (typeof color === 'string') color = (0, $ebac9d8363fa165e$export$75093a47a9fa838d)(color);
            if (color === null) opacity = 1;
            else if (Array.isArray(color)) opacity = color.length === 4 ? color[3] : 1;
            if (opacity === 0) {
                // if a transparent fill style is set, create an extra hit-detection image
                // with a default fill style
                context = (0, $b6f6d442e8ff57e1$export$9e05d10eae75c464)(renderOptions.size, renderOptions.size);
                this.drawHitDetectionCanvas_(renderOptions, context);
            }
        }
        return context ? context.canvas : this.getImage(1);
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} context The context to draw in.
   */ createPath_(context) {
        let points = this.points_;
        const radius = this.radius;
        if (points === Infinity) context.arc(0, 0, radius, 0, 2 * Math.PI);
        else {
            const radius2 = this.radius2_ === undefined ? radius : this.radius2_;
            if (this.radius2_ !== undefined) points *= 2;
            const startAngle = this.angle_ - Math.PI / 2;
            const step = 2 * Math.PI / points;
            for(let i = 0; i < points; i++){
                const angle0 = startAngle + i * step;
                const radiusC = i % 2 === 0 ? radius : radius2;
                context.lineTo(radiusC * Math.cos(angle0), radiusC * Math.sin(angle0));
            }
            context.closePath();
        }
    }
    /**
   * @private
   * @param {RenderOptions} renderOptions Render options.
   * @param {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} context The context.
   */ drawHitDetectionCanvas_(renderOptions, context) {
        // set origin to canvas center
        context.translate(renderOptions.size / 2, renderOptions.size / 2);
        this.createPath_(context);
        context.fillStyle = (0, $6a4acf19c5e548d6$export$c495d52ee3fd74b2);
        context.fill();
        if (renderOptions.strokeStyle) {
            context.strokeStyle = renderOptions.strokeStyle;
            context.lineWidth = renderOptions.strokeWidth;
            if (renderOptions.lineDash) {
                context.setLineDash(renderOptions.lineDash);
                context.lineDashOffset = renderOptions.lineDashOffset;
            }
            context.lineJoin = renderOptions.lineJoin;
            context.miterLimit = renderOptions.miterLimit;
            context.stroke();
        }
    }
    /**
   * @override
   */ ready() {
        return this.fill_ ? this.fill_.ready() : Promise.resolve();
    }
}
var $48ca673e38ce3364$export$2e2bcd8739ae039 = $48ca673e38ce3364$var$RegularShape;


/**
 * @typedef {Object} Options
 * @property {import("./Fill.js").default} [fill] Fill style.
 * @property {number} radius Circle radius.
 * @property {import("./Stroke.js").default} [stroke] Stroke style.
 * @property {Array<number>} [displacement=[0,0]] displacement
 * @property {number|import("../size.js").Size} [scale=1] Scale. A two dimensional scale will produce an ellipse.
 * Unless two dimensional scaling is required a better result may be obtained with an appropriate setting for `radius`.
 * @property {number} [rotation=0] Rotation in radians
 * (positive rotation clockwise, meaningful only when used in conjunction with a two dimensional scale).
 * @property {boolean} [rotateWithView=false] Whether to rotate the shape with the view
 * (meaningful only when used in conjunction with a two dimensional scale).
 * @property {import('./Style.js').DeclutterMode} [declutterMode] Declutter mode
 */ /**
 * @classdesc
 * Set circle style for vector features.
 * @api
 */ class $f060542c6e9f52e6$var$CircleStyle extends (0, $48ca673e38ce3364$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options ? options : {
            radius: 5
        };
        super({
            points: Infinity,
            fill: options.fill,
            radius: options.radius,
            stroke: options.stroke,
            scale: options.scale !== undefined ? options.scale : 1,
            rotation: options.rotation !== undefined ? options.rotation : 0,
            rotateWithView: options.rotateWithView !== undefined ? options.rotateWithView : false,
            displacement: options.displacement !== undefined ? options.displacement : [
                0,
                0
            ],
            declutterMode: options.declutterMode
        });
    }
    /**
   * Clones the style.
   * @return {CircleStyle} The cloned style.
   * @api
   * @override
   */ clone() {
        const scale = this.getScale();
        const style = new $f060542c6e9f52e6$var$CircleStyle({
            fill: this.getFill() ? this.getFill().clone() : undefined,
            stroke: this.getStroke() ? this.getStroke().clone() : undefined,
            radius: this.getRadius(),
            scale: Array.isArray(scale) ? scale.slice() : scale,
            rotation: this.getRotation(),
            rotateWithView: this.getRotateWithView(),
            displacement: this.getDisplacement().slice(),
            declutterMode: this.getDeclutterMode()
        });
        style.setOpacity(this.getOpacity());
        return style;
    }
}
var $f060542c6e9f52e6$export$2e2bcd8739ae039 = $f060542c6e9f52e6$var$CircleStyle;


/**
 * @module ol/style/Fill
 */ 



/**
 * @typedef {Object} Options
 * @property {import("../color.js").Color|import("../colorlike.js").ColorLike|import('../colorlike.js').PatternDescriptor|null} [color=null] A color,
 * gradient or pattern.
 * See {@link module:ol/color~Color} and {@link module:ol/colorlike~ColorLike} for possible formats. For polygon fills (not for {@link import("./RegularShape.js").default} fills),
 * a pattern can also be provided as {@link module:ol/colorlike~PatternDescriptor}.
 * Default null; if null, the Canvas/renderer default black will be used.
 */ /**
 * @classdesc
 * Set fill style for vector features.
 * @api
 */ class $8624b871a0af6dab$var$Fill {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options || {};
        /**
     * @private
     * @type {import("./IconImage.js").default|null}
     */ this.patternImage_ = null;
        /**
     * @private
     * @type {import("../color.js").Color|import("../colorlike.js").ColorLike|import('../colorlike.js').PatternDescriptor|null}
     */ this.color_ = null;
        if (options.color !== undefined) this.setColor(options.color);
    }
    /**
   * Clones the style. The color is not cloned if it is a {@link module:ol/colorlike~ColorLike}.
   * @return {Fill} The cloned style.
   * @api
   */ clone() {
        const color = this.getColor();
        return new $8624b871a0af6dab$var$Fill({
            color: Array.isArray(color) ? color.slice() : color || undefined
        });
    }
    /**
   * Get the fill color.
   * @return {import("../color.js").Color|import("../colorlike.js").ColorLike|import('../colorlike.js').PatternDescriptor|null} Color.
   * @api
   */ getColor() {
        return this.color_;
    }
    /**
   * Set the color.
   *
   * @param {import("../color.js").Color|import("../colorlike.js").ColorLike|import('../colorlike.js').PatternDescriptor|null} color Color.
   * @api
   */ setColor(color) {
        if (color !== null && typeof color === 'object' && 'src' in color) {
            const patternImage = (0, $671c623bccf16134$export$3988ae62b71be9a3)(null, color.src, {
                crossOrigin: 'anonymous'
            }, undefined, color.offset ? null : color.color ? color.color : null, !(color.offset && color.size));
            patternImage.ready().then(()=>{
                this.patternImage_ = null;
            });
            if (patternImage.getImageState() === (0, $f217251b3f1483a0$export$2e2bcd8739ae039).IDLE) patternImage.load();
            if (patternImage.getImageState() === (0, $f217251b3f1483a0$export$2e2bcd8739ae039).LOADING) this.patternImage_ = patternImage;
        }
        this.color_ = color;
    }
    /**
   * @return {string} Key of the fill for cache lookup.
   */ getKey() {
        const fill = this.getColor();
        if (!fill) return '';
        return fill instanceof CanvasPattern || fill instanceof CanvasGradient ? (0, $fd76d391cc228565$export$5e82334337e0f204)(fill) : typeof fill === 'object' && 'src' in fill ? fill.src + ':' + fill.offset : (0, $ebac9d8363fa165e$export$75093a47a9fa838d)(fill).toString();
    }
    /**
   * @return {boolean} The fill style is loading an image pattern.
   */ loading() {
        return !!this.patternImage_;
    }
    /**
   * @return {Promise<void>} `false` or a promise that resolves when the style is ready to use.
   */ ready() {
        return this.patternImage_ ? this.patternImage_.ready() : Promise.resolve();
    }
}
var $8624b871a0af6dab$export$2e2bcd8739ae039 = $8624b871a0af6dab$var$Fill;




/**
 * @module ol/style/Stroke
 */ /**
 * @typedef {Object} Options
 * @property {import("../color.js").Color|import("../colorlike.js").ColorLike} [color] A color, gradient or pattern.
 * See {@link module:ol/color~Color} and {@link module:ol/colorlike~ColorLike} for possible formats.
 * Default null; if null, the Canvas/renderer default black will be used.
 * @property {CanvasLineCap} [lineCap='round'] Line cap style: `butt`, `round`, or `square`.
 * @property {CanvasLineJoin} [lineJoin='round'] Line join style: `bevel`, `round`, or `miter`.
 * @property {Array<number>} [lineDash] Line dash pattern. Default is `null` (no dash).
 * @property {number} [lineDashOffset=0] Line dash offset.
 * @property {number} [miterLimit=10] Miter limit.
 * @property {number} [offset] Line offset in pixels along the normal. A positive value offsets the line to the right,
 * relative to the direction of the line. Default is `null` (no offset).
 * @property {number} [width] Width.
 */ /**
 * @classdesc
 * Set stroke style for vector features.
 * Note that the defaults given are the Canvas defaults, which will be used if
 * option is not defined. The `get` functions return whatever was entered in
 * the options; they will not return the default.
 * @api
 */ class $281691897fddf9d0$var$Stroke {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options || {};
        /**
     * @private
     * @type {import("../color.js").Color|import("../colorlike.js").ColorLike}
     */ this.color_ = options.color !== undefined ? options.color : null;
        /**
     * @private
     * @type {CanvasLineCap|undefined}
     */ this.lineCap_ = options.lineCap;
        /**
     * @private
     * @type {Array<number>|null}
     */ this.lineDash_ = options.lineDash !== undefined ? options.lineDash : null;
        /**
     * @private
     * @type {number|undefined}
     */ this.lineDashOffset_ = options.lineDashOffset;
        /**
     * @private
     * @type {CanvasLineJoin|undefined}
     */ this.lineJoin_ = options.lineJoin;
        /**
     * @private
     * @type {number|undefined}
     */ this.miterLimit_ = options.miterLimit;
        /**
     * @private
     * @type {number|undefined}
     */ this.offset_ = options.offset;
        /**
     * @private
     * @type {number|undefined}
     */ this.width_ = options.width;
    }
    /**
   * Clones the style.
   * @return {Stroke} The cloned style.
   * @api
   */ clone() {
        const color = this.getColor();
        return new $281691897fddf9d0$var$Stroke({
            color: Array.isArray(color) ? color.slice() : color || undefined,
            lineCap: this.getLineCap(),
            lineDash: this.getLineDash() ? this.getLineDash().slice() : undefined,
            lineDashOffset: this.getLineDashOffset(),
            lineJoin: this.getLineJoin(),
            miterLimit: this.getMiterLimit(),
            offset: this.getOffset(),
            width: this.getWidth()
        });
    }
    /**
   * Get the stroke color.
   * @return {import("../color.js").Color|import("../colorlike.js").ColorLike} Color.
   * @api
   */ getColor() {
        return this.color_;
    }
    /**
   * Get the line cap type for the stroke.
   * @return {CanvasLineCap|undefined} Line cap.
   * @api
   */ getLineCap() {
        return this.lineCap_;
    }
    /**
   * Get the line dash style for the stroke.
   * @return {Array<number>|null} Line dash.
   * @api
   */ getLineDash() {
        return this.lineDash_;
    }
    /**
   * Get the line dash offset for the stroke.
   * @return {number|undefined} Line dash offset.
   * @api
   */ getLineDashOffset() {
        return this.lineDashOffset_;
    }
    /**
   * Get the line join type for the stroke.
   * @return {CanvasLineJoin|undefined} Line join.
   * @api
   */ getLineJoin() {
        return this.lineJoin_;
    }
    /**
   * Get the miter limit for the stroke.
   * @return {number|undefined} Miter limit.
   * @api
   */ getMiterLimit() {
        return this.miterLimit_;
    }
    /**
   * Get the line offset in pixels.
   * @return {number|undefined} Offset.
   * @api
   */ getOffset() {
        return this.offset_;
    }
    /**
   * Get the stroke width.
   * @return {number|undefined} Width.
   * @api
   */ getWidth() {
        return this.width_;
    }
    /**
   * Set the color.
   *
   * @param {import("../color.js").Color|import("../colorlike.js").ColorLike} color Color.
   * @api
   */ setColor(color) {
        this.color_ = color;
    }
    /**
   * Set the line cap.
   *
   * @param {CanvasLineCap|undefined} lineCap Line cap.
   * @api
   */ setLineCap(lineCap) {
        this.lineCap_ = lineCap;
    }
    /**
   * Set the line dash.
   *
   * @param {Array<number>|null} lineDash Line dash.
   * @api
   */ setLineDash(lineDash) {
        this.lineDash_ = lineDash;
    }
    /**
   * Set the line dash offset.
   *
   * @param {number|undefined} lineDashOffset Line dash offset.
   * @api
   */ setLineDashOffset(lineDashOffset) {
        this.lineDashOffset_ = lineDashOffset;
    }
    /**
   * Set the line join.
   *
   * @param {CanvasLineJoin|undefined} lineJoin Line join.
   * @api
   */ setLineJoin(lineJoin) {
        this.lineJoin_ = lineJoin;
    }
    /**
   * Set the miter limit.
   *
   * @param {number|undefined} miterLimit Miter limit.
   * @api
   */ setMiterLimit(miterLimit) {
        this.miterLimit_ = miterLimit;
    }
    /**
   * Set the line offset in pixels.
   *
   * @param {number|undefined} offset Offset.
   * @api
   */ setOffset(offset) {
        this.offset_ = offset;
    }
    /**
   * Set the width.
   *
   * @param {number|undefined} width Width.
   * @api
   */ setWidth(width) {
        this.width_ = width;
    }
}
var $281691897fddf9d0$export$2e2bcd8739ae039 = $281691897fddf9d0$var$Stroke;


/**
 * @module ol/style/Style
 */ 



/**
 * Defines how symbols and text are decluttered on layers ith `declutter` set to `true`
 * **declutter**: Overlapping symbols and text are decluttered.
 * **obstacle**: Symbols and text are rendered, but serve as obstacle for subsequent attempts
 *   to place a symbol or text at the same location.
 * **none**: No decluttering is done.
 *
 * @typedef {"declutter"|"obstacle"|"none"} DeclutterMode
 */ /**
 * A function that takes a {@link module:ol/Feature~Feature} and a `{number}`
 * representing the view's resolution. The function should return a
 * {@link module:ol/style/Style~Style} or an array of them. This way e.g. a
 * vector layer can be styled. If the function returns `undefined`, the
 * feature will not be rendered.
 *
 * @typedef {function(import("../Feature.js").FeatureLike, number):(Style|Array<Style>|void)} StyleFunction
 */ /**
 * A {@link Style}, an array of {@link Style}, or a {@link StyleFunction}.
 * @typedef {Style|Array<Style>|StyleFunction} StyleLike
 */ /**
 * A function that takes a {@link module:ol/Feature~Feature} as argument and returns an
 * {@link module:ol/geom/Geometry~Geometry} that will be rendered and styled for the feature.
 *
 * @typedef {function(import("../Feature.js").FeatureLike):
 *     (import("../geom/Geometry.js").default|import("../render/Feature.js").default|undefined)} GeometryFunction
 */ /**
 * Custom renderer function. Takes two arguments:
 *
 * 1. The pixel coordinates of the geometry in GeoJSON notation.
 * 2. The {@link module:ol/render~State} of the layer renderer.
 *
 * @typedef {function((import("../coordinate.js").Coordinate|Array<import("../coordinate.js").Coordinate>|Array<Array<import("../coordinate.js").Coordinate>>|Array<Array<Array<import("../coordinate.js").Coordinate>>>),import("../render.js").State): void} RenderFunction
 */ /**
 * @typedef {Object} Options
 * @property {string|import("../geom/Geometry.js").default|GeometryFunction} [geometry] Feature property or geometry
 * or function returning a geometry to render for this style.
 * @property {import("./Fill.js").default} [fill] Fill style.
 * @property {import("./Image.js").default} [image] Image style.
 * @property {RenderFunction} [renderer] Custom renderer. When configured, `fill`, `stroke` and `image` will be
 * ignored, and the provided function will be called with each render frame for each geometry.
 * @property {RenderFunction} [hitDetectionRenderer] Custom renderer for hit detection. If provided will be used
 * in hit detection rendering.
 * @property {import("./Stroke.js").default} [stroke] Stroke style.
 * @property {import("./Text.js").default} [text] Text style.
 * @property {number} [zIndex] Z index.
 */ /**
 * @classdesc
 * Container for vector feature rendering styles. Any changes made to the style
 * or its children through `set*()` methods will not take effect until the
 * feature or layer that uses the style is re-rendered.
 *
 * ## Feature styles
 *
 * If no style is defined, the following default style is used:
 * ```js
 *  import {Circle, Fill, Stroke, Style} from 'ol/style.js';
 *
 *  const fill = new Fill({
 *    color: 'rgba(255,255,255,0.4)',
 *  });
 *  const stroke = new Stroke({
 *    color: '#3399CC',
 *    width: 1.25,
 *  });
 *  const styles = [
 *    new Style({
 *      image: new Circle({
 *        fill: fill,
 *        stroke: stroke,
 *        radius: 5,
 *      }),
 *      fill: fill,
 *      stroke: stroke,
 *    }),
 *  ];
 * ```
 *
 * A separate editing style has the following defaults:
 * ```js
 *  import {Circle, Fill, Stroke, Style} from 'ol/style.js';
 *
 *  const styles = {};
 *  const white = [255, 255, 255, 1];
 *  const blue = [0, 153, 255, 1];
 *  const width = 3;
 *  styles['Polygon'] = [
 *    new Style({
 *      fill: new Fill({
 *        color: [255, 255, 255, 0.5],
 *      }),
 *    }),
 *  ];
 *  styles['MultiPolygon'] =
 *      styles['Polygon'];
 *  styles['LineString'] = [
 *    new Style({
 *      stroke: new Stroke({
 *        color: white,
 *        width: width + 2,
 *      }),
 *    }),
 *    new Style({
 *      stroke: new Stroke({
 *        color: blue,
 *        width: width,
 *      }),
 *    }),
 *  ];
 *  styles['MultiLineString'] = styles['LineString'];
 *
 *  styles['Circle'] = styles['Polygon'].concat(
 *    styles['LineString']
 *  );
 *
 *  styles['Point'] = [
 *    new Style({
 *      image: new Circle({
 *        radius: width * 2,
 *        fill: new Fill({
 *          color: blue,
 *        }),
 *        stroke: new Stroke({
 *          color: white,
 *          width: width / 2,
 *        }),
 *      }),
 *      zIndex: Infinity,
 *    }),
 *  ];
 *  styles['MultiPoint'] =
 *      styles['Point'];
 *  styles['GeometryCollection'] =
 *      styles['Polygon'].concat(
 *          styles['LineString'],
 *          styles['Point']
 *      );
 * ```
 *
 * @api
 */ class $a5fc261473972d1d$var$Style {
    /**
   * @param {Options} [options] Style options.
   */ constructor(options){
        options = options || {};
        /**
     * @private
     * @type {string|import("../geom/Geometry.js").default|GeometryFunction|null}
     */ this.geometry_ = null;
        /**
     * @private
     * @type {!GeometryFunction}
     */ this.geometryFunction_ = $a5fc261473972d1d$var$defaultGeometryFunction;
        if (options.geometry !== undefined) this.setGeometry(options.geometry);
        /**
     * @private
     * @type {import("./Fill.js").default|null}
     */ this.fill_ = options.fill !== undefined ? options.fill : null;
        /**
     * @private
     * @type {import("./Image.js").default|null}
     */ this.image_ = options.image !== undefined ? options.image : null;
        /**
     * @private
     * @type {RenderFunction|null}
     */ this.renderer_ = options.renderer !== undefined ? options.renderer : null;
        /**
     * @private
     * @type {RenderFunction|null}
     */ this.hitDetectionRenderer_ = options.hitDetectionRenderer !== undefined ? options.hitDetectionRenderer : null;
        /**
     * @private
     * @type {import("./Stroke.js").default|null}
     */ this.stroke_ = options.stroke !== undefined ? options.stroke : null;
        /**
     * @private
     * @type {import("./Text.js").default|null}
     */ this.text_ = options.text !== undefined ? options.text : null;
        /**
     * @private
     * @type {number|undefined}
     */ this.zIndex_ = options.zIndex;
    }
    /**
   * Clones the style.
   * @return {Style} The cloned style.
   * @api
   */ clone() {
        let geometry = this.getGeometry();
        if (geometry && typeof geometry === 'object') geometry = /** @type {import("../geom/Geometry.js").default} */ geometry.clone();
        return new $a5fc261473972d1d$var$Style({
            geometry: geometry ?? undefined,
            fill: this.getFill() ? this.getFill().clone() : undefined,
            image: this.getImage() ? this.getImage().clone() : undefined,
            renderer: this.getRenderer() ?? undefined,
            stroke: this.getStroke() ? this.getStroke().clone() : undefined,
            text: this.getText() ? this.getText().clone() : undefined,
            zIndex: this.getZIndex()
        });
    }
    /**
   * Get the custom renderer function that was configured with
   * {@link #setRenderer} or the `renderer` constructor option.
   * @return {RenderFunction|null} Custom renderer function.
   * @api
   */ getRenderer() {
        return this.renderer_;
    }
    /**
   * Sets a custom renderer function for this style. When set, `fill`, `stroke`
   * and `image` options of the style will be ignored.
   * @param {RenderFunction|null} renderer Custom renderer function.
   * @api
   */ setRenderer(renderer) {
        this.renderer_ = renderer;
    }
    /**
   * Sets a custom renderer function for this style used
   * in hit detection.
   * @param {RenderFunction|null} renderer Custom renderer function.
   * @api
   */ setHitDetectionRenderer(renderer) {
        this.hitDetectionRenderer_ = renderer;
    }
    /**
   * Get the custom renderer function that was configured with
   * {@link #setHitDetectionRenderer} or the `hitDetectionRenderer` constructor option.
   * @return {RenderFunction|null} Custom renderer function.
   * @api
   */ getHitDetectionRenderer() {
        return this.hitDetectionRenderer_;
    }
    /**
   * Get the geometry to be rendered.
   * @return {string|import("../geom/Geometry.js").default|GeometryFunction|null}
   * Feature property or geometry or function that returns the geometry that will
   * be rendered with this style.
   * @api
   */ getGeometry() {
        return this.geometry_;
    }
    /**
   * Get the function used to generate a geometry for rendering.
   * @return {!GeometryFunction} Function that is called with a feature
   * and returns the geometry to render instead of the feature's geometry.
   * @api
   */ getGeometryFunction() {
        return this.geometryFunction_;
    }
    /**
   * Get the fill style.
   * @return {import("./Fill.js").default|null} Fill style.
   * @api
   */ getFill() {
        return this.fill_;
    }
    /**
   * Set the fill style.
   * @param {import("./Fill.js").default|null} fill Fill style.
   * @api
   */ setFill(fill) {
        this.fill_ = fill;
    }
    /**
   * Get the image style.
   * @return {import("./Image.js").default|null} Image style.
   * @api
   */ getImage() {
        return this.image_;
    }
    /**
   * Set the image style.
   * @param {import("./Image.js").default} image Image style.
   * @api
   */ setImage(image) {
        this.image_ = image;
    }
    /**
   * Get the stroke style.
   * @return {import("./Stroke.js").default|null} Stroke style.
   * @api
   */ getStroke() {
        return this.stroke_;
    }
    /**
   * Set the stroke style.
   * @param {import("./Stroke.js").default|null} stroke Stroke style.
   * @api
   */ setStroke(stroke) {
        this.stroke_ = stroke;
    }
    /**
   * Get the text style.
   * @return {import("./Text.js").default|null} Text style.
   * @api
   */ getText() {
        return this.text_;
    }
    /**
   * Set the text style.
   * @param {import("./Text.js").default} text Text style.
   * @api
   */ setText(text) {
        this.text_ = text;
    }
    /**
   * Get the z-index for the style.
   * @return {number|undefined} ZIndex.
   * @api
   */ getZIndex() {
        return this.zIndex_;
    }
    /**
   * Set a geometry that is rendered instead of the feature's geometry.
   *
   * @param {string|import("../geom/Geometry.js").default|GeometryFunction|null} geometry
   *     Feature property or geometry or function returning a geometry to render
   *     for this style.
   * @api
   */ setGeometry(geometry) {
        if (typeof geometry === 'function') this.geometryFunction_ = geometry;
        else if (typeof geometry === 'string') this.geometryFunction_ = function(feature) {
            return /** @type {import("../geom/Geometry.js").default} */ feature.get(geometry);
        };
        else if (!geometry) this.geometryFunction_ = $a5fc261473972d1d$var$defaultGeometryFunction;
        else if (geometry !== undefined) this.geometryFunction_ = function() {
            return /** @type {import("../geom/Geometry.js").default} */ geometry;
        };
        this.geometry_ = geometry;
    }
    /**
   * Set the z-index.
   *
   * @param {number|undefined} zIndex ZIndex.
   * @api
   */ setZIndex(zIndex) {
        this.zIndex_ = zIndex;
    }
}
function $a5fc261473972d1d$export$c314ea3f6b164147(obj) {
    let styleFunction;
    if (typeof obj === 'function') styleFunction = obj;
    else {
        /**
     * @type {Array<Style>}
     */ let styles;
        if (Array.isArray(obj)) styles = obj;
        else {
            (0, $71eb897bda873684$export$a7a9523472993e97)(typeof /** @type {?} */ obj.getZIndex === 'function', 'Expected an `Style` or an array of `Style`');
            const style = /** @type {Style} */ obj;
            styles = [
                style
            ];
        }
        styleFunction = function() {
            return styles;
        };
    }
    return styleFunction;
}
/**
 * @type {Array<Style>|null}
 */ let $a5fc261473972d1d$var$defaultStyles = null;
function $a5fc261473972d1d$export$6865c5ac2f5ce8b6(feature, resolution) {
    // We don't use an immediately-invoked function
    // and a closure so we don't get an error at script evaluation time in
    // browsers that do not support Canvas. (import("./Circle.js").CircleStyle does
    // canvas.getContext('2d') at construction time, which will cause an.error
    // in such browsers.)
    if (!$a5fc261473972d1d$var$defaultStyles) {
        const fill = new (0, $8624b871a0af6dab$export$2e2bcd8739ae039)({
            color: 'rgba(255,255,255,0.4)'
        });
        const stroke = new (0, $281691897fddf9d0$export$2e2bcd8739ae039)({
            color: '#3399CC',
            width: 1.25
        });
        $a5fc261473972d1d$var$defaultStyles = [
            new $a5fc261473972d1d$var$Style({
                image: new (0, $f060542c6e9f52e6$export$2e2bcd8739ae039)({
                    fill: fill,
                    stroke: stroke,
                    radius: 5
                }),
                fill: fill,
                stroke: stroke
            })
        ];
    }
    return $a5fc261473972d1d$var$defaultStyles;
}
function $a5fc261473972d1d$export$ed1eaede5d0e77ac() {
    /** @type {Object<import("../geom/Geometry.js").Type, Array<Style>>} */ const styles = {};
    const white = [
        255,
        255,
        255,
        1
    ];
    const blue = [
        0,
        153,
        255,
        1
    ];
    const width = 3;
    styles['Polygon'] = [
        new $a5fc261473972d1d$var$Style({
            fill: new (0, $8624b871a0af6dab$export$2e2bcd8739ae039)({
                color: [
                    255,
                    255,
                    255,
                    0.5
                ]
            })
        })
    ];
    styles['MultiPolygon'] = styles['Polygon'];
    styles['LineString'] = [
        new $a5fc261473972d1d$var$Style({
            stroke: new (0, $281691897fddf9d0$export$2e2bcd8739ae039)({
                color: white,
                width: width + 2
            })
        }),
        new $a5fc261473972d1d$var$Style({
            stroke: new (0, $281691897fddf9d0$export$2e2bcd8739ae039)({
                color: blue,
                width: width
            })
        })
    ];
    styles['MultiLineString'] = styles['LineString'];
    styles['Circle'] = styles['Polygon'].concat(styles['LineString']);
    styles['Point'] = [
        new $a5fc261473972d1d$var$Style({
            image: new (0, $f060542c6e9f52e6$export$2e2bcd8739ae039)({
                radius: width * 2,
                fill: new (0, $8624b871a0af6dab$export$2e2bcd8739ae039)({
                    color: blue
                }),
                stroke: new (0, $281691897fddf9d0$export$2e2bcd8739ae039)({
                    color: white,
                    width: width / 2
                })
            }),
            zIndex: Infinity
        })
    ];
    styles['MultiPoint'] = styles['Point'];
    styles['GeometryCollection'] = styles['Polygon'].concat(styles['LineString'], styles['Point']);
    return styles;
}
/**
 * Function that is called with a feature and returns its default geometry.
 * @param {import("../Feature.js").FeatureLike} feature Feature to get the geometry for.
 * @return {import("../geom/Geometry.js").default|import("../render/Feature.js").default|undefined} Geometry to render.
 */ function $a5fc261473972d1d$var$defaultGeometryFunction(feature) {
    return feature.getGeometry();
}
var $a5fc261473972d1d$export$2e2bcd8739ae039 = $a5fc261473972d1d$var$Style;


/**
 * @module ol/style/Text
 */ 

/**
 * @typedef {'point' | 'line'} TextPlacement
 * Default text placement is `'point'`. Note that
 * `'line'` requires the underlying geometry to be a {@link module:ol/geom/LineString~LineString},
 * {@link module:ol/geom/Polygon~Polygon}, {@link module:ol/geom/MultiLineString~MultiLineString} or
 * {@link module:ol/geom/MultiPolygon~MultiPolygon}.
 */ /**
 * @typedef {'left' | 'center' | 'right'} TextJustify
 */ /**
 * The default fill color to use if no fill was set at construction time; a
 * blackish `#333`.
 *
 * @const {string}
 */ const $ee3bf0a2c13d7793$var$DEFAULT_FILL_COLOR = '#333';
/**
 * @typedef {Object} Options
 * @property {string} [font] Font style as CSS `font` value, see:
 * https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/font. Default is `'10px sans-serif'`
 * @property {number} [maxAngle=Math.PI/4] When `placement` is set to `'line'`, allow a maximum angle between adjacent characters.
 * The expected value is in radians, and the default is 45° (`Math.PI / 4`).
 * @property {number} [offsetX=0] Horizontal text offset in pixels. A positive will shift the text right.
 * @property {number} [offsetY=0] Vertical text offset in pixels. A positive will shift the text down.
 * @property {boolean} [overflow=false] For polygon labels or when `placement` is set to `'line'`, allow text to exceed
 * the width of the polygon at the label position or the length of the path that it follows.
 * @property {TextPlacement} [placement='point'] Text placement.
 * @property {number} [repeat] Repeat interval. When set, the text will be repeated at this interval, which specifies
 * the distance between two text anchors in pixels. Only available when `placement` is set to `'line'`. Overrides 'textAlign'.
 * @property {number|import("../size.js").Size} [scale] Scale.
 * @property {boolean} [rotateWithView=false] Whether to rotate the text with the view.
 * @property {boolean} [keepUpright=true] Whether the text can be rotated 180° to prevent being rendered upside down.
 * @property {number} [rotation=0] Rotation in radians (positive rotation clockwise).
 * @property {string|Array<string>} [text] Text content or rich text content. For plain text provide a string, which can
 * contain line breaks (`\n`). For rich text provide an array of text/font tuples. A tuple consists of the text to
 * render and the font to use (or `''` to use the text style's font). A line break has to be a separate tuple (i.e. `'\n', ''`).
 * **Example:** `['foo', 'bold 10px sans-serif', ' bar', 'italic 10px sans-serif', ' baz', '']` will yield "**foo** *bar* baz".
 * **Note:** Rich text is not supported for `placement: 'line'` or the immediate rendering API.
 * @property {CanvasTextAlign} [textAlign] Text alignment. Possible values: `'left'`, `'right'`, `'center'`, `'end'` or `'start'`.
 * Default is `'center'` for `placement: 'point'`. For `placement: 'line'`, the default is to let the renderer choose a
 * placement where `maxAngle` is not exceeded.
 * @property {TextJustify} [justify] Text justification within the text box.
 * If not set, text is justified towards the `textAlign` anchor.
 * Otherwise, use options `'left'`, `'center'`, or `'right'` to justify the text within the text box.
 * **Note:** `justify` is ignored for immediate rendering and also for `placement: 'line'`.
 * @property {CanvasTextBaseline} [textBaseline='middle'] Text base line. Possible values: `'bottom'`, `'top'`, `'middle'`, `'alphabetic'`,
 * `'hanging'`, `'ideographic'`.
 * @property {import("./Fill.js").default|null} [fill] Fill style. If none is provided, we'll use a dark fill-style (#333). Specify `null` for no fill.
 * @property {import("./Stroke.js").default} [stroke] Stroke style.
 * @property {import("./Fill.js").default} [backgroundFill] Fill style for the text background when `placement` is
 * `'point'`. Default is no fill.
 * @property {import("./Stroke.js").default} [backgroundStroke] Stroke style for the text background  when `placement`
 * is `'point'`. Default is no stroke.
 * @property {Array<number>} [padding=[0, 0, 0, 0]] Padding in pixels around the text for decluttering and background. The order of
 * values in the array is `[top, right, bottom, left]`.
 * @property {import('../style/Style.js').DeclutterMode} [declutterMode] Declutter mode: `declutter`, `obstacle`, `none`
 */ /**
 * @classdesc
 * Set text style for vector features.
 * @api
 */ class $ee3bf0a2c13d7793$var$Text {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options || {};
        /**
     * @private
     * @type {string|undefined}
     */ this.font_ = options.font;
        /**
     * @private
     * @type {number|undefined}
     */ this.rotation_ = options.rotation;
        /**
     * @private
     * @type {boolean|undefined}
     */ this.rotateWithView_ = options.rotateWithView;
        /**
     * @private
     * @type {boolean|undefined}
     */ this.keepUpright_ = options.keepUpright;
        /**
     * @private
     * @type {number|import("../size.js").Size|undefined}
     */ this.scale_ = options.scale;
        /**
     * @private
     * @type {import("../size.js").Size}
     */ this.scaleArray_ = (0, $625e418aeada4c0d$export$a71a825ff42fb8e1)(options.scale !== undefined ? options.scale : 1);
        /**
     * @private
     * @type {string|Array<string>|undefined}
     */ this.text_ = options.text;
        /**
     * @private
     * @type {CanvasTextAlign|undefined}
     */ this.textAlign_ = options.textAlign;
        /**
     * @private
     * @type {TextJustify|undefined}
     */ this.justify_ = options.justify;
        /**
     * @private
     * @type {number|undefined}
     */ this.repeat_ = options.repeat;
        /**
     * @private
     * @type {CanvasTextBaseline|undefined}
     */ this.textBaseline_ = options.textBaseline;
        /**
     * @private
     * @type {import("./Fill.js").default|null}
     */ this.fill_ = options.fill !== undefined ? options.fill : new (0, $8624b871a0af6dab$export$2e2bcd8739ae039)({
            color: $ee3bf0a2c13d7793$var$DEFAULT_FILL_COLOR
        });
        /**
     * @private
     * @type {number}
     */ this.maxAngle_ = options.maxAngle !== undefined ? options.maxAngle : Math.PI / 4;
        /**
     * @private
     * @type {TextPlacement}
     */ this.placement_ = options.placement !== undefined ? options.placement : 'point';
        /**
     * @private
     * @type {boolean}
     */ this.overflow_ = !!options.overflow;
        /**
     * @private
     * @type {import("./Stroke.js").default|null}
     */ this.stroke_ = options.stroke !== undefined ? options.stroke : null;
        /**
     * @private
     * @type {number}
     */ this.offsetX_ = options.offsetX !== undefined ? options.offsetX : 0;
        /**
     * @private
     * @type {number}
     */ this.offsetY_ = options.offsetY !== undefined ? options.offsetY : 0;
        /**
     * @private
     * @type {import("./Fill.js").default|null}
     */ this.backgroundFill_ = options.backgroundFill ? options.backgroundFill : null;
        /**
     * @private
     * @type {import("./Stroke.js").default|null}
     */ this.backgroundStroke_ = options.backgroundStroke ? options.backgroundStroke : null;
        /**
     * @private
     * @type {Array<number>|null}
     */ this.padding_ = options.padding === undefined ? null : options.padding;
        /**
     * @private
     * @type {import('../style/Style.js').DeclutterMode}
     */ this.declutterMode_ = options.declutterMode;
    }
    /**
   * Clones the style.
   * @return {Text} The cloned style.
   * @api
   */ clone() {
        const scale = this.getScale();
        return new $ee3bf0a2c13d7793$var$Text({
            font: this.getFont(),
            placement: this.getPlacement(),
            repeat: this.getRepeat(),
            maxAngle: this.getMaxAngle(),
            overflow: this.getOverflow(),
            rotation: this.getRotation(),
            rotateWithView: this.getRotateWithView(),
            keepUpright: this.getKeepUpright(),
            scale: Array.isArray(scale) ? scale.slice() : scale,
            text: this.getText(),
            textAlign: this.getTextAlign(),
            justify: this.getJustify(),
            textBaseline: this.getTextBaseline(),
            fill: this.getFill() instanceof (0, $8624b871a0af6dab$export$2e2bcd8739ae039) ? this.getFill().clone() : this.getFill(),
            stroke: this.getStroke() ? this.getStroke().clone() : undefined,
            offsetX: this.getOffsetX(),
            offsetY: this.getOffsetY(),
            backgroundFill: this.getBackgroundFill() ? this.getBackgroundFill().clone() : undefined,
            backgroundStroke: this.getBackgroundStroke() ? this.getBackgroundStroke().clone() : undefined,
            padding: this.getPadding() || undefined,
            declutterMode: this.getDeclutterMode()
        });
    }
    /**
   * Get the `overflow` configuration.
   * @return {boolean} Let text overflow the length of the path they follow.
   * @api
   */ getOverflow() {
        return this.overflow_;
    }
    /**
   * Get the font name.
   * @return {string|undefined} Font.
   * @api
   */ getFont() {
        return this.font_;
    }
    /**
   * Get the maximum angle between adjacent characters.
   * @return {number} Angle in radians.
   * @api
   */ getMaxAngle() {
        return this.maxAngle_;
    }
    /**
   * Get the label placement.
   * @return {TextPlacement} Text placement.
   * @api
   */ getPlacement() {
        return this.placement_;
    }
    /**
   * Get the repeat interval of the text.
   * @return {number|undefined} Repeat interval in pixels.
   * @api
   */ getRepeat() {
        return this.repeat_;
    }
    /**
   * Get the x-offset for the text.
   * @return {number} Horizontal text offset.
   * @api
   */ getOffsetX() {
        return this.offsetX_;
    }
    /**
   * Get the y-offset for the text.
   * @return {number} Vertical text offset.
   * @api
   */ getOffsetY() {
        return this.offsetY_;
    }
    /**
   * Get the fill style for the text.
   * @return {import("./Fill.js").default|null} Fill style.
   * @api
   */ getFill() {
        return this.fill_;
    }
    /**
   * Determine whether the text rotates with the map.
   * @return {boolean|undefined} Rotate with map.
   * @api
   */ getRotateWithView() {
        return this.rotateWithView_;
    }
    /**
   * Determine whether the text can be rendered upside down.
   * @return {boolean|undefined} Keep text upright.
   * @api
   */ getKeepUpright() {
        return this.keepUpright_;
    }
    /**
   * Get the text rotation.
   * @return {number|undefined} Rotation.
   * @api
   */ getRotation() {
        return this.rotation_;
    }
    /**
   * Get the text scale.
   * @return {number|import("../size.js").Size|undefined} Scale.
   * @api
   */ getScale() {
        return this.scale_;
    }
    /**
   * Get the symbolizer scale array.
   * @return {import("../size.js").Size} Scale array.
   */ getScaleArray() {
        return this.scaleArray_;
    }
    /**
   * Get the stroke style for the text.
   * @return {import("./Stroke.js").default|null} Stroke style.
   * @api
   */ getStroke() {
        return this.stroke_;
    }
    /**
   * Get the text to be rendered.
   * @return {string|Array<string>|undefined} Text.
   * @api
   */ getText() {
        return this.text_;
    }
    /**
   * Get the text alignment.
   * @return {CanvasTextAlign|undefined} Text align.
   * @api
   */ getTextAlign() {
        return this.textAlign_;
    }
    /**
   * Get the justification.
   * @return {TextJustify|undefined} Justification.
   * @api
   */ getJustify() {
        return this.justify_;
    }
    /**
   * Get the text baseline.
   * @return {CanvasTextBaseline|undefined} Text baseline.
   * @api
   */ getTextBaseline() {
        return this.textBaseline_;
    }
    /**
   * Get the background fill style for the text.
   * @return {import("./Fill.js").default|null} Fill style.
   * @api
   */ getBackgroundFill() {
        return this.backgroundFill_;
    }
    /**
   * Get the background stroke style for the text.
   * @return {import("./Stroke.js").default|null} Stroke style.
   * @api
   */ getBackgroundStroke() {
        return this.backgroundStroke_;
    }
    /**
   * Get the padding for the text.
   * @return {Array<number>|null} Padding.
   * @api
   */ getPadding() {
        return this.padding_;
    }
    /**
   * Get the declutter mode of the shape
   * @return {import("./Style.js").DeclutterMode} Shape's declutter mode
   * @api
   */ getDeclutterMode() {
        return this.declutterMode_;
    }
    /**
   * Set the `overflow` property.
   *
   * @param {boolean} overflow Let text overflow the path that it follows.
   * @api
   */ setOverflow(overflow) {
        this.overflow_ = overflow;
    }
    /**
   * Set the font.
   *
   * @param {string|undefined} font Font.
   * @api
   */ setFont(font) {
        this.font_ = font;
    }
    /**
   * Set the maximum angle between adjacent characters.
   *
   * @param {number} maxAngle Angle in radians.
   * @api
   */ setMaxAngle(maxAngle) {
        this.maxAngle_ = maxAngle;
    }
    /**
   * Set the x offset.
   *
   * @param {number} offsetX Horizontal text offset.
   * @api
   */ setOffsetX(offsetX) {
        this.offsetX_ = offsetX;
    }
    /**
   * Set the y offset.
   *
   * @param {number} offsetY Vertical text offset.
   * @api
   */ setOffsetY(offsetY) {
        this.offsetY_ = offsetY;
    }
    /**
   * Set the text placement.
   *
   * @param {TextPlacement} placement Placement.
   * @api
   */ setPlacement(placement) {
        this.placement_ = placement;
    }
    /**
   * Set the repeat interval of the text.
   * @param {number|undefined} [repeat] Repeat interval in pixels.
   * @api
   */ setRepeat(repeat) {
        this.repeat_ = repeat;
    }
    /**
   * Set whether to rotate the text with the view.
   *
   * @param {boolean} rotateWithView Rotate with map.
   * @api
   */ setRotateWithView(rotateWithView) {
        this.rotateWithView_ = rotateWithView;
    }
    /**
   * Set whether the text can be rendered upside down.
   *
   * @param {boolean} keepUpright Keep text upright.
   * @api
   */ setKeepUpright(keepUpright) {
        this.keepUpright_ = keepUpright;
    }
    /**
   * Set the fill.
   *
   * @param {import("./Fill.js").default|null} fill Fill style.
   * @api
   */ setFill(fill) {
        this.fill_ = fill;
    }
    /**
   * Set the rotation.
   *
   * @param {number|undefined} rotation Rotation.
   * @api
   */ setRotation(rotation) {
        this.rotation_ = rotation;
    }
    /**
   * Set the scale.
   *
   * @param {number|import("../size.js").Size|undefined} scale Scale.
   * @api
   */ setScale(scale) {
        this.scale_ = scale;
        this.scaleArray_ = (0, $625e418aeada4c0d$export$a71a825ff42fb8e1)(scale !== undefined ? scale : 1);
    }
    /**
   * Set the stroke.
   *
   * @param {import("./Stroke.js").default|null} stroke Stroke style.
   * @api
   */ setStroke(stroke) {
        this.stroke_ = stroke;
    }
    /**
   * Set the text.
   *
   * @param {string|Array<string>|undefined} text Text.
   * @api
   */ setText(text) {
        this.text_ = text;
    }
    /**
   * Set the text alignment.
   *
   * @param {CanvasTextAlign|undefined} textAlign Text align.
   * @api
   */ setTextAlign(textAlign) {
        this.textAlign_ = textAlign;
    }
    /**
   * Set the justification.
   *
   * @param {TextJustify|undefined} justify Justification.
   * @api
   */ setJustify(justify) {
        this.justify_ = justify;
    }
    /**
   * Set the text baseline.
   *
   * @param {CanvasTextBaseline|undefined} textBaseline Text baseline.
   * @api
   */ setTextBaseline(textBaseline) {
        this.textBaseline_ = textBaseline;
    }
    /**
   * Set the background fill.
   *
   * @param {import("./Fill.js").default|null} fill Fill style.
   * @api
   */ setBackgroundFill(fill) {
        this.backgroundFill_ = fill;
    }
    /**
   * Set the background stroke.
   *
   * @param {import("./Stroke.js").default|null} stroke Stroke style.
   * @api
   */ setBackgroundStroke(stroke) {
        this.backgroundStroke_ = stroke;
    }
    /**
   * Set the padding (`[top, right, bottom, left]`).
   *
   * @param {Array<number>|null} padding Padding.
   * @api
   */ setPadding(padding) {
        this.padding_ = padding;
    }
}
var $ee3bf0a2c13d7793$export$2e2bcd8739ae039 = $ee3bf0a2c13d7793$var$Text;


/**
 * @fileoverview This module includes functions to build styles for the canvas renderer.  Building
 * is composed of two steps: parsing and compiling.  The parsing step takes an encoded expression
 * and returns an instance of one of the expression classes.  The compiling step takes the
 * expression instance and returns a function that can be evaluated to return a literal value.  The
 * evaluator function should do as little allocation and work as possible.
 */ /**
 * @typedef {import("../../style/flat.js").FlatStyle} FlatStyle
 */ /**
 * @typedef {import("../../expr/expression.js").EncodedExpression} EncodedExpression
 */ /**
 * @typedef {import("../../expr/expression.js").ParsingContext} ParsingContext
 */ /**
 * @typedef {import("../../expr/expression.js").CallExpression} CallExpression
 */ /**
 * @typedef {import("../../expr/cpu.js").EvaluationContext} EvaluationContext
 */ /**
 * @typedef {import("../../expr/cpu.js").ExpressionEvaluator} ExpressionEvaluator
 */ /**
 * @param {EvaluationContext} context The evaluation context.
 * @return {boolean} Always true.
 */ function $42615ab27a1cc094$var$always(context) {
    return true;
}
function $42615ab27a1cc094$export$fc6a94152b1b05a8(rules) {
    const parsingContext = (0, $026a116c72f030b4$export$1c8b4c1584800354)();
    const evaluator = $42615ab27a1cc094$export$d6ae6a4799989976(rules, parsingContext);
    const evaluationContext = (0, $a87b5daadb108525$export$c18f39f0e136c26)();
    return function(feature, resolution) {
        evaluationContext.properties = feature.getPropertiesInternal();
        evaluationContext.resolution = resolution;
        if (parsingContext.featureId) {
            const id = feature.getId();
            if (id !== undefined) evaluationContext.featureId = id;
            else evaluationContext.featureId = null;
        }
        if (parsingContext.geometryType) evaluationContext.geometryType = (0, $026a116c72f030b4$export$8da88d86d10c1295)(feature.getGeometry());
        return evaluator(evaluationContext);
    };
}
function $42615ab27a1cc094$export$5a130bc4f0a0420b(flatStyles) {
    const parsingContext = (0, $026a116c72f030b4$export$1c8b4c1584800354)();
    const length = flatStyles.length;
    /**
   * @type {Array<StyleEvaluator>}
   */ const evaluators = new Array(length);
    for(let i = 0; i < length; ++i)evaluators[i] = $42615ab27a1cc094$export$a6e5f510497b7388(flatStyles[i], parsingContext);
    const evaluationContext = (0, $a87b5daadb108525$export$c18f39f0e136c26)();
    /**
   * @type {Array<Style>}
   */ const styles = new Array(length);
    return function(feature, resolution) {
        evaluationContext.properties = feature.getPropertiesInternal();
        evaluationContext.resolution = resolution;
        if (parsingContext.featureId) {
            const id = feature.getId();
            if (id !== undefined) evaluationContext.featureId = id;
            else evaluationContext.featureId = null;
        }
        let nonNullCount = 0;
        for(let i = 0; i < length; ++i){
            const style = evaluators[i](evaluationContext);
            if (style) {
                styles[nonNullCount] = style;
                nonNullCount += 1;
            }
        }
        styles.length = nonNullCount;
        return styles;
    };
}
function $42615ab27a1cc094$export$d6ae6a4799989976(rules, context) {
    const length = rules.length;
    /**
   * @type {Array<CompiledRule>}
   */ const compiledRules = new Array(length);
    for(let i = 0; i < length; ++i){
        const rule = rules[i];
        const filter = 'filter' in rule ? (0, $a87b5daadb108525$export$b5f535122a9211f0)(rule.filter, (0, $026a116c72f030b4$export$240f7fffab1b25a0), context) : $42615ab27a1cc094$var$always;
        /**
     * @type {Array<StyleEvaluator>}
     */ let styles;
        if (Array.isArray(rule.style)) {
            const styleLength = rule.style.length;
            styles = new Array(styleLength);
            for(let j = 0; j < styleLength; ++j)styles[j] = $42615ab27a1cc094$export$a6e5f510497b7388(rule.style[j], context);
        } else styles = [
            $42615ab27a1cc094$export$a6e5f510497b7388(rule.style, context)
        ];
        compiledRules[i] = {
            filter: filter,
            styles: styles
        };
    }
    return function(context) {
        /**
     * @type {Array<Style>}
     */ const styles = [];
        let someMatched = false;
        for(let i = 0; i < length; ++i){
            const filterEvaluator = compiledRules[i].filter;
            if (!filterEvaluator(context)) continue;
            if (rules[i].else && someMatched) continue;
            someMatched = true;
            for (const styleEvaluator of compiledRules[i].styles){
                const style = styleEvaluator(context);
                if (!style) continue;
                styles.push(style);
            }
        }
        return styles;
    };
}
function $42615ab27a1cc094$export$a6e5f510497b7388(flatStyle, context) {
    const evaluateFill = $42615ab27a1cc094$var$buildFill(flatStyle, '', context);
    const evaluateStroke = $42615ab27a1cc094$var$buildStroke(flatStyle, '', context);
    const evaluateText = $42615ab27a1cc094$var$buildText(flatStyle, context);
    const evaluateImage = $42615ab27a1cc094$var$buildImage(flatStyle, context);
    const evaluateZIndex = $42615ab27a1cc094$var$numberEvaluator(flatStyle, 'z-index', context);
    if (!evaluateFill && !evaluateStroke && !evaluateText && !evaluateImage && !(0, $9f2b61a1df00e9b3$export$dd1bc94b04021eeb)(flatStyle)) // assume this is a user error
    // would be nice to check the properties and suggest "did you mean..."
    throw new Error('No fill, stroke, point, or text symbolizer properties in style: ' + JSON.stringify(flatStyle));
    const style = new (0, $a5fc261473972d1d$export$2e2bcd8739ae039)();
    return function(context) {
        let empty = true;
        if (evaluateFill) {
            const fill = evaluateFill(context);
            if (fill) empty = false;
            style.setFill(fill);
        }
        if (evaluateStroke) {
            const stroke = evaluateStroke(context);
            if (stroke) empty = false;
            style.setStroke(stroke);
        }
        if (evaluateText) {
            const text = evaluateText(context);
            if (text) empty = false;
            style.setText(text);
        }
        if (evaluateImage) {
            const image = evaluateImage(context);
            if (image) empty = false;
            style.setImage(image);
        }
        if (evaluateZIndex) style.setZIndex(evaluateZIndex(context));
        if (empty) return null;
        return style;
    };
}
/**
 * @typedef {function(EvaluationContext):Fill|null} FillEvaluator
 */ /**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} prefix The property prefix.
 * @param {ParsingContext} context The parsing context.
 * @return {FillEvaluator?} A function that evaluates to a fill.
 */ function $42615ab27a1cc094$var$buildFill(flatStyle, prefix, context) {
    let evaluateColor;
    if (prefix + 'fill-pattern-src' in flatStyle) evaluateColor = $42615ab27a1cc094$var$patternEvaluator(flatStyle, prefix + 'fill-', context);
    else {
        if (flatStyle[prefix + 'fill-color'] === 'none') // avoids hit detection
        return (context)=>null;
        evaluateColor = $42615ab27a1cc094$var$colorLikeEvaluator(flatStyle, prefix + 'fill-color', context);
    }
    if (!evaluateColor) return null;
    const fill = new (0, $8624b871a0af6dab$export$2e2bcd8739ae039)();
    return function(context) {
        const color = evaluateColor(context);
        if (color === (0, $ebac9d8363fa165e$export$6c844c64a5efe1ee)) return null;
        fill.setColor(color);
        return fill;
    };
}
/**
 * @typedef {function(EvaluationContext):Stroke|null} StrokeEvaluator
 */ /**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} prefix The property prefix.
 * @param {ParsingContext} context The parsing context.
 * @return {StrokeEvaluator?} A function the evaluates to a stroke.
 */ function $42615ab27a1cc094$var$buildStroke(flatStyle, prefix, context) {
    const evaluateWidth = $42615ab27a1cc094$var$numberEvaluator(flatStyle, prefix + 'stroke-width', context);
    const evaluateColor = $42615ab27a1cc094$var$colorLikeEvaluator(flatStyle, prefix + 'stroke-color', context);
    if (!evaluateWidth && !evaluateColor) return null;
    const evaluateLineCap = $42615ab27a1cc094$var$stringEvaluator(flatStyle, prefix + 'stroke-line-cap', context);
    const evaluateLineJoin = $42615ab27a1cc094$var$stringEvaluator(flatStyle, prefix + 'stroke-line-join', context);
    const evaluateLineDash = $42615ab27a1cc094$var$numberArrayEvaluator(flatStyle, prefix + 'stroke-line-dash', context);
    const evaluateLineDashOffset = $42615ab27a1cc094$var$numberEvaluator(flatStyle, prefix + 'stroke-line-dash-offset', context);
    const evaluateMiterLimit = $42615ab27a1cc094$var$numberEvaluator(flatStyle, prefix + 'stroke-miter-limit', context);
    const evaluateOffset = $42615ab27a1cc094$var$numberEvaluator(flatStyle, prefix + 'stroke-offset', context);
    const stroke = new (0, $281691897fddf9d0$export$2e2bcd8739ae039)();
    return function(context) {
        if (evaluateColor) {
            const color = evaluateColor(context);
            if (color === (0, $ebac9d8363fa165e$export$6c844c64a5efe1ee)) return null;
            stroke.setColor(color);
        }
        if (evaluateWidth) stroke.setWidth(evaluateWidth(context));
        if (evaluateLineCap) {
            const lineCap = evaluateLineCap(context);
            if (lineCap !== 'butt' && lineCap !== 'round' && lineCap !== 'square') throw new Error('Expected butt, round, or square line cap');
            stroke.setLineCap(lineCap);
        }
        if (evaluateLineJoin) {
            const lineJoin = evaluateLineJoin(context);
            if (lineJoin !== 'bevel' && lineJoin !== 'round' && lineJoin !== 'miter') throw new Error('Expected bevel, round, or miter line join');
            stroke.setLineJoin(lineJoin);
        }
        if (evaluateLineDash) stroke.setLineDash(evaluateLineDash(context));
        if (evaluateLineDashOffset) stroke.setLineDashOffset(evaluateLineDashOffset(context));
        if (evaluateMiterLimit) stroke.setMiterLimit(evaluateMiterLimit(context));
        if (evaluateOffset) stroke.setOffset(evaluateOffset(context));
        return stroke;
    };
}
/**
 * @typedef {function(EvaluationContext):Text} TextEvaluator
 */ /**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {ParsingContext} context The parsing context.
 * @return {TextEvaluator?} A function that evaluates to a text symbolizer.
 */ function $42615ab27a1cc094$var$buildText(flatStyle, context) {
    const prefix = 'text-';
    // Currently, an Array<string> may be used for rich text support.  This doesn't
    // work with our expression syntax where arrays of strings are interpreted as
    // call expressions.  To support rich text, we could add a 'strings' operator
    // where all the following arguments would be string values.
    const evaluateValue = $42615ab27a1cc094$var$stringEvaluator(flatStyle, prefix + 'value', context);
    if (!evaluateValue) return null;
    const evaluateFill = $42615ab27a1cc094$var$buildFill(flatStyle, prefix, context);
    const evaluateBackgroundFill = $42615ab27a1cc094$var$buildFill(flatStyle, prefix + 'background-', context);
    const evaluateStroke = $42615ab27a1cc094$var$buildStroke(flatStyle, prefix, context);
    const evaluateBackgroundStroke = $42615ab27a1cc094$var$buildStroke(flatStyle, prefix + 'background-', context);
    const evaluateFont = $42615ab27a1cc094$var$stringEvaluator(flatStyle, prefix + 'font', context);
    const evaluateMaxAngle = $42615ab27a1cc094$var$numberEvaluator(flatStyle, prefix + 'max-angle', context);
    const evaluateOffsetX = $42615ab27a1cc094$var$numberEvaluator(flatStyle, prefix + 'offset-x', context);
    const evaluateOffsetY = $42615ab27a1cc094$var$numberEvaluator(flatStyle, prefix + 'offset-y', context);
    const evaluateOverflow = $42615ab27a1cc094$var$booleanEvaluator(flatStyle, prefix + 'overflow', context);
    const evaluatePlacement = $42615ab27a1cc094$var$stringEvaluator(flatStyle, prefix + 'placement', context);
    const evaluateRepeat = $42615ab27a1cc094$var$numberEvaluator(flatStyle, prefix + 'repeat', context);
    const evaluateScale = $42615ab27a1cc094$var$sizeLikeEvaluator(flatStyle, prefix + 'scale', context);
    const evaluateRotateWithView = $42615ab27a1cc094$var$booleanEvaluator(flatStyle, prefix + 'rotate-with-view', context);
    const evaluateRotation = $42615ab27a1cc094$var$numberEvaluator(flatStyle, prefix + 'rotation', context);
    const evaluateAlign = $42615ab27a1cc094$var$stringEvaluator(flatStyle, prefix + 'align', context);
    const evaluateJustify = $42615ab27a1cc094$var$stringEvaluator(flatStyle, prefix + 'justify', context);
    const evaluateBaseline = $42615ab27a1cc094$var$stringEvaluator(flatStyle, prefix + 'baseline', context);
    const evaluateKeepUpright = $42615ab27a1cc094$var$booleanEvaluator(flatStyle, prefix + 'keep-upright', context);
    const evaluatePadding = $42615ab27a1cc094$var$numberArrayEvaluator(flatStyle, prefix + 'padding', context);
    // The following properties are not currently settable
    const declutterMode = $42615ab27a1cc094$var$optionalDeclutterMode(flatStyle, prefix + 'declutter-mode');
    const text = new (0, $ee3bf0a2c13d7793$export$2e2bcd8739ae039)({
        declutterMode: declutterMode
    });
    return function(context) {
        text.setText(evaluateValue(context));
        if (evaluateFill) text.setFill(evaluateFill(context));
        if (evaluateBackgroundFill) text.setBackgroundFill(evaluateBackgroundFill(context));
        if (evaluateStroke) text.setStroke(evaluateStroke(context));
        if (evaluateBackgroundStroke) text.setBackgroundStroke(evaluateBackgroundStroke(context));
        if (evaluateFont) text.setFont(evaluateFont(context));
        if (evaluateMaxAngle) text.setMaxAngle(evaluateMaxAngle(context));
        if (evaluateOffsetX) text.setOffsetX(evaluateOffsetX(context));
        if (evaluateOffsetY) text.setOffsetY(evaluateOffsetY(context));
        if (evaluateOverflow) text.setOverflow(evaluateOverflow(context));
        if (evaluatePlacement) {
            const placement = evaluatePlacement(context);
            if (placement !== 'point' && placement !== 'line') throw new Error('Expected point or line for text-placement');
            text.setPlacement(placement);
        }
        if (evaluateRepeat) text.setRepeat(evaluateRepeat(context));
        if (evaluateScale) text.setScale(evaluateScale(context));
        if (evaluateRotateWithView) text.setRotateWithView(evaluateRotateWithView(context));
        if (evaluateRotation) text.setRotation(evaluateRotation(context));
        if (evaluateAlign) {
            const textAlign = evaluateAlign(context);
            if (textAlign !== 'left' && textAlign !== 'center' && textAlign !== 'right' && textAlign !== 'end' && textAlign !== 'start') throw new Error('Expected left, right, center, start, or end for text-align');
            text.setTextAlign(textAlign);
        }
        if (evaluateJustify) {
            const justify = evaluateJustify(context);
            if (justify !== 'left' && justify !== 'right' && justify !== 'center') throw new Error('Expected left, right, or center for text-justify');
            text.setJustify(justify);
        }
        if (evaluateBaseline) {
            const textBaseline = evaluateBaseline(context);
            if (textBaseline !== 'bottom' && textBaseline !== 'top' && textBaseline !== 'middle' && textBaseline !== 'alphabetic' && textBaseline !== 'hanging') throw new Error('Expected bottom, top, middle, alphabetic, or hanging for text-baseline');
            text.setTextBaseline(textBaseline);
        }
        if (evaluatePadding) text.setPadding(evaluatePadding(context));
        if (evaluateKeepUpright) text.setKeepUpright(evaluateKeepUpright(context));
        return text;
    };
}
/**
 * @typedef {function(EvaluationContext):import("../../style/Image.js").default} ImageEvaluator
 */ /**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {ParsingContext} context The parsing context.
 * @return {ImageEvaluator?} A function that evaluates to an image symbolizer.
 */ function $42615ab27a1cc094$var$buildImage(flatStyle, context) {
    if ('icon-src' in flatStyle) return $42615ab27a1cc094$var$buildIcon(flatStyle, context);
    if ('shape-points' in flatStyle) return $42615ab27a1cc094$var$buildShape(flatStyle, context);
    if ('circle-radius' in flatStyle) return $42615ab27a1cc094$var$buildCircle(flatStyle, context);
    return null;
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {ParsingContext} context The parsing context.
 * @return {ImageEvaluator} A function that evaluates to an image symbolizer.
 */ function $42615ab27a1cc094$var$buildIcon(flatStyle, context) {
    const prefix = 'icon-';
    // required property
    const srcName = prefix + 'src';
    const src = $42615ab27a1cc094$var$requireString(flatStyle[srcName], srcName);
    // settable properties
    const evaluateAnchor = $42615ab27a1cc094$var$coordinateEvaluator(flatStyle, prefix + 'anchor', context);
    const evaluateScale = $42615ab27a1cc094$var$sizeLikeEvaluator(flatStyle, prefix + 'scale', context);
    const evaluateOpacity = $42615ab27a1cc094$var$numberEvaluator(flatStyle, prefix + 'opacity', context);
    const evaluateDisplacement = $42615ab27a1cc094$var$coordinateEvaluator(flatStyle, prefix + 'displacement', context);
    const evaluateRotation = $42615ab27a1cc094$var$numberEvaluator(flatStyle, prefix + 'rotation', context);
    const evaluateRotateWithView = $42615ab27a1cc094$var$booleanEvaluator(flatStyle, prefix + 'rotate-with-view', context);
    // the remaining symbolizer properties are not currently settable
    const anchorOrigin = $42615ab27a1cc094$var$optionalIconOrigin(flatStyle, prefix + 'anchor-origin');
    const anchorXUnits = $42615ab27a1cc094$var$optionalIconAnchorUnits(flatStyle, prefix + 'anchor-x-units');
    const anchorYUnits = $42615ab27a1cc094$var$optionalIconAnchorUnits(flatStyle, prefix + 'anchor-y-units');
    const colorValue = $42615ab27a1cc094$var$getExpressionValue(flatStyle, prefix + 'color');
    let color;
    let evaluateColor = null;
    if (colorValue !== undefined) {
        const isColorExpression = Array.isArray(colorValue) && colorValue.length > 0 && typeof colorValue[0] === 'string';
        if (isColorExpression) evaluateColor = $42615ab27a1cc094$var$colorLikeEvaluator(flatStyle, prefix + 'color', context);
        else color = $42615ab27a1cc094$var$requireColorLike(colorValue, prefix + 'color');
    }
    const crossOrigin = $42615ab27a1cc094$var$optionalString(flatStyle, prefix + 'cross-origin');
    const offset = $42615ab27a1cc094$var$optionalNumberArray(flatStyle, prefix + 'offset');
    const offsetOrigin = $42615ab27a1cc094$var$optionalIconOrigin(flatStyle, prefix + 'offset-origin');
    const width = $42615ab27a1cc094$var$optionalNumber(flatStyle, prefix + 'width');
    const height = $42615ab27a1cc094$var$optionalNumber(flatStyle, prefix + 'height');
    const size = $42615ab27a1cc094$var$optionalSize(flatStyle, prefix + 'size');
    const declutterMode = $42615ab27a1cc094$var$optionalDeclutterMode(flatStyle, prefix + 'declutter-mode');
    const iconOptions = {
        src: src,
        anchorOrigin: anchorOrigin,
        anchorXUnits: anchorXUnits,
        anchorYUnits: anchorYUnits,
        crossOrigin: crossOrigin,
        offset: offset,
        offsetOrigin: offsetOrigin,
        height: height,
        width: width,
        size: size,
        declutterMode: declutterMode
    };
    let icon = null;
    return function(context) {
        if (!icon) {
            // lazily create the icon to allow for expression evaluation
            const initialColor = evaluateColor ? evaluateColor(context) : color;
            icon = new (0, $39b0ac330ad6f6e7$export$2e2bcd8739ae039)(initialColor !== undefined ? Object.assign({}, iconOptions, {
                color: initialColor
            }) : Object.assign({}, iconOptions));
        } else if (evaluateColor) icon.setColor(evaluateColor(context));
        if (evaluateOpacity) icon.setOpacity(evaluateOpacity(context));
        if (evaluateDisplacement) icon.setDisplacement(evaluateDisplacement(context));
        if (evaluateRotation) icon.setRotation(evaluateRotation(context));
        if (evaluateRotateWithView) icon.setRotateWithView(evaluateRotateWithView(context));
        if (evaluateScale) icon.setScale(evaluateScale(context));
        if (evaluateAnchor) icon.setAnchor(evaluateAnchor(context));
        return icon;
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {ParsingContext} context The parsing context.
 * @return {ImageEvaluator} A function that evaluates to an icon symbolizer.
 */ function $42615ab27a1cc094$var$buildShape(flatStyle, context) {
    const prefix = 'shape-';
    // required property
    const pointsName = prefix + 'points';
    const radiusName = prefix + 'radius';
    const points = $42615ab27a1cc094$var$requireNumber(flatStyle[pointsName], pointsName);
    if (!(radiusName in flatStyle)) throw new Error(`Expected a number for ${radiusName}`);
    const evaluateRadius = $42615ab27a1cc094$var$numberEvaluator(flatStyle, radiusName, context);
    const initialRadius = typeof flatStyle[radiusName] === 'number' ? flatStyle[radiusName] : 5;
    const radius2Name = prefix + 'radius2';
    const evaluateRadius2 = $42615ab27a1cc094$var$numberEvaluator(flatStyle, radius2Name, context);
    const initialRadius2 = typeof flatStyle[radius2Name] === 'number' ? flatStyle[radius2Name] : undefined;
    // settable properties
    const evaluateFill = $42615ab27a1cc094$var$buildFill(flatStyle, prefix, context);
    const evaluateStroke = $42615ab27a1cc094$var$buildStroke(flatStyle, prefix, context);
    const evaluateScale = $42615ab27a1cc094$var$sizeLikeEvaluator(flatStyle, prefix + 'scale', context);
    const evaluateDisplacement = $42615ab27a1cc094$var$coordinateEvaluator(flatStyle, prefix + 'displacement', context);
    const evaluateRotation = $42615ab27a1cc094$var$numberEvaluator(flatStyle, prefix + 'rotation', context);
    const evaluateRotateWithView = $42615ab27a1cc094$var$booleanEvaluator(flatStyle, prefix + 'rotate-with-view', context);
    // the remaining properties are not currently settable
    const angle = $42615ab27a1cc094$var$optionalNumber(flatStyle, prefix + 'angle');
    const declutterMode = $42615ab27a1cc094$var$optionalDeclutterMode(flatStyle, prefix + 'declutter-mode');
    const shape = new (0, $48ca673e38ce3364$export$2e2bcd8739ae039)({
        points: points,
        radius: initialRadius,
        radius2: initialRadius2,
        angle: angle,
        declutterMode: declutterMode
    });
    return function(context) {
        if (evaluateRadius) shape.setRadius(evaluateRadius(context));
        if (evaluateRadius2) shape.setRadius2(evaluateRadius2(context));
        if (evaluateFill) shape.setFill(evaluateFill(context));
        if (evaluateStroke) shape.setStroke(evaluateStroke(context));
        if (evaluateDisplacement) shape.setDisplacement(evaluateDisplacement(context));
        if (evaluateRotation) shape.setRotation(evaluateRotation(context));
        if (evaluateRotateWithView) shape.setRotateWithView(evaluateRotateWithView(context));
        if (evaluateScale) shape.setScale(evaluateScale(context));
        return shape;
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {ParsingContext} context The parsing context.
 * @return {ImageEvaluator} A function that evaluates to a circle symbolizer.
 */ function $42615ab27a1cc094$var$buildCircle(flatStyle, context) {
    const prefix = 'circle-';
    // settable properties
    const evaluateFill = $42615ab27a1cc094$var$buildFill(flatStyle, prefix, context);
    const evaluateStroke = $42615ab27a1cc094$var$buildStroke(flatStyle, prefix, context);
    const evaluateRadius = $42615ab27a1cc094$var$numberEvaluator(flatStyle, prefix + 'radius', context);
    const evaluateScale = $42615ab27a1cc094$var$sizeLikeEvaluator(flatStyle, prefix + 'scale', context);
    const evaluateDisplacement = $42615ab27a1cc094$var$coordinateEvaluator(flatStyle, prefix + 'displacement', context);
    const evaluateRotation = $42615ab27a1cc094$var$numberEvaluator(flatStyle, prefix + 'rotation', context);
    const evaluateRotateWithView = $42615ab27a1cc094$var$booleanEvaluator(flatStyle, prefix + 'rotate-with-view', context);
    // the remaining properties are not currently settable
    const declutterMode = $42615ab27a1cc094$var$optionalDeclutterMode(flatStyle, prefix + 'declutter-mode');
    const circle = new (0, $f060542c6e9f52e6$export$2e2bcd8739ae039)({
        radius: 5,
        declutterMode: declutterMode
    });
    return function(context) {
        if (evaluateRadius) circle.setRadius(evaluateRadius(context));
        if (evaluateFill) circle.setFill(evaluateFill(context));
        if (evaluateStroke) circle.setStroke(evaluateStroke(context));
        if (evaluateDisplacement) circle.setDisplacement(evaluateDisplacement(context));
        if (evaluateRotation) circle.setRotation(evaluateRotation(context));
        if (evaluateRotateWithView) circle.setRotateWithView(evaluateRotateWithView(context));
        if (evaluateScale) circle.setScale(evaluateScale(context));
        return circle;
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @return {any|undefined} The encoded value, or undefined if not provided.
 */ function $42615ab27a1cc094$var$getExpressionValue(flatStyle, name) {
    if (!(name in flatStyle)) return undefined;
    const value = flatStyle[name];
    return value === undefined ? undefined : value;
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').NumberEvaluator|undefined} The expression evaluator or undefined.
 */ function $42615ab27a1cc094$var$numberEvaluator(flatStyle, name, context) {
    const encoded = $42615ab27a1cc094$var$getExpressionValue(flatStyle, name);
    if (encoded === undefined) return undefined;
    const evaluator = (0, $a87b5daadb108525$export$b5f535122a9211f0)(encoded, (0, $026a116c72f030b4$export$86a7aca748b1e260), context);
    return function(context) {
        return $42615ab27a1cc094$var$requireNumber(evaluator(context), name);
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').StringEvaluator?} The expression evaluator.
 */ function $42615ab27a1cc094$var$stringEvaluator(flatStyle, name, context) {
    const encoded = $42615ab27a1cc094$var$getExpressionValue(flatStyle, name);
    if (encoded === undefined) return null;
    const evaluator = (0, $a87b5daadb108525$export$b5f535122a9211f0)(encoded, (0, $026a116c72f030b4$export$2b93044cbf134323), context);
    return function(context) {
        return $42615ab27a1cc094$var$requireString(evaluator(context), name);
    };
}
function $42615ab27a1cc094$var$patternEvaluator(flatStyle, prefix, context) {
    const srcEvaluator = $42615ab27a1cc094$var$stringEvaluator(flatStyle, prefix + 'pattern-src', context);
    const offsetEvaluator = $42615ab27a1cc094$var$sizeEvaluator(flatStyle, prefix + 'pattern-offset', context);
    const patternSizeEvaluator = $42615ab27a1cc094$var$sizeEvaluator(flatStyle, prefix + 'pattern-size', context);
    const colorEvaluator = $42615ab27a1cc094$var$colorLikeEvaluator(flatStyle, prefix + 'color', context);
    return function(context) {
        return {
            src: srcEvaluator(context),
            offset: offsetEvaluator && offsetEvaluator(context),
            size: patternSizeEvaluator && patternSizeEvaluator(context),
            color: colorEvaluator && colorEvaluator(context)
        };
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').BooleanEvaluator?} The expression evaluator.
 */ function $42615ab27a1cc094$var$booleanEvaluator(flatStyle, name, context) {
    const encoded = $42615ab27a1cc094$var$getExpressionValue(flatStyle, name);
    if (encoded === undefined) return null;
    const evaluator = (0, $a87b5daadb108525$export$b5f535122a9211f0)(encoded, (0, $026a116c72f030b4$export$240f7fffab1b25a0), context);
    return function(context) {
        const value = evaluator(context);
        if (typeof value !== 'boolean') throw new Error(`Expected a boolean for ${name}`);
        return value;
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').ColorLikeEvaluator?} The expression evaluator.
 */ function $42615ab27a1cc094$var$colorLikeEvaluator(flatStyle, name, context) {
    const encoded = $42615ab27a1cc094$var$getExpressionValue(flatStyle, name);
    if (encoded === undefined) return null;
    const evaluator = (0, $a87b5daadb108525$export$b5f535122a9211f0)(encoded, (0, $026a116c72f030b4$export$2cd82751acc0e609), context);
    return function(context) {
        return $42615ab27a1cc094$var$requireColorLike(evaluator(context), name);
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').NumberArrayEvaluator?} The expression evaluator.
 */ function $42615ab27a1cc094$var$numberArrayEvaluator(flatStyle, name, context) {
    const encoded = $42615ab27a1cc094$var$getExpressionValue(flatStyle, name);
    if (encoded === undefined) return null;
    if (Array.isArray(encoded) && (encoded.length === 0 || typeof encoded[0] !== 'string')) {
        /** @type {Array<import('../../expr/cpu.js').NumberEvaluator>} */ const evaluators = encoded.map((value, index)=>{
            if (typeof value === 'number') return ()=>value;
            const evaluator = (0, $a87b5daadb108525$export$b5f535122a9211f0)(value, (0, $026a116c72f030b4$export$86a7aca748b1e260), context);
            return function(context) {
                return $42615ab27a1cc094$var$requireNumber(evaluator(context), `${name}[${index}]`);
            };
        });
        return function(context) {
            const array = new Array(evaluators.length);
            for(let i = 0; i < evaluators.length; ++i)array[i] = evaluators[i](context);
            return array;
        };
    }
    const evaluator = (0, $a87b5daadb108525$export$b5f535122a9211f0)(encoded, (0, $026a116c72f030b4$export$d701d0e49f4bcb39), context);
    return function(context) {
        return $42615ab27a1cc094$var$requireNumberArray(evaluator(context), name);
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').CoordinateEvaluator?} The expression evaluator.
 */ function $42615ab27a1cc094$var$coordinateEvaluator(flatStyle, name, context) {
    const encoded = $42615ab27a1cc094$var$getExpressionValue(flatStyle, name);
    if (encoded === undefined) return null;
    const evaluator = (0, $a87b5daadb108525$export$b5f535122a9211f0)(encoded, (0, $026a116c72f030b4$export$d701d0e49f4bcb39), context);
    return function(context) {
        const array = $42615ab27a1cc094$var$requireNumberArray(evaluator(context), name);
        if (array.length !== 2) throw new Error(`Expected two numbers for ${name}`);
        return array;
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').SizeEvaluator?} The expression evaluator.
 */ function $42615ab27a1cc094$var$sizeEvaluator(flatStyle, name, context) {
    const encoded = $42615ab27a1cc094$var$getExpressionValue(flatStyle, name);
    if (encoded === undefined) return null;
    const evaluator = (0, $a87b5daadb108525$export$b5f535122a9211f0)(encoded, (0, $026a116c72f030b4$export$d701d0e49f4bcb39), context);
    return function(context) {
        return $42615ab27a1cc094$var$requireSize(evaluator(context), name);
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').SizeLikeEvaluator?} The expression evaluator.
 */ function $42615ab27a1cc094$var$sizeLikeEvaluator(flatStyle, name, context) {
    const encoded = $42615ab27a1cc094$var$getExpressionValue(flatStyle, name);
    if (encoded === undefined) return null;
    const evaluator = (0, $a87b5daadb108525$export$b5f535122a9211f0)(encoded, (0, $026a116c72f030b4$export$d701d0e49f4bcb39) | (0, $026a116c72f030b4$export$86a7aca748b1e260), context);
    return function(context) {
        return $42615ab27a1cc094$var$requireSizeLike(evaluator(context), name);
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {number|undefined} A number or undefined.
 */ function $42615ab27a1cc094$var$optionalNumber(flatStyle, property) {
    const value = flatStyle[property];
    if (value === undefined) return undefined;
    if (typeof value !== 'number') throw new Error(`Expected a number for ${property}`);
    return value;
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {import("../../size.js").Size|undefined} A size or undefined.
 */ function $42615ab27a1cc094$var$optionalSize(flatStyle, property) {
    const encoded = flatStyle[property];
    if (encoded === undefined) return undefined;
    if (typeof encoded === 'number') return (0, $625e418aeada4c0d$export$a71a825ff42fb8e1)(encoded);
    if (!Array.isArray(encoded)) throw new Error(`Expected a number or size array for ${property}`);
    if (encoded.length !== 2 || typeof encoded[0] !== 'number' || typeof encoded[1] !== 'number') throw new Error(`Expected a number or size array for ${property}`);
    return encoded;
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {string|undefined} A string or undefined.
 */ function $42615ab27a1cc094$var$optionalString(flatStyle, property) {
    const encoded = flatStyle[property];
    if (encoded === undefined) return undefined;
    if (typeof encoded !== 'string') throw new Error(`Expected a string for ${property}`);
    return encoded;
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {import("../../style/Icon.js").IconOrigin|undefined} An icon origin or undefined.
 */ function $42615ab27a1cc094$var$optionalIconOrigin(flatStyle, property) {
    const encoded = flatStyle[property];
    if (encoded === undefined) return undefined;
    if (encoded !== 'bottom-left' && encoded !== 'bottom-right' && encoded !== 'top-left' && encoded !== 'top-right') throw new Error(`Expected bottom-left, bottom-right, top-left, or top-right for ${property}`);
    return encoded;
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {import("../../style/Icon.js").IconAnchorUnits|undefined} Icon anchor units or undefined.
 */ function $42615ab27a1cc094$var$optionalIconAnchorUnits(flatStyle, property) {
    const encoded = flatStyle[property];
    if (encoded === undefined) return undefined;
    if (encoded !== 'pixels' && encoded !== 'fraction') throw new Error(`Expected pixels or fraction for ${property}`);
    return encoded;
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {Array<number>|undefined} An array of numbers or undefined.
 */ function $42615ab27a1cc094$var$optionalNumberArray(flatStyle, property) {
    const encoded = flatStyle[property];
    if (encoded === undefined) return undefined;
    return $42615ab27a1cc094$var$requireNumberArray(encoded, property);
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {import('../../style/Style.js').DeclutterMode} Icon declutter mode.
 */ function $42615ab27a1cc094$var$optionalDeclutterMode(flatStyle, property) {
    const encoded = flatStyle[property];
    if (encoded === undefined) return undefined;
    if (typeof encoded !== 'string') throw new Error(`Expected a string for ${property}`);
    if (encoded !== 'declutter' && encoded !== 'obstacle' && encoded !== 'none') throw new Error(`Expected declutter, obstacle, or none for ${property}`);
    return encoded;
}
/**
 * @param {any} value The value.
 * @param {string} property The property.
 * @return {Array<number>} An array of numbers.
 */ function $42615ab27a1cc094$var$requireNumberArray(value, property) {
    if (!Array.isArray(value)) throw new Error(`Expected an array for ${property}`);
    const length = value.length;
    for(let i = 0; i < length; ++i){
        if (typeof value[i] !== 'number') throw new Error(`Expected an array of numbers for ${property}`);
    }
    return value;
}
/**
 * @param {any} value The value.
 * @param {string} property The property.
 * @return {string} A string.
 */ function $42615ab27a1cc094$var$requireString(value, property) {
    if (typeof value !== 'string') throw new Error(`Expected a string for ${property}`);
    return value;
}
/**
 * @param {any} value The value.
 * @param {string} property The property.
 * @return {number} A number.
 */ function $42615ab27a1cc094$var$requireNumber(value, property) {
    if (typeof value !== 'number') throw new Error(`Expected a number for ${property}`);
    return value;
}
/**
 * @param {any} value The value.
 * @param {string} property The property.
 * @return {Array<number>|string} A color.
 */ function $42615ab27a1cc094$var$requireColorLike(value, property) {
    if (typeof value === 'string') return value;
    const array = $42615ab27a1cc094$var$requireNumberArray(value, property);
    const length = array.length;
    if (length < 3 || length > 4) throw new Error(`Expected a color with 3 or 4 values for ${property}`);
    return array;
}
/**
 * @param {any} value The value.
 * @param {string} property The property.
 * @return {Array<number>} A number or an array of two numbers.
 */ function $42615ab27a1cc094$var$requireSize(value, property) {
    const size = $42615ab27a1cc094$var$requireNumberArray(value, property);
    if (size.length !== 2) throw new Error(`Expected an array of two numbers for ${property}`);
    return size;
}
/**
 * @param {any} value The value.
 * @param {string} property The property.
 * @return {number|Array<number>} A number or an array of two numbers.
 */ function $42615ab27a1cc094$var$requireSizeLike(value, property) {
    if (typeof value === 'number') return value;
    return $42615ab27a1cc094$var$requireSize(value, property);
}




/***
 * @template T
 * @typedef {T extends import("../source/Vector.js").default<infer U extends import("../Feature.js").FeatureLike> ? U : never} ExtractedFeatureType
 */ /**
 * @template {import('../Feature').FeatureLike} FeatureType
 * @template {import("../source/Vector.js").default<FeatureType>|import("../source/VectorTile.js").default<FeatureType>} VectorSourceType<FeatureType>
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {import("../render.js").OrderFunction} [renderOrder] Render order. Function to be used when sorting
 * features before rendering. By default features are drawn in the order that they are created. Use
 * `null` to avoid the sort, but get an undefined draw order.
 * @property {number} [renderBuffer=100] The buffer in pixels around the viewport extent used by the
 * renderer when getting features from the vector source for the rendering or hit-detection.
 * Recommended value: the size of the largest symbol, line width or label.
 * @property {VectorSourceType} [source] Source.
 * @property {import("../Map.js").default} [map] Sets the layer as overlay on a map. The map will not manage
 * this layer in its layers collection, and the layer will be rendered on top. This is useful for
 * temporary layers. The standard way to add a layer to a map and have it managed by the map is to
 * use [map.addLayer()]{@link import("../Map.js").default#addLayer}.
 * @property {boolean|string|number} [declutter=false] Declutter images and text. Any truthy value will enable
 * decluttering. Within a layer, a feature rendered before another has higher priority. All layers with the
 * same `declutter` value will be decluttered together. The priority is determined by the drawing order of the
 * layers with the same `declutter` value. Higher in the layer stack means higher priority. To declutter distinct
 * layers or groups of layers separately, use different truthy values for `declutter`.
 * @property {import("../style/Style.js").StyleLike|import("../style/flat.js").FlatStyleLike|null} [style] Layer style. When set to `null`, only
 * features that have their own style will be rendered. See {@link module:ol/style/Style~Style} for the default style
 * which will be used if this is not set.
 * @property {import("./Base.js").BackgroundColor} [background] Background color for the layer. If not specified, no background
 * will be rendered.
 * @property {boolean} [updateWhileAnimating=false] When set to `true`, feature batches will
 * be recreated during animations. This means that no vectors will be shown clipped, but the
 * setting will have a performance impact for large amounts of vector data. When set to `false`,
 * batches will be recreated when no animation is active.
 * @property {boolean} [updateWhileInteracting=false] When set to `true`, feature batches will
 * be recreated during interactions. See also `updateWhileAnimating`.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */ /**
 * @enum {string}
 * @private
 */ const $56912d183e066438$var$Property = {
    RENDER_ORDER: 'renderOrder'
};
/**
 * @classdesc
 * Vector data that is rendered client-side.
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @template {import('../Feature').FeatureLike} FeatureType
 * @template {import("../source/Vector.js").default<FeatureType>|import("../source/VectorTile.js").default<FeatureType>} VectorSourceType<FeatureType>
 * @extends {Layer<VectorSourceType, RendererType>}
 * @template {import("../renderer/canvas/VectorLayer.js").default|import("../renderer/canvas/VectorTileLayer.js").default|import("../renderer/canvas/VectorImageLayer.js").default|import("../renderer/webgl/VectorLayer.js").default|import("../renderer/webgl/PointsLayer.js").default} RendererType
 * @api
 */ class $56912d183e066438$var$BaseVectorLayer extends (0, $af81f8f05dcf2037$export$2e2bcd8739ae039) {
    /**
   * @param {Options<FeatureType, VectorSourceType>} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        const baseOptions = Object.assign({}, options);
        delete baseOptions.style;
        delete baseOptions.renderBuffer;
        delete baseOptions.updateWhileAnimating;
        delete baseOptions.updateWhileInteracting;
        super(baseOptions);
        /**
     * @private
     * @type {string}
     */ this.declutter_ = options.declutter ? String(options.declutter) : undefined;
        /**
     * @type {number}
     * @private
     */ this.renderBuffer_ = options.renderBuffer !== undefined ? options.renderBuffer : 100;
        /**
     * User provided style.
     * @type {import("../style/Style.js").StyleLike|import("../style/flat.js").FlatStyleLike}
     * @private
     */ this.style_ = null;
        /**
     * Style function for use within the library.
     * @type {import("../style/Style.js").StyleFunction|undefined}
     * @private
     */ this.styleFunction_ = undefined;
        this.setStyle(options.style);
        /**
     * @type {boolean}
     * @private
     */ this.updateWhileAnimating_ = options.updateWhileAnimating !== undefined ? options.updateWhileAnimating : false;
        /**
     * @type {boolean}
     * @private
     */ this.updateWhileInteracting_ = options.updateWhileInteracting !== undefined ? options.updateWhileInteracting : false;
    }
    /**
   * @return {string} Declutter group.
   * @override
   */ getDeclutter() {
        return this.declutter_;
    }
    /**
   * Get the topmost feature that intersects the given pixel on the viewport. Returns a promise
   * that resolves with an array of features. The array will either contain the topmost feature
   * when a hit was detected, or it will be empty.
   *
   * The hit detection algorithm used for this method is optimized for performance, but is less
   * accurate than the one used in [map.getFeaturesAtPixel()]{@link import("../Map.js").default#getFeaturesAtPixel}.
   * Text is not considered, and icons are only represented by their bounding box instead of the exact
   * image.
   *
   * @param {import("../pixel.js").Pixel} pixel Pixel.
   * @return {Promise<Array<import("../Feature").FeatureLike>>} Promise that resolves with an array of features.
   * @api
   * @override
   */ getFeatures(pixel) {
        return super.getFeatures(pixel);
    }
    /**
   * @return {number|undefined} Render buffer.
   */ getRenderBuffer() {
        return this.renderBuffer_;
    }
    /**
   * @return {import("../render.js").OrderFunction|null|undefined} Render order.
   */ getRenderOrder() {
        return /** @type {import("../render.js").OrderFunction|null|undefined} */ this.get($56912d183e066438$var$Property.RENDER_ORDER);
    }
    /**
   * Get the style for features.  This returns whatever was passed to the `style`
   * option at construction or to the `setStyle` method.
   * @return {import("../style/Style.js").StyleLike|import("../style/flat.js").FlatStyleLike|null|undefined} Layer style.
   * @api
   */ getStyle() {
        return this.style_;
    }
    /**
   * Get the style function.
   * @return {import("../style/Style.js").StyleFunction|undefined} Layer style function.
   * @api
   */ getStyleFunction() {
        return this.styleFunction_;
    }
    /**
   * @return {boolean} Whether the rendered layer should be updated while
   *     animating.
   */ getUpdateWhileAnimating() {
        return this.updateWhileAnimating_;
    }
    /**
   * @return {boolean} Whether the rendered layer should be updated while
   *     interacting.
   */ getUpdateWhileInteracting() {
        return this.updateWhileInteracting_;
    }
    /**
   * Render declutter items for this layer
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @param {import("../layer/Layer.js").State} layerState Layer state.
   * @override
   */ renderDeclutter(frameState, layerState) {
        const declutterGroup = this.getDeclutter();
        if (declutterGroup in frameState.declutter === false) frameState.declutter[declutterGroup] = new (0, $fb66a48cf2a65dd1$export$2e2bcd8739ae039)(9);
        this.getRenderer().renderDeclutter(frameState, layerState);
    }
    /**
   * @param {import("../render.js").OrderFunction|null|undefined} renderOrder
   *     Render order.
   */ setRenderOrder(renderOrder) {
        this.set($56912d183e066438$var$Property.RENDER_ORDER, renderOrder);
    }
    /**
   * Set the style for features.  This can be a single style object, an array
   * of styles, or a function that takes a feature and resolution and returns
   * an array of styles. If set to `null`, the layer has no style (a `null` style),
   * so only features that have their own styles will be rendered in the layer. Call
   * `setStyle()` without arguments to reset to the default style. See
   * [the ol/style/Style module]{@link module:ol/style/Style~Style} for information on the default style.
   *
   * If your layer has a static style, you can use [flat style]{@link module:ol/style/flat~FlatStyle} object
   * literals instead of using the `Style` and symbolizer constructors (`Fill`, `Stroke`, etc.):
   * ```js
   * vectorLayer.setStyle({
   *   "fill-color": "yellow",
   *   "stroke-color": "black",
   *   "stroke-width": 4
   * })
   * ```
   *
   * @param {import("../style/Style.js").StyleLike|import("../style/flat.js").FlatStyleLike|null} [style] Layer style.
   * @api
   */ setStyle(style) {
        this.style_ = style === undefined ? (0, $a5fc261473972d1d$export$6865c5ac2f5ce8b6) : style;
        const styleLike = $56912d183e066438$var$toStyleLike(style);
        this.styleFunction_ = style === null ? undefined : (0, $a5fc261473972d1d$export$c314ea3f6b164147)(styleLike);
        this.changed();
    }
    /**
   * @param {boolean|string|number} declutter Declutter images and text.
   * @api
   */ setDeclutter(declutter) {
        this.declutter_ = declutter ? String(declutter) : undefined;
        this.changed();
    }
}
/**
 * Coerce the allowed style types into a shorter list of types.  Flat styles, arrays of flat
 * styles, and arrays of rules are converted into style functions.
 *
 * @param {import("../style/Style.js").StyleLike|import("../style/flat.js").FlatStyleLike|null} [style] Layer style.
 * @return {import("../style/Style.js").StyleLike|null} The style.
 */ function $56912d183e066438$var$toStyleLike(style) {
    if (style === undefined) return 0, $a5fc261473972d1d$export$6865c5ac2f5ce8b6;
    if (!style) return null;
    if (typeof style === 'function') return style;
    if (style instanceof (0, $a5fc261473972d1d$export$2e2bcd8739ae039)) return style;
    if (!Array.isArray(style)) return (0, $42615ab27a1cc094$export$5a130bc4f0a0420b)([
        style
    ]);
    if (style.length === 0) return [];
    const length = style.length;
    const first = style[0];
    if (first instanceof (0, $a5fc261473972d1d$export$2e2bcd8739ae039)) {
        /**
     * @type {Array<Style>}
     */ const styles = new Array(length);
        for(let i = 0; i < length; ++i){
            const candidate = style[i];
            if (!(candidate instanceof (0, $a5fc261473972d1d$export$2e2bcd8739ae039))) throw new Error('Expected a list of style instances');
            styles[i] = candidate;
        }
        return styles;
    }
    if ('style' in first) {
        /**
     * @type {Array<import("../style/flat.js").Rule>}
     */ const rules = new Array(length);
        for(let i = 0; i < length; ++i){
            const candidate = style[i];
            if (!('style' in candidate)) throw new Error('Expected a list of rules with a style property');
            rules[i] = candidate;
        }
        return (0, $42615ab27a1cc094$export$fc6a94152b1b05a8)(rules);
    }
    const flatStyles = /** @type {Array<import("../style/flat.js").FlatStyle>} */ style;
    return (0, $42615ab27a1cc094$export$5a130bc4f0a0420b)(flatStyles);
}
var $56912d183e066438$export$2e2bcd8739ae039 = $56912d183e066438$var$BaseVectorLayer;


/**
 * @template {import("../source/Vector.js").default<FeatureType>} [VectorSourceType=import("../source/Vector.js").default<*>]
 * @template {import('../Feature.js').FeatureLike} [FeatureType=import("./BaseVector.js").ExtractedFeatureType<VectorSourceType>]
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {import("../render.js").OrderFunction} [renderOrder] Render order. Function to be used when sorting
 * features before rendering. By default features are drawn in the order that they are created. Use
 * `null` to avoid the sort, but get an undefined draw order.
 * @property {number} [renderBuffer=100] The buffer in pixels around the viewport extent used by the
 * renderer when getting features from the vector source for the rendering or hit-detection.
 * Recommended value: the size of the largest symbol, line width or label.
 * @property {VectorSourceType} [source] Source.
 * @property {import("../Map.js").default} [map] Sets the layer as overlay on a map. The map will not manage
 * this layer in its layers collection, and the layer will be rendered on top. This is useful for
 * temporary layers. The standard way to add a layer to a map and have it managed by the map is to
 * use [map.addLayer()]{@link import("../Map.js").default#addLayer}.
 * @property {boolean|string|number} [declutter=false] Declutter images and text. Any truthy value will enable
 * decluttering. Within a layer, a feature rendered before another has higher priority. All layers with the
 * same `declutter` value will be decluttered together. The priority is determined by the drawing order of the
 * layers with the same `declutter` value. Higher in the layer stack means higher priority. To declutter distinct
 * layers or groups of layers separately, use different truthy values for `declutter`.
 * @property {import("../style/Style.js").StyleLike|import("../style/flat.js").FlatStyleLike|null} [style] Layer style. When set to `null`, only
 * features that have their own style will be rendered. See {@link module:ol/style/Style~Style} for the default style
 * which will be used if this is not set.
 * @property {import("./Base.js").BackgroundColor} [background] Background color for the layer. If not specified, no background
 * will be rendered.
 * @property {boolean} [updateWhileAnimating=false] When set to `true`, feature batches will
 * be recreated during animations. This means that no vectors will be shown clipped, but the
 * setting will have a performance impact for large amounts of vector data. When set to `false`,
 * batches will be recreated when no animation is active.
 * @property {boolean} [updateWhileInteracting=false] When set to `true`, feature batches will
 * be recreated during interactions. See also `updateWhileAnimating`.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */ /**
 * @classdesc
 * Vector data is rendered client-side, as vectors. This layer type provides most accurate rendering
 * even during animations. Points and labels stay upright on rotated views. For very large
 * amounts of vector data, performance may suffer during pan and zoom animations. In this case,
 * try {@link module:ol/layer/VectorImage~VectorImageLayer}.
 *
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @template {import("../source/Vector.js").default<FeatureType>} [VectorSourceType=import("../source/Vector.js").default<*>]
 * @template {import('../Feature.js').FeatureLike} [FeatureType=import("./BaseVector.js").ExtractedFeatureType<VectorSourceType>]
 * @extends {BaseVectorLayer<FeatureType, VectorSourceType, CanvasVectorLayerRenderer>}
 * @api
 */ class $082a79ecb622f84a$var$VectorLayer extends (0, $56912d183e066438$export$2e2bcd8739ae039) {
    /**
   * @param {Options<VectorSourceType, FeatureType>} [options] Options.
   */ constructor(options){
        super(options);
    }
    /**
   * @override
   */ createRenderer() {
        return new (0, $c0bb897062f275b7$export$2e2bcd8739ae039)(this);
    }
}
var $082a79ecb622f84a$export$2e2bcd8739ae039 = $082a79ecb622f84a$var$VectorLayer;


/**
 * @module ol/loadingstrategy
 */ 
function $6a8cacaa690463df$export$84bf76cd7afc7469(extent, resolution) {
    return [
        [
            -Infinity,
            -Infinity,
            Infinity,
            Infinity
        ]
    ];
}
function $6a8cacaa690463df$export$bf67010aacbe66fa(extent, resolution) {
    return [
        extent
    ];
}
function $6a8cacaa690463df$export$3c17558da18e4d75(tileGrid) {
    return(/**
     * @param {import("./extent.js").Extent} extent Extent.
     * @param {number} resolution Resolution.
     * @param {import("./proj.js").Projection} projection Projection.
     * @return {Array<import("./extent.js").Extent>} Extents.
     */ function(extent, resolution, projection) {
        const z = tileGrid.getZForResolution((0, $a86eee1c28205a05$export$bd1cd3b88140b906)(resolution, projection));
        const tileRange = tileGrid.getTileRangeForExtentAndZ((0, $a86eee1c28205a05$export$494be3a3a25689ca)(extent, projection), z);
        /** @type {Array<import("./extent.js").Extent>} */ const extents = [];
        /** @type {import("./tilecoord.js").TileCoord} */ const tileCoord = [
            z,
            0,
            0
        ];
        for(tileCoord[1] = tileRange.minX; tileCoord[1] <= tileRange.maxX; ++tileCoord[1])for(tileCoord[2] = tileRange.minY; tileCoord[2] <= tileRange.maxY; ++tileCoord[2])extents.push((0, $a86eee1c28205a05$export$96bfd09e2cffb006)(tileGrid.getTileCoordExtent(tileCoord), projection));
        return extents;
    });
}


/**
 * @module ol/Map
 */ 

/**
 * @module ol/MapBrowserEvent
 */ /**
 * @module ol/MapEvent
 */ 
/**
 * @classdesc
 * Events emitted as map events are instances of this type.
 * See {@link module:ol/Map~Map} for which events trigger a map event.
 */ class $e44c6b7d9bfa1ac8$var$MapEvent extends (0, $5c6b0a43c077a98f$export$2e2bcd8739ae039) {
    /**
   * @param {string} type Event type.
   * @param {import("./Map.js").default} map Map.
   * @param {?import("./Map.js").FrameState} [frameState] Frame state.
   */ constructor(type, map, frameState){
        super(type);
        /**
     * The map where the event occurred.
     * @type {import("./Map.js").default}
     * @api
     */ this.map = map;
        /**
     * The frame state at the time of the event.
     * @type {?import("./Map.js").FrameState}
     * @api
     */ this.frameState = frameState !== undefined ? frameState : null;
    }
}
var $e44c6b7d9bfa1ac8$export$2e2bcd8739ae039 = $e44c6b7d9bfa1ac8$var$MapEvent;


/**
 * @classdesc
 * Events emitted as map browser events are instances of this type.
 * See {@link module:ol/Map~Map} for which events trigger a map browser event.
 * @template {PointerEvent|KeyboardEvent|WheelEvent} [EVENT=PointerEvent|KeyboardEvent|WheelEvent]
 */ class $1e9a92005e196af9$var$MapBrowserEvent extends (0, $e44c6b7d9bfa1ac8$export$2e2bcd8739ae039) {
    /**
   * @param {string} type Event type.
   * @param {import("./Map.js").default} map Map.
   * @param {EVENT} originalEvent Original event.
   * @param {boolean} [dragging] Is the map currently being dragged?
   * @param {import("./Map.js").FrameState} [frameState] Frame state.
   * @param {Array<PointerEvent>} [activePointers] Active pointers.
   */ constructor(type, map, originalEvent, dragging, frameState, activePointers){
        super(type, map, frameState);
        /**
     * The original browser event.
     * @const
     * @type {EVENT}
     * @api
     */ this.originalEvent = originalEvent;
        /**
     * The map pixel relative to the viewport corresponding to the original browser event.
     * @type {?import("./pixel.js").Pixel}
     * @private
     */ this.pixel_ = null;
        /**
     * The coordinate in the user projection corresponding to the original browser event.
     * @type {?import("./coordinate.js").Coordinate}
     * @private
     */ this.coordinate_ = null;
        /**
     * Indicates if the map is currently being dragged. Only set for
     * `POINTERDRAG` and `POINTERMOVE` events. Default is `false`.
     *
     * @type {boolean}
     * @api
     */ this.dragging = dragging !== undefined ? dragging : false;
        /**
     * @type {Array<PointerEvent>|undefined}
     */ this.activePointers = activePointers;
    }
    /**
   * The map pixel relative to the viewport corresponding to the original event.
   * @type {import("./pixel.js").Pixel}
   * @api
   */ get pixel() {
        if (!this.pixel_) this.pixel_ = this.map.getEventPixel(this.originalEvent);
        return this.pixel_;
    }
    set pixel(pixel) {
        this.pixel_ = pixel;
    }
    /**
   * The coordinate corresponding to the original browser event.  This will be in the user
   * projection if one is set.  Otherwise it will be in the view projection.
   * @type {import("./coordinate.js").Coordinate}
   * @api
   */ get coordinate() {
        if (!this.coordinate_) this.coordinate_ = this.map.getCoordinateFromPixel(this.pixel);
        return this.coordinate_;
    }
    set coordinate(coordinate) {
        this.coordinate_ = coordinate;
    }
    /**
   * Prevents the default browser action.
   * See https://developer.mozilla.org/en-US/docs/Web/API/event.preventDefault.
   * @api
   * @override
   */ preventDefault() {
        super.preventDefault();
        if ('preventDefault' in this.originalEvent) /** @type {UIEvent} */ this.originalEvent.preventDefault();
    }
    /**
   * Prevents further propagation of the current event.
   * See https://developer.mozilla.org/en-US/docs/Web/API/event.stopPropagation.
   * @api
   * @override
   */ stopPropagation() {
        super.stopPropagation();
        if ('stopPropagation' in this.originalEvent) /** @type {UIEvent} */ this.originalEvent.stopPropagation();
    }
}
var $1e9a92005e196af9$export$2e2bcd8739ae039 = $1e9a92005e196af9$var$MapBrowserEvent;


/**
 * @module ol/MapBrowserEventHandler
 */ 






class $22122345cac37f85$var$MapBrowserEventHandler extends (0, $272b64a21016b61a$export$2e2bcd8739ae039) {
    /**
   * @param {import("./Map.js").default} map The map with the viewport to listen to events on.
   * @param {number} [moveTolerance] The minimal distance the pointer must travel to trigger a move.
   */ constructor(map, moveTolerance){
        super(map);
        /**
     * This is the element that we will listen to the real events on.
     * @type {import("./Map.js").default}
     * @private
     */ this.map_ = map;
        /**
     * @type {ReturnType<typeof setTimeout>}
     * @private
     */ this.clickTimeoutId_;
        /**
     * Emulate dblclick and singleclick. Will be true when only one pointer is active.
     * @type {boolean}
     */ this.emulateClicks_ = false;
        /**
     * @type {boolean}
     * @private
     */ this.dragging_ = false;
        /**
     * @type {!Array<import("./events.js").EventsKey>}
     * @private
     */ this.dragListenerKeys_ = [];
        /**
     * @type {number}
     * @private
     */ this.moveTolerance_ = moveTolerance === undefined ? 1 : moveTolerance;
        /**
     * The most recent "down" type event (or null if none have occurred).
     * Set on pointerdown.
     * @type {PointerEvent|null}
     * @private
     */ this.down_ = null;
        const element = this.map_.getViewport();
        /**
     * @type {Array<PointerEvent>}
     * @private
     */ this.activePointers_ = [];
        /**
     * @type {!Object<number, Event>}
     * @private
     */ this.trackedTouches_ = {};
        /**
     * @private
     */ this.element_ = element;
        /**
     * @type {?import("./events.js").EventsKey}
     * @private
     */ this.pointerdownListenerKey_ = (0, $63963d09e0c49405$export$63174c828edd6ff8)(element, (0, $4b8b28c70a4b5328$export$2e2bcd8739ae039).POINTERDOWN, this.handlePointerDown_, this);
        /**
     * @type {PointerEvent}
     * @private
     */ this.originalPointerMoveEvent_;
        /**
     * @type {?import("./events.js").EventsKey}
     * @private
     */ this.relayedListenerKey_ = (0, $63963d09e0c49405$export$63174c828edd6ff8)(element, (0, $4b8b28c70a4b5328$export$2e2bcd8739ae039).POINTERMOVE, this.relayMoveEvent_, this);
        /**
     * @private
     */ this.boundHandleTouchMove_ = this.handleTouchMove_.bind(this);
        this.element_.addEventListener((0, $b5fa963342da4935$export$2e2bcd8739ae039).TOUCHMOVE, this.boundHandleTouchMove_, (0, $32d41268b5f53567$export$f751ce96c6c4e4fc) ? {
            passive: false
        } : false);
    }
    /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */ emulateClick_(pointerEvent) {
        let newEvent = new (0, $1e9a92005e196af9$export$2e2bcd8739ae039)((0, $1b4cb51f4587f284$export$2e2bcd8739ae039).CLICK, this.map_, pointerEvent);
        this.dispatchEvent(newEvent);
        if (this.clickTimeoutId_ !== undefined) {
            // double-click
            clearTimeout(this.clickTimeoutId_);
            this.clickTimeoutId_ = undefined;
            newEvent = new (0, $1e9a92005e196af9$export$2e2bcd8739ae039)((0, $1b4cb51f4587f284$export$2e2bcd8739ae039).DBLCLICK, this.map_, pointerEvent);
            this.dispatchEvent(newEvent);
        } else // click
        this.clickTimeoutId_ = setTimeout(()=>{
            this.clickTimeoutId_ = undefined;
            const newEvent = new (0, $1e9a92005e196af9$export$2e2bcd8739ae039)((0, $1b4cb51f4587f284$export$2e2bcd8739ae039).SINGLECLICK, this.map_, pointerEvent);
            this.dispatchEvent(newEvent);
        }, 250);
    }
    /**
   * Keeps track on how many pointers are currently active.
   *
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */ updateActivePointers_(pointerEvent) {
        const event = pointerEvent;
        const id = event.pointerId;
        if (event.type == (0, $1b4cb51f4587f284$export$2e2bcd8739ae039).POINTERUP || event.type == (0, $1b4cb51f4587f284$export$2e2bcd8739ae039).POINTERCANCEL) {
            delete this.trackedTouches_[id];
            for(const pointerId in this.trackedTouches_)if (this.trackedTouches_[pointerId].target !== event.target) {
                // Some platforms assign a new pointerId when the target changes.
                // If this happens, delete one tracked pointer. If there is more
                // than one tracked pointer for the old target, it will be cleared
                // by subsequent POINTERUP events from other pointers.
                delete this.trackedTouches_[pointerId];
                break;
            }
        } else if (event.type == (0, $1b4cb51f4587f284$export$2e2bcd8739ae039).POINTERDOWN || event.type == (0, $1b4cb51f4587f284$export$2e2bcd8739ae039).POINTERMOVE) this.trackedTouches_[id] = event;
        this.activePointers_ = Object.values(this.trackedTouches_);
    }
    /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */ handlePointerUp_(pointerEvent) {
        this.updateActivePointers_(pointerEvent);
        const newEvent = new (0, $1e9a92005e196af9$export$2e2bcd8739ae039)((0, $1b4cb51f4587f284$export$2e2bcd8739ae039).POINTERUP, this.map_, pointerEvent, undefined, undefined, this.activePointers_);
        this.dispatchEvent(newEvent);
        // We emulate click events on left mouse button click, touch contact, and pen
        // contact. isMouseActionButton returns true in these cases (evt.button is set
        // to 0).
        // See http://www.w3.org/TR/pointerevents/#button-states
        // We only fire click, singleclick, and doubleclick if nobody has called
        // event.preventDefault().
        if (this.emulateClicks_ && !newEvent.defaultPrevented && !this.dragging_ && this.isMouseActionButton_(pointerEvent)) this.emulateClick_(this.down_);
        if (this.activePointers_.length === 0) {
            this.dragListenerKeys_.forEach((0, $63963d09e0c49405$export$b0a21c8b3c1c921));
            this.dragListenerKeys_.length = 0;
            this.dragging_ = false;
            this.down_ = null;
        }
    }
    /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @return {boolean} If the left mouse button was pressed.
   * @private
   */ isMouseActionButton_(pointerEvent) {
        return pointerEvent.button === 0;
    }
    /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */ handlePointerDown_(pointerEvent) {
        this.emulateClicks_ = this.activePointers_.length === 0;
        this.updateActivePointers_(pointerEvent);
        const newEvent = new (0, $1e9a92005e196af9$export$2e2bcd8739ae039)((0, $1b4cb51f4587f284$export$2e2bcd8739ae039).POINTERDOWN, this.map_, pointerEvent, undefined, undefined, this.activePointers_);
        this.dispatchEvent(newEvent);
        this.down_ = new PointerEvent(pointerEvent.type, pointerEvent);
        Object.defineProperty(this.down_, 'target', {
            writable: false,
            value: pointerEvent.target
        });
        if (this.dragListenerKeys_.length === 0) {
            const doc = this.map_.getOwnerDocument();
            this.dragListenerKeys_.push((0, $63963d09e0c49405$export$63174c828edd6ff8)(doc, (0, $1b4cb51f4587f284$export$2e2bcd8739ae039).POINTERMOVE, this.handlePointerMove_, this), (0, $63963d09e0c49405$export$63174c828edd6ff8)(doc, (0, $1b4cb51f4587f284$export$2e2bcd8739ae039).POINTERUP, this.handlePointerUp_, this), /* Note that the listener for `pointercancel is set up on
         * `pointerEventHandler_` and not `documentPointerEventHandler_` like
         * the `pointerup` and `pointermove` listeners.
         *
         * The reason for this is the following: `TouchSource.vacuumTouches_()`
         * issues `pointercancel` events, when there was no `touchend` for a
         * `touchstart`. Now, let's say a first `touchstart` is registered on
         * `pointerEventHandler_`. The `documentPointerEventHandler_` is set up.
         * But `documentPointerEventHandler_` doesn't know about the first
         * `touchstart`. If there is no `touchend` for the `touchstart`, we can
         * only receive a `touchcancel` from `pointerEventHandler_`, because it is
         * only registered there.
         */ (0, $63963d09e0c49405$export$63174c828edd6ff8)(this.element_, (0, $1b4cb51f4587f284$export$2e2bcd8739ae039).POINTERCANCEL, this.handlePointerUp_, this));
            if (this.element_.getRootNode && this.element_.getRootNode() !== doc) this.dragListenerKeys_.push((0, $63963d09e0c49405$export$63174c828edd6ff8)(this.element_.getRootNode(), (0, $1b4cb51f4587f284$export$2e2bcd8739ae039).POINTERUP, this.handlePointerUp_, this));
        }
    }
    /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */ handlePointerMove_(pointerEvent) {
        // Between pointerdown and pointerup, pointermove events are triggered.
        // To avoid a 'false' touchmove event to be dispatched, we test if the pointer
        // moved a significant distance.
        if (this.isMoving_(pointerEvent)) {
            this.updateActivePointers_(pointerEvent);
            this.dragging_ = true;
            const newEvent = new (0, $1e9a92005e196af9$export$2e2bcd8739ae039)((0, $1b4cb51f4587f284$export$2e2bcd8739ae039).POINTERDRAG, this.map_, pointerEvent, this.dragging_, undefined, this.activePointers_);
            this.dispatchEvent(newEvent);
        }
    }
    /**
   * Wrap and relay a pointermove event.
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */ relayMoveEvent_(pointerEvent) {
        this.originalPointerMoveEvent_ = pointerEvent;
        const dragging = !!(this.down_ && this.isMoving_(pointerEvent));
        this.dispatchEvent(new (0, $1e9a92005e196af9$export$2e2bcd8739ae039)((0, $1b4cb51f4587f284$export$2e2bcd8739ae039).POINTERMOVE, this.map_, pointerEvent, dragging));
    }
    /**
   * Flexible handling of a `touch-action: none` css equivalent: because calling
   * `preventDefault()` on a `pointermove` event does not stop native page scrolling
   * and zooming, we also listen for `touchmove` and call `preventDefault()` on it
   * when an interaction (currently `DragPan` handles the event.
   * @param {TouchEvent} event Event.
   * @private
   */ handleTouchMove_(event) {
        // Due to https://github.com/mpizenberg/elm-pep/issues/2, `this.originalPointerMoveEvent_`
        // may not be initialized yet when we get here on a platform without native pointer events,
        // when elm-pep is used as pointer events polyfill.
        const originalEvent = this.originalPointerMoveEvent_;
        if ((!originalEvent || originalEvent.defaultPrevented) && (typeof event.cancelable !== 'boolean' || event.cancelable === true)) event.preventDefault();
    }
    /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @return {boolean} Is moving.
   * @private
   */ isMoving_(pointerEvent) {
        return this.dragging_ || Math.abs(pointerEvent.clientX - this.down_.clientX) > this.moveTolerance_ || Math.abs(pointerEvent.clientY - this.down_.clientY) > this.moveTolerance_;
    }
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        if (this.relayedListenerKey_) {
            (0, $63963d09e0c49405$export$b0a21c8b3c1c921)(this.relayedListenerKey_);
            this.relayedListenerKey_ = null;
        }
        this.element_.removeEventListener((0, $b5fa963342da4935$export$2e2bcd8739ae039).TOUCHMOVE, this.boundHandleTouchMove_);
        if (this.pointerdownListenerKey_) {
            (0, $63963d09e0c49405$export$b0a21c8b3c1c921)(this.pointerdownListenerKey_);
            this.pointerdownListenerKey_ = null;
        }
        this.dragListenerKeys_.forEach((0, $63963d09e0c49405$export$b0a21c8b3c1c921));
        this.dragListenerKeys_.length = 0;
        this.element_ = null;
        super.disposeInternal();
    }
}
var $22122345cac37f85$export$2e2bcd8739ae039 = $22122345cac37f85$var$MapBrowserEventHandler;








/**
 * @module ol/TileQueue
 */ 

/**
 * @module ol/structs/PriorityQueue
 */ 

const $1d39a4b830fd27cd$export$b4af72c40fd57063 = Infinity;
/**
 * @classdesc
 * Priority queue.
 *
 * The implementation is inspired from the Closure Library's Heap class and
 * Python's heapq module.
 *
 * See https://github.com/google/closure-library/blob/master/closure/goog/structs/heap.js
 * and https://hg.python.org/cpython/file/2.7/Lib/heapq.py.
 *
 * @template T
 */ class $1d39a4b830fd27cd$var$PriorityQueue {
    /**
   * @param {function(T): number} priorityFunction Priority function.
   * @param {function(T): string} keyFunction Key function.
   */ constructor(priorityFunction, keyFunction){
        /**
     * @type {function(T): number}
     * @private
     */ this.priorityFunction_ = priorityFunction;
        /**
     * @type {function(T): string}
     * @private
     */ this.keyFunction_ = keyFunction;
        /**
     * @type {Array<T>}
     * @private
     */ this.elements_ = [];
        /**
     * @type {Array<number>}
     * @private
     */ this.priorities_ = [];
        /**
     * @type {!Object<string, boolean>}
     * @private
     */ this.queuedElements_ = {};
    }
    /**
   * FIXME empty description for jsdoc
   */ clear() {
        this.elements_.length = 0;
        this.priorities_.length = 0;
        (0, $9f2b61a1df00e9b3$export$42ffd38884aecdac)(this.queuedElements_);
    }
    /**
   * Remove and return the highest-priority element. O(log N).
   * @return {T} Element.
   */ dequeue() {
        const elements = this.elements_;
        const priorities = this.priorities_;
        const element = elements[0];
        if (elements.length == 1) {
            elements.length = 0;
            priorities.length = 0;
        } else {
            elements[0] = /** @type {T} */ elements.pop();
            priorities[0] = /** @type {number} */ priorities.pop();
            this.siftUp_(0);
        }
        const elementKey = this.keyFunction_(element);
        delete this.queuedElements_[elementKey];
        return element;
    }
    /**
   * Enqueue an element. O(log N).
   * @param {T} element Element.
   * @return {boolean} The element was added to the queue.
   */ enqueue(element) {
        (0, $71eb897bda873684$export$a7a9523472993e97)(!(this.keyFunction_(element) in this.queuedElements_), 'Tried to enqueue an `element` that was already added to the queue');
        const priority = this.priorityFunction_(element);
        if (priority != $1d39a4b830fd27cd$export$b4af72c40fd57063) {
            this.elements_.push(element);
            this.priorities_.push(priority);
            this.queuedElements_[this.keyFunction_(element)] = true;
            this.siftDown_(0, this.elements_.length - 1);
            return true;
        }
        return false;
    }
    /**
   * @return {number} Count.
   */ getCount() {
        return this.elements_.length;
    }
    /**
   * Gets the index of the left child of the node at the given index.
   * @param {number} index The index of the node to get the left child for.
   * @return {number} The index of the left child.
   * @private
   */ getLeftChildIndex_(index) {
        return index * 2 + 1;
    }
    /**
   * Gets the index of the right child of the node at the given index.
   * @param {number} index The index of the node to get the right child for.
   * @return {number} The index of the right child.
   * @private
   */ getRightChildIndex_(index) {
        return index * 2 + 2;
    }
    /**
   * Gets the index of the parent of the node at the given index.
   * @param {number} index The index of the node to get the parent for.
   * @return {number} The index of the parent.
   * @private
   */ getParentIndex_(index) {
        return index - 1 >> 1;
    }
    /**
   * Make this a heap. O(N).
   * @private
   */ heapify_() {
        let i;
        for(i = (this.elements_.length >> 1) - 1; i >= 0; i--)this.siftUp_(i);
    }
    /**
   * @return {boolean} Is empty.
   */ isEmpty() {
        return this.elements_.length === 0;
    }
    /**
   * @param {string} key Key.
   * @return {boolean} Is key queued.
   */ isKeyQueued(key) {
        return key in this.queuedElements_;
    }
    /**
   * @param {T} element Element.
   * @return {boolean} Is queued.
   */ isQueued(element) {
        return this.isKeyQueued(this.keyFunction_(element));
    }
    /**
   * @param {number} index The index of the node to move down.
   * @private
   */ siftUp_(index) {
        const elements = this.elements_;
        const priorities = this.priorities_;
        const count = elements.length;
        const element = elements[index];
        const priority = priorities[index];
        const startIndex = index;
        while(index < count >> 1){
            const lIndex = this.getLeftChildIndex_(index);
            const rIndex = this.getRightChildIndex_(index);
            const smallerChildIndex = rIndex < count && priorities[rIndex] < priorities[lIndex] ? rIndex : lIndex;
            elements[index] = elements[smallerChildIndex];
            priorities[index] = priorities[smallerChildIndex];
            index = smallerChildIndex;
        }
        elements[index] = element;
        priorities[index] = priority;
        this.siftDown_(startIndex, index);
    }
    /**
   * @param {number} startIndex The index of the root.
   * @param {number} index The index of the node to move up.
   * @private
   */ siftDown_(startIndex, index) {
        const elements = this.elements_;
        const priorities = this.priorities_;
        const element = elements[index];
        const priority = priorities[index];
        while(index > startIndex){
            const parentIndex = this.getParentIndex_(index);
            if (priorities[parentIndex] > priority) {
                elements[index] = elements[parentIndex];
                priorities[index] = priorities[parentIndex];
                index = parentIndex;
            } else break;
        }
        elements[index] = element;
        priorities[index] = priority;
    }
    /**
   * FIXME empty description for jsdoc
   */ reprioritize() {
        const priorityFunction = this.priorityFunction_;
        const elements = this.elements_;
        const priorities = this.priorities_;
        let index = 0;
        const n = elements.length;
        let element, i, priority;
        for(i = 0; i < n; ++i){
            element = elements[i];
            priority = priorityFunction(element);
            if (priority == $1d39a4b830fd27cd$export$b4af72c40fd57063) delete this.queuedElements_[this.keyFunction_(element)];
            else {
                priorities[index] = priority;
                elements[index++] = element;
            }
        }
        elements.length = index;
        priorities.length = index;
        this.heapify_();
    }
}
var $1d39a4b830fd27cd$export$2e2bcd8739ae039 = $1d39a4b830fd27cd$var$PriorityQueue;


/**
 * @typedef {function(import("./Tile.js").default, string, import('./tilecoord.js').TileCoord, number): number} PriorityFunction
 */ /**
 * @typedef {[import('./Tile.js').default, string, import('./tilecoord.js').TileCoord, number]} TileQueueElement
 */ /**
 * @extends PriorityQueue<TileQueueElement>}
 */ class $bd8e17c0efd883d0$var$TileQueue extends (0, $1d39a4b830fd27cd$export$2e2bcd8739ae039) {
    /**
   * @param {PriorityFunction} tilePriorityFunction Tile priority function.
   * @param {function(): ?} tileChangeCallback Function called on each tile change event.
   */ constructor(tilePriorityFunction, tileChangeCallback){
        super((element)=>tilePriorityFunction.apply(null, element), (element)=>element[0].getKey());
        /** @private */ this.boundHandleTileChange_ = this.handleTileChange.bind(this);
        /**
     * @private
     * @type {function(): ?}
     */ this.tileChangeCallback_ = tileChangeCallback;
        /**
     * @private
     * @type {number}
     */ this.tilesLoading_ = 0;
        /**
     * @private
     * @type {!Object<string,boolean>}
     */ this.tilesLoadingKeys_ = {};
    }
    /**
   * @param {TileQueueElement} element Element.
   * @return {boolean} The element was added to the queue.
   * @override
   */ enqueue(element) {
        const added = super.enqueue(element);
        if (added) {
            const tile = element[0];
            tile.addEventListener((0, $b5fa963342da4935$export$2e2bcd8739ae039).CHANGE, this.boundHandleTileChange_);
        }
        return added;
    }
    /**
   * @return {number} Number of tiles loading.
   */ getTilesLoading() {
        return this.tilesLoading_;
    }
    /**
   * @param {import("./events/Event.js").default} event Event.
   * @protected
   */ handleTileChange(event) {
        const tile = /** @type {import("./Tile.js").default} */ event.target;
        const state = tile.getState();
        if (state === (0, $79d423c0f6adbcbb$export$2e2bcd8739ae039).LOADED || state === (0, $79d423c0f6adbcbb$export$2e2bcd8739ae039).ERROR || state === (0, $79d423c0f6adbcbb$export$2e2bcd8739ae039).EMPTY) {
            if (state !== (0, $79d423c0f6adbcbb$export$2e2bcd8739ae039).ERROR) tile.removeEventListener((0, $b5fa963342da4935$export$2e2bcd8739ae039).CHANGE, this.boundHandleTileChange_);
            const tileKey = tile.getKey();
            if (tileKey in this.tilesLoadingKeys_) {
                delete this.tilesLoadingKeys_[tileKey];
                --this.tilesLoading_;
            }
            this.tileChangeCallback_();
        }
    }
    /**
   * @param {number} maxTotalLoading Maximum number tiles to load simultaneously.
   * @param {number} maxNewLoads Maximum number of new tiles to load.
   */ loadMoreTiles(maxTotalLoading, maxNewLoads) {
        let newLoads = 0;
        while(this.tilesLoading_ < maxTotalLoading && newLoads < maxNewLoads && this.getCount() > 0){
            const tile = this.dequeue()[0];
            const tileKey = tile.getKey();
            const state = tile.getState();
            if (state === (0, $79d423c0f6adbcbb$export$2e2bcd8739ae039).IDLE && !(tileKey in this.tilesLoadingKeys_)) {
                this.tilesLoadingKeys_[tileKey] = true;
                ++this.tilesLoading_;
                ++newLoads;
                tile.load();
            }
        }
    }
}
var $bd8e17c0efd883d0$export$2e2bcd8739ae039 = $bd8e17c0efd883d0$var$TileQueue;
function $bd8e17c0efd883d0$export$f08ad5eceeff5d45(frameState, tile, tileSourceKey, tileCenter, tileResolution) {
    // Filter out tiles at higher zoom levels than the current zoom level, or that
    // are outside the visible extent.
    if (!frameState || !(tileSourceKey in frameState.wantedTiles)) return 0, $1d39a4b830fd27cd$export$b4af72c40fd57063;
    if (!frameState.wantedTiles[tileSourceKey][tile.getKey()]) return 0, $1d39a4b830fd27cd$export$b4af72c40fd57063;
    // Prioritize the highest zoom level tiles closest to the focus.
    // Tiles at higher zoom levels are prioritized using Math.log(tileResolution).
    // Within a zoom level, tiles are prioritized by the distance in pixels between
    // the center of the tile and the center of the viewport.  The factor of 65536
    // means that the prioritization should behave as desired for tiles up to
    // 65536 * Math.log(2) = 45426 pixels from the focus.
    const center = frameState.viewState.center;
    const deltaX = tileCenter[0] - center[0];
    const deltaY = tileCenter[1] - center[1];
    return 65536 * Math.log(tileResolution) + Math.sqrt(deltaX * deltaX + deltaY * deltaY) / tileResolution;
}














/**
 * @module ol/interaction/defaults
 */ 
/**
 * @module ol/Kinetic
 */ /**
 * @classdesc
 * Implementation of inertial deceleration for map movement.
 *
 * @api
 */ class $7d556ebdaefd511a$var$Kinetic {
    /**
   * @param {number} decay Rate of decay (must be negative).
   * @param {number} minVelocity Minimum velocity (pixels/millisecond).
   * @param {number} delay Delay to consider to calculate the kinetic
   *     initial values (milliseconds).
   */ constructor(decay, minVelocity, delay){
        /**
     * @private
     * @type {number}
     */ this.decay_ = decay;
        /**
     * @private
     * @type {number}
     */ this.minVelocity_ = minVelocity;
        /**
     * @private
     * @type {number}
     */ this.delay_ = delay;
        /**
     * @private
     * @type {Array<number>}
     */ this.points_ = [];
        /**
     * @private
     * @type {number}
     */ this.angle_ = 0;
        /**
     * @private
     * @type {number}
     */ this.initialVelocity_ = 0;
    }
    /**
   * FIXME empty description for jsdoc
   */ begin() {
        this.points_.length = 0;
        this.angle_ = 0;
        this.initialVelocity_ = 0;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   */ update(x, y) {
        this.points_.push(x, y, Date.now());
    }
    /**
   * @return {boolean} Whether we should do kinetic animation.
   */ end() {
        if (this.points_.length < 6) // at least 2 points are required (i.e. there must be at least 6 elements
        // in the array)
        return false;
        const delay = Date.now() - this.delay_;
        const lastIndex = this.points_.length - 3;
        if (this.points_[lastIndex + 2] < delay) // the last tracked point is too old, which means that the user stopped
        // panning before releasing the map
        return false;
        // get the first point which still falls into the delay time
        let firstIndex = lastIndex - 3;
        while(firstIndex > 0 && this.points_[firstIndex + 2] > delay)firstIndex -= 3;
        const duration = this.points_[lastIndex + 2] - this.points_[firstIndex + 2];
        // we don't want a duration of 0 (divide by zero)
        // we also make sure the user panned for a duration of at least one frame
        // (1/60s) to compute sane displacement values
        if (duration < 1000 / 60) return false;
        const dx = this.points_[lastIndex] - this.points_[firstIndex];
        const dy = this.points_[lastIndex + 1] - this.points_[firstIndex + 1];
        this.angle_ = Math.atan2(dy, dx);
        this.initialVelocity_ = Math.sqrt(dx * dx + dy * dy) / duration;
        return this.initialVelocity_ > this.minVelocity_;
    }
    /**
   * @return {number} Total distance travelled (pixels).
   */ getDistance() {
        return (this.minVelocity_ - this.initialVelocity_) / this.decay_;
    }
    /**
   * @return {number} Angle of the kinetic panning animation (radians).
   */ getAngle() {
        return this.angle_;
    }
}
var $7d556ebdaefd511a$export$2e2bcd8739ae039 = $7d556ebdaefd511a$var$Kinetic;


/**
 * @module ol/interaction/DoubleClickZoom
 */ 

/**
 * @typedef {Object} Options
 * @property {number} [duration=250] Animation duration in milliseconds.
 * @property {number} [delta=1] The zoom delta applied on each double click.
 */ /**
 * @classdesc
 * Allows the user to zoom by double-clicking on the map.
 * @api
 */ class $a1ba7279e77eb328$var$DoubleClickZoom extends (0, $24f38e4defed3bcd$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        super();
        options = options ? options : {};
        /**
     * @private
     * @type {number}
     */ this.delta_ = options.delta ? options.delta : 1;
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 250;
    }
    /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} (if it was a
   * doubleclick) and eventually zooms the map.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @override
   */ handleEvent(mapBrowserEvent) {
        let stopEvent = false;
        if (mapBrowserEvent.type == (0, $1b4cb51f4587f284$export$2e2bcd8739ae039).DBLCLICK) {
            const browserEvent = /** @type {MouseEvent} */ mapBrowserEvent.originalEvent;
            const map = mapBrowserEvent.map;
            const anchor = mapBrowserEvent.coordinate;
            const delta = browserEvent.shiftKey ? -this.delta_ : this.delta_;
            const view = map.getView();
            (0, $24f38e4defed3bcd$export$ace321ff2a8016ef)(view, delta, anchor, this.duration_);
            browserEvent.preventDefault();
            stopEvent = true;
        }
        return !stopEvent;
    }
}
var $a1ba7279e77eb328$export$2e2bcd8739ae039 = $a1ba7279e77eb328$var$DoubleClickZoom;


/**
 * @module ol/interaction/DragPan
 */ 



/**
 * @module ol/interaction/Pointer
 */ 

/**
 * @typedef {Object} Options
 * @property {function(import("../MapBrowserEvent.js").default):boolean} [handleDownEvent]
 * Function handling "down" events. If the function returns `true` then a drag
 * sequence is started.
 * @property {function(import("../MapBrowserEvent.js").default):void} [handleDragEvent]
 * Function handling "drag" events. This function is called on "move" events
 * during a drag sequence.
 * @property {function(import("../MapBrowserEvent.js").default):boolean} [handleEvent]
 * Method called by the map to notify the interaction that a browser event was
 * dispatched to the map. The function may return `false` to prevent the
 * propagation of the event to other interactions in the map's interactions
 * chain.
 * @property {function(import("../MapBrowserEvent.js").default):void} [handleMoveEvent]
 * Function handling "move" events. This function is called on "move" events.
 * This functions is also called during a drag sequence, so during a drag
 * sequence both the `handleDragEvent` function and this function are called.
 * If `handleDownEvent` is defined and it returns true this function will not
 * be called during a drag sequence.
 * @property {function(import("../MapBrowserEvent.js").default):boolean} [handleUpEvent]
 *  Function handling "up" events. If the function returns `false` then the
 * current drag sequence is stopped.
 * @property {function(boolean):boolean} [stopDown]
 * Should the down event be propagated to other interactions, or should be
 * stopped?
 */ /**
 * @classdesc
 * Base class that calls user-defined functions on `down`, `move` and `up`
 * events. This class also manages "drag sequences".
 *
 * When the `handleDownEvent` user function returns `true` a drag sequence is
 * started. During a drag sequence the `handleDragEvent` user function is
 * called on `move` events. The drag sequence ends when the `handleUpEvent`
 * user function is called and returns `false`.
 * @api
 */ class $21bd437a923ad8cf$var$PointerInteraction extends (0, $24f38e4defed3bcd$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        super(/** @type {import("./Interaction.js").InteractionOptions} */ options);
        if (options.handleDownEvent) this.handleDownEvent = options.handleDownEvent;
        if (options.handleDragEvent) this.handleDragEvent = options.handleDragEvent;
        if (options.handleMoveEvent) this.handleMoveEvent = options.handleMoveEvent;
        if (options.handleUpEvent) this.handleUpEvent = options.handleUpEvent;
        if (options.stopDown) this.stopDown = options.stopDown;
        /**
     * @type {boolean}
     * @protected
     */ this.handlingDownUpSequence = false;
        /**
     * @type {Array<PointerEvent>}
     * @protected
     */ this.targetPointers = [];
    }
    /**
   * Returns the current number of pointers involved in the interaction,
   * e.g. `2` when two fingers are used.
   * @return {number} The number of pointers.
   * @api
   */ getPointerCount() {
        return this.targetPointers.length;
    }
    /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @protected
   */ handleDownEvent(mapBrowserEvent) {
        return false;
    }
    /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @protected
   */ handleDragEvent(mapBrowserEvent) {}
    /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} and may call into
   * other functions, if event sequences like e.g. 'drag' or 'down-up' etc. are
   * detected.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @api
   * @override
   */ handleEvent(mapBrowserEvent) {
        if (!mapBrowserEvent.originalEvent) return true;
        let stopEvent = false;
        this.updateTrackedPointers_(mapBrowserEvent);
        if (this.handlingDownUpSequence) {
            if (mapBrowserEvent.type == (0, $1b4cb51f4587f284$export$2e2bcd8739ae039).POINTERDRAG) {
                this.handleDragEvent(mapBrowserEvent);
                // prevent page scrolling during dragging
                mapBrowserEvent.originalEvent.preventDefault();
            } else if (mapBrowserEvent.type == (0, $1b4cb51f4587f284$export$2e2bcd8739ae039).POINTERUP) {
                const handledUp = this.handleUpEvent(mapBrowserEvent);
                this.handlingDownUpSequence = handledUp && this.targetPointers.length > 0;
            }
        } else {
            if (mapBrowserEvent.type == (0, $1b4cb51f4587f284$export$2e2bcd8739ae039).POINTERDOWN) {
                const handled = this.handleDownEvent(mapBrowserEvent);
                this.handlingDownUpSequence = handled;
                stopEvent = this.stopDown(handled);
            } else if (mapBrowserEvent.type == (0, $1b4cb51f4587f284$export$2e2bcd8739ae039).POINTERMOVE) this.handleMoveEvent(mapBrowserEvent);
        }
        return !stopEvent;
    }
    /**
   * Handle pointer move events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @protected
   */ handleMoveEvent(mapBrowserEvent) {}
    /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @protected
   */ handleUpEvent(mapBrowserEvent) {
        return false;
    }
    /**
   * This function is used to determine if "down" events should be propagated
   * to other interactions or should be stopped.
   * @param {boolean} handled Was the event handled by the interaction?
   * @return {boolean} Should the `down` event be stopped?
   */ stopDown(handled) {
        return handled;
    }
    /**
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @private
   */ updateTrackedPointers_(mapBrowserEvent) {
        if (mapBrowserEvent.activePointers) this.targetPointers = mapBrowserEvent.activePointers;
    }
}
function $21bd437a923ad8cf$export$e2a20c553f6c85ce(pointerEvents) {
    const length = pointerEvents.length;
    let clientX = 0;
    let clientY = 0;
    for(let i = 0; i < length; i++){
        clientX += pointerEvents[i].clientX;
        clientY += pointerEvents[i].clientY;
    }
    return {
        clientX: clientX / length,
        clientY: clientY / length
    };
}
var $21bd437a923ad8cf$export$2e2bcd8739ae039 = $21bd437a923ad8cf$var$PointerInteraction;


/**
 * @typedef {Object} Options
 * @property {import("../events/condition.js").Condition} [condition] A function that takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a boolean
 * to indicate whether that event should be handled.
 * Default is {@link module:ol/events/condition.noModifierKeys} and {@link module:ol/events/condition.primaryAction}.
 * @property {boolean} [onFocusOnly=false] When the map's target has a `tabindex` attribute set,
 * the interaction will only handle events when the map has the focus.
 * @property {import("../Kinetic.js").default} [kinetic] Kinetic inertia to apply to the pan.
 */ /**
 * @classdesc
 * Allows the user to pan the map by dragging the map.
 * @api
 */ class $fbb92ebf821804c2$var$DragPan extends (0, $21bd437a923ad8cf$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        super({
            stopDown: (0, $bc15bca7780ad95b$export$8f11cee4bdc7e668)
        });
        options = options ? options : {};
        /**
     * @private
     * @type {import("../Kinetic.js").default|undefined}
     */ this.kinetic_ = options.kinetic;
        /**
     * @type {import("../pixel.js").Pixel}
     */ this.lastCentroid = null;
        /**
     * @type {number}
     * @private
     */ this.lastPointersCount_;
        /**
     * @type {boolean}
     * @private
     */ this.panning_ = false;
        const condition = options.condition ? options.condition : (0, $638912a122b4daef$export$84bf76cd7afc7469)((0, $638912a122b4daef$export$fdc892d0d8fe3bfb), (0, $638912a122b4daef$export$189f0d593022b199));
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.onFocusOnly ? (0, $638912a122b4daef$export$84bf76cd7afc7469)((0, $638912a122b4daef$export$ae2cdf064e3b0c55), condition) : condition;
        /**
     * @private
     * @type {boolean}
     */ this.noKinetic_ = false;
    }
    /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @override
   */ handleDragEvent(mapBrowserEvent) {
        const map = mapBrowserEvent.map;
        if (!this.panning_) {
            this.panning_ = true;
            map.getView().beginInteraction();
        }
        const targetPointers = this.targetPointers;
        const centroid = map.getEventPixel((0, $21bd437a923ad8cf$export$e2a20c553f6c85ce)(targetPointers));
        if (targetPointers.length == this.lastPointersCount_) {
            if (this.kinetic_) this.kinetic_.update(centroid[0], centroid[1]);
            if (this.lastCentroid) {
                const delta = [
                    this.lastCentroid[0] - centroid[0],
                    centroid[1] - this.lastCentroid[1]
                ];
                const map = mapBrowserEvent.map;
                const view = map.getView();
                (0, $a6adb03fd2fbc071$export$dcdf75081b88279d)(delta, view.getResolution());
                (0, $a6adb03fd2fbc071$export$bb628a54ab399bc9)(delta, view.getRotation());
                view.adjustCenterInternal(delta);
            }
        } else if (this.kinetic_) // reset so we don't overestimate the kinetic energy after
        // after one finger down, tiny drag, second finger down
        this.kinetic_.begin();
        this.lastCentroid = centroid;
        this.lastPointersCount_ = targetPointers.length;
        mapBrowserEvent.originalEvent.preventDefault();
    }
    /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleUpEvent(mapBrowserEvent) {
        const map = mapBrowserEvent.map;
        const view = map.getView();
        if (this.targetPointers.length === 0) {
            if (!this.noKinetic_ && this.kinetic_ && this.kinetic_.end()) {
                const distance = this.kinetic_.getDistance();
                const angle = this.kinetic_.getAngle();
                const center = view.getCenterInternal();
                const centerpx = map.getPixelFromCoordinateInternal(center);
                const dest = map.getCoordinateFromPixelInternal([
                    centerpx[0] - distance * Math.cos(angle),
                    centerpx[1] - distance * Math.sin(angle)
                ]);
                view.animateInternal({
                    center: view.getConstrainedCenter(dest),
                    duration: 500,
                    easing: (0, $386674cda6e01ace$export$57636bb43b1ccbb0)
                });
            }
            if (this.panning_) {
                this.panning_ = false;
                view.endInteraction();
            }
            return false;
        }
        if (this.kinetic_) // reset so we don't overestimate the kinetic energy after
        // after one finger up, tiny drag, second finger up
        this.kinetic_.begin();
        this.lastCentroid = null;
        return true;
    }
    /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleDownEvent(mapBrowserEvent) {
        if (this.targetPointers.length > 0 && this.condition_(mapBrowserEvent)) {
            const map = mapBrowserEvent.map;
            const view = map.getView();
            this.lastCentroid = null;
            // stop any current animation
            if (view.getAnimating()) view.cancelAnimations();
            if (this.kinetic_) this.kinetic_.begin();
            // No kinetic as soon as more than one pointer on the screen is
            // detected. This is to prevent nasty pans after pinch.
            this.noKinetic_ = this.targetPointers.length > 1;
            return true;
        }
        return false;
    }
}
var $fbb92ebf821804c2$export$2e2bcd8739ae039 = $fbb92ebf821804c2$var$DragPan;


/**
 * @module ol/interaction/DragRotate
 */ 



/**
 * @typedef {Object} Options
 * @property {import("../events/condition.js").Condition} [condition] A function that takes a
 * {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a boolean
 * to indicate whether that event should be handled.
 * Default is {@link module:ol/events/condition.altShiftKeysOnly}.
 * @property {number} [duration=250] Animation duration in milliseconds.
 */ /**
 * @classdesc
 * Allows the user to rotate the map by clicking and dragging on the map,
 * normally combined with a {@link module:ol/events/condition} that limits
 * it to when the alt and shift keys are held down.
 *
 * This interaction is only supported for mouse devices.
 * @api
 */ class $91e1f60136545f66$var$DragRotate extends (0, $21bd437a923ad8cf$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        super({
            stopDown: (0, $bc15bca7780ad95b$export$8f11cee4bdc7e668)
        });
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.condition ? options.condition : (0, $638912a122b4daef$export$4e5f01653f9f1f82);
        /**
     * @private
     * @type {number|undefined}
     */ this.lastAngle_ = undefined;
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 250;
    }
    /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @override
   */ handleDragEvent(mapBrowserEvent) {
        if (!(0, $638912a122b4daef$export$abb7acbfa76bf3c4)(mapBrowserEvent)) return;
        const map = mapBrowserEvent.map;
        const view = map.getView();
        if (view.getConstraints().rotation === (0, $a4b2c7f4b045b17d$export$e20fbacbb41798b)) return;
        const size = map.getSize();
        const offset = mapBrowserEvent.pixel;
        const theta = Math.atan2(size[1] / 2 - offset[1], offset[0] - size[0] / 2);
        if (this.lastAngle_ !== undefined) {
            const delta = theta - this.lastAngle_;
            view.adjustRotationInternal(-delta);
        }
        this.lastAngle_ = theta;
    }
    /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleUpEvent(mapBrowserEvent) {
        if (!(0, $638912a122b4daef$export$abb7acbfa76bf3c4)(mapBrowserEvent)) return true;
        const map = mapBrowserEvent.map;
        const view = map.getView();
        view.endInteraction(this.duration_);
        return false;
    }
    /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleDownEvent(mapBrowserEvent) {
        if (!(0, $638912a122b4daef$export$abb7acbfa76bf3c4)(mapBrowserEvent)) return false;
        if ((0, $638912a122b4daef$export$1238ad6b5e7fff70)(mapBrowserEvent) && this.condition_(mapBrowserEvent)) {
            const map = mapBrowserEvent.map;
            map.getView().beginInteraction();
            this.lastAngle_ = undefined;
            return true;
        }
        return false;
    }
}
var $91e1f60136545f66$export$2e2bcd8739ae039 = $91e1f60136545f66$var$DragRotate;


/**
 * @module ol/interaction/DragZoom
 */ 

/**
 * @module ol/interaction/DragBox
 */ // FIXME draw drag box


/**
 * @module ol/render/Box
 */ 

class $545ac2c1b1be68f3$var$RenderBox extends (0, $1f0239b94d40ee35$export$2e2bcd8739ae039) {
    /**
   * @param {string} className CSS class name.
   */ constructor(className){
        super();
        /**
     * @type {import("../geom/Polygon.js").default}
     * @private
     */ this.geometry_ = null;
        /**
     * @type {HTMLDivElement}
     * @private
     */ this.element_ = document.createElement('div');
        this.element_.style.position = 'absolute';
        this.element_.style.pointerEvents = 'auto';
        this.element_.className = 'ol-box ' + className;
        /**
     * @private
     * @type {import("../Map.js").default|null}
     */ this.map_ = null;
        /**
     * @private
     * @type {import("../pixel.js").Pixel}
     */ this.startPixel_ = null;
        /**
     * @private
     * @type {import("../pixel.js").Pixel}
     */ this.endPixel_ = null;
    }
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        this.setMap(null);
    }
    /**
   * @private
   */ render_() {
        const startPixel = this.startPixel_;
        const endPixel = this.endPixel_;
        const px = 'px';
        const style = this.element_.style;
        style.left = Math.min(startPixel[0], endPixel[0]) + px;
        style.top = Math.min(startPixel[1], endPixel[1]) + px;
        style.width = Math.abs(endPixel[0] - startPixel[0]) + px;
        style.height = Math.abs(endPixel[1] - startPixel[1]) + px;
    }
    /**
   * @param {import("../Map.js").default|null} map Map.
   */ setMap(map) {
        if (this.map_) {
            this.map_.getOverlayContainer().removeChild(this.element_);
            const style = this.element_.style;
            style.left = 'inherit';
            style.top = 'inherit';
            style.width = 'inherit';
            style.height = 'inherit';
        }
        this.map_ = map;
        if (this.map_) this.map_.getOverlayContainer().appendChild(this.element_);
    }
    /**
   * @param {import("../pixel.js").Pixel} startPixel Start pixel.
   * @param {import("../pixel.js").Pixel} endPixel End pixel.
   */ setPixels(startPixel, endPixel) {
        this.startPixel_ = startPixel;
        this.endPixel_ = endPixel;
        this.createOrUpdateGeometry();
        this.render_();
    }
    /**
   * Creates or updates the cached geometry.
   */ createOrUpdateGeometry() {
        if (!this.map_) return;
        const startPixel = this.startPixel_;
        const endPixel = this.endPixel_;
        const pixels = [
            startPixel,
            [
                startPixel[0],
                endPixel[1]
            ],
            endPixel,
            [
                endPixel[0],
                startPixel[1]
            ]
        ];
        const coordinates = pixels.map(this.map_.getCoordinateFromPixelInternal, this.map_);
        // close the polygon
        coordinates[4] = coordinates[0].slice();
        if (!this.geometry_) this.geometry_ = new (0, $52cb54ac72de6b07$export$2e2bcd8739ae039)([
            coordinates
        ]);
        else this.geometry_.setCoordinates([
            coordinates
        ]);
    }
    /**
   * @return {import("../geom/Polygon.js").default} Geometry.
   */ getGeometry() {
        return this.geometry_;
    }
}
var $545ac2c1b1be68f3$export$2e2bcd8739ae039 = $545ac2c1b1be68f3$var$RenderBox;



/**
 * A function that takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and two
 * {@link module:ol/pixel~Pixel}s and returns a `{boolean}`. If the condition is met,
 * true should be returned.
 * @typedef {function(this: ?, import("../MapBrowserEvent.js").default, import("../pixel.js").Pixel, import("../pixel.js").Pixel):boolean} EndCondition
 */ /**
 * @typedef {Object} Options
 * @property {string} [className='ol-dragbox'] CSS class name for styling the box.
 * @property {import("../events/condition.js").Condition} [condition] A function that takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a boolean
 * to indicate whether that event should be handled.
 * Default is {@link ol/events/condition~mouseActionButton}.
 * @property {number} [minArea=64] The minimum area of the box in pixel, this value is used by the default
 * `boxEndCondition` function.
 * @property {EndCondition} [boxEndCondition] A function that takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and two
 * {@link module:ol/pixel~Pixel}s to indicate whether a `boxend` event should be fired.
 * Default is `true` if the area of the box is bigger than the `minArea` option.
 * @property {function(this:DragBox, import("../MapBrowserEvent.js").default):void} [onBoxEnd] Code to execute just
 * before `boxend` is fired.
 */ /**
 * @enum {string}
 */ const $886371f562c99b97$var$DragBoxEventType = {
    /**
   * Triggered upon drag box start.
   * @event DragBoxEvent#boxstart
   * @api
   */ BOXSTART: 'boxstart',
    /**
   * Triggered on drag when box is active.
   * @event DragBoxEvent#boxdrag
   * @api
   */ BOXDRAG: 'boxdrag',
    /**
   * Triggered upon drag box end.
   * @event DragBoxEvent#boxend
   * @api
   */ BOXEND: 'boxend',
    /**
   * Triggered upon drag box canceled.
   * @event DragBoxEvent#boxcancel
   * @api
   */ BOXCANCEL: 'boxcancel'
};
class $886371f562c99b97$export$7053c33c051365ea extends (0, $5c6b0a43c077a98f$export$2e2bcd8739ae039) {
    /**
   * @param {string} type The event type.
   * @param {import("../coordinate.js").Coordinate} coordinate The event coordinate.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Originating event.
   */ constructor(type, coordinate, mapBrowserEvent){
        super(type);
        /**
     * The coordinate of the drag event.
     * @const
     * @type {import("../coordinate.js").Coordinate}
     * @api
     */ this.coordinate = coordinate;
        /**
     * @const
     * @type {import("../MapBrowserEvent.js").default}
     * @api
     */ this.mapBrowserEvent = mapBrowserEvent;
    }
}
/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types|
 *     'change:active', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<'boxcancel'|'boxdrag'|'boxend'|'boxstart', DragBoxEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types|
 *     'change:active'|'boxcancel'|'boxdrag'|'boxend', Return>} DragBoxOnSignature
 */ /**
 * @classdesc
 * Allows the user to draw a vector box by clicking and dragging on the map,
 * normally combined with a {@link module:ol/events/condition} that limits
 * it to when the shift or other key is held down. This is used, for example,
 * for zooming to a specific area of the map
 * (see {@link module:ol/interaction/DragZoom~DragZoom} and
 * {@link module:ol/interaction/DragRotateAndZoom~DragRotateAndZoom}).
 *
 * @fires DragBoxEvent
 * @api
 */ class $886371f562c99b97$var$DragBox extends (0, $21bd437a923ad8cf$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        super();
        /***
     * @type {DragBoxOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {DragBoxOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {DragBoxOnSignature<void>}
     */ this.un;
        options = options ?? {};
        /**
     * @type {import("../render/Box.js").default}
     * @private
     */ this.box_ = new (0, $545ac2c1b1be68f3$export$2e2bcd8739ae039)(options.className || 'ol-dragbox');
        /**
     * @type {number}
     * @private
     */ this.minArea_ = options.minArea ?? 64;
        if (options.onBoxEnd) this.onBoxEnd = options.onBoxEnd;
        /**
     * @type {import("../pixel.js").Pixel}
     * @private
     */ this.startPixel_ = null;
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.condition ?? (0, $638912a122b4daef$export$1238ad6b5e7fff70);
        /**
     * @private
     * @type {EndCondition}
     */ this.boxEndCondition_ = options.boxEndCondition ?? this.defaultBoxEndCondition;
    }
    /**
   * The default condition for determining whether the boxend event
   * should fire.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent The originating MapBrowserEvent
   *     leading to the box end.
   * @param {import("../pixel.js").Pixel} startPixel The starting pixel of the box.
   * @param {import("../pixel.js").Pixel} endPixel The end pixel of the box.
   * @return {boolean} Whether or not the boxend condition should be fired.
   */ defaultBoxEndCondition(mapBrowserEvent, startPixel, endPixel) {
        const width = endPixel[0] - startPixel[0];
        const height = endPixel[1] - startPixel[1];
        return width * width + height * height >= this.minArea_;
    }
    /**
   * Returns geometry of last drawn box.
   * @return {import("../geom/Polygon.js").default} Geometry.
   * @api
   */ getGeometry() {
        return this.box_.getGeometry();
    }
    /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @override
   */ handleDragEvent(mapBrowserEvent) {
        if (!this.startPixel_) return;
        this.box_.setPixels(this.startPixel_, mapBrowserEvent.pixel);
        this.dispatchEvent(new $886371f562c99b97$export$7053c33c051365ea($886371f562c99b97$var$DragBoxEventType.BOXDRAG, mapBrowserEvent.coordinate, mapBrowserEvent));
    }
    /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleUpEvent(mapBrowserEvent) {
        if (!this.startPixel_) return false;
        const completeBox = this.boxEndCondition_(mapBrowserEvent, this.startPixel_, mapBrowserEvent.pixel);
        if (completeBox) this.onBoxEnd(mapBrowserEvent);
        this.dispatchEvent(new $886371f562c99b97$export$7053c33c051365ea(completeBox ? $886371f562c99b97$var$DragBoxEventType.BOXEND : $886371f562c99b97$var$DragBoxEventType.BOXCANCEL, mapBrowserEvent.coordinate, mapBrowserEvent));
        this.box_.setMap(null);
        this.startPixel_ = null;
        return false;
    }
    /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleDownEvent(mapBrowserEvent) {
        if (this.condition_(mapBrowserEvent)) {
            this.startPixel_ = mapBrowserEvent.pixel;
            this.box_.setMap(mapBrowserEvent.map);
            this.box_.setPixels(this.startPixel_, this.startPixel_);
            this.dispatchEvent(new $886371f562c99b97$export$7053c33c051365ea($886371f562c99b97$var$DragBoxEventType.BOXSTART, mapBrowserEvent.coordinate, mapBrowserEvent));
            return true;
        }
        return false;
    }
    /**
   * Function to execute just before `onboxend` is fired
   * @param {import("../MapBrowserEvent.js").default} event Event.
   */ onBoxEnd(event) {}
    /**
   * Activate or deactivate the interaction.
   * @param {boolean} active Active.
   * @observable
   * @api
   * @override
   */ setActive(active) {
        if (!active) {
            this.box_.setMap(null);
            if (this.startPixel_) {
                this.dispatchEvent(new $886371f562c99b97$export$7053c33c051365ea($886371f562c99b97$var$DragBoxEventType.BOXCANCEL, this.startPixel_, null));
                this.startPixel_ = null;
            }
        }
        super.setActive(active);
    }
    /**
   * @param {import("../Map.js").default|null} map Map.
   * @override
   */ setMap(map) {
        const oldMap = this.getMap();
        if (oldMap) {
            this.box_.setMap(null);
            if (this.startPixel_) {
                this.dispatchEvent(new $886371f562c99b97$export$7053c33c051365ea($886371f562c99b97$var$DragBoxEventType.BOXCANCEL, this.startPixel_, null));
                this.startPixel_ = null;
            }
        }
        super.setMap(map);
    }
}
var $886371f562c99b97$export$2e2bcd8739ae039 = $886371f562c99b97$var$DragBox;


/**
 * @typedef {Object} Options
 * @property {string} [className='ol-dragzoom'] CSS class name for styling the
 * box.
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled.
 * Default is {@link module:ol/events/condition.shiftKeyOnly}.
 * @property {number} [duration=200] Animation duration in milliseconds.
 * @property {boolean} [out=false] Use interaction for zooming out.
 * @property {number} [minArea=64] The minimum area of the box in pixel, this value is used by the parent default
 * `boxEndCondition` function.
 */ /**
 * @classdesc
 * Allows the user to zoom the map by clicking and dragging on the map,
 * normally combined with a {@link module:ol/events/condition} that limits
 * it to when a key, shift by default, is held down.
 *
 * To change the style of the box, use CSS and the `.ol-dragzoom` selector, or
 * your custom one configured with `className`.
 * @api
 */ class $2279cbb831360107$var$DragZoom extends (0, $886371f562c99b97$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        const condition = options.condition ? options.condition : (0, $638912a122b4daef$export$5d31fe68a477cfbb);
        super({
            condition: condition,
            className: options.className || 'ol-dragzoom',
            minArea: options.minArea
        });
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 200;
        /**
     * @private
     * @type {boolean}
     */ this.out_ = options.out !== undefined ? options.out : false;
    }
    /**
   * Function to execute just before `onboxend` is fired
   * @param {import("../MapBrowserEvent.js").default} event Event.
   * @override
   */ onBoxEnd(event) {
        const map = this.getMap();
        const view = /** @type {!import("../View.js").default} */ map.getView();
        let geometry = this.getGeometry();
        if (this.out_) {
            const rotatedExtent = view.rotatedExtentForGeometry(geometry);
            const resolution = view.getResolutionForExtentInternal(rotatedExtent);
            const factor = view.getResolution() / resolution;
            geometry = geometry.clone();
            geometry.scale(factor * factor);
        }
        view.fitInternal(geometry, {
            duration: this.duration_,
            easing: (0, $386674cda6e01ace$export$57636bb43b1ccbb0)
        });
    }
}
var $2279cbb831360107$export$2e2bcd8739ae039 = $2279cbb831360107$var$DragZoom;


/**
 * @module ol/interaction/KeyboardPan
 */ 

/**
 * @module ol/events/Key
 */ /**
 * @enum {string}
 * @const
 */ var $f66471952b3153a3$export$2e2bcd8739ae039 = {
    LEFT: 'ArrowLeft',
    UP: 'ArrowUp',
    RIGHT: 'ArrowRight',
    DOWN: 'ArrowDown'
};




/**
 * @typedef {Object} Options
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled. Default is
 * {@link module:ol/events/condition.noModifierKeys} and
 * {@link module:ol/events/condition.targetNotEditable}.
 * @property {number} [duration=100] Animation duration in milliseconds.
 * @property {number} [pixelDelta=128] The amount of pixels to pan on each key
 * press.
 */ /**
 * @classdesc
 * Allows the user to pan the map using keyboard arrows.
 * Note that, although this interaction is by default included in maps,
 * the keys can only be used when browser focus is on the element to which
 * the keyboard events are attached. By default, this is the map div,
 * though you can change this with the `keyboardEventTarget` in
 * {@link module:ol/Map~Map}. `document` never loses focus but, for any other
 * element, focus will have to be on, and returned to, this element if the keys
 * are to function.
 * See also {@link module:ol/interaction/KeyboardZoom~KeyboardZoom}.
 * @api
 */ class $accd6354e6bdfe20$var$KeyboardPan extends (0, $24f38e4defed3bcd$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        super();
        options = options || {};
        /**
     * @private
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Browser event.
     * @return {boolean} Combined condition result.
     */ this.defaultCondition_ = function(mapBrowserEvent) {
            return (0, $638912a122b4daef$export$fdc892d0d8fe3bfb)(mapBrowserEvent) && (0, $638912a122b4daef$export$e5570ca80cd8fd54)(mapBrowserEvent);
        };
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.condition !== undefined ? options.condition : this.defaultCondition_;
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 100;
        /**
     * @private
     * @type {number}
     */ this.pixelDelta_ = options.pixelDelta !== undefined ? options.pixelDelta : 128;
    }
    /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} if it was a
   * `KeyEvent`, and decides the direction to pan to (if an arrow key was
   * pressed).
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @override
   */ handleEvent(mapBrowserEvent) {
        let stopEvent = false;
        if (mapBrowserEvent.type == (0, $b5fa963342da4935$export$2e2bcd8739ae039).KEYDOWN) {
            const keyEvent = /** @type {KeyboardEvent} */ mapBrowserEvent.originalEvent;
            const key = keyEvent.key;
            if (this.condition_(mapBrowserEvent) && (key == (0, $f66471952b3153a3$export$2e2bcd8739ae039).DOWN || key == (0, $f66471952b3153a3$export$2e2bcd8739ae039).LEFT || key == (0, $f66471952b3153a3$export$2e2bcd8739ae039).RIGHT || key == (0, $f66471952b3153a3$export$2e2bcd8739ae039).UP)) {
                const map = mapBrowserEvent.map;
                const view = map.getView();
                const mapUnitsDelta = view.getResolution() * this.pixelDelta_;
                let deltaX = 0, deltaY = 0;
                if (key == (0, $f66471952b3153a3$export$2e2bcd8739ae039).DOWN) deltaY = -mapUnitsDelta;
                else if (key == (0, $f66471952b3153a3$export$2e2bcd8739ae039).LEFT) deltaX = -mapUnitsDelta;
                else if (key == (0, $f66471952b3153a3$export$2e2bcd8739ae039).RIGHT) deltaX = mapUnitsDelta;
                else deltaY = mapUnitsDelta;
                const delta = [
                    deltaX,
                    deltaY
                ];
                (0, $a6adb03fd2fbc071$export$bb628a54ab399bc9)(delta, view.getRotation());
                (0, $24f38e4defed3bcd$export$4c486572e961a974)(view, delta, this.duration_);
                keyEvent.preventDefault();
                stopEvent = true;
            }
        }
        return !stopEvent;
    }
}
var $accd6354e6bdfe20$export$2e2bcd8739ae039 = $accd6354e6bdfe20$var$KeyboardPan;


/**
 * @module ol/interaction/KeyboardZoom
 */ 


/**
 * @typedef {Object} Options
 * @property {number} [duration=100] Animation duration in milliseconds.
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled. The default condition is
 * that {@link module:ol/events/condition.targetNotEditable} is fulfilled and that
 * the platform modifier key isn't pressed
 * (!{@link module:ol/events/condition.platformModifierKey}).
 * @property {number} [delta=1] The zoom level delta on each key press.
 */ /**
 * @classdesc
 * Allows the user to zoom the map using keyboard + and -.
 * Note that, although this interaction is by default included in maps,
 * the keys can only be used when browser focus is on the element to which
 * the keyboard events are attached. By default, this is the map div,
 * though you can change this with the `keyboardEventTarget` in
 * {@link module:ol/Map~Map}. `document` never loses focus but, for any other
 * element, focus will have to be on, and returned to, this element if the keys
 * are to function.
 * See also {@link module:ol/interaction/KeyboardPan~KeyboardPan}.
 * @api
 */ class $10c5ac6339d0ad8b$var$KeyboardZoom extends (0, $24f38e4defed3bcd$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        super();
        options = options ? options : {};
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.condition ? options.condition : function(mapBrowserEvent) {
            return !(0, $638912a122b4daef$export$32603ad571dd22b5)(mapBrowserEvent) && (0, $638912a122b4daef$export$e5570ca80cd8fd54)(mapBrowserEvent);
        };
        /**
     * @private
     * @type {number}
     */ this.delta_ = options.delta ? options.delta : 1;
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 100;
    }
    /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} if it was a
   * `KeyEvent`, and decides whether to zoom in or out (depending on whether the
   * key pressed was '+' or '-').
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @override
   */ handleEvent(mapBrowserEvent) {
        let stopEvent = false;
        if (mapBrowserEvent.type == (0, $b5fa963342da4935$export$2e2bcd8739ae039).KEYDOWN || mapBrowserEvent.type == (0, $b5fa963342da4935$export$2e2bcd8739ae039).KEYPRESS) {
            const keyEvent = /** @type {KeyboardEvent} */ mapBrowserEvent.originalEvent;
            const key = keyEvent.key;
            if (this.condition_(mapBrowserEvent) && (key === '+' || key === '-')) {
                const map = mapBrowserEvent.map;
                const delta = key === '+' ? this.delta_ : -this.delta_;
                const view = map.getView();
                (0, $24f38e4defed3bcd$export$ace321ff2a8016ef)(view, delta, undefined, this.duration_);
                keyEvent.preventDefault();
                stopEvent = true;
            }
        }
        return !stopEvent;
    }
}
var $10c5ac6339d0ad8b$export$2e2bcd8739ae039 = $10c5ac6339d0ad8b$var$KeyboardZoom;



/**
 * @module ol/interaction/PinchRotate
 */ 


/**
 * @typedef {Object} Options
 * @property {number} [duration=250] The duration of the animation in
 * milliseconds.
 * @property {number} [threshold=0.3] Minimal angle in radians to start a rotation.
 */ /**
 * @classdesc
 * Allows the user to rotate the map by twisting with two fingers
 * on a touch screen.
 * @api
 */ class $111f6b7ffbc56a50$var$PinchRotate extends (0, $21bd437a923ad8cf$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        const pointerOptions = /** @type {import("./Pointer.js").Options} */ options;
        if (!pointerOptions.stopDown) pointerOptions.stopDown = (0, $bc15bca7780ad95b$export$8f11cee4bdc7e668);
        super(pointerOptions);
        /**
     * @private
     * @type {import("../coordinate.js").Coordinate}
     */ this.anchor_ = null;
        /**
     * @private
     * @type {number|undefined}
     */ this.lastAngle_ = undefined;
        /**
     * @private
     * @type {boolean}
     */ this.rotating_ = false;
        /**
     * @private
     * @type {number}
     */ this.rotationDelta_ = 0.0;
        /**
     * @private
     * @type {number}
     */ this.threshold_ = options.threshold !== undefined ? options.threshold : 0.3;
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 250;
    }
    /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @override
   */ handleDragEvent(mapBrowserEvent) {
        let rotationDelta = 0.0;
        const touch0 = this.targetPointers[0];
        const touch1 = this.targetPointers[1];
        // angle between touches
        const angle = Math.atan2(touch1.clientY - touch0.clientY, touch1.clientX - touch0.clientX);
        if (this.lastAngle_ !== undefined) {
            const delta = angle - this.lastAngle_;
            this.rotationDelta_ += delta;
            if (!this.rotating_ && Math.abs(this.rotationDelta_) > this.threshold_) this.rotating_ = true;
            rotationDelta = delta;
        }
        this.lastAngle_ = angle;
        const map = mapBrowserEvent.map;
        const view = map.getView();
        if (view.getConstraints().rotation === (0, $a4b2c7f4b045b17d$export$e20fbacbb41798b)) return;
        // rotate anchor point.
        // FIXME: should be the intersection point between the lines:
        //     touch0,touch1 and previousTouch0,previousTouch1
        this.anchor_ = map.getCoordinateFromPixelInternal(map.getEventPixel((0, $21bd437a923ad8cf$export$e2a20c553f6c85ce)(this.targetPointers)));
        // rotate
        if (this.rotating_) {
            map.render();
            view.adjustRotationInternal(rotationDelta, this.anchor_);
        }
    }
    /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleUpEvent(mapBrowserEvent) {
        if (this.targetPointers.length < 2) {
            const map = mapBrowserEvent.map;
            const view = map.getView();
            view.endInteraction(this.duration_);
            return false;
        }
        return true;
    }
    /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleDownEvent(mapBrowserEvent) {
        if (this.targetPointers.length >= 2) {
            const map = mapBrowserEvent.map;
            this.anchor_ = null;
            this.lastAngle_ = undefined;
            this.rotating_ = false;
            this.rotationDelta_ = 0.0;
            if (!this.handlingDownUpSequence) map.getView().beginInteraction();
            return true;
        }
        return false;
    }
}
var $111f6b7ffbc56a50$export$2e2bcd8739ae039 = $111f6b7ffbc56a50$var$PinchRotate;


/**
 * @module ol/interaction/PinchZoom
 */ 

/**
 * @typedef {Object} Options
 * @property {number} [duration=400] Animation duration in milliseconds.
 */ /**
 * @classdesc
 * Allows the user to zoom the map by pinching with two fingers
 * on a touch screen.
 * @api
 */ class $91e5d4a47c126b0d$var$PinchZoom extends (0, $21bd437a923ad8cf$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        const pointerOptions = /** @type {import("./Pointer.js").Options} */ options;
        if (!pointerOptions.stopDown) pointerOptions.stopDown = (0, $bc15bca7780ad95b$export$8f11cee4bdc7e668);
        super(pointerOptions);
        /**
     * @private
     * @type {import("../coordinate.js").Coordinate}
     */ this.anchor_ = null;
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 400;
        /**
     * @private
     * @type {number|undefined}
     */ this.lastDistance_ = undefined;
        /**
     * @private
     * @type {number}
     */ this.lastScaleDelta_ = 1;
    }
    /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @override
   */ handleDragEvent(mapBrowserEvent) {
        let scaleDelta = 1.0;
        const touch0 = this.targetPointers[0];
        const touch1 = this.targetPointers[1];
        const dx = touch0.clientX - touch1.clientX;
        const dy = touch0.clientY - touch1.clientY;
        // distance between touches
        const distance = Math.sqrt(dx * dx + dy * dy);
        if (this.lastDistance_ !== undefined) scaleDelta = this.lastDistance_ / distance;
        this.lastDistance_ = distance;
        const map = mapBrowserEvent.map;
        const view = map.getView();
        if (scaleDelta != 1.0) this.lastScaleDelta_ = scaleDelta;
        // scale anchor point.
        this.anchor_ = map.getCoordinateFromPixelInternal(map.getEventPixel((0, $21bd437a923ad8cf$export$e2a20c553f6c85ce)(this.targetPointers)));
        // scale, bypass the resolution constraint
        map.render();
        view.adjustResolutionInternal(scaleDelta, this.anchor_);
    }
    /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleUpEvent(mapBrowserEvent) {
        if (this.targetPointers.length < 2) {
            const map = mapBrowserEvent.map;
            const view = map.getView();
            const direction = this.lastScaleDelta_ > 1 ? 1 : -1;
            view.endInteraction(this.duration_, direction);
            return false;
        }
        return true;
    }
    /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleDownEvent(mapBrowserEvent) {
        if (this.targetPointers.length >= 2) {
            const map = mapBrowserEvent.map;
            this.anchor_ = null;
            this.lastDistance_ = undefined;
            this.lastScaleDelta_ = 1;
            if (!this.handlingDownUpSequence) map.getView().beginInteraction();
            return true;
        }
        return false;
    }
}
var $91e5d4a47c126b0d$export$2e2bcd8739ae039 = $91e5d4a47c126b0d$var$PinchZoom;


function $18994d5cfd7e8f85$export$ebe90cb607ad99e(options) {
    options = options ? options : {};
    /** @type {Collection<import("./Interaction.js").default>} */ const interactions = new (0, $e1f99232eb9bff27$export$2e2bcd8739ae039)();
    const kinetic = new (0, $7d556ebdaefd511a$export$2e2bcd8739ae039)(-0.005, 0.05, 100);
    const altShiftDragRotate = options.altShiftDragRotate !== undefined ? options.altShiftDragRotate : true;
    if (altShiftDragRotate) interactions.push(new (0, $91e1f60136545f66$export$2e2bcd8739ae039)());
    const doubleClickZoom = options.doubleClickZoom !== undefined ? options.doubleClickZoom : true;
    if (doubleClickZoom) interactions.push(new (0, $a1ba7279e77eb328$export$2e2bcd8739ae039)({
        delta: options.zoomDelta,
        duration: options.zoomDuration
    }));
    const dragPan = options.dragPan !== undefined ? options.dragPan : true;
    if (dragPan) interactions.push(new (0, $fbb92ebf821804c2$export$2e2bcd8739ae039)({
        onFocusOnly: options.onFocusOnly,
        kinetic: kinetic
    }));
    const pinchRotate = options.pinchRotate !== undefined ? options.pinchRotate : true;
    if (pinchRotate) interactions.push(new (0, $111f6b7ffbc56a50$export$2e2bcd8739ae039)());
    const pinchZoom = options.pinchZoom !== undefined ? options.pinchZoom : true;
    if (pinchZoom) interactions.push(new (0, $91e5d4a47c126b0d$export$2e2bcd8739ae039)({
        duration: options.zoomDuration
    }));
    const keyboard = options.keyboard !== undefined ? options.keyboard : true;
    if (keyboard) {
        interactions.push(new (0, $accd6354e6bdfe20$export$2e2bcd8739ae039)());
        interactions.push(new (0, $10c5ac6339d0ad8b$export$2e2bcd8739ae039)({
            delta: options.zoomDelta,
            duration: options.zoomDuration
        }));
    }
    const mouseWheelZoom = options.mouseWheelZoom !== undefined ? options.mouseWheelZoom : true;
    if (mouseWheelZoom) interactions.push(new (0, $f18552b5a876d636$export$2e2bcd8739ae039)({
        onFocusOnly: options.onFocusOnly,
        duration: options.zoomDuration
    }));
    const shiftDragZoom = options.shiftDragZoom !== undefined ? options.shiftDragZoom : true;
    if (shiftDragZoom) interactions.push(new (0, $2279cbb831360107$export$2e2bcd8739ae039)({
        duration: options.zoomDuration
    }));
    return interactions;
}


/**
 * @module ol/layer/Group
 */ 










/**
 * @enum {string}
 */ const $7b793edad973bda2$var$GroupEventType = {
    /**
   * Triggered when a layer is added
   * @event GroupEvent#addlayer
   * @api
   */ ADDLAYER: 'addlayer',
    /**
   * Triggered when a layer is removed
   * @event GroupEvent#removelayer
   * @api
   */ REMOVELAYER: 'removelayer'
};
class $7b793edad973bda2$export$2f5ff21d758d25a7 extends (0, $5c6b0a43c077a98f$export$2e2bcd8739ae039) {
    /**
   * @param {GroupEventType} type The event type.
   * @param {BaseLayer} layer The layer.
   */ constructor(type, layer){
        super(type);
        /**
     * The added or removed layer.
     * @type {BaseLayer}
     * @api
     */ this.layer = layer;
    }
}
/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("./Base").BaseLayerObjectEventTypes|
 *     'change:layers', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<'addlayer'|'removelayer', GroupEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("./Base").BaseLayerObjectEventTypes|'addlayer'|'removelayer'|'change:layers', Return>} GroupOnSignature
 */ /**
 * @typedef {Object} Options
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {Array<import("./Base.js").default>|Collection<import("./Base.js").default>} [layers] Child layers.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */ /**
 * @enum {string}
 * @private
 */ const $7b793edad973bda2$var$Property = {
    LAYERS: 'layers'
};
/**
 * @classdesc
 * A {@link module:ol/Collection~Collection} of layers that are handled together.
 *
 * A generic `change` event is triggered when the group/Collection changes.
 *
 * @fires GroupEvent
 * @api
 */ class $7b793edad973bda2$var$LayerGroup extends (0, $499e541616b1f6f1$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Layer options.
   */ constructor(options){
        options = options || {};
        const baseOptions = /** @type {Options} */ Object.assign({}, options);
        delete baseOptions.layers;
        let layers = options.layers;
        super(baseOptions);
        /***
     * @type {GroupOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {GroupOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {GroupOnSignature<void>}
     */ this.un;
        /**
     * @private
     * @type {Array<import("../events.js").EventsKey>}
     */ this.layersListenerKeys_ = [];
        /**
     * @private
     * @type {Object<string, Array<import("../events.js").EventsKey>>}
     */ this.listenerKeys_ = {};
        this.addChangeListener($7b793edad973bda2$var$Property.LAYERS, this.handleLayersChanged_);
        if (layers) {
            if (Array.isArray(layers)) layers = new (0, $e1f99232eb9bff27$export$2e2bcd8739ae039)(layers.slice(), {
                unique: true
            });
            else (0, $71eb897bda873684$export$a7a9523472993e97)(typeof /** @type {?} */ layers.getArray === 'function', 'Expected `layers` to be an array or a `Collection`');
        } else layers = new (0, $e1f99232eb9bff27$export$2e2bcd8739ae039)(undefined, {
            unique: true
        });
        this.setLayers(layers);
    }
    /**
   * @private
   */ handleLayerChange_() {
        this.changed();
    }
    /**
   * @private
   */ handleLayersChanged_() {
        this.layersListenerKeys_.forEach((0, $63963d09e0c49405$export$b0a21c8b3c1c921));
        this.layersListenerKeys_.length = 0;
        const layers = this.getLayers();
        this.layersListenerKeys_.push((0, $63963d09e0c49405$export$63174c828edd6ff8)(layers, (0, $ea71ddfe3b669b23$export$2e2bcd8739ae039).ADD, this.handleLayersAdd_, this), (0, $63963d09e0c49405$export$63174c828edd6ff8)(layers, (0, $ea71ddfe3b669b23$export$2e2bcd8739ae039).REMOVE, this.handleLayersRemove_, this));
        for(const id in this.listenerKeys_)this.listenerKeys_[id].forEach((0, $63963d09e0c49405$export$b0a21c8b3c1c921));
        (0, $9f2b61a1df00e9b3$export$42ffd38884aecdac)(this.listenerKeys_);
        const layersArray = layers.getArray();
        for(let i = 0, ii = layersArray.length; i < ii; i++){
            const layer = layersArray[i];
            this.registerLayerListeners_(layer);
            this.dispatchEvent(new $7b793edad973bda2$export$2f5ff21d758d25a7($7b793edad973bda2$var$GroupEventType.ADDLAYER, layer));
        }
        this.changed();
    }
    /**
   * @param {BaseLayer} layer The layer.
   */ registerLayerListeners_(layer) {
        const listenerKeys = [
            (0, $63963d09e0c49405$export$63174c828edd6ff8)(layer, (0, $ff212aeaa481a85e$export$2e2bcd8739ae039).PROPERTYCHANGE, this.handleLayerChange_, this),
            (0, $63963d09e0c49405$export$63174c828edd6ff8)(layer, (0, $b5fa963342da4935$export$2e2bcd8739ae039).CHANGE, this.handleLayerChange_, this)
        ];
        if (layer instanceof $7b793edad973bda2$var$LayerGroup) listenerKeys.push((0, $63963d09e0c49405$export$63174c828edd6ff8)(layer, $7b793edad973bda2$var$GroupEventType.ADDLAYER, this.handleLayerGroupAdd_, this), (0, $63963d09e0c49405$export$63174c828edd6ff8)(layer, $7b793edad973bda2$var$GroupEventType.REMOVELAYER, this.handleLayerGroupRemove_, this));
        this.listenerKeys_[(0, $fd76d391cc228565$export$5e82334337e0f204)(layer)] = listenerKeys;
    }
    /**
   * @param {GroupEvent} event The layer group event.
   */ handleLayerGroupAdd_(event) {
        this.dispatchEvent(new $7b793edad973bda2$export$2f5ff21d758d25a7($7b793edad973bda2$var$GroupEventType.ADDLAYER, event.layer));
    }
    /**
   * @param {GroupEvent} event The layer group event.
   */ handleLayerGroupRemove_(event) {
        this.dispatchEvent(new $7b793edad973bda2$export$2f5ff21d758d25a7($7b793edad973bda2$var$GroupEventType.REMOVELAYER, event.layer));
    }
    /**
   * @param {import("../Collection.js").CollectionEvent<import("./Base.js").default>} collectionEvent CollectionEvent.
   * @private
   */ handleLayersAdd_(collectionEvent) {
        const layer = collectionEvent.element;
        this.registerLayerListeners_(layer);
        this.dispatchEvent(new $7b793edad973bda2$export$2f5ff21d758d25a7($7b793edad973bda2$var$GroupEventType.ADDLAYER, layer));
        this.changed();
    }
    /**
   * @param {import("../Collection.js").CollectionEvent<import("./Base.js").default>} collectionEvent CollectionEvent.
   * @private
   */ handleLayersRemove_(collectionEvent) {
        const layer = collectionEvent.element;
        const key = (0, $fd76d391cc228565$export$5e82334337e0f204)(layer);
        this.listenerKeys_[key].forEach((0, $63963d09e0c49405$export$b0a21c8b3c1c921));
        delete this.listenerKeys_[key];
        this.dispatchEvent(new $7b793edad973bda2$export$2f5ff21d758d25a7($7b793edad973bda2$var$GroupEventType.REMOVELAYER, layer));
        this.changed();
    }
    /**
   * Returns the {@link module:ol/Collection~Collection collection} of {@link module:ol/layer/Layer~Layer layers}
   * in this group.
   * @return {!Collection<import("./Base.js").default>} Collection of
   *   {@link module:ol/layer/Base~BaseLayer layers} that are part of this group.
   * @observable
   * @api
   */ getLayers() {
        return /** @type {!Collection<import("./Base.js").default>} */ this.get($7b793edad973bda2$var$Property.LAYERS);
    }
    /**
   * Set the {@link module:ol/Collection~Collection collection} of {@link module:ol/layer/Layer~Layer layers}
   * in this group.
   * @param {!Collection<import("./Base.js").default>} layers Collection of
   *   {@link module:ol/layer/Base~BaseLayer layers} that are part of this group.
   * @observable
   * @api
   */ setLayers(layers) {
        const collection = this.getLayers();
        if (collection) {
            const currentLayers = collection.getArray();
            for(let i = 0, ii = currentLayers.length; i < ii; ++i)this.dispatchEvent(new $7b793edad973bda2$export$2f5ff21d758d25a7($7b793edad973bda2$var$GroupEventType.REMOVELAYER, currentLayers[i]));
        }
        this.set($7b793edad973bda2$var$Property.LAYERS, layers);
    }
    /**
   * @param {Array<import("./Layer.js").default>} [array] Array of layers (to be modified in place).
   * @return {Array<import("./Layer.js").default>} Array of layers.
   * @override
   */ getLayersArray(array) {
        array = array !== undefined ? array : [];
        this.getLayers().forEach(function(layer) {
            layer.getLayersArray(array);
        });
        return array;
    }
    /**
   * Get the layer states list and use this groups z-index as the default
   * for all layers in this and nested groups, if it is unset at this point.
   * If dest is not provided and this group's z-index is undefined
   * 0 is used a the default z-index.
   * @param {Array<import("./Layer.js").State>} [dest] Optional list
   * of layer states (to be modified in place).
   * @return {Array<import("./Layer.js").State>} List of layer states.
   * @override
   */ getLayerStatesArray(dest) {
        const states = dest !== undefined ? dest : [];
        const pos = states.length;
        this.getLayers().forEach(function(layer) {
            layer.getLayerStatesArray(states);
        });
        const ownLayerState = this.getLayerState();
        let defaultZIndex = ownLayerState.zIndex;
        if (!dest && ownLayerState.zIndex === undefined) defaultZIndex = 0;
        for(let i = pos, ii = states.length; i < ii; i++){
            const layerState = states[i];
            layerState.opacity *= ownLayerState.opacity;
            layerState.visible = layerState.visible && ownLayerState.visible;
            layerState.maxResolution = Math.min(layerState.maxResolution, ownLayerState.maxResolution);
            layerState.minResolution = Math.max(layerState.minResolution, ownLayerState.minResolution);
            layerState.minZoom = Math.max(layerState.minZoom, ownLayerState.minZoom);
            layerState.maxZoom = Math.min(layerState.maxZoom, ownLayerState.maxZoom);
            if (ownLayerState.extent !== undefined) {
                if (layerState.extent !== undefined) layerState.extent = (0, $dea65c2f666fa450$export$72209efa88586d42)(layerState.extent, ownLayerState.extent);
                else layerState.extent = ownLayerState.extent;
            }
            if (layerState.zIndex === undefined) layerState.zIndex = defaultZIndex;
        }
        return states;
    }
    /**
   * @return {import("../source/Source.js").State} Source state.
   * @override
   */ getSourceState() {
        return 'ready';
    }
}
var $7b793edad973bda2$export$2e2bcd8739ae039 = $7b793edad973bda2$var$LayerGroup;






/**
 * @module ol/renderer/Composite
 */ 










/**
 * @module ol/renderer/Map
 */ 







/**
 * @template T
 * @typedef HitMatch
 * @property {import("../Feature.js").FeatureLike} feature Feature.
 * @property {import("../layer/Layer.js").default} layer Layer.
 * @property {import("../geom/SimpleGeometry.js").default} geometry Geometry.
 * @property {number} distanceSq Squared distance.
 * @property {import("./vector.js").FeatureCallback<T>} callback Callback.
 */ /**
 * @abstract
 */ class $bc68532edeef5692$var$MapRenderer extends (0, $1f0239b94d40ee35$export$2e2bcd8739ae039) {
    /**
   * @param {import("../Map.js").default} map Map.
   */ constructor(map){
        super();
        /**
     * @private
     * @type {import("../Map.js").default}
     */ this.map_ = map;
    }
    /**
   * @abstract
   * @param {import("../render/EventType.js").default} type Event type.
   * @param {import("../Map.js").FrameState} frameState Frame state.
   */ dispatchRenderEvent(type, frameState) {
        (0, $fd76d391cc228565$export$817eb92a8194bab0)();
    }
    /**
   * @param {import("../Map.js").FrameState} frameState FrameState.
   * @protected
   */ calculateMatrices2D(frameState) {
        const viewState = frameState.viewState;
        const coordinateToPixelTransform = frameState.coordinateToPixelTransform;
        const pixelToCoordinateTransform = frameState.pixelToCoordinateTransform;
        (0, $dff5a03e015694d8$export$f672e0b6f7222cd7)(coordinateToPixelTransform, frameState.size[0] / 2, frameState.size[1] / 2, 1 / viewState.resolution, -1 / viewState.resolution, -viewState.rotation, -viewState.center[0], -viewState.center[1]);
        (0, $dff5a03e015694d8$export$bd70ea2a93c0fa4)(pixelToCoordinateTransform, coordinateToPixelTransform);
    }
    /**
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("../Map.js").FrameState} frameState FrameState.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @param {boolean} checkWrapped Check for wrapped geometries.
   * @param {import("./vector.js").FeatureCallback<T>} callback Feature callback.
   * @param {S} thisArg Value to use as `this` when executing `callback`.
   * @param {function(this: U, import("../layer/Layer.js").default): boolean} layerFilter Layer filter
   *     function, only layers which are visible and for which this function
   *     returns `true` will be tested for features.  By default, all visible
   *     layers will be tested.
   * @param {U} thisArg2 Value to use as `this` when executing `layerFilter`.
   * @return {T|undefined} Callback result.
   * @template S,T,U
   */ forEachFeatureAtCoordinate(coordinate, frameState, hitTolerance, checkWrapped, callback, thisArg, layerFilter, thisArg2) {
        let result;
        const viewState = frameState.viewState;
        /**
     * @param {boolean} managed Managed layer.
     * @param {import("../Feature.js").FeatureLike} feature Feature.
     * @param {import("../layer/Layer.js").default} layer Layer.
     * @param {import("../geom/Geometry.js").default} geometry Geometry.
     * @return {T|undefined} Callback result.
     */ function forEachFeatureAtCoordinate(managed, feature, layer, geometry) {
            return callback.call(thisArg, feature, managed ? layer : null, geometry);
        }
        const projection = viewState.projection;
        const translatedCoordinate = (0, $a6adb03fd2fbc071$export$39a9ce3624977b84)(coordinate.slice(), projection);
        const offsets = [
            [
                0,
                0
            ]
        ];
        if (projection.canWrapX() && checkWrapped) {
            const projectionExtent = projection.getExtent();
            const worldWidth = (0, $dea65c2f666fa450$export$3c49c185de0c2bfc)(projectionExtent);
            offsets.push([
                -worldWidth,
                0
            ], [
                worldWidth,
                0
            ]);
        }
        const layerStates = frameState.layerStatesArray;
        const numLayers = layerStates.length;
        const matches = /** @type {Array<HitMatch<T>>} */ [];
        const tmpCoord = [];
        for(let i = 0; i < offsets.length; i++)for(let j = numLayers - 1; j >= 0; --j){
            const layerState = layerStates[j];
            const layer = layerState.layer;
            if (layer.hasRenderer() && (0, $af81f8f05dcf2037$export$acb1e9cb9ce4ca56)(layerState, viewState) && layerFilter.call(thisArg2, layer)) {
                const layerRenderer = layer.getRenderer();
                const source = layer.getSource();
                if (layerRenderer && source) {
                    const coordinates = source.getWrapX() ? translatedCoordinate : coordinate;
                    const callback = forEachFeatureAtCoordinate.bind(null, layerState.managed);
                    tmpCoord[0] = coordinates[0] + offsets[i][0];
                    tmpCoord[1] = coordinates[1] + offsets[i][1];
                    result = layerRenderer.forEachFeatureAtCoordinate(tmpCoord, frameState, hitTolerance, callback, matches);
                }
                if (result) return result;
            }
        }
        if (matches.length === 0) return undefined;
        const order = 1 / matches.length;
        matches.forEach((m, i)=>m.distanceSq += i * order);
        matches.sort((a, b)=>a.distanceSq - b.distanceSq);
        matches.some((m)=>{
            return result = m.callback(m.feature, m.layer, m.geometry);
        });
        return result;
    }
    /**
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("../Map.js").FrameState} frameState FrameState.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @param {boolean} checkWrapped Check for wrapped geometries.
   * @param {function(this: U, import("../layer/Layer.js").default): boolean} layerFilter Layer filter
   *     function, only layers which are visible and for which this function
   *     returns `true` will be tested for features.  By default, all visible
   *     layers will be tested.
   * @param {U} thisArg Value to use as `this` when executing `layerFilter`.
   * @return {boolean} Is there a feature at the given coordinate?
   * @template U
   */ hasFeatureAtCoordinate(coordinate, frameState, hitTolerance, checkWrapped, layerFilter, thisArg) {
        const hasFeature = this.forEachFeatureAtCoordinate(coordinate, frameState, hitTolerance, checkWrapped, (0, $bc15bca7780ad95b$export$22e23a2304399231), this, layerFilter, thisArg);
        return hasFeature !== undefined;
    }
    /**
   * @return {import("../Map.js").default} Map.
   */ getMap() {
        return this.map_;
    }
    /**
   * Render.
   * @abstract
   * @param {?import("../Map.js").FrameState} frameState Frame state.
   */ renderFrame(frameState) {
        (0, $fd76d391cc228565$export$817eb92a8194bab0)();
    }
    /**
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @protected
   */ scheduleExpireIconCache(frameState) {
        if ((0, $3f062f3a3d0ff66a$export$747ccdf771a87ab8).canExpireCache()) frameState.postRenderFunctions.push($bc68532edeef5692$var$expireIconCache);
    }
}
/**
 * @param {import("../Map.js").default} map Map.
 * @param {import("../Map.js").FrameState} frameState Frame state.
 */ function $bc68532edeef5692$var$expireIconCache(map, frameState) {
    (0, $3f062f3a3d0ff66a$export$747ccdf771a87ab8).expire();
}
var $bc68532edeef5692$export$2e2bcd8739ae039 = $bc68532edeef5692$var$MapRenderer;


/**
 * @classdesc
 * Canvas map renderer.
 * @api
 */ class $3643aa66e99da098$var$CompositeMapRenderer extends (0, $bc68532edeef5692$export$2e2bcd8739ae039) {
    /**
   * @param {import("../Map.js").default} map Map.
   */ constructor(map){
        super(map);
        /**
     * @private
     * @type {import("../events.js").EventsKey}
     */ this.fontChangeListenerKey_ = (0, $63963d09e0c49405$export$63174c828edd6ff8)((0, $6a4acf19c5e548d6$export$1d36981fcadac93b), (0, $ff212aeaa481a85e$export$2e2bcd8739ae039).PROPERTYCHANGE, map.redrawText, map);
        /**
     * @private
     * @type {HTMLDivElement}
     */ this.element_ = (0, $32d41268b5f53567$export$98fcef3dc9973292) ? (0, $b6f6d442e8ff57e1$export$45b7f73d625b5cde)() : document.createElement('div');
        const style = this.element_.style;
        style.position = 'absolute';
        style.width = '100%';
        style.height = '100%';
        style.zIndex = '0';
        this.element_.className = (0, $d3be093641aea1c1$export$1afde3d6e16a7b29) + ' ol-layers';
        const container = map.getViewport();
        if (container) // maps in a worker do not have a viewport.
        container.insertBefore(this.element_, container.firstChild || null);
        /**
     * @private
     * @type {Array<HTMLElement>}
     */ this.children_ = [];
        /**
     * @private
     * @type {boolean}
     */ this.renderedVisible_ = true;
    }
    /**
   * @param {import("../render/EventType.js").default} type Event type.
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @override
   */ dispatchRenderEvent(type, frameState) {
        const map = this.getMap();
        if (map.hasListener(type)) {
            const event = new (0, $e974dfa6f9f27b98$export$2e2bcd8739ae039)(type, undefined, frameState);
            map.dispatchEvent(event);
        }
    }
    /**
   * @override
   */ disposeInternal() {
        (0, $63963d09e0c49405$export$b0a21c8b3c1c921)(this.fontChangeListenerKey_);
        this.element_.remove();
        super.disposeInternal();
    }
    /**
   * Render.
   * @param {?import("../Map.js").FrameState} frameState Frame state.
   * @override
   */ renderFrame(frameState) {
        if (!frameState) {
            if (this.renderedVisible_) {
                this.element_.style.display = 'none';
                this.renderedVisible_ = false;
            }
            return;
        }
        this.calculateMatrices2D(frameState);
        this.dispatchRenderEvent((0, $6e54630f610adff4$export$2e2bcd8739ae039).PRECOMPOSE, frameState);
        const layerStatesArray = frameState.layerStatesArray.sort((a, b)=>a.zIndex - b.zIndex);
        const declutter = layerStatesArray.some((layerState)=>layerState.layer instanceof (0, $56912d183e066438$export$2e2bcd8739ae039) && layerState.layer.getDeclutter());
        if (declutter) // Some layers need decluttering, turn on deferred rendering hint
        frameState.declutter = {};
        const viewState = frameState.viewState;
        this.children_.length = 0;
        const renderedLayerStates = [];
        let previousElement = null;
        for(let i = 0, ii = layerStatesArray.length; i < ii; ++i){
            const layerState = layerStatesArray[i];
            frameState.layerIndex = i;
            const layer = layerState.layer;
            const sourceState = layer.getSourceState();
            if (!(0, $af81f8f05dcf2037$export$acb1e9cb9ce4ca56)(layerState, viewState) || sourceState != 'ready' && sourceState != 'undefined') {
                layer.unrender();
                continue;
            }
            const element = layer.render(frameState, previousElement);
            if (!element) continue;
            if (element !== previousElement) {
                this.children_.push(element);
                previousElement = element;
            }
            renderedLayerStates.push(layerState);
        }
        this.declutter(frameState, renderedLayerStates);
        (0, $b6f6d442e8ff57e1$export$caeacfe04f52533a)(this.element_, this.children_);
        const map = this.getMap();
        const mapCanvas = map.getTargetElement();
        if ((0, $b6f6d442e8ff57e1$export$4b05d74c82e4c4d2)(mapCanvas)) {
            // Canvas composition when container is a canvas
            const mapContext = mapCanvas.getContext('2d');
            for (const container of this.children_){
                const canvas = container.firstElementChild || container;
                const backgroundColor = container.style.backgroundColor;
                if (backgroundColor && (!(0, $b6f6d442e8ff57e1$export$4b05d74c82e4c4d2)(canvas) || canvas.width > 0)) {
                    mapContext.fillStyle = backgroundColor;
                    mapContext.fillRect(0, 0, mapCanvas.width, mapCanvas.height);
                }
                if ((0, $b6f6d442e8ff57e1$export$4b05d74c82e4c4d2)(canvas) && canvas.width > 0) {
                    mapContext.save();
                    const opacity = container.style.opacity || canvas.style.opacity;
                    mapContext.globalAlpha = opacity === '' ? 1 : Number(opacity);
                    const transform = canvas.style.transform;
                    if (transform) // Get the transform parameters from the style's transform matrix
                    mapContext.transform(.../** @type {[number, number, number, number, number, number]} */ (0, $dff5a03e015694d8$export$3004f64547af360e)(transform));
                    else {
                        const w = parseFloat(canvas.style.width) / canvas.width;
                        const h = parseFloat(canvas.style.height) / canvas.height;
                        mapContext.transform(w, 0, 0, h, 0, 0);
                    }
                    mapContext.drawImage(canvas, 0, 0);
                    mapContext.restore();
                }
            }
        }
        this.dispatchRenderEvent((0, $6e54630f610adff4$export$2e2bcd8739ae039).POSTCOMPOSE, frameState);
        if (!this.renderedVisible_) {
            this.element_.style.display = '';
            this.renderedVisible_ = true;
        }
        this.scheduleExpireIconCache(frameState);
    }
    /**
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @param {Array<import('../layer/Layer.js').State>} layerStates Layers.
   */ declutter(frameState, layerStates) {
        if (!frameState.declutter) return;
        for(let i = layerStates.length - 1; i >= 0; --i){
            const layerState = layerStates[i];
            const layer = layerState.layer;
            if (layer.getDeclutter()) layer.renderDeclutter(frameState, layerState);
        }
        layerStates.forEach((layerState)=>layerState.layer.renderDeferred(frameState));
    }
}
var $3643aa66e99da098$export$2e2bcd8739ae039 = $3643aa66e99da098$var$CompositeMapRenderer;





/**
 * State of the current frame. Only `pixelRatio`, `time` and `viewState` should
 * be used in applications.
 * @typedef {Object} FrameState
 * @property {number} pixelRatio The pixel ratio of the frame.
 * @property {number} time The time when rendering of the frame was requested.
 * @property {import("./View.js").State} viewState The state of the current view.
 * @property {boolean} animate Animate.
 * @property {import("./transform.js").Transform} coordinateToPixelTransform CoordinateToPixelTransform.
 * @property {Object<string, import("rbush").default<import('./render/canvas/Executor.js').DeclutterEntry>>|null} declutter
 * Declutter trees by declutter group.
 * When null, no decluttering is needed because no layers have decluttering enabled.
 * @property {null|import("./extent.js").Extent} extent Extent (in view projection coordinates).
 * @property {import("./extent.js").Extent} [nextExtent] Next extent during an animation series.
 * @property {number} index Index.
 * @property {Array<import("./layer/Layer.js").State>} layerStatesArray LayerStatesArray.
 * @property {number} layerIndex LayerIndex.
 * @property {import("./transform.js").Transform} pixelToCoordinateTransform PixelToCoordinateTransform.
 * @property {Array<PostRenderFunction>} postRenderFunctions PostRenderFunctions.
 * @property {import("./size.js").Size} size Size.
 * @property {TileQueue} tileQueue TileQueue.
 * @property {!Object<string, Object<string, boolean>>} usedTiles UsedTiles.
 * @property {Array<number>} viewHints ViewHints.
 * @property {!Object<string, Object<string, boolean>>} wantedTiles WantedTiles.
 * @property {string} mapId The id of the map.
 * @property {Object<string, boolean>} renderTargets Identifiers of previously rendered elements.
 */ /**
 * @typedef {function(Map, FrameState): any} PostRenderFunction
 */ /**
 * @typedef {Object} AtPixelOptions
 * @property {undefined|function(import("./layer/Layer.js").default<import("./source/Source").default>): boolean} [layerFilter] Layer filter
 * function. The filter function will receive one argument, the
 * {@link module:ol/layer/Layer~Layer layer-candidate} and it should return a boolean value.
 * Only layers which are visible and for which this function returns `true`
 * will be tested for features. By default, all visible layers will be tested.
 * @property {number} [hitTolerance=0] Hit-detection tolerance in css pixels. Pixels
 * inside the radius around the given position will be checked for features.
 * @property {boolean} [checkWrapped=true] Check-Wrapped Will check for wrapped geometries inside the range of
 *   +/- 1 world width. Works only if a projection is used that can be wrapped.
 */ /**
 * @typedef {Object} MapOptionsInternal
 * @property {Collection<import("./control/Control.js").default>} [controls] Controls.
 * @property {Collection<import("./interaction/Interaction.js").default>} [interactions] Interactions.
 * @property {HTMLElement|Document} keyboardEventTarget KeyboardEventTarget.
 * @property {Collection<import("./Overlay.js").default>} overlays Overlays.
 * @property {Object<string, *>} values Values.
 */ /**
 * @typedef {import("./ObjectEventType").Types|'change:layergroup'|'change:size'|'change:target'|'change:view'} MapObjectEventTypes
 */ /***
 * @template Return
 * @typedef {import("./Observable").OnSignature<import("./Observable").EventTypes, import("./events/Event.js").default, Return> &
 *    import("./Observable").OnSignature<MapObjectEventTypes, import("./Object").ObjectEvent, Return> &
 *    import("./Observable").OnSignature<import("./MapBrowserEventType").Types, import("./MapBrowserEvent").default, Return> &
 *    import("./Observable").OnSignature<import("./MapEventType").Types, import("./MapEvent").default, Return> &
 *    import("./Observable").OnSignature<import("./render/EventType").MapRenderEventTypes, import("./render/Event").default, Return> &
 *    import("./Observable").CombinedOnSignature<import("./Observable").EventTypes|MapObjectEventTypes|
 *      import("./MapBrowserEventType").Types|import("./MapEventType").Types|
 *      import("./render/EventType").MapRenderEventTypes, Return>} MapEventHandler
 */ /**
 * Object literal with config options for the map.
 * @typedef {Object} MapOptions
 * @property {Collection<import("./control/Control.js").default>|Array<import("./control/Control.js").default>} [controls]
 * Controls initially added to the map. If not specified,
 * {@link module:ol/control/defaults.defaults} is used. In a worker, no controls are added by default.
 * @property {number} [pixelRatio=window.devicePixelRatio] The ratio between
 * physical pixels and device-independent pixels (dips) on the device.
 * @property {Collection<import("./interaction/Interaction.js").default>|Array<import("./interaction/Interaction.js").default>} [interactions]
 * Interactions that are initially added to the map. If not specified,
 * {@link module:ol/interaction/defaults.defaults} is used. In a worker, no interactions are added by default.
 * @property {HTMLElement|Document|string} [keyboardEventTarget] The element to
 * listen to keyboard events on. This determines when the `KeyboardPan` and
 * `KeyboardZoom` interactions trigger. For example, if this option is set to
 * `document` the keyboard interactions will always trigger. If this option is
 * not specified, the element the library listens to keyboard events on is the
 * map target (i.e. the user-provided div for the map). If this is not
 * `document`, the target element needs to be focused for key events to be
 * emitted, requiring that the target element has a `tabindex` attribute.
 * @property {Array<import("./layer/Base.js").default>|Collection<import("./layer/Base.js").default>|LayerGroup} [layers]
 * Layers. If this is not defined, a map with no layers will be rendered. Note
 * that layers are rendered in the order supplied, so if you want, for example,
 * a vector layer to appear on top of a tile layer, it must come after the tile
 * layer.
 * @property {number} [maxTilesLoading=16] Maximum number tiles to load
 * simultaneously.
 * @property {number} [moveTolerance=1] The minimum distance in pixels the
 * cursor must move to be detected as a map move event instead of a click.
 * Increasing this value can make it easier to click on the map.
 * @property {Collection<import("./Overlay.js").default>|Array<import("./Overlay.js").default>} [overlays]
 * Overlays initially added to the map. By default, no overlays are added.
 * @property {HTMLElement|string|HTMLCanvasElement|OffscreenCanvas} [target] The container for the map, either the
 * element itself or the `id` of the element. If not specified at construction
 * time, {@link module:ol/Map~Map#setTarget} must be called for the map to be
 * rendered. If passed by element, the container can be in a secondary document.
 * For use in workers or when exporting a map, use an `OffscreenCanvas` or `HTMLCanvasElement` as target,
 * with a width and height in physical pixels, optionally multiplied by and a scale transform matching
 * the map's pixel ratio.
 * For accessibility (focus and keyboard events for map navigation), the `target` element must have a
 *  properly configured `tabindex` attribute. If the `target` element is inside a Shadow DOM, the
 *  `tabindex` atribute must be set on the custom element's host element.
 * **Note:** CSS `transform` support for the target element is limited to `scale`.
 * @property {View|Promise<import("./View.js").ViewOptions>} [view] The map's view.  No layer sources will be
 * fetched unless this is specified at construction time or through
 * {@link module:ol/Map~Map#setView}.
 */ /**
 * @param {import("./layer/Base.js").default} layer Layer.
 */ function $fe544abd54013409$var$removeLayerMapProperty(layer) {
    if (layer instanceof (0, $af81f8f05dcf2037$export$2e2bcd8739ae039)) {
        layer.setMapInternal(null);
        return;
    }
    if (layer instanceof (0, $7b793edad973bda2$export$2e2bcd8739ae039)) layer.getLayers().forEach($fe544abd54013409$var$removeLayerMapProperty);
}
/**
 * @param {import("./layer/Base.js").default} layer Layer.
 * @param {Map} map Map.
 */ function $fe544abd54013409$var$setLayerMapProperty(layer, map) {
    if (layer instanceof (0, $af81f8f05dcf2037$export$2e2bcd8739ae039)) {
        layer.setMapInternal(map);
        return;
    }
    if (layer instanceof (0, $7b793edad973bda2$export$2e2bcd8739ae039)) {
        const layers = layer.getLayers().getArray();
        for(let i = 0, ii = layers.length; i < ii; ++i)$fe544abd54013409$var$setLayerMapProperty(layers[i], map);
    }
}
/**
 * @classdesc
 * The map is the core component of OpenLayers. For a map to render, a view,
 * one or more layers, and a target container are needed:
 *
 *     import Map from 'ol/Map.js';
 *     import View from 'ol/View.js';
 *     import TileLayer from 'ol/layer/Tile.js';
 *     import OSM from 'ol/source/OSM.js';
 *
 *     const map = new Map({
 *       view: new View({
 *         center: [0, 0],
 *         zoom: 1,
 *       }),
 *       layers: [
 *         new TileLayer({
 *           source: new OSM(),
 *         }),
 *       ],
 *       target: 'map',
 *     });
 *
 * The above snippet creates a map using a {@link module:ol/layer/Tile~TileLayer} to
 * display {@link module:ol/source/OSM~OSM} OSM data and render it to a DOM
 * element with the id `map`.
 *
 * The constructor places a viewport container (with CSS class name
 * `ol-viewport`) in the target element (see `getViewport()`), and then two
 * further elements within the viewport: one with CSS class name
 * `ol-overlaycontainer-stopevent` for controls and some overlays, and one with
 * CSS class name `ol-overlaycontainer` for other overlays (see the `stopEvent`
 * option of {@link module:ol/Overlay~Overlay} for the difference). The map
 * itself is placed in a further element within the viewport.
 *
 * Layers are stored as a {@link module:ol/Collection~Collection} in
 * layerGroups. A top-level group is provided by the library. This is what is
 * accessed by `getLayerGroup` and `setLayerGroup`. Layers entered in the
 * options are added to this group, and `addLayer` and `removeLayer` change the
 * layer collection in the group. `getLayers` is a convenience function for
 * `getLayerGroup().getLayers()`. Note that {@link module:ol/layer/Group~LayerGroup}
 * is a subclass of {@link module:ol/layer/Base~BaseLayer}, so layers entered in the
 * options or added with `addLayer` can be groups, which can contain further
 * groups, and so on.
 *
 * @fires import("./MapBrowserEvent.js").MapBrowserEvent
 * @fires import("./MapEvent.js").MapEvent
 * @fires import("./render/Event.js").default#precompose
 * @fires import("./render/Event.js").default#postcompose
 * @fires import("./render/Event.js").default#rendercomplete
 * @api
 */ class $fe544abd54013409$var$Map extends (0, $4862cdcc23257f5b$export$2e2bcd8739ae039) {
    /**
   * @param {MapOptions} [options] Map options.
   */ constructor(options){
        super();
        options = options || {};
        /***
     * @type {MapEventHandler<import("./events").EventsKey>}
     */ this.on;
        /***
     * @type {MapEventHandler<import("./events").EventsKey>}
     */ this.once;
        /***
     * @type {MapEventHandler<void>}
     */ this.un;
        const optionsInternal = $fe544abd54013409$var$createOptionsInternal(options);
        /**
     * @private
     * @type {boolean}
     */ this.renderComplete_ = false;
        /**
     * @private
     * @type {boolean}
     */ this.loaded_ = true;
        /** @private */ this.boundHandleBrowserEvent_ = this.handleBrowserEvent.bind(this);
        /**
     * @type {number}
     * @private
     */ this.maxTilesLoading_ = options.maxTilesLoading !== undefined ? options.maxTilesLoading : 16;
        /**
     * @private
     * @type {number}
     */ this.pixelRatio_ = options.pixelRatio !== undefined ? options.pixelRatio : (0, $32d41268b5f53567$export$6b83a0446fc26f94);
        /**
     * @private
     * @type {ReturnType<typeof setTimeout>}
     */ this.postRenderTimeoutHandle_;
        /**
     * @private
     * @type {number|undefined}
     */ this.animationDelayKey_;
        /**
     * @private
     */ this.animationDelay_ = this.animationDelay_.bind(this);
        /**
     * @private
     * @type {import("./transform.js").Transform}
     */ this.coordinateToPixelTransform_ = (0, $dff5a03e015694d8$export$185802fd694ee1f5)();
        /**
     * @private
     * @type {import("./transform.js").Transform}
     */ this.pixelToCoordinateTransform_ = (0, $dff5a03e015694d8$export$185802fd694ee1f5)();
        /**
     * @private
     * @type {number}
     */ this.frameIndex_ = 0;
        /**
     * @private
     * @type {?FrameState}
     */ this.frameState_ = null;
        /**
     * The extent at the previous 'moveend' event.
     * @private
     * @type {import("./extent.js").Extent}
     */ this.previousExtent_ = null;
        /**
     * @private
     * @type {?import("./events.js").EventsKey}
     */ this.viewPropertyListenerKey_ = null;
        /**
     * @private
     * @type {?import("./events.js").EventsKey}
     */ this.viewChangeListenerKey_ = null;
        /**
     * @private
     * @type {?Array<import("./events.js").EventsKey>}
     */ this.layerGroupPropertyListenerKeys_ = null;
        /**
     * @private
     * @type {!HTMLElement}
     */ if (!(0, $32d41268b5f53567$export$98fcef3dc9973292)) {
            this.viewport_ = document.createElement('div');
            this.viewport_.className = 'ol-viewport' + ('ontouchstart' in window ? ' ol-touch' : '');
            this.viewport_.style.position = 'relative';
            this.viewport_.style.overflow = 'hidden';
            this.viewport_.style.width = '100%';
            this.viewport_.style.height = '100%';
            /**
       * @private
       * @type {!HTMLElement}
       */ this.overlayContainer_ = document.createElement('div');
            this.overlayContainer_.style.position = 'absolute';
            this.overlayContainer_.style.zIndex = '0';
            this.overlayContainer_.style.width = '100%';
            this.overlayContainer_.style.height = '100%';
            this.overlayContainer_.style.pointerEvents = 'none';
            this.overlayContainer_.className = 'ol-overlaycontainer';
            this.viewport_.appendChild(this.overlayContainer_);
            /**
       * @private
       * @type {!HTMLElement}
       */ this.overlayContainerStopEvent_ = document.createElement('div');
            this.overlayContainerStopEvent_.style.position = 'absolute';
            this.overlayContainerStopEvent_.style.zIndex = '0';
            this.overlayContainerStopEvent_.style.width = '100%';
            this.overlayContainerStopEvent_.style.height = '100%';
            this.overlayContainerStopEvent_.style.pointerEvents = 'none';
            this.overlayContainerStopEvent_.className = 'ol-overlaycontainer-stopevent';
            this.viewport_.appendChild(this.overlayContainerStopEvent_);
        }
        /**
     * @private
     * @type {MapBrowserEventHandler}
     */ this.mapBrowserEventHandler_ = null;
        /**
     * @private
     * @type {number}
     */ this.moveTolerance_ = options.moveTolerance;
        /**
     * @private
     * @type {HTMLElement|Document}
     */ this.keyboardEventTarget_ = optionsInternal.keyboardEventTarget;
        /**
     * @private
     * @type {?Array<import("./events.js").EventsKey>}
     */ this.targetChangeHandlerKeys_ = null;
        /**
     * @private
     * @type {HTMLElement|null}
     */ this.targetElement_ = null;
        if (!(0, $32d41268b5f53567$export$98fcef3dc9973292)) /**
       * @private
       * @type {ResizeObserver}
       */ this.resizeObserver_ = new ResizeObserver(()=>this.updateSize());
        /**
     * @type {Collection<import("./control/Control.js").default>}
     * @protected
     */ this.controls = optionsInternal.controls || ((0, $32d41268b5f53567$export$98fcef3dc9973292) ? new (0, $e1f99232eb9bff27$export$2e2bcd8739ae039)() : (0, $ec4b8275865f52de$export$ebe90cb607ad99e)());
        /**
     * @type {Collection<import("./interaction/Interaction.js").default>}
     * @protected
     */ this.interactions = optionsInternal.interactions || ((0, $32d41268b5f53567$export$98fcef3dc9973292) ? new (0, $e1f99232eb9bff27$export$2e2bcd8739ae039)() : (0, $18994d5cfd7e8f85$export$ebe90cb607ad99e)({
            onFocusOnly: true
        }));
        /**
     * @type {Collection<import("./Overlay.js").default>}
     * @private
     */ this.overlays_ = optionsInternal.overlays;
        /**
     * A lookup of overlays by id.
     * @private
     * @type {Object<string, import("./Overlay.js").default>}
     */ this.overlayIdIndex_ = {};
        /**
     * @type {import("./renderer/Map.js").default|null}
     * @private
     */ this.renderer_ = null;
        /**
     * @private
     * @type {!Array<PostRenderFunction>}
     */ this.postRenderFunctions_ = [];
        /**
     * @private
     * @type {TileQueue}
     */ this.tileQueue_ = new (0, $bd8e17c0efd883d0$export$2e2bcd8739ae039)(this.getTilePriority.bind(this), this.handleTileChange_.bind(this));
        this.addChangeListener((0, $9ffbaa2d2202cd6d$export$2e2bcd8739ae039).LAYERGROUP, this.handleLayerGroupChanged_);
        this.addChangeListener((0, $9ffbaa2d2202cd6d$export$2e2bcd8739ae039).VIEW, this.handleViewChanged_);
        this.addChangeListener((0, $9ffbaa2d2202cd6d$export$2e2bcd8739ae039).SIZE, this.handleSizeChanged_);
        this.addChangeListener((0, $9ffbaa2d2202cd6d$export$2e2bcd8739ae039).TARGET, this.handleTargetChanged_);
        // setProperties will trigger the rendering of the map if the map
        // is "defined" already.
        this.setProperties(optionsInternal.values);
        const map = this;
        if (options.view && !(options.view instanceof (0, $22c5be3317ad81f4$export$2e2bcd8739ae039))) options.view.then(function(viewOptions) {
            map.setView(new (0, $22c5be3317ad81f4$export$2e2bcd8739ae039)(viewOptions));
        });
        this.controls.addEventListener((0, $ea71ddfe3b669b23$export$2e2bcd8739ae039).ADD, /**
       * @param {import("./Collection.js").CollectionEvent<import("./control/Control.js").default>} event CollectionEvent
       */ (event)=>{
            event.element.setMap(this);
        });
        this.controls.addEventListener((0, $ea71ddfe3b669b23$export$2e2bcd8739ae039).REMOVE, /**
       * @param {import("./Collection.js").CollectionEvent<import("./control/Control.js").default>} event CollectionEvent.
       */ (event)=>{
            event.element.setMap(null);
        });
        this.interactions.addEventListener((0, $ea71ddfe3b669b23$export$2e2bcd8739ae039).ADD, /**
       * @param {import("./Collection.js").CollectionEvent<import("./interaction/Interaction.js").default>} event CollectionEvent.
       */ (event)=>{
            event.element.setMap(this);
        });
        this.interactions.addEventListener((0, $ea71ddfe3b669b23$export$2e2bcd8739ae039).REMOVE, /**
       * @param {import("./Collection.js").CollectionEvent<import("./interaction/Interaction.js").default>} event CollectionEvent.
       */ (event)=>{
            event.element.setMap(null);
        });
        this.overlays_.addEventListener((0, $ea71ddfe3b669b23$export$2e2bcd8739ae039).ADD, /**
       * @param {import("./Collection.js").CollectionEvent<import("./Overlay.js").default>} event CollectionEvent.
       */ (event)=>{
            this.addOverlayInternal_(event.element);
        });
        this.overlays_.addEventListener((0, $ea71ddfe3b669b23$export$2e2bcd8739ae039).REMOVE, /**
       * @param {import("./Collection.js").CollectionEvent<import("./Overlay.js").default>} event CollectionEvent.
       */ (event)=>{
            const id = event.element.getId();
            if (id !== undefined) delete this.overlayIdIndex_[id.toString()];
            event.element.setMap(null);
        });
        this.controls.forEach(/**
       * @param {import("./control/Control.js").default} control Control.
       */ (control)=>{
            control.setMap(this);
        });
        this.interactions.forEach(/**
       * @param {import("./interaction/Interaction.js").default} interaction Interaction.
       */ (interaction)=>{
            interaction.setMap(this);
        });
        this.overlays_.forEach(this.addOverlayInternal_.bind(this));
    }
    /**
   * Add the given control to the map.
   * @param {import("./control/Control.js").default} control Control.
   * @api
   */ addControl(control) {
        this.getControls().push(control);
    }
    /**
   * Add the given interaction to the map. If you want to add an interaction
   * at another point of the collection use `getInteractions()` and the methods
   * available on {@link module:ol/Collection~Collection}. This can be used to
   * stop the event propagation from the handleEvent function. The interactions
   * get to handle the events in the reverse order of this collection.
   * @param {import("./interaction/Interaction.js").default} interaction Interaction to add.
   * @api
   */ addInteraction(interaction) {
        this.getInteractions().push(interaction);
    }
    /**
   * Adds the given layer to the top of this map. If you want to add a layer
   * elsewhere in the stack, use `getLayers()` and the methods available on
   * {@link module:ol/Collection~Collection}.
   * @param {import("./layer/Base.js").default} layer Layer.
   * @api
   */ addLayer(layer) {
        const layers = this.getLayerGroup().getLayers();
        layers.push(layer);
    }
    /**
   * @param {import("./layer/Group.js").GroupEvent} event The layer add event.
   * @private
   */ handleLayerAdd_(event) {
        $fe544abd54013409$var$setLayerMapProperty(event.layer, this);
    }
    /**
   * Add the given overlay to the map.
   * @param {import("./Overlay.js").default} overlay Overlay.
   * @api
   */ addOverlay(overlay) {
        this.getOverlays().push(overlay);
    }
    /**
   * This deals with map's overlay collection changes.
   * @param {import("./Overlay.js").default} overlay Overlay.
   * @private
   */ addOverlayInternal_(overlay) {
        const id = overlay.getId();
        if (id !== undefined) this.overlayIdIndex_[id.toString()] = overlay;
        overlay.setMap(this);
    }
    /**
   *
   * Clean up.
   * @override
   */ disposeInternal() {
        this.controls.clear();
        this.interactions.clear();
        this.overlays_.clear();
        this.resizeObserver_?.disconnect();
        this.setTarget(null);
        super.disposeInternal();
    }
    /**
   * Detect features that intersect a pixel on the viewport, and execute a
   * callback with each intersecting feature. Layers included in the detection can
   * be configured through the `layerFilter` option in `options`.
   * For polygons without a fill, only the stroke will be used for hit detection.
   * Polygons must have a fill style applied to ensure that pixels inside a polygon are detected.
   * The fill can be transparent.
   * @param {import("./pixel.js").Pixel} pixel Pixel.
   * @param {function(import("./Feature.js").FeatureLike, import("./layer/Layer.js").default<import("./source/Source").default>, import("./geom/SimpleGeometry.js").default): T} callback Feature callback. The callback will be
   *     called with two arguments. The first argument is one
   *     {@link module:ol/Feature~Feature feature} or
   *     {@link module:ol/render/Feature~RenderFeature render feature} at the pixel, the second is
   *     the {@link module:ol/layer/Layer~Layer layer} of the feature and will be null for
   *     unmanaged layers. To stop detection, callback functions can return a
   *     truthy value.
   * @param {AtPixelOptions} [options] Optional options.
   * @return {T|undefined} Callback result, i.e. the return value of last
   * callback execution, or the first truthy callback return value.
   * @template T
   * @api
   */ forEachFeatureAtPixel(pixel, callback, options) {
        if (!this.frameState_ || !this.renderer_) return;
        const coordinate = this.getCoordinateFromPixelInternal(pixel);
        options = options !== undefined ? options : {};
        const hitTolerance = options.hitTolerance !== undefined ? options.hitTolerance : 0;
        const layerFilter = options.layerFilter !== undefined ? options.layerFilter : (0, $bc15bca7780ad95b$export$22e23a2304399231);
        const checkWrapped = options.checkWrapped !== false;
        return this.renderer_.forEachFeatureAtCoordinate(coordinate, this.frameState_, hitTolerance, checkWrapped, callback, null, layerFilter, null);
    }
    /**
   * Get all features that intersect a pixel on the viewport.
   * For polygons without a fill, only the stroke will be used for hit detection.
   * Polygons must have a fill style applied to ensure that pixels inside a polygon are detected.
   * The fill can be transparent.
   * @param {import("./pixel.js").Pixel} pixel Pixel.
   * @param {AtPixelOptions} [options] Optional options.
   * @return {Array<import("./Feature.js").FeatureLike>} The detected features or
   * an empty array if none were found.
   * @api
   */ getFeaturesAtPixel(pixel, options) {
        const features = [];
        this.forEachFeatureAtPixel(pixel, function(feature) {
            features.push(feature);
        }, options);
        return features;
    }
    /**
   * Get all layers from all layer groups.
   * @return {Array<import("./layer/Layer.js").default>} Layers.
   * @api
   */ getAllLayers() {
        const layers = [];
        function addLayersFrom(layerGroup) {
            layerGroup.forEach(function(layer) {
                if (layer instanceof (0, $7b793edad973bda2$export$2e2bcd8739ae039)) addLayersFrom(layer.getLayers());
                else layers.push(layer);
            });
        }
        addLayersFrom(this.getLayers());
        return layers;
    }
    /**
   * Detect if features intersect a pixel on the viewport. Layers included in the
   * detection can be configured through the `layerFilter` option.
   * For polygons without a fill, only the stroke will be used for hit detection.
   * Polygons must have a fill style applied to ensure that pixels inside a polygon are detected.
   * The fill can be transparent.
   * @param {import("./pixel.js").Pixel} pixel Pixel.
   * @param {AtPixelOptions} [options] Optional options.
   * @return {boolean} Is there a feature at the given pixel?
   * @api
   */ hasFeatureAtPixel(pixel, options) {
        if (!this.frameState_ || !this.renderer_) return false;
        const coordinate = this.getCoordinateFromPixelInternal(pixel);
        options = options !== undefined ? options : {};
        const layerFilter = options.layerFilter !== undefined ? options.layerFilter : (0, $bc15bca7780ad95b$export$22e23a2304399231);
        const hitTolerance = options.hitTolerance !== undefined ? options.hitTolerance : 0;
        const checkWrapped = options.checkWrapped !== false;
        return this.renderer_.hasFeatureAtCoordinate(coordinate, this.frameState_, hitTolerance, checkWrapped, layerFilter, null);
    }
    /**
   * Returns the coordinate in user projection for a browser event.
   * @param {MouseEvent} event Event.
   * @return {import("./coordinate.js").Coordinate} Coordinate.
   * @api
   */ getEventCoordinate(event) {
        return this.getCoordinateFromPixel(this.getEventPixel(event));
    }
    /**
   * Returns the coordinate in view projection for a browser event.
   * @param {MouseEvent} event Event.
   * @return {import("./coordinate.js").Coordinate} Coordinate.
   */ getEventCoordinateInternal(event) {
        return this.getCoordinateFromPixelInternal(this.getEventPixel(event));
    }
    /**
   * Returns the map pixel position for a browser event relative to the viewport.
   * @param {UIEvent|{clientX: number, clientY: number}} event Event.
   * @return {import("./pixel.js").Pixel} Pixel.
   * @api
   */ getEventPixel(event) {
        const viewport = this.viewport_;
        const viewportPosition = viewport.getBoundingClientRect();
        const viewportSize = this.getSize();
        const scaleX = viewportPosition.width / viewportSize[0];
        const scaleY = viewportPosition.height / viewportSize[1];
        const eventPosition = //FIXME Are we really calling this with a TouchEvent anywhere?
        'changedTouches' in event ? /** @type {TouchEvent} */ event.changedTouches[0] : /** @type {MouseEvent} */ event;
        return [
            (eventPosition.clientX - viewportPosition.left) / scaleX,
            (eventPosition.clientY - viewportPosition.top) / scaleY
        ];
    }
    /**
   * Get the target in which this map is rendered.
   * Note that this returns what is entered as an option or in setTarget:
   * if that was an element, it returns an element; if a string, it returns that.
   * @return {HTMLElement|string|undefined} The Element or id of the Element that the
   *     map is rendered in.
   * @observable
   * @api
   */ getTarget() {
        return /** @type {HTMLElement|string|undefined} */ this.get((0, $9ffbaa2d2202cd6d$export$2e2bcd8739ae039).TARGET);
    }
    /**
   * Get the DOM element into which this map is rendered. In contrast to
   * `getTarget` this method always return an `Element`, or `null` if the
   * map has no target.
   * @return {HTMLElement} The element that the map is rendered in.
   * @api
   */ getTargetElement() {
        return this.targetElement_;
    }
    /**
   * Get the coordinate for a given pixel.  This returns a coordinate in the
   * user projection.
   * @param {import("./pixel.js").Pixel} pixel Pixel position in the map viewport.
   * @return {import("./coordinate.js").Coordinate} The coordinate for the pixel position.
   * @api
   */ getCoordinateFromPixel(pixel) {
        return (0, $a86eee1c28205a05$export$698f563af1ba02a5)(this.getCoordinateFromPixelInternal(pixel), this.getView().getProjection());
    }
    /**
   * Get the coordinate for a given pixel.  This returns a coordinate in the
   * map view projection.
   * @param {import("./pixel.js").Pixel} pixel Pixel position in the map viewport.
   * @return {import("./coordinate.js").Coordinate} The coordinate for the pixel position.
   */ getCoordinateFromPixelInternal(pixel) {
        const frameState = this.frameState_;
        if (!frameState) return null;
        return (0, $dff5a03e015694d8$export$5635d7ef4b8fee1c)(frameState.pixelToCoordinateTransform, pixel.slice());
    }
    /**
   * Get the map controls. Modifying this collection changes the controls
   * associated with the map.
   * @return {Collection<import("./control/Control.js").default>} Controls.
   * @api
   */ getControls() {
        return this.controls;
    }
    /**
   * Get the map overlays. Modifying this collection changes the overlays
   * associated with the map.
   * @return {Collection<import("./Overlay.js").default>} Overlays.
   * @api
   */ getOverlays() {
        return this.overlays_;
    }
    /**
   * Get an overlay by its identifier (the value returned by overlay.getId()).
   * Note that the index treats string and numeric identifiers as the same. So
   * `map.getOverlayById(2)` will return an overlay with id `'2'` or `2`.
   * @param {string|number} id Overlay identifier.
   * @return {import("./Overlay.js").default|null} Overlay.
   * @api
   */ getOverlayById(id) {
        const overlay = this.overlayIdIndex_[id.toString()];
        return overlay !== undefined ? overlay : null;
    }
    /**
   * Get the map interactions. Modifying this collection changes the interactions
   * associated with the map.
   *
   * Interactions are used for e.g. pan, zoom and rotate.
   * @return {Collection<import("./interaction/Interaction.js").default>} Interactions.
   * @api
   */ getInteractions() {
        return this.interactions;
    }
    /**
   * Get the layergroup associated with this map.
   * @return {LayerGroup} A layer group containing the layers in this map.
   * @observable
   * @api
   */ getLayerGroup() {
        return /** @type {LayerGroup} */ this.get((0, $9ffbaa2d2202cd6d$export$2e2bcd8739ae039).LAYERGROUP);
    }
    /**
   * Clear any existing layers and add layers to the map.
   * @param {Array<import("./layer/Base.js").default>|Collection<import("./layer/Base.js").default>} layers The layers to be added to the map.
   * @api
   */ setLayers(layers) {
        const group = this.getLayerGroup();
        if (layers instanceof (0, $e1f99232eb9bff27$export$2e2bcd8739ae039)) {
            group.setLayers(layers);
            return;
        }
        const collection = group.getLayers();
        collection.clear();
        collection.extend(layers);
    }
    /**
   * Get the collection of layers associated with this map.
   * @return {!Collection<import("./layer/Base.js").default>} Layers.
   * @api
   */ getLayers() {
        const layers = this.getLayerGroup().getLayers();
        return layers;
    }
    /**
   * @return {boolean} Layers have sources that are still loading.
   */ getLoadingOrNotReady() {
        const layerStatesArray = this.getLayerGroup().getLayerStatesArray();
        for(let i = 0, ii = layerStatesArray.length; i < ii; ++i){
            const state = layerStatesArray[i];
            if (!state.visible) continue;
            const renderer = state.layer.getRenderer();
            if (renderer && !renderer.ready) return true;
            const source = state.layer.getSource();
            if (source && source.loading) return true;
        }
        return false;
    }
    /**
   * Get the pixel for a coordinate.  This takes a coordinate in the user
   * projection and returns the corresponding pixel.
   * @param {import("./coordinate.js").Coordinate} coordinate A map coordinate.
   * @return {import("./pixel.js").Pixel} A pixel position in the map viewport.
   * @api
   */ getPixelFromCoordinate(coordinate) {
        const viewCoordinate = (0, $a86eee1c28205a05$export$d4b8ec0b96db1ee2)(coordinate, this.getView().getProjection());
        return this.getPixelFromCoordinateInternal(viewCoordinate);
    }
    /**
   * Get the pixel for a coordinate.  This takes a coordinate in the map view
   * projection and returns the corresponding pixel.
   * @param {import("./coordinate.js").Coordinate} coordinate A map coordinate.
   * @return {import("./pixel.js").Pixel} A pixel position in the map viewport.
   */ getPixelFromCoordinateInternal(coordinate) {
        const frameState = this.frameState_;
        if (!frameState) return null;
        return (0, $dff5a03e015694d8$export$5635d7ef4b8fee1c)(frameState.coordinateToPixelTransform, coordinate.slice(0, 2));
    }
    /**
   * Get the pixel ratio of the rendered map.
   * @return {number} Pixel ratio.
   * @api
   */ getPixelRatio() {
        return this.pixelRatio_;
    }
    /**
   * Set the pixel ratio of the rendered map.
   * @param {number} pixelRatio Pixel ratio.
   * @api
   */ setPixelRatio(pixelRatio) {
        if (this.pixelRatio_ === pixelRatio) return;
        this.pixelRatio_ = pixelRatio;
        this.render();
    }
    /**
   * Get the map renderer.
   * @return {import("./renderer/Map.js").default|null} Renderer
   */ getRenderer() {
        return this.renderer_;
    }
    /**
   * Get the size of this map.
   * @return {import("./size.js").Size|undefined} The size in pixels of the map in the DOM.
   * @observable
   * @api
   */ getSize() {
        return /** @type {import("./size.js").Size|undefined} */ this.get((0, $9ffbaa2d2202cd6d$export$2e2bcd8739ae039).SIZE);
    }
    /**
   * Get the view associated with this map. A view manages properties such as
   * center and resolution.
   * @return {View} The view that controls this map.
   * @observable
   * @api
   */ getView() {
        return /** @type {View} */ this.get((0, $9ffbaa2d2202cd6d$export$2e2bcd8739ae039).VIEW);
    }
    /**
   * Get the element that serves as the map viewport.
   * @return {HTMLElement} Viewport.
   * @api
   */ getViewport() {
        return this.viewport_;
    }
    /**
   * Get the element that serves as the container for overlays.  Elements added to
   * this container will let mousedown and touchstart events through to the map,
   * so clicks and gestures on an overlay will trigger {@link module:ol/MapBrowserEvent~MapBrowserEvent}
   * events.
   * @return {!HTMLElement} The map's overlay container.
   */ getOverlayContainer() {
        return this.overlayContainer_;
    }
    /**
   * Get the element that serves as a container for overlays that don't allow
   * event propagation. Elements added to this container won't let mousedown and
   * touchstart events through to the map, so clicks and gestures on an overlay
   * don't trigger any {@link module:ol/MapBrowserEvent~MapBrowserEvent}.
   * @return {!HTMLElement} The map's overlay container that stops events.
   */ getOverlayContainerStopEvent() {
        return this.overlayContainerStopEvent_;
    }
    /**
   * @return {!Document} The document where the map is displayed.
   */ getOwnerDocument() {
        const targetElement = this.getTargetElement();
        return targetElement ? targetElement.ownerDocument : document;
    }
    /**
   * @param {import("./Tile.js").default} tile Tile.
   * @param {string} tileSourceKey Tile source key.
   * @param {import("./coordinate.js").Coordinate} tileCenter Tile center.
   * @param {number} tileResolution Tile resolution.
   * @return {number} Tile priority.
   */ getTilePriority(tile, tileSourceKey, tileCenter, tileResolution) {
        return (0, $bd8e17c0efd883d0$export$f08ad5eceeff5d45)(this.frameState_, tile, tileSourceKey, tileCenter, tileResolution);
    }
    /**
   * @param {PointerEvent|KeyboardEvent|WheelEvent} browserEvent Browser event.
   * @param {string} [type] Type.
   */ handleBrowserEvent(browserEvent, type) {
        type = type || browserEvent.type;
        const mapBrowserEvent = new (0, $1e9a92005e196af9$export$2e2bcd8739ae039)(type, this, browserEvent);
        this.handleMapBrowserEvent(mapBrowserEvent);
    }
    /**
   * @param {MapBrowserEvent} mapBrowserEvent The event to handle.
   */ handleMapBrowserEvent(mapBrowserEvent) {
        if (!this.frameState_) // With no view defined, we cannot translate pixels into geographical
        // coordinates so interactions cannot be used.
        return;
        const originalEvent = mapBrowserEvent.originalEvent;
        const eventType = originalEvent.type;
        if (eventType === (0, $4b8b28c70a4b5328$export$2e2bcd8739ae039).POINTERDOWN || eventType === (0, $b5fa963342da4935$export$2e2bcd8739ae039).WHEEL || eventType === (0, $b5fa963342da4935$export$2e2bcd8739ae039).KEYDOWN) {
            const doc = this.getOwnerDocument();
            const rootNode = this.viewport_.getRootNode ? this.viewport_.getRootNode() : doc;
            const target = /** @type {Node} */ originalEvent.target;
            const currentDoc = rootNode instanceof ShadowRoot ? rootNode.host === target ? rootNode.host.ownerDocument : rootNode : rootNode === doc ? doc.documentElement : rootNode;
            if (// Abort if the target is a child of the container for elements whose events are not meant
            // to be handled by map interactions.
            this.overlayContainerStopEvent_.contains(target) || // Abort if the event target is a child of the container that is no longer in the page.
            // It's possible for the target to no longer be in the page if it has been removed in an
            // event listener, this might happen in a Control that recreates it's content based on
            // user interaction either manually or via a render in something like https://reactjs.org/
            !currentDoc.contains(target)) return;
        }
        mapBrowserEvent.frameState = this.frameState_;
        if (this.dispatchEvent(mapBrowserEvent) !== false) {
            const interactionsArray = this.getInteractions().getArray().slice();
            for(let i = interactionsArray.length - 1; i >= 0; i--){
                const interaction = interactionsArray[i];
                if (interaction.getMap() !== this || !interaction.getActive() || !this.getTargetElement()) continue;
                const cont = interaction.handleEvent(mapBrowserEvent);
                if (!cont || mapBrowserEvent.propagationStopped) break;
            }
        }
    }
    /**
   * @protected
   */ handlePostRender() {
        const frameState = this.frameState_;
        // Manage the tile queue
        // Image loads are expensive and a limited resource, so try to use them
        // efficiently:
        // * When the view is static we allow a large number of parallel tile loads
        //   to complete the frame as quickly as possible.
        // * When animating or interacting, image loads can cause janks, so we reduce
        //   the maximum number of loads per frame and limit the number of parallel
        //   tile loads to remain reactive to view changes and to reduce the chance of
        //   loading tiles that will quickly disappear from view.
        const tileQueue = this.tileQueue_;
        if (!tileQueue.isEmpty()) {
            let maxTotalLoading = this.maxTilesLoading_;
            let maxNewLoads = maxTotalLoading;
            if (frameState) {
                const hints = frameState.viewHints;
                if (hints[(0, $e4565fb1c11da106$export$2e2bcd8739ae039).ANIMATING] || hints[(0, $e4565fb1c11da106$export$2e2bcd8739ae039).INTERACTING]) {
                    const lowOnFrameBudget = Date.now() - frameState.time > 8;
                    maxTotalLoading = lowOnFrameBudget ? 0 : 8;
                    maxNewLoads = lowOnFrameBudget ? 0 : 2;
                }
            }
            if (tileQueue.getTilesLoading() < maxTotalLoading) {
                tileQueue.reprioritize(); // FIXME only call if view has changed
                tileQueue.loadMoreTiles(maxTotalLoading, maxNewLoads);
            }
        }
        if (frameState && this.renderer_ && !frameState.animate) {
            if (this.renderComplete_) {
                if (this.hasListener((0, $6e54630f610adff4$export$2e2bcd8739ae039).RENDERCOMPLETE)) this.renderer_.dispatchRenderEvent((0, $6e54630f610adff4$export$2e2bcd8739ae039).RENDERCOMPLETE, frameState);
                if (this.loaded_ === false) {
                    this.loaded_ = true;
                    this.dispatchEvent(new (0, $e44c6b7d9bfa1ac8$export$2e2bcd8739ae039)((0, $13d83f941f2fce32$export$2e2bcd8739ae039).LOADEND, this, frameState));
                }
            } else if (this.loaded_ === true) {
                this.loaded_ = false;
                this.dispatchEvent(new (0, $e44c6b7d9bfa1ac8$export$2e2bcd8739ae039)((0, $13d83f941f2fce32$export$2e2bcd8739ae039).LOADSTART, this, frameState));
            }
        }
        const postRenderFunctions = this.postRenderFunctions_;
        if (frameState) for(let i = 0, ii = postRenderFunctions.length; i < ii; ++i)postRenderFunctions[i](this, frameState);
        postRenderFunctions.length = 0;
    }
    /**
   * @private
   */ handleSizeChanged_() {
        if (this.getView() && !this.getView().getAnimating()) this.getView().resolveConstraints(0);
        this.render();
    }
    /**
   * @private
   */ handleTargetChanged_() {
        if (this.mapBrowserEventHandler_) {
            for(let i = 0, ii = this.targetChangeHandlerKeys_.length; i < ii; ++i)(0, $63963d09e0c49405$export$b0a21c8b3c1c921)(this.targetChangeHandlerKeys_[i]);
            this.targetChangeHandlerKeys_ = null;
            this.viewport_.removeEventListener((0, $b5fa963342da4935$export$2e2bcd8739ae039).CONTEXTMENU, this.boundHandleBrowserEvent_);
            this.viewport_.removeEventListener((0, $b5fa963342da4935$export$2e2bcd8739ae039).WHEEL, this.boundHandleBrowserEvent_);
            this.mapBrowserEventHandler_.dispose();
            this.mapBrowserEventHandler_ = null;
            this.viewport_.remove();
        }
        if (this.targetElement_ && !(0, $b6f6d442e8ff57e1$export$4b05d74c82e4c4d2)(this.targetElement_)) {
            this.resizeObserver_?.unobserve(this.targetElement_);
            const rootNode = this.targetElement_.getRootNode();
            if (rootNode instanceof ShadowRoot) this.resizeObserver_.unobserve(rootNode.host);
            this.setSize(undefined);
        }
        // target may be undefined, null, a string or an Element.
        // If it's a string we convert it to an Element before proceeding.
        // If it's not now an Element we remove the viewport from the DOM.
        // If it's an Element we append the viewport element to it.
        const target = this.getTarget();
        const targetElement = typeof target === 'string' ? document.getElementById(target) : target;
        this.targetElement_ = targetElement;
        if (!targetElement) {
            if (this.renderer_) {
                clearTimeout(this.postRenderTimeoutHandle_);
                this.postRenderTimeoutHandle_ = undefined;
                this.postRenderFunctions_.length = 0;
                this.renderer_.dispose();
                this.renderer_ = null;
            }
            if (this.animationDelayKey_) {
                cancelAnimationFrame(this.animationDelayKey_);
                this.animationDelayKey_ = undefined;
            }
        } else {
            if (!(0, $b6f6d442e8ff57e1$export$4b05d74c82e4c4d2)(targetElement)) targetElement.appendChild(this.viewport_);
            if (!this.renderer_) this.renderer_ = new (0, $3643aa66e99da098$export$2e2bcd8739ae039)(this);
            if (!(0, $b6f6d442e8ff57e1$export$4b05d74c82e4c4d2)(targetElement)) {
                this.mapBrowserEventHandler_ = new (0, $22122345cac37f85$export$2e2bcd8739ae039)(this, this.moveTolerance_);
                for(const key in 0, $1b4cb51f4587f284$export$2e2bcd8739ae039)this.mapBrowserEventHandler_.addEventListener((0, $1b4cb51f4587f284$export$2e2bcd8739ae039)[key], this.handleMapBrowserEvent.bind(this));
                this.viewport_.addEventListener((0, $b5fa963342da4935$export$2e2bcd8739ae039).CONTEXTMENU, this.boundHandleBrowserEvent_, false);
                this.viewport_.addEventListener((0, $b5fa963342da4935$export$2e2bcd8739ae039).WHEEL, this.boundHandleBrowserEvent_, (0, $32d41268b5f53567$export$f751ce96c6c4e4fc) ? {
                    passive: false
                } : false);
                let keyboardEventTarget;
                if (!this.keyboardEventTarget_) {
                    // check if map target is in shadowDOM, if yes use host element as target
                    const targetRoot = targetElement.getRootNode();
                    const targetCandidate = targetRoot instanceof ShadowRoot ? targetRoot.host : targetElement;
                    keyboardEventTarget = targetCandidate;
                } else keyboardEventTarget = this.keyboardEventTarget_;
                this.targetChangeHandlerKeys_ = [
                    (0, $63963d09e0c49405$export$63174c828edd6ff8)(keyboardEventTarget, (0, $b5fa963342da4935$export$2e2bcd8739ae039).KEYDOWN, this.handleBrowserEvent, this),
                    (0, $63963d09e0c49405$export$63174c828edd6ff8)(keyboardEventTarget, (0, $b5fa963342da4935$export$2e2bcd8739ae039).KEYPRESS, this.handleBrowserEvent, this)
                ];
                if (targetElement instanceof HTMLElement) {
                    const rootNode = targetElement.getRootNode();
                    if (rootNode instanceof ShadowRoot) this.resizeObserver_.observe(rootNode.host);
                    this.resizeObserver_?.observe(targetElement);
                }
            }
            this.updateSize();
        }
    // updateSize calls setSize, so no need to call this.render
    // ourselves here.
    }
    /**
   * @private
   */ handleTileChange_() {
        this.render();
    }
    /**
   * @private
   */ handleViewPropertyChanged_() {
        this.render();
    }
    /**
   * @private
   */ handleViewChanged_() {
        if (this.viewPropertyListenerKey_) {
            (0, $63963d09e0c49405$export$b0a21c8b3c1c921)(this.viewPropertyListenerKey_);
            this.viewPropertyListenerKey_ = null;
        }
        if (this.viewChangeListenerKey_) {
            (0, $63963d09e0c49405$export$b0a21c8b3c1c921)(this.viewChangeListenerKey_);
            this.viewChangeListenerKey_ = null;
        }
        const view = this.getView();
        if (view) {
            this.updateViewportSize_(this.getSize());
            this.viewPropertyListenerKey_ = (0, $63963d09e0c49405$export$63174c828edd6ff8)(view, (0, $ff212aeaa481a85e$export$2e2bcd8739ae039).PROPERTYCHANGE, this.handleViewPropertyChanged_, this);
            this.viewChangeListenerKey_ = (0, $63963d09e0c49405$export$63174c828edd6ff8)(view, (0, $b5fa963342da4935$export$2e2bcd8739ae039).CHANGE, this.handleViewPropertyChanged_, this);
            view.resolveConstraints(0);
        }
        this.render();
    }
    /**
   * @private
   */ handleLayerGroupChanged_() {
        if (this.layerGroupPropertyListenerKeys_) {
            this.layerGroupPropertyListenerKeys_.forEach((0, $63963d09e0c49405$export$b0a21c8b3c1c921));
            this.layerGroupPropertyListenerKeys_ = null;
        }
        const layerGroup = this.getLayerGroup();
        if (layerGroup) {
            this.handleLayerAdd_(new (0, $7b793edad973bda2$export$2f5ff21d758d25a7)('addlayer', layerGroup));
            this.layerGroupPropertyListenerKeys_ = [
                (0, $63963d09e0c49405$export$63174c828edd6ff8)(layerGroup, (0, $ff212aeaa481a85e$export$2e2bcd8739ae039).PROPERTYCHANGE, this.render, this),
                (0, $63963d09e0c49405$export$63174c828edd6ff8)(layerGroup, (0, $b5fa963342da4935$export$2e2bcd8739ae039).CHANGE, this.render, this),
                (0, $63963d09e0c49405$export$63174c828edd6ff8)(layerGroup, 'addlayer', this.handleLayerAdd_, this),
                (0, $63963d09e0c49405$export$63174c828edd6ff8)(layerGroup, 'removelayer', this.handleLayerRemove_, this)
            ];
        }
        this.render();
    }
    /**
   * @return {boolean} Is rendered.
   */ isRendered() {
        return !!this.frameState_;
    }
    /**
   * @private
   */ animationDelay_() {
        this.animationDelayKey_ = undefined;
        this.renderFrame_(Date.now());
    }
    /**
   * Requests an immediate render in a synchronous manner.
   * @api
   */ renderSync() {
        if (this.animationDelayKey_) cancelAnimationFrame(this.animationDelayKey_);
        this.animationDelay_();
    }
    /**
   * Redraws all text after new fonts have loaded
   */ redrawText() {
        if (!this.frameState_) return;
        const layerStates = this.frameState_.layerStatesArray;
        for(let i = 0, ii = layerStates.length; i < ii; ++i){
            const layer = layerStates[i].layer;
            if (layer.hasRenderer()) layer.getRenderer().handleFontsChanged();
        }
    }
    /**
   * Request a map rendering (at the next animation frame).
   * @api
   */ render() {
        if (this.renderer_ && this.animationDelayKey_ === undefined) this.animationDelayKey_ = requestAnimationFrame(this.animationDelay_);
    }
    /**
   * Remove the given control from the map.
   * @param {import("./control/Control.js").default} control Control.
   * @return {import("./control/Control.js").default|undefined} The removed control (or undefined
   *     if the control was not found).
   * @api
   */ removeControl(control) {
        return this.getControls().remove(control);
    }
    /**
   * Remove the given interaction from the map.
   * @param {import("./interaction/Interaction.js").default} interaction Interaction to remove.
   * @return {import("./interaction/Interaction.js").default|undefined} The removed interaction (or
   *     undefined if the interaction was not found).
   * @api
   */ removeInteraction(interaction) {
        return this.getInteractions().remove(interaction);
    }
    /**
   * Removes the given layer from the map.
   * @param {import("./layer/Base.js").default} layer Layer.
   * @return {import("./layer/Base.js").default|undefined} The removed layer (or undefined if the
   *     layer was not found).
   * @api
   */ removeLayer(layer) {
        const layers = this.getLayerGroup().getLayers();
        return layers.remove(layer);
    }
    /**
   * @param {import("./layer/Group.js").GroupEvent} event The layer remove event.
   * @private
   */ handleLayerRemove_(event) {
        $fe544abd54013409$var$removeLayerMapProperty(event.layer);
    }
    /**
   * Remove the given overlay from the map.
   * @param {import("./Overlay.js").default} overlay Overlay.
   * @return {import("./Overlay.js").default|undefined} The removed overlay (or undefined
   *     if the overlay was not found).
   * @api
   */ removeOverlay(overlay) {
        return this.getOverlays().remove(overlay);
    }
    /**
   * @param {number} time Time.
   * @private
   */ renderFrame_(time) {
        const size = this.getSize();
        const view = this.getView();
        const previousFrameState = this.frameState_;
        /** @type {?FrameState} */ let frameState = null;
        if (size !== undefined && (0, $625e418aeada4c0d$export$622c471beb1693c7)(size) && view && view.isDef()) {
            const viewHints = view.getHints(this.frameState_ ? this.frameState_.viewHints : undefined);
            const viewState = view.getState();
            frameState = {
                animate: false,
                coordinateToPixelTransform: this.coordinateToPixelTransform_,
                declutter: null,
                extent: (0, $dea65c2f666fa450$export$13ba650faf8308)(viewState.center, viewState.resolution, viewState.rotation, size),
                index: this.frameIndex_++,
                layerIndex: 0,
                layerStatesArray: this.getLayerGroup().getLayerStatesArray(),
                pixelRatio: this.pixelRatio_,
                pixelToCoordinateTransform: this.pixelToCoordinateTransform_,
                postRenderFunctions: [],
                size: size,
                tileQueue: this.tileQueue_,
                time: time,
                usedTiles: {},
                viewState: viewState,
                viewHints: viewHints,
                wantedTiles: {},
                mapId: (0, $fd76d391cc228565$export$5e82334337e0f204)(this),
                renderTargets: {}
            };
            if (viewState.nextCenter && viewState.nextResolution) {
                const rotation = isNaN(viewState.nextRotation) ? viewState.rotation : viewState.nextRotation;
                frameState.nextExtent = (0, $dea65c2f666fa450$export$13ba650faf8308)(viewState.nextCenter, viewState.nextResolution, rotation, size);
            }
        }
        this.frameState_ = frameState;
        this.renderer_.renderFrame(frameState);
        if (frameState) {
            if (frameState.animate) this.render();
            Array.prototype.push.apply(this.postRenderFunctions_, frameState.postRenderFunctions);
            if (previousFrameState) {
                const moveStart = !this.previousExtent_ || !(0, $dea65c2f666fa450$export$dd1bc94b04021eeb)(this.previousExtent_) && !(0, $dea65c2f666fa450$export$e9bab7fafb253603)(frameState.extent, this.previousExtent_);
                if (moveStart) {
                    this.dispatchEvent(new (0, $e44c6b7d9bfa1ac8$export$2e2bcd8739ae039)((0, $13d83f941f2fce32$export$2e2bcd8739ae039).MOVESTART, this, previousFrameState));
                    this.previousExtent_ = (0, $dea65c2f666fa450$export$3e2152b047719fa1)(this.previousExtent_);
                }
            }
            const idle = this.previousExtent_ && !frameState.viewHints[(0, $e4565fb1c11da106$export$2e2bcd8739ae039).ANIMATING] && !frameState.viewHints[(0, $e4565fb1c11da106$export$2e2bcd8739ae039).INTERACTING] && !(0, $dea65c2f666fa450$export$e9bab7fafb253603)(frameState.extent, this.previousExtent_);
            if (idle) {
                this.dispatchEvent(new (0, $e44c6b7d9bfa1ac8$export$2e2bcd8739ae039)((0, $13d83f941f2fce32$export$2e2bcd8739ae039).MOVEEND, this, frameState));
                (0, $dea65c2f666fa450$export$9cd59f9826255e47)(frameState.extent, this.previousExtent_);
            }
        }
        this.dispatchEvent(new (0, $e44c6b7d9bfa1ac8$export$2e2bcd8739ae039)((0, $13d83f941f2fce32$export$2e2bcd8739ae039).POSTRENDER, this, frameState));
        this.renderComplete_ = (this.hasListener((0, $13d83f941f2fce32$export$2e2bcd8739ae039).LOADSTART) || this.hasListener((0, $13d83f941f2fce32$export$2e2bcd8739ae039).LOADEND) || this.hasListener((0, $6e54630f610adff4$export$2e2bcd8739ae039).RENDERCOMPLETE)) && !this.tileQueue_.getTilesLoading() && !this.tileQueue_.getCount() && !this.getLoadingOrNotReady();
        if (!this.postRenderTimeoutHandle_) this.postRenderTimeoutHandle_ = setTimeout(()=>{
            this.postRenderTimeoutHandle_ = undefined;
            this.handlePostRender();
        }, 0);
    }
    /**
   * Sets the layergroup of this map.
   * @param {LayerGroup} layerGroup A layer group containing the layers in this map.
   * @observable
   * @api
   */ setLayerGroup(layerGroup) {
        const oldLayerGroup = this.getLayerGroup();
        if (oldLayerGroup) this.handleLayerRemove_(new (0, $7b793edad973bda2$export$2f5ff21d758d25a7)('removelayer', oldLayerGroup));
        this.set((0, $9ffbaa2d2202cd6d$export$2e2bcd8739ae039).LAYERGROUP, layerGroup);
    }
    /**
   * Set the size of this map.
   * @param {import("./size.js").Size|undefined} size The size in pixels of the map in the DOM.
   * @observable
   * @api
   */ setSize(size) {
        this.set((0, $9ffbaa2d2202cd6d$export$2e2bcd8739ae039).SIZE, size);
    }
    /**
   * Set the target element to render this map into.
   * For accessibility (focus and keyboard events for map navigation), the `target` element must have a
   *  properly configured `tabindex` attribute. If the `target` element is inside a Shadow DOM, the
   *  `tabindex` atribute must be set on the custom element's host element.
   * @param {HTMLElement|string} [target] The Element or id of the Element
   *     that the map is rendered in.
   * @observable
   * @api
   */ setTarget(target) {
        this.set((0, $9ffbaa2d2202cd6d$export$2e2bcd8739ae039).TARGET, target);
    }
    /**
   * Set the view for this map.
   * @param {View|Promise<import("./View.js").ViewOptions>|null} view The view that controls this map.
   * It is also possible to pass a promise that resolves to options for constructing a view.  This
   * alternative allows view properties to be resolved by sources or other components that load
   * view-related metadata.
   * @observable
   * @api
   */ setView(view) {
        if (!view || view instanceof (0, $22c5be3317ad81f4$export$2e2bcd8739ae039)) {
            this.set((0, $9ffbaa2d2202cd6d$export$2e2bcd8739ae039).VIEW, view);
            return;
        }
        this.set((0, $9ffbaa2d2202cd6d$export$2e2bcd8739ae039).VIEW, new (0, $22c5be3317ad81f4$export$2e2bcd8739ae039)());
        const map = this;
        view.then(function(viewOptions) {
            map.setView(new (0, $22c5be3317ad81f4$export$2e2bcd8739ae039)(viewOptions));
        });
    }
    /**
   * Force a recalculation of the map viewport size.  This should be called when
   * third-party code changes the size of the map viewport.
   * @api
   */ updateSize() {
        const targetElement = this.getTargetElement();
        let size = undefined;
        if (targetElement) {
            let width, height;
            if ((0, $b6f6d442e8ff57e1$export$4b05d74c82e4c4d2)(targetElement)) {
                const transform = targetElement.getContext('2d').getTransform();
                // Use scale components of the transform to calculate the size in CSS pixels
                width = targetElement.width / transform.a;
                height = targetElement.height / transform.d;
            } else {
                const computedStyle = getComputedStyle(targetElement);
                width = targetElement.offsetWidth - parseFloat(computedStyle['borderLeftWidth']) - parseFloat(computedStyle['paddingLeft']) - parseFloat(computedStyle['paddingRight']) - parseFloat(computedStyle['borderRightWidth']);
                height = targetElement.offsetHeight - parseFloat(computedStyle['borderTopWidth']) - parseFloat(computedStyle['paddingTop']) - parseFloat(computedStyle['paddingBottom']) - parseFloat(computedStyle['borderBottomWidth']);
            }
            if (!isNaN(width) && !isNaN(height)) {
                size = [
                    Math.max(0, width),
                    Math.max(0, height)
                ];
                if (!(0, $625e418aeada4c0d$export$622c471beb1693c7)(size) && !!(targetElement.offsetWidth || targetElement.offsetHeight || targetElement.getClientRects().length)) (0, $7636ffe0700f8dd9$export$c106dd0671a0fc2d)("No map visible because the map container's width or height are 0.");
            }
        }
        const oldSize = this.getSize();
        if (size && (!oldSize || !(0, $49313fcb0fc32abe$export$e9bab7fafb253603)(size, oldSize))) {
            this.setSize(size);
            this.updateViewportSize_(size);
        }
    }
    /**
   * Recomputes the viewport size and save it on the view object (if any)
   * @param {import("./size.js").Size|undefined} size The size.
   * @private
   */ updateViewportSize_(size) {
        const view = this.getView();
        if (view) view.setViewportSize(size);
    }
}
/**
 * @param {MapOptions} options Map options.
 * @return {MapOptionsInternal} Internal map options.
 */ function $fe544abd54013409$var$createOptionsInternal(options) {
    /**
   * @type {HTMLElement|Document}
   */ let keyboardEventTarget = null;
    if (options.keyboardEventTarget !== undefined) keyboardEventTarget = typeof options.keyboardEventTarget === 'string' ? document.getElementById(options.keyboardEventTarget) : options.keyboardEventTarget;
    /**
   * @type {Object<string, *>}
   */ const values = {};
    const layerGroup = options.layers && typeof /** @type {?} */ options.layers.getLayers === 'function' ? /** @type {LayerGroup} */ options.layers : new (0, $7b793edad973bda2$export$2e2bcd8739ae039)({
        layers: /** @type {Collection<import("./layer/Base.js").default>|Array<import("./layer/Base.js").default>} */ options.layers
    });
    values[(0, $9ffbaa2d2202cd6d$export$2e2bcd8739ae039).LAYERGROUP] = layerGroup;
    values[(0, $9ffbaa2d2202cd6d$export$2e2bcd8739ae039).TARGET] = options.target;
    values[(0, $9ffbaa2d2202cd6d$export$2e2bcd8739ae039).VIEW] = options.view instanceof (0, $22c5be3317ad81f4$export$2e2bcd8739ae039) ? options.view : new (0, $22c5be3317ad81f4$export$2e2bcd8739ae039)();
    /** @type {Collection<import("./control/Control.js").default>} */ let controls;
    if (options.controls !== undefined) {
        if (Array.isArray(options.controls)) controls = new (0, $e1f99232eb9bff27$export$2e2bcd8739ae039)(options.controls.slice());
        else {
            (0, $71eb897bda873684$export$a7a9523472993e97)(typeof /** @type {?} */ options.controls.getArray === 'function', 'Expected `controls` to be an array or an `ol/Collection.js`');
            controls = options.controls;
        }
    }
    /** @type {Collection<import("./interaction/Interaction").default>} */ let interactions;
    if (options.interactions !== undefined) {
        if (Array.isArray(options.interactions)) interactions = new (0, $e1f99232eb9bff27$export$2e2bcd8739ae039)(options.interactions.slice());
        else {
            (0, $71eb897bda873684$export$a7a9523472993e97)(typeof /** @type {?} */ options.interactions.getArray === 'function', 'Expected `interactions` to be an array or an `ol/Collection.js`');
            interactions = options.interactions;
        }
    }
    /** @type {Collection<import("./Overlay.js").default>} */ let overlays;
    if (options.overlays !== undefined) {
        if (Array.isArray(options.overlays)) overlays = new (0, $e1f99232eb9bff27$export$2e2bcd8739ae039)(options.overlays.slice());
        else {
            (0, $71eb897bda873684$export$a7a9523472993e97)(typeof /** @type {?} */ options.overlays.getArray === 'function', 'Expected `overlays` to be an array or an `ol/Collection.js`');
            overlays = options.overlays;
        }
    } else overlays = new (0, $e1f99232eb9bff27$export$2e2bcd8739ae039)();
    return {
        controls: controls,
        interactions: interactions,
        keyboardEventTarget: keyboardEventTarget,
        overlays: overlays,
        values: values
    };
}
var $fe544abd54013409$export$2e2bcd8739ae039 = $fe544abd54013409$var$Map;




/**
 * @module ol/layer/Image
 */ /**
 * @module ol/renderer/canvas/ImageLayer
 */ 





/**
 * @classdesc
 * Canvas renderer for image layers.
 * @api
 */ class $d49cba3dedcd64ca$var$CanvasImageLayerRenderer extends (0, $334f608456f9cc13$export$2e2bcd8739ae039) {
    /**
   * @param {import("../../layer/Image.js").default} imageLayer Image layer.
   */ constructor(imageLayer){
        super(imageLayer);
        /**
     * @protected
     * @type {?import("../../Image.js").default}
     */ this.image = null;
        /**
     * @private
     * @type {number}
     */ this.renderedSourceRevision_ = 0;
    }
    /**
   * @return {import('../../DataTile.js').ImageLike} Image.
   */ getImage() {
        return !this.image ? null : this.image.getImage();
    }
    /**
   * Determine whether render should be called.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @return {boolean} Layer is ready to be rendered.
   * @override
   */ prepareFrame(frameState) {
        const layerState = frameState.layerStatesArray[frameState.layerIndex];
        const pixelRatio = frameState.pixelRatio;
        const viewState = frameState.viewState;
        const viewResolution = viewState.resolution;
        const imageSource = this.getLayer().getSource();
        const hints = frameState.viewHints;
        let renderedExtent = frameState.extent;
        if (layerState.extent !== undefined) renderedExtent = (0, $dea65c2f666fa450$export$72209efa88586d42)(renderedExtent, (0, $a86eee1c28205a05$export$494be3a3a25689ca)(layerState.extent, viewState.projection));
        if (!hints[(0, $e4565fb1c11da106$export$2e2bcd8739ae039).ANIMATING] && !hints[(0, $e4565fb1c11da106$export$2e2bcd8739ae039).INTERACTING] && !(0, $dea65c2f666fa450$export$dd1bc94b04021eeb)(renderedExtent)) {
            if (imageSource) {
                if (!this.getLayer().rendered && this.renderedSourceRevision_ !== imageSource.getRevision()) this.image = null;
                this.renderedSourceRevision_ = imageSource.getRevision();
                const projection = viewState.projection;
                const image = imageSource.getImage(renderedExtent, viewResolution, pixelRatio, projection);
                if (image) {
                    if (this.loadImage(image)) this.image = image;
                    else if (image.getState() === (0, $f217251b3f1483a0$export$2e2bcd8739ae039).EMPTY) this.image = null;
                }
            } else this.image = null;
        }
        return !!this.image;
    }
    /**
   * @param {import("../../pixel.js").Pixel} pixel Pixel.
   * @return {Uint8ClampedArray} Data at the pixel location.
   * @override
   */ getData(pixel) {
        const frameState = this.frameState;
        if (!frameState) return null;
        const layer = this.getLayer();
        const coordinate = (0, $dff5a03e015694d8$export$5635d7ef4b8fee1c)(frameState.pixelToCoordinateTransform, pixel.slice());
        const layerExtent = layer.getExtent();
        if (layerExtent) {
            if (!(0, $dea65c2f666fa450$export$ac68c24d37ca240f)(layerExtent, coordinate)) return null;
        }
        const imageExtent = this.image.getExtent();
        const img = this.image.getImage();
        const imageMapWidth = (0, $dea65c2f666fa450$export$3c49c185de0c2bfc)(imageExtent);
        const col = Math.floor(img.width * ((coordinate[0] - imageExtent[0]) / imageMapWidth));
        if (col < 0 || col >= img.width) return null;
        const imageMapHeight = (0, $dea65c2f666fa450$export$c08559766941f856)(imageExtent);
        const row = Math.floor(img.height * ((imageExtent[3] - coordinate[1]) / imageMapHeight));
        if (row < 0 || row >= img.height) return null;
        return this.getImageData(img, col, row);
    }
    /**
   * Render the layer.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {HTMLElement} target Target that may be used to render content to.
   * @return {HTMLElement} The rendered element.
   * @override
   */ renderFrame(frameState, target) {
        const image = this.image;
        const imageExtent = image.getExtent();
        const imageResolution = image.getResolution();
        const [imageResolutionX, imageResolutionY] = Array.isArray(imageResolution) ? imageResolution : [
            imageResolution,
            imageResolution
        ];
        const imagePixelRatio = image.getPixelRatio();
        const layerState = frameState.layerStatesArray[frameState.layerIndex];
        const pixelRatio = frameState.pixelRatio;
        const viewState = frameState.viewState;
        const viewCenter = viewState.center;
        const viewResolution = viewState.resolution;
        const scaleX = pixelRatio * imageResolutionX / (viewResolution * imagePixelRatio);
        const scaleY = pixelRatio * imageResolutionY / (viewResolution * imagePixelRatio);
        this.prepareContainer(frameState, target);
        // desired dimensions of the canvas in pixels
        const width = this.context.canvas.width;
        const height = this.context.canvas.height;
        const context = this.getRenderContext(frameState);
        // clipped rendering if layer extent is set
        let clipped = false;
        let render = true;
        if (layerState.extent) {
            const layerExtent = (0, $a86eee1c28205a05$export$494be3a3a25689ca)(layerState.extent, viewState.projection);
            render = (0, $dea65c2f666fa450$export$7b0a31e10bbff018)(layerExtent, frameState.extent);
            clipped = render && !(0, $dea65c2f666fa450$export$be866b1e0809b17e)(layerExtent, frameState.extent);
            if (clipped) this.clipUnrotated(context, frameState, layerExtent);
        }
        const img = image.getImage();
        const transform = (0, $dff5a03e015694d8$export$f672e0b6f7222cd7)(this.tempTransform, width / 2, height / 2, scaleX, scaleY, 0, imagePixelRatio * (imageExtent[0] - viewCenter[0]) / imageResolutionX, imagePixelRatio * (viewCenter[1] - imageExtent[3]) / imageResolutionY);
        this.renderedResolution = imageResolutionY * pixelRatio / imagePixelRatio;
        const dw = img.width * transform[0];
        const dh = img.height * transform[3];
        if (!this.getLayer().getSource().getInterpolate()) context.imageSmoothingEnabled = false;
        this.preRender(context, frameState);
        if (render && dw >= 0.5 && dh >= 0.5) {
            const dx = transform[4];
            const dy = transform[5];
            const opacity = layerState.opacity;
            if (opacity !== 1) {
                context.save();
                context.globalAlpha = opacity;
            }
            context.drawImage(img, 0, 0, +img.width, +img.height, dx, dy, dw, dh);
            if (opacity !== 1) context.restore();
        }
        this.postRender(this.context, frameState);
        if (clipped) context.restore();
        context.imageSmoothingEnabled = true;
        return this.container;
    }
}
var $d49cba3dedcd64ca$export$2e2bcd8739ae039 = $d49cba3dedcd64ca$var$CanvasImageLayerRenderer;


/**
 * @module ol/layer/BaseImage
 */ 
/**
 * @template {import("../source/Image.js").default} ImageSourceType
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {import("../Map.js").default} [map] Sets the layer as overlay on a map. The map will not manage
 * this layer in its layers collection, and the layer will be rendered on top. This is useful for
 * temporary layers. The standard way to add a layer to a map and have it managed by the map is to
 * use {@link import("../Map.js").default#addLayer map.addLayer()}.
 * @property {ImageSourceType} [source] Source for this layer.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */ /**
 * @classdesc
 * Server-rendered images that are available for arbitrary extents and
 * resolutions.
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @template {import("../source/Image.js").default} ImageSourceType
 * @template {import("../renderer/Layer.js").default} RendererType
 * @extends {Layer<ImageSourceType, RendererType>}
 * @api
 */ class $558d3c29ad0d737f$var$BaseImageLayer extends (0, $af81f8f05dcf2037$export$2e2bcd8739ae039) {
    /**
   * @param {Options<ImageSourceType>} [options] Layer options.
   */ constructor(options){
        options = options ? options : {};
        super(options);
    }
}
var $558d3c29ad0d737f$export$2e2bcd8739ae039 = $558d3c29ad0d737f$var$BaseImageLayer;


/**
 * @classdesc
 * Server-rendered images that are available for arbitrary extents and
 * resolutions.
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @template {import("../source/Image.js").default} ImageSourceType
 * @extends {BaseImageLayer<ImageSourceType, CanvasImageLayerRenderer>}
 * @api
 */ class $6ffb4d96f7dfea2e$var$ImageLayer extends (0, $558d3c29ad0d737f$export$2e2bcd8739ae039) {
    /**
   * @param {import("./BaseImage.js").Options<ImageSourceType>} [options] Layer options.
   */ constructor(options){
        super(options);
    }
    /**
   * @override
   */ createRenderer() {
        return new (0, $d49cba3dedcd64ca$export$2e2bcd8739ae039)(this);
    }
    /**
   * Get data for a pixel location.  A four element RGBA array will be returned.  For requests outside the
   * layer extent, `null` will be returned.  Data for an image can only be retrieved if the
   * source's `crossOrigin` property is set.
   *
   * ```js
   * // display layer data on every pointer move
   * map.on('pointermove', (event) => {
   *   console.log(layer.getData(event.pixel));
   * });
   * ```
   * @param {import("../pixel").Pixel} pixel Pixel.
   * @return {Uint8ClampedArray|Uint8Array|Float32Array|DataView|null} Pixel data.
   * @api
   * @override
   */ getData(pixel) {
        return super.getData(pixel);
    }
}
var $6ffb4d96f7dfea2e$export$2e2bcd8739ae039 = $6ffb4d96f7dfea2e$var$ImageLayer;



/**
 * @module ol/source/OSM
 */ /**
 * @module ol/source/XYZ
 */ /**
 * @module ol/tilegrid
 */ 


/**
 * @module ol/tilegrid/TileGrid
 */ 








/**
 * @private
 * @type {import("../tilecoord.js").TileCoord}
 */ const $bc3c803236fb01b8$var$tmpTileCoord = [
    0,
    0,
    0
];
/**
 * Number of decimal digits to consider in integer values when rounding.
 * @type {number}
 */ const $bc3c803236fb01b8$var$DECIMALS = 5;
/**
 * @typedef {Object} Options
 * @property {import("../extent.js").Extent} [extent] Extent for the tile grid. No tiles outside this
 * extent will be requested by {@link module:ol/source/Tile~TileSource} sources. When no `origin` or
 * `origins` are configured, the `origin` will be set to the top-left corner of the extent.
 * @property {number} [minZoom=0] Minimum zoom.
 * @property {import("../coordinate.js").Coordinate} [origin] The tile grid origin, i.e. where the `x`
 * and `y` axes meet (`[z, 0, 0]`). Tile coordinates increase left to right and downwards. If not
 * specified, `extent` or `origins` must be provided.
 * @property {Array<import("../coordinate.js").Coordinate>} [origins] Tile grid origins, i.e. where
 * the `x` and `y` axes meet (`[z, 0, 0]`), for each zoom level. If given, the array length
 * should match the length of the `resolutions` array, i.e. each resolution can have a different
 * origin. Tile coordinates increase left to right and downwards. If not specified, `extent` or
 * `origin` must be provided.
 * @property {!Array<number>} resolutions Resolutions. The array index of each resolution needs
 * to match the zoom level. This means that even if a `minZoom` is configured, the resolutions
 * array will have a length of `maxZoom + 1`.
 * @property {Array<import("../size.js").Size>} [sizes] Number of tile rows and columns
 * of the grid for each zoom level. If specified the values
 * define each zoom level's extent together with the `origin` or `origins`.
 * A grid `extent` can be configured in addition, and will further limit the extent
 * for which tile requests are made by sources. If the bottom-left corner of
 * an extent is used as `origin` or `origins`, then the `y` value must be
 * negative because OpenLayers tile coordinates use the top left as the origin.
 * @property {number|import("../size.js").Size} [tileSize] Tile size.
 * Default is `[256, 256]`.
 * @property {Array<number|import("../size.js").Size>} [tileSizes] Tile sizes. If given, the array length
 * should match the length of the `resolutions` array, i.e. each resolution can have a different
 * tile size.
 */ /**
 * @classdesc
 * Base class for setting the grid pattern for sources accessing tiled-image
 * servers.
 * @api
 */ class $bc3c803236fb01b8$var$TileGrid {
    /**
   * @param {Options} options Tile grid options.
   */ constructor(options){
        /**
     * @protected
     * @type {number}
     */ this.minZoom = options.minZoom !== undefined ? options.minZoom : 0;
        /**
     * @private
     * @type {!Array<number>}
     */ this.resolutions_ = options.resolutions;
        (0, $71eb897bda873684$export$a7a9523472993e97)((0, $49313fcb0fc32abe$export$efa610630f9e181)(this.resolutions_, /**
         * @param {number} a First resolution
         * @param {number} b Second resolution
         * @return {number} Comparison result
         */ (a, b)=>b - a, true), '`resolutions` must be sorted in descending order');
        // check if we've got a consistent zoom factor and origin
        let zoomFactor;
        if (!options.origins) for(let i = 0, ii = this.resolutions_.length - 1; i < ii; ++i){
            if (!zoomFactor) zoomFactor = this.resolutions_[i] / this.resolutions_[i + 1];
            else if (this.resolutions_[i] / this.resolutions_[i + 1] !== zoomFactor) {
                zoomFactor = undefined;
                break;
            }
        }
        /**
     * @private
     * @type {number|undefined}
     */ this.zoomFactor_ = zoomFactor;
        /**
     * @protected
     * @type {number}
     */ this.maxZoom = this.resolutions_.length - 1;
        /**
     * @private
     * @type {import("../coordinate.js").Coordinate|null}
     */ this.origin_ = options.origin !== undefined ? options.origin : null;
        /**
     * @private
     * @type {Array<import("../coordinate.js").Coordinate>}
     */ this.origins_ = null;
        if (options.origins !== undefined) {
            this.origins_ = options.origins;
            (0, $71eb897bda873684$export$a7a9523472993e97)(this.origins_.length == this.resolutions_.length, 'Number of `origins` and `resolutions` must be equal');
        }
        const extent = options.extent;
        if (extent !== undefined && !this.origin_ && !this.origins_) this.origin_ = (0, $dea65c2f666fa450$export$cb1538b07e6964ff)(extent);
        (0, $71eb897bda873684$export$a7a9523472993e97)(!this.origin_ && this.origins_ || this.origin_ && !this.origins_, 'Either `origin` or `origins` must be configured, never both');
        /**
     * @private
     * @type {Array<number|import("../size.js").Size>}
     */ this.tileSizes_ = null;
        if (options.tileSizes !== undefined) {
            this.tileSizes_ = options.tileSizes;
            (0, $71eb897bda873684$export$a7a9523472993e97)(this.tileSizes_.length == this.resolutions_.length, 'Number of `tileSizes` and `resolutions` must be equal');
        }
        /**
     * @private
     * @type {number|import("../size.js").Size}
     */ this.tileSize_ = options.tileSize !== undefined ? options.tileSize : !this.tileSizes_ ? (0, $8d38b00f56572d28$export$6b8cb5cd370bd90c) : null;
        (0, $71eb897bda873684$export$a7a9523472993e97)(!this.tileSize_ && this.tileSizes_ || this.tileSize_ && !this.tileSizes_, 'Either `tileSize` or `tileSizes` must be configured, never both');
        /**
     * @private
     * @type {import("../extent.js").Extent}
     */ this.extent_ = extent !== undefined ? extent : null;
        /**
     * @private
     * @type {Array<import("../TileRange.js").default>}
     */ this.fullTileRanges_ = null;
        /**
     * @private
     * @type {import("../size.js").Size}
     */ this.tmpSize_ = [
            0,
            0
        ];
        /**
     * @private
     * @type {import("../extent.js").Extent}
     */ this.tmpExtent_ = [
            0,
            0,
            0,
            0
        ];
        if (options.sizes !== undefined) this.fullTileRanges_ = options.sizes.map((size, z)=>{
            const tileRange = new (0, $9d539d0e6964f568$export$2e2bcd8739ae039)(Math.min(0, size[0]), Math.max(size[0] - 1, -1), Math.min(0, size[1]), Math.max(size[1] - 1, -1));
            if (extent) {
                const restrictedTileRange = this.getTileRangeForExtentAndZ(extent, z);
                tileRange.minX = Math.max(restrictedTileRange.minX, tileRange.minX);
                tileRange.maxX = Math.min(restrictedTileRange.maxX, tileRange.maxX);
                tileRange.minY = Math.max(restrictedTileRange.minY, tileRange.minY);
                tileRange.maxY = Math.min(restrictedTileRange.maxY, tileRange.maxY);
            }
            return tileRange;
        });
        else if (extent) this.calculateTileRanges_(extent);
    }
    /**
   * Call a function with each tile coordinate for a given extent and zoom level.
   *
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {number} zoom Integer zoom level.
   * @param {function(import("../tilecoord.js").TileCoord): void} callback Function called with each tile coordinate.
   * @api
   */ forEachTileCoord(extent, zoom, callback) {
        const tileRange = this.getTileRangeForExtentAndZ(extent, zoom);
        for(let i = tileRange.minX, ii = tileRange.maxX; i <= ii; ++i)for(let j = tileRange.minY, jj = tileRange.maxY; j <= jj; ++j)callback([
            zoom,
            i,
            j
        ]);
    }
    /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {function(number, import("../TileRange.js").default): boolean} callback Callback.
   * @param {import("../TileRange.js").default} [tempTileRange] Temporary import("../TileRange.js").default object.
   * @param {import("../extent.js").Extent} [tempExtent] Temporary import("../extent.js").Extent object.
   * @return {boolean} Callback succeeded.
   */ forEachTileCoordParentTileRange(tileCoord, callback, tempTileRange, tempExtent) {
        let tileRange, x, y;
        let tileCoordExtent = null;
        let z = tileCoord[0] - 1;
        if (this.zoomFactor_ === 2) {
            x = tileCoord[1];
            y = tileCoord[2];
        } else tileCoordExtent = this.getTileCoordExtent(tileCoord, tempExtent);
        while(z >= this.minZoom){
            if (x !== undefined && y !== undefined) {
                x = Math.floor(x / 2);
                y = Math.floor(y / 2);
                tileRange = (0, $9d539d0e6964f568$export$958e3e1a02eac4b6)(x, x, y, y, tempTileRange);
            } else tileRange = this.getTileRangeForExtentAndZ(tileCoordExtent, z, tempTileRange);
            if (callback(z, tileRange)) return true;
            --z;
        }
        return false;
    }
    /**
   * Get the extent for this tile grid, if it was configured.
   * @return {import("../extent.js").Extent} Extent.
   * @api
   */ getExtent() {
        return this.extent_;
    }
    /**
   * Get the maximum zoom level for the grid.
   * @return {number} Max zoom.
   * @api
   */ getMaxZoom() {
        return this.maxZoom;
    }
    /**
   * Get the minimum zoom level for the grid.
   * @return {number} Min zoom.
   * @api
   */ getMinZoom() {
        return this.minZoom;
    }
    /**
   * Get the origin for the grid at the given zoom level.
   * @param {number} z Integer zoom level.
   * @return {import("../coordinate.js").Coordinate} Origin.
   * @api
   */ getOrigin(z) {
        if (this.origin_) return this.origin_;
        return this.origins_[z];
    }
    /**
   * Get the list of origins for the grid.
   * @return {Array<import("../coordinate.js").Coordinate>|null} Origin.
   */ getOrigins() {
        return this.origins_;
    }
    /**
   * Get the resolution for the given zoom level.
   * @param {number} z Integer zoom level.
   * @return {number} Resolution.
   * @api
   */ getResolution(z) {
        return this.resolutions_[z];
    }
    /**
   * Get the list of resolutions for the tile grid.
   * @return {Array<number>} Resolutions.
   * @api
   */ getResolutions() {
        return this.resolutions_;
    }
    /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {import("../TileRange.js").default} [tempTileRange] Temporary import("../TileRange.js").default object.
   * @param {import("../extent.js").Extent} [tempExtent] Temporary import("../extent.js").Extent object.
   * @return {import("../TileRange.js").default|null} Tile range.
   */ getTileCoordChildTileRange(tileCoord, tempTileRange, tempExtent) {
        if (tileCoord[0] < this.maxZoom) {
            if (this.zoomFactor_ === 2) {
                const minX = tileCoord[1] * 2;
                const minY = tileCoord[2] * 2;
                return (0, $9d539d0e6964f568$export$958e3e1a02eac4b6)(minX, minX + 1, minY, minY + 1, tempTileRange);
            }
            const tileCoordExtent = this.getTileCoordExtent(tileCoord, tempExtent || this.tmpExtent_);
            return this.getTileRangeForExtentAndZ(tileCoordExtent, tileCoord[0] + 1, tempTileRange);
        }
        return null;
    }
    /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {number} z Integer zoom level.
   * @param {import("../TileRange.js").default} [tempTileRange] Temporary import("../TileRange.js").default object.
   * @return {import("../TileRange.js").default|null} Tile range.
   */ getTileRangeForTileCoordAndZ(tileCoord, z, tempTileRange) {
        if (z > this.maxZoom || z < this.minZoom) return null;
        const tileCoordZ = tileCoord[0];
        const tileCoordX = tileCoord[1];
        const tileCoordY = tileCoord[2];
        if (z === tileCoordZ) return (0, $9d539d0e6964f568$export$958e3e1a02eac4b6)(tileCoordX, tileCoordY, tileCoordX, tileCoordY, tempTileRange);
        if (this.zoomFactor_) {
            const factor = Math.pow(this.zoomFactor_, z - tileCoordZ);
            const minX = Math.floor(tileCoordX * factor);
            const minY = Math.floor(tileCoordY * factor);
            if (z < tileCoordZ) return (0, $9d539d0e6964f568$export$958e3e1a02eac4b6)(minX, minX, minY, minY, tempTileRange);
            const maxX = Math.floor(factor * (tileCoordX + 1)) - 1;
            const maxY = Math.floor(factor * (tileCoordY + 1)) - 1;
            return (0, $9d539d0e6964f568$export$958e3e1a02eac4b6)(minX, maxX, minY, maxY, tempTileRange);
        }
        const tileCoordExtent = this.getTileCoordExtent(tileCoord, this.tmpExtent_);
        return this.getTileRangeForExtentAndZ(tileCoordExtent, z, tempTileRange);
    }
    /**
   * Get a tile range for the given extent and integer zoom level.
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {number} z Integer zoom level.
   * @param {import("../TileRange.js").default} [tempTileRange] Temporary tile range object.
   * @return {import("../TileRange.js").default} Tile range.
   */ getTileRangeForExtentAndZ(extent, z, tempTileRange) {
        this.getTileCoordForXYAndZ_(extent[0], extent[3], z, false, $bc3c803236fb01b8$var$tmpTileCoord);
        const minX = $bc3c803236fb01b8$var$tmpTileCoord[1];
        const minY = $bc3c803236fb01b8$var$tmpTileCoord[2];
        this.getTileCoordForXYAndZ_(extent[2], extent[1], z, true, $bc3c803236fb01b8$var$tmpTileCoord);
        const maxX = $bc3c803236fb01b8$var$tmpTileCoord[1];
        const maxY = $bc3c803236fb01b8$var$tmpTileCoord[2];
        return (0, $9d539d0e6964f568$export$958e3e1a02eac4b6)(minX, maxX, minY, maxY, tempTileRange);
    }
    /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @return {import("../coordinate.js").Coordinate} Tile center.
   */ getTileCoordCenter(tileCoord) {
        const origin = this.getOrigin(tileCoord[0]);
        const resolution = this.getResolution(tileCoord[0]);
        const tileSize = (0, $625e418aeada4c0d$export$a71a825ff42fb8e1)(this.getTileSize(tileCoord[0]), this.tmpSize_);
        return [
            origin[0] + (tileCoord[1] + 0.5) * tileSize[0] * resolution,
            origin[1] - (tileCoord[2] + 0.5) * tileSize[1] * resolution
        ];
    }
    /**
   * Get the extent of a tile coordinate.
   *
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {import("../extent.js").Extent} [tempExtent] Temporary extent object.
   * @return {import("../extent.js").Extent} Extent.
   * @api
   */ getTileCoordExtent(tileCoord, tempExtent) {
        const origin = this.getOrigin(tileCoord[0]);
        const resolution = this.getResolution(tileCoord[0]);
        const tileSize = (0, $625e418aeada4c0d$export$a71a825ff42fb8e1)(this.getTileSize(tileCoord[0]), this.tmpSize_);
        const minX = origin[0] + tileCoord[1] * tileSize[0] * resolution;
        const minY = origin[1] - (tileCoord[2] + 1) * tileSize[1] * resolution;
        const maxX = minX + tileSize[0] * resolution;
        const maxY = minY + tileSize[1] * resolution;
        return (0, $dea65c2f666fa450$export$958e3e1a02eac4b6)(minX, minY, maxX, maxY, tempExtent);
    }
    /**
   * Get the tile coordinate for the given map coordinate and resolution.  This
   * method considers that coordinates that intersect tile boundaries should be
   * assigned the higher tile coordinate.
   *
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {number} resolution Resolution.
   * @param {import("../tilecoord.js").TileCoord} [opt_tileCoord] Destination import("../tilecoord.js").TileCoord object.
   * @return {import("../tilecoord.js").TileCoord} Tile coordinate.
   * @api
   */ getTileCoordForCoordAndResolution(coordinate, resolution, opt_tileCoord) {
        return this.getTileCoordForXYAndResolution_(coordinate[0], coordinate[1], resolution, false, opt_tileCoord);
    }
    /**
   * Note that this method should not be called for resolutions that correspond
   * to an integer zoom level.  Instead call the `getTileCoordForXYAndZ_` method.
   * @param {number} x X.
   * @param {number} y Y.
   * @param {number} resolution Resolution (for a non-integer zoom level).
   * @param {boolean} reverseIntersectionPolicy Instead of letting edge
   *     intersections go to the higher tile coordinate, let edge intersections
   *     go to the lower tile coordinate.
   * @param {import("../tilecoord.js").TileCoord} [opt_tileCoord] Temporary import("../tilecoord.js").TileCoord object.
   * @return {import("../tilecoord.js").TileCoord} Tile coordinate.
   * @private
   */ getTileCoordForXYAndResolution_(x, y, resolution, reverseIntersectionPolicy, opt_tileCoord) {
        const z = this.getZForResolution(resolution);
        const scale = resolution / this.getResolution(z);
        const origin = this.getOrigin(z);
        const tileSize = (0, $625e418aeada4c0d$export$a71a825ff42fb8e1)(this.getTileSize(z), this.tmpSize_);
        let tileCoordX = scale * (x - origin[0]) / resolution / tileSize[0];
        let tileCoordY = scale * (origin[1] - y) / resolution / tileSize[1];
        if (reverseIntersectionPolicy) {
            tileCoordX = (0, $6a95bd76d7103f37$export$803ce6b71a0a94b2)(tileCoordX, $bc3c803236fb01b8$var$DECIMALS) - 1;
            tileCoordY = (0, $6a95bd76d7103f37$export$803ce6b71a0a94b2)(tileCoordY, $bc3c803236fb01b8$var$DECIMALS) - 1;
        } else {
            tileCoordX = (0, $6a95bd76d7103f37$export$a3fe094919f356fd)(tileCoordX, $bc3c803236fb01b8$var$DECIMALS);
            tileCoordY = (0, $6a95bd76d7103f37$export$a3fe094919f356fd)(tileCoordY, $bc3c803236fb01b8$var$DECIMALS);
        }
        return (0, $8b203a265587842e$export$958e3e1a02eac4b6)(z, tileCoordX, tileCoordY, opt_tileCoord);
    }
    /**
   * Although there is repetition between this method and `getTileCoordForXYAndResolution_`,
   * they should have separate implementations.  This method is for integer zoom
   * levels.  The other method should only be called for resolutions corresponding
   * to non-integer zoom levels.
   * @param {number} x Map x coordinate.
   * @param {number} y Map y coordinate.
   * @param {number} z Integer zoom level.
   * @param {boolean} reverseIntersectionPolicy Instead of letting edge
   *     intersections go to the higher tile coordinate, let edge intersections
   *     go to the lower tile coordinate.
   * @param {import("../tilecoord.js").TileCoord} [opt_tileCoord] Temporary import("../tilecoord.js").TileCoord object.
   * @return {import("../tilecoord.js").TileCoord} Tile coordinate.
   * @private
   */ getTileCoordForXYAndZ_(x, y, z, reverseIntersectionPolicy, opt_tileCoord) {
        const origin = this.getOrigin(z);
        const resolution = this.getResolution(z);
        const tileSize = (0, $625e418aeada4c0d$export$a71a825ff42fb8e1)(this.getTileSize(z), this.tmpSize_);
        let tileCoordX = (x - origin[0]) / resolution / tileSize[0];
        let tileCoordY = (origin[1] - y) / resolution / tileSize[1];
        if (reverseIntersectionPolicy) {
            tileCoordX = (0, $6a95bd76d7103f37$export$803ce6b71a0a94b2)(tileCoordX, $bc3c803236fb01b8$var$DECIMALS) - 1;
            tileCoordY = (0, $6a95bd76d7103f37$export$803ce6b71a0a94b2)(tileCoordY, $bc3c803236fb01b8$var$DECIMALS) - 1;
        } else {
            tileCoordX = (0, $6a95bd76d7103f37$export$a3fe094919f356fd)(tileCoordX, $bc3c803236fb01b8$var$DECIMALS);
            tileCoordY = (0, $6a95bd76d7103f37$export$a3fe094919f356fd)(tileCoordY, $bc3c803236fb01b8$var$DECIMALS);
        }
        return (0, $8b203a265587842e$export$958e3e1a02eac4b6)(z, tileCoordX, tileCoordY, opt_tileCoord);
    }
    /**
   * Get a tile coordinate given a map coordinate and zoom level.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {number} z Integer zoom level, e.g. the result of a `getZForResolution()` method call
   * @param {import("../tilecoord.js").TileCoord} [opt_tileCoord] Destination import("../tilecoord.js").TileCoord object.
   * @return {import("../tilecoord.js").TileCoord} Tile coordinate.
   * @api
   */ getTileCoordForCoordAndZ(coordinate, z, opt_tileCoord) {
        return this.getTileCoordForXYAndZ_(coordinate[0], coordinate[1], z, false, opt_tileCoord);
    }
    /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @return {number} Tile resolution.
   */ getTileCoordResolution(tileCoord) {
        return this.resolutions_[tileCoord[0]];
    }
    /**
   * Get the tile size for a zoom level. The type of the return value matches the
   * `tileSize` or `tileSizes` that the tile grid was configured with. To always
   * get an {@link import("../size.js").Size}, run the result through {@link module:ol/size.toSize}.
   * @param {number} z Z.
   * @return {number|import("../size.js").Size} Tile size.
   * @api
   */ getTileSize(z) {
        if (this.tileSize_) return this.tileSize_;
        return this.tileSizes_[z];
    }
    /**
   * @param {number} z Zoom level.
   * @return {import("../TileRange.js").default|null} Extent tile range for the specified zoom level.
   */ getFullTileRange(z) {
        if (!this.fullTileRanges_) return this.extent_ ? this.getTileRangeForExtentAndZ(this.extent_, z) : null;
        return this.fullTileRanges_[z];
    }
    /**
   * @param {number} resolution Resolution.
   * @param {number|import("../array.js").NearestDirectionFunction} [opt_direction]
   *     If 0, the nearest resolution will be used.
   *     If 1, the nearest higher resolution (lower Z) will be used. If -1, the
   *     nearest lower resolution (higher Z) will be used. Default is 0.
   *     Use a {@link module:ol/array~NearestDirectionFunction} for more precise control.
   *
   * For example to change tile Z at the midpoint of zoom levels
   * ```js
   * function(value, high, low) {
   *   return value - low * Math.sqrt(high / low);
   * }
   * ```
   * @return {number} Z.
   * @api
   */ getZForResolution(resolution, opt_direction) {
        const z = (0, $49313fcb0fc32abe$export$8a3786cc03fdb777)(this.resolutions_, resolution, opt_direction || 0);
        return (0, $6a95bd76d7103f37$export$7d15b64cf5a3a4c4)(z, this.minZoom, this.maxZoom);
    }
    /**
   * The tile with the provided tile coordinate intersects the given viewport.
   * @param {import('../tilecoord.js').TileCoord} tileCoord Tile coordinate.
   * @param {Array<number>} viewport Viewport as returned from {@link module:ol/extent.getRotatedViewport}.
   * @return {boolean} The tile with the provided tile coordinate intersects the given viewport.
   */ tileCoordIntersectsViewport(tileCoord, viewport) {
        return (0, $a3da3236b4fb8b80$export$830a0dafbb2ef1c5)(viewport, 0, viewport.length, 2, this.getTileCoordExtent(tileCoord));
    }
    /**
   * @param {!import("../extent.js").Extent} extent Extent for this tile grid.
   * @private
   */ calculateTileRanges_(extent) {
        const length = this.resolutions_.length;
        const fullTileRanges = new Array(length);
        for(let z = this.minZoom; z < length; ++z)fullTileRanges[z] = this.getTileRangeForExtentAndZ(extent, z);
        this.fullTileRanges_ = fullTileRanges;
    }
}
var $bc3c803236fb01b8$export$2e2bcd8739ae039 = $bc3c803236fb01b8$var$TileGrid;




function $ce64bfb95181f463$export$1f4812384df8a9c5(projection) {
    let tileGrid = projection.getDefaultTileGrid();
    if (!tileGrid) {
        tileGrid = $ce64bfb95181f463$export$a251b12f5601c16f(projection);
        projection.setDefaultTileGrid(tileGrid);
    }
    return tileGrid;
}
function $ce64bfb95181f463$export$39a9ce3624977b84(tileGrid, tileCoord, projection) {
    const z = tileCoord[0];
    const center = tileGrid.getTileCoordCenter(tileCoord);
    const projectionExtent = $ce64bfb95181f463$export$7b5b6ef8fd55fac4(projection);
    if (!(0, $dea65c2f666fa450$export$ac68c24d37ca240f)(projectionExtent, center)) {
        const worldWidth = (0, $dea65c2f666fa450$export$3c49c185de0c2bfc)(projectionExtent);
        const worldsAway = Math.ceil((projectionExtent[0] - center[0]) / worldWidth);
        center[0] += worldWidth * worldsAway;
        return tileGrid.getTileCoordForCoordAndZ(center, z);
    }
    return tileCoord;
}
function $ce64bfb95181f463$export$ce88871416242df8(extent, maxZoom, tileSize, corner) {
    corner = corner !== undefined ? corner : 'top-left';
    const resolutions = $ce64bfb95181f463$var$resolutionsFromExtent(extent, maxZoom, tileSize);
    return new (0, $bc3c803236fb01b8$export$2e2bcd8739ae039)({
        extent: extent,
        origin: (0, $dea65c2f666fa450$export$a1cfd206661d0801)(extent, corner),
        resolutions: resolutions,
        tileSize: tileSize
    });
}
function $ce64bfb95181f463$export$38500bbeccc864ff(options) {
    const xyzOptions = options || {};
    const extent = xyzOptions.extent || (0, $a86eee1c28205a05$export$3988ae62b71be9a3)('EPSG:3857').getExtent();
    const gridOptions = {
        extent: extent,
        minZoom: xyzOptions.minZoom,
        tileSize: xyzOptions.tileSize,
        resolutions: $ce64bfb95181f463$var$resolutionsFromExtent(extent, xyzOptions.maxZoom, xyzOptions.tileSize, xyzOptions.maxResolution)
    };
    return new (0, $bc3c803236fb01b8$export$2e2bcd8739ae039)(gridOptions);
}
/**
 * Create a resolutions array from an extent.  A zoom factor of 2 is assumed.
 * @param {import("./extent.js").Extent} extent Extent.
 * @param {number} [maxZoom] Maximum zoom level (default is
 *     DEFAULT_MAX_ZOOM).
 * @param {number|import("./size.js").Size} [tileSize] Tile size (default uses
 *     DEFAULT_TILE_SIZE).
 * @param {number} [maxResolution] Resolution at level zero.
 * @return {!Array<number>} Resolutions array.
 */ function $ce64bfb95181f463$var$resolutionsFromExtent(extent, maxZoom, tileSize, maxResolution) {
    maxZoom = maxZoom !== undefined ? maxZoom : (0, $8d38b00f56572d28$export$e98a216cdcc847dc);
    tileSize = (0, $625e418aeada4c0d$export$a71a825ff42fb8e1)(tileSize !== undefined ? tileSize : (0, $8d38b00f56572d28$export$6b8cb5cd370bd90c));
    const height = (0, $dea65c2f666fa450$export$c08559766941f856)(extent);
    const width = (0, $dea65c2f666fa450$export$3c49c185de0c2bfc)(extent);
    maxResolution = maxResolution > 0 ? maxResolution : Math.max(width / tileSize[0], height / tileSize[1]);
    const length = maxZoom + 1;
    const resolutions = new Array(length);
    for(let z = 0; z < length; ++z)resolutions[z] = maxResolution / Math.pow(2, z);
    return resolutions;
}
function $ce64bfb95181f463$export$a251b12f5601c16f(projection, maxZoom, tileSize, corner) {
    const extent = $ce64bfb95181f463$export$7b5b6ef8fd55fac4(projection);
    return $ce64bfb95181f463$export$ce88871416242df8(extent, maxZoom, tileSize, corner);
}
function $ce64bfb95181f463$export$7b5b6ef8fd55fac4(projection) {
    projection = (0, $a86eee1c28205a05$export$3988ae62b71be9a3)(projection);
    let extent = projection.getExtent();
    if (!extent) {
        const half = 180 * (0, $9149a5943443441b$export$1482081eec883108).degrees / projection.getMetersPerUnit();
        extent = (0, $dea65c2f666fa450$export$958e3e1a02eac4b6)(-half, -half, half, half);
    }
    return extent;
}


/**
 * @module ol/source/TileImage
 */ 








/**
 * @module ol/source/UrlTile
 */ 
/**
 * @module ol/tileurlfunction
 */ 

/**
 * @module ol/uri
 */ 

function $ce940d0af289b90b$export$c202e3cb8db99a95(uri, params) {
    /** @type {Array<string>} */ const keyParams = [];
    // Skip any null or undefined parameter values
    Object.keys(params).forEach(function(k) {
        if (params[k] !== null && params[k] !== undefined) keyParams.push(k + '=' + encodeURIComponent(params[k]));
    });
    const qs = keyParams.join('&');
    // remove any trailing ? or &
    uri = uri.replace(/[?&]$/, '');
    // append ? or & depending on whether uri has existing parameters
    uri += uri.includes('?') ? '&' : '?';
    return uri + qs;
}
const $ce940d0af289b90b$var$zRegEx = /\{z\}/g;
const $ce940d0af289b90b$var$xRegEx = /\{x\}/g;
const $ce940d0af289b90b$var$yRegEx = /\{y\}/g;
const $ce940d0af289b90b$var$dashYRegEx = /\{-y\}/g;
function $ce940d0af289b90b$export$df1e52f1b5b1c86f(template, z, x, y, maxY) {
    return template.replace($ce940d0af289b90b$var$zRegEx, z.toString()).replace($ce940d0af289b90b$var$xRegEx, x.toString()).replace($ce940d0af289b90b$var$yRegEx, y.toString()).replace($ce940d0af289b90b$var$dashYRegEx, function() {
        if (maxY === undefined) throw new Error('If the URL template has a {-y} placeholder, the grid extent must be known');
        return (maxY - y).toString();
    });
}
function $ce940d0af289b90b$export$83e87e683240b2e8(urls, z, x, y) {
    const hash = (0, $8b203a265587842e$export$731f79419750ccf7)(z, x, y);
    const index = (0, $6a95bd76d7103f37$export$ba467bec01d66def)(hash, urls.length);
    return urls[index];
}
function $ce940d0af289b90b$export$2a1fa079bfd73dde(url) {
    const urls = [];
    let match = /\{([a-z])-([a-z])\}/.exec(url);
    if (match) {
        // char range
        const startCharCode = match[1].charCodeAt(0);
        const stopCharCode = match[2].charCodeAt(0);
        let charCode;
        for(charCode = startCharCode; charCode <= stopCharCode; ++charCode)urls.push(url.replace(match[0], String.fromCharCode(charCode)));
        return urls;
    }
    match = /\{(\d+)-(\d+)\}/.exec(url);
    if (match) {
        // number range
        const stop = parseInt(match[2], 10);
        for(let i = parseInt(match[1], 10); i <= stop; i++)urls.push(url.replace(match[0], i.toString()));
        return urls;
    }
    urls.push(url);
    return urls;
}


function $f67d91f4d04e08ca$export$f0ecb46e90798741(template, tileGrid) {
    return(/**
     * @param {import("./tilecoord.js").TileCoord} tileCoord Tile Coordinate.
     * @param {number} pixelRatio Pixel ratio.
     * @param {import("./proj/Projection.js").default} projection Projection.
     * @return {string|undefined} Tile URL.
     */ function(tileCoord, pixelRatio, projection) {
        if (!tileCoord) return undefined;
        let maxY;
        const z = tileCoord[0];
        if (tileGrid) {
            // The `{-y}` placeholder only works for sources that have a tile grid at construction
            const range = tileGrid.getFullTileRange(z);
            if (range) maxY = range.getHeight() - 1;
        }
        return (0, $ce940d0af289b90b$export$df1e52f1b5b1c86f)(template, z, tileCoord[1], tileCoord[2], maxY);
    });
}
function $f67d91f4d04e08ca$export$436f44dbcc31fea3(templates, tileGrid) {
    const len = templates.length;
    const tileUrlFunctions = new Array(len);
    for(let i = 0; i < len; ++i)tileUrlFunctions[i] = $f67d91f4d04e08ca$export$f0ecb46e90798741(templates[i], tileGrid);
    return $f67d91f4d04e08ca$export$4229b1d9af69b3be(tileUrlFunctions);
}
function $f67d91f4d04e08ca$export$4229b1d9af69b3be(tileUrlFunctions) {
    if (tileUrlFunctions.length === 1) return tileUrlFunctions[0];
    return(/**
     * @param {import("./tilecoord.js").TileCoord} tileCoord Tile Coordinate.
     * @param {number} pixelRatio Pixel ratio.
     * @param {import("./proj/Projection.js").default} projection Projection.
     * @return {string|undefined} Tile URL.
     */ function(tileCoord, pixelRatio, projection) {
        if (!tileCoord) return undefined;
        const h = (0, $8b203a265587842e$export$d6af199866bfb566)(tileCoord);
        const index = (0, $6a95bd76d7103f37$export$ba467bec01d66def)(h, tileUrlFunctions.length);
        return tileUrlFunctions[index](tileCoord, pixelRatio, projection);
    });
}
function $f67d91f4d04e08ca$export$fab585f002f634a1(tileCoord, pixelRatio, projection) {
    return undefined;
}




/**
 * @module ol/source/Tile
 */ 




/**
 * @module ol/source/Source
 */ 

/**
 * @typedef {'undefined' | 'loading' | 'ready' | 'error'} State
 * State of the source, one of 'undefined', 'loading', 'ready' or 'error'.
 */ /**
 * A function that takes a {@link import("../View.js").ViewStateLayerStateExtent} and returns a string or
 * an array of strings representing source attributions.
 *
 * @typedef {function(import("../View.js").ViewStateLayerStateExtent): (string|Array<string>)} Attribution
 */ /**
 * A type that can be used to provide attribution information for data sources.
 *
 * It represents either
 * a simple string (e.g. `'© Acme Inc.'`)
 * an array of simple strings (e.g. `['© Acme Inc.', '© Bacme Inc.']`)
 * a function that returns a string or array of strings ({@link module:ol/source/Source~Attribution})
 *
 * @typedef {string|Array<string>|Attribution} AttributionLike
 */ /**
 * @typedef {Object} Options
 * @property {AttributionLike} [attributions] Attributions.
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection. Default is the view projection.
 * @property {import("./Source.js").State} [state='ready'] State.
 * @property {boolean} [wrapX=false] WrapX.
 * @property {boolean} [interpolate=false] Use interpolated values when resampling.  By default,
 * the nearest neighbor is used when resampling.
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Base class for {@link module:ol/layer/Layer~Layer} sources.
 *
 * A generic `change` event is triggered when the state of the source changes.
 * @abstract
 * @api
 */ class $f43c44b2b88dd1d8$var$Source extends (0, $4862cdcc23257f5b$export$2e2bcd8739ae039) {
    /**
   * @param {Options} options Source options.
   */ constructor(options){
        super();
        /**
     * @protected
     * @type {import("../proj/Projection.js").default|null}
     */ this.projection = (0, $a86eee1c28205a05$export$3988ae62b71be9a3)(options.projection);
        /**
     * @private
     * @type {?Attribution}
     */ this.attributions_ = $f43c44b2b88dd1d8$var$adaptAttributions(options.attributions);
        /**
     * @private
     * @type {boolean}
     */ this.attributionsCollapsible_ = options.attributionsCollapsible ?? true;
        /**
     * This source is currently loading data. Sources that defer loading to the
     * map's tile queue never set this to `true`.
     * @type {boolean}
     */ this.loading = false;
        /**
     * @private
     * @type {import("./Source.js").State}
     */ this.state_ = options.state !== undefined ? options.state : 'ready';
        /**
     * @private
     * @type {boolean}
     */ this.wrapX_ = options.wrapX !== undefined ? options.wrapX : false;
        /**
     * @private
     * @type {boolean}
     */ this.interpolate_ = !!options.interpolate;
        /**
     * @protected
     * @type {function(import("../View.js").ViewOptions):void}
     */ this.viewResolver = null;
        /**
     * @protected
     * @type {function(Error):void}
     */ this.viewRejector = null;
        const self = this;
        /**
     * @private
     * @type {Promise<import("../View.js").ViewOptions>}
     */ this.viewPromise_ = new Promise(function(resolve, reject) {
            self.viewResolver = resolve;
            self.viewRejector = reject;
        });
    }
    /**
   * Get the attribution function for the source.
   * @return {?Attribution} Attribution function.
   * @api
   */ getAttributions() {
        return this.attributions_;
    }
    /**
   * @return {boolean} Attributions are collapsible.
   * @api
   */ getAttributionsCollapsible() {
        return this.attributionsCollapsible_;
    }
    /**
   * Get the projection of the source.
   * @return {import("../proj/Projection.js").default|null} Projection.
   * @api
   */ getProjection() {
        return this.projection;
    }
    /**
   * @param {import("../proj/Projection").default} [projection] Projection.
   * @return {Array<number>|null} Resolutions.
   */ getResolutions(projection) {
        return null;
    }
    /**
   * @return {Promise<import("../View.js").ViewOptions>} A promise for view-related properties.
   */ getView() {
        return this.viewPromise_;
    }
    /**
   * Get the state of the source, see {@link import("./Source.js").State} for possible states.
   * @return {import("./Source.js").State} State.
   * @api
   */ getState() {
        return this.state_;
    }
    /**
   * @return {boolean|undefined} Wrap X.
   */ getWrapX() {
        return this.wrapX_;
    }
    /**
   * @return {boolean} Use linear interpolation when resampling.
   */ getInterpolate() {
        return this.interpolate_;
    }
    /**
   * Refreshes the source. The source will be cleared, and data from the server will be reloaded.
   * @api
   */ refresh() {
        this.changed();
    }
    /**
   * Set the attributions of the source.
   * @param {AttributionLike|undefined} attributions Attributions.
   *     Can be passed as `string`, `Array<string>`, {@link module:ol/source/Source~Attribution},
   *     or `undefined`.
   * @api
   */ setAttributions(attributions) {
        this.attributions_ = $f43c44b2b88dd1d8$var$adaptAttributions(attributions);
        this.changed();
    }
    /**
   * Set the state of the source.
   * @param {import("./Source.js").State} state State.
   */ setState(state) {
        this.state_ = state;
        this.changed();
    }
}
/**
 * Turns the attributions option into an attributions function.
 * @param {AttributionLike|undefined} attributionLike The attribution option.
 * @return {Attribution|null} An attribution function (or null).
 */ function $f43c44b2b88dd1d8$var$adaptAttributions(attributionLike) {
    if (!attributionLike) return null;
    if (typeof attributionLike === 'function') return attributionLike;
    if (!Array.isArray(attributionLike)) attributionLike = [
        attributionLike
    ];
    return (frameState)=>attributionLike;
}
var $f43c44b2b88dd1d8$export$2e2bcd8739ae039 = $f43c44b2b88dd1d8$var$Source;


/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types, import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<import("./TileEventType").TileSourceEventTypes, TileSourceEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types|
 *     import("./TileEventType").TileSourceEventTypes, Return>} TileSourceOnSignature
 */ /**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {number} [cacheSize] Deprecated.  Use the cacheSize option on the layer instead.
 * @property {number} [tilePixelRatio] TilePixelRatio.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection.
 * @property {import("./Source.js").State} [state] State.
 * @property {import("../tilegrid/TileGrid.js").default} [tileGrid] TileGrid.
 * @property {boolean} [wrapX=false] WrapX.
 * @property {number} [transition] Transition.
 * @property {string} [key] Key.
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=0] ZDirection.
 * @property {boolean} [interpolate=false] Use interpolated values when resampling.  By default,
 * the nearest neighbor is used when resampling.
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Base class for sources providing images divided into a tile grid.
 *
 * @template {import("../Tile.js").default} [TileType=import("../Tile.js").default]
 * @abstract
 * @api
 */ class $fb8cfae1128cb404$var$TileSource extends (0, $f43c44b2b88dd1d8$export$2e2bcd8739ae039) {
    /**
   * @param {Options} options SourceTile source options.
   */ constructor(options){
        super({
            attributions: options.attributions,
            attributionsCollapsible: options.attributionsCollapsible,
            projection: options.projection,
            state: options.state,
            wrapX: options.wrapX,
            interpolate: options.interpolate
        });
        /***
     * @type {TileSourceOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {TileSourceOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {TileSourceOnSignature<void>}
     */ this.un;
        /**
     * @private
     * @type {number}
     */ this.tilePixelRatio_ = options.tilePixelRatio !== undefined ? options.tilePixelRatio : 1;
        /**
     * @type {import("../tilegrid/TileGrid.js").default|null}
     * @protected
     */ this.tileGrid = options.tileGrid !== undefined ? options.tileGrid : null;
        const tileSize = [
            256,
            256
        ];
        if (this.tileGrid) (0, $625e418aeada4c0d$export$a71a825ff42fb8e1)(this.tileGrid.getTileSize(this.tileGrid.getMinZoom()), tileSize);
        /**
     * @protected
     * @type {import("../size.js").Size}
     */ this.tmpSize = [
            0,
            0
        ];
        /**
     * @private
     * @type {string}
     */ this.key_ = options.key || (0, $fd76d391cc228565$export$5e82334337e0f204)(this);
        /**
     * @protected
     * @type {import("../Tile.js").Options}
     */ this.tileOptions = {
            transition: options.transition,
            interpolate: options.interpolate
        };
        /**
     * zDirection hint, read by the renderer. Indicates which resolution should be used
     * by a renderer if the views resolution does not match any resolution of the tile source.
     * If 0, the nearest resolution will be used. If 1, the nearest lower resolution
     * will be used. If -1, the nearest higher resolution will be used.
     * @type {number|import("../array.js").NearestDirectionFunction}
     */ this.zDirection = options.zDirection ? options.zDirection : 0;
    }
    /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {number} Gutter.
   */ getGutterForProjection(projection) {
        return 0;
    }
    /**
   * Return the key to be used for all tiles in the source.
   * @return {string} The key for all tiles.
   */ getKey() {
        return this.key_;
    }
    /**
   * Set the value to be used as the key for all tiles in the source.
   * @param {string} key The key for tiles.
   * @protected
   */ setKey(key) {
        if (this.key_ !== key) {
            this.key_ = key;
            this.changed();
        }
    }
    /**
   * @param {import("../proj/Projection").default} [projection] Projection.
   * @return {Array<number>|null} Resolutions.
   * @override
   */ getResolutions(projection) {
        const tileGrid = projection ? this.getTileGridForProjection(projection) : this.tileGrid;
        if (!tileGrid) return null;
        return tileGrid.getResolutions();
    }
    /**
   * @abstract
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @param {import("../structs/LRUCache.js").default<import("../Tile.js").default>} [tileCache] Tile cache.
   * @return {TileType|null} Tile.
   */ getTile(z, x, y, pixelRatio, projection, tileCache) {
        return (0, $fd76d391cc228565$export$817eb92a8194bab0)();
    }
    /**
   * Return the tile grid of the tile source.
   * @return {import("../tilegrid/TileGrid.js").default|null} Tile grid.
   * @api
   */ getTileGrid() {
        return this.tileGrid;
    }
    /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {!import("../tilegrid/TileGrid.js").default} Tile grid.
   */ getTileGridForProjection(projection) {
        if (!this.tileGrid) return (0, $ce64bfb95181f463$export$1f4812384df8a9c5)(projection);
        return this.tileGrid;
    }
    /**
   * Get the tile pixel ratio for this source. Subclasses may override this
   * method, which is meant to return a supported pixel ratio that matches the
   * provided `pixelRatio` as close as possible.
   * @param {number} pixelRatio Pixel ratio.
   * @return {number} Tile pixel ratio.
   */ getTilePixelRatio(pixelRatio) {
        return this.tilePixelRatio_;
    }
    /**
   * @param {number} z Z.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {import("../size.js").Size} Tile size.
   */ getTilePixelSize(z, pixelRatio, projection) {
        const tileGrid = this.getTileGridForProjection(projection);
        const tilePixelRatio = this.getTilePixelRatio(pixelRatio);
        const tileSize = (0, $625e418aeada4c0d$export$a71a825ff42fb8e1)(tileGrid.getTileSize(z), this.tmpSize);
        if (tilePixelRatio == 1) return tileSize;
        return (0, $625e418aeada4c0d$export$dcdf75081b88279d)(tileSize, tilePixelRatio, this.tmpSize);
    }
    /**
   * Returns a tile coordinate wrapped around the x-axis. When the tile coordinate
   * is outside the resolution and extent range of the tile grid, `null` will be
   * returned.
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {import("../proj/Projection.js").default} [projection] Projection.
   * @return {import("../tilecoord.js").TileCoord} Tile coordinate to be passed to the tileUrlFunction or
   *     null if no tile URL should be created for the passed `tileCoord`.
   */ getTileCoordForTileUrlFunction(tileCoord, projection) {
        const gridProjection = projection !== undefined ? projection : this.getProjection();
        const tileGrid = projection !== undefined ? this.getTileGridForProjection(gridProjection) : this.tileGrid || this.getTileGridForProjection(gridProjection);
        if (this.getWrapX() && gridProjection.isGlobal()) tileCoord = (0, $ce64bfb95181f463$export$39a9ce3624977b84)(tileGrid, tileCoord, gridProjection);
        return (0, $8b203a265587842e$export$60bedf8e3e3c3dbe)(tileCoord, tileGrid) ? tileCoord : null;
    }
    /**
   * Remove all cached reprojected tiles from the source. The next render cycle will create new tiles.
   * @api
   */ clear() {}
    /**
   * @override
   */ refresh() {
        this.clear();
        super.refresh();
    }
}
class $fb8cfae1128cb404$export$c571855c51e6c4b6 extends (0, $5c6b0a43c077a98f$export$2e2bcd8739ae039) {
    /**
   * @param {string} type Type.
   * @param {import("../Tile.js").default} tile The tile.
   */ constructor(type, tile){
        super(type);
        /**
     * The tile related to the event.
     * @type {import("../Tile.js").default}
     * @api
     */ this.tile = tile;
    }
}
var $fb8cfae1128cb404$export$2e2bcd8739ae039 = $fb8cfae1128cb404$var$TileSource;


/**
 * @module ol/source/TileEventType
 */ /**
 * @enum {string}
 */ var $b703cf2946e056bb$export$2e2bcd8739ae039 /**
 * @typedef {'tileloadstart'|'tileloadend'|'tileloaderror'} TileSourceEventTypes
 */  = {
    /**
   * Triggered when a tile starts loading.
   * @event module:ol/source/Tile.TileSourceEvent#tileloadstart
   * @api
   */ TILELOADSTART: 'tileloadstart',
    /**
   * Triggered when a tile finishes loading, either when its data is loaded,
   * or when loading was aborted because the tile is no longer needed.
   * @event module:ol/source/Tile.TileSourceEvent#tileloadend
   * @api
   */ TILELOADEND: 'tileloadend',
    /**
   * Triggered if tile loading results in an error. Note that this is not the
   * right place to re-fetch tiles. See {@link module:ol/ImageTile~ImageTile#load}
   * for details.
   * @event module:ol/source/Tile.TileSourceEvent#tileloaderror
   * @api
   */ TILELOADERROR: 'tileloaderror'
};


/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {number} [cacheSize] Deprecated.  Use the cacheSize option on the layer instead.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection.
 * @property {import("./Source.js").State} [state] State.
 * @property {import("../tilegrid/TileGrid.js").default} [tileGrid] TileGrid.
 * @property {import("../Tile.js").LoadFunction} tileLoadFunction TileLoadFunction.
 * @property {number} [tilePixelRatio] TilePixelRatio.
 * @property {import("../Tile.js").UrlFunction} [tileUrlFunction] Deprecated.  Use an ImageTile source and provide a function
 * for the url option instead.
 * @property {string} [url] Url.
 * @property {Array<string>} [urls] Urls.
 * @property {boolean} [wrapX=true] WrapX.
 * @property {number} [transition] Transition.
 * @property {string} [key] Key.
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=0] ZDirection.
 * @property {boolean} [interpolate=false] Use interpolated values when resampling.  By default,
 * the nearest neighbor is used when resampling.
 */ /**
 * @deprecated Use the ol/source/ImageTile.js instead.
 *
 * @fires import("./Tile.js").TileSourceEvent
 */ class $57d6f55c571301ca$var$UrlTile extends (0, $fb8cfae1128cb404$export$2e2bcd8739ae039) {
    /**
   * @param {Options} options Image tile options.
   */ constructor(options){
        super({
            attributions: options.attributions,
            cacheSize: options.cacheSize,
            projection: options.projection,
            state: options.state,
            tileGrid: options.tileGrid,
            tilePixelRatio: options.tilePixelRatio,
            wrapX: options.wrapX,
            transition: options.transition,
            interpolate: options.interpolate,
            key: options.key,
            attributionsCollapsible: options.attributionsCollapsible,
            zDirection: options.zDirection
        });
        /**
     * @private
     * @type {boolean}
     */ this.generateTileUrlFunction_ = this.tileUrlFunction === $57d6f55c571301ca$var$UrlTile.prototype.tileUrlFunction;
        /**
     * @protected
     * @type {import("../Tile.js").LoadFunction}
     */ this.tileLoadFunction = options.tileLoadFunction;
        if (options.tileUrlFunction) this.tileUrlFunction = options.tileUrlFunction;
        /**
     * @protected
     * @type {!Array<string>|null}
     */ this.urls = null;
        if (options.urls) this.setUrls(options.urls);
        else if (options.url) this.setUrl(options.url);
        /**
     * @private
     * @type {!Object<string, boolean>}
     */ this.tileLoadingKeys_ = {};
    }
    /**
   * Deprecated.  Use an ImageTile source instead.
   * Return the tile load function of the source.
   * @return {import("../Tile.js").LoadFunction} TileLoadFunction
   * @api
   */ getTileLoadFunction() {
        return this.tileLoadFunction;
    }
    /**
   * Deprecated.  Use an ImageTile source instead.
   * Return the tile URL function of the source.
   * @return {import("../Tile.js").UrlFunction} TileUrlFunction
   * @api
   */ getTileUrlFunction() {
        return Object.getPrototypeOf(this).tileUrlFunction === this.tileUrlFunction ? this.tileUrlFunction.bind(this) : this.tileUrlFunction;
    }
    /**
   * Deprecated.  Use an ImageTile source instead.
   * Return the URLs used for this source.
   * When a tileUrlFunction is used instead of url or urls,
   * null will be returned.
   * @return {!Array<string>|null} URLs.
   * @api
   */ getUrls() {
        return this.urls;
    }
    /**
   * Handle tile change events.
   * @param {import("../events/Event.js").default} event Event.
   * @protected
   */ handleTileChange(event) {
        const tile = /** @type {import("../Tile.js").default} */ event.target;
        const uid = (0, $fd76d391cc228565$export$5e82334337e0f204)(tile);
        const tileState = tile.getState();
        let type;
        if (tileState == (0, $79d423c0f6adbcbb$export$2e2bcd8739ae039).LOADING) {
            this.tileLoadingKeys_[uid] = true;
            type = (0, $b703cf2946e056bb$export$2e2bcd8739ae039).TILELOADSTART;
        } else if (uid in this.tileLoadingKeys_) {
            delete this.tileLoadingKeys_[uid];
            type = tileState == (0, $79d423c0f6adbcbb$export$2e2bcd8739ae039).ERROR ? (0, $b703cf2946e056bb$export$2e2bcd8739ae039).TILELOADERROR : tileState == (0, $79d423c0f6adbcbb$export$2e2bcd8739ae039).LOADED ? (0, $b703cf2946e056bb$export$2e2bcd8739ae039).TILELOADEND : undefined;
        }
        if (type != undefined) this.dispatchEvent(new (0, $fb8cfae1128cb404$export$c571855c51e6c4b6)(type, tile));
    }
    /**
   * Deprecated.  Use an ImageTile source instead.
   * Set the tile load function of the source.
   * @param {import("../Tile.js").LoadFunction} tileLoadFunction Tile load function.
   * @api
   */ setTileLoadFunction(tileLoadFunction) {
        this.tileLoadFunction = tileLoadFunction;
        this.changed();
    }
    /**
   * Deprecated.  Use an ImageTile source instead.
   * Set the tile URL function of the source.
   * @param {import("../Tile.js").UrlFunction} tileUrlFunction Tile URL function.
   * @param {string} [key] Optional new tile key for the source.
   * @api
   */ setTileUrlFunction(tileUrlFunction, key) {
        this.tileUrlFunction = tileUrlFunction;
        if (typeof key !== 'undefined') this.setKey(key);
        else this.changed();
    }
    /**
   * Set the URL to use for requests.
   * @param {string} url URL.
   * @api
   */ setUrl(url) {
        const urls = (0, $ce940d0af289b90b$export$2a1fa079bfd73dde)(url);
        this.urls = urls;
        this.setUrls(urls);
    }
    /**
   * Deprecated.  Use an ImageTile source instead.
   * Set the URLs to use for requests.
   * @param {Array<string>} urls URLs.
   * @api
   */ setUrls(urls) {
        this.urls = urls;
        const key = urls.join('\n');
        if (this.generateTileUrlFunction_) this.setTileUrlFunction((0, $f67d91f4d04e08ca$export$436f44dbcc31fea3)(urls, this.tileGrid), key);
        else this.setKey(key);
    }
    /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {string|undefined} Tile URL.
   */ tileUrlFunction(tileCoord, pixelRatio, projection) {
        return undefined;
    }
}
var $57d6f55c571301ca$export$2e2bcd8739ae039 = $57d6f55c571301ca$var$UrlTile;


/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {number} [cacheSize] Deprecated.  Use the cacheSize option on the layer instead.
 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images.  Note that
 * you must provide a `crossOrigin` value if you want to access pixel data with the Canvas renderer.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {ReferrerPolicy} [referrerPolicy] The `referrerPolicy` property for loaded images.
 * @property {boolean} [interpolate=true] Use interpolated values when resampling.  By default,
 * linear interpolation is used when resampling.  Set to false to use the nearest neighbor instead.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection. Default is the view projection.
 * @property {number} [reprojectionErrorThreshold=0.5] Maximum allowed reprojection error (in pixels).
 * Higher values can increase reprojection performance, but decrease precision.
 * @property {import("./Source.js").State} [state] Source state.
 * @property {typeof import("../ImageTile.js").default} [tileClass] Class used to instantiate image tiles.
 * Default is {@link module:ol/ImageTile~ImageTile}.
 * @property {import("../tilegrid/TileGrid.js").default} [tileGrid] Tile grid.
 * @property {import("../Tile.js").LoadFunction} [tileLoadFunction] Optional function to load a tile given a URL. The default is
 * ```js
 * function(imageTile, src) {
 *   imageTile.getImage().src = src;
 * };
 * ```
 * @property {number} [tilePixelRatio=1] The pixel ratio used by the tile service. For example, if the tile
 * service advertizes 256px by 256px tiles but actually sends 512px
 * by 512px images (for retina/hidpi devices) then `tilePixelRatio`
 * should be set to `2`.
 * @property {import("../Tile.js").UrlFunction} [tileUrlFunction] Deprecated.  Use an ImageTile source and provide a function
 * for the url option instead.
 * @property {string} [url] URL template. Must include `{x}`, `{y}` or `{-y}`, and `{z}` placeholders.
 * A `{?-?}` template pattern, for example `subdomain{a-f}.domain.com`, may be
 * used instead of defining each one separately in the `urls` option.
 * @property {Array<string>} [urls] An array of URL templates.
 * @property {boolean} [wrapX] Whether to wrap the world horizontally. The default, is to
 * request out-of-bounds tiles from the server. When set to `false`, only one
 * world will be rendered. When set to `true`, tiles will be requested for one
 * world only, but they will be wrapped horizontally to render multiple worlds.
 * @property {number} [transition] Duration of the opacity transition for rendering.
 * To disable the opacity transition, pass `transition: 0`.
 * @property {string} [key] Optional tile key for proper cache fetching
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=0]
 * Choose whether to use tiles with a higher or lower zoom level when between integer
 * zoom levels. See {@link module:ol/tilegrid/TileGrid~TileGrid#getZForResolution}.
 */ /**
 * @deprecated Use the ol/source/ImageTile.js instead.
 *
 * @fires import("./Tile.js").TileSourceEvent
 * @api
 */ class $451985fb6fe2e606$var$TileImage extends (0, $57d6f55c571301ca$export$2e2bcd8739ae039) {
    /**
   * @param {!Options} options Image tile options.
   */ constructor(options){
        super({
            attributions: options.attributions,
            cacheSize: options.cacheSize,
            projection: options.projection,
            state: options.state,
            tileGrid: options.tileGrid,
            tileLoadFunction: options.tileLoadFunction ? options.tileLoadFunction : $451985fb6fe2e606$export$bf0e2e44d1d59b25,
            tilePixelRatio: options.tilePixelRatio,
            tileUrlFunction: options.tileUrlFunction,
            url: options.url,
            urls: options.urls,
            wrapX: options.wrapX,
            transition: options.transition,
            interpolate: options.interpolate !== undefined ? options.interpolate : true,
            key: options.key,
            attributionsCollapsible: options.attributionsCollapsible,
            zDirection: options.zDirection
        });
        /**
     * @protected
     * @type {?string}
     */ this.crossOrigin = options.crossOrigin !== undefined ? options.crossOrigin : null;
        /**
     * @protected
     * @type {ReferrerPolicy}
     */ this.referrerPolicy = options.referrerPolicy;
        /**
     * @protected
     * @type {typeof ImageTile}
     */ this.tileClass = options.tileClass !== undefined ? options.tileClass : (0, $af328a9781fa918b$export$2e2bcd8739ae039);
        /**
     * @protected
     * @type {!Object<string, import("../tilegrid/TileGrid.js").default>}
     */ this.tileGridForProjection = {};
        /**
     * @private
     * @type {number|undefined}
     */ this.reprojectionErrorThreshold_ = options.reprojectionErrorThreshold;
        /**
     * @private
     * @type {boolean}
     */ this.renderReprojectionEdges_ = false;
    }
    /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {number} Gutter.
   * @override
   */ getGutterForProjection(projection) {
        if (this.getProjection() && projection && !(0, $a86eee1c28205a05$export$fe091d73a555748b)(this.getProjection(), projection)) return 0;
        return this.getGutter();
    }
    /**
   * @return {number} Gutter.
   */ getGutter() {
        return 0;
    }
    /**
   * Return the key to be used for all tiles in the source.
   * @return {string} The key for all tiles.
   * @override
   */ getKey() {
        let key = super.getKey();
        if (!this.getInterpolate()) key += ':disable-interpolation';
        return key;
    }
    /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {!import("../tilegrid/TileGrid.js").default} Tile grid.
   * @override
   */ getTileGridForProjection(projection) {
        const thisProj = this.getProjection();
        if (this.tileGrid && (!thisProj || (0, $a86eee1c28205a05$export$fe091d73a555748b)(thisProj, projection))) return this.tileGrid;
        const projKey = (0, $fd76d391cc228565$export$5e82334337e0f204)(projection);
        if (!(projKey in this.tileGridForProjection)) this.tileGridForProjection[projKey] = (0, $ce64bfb95181f463$export$1f4812384df8a9c5)(projection);
        return this.tileGridForProjection[projKey];
    }
    /**
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @param {string} key The key set on the tile.
   * @return {!ImageTile} Tile.
   * @private
   */ createTile_(z, x, y, pixelRatio, projection, key) {
        const tileCoord = [
            z,
            x,
            y
        ];
        const urlTileCoord = this.getTileCoordForTileUrlFunction(tileCoord, projection);
        const tileUrl = urlTileCoord ? this.tileUrlFunction(urlTileCoord, pixelRatio, projection) : undefined;
        const tile = new this.tileClass(tileCoord, tileUrl !== undefined ? (0, $79d423c0f6adbcbb$export$2e2bcd8739ae039).IDLE : (0, $79d423c0f6adbcbb$export$2e2bcd8739ae039).EMPTY, tileUrl !== undefined ? tileUrl : '', {
            crossOrigin: this.crossOrigin,
            referrerPolicy: this.referrerPolicy
        }, this.tileLoadFunction, this.tileOptions);
        tile.key = key;
        tile.addEventListener((0, $b5fa963342da4935$export$2e2bcd8739ae039).CHANGE, this.handleTileChange.bind(this));
        return tile;
    }
    /**
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @param {import("../structs/LRUCache.js").default<import("../Tile.js").default>} [tileCache] Tile cache.
   * @return {!(ImageTile|ReprojTile)} Tile.
   * @override
   */ getTile(z, x, y, pixelRatio, projection, tileCache) {
        const sourceProjection = this.getProjection();
        if (!sourceProjection || !projection || (0, $a86eee1c28205a05$export$fe091d73a555748b)(sourceProjection, projection)) return this.getTileInternal(z, x, y, pixelRatio, sourceProjection || projection);
        const tileCoord = [
            z,
            x,
            y
        ];
        const key = this.getKey();
        const sourceTileGrid = this.getTileGridForProjection(sourceProjection);
        const targetTileGrid = this.getTileGridForProjection(projection);
        const wrappedTileCoord = this.getTileCoordForTileUrlFunction(tileCoord, projection);
        const tile = new (0, $a9e17fc88997910c$export$2e2bcd8739ae039)(sourceProjection, sourceTileGrid, projection, targetTileGrid, tileCoord, wrappedTileCoord, this.getTilePixelRatio(pixelRatio), this.getGutter(), (z, x, y, pixelRatio)=>this.getTileInternal(z, x, y, pixelRatio, sourceProjection, tileCache), this.reprojectionErrorThreshold_, this.renderReprojectionEdges_, this.tileOptions);
        tile.key = key;
        return tile;
    }
    /**
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {number} pixelRatio Pixel ratio.
   * @param {!import("../proj/Projection.js").default} projection Projection.
   * @param {import("../structs/LRUCache.js").default<import("../Tile.js").default>} [tileCache] Tile cache.
   * @return {!ImageTile} Tile.
   * @protected
   */ getTileInternal(z, x, y, pixelRatio, projection, tileCache) {
        const key = this.getKey();
        const cacheKey = (0, $8b203a265587842e$export$611736262b635f8d)(this, key, z, x, y);
        if (tileCache && tileCache.containsKey(cacheKey)) {
            const tile = /** @type {!ImageTile} */ tileCache.get(cacheKey);
            return tile;
        }
        const tile = this.createTile_(z, x, y, pixelRatio, projection, key);
        tileCache?.set(cacheKey, tile);
        return tile;
    }
    /**
   * Sets whether to render reprojection edges or not (usually for debugging).
   * @param {boolean} render Render the edges.
   * @api
   */ setRenderReprojectionEdges(render) {
        if (this.renderReprojectionEdges_ == render) return;
        this.renderReprojectionEdges_ = render;
        this.changed();
    }
    /**
   * Sets the tile grid to use when reprojecting the tiles to the given
   * projection instead of the default tile grid for the projection.
   *
   * This can be useful when the default tile grid cannot be created
   * (e.g. projection has no extent defined) or
   * for optimization reasons (custom tile size, resolutions, ...).
   *
   * @param {import("../proj.js").ProjectionLike} projection Projection.
   * @param {import("../tilegrid/TileGrid.js").default} tilegrid Tile grid to use for the projection.
   * @api
   */ setTileGridForProjection(projection, tilegrid) {
        const proj = (0, $a86eee1c28205a05$export$3988ae62b71be9a3)(projection);
        if (proj) {
            const projKey = (0, $fd76d391cc228565$export$5e82334337e0f204)(proj);
            if (!(projKey in this.tileGridForProjection)) this.tileGridForProjection[projKey] = tilegrid;
        }
    }
}
function $451985fb6fe2e606$export$bf0e2e44d1d59b25(imageTile, src) {
    if (0, $32d41268b5f53567$export$98fcef3dc9973292) {
        // special treatment for offscreen canvas
        const crossOrigin = imageTile.getCrossOrigin();
        /** @type {RequestMode} */ let mode = 'same-origin';
        /** @type {RequestCredentials} */ let credentials = 'same-origin';
        if (crossOrigin === 'anonymous' || crossOrigin === '') {
            mode = 'cors';
            credentials = 'omit';
        } else if (crossOrigin === 'use-credentials') {
            mode = 'cors';
            credentials = 'include';
        }
        const options = {
            mode: mode,
            credentials: credentials,
            referrerPolicy: imageTile.getReferrerPolicy()
        };
        fetch(src, options).then((response)=>{
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            return response.blob();
        }).then((blob)=>{
            return createImageBitmap(blob);
        }).then((imageBitmap)=>{
            const canvas = imageTile.getImage();
            canvas.width = imageBitmap.width;
            canvas.height = imageBitmap.height;
            const ctx = /** @type {OffscreenCanvas} */ canvas.getContext('2d');
            ctx.drawImage(imageBitmap, 0, 0);
            imageBitmap.close?.();
            // mock the image 'load' event
            canvas.dispatchEvent(new Event('load'));
        }).catch(()=>{
            const canvas = imageTile.getImage();
            canvas.dispatchEvent(new Event('error'));
        });
        return;
    }
    /** @type {HTMLImageElement|HTMLVideoElement} */ imageTile.getImage().src = src;
}
var $451985fb6fe2e606$export$2e2bcd8739ae039 = $451985fb6fe2e606$var$TileImage;


/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {number} [cacheSize] Deprecated.  Use the cacheSize option on the layer instead.
 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images.  Note that
 * you must provide a `crossOrigin` value if you want to access pixel data with the Canvas renderer.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {ReferrerPolicy} [referrerPolicy] The `referrerPolicy` property for loaded images.
 * @property {boolean} [interpolate=true] Use interpolated values when resampling.  By default,
 * linear interpolation is used when resampling.  Set to false to use the nearest neighbor instead.
 * @property {import("../proj.js").ProjectionLike} [projection='EPSG:3857'] Projection.
 * @property {number} [reprojectionErrorThreshold=0.5] Maximum allowed reprojection error (in pixels).
 * Higher values can increase reprojection performance, but decrease precision.
 * @property {number} [maxZoom=42] Optional max zoom level. Not used if `tileGrid` is provided.
 * @property {number} [minZoom=0] Optional min zoom level. Not used if `tileGrid` is provided.
 * @property {number} [maxResolution] Optional tile grid resolution at level zero. Not used if `tileGrid` is provided.
 * @property {import("../tilegrid/TileGrid.js").default} [tileGrid] Tile grid.
 * @property {import("../Tile.js").LoadFunction} [tileLoadFunction] Deprecated.  Use an ImageTile source with a loader
 * instead.  Optional function to load a tile given a URL. The default is
 * ```js
 * function(imageTile, src) {
 *   imageTile.getImage().src = src;
 * };
 * ```
 * @property {number} [tilePixelRatio=1] The pixel ratio used by the tile service.
 * For example, if the tile service advertizes 256px by 256px tiles but actually sends 512px
 * by 512px images (for retina/hidpi devices) then `tilePixelRatio`
 * should be set to `2`.
 * @property {number|import("../size.js").Size} [tileSize=[256, 256]] The tile size used by the tile service.
 * Not used if `tileGrid` is provided.
 * @property {number} [gutter=0] The size in pixels of the gutter around image tiles to ignore.
 * This allows artifacts of rendering at tile edges to be ignored.
 * Supported images should be wider and taller than the tile size by a value of `2 x gutter`.
 * @property {import("../Tile.js").UrlFunction} [tileUrlFunction] Deprecated.  Use an ImageTile source and provide a function
 * for the url option instead.
 * @property {string} [url] URL template. Must include `{x}`, `{y}` or `{-y}`,
 * and `{z}` placeholders. A `{?-?}` template pattern, for example `subdomain{a-f}.domain.com`,
 * may be used instead of defining each one separately in the `urls` option.
 * @property {Array<string>} [urls] Deprecated.  Use an ImageTile source and provide an array of URLs for the
 * url option instead.
 * @property {boolean} [wrapX=true] Whether to wrap the world horizontally.
 * @property {number} [transition=250] Duration of the opacity transition for rendering.
 * To disable the opacity transition, pass `transition: 0`.
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=0]
 * Choose whether to use tiles with a higher or lower zoom level when between integer
 * zoom levels. See {@link module:ol/tilegrid/TileGrid~TileGrid#getZForResolution}.
 */ /**
 * @classdesc
 * Layer source for tile data with URLs in a set XYZ format that are
 * defined in a URL template. By default, this follows the widely-used
 * Google grid where `x` 0 and `y` 0 are in the top left. Grids like
 * TMS where `x` 0 and `y` 0 are in the bottom left can be used by
 * using the `{-y}` placeholder in the URL template, so long as the
 * source does not have a custom tile grid. In this case
 * a `tileUrlFunction` can be used, such as:
 * ```js
 *  tileUrlFunction: function(coordinate) {
 *    return 'http://mapserver.com/' + coordinate[0] + '/' +
 *      coordinate[1] + '/' + (-coordinate[2] - 1) + '.png';
 *  }
 * ```
 * @api
 */ class $2efdbaeaea9b4c0f$var$XYZ extends (0, $451985fb6fe2e606$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] XYZ options.
   */ constructor(options){
        options = options || {};
        const projection = options.projection !== undefined ? options.projection : 'EPSG:3857';
        const tileGrid = options.tileGrid !== undefined ? options.tileGrid : (0, $ce64bfb95181f463$export$38500bbeccc864ff)({
            extent: (0, $ce64bfb95181f463$export$7b5b6ef8fd55fac4)(projection),
            maxResolution: options.maxResolution,
            maxZoom: options.maxZoom,
            minZoom: options.minZoom,
            tileSize: options.tileSize
        });
        super({
            attributions: options.attributions,
            cacheSize: options.cacheSize,
            crossOrigin: options.crossOrigin,
            referrerPolicy: options.referrerPolicy,
            interpolate: options.interpolate,
            projection: projection,
            reprojectionErrorThreshold: options.reprojectionErrorThreshold,
            tileGrid: tileGrid,
            tileLoadFunction: options.tileLoadFunction,
            tilePixelRatio: options.tilePixelRatio,
            tileUrlFunction: options.tileUrlFunction,
            url: options.url,
            urls: options.urls,
            wrapX: options.wrapX !== undefined ? options.wrapX : true,
            transition: options.transition,
            attributionsCollapsible: options.attributionsCollapsible,
            zDirection: options.zDirection
        });
        /**
     * @private
     * @type {number}
     */ this.gutter_ = options.gutter !== undefined ? options.gutter : 0;
    }
    /**
   * @return {number} Gutter.
   * @override
   */ getGutter() {
        return this.gutter_;
    }
}
var $2efdbaeaea9b4c0f$export$2e2bcd8739ae039 = $2efdbaeaea9b4c0f$var$XYZ;


const $6944b8b0ce57af59$export$4de8a5e77eb994ad = '&#169; <a href="https://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a> contributors.';
/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {number} [cacheSize] Deprecated.  Use the cacheSize option on the layer instead.
 * @property {null|string} [crossOrigin='anonymous'] The `crossOrigin` attribute for loaded images.  Note that
 * you must provide a `crossOrigin` value if you want to access pixel data with the Canvas renderer.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {ReferrerPolicy} [referrerPolicy='origin-when-cross-origin'] The `referrerPolicy` property for loaded images.
 * @property {boolean} [interpolate=true] Use interpolated values when resampling.  By default,
 * linear interpolation is used when resampling.  Set to false to use the nearest neighbor instead.
 * @property {number} [maxZoom=19] Max zoom.
 * @property {number} [reprojectionErrorThreshold=0.5] Maximum allowed reprojection error (in pixels).
 * Higher values can increase reprojection performance, but decrease precision.
 * @property {import("../Tile.js").LoadFunction} [tileLoadFunction] Optional function to load a tile given a URL. The default is
 * ```js
 * function(imageTile, src) {
 *   imageTile.getImage().src = src;
 * };
 * ```
 * @property {number} [transition=250] Duration of the opacity transition for rendering.
 * To disable the opacity transition, pass `transition: 0`.
 * @property {string} [url='https://tile.openstreetmap.org/{z}/{x}/{y}.png'] URL template.
 * Must include `{x}`, `{y}` or `{-y}`, and `{z}` placeholders.
 * @property {boolean} [wrapX=true] Whether to wrap the world horizontally.
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=0]
 * Choose whether to use tiles with a higher or lower zoom level when between integer
 * zoom levels. See {@link module:ol/tilegrid/TileGrid~TileGrid#getZForResolution}.
 */ /**
 * @classdesc
 * Layer source for the OpenStreetMap tile server.
 * @api
 */ class $6944b8b0ce57af59$var$OSM extends (0, $2efdbaeaea9b4c0f$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Open Street Map options.
   */ constructor(options){
        options = options || {};
        let attributions;
        if (options.attributions !== undefined) attributions = options.attributions;
        else attributions = [
            $6944b8b0ce57af59$export$4de8a5e77eb994ad
        ];
        const url = options.url !== undefined ? options.url : 'https://tile.openstreetmap.org/{z}/{x}/{y}.png';
        super({
            attributions: attributions,
            attributionsCollapsible: false,
            cacheSize: options.cacheSize,
            crossOrigin: options.crossOrigin !== undefined ? options.crossOrigin : 'anonymous',
            referrerPolicy: options.referrerPolicy || 'origin-when-cross-origin',
            interpolate: options.interpolate,
            maxZoom: options.maxZoom !== undefined ? options.maxZoom : 19,
            reprojectionErrorThreshold: options.reprojectionErrorThreshold,
            tileLoadFunction: options.tileLoadFunction,
            transition: options.transition,
            url: url,
            wrapX: options.wrapX,
            zDirection: options.zDirection
        });
    }
}
var $6944b8b0ce57af59$export$2e2bcd8739ae039 = $6944b8b0ce57af59$var$OSM;

/**
 * @module ol/source/TileWMS
 */ 







/**
 * @module ol/source/wms
 */ 





/**
 * @module ol/source/Image
 */ 







/**
 * @module ol/reproj/Image
 */ 





/**
 * @module ol/resolution
 */ /**
 * @typedef {number|Array<number>} ResolutionLike
 */ /**
 * @param {ResolutionLike} resolution Resolution.
 * @return {number} Resolution.
 */ function $1c18999cbe219866$export$bc4231bf34bfa9ad(resolution) {
    if (Array.isArray(resolution)) return Math.min(...resolution);
    return resolution;
}




/**
 * @typedef {function(import("../extent.js").Extent, number, number) : import("../Image.js").default} FunctionType
 */ /**
 * @classdesc
 * Class encapsulating single reprojected image.
 * See {@link module:ol/source/Image~ImageSource}.
 */ class $ceb5095d9cefa117$var$ReprojImage extends (0, $617ef54ed150e783$export$2e2bcd8739ae039) {
    /**
   * @param {import("../proj/Projection.js").default} sourceProj Source projection (of the data).
   * @param {import("../proj/Projection.js").default} targetProj Target projection.
   * @param {import("../extent.js").Extent} targetExtent Target extent.
   * @param {number} targetResolution Target resolution.
   * @param {number} pixelRatio Pixel ratio.
   * @param {FunctionType} getImageFunction
   *     Function returning source images (extent, resolution, pixelRatio).
   * @param {boolean} interpolate Use linear interpolation when resampling.
   */ constructor(sourceProj, targetProj, targetExtent, targetResolution, pixelRatio, getImageFunction, interpolate){
        let maxSourceExtent = sourceProj.getExtent();
        if (maxSourceExtent && sourceProj.canWrapX()) {
            maxSourceExtent = maxSourceExtent.slice();
            maxSourceExtent[0] = -Infinity;
            maxSourceExtent[2] = Infinity;
        }
        let maxTargetExtent = targetProj.getExtent();
        if (maxTargetExtent && targetProj.canWrapX()) {
            maxTargetExtent = maxTargetExtent.slice();
            maxTargetExtent[0] = -Infinity;
            maxTargetExtent[2] = Infinity;
        }
        const limitedTargetExtent = maxTargetExtent ? (0, $dea65c2f666fa450$export$72209efa88586d42)(targetExtent, maxTargetExtent) : targetExtent;
        const targetCenter = (0, $dea65c2f666fa450$export$c91255cadecfe081)(limitedTargetExtent);
        const sourceResolution = (0, $a414945bcb55714f$export$5fbb958059b7e71f)(sourceProj, targetProj, targetCenter, targetResolution);
        const errorThresholdInPixels = (0, $8700c9c2fd379982$export$3ecb4bcfa5aae855);
        const triangulation = new (0, $ac803fe94e8ac9e6$export$2e2bcd8739ae039)(sourceProj, targetProj, limitedTargetExtent, maxSourceExtent, sourceResolution * errorThresholdInPixels, targetResolution);
        const sourceExtent = triangulation.calculateSourceExtent();
        const sourceImage = (0, $dea65c2f666fa450$export$dd1bc94b04021eeb)(sourceExtent) ? null : getImageFunction(sourceExtent, sourceResolution, pixelRatio);
        const state = sourceImage ? (0, $f217251b3f1483a0$export$2e2bcd8739ae039).IDLE : (0, $f217251b3f1483a0$export$2e2bcd8739ae039).EMPTY;
        const sourcePixelRatio = sourceImage ? sourceImage.getPixelRatio() : 1;
        super(targetExtent, targetResolution, sourcePixelRatio, state);
        /**
     * @private
     * @type {import("../proj/Projection.js").default}
     */ this.targetProj_ = targetProj;
        /**
     * @private
     * @type {import("../extent.js").Extent}
     */ this.maxSourceExtent_ = maxSourceExtent;
        /**
     * @private
     * @type {!import("./Triangulation.js").default}
     */ this.triangulation_ = triangulation;
        /**
     * @private
     * @type {number}
     */ this.targetResolution_ = targetResolution;
        /**
     * @private
     * @type {import("../extent.js").Extent}
     */ this.targetExtent_ = targetExtent;
        /**
     * @private
     * @type {import("../Image.js").default}
     */ this.sourceImage_ = sourceImage;
        /**
     * @private
     * @type {number}
     */ this.sourcePixelRatio_ = sourcePixelRatio;
        /**
     * @private
     * @type {boolean}
     */ this.interpolate_ = interpolate;
        /**
     * @private
     * @type {HTMLCanvasElement|OffscreenCanvas}
     */ this.canvas_ = null;
        /**
     * @private
     * @type {?import("../events.js").EventsKey}
     */ this.sourceListenerKey_ = null;
    }
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        if (this.state == (0, $f217251b3f1483a0$export$2e2bcd8739ae039).LOADING) this.unlistenSource_();
        super.disposeInternal();
    }
    /**
   * @return {HTMLCanvasElement|OffscreenCanvas} Image.
   * @override
   */ getImage() {
        return this.canvas_;
    }
    /**
   * @return {import("../proj/Projection.js").default} Projection.
   */ getProjection() {
        return this.targetProj_;
    }
    /**
   * @private
   */ reproject_() {
        const sourceState = this.sourceImage_.getState();
        if (sourceState == (0, $f217251b3f1483a0$export$2e2bcd8739ae039).LOADED) {
            const width = (0, $dea65c2f666fa450$export$3c49c185de0c2bfc)(this.targetExtent_) / this.targetResolution_;
            const height = (0, $dea65c2f666fa450$export$c08559766941f856)(this.targetExtent_) / this.targetResolution_;
            this.canvas_ = (0, $a414945bcb55714f$export$b3890eb0ae9dca99)(width, height, this.sourcePixelRatio_, (0, $1c18999cbe219866$export$bc4231bf34bfa9ad)(this.sourceImage_.getResolution()), this.maxSourceExtent_, this.targetResolution_, this.targetExtent_, this.triangulation_, [
                {
                    extent: this.sourceImage_.getExtent(),
                    image: this.sourceImage_.getImage()
                }
            ], 0, undefined, this.interpolate_, true);
        }
        this.state = sourceState;
        this.changed();
    }
    /**
   * Load not yet loaded URI.
   * @override
   */ load() {
        if (this.state == (0, $f217251b3f1483a0$export$2e2bcd8739ae039).IDLE) {
            this.state = (0, $f217251b3f1483a0$export$2e2bcd8739ae039).LOADING;
            this.changed();
            const sourceState = this.sourceImage_.getState();
            if (sourceState == (0, $f217251b3f1483a0$export$2e2bcd8739ae039).LOADED || sourceState == (0, $f217251b3f1483a0$export$2e2bcd8739ae039).ERROR) this.reproject_();
            else {
                this.sourceListenerKey_ = (0, $63963d09e0c49405$export$63174c828edd6ff8)(this.sourceImage_, (0, $b5fa963342da4935$export$2e2bcd8739ae039).CHANGE, (e)=>{
                    const sourceState = this.sourceImage_.getState();
                    if (sourceState == (0, $f217251b3f1483a0$export$2e2bcd8739ae039).LOADED || sourceState == (0, $f217251b3f1483a0$export$2e2bcd8739ae039).ERROR) {
                        this.unlistenSource_();
                        this.reproject_();
                    }
                });
                this.sourceImage_.load();
            }
        }
    }
    /**
   * @private
   */ unlistenSource_() {
        (0, $63963d09e0c49405$export$b0a21c8b3c1c921)(/** @type {!import("../events.js").EventsKey} */ this.sourceListenerKey_);
        this.sourceListenerKey_ = null;
    }
}
var $ceb5095d9cefa117$export$2e2bcd8739ae039 = $ceb5095d9cefa117$var$ReprojImage;




/**
 * @module ol/source/common
 */ /**
 * Default WMS version.
 * @type {string}
 */ const $dc0fdb47039c6a50$export$8c33e4eedb20eeb5 = '1.3.0';
const $dc0fdb47039c6a50$export$48fbc15abf52505f = 4;


const $4a79210cc82cb3cb$export$4e0f6da20e5dcc4f = {
    /**
   * Triggered when an image starts loading.
   * @event module:ol/source/Image.ImageSourceEvent#imageloadstart
   * @api
   */ IMAGELOADSTART: 'imageloadstart',
    /**
   * Triggered when an image finishes loading.
   * @event module:ol/source/Image.ImageSourceEvent#imageloadend
   * @api
   */ IMAGELOADEND: 'imageloadend',
    /**
   * Triggered if image loading results in an error.
   * @event module:ol/source/Image.ImageSourceEvent#imageloaderror
   * @api
   */ IMAGELOADERROR: 'imageloaderror'
};
class $4a79210cc82cb3cb$export$58d3276cd83daede extends (0, $5c6b0a43c077a98f$export$2e2bcd8739ae039) {
    /**
   * @param {string} type Type.
   * @param {import("../Image.js").default} image The image.
   */ constructor(type, image){
        super(type);
        /**
     * The image related to the event.
     * @type {import("../Image.js").default}
     * @api
     */ this.image = image;
    }
}
/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types, import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<ImageSourceEventTypes, ImageSourceEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types
 *     |ImageSourceEventTypes, Return>} ImageSourceOnSignature
 */ /**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {boolean} [interpolate=true] Use interpolated values when resampling.  By default,
 * linear interpolation is used when resampling.  Set to false to use the nearest neighbor instead.
 * @property {import("../Image.js").Loader} [loader] Loader. Can either be a custom loader, or one of the
 * loaders created with a `createLoader()` function ({@link module:ol/source/wms.createLoader wms},
 * {@link module:ol/source/arcgisRest.createLoader arcgisRest}, {@link module:ol/source/mapguide.createLoader mapguide},
 * {@link module:ol/source/static.createLoader static}).
 * @property {import("../proj.js").ProjectionLike} [projection] Projection.
 * @property {Array<number>} [resolutions] Resolutions.
 * @property {import("./Source.js").State} [state] State.
 */ /**
 * @classdesc
 * Base class for sources providing a single image.
 * @fires module:ol/source/Image.ImageSourceEvent
 * @api
 */ class $4a79210cc82cb3cb$var$ImageSource extends (0, $f43c44b2b88dd1d8$export$2e2bcd8739ae039) {
    /**
   * @param {Options} options Single image source options.
   */ constructor(options){
        super({
            attributions: options.attributions,
            projection: options.projection,
            state: options.state,
            interpolate: options.interpolate !== undefined ? options.interpolate : true
        });
        /***
     * @type {ImageSourceOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {ImageSourceOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {ImageSourceOnSignature<void>}
     */ this.un;
        /**
     * @protected
     * @type {import("../Image.js").Loader}
     */ this.loader = options.loader || null;
        /**
     * @private
     * @type {Array<number>|null}
     */ this.resolutions_ = options.resolutions !== undefined ? options.resolutions : null;
        /**
     * @private
     * @type {import("../reproj/Image.js").default}
     */ this.reprojectedImage_ = null;
        /**
     * @private
     * @type {number}
     */ this.reprojectedRevision_ = 0;
        /**
     * @protected
     * @type {import("../Image.js").default}
     */ this.image = null;
        /**
     * @private
     * @type {import("../extent.js").Extent}
     */ this.wantedExtent_;
        /**
     * @private
     * @type {number}
     */ this.wantedResolution_;
        /**
     * @private
     * @type {boolean}
     */ this.static_ = options.loader ? options.loader.length === 0 : false;
        /**
     * @private
     * @type {import("../proj/Projection.js").default}
     */ this.wantedProjection_ = null;
    }
    /**
   * @return {Array<number>|null} Resolutions.
   * @override
   */ getResolutions() {
        return this.resolutions_;
    }
    /**
   * @param {Array<number>|null} resolutions Resolutions.
   */ setResolutions(resolutions) {
        this.resolutions_ = resolutions;
    }
    /**
   * @protected
   * @param {number} resolution Resolution.
   * @return {number} Resolution.
   */ findNearestResolution(resolution) {
        const resolutions = this.getResolutions();
        if (resolutions) {
            const idx = (0, $49313fcb0fc32abe$export$8a3786cc03fdb777)(resolutions, resolution, 0);
            resolution = resolutions[idx];
        }
        return resolution;
    }
    /**
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {import("../Image.js").default} Single image.
   */ getImage(extent, resolution, pixelRatio, projection) {
        const sourceProjection = this.getProjection();
        if (!sourceProjection || !projection || (0, $a86eee1c28205a05$export$fe091d73a555748b)(sourceProjection, projection)) {
            if (sourceProjection) projection = sourceProjection;
            return this.getImageInternal(extent, resolution, pixelRatio, projection);
        }
        if (this.reprojectedImage_) {
            if (this.reprojectedRevision_ == this.getRevision() && (0, $a86eee1c28205a05$export$fe091d73a555748b)(this.reprojectedImage_.getProjection(), projection) && this.reprojectedImage_.getResolution() == resolution && (0, $dea65c2f666fa450$export$e9bab7fafb253603)(this.reprojectedImage_.getExtent(), extent)) return this.reprojectedImage_;
            this.reprojectedImage_.dispose();
            this.reprojectedImage_ = null;
        }
        this.reprojectedImage_ = new (0, $ceb5095d9cefa117$export$2e2bcd8739ae039)(sourceProjection, projection, extent, resolution, pixelRatio, (extent, resolution, pixelRatio)=>this.getImageInternal(extent, resolution, pixelRatio, sourceProjection), this.getInterpolate());
        this.reprojectedRevision_ = this.getRevision();
        return this.reprojectedImage_;
    }
    /**
   * @abstract
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {import("../Image.js").default} Single image.
   * @protected
   */ getImageInternal(extent, resolution, pixelRatio, projection) {
        if (this.loader) {
            const requestExtent = $4a79210cc82cb3cb$export$2a9dcc8f63da1787(extent, resolution, pixelRatio, 1);
            const requestResolution = this.findNearestResolution(resolution);
            if (this.image && (this.static_ || this.wantedProjection_ === projection && (this.wantedExtent_ && (0, $dea65c2f666fa450$export$be866b1e0809b17e)(this.wantedExtent_, requestExtent) || (0, $dea65c2f666fa450$export$be866b1e0809b17e)(this.image.getExtent(), requestExtent)) && (this.wantedResolution_ && (0, $1c18999cbe219866$export$bc4231bf34bfa9ad)(this.wantedResolution_) === requestResolution || (0, $1c18999cbe219866$export$bc4231bf34bfa9ad)(this.image.getResolution()) === requestResolution))) return this.image;
            this.wantedProjection_ = projection;
            this.wantedExtent_ = requestExtent;
            this.wantedResolution_ = requestResolution;
            this.image = new (0, $617ef54ed150e783$export$2e2bcd8739ae039)(requestExtent, requestResolution, pixelRatio, this.loader);
            this.image.addEventListener((0, $b5fa963342da4935$export$2e2bcd8739ae039).CHANGE, this.handleImageChange.bind(this));
        }
        return this.image;
    }
    /**
   * Handle image change events.
   * @param {import("../events/Event.js").default} event Event.
   * @protected
   */ handleImageChange(event) {
        const image = /** @type {import("../Image.js").default} */ event.target;
        let type;
        switch(image.getState()){
            case (0, $f217251b3f1483a0$export$2e2bcd8739ae039).LOADING:
                this.loading = true;
                type = $4a79210cc82cb3cb$export$4e0f6da20e5dcc4f.IMAGELOADSTART;
                break;
            case (0, $f217251b3f1483a0$export$2e2bcd8739ae039).LOADED:
                this.loading = false;
                type = $4a79210cc82cb3cb$export$4e0f6da20e5dcc4f.IMAGELOADEND;
                break;
            case (0, $f217251b3f1483a0$export$2e2bcd8739ae039).ERROR:
                this.loading = false;
                type = $4a79210cc82cb3cb$export$4e0f6da20e5dcc4f.IMAGELOADERROR;
                break;
            default:
                return;
        }
        if (this.hasListener(type)) this.dispatchEvent(new $4a79210cc82cb3cb$export$58d3276cd83daede(type, image));
    }
}
function $4a79210cc82cb3cb$export$584f102f75ff44b3(image, src) {
    /** @type {HTMLImageElement|HTMLVideoElement} */ image.getImage().src = src;
}
function $4a79210cc82cb3cb$export$2a9dcc8f63da1787(extent, resolution, pixelRatio, ratio) {
    const imageResolution = resolution / pixelRatio;
    const center = (0, $dea65c2f666fa450$export$c91255cadecfe081)(extent);
    const viewWidth = (0, $6a95bd76d7103f37$export$803ce6b71a0a94b2)((0, $dea65c2f666fa450$export$3c49c185de0c2bfc)(extent) / imageResolution, (0, $dc0fdb47039c6a50$export$48fbc15abf52505f));
    const viewHeight = (0, $6a95bd76d7103f37$export$803ce6b71a0a94b2)((0, $dea65c2f666fa450$export$c08559766941f856)(extent) / imageResolution, (0, $dc0fdb47039c6a50$export$48fbc15abf52505f));
    const marginWidth = (0, $6a95bd76d7103f37$export$803ce6b71a0a94b2)((ratio - 1) * viewWidth / 2, (0, $dc0fdb47039c6a50$export$48fbc15abf52505f));
    const requestWidth = viewWidth + 2 * marginWidth;
    const marginHeight = (0, $6a95bd76d7103f37$export$803ce6b71a0a94b2)((ratio - 1) * viewHeight / 2, (0, $dc0fdb47039c6a50$export$48fbc15abf52505f));
    const requestHeight = viewHeight + 2 * marginHeight;
    return (0, $dea65c2f666fa450$export$13ba650faf8308)(center, imageResolution, 0, [
        requestWidth,
        requestHeight
    ]);
}
var $4a79210cc82cb3cb$export$2e2bcd8739ae039 = $4a79210cc82cb3cb$var$ImageSource;



const $463fc5224b289b57$export$363ebe89e6e7aeef = '1.3.0';
/**
 * @const
 * @type {import("../size.js").Size}
 */ const $463fc5224b289b57$var$GETFEATUREINFO_IMAGE_SIZE = [
    101,
    101
];
function $463fc5224b289b57$export$14619c0eed01a470(baseUrl, extent, size, projection, params) {
    params['WIDTH'] = size[0];
    params['HEIGHT'] = size[1];
    const axisOrientation = projection.getAxisOrientation();
    const v13 = (0, $cef15f396d6ffa11$export$66e1c0999abad646)(params['VERSION'], '1.3') >= 0;
    params[v13 ? 'CRS' : 'SRS'] = projection.getCode();
    const bbox = v13 && axisOrientation.startsWith('ne') ? [
        extent[1],
        extent[0],
        extent[3],
        extent[2]
    ] : extent;
    params['BBOX'] = bbox.join(',');
    return (0, $ce940d0af289b90b$export$c202e3cb8db99a95)(baseUrl, params);
}
function $463fc5224b289b57$export$ef1c8480e0b65584(extent, resolution, pixelRatio, projection, url, params, serverType) {
    params = Object.assign({
        REQUEST: 'GetMap'
    }, params);
    const imageResolution = resolution / pixelRatio;
    const imageSize = [
        (0, $6a95bd76d7103f37$export$2077e0241d6afd3c)((0, $dea65c2f666fa450$export$3c49c185de0c2bfc)(extent) / imageResolution, (0, $dc0fdb47039c6a50$export$48fbc15abf52505f)),
        (0, $6a95bd76d7103f37$export$2077e0241d6afd3c)((0, $dea65c2f666fa450$export$c08559766941f856)(extent) / imageResolution, (0, $dc0fdb47039c6a50$export$48fbc15abf52505f))
    ];
    if (pixelRatio != 1) switch(serverType){
        case 'geoserver':
            const dpi = 90 * pixelRatio + 0.5 | 0;
            if ('FORMAT_OPTIONS' in params) params['FORMAT_OPTIONS'] += ';dpi:' + dpi;
            else params['FORMAT_OPTIONS'] = 'dpi:' + dpi;
            break;
        case 'mapserver':
            params['MAP_RESOLUTION'] = 90 * pixelRatio;
            break;
        case 'carmentaserver':
        case 'qgis':
            params['DPI'] = 90 * pixelRatio;
            break;
        default:
            throw new Error('Unknown `serverType` configured');
    }
    const src = $463fc5224b289b57$export$14619c0eed01a470(url, extent, imageSize, projection, params);
    return src;
}
function $463fc5224b289b57$export$a4c60e148c7af082(params, request) {
    return Object.assign({
        'REQUEST': request,
        'SERVICE': 'WMS',
        'VERSION': $463fc5224b289b57$export$363ebe89e6e7aeef,
        'FORMAT': 'image/png',
        'STYLES': '',
        'TRANSPARENT': 'TRUE'
    }, params);
}
function $463fc5224b289b57$export$8e84ca9bef6adc3a(options) {
    const hidpi = options.hidpi === undefined ? true : options.hidpi;
    const projection = (0, $a86eee1c28205a05$export$3988ae62b71be9a3)(options.projection || 'EPSG:3857');
    const ratio = options.ratio || 1.5;
    const load = options.load || (0, $617ef54ed150e783$export$2f872c0f2117be69);
    const crossOrigin = options.crossOrigin ?? null;
    const referrerPolicy = options.referrerPolicy;
    return (extent, resolution, pixelRatio)=>{
        extent = (0, $4a79210cc82cb3cb$export$2a9dcc8f63da1787)(extent, resolution, pixelRatio, ratio);
        if (pixelRatio != 1 && (!hidpi || options.serverType === undefined)) pixelRatio = 1;
        const src = $463fc5224b289b57$export$ef1c8480e0b65584(extent, resolution, pixelRatio, projection, options.url, $463fc5224b289b57$export$a4c60e148c7af082(options.params, 'GetMap'), options.serverType);
        const image = new Image();
        image.crossOrigin = crossOrigin;
        if (referrerPolicy !== undefined) image.referrerPolicy = referrerPolicy;
        return load(image, src).then((image)=>({
                image: image,
                extent: extent,
                pixelRatio: pixelRatio
            }));
    };
}
function $463fc5224b289b57$export$6f3ec358b8c06c5b(options, coordinate, resolution) {
    if (options.url === undefined) return undefined;
    const projectionObj = (0, $a86eee1c28205a05$export$3988ae62b71be9a3)(options.projection || 'EPSG:3857');
    const extent = (0, $dea65c2f666fa450$export$13ba650faf8308)(coordinate, resolution, 0, $463fc5224b289b57$var$GETFEATUREINFO_IMAGE_SIZE);
    const baseParams = {
        'QUERY_LAYERS': options.params['LAYERS'],
        'INFO_FORMAT': 'application/json'
    };
    Object.assign(baseParams, $463fc5224b289b57$export$a4c60e148c7af082(options.params, 'GetFeatureInfo'), options.params);
    const x = (0, $6a95bd76d7103f37$export$a3fe094919f356fd)((coordinate[0] - extent[0]) / resolution, (0, $dc0fdb47039c6a50$export$48fbc15abf52505f));
    const y = (0, $6a95bd76d7103f37$export$a3fe094919f356fd)((extent[3] - coordinate[1]) / resolution, (0, $dc0fdb47039c6a50$export$48fbc15abf52505f));
    const v13 = (0, $cef15f396d6ffa11$export$66e1c0999abad646)(baseParams['VERSION'], '1.3') >= 0;
    baseParams[v13 ? 'I' : 'X'] = x;
    baseParams[v13 ? 'J' : 'Y'] = y;
    return $463fc5224b289b57$export$14619c0eed01a470(options.url, extent, $463fc5224b289b57$var$GETFEATUREINFO_IMAGE_SIZE, projectionObj, baseParams);
}
function $463fc5224b289b57$export$9ee42325bd9ccc93(options, resolution) {
    if (options.url === undefined) return undefined;
    const baseParams = {
        'SERVICE': 'WMS',
        'VERSION': $463fc5224b289b57$export$363ebe89e6e7aeef,
        'REQUEST': 'GetLegendGraphic',
        'FORMAT': 'image/png'
    };
    if (resolution !== undefined) {
        const mpu = (0, $a86eee1c28205a05$export$3988ae62b71be9a3)(options.projection || 'EPSG:3857').getMetersPerUnit() || 1;
        const pixelSize = 0.00028;
        baseParams['SCALE'] = resolution * mpu / pixelSize;
    }
    Object.assign(baseParams, options.params);
    if (options.params !== undefined && baseParams['LAYER'] === undefined) {
        const layers = baseParams['LAYERS'];
        const isSingleLayer = !Array.isArray(layers) || layers.length !== 1;
        if (!isSingleLayer) return undefined;
        baseParams['LAYER'] = layers;
    }
    return (0, $ce940d0af289b90b$export$c202e3cb8db99a95)(options.url, baseParams);
}


/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {number} [cacheSize] Deprecated.  Use the cacheSize option on the layer instead.
 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images.  Note that
 * you must provide a `crossOrigin` value if you want to access pixel data with the Canvas renderer.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {boolean} [interpolate=true] Use interpolated values when resampling.  By default,
 * linear interpolation is used when resampling.  Set to false to use the nearest neighbor instead.
 * @property {Object<string,*>} params WMS request parameters.
 * At least a `LAYERS` param is required. `STYLES` is
 * `''` by default. `VERSION` is `1.3.0` by default. `WIDTH`, `HEIGHT`, `BBOX`
 * and `CRS` (`SRS` for WMS version < 1.3.0) will be set dynamically.
 * @property {number} [gutter=0]
 * The size in pixels of the gutter around image tiles to ignore. By setting
 * this property to a non-zero value, images will be requested that are wider
 * and taller than the tile size by a value of `2 x gutter`.
 * Using a non-zero value allows artifacts of rendering at tile edges to be
 * ignored. If you control the WMS service it is recommended to address
 * "artifacts at tile edges" issues by properly configuring the WMS service. For
 * example, MapServer has a `tile_map_edge_buffer` configuration parameter for
 * this. See https://mapserver.org/output/tile_mode.html.
 * @property {boolean} [hidpi=true] Use the `ol/Map#pixelRatio` value when requesting
 * the image from the remote server.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection. Default is the view projection.
 * @property {number} [reprojectionErrorThreshold=0.5] Maximum allowed reprojection error (in pixels).
 * Higher values can increase reprojection performance, but decrease precision.
 * @property {typeof import("../ImageTile.js").default} [tileClass] Class used to instantiate image tiles.
 * Default is {@link module:ol/ImageTile~ImageTile}.
 * @property {import("../tilegrid/TileGrid.js").default} [tileGrid] Tile grid. Base this on the resolutions,
 * tilesize and extent supported by the server.
 * If this is not defined, a default grid will be used: if there is a projection
 * extent, the grid will be based on that; if not, a grid based on a global
 * extent with origin at 0,0 will be used.
 * @property {import("./wms.js").ServerType} [serverType] The type of
 * the remote WMS server: `mapserver`, `geoserver`, `carmentaserver`, or `qgis`.
 * Only needed if `hidpi` is `true`.
 * @property {import("../Tile.js").LoadFunction} [tileLoadFunction] Optional function to load a tile given a URL. The default is
 * ```js
 * function(imageTile, src) {
 *   imageTile.getImage().src = src;
 * };
 * ```
 * @property {string} [url] WMS service URL.
 * @property {Array<string>} [urls] WMS service urls.
 * Use this instead of `url` when the WMS supports multiple urls for GetMap requests.
 * @property {boolean} [wrapX=true] Whether to wrap the world horizontally.
 * When set to `false`, only one world
 * will be rendered. When `true`, tiles will be requested for one world only,
 * but they will be wrapped horizontally to render multiple worlds.
 * @property {number} [transition] Duration of the opacity transition for rendering.
 * To disable the opacity transition, pass `transition: 0`.
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=0]
 * Choose whether to use tiles with a higher or lower zoom level when between integer
 * zoom levels. See {@link module:ol/tilegrid/TileGrid~TileGrid#getZForResolution}.
 */ /**
 * @classdesc
 * Layer source for tile data from WMS servers.
 * @api
 */ class $4c9244de85181135$var$TileWMS extends (0, $451985fb6fe2e606$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Tile WMS options.
   */ constructor(options){
        options = options ? options : /** @type {Options} */ {};
        const params = Object.assign({}, options.params);
        super({
            attributions: options.attributions,
            attributionsCollapsible: options.attributionsCollapsible,
            cacheSize: options.cacheSize,
            crossOrigin: options.crossOrigin,
            interpolate: options.interpolate,
            projection: options.projection,
            reprojectionErrorThreshold: options.reprojectionErrorThreshold,
            tileClass: options.tileClass,
            tileGrid: options.tileGrid,
            tileLoadFunction: options.tileLoadFunction,
            url: options.url,
            urls: options.urls,
            wrapX: options.wrapX !== undefined ? options.wrapX : true,
            transition: options.transition,
            zDirection: options.zDirection
        });
        /**
     * @private
     * @type {number}
     */ this.gutter_ = options.gutter !== undefined ? options.gutter : 0;
        /**
     * @private
     * @type {!Object}
     */ this.params_ = params;
        /**
     * @private
     * @type {boolean}
     */ this.v13_ = true;
        /**
     * @private
     * @type {import("./wms.js").ServerType}
     */ this.serverType_ = options.serverType;
        /**
     * @private
     * @type {boolean}
     */ this.hidpi_ = options.hidpi !== undefined ? options.hidpi : true;
        /**
     * @private
     * @type {import("../extent.js").Extent}
     */ this.tmpExtent_ = (0, $dea65c2f666fa450$export$fe201bb3bbe031e9)();
        this.updateV13_();
        this.setKey(this.getKeyForParams_());
    }
    /**
   * Return the GetFeatureInfo URL for the passed coordinate, resolution, and
   * projection. Return `undefined` if the GetFeatureInfo URL cannot be
   * constructed.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {number} resolution Resolution.
   * @param {import("../proj.js").ProjectionLike} projection Projection.
   * @param {!Object} params GetFeatureInfo params. `INFO_FORMAT` at least should
   *     be provided. If `QUERY_LAYERS` is not provided then the layers specified
   *     in the `LAYERS` parameter will be used. `VERSION` should not be
   *     specified here.
   * @return {string|undefined} GetFeatureInfo URL.
   * @api
   */ getFeatureInfoUrl(coordinate, resolution, projection, params) {
        const projectionObj = (0, $a86eee1c28205a05$export$3988ae62b71be9a3)(projection);
        const sourceProjectionObj = this.getProjection() || projectionObj;
        let tileGrid = this.getTileGrid();
        if (!tileGrid) tileGrid = this.getTileGridForProjection(sourceProjectionObj);
        const sourceProjCoord = (0, $a86eee1c28205a05$export$51186ad6e864892a)(coordinate, projectionObj, sourceProjectionObj);
        const sourceResolution = (0, $a414945bcb55714f$export$5fbb958059b7e71f)(sourceProjectionObj, projectionObj, coordinate, resolution);
        const z = tileGrid.getZForResolution(sourceResolution, this.zDirection);
        const tileResolution = tileGrid.getResolution(z);
        const tileCoord = tileGrid.getTileCoordForCoordAndZ(sourceProjCoord, z);
        if (tileGrid.getResolutions().length <= tileCoord[0]) return undefined;
        let tileExtent = tileGrid.getTileCoordExtent(tileCoord, this.tmpExtent_);
        const gutter = this.gutter_;
        if (gutter !== 0) tileExtent = (0, $dea65c2f666fa450$export$ab1029bcae9ddb4a)(tileExtent, tileResolution * gutter, tileExtent);
        const baseParams = {
            'QUERY_LAYERS': this.params_['LAYERS']
        };
        Object.assign(baseParams, (0, $463fc5224b289b57$export$a4c60e148c7af082)(this.params_, 'GetFeatureInfo'), params);
        const x = Math.floor((sourceProjCoord[0] - tileExtent[0]) / tileResolution);
        const y = Math.floor((tileExtent[3] - sourceProjCoord[1]) / tileResolution);
        baseParams[this.v13_ ? 'I' : 'X'] = x;
        baseParams[this.v13_ ? 'J' : 'Y'] = y;
        return this.getRequestUrl_(tileCoord, tileExtent, 1, sourceProjectionObj || projectionObj, baseParams);
    }
    /**
   * Return the GetLegendGraphic URL, optionally optimized for the passed
   * resolution and possibly including any passed specific parameters. Returns
   * `undefined` if the GetLegendGraphic URL cannot be constructed.
   *
   * @param {number} [resolution] Resolution. If set to undefined, `SCALE`
   *     will not be calculated and included in URL.
   * @param {Object} [params] GetLegendGraphic params. If `LAYER` is set, the
   *     request is generated for this wms layer, else it will try to use the
   *     configured wms layer. Default `FORMAT` is `image/png`.
   *     `VERSION` should not be specified here.
   * @return {string|undefined} GetLegendGraphic URL.
   * @api
   */ getLegendUrl(resolution, params) {
        if (this.urls[0] === undefined) return undefined;
        const baseParams = {
            'SERVICE': 'WMS',
            'VERSION': (0, $463fc5224b289b57$export$363ebe89e6e7aeef),
            'REQUEST': 'GetLegendGraphic',
            'FORMAT': 'image/png'
        };
        if (params === undefined || params['LAYER'] === undefined) {
            const layers = this.params_.LAYERS;
            const isSingleLayer = !Array.isArray(layers) || layers.length === 1;
            if (!isSingleLayer) return undefined;
            baseParams['LAYER'] = layers;
        }
        if (resolution !== undefined) {
            const mpu = this.getProjection() ? this.getProjection().getMetersPerUnit() : 1;
            const pixelSize = 0.00028;
            baseParams['SCALE'] = resolution * mpu / pixelSize;
        }
        Object.assign(baseParams, params);
        return (0, $ce940d0af289b90b$export$c202e3cb8db99a95)(/** @type {string} */ this.urls[0], baseParams);
    }
    /**
   * @return {number} Gutter.
   * @override
   */ getGutter() {
        return this.gutter_;
    }
    /**
   * Get the user-provided params, i.e. those passed to the constructor through
   * the "params" option, and possibly updated using the updateParams method.
   * @return {Object} Params.
   * @api
   */ getParams() {
        return this.params_;
    }
    /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {import("../extent.js").Extent} tileExtent Tile extent.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @param {Object} params Params.
   * @return {string|undefined} Request URL.
   * @private
   */ getRequestUrl_(tileCoord, tileExtent, pixelRatio, projection, params) {
        const urls = this.urls;
        if (!urls) return undefined;
        let url;
        if (urls.length == 1) url = urls[0];
        else {
            const index = (0, $6a95bd76d7103f37$export$ba467bec01d66def)((0, $8b203a265587842e$export$d6af199866bfb566)(tileCoord), urls.length);
            url = urls[index];
        }
        return (0, $463fc5224b289b57$export$ef1c8480e0b65584)(tileExtent, (this.tileGrid || this.getTileGridForProjection(projection)).getResolution(tileCoord[0]), pixelRatio, projection, url, params, this.serverType_);
    }
    /**
   * Get the tile pixel ratio for this source.
   * @param {number} pixelRatio Pixel ratio.
   * @return {number} Tile pixel ratio.
   * @override
   */ getTilePixelRatio(pixelRatio) {
        return !this.hidpi_ || this.serverType_ === undefined ? 1 : pixelRatio;
    }
    /**
   * @private
   * @return {string} The key for the current params.
   */ getKeyForParams_() {
        let i = 0;
        const res = [];
        for(const key in this.params_)res[i++] = key + '-' + this.params_[key];
        return res.join('/');
    }
    /**
   * @param {Object} params New URL paremeters.
   * @private
   */ setParams_(params) {
        this.params_ = params;
        this.updateV13_();
        this.setKey(this.getKeyForParams_());
    }
    /**
   * Set the URL parameters passed to the WMS source.
   * @param {Object} params New URL paremeters.
   * @api
   */ setParams(params) {
        this.setParams_(Object.assign({}, params));
    }
    /**
   * Update the URL parameters. This method can be used to update a subset of the WMS
   * parameters. Call `setParams` to set all of the parameters.
   * @param {Object} params Updated URL parameters.
   * @api
   */ updateParams(params) {
        this.setParams_(Object.assign(this.params_, params));
    }
    /**
   * @private
   */ updateV13_() {
        const version = this.params_['VERSION'] || (0, $463fc5224b289b57$export$363ebe89e6e7aeef);
        this.v13_ = (0, $cef15f396d6ffa11$export$66e1c0999abad646)(version, '1.3') >= 0;
    }
    /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord The tile coordinate
   * @param {number} pixelRatio The pixel ratio
   * @param {import("../proj/Projection.js").default} projection The projection
   * @return {string|undefined} The tile URL
   * @override
   */ tileUrlFunction(tileCoord, pixelRatio, projection) {
        let tileGrid = this.getTileGrid();
        if (!tileGrid) tileGrid = this.getTileGridForProjection(projection);
        if (tileGrid.getResolutions().length <= tileCoord[0]) return undefined;
        if (pixelRatio != 1 && (!this.hidpi_ || this.serverType_ === undefined)) pixelRatio = 1;
        const tileResolution = tileGrid.getResolution(tileCoord[0]);
        let tileExtent = tileGrid.getTileCoordExtent(tileCoord, this.tmpExtent_);
        const gutter = this.gutter_;
        if (gutter !== 0) tileExtent = (0, $dea65c2f666fa450$export$ab1029bcae9ddb4a)(tileExtent, tileResolution * gutter, tileExtent);
        const baseParams = Object.assign({}, (0, $463fc5224b289b57$export$a4c60e148c7af082)(this.params_, 'GetMap'));
        return this.getRequestUrl_(tileCoord, tileExtent, pixelRatio, projection, baseParams);
    }
}
var $4c9244de85181135$export$2e2bcd8739ae039 = $4c9244de85181135$var$TileWMS;

/**
 * @module ol/source/WMTS
 */ 

/**
 * @module ol/tilegrid/WMTS
 */ 

/**
 * @typedef {Object} Options
 * @property {import("../extent.js").Extent} [extent] Extent for the tile grid. No tiles
 * outside this extent will be requested by {@link module:ol/source/Tile~TileSource} sources.
 * When no `origin` or `origins` are configured, the `origin` will be set to the
 * top-left corner of the extent.
 * @property {import("../coordinate.js").Coordinate} [origin] The tile grid origin, i.e.
 * where the `x` and `y` axes meet (`[z, 0, 0]`). Tile coordinates increase left
 * to right and downwards. If not specified, `extent` or `origins` must be provided.
 * @property {Array<import("../coordinate.js").Coordinate>} [origins] Tile grid origins,
 * i.e. where the `x` and `y` axes meet (`[z, 0, 0]`), for each zoom level. If
 * given, the array length should match the length of the `resolutions` array, i.e.
 * each resolution can have a different origin. Tile coordinates increase left to
 * right and downwards. If not specified, `extent` or `origin` must be provided.
 * @property {!Array<number>} resolutions Resolutions. The array index of each
 * resolution needs to match the zoom level. This means that even if a `minZoom`
 * is configured, the resolutions array will have a length of `maxZoom + 1`
 * @property {!Array<string>} matrixIds matrix IDs. The length of this array needs
 * to match the length of the `resolutions` array.
 * @property {Array<import("../size.js").Size>} [sizes] Number of tile rows and columns
 * of the grid for each zoom level. The values here are the `TileMatrixWidth` and
 * `TileMatrixHeight` advertised in the GetCapabilities response of the WMTS, and
 * define each zoom level's extent together with the `origin` or `origins`.
 * A grid `extent` can be configured in addition, and will further limit the extent for
 * which tile requests are made by sources. If the bottom-left corner of
 * an extent is used as `origin` or `origins`, then the `y` value must be
 * negative because OpenLayers tile coordinates use the top left as the origin.
 * @property {number|import("../size.js").Size} [tileSize] Tile size.
 * @property {Array<number|import("../size.js").Size>} [tileSizes] Tile sizes. The length of
 * this array needs to match the length of the `resolutions` array.
 */ /**
 * @classdesc
 * Set the grid pattern for sources accessing WMTS tiled-image servers.
 * @api
 */ class $298480a99c8b5ec1$var$WMTSTileGrid extends (0, $bc3c803236fb01b8$export$2e2bcd8739ae039) {
    /**
   * @param {Options} options WMTS options.
   */ constructor(options){
        super({
            extent: options.extent,
            origin: options.origin,
            origins: options.origins,
            resolutions: options.resolutions,
            tileSize: options.tileSize,
            tileSizes: options.tileSizes,
            sizes: options.sizes
        });
        /**
     * @private
     * @type {!Array<string>}
     */ this.matrixIds_ = options.matrixIds;
    }
    /**
   * @param {number} z Z.
   * @return {string} MatrixId..
   */ getMatrixId(z) {
        return this.matrixIds_[z];
    }
    /**
   * Get the list of matrix identifiers.
   * @return {Array<string>} MatrixIds.
   * @api
   */ getMatrixIds() {
        return this.matrixIds_;
    }
}
var $298480a99c8b5ec1$export$2e2bcd8739ae039 = $298480a99c8b5ec1$var$WMTSTileGrid;
function $298480a99c8b5ec1$export$435b228518a973ff(matrixSet, extent, matrixLimits) {
    /** @type {!Array<number>} */ const resolutions = [];
    /** @type {!Array<string>} */ const matrixIds = [];
    /** @type {!Array<import("../coordinate.js").Coordinate>} */ const origins = [];
    /** @type {!Array<number|import("../size.js").Size>} */ const tileSizes = [];
    /** @type {!Array<import("../size.js").Size>} */ const sizes = [];
    matrixLimits = matrixLimits !== undefined ? matrixLimits : [];
    const supportedCRSPropName = 'SupportedCRS';
    const matrixIdsPropName = 'TileMatrix';
    const identifierPropName = 'Identifier';
    const scaleDenominatorPropName = 'ScaleDenominator';
    const topLeftCornerPropName = 'TopLeftCorner';
    const tileWidthPropName = 'TileWidth';
    const tileHeightPropName = 'TileHeight';
    const code = matrixSet[supportedCRSPropName];
    const projection = (0, $a86eee1c28205a05$export$3988ae62b71be9a3)(code);
    const metersPerUnit = projection.getMetersPerUnit();
    // swap origin x and y coordinates if axis orientation is lat/long
    const switchOriginXY = projection.getAxisOrientation().startsWith('ne');
    matrixSet[matrixIdsPropName].sort(function(a, b) {
        return b[scaleDenominatorPropName] - a[scaleDenominatorPropName];
    });
    matrixSet[matrixIdsPropName].forEach(function(elt) {
        let matrixAvailable;
        // use of matrixLimits to filter TileMatrices from GetCapabilities
        // TileMatrixSet from unavailable matrix levels.
        if (matrixLimits.length > 0) matrixAvailable = matrixLimits.find(function(elt_ml) {
            if (elt[identifierPropName] == elt_ml[matrixIdsPropName]) return true;
            // Fallback for tileMatrix identifiers that don't get prefixed
            // by their tileMatrixSet identifiers.
            if (!elt[identifierPropName].includes(':')) return matrixSet[identifierPropName] + ':' + elt[identifierPropName] === elt_ml[matrixIdsPropName];
            return false;
        });
        else matrixAvailable = true;
        if (matrixAvailable) {
            matrixIds.push(elt[identifierPropName]);
            const resolution = elt[scaleDenominatorPropName] * 0.28e-3 / metersPerUnit;
            const tileWidth = elt[tileWidthPropName];
            const tileHeight = elt[tileHeightPropName];
            if (switchOriginXY) origins.push([
                elt[topLeftCornerPropName][1],
                elt[topLeftCornerPropName][0]
            ]);
            else origins.push(elt[topLeftCornerPropName]);
            resolutions.push(resolution);
            tileSizes.push(tileWidth == tileHeight ? tileWidth : [
                tileWidth,
                tileHeight
            ]);
            sizes.push([
                elt['MatrixWidth'],
                elt['MatrixHeight']
            ]);
        }
    });
    return new $298480a99c8b5ec1$var$WMTSTileGrid({
        extent: extent,
        origins: origins,
        resolutions: resolutions,
        matrixIds: matrixIds,
        tileSizes: tileSizes,
        sizes: sizes
    });
}





/**
 * Request encoding. One of 'KVP', 'REST'.
 * @typedef {'KVP' | 'REST'} RequestEncoding
 */ /**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {number} [cacheSize] Deprecated.  Use the cacheSize option on the layer instead.
 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images.  Note that
 * you must provide a `crossOrigin` value if you want to access pixel data with the Canvas renderer.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {ReferrerPolicy} [referrerPolicy] The `referrerPolicy` property for loaded images.
 * @property {boolean} [interpolate=true] Use interpolated values when resampling.  By default,
 * linear interpolation is used when resampling.  Set to false to use the nearest neighbor instead.
 * @property {import("../tilegrid/WMTS.js").default} tileGrid Tile grid.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection. Default is the view projection.
 * @property {number} [reprojectionErrorThreshold=0.5] Maximum allowed reprojection error (in pixels).
 * Higher values can increase reprojection performance, but decrease precision.
 * @property {RequestEncoding} [requestEncoding='KVP'] Request encoding.
 * @property {string} layer Layer name as advertised in the WMTS capabilities.
 * @property {string} style Style name as advertised in the WMTS capabilities.
 * @property {typeof import("../ImageTile.js").default} [tileClass]  Class used to instantiate image tiles. Default is {@link module:ol/ImageTile~ImageTile}.
 * @property {number} [tilePixelRatio=1] The pixel ratio used by the tile service.
 * For example, if the tile service advertizes 256px by 256px tiles but actually sends 512px
 * by 512px images (for retina/hidpi devices) then `tilePixelRatio`
 * should be set to `2`.
 * @property {string} [format='image/jpeg'] Image format. Only used when `requestEncoding` is `'KVP'`.
 * @property {string} [version='1.0.0'] WMTS version.
 * @property {string} matrixSet Matrix set.
 * @property {!Object} [dimensions] Additional "dimensions" for tile requests.
 * This is an object with properties named like the advertised WMTS dimensions.
 * @property {string} [url]  A URL for the service.
 * For the RESTful request encoding, this is a URL
 * template.  For KVP encoding, it is normal URL. A `{?-?}` template pattern,
 * for example `subdomain{a-f}.domain.com`, may be used instead of defining
 * each one separately in the `urls` option.
 * @property {import("../Tile.js").LoadFunction} [tileLoadFunction] Optional function to load a tile given a URL. The default is
 * ```js
 * function(imageTile, src) {
 *   imageTile.getImage().src = src;
 * };
 * ```
 * @property {Array<string>} [urls] An array of URLs.
 * Requests will be distributed among the URLs in this array.
 * @property {boolean} [wrapX=false] Whether to wrap the world horizontally.
 * @property {number} [transition] Duration of the opacity transition for rendering.
 * To disable the opacity transition, pass `transition: 0`.
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=0]
 * Choose whether to use tiles with a higher or lower zoom level when between integer
 * zoom levels. See {@link module:ol/tilegrid/TileGrid~TileGrid#getZForResolution}.
 */ /**
 * @classdesc
 * Layer source for tile data from WMTS servers.
 * @api
 */ class $7ba829994893f414$var$WMTS extends (0, $451985fb6fe2e606$export$2e2bcd8739ae039) {
    /**
   * @param {Options} options WMTS options.
   */ constructor(options){
        // TODO: add support for TileMatrixLimits
        const requestEncoding = options.requestEncoding !== undefined ? options.requestEncoding : 'KVP';
        // FIXME: should we create a default tileGrid?
        // we could issue a getCapabilities xhr to retrieve missing configuration
        const tileGrid = options.tileGrid;
        let urls = options.urls;
        if (urls === undefined && options.url !== undefined) urls = (0, $ce940d0af289b90b$export$2a1fa079bfd73dde)(options.url);
        super({
            attributions: options.attributions,
            attributionsCollapsible: options.attributionsCollapsible,
            cacheSize: options.cacheSize,
            crossOrigin: options.crossOrigin,
            referrerPolicy: options.referrerPolicy,
            interpolate: options.interpolate,
            projection: options.projection,
            reprojectionErrorThreshold: options.reprojectionErrorThreshold,
            tileClass: options.tileClass,
            tileGrid: tileGrid,
            tileLoadFunction: options.tileLoadFunction,
            tilePixelRatio: options.tilePixelRatio,
            urls: urls,
            wrapX: options.wrapX !== undefined ? options.wrapX : false,
            transition: options.transition,
            zDirection: options.zDirection
        });
        /**
     * @private
     * @type {string}
     */ this.version_ = options.version !== undefined ? options.version : '1.0.0';
        /**
     * @private
     * @type {string}
     */ this.format_ = options.format !== undefined ? options.format : 'image/jpeg';
        /**
     * @private
     * @type {!Object}
     */ this.dimensions_ = options.dimensions !== undefined ? options.dimensions : {};
        /**
     * @private
     * @type {string}
     */ this.layer_ = options.layer;
        /**
     * @private
     * @type {string}
     */ this.matrixSet_ = options.matrixSet;
        /**
     * @private
     * @type {string}
     */ this.style_ = options.style;
        // FIXME: should we guess this requestEncoding from options.url(s)
        //        structure? that would mean KVP only if a template is not provided.
        /**
     * @private
     * @type {RequestEncoding}
     */ this.requestEncoding_ = requestEncoding;
        this.setKey(this.getKeyForDimensions_());
        if (urls && urls.length > 0) this.tileUrlFunction = (0, $f67d91f4d04e08ca$export$4229b1d9af69b3be)(urls.map(this.createFromWMTSTemplate.bind(this)));
    }
    /**
   * Set the URLs to use for requests.
   * URLs may contain OGC conform URL Template Variables: {TileMatrix}, {TileRow}, {TileCol}.
   * @param {Array<string>} urls URLs.
   * @override
   */ setUrls(urls) {
        this.urls = urls;
        const key = urls.join('\n');
        this.setTileUrlFunction((0, $f67d91f4d04e08ca$export$4229b1d9af69b3be)(urls.map(this.createFromWMTSTemplate.bind(this))), key);
    }
    /**
   * Get the dimensions, i.e. those passed to the constructor through the
   * "dimensions" option, and possibly updated using the updateDimensions
   * method.
   * @return {!Object} Dimensions.
   * @api
   */ getDimensions() {
        return this.dimensions_;
    }
    /**
   * Return the image format of the WMTS source.
   * @return {string} Format.
   * @api
   */ getFormat() {
        return this.format_;
    }
    /**
   * Return the layer of the WMTS source.
   * @return {string} Layer.
   * @api
   */ getLayer() {
        return this.layer_;
    }
    /**
   * Return the matrix set of the WMTS source.
   * @return {string} MatrixSet.
   * @api
   */ getMatrixSet() {
        return this.matrixSet_;
    }
    /**
   * Return the request encoding, either "KVP" or "REST".
   * @return {RequestEncoding} Request encoding.
   * @api
   */ getRequestEncoding() {
        return this.requestEncoding_;
    }
    /**
   * Return the style of the WMTS source.
   * @return {string} Style.
   * @api
   */ getStyle() {
        return this.style_;
    }
    /**
   * Return the version of the WMTS source.
   * @return {string} Version.
   * @api
   */ getVersion() {
        return this.version_;
    }
    /**
   * @private
   * @return {string} The key for the current dimensions.
   */ getKeyForDimensions_() {
        const res = this.urls ? this.urls.slice(0) : [];
        for(const key in this.dimensions_)res.push(key + '-' + this.dimensions_[key]);
        return res.join('/');
    }
    /**
   * Update the dimensions.
   * @param {Object} dimensions Dimensions.
   * @api
   */ updateDimensions(dimensions) {
        Object.assign(this.dimensions_, dimensions);
        this.setKey(this.getKeyForDimensions_());
    }
    /**
   * @param {string} template Template.
   * @return {import("../Tile.js").UrlFunction} Tile URL function.
   */ createFromWMTSTemplate(template) {
        const requestEncoding = this.requestEncoding_;
        // context property names are lower case to allow for a case insensitive
        // replacement as some services use different naming conventions
        const context = {
            'layer': this.layer_,
            'style': this.style_,
            'tilematrixset': this.matrixSet_
        };
        if (requestEncoding == 'KVP') Object.assign(context, {
            'Service': 'WMTS',
            'Request': 'GetTile',
            'Version': this.version_,
            'Format': this.format_
        });
        // TODO: we may want to create our own appendParams function so that params
        // order conforms to wmts spec guidance, and so that we can avoid to escape
        // special template params
        template = requestEncoding == 'KVP' ? (0, $ce940d0af289b90b$export$c202e3cb8db99a95)(template, context) : template.replace(/\{(\w+?)\}/g, function(m, p) {
            return p.toLowerCase() in context ? context[p.toLowerCase()] : m;
        });
        const tileGrid = /** @type {import("../tilegrid/WMTS.js").default} */ this.tileGrid;
        const dimensions = this.dimensions_;
        return(/**
       * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
       * @param {number} pixelRatio Pixel ratio.
       * @param {import("../proj/Projection.js").default} projection Projection.
       * @return {string|undefined} Tile URL.
       */ function(tileCoord, pixelRatio, projection) {
            if (!tileCoord) return undefined;
            const localContext = {
                'TileMatrix': tileGrid.getMatrixId(tileCoord[0]),
                'TileCol': tileCoord[1],
                'TileRow': tileCoord[2]
            };
            Object.assign(localContext, dimensions);
            let url = template;
            if (requestEncoding == 'KVP') url = (0, $ce940d0af289b90b$export$c202e3cb8db99a95)(url, localContext);
            else url = url.replace(/\{(\w+?)\}/g, function(m, p) {
                return encodeURIComponent(localContext[p]);
            });
            return url;
        });
    }
}
var $7ba829994893f414$export$2e2bcd8739ae039 = $7ba829994893f414$var$WMTS;
function $7ba829994893f414$export$6a2b1d2e791d254c(wmtsCap, config) {
    const layers = wmtsCap['Contents']['Layer'];
    const l = layers?.find(function(elt) {
        return elt['Identifier'] == config['layer'];
    });
    if (!l) return null;
    const tileMatrixSets = wmtsCap['Contents']['TileMatrixSet'];
    let idx;
    if (l['TileMatrixSetLink'].length > 1) {
        if ('projection' in config) idx = l['TileMatrixSetLink'].findIndex(function(elt) {
            const tileMatrixSet = tileMatrixSets.find(function(el) {
                return el['Identifier'] == elt['TileMatrixSet'];
            });
            const supportedCRS = tileMatrixSet['SupportedCRS'];
            const proj1 = (0, $a86eee1c28205a05$export$3988ae62b71be9a3)(supportedCRS);
            const proj2 = (0, $a86eee1c28205a05$export$3988ae62b71be9a3)(config['projection']);
            if (proj1 && proj2) return (0, $a86eee1c28205a05$export$fe091d73a555748b)(proj1, proj2);
            return supportedCRS == config['projection'];
        });
        else idx = l['TileMatrixSetLink'].findIndex(function(elt) {
            return elt['TileMatrixSet'] == config['matrixSet'];
        });
    } else idx = 0;
    if (idx < 0) idx = 0;
    const matrixSet = /** @type {string} */ l['TileMatrixSetLink'][idx]['TileMatrixSet'];
    const matrixLimits = /** @type {Array<Object>} */ l['TileMatrixSetLink'][idx]['TileMatrixSetLimits'];
    let format = /** @type {string} */ l['Format'][0];
    if ('format' in config) format = config['format'];
    idx = l['Style'].findIndex(function(elt) {
        if ('style' in config) return elt['Title'] == config['style'];
        return elt['isDefault'];
    });
    if (idx < 0) idx = 0;
    const style = /** @type {string} */ l['Style'][idx]['Identifier'];
    const dimensions = {};
    if ('Dimension' in l) l['Dimension'].forEach(function(elt, index, array) {
        const key = elt['Identifier'];
        let value = elt['Default'];
        if (value === undefined) value = elt['Value'][0];
        dimensions[key] = value;
    });
    const matrixSets = wmtsCap['Contents']['TileMatrixSet'];
    const matrixSetObj = matrixSets.find(function(elt) {
        return elt['Identifier'] == matrixSet;
    });
    let projection;
    const code = matrixSetObj['SupportedCRS'];
    if (code) projection = (0, $a86eee1c28205a05$export$3988ae62b71be9a3)(code);
    if ('projection' in config) {
        const projConfig = (0, $a86eee1c28205a05$export$3988ae62b71be9a3)(config['projection']);
        if (projConfig) {
            if (!projection || (0, $a86eee1c28205a05$export$fe091d73a555748b)(projConfig, projection)) projection = projConfig;
        }
    }
    let wrapX = false;
    const switchXY = projection.getAxisOrientation().startsWith('ne');
    let matrix = matrixSetObj.TileMatrix[0];
    // create default matrixLimit
    let selectedMatrixLimit = {
        MinTileCol: 0,
        MinTileRow: 0,
        // subtract one to end up at tile top left
        MaxTileCol: matrix.MatrixWidth - 1,
        MaxTileRow: matrix.MatrixHeight - 1
    };
    //in case of matrix limits, use matrix limits to calculate extent
    if (matrixLimits) {
        selectedMatrixLimit = matrixLimits[matrixLimits.length - 1];
        const m = matrixSetObj.TileMatrix.find((tileMatrixValue)=>tileMatrixValue.Identifier === selectedMatrixLimit.TileMatrix || matrixSetObj.Identifier + ':' + tileMatrixValue.Identifier === selectedMatrixLimit.TileMatrix);
        if (m) matrix = m;
    }
    const layerExtent = l['BoundingBox']?.find((bbox)=>(0, $a86eee1c28205a05$export$3988ae62b71be9a3)(bbox.crs) && (0, $a86eee1c28205a05$export$fe091d73a555748b)((0, $a86eee1c28205a05$export$3988ae62b71be9a3)(bbox.crs), projection));
    const resolution = matrix.ScaleDenominator * 0.00028 / projection.getMetersPerUnit(); // WMTS 1.0.0: standardized rendering pixel size
    const origin = switchXY ? [
        matrix.TopLeftCorner[1],
        matrix.TopLeftCorner[0]
    ] : matrix.TopLeftCorner;
    const tileSpanX = matrix.TileWidth * resolution;
    const tileSpanY = matrix.TileHeight * resolution;
    let matrixSetExtent = layerExtent?.extent ?? matrixSetObj['BoundingBox'];
    if (matrixSetExtent && switchXY) matrixSetExtent = [
        matrixSetExtent[1],
        matrixSetExtent[0],
        matrixSetExtent[3],
        matrixSetExtent[2]
    ];
    let extent = [
        origin[0] + tileSpanX * selectedMatrixLimit.MinTileCol,
        // add one to get proper bottom/right coordinate
        origin[1] - tileSpanY * (1 + selectedMatrixLimit.MaxTileRow),
        origin[0] + tileSpanX * (1 + selectedMatrixLimit.MaxTileCol),
        origin[1] - tileSpanY * selectedMatrixLimit.MinTileRow
    ];
    if (matrixSetExtent !== undefined && !(0, $dea65c2f666fa450$export$be866b1e0809b17e)(matrixSetExtent, extent)) {
        const wgs84BoundingBox = l['WGS84BoundingBox'];
        const wgs84ProjectionExtent = (0, $a86eee1c28205a05$export$3988ae62b71be9a3)('EPSG:4326').getExtent();
        extent = matrixSetExtent;
        if (wgs84BoundingBox) wrapX = wgs84BoundingBox[0] === wgs84ProjectionExtent[0] && wgs84BoundingBox[2] === wgs84ProjectionExtent[2];
        else {
            const wgs84MatrixSetExtent = (0, $a86eee1c28205a05$export$751c68e0e0efff79)(matrixSetExtent, matrixSetObj['SupportedCRS'], 'EPSG:4326');
            // Ignore slight deviation from the correct x limits
            wrapX = wgs84MatrixSetExtent[0] - 1e-10 <= wgs84ProjectionExtent[0] && wgs84MatrixSetExtent[2] + 1e-10 >= wgs84ProjectionExtent[2];
        }
    }
    const tileGrid = (0, $298480a99c8b5ec1$export$435b228518a973ff)(matrixSetObj, extent, matrixLimits);
    /** @type {!Array<string>} */ const urls = [];
    let requestEncoding = config['requestEncoding'];
    requestEncoding = requestEncoding !== undefined ? requestEncoding : '';
    if ('OperationsMetadata' in wmtsCap && 'GetTile' in wmtsCap['OperationsMetadata']) {
        const gets = wmtsCap['OperationsMetadata']['GetTile']['DCP']['HTTP']['Get'];
        for(let i = 0, ii = gets.length; i < ii; ++i){
            if (gets[i]['Constraint']) {
                const constraint = gets[i]['Constraint'].find(function(element) {
                    return element['name'] == 'GetEncoding';
                });
                const encodings = constraint['AllowedValues']['Value'];
                if (requestEncoding === '') // requestEncoding not provided, use the first encoding from the list
                requestEncoding = encodings[0];
                if (requestEncoding === 'KVP') {
                    if (encodings.includes('KVP')) urls.push(/** @type {string} */ gets[i]['href']);
                } else break;
            } else if (gets[i]['href']) {
                requestEncoding = 'KVP';
                urls.push(/** @type {string} */ gets[i]['href']);
            }
        }
    }
    if (urls.length === 0) {
        requestEncoding = 'REST';
        l['ResourceURL'].forEach(function(element) {
            if (element['resourceType'] === 'tile') {
                format = element['format'];
                urls.push(/** @type {string} */ element['template']);
            }
        });
    }
    return {
        urls: urls,
        layer: config['layer'],
        matrixSet: matrixSet,
        format: format,
        projection: projection,
        requestEncoding: requestEncoding,
        tileGrid: tileGrid,
        style: style,
        dimensions: dimensions,
        wrapX: wrapX,
        crossOrigin: config['crossOrigin']
    };
}


/**
 * @module ol/source/ImageWMS
 */ 




/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images.  Note that
 * you must provide a `crossOrigin` value if you want to access pixel data with the Canvas renderer.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {ReferrerPolicy} [referrerPolicy] The `referrerPolicy` property for loaded images.
 * @property {boolean} [hidpi=true] Use the `ol/Map#pixelRatio` value when requesting
 * the image from the remote server.
 * @property {import("./wms.js").ServerType} [serverType] The type of
 * the remote WMS server: `mapserver`, `geoserver`, `carmentaserver`, or `qgis`.
 * Only needed if `hidpi` is `true`.
 * @property {import("../Image.js").LoadFunction} [imageLoadFunction] Optional function to load an image given a URL.
 * @property {boolean} [interpolate=true] Use interpolated values when resampling.  By default,
 * linear interpolation is used when resampling.  Set to false to use the nearest neighbor instead.
 * @property {Object<string,*>} [params] WMS request parameters.
 * At least a `LAYERS` param is required. `STYLES` is
 * `''` by default. `VERSION` is `1.3.0` by default. `WIDTH`, `HEIGHT`, `BBOX`
 * and `CRS` (`SRS` for WMS version < 1.3.0) will be set dynamically.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection. Default is the view projection.
 * @property {number} [ratio=1.5] Ratio. `1` means image requests are the size of the map viewport, `2` means
 * twice the width and height of the map viewport, and so on. Must be `1` or higher.
 * @property {Array<number>} [resolutions] Resolutions.
 * If specified, requests will be made for these resolutions only.
 * @property {string} [url] WMS service URL.
 */ /**
 * @classdesc
 * Source for WMS servers providing single, untiled images.
 *
 * @fires module:ol/source/Image.ImageSourceEvent
 * @api
 */ class $afbdb872d70a16e7$var$ImageWMS extends (0, $4a79210cc82cb3cb$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] ImageWMS options.
   */ constructor(options){
        options = options ? options : {};
        super({
            attributions: options.attributions,
            interpolate: options.interpolate,
            projection: options.projection,
            resolutions: options.resolutions
        });
        /**
     * @private
     * @type {?string}
     */ this.crossOrigin_ = options.crossOrigin !== undefined ? options.crossOrigin : null;
        /**
     * @private
     * @type {ReferrerPolicy}
     */ this.referrerPolicy_ = options.referrerPolicy;
        /**
     * @private
     * @type {string|undefined}
     */ this.url_ = options.url;
        /**
     * @private
     * @type {import("../Image.js").LoadFunction}
     */ this.imageLoadFunction_ = options.imageLoadFunction !== undefined ? options.imageLoadFunction : (0, $4a79210cc82cb3cb$export$584f102f75ff44b3);
        /**
     * @private
     * @type {!Object}
     */ this.params_ = Object.assign({}, options.params);
        /**
     * @private
     * @type {import("./wms.js").ServerType}
     */ this.serverType_ = options.serverType;
        /**
     * @private
     * @type {boolean}
     */ this.hidpi_ = options.hidpi !== undefined ? options.hidpi : true;
        /**
     * @private
     * @type {number}
     */ this.renderedRevision_ = 0;
        /**
     * @private
     * @type {number}
     */ this.ratio_ = options.ratio !== undefined ? options.ratio : 1.5;
        /**
     * @private
     * @type {import("../proj/Projection.js").default}
     */ this.loaderProjection_ = null;
    }
    /**
   * Return the GetFeatureInfo URL for the passed coordinate, resolution, and
   * projection. Return `undefined` if the GetFeatureInfo URL cannot be
   * constructed.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {number} resolution Resolution.
   * @param {import("../proj.js").ProjectionLike} projection Projection.
   * @param {!Object} params GetFeatureInfo params. `INFO_FORMAT` at least should
   *     be provided. If `QUERY_LAYERS` is not provided then the layers specified
   *     in the `LAYERS` parameter will be used. `VERSION` should not be
   *     specified here.
   * @return {string|undefined} GetFeatureInfo URL.
   * @api
   */ getFeatureInfoUrl(coordinate, resolution, projection, params) {
        const projectionObj = (0, $a86eee1c28205a05$export$3988ae62b71be9a3)(projection);
        const sourceProjectionObj = this.getProjection();
        if (sourceProjectionObj && sourceProjectionObj !== projectionObj) {
            resolution = (0, $a414945bcb55714f$export$5fbb958059b7e71f)(sourceProjectionObj, projectionObj, coordinate, resolution);
            coordinate = (0, $a86eee1c28205a05$export$51186ad6e864892a)(coordinate, projectionObj, sourceProjectionObj);
        }
        const options = {
            url: this.url_,
            params: {
                ...this.params_,
                ...params
            },
            projection: sourceProjectionObj || projectionObj
        };
        return (0, $463fc5224b289b57$export$6f3ec358b8c06c5b)(options, coordinate, resolution);
    }
    /**
   * Return the GetLegendGraphic URL, optionally optimized for the passed
   * resolution and possibly including any passed specific parameters. Returns
   * `undefined` if the GetLegendGraphic URL cannot be constructed.
   *
   * @param {number} [resolution] Resolution. If set to undefined, `SCALE`
   *     will not be calculated and included in URL.
   * @param {Object} [params] GetLegendGraphic params. If `LAYER` is set, the
   *     request is generated for this wms layer, else it will try to use the
   *     configured wms layer. Default `FORMAT` is `image/png`.
   *     `VERSION` should not be specified here.
   * @return {string|undefined} GetLegendGraphic URL.
   * @api
   */ getLegendUrl(resolution, params) {
        return (0, $463fc5224b289b57$export$9ee42325bd9ccc93)({
            url: this.url_,
            params: {
                ...this.params_,
                ...params
            }
        }, resolution);
    }
    /**
   * Get the user-provided params, i.e. those passed to the constructor through
   * the "params" option, and possibly updated using the updateParams method.
   * @return {Object} Params.
   * @api
   */ getParams() {
        return this.params_;
    }
    /**
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {import("../Image.js").default} Single image.
   * @override
   */ getImageInternal(extent, resolution, pixelRatio, projection) {
        if (this.url_ === undefined) return null;
        if (!this.loader || this.loaderProjection_ !== projection) {
            // Lazily create loader to pick up the view projection and to allow `params` updates
            this.loaderProjection_ = projection;
            this.loader = (0, $463fc5224b289b57$export$8e84ca9bef6adc3a)({
                crossOrigin: this.crossOrigin_,
                referrerPolicy: this.referrerPolicy_,
                params: this.params_,
                projection: projection,
                serverType: this.serverType_,
                hidpi: this.hidpi_,
                url: this.url_,
                ratio: this.ratio_,
                load: (image, src)=>{
                    this.image.setImage(image);
                    this.imageLoadFunction_(this.image, src);
                    return (0, $617ef54ed150e783$export$2f872c0f2117be69)(image);
                }
            });
        }
        return super.getImageInternal(extent, resolution, pixelRatio, projection);
    }
    /**
   * Return the image load function of the source.
   * @return {import("../Image.js").LoadFunction} The image load function.
   * @api
   */ getImageLoadFunction() {
        return this.imageLoadFunction_;
    }
    /**
   * Return the URL used for this WMS source.
   * @return {string|undefined} URL.
   * @api
   */ getUrl() {
        return this.url_;
    }
    /**
   * Set the image load function of the source.
   * @param {import("../Image.js").LoadFunction} imageLoadFunction Image load function.
   * @api
   */ setImageLoadFunction(imageLoadFunction) {
        this.imageLoadFunction_ = imageLoadFunction;
        this.changed();
    }
    /**
   * Set the URL to use for requests.
   * @param {string|undefined} url URL.
   * @api
   */ setUrl(url) {
        if (url != this.url_) {
            this.url_ = url;
            this.loader = null;
            this.changed();
        }
    }
    /**
   * Set the user-provided params.
   * @param {Object} params Params.
   * @api
   */ setParams(params) {
        this.params_ = Object.assign({}, params);
        // Reset loader to pick up new params
        this.loader = null;
        this.changed();
    }
    /**
   * Update the user-provided params.
   * @param {Object} params Params.
   * @api
   */ updateParams(params) {
        Object.assign(this.params_, params);
        this.changed();
    }
    /**
   * @override
   */ changed() {
        this.image = null;
        super.changed();
    }
}
var $afbdb872d70a16e7$export$2e2bcd8739ae039 = $afbdb872d70a16e7$var$ImageWMS;


/**
 * @module ol/source/Vector
 */ 








/**
 * @module ol/featureloader
 */ /**
 *
 * @type {boolean}
 * @private
 */ let $fdd08e685d8d561c$var$withCredentials = false;
function $fdd08e685d8d561c$export$441d7b57adab24d0(url, format, extent, resolution, projection, success, failure) {
    const xhr = new XMLHttpRequest();
    xhr.open('GET', typeof url === 'function' ? url(extent, resolution, projection) : url, true);
    if (format.getType() == 'arraybuffer') xhr.responseType = 'arraybuffer';
    xhr.withCredentials = $fdd08e685d8d561c$var$withCredentials;
    /**
   * @param {Event} event Event.
   * @private
   */ xhr.onload = function(event) {
        // status will be 0 for file:// urls
        if (!xhr.status || xhr.status >= 200 && xhr.status < 300) {
            const type = format.getType();
            try {
                /** @type {Document|Node|Object|string|undefined} */ let source;
                if (type == 'text' || type == 'json') source = xhr.responseText;
                else if (type == 'xml') source = xhr.responseXML || xhr.responseText;
                else if (type == 'arraybuffer') source = /** @type {ArrayBuffer} */ xhr.response;
                if (source) success(/** @type {Array<FeatureType>} */ format.readFeatures(source, {
                    extent: extent,
                    featureProjection: projection
                }), format.readProjection(source));
                else failure();
            } catch  {
                failure();
            }
        } else failure();
    };
    /**
   * @private
   */ xhr.onerror = failure;
    xhr.send();
}
function $fdd08e685d8d561c$export$14cc81df70b6707e(url, format) {
    /**
   * @param {import("./extent.js").Extent} extent Extent.
   * @param {number} resolution Resolution.
   * @param {import("./proj/Projection.js").default} projection Projection.
   * @param {function(Array<FeatureType>): void} [success] Success
   *      Function called when loading succeeded.
   * @param {function(): void} [failure] Failure
   *      Function called when loading failed.
   * @this {import("./source/Vector.js").default<FeatureType>}
   */ return function(extent, resolution, projection, success, failure) {
        $fdd08e685d8d561c$export$441d7b57adab24d0(url, format, extent, resolution, projection, /**
       * @param {Array<FeatureType>} features The loaded features.
       * @param {import("./proj/Projection.js").default} dataProjection Data
       * projection.
       */ (features, dataProjection)=>{
            this.addFeatures(features);
            if (success !== undefined) success(features);
        }, ()=>{
            this.changed();
            if (failure !== undefined) failure();
        });
    };
}
function $fdd08e685d8d561c$export$36fa6977a6d0d8fe(xhrWithCredentials) {
    $fdd08e685d8d561c$var$withCredentials = xhrWithCredentials;
}






/**
 * @module ol/structs/RBush
 */ 



/**
 * @typedef {import("rbush").BBox & {value: T}} Entry
 * @template T
 */ /**
 * @classdesc
 * Wrapper around the RBush by Vladimir Agafonkin.
 * See https://github.com/mourner/rbush.
 *
 * @template {Object} T
 */ class $5d9bfc7868d1dd0e$var$RBush {
    /**
   * @param {number} [maxEntries] Max entries.
   */ constructor(maxEntries){
        /**
     * @private
     * @type {RBush_<Entry<T>>}
     */ this.rbush_ = new (0, $fb66a48cf2a65dd1$export$2e2bcd8739ae039)(maxEntries);
        /**
     * A mapping between the objects added to this rbush wrapper
     * and the objects that are actually added to the internal rbush.
     * @private
     * @type {Object<string, Entry<T>>}
     */ this.items_ = {};
    }
    /**
   * Insert a value into the RBush.
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {T} value Value.
   */ insert(extent, value) {
        /** @type {Entry<T>} */ const item = {
            minX: extent[0],
            minY: extent[1],
            maxX: extent[2],
            maxY: extent[3],
            value: value
        };
        this.rbush_.insert(item);
        this.items_[(0, $fd76d391cc228565$export$5e82334337e0f204)(value)] = item;
    }
    /**
   * Bulk-insert values into the RBush.
   * @param {Array<import("../extent.js").Extent>} extents Extents.
   * @param {Array<T>} values Values.
   */ load(extents, values) {
        const items = new Array(values.length);
        for(let i = 0, l = values.length; i < l; i++){
            const extent = extents[i];
            const value = values[i];
            /** @type {Entry<T>} */ const item = {
                minX: extent[0],
                minY: extent[1],
                maxX: extent[2],
                maxY: extent[3],
                value: value
            };
            items[i] = item;
            this.items_[(0, $fd76d391cc228565$export$5e82334337e0f204)(value)] = item;
        }
        this.rbush_.load(items);
    }
    /**
   * Remove a value from the RBush.
   * @param {T} value Value.
   * @return {boolean} Removed.
   */ remove(value) {
        const uid = (0, $fd76d391cc228565$export$5e82334337e0f204)(value);
        // get the object in which the value was wrapped when adding to the
        // internal rbush. then use that object to do the removal.
        const item = this.items_[uid];
        delete this.items_[uid];
        return this.rbush_.remove(item) !== null;
    }
    /**
   * Update the extent of a value in the RBush.
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {T} value Value.
   */ update(extent, value) {
        const item = this.items_[(0, $fd76d391cc228565$export$5e82334337e0f204)(value)];
        const bbox = [
            item.minX,
            item.minY,
            item.maxX,
            item.maxY
        ];
        if (!(0, $dea65c2f666fa450$export$e9bab7fafb253603)(bbox, extent)) {
            this.remove(value);
            this.insert(extent, value);
        }
    }
    /**
   * Return all values in the RBush.
   * @return {Array<T>} All.
   */ getAll() {
        const items = this.rbush_.all();
        return items.map(function(item) {
            return item.value;
        });
    }
    /**
   * Return all values in the given extent.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {Array<T>} All in extent.
   */ getInExtent(extent) {
        /** @type {import("rbush").BBox} */ const bbox = {
            minX: extent[0],
            minY: extent[1],
            maxX: extent[2],
            maxY: extent[3]
        };
        const items = this.rbush_.search(bbox);
        return items.map(function(item) {
            return item.value;
        });
    }
    /**
   * Calls a callback function with each value in the tree.
   * If the callback returns a truthy value, this value is returned without
   * checking the rest of the tree.
   * @param {function(T): R} callback Callback.
   * @return {R|undefined} Callback return value.
   * @template R
   */ forEach(callback) {
        return this.forEach_(this.getAll(), callback);
    }
    /**
   * Calls a callback function with each value in the provided extent.
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {function(T): R} callback Callback.
   * @return {R|undefined} Callback return value.
   * @template R
   */ forEachInExtent(extent, callback) {
        return this.forEach_(this.getInExtent(extent), callback);
    }
    /**
   * @param {Array<T>} values Values.
   * @param {function(T): R} callback Callback.
   * @return {R|undefined} Callback return value.
   * @template R
   * @private
   */ forEach_(values, callback) {
        let result;
        for(let i = 0, l = values.length; i < l; i++){
            result = callback(values[i]);
            if (result) return result;
        }
        return result;
    }
    /**
   * @return {boolean} Is empty.
   */ isEmpty() {
        return (0, $9f2b61a1df00e9b3$export$dd1bc94b04021eeb)(this.items_);
    }
    /**
   * Remove all values from the RBush.
   */ clear() {
        this.rbush_.clear();
        this.items_ = {};
    }
    /**
   * @param {import("../extent.js").Extent} [extent] Extent.
   * @return {import("../extent.js").Extent} Extent.
   */ getExtent(extent) {
        const data = this.rbush_.toJSON();
        return (0, $dea65c2f666fa450$export$958e3e1a02eac4b6)(data.minX, data.minY, data.maxX, data.maxY, extent);
    }
    /**
   * @param {RBush<T>} rbush R-Tree.
   */ concat(rbush) {
        this.rbush_.load(rbush.rbush_.all());
        for(const i in rbush.items_)this.items_[i] = rbush.items_[i];
    }
}
var $5d9bfc7868d1dd0e$export$2e2bcd8739ae039 = $5d9bfc7868d1dd0e$var$RBush;




/**
 * @module ol/source/VectorEventType
 */ /**
 * @enum {string}
 */ var $73c4cd82312d5027$export$2e2bcd8739ae039 /**
 * @typedef {'addfeature'|'changefeature'|'clear'|'removefeature'|'featuresloadstart'|'featuresloadend'|'featuresloaderror'} VectorSourceEventTypes
 */  = {
    /**
   * Triggered when a feature is added to the source.
   * @event module:ol/source/Vector.VectorSourceEvent#addfeature
   * @api
   */ ADDFEATURE: 'addfeature',
    /**
   * Triggered when a feature is updated.
   * @event module:ol/source/Vector.VectorSourceEvent#changefeature
   * @api
   */ CHANGEFEATURE: 'changefeature',
    /**
   * Triggered when the clear method is called on the source.
   * @event module:ol/source/Vector.VectorSourceEvent#clear
   * @api
   */ CLEAR: 'clear',
    /**
   * Triggered when a feature is removed from the source.
   * See {@link module:ol/source/Vector~VectorSource#clear source.clear()} for exceptions.
   * @event module:ol/source/Vector.VectorSourceEvent#removefeature
   * @api
   */ REMOVEFEATURE: 'removefeature',
    /**
   * Triggered when features starts loading.
   * @event module:ol/source/Vector.VectorSourceEvent#featuresloadstart
   * @api
   */ FEATURESLOADSTART: 'featuresloadstart',
    /**
   * Triggered when features finishes loading.
   * @event module:ol/source/Vector.VectorSourceEvent#featuresloadend
   * @api
   */ FEATURESLOADEND: 'featuresloadend',
    /**
   * Triggered if feature loading results in an error.
   * @event module:ol/source/Vector.VectorSourceEvent#featuresloaderror
   * @api
   */ FEATURESLOADERROR: 'featuresloaderror'
};


class $1020e4d07ddbfab1$export$d402fd02dc2b661c extends (0, $5c6b0a43c077a98f$export$2e2bcd8739ae039) {
    /**
   * @param {string} type Type.
   * @param {FeatureType} [feature] Feature.
   * @param {Array<FeatureType>} [features] Features.
   */ constructor(type, feature, features){
        super(type);
        /**
     * The added or removed feature for the `ADDFEATURE` and `REMOVEFEATURE` events, `undefined` otherwise.
     * @type {FeatureType|undefined}
     * @api
     */ this.feature = feature;
        /**
     * The loaded features for the `FEATURESLOADED` event, `undefined` otherwise.
     * @type {Array<FeatureType>|undefined}
     * @api
     */ this.features = features;
    }
}
/***
 * @template {import("../Feature.js").FeatureLike} [T=import("../Feature.js").default]
 * @typedef {T extends RenderFeature ? T|Array<T> : T} FeatureClassOrArrayOfRenderFeatures
 */ /***
 * @template Return
 * @template {import("../Feature.js").FeatureLike} [FeatureType=import("../Feature.js").default]
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types, import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<import("./VectorEventType").VectorSourceEventTypes, VectorSourceEvent<FeatureType>, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types|
 *     import("./VectorEventType").VectorSourceEventTypes, Return>} VectorSourceOnSignature
 */ /**
 * @template {import("../Feature.js").FeatureLike} [FeatureType=import("../Feature.js").default]
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {Array<FeatureType>|Collection<FeatureType>} [features]
 * Features. If provided as {@link module:ol/Collection~Collection}, the features in the source
 * and the collection will stay in sync.
 * @property {import("../format/Feature.js").default<FeatureType>} [format] The feature format used by the XHR
 * feature loader when `url` is set. Required if `url` is set, otherwise ignored.
 * @property {import("../featureloader.js").FeatureLoader<FeatureType>} [loader]
 * The loader function used to load features, from a remote source for example.
 * If this is not set and `url` is set, the source will create and use an XHR
 * feature loader. The `'featuresloadend'` and `'featuresloaderror'` events
 * will only fire if the `success` and `failure` callbacks are used.
 *
 * Example:
 *
 * ```js
 * import Vector from 'ol/source/Vector.js';
 * import GeoJSON from 'ol/format/GeoJSON.js';
 * import {bbox} from 'ol/loadingstrategy.js';
 *
 * const vectorSource = new Vector({
 *   format: new GeoJSON(),
 *   loader: function(extent, resolution, projection, success, failure) {
 *      const proj = projection.getCode();
 *      const url = 'https://ahocevar.com/geoserver/wfs?service=WFS&' +
 *          'version=1.1.0&request=GetFeature&typename=osm:water_areas&' +
 *          'outputFormat=application/json&srsname=' + proj + '&' +
 *          'bbox=' + extent.join(',') + ',' + proj;
 *      const xhr = new XMLHttpRequest();
 *      xhr.open('GET', url);
 *      const onError = function() {
 *        vectorSource.removeLoadedExtent(extent);
 *        failure();
 *      }
 *      xhr.onerror = onError;
 *      xhr.onload = function() {
 *        if (xhr.status == 200) {
 *          const features = vectorSource.getFormat().readFeatures(xhr.responseText);
 *          vectorSource.addFeatures(features);
 *          success(features);
 *        } else {
 *          onError();
 *        }
 *      }
 *      xhr.send();
 *    },
 *    strategy: bbox,
 *  });
 * ```
 * @property {boolean} [overlaps=true] This source may have overlapping geometries.
 * Setting this to `false` (e.g. for sources with polygons that represent administrative
 * boundaries or TopoJSON sources) allows the renderer to optimise fill and
 * stroke operations.
 * @property {LoadingStrategy} [strategy] The loading strategy to use.
 * By default an {@link module:ol/loadingstrategy.all}
 * strategy is used, a one-off strategy which loads all features at once.
 * @property {string|import("../featureloader.js").FeatureUrlFunction} [url]
 * Setting this option instructs the source to load features using an XHR loader
 * (see {@link module:ol/featureloader.xhr}). Use a `string` and an
 * {@link module:ol/loadingstrategy.all} for a one-off download of all features from
 * the given URL. Use a {@link module:ol/featureloader~FeatureUrlFunction} to generate the url with
 * other loading strategies.
 * Requires `format` to be set as well.
 * When default XHR feature loader is provided, the features will
 * be transformed from the data projection to the view projection
 * during parsing. If your remote data source does not advertise its projection
 * properly, this transformation will be incorrect. For some formats, the
 * default projection (usually EPSG:4326) can be overridden by setting the
 * dataProjection constructor option on the format.
 * Note that if a source contains non-feature data, such as a GeoJSON geometry
 * or a KML NetworkLink, these will be ignored. Use a custom loader to load these.
 * @property {boolean} [useSpatialIndex=true]
 * By default, an RTree is used as spatial index. When features are removed and
 * added frequently, and the total number of features is low, setting this to
 * `false` may improve performance.
 *
 * Note that
 * {@link module:ol/source/Vector~VectorSource#getFeaturesInExtent},
 * {@link module:ol/source/Vector~VectorSource#getClosestFeatureToCoordinate} and
 * {@link module:ol/source/Vector~VectorSource#getExtent} cannot be used when `useSpatialIndex` is
 * set to `false`, and {@link module:ol/source/Vector~VectorSource#forEachFeatureInExtent} will loop
 * through all features.
 *
 * When set to `false`, the features will be maintained in an
 * {@link module:ol/Collection~Collection}, which can be retrieved through
 * {@link module:ol/source/Vector~VectorSource#getFeaturesCollection}.
 * @property {boolean} [wrapX=true] Wrap the world horizontally. For vector editing across the
 * -180° and 180° meridians to work properly, this should be set to `false`. The
 * resulting geometry coordinates will then exceed the world bounds.
 */ /**
 * @classdesc
 * Provides a source of features for vector layers. Vector features provided
 * by this source are suitable for editing. See {@link module:ol/source/VectorTile~VectorTile} for
 * vector data that is optimized for rendering.
 *
 * @fires VectorSourceEvent
 * @api
 * @template {import("../Feature.js").FeatureLike} [FeatureType=import("../Feature.js").default]
 */ class $1020e4d07ddbfab1$var$VectorSource extends (0, $f43c44b2b88dd1d8$export$2e2bcd8739ae039) {
    /**
   * @param {Options<FeatureType>} [options] Vector source options.
   */ constructor(options){
        options = options || {};
        super({
            attributions: options.attributions,
            interpolate: true,
            projection: undefined,
            state: 'ready',
            wrapX: options.wrapX !== undefined ? options.wrapX : true
        });
        /***
     * @type {VectorSourceOnSignature<import("../events").EventsKey, FeatureType>}
     */ this.on;
        /***
     * @type {VectorSourceOnSignature<import("../events").EventsKey, FeatureType>}
     */ this.once;
        /***
     * @type {VectorSourceOnSignature<void>}
     */ this.un;
        /**
     * @private
     * @type {import("../featureloader.js").FeatureLoader<import("../Feature.js").FeatureLike>}
     */ this.loader_ = (0, $bc15bca7780ad95b$export$1cd1943b3a73bbe8);
        /**
     * @private
     * @type {import("../format/Feature.js").default<FeatureType>|null}
     */ this.format_ = options.format || null;
        /**
     * @private
     * @type {boolean}
     */ this.overlaps_ = options.overlaps === undefined ? true : options.overlaps;
        /**
     * @private
     * @type {string|import("../featureloader.js").FeatureUrlFunction|undefined}
     */ this.url_ = options.url;
        if (options.loader !== undefined) this.loader_ = options.loader;
        else if (this.url_ !== undefined) {
            (0, $71eb897bda873684$export$a7a9523472993e97)(this.format_, '`format` must be set when `url` is set');
            // create a XHR feature loader for "url" and "format"
            this.loader_ = (0, $fdd08e685d8d561c$export$14cc81df70b6707e)(this.url_, this.format_);
        }
        /**
     * @private
     * @type {LoadingStrategy}
     */ this.strategy_ = options.strategy !== undefined ? options.strategy : (0, $6a8cacaa690463df$export$84bf76cd7afc7469);
        const useSpatialIndex = options.useSpatialIndex !== undefined ? options.useSpatialIndex : true;
        /**
     * @private
     * @type {RBush<FeatureType>}
     */ this.featuresRtree_ = useSpatialIndex ? new (0, $5d9bfc7868d1dd0e$export$2e2bcd8739ae039)() : null;
        /**
     * @private
     * @type {RBush<{extent: import("../extent.js").Extent}>}
     */ this.loadedExtentsRtree_ = new (0, $5d9bfc7868d1dd0e$export$2e2bcd8739ae039)();
        /**
     * @type {number}
     * @private
     */ this.loadingExtentsCount_ = 0;
        /**
     * @private
     * @type {!Object<string, FeatureType>}
     */ this.nullGeometryFeatures_ = {};
        /**
     * A lookup of features by id (the return from feature.getId()).
     * @private
     * @type {!Object<string, import('../Feature.js').FeatureLike|Array<import('../Feature.js').FeatureLike>>}
     */ this.idIndex_ = {};
        /**
     * A lookup of features by uid (using getUid(feature)).
     * @private
     * @type {!Object<string, FeatureType>}
     */ this.uidIndex_ = {};
        /**
     * @private
     * @type {Object<string, Array<import("../events.js").EventsKey>>}
     */ this.featureChangeKeys_ = {};
        /**
     * @private
     * @type {Collection<FeatureType>|null}
     */ this.featuresCollection_ = null;
        /** @type {Collection<FeatureType>} */ let collection;
        /** @type {Array<FeatureType>} */ let features;
        if (Array.isArray(options.features)) features = options.features;
        else if (options.features) {
            collection = options.features;
            features = collection.getArray();
        }
        if (!useSpatialIndex && collection === undefined) collection = new (0, $e1f99232eb9bff27$export$2e2bcd8739ae039)(features);
        if (features !== undefined) this.addFeaturesInternal(features);
        if (collection !== undefined) this.bindFeaturesCollection_(collection);
    }
    /**
   * Add a single feature to the source.  If you want to add a batch of features
   * at once, call {@link module:ol/source/Vector~VectorSource#addFeatures #addFeatures()}
   * instead. A feature will not be added to the source if feature with
   * the same id is already there. The reason for this behavior is to avoid
   * feature duplication when using bbox or tile loading strategies.
   * Note: this also applies if a {@link module:ol/Collection~Collection} is used for features,
   * meaning that if a feature with a duplicate id is added in the collection, it will
   * be removed from it right away.
   * @param {FeatureType} feature Feature to add.
   * @api
   */ addFeature(feature) {
        this.addFeatureInternal(feature);
        this.changed();
    }
    /**
   * Add a feature without firing a `change` event.
   * @param {FeatureType} feature Feature.
   * @protected
   */ addFeatureInternal(feature) {
        const featureKey = (0, $fd76d391cc228565$export$5e82334337e0f204)(feature);
        if (!this.addToIndex_(featureKey, feature)) {
            if (this.featuresCollection_) this.featuresCollection_.remove(feature);
            return;
        }
        this.setupChangeEvents_(featureKey, feature);
        const geometry = feature.getGeometry();
        if (geometry) {
            const extent = geometry.getExtent();
            if (this.featuresRtree_) this.featuresRtree_.insert(extent, feature);
        } else this.nullGeometryFeatures_[featureKey] = feature;
        this.dispatchEvent(new $1020e4d07ddbfab1$export$d402fd02dc2b661c((0, $73c4cd82312d5027$export$2e2bcd8739ae039).ADDFEATURE, feature));
    }
    /**
   * @param {string} featureKey Unique identifier for the feature.
   * @param {FeatureType} feature The feature.
   * @private
   */ setupChangeEvents_(featureKey, feature) {
        if (feature instanceof (0, $e5b428c112c9c5d6$export$2e2bcd8739ae039)) return;
        this.featureChangeKeys_[featureKey] = [
            (0, $63963d09e0c49405$export$63174c828edd6ff8)(feature, (0, $b5fa963342da4935$export$2e2bcd8739ae039).CHANGE, this.handleFeatureChange_, this),
            (0, $63963d09e0c49405$export$63174c828edd6ff8)(feature, (0, $ff212aeaa481a85e$export$2e2bcd8739ae039).PROPERTYCHANGE, this.handleFeatureChange_, this)
        ];
    }
    /**
   * @param {string} featureKey Unique identifier for the feature.
   * @param {FeatureType} feature The feature.
   * @return {boolean} The feature is "valid", in the sense that it is also a
   *     candidate for insertion into the Rtree.
   * @private
   */ addToIndex_(featureKey, feature) {
        let valid = true;
        if (feature.getId() !== undefined) {
            const id = String(feature.getId());
            if (!(id in this.idIndex_)) this.idIndex_[id] = feature;
            else if (feature instanceof (0, $e5b428c112c9c5d6$export$2e2bcd8739ae039)) {
                const indexedFeature = this.idIndex_[id];
                if (!(indexedFeature instanceof (0, $e5b428c112c9c5d6$export$2e2bcd8739ae039))) valid = false;
                else if (!Array.isArray(indexedFeature)) this.idIndex_[id] = [
                    indexedFeature,
                    feature
                ];
                else indexedFeature.push(feature);
            } else valid = false;
        }
        if (valid) {
            (0, $71eb897bda873684$export$a7a9523472993e97)(!(featureKey in this.uidIndex_), 'The passed `feature` was already added to the source');
            this.uidIndex_[featureKey] = feature;
        }
        return valid;
    }
    /**
   * Add a batch of features to the source.
   * @param {Array<FeatureType>} features Features to add.
   * @api
   */ addFeatures(features) {
        this.addFeaturesInternal(features);
        this.changed();
    }
    /**
   * Add features without firing a `change` event.
   * @param {Array<FeatureType>} features Features.
   * @protected
   */ addFeaturesInternal(features) {
        const extents = [];
        /** @type {Array<FeatureType>} */ const newFeatures = [];
        /** @type {Array<FeatureType>} */ const geometryFeatures = [];
        for(let i = 0, length = features.length; i < length; i++){
            const feature = features[i];
            const featureKey = (0, $fd76d391cc228565$export$5e82334337e0f204)(feature);
            if (this.addToIndex_(featureKey, feature)) newFeatures.push(feature);
        }
        for(let i = 0, length = newFeatures.length; i < length; i++){
            const feature = newFeatures[i];
            const featureKey = (0, $fd76d391cc228565$export$5e82334337e0f204)(feature);
            this.setupChangeEvents_(featureKey, feature);
            const geometry = feature.getGeometry();
            if (geometry) {
                const extent = geometry.getExtent();
                extents.push(extent);
                geometryFeatures.push(feature);
            } else this.nullGeometryFeatures_[featureKey] = feature;
        }
        if (this.featuresRtree_) this.featuresRtree_.load(extents, geometryFeatures);
        if (this.hasListener((0, $73c4cd82312d5027$export$2e2bcd8739ae039).ADDFEATURE)) for(let i = 0, length = newFeatures.length; i < length; i++)this.dispatchEvent(new $1020e4d07ddbfab1$export$d402fd02dc2b661c((0, $73c4cd82312d5027$export$2e2bcd8739ae039).ADDFEATURE, newFeatures[i]));
    }
    /**
   * @param {!Collection<FeatureType>} collection Collection.
   * @private
   */ bindFeaturesCollection_(collection) {
        let modifyingCollection = false;
        this.addEventListener((0, $73c4cd82312d5027$export$2e2bcd8739ae039).ADDFEATURE, /**
       * @param {VectorSourceEvent<FeatureType>} evt The vector source event
       */ function(evt) {
            if (!modifyingCollection) {
                modifyingCollection = true;
                collection.push(evt.feature);
                modifyingCollection = false;
            }
        });
        this.addEventListener((0, $73c4cd82312d5027$export$2e2bcd8739ae039).REMOVEFEATURE, /**
       * @param {VectorSourceEvent<FeatureType>} evt The vector source event
       */ function(evt) {
            if (!modifyingCollection) {
                modifyingCollection = true;
                collection.remove(evt.feature);
                modifyingCollection = false;
            }
        });
        collection.addEventListener((0, $ea71ddfe3b669b23$export$2e2bcd8739ae039).ADD, /**
       * @param {import("../Collection.js").CollectionEvent<FeatureType>} evt The collection event
       */ (evt)=>{
            if (!modifyingCollection) {
                modifyingCollection = true;
                this.addFeature(evt.element);
                modifyingCollection = false;
            }
        });
        collection.addEventListener((0, $ea71ddfe3b669b23$export$2e2bcd8739ae039).REMOVE, /**
       * @param {import("../Collection.js").CollectionEvent<FeatureType>} evt The collection event
       */ (evt)=>{
            if (!modifyingCollection) {
                modifyingCollection = true;
                this.removeFeature(evt.element);
                modifyingCollection = false;
            }
        });
        this.featuresCollection_ = collection;
    }
    /**
   * Remove all features from the source.
   * @param {boolean} [fast] Skip dispatching of {@link module:ol/source/Vector.VectorSourceEvent#event:removefeature} events.
   * @api
   */ clear(fast) {
        if (fast) {
            for(const featureId in this.featureChangeKeys_){
                const keys = this.featureChangeKeys_[featureId];
                keys.forEach((0, $63963d09e0c49405$export$b0a21c8b3c1c921));
            }
            if (!this.featuresCollection_) {
                this.featureChangeKeys_ = {};
                this.idIndex_ = {};
                this.uidIndex_ = {};
            }
        } else if (this.featuresRtree_) {
            this.featuresRtree_.forEach((feature)=>{
                this.removeFeatureInternal(feature);
            });
            for(const id in this.nullGeometryFeatures_)this.removeFeatureInternal(this.nullGeometryFeatures_[id]);
        }
        if (this.featuresCollection_) this.featuresCollection_.clear();
        if (this.featuresRtree_) this.featuresRtree_.clear();
        this.nullGeometryFeatures_ = {};
        const clearEvent = new $1020e4d07ddbfab1$export$d402fd02dc2b661c((0, $73c4cd82312d5027$export$2e2bcd8739ae039).CLEAR);
        this.dispatchEvent(clearEvent);
        this.changed();
    }
    /**
   * Iterate through all features on the source, calling the provided callback
   * with each one.  If the callback returns any "truthy" value, iteration will
   * stop and the function will return the same value.
   * Note: this function only iterate through the feature that have a defined geometry.
   *
   * @param {function(FeatureType): T} callback Called with each feature
   *     on the source.  Return a truthy value to stop iteration.
   * @return {T|undefined} The return value from the last call to the callback.
   * @template T
   * @api
   */ forEachFeature(callback) {
        if (this.featuresRtree_) return this.featuresRtree_.forEach(callback);
        if (this.featuresCollection_) this.featuresCollection_.forEach(callback);
    }
    /**
   * Iterate through all features whose geometries contain the provided
   * coordinate, calling the callback with each feature.  If the callback returns
   * a "truthy" value, iteration will stop and the function will return the same
   * value.
   *
   * For {@link module:ol/render/Feature~RenderFeature} features, the callback will be
   * called for all features.
   *
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {function(FeatureType): T} callback Called with each feature
   *     whose goemetry contains the provided coordinate.
   * @return {T|undefined} The return value from the last call to the callback.
   * @template T
   */ forEachFeatureAtCoordinateDirect(coordinate, callback) {
        const extent = [
            coordinate[0],
            coordinate[1],
            coordinate[0],
            coordinate[1]
        ];
        return this.forEachFeatureInExtent(extent, function(feature) {
            const geometry = feature.getGeometry();
            if (geometry instanceof (0, $e5b428c112c9c5d6$export$2e2bcd8739ae039) || geometry.intersectsCoordinate(coordinate)) return callback(feature);
            return undefined;
        });
    }
    /**
   * Iterate through all features whose bounding box intersects the provided
   * extent (note that the feature's geometry may not intersect the extent),
   * calling the callback with each feature.  If the callback returns a "truthy"
   * value, iteration will stop and the function will return the same value.
   *
   * If you are interested in features whose geometry intersects an extent, call
   * the {@link module:ol/source/Vector~VectorSource#forEachFeatureIntersectingExtent #forEachFeatureIntersectingExtent()} method instead.
   *
   * When `useSpatialIndex` is set to false, this method will loop through all
   * features, equivalent to {@link module:ol/source/Vector~VectorSource#forEachFeature #forEachFeature()}.
   *
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {function(FeatureType): T} callback Called with each feature
   *     whose bounding box intersects the provided extent.
   * @return {T|undefined} The return value from the last call to the callback.
   * @template T
   * @api
   */ forEachFeatureInExtent(extent, callback) {
        if (this.featuresRtree_) return this.featuresRtree_.forEachInExtent(extent, callback);
        if (this.featuresCollection_) this.featuresCollection_.forEach(callback);
    }
    /**
   * Iterate through all features whose geometry intersects the provided extent,
   * calling the callback with each feature.  If the callback returns a "truthy"
   * value, iteration will stop and the function will return the same value.
   *
   * If you only want to test for bounding box intersection, call the
   * {@link module:ol/source/Vector~VectorSource#forEachFeatureInExtent #forEachFeatureInExtent()} method instead.
   *
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {function(FeatureType): T} callback Called with each feature
   *     whose geometry intersects the provided extent.
   * @return {T|undefined} The return value from the last call to the callback.
   * @template T
   * @api
   */ forEachFeatureIntersectingExtent(extent, callback) {
        return this.forEachFeatureInExtent(extent, /**
       * @param {FeatureType} feature Feature.
       * @return {T|undefined} The return value from the last call to the callback.
       */ function(feature) {
            const geometry = feature.getGeometry();
            if (geometry instanceof (0, $e5b428c112c9c5d6$export$2e2bcd8739ae039) || geometry.intersectsExtent(extent)) {
                const result = callback(feature);
                if (result) return result;
            }
        });
    }
    /**
   * Get the features collection associated with this source. Will be `null`
   * unless the source was configured with `useSpatialIndex` set to `false`, or
   * with a {@link module:ol/Collection~Collection} as `features`.
   * @return {Collection<FeatureType>|null} The collection of features.
   * @api
   */ getFeaturesCollection() {
        return this.featuresCollection_;
    }
    /**
   * Get a snapshot of the features currently on the source in random order. The returned array
   * is a copy, the features are references to the features in the source.
   * @return {Array<FeatureType>} Features.
   * @api
   */ getFeatures() {
        let features;
        if (this.featuresCollection_) features = this.featuresCollection_.getArray().slice(0);
        else if (this.featuresRtree_) {
            features = this.featuresRtree_.getAll();
            if (!(0, $9f2b61a1df00e9b3$export$dd1bc94b04021eeb)(this.nullGeometryFeatures_)) (0, $49313fcb0fc32abe$export$8b58be045bf06082)(features, Object.values(this.nullGeometryFeatures_));
        }
        return features;
    }
    /**
   * Get all features whose geometry intersects the provided coordinate.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @return {Array<FeatureType>} Features.
   * @api
   */ getFeaturesAtCoordinate(coordinate) {
        /** @type {Array<FeatureType>} */ const features = [];
        this.forEachFeatureAtCoordinateDirect(coordinate, function(feature) {
            features.push(feature);
        });
        return features;
    }
    /**
   * Get all features whose bounding box intersects the provided extent.  Note that this returns an array of
   * all features intersecting the given extent in random order (so it may include
   * features whose geometries do not intersect the extent).
   *
   * When `useSpatialIndex` is set to false, this method will return all
   * features.
   *
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {import("../proj/Projection.js").default} [projection] Include features
   * where `extent` exceeds the x-axis bounds of `projection` and wraps around the world.
   * @return {Array<FeatureType>} Features.
   * @api
   */ getFeaturesInExtent(extent, projection) {
        if (this.featuresRtree_) {
            const multiWorld = projection && projection.canWrapX() && this.getWrapX();
            if (!multiWorld) return this.featuresRtree_.getInExtent(extent);
            const extents = (0, $dea65c2f666fa450$export$9031237f01de0947)(extent, projection);
            return [].concat(...extents.map((anExtent)=>this.featuresRtree_.getInExtent(anExtent)));
        }
        if (this.featuresCollection_) return this.featuresCollection_.getArray().slice(0);
        return [];
    }
    /**
   * Get the closest feature to the provided coordinate.
   *
   * This method is not available when the source is configured with
   * `useSpatialIndex` set to `false` and the features in this source are of type
   * {@link module:ol/Feature~Feature}.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {function(FeatureType):boolean} [filter] Feature filter function.
   *     The filter function will receive one argument, the {@link module:ol/Feature~Feature feature}
   *     and it should return a boolean value. By default, no filtering is made.
   * @return {FeatureType|null} Closest feature (or `null` if none found).
   * @api
   */ getClosestFeatureToCoordinate(coordinate, filter) {
        // Find the closest feature using branch and bound.  We start searching an
        // infinite extent, and find the distance from the first feature found.  This
        // becomes the closest feature.  We then compute a smaller extent which any
        // closer feature must intersect.  We continue searching with this smaller
        // extent, trying to find a closer feature.  Every time we find a closer
        // feature, we update the extent being searched so that any even closer
        // feature must intersect it.  We continue until we run out of features.
        const x = coordinate[0];
        const y = coordinate[1];
        let closestFeature = null;
        const closestPoint = [
            NaN,
            NaN
        ];
        let minSquaredDistance = Infinity;
        const extent = [
            -Infinity,
            -Infinity,
            Infinity,
            Infinity
        ];
        filter = filter ? filter : (0, $bc15bca7780ad95b$export$22e23a2304399231);
        this.featuresRtree_.forEachInExtent(extent, /**
       * @param {FeatureType} feature Feature.
       */ function(feature) {
            if (filter(feature)) {
                const geometry = feature.getGeometry();
                const previousMinSquaredDistance = minSquaredDistance;
                minSquaredDistance = geometry instanceof (0, $e5b428c112c9c5d6$export$2e2bcd8739ae039) ? 0 : geometry.closestPointXY(x, y, closestPoint, minSquaredDistance);
                if (minSquaredDistance < previousMinSquaredDistance) {
                    closestFeature = feature;
                    // This is sneaky.  Reduce the extent that it is currently being
                    // searched while the R-Tree traversal using this same extent object
                    // is still in progress.  This is safe because the new extent is
                    // strictly contained by the old extent.
                    const minDistance = Math.sqrt(minSquaredDistance);
                    extent[0] = x - minDistance;
                    extent[1] = y - minDistance;
                    extent[2] = x + minDistance;
                    extent[3] = y + minDistance;
                }
            }
        });
        return closestFeature;
    }
    /**
   * Get the extent of the features currently in the source.
   *
   * This will return `null` when the source is configured with
   * `useSpatialIndex` set to `false`.
   * @param {import("../extent.js").Extent} [extent] Destination extent. If provided, no new extent
   *     will be created. Instead, that extent's coordinates will be overwritten.
   * @return {import("../extent.js").Extent | null} Extent.
   * @api
   */ getExtent(extent) {
        return this.featuresRtree_?.getExtent(extent) ?? null;
    }
    /**
   * Get a feature by its identifier (the value returned by feature.getId()). When `RenderFeature`s
   * are used, `getFeatureById()` can return an array of `RenderFeature`s. This allows for handling
   * of `GeometryCollection` geometries, where format readers create one `RenderFeature` per
   * `GeometryCollection` member.
   * Note that the index treats string and numeric identifiers as the same.  So
   * `source.getFeatureById(2)` will return a feature with id `'2'` or `2`.
   *
   * @param {string|number} id Feature identifier.
   * @return {FeatureClassOrArrayOfRenderFeatures<FeatureType>|null} The feature (or `null` if not found).
   * @api
   */ getFeatureById(id) {
        const feature = this.idIndex_[id.toString()];
        return feature !== undefined ? /** @type {FeatureClassOrArrayOfRenderFeatures<FeatureType>} */ feature : null;
    }
    /**
   * Get a feature by its internal unique identifier (using `getUid`).
   *
   * @param {string} uid Feature identifier.
   * @return {FeatureType|null} The feature (or `null` if not found).
   */ getFeatureByUid(uid) {
        const feature = this.uidIndex_[uid];
        return feature !== undefined ? feature : null;
    }
    /**
   * Get the format associated with this source.
   *
   * @return {import("../format/Feature.js").default<FeatureType>|null}} The feature format.
   * @api
   */ getFormat() {
        return this.format_;
    }
    /**
   * @return {boolean} The source can have overlapping geometries.
   */ getOverlaps() {
        return this.overlaps_;
    }
    /**
   * Get the url associated with this source.
   *
   * @return {string|import("../featureloader.js").FeatureUrlFunction|undefined} The url.
   * @api
   */ getUrl() {
        return this.url_;
    }
    /**
   * @param {Event} event Event.
   * @private
   */ handleFeatureChange_(event) {
        const feature = /** @type {FeatureType} */ event.target;
        const featureKey = (0, $fd76d391cc228565$export$5e82334337e0f204)(feature);
        const geometry = feature.getGeometry();
        if (!geometry) {
            if (!(featureKey in this.nullGeometryFeatures_)) {
                if (this.featuresRtree_) this.featuresRtree_.remove(feature);
                this.nullGeometryFeatures_[featureKey] = feature;
            }
        } else {
            const extent = geometry.getExtent();
            if (featureKey in this.nullGeometryFeatures_) {
                delete this.nullGeometryFeatures_[featureKey];
                if (this.featuresRtree_) this.featuresRtree_.insert(extent, feature);
            } else if (this.featuresRtree_) this.featuresRtree_.update(extent, feature);
        }
        const id = feature.getId();
        if (id !== undefined) {
            const sid = id.toString();
            if (this.idIndex_[sid] !== feature) {
                this.removeFromIdIndex_(feature);
                this.idIndex_[sid] = feature;
            }
        } else {
            this.removeFromIdIndex_(feature);
            this.uidIndex_[featureKey] = feature;
        }
        this.changed();
        this.dispatchEvent(new $1020e4d07ddbfab1$export$d402fd02dc2b661c((0, $73c4cd82312d5027$export$2e2bcd8739ae039).CHANGEFEATURE, feature));
    }
    /**
   * Returns true if the feature is contained within the source.
   * @param {FeatureType} feature Feature.
   * @return {boolean} Has feature.
   * @api
   */ hasFeature(feature) {
        const id = feature.getId();
        if (id !== undefined) return id in this.idIndex_;
        return (0, $fd76d391cc228565$export$5e82334337e0f204)(feature) in this.uidIndex_;
    }
    /**
   * @return {boolean} Is empty.
   */ isEmpty() {
        if (this.featuresRtree_) return this.featuresRtree_.isEmpty() && (0, $9f2b61a1df00e9b3$export$dd1bc94b04021eeb)(this.nullGeometryFeatures_);
        if (this.featuresCollection_) return this.featuresCollection_.getLength() === 0;
        return true;
    }
    /**
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {number} resolution Resolution.
   * @param {import("../proj/Projection.js").default} projection Projection.
   */ loadFeatures(extent, resolution, projection) {
        const loadedExtentsRtree = this.loadedExtentsRtree_;
        const extentsToLoad = this.strategy_(extent, resolution, projection);
        for(let i = 0, ii = extentsToLoad.length; i < ii; ++i){
            const extentToLoad = extentsToLoad[i];
            const alreadyLoaded = loadedExtentsRtree.forEachInExtent(extentToLoad, /**
         * @param {{extent: import("../extent.js").Extent}} object Object.
         * @return {boolean} Contains.
         */ function(object) {
                return (0, $dea65c2f666fa450$export$be866b1e0809b17e)(object.extent, extentToLoad);
            });
            if (!alreadyLoaded) {
                ++this.loadingExtentsCount_;
                this.dispatchEvent(new $1020e4d07ddbfab1$export$d402fd02dc2b661c((0, $73c4cd82312d5027$export$2e2bcd8739ae039).FEATURESLOADSTART));
                this.loader_.call(this, extentToLoad, resolution, projection, /**
           * @param {Array<FeatureType>} features Loaded features
           */ (features)=>{
                    --this.loadingExtentsCount_;
                    this.dispatchEvent(new $1020e4d07ddbfab1$export$d402fd02dc2b661c((0, $73c4cd82312d5027$export$2e2bcd8739ae039).FEATURESLOADEND, undefined, features));
                }, ()=>{
                    --this.loadingExtentsCount_;
                    this.dispatchEvent(new $1020e4d07ddbfab1$export$d402fd02dc2b661c((0, $73c4cd82312d5027$export$2e2bcd8739ae039).FEATURESLOADERROR));
                });
                loadedExtentsRtree.insert(extentToLoad, {
                    extent: extentToLoad.slice()
                });
            }
        }
        this.loading = this.loader_.length < 4 ? false : this.loadingExtentsCount_ > 0;
    }
    /**
   * @override
   */ refresh() {
        this.clear(true);
        this.loadedExtentsRtree_.clear();
        super.refresh();
    }
    /**
   * Remove an extent from the list of loaded extents.
   * @param {import("../extent.js").Extent} extent Extent.
   * @api
   */ removeLoadedExtent(extent) {
        const loadedExtentsRtree = this.loadedExtentsRtree_;
        const obj = loadedExtentsRtree.forEachInExtent(extent, function(object) {
            if ((0, $dea65c2f666fa450$export$e9bab7fafb253603)(object.extent, extent)) return object;
        });
        if (obj) loadedExtentsRtree.remove(obj);
    }
    /**
   * Batch remove features from the source.  If you want to remove all features
   * at once, use the {@link module:ol/source/Vector~VectorSource#clear #clear()} method
   * instead.
   * @param {Array<FeatureType>} features Features to remove.
   * @api
   */ removeFeatures(features) {
        let removed = false;
        for(let i = 0, ii = features.length; i < ii; ++i)removed = this.removeFeatureInternal(features[i]) || removed;
        if (removed) this.changed();
    }
    /**
   * Remove a single feature from the source. If you want to batch remove
   * features, use the {@link module:ol/source/Vector~VectorSource#removeFeatures #removeFeatures()} method
   * instead.
   * @param {FeatureType} feature Feature to remove.
   * @api
   */ removeFeature(feature) {
        if (!feature) return;
        const removed = this.removeFeatureInternal(feature);
        if (removed) this.changed();
    }
    /**
   * Remove feature without firing a `change` event.
   * @param {FeatureType} feature Feature.
   * @return {boolean} True if the feature was removed, false if it was not found.
   * @protected
   */ removeFeatureInternal(feature) {
        const featureKey = (0, $fd76d391cc228565$export$5e82334337e0f204)(feature);
        if (!(featureKey in this.uidIndex_)) return false;
        if (featureKey in this.nullGeometryFeatures_) delete this.nullGeometryFeatures_[featureKey];
        else if (this.featuresRtree_) this.featuresRtree_.remove(feature);
        const featureChangeKeys = this.featureChangeKeys_[featureKey];
        featureChangeKeys?.forEach((0, $63963d09e0c49405$export$b0a21c8b3c1c921));
        delete this.featureChangeKeys_[featureKey];
        const id = feature.getId();
        if (id !== undefined) {
            const idString = id.toString();
            const indexedFeature = this.idIndex_[idString];
            if (indexedFeature === feature) delete this.idIndex_[idString];
            else if (Array.isArray(indexedFeature)) {
                indexedFeature.splice(indexedFeature.indexOf(feature), 1);
                if (indexedFeature.length === 1) this.idIndex_[idString] = indexedFeature[0];
            }
        }
        delete this.uidIndex_[featureKey];
        if (this.hasListener((0, $73c4cd82312d5027$export$2e2bcd8739ae039).REMOVEFEATURE)) this.dispatchEvent(new $1020e4d07ddbfab1$export$d402fd02dc2b661c((0, $73c4cd82312d5027$export$2e2bcd8739ae039).REMOVEFEATURE, feature));
        return true;
    }
    /**
   * Remove a feature from the id index.  Called internally when the feature id
   * may have changed.
   * @param {FeatureType} feature The feature.
   * @private
   */ removeFromIdIndex_(feature) {
        for(const id in this.idIndex_)if (this.idIndex_[id] === feature) {
            delete this.idIndex_[id];
            break;
        }
    }
    /**
   * Set the new loader of the source. The next render cycle will use the
   * new loader.
   * @param {import("../featureloader.js").FeatureLoader} loader The loader to set.
   * @api
   */ setLoader(loader) {
        this.loader_ = loader;
    }
    /**
   * Points the source to a new url. The next render cycle will use the new url.
   * @param {string|import("../featureloader.js").FeatureUrlFunction} url Url.
   * @api
   */ setUrl(url) {
        (0, $71eb897bda873684$export$a7a9523472993e97)(this.format_, '`format` must be set when `url` is set');
        this.url_ = url;
        this.setLoader((0, $fdd08e685d8d561c$export$14cc81df70b6707e)(url, this.format_));
    }
    /**
   * @param {boolean} overlaps The source can have overlapping geometries.
   */ setOverlaps(overlaps) {
        this.overlaps_ = overlaps;
        this.changed();
    }
}
var $1020e4d07ddbfab1$export$2e2bcd8739ae039 = $1020e4d07ddbfab1$var$VectorSource;






var $kc00y = parcelRequire("kc00y");



var $b38d314a5a0d0e6b$var$SOURCE_CARTO = /*#__PURE__*/ function(SOURCE_CARTO) {
    SOURCE_CARTO["GEOJSON"] = "GEOJSON";
    SOURCE_CARTO["OSM"] = "OSM";
    SOURCE_CARTO["WMS"] = "WMS";
    SOURCE_CARTO["WMTS"] = "WMTS";
    SOURCE_CARTO["WFS"] = "WFS";
    return SOURCE_CARTO;
}($b38d314a5a0d0e6b$var$SOURCE_CARTO || {});
var $b38d314a5a0d0e6b$export$2e2bcd8739ae039 = $b38d314a5a0d0e6b$var$SOURCE_CARTO;


const $2787da6a8e84611c$var$typeAffichageCoordonnees = [
    {
        id: "X_Y",
        libelle: "X et Y"
    },
    {
        id: "DEGRES_DECIMAUX",
        libelle: "D\xe9gr\xe9s d\xe9cimaux"
    },
    {
        id: "DEGRES_SEXAGESIMAUX",
        libelle: "D\xe9gr\xe9s sexag\xe9simaux"
    }
];
var $2787da6a8e84611c$export$209cd9796c16313d = /*#__PURE__*/ function(TYPE_AFFICHAGE_COORDONNEES) {
    TYPE_AFFICHAGE_COORDONNEES["X_Y"] = "X_Y";
    TYPE_AFFICHAGE_COORDONNEES["DEGRES_DECIMAUX"] = "DEGRES_DECIMAUX";
    TYPE_AFFICHAGE_COORDONNEES["DEGRES_SEXAGESIMAUX"] = "DEGRES_SEXAGESIMAUX";
    return TYPE_AFFICHAGE_COORDONNEES;
}({});
var $2787da6a8e84611c$export$2e2bcd8739ae039 = $2787da6a8e84611c$var$typeAffichageCoordonnees;











var $kc00y = parcelRequire("kc00y");


var $kc00y = parcelRequire("kc00y");






var $kc00y = parcelRequire("kc00y");






"use client";
const $8276ef0b00794fc4$var$ListGroupItem = /*#__PURE__*/ $kc00y.forwardRef(({ bsPrefix: bsPrefix, active: active, disabled: disabled, eventKey: eventKey, className: className, variant: variant, action: action, as: as, ...props }, ref)=>{
    bsPrefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(bsPrefix, 'list-group-item');
    const [navItemProps, meta] = (0, $fef4535ccedac40e$export$d7a68693710982a)({
        key: (0, $218ada47f6b11566$export$eef49b42fde998a3)(eventKey, props.href),
        active: active,
        ...props
    });
    const handleClick = (0, $4655b62db0931f1e$export$2e2bcd8739ae039)((event)=>{
        if (disabled) {
            event.preventDefault();
            event.stopPropagation();
            return;
        }
        navItemProps.onClick(event);
    });
    if (disabled && props.tabIndex === undefined) {
        props.tabIndex = -1;
        props['aria-disabled'] = true;
    }
    const Component = as || (action ? props.href ? 'a' : 'button' : 'div');
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)(Component, {
        ref: ref,
        ...props,
        ...navItemProps,
        onClick: handleClick,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, bsPrefix, meta.isActive && 'active', disabled && 'disabled', variant && `${bsPrefix}-${variant}`, action && `${bsPrefix}-action`)
    });
});
$8276ef0b00794fc4$var$ListGroupItem.displayName = 'ListGroupItem';
var $8276ef0b00794fc4$export$2e2bcd8739ae039 = $8276ef0b00794fc4$var$ListGroupItem;



"use client";
const $87d0f3f36f67a4f7$var$ListGroup = /*#__PURE__*/ $kc00y.forwardRef((props, ref)=>{
    const { className: className, bsPrefix: initialBsPrefix, variant: variant, horizontal: horizontal, numbered: numbered, as: // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as = 'div', ...controlledProps } = (0, $b0582fd40c314767$export$2e2bcd8739ae039)(props, {
        activeKey: 'onSelect'
    });
    const bsPrefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(initialBsPrefix, 'list-group');
    let horizontalVariant;
    if (horizontal) horizontalVariant = horizontal === true ? 'horizontal' : `horizontal-${horizontal}`;
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $9c61fab88f8a2080$export$2e2bcd8739ae039), {
        ref: ref,
        ...controlledProps,
        as: as,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, bsPrefix, variant && `${bsPrefix}-${variant}`, horizontalVariant && `${bsPrefix}-${horizontalVariant}`, numbered && `${bsPrefix}-numbered`)
    });
});
$87d0f3f36f67a4f7$var$ListGroup.displayName = 'ListGroup';
var $87d0f3f36f67a4f7$export$2e2bcd8739ae039 = Object.assign($87d0f3f36f67a4f7$var$ListGroup, {
    Item: (0, $8276ef0b00794fc4$export$2e2bcd8739ae039)
});







var $kc00y = parcelRequire("kc00y");


var $kc00y = parcelRequire("kc00y");




var $kc00y = parcelRequire("kc00y");



var $kc00y = parcelRequire("kc00y");



var $kc00y = parcelRequire("kc00y");
"use client";
function $78592c7a2bcd1303$export$15e4e2f40b49cd81(activeEventKey, eventKey) {
    return Array.isArray(activeEventKey) ? activeEventKey.includes(eventKey) : activeEventKey === eventKey;
}
const $78592c7a2bcd1303$var$context = /*#__PURE__*/ $kc00y.createContext({});
$78592c7a2bcd1303$var$context.displayName = 'AccordionContext';
var $78592c7a2bcd1303$export$2e2bcd8739ae039 = $78592c7a2bcd1303$var$context;



"use client";
/**
 * This component accepts all of [`Collapse`'s props](/docs/utilities/transitions#collapse-1).
 */ const $49c82aaa98eb6a94$var$AccordionCollapse = /*#__PURE__*/ $kc00y.forwardRef(({ as: Component = 'div', bsPrefix: bsPrefix, className: className, children: children, eventKey: eventKey, ...props }, ref)=>{
    const { activeEventKey: activeEventKey } = (0, $kc00y.useContext)((0, $78592c7a2bcd1303$export$2e2bcd8739ae039));
    bsPrefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(bsPrefix, 'accordion-collapse');
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $0a86e6f0571c7093$export$2e2bcd8739ae039), {
        ref: ref,
        in: (0, $78592c7a2bcd1303$export$15e4e2f40b49cd81)(activeEventKey, eventKey),
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, bsPrefix),
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)(Component, {
            children: $kc00y.Children.only(children)
        })
    });
});
$49c82aaa98eb6a94$var$AccordionCollapse.displayName = 'AccordionCollapse';
var $49c82aaa98eb6a94$export$2e2bcd8739ae039 = $49c82aaa98eb6a94$var$AccordionCollapse;



var $kc00y = parcelRequire("kc00y");
"use client";
const $9ef0bee9f61a804c$var$context = /*#__PURE__*/ $kc00y.createContext({
    eventKey: ''
});
$9ef0bee9f61a804c$var$context.displayName = 'AccordionItemContext';
var $9ef0bee9f61a804c$export$2e2bcd8739ae039 = $9ef0bee9f61a804c$var$context;



"use client";
const $006adc1a67f63feb$var$AccordionBody = /*#__PURE__*/ $kc00y.forwardRef(({ // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', bsPrefix: bsPrefix, className: className, onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited, ...props }, ref)=>{
    bsPrefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(bsPrefix, 'accordion-body');
    const { eventKey: eventKey } = (0, $kc00y.useContext)((0, $9ef0bee9f61a804c$export$2e2bcd8739ae039));
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $49c82aaa98eb6a94$export$2e2bcd8739ae039), {
        eventKey: eventKey,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered,
        onExit: onExit,
        onExiting: onExiting,
        onExited: onExited,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)(Component, {
            ref: ref,
            ...props,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, bsPrefix)
        })
    });
});
$006adc1a67f63feb$var$AccordionBody.displayName = 'AccordionBody';
var $006adc1a67f63feb$export$2e2bcd8739ae039 = $006adc1a67f63feb$var$AccordionBody;



var $kc00y = parcelRequire("kc00y");





"use client";
function $80ea99822d817bee$export$1361ce4b8f883f3e(eventKey, onClick) {
    const { activeEventKey: activeEventKey, onSelect: onSelect, alwaysOpen: alwaysOpen } = (0, $kc00y.useContext)((0, $78592c7a2bcd1303$export$2e2bcd8739ae039));
    return (e)=>{
        /*
      Compare the event key in context with the given event key.
      If they are the same, then collapse the component.
    */ let eventKeyPassed = eventKey === activeEventKey ? null : eventKey;
        if (alwaysOpen) {
            if (Array.isArray(activeEventKey)) {
                if (activeEventKey.includes(eventKey)) eventKeyPassed = activeEventKey.filter((k)=>k !== eventKey);
                else eventKeyPassed = [
                    ...activeEventKey,
                    eventKey
                ];
            } else // activeEventKey is undefined.
            eventKeyPassed = [
                eventKey
            ];
        }
        onSelect == null || onSelect(eventKeyPassed, e);
        onClick == null || onClick(e);
    };
}
const $80ea99822d817bee$var$AccordionButton = /*#__PURE__*/ $kc00y.forwardRef(({ // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'button', bsPrefix: bsPrefix, className: className, onClick: onClick, ...props }, ref)=>{
    bsPrefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(bsPrefix, 'accordion-button');
    const { eventKey: eventKey } = (0, $kc00y.useContext)((0, $9ef0bee9f61a804c$export$2e2bcd8739ae039));
    const accordionOnClick = $80ea99822d817bee$export$1361ce4b8f883f3e(eventKey, onClick);
    const { activeEventKey: activeEventKey } = (0, $kc00y.useContext)((0, $78592c7a2bcd1303$export$2e2bcd8739ae039));
    if (Component === 'button') props.type = 'button';
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)(Component, {
        ref: ref,
        onClick: accordionOnClick,
        ...props,
        "aria-expanded": Array.isArray(activeEventKey) ? activeEventKey.includes(eventKey) : eventKey === activeEventKey,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, bsPrefix, !(0, $78592c7a2bcd1303$export$15e4e2f40b49cd81)(activeEventKey, eventKey) && 'collapsed')
    });
});
$80ea99822d817bee$var$AccordionButton.displayName = 'AccordionButton';
var $80ea99822d817bee$export$2e2bcd8739ae039 = $80ea99822d817bee$var$AccordionButton;






var $kc00y = parcelRequire("kc00y");



"use client";
const $2f733f440a61c797$var$AccordionHeader = /*#__PURE__*/ $kc00y.forwardRef(({ // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'h2', 'aria-controls': ariaControls, bsPrefix: bsPrefix, className: className, children: children, onClick: onClick, ...props }, ref)=>{
    bsPrefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(bsPrefix, 'accordion-header');
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, bsPrefix),
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $80ea99822d817bee$export$2e2bcd8739ae039), {
            onClick: onClick,
            "aria-controls": ariaControls,
            children: children
        })
    });
});
$2f733f440a61c797$var$AccordionHeader.displayName = 'AccordionHeader';
var $2f733f440a61c797$export$2e2bcd8739ae039 = $2f733f440a61c797$var$AccordionHeader;




var $kc00y = parcelRequire("kc00y");



"use client";
const $5cd4d9de9b9b6e20$var$AccordionItem = /*#__PURE__*/ $kc00y.forwardRef(({ // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', bsPrefix: bsPrefix, className: className, eventKey: eventKey, ...props }, ref)=>{
    bsPrefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(bsPrefix, 'accordion-item');
    const contextValue = (0, $kc00y.useMemo)(()=>({
            eventKey: eventKey
        }), [
        eventKey
    ]);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $9ef0bee9f61a804c$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)(Component, {
            ref: ref,
            ...props,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, bsPrefix)
        })
    });
});
$5cd4d9de9b9b6e20$var$AccordionItem.displayName = 'AccordionItem';
var $5cd4d9de9b9b6e20$export$2e2bcd8739ae039 = $5cd4d9de9b9b6e20$var$AccordionItem;



"use client";
const $69c77a5b3889bd0f$var$Accordion = /*#__PURE__*/ $kc00y.forwardRef((props, ref)=>{
    const { // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div', activeKey: activeKey, bsPrefix: bsPrefix, className: className, onSelect: onSelect, flush: flush, alwaysOpen: alwaysOpen, ...controlledProps } = (0, $b0582fd40c314767$export$2e2bcd8739ae039)(props, {
        activeKey: 'onSelect'
    });
    const prefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(bsPrefix, 'accordion');
    const contextValue = (0, $kc00y.useMemo)(()=>({
            activeEventKey: activeKey,
            onSelect: onSelect,
            alwaysOpen: alwaysOpen
        }), [
        activeKey,
        onSelect,
        alwaysOpen
    ]);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $78592c7a2bcd1303$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)(Component, {
            ref: ref,
            ...controlledProps,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, prefix, flush && `${prefix}-flush`)
        })
    });
});
$69c77a5b3889bd0f$var$Accordion.displayName = 'Accordion';
var $69c77a5b3889bd0f$export$2e2bcd8739ae039 = Object.assign($69c77a5b3889bd0f$var$Accordion, {
    Button: (0, $80ea99822d817bee$export$2e2bcd8739ae039),
    Collapse: (0, $49c82aaa98eb6a94$export$2e2bcd8739ae039),
    Item: (0, $5cd4d9de9b9b6e20$export$2e2bcd8739ae039),
    Header: (0, $2f733f440a61c797$export$2e2bcd8739ae039),
    Body: (0, $006adc1a67f63feb$export$2e2bcd8739ae039)
});


/**
 * Composant Accordion qui permet d'avoir plusieurs sections
 *
 * @param {list} list - liste des sections avec leur nom et leur contenu
 * @param {Function} handleShowClose - Fonction qui permet de fermer / ouvrir une section (elle doit venir de useAccordionState)
 * @param {list} activesKeys - Liste des sections qui doivent être actives
 */ const $db860d90b4a42fea$var$AccordionCustom = ({ list: list, handleShowClose: handleShowClose, activesKeys: activesKeys, classNameBody: classNameBody })=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $69c77a5b3889bd0f$export$2e2bcd8739ae039), {
        alwaysOpen: true,
        defaultActiveKey: activesKeys,
        activeKey: activesKeys,
        children: list.map(({ header: header, content: content, noprint: noprint }, key)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $69c77a5b3889bd0f$export$2e2bcd8739ae039).Item, {
                eventKey: key.toString(),
                className: noprint ? "noprint" : "",
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $69c77a5b3889bd0f$export$2e2bcd8739ae039).Header, {
                        onClick: ()=>handleShowClose(key),
                        children: header
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $69c77a5b3889bd0f$export$2e2bcd8739ae039).Body, {
                        className: classNameBody,
                        children: content
                    })
                ]
            }, key))
    });
};
var $db860d90b4a42fea$export$2e2bcd8739ae039 = $db860d90b4a42fea$var$AccordionCustom;
function $db860d90b4a42fea$export$dae930a4ba30758b(initialeOpenState = [
    true
]) {
    const [openState, setOpenState] = (0, $kc00y.useState)(initialeOpenState);
    const [activesKeys, setActivesKeys] = (0, $kc00y.useState)(initialeOpenState.map((e, i)=>e === true ? i.toString() : "").filter(String));
    function handleShowClose(index) {
        openState[index] = !openState[index];
        setOpenState(openState);
        getActivesKeys();
    }
    function getActivesKeys() {
        setActivesKeys(openState.map((e, i)=>e === true ? i.toString() : "").filter(String));
    }
    // Force l'ouverture
    function show(index) {
        openState[index] = true;
        setOpenState(openState);
        getActivesKeys();
    }
    return {
        openState: openState,
        handleShowClose: handleShowClose,
        activesKeys: activesKeys,
        show: show
    };
}



const $6070da25ca8c9100$var$MapLegend = /*#__PURE__*/ (0, $kc00y.forwardRef)(({ layers: layers, addOrRemoveLayer: addOrRemoveLayer }, ref)=>{
    const [activeLayers, setActiveLayers] = (0, $kc00y.useState)([]);
    const [open, setOpen] = (0, $kc00y.useState)({});
    (0, $kc00y.useImperativeHandle)(ref, ()=>({
            addActiveLayer (layerId) {
                setActiveLayers((_activeLayers)=>[
                        ..._activeLayers,
                        layerId
                    ]);
            },
            removeActiveLayer (layerId) {
                setActiveLayers(activeLayers.filter((l)=>l !== layerId));
            }
        }));
    function isChecked(layer) {
        return activeLayers.some((l)=>(0, $fd76d391cc228565$export$5e82334337e0f204)(layer.openlayer) === l);
    }
    const listeVoletsAccordion = [];
    layers?.filter((g)=>g.layers.length > 0).map((group)=>{
        const hasActiveLayers = group.layers.some((layer)=>activeLayers.some((l)=>(0, $fd76d391cc228565$export$5e82334337e0f204)(layer.openlayer) === l));
        listeVoletsAccordion.push({
            header: group.libelle,
            noprint: !hasActiveLayers,
            content: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $87d0f3f36f67a4f7$export$2e2bcd8739ae039), {
                className: "list-group-flush",
                children: group.layers.sort((a, b)=>{
                    return b.ordre - a.ordre;
                }).map((layer, layerIdx)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $87d0f3f36f67a4f7$export$2e2bcd8739ae039).Item, {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))("pb-0", isChecked(layer) ? "" : "noprint"),
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                        className: "m-0 p-0",
                                        xs: "auto",
                                        children: layer.icone && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ad18c81fdcf37de8$export$2e2bcd8739ae039), {
                                            src: layer.icone,
                                            fluid: true,
                                            style: {
                                                width: 20
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Group, {
                                                controlId: (0, $fd76d391cc228565$export$5e82334337e0f204)(layer.openlayer),
                                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                                    className: !isChecked(layer) ? "noprint" : "",
                                                    children: [
                                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                                            xs: 10,
                                                            className: "p-0 px-1",
                                                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Switch, {
                                                                checked: isChecked(layer),
                                                                onClick: ()=>{
                                                                    addOrRemoveLayer(layer);
                                                                },
                                                                label: layer.libelle
                                                            })
                                                        }),
                                                        layer.legende && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                                            xs: 1,
                                                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $98f55aa78fbaf278$export$2e2bcd8739ae039), {
                                                                pill: true,
                                                                onClick: ()=>setOpen({
                                                                        ...open,
                                                                        ...{
                                                                            [(0, $fd76d391cc228565$export$5e82334337e0f204)(layer.openlayer)]: !open[(0, $fd76d391cc228565$export$5e82334337e0f204)(layer.openlayer)]
                                                                        }
                                                                    }),
                                                                children: open[(0, $fd76d391cc228565$export$5e82334337e0f204)(layer.openlayer)] ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$ce5c58c6a297ddaf), {}) : /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$7b7ad8f03d93a9da), {})
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            isChecked(layer) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $fb281c3c0e7b8a11$export$2e2bcd8739ae039), {
                                                className: "noprint",
                                                disabled: !isChecked(layer),
                                                min: 0,
                                                max: 1,
                                                step: 0.1,
                                                defaultValue: layer.openlayer.getOpacity(),
                                                onChange: (evt)=>{
                                                    layer.openlayer.setOpacity(parseFloat(evt.target.value));
                                                }
                                            })
                                        ]
                                    })
                                ]
                            }),
                            layer.legende && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $0a86e6f0571c7093$export$2e2bcd8739ae039), {
                                        in: open[(0, $fd76d391cc228565$export$5e82334337e0f204)(layer.openlayer)],
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ad18c81fdcf37de8$export$2e2bcd8739ae039), {
                                            src: layer.legende,
                                            rounded: true,
                                            fluid: true
                                        })
                                    })
                                })
                            })
                        ]
                    }, layerIdx))
            })
        });
    });
    if (listeVoletsAccordion.length === 0) return;
    return listeVoletsAccordion && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($6070da25ca8c9100$var$AccordionMap, {
        listeVoletsAccordion: listeVoletsAccordion
    });
});
const $6070da25ca8c9100$var$AccordionMap = ({ listeVoletsAccordion: listeVoletsAccordion })=>{
    const { handleShowClose: handleShowClose, activesKeys: activesKeys } = (0, $db860d90b4a42fea$export$dae930a4ba30758b)(Array(listeVoletsAccordion.length).fill(true));
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db860d90b4a42fea$export$2e2bcd8739ae039), {
        activesKeys: activesKeys,
        handleShowClose: handleShowClose,
        list: listeVoletsAccordion,
        classNameBody: "p-1"
    });
};
$6070da25ca8c9100$var$MapLegend.displayName = "MapLegend";
var $6070da25ca8c9100$export$2e2bcd8739ae039 = $6070da25ca8c9100$var$MapLegend;



const $6c6ce495fc1da0b9$export$491bf9ecfffd2ca0 = {
    cacheSize: 1024,
    transition: 0,
    // Désactive les transitions pour un affichage plus rapide
    interpolate: false // Désactive l'interpolation pour un rendu plus rapide
};
const $6c6ce495fc1da0b9$export$6a2824e7e883c132 = {
    updateWhileAnimating: false,
    // Évite la mise à jour pendant l'animation
    updateWhileInteracting: false,
    // Évite la mise à jour pendant l'interaction
    renderBuffer: 150
};
function $6c6ce495fc1da0b9$export$a019f6ab8977315c(source) {
    // Applique les optimisations communes aux sources de tuiles
    if (source instanceof (0, $4c9244de85181135$export$2e2bcd8739ae039) || source instanceof (0, $7ba829994893f414$export$2e2bcd8739ae039) || source instanceof (0, $6944b8b0ce57af59$export$2e2bcd8739ae039)) {
        // Configuration du cache et des transitions
        source.set("cacheSize", $6c6ce495fc1da0b9$export$491bf9ecfffd2ca0.cacheSize);
        source.set("transition", $6c6ce495fc1da0b9$export$491bf9ecfffd2ca0.transition);
    }
    return source;
}
function $6c6ce495fc1da0b9$export$ee92df296c1dcf24(layer) {
    // Configuration du préchargement et du rendu
    layer.setPreload(1); // Précharge 1 niveau de zoom
    layer.setUseInterimTilesOnError(false); // Désactive les tuiles intermédiaires en cas d'erreur
    return layer;
}
function $6c6ce495fc1da0b9$export$d96f612ac05cb0c0(layer) {
    // Configuration des optimisations vectorielles via les options
    layer.set("updateWhileAnimating", $6c6ce495fc1da0b9$export$6a2824e7e883c132.updateWhileAnimating);
    layer.set("updateWhileInteracting", $6c6ce495fc1da0b9$export$6a2824e7e883c132.updateWhileInteracting);
    layer.set("renderBuffer", $6c6ce495fc1da0b9$export$6a2824e7e883c132.renderBuffer);
    return layer;
}
function $6c6ce495fc1da0b9$export$80f3d9824dd64b88(map) {
    // Configuration du rendu
    map.setLayerGroup(map.getLayerGroup()); // Force la régénération des couches
    // Optimisation des interactions de zoom
    const interactions = map.getInteractions().getArray();
    interactions.forEach((interaction)=>{
        if (interaction.constructor.name === "MouseWheelZoom") {
            interaction.set("useAnchor", true);
            interaction.set("constrainResolution", true);
        }
    });
    return map;
}
function $6c6ce495fc1da0b9$export$293c4afb163908ec() {
    const originalGetContext = HTMLCanvasElement.prototype.getContext;
    HTMLCanvasElement.prototype.getContext = function(contextType, contextAttributes) {
        // Pour les contextes 2D (utilisés par OpenLayers pour le rendu), ajouter l'option willReadFrequently
        if (contextType === "2d") {
            const settings = contextAttributes || {};
            settings.willReadFrequently = true;
            contextAttributes = settings;
        }
        return originalGetContext.call(this, contextType, contextAttributes);
    };
}
// Convertit la valeur crossOrigin HTML en options fetch équivalentes
function $6c6ce495fc1da0b9$var$crossOriginToFetchOptions(crossOrigin) {
    if (crossOrigin === "use-credentials") return {
        mode: "cors",
        credentials: "include"
    };
    if (crossOrigin === "anonymous") return {
        mode: "cors",
        credentials: "omit"
    };
    return {
        credentials: "same-origin"
    };
}
function $6c6ce495fc1da0b9$export$40aaeac5541a69ec(crossOrigin) {
    const controllers = new Map();
    const fetchOptions = $6c6ce495fc1da0b9$var$crossOriginToFetchOptions(crossOrigin);
    return (tile, src)=>{
        // Annuler une éventuelle requête en cours pour la même URL (re-demande de la même tuile)
        controllers.get(src)?.abort();
        const controller = new AbortController();
        controllers.set(src, controller);
        // OL appelle dispose() sur la tuile quand elle quitte le viewport — on abort alors la requête
        const onDispose = ()=>{
            controller.abort();
            controllers.delete(src);
            tile.removeEventListener("dispose", onDispose);
        };
        tile.addEventListener("dispose", onDispose);
        fetch(src, {
            ...fetchOptions,
            signal: controller.signal
        }).then((res)=>res.blob()).then((blob)=>{
            const imgEl = tile.getImage();
            const objectUrl = URL.createObjectURL(blob);
            imgEl.onload = ()=>URL.revokeObjectURL(objectUrl);
            imgEl.src = objectUrl;
            controllers.delete(src);
        }).catch((e)=>{
            controllers.delete(src);
            if (e.name !== "AbortError") tile.getImage().dispatchEvent(new Event("Erreur lors de la r\xe9cup\xe9ration de la tuile : " + e.message));
        });
    };
}
function $6c6ce495fc1da0b9$export$8c9efd2f226f6e84() {
    let controller = null;
    let currentObjectUrl = null;
    return (image, src)=>{
        // Annuler la requête précédente si elle est encore en cours
        controller?.abort();
        controller = new AbortController();
        // Libérer l'URL blob précédente si elle n'a pas encore été révoquée
        if (currentObjectUrl) {
            URL.revokeObjectURL(currentObjectUrl);
            currentObjectUrl = null;
        }
        fetch(src, {
            credentials: "same-origin",
            signal: controller.signal
        }).then((res)=>res.blob()).then((blob)=>{
            const imgEl = image.getImage();
            const objectUrl = URL.createObjectURL(blob);
            currentObjectUrl = objectUrl;
            imgEl.onload = ()=>{
                URL.revokeObjectURL(objectUrl);
                currentObjectUrl = null;
            };
            imgEl.src = objectUrl;
            controller = null;
        }).catch((e)=>{
            controller = null;
            if (e.name !== "AbortError") image.getImage().dispatchEvent(new Event("Erreur lors de la r\xe9cup\xe9ration de la tuile : " + e.message));
        });
    };
}
function $6c6ce495fc1da0b9$export$61fc7d43ac8f84b0(func, wait) {
    let timeout;
    return (...args)=>{
        clearTimeout(timeout);
        timeout = setTimeout(()=>func(...args), wait);
    };
}
function $6c6ce495fc1da0b9$export$de363e709c412c8a(func, limit) {
    let inThrottle;
    return (...args)=>{
        if (!inThrottle) {
            func(...args);
            inThrottle = true;
            setTimeout(()=>inThrottle = false, limit);
        }
    };
}



/**
 * @module ol/Overlay
 */ 





/**
 * @typedef {'bottom-left' | 'bottom-center' | 'bottom-right' | 'center-left' | 'center-center' | 'center-right' | 'top-left' | 'top-center' | 'top-right'} Positioning
 * The overlay position: `'bottom-left'`, `'bottom-center'`,  `'bottom-right'`,
 * `'center-left'`, `'center-center'`, `'center-right'`, `'top-left'`,
 * `'top-center'`, or `'top-right'`.
 */ /**
 * @typedef {Object} Options
 * @property {number|string} [id] Set the overlay id. The overlay id can be used
 * with the {@link module:ol/Map~Map#getOverlayById} method.
 * @property {HTMLElement} [element] The overlay element.
 * @property {Array<number>} [offset=[0, 0]] Offsets in pixels used when positioning
 * the overlay. The first element in the
 * array is the horizontal offset. A positive value shifts the overlay right.
 * The second element in the array is the vertical offset. A positive value
 * shifts the overlay down.
 * @property {import("./coordinate.js").Coordinate} [position] The overlay position
 * in map projection.
 * @property {Positioning} [positioning='top-left'] Defines how
 * the overlay is actually positioned with respect to its `position` property.
 * Possible values are `'bottom-left'`, `'bottom-center'`, `'bottom-right'`,
 * `'center-left'`, `'center-center'`, `'center-right'`, `'top-left'`,
 * `'top-center'`, and `'top-right'`.
 * @property {boolean} [stopEvent=true] Whether event propagation to the map
 * viewport should be stopped. If `true` the overlay is placed in the same
 * container as that of the controls (CSS class name
 * `ol-overlaycontainer-stopevent`); if `false` it is placed in the container
 * with CSS class name specified by the `className` property.
 * @property {boolean} [insertFirst=true] Whether the overlay is inserted first
 * in the overlay container, or appended. If the overlay is placed in the same
 * container as that of the controls (see the `stopEvent` option) you will
 * probably set `insertFirst` to `true` so the overlay is displayed below the
 * controls.
 * @property {PanIntoViewOptions|boolean} [autoPan=false] Pan the map when calling
 * `setPosition`, so that the overlay is entirely visible in the current viewport.
 * @property {string} [className='ol-overlay-container ol-selectable'] CSS class
 * name.
 */ /**
 * @typedef {Object} PanOptions
 * @property {number} [duration=1000] The duration of the animation in
 * milliseconds.
 * @property {function(number):number} [easing] The easing function to use. Can
 * be one from {@link module:ol/easing} or a custom function.
 * Default is {@link module:ol/easing.inAndOut}.
 */ /**
 * @typedef {Object} PanIntoViewOptions
 * @property {PanOptions} [animation={}] The animation parameters for the pan
 * @property {number} [margin=20] The margin (in pixels) between the
 * overlay and the borders of the map when panning into view.
 */ /**
 * @enum {string}
 * @protected
 */ const $bedb0af9b4c870c1$var$Property = {
    ELEMENT: 'element',
    MAP: 'map',
    OFFSET: 'offset',
    POSITION: 'position',
    POSITIONING: 'positioning'
};
/**
 * @typedef {import("./ObjectEventType").Types|'change:element'|'change:map'|'change:offset'|'change:position'|
 *   'change:positioning'} OverlayObjectEventTypes
 */ /***
 * @template Return
 * @typedef {import("./Observable").OnSignature<import("./Observable").EventTypes, import("./events/Event.js").default, Return> &
 *   import("./Observable").OnSignature<OverlayObjectEventTypes, import("./Object").ObjectEvent, Return> &
 *   import("./Observable").CombinedOnSignature<import("./Observable").EventTypes|OverlayObjectEventTypes, Return>} OverlayOnSignature
 */ /**
 * @classdesc
 * An element to be displayed over the map and attached to a single map
 * location.  Like {@link module:ol/control/Control~Control}, Overlays are
 * visible widgets. Unlike Controls, they are not in a fixed position on the
 * screen, but are tied to a geographical coordinate, so panning the map will
 * move an Overlay but not a Control.
 *
 * Example:
 *
 *     import Overlay from 'ol/Overlay.js';
 *
 *     // ...
 *     const popup = new Overlay({
 *       element: document.getElementById('popup'),
 *     });
 *     popup.setPosition(coordinate);
 *     map.addOverlay(popup);
 *
 * @api
 */ class $bedb0af9b4c870c1$var$Overlay extends (0, $4862cdcc23257f5b$export$2e2bcd8739ae039) {
    /**
   * @param {Options} options Overlay options.
   */ constructor(options){
        super();
        /***
     * @type {OverlayOnSignature<import("./events").EventsKey>}
     */ this.on;
        /***
     * @type {OverlayOnSignature<import("./events").EventsKey>}
     */ this.once;
        /***
     * @type {OverlayOnSignature<void>}
     */ this.un;
        /**
     * @protected
     * @type {Options}
     */ this.options = options;
        /**
     * @protected
     * @type {number|string|undefined}
     */ this.id = options.id;
        /**
     * @protected
     * @type {boolean}
     */ this.insertFirst = options.insertFirst !== undefined ? options.insertFirst : true;
        /**
     * @protected
     * @type {boolean}
     */ this.stopEvent = options.stopEvent !== undefined ? options.stopEvent : true;
        /**
     * @protected
     * @type {HTMLElement}
     */ this.element = document.createElement('div');
        this.element.className = options.className !== undefined ? options.className : 'ol-overlay-container ' + (0, $d3be093641aea1c1$export$99b49471b0394319);
        this.element.style.position = 'absolute';
        this.element.style.pointerEvents = 'auto';
        /**
     * @protected
     * @type {PanIntoViewOptions|undefined}
     */ this.autoPan = options.autoPan === true ? {} : options.autoPan || undefined;
        /**
     * @protected
     * @type {{transform_: string,
     *         visible: boolean}}
     */ this.rendered = {
            transform_: '',
            visible: true
        };
        /**
     * @protected
     * @type {?import("./events.js").EventsKey}
     */ this.mapPostrenderListenerKey = null;
        this.addChangeListener($bedb0af9b4c870c1$var$Property.ELEMENT, this.handleElementChanged);
        this.addChangeListener($bedb0af9b4c870c1$var$Property.MAP, this.handleMapChanged);
        this.addChangeListener($bedb0af9b4c870c1$var$Property.OFFSET, this.handleOffsetChanged);
        this.addChangeListener($bedb0af9b4c870c1$var$Property.POSITION, this.handlePositionChanged);
        this.addChangeListener($bedb0af9b4c870c1$var$Property.POSITIONING, this.handlePositioningChanged);
        if (options.element !== undefined) this.setElement(options.element);
        this.setOffset(options.offset !== undefined ? options.offset : [
            0,
            0
        ]);
        this.setPositioning(options.positioning || 'top-left');
        if (options.position !== undefined) this.setPosition(options.position);
    }
    /**
   * Get the DOM element of this overlay.
   * @return {HTMLElement|undefined} The Element containing the overlay.
   * @observable
   * @api
   */ getElement() {
        return /** @type {HTMLElement|undefined} */ this.get($bedb0af9b4c870c1$var$Property.ELEMENT);
    }
    /**
   * Get the overlay identifier which is set on constructor.
   * @return {number|string|undefined} Id.
   * @api
   */ getId() {
        return this.id;
    }
    /**
   * Get the map associated with this overlay.
   * @return {import("./Map.js").default|null} The map that the
   * overlay is part of.
   * @observable
   * @api
   */ getMap() {
        return /** @type {import("./Map.js").default|null} */ this.get($bedb0af9b4c870c1$var$Property.MAP) || null;
    }
    /**
   * Get the offset of this overlay.
   * @return {Array<number>} The offset.
   * @observable
   * @api
   */ getOffset() {
        return /** @type {Array<number>} */ this.get($bedb0af9b4c870c1$var$Property.OFFSET);
    }
    /**
   * Get the current position of this overlay.
   * @return {import("./coordinate.js").Coordinate|undefined} The spatial point that the overlay is
   *     anchored at.
   * @observable
   * @api
   */ getPosition() {
        return /** @type {import("./coordinate.js").Coordinate|undefined} */ this.get($bedb0af9b4c870c1$var$Property.POSITION);
    }
    /**
   * Get the current positioning of this overlay.
   * @return {Positioning} How the overlay is positioned
   *     relative to its point on the map.
   * @observable
   * @api
   */ getPositioning() {
        return /** @type {Positioning} */ this.get($bedb0af9b4c870c1$var$Property.POSITIONING);
    }
    /**
   * @protected
   */ handleElementChanged() {
        (0, $b6f6d442e8ff57e1$export$1e1c9bf5a4ffe0d1)(this.element);
        const element = this.getElement();
        if (element) this.element.appendChild(element);
    }
    /**
   * @protected
   */ handleMapChanged() {
        if (this.mapPostrenderListenerKey) {
            this.element?.remove();
            (0, $63963d09e0c49405$export$b0a21c8b3c1c921)(this.mapPostrenderListenerKey);
            this.mapPostrenderListenerKey = null;
        }
        const map = this.getMap();
        if (map) {
            this.mapPostrenderListenerKey = (0, $63963d09e0c49405$export$63174c828edd6ff8)(map, (0, $13d83f941f2fce32$export$2e2bcd8739ae039).POSTRENDER, this.render, this);
            this.updatePixelPosition();
            const container = this.stopEvent ? map.getOverlayContainerStopEvent() : map.getOverlayContainer();
            if (this.insertFirst) container.insertBefore(this.element, container.childNodes[0] || null);
            else container.appendChild(this.element);
            this.performAutoPan();
        }
    }
    /**
   * @protected
   */ render() {
        this.updatePixelPosition();
    }
    /**
   * @protected
   */ handleOffsetChanged() {
        this.updatePixelPosition();
    }
    /**
   * @protected
   */ handlePositionChanged() {
        this.updatePixelPosition();
        this.performAutoPan();
    }
    /**
   * @protected
   */ handlePositioningChanged() {
        this.updatePixelPosition();
    }
    /**
   * Set the DOM element to be associated with this overlay.
   * @param {HTMLElement|undefined} element The Element containing the overlay.
   * @observable
   * @api
   */ setElement(element) {
        this.set($bedb0af9b4c870c1$var$Property.ELEMENT, element);
    }
    /**
   * Set the map to be associated with this overlay.
   * @param {import("./Map.js").default|null} map The map that the
   * overlay is part of. Pass `null` to just remove the overlay from the current map.
   * @observable
   * @api
   */ setMap(map) {
        this.set($bedb0af9b4c870c1$var$Property.MAP, map);
    }
    /**
   * Set the offset for this overlay.
   * @param {Array<number>} offset Offset.
   * @observable
   * @api
   */ setOffset(offset) {
        this.set($bedb0af9b4c870c1$var$Property.OFFSET, offset);
    }
    /**
   * Set the position for this overlay. If the position is `undefined` the
   * overlay is hidden.
   * @param {import("./coordinate.js").Coordinate|undefined} position The spatial point that the overlay
   *     is anchored at.
   * @observable
   * @api
   */ setPosition(position) {
        this.set($bedb0af9b4c870c1$var$Property.POSITION, position);
    }
    /**
   * Pan the map so that the overlay is entirely visible in the current viewport
   * (if necessary) using the configured autoPan parameters
   * @protected
   */ performAutoPan() {
        if (this.autoPan) this.panIntoView(this.autoPan);
    }
    /**
   * Pan the map so that the overlay is entirely visible in the current viewport
   * (if necessary).
   * @param {PanIntoViewOptions} [panIntoViewOptions] Options for the pan action
   * @api
   */ panIntoView(panIntoViewOptions) {
        const map = this.getMap();
        if (!map || !map.getTargetElement() || !this.get($bedb0af9b4c870c1$var$Property.POSITION)) return;
        const mapRect = this.getRect(map.getTargetElement(), map.getSize());
        const element = this.getElement();
        const overlayRect = this.getRect(element, [
            (0, $b6f6d442e8ff57e1$export$e823f88e4111159a)(element),
            (0, $b6f6d442e8ff57e1$export$fc5b8aac72846d1e)(element)
        ]);
        panIntoViewOptions = panIntoViewOptions || {};
        const myMargin = panIntoViewOptions.margin === undefined ? 20 : panIntoViewOptions.margin;
        if (!(0, $dea65c2f666fa450$export$be866b1e0809b17e)(mapRect, overlayRect)) {
            // the overlay is not completely inside the viewport, so pan the map
            const offsetLeft = overlayRect[0] - mapRect[0];
            const offsetRight = mapRect[2] - overlayRect[2];
            const offsetTop = overlayRect[1] - mapRect[1];
            const offsetBottom = mapRect[3] - overlayRect[3];
            const delta = [
                0,
                0
            ];
            if (offsetLeft < 0) // move map to the left
            delta[0] = offsetLeft - myMargin;
            else if (offsetRight < 0) // move map to the right
            delta[0] = Math.abs(offsetRight) + myMargin;
            if (offsetTop < 0) // move map up
            delta[1] = offsetTop - myMargin;
            else if (offsetBottom < 0) // move map down
            delta[1] = Math.abs(offsetBottom) + myMargin;
            if (delta[0] !== 0 || delta[1] !== 0) {
                const center = /** @type {import("./coordinate.js").Coordinate} */ map.getView().getCenterInternal();
                const centerPx = map.getPixelFromCoordinateInternal(center);
                if (!centerPx) return;
                const newCenterPx = [
                    centerPx[0] + delta[0],
                    centerPx[1] + delta[1]
                ];
                const panOptions = panIntoViewOptions.animation || {};
                map.getView().animateInternal({
                    center: map.getCoordinateFromPixelInternal(newCenterPx),
                    duration: panOptions.duration,
                    easing: panOptions.easing
                });
            }
        }
    }
    /**
   * Get the extent of an element relative to the document
   * @param {HTMLElement} element The element.
   * @param {import("./size.js").Size} size The size of the element.
   * @return {import("./extent.js").Extent} The extent.
   * @protected
   */ getRect(element, size) {
        const box = element.getBoundingClientRect();
        const offsetX = box.left + window.pageXOffset;
        const offsetY = box.top + window.pageYOffset;
        return [
            offsetX,
            offsetY,
            offsetX + size[0],
            offsetY + size[1]
        ];
    }
    /**
   * Set the positioning for this overlay.
   * @param {Positioning} positioning how the overlay is
   *     positioned relative to its point on the map.
   * @observable
   * @api
   */ setPositioning(positioning) {
        this.set($bedb0af9b4c870c1$var$Property.POSITIONING, positioning);
    }
    /**
   * Modify the visibility of the element.
   * @param {boolean} visible Element visibility.
   * @protected
   */ setVisible(visible) {
        if (this.rendered.visible !== visible) {
            this.element.style.display = visible ? '' : 'none';
            this.rendered.visible = visible;
        }
    }
    /**
   * Update pixel position.
   * @protected
   */ updatePixelPosition() {
        const map = this.getMap();
        const position = this.getPosition();
        if (!map || !map.isRendered() || !position) {
            this.setVisible(false);
            return;
        }
        const pixel = map.getPixelFromCoordinate(position);
        const mapSize = map.getSize();
        this.updateRenderedPosition(pixel, mapSize);
    }
    /**
   * @param {import("./pixel.js").Pixel} pixel The pixel location.
   * @param {import("./size.js").Size|undefined} mapSize The map size.
   * @protected
   */ updateRenderedPosition(pixel, mapSize) {
        const style = this.element.style;
        const offset = this.getOffset();
        const positioning = this.getPositioning();
        this.setVisible(true);
        const x = `${pixel[0] + offset[0]}px`;
        const y = `${pixel[1] + offset[1]}px`;
        let posX = '0%';
        let posY = '0%';
        if (positioning == 'bottom-right' || positioning == 'center-right' || positioning == 'top-right') posX = '-100%';
        else if (positioning == 'bottom-center' || positioning == 'center-center' || positioning == 'top-center') posX = '-50%';
        if (positioning == 'bottom-left' || positioning == 'bottom-center' || positioning == 'bottom-right') posY = '-100%';
        else if (positioning == 'center-left' || positioning == 'center-center' || positioning == 'center-right') posY = '-50%';
        const transform = `translate(${posX}, ${posY}) translate(${x}, ${y})`;
        if (this.rendered.transform_ != transform) {
            this.rendered.transform_ = transform;
            style.transform = transform;
        }
    }
    /**
   * returns the options this Overlay has been created with
   * @return {Options} overlay options
   */ getOptions() {
        return this.options;
    }
}
var $bedb0af9b4c870c1$export$2e2bcd8739ae039 = $bedb0af9b4c870c1$var$Overlay;



/**
 * @module ol/interaction/Draw
 */ 








/**
 * @module ol/geom/Circle
 */ 



/**
 * @classdesc
 * Circle geometry.
 *
 * @api
 */ class $0c02e7a8e145dce8$var$Circle extends (0, $6773c3d7448f46a9$export$2e2bcd8739ae039) {
    /**
   * @param {!import("../coordinate.js").Coordinate} center Center.
   *     For internal use, flat coordinates in combination with `layout` and no
   *     `radius` are also accepted.
   * @param {number} [radius] Radius in units of the projection.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   */ constructor(center, radius, layout){
        super();
        if (layout !== undefined && radius === undefined) this.setFlatCoordinates(layout, center);
        else {
            radius = radius ? radius : 0;
            this.setCenterAndRadius(center, radius, layout);
        }
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!Circle} Clone.
   * @api
   * @override
   */ clone() {
        const circle = new $0c02e7a8e145dce8$var$Circle(this.flatCoordinates.slice(), undefined, this.layout);
        circle.applyProperties(this);
        return circle;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   * @override
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        const flatCoordinates = this.flatCoordinates;
        const dx = x - flatCoordinates[0];
        const dy = y - flatCoordinates[1];
        const squaredDistance = dx * dx + dy * dy;
        if (squaredDistance < minSquaredDistance) {
            if (squaredDistance === 0) for(let i = 0; i < this.stride; ++i)closestPoint[i] = flatCoordinates[i];
            else {
                const delta = this.getRadius() / Math.sqrt(squaredDistance);
                closestPoint[0] = flatCoordinates[0] + delta * dx;
                closestPoint[1] = flatCoordinates[1] + delta * dy;
                for(let i = 2; i < this.stride; ++i)closestPoint[i] = flatCoordinates[i];
            }
            closestPoint.length = this.stride;
            return squaredDistance;
        }
        return minSquaredDistance;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @return {boolean} Contains (x, y).
   * @override
   */ containsXY(x, y) {
        const flatCoordinates = this.flatCoordinates;
        const dx = x - flatCoordinates[0];
        const dy = y - flatCoordinates[1];
        return dx * dx + dy * dy <= this.getRadiusSquared_();
    }
    /**
   * Return the center of the circle as {@link module:ol/coordinate~Coordinate coordinate}.
   * @return {import("../coordinate.js").Coordinate} Center.
   * @api
   */ getCenter() {
        return this.flatCoordinates.slice(0, this.stride);
    }
    /**
   * @param {import("../extent.js").Extent} extent Extent.
   * @protected
   * @return {import("../extent.js").Extent} extent Extent.
   * @override
   */ computeExtent(extent) {
        const flatCoordinates = this.flatCoordinates;
        const radius = flatCoordinates[this.stride] - flatCoordinates[0];
        return (0, $dea65c2f666fa450$export$958e3e1a02eac4b6)(flatCoordinates[0] - radius, flatCoordinates[1] - radius, flatCoordinates[0] + radius, flatCoordinates[1] + radius, extent);
    }
    /**
   * Return the radius of the circle.
   * @return {number} Radius.
   * @api
   */ getRadius() {
        return Math.sqrt(this.getRadiusSquared_());
    }
    /**
   * @private
   * @return {number} Radius squared.
   */ getRadiusSquared_() {
        const dx = this.flatCoordinates[this.stride] - this.flatCoordinates[0];
        const dy = this.flatCoordinates[this.stride + 1] - this.flatCoordinates[1];
        return dx * dx + dy * dy;
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   * @override
   */ getType() {
        return 'Circle';
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   * @override
   */ intersectsExtent(extent) {
        const circleExtent = this.getExtent();
        if ((0, $dea65c2f666fa450$export$7b0a31e10bbff018)(extent, circleExtent)) {
            const center = this.getCenter();
            if (extent[0] <= center[0] && extent[2] >= center[0]) return true;
            if (extent[1] <= center[1] && extent[3] >= center[1]) return true;
            return (0, $dea65c2f666fa450$export$f9ed8a3d123a08e2)(extent, this.intersectsCoordinate.bind(this));
        }
        return false;
    }
    /**
   * Set the center of the circle as {@link module:ol/coordinate~Coordinate coordinate}.
   * @param {import("../coordinate.js").Coordinate} center Center.
   * @api
   */ setCenter(center) {
        const stride = this.stride;
        const radius = this.flatCoordinates[stride] - this.flatCoordinates[0];
        const flatCoordinates = center.slice();
        flatCoordinates[stride] = flatCoordinates[0] + radius;
        for(let i = 1; i < stride; ++i)flatCoordinates[stride + i] = center[i];
        this.setFlatCoordinates(this.layout, flatCoordinates);
        this.changed();
    }
    /**
   * Set the center (as {@link module:ol/coordinate~Coordinate coordinate}) and the radius (as
   * number) of the circle.
   * @param {!import("../coordinate.js").Coordinate} center Center.
   * @param {number} radius Radius.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   */ setCenterAndRadius(center, radius, layout) {
        this.setLayout(layout, center, 0);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        /** @type {Array<number>} */ const flatCoordinates = this.flatCoordinates;
        let offset = (0, $f96815e1fef680b1$export$60815ead40ec79ab)(flatCoordinates, 0, center, this.stride);
        flatCoordinates[offset++] = flatCoordinates[0] + radius;
        for(let i = 1, ii = this.stride; i < ii; ++i)flatCoordinates[offset++] = flatCoordinates[i];
        flatCoordinates.length = offset;
        this.changed();
    }
    /**
   * @override
   */ getCoordinates() {
        return null;
    }
    /**
   * @override
   */ setCoordinates(coordinates, layout) {}
    /**
   * Set the radius of the circle. The radius is in the units of the projection.
   * @param {number} radius Radius.
   * @api
   */ setRadius(radius) {
        this.flatCoordinates[this.stride] = this.flatCoordinates[0] + radius;
        this.changed();
    }
    /**
   * Rotate the geometry around a given coordinate. This modifies the geometry
   * coordinates in place.
   * @param {number} angle Rotation angle in counter-clockwise radians.
   * @param {import("../coordinate.js").Coordinate} anchor The rotation center.
   * @api
   * @override
   */ rotate(angle, anchor) {
        const center = this.getCenter();
        const stride = this.getStride();
        this.setCenter((0, $d95a11593b39996c$export$bb628a54ab399bc9)(center, 0, center.length, stride, angle, anchor, center));
        this.changed();
    }
}
/**
 * Transform each coordinate of the circle from one coordinate reference system
 * to another. The geometry is modified in place.
 * If you do not want the geometry modified in place, first clone() it and
 * then use this function on the clone.
 *
 * Internally a circle is currently represented by two points: the center of
 * the circle `[cx, cy]`, and the point to the right of the circle
 * `[cx + r, cy]`. This `transform` function just transforms these two points.
 * So the resulting geometry is also a circle, and that circle does not
 * correspond to the shape that would be obtained by transforming every point
 * of the original circle.
 *
 * @param {import("../proj.js").ProjectionLike} source The current projection.  Can be a
 *     string identifier or a {@link module:ol/proj/Projection~Projection} object.
 * @param {import("../proj.js").ProjectionLike} destination The desired projection.  Can be a
 *     string identifier or a {@link module:ol/proj/Projection~Projection} object.
 * @return {Circle} This geometry.  Note that original geometry is
 *     modified in place.
 * @function
 * @api
 */ $0c02e7a8e145dce8$var$Circle.prototype.transform;
var $0c02e7a8e145dce8$export$2e2bcd8739ae039 = $0c02e7a8e145dce8$var$Circle;















/**
 * Coordinate type when drawing lines.
 * @typedef {Array<import("../coordinate.js").Coordinate>} LineCoordType
 */ 


function $0a2478def9b60c71$export$2028164776634ba(coordinates, index) {
    const count = coordinates.length;
    if (index < 0) return coordinates[index + count];
    if (index >= count) return coordinates[index - count];
    return coordinates[index];
}
function $0a2478def9b60c71$export$46d85ac2b3f8e419(coordinates, index) {
    const count = coordinates.length;
    let startIndex = Math.floor(index);
    const along = index - startIndex;
    if (startIndex >= count) startIndex -= count;
    else if (startIndex < 0) startIndex += count;
    let endIndex = startIndex + 1;
    if (endIndex >= count) endIndex -= count;
    const start = coordinates[startIndex];
    const x0 = start[0];
    const y0 = start[1];
    const end = coordinates[endIndex];
    const dx = end[0] - x0;
    const dy = end[1] - y0;
    return [
        x0 + dx * along,
        y0 + dy * along
    ];
}
/**
 * @typedef {Object} TraceTarget
 * @property {Array<import("../coordinate.js").Coordinate>} coordinates Target coordinates.
 * @property {boolean} ring The target coordinates are a linear ring.
 * @property {number} startIndex The index of first traced coordinate.  A fractional index represents an
 * edge intersection.  Index values for rings will wrap (may be negative or larger than coordinates length).
 * @property {number} endIndex The index of last traced coordinate.  Details from startIndex also apply here.
 */ /**
 * @typedef {Object} TraceState
 * @property {boolean} active Tracing active.
 * @property {import("../coordinate.js").Coordinate} [startCoord] The initially clicked coordinate.
 * @property {Array<TraceTarget>} [targets] Targets available for tracing.
 * @property {number} [targetIndex] The index of the currently traced target.  A value of -1 indicates
 * that no trace target is active.
 */ /**
 * @typedef {Object} TraceTargetUpdateInfo
 * @property {number} index The new target index.
 * @property {number} endIndex The new segment end index.
 * @property {number} closestTargetDistance The squared distance to the closest target.
 */ /**
 * @type {TraceTargetUpdateInfo}
 */ const $0a2478def9b60c71$var$sharedUpdateInfo = {
    index: -1,
    endIndex: NaN,
    closestTargetDistance: Infinity
};
function $0a2478def9b60c71$export$4a6978e1933d7fa(coordinate, traceState, map, snapTolerance) {
    const x = coordinate[0];
    const y = coordinate[1];
    let closestTargetDistance = Infinity;
    let newTargetIndex = -1;
    let newEndIndex = NaN;
    for(let targetIndex = 0; targetIndex < traceState.targets.length; ++targetIndex){
        const target = traceState.targets[targetIndex];
        const coordinates = target.coordinates;
        let minSegmentDistance = Infinity;
        let endIndex;
        for(let coordinateIndex = 0; coordinateIndex < coordinates.length - 1; ++coordinateIndex){
            const start = coordinates[coordinateIndex];
            const end = coordinates[coordinateIndex + 1];
            const rel = $0a2478def9b60c71$export$e99aa903bac0bc9b(x, y, start, end);
            if (rel.squaredDistance < minSegmentDistance) {
                minSegmentDistance = rel.squaredDistance;
                endIndex = coordinateIndex + rel.along;
            }
        }
        if (minSegmentDistance < closestTargetDistance) {
            closestTargetDistance = minSegmentDistance;
            if (target.ring && traceState.targetIndex === targetIndex) {
                // same target, maintain the same trace direction
                if (target.endIndex > target.startIndex) // forward trace
                {
                    if (endIndex < target.startIndex) endIndex += coordinates.length;
                } else if (target.endIndex < target.startIndex) // reverse trace
                {
                    if (endIndex > target.startIndex) endIndex -= coordinates.length;
                }
            }
            newEndIndex = endIndex;
            newTargetIndex = targetIndex;
        }
    }
    const newTarget = traceState.targets[newTargetIndex];
    let considerBothDirections = newTarget.ring;
    if (traceState.targetIndex === newTargetIndex && considerBothDirections) {
        // only consider switching trace direction if close to the start
        const newCoordinate = $0a2478def9b60c71$export$46d85ac2b3f8e419(newTarget.coordinates, newEndIndex);
        const pixel = map.getPixelFromCoordinate(newCoordinate);
        const startPx = map.getPixelFromCoordinate(traceState.startCoord);
        if ((0, $a6adb03fd2fbc071$export$9f17032d917177de)(pixel, startPx) > snapTolerance) considerBothDirections = false;
    }
    if (considerBothDirections) {
        const coordinates = newTarget.coordinates;
        const count = coordinates.length;
        const startIndex = newTarget.startIndex;
        const endIndex = newEndIndex;
        if (startIndex < endIndex) {
            const forwardDistance = $0a2478def9b60c71$var$getCumulativeSquaredDistance(coordinates, startIndex, endIndex);
            const reverseDistance = $0a2478def9b60c71$var$getCumulativeSquaredDistance(coordinates, startIndex, endIndex - count);
            if (reverseDistance < forwardDistance) newEndIndex -= count;
        } else {
            const reverseDistance = $0a2478def9b60c71$var$getCumulativeSquaredDistance(coordinates, startIndex, endIndex);
            const forwardDistance = $0a2478def9b60c71$var$getCumulativeSquaredDistance(coordinates, startIndex, endIndex + count);
            if (forwardDistance < reverseDistance) newEndIndex += count;
        }
    }
    $0a2478def9b60c71$var$sharedUpdateInfo.index = newTargetIndex;
    $0a2478def9b60c71$var$sharedUpdateInfo.endIndex = newEndIndex;
    $0a2478def9b60c71$var$sharedUpdateInfo.closestTargetDistance = closestTargetDistance;
    return $0a2478def9b60c71$var$sharedUpdateInfo;
}
function $0a2478def9b60c71$export$8b36095f6110ee8f(coordinate, features) {
    /**
   * @type {Array<TraceTarget>}
   */ const targets = [];
    for(let i = 0; i < features.length; ++i){
        const feature = features[i];
        const geometry = feature.getGeometry();
        $0a2478def9b60c71$var$appendGeometryTraceTargets(coordinate, geometry, targets);
    }
    return targets;
}
/**
 * @param {import("../coordinate.js").Coordinate} coordinate The coordinate.
 * @param {import("../geom/Geometry.js").default} geometry The candidate geometry.
 * @param {Array<TraceTarget>} targets The trace targets.
 */ function $0a2478def9b60c71$var$appendGeometryTraceTargets(coordinate, geometry, targets) {
    if (geometry instanceof (0, $197b31f867e63891$export$2e2bcd8739ae039)) {
        $0a2478def9b60c71$var$appendTraceTarget(coordinate, geometry.getCoordinates(), false, targets);
        return;
    }
    if (geometry instanceof (0, $96d2138ace1f7d2d$export$2e2bcd8739ae039)) {
        const coordinates = geometry.getCoordinates();
        for(let i = 0, ii = coordinates.length; i < ii; ++i)$0a2478def9b60c71$var$appendTraceTarget(coordinate, coordinates[i], false, targets);
        return;
    }
    if (geometry instanceof (0, $52cb54ac72de6b07$export$2e2bcd8739ae039)) {
        const coordinates = geometry.getCoordinates();
        for(let i = 0, ii = coordinates.length; i < ii; ++i)$0a2478def9b60c71$var$appendTraceTarget(coordinate, coordinates[i], true, targets);
        return;
    }
    if (geometry instanceof (0, $71dd1c600460678c$export$2e2bcd8739ae039)) {
        const polys = geometry.getCoordinates();
        for(let i = 0, ii = polys.length; i < ii; ++i){
            const coordinates = polys[i];
            for(let j = 0, jj = coordinates.length; j < jj; ++j)$0a2478def9b60c71$var$appendTraceTarget(coordinate, coordinates[j], true, targets);
        }
        return;
    }
    if (geometry instanceof (0, $83009074668f36ff$export$2e2bcd8739ae039)) {
        const geometries = geometry.getGeometries();
        for(let i = 0; i < geometries.length; ++i)$0a2478def9b60c71$var$appendGeometryTraceTargets(coordinate, geometries[i], targets);
        return;
    }
// other types cannot be traced
}
/**
 * @param {import("../coordinate.js").Coordinate} coordinate The clicked coordinate.
 * @param {Array<import("../coordinate.js").Coordinate>} coordinates The geometry component coordinates.
 * @param {boolean} ring The coordinates represent a linear ring.
 * @param {Array<TraceTarget>} targets The trace targets.
 */ function $0a2478def9b60c71$var$appendTraceTarget(coordinate, coordinates, ring, targets) {
    const x = coordinate[0];
    const y = coordinate[1];
    for(let i = 0, ii = coordinates.length - 1; i < ii; ++i){
        const start = coordinates[i];
        const end = coordinates[i + 1];
        const rel = $0a2478def9b60c71$export$e99aa903bac0bc9b(x, y, start, end);
        if (rel.squaredDistance === 0) {
            const index = i + rel.along;
            targets.push({
                coordinates: coordinates,
                ring: ring,
                startIndex: index,
                endIndex: index
            });
            return;
        }
    }
}
/**
 * @param {import("../coordinate.js").Coordinate} a One coordinate.
 * @param {import("../coordinate.js").Coordinate} b Another coordinate.
 * @return {number} The squared distance between the two coordinates.
 */ function $0a2478def9b60c71$var$getSquaredDistance(a, b) {
    return (0, $6a95bd76d7103f37$export$88e6ebb4fe54f538)(a[0], a[1], b[0], b[1]);
}
/**
 * Get the cumulative squared distance along a ring path.  The end index index may be "wrapped" and it may
 * be less than the start index to indicate the direction of travel.  The start and end index may have
 * a fractional part to indicate a point between two coordinates.
 * @param {LineCoordType} coordinates Ring coordinates.
 * @param {number} startIndex The start index.
 * @param {number} endIndex The end index.
 * @return {number} The cumulative squared distance along the ring path.
 */ function $0a2478def9b60c71$var$getCumulativeSquaredDistance(coordinates, startIndex, endIndex) {
    let lowIndex, highIndex;
    if (startIndex < endIndex) {
        lowIndex = startIndex;
        highIndex = endIndex;
    } else {
        lowIndex = endIndex;
        highIndex = startIndex;
    }
    const lowWholeIndex = Math.ceil(lowIndex);
    const highWholeIndex = Math.floor(highIndex);
    if (lowWholeIndex > highWholeIndex) {
        // both start and end are on the same segment
        const start = $0a2478def9b60c71$export$46d85ac2b3f8e419(coordinates, lowIndex);
        const end = $0a2478def9b60c71$export$46d85ac2b3f8e419(coordinates, highIndex);
        return $0a2478def9b60c71$var$getSquaredDistance(start, end);
    }
    let sd = 0;
    if (lowIndex < lowWholeIndex) {
        const start = $0a2478def9b60c71$export$46d85ac2b3f8e419(coordinates, lowIndex);
        const end = $0a2478def9b60c71$export$2028164776634ba(coordinates, lowWholeIndex);
        sd += $0a2478def9b60c71$var$getSquaredDistance(start, end);
    }
    if (highWholeIndex < highIndex) {
        const start = $0a2478def9b60c71$export$2028164776634ba(coordinates, highWholeIndex);
        const end = $0a2478def9b60c71$export$46d85ac2b3f8e419(coordinates, highIndex);
        sd += $0a2478def9b60c71$var$getSquaredDistance(start, end);
    }
    for(let i = lowWholeIndex; i < highWholeIndex - 1; ++i){
        const start = $0a2478def9b60c71$export$2028164776634ba(coordinates, i);
        const end = $0a2478def9b60c71$export$2028164776634ba(coordinates, i + 1);
        sd += $0a2478def9b60c71$var$getSquaredDistance(start, end);
    }
    return sd;
}
/**
 * @typedef {Object} PointSegmentRelationship
 * @property {number} along The closest point expressed as a fraction along the segment length.
 * @property {number} squaredDistance The squared distance of the point to the segment.
 */ /**
 * @type {PointSegmentRelationship}
 */ const $0a2478def9b60c71$var$sharedRel = {
    along: 0,
    squaredDistance: 0
};
function $0a2478def9b60c71$export$e99aa903bac0bc9b(x, y, start, end) {
    const x1 = start[0];
    const y1 = start[1];
    const x2 = end[0];
    const y2 = end[1];
    const dx = x2 - x1;
    const dy = y2 - y1;
    let along = 0;
    let px = x1;
    let py = y1;
    if (dx !== 0 || dy !== 0) {
        along = (0, $6a95bd76d7103f37$export$7d15b64cf5a3a4c4)(((x - x1) * dx + (y - y1) * dy) / (dx * dx + dy * dy), 0, 1);
        px += dx * along;
        py += dy * along;
    }
    $0a2478def9b60c71$var$sharedRel.along = along;
    $0a2478def9b60c71$var$sharedRel.squaredDistance = (0, $6a95bd76d7103f37$export$a81f732198733497)((0, $6a95bd76d7103f37$export$88e6ebb4fe54f538)(x, y, px, py), 10);
    return $0a2478def9b60c71$var$sharedRel;
}


/**
 * @typedef {Object} Options
 * @property {import("../geom/Geometry.js").Type} type Geometry type of
 * the geometries being drawn with this instance.
 * @property {number} [clickTolerance=6] The maximum distance in pixels between
 * "down" and "up" for a "up" event to be considered a "click" event and
 * actually add a point/vertex to the geometry being drawn.  The default of `6`
 * was chosen for the draw interaction to behave correctly on mouse as well as
 * on touch devices.
 * @property {import("../Collection.js").default<Feature>} [features]
 * Destination collection for the drawn features.
 * @property {VectorSource} [source] Destination source for
 * the drawn features.
 * @property {number} [dragVertexDelay=500] Delay in milliseconds after pointerdown
 * before the current vertex can be dragged to its exact position.
 * @property {number} [snapTolerance=12] Pixel distance for snapping to the
 * drawing finish. Must be greater than `0`.
 * @property {boolean} [stopClick=false] Stop click, singleclick, and
 * doubleclick events from firing during drawing.
 * @property {number} [maxPoints] The number of points that can be drawn before
 * a polygon ring or line string is finished. By default there is no
 * restriction.
 * @property {number} [minPoints] The number of points that must be drawn
 * before a polygon ring or line string can be finished. Default is `3` for
 * polygon rings and `2` for line strings.
 * @property {import("../events/condition.js").Condition} [finishCondition] A function
 * that takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether the drawing can be finished. Not used when drawing
 * POINT or MULTI_POINT geometries.
 * @property {import("../style/Style.js").StyleLike|import("../style/flat.js").FlatStyleLike} [style]
 * Style for sketch features. The draw interaction can have up to three sketch features, depending on the mode.
 * It will always contain a feature with a `Point` geometry that corresponds to the current cursor position.
 * If the mode is `LineString` or `Polygon`, and there is at least one drawn point, it will also contain a feature with
 * a `LineString` geometry that corresponds to the line between the already drawn points and the current cursor position.
 * If the mode is `Polygon`, and there is at least one drawn point, it will also contain a feature with a `Polygon`
 * geometry that corresponds to the polygon between the already drawn points and the current cursor position
 * (note that this polygon has only two points if only one point is drawn).
 * If the mode is `Circle`, and there is one point drawn, it will also contain a feature with a `Circle` geometry whose
 * center is the drawn point and the radius is determined by the distance between the drawn point and the cursor.
 * @property {GeometryFunction} [geometryFunction]
 * Function that is called when a geometry's coordinates are updated.
 * @property {string} [geometryName] Geometry name to use for features created
 * by the draw interaction.
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled.
 * By default {@link module:ol/events/condition.noModifierKeys}, i.e. a click,
 * adds a vertex or deactivates freehand drawing.
 * @property {boolean} [freehand=false] Operate in freehand mode for lines,
 * polygons, and circles.  This makes the interaction always operate in freehand
 * mode and takes precedence over any `freehandCondition` option.
 * @property {import("../events/condition.js").Condition} [freehandCondition]
 * Condition that activates freehand drawing for lines and polygons. This
 * function takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and
 * returns a boolean to indicate whether that event should be handled. The
 * default is {@link module:ol/events/condition.shiftKeyOnly}, meaning that the
 * Shift key activates freehand drawing.
 * @property {boolean|import("../events/condition.js").Condition} [trace=false] Trace a portion of another geometry.
 * Ignored when in freehand mode.
 * @property {VectorSource} [traceSource] Source for features to trace.  If tracing is active and a `traceSource` is
 * not provided, the interaction's `source` will be used.  Tracing requires that the interaction is configured with
 * either a `traceSource` or a `source`.
 * @property {boolean} [wrapX=false] Wrap the world horizontally on the sketch
 * overlay.
 * @property {import("../geom/Geometry.js").GeometryLayout} [geometryLayout='XY'] Layout of the
 * feature geometries created by the draw interaction.
 */ /**
 * Coordinate type when drawing points.
 * @typedef {import("../coordinate.js").Coordinate} PointCoordType
 */ /**
 * @typedef {import('./tracing.js').LineCoordType} LineCoordType
 */ /**
 * Coordinate type when drawing polygons.
 * @typedef {Array<Array<import("../coordinate.js").Coordinate>>} PolyCoordType
 */ /**
 * Types used for drawing coordinates.
 * @typedef {PointCoordType|LineCoordType|PolyCoordType} SketchCoordType
 */ /** @typedef {import('./tracing.js').TraceState} TraceState */ /** @typedef {import('./tracing.js').TraceTarget} TraceTarget */ /**
 * Function that takes an array of coordinates and an optional existing geometry
 * and a projection as arguments, and returns a geometry. The optional existing
 * geometry is the geometry that is returned when the function is called without
 * a second argument.
 * @typedef {function(!SketchCoordType, import("../geom/SimpleGeometry.js").default,
 *     import("../proj/Projection.js").default):
 *     import("../geom/SimpleGeometry.js").default} GeometryFunction
 */ /**
 * @typedef {'Point' | 'LineString' | 'Polygon' | 'Circle'} Mode
 * Draw mode.  This collapses multi-part geometry types with their single-part
 * cousins.
 */ /**
 * @enum {string}
 */ const $2ef894158a48397d$var$DrawEventType = {
    /**
   * Triggered upon feature draw start
   * @event DrawEvent#drawstart
   * @api
   */ DRAWSTART: 'drawstart',
    /**
   * Triggered upon feature draw end
   * @event DrawEvent#drawend
   * @api
   */ DRAWEND: 'drawend',
    /**
   * Triggered upon feature draw abortion
   * @event DrawEvent#drawabort
   * @api
   */ DRAWABORT: 'drawabort'
};
class $2ef894158a48397d$export$85a4910380d251a7 extends (0, $5c6b0a43c077a98f$export$2e2bcd8739ae039) {
    /**
   * @param {DrawEventType} type Type.
   * @param {Feature} feature The feature drawn.
   */ constructor(type, feature){
        super(type);
        /**
     * The feature being drawn.
     * @type {Feature}
     * @api
     */ this.feature = feature;
    }
}
/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types|
 *     'change:active', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<'drawabort'|'drawend'|'drawstart', DrawEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types|
 *     'change:active'|'drawabort'|'drawend'|'drawstart', Return>} DrawOnSignature
 */ /**
 * @classdesc
 * Interaction for drawing feature geometries.
 *
 * @fires DrawEvent
 * @api
 */ class $2ef894158a48397d$var$Draw extends (0, $21bd437a923ad8cf$export$2e2bcd8739ae039) {
    /**
   * @param {Options} options Options.
   */ constructor(options){
        const pointerOptions = /** @type {import("./Pointer.js").Options} */ options;
        if (!pointerOptions.stopDown) pointerOptions.stopDown = (0, $bc15bca7780ad95b$export$8f11cee4bdc7e668);
        super(pointerOptions);
        /***
     * @type {DrawOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {DrawOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {DrawOnSignature<void>}
     */ this.un;
        /**
     * @type {Options}
     * @private
     */ this.options_ = options;
        /**
     * @type {boolean}
     * @private
     */ this.shouldHandle_ = false;
        /**
     * @type {import("../pixel.js").Pixel}
     * @private
     */ this.downPx_ = null;
        /**
     * @type {ReturnType<typeof setTimeout>}
     * @private
     */ this.downTimeout_;
        /**
     * @type {number|undefined}
     * @private
     */ this.lastDragTime_;
        /**
     * Pointer type of the last pointermove event
     * @type {string}
     * @private
     */ this.pointerType_;
        /**
     * @type {boolean}
     * @private
     */ this.freehand_ = false;
        /**
     * Target source for drawn features.
     * @type {VectorSource|null}
     * @private
     */ this.source_ = options.source ? options.source : null;
        /**
     * Target collection for drawn features.
     * @type {import("../Collection.js").default<Feature>|null}
     * @private
     */ this.features_ = options.features ? options.features : null;
        /**
     * Pixel distance for snapping.
     * @type {number}
     * @private
     */ this.snapTolerance_ = options.snapTolerance ? options.snapTolerance : 12;
        /**
     * Geometry type.
     * @type {import("../geom/Geometry.js").Type}
     * @private
     */ this.type_ = /** @type {import("../geom/Geometry.js").Type} */ options.type;
        /**
     * Drawing mode (derived from geometry type.
     * @type {Mode}
     * @private
     */ this.mode_ = $2ef894158a48397d$var$getMode(this.type_);
        /**
     * Stop click, singleclick, and doubleclick events from firing during drawing.
     * Default is `false`.
     * @type {boolean}
     * @private
     */ this.stopClick_ = !!options.stopClick;
        /**
     * Ignore the next up event. This is set to `true` when a drag event is encountered,
     * e.g. when the user pans the map while drawing. In this case, we do not want to bail
     * out of tracing.
     * @type {boolean}
     * @private
     */ this.ignoreNextUpEvent_ = false;
        /**
     * The number of points that must be drawn before a polygon ring or line
     * string can be finished.  The default is 3 for polygon rings and 2 for
     * line strings.
     * @type {number}
     * @private
     */ this.minPoints_ = options.minPoints ? options.minPoints : this.mode_ === 'Polygon' ? 3 : 2;
        /**
     * The number of points that can be drawn before a polygon ring or line string
     * is finished. The default is no restriction.
     * @type {number}
     * @private
     */ this.maxPoints_ = this.mode_ === 'Circle' ? 2 : options.maxPoints ? options.maxPoints : Infinity;
        /**
     * A function to decide if a potential finish coordinate is permissible
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.finishCondition_ = options.finishCondition ? options.finishCondition : (0, $bc15bca7780ad95b$export$22e23a2304399231);
        /**
     * @private
     * @type {import("../geom/Geometry.js").GeometryLayout}
     */ this.geometryLayout_ = options.geometryLayout ? options.geometryLayout : 'XY';
        let geometryFunction = options.geometryFunction;
        if (!geometryFunction) {
            const mode = this.mode_;
            if (mode === 'Circle') /**
         * @param {!LineCoordType} coordinates The coordinates.
         * @param {import("../geom/SimpleGeometry.js").default|undefined} geometry Optional geometry.
         * @param {import("../proj/Projection.js").default} projection The view projection.
         * @return {import("../geom/SimpleGeometry.js").default} A geometry.
         */ geometryFunction = (coordinates, geometry, projection)=>{
                const circle = geometry ? /** @type {Circle} */ geometry : new (0, $0c02e7a8e145dce8$export$2e2bcd8739ae039)([
                    NaN,
                    NaN
                ]);
                const center = (0, $a86eee1c28205a05$export$d4b8ec0b96db1ee2)(coordinates[0], projection);
                const squaredLength = (0, $a6adb03fd2fbc071$export$88e6ebb4fe54f538)(center, (0, $a86eee1c28205a05$export$d4b8ec0b96db1ee2)(coordinates[coordinates.length - 1], projection));
                circle.setCenterAndRadius(center, Math.sqrt(squaredLength), this.geometryLayout_);
                const userProjection = (0, $a86eee1c28205a05$export$3973b77d5f6f2790)();
                if (userProjection) circle.transform(projection, userProjection);
                return circle;
            };
            else {
                let Constructor;
                if (mode === 'Point') Constructor = (0, $3153df5f3993c8ca$export$2e2bcd8739ae039);
                else if (mode === 'LineString') Constructor = (0, $197b31f867e63891$export$2e2bcd8739ae039);
                else if (mode === 'Polygon') Constructor = (0, $52cb54ac72de6b07$export$2e2bcd8739ae039);
                /**
         * @param {!LineCoordType} coordinates The coordinates.
         * @param {import("../geom/SimpleGeometry.js").default|undefined} geometry Optional geometry.
         * @param {import("../proj/Projection.js").default} projection The view projection.
         * @return {import("../geom/SimpleGeometry.js").default} A geometry.
         */ geometryFunction = (coordinates, geometry, projection)=>{
                    if (geometry) {
                        if (mode === 'Polygon') {
                            if (coordinates[0].length) // Add a closing coordinate to match the first
                            geometry.setCoordinates([
                                coordinates[0].concat([
                                    coordinates[0][0]
                                ])
                            ], this.geometryLayout_);
                            else geometry.setCoordinates([], this.geometryLayout_);
                        } else geometry.setCoordinates(coordinates, this.geometryLayout_);
                    } else geometry = new Constructor(coordinates, this.geometryLayout_);
                    return geometry;
                };
            }
        }
        /**
     * @type {GeometryFunction}
     * @private
     */ this.geometryFunction_ = geometryFunction;
        /**
     * @type {number}
     * @private
     */ this.dragVertexDelay_ = options.dragVertexDelay !== undefined ? options.dragVertexDelay : 500;
        /**
     * Finish coordinate for the feature (first point for polygons, last point for
     * linestrings).
     * @type {import("../coordinate.js").Coordinate}
     * @private
     */ this.finishCoordinate_ = null;
        /**
     * Sketch feature.
     * @type {Feature<import('../geom/SimpleGeometry.js').default>}
     * @private
     */ this.sketchFeature_ = null;
        /**
     * Sketch point.
     * @type {Feature<Point>}
     * @private
     */ this.sketchPoint_ = null;
        /**
     * Sketch coordinates. Used when drawing a line or polygon.
     * @type {SketchCoordType}
     * @private
     */ this.sketchCoords_ = null;
        /**
     * Sketch line. Used when drawing polygon.
     * @type {Feature<LineString>}
     * @private
     */ this.sketchLine_ = null;
        /**
     * Sketch line coordinates. Used when drawing a polygon or circle.
     * @type {LineCoordType}
     * @private
     */ this.sketchLineCoords_ = null;
        /**
     * Squared tolerance for handling up events.  If the squared distance
     * between a down and up event is greater than this tolerance, up events
     * will not be handled.
     * @type {number}
     * @private
     */ this.squaredClickTolerance_ = options.clickTolerance ? options.clickTolerance * options.clickTolerance : 36;
        /**
     * Draw overlay where our sketch features are drawn.
     * @type {VectorLayer}
     * @private
     */ this.overlay_ = new (0, $082a79ecb622f84a$export$2e2bcd8739ae039)({
            source: new (0, $1020e4d07ddbfab1$export$2e2bcd8739ae039)({
                useSpatialIndex: false,
                wrapX: options.wrapX ? options.wrapX : false
            }),
            style: options.style ? options.style : $2ef894158a48397d$var$getDefaultStyleFunction(),
            updateWhileInteracting: true
        });
        /**
     * Name of the geometry attribute for newly created features.
     * @type {string|undefined}
     * @private
     */ this.geometryName_ = options.geometryName;
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.condition ? options.condition : (0, $638912a122b4daef$export$fdc892d0d8fe3bfb);
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.freehandCondition_;
        if (options.freehand) this.freehandCondition_ = (0, $638912a122b4daef$export$ba9e5d519bc326ca);
        else this.freehandCondition_ = options.freehandCondition ? options.freehandCondition : (0, $638912a122b4daef$export$5d31fe68a477cfbb);
        /**
     * @type {import("../events/condition.js").Condition}
     * @private
     */ this.traceCondition_;
        this.setTrace(options.trace || false);
        /**
     * @type {TraceState}
     * @private
     */ this.traceState_ = {
            active: false
        };
        /**
     * @type {VectorSource|null}
     * @private
     */ this.traceSource_ = options.traceSource || options.source || null;
        this.addChangeListener((0, $273e59fcc49a5e15$export$2e2bcd8739ae039).ACTIVE, this.updateState_);
    }
    /**
   * Toggle tracing mode or set a tracing condition.
   *
   * @param {boolean|import("../events/condition.js").Condition} trace A boolean to toggle tracing mode or an event
   *     condition that will be checked when a feature is clicked to determine if tracing should be active.
   */ setTrace(trace) {
        let condition;
        if (!trace) condition = (0, $638912a122b4daef$export$b3e22bcfd64c1022);
        else if (trace === true) condition = (0, $638912a122b4daef$export$ba9e5d519bc326ca);
        else condition = trace;
        this.traceCondition_ = condition;
    }
    /**
   * Remove the interaction from its current map and attach it to the new map.
   * Subclasses may set up event handlers to get notified about changes to
   * the map here.
   * @param {import("../Map.js").default} map Map.
   * @override
   */ setMap(map) {
        super.setMap(map);
        this.updateState_();
    }
    /**
   * Set whether the drawing is done in freehand mode.
   *
   * @param {boolean} freehand Freehand drawing.
   * @api
   */ setFreehand(freehand) {
        this.freehand_ = freehand;
        if (this.freehand_) this.freehandCondition_ = (0, $638912a122b4daef$export$ba9e5d519bc326ca);
        else this.freehandCondition_ = this.options_ && this.options_.freehandCondition ? this.options_.freehandCondition : (0, $638912a122b4daef$export$5d31fe68a477cfbb);
    }
    /**
   * Get the overlay layer that this interaction renders sketch features to.
   * @return {VectorLayer} Overlay layer.
   * @api
   */ getOverlay() {
        return this.overlay_;
    }
    /**
   * Get if this interaction is in freehand mode.
   * @return {boolean} Freehand drawing.
   * @api
   */ getFreehand() {
        return this.freehand_;
    }
    /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} and may actually draw or finish the drawing.
   * @param {import("../MapBrowserEvent.js").default<PointerEvent>} event Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @api
   * @override
   */ handleEvent(event) {
        if (event.originalEvent.type === (0, $b5fa963342da4935$export$2e2bcd8739ae039).CONTEXTMENU) // Avoid context menu for long taps when drawing on mobile
        event.originalEvent.preventDefault();
        this.freehand_ = this.mode_ !== 'Point' && this.freehandCondition_(event);
        let move = event.type === (0, $1b4cb51f4587f284$export$2e2bcd8739ae039).POINTERMOVE;
        let pass = true;
        if (!this.freehand_ && this.lastDragTime_ && event.type === (0, $1b4cb51f4587f284$export$2e2bcd8739ae039).POINTERDRAG) {
            const now = Date.now();
            if (now - this.lastDragTime_ >= this.dragVertexDelay_) {
                this.downPx_ = event.pixel;
                this.shouldHandle_ = !this.freehand_;
                move = true;
            } else this.lastDragTime_ = undefined;
            if (this.shouldHandle_ && this.downTimeout_ !== undefined) {
                clearTimeout(this.downTimeout_);
                this.downTimeout_ = undefined;
            }
        }
        if (this.freehand_ && event.type === (0, $1b4cb51f4587f284$export$2e2bcd8739ae039).POINTERDRAG && this.sketchFeature_ !== null) {
            this.addToDrawing_(event.coordinate);
            pass = false;
        } else if (this.freehand_ && event.type === (0, $1b4cb51f4587f284$export$2e2bcd8739ae039).POINTERDOWN) pass = false;
        else if (move && this.getPointerCount() < 2) {
            pass = event.type === (0, $1b4cb51f4587f284$export$2e2bcd8739ae039).POINTERMOVE;
            if (pass && this.freehand_) {
                this.handlePointerMove_(event);
                if (this.shouldHandle_) // Avoid page scrolling when freehand drawing on mobile
                event.originalEvent.preventDefault();
            } else if (event.originalEvent.pointerType === 'mouse' || event.type === (0, $1b4cb51f4587f284$export$2e2bcd8739ae039).POINTERDRAG && this.downTimeout_ === undefined) this.handlePointerMove_(event);
        } else if (event.type === (0, $1b4cb51f4587f284$export$2e2bcd8739ae039).DBLCLICK) pass = false;
        return super.handleEvent(event) && pass;
    }
    /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default<PointerEvent>} event Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleDownEvent(event) {
        this.shouldHandle_ = !this.freehand_;
        if (this.freehand_) {
            this.downPx_ = event.pixel;
            if (!this.finishCoordinate_) this.startDrawing_(event.coordinate);
            return true;
        }
        if (!this.condition_(event)) {
            this.lastDragTime_ = undefined;
            return false;
        }
        this.lastDragTime_ = Date.now();
        this.downTimeout_ = setTimeout(()=>{
            this.handlePointerMove_(new (0, $1e9a92005e196af9$export$2e2bcd8739ae039)((0, $1b4cb51f4587f284$export$2e2bcd8739ae039).POINTERMOVE, event.map, event.originalEvent, false, event.frameState));
        }, this.dragVertexDelay_);
        this.downPx_ = event.pixel;
        return true;
    }
    /**
   * @private
   */ deactivateTrace_() {
        this.traceState_ = {
            active: false
        };
    }
    /**
   * Activate or deactivate trace state based on a browser event.
   * @param {import("../MapBrowserEvent.js").default} event Event.
   * @private
   */ toggleTraceState_(event) {
        if (!this.traceSource_ || !this.traceCondition_(event)) return;
        if (this.traceState_.active) {
            this.deactivateTrace_();
            return;
        }
        const map = this.getMap();
        const lowerLeft = map.getCoordinateFromPixel([
            event.pixel[0] - this.snapTolerance_,
            event.pixel[1] + this.snapTolerance_
        ]);
        const upperRight = map.getCoordinateFromPixel([
            event.pixel[0] + this.snapTolerance_,
            event.pixel[1] - this.snapTolerance_
        ]);
        const extent = (0, $dea65c2f666fa450$export$8aceca7c77505534)([
            lowerLeft,
            upperRight
        ]);
        const features = this.traceSource_.getFeaturesInExtent(extent);
        if (features.length === 0) return;
        const targets = (0, $0a2478def9b60c71$export$8b36095f6110ee8f)(event.coordinate, features);
        if (targets.length) this.traceState_ = {
            active: true,
            startCoord: event.coordinate.slice(),
            targets: targets,
            targetIndex: -1
        };
    }
    /**
   * @param {TraceTarget} target The trace target.
   * @param {number} endIndex The new end index of the trace.
   * @private
   */ addOrRemoveTracedCoordinates_(target, endIndex) {
        // three cases to handle:
        //  1. traced in the same direction and points need adding
        //  2. traced in the same direction and points need removing
        //  3. traced in a new direction
        const previouslyForward = target.startIndex <= target.endIndex;
        const currentlyForward = target.startIndex <= endIndex;
        if (previouslyForward === currentlyForward) {
            // same direction
            if (previouslyForward && endIndex > target.endIndex || !previouslyForward && endIndex < target.endIndex) // case 1 - add new points
            this.addTracedCoordinates_(target, target.endIndex, endIndex);
            else if (previouslyForward && endIndex < target.endIndex || !previouslyForward && endIndex > target.endIndex) // case 2 - remove old points
            this.removeTracedCoordinates_(endIndex, target.endIndex);
        } else {
            // case 3 - remove old points, add new points
            this.removeTracedCoordinates_(target.startIndex, target.endIndex);
            this.addTracedCoordinates_(target, target.startIndex, endIndex);
        }
    }
    /**
   * @param {number} fromIndex The start index.
   * @param {number} toIndex The end index.
   * @private
   */ removeTracedCoordinates_(fromIndex, toIndex) {
        if (fromIndex === toIndex) return;
        let remove = 0;
        if (fromIndex < toIndex) {
            const start = Math.ceil(fromIndex);
            let end = Math.floor(toIndex);
            if (end === toIndex) end -= 1;
            remove = end - start + 1;
        } else {
            const start = Math.floor(fromIndex);
            let end = Math.ceil(toIndex);
            if (end === toIndex) end += 1;
            remove = start - end + 1;
        }
        if (remove > 0) this.removeLastPoints_(remove);
    }
    /**
   * @param {TraceTarget} target The trace target.
   * @param {number} fromIndex The start index.
   * @param {number} toIndex The end index.
   * @private
   */ addTracedCoordinates_(target, fromIndex, toIndex) {
        if (fromIndex === toIndex) return;
        const coordinates = [];
        if (fromIndex < toIndex) {
            // forward trace
            const start = Math.ceil(fromIndex);
            let end = Math.floor(toIndex);
            if (end === toIndex) // if end is snapped to a vertex, it will be added later
            end -= 1;
            for(let i = start; i <= end; ++i)coordinates.push((0, $0a2478def9b60c71$export$2028164776634ba)(target.coordinates, i));
        } else {
            // reverse trace
            const start = Math.floor(fromIndex);
            let end = Math.ceil(toIndex);
            if (end === toIndex) end += 1;
            for(let i = start; i >= end; --i)coordinates.push((0, $0a2478def9b60c71$export$2028164776634ba)(target.coordinates, i));
        }
        if (coordinates.length) this.appendCoordinates(coordinates);
    }
    /**
   * Update the trace.
   * @param {import("../MapBrowserEvent.js").default} event Event.
   * @private
   */ updateTrace_(event) {
        const traceState = this.traceState_;
        if (!traceState.active) return;
        if (traceState.targetIndex === -1) {
            // check if we are ready to pick a target
            const startPx = event.map.getPixelFromCoordinate(traceState.startCoord);
            if ((0, $a6adb03fd2fbc071$export$9f17032d917177de)(startPx, event.pixel) < this.snapTolerance_) return;
        }
        const updatedTraceTarget = (0, $0a2478def9b60c71$export$4a6978e1933d7fa)(event.coordinate, traceState, this.getMap(), this.snapTolerance_);
        if (traceState.targetIndex !== updatedTraceTarget.index) {
            // target changed
            if (traceState.targetIndex !== -1) {
                // remove points added during previous trace
                const oldTarget = traceState.targets[traceState.targetIndex];
                this.removeTracedCoordinates_(oldTarget.startIndex, oldTarget.endIndex);
            }
            // add points for the new target
            const newTarget = traceState.targets[updatedTraceTarget.index];
            this.addTracedCoordinates_(newTarget, newTarget.startIndex, updatedTraceTarget.endIndex);
        } else {
            // target stayed the same
            const target = traceState.targets[traceState.targetIndex];
            this.addOrRemoveTracedCoordinates_(target, updatedTraceTarget.endIndex);
        }
        // modify the state with updated info
        traceState.targetIndex = updatedTraceTarget.index;
        const target = traceState.targets[traceState.targetIndex];
        target.endIndex = updatedTraceTarget.endIndex;
        // update event coordinate and pixel to match end point of final segment
        const coordinate = (0, $0a2478def9b60c71$export$46d85ac2b3f8e419)(target.coordinates, target.endIndex);
        const pixel = this.getMap().getPixelFromCoordinate(coordinate);
        event.coordinate = coordinate;
        event.pixel = [
            Math.round(pixel[0]),
            Math.round(pixel[1])
        ];
    }
    /**
   * Handle drag events.
   * @param {import("../MapBrowserEvent.js").default<PointerEvent>} event Event.
   * @override
   */ handleDragEvent(event) {
        this.ignoreNextUpEvent_ = true;
        super.handleDragEvent(event);
    }
    /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default<PointerEvent>} event Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleUpEvent(event) {
        let pass = true;
        if (this.getPointerCount() === 0) {
            if (this.downTimeout_) {
                clearTimeout(this.downTimeout_);
                this.downTimeout_ = undefined;
            }
            this.handlePointerMove_(event);
            const tracing = this.traceState_.active;
            if (!this.ignoreNextUpEvent_) this.toggleTraceState_(event);
            if (this.shouldHandle_) {
                const startingToDraw = !this.finishCoordinate_;
                if (startingToDraw) this.startDrawing_(event.coordinate);
                if (!startingToDraw && this.freehand_) this.finishDrawing();
                else if (!this.freehand_ && (!startingToDraw || this.mode_ === 'Point')) {
                    if (this.atFinish_(event.pixel, tracing)) {
                        if (this.finishCondition_(event)) this.finishDrawing();
                    } else this.addToDrawing_(event.coordinate);
                }
                pass = false;
            } else if (this.freehand_) this.abortDrawing();
        }
        this.ignoreNextUpEvent_ = false;
        if (!pass && this.stopClick_) event.preventDefault();
        return pass;
    }
    /**
   * Handle move events.
   * @param {import("../MapBrowserEvent.js").default<PointerEvent>} event A move event.
   * @private
   */ handlePointerMove_(event) {
        this.pointerType_ = event.originalEvent.pointerType;
        if (this.downPx_ && (!this.freehand_ && this.shouldHandle_ || this.freehand_ && !this.shouldHandle_)) {
            const downPx = this.downPx_;
            const clickPx = event.pixel;
            const dx = downPx[0] - clickPx[0];
            const dy = downPx[1] - clickPx[1];
            const squaredDistance = dx * dx + dy * dy;
            this.shouldHandle_ = this.freehand_ ? squaredDistance > this.squaredClickTolerance_ : squaredDistance <= this.squaredClickTolerance_;
            if (!this.shouldHandle_) return;
        }
        if (!this.finishCoordinate_) {
            this.createOrUpdateSketchPoint_(event.coordinate.slice());
            return;
        }
        this.updateTrace_(event);
        this.modifyDrawing_(event.coordinate);
    }
    /**
   * Determine if an event is within the snapping tolerance of the start coord.
   * @param {import("../pixel.js").Pixel} pixel Pixel.
   * @param {boolean} [tracing] Drawing in trace mode (only stop if at the starting point).
   * @return {boolean} The event is within the snapping tolerance of the start.
   * @private
   */ atFinish_(pixel, tracing) {
        let at = false;
        if (this.sketchFeature_) {
            let potentiallyDone = false;
            let potentiallyFinishCoordinates = [
                this.finishCoordinate_
            ];
            const mode = this.mode_;
            if (mode === 'Point') at = true;
            else if (mode === 'Circle') at = this.sketchCoords_.length === 2;
            else if (mode === 'LineString') potentiallyDone = !tracing && this.sketchCoords_.length > this.minPoints_;
            else if (mode === 'Polygon') {
                const sketchCoords = /** @type {PolyCoordType} */ this.sketchCoords_;
                potentiallyDone = sketchCoords[0].length > this.minPoints_;
                potentiallyFinishCoordinates = [
                    sketchCoords[0][0],
                    sketchCoords[0][sketchCoords[0].length - 2]
                ];
                if (tracing) potentiallyFinishCoordinates = [
                    sketchCoords[0][0]
                ];
                else potentiallyFinishCoordinates = [
                    sketchCoords[0][0],
                    sketchCoords[0][sketchCoords[0].length - 2]
                ];
            }
            if (potentiallyDone) {
                const map = this.getMap();
                for(let i = 0, ii = potentiallyFinishCoordinates.length; i < ii; i++){
                    const finishCoordinate = potentiallyFinishCoordinates[i];
                    const finishPixel = map.getPixelFromCoordinate(finishCoordinate);
                    const dx = pixel[0] - finishPixel[0];
                    const dy = pixel[1] - finishPixel[1];
                    const snapTolerance = this.freehand_ ? 1 : this.snapTolerance_;
                    at = Math.sqrt(dx * dx + dy * dy) <= snapTolerance;
                    if (at) {
                        this.finishCoordinate_ = finishCoordinate;
                        break;
                    }
                }
            }
        }
        return at;
    }
    /**
   * @param {import("../coordinate").Coordinate} coordinates Coordinate.
   * @private
   */ createOrUpdateSketchPoint_(coordinates) {
        if (!this.sketchPoint_) {
            this.sketchPoint_ = new (0, $df26d2327ced1fa9$export$2e2bcd8739ae039)(new (0, $3153df5f3993c8ca$export$2e2bcd8739ae039)(coordinates));
            this.updateSketchFeatures_();
        } else {
            const sketchPointGeom = this.sketchPoint_.getGeometry();
            sketchPointGeom.setCoordinates(coordinates);
        }
    }
    /**
   * @param {import("../geom/Polygon.js").default} geometry Polygon geometry.
   * @private
   */ createOrUpdateCustomSketchLine_(geometry) {
        if (!this.sketchLine_) this.sketchLine_ = new (0, $df26d2327ced1fa9$export$2e2bcd8739ae039)();
        const ring = geometry.getLinearRing(0);
        let sketchLineGeom = this.sketchLine_.getGeometry();
        if (!sketchLineGeom) {
            sketchLineGeom = new (0, $197b31f867e63891$export$2e2bcd8739ae039)(ring.getFlatCoordinates(), ring.getLayout());
            this.sketchLine_.setGeometry(sketchLineGeom);
        } else {
            sketchLineGeom.setFlatCoordinates(ring.getLayout(), ring.getFlatCoordinates());
            sketchLineGeom.changed();
        }
    }
    /**
   * Start the drawing.
   * @param {import("../coordinate.js").Coordinate} start Start coordinate.
   * @private
   */ startDrawing_(start) {
        const projection = this.getMap().getView().getProjection();
        const stride = (0, $6773c3d7448f46a9$export$6af0c1b4a8549a43)(this.geometryLayout_);
        while(start.length < stride)start.push(0);
        this.finishCoordinate_ = start;
        if (this.mode_ === 'Point') this.sketchCoords_ = start.slice();
        else if (this.mode_ === 'Polygon') {
            this.sketchCoords_ = [
                [
                    start.slice(),
                    start.slice()
                ]
            ];
            this.sketchLineCoords_ = this.sketchCoords_[0];
        } else this.sketchCoords_ = [
            start.slice(),
            start.slice()
        ];
        if (this.sketchLineCoords_) this.sketchLine_ = new (0, $df26d2327ced1fa9$export$2e2bcd8739ae039)(new (0, $197b31f867e63891$export$2e2bcd8739ae039)(this.sketchLineCoords_));
        const geometry = this.geometryFunction_(this.sketchCoords_, undefined, projection);
        this.sketchFeature_ = new (0, $df26d2327ced1fa9$export$2e2bcd8739ae039)();
        if (this.geometryName_) this.sketchFeature_.setGeometryName(this.geometryName_);
        this.sketchFeature_.setGeometry(geometry);
        this.updateSketchFeatures_();
        this.dispatchEvent(new $2ef894158a48397d$export$85a4910380d251a7($2ef894158a48397d$var$DrawEventType.DRAWSTART, this.sketchFeature_));
    }
    /**
   * Modify the drawing.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @private
   */ modifyDrawing_(coordinate) {
        const map = this.getMap();
        const geometry = this.sketchFeature_.getGeometry();
        const projection = map.getView().getProjection();
        const stride = (0, $6773c3d7448f46a9$export$6af0c1b4a8549a43)(this.geometryLayout_);
        let coordinates, last;
        while(coordinate.length < stride)coordinate.push(0);
        if (this.mode_ === 'Point') last = this.sketchCoords_;
        else if (this.mode_ === 'Polygon') {
            coordinates = /** @type {PolyCoordType} */ this.sketchCoords_[0];
            last = coordinates[coordinates.length - 1];
            if (this.atFinish_(map.getPixelFromCoordinate(coordinate))) // snap to finish
            coordinate = this.finishCoordinate_.slice();
        } else {
            coordinates = this.sketchCoords_;
            last = coordinates[coordinates.length - 1];
        }
        last[0] = coordinate[0];
        last[1] = coordinate[1];
        this.geometryFunction_(/** @type {!LineCoordType} */ this.sketchCoords_, geometry, projection);
        if (this.sketchPoint_) {
            const sketchPointGeom = this.sketchPoint_.getGeometry();
            sketchPointGeom.setCoordinates(coordinate);
        }
        if (geometry.getType() === 'Polygon' && this.mode_ !== 'Polygon') this.createOrUpdateCustomSketchLine_(/** @type {Polygon} */ geometry);
        else if (this.sketchLineCoords_) {
            const sketchLineGeom = this.sketchLine_.getGeometry();
            sketchLineGeom.setCoordinates(this.sketchLineCoords_);
        }
        this.updateSketchFeatures_();
    }
    /**
   * Add a new coordinate to the drawing.
   * @param {!PointCoordType} coordinate Coordinate
   * @return {Feature<import("../geom/SimpleGeometry.js").default>} The sketch feature.
   * @private
   */ addToDrawing_(coordinate) {
        const geometry = this.sketchFeature_.getGeometry();
        const projection = this.getMap().getView().getProjection();
        let done;
        let coordinates;
        const mode = this.mode_;
        if (mode === 'LineString' || mode === 'Circle') {
            this.finishCoordinate_ = coordinate.slice();
            coordinates = /** @type {LineCoordType} */ this.sketchCoords_;
            if (coordinates.length >= this.maxPoints_) {
                if (this.freehand_) coordinates.pop();
                else done = true;
            }
            coordinates.push(coordinate.slice());
            this.geometryFunction_(coordinates, geometry, projection);
        } else if (mode === 'Polygon') {
            coordinates = /** @type {PolyCoordType} */ this.sketchCoords_[0];
            if (coordinates.length >= this.maxPoints_) {
                if (this.freehand_) coordinates.pop();
                else done = true;
            }
            coordinates.push(coordinate.slice());
            if (done) this.finishCoordinate_ = coordinates[0];
            this.geometryFunction_(this.sketchCoords_, geometry, projection);
        }
        this.createOrUpdateSketchPoint_(coordinate.slice());
        this.updateSketchFeatures_();
        if (done) return this.finishDrawing();
        return this.sketchFeature_;
    }
    /**
   * @param {number} n The number of points to remove.
   */ removeLastPoints_(n) {
        if (!this.sketchFeature_) return;
        const geometry = this.sketchFeature_.getGeometry();
        const projection = this.getMap().getView().getProjection();
        const mode = this.mode_;
        for(let i = 0; i < n; ++i){
            let coordinates;
            if (mode === 'LineString' || mode === 'Circle') {
                coordinates = /** @type {LineCoordType} */ this.sketchCoords_;
                coordinates.splice(-2, 1);
                if (coordinates.length >= 2) {
                    this.finishCoordinate_ = coordinates[coordinates.length - 2].slice();
                    const finishCoordinate = this.finishCoordinate_.slice();
                    coordinates[coordinates.length - 1] = finishCoordinate;
                    this.createOrUpdateSketchPoint_(finishCoordinate);
                }
                this.geometryFunction_(coordinates, geometry, projection);
                if (geometry.getType() === 'Polygon' && this.sketchLine_) this.createOrUpdateCustomSketchLine_(/** @type {Polygon} */ geometry);
            } else if (mode === 'Polygon') {
                coordinates = /** @type {PolyCoordType} */ this.sketchCoords_[0];
                coordinates.splice(-2, 1);
                const sketchLineGeom = this.sketchLine_.getGeometry();
                if (coordinates.length >= 2) {
                    const finishCoordinate = coordinates[coordinates.length - 2].slice();
                    coordinates[coordinates.length - 1] = finishCoordinate;
                    this.createOrUpdateSketchPoint_(finishCoordinate);
                }
                sketchLineGeom.setCoordinates(coordinates);
                this.geometryFunction_(this.sketchCoords_, geometry, projection);
            }
            if (coordinates.length === 1) {
                this.abortDrawing();
                break;
            }
        }
        this.updateSketchFeatures_();
    }
    /**
   * Remove last point of the feature currently being drawn. Does not do anything when
   * drawing POINT or MULTI_POINT geometries.
   * @api
   */ removeLastPoint() {
        this.removeLastPoints_(1);
    }
    /**
   * Stop drawing and add the sketch feature to the target layer.
   * The {@link module:ol/interaction/Draw~DrawEventType.DRAWEND} event is
   * dispatched before inserting the feature.
   * @return {Feature<import("../geom/SimpleGeometry.js").default>|null} The drawn feature.
   * @api
   */ finishDrawing() {
        const sketchFeature = this.abortDrawing_();
        if (!sketchFeature) return null;
        let coordinates = this.sketchCoords_;
        const geometry = sketchFeature.getGeometry();
        const projection = this.getMap().getView().getProjection();
        if (this.mode_ === 'LineString') {
            // remove the redundant last point
            coordinates.pop();
            this.geometryFunction_(coordinates, geometry, projection);
        } else if (this.mode_ === 'Polygon') {
            // remove the redundant last point in ring
            /** @type {PolyCoordType} */ coordinates[0].pop();
            this.geometryFunction_(coordinates, geometry, projection);
            coordinates = geometry.getCoordinates();
        }
        // cast multi-part geometries
        if (this.type_ === 'MultiPoint') sketchFeature.setGeometry(new (0, $1a0594f8edc26022$export$2e2bcd8739ae039)([
            /** @type {PointCoordType} */ coordinates
        ]));
        else if (this.type_ === 'MultiLineString') sketchFeature.setGeometry(new (0, $96d2138ace1f7d2d$export$2e2bcd8739ae039)([
            /** @type {LineCoordType} */ coordinates
        ]));
        else if (this.type_ === 'MultiPolygon') sketchFeature.setGeometry(new (0, $71dd1c600460678c$export$2e2bcd8739ae039)([
            /** @type {PolyCoordType} */ coordinates
        ]));
        // First dispatch event to allow full set up of feature
        this.dispatchEvent(new $2ef894158a48397d$export$85a4910380d251a7($2ef894158a48397d$var$DrawEventType.DRAWEND, sketchFeature));
        // Then insert feature
        if (this.features_) this.features_.push(sketchFeature);
        if (this.source_) this.source_.addFeature(sketchFeature);
        return sketchFeature;
    }
    /**
   * Stop drawing without adding the sketch feature to the target layer.
   * @return {Feature<import("../geom/SimpleGeometry.js").default>|null} The sketch feature (or null if none).
   * @private
   */ abortDrawing_() {
        this.finishCoordinate_ = null;
        const sketchFeature = this.sketchFeature_;
        this.sketchFeature_ = null;
        this.sketchPoint_ = null;
        this.sketchLine_ = null;
        this.overlay_.getSource().clear(true);
        this.deactivateTrace_();
        return sketchFeature;
    }
    /**
   * Stop drawing without adding the sketch feature to the target layer.
   * @api
   */ abortDrawing() {
        const sketchFeature = this.abortDrawing_();
        if (sketchFeature) this.dispatchEvent(new $2ef894158a48397d$export$85a4910380d251a7($2ef894158a48397d$var$DrawEventType.DRAWABORT, sketchFeature));
    }
    /**
   * Append coordinates to the end of the geometry that is currently being drawn.
   * This can be used when drawing LineStrings or Polygons. Coordinates will
   * either be appended to the current LineString or the outer ring of the current
   * Polygon. If no geometry is being drawn, a new one will be created.
   * @param {!LineCoordType} coordinates Linear coordinates to be appended to
   * the coordinate array.
   * @api
   */ appendCoordinates(coordinates) {
        const mode = this.mode_;
        const newDrawing = !this.sketchFeature_;
        if (newDrawing) this.startDrawing_(coordinates[0]);
        /** @type {LineCoordType} */ let sketchCoords;
        if (mode === 'LineString' || mode === 'Circle') sketchCoords = /** @type {LineCoordType} */ this.sketchCoords_;
        else if (mode === 'Polygon') sketchCoords = this.sketchCoords_ && this.sketchCoords_.length ? /** @type {PolyCoordType} */ this.sketchCoords_[0] : [];
        else return;
        if (newDrawing) sketchCoords.shift();
        // Remove last coordinate from sketch drawing (this coordinate follows cursor position)
        sketchCoords.pop();
        // Append coordinate list
        for(let i = 0; i < coordinates.length; i++)this.addToDrawing_(coordinates[i]);
        const ending = coordinates[coordinates.length - 1];
        // Duplicate last coordinate for sketch drawing (cursor position)
        this.sketchFeature_ = this.addToDrawing_(ending);
        this.modifyDrawing_(ending);
    }
    /**
   * Initiate draw mode by starting from an existing geometry which will
   * receive new additional points. This only works on features with
   * `LineString` geometries, where the interaction will extend lines by adding
   * points to the end of the coordinates array.
   * This will change the original feature, instead of drawing a copy.
   *
   * The function will dispatch a `drawstart` event.
   *
   * @param {!Feature<LineString>} feature Feature to be extended.
   * @api
   */ extend(feature) {
        const geometry = feature.getGeometry();
        const lineString = geometry;
        this.sketchFeature_ = feature;
        this.sketchCoords_ = lineString.getCoordinates();
        const last = this.sketchCoords_[this.sketchCoords_.length - 1];
        this.finishCoordinate_ = last.slice();
        this.sketchCoords_.push(last.slice());
        this.sketchPoint_ = new (0, $df26d2327ced1fa9$export$2e2bcd8739ae039)(new (0, $3153df5f3993c8ca$export$2e2bcd8739ae039)(last));
        this.updateSketchFeatures_();
        this.dispatchEvent(new $2ef894158a48397d$export$85a4910380d251a7($2ef894158a48397d$var$DrawEventType.DRAWSTART, this.sketchFeature_));
    }
    /**
   * Redraw the sketch features.
   * @private
   */ updateSketchFeatures_() {
        const sketchFeatures = [];
        if (this.sketchFeature_) sketchFeatures.push(this.sketchFeature_);
        if (this.sketchLine_) sketchFeatures.push(this.sketchLine_);
        if (this.sketchPoint_) sketchFeatures.push(this.sketchPoint_);
        const overlaySource = this.overlay_.getSource();
        overlaySource.clear(true);
        overlaySource.addFeatures(sketchFeatures);
    }
    /**
   * @private
   */ updateState_() {
        const map = this.getMap();
        const active = this.getActive();
        if (!map || !active) this.abortDrawing();
        this.overlay_.setMap(active ? map : null);
    }
}
/**
 * @return {import("../style/Style.js").StyleFunction} Styles.
 */ function $2ef894158a48397d$var$getDefaultStyleFunction() {
    const styles = (0, $a5fc261473972d1d$export$ed1eaede5d0e77ac)();
    return function(feature, resolution) {
        return styles[feature.getGeometry().getType()];
    };
}
function $2ef894158a48397d$export$e636e17021965266(sides, angle) {
    return function(coordinates, geometry, projection) {
        const center = (0, $a86eee1c28205a05$export$d4b8ec0b96db1ee2)(/** @type {LineCoordType} */ coordinates[0], projection);
        const end = (0, $a86eee1c28205a05$export$d4b8ec0b96db1ee2)(/** @type {LineCoordType} */ coordinates[coordinates.length - 1], projection);
        const radius = Math.sqrt((0, $a6adb03fd2fbc071$export$88e6ebb4fe54f538)(center, end));
        geometry = geometry || (0, $52cb54ac72de6b07$export$2451009d645fb8c2)(new (0, $0c02e7a8e145dce8$export$2e2bcd8739ae039)(center), sides);
        let internalAngle = angle;
        if (!angle && angle !== 0) {
            const x = end[0] - center[0];
            const y = end[1] - center[1];
            internalAngle = Math.atan2(y, x);
        }
        (0, $52cb54ac72de6b07$export$87d6a1539a56e47f)(/** @type {Polygon} */ geometry, center, radius, internalAngle);
        const userProjection = (0, $a86eee1c28205a05$export$3973b77d5f6f2790)();
        if (userProjection) geometry.transform(projection, userProjection);
        return geometry;
    };
}
function $2ef894158a48397d$export$6459fc9e86be362e() {
    return function(coordinates, geometry, projection) {
        const extent = (0, $dea65c2f666fa450$export$8aceca7c77505534)(/** @type {LineCoordType} */ [
            coordinates[0],
            coordinates[coordinates.length - 1]
        ].map(function(coordinate) {
            return (0, $a86eee1c28205a05$export$d4b8ec0b96db1ee2)(coordinate, projection);
        }));
        const boxCoordinates = [
            [
                (0, $dea65c2f666fa450$export$8d09f5e2e1bf560d)(extent),
                (0, $dea65c2f666fa450$export$e77c1cf70445e168)(extent),
                (0, $dea65c2f666fa450$export$b84fa077c8b05295)(extent),
                (0, $dea65c2f666fa450$export$cb1538b07e6964ff)(extent),
                (0, $dea65c2f666fa450$export$8d09f5e2e1bf560d)(extent)
            ]
        ];
        if (geometry) geometry.setCoordinates(boxCoordinates);
        else geometry = new (0, $52cb54ac72de6b07$export$2e2bcd8739ae039)(boxCoordinates);
        const userProjection = (0, $a86eee1c28205a05$export$3973b77d5f6f2790)();
        if (userProjection) geometry.transform(projection, userProjection);
        return geometry;
    };
}
/**
 * Get the drawing mode.  The mode for multi-part geometries is the same as for
 * their single-part cousins.
 * @param {import("../geom/Geometry.js").Type} type Geometry type.
 * @return {Mode} Drawing mode.
 */ function $2ef894158a48397d$var$getMode(type) {
    switch(type){
        case 'Point':
        case 'MultiPoint':
            return 'Point';
        case 'LineString':
        case 'MultiLineString':
            return 'LineString';
        case 'Polygon':
        case 'MultiPolygon':
            return 'Polygon';
        case 'Circle':
            return 'Circle';
        default:
            throw new Error('Invalid type: ' + type);
    }
}
var $2ef894158a48397d$export$2e2bcd8739ae039 = $2ef894158a48397d$var$Draw;










var $kc00y = parcelRequire("kc00y");


var $kc00y = parcelRequire("kc00y");


"use client";
const $a43e6f68e14bab96$var$ButtonGroup = /*#__PURE__*/ $kc00y.forwardRef(({ bsPrefix: bsPrefix, size: size, vertical: vertical = false, className: className, role: role = 'group', // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...rest }, ref)=>{
    const prefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(bsPrefix, 'btn-group');
    let baseClass = prefix;
    if (vertical) baseClass = `${prefix}-vertical`;
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)(Component, {
        ...rest,
        ref: ref,
        role: role,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, baseClass, size && `${prefix}-${size}`)
    });
});
$a43e6f68e14bab96$var$ButtonGroup.displayName = 'ButtonGroup';
var $a43e6f68e14bab96$export$2e2bcd8739ae039 = $a43e6f68e14bab96$var$ButtonGroup;



var $kc00y = parcelRequire("kc00y");


"use client";
const $669f9c52e6081841$var$ButtonToolbar = /*#__PURE__*/ $kc00y.forwardRef(({ bsPrefix: bsPrefix, className: className, role: role = 'toolbar', ...props }, ref)=>{
    const prefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(bsPrefix, 'btn-toolbar');
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, prefix),
        role: role
    });
});
$669f9c52e6081841$var$ButtonToolbar.displayName = 'ButtonToolbar';
var $669f9c52e6081841$export$2e2bcd8739ae039 = $669f9c52e6081841$var$ButtonToolbar;







var $kc00y = parcelRequire("kc00y");


const $a1d50030dc0bb103$var$AccesRapideTypeahead = ({ label: label, queryUrl: queryUrl, setter: setter, dependentObject: dependentObject, className: className })=>{
    const [motif, setMotif] = (0, $kc00y.useState)("");
    const queryParams = {
        motifLibelle: motif
    };
    const [state, setState] = (0, $kc00y.useState)({
        isLoading: false,
        options: []
    });
    if (dependentObject) queryParams.dependenceObjId = dependentObject.id;
    const queryString = motif ? `${queryUrl}?${new URLSearchParams(queryParams).toString()}` : null;
    const { data: data, run: run, isResolved: isResolved } = (0, $8d9ebd8892d8a5f5$export$6326fb4463ae1be4)(queryString || "");
    (0, $kc00y.useEffect)(()=>{
        if (motif.length > 0) {
            setState((prevState)=>({
                    ...prevState,
                    isLoading: true
                }));
            run();
        }
    }, [
        motif,
        run
    ]);
    (0, $kc00y.useEffect)(()=>{
        if (isResolved) setState(()=>({
                isLoading: false,
                options: data || []
            }));
    }, [
        isResolved,
        data
    ]);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $64bc064c742d3abb$export$2e2bcd8739ae039), {
        className: className,
        minLength: 2,
        placeholder: label,
        emptyLabel: "Aucun r\xe9sultat",
        promptText: "Saisissez au moins 2 lettres",
        searchText: "Recherche en cours",
        isLoading: state.isLoading,
        labelKey: "libelle",
        options: state.options,
        onSearch: (query)=>{
            if (query.length < 2) // des communes de 2 caractères existent
            return;
            setMotif(query);
        },
        onChange: (value)=>{
            if (value.length > 0) setter(value[0]);
            else setter(null);
        }
    });
};
var $a1d50030dc0bb103$export$2e2bcd8739ae039 = $a1d50030dc0bb103$var$AccesRapideTypeahead;













var $kc00y = parcelRequire("kc00y");



function $83829b7d3cf4e8d9$var$findMetadataById(coucheMetadata, coucheId) {
    return coucheMetadata.find((metadata)=>metadata.coucheId === coucheId) ?? null;
}
// Remplace les #clé# du style par leur valeur, et supprime la ligne si la valeur est vide.
function $83829b7d3cf4e8d9$var$resolveTemplatePlaceholders(template, properties) {
    return template.replace(/^.*#(.*?)#.*$/gm, (line, key)=>{
        const value = properties[key];
        if (value === undefined || value === null || value === "") return "";
        return line.replace(`#${key}#`, String(value));
    });
}
// Transforme le texte (déjà résolu) en éléments React en interprétant [b]/[i]/[u]/[br].
function $83829b7d3cf4e8d9$var$renderStyledTemplate(text) {
    const tokens = text.split(/(\[\/?(?:b|i|u|br)\])/);
    const openTags = [];
    const elements = [];
    let buffer = [];
    const flushBuffer = ()=>{
        if (buffer.length === 0) return;
        let wrapped = buffer;
        for(let i = openTags.length - 1; i >= 0; i--){
            const key = `${elements.length}-${i}`;
            switch(openTags[i]){
                case "b":
                    wrapped = [
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("b", {
                            children: wrapped
                        }, key)
                    ];
                    break;
                case "i":
                    wrapped = [
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("i", {
                            children: wrapped
                        }, key)
                    ];
                    break;
                case "u":
                    wrapped = [
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("u", {
                            children: wrapped
                        }, key)
                    ];
                    break;
            }
        }
        elements.push(...wrapped);
        buffer = [];
    };
    for (const token of tokens){
        if (token === "[br]") {
            flushBuffer();
            elements.push(/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}, elements.length));
        } else if (token === "[b]" || token === "[i]" || token === "[u]") {
            flushBuffer();
            openTags.push(token.slice(1, -1));
        } else if (token === "[/b]" || token === "[/i]" || token === "[/u]") {
            flushBuffer();
            openTags.pop();
        } else if (token !== "") buffer.push(token);
    }
    flushBuffer();
    return elements;
}
// Applique le style complet (texte + mise en forme) sur les propriétés d'une feature.
function $83829b7d3cf4e8d9$var$applyStyleTemplate(template, properties) {
    const resolved = $83829b7d3cf4e8d9$var$resolveTemplatePlaceholders(template, properties);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
        children: $83829b7d3cf4e8d9$var$renderStyledTemplate(resolved)
    });
}
// Affiche toutes les propriétés brutes d'une feature (vue superadmin).
function $83829b7d3cf4e8d9$var$renderRawProperties(properties) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
        children: Object.keys(properties).map((key, idx)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("b", {
                        children: key.replace(/_/g, " ")
                    }),
                    ":",
                    " ",
                    JSON.stringify(properties[key] ?? "Non renseign\xe9").replace(/"/g, "")
                ]
            }, idx))
    });
}
// Récupère le nom de couche à partir de l'id GeoServer (format "nomCouche.fid", parfois
// préfixé par un workspace "workspace:nomCouche.fid").
function $83829b7d3cf4e8d9$var$extractLayerNameFromFeatureId(featureId) {
    const id = featureId ?? "";
    const withoutWorkspace = id.includes(":") ? id.split(":").at(-1) : id;
    const lastDotIndex = withoutWorkspace.lastIndexOf(".");
    return lastDotIndex === -1 ? withoutWorkspace : withoutWorkspace.slice(0, lastDotIndex);
}
// Regroupe les features par couche source réelle (via le nom de couche dans feature.id).
// S'il n'y a qu'une seule couche (pas d'agrégat), on obtient un seul groupe.
function $83829b7d3cf4e8d9$var$groupFeaturesByType(features) {
    const groups = new Map();
    for (const feature of features){
        const layerName = $83829b7d3cf4e8d9$var$extractLayerNameFromFeatureId(feature?.id);
        if (!groups.has(layerName)) groups.set(layerName, []);
        groups.get(layerName).push(feature);
    }
    return [
        ...groups.values()
    ];
}
// Fusionne les propriétés de toutes les features (garde la 1ère valeur non vide par clé).
// Sert de socle commun pour compléter les données partagées dans chaque accordéon.
function $83829b7d3cf4e8d9$var$mergePropertiesFirstWins(features) {
    const merged = {};
    for (const feature of features){
        const properties = feature?.properties ?? {};
        for (const key of Object.keys(properties)){
            const value = properties[key];
            if (merged[key] === undefined && value !== undefined && value !== null && value !== "") merged[key] = value;
        }
    }
    return merged;
}
// Construit les accordéons pour une couche (ou un agrégat de couches).
// Ex: 1 commune + 3 réseaux au même endroit => 3 accordéons, la commune étant répétée dans chacun.
function $83829b7d3cf4e8d9$var$buildAccordionItemsForLayer({ featureCollection: featureCollection, coucheMetadata: coucheMetadata, isSuperAdmin: isSuperAdmin }) {
    const features = featureCollection?.features ?? [];
    const coucheId = featureCollection?.id;
    const metadata = coucheId ? $83829b7d3cf4e8d9$var$findMetadataById(coucheMetadata, coucheId) : null;
    const style = metadata?.coucheMetadataStyle;
    const libelle = metadata?.coucheLibelle || null;
    // Si pas de métadonnée, on ignore complètement cette couche, sauf pour le superadmin
    if (!metadata && !isSuperAdmin || features.length === 0) return [];
    const baseHeader = libelle || features[0]?.id?.split(".")?.[0] || coucheId || "Inconnu";
    const groups = $83829b7d3cf4e8d9$var$groupFeaturesByType(features);
    const commonProperties = $83829b7d3cf4e8d9$var$mergePropertiesFirstWins(features);
    // Le nombre d'accordéons = la taille du plus grand groupe (ex: 3 réseaux => 3 accordéons),
    // pas le total de toutes les features (ex: 1 commune + 3 réseaux => 3, pas 4).
    const accordionCount = Math.max(1, ...groups.map((group)=>group.length));
    return Array.from({
        length: accordionCount
    }, (_, accordionIdx)=>{
        // Pour chaque accordéon : une feature par groupe (celle à cet index, ou la 1ère du groupe si trop court,).
        const effectiveProperties = groups.reduce((acc, group)=>{
            const feature = group[accordionIdx] ?? group[0];
            return {
                ...acc,
                ...feature?.properties ?? {}
            };
        }, {
            ...commonProperties
        });
        const header = accordionCount > 1 ? `${baseHeader} (${accordionIdx + 1}/${accordionCount})` : baseHeader;
        if (isSuperAdmin) return {
            header: header,
            content: $83829b7d3cf4e8d9$var$renderRawProperties(effectiveProperties)
        };
        if (style) return {
            header: header,
            content: $83829b7d3cf4e8d9$var$applyStyleTemplate(style, effectiveProperties)
        };
        return {
            header: header,
            content: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                children: "Aucune m\xe9tadonn\xe9e \xe0 afficher param\xe9tr\xe9e"
            })
        };
    });
}
const $83829b7d3cf4e8d9$var$ListInfos = ({ data: data, coucheMetadata: coucheMetadata })=>{
    const { user: user } = (0, $e787cde576104469$export$fdc397e486fa83e7)();
    const [tableau, setTableau] = (0, $kc00y.useState)([]);
    const { activesKeys: activesKeys, handleShowClose: handleShowClose } = (0, $db860d90b4a42fea$export$dae930a4ba30758b)(Array(6).fill(false));
    (0, $kc00y.useEffect)(()=>{
        const isSuperAdmin = Boolean(user?.isSuperAdmin);
        const generatedTableau = data.flatMap((featureCollection)=>$83829b7d3cf4e8d9$var$buildAccordionItemsForLayer({
                featureCollection: featureCollection,
                coucheMetadata: coucheMetadata,
                isSuperAdmin: isSuperAdmin
            }));
        setTableau(generatedTableau);
    }, [
        data,
        coucheMetadata,
        user?.isSuperAdmin
    ]);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: tableau.length === 0 ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
            children: "Aucune donn\xe9e"
        }) : /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db860d90b4a42fea$export$2e2bcd8739ae039), {
            list: tableau,
            activesKeys: activesKeys,
            handleShowClose: handleShowClose
        })
    });
};
var $83829b7d3cf4e8d9$export$2e2bcd8739ae039 = $83829b7d3cf4e8d9$var$ListInfos;


const $f077da3af045a95a$var$OutilIVolet = ({ generalsInfos: generalsInfos, coucheMetadata: coucheMetadata })=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$340bfce9b4df026b), {}),
                title: "Informations",
                displayReturnButton: false
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $83829b7d3cf4e8d9$export$2e2bcd8739ae039), {
                data: generalsInfos,
                coucheMetadata: coucheMetadata
            })
        ]
    });
};
var $f077da3af045a95a$export$2e2bcd8739ae039 = $f077da3af045a95a$var$OutilIVolet;





var $kc00y = parcelRequire("kc00y");





const $be97a61e865d594d$var$AdresseTypeahead = ({ map: map })=>{
    const [state, setState] = (0, $kc00y.useState)({
        isLoading: false,
        options: []
    });
    const apiEpsg = (0, $f740b0d032822ba6$export$ea1a29af61241729); // ESPG utilisée pour data.gouv
    const parametresState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/parametres?${{
        listeParametreCode: JSON.stringify([
            (0, $ee297f06e8568bf4$export$2e2bcd8739ae039).BAN_CODE_DEPARTEMENT
        ])
    }}`);
    const banCodeDepartement = (0, $kc00y.useMemo)(()=>{
        if (!parametresState.isResolved) return undefined;
        return parametresState?.data[(0, $ee297f06e8568bf4$export$2e2bcd8739ae039).BAN_CODE_DEPARTEMENT].parametreValeur;
    }, [
        parametresState
    ]);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $64bc064c742d3abb$export$2e2bcd8739ae039), {
        minLength: 3,
        className: "ms-3",
        placeholder: "Zoomer sur la voie",
        emptyLabel: "Aucun r\xe9sultat",
        promptText: "Saisissez au moins 3 lettres",
        searchText: "Recherche en cours",
        isLoading: state.isLoading,
        options: state.options,
        filterBy: ()=>true // On récupère toutes les options que la requête nous renvoie !
        ,
        labelKey: (feature)=>`${feature.properties.label}`,
        onSearch: (query)=>{
            if (query.length < 2) return;
            const coord4326 = (0, $a86eee1c28205a05$export$51186ad6e864892a)(map.getView().getCenter(), map.getView().getViewStateAndExtent().viewState.projection, apiEpsg);
            setState({
                ...state,
                isLoading: true
            });
            fetch(`https://data.geopf.fr/geocodage/search?q=${query}&lat=${coord4326[0]}&lon=${coord4326[1]}${banCodeDepartement ? `&depcode=${banCodeDepartement}` : ""}`).then((response)=>response.json()).then((json)=>setState({
                    isLoading: false,
                    options: json.features
                }));
        },
        onChange: (features)=>{
            if (features.length === 0) return;
            const coordSource = (0, $a86eee1c28205a05$export$51186ad6e864892a)(features[0].geometry.coordinates, apiEpsg, map.getView().getViewStateAndExtent().viewState.projection);
            map.getView().setCenter(coordSource);
            map.getView().setZoom(map.getView().getZoomForResolution((0, $f740b0d032822ba6$export$aa1e784cdd98af28)));
        },
        style: {
            width: 400
        }
    });
};
var $be97a61e865d594d$export$2e2bcd8739ae039 = $be97a61e865d594d$var$AdresseTypeahead;






var $kc00y = parcelRequire("kc00y");




const $ef04aa6164ff9f18$var$ToponymieTypeBarre = ({ map: map, urlAPI: urlAPI, dependentObject: dependentObject })=>{
    const [state, setState] = (0, $kc00y.useState)({
        isLoading: false,
        options: []
    });
    const { error: errorToast } = (0, $6bdae0bad7b05751$export$91b3d218c74c79e4)();
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $64bc064c742d3abb$export$2e2bcd8739ae039), {
        className: "h-100",
        minLength: 2,
        placeholder: "Zoomer sur le lieu...",
        emptyLabel: "Aucun r\xe9sultat",
        promptText: "Saisissez au moins 2 lettres",
        searchText: "Recherche en cours",
        isLoading: state.isLoading,
        options: state.options,
        labelKey: (feature)=>`${feature.properties.label}`,
        onSearch: (query)=>{
            if (query.length < 2) return;
            setState({
                ...state,
                isLoading: true
            });
            const params = new URLSearchParams();
            params.append("libelle", query);
            if (dependentObject) params.append("dependenceObjId", dependentObject.id);
            fetch(`${urlAPI}/get-toponymies?${params.toString()}`, (0, $fbd4d34e07af0ac7$export$b163ec2f884327db)()).then((response)=>response.json()).then((json)=>{
                const features = json.map((item)=>{
                    const [sridStr, wkt] = item.toponymieGeometrie.split(";");
                    return {
                        type: "Feature",
                        geometry: {
                            type: "Point",
                            // On prend le premier point pour représenter le lieu
                            coordinates: new (0, $15a985d09649bdc2$export$2e2bcd8739ae039)().readGeometry(wkt).getExtent(),
                            srid: sridStr.split("=").pop()
                        },
                        properties: {
                            id: item.toponymieId,
                            label: item.toponymieLibelle
                        }
                    };
                });
                setState({
                    isLoading: false,
                    options: features
                });
            });
        },
        onChange: (features)=>{
            if (features.length === 0) return;
            const feature = features[0];
            if (feature.geometry.srid !== "0") {
                map.getView().fit((0, $a86eee1c28205a05$export$751c68e0e0efff79)(feature.geometry.coordinates, `EPSG:${feature.geometry.srid}`, map.getView().getViewStateAndExtent().viewState.projection));
                map.getView().setZoom(map.getView().getZoomForResolution((0, $f740b0d032822ba6$export$aa1e784cdd98af28)));
            } else errorToast("La g\xe9om\xe9trie pr\xe9sente une anomalie : l'SRID vaut 0.");
        }
    });
};
var $ef04aa6164ff9f18$export$2e2bcd8739ae039 = $ef04aa6164ff9f18$var$ToponymieTypeBarre;





var $kc00y = parcelRequire("kc00y");



"use client";
const $8b78b8a93971307c$var$noop = ()=>undefined;
const $8b78b8a93971307c$var$ToggleButton = /*#__PURE__*/ $kc00y.forwardRef(({ bsPrefix: bsPrefix, name: name, className: className, checked: checked, type: type, onChange: onChange, value: value, disabled: disabled, id: id, inputRef: inputRef, ...props }, ref)=>{
    bsPrefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(bsPrefix, 'btn-check');
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("input", {
                className: bsPrefix,
                name: name,
                type: type,
                value: value,
                ref: inputRef,
                autoComplete: "off",
                checked: !!checked,
                disabled: !!disabled,
                onChange: onChange || $8b78b8a93971307c$var$noop,
                id: id
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                ...props,
                ref: ref,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, disabled && 'disabled'),
                type: undefined,
                role: undefined,
                as: "label",
                htmlFor: id
            })
        ]
    });
});
$8b78b8a93971307c$var$ToggleButton.displayName = 'ToggleButton';
var $8b78b8a93971307c$export$2e2bcd8739ae039 = $8b78b8a93971307c$var$ToggleButton;



const $f2eef644ac9323e0$var$ToolbarButton = ({ toolName: toolName, toolIcon: toolIcon, toolLabelTooltip: toolLabelTooltip, toggleTool: toggleTool, activeTool: activeTool, disabled: disabled = false, variant: variant = "primary" })=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
        tooltipText: toolLabelTooltip,
        tooltipId: toolName,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8b78b8a93971307c$export$2e2bcd8739ae039), {
            name: "tool",
            disabled: disabled,
            onClick: ()=>toggleTool(toolName),
            id: toolName,
            value: toolName,
            type: "radio",
            variant: "outline-" + variant,
            checked: !disabled && activeTool === toolName,
            className: "m-2",
            children: toolIcon
        })
    });
};
var $f2eef644ac9323e0$export$2e2bcd8739ae039 = $f2eef644ac9323e0$var$ToolbarButton;


const $e2b798e23180fa76$var$measureStyle = new (0, $a5fc261473972d1d$export$2e2bcd8739ae039)({
    fill: new (0, $8624b871a0af6dab$export$2e2bcd8739ae039)({
        color: "rgba(255, 255, 255, 0.2)"
    }),
    stroke: new (0, $281691897fddf9d0$export$2e2bcd8739ae039)({
        color: "rgba(255, 0, 0, 0.7)",
        lineDash: [
            10,
            10
        ],
        width: 2
    }),
    image: new (0, $f060542c6e9f52e6$export$2e2bcd8739ae039)({
        radius: 5,
        stroke: new (0, $281691897fddf9d0$export$2e2bcd8739ae039)({
            color: "rgba(0, 0, 0, 0.7)"
        }),
        fill: new (0, $8624b871a0af6dab$export$2e2bcd8739ae039)({
            color: "rgba(255, 255, 255, 0.2)"
        })
    })
});
const $e2b798e23180fa76$var$formatLength = function(line) {
    const length = (0, $42da4f557dd38010$export$f0d11c074a923179)(line); // m
    let output;
    if (length > 1000) output = Math.round(length / 1000 * 100) / 100 + " " + "km";
    else output = Math.round(length * 100) / 100 + " " + "m";
    return output;
};
const $e2b798e23180fa76$var$formatArea = function(polygon) {
    const area = (0, $42da4f557dd38010$export$520c40045967cb15)(polygon); // m²
    let output;
    // Au dessus de 10 000 m², on passe en hectares ; 1ha == 10 000 m² == 100 m * 100 m
    if (area > 10000) output = Math.round(area / 10000 * 100) / 100 + " ha";
    else output = Math.round(area * 100) / 100 + " " + "m<sup>2</sup>";
    return output;
};
const $e2b798e23180fa76$export$194c7727cbdc0cac = ({ map: map, workingLayer: workingLayer, availableLayers: availableLayers, extraTools: extraTools = {} })=>{
    const [activeTool, setActiveTool] = (0, $kc00y.useState)("");
    const [infoOutilI, setInfoOutilI] = (0, $kc00y.useState)({
        show: false,
        data: []
    });
    const measureOverlayArray = [];
    const geometryOverlayArray = [];
    const handleCloseInfoI = ()=>{
        workingLayer.getSource().clear();
        setInfoOutilI({
            show: false,
            data: []
        });
    };
    let measureTooltipElement, measureTooltip;
    function createMeasureTooltip() {
        if (measureTooltipElement) measureTooltipElement.remove();
        measureTooltipElement = document.createElement("div");
        measureTooltipElement.className = "ol-tooltip ol-tooltip-measure";
        measureTooltip = new (0, $bedb0af9b4c870c1$export$2e2bcd8739ae039)({
            element: measureTooltipElement,
            offset: [
                0,
                -15
            ],
            positioning: "bottom-center",
            stopEvent: false,
            insertFirst: false
        });
        measureOverlayArray.push(measureTooltip);
        map.addOverlay(measureTooltip);
    }
    // biome-ignore lint/correctness/useExhaustiveDependencies: on veut que les outils soient recréés uniquement si la carte ou les couches disponibles changent, pas à chaque changement d'outil actif
    const tools = (0, $kc00y.useMemo)(()=>{
        if (!map) return {};
        const dragPanCtrl = new (0, $fbb92ebf821804c2$export$2e2bcd8739ae039)();
        function toggleMove(active = false) {
            const idx = map.getInteractions().getArray().indexOf(dragPanCtrl);
            if (active) {
                if (idx === -1) map.addInteraction(dragPanCtrl);
                dragPanCtrl.setActive(true);
            } else dragPanCtrl.setActive(false);
        }
        function toggleMeasureLength(active = false) {
            toggleMeasure(active, "LineString");
        }
        function toggleMeasureArea(active = false) {
            toggleMeasure(active, "Polygon");
        }
        function toggleInfoArea(active = false) {
            const draw = drawCtrlInfo;
            if (active) {
                if (map?.getInteractions().getArray().indexOf(draw) === -1) map?.addInteraction(draw);
            } else {
                map?.removeInteraction(draw);
                handleCloseInfoI();
            }
        }
        function findIdByLayerCode(availableLayers, code) {
            for (const group of availableLayers)for (const subLayer of group.layers){
                if (subLayer.layer === code) return subLayer.id;
            }
            return null; // Si aucun match trouvé
        }
        let listener;
        const drawstartCallback = (evt)=>{
            const sketch = evt.feature;
            let tooltipCoord = evt.coordinate;
            listener = sketch.getGeometry().on("change", function(evt) {
                createMeasureTooltip();
                const geom = evt.target;
                let output = "";
                if (geom instanceof (0, $52cb54ac72de6b07$export$2e2bcd8739ae039)) {
                    output = $e2b798e23180fa76$var$formatArea(geom);
                    tooltipCoord = geom.getInteriorPoint().getCoordinates();
                } else if (geom instanceof (0, $197b31f867e63891$export$2e2bcd8739ae039)) {
                    output = $e2b798e23180fa76$var$formatLength(geom);
                    tooltipCoord = geom.getLastCoordinate();
                }
                if (measureTooltipElement && output) measureTooltipElement.innerHTML = output;
                if (measureTooltip) measureTooltip.setPosition(tooltipCoord);
            });
        };
        const drawendCallback = (evt)=>{
            geometryOverlayArray.push(evt.feature);
            if (measureTooltipElement) measureTooltipElement.className = "ol-tooltip ol-tooltip-static";
            if (measureTooltip) measureTooltip.setOffset([
                0,
                -7
            ]);
            // unset sketch
            // unset tooltip so that a new one can be created
            measureTooltipElement = null;
            if (listener) (0, $a8e855f7c93fe402$export$b7ef3f8527533384)(listener);
        };
        // draw pour l'élément "boutonI"
        const drawCtrlInfo = new (0, $2ef894158a48397d$export$2e2bcd8739ae039)({
            source: workingLayer.getSource(),
            type: "Point"
        });
        drawCtrlInfo.on("drawend", async (event)=>{
            const feature = event.feature;
            const coords = feature.getGeometry().getCoordinates();
            setInfoOutilI({
                show: false,
                data: []
            });
            map.getLayers().getArray().filter((l)=>l.getVisible() && (l instanceof (0, $6ffb4d96f7dfea2e$export$2e2bcd8739ae039) && l.getSource() instanceof (0, $afbdb872d70a16e7$export$2e2bcd8739ae039) || l instanceof (0, $db51b5c8e297e6ef$export$2e2bcd8739ae039) && l.getSource() instanceof (0, $4c9244de85181135$export$2e2bcd8739ae039))).forEach((wmsLayer)=>{
                const view = map.getView();
                const source = wmsLayer.getSource();
                if (!source) return;
                const url = source.getFeatureInfoUrl(coords, view.getResolution(), view.getProjection(), {
                    INFO_FORMAT: "application/json",
                    FEATURE_COUNT: 5
                });
                if (url) fetch(url).then((r)=>{
                    if (!r.ok) throw new Error("Mauvaise r\xe9ponse internet");
                    return r.json();
                }).then((data)=>{
                    const features = Array.isArray(data?.features) ? data.features : [];
                    // Pour les aggrégations, on inverse l'ordre pour que les couches les plus hautes soient affichées en premier
                    // Les id des features sont de la forme "layerName.uuid", on peut donc récupérer le nom de la couche en prenant la première partie de l'id
                    const sourceLayerNames = new Set(features.map((feature)=>String(feature?.id ?? "").split(".").at(0)).filter(Boolean));
                    const isAggregationLayerUsed = sourceLayerNames.size > 1;
                    const dataTriees = isAggregationLayerUsed ? {
                        ...data,
                        features: [
                            ...features
                        ].reverse()
                    } : data;
                    if (dataTriees.features.length > 0) dataTriees.id = findIdByLayerCode(availableLayers, source.getParams().LAYERS);
                    setInfoOutilI((e)=>({
                            show: true,
                            data: [
                                ...e.data,
                                {
                                    ...dataTriees
                                }
                            ]
                        }));
                }).catch(()=>{
                // plan sans documentation => ne rien faire
                });
            });
        });
        drawCtrlInfo.on("drawstart", async ()=>{
            workingLayer.getSource().clear();
        });
        const measureLengthCtrl = new (0, $2ef894158a48397d$export$2e2bcd8739ae039)({
            source: workingLayer.getSource(),
            type: "LineString",
            style: (feature)=>{
                const geometry = feature.getGeometry();
                if (!geometry) return;
                const geometryType = geometry.getType();
                if (geometryType === "LineString" || geometryType === "Point") return $e2b798e23180fa76$var$measureStyle;
            }
        });
        measureLengthCtrl.on("drawstart", drawstartCallback);
        measureLengthCtrl.on("drawend", drawendCallback);
        const measureAreaCtrl = new (0, $2ef894158a48397d$export$2e2bcd8739ae039)({
            source: workingLayer.getSource(),
            type: "Polygon",
            style: (feature)=>{
                const geometry = feature.getGeometry();
                if (!geometry) return;
                const geometryType = geometry.getType();
                if (geometryType === "Polygon" || geometryType === "Point") return $e2b798e23180fa76$var$measureStyle;
            }
        });
        measureAreaCtrl.on("drawstart", drawstartCallback);
        measureAreaCtrl.on("drawend", drawendCallback);
        function toggleMeasure(active = false, type) {
            const ctrl = type === "LineString" ? measureLengthCtrl : measureAreaCtrl;
            const idx = map.getInteractions().getArray().indexOf(ctrl);
            if (active) {
                if (idx === -1) map.addInteraction(ctrl);
            } else {
                map.removeInteraction(ctrl);
                measureOverlayArray.forEach((o)=>map.removeOverlay(o));
                measureOverlayArray.splice(0, measureOverlayArray.length);
                geometryOverlayArray.splice(0, geometryOverlayArray.length);
            }
        }
        return {
            "move-view": {
                action: toggleMove,
                actionPossibleEnDeplacement: true
            },
            "measure-length": {
                action: toggleMeasureLength,
                actionPossibleEnDeplacement: true
            },
            "measure-area": {
                action: toggleMeasureArea,
                actionPossibleEnDeplacement: true
            },
            "info-outil-i": {
                action: toggleInfoArea,
                actionPossibleEnDeplacement: true
            },
            ...extraTools
        };
    }, [
        map,
        availableLayers
    ]);
    function disabledTool(toolId) {
        if (activeTool === toolId) {
            setActiveTool(null);
            tools[toolId]?.action(false);
        }
    }
    function toggleTool(toolId) {
        let newTool = null;
        if (activeTool === toolId) setActiveTool(null);
        else {
            setActiveTool(toolId);
            newTool = toolId;
        }
        for(const property in tools)tools[property].action(property === newTool);
        // on autorise le déplacement que si on n'est pas dans une situation qui l'interdit (sélection)
        tools["move-view"].action(tools[toolId]?.actionPossibleEnDeplacement !== false || newTool == null || map.getInteractions().getArray().find((interaction)=>interaction instanceof (0, $fbb92ebf821804c2$export$2e2bcd8739ae039))?.getActive() !== true);
    }
    return {
        activeTool: activeTool,
        toggleTool: toggleTool,
        disabledTool: disabledTool,
        infoOutilI: infoOutilI,
        handleCloseInfoI: handleCloseInfoI
    };
};
const $e2b798e23180fa76$var$MapToolbar = /*#__PURE__*/ (0, $kc00y.forwardRef)(({ map: map, toggleTool: toggleTool, activeTool: activeTool, variant: variant = "primary", generalInfo: generalInfo, handleCloseInfoI: handleCloseInfoI, showOutilI: showOutilI, showZoomPlace: showZoomPlace, availableLayers: availableLayers }, ref)=>{
    const [zoom, setZoom] = (0, $kc00y.useState)(map.getView().getZoom() ?? 0);
    const { user: user } = (0, $e787cde576104469$export$fdc397e486fa83e7)();
    const availableLayerIds = Array.isArray(availableLayers) ? availableLayers.flatMap((group)=>Array.isArray(group.layers) ? group.layers.map((l)=>l.id) : []) : [];
    const { data: metadata } = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/admin/couche-metadata/get-available-metadata?${{
        couchesIds: JSON.stringify(availableLayerIds)
    }}`);
    const isBANSearch = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/parametres?${{
        listeParametreCode: JSON.stringify((0, $ee297f06e8568bf4$export$2e2bcd8739ae039).RECHERCHE_BAN)
    }}`, {})?.data?.[(0, $ee297f06e8568bf4$export$2e2bcd8739ae039).RECHERCHE_BAN].parametreValeur;
    (0, $kc00y.useEffect)(()=>{
        // setActiveTool("move");
        setZoom(map.getView().getZoom() ?? 0);
    }, [
        map
    ]);
    map.getView().on("change:resolution", ()=>{
        setZoom(map.getView().getZoom() ?? 0);
    });
    function zoomIn() {
        const currentZoom = zoom ?? 0;
        if (currentZoom < map.getView().getMaxZoom()) map.getView().setZoom(currentZoom + 1);
    }
    function zoomOut() {
        const currentZoom = zoom ?? 0;
        if (currentZoom > map.getView().getMinZoom()) map.getView().setZoom(currentZoom - 1);
    }
    // Pour accéder aux méthodes de la bar en dehors
    (0, $kc00y.useImperativeHandle)(ref, ()=>({}));
    const { fetchMapGeometry: fetchMapGeometry } = (0, $a178c3075f0f40bb$export$d1a1b15ef15cfb13)();
    const [commune, setCommune] = (0, $kc00y.useState)();
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $669f9c52e6081841$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $a43e6f68e14bab96$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                                className: "m-2 rounded",
                                onClick: zoomIn,
                                disabled: zoom >= map.getView().getMaxZoom(),
                                variant: variant,
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$279925e52ecb7067), {})
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                                className: "m-2 rounded",
                                onClick: zoomOut,
                                disabled: zoom <= map.getView().getMinZoom(),
                                variant: variant,
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$8a3fa2b294d0816a), {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $a43e6f68e14bab96$export$2e2bcd8739ae039), {
                        children: isBANSearch !== null && isBANSearch === "true" ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $be97a61e865d594d$export$2e2bcd8739ae039), {
                            map: map
                        }) : /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $a1d50030dc0bb103$export$2e2bcd8739ae039), {
                                    label: "Zoomer sur la commune",
                                    queryUrl: "/api/commune/get-by-name",
                                    setter: (objet)=>{
                                        if (!objet) setCommune(null);
                                        else {
                                            fetchMapGeometry(objet, map);
                                            setCommune(objet);
                                        }
                                    }
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $a1d50030dc0bb103$export$2e2bcd8739ae039), {
                                    label: "Zoomer sur la voie",
                                    queryUrl: "/api/voie/get-by-name",
                                    dependentObject: commune,
                                    setter: (objet)=>{
                                        fetchMapGeometry(objet, map);
                                    }
                                }),
                                showZoomPlace && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ef04aa6164ff9f18$export$2e2bcd8739ae039), {
                                    map: map,
                                    dependentObject: commune,
                                    urlAPI: `/api/toponymie/parametres`
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $a43e6f68e14bab96$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $f2eef644ac9323e0$export$2e2bcd8739ae039), {
                                toolName: "measure-length",
                                toolIcon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$f3d1eed2a70340c3), {}),
                                toolLabelTooltip: "Mesurer une distance",
                                toggleTool: toggleTool,
                                activeTool: activeTool,
                                variant: variant
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $f2eef644ac9323e0$export$2e2bcd8739ae039), {
                                toolName: "measure-area",
                                toolIcon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$8fb9a74ca2700ad5), {}),
                                toolLabelTooltip: "Mesurer une superficie",
                                toggleTool: toggleTool,
                                activeTool: activeTool,
                                variant: variant
                            }),
                            (user?.isSuperAdmin || showOutilI && metadata && metadata.length > 0) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $f2eef644ac9323e0$export$2e2bcd8739ae039), {
                                toolName: "info-outil-i",
                                toolIcon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$340bfce9b4df026b), {}),
                                toolLabelTooltip: "Obtenir des informations sur un point de la carte",
                                toggleTool: toggleTool,
                                activeTool: activeTool,
                                variant: variant
                            })
                        ]
                    })
                ]
            }),
            generalInfo.show && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1eee265537f042a4$export$2e2bcd8739ae039), {
                handleClose: handleCloseInfoI,
                show: generalInfo.show,
                className: "w-auto",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $f077da3af045a95a$export$2e2bcd8739ae039), {
                    generalsInfos: generalInfo.data,
                    coucheMetadata: metadata
                })
            })
        ]
    });
});
$e2b798e23180fa76$var$MapToolbar.displayName = "MapToolbar";
var $e2b798e23180fa76$export$2e2bcd8739ae039 = $e2b798e23180fa76$var$MapToolbar;














/**
 * Permet de déplacer un objet
 * @param active : si le toggle est séléctionné ou non
 * @param selectCtrl : le select qui sera utilisé
 * @param modifyCtrl : le modify qui sera utilisé
 * @param map : la carte
 * @param onMoveEnd : la fonction qui sera appelée à la fin du déplacement
 * @param conditionObjetSelectionne : La condition pour pouvoir déplacer l'objet (par exemple, il doit s'agit d'un PEI en projet pour la couverture hydraulique)
 */ function $1ed1be1197ad1bc4$var$toggleDeplacerPoint(active = false, selectCtrl, modifyCtrl, map, onMoveEnd, conditionObjetSelectionne = (feature)=>feature != null) {
    const idx1 = map?.getInteractions().getArray().indexOf(selectCtrl);
    // Helper to enable/disable DragPan
    function setDragPanActive(active) {
        map.getInteractions().getArray().forEach((interaction)=>{
            if (interaction instanceof (0, $fbb92ebf821804c2$export$2e2bcd8739ae039)) interaction.setActive(active);
        });
    }
    if (active) {
        const idx2 = map?.getInteractions().getArray().indexOf(modifyCtrl);
        if (idx1 === -1 && idx2 === -1) {
            map.addInteraction(selectCtrl);
            map.addInteraction(modifyCtrl);
            // Désactive le déplacement de la carte pendant le drag d'un objet, puis réactive après
            modifyCtrl.on("modifystart", function() {
                setDragPanActive(false);
            });
            modifyCtrl.on("modifyend", function(evt) {
                setDragPanActive(true);
                evt.features.forEach(async function(feature) {
                    if (conditionObjetSelectionne(feature)) onMoveEnd("SRID=" + map.getView().getProjection().getCode().split(":").pop() + ";" + new (0, $15a985d09649bdc2$export$2e2bcd8739ae039)().writeFeature(feature), feature.getProperties());
                });
            });
        }
        // Toujours activer DragPan quand l'outil est activé (sauf pendant drag objet)
        setDragPanActive(true);
    } else {
        map.removeInteraction(selectCtrl);
        map.removeInteraction(modifyCtrl);
        setDragPanActive(true);
    }
}
function $1ed1be1197ad1bc4$export$a3178456480ccf5b(map, urlApi, projection, style) {
    const dl = $1ed1be1197ad1bc4$export$a78c202fabe99b8e(map, urlApi, projection, style);
    map.addLayer(dl);
    return dl;
}
function $1ed1be1197ad1bc4$export$a78c202fabe99b8e(map, urlApi, projection, style) {
    let activeController = null;
    let latestRequestId = 0;
    const vectorSource = (0, $cdcdd8e1ff041f79$export$171b9db83e5b3b3e)({
        source: (0, $b38d314a5a0d0e6b$export$2e2bcd8739ae039).GEOJSON,
        loader: async (extent, resolution, projection, success, failure)=>{
            if (activeController != null) activeController.abort();
            const controller = new AbortController();
            activeController = controller;
            const requestId = ++latestRequestId;
            try {
                const res = await fetch((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`${urlApi(extent, projection)}`, {
                    ...(0, $fbd4d34e07af0ac7$export$b163ec2f884327db)({
                        method: "GET"
                    }),
                    signal: controller.signal
                });
                if (requestId !== latestRequestId) return;
                if (!res.ok) throw new Error(`HTTP ${res.status}`);
                const text = await res.text();
                const features = vectorSource.getFormat().readFeatures(JSON.parse(text));
                if (requestId !== latestRequestId) return;
                // Optimisation : batch l'ajout des features
                if (features.length > 0) vectorSource.addFeatures(features);
                success(features);
            } catch (error) {
                if (error instanceof DOMException && error.name === "AbortError") {
                    vectorSource.removeLoadedExtent(extent);
                    return;
                }
                vectorSource.removeLoadedExtent(extent);
                failure();
            }
        },
        extent: map.getView().calculateExtent(),
        projection: projection.name,
        strategy: (0, $6a8cacaa690463df$export$bf67010aacbe66fa)
    });
    const dl = new (0, $082a79ecb622f84a$export$2e2bcd8739ae039)({
        source: vectorSource,
        style: style ?? new (0, $a5fc261473972d1d$export$2e2bcd8739ae039)({
            fill: new (0, $8624b871a0af6dab$export$2e2bcd8739ae039)({
                color: "rgba(0, 0, 0, 0.01)" //Applique un style invisible à l'oeil nu par defaut en l'absence de geoserver
            }),
            //(bug OpenLayer ne permettant pas de cliquer sur des lignes totalement transparentes)
            stroke: new (0, $281691897fddf9d0$export$2e2bcd8739ae039)({
                color: "rgba(0, 0, 0, 0.01)",
                width: 4
            }),
            image: new (0, $f060542c6e9f52e6$export$2e2bcd8739ae039)({
                radius: 4,
                stroke: new (0, $281691897fddf9d0$export$2e2bcd8739ae039)({
                    color: "rgba(0, 0, 0, 0)"
                }),
                fill: new (0, $8624b871a0af6dab$export$2e2bcd8739ae039)({
                    color: "rgba(0, 0, 0, 0)"
                })
            })
        }),
        extent: map.getView().calculateExtent(),
        opacity: 1,
        visible: true,
        minZoom: (0, $f740b0d032822ba6$export$43e6e1d03cd3f2e7),
        minResolution: 0,
        maxResolution: 99999,
        zIndex: 9999,
        updateWhileAnimating: false,
        updateWhileInteracting: false,
        renderBuffer: 150
    });
    (0, $6c6ce495fc1da0b9$export$d96f612ac05cb0c0)(dl);
    return dl;
}
var $1ed1be1197ad1bc4$export$2e2bcd8739ae039 = $1ed1be1197ad1bc4$var$toggleDeplacerPoint;
function $1ed1be1197ad1bc4$export$3e0671d22771d76c(map, wktString, workingLayer, projection) {
    workingLayer.getSource().clear();
    const wktFormat = new (0, $15a985d09649bdc2$export$2e2bcd8739ae039)();
    const feature = wktFormat.readFeature(wktString, {
        dataProjection: projection.name,
        featureProjection: projection.name
    });
    // On transforme en 3857
    feature.getGeometry().transform(projection.name, (0, $f740b0d032822ba6$export$3eb968b6a9f43207));
    workingLayer.getSource().addFeature(feature);
    const vectorLayer = new (0, $082a79ecb622f84a$export$2e2bcd8739ae039)({
        source: workingLayer.getSource(),
        style: new (0, $a5fc261473972d1d$export$2e2bcd8739ae039)({
            stroke: new (0, $281691897fddf9d0$export$2e2bcd8739ae039)({
                color: "green",
                width: 2
            }),
            fill: new (0, $8624b871a0af6dab$export$2e2bcd8739ae039)({
                color: "rgba(0, 255, 0, 0.2)"
            }),
            image: new (0, $f060542c6e9f52e6$export$2e2bcd8739ae039)({
                radius: 8,
                fill: new (0, $8624b871a0af6dab$export$2e2bcd8739ae039)({
                    color: "#ffb412"
                })
            })
        }),
        zIndex: 9999
    });
    // Ajouter la couche à la carte existante
    map.addLayer(vectorLayer);
    // On zoom sur la carte avce un maxZoom
    const extent = workingLayer.getSource().getExtent();
    if (map.getSize()?.every((e)=>e === 0)) map.setSize([
        1000,
        800
    ]);
    map.getView().fit(extent, {
        padding: [
            50,
            50,
            50,
            50
        ],
        size: map.getSize(),
        maxZoom: 18
    });
}
function $1ed1be1197ad1bc4$export$51ba454167fb25ab(map) {
    if (!map) return;
    map.getLayers().forEach((layer)=>{
        if (layer.getSource().updateParams) {
            layer.getSource().updateParams({
                time: Date.now()
            });
            layer.getSource().refresh();
        }
    });
}
function $1ed1be1197ad1bc4$export$7c332a2c034a88e4(map) {
    map.getInteractions().getArray().forEach((interaction)=>{
        if (interaction instanceof (0, $fbb92ebf821804c2$export$2e2bcd8739ae039)) interaction.setActive(false);
    });
}
function $1ed1be1197ad1bc4$export$856bbc3500e88ad3(extent, map, sridFrom) {
    map?.getView().fit((0, $a86eee1c28205a05$export$751c68e0e0efff79)(extent, `EPSG:${sridFrom}`, map.getView().getProjection().getCode()), {
        padding: [
            50,
            50,
            50,
            50
        ],
        maxZoom: 20
    });
}



const $cdcdd8e1ff041f79$var$resolutions = [];
const $cdcdd8e1ff041f79$var$matrixIds = [];
const $cdcdd8e1ff041f79$var$proj3857 = (0, $a86eee1c28205a05$export$3988ae62b71be9a3)((0, $f740b0d032822ba6$export$3eb968b6a9f43207));
const $cdcdd8e1ff041f79$var$maxResolution = (0, $dea65c2f666fa450$export$3c49c185de0c2bfc)($cdcdd8e1ff041f79$var$proj3857.getExtent()) / 256;
// Matrices TileGrid 0..19 pour afficher les tuiles suivant le zoom, les services (IGN, etc.) ne vont pas au-delà de 20 niveaux
for(let i = 0; i < 20; i++){
    $cdcdd8e1ff041f79$var$matrixIds[i] = i.toString();
    $cdcdd8e1ff041f79$var$resolutions[i] = $cdcdd8e1ff041f79$var$maxResolution / Math.pow(2, i);
}
// Échelle sur la carte suivant le niveau zoom
const $cdcdd8e1ff041f79$var$scaleControl = new (0, $126e6859554e1a5d$export$2e2bcd8739ae039)({
    units: "metric",
    maxWidth: 200,
    minWidth: 100
});
// Grille de tuiles
const $cdcdd8e1ff041f79$var$tileGrid = new (0, $298480a99c8b5ec1$export$2e2bcd8739ae039)({
    origin: (0, $dea65c2f666fa450$export$cb1538b07e6964ff)($cdcdd8e1ff041f79$var$proj3857.getExtent()),
    // [-20037508, 20037508]
    resolutions: $cdcdd8e1ff041f79$var$resolutions,
    matrixIds: $cdcdd8e1ff041f79$var$matrixIds
});
function $cdcdd8e1ff041f79$export$171b9db83e5b3b3e(layer, etudeId, criseId, evenementStatutMode, viewParamsExtras) {
    switch(layer.source){
        case (0, $b38d314a5a0d0e6b$export$2e2bcd8739ae039).WMS:
            {
                const wmsParams = {
                    LAYERS: layer.layer,
                    TILED: true,
                    projection: layer.projection,
                    matrixSet: "PM",
                    FORMAT: layer.format ?? "image/png",
                    style: "normal"
                };
                const viewParamsArray = [];
                if (criseId) viewParamsArray.push(`idCrise:${encodeURIComponent(criseId)}`);
                if (etudeId) viewParamsArray.push(`idEtude:${encodeURIComponent(etudeId)}`);
                if (evenementStatutMode) viewParamsArray.push(`statutMode:${encodeURIComponent(evenementStatutMode)}`);
                // Ajouter les viewParams supplémentaires passés en paramètre
                if (viewParamsExtras) Object.entries(viewParamsExtras).forEach(([key, value])=>{
                    // Ne pas encoder les listes d'IDs (séparées par ;) pour préserver les séparateurs
                    if (key === "evenementIds") viewParamsArray.push(`${key}:${value}`);
                    else viewParamsArray.push(`${key}:${encodeURIComponent(value)}`);
                });
                wmsParams.viewParams = viewParamsArray.join(";");
                return !layer.tuilage ? new (0, $afbdb872d70a16e7$export$2e2bcd8739ae039)({
                    url: layer.url,
                    params: wmsParams,
                    imageLoadFunction: (0, $6c6ce495fc1da0b9$export$8c9efd2f226f6e84)()
                }) : new (0, $4c9244de85181135$export$2e2bcd8739ae039)({
                    url: layer.url,
                    params: wmsParams,
                    // Optimisations de performance
                    cacheSize: 512,
                    transition: 0,
                    tileGrid: $cdcdd8e1ff041f79$var$tileGrid,
                    tileLoadFunction: (0, $6c6ce495fc1da0b9$export$40aaeac5541a69ec)(layer.crossOrigin)
                });
            }
        case (0, $b38d314a5a0d0e6b$export$2e2bcd8739ae039).WMTS:
            return new (0, $7ba829994893f414$export$2e2bcd8739ae039)({
                crossOrigin: layer.crossOrigin,
                url: layer.url,
                layer: layer.layer,
                projection: layer.projection,
                matrixSet: "PM",
                format: layer.format ?? "image/png",
                tileGrid: $cdcdd8e1ff041f79$var$tileGrid,
                style: "normal",
                // Optimisations de performance
                cacheSize: 512,
                transition: 0,
                tileLoadFunction: (0, $6c6ce495fc1da0b9$export$40aaeac5541a69ec)(layer.crossOrigin)
            });
        case (0, $b38d314a5a0d0e6b$export$2e2bcd8739ae039).GEOJSON:
            return new (0, $1020e4d07ddbfab1$export$2e2bcd8739ae039)({
                url: layer.url,
                loader: layer.loader,
                strategy: layer.strategy,
                format: new (0, $93342158ce8701e7$export$2e2bcd8739ae039)({
                    dataProjection: layer.projection,
                    featureProjection: layer.projection
                })
            });
        case (0, $b38d314a5a0d0e6b$export$2e2bcd8739ae039).OSM:
            return new (0, $6944b8b0ce57af59$export$2e2bcd8739ae039)({
                url: layer.url,
                crossOrigin: layer.crossOrigin ?? null,
                // Optimisations de performance
                cacheSize: 512,
                transition: 0
            });
        case (0, $b38d314a5a0d0e6b$export$2e2bcd8739ae039).WFS:
            return new (0, $1020e4d07ddbfab1$export$2e2bcd8739ae039)({
                url: (extent)=>{
                    return layer.url + "?service=WFS&request=GetFeature&typename=" + layer.layer + "&outputFormat=" + (layer.format ?? "application/json") + "&srsname=" + layer.projection + "&bbox=" + extent.join(",") + "," + layer.projection;
                },
                format: new (0, $93342158ce8701e7$export$2e2bcd8739ae039)({}),
                strategy: (0, $6a8cacaa690463df$export$bf67010aacbe66fa)
            });
        default:
            return undefined;
    }
}
const $cdcdd8e1ff041f79$var$MapComponent = ({ map: map, availableLayers: availableLayers, addOrRemoveLayer: addOrRemoveLayer, layerListRef: layerListRef, mapToolbarRef: mapToolbarRef, mapElement: mapElement, toolbarElement: toolbarElement, toggleTool: toggleTool, activeTool: activeTool, variant: variant = "primary", outilI: outilI, handleCloseInfoI: handleCloseInfoI, showOutilI: showOutilI, printable: printable = false, showZoomPlace: showZoomPlace = true })=>{
    (0, $kc00y.useEffect)(()=>{
        // Patch canvas context pour optimiser les opérations de readback (utilisées par OpenLayers)
        (0, $6c6ce495fc1da0b9$export$293c4afb163908ec)();
        const mapContainer = document.getElementById("map-container");
        const handleFullscreenChange = ()=>{
            requestAnimationFrame(()=>{
                if (document.fullscreenElement === mapContainer) mapContainer?.classList.add("is-fullscreen");
                else mapContainer?.classList.remove("is-fullscreen");
            });
        };
        document.addEventListener("fullscreenchange", handleFullscreenChange);
        return ()=>{
            document.removeEventListener("fullscreenchange", handleFullscreenChange);
        };
    }, []);
    // biome-ignore lint/correctness/useExhaustiveDependencies: on veut que ce useEffect ne se déclenche que lors de la création de la carte, pas à chaque changement d'outil actif
    (0, $kc00y.useEffect)(()=>{
        if (!map) return;
        toggleTool("move-view");
    }, [
        map
    ]);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))("map-component-wrapper", printable ? "isPrintable" : ""),
        id: "map-container",
        children: [
            map && mapElement && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                className: "map-toolbar noprint",
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        xs: "auto",
                        className: "map-toolbar-main-col",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e2b798e23180fa76$export$2e2bcd8739ae039), {
                            ref: mapToolbarRef,
                            map: map,
                            toggleTool: toggleTool,
                            activeTool: activeTool,
                            variant: variant,
                            generalInfo: outilI,
                            handleCloseInfoI: handleCloseInfoI,
                            showOutilI: showOutilI,
                            showZoomPlace: showZoomPlace,
                            availableLayers: availableLayers
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        xs: "auto",
                        className: "map-toolbar-extra-col",
                        children: toolbarElement && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                            className: "map-toolbar-extra",
                            children: toolbarElement
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                ref: mapElement,
                className: "map-map border border-" + variant
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                className: "map-layers printable-legend",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $6070da25ca8c9100$export$2e2bcd8739ae039), {
                    ref: layerListRef,
                    layers: availableLayers,
                    addOrRemoveLayer: addOrRemoveLayer
                })
            })
        ]
    });
};
const $cdcdd8e1ff041f79$export$547f9c492d831282 = ({ mapElement: mapElement, typeModule: typeModule, displayPei: displayPei = true, etudeId: etudeId, criseId: criseId, evenementStatutMode: evenementStatutMode, viewParamsExtras: viewParamsExtras })=>{
    const { state: state, search: search } = (0, $7a844823b04d4282$export$45d76561a5302f2b)();
    const navigate = (0, $7a844823b04d4282$export$9770f232ac06a008)();
    const { epsg: projection, extent: defaultExtent, user: user, extentSRID: extentSRID } = (0, $e787cde576104469$export$fdc397e486fa83e7)();
    const layersState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/layers/${typeModule}`, {});
    const afficheCoordonneesState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/parametres?${{
        listeParametreCode: JSON.stringify((0, $ee297f06e8568bf4$export$2e2bcd8739ae039).COORDONNEES_FORMAT_AFFICHAGE)
    }}`, {});
    const layerListRef = (0, $kc00y.useRef)(null);
    const mapToolbarRef = (0, $kc00y.useRef)();
    const map = (0, $kc00y.useMemo)(()=>{
        if (!projection || !mapElement.current || !afficheCoordonneesState.data) return;
        const initialMap = new (0, $fe544abd54013409$export$2e2bcd8739ae039)({
            controls: (0, $ec4b8275865f52de$export$ebe90cb607ad99e)().extend([
                new (0, $5fb44d261f72cf9a$export$2e2bcd8739ae039)({
                    source: "map-container"
                }),
                new (0, $64a039ea82d24f6b$export$2e2bcd8739ae039)({
                    coordinateFormat: afficheCoordonneesState.data?.[(0, $ee297f06e8568bf4$export$2e2bcd8739ae039).COORDONNEES_FORMAT_AFFICHAGE].parametreValeur !== (0, $2787da6a8e84611c$export$209cd9796c16313d).X_Y ? (coordinate)=>{
                        if (!coordinate) return "";
                        const coord = (0, $a86eee1c28205a05$export$51186ad6e864892a)(coordinate, projection.name, (0, $f740b0d032822ba6$export$ea1a29af61241729));
                        let result;
                        // Nombre de décimales à afficher
                        const decimals = 6;
                        const latitude = coord[1].toFixed(decimals);
                        const longitude = coord[0].toFixed(decimals);
                        if (afficheCoordonneesState.data?.[(0, $ee297f06e8568bf4$export$2e2bcd8739ae039).COORDONNEES_FORMAT_AFFICHAGE].parametreValeur === (0, $2787da6a8e84611c$export$209cd9796c16313d).DEGRES_SEXAGESIMAUX) result = (0, $a6adb03fd2fbc071$export$6eb0ac5f024d8590)("NS", parseFloat(latitude), decimals) + " " + (0, $a6adb03fd2fbc071$export$6eb0ac5f024d8590)("EO", parseFloat(longitude), decimals);
                        else result = "x : " + parseFloat(longitude) + ", y : " + parseFloat(latitude);
                        return result;
                    } : (0, $a6adb03fd2fbc071$export$35ad6765fe262b6)(4),
                    projection: projection.name
                }),
                $cdcdd8e1ff041f79$var$scaleControl
            ]),
            interactions: [
                new (0, $f18552b5a876d636$export$2e2bcd8739ae039)({
                    useAnchor: true,
                    constrainResolution: true
                })
            ],
            target: mapElement.current,
            layers: [],
            view: new (0, $22c5be3317ad81f4$export$2e2bcd8739ae039)({
                zoom: 6,
                projection: (0, $f740b0d032822ba6$export$3eb968b6a9f43207)
            })
        });
        if (user?.zoneIntegrationExtent) {
            const rawExtent = new (0, $15a985d09649bdc2$export$2e2bcd8739ae039)().readGeometry(user.zoneIntegrationExtent.split(";").pop()).getExtent();
            initialMap?.getView().fit((0, $a86eee1c28205a05$export$751c68e0e0efff79)(rawExtent, projection.name, (0, $f740b0d032822ba6$export$3eb968b6a9f43207)), {
                maxZoom: 20
            });
        } else initialMap.getView().fit((0, $a86eee1c28205a05$export$751c68e0e0efff79)(defaultExtent, extentSRID, (0, $f740b0d032822ba6$export$3eb968b6a9f43207)), {
            maxZoom: 20
        }); // Centre depuis l'étendue fournie par le serveur)
        return initialMap;
    }, [
        mapElement.current,
        projection,
        afficheCoordonneesState.data,
        user?.zoneIntegrationExtent,
        defaultExtent,
        extentSRID
    ]);
    // Application des optimisations de performance après création de la carte
    (0, $kc00y.useEffect)(()=>{
        if (map) (0, $6c6ce495fc1da0b9$export$80f3d9824dd64b88)(map);
    }, [
        map
    ]);
    const [showOutilI, setHasStyleLayer] = (0, $kc00y.useState)(false);
    // Ajout des couches disponibles depuis le serveur
    const availableLayers = (0, $kc00y.useMemo)(()=>{
        if (!layersState.data || !map) return [];
        setHasStyleLayer(layersState.data.some((group)=>group.layers.some((layer)=>layer.hasStyle)));
        // Calcul du nombre total de couches
        const totalLayers = layersState.data.reduce((acc, group)=>acc + group.layers.length, 0);
        let globalLayerIndex = totalLayers - 1;
        return layersState.data.map((group)=>{
            return {
                libelle: group.libelle,
                code: group.code,
                ordre: group.ordre,
                layers: group.layers.map((layer)=>{
                    const zIndex = globalLayerIndex--;
                    let openlayer;
                    if (layer.source === (0, $b38d314a5a0d0e6b$export$2e2bcd8739ae039).WFS) {
                        openlayer = new (0, $082a79ecb622f84a$export$2e2bcd8739ae039)({
                            source: $cdcdd8e1ff041f79$export$171b9db83e5b3b3e(layer),
                            zIndex: zIndex,
                            updateWhileAnimating: false,
                            updateWhileInteracting: false,
                            renderBuffer: 100,
                            opacity: layer.opacite
                        });
                        (0, $6c6ce495fc1da0b9$export$d96f612ac05cb0c0)(openlayer);
                    } else if (layer.source === (0, $b38d314a5a0d0e6b$export$2e2bcd8739ae039).GEOJSON) {
                        openlayer = (0, $1ed1be1197ad1bc4$export$a78c202fabe99b8e)(map, (extent, projection)=>layer.url + `?bbox=` + extent.join(",") + "&srid=" + projection.getCode(), projection);
                        openlayer.setZIndex(zIndex);
                    } else if (layer.source === (0, $b38d314a5a0d0e6b$export$2e2bcd8739ae039).WMS && layer.tuilage !== true) openlayer = new (0, $6ffb4d96f7dfea2e$export$2e2bcd8739ae039)({
                        source: $cdcdd8e1ff041f79$export$171b9db83e5b3b3e(layer, etudeId, criseId, evenementStatutMode, viewParamsExtras),
                        zIndex: zIndex,
                        opacity: layer.opacite
                    });
                    else {
                        openlayer = new (0, $db51b5c8e297e6ef$export$2e2bcd8739ae039)({
                            source: $cdcdd8e1ff041f79$export$171b9db83e5b3b3e(layer, etudeId, criseId, evenementStatutMode, viewParamsExtras),
                            zIndex: zIndex,
                            preload: 1,
                            useInterimTilesOnError: false,
                            opacity: layer.opacite
                        });
                        (0, $6c6ce495fc1da0b9$export$ee92df296c1dcf24)(openlayer);
                    }
                    if (layer.active) {
                        map?.addLayer(openlayer);
                        layerListRef.current?.addActiveLayer((0, $fd76d391cc228565$export$5e82334337e0f204)(openlayer));
                    }
                    return {
                        ...layer,
                        openlayer: openlayer
                    };
                })
            };
        });
    }, [
        layersState.data,
        map,
        projection,
        etudeId,
        criseId,
        evenementStatutMode,
        viewParamsExtras
    ]);
    // Ajout / retrait d'une couche sur la carte
    const addOrRemoveLayer = (layer)=>{
        const index = map?.getLayers().getArray().indexOf(layer.openlayer);
        if (index !== undefined && index > -1) {
            map?.removeLayer(layer.openlayer);
            layerListRef.current?.removeActiveLayer((0, $fd76d391cc228565$export$5e82334337e0f204)(layer.openlayer));
        } else {
            map?.addLayer(layer.openlayer);
            layerListRef.current?.addActiveLayer((0, $fd76d391cc228565$export$5e82334337e0f204)(layer.openlayer));
        }
    };
    // Ajout de la couche de travail
    const createWorkingLayer = (0, $kc00y.useCallback)(()=>{
        const wl = new (0, $082a79ecb622f84a$export$2e2bcd8739ae039)({
            source: new (0, $1020e4d07ddbfab1$export$2e2bcd8739ae039)(),
            style: ()=>{
                return new (0, $a5fc261473972d1d$export$2e2bcd8739ae039)({
                    fill: new (0, $8624b871a0af6dab$export$2e2bcd8739ae039)({
                        color: "rgba(255, 255, 255, 0.2)"
                    }),
                    stroke: new (0, $281691897fddf9d0$export$2e2bcd8739ae039)({
                        color: "rgba(255, 0, 0, 0.7)",
                        width: 2
                    }),
                    image: new (0, $f060542c6e9f52e6$export$2e2bcd8739ae039)({
                        radius: 7,
                        fill: new (0, $8624b871a0af6dab$export$2e2bcd8739ae039)({
                            color: "#ffcc33"
                        })
                    })
                });
            },
            opacity: 1,
            zIndex: 9000
        });
        map?.addLayer(wl);
        return wl;
    }, [
        map
    ]);
    const createDataPeiLayer = (0, $kc00y.useCallback)(()=>{
        if (!map) return;
        return (0, $1ed1be1197ad1bc4$export$a3178456480ccf5b)(map, (extent, projection)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/pei/layer?bbox=` + extent.join(",") + "&srid=" + projection.getCode(), projection);
    }, [
        map,
        projection
    ]);
    const workingLayer = (0, $kc00y.useMemo)(()=>{
        if (map && projection) return createWorkingLayer();
    }, [
        map,
        projection,
        createWorkingLayer
    ]);
    const dataPeiLayer = (0, $kc00y.useMemo)(()=>{
        if (map && projection && displayPei) return createDataPeiLayer();
    }, [
        map,
        projection,
        displayPei,
        createDataPeiLayer
    ]);
    (0, $kc00y.useEffect)(()=>{
        if (state?.target && map) {
            map.getView().fit((0, $a86eee1c28205a05$export$751c68e0e0efff79)(state.target.extent, `EPSG:${state.target.srid}`, map.getView().getProjection().getCode()), {
                maxZoom: 20
            });
            window.history.replaceState({
                from: state.from
            }, "");
        }
    }, [
        state,
        map
    ]);
    (0, $kc00y.useEffect)(()=>{
        // On met dans l'URL le extent pour simplifier la navigation
        if (map) {
            // On mémorise la dernière valeur connue de l'étendue pour éviter les navigations inutiles
            let lastExtent = "";
            // Débounce les évènements de fin de mouvement pour éviter trop d'appels
            const debouncedHandleMoveEnd = (0, $6c6ce495fc1da0b9$export$61fc7d43ac8f84b0)(()=>{
                const view = map.getView();
                const extent = view.calculateExtent().join(",");
                // On vérifie si l'étendue a réellement changée pour éviter une boucle infinie
                if (extent !== lastExtent) {
                    // Si elle a réellement changé, on la mémorise pour le prochain tour
                    lastExtent = extent;
                    const params = new URLSearchParams();
                    params.set("extent", extent);
                    navigate(`?${params.toString()}`, {
                        replace: true,
                        state: {
                            from: state?.from
                        }
                    });
                }
            }, 300); // Délai de 300ms
            // Throttle les évènements de zoom pour améliorer les performances
            const throttledHandleZoom = (0, $6c6ce495fc1da0b9$export$de363e709c412c8a)(()=>{
            // Actions spécifiques au zoom si nécessaire
            }, 100); // Délai de 100ms
            map.on("moveend", debouncedHandleMoveEnd);
            map.getView().on("change:resolution", throttledHandleZoom);
            // Récupération de l'étendue depuis les paramètres d'URL au chargement initial
            const params = new URLSearchParams(search);
            const extentParam = params.get("extent");
            if (extentParam && typeModule !== (0, $a9754922f4c67d47$export$ef88b514e4bfff34).RAPPORT_PERSONNALISE) {
                const geom = extentParam.split(",").map(Number);
                if (!(0, $dea65c2f666fa450$export$dd1bc94b04021eeb)(geom)) // On adapte la vue à l'étendue si elle est présente dans l'URL
                map.getView().fit(geom, {
                    maxZoom: 20
                });
            }
            // Nettoyage du listener lorsque le composant est démonté ou que la carte change
            return ()=>{
                map.un("moveend", debouncedHandleMoveEnd);
                map.getView().un("change:resolution", throttledHandleZoom);
            };
        }
    }, [
        state,
        map,
        navigate,
        search,
        typeModule
    ]);
    return {
        map: map,
        workingLayer: workingLayer,
        dataPeiLayer: dataPeiLayer,
        availableLayers: availableLayers,
        addOrRemoveLayer: addOrRemoveLayer,
        layerListRef: layerListRef,
        mapToolbarRef: mapToolbarRef,
        projection: projection,
        showOutilI: showOutilI
    };
};
var $cdcdd8e1ff041f79$export$2e2bcd8739ae039 = $cdcdd8e1ff041f79$var$MapComponent;






/**
 * Enumération définissant les thématiques existantes et protégées
 */ var $690fed8fd87ee1b4$var$THEMATIQUE = /*#__PURE__*/ function(THEMATIQUE) {
    THEMATIQUE["OLDEBS"] = "OLDEBS";
    THEMATIQUE["PERMIS"] = "PERMIS";
    THEMATIQUE["RCI"] = "RCI";
    THEMATIQUE["DFCI"] = "DFCI";
    THEMATIQUE["SIGNALEMENT"] = "SIGNALEMENT";
    THEMATIQUE["RISQUES"] = "RISQUES";
    THEMATIQUE["DIVERS"] = "DIVERS";
    THEMATIQUE["CARTOGRAPHIE_PERSONNALISEE"] = "CARTOGRAPHIE_PERSONNALISEE";
    THEMATIQUE["POINT_EAU"] = "POINT_EAU";
    THEMATIQUE["COUVERTURE_HYDRAULIQUE"] = "COUVERTURE_HYDRAULIQUE";
    return THEMATIQUE;
}($690fed8fd87ee1b4$var$THEMATIQUE || {});
var $690fed8fd87ee1b4$export$2e2bcd8739ae039 = $690fed8fd87ee1b4$var$THEMATIQUE;




var $kc00y = parcelRequire("kc00y");














const $4e573033f1d10af3$var$ListeDocumentThematique = ({ codeThematique: codeThematique, titre: titre, icon: icon, displayReturnButton: displayReturnButton = false })=>{
    const { isResolved: isResolved, data: listeDocument } = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/document-habilitable/` + codeThematique);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                title: titre,
                icon: icon,
                displayReturnButton: displayReturnButton
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $13de46b4dfcc473f$export$2e2bcd8739ae039), {
                bordered: true,
                striped: true,
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("thead", {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("th", {
                                    children: "Libell\xe9"
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("th", {
                                    children: "Date de derni\xe8re mise \xe0 jour"
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("th", {})
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("tbody", {
                        children: isResolved && listeDocument?.map((e, index)=>{
                            return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("td", {
                                        children: e.libelle
                                    }),
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("td", {
                                        children: e.date && (0, $00c47c7740afd024$export$2e2bcd8739ae039)(e.date)
                                    }),
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("td", {
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                                            className: "text-warning",
                                            href: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/document-habilitable/telecharger/` + e.id,
                                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$4a5ccdc9878f4668), {})
                                        })
                                    })
                                ]
                            }, index);
                        })
                    })
                ]
            })
        ]
    });
};
var $4e573033f1d10af3$export$2e2bcd8739ae039 = $4e573033f1d10af3$var$ListeDocumentThematique;


const $1ac4483a0721609f$var$VoletButtonListeDocumentThematique = ({ codeThematique: codeThematique, titreVolet: titreVolet })=>{
    const [showDocs, setShowDocs] = (0, $kc00y.useState)(false);
    const handleCloseDocs = ()=>setShowDocs(false);
    const { user: user } = (0, $e787cde576104469$export$fdc397e486fa83e7)();
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                tooltipText: "Afficher la liste des documents",
                tooltipId: "afficher-docs-dfci",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                    variant: "outline-primary",
                    onClick: ()=>setShowDocs(true),
                    className: "rounded m-2",
                    disabled: !(0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).DOCUMENTS_R),
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$84ac927778fdc063), {})
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1eee265537f042a4$export$2e2bcd8739ae039), {
                handleClose: handleCloseDocs,
                show: showDocs,
                className: "w-auto",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $4e573033f1d10af3$export$2e2bcd8739ae039), {
                    codeThematique: codeThematique,
                    titre: titreVolet,
                    icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$84ac927778fdc063), {})
                })
            })
        ]
    });
};
var $1ac4483a0721609f$export$2e2bcd8739ae039 = $1ac4483a0721609f$var$VoletButtonListeDocumentThematique;







var $kc00y = parcelRequire("kc00y");




/**
 * Enumeration des différents éléments possible sur la carte DFCI
 */ var $f32c9305c9576eaf$export$4fa1916ee9d33028 = /*#__PURE__*/ function(DFCI_ELEMENT) {
    DFCI_ELEMENT["AIRE"] = "AIRE";
    DFCI_ELEMENT["PISTE"] = "PISTE";
    DFCI_ELEMENT["DEBROUSSAILLEMENT"] = "DEBROUSSAILLEMENT";
    DFCI_ELEMENT["PANNEAU"] = "PANNEAU";
    return DFCI_ELEMENT;
}({});




var $56aa34800e0589a0$var$TYPE_POINT_CARTE = /*#__PURE__*/ function(TYPE_POINT_CARTE) {
    TYPE_POINT_CARTE["PEI"] = "PEI";
    TYPE_POINT_CARTE["PEI_PROJET"] = "PEI_PROJET";
    TYPE_POINT_CARTE["DEBIT_SIMULTANE"] = "DEBIT_SIMULTANE";
    return TYPE_POINT_CARTE;
}($56aa34800e0589a0$var$TYPE_POINT_CARTE || {});
var $56aa34800e0589a0$export$2e2bcd8739ae039 = $56aa34800e0589a0$var$TYPE_POINT_CARTE;












var $bkJfK = parcelRequire("bkJfK");





/**
 * Composant Select qui attend un Endpoint renvoyant un objet de type List<IdLibelleData>
 *     pour faire un select dans les formulaires
 *
 * @param {Function} onChange - Fonction de rappel pour gérer les changements de sélection.
 * @param {string} name - Nom du composant de sélection.
 * @param {list} listIdCodeLibelle - Liste ayant des objets id-Libellé.
 * @param {IdLibelleType} value - Value sélectionnée par défaut.
 * @param {string} label - Label du select.
 * @param {boolean} required - Valeur obligatoire ?
 * @param {Function} setValues - Permet de mettre à jour la valeur du select
 * @param {Function} setFieldValue - Permet de mettre à jour individuellement la valeur du select
 * @param {Function} setOtherValues - Permet de mettre à jour une / des autres valeurs du formulaire
 */ const $41485b498b8865f9$var$SelectForm = ({ name: name, listIdCodeLibelle: listIdCodeLibelle, defaultValue: defaultValue, label: label, required: required = false, disabled: disabled = false, onChange: onChangeCustom, optionDisabled: optionDisabled, setValues: setValues, setFieldValue: setFieldValue, setOtherValues: setOtherValues })=>{
    const onChange = ({ name: name, value: value })=>{
        setValues != null && setValues((prevValues)=>({
                ...prevValues,
                [name]: value
            }));
        setFieldValue != null && setFieldValue(name, value);
        setOtherValues != null && setOtherValues();
    };
    const list = listIdCodeLibelle ?? [];
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$d6701e98ab1a6725), {
        name: name,
        label: label,
        required: required,
        disabled: disabled,
        options: list,
        getOptionLabel: (option)=>option.libelle,
        getOptionValue: (option)=>option.id ?? "",
        defaultValue: defaultValue ?? null,
        onChange: (e)=>{
            onChangeCustom ? onChangeCustom(e) : onChange({
                name: name,
                value: e?.id
            });
        },
        noOptionsMessage: optionDisabled,
        isClearable: true
    });
};
var $41485b498b8865f9$export$2e2bcd8739ae039 = $41485b498b8865f9$var$SelectForm;






const $f89cdb798dc1325f$var$SelectNomenclaturesForm = ({ onChange: onChange, name: name, valueId: valueId, label: label, required: required = false, disabled: disabled = false, setValues: setValues, nomenclature: nomenclature, setOtherValues: setOtherValues })=>{
    const response = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/nomenclatures/list/` + nomenclature);
    return response.data && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
        name: name,
        listIdCodeLibelle: response.data,
        label: label,
        defaultValue: response.data.find((e)=>e.id === valueId),
        required: required,
        disabled: disabled,
        onChange: onChange,
        setValues: setValues,
        setOtherValues: setOtherValues
    });
};
var $f89cdb798dc1325f$export$2e2bcd8739ae039 = $f89cdb798dc1325f$var$SelectNomenclaturesForm;


var $25870915d2dbd38b$export$4a614337ddce2769 = /*#__PURE__*/ function(TypePeiProjet) {
    TypePeiProjet["PIBI"] = "PIBI";
    TypePeiProjet["RESERVE"] = "RESERVE";
    TypePeiProjet["PA"] = "PA";
    return TypePeiProjet;
}({});




function $36ceaed6faf947af$var$requiredIf(test, validator) {
    return test ? validator.required("Ce champ est requis.") : validator;
}
const $36ceaed6faf947af$export$8bc4fdb2734276ba = $36ceaed6faf947af$var$requiredIf(true, (0, $ce4de947442b2ab1$export$22b082955e083ec3)());
const $36ceaed6faf947af$export$f25be618b434f50b = $36ceaed6faf947af$var$requiredIf(true, (0, $ce4de947442b2ab1$export$22b082955e083ec3)().email("Format de l'adresse e-mail non valide."));
const $36ceaed6faf947af$export$d290fa47940df19d = (0, $ce4de947442b2ab1$export$22b082955e083ec3)().nullable().email("Format de l'adresse e-mail non valide.");
const $36ceaed6faf947af$export$98e628dec113755e = (0, $ce4de947442b2ab1$export$98e628dec113755e)().typeError("Ce champ doit \xeatre un nombre.");
const $36ceaed6faf947af$export$d73626444d3ce57a = $36ceaed6faf947af$var$requiredIf(true, $36ceaed6faf947af$export$98e628dec113755e);
const $36ceaed6faf947af$export$4a21f16c33752377 = (0, $ce4de947442b2ab1$export$87b259aa03e3d267)().typeError("Ce champ doit \xeatre un bool\xe9en.");
const $36ceaed6faf947af$export$87bba3bb7a1f4285 = $36ceaed6faf947af$var$requiredIf(true, $36ceaed6faf947af$export$4a21f16c33752377);
const $36ceaed6faf947af$export$24a1e2b92fa94c07 = $36ceaed6faf947af$export$98e628dec113755e.min(0, "Ce champ doit \xeatre sup\xe9rieur ou \xe9gal \xe0 0.");
const $36ceaed6faf947af$export$67e44a5301f37174 = $36ceaed6faf947af$export$24a1e2b92fa94c07.integer("Ce champ doit \xeatre un entier");
const $36ceaed6faf947af$export$a3560dfa62c7efe0 = $36ceaed6faf947af$export$24a1e2b92fa94c07.max(100, "Ce champ doit inf\xe9rieur ou \xe9gal \xe0 100.");
const $36ceaed6faf947af$export$ce12259c7522d9ef = $36ceaed6faf947af$var$requiredIf(true, $36ceaed6faf947af$export$a3560dfa62c7efe0);
const $36ceaed6faf947af$export$6e10f2f70d298df6 = $36ceaed6faf947af$var$requiredIf(true, (0, $ce4de947442b2ab1$export$2f23118c22fb2630)().ensure().min(1, "Ce champ doit comporter au moins 1 valeur."));
const $36ceaed6faf947af$export$324d90190a8b822a = (0, $ce4de947442b2ab1$export$324d90190a8b822a)().typeError("Format de date invalide");
const $36ceaed6faf947af$export$5cbf64e9c4f743ca = $36ceaed6faf947af$var$requiredIf(true, $36ceaed6faf947af$export$324d90190a8b822a);
const $36ceaed6faf947af$export$ec3358fdc98c6c51 = (0, $ce4de947442b2ab1$export$9b30b6294c1449a8)().required("Fichier requis");


const $1bfa9c502da04094$export$a5cab80145b70e98 = (data)=>({
        peiProjetNatureDeciId: data?.peiProjetNatureDeciId,
        peiProjetTypePeiProjet: data?.peiProjetTypePeiProjet,
        peiProjetDiametreId: data?.peiProjetDiametreId,
        peiProjetDiametreCanalisation: data?.peiProjetDiametreCanalisation,
        peiProjetCapacite: data?.peiProjetCapacite,
        peiProjetDebit: data?.peiProjetDebit,
        peiProjetCoordonneeX: data.peiProjetCoordonneeX,
        peiProjetCoordonneeY: data.peiProjetCoordonneeY,
        peiProjetSrid: data.peiProjetSrid
    });
const $1bfa9c502da04094$export$c084437b5e3206cd = (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({
    peiProjetNatureDeciId: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
    peiProjetTypePeiProjet: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba)
});
const $1bfa9c502da04094$export$f97400759cfd946 = (values)=>({
        peiProjetNatureDeciId: values.peiProjetNatureDeciId,
        peiProjetTypePeiProjet: values.peiProjetTypePeiProjet,
        peiProjetDiametreId: values.peiProjetDiametreId,
        peiProjetDiametreCanalisation: values.peiProjetDiametreCanalisation,
        peiProjetCapacite: values.peiProjetCapacite,
        peiProjetDebit: values.peiProjetDebit,
        peiProjetGeometrie: "SRID=" + values.peiProjetSrid + ";POINT(" + values.peiProjetCoordonneeX + " " + values.peiProjetCoordonneeY + ")"
    });
const $1bfa9c502da04094$var$PeiProjet = ()=>{
    const { values: values, setValues: setValues, setFieldValue: setFieldValue } = (0, $bkJfK.useFormikContext)();
    const listeTypePeiProjet = Object.values((0, $25870915d2dbd38b$export$4a614337ddce2769)).map((e)=>{
        return {
            id: e,
            code: e,
            libelle: e
        };
    });
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                            name: "peiProjetTypePeiProjet",
                            listIdCodeLibelle: listeTypePeiProjet,
                            label: "Type du PEI en projet",
                            defaultValue: listeTypePeiProjet?.find((e)=>e.code === values.peiProjetTypePeiProjet),
                            required: true,
                            setValues: setValues,
                            setOtherValues: ()=>{
                                setFieldValue("peiProjetDiametreId", null);
                                setFieldValue("peiProjetDiametreCanalisation", null);
                                setFieldValue("peiProjetCapacite", null);
                                setFieldValue("peiProjetDebit", null);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $f89cdb798dc1325f$export$2e2bcd8739ae039), {
                            name: "peiProjetNatureDeciId",
                            nomenclature: (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).NATURE_DECI,
                            label: "Nature DECI",
                            valueId: values.peiProjetNatureDeciId,
                            required: true,
                            setValues: setValues
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: values.peiProjetTypePeiProjet === (0, $25870915d2dbd38b$export$4a614337ddce2769).PIBI ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $f89cdb798dc1325f$export$2e2bcd8739ae039), {
                                name: "peiProjetDiametreId",
                                nomenclature: (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).DIAMETRE,
                                label: "Diam\xe8tre",
                                valueId: values.peiProjetDiametreId,
                                required: true,
                                setValues: setValues
                            })
                        }),
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$2e2bcd8739ae039), {
                                name: "peiProjetDiametreCanalisation",
                                label: "Diam\xe8tre de canalisation",
                                required: true
                            })
                        })
                    ]
                }) : values.peiProjetTypePeiProjet === (0, $25870915d2dbd38b$export$4a614337ddce2769).RESERVE ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$2e2bcd8739ae039), {
                                name: "peiProjetCapacite",
                                label: "Capacit\xe9 en m\xb3",
                                required: true
                            })
                        }),
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$2e2bcd8739ae039), {
                                name: "peiProjetDebit",
                                label: "D\xe9bit en m\xb3",
                                required: true
                            })
                        })
                    ]
                }) : values.peiProjetTypePeiProjet === (0, $25870915d2dbd38b$export$4a614337ddce2769).PA ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$2e2bcd8739ae039), {
                        name: "peiProjetDebit",
                        label: "D\xe9bit en m\xb3",
                        required: true
                    })
                }) : ""
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                className: "mt-3",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                    className: "text-center",
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                        type: "submit",
                        variant: "primary",
                        children: "Valider"
                    })
                })
            })
        ]
    });
};
var $1bfa9c502da04094$export$2e2bcd8739ae039 = $1bfa9c502da04094$var$PeiProjet;


const $bb50efe5e52f41fa$var$UpdatePeiProjet = ({ etudeId: etudeId, peiProjetId: peiProjetId, coordonneeX: coordonneeX, coordonneeY: coordonneeY, srid: srid, onSubmit: onSubmit })=>{
    const { data: data } = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/couverture-hydraulique/pei-projet/` + peiProjetId);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$ba2fbb9644c8bf32), {}),
                title: "Modification d'un PEI en projet"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                initialValues: (0, $1bfa9c502da04094$export$a5cab80145b70e98)({
                    peiProjetNatureDeciId: data?.peiProjetNatureDeciId,
                    peiProjetTypePeiProjet: data?.peiProjetTypePeiProjet,
                    peiProjetDiametreId: data?.peiProjetDiametreId,
                    peiProjetDiametreCanalisation: data?.peiProjetDiametreCanalisation,
                    peiProjetCapacite: data?.peiProjetCapacite,
                    peiProjetDebit: data?.peiProjetDebit,
                    peiProjetCoordonneeX: coordonneeX,
                    peiProjetCoordonneeY: coordonneeY,
                    peiProjetSrid: srid,
                    peiProjetEtudeId: etudeId
                }),
                validationSchema: (0, $1bfa9c502da04094$export$c084437b5e3206cd),
                isPost: false,
                submitUrl: `/api/couverture-hydraulique/etude/` + etudeId + `/pei-projet/` + peiProjetId,
                prepareVariables: (values)=>(0, $1bfa9c502da04094$export$f97400759cfd946)(values),
                onSubmit: onSubmit,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1bfa9c502da04094$export$2e2bcd8739ae039), {})
            })
        ]
    });
};
var $bb50efe5e52f41fa$export$2e2bcd8739ae039 = $bb50efe5e52f41fa$var$UpdatePeiProjet;








var $bkJfK = parcelRequire("bkJfK");

var $kc00y = parcelRequire("kc00y");




var $bkJfK = parcelRequire("bkJfK");






/**
 * ATTENTION : doit être utiliser dans un <MyFormik>
 * Permet de gérer, ajouter et supprimer des élements d'une liste
 * A chaque fois que l'utilisateur cliquera sur ajouter, une nouvelle partie de formulaire sera ajoutée
 * @param name : nom de la propriété de formik, une liste d'objet
 * @param defaultElement : élément par défaut qui sera ajouté si l'utilisateur clique sur "Ajouter"
 * @param listeElements : liste des éléments à afficher
 * @param canAdd : Permet de savoir si c'est le composant qui doit gérer les ajouts
 * @param createComponentToRepeat : Fonction qui doit prendre en paramètre l'index et la liste histoire de mettre un name unique par composant.
 *                                  Elle permettra de répéter le formulaire
 */ const $665753c43020c55f$var$AddRemoveComponent = ({ name: name, defaultElement: defaultElement, protectedProperty: protectedProperty, listeElements: listeElements, canAdd: canAdd = true, createComponentToRepeat: createComponentToRepeat, label: label, disabled: disabled, readOnly: readOnly, typeModule: typeModule, buttonLibelle: buttonLibelle, isDisabledButton: isDisabledButton = false, disableText: disableText })=>{
    const { setFieldValue: setFieldValue } = (0, $bkJfK.useFormikContext)();
    const scrollToBottom = ()=>{
        //requestAnomationFrame permet d'attendre la fin de la création du dom avant de descendre
        requestAnimationFrame(()=>{
            const heightDOM = document.body.scrollHeight;
            if (heightDOM > 900) window.scrollTo({
                top: document.body.scrollHeight,
                behavior: "smooth"
            });
        });
    };
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $bkJfK.FieldArray), {
            name: name,
            render: (elements)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                    children: [
                        canAdd && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                            children: [
                                label && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$842aba50ed0ce9d7), {
                                        name: name,
                                        label: label,
                                        required: false
                                    })
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                    xs: "auto",
                                    className: "ms-auto",
                                    children: isDisabledButton && disableText ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                                        tooltipText: disableText,
                                        tooltipId: name,
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("span", {
                                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                                                onClick: ()=>{
                                                    elements.push(defaultElement);
                                                    scrollToBottom();
                                                },
                                                disabled: true,
                                                style: {
                                                    pointerEvents: "none"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$4176b1d4e95be624), {}),
                                                    " ",
                                                    buttonLibelle ?? "Ajouter"
                                                ]
                                            })
                                        })
                                    }) : /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                                        onClick: ()=>{
                                            elements.push(defaultElement);
                                            scrollToBottom();
                                        },
                                        disabled: isDisabledButton,
                                        children: [
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$4176b1d4e95be624), {}),
                                            " ",
                                            buttonLibelle ?? "Ajouter"
                                        ]
                                    })
                                })
                            ]
                        }),
                        listeElements.map((value, index)=>{
                            return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("span", {
                                className: "d-flex bg-light m-4 p-3 border rounded-3 align-items-center",
                                children: [
                                    createComponentToRepeat(index, listeElements, typeModule),
                                    // On n'affiche le bouton supprimer que si la propriété "protected" ne vaut pas TRUE
                                    !readOnly && (!protectedProperty || value[protectedProperty] !== true) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                        className: "p-2 d-flex justify-content-end",
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $c094b74d2be2aa67$export$2e2bcd8739ae039), {
                                            title: "Supprimer",
                                            onClick: ()=>{
                                                elements.remove(index);
                                                setFieldValue(name, elements.form.values[name].filter((e)=>e !== value));
                                            },
                                            disabled: disabled
                                        })
                                    }, index)
                                ]
                            }, index);
                        })
                    ]
                })
        })
    });
};
var $665753c43020c55f$export$2e2bcd8739ae039 = $665753c43020c55f$var$AddRemoveComponent;









const $ed7d84930c1d31ac$export$a5cab80145b70e98 = (data, listePeiSelectionnable, vitesseEau, siteLibelle, typeReseauLibelle, maxDiametreCanalisation)=>({
        debitSimultaneNumeroDossier: data?.debitSimultaneNumeroDossier ?? null,
        siteLibelle: siteLibelle ?? null,
        maxDiametreCanalisation: maxDiametreCanalisation ?? null,
        typeReseauLibelle: typeReseauLibelle ?? null,
        listeDebitSimultaneMesure: data?.listeDebitSimultaneMesure ?? [],
        listePeiSelectionnable: listePeiSelectionnable,
        vitesseEau: vitesseEau
    });
const $ed7d84930c1d31ac$export$c084437b5e3206cd = (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({});
const $ed7d84930c1d31ac$export$f97400759cfd946 = (values)=>{
    const formData = new FormData();
    formData.append("debitSimultaneNumeroDossier", values.debitSimultaneNumeroDossier);
    formData.append("listeDebitSimultaneMesure", JSON.stringify(values.listeDebitSimultaneMesure.map((e)=>({
            debitSimultaneMesureId: e.debitSimultaneMesureId,
            debitSimultaneMesureDebitRequis: e.debitSimultaneMesureDebitRequis,
            debitSimultaneMesureDebitMesure: e.debitSimultaneMesureDebitMesure,
            debitSimultaneMesureDebitRetenu: e.debitSimultaneMesureDebitRetenu,
            debitSimultaneMesureDateMesure: e.debitSimultaneMesureDateMesure ? new Date(e.debitSimultaneMesureDateMesure).toISOString() : null,
            debitSimultaneMesureCommentaire: e.debitSimultaneMesureCommentaire,
            debitSimultaneMesureIdentiqueReseauVille: e.debitSimultaneMesureIdentiqueReseauVille ?? false,
            listePeiId: e.listePeiId,
            documentNomFichier: e.documentNomFichier
        }))));
    values.listeDebitSimultaneMesure.forEach((e)=>{
        formData.append("document_" + e.documentNomFichier, e.document);
    });
    return formData;
};
const $ed7d84930c1d31ac$var$DebitSimultane = ()=>{
    const { values: values } = (0, $bkJfK.useFormikContext)();
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                        displayReturnButton: false,
                        icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$e7e4d28a1367130c), {}),
                        title: "Gestion des d\xe9bits simultan\xe9s"
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                            name: "debitSimultaneNumeroDossier",
                            label: "Num\xe9ro de dossier"
                        })
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    className: "mt-2",
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        className: "bg-light p-2 border rounded",
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                                className: "fw-bold text-center p-2",
                                children: [
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$340bfce9b4df026b), {}),
                                    " Information"
                                ]
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                    children: [
                                        "Site : ",
                                        values.siteLibelle ?? ""
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                    children: [
                                        "Type de r\xe9seau : ",
                                        values.typeReseauLibelle ?? ""
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                    children: [
                                        "Diam\xe8tre maximal de canalisation :",
                                        " ",
                                        values.maxDiametreCanalisation ?? ""
                                    ]
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                    className: "text-primary",
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("hr", {})
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    className: "mt-3",
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $665753c43020c55f$export$2e2bcd8739ae039), {
                            name: "listeDebitSimultaneMesure",
                            createComponentToRepeat: (index)=>{
                                return $ed7d84930c1d31ac$var$createComponentToRepeat(index, values.listeDebitSimultaneMesure);
                            },
                            defaultElement: {
                                debitSimultaneMesureId: null,
                                debitSimultaneMesureDebitRequis: null,
                                debitSimultaneMesureDebitMesure: null,
                                debitSimultaneMesureDebitRetenu: null,
                                debitSimultaneMesureDateMesure: new Date(),
                                debitSimultaneMesureCommentaire: null,
                                debitSimultaneMesureIdentiqueReseauVille: false,
                                listePeiId: undefined
                            },
                            listeElements: values.listeDebitSimultaneMesure
                        })
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db9b0e6fdb142a4c$export$2e2bcd8739ae039), {})
            ]
        })
    });
};
const $ed7d84930c1d31ac$var$ComposantToRepeat = ({ index: index, listeElements: listeElements })=>{
    const { setValues: setValues, values: values, setFieldValue: setFieldValue } = (0, $bkJfK.useFormikContext)();
    const selectDebitRetenu = [];
    for(let i = 60; i <= 2400; i += 60)selectDebitRetenu.push({
        id: i.toString(),
        code: i.toString(),
        libelle: i.toString()
    });
    const defaultDateValue = listeElements[index].debitSimultaneMesureDateMesure ?? new Date();
    const defaultMesureValue = listeElements[index].debitSimultaneMesureDebitMesure ?? (values.vitesseEau && values.maxDiametreCanalisation && values.vitesseEau > 0 && values.maxDiametreCanalisation > 0 ? Math.floor(values.vitesseEau * Math.pow(Number(values.maxDiametreCanalisation) / 1000, 2) * 2826) : undefined);
    (0, $kc00y.useMemo)(()=>{
        const currentMesure = values.listeDebitSimultaneMesure[index];
        if (currentMesure.debitSimultaneMesureDateMesure === undefined) setFieldValue(`listeDebitSimultaneMesure[${index}].debitSimultaneMesureDateMesure`, defaultDateValue // formaté dans le back donc pas de formatage
        );
        if (currentMesure.debitSimultaneMesureDebitMesure === undefined) setFieldValue(`listeDebitSimultaneMesure[${index}].debitSimultaneMesureDebitMesure`, defaultMesureValue);
    }, [
        index,
        defaultDateValue,
        setFieldValue,
        defaultMesureValue,
        values.listeDebitSimultaneMesure[index]
    ]);
    (0, $kc00y.useEffect)(()=>{
        const defaultPeiValue = listeElements[index === 0 ? index : index - 1]?.listePeiId?.map((e)=>values.listePeiSelectionnable?.find((c)=>c.id === e)) ?? [];
        if (values.listeDebitSimultaneMesure[index]) {
            if (values.listeDebitSimultaneMesure[index].listePeiId === undefined && defaultPeiValue.length > 0) setFieldValue(`listeDebitSimultaneMesure[${index}].listePeiId`, defaultPeiValue.filter((e)=>e !== undefined).map((e)=>e.id));
        }
    }, [
        index,
        setFieldValue,
        listeElements,
        values.listeDebitSimultaneMesure,
        values.listePeiSelectionnable
    ]);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                className: "align-items-center mt-3",
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$183478aa40b5df1), {
                            name: `listeDebitSimultaneMesure[${index}].debitSimultaneMesureDateMesure`,
                            label: "Date de la mesure",
                            required: true,
                            value: (0, $00c47c7740afd024$export$cc23f907e4acb548)(values.listeDebitSimultaneMesure[index]?.debitSimultaneMesureDateMesure ?? defaultDateValue)
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$6bf0cd3a219bbade), {
                            name: `listeDebitSimultaneMesure[${index}].debitSimultaneMesureDebitRequis`,
                            label: "D\xe9bit requis (m\xb3/h)",
                            required: false
                        })
                    })
                ]
            }),
            !listeElements[index].debitSimultaneMesureIdentiqueReseauVille && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$6bf0cd3a219bbade), {
                            name: `listeDebitSimultaneMesure[${index}].debitSimultaneMesureDebitMesure`,
                            label: "D\xe9bit mesur\xe9 (m\xb3/h)",
                            required: false,
                            value: values.listeDebitSimultaneMesure[index]?.debitSimultaneMesureDebitMesure ?? defaultMesureValue
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                            name: `listeDebitSimultaneMesure[${index}].debitSimultaneMesureDebitRetenu`,
                            label: "D\xe9bit retenu (m\xb3/h)",
                            listIdCodeLibelle: selectDebitRetenu,
                            defaultValue: selectDebitRetenu?.find((e)=>e.id === listeElements[index].debitSimultaneMesureDebitRetenu?.toString()),
                            onChange: (e)=>{
                                setFieldValue(`listeDebitSimultaneMesure[${index}].debitSimultaneMesureDebitRetenu`, e.id);
                            },
                            required: true,
                            setValues: setValues
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$eae70af4b4e3f197), {
                            name: `listeDebitSimultaneMesure[${index}].listePeiId`,
                            label: "Liste des PEI",
                            options: values.listePeiSelectionnable,
                            getOptionValue: (t)=>t.id,
                            value: values.listePeiSelectionnable?.filter((c)=>{
                                const peiIds = (listeElements[index]?.listePeiId ?? []).filter((id)=>id !== undefined);
                                return c.id ? peiIds.includes(c.id) : false;
                            }) ?? [],
                            getOptionLabel: (t)=>t.libelle,
                            onChange: (pei)=>{
                                const peiId = pei.map((e)=>e.id);
                                setFieldValue(`listeDebitSimultaneMesure[${index}].listePeiId`, peiId.length > 0 ? peiId : []);
                            },
                            isClearable: true
                        }, index)
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                            name: `listeDebitSimultaneMesure[${index}].debitSimultaneMesureIdentiqueReseauVille`,
                            label: "Identique R\xe9seau Ville",
                            onChange: (e)=>{
                                setFieldValue(`listeDebitSimultaneMesure[${index}].debitSimultaneMesureIdentiqueReseauVille`, e.target.checked);
                                if (!e.target.checked) // Formule: Q (m³/s) = V * S = Vitesse_eau*(π*D²)/4; Q (m³/h) = Q(m³/s)*3600
                                setFieldValue(`listeDebitSimultaneMesure[${index}].debitSimultaneMesureDebitMesure`, Math.floor(values.vitesseEau * Math.pow(Number(values.maxDiametreCanalisation) / 1000, 2) * 2826));
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                className: "mt-3",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$ce9b1cc0c34506d0), {
                        name: `listeDebitSimultaneMesure[${index}].debitSimultaneMesureCommentaire`,
                        label: "Commentaire",
                        required: false
                    })
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b57af79a4ab2a1c6), {
                            name: `listeDebitSimultaneMesure[${index}].document`,
                            accept: "*.*",
                            label: "Attestation",
                            required: false,
                            onChange: (e)=>{
                                // Si on modifie le fichier, on supprime le document associé
                                setFieldValue(`listeDebitSimultaneMesure[${index}].documentId`, null);
                                setFieldValue(`listeDebitSimultaneMesure[${index}].document`, e.target.files[0]);
                                setFieldValue(`listeDebitSimultaneMesure[${index}].documentNomFichier`, e.target.files[0].name);
                            }
                        })
                    }),
                    listeElements[index].documentId && !listeElements[index].document && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                            variant: "link",
                            href: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/documents/telecharger/` + listeElements[index].documentId,
                            children: listeElements[index].documentNomFichier
                        })
                    })
                ]
            })
        ]
    });
};
function $ed7d84930c1d31ac$var$createComponentToRepeat(index, listeElements) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($ed7d84930c1d31ac$var$ComposantToRepeat, {
        index: index,
        listeElements: listeElements
    });
}
var $ed7d84930c1d31ac$export$2e2bcd8739ae039 = $ed7d84930c1d31ac$var$DebitSimultane;


const $c0d401b6231ce1af$var$UpdateDebitSimultane = ({ debitSimultaneId: debitSimultaneId, typeReseauId: typeReseauId, coordonneeX: coordonneeX, coordonneeY: coordonneeY, srid: srid, onSubmit: onSubmit })=>{
    const { data: data } = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/debit-simultane/get/` + debitSimultaneId);
    const { data: listePeiSelectionnable } = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/debit-simultane/pei?${{
        geometry: `SRID=${srid};POINT(${coordonneeX} ${coordonneeY})`,
        typeReseauId: typeReseauId
    }}`);
    return data && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
        initialValues: (0, $ed7d84930c1d31ac$export$a5cab80145b70e98)(data, listePeiSelectionnable, data.vitesseEau, data.siteLibelle, data.typeReseauLibelle, data.maxDiametreCanalisation),
        validationSchema: (0, $ed7d84930c1d31ac$export$c084437b5e3206cd),
        isPost: false,
        isMultipartFormData: true,
        submitUrl: `/api/debit-simultane/update/` + debitSimultaneId,
        prepareVariables: (values)=>(0, $ed7d84930c1d31ac$export$f97400759cfd946)(values),
        onSubmit: onSubmit,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ed7d84930c1d31ac$export$2e2bcd8739ae039), {})
    });
};
var $c0d401b6231ce1af$export$2e2bcd8739ae039 = $c0d401b6231ce1af$var$UpdateDebitSimultane;














var $bkJfK = parcelRequire("bkJfK");








/**
 * Utils permettant de récupérer un id, code et libelle
 * pour les enums
 * @param enumType Type de l'enum
 * @returns liste d'id code libelle pour toutes les valeurs de l'enum
 */ function $bb71d7e084b1948b$export$4e79f2b2ff1f6154(enumType) {
    return Object.entries(enumType).map(([key, value])=>{
        return {
            id: key,
            code: key,
            libelle: value.toString()
        };
    });
}


var $af5674812902f9b0$export$8e37720fa5eab116 = /*#__PURE__*/ function(TypeAire) {
    TypeAire["CROISEMENT"] = "Croisement";
    TypeAire["RETOURNEMENT"] = "Retournement";
    return TypeAire;
}({});
const $af5674812902f9b0$export$6edbd638009b9fd = (0, $bb71d7e084b1948b$export$4e79f2b2ff1f6154)($af5674812902f9b0$export$8e37720fa5eab116);






const $f93a7b4ddd19d0d7$export$315d1bfd0c11cdb3 = (data)=>({
        dfciAireId: data?.dfciAireId,
        dfciAireAmenagement: data?.dfciAireAmenagement ?? false,
        dfciAireDateGps: (0, $00c47c7740afd024$export$c6834cb9c1260d15)(data?.dfciAireDateGps ?? new Date()),
        dfciAireGrandeDimension: data?.dfciAireGrandeDimension,
        dfciAirePetiteDimension: data?.dfciAirePetiteDimension,
        dfciAireType: data?.dfciAireType,
        dfciAireGeometrie: data?.dfciAireGeometrie,
        dfciAireDfciPisteId: data?.dfciAireDfciPisteId,
        dfciAireRemarque: data?.dfciAireRemarque,
        dfciAireCode: data?.dfciAireCode,
        dfciAireVersion: data?.dfciAireVersion
    });
const $f93a7b4ddd19d0d7$export$fac8e025a192da06 = (values)=>({
        dfciAireId: values.dfciAireId,
        dfciAireAmenagement: values.dfciAireAmenagement,
        dfciAireDateGps: values.dfciAireDateGps ? new Date(values.dfciAireDateGps).toISOString() : null,
        dfciAireGrandeDimension: values.dfciAireGrandeDimension,
        dfciAirePetiteDimension: values.dfciAirePetiteDimension,
        dfciAireType: values.dfciAireType,
        dfciAireGeometrie: values.dfciAireGeometrie,
        dfciAireDfciPisteId: values.dfciAireDfciPisteId ?? null,
        dfciAireRemarque: values.dfciAireRemarque ?? null,
        dfciAireCode: values.dfciAireCode,
        dfciAireVersion: values.dfciAireVersion
    });
const $f93a7b4ddd19d0d7$export$736924de402fbf3d = (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({
    dfciAireAmenagement: (0, $36ceaed6faf947af$export$87bba3bb7a1f4285),
    dfciAireDateGps: (0, $36ceaed6faf947af$export$5cbf64e9c4f743ca),
    dfciAireType: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
    dfciAireDfciPisteId: (0, $ce4de947442b2ab1$export$22b082955e083ec3)().nullable()
});
const $f93a7b4ddd19d0d7$var$DfciAire = ({ readOnly: readOnly })=>{
    const { user: user } = (0, $e787cde576104469$export$fdc397e486fa83e7)();
    const { values: values, setFieldValue: setFieldValue } = (0, $bkJfK.useFormikContext)();
    const listPiste = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/dfci-pistes/piste-id-code-libelle?${{
        geometrie: values.dfciAireGeometrie
    }}`).data;
    const hasDroitUpdateDfciAire = (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).DFCI_AIRE_U);
    const isDisabled = readOnly || !hasDroitUpdateDfciAire;
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
        children: listPiste && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
            children: [
                !hasDroitUpdateDfciAire && !readOnly && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("p", {
                    className: "fade alert alert-danger show",
                    children: "Vous n'avez pas le droit de modification"
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                        name: "dfciAireAmenagement",
                        label: "Am\xe9nagement",
                        disabled: isDisabled,
                        checked: values.dfciAireAmenagement,
                        required: true
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$7edc06cf1783b30f), {
                        name: "dfciAireDateGps",
                        label: "Date GPS",
                        readOnly: true,
                        value: values.dfciAireDateGps,
                        required: true
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$6bf0cd3a219bbade), {
                        name: "dfciAireGrandeDimension",
                        label: "Plus grande dimension (en m\xe8tres)",
                        disabled: isDisabled,
                        value: values.dfciAireGrandeDimension,
                        min: 0,
                        step: 0.1,
                        required: false
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$6bf0cd3a219bbade), {
                        name: "dfciAirePetiteDimension",
                        label: "Plus petite dimension (en m\xe8tres)",
                        disabled: isDisabled,
                        value: values.dfciAirePetiteDimension,
                        min: 0,
                        step: 0.1,
                        required: false
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                        name: "dfciAireType",
                        listIdCodeLibelle: (0, $af5674812902f9b0$export$6edbd638009b9fd),
                        label: "Type d'aire",
                        defaultValue: (0, $af5674812902f9b0$export$6edbd638009b9fd)?.find((e)=>e.code === values.dfciAireType),
                        disabled: isDisabled,
                        setFieldValue: setFieldValue,
                        required: true
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                        name: "dfciAireDfciPisteId",
                        listIdCodeLibelle: listPiste,
                        label: "Piste",
                        defaultValue: values.dfciAireDfciPisteId ? listPiste.find((e)=>e.id === values.dfciAireDfciPisteId) : undefined,
                        disabled: true
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$ce9b1cc0c34506d0), {
                        name: "dfciAireRemarque",
                        label: "Remarque",
                        value: values.dfciAireRemarque,
                        required: false,
                        disabled: isDisabled
                    })
                }),
                !readOnly && hasDroitUpdateDfciAire && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db9b0e6fdb142a4c$export$2e2bcd8739ae039), {})
            ]
        })
    });
};
var $f93a7b4ddd19d0d7$export$2e2bcd8739ae039 = $f93a7b4ddd19d0d7$var$DfciAire;


const $d746c92b56648e40$export$d3dbec490536a542 = ({ aireId: aireId, onSubmit: onSubmit, readOnly: readOnly })=>{
    const { data: data } = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/dfci-aires/${aireId}`);
    if (!data) return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $c21b1c237cfa1d94$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                icon: readOnly ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$d7cfde09abbb52ee), {}) : /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$b51dd496211ae105), {}),
                title: readOnly ? "Visualisation de l'aire" : "Modification de l'aire",
                displayReturnButton: false
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                initialValues: (0, $f93a7b4ddd19d0d7$export$315d1bfd0c11cdb3)(data),
                isPost: false,
                prepareVariables: (0, $f93a7b4ddd19d0d7$export$fac8e025a192da06),
                validationSchema: (0, $f93a7b4ddd19d0d7$export$736924de402fbf3d),
                onSubmit: onSubmit,
                submitUrl: "/api/dfci-aires/update",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $f93a7b4ddd19d0d7$export$2e2bcd8739ae039), {
                    readOnly: readOnly
                })
            })
        ]
    });
};












var $bkJfK = parcelRequire("bkJfK");










var $fc3bf7eaea039709$export$19a645142872c8d0 = /*#__PURE__*/ function(TypeImpraticabilite) {
    TypeImpraticabilite["GABARIT"] = "Gabarit";
    TypeImpraticabilite["TONNAGE"] = "Tonnage";
    TypeImpraticabilite["ETAT_BDR"] = "Etat Bordure";
    TypeImpraticabilite["MULTIPLE"] = "Multiple";
    return TypeImpraticabilite;
}({});
var $fc3bf7eaea039709$export$32371f12c3ac8b52 = /*#__PURE__*/ function(TypeTravaux) {
    TypeTravaux["CREER"] = "Cr\xe9er";
    TypeTravaux["CONFORMITE"] = "Conformit\xe9";
    TypeTravaux["ENTRETENIR"] = "Entretenir";
    return TypeTravaux;
}({});
var $fc3bf7eaea039709$export$4c26b854f0148bda = /*#__PURE__*/ function(TypeVoie) {
    TypeVoie["DFCI"] = "DFCI";
    TypeVoie["MULTI"] = "Multi";
    TypeVoie["INTERFACE"] = "Interface";
    TypeVoie["PPRIF"] = "PPRIF";
    return TypeVoie;
}({});
var $fc3bf7eaea039709$export$d2130c704995535b = /*#__PURE__*/ function(TypeImpasse) {
    TypeImpasse["AMENAGEE"] = "Am\xe9nag\xe9e";
    TypeImpasse["NON_AMENAGEE"] = "Non am\xe9nag\xe9e";
    TypeImpasse["SANS"] = "Sans am\xe9nagement";
    return TypeImpasse;
}({});
var $fc3bf7eaea039709$export$13c636c97c42867 = /*#__PURE__*/ function(TypeFoncier) {
    TypeFoncier["DFCI"] = "DFCI";
    TypeFoncier["PUBLIC"] = "Public";
    TypeFoncier["PRIVE"] = "Priv\xe9";
    TypeFoncier["MIXTE"] = "Mixte";
    TypeFoncier["INCONNU"] = "Inconnu";
    return TypeFoncier;
}({});
var $fc3bf7eaea039709$export$62536b841beca8bf = /*#__PURE__*/ function(TypeCroisement) {
    TypeCroisement["GENERALISEE"] = "G\xe9n\xe9ralis\xe9e";
    TypeCroisement["PONCTUELLE"] = "Ponctuelle";
    TypeCroisement["SANS"] = "Sans croisement";
    return TypeCroisement;
}({});
var $fc3bf7eaea039709$export$c9012a9968920151 = /*#__PURE__*/ function(TypeProgramme) {
    TypeProgramme["IF"] = "IF";
    TypeProgramme["MCO"] = "MCO";
    TypeProgramme["AMP"] = "AMP";
    TypeProgramme["AUTRE"] = "Autre";
    return TypeProgramme;
}({});
const $fc3bf7eaea039709$export$59dcf1933ea87193 = (0, $bb71d7e084b1948b$export$4e79f2b2ff1f6154)($fc3bf7eaea039709$export$19a645142872c8d0);
const $fc3bf7eaea039709$export$52330988015f54b8 = (0, $bb71d7e084b1948b$export$4e79f2b2ff1f6154)($fc3bf7eaea039709$export$32371f12c3ac8b52);
const $fc3bf7eaea039709$export$7927f37fb4884444 = (0, $bb71d7e084b1948b$export$4e79f2b2ff1f6154)($fc3bf7eaea039709$export$4c26b854f0148bda);
const $fc3bf7eaea039709$export$7d89172afc8971d = (0, $bb71d7e084b1948b$export$4e79f2b2ff1f6154)($fc3bf7eaea039709$export$d2130c704995535b);
const $fc3bf7eaea039709$export$13c16a43e817215e = (0, $bb71d7e084b1948b$export$4e79f2b2ff1f6154)($fc3bf7eaea039709$export$13c636c97c42867);
const $fc3bf7eaea039709$export$80ccc07e80dcd26a = (0, $bb71d7e084b1948b$export$4e79f2b2ff1f6154)($fc3bf7eaea039709$export$62536b841beca8bf);
const $fc3bf7eaea039709$export$bbb452418c84de4c = (0, $bb71d7e084b1948b$export$4e79f2b2ff1f6154)($fc3bf7eaea039709$export$c9012a9968920151);


var $9f7bbcc5d0b28d10$export$61601f1f3093255c = /*#__PURE__*/ function(TypeDebroussaillement) {
    TypeDebroussaillement["DFCI"] = "DFCI";
    TypeDebroussaillement["ARCHIVE"] = "Archive";
    TypeDebroussaillement["AUTRE"] = "Autre";
    return TypeDebroussaillement;
}({});
const $9f7bbcc5d0b28d10$export$52330988015f54b8 = (0, $bb71d7e084b1948b$export$4e79f2b2ff1f6154)((0, $fc3bf7eaea039709$export$32371f12c3ac8b52));
const $9f7bbcc5d0b28d10$export$bbb452418c84de4c = (0, $bb71d7e084b1948b$export$4e79f2b2ff1f6154)((0, $fc3bf7eaea039709$export$c9012a9968920151));
const $9f7bbcc5d0b28d10$export$300db14b5655d18 = (0, $bb71d7e084b1948b$export$4e79f2b2ff1f6154)($9f7bbcc5d0b28d10$export$61601f1f3093255c);





const $3444a818c1ee2e24$export$b497d8cfbc4d5694 = (data)=>({
        dfciDebId: data?.dfciDebId,
        dfciDebLibelle: data?.dfciDebLibelle,
        dfciDebAnneeProgramme: data?.dfciDebAnneeProgramme,
        dfciDebAnneeTravaux: data?.dfciDebAnneeTravaux,
        dfciDebMoisTravaux: data?.dfciDebMoisTravaux,
        dfciDebAnneeEdition: data?.dfciDebAnneeEdition,
        dfciDebLargeur: data?.dfciDebLargeur,
        dfciDebSurface: data?.dfciDebSurface,
        dfciDebType: data?.dfciDebType,
        dfciDebGeometrie: data?.dfciDebGeometrie,
        dfciDebRemarque: data?.dfciDebRemarque,
        dfciDebProgramme: data?.dfciDebProgramme,
        dfciDebTravaux: data?.dfciDebTravaux,
        dfciDebDfciMassifId: data?.dfciDebDfciMassifId,
        dfciDebDfciOuvrageId: data?.dfciDebDfciOuvrageId,
        dfciDebDfciPrestataireId: data?.dfciDebDfciPrestataireId,
        dfciDebCode: data?.dfciDebCode,
        dfciDebVersion: data?.dfciDebVersion
    });
const $3444a818c1ee2e24$export$9b7373558a000b8d = (values)=>({
        dfciDebId: values.dfciDebId,
        dfciDebLibelle: values.dfciDebLibelle,
        dfciDebAnneeProgramme: values.dfciDebAnneeProgramme ?? null,
        dfciDebAnneeTravaux: values.dfciDebAnneeTravaux ?? null,
        dfciDebMoisTravaux: values.dfciDebMoisTravaux ?? null,
        dfciDebAnneeEdition: values.dfciDebAnneeEdition ?? null,
        dfciDebLargeur: values.dfciDebLargeur,
        dfciDebSurface: values.dfciDebSurface,
        dfciDebType: values.dfciDebType,
        dfciDebGeometrie: values.dfciDebGeometrie,
        dfciDebRemarque: values.dfciDebRemarque ?? null,
        dfciDebProgramme: values.dfciDebProgramme ?? null,
        dfciDebTravaux: values.dfciDebTravaux ?? null,
        dfciDebDfciMassifId: values.dfciDebDfciMassifId,
        dfciDebDfciOuvrageId: values.dfciDebDfciOuvrageId ?? null,
        dfciDebDfciPrestataireId: values.dfciDebDfciPrestataireId ?? null,
        dfciDebCode: values.dfciDebCode,
        dfciDebVersion: values.dfciDebVersion
    });
const $3444a818c1ee2e24$export$a03fe546ef4d7917 = (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({
    dfciDebLibelle: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
    dfciDebAnneeProgramme: (0, $ce4de947442b2ab1$export$98e628dec113755e)().nullable(),
    dfciDebAnneeTravaux: (0, $ce4de947442b2ab1$export$98e628dec113755e)().nullable(),
    dfciDebMoisTravaux: (0, $ce4de947442b2ab1$export$98e628dec113755e)().nullable(),
    dfciDebAnneeEdition: (0, $ce4de947442b2ab1$export$98e628dec113755e)().nullable(),
    dfciDebLargeur: (0, $36ceaed6faf947af$export$24a1e2b92fa94c07),
    dfciDebSurface: (0, $36ceaed6faf947af$export$24a1e2b92fa94c07),
    dfciDebType: (0, $ce4de947442b2ab1$export$22b082955e083ec3)(),
    dfciDebProgramme: (0, $ce4de947442b2ab1$export$22b082955e083ec3)().nullable(),
    dfciDebTravaux: (0, $ce4de947442b2ab1$export$22b082955e083ec3)().nullable(),
    dfciDebDfciMassifId: (0, $ce4de947442b2ab1$export$22b082955e083ec3)(),
    dfciDebDfciOuvrageId: (0, $ce4de947442b2ab1$export$22b082955e083ec3)().nullable(),
    dfciDebDfciPrestataireId: (0, $ce4de947442b2ab1$export$22b082955e083ec3)().nullable()
});
const $3444a818c1ee2e24$var$DfciDeb = ({ readOnly: readOnly })=>{
    const { user: user } = (0, $e787cde576104469$export$fdc397e486fa83e7)();
    const { values: values, setFieldValue: setFieldValue } = (0, $bkJfK.useFormikContext)();
    const listMassif = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/dfci/massif`).data;
    const listPrestataire = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/dfci/prestataire`).data;
    const listOuvrage = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/dfci/ouvrage`).data;
    const hasDroitUpdateDfciDeb = (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).DFCI_DEB_U);
    const isDisabled = readOnly || !hasDroitUpdateDfciDeb;
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
        children: listMassif && listPrestataire && listOuvrage && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
            children: [
                !hasDroitUpdateDfciDeb && !readOnly && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("p", {
                    className: "fade alert alert-danger show",
                    children: "Vous n'avez pas le droit de modification"
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                        name: "dfciDebLibelle",
                        label: "Libell\xe9",
                        disabled: isDisabled,
                        value: values.dfciDebLibelle,
                        required: true
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                        name: "dfciDebDfciMassifId",
                        listIdCodeLibelle: listMassif,
                        label: "Massif",
                        defaultValue: values.dfciDebDfciMassifId ? listMassif.find((e)=>e.id === values.dfciDebDfciMassifId) : undefined,
                        disabled: true,
                        required: true
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$6bf0cd3a219bbade), {
                        name: "dfciDebLargeur",
                        label: "Largeur (en m\xe8tres)",
                        disabled: true,
                        value: values.dfciDebLargeur,
                        required: true,
                        step: 0.1
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$6bf0cd3a219bbade), {
                        name: "dfciDebSurface",
                        label: "Surface (au dixi\xe8me d'hectare)",
                        disabled: isDisabled,
                        value: values.dfciDebSurface,
                        required: true,
                        min: 0,
                        step: 0.1
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                        name: "dfciDebType",
                        listIdCodeLibelle: (0, $9f7bbcc5d0b28d10$export$300db14b5655d18),
                        label: "Type de d\xe9broussaillement",
                        defaultValue: values.dfciDebType ? (0, $9f7bbcc5d0b28d10$export$300db14b5655d18).find((e)=>e.id === values.dfciDebType) : undefined,
                        disabled: isDisabled,
                        required: true,
                        setFieldValue: setFieldValue
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$2e2bcd8739ae039), {
                        name: "dfciDebMoisTravaux",
                        label: "Mois des travaux",
                        disabled: isDisabled,
                        value: values.dfciDebMoisTravaux,
                        required: false
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$2e2bcd8739ae039), {
                        name: "dfciDebAnneeTravaux",
                        label: "Ann\xe9e des travaux",
                        disabled: isDisabled,
                        value: values.dfciDebAnneeTravaux,
                        required: false
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                        name: "dfciDebTravaux",
                        listIdCodeLibelle: (0, $9f7bbcc5d0b28d10$export$52330988015f54b8),
                        label: "Type de travaux",
                        defaultValue: values.dfciDebTravaux ? (0, $9f7bbcc5d0b28d10$export$52330988015f54b8).find((e)=>e.id === values.dfciDebTravaux) : undefined,
                        disabled: isDisabled,
                        required: false,
                        setFieldValue: setFieldValue
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$2e2bcd8739ae039), {
                        name: "dfciDebAnneeEdition",
                        label: "Ann\xe9e de l'\xe9dition",
                        disabled: true,
                        value: values.dfciDebAnneeEdition,
                        required: false
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$2e2bcd8739ae039), {
                        name: "dfciDebAnneeProgramme",
                        label: "Ann\xe9e de programmation",
                        disabled: isDisabled,
                        value: values.dfciDebAnneeProgramme,
                        required: false
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                        name: "dfciDebProgramme",
                        listIdCodeLibelle: (0, $9f7bbcc5d0b28d10$export$bbb452418c84de4c),
                        label: "Type de programmation",
                        defaultValue: values.dfciDebProgramme ? (0, $9f7bbcc5d0b28d10$export$bbb452418c84de4c).find((e)=>e.id === values.dfciDebProgramme) : undefined,
                        disabled: isDisabled,
                        required: false,
                        setFieldValue: setFieldValue
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                        name: "dfciDebDfciPrestataireId",
                        listIdCodeLibelle: listPrestataire,
                        label: "Prestataire",
                        defaultValue: values.dfciDebDfciPrestataireId ? listPrestataire.find((e)=>e.id === values.dfciDebDfciPrestataireId) : undefined,
                        disabled: isDisabled,
                        required: false,
                        setFieldValue: setFieldValue
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                        name: "dfciDebDfciOuvrageId",
                        listIdCodeLibelle: listOuvrage,
                        label: "Ouvrage",
                        defaultValue: values.dfciDebDfciOuvrageId ? listOuvrage.find((e)=>e.id === values.dfciDebDfciOuvrageId) : undefined,
                        disabled: true,
                        required: false
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$ce9b1cc0c34506d0), {
                        name: "dfciDebRemarque",
                        label: "Remarque",
                        value: values.dfciDebRemarque,
                        required: false,
                        disabled: isDisabled
                    })
                }),
                !readOnly && hasDroitUpdateDfciDeb && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db9b0e6fdb142a4c$export$2e2bcd8739ae039), {})
            ]
        })
    });
};
var $3444a818c1ee2e24$export$2e2bcd8739ae039 = $3444a818c1ee2e24$var$DfciDeb;


const $3cce4f8c1dd88eab$export$9ae15ae284067d3f = ({ debId: debId, onSubmit: onSubmit, readOnly: readOnly })=>{
    const { data: data } = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/dfci-deb/${debId}`);
    if (!data) return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $c21b1c237cfa1d94$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                icon: readOnly ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$d7cfde09abbb52ee), {}) : /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$b51dd496211ae105), {}),
                title: readOnly ? `Visualisation de ${data.dfciDebLibelle}` : `Modification de ${data.dfciDebLibelle}`,
                displayReturnButton: false
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                initialValues: (0, $3444a818c1ee2e24$export$b497d8cfbc4d5694)(data),
                isPost: false,
                prepareVariables: (0, $3444a818c1ee2e24$export$9b7373558a000b8d),
                validationSchema: (0, $3444a818c1ee2e24$export$a03fe546ef4d7917),
                onSubmit: onSubmit,
                submitUrl: "/api/dfci-deb/update",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $3444a818c1ee2e24$export$2e2bcd8739ae039), {
                    readOnly: readOnly
                })
            })
        ]
    });
};












var $bkJfK = parcelRequire("bkJfK");









var $92752aed6919c0f5$export$9eceb5f4ed2489f3 = /*#__PURE__*/ function(TypeEquipement) {
    TypeEquipement["POINT_EAU"] = "Point d'eau";
    TypeEquipement["DIRECTION"] = "Direction";
    TypeEquipement["ENTREE_PISTE"] = "Entr\xe9e piste";
    return TypeEquipement;
}({});
var $92752aed6919c0f5$export$d78a60c27b1fe292 = /*#__PURE__*/ function(TypePanneau) {
    TypePanneau["SIGNAL_COMPLEMENT"] = "Signal compl\xe9mentaire";
    TypePanneau["SIGNAL_PRINCIPAL"] = "Signal principal";
    return TypePanneau;
}({});
var $92752aed6919c0f5$export$50bbbe6990aaa5b9 = /*#__PURE__*/ function(TypePosition) {
    TypePosition["GAUCHE"] = "Gauche";
    TypePosition["DROITE"] = "Droite";
    return TypePosition;
}({});
var $92752aed6919c0f5$export$6cf9403345ede289 = /*#__PURE__*/ function(TypeBZero) {
    TypeBZero["PERMANENT"] = "Permanent";
    TypeBZero["TEMPORAIRE"] = "Temporaire";
    TypeBZero["AUCUN"] = "Aucun";
    return TypeBZero;
}({});
const $92752aed6919c0f5$export$50d229de821c9bd1 = (0, $bb71d7e084b1948b$export$4e79f2b2ff1f6154)($92752aed6919c0f5$export$d78a60c27b1fe292);
const $92752aed6919c0f5$export$8ae4e6d3fe00f561 = (0, $bb71d7e084b1948b$export$4e79f2b2ff1f6154)($92752aed6919c0f5$export$6cf9403345ede289);
const $92752aed6919c0f5$export$dc63abb717514f16 = (0, $bb71d7e084b1948b$export$4e79f2b2ff1f6154)($92752aed6919c0f5$export$50bbbe6990aaa5b9);
const $92752aed6919c0f5$export$f490cf69d2db7a8a = (0, $bb71d7e084b1948b$export$4e79f2b2ff1f6154)($92752aed6919c0f5$export$9eceb5f4ed2489f3);






const $8778c90e7f5e037f$export$830fa9b2938d5274 = (data)=>({
        dfciPanneauId: data?.dfciPanneauId,
        dfciPanneauType: data?.dfciPanneauType,
        dfciPanneauEtat: data?.dfciPanneauEtat ?? false,
        dfciPanneauBzero: data?.dfciPanneauBzero,
        dfciPanneauDateGps: (0, $00c47c7740afd024$export$c6834cb9c1260d15)(data?.dfciPanneauDateGps ?? new Date()),
        dfciPanneauPosition: data?.dfciPanneauPosition,
        dfciPanneauEquipement: data?.dfciPanneauEquipement,
        dfciPanneauDfciPisteId: data?.dfciPanneauDfciPisteId,
        dfciPanneauNumPiste: data?.dfciPanneauNumPiste ?? false,
        dfciPanneauLibellePiste: data?.dfciPanneauLibellePiste ?? false,
        dfciPanneauRemarque: data?.dfciPanneauRemarque,
        dfciPanneauGeometrie: data?.dfciPanneauGeometrie,
        dfciPanneauCode: data?.dfciPanneauCode,
        dfciPanneauVersion: data?.dfciPanneauVersion
    });
const $8778c90e7f5e037f$export$20d3eff613240161 = (values)=>({
        dfciPanneauId: values.dfciPanneauId,
        dfciPanneauType: values.dfciPanneauType,
        dfciPanneauEtat: values.dfciPanneauEtat,
        dfciPanneauBzero: values.dfciPanneauBzero,
        dfciPanneauDateGps: values.dfciPanneauDateGps ? new Date(values.dfciPanneauDateGps).toISOString() : null,
        dfciPanneauPosition: values.dfciPanneauPosition,
        dfciPanneauEquipement: values.dfciPanneauEquipement,
        dfciPanneauDfciPisteId: values.dfciPanneauDfciPisteId,
        dfciPanneauNumPiste: values.dfciPanneauNumPiste,
        dfciPanneauLibellePiste: values.dfciPanneauLibellePiste,
        dfciPanneauRemarque: values.dfciPanneauRemarque ?? null,
        dfciPanneauGeometrie: values.dfciPanneauGeometrie,
        dfciPanneauCode: values.dfciPanneauCode,
        dfciPanneauVersion: values.dfciPanneauVersion
    });
const $8778c90e7f5e037f$export$f758b7d319675e5e = (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({
    dfciPanneauType: (0, $ce4de947442b2ab1$export$22b082955e083ec3)(),
    dfciPanneauEtat: (0, $36ceaed6faf947af$export$87bba3bb7a1f4285),
    dfciPanneauBzero: (0, $ce4de947442b2ab1$export$22b082955e083ec3)(),
    dfciPanneauDateGps: (0, $36ceaed6faf947af$export$5cbf64e9c4f743ca),
    dfciPanneauPosition: (0, $ce4de947442b2ab1$export$22b082955e083ec3)(),
    dfciPanneauEquipement: (0, $ce4de947442b2ab1$export$22b082955e083ec3)(),
    dfciPanneauDfciPisteId: (0, $ce4de947442b2ab1$export$22b082955e083ec3)(),
    dfciPanneauNumPiste: (0, $36ceaed6faf947af$export$87bba3bb7a1f4285),
    dfciPanneauLibellePiste: (0, $36ceaed6faf947af$export$87bba3bb7a1f4285),
    dfciPanneauRemarque: (0, $ce4de947442b2ab1$export$22b082955e083ec3)().nullable()
});
const $8778c90e7f5e037f$var$DfciPanneau = ({ readOnly: readOnly })=>{
    const { user: user } = (0, $e787cde576104469$export$fdc397e486fa83e7)();
    const { values: values, setFieldValue: setFieldValue } = (0, $bkJfK.useFormikContext)();
    const listPiste = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/dfci-pistes/piste-id-code-libelle?${{
        geometrie: values.dfciPanneauGeometrie
    }}`).data;
    const hasDroitUpdateDfciPanneau = (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).DFCI_PANNEAU_U);
    const isDisabled = readOnly || !hasDroitUpdateDfciPanneau;
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
        children: listPiste && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
            children: [
                !hasDroitUpdateDfciPanneau && !readOnly && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("p", {
                    className: "fade alert alert-danger show",
                    children: "Vous n'avez pas le droit de modification"
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                        name: "dfciPanneauType",
                        listIdCodeLibelle: (0, $92752aed6919c0f5$export$50d229de821c9bd1),
                        label: "Type de panneau",
                        defaultValue: values.dfciPanneauType ? (0, $92752aed6919c0f5$export$50d229de821c9bd1).find((e)=>e.id === values.dfciPanneauType) : undefined,
                        disabled: isDisabled,
                        required: true,
                        setFieldValue: setFieldValue
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                        name: "dfciPanneauEtat",
                        label: "En bon \xe9tat",
                        disabled: isDisabled,
                        checked: values.dfciPanneauEtat,
                        required: true
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                        name: "dfciPanneauBzero",
                        listIdCodeLibelle: (0, $92752aed6919c0f5$export$8ae4e6d3fe00f561),
                        label: "Type B0",
                        defaultValue: values.dfciPanneauBzero ? (0, $92752aed6919c0f5$export$8ae4e6d3fe00f561).find((e)=>e.id === values.dfciPanneauBzero) : undefined,
                        disabled: isDisabled,
                        required: true,
                        setFieldValue: setFieldValue
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$7edc06cf1783b30f), {
                        name: "dfciPanneauDateGps",
                        label: "Date GPS",
                        readOnly: true,
                        value: values.dfciPanneauDateGps,
                        required: true
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                        name: "dfciPanneauPosition",
                        listIdCodeLibelle: (0, $92752aed6919c0f5$export$dc63abb717514f16),
                        label: "Position",
                        defaultValue: values.dfciPanneauPosition ? (0, $92752aed6919c0f5$export$dc63abb717514f16).find((e)=>e.id === values.dfciPanneauPosition) : undefined,
                        disabled: isDisabled,
                        required: true,
                        setFieldValue: setFieldValue
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                        name: "dfciPanneauEquipement",
                        listIdCodeLibelle: (0, $92752aed6919c0f5$export$f490cf69d2db7a8a),
                        label: "Equipement",
                        defaultValue: values.dfciPanneauEquipement ? (0, $92752aed6919c0f5$export$f490cf69d2db7a8a).find((e)=>e.id === values.dfciPanneauEquipement) : undefined,
                        disabled: isDisabled,
                        required: true,
                        setFieldValue: setFieldValue
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                        name: "dfciPanneauDfciPisteId",
                        listIdCodeLibelle: listPiste,
                        label: "Piste",
                        defaultValue: values.dfciPanneauDfciPisteId ? listPiste.find((e)=>e.id === values.dfciPanneauDfciPisteId) : undefined,
                        disabled: true,
                        required: true
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                        name: "dfciPanneauNumPiste",
                        label: "Pr\xe9sence du n\xb0 de piste",
                        disabled: isDisabled,
                        checked: values.dfciPanneauNumPiste,
                        required: true
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                        name: "dfciPanneauLibellePiste",
                        label: "Pr\xe9sence du libell\xe9 de piste",
                        disabled: isDisabled,
                        checked: values.dfciPanneauLibellePiste,
                        required: true
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$ce9b1cc0c34506d0), {
                        name: "dfciPanneauRemarque",
                        label: "Remarque",
                        disabled: isDisabled,
                        value: values.dfciPanneauRemarque,
                        required: false
                    })
                }),
                !readOnly && hasDroitUpdateDfciPanneau && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db9b0e6fdb142a4c$export$2e2bcd8739ae039), {})
            ]
        })
    });
};
var $8778c90e7f5e037f$export$2e2bcd8739ae039 = $8778c90e7f5e037f$var$DfciPanneau;


const $cab523073391bfe2$export$e71b238f6052f84a = ({ panneauId: panneauId, onSubmit: onSubmit, readOnly: readOnly })=>{
    const { data: data } = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/dfci-panneau/${panneauId}`);
    if (!data) return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $c21b1c237cfa1d94$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                icon: readOnly ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$d7cfde09abbb52ee), {}) : /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$b51dd496211ae105), {}),
                title: readOnly ? "Visualisation du panneau" : "Modification du panneau",
                displayReturnButton: false
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                initialValues: (0, $8778c90e7f5e037f$export$830fa9b2938d5274)(data),
                isPost: false,
                prepareVariables: (0, $8778c90e7f5e037f$export$20d3eff613240161),
                validationSchema: (0, $8778c90e7f5e037f$export$f758b7d319675e5e),
                onSubmit: onSubmit,
                submitUrl: "/api/dfci-panneau/update",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8778c90e7f5e037f$export$2e2bcd8739ae039), {
                    readOnly: readOnly
                })
            })
        ]
    });
};












var $bkJfK = parcelRequire("bkJfK");













const $bd36fbb11165aa20$export$8d50245677c3dc29 = (data)=>({
        dfciPisteId: data?.dfciPisteId,
        dfciPisteAdresse: data?.dfciPisteAdresse,
        dfciPisteAnneeProgramme: data?.dfciPisteAnneeProgramme,
        dfciPisteAnneeTravaux: data?.dfciPisteAnneeTravaux,
        dfciPisteCirculation: data?.dfciPisteCirculation ?? false,
        dfciPisteDateGps: (0, $00c47c7740afd024$export$c6834cb9c1260d15)(data?.dfciPisteDateGps ?? new Date()),
        dfciPisteLibelle: data?.dfciPisteLibelle,
        dfciPisteNumero: data?.dfciPisteNumero,
        dfciPisteOuverture: data?.dfciPisteOuverture ?? false,
        dfciPisteEstDfci: data?.dfciPisteEstDfci ?? false,
        dfciPisteRetournement: data?.dfciPisteRetournement ?? false,
        dfciPisteNumTroncon: data?.dfciPisteNumTroncon,
        dfciPisteNumObjectif: data?.dfciPisteNumObjectif,
        dfciPisteLibelleObjectif: data?.dfciPisteLibelleObjectif,
        dfciPisteGeometrie: data?.dfciPisteGeometrie,
        dfciPistePraticabilite: data?.dfciPistePraticabilite ?? false,
        dfciPisteRemarque: data?.dfciPisteRemarque,
        dfciPisteImpraticabilite: data?.dfciPisteImpraticabilite,
        dfciPisteTravaux: data?.dfciPisteTravaux,
        dfciPisteVoie: data?.dfciPisteVoie,
        dfciPisteImpasse: data?.dfciPisteImpasse,
        dfciPisteFoncier: data?.dfciPisteFoncier,
        dfciPisteCroisement: data?.dfciPisteCroisement,
        dfciPisteProgramme: data?.dfciPisteProgramme,
        dfciPisteDfciCategoriePisteId: data?.dfciPisteDfciCategoriePisteId,
        dfciPisteDfciMassifId: data?.dfciPisteDfciMassifId,
        dfciPisteDfciPrestataireId: data?.dfciPisteDfciPrestataireId,
        dfciPisteDfciOuvrageId: data?.dfciPisteDfciOuvrageId,
        dfciPisteCode: data?.dfciPisteCode,
        dfciPisteVersion: data?.dfciPisteVersion
    });
const $bd36fbb11165aa20$export$fbfb1796a38b4c89 = (values)=>({
        dfciPisteId: values.dfciPisteId,
        dfciPisteAdresse: values.dfciPisteAdresse ?? null,
        dfciPisteAnneeProgramme: values.dfciPisteAnneeProgramme ?? null,
        dfciPisteAnneeTravaux: values.dfciPisteAnneeTravaux ?? null,
        dfciPisteCirculation: values.dfciPisteCirculation,
        dfciPisteDateGps: values.dfciPisteDateGps ? new Date(values.dfciPisteDateGps).toISOString() : null,
        dfciPisteLibelle: values.dfciPisteLibelle,
        dfciPisteNumero: values.dfciPisteNumero,
        dfciPisteOuverture: values.dfciPisteOuverture,
        dfciPisteEstDfci: values.dfciPisteEstDfci,
        dfciPisteRetournement: values.dfciPisteRetournement,
        dfciPisteNumTroncon: values.dfciPisteNumTroncon,
        dfciPisteNumObjectif: values.dfciPisteNumObjectif ?? null,
        dfciPisteLibelleObjectif: values.dfciPisteLibelleObjectif ?? null,
        dfciPistePraticabilite: values.dfciPistePraticabilite,
        dfciPisteRemarque: values.dfciPisteRemarque ?? null,
        dfciPisteImpraticabilite: values.dfciPisteImpraticabilite ?? null,
        dfciPisteGeometrie: values.dfciPisteGeometrie,
        dfciPisteTravaux: values.dfciPisteTravaux ?? null,
        dfciPisteVoie: values.dfciPisteVoie,
        dfciPisteImpasse: values.dfciPisteImpasse,
        dfciPisteFoncier: values.dfciPisteFoncier ?? null,
        dfciPisteCroisement: values.dfciPisteCroisement,
        dfciPisteProgramme: values.dfciPisteProgramme ?? null,
        dfciPisteDfciCategoriePisteId: values.dfciPisteDfciCategoriePisteId,
        dfciPisteDfciMassifId: values.dfciPisteDfciMassifId,
        dfciPisteDfciPrestataireId: values.dfciPisteDfciPrestataireId ?? null,
        dfciPisteDfciOuvrageId: values.dfciPisteDfciOuvrageId ?? null,
        dfciPisteCode: values.dfciPisteCode,
        dfciPisteVersion: values.dfciPisteVersion
    });
const $bd36fbb11165aa20$export$26cda8e50f14b9fa = (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({
    dfciPisteAdresse: (0, $ce4de947442b2ab1$export$22b082955e083ec3)().nullable(),
    dfciPisteAnneeProgramme: (0, $ce4de947442b2ab1$export$98e628dec113755e)().nullable(),
    dfciPisteAnneeTravaux: (0, $ce4de947442b2ab1$export$98e628dec113755e)().nullable(),
    dfciPisteCirculation: (0, $36ceaed6faf947af$export$87bba3bb7a1f4285),
    dfciPisteDateGps: (0, $36ceaed6faf947af$export$5cbf64e9c4f743ca),
    dfciPisteLibelle: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
    dfciPisteNumero: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
    dfciPisteOuverture: (0, $36ceaed6faf947af$export$87bba3bb7a1f4285),
    dfciPisteEstDfci: (0, $36ceaed6faf947af$export$87bba3bb7a1f4285),
    dfciPisteRetournement: (0, $36ceaed6faf947af$export$87bba3bb7a1f4285),
    dfciPisteNumTroncon: (0, $ce4de947442b2ab1$export$98e628dec113755e)(),
    dfciPisteNumObjectif: (0, $ce4de947442b2ab1$export$98e628dec113755e)().nullable(),
    dfciPisteLibelleObjectif: (0, $ce4de947442b2ab1$export$22b082955e083ec3)().nullable(),
    dfciPistePraticabilite: (0, $36ceaed6faf947af$export$87bba3bb7a1f4285),
    dfciPisteImpraticabilite: (0, $ce4de947442b2ab1$export$22b082955e083ec3)().nullable(),
    dfciPisteTravaux: (0, $ce4de947442b2ab1$export$22b082955e083ec3)().nullable(),
    dfciPisteVoie: (0, $ce4de947442b2ab1$export$22b082955e083ec3)(),
    dfciPisteImpasse: (0, $ce4de947442b2ab1$export$22b082955e083ec3)(),
    dfciPisteFoncier: (0, $ce4de947442b2ab1$export$22b082955e083ec3)().nullable(),
    dfciPisteCroisement: (0, $ce4de947442b2ab1$export$22b082955e083ec3)(),
    dfciPisteProgramme: (0, $ce4de947442b2ab1$export$22b082955e083ec3)().nullable(),
    dfciPisteDfciCategoriePisteId: (0, $ce4de947442b2ab1$export$22b082955e083ec3)(),
    dfciPisteDfciMassifId: (0, $ce4de947442b2ab1$export$22b082955e083ec3)(),
    dfciPisteDfciPrestataireId: (0, $ce4de947442b2ab1$export$22b082955e083ec3)().nullable(),
    dfciPisteDfciOuvrageId: (0, $ce4de947442b2ab1$export$22b082955e083ec3)().nullable()
});
const $bd36fbb11165aa20$var$DfciPiste = ({ readOnly: readOnly })=>{
    const { values: values, setFieldValue: setFieldValue } = (0, $bkJfK.useFormikContext)();
    const listCategoPiste = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/dfci/catego-piste`).data;
    const listMassif = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/dfci/massif`).data;
    const listPrestataire = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/dfci/prestataire`).data;
    const listOuvrage = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/dfci/ouvrage`).data;
    const { user: user } = (0, $e787cde576104469$export$fdc397e486fa83e7)();
    const hasDroitUpdateDfciPiste = (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).DFCI_PISTE_U);
    const isDisabled = readOnly || !hasDroitUpdateDfciPiste;
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
        children: listCategoPiste && listMassif && listPrestataire && listOuvrage && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
            children: [
                !hasDroitUpdateDfciPiste && !readOnly && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("p", {
                    className: "fade alert alert-danger show",
                    children: "Vous n'avez pas le droit de modification"
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                        name: "dfciPisteLibelle",
                        label: "Piste",
                        disabled: isDisabled,
                        value: values.dfciPisteLibelle,
                        required: true
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                        name: "dfciPisteNumero",
                        label: "N\xb0 de la piste",
                        disabled: true,
                        value: values.dfciPisteNumero,
                        required: true
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                        name: "dfciPisteDfciCategoriePisteId",
                        listIdCodeLibelle: listCategoPiste,
                        label: "Cat\xe9gorie de piste",
                        defaultValue: values.dfciPisteDfciCategoriePisteId ? listCategoPiste.find((e)=>e.id === values.dfciPisteDfciCategoriePisteId) : undefined,
                        disabled: true,
                        required: true
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                        name: "dfciPisteAdresse",
                        label: "Adresse",
                        disabled: isDisabled,
                        value: values.dfciPisteAdresse,
                        required: false
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                        name: "dfciPisteDfciMassifId",
                        listIdCodeLibelle: listMassif,
                        label: "Massif",
                        defaultValue: values.dfciPisteDfciMassifId ? listMassif.find((e)=>e.id === values.dfciPisteDfciMassifId) : undefined,
                        disabled: true,
                        required: true
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$7edc06cf1783b30f), {
                        name: "dfciPisteDateGps",
                        label: "Date GPS",
                        readOnly: true,
                        value: values.dfciPisteDateGps,
                        required: true
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                        name: "dfciPisteEstDfci",
                        label: "Est une piste DFCI",
                        disabled: true,
                        checked: values.dfciPisteEstDfci,
                        required: true
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                        name: "dfciPisteCirculation",
                        label: "Circulation praticable",
                        disabled: true,
                        checked: values.dfciPisteCirculation,
                        required: true
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                        name: "dfciPistePraticabilite",
                        label: "Praticabilit\xe9",
                        disabled: isDisabled,
                        checked: values.dfciPistePraticabilite,
                        required: true
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                        name: "dfciPisteImpraticabilite",
                        listIdCodeLibelle: (0, $fc3bf7eaea039709$export$59dcf1933ea87193),
                        label: "Type d'impraticabilit\xe9",
                        defaultValue: values.dfciPisteImpraticabilite ? (0, $fc3bf7eaea039709$export$59dcf1933ea87193).find((e)=>e.id === values.dfciPisteImpraticabilite) : undefined,
                        disabled: isDisabled,
                        required: false,
                        setFieldValue: setFieldValue
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                        name: "dfciPisteOuverture",
                        label: "Ouverte au public",
                        disabled: true,
                        checked: values.dfciPisteOuverture,
                        required: true
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                        name: "dfciPisteRetournement",
                        label: "Retournement possible",
                        disabled: true,
                        checked: values.dfciPisteRetournement,
                        required: true
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$2e2bcd8739ae039), {
                        name: "dfciPisteNumTroncon",
                        label: "N\xb0 du tron\xe7on",
                        disabled: true,
                        value: values.dfciPisteNumTroncon,
                        required: true
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$2e2bcd8739ae039), {
                        name: "dfciPisteNumObjectif",
                        label: "N\xb0 de l'objectif",
                        disabled: true,
                        value: values.dfciPisteNumObjectif,
                        required: false
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                        name: "dfciPisteLibelleObjectif",
                        label: "Libell\xe9 de l'objectif",
                        disabled: true,
                        value: values.dfciPisteLibelleObjectif,
                        required: false
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$2e2bcd8739ae039), {
                        name: "dfciPisteAnneeTravaux",
                        label: "Ann\xe9e des travaux",
                        disabled: isDisabled,
                        value: values.dfciPisteAnneeTravaux,
                        required: false
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                        name: "dfciPisteTravaux",
                        listIdCodeLibelle: (0, $fc3bf7eaea039709$export$52330988015f54b8),
                        label: "Type de travaux",
                        defaultValue: values.dfciPisteTravaux ? (0, $fc3bf7eaea039709$export$52330988015f54b8).find((e)=>e.id === values.dfciPisteTravaux) : undefined,
                        disabled: isDisabled,
                        required: false,
                        setFieldValue: setFieldValue
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                        name: "dfciPisteCroisement",
                        listIdCodeLibelle: (0, $fc3bf7eaea039709$export$80ccc07e80dcd26a),
                        label: "Type de croisement",
                        defaultValue: values.dfciPisteCroisement ? (0, $fc3bf7eaea039709$export$80ccc07e80dcd26a).find((e)=>e.id === values.dfciPisteCroisement) : undefined,
                        disabled: true,
                        required: true
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                        name: "dfciPisteImpasse",
                        listIdCodeLibelle: (0, $fc3bf7eaea039709$export$7d89172afc8971d),
                        label: "Type d'impasse",
                        defaultValue: values.dfciPisteImpasse ? (0, $fc3bf7eaea039709$export$7d89172afc8971d).find((e)=>e.id === values.dfciPisteImpasse) : undefined,
                        disabled: true,
                        required: true
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                        name: "dfciPisteVoie",
                        listIdCodeLibelle: (0, $fc3bf7eaea039709$export$7927f37fb4884444),
                        label: "Type de voie",
                        defaultValue: values.dfciPisteVoie ? (0, $fc3bf7eaea039709$export$7927f37fb4884444).find((e)=>e.id === values.dfciPisteVoie) : undefined,
                        disabled: true,
                        required: true,
                        setFieldValue: setFieldValue
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$2e2bcd8739ae039), {
                        name: "dfciPisteAnneeProgramme",
                        label: "Ann\xe9e de programmation",
                        disabled: isDisabled,
                        value: values.dfciPisteAnneeProgramme,
                        required: false
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                        name: "dfciPisteProgramme",
                        listIdCodeLibelle: (0, $fc3bf7eaea039709$export$bbb452418c84de4c),
                        label: "Type de programmation",
                        defaultValue: values.dfciPisteProgramme ? (0, $fc3bf7eaea039709$export$bbb452418c84de4c).find((e)=>e.id === values.dfciPisteProgramme) : undefined,
                        disabled: isDisabled,
                        required: false,
                        setFieldValue: setFieldValue
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                        name: "dfciPisteFoncier",
                        listIdCodeLibelle: (0, $fc3bf7eaea039709$export$13c16a43e817215e),
                        label: "Foncier",
                        defaultValue: values.dfciPisteFoncier ? (0, $fc3bf7eaea039709$export$13c16a43e817215e).find((e)=>e.id === values.dfciPisteFoncier) : undefined,
                        disabled: isDisabled,
                        required: false,
                        setFieldValue: setFieldValue
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                        name: "dfciPisteDfciPrestataireId",
                        listIdCodeLibelle: listPrestataire,
                        label: "Prestataire",
                        defaultValue: values.dfciPisteDfciPrestataireId ? listPrestataire.find((e)=>e.id === values.dfciPisteDfciPrestataireId) : undefined,
                        required: false,
                        disabled: isDisabled,
                        setFieldValue: setFieldValue
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                        name: "dfciPisteDfciOuvrageId",
                        listIdCodeLibelle: listOuvrage,
                        label: "Ouvrage",
                        defaultValue: values.dfciPisteDfciOuvrageId ? listOuvrage.find((e)=>e.id === values.dfciPisteDfciOuvrageId) : undefined,
                        disabled: true,
                        required: false
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$ce9b1cc0c34506d0), {
                        name: "dfciPisteRemarque",
                        label: "Remarque",
                        value: values.dfciPisteRemarque,
                        disabled: isDisabled,
                        required: false
                    })
                }),
                !readOnly && hasDroitUpdateDfciPiste && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db9b0e6fdb142a4c$export$2e2bcd8739ae039), {})
            ]
        })
    });
};
var $bd36fbb11165aa20$export$2e2bcd8739ae039 = $bd36fbb11165aa20$var$DfciPiste;


const $de3c0da331160f97$export$b13f4232924e8b52 = ({ pisteId: pisteId, onSubmit: onSubmit, readOnly: readOnly })=>{
    const { data: data } = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/dfci-pistes/${pisteId}`);
    if (!data) return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $c21b1c237cfa1d94$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                icon: readOnly ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$d7cfde09abbb52ee), {}) : /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$b51dd496211ae105), {}),
                title: readOnly ? "Visualisation de la piste " + data.dfciPisteLibelle : "Modification de la piste " + data.dfciPisteLibelle,
                displayReturnButton: false
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                initialValues: (0, $bd36fbb11165aa20$export$8d50245677c3dc29)(data),
                isPost: false,
                prepareVariables: (0, $bd36fbb11165aa20$export$fbfb1796a38b4c89),
                validationSchema: (0, $bd36fbb11165aa20$export$26cda8e50f14b9fa),
                onSubmit: onSubmit,
                submitUrl: "/api/dfci-pistes/update",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $bd36fbb11165aa20$export$2e2bcd8739ae039), {
                    readOnly: readOnly
                })
            })
        ]
    });
};


/**
 * Composant permettant de visualiser l'élément
 * @param DfciElement Element sélectionné sur la carte
 * @returns Le composant de visualisation de l'élément
 */ const $45418e7136067e6b$var$DfciUpdateElement = ({ typeElem: typeElem, elementId: elementId, onSubmit: onSubmit, readOnly: readOnly })=>{
    switch(typeElem){
        case (0, $f32c9305c9576eaf$export$4fa1916ee9d33028).AIRE:
            return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $d746c92b56648e40$export$d3dbec490536a542), {
                aireId: elementId,
                onSubmit: onSubmit,
                readOnly: readOnly
            });
        case (0, $f32c9305c9576eaf$export$4fa1916ee9d33028).PISTE:
            return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $de3c0da331160f97$export$b13f4232924e8b52), {
                pisteId: elementId,
                onSubmit: onSubmit,
                readOnly: readOnly
            });
        case (0, $f32c9305c9576eaf$export$4fa1916ee9d33028).DEBROUSSAILLEMENT:
            return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $3cce4f8c1dd88eab$export$9ae15ae284067d3f), {
                debId: elementId,
                onSubmit: onSubmit,
                readOnly: readOnly
            });
        case (0, $f32c9305c9576eaf$export$4fa1916ee9d33028).PANNEAU:
            return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $cab523073391bfe2$export$e71b238f6052f84a), {
                panneauId: elementId,
                onSubmit: onSubmit,
                readOnly: readOnly
            });
    }
};
var $45418e7136067e6b$export$2e2bcd8739ae039 = $45418e7136067e6b$var$DfciUpdateElement;




var $kc00y = parcelRequire("kc00y");

















const $035f6f2af959c2b0$var$filterValuesToVariable = ({ indisponibiliteTemporaireMotif: indisponibiliteTemporaireMotif, indisponibiliteTemporaireStatut: indisponibiliteTemporaireStatut, indisponibiliteTemporaireObservation: indisponibiliteTemporaireObservation, indisponibiliteTemporaireMailAvantIndisponibilite: indisponibiliteTemporaireMailAvantIndisponibilite, indisponibiliteTemporaireMailApresIndisponibilite: indisponibiliteTemporaireMailApresIndisponibilite, listePeiId: listePeiId, listeCommunes: listeCommunes })=>{
    const filter = {};
    if (indisponibiliteTemporaireMotif?.trim().length > 0) filter.indisponibiliteTemporaireMotif = indisponibiliteTemporaireMotif;
    if (indisponibiliteTemporaireMailAvantIndisponibilite?.trim().length > 0) filter.indisponibiliteTemporaireMailAvantIndisponibilite = indisponibiliteTemporaireMailAvantIndisponibilite;
    if (indisponibiliteTemporaireMailApresIndisponibilite?.trim().length > 0) filter.indisponibiliteTemporaireMailApresIndisponibilite = indisponibiliteTemporaireMailApresIndisponibilite;
    if (listePeiId && listePeiId?.length > 0) filter.listePeiId = listePeiId;
    if (indisponibiliteTemporaireMotif?.trim().length > 0) filter.indisponibiliteTemporaireMotif = indisponibiliteTemporaireMotif;
    if (indisponibiliteTemporaireObservation?.trim().length > 0) filter.indisponibiliteTemporaireObservation = indisponibiliteTemporaireObservation;
    if (indisponibiliteTemporaireStatut?.trim().length > 0) filter.indisponibiliteTemporaireStatut = indisponibiliteTemporaireStatut;
    if (listeCommunes && listeCommunes.length > 0) filter.listeCommunes = listeCommunes;
    return filter;
};
var $035f6f2af959c2b0$export$2e2bcd8739ae039 = $035f6f2af959c2b0$var$filterValuesToVariable;


const $e7fda6f52dff7328$var$ListIndisponibiliteTemporaire = ({ peiId: peiId, colonnes: colonnes })=>{
    const { user: user } = (0, $e787cde576104469$export$fdc397e486fa83e7)();
    const { fetchGeometry: fetchGeometry } = (0, $a178c3075f0f40bb$export$2e2bcd8739ae039)();
    //TODO a aller chercher en base
    const column = colonnes ?? [
        (0, $7232829592627b50$export$2e2bcd8739ae039).LIST_PEI,
        (0, $7232829592627b50$export$2e2bcd8739ae039).COMMUNE,
        (0, $7232829592627b50$export$2e2bcd8739ae039).DATE_DEBUT,
        (0, $7232829592627b50$export$2e2bcd8739ae039).DATE_FIN,
        (0, $7232829592627b50$export$2e2bcd8739ae039).STATUT,
        (0, $7232829592627b50$export$2e2bcd8739ae039).MAIL_AVANT,
        (0, $7232829592627b50$export$2e2bcd8739ae039).MAIL_APRES,
        (0, $7232829592627b50$export$2e2bcd8739ae039).MOTIF,
        (0, $7232829592627b50$export$2e2bcd8739ae039).DESCRIPTION
    ];
    /***Constante permetant de gérer les état des composants "QueryTable" et "ListePei" *****/ const [showTable, setShowTable] = (0, $kc00y.useState)(true); // Contrôle de l'affichage du tableau
    const [idIndisponibiliteTemporaire, setIdIndisponibiliteTemporaire] = (0, $kc00y.useState)(null); // Variable à mettre à jour
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                    displayReturnButton: peiId == null,
                    title: "Indisponibilit\xe9s temporaires",
                    icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$77223e42038127b5), {}),
                    right: (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).INDISPO_TEMP_C) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8ad69b89456b65bc$export$2e2bcd8739ae039), {
                        title: "Ajouter une indisponibilit\xe9 temporaire",
                        href: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).CREATE_INDISPONIBILITE_TEMPORAIRE
                    })
                })
            }),
            //pas besoin de container il est dans le composant QueryTableWithListingPei
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $0e7b0f927316b537$export$2e2bcd8739ae039), {
                column: (0, $491b746883a2d098$export$876888025bdab36c)({
                    user: user,
                    parametres: column,
                    fetchGeometry: fetchGeometry
                }),
                query: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/indisponibilite-temporaire`,
                idName: "IndisponibiliteTemporaireTable",
                filterPage: (0, $e8a2c985711dfc19$export$2e2bcd8739ae039).INDISPONIBILITE_TEMPORAIRE,
                showTable: showTable,
                filterId: idIndisponibiliteTemporaire,
                //on envoie les constantes au composant enfant pour qu'il mette à jour le composant parent
                setFilterId: setIdIndisponibiliteTemporaire,
                setShowTable: setShowTable,
                filterValuesToVariable: (0, $035f6f2af959c2b0$export$2e2bcd8739ae039),
                useFilterContext: (0, $9a9eebc3462fba73$export$396ef541d9951d45)({
                    indisponibiliteTemporaireDateDebut: undefined,
                    indisponibiliteTemporaireDateFin: undefined,
                    indisponibiliteTemporaireMotif: undefined,
                    indisponibiliteTemporaireStatut: (0, $c066b242635c27a6$export$40ef1f64c11ebe55)((0, $4a8fc6d624905721$export$2e2bcd8739ae039), (0, $4a8fc6d624905721$export$2e2bcd8739ae039).EN_COURS_PLANIFIEE),
                    indisponibiliteTemporaireObservation: undefined,
                    indisponibiliteTemporaireMailAvantIndisponibilite: undefined,
                    indisponibiliteTemporaireMailApresIndisponibilite: undefined,
                    listePeiId: peiId ? [
                        peiId
                    ] : undefined
                })
            })
        ]
    });
};
var $e7fda6f52dff7328$export$2e2bcd8739ae039 = $e7fda6f52dff7328$var$ListIndisponibiliteTemporaire;












var $bkJfK = parcelRequire("bkJfK");

var $kc00y = parcelRequire("kc00y");







/**
 * Formulaire utilisé pour ajouter ou supprimer des documents
 * La variable dans formik doit s'appeler obligatoirement "documents"
 * @param documents liste des documents
 * @param setFieldValue fonction formik
 * @param defaultOtherProperties si l'object document n'a pas qu'un id, un nom, alors on envoie un objet contenant les autres propriétés à définir par défaut
 * @param otherFormParam si l'object document n'a pas qu'un id, un nom alors on fournit l'autre partie du formulaire à répéter
 */ const $69d686b1e97c5ea6$var$FormDocuments = ({ documents: documents, multiple: multiple = false, setFieldValue: setFieldValue, otherFormParam: otherFormParam, defaultOtherProperties: defaultOtherProperties, disabled: disabled = false, readOnly: readOnly = false })=>{
    function formDocumentsToRepeat(index, listeElements) {
        return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
            children: [
                listeElements[index].documentId != null ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                        variant: "link",
                        href: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/documents/telecharger/` + listeElements[index].documentId,
                        children: listeElements[index].documentNomFichier
                    })
                }) : /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                    children: listeElements[index].documentNomFichier
                }),
                otherFormParam && otherFormParam(index, listeElements)
            ]
        });
    }
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b57af79a4ab2a1c6), {
                name: "documentCourant",
                accept: "*.*",
                label: "G\xe9rer les documents",
                required: false,
                onChange: (e)=>{
                    const files = Array.from(e.currentTarget.files ?? []);
                    if (files.length === 0) return;
                    const newDocuments = files.map((file)=>({
                            documentNomFichier: file.name,
                            data: file,
                            ...defaultOtherProperties
                        }));
                    const nextDocuments = [
                        ...documents ?? [],
                        ...newDocuments
                    ];
                    setFieldValue("documents", nextDocuments);
                    e.currentTarget.value = "";
                },
                disabled: disabled,
                readOnly: readOnly,
                multiple: multiple
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $665753c43020c55f$export$2e2bcd8739ae039), {
                name: "documents",
                createComponentToRepeat: formDocumentsToRepeat,
                listeElements: documents ?? [],
                canAdd: false,
                disabled: disabled,
                readOnly: readOnly
            })
        ]
    });
};
function $69d686b1e97c5ea6$export$3f0f08502708410b(documentsApresModif, documentsAvantModif, formData) {
    documentsApresModif.map((e)=>{
        if (e.data != null) formData.append("document_" + e.documentNomFichier, e.data);
    });
    formData.append("documents", JSON.stringify(documentsApresModif));
    formData.append("listeDocsToRemove", JSON.stringify(documentsAvantModif?.filter((e)=>!documentsApresModif.map((e)=>e.documentId).includes(e.documentId)).filter((e)=>e != null).map((e)=>e.documentId) ?? []));
}
var $69d686b1e97c5ea6$export$2e2bcd8739ae039 = $69d686b1e97c5ea6$var$FormDocuments;






var $kc00y = parcelRequire("kc00y");


var $kc00y = parcelRequire("kc00y");




var $kc00y = parcelRequire("kc00y");



"use client";
const $165df2b99fae9c94$var$InputGroupText = /*#__PURE__*/ $kc00y.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'span', ...props }, ref)=>{
    bsPrefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(bsPrefix, 'input-group-text');
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, bsPrefix),
        ...props
    });
});
$165df2b99fae9c94$var$InputGroupText.displayName = 'InputGroupText';
var $165df2b99fae9c94$export$2e2bcd8739ae039 = $165df2b99fae9c94$var$InputGroupText;



"use client";
const $4077d7882ac62206$var$InputGroupCheckbox = (props)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $165df2b99fae9c94$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $4c16259bbd613a35$export$2e2bcd8739ae039), {
            type: "checkbox",
            ...props
        })
    });
const $4077d7882ac62206$var$InputGroupRadio = (props)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $165df2b99fae9c94$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $4c16259bbd613a35$export$2e2bcd8739ae039), {
            type: "radio",
            ...props
        })
    });
const $4077d7882ac62206$var$InputGroup = /*#__PURE__*/ $kc00y.forwardRef(({ bsPrefix: bsPrefix, size: size, hasValidation: hasValidation, className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(bsPrefix, 'input-group');
    // Intentionally an empty object. Used in detecting if a dropdown
    // exists under an input group.
    const contextValue = (0, $kc00y.useMemo)(()=>({}), []);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $bb90c81eb1eb23cc$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)(Component, {
            ref: ref,
            ...props,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, bsPrefix, size && `${bsPrefix}-${size}`, hasValidation && 'has-validation')
        })
    });
});
$4077d7882ac62206$var$InputGroup.displayName = 'InputGroup';
var $4077d7882ac62206$export$2e2bcd8739ae039 = Object.assign($4077d7882ac62206$var$InputGroup, {
    Text: (0, $165df2b99fae9c94$export$2e2bcd8739ae039),
    Radio: $4077d7882ac62206$var$InputGroupRadio,
    Checkbox: $4077d7882ac62206$var$InputGroupCheckbox
});


const $08d896774a042b59$var$TagInput = ({ name: name, label: label, onTagsChange: onTagsChange, defaultTags: defaultTags = [], disabled: disabled = false, required: required = false })=>{
    const [tags, setTags] = (0, $kc00y.useState)(defaultTags);
    const [inputValue, setInputValue] = (0, $kc00y.useState)("");
    const isInitialized = (0, $kc00y.useRef)(false); // Empêche le useEffect de trigger "onTagsChange" au montage
    (0, $kc00y.useEffect)(()=>{
        if (!isInitialized.current) {
            isInitialized.current = true;
            return;
        }
    // Ne pas appeler "onTagsChange" ici pour éviter une boucle infinie
    }, []);
    const addTag = (tag)=>{
        if (disabled) return;
        const trimmedTag = tag.trim();
        if (trimmedTag && !tags.includes(trimmedTag)) {
            const newTags = [
                ...tags,
                trimmedTag
            ];
            setTags(newTags);
            onTagsChange(newTags);
        }
        setInputValue("");
    };
    const removeTag = (index)=>{
        if (disabled) return;
        const newTags = tags.filter((_, i)=>i !== index);
        setTags(newTags);
        onTagsChange(newTags);
    };
    const handleKeyDown = (event)=>{
        if (event.key === "Enter" && inputValue.trim()) {
            event.preventDefault();
            addTag(inputValue);
        }
    };
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Group, {
        controlId: name,
        children: [
            label && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Label, {
                children: label
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $4077d7882ac62206$export$2e2bcd8739ae039), {
                className: "mb-3",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                    className: "d-flex flex-wrap gap-2 p-2 border rounded",
                    style: {
                        minHeight: "38px",
                        width: "350px",
                        maxWidth: "100%",
                        overflowY: "auto",
                        backgroundColor: disabled ? "#e9ecef" : "white"
                    },
                    children: [
                        tags.map((tag, index)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $98f55aa78fbaf278$export$2e2bcd8739ae039), {
                                pill: true,
                                bg: "primary",
                                className: "d-flex align-items-center",
                                children: [
                                    tag,
                                    " ",
                                    !disabled && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $80bef9dfc5e82bc1$export$2e2bcd8739ae039), {
                                        onClick: ()=>removeTag(index),
                                        className: "ms-2",
                                        variant: "white",
                                        style: {
                                            fontSize: "0.7rem"
                                        }
                                    })
                                ]
                            }, index)),
                        !disabled && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $399684c98cf70cc1$export$2e2bcd8739ae039), {
                            type: "text",
                            name: name,
                            value: inputValue,
                            onChange: (e)=>setInputValue(e.target.value),
                            onKeyDown: handleKeyDown,
                            placeholder: "Ajouter un tag...",
                            className: "border-0 flex-grow-1",
                            disabled: disabled,
                            required: required && tags.length === 0
                        })
                    ]
                })
            })
        ]
    });
};
var $08d896774a042b59$export$2e2bcd8739ae039 = $08d896774a042b59$var$TagInput;





var $bkJfK = parcelRequire("bkJfK");

var $kc00y = parcelRequire("kc00y");





var $d44cc71db68851bf$export$3d7fc3ac5152d16e = /*#__PURE__*/ function(TYPE_PARAMETRE_RAPPORT_COURRIER) {
    TYPE_PARAMETRE_RAPPORT_COURRIER["CHECKBOX_INPUT"] = "Case \xe0 cocher";
    TYPE_PARAMETRE_RAPPORT_COURRIER["DATE_INPUT"] = "Champ date";
    TYPE_PARAMETRE_RAPPORT_COURRIER["NUMBER_INPUT"] = "Champ nombre";
    TYPE_PARAMETRE_RAPPORT_COURRIER["SELECT_INPUT"] = "Liste d\xe9roulante";
    TYPE_PARAMETRE_RAPPORT_COURRIER["TEXT_INPUT"] = "Champ texte";
    TYPE_PARAMETRE_RAPPORT_COURRIER["POINT"] = "Point";
    TYPE_PARAMETRE_RAPPORT_COURRIER["POLYGON"] = "Polygone";
    TYPE_PARAMETRE_RAPPORT_COURRIER["LINESTRING"] = "Ligne";
    return TYPE_PARAMETRE_RAPPORT_COURRIER;
}({});
const $d44cc71db68851bf$export$ece0d44852850b0a = [
    "#ZONE_COMPETENCE_ID#",
    "#UTILISATEUR_ID#",
    "#ORGANISME_ID#"
];


function $3dfd663e22480fb2$var$buildDynamicForm(element, values, setFieldValue, onGeometrySelect, visibleMap) {
    switch((0, $d44cc71db68851bf$export$3d7fc3ac5152d16e)[element.dynamicFormParametreType]){
        case (0, $d44cc71db68851bf$export$3d7fc3ac5152d16e).CHECKBOX_INPUT:
            return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                name: element.dynamicFormParametreCode,
                label: element.dynamicFormParametreLibelle,
                required: element.dynamicFormParametreIsRequired,
                checked: values[element.dynamicFormParametreCode] ?? element.dynamicFormParametreValeurDefaut === "true",
                tooltipText: element.dynamicFormParametreDescription,
                visibleMap: visibleMap
            });
        case (0, $d44cc71db68851bf$export$3d7fc3ac5152d16e).NUMBER_INPUT:
            return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$6bf0cd3a219bbade), {
                name: element.dynamicFormParametreCode,
                label: element.dynamicFormParametreLibelle,
                required: element.dynamicFormParametreIsRequired,
                value: element.dynamicFormParametreValeurDefaut,
                tooltipText: element.dynamicFormParametreDescription,
                visibleMap: visibleMap
            });
        case (0, $d44cc71db68851bf$export$3d7fc3ac5152d16e).TEXT_INPUT:
            return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                name: element.dynamicFormParametreCode,
                label: element.dynamicFormParametreLibelle,
                required: element.dynamicFormParametreIsRequired,
                value: element.dynamicFormParametreValeurDefaut,
                tooltipText: element.dynamicFormParametreDescription,
                visibleMap: visibleMap
            });
        case (0, $d44cc71db68851bf$export$3d7fc3ac5152d16e).DATE_INPUT:
            return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$183478aa40b5df1), {
                name: element.dynamicFormParametreCode,
                label: element.dynamicFormParametreLibelle,
                required: element.dynamicFormParametreIsRequired,
                defaultValue: element.dynamicFormParametreValeurDefaut,
                tooltipText: element.dynamicFormParametreDescription,
                visibleMap: visibleMap
            });
        case (0, $d44cc71db68851bf$export$3d7fc3ac5152d16e).SELECT_INPUT:
            return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$d6701e98ab1a6725), {
                visibleMap: visibleMap,
                name: element.dynamicFormParametreCode,
                label: element.dynamicFormParametreLibelle,
                required: element.dynamicFormParametreIsRequired,
                options: element.listeSelectInput,
                getOptionValue: (t)=>t.id,
                getOptionLabel: (t)=>t.libelle,
                onChange: (e)=>{
                    setFieldValue(element.dynamicFormParametreCode, element.listeSelectInput?.find((r)=>r.id === e.id).id);
                },
                defaultValue: element.listeSelectInput?.find((r)=>{
                    return values[element.dynamicFormParametreCode] ? r.id === values[element.dynamicFormParametreCode] : r.id === element?.dynamicFormParametreValeurDefaut;
                }),
                tooltipText: element.dynamicFormParametreDescription
            });
        case (0, $d44cc71db68851bf$export$3d7fc3ac5152d16e).POLYGON:
            return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                className: "mt-2",
                onClick: ()=>{
                    if (onGeometrySelect) onGeometrySelect(element.dynamicFormParametreType, element.dynamicFormParametreCode);
                },
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$fa5eb5b4918005e3), {}),
                    "Dessiner un polygone"
                ]
            }, `polygon`);
        case (0, $d44cc71db68851bf$export$3d7fc3ac5152d16e).LINESTRING:
            return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                className: "mt-2",
                onClick: ()=>{
                    if (onGeometrySelect) onGeometrySelect(element.dynamicFormParametreType, element.dynamicFormParametreCode);
                },
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$365092c6388045c9), {}),
                    "Dessiner une ligne"
                ]
            }, `linestring`);
        case (0, $d44cc71db68851bf$export$3d7fc3ac5152d16e).POINT:
            return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                className: "mt-2",
                onClick: ()=>{
                    if (onGeometrySelect) onGeometrySelect(element.dynamicFormParametreType, element.dynamicFormParametreCode);
                },
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$fc789d8a435194dc), {}),
                    "Dessiner un point"
                ]
            }, `point`);
        default:
            return;
    }
}
/**
 * Permet d'afficher dynamiquement le formulaire qu'il s'agisse de rapports personnalisé ou de courrier
 * @param listeIdLibelleDescription : liste des rapports ou courriers avec leur description
 * @param contexteLibelle : Rapport personnalisé ou Modèle de courrier par exemple
 * @param reference : afficher la référence ? (applicable que dans le cadre des courriers)
 * @returns
 */ const $3dfd663e22480fb2$var$GenererForm = ({ listeIdLibelleDescription: listeIdLibelleDescription, contexteLibelle: contexteLibelle, reference: reference = false, url: url, onGeometrySelect: onGeometrySelect, onParametresChange: onParametresChange, visibleMap: visibleMap = true })=>{
    const { setFieldValue: setFieldValue, values: values } = (0, $bkJfK.useFormikContext)();
    const [objetId, setObjetId] = (0, $kc00y.useState)(values.dynamicFormId);
    const { data: listeWithParametres, run: run, isLoading: isLoading } = (0, $8d9ebd8892d8a5f5$export$6326fb4463ae1be4)(`${url}${objetId}`, {});
    (0, $kc00y.useEffect)(()=>{
        if (objetId) run();
    }, [
        objetId,
        run
    ]);
    // Notifier le parent quand les paramètres changent
    (0, $kc00y.useEffect)(()=>{
        if (listeWithParametres?.listeParametre && onParametresChange) onParametresChange(listeWithParametres.listeParametre);
    }, [
        listeWithParametres,
        onParametresChange
    ]);
    const rapportPersonnaliseCourrierCourant = listeIdLibelleDescription?.find((r)=>r.id === objetId);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$d6701e98ab1a6725), {
                    name: `dynamicFormId`,
                    label: contexteLibelle,
                    options: listeIdLibelleDescription,
                    getOptionValue: (t)=>t.id,
                    getOptionLabel: (t)=>t.libelle,
                    onChange: (e)=>{
                        setFieldValue(`dynamicFormId`, listeIdLibelleDescription?.find((r)=>r.id === e.id)?.id);
                        setFieldValue("courrierReference", "");
                        setObjetId(e.id);
                    },
                    defaultValue: listeIdLibelleDescription?.find((r)=>r.id === values.dynamicFormId),
                    required: true
                })
            }),
            reference && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                    name: "courrierReference",
                    required: true,
                    label: "R\xe9f\xe9rence"
                })
            }),
            rapportPersonnaliseCourrierCourant?.description && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                className: "mt-3",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                    className: "text-pre-line",
                    children: [
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("b", {
                            children: "Description : "
                        }),
                        rapportPersonnaliseCourrierCourant.description
                    ]
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                className: "mt-3",
                children: isLoading ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $c21b1c237cfa1d94$export$2e2bcd8739ae039), {}) : listeWithParametres?.listeParametre?.map((element)=>{
                    return $3dfd663e22480fb2$var$buildDynamicForm(element, values, setFieldValue, onGeometrySelect, visibleMap);
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                className: "my-3 d-flex justify-content-center",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                    sm: "auto",
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                        type: "submit",
                        variant: "primary",
                        children: "Ex\xe9cuter"
                    })
                })
            })
        ]
    });
};
const $3dfd663e22480fb2$export$20729168b6e27a0d = ({ listeWithParametre: listeWithParametre, setFieldValue: setFieldValue, isReadOnly: isReadOnly, onParamChange: onParamChange, values: values })=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
        className: "mt-3",
        children: listeWithParametre?.map((element, index)=>{
            return $3dfd663e22480fb2$var$buildDynamicComplement(element, setFieldValue, index, isReadOnly, onParamChange, values);
        })
    });
};
function $3dfd663e22480fb2$var$buildDynamicComplement(element, setFieldValue, index, isReadOnly, onParamChange, values) {
    const updateParams = (valueParam)=>{
        const baseName = `evenementSousCategorieComplement[${index}]`;
        Object.entries({
            [`${baseName}.valueParam`]: valueParam,
            [`${baseName}.idParam`]: element.dynamicFormParametreId
        }).forEach(([name, value])=>{
            onParamChange(name, value);
        });
    };
    switch(element.dynamicFormParametreType){
        case "DATE_INPUT":
            return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$183478aa40b5df1), {
                    readOnly: isReadOnly,
                    name: `evenementSousCategorieComplement[${index}].valueParam`,
                    label: element.dynamicFormParametreLibelle,
                    required: element.dynamicFormParametreIsRequired,
                    defaultValue: values?.evenementSousCategorieComplement?.[index]?.valueParam,
                    onChange: (e)=>{
                        updateParams(e.target.value);
                    }
                })
            });
        case "TEXT_INPUT":
            return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                    readOnly: isReadOnly,
                    name: `evenementSousCategorieComplement[${index}].valueParam`,
                    required: element.dynamicFormParametreIsRequired,
                    label: element.dynamicFormParametreLibelle,
                    onChange: (e)=>{
                        updateParams(e.target.value);
                    }
                })
            });
        case "NUMBER_INPUT":
            return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$6bf0cd3a219bbade), {
                    readOnly: isReadOnly,
                    name: `evenementSousCategorieComplement[${index}].valueParam`,
                    label: element.dynamicFormParametreLibelle,
                    required: element.dynamicFormParametreIsRequired,
                    onChange: (e)=>{
                        updateParams(e.target.value);
                    }
                })
            });
        case "SELECT_INPUT":
            return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$d6701e98ab1a6725), {
                    name: `evenementSousCategorieComplement[${index}].valueParam`,
                    readOnly: isReadOnly,
                    label: element.dynamicFormParametreLibelle,
                    required: element.dynamicFormParametreIsRequired,
                    options: element.listeSelectInput,
                    getOptionValue: (t)=>t.id,
                    getOptionLabel: (t)=>t.libelle,
                    onChange: (e)=>{
                        setFieldValue(element.dynamicFormParametreId, element.listeSelectInput?.find((r)=>r.id === e.id)?.id);
                        updateParams(e.id);
                    },
                    defaultValue: element.listeSelectInput?.find((r)=>r.id === values?.evenementSousCategorieComplement?.[index]?.valueParam)
                })
            });
        default:
            return;
    }
}
var $3dfd663e22480fb2$export$2e2bcd8739ae039 = $3dfd663e22480fb2$var$GenererForm;



const $2764f711dbde8826$export$a5cab80145b70e98 = (data, geometrie, sousCategorieEvenement, parameters)=>{
    const sousCategorieEvenementId = data?.evenementSousCategorieId ?? sousCategorieEvenement;
    return {
        evenementLibelle: data?.evenementLibelle ?? null,
        evenementOrigine: data?.evenementOrigine ?? "",
        evenementDescription: data?.evenementDescription ?? "",
        evenementDateConstat: data?.evenementDateConstat ?? new Date(),
        evenementImportance: data?.evenementImportance ?? 1,
        evenementEstFerme: data?.evenementEstFerme ?? false,
        documents: data?.documents ?? [],
        evenementTags: data?.evenementTags ?? [],
        geometrieEvenement: geometrie ?? null,
        evenementSousCategorieId: sousCategorieEvenementId,
        evenementSousCategorieComplement: data?.evenementParametre ?? parameters?.find((param)=>param.evenementSousCategorieId === sousCategorieEvenementId)?.evenementSousCategorieComplement.map((param)=>({
                idParam: param.dynamicFormParametreId,
                valueParam: param.dynamicFormParametreValeurDefaut ?? ""
            }))
    };
};
const $2764f711dbde8826$export$c084437b5e3206cd = (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({
    evenementLibelle: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
    evenementDateConstat: (0, $36ceaed6faf947af$export$5cbf64e9c4f743ca)
});
function $2764f711dbde8826$var$formatGeometrie(geometrie) {
    let geometryString = geometrie?.replace(/ ,/g, ",");
    geometryString = geometryString?.replace("LINESTRING Z", "LINESTRING");
    geometryString = geometryString?.replace("LINESTRINGM", "LINESTRING");
    return geometryString;
}
const $2764f711dbde8826$export$f97400759cfd946 = (values, initialData, userId)=>{
    const formData = new FormData();
    (0, $69d686b1e97c5ea6$export$3f0f08502708410b)(values?.documents, initialData?.documents, formData);
    formData.append("evenementSousCategorieId", values.evenementSousCategorieId);
    formData.append("evenementLibelle", values.evenementLibelle);
    formData.append("evenementOrigine", values.evenementOrigine);
    formData.append("evenementDescription", values.evenementDescription);
    formData.append("evenementDateConstat", new Date(values.evenementDateConstat).toISOString());
    formData.append("evenementImportance", values.evenementImportance);
    formData.append("evenementEstFerme", JSON.stringify(values.evenementEstFerme));
    formData.append("evenementGeometrie", JSON.stringify($2764f711dbde8826$var$formatGeometrie(values.geometrieEvenement)));
    formData.append("evenementUtilisateurId", userId);
    formData.append("evenementTags", values.evenementTags.join());
    formData.append("evenementParametre", JSON.stringify(values.evenementSousCategorieComplement));
    return formData;
};
const $2764f711dbde8826$var$Evenement = ({ isReadOnly: isReadOnly, sousCategoriesEvenement: sousCategoriesEvenement })=>{
    const { setValues: setValues, setFieldValue: setFieldValue, values: values } = (0, $bkJfK.useFormikContext)();
    const filtre = values.geometrieEvenement ? (e)=>e.evenementSousCategorieId === values.evenementSousCategorieId : (e)=>e.typeEvenementGeometrie == null;
    const listeSousCategories = sousCategoriesEvenement?.filter(filtre)?.map((e)=>({
            id: e.evenementSousCategorieId,
            code: e.evenementSousCategorieCode,
            libelle: e.evenementSousCategorieLibelle,
            parameters: e.evenementSousCategorieComplement
        }));
    const sousCategorie = (0, $kc00y.useMemo)(()=>{
        return values.evenementSousCategorieId ? listeSousCategories?.find((e)=>e.id === values.evenementSousCategorieId) ?? null : null;
    }, [
        values.evenementSousCategorieId,
        listeSousCategories
    ]);
    const paramChange = (name, value)=>{
        setFieldValue(name, value);
    };
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("h3", {
                className: "mt-5",
                children: "Informations g\xe9n\xe9rales"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                disabled: values.geometrieEvenement ? true : isReadOnly,
                name: "evenementSousCategorieId",
                listIdCodeLibelle: listeSousCategories,
                label: "Type",
                required: true,
                setValues: setValues,
                defaultValue: sousCategorie
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                disabled: isReadOnly,
                label: "titre",
                name: "evenementLibelle",
                required: true
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$ce9b1cc0c34506d0), {
                disabled: isReadOnly,
                name: "evenementDescription",
                label: "Description",
                required: false
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                disabled: isReadOnly,
                label: "Origine",
                name: "evenementOrigine",
                required: false
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$183478aa40b5df1), {
                readOnly: isReadOnly,
                name: "evenementDateConstat",
                label: "Date et heure d\u2019activation",
                required: true,
                value: values.evenementDateConstat && (0, $00c47c7740afd024$export$cc23f907e4acb548)(values.evenementDateConstat)
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$f5603a09670563b9), {
                disabled: isReadOnly,
                step: 1,
                min: 0,
                value: +values.evenementImportance,
                name: "evenementImportance",
                label: "Importance",
                max: 5
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                disabled: isReadOnly,
                name: "evenementEstFerme",
                label: "Clore l'\xe9v\xe8nement"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $08d896774a042b59$export$2e2bcd8739ae039), {
                onTagsChange: (tags)=>setFieldValue("evenementTags", tags),
                name: "evenementTag",
                label: "Liste des tags",
                disabled: isReadOnly,
                defaultTags: values.evenementTags
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("h3", {
                className: "mt-5",
                children: "Document"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $69d686b1e97c5ea6$export$2e2bcd8739ae039), {
                disabled: isReadOnly,
                documents: values.documents,
                setFieldValue: setFieldValue,
                otherFormParam: (index)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                            label: "Nom",
                            name: `documents[${index}].evenementDocumentLibelle`,
                            required: false
                        })
                    }),
                defaultOtherProperties: {
                    levenementDocumentLibelle: null
                }
            }),
            sousCategorie?.parameters?.length > 0 && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("h3", {
                        className: "mt-5",
                        children: "Compl\xe9ment"
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $3dfd663e22480fb2$export$20729168b6e27a0d), {
                        listeWithParametre: sousCategorie.parameters,
                        setFieldValue: setFieldValue,
                        isReadOnly: isReadOnly,
                        onParamChange: paramChange,
                        values: values
                    })
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db9b0e6fdb142a4c$export$2e2bcd8739ae039), {
                disabledValide: isReadOnly
            })
        ]
    });
};
var $2764f711dbde8826$export$2e2bcd8739ae039 = $2764f711dbde8826$var$Evenement;


const $82ecdcbf19510aa3$var$UpdateEvenement = ({ state: state, readOnly: readOnly, criseId: criseId, evenementId: evenementId, geometrieEvenement: geometrieEvenement, onSubmit: onSubmit })=>{
    const selectDataState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/crise/evenement/${evenementId}`);
    const sousCategorieList = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/crise/evenement/get-evenement-sous-categorie${selectDataState.data?.evenementSousCategorieId ? `?evenementSousCategorieId=${selectDataState.data?.evenementSousCategorieId}` : ""}`)?.data;
    const { user: user } = (0, $e787cde576104469$export$fdc397e486fa83e7)();
    return selectDataState.data && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$16ae26c700600e84), {}),
                title: readOnly ? "Informations" : "Modifier l'\xe9v\xe8nement",
                displayReturnButton: false
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                initialValues: (0, $2764f711dbde8826$export$a5cab80145b70e98)(selectDataState.data, geometrieEvenement, selectDataState.data?.evenementSousCategorieId, sousCategorieList),
                validationSchema: (0, $2764f711dbde8826$export$c084437b5e3206cd),
                isPost: false,
                isMultipartFormData: true,
                prepareVariables: (values)=>(0, $2764f711dbde8826$export$f97400759cfd946)(values, selectDataState.data, user.utilisateurId),
                onSubmit: onSubmit,
                submitUrl: `/api/crise/${criseId}/evenement/${state}/${evenementId}/update`,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2764f711dbde8826$export$2e2bcd8739ae039), {
                    isReadOnly: readOnly,
                    sousCategoriesEvenement: sousCategorieList
                })
            })
        ]
    });
};
var $82ecdcbf19510aa3$export$2e2bcd8739ae039 = $82ecdcbf19510aa3$var$UpdateEvenement;















var $bkJfK = parcelRequire("bkJfK");






const $a7c785bd8da3e879$export$a5cab80145b70e98 = (data)=>({
        peiPrescritId: data?.peiPrescritId,
        peiPrescritDate: (0, $00c47c7740afd024$export$c6834cb9c1260d15)(data?.peiPrescritDate ?? new Date()),
        peiPrescritDebit: data?.peiPrescritDebit,
        peiPrescritNbPoteaux: data?.peiPrescritNbPoteaux,
        peiPrescritCommentaire: data?.peiPrescritCommentaire,
        peiPrescritAgent: data?.peiPrescritAgent,
        peiPrescritNumDossier: data?.peiPrescritNumDossier,
        peiPrescritCoordonneeX: data?.peiPrescritCoordonneeX,
        peiPrescritCoordonneeY: data?.peiPrescritCoordonneeY,
        peiPrescritSrid: data?.peiPrescritSrid
    });
const $a7c785bd8da3e879$export$f97400759cfd946 = (values)=>({
        peiPrescritId: values.peiPrescritId,
        peiPrescritDate: values.peiPrescritDate ? new Date(values.peiPrescritDate).toISOString() : null,
        peiPrescritDebit: values.peiPrescritDebit,
        peiPrescritNbPoteaux: values.peiPrescritNbPoteaux,
        peiPrescritCommentaire: values.peiPrescritCommentaire,
        peiPrescritAgent: values.peiPrescritAgent,
        peiPrescritNumDossier: values.peiPrescritNumDossier,
        peiPrescritGeometrie: `SRID=${values.peiPrescritSrid};POINT(${values.peiPrescritCoordonneeX} ${values.peiPrescritCoordonneeY})`
    });
const $a7c785bd8da3e879$var$PeiPrescrit = ()=>{
    const { values: values } = (0, $bkJfK.useFormikContext)();
    const coordinates = (0, $a86eee1c28205a05$export$51186ad6e864892a)([
        values.peiPrescritCoordonneeX,
        values.peiPrescritCoordonneeY
    ], (0, $f740b0d032822ba6$export$3eb968b6a9f43207), (0, $f740b0d032822ba6$export$ea1a29af61241729));
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$2e2bcd8739ae039), {
                    name: "peiPrescritNbPoteaux",
                    label: "Nombre de PEI",
                    required: false
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$2e2bcd8739ae039), {
                    name: "peiPrescritDebit",
                    label: "D\xe9bit (m\xb3/h) / Capacit\xe9 (m\xb3) : ",
                    min: 0,
                    required: false
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$7edc06cf1783b30f), {
                    name: "peiPrescritDate",
                    label: "Date",
                    required: false,
                    value: values.peiPrescritDate
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                    name: "peiPrescritAgent",
                    label: "Agent",
                    required: false
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                    name: "peiPrescritNumDossier",
                    label: "Num\xe9ro de dossier",
                    required: false
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$ce9b1cc0c34506d0), {
                    name: "peiPrescritCommentaire",
                    label: "Commentaire",
                    required: false
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$842aba50ed0ce9d7), {
                            name: "",
                            label: "Coordonn\xe9es WGS",
                            required: false
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("p", {
                                children: (0, $a6adb03fd2fbc071$export$6eb0ac5f024d8590)("NS", coordinates[1], 4) + " " + (0, $a6adb03fd2fbc071$export$6eb0ac5f024d8590)("EO", coordinates[0], 4)
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                className: "mt-3",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                    className: "text-center",
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                        type: "submit",
                        variant: "primary",
                        children: "Valider"
                    })
                })
            })
        ]
    });
};
var $a7c785bd8da3e879$export$2e2bcd8739ae039 = $a7c785bd8da3e879$var$PeiPrescrit;


const $09be900bd8ffca81$var$UpdatePeiPrescrit = ({ peiPrescritId: peiPrescritId, coordonneeX: coordonneeX, coordonneeY: coordonneeY, srid: srid, onSubmit: onSubmit })=>{
    const { data: data } = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/pei-prescrit/${peiPrescritId}`);
    const pageTitle = data?.peiPrescritNumDossier ? `Modification de la prescription ${data?.peiPrescritNumDossier}` : "Modification d'une prescription de PEI";
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$f9db439cdc8db790), {}),
                title: pageTitle,
                displayReturnButton: false
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                initialValues: (0, $a7c785bd8da3e879$export$a5cab80145b70e98)({
                    peiPrescritId: peiPrescritId,
                    peiPrescritCoordonneeX: coordonneeX,
                    peiPrescritCoordonneeY: coordonneeY,
                    peiPrescritSrid: srid,
                    peiPrescritDate: data?.peiPrescritDate ? (0, $00c47c7740afd024$export$c6834cb9c1260d15)(data.peiPrescritDate) : null,
                    peiPrescritDebit: data?.peiPrescritDebit,
                    peiPrescritNbPoteaux: data?.peiPrescritNbPoteaux,
                    peiPrescritCommentaire: data?.peiPrescritCommentaire,
                    peiPrescritAgent: data?.peiPrescritAgent,
                    peiPrescritNumDossier: data?.peiPrescritNumDossier
                }),
                isPost: false,
                prepareVariables: (values)=>(0, $a7c785bd8da3e879$export$f97400759cfd946)(values),
                onSubmit: onSubmit,
                submitUrl: `/api/pei-prescrit/update/${peiPrescritId}`,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $a7c785bd8da3e879$export$2e2bcd8739ae039), {})
            })
        ]
    });
};
var $09be900bd8ffca81$export$2e2bcd8739ae039 = $09be900bd8ffca81$var$UpdatePeiPrescrit;




var $bkJfK = parcelRequire("bkJfK");


var $kc00y = parcelRequire("kc00y");












const $e2315562ed43d638$var$TypeSystemeSrid = [
    {
        srid: 2154,
        nomSystem: "RGF93 v1 / Lambert-93",
        actif: false
    },
    {
        srid: 2972,
        nomSystem: "RGFG95 / UTM zone 22N",
        actif: false
    },
    {
        srid: 3857,
        nomSystem: "WGS 84 / Pseudo-Mercator",
        actif: true
    },
    {
        srid: 4326,
        nomSystem: "WGS 84 degr\xe9s d\xe9cimaux",
        actif: true
    },
    {
        srid: 32620,
        nomSystem: "WGS 84 / UTM zone 20N",
        actif: false
    },
    {
        srid: -1,
        nomSystem: "WGS 84 degr\xe9s sexag\xe9simaux",
        actif: true
    }
];
var $e2315562ed43d638$export$2e2bcd8739ae039 = $e2315562ed43d638$var$TypeSystemeSrid;




const $8bff802721744b7b$export$a5cab80145b70e98 = (data, srid)=>({
        listeAireAspiration: data.map((v)=>{
            const geom = v.geometrie?.split(";");
            const geometry = geom ? new (0, $15a985d09649bdc2$export$2e2bcd8739ae039)().readGeometry(geom[1]) : undefined;
            const coords = geometry?.getCoordinates?.();
            const coordX = coords?.[0];
            const coordY = coords?.[1];
            const dataSrid = geom?.[0]?.split("=")?.pop();
            return {
                penaAspirationId: v.penaAspirationId,
                numero: v.numero,
                estNormalise: v.estNormalise,
                hauteurSuperieure3Metres: v.hauteurSuperieure3Metres,
                typePenaAspirationId: v.typePenaAspirationId,
                estDeporte: v.estDeporte,
                coordonneeX: coordX,
                coordonneeY: coordY,
                srid: dataSrid ? parseInt(dataSrid) : srid,
                typeSystemeSrid: dataSrid ? (0, $e2315562ed43d638$export$2e2bcd8739ae039).find((e)=>e.srid === parseInt(dataSrid))?.srid ?? (0, $e2315562ed43d638$export$2e2bcd8739ae039)[0].srid : (0, $e2315562ed43d638$export$2e2bcd8739ae039)[0].srid,
                coordonneeXToDisplay: coordX,
                coordonneeYToDisplay: coordY
            };
        })
    });
const $8bff802721744b7b$export$c084437b5e3206cd = (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({});
const $8bff802721744b7b$export$f97400759cfd946 = (values)=>({
        listeAireAspiration: values.listeAireAspiration.map((v)=>{
            const coordX = v.coordonneeX ? parseFloat(String(v.coordonneeX)) : null;
            const coordY = v.coordonneeY ? parseFloat(String(v.coordonneeY)) : null;
            const hasValidCoords = coordX != null && !isNaN(coordX) && coordY != null && !isNaN(coordY);
            return {
                penaAspirationId: v.penaAspirationId,
                numero: v.numero,
                estNormalise: v.estNormalise,
                hauteurSuperieure3Metres: v.hauteurSuperieure3Metres,
                typePenaAspirationId: v.typePenaAspirationId,
                estDeporte: v.estDeporte,
                geometrie: v.estDeporte && v.srid && hasValidCoords ? `SRID=${v.srid};POINT(${coordX} ${coordY})` : null
            };
        })
    });
const $8bff802721744b7b$var$AireAspiration = ({ peiIdCarte: peiIdCarte, onSubmit: onSubmit })=>{
    let { penaId: penaId } = (0, $7a844823b04d4282$export$99eaa27ddbbb95ef)();
    penaId = peiIdCarte ?? penaId;
    const { srid: srid } = (0, $e787cde576104469$export$fdc397e486fa83e7)();
    const listeAireAspirationState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/pena/get-aire-aspiration/` + penaId);
    const { data: data } = listeAireAspirationState;
    return data && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
        initialValues: $8bff802721744b7b$export$a5cab80145b70e98(data, srid),
        validationSchema: $8bff802721744b7b$export$c084437b5e3206cd,
        isPost: false,
        submitUrl: `/api/pena/upsert-pena-aspiration/` + penaId,
        prepareVariables: (values)=>$8bff802721744b7b$export$f97400759cfd946(values),
        redirectUrl: peiIdCarte ? "" : (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).PEI,
        onSubmit: onSubmit ?? (()=>null),
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($8bff802721744b7b$var$FormAireAspiration, {
            peiIdCarte: peiIdCarte
        })
    });
};
const $8bff802721744b7b$var$FormAireAspiration = ({ peiIdCarte: peiIdCarte })=>{
    const { values: values } = (0, $bkJfK.useFormikContext)();
    const { srid: srid } = (0, $e787cde576104469$export$fdc397e486fa83e7)();
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                        icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$f736853d852cc436), {}),
                        title: "Modification des aires d'aspiration",
                        displayReturnButton: peiIdCarte ? false : true
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $665753c43020c55f$export$2e2bcd8739ae039), {
                        name: "listeAireAspiration",
                        createComponentToRepeat: $8bff802721744b7b$var$createComponentToRepeat,
                        defaultElement: {
                            penaAspirationId: null,
                            numero: "",
                            estNormalise: false,
                            hauteurSuperieure3Metres: false,
                            typePenaAspirationId: null,
                            estDeporte: false,
                            coordonneeX: null,
                            coordonneeY: null,
                            srid: srid,
                            typeSystemeSrid: (0, $e2315562ed43d638$export$2e2bcd8739ae039)[0].srid,
                            coordonneeXToDisplay: null,
                            coordonneeYToDisplay: null
                        },
                        listeElements: values.listeAireAspiration
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db9b0e6fdb142a4c$export$2e2bcd8739ae039), {
                    returnLink: peiIdCarte ? false : true
                })
            ]
        })
    });
};
const $8bff802721744b7b$var$ComposantToRepeat = ({ index: index, listeElements: listeElements })=>{
    const typePenaAspirationState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/pena/type-pena-aspiration`);
    const { setFieldValue: setFieldValue } = (0, $bkJfK.useFormikContext)();
    const { srid: srid } = (0, $e787cde576104469$export$fdc397e486fa83e7)();
    const element = listeElements[index];
    const sridList = (0, $e2315562ed43d638$export$2e2bcd8739ae039).filter((v)=>v.actif || v.srid === Number(srid)).map((v)=>({
            id: `${v.srid}`,
            code: `${v.srid}`,
            libelle: v.nomSystem
        }));
    // Récupération des géométries selon le SRID
    const geometrieState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/pei/get-geometrie-by-srid?${{
        coordonneeX: element.coordonneeXToDisplay,
        coordonneeY: element.coordonneeYToDisplay,
        srid: element.typeSystemeSrid
    }}`);
    const geometrieData = geometrieState?.data;
    // Conversion des coordonnées
    (0, $kc00y.useEffect)(()=>{
        if (element.coordonneeXToDisplay != null && element.coordonneeYToDisplay != null && element.typeSystemeSrid != null) geometrieState?.run({
            coordonneeX: element.coordonneeXToDisplay,
            coordonneeY: element.coordonneeYToDisplay,
            srid: element.typeSystemeSrid
        });
    }, [
        element.coordonneeXToDisplay,
        element.coordonneeYToDisplay,
        element.typeSystemeSrid,
        geometrieState
    ]);
    // Mettre à jour les coordonnées converties
    (0, $kc00y.useEffect)(()=>{
        if (element.coordonneeXToDisplay !== undefined && element.coordonneeYToDisplay !== undefined) {
            const coordonnees = geometrieData?.find((e)=>Number(e.srid) === Number(srid));
            if (coordonnees != null) {
                setFieldValue(`listeAireAspiration[${index}].coordonneeX`, coordonnees?.coordonneeX);
                setFieldValue(`listeAireAspiration[${index}].coordonneeY`, coordonnees?.coordonneeY);
                setFieldValue(`listeAireAspiration[${index}].srid`, srid);
            }
        }
    }, [
        element.coordonneeXToDisplay,
        element.coordonneeYToDisplay,
        srid,
        setFieldValue,
        geometrieData,
        index
    ]);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                className: "align-items-center mt-3",
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                            name: `listeAireAspiration[${index}].numero`,
                            label: "Num\xe9ro",
                            required: true
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                            name: `listeAireAspiration[${index}].typePenaAspirationId`,
                            label: "Dispositif d'aspiration",
                            listIdCodeLibelle: typePenaAspirationState.data,
                            defaultValue: typePenaAspirationState?.data?.find((e)=>e.id === listeElements[index].typePenaAspirationId),
                            required: false,
                            setFieldValue: setFieldValue
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                            name: `listeAireAspiration[${index}].estNormalise`,
                            label: "Est normalis\xe9e"
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                            name: `listeAireAspiration[${index}].hauteurSuperieure3Metres`,
                            label: "Hauteur > 3 m\xe8tres"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                className: "mt-3",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                        name: `listeAireAspiration[${index}].estDeporte`,
                        label: "Est d\xe9port\xe9e"
                    })
                })
            }),
            listeElements[index].estDeporte && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                className: "mt-3",
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        xs: 4,
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                            label: "Syst\xe8me",
                            name: `listeAireAspiration[${index}].typeSystemeSrid`,
                            required: true,
                            listIdCodeLibelle: sridList,
                            defaultValue: sridList.find((v)=>v.id === `${element.typeSystemeSrid}`),
                            onChange: (e)=>{
                                setFieldValue(`listeAireAspiration[${index}].typeSystemeSrid`, parseInt(e.code));
                                const sridActif = e.code;
                                const projectionValeur = geometrieData?.find((proj)=>proj.srid === parseInt(sridActif));
                                if (projectionValeur) {
                                    setFieldValue(`listeAireAspiration[${index}].coordonneeXToDisplay`, projectionValeur.coordonneeX);
                                    setFieldValue(`listeAireAspiration[${index}].coordonneeYToDisplay`, projectionValeur.coordonneeY);
                                    // Coordonnées en SRID système
                                    const coordonneesToSave = geometrieData?.find((proj)=>proj.srid === srid);
                                    if (coordonneesToSave) {
                                        setFieldValue(`listeAireAspiration[${index}].coordonneeX`, coordonneesToSave.coordonneeX);
                                        setFieldValue(`listeAireAspiration[${index}].coordonneeY`, coordonneesToSave.coordonneeY);
                                        setFieldValue(`listeAireAspiration[${index}].srid`, srid);
                                    }
                                }
                            },
                            setFieldValue: setFieldValue
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        xs: 4,
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                            name: `listeAireAspiration[${index}].coordonneeXToDisplay`,
                            label: "Coordonn\xe9e X",
                            required: listeElements[index].estDeporte,
                            onChange: (e)=>{
                                setFieldValue(`listeAireAspiration[${index}].coordonneeXToDisplay`, e.target.value);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        xs: 4,
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                            name: `listeAireAspiration[${index}].coordonneeYToDisplay`,
                            label: "Coordonn\xe9e Y",
                            required: listeElements[index].estDeporte,
                            onChange: (e)=>{
                                setFieldValue(`listeAireAspiration[${index}].coordonneeYToDisplay`, e.target.value);
                            }
                        })
                    })
                ]
            })
        ]
    });
};
function $8bff802721744b7b$var$createComponentToRepeat(index, listeElements) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($8bff802721744b7b$var$ComposantToRepeat, {
        index: index,
        listeElements: listeElements
    });
}
var $8bff802721744b7b$export$2e2bcd8739ae039 = $8bff802721744b7b$var$AireAspiration;












var $bkJfK = parcelRequire("bkJfK");











const $5b79ea0b037973c6$export$a5cab80145b70e98 = (data)=>({
        permisId: data?.permisId,
        permisLibelle: data?.permisLibelle,
        permisNumero: data?.permisNumero,
        permisServiceInstructeurId: data?.permisServiceInstructeurId,
        permisTypePermisInterserviceId: data?.permisTypePermisInterserviceId,
        permisTypePermisAvisId: data?.permisTypePermisAvisId,
        permisRiReceptionnee: data?.permisRiReceptionnee,
        permisDossierRiValide: data?.permisDossierRiValide,
        permisObservations: data?.permisObservations,
        permisVoieText: data?.permisVoieText,
        permisVoieId: data?.permisVoieId,
        permisComplement: data?.permisComplement,
        permisCommuneId: data?.permisCommuneId,
        permisAnnee: data?.permisAnnee,
        permisDatePermis: (0, $00c47c7740afd024$export$c6834cb9c1260d15)(data?.permisDatePermis ?? new Date()),
        permisCadastreParcelle: data?.permisCadastreParcelle,
        permisCoordonneeX: data?.permisCoordonneeX,
        permisCoordonneeY: data?.permisCoordonneeY,
        permisSrid: data?.permisSrid,
        voieSaisieText: data?.voieSaisieText,
        permisLastUpdateDate: data?.permisLastUpdateDate,
        permisInstructeurUsername: data?.permisInstructeurUsername,
        documents: data?.documents ?? []
    });
const $5b79ea0b037973c6$export$f97400759cfd946 = (values, initialData)=>{
    const formData = new FormData();
    (0, $69d686b1e97c5ea6$export$3f0f08502708410b)(values?.documents, initialData, formData);
    const permisData = {
        permisId: values.permisId,
        permisLibelle: values.permisLibelle,
        permisNumero: values.permisNumero,
        permisServiceInstructeurId: values.permisServiceInstructeurId,
        permisTypePermisInterserviceId: values.permisTypePermisInterserviceId,
        permisTypePermisAvisId: values.permisTypePermisAvisId,
        permisRiReceptionnee: values.permisRiReceptionnee,
        permisDossierRiValide: values.permisDossierRiValide,
        permisObservations: values.permisObservations?.trim() || null,
        permisVoieText: values.voieSaisieText ? values.permisVoieText : null,
        permisVoieId: values.voieSaisieText ? null : values.permisVoieId,
        permisComplement: values.permisComplement?.trim() || null,
        permisCommuneId: values.permisCommuneId,
        permisAnnee: values.permisAnnee,
        permisDatePermis: values.permisDatePermis ? new Date(values.permisDatePermis).toISOString() : null,
        permisCadastreParcelle: values.permisCadastreParcelle,
        permisGeometrie: "SRID=" + values.permisSrid + ";POINT(" + values.permisCoordonneeX + " " + values.permisCoordonneeY + ")"
    };
    formData.append("permisData", JSON.stringify(permisData));
    return formData;
};
const $5b79ea0b037973c6$var$Permis = ({ readOnly: readOnly })=>{
    const { user: user } = (0, $e787cde576104469$export$fdc397e486fa83e7)();
    const { values: values, setFieldValue: setFieldValue } = (0, $bkJfK.useFormikContext)();
    const fetchPermisData = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/permis/fetch-permis-data?${{
        geometry: "SRID=" + values.permisSrid + ";POINT(" + values.permisCoordonneeX + " " + values.permisCoordonneeY + ")"
    }}`);
    const listeParametre = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/parametres?${{
        listeParametreCode: JSON.stringify((0, $ee297f06e8568bf4$export$2e2bcd8739ae039).VOIE_SAISIE_LIBRE)
    }}`);
    if (!fetchPermisData.isResolved || !listeParametre.isResolved) return;
    const isSaisieVoieTextEnabled = JSON.parse(listeParametre?.data[(0, $ee297f06e8568bf4$export$2e2bcd8739ae039).VOIE_SAISIE_LIBRE].parametreValeur);
    const permisData = fetchPermisData.data;
    // On ne laisse pas le choix de la commune, le permis est déclaré là où le point à été posé
    if (values.permisCommuneId === "") setFieldValue("permisCommuneId", permisData.communeData.id);
    const communeAsListe = [
        {
            id: permisData.communeData.id,
            code: permisData.communeData.code,
            libelle: permisData.communeData.libelle
        }
    ];
    const filteredListeAvis = permisData.listeAvis.filter((e)=>e.pprif === permisData.communeData.pprif || e.code === "ATTENTE");
    const filteredlisteInterservice = permisData.listeInterservice.filter((e)=>e.pprif === permisData.communeData.pprif);
    const sectionCadastrale = [
        ...new Set(permisData.listeCadastreParcelle?.filter((a)=>values.permisCadastreParcelle?.includes(a.id))?.map((e)=>e.code))
    ].join(", ");
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                    name: "permisLibelle",
                    label: "Nom",
                    readOnly: readOnly
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$7edc06cf1783b30f), {
                    name: "permisDatePermis",
                    label: "Date permis",
                    readOnly: readOnly,
                    value: values.permisDatePermis
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                    name: "permisCommuneId",
                    listIdCodeLibelle: communeAsListe,
                    label: "Commune",
                    defaultValue: communeAsListe[0],
                    required: true,
                    setFieldValue: setFieldValue,
                    disabled: true
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                    name: "permisVoieId",
                    listIdCodeLibelle: permisData.listeVoie,
                    label: "Voie",
                    defaultValue: values.permisVoieId ? permisData.listeVoie.find((e)=>e.id === values.permisVoieId) : undefined,
                    required: false,
                    setFieldValue: setFieldValue,
                    disabled: readOnly || values.voieSaisieText
                })
            }),
            isSaisieVoieTextEnabled && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                            name: "voieSaisieText",
                            label: "Voie non trouv\xe9e",
                            disabled: readOnly
                        }),
                        values.voieSaisieText && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                            name: "permisVoieText",
                            label: "Voie (saisie libre)",
                            required: false,
                            readOnly: readOnly
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                    name: "permisComplement",
                    label: "Compl\xe9ment adresse",
                    required: false,
                    readOnly: readOnly
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$eae70af4b4e3f197), {
                    name: "permisCadastreParcelle",
                    label: "Parcelle cadastrale",
                    options: permisData.listeCadastreParcelle,
                    getOptionValue: (t)=>t.id,
                    getOptionLabel: (t)=>t.code + " - " + t.libelle,
                    value: values.permisCadastreParcelle?.map((e)=>permisData.listeCadastreParcelle?.find((r)=>r.id === e)) ?? undefined,
                    onChange: (parcelle)=>{
                        const parcelleId = parcelle.map((e)=>e.id);
                        parcelleId.length > 0 ? setFieldValue(`permisCadastreParcelle`, parcelleId) : setFieldValue(`permisCadastreParcelle`, undefined);
                    },
                    isClearable: false,
                    required: false,
                    tooltipText: "Les options propos\xe9es sont les 25 parcelles les plus proches du point de d\xe9claration du permis.",
                    readOnly: readOnly
                })
            }),
            values.permisCadastreParcelle?.length > 0 && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("p", {
                    children: [
                        "Section cadastrale : ",
                        sectionCadastrale
                    ]
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                    name: "permisNumero",
                    label: "N\xb0 permis",
                    readOnly: readOnly
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                            name: "permisDossierRiValide",
                            label: "Dossier RI valid\xe9",
                            disabled: readOnly
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                            name: "permisRiReceptionnee",
                            label: "RI r\xe9ceptionn\xe9e",
                            disabled: readOnly
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                    name: "permisTypePermisAvisId",
                    listIdCodeLibelle: filteredListeAvis,
                    label: "Avis",
                    defaultValue: filteredListeAvis.find((e)=>e.id === values.permisTypePermisAvisId),
                    required: true,
                    setFieldValue: setFieldValue,
                    disabled: readOnly
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                    name: "permisTypePermisInterserviceId",
                    listIdCodeLibelle: filteredlisteInterservice,
                    label: "Interservice",
                    defaultValue: filteredlisteInterservice.find((e)=>e.id === values.permisTypePermisInterserviceId),
                    required: true,
                    setFieldValue: setFieldValue,
                    disabled: readOnly
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$ce9b1cc0c34506d0), {
                    name: "permisObservations",
                    label: "Observations",
                    required: false,
                    readOnly: readOnly
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                    name: "permisServiceInstructeurId",
                    listIdCodeLibelle: permisData.listeServiceInstructeur,
                    label: "Service instructeur",
                    defaultValue: permisData.listeServiceInstructeur.find((e)=>e.id === values.permisServiceInstructeurId),
                    required: true,
                    setFieldValue: setFieldValue,
                    disabled: readOnly
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$2e2bcd8739ae039), {
                    name: "permisAnnee",
                    label: "Ann\xe9e",
                    readOnly: readOnly
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("p", {
                        children: [
                            "Derni\xe8re modification :",
                            " ",
                            values.permisLastUpdateDate ?? "aucune donn\xe9e"
                        ]
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("p", {
                        children: [
                            "Instructeur : ",
                            values.permisInstructeurUsername
                        ]
                    })
                ]
            }),
            !readOnly && (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).PERMIS_DOCUMENTS_C) ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $69d686b1e97c5ea6$export$2e2bcd8739ae039), {
                    documents: values.documents,
                    setFieldValue: setFieldValue
                })
            }) : /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("p", {
                            className: "fw-bold mt-2",
                            children: "Document"
                        })
                    }),
                    values.documents.length > 0 ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                        children: values.documents.map((value, index)=>{
                            return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                                variant: "link",
                                href: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/documents/telecharger/` + value.documentId,
                                children: value.documentNomFichier
                            }, index);
                        })
                    }) : (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).PERMIS_DOCUMENTS_C) ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("p", {
                        children: "Aucun document fourni"
                    }) : /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("p", {
                        children: "Vous n'avez pas les droits n\xe9cessaires pour d\xe9poser des documents."
                    })
                ]
            }),
            !readOnly && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                className: "mt-3",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                    className: "text-center",
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                        type: "submit",
                        variant: "primary",
                        children: "Valider"
                    })
                })
            })
        ]
    });
};
var $5b79ea0b037973c6$export$2e2bcd8739ae039 = $5b79ea0b037973c6$var$Permis;


const $cc4162eb629a87fb$var$UpdatePermis = ({ permisId: permisId, coordonneeX: coordonneeX, coordonneeY: coordonneeY, srid: srid, onSubmit: onSubmit, readOnly: readOnly = false, deplacement: deplacement = false })=>{
    const data = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/permis/${permisId}`);
    if (!data.isResolved) return;
    const resolvedData = data.data;
    // Si le volet est ouvert suite à un déplacement sur la carte,
    // on réinitialise commune, voie, complément, parcelles.
    const contextDeplacement = !!deplacement;
    const pageTitle = readOnly ? resolvedData.permis.permisLibelle ? `Visualisation du permis ${resolvedData.permis.permisLibelle}` : "Visualisation d'un permis" : resolvedData.permis.permisLibelle ? `Modification du permis ${resolvedData.permis.permisLibelle}` : "Modification d'un permis";
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$7876caa18827ace7), {}),
                title: pageTitle,
                displayReturnButton: false
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                initialValues: (0, $5b79ea0b037973c6$export$a5cab80145b70e98)({
                    ...resolvedData.permis,
                    permisId: permisId,
                    permisCoordonneeX: coordonneeX,
                    permisCoordonneeY: coordonneeY,
                    permisSrid: srid,
                    permisDatePermis: resolvedData.permis.permisDatePermis ? (0, $00c47c7740afd024$export$c6834cb9c1260d15)(resolvedData.permis.permisDatePermis) : null,
                    permisCadastreParcelle: contextDeplacement ? [] : resolvedData.permisCadastreParcelle,
                    voieSaisieText: contextDeplacement ? false : !!(resolvedData.permis.permisVoieText && resolvedData.permis.permisVoieText.trim() !== ""),
                    permisVoieId: contextDeplacement ? undefined : resolvedData.permis.permisVoieId ?? undefined,
                    permisVoieText: contextDeplacement ? undefined : resolvedData.permis.permisVoieText ?? undefined,
                    permisComplement: contextDeplacement ? undefined : resolvedData.permis.permisComplement ?? undefined,
                    permisLastUpdateDate: resolvedData.permisLastUpdateDate ? (0, $00c47c7740afd024$export$c74325cff954054e)(new Date(resolvedData.permisLastUpdateDate)) : null,
                    permisInstructeurUsername: resolvedData.permisInstructeurUsername,
                    documents: resolvedData.permisDocument ?? []
                }),
                isPost: false,
                isMultipartFormData: true,
                prepareVariables: (values)=>(0, $5b79ea0b037973c6$export$f97400759cfd946)(values, resolvedData.permisDocument),
                onSubmit: onSubmit,
                submitUrl: `/api/permis/${permisId}`,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $5b79ea0b037973c6$export$2e2bcd8739ae039), {
                    readOnly: readOnly
                })
            })
        ]
    });
};
var $cc4162eb629a87fb$export$2e2bcd8739ae039 = $cc4162eb629a87fb$var$UpdatePermis;






const $75922f6c6bbf044f$export$5ce08de4b8a5efb7 = (html)=>{
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    // Traiter les dates sans heure (formatDate)
    const dateOnlyElements = doc.querySelectorAll(".date-to-convert");
    dateOnlyElements.forEach((el)=>{
        const isoDateString = el.getAttribute("datetime") || "";
        if (isoDateString) try {
            const date = new Date(isoDateString);
            el.textContent = (0, $00c47c7740afd024$export$3ae94a2503e890a1)(date);
        } catch (_) {
            el.textContent = isoDateString;
        }
    });
    // Traiter les dates avec heure (formatDateHeure)
    const dateTimeElements = doc.querySelectorAll(".date-time-to-convert");
    dateTimeElements.forEach((el)=>{
        const isoDateString = el.getAttribute("datetime") || "";
        if (isoDateString) try {
            const date = new Date(isoDateString);
            el.textContent = (0, $00c47c7740afd024$export$c74325cff954054e)(date);
        } catch (_) {
            el.textContent = isoDateString;
        }
    });
    return doc.body.innerHTML;
};









const $261998279c461521$var$DeleteButtonWithModal = ({ path: path, reload: reload, title: title = true, disabled: disabled = false, variant: variant = "danger", className: className = "text-white", header: header = null, content: content = null })=>{
    const { visible: visible, ref: ref, isDeleteEnabled: isDeleteEnabled, openDeleteModal: openDeleteModal, closeDeleteModalCancel: closeDeleteModalCancel, closeDeleteModalError: closeDeleteModalError, closeDeleteModalSuccess: closeDeleteModalSuccess } = (0, $6db3fd3479b0e545$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                variant: variant,
                disabled: disabled || !isDeleteEnabled,
                onClick: openDeleteModal,
                className: className,
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$4d4e10ce882b8153), {}),
                    title && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
                        children: "\xa0Supprimer"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $791e7ee3b0d1ae7e$export$2e2bcd8739ae039), {
                visible: visible,
                onCancel: closeDeleteModalCancel,
                onError: closeDeleteModalError,
                onSuccess: closeDeleteModalSuccess,
                query: path,
                ref: ref,
                onDelete: ()=>reload ? reload() : window.location.reload(),
                header: header,
                content: content
            })
        ]
    });
};
var $261998279c461521$export$2e2bcd8739ae039 = $261998279c461521$var$DeleteButtonWithModal;










/**
 * Permet d'afficher une tooltip sur la carte lorsque l'utilisateur clique sur un point
 * @param map : la carte
 * @returns la tooltip
 */ const $b0759c348c3ed98d$var$TooltipMapPei = ({ map: map, displayButtonEdit: displayButtonEdit, displayButtonSeeFichePei: displayButtonSeeFichePei, displayButtonDelete: displayButtonDelete, dataPeiLayer: dataPeiLayer, disabledTooltip: disabledTooltip = false, displayButtonEditDebitSimultane: displayButtonEditDebitSimultane, dataDebitSimultaneLayer: dataDebitSimultaneLayer, setShowFormPei: setShowFormPei, peiIdUpdate: peiIdUpdate, setPeiIdUpdate: setPeiIdUpdate, showFormPei: showFormPei, disabledCreateButton: disabledCreateButton, setShowFormVisite: setShowFormVisite, showFormVisite: showFormVisite, coordonneesPeiCreate: coordonneesPeiCreate, onTooltipPeiSelectionChange: onTooltipPeiSelectionChange })=>{
    const ref = (0, $kc00y.useRef)(null);
    const navigate = (0, $7a844823b04d4282$export$9770f232ac06a008)();
    const location = (0, $7a844823b04d4282$export$45d76561a5302f2b)();
    const filterFeaturePei = (0, $kc00y.useCallback)((feature)=>feature.getProperties().typeElementCarte === (0, $56aa34800e0589a0$export$2e2bcd8739ae039).PEI || feature.getProperties().typeElementCarte === (0, $56aa34800e0589a0$export$2e2bcd8739ae039).DEBIT_SIMULTANE, []);
    const { featureSelect: featureSelect, overlay: overlay } = $b0759c348c3ed98d$var$useTooltipMap({
        ref: ref,
        map: map,
        filterFeature: filterFeaturePei
    });
    const [showFichePei, setShowFichePei] = (0, $kc00y.useState)(false);
    const handleCloseFichePei = ()=>setShowFichePei(false);
    const [showDocumentPei, setShowDocumentPei] = (0, $kc00y.useState)(false);
    const handleCloseDocumentPei = ()=>setShowDocumentPei(false);
    const [showIndispoTemp, setShowIndispoTemp] = (0, $kc00y.useState)(false);
    const handleCloseIndispoTemp = ()=>setShowIndispoTemp(false);
    const [showLeverIndispoTempVolet, setShowLeverIndispoTempVolet] = (0, $kc00y.useState)(false);
    const [showTournee, setShowTournee] = (0, $kc00y.useState)(false);
    const handleCloseTournee = ()=>setShowTournee(false);
    const [showAspiration, setShowAspiration] = (0, $kc00y.useState)(false);
    const handleCloseAspiration = ()=>setShowAspiration(false);
    const [showUpdateDebitSimultane, setShowUpdateDebitSimultane] = (0, $kc00y.useState)(false);
    const handleCloseUpdateDebitSimultane = ()=>setShowUpdateDebitSimultane(false);
    const elementId = featureSelect?.getProperties().elementId;
    const { user: user } = (0, $e787cde576104469$export$fdc397e486fa83e7)();
    const textDisable = "Un formulaire est en cours d'\xe9dition";
    const paramPeiFicheResumeStandalone = (0, $ee297f06e8568bf4$export$2e2bcd8739ae039).PEI_FICHE_RESUME_STANDALONE;
    const parametresState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/parametres?${{
        listeParametreCode: JSON.stringify(paramPeiFicheResumeStandalone)
    }}`, {});
    const isFicheResumeStandalone = (0, $kc00y.useMemo)(()=>{
        if (!parametresState.isResolved) return false;
        return JSON.parse(parametresState?.data[paramPeiFicheResumeStandalone].parametreValeur);
    }, [
        parametresState
    ]);
    (0, $kc00y.useEffect)(()=>{
        if (peiIdUpdate === null && showFormPei && !coordonneesPeiCreate) {
            overlay?.setPosition(undefined);
            setShowFormPei(false);
        }
    }, [
        peiIdUpdate,
        setShowFormPei,
        showFormPei,
        overlay,
        coordonneesPeiCreate
    ]);
    (0, $kc00y.useEffect)(()=>{
        if (!onTooltipPeiSelectionChange || disabledTooltip) return;
        if (featureSelect?.getProperties().typeElementCarte === (0, $56aa34800e0589a0$export$2e2bcd8739ae039).PEI) {
            const point = featureSelect.getProperties();
            onTooltipPeiSelectionChange({
                elementId: point.elementId,
                peiNumeroComplet: point.peiNumeroComplet,
                natureDeciCode: point.natureDeciCode
            });
        } else onTooltipPeiSelectionChange(null);
    }, [
        featureSelect,
        onTooltipPeiSelectionChange,
        disabledTooltip
    ]);
    (0, $kc00y.useEffect)(()=>{
        if (!overlay || !onTooltipPeiSelectionChange) return;
        const listener = overlay.on("change:position", ()=>{
            if (overlay.getPosition() == null) onTooltipPeiSelectionChange(null);
        });
        return ()=>{
            (0, $a8e855f7c93fe402$export$b7ef3f8527533384)(listener);
        };
    }, [
        overlay,
        onTooltipPeiSelectionChange
    ]);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
        ref: ref,
        children: featureSelect?.getProperties().typeElementCarte === (0, $56aa34800e0589a0$export$2e2bcd8739ae039).PEI ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($b0759c348c3ed98d$var$Tooltip, {
            disabled: disabledTooltip,
            featureSelect: featureSelect,
            overlay: overlay,
            displayButtonEdit: displayButtonEdit,
            onClickEdit: ()=>{
                setShowFormPei(true);
                setPeiIdUpdate(elementId);
                disabledCreateButton();
            },
            labelEdit: showFormPei || showFormVisite.show ? textDisable : "Modifier le PEI",
            displayButtonDelete: displayButtonDelete,
            disabledEdit: showFormPei || showFormVisite.show,
            deletePath: `/api/pei/delete/` + elementId,
            onClickDelete: ()=>{
                dataPeiLayer.getSource().refresh();
                (0, $1ed1be1197ad1bc4$export$51ba454167fb25ab)(map);
                overlay?.setPosition(undefined);
            },
            labelDelete: featureSelect?.getProperties().hasTourneeReservee ? "Impossible de supprimer un PEI affect\xe9 \xe0 une tourn\xe9e r\xe9serv\xe9e" : showFormPei || showFormVisite.show ? textDisable : "Supprimer le PEI",
            disabledDelete: showFormPei || showFormVisite.show,
            displayButtonSee: isFicheResumeStandalone,
            onClickSee: ()=>setShowFichePei(true),
            labelSee: "Voir la fiche R\xe9sum\xe9 du PEI",
            autreActionBouton: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                children: [
                    displayButtonSeeFichePei && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        className: "p-1",
                        xs: "auto",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                            tooltipText: "Voir la fiche compl\xe8te du PEI",
                            tooltipId: "fichepei",
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $43f579690a1c166d$export$2e2bcd8739ae039), {
                                pathname: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).UPDATE_PEI(elementId),
                                variant: "primary",
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$50a7b2527c056255), {})
                            })
                        })
                    }),
                    (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).PEI_R) && featureSelect?.getProperties().hasDocuments && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        className: "p-1",
                        xs: "auto",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                            tooltipText: "Consulter les documents du PEI",
                            tooltipId: "documents-pei-carte",
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                                variant: "info",
                                onClick: ()=>{
                                    setShowDocumentPei(true);
                                    overlay?.setPosition(undefined);
                                },
                                disabled: showFormPei || showFormVisite.show,
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$84ac927778fdc063), {})
                            })
                        })
                    }),
                    (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).VISITE_R) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        className: "p-1",
                        xs: "auto",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                            tooltipText: showFormPei || showFormVisite.show ? textDisable : "G\xe9rer les visites du PEI",
                            tooltipId: "visite",
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                                variant: "warning",
                                onClick: ()=>{
                                    setShowFormVisite({
                                        peiId: elementId,
                                        show: true
                                    });
                                },
                                disabled: showFormPei || showFormVisite.show,
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$931ba9c16d55112), {})
                            })
                        })
                    }),
                    featureSelect?.getProperties().hasIndispoTemp && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                className: "p-1",
                                xs: "auto",
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                                    tooltipText: showFormPei || showFormVisite.show ? textDisable : "Voir les indisponibilit\xe9s temporaires du PEI",
                                    tooltipId: "indispo-temp-carte",
                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                                        variant: "warning",
                                        onClick: ()=>{
                                            setShowIndispoTemp(true);
                                            overlay?.setPosition(undefined);
                                        },
                                        disabled: showFormPei || showFormVisite.show,
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$77223e42038127b5), {})
                                    })
                                })
                            }),
                            (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).INDISPO_TEMP_U) && featureSelect?.getProperties()?.hasIndispoTemp && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                className: "p-1",
                                xs: "auto",
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                                    tooltipText: showFormPei || showFormVisite.show ? textDisable : "Lever une indisponibilit\xe9 temporaire",
                                    tooltipId: "indispo-temp-carte",
                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                                        variant: "danger",
                                        className: "text-white",
                                        onClick: ()=>{
                                            dataPeiLayer.getSource().refresh();
                                            setShowLeverIndispoTempVolet(true);
                                            overlay?.setPosition(undefined);
                                        },
                                        disabled: showFormPei || showFormVisite.show,
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$37a0f4bc54062d1c), {})
                                    })
                                })
                            })
                        ]
                    }),
                    featureSelect?.getProperties().hasTournee && (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).TOURNEE_R) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        className: "p-1",
                        xs: "auto",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                            tooltipText: showFormPei || showFormVisite.show ? textDisable : "Voir les tourn\xe9es associ\xe9es",
                            tooltipId: "tournees-carte",
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                                variant: "warning",
                                onClick: ()=>{
                                    setShowTournee(true);
                                    overlay?.setPosition(undefined);
                                },
                                disabled: showFormPei || showFormVisite.show,
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$5ee68ae963bf2bda), {})
                            })
                        })
                    }),
                    featureSelect?.getProperties().peiTypePei === "PENA" && (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).PEI_U) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        className: "p-1",
                        xs: "auto",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                            tooltipText: showFormPei || showFormVisite.show ? textDisable : "Voir les aires d'aspiration associ\xe9es",
                            tooltipId: "aspiration-carte",
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                                variant: "warning",
                                onClick: ()=>{
                                    setShowAspiration(true);
                                    overlay?.setPosition(undefined);
                                },
                                disabled: showFormPei || showFormVisite.show,
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$f736853d852cc436), {})
                            })
                        })
                    }),
                    isFicheResumeStandalone && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1eee265537f042a4$export$2e2bcd8739ae039), {
                        handleClose: handleCloseFichePei,
                        show: showFichePei,
                        className: "w-auto",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $4c401fa322fe4af6$export$2e2bcd8739ae039), {
                            peiId: elementId,
                            peiNumeroComplet: featureSelect?.getProperties().peiNumeroComplet,
                            titre: "Fiche R\xe9sum\xe9 du PEI " + featureSelect?.getProperties().peiNumeroComplet
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1eee265537f042a4$export$2e2bcd8739ae039), {
                        handleClose: handleCloseDocumentPei,
                        show: showDocumentPei,
                        className: "w-auto",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e7b5be6e16761684$export$2e2bcd8739ae039), {
                            peiId: elementId,
                            titre: "Documents du PEI " + featureSelect?.getProperties().peiNumeroComplet
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1eee265537f042a4$export$2e2bcd8739ae039), {
                        handleClose: ()=>{
                            handleCloseIndispoTemp();
                            navigate({
                                pathname: location.pathname,
                                search: ""
                            }, {
                                replace: true,
                                state: location.state
                            });
                        },
                        show: showIndispoTemp,
                        className: "w-auto",
                        backdrop: true,
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e7fda6f52dff7328$export$2e2bcd8739ae039), {
                            peiId: elementId,
                            colonnes: [
                                (0, $7232829592627b50$export$2e2bcd8739ae039).MOTIF,
                                (0, $7232829592627b50$export$2e2bcd8739ae039).LIST_PEI
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1eee265537f042a4$export$2e2bcd8739ae039), {
                        handleClose: ()=>{
                            setShowLeverIndispoTempVolet(false);
                        },
                        show: showLeverIndispoTempVolet,
                        className: "w-auto",
                        backdrop: true,
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $d41e9686ad2d2092$export$2e2bcd8739ae039), {
                            onClick: ()=>{
                                dataPeiLayer.getSource().refresh();
                                (0, $1ed1be1197ad1bc4$export$51ba454167fb25ab)(map);
                                overlay?.setPosition(undefined);
                            },
                            idPei: elementId,
                            closeVolet: ()=>{
                                setShowLeverIndispoTempVolet(false);
                                (0, $1ed1be1197ad1bc4$export$51ba454167fb25ab)(map);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1eee265537f042a4$export$2e2bcd8739ae039), {
                        handleClose: ()=>{
                            handleCloseTournee();
                            navigate({
                                pathname: location.pathname,
                                search: ""
                            }, {
                                replace: true,
                                state: location.state
                            });
                        },
                        show: showTournee,
                        className: "w-auto",
                        backdrop: true,
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $32ff803568ba9e09$export$2e2bcd8739ae039), {
                            peiId: elementId
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1eee265537f042a4$export$2e2bcd8739ae039), {
                        handleClose: ()=>{
                            handleCloseAspiration();
                            navigate({
                                pathname: location.pathname,
                                search: ""
                            }, {
                                replace: true,
                                state: location.state
                            });
                        },
                        show: showAspiration,
                        className: "w-auto",
                        backdrop: true,
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8bff802721744b7b$export$2e2bcd8739ae039), {
                            peiIdCarte: elementId,
                            onSubmit: handleCloseAspiration
                        })
                    })
                ]
            })
        }) : featureSelect?.getProperties().typeElementCarte === (0, $56aa34800e0589a0$export$2e2bcd8739ae039).DEBIT_SIMULTANE ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($b0759c348c3ed98d$var$Tooltip, {
                    featureSelect: featureSelect,
                    overlay: overlay,
                    displayButtonEdit: displayButtonEditDebitSimultane,
                    onClickEdit: ()=>setShowUpdateDebitSimultane(true),
                    displayButtonDelete: displayButtonEditDebitSimultane,
                    onClickDelete: ()=>{
                        dataDebitSimultaneLayer.getSource().refresh();
                        dataPeiLayer.getSource().refresh();
                        (0, $1ed1be1197ad1bc4$export$51ba454167fb25ab)(map);
                        overlay?.setPosition(undefined);
                    },
                    deletePath: `/api/debit-simultane/delete/` + elementId
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1eee265537f042a4$export$2e2bcd8739ae039), {
                    handleClose: ()=>{
                        handleCloseUpdateDebitSimultane();
                    },
                    show: showUpdateDebitSimultane,
                    className: "w-50",
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $c0d401b6231ce1af$export$2e2bcd8739ae039), {
                        debitSimultaneId: elementId,
                        onSubmit: ()=>{
                            dataDebitSimultaneLayer.getSource().refresh();
                            dataPeiLayer.getSource().refresh();
                            (0, $1ed1be1197ad1bc4$export$51ba454167fb25ab)(map);
                            handleCloseUpdateDebitSimultane();
                        },
                        typeReseauId: featureSelect?.getProperties().typeReseauId,
                        coordonneeX: featureSelect?.getProperties().geometry.flatCoordinates[0],
                        coordonneeY: featureSelect?.getProperties().geometry.flatCoordinates[1],
                        srid: map.getView().getProjection().getCode().split(":")[1]
                    })
                })
            ]
        }) : ""
    });
};
var $b0759c348c3ed98d$export$2e2bcd8739ae039 = $b0759c348c3ed98d$var$TooltipMapPei;
const $b0759c348c3ed98d$var$Tooltip = ({ disabled: disabled = false, featureSelect: featureSelect, overlay: overlay, displayButtonEdit: displayButtonEdit = false, onClickEdit: onClickEdit, hrefEdit: hrefEdit, labelEdit: labelEdit = "Modifier l'\xe9l\xe9ment", disabledEdit: disabledEdit = false, displayButtonDelete: displayButtonDelete = false, onClickDelete: onClickDelete, deletePath: deletePath, labelDelete: labelDelete = "Supprimer l'\xe9l\xe9ment", disabledDelete: disabledDelete = false, displayButtonSee: displayButtonSee = false, onClickSee: onClickSee, labelSee: labelSee = "Voir l'\xe9l\xe9ment", href: href, autreActionBouton: autreActionBouton })=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
        children: featureSelect?.getProperties().elementId && !disabled && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $24bc7fd4c9d44342$export$2e2bcd8739ae039), {
            id: "popover",
            placement: "bottom",
            arrowProps: {
                style: {
                    display: "none"
                }
            },
            style: {
                transform: "translateY(-20px)"
            },
            children: [
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $24bc7fd4c9d44342$export$2e2bcd8739ae039).Header, {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                children: "Informations"
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                className: "ms-auto",
                                xs: "auto",
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                                    variant: "link",
                                    onClick: ()=>overlay?.setPosition(undefined),
                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$e04bcc6127e699bf), {})
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $24bc7fd4c9d44342$export$2e2bcd8739ae039).Body, {
                    children: [
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                            className: "popover-body-content",
                            dangerouslySetInnerHTML: {
                                __html: (0, $75922f6c6bbf044f$export$5ce08de4b8a5efb7)(featureSelect.getProperties().propertiesToDisplay)
                            }
                        }),
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                            className: "mt-3",
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                className: "ms-auto",
                                xs: "auto",
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                    children: [
                                        displayButtonSee && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                            className: "p-1",
                                            xs: "auto",
                                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                                                tooltipText: labelSee,
                                                tooltipId: "fiche-resume-carte",
                                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                                                    variant: "primary",
                                                    onClick: onClickSee,
                                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$8bb46d5eef767d7), {})
                                                })
                                            })
                                        }),
                                        displayButtonEdit && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                            className: "p-1",
                                            xs: "auto",
                                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                                                tooltipText: labelEdit,
                                                tooltipId: "edit-carte",
                                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $43f579690a1c166d$export$2e2bcd8739ae039), {
                                                    variant: "info",
                                                    className: "text-white",
                                                    onClick: onClickEdit,
                                                    pathname: hrefEdit,
                                                    disabled: disabledEdit,
                                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$b51dd496211ae105), {})
                                                })
                                            })
                                        }),
                                        displayButtonDelete && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                            className: "p-1",
                                            xs: "auto",
                                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                                                tooltipText: labelDelete,
                                                tooltipId: "supprimer-carte",
                                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $261998279c461521$export$2e2bcd8739ae039), {
                                                    path: deletePath,
                                                    disabled: !displayButtonDelete || featureSelect?.getProperties().hasTourneeReservee || disabledDelete,
                                                    title: false,
                                                    reload: onClickDelete,
                                                    header: `Suppression du PEI ${featureSelect?.getProperties().peiNumeroComplet ? featureSelect?.getProperties().peiNumeroComplet : ""}`,
                                                    content: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                                                        children: [
                                                            "\xcates-vous s\xfbr de vouloir supprimer le PEI",
                                                            " ",
                                                            featureSelect?.getProperties().peiNumeroComplet ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("b", {
                                                                children: featureSelect?.getProperties().peiNumeroComplet
                                                            }) : "s\xe9lectionn\xe9",
                                                            " ",
                                                            "? Cette action est irr\xe9versible."
                                                        ]
                                                    })
                                                })
                                            })
                                        }),
                                        autreActionBouton && autreActionBouton
                                    ]
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
const $b0759c348c3ed98d$export$6dc0aa31e09fabda = ({ map: map, etudeId: etudeId, disabledEditPeiProjet: disabledEditPeiProjet = false, dataPeiProjetLayer: dataPeiProjetLayer, disabled: disabled })=>{
    const ref = (0, $kc00y.useRef)(null);
    const [showUpdatePeiProjet, setShowUpdatePeiProjet] = (0, $kc00y.useState)(false);
    const handleCloseUpdatePeiProjet = ()=>setShowUpdatePeiProjet(false);
    const { featureSelect: featureSelect, overlay: overlay } = $b0759c348c3ed98d$var$useTooltipMap({
        ref: ref,
        map: map,
        disabled: disabled
    });
    const displayEditDeleteButton = !disabledEditPeiProjet && featureSelect?.getProperties().typeElementCarte === "PEI_PROJET" && featureSelect?.getProperties().elementId != null;
    if (disabled) overlay?.setPosition(undefined);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                ref: ref,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($b0759c348c3ed98d$var$Tooltip, {
                    featureSelect: featureSelect,
                    overlay: overlay,
                    onClickEdit: ()=>setShowUpdatePeiProjet(true),
                    displayButtonEdit: displayEditDeleteButton,
                    displayButtonDelete: displayEditDeleteButton,
                    onClickDelete: ()=>{
                        dataPeiProjetLayer.getSource().refresh();
                        (0, $1ed1be1197ad1bc4$export$51ba454167fb25ab)(map);
                        overlay?.setPosition(undefined);
                    },
                    deletePath: "/api/couverture-hydraulique/pei-projet/" + featureSelect?.getProperties().elementId,
                    disabled: disabled
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1eee265537f042a4$export$2e2bcd8739ae039), {
                handleClose: handleCloseUpdatePeiProjet,
                show: showUpdatePeiProjet,
                className: "w-auto",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $bb50efe5e52f41fa$export$2e2bcd8739ae039), {
                    etudeId: etudeId,
                    peiProjetId: featureSelect?.getProperties().elementId,
                    coordonneeX: featureSelect?.getProperties().geometry.getFlatCoordinates()[0],
                    coordonneeY: featureSelect?.getProperties().geometry.getFlatCoordinates()[1],
                    srid: map.getView().getProjection().getCode().split(":").pop(),
                    onSubmit: ()=>{
                        handleCloseUpdatePeiProjet();
                        overlay?.setPosition(undefined);
                    }
                })
            })
        ]
    });
};
const $b0759c348c3ed98d$export$bb9fc698d6b9459f = ({ map: map, disabled: disabled, criseId: criseId, state: state, onClose: onClose, dataEvenementLayer: dataEvenementLayer })=>{
    const ref = (0, $kc00y.useRef)(null);
    const [showUpdateEvenement, setShowUpdateEvenement] = (0, $kc00y.useState)(false);
    const [isReadOnly, setIsReadOnly] = (0, $kc00y.useState)(false);
    const handleCloseUpdateEvenement = ()=>setShowUpdateEvenement(false);
    const { featureSelect: featureSelect, overlay: overlay } = $b0759c348c3ed98d$var$useTooltipMap({
        ref: ref,
        map: map,
        disabled: disabled,
        filterFeature: (feature)=>{
            // Ne détecte que les features de la couche évènements
            return dataEvenementLayer?.getSource()?.getFeatures()?.includes(feature) ?? false;
        }
    });
    const eventId = featureSelect?.getProperties().elementId;
    const displayButton = featureSelect?.getProperties().elementId != null;
    const srid = map.getView().getProjection().getCode().split(":")[1];
    if (disabled) overlay?.setPosition(undefined);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
        ref: ref,
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($b0759c348c3ed98d$var$Tooltip, {
                featureSelect: featureSelect,
                overlay: overlay,
                onClickEdit: ()=>{
                    setShowUpdateEvenement(true), setIsReadOnly(false);
                },
                displayButtonEdit: displayButton,
                displayButtonSee: displayButton,
                onClickSee: ()=>{
                    setShowUpdateEvenement(true), setIsReadOnly(true);
                }
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1eee265537f042a4$export$2e2bcd8739ae039), {
                handleClose: handleCloseUpdateEvenement,
                show: showUpdateEvenement,
                className: "w-auto",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $82ecdcbf19510aa3$export$2e2bcd8739ae039), {
                    state: state,
                    readOnly: isReadOnly,
                    criseId: criseId,
                    evenementId: eventId,
                    geometrieEvenement: `SRID=${srid};${featureSelect && new (0, $15a985d09649bdc2$export$2e2bcd8739ae039)().writeFeature(featureSelect)}`,
                    onSubmit: ()=>{
                        onClose();
                        handleCloseUpdateEvenement();
                        overlay?.setPosition(undefined);
                    }
                })
            })
        ]
    });
};
const $b0759c348c3ed98d$export$821d223070f8ed58 = ({ map: map, disabledEditPeiPrescrit: disabledEditPeiPrescrit = false, dataPeiPrescritLayer: dataPeiPrescritLayer, disabled: disabled })=>{
    const ref = (0, $kc00y.useRef)(null);
    const [showUpdatePeiPrescrit, setShowUpdatePeiPrescrit] = (0, $kc00y.useState)(false);
    const handleCloseUpdatePeiPrescrit = ()=>setShowUpdatePeiPrescrit(false);
    const { featureSelect: featureSelect, overlay: overlay } = $b0759c348c3ed98d$var$useTooltipMap({
        ref: ref,
        map: map,
        disabled: disabled
    });
    const displayEditDeleteButton = !disabledEditPeiPrescrit && featureSelect?.getProperties().typeElementCarte === "PEI_PRESCRIT" && featureSelect?.getProperties().elementId != null;
    if (disabled) overlay?.setPosition(undefined);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
        ref: ref,
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($b0759c348c3ed98d$var$Tooltip, {
                featureSelect: featureSelect,
                overlay: overlay,
                onClickEdit: ()=>{
                    setShowUpdatePeiPrescrit(true), overlay?.setPosition(undefined);
                },
                displayButtonEdit: displayEditDeleteButton,
                displayButtonDelete: displayEditDeleteButton,
                onClickDelete: ()=>{
                    dataPeiPrescritLayer.getSource().refresh();
                    (0, $1ed1be1197ad1bc4$export$51ba454167fb25ab)(map);
                    overlay?.setPosition(undefined);
                },
                deletePath: "/api/pei-prescrit/" + featureSelect?.getProperties().elementId,
                disabled: disabled
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1eee265537f042a4$export$2e2bcd8739ae039), {
                handleClose: handleCloseUpdatePeiPrescrit,
                show: showUpdatePeiPrescrit,
                className: "w-auto",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $09be900bd8ffca81$export$2e2bcd8739ae039), {
                    peiPrescritId: featureSelect?.getProperties().elementId,
                    coordonneeX: featureSelect?.getProperties().geometry.getFlatCoordinates()[0],
                    coordonneeY: featureSelect?.getProperties().geometry.getFlatCoordinates()[1],
                    srid: map.getView().getProjection().getCode().split(":")[1],
                    onSubmit: ()=>{
                        handleCloseUpdatePeiPrescrit();
                        dataPeiPrescritLayer.getSource().refresh();
                        overlay?.setPosition(undefined);
                    }
                })
            })
        ]
    });
};
const $b0759c348c3ed98d$export$561d6732975c09b8 = ({ map: map, disabledEditPermis: disabledEditPermis = false, dataPermisLayer: dataPermisLayer, disabled: disabled, hasRightToInteract: hasRightToInteract = false, voletOuvert: voletOuvert })=>{
    const ref = (0, $kc00y.useRef)(null);
    const [permisSelectionne, setPermisSelectionne] = (0, $kc00y.useState)(null);
    const [showUpdatePermis, setShowUpdatePermis] = (0, $kc00y.useState)(false);
    const handleCloseUpdatePermis = ()=>{
        voletOuvert.current = false;
        setShowUpdatePermis(false);
        setPermisSelectionne(null);
    };
    const [showPermisReadOnly, setShowPermisReadOnly] = (0, $kc00y.useState)(false);
    const handleClosePermisReadOnly = ()=>{
        voletOuvert.current = false;
        setShowPermisReadOnly(false);
        setPermisSelectionne(null);
    };
    const { featureSelect: featureSelect, overlay: overlay } = $b0759c348c3ed98d$var$useTooltipMap({
        ref: ref,
        map: map,
        disabled: disabled
    });
    const displayEditDeleteButton = hasRightToInteract && !disabledEditPermis && !voletOuvert.current && featureSelect?.getProperties().typeElementCarte === "PERMIS" && featureSelect?.getProperties().elementId != null;
    if (disabled) overlay?.setPosition(undefined);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
        ref: ref,
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($b0759c348c3ed98d$var$Tooltip, {
                featureSelect: featureSelect,
                overlay: overlay,
                onClickEdit: ()=>{
                    if (voletOuvert.current) return;
                    voletOuvert.current = true;
                    setPermisSelectionne(featureSelect?.getProperties());
                    setShowUpdatePermis(true);
                    setShowPermisReadOnly(false);
                },
                displayButtonEdit: displayEditDeleteButton,
                displayButtonDelete: displayEditDeleteButton,
                onClickDelete: ()=>{
                    dataPermisLayer.getSource().refresh();
                    (0, $1ed1be1197ad1bc4$export$51ba454167fb25ab)(map);
                    overlay?.setPosition(undefined);
                },
                deletePath: "/api/permis/" + featureSelect?.getProperties().elementId,
                disabled: disabled,
                displayButtonSee: !voletOuvert.current,
                onClickSee: ()=>{
                    if (voletOuvert.current) return;
                    voletOuvert.current = true;
                    setPermisSelectionne(featureSelect?.getProperties());
                    setShowPermisReadOnly(true);
                    setShowUpdatePermis(false);
                }
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1eee265537f042a4$export$2e2bcd8739ae039), {
                handleClose: handleCloseUpdatePermis,
                show: showUpdatePermis,
                className: "w-auto",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $cc4162eb629a87fb$export$2e2bcd8739ae039), {
                    permisId: permisSelectionne?.elementId,
                    coordonneeX: permisSelectionne?.geometry.getFlatCoordinates()[0],
                    coordonneeY: permisSelectionne?.geometry.getFlatCoordinates()[1],
                    srid: map.getView().getProjection().getCode().split(":")[1],
                    deplacement: false,
                    onSubmit: ()=>{
                        handleCloseUpdatePermis();
                        overlay?.setPosition(undefined);
                    },
                    readOnly: false
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1eee265537f042a4$export$2e2bcd8739ae039), {
                handleClose: handleClosePermisReadOnly,
                show: showPermisReadOnly,
                className: "w-auto",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $cc4162eb629a87fb$export$2e2bcd8739ae039), {
                    permisId: permisSelectionne?.elementId,
                    coordonneeX: permisSelectionne?.geometry.getFlatCoordinates()[0],
                    coordonneeY: permisSelectionne?.geometry.getFlatCoordinates()[1],
                    srid: map.getView().getProjection().getCode().split(":")[1],
                    deplacement: false,
                    readOnly: true,
                    onSubmit: ()=>{
                        handleClosePermisReadOnly();
                        overlay?.setPosition(undefined);
                    }
                })
            })
        ]
    });
};
const $b0759c348c3ed98d$export$b8624bc36b7db2ab = ({ map: map })=>{
    const ref = (0, $kc00y.useRef)(null);
    const { featureSelect: featureSelect, overlay: overlay } = $b0759c348c3ed98d$var$useTooltipMap({
        ref: ref,
        map: map
    });
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
        ref: ref,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($b0759c348c3ed98d$var$Tooltip, {
            featureSelect: featureSelect,
            overlay: overlay,
            displayButtonEdit: false,
            displayButtonDelete: false,
            displayButtonSee: false
        })
    });
};
/**
 * Permet d'observer quel point est cliqué par l'utilisateur
 */ /**
 * useTooltipMap : hook générique pour détecter le clic sur un feature et afficher une tooltip.
 * @param ref - ref du conteneur React
 * @param map - instance OpenLayers Map
 * @param filterFeature - fonction optionnelle pour filtrer le feature à tooltipper
 * @param disabled - désactive le tooltip
 * @returns { featureSelect, overlay }
 */ const $b0759c348c3ed98d$var$useTooltipMap = ({ ref: ref, map: map, filterFeature: filterFeature, disabled: disabled = false })=>{
    const [featureSelect, setFeatureSelect] = (0, $kc00y.useState)(null);
    const [overlay, setOverlay] = (0, $kc00y.useState)(new (0, $bedb0af9b4c870c1$export$2e2bcd8739ae039)({
        positioning: "bottom-center",
        stopEvent: true
    }));
    (0, $kc00y.useEffect)(()=>{
        if (map && ref.current != null && !disabled) {
            // Change le curseur au survol des éléments interactifs
            map.on("pointermove", (event)=>{
                const pixel = map.getEventPixel(event.originalEvent);
                const currentZoom = map.getView().getZoom() || 0;
                let hasInteractiveFeature = false;
                map.forEachFeatureAtPixel(pixel, function(feature) {
                    if (!filterFeature || filterFeature(feature)) {
                        hasInteractiveFeature = true;
                        return true;
                    }
                    return false;
                }, {
                    hitTolerance: 15
                });
                map.getTargetElement().style.cursor = hasInteractiveFeature && currentZoom >= (0, $f740b0d032822ba6$export$43e6e1d03cd3f2e7) ? "pointer" : "";
            });
            map.on("singleclick", (event)=>{
                const pixel = map.getEventPixel(event.originalEvent);
                let found = false;
                map.forEachFeatureAtPixel(pixel, function(feature) {
                    if (!filterFeature || filterFeature(feature)) {
                        setFeatureSelect(feature);
                        found = true;
                        // Crée et positionne l'overlay
                        const coordinate = event.coordinate;
                        const over = new (0, $bedb0af9b4c870c1$export$2e2bcd8739ae039)({
                            element: ref.current,
                            positioning: "bottom-center",
                            position: coordinate,
                            autoPan: {
                                animation: {
                                    duration: 250
                                }
                            }
                        });
                        map.addOverlay(over);
                        setOverlay(over);
                        return true; // stop
                    }
                    return false; // continue cherche une autre feature
                }, {
                    hitTolerance: 15
                });
                if (!found) setFeatureSelect(null);
            });
        }
    }, [
        map,
        ref,
        disabled,
        filterFeature
    ]);
    return {
        featureSelect: featureSelect,
        overlay: overlay
    };
};
const $b0759c348c3ed98d$export$d948e7b8d50e3806 = ({ map: map, displayButtonSeeFichePei: displayButtonSeeFichePei })=>{
    const { user: user } = (0, $e787cde576104469$export$fdc397e486fa83e7)();
    const ref = (0, $kc00y.useRef)(null);
    const { featureSelect: featureSelect, overlay: overlay } = $b0759c348c3ed98d$var$useTooltipMap({
        ref: ref,
        map: map
    });
    const { visible: visible, show: show, close: close } = (0, $ca8671088139af49$export$2e2bcd8739ae039)();
    const [showFichePei, setShowFichePei] = (0, $kc00y.useState)(false);
    const handleCloseFichePei = ()=>setShowFichePei(false);
    const elementId = featureSelect?.getProperties().elementId;
    const RisquesExpressData = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/risque/get`)?.data;
    if (!RisquesExpressData) return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $c21b1c237cfa1d94$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
        ref: ref,
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($b0759c348c3ed98d$var$Tooltip, {
                disabled: false,
                featureSelect: featureSelect,
                overlay: overlay,
                displayButtonEdit: false,
                disabledEdit: true,
                displayButtonDelete: false,
                disabledDelete: true,
                displayButtonSee: displayButtonSeeFichePei,
                onClickSee: ()=>setShowFichePei(true),
                labelSee: "Voir la fiche R\xe9sum\xe9 du PEI"
            }),
            user != null && (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).RISQUE_EXPRESS_A) ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                        tooltipId: "risques-express-purge",
                        tooltipText: "Purger la couche des risques express",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                            variant: "primary",
                            className: "m-2",
                            onClick: ()=>{
                                show();
                            },
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$e04bcc6127e699bf), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $791e7ee3b0d1ae7e$export$2e2bcd8739ae039), {
                        visible: visible,
                        onCancel: close,
                        onSuccess: close,
                        onError: close,
                        query: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/risque/delete/`,
                        ref: ref,
                        header: "Risque",
                        content: `Confirmez-vous la purge des risques express ? Liste des risques express enregistr\xe9s : ${RisquesExpressData?.map((item)=>item.risqueExpressLibelle).join(", ") || "(aucun risque express trouv\xe9)"}`,
                        onDelete: ()=>null,
                        successLibelle: "Tous les risques express ont \xe9t\xe9 supprim\xe9s."
                    })
                ]
            }) : "",
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1eee265537f042a4$export$2e2bcd8739ae039), {
                handleClose: handleCloseFichePei,
                show: showFichePei,
                className: "w-auto",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $4c401fa322fe4af6$export$2e2bcd8739ae039), {
                    peiId: elementId,
                    peiNumeroComplet: featureSelect?.getProperties().peiNumeroComplet,
                    titre: "Fiche R\xe9sum\xe9 du PEI " + featureSelect?.getProperties().peiNumeroComplet
                })
            })
        ]
    });
};
const $b0759c348c3ed98d$export$d0a60140f443ee5c = ({ map: map, dataDfciAireLayer: dataDfciAireLayer, dataDfciPisteLayer: dataDfciPisteLayer, dataDfciDebLayer: dataDfciDebLayer, dataDfciPanneauLayer: dataDfciPanneauLayer })=>{
    const ref = (0, $kc00y.useRef)(null);
    const { featureSelect: featureSelect, overlay: overlay } = $b0759c348c3ed98d$var$useTooltipMap({
        ref: ref,
        map: map
    });
    const [showVoletInfo, setShowVoletInfo] = (0, $kc00y.useState)(false);
    const typeElem = featureSelect?.getProperties().dfciTypeElement;
    const elementId = featureSelect?.getProperties().elementId;
    const [readOnlyForm, setReadOnlyForm] = (0, $kc00y.useState)(true);
    const { user: user } = (0, $e787cde576104469$export$fdc397e486fa83e7)();
    function hasDroitUpdateElem() {
        switch(typeElem){
            case (0, $f32c9305c9576eaf$export$4fa1916ee9d33028).AIRE:
                return (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).DFCI_AIRE_U);
            case (0, $f32c9305c9576eaf$export$4fa1916ee9d33028).PISTE:
                return (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).DFCI_PISTE_U);
            case (0, $f32c9305c9576eaf$export$4fa1916ee9d33028).DEBROUSSAILLEMENT:
                return (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).DFCI_DEB_U);
            case (0, $f32c9305c9576eaf$export$4fa1916ee9d33028).PANNEAU:
                return (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).DFCI_PANNEAU_U);
        }
    }
    const elementHasConflit = featureSelect?.getProperties().hasConflit;
    const hasDroitResolveConflit = (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).DFCI_GESTION_CONFLITS_A) && elementHasConflit;
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
        ref: ref,
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($b0759c348c3ed98d$var$Tooltip, {
                featureSelect: featureSelect,
                overlay: overlay,
                displayButtonDelete: false,
                displayButtonEdit: hasDroitUpdateElem(),
                displayButtonSee: true,
                disabledEdit: !hasDroitUpdateElem(),
                onClickSee: ()=>{
                    setShowVoletInfo(true), setReadOnlyForm(true);
                },
                onClickEdit: ()=>{
                    setShowVoletInfo(true), setReadOnlyForm(false);
                },
                autreActionBouton: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
                    children: hasDroitResolveConflit && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        className: "p-1",
                        xs: "auto",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                            tooltipText: "R\xe9soudre le conflit",
                            tooltipId: "resolveDfciConflit",
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $43f579690a1c166d$export$2e2bcd8739ae039), {
                                pathname: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).DFCI_GESTION_CONFLITS,
                                variant: "danger",
                                search: new URLSearchParams({
                                    filterBy: JSON.stringify({
                                        dfciConflitElementId: elementId
                                    })
                                }).toString(),
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$81608868aefa31ce), {})
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1eee265537f042a4$export$2e2bcd8739ae039), {
                handleClose: ()=>setShowVoletInfo(false),
                show: showVoletInfo,
                className: "w-auto",
                children: [
                    elementHasConflit && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("p", {
                        className: "fade alert alert-danger show text-center",
                        children: "Un conflit est en cours sur cet \xe9l\xe9ment, veuillez le corriger."
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $45418e7136067e6b$export$2e2bcd8739ae039), {
                        typeElem: typeElem,
                        elementId: elementId,
                        readOnly: readOnlyForm || elementHasConflit,
                        onSubmit: ()=>{
                            setShowVoletInfo(false);
                            switch(typeElem){
                                case (0, $f32c9305c9576eaf$export$4fa1916ee9d33028).AIRE:
                                    dataDfciAireLayer?.getSource()?.refresh();
                                    break;
                                case (0, $f32c9305c9576eaf$export$4fa1916ee9d33028).PISTE:
                                    dataDfciPisteLayer?.getSource()?.refresh();
                                    break;
                                case (0, $f32c9305c9576eaf$export$4fa1916ee9d33028).DEBROUSSAILLEMENT:
                                    dataDfciDebLayer?.getSource()?.refresh();
                                    break;
                                case (0, $f32c9305c9576eaf$export$4fa1916ee9d33028).PANNEAU:
                                    dataDfciPanneauLayer?.getSource()?.refresh();
                                    break;
                            }
                        }
                    })
                ]
            })
        ]
    });
};


const $0193c5b6c7789889$var$MapToolbarDFCI = ({ map: map, dataDfciAireLayer: dataDfciAireLayer, dataDfciPisteLayer: dataDfciPisteLayer, dataDfciDebLayer: dataDfciDebLayer, dataDfciPanneauLayer: dataDfciPanneauLayer })=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $a43e6f68e14bab96$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1ac4483a0721609f$export$2e2bcd8739ae039), {
                    codeThematique: (0, $690fed8fd87ee1b4$export$2e2bcd8739ae039).DFCI,
                    titreVolet: "Liste des documents DFCI"
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b0759c348c3ed98d$export$d0a60140f443ee5c), {
                map: map,
                dataDfciAireLayer: dataDfciAireLayer,
                dataDfciPisteLayer: dataDfciPisteLayer,
                dataDfciDebLayer: dataDfciDebLayer,
                dataDfciPanneauLayer: dataDfciPanneauLayer
            })
        ]
    });
};
$0193c5b6c7789889$var$MapToolbarDFCI.displayName = "MapToolbarDFCI";
var $0193c5b6c7789889$export$2e2bcd8739ae039 = $0193c5b6c7789889$var$MapToolbarDFCI;


const $8be8331dcad9d257$var$AtlasManagment = ()=>{
    const { success: successToast, error: errorToast } = (0, $6bdae0bad7b05751$export$91b3d218c74c79e4)();
    const { data: hasElements = false } = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)("/api/atlas/has-element", {});
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
        children: hasElements && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
            tooltipText: "T\xe9l\xe9charger l'atlas en PDF",
            tooltipId: "afficher-docs-dfci",
            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                variant: "outline-primary",
                onClick: ()=>(0, $c066b242635c27a6$export$9cca65ea339c61b4)(`/api/atlas/download-atlas`, null, `atlas.zip`, "T\xe9l\xe9chargement termin\xe9", successToast, errorToast),
                className: "rounded m-2",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$4a5ccdc9878f4668), {})
            })
        })
    });
};
const $8be8331dcad9d257$var$MapDFCI = ()=>{
    const { user: user } = (0, $e787cde576104469$export$fdc397e486fa83e7)();
    const mapElement = (0, $kc00y.useRef)();
    const { map: map, workingLayer: workingLayer, availableLayers: availableLayers, addOrRemoveLayer: addOrRemoveLayer, layerListRef: layerListRef, showOutilI: showOutilI, mapToolbarRef: mapToolbarRef, projection: projection } = (0, $cdcdd8e1ff041f79$export$547f9c492d831282)({
        mapElement: mapElement,
        typeModule: (0, $a9754922f4c67d47$export$ef88b514e4bfff34).DFCI,
        displayPei: false
    });
    const parametreCouche = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/parametres?${{
        listeParametreCode: JSON.stringify([
            (0, $ee297f06e8568bf4$export$2e2bcd8739ae039).DFCI_LISTE_COUCHE
        ])
    }}`);
    const listeCouche = (0, $kc00y.useMemo)(()=>{
        if (!parametreCouche.isResolved || parametreCouche?.data[(0, $ee297f06e8568bf4$export$2e2bcd8739ae039).DFCI_LISTE_COUCHE].parametreValeur == null) return [];
        return JSON.parse(parametreCouche?.data[(0, $ee297f06e8568bf4$export$2e2bcd8739ae039).DFCI_LISTE_COUCHE].parametreValeur);
    }, [
        parametreCouche
    ]) ?? [];
    const dataDfciAireLayer = (0, $kc00y.useMemo)(()=>{
        if (!map || !listeCouche.includes((0, $5d863552eb3c939f$export$397a4e925c2f682d).DFCI_AIRE)) return;
        return (0, $1ed1be1197ad1bc4$export$a3178456480ccf5b)(map, (extent, projection)=>`/api/dfci-aires/layer?bbox=` + extent.join(",") + "&srid=" + projection.getCode(), projection);
    }, [
        map,
        projection,
        listeCouche
    ]);
    const dataDfciPisteLayer = (0, $kc00y.useMemo)(()=>{
        if (!map || !listeCouche.includes((0, $5d863552eb3c939f$export$397a4e925c2f682d).DFCI_PISTE)) return;
        return (0, $1ed1be1197ad1bc4$export$a3178456480ccf5b)(map, (extent, projection)=>`/api/dfci-pistes/layer?bbox=` + extent.join(",") + "&srid=" + projection.getCode(), projection);
    }, [
        map,
        projection,
        listeCouche
    ]);
    const dataDfciDebLayer = (0, $kc00y.useMemo)(()=>{
        if (!map || !listeCouche.includes((0, $5d863552eb3c939f$export$397a4e925c2f682d).DFCI_DEB)) return;
        return (0, $1ed1be1197ad1bc4$export$a3178456480ccf5b)(map, (extent, projection)=>`/api/dfci-deb/layer?bbox=` + extent.join(",") + "&srid=" + projection.getCode(), projection);
    }, [
        map,
        projection,
        listeCouche
    ]);
    const dataDfciPanneauLayer = (0, $kc00y.useMemo)(()=>{
        if (!map || !listeCouche.includes((0, $5d863552eb3c939f$export$397a4e925c2f682d).DFCI_PANNEAU)) return;
        return (0, $1ed1be1197ad1bc4$export$a3178456480ccf5b)(map, (extent, projection)=>`/api/dfci-panneau/layer?bbox=` + extent.join(",") + "&srid=" + projection.getCode(), projection);
    }, [
        map,
        projection,
        listeCouche
    ]);
    const { toggleTool: toggleTool, activeTool: activeTool, infoOutilI: infoOutilI, handleCloseInfoI: handleCloseInfoI } = (0, $e2b798e23180fa76$export$194c7727cbdc0cac)({
        availableLayers: availableLayers,
        map: map,
        workingLayer: workingLayer,
        extraTools: {}
    });
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                title: "D\xe9fense de la For\xeat Contre les Incendies",
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$f80e384965135114), {}),
                right: ((0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).DFCI_EXPORTATLAS_C) || (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ATLAS_A)) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($8be8331dcad9d257$var$AtlasManagment, {})
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $cdcdd8e1ff041f79$export$2e2bcd8739ae039), {
                map: map,
                outilI: infoOutilI,
                showOutilI: showOutilI,
                handleCloseInfoI: handleCloseInfoI,
                availableLayers: availableLayers,
                addOrRemoveLayer: addOrRemoveLayer,
                layerListRef: layerListRef,
                mapToolbarRef: mapToolbarRef,
                mapElement: mapElement,
                toggleTool: toggleTool,
                activeTool: activeTool,
                toolbarElement: mapToolbarRef.current && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $0193c5b6c7789889$export$2e2bcd8739ae039), {
                    map: map,
                    dataDfciAireLayer: dataDfciAireLayer,
                    dataDfciPisteLayer: dataDfciPisteLayer,
                    dataDfciDebLayer: dataDfciDebLayer,
                    dataDfciPanneauLayer: dataDfciPanneauLayer
                })
            })
        ]
    });
};
var $8be8331dcad9d257$export$2e2bcd8739ae039 = $8be8331dcad9d257$var$MapDFCI;






var $kc00y = parcelRequire("kc00y");









var $bkJfK = parcelRequire("bkJfK");

var $kc00y = parcelRequire("kc00y");




















/**
 * Enumération définissant les types de nature DECI
 */ var $e2b283d869a75a62$var$TYPE_NATURE_DECI = /*#__PURE__*/ function(TYPE_NATURE_DECI) {
    TYPE_NATURE_DECI["PRIVE"] = "PRIVE";
    TYPE_NATURE_DECI["PUBLIC"] = "PUBLIC";
    TYPE_NATURE_DECI["CONVENTIONNE"] = "CONVENTIONNE";
    TYPE_NATURE_DECI["ICPE"] = "ICPE";
    TYPE_NATURE_DECI["ICPE_CONVENTIONNE"] = "ICPE_CONVENTIONNE";
    return TYPE_NATURE_DECI;
}($e2b283d869a75a62$var$TYPE_NATURE_DECI || {});
var $e2b283d869a75a62$export$2e2bcd8739ae039 = $e2b283d869a75a62$var$TYPE_NATURE_DECI;







const $e55b099050255859$export$a5cab80145b70e98 = (data)=>({
        peiId: data?.peiId ?? null,
        peiNumeroComplet: data?.peiNumeroComplet ?? null,
        peiNumeroInterne: data?.peiNumeroInterne ?? null,
        peiTypePei: data?.peiTypePei ?? null,
        peiDisponibiliteTerrestre: data?.peiDisponibiliteTerrestre ?? null,
        peiAnneeFabrication: data?.peiAnneeFabrication ?? null,
        peiObservation: data?.peiObservation ?? null,
        coordonneeX: data?.coordonneeX ?? null,
        coordonneeY: data?.coordonneeY ?? null,
        srid: data?.srid ?? null,
        typeSystemeSrid: (0, $e2315562ed43d638$export$2e2bcd8739ae039).find((e)=>e.srid === data?.srid)?.srid ?? (0, $e2315562ed43d638$export$2e2bcd8739ae039)[0].srid,
        coordonneeXToDisplay: data?.coordonneeX ?? null,
        coordonneeYToDisplay: data?.coordonneeY ?? null,
        peiAutoriteDeciId: data?.peiAutoriteDeciId ?? null,
        peiServicePublicDeciId: data?.peiServicePublicDeciId ?? null,
        peiMaintenanceDeciId: data?.peiMaintenanceDeciId ?? null,
        peiCommuneId: data?.peiCommuneId ?? null,
        peiVoieId: data?.peiVoieId ?? null,
        peiVoieTexte: data?.peiVoieTexte ?? null,
        peiNumeroVoie: data?.peiNumeroVoie ?? null,
        peiSuffixeVoie: data?.peiSuffixeVoie ?? null,
        peiLieuDitId: data?.peiLieuDitId ?? null,
        peiCroisementId: data?.peiCroisementId ?? null,
        peiComplementAdresse: data?.peiComplementAdresse ?? null,
        peiEnFace: data?.peiEnFace ?? null,
        peiDomaineId: data?.peiDomaineId ?? null,
        peiNatureId: data?.peiNatureId ?? null,
        peiSiteId: data?.peiSiteId ?? null,
        peiGestionnaireId: data?.peiGestionnaireId ?? null,
        peiNatureDeciId: data?.peiNatureDeciId ?? null,
        peiNiveauId: data?.peiNiveauId ?? null,
        peiZoneSpecialeId: data?.peiZoneSpecialeId ?? null,
        peiDateChangementDispo: data?.peiDateChangementDispo ?? null,
        peiPerenne: data?.peiPerenne ?? false,
        peiRotation_6Ccf: data?.peiRotation_6Ccf ?? false,
        // DONNEES PIBI
        pibiDiametreId: data?.pibiDiametreId ?? null,
        pibiServiceEauId: data?.pibiServiceEauId ?? null,
        pibiIdentifiantGestionnaire: data?.pibiIdentifiantGestionnaire ?? null,
        pibiRenversable: data?.pibiRenversable ?? null,
        pibiDispositifInviolabilite: data?.pibiDispositifInviolabilite ?? null,
        pibiModeleId: data?.pibiModeleId ?? null,
        pibiMarqueId: data?.pibiMarqueId ?? null,
        pibiReservoirId: data?.pibiReservoirId ?? null,
        pibiDebitRenforce: data?.pibiDebitRenforce ?? null,
        pibiTypeCanalisationId: data?.pibiTypeCanalisationId ?? null,
        pibiTypeReseauId: data?.pibiTypeReseauId ?? null,
        pibiDiametreCanalisation: data?.pibiDiametreCanalisation ?? null,
        pibiSurpresse: data?.pibiSurpresse ?? null,
        pibiAdditive: data?.pibiAdditive ?? null,
        pibiJumeleId: data?.pibiJumeleId ?? null,
        // DONNEES PENA
        penaCapacite: data?.penaCapacite ?? null,
        penaCapaciteIllimitee: data?.penaCapaciteIllimitee ?? null,
        penaCapaciteIncertaine: data?.penaCapaciteIncertaine ?? null,
        penaMateriauId: data?.penaMateriauId ?? null,
        penaQuantiteAppoint: data?.penaQuantiteAppoint ?? null,
        penaDisponibiliteHbe: data?.penaDisponibiliteHbe ?? null,
        penaEquipeHbe: data?.penaEquipeHbe ?? false,
        typeEnginIds: data?.typeEnginIds ?? [],
        documents: data?.documents ?? [],
        voieSaisieLibre: data?.peiVoieTexte != null && data?.peiVoieTexte?.trim() !== ""
    });
const $e55b099050255859$export$c084437b5e3206cd = (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({
    peiAutoriteDeciId: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
    peiServicePublicDeciId: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
    peiNatureId: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
    peiNatureDeciId: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
    peiCommuneId: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
    peiDomaineId: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
    coordonneeX: (0, $36ceaed6faf947af$export$d73626444d3ce57a),
    coordonneeY: (0, $36ceaed6faf947af$export$d73626444d3ce57a)
}).test("voie-xor", "", function(values) {
    const { voieSaisieLibre: voieSaisieLibre, peiVoieId: peiVoieId, peiVoieTexte: peiVoieTexte } = values;
    if (voieSaisieLibre) return peiVoieTexte != null && peiVoieTexte.trim() !== "";
    return peiVoieId != null;
});
const $e55b099050255859$export$f97400759cfd946 = (values, data)=>{
    const formData = new FormData();
    (0, $69d686b1e97c5ea6$export$3f0f08502708410b)(values?.documents, data?.documents, formData);
    formData.append("peiTypePei", values.peiTypePei);
    const dataPei = {
        peiId: data?.peiId,
        peiNumeroComplet: values.peiNumeroComplet ?? null,
        peiNumeroInterne: values.peiNumeroInterne ?? null,
        peiTypePei: values.peiTypePei,
        peiDisponibiliteTerrestre: data?.peiDisponibiliteTerrestre ?? (0, $f808952c311684ce$export$2e2bcd8739ae039).INDISPONIBLE.toUpperCase(),
        peiAnneeFabrication: values?.peiAnneeFabrication ?? null,
        peiGeometrie: "SRID=" + values.srid + ";POINT(" + values.coordonneeX + " " + values.coordonneeY + ")",
        peiAutoriteDeciId: values.peiAutoriteDeciId ?? null,
        peiServicePublicDeciId: values.peiServicePublicDeciId ?? null,
        peiMaintenanceDeciId: values.peiMaintenanceDeciId ?? null,
        peiObservation: values.peiObservation ?? null,
        peiCommuneId: values.peiCommuneId ?? null,
        peiVoieId: values.peiVoieId ?? null,
        peiVoieTexte: values.peiVoieTexte != null && values.peiVoieTexte?.trim() !== "" ? values.peiVoieTexte : null,
        peiNumeroVoie: values.peiNumeroVoie ?? null,
        peiSuffixeVoie: values.peiSuffixeVoie ?? null,
        peiLieuDitId: values.peiLieuDitId ?? null,
        peiCroisementId: values.peiCroisementId ?? null,
        peiComplementAdresse: values.peiComplementAdresse ?? null,
        peiEnFace: values.peiEnFace ?? null,
        peiDomaineId: values.peiDomaineId ?? null,
        peiNatureId: values.peiNatureId ?? null,
        peiNatureDeciId: values.peiNatureDeciId ?? null,
        peiSiteId: values.peiSiteId ?? null,
        peiGestionnaireId: values.peiGestionnaireId ?? null,
        peiNiveauId: values.peiNiveauId ?? null,
        peiDateChangementDispo: values?.peiDateChangementDispo ?? null,
        peiPerenne: values.peiPerenne,
        peiRotation_6Ccf: values.peiRotation_6Ccf,
        coordonneeX: values?.coordonneeX ?? null,
        coordonneeY: values?.coordonneeY ?? null,
        // DONNEES INITIALES
        peiNumeroInterneInitial: data?.peiNumeroInterne ?? null,
        peiCommuneIdInitial: data?.peiCommuneId ?? null,
        peiZoneSpecialeIdInitial: data?.peiZoneSpecialeId ?? null,
        peiNatureDeciIdInitial: data?.peiNatureDeciId ?? null,
        peiNatureIdInitial: data?.peiNatureId ?? null,
        peiDomaineIdInitial: data?.peiDomaineId ?? null,
        peiGestionnaireIdInitial: data?.peiGestionnaireId ?? null,
        peiDisponibiliteTerrestreInitiale: data?.peiDisponibiliteTerrestre ?? null,
        pibiIdentifiantGestionnaireInitial: data?.pibiIdentifiantGestionnaire ?? null
    };
    formData.append("peiData", JSON.stringify(values.peiTypePei === (0, $f31f748b1c9fd0fb$export$2e2bcd8739ae039).PIBI ? {
        ...dataPei,
        // DONNEES PIBI
        pibiDiametreId: values.pibiDiametreId ?? null,
        pibiServiceEauId: values.pibiServiceEauId ?? null,
        pibiIdentifiantGestionnaire: values.pibiIdentifiantGestionnaire ?? null,
        pibiRenversable: values.pibiRenversable ?? null,
        pibiDispositifInviolabilite: values.pibiDispositifInviolabilite ?? null,
        pibiModeleId: values.pibiModeleId ?? null,
        pibiMarqueId: values.pibiMarqueId ?? null,
        pibiReservoirId: values.pibiReservoirId ?? null,
        pibiDebitRenforce: values.pibiDebitRenforce ?? null,
        pibiTypeCanalisationId: values.pibiTypeCanalisationId ?? null,
        pibiTypeReseauId: values.pibiTypeReseauId ?? null,
        pibiDiametreCanalisation: values.pibiDiametreCanalisation ?? null,
        pibiSurpresse: values.pibiSurpresse ?? null,
        pibiAdditive: values.pibiAdditive ?? null,
        pibiJumeleId: values.pibiJumeleId ?? null
    } : {
        ...dataPei,
        // DONNEES PENA
        penaCapacite: values.penaCapacite ?? null,
        penaCapaciteIllimitee: values.penaCapaciteIllimitee ?? null,
        penaCapaciteIncertaine: values.penaCapaciteIncertaine ?? null,
        penaMateriauId: values.penaMateriauId ?? null,
        penaQuantiteAppoint: values.penaQuantiteAppoint ?? null,
        penaDisponibiliteHbe: data?.penaDisponibiliteHbe ?? (0, $f808952c311684ce$export$2e2bcd8739ae039).INDISPONIBLE.toUpperCase(),
        penaEquipeHbe: values.penaEquipeHbe,
        typeEnginIds: values.typeEnginIds ?? []
    }));
    return formData;
};
const $e55b099050255859$var$Pei = ({ isNew: isNew = false, close: close, returnBouton: returnBouton = true, isFromMap: isFromMap = true })=>{
    // On récupère l'utilisateur pour prendre en compte les droits
    const { user: user, srid: srid } = (0, $e787cde576104469$export$fdc397e486fa83e7)();
    const { values: values, setValues: setValues, setFieldValue: setFieldValue } = (0, $bkJfK.useFormikContext)();
    const selectDataState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/pei/referentiel-for-upsert-pei?${{
        coordonneeX: values.coordonneeXToDisplay,
        coordonneeY: values.coordonneeYToDisplay,
        srid: values.typeSystemeSrid,
        peiId: values.peiId
    }}`);
    // Si les coordonnées changent, il faut recharger les coordonnées dans les différents systèmes
    const geometrieState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/pei/get-geometrie-by-srid?${{
        coordonneeX: values.coordonneeXToDisplay,
        coordonneeY: values.coordonneeYToDisplay,
        srid: values.typeSystemeSrid
    }}`);
    const parametreVoieSaisieLibre = (0, $ee297f06e8568bf4$export$2e2bcd8739ae039).VOIE_SAISIE_LIBRE;
    const parametrePeiDisplayIdentifiantGestionnaire = (0, $ee297f06e8568bf4$export$2e2bcd8739ae039).PEI_DISPLAY_IDENTIFIANT_GESTIONNAIRE;
    const parametrePeiDisplayTypeEngin = (0, $ee297f06e8568bf4$export$2e2bcd8739ae039).PEI_DISPLAY_TYPE_ENGIN;
    const parametrePeiRenumerotationInterneAuto = (0, $ee297f06e8568bf4$export$2e2bcd8739ae039).PEI_RENUMEROTATION_INTERNE_AUTO;
    const listeParametre = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/parametres?${{
        listeParametreCode: JSON.stringify([
            parametreVoieSaisieLibre,
            parametrePeiDisplayTypeEngin,
            parametrePeiDisplayIdentifiantGestionnaire,
            parametrePeiRenumerotationInterneAuto
        ])
    }}`);
    const isSaisieVoieEnabled = (0, $kc00y.useMemo)(()=>{
        if (!listeParametre.isResolved) return false;
        // Le résultat est une String, on le parse pour récupérer le tableau
        return JSON.parse(listeParametre?.data[parametreVoieSaisieLibre].parametreValeur);
    }, [
        listeParametre
    ]);
    const displayTypeEngin = (0, $kc00y.useMemo)(()=>{
        if (!listeParametre.isResolved) return false;
        // Le résultat est une String, on le parse pour récupérer le tableau
        return JSON.parse(listeParametre?.data[parametrePeiDisplayTypeEngin].parametreValeur);
    }, [
        listeParametre
    ]);
    const displayIdentifiantGestionnaire = (0, $kc00y.useMemo)(()=>{
        if (!listeParametre.isResolved) return false;
        // Le résultat est une String, on le parse pour récupérer le tableau
        return JSON.parse(listeParametre?.data[parametrePeiDisplayIdentifiantGestionnaire].parametreValeur);
    }, [
        listeParametre
    ]);
    const renumerotationInterneAuto = (0, $kc00y.useMemo)(()=>{
        if (!listeParametre.isResolved) return false;
        // Le résultat est une String, on le parse pour récupérer le tableau
        return JSON.parse(listeParametre?.data[parametrePeiRenumerotationInterneAuto].parametreValeur);
    }, [
        listeParametre
    ]);
    (0, $kc00y.useEffect)(()=>{
        if (values.coordonneeXToDisplay != null && values.coordonneeYToDisplay != null) {
            geometrieState?.run({
                coordonneeX: values.coordonneeXToDisplay,
                coordonneeY: values.coordonneeYToDisplay,
                srid: values.typeSystemeSrid
            });
            selectDataState?.run({
                geometry: "SRID=" + values.typeSystemeSrid + ";POINT(" + values.coordonneeXToDisplay + " " + values.coordonneeYToDisplay + ")",
                peiId: values.peiId
            });
        }
        const coordonnees = geometrieState?.data?.find((e)=>e.srid === srid);
        if (coordonnees != null) {
            setFieldValue("coordonneeX", coordonnees?.coordonneeX);
            setFieldValue("coordonneeY", coordonnees?.coordonneeY);
        }
        if (selectDataState?.data?.listCommune != null && selectDataState?.data?.listCommune?.length !== 0 && values.peiCommuneId == null) setFieldValue("peiCommuneId", values.peiCommuneId ?? selectDataState?.data?.listCommune[0].id);
    }, [
        setFieldValue,
        values.coordonneeXToDisplay,
        values.coordonneeYToDisplay,
        values.typeSystemeSrid,
        values.peiCommuneId,
        values.peiId,
        geometrieState,
        selectDataState,
        srid
    ]);
    const openedAccordions = [];
    if (!isNew) openedAccordions.push(false);
    openedAccordions.push(true, false, false, false);
    // Permet de savoir si les sections de l'accordion sont ouvertes et de les set
    const { handleShowClose: handleShowClose, activesKeys: activesKeys, show: show } = (0, $db860d90b4a42fea$export$dae930a4ba30758b)(openedAccordions);
    // Correspond à la liste des champs obligatoires avec leur index dans l'accordion
    // Cela nous permettra d'ouvrir une section si un champ obligatoire n'est pas saisi
    const index = isNew ? 0 : 1;
    const listValuesWithConstraints = [
        {
            name: "peiAutoriteDeciId",
            accordionIndex: index
        },
        {
            name: "peiServicePublicDeciId",
            accordionIndex: index
        },
        {
            name: "peiNatureId",
            accordionIndex: index
        },
        {
            name: "peiNatureDeciId",
            accordionIndex: index
        },
        {
            name: "peiCommuneId",
            accordionIndex: index + 1
        },
        {
            name: "voie-xor",
            constraint: values.voieSaisieLibre ? values.peiVoieTexte == null || values.peiVoieTexte.trim() === "" : values.peiVoieId == null || values.peiVoieId === "",
            accordionIndex: index + 1
        },
        {
            name: "peiDomaineId",
            accordionIndex: index + 1
        },
        {
            name: "pibiDiametreCanalisation",
            constraint: values.pibiDiametreCanalisation !== undefined && values.pibiDiametreCanalisation < 1,
            accordionIndex: index + 2
        }
    ];
    const { data: selectData } = selectDataState;
    const hasDroitCaracteristique = isNew || (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).PEI_CARACTERISTIQUES_U);
    const listAccordions = [];
    if (!isNew) listAccordions.push({
        header: "Fiche R\xe9sum\xe9",
        content: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $4c401fa322fe4af6$export$2e2bcd8739ae039), {
            peiId: values.peiId,
            peiNumeroComplet: values.peiNumeroComplet
        })
    });
    listAccordions.push({
        header: "Informations g\xe9n\xe9rales",
        content: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($e55b099050255859$var$FormEntetePei, {
            values: values,
            selectData: selectData,
            setValues: setValues,
            setFieldValue: setFieldValue,
            isNew: isNew,
            renumerotationInterneAuto: renumerotationInterneAuto,
            isFromMap: isFromMap,
            displayIdentifiantGestionnaire: displayIdentifiantGestionnaire,
            user: user
        })
    }, {
        header: "Localisation",
        content: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($e55b099050255859$var$FormLocalisationPei, {
            values: values,
            selectData: selectData,
            setValues: setValues,
            setFieldValue: setFieldValue,
            geometrieData: geometrieState?.data,
            srid: parseInt(srid),
            isSaisieVoieEnabled: isSaisieVoieEnabled,
            isNew: isNew,
            user: user
        })
    }, {
        header: "Caract\xe9ristiques techniques",
        content: values.peiTypePei === (0, $f31f748b1c9fd0fb$export$2e2bcd8739ae039).PIBI ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($e55b099050255859$var$FormPibi, {
            values: values,
            selectData: selectData,
            setFieldValue: setFieldValue,
            setValues: setValues,
            hasDroitCaracteristique: hasDroitCaracteristique
        }) : values.peiTypePei === (0, $f31f748b1c9fd0fb$export$2e2bcd8739ae039).PENA ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($e55b099050255859$var$FormPena, {
            values: values,
            setValues: setValues,
            setFieldValue: setFieldValue,
            hasDroitCaracteristique: hasDroitCaracteristique,
            displayTypeEngin: displayTypeEngin
        }) : /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
            children: "Veuillez renseigner le type de PEI"
        })
    }, {
        header: "Documents",
        content: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $69d686b1e97c5ea6$export$2e2bcd8739ae039), {
            documents: values.documents,
            multiple: true,
            setFieldValue: setFieldValue,
            defaultOtherProperties: {
                isPhotoPei: false
            },
            otherFormParam: (index, listeElements)=>{
                // Si c'est une image
                const isImage = [
                    "png",
                    "svg",
                    "jpeg",
                    "jpg",
                    "bmp",
                    "webp",
                    "gif"
                ].includes(listeElements[index].documentNomFichier.split(".").at(-1));
                if (!isImage) return null;
                const hasChecked = listeElements.some((doc)=>doc.isPhotoPei);
                const isCurrentChecked = listeElements[index].isPhotoPei;
                const isDisabledByPhotoSelected = hasChecked && !isCurrentChecked;
                const disabledCheckbox = !(0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).PEI_U) || isDisabledByPhotoSelected;
                const tooltipText = isDisabledByPhotoSelected ? "Une photo est d\xe9j\xe0 s\xe9lectionn\xe9e. D\xe9cochez-la pour en choisir une autre." : undefined;
                return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                    name: `documents[${index}].isPhotoPei`,
                    label: "Est la photo du PEI",
                    disabled: disabledCheckbox,
                    tooltipText: tooltipText
                });
            },
            disabled: !isNew && !(0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).PEI_U)
        })
    });
    // Affichage du titre et de l'icône en fonction du contexte et des droits
    let titre = "";
    let icon;
    let showFormButtons = true;
    if (isNew) {
        titre = "Cr\xe9ation d'un PEI";
        icon = /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$d776d19dfae66ece), {});
    } else if ((0, $e3b8d60f4bb99483$export$4f612ab7b7b1d133)(user, [
        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).PEI_U,
        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).PEI_CARACTERISTIQUES_U,
        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).PEI_DEPLACEMENT_U,
        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).PEI_NUMERO_INTERNE_U,
        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).PEI_ADRESSE_C
    ])) {
        // Autorisé à une modification au moins partielle
        titre = "Modification du " + values.peiTypePei + " n\xb0" + values.peiNumeroComplet;
        icon = /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$b51dd496211ae105), {});
    } else {
        // Seul cas possible : lecture seule
        titre = "Visualisation du " + values.peiTypePei + " n\xb0" + values.peiNumeroComplet;
        icon = /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$50a7b2527c056255), {});
        showFormButtons = false;
    }
    return selectData && srid != null && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                    icon: icon,
                    title: titre,
                    displayReturnButton: returnBouton,
                    right: !returnBouton && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                        variant: "danger",
                        className: "text-white",
                        onClick: close,
                        children: "Fermer"
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db860d90b4a42fea$export$2e2bcd8739ae039), {
                    activesKeys: activesKeys,
                    handleShowClose: handleShowClose,
                    list: listAccordions
                }),
                showFormButtons && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db9b0e6fdb142a4c$export$2e2bcd8739ae039), {
                    returnLink: returnBouton,
                    onClick: ()=>{
                        const coordonnees = geometrieState.data?.find((e)=>e.srid === parseInt(srid));
                        setFieldValue("coordonneeX", coordonnees.coordonneeX);
                        setFieldValue("coordonneeY", coordonnees.coordonneeY);
                        setFieldValue("srid", srid);
                        $e55b099050255859$var$checkValidity(values, show, listValuesWithConstraints);
                    }
                })
            ]
        })
    });
};
function $e55b099050255859$var$checkValidity(values, show, listValuesWithConstraints) {
    const schemaFieldNames = new Set(Object.keys($e55b099050255859$export$c084437b5e3206cd.fields));
    const isFormField = (fieldName)=>fieldName in values;
    for (const e of listValuesWithConstraints){
        const hasFieldValidationError = schemaFieldNames.has(e.name) && isFormField(e.name) && (values[e.name] === null || values[e.name] === "" || values[e.name] === undefined);
        const hasConstraintError = e.constraint === true;
        if (hasFieldValidationError || hasConstraintError) {
            show(e.accordionIndex);
            break;
        }
    }
}
var $e55b099050255859$export$2e2bcd8739ae039 = $e55b099050255859$var$Pei;
const $e55b099050255859$var$FormEntetePei = ({ values: values, selectData: selectData, setValues: setValues, setFieldValue: setFieldValue, isNew: isNew, renumerotationInterneAuto: renumerotationInterneAuto, isFromMap: isFromMap, displayIdentifiantGestionnaire: displayIdentifiantGestionnaire = false, user: user })=>{
    const { data: listNatureDeci } = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/nomenclatures/list/` + (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).NATURE_DECI);
    const { data: listNaturesWithDfci } = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/nature/get-libelle-nature`);
    const codeNatureDeci = listNatureDeci && listNatureDeci.find((e)=>e.id === values.peiNatureDeciId)?.code;
    const idGestionnaire = values.peiSiteId ? selectData.listSite.find((e)=>e.id === values.peiSiteId)?.gestionnaireId : null;
    const listTypePei = Object.values((0, $f31f748b1c9fd0fb$export$2e2bcd8739ae039)).map((e)=>{
        return {
            id: e.toString(),
            code: e.toString(),
            libelle: e.toString()
        };
    });
    // Condition générale d'update du PEI : l'utilisateur doit posséder le droit PEI_U
    const disablePeiUpdate = !isNew && !(0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).PEI_U);
    // Vérifier si la nature sélectionnée participe au DFCI
    const natureParticipeDfci = listNaturesWithDfci?.find((e)=>e.natureId === values.peiNatureId)?.natureParticipeDfci ?? false;
    return listNatureDeci && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                className: "align-items-end",
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        xs: 12,
                        sm: isFromMap ? 12 : 5,
                        lg: isFromMap ? 12 : 2,
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$2e2bcd8739ae039), {
                            name: "peiNumeroInterne",
                            label: "Num\xe9ro interne",
                            required: false,
                            disabled: renumerotationInterneAuto || !isNew && !(0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).PEI_NUMERO_INTERNE_U)
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        xs: 12,
                        lg: isFromMap ? 6 : 5,
                        className: isFromMap ? "mt-3 mt-lg-0" : "",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                            name: "peiTypePei",
                            listIdCodeLibelle: listTypePei,
                            label: "Type de PEI",
                            defaultValue: listTypePei?.find((e)=>e.code === values.peiTypePei),
                            required: true,
                            disabled: !isNew,
                            setValues: setValues,
                            setOtherValues: ()=>{
                                setFieldValue("peiNatureId", null);
                                setFieldValue("pibiDiametreId", null);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        xs: 12,
                        lg: isFromMap ? 6 : 5,
                        className: isFromMap ? "mt-3 mt-lg-0" : "",
                        children: values.peiTypePei && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $f89cdb798dc1325f$export$2e2bcd8739ae039), {
                            name: "peiNatureId",
                            nomenclature: values.peiTypePei === (0, $f31f748b1c9fd0fb$export$2e2bcd8739ae039).PIBI ? (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).NATURE_PIBI : values.peiTypePei === (0, $f31f748b1c9fd0fb$export$2e2bcd8739ae039).PENA ? (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).NATURE_PENA : (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).NATURE,
                            label: "Nature du PEI",
                            valueId: values.peiNatureId,
                            required: true,
                            setValues: setValues,
                            setOtherValues: ()=>{
                                setFieldValue("pibiDiametreId", null);
                            },
                            disabled: disablePeiUpdate
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                className: "mt-3 align-items-end",
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                            name: "peiAutoriteDeciId",
                            listIdCodeLibelle: selectData.listAutoriteDeci,
                            label: "Autorit\xe9 de police DECI",
                            defaultValue: selectData.listAutoriteDeci?.find((e)=>e.id === values.peiAutoriteDeciId),
                            required: true,
                            setValues: setValues,
                            disabled: disablePeiUpdate
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                            name: "peiServicePublicDeciId",
                            listIdCodeLibelle: selectData.listServicePublicDeci,
                            label: "Service Public DECI",
                            defaultValue: selectData.listServicePublicDeci?.find((e)=>e.id === values.peiServicePublicDeciId),
                            required: true,
                            setValues: setValues,
                            disabled: disablePeiUpdate
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                            name: "peiMaintenanceDeciId",
                            listIdCodeLibelle: selectData.listMaintenanceDeci,
                            label: "Maintenance et CTP",
                            defaultValue: selectData.listMaintenanceDeci?.find((e)=>e.id === values.peiMaintenanceDeciId),
                            required: false,
                            setValues: setValues,
                            disabled: disablePeiUpdate
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                className: "mt-3 align-items-end",
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                            name: "peiNatureDeciId",
                            label: "Nature DECI",
                            listIdCodeLibelle: listNatureDeci,
                            defaultValue: listNatureDeci?.find((e)=>e.id === values.peiNatureDeciId),
                            required: true,
                            setOtherValues: ()=>{
                                setFieldValue("peiGestionnaireId", null);
                                setFieldValue("peiSiteId", null);
                            },
                            setValues: setValues,
                            disabled: disablePeiUpdate
                        })
                    }),
                    (codeNatureDeci === (0, $e2b283d869a75a62$export$2e2bcd8739ae039).PRIVE || codeNatureDeci === (0, $e2b283d869a75a62$export$2e2bcd8739ae039).CONVENTIONNE || codeNatureDeci === (0, $e2b283d869a75a62$export$2e2bcd8739ae039).ICPE || codeNatureDeci === (0, $e2b283d869a75a62$export$2e2bcd8739ae039).ICPE_CONVENTIONNE) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                                    name: "peiGestionnaireId",
                                    listIdCodeLibelle: selectData.listGestionnaire,
                                    label: "Gestionnaire",
                                    defaultValue: selectData.listGestionnaire.find((e)=>idGestionnaire ? e.id === idGestionnaire : e.id === values.peiGestionnaireId),
                                    required: false,
                                    setValues: setValues,
                                    disabled: disablePeiUpdate
                                })
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                                    name: "peiSiteId",
                                    listIdCodeLibelle: selectData.listSite.filter((e)=>e.gestionnaireId === values.peiGestionnaireId || e.gestionnaireId === idGestionnaire),
                                    label: "Site",
                                    defaultValue: selectData.listSite.find((e)=>e.id === values.peiSiteId),
                                    required: false,
                                    setValues: setValues,
                                    disabled: disablePeiUpdate
                                })
                            })
                        ]
                    })
                ]
            }),
            values.peiTypePei === (0, $f31f748b1c9fd0fb$export$2e2bcd8739ae039).PIBI && displayIdentifiantGestionnaire && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                        name: "pibiIdentifiantGestionnaire",
                        label: "Identifiant gestionnaire",
                        required: false,
                        disabled: disablePeiUpdate,
                        tooltipText: "Num\xe9ro utilis\xe9 par le gestionnaire pour identifier un PIBI dans son syst\xe8me d'information."
                    })
                })
            }),
            natureParticipeDfci && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                className: "mt-3 align-items-end",
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                            name: "peiPerenne",
                            label: "P\xe9renne",
                            disabled: disablePeiUpdate
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                            name: "peiRotation_6Ccf",
                            label: "Rotation 6 CCF",
                            disabled: disablePeiUpdate
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                className: "mt-3",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$ce9b1cc0c34506d0), {
                        name: "peiObservation",
                        label: "Observations",
                        required: false,
                        disabled: disablePeiUpdate
                    })
                })
            })
        ]
    });
};
const $e55b099050255859$var$FormLocalisationPei = ({ values: values, selectData: selectData, setValues: setValues, setFieldValue: setFieldValue, geometrieData: geometrieData, srid: srid, isSaisieVoieEnabled: isSaisieVoieEnabled, isNew: isNew, user: user })=>{
    const canEdit = isNew || (0, $e3b8d60f4bb99483$export$4f612ab7b7b1d133)(user, [
        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).PEI_U,
        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).PEI_ADRESSE_C
    ]);
    const disableDeplacer = !isNew && !(0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).PEI_DEPLACEMENT_U);
    function VerificationReferentiel() {
        if (selectData !== undefined) {
            if (!selectData?.listAutoriteDeci.map((e)=>e.id).includes(values.peiAutoriteDeciId)) setFieldValue("peiAutoriteDeciId", null);
            if (!selectData?.listServicePublicDeci.map((e)=>e.id).includes(values.peiServicePublicDeciId)) setFieldValue("peiServicePublicDeciId", null);
            if (!selectData?.listMaintenanceDeci.map((e)=>e.id).includes(values.peiMaintenanceDeciId)) setFieldValue("peiMaintenanceDeciId", null);
            if (!selectData?.listGestionnaire.map((e)=>e.id).includes(values.peiGestionnaireId)) setFieldValue("peiGestionnaireId", null);
            if (!selectData?.listSite.map((e)=>e.id).includes(values.peiSiteId)) setFieldValue("peiSiteId", null);
            if (!selectData?.listCommune.map((e)=>e.id).includes(values.peiCommuneId)) setFieldValue("peiCommuneId", null);
            if (!selectData?.listLieuDit.map((e)=>e.id).includes(values.peiLieuDitId)) setFieldValue("peiLieuDitId", null);
            if (!selectData?.listVoie.map((e)=>e.id).includes(values.peiVoieId)) setFieldValue("peiVoieId", null);
            if (!selectData?.listModele.map((e)=>e.id).includes(values.pibiModeleId)) setFieldValue("pibiModeleId", null);
            if (!selectData?.listServiceEau.map((e)=>e.id).includes(values.pibiServiceEauId)) setFieldValue("pibiServiceEauId", null);
            if (!selectData?.listPeiJumelage.map((e)=>e.id).includes(values.pibiJumeleId)) setFieldValue("pibiJumeleId", null);
            if (!selectData?.listDiametreWithNature.map((e)=>e.id).includes(values.pibiDiametreId)) setFieldValue("pibiDiametreId", null);
        }
    }
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($e55b099050255859$var$TitreSousSection, {
                        children: "Coordonn\xe9es g\xe9ographiques"
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Select, {
                            name: "typeSystemeSrid",
                            onChange: (e)=>{
                                setValues((prevValues)=>({
                                        ...prevValues,
                                        typeSystemeSrid: e.target.value
                                    }));
                                const sridActif = e.target.value;
                                const projectionValeur = geometrieData?.find((e)=>e.srid === parseInt(sridActif));
                                setFieldValue("coordonneeXToDisplay", projectionValeur?.coordonneeX);
                                setFieldValue("coordonneeYToDisplay", projectionValeur?.coordonneeY);
                                // Coordonnées en 2154 ou autres
                                const coordonneesToSave = geometrieData?.find((e)=>e.srid === srid);
                                setFieldValue("coordonneeX", coordonneesToSave?.coordonneeX);
                                setFieldValue("coordonneeY", coordonneesToSave?.coordonneeY);
                            },
                            disabled: disableDeplacer,
                            className: "mt-3",
                            children: (0, $e2315562ed43d638$export$2e2bcd8739ae039).map((e)=>{
                                if (e.actif || e.srid === srid) return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("option", {
                                    value: e.srid,
                                    selected: e.srid === values.typeSystemeSrid,
                                    children: e.nomSystem
                                }, e.srid);
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                className: "mt-3",
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                            label: "Coordonn\xe9e X",
                            name: "coordonneeXToDisplay",
                            required: true,
                            disabled: disableDeplacer,
                            onChange: (v)=>{
                                setFieldValue("coordonneeXToDisplay", v.target.value), VerificationReferentiel();
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                            label: "Coordonn\xe9e Y",
                            name: "coordonneeYToDisplay",
                            required: true,
                            disabled: disableDeplacer,
                            onChange: (v)=>{
                                setFieldValue("coordonneeYToDisplay", v.target.value), VerificationReferentiel();
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                className: "mt-3",
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($e55b099050255859$var$TitreSousSection, {
                        children: "Adresse"
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                            name: "peiCommuneId",
                            listIdCodeLibelle: selectData.listCommune,
                            label: "Commune",
                            defaultValue: selectData.listCommune.find((e)=>e.id === values.peiCommuneId),
                            required: true,
                            setValues: setValues,
                            disabled: !canEdit
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: values.peiCommuneId && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                            name: "peiLieuDitId",
                            listIdCodeLibelle: selectData.listLieuDit.filter((e)=>e.communeId === values.peiCommuneId),
                            label: "Lieu dit",
                            defaultValue: selectData.listLieuDit.find((e)=>e.id === values.peiLieuDitId),
                            required: false,
                            setValues: setValues,
                            disabled: !canEdit
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                className: "mt-3 g-3 align-items-end",
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        xs: 6,
                        xxl: 2,
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                            name: "peiNumeroVoie",
                            label: "N\xb0 de voie",
                            required: false,
                            disabled: !canEdit
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        xs: 6,
                        xxl: 2,
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                            name: "peiSuffixeVoie",
                            label: "Suffixe",
                            required: false,
                            disabled: !canEdit
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        xs: 8,
                        xxl: 5,
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                            name: "peiVoieId",
                            listIdCodeLibelle: selectData.listVoie.filter((e)=>e.communeId === values.peiCommuneId),
                            label: "Voie",
                            defaultValue: selectData.listVoie.find((e)=>e.id === values.peiVoieId),
                            required: !values.voieSaisieLibre,
                            setValues: setValues,
                            disabled: !canEdit || values.voieSaisieLibre || values.peiVoieTexte != null && values.peiVoieTexte?.trim() !== ""
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        xs: 4,
                        xxl: 3,
                        className: "d-flex align-self-end justify-content-start",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                            name: "peiEnFace",
                            label: "Situ\xe9 en face",
                            disabled: !canEdit
                        })
                    })
                ]
            }),
            isSaisieVoieEnabled && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                    xs: 8,
                    xxl: {
                        span: 5,
                        offset: 4
                    },
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                        name: "voieSaisieLibre",
                        label: "Voie non trouv\xe9e",
                        disabled: !canEdit,
                        onChange: ()=>{
                            setFieldValue("voieSaisieLibre", !values.voieSaisieLibre);
                            if (!values.voieSaisieLibre) setFieldValue("peiVoieId", null);
                            else setFieldValue("peiVoieTexte", null);
                        }
                    })
                })
            }),
            isSaisieVoieEnabled && values.voieSaisieLibre && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                    xs: 12,
                    xxl: {
                        span: 5,
                        offset: 4
                    },
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                        name: "peiVoieTexte",
                        label: "Voie (saisie libre)",
                        required: values.voieSaisieLibre,
                        disabled: !canEdit || values.peiVoieId != null && values.peiVoieId?.trim() !== ""
                    })
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                className: "mt-3 d-flex align-items-end",
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $f89cdb798dc1325f$export$2e2bcd8739ae039), {
                            name: "peiNiveauId",
                            nomenclature: (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).NIVEAU,
                            label: "Niveau",
                            valueId: values.peiNiveauId,
                            required: false,
                            setValues: setValues,
                            disabled: !canEdit
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                            name: "peiCroisementId",
                            listIdCodeLibelle: selectData.listVoie.filter((e)=>e.communeId === values.peiCommuneId),
                            label: "Croisement avec",
                            defaultValue: selectData.listVoie.find((e)=>e.id === values.peiCroisementId),
                            required: false,
                            setValues: setValues,
                            disabled: !canEdit
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $f89cdb798dc1325f$export$2e2bcd8739ae039), {
                            name: "peiDomaineId",
                            nomenclature: (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).DOMAINE,
                            label: "Domaine",
                            valueId: values.peiDomaineId,
                            required: true,
                            setValues: setValues,
                            disabled: !canEdit
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                className: "mt-3 d-flex align-items-center",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$ce9b1cc0c34506d0), {
                        name: "peiComplementAdresse",
                        label: "Compl\xe9ment d'adresse",
                        required: false,
                        disabled: !canEdit
                    })
                })
            })
        ]
    });
};
const $e55b099050255859$var$FormPibi = ({ values: values, selectData: selectData, setValues: setValues, setFieldValue: setFieldValue, hasDroitCaracteristique: hasDroitCaracteristique })=>{
    const idMarque = values.pibiModeleId ? selectData.listModele.find((e)=>e.id === values.pibiModeleId)?.marqueId : values.pibiMarqueId;
    const listDiametreOptions = selectData.listDiametreWithNature.filter((e)=>//retire les éléments non assignable (car nature (!=) ou inactif)
        e.natureId === values.peiNatureId && e.actif || // conserve l'élément assigné actuellement
        e.id === values.pibiDiametreId).map((e)=>// Formate la liste dans l'état attendu par le composant SelectForm
        ({
            id: e.id,
            code: e.code,
            libelle: e.libelle
        })).filter(// Elimination des doublons
    (item, index, self)=>self.findIndex((t)=>t.id === item.id && t.code === item.code && t.libelle === item.libelle) === index).sort((a, b)=>{
        // Tri des options, nécessaire au bon fonctionnement du composant
        // Si les options changent d'index au cours de l'assignation, le SetValue ne donne pas le résultat attendu
        return a.code < b.code ? -1 : 1;
    });
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($e55b099050255859$var$TitreSousSection, {
                        children: "Informations PEI"
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        xs: 6,
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                            name: "pibiDiametreId",
                            listIdCodeLibelle: listDiametreOptions,
                            label: "Diam\xe8tre nominal",
                            defaultValue: listDiametreOptions.find((e)=>e.id === values.pibiDiametreId),
                            required: false,
                            disabled: !hasDroitCaracteristique,
                            setValues: setValues
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        className: "d-flex align-items-end mb-2 me-2",
                        xs: "auto",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                            name: "pibiDispositifInviolabilite",
                            label: "Dispositif d'inviolabilit\xe9",
                            disabled: !hasDroitCaracteristique
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        className: "d-flex align-items-end mb-2",
                        xs: "auto",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                            name: "pibiRenversable",
                            label: "Renversable",
                            disabled: !hasDroitCaracteristique
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                className: "mt-3 d-flex align-items-end mb-2",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                        name: "pibiJumeleId",
                        listIdCodeLibelle: selectData.listPeiJumelage,
                        label: "Jumel\xe9 avec",
                        defaultValue: selectData?.listPeiJumelage?.find((e)=>e.id === values.pibiJumeleId),
                        required: false,
                        setValues: setValues,
                        disabled: !hasDroitCaracteristique
                    })
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                className: "mt-3",
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $f89cdb798dc1325f$export$2e2bcd8739ae039), {
                            name: "pibiMarqueId",
                            nomenclature: (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).MARQUE_PIBI,
                            label: "Marque",
                            valueId: idMarque,
                            required: false,
                            setValues: setValues,
                            setOtherValues: ()=>{
                                setFieldValue("pibiModeleId", null);
                            },
                            disabled: !hasDroitCaracteristique
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                            name: "pibiModeleId",
                            listIdCodeLibelle: selectData.listModele.filter((e)=>e.marqueId === values.pibiMarqueId || e.marqueId === idMarque),
                            label: "Mod\xe8le",
                            defaultValue: selectData.listModele.find((e)=>e.id === values.pibiModeleId),
                            required: false,
                            setValues: setValues,
                            disabled: !hasDroitCaracteristique
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$2e2bcd8739ae039), {
                            name: "peiAnneeFabrication",
                            label: "Ann\xe9e de fabrication",
                            required: false,
                            disabled: !hasDroitCaracteristique
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                className: "mt-3",
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($e55b099050255859$var$TitreSousSection, {
                        children: "R\xe9seau"
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                            name: "pibiServiceEauId",
                            listIdCodeLibelle: selectData.listServiceEau,
                            label: "Service des eaux",
                            defaultValue: selectData.listServiceEau.find((e)=>e.id === values.pibiServiceEauId),
                            required: false,
                            setValues: setValues,
                            disabled: !hasDroitCaracteristique
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $f89cdb798dc1325f$export$2e2bcd8739ae039), {
                            name: "pibiTypeReseauId",
                            nomenclature: (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).TYPE_RESEAU,
                            label: "Type de r\xe9seau",
                            valueId: values.pibiTypeReseauId,
                            required: false,
                            setValues: setValues,
                            disabled: !hasDroitCaracteristique
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                className: "mt-3",
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $f89cdb798dc1325f$export$2e2bcd8739ae039), {
                            name: "pibiTypeCanalisationId",
                            nomenclature: (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).TYPE_CANALISATION,
                            label: "Type de canalisation",
                            valueId: values.pibiTypeCanalisationId,
                            required: false,
                            setValues: setValues,
                            disabled: !hasDroitCaracteristique
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$6bf0cd3a219bbade), {
                            name: "pibiDiametreCanalisation",
                            label: "Diam\xe8tre de canalisation",
                            required: false,
                            disabled: !hasDroitCaracteristique
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        className: "d-flex align-items-end mb-2",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                            name: "pibiDebitRenforce",
                            label: "D\xe9bit renforc\xe9",
                            disabled: !hasDroitCaracteristique
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                className: "mt-3",
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        xs: 4,
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $f89cdb798dc1325f$export$2e2bcd8739ae039), {
                            name: "pibiReservoirId",
                            nomenclature: (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).RESERVOIR,
                            label: "R\xe9servoir",
                            valueId: values.pibiReservoirId,
                            required: false,
                            setValues: setValues,
                            disabled: !hasDroitCaracteristique
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        className: "d-flex align-items-end mb-2 me-2",
                        xs: "auto",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                            name: "pibiSurpresse",
                            label: "R\xe9seau surpress\xe9",
                            disabled: !hasDroitCaracteristique
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        className: "d-flex align-items-end mb-2",
                        xs: "auto",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                            name: "pibiAdditive",
                            label: "R\xe9seau additiv\xe9",
                            disabled: !hasDroitCaracteristique
                        })
                    })
                ]
            })
        ]
    });
};
const $e55b099050255859$var$FormPena = ({ values: values, setValues: setValues, setFieldValue: setFieldValue, hasDroitCaracteristique: hasDroitCaracteristique, displayTypeEngin: displayTypeEngin = false })=>{
    const typeEnginState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/nomenclatures/type_engin`);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($e55b099050255859$var$TitreSousSection, {
                        children: "Ressource"
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        className: "d-flex align-items-center",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                            name: "penaCapaciteIllimitee",
                            label: "Capacit\xe9 illimit\xe9e",
                            disabled: !hasDroitCaracteristique
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        className: "d-flex align-items-center",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                            name: "penaCapaciteIncertaine",
                            label: "Capacit\xe9 incertaine",
                            disabled: !hasDroitCaracteristique
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        className: "d-flex align-items-center",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                            name: "penaEquipeHbe",
                            label: "\xc9quip\xe9 HBE",
                            disabled: !hasDroitCaracteristique
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                className: "mt-3",
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$2e2bcd8739ae039), {
                            name: "penaCapacite",
                            label: "Capacit\xe9 en m\xb3",
                            required: false,
                            disabled: !hasDroitCaracteristique
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$2e2bcd8739ae039), {
                            name: "penaQuantiteAppoint",
                            label: "Quantit\xe9 d'appoint en m\xb3/h",
                            required: false,
                            disabled: !hasDroitCaracteristique
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $f89cdb798dc1325f$export$2e2bcd8739ae039), {
                            name: "penaMateriauId",
                            nomenclature: (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).MATERIAU,
                            label: "Mat\xe9riau de la citerne",
                            valueId: values.penaMateriauId,
                            required: false,
                            setValues: setValues,
                            disabled: !hasDroitCaracteristique
                        })
                    })
                ]
            }),
            displayTypeEngin && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                className: "mt-3",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                    xs: 4,
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$eae70af4b4e3f197), {
                        name: "typeEnginIds",
                        label: "Types d'engins compatibles",
                        required: false,
                        options: typeEnginState?.data ? Object.values(typeEnginState?.data) : [],
                        getOptionValue: (t)=>t.typeEnginId,
                        getOptionLabel: (t)=>t.typeEnginLibelle,
                        value: typeEnginState?.data ? values?.typeEnginIds?.map((e)=>Object.values(typeEnginState?.data)?.find((r)=>r.typeEnginId === e)) : undefined,
                        onChange: (typeEngin)=>{
                            const typeEnginId = typeEngin.map((e)=>e.typeEnginId);
                            typeEnginId.length > 0 ? setFieldValue("typeEnginIds", typeEnginId) : setFieldValue("typeEnginIds", []);
                        },
                        disabled: !hasDroitCaracteristique
                    })
                })
            })
        ]
    });
};
const $e55b099050255859$var$TitreSousSection = ({ children: children })=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("p", {
        className: "h5 mt-3",
        children: children
    });
};


const $948eb983c24fac1c$var$CreatePei = ({ coordonneesPeiCreate: coordonneesPeiCreate, close: close, map: map })=>{
    const initialValues = (0, $e55b099050255859$export$a5cab80145b70e98)({
        coordonneeX: coordonneesPeiCreate.coordonneeX,
        coordonneeY: coordonneesPeiCreate.coordonneeY,
        srid: parseInt(coordonneesPeiCreate.srid)
    });
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
            initialValues: initialValues,
            validationSchema: (0, $e55b099050255859$export$c084437b5e3206cd),
            isPost: true,
            isMultipartFormData: true,
            submitUrl: `/api/pei/create/`,
            prepareVariables: (values)=>(0, $e55b099050255859$export$f97400759cfd946)(values),
            onSubmit: ()=>{
                close();
                (0, $1ed1be1197ad1bc4$export$51ba454167fb25ab)(map);
            },
            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e55b099050255859$export$2e2bcd8739ae039), {
                isNew: true,
                close: close,
                returnBouton: false
            })
        })
    });
};
var $948eb983c24fac1c$export$2e2bcd8739ae039 = $948eb983c24fac1c$var$CreatePei;











const $b5a42a59076ab4fc$var$UpdatePei = ({ peiIdUpdate: peiIdUpdate, close: close, map: map })=>{
    const { peiId: peiId } = (0, $7a844823b04d4282$export$99eaa27ddbbb95ef)();
    const id = peiIdUpdate ?? peiId;
    const peiState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/pei/` + id);
    const documentsState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/documents/pei/` + id);
    if (!peiState.isResolved) return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $c21b1c237cfa1d94$export$2e2bcd8739ae039), {});
    const { data: data } = peiState;
    data.documents = documentsState.data;
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
        initialValues: (0, $e55b099050255859$export$a5cab80145b70e98)(data),
        validationSchema: (0, $e55b099050255859$export$c084437b5e3206cd),
        isPost: false,
        isMultipartFormData: true,
        submitUrl: `/api/pei/update`,
        prepareVariables: (values)=>(0, $e55b099050255859$export$f97400759cfd946)(values, data),
        redirectUrl: !peiIdUpdate ? (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).PEI : undefined,
        onSubmit: ()=>{
            if (peiIdUpdate !== undefined) {
                close();
                (0, $1ed1be1197ad1bc4$export$51ba454167fb25ab)(map);
            }
        },
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e55b099050255859$export$2e2bcd8739ae039), {
            returnBouton: !peiIdUpdate,
            close: close,
            isFromMap: peiIdUpdate !== undefined
        })
    });
};
var $b5a42a59076ab4fc$export$2e2bcd8739ae039 = $b5a42a59076ab4fc$var$UpdatePei;





var $kc00y = parcelRequire("kc00y");


















/**
 * Enumération définissant les types de Visite
 */ var $d1d6244030f5b65c$export$75645a4de2ddb107 = /*#__PURE__*/ function(TYPE_VISITE) {
    TYPE_VISITE["RECEPTION"] = "RECEPTION";
    TYPE_VISITE["RECO_INIT"] = "RECO_INIT";
    TYPE_VISITE["CTP"] = "CTP";
    TYPE_VISITE["ROP"] = "ROP";
    TYPE_VISITE["NP"] = "NP";
    return TYPE_VISITE;
}({});
const $d1d6244030f5b65c$var$referenceTypeVisite = [
    {
        code: "RECEPTION",
        libelle: "Visite de R\xe9ception"
    },
    {
        code: "RECO_INIT",
        libelle: "Reconnaissance op\xe9rationnelle initiale"
    },
    {
        code: "CTP",
        libelle: "Contr\xf4le technique p\xe9riodique"
    },
    {
        code: "ROP",
        libelle: "Reconnaissance op\xe9rationnelle p\xe9riodique"
    },
    {
        code: "NP",
        libelle: "Non programm\xe9e"
    }
];
var $d1d6244030f5b65c$export$2e2bcd8739ae039 = $d1d6244030f5b65c$var$referenceTypeVisite;







var $bkJfK = parcelRequire("bkJfK");

var $kc00y = parcelRequire("kc00y");













const $d1f7eed652dc9cd5$export$a5cab80145b70e98 = (_visitePeiId, _listeAnomaliesAssignable, _lastCDP, _derniereObservation)=>({
        visiteId: null,
        visitePeiId: _visitePeiId,
        visiteDate: (0, $00c47c7740afd024$export$cc23f907e4acb548)(new Date()),
        visiteTypeVisite: null,
        visiteAgent1: null,
        visiteAgent2: null,
        visiteObservation: _derniereObservation,
        listeAnomalie: _listeAnomaliesAssignable,
        isCtrlDebitPression: false,
        ctrlDebitPression: _lastCDP
    });
const $d1f7eed652dc9cd5$export$f97400759cfd946 = (values)=>({
        visiteId: values.visiteId ?? null,
        visitePeiId: values.visitePeiId ?? null,
        visiteDate: new Date(values.visiteDate).toISOString() ?? null,
        visiteTypeVisite: values.visiteTypeVisite ?? null,
        visiteAgent1: values.visiteAgent1 ?? null,
        visiteAgent2: values.visiteAgent2 ?? null,
        visiteObservation: values.visiteObservation ?? null,
        listeAnomalie: values.listeAnomalie.filter((e)=>e.isAssigned === true).map((e)=>e.anomalieId) ?? [],
        isCtrlDebitPression: values.isCtrlDebitPression ?? false,
        ctrlDebitPression: values.ctrlDebitPression ?? null
    });
const $d1f7eed652dc9cd5$var$VisiteForm = ({ nbVisite: nbVisite, typePei: typePei, listeAnomaliesAssignable: listeAnomaliesAssignable, user: user })=>{
    const { values: values, setValues: setValues, resetForm: resetForm } = (0, $bkJfK.useFormikContext)();
    const parametreVisiteTypeCdp = (0, $ee297f06e8568bf4$export$2e2bcd8739ae039).TYPE_VISITE_CDP;
    const listeParametre = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/parametres?${{
        listeParametreCode: JSON.stringify(parametreVisiteTypeCdp)
    }}`);
    let listeTypeVisiteCdp = [];
    if (listeParametre.isResolved) listeTypeVisiteCdp = JSON.parse(listeParametre?.data[parametreVisiteTypeCdp].parametreValeur);
    const { handleShowClose: handleShowCloseFormulaire, activesKeys: activesKeysFormulaire, show: show, openState: openState } = (0, $db860d90b4a42fea$export$dae930a4ba30758b)([
        true,
        false,
        false,
        false
    ]);
    (0, $kc00y.useEffect)(()=>{
        if (values?.visiteObservation && !openState[2]) show(2); // Si visiteObservation est remplit, alors on affiche l'accordeon
    }, [
        values?.visiteObservation,
        show,
        openState[2]
    ]);
    const { handleShowClose: handleShowCloseAnomalies, activesKeys: activesKeysAnomalies } = (0, $db860d90b4a42fea$export$dae930a4ba30758b)([]);
    const listTypeVisite = (0, $d1d6244030f5b65c$export$2e2bcd8739ae039).map((e)=>({
            id: e.code,
            code: e.code,
            libelle: e.libelle
        }));
    const dynamicListTypeVisite = nbVisite === 0 && (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).VISITE_RECEP_C) ? listTypeVisite.filter((e)=>e.code === (0, $d1d6244030f5b65c$export$75645a4de2ddb107).RECEPTION) : nbVisite === 1 && (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).VISITE_RECO_INIT_C) ? listTypeVisite.filter((e)=>e.code === (0, $d1d6244030f5b65c$export$75645a4de2ddb107).RECO_INIT) : listTypeVisite.filter((e)=>e.code !== (0, $d1d6244030f5b65c$export$75645a4de2ddb107).RECEPTION && e.code !== (0, $d1d6244030f5b65c$export$75645a4de2ddb107).RECO_INIT && (!(0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).VISITE_CONTROLE_TECHNIQUE_C) ? e.code !== (0, $d1d6244030f5b65c$export$75645a4de2ddb107).CTP : true) && (!(0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).VISITE_RECO_C) ? e.code !== (0, $d1d6244030f5b65c$export$75645a4de2ddb107).ROP : true) && (!(0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).VISITE_NON_PROGRAMME_C) ? e.code !== (0, $d1d6244030f5b65c$export$75645a4de2ddb107).NP : true));
    let filteredListAnomalie = [];
    let enableCDP = false;
    if (values.visiteTypeVisite) {
        if (listeTypeVisiteCdp.some((typeVisite)=>values.visiteTypeVisite === typeVisite)) enableCDP = true;
        else values.isCtrlDebitPression = false;
        switch(values.visiteTypeVisite){
            case (0, $d1d6244030f5b65c$export$75645a4de2ddb107).RECEPTION:
                filteredListAnomalie = listeAnomaliesAssignable.filter((e)=>e.isReceptionAssignable === true && e.anomalieActif === true || e.isAssigned === true);
                break;
            case (0, $d1d6244030f5b65c$export$75645a4de2ddb107).RECO_INIT:
                filteredListAnomalie = listeAnomaliesAssignable.filter((e)=>e.isRecoInitAssignable === true && e.anomalieActif === true || e.isAssigned === true);
                break;
            case (0, $d1d6244030f5b65c$export$75645a4de2ddb107).CTP:
                filteredListAnomalie = listeAnomaliesAssignable.filter((e)=>e.isCTPAssignable === true && e.anomalieActif === true || e.isAssigned === true);
                break;
            case (0, $d1d6244030f5b65c$export$75645a4de2ddb107).ROP:
                filteredListAnomalie = listeAnomaliesAssignable.filter((e)=>e.isRopAssignable === true && e.anomalieActif === true || e.isAssigned === true);
                break;
            case (0, $d1d6244030f5b65c$export$75645a4de2ddb107).NP:
                filteredListAnomalie = listeAnomaliesAssignable.filter((e)=>e.isNPAssignable === true && e.anomalieActif === true || e.isAssigned === true);
                break;
            default:
                break;
        }
    }
    const groupedListeAnomalies = Object.groupBy(filteredListAnomalie, (item)=>item.anomalieCategorieLibelle);
    const listeVoletsAccordion = [];
    Object.entries(groupedListeAnomalies).map(([categorie, listAno])=>listeVoletsAccordion.push({
            header: categorie,
            // TODO : Ajouter une indication du nombre d'anomalie cochée
            content: listAno?.map((element)=>{
                const anomalieIndex = values.listeAnomalie?.findIndex((e)=>e.anomalieId === element.anomalieId);
                return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                    name: "listeAnomalie[" + anomalieIndex + "].isAssigned",
                    label: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("span", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(element.poidsAnomalieValIndispoTerrestre === 5 && "fw-bold", element.poidsAnomalieValIndispoHbe === 5 && "text-decoration-underline"),
                        children: [
                            element.anomalieLibelle,
                            element.anomalieActif === false ? " (inactive)" : null
                        ]
                    })
                }, element.anomalieId);
            })
        }));
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db860d90b4a42fea$export$2e2bcd8739ae039), {
                activesKeys: activesKeysFormulaire,
                handleShowClose: handleShowCloseFormulaire,
                list: [
                    {
                        header: "Informations g\xe9n\xe9rales",
                        content: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$183478aa40b5df1), {
                                        name: "visiteDate",
                                        label: "Date et Heure : ",
                                        value: values.visiteDate,
                                        onChange: (e)=>{
                                            resetForm({
                                                values: {
                                                    ...values,
                                                    visiteDate: e.target.value
                                                }
                                            });
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                                        name: "visiteTypeVisite",
                                        listIdCodeLibelle: dynamicListTypeVisite,
                                        defaultValue: dynamicListTypeVisite.find((e)=>e.id === values.visiteTypeVisite),
                                        label: "Type de visite : ",
                                        required: true,
                                        setValues: setValues
                                    })
                                }),
                                typePei === (0, $f31f748b1c9fd0fb$export$2e2bcd8739ae039).PIBI && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                                        name: "isCtrlDebitPression",
                                        label: "Contr\xf4le d\xe9bit et pression (CDP)",
                                        disabled: !enableCDP
                                    })
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                                                name: "visiteAgent1",
                                                label: "Agent 1 : ",
                                                required: false
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                                                name: "visiteAgent2",
                                                label: "Agent 2 : ",
                                                required: false
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    },
                    ...values.isCtrlDebitPression === true ? [
                        {
                            header: "Mesures",
                            content: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$2e2bcd8739ae039), {
                                            name: "ctrlDebitPression.visiteCtrlDebitPressionPression",
                                            label: "Pression statique (bar) : ",
                                            min: 0,
                                            step: 0.01,
                                            required: false
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$2e2bcd8739ae039), {
                                            name: "ctrlDebitPression.visiteCtrlDebitPressionPressionDyn",
                                            label: "Pression dynamique au d\xe9bit nominal (bar) : ",
                                            min: 0,
                                            step: 0.01,
                                            required: false
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$2e2bcd8739ae039), {
                                            name: "ctrlDebitPression.visiteCtrlDebitPressionDebit",
                                            label: "D\xe9bit \xe0 1 bar (m\xb3/h) : ",
                                            min: 0,
                                            required: false
                                        })
                                    })
                                ]
                            })
                        }
                    ] : [],
                    {
                        header: "Points d'attention",
                        content: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                            children: values.visiteTypeVisite ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db860d90b4a42fea$export$2e2bcd8739ae039), {
                                activesKeys: activesKeysAnomalies,
                                handleShowClose: handleShowCloseAnomalies,
                                list: listeVoletsAccordion
                            }) : /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("p", {
                                children: "S\xe9lectionnez le type de visite pour acc\xe9der \xe0 la liste des anomalies assignables"
                            })
                        })
                    },
                    {
                        header: "Observations",
                        content: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$ce9b1cc0c34506d0), {
                            name: "visiteObservation",
                            required: false
                        })
                    }
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db9b0e6fdb142a4c$export$2e2bcd8739ae039), {
                onClick: ()=>$d1f7eed652dc9cd5$var$checkValidity(values, show),
                returnLink: false
            })
        ]
    });
};
var $d1f7eed652dc9cd5$export$2e2bcd8739ae039 = $d1f7eed652dc9cd5$var$VisiteForm;
function $d1f7eed652dc9cd5$var$checkValidity(values, show) {
    if (values.visiteDate === null || values.visiteDate === "" || values.visiteTypeVisite === null || values.visiteTypeVisite === "") show(0);
}


const $1398c46fdaf43768$var$Visite = ({ peiIdCarte: peiIdCarte, closeForm: closeForm, map: map })=>{
    const { peiId: paramPeiId } = (0, $7a844823b04d4282$export$99eaa27ddbbb95ef)();
    const peiId = peiIdCarte ?? paramPeiId;
    const { user: user } = (0, $e787cde576104469$export$fdc397e486fa83e7)();
    function handleNewVisite() {
        setNewVisite(true);
        setCurrentVisite(null);
    }
    const { visible: visible, show: show, close: close, ref: ref } = (0, $ca8671088139af49$export$2e2bcd8739ae039)();
    const [currentVisite, setCurrentVisite] = (0, $kc00y.useState)(null);
    const [newVisite, setNewVisite] = (0, $kc00y.useState)(false); // Permet de différencier la lecture de la création d'un visite pour l'affichage
    const { handleShowClose: handleShowClose, activesKeys: activesKeys } = (0, $db860d90b4a42fea$export$dae930a4ba30758b)([
        true,
        false,
        false,
        false
    ]);
    const visiteInformations = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/visite/getVisiteWithAnomalies/` + peiId, {});
    const listeAnomaliesAssignable = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/anomalie/getAssignablesAnomalies/` + peiId, {});
    if (!visiteInformations.isResolved) return;
    const listeVisite = visiteInformations.data.listVisite;
    const typePei = visiteInformations.data.typePei;
    const numeroComplet = visiteInformations.data.numeroComplet;
    const commune = visiteInformations.data.commune;
    const lastCDP = {
        visiteCtrlDebitPressionDebit: visiteInformations.data.lastCDP?.visiteCtrlDebitPressionDebit,
        visiteCtrlDebitPressionPression: visiteInformations.data.lastCDP?.visiteCtrlDebitPressionPression,
        visiteCtrlDebitPressionPressionDyn: visiteInformations.data.lastCDP?.visiteCtrlDebitPressionPressionDyn
    };
    const listeVoletsAccordion = [];
    if (currentVisite != null) {
        const groupedListeAnomalies = currentVisite.listeAnomalie ? Object.groupBy(currentVisite.listeAnomalie.filter((item)=>item.anomalieCategorieLibelle != null), (item)=>item.anomalieCategorieLibelle) : [];
        Object.entries(groupedListeAnomalies).map(([categorie, values])=>listeVoletsAccordion.push({
                header: categorie,
                // TODO : Ajouter une indication du nombre d'anomalie cochée
                content: values?.map((element)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Check, {
                        type: "checkbox",
                        disabled: true,
                        checked: true,
                        label: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("span", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(element.poidsAnomalieValIndispoTerrestre === 5 && "fw-bold", element.poidsAnomalieValIndispoHbe === 5 && "text-decoration-underline"),
                            children: element.anomalieLibelle
                        })
                    }, element.anomalieId))
            }));
    }
    const hasRightToDelete = (visite)=>{
        switch(visite.visiteTypeVisite){
            case (0, $d1d6244030f5b65c$export$75645a4de2ddb107).CTP:
                return (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).VISITE_CTP_D);
            case (0, $d1d6244030f5b65c$export$75645a4de2ddb107).NP:
                return (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).VISITE_NP_D);
            case (0, $d1d6244030f5b65c$export$75645a4de2ddb107).RECEPTION:
                return (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).VISITE_RECEP_D);
            case (0, $d1d6244030f5b65c$export$75645a4de2ddb107).ROP:
                return (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).VISITE_RECO_D);
            case (0, $d1d6244030f5b65c$export$75645a4de2ddb107).RECO_INIT:
                return (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).VISITE_RECO_INIT_D);
        }
    };
    const hasRightToCreate = ()=>{
        if (listeVisite.length === 0) return (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).VISITE_RECEP_C);
        else if (listeVisite.length === 1) return (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).VISITE_RECO_INIT_C);
        else if (listeVisite.length >= 2) return (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).VISITE_CONTROLE_TECHNIQUE_C) || (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).VISITE_RECO_C) || (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).VISITE_NON_PROGRAMME_C);
    };
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        fluid: true,
        className: "px-5",
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                title: `Visites du PEI ${numeroComplet} - ${commune}`,
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$931ba9c16d55112), {}),
                displayReturnButton: !peiIdCarte,
                right: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
                    children: peiIdCarte ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                        variant: "danger",
                        className: "text-white",
                        onClick: closeForm,
                        children: "Fermer"
                    }) : hasRightToCreate() && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                        className: "d-flex justify-content-end my-3",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($1398c46fdaf43768$var$CreateVisiteButton, {
                            onClick: handleNewVisite
                        })
                    })
                })
            }),
            peiIdCarte && hasRightToCreate() && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                className: "d-flex justify-content-end my-3",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($1398c46fdaf43768$var$CreateVisiteButton, {
                    onClick: handleNewVisite
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                className: "mt-2",
                children: [
                    currentVisite && !newVisite && peiIdCarte && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($1398c46fdaf43768$var$ConsulterVisite, {
                        peiIdCarte: peiIdCarte,
                        activesKeys: activesKeys,
                        handleShowClose: handleShowClose,
                        currentVisite: currentVisite,
                        typePei: typePei,
                        listeVoletsAccordion: listeVoletsAccordion
                    }),
                    !currentVisite && newVisite && peiIdCarte && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($1398c46fdaf43768$var$CreateVisite, {
                        peiIdCarte: peiIdCarte,
                        listeAnomaliesAssignable: listeAnomaliesAssignable,
                        peiId: peiId,
                        lastCDP: lastCDP,
                        listeVisite: listeVisite,
                        typePei: typePei,
                        user: user,
                        onSubmit: ()=>{
                            (0, $1ed1be1197ad1bc4$export$51ba454167fb25ab)(map);
                            setNewVisite(false);
                            visiteInformations.reload();
                        }
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        xs: peiIdCarte ? "12" : "5",
                        className: "mt-3",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("h3", {
                                    children: "Historique des visites"
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $13de46b4dfcc473f$export$2e2bcd8739ae039), {
                                    striped: true,
                                    bordered: true,
                                    size: "sm",
                                    children: [
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("thead", {
                                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("th", {
                                                        children: "Date"
                                                    }),
                                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("th", {
                                                        children: "Type"
                                                    }),
                                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("th", {
                                                        children: "Agent"
                                                    }),
                                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("th", {
                                                        children: "Action"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("tbody", {
                                            children: listeVisite.map((element, index)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("tr", {
                                                    className: currentVisite && element.visiteId === currentVisite.visiteId ? "table-info" : "",
                                                    children: [
                                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("td", {
                                                            className: "text-nowrap",
                                                            children: (0, $00c47c7740afd024$export$beb50dcdba5b8943)(element.visiteDate)
                                                        }),
                                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("td", {
                                                            children: (0, $d1d6244030f5b65c$export$2e2bcd8739ae039).find((e)=>e.code === element.visiteTypeVisite)?.libelle
                                                        }),
                                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("td", {
                                                            className: "text-nowrap",
                                                            children: element.visiteAgent1
                                                        }),
                                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("td", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                                                                    tooltipText: "Consulter la visite",
                                                                    tooltipId: `tooltip-view-${index}`,
                                                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                                                                        variant: "link",
                                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))("p-0 m-0 text-decoration-none"),
                                                                        onClick: ()=>{
                                                                            setCurrentVisite(element);
                                                                            setNewVisite(false);
                                                                        },
                                                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$d7cfde09abbb52ee), {})
                                                                    })
                                                                }),
                                                                index === 0 && hasRightToDelete(element) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                                                                            tooltipText: "Supprimer la visite",
                                                                            tooltipId: `tooltip-delete-${index}`,
                                                                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                                                                                variant: "link",
                                                                                className: "p-0 m-0 ps-1 text-decoration-none text-danger",
                                                                                onClick: ()=>show(),
                                                                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$4d4e10ce882b8153), {})
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $791e7ee3b0d1ae7e$export$2e2bcd8739ae039), {
                                                                            visible: visible,
                                                                            onCancel: close,
                                                                            onSuccess: close,
                                                                            onError: close,
                                                                            query: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/visite/` + element.visiteId,
                                                                            ref: ref,
                                                                            onDelete: ()=>{
                                                                                close();
                                                                                (0, $1ed1be1197ad1bc4$export$51ba454167fb25ab)(map);
                                                                                visiteInformations.reload();
                                                                                listeAnomaliesAssignable.reload();
                                                                            }
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }, index))
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    !currentVisite && newVisite && !peiIdCarte && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($1398c46fdaf43768$var$CreateVisite, {
                        peiIdCarte: peiIdCarte,
                        listeAnomaliesAssignable: listeAnomaliesAssignable,
                        peiId: peiId,
                        lastCDP: lastCDP,
                        listeVisite: listeVisite,
                        typePei: typePei,
                        user: user,
                        onSubmit: ()=>{
                            setNewVisite(false);
                            visiteInformations.reload();
                        }
                    }),
                    currentVisite && !newVisite && !peiIdCarte && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($1398c46fdaf43768$var$ConsulterVisite, {
                        peiIdCarte: peiIdCarte,
                        activesKeys: activesKeys,
                        handleShowClose: handleShowClose,
                        currentVisite: currentVisite,
                        typePei: typePei,
                        listeVoletsAccordion: listeVoletsAccordion
                    })
                ]
            })
        ]
    });
};
var $1398c46fdaf43768$export$2e2bcd8739ae039 = $1398c46fdaf43768$var$Visite;
const $1398c46fdaf43768$var$CreateVisite = ({ peiIdCarte: peiIdCarte, listeAnomaliesAssignable: listeAnomaliesAssignable, peiId: peiId, lastCDP: lastCDP, listeVisite: listeVisite, typePei: typePei, user: user, onSubmit: onSubmit })=>{
    const listeParametre = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/parametres?${{
        listeParametreCode: JSON.stringify((0, $ee297f06e8568bf4$export$2e2bcd8739ae039).CONSERVER_OBSERVATION_VISITE)
    }}`, {});
    if (!listeParametre.isResolved) return null;
    const needKeepObservation = JSON.parse(listeParametre.data[(0, $ee297f06e8568bf4$export$2e2bcd8739ae039).CONSERVER_OBSERVATION_VISITE].parametreValeur);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
        xs: peiIdCarte ? "12" : "7",
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("h3", {
                    children: "Cr\xe9ation d'une visite"
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                    initialValues: (0, $d1f7eed652dc9cd5$export$a5cab80145b70e98)(peiId, listeAnomaliesAssignable.data, lastCDP, needKeepObservation && listeVisite[0]?.visiteObservation != null ? listeVisite[0].visiteObservation : ""),
                    validationSchema: (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({}),
                    isPost: false,
                    submitUrl: `/api/visite/createVisite`,
                    prepareVariables: (values)=>(0, $d1f7eed652dc9cd5$export$f97400759cfd946)(values),
                    onSubmit: ()=>onSubmit(),
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $d1f7eed652dc9cd5$export$2e2bcd8739ae039), {
                        nbVisite: listeVisite.length,
                        typePei: typePei,
                        listeAnomaliesAssignable: listeAnomaliesAssignable.data,
                        user: user
                    })
                })
            ]
        })
    });
};
const $1398c46fdaf43768$var$PointsAttentionAccordion = ({ listeVoletsAccordion: listeVoletsAccordion })=>{
    const { handleShowClose: handleShowClose, activesKeys: activesKeys } = (0, $db860d90b4a42fea$export$dae930a4ba30758b)(Array(listeVoletsAccordion.length).fill(false));
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db860d90b4a42fea$export$2e2bcd8739ae039), {
        list: listeVoletsAccordion,
        handleShowClose: handleShowClose,
        activesKeys: activesKeys
    });
};
const $1398c46fdaf43768$var$CreateVisiteButton = ({ onClick: onClick })=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$d776d19dfae66ece), {}),
            " Ajouter une visite"
        ]
    });
};
const $1398c46fdaf43768$var$ConsulterVisite = ({ peiIdCarte: peiIdCarte, activesKeys: activesKeys, handleShowClose: handleShowClose, currentVisite: currentVisite, typePei: typePei, listeVoletsAccordion: listeVoletsAccordion })=>{
    function formatDateTimeWithFallback(date) {
        try {
            return (0, $00c47c7740afd024$export$2e2bcd8739ae039)(date);
        } catch  {
            return (0, $00c47c7740afd024$export$1bea58d51b4f086c)(date);
        }
    }
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
        xs: peiIdCarte ? "12" : "7",
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("h3", {
                    children: "Consultation d'une visite "
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db860d90b4a42fea$export$2e2bcd8739ae039), {
                    activesKeys: activesKeys,
                    handleShowClose: handleShowClose,
                    list: [
                        {
                            header: "Informations g\xe9n\xe9rales",
                            content: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                                            children: [
                                                "Date et Heure :",
                                                " ",
                                                formatDateTimeWithFallback(currentVisite.visiteDate)
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                                            children: [
                                                "Type de visite : ",
                                                currentVisite.visiteTypeVisite
                                            ]
                                        }),
                                        typePei === (0, $f31f748b1c9fd0fb$export$2e2bcd8739ae039).PIBI && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Check, {
                                                type: "checkbox",
                                                disabled: true,
                                                checked: currentVisite.ctrlDebitPression != null,
                                                label: "Contr\xf4le d\xe9bit et pression (CDP)"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                            children: [
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                                    children: [
                                                        "Agent1 : ",
                                                        currentVisite.visiteAgent1
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                                    children: [
                                                        "Agent2 : ",
                                                        currentVisite.visiteAgent2
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        },
                        ...typePei === (0, $f31f748b1c9fd0fb$export$2e2bcd8739ae039).PIBI ? [
                            {
                                header: "Mesures",
                                content: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                                    children: [
                                        currentVisite.ctrlDebitPression != null && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                                                    children: [
                                                        "Pression statique (bar) :",
                                                        " ",
                                                        currentVisite.ctrlDebitPression.visiteCtrlDebitPressionPression
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                                                    children: [
                                                        "Pression dynamique au d\xe9bit nominal (bar) :",
                                                        " ",
                                                        currentVisite.ctrlDebitPression.visiteCtrlDebitPressionPressionDyn
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                                                    children: [
                                                        "D\xe9bit \xe0 1 bar (m\xb3/h) :",
                                                        " ",
                                                        currentVisite.ctrlDebitPression.visiteCtrlDebitPressionDebit
                                                    ]
                                                })
                                            ]
                                        }),
                                        currentVisite.ctrlDebitPression == null && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("p", {
                                            children: "Aucune mesure de d\xe9bit/pression n'a \xe9t\xe9 effectu\xe9e lors de cette visite"
                                        })
                                    ]
                                })
                            }
                        ] : [],
                        {
                            header: "Points d'attention",
                            content: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                children: listeVoletsAccordion.length > 0 ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($1398c46fdaf43768$var$PointsAttentionAccordion, {
                                    listeVoletsAccordion: listeVoletsAccordion
                                }) : /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("p", {
                                    children: "Aucune anomalie n'a \xe9t\xe9 retenue lors de cette visite"
                                })
                            })
                        },
                        {
                            header: "Observations",
                            content: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("p", {
                                children: currentVisite.visiteObservation
                            })
                        }
                    ]
                })
            ]
        })
    });
};












var $bkJfK = parcelRequire("bkJfK");


/**
 * @module ol/interaction/Modify
 */ 





















/**
 * The segment index assigned to a circle's center when
 * breaking up a circle into ModifySegmentDataType segments.
 * @type {number}
 */ const $2375ecf9b29b2a49$var$CIRCLE_CENTER_INDEX = 0;
/**
 * The segment index assigned to a circle's circumference when
 * breaking up a circle into ModifySegmentDataType segments.
 * @type {number}
 */ const $2375ecf9b29b2a49$var$CIRCLE_CIRCUMFERENCE_INDEX = 1;
const $2375ecf9b29b2a49$var$tempExtent = [
    0,
    0,
    0,
    0
];
const $2375ecf9b29b2a49$var$tempSegment = [];
/**
 * @enum {string}
 */ const $2375ecf9b29b2a49$var$ModifyEventType = {
    /**
   * Triggered upon feature modification start
   * @event ModifyEvent#modifystart
   * @api
   */ MODIFYSTART: 'modifystart',
    /**
   * Triggered upon feature modification end
   * @event ModifyEvent#modifyend
   * @api
   */ MODIFYEND: 'modifyend'
};
/**
 * @typedef {Object} SegmentData
 * @property {Array<number>} [depth] Depth.
 * @property {Feature} feature Feature.
 * @property {import("../geom/SimpleGeometry.js").default} geometry Geometry.
 * @property {number} [index] Index.
 * @property {Array<Array<number>>} segment Segment.
 * @property {Array<SegmentData>} [featureSegments] FeatureSegments.
 */ /**
 * A function that takes a {@link module:ol/Feature~Feature} and  returns `true` if
 * the feature may be modified or `false` otherwise.
 * @typedef {function(Feature):boolean} FilterFunction
 */ /**
 * @typedef {[SegmentData, number]} DragSegment
 */ /**
 * @typedef {Object} Options
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event will be considered to add or move a
 * vertex to the sketch. Default is
 * {@link module:ol/events/condition.primaryAction}.
 * @property {import("../events/condition.js").Condition} [deleteCondition] A function
 * that takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled. By default,
 * {@link module:ol/events/condition.singleClick} with
 * {@link module:ol/events/condition.altKeyOnly} results in a vertex deletion.
 * This combination is handled by wrapping the two condition checks in a single function:
 * ```js
 * import { altKeyOnly, singleClick } from 'ol/events/condition.js';
 *
 * function (event) {
 *   return altKeyOnly(event) && singleClick(event)
 * }
 * ```
 * @property {import("../events/condition.js").Condition} [insertVertexCondition] A
 * function that takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and
 * returns a boolean to indicate whether a new vertex should be added to the sketch
 * features. Default is {@link module:ol/events/condition.always}.
 * @property {number} [pixelTolerance=10] Pixel tolerance for considering the
 * pointer close enough to a segment or vertex for editing.
 * @property {import("../style/Style.js").StyleLike|import("../style/flat.js").FlatStyleLike} [style]
 * Style used for the modification point or vertex. For linestrings and polygons, this will
 * be the affected vertex, for circles a point along the circle, and for points the actual
 * point. If not configured, the default edit style is used (see {@link module:ol/style/Style~Style}).
 * When using a style function, the point feature passed to the function will have an `existing` property -
 * indicating whether there is an existing vertex underneath or not, a `features`
 * property - an array whose entries are the features that are being modified, and a `geometries`
 * property - an array whose entries are the geometries that are being modified. Both arrays are
 * in the same order. The `geometries` are only useful when modifying geometry collections, where
 * the geometry will be the particular geometry from the collection that is being modified.
 * @property {VectorSource} [source] The vector source with
 * features to modify.  If a vector source is not provided, a feature collection
 * must be provided with the `features` option.
 * @property {boolean|import("../layer/BaseVector").default} [hitDetection] When configured, point
 * features will be considered for modification based on their visual appearance, instead of being within
 * the `pixelTolerance` from the pointer location. When a {@link module:ol/layer/BaseVector~BaseVectorLayer} is
 * provided, only the rendered representation of the features on that layer will be considered.
 * @property {Collection<Feature>} [features]
 * The features the interaction works on.  If a feature collection is not
 * provided, a vector source must be provided with the `source` option.
 * @property {FilterFunction} [filter] A function that takes a {@link module:ol/Feature~Feature}
 * and returns `true` if the feature may be modified or `false` otherwise.
 * @property {boolean|import("../events/condition.js").Condition} [trace=false] Trace a portion of another geometry.
 * Tracing starts when two neighboring vertices are dragged onto a trace target, without any other modification in between..
 * @property {VectorSource} [traceSource] Source for features to trace.  If tracing is active and a `traceSource` is
 * not provided, the interaction's `source` will be used.  Tracing requires that the interaction is configured with
 * either a `traceSource` or a `source`.
 * @property {boolean} [wrapX=false] Wrap the world horizontally on the sketch
 * overlay.
 * @property {boolean} [snapToPointer=!hitDetection] The vertex, point or segment being modified snaps to the
 * pointer coordinate when clicked within the `pixelTolerance`.
 */ function $2375ecf9b29b2a49$var$getCoordinatesArray(coordinates, geometryType, depth) {
    let coordinatesArray;
    switch(geometryType){
        case 'LineString':
            coordinatesArray = coordinates;
            break;
        case 'MultiLineString':
        case 'Polygon':
            coordinatesArray = coordinates[depth[0]];
            break;
        case 'MultiPolygon':
            coordinatesArray = coordinates[depth[1]][depth[0]];
            break;
        default:
    }
    return coordinatesArray;
}
class $2375ecf9b29b2a49$export$eb2af8bb6aa1fb54 extends (0, $5c6b0a43c077a98f$export$2e2bcd8739ae039) {
    /**
   * @param {ModifyEventType} type Type.
   * @param {Collection<Feature>} features
   * The features modified.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent
   * Associated {@link module:ol/MapBrowserEvent~MapBrowserEvent}.
   */ constructor(type, features, mapBrowserEvent){
        super(type);
        /**
     * The features being modified.
     * @type {Collection<Feature>}
     * @api
     */ this.features = features;
        /**
     * Associated {@link module:ol/MapBrowserEvent~MapBrowserEvent}.
     * @type {import("../MapBrowserEvent.js").default}
     * @api
     */ this.mapBrowserEvent = mapBrowserEvent;
    }
}
/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types|
 *     'change:active', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<'modifyend'|'modifystart', ModifyEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types|
 *     'change:active'|'modifyend'|'modifystart', Return>} ModifyOnSignature
 */ /**
 * @classdesc
 * Interaction for modifying feature geometries.  To modify features that have
 * been added to an existing source, construct the modify interaction with the
 * `source` option.  If you want to modify features in a collection (for example,
 * the collection used by a select interaction), construct the interaction with
 * the `features` option.  The interaction must be constructed with either a
 * `source` or `features` option.
 *
 * Cartesian distance from the pointer is used to determine the features that
 * will be modified. This means that geometries will only be considered for
 * modification when they are within the configured `pixelTolerance`. For point
 * geometries, the `hitDetection` option can be used to match their visual
 * appearance.
 *
 * By default, the interaction will allow deletion of vertices when the `alt`
 * key is pressed.  To configure the interaction with a different condition
 * for deletion, use the `deleteCondition` option.
 * @fires ModifyEvent
 * @api
 */ class $2375ecf9b29b2a49$var$Modify extends (0, $21bd437a923ad8cf$export$2e2bcd8739ae039) {
    /**
   * @param {Options} options Options.
   */ constructor(options){
        super(/** @type {import("./Pointer.js").Options} */ options);
        //Maintain a ref to event handlers for later unregistering
        /** @private */ this.handleSourceAdd_ = this.handleSourceAdd_.bind(this);
        /** @private */ this.handleSourceRemove_ = this.handleSourceRemove_.bind(this);
        /** @private */ this.handleExternalCollectionAdd_ = this.handleExternalCollectionAdd_.bind(this);
        /** @private */ this.handleExternalCollectionRemove_ = this.handleExternalCollectionRemove_.bind(this);
        /** @private */ this.handleFeatureChange_ = this.handleFeatureChange_.bind(this);
        /***
     * @type {ModifyOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {ModifyOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {ModifyOnSignature<void>}
     */ this.un;
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.condition ? options.condition : (0, $638912a122b4daef$export$189f0d593022b199);
        /**
     * @private
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Browser event.
     * @return {boolean} Combined condition result.
     */ this.defaultDeleteCondition_ = function(mapBrowserEvent) {
            return (0, $638912a122b4daef$export$573409992e89967e)(mapBrowserEvent) && (0, $638912a122b4daef$export$194df8bad091b401)(mapBrowserEvent);
        };
        /**
     * @type {import("../events/condition.js").Condition}
     * @private
     */ this.deleteCondition_ = options.deleteCondition ? options.deleteCondition : this.defaultDeleteCondition_;
        /**
     * @type {import("../events/condition.js").Condition}
     * @private
     */ this.insertVertexCondition_ = options.insertVertexCondition ? options.insertVertexCondition : (0, $638912a122b4daef$export$ba9e5d519bc326ca);
        /**
     * Editing vertex.
     * @type {Feature<Point>}
     * @private
     */ this.vertexFeature_ = null;
        /**
     * Segments intersecting {@link this.vertexFeature_} by segment uid.
     * @type {Object<string, boolean>}
     * @private
     */ this.vertexSegments_ = null;
        /**
     * @type {import("../coordinate.js").Coordinate}
     * @private
     */ this.lastCoordinate_ = [
            0,
            0
        ];
        /**
     * Tracks if the next `singleclick` event should be ignored to prevent
     * accidental deletion right after vertex creation.
     * @type {boolean}
     * @private
     */ this.ignoreNextSingleClick_ = false;
        /**
     * @type {Collection<Feature>}
     * @private
     */ this.featuresBeingModified_ = null;
        /**
     * Segment RTree for each layer
     * @type {RBush<SegmentData>}
     * @private
     */ this.rBush_ = new (0, $5d9bfc7868d1dd0e$export$2e2bcd8739ae039)();
        /**
     * @type {number}
     * @private
     */ this.pixelTolerance_ = options.pixelTolerance !== undefined ? options.pixelTolerance : 10;
        /**
     * @type {boolean}
     * @private
     */ this.snappedToVertex_ = false;
        /**
     * Indicate whether the interaction is currently changing a feature's
     * coordinates.
     * @type {boolean}
     * @private
     */ this.changingFeature_ = false;
        /**
     * @type {Array<DragSegment>}
     * @private
     */ this.dragSegments_ = [];
        /**
     * Draw overlay where sketch features are drawn.
     * @type {VectorLayer}
     * @private
     */ this.overlay_ = new (0, $082a79ecb622f84a$export$2e2bcd8739ae039)({
            source: new (0, $1020e4d07ddbfab1$export$2e2bcd8739ae039)({
                useSpatialIndex: false,
                wrapX: !!options.wrapX
            }),
            style: options.style ? options.style : $2375ecf9b29b2a49$var$getDefaultStyleFunction(),
            updateWhileAnimating: true,
            updateWhileInteracting: true
        });
        /**
     * @const
     * @private
     * @type {!Object<string, function(Feature, import("../geom/Geometry.js").default): void>}
     */ this.SEGMENT_WRITERS_ = {
            Point: this.writePointGeometry_.bind(this),
            LineString: this.writeLineStringGeometry_.bind(this),
            LinearRing: this.writeLineStringGeometry_.bind(this),
            Polygon: this.writePolygonGeometry_.bind(this),
            MultiPoint: this.writeMultiPointGeometry_.bind(this),
            MultiLineString: this.writeMultiLineStringGeometry_.bind(this),
            MultiPolygon: this.writeMultiPolygonGeometry_.bind(this),
            Circle: this.writeCircleGeometry_.bind(this),
            GeometryCollection: this.writeGeometryCollectionGeometry_.bind(this)
        };
        /**
     * @type {VectorSource}
     * @private
     */ this.source_ = null;
        /**
     * @type {VectorSource|null}
     * @private
     */ this.traceSource_ = options.traceSource || options.source || null;
        /**
     * @type {import("../events/condition.js").Condition}
     * @private
     */ this.traceCondition_;
        this.setTrace(options.trace || false);
        /**
     * @type {import('./tracing.js').TraceState}
     * @private
     */ this.traceState_ = {
            active: false
        };
        /**
     * @type {Array<DragSegment>|null}
     * @private
     */ this.traceSegments_ = null;
        /**
     * @type {boolean|import("../layer/BaseVector").default}
     * @private
     */ this.hitDetection_ = null;
        /**
     * Useful for performance optimization
     * @private
     * @type boolean
     */ this.filterFunctionWasSupplied_ = options.filter != undefined ? true : false;
        /**
     * @private
     * @type {FilterFunction}
     */ this.filter_ = options.filter ? options.filter : ()=>true;
        if (!(options.features || options.source)) throw new Error('The modify interaction requires features collection or a source');
        /** @type {Array<Feature>} */ let features;
        if (options.features) {
            features = options.features.getArray();
            //setup listeners on external features collection and features
            options.features.addEventListener((0, $ea71ddfe3b669b23$export$2e2bcd8739ae039).ADD, this.handleExternalCollectionAdd_);
            options.features.addEventListener((0, $ea71ddfe3b669b23$export$2e2bcd8739ae039).REMOVE, this.handleExternalCollectionRemove_);
            //keep ref for unsubscribe on dispose
            this.featuresCollection_ = options.features;
        } else if (options.source) {
            features = options.source.getFeatures();
            //setup listeners on external source and features
            options.source.addEventListener((0, $73c4cd82312d5027$export$2e2bcd8739ae039).ADDFEATURE, this.handleSourceAdd_);
            options.source.addEventListener((0, $73c4cd82312d5027$export$2e2bcd8739ae039).REMOVEFEATURE, this.handleSourceRemove_);
            //keep ref for unsubscribe on dispose
            this.source_ = options.source;
        }
        features.forEach((feature)=>{
            //any modification to the feature requires filter to be re-run
            feature.addEventListener((0, $b5fa963342da4935$export$2e2bcd8739ae039).CHANGE, this.handleFeatureChange_);
            //prop change handler is only to re-run the filter
            if (this.filterFunctionWasSupplied_) feature.addEventListener((0, $ff212aeaa481a85e$export$2e2bcd8739ae039).PROPERTYCHANGE, this.handleFeatureChange_);
        });
        if (options.hitDetection) this.hitDetection_ = options.hitDetection;
        /**
     * Internal features array.  When adding or removing features, be sure to use
     * addFeature_()/removeFeature_() so that the the segment index is adjusted.
     * @type {Array<Feature>}
     * @private
     */ this.features_ = [];
        features.filter(this.filter_).forEach((feature)=>this.addFeature_(feature));
        /**
     * @type {import("../MapBrowserEvent.js").default}
     * @private
     */ this.lastPointerEvent_ = null;
        /**
     * Delta (x, y in map units) between matched rtree vertex and pointer vertex.
     * @type {Array<number>}
     * @private
     */ this.delta_ = [
            0,
            0
        ];
        /**
     * @private
     */ this.snapToPointer_ = options.snapToPointer === undefined ? !this.hitDetection_ : options.snapToPointer;
    }
    /**
   * Toggle tracing mode or set a tracing condition.
   *
   * @param {boolean|import("../events/condition.js").Condition} trace A boolean to toggle tracing mode or an event
   *     condition that will be checked when a feature is clicked to determine if tracing should be active.
   */ setTrace(trace) {
        let condition;
        if (!trace) condition = (0, $638912a122b4daef$export$b3e22bcfd64c1022);
        else if (trace === true) condition = (0, $638912a122b4daef$export$ba9e5d519bc326ca);
        else condition = trace;
        this.traceCondition_ = condition;
    }
    /**
   * Called when a feature is added to the internal features collection
   * @param {Feature} feature Feature.
   * @private
   */ addFeature_(feature) {
        this.features_.push(feature);
        const geometry = feature.getGeometry();
        if (geometry) {
            const writer = this.SEGMENT_WRITERS_[geometry.getType()];
            if (writer) writer(feature, geometry);
        }
        const map = this.getMap();
        if (map && map.isRendered() && this.getActive()) this.handlePointerAtPixel_(this.lastCoordinate_);
    }
    /**
   * @param {import("../MapBrowserEvent.js").default} evt Map browser event.
   * @param {Array<SegmentData>} segments The segments subject to modification.
   * @private
   */ willModifyFeatures_(evt, segments) {
        if (!this.featuresBeingModified_) {
            this.featuresBeingModified_ = new (0, $e1f99232eb9bff27$export$2e2bcd8739ae039)();
            const features = this.featuresBeingModified_.getArray();
            for(let i = 0, ii = segments.length; i < ii; ++i){
                const feature = segments[i].feature;
                if (feature && !features.includes(feature)) this.featuresBeingModified_.push(feature);
            }
            if (this.featuresBeingModified_.getLength() === 0) this.featuresBeingModified_ = null;
            else this.dispatchEvent(new $2375ecf9b29b2a49$export$eb2af8bb6aa1fb54($2375ecf9b29b2a49$var$ModifyEventType.MODIFYSTART, this.featuresBeingModified_, evt));
        }
    }
    /**
   * Removes a feature from the internal features collection and updates internal state
   * accordingly.
   * @param {Feature} feature Feature.
   * @private
   */ removeFeature_(feature) {
        const itemIndex = this.features_.indexOf(feature);
        this.features_.splice(itemIndex, 1);
        this.removeFeatureSegmentData_(feature);
        // Remove the vertex feature if the collection of candidate features is empty.
        if (this.vertexFeature_ && this.features_.length === 0) {
            this.overlay_.getSource().removeFeature(this.vertexFeature_);
            this.vertexFeature_ = null;
        }
    }
    /**
   * @param {Feature} feature Feature.
   * @private
   */ removeFeatureSegmentData_(feature) {
        const rBush = this.rBush_;
        /** @type {Array<SegmentData>} */ const nodesToRemove = [];
        rBush.forEach(/**
       * @param {SegmentData} node RTree node.
       */ function(node) {
            if (feature === node.feature) nodesToRemove.push(node);
        });
        for(let i = nodesToRemove.length - 1; i >= 0; --i){
            const nodeToRemove = nodesToRemove[i];
            for(let j = this.dragSegments_.length - 1; j >= 0; --j)if (this.dragSegments_[j][0] === nodeToRemove) this.dragSegments_.splice(j, 1);
            rBush.remove(nodeToRemove);
        }
    }
    /**
   * Activate or deactivate the interaction.
   * @param {boolean} active Active.
   * @observable
   * @api
   * @override
   */ setActive(active) {
        if (this.vertexFeature_ && !active) {
            this.overlay_.getSource().removeFeature(this.vertexFeature_);
            this.vertexFeature_ = null;
        }
        super.setActive(active);
    }
    /**
   * Remove the interaction from its current map and attach it to the new map.
   * Subclasses may set up event handlers to get notified about changes to
   * the map here.
   * @param {import("../Map.js").default} map Map.
   * @override
   */ setMap(map) {
        this.overlay_.setMap(map);
        super.setMap(map);
    }
    /**
   * Get the overlay layer that this interaction renders the modification point or vertex to.
   * @return {VectorLayer} Overlay layer.
   * @api
   */ getOverlay() {
        return this.overlay_;
    }
    /**
   * @param {import("../source/Vector.js").VectorSourceEvent} event Event.
   * @private
   */ handleSourceAdd_(event) {
        const feature = event.feature;
        if (feature) this.externalAddFeatureHandler_(feature);
    }
    /**
   * @param {import("../source/Vector.js").VectorSourceEvent} event Event.
   * @private
   */ handleSourceRemove_(event) {
        const feature = event.feature;
        if (feature) this.externalRemoveFeatureHandler_(feature);
    }
    /**
   * @param {import("../Collection.js").CollectionEvent} event Event.
   * @private
   */ handleExternalCollectionAdd_(event) {
        const feature = event.element;
        if (feature) this.externalAddFeatureHandler_(feature);
    }
    /**
   * @param {import("../Collection.js").CollectionEvent} event Event.
   * @private
   */ handleExternalCollectionRemove_(event) {
        const feature = event.element;
        if (feature) this.externalRemoveFeatureHandler_(feature);
    }
    /**
   * Common handler for event signaling addition of feature to the supplied features source
   * or collection.
   * @param {Feature} feature Feature.
   */ externalAddFeatureHandler_(feature) {
        feature.addEventListener((0, $b5fa963342da4935$export$2e2bcd8739ae039).CHANGE, this.handleFeatureChange_);
        //prop change handler is only for reapplying the filter
        if (this.filterFunctionWasSupplied_) feature.addEventListener((0, $ff212aeaa481a85e$export$2e2bcd8739ae039).PROPERTYCHANGE, this.handleFeatureChange_);
        if (this.filter_(feature)) this.addFeature_(feature);
    }
    /**
   * Common handler for event signaling removal of feature from the supplied features source
   * or collection.
   * @param {Feature} feature Feature.
   */ externalRemoveFeatureHandler_(feature) {
        feature.removeEventListener((0, $b5fa963342da4935$export$2e2bcd8739ae039).CHANGE, this.handleFeatureChange_);
        if (this.filterFunctionWasSupplied_) feature.removeEventListener((0, $ff212aeaa481a85e$export$2e2bcd8739ae039).PROPERTYCHANGE, this.handleFeatureChange_);
        this.removeFeature_(feature);
    }
    /**
   * Listener for features in external source or features collection.  Ensures the feature filter
   * is re-run and segment data is updated.
   * @param {import("../events/Event.js").default | import("../Object").ObjectEvent} evt Event.
   * @private
   */ handleFeatureChange_(evt) {
        if (!this.changingFeature_) {
            const feature = /** @type {Feature} */ evt.target;
            this.removeFeature_(feature);
            //safe to remove handler on a feature if there isn't one, but need to apply the filter
            // before adding the feature.
            this.filter_(feature) && this.addFeature_(feature);
        }
    }
    /**
   * @param {Feature} feature Feature
   * @param {Point} geometry Geometry.
   * @private
   */ writePointGeometry_(feature, geometry) {
        const coordinates = geometry.getCoordinates();
        /** @type {SegmentData} */ const segmentData = {
            feature: feature,
            geometry: geometry,
            segment: [
                coordinates,
                coordinates
            ]
        };
        this.rBush_.insert(geometry.getExtent(), segmentData);
    }
    /**
   * @param {Feature} feature Feature
   * @param {import("../geom/MultiPoint.js").default} geometry Geometry.
   * @private
   */ writeMultiPointGeometry_(feature, geometry) {
        const points = geometry.getCoordinates();
        for(let i = 0, ii = points.length; i < ii; ++i){
            const coordinates = points[i];
            /** @type {SegmentData} */ const segmentData = {
                feature: feature,
                geometry: geometry,
                depth: [
                    i
                ],
                index: i,
                segment: [
                    coordinates,
                    coordinates
                ]
            };
            this.rBush_.insert(geometry.getExtent(), segmentData);
        }
    }
    /**
   * @param {Feature} feature Feature
   * @param {import("../geom/LineString.js").default} geometry Geometry.
   * @private
   */ writeLineStringGeometry_(feature, geometry) {
        const coordinates = geometry.getCoordinates();
        for(let i = 0, ii = coordinates.length - 1; i < ii; ++i){
            const segment = coordinates.slice(i, i + 2);
            /** @type {SegmentData} */ const segmentData = {
                feature: feature,
                geometry: geometry,
                index: i,
                segment: segment
            };
            this.rBush_.insert((0, $dea65c2f666fa450$export$8aceca7c77505534)(segment), segmentData);
        }
    }
    /**
   * @param {Feature} feature Feature
   * @param {import("../geom/MultiLineString.js").default} geometry Geometry.
   * @private
   */ writeMultiLineStringGeometry_(feature, geometry) {
        const lines = geometry.getCoordinates();
        for(let j = 0, jj = lines.length; j < jj; ++j){
            const coordinates = lines[j];
            for(let i = 0, ii = coordinates.length - 1; i < ii; ++i){
                const segment = coordinates.slice(i, i + 2);
                /** @type {SegmentData} */ const segmentData = {
                    feature: feature,
                    geometry: geometry,
                    depth: [
                        j
                    ],
                    index: i,
                    segment: segment
                };
                this.rBush_.insert((0, $dea65c2f666fa450$export$8aceca7c77505534)(segment), segmentData);
            }
        }
    }
    /**
   * @param {Feature} feature Feature
   * @param {import("../geom/Polygon.js").default} geometry Geometry.
   * @private
   */ writePolygonGeometry_(feature, geometry) {
        const rings = geometry.getCoordinates();
        for(let j = 0, jj = rings.length; j < jj; ++j){
            const coordinates = rings[j];
            for(let i = 0, ii = coordinates.length - 1; i < ii; ++i){
                const segment = coordinates.slice(i, i + 2);
                /** @type {SegmentData} */ const segmentData = {
                    feature: feature,
                    geometry: geometry,
                    depth: [
                        j
                    ],
                    index: i,
                    segment: segment
                };
                this.rBush_.insert((0, $dea65c2f666fa450$export$8aceca7c77505534)(segment), segmentData);
            }
        }
    }
    /**
   * @param {Feature} feature Feature
   * @param {import("../geom/MultiPolygon.js").default} geometry Geometry.
   * @private
   */ writeMultiPolygonGeometry_(feature, geometry) {
        const polygons = geometry.getCoordinates();
        for(let k = 0, kk = polygons.length; k < kk; ++k){
            const rings = polygons[k];
            for(let j = 0, jj = rings.length; j < jj; ++j){
                const coordinates = rings[j];
                for(let i = 0, ii = coordinates.length - 1; i < ii; ++i){
                    const segment = coordinates.slice(i, i + 2);
                    /** @type {SegmentData} */ const segmentData = {
                        feature: feature,
                        geometry: geometry,
                        depth: [
                            j,
                            k
                        ],
                        index: i,
                        segment: segment
                    };
                    this.rBush_.insert((0, $dea65c2f666fa450$export$8aceca7c77505534)(segment), segmentData);
                }
            }
        }
    }
    /**
   * We convert a circle into two segments.  The segment at index
   * {@link CIRCLE_CENTER_INDEX} is the
   * circle's center (a point).  The segment at index
   * {@link CIRCLE_CIRCUMFERENCE_INDEX} is
   * the circumference, and is not a line segment.
   *
   * @param {Feature} feature Feature.
   * @param {import("../geom/Circle.js").default} geometry Geometry.
   * @private
   */ writeCircleGeometry_(feature, geometry) {
        const coordinates = geometry.getCenter();
        /** @type {SegmentData} */ const centerSegmentData = {
            feature: feature,
            geometry: geometry,
            index: $2375ecf9b29b2a49$var$CIRCLE_CENTER_INDEX,
            segment: [
                coordinates,
                coordinates
            ]
        };
        /** @type {SegmentData} */ const circumferenceSegmentData = {
            feature: feature,
            geometry: geometry,
            index: $2375ecf9b29b2a49$var$CIRCLE_CIRCUMFERENCE_INDEX,
            segment: [
                coordinates,
                coordinates
            ]
        };
        const featureSegments = [
            centerSegmentData,
            circumferenceSegmentData
        ];
        centerSegmentData.featureSegments = featureSegments;
        circumferenceSegmentData.featureSegments = featureSegments;
        this.rBush_.insert((0, $dea65c2f666fa450$export$4838bf78d04a9440)(coordinates), centerSegmentData);
        let circleGeometry = /** @type {import("../geom/Geometry.js").default} */ geometry;
        const userProjection = (0, $a86eee1c28205a05$export$3973b77d5f6f2790)();
        if (userProjection && this.getMap()) {
            const projection = this.getMap().getView().getProjection();
            circleGeometry = circleGeometry.clone().transform(userProjection, projection);
            circleGeometry = (0, $52cb54ac72de6b07$export$2451009d645fb8c2)(/** @type {import("../geom/Circle.js").default} */ circleGeometry).transform(projection, userProjection);
        }
        this.rBush_.insert(circleGeometry.getExtent(), circumferenceSegmentData);
    }
    /**
   * @param {Feature} feature Feature
   * @param {import("../geom/GeometryCollection.js").default} geometry Geometry.
   * @private
   */ writeGeometryCollectionGeometry_(feature, geometry) {
        const geometries = geometry.getGeometriesArray();
        for(let i = 0; i < geometries.length; ++i){
            const geometry = geometries[i];
            const writer = this.SEGMENT_WRITERS_[geometry.getType()];
            writer(feature, geometry);
        }
    }
    /**
   * @param {import("../coordinate.js").Coordinate} coordinates Coordinates.
   * @param {Array<Feature>} features The features being modified.
   * @param {Array<import("../geom/SimpleGeometry.js").default>} geometries The geometries being modified.
   * @param {boolean} existing The vertex represents an existing vertex.
   * @return {Feature} Vertex feature.
   * @private
   */ createOrUpdateVertexFeature_(coordinates, features, geometries, existing) {
        let vertexFeature = this.vertexFeature_;
        if (!vertexFeature) {
            vertexFeature = new (0, $df26d2327ced1fa9$export$2e2bcd8739ae039)(new (0, $3153df5f3993c8ca$export$2e2bcd8739ae039)(coordinates));
            this.vertexFeature_ = vertexFeature;
            this.overlay_.getSource().addFeature(vertexFeature);
        } else {
            const geometry = vertexFeature.getGeometry();
            geometry.setCoordinates(coordinates);
        }
        vertexFeature.set('features', features);
        vertexFeature.set('geometries', geometries);
        vertexFeature.set('existing', existing);
        return vertexFeature;
    }
    /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} and may modify the geometry.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @override
   */ handleEvent(mapBrowserEvent) {
        if (!mapBrowserEvent.originalEvent) return true;
        this.lastPointerEvent_ = mapBrowserEvent;
        let handled;
        if (!mapBrowserEvent.map.getView().getInteracting() && mapBrowserEvent.type == (0, $1b4cb51f4587f284$export$2e2bcd8739ae039).POINTERMOVE && !this.handlingDownUpSequence) this.handlePointerMove_(mapBrowserEvent);
        if (this.vertexFeature_ && this.deleteCondition_(mapBrowserEvent)) {
            if (mapBrowserEvent.type != (0, $1b4cb51f4587f284$export$2e2bcd8739ae039).SINGLECLICK || !this.ignoreNextSingleClick_) handled = this.removePoint();
            else handled = true;
        }
        if (mapBrowserEvent.type == (0, $1b4cb51f4587f284$export$2e2bcd8739ae039).SINGLECLICK) this.ignoreNextSingleClick_ = false;
        return super.handleEvent(mapBrowserEvent) && !handled;
    }
    /**
   * @param {import("../coordinate.js").Coordinate} pixelCoordinate Pixel coordinate.
   * @return {Array<SegmentData>|undefined} Insert vertices and update drag segments.
   * @private
   */ findInsertVerticesAndUpdateDragSegments_(pixelCoordinate) {
        this.handlePointerAtPixel_(pixelCoordinate);
        this.dragSegments_.length = 0;
        this.featuresBeingModified_ = null;
        const vertexFeature = this.vertexFeature_;
        if (!vertexFeature) return;
        const projection = this.getMap().getView().getProjection();
        /** @type {Array<SegmentData>} */ const insertVertices = [];
        const vertex = this.vertexFeature_.getGeometry().getCoordinates();
        const vertexExtent = (0, $dea65c2f666fa450$export$8aceca7c77505534)([
            vertex
        ]);
        const segmentDataMatches = this.rBush_.getInExtent(vertexExtent);
        const componentSegments = {};
        segmentDataMatches.sort($2375ecf9b29b2a49$var$compareIndexes);
        for(let i = 0, ii = segmentDataMatches.length; i < ii; ++i){
            const segmentDataMatch = segmentDataMatches[i];
            const segment = segmentDataMatch.segment;
            let uid = (0, $fd76d391cc228565$export$5e82334337e0f204)(segmentDataMatch.geometry);
            const depth = segmentDataMatch.depth;
            if (depth) uid += '-' + depth.join('-'); // separate feature components
            if (!componentSegments[uid]) componentSegments[uid] = new Array(2);
            if (segmentDataMatch.geometry.getType() === 'Circle' && segmentDataMatch.index === $2375ecf9b29b2a49$var$CIRCLE_CIRCUMFERENCE_INDEX) {
                const closestVertex = $2375ecf9b29b2a49$var$closestOnSegmentData(pixelCoordinate, segmentDataMatch, projection);
                if ((0, $a6adb03fd2fbc071$export$e9bab7fafb253603)(closestVertex, vertex) && !componentSegments[uid][0]) {
                    this.dragSegments_.push([
                        segmentDataMatch,
                        0
                    ]);
                    componentSegments[uid][0] = segmentDataMatch;
                }
                continue;
            }
            if ((0, $a6adb03fd2fbc071$export$e9bab7fafb253603)(segment[0], vertex) && !componentSegments[uid][0]) {
                this.dragSegments_.push([
                    segmentDataMatch,
                    0
                ]);
                componentSegments[uid][0] = segmentDataMatch;
                continue;
            }
            if ((0, $a6adb03fd2fbc071$export$e9bab7fafb253603)(segment[1], vertex) && !componentSegments[uid][1]) {
                if (componentSegments[uid][0] && componentSegments[uid][0].index === 0) {
                    let coordinates = segmentDataMatch.geometry.getCoordinates();
                    switch(segmentDataMatch.geometry.getType()){
                        // prevent dragging closed linestrings by the connecting node
                        case 'LineString':
                        case 'MultiLineString':
                            continue;
                        // if dragging the first vertex of a polygon, ensure the other segment
                        // belongs to the closing vertex of the linear ring
                        case 'MultiPolygon':
                            coordinates = coordinates[depth[1]];
                        /* falls through */ case 'Polygon':
                            if (segmentDataMatch.index !== coordinates[depth[0]].length - 2) continue;
                            break;
                        default:
                    }
                }
                this.dragSegments_.push([
                    segmentDataMatch,
                    1
                ]);
                componentSegments[uid][1] = segmentDataMatch;
                continue;
            }
            if ((0, $fd76d391cc228565$export$5e82334337e0f204)(segment) in this.vertexSegments_ && !componentSegments[uid][0] && !componentSegments[uid][1]) insertVertices.push(segmentDataMatch);
        }
        return insertVertices;
    }
    /**
   * @private
   */ deactivateTrace_() {
        this.traceState_ = {
            active: false
        };
    }
    /**
   * Update the trace.
   * @param {import("../MapBrowserEvent.js").default} event Event.
   * @private
   */ updateTrace_(event) {
        const traceState = this.traceState_;
        if (!traceState.active) return;
        if (traceState.targetIndex === -1) {
            // check if we are ready to pick a target
            const startPx = event.map.getPixelFromCoordinate(traceState.startCoord);
            if ((0, $a6adb03fd2fbc071$export$9f17032d917177de)(startPx, event.pixel) < this.pixelTolerance_) return;
        }
        const updatedTraceTarget = (0, $0a2478def9b60c71$export$4a6978e1933d7fa)(event.coordinate, traceState, event.map, this.pixelTolerance_);
        if (traceState.targetIndex === -1 && Math.sqrt(updatedTraceTarget.closestTargetDistance) / event.map.getView().getResolution() > this.pixelTolerance_) return;
        if (traceState.targetIndex !== updatedTraceTarget.index) {
            // target changed
            if (traceState.targetIndex !== -1) {
                // remove points added during previous trace
                const oldTarget = traceState.targets[traceState.targetIndex];
                this.removeTracedCoordinates_(oldTarget.startIndex, oldTarget.endIndex);
            } else for (const traceSegment of this.traceSegments_){
                const segmentData = traceSegment[0];
                const geometry = segmentData.geometry;
                const index = traceSegment[1];
                const coordinates = geometry.getCoordinates();
                const coordinatesArray = $2375ecf9b29b2a49$var$getCoordinatesArray(coordinates, geometry.getType(), segmentData.depth);
                coordinatesArray.splice(segmentData.index + index, 1);
                geometry.setCoordinates(coordinates);
                if (index === 0) segmentData.index -= 1;
            }
            // add points for the new target
            const newTarget = traceState.targets[updatedTraceTarget.index];
            this.addTracedCoordinates_(newTarget, newTarget.startIndex, updatedTraceTarget.endIndex);
        } else {
            // target stayed the same
            const target = traceState.targets[traceState.targetIndex];
            this.addOrRemoveTracedCoordinates_(target, updatedTraceTarget.endIndex);
        }
        // modify the state with updated info
        traceState.targetIndex = updatedTraceTarget.index;
        const target = traceState.targets[traceState.targetIndex];
        target.endIndex = updatedTraceTarget.endIndex;
    }
    getTraceCandidates_(event) {
        const map = this.getMap();
        const tolerance = this.pixelTolerance_;
        const lowerLeft = map.getCoordinateFromPixel([
            event.pixel[0] - tolerance,
            event.pixel[1] + tolerance
        ]);
        const upperRight = map.getCoordinateFromPixel([
            event.pixel[0] + tolerance,
            event.pixel[1] - tolerance
        ]);
        const extent = (0, $dea65c2f666fa450$export$8aceca7c77505534)([
            lowerLeft,
            upperRight
        ]);
        const features = this.traceSource_.getFeaturesInExtent(extent);
        return features;
    }
    /**
   * Activate or deactivate trace state based on a browser event.
   * @param {import("../MapBrowserEvent.js").default} event Event.
   * @private
   */ toggleTraceState_(event) {
        if (!this.traceSource_ || !this.traceCondition_(event)) return;
        if (this.traceState_.active) {
            this.deactivateTrace_();
            this.traceSegments_ = null;
            return;
        }
        const features = this.getTraceCandidates_(event);
        if (features.length === 0) return;
        const targets = (0, $0a2478def9b60c71$export$8b36095f6110ee8f)(event.coordinate, features);
        if (targets.length) this.traceState_ = {
            active: true,
            startCoord: event.coordinate.slice(),
            targets: targets,
            targetIndex: -1
        };
    }
    /**
   * @param {import('./tracing.js').TraceTarget} target The trace target.
   * @param {number} endIndex The new end index of the trace.
   * @private
   */ addOrRemoveTracedCoordinates_(target, endIndex) {
        // three cases to handle:
        //  1. traced in the same direction and points need adding
        //  2. traced in the same direction and points need removing
        //  3. traced in a new direction
        const previouslyForward = target.startIndex <= target.endIndex;
        const currentlyForward = target.startIndex <= endIndex;
        if (previouslyForward === currentlyForward) {
            // same direction
            if (previouslyForward && endIndex > target.endIndex || !previouslyForward && endIndex < target.endIndex) // case 1 - add new points
            this.addTracedCoordinates_(target, target.endIndex, endIndex);
            else if (previouslyForward && endIndex < target.endIndex || !previouslyForward && endIndex > target.endIndex) // case 2 - remove old points
            this.removeTracedCoordinates_(endIndex, target.endIndex);
        } else {
            // case 3 - remove old points, add new points
            this.removeTracedCoordinates_(target.startIndex, target.endIndex);
            this.addTracedCoordinates_(target, target.startIndex, endIndex);
        }
    }
    /**
   * @param {number} fromIndex The start index.
   * @param {number} toIndex The end index.
   * @private
   */ removeTracedCoordinates_(fromIndex, toIndex) {
        if (fromIndex === toIndex) return;
        let remove = 0;
        if (fromIndex < toIndex) {
            const start = Math.ceil(fromIndex);
            let end = Math.floor(toIndex);
            if (end === toIndex) end -= 1;
            remove = end - start + 1;
        } else {
            const start = Math.floor(fromIndex);
            let end = Math.ceil(toIndex);
            if (end === toIndex) end += 1;
            remove = start - end + 1;
        }
        if (remove > 0) for (const traceSegment of this.traceSegments_){
            const segmentData = traceSegment[0];
            const geometry = segmentData.geometry;
            const index = traceSegment[1];
            let removeIndex = traceSegment[0].index + 1;
            if (index === 1) removeIndex -= remove;
            const coordinates = geometry.getCoordinates();
            const coordinatesArray = $2375ecf9b29b2a49$var$getCoordinatesArray(coordinates, geometry.getType(), segmentData.depth);
            coordinatesArray.splice(removeIndex, remove);
            geometry.setCoordinates(coordinates);
            if (index === 1) segmentData.index -= remove;
        }
    }
    /**
   * @param {import('./tracing.js').TraceTarget} target The trace target.
   * @param {number} fromIndex The start index.
   * @param {number} toIndex The end index.
   * @private
   */ addTracedCoordinates_(target, fromIndex, toIndex) {
        if (fromIndex === toIndex) return;
        const newCoordinates = [];
        if (fromIndex < toIndex) {
            // forward trace
            const start = Math.ceil(fromIndex);
            let end = Math.floor(toIndex);
            if (end === toIndex) // if end is snapped to a vertex, it will be added later
            end -= 1;
            for(let i = start; i <= end; ++i)newCoordinates.push((0, $0a2478def9b60c71$export$2028164776634ba)(target.coordinates, i));
        } else {
            // reverse trace
            const start = Math.floor(fromIndex);
            let end = Math.ceil(toIndex);
            if (end === toIndex) end += 1;
            for(let i = start; i >= end; --i)newCoordinates.push((0, $0a2478def9b60c71$export$2028164776634ba)(target.coordinates, i));
        }
        if (newCoordinates.length) for (const traceSegment of this.traceSegments_){
            const segmentData = traceSegment[0];
            const geometry = segmentData.geometry;
            const index = traceSegment[1];
            const insertIndex = segmentData.index + 1;
            if (index === 0) newCoordinates.reverse();
            const coordinates = geometry.getCoordinates();
            const coordinatesArray = $2375ecf9b29b2a49$var$getCoordinatesArray(coordinates, geometry.getType(), segmentData.depth);
            coordinatesArray.splice(insertIndex, 0, ...newCoordinates);
            geometry.setCoordinates(coordinates);
            if (index === 1) segmentData.index += newCoordinates.length;
        }
    }
    /**
   * @param {import('../coordinate.js').Coordinate} vertex Vertex.
   * @param {DragSegment} dragSegment Drag segment.
   */ updateGeometry_(vertex, dragSegment) {
        const segmentData = dragSegment[0];
        const depth = segmentData.depth;
        let coordinates;
        const segment = segmentData.segment;
        const geometry = segmentData.geometry;
        const index = dragSegment[1];
        while(vertex.length < geometry.getStride())vertex.push(segment[index][vertex.length]);
        switch(geometry.getType()){
            case 'Point':
                coordinates = vertex;
                segment[0] = vertex;
                segment[1] = vertex;
                break;
            case 'MultiPoint':
                coordinates = geometry.getCoordinates();
                coordinates[segmentData.index] = vertex;
                segment[0] = vertex;
                segment[1] = vertex;
                break;
            case 'LineString':
                coordinates = geometry.getCoordinates();
                coordinates[segmentData.index + index] = vertex;
                segment[index] = vertex;
                break;
            case 'MultiLineString':
                coordinates = geometry.getCoordinates();
                coordinates[depth[0]][segmentData.index + index] = vertex;
                segment[index] = vertex;
                break;
            case 'Polygon':
                {
                    coordinates = geometry.getCoordinates();
                    const ring = coordinates[depth[0]];
                    const targetIndex = segmentData.index + index;
                    // Prevent duplicate change events when vertex already at position
                    if (ring[targetIndex][0] === vertex[0] && ring[targetIndex][1] === vertex[1]) coordinates = null;
                    else {
                        ring[targetIndex] = vertex;
                        if (targetIndex === 0) ring[ring.length - 1] = vertex;
                        else if (targetIndex === ring.length - 1) ring[0] = vertex;
                    }
                    segment[index] = vertex;
                    break;
                }
            case 'MultiPolygon':
                {
                    coordinates = geometry.getCoordinates();
                    const mRing = coordinates[depth[1]][depth[0]];
                    const mTargetIndex = segmentData.index + index;
                    // Prevent duplicate change events when vertex already at position
                    if (mRing[mTargetIndex][0] === vertex[0] && mRing[mTargetIndex][1] === vertex[1]) coordinates = null;
                    else {
                        mRing[mTargetIndex] = vertex;
                        if (mTargetIndex === 0) mRing[mRing.length - 1] = vertex;
                        else if (mTargetIndex === mRing.length - 1) mRing[0] = vertex;
                    }
                    segment[index] = vertex;
                    break;
                }
            case 'Circle':
                const circle = /** @type {import("../geom/Circle.js").default} */ geometry;
                segment[0] = vertex;
                segment[1] = vertex;
                if (segmentData.index === $2375ecf9b29b2a49$var$CIRCLE_CENTER_INDEX) {
                    this.changingFeature_ = true;
                    circle.setCenter(vertex);
                    this.changingFeature_ = false;
                } else {
                    // We're dragging the circle's circumference:
                    this.changingFeature_ = true;
                    const projection = this.getMap().getView().getProjection();
                    let radius = (0, $a6adb03fd2fbc071$export$9f17032d917177de)((0, $a86eee1c28205a05$export$d4b8ec0b96db1ee2)(circle.getCenter(), projection), (0, $a86eee1c28205a05$export$d4b8ec0b96db1ee2)(vertex, projection));
                    const userProjection = (0, $a86eee1c28205a05$export$3973b77d5f6f2790)();
                    if (userProjection) {
                        const circleGeometry = circle.clone().transform(userProjection, projection);
                        circleGeometry.setRadius(radius);
                        radius = circleGeometry.transform(projection, userProjection).getRadius();
                    }
                    circle.setRadius(radius);
                    this.changingFeature_ = false;
                }
                break;
            default:
        }
        if (coordinates) this.setGeometryCoordinates_(geometry, coordinates);
    }
    /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} evt Event.
   * @override
   */ handleDragEvent(evt) {
        this.ignoreNextSingleClick_ = false;
        this.willModifyFeatures_(evt, this.dragSegments_.map(([segment])=>segment));
        const vertex = [
            evt.coordinate[0] + this.delta_[0],
            evt.coordinate[1] + this.delta_[1]
        ];
        const features = [];
        const geometries = [];
        const startTraceCoord = this.traceState_.active && !this.traceSegments_ ? this.traceState_.startCoord : null;
        if (startTraceCoord) {
            this.traceSegments_ = [];
            for (const dragSegment of this.dragSegments_){
                const segmentData = dragSegment[0];
                const eligibleForTracing = (0, $a6adb03fd2fbc071$export$9f17032d917177de)((0, $a6adb03fd2fbc071$export$18cdd31d17f97131)(startTraceCoord, segmentData.segment), startTraceCoord) / evt.map.getView().getResolution() < 1;
                if (eligibleForTracing) this.traceSegments_.push(dragSegment);
            }
        }
        for(let i = 0, ii = this.dragSegments_.length; i < ii; ++i){
            const dragSegment = this.dragSegments_[i];
            const segmentData = dragSegment[0];
            const feature = segmentData.feature;
            if (!features.includes(feature)) features.push(feature);
            const geometry = segmentData.geometry;
            if (!geometries.includes(geometry)) geometries.push(geometry);
            this.updateGeometry_(vertex, dragSegment);
        }
        this.updateTrace_(evt);
        this.createOrUpdateVertexFeature_(vertex, features, geometries, true);
    }
    /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} evt Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleDownEvent(evt) {
        if (!this.condition_(evt)) return false;
        const pixelCoordinate = evt.coordinate;
        const insertVertices = this.findInsertVerticesAndUpdateDragSegments_(pixelCoordinate);
        if (insertVertices?.length && this.insertVertexCondition_(evt)) {
            this.willModifyFeatures_(evt, insertVertices);
            if (this.vertexFeature_) {
                const vertex = this.vertexFeature_.getGeometry().getCoordinates();
                for(let j = insertVertices.length - 1; j >= 0; --j)this.insertVertex_(insertVertices[j], vertex);
                this.ignoreNextSingleClick_ = true;
            }
        }
        return !!this.vertexFeature_;
    }
    /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} evt Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleUpEvent(evt) {
        for(let i = this.dragSegments_.length - 1; i >= 0; --i){
            const segmentData = this.dragSegments_[i][0];
            const geometry = segmentData.geometry;
            if (geometry.getType() === 'Circle') {
                const circle = /** @type {import("../geom/Circle.js").default} */ geometry;
                // Update a circle object in the R* bush:
                const coordinates = circle.getCenter();
                const centerSegmentData = segmentData.featureSegments[0];
                const circumferenceSegmentData = segmentData.featureSegments[1];
                centerSegmentData.segment[0] = coordinates;
                centerSegmentData.segment[1] = coordinates;
                circumferenceSegmentData.segment[0] = coordinates;
                circumferenceSegmentData.segment[1] = coordinates;
                this.rBush_.update((0, $dea65c2f666fa450$export$4838bf78d04a9440)(coordinates), centerSegmentData);
                /** @type {import("../geom/Circle.js").default | import("../geom/Polygon.js").default} */ let circleGeometry = circle;
                const userProjection = (0, $a86eee1c28205a05$export$3973b77d5f6f2790)();
                if (userProjection) {
                    const projection = evt.map.getView().getProjection();
                    circleGeometry = circleGeometry.clone().transform(userProjection, projection);
                    circleGeometry = (0, $52cb54ac72de6b07$export$2451009d645fb8c2)(circleGeometry).transform(projection, userProjection);
                }
                this.rBush_.update(circleGeometry.getExtent(), circumferenceSegmentData);
            } else this.rBush_.update((0, $dea65c2f666fa450$export$8aceca7c77505534)(segmentData.segment), segmentData);
        }
        if (this.featuresBeingModified_) {
            this.toggleTraceState_(evt);
            this.dispatchEvent(new $2375ecf9b29b2a49$export$eb2af8bb6aa1fb54($2375ecf9b29b2a49$var$ModifyEventType.MODIFYEND, this.featuresBeingModified_, evt));
            this.featuresBeingModified_ = null;
        }
        return false;
    }
    /**
   * @param {import("../MapBrowserEvent.js").default} evt Event.
   * @private
   */ handlePointerMove_(evt) {
        this.lastCoordinate_ = evt.coordinate;
        this.handlePointerAtPixel_(this.lastCoordinate_);
    }
    /**
   * @param {import("../coordinate.js").Coordinate} pixelCoordinate The pixel Coordinate.
   * @private
   */ handlePointerAtPixel_(pixelCoordinate) {
        const map = this.getMap();
        const pixel = map.getPixelFromCoordinate(pixelCoordinate);
        const projection = map.getView().getProjection();
        const sortByDistance = function(a, b) {
            return $2375ecf9b29b2a49$var$projectedDistanceToSegmentDataSquared(pixelCoordinate, a, projection) - $2375ecf9b29b2a49$var$projectedDistanceToSegmentDataSquared(pixelCoordinate, b, projection);
        };
        /** @type {Array<SegmentData>|undefined} */ let nodes;
        /** @type {Point|undefined} */ let hitPointGeometry;
        if (this.hitDetection_) {
            const layerFilter = typeof this.hitDetection_ === 'object' ? (layer)=>layer === this.hitDetection_ : undefined;
            map.forEachFeatureAtPixel(pixel, (feature, layer, geometry)=>{
                if (geometry && geometry.getType() === 'Point') geometry = new (0, $3153df5f3993c8ca$export$2e2bcd8739ae039)((0, $a86eee1c28205a05$export$698f563af1ba02a5)(geometry.getCoordinates(), projection));
                const geom = geometry || feature.getGeometry();
                if (geom && geom.getType() === 'Point' && feature instanceof (0, $df26d2327ced1fa9$export$2e2bcd8739ae039) && this.features_.includes(feature)) {
                    hitPointGeometry = /** @type {Point} */ geom;
                    const coordinate = /** @type {Point} */ feature.getGeometry().getFlatCoordinates().slice(0, 2);
                    nodes = [
                        {
                            feature: feature,
                            geometry: hitPointGeometry,
                            segment: [
                                coordinate,
                                coordinate
                            ]
                        }
                    ];
                }
                return true;
            }, {
                layerFilter: layerFilter
            });
        }
        if (!nodes) {
            const viewExtent = (0, $a86eee1c28205a05$export$494be3a3a25689ca)((0, $dea65c2f666fa450$export$4838bf78d04a9440)(pixelCoordinate, $2375ecf9b29b2a49$var$tempExtent), projection);
            const buffer = map.getView().getResolution() * this.pixelTolerance_;
            const box = (0, $a86eee1c28205a05$export$96bfd09e2cffb006)((0, $dea65c2f666fa450$export$ab1029bcae9ddb4a)(viewExtent, buffer, $2375ecf9b29b2a49$var$tempExtent), projection);
            nodes = this.rBush_.getInExtent(box);
        }
        if (nodes && nodes.length > 0) {
            const node = nodes.sort(sortByDistance)[0];
            const closestSegment = node.segment;
            let vertex = $2375ecf9b29b2a49$var$closestOnSegmentData(pixelCoordinate, node, projection);
            const vertexPixel = map.getPixelFromCoordinate(vertex);
            let dist = (0, $a6adb03fd2fbc071$export$9f17032d917177de)(pixel, vertexPixel);
            if (hitPointGeometry || dist <= this.pixelTolerance_) {
                /** @type {Object<string, boolean>} */ const vertexSegments = {};
                vertexSegments[(0, $fd76d391cc228565$export$5e82334337e0f204)(closestSegment)] = true;
                if (!this.snapToPointer_) {
                    this.delta_[0] = vertex[0] - pixelCoordinate[0];
                    this.delta_[1] = vertex[1] - pixelCoordinate[1];
                }
                if (node.geometry.getType() === 'Circle' && node.index === $2375ecf9b29b2a49$var$CIRCLE_CIRCUMFERENCE_INDEX) {
                    this.snappedToVertex_ = true;
                    this.createOrUpdateVertexFeature_(vertex, [
                        node.feature
                    ], [
                        node.geometry
                    ], this.snappedToVertex_);
                } else {
                    const pixel1 = map.getPixelFromCoordinate(closestSegment[0]);
                    const pixel2 = map.getPixelFromCoordinate(closestSegment[1]);
                    const squaredDist1 = (0, $a6adb03fd2fbc071$export$88e6ebb4fe54f538)(vertexPixel, pixel1);
                    const squaredDist2 = (0, $a6adb03fd2fbc071$export$88e6ebb4fe54f538)(vertexPixel, pixel2);
                    dist = Math.sqrt(Math.min(squaredDist1, squaredDist2));
                    this.snappedToVertex_ = dist <= this.pixelTolerance_;
                    // Stop and cleanup overlay vertex feature if a segment was hit and new vertex creation is not allowed by the insertVertexCondition
                    if (!this.snappedToVertex_ && !this.insertVertexCondition_(this.lastPointerEvent_)) {
                        if (this.vertexFeature_) {
                            this.overlay_.getSource().removeFeature(this.vertexFeature_);
                            this.vertexFeature_ = null;
                        }
                        return;
                    }
                    if (this.snappedToVertex_) vertex = squaredDist1 > squaredDist2 ? closestSegment[1] : closestSegment[0];
                    this.createOrUpdateVertexFeature_(vertex, [
                        node.feature
                    ], [
                        node.geometry
                    ], this.snappedToVertex_);
                    const geometries = {};
                    geometries[(0, $fd76d391cc228565$export$5e82334337e0f204)(node.geometry)] = true;
                    for(let i = 1, ii = nodes.length; i < ii; ++i){
                        const segment = nodes[i].segment;
                        if ((0, $a6adb03fd2fbc071$export$e9bab7fafb253603)(closestSegment[0], segment[0]) && (0, $a6adb03fd2fbc071$export$e9bab7fafb253603)(closestSegment[1], segment[1]) || (0, $a6adb03fd2fbc071$export$e9bab7fafb253603)(closestSegment[0], segment[1]) && (0, $a6adb03fd2fbc071$export$e9bab7fafb253603)(closestSegment[1], segment[0])) {
                            const geometryUid = (0, $fd76d391cc228565$export$5e82334337e0f204)(nodes[i].geometry);
                            if (!(geometryUid in geometries)) {
                                geometries[geometryUid] = true;
                                vertexSegments[(0, $fd76d391cc228565$export$5e82334337e0f204)(segment)] = true;
                            }
                        } else break;
                    }
                }
                this.vertexSegments_ = vertexSegments;
                return;
            }
        }
        if (this.vertexFeature_) {
            this.overlay_.getSource().removeFeature(this.vertexFeature_);
            this.vertexFeature_ = null;
        }
    }
    /**
   * @param {SegmentData} segmentData Segment data.
   * @param {import("../coordinate.js").Coordinate} vertex Vertex.
   * @return {boolean} A vertex was inserted.
   * @private
   */ insertVertex_(segmentData, vertex) {
        const segment = segmentData.segment;
        const feature = segmentData.feature;
        const geometry = segmentData.geometry;
        const depth = segmentData.depth;
        const index = segmentData.index;
        let coordinates;
        while(vertex.length < geometry.getStride())vertex.push(0);
        switch(geometry.getType()){
            case 'MultiLineString':
                coordinates = geometry.getCoordinates();
                coordinates[depth[0]].splice(index + 1, 0, vertex);
                break;
            case 'Polygon':
                coordinates = geometry.getCoordinates();
                coordinates[depth[0]].splice(index + 1, 0, vertex);
                break;
            case 'MultiPolygon':
                coordinates = geometry.getCoordinates();
                coordinates[depth[1]][depth[0]].splice(index + 1, 0, vertex);
                break;
            case 'LineString':
                coordinates = geometry.getCoordinates();
                coordinates.splice(index + 1, 0, vertex);
                break;
            default:
                return false;
        }
        this.setGeometryCoordinates_(geometry, coordinates);
        const rTree = this.rBush_;
        rTree.remove(segmentData);
        this.updateSegmentIndices_(geometry, index, depth, 1);
        /** @type {SegmentData} */ const newSegmentData = {
            segment: [
                segment[0],
                vertex
            ],
            feature: feature,
            geometry: geometry,
            depth: depth,
            index: index
        };
        rTree.insert((0, $dea65c2f666fa450$export$8aceca7c77505534)(newSegmentData.segment), newSegmentData);
        this.dragSegments_.push([
            newSegmentData,
            1
        ]);
        /** @type {SegmentData} */ const newSegmentData2 = {
            segment: [
                vertex,
                segment[1]
            ],
            feature: feature,
            geometry: geometry,
            depth: depth,
            index: index + 1
        };
        rTree.insert((0, $dea65c2f666fa450$export$8aceca7c77505534)(newSegmentData2.segment), newSegmentData2);
        this.dragSegments_.push([
            newSegmentData2,
            0
        ]);
        return true;
    }
    /**
   * @param {import("../coordinate.js").Coordinate} coordinate The coordinate.
   * @return {import("../coordinate.js").Coordinate} The updated pointer coordinate.
   * @private
   */ updatePointer_(coordinate) {
        if (coordinate) this.findInsertVerticesAndUpdateDragSegments_(coordinate);
        return this.vertexFeature_?.getGeometry().getCoordinates();
    }
    /**
   * Get the current pointer position.
   * @return {import("../coordinate.js").Coordinate | null} The current pointer coordinate.
   */ getPoint() {
        const coordinate = this.vertexFeature_?.getGeometry().getCoordinates();
        if (!coordinate) return null;
        return (0, $a86eee1c28205a05$export$698f563af1ba02a5)(coordinate, this.getMap().getView().getProjection());
    }
    /**
   * Check if a point can be removed from the current linestring or polygon at the current
   * pointer position.
   * @return {boolean} A point can be deleted at the current pointer position.
   * @api
   */ canRemovePoint() {
        if (!this.vertexFeature_) return false;
        if (this.vertexFeature_.get('geometries').every((geometry)=>geometry.getType() === 'Circle' || geometry.getType().endsWith('Point'))) return false;
        const coordinate = this.vertexFeature_.getGeometry().getCoordinates();
        const segments = this.rBush_.getInExtent((0, $dea65c2f666fa450$export$8aceca7c77505534)([
            coordinate
        ]));
        return segments.some(({ segment: segment })=>(0, $a6adb03fd2fbc071$export$e9bab7fafb253603)(segment[0], coordinate) || (0, $a6adb03fd2fbc071$export$e9bab7fafb253603)(segment[1], coordinate));
    }
    /**
   * Removes the vertex currently being pointed from the current linestring or polygon.
   * @param {import('../coordinate.js').Coordinate} [coordinate] If provided, the pointer
   * will be set to the provided coordinate. If not, the current pointer coordinate will be used.
   * @return {boolean} True when a vertex was removed.
   * @api
   */ removePoint(coordinate) {
        if (coordinate) {
            coordinate = (0, $a86eee1c28205a05$export$d4b8ec0b96db1ee2)(coordinate, this.getMap().getView().getProjection());
            this.updatePointer_(coordinate);
        }
        if (!this.lastPointerEvent_ || this.lastPointerEvent_ && this.lastPointerEvent_.type != (0, $1b4cb51f4587f284$export$2e2bcd8739ae039).POINTERDRAG) {
            const evt = this.lastPointerEvent_;
            this.willModifyFeatures_(evt, this.dragSegments_.map(([segment])=>segment));
            const removed = this.removeVertex_();
            if (this.featuresBeingModified_) this.dispatchEvent(new $2375ecf9b29b2a49$export$eb2af8bb6aa1fb54($2375ecf9b29b2a49$var$ModifyEventType.MODIFYEND, this.featuresBeingModified_, evt));
            this.featuresBeingModified_ = null;
            return removed;
        }
        return false;
    }
    /**
   * Removes a vertex from all matching features.
   * @return {boolean} True when a vertex was removed.
   * @private
   */ removeVertex_() {
        const dragSegments = this.dragSegments_;
        const segmentsByFeature = {};
        let deleted = false;
        let component, coordinates, dragSegment, geometry, i, index, left;
        let newIndex, right, segmentData, uid;
        for(i = dragSegments.length - 1; i >= 0; --i){
            dragSegment = dragSegments[i];
            segmentData = dragSegment[0];
            uid = (0, $fd76d391cc228565$export$5e82334337e0f204)(segmentData.feature);
            if (segmentData.depth) // separate feature components
            uid += '-' + segmentData.depth.join('-');
            if (!(uid in segmentsByFeature)) segmentsByFeature[uid] = {};
            if (dragSegment[1] === 0) {
                segmentsByFeature[uid].right = segmentData;
                segmentsByFeature[uid].index = segmentData.index;
            } else if (dragSegment[1] == 1) {
                segmentsByFeature[uid].left = segmentData;
                segmentsByFeature[uid].index = segmentData.index + 1;
            }
        }
        for(uid in segmentsByFeature){
            right = segmentsByFeature[uid].right;
            left = segmentsByFeature[uid].left;
            index = segmentsByFeature[uid].index;
            newIndex = index - 1;
            if (left !== undefined) segmentData = left;
            else segmentData = right;
            if (newIndex < 0) newIndex = 0;
            geometry = segmentData.geometry;
            coordinates = geometry.getCoordinates();
            component = coordinates;
            deleted = false;
            switch(geometry.getType()){
                case 'MultiLineString':
                    if (coordinates[segmentData.depth[0]].length > 2) {
                        coordinates[segmentData.depth[0]].splice(index, 1);
                        deleted = true;
                    }
                    break;
                case 'LineString':
                    if (coordinates.length > 2) {
                        coordinates.splice(index, 1);
                        deleted = true;
                    }
                    break;
                case 'MultiPolygon':
                    component = component[segmentData.depth[1]];
                /* falls through */ case 'Polygon':
                    component = component[segmentData.depth[0]];
                    if (component.length > 4) {
                        if (index == component.length - 1) index = 0;
                        component.splice(index, 1);
                        deleted = true;
                        if (index === 0) {
                            // close the ring again
                            component.pop();
                            component.push(component[0]);
                            newIndex = component.length - 1;
                        }
                    }
                    break;
                default:
            }
            if (deleted) {
                this.setGeometryCoordinates_(geometry, coordinates);
                const segments = [];
                if (left !== undefined) {
                    this.rBush_.remove(left);
                    segments.push(left.segment[0]);
                }
                if (right !== undefined) {
                    this.rBush_.remove(right);
                    segments.push(right.segment[1]);
                }
                if (left !== undefined && right !== undefined) {
                    /** @type {SegmentData} */ const newSegmentData = {
                        depth: segmentData.depth,
                        feature: segmentData.feature,
                        geometry: segmentData.geometry,
                        index: newIndex,
                        segment: segments
                    };
                    this.rBush_.insert((0, $dea65c2f666fa450$export$8aceca7c77505534)(newSegmentData.segment), newSegmentData);
                }
                this.updateSegmentIndices_(geometry, index, segmentData.depth, -1);
                if (this.vertexFeature_) {
                    this.overlay_.getSource().removeFeature(this.vertexFeature_);
                    this.vertexFeature_ = null;
                }
                dragSegments.length = 0;
            }
        }
        return deleted;
    }
    /**
   * Check if a point can be inserted to the current linestring or polygon at the current
   * pointer position.
   * @return {boolean} A point can be inserted at the current pointer position.
   * @api
   */ canInsertPoint() {
        if (!this.vertexFeature_) return false;
        if (this.vertexFeature_.get('geometries').every((geometry)=>geometry.getType() === 'Circle' || geometry.getType().endsWith('Point'))) return false;
        const coordinate = this.vertexFeature_.getGeometry().getCoordinates();
        const segments = this.rBush_.getInExtent((0, $dea65c2f666fa450$export$8aceca7c77505534)([
            coordinate
        ]));
        return segments.some(({ segment: segment })=>!((0, $a6adb03fd2fbc071$export$e9bab7fafb253603)(segment[0], coordinate) || (0, $a6adb03fd2fbc071$export$e9bab7fafb253603)(segment[1], coordinate)));
    }
    /**
   * Inserts the vertex currently being pointed to the current linestring or polygon.
   * @param {import('../coordinate.js').Coordinate} [coordinate] If provided, the pointer
   * will be set to the provided coordinate. If not, the current pointer coordinate will be used.
   * @return {boolean} A vertex was inserted.
   * @api
   */ insertPoint(coordinate) {
        const pixelCoordinate = coordinate ? (0, $a86eee1c28205a05$export$d4b8ec0b96db1ee2)(coordinate, this.getMap().getView().getProjection()) : this.vertexFeature_?.getGeometry().getCoordinates();
        if (!pixelCoordinate) return false;
        const insertVertices = this.findInsertVerticesAndUpdateDragSegments_(pixelCoordinate);
        return insertVertices.reduce((prev, segmentData)=>prev || this.insertVertex_(segmentData, pixelCoordinate), false);
    }
    /**
   * @param {import("../geom/SimpleGeometry.js").default} geometry Geometry.
   * @param {Array} coordinates Coordinates.
   * @private
   */ setGeometryCoordinates_(geometry, coordinates) {
        this.changingFeature_ = true;
        geometry.setCoordinates(coordinates);
        this.changingFeature_ = false;
    }
    /**
   * @param {import("../geom/SimpleGeometry.js").default} geometry Geometry.
   * @param {number} index Index.
   * @param {Array<number>|undefined} depth Depth.
   * @param {number} delta Delta (1 or -1).
   * @private
   */ updateSegmentIndices_(geometry, index, depth, delta) {
        this.rBush_.forEachInExtent(geometry.getExtent(), function(segmentDataMatch) {
            if (segmentDataMatch.geometry === geometry && (depth === undefined || segmentDataMatch.depth === undefined || (0, $49313fcb0fc32abe$export$e9bab7fafb253603)(segmentDataMatch.depth, depth)) && segmentDataMatch.index > index) segmentDataMatch.index += delta;
        });
    }
    /**
   * @override
   */ disposeInternal() {
        super.disposeInternal();
        if (this.featuresCollection_) {
            this.featuresCollection_.removeEventListener((0, $ea71ddfe3b669b23$export$2e2bcd8739ae039).ADD, this.handleExternalCollectionAdd_);
            this.featuresCollection_.removeEventListener((0, $ea71ddfe3b669b23$export$2e2bcd8739ae039).REMOVE, this.handleExternalCollectionRemove_);
            //change and propertychange event handlers were placed on all features in the external
            // collection, not just the ones that passed the filter.  Remove these too.
            for (const feature of this.featuresCollection_.getArray()){
                feature.removeEventListener((0, $b5fa963342da4935$export$2e2bcd8739ae039).CHANGE, this.handleFeatureChange_);
                if (this.filterFunctionWasSupplied_) feature.removeEventListener((0, $ff212aeaa481a85e$export$2e2bcd8739ae039).PROPERTYCHANGE, this.handleFeatureChange_);
            }
        } else if (this.source_) {
            this.source_.removeEventListener((0, $73c4cd82312d5027$export$2e2bcd8739ae039).ADDFEATURE, this.handleSourceAdd_);
            this.source_.removeEventListener((0, $73c4cd82312d5027$export$2e2bcd8739ae039).REMOVEFEATURE, this.handleSourceRemove_);
            //change and propertychange event handlers were placed on all features in the source, not
            // just the ones that passed the filter.  Remove these too.
            for (const feature of this.source_.getFeatures()){
                feature.removeEventListener((0, $b5fa963342da4935$export$2e2bcd8739ae039).CHANGE, this.handleFeatureChange_);
                if (this.filterFunctionWasSupplied_) feature.removeEventListener((0, $ff212aeaa481a85e$export$2e2bcd8739ae039).PROPERTYCHANGE, this.handleFeatureChange_);
            }
        }
    }
}
/**
 * @param {SegmentData} a The first segment data.
 * @param {SegmentData} b The second segment data.
 * @return {number} The difference in indexes.
 */ function $2375ecf9b29b2a49$var$compareIndexes(a, b) {
    return a.index - b.index;
}
/**
 * Returns the distance from a point to a line segment.
 *
 * @param {import("../coordinate.js").Coordinate} pointCoordinates The coordinates of the point from
 *        which to calculate the distance.
 * @param {SegmentData} segmentData The object describing the line
 *        segment we are calculating the distance to.
 * @param {import("../proj/Projection.js").default} projection The view projection.
 * @return {number} The square of the distance between a point and a line segment.
 */ function $2375ecf9b29b2a49$var$projectedDistanceToSegmentDataSquared(pointCoordinates, segmentData, projection) {
    const geometry = segmentData.geometry;
    if (geometry.getType() === 'Circle') {
        let circleGeometry = /** @type {import("../geom/Circle.js").default} */ geometry;
        if (segmentData.index === $2375ecf9b29b2a49$var$CIRCLE_CIRCUMFERENCE_INDEX) {
            const userProjection = (0, $a86eee1c28205a05$export$3973b77d5f6f2790)();
            if (userProjection) circleGeometry = circleGeometry.clone().transform(userProjection, projection);
            const distanceToCenterSquared = (0, $a6adb03fd2fbc071$export$88e6ebb4fe54f538)(circleGeometry.getCenter(), (0, $a86eee1c28205a05$export$d4b8ec0b96db1ee2)(pointCoordinates, projection));
            const distanceToCircumference = Math.sqrt(distanceToCenterSquared) - circleGeometry.getRadius();
            return distanceToCircumference * distanceToCircumference;
        }
    }
    const coordinate = (0, $a86eee1c28205a05$export$d4b8ec0b96db1ee2)(pointCoordinates, projection);
    $2375ecf9b29b2a49$var$tempSegment[0] = (0, $a86eee1c28205a05$export$d4b8ec0b96db1ee2)(segmentData.segment[0], projection);
    $2375ecf9b29b2a49$var$tempSegment[1] = (0, $a86eee1c28205a05$export$d4b8ec0b96db1ee2)(segmentData.segment[1], projection);
    return (0, $a6adb03fd2fbc071$export$6985570514055196)(coordinate, $2375ecf9b29b2a49$var$tempSegment);
}
/**
 * Returns the point closest to a given line segment.
 *
 * @param {import("../coordinate.js").Coordinate} pointCoordinates The point to which a closest point
 *        should be found.
 * @param {SegmentData} segmentData The object describing the line
 *        segment which should contain the closest point.
 * @param {import("../proj/Projection.js").default} projection The view projection.
 * @return {import("../coordinate.js").Coordinate} The point closest to the specified line segment.
 */ function $2375ecf9b29b2a49$var$closestOnSegmentData(pointCoordinates, segmentData, projection) {
    const geometry = segmentData.geometry;
    if (geometry.getType() === 'Circle' && segmentData.index === $2375ecf9b29b2a49$var$CIRCLE_CIRCUMFERENCE_INDEX) {
        let circleGeometry = /** @type {import("../geom/Circle.js").default} */ geometry;
        const userProjection = (0, $a86eee1c28205a05$export$3973b77d5f6f2790)();
        if (userProjection) circleGeometry = circleGeometry.clone().transform(userProjection, projection);
        return (0, $a86eee1c28205a05$export$698f563af1ba02a5)(circleGeometry.getClosestPoint((0, $a86eee1c28205a05$export$d4b8ec0b96db1ee2)(pointCoordinates, projection)), projection);
    }
    const coordinate = (0, $a86eee1c28205a05$export$d4b8ec0b96db1ee2)(pointCoordinates, projection);
    $2375ecf9b29b2a49$var$tempSegment[0] = (0, $a86eee1c28205a05$export$d4b8ec0b96db1ee2)(segmentData.segment[0], projection);
    $2375ecf9b29b2a49$var$tempSegment[1] = (0, $a86eee1c28205a05$export$d4b8ec0b96db1ee2)(segmentData.segment[1], projection);
    return (0, $a86eee1c28205a05$export$698f563af1ba02a5)((0, $a6adb03fd2fbc071$export$18cdd31d17f97131)(coordinate, $2375ecf9b29b2a49$var$tempSegment), projection);
}
/**
 * @return {import("../style/Style.js").StyleFunction} Styles.
 */ function $2375ecf9b29b2a49$var$getDefaultStyleFunction() {
    const style = (0, $a5fc261473972d1d$export$ed1eaede5d0e77ac)();
    return function(feature, resolution) {
        return style['Point'];
    };
}
var $2375ecf9b29b2a49$export$2e2bcd8739ae039 = $2375ecf9b29b2a49$var$Modify;

/**
 * @module ol/interaction/Select
 */ 










/**
 * @enum {string}
 */ const $20af4deb83586389$var$SelectEventType = {
    /**
   * Triggered when feature(s) has been (de)selected.
   * @event SelectEvent#select
   * @api
   */ SELECT: 'select'
};
class $20af4deb83586389$export$1bcc516ebf36ffe2 extends (0, $5c6b0a43c077a98f$export$2e2bcd8739ae039) {
    /**
   * @param {SelectEventType} type The event type.
   * @param {Array<import("../Feature.js").default>} selected Selected features.
   * @param {Array<import("../Feature.js").default>} deselected Deselected features.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Associated
   *     {@link module:ol/MapBrowserEvent~MapBrowserEvent}.
   */ constructor(type, selected, deselected, mapBrowserEvent){
        super(type);
        /**
     * Selected features array.
     * @type {Array<import("../Feature.js").default>}
     * @api
     */ this.selected = selected;
        /**
     * Deselected features array.
     * @type {Array<import("../Feature.js").default>}
     * @api
     */ this.deselected = deselected;
        /**
     * Associated {@link module:ol/MapBrowserEvent~MapBrowserEvent}.
     * @type {import("../MapBrowserEvent.js").default}
     * @api
     */ this.mapBrowserEvent = mapBrowserEvent;
    }
}
/**
 * Original feature styles to reset to when features are no longer selected.
 * @type {Object<number, import("../style/Style.js").default|Array<import("../style/Style.js").default>|import("../style/Style.js").StyleFunction>}
 */ const $20af4deb83586389$var$originalFeatureStyles = {};
/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types|
 *     'change:active', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<'select', SelectEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types|
 *     'change:active'|'select', Return>} SelectOnSignature
 */ /**
 * @classdesc
 * Interaction for selecting vector features. By default, selected features are
 * styled differently, so this interaction can be used for visual highlighting,
 * as well as selecting features for other actions, such as modification or
 * output. There are three ways of controlling which features are selected:
 * using the browser event as defined by the `condition` and optionally the
 * `toggle`, `add`/`remove`, and `multi` options; a `layers` filter; and a
 * further feature filter using the `filter` option.
 *
 * @fires SelectEvent
 * @api
 */ class $20af4deb83586389$var$Select extends (0, $24f38e4defed3bcd$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        super();
        /***
     * @type {SelectOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {SelectOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {SelectOnSignature<void>}
     */ this.un;
        options = options ? options : {};
        /**
     * @private
     */ this.boundAddFeature_ = this.addFeature_.bind(this);
        /**
     * @private
     */ this.boundRemoveFeature_ = this.removeFeature_.bind(this);
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.condition ? options.condition : (0, $638912a122b4daef$export$194df8bad091b401);
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.addCondition_ = options.addCondition ? options.addCondition : (0, $638912a122b4daef$export$b3e22bcfd64c1022);
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.removeCondition_ = options.removeCondition ? options.removeCondition : (0, $638912a122b4daef$export$b3e22bcfd64c1022);
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.toggleCondition_ = options.toggleCondition ? options.toggleCondition : (0, $638912a122b4daef$export$5d31fe68a477cfbb);
        /**
     * @private
     * @type {boolean}
     */ this.multi_ = options.multi ? options.multi : false;
        /**
     * @private
     * @type {FilterFunction}
     */ this.filter_ = options.filter ? options.filter : (0, $bc15bca7780ad95b$export$22e23a2304399231);
        /**
     * @private
     * @type {number}
     */ this.hitTolerance_ = options.hitTolerance ? options.hitTolerance : 0;
        /**
     * @private
     * @type {import("../style/Style.js").default|Array<import("../style/Style.js").default>|import("../style/Style.js").StyleFunction|null}
     */ this.style_ = options.style !== undefined ? options.style : $20af4deb83586389$var$getDefaultStyleFunction();
        /**
     * @private
     * @type {Collection<Feature>}
     */ this.features_ = options.features || new (0, $e1f99232eb9bff27$export$2e2bcd8739ae039)();
        /** @type {function(import("../layer/Layer.js").default<import("../source/Source").default>): boolean} */ let layerFilter;
        if (options.layers) {
            if (typeof options.layers === 'function') layerFilter = options.layers;
            else {
                const layers = options.layers;
                layerFilter = function(layer) {
                    return layers.includes(layer);
                };
            }
        } else layerFilter = (0, $bc15bca7780ad95b$export$22e23a2304399231);
        /**
     * @private
     * @type {function(import("../layer/Layer.js").default<import("../source/Source").default>): boolean}
     */ this.layerFilter_ = layerFilter;
        /**
     * An association between selected feature (key)
     * and layer (value)
     * @private
     * @type {Object<string, import("../layer/Layer.js").default>}
     */ this.featureLayerAssociation_ = {};
    }
    /**
   * @param {import("../Feature.js").default} feature Feature.
   * @param {import("../layer/Layer.js").default} layer Layer.
   * @private
   */ addFeatureLayerAssociation_(feature, layer) {
        this.featureLayerAssociation_[(0, $fd76d391cc228565$export$5e82334337e0f204)(feature)] = layer;
    }
    /**
   * Get the selected features.
   * @return {Collection<Feature>} Features collection.
   * @api
   */ getFeatures() {
        return this.features_;
    }
    /**
   * Returns the Hit-detection tolerance.
   * @return {number} Hit tolerance in pixels.
   * @api
   */ getHitTolerance() {
        return this.hitTolerance_;
    }
    /**
   * Returns the associated {@link module:ol/layer/Vector~VectorLayer vector layer} of
   * a selected feature.
   * @param {import("../Feature.js").default} feature Feature
   * @return {import('../layer/Vector.js').default} Layer.
   * @api
   */ getLayer(feature) {
        return /** @type {import('../layer/Vector.js').default} */ this.featureLayerAssociation_[(0, $fd76d391cc228565$export$5e82334337e0f204)(feature)];
    }
    /**
   * Hit-detection tolerance. Pixels inside the radius around the given position
   * will be checked for features.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @api
   */ setHitTolerance(hitTolerance) {
        this.hitTolerance_ = hitTolerance;
    }
    /**
   * Remove the interaction from its current map, if any,  and attach it to a new
   * map, if any. Pass `null` to just remove the interaction from the current map.
   * @param {import("../Map.js").default|null} map Map.
   * @api
   * @override
   */ setMap(map) {
        const currentMap = this.getMap();
        if (currentMap && this.style_) this.features_.forEach(this.restorePreviousStyle_.bind(this));
        super.setMap(map);
        if (map) {
            this.features_.addEventListener((0, $ea71ddfe3b669b23$export$2e2bcd8739ae039).ADD, this.boundAddFeature_);
            this.features_.addEventListener((0, $ea71ddfe3b669b23$export$2e2bcd8739ae039).REMOVE, this.boundRemoveFeature_);
            if (this.style_) this.features_.forEach(this.applySelectedStyle_.bind(this));
        } else {
            this.features_.removeEventListener((0, $ea71ddfe3b669b23$export$2e2bcd8739ae039).ADD, this.boundAddFeature_);
            this.features_.removeEventListener((0, $ea71ddfe3b669b23$export$2e2bcd8739ae039).REMOVE, this.boundRemoveFeature_);
        }
    }
    /**
   * @param {import("../Collection.js").CollectionEvent<Feature>} evt Event.
   * @private
   */ addFeature_(evt) {
        const feature = evt.element;
        if (this.style_) this.applySelectedStyle_(feature);
        if (!this.getLayer(feature)) {
            const layer = this.findLayerOfFeature_(feature);
            if (layer) this.addFeatureLayerAssociation_(feature, layer);
        }
    }
    /**
   * @param {import("../Collection.js").CollectionEvent<Feature>} evt Event.
   * @private
   */ removeFeature_(evt) {
        if (this.style_) this.restorePreviousStyle_(evt.element);
        this.removeFeatureLayerAssociation_(evt.element);
    }
    /**
   * @param {Feature} feature Feature of which to get the layer
   * @return {VectorLayer} layer, if one was found.
   * @private
   */ findLayerOfFeature_(feature) {
        const layer = /** @type {VectorLayer} */ this.getMap().getAllLayers().find(function(layer) {
            if (layer instanceof (0, $082a79ecb622f84a$export$2e2bcd8739ae039) && layer.getSource() && layer.getSource().hasFeature(feature)) return layer;
        });
        return layer;
    }
    /**
   * @return {import("../style/Style.js").StyleLike|null} Select style.
   */ getStyle() {
        return this.style_;
    }
    /**
   * @param {Feature} feature Feature
   * @private
   */ applySelectedStyle_(feature) {
        const key = (0, $fd76d391cc228565$export$5e82334337e0f204)(feature);
        if (!(key in $20af4deb83586389$var$originalFeatureStyles)) $20af4deb83586389$var$originalFeatureStyles[key] = feature.getStyle();
        feature.setStyle(this.style_);
    }
    /**
   * @param {Feature} feature Feature
   * @private
   */ restorePreviousStyle_(feature) {
        const interactions = this.getMap().getInteractions().getArray();
        for(let i = interactions.length - 1; i >= 0; --i){
            const interaction = interactions[i];
            if (interaction !== this && interaction instanceof $20af4deb83586389$var$Select && interaction.getStyle() && interaction.getFeatures().getArray().lastIndexOf(feature) !== -1) {
                feature.setStyle(interaction.getStyle());
                return;
            }
        }
        const key = (0, $fd76d391cc228565$export$5e82334337e0f204)(feature);
        feature.setStyle($20af4deb83586389$var$originalFeatureStyles[key]);
        delete $20af4deb83586389$var$originalFeatureStyles[key];
    }
    /**
   * @param {Feature} feature Feature.
   * @private
   */ removeFeatureLayerAssociation_(feature) {
        delete this.featureLayerAssociation_[(0, $fd76d391cc228565$export$5e82334337e0f204)(feature)];
    }
    /**
   * Try to select a feature as if it was clicked and `addCondition` evaluated to True.
   * Unlike modifying `select.getFeatures()` directly, this respects the `filter` and `layers` options (except `multi`, which is ignored).
   * The {@link module:ol/interaction/Select~SelectEvent} fired by this won't have a mapBrowserEvent property
   * @param {Feature} feature The feature to select
   * @return {boolean} True if the feature was selected
   * @api
   */ selectFeature(feature) {
        const layer = this.findLayerOfFeature_(feature);
        if (!this.layerFilter_(layer) || !this.filter_(feature, layer)) return false;
        const features = this.getFeatures();
        if (features.getArray().includes(feature)) return false;
        this.addFeatureLayerAssociation_(feature, layer);
        features.push(feature);
        this.dispatchEvent(new $20af4deb83586389$export$1bcc516ebf36ffe2($20af4deb83586389$var$SelectEventType.SELECT, [
            feature
        ], [], undefined));
        return true;
    }
    /**
   * Try to deselect a feature as if it was clicked.
   * Compared to `select.getFeatures().remove(feature)` this causes a SelectEvent.
   * The {@link module:ol/interaction/Select~SelectEvent} fired by this won't have a mapBrowserEvent property
   * @param {Feature} feature The feature to deselect
   * @return {boolean} True if the feature was deselected
   * @api
   */ deselectFeature(feature) {
        const features = this.getFeatures();
        const index = features.getArray().indexOf(feature);
        if (index === -1) return false;
        features.removeAt(index);
        this.dispatchEvent(new $20af4deb83586389$export$1bcc516ebf36ffe2($20af4deb83586389$var$SelectEventType.SELECT, [], [
            feature
        ], undefined));
        return true;
    }
    /**
   * Try to toggle a feature as if it was clicked and `toggleCondition` was True.
   * Unlike modifying `select.getFeatures()` directly, this respects the `filter` and `layers` options (except `multi`, which is ignored).
   * The {@link module:ol/interaction/Select~SelectEvent} fired by this won't have a mapBrowserEvent property
   * @param {Feature} feature The feature to deselect
   * @api
   */ toggleFeature(feature) {
        if (!this.deselectFeature(feature)) this.selectFeature(feature);
    }
    /**
   * Deselect all features as if a user deselected them.
   * Compared to `select.getFeatures().clear()` this causes a SelectEvent.
   * The {@link module:ol/interaction/Select~SelectEvent} fired by this won't have a mapBrowserEvent property
   * @api
   */ clearSelection() {
        const features = this.getFeatures();
        if (features.getLength() !== 0) {
            const deselected = features.getArray().slice(); // shallow copy
            features.clear();
            this.dispatchEvent(new $20af4deb83586389$export$1bcc516ebf36ffe2($20af4deb83586389$var$SelectEventType.SELECT, [], deselected, undefined));
        }
    }
    /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} and may change the
   * selected state of features.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @override
   */ handleEvent(mapBrowserEvent) {
        if (!this.condition_(mapBrowserEvent)) return true;
        const add = this.addCondition_(mapBrowserEvent);
        const remove = this.removeCondition_(mapBrowserEvent);
        const toggle = this.toggleCondition_(mapBrowserEvent);
        const set = !add && !remove && !toggle;
        const map = mapBrowserEvent.map;
        const features = this.getFeatures();
        /**
     * @type {Array<Feature>}
     */ const deselected = [];
        /**
     * @type {Array<Feature>}
     */ const selected = [];
        if (set) {
            // Replace the currently selected feature(s) with the feature(s) at the
            // pixel, or clear the selected feature(s) if there is no feature at
            // the pixel.
            map.forEachFeatureAtPixel(mapBrowserEvent.pixel, (feature, layer)=>{
                if (!(feature instanceof (0, $df26d2327ced1fa9$export$2e2bcd8739ae039)) || !this.filter_(feature, layer)) return;
                this.addFeatureLayerAssociation_(feature, layer);
                selected.push(feature);
                return !this.multi_;
            }, {
                layerFilter: this.layerFilter_,
                hitTolerance: this.hitTolerance_
            });
            for(let i = features.getLength() - 1; i >= 0; --i){
                const feature = features.item(i);
                const index = selected.indexOf(feature);
                if (index === -1) {
                    features.removeAt(i);
                    deselected.push(feature);
                } else // feature is already selected
                selected.splice(index, 1);
            }
            if (selected.length !== 0) features.extend(selected);
        } else {
            // Modify the currently selected feature(s).
            map.forEachFeatureAtPixel(mapBrowserEvent.pixel, (feature, layer)=>{
                if (!(feature instanceof (0, $df26d2327ced1fa9$export$2e2bcd8739ae039)) || !this.filter_(feature, layer)) return;
                const hasFeature = features.getArray().includes(feature);
                if (hasFeature && (remove || toggle)) deselected.push(feature);
                else if (!hasFeature && (add || toggle)) {
                    this.addFeatureLayerAssociation_(feature, layer);
                    selected.push(feature);
                }
                return !this.multi_; // stop if not multi
            }, {
                layerFilter: this.layerFilter_,
                hitTolerance: this.hitTolerance_
            });
            for(let j = deselected.length - 1; j >= 0; --j)features.remove(deselected[j]);
            features.extend(selected);
        }
        if (selected.length > 0 || deselected.length > 0) this.dispatchEvent(new $20af4deb83586389$export$1bcc516ebf36ffe2($20af4deb83586389$var$SelectEventType.SELECT, selected, deselected, mapBrowserEvent));
        return true;
    }
}
/**
 * @return {import("../style/Style.js").StyleFunction} Styles.
 */ function $20af4deb83586389$var$getDefaultStyleFunction() {
    const styles = (0, $a5fc261473972d1d$export$ed1eaede5d0e77ac)();
    (0, $49313fcb0fc32abe$export$8b58be045bf06082)(styles['Polygon'], styles['LineString']);
    (0, $49313fcb0fc32abe$export$8b58be045bf06082)(styles['GeometryCollection'], styles['LineString']);
    return function(feature) {
        if (!feature.getGeometry()) return null;
        return styles[feature.getGeometry().getType()];
    };
}
var $20af4deb83586389$export$2e2bcd8739ae039 = $20af4deb83586389$var$Select;





var $kc00y = parcelRequire("kc00y");
















const $0f5f18cfec20c55d$var$CreateDebitSimultane = ({ typeReseauId: typeReseauId, listePibiId: listePibiId, onSubmit: onSubmit })=>{
    const { data: vitesseEau } = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/parametres?${{
        listeParametreCode: JSON.stringify((0, $ee297f06e8568bf4$export$2e2bcd8739ae039).VITESSE_EAU)
    }}`);
    const { data: listePeiSelectionnable } = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/debit-simultane/pei?${{
        listePibiId: JSON.stringify(listePibiId),
        typeReseauId: typeReseauId
    }}`);
    const { data: data } = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/debit-simultane/get-infos?${{
        listePibiId: JSON.stringify(listePibiId)
    }}`);
    return data && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
        initialValues: (0, $ed7d84930c1d31ac$export$a5cab80145b70e98)({
            listeDebitSimultaneMesure: [
                {
                    debitSimultaneMesureDateMesure: new Date(),
                    listePeiId: listePibiId
                }
            ]
        }, listePeiSelectionnable, vitesseEau, data.siteLibelle, data.typeReseauLibelle, data.pibiDiametreCanalisation),
        validationSchema: (0, $ed7d84930c1d31ac$export$c084437b5e3206cd),
        isPost: true,
        isMultipartFormData: true,
        submitUrl: `/api/debit-simultane/create/`,
        prepareVariables: (values)=>(0, $ed7d84930c1d31ac$export$f97400759cfd946)(values),
        onSubmit: onSubmit,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ed7d84930c1d31ac$export$2e2bcd8739ae039), {})
    });
};
var $0f5f18cfec20c55d$export$2e2bcd8739ae039 = $0f5f18cfec20c55d$var$CreateDebitSimultane;







var $bkJfK = parcelRequire("bkJfK");

var $kc00y = parcelRequire("kc00y");












const $0401a2e743f7cc5b$var$SectionTitle = ({ children: children })=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
        className: "my-3",
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("h3", {
            children: children
        })
    });
};
var $0401a2e743f7cc5b$export$2e2bcd8739ae039 = $0401a2e743f7cc5b$var$SectionTitle;





const $98b3054bb852b7dd$export$a5cab80145b70e98 = (data)=>({
        indisponibiliteTemporaireMotif: data?.indisponibiliteTemporaireMotif,
        indisponibiliteTemporaireObservation: data?.indisponibiliteTemporaireObservation,
        debutImmediat: data?.indisponibiliteTemporaireDateDebut === undefined,
        finInconnue: data?.indisponibiliteTemporaireDateFin === undefined,
        indisponibiliteTemporaireDateDebut: data?.indisponibiliteTemporaireDateDebut,
        indisponibiliteTemporaireDateFin: data?.indisponibiliteTemporaireDateFin,
        listePeiId: data?.listePeiId,
        indisponibiliteTemporaireMailAvantIndisponibilite: data?.indisponibiliteTemporaireMailAvantIndisponibilite,
        indisponibiliteTemporaireMailApresIndisponibilite: data?.indisponibiliteTemporaireMailApresIndisponibilite
    });
const $98b3054bb852b7dd$export$c084437b5e3206cd = (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({
    indisponibiliteTemporaireMotif: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
    listePeiId: (0, $36ceaed6faf947af$export$6e10f2f70d298df6)
});
const $98b3054bb852b7dd$export$f97400759cfd946 = (values)=>({
        indisponibiliteTemporaireMotif: values.indisponibiliteTemporaireMotif,
        indisponibiliteTemporaireObservation: values.indisponibiliteTemporaireObservation,
        indisponibiliteTemporaireDateDebut: values.debutImmediat ? new Date().toISOString() : new Date(values.indisponibiliteTemporaireDateDebut).toISOString(),
        indisponibiliteTemporaireDateFin: values.finInconnue ? null : new Date(values.indisponibiliteTemporaireDateFin).toISOString(),
        listePeiId: values?.listePeiId,
        indisponibiliteTemporaireMailAvantIndisponibilite: values?.indisponibiliteTemporaireMailAvantIndisponibilite,
        indisponibiliteTemporaireMailApresIndisponibilite: values?.indisponibiliteTemporaireMailApresIndisponibilite
    });
const $98b3054bb852b7dd$var$hasSelectedPeiWithActiveIndispo = (selectedPeiIds, peis)=>(selectedPeiIds?.length ?? 0) > 0 && (selectedPeiIds ?? []).some((selectedPeiId)=>(peis ?? []).some((pei)=>pei.peiId === selectedPeiId && pei.hasIndispoTempActive));
const $98b3054bb852b7dd$var$IndisponibiliteTemporaireForm = ({ title: title, listePeiId: listePeiId, indisponibiliteTemporaireId: indisponibiliteTemporaireId = null })=>{
    const { values: values, setFieldValue: setFieldValue } = (0, $bkJfK.useFormikContext)();
    const [shouldDisplayIndispoWarning, setShouldDisplayIndispoWarning] = (0, $kc00y.useState)(false);
    const peiState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/pei/get-id-numero-indispos-temp-active?${{
        indisponibiliteTemporaireId: indisponibiliteTemporaireId
    }}`);
    const selectedPeiIds = values?.listePeiId ?? listePeiId;
    const hasSelectedPeiWithWarningAtInit = $98b3054bb852b7dd$var$hasSelectedPeiWithActiveIndispo(selectedPeiIds, peiState?.data);
    const shouldDisplayWarningAtInit = indisponibiliteTemporaireId === null && hasSelectedPeiWithWarningAtInit;
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                    title: title,
                    icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$77223e42038127b5), {}),
                    displayReturnButton: !((listePeiId?.length ?? 0) > 0)
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
                    children: [
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $0401a2e743f7cc5b$export$2e2bcd8739ae039), {
                            children: "Mise en indisponibilit\xe9"
                        }),
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                                    name: "indisponibiliteTemporaireMotif",
                                    label: "Motif"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$ce9b1cc0c34506d0), {
                                    name: "indisponibiliteTemporaireObservation",
                                    required: false,
                                    label: "Description"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                                        name: "debutImmediat",
                                        required: false,
                                        label: "Imm\xe9diate",
                                        onChange: ()=>{
                                            const newValue = !values.debutImmediat;
                                            setFieldValue("debutImmediat", newValue);
                                            if (!newValue) // On décoche : on met la date du moment
                                            setFieldValue("indisponibiliteTemporaireDateDebut", new Date().toISOString().slice(0, 16));
                                            else // On coche : on vide la date
                                            setFieldValue("indisponibiliteTemporaireDateDebut", undefined);
                                        }
                                    })
                                }),
                                !values.debutImmediat && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                    className: "m-2 p-1 bg-light border border-1 border-secondary",
                                    children: [
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$183478aa40b5df1), {
                                                    name: "indisponibiliteTemporaireDateDebut",
                                                    required: !values.debutImmediat,
                                                    value: values.indisponibiliteTemporaireDateDebut && (0, $00c47c7740afd024$export$cc23f907e4acb548)(new Date(values.indisponibiliteTemporaireDateDebut)),
                                                    label: "Date de d\xe9but"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                                                    name: "indisponibiliteTemporaireMailAvantIndisponibilite",
                                                    required: false,
                                                    label: "Pr\xe9venir par mail avant la date pr\xe9vue"
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $0401a2e743f7cc5b$export$2e2bcd8739ae039), {
                            children: "Remise en disponibilit\xe9"
                        }),
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                                        name: "finInconnue",
                                        required: false,
                                        label: "Date de fin inconnue",
                                        onChange: ()=>{
                                            const newValue = !values.finInconnue;
                                            setFieldValue("finInconnue", newValue);
                                            if (!newValue) // On décoche : on met la date du moment + 1 min pour avoir une date différente de la date de début par défaut
                                            setFieldValue("indisponibiliteTemporaireDateFin", new Date(Date.now() + 60000).toISOString().slice(0, 16));
                                            else // On coche : on vide la date
                                            setFieldValue("indisponibiliteTemporaireDateFin", undefined);
                                        }
                                    })
                                }),
                                !values.finInconnue && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                    className: "m-2 bg-light p-1 border border-1 border-secondary",
                                    children: [
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$183478aa40b5df1), {
                                                    name: "indisponibiliteTemporaireDateFin",
                                                    required: !values.finInconnue,
                                                    value: values.indisponibiliteTemporaireDateFin && (0, $00c47c7740afd024$export$cc23f907e4acb548)(new Date(values.indisponibiliteTemporaireDateFin)),
                                                    label: "Date de fin pr\xe9vue"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                                                    name: "indisponibiliteTemporaireMailApresIndisponibilite",
                                                    required: false,
                                                    label: "Pr\xe9venir par mail avant la date pr\xe9vue"
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $0401a2e743f7cc5b$export$2e2bcd8739ae039), {
                            children: "PEI concern\xe9s"
                        }),
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$eae70af4b4e3f197), {
                                        name: "listePei",
                                        label: "PEI concern\xe9s",
                                        options: peiState?.data,
                                        getOptionValue: (t)=>t.peiId,
                                        getOptionLabel: (t)=>t.peiNumeroComplet,
                                        value: selectedPeiIds?.map((e)=>peiState?.data?.find((pei)=>pei.peiId === e)) ?? undefined,
                                        onChange: (pei)=>{
                                            const peiId = pei.map((e)=>e.peiId);
                                            setFieldValue("listePeiId", peiId);
                                            setShouldDisplayIndispoWarning($98b3054bb852b7dd$var$hasSelectedPeiWithActiveIndispo(peiId, peiState?.data));
                                        },
                                        isClearable: true
                                    }),
                                    (shouldDisplayWarningAtInit || shouldDisplayIndispoWarning) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8598ca69ed8b9dca$export$2e2bcd8739ae039), {
                                        variant: "warning",
                                        className: "mt-3",
                                        children: "Attention : au moins un PEI s\xe9lectionn\xe9 est d\xe9j\xe0 concern\xe9 par une indisponibilit\xe9 temporaire en cours ou planifi\xe9e dans le futur."
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db9b0e6fdb142a4c$export$2e2bcd8739ae039), {
                            returnLink: !((listePeiId?.length ?? 0) > 0)
                        })
                    ]
                })
            ]
        })
    });
};
var $98b3054bb852b7dd$export$2e2bcd8739ae039 = $98b3054bb852b7dd$var$IndisponibiliteTemporaireForm;


const $cb6c3964a06abc13$var$CreateIndisponibiliteTemporaire = ({ listePeiId: listePeiId, onSubmit: onSubmit })=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
        initialValues: (0, $98b3054bb852b7dd$export$a5cab80145b70e98)({
            listePeiId: listePeiId
        }),
        validationSchema: (0, $98b3054bb852b7dd$export$c084437b5e3206cd),
        isPost: true,
        submitUrl: `/api/indisponibilite-temporaire/create`,
        prepareVariables: (values)=>(0, $98b3054bb852b7dd$export$f97400759cfd946)(values),
        ...listePeiId ? {
            onSubmit: onSubmit
        } : {
            redirectUrl: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_INDISPONIBILITE_TEMPORAIRE
        },
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $98b3054bb852b7dd$export$2e2bcd8739ae039), {
            title: "Nouvelle indisponibilit\xe9 temporaire",
            listePeiId: listePeiId
        })
    });
};
var $cb6c3964a06abc13$export$2e2bcd8739ae039 = $cb6c3964a06abc13$var$CreateIndisponibiliteTemporaire;




var $kc00y = parcelRequire("kc00y");









var $kc00y = parcelRequire("kc00y");





var $bkJfK = parcelRequire("bkJfK");








const $8e1c372a2c39ab17$export$a5cab80145b70e98 = (data)=>({
        tourneeId: data?.tourneeId ?? null,
        tourneeLibelle: data?.tourneeLibelle ?? null,
        tourneeOrganismeId: data?.tourneeOrganismeId ?? null
    });
const $8e1c372a2c39ab17$export$f97400759cfd946 = (values)=>({
        tourneeId: values.tourneeId ?? null,
        tourneeLibelle: values.tourneeLibelle ?? null,
        tourneeOrganismeId: values.tourneeOrganismeId ?? null
    });
const $8e1c372a2c39ab17$var$TourneeForm = ({ isCreation: isCreation = false, tourneeLibelle: tourneeLibelle = null, listePei: listePei = [], hideSubmit: hideSubmit = false })=>{
    const { values: values, setValues: setValues } = (0, $bkJfK.useFormikContext)();
    const organismeState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)(listePei ? (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/organisme/get-libelle-organisme-filter-with-pei?${{
        listePei: JSON.stringify(listePei)
    }}` : (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/organisme/get-libelle-organisme`);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                    icon: isCreation ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$d776d19dfae66ece), {}) : /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$b51dd496211ae105), {}),
                    title: isCreation ? "Cr\xe9ation d'une tourn\xe9e" : "Modification de la tourn\xe9e " + tourneeLibelle,
                    displayReturnButton: !hideSubmit
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                            name: "tourneeLibelle",
                            label: "Nom de la tourn\xe9e :"
                        }),
                        isCreation && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                            name: "tourneeOrganismeId",
                            listIdCodeLibelle: organismeState.data,
                            label: "Organisme :",
                            required: true,
                            setValues: setValues,
                            defaultValue: organismeState.data?.find((value)=>value.id === values.tourneeOrganismeId)
                        })
                    ]
                }),
                !hideSubmit && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db9b0e6fdb142a4c$export$2e2bcd8739ae039), {
                    returnLink: true
                })
            ]
        })
    });
};
var $8e1c372a2c39ab17$export$2e2bcd8739ae039 = $8e1c372a2c39ab17$var$TourneeForm;


const $a1be20d90875d36b$var$CreateTournee = /*#__PURE__*/ (0, $kc00y.forwardRef)(({ isFromMap: isFromMap = false, setTourneeId: setTourneeId, listePei: listePei = [] }, ref)=>{
    const navigate = (0, $7a844823b04d4282$export$9770f232ac06a008)();
    const formikRef = (0, $kc00y.useRef)();
    const location = (0, $7a844823b04d4282$export$45d76561a5302f2b)();
    (0, $kc00y.useImperativeHandle)(ref, ()=>({
            submit: ()=>{
                if (formikRef.current) formikRef.current.submitForm();
            }
        }));
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
        innerRef: formikRef,
        initialValues: (0, $8e1c372a2c39ab17$export$a5cab80145b70e98)(),
        isPost: true,
        submitUrl: `/api/tournee/createTournee`,
        prepareVariables: (values)=>(0, $8e1c372a2c39ab17$export$f97400759cfd946)(values),
        redirectUrl: undefined,
        onSubmit: (e)=>!isFromMap ? navigate((0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).TOURNEE_PEI(e.tourneeId), {
                state: {
                    ...location.state
                }
            }) : setTourneeId && setTourneeId(e.tourneeId),
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8e1c372a2c39ab17$export$2e2bcd8739ae039), {
            isCreation: true,
            listePei: listePei,
            hideSubmit: isFromMap
        })
    });
});
$a1be20d90875d36b$var$CreateTournee.displayName = "CreateTournee";
var $a1be20d90875d36b$export$2e2bcd8739ae039 = $a1be20d90875d36b$var$CreateTournee;




var $kc00y = parcelRequire("kc00y");







var $kc00y = parcelRequire("kc00y");


var $kc00y = parcelRequire("kc00y");
function $f5d873c94758f78f$export$2f8294366bb2d67a() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++)refs[_key] = arguments[_key];
    return (0, $kc00y.useMemo)(()=>(node)=>{
            refs.forEach((ref)=>ref(node));
        }, refs);
}
// https://github.com/facebook/react/blob/master/packages/shared/ExecutionEnvironment.js
const $f5d873c94758f78f$export$71594e8a50f746f4 = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined';
function $f5d873c94758f78f$export$5a096129d439f843(element) {
    const elementString = Object.prototype.toString.call(element);
    return elementString === '[object Window]' || // In Electron context the Window object serializes to [object global]
    elementString === '[object global]';
}
function $f5d873c94758f78f$export$8ee0fc9ee280b4ee(node) {
    return 'nodeType' in node;
}
function $f5d873c94758f78f$export$38b2d434cce3ea22(target) {
    var _target$ownerDocument, _target$ownerDocument2;
    if (!target) return window;
    if ($f5d873c94758f78f$export$5a096129d439f843(target)) return target;
    if (!$f5d873c94758f78f$export$8ee0fc9ee280b4ee(target)) return window;
    return (_target$ownerDocument = (_target$ownerDocument2 = target.ownerDocument) == null ? void 0 : _target$ownerDocument2.defaultView) != null ? _target$ownerDocument : window;
}
function $f5d873c94758f78f$export$62858bae88b53fd0(node) {
    const { Document: Document } = $f5d873c94758f78f$export$38b2d434cce3ea22(node);
    return node instanceof Document;
}
function $f5d873c94758f78f$export$1b3bfaa9684536aa(node) {
    if ($f5d873c94758f78f$export$5a096129d439f843(node)) return false;
    return node instanceof $f5d873c94758f78f$export$38b2d434cce3ea22(node).HTMLElement;
}
function $f5d873c94758f78f$export$17eda790a720ec57(node) {
    return node instanceof $f5d873c94758f78f$export$38b2d434cce3ea22(node).SVGElement;
}
function $f5d873c94758f78f$export$b204af158042fbac(target) {
    if (!target) return document;
    if ($f5d873c94758f78f$export$5a096129d439f843(target)) return target.document;
    if (!$f5d873c94758f78f$export$8ee0fc9ee280b4ee(target)) return document;
    if ($f5d873c94758f78f$export$62858bae88b53fd0(target)) return target;
    if ($f5d873c94758f78f$export$1b3bfaa9684536aa(target) || $f5d873c94758f78f$export$17eda790a720ec57(target)) return target.ownerDocument;
    return document;
}
/**
 * A hook that resolves to useEffect on the server and useLayoutEffect on the client
 * @param callback {function} Callback function that is invoked when the dependencies of the hook change
 */ const $f5d873c94758f78f$export$700979bc83e7db82 = $f5d873c94758f78f$export$71594e8a50f746f4 ? (0, $kc00y.useLayoutEffect) : (0, $kc00y.useEffect);
function $f5d873c94758f78f$export$90fc3a17d93f704c(handler) {
    const handlerRef = (0, $kc00y.useRef)(handler);
    $f5d873c94758f78f$export$700979bc83e7db82(()=>{
        handlerRef.current = handler;
    });
    return (0, $kc00y.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return handlerRef.current == null ? void 0 : handlerRef.current(...args);
    }, []);
}
function $f5d873c94758f78f$export$f4b266cd2aae9cb1() {
    const intervalRef = (0, $kc00y.useRef)(null);
    const set = (0, $kc00y.useCallback)((listener, duration)=>{
        intervalRef.current = setInterval(listener, duration);
    }, []);
    const clear = (0, $kc00y.useCallback)(()=>{
        if (intervalRef.current !== null) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }
    }, []);
    return [
        set,
        clear
    ];
}
function $f5d873c94758f78f$export$86c4283a11f23f95(value, dependencies) {
    if (dependencies === void 0) dependencies = [
        value
    ];
    const valueRef = (0, $kc00y.useRef)(value);
    $f5d873c94758f78f$export$700979bc83e7db82(()=>{
        if (valueRef.current !== value) valueRef.current = value;
    }, dependencies);
    return valueRef;
}
function $f5d873c94758f78f$export$b0d7b7f1fcd613d1(callback, dependencies) {
    const valueRef = (0, $kc00y.useRef)();
    return (0, $kc00y.useMemo)(()=>{
        const newValue = callback(valueRef.current);
        valueRef.current = newValue;
        return newValue;
    }, [
        ...dependencies
    ]);
}
function $f5d873c94758f78f$export$bc23c270f170c912(onChange) {
    const onChangeHandler = $f5d873c94758f78f$export$90fc3a17d93f704c(onChange);
    const node = (0, $kc00y.useRef)(null);
    const setNodeRef = (0, $kc00y.useCallback)((element)=>{
        if (element !== node.current) onChangeHandler == null || onChangeHandler(element, node.current);
        node.current = element;
    }, []);
    return [
        node,
        setNodeRef
    ];
}
function $f5d873c94758f78f$export$5cae361ad82dce8b(value) {
    const ref = (0, $kc00y.useRef)();
    (0, $kc00y.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}
let $f5d873c94758f78f$var$ids = {};
function $f5d873c94758f78f$export$c485849f2e393253(prefix, value) {
    return (0, $kc00y.useMemo)(()=>{
        if (value) return value;
        const id = $f5d873c94758f78f$var$ids[prefix] == null ? 0 : $f5d873c94758f78f$var$ids[prefix] + 1;
        $f5d873c94758f78f$var$ids[prefix] = id;
        return prefix + "-" + id;
    }, [
        prefix,
        value
    ]);
}
function $f5d873c94758f78f$var$createAdjustmentFn(modifier) {
    return function(object) {
        for(var _len = arguments.length, adjustments = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)adjustments[_key - 1] = arguments[_key];
        return adjustments.reduce((accumulator, adjustment)=>{
            const entries = Object.entries(adjustment);
            for (const [key, valueAdjustment] of entries){
                const value = accumulator[key];
                if (value != null) accumulator[key] = value + modifier * valueAdjustment;
            }
            return accumulator;
        }, {
            ...object
        });
    };
}
const $f5d873c94758f78f$export$e16d8520af44a096 = /*#__PURE__*/ $f5d873c94758f78f$var$createAdjustmentFn(1);
const $f5d873c94758f78f$export$4e2d2ead65e5f7e3 = /*#__PURE__*/ $f5d873c94758f78f$var$createAdjustmentFn(-1);
function $f5d873c94758f78f$export$d0e71af79cd586c6(event) {
    return 'clientX' in event && 'clientY' in event;
}
function $f5d873c94758f78f$export$130b789831072f4c(event) {
    if (!event) return false;
    const { KeyboardEvent: KeyboardEvent } = $f5d873c94758f78f$export$38b2d434cce3ea22(event.target);
    return KeyboardEvent && event instanceof KeyboardEvent;
}
function $f5d873c94758f78f$export$c4dfce035d43d1e0(event) {
    if (!event) return false;
    const { TouchEvent: TouchEvent } = $f5d873c94758f78f$export$38b2d434cce3ea22(event.target);
    return TouchEvent && event instanceof TouchEvent;
}
/**
 * Returns the normalized x and y coordinates for mouse and touch events.
 */ function $f5d873c94758f78f$export$36195c8aa1517e04(event) {
    if ($f5d873c94758f78f$export$c4dfce035d43d1e0(event)) {
        if (event.touches && event.touches.length) {
            const { clientX: x, clientY: y } = event.touches[0];
            return {
                x: x,
                y: y
            };
        } else if (event.changedTouches && event.changedTouches.length) {
            const { clientX: x, clientY: y } = event.changedTouches[0];
            return {
                x: x,
                y: y
            };
        }
    }
    if ($f5d873c94758f78f$export$d0e71af79cd586c6(event)) return {
        x: event.clientX,
        y: event.clientY
    };
    return null;
}
const $f5d873c94758f78f$export$c4ffa16951855e28 = /*#__PURE__*/ Object.freeze({
    Translate: {
        toString (transform) {
            if (!transform) return;
            const { x: x, y: y } = transform;
            return "translate3d(" + (x ? Math.round(x) : 0) + "px, " + (y ? Math.round(y) : 0) + "px, 0)";
        }
    },
    Scale: {
        toString (transform) {
            if (!transform) return;
            const { scaleX: scaleX, scaleY: scaleY } = transform;
            return "scaleX(" + scaleX + ") scaleY(" + scaleY + ")";
        }
    },
    Transform: {
        toString (transform) {
            if (!transform) return;
            return [
                $f5d873c94758f78f$export$c4ffa16951855e28.Translate.toString(transform),
                $f5d873c94758f78f$export$c4ffa16951855e28.Scale.toString(transform)
            ].join(' ');
        }
    },
    Transition: {
        toString (_ref) {
            let { property: property, duration: duration, easing: easing } = _ref;
            return property + " " + duration + "ms " + easing;
        }
    }
});
const $f5d873c94758f78f$var$SELECTOR = 'a,frame,iframe,input:not([type=hidden]):not(:disabled),select:not(:disabled),textarea:not(:disabled),button:not(:disabled),*[tabindex]';
function $f5d873c94758f78f$export$44f71d798fd0a62b(element) {
    if (element.matches($f5d873c94758f78f$var$SELECTOR)) return element;
    return element.querySelector($f5d873c94758f78f$var$SELECTOR);
}



var $kc00y = parcelRequire("kc00y");
const $7f3020fb1816ca53$var$hiddenStyles = {
    display: 'none'
};
function $7f3020fb1816ca53$export$1496ac55023363a5(_ref) {
    let { id: id, value: value } = _ref;
    return (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement("div", {
        id: id,
        style: $7f3020fb1816ca53$var$hiddenStyles
    }, value);
}
function $7f3020fb1816ca53$export$ae99b902be98b17(_ref) {
    let { id: id, announcement: announcement, ariaLiveType: ariaLiveType = "assertive" } = _ref;
    // Hide element visually but keep it readable by screen readers
    const visuallyHidden = {
        position: 'fixed',
        top: 0,
        left: 0,
        width: 1,
        height: 1,
        margin: -1,
        border: 0,
        padding: 0,
        overflow: 'hidden',
        clip: 'rect(0 0 0 0)',
        clipPath: 'inset(100%)',
        whiteSpace: 'nowrap'
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement("div", {
        id: id,
        style: visuallyHidden,
        role: "status",
        "aria-live": ariaLiveType,
        "aria-atomic": true
    }, announcement);
}
function $7f3020fb1816ca53$export$97d78af8d95ca8bd() {
    const [announcement, setAnnouncement] = (0, $kc00y.useState)('');
    const announce = (0, $kc00y.useCallback)((value)=>{
        if (value != null) setAnnouncement(value);
    }, []);
    return {
        announce: announce,
        announcement: announcement
    };
}


const $3b30af0a3bfceeb3$var$DndMonitorContext = /*#__PURE__*/ (0, $kc00y.createContext)(null);
function $3b30af0a3bfceeb3$export$1182af90218a7b81(listener) {
    const registerListener = (0, $kc00y.useContext)($3b30af0a3bfceeb3$var$DndMonitorContext);
    (0, $kc00y.useEffect)(()=>{
        if (!registerListener) throw new Error('useDndMonitor must be used within a children of <DndContext>');
        const unsubscribe = registerListener(listener);
        return unsubscribe;
    }, [
        listener,
        registerListener
    ]);
}
function $3b30af0a3bfceeb3$var$useDndMonitorProvider() {
    const [listeners] = (0, $kc00y.useState)(()=>new Set());
    const registerListener = (0, $kc00y.useCallback)((listener)=>{
        listeners.add(listener);
        return ()=>listeners.delete(listener);
    }, [
        listeners
    ]);
    const dispatch = (0, $kc00y.useCallback)((_ref)=>{
        let { type: type, event: event } = _ref;
        listeners.forEach((listener)=>{
            var _listener$type;
            return (_listener$type = listener[type]) == null ? void 0 : _listener$type.call(listener, event);
        });
    }, [
        listeners
    ]);
    return [
        dispatch,
        registerListener
    ];
}
const $3b30af0a3bfceeb3$export$2547556495408594 = {
    draggable: "\n    To pick up a draggable item, press the space bar.\n    While dragging, use the arrow keys to move the item.\n    Press space again to drop the item in its new position, or press escape to cancel.\n  "
};
const $3b30af0a3bfceeb3$export$6acb64047911dd54 = {
    onDragStart (_ref) {
        let { active: active } = _ref;
        return "Picked up draggable item " + active.id + ".";
    },
    onDragOver (_ref2) {
        let { active: active, over: over } = _ref2;
        if (over) return "Draggable item " + active.id + " was moved over droppable area " + over.id + ".";
        return "Draggable item " + active.id + " is no longer over a droppable area.";
    },
    onDragEnd (_ref3) {
        let { active: active, over: over } = _ref3;
        if (over) return "Draggable item " + active.id + " was dropped over droppable area " + over.id;
        return "Draggable item " + active.id + " was dropped.";
    },
    onDragCancel (_ref4) {
        let { active: active } = _ref4;
        return "Dragging was cancelled. Draggable item " + active.id + " was dropped.";
    }
};
function $3b30af0a3bfceeb3$var$Accessibility(_ref) {
    let { announcements: announcements = $3b30af0a3bfceeb3$export$6acb64047911dd54, container: container, hiddenTextDescribedById: hiddenTextDescribedById, screenReaderInstructions: screenReaderInstructions = $3b30af0a3bfceeb3$export$2547556495408594 } = _ref;
    const { announce: announce, announcement: announcement } = (0, $7f3020fb1816ca53$export$97d78af8d95ca8bd)();
    const liveRegionId = (0, $f5d873c94758f78f$export$c485849f2e393253)("DndLiveRegion");
    const [mounted, setMounted] = (0, $kc00y.useState)(false);
    (0, $kc00y.useEffect)(()=>{
        setMounted(true);
    }, []);
    $3b30af0a3bfceeb3$export$1182af90218a7b81((0, $kc00y.useMemo)(()=>({
            onDragStart (_ref2) {
                let { active: active } = _ref2;
                announce(announcements.onDragStart({
                    active: active
                }));
            },
            onDragMove (_ref3) {
                let { active: active, over: over } = _ref3;
                if (announcements.onDragMove) announce(announcements.onDragMove({
                    active: active,
                    over: over
                }));
            },
            onDragOver (_ref4) {
                let { active: active, over: over } = _ref4;
                announce(announcements.onDragOver({
                    active: active,
                    over: over
                }));
            },
            onDragEnd (_ref5) {
                let { active: active, over: over } = _ref5;
                announce(announcements.onDragEnd({
                    active: active,
                    over: over
                }));
            },
            onDragCancel (_ref6) {
                let { active: active, over: over } = _ref6;
                announce(announcements.onDragCancel({
                    active: active,
                    over: over
                }));
            }
        }), [
        announce,
        announcements
    ]));
    if (!mounted) return null;
    const markup = (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement((0, $7f3020fb1816ca53$export$1496ac55023363a5), {
        id: hiddenTextDescribedById,
        value: screenReaderInstructions.draggable
    }), (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement((0, $7f3020fb1816ca53$export$ae99b902be98b17), {
        id: liveRegionId,
        announcement: announcement
    }));
    return container ? (0, $9018fd8b87cabbb7$exports.createPortal)(markup, container) : markup;
}
var $3b30af0a3bfceeb3$var$Action;
(function(Action) {
    Action["DragStart"] = "dragStart";
    Action["DragMove"] = "dragMove";
    Action["DragEnd"] = "dragEnd";
    Action["DragCancel"] = "dragCancel";
    Action["DragOver"] = "dragOver";
    Action["RegisterDroppable"] = "registerDroppable";
    Action["SetDroppableDisabled"] = "setDroppableDisabled";
    Action["UnregisterDroppable"] = "unregisterDroppable";
})($3b30af0a3bfceeb3$var$Action || ($3b30af0a3bfceeb3$var$Action = {}));
function $3b30af0a3bfceeb3$var$noop() {}
function $3b30af0a3bfceeb3$export$cc72dd71f4ec69eb(sensor, options) {
    return (0, $kc00y.useMemo)(()=>({
            sensor: sensor,
            options: options != null ? options : {}
        }), [
        sensor,
        options
    ]);
}
function $3b30af0a3bfceeb3$export$19012f58216d597f() {
    for(var _len = arguments.length, sensors = new Array(_len), _key = 0; _key < _len; _key++)sensors[_key] = arguments[_key];
    return (0, $kc00y.useMemo)(()=>[
            ...sensors
        ].filter((sensor)=>sensor != null), [
        ...sensors
    ]);
}
const $3b30af0a3bfceeb3$export$597cbd7bbd10deb4 = /*#__PURE__*/ Object.freeze({
    x: 0,
    y: 0
});
/**
 * Returns the distance between two points
 */ function $3b30af0a3bfceeb3$var$distanceBetween(p1, p2) {
    return Math.sqrt(Math.pow(p1.x - p2.x, 2) + Math.pow(p1.y - p2.y, 2));
}
function $3b30af0a3bfceeb3$var$getRelativeTransformOrigin(event, rect) {
    const eventCoordinates = (0, $f5d873c94758f78f$export$36195c8aa1517e04)(event);
    if (!eventCoordinates) return '0 0';
    const transformOrigin = {
        x: (eventCoordinates.x - rect.left) / rect.width * 100,
        y: (eventCoordinates.y - rect.top) / rect.height * 100
    };
    return transformOrigin.x + "% " + transformOrigin.y + "%";
}
/**
 * Sort collisions from smallest to greatest value
 */ function $3b30af0a3bfceeb3$var$sortCollisionsAsc(_ref, _ref2) {
    let { data: { value: a } } = _ref;
    let { data: { value: b } } = _ref2;
    return a - b;
}
/**
 * Sort collisions from greatest to smallest value
 */ function $3b30af0a3bfceeb3$var$sortCollisionsDesc(_ref3, _ref4) {
    let { data: { value: a } } = _ref3;
    let { data: { value: b } } = _ref4;
    return b - a;
}
/**
 * Returns the coordinates of the corners of a given rectangle:
 * [TopLeft {x, y}, TopRight {x, y}, BottomLeft {x, y}, BottomRight {x, y}]
 */ function $3b30af0a3bfceeb3$var$cornersOfRectangle(_ref5) {
    let { left: left, top: top, height: height, width: width } = _ref5;
    return [
        {
            x: left,
            y: top
        },
        {
            x: left + width,
            y: top
        },
        {
            x: left,
            y: top + height
        },
        {
            x: left + width,
            y: top + height
        }
    ];
}
function $3b30af0a3bfceeb3$export$ef1beab6d7287295(collisions, property) {
    if (!collisions || collisions.length === 0) return null;
    const [firstCollision] = collisions;
    return property ? firstCollision[property] : firstCollision;
}
/**
 * Returns the coordinates of the center of a given ClientRect
 */ function $3b30af0a3bfceeb3$var$centerOfRectangle(rect, left, top) {
    if (left === void 0) left = rect.left;
    if (top === void 0) top = rect.top;
    return {
        x: left + rect.width * 0.5,
        y: top + rect.height * 0.5
    };
}
/**
 * Returns the closest rectangles from an array of rectangles to the center of a given
 * rectangle.
 */ const $3b30af0a3bfceeb3$export$c8e785ae6b74bab8 = (_ref)=>{
    let { collisionRect: collisionRect, droppableRects: droppableRects, droppableContainers: droppableContainers } = _ref;
    const centerRect = $3b30af0a3bfceeb3$var$centerOfRectangle(collisionRect, collisionRect.left, collisionRect.top);
    const collisions = [];
    for (const droppableContainer of droppableContainers){
        const { id: id } = droppableContainer;
        const rect = droppableRects.get(id);
        if (rect) {
            const distBetween = $3b30af0a3bfceeb3$var$distanceBetween($3b30af0a3bfceeb3$var$centerOfRectangle(rect), centerRect);
            collisions.push({
                id: id,
                data: {
                    droppableContainer: droppableContainer,
                    value: distBetween
                }
            });
        }
    }
    return collisions.sort($3b30af0a3bfceeb3$var$sortCollisionsAsc);
};
/**
 * Returns the closest rectangles from an array of rectangles to the corners of
 * another rectangle.
 */ const $3b30af0a3bfceeb3$export$c3a6c1c7122b31c9 = (_ref)=>{
    let { collisionRect: collisionRect, droppableRects: droppableRects, droppableContainers: droppableContainers } = _ref;
    const corners = $3b30af0a3bfceeb3$var$cornersOfRectangle(collisionRect);
    const collisions = [];
    for (const droppableContainer of droppableContainers){
        const { id: id } = droppableContainer;
        const rect = droppableRects.get(id);
        if (rect) {
            const rectCorners = $3b30af0a3bfceeb3$var$cornersOfRectangle(rect);
            const distances = corners.reduce((accumulator, corner, index)=>{
                return accumulator + $3b30af0a3bfceeb3$var$distanceBetween(rectCorners[index], corner);
            }, 0);
            const effectiveDistance = Number((distances / 4).toFixed(4));
            collisions.push({
                id: id,
                data: {
                    droppableContainer: droppableContainer,
                    value: effectiveDistance
                }
            });
        }
    }
    return collisions.sort($3b30af0a3bfceeb3$var$sortCollisionsAsc);
};
/**
 * Returns the intersecting rectangle area between two rectangles
 */ function $3b30af0a3bfceeb3$var$getIntersectionRatio(entry, target) {
    const top = Math.max(target.top, entry.top);
    const left = Math.max(target.left, entry.left);
    const right = Math.min(target.left + target.width, entry.left + entry.width);
    const bottom = Math.min(target.top + target.height, entry.top + entry.height);
    const width = right - left;
    const height = bottom - top;
    if (left < right && top < bottom) {
        const targetArea = target.width * target.height;
        const entryArea = entry.width * entry.height;
        const intersectionArea = width * height;
        const intersectionRatio = intersectionArea / (targetArea + entryArea - intersectionArea);
        return Number(intersectionRatio.toFixed(4));
    } // Rectangles do not overlap, or overlap has an area of zero (edge/corner overlap)
    return 0;
}
/**
 * Returns the rectangles that has the greatest intersection area with a given
 * rectangle in an array of rectangles.
 */ const $3b30af0a3bfceeb3$export$953346c40b5eb62a = (_ref)=>{
    let { collisionRect: collisionRect, droppableRects: droppableRects, droppableContainers: droppableContainers } = _ref;
    const collisions = [];
    for (const droppableContainer of droppableContainers){
        const { id: id } = droppableContainer;
        const rect = droppableRects.get(id);
        if (rect) {
            const intersectionRatio = $3b30af0a3bfceeb3$var$getIntersectionRatio(rect, collisionRect);
            if (intersectionRatio > 0) collisions.push({
                id: id,
                data: {
                    droppableContainer: droppableContainer,
                    value: intersectionRatio
                }
            });
        }
    }
    return collisions.sort($3b30af0a3bfceeb3$var$sortCollisionsDesc);
};
/**
 * Check if a given point is contained within a bounding rectangle
 */ function $3b30af0a3bfceeb3$var$isPointWithinRect(point, rect) {
    const { top: top, left: left, bottom: bottom, right: right } = rect;
    return top <= point.y && point.y <= bottom && left <= point.x && point.x <= right;
}
/**
 * Returns the rectangles that the pointer is hovering over
 */ const $3b30af0a3bfceeb3$export$cd834c0ba378cb94 = (_ref)=>{
    let { droppableContainers: droppableContainers, droppableRects: droppableRects, pointerCoordinates: pointerCoordinates } = _ref;
    if (!pointerCoordinates) return [];
    const collisions = [];
    for (const droppableContainer of droppableContainers){
        const { id: id } = droppableContainer;
        const rect = droppableRects.get(id);
        if (rect && $3b30af0a3bfceeb3$var$isPointWithinRect(pointerCoordinates, rect)) {
            /* There may be more than a single rectangle intersecting
       * with the pointer coordinates. In order to sort the
       * colliding rectangles, we measure the distance between
       * the pointer and the corners of the intersecting rectangle
       */ const corners = $3b30af0a3bfceeb3$var$cornersOfRectangle(rect);
            const distances = corners.reduce((accumulator, corner)=>{
                return accumulator + $3b30af0a3bfceeb3$var$distanceBetween(pointerCoordinates, corner);
            }, 0);
            const effectiveDistance = Number((distances / 4).toFixed(4));
            collisions.push({
                id: id,
                data: {
                    droppableContainer: droppableContainer,
                    value: effectiveDistance
                }
            });
        }
    }
    return collisions.sort($3b30af0a3bfceeb3$var$sortCollisionsAsc);
};
function $3b30af0a3bfceeb3$var$adjustScale(transform, rect1, rect2) {
    return {
        ...transform,
        scaleX: rect1 && rect2 ? rect1.width / rect2.width : 1,
        scaleY: rect1 && rect2 ? rect1.height / rect2.height : 1
    };
}
function $3b30af0a3bfceeb3$var$getRectDelta(rect1, rect2) {
    return rect1 && rect2 ? {
        x: rect1.left - rect2.left,
        y: rect1.top - rect2.top
    } : $3b30af0a3bfceeb3$export$597cbd7bbd10deb4;
}
function $3b30af0a3bfceeb3$var$createRectAdjustmentFn(modifier) {
    return function adjustClientRect(rect) {
        for(var _len = arguments.length, adjustments = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)adjustments[_key - 1] = arguments[_key];
        return adjustments.reduce((acc, adjustment)=>({
                ...acc,
                top: acc.top + modifier * adjustment.y,
                bottom: acc.bottom + modifier * adjustment.y,
                left: acc.left + modifier * adjustment.x,
                right: acc.right + modifier * adjustment.x
            }), {
            ...rect
        });
    };
}
const $3b30af0a3bfceeb3$var$getAdjustedRect = /*#__PURE__*/ $3b30af0a3bfceeb3$var$createRectAdjustmentFn(1);
function $3b30af0a3bfceeb3$var$parseTransform(transform) {
    if (transform.startsWith('matrix3d(')) {
        const transformArray = transform.slice(9, -1).split(/, /);
        return {
            x: +transformArray[12],
            y: +transformArray[13],
            scaleX: +transformArray[0],
            scaleY: +transformArray[5]
        };
    } else if (transform.startsWith('matrix(')) {
        const transformArray = transform.slice(7, -1).split(/, /);
        return {
            x: +transformArray[4],
            y: +transformArray[5],
            scaleX: +transformArray[0],
            scaleY: +transformArray[3]
        };
    }
    return null;
}
function $3b30af0a3bfceeb3$var$inverseTransform(rect, transform, transformOrigin) {
    const parsedTransform = $3b30af0a3bfceeb3$var$parseTransform(transform);
    if (!parsedTransform) return rect;
    const { scaleX: scaleX, scaleY: scaleY, x: translateX, y: translateY } = parsedTransform;
    const x = rect.left - translateX - (1 - scaleX) * parseFloat(transformOrigin);
    const y = rect.top - translateY - (1 - scaleY) * parseFloat(transformOrigin.slice(transformOrigin.indexOf(' ') + 1));
    const w = scaleX ? rect.width / scaleX : rect.width;
    const h = scaleY ? rect.height / scaleY : rect.height;
    return {
        width: w,
        height: h,
        top: y,
        right: x + w,
        bottom: y + h,
        left: x
    };
}
const $3b30af0a3bfceeb3$var$defaultOptions = {
    ignoreTransform: false
};
/**
 * Returns the bounding client rect of an element relative to the viewport.
 */ function $3b30af0a3bfceeb3$export$b6aa1f30c53d7454(element, options) {
    if (options === void 0) options = $3b30af0a3bfceeb3$var$defaultOptions;
    let rect = element.getBoundingClientRect();
    if (options.ignoreTransform) {
        const { transform: transform, transformOrigin: transformOrigin } = (0, $f5d873c94758f78f$export$38b2d434cce3ea22)(element).getComputedStyle(element);
        if (transform) rect = $3b30af0a3bfceeb3$var$inverseTransform(rect, transform, transformOrigin);
    }
    const { top: top, left: left, width: width, height: height, bottom: bottom, right: right } = rect;
    return {
        top: top,
        left: left,
        width: width,
        height: height,
        bottom: bottom,
        right: right
    };
}
/**
 * Returns the bounding client rect of an element relative to the viewport.
 *
 * @remarks
 * The ClientRect returned by this method does not take into account transforms
 * applied to the element it measures.
 *
 */ function $3b30af0a3bfceeb3$var$getTransformAgnosticClientRect(element) {
    return $3b30af0a3bfceeb3$export$b6aa1f30c53d7454(element, {
        ignoreTransform: true
    });
}
function $3b30af0a3bfceeb3$var$getWindowClientRect(element) {
    const width = element.innerWidth;
    const height = element.innerHeight;
    return {
        top: 0,
        left: 0,
        right: width,
        bottom: height,
        width: width,
        height: height
    };
}
function $3b30af0a3bfceeb3$var$isFixed(node, computedStyle) {
    if (computedStyle === void 0) computedStyle = (0, $f5d873c94758f78f$export$38b2d434cce3ea22)(node).getComputedStyle(node);
    return computedStyle.position === 'fixed';
}
function $3b30af0a3bfceeb3$var$isScrollable(element, computedStyle) {
    if (computedStyle === void 0) computedStyle = (0, $f5d873c94758f78f$export$38b2d434cce3ea22)(element).getComputedStyle(element);
    const overflowRegex = /(auto|scroll|overlay)/;
    const properties = [
        'overflow',
        'overflowX',
        'overflowY'
    ];
    return properties.some((property)=>{
        const value = computedStyle[property];
        return typeof value === 'string' ? overflowRegex.test(value) : false;
    });
}
function $3b30af0a3bfceeb3$export$e4864aa91b5ed091(element, limit) {
    const scrollParents = [];
    function findScrollableAncestors(node) {
        if (limit != null && scrollParents.length >= limit) return scrollParents;
        if (!node) return scrollParents;
        if ((0, $f5d873c94758f78f$export$62858bae88b53fd0)(node) && node.scrollingElement != null && !scrollParents.includes(node.scrollingElement)) {
            scrollParents.push(node.scrollingElement);
            return scrollParents;
        }
        if (!(0, $f5d873c94758f78f$export$1b3bfaa9684536aa)(node) || (0, $f5d873c94758f78f$export$17eda790a720ec57)(node)) return scrollParents;
        if (scrollParents.includes(node)) return scrollParents;
        const computedStyle = (0, $f5d873c94758f78f$export$38b2d434cce3ea22)(element).getComputedStyle(node);
        if (node !== element) {
            if ($3b30af0a3bfceeb3$var$isScrollable(node, computedStyle)) scrollParents.push(node);
        }
        if ($3b30af0a3bfceeb3$var$isFixed(node, computedStyle)) return scrollParents;
        return findScrollableAncestors(node.parentNode);
    }
    if (!element) return scrollParents;
    return findScrollableAncestors(element);
}
function $3b30af0a3bfceeb3$var$getFirstScrollableAncestor(node) {
    const [firstScrollableAncestor] = $3b30af0a3bfceeb3$export$e4864aa91b5ed091(node, 1);
    return firstScrollableAncestor != null ? firstScrollableAncestor : null;
}
function $3b30af0a3bfceeb3$var$getScrollableElement(element) {
    if (!(0, $f5d873c94758f78f$export$71594e8a50f746f4) || !element) return null;
    if ((0, $f5d873c94758f78f$export$5a096129d439f843)(element)) return element;
    if (!(0, $f5d873c94758f78f$export$8ee0fc9ee280b4ee)(element)) return null;
    if ((0, $f5d873c94758f78f$export$62858bae88b53fd0)(element) || element === (0, $f5d873c94758f78f$export$b204af158042fbac)(element).scrollingElement) return window;
    if ((0, $f5d873c94758f78f$export$1b3bfaa9684536aa)(element)) return element;
    return null;
}
function $3b30af0a3bfceeb3$var$getScrollXCoordinate(element) {
    if ((0, $f5d873c94758f78f$export$5a096129d439f843)(element)) return element.scrollX;
    return element.scrollLeft;
}
function $3b30af0a3bfceeb3$var$getScrollYCoordinate(element) {
    if ((0, $f5d873c94758f78f$export$5a096129d439f843)(element)) return element.scrollY;
    return element.scrollTop;
}
function $3b30af0a3bfceeb3$var$getScrollCoordinates(element) {
    return {
        x: $3b30af0a3bfceeb3$var$getScrollXCoordinate(element),
        y: $3b30af0a3bfceeb3$var$getScrollYCoordinate(element)
    };
}
var $3b30af0a3bfceeb3$var$Direction;
(function(Direction) {
    Direction[Direction["Forward"] = 1] = "Forward";
    Direction[Direction["Backward"] = -1] = "Backward";
})($3b30af0a3bfceeb3$var$Direction || ($3b30af0a3bfceeb3$var$Direction = {}));
function $3b30af0a3bfceeb3$var$isDocumentScrollingElement(element) {
    if (!(0, $f5d873c94758f78f$export$71594e8a50f746f4) || !element) return false;
    return element === document.scrollingElement;
}
function $3b30af0a3bfceeb3$var$getScrollPosition(scrollingContainer) {
    const minScroll = {
        x: 0,
        y: 0
    };
    const dimensions = $3b30af0a3bfceeb3$var$isDocumentScrollingElement(scrollingContainer) ? {
        height: window.innerHeight,
        width: window.innerWidth
    } : {
        height: scrollingContainer.clientHeight,
        width: scrollingContainer.clientWidth
    };
    const maxScroll = {
        x: scrollingContainer.scrollWidth - dimensions.width,
        y: scrollingContainer.scrollHeight - dimensions.height
    };
    const isTop = scrollingContainer.scrollTop <= minScroll.y;
    const isLeft = scrollingContainer.scrollLeft <= minScroll.x;
    const isBottom = scrollingContainer.scrollTop >= maxScroll.y;
    const isRight = scrollingContainer.scrollLeft >= maxScroll.x;
    return {
        isTop: isTop,
        isLeft: isLeft,
        isBottom: isBottom,
        isRight: isRight,
        maxScroll: maxScroll,
        minScroll: minScroll
    };
}
const $3b30af0a3bfceeb3$var$defaultThreshold = {
    x: 0.2,
    y: 0.2
};
function $3b30af0a3bfceeb3$var$getScrollDirectionAndSpeed(scrollContainer, scrollContainerRect, _ref, acceleration, thresholdPercentage) {
    let { top: top, left: left, right: right, bottom: bottom } = _ref;
    if (acceleration === void 0) acceleration = 10;
    if (thresholdPercentage === void 0) thresholdPercentage = $3b30af0a3bfceeb3$var$defaultThreshold;
    const { isTop: isTop, isBottom: isBottom, isLeft: isLeft, isRight: isRight } = $3b30af0a3bfceeb3$var$getScrollPosition(scrollContainer);
    const direction = {
        x: 0,
        y: 0
    };
    const speed = {
        x: 0,
        y: 0
    };
    const threshold = {
        height: scrollContainerRect.height * thresholdPercentage.y,
        width: scrollContainerRect.width * thresholdPercentage.x
    };
    if (!isTop && top <= scrollContainerRect.top + threshold.height) {
        // Scroll Up
        direction.y = $3b30af0a3bfceeb3$var$Direction.Backward;
        speed.y = acceleration * Math.abs((scrollContainerRect.top + threshold.height - top) / threshold.height);
    } else if (!isBottom && bottom >= scrollContainerRect.bottom - threshold.height) {
        // Scroll Down
        direction.y = $3b30af0a3bfceeb3$var$Direction.Forward;
        speed.y = acceleration * Math.abs((scrollContainerRect.bottom - threshold.height - bottom) / threshold.height);
    }
    if (!isRight && right >= scrollContainerRect.right - threshold.width) {
        // Scroll Right
        direction.x = $3b30af0a3bfceeb3$var$Direction.Forward;
        speed.x = acceleration * Math.abs((scrollContainerRect.right - threshold.width - right) / threshold.width);
    } else if (!isLeft && left <= scrollContainerRect.left + threshold.width) {
        // Scroll Left
        direction.x = $3b30af0a3bfceeb3$var$Direction.Backward;
        speed.x = acceleration * Math.abs((scrollContainerRect.left + threshold.width - left) / threshold.width);
    }
    return {
        direction: direction,
        speed: speed
    };
}
function $3b30af0a3bfceeb3$var$getScrollElementRect(element) {
    if (element === document.scrollingElement) {
        const { innerWidth: innerWidth, innerHeight: innerHeight } = window;
        return {
            top: 0,
            left: 0,
            right: innerWidth,
            bottom: innerHeight,
            width: innerWidth,
            height: innerHeight
        };
    }
    const { top: top, left: left, right: right, bottom: bottom } = element.getBoundingClientRect();
    return {
        top: top,
        left: left,
        right: right,
        bottom: bottom,
        width: element.clientWidth,
        height: element.clientHeight
    };
}
function $3b30af0a3bfceeb3$var$getScrollOffsets(scrollableAncestors) {
    return scrollableAncestors.reduce((acc, node)=>{
        return (0, $f5d873c94758f78f$export$e16d8520af44a096)(acc, $3b30af0a3bfceeb3$var$getScrollCoordinates(node));
    }, $3b30af0a3bfceeb3$export$597cbd7bbd10deb4);
}
function $3b30af0a3bfceeb3$var$getScrollXOffset(scrollableAncestors) {
    return scrollableAncestors.reduce((acc, node)=>{
        return acc + $3b30af0a3bfceeb3$var$getScrollXCoordinate(node);
    }, 0);
}
function $3b30af0a3bfceeb3$var$getScrollYOffset(scrollableAncestors) {
    return scrollableAncestors.reduce((acc, node)=>{
        return acc + $3b30af0a3bfceeb3$var$getScrollYCoordinate(node);
    }, 0);
}
function $3b30af0a3bfceeb3$var$scrollIntoViewIfNeeded(element, measure) {
    if (measure === void 0) measure = $3b30af0a3bfceeb3$export$b6aa1f30c53d7454;
    if (!element) return;
    const { top: top, left: left, bottom: bottom, right: right } = measure(element);
    const firstScrollableAncestor = $3b30af0a3bfceeb3$var$getFirstScrollableAncestor(element);
    if (!firstScrollableAncestor) return;
    if (bottom <= 0 || right <= 0 || top >= window.innerHeight || left >= window.innerWidth) element.scrollIntoView({
        block: 'center',
        inline: 'center'
    });
}
const $3b30af0a3bfceeb3$var$properties = [
    [
        'x',
        [
            'left',
            'right'
        ],
        $3b30af0a3bfceeb3$var$getScrollXOffset
    ],
    [
        'y',
        [
            'top',
            'bottom'
        ],
        $3b30af0a3bfceeb3$var$getScrollYOffset
    ]
];
class $3b30af0a3bfceeb3$var$Rect {
    constructor(rect, element){
        this.rect = void 0;
        this.width = void 0;
        this.height = void 0;
        this.top = void 0;
        this.bottom = void 0;
        this.right = void 0;
        this.left = void 0;
        const scrollableAncestors = $3b30af0a3bfceeb3$export$e4864aa91b5ed091(element);
        const scrollOffsets = $3b30af0a3bfceeb3$var$getScrollOffsets(scrollableAncestors);
        this.rect = {
            ...rect
        };
        this.width = rect.width;
        this.height = rect.height;
        for (const [axis, keys, getScrollOffset] of $3b30af0a3bfceeb3$var$properties)for (const key of keys)Object.defineProperty(this, key, {
            get: ()=>{
                const currentOffsets = getScrollOffset(scrollableAncestors);
                const scrollOffsetsDeltla = scrollOffsets[axis] - currentOffsets;
                return this.rect[key] + scrollOffsetsDeltla;
            },
            enumerable: true
        });
        Object.defineProperty(this, 'rect', {
            enumerable: false
        });
    }
}
class $3b30af0a3bfceeb3$var$Listeners {
    constructor(target){
        this.target = void 0;
        this.listeners = [];
        this.removeAll = ()=>{
            this.listeners.forEach((listener)=>{
                var _this$target;
                return (_this$target = this.target) == null ? void 0 : _this$target.removeEventListener(...listener);
            });
        };
        this.target = target;
    }
    add(eventName, handler, options) {
        var _this$target2;
        (_this$target2 = this.target) == null || _this$target2.addEventListener(eventName, handler, options);
        this.listeners.push([
            eventName,
            handler,
            options
        ]);
    }
}
function $3b30af0a3bfceeb3$var$getEventListenerTarget(target) {
    // If the `event.target` element is removed from the document events will still be targeted
    // at it, and hence won't always bubble up to the window or document anymore.
    // If there is any risk of an element being removed while it is being dragged,
    // the best practice is to attach the event listeners directly to the target.
    // https://developer.mozilla.org/en-US/docs/Web/API/EventTarget
    const { EventTarget: EventTarget } = (0, $f5d873c94758f78f$export$38b2d434cce3ea22)(target);
    return target instanceof EventTarget ? target : (0, $f5d873c94758f78f$export$b204af158042fbac)(target);
}
function $3b30af0a3bfceeb3$var$hasExceededDistance(delta, measurement) {
    const dx = Math.abs(delta.x);
    const dy = Math.abs(delta.y);
    if (typeof measurement === 'number') return Math.sqrt(dx ** 2 + dy ** 2) > measurement;
    if ('x' in measurement && 'y' in measurement) return dx > measurement.x && dy > measurement.y;
    if ('x' in measurement) return dx > measurement.x;
    if ('y' in measurement) return dy > measurement.y;
    return false;
}
var $3b30af0a3bfceeb3$var$EventName;
(function(EventName) {
    EventName["Click"] = "click";
    EventName["DragStart"] = "dragstart";
    EventName["Keydown"] = "keydown";
    EventName["ContextMenu"] = "contextmenu";
    EventName["Resize"] = "resize";
    EventName["SelectionChange"] = "selectionchange";
    EventName["VisibilityChange"] = "visibilitychange";
})($3b30af0a3bfceeb3$var$EventName || ($3b30af0a3bfceeb3$var$EventName = {}));
function $3b30af0a3bfceeb3$var$preventDefault(event) {
    event.preventDefault();
}
function $3b30af0a3bfceeb3$var$stopPropagation(event) {
    event.stopPropagation();
}
var $3b30af0a3bfceeb3$export$a8b1916dba3ae88b;
(function(KeyboardCode) {
    KeyboardCode["Space"] = "Space";
    KeyboardCode["Down"] = "ArrowDown";
    KeyboardCode["Right"] = "ArrowRight";
    KeyboardCode["Left"] = "ArrowLeft";
    KeyboardCode["Up"] = "ArrowUp";
    KeyboardCode["Esc"] = "Escape";
    KeyboardCode["Enter"] = "Enter";
    KeyboardCode["Tab"] = "Tab";
})($3b30af0a3bfceeb3$export$a8b1916dba3ae88b || ($3b30af0a3bfceeb3$export$a8b1916dba3ae88b = {}));
const $3b30af0a3bfceeb3$var$defaultKeyboardCodes = {
    start: [
        $3b30af0a3bfceeb3$export$a8b1916dba3ae88b.Space,
        $3b30af0a3bfceeb3$export$a8b1916dba3ae88b.Enter
    ],
    cancel: [
        $3b30af0a3bfceeb3$export$a8b1916dba3ae88b.Esc
    ],
    end: [
        $3b30af0a3bfceeb3$export$a8b1916dba3ae88b.Space,
        $3b30af0a3bfceeb3$export$a8b1916dba3ae88b.Enter,
        $3b30af0a3bfceeb3$export$a8b1916dba3ae88b.Tab
    ]
};
const $3b30af0a3bfceeb3$export$ae4c9a18005b0235 = (event, _ref)=>{
    let { currentCoordinates: currentCoordinates } = _ref;
    switch(event.code){
        case $3b30af0a3bfceeb3$export$a8b1916dba3ae88b.Right:
            return {
                ...currentCoordinates,
                x: currentCoordinates.x + 25
            };
        case $3b30af0a3bfceeb3$export$a8b1916dba3ae88b.Left:
            return {
                ...currentCoordinates,
                x: currentCoordinates.x - 25
            };
        case $3b30af0a3bfceeb3$export$a8b1916dba3ae88b.Down:
            return {
                ...currentCoordinates,
                y: currentCoordinates.y + 25
            };
        case $3b30af0a3bfceeb3$export$a8b1916dba3ae88b.Up:
            return {
                ...currentCoordinates,
                y: currentCoordinates.y - 25
            };
    }
    return undefined;
};
class $3b30af0a3bfceeb3$export$44d67f2a438aeba9 {
    constructor(props){
        this.props = void 0;
        this.autoScrollEnabled = false;
        this.referenceCoordinates = void 0;
        this.listeners = void 0;
        this.windowListeners = void 0;
        this.props = props;
        const { event: { target: target } } = props;
        this.props = props;
        this.listeners = new $3b30af0a3bfceeb3$var$Listeners((0, $f5d873c94758f78f$export$b204af158042fbac)(target));
        this.windowListeners = new $3b30af0a3bfceeb3$var$Listeners((0, $f5d873c94758f78f$export$38b2d434cce3ea22)(target));
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.attach();
    }
    attach() {
        this.handleStart();
        this.windowListeners.add($3b30af0a3bfceeb3$var$EventName.Resize, this.handleCancel);
        this.windowListeners.add($3b30af0a3bfceeb3$var$EventName.VisibilityChange, this.handleCancel);
        setTimeout(()=>this.listeners.add($3b30af0a3bfceeb3$var$EventName.Keydown, this.handleKeyDown));
    }
    handleStart() {
        const { activeNode: activeNode, onStart: onStart } = this.props;
        const node = activeNode.node.current;
        if (node) $3b30af0a3bfceeb3$var$scrollIntoViewIfNeeded(node);
        onStart($3b30af0a3bfceeb3$export$597cbd7bbd10deb4);
    }
    handleKeyDown(event) {
        if ((0, $f5d873c94758f78f$export$130b789831072f4c)(event)) {
            const { active: active, context: context, options: options } = this.props;
            const { keyboardCodes: keyboardCodes = $3b30af0a3bfceeb3$var$defaultKeyboardCodes, coordinateGetter: coordinateGetter = $3b30af0a3bfceeb3$export$ae4c9a18005b0235, scrollBehavior: scrollBehavior = 'smooth' } = options;
            const { code: code } = event;
            if (keyboardCodes.end.includes(code)) {
                this.handleEnd(event);
                return;
            }
            if (keyboardCodes.cancel.includes(code)) {
                this.handleCancel(event);
                return;
            }
            const { collisionRect: collisionRect } = context.current;
            const currentCoordinates = collisionRect ? {
                x: collisionRect.left,
                y: collisionRect.top
            } : $3b30af0a3bfceeb3$export$597cbd7bbd10deb4;
            if (!this.referenceCoordinates) this.referenceCoordinates = currentCoordinates;
            const newCoordinates = coordinateGetter(event, {
                active: active,
                context: context.current,
                currentCoordinates: currentCoordinates
            });
            if (newCoordinates) {
                const coordinatesDelta = (0, $f5d873c94758f78f$export$4e2d2ead65e5f7e3)(newCoordinates, currentCoordinates);
                const scrollDelta = {
                    x: 0,
                    y: 0
                };
                const { scrollableAncestors: scrollableAncestors } = context.current;
                for (const scrollContainer of scrollableAncestors){
                    const direction = event.code;
                    const { isTop: isTop, isRight: isRight, isLeft: isLeft, isBottom: isBottom, maxScroll: maxScroll, minScroll: minScroll } = $3b30af0a3bfceeb3$var$getScrollPosition(scrollContainer);
                    const scrollElementRect = $3b30af0a3bfceeb3$var$getScrollElementRect(scrollContainer);
                    const clampedCoordinates = {
                        x: Math.min(direction === $3b30af0a3bfceeb3$export$a8b1916dba3ae88b.Right ? scrollElementRect.right - scrollElementRect.width / 2 : scrollElementRect.right, Math.max(direction === $3b30af0a3bfceeb3$export$a8b1916dba3ae88b.Right ? scrollElementRect.left : scrollElementRect.left + scrollElementRect.width / 2, newCoordinates.x)),
                        y: Math.min(direction === $3b30af0a3bfceeb3$export$a8b1916dba3ae88b.Down ? scrollElementRect.bottom - scrollElementRect.height / 2 : scrollElementRect.bottom, Math.max(direction === $3b30af0a3bfceeb3$export$a8b1916dba3ae88b.Down ? scrollElementRect.top : scrollElementRect.top + scrollElementRect.height / 2, newCoordinates.y))
                    };
                    const canScrollX = direction === $3b30af0a3bfceeb3$export$a8b1916dba3ae88b.Right && !isRight || direction === $3b30af0a3bfceeb3$export$a8b1916dba3ae88b.Left && !isLeft;
                    const canScrollY = direction === $3b30af0a3bfceeb3$export$a8b1916dba3ae88b.Down && !isBottom || direction === $3b30af0a3bfceeb3$export$a8b1916dba3ae88b.Up && !isTop;
                    if (canScrollX && clampedCoordinates.x !== newCoordinates.x) {
                        const newScrollCoordinates = scrollContainer.scrollLeft + coordinatesDelta.x;
                        const canScrollToNewCoordinates = direction === $3b30af0a3bfceeb3$export$a8b1916dba3ae88b.Right && newScrollCoordinates <= maxScroll.x || direction === $3b30af0a3bfceeb3$export$a8b1916dba3ae88b.Left && newScrollCoordinates >= minScroll.x;
                        if (canScrollToNewCoordinates && !coordinatesDelta.y) {
                            // We don't need to update coordinates, the scroll adjustment alone will trigger
                            // logic to auto-detect the new container we are over
                            scrollContainer.scrollTo({
                                left: newScrollCoordinates,
                                behavior: scrollBehavior
                            });
                            return;
                        }
                        if (canScrollToNewCoordinates) scrollDelta.x = scrollContainer.scrollLeft - newScrollCoordinates;
                        else scrollDelta.x = direction === $3b30af0a3bfceeb3$export$a8b1916dba3ae88b.Right ? scrollContainer.scrollLeft - maxScroll.x : scrollContainer.scrollLeft - minScroll.x;
                        if (scrollDelta.x) scrollContainer.scrollBy({
                            left: -scrollDelta.x,
                            behavior: scrollBehavior
                        });
                        break;
                    } else if (canScrollY && clampedCoordinates.y !== newCoordinates.y) {
                        const newScrollCoordinates = scrollContainer.scrollTop + coordinatesDelta.y;
                        const canScrollToNewCoordinates = direction === $3b30af0a3bfceeb3$export$a8b1916dba3ae88b.Down && newScrollCoordinates <= maxScroll.y || direction === $3b30af0a3bfceeb3$export$a8b1916dba3ae88b.Up && newScrollCoordinates >= minScroll.y;
                        if (canScrollToNewCoordinates && !coordinatesDelta.x) {
                            // We don't need to update coordinates, the scroll adjustment alone will trigger
                            // logic to auto-detect the new container we are over
                            scrollContainer.scrollTo({
                                top: newScrollCoordinates,
                                behavior: scrollBehavior
                            });
                            return;
                        }
                        if (canScrollToNewCoordinates) scrollDelta.y = scrollContainer.scrollTop - newScrollCoordinates;
                        else scrollDelta.y = direction === $3b30af0a3bfceeb3$export$a8b1916dba3ae88b.Down ? scrollContainer.scrollTop - maxScroll.y : scrollContainer.scrollTop - minScroll.y;
                        if (scrollDelta.y) scrollContainer.scrollBy({
                            top: -scrollDelta.y,
                            behavior: scrollBehavior
                        });
                        break;
                    }
                }
                this.handleMove(event, (0, $f5d873c94758f78f$export$e16d8520af44a096)((0, $f5d873c94758f78f$export$4e2d2ead65e5f7e3)(newCoordinates, this.referenceCoordinates), scrollDelta));
            }
        }
    }
    handleMove(event, coordinates) {
        const { onMove: onMove } = this.props;
        event.preventDefault();
        onMove(coordinates);
    }
    handleEnd(event) {
        const { onEnd: onEnd } = this.props;
        event.preventDefault();
        this.detach();
        onEnd();
    }
    handleCancel(event) {
        const { onCancel: onCancel } = this.props;
        event.preventDefault();
        this.detach();
        onCancel();
    }
    detach() {
        this.listeners.removeAll();
        this.windowListeners.removeAll();
    }
}
$3b30af0a3bfceeb3$export$44d67f2a438aeba9.activators = [
    {
        eventName: 'onKeyDown',
        handler: (event, _ref, _ref2)=>{
            let { keyboardCodes: keyboardCodes = $3b30af0a3bfceeb3$var$defaultKeyboardCodes, onActivation: onActivation } = _ref;
            let { active: active } = _ref2;
            const { code: code } = event.nativeEvent;
            if (keyboardCodes.start.includes(code)) {
                const activator = active.activatorNode.current;
                if (activator && event.target !== activator) return false;
                event.preventDefault();
                onActivation == null || onActivation({
                    event: event.nativeEvent
                });
                return true;
            }
            return false;
        }
    }
];
function $3b30af0a3bfceeb3$var$isDistanceConstraint(constraint) {
    return Boolean(constraint && 'distance' in constraint);
}
function $3b30af0a3bfceeb3$var$isDelayConstraint(constraint) {
    return Boolean(constraint && 'delay' in constraint);
}
class $3b30af0a3bfceeb3$var$AbstractPointerSensor {
    constructor(props, events, listenerTarget){
        var _getEventCoordinates;
        if (listenerTarget === void 0) listenerTarget = $3b30af0a3bfceeb3$var$getEventListenerTarget(props.event.target);
        this.props = void 0;
        this.events = void 0;
        this.autoScrollEnabled = true;
        this.document = void 0;
        this.activated = false;
        this.initialCoordinates = void 0;
        this.timeoutId = null;
        this.listeners = void 0;
        this.documentListeners = void 0;
        this.windowListeners = void 0;
        this.props = props;
        this.events = events;
        const { event: event } = props;
        const { target: target } = event;
        this.props = props;
        this.events = events;
        this.document = (0, $f5d873c94758f78f$export$b204af158042fbac)(target);
        this.documentListeners = new $3b30af0a3bfceeb3$var$Listeners(this.document);
        this.listeners = new $3b30af0a3bfceeb3$var$Listeners(listenerTarget);
        this.windowListeners = new $3b30af0a3bfceeb3$var$Listeners((0, $f5d873c94758f78f$export$38b2d434cce3ea22)(target));
        this.initialCoordinates = (_getEventCoordinates = (0, $f5d873c94758f78f$export$36195c8aa1517e04)(event)) != null ? _getEventCoordinates : $3b30af0a3bfceeb3$export$597cbd7bbd10deb4;
        this.handleStart = this.handleStart.bind(this);
        this.handleMove = this.handleMove.bind(this);
        this.handleEnd = this.handleEnd.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
        this.removeTextSelection = this.removeTextSelection.bind(this);
        this.attach();
    }
    attach() {
        const { events: events, props: { options: { activationConstraint: activationConstraint, bypassActivationConstraint: bypassActivationConstraint } } } = this;
        this.listeners.add(events.move.name, this.handleMove, {
            passive: false
        });
        this.listeners.add(events.end.name, this.handleEnd);
        if (events.cancel) this.listeners.add(events.cancel.name, this.handleCancel);
        this.windowListeners.add($3b30af0a3bfceeb3$var$EventName.Resize, this.handleCancel);
        this.windowListeners.add($3b30af0a3bfceeb3$var$EventName.DragStart, $3b30af0a3bfceeb3$var$preventDefault);
        this.windowListeners.add($3b30af0a3bfceeb3$var$EventName.VisibilityChange, this.handleCancel);
        this.windowListeners.add($3b30af0a3bfceeb3$var$EventName.ContextMenu, $3b30af0a3bfceeb3$var$preventDefault);
        this.documentListeners.add($3b30af0a3bfceeb3$var$EventName.Keydown, this.handleKeydown);
        if (activationConstraint) {
            if (bypassActivationConstraint != null && bypassActivationConstraint({
                event: this.props.event,
                activeNode: this.props.activeNode,
                options: this.props.options
            })) return this.handleStart();
            if ($3b30af0a3bfceeb3$var$isDelayConstraint(activationConstraint)) {
                this.timeoutId = setTimeout(this.handleStart, activationConstraint.delay);
                this.handlePending(activationConstraint);
                return;
            }
            if ($3b30af0a3bfceeb3$var$isDistanceConstraint(activationConstraint)) {
                this.handlePending(activationConstraint);
                return;
            }
        }
        this.handleStart();
    }
    detach() {
        this.listeners.removeAll();
        this.windowListeners.removeAll(); // Wait until the next event loop before removing document listeners
        // This is necessary because we listen for `click` and `selection` events on the document
        setTimeout(this.documentListeners.removeAll, 50);
        if (this.timeoutId !== null) {
            clearTimeout(this.timeoutId);
            this.timeoutId = null;
        }
    }
    handlePending(constraint, offset) {
        const { active: active, onPending: onPending } = this.props;
        onPending(active, constraint, this.initialCoordinates, offset);
    }
    handleStart() {
        const { initialCoordinates: initialCoordinates } = this;
        const { onStart: onStart } = this.props;
        if (initialCoordinates) {
            this.activated = true; // Stop propagation of click events once activation constraints are met
            this.documentListeners.add($3b30af0a3bfceeb3$var$EventName.Click, $3b30af0a3bfceeb3$var$stopPropagation, {
                capture: true
            }); // Remove any text selection from the document
            this.removeTextSelection(); // Prevent further text selection while dragging
            this.documentListeners.add($3b30af0a3bfceeb3$var$EventName.SelectionChange, this.removeTextSelection);
            onStart(initialCoordinates);
        }
    }
    handleMove(event) {
        var _getEventCoordinates2;
        const { activated: activated, initialCoordinates: initialCoordinates, props: props } = this;
        const { onMove: onMove, options: { activationConstraint: activationConstraint } } = props;
        if (!initialCoordinates) return;
        const coordinates = (_getEventCoordinates2 = (0, $f5d873c94758f78f$export$36195c8aa1517e04)(event)) != null ? _getEventCoordinates2 : $3b30af0a3bfceeb3$export$597cbd7bbd10deb4;
        const delta = (0, $f5d873c94758f78f$export$4e2d2ead65e5f7e3)(initialCoordinates, coordinates); // Constraint validation
        if (!activated && activationConstraint) {
            if ($3b30af0a3bfceeb3$var$isDistanceConstraint(activationConstraint)) {
                if (activationConstraint.tolerance != null && $3b30af0a3bfceeb3$var$hasExceededDistance(delta, activationConstraint.tolerance)) return this.handleCancel();
                if ($3b30af0a3bfceeb3$var$hasExceededDistance(delta, activationConstraint.distance)) return this.handleStart();
            }
            if ($3b30af0a3bfceeb3$var$isDelayConstraint(activationConstraint)) {
                if ($3b30af0a3bfceeb3$var$hasExceededDistance(delta, activationConstraint.tolerance)) return this.handleCancel();
            }
            this.handlePending(activationConstraint, delta);
            return;
        }
        if (event.cancelable) event.preventDefault();
        onMove(coordinates);
    }
    handleEnd() {
        const { onAbort: onAbort, onEnd: onEnd } = this.props;
        this.detach();
        if (!this.activated) onAbort(this.props.active);
        onEnd();
    }
    handleCancel() {
        const { onAbort: onAbort, onCancel: onCancel } = this.props;
        this.detach();
        if (!this.activated) onAbort(this.props.active);
        onCancel();
    }
    handleKeydown(event) {
        if (event.code === $3b30af0a3bfceeb3$export$a8b1916dba3ae88b.Esc) this.handleCancel();
    }
    removeTextSelection() {
        var _this$document$getSel;
        (_this$document$getSel = this.document.getSelection()) == null || _this$document$getSel.removeAllRanges();
    }
}
const $3b30af0a3bfceeb3$var$events = {
    cancel: {
        name: 'pointercancel'
    },
    move: {
        name: 'pointermove'
    },
    end: {
        name: 'pointerup'
    }
};
class $3b30af0a3bfceeb3$export$b26af955418d6638 extends $3b30af0a3bfceeb3$var$AbstractPointerSensor {
    constructor(props){
        const { event: event } = props; // Pointer events stop firing if the target is unmounted while dragging
        // Therefore we attach listeners to the owner document instead
        const listenerTarget = (0, $f5d873c94758f78f$export$b204af158042fbac)(event.target);
        super(props, $3b30af0a3bfceeb3$var$events, listenerTarget);
    }
}
$3b30af0a3bfceeb3$export$b26af955418d6638.activators = [
    {
        eventName: 'onPointerDown',
        handler: (_ref, _ref2)=>{
            let { nativeEvent: event } = _ref;
            let { onActivation: onActivation } = _ref2;
            if (!event.isPrimary || event.button !== 0) return false;
            onActivation == null || onActivation({
                event: event
            });
            return true;
        }
    }
];
const $3b30af0a3bfceeb3$var$events$1 = {
    move: {
        name: 'mousemove'
    },
    end: {
        name: 'mouseup'
    }
};
var $3b30af0a3bfceeb3$var$MouseButton;
(function(MouseButton) {
    MouseButton[MouseButton["RightClick"] = 2] = "RightClick";
})($3b30af0a3bfceeb3$var$MouseButton || ($3b30af0a3bfceeb3$var$MouseButton = {}));
class $3b30af0a3bfceeb3$export$b28554b50bf7f273 extends $3b30af0a3bfceeb3$var$AbstractPointerSensor {
    constructor(props){
        super(props, $3b30af0a3bfceeb3$var$events$1, (0, $f5d873c94758f78f$export$b204af158042fbac)(props.event.target));
    }
}
$3b30af0a3bfceeb3$export$b28554b50bf7f273.activators = [
    {
        eventName: 'onMouseDown',
        handler: (_ref, _ref2)=>{
            let { nativeEvent: event } = _ref;
            let { onActivation: onActivation } = _ref2;
            if (event.button === $3b30af0a3bfceeb3$var$MouseButton.RightClick) return false;
            onActivation == null || onActivation({
                event: event
            });
            return true;
        }
    }
];
const $3b30af0a3bfceeb3$var$events$2 = {
    cancel: {
        name: 'touchcancel'
    },
    move: {
        name: 'touchmove'
    },
    end: {
        name: 'touchend'
    }
};
class $3b30af0a3bfceeb3$export$19b41baf2e1bcdc0 extends $3b30af0a3bfceeb3$var$AbstractPointerSensor {
    constructor(props){
        super(props, $3b30af0a3bfceeb3$var$events$2);
    }
    static setup() {
        // Adding a non-capture and non-passive `touchmove` listener in order
        // to force `event.preventDefault()` calls to work in dynamically added
        // touchmove event handlers. This is required for iOS Safari.
        window.addEventListener($3b30af0a3bfceeb3$var$events$2.move.name, noop, {
            capture: false,
            passive: false
        });
        return function teardown() {
            window.removeEventListener($3b30af0a3bfceeb3$var$events$2.move.name, noop);
        }; // We create a new handler because the teardown function of another sensor
        // could remove our event listener if we use a referentially equal listener.
        function noop() {}
    }
}
$3b30af0a3bfceeb3$export$19b41baf2e1bcdc0.activators = [
    {
        eventName: 'onTouchStart',
        handler: (_ref, _ref2)=>{
            let { nativeEvent: event } = _ref;
            let { onActivation: onActivation } = _ref2;
            const { touches: touches } = event;
            if (touches.length > 1) return false;
            onActivation == null || onActivation({
                event: event
            });
            return true;
        }
    }
];
var $3b30af0a3bfceeb3$export$eefe60e26f04c318;
(function(AutoScrollActivator) {
    AutoScrollActivator[AutoScrollActivator["Pointer"] = 0] = "Pointer";
    AutoScrollActivator[AutoScrollActivator["DraggableRect"] = 1] = "DraggableRect";
})($3b30af0a3bfceeb3$export$eefe60e26f04c318 || ($3b30af0a3bfceeb3$export$eefe60e26f04c318 = {}));
var $3b30af0a3bfceeb3$export$f93aa492a37e1b0e;
(function(TraversalOrder) {
    TraversalOrder[TraversalOrder["TreeOrder"] = 0] = "TreeOrder";
    TraversalOrder[TraversalOrder["ReversedTreeOrder"] = 1] = "ReversedTreeOrder";
})($3b30af0a3bfceeb3$export$f93aa492a37e1b0e || ($3b30af0a3bfceeb3$export$f93aa492a37e1b0e = {}));
function $3b30af0a3bfceeb3$var$useAutoScroller(_ref) {
    let { acceleration: acceleration, activator: activator = $3b30af0a3bfceeb3$export$eefe60e26f04c318.Pointer, canScroll: canScroll, draggingRect: draggingRect, enabled: enabled, interval: interval = 5, order: order = $3b30af0a3bfceeb3$export$f93aa492a37e1b0e.TreeOrder, pointerCoordinates: pointerCoordinates, scrollableAncestors: scrollableAncestors, scrollableAncestorRects: scrollableAncestorRects, delta: delta, threshold: threshold } = _ref;
    const scrollIntent = $3b30af0a3bfceeb3$var$useScrollIntent({
        delta: delta,
        disabled: !enabled
    });
    const [setAutoScrollInterval, clearAutoScrollInterval] = (0, $f5d873c94758f78f$export$f4b266cd2aae9cb1)();
    const scrollSpeed = (0, $kc00y.useRef)({
        x: 0,
        y: 0
    });
    const scrollDirection = (0, $kc00y.useRef)({
        x: 0,
        y: 0
    });
    const rect = (0, $kc00y.useMemo)(()=>{
        switch(activator){
            case $3b30af0a3bfceeb3$export$eefe60e26f04c318.Pointer:
                return pointerCoordinates ? {
                    top: pointerCoordinates.y,
                    bottom: pointerCoordinates.y,
                    left: pointerCoordinates.x,
                    right: pointerCoordinates.x
                } : null;
            case $3b30af0a3bfceeb3$export$eefe60e26f04c318.DraggableRect:
                return draggingRect;
        }
    }, [
        activator,
        draggingRect,
        pointerCoordinates
    ]);
    const scrollContainerRef = (0, $kc00y.useRef)(null);
    const autoScroll = (0, $kc00y.useCallback)(()=>{
        const scrollContainer = scrollContainerRef.current;
        if (!scrollContainer) return;
        const scrollLeft = scrollSpeed.current.x * scrollDirection.current.x;
        const scrollTop = scrollSpeed.current.y * scrollDirection.current.y;
        scrollContainer.scrollBy(scrollLeft, scrollTop);
    }, []);
    const sortedScrollableAncestors = (0, $kc00y.useMemo)(()=>order === $3b30af0a3bfceeb3$export$f93aa492a37e1b0e.TreeOrder ? [
            ...scrollableAncestors
        ].reverse() : scrollableAncestors, [
        order,
        scrollableAncestors
    ]);
    (0, $kc00y.useEffect)(()=>{
        if (!enabled || !scrollableAncestors.length || !rect) {
            clearAutoScrollInterval();
            return;
        }
        for (const scrollContainer of sortedScrollableAncestors){
            if ((canScroll == null ? void 0 : canScroll(scrollContainer)) === false) continue;
            const index = scrollableAncestors.indexOf(scrollContainer);
            const scrollContainerRect = scrollableAncestorRects[index];
            if (!scrollContainerRect) continue;
            const { direction: direction, speed: speed } = $3b30af0a3bfceeb3$var$getScrollDirectionAndSpeed(scrollContainer, scrollContainerRect, rect, acceleration, threshold);
            for (const axis of [
                'x',
                'y'
            ])if (!scrollIntent[axis][direction[axis]]) {
                speed[axis] = 0;
                direction[axis] = 0;
            }
            if (speed.x > 0 || speed.y > 0) {
                clearAutoScrollInterval();
                scrollContainerRef.current = scrollContainer;
                setAutoScrollInterval(autoScroll, interval);
                scrollSpeed.current = speed;
                scrollDirection.current = direction;
                return;
            }
        }
        scrollSpeed.current = {
            x: 0,
            y: 0
        };
        scrollDirection.current = {
            x: 0,
            y: 0
        };
        clearAutoScrollInterval();
    }, [
        acceleration,
        autoScroll,
        canScroll,
        clearAutoScrollInterval,
        enabled,
        interval,
        JSON.stringify(rect),
        JSON.stringify(scrollIntent),
        setAutoScrollInterval,
        scrollableAncestors,
        sortedScrollableAncestors,
        scrollableAncestorRects,
        JSON.stringify(threshold)
    ]);
}
const $3b30af0a3bfceeb3$var$defaultScrollIntent = {
    x: {
        [$3b30af0a3bfceeb3$var$Direction.Backward]: false,
        [$3b30af0a3bfceeb3$var$Direction.Forward]: false
    },
    y: {
        [$3b30af0a3bfceeb3$var$Direction.Backward]: false,
        [$3b30af0a3bfceeb3$var$Direction.Forward]: false
    }
};
function $3b30af0a3bfceeb3$var$useScrollIntent(_ref2) {
    let { delta: delta, disabled: disabled } = _ref2;
    const previousDelta = (0, $f5d873c94758f78f$export$5cae361ad82dce8b)(delta);
    return (0, $f5d873c94758f78f$export$b0d7b7f1fcd613d1)((previousIntent)=>{
        if (disabled || !previousDelta || !previousIntent) // Reset scroll intent tracking when auto-scrolling is disabled
        return $3b30af0a3bfceeb3$var$defaultScrollIntent;
        const direction = {
            x: Math.sign(delta.x - previousDelta.x),
            y: Math.sign(delta.y - previousDelta.y)
        }; // Keep track of the user intent to scroll in each direction for both axis
        return {
            x: {
                [$3b30af0a3bfceeb3$var$Direction.Backward]: previousIntent.x[$3b30af0a3bfceeb3$var$Direction.Backward] || direction.x === -1,
                [$3b30af0a3bfceeb3$var$Direction.Forward]: previousIntent.x[$3b30af0a3bfceeb3$var$Direction.Forward] || direction.x === 1
            },
            y: {
                [$3b30af0a3bfceeb3$var$Direction.Backward]: previousIntent.y[$3b30af0a3bfceeb3$var$Direction.Backward] || direction.y === -1,
                [$3b30af0a3bfceeb3$var$Direction.Forward]: previousIntent.y[$3b30af0a3bfceeb3$var$Direction.Forward] || direction.y === 1
            }
        };
    }, [
        disabled,
        delta,
        previousDelta
    ]);
}
function $3b30af0a3bfceeb3$var$useCachedNode(draggableNodes, id) {
    const draggableNode = id != null ? draggableNodes.get(id) : undefined;
    const node = draggableNode ? draggableNode.node.current : null;
    return (0, $f5d873c94758f78f$export$b0d7b7f1fcd613d1)((cachedNode)=>{
        var _ref;
        if (id == null) return null;
         // In some cases, the draggable node can unmount while dragging
        // This is the case for virtualized lists. In those situations,
        // we fall back to the last known value for that node.
        return (_ref = node != null ? node : cachedNode) != null ? _ref : null;
    }, [
        node,
        id
    ]);
}
function $3b30af0a3bfceeb3$var$useCombineActivators(sensors, getSyntheticHandler) {
    return (0, $kc00y.useMemo)(()=>sensors.reduce((accumulator, sensor)=>{
            const { sensor: Sensor } = sensor;
            const sensorActivators = Sensor.activators.map((activator)=>({
                    eventName: activator.eventName,
                    handler: getSyntheticHandler(activator.handler, sensor)
                }));
            return [
                ...accumulator,
                ...sensorActivators
            ];
        }, []), [
        sensors,
        getSyntheticHandler
    ]);
}
var $3b30af0a3bfceeb3$export$571c10ffffe014ab;
(function(MeasuringStrategy) {
    MeasuringStrategy[MeasuringStrategy["Always"] = 0] = "Always";
    MeasuringStrategy[MeasuringStrategy["BeforeDragging"] = 1] = "BeforeDragging";
    MeasuringStrategy[MeasuringStrategy["WhileDragging"] = 2] = "WhileDragging";
})($3b30af0a3bfceeb3$export$571c10ffffe014ab || ($3b30af0a3bfceeb3$export$571c10ffffe014ab = {}));
var $3b30af0a3bfceeb3$export$8e062c3160beefd5;
(function(MeasuringFrequency) {
    MeasuringFrequency["Optimized"] = "optimized";
})($3b30af0a3bfceeb3$export$8e062c3160beefd5 || ($3b30af0a3bfceeb3$export$8e062c3160beefd5 = {}));
const $3b30af0a3bfceeb3$var$defaultValue = /*#__PURE__*/ new Map();
function $3b30af0a3bfceeb3$var$useDroppableMeasuring(containers, _ref) {
    let { dragging: dragging, dependencies: dependencies, config: config } = _ref;
    const [queue, setQueue] = (0, $kc00y.useState)(null);
    const { frequency: frequency, measure: measure, strategy: strategy } = config;
    const containersRef = (0, $kc00y.useRef)(containers);
    const disabled = isDisabled();
    const disabledRef = (0, $f5d873c94758f78f$export$86c4283a11f23f95)(disabled);
    const measureDroppableContainers = (0, $kc00y.useCallback)(function(ids) {
        if (ids === void 0) ids = [];
        if (disabledRef.current) return;
        setQueue((value)=>{
            if (value === null) return ids;
            return value.concat(ids.filter((id)=>!value.includes(id)));
        });
    }, [
        disabledRef
    ]);
    const timeoutId = (0, $kc00y.useRef)(null);
    const droppableRects = (0, $f5d873c94758f78f$export$b0d7b7f1fcd613d1)((previousValue)=>{
        if (disabled && !dragging) return $3b30af0a3bfceeb3$var$defaultValue;
        if (!previousValue || previousValue === $3b30af0a3bfceeb3$var$defaultValue || containersRef.current !== containers || queue != null) {
            const map = new Map();
            for (let container of containers){
                if (!container) continue;
                if (queue && queue.length > 0 && !queue.includes(container.id) && container.rect.current) {
                    // This container does not need to be re-measured
                    map.set(container.id, container.rect.current);
                    continue;
                }
                const node = container.node.current;
                const rect = node ? new $3b30af0a3bfceeb3$var$Rect(measure(node), node) : null;
                container.rect.current = rect;
                if (rect) map.set(container.id, rect);
            }
            return map;
        }
        return previousValue;
    }, [
        containers,
        queue,
        dragging,
        disabled,
        measure
    ]);
    (0, $kc00y.useEffect)(()=>{
        containersRef.current = containers;
    }, [
        containers
    ]);
    (0, $kc00y.useEffect)(()=>{
        if (disabled) return;
        measureDroppableContainers();
    }, [
        dragging,
        disabled
    ]);
    (0, $kc00y.useEffect)(()=>{
        if (queue && queue.length > 0) setQueue(null);
    }, [
        JSON.stringify(queue)
    ]);
    (0, $kc00y.useEffect)(()=>{
        if (disabled || typeof frequency !== 'number' || timeoutId.current !== null) return;
        timeoutId.current = setTimeout(()=>{
            measureDroppableContainers();
            timeoutId.current = null;
        }, frequency);
    }, [
        frequency,
        disabled,
        measureDroppableContainers,
        ...dependencies
    ]);
    return {
        droppableRects: droppableRects,
        measureDroppableContainers: measureDroppableContainers,
        measuringScheduled: queue != null
    };
    function isDisabled() {
        switch(strategy){
            case $3b30af0a3bfceeb3$export$571c10ffffe014ab.Always:
                return false;
            case $3b30af0a3bfceeb3$export$571c10ffffe014ab.BeforeDragging:
                return dragging;
            default:
                return !dragging;
        }
    }
}
function $3b30af0a3bfceeb3$var$useInitialValue(value, computeFn) {
    return (0, $f5d873c94758f78f$export$b0d7b7f1fcd613d1)((previousValue)=>{
        if (!value) return null;
        if (previousValue) return previousValue;
        return typeof computeFn === 'function' ? computeFn(value) : value;
    }, [
        computeFn,
        value
    ]);
}
function $3b30af0a3bfceeb3$var$useInitialRect(node, measure) {
    return $3b30af0a3bfceeb3$var$useInitialValue(node, measure);
}
/**
 * Returns a new MutationObserver instance.
 * If `MutationObserver` is undefined in the execution environment, returns `undefined`.
 */ function $3b30af0a3bfceeb3$var$useMutationObserver(_ref) {
    let { callback: callback, disabled: disabled } = _ref;
    const handleMutations = (0, $f5d873c94758f78f$export$90fc3a17d93f704c)(callback);
    const mutationObserver = (0, $kc00y.useMemo)(()=>{
        if (disabled || typeof window === 'undefined' || typeof window.MutationObserver === 'undefined') return undefined;
        const { MutationObserver: MutationObserver } = window;
        return new MutationObserver(handleMutations);
    }, [
        handleMutations,
        disabled
    ]);
    (0, $kc00y.useEffect)(()=>{
        return ()=>mutationObserver == null ? void 0 : mutationObserver.disconnect();
    }, [
        mutationObserver
    ]);
    return mutationObserver;
}
/**
 * Returns a new ResizeObserver instance bound to the `onResize` callback.
 * If `ResizeObserver` is undefined in the execution environment, returns `undefined`.
 */ function $3b30af0a3bfceeb3$var$useResizeObserver(_ref) {
    let { callback: callback, disabled: disabled } = _ref;
    const handleResize = (0, $f5d873c94758f78f$export$90fc3a17d93f704c)(callback);
    const resizeObserver = (0, $kc00y.useMemo)(()=>{
        if (disabled || typeof window === 'undefined' || typeof window.ResizeObserver === 'undefined') return undefined;
        const { ResizeObserver: ResizeObserver } = window;
        return new ResizeObserver(handleResize);
    }, [
        disabled
    ]);
    (0, $kc00y.useEffect)(()=>{
        return ()=>resizeObserver == null ? void 0 : resizeObserver.disconnect();
    }, [
        resizeObserver
    ]);
    return resizeObserver;
}
function $3b30af0a3bfceeb3$var$defaultMeasure(element) {
    return new $3b30af0a3bfceeb3$var$Rect($3b30af0a3bfceeb3$export$b6aa1f30c53d7454(element), element);
}
function $3b30af0a3bfceeb3$var$useRect(element, measure, fallbackRect) {
    if (measure === void 0) measure = $3b30af0a3bfceeb3$var$defaultMeasure;
    const [rect, setRect] = (0, $kc00y.useState)(null);
    function measureRect() {
        setRect((currentRect)=>{
            if (!element) return null;
            if (element.isConnected === false) {
                var _ref;
                // Fall back to last rect we measured if the element is
                // no longer connected to the DOM.
                return (_ref = currentRect != null ? currentRect : fallbackRect) != null ? _ref : null;
            }
            const newRect = measure(element);
            if (JSON.stringify(currentRect) === JSON.stringify(newRect)) return currentRect;
            return newRect;
        });
    }
    const mutationObserver = $3b30af0a3bfceeb3$var$useMutationObserver({
        callback (records) {
            if (!element) return;
            for (const record of records){
                const { type: type, target: target } = record;
                if (type === 'childList' && target instanceof HTMLElement && target.contains(element)) {
                    measureRect();
                    break;
                }
            }
        }
    });
    const resizeObserver = $3b30af0a3bfceeb3$var$useResizeObserver({
        callback: measureRect
    });
    (0, $f5d873c94758f78f$export$700979bc83e7db82)(()=>{
        measureRect();
        if (element) {
            resizeObserver == null || resizeObserver.observe(element);
            mutationObserver == null || mutationObserver.observe(document.body, {
                childList: true,
                subtree: true
            });
        } else {
            resizeObserver == null || resizeObserver.disconnect();
            mutationObserver == null || mutationObserver.disconnect();
        }
    }, [
        element
    ]);
    return rect;
}
function $3b30af0a3bfceeb3$var$useRectDelta(rect) {
    const initialRect = $3b30af0a3bfceeb3$var$useInitialValue(rect);
    return $3b30af0a3bfceeb3$var$getRectDelta(rect, initialRect);
}
const $3b30af0a3bfceeb3$var$defaultValue$1 = [];
function $3b30af0a3bfceeb3$var$useScrollableAncestors(node) {
    const previousNode = (0, $kc00y.useRef)(node);
    const ancestors = (0, $f5d873c94758f78f$export$b0d7b7f1fcd613d1)((previousValue)=>{
        if (!node) return $3b30af0a3bfceeb3$var$defaultValue$1;
        if (previousValue && previousValue !== $3b30af0a3bfceeb3$var$defaultValue$1 && node && previousNode.current && node.parentNode === previousNode.current.parentNode) return previousValue;
        return $3b30af0a3bfceeb3$export$e4864aa91b5ed091(node);
    }, [
        node
    ]);
    (0, $kc00y.useEffect)(()=>{
        previousNode.current = node;
    }, [
        node
    ]);
    return ancestors;
}
function $3b30af0a3bfceeb3$var$useScrollOffsets(elements) {
    const [scrollCoordinates, setScrollCoordinates] = (0, $kc00y.useState)(null);
    const prevElements = (0, $kc00y.useRef)(elements); // To-do: Throttle the handleScroll callback
    const handleScroll = (0, $kc00y.useCallback)((event)=>{
        const scrollingElement = $3b30af0a3bfceeb3$var$getScrollableElement(event.target);
        if (!scrollingElement) return;
        setScrollCoordinates((scrollCoordinates)=>{
            if (!scrollCoordinates) return null;
            scrollCoordinates.set(scrollingElement, $3b30af0a3bfceeb3$var$getScrollCoordinates(scrollingElement));
            return new Map(scrollCoordinates);
        });
    }, []);
    (0, $kc00y.useEffect)(()=>{
        const previousElements = prevElements.current;
        if (elements !== previousElements) {
            cleanup(previousElements);
            const entries = elements.map((element)=>{
                const scrollableElement = $3b30af0a3bfceeb3$var$getScrollableElement(element);
                if (scrollableElement) {
                    scrollableElement.addEventListener('scroll', handleScroll, {
                        passive: true
                    });
                    return [
                        scrollableElement,
                        $3b30af0a3bfceeb3$var$getScrollCoordinates(scrollableElement)
                    ];
                }
                return null;
            }).filter((entry)=>entry != null);
            setScrollCoordinates(entries.length ? new Map(entries) : null);
            prevElements.current = elements;
        }
        return ()=>{
            cleanup(elements);
            cleanup(previousElements);
        };
        function cleanup(elements) {
            elements.forEach((element)=>{
                const scrollableElement = $3b30af0a3bfceeb3$var$getScrollableElement(element);
                scrollableElement == null || scrollableElement.removeEventListener('scroll', handleScroll);
            });
        }
    }, [
        handleScroll,
        elements
    ]);
    return (0, $kc00y.useMemo)(()=>{
        if (elements.length) return scrollCoordinates ? Array.from(scrollCoordinates.values()).reduce((acc, coordinates)=>(0, $f5d873c94758f78f$export$e16d8520af44a096)(acc, coordinates), $3b30af0a3bfceeb3$export$597cbd7bbd10deb4) : $3b30af0a3bfceeb3$var$getScrollOffsets(elements);
        return $3b30af0a3bfceeb3$export$597cbd7bbd10deb4;
    }, [
        elements,
        scrollCoordinates
    ]);
}
function $3b30af0a3bfceeb3$var$useScrollOffsetsDelta(scrollOffsets, dependencies) {
    if (dependencies === void 0) dependencies = [];
    const initialScrollOffsets = (0, $kc00y.useRef)(null);
    (0, $kc00y.useEffect)(()=>{
        initialScrollOffsets.current = null;
    }, dependencies);
    (0, $kc00y.useEffect)(()=>{
        const hasScrollOffsets = scrollOffsets !== $3b30af0a3bfceeb3$export$597cbd7bbd10deb4;
        if (hasScrollOffsets && !initialScrollOffsets.current) initialScrollOffsets.current = scrollOffsets;
        if (!hasScrollOffsets && initialScrollOffsets.current) initialScrollOffsets.current = null;
    }, [
        scrollOffsets
    ]);
    return initialScrollOffsets.current ? (0, $f5d873c94758f78f$export$4e2d2ead65e5f7e3)(scrollOffsets, initialScrollOffsets.current) : $3b30af0a3bfceeb3$export$597cbd7bbd10deb4;
}
function $3b30af0a3bfceeb3$var$useSensorSetup(sensors) {
    (0, $kc00y.useEffect)(()=>{
        if (!(0, $f5d873c94758f78f$export$71594e8a50f746f4)) return;
        const teardownFns = sensors.map((_ref)=>{
            let { sensor: sensor } = _ref;
            return sensor.setup == null ? void 0 : sensor.setup();
        });
        return ()=>{
            for (const teardown of teardownFns)teardown == null || teardown();
        };
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    sensors.map((_ref2)=>{
        let { sensor: sensor } = _ref2;
        return sensor;
    }));
}
function $3b30af0a3bfceeb3$var$useSyntheticListeners(listeners, id) {
    return (0, $kc00y.useMemo)(()=>{
        return listeners.reduce((acc, _ref)=>{
            let { eventName: eventName, handler: handler } = _ref;
            acc[eventName] = (event)=>{
                handler(event, id);
            };
            return acc;
        }, {});
    }, [
        listeners,
        id
    ]);
}
function $3b30af0a3bfceeb3$var$useWindowRect(element) {
    return (0, $kc00y.useMemo)(()=>element ? $3b30af0a3bfceeb3$var$getWindowClientRect(element) : null, [
        element
    ]);
}
const $3b30af0a3bfceeb3$var$defaultValue$2 = [];
function $3b30af0a3bfceeb3$var$useRects(elements, measure) {
    if (measure === void 0) measure = $3b30af0a3bfceeb3$export$b6aa1f30c53d7454;
    const [firstElement] = elements;
    const windowRect = $3b30af0a3bfceeb3$var$useWindowRect(firstElement ? (0, $f5d873c94758f78f$export$38b2d434cce3ea22)(firstElement) : null);
    const [rects, setRects] = (0, $kc00y.useState)($3b30af0a3bfceeb3$var$defaultValue$2);
    function measureRects() {
        setRects(()=>{
            if (!elements.length) return $3b30af0a3bfceeb3$var$defaultValue$2;
            return elements.map((element)=>$3b30af0a3bfceeb3$var$isDocumentScrollingElement(element) ? windowRect : new $3b30af0a3bfceeb3$var$Rect(measure(element), element));
        });
    }
    const resizeObserver = $3b30af0a3bfceeb3$var$useResizeObserver({
        callback: measureRects
    });
    (0, $f5d873c94758f78f$export$700979bc83e7db82)(()=>{
        resizeObserver == null || resizeObserver.disconnect();
        measureRects();
        elements.forEach((element)=>resizeObserver == null ? void 0 : resizeObserver.observe(element));
    }, [
        elements
    ]);
    return rects;
}
function $3b30af0a3bfceeb3$var$getMeasurableNode(node) {
    if (!node) return null;
    if (node.children.length > 1) return node;
    const firstChild = node.children[0];
    return (0, $f5d873c94758f78f$export$1b3bfaa9684536aa)(firstChild) ? firstChild : node;
}
function $3b30af0a3bfceeb3$var$useDragOverlayMeasuring(_ref) {
    let { measure: measure } = _ref;
    const [rect, setRect] = (0, $kc00y.useState)(null);
    const handleResize = (0, $kc00y.useCallback)((entries)=>{
        for (const { target: target } of entries)if ((0, $f5d873c94758f78f$export$1b3bfaa9684536aa)(target)) {
            setRect((rect)=>{
                const newRect = measure(target);
                return rect ? {
                    ...rect,
                    width: newRect.width,
                    height: newRect.height
                } : newRect;
            });
            break;
        }
    }, [
        measure
    ]);
    const resizeObserver = $3b30af0a3bfceeb3$var$useResizeObserver({
        callback: handleResize
    });
    const handleNodeChange = (0, $kc00y.useCallback)((element)=>{
        const node = $3b30af0a3bfceeb3$var$getMeasurableNode(element);
        resizeObserver == null || resizeObserver.disconnect();
        if (node) resizeObserver == null || resizeObserver.observe(node);
        setRect(node ? measure(node) : null);
    }, [
        measure,
        resizeObserver
    ]);
    const [nodeRef, setRef] = (0, $f5d873c94758f78f$export$bc23c270f170c912)(handleNodeChange);
    return (0, $kc00y.useMemo)(()=>({
            nodeRef: nodeRef,
            rect: rect,
            setRef: setRef
        }), [
        rect,
        nodeRef,
        setRef
    ]);
}
const $3b30af0a3bfceeb3$var$defaultSensors = [
    {
        sensor: $3b30af0a3bfceeb3$export$b26af955418d6638,
        options: {}
    },
    {
        sensor: $3b30af0a3bfceeb3$export$44d67f2a438aeba9,
        options: {}
    }
];
const $3b30af0a3bfceeb3$var$defaultData = {
    current: {}
};
const $3b30af0a3bfceeb3$var$defaultMeasuringConfiguration = {
    draggable: {
        measure: $3b30af0a3bfceeb3$var$getTransformAgnosticClientRect
    },
    droppable: {
        measure: $3b30af0a3bfceeb3$var$getTransformAgnosticClientRect,
        strategy: $3b30af0a3bfceeb3$export$571c10ffffe014ab.WhileDragging,
        frequency: $3b30af0a3bfceeb3$export$8e062c3160beefd5.Optimized
    },
    dragOverlay: {
        measure: $3b30af0a3bfceeb3$export$b6aa1f30c53d7454
    }
};
class $3b30af0a3bfceeb3$var$DroppableContainersMap extends Map {
    get(id) {
        var _super$get;
        return id != null ? (_super$get = super.get(id)) != null ? _super$get : undefined : undefined;
    }
    toArray() {
        return Array.from(this.values());
    }
    getEnabled() {
        return this.toArray().filter((_ref)=>{
            let { disabled: disabled } = _ref;
            return !disabled;
        });
    }
    getNodeFor(id) {
        var _this$get$node$curren, _this$get;
        return (_this$get$node$curren = (_this$get = this.get(id)) == null ? void 0 : _this$get.node.current) != null ? _this$get$node$curren : undefined;
    }
}
const $3b30af0a3bfceeb3$var$defaultPublicContext = {
    activatorEvent: null,
    active: null,
    activeNode: null,
    activeNodeRect: null,
    collisions: null,
    containerNodeRect: null,
    draggableNodes: /*#__PURE__*/ new Map(),
    droppableRects: /*#__PURE__*/ new Map(),
    droppableContainers: /*#__PURE__*/ new $3b30af0a3bfceeb3$var$DroppableContainersMap(),
    over: null,
    dragOverlay: {
        nodeRef: {
            current: null
        },
        rect: null,
        setRef: $3b30af0a3bfceeb3$var$noop
    },
    scrollableAncestors: [],
    scrollableAncestorRects: [],
    measuringConfiguration: $3b30af0a3bfceeb3$var$defaultMeasuringConfiguration,
    measureDroppableContainers: $3b30af0a3bfceeb3$var$noop,
    windowRect: null,
    measuringScheduled: false
};
const $3b30af0a3bfceeb3$var$defaultInternalContext = {
    activatorEvent: null,
    activators: [],
    active: null,
    activeNodeRect: null,
    ariaDescribedById: {
        draggable: ''
    },
    dispatch: $3b30af0a3bfceeb3$var$noop,
    draggableNodes: /*#__PURE__*/ new Map(),
    over: null,
    measureDroppableContainers: $3b30af0a3bfceeb3$var$noop
};
const $3b30af0a3bfceeb3$var$InternalContext = /*#__PURE__*/ (0, $kc00y.createContext)($3b30af0a3bfceeb3$var$defaultInternalContext);
const $3b30af0a3bfceeb3$var$PublicContext = /*#__PURE__*/ (0, $kc00y.createContext)($3b30af0a3bfceeb3$var$defaultPublicContext);
function $3b30af0a3bfceeb3$var$getInitialState() {
    return {
        draggable: {
            active: null,
            initialCoordinates: {
                x: 0,
                y: 0
            },
            nodes: new Map(),
            translate: {
                x: 0,
                y: 0
            }
        },
        droppable: {
            containers: new $3b30af0a3bfceeb3$var$DroppableContainersMap()
        }
    };
}
function $3b30af0a3bfceeb3$var$reducer(state, action) {
    switch(action.type){
        case $3b30af0a3bfceeb3$var$Action.DragStart:
            return {
                ...state,
                draggable: {
                    ...state.draggable,
                    initialCoordinates: action.initialCoordinates,
                    active: action.active
                }
            };
        case $3b30af0a3bfceeb3$var$Action.DragMove:
            if (state.draggable.active == null) return state;
            return {
                ...state,
                draggable: {
                    ...state.draggable,
                    translate: {
                        x: action.coordinates.x - state.draggable.initialCoordinates.x,
                        y: action.coordinates.y - state.draggable.initialCoordinates.y
                    }
                }
            };
        case $3b30af0a3bfceeb3$var$Action.DragEnd:
        case $3b30af0a3bfceeb3$var$Action.DragCancel:
            return {
                ...state,
                draggable: {
                    ...state.draggable,
                    active: null,
                    initialCoordinates: {
                        x: 0,
                        y: 0
                    },
                    translate: {
                        x: 0,
                        y: 0
                    }
                }
            };
        case $3b30af0a3bfceeb3$var$Action.RegisterDroppable:
            {
                const { element: element } = action;
                const { id: id } = element;
                const containers = new $3b30af0a3bfceeb3$var$DroppableContainersMap(state.droppable.containers);
                containers.set(id, element);
                return {
                    ...state,
                    droppable: {
                        ...state.droppable,
                        containers: containers
                    }
                };
            }
        case $3b30af0a3bfceeb3$var$Action.SetDroppableDisabled:
            {
                const { id: id, key: key, disabled: disabled } = action;
                const element = state.droppable.containers.get(id);
                if (!element || key !== element.key) return state;
                const containers = new $3b30af0a3bfceeb3$var$DroppableContainersMap(state.droppable.containers);
                containers.set(id, {
                    ...element,
                    disabled: disabled
                });
                return {
                    ...state,
                    droppable: {
                        ...state.droppable,
                        containers: containers
                    }
                };
            }
        case $3b30af0a3bfceeb3$var$Action.UnregisterDroppable:
            {
                const { id: id, key: key } = action;
                const element = state.droppable.containers.get(id);
                if (!element || key !== element.key) return state;
                const containers = new $3b30af0a3bfceeb3$var$DroppableContainersMap(state.droppable.containers);
                containers.delete(id);
                return {
                    ...state,
                    droppable: {
                        ...state.droppable,
                        containers: containers
                    }
                };
            }
        default:
            return state;
    }
}
function $3b30af0a3bfceeb3$var$RestoreFocus(_ref) {
    let { disabled: disabled } = _ref;
    const { active: active, activatorEvent: activatorEvent, draggableNodes: draggableNodes } = (0, $kc00y.useContext)($3b30af0a3bfceeb3$var$InternalContext);
    const previousActivatorEvent = (0, $f5d873c94758f78f$export$5cae361ad82dce8b)(activatorEvent);
    const previousActiveId = (0, $f5d873c94758f78f$export$5cae361ad82dce8b)(active == null ? void 0 : active.id); // Restore keyboard focus on the activator node
    (0, $kc00y.useEffect)(()=>{
        if (disabled) return;
        if (!activatorEvent && previousActivatorEvent && previousActiveId != null) {
            if (!(0, $f5d873c94758f78f$export$130b789831072f4c)(previousActivatorEvent)) return;
            if (document.activeElement === previousActivatorEvent.target) // No need to restore focus
            return;
            const draggableNode = draggableNodes.get(previousActiveId);
            if (!draggableNode) return;
            const { activatorNode: activatorNode, node: node } = draggableNode;
            if (!activatorNode.current && !node.current) return;
            requestAnimationFrame(()=>{
                for (const element of [
                    activatorNode.current,
                    node.current
                ]){
                    if (!element) continue;
                    const focusableNode = (0, $f5d873c94758f78f$export$44f71d798fd0a62b)(element);
                    if (focusableNode) {
                        focusableNode.focus();
                        break;
                    }
                }
            });
        }
    }, [
        activatorEvent,
        disabled,
        draggableNodes,
        previousActiveId,
        previousActivatorEvent
    ]);
    return null;
}
function $3b30af0a3bfceeb3$export$f1696300e8775372(modifiers, _ref) {
    let { transform: transform, ...args } = _ref;
    return modifiers != null && modifiers.length ? modifiers.reduce((accumulator, modifier)=>{
        return modifier({
            transform: accumulator,
            ...args
        });
    }, transform) : transform;
}
function $3b30af0a3bfceeb3$var$useMeasuringConfiguration(config) {
    return (0, $kc00y.useMemo)(()=>({
            draggable: {
                ...$3b30af0a3bfceeb3$var$defaultMeasuringConfiguration.draggable,
                ...config == null ? void 0 : config.draggable
            },
            droppable: {
                ...$3b30af0a3bfceeb3$var$defaultMeasuringConfiguration.droppable,
                ...config == null ? void 0 : config.droppable
            },
            dragOverlay: {
                ...$3b30af0a3bfceeb3$var$defaultMeasuringConfiguration.dragOverlay,
                ...config == null ? void 0 : config.dragOverlay
            }
        }), [
        config == null ? void 0 : config.draggable,
        config == null ? void 0 : config.droppable,
        config == null ? void 0 : config.dragOverlay
    ]);
}
function $3b30af0a3bfceeb3$var$useLayoutShiftScrollCompensation(_ref) {
    let { activeNode: activeNode, measure: measure, initialRect: initialRect, config: config = true } = _ref;
    const initialized = (0, $kc00y.useRef)(false);
    const { x: x, y: y } = typeof config === 'boolean' ? {
        x: config,
        y: config
    } : config;
    (0, $f5d873c94758f78f$export$700979bc83e7db82)(()=>{
        const disabled = !x && !y;
        if (disabled || !activeNode) {
            initialized.current = false;
            return;
        }
        if (initialized.current || !initialRect) // Return early if layout shift scroll compensation was already attempted
        // or if there is no initialRect to compare to.
        return;
         // Get the most up to date node ref for the active draggable
        const node = activeNode == null ? void 0 : activeNode.node.current;
        if (!node || node.isConnected === false) // Return early if there is no attached node ref or if the node is
        // disconnected from the document.
        return;
        const rect = measure(node);
        const rectDelta = $3b30af0a3bfceeb3$var$getRectDelta(rect, initialRect);
        if (!x) rectDelta.x = 0;
        if (!y) rectDelta.y = 0;
         // Only perform layout shift scroll compensation once
        initialized.current = true;
        if (Math.abs(rectDelta.x) > 0 || Math.abs(rectDelta.y) > 0) {
            const firstScrollableAncestor = $3b30af0a3bfceeb3$var$getFirstScrollableAncestor(node);
            if (firstScrollableAncestor) firstScrollableAncestor.scrollBy({
                top: rectDelta.y,
                left: rectDelta.x
            });
        }
    }, [
        activeNode,
        x,
        y,
        initialRect,
        measure
    ]);
}
const $3b30af0a3bfceeb3$var$ActiveDraggableContext = /*#__PURE__*/ (0, $kc00y.createContext)({
    ...$3b30af0a3bfceeb3$export$597cbd7bbd10deb4,
    scaleX: 1,
    scaleY: 1
});
var $3b30af0a3bfceeb3$var$Status;
(function(Status) {
    Status[Status["Uninitialized"] = 0] = "Uninitialized";
    Status[Status["Initializing"] = 1] = "Initializing";
    Status[Status["Initialized"] = 2] = "Initialized";
})($3b30af0a3bfceeb3$var$Status || ($3b30af0a3bfceeb3$var$Status = {}));
const $3b30af0a3bfceeb3$export$2d5c5ceac203fc1e = /*#__PURE__*/ (0, $kc00y.memo)(function DndContext(_ref) {
    var _sensorContext$curren, _dragOverlay$nodeRef$, _dragOverlay$rect, _over$rect;
    let { id: id, accessibility: accessibility, autoScroll: autoScroll = true, children: children, sensors: sensors = $3b30af0a3bfceeb3$var$defaultSensors, collisionDetection: collisionDetection = $3b30af0a3bfceeb3$export$953346c40b5eb62a, measuring: measuring, modifiers: modifiers, ...props } = _ref;
    const store = (0, $kc00y.useReducer)($3b30af0a3bfceeb3$var$reducer, undefined, $3b30af0a3bfceeb3$var$getInitialState);
    const [state, dispatch] = store;
    const [dispatchMonitorEvent, registerMonitorListener] = $3b30af0a3bfceeb3$var$useDndMonitorProvider();
    const [status, setStatus] = (0, $kc00y.useState)($3b30af0a3bfceeb3$var$Status.Uninitialized);
    const isInitialized = status === $3b30af0a3bfceeb3$var$Status.Initialized;
    const { draggable: { active: activeId, nodes: draggableNodes, translate: translate }, droppable: { containers: droppableContainers } } = state;
    const node = activeId != null ? draggableNodes.get(activeId) : null;
    const activeRects = (0, $kc00y.useRef)({
        initial: null,
        translated: null
    });
    const active = (0, $kc00y.useMemo)(()=>{
        var _node$data;
        return activeId != null ? {
            id: activeId,
            // It's possible for the active node to unmount while dragging
            data: (_node$data = node == null ? void 0 : node.data) != null ? _node$data : $3b30af0a3bfceeb3$var$defaultData,
            rect: activeRects
        } : null;
    }, [
        activeId,
        node
    ]);
    const activeRef = (0, $kc00y.useRef)(null);
    const [activeSensor, setActiveSensor] = (0, $kc00y.useState)(null);
    const [activatorEvent, setActivatorEvent] = (0, $kc00y.useState)(null);
    const latestProps = (0, $f5d873c94758f78f$export$86c4283a11f23f95)(props, Object.values(props));
    const draggableDescribedById = (0, $f5d873c94758f78f$export$c485849f2e393253)("DndDescribedBy", id);
    const enabledDroppableContainers = (0, $kc00y.useMemo)(()=>droppableContainers.getEnabled(), [
        droppableContainers
    ]);
    const measuringConfiguration = $3b30af0a3bfceeb3$var$useMeasuringConfiguration(measuring);
    const { droppableRects: droppableRects, measureDroppableContainers: measureDroppableContainers, measuringScheduled: measuringScheduled } = $3b30af0a3bfceeb3$var$useDroppableMeasuring(enabledDroppableContainers, {
        dragging: isInitialized,
        dependencies: [
            translate.x,
            translate.y
        ],
        config: measuringConfiguration.droppable
    });
    const activeNode = $3b30af0a3bfceeb3$var$useCachedNode(draggableNodes, activeId);
    const activationCoordinates = (0, $kc00y.useMemo)(()=>activatorEvent ? (0, $f5d873c94758f78f$export$36195c8aa1517e04)(activatorEvent) : null, [
        activatorEvent
    ]);
    const autoScrollOptions = getAutoScrollerOptions();
    const initialActiveNodeRect = $3b30af0a3bfceeb3$var$useInitialRect(activeNode, measuringConfiguration.draggable.measure);
    $3b30af0a3bfceeb3$var$useLayoutShiftScrollCompensation({
        activeNode: activeId != null ? draggableNodes.get(activeId) : null,
        config: autoScrollOptions.layoutShiftCompensation,
        initialRect: initialActiveNodeRect,
        measure: measuringConfiguration.draggable.measure
    });
    const activeNodeRect = $3b30af0a3bfceeb3$var$useRect(activeNode, measuringConfiguration.draggable.measure, initialActiveNodeRect);
    const containerNodeRect = $3b30af0a3bfceeb3$var$useRect(activeNode ? activeNode.parentElement : null);
    const sensorContext = (0, $kc00y.useRef)({
        activatorEvent: null,
        active: null,
        activeNode: activeNode,
        collisionRect: null,
        collisions: null,
        droppableRects: droppableRects,
        draggableNodes: draggableNodes,
        draggingNode: null,
        draggingNodeRect: null,
        droppableContainers: droppableContainers,
        over: null,
        scrollableAncestors: [],
        scrollAdjustedTranslate: null
    });
    const overNode = droppableContainers.getNodeFor((_sensorContext$curren = sensorContext.current.over) == null ? void 0 : _sensorContext$curren.id);
    const dragOverlay = $3b30af0a3bfceeb3$var$useDragOverlayMeasuring({
        measure: measuringConfiguration.dragOverlay.measure
    }); // Use the rect of the drag overlay if it is mounted
    const draggingNode = (_dragOverlay$nodeRef$ = dragOverlay.nodeRef.current) != null ? _dragOverlay$nodeRef$ : activeNode;
    const draggingNodeRect = isInitialized ? (_dragOverlay$rect = dragOverlay.rect) != null ? _dragOverlay$rect : activeNodeRect : null;
    const usesDragOverlay = Boolean(dragOverlay.nodeRef.current && dragOverlay.rect); // The delta between the previous and new position of the draggable node
    // is only relevant when there is no drag overlay
    const nodeRectDelta = $3b30af0a3bfceeb3$var$useRectDelta(usesDragOverlay ? null : activeNodeRect); // Get the window rect of the dragging node
    const windowRect = $3b30af0a3bfceeb3$var$useWindowRect(draggingNode ? (0, $f5d873c94758f78f$export$38b2d434cce3ea22)(draggingNode) : null); // Get scrollable ancestors of the dragging node
    const scrollableAncestors = $3b30af0a3bfceeb3$var$useScrollableAncestors(isInitialized ? overNode != null ? overNode : activeNode : null);
    const scrollableAncestorRects = $3b30af0a3bfceeb3$var$useRects(scrollableAncestors); // Apply modifiers
    const modifiedTranslate = $3b30af0a3bfceeb3$export$f1696300e8775372(modifiers, {
        transform: {
            x: translate.x - nodeRectDelta.x,
            y: translate.y - nodeRectDelta.y,
            scaleX: 1,
            scaleY: 1
        },
        activatorEvent: activatorEvent,
        active: active,
        activeNodeRect: activeNodeRect,
        containerNodeRect: containerNodeRect,
        draggingNodeRect: draggingNodeRect,
        over: sensorContext.current.over,
        overlayNodeRect: dragOverlay.rect,
        scrollableAncestors: scrollableAncestors,
        scrollableAncestorRects: scrollableAncestorRects,
        windowRect: windowRect
    });
    const pointerCoordinates = activationCoordinates ? (0, $f5d873c94758f78f$export$e16d8520af44a096)(activationCoordinates, translate) : null;
    const scrollOffsets = $3b30af0a3bfceeb3$var$useScrollOffsets(scrollableAncestors); // Represents the scroll delta since dragging was initiated
    const scrollAdjustment = $3b30af0a3bfceeb3$var$useScrollOffsetsDelta(scrollOffsets); // Represents the scroll delta since the last time the active node rect was measured
    const activeNodeScrollDelta = $3b30af0a3bfceeb3$var$useScrollOffsetsDelta(scrollOffsets, [
        activeNodeRect
    ]);
    const scrollAdjustedTranslate = (0, $f5d873c94758f78f$export$e16d8520af44a096)(modifiedTranslate, scrollAdjustment);
    const collisionRect = draggingNodeRect ? $3b30af0a3bfceeb3$var$getAdjustedRect(draggingNodeRect, modifiedTranslate) : null;
    const collisions = active && collisionRect ? collisionDetection({
        active: active,
        collisionRect: collisionRect,
        droppableRects: droppableRects,
        droppableContainers: enabledDroppableContainers,
        pointerCoordinates: pointerCoordinates
    }) : null;
    const overId = $3b30af0a3bfceeb3$export$ef1beab6d7287295(collisions, 'id');
    const [over, setOver] = (0, $kc00y.useState)(null); // When there is no drag overlay used, we need to account for the
    // window scroll delta
    const appliedTranslate = usesDragOverlay ? modifiedTranslate : (0, $f5d873c94758f78f$export$e16d8520af44a096)(modifiedTranslate, activeNodeScrollDelta);
    const transform = $3b30af0a3bfceeb3$var$adjustScale(appliedTranslate, (_over$rect = over == null ? void 0 : over.rect) != null ? _over$rect : null, activeNodeRect);
    const activeSensorRef = (0, $kc00y.useRef)(null);
    const instantiateSensor = (0, $kc00y.useCallback)((event, _ref2)=>{
        let { sensor: Sensor, options: options } = _ref2;
        if (activeRef.current == null) return;
        const activeNode = draggableNodes.get(activeRef.current);
        if (!activeNode) return;
        const activatorEvent = event.nativeEvent;
        const sensorInstance = new Sensor({
            active: activeRef.current,
            activeNode: activeNode,
            event: activatorEvent,
            options: options,
            // Sensors need to be instantiated with refs for arguments that change over time
            // otherwise they are frozen in time with the stale arguments
            context: sensorContext,
            onAbort (id) {
                const draggableNode = draggableNodes.get(id);
                if (!draggableNode) return;
                const { onDragAbort: onDragAbort } = latestProps.current;
                const event = {
                    id: id
                };
                onDragAbort == null || onDragAbort(event);
                dispatchMonitorEvent({
                    type: 'onDragAbort',
                    event: event
                });
            },
            onPending (id, constraint, initialCoordinates, offset) {
                const draggableNode = draggableNodes.get(id);
                if (!draggableNode) return;
                const { onDragPending: onDragPending } = latestProps.current;
                const event = {
                    id: id,
                    constraint: constraint,
                    initialCoordinates: initialCoordinates,
                    offset: offset
                };
                onDragPending == null || onDragPending(event);
                dispatchMonitorEvent({
                    type: 'onDragPending',
                    event: event
                });
            },
            onStart (initialCoordinates) {
                const id = activeRef.current;
                if (id == null) return;
                const draggableNode = draggableNodes.get(id);
                if (!draggableNode) return;
                const { onDragStart: onDragStart } = latestProps.current;
                const event = {
                    activatorEvent: activatorEvent,
                    active: {
                        id: id,
                        data: draggableNode.data,
                        rect: activeRects
                    }
                };
                (0, $9018fd8b87cabbb7$exports.unstable_batchedUpdates)(()=>{
                    onDragStart == null || onDragStart(event);
                    setStatus($3b30af0a3bfceeb3$var$Status.Initializing);
                    dispatch({
                        type: $3b30af0a3bfceeb3$var$Action.DragStart,
                        initialCoordinates: initialCoordinates,
                        active: id
                    });
                    dispatchMonitorEvent({
                        type: 'onDragStart',
                        event: event
                    });
                    setActiveSensor(activeSensorRef.current);
                    setActivatorEvent(activatorEvent);
                });
            },
            onMove (coordinates) {
                dispatch({
                    type: $3b30af0a3bfceeb3$var$Action.DragMove,
                    coordinates: coordinates
                });
            },
            onEnd: createHandler($3b30af0a3bfceeb3$var$Action.DragEnd),
            onCancel: createHandler($3b30af0a3bfceeb3$var$Action.DragCancel)
        });
        activeSensorRef.current = sensorInstance;
        function createHandler(type) {
            return async function handler() {
                const { active: active, collisions: collisions, over: over, scrollAdjustedTranslate: scrollAdjustedTranslate } = sensorContext.current;
                let event = null;
                if (active && scrollAdjustedTranslate) {
                    const { cancelDrop: cancelDrop } = latestProps.current;
                    event = {
                        activatorEvent: activatorEvent,
                        active: active,
                        collisions: collisions,
                        delta: scrollAdjustedTranslate,
                        over: over
                    };
                    if (type === $3b30af0a3bfceeb3$var$Action.DragEnd && typeof cancelDrop === 'function') {
                        const shouldCancel = await Promise.resolve(cancelDrop(event));
                        if (shouldCancel) type = $3b30af0a3bfceeb3$var$Action.DragCancel;
                    }
                }
                activeRef.current = null;
                (0, $9018fd8b87cabbb7$exports.unstable_batchedUpdates)(()=>{
                    dispatch({
                        type: type
                    });
                    setStatus($3b30af0a3bfceeb3$var$Status.Uninitialized);
                    setOver(null);
                    setActiveSensor(null);
                    setActivatorEvent(null);
                    activeSensorRef.current = null;
                    const eventName = type === $3b30af0a3bfceeb3$var$Action.DragEnd ? 'onDragEnd' : 'onDragCancel';
                    if (event) {
                        const handler = latestProps.current[eventName];
                        handler == null || handler(event);
                        dispatchMonitorEvent({
                            type: eventName,
                            event: event
                        });
                    }
                });
            };
        }
    }, [
        draggableNodes
    ]);
    const bindActivatorToSensorInstantiator = (0, $kc00y.useCallback)((handler, sensor)=>{
        return (event, active)=>{
            const nativeEvent = event.nativeEvent;
            const activeDraggableNode = draggableNodes.get(active);
            if (activeRef.current !== null || // No active draggable
            !activeDraggableNode || // Event has already been captured
            nativeEvent.dndKit || nativeEvent.defaultPrevented) return;
            const activationContext = {
                active: activeDraggableNode
            };
            const shouldActivate = handler(event, sensor.options, activationContext);
            if (shouldActivate === true) {
                nativeEvent.dndKit = {
                    capturedBy: sensor.sensor
                };
                activeRef.current = active;
                instantiateSensor(event, sensor);
            }
        };
    }, [
        draggableNodes,
        instantiateSensor
    ]);
    const activators = $3b30af0a3bfceeb3$var$useCombineActivators(sensors, bindActivatorToSensorInstantiator);
    $3b30af0a3bfceeb3$var$useSensorSetup(sensors);
    (0, $f5d873c94758f78f$export$700979bc83e7db82)(()=>{
        if (activeNodeRect && status === $3b30af0a3bfceeb3$var$Status.Initializing) setStatus($3b30af0a3bfceeb3$var$Status.Initialized);
    }, [
        activeNodeRect,
        status
    ]);
    (0, $kc00y.useEffect)(()=>{
        const { onDragMove: onDragMove } = latestProps.current;
        const { active: active, activatorEvent: activatorEvent, collisions: collisions, over: over } = sensorContext.current;
        if (!active || !activatorEvent) return;
        const event = {
            active: active,
            activatorEvent: activatorEvent,
            collisions: collisions,
            delta: {
                x: scrollAdjustedTranslate.x,
                y: scrollAdjustedTranslate.y
            },
            over: over
        };
        (0, $9018fd8b87cabbb7$exports.unstable_batchedUpdates)(()=>{
            onDragMove == null || onDragMove(event);
            dispatchMonitorEvent({
                type: 'onDragMove',
                event: event
            });
        });
    }, [
        scrollAdjustedTranslate.x,
        scrollAdjustedTranslate.y
    ]);
    (0, $kc00y.useEffect)(()=>{
        const { active: active, activatorEvent: activatorEvent, collisions: collisions, droppableContainers: droppableContainers, scrollAdjustedTranslate: scrollAdjustedTranslate } = sensorContext.current;
        if (!active || activeRef.current == null || !activatorEvent || !scrollAdjustedTranslate) return;
        const { onDragOver: onDragOver } = latestProps.current;
        const overContainer = droppableContainers.get(overId);
        const over = overContainer && overContainer.rect.current ? {
            id: overContainer.id,
            rect: overContainer.rect.current,
            data: overContainer.data,
            disabled: overContainer.disabled
        } : null;
        const event = {
            active: active,
            activatorEvent: activatorEvent,
            collisions: collisions,
            delta: {
                x: scrollAdjustedTranslate.x,
                y: scrollAdjustedTranslate.y
            },
            over: over
        };
        (0, $9018fd8b87cabbb7$exports.unstable_batchedUpdates)(()=>{
            setOver(over);
            onDragOver == null || onDragOver(event);
            dispatchMonitorEvent({
                type: 'onDragOver',
                event: event
            });
        });
    }, [
        overId
    ]);
    (0, $f5d873c94758f78f$export$700979bc83e7db82)(()=>{
        sensorContext.current = {
            activatorEvent: activatorEvent,
            active: active,
            activeNode: activeNode,
            collisionRect: collisionRect,
            collisions: collisions,
            droppableRects: droppableRects,
            draggableNodes: draggableNodes,
            draggingNode: draggingNode,
            draggingNodeRect: draggingNodeRect,
            droppableContainers: droppableContainers,
            over: over,
            scrollableAncestors: scrollableAncestors,
            scrollAdjustedTranslate: scrollAdjustedTranslate
        };
        activeRects.current = {
            initial: draggingNodeRect,
            translated: collisionRect
        };
    }, [
        active,
        activeNode,
        collisions,
        collisionRect,
        draggableNodes,
        draggingNode,
        draggingNodeRect,
        droppableRects,
        droppableContainers,
        over,
        scrollableAncestors,
        scrollAdjustedTranslate
    ]);
    $3b30af0a3bfceeb3$var$useAutoScroller({
        ...autoScrollOptions,
        delta: translate,
        draggingRect: collisionRect,
        pointerCoordinates: pointerCoordinates,
        scrollableAncestors: scrollableAncestors,
        scrollableAncestorRects: scrollableAncestorRects
    });
    const publicContext = (0, $kc00y.useMemo)(()=>{
        const context = {
            active: active,
            activeNode: activeNode,
            activeNodeRect: activeNodeRect,
            activatorEvent: activatorEvent,
            collisions: collisions,
            containerNodeRect: containerNodeRect,
            dragOverlay: dragOverlay,
            draggableNodes: draggableNodes,
            droppableContainers: droppableContainers,
            droppableRects: droppableRects,
            over: over,
            measureDroppableContainers: measureDroppableContainers,
            scrollableAncestors: scrollableAncestors,
            scrollableAncestorRects: scrollableAncestorRects,
            measuringConfiguration: measuringConfiguration,
            measuringScheduled: measuringScheduled,
            windowRect: windowRect
        };
        return context;
    }, [
        active,
        activeNode,
        activeNodeRect,
        activatorEvent,
        collisions,
        containerNodeRect,
        dragOverlay,
        draggableNodes,
        droppableContainers,
        droppableRects,
        over,
        measureDroppableContainers,
        scrollableAncestors,
        scrollableAncestorRects,
        measuringConfiguration,
        measuringScheduled,
        windowRect
    ]);
    const internalContext = (0, $kc00y.useMemo)(()=>{
        const context = {
            activatorEvent: activatorEvent,
            activators: activators,
            active: active,
            activeNodeRect: activeNodeRect,
            ariaDescribedById: {
                draggable: draggableDescribedById
            },
            dispatch: dispatch,
            draggableNodes: draggableNodes,
            over: over,
            measureDroppableContainers: measureDroppableContainers
        };
        return context;
    }, [
        activatorEvent,
        activators,
        active,
        activeNodeRect,
        dispatch,
        draggableDescribedById,
        draggableNodes,
        over,
        measureDroppableContainers
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement($3b30af0a3bfceeb3$var$DndMonitorContext.Provider, {
        value: registerMonitorListener
    }, (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement($3b30af0a3bfceeb3$var$InternalContext.Provider, {
        value: internalContext
    }, (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement($3b30af0a3bfceeb3$var$PublicContext.Provider, {
        value: publicContext
    }, (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement($3b30af0a3bfceeb3$var$ActiveDraggableContext.Provider, {
        value: transform
    }, children)), (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement($3b30af0a3bfceeb3$var$RestoreFocus, {
        disabled: (accessibility == null ? void 0 : accessibility.restoreFocus) === false
    })), (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement($3b30af0a3bfceeb3$var$Accessibility, {
        ...accessibility,
        hiddenTextDescribedById: draggableDescribedById
    }));
    function getAutoScrollerOptions() {
        const activeSensorDisablesAutoscroll = (activeSensor == null ? void 0 : activeSensor.autoScrollEnabled) === false;
        const autoScrollGloballyDisabled = typeof autoScroll === 'object' ? autoScroll.enabled === false : autoScroll === false;
        const enabled = isInitialized && !activeSensorDisablesAutoscroll && !autoScrollGloballyDisabled;
        if (typeof autoScroll === 'object') return {
            ...autoScroll,
            enabled: enabled
        };
        return {
            enabled: enabled
        };
    }
});
const $3b30af0a3bfceeb3$var$NullContext = /*#__PURE__*/ (0, $kc00y.createContext)(null);
const $3b30af0a3bfceeb3$var$defaultRole = 'button';
const $3b30af0a3bfceeb3$var$ID_PREFIX = 'Draggable';
function $3b30af0a3bfceeb3$export$df30c81f5aa01ff7(_ref) {
    let { id: id, data: data, disabled: disabled = false, attributes: attributes } = _ref;
    const key = (0, $f5d873c94758f78f$export$c485849f2e393253)($3b30af0a3bfceeb3$var$ID_PREFIX);
    const { activators: activators, activatorEvent: activatorEvent, active: active, activeNodeRect: activeNodeRect, ariaDescribedById: ariaDescribedById, draggableNodes: draggableNodes, over: over } = (0, $kc00y.useContext)($3b30af0a3bfceeb3$var$InternalContext);
    const { role: role = $3b30af0a3bfceeb3$var$defaultRole, roleDescription: roleDescription = 'draggable', tabIndex: tabIndex = 0 } = attributes != null ? attributes : {};
    const isDragging = (active == null ? void 0 : active.id) === id;
    const transform = (0, $kc00y.useContext)(isDragging ? $3b30af0a3bfceeb3$var$ActiveDraggableContext : $3b30af0a3bfceeb3$var$NullContext);
    const [node, setNodeRef] = (0, $f5d873c94758f78f$export$bc23c270f170c912)();
    const [activatorNode, setActivatorNodeRef] = (0, $f5d873c94758f78f$export$bc23c270f170c912)();
    const listeners = $3b30af0a3bfceeb3$var$useSyntheticListeners(activators, id);
    const dataRef = (0, $f5d873c94758f78f$export$86c4283a11f23f95)(data);
    (0, $f5d873c94758f78f$export$700979bc83e7db82)(()=>{
        draggableNodes.set(id, {
            id: id,
            key: key,
            node: node,
            activatorNode: activatorNode,
            data: dataRef
        });
        return ()=>{
            const node = draggableNodes.get(id);
            if (node && node.key === key) draggableNodes.delete(id);
        };
    }, [
        draggableNodes,
        id
    ]);
    const memoizedAttributes = (0, $kc00y.useMemo)(()=>({
            role: role,
            tabIndex: tabIndex,
            'aria-disabled': disabled,
            'aria-pressed': isDragging && role === $3b30af0a3bfceeb3$var$defaultRole ? true : undefined,
            'aria-roledescription': roleDescription,
            'aria-describedby': ariaDescribedById.draggable
        }), [
        disabled,
        role,
        tabIndex,
        isDragging,
        roleDescription,
        ariaDescribedById.draggable
    ]);
    return {
        active: active,
        activatorEvent: activatorEvent,
        activeNodeRect: activeNodeRect,
        attributes: memoizedAttributes,
        isDragging: isDragging,
        listeners: disabled ? undefined : listeners,
        node: node,
        over: over,
        setNodeRef: setNodeRef,
        setActivatorNodeRef: setActivatorNodeRef,
        transform: transform
    };
}
function $3b30af0a3bfceeb3$export$4930f6bf413be70e() {
    return (0, $kc00y.useContext)($3b30af0a3bfceeb3$var$PublicContext);
}
const $3b30af0a3bfceeb3$var$ID_PREFIX$1 = 'Droppable';
const $3b30af0a3bfceeb3$var$defaultResizeObserverConfig = {
    timeout: 25
};
function $3b30af0a3bfceeb3$export$d74e5d67dc2b3176(_ref) {
    let { data: data, disabled: disabled = false, id: id, resizeObserverConfig: resizeObserverConfig } = _ref;
    const key = (0, $f5d873c94758f78f$export$c485849f2e393253)($3b30af0a3bfceeb3$var$ID_PREFIX$1);
    const { active: active, dispatch: dispatch, over: over, measureDroppableContainers: measureDroppableContainers } = (0, $kc00y.useContext)($3b30af0a3bfceeb3$var$InternalContext);
    const previous = (0, $kc00y.useRef)({
        disabled: disabled
    });
    const resizeObserverConnected = (0, $kc00y.useRef)(false);
    const rect = (0, $kc00y.useRef)(null);
    const callbackId = (0, $kc00y.useRef)(null);
    const { disabled: resizeObserverDisabled, updateMeasurementsFor: updateMeasurementsFor, timeout: resizeObserverTimeout } = {
        ...$3b30af0a3bfceeb3$var$defaultResizeObserverConfig,
        ...resizeObserverConfig
    };
    const ids = (0, $f5d873c94758f78f$export$86c4283a11f23f95)(updateMeasurementsFor != null ? updateMeasurementsFor : id);
    const handleResize = (0, $kc00y.useCallback)(()=>{
        if (!resizeObserverConnected.current) {
            // ResizeObserver invokes the `handleResize` callback as soon as `observe` is called,
            // assuming the element is rendered and displayed.
            resizeObserverConnected.current = true;
            return;
        }
        if (callbackId.current != null) clearTimeout(callbackId.current);
        callbackId.current = setTimeout(()=>{
            measureDroppableContainers(Array.isArray(ids.current) ? ids.current : [
                ids.current
            ]);
            callbackId.current = null;
        }, resizeObserverTimeout);
    }, [
        resizeObserverTimeout
    ]);
    const resizeObserver = $3b30af0a3bfceeb3$var$useResizeObserver({
        callback: handleResize,
        disabled: resizeObserverDisabled || !active
    });
    const handleNodeChange = (0, $kc00y.useCallback)((newElement, previousElement)=>{
        if (!resizeObserver) return;
        if (previousElement) {
            resizeObserver.unobserve(previousElement);
            resizeObserverConnected.current = false;
        }
        if (newElement) resizeObserver.observe(newElement);
    }, [
        resizeObserver
    ]);
    const [nodeRef, setNodeRef] = (0, $f5d873c94758f78f$export$bc23c270f170c912)(handleNodeChange);
    const dataRef = (0, $f5d873c94758f78f$export$86c4283a11f23f95)(data);
    (0, $kc00y.useEffect)(()=>{
        if (!resizeObserver || !nodeRef.current) return;
        resizeObserver.disconnect();
        resizeObserverConnected.current = false;
        resizeObserver.observe(nodeRef.current);
    }, [
        nodeRef,
        resizeObserver
    ]);
    (0, $kc00y.useEffect)(()=>{
        dispatch({
            type: $3b30af0a3bfceeb3$var$Action.RegisterDroppable,
            element: {
                id: id,
                key: key,
                disabled: disabled,
                node: nodeRef,
                rect: rect,
                data: dataRef
            }
        });
        return ()=>dispatch({
                type: $3b30af0a3bfceeb3$var$Action.UnregisterDroppable,
                key: key,
                id: id
            });
    }, [
        id
    ]);
    (0, $kc00y.useEffect)(()=>{
        if (disabled !== previous.current.disabled) {
            dispatch({
                type: $3b30af0a3bfceeb3$var$Action.SetDroppableDisabled,
                id: id,
                key: key,
                disabled: disabled
            });
            previous.current.disabled = disabled;
        }
    }, [
        id,
        key,
        disabled,
        dispatch
    ]);
    return {
        active: active,
        rect: rect,
        isOver: (over == null ? void 0 : over.id) === id,
        node: nodeRef,
        over: over,
        setNodeRef: setNodeRef
    };
}
function $3b30af0a3bfceeb3$var$AnimationManager(_ref) {
    let { animation: animation, children: children } = _ref;
    const [clonedChildren, setClonedChildren] = (0, $kc00y.useState)(null);
    const [element, setElement] = (0, $kc00y.useState)(null);
    const previousChildren = (0, $f5d873c94758f78f$export$5cae361ad82dce8b)(children);
    if (!children && !clonedChildren && previousChildren) setClonedChildren(previousChildren);
    (0, $f5d873c94758f78f$export$700979bc83e7db82)(()=>{
        if (!element) return;
        const key = clonedChildren == null ? void 0 : clonedChildren.key;
        const id = clonedChildren == null ? void 0 : clonedChildren.props.id;
        if (key == null || id == null) {
            setClonedChildren(null);
            return;
        }
        Promise.resolve(animation(id, element)).then(()=>{
            setClonedChildren(null);
        });
    }, [
        animation,
        clonedChildren,
        element
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).Fragment, null, children, clonedChildren ? (0, $kc00y.cloneElement)(clonedChildren, {
        ref: setElement
    }) : null);
}
const $3b30af0a3bfceeb3$var$defaultTransform = {
    x: 0,
    y: 0,
    scaleX: 1,
    scaleY: 1
};
function $3b30af0a3bfceeb3$var$NullifiedContextProvider(_ref) {
    let { children: children } = _ref;
    return (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement($3b30af0a3bfceeb3$var$InternalContext.Provider, {
        value: $3b30af0a3bfceeb3$var$defaultInternalContext
    }, (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement($3b30af0a3bfceeb3$var$ActiveDraggableContext.Provider, {
        value: $3b30af0a3bfceeb3$var$defaultTransform
    }, children));
}
const $3b30af0a3bfceeb3$var$baseStyles = {
    position: 'fixed',
    touchAction: 'none'
};
const $3b30af0a3bfceeb3$var$defaultTransition = (activatorEvent)=>{
    const isKeyboardActivator = (0, $f5d873c94758f78f$export$130b789831072f4c)(activatorEvent);
    return isKeyboardActivator ? 'transform 250ms ease' : undefined;
};
const $3b30af0a3bfceeb3$var$PositionedOverlay = /*#__PURE__*/ (0, $kc00y.forwardRef)((_ref, ref)=>{
    let { as: as, activatorEvent: activatorEvent, adjustScale: adjustScale, children: children, className: className, rect: rect, style: style, transform: transform, transition: transition = $3b30af0a3bfceeb3$var$defaultTransition } = _ref;
    if (!rect) return null;
    const scaleAdjustedTransform = adjustScale ? transform : {
        ...transform,
        scaleX: 1,
        scaleY: 1
    };
    const styles = {
        ...$3b30af0a3bfceeb3$var$baseStyles,
        width: rect.width,
        height: rect.height,
        top: rect.top,
        left: rect.left,
        transform: (0, $f5d873c94758f78f$export$c4ffa16951855e28).Transform.toString(scaleAdjustedTransform),
        transformOrigin: adjustScale && activatorEvent ? $3b30af0a3bfceeb3$var$getRelativeTransformOrigin(activatorEvent, rect) : undefined,
        transition: typeof transition === 'function' ? transition(activatorEvent) : transition,
        ...style
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement(as, {
        className: className,
        style: styles,
        ref: ref
    }, children);
});
const $3b30af0a3bfceeb3$export$28c62adcaabe654c = (options)=>(_ref)=>{
        let { active: active, dragOverlay: dragOverlay } = _ref;
        const originalStyles = {};
        const { styles: styles, className: className } = options;
        if (styles != null && styles.active) for (const [key, value] of Object.entries(styles.active)){
            if (value === undefined) continue;
            originalStyles[key] = active.node.style.getPropertyValue(key);
            active.node.style.setProperty(key, value);
        }
        if (styles != null && styles.dragOverlay) for (const [key, value] of Object.entries(styles.dragOverlay)){
            if (value === undefined) continue;
            dragOverlay.node.style.setProperty(key, value);
        }
        if (className != null && className.active) active.node.classList.add(className.active);
        if (className != null && className.dragOverlay) dragOverlay.node.classList.add(className.dragOverlay);
        return function cleanup() {
            for (const [key, value] of Object.entries(originalStyles))active.node.style.setProperty(key, value);
            if (className != null && className.active) active.node.classList.remove(className.active);
        };
    };
const $3b30af0a3bfceeb3$var$defaultKeyframeResolver = (_ref2)=>{
    let { transform: { initial: initial, final: final } } = _ref2;
    return [
        {
            transform: (0, $f5d873c94758f78f$export$c4ffa16951855e28).Transform.toString(initial)
        },
        {
            transform: (0, $f5d873c94758f78f$export$c4ffa16951855e28).Transform.toString(final)
        }
    ];
};
const $3b30af0a3bfceeb3$export$10f7ab1c653bb60e = {
    duration: 250,
    easing: 'ease',
    keyframes: $3b30af0a3bfceeb3$var$defaultKeyframeResolver,
    sideEffects: /*#__PURE__*/ $3b30af0a3bfceeb3$export$28c62adcaabe654c({
        styles: {
            active: {
                opacity: '0'
            }
        }
    })
};
function $3b30af0a3bfceeb3$var$useDropAnimation(_ref3) {
    let { config: config, draggableNodes: draggableNodes, droppableContainers: droppableContainers, measuringConfiguration: measuringConfiguration } = _ref3;
    return (0, $f5d873c94758f78f$export$90fc3a17d93f704c)((id, node)=>{
        if (config === null) return;
        const activeDraggable = draggableNodes.get(id);
        if (!activeDraggable) return;
        const activeNode = activeDraggable.node.current;
        if (!activeNode) return;
        const measurableNode = $3b30af0a3bfceeb3$var$getMeasurableNode(node);
        if (!measurableNode) return;
        const { transform: transform } = (0, $f5d873c94758f78f$export$38b2d434cce3ea22)(node).getComputedStyle(node);
        const parsedTransform = $3b30af0a3bfceeb3$var$parseTransform(transform);
        if (!parsedTransform) return;
        const animation = typeof config === 'function' ? config : $3b30af0a3bfceeb3$var$createDefaultDropAnimation(config);
        $3b30af0a3bfceeb3$var$scrollIntoViewIfNeeded(activeNode, measuringConfiguration.draggable.measure);
        return animation({
            active: {
                id: id,
                data: activeDraggable.data,
                node: activeNode,
                rect: measuringConfiguration.draggable.measure(activeNode)
            },
            draggableNodes: draggableNodes,
            dragOverlay: {
                node: node,
                rect: measuringConfiguration.dragOverlay.measure(measurableNode)
            },
            droppableContainers: droppableContainers,
            measuringConfiguration: measuringConfiguration,
            transform: parsedTransform
        });
    });
}
function $3b30af0a3bfceeb3$var$createDefaultDropAnimation(options) {
    const { duration: duration, easing: easing, sideEffects: sideEffects, keyframes: keyframes } = {
        ...$3b30af0a3bfceeb3$export$10f7ab1c653bb60e,
        ...options
    };
    return (_ref4)=>{
        let { active: active, dragOverlay: dragOverlay, transform: transform, ...rest } = _ref4;
        if (!duration) // Do not animate if animation duration is zero.
        return;
        const delta = {
            x: dragOverlay.rect.left - active.rect.left,
            y: dragOverlay.rect.top - active.rect.top
        };
        const scale = {
            scaleX: transform.scaleX !== 1 ? active.rect.width * transform.scaleX / dragOverlay.rect.width : 1,
            scaleY: transform.scaleY !== 1 ? active.rect.height * transform.scaleY / dragOverlay.rect.height : 1
        };
        const finalTransform = {
            x: transform.x - delta.x,
            y: transform.y - delta.y,
            ...scale
        };
        const animationKeyframes = keyframes({
            ...rest,
            active: active,
            dragOverlay: dragOverlay,
            transform: {
                initial: transform,
                final: finalTransform
            }
        });
        const [firstKeyframe] = animationKeyframes;
        const lastKeyframe = animationKeyframes[animationKeyframes.length - 1];
        if (JSON.stringify(firstKeyframe) === JSON.stringify(lastKeyframe)) // The start and end keyframes are the same, infer that there is no animation needed.
        return;
        const cleanup = sideEffects == null ? void 0 : sideEffects({
            active: active,
            dragOverlay: dragOverlay,
            ...rest
        });
        const animation = dragOverlay.node.animate(animationKeyframes, {
            duration: duration,
            easing: easing,
            fill: 'forwards'
        });
        return new Promise((resolve)=>{
            animation.onfinish = ()=>{
                cleanup == null || cleanup();
                resolve();
            };
        });
    };
}
let $3b30af0a3bfceeb3$var$key = 0;
function $3b30af0a3bfceeb3$var$useKey(id) {
    return (0, $kc00y.useMemo)(()=>{
        if (id == null) return;
        $3b30af0a3bfceeb3$var$key++;
        return $3b30af0a3bfceeb3$var$key;
    }, [
        id
    ]);
}
const $3b30af0a3bfceeb3$export$aca73479aa40659d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).memo((_ref)=>{
    let { adjustScale: adjustScale = false, children: children, dropAnimation: dropAnimationConfig, style: style, transition: transition, modifiers: modifiers, wrapperElement: wrapperElement = 'div', className: className, zIndex: zIndex = 999 } = _ref;
    const { activatorEvent: activatorEvent, active: active, activeNodeRect: activeNodeRect, containerNodeRect: containerNodeRect, draggableNodes: draggableNodes, droppableContainers: droppableContainers, dragOverlay: dragOverlay, over: over, measuringConfiguration: measuringConfiguration, scrollableAncestors: scrollableAncestors, scrollableAncestorRects: scrollableAncestorRects, windowRect: windowRect } = $3b30af0a3bfceeb3$export$4930f6bf413be70e();
    const transform = (0, $kc00y.useContext)($3b30af0a3bfceeb3$var$ActiveDraggableContext);
    const key = $3b30af0a3bfceeb3$var$useKey(active == null ? void 0 : active.id);
    const modifiedTransform = $3b30af0a3bfceeb3$export$f1696300e8775372(modifiers, {
        activatorEvent: activatorEvent,
        active: active,
        activeNodeRect: activeNodeRect,
        containerNodeRect: containerNodeRect,
        draggingNodeRect: dragOverlay.rect,
        over: over,
        overlayNodeRect: dragOverlay.rect,
        scrollableAncestors: scrollableAncestors,
        scrollableAncestorRects: scrollableAncestorRects,
        transform: transform,
        windowRect: windowRect
    });
    const initialRect = $3b30af0a3bfceeb3$var$useInitialValue(activeNodeRect);
    const dropAnimation = $3b30af0a3bfceeb3$var$useDropAnimation({
        config: dropAnimationConfig,
        draggableNodes: draggableNodes,
        droppableContainers: droppableContainers,
        measuringConfiguration: measuringConfiguration
    }); // We need to wait for the active node to be measured before connecting the drag overlay ref
    // otherwise collisions can be computed against a mispositioned drag overlay
    const ref = initialRect ? dragOverlay.setRef : undefined;
    return (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement($3b30af0a3bfceeb3$var$NullifiedContextProvider, null, (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement($3b30af0a3bfceeb3$var$AnimationManager, {
        animation: dropAnimation
    }, active && key ? (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement($3b30af0a3bfceeb3$var$PositionedOverlay, {
        key: key,
        id: active.id,
        ref: ref,
        as: wrapperElement,
        activatorEvent: activatorEvent,
        adjustScale: adjustScale,
        className: className,
        transition: transition,
        rect: initialRect,
        style: {
            zIndex: zIndex,
            ...style
        },
        transform: modifiedTransform
    }, children) : null));
});



var $kc00y = parcelRequire("kc00y");


/**
 * Move an array item to a different position. Returns a new array with the item moved to the new position.
 */ function $6e75a0664b0e0f07$export$5d49d615ad5ea2b0(array, from, to) {
    const newArray = array.slice();
    newArray.splice(to < 0 ? newArray.length + to : to, 0, newArray.splice(from, 1)[0]);
    return newArray;
}
/**
 * Swap an array item to a different position. Returns a new array with the item swapped to the new position.
 */ function $6e75a0664b0e0f07$export$5d3a3e794fd2dcef(array, from, to) {
    const newArray = array.slice();
    newArray[from] = array[to];
    newArray[to] = array[from];
    return newArray;
}
function $6e75a0664b0e0f07$var$getSortedRects(items, rects) {
    return items.reduce((accumulator, id, index)=>{
        const rect = rects.get(id);
        if (rect) accumulator[index] = rect;
        return accumulator;
    }, Array(items.length));
}
function $6e75a0664b0e0f07$var$isValidIndex(index) {
    return index !== null && index >= 0;
}
function $6e75a0664b0e0f07$var$itemsEqual(a, b) {
    if (a === b) return true;
    if (a.length !== b.length) return false;
    for(let i = 0; i < a.length; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
function $6e75a0664b0e0f07$var$normalizeDisabled(disabled) {
    if (typeof disabled === 'boolean') return {
        draggable: disabled,
        droppable: disabled
    };
    return disabled;
}
// To-do: We should be calculating scale transformation
const $6e75a0664b0e0f07$var$defaultScale = {
    scaleX: 1,
    scaleY: 1
};
const $6e75a0664b0e0f07$export$7a687825fa98548a = (_ref)=>{
    var _rects$activeIndex;
    let { rects: rects, activeNodeRect: fallbackActiveRect, activeIndex: activeIndex, overIndex: overIndex, index: index } = _ref;
    const activeNodeRect = (_rects$activeIndex = rects[activeIndex]) != null ? _rects$activeIndex : fallbackActiveRect;
    if (!activeNodeRect) return null;
    const itemGap = $6e75a0664b0e0f07$var$getItemGap(rects, index, activeIndex);
    if (index === activeIndex) {
        const newIndexRect = rects[overIndex];
        if (!newIndexRect) return null;
        return {
            x: activeIndex < overIndex ? newIndexRect.left + newIndexRect.width - (activeNodeRect.left + activeNodeRect.width) : newIndexRect.left - activeNodeRect.left,
            y: 0,
            ...$6e75a0664b0e0f07$var$defaultScale
        };
    }
    if (index > activeIndex && index <= overIndex) return {
        x: -activeNodeRect.width - itemGap,
        y: 0,
        ...$6e75a0664b0e0f07$var$defaultScale
    };
    if (index < activeIndex && index >= overIndex) return {
        x: activeNodeRect.width + itemGap,
        y: 0,
        ...$6e75a0664b0e0f07$var$defaultScale
    };
    return {
        x: 0,
        y: 0,
        ...$6e75a0664b0e0f07$var$defaultScale
    };
};
function $6e75a0664b0e0f07$var$getItemGap(rects, index, activeIndex) {
    const currentRect = rects[index];
    const previousRect = rects[index - 1];
    const nextRect = rects[index + 1];
    if (!currentRect || !previousRect && !nextRect) return 0;
    if (activeIndex < index) return previousRect ? currentRect.left - (previousRect.left + previousRect.width) : nextRect.left - (currentRect.left + currentRect.width);
    return nextRect ? nextRect.left - (currentRect.left + currentRect.width) : currentRect.left - (previousRect.left + previousRect.width);
}
const $6e75a0664b0e0f07$export$9377a9486e3fbbe1 = (_ref)=>{
    let { rects: rects, activeIndex: activeIndex, overIndex: overIndex, index: index } = _ref;
    const newRects = $6e75a0664b0e0f07$export$5d49d615ad5ea2b0(rects, overIndex, activeIndex);
    const oldRect = rects[index];
    const newRect = newRects[index];
    if (!newRect || !oldRect) return null;
    return {
        x: newRect.left - oldRect.left,
        y: newRect.top - oldRect.top,
        scaleX: newRect.width / oldRect.width,
        scaleY: newRect.height / oldRect.height
    };
};
const $6e75a0664b0e0f07$export$8b26fb37076c162 = (_ref)=>{
    let { activeIndex: activeIndex, index: index, rects: rects, overIndex: overIndex } = _ref;
    let oldRect;
    let newRect;
    if (index === activeIndex) {
        oldRect = rects[index];
        newRect = rects[overIndex];
    }
    if (index === overIndex) {
        oldRect = rects[index];
        newRect = rects[activeIndex];
    }
    if (!newRect || !oldRect) return null;
    return {
        x: newRect.left - oldRect.left,
        y: newRect.top - oldRect.top,
        scaleX: newRect.width / oldRect.width,
        scaleY: newRect.height / oldRect.height
    };
};
// To-do: We should be calculating scale transformation
const $6e75a0664b0e0f07$var$defaultScale$1 = {
    scaleX: 1,
    scaleY: 1
};
const $6e75a0664b0e0f07$export$fe2be640df2ffb9e = (_ref)=>{
    var _rects$activeIndex;
    let { activeIndex: activeIndex, activeNodeRect: fallbackActiveRect, index: index, rects: rects, overIndex: overIndex } = _ref;
    const activeNodeRect = (_rects$activeIndex = rects[activeIndex]) != null ? _rects$activeIndex : fallbackActiveRect;
    if (!activeNodeRect) return null;
    if (index === activeIndex) {
        const overIndexRect = rects[overIndex];
        if (!overIndexRect) return null;
        return {
            x: 0,
            y: activeIndex < overIndex ? overIndexRect.top + overIndexRect.height - (activeNodeRect.top + activeNodeRect.height) : overIndexRect.top - activeNodeRect.top,
            ...$6e75a0664b0e0f07$var$defaultScale$1
        };
    }
    const itemGap = $6e75a0664b0e0f07$var$getItemGap$1(rects, index, activeIndex);
    if (index > activeIndex && index <= overIndex) return {
        x: 0,
        y: -activeNodeRect.height - itemGap,
        ...$6e75a0664b0e0f07$var$defaultScale$1
    };
    if (index < activeIndex && index >= overIndex) return {
        x: 0,
        y: activeNodeRect.height + itemGap,
        ...$6e75a0664b0e0f07$var$defaultScale$1
    };
    return {
        x: 0,
        y: 0,
        ...$6e75a0664b0e0f07$var$defaultScale$1
    };
};
function $6e75a0664b0e0f07$var$getItemGap$1(clientRects, index, activeIndex) {
    const currentRect = clientRects[index];
    const previousRect = clientRects[index - 1];
    const nextRect = clientRects[index + 1];
    if (!currentRect) return 0;
    if (activeIndex < index) return previousRect ? currentRect.top - (previousRect.top + previousRect.height) : nextRect ? nextRect.top - (currentRect.top + currentRect.height) : 0;
    return nextRect ? nextRect.top - (currentRect.top + currentRect.height) : previousRect ? currentRect.top - (previousRect.top + previousRect.height) : 0;
}
const $6e75a0664b0e0f07$var$ID_PREFIX = 'Sortable';
const $6e75a0664b0e0f07$var$Context = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createContext({
    activeIndex: -1,
    containerId: $6e75a0664b0e0f07$var$ID_PREFIX,
    disableTransforms: false,
    items: [],
    overIndex: -1,
    useDragOverlay: false,
    sortedRects: [],
    strategy: $6e75a0664b0e0f07$export$9377a9486e3fbbe1,
    disabled: {
        draggable: false,
        droppable: false
    }
});
function $6e75a0664b0e0f07$export$86155fde54f06e6a(_ref) {
    let { children: children, id: id, items: userDefinedItems, strategy: strategy = $6e75a0664b0e0f07$export$9377a9486e3fbbe1, disabled: disabledProp = false } = _ref;
    const { active: active, dragOverlay: dragOverlay, droppableRects: droppableRects, over: over, measureDroppableContainers: measureDroppableContainers } = (0, $3b30af0a3bfceeb3$export$4930f6bf413be70e)();
    const containerId = (0, $f5d873c94758f78f$export$c485849f2e393253)($6e75a0664b0e0f07$var$ID_PREFIX, id);
    const useDragOverlay = Boolean(dragOverlay.rect !== null);
    const items = (0, $kc00y.useMemo)(()=>userDefinedItems.map((item)=>typeof item === 'object' && 'id' in item ? item.id : item), [
        userDefinedItems
    ]);
    const isDragging = active != null;
    const activeIndex = active ? items.indexOf(active.id) : -1;
    const overIndex = over ? items.indexOf(over.id) : -1;
    const previousItemsRef = (0, $kc00y.useRef)(items);
    const itemsHaveChanged = !$6e75a0664b0e0f07$var$itemsEqual(items, previousItemsRef.current);
    const disableTransforms = overIndex !== -1 && activeIndex === -1 || itemsHaveChanged;
    const disabled = $6e75a0664b0e0f07$var$normalizeDisabled(disabledProp);
    (0, $f5d873c94758f78f$export$700979bc83e7db82)(()=>{
        if (itemsHaveChanged && isDragging) measureDroppableContainers(items);
    }, [
        itemsHaveChanged,
        items,
        isDragging,
        measureDroppableContainers
    ]);
    (0, $kc00y.useEffect)(()=>{
        previousItemsRef.current = items;
    }, [
        items
    ]);
    const contextValue = (0, $kc00y.useMemo)(()=>({
            activeIndex: activeIndex,
            containerId: containerId,
            disabled: disabled,
            disableTransforms: disableTransforms,
            items: items,
            overIndex: overIndex,
            useDragOverlay: useDragOverlay,
            sortedRects: $6e75a0664b0e0f07$var$getSortedRects(items, droppableRects),
            strategy: strategy
        }), [
        activeIndex,
        containerId,
        disabled.draggable,
        disabled.droppable,
        disableTransforms,
        items,
        overIndex,
        droppableRects,
        useDragOverlay,
        strategy
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).createElement($6e75a0664b0e0f07$var$Context.Provider, {
        value: contextValue
    }, children);
}
const $6e75a0664b0e0f07$export$e1ca29a833a61b5e = (_ref)=>{
    let { id: id, items: items, activeIndex: activeIndex, overIndex: overIndex } = _ref;
    return $6e75a0664b0e0f07$export$5d49d615ad5ea2b0(items, activeIndex, overIndex).indexOf(id);
};
const $6e75a0664b0e0f07$export$633d85fd1dcf5e11 = (_ref2)=>{
    let { containerId: containerId, isSorting: isSorting, wasDragging: wasDragging, index: index, items: items, newIndex: newIndex, previousItems: previousItems, previousContainerId: previousContainerId, transition: transition } = _ref2;
    if (!transition || !wasDragging) return false;
    if (previousItems !== items && index === newIndex) return false;
    if (isSorting) return true;
    return newIndex !== index && containerId === previousContainerId;
};
const $6e75a0664b0e0f07$var$defaultTransition = {
    duration: 200,
    easing: 'ease'
};
const $6e75a0664b0e0f07$var$transitionProperty = 'transform';
const $6e75a0664b0e0f07$var$disabledTransition = /*#__PURE__*/ (0, $f5d873c94758f78f$export$c4ffa16951855e28).Transition.toString({
    property: $6e75a0664b0e0f07$var$transitionProperty,
    duration: 0,
    easing: 'linear'
});
const $6e75a0664b0e0f07$var$defaultAttributes = {
    roleDescription: 'sortable'
};
/*
 * When the index of an item changes while sorting,
 * we need to temporarily disable the transforms
 */ function $6e75a0664b0e0f07$var$useDerivedTransform(_ref) {
    let { disabled: disabled, index: index, node: node, rect: rect } = _ref;
    const [derivedTransform, setDerivedtransform] = (0, $kc00y.useState)(null);
    const previousIndex = (0, $kc00y.useRef)(index);
    (0, $f5d873c94758f78f$export$700979bc83e7db82)(()=>{
        if (!disabled && index !== previousIndex.current && node.current) {
            const initial = rect.current;
            if (initial) {
                const current = (0, $3b30af0a3bfceeb3$export$b6aa1f30c53d7454)(node.current, {
                    ignoreTransform: true
                });
                const delta = {
                    x: initial.left - current.left,
                    y: initial.top - current.top,
                    scaleX: initial.width / current.width,
                    scaleY: initial.height / current.height
                };
                if (delta.x || delta.y) setDerivedtransform(delta);
            }
        }
        if (index !== previousIndex.current) previousIndex.current = index;
    }, [
        disabled,
        index,
        node,
        rect
    ]);
    (0, $kc00y.useEffect)(()=>{
        if (derivedTransform) setDerivedtransform(null);
    }, [
        derivedTransform
    ]);
    return derivedTransform;
}
function $6e75a0664b0e0f07$export$4ebcb6201122185a(_ref) {
    let { animateLayoutChanges: animateLayoutChanges = $6e75a0664b0e0f07$export$633d85fd1dcf5e11, attributes: userDefinedAttributes, disabled: localDisabled, data: customData, getNewIndex: getNewIndex = $6e75a0664b0e0f07$export$e1ca29a833a61b5e, id: id, strategy: localStrategy, resizeObserverConfig: resizeObserverConfig, transition: transition = $6e75a0664b0e0f07$var$defaultTransition } = _ref;
    const { items: items, containerId: containerId, activeIndex: activeIndex, disabled: globalDisabled, disableTransforms: disableTransforms, sortedRects: sortedRects, overIndex: overIndex, useDragOverlay: useDragOverlay, strategy: globalStrategy } = (0, $kc00y.useContext)($6e75a0664b0e0f07$var$Context);
    const disabled = $6e75a0664b0e0f07$var$normalizeLocalDisabled(localDisabled, globalDisabled);
    const index = items.indexOf(id);
    const data = (0, $kc00y.useMemo)(()=>({
            sortable: {
                containerId: containerId,
                index: index,
                items: items
            },
            ...customData
        }), [
        containerId,
        customData,
        index,
        items
    ]);
    const itemsAfterCurrentSortable = (0, $kc00y.useMemo)(()=>items.slice(items.indexOf(id)), [
        items,
        id
    ]);
    const { rect: rect, node: node, isOver: isOver, setNodeRef: setDroppableNodeRef } = (0, $3b30af0a3bfceeb3$export$d74e5d67dc2b3176)({
        id: id,
        data: data,
        disabled: disabled.droppable,
        resizeObserverConfig: {
            updateMeasurementsFor: itemsAfterCurrentSortable,
            ...resizeObserverConfig
        }
    });
    const { active: active, activatorEvent: activatorEvent, activeNodeRect: activeNodeRect, attributes: attributes, setNodeRef: setDraggableNodeRef, listeners: listeners, isDragging: isDragging, over: over, setActivatorNodeRef: setActivatorNodeRef, transform: transform } = (0, $3b30af0a3bfceeb3$export$df30c81f5aa01ff7)({
        id: id,
        data: data,
        attributes: {
            ...$6e75a0664b0e0f07$var$defaultAttributes,
            ...userDefinedAttributes
        },
        disabled: disabled.draggable
    });
    const setNodeRef = (0, $f5d873c94758f78f$export$2f8294366bb2d67a)(setDroppableNodeRef, setDraggableNodeRef);
    const isSorting = Boolean(active);
    const displaceItem = isSorting && !disableTransforms && $6e75a0664b0e0f07$var$isValidIndex(activeIndex) && $6e75a0664b0e0f07$var$isValidIndex(overIndex);
    const shouldDisplaceDragSource = !useDragOverlay && isDragging;
    const dragSourceDisplacement = shouldDisplaceDragSource && displaceItem ? transform : null;
    const strategy = localStrategy != null ? localStrategy : globalStrategy;
    const finalTransform = displaceItem ? dragSourceDisplacement != null ? dragSourceDisplacement : strategy({
        rects: sortedRects,
        activeNodeRect: activeNodeRect,
        activeIndex: activeIndex,
        overIndex: overIndex,
        index: index
    }) : null;
    const newIndex = $6e75a0664b0e0f07$var$isValidIndex(activeIndex) && $6e75a0664b0e0f07$var$isValidIndex(overIndex) ? getNewIndex({
        id: id,
        items: items,
        activeIndex: activeIndex,
        overIndex: overIndex
    }) : index;
    const activeId = active == null ? void 0 : active.id;
    const previous = (0, $kc00y.useRef)({
        activeId: activeId,
        items: items,
        newIndex: newIndex,
        containerId: containerId
    });
    const itemsHaveChanged = items !== previous.current.items;
    const shouldAnimateLayoutChanges = animateLayoutChanges({
        active: active,
        containerId: containerId,
        isDragging: isDragging,
        isSorting: isSorting,
        id: id,
        index: index,
        items: items,
        newIndex: previous.current.newIndex,
        previousItems: previous.current.items,
        previousContainerId: previous.current.containerId,
        transition: transition,
        wasDragging: previous.current.activeId != null
    });
    const derivedTransform = $6e75a0664b0e0f07$var$useDerivedTransform({
        disabled: !shouldAnimateLayoutChanges,
        index: index,
        node: node,
        rect: rect
    });
    (0, $kc00y.useEffect)(()=>{
        if (isSorting && previous.current.newIndex !== newIndex) previous.current.newIndex = newIndex;
        if (containerId !== previous.current.containerId) previous.current.containerId = containerId;
        if (items !== previous.current.items) previous.current.items = items;
    }, [
        isSorting,
        newIndex,
        containerId,
        items
    ]);
    (0, $kc00y.useEffect)(()=>{
        if (activeId === previous.current.activeId) return;
        if (activeId != null && previous.current.activeId == null) {
            previous.current.activeId = activeId;
            return;
        }
        const timeoutId = setTimeout(()=>{
            previous.current.activeId = activeId;
        }, 50);
        return ()=>clearTimeout(timeoutId);
    }, [
        activeId
    ]);
    return {
        active: active,
        activeIndex: activeIndex,
        attributes: attributes,
        data: data,
        rect: rect,
        index: index,
        newIndex: newIndex,
        items: items,
        isOver: isOver,
        isSorting: isSorting,
        isDragging: isDragging,
        listeners: listeners,
        node: node,
        overIndex: overIndex,
        over: over,
        setNodeRef: setNodeRef,
        setActivatorNodeRef: setActivatorNodeRef,
        setDroppableNodeRef: setDroppableNodeRef,
        setDraggableNodeRef: setDraggableNodeRef,
        transform: derivedTransform != null ? derivedTransform : finalTransform,
        transition: getTransition()
    };
    function getTransition() {
        if (derivedTransform || // Or to prevent items jumping to back to their "new" position when items change
        itemsHaveChanged && previous.current.newIndex === index) return $6e75a0664b0e0f07$var$disabledTransition;
        if (shouldDisplaceDragSource && !(0, $f5d873c94758f78f$export$130b789831072f4c)(activatorEvent) || !transition) return undefined;
        if (isSorting || shouldAnimateLayoutChanges) return (0, $f5d873c94758f78f$export$c4ffa16951855e28).Transition.toString({
            ...transition,
            property: $6e75a0664b0e0f07$var$transitionProperty
        });
        return undefined;
    }
}
function $6e75a0664b0e0f07$var$normalizeLocalDisabled(localDisabled, globalDisabled) {
    var _localDisabled$dragga, _localDisabled$droppa;
    if (typeof localDisabled === 'boolean') return {
        draggable: localDisabled,
        // Backwards compatibility
        droppable: false
    };
    return {
        draggable: (_localDisabled$dragga = localDisabled == null ? void 0 : localDisabled.draggable) != null ? _localDisabled$dragga : globalDisabled.draggable,
        droppable: (_localDisabled$droppa = localDisabled == null ? void 0 : localDisabled.droppable) != null ? _localDisabled$droppa : globalDisabled.droppable
    };
}
function $6e75a0664b0e0f07$export$6424ec8a0d450b09(entry) {
    if (!entry) return false;
    const data = entry.data.current;
    if (data && 'sortable' in data && typeof data.sortable === 'object' && 'containerId' in data.sortable && 'items' in data.sortable && 'index' in data.sortable) return true;
    return false;
}
const $6e75a0664b0e0f07$var$directions = [
    (0, $3b30af0a3bfceeb3$export$a8b1916dba3ae88b).Down,
    (0, $3b30af0a3bfceeb3$export$a8b1916dba3ae88b).Right,
    (0, $3b30af0a3bfceeb3$export$a8b1916dba3ae88b).Up,
    (0, $3b30af0a3bfceeb3$export$a8b1916dba3ae88b).Left
];
const $6e75a0664b0e0f07$export$a6f27ecf02eb3a67 = (event, _ref)=>{
    let { context: { active: active, collisionRect: collisionRect, droppableRects: droppableRects, droppableContainers: droppableContainers, over: over, scrollableAncestors: scrollableAncestors } } = _ref;
    if ($6e75a0664b0e0f07$var$directions.includes(event.code)) {
        event.preventDefault();
        if (!active || !collisionRect) return;
        const filteredContainers = [];
        droppableContainers.getEnabled().forEach((entry)=>{
            if (!entry || entry != null && entry.disabled) return;
            const rect = droppableRects.get(entry.id);
            if (!rect) return;
            switch(event.code){
                case (0, $3b30af0a3bfceeb3$export$a8b1916dba3ae88b).Down:
                    if (collisionRect.top < rect.top) filteredContainers.push(entry);
                    break;
                case (0, $3b30af0a3bfceeb3$export$a8b1916dba3ae88b).Up:
                    if (collisionRect.top > rect.top) filteredContainers.push(entry);
                    break;
                case (0, $3b30af0a3bfceeb3$export$a8b1916dba3ae88b).Left:
                    if (collisionRect.left > rect.left) filteredContainers.push(entry);
                    break;
                case (0, $3b30af0a3bfceeb3$export$a8b1916dba3ae88b).Right:
                    if (collisionRect.left < rect.left) filteredContainers.push(entry);
                    break;
            }
        });
        const collisions = (0, $3b30af0a3bfceeb3$export$c3a6c1c7122b31c9)({
            active: active,
            collisionRect: collisionRect,
            droppableRects: droppableRects,
            droppableContainers: filteredContainers,
            pointerCoordinates: null
        });
        let closestId = (0, $3b30af0a3bfceeb3$export$ef1beab6d7287295)(collisions, 'id');
        if (closestId === (over == null ? void 0 : over.id) && collisions.length > 1) closestId = collisions[1].id;
        if (closestId != null) {
            const activeDroppable = droppableContainers.get(active.id);
            const newDroppable = droppableContainers.get(closestId);
            const newRect = newDroppable ? droppableRects.get(newDroppable.id) : null;
            const newNode = newDroppable == null ? void 0 : newDroppable.node.current;
            if (newNode && newRect && activeDroppable && newDroppable) {
                const newScrollAncestors = (0, $3b30af0a3bfceeb3$export$e4864aa91b5ed091)(newNode);
                const hasDifferentScrollAncestors = newScrollAncestors.some((element, index)=>scrollableAncestors[index] !== element);
                const hasSameContainer = $6e75a0664b0e0f07$var$isSameContainer(activeDroppable, newDroppable);
                const isAfterActive = $6e75a0664b0e0f07$var$isAfter(activeDroppable, newDroppable);
                const offset = hasDifferentScrollAncestors || !hasSameContainer ? {
                    x: 0,
                    y: 0
                } : {
                    x: isAfterActive ? collisionRect.width - newRect.width : 0,
                    y: isAfterActive ? collisionRect.height - newRect.height : 0
                };
                const rectCoordinates = {
                    x: newRect.left,
                    y: newRect.top
                };
                const newCoordinates = offset.x && offset.y ? rectCoordinates : (0, $f5d873c94758f78f$export$4e2d2ead65e5f7e3)(rectCoordinates, offset);
                return newCoordinates;
            }
        }
    }
    return undefined;
};
function $6e75a0664b0e0f07$var$isSameContainer(a, b) {
    if (!$6e75a0664b0e0f07$export$6424ec8a0d450b09(a) || !$6e75a0664b0e0f07$export$6424ec8a0d450b09(b)) return false;
    return a.data.current.sortable.containerId === b.data.current.sortable.containerId;
}
function $6e75a0664b0e0f07$var$isAfter(a, b) {
    if (!$6e75a0664b0e0f07$export$6424ec8a0d450b09(a) || !$6e75a0664b0e0f07$export$6424ec8a0d450b09(b)) return false;
    if (!$6e75a0664b0e0f07$var$isSameContainer(a, b)) return false;
    return a.data.current.sortable.index < b.data.current.sortable.index;
}










const $5dbf5c26121a4115$var$SortableRowTourneePei = ({ id: id, item: // La propriété id doit impérativement s'appeler id
item, onRemove: onRemove, canRemove: canRemove })=>{
    const { setNodeRef: setNodeRef, listeners: listeners, transform: transform, transition: transition } = (0, $6e75a0664b0e0f07$export$4ebcb6201122185a)({
        id: id
    });
    const styles = {
        transform: (0, $f5d873c94758f78f$export$c4ffa16951855e28).Transform.toString(transform),
        transition: transition
    };
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("tr", {
        ref: setNodeRef,
        style: styles,
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("td", {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("span", {
                        ...listeners,
                        role: "button",
                        className: "pe-2",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$72e0de8e793fca75), {})
                    }),
                    item.peiNumeroComplet
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("td", {
                children: item.natureLibelle
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("td", {
                children: item.adresse
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("td", {
                children: item.communeLibelle
            }),
            canRemove && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("td", {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                    variant: "link",
                    className: "text-danger text-decoration-none",
                    onClick: ()=>{
                        onRemove(id);
                    },
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$e04bcc6127e699bf), {})
                })
            })
        ]
    });
};
const $5dbf5c26121a4115$var$SortableTableTourneePei = ({ data: data, setData: setData })=>{
    const { user: user } = (0, $e787cde576104469$export$fdc397e486fa83e7)();
    const canRemove = (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).TOURNEE_A);
    function handleRemove(id) {
        setData((data)=>data.filter((e)=>e.id !== id));
    }
    function dragEndEvent(e) {
        const { over: over, active: active } = e;
        setData((data)=>{
            return (0, $6e75a0664b0e0f07$export$5d49d615ad5ea2b0)(data, data.findIndex((item)=>item.id === active.id), data.findIndex((item)=>item.id === over?.id));
        });
    }
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $3b30af0a3bfceeb3$export$2d5c5ceac203fc1e), {
        onDragEnd: dragEndEvent,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $13de46b4dfcc473f$export$2e2bcd8739ae039), {
            bordered: true,
            striped: true,
            children: [
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("thead", {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("th", {
                                children: [
                                    "Point d'eau",
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                                        tooltipText: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                                            children: [
                                                "Utilisez la fonctionnalit\xe9 de glisser / d\xe9placer \xe0 l'aide du bouton ",
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$72e0de8e793fca75), {}),
                                                " en d\xe9but de ligne pour placer les PEI dans l'ordre souhait\xe9"
                                            ]
                                        }),
                                        tooltipId: "dragDropTournee",
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$340bfce9b4df026b), {})
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("th", {
                                children: "Nature"
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("th", {
                                children: "Adresse"
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("th", {
                                children: "Commune"
                            }),
                            canRemove && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("th", {
                                children: [
                                    "Action",
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                                        tooltipText: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                                            children: [
                                                "Le bouton \xa0",
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$e04bcc6127e699bf), {}),
                                                "\xa0 permet de supprimer le PEI correspondant de la tourn\xe9e"
                                            ]
                                        }),
                                        tooltipId: "supprimeTournee",
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$340bfce9b4df026b), {})
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("tbody", {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $6e75a0664b0e0f07$export$86155fde54f06e6a), {
                        items: data,
                        children: data.map((v)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($5dbf5c26121a4115$var$SortableRowTourneePei, {
                                id: v.id,
                                item: v,
                                onRemove: handleRemove,
                                canRemove: canRemove
                            }, v.id))
                    })
                })
            ]
        })
    });
};
var $5dbf5c26121a4115$export$2e2bcd8739ae039 = $5dbf5c26121a4115$var$SortableTableTourneePei;













const $d5414c57b72b1aae$var$TourneePei = ({ tourneeMapId: tourneeMapId, listePeiId: listePeiId, closeVolet: closeVolet })=>{
    const { tourneeId: tourneeId } = (0, $7a844823b04d4282$export$99eaa27ddbbb95ef)();
    const { user: user } = (0, $e787cde576104469$export$fdc397e486fa83e7)();
    const tourneeIdToUse = tourneeMapId ?? tourneeId;
    const canManageTournee = (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).TOURNEE_A);
    const tourneePeiInfo = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/tournee/listPeiTournee/${tourneeIdToUse}?${{
        listePeiId: JSON.stringify(listePeiId)
    }}`);
    // TODO ajouter la liste des PEI en plus
    const allPeiInfoSource = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)(canManageTournee ? `/api/tournee/listPei/` + tourneeIdToUse : "", {});
    const [data, setData] = (0, $kc00y.useState)(null);
    const [errorMessage, setErrorMessage] = (0, $kc00y.useState)(null);
    const [displaySection, setDisplaySection] = (0, $kc00y.useState)(false);
    const [selectOptions, setSelectOptions] = (0, $kc00y.useState)([]);
    const [selectedPei, setSelectedPei] = (0, $kc00y.useState)(null);
    const { success: successToast, error: errorToast } = (0, $6bdae0bad7b05751$export$91b3d218c74c79e4)();
    const navigate = (0, $7a844823b04d4282$export$9770f232ac06a008)();
    const location = (0, $7a844823b04d4282$export$45d76561a5302f2b)();
    if (tourneePeiInfo.isResolved && data == null) setData(tourneePeiInfo.data.listPeiTournee.map((e)=>{
        return {
            id: e.peiId,
            peiNumeroComplet: e.peiNumeroComplet,
            natureDeciCode: e.natureDeciCode,
            natureLibelle: e.natureLibelle,
            adresse: e.adresse,
            communeLibelle: e.communeLibelle,
            tourneeId: tourneeIdToUse
        };
    }));
    const execute = (0, $8d9ebd8892d8a5f5$export$f378150f39d4621f)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/tournee/listPeiTournee/update/` + tourneeIdToUse, {
        onResolve: ()=>{
            closeVolet ? closeVolet() : (0, $c066b242635c27a6$export$e37953fa8ba80500)(location, navigate, (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_TOURNEE);
            successToast("L'\xe9l\xe9ment a bien \xe9t\xe9 mis \xe0 jour.");
        },
        onReject: async (error)=>{
            setErrorMessage(await error.text());
            errorToast(await error.text());
        }
    }, true);
    const filterOptions = (0, $kc00y.useCallback)(()=>{
        if (!canManageTournee) return [];
        let filteredList = allPeiInfoSource.data;
        if (data.length > 0) {
            if (data[0].natureDeciCode === "ICPE" || data[0].natureDeciCode === "ICPE_CONVENTIONNE") filteredList = filteredList.filter((e)=>e.natureDeciCode === "ICPE" || e.natureDeciCode === "ICPE_CONVENTIONNE");
            else filteredList = filteredList.filter((e)=>e.natureDeciCode === data[0].natureDeciCode);
            filteredList = filteredList.filter((v)=>!data.map((e)=>e.id).includes(v.peiId));
        }
        return filteredList.map((e)=>{
            return {
                id: e.peiId,
                peiNumeroComplet: e.peiNumeroComplet,
                natureDeciCode: e.natureDeciCode,
                natureLibelle: e.natureLibelle,
                adresse: e.adresse,
                communeLibelle: e.communeLibelle,
                tourneeId: tourneeIdToUse
            };
        });
    }, [
        allPeiInfoSource.data,
        data,
        tourneeIdToUse,
        canManageTournee
    ]);
    (0, $kc00y.useEffect)(()=>{
        if (allPeiInfoSource.isResolved && data) {
            setSelectedPei(null);
            setSelectOptions(filterOptions());
        }
    }, [
        data,
        allPeiInfoSource.isResolved,
        filterOptions
    ]);
    const submitList = ()=>{
        const formData = new FormData();
        const formattedData = data.map((e, index)=>{
            return {
                tourneeId: e.tourneeId,
                peiId: e.id,
                ordre: index + 1
            };
        });
        formData.append("listTourneePei", JSON.stringify(formattedData));
        execute.run(formData);
    };
    const showAddPeiSection = ()=>{
        setSelectOptions(filterOptions());
        setDisplaySection(!displaySection);
    };
    const addPei = ()=>{
        setData((data)=>[
                ...data,
                selectedPei
            ]);
    };
    const showLoading = !tourneePeiInfo.isResolved || !allPeiInfoSource.isResolved;
    if (showLoading) return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $c21b1c237cfa1d94$export$2e2bcd8739ae039), {});
    return data && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$5ee68ae963bf2bda), {}),
                title: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                    children: [
                        "Gestion des PEI de la tourn\xe9e\xa0",
                        tourneePeiInfo.data.tourneeLibelle
                    ]
                }),
                right: (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).TOURNEE_A) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8ad69b89456b65bc$export$2e2bcd8739ae039), {
                    title: "Ajouter un PEI",
                    onClick: showAddPeiSection
                }),
                displayReturnButton: tourneeMapId ? false : true
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                className: "my-3 mx-2",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("h3", {
                            className: "fw-bold",
                            children: [
                                "Libell\xe9 tourn\xe9e : ",
                                tourneePeiInfo.data.tourneeLibelle
                            ]
                        }),
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("h3", {
                            className: "fw-bold",
                            children: [
                                "Organisme : ",
                                tourneePeiInfo.data.organismeLibelle
                            ]
                        }),
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("h3", {
                            className: "fw-bold",
                            children: [
                                "Nombre de PEI : ",
                                data.length
                            ]
                        })
                    ]
                })
            }),
            displaySection && allPeiInfoSource && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                className: "m-2 p-1 bg-light border border-1 border-secondary",
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ac15ab874ad2390c$export$2e2bcd8739ae039), {
                            options: selectOptions,
                            getOptionValue: (t)=>t.id,
                            getOptionLabel: (t)=>t.peiNumeroComplet,
                            value: selectedPei,
                            onChange: setSelectedPei,
                            className: "my-3 mx-2",
                            placeholder: "S\xe9lectionnez",
                            noOptionsMessage: ()=>"Aucune donn\xe9e trouv\xe9e"
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        sm: "auto",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                            onClick: addPei,
                            className: "my-3 mx-2",
                            disabled: selectedPei === null,
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$d776d19dfae66ece), {}),
                                " Ajouter le PEI"
                            ]
                        })
                    })
                ]
            }),
            errorMessage !== null && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                className: "text-danger",
                children: errorMessage
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $5dbf5c26121a4115$export$2e2bcd8739ae039), {
                data: data,
                setData: setData
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db9b0e6fdb142a4c$export$2e2bcd8739ae039), {
                onClick: submitList
            })
        ]
    });
};
var $d5414c57b72b1aae$export$2e2bcd8739ae039 = $d5414c57b72b1aae$var$TourneePei;


const $1ca593349a99e9a5$var$AffecterPeiTourneeMap = ({ listePei: listePei, isPrive: isPrive, isIcpe: isIcpe, closeVolet: closeVolet })=>{
    const [create, setCreate] = (0, $kc00y.useState)(false);
    const [update, setUpdate] = (0, $kc00y.useState)(false);
    const [showListePei, setShowListePei] = (0, $kc00y.useState)(false);
    const [tourneeId, setTourneeId] = (0, $kc00y.useState)();
    // Callback pour recevoir l'id de la tournée créée et afficher la liste
    const handleTourneeCreated = (id)=>{
        setTourneeId(id);
        setShowListePei(true);
    };
    // Ref pour contrôler la soumission du formulaire CreateTournee
    const createTourneeRef = (0, $kc00y.useRef)(null);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("b", {
                children: "PEI s\xe9lectionn\xe9s :"
            }),
            " ",
            listePei.map((e)=>e.numeroComplet).join(", "),
            !create && !update ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                        displayReturnButton: false,
                        icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$5ee68ae963bf2bda), {}),
                        title: "Ajouter les PEI \xe0 une tourn\xe9e"
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                className: "mt-3 text-center",
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                                        variant: "primary",
                                        onClick: ()=>{
                                            setCreate(true);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$d776d19dfae66ece), {}),
                                            " Cr\xe9er une tourn\xe9e avec ces PEI"
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                className: "mt-3 text-center",
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                                        variant: "primary",
                                        onClick: ()=>{
                                            setUpdate(true);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$b51dd496211ae105), {}),
                                            " Affecter ces PEI \xe0 une tourn\xe9e existante"
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                ]
            }) : showListePei ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $d5414c57b72b1aae$export$2e2bcd8739ae039), {
                    listePeiId: listePei.map((e)=>e.peiId),
                    tourneeMapId: tourneeId,
                    closeVolet: closeVolet
                })
            }) : create ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $a1be20d90875d36b$export$2e2bcd8739ae039), {
                ref: createTourneeRef,
                isFromMap: true,
                setTourneeId: handleTourneeCreated,
                listePei: listePei.map((e)=>e.peiId)
            }) : update && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($1ca593349a99e9a5$var$Update, {
                    isPrive: isPrive,
                    isIcpe: isIcpe,
                    listePei: listePei.map((e)=>e.peiId),
                    setTourneeId: setTourneeId
                })
            }),
            (create || update) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                className: "mt-3 text-center",
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                            type: "button",
                            variant: "primary",
                            onClick: ()=>{
                                setCreate(false);
                                setUpdate(false);
                                setTourneeId(undefined);
                                setShowListePei(false);
                            },
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$41884575254a94be), {}),
                                " Pr\xe9c\xe9dent"
                            ]
                        })
                    }),
                    create && !showListePei && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                            type: "button",
                            variant: "primary",
                            onClick: ()=>{
                                if (createTourneeRef.current && createTourneeRef.current.submit) createTourneeRef.current.submit();
                            },
                            children: [
                                "Suivant ",
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$3213a407ffb0559), {})
                            ]
                        })
                    }),
                    update && !showListePei && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                            type: "button",
                            variant: "primary",
                            disabled: tourneeId === undefined,
                            onClick: ()=>setShowListePei(true),
                            children: [
                                "Suivant ",
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$3213a407ffb0559), {})
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
const $1ca593349a99e9a5$var$Update = ({ isPrive: isPrive, isIcpe: isIcpe, listePei: listePei, setTourneeId: setTourneeId })=>{
    const tournees = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/tournee/actives?${{
        isPrive: isPrive,
        isIcpe: isIcpe,
        listePei: JSON.stringify(listePei)
    }}`);
    if (!tournees.isResolved) return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $c21b1c237cfa1d94$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$5ee68ae963bf2bda), {}),
                title: "Choisissez la tourn\xe9e",
                displayReturnButton: false
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ac15ab874ad2390c$export$2e2bcd8739ae039), {
                isMulti: false,
                placeholder: "S\xe9lectionnez",
                noOptionsMessage: ()=>"Aucune donn\xe9e trouv\xe9e",
                options: tournees?.data,
                getOptionValue: (t)=>t.tourneeId,
                getOptionLabel: (t)=>t.tourneeLibelle,
                onChange: (e)=>setTourneeId(e.tourneeId)
            })
        ]
    });
};
var $1ca593349a99e9a5$export$2e2bcd8739ae039 = $1ca593349a99e9a5$var$AffecterPeiTourneeMap;




var $bkJfK = parcelRequire("bkJfK");

var $kc00y = parcelRequire("kc00y");










const $2e70ec757db05d39$var$SimpleConfirmModal = ({ ref: ref, visible: visible, closeModal: closeModal, onSubmit: onSubmit, header: header, content: content, confirmButtonText: confirmButtonText })=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $8e1f7dde30da3bf6$export$2e2bcd8739ae039), {
        show: visible,
        onHide: closeModal,
        ref: ref,
        size: "xl",
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8e1f7dde30da3bf6$export$2e2bcd8739ae039).Header, {
                closeButton: true,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8e1f7dde30da3bf6$export$2e2bcd8739ae039).Title, {
                    children: header
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eda4eaeb791cb8f1$export$89b68a1a5a6d2b69), {
                closeModal: onSubmit,
                content: content,
                confirmButtonText: confirmButtonText
            })
        ]
    });
};
var $2e70ec757db05d39$export$2e2bcd8739ae039 = $2e70ec757db05d39$var$SimpleConfirmModal;



const $c0d44c4437327dc3$export$a5cab80145b70e98 = (dataPeis)=>({
        peiData: dataPeis ? dataPeis.map((pei)=>({
                ...pei,
                tournees: pei.tournees.map((tournee)=>({
                        ...tournee
                    }))
            })) : []
    });
const $c0d44c4437327dc3$var$DesaffecterPeiTourneeMap = ({ listePei: listePei, closeVolet: closeVolet })=>{
    const ids = listePei?.map((pei)=>pei.peiId) ?? [];
    const { data: dataPeis } = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)(ids.length ? (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/pei-desaffecter-tournee/get-pei-tournee?${{
        peiIds: JSON.stringify(ids)
    }}` : "");
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                displayReturnButton: false,
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$5ee68ae963bf2bda), {}),
                title: "D\xe9saffecter les PEI de leur tourn\xe9e"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                className: "bg-light border p-2 rounded",
                children: "Les points d'eau suivants vont \xeatre d\xe9saffect\xe9s de leurs tourn\xe9es s\xe9lectionn\xe9es."
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                isPost: false,
                isMultipartFormData: false,
                submitUrl: `/api/pei-desaffecter-tournee/desaffecter-tournee`,
                onSubmit: closeVolet,
                prepareVariables: (values)=>$c0d44c4437327dc3$export$f97400759cfd946(values),
                initialValues: $c0d44c4437327dc3$export$a5cab80145b70e98(dataPeis),
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($c0d44c4437327dc3$var$DesaffecterPeiTourneeForm, {
                    allPeiData: dataPeis
                })
            })
        ]
    });
};
const $c0d44c4437327dc3$var$DesaffecterPeiTourneeForm = ({ allPeiData: allPeiData })=>{
    const { values: values, setFieldValue: setFieldValue, submitForm: submitForm } = (0, $bkJfK.useFormikContext)();
    const { visible: visible, show: show, close: close, ref: ref } = (0, $ca8671088139af49$export$2e2bcd8739ae039)();
    const initPeiData = (0, $kc00y.useMemo)(()=>{
        if (!allPeiData) return [];
        return allPeiData.flatMap((pei)=>pei.tournees.map((tournee)=>({
                    peiId: pei.peiId,
                    peiNumeroComplet: pei.peiNumeroComplet,
                    ...tournee
                })));
    }, [
        allPeiData
    ]);
    // Set pour savoir quelles tournées sont actuellement sélectionnées
    const selectedRow = (0, $kc00y.useMemo)(()=>{
        const set = new Set();
        values.peiData.forEach((pei)=>// On ajoute une clé pour chaque tournée sélectionnée qui est selectionnée
            pei.tournees.forEach((tournee)=>set.add(`${pei.peiId}_${tournee.idTournee}`)));
        return set; // toutes les lignes selectionnées
    }, [
        values.peiData
    ]);
    const selectLine = (peiId, tourneeId)=>{
        const newPeiData = values.peiData.map((pei)=>{
            if (pei.peiId !== peiId) return pei; // Si ce n'est pas le PEI concerné, on le laisse tel quel
            const tournees = pei.tournees.filter((tournee)=>tournee.idTournee !== tourneeId);
            return {
                ...pei,
                tournees: tournees
            };
        });
        if (values.peiData.find((pei)=>pei.peiId === peiId)) {
            const tournee = allPeiData?.find((pei)=>pei.peiId === peiId)?.tournees.find((tournee)=>tournee.idTournee === tourneeId);
            // Si la tournée existe et n'était pas sélectionnée avant
            if (tournee && !selectedRow.has(`${peiId}_${tourneeId}`)) {
                setFieldValue("peiData", newPeiData.map((pei)=>pei.peiId === peiId ? {
                        ...pei,
                        tournees: [
                            ...pei.tournees,
                            tournee
                        ]
                    } : pei));
                return;
            }
        }
        setFieldValue("peiData", newPeiData);
    };
    const onSelectAll = (checked)=>{
        if (!allPeiData) return;
        const newPeiData = checked ? allPeiData.map((pei)=>({
                ...pei,
                tournees: [
                    ...pei.tournees
                ]
            })) : allPeiData.map((pei)=>({
                ...pei,
                tournees: []
            }));
        setFieldValue("peiData", newPeiData);
    };
    const selectedTourneesCount = values.peiData.reduce((acc, pei)=>acc + pei.tournees.length, 0);
    return values ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $13de46b4dfcc473f$export$2e2bcd8739ae039), {
                bordered: true,
                responsive: true,
                className: "mt-3",
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("thead", {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("th", {
                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $15ea91ee06c5121b$export$2e2bcd8739ae039), {
                                        type: "checkbox",
                                        label: "S\xe9lectionner",
                                        checked: initPeiData.length > 0 && selectedTourneesCount === initPeiData.length,
                                        onChange: (e)=>onSelectAll(e.target.checked)
                                    })
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("th", {
                                    children: "Num\xe9ro de PEI"
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("th", {
                                    children: "Libell\xe9 de la tourn\xe9e"
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("th", {
                                    children: "Organisme"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("tbody", {
                        children: initPeiData.map((row)=>{
                            const key = `${row.peiId}_${row.idTournee}`;
                            const isChecked = selectedRow.has(key);
                            return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("td", {
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $15ea91ee06c5121b$export$2e2bcd8739ae039), {
                                            type: "checkbox",
                                            checked: isChecked,
                                            onChange: ()=>selectLine(row.peiId, row.idTournee)
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("td", {
                                        children: row.peiNumeroComplet
                                    }),
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("td", {
                                        children: row.libelleTournee
                                    }),
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("td", {
                                        children: row.organismeTournee
                                    })
                                ]
                            }, key);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                className: "d-flex justify-content-end mt-3",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                    variant: "primary",
                    disabled: selectedTourneesCount === 0,
                    onClick: ()=>show(),
                    children: "D\xe9saffecter"
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2e70ec757db05d39$export$2e2bcd8739ae039), {
                onSubmit: ()=>{
                    submitForm();
                    close();
                },
                closeModal: ()=>close(),
                confirmButtonText: "Confirmer",
                content: "Confirmer la d\xe9saffectation des PEI s\xe9lectionn\xe9s",
                header: "Confirmation de la d\xe9saffectation",
                ref: ref,
                visible: visible
            })
        ]
    }) : /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
        className: "mt-3",
        children: "Seuls les PEI dont les tourn\xe9es sont rattach\xe9es \xe0 votre organisme ou vos organismes enfants peuvent \xeatre d\xe9saffect\xe9s."
    });
};
const $c0d44c4437327dc3$export$f97400759cfd946 = (values)=>{
    return values.peiData.filter((p)=>p.tournees.length > 0).map((p)=>({
            peiId: p.peiId,
            peiNumeroComplet: p.peiNumeroComplet,
            tournees: p.tournees.map((t)=>({
                    idTournee: t.idTournee,
                    libelleTournee: t.libelleTournee,
                    organismeTournee: t.organismeTournee
                }))
        }));
};
var $c0d44c4437327dc3$export$2e2bcd8739ae039 = $c0d44c4437327dc3$var$DesaffecterPeiTourneeMap;
















const $185040c6178f57d9$export$4189fbf3a3d5eb53 = ({ map: map, workingLayer: workingLayer, dataPeiLayer: dataPeiLayer, setShowFormPei: setShowFormPei, setCoordonneesPeiCreate: setCoordonneesPeiCreate })=>{
    const { visible: visible, show: show, close: close, ref: ref } = (0, $ca8671088139af49$export$2e2bcd8739ae039)();
    const { visible: visibleMove, show: showMove, close: closeMove, ref: refMove } = (0, $ca8671088139af49$export$2e2bcd8739ae039)();
    const { error: errorToast } = (0, $6bdae0bad7b05751$export$91b3d218c74c79e4)();
    // Chargement des paramètres de style de sélection
    const parametres = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/parametres?${{
        listeParametreCode: JSON.stringify([
            (0, $ee297f06e8568bf4$export$2e2bcd8739ae039).PEI_SELECTION_COULEUR,
            (0, $ee297f06e8568bf4$export$2e2bcd8739ae039).PEI_SELECTION_RAYON,
            (0, $ee297f06e8568bf4$export$2e2bcd8739ae039).PEI_SELECTION_LARGEUR
        ])
    }}`);
    const [listePeiId, setListePeiId] = (0, $kc00y.useState)([]);
    const [listePeiTourneePublic, setListePeiTourneePublic] = (0, $kc00y.useState)([]);
    const [listePeiTourneePrive, setListePeiTourneePrive] = (0, $kc00y.useState)([]);
    const [listePeiTourneeIcpe, setListePeiTourneeIcpe] = (0, $kc00y.useState)([]);
    const [showCreateIndispoTemp, setShowCreateIndispoTemp] = (0, $kc00y.useState)(false);
    const handleCloseIndispoTemp = ()=>setShowCreateIndispoTemp(false);
    const [showCreateTournee, setShowCreateTournee] = (0, $kc00y.useState)(false);
    const handleCloseTournee = ()=>setShowCreateTournee(false);
    const [showDesaffecterTournee, setShowDesaffecterTournee] = (0, $kc00y.useState)(false);
    const handleCloseDesaffecterTournee = ()=>setShowDesaffecterTournee(false);
    const [showCreateDebitSimultane, setShowCreateDebitSimultane] = (0, $kc00y.useState)(false);
    const handleCloseDebitSimultane = ()=>setShowCreateDebitSimultane(false);
    const [listePeiIdDebitSimultane, setListePeiIdDebitSimultane] = (0, $kc00y.useState)([]);
    const [typeReseauId, setTypeReseauId] = (0, $kc00y.useState)();
    const [peiInfoMove, setPeiInfodMove] = (0, $kc00y.useState)(null);
    const [geometrieMove, setGeometrieMove] = (0, $kc00y.useState)(null);
    const highlightedFeatureRef = (0, $kc00y.useRef)(null);
    const selectionStyle = (0, $kc00y.useMemo)(()=>new (0, $a5fc261473972d1d$export$2e2bcd8739ae039)({
            image: new (0, $f060542c6e9f52e6$export$2e2bcd8739ae039)({
                radius: parseInt(parametres.data?.[(0, $ee297f06e8568bf4$export$2e2bcd8739ae039).PEI_SELECTION_RAYON]?.parametreValeur) || 16,
                stroke: new (0, $281691897fddf9d0$export$2e2bcd8739ae039)({
                    color: parametres.data?.[(0, $ee297f06e8568bf4$export$2e2bcd8739ae039).PEI_SELECTION_COULEUR]?.parametreValeur || "#ff00f2b3",
                    width: parseInt(parametres.data?.[(0, $ee297f06e8568bf4$export$2e2bcd8739ae039).PEI_SELECTION_LARGEUR]?.parametreValeur) || 4
                })
            })
        }), [
        parametres.data
    ]);
    const tools = (0, $kc00y.useMemo)(()=>{
        function associeNatureDeciPeiTournee(features) {
            const prives = [];
            const publics = [];
            const icpes = [];
            features.forEach((feature)=>{
                const point = feature.getProperties();
                const obj = {
                    peiId: point.elementId,
                    numeroComplet: point.peiNumeroComplet
                };
                switch(point.natureDeciCode){
                    case (0, $e2b283d869a75a62$export$2e2bcd8739ae039).PRIVE:
                        prives.push(obj);
                        break;
                    case (0, $e2b283d869a75a62$export$2e2bcd8739ae039).ICPE:
                    case (0, $e2b283d869a75a62$export$2e2bcd8739ae039).ICPE_CONVENTIONNE:
                        icpes.push(obj);
                        break;
                    default:
                        publics.push(obj);
                }
            });
            if (prives.length > 0 && publics.length === 0 && icpes.length === 0) {
                setListePeiTourneePrive(prives);
                setListePeiTourneePublic([]);
                setListePeiTourneeIcpe([]);
            } else if (publics.length > 0 && prives.length === 0 && icpes.length === 0) {
                setListePeiTourneePublic(publics);
                setListePeiTourneePrive([]);
                setListePeiTourneeIcpe([]);
            } else if (icpes.length > 0 && prives.length === 0 && publics.length === 0) {
                setListePeiTourneeIcpe(icpes);
                setListePeiTourneePrive([]);
                setListePeiTourneePublic([]);
            } else {
                setListePeiTourneePrive([]);
                setListePeiTourneePublic([]);
                setListePeiTourneeIcpe([]);
            }
        }
        if (!map) return {};
        const createCtrl = new (0, $2ef894158a48397d$export$2e2bcd8739ae039)({
            source: workingLayer.getSource(),
            type: "Point",
            style: (feature)=>{
                const geometryType = feature.getGeometry().getType();
                if (geometryType === "Point") return new (0, $a5fc261473972d1d$export$2e2bcd8739ae039)({
                    fill: new (0, $8624b871a0af6dab$export$2e2bcd8739ae039)({
                        color: "rgba(255, 255, 255, 0.2)"
                    }),
                    stroke: new (0, $281691897fddf9d0$export$2e2bcd8739ae039)({
                        color: "rgba(0, 0, 0, 0.5)",
                        lineDash: [
                            10,
                            10
                        ],
                        width: 2
                    }),
                    image: new (0, $f060542c6e9f52e6$export$2e2bcd8739ae039)({
                        radius: 5,
                        stroke: new (0, $281691897fddf9d0$export$2e2bcd8739ae039)({
                            color: "rgba(0, 0, 0, 0.7)"
                        }),
                        fill: new (0, $8624b871a0af6dab$export$2e2bcd8739ae039)({
                            color: "rgba(255, 255, 255, 0.2)"
                        })
                    })
                });
            }
        });
        createCtrl.on("drawstart", async ()=>{
            // Avant de redessiner un point, on supprime les autres points, le but est d'avoir juste un seul point à la fois.
            workingLayer.getSource().clear();
        });
        createCtrl.on("drawend", async (event)=>{
            const feature = event.feature;
            (await fetch((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/zone-integration/check`, (0, $fbd4d34e07af0ac7$export$b163ec2f884327db)({
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    geometry: "SRID=" + map.getView().getProjection().getCode().split(":").pop() + ";" + new (0, $15a985d09649bdc2$export$2e2bcd8739ae039)().writeFeature(feature)
                })
            }))).text().then((text)=>{
                if (text === "true") {
                    setShowFormPei(true);
                    setCoordonneesPeiCreate({
                        coordonneeX: feature.getGeometry().getFlatCoordinates()[0],
                        coordonneeY: feature.getGeometry().getFlatCoordinates()[1],
                        srid: map.getView().getProjection().getCode().split(":").pop()
                    });
                } else {
                    workingLayer.getSource().removeFeature(event.feature);
                    errorToast(text);
                }
            }).catch((reason)=>{
                workingLayer.getSource().removeFeature(event.feature);
                errorToast(reason);
            });
        });
        // Style de sélection paramétrable — calculé dans selectionStyle (useMemo dédié)
        const selectCtrl = new (0, $20af4deb83586389$export$2e2bcd8739ae039)({
            style: selectionStyle,
            toggleCondition: (0, $638912a122b4daef$export$f3100d8d6292d638),
            multi: true,
            hitTolerance: 16
        });
        // Remplir listePeiId lors d'un Ctrl+clic (sélection individuelle)
        selectCtrl.on("select", function() {
            const newListe = [];
            const peiPrivesDebitSimultane = [];
            const peiIcpesDebitSimultane = [];
            const totalFeatures = selectCtrl.getFeatures().getLength();
            selectCtrl.getFeatures().forEach((feature)=>{
                const point = feature.getProperties();
                if (!newListe.includes(point.elementId)) newListe.push(point.elementId);
                if (point.natureDeciCode === (0, $e2b283d869a75a62$export$2e2bcd8739ae039).PRIVE && point.pibiTypeReseauId != null) peiPrivesDebitSimultane.push(point);
                else if ((point.natureDeciCode === (0, $e2b283d869a75a62$export$2e2bcd8739ae039).ICPE || point.natureDeciCode === (0, $e2b283d869a75a62$export$2e2bcd8739ae039).ICPE_CONVENTIONNE) && point.pibiTypeReseauId != null) peiIcpesDebitSimultane.push(point);
            });
            setListePeiId(newListe);
            const peiDebitSimultane = [
                ...peiPrivesDebitSimultane,
                ...peiIcpesDebitSimultane
            ];
            const distinctTypeReseau = peiDebitSimultane.map((pei)=>pei.pibiTypeReseauId).filter((value, index, self)=>self.indexOf(value) === index);
            const hasDebitSimultane = peiDebitSimultane.map((pei)=>pei.hasDebitSimultane).find((e)=>e === true);
            // Si TOUS les PEI sélectionnés sont éligibles (privés/ICPE), ont le même type de réseau, n'ont pas de débit simultané et sont au moins 2, on autorise la création
            if (peiDebitSimultane.length === totalFeatures && peiDebitSimultane.length >= 2 && distinctTypeReseau.length === 1 && hasDebitSimultane == null) {
                setListePeiIdDebitSimultane(peiDebitSimultane.map((e)=>e.elementId));
                setTypeReseauId(distinctTypeReseau.at(0));
            } else {
                setListePeiIdDebitSimultane([]);
                setTypeReseauId(undefined);
            }
            associeNatureDeciPeiTournee(selectCtrl.getFeatures());
        });
        const dragBoxCtrl = new (0, $886371f562c99b97$export$2e2bcd8739ae039)({
            style: new (0, $a5fc261473972d1d$export$2e2bcd8739ae039)({
                stroke: new (0, $281691897fddf9d0$export$2e2bcd8739ae039)({
                    color: [
                        0,
                        0,
                        255,
                        1
                    ]
                })
            }),
            minArea: 25
        });
        dragBoxCtrl.on("boxend", function(e) {
            if (!(0, $638912a122b4daef$export$f3100d8d6292d638)(e.mapBrowserEvent)) selectCtrl.getFeatures().clear();
            const boxExtent = dragBoxCtrl.getGeometry().getExtent();
            const boxFeatures = dataPeiLayer.getSource().getFeaturesInExtent(boxExtent);
            selectCtrl.getFeatures().extend(boxFeatures);
            const newListe = [];
            const peiPrivesDebitSimultane = [];
            const peiIcpesDebitSimultane = [];
            const totalFeatures = selectCtrl.getFeatures().getLength();
            selectCtrl.getFeatures().forEach((e)=>{
                const point = e.getProperties();
                if (!newListe.includes(point.elementId)) newListe.push(point.elementId);
                if (point.natureDeciCode === (0, $e2b283d869a75a62$export$2e2bcd8739ae039).PRIVE && point.pibiTypeReseauId != null) peiPrivesDebitSimultane.push(point);
                else if ((point.natureDeciCode === (0, $e2b283d869a75a62$export$2e2bcd8739ae039).ICPE || point.natureDeciCode === (0, $e2b283d869a75a62$export$2e2bcd8739ae039).ICPE_CONVENTIONNE) && point.pibiTypeReseauId != null) peiIcpesDebitSimultane.push(point);
            });
            setListePeiId(newListe);
            const peiDebitSimultane = [
                ...peiPrivesDebitSimultane,
                ...peiIcpesDebitSimultane
            ];
            const distinctTypeReseau = peiDebitSimultane.map((pei)=>pei.pibiTypeReseauId).filter((value, index, self)=>self.indexOf(value) === index);
            const hasDebitSimultane = peiDebitSimultane.map((pei)=>pei.hasDebitSimultane).find((e)=>e === true);
            // Si TOUS les PEI sélectionnés sont éligibles (privés/ICPE), ont le même type de réseau, n'ont pas de débit simultané et sont au moins 2, on autorise la création
            if (peiDebitSimultane.length === totalFeatures && peiDebitSimultane.length >= 2 && distinctTypeReseau.length === 1 && hasDebitSimultane == null) {
                setListePeiIdDebitSimultane(peiDebitSimultane.map((e)=>e.elementId));
                setTypeReseauId(distinctTypeReseau.at(0));
            } else {
                setListePeiIdDebitSimultane([]);
                setTypeReseauId(undefined);
            }
            // A retirer en 3.1 => ticket #126505
            associeNatureDeciPeiTournee(selectCtrl.getFeatures());
        });
        function toggleSelect(active = false) {
            const idx1 = map?.getInteractions().getArray().indexOf(selectCtrl);
            const idx2 = map?.getInteractions().getArray().indexOf(dragBoxCtrl);
            if (active) {
                if (idx1 === -1 && idx2 === -1) {
                    map.addInteraction(selectCtrl);
                    map.addInteraction(dragBoxCtrl);
                }
            } else {
                setListePeiTourneePrive([]);
                setListePeiTourneePublic([]);
                setListePeiTourneeIcpe([]);
                setListePeiId([]);
                setListePeiIdDebitSimultane([]);
                setTypeReseauId(undefined);
                selectCtrl.getFeatures().clear();
                map.removeInteraction(selectCtrl);
                map.removeInteraction(dragBoxCtrl);
            }
        }
        function toggleCreate(active = false) {
            const idx = map?.getInteractions().getArray().indexOf(createCtrl);
            if (active) {
                if (idx === -1) map.addInteraction(createCtrl);
            } else map.removeInteraction(createCtrl);
        }
        const selectPeiCtrl = new (0, $20af4deb83586389$export$2e2bcd8739ae039)();
        const modifyCtrl = new (0, $2375ecf9b29b2a49$export$2e2bcd8739ae039)({
            features: selectPeiCtrl.getFeatures(),
            source: dataPeiLayer,
            snapToPointer: true
        });
        function toggleDeplacerPei(active = false) {
            if (highlightedFeatureRef.current) {
                highlightedFeatureRef.current.setStyle(undefined);
                highlightedFeatureRef.current = null;
            }
            if (active) {
                if (map?.getInteractions().getArray().includes(selectPeiCtrl) && map?.getInteractions().getArray().includes(modifyCtrl)) return;
                map.addInteraction(selectPeiCtrl);
                // Délai pour permettre le chargement des features via la stratégie bbox
                setTimeout(()=>{
                    map.addInteraction(modifyCtrl);
                });
                modifyCtrl.on("modifyend", function(evt) {
                    evt.features.forEach(async function(feature) {
                        const featureGeometry = "SRID=" + map.getView().getProjection().getCode().split(":").pop() + ";" + new (0, $15a985d09649bdc2$export$2e2bcd8739ae039)().writeFeature(feature);
                        const featureProps = feature.getProperties();
                        setGeometrieMove(featureGeometry);
                        setPeiInfodMove(featureProps);
                        showMove();
                    });
                });
            } else {
                map.removeInteraction(selectPeiCtrl);
                map.removeInteraction(modifyCtrl);
                setPeiInfodMove(null);
                setGeometrieMove(null);
            }
        }
        const tools = {
            "select-pei": {
                action: toggleSelect,
                actionPossibleEnDeplacement: false
            },
            "create-pei": {
                action: toggleCreate
            },
            "deplacer-pei": {
                action: toggleDeplacerPei
            }
        };
        return tools;
    }, [
        map,
        errorToast,
        dataPeiLayer,
        setShowFormPei,
        showMove,
        setCoordonneesPeiCreate,
        workingLayer?.getSource,
        selectionStyle
    ]);
    function createUpdateTournee() {
        setShowCreateTournee(true);
    }
    function createDesaffecterTournee() {
        setShowDesaffecterTournee(true);
    }
    function createIndispoTemp() {
        setShowCreateIndispoTemp(true);
    }
    async function createDebitSimultane() {
        // On regarde si les PEI sélectionné sont à moins de 500 mètres
        (await fetch((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/debit-simultane/check-distance?${{
            listePibiId: JSON.stringify(listePeiIdDebitSimultane)
        }}`, (0, $fbd4d34e07af0ac7$export$b163ec2f884327db)({
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({})
        }))).text().then((text)=>{
            if (text === "true") setShowCreateDebitSimultane(true);
            else show();
        }).catch(()=>{
            show();
        });
    }
    function syncTooltipSelection(selection) {
        // Retirer le highlight de la feature précédente
        if (highlightedFeatureRef.current) {
            highlightedFeatureRef.current.setStyle(undefined);
            highlightedFeatureRef.current = null;
        }
        if (selection == null) {
            setListePeiId([]);
            setListePeiTourneePrive([]);
            setListePeiTourneePublic([]);
            setListePeiTourneeIcpe([]);
            setListePeiIdDebitSimultane([]);
            setTypeReseauId(undefined);
            return;
        }
        // Appliquer le highlight sur la nouvelle feature
        const feature = dataPeiLayer.getSource()?.getFeatures().find((f)=>f.getProperties().elementId === selection.elementId);
        if (feature) {
            feature.setStyle(selectionStyle);
            highlightedFeatureRef.current = feature;
        }
        setListePeiId([
            selection.elementId
        ]);
        setListePeiIdDebitSimultane([]);
        setTypeReseauId(undefined);
        switch(selection.natureDeciCode){
            case (0, $e2b283d869a75a62$export$2e2bcd8739ae039).PRIVE:
                setListePeiTourneePrive([
                    {
                        peiId: selection.elementId,
                        numeroComplet: selection.peiNumeroComplet
                    }
                ]);
                setListePeiTourneePublic([]);
                setListePeiTourneeIcpe([]);
                break;
            case (0, $e2b283d869a75a62$export$2e2bcd8739ae039).ICPE:
            case (0, $e2b283d869a75a62$export$2e2bcd8739ae039).ICPE_CONVENTIONNE:
                setListePeiTourneeIcpe([
                    {
                        peiId: selection.elementId,
                        numeroComplet: selection.peiNumeroComplet
                    }
                ]);
                setListePeiTourneePrive([]);
                setListePeiTourneePublic([]);
                break;
            default:
                setListePeiTourneePublic([
                    {
                        peiId: selection.elementId,
                        numeroComplet: selection.peiNumeroComplet
                    }
                ]);
                setListePeiTourneePrive([]);
                setListePeiTourneeIcpe([]);
        }
    }
    return {
        tools: tools,
        showCreateIndispoTemp: showCreateIndispoTemp,
        handleCloseIndispoTemp: handleCloseIndispoTemp,
        listePeiId: listePeiId,
        createIndispoTemp: createIndispoTemp,
        createUpdateTournee: createUpdateTournee,
        createDesaffecterTournee: createDesaffecterTournee,
        showCreateTournee: showCreateTournee,
        showDesaffecterTournee: showDesaffecterTournee,
        handleCloseTournee: handleCloseTournee,
        handleCloseDesaffecterTournee: handleCloseDesaffecterTournee,
        listePeiTourneePublic: listePeiTourneePublic,
        listePeiTourneePrive: listePeiTourneePrive,
        listePeiTourneeIcpe: listePeiTourneeIcpe,
        createDebitSimultane: createDebitSimultane,
        handleCloseDebitSimultane: handleCloseDebitSimultane,
        showCreateDebitSimultane: showCreateDebitSimultane,
        listePeiIdDebitSimultane: listePeiIdDebitSimultane,
        typeReseauId: typeReseauId,
        ref: ref,
        visible: visible,
        close: close,
        peiInfoMove: peiInfoMove,
        geometrieMove: geometrieMove,
        closeMove: closeMove,
        visibleMove: visibleMove,
        refMove: refMove,
        syncTooltipSelection: syncTooltipSelection
    };
};
const $185040c6178f57d9$export$f97400759cfd946 = (values)=>({
        geometry: values.geometrie,
        voieId: values.voieId,
        voieLibelle: values.voieLibelle
    });
const $185040c6178f57d9$var$MapToolbarPei = ({ toggleTool: toggleToolCallback, activeTool: activeTool, map: map, dataPeiLayer: dataPeiLayer, showCreateIndispoTemp: showCreateIndispoTemp, handleCloseIndispoTemp: handleCloseIndispoTemp, listePeiId: listePeiId, createIndispoTemp: createIndispoTemp, createUpdateTournee: createUpdateTournee, createDesaffecterTournee: createDesaffecterTournee, showDesaffecterTournee: showDesaffecterTournee, showCreateTournee: showCreateTournee, handleCloseDesaffecterTournee: handleCloseDesaffecterTournee, handleCloseTournee: handleCloseTournee, listePeiTourneePrive: listePeiTourneePrive, listePeiTourneePublic: listePeiTourneePublic, listePeiTourneeIcpe: listePeiTourneeIcpe, dataDebitSimultaneLayer: dataDebitSimultaneLayer, createDebitSimultane: createDebitSimultane, handleCloseDebitSimultane: handleCloseDebitSimultane, showCreateDebitSimultane: showCreateDebitSimultane, listePeiIdDebitSimultane: listePeiIdDebitSimultane, typeReseauId: typeReseauId, closeModal: closeModal, refModal: refModal, visibleModal: visibleModal, setPeiIdUpdate: setPeiIdUpdate, setShowFormPei: setShowFormPei, showFormPei: showFormPei, peiIdUpdate: peiIdUpdate, disabledTool: disabledTool, peiInfoMove: peiInfoMove, geometrieMove: geometrieMove, closeMove: closeMove, visibleMove: visibleMove, setShowFormVisite: setShowFormVisite, showFormVisite: showFormVisite, coordonneesPeiCreate: coordonneesPeiCreate, syncTooltipSelection: syncTooltipSelection })=>{
    const { user: user } = (0, $e787cde576104469$export$fdc397e486fa83e7)();
    const canEdit = (0, $e3b8d60f4bb99483$export$4f612ab7b7b1d133)(user, [
        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).PEI_U,
        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).PEI_ADRESSE_C
    ]);
    const voiesList = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)(geometrieMove ? (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/pei/voie?${{
        geometry: geometrieMove
    }}` : "")?.data;
    const parametreVoieSaisieLibre = (0, $ee297f06e8568bf4$export$2e2bcd8739ae039).VOIE_SAISIE_LIBRE;
    const listeParametre = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/parametres?${{
        listeParametreCode: JSON.stringify(parametreVoieSaisieLibre)
    }}`);
    const isSaisieVoieEnabled = (0, $kc00y.useMemo)(()=>{
        if (!listeParametre.isResolved) return false;
        // Le résultat est une String, on le parse pour récupérer le tableau
        return JSON.parse(listeParametre?.data[parametreVoieSaisieLibre].parametreValeur);
    }, [
        listeParametre
    ]);
    // Pour afficher le *bon* bouton pour accéder à la fiche PEI (lecture, écriture)
    const canEditPei = (0, $e3b8d60f4bb99483$export$4f612ab7b7b1d133)(user, [
        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).PEI_U,
        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).PEI_CARACTERISTIQUES_U,
        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).PEI_DEPLACEMENT_U,
        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).PEI_NUMERO_INTERNE_U,
        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).PEI_ADRESSE_C
    ]);
    const handleTooltipPeiSelectionChange = (0, $kc00y.useCallback)((selection)=>{
        if (activeTool === "select-pei") return;
        syncTooltipSelection(selection);
    }, [
        activeTool,
        syncTooltipSelection
    ]);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $a43e6f68e14bab96$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $f2eef644ac9323e0$export$2e2bcd8739ae039), {
                toolName: "select-pei",
                toolIcon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$249df474ea45aebc), {}),
                toolLabelTooltip: "S\xe9lectionner",
                toggleTool: toggleToolCallback,
                activeTool: activeTool
            }),
            (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).PEI_C) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $f2eef644ac9323e0$export$2e2bcd8739ae039), {
                toolName: "create-pei",
                toolIcon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$d776d19dfae66ece), {}),
                disabled: showFormPei && peiIdUpdate || showFormVisite.show,
                toolLabelTooltip: showFormPei && peiIdUpdate || showFormVisite.show ? "Un formulaire est en cours d'\xe9dition" : "Cr\xe9er un PEI",
                toggleTool: toggleToolCallback,
                activeTool: activeTool
            }),
            (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).PEI_DEPLACEMENT_U) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $f2eef644ac9323e0$export$2e2bcd8739ae039), {
                toolName: "deplacer-pei",
                toolIcon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$ef875af7def69d98), {}),
                toolLabelTooltip: showFormPei || showFormVisite.show ? "Un formulaire est en cours d'\xe9dition" : "D\xe9placer un PEI",
                toggleTool: toggleToolCallback,
                disabled: showFormPei || showFormVisite.show,
                activeTool: activeTool
            }),
            (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).INDISPO_TEMP_C) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                        tooltipText: showFormPei || showFormVisite.show ? "Un formulaire est en cours d'\xe9dition" : listePeiId.length === 0 ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("b", {
                                    children: "Cr\xe9er une indisponibilit\xe9 temporaire"
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                                "S\xe9lectionnez au moins un PEI pour cr\xe9er une indisponibilit\xe9 temporaire."
                            ]
                        }) : "Cr\xe9er une indisponibilit\xe9 temporaire",
                        tooltipId: "indispo-temp-carte",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                            variant: "outline-primary",
                            onClick: createIndispoTemp,
                            className: "rounded m-2",
                            disabled: showFormPei || showFormVisite.show || listePeiId.length === 0,
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$77223e42038127b5), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1eee265537f042a4$export$2e2bcd8739ae039), {
                        handleClose: handleCloseIndispoTemp,
                        show: showCreateIndispoTemp,
                        className: "w-50",
                        backdrop: true,
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $cb6c3964a06abc13$export$2e2bcd8739ae039), {
                            listePeiId: listePeiId,
                            onSubmit: ()=>{
                                handleCloseIndispoTemp();
                                (0, $1ed1be1197ad1bc4$export$51ba454167fb25ab)(map);
                            }
                        })
                    })
                ]
            }),
            (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).TOURNEE_A) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                        tooltipText: showFormPei ? "Un formulaire est en cours d'\xe9dition" : listePeiTourneePrive.length === 0 && listePeiTourneePublic.length === 0 && listePeiTourneeIcpe.length === 0 ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("b", {
                                    children: "Affecter des PEI \xe0 une tourn\xe9e"
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                                "S\xe9lectionnez au moins un PEI pour affecter une tourn\xe9e. Les PEI doivent avoir la m\xeame nature DECI pour \xeatre ajout\xe9 dans une tourn\xe9e"
                            ]
                        }) : "Affecter des PEI \xe0 une tourn\xe9e",
                        tooltipId: "affecter-pei-tournee-carte",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                            variant: "outline-primary",
                            onClick: createUpdateTournee,
                            className: "rounded m-2",
                            disabled: listePeiTourneePrive.length === 0 && listePeiTourneePublic.length === 0 && listePeiTourneeIcpe.length === 0 || showFormPei || showFormVisite.show,
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$5ee68ae963bf2bda), {})
                        })
                    }),
                    (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).TOURNEE_DESAFFECTER_U) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                        tooltipText: showFormPei ? "Un formulaire est en cours d'\xe9dition" : listePeiTourneePrive.length === 0 && listePeiTourneePublic.length === 0 && listePeiTourneeIcpe.length === 0 ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("b", {
                                    children: "D\xe9saffecter les PEI de leur tourn\xe9e"
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                                "S\xe9lectionnez au moins un PEI pour d\xe9saffecter une tourn\xe9e."
                            ]
                        }) : "D\xe9saffecter les PEI de leur tourn\xe9e",
                        tooltipId: "desaffecter-pei-tournee-carte",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                            variant: "outline-primary",
                            onClick: createDesaffecterTournee,
                            className: "rounded m-2",
                            disabled: listePeiTourneePrive.length === 0 && listePeiTourneePublic.length === 0 && listePeiTourneeIcpe.length === 0 || showFormPei || showFormVisite.show,
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$40e1334ac13dc359), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1ac4483a0721609f$export$2e2bcd8739ae039), {
                        codeThematique: (0, $690fed8fd87ee1b4$export$2e2bcd8739ae039).POINT_EAU,
                        titreVolet: "Liste des documents li\xe9s aux PEI"
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1eee265537f042a4$export$2e2bcd8739ae039), {
                        handleClose: handleCloseTournee,
                        show: showCreateTournee,
                        className: "w-auto",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1ca593349a99e9a5$export$2e2bcd8739ae039), {
                            listePei: listePeiTourneePrive.length !== 0 ? listePeiTourneePrive : listePeiTourneeIcpe.length !== 0 ? listePeiTourneeIcpe : listePeiTourneePublic,
                            isPrive: listePeiTourneePrive.length !== 0,
                            isIcpe: listePeiTourneeIcpe.length !== 0,
                            closeVolet: handleCloseTournee
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1eee265537f042a4$export$2e2bcd8739ae039), {
                        handleClose: handleCloseDesaffecterTournee,
                        show: showDesaffecterTournee,
                        className: "w-auto",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $c0d44c4437327dc3$export$2e2bcd8739ae039), {
                            listePei: [
                                ...listePeiTourneePrive,
                                ...listePeiTourneeIcpe,
                                ...listePeiTourneePublic
                            ],
                            closeVolet: handleCloseDesaffecterTournee
                        })
                    })
                ]
            }),
            (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).DEBITS_SIMULTANES_A) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                        tooltipText: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                    className: "p-2",
                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("b", {
                                        children: "Cr\xe9er un d\xe9bit simultan\xe9"
                                    })
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                    className: "p-2",
                                    children: [
                                        "Les PIBI s\xe9lectionn\xe9s doivent :",
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("ul", {
                                            children: [
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("li", {
                                                    children: "avoir la nature DECI priv\xe9, ICPE ou ICPE conventionn\xe9"
                                                }),
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("li", {
                                                    children: "avoir le m\xeame type de r\xe9seau"
                                                }),
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("li", {
                                                    children: "n'avoir aucun d\xe9bit simultan\xe9 associ\xe9"
                                                }),
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("li", {
                                                    children: "\xeatre \xe0 moins de 500m"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        tooltipId: "debit-simultane-carte",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                            variant: "outline-primary",
                            onClick: createDebitSimultane,
                            className: "rounded m-2",
                            disabled: listePeiIdDebitSimultane.length < 2 || typeReseauId == null,
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$e7e4d28a1367130c), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1eee265537f042a4$export$2e2bcd8739ae039), {
                        handleClose: handleCloseDebitSimultane,
                        show: showCreateDebitSimultane,
                        className: "w-auto",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $0f5f18cfec20c55d$export$2e2bcd8739ae039), {
                            listePibiId: listePeiIdDebitSimultane,
                            typeReseauId: typeReseauId,
                            onSubmit: ()=>{
                                dataDebitSimultaneLayer.getSource().refresh();
                                dataPeiLayer.getSource().refresh();
                                (0, $1ed1be1197ad1bc4$export$51ba454167fb25ab)(map);
                                handleCloseDebitSimultane();
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eda4eaeb791cb8f1$export$2e2bcd8739ae039), {
                        closeModal: closeModal,
                        content: "Tous les PEI doivent \xeatre \xe0 moins de 500 m\xe8tres.",
                        header: "Impossible de cr\xe9er un d\xe9bit simultan\xe9",
                        ref: refModal,
                        visible: visibleModal
                    })
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b0759c348c3ed98d$export$2e2bcd8739ae039), {
                map: map,
                dataPeiLayer: dataPeiLayer,
                displayButtonDelete: (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).PEI_D),
                displayButtonEdit: canEditPei,
                displayButtonSeeFichePei: (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).PEI_R) && !canEditPei,
                disabledTooltip: activeTool === "deplacer-pei",
                displayButtonEditDebitSimultane: (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).DEBITS_SIMULTANES_A),
                setShowFormPei: setShowFormPei,
                setPeiIdUpdate: setPeiIdUpdate,
                peiIdUpdate: peiIdUpdate,
                setShowFormVisite: setShowFormVisite,
                showFormVisite: showFormVisite,
                dataDebitSimultaneLayer: dataDebitSimultaneLayer,
                showFormPei: showFormPei,
                onTooltipPeiSelectionChange: handleTooltipPeiSelectionChange,
                disabledCreateButton: ()=>disabledTool("create-pei"),
                coordonneesPeiCreate: coordonneesPeiCreate
            }),
            peiInfoMove && geometrieMove && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $c738870e8199ea0b$export$2e2bcd8739ae039), {
                closeModal: ()=>{
                    dataPeiLayer.getSource().refresh();
                    toggleToolCallback("deplacer-pei");
                    closeMove();
                },
                canModify: canEditPei,
                query: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/pei/deplacer/${peiInfoMove.elementId}`,
                submitLabel: "Valider",
                visible: visibleMove,
                validationSchema: // si pas saisie libre: voieId obligatoire
                // si saisie libre : voieId ou voieLibelle
                isSaisieVoieEnabled ? $185040c6178f57d9$export$27511cc6e5cc5033 : $185040c6178f57d9$export$9bde28f72276fcf9,
                header: `D\xe9placer le PEI ${peiInfoMove.peiNumeroComplet ?? ""}`,
                onSubmit: ()=>{
                    // Fermer toutes les tooltips avant le refresh
                    map.getOverlays().forEach((overlay)=>{
                        overlay.setPosition(undefined);
                    });
                    dataPeiLayer.getSource().refresh();
                    (0, $1ed1be1197ad1bc4$export$51ba454167fb25ab)(map);
                },
                getInitialValues: ()=>({
                        geometrie: geometrieMove,
                        voieId: null,
                        voieLibelle: ""
                    }),
                prepareVariables: (values)=>$185040c6178f57d9$export$f97400759cfd946(values),
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("p", {
                        children: [
                            "Voulez-vous d\xe9placer le PEI ?",
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                            "Attention, le d\xe9placement du PEI peut entra\xeener une modification sur son adresse, veuillez la mettre \xe0 jour en cas de besoin."
                        ]
                    }),
                    voiesList && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($185040c6178f57d9$var$MessageVoieForm, {
                        voiesList: voiesList,
                        canEdit: canEdit,
                        isSaisieVoieEnabled: isSaisieVoieEnabled
                    })
                ]
            })
        ]
    });
};
const $185040c6178f57d9$export$9bde28f72276fcf9 = (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({
    voieId: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba)
});
const $185040c6178f57d9$export$27511cc6e5cc5033 = (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({
    voieId: (0, $ce4de947442b2ab1$export$22b082955e083ec3)().nullable(),
    voieLibelle: (0, $ce4de947442b2ab1$export$22b082955e083ec3)().nullable()
}).test((value)=>{
    if (!value) return false;
    const { voieId: voieId, voieLibelle: voieLibelle } = value;
    return Boolean(voieId && voieId !== "" || voieLibelle && voieLibelle !== "");
});
const $185040c6178f57d9$var$MessageVoieForm = ({ voiesList: voiesList, canEdit: canEdit, isSaisieVoieEnabled: isSaisieVoieEnabled })=>{
    const { values: values, setValues: setValues, setFieldValue: setFieldValue } = (0, $bkJfK.useFormikContext)();
    const [voieTrouvee, setVoieTrouvee] = (0, $kc00y.useState)(false);
    const voieArray = voiesList ?? [];
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                name: "voieId",
                listIdCodeLibelle: voieArray,
                label: "Voie",
                disabled: voieTrouvee,
                setValues: setValues,
                defaultValue: voieArray.find((e)=>e.id === values?.voieId)
            }),
            isSaisieVoieEnabled && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                        name: "voieSaisieLibre",
                        checked: voieTrouvee,
                        label: "Voie non trouv\xe9e",
                        onChange: ()=>{
                            setVoieTrouvee(!voieTrouvee);
                            setFieldValue(!voieTrouvee ? "voieId" : "voieLibelle", undefined);
                        }
                    }),
                    voieTrouvee && canEdit && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                        name: "voieLibelle",
                        label: "Voie (saisie libre)"
                    })
                ]
            })
        ]
    });
};
$185040c6178f57d9$var$MapToolbarPei.displayName = "MapToolbarPei";
var $185040c6178f57d9$export$2e2bcd8739ae039 = $185040c6178f57d9$var$MapToolbarPei;


const $acaa38b73f277215$var$MapPei = ()=>{
    const mapElement = (0, $kc00y.useRef)();
    const [showFormPei, setShowFormPei] = (0, $kc00y.useState)(false);
    const [showFormVisite, setShowFormVisite] = (0, $kc00y.useState)({
        peiId: null,
        show: false
    });
    const [coordonneesPeiCreate, setCoordonneesPeiCreate] = (0, $kc00y.useState)(null);
    const [peiIdUpdate, setPeiIdUpdate] = (0, $kc00y.useState)(null);
    const location = (0, $7a844823b04d4282$export$45d76561a5302f2b)();
    const [estSurligne, setEstSurligne] = (0, $kc00y.useState)(location.state?.listePeiId?.length === 0 || location.state?.listePeiId == null);
    const parametres = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/parametres?${{
        listeParametreCode: JSON.stringify([
            (0, $ee297f06e8568bf4$export$2e2bcd8739ae039).PEI_HIGHLIGHT_DUREE,
            (0, $ee297f06e8568bf4$export$2e2bcd8739ae039).PEI_HIGHLIGHT_COULEUR,
            (0, $ee297f06e8568bf4$export$2e2bcd8739ae039).PEI_HIGHLIGHT_RAYON,
            (0, $ee297f06e8568bf4$export$2e2bcd8739ae039).PEI_HIGHLIGHT_LARGEUR,
            (0, $ee297f06e8568bf4$export$2e2bcd8739ae039).PEI_SELECTION_COULEUR,
            (0, $ee297f06e8568bf4$export$2e2bcd8739ae039).PEI_SELECTION_RAYON,
            (0, $ee297f06e8568bf4$export$2e2bcd8739ae039).PEI_SELECTION_LARGEUR
        ])
    }}`);
    const { map: map, workingLayer: workingLayer, dataPeiLayer: dataPeiLayer, availableLayers: availableLayers, addOrRemoveLayer: addOrRemoveLayer, layerListRef: layerListRef, mapToolbarRef: mapToolbarRef, showOutilI: showOutilI, projection: projection } = (0, $cdcdd8e1ff041f79$export$547f9c492d831282)({
        mapElement: mapElement,
        typeModule: (0, $a9754922f4c67d47$export$ef88b514e4bfff34).DECI
    });
    const { tools: extraTools, createIndispoTemp: createIndispoTemp, handleCloseIndispoTemp: handleCloseIndispoTemp, listePeiId: listePeiId, showCreateIndispoTemp: showCreateIndispoTemp, listePeiTourneePrive: listePeiTourneePrive, listePeiTourneeIcpe: listePeiTourneeIcpe, listePeiTourneePublic: listePeiTourneePublic, createUpdateTournee: createUpdateTournee, handleCloseTournee: handleCloseTournee, showCreateTournee: showCreateTournee, createDebitSimultane: createDebitSimultane, handleCloseDebitSimultane: handleCloseDebitSimultane, showCreateDebitSimultane: showCreateDebitSimultane, listePeiIdDebitSimultane: listePeiIdDebitSimultane, typeReseauId: typeReseauId, close: close, ref: ref, visible: visible, visibleMove: visibleMove, refMove: refMove, closeMove: closeMove, peiInfoMove: peiInfoMove, geometrieMove: geometrieMove, showDesaffecterTournee: showDesaffecterTournee, handleCloseDesaffecterTournee: handleCloseDesaffecterTournee, createDesaffecterTournee: createDesaffecterTournee, syncTooltipSelection: syncTooltipSelection } = (0, $185040c6178f57d9$export$4189fbf3a3d5eb53)({
        map: map,
        workingLayer: workingLayer,
        dataPeiLayer: dataPeiLayer,
        setShowFormPei: setShowFormPei,
        setCoordonneesPeiCreate: setCoordonneesPeiCreate,
        coordonneesPeiCreate: coordonneesPeiCreate
    });
    /**
   * Permet d'afficher les débits simultanés
   * @returns
   */ const dataDebitSimultaneLayer = (0, $kc00y.useMemo)(()=>{
        if (!map) return;
        const layer = (0, $1ed1be1197ad1bc4$export$a3178456480ccf5b)(map, (extent, projection)=>`/api/debit-simultane/layer?bbox=` + extent.join(",") + "&srid=" + projection.getCode(), projection);
        if (layer) (0, $6c6ce495fc1da0b9$export$d96f612ac05cb0c0)(layer);
        return layer;
    }, [
        map,
        projection
    ]);
    const { toggleTool: toggleTool, activeTool: activeTool, disabledTool: disabledTool, infoOutilI: infoOutilI, handleCloseInfoI: handleCloseInfoI } = (0, $e2b798e23180fa76$export$194c7727cbdc0cac)({
        availableLayers: availableLayers,
        map: map,
        workingLayer: workingLayer,
        extraTools: extraTools
    });
    const stateListePeiId = location.state?.listePeiId;
    // On construit la couche de surbrillance optimisée
    const highlightLayer = (0, $kc00y.useMemo)(()=>{
        if (!map || !stateListePeiId || estSurligne || !parametres.data) return;
        const highlightColor = parametres.data[(0, $ee297f06e8568bf4$export$2e2bcd8739ae039).PEI_HIGHLIGHT_COULEUR]?.parametreValeur || "rgba(217, 131, 226, 0.7)";
        const highlightRadius = parseInt(parametres.data[(0, $ee297f06e8568bf4$export$2e2bcd8739ae039).PEI_HIGHLIGHT_RAYON]?.parametreValeur) ?? 16;
        const highlightWidth = parseInt(parametres.data[(0, $ee297f06e8568bf4$export$2e2bcd8739ae039).PEI_HIGHLIGHT_LARGEUR]?.parametreValeur) ?? 4;
        // Style optimisé avec cache
        const highlightStyle = new (0, $a5fc261473972d1d$export$2e2bcd8739ae039)({
            image: new (0, $f060542c6e9f52e6$export$2e2bcd8739ae039)({
                radius: highlightRadius,
                stroke: new (0, $281691897fddf9d0$export$2e2bcd8739ae039)({
                    color: highlightColor,
                    width: highlightWidth
                })
            })
        });
        const layer = (0, $1ed1be1197ad1bc4$export$a3178456480ccf5b)(map, (extent, projection)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/pei/hightlight/layer?bbox=` + extent.join(",") + "&srid=" + projection.getCode() + "&listePeiId=" + stateListePeiId, projection, highlightStyle);
        // Application des optimisations de performance
        if (layer) {
            (0, $6c6ce495fc1da0b9$export$d96f612ac05cb0c0)(layer);
            // Configuration spécifique pour la couche highlight
            layer.setZIndex(8999);
            layer.set("renderBuffer", 50);
        }
        return layer;
    }, [
        map,
        stateListePeiId,
        estSurligne,
        projection,
        parametres.data
    ]);
    (0, $kc00y.useEffect)(()=>{
        if (!map || !highlightLayer || !parametres.data) return;
        setTimeout(function() {
            map.removeLayer(highlightLayer);
            setEstSurligne(true);
        }, parametres.data[(0, $ee297f06e8568bf4$export$2e2bcd8739ae039).PEI_HIGHLIGHT_DUREE].parametreValeur * 1000);
    }, [
        map,
        highlightLayer,
        parametres
    ]);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                title: "Carte",
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$ba2fbb9644c8bf32), {})
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                className: "map-page-wrapper",
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        className: "map-page-map-col",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $cdcdd8e1ff041f79$export$2e2bcd8739ae039), {
                            map: map,
                            availableLayers: availableLayers,
                            addOrRemoveLayer: addOrRemoveLayer,
                            layerListRef: layerListRef,
                            mapToolbarRef: mapToolbarRef,
                            mapElement: mapElement,
                            showOutilI: showOutilI,
                            toggleTool: toggleTool,
                            activeTool: activeTool,
                            outilI: infoOutilI,
                            handleCloseInfoI: handleCloseInfoI,
                            toolbarElement: mapToolbarRef.current && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $185040c6178f57d9$export$2e2bcd8739ae039), {
                                toggleTool: toggleTool,
                                activeTool: activeTool,
                                map: map,
                                dataPeiLayer: dataPeiLayer,
                                showCreateIndispoTemp: showCreateIndispoTemp,
                                handleCloseIndispoTemp: handleCloseIndispoTemp,
                                listePeiId: listePeiId,
                                createIndispoTemp: createIndispoTemp,
                                listePeiTourneePrive: listePeiTourneePrive,
                                listePeiTourneeIcpe: listePeiTourneeIcpe,
                                listePeiTourneePublic: listePeiTourneePublic,
                                createUpdateTournee: createUpdateTournee,
                                handleCloseTournee: handleCloseTournee,
                                showCreateTournee: showCreateTournee,
                                dataDebitSimultaneLayer: dataDebitSimultaneLayer,
                                createDebitSimultane: createDebitSimultane,
                                handleCloseDebitSimultane: handleCloseDebitSimultane,
                                showCreateDebitSimultane: showCreateDebitSimultane,
                                listePeiIdDebitSimultane: listePeiIdDebitSimultane,
                                typeReseauId: typeReseauId,
                                closeModal: close,
                                refModal: ref,
                                visibleModal: visible,
                                setPeiIdUpdate: setPeiIdUpdate,
                                setShowFormPei: setShowFormPei,
                                showFormPei: showFormPei,
                                peiIdUpdate: peiIdUpdate,
                                disabledTool: disabledTool,
                                closeMove: closeMove,
                                refMove: refMove,
                                visibleMove: visibleMove,
                                peiInfoMove: peiInfoMove,
                                geometrieMove: geometrieMove,
                                setShowFormVisite: setShowFormVisite,
                                showFormVisite: showFormVisite,
                                coordonneesPeiCreate: coordonneesPeiCreate,
                                syncTooltipSelection: syncTooltipSelection,
                                createDesaffecterTournee: createDesaffecterTournee,
                                handleCloseDesaffecterTournee: handleCloseDesaffecterTournee,
                                showDesaffecterTournee: showDesaffecterTournee
                            })
                        })
                    }),
                    showFormPei && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        xs: 5,
                        className: "border-primary border-start border-3 overflow-y-scroll",
                        style: {
                            maxHeight: "80vh"
                        },
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                            className: "bg-light p-2 ",
                            children: coordonneesPeiCreate ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948eb983c24fac1c$export$2e2bcd8739ae039), {
                                coordonneesPeiCreate: coordonneesPeiCreate,
                                close: ()=>{
                                    dataPeiLayer?.getSource()?.refresh();
                                    workingLayer?.getSource()?.clear();
                                    setCoordonneesPeiCreate(null);
                                    setShowFormPei(false);
                                    disabledTool("create-pei");
                                },
                                map: map
                            }) : peiIdUpdate && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b5a42a59076ab4fc$export$2e2bcd8739ae039), {
                                peiIdUpdate: peiIdUpdate,
                                close: ()=>{
                                    dataPeiLayer?.getSource()?.refresh();
                                    setPeiIdUpdate(null);
                                // Le setShowFormPei(false) est géré par la tooltip
                                },
                                map: map
                            })
                        })
                    }),
                    showFormVisite.show && showFormVisite.peiId && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        xs: 5,
                        className: "border-primary border-start border-3 overflow-y-scroll",
                        style: {
                            maxHeight: "80vh"
                        },
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                            className: "bg-light p-2 ",
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1398c46fdaf43768$export$2e2bcd8739ae039), {
                                peiIdCarte: showFormVisite.peiId,
                                closeForm: ()=>setShowFormVisite({
                                        show: false,
                                        peiId: null
                                    }),
                                map: map
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var $acaa38b73f277215$export$2e2bcd8739ae039 = $acaa38b73f277215$var$MapPei;




var $kc00y = parcelRequire("kc00y");












var $kc00y = parcelRequire("kc00y");









const $dc5173db18dbca30$var$CreatePeiPrescrit = ({ coordonneeX: coordonneeX, coordonneeY: coordonneeY, srid: srid, onSubmit: onSubmit })=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$f9db439cdc8db790), {}),
                title: "Prescription de PEI",
                displayReturnButton: false
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                initialValues: (0, $a7c785bd8da3e879$export$a5cab80145b70e98)({
                    peiPrescritCoordonneeX: coordonneeX,
                    peiPrescritCoordonneeY: coordonneeY,
                    peiPrescritSrid: srid
                }),
                isPost: true,
                prepareVariables: (values)=>(0, $a7c785bd8da3e879$export$f97400759cfd946)(values),
                onSubmit: onSubmit,
                submitUrl: `/api/pei-prescrit/create`,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $a7c785bd8da3e879$export$2e2bcd8739ae039), {})
            })
        ]
    });
};
var $dc5173db18dbca30$export$2e2bcd8739ae039 = $dc5173db18dbca30$var$CreatePeiPrescrit;








const $8464e8de4446423f$var$defaultStyle = new (0, $a5fc261473972d1d$export$2e2bcd8739ae039)({
    image: new (0, $f060542c6e9f52e6$export$2e2bcd8739ae039)({
        radius: 5,
        fill: new (0, $8624b871a0af6dab$export$2e2bcd8739ae039)({
            color: "green"
        }),
        stroke: new (0, $281691897fddf9d0$export$2e2bcd8739ae039)({
            color: [
                255,
                0,
                0
            ],
            width: 1
        })
    })
});
const $8464e8de4446423f$export$ed004509c9231189 = ({ map: map, workingLayer: workingLayer })=>{
    const [featureStyle] = (0, $kc00y.useState)($8464e8de4446423f$var$defaultStyle);
    const [showCreatePeiPrescrit, setShowPeiPrescrit] = (0, $kc00y.useState)(false);
    const handleClosePeiPrescrit = ()=>{
        workingLayer.getSource().clear();
        setShowPeiPrescrit(false);
    };
    const [pointPeiPrescrit, setPointPeiPrescrit] = (0, $kc00y.useState)(null);
    const tools = (0, $kc00y.useMemo)(()=>{
        if (!map) return {};
        const createPeiPrescrit = new (0, $2ef894158a48397d$export$2e2bcd8739ae039)({
            source: workingLayer.getSource(),
            type: "Point",
            style: (feature)=>{
                const geometryType = feature.getGeometry().getType();
                if (geometryType === "Point") return $8464e8de4446423f$var$defaultStyle;
            }
        });
        createPeiPrescrit.on("drawstart", async ()=>{
            // Avant de redessiner un point, on supprime les autres points, le but est d'avoir juste un seul point à la fois.
            workingLayer.getSource().clear();
        });
        createPeiPrescrit.on("drawend", (event)=>{
            event.feature.setStyle(featureStyle.clone());
            const geometry = event.feature.getGeometry();
            setPointPeiPrescrit(geometry);
            setShowPeiPrescrit(true);
        });
        function toggleCreatePeiPrescrit(active = false) {
            const idx = map?.getInteractions().getArray().indexOf(createPeiPrescrit);
            if (active) {
                if (idx === -1) map.addInteraction(createPeiPrescrit);
            } else map.removeInteraction(createPeiPrescrit);
        }
        const tools = {
            "create-pei-prescrits": {
                action: toggleCreatePeiPrescrit
            }
        };
        return tools;
    }, [
        map,
        featureStyle,
        workingLayer
    ]);
    return {
        tools: tools,
        showCreatePeiPrescrit: showCreatePeiPrescrit,
        handleClosePeiPrescrit: handleClosePeiPrescrit,
        pointPeiPrescrit: pointPeiPrescrit
    };
};
const $8464e8de4446423f$var$MapToolbarPeiPrescrit = ({ map: map, dataPeiPrescritLayer: dataPeiPrescritLayer, showCreatePeiPrescrit: showCreatePeiPrescrit, handleClosePeiPrescrit: handleClosePeiPrescrit, pointPeiPrescrit: pointPeiPrescrit, toggleTool: toggleToolCallback, activeTool: activeTool })=>{
    const { user: user } = (0, $e787cde576104469$export$fdc397e486fa83e7)();
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).PEI_PRESCRIT_A) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $a43e6f68e14bab96$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $f2eef644ac9323e0$export$2e2bcd8739ae039), {
                    toolName: "create-pei-prescrits",
                    toolIcon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$d776d19dfae66ece), {}),
                    toolLabelTooltip: "Prescrire des points d'eau",
                    toggleTool: toggleToolCallback,
                    activeTool: activeTool
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1eee265537f042a4$export$2e2bcd8739ae039), {
                handleClose: handleClosePeiPrescrit,
                show: showCreatePeiPrescrit,
                className: "w-auto",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $dc5173db18dbca30$export$2e2bcd8739ae039), {
                    coordonneeX: pointPeiPrescrit?.getFlatCoordinates()[0],
                    coordonneeY: pointPeiPrescrit?.getFlatCoordinates()[1],
                    srid: map.getView().getProjection().getCode().split(":").pop(),
                    onSubmit: ()=>{
                        dataPeiPrescritLayer.getSource().refresh();
                        (0, $1ed1be1197ad1bc4$export$51ba454167fb25ab)(map);
                        handleClosePeiPrescrit();
                    }
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b0759c348c3ed98d$export$821d223070f8ed58), {
                map: map,
                disabledEditPeiPrescrit: !(0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).PEI_PRESCRIT_A),
                dataPeiPrescritLayer: dataPeiPrescritLayer,
                disabled: false
            })
        ]
    });
};
$8464e8de4446423f$var$MapToolbarPeiPrescrit.displayName = "MapToolbarPeiPrescrit";
var $8464e8de4446423f$export$2e2bcd8739ae039 = $8464e8de4446423f$var$MapToolbarPeiPrescrit;


const $f0932257f8def3d4$var$MapPeiPrescrit = ()=>{
    const mapElement = (0, $kc00y.useRef)();
    const { map: map, workingLayer: workingLayer, availableLayers: availableLayers, showOutilI: showOutilI, addOrRemoveLayer: addOrRemoveLayer, layerListRef: layerListRef, mapToolbarRef: mapToolbarRef, projection: projection } = (0, $cdcdd8e1ff041f79$export$547f9c492d831282)({
        mapElement: mapElement,
        typeModule: (0, $a9754922f4c67d47$export$ef88b514e4bfff34).PEI_PRESCRIT,
        displayPei: false
    });
    /** Permet d'afficher les PEI prescrits */ const dataPeiPrescritLayer = (0, $kc00y.useMemo)(()=>{
        if (!map) return;
        return (0, $1ed1be1197ad1bc4$export$a3178456480ccf5b)(map, (extent, projection)=>`/api/pei-prescrit/layer?bbox=` + extent.join(",") + "&srid=" + projection.getCode(), projection);
    }, [
        map,
        projection
    ]);
    const { tools: extraTools, showCreatePeiPrescrit: showCreatePeiPrescrit, handleClosePeiPrescrit: handleClosePeiPrescrit, pointPeiPrescrit: pointPeiPrescrit } = (0, $8464e8de4446423f$export$ed004509c9231189)({
        map: map,
        workingLayer: workingLayer,
        dataPeiPrescritLayer: dataPeiPrescritLayer
    });
    const { toggleTool: toggleTool, activeTool: activeTool, infoOutilI: infoOutilI, handleCloseInfoI: handleCloseInfoI } = (0, $e2b798e23180fa76$export$194c7727cbdc0cac)({
        availableLayers: availableLayers,
        map: map,
        workingLayer: workingLayer,
        extraTools: extraTools
    });
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $a0064658a8399ad3$export$2e2bcd8739ae039), {
        navbar: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $5de16d9a2066fdee$export$2e2bcd8739ae039), {}),
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                title: "PEI Prescrits",
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$f9db439cdc8db790), {})
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $cdcdd8e1ff041f79$export$2e2bcd8739ae039), {
                map: map,
                workingLayer: workingLayer,
                availableLayers: availableLayers,
                showOutilI: showOutilI,
                addOrRemoveLayer: addOrRemoveLayer,
                layerListRef: layerListRef,
                outilI: infoOutilI,
                handleCloseInfoI: handleCloseInfoI,
                mapToolbarRef: mapToolbarRef,
                mapElement: mapElement,
                toggleTool: toggleTool,
                activeTool: activeTool,
                toolbarElement: mapToolbarRef.current && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8464e8de4446423f$export$2e2bcd8739ae039), {
                    map: map,
                    dataPeiPrescritLayer: dataPeiPrescritLayer,
                    showCreatePeiPrescrit: showCreatePeiPrescrit,
                    handleClosePeiPrescrit: handleClosePeiPrescrit,
                    pointPeiPrescrit: pointPeiPrescrit,
                    toggleTool: toggleTool,
                    activeTool: activeTool
                })
            })
        ]
    });
};
var $f0932257f8def3d4$export$2e2bcd8739ae039 = $f0932257f8def3d4$var$MapPeiPrescrit;





var $kc00y = parcelRequire("kc00y");

















var $kc00y = parcelRequire("kc00y");












const $11f0bfe9d65542aa$var$CreatePermis = ({ coordonneeX: coordonneeX, coordonneeY: coordonneeY, srid: srid, onSubmit: onSubmit })=>{
    const { user: user } = (0, $e787cde576104469$export$fdc397e486fa83e7)();
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$7876caa18827ace7), {}),
                title: "D\xe9claration d'un permis",
                displayReturnButton: false
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                initialValues: (0, $5b79ea0b037973c6$export$a5cab80145b70e98)({
                    permisLibelle: "",
                    permisNumero: "",
                    permisServiceInstructeurId: "",
                    permisTypePermisInterserviceId: "",
                    permisTypePermisAvisId: "",
                    permisRiReceptionnee: false,
                    permisDossierRiValide: false,
                    permisObservations: "",
                    permisVoieText: "",
                    permisVoieId: "",
                    permisComplement: "",
                    permisCommuneId: "",
                    permisAnnee: new Date().getFullYear(),
                    permisDatePermis: null,
                    permisCoordonneeX: coordonneeX,
                    permisCoordonneeY: coordonneeY,
                    permisSrid: srid,
                    voieSaisieText: false,
                    permisLastUpdateDate: (0, $00c47c7740afd024$export$2e2bcd8739ae039)(new Date()),
                    permisInstructeurUsername: user.username
                }),
                isPost: true,
                isMultipartFormData: true,
                prepareVariables: (values)=>(0, $5b79ea0b037973c6$export$f97400759cfd946)(values),
                onSubmit: onSubmit,
                submitUrl: `/api/permis/create`,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $5b79ea0b037973c6$export$2e2bcd8739ae039), {})
            })
        ]
    });
};
var $11f0bfe9d65542aa$export$2e2bcd8739ae039 = $11f0bfe9d65542aa$var$CreatePermis;





var $kc00y = parcelRequire("kc00y");









const $0bbeef94aa4d52c8$var$SearchPermis = ()=>{
    const [searchParam, setSearchParam] = (0, $kc00y.useState)({});
    const [buttonClicked, setButtonClicked] = (0, $kc00y.useState)(false);
    const { data: data, run: run } = (0, $8d9ebd8892d8a5f5$export$6326fb4463ae1be4)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/permis/?${searchParam}`, {});
    (0, $kc00y.useEffect)(()=>{
        if (buttonClicked) {
            run();
            setButtonClicked(false);
        }
    }, [
        buttonClicked,
        run
    ]);
    const setValue = (name, value)=>{
        setSearchParam((previous)=>({
                ...previous || {},
                [name]: value
            }));
    };
    const SearchDisabled = Object.values(searchParam).every((value)=>value === "" || value === null);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$2be804e19c04baed), {}),
                title: "Recherche un permis",
                displayReturnButton: false
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f76670b5e5897c33), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$842aba50ed0ce9d7), {
                                        label: "Nom",
                                        required: false,
                                        name: "searchNom"
                                    })
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("input", {
                                        id: "searchNom",
                                        onChange: (e)=>setValue("searchNom", e.currentTarget.value)
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$842aba50ed0ce9d7), {
                                        label: "Commune",
                                        required: false,
                                        name: "searchCommuneId"
                                    })
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $dd08a763d100724f$export$2e2bcd8739ae039), {
                                        name: "searchCommuneId",
                                        url: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/commune/get-libelle-commune`,
                                        onChange: (e)=>setValue("searchCommuneId", e.value === "" ? null : e.value)
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$842aba50ed0ce9d7), {
                                        label: "N\xb0 permis",
                                        required: false,
                                        name: "searchNumero"
                                    })
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("input", {
                                        id: "searchNumero",
                                        onChange: (e)=>setValue("searchNumero", e.currentTarget.value)
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$842aba50ed0ce9d7), {
                                        label: "N\xb0 section",
                                        required: false,
                                        name: "searchSection"
                                    })
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("input", {
                                        id: "searchSection",
                                        onChange: (e)=>setValue("searchSection", e.currentTarget.value)
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$842aba50ed0ce9d7), {
                                        label: "N\xb0 parcelle",
                                        required: false,
                                        name: "searchParcelle"
                                    })
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("input", {
                                        id: "searchParcelle",
                                        onChange: (e)=>setValue("searchParcelle", e.currentTarget.value)
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$842aba50ed0ce9d7), {
                                        label: "Avis",
                                        required: false,
                                        name: "searchAvisId"
                                    })
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $dd08a763d100724f$export$2e2bcd8739ae039), {
                                        name: "searchAvisId",
                                        url: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/permis/get-libelle-permis-avis`,
                                        onChange: (e)=>setValue("searchAvisId", e.value)
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                            className: "text-center",
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                                className: "mt-2",
                                disabled: SearchDisabled,
                                onClick: ()=>setButtonClicked(true),
                                children: "Rechercher"
                            })
                        })
                    })
                ]
            }),
            data?.length === 0 && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("p", {
                            className: "fw-bold mt-2",
                            children: "R\xe9sultats :"
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("p", {
                            children: "Aucun permis ne correspond \xe0 vos crit\xe8res"
                        })
                    })
                ]
            }),
            data?.length > 0 && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("p", {
                            className: "fw-bold mt-2",
                            children: "R\xe9sultats :"
                        })
                    }),
                    data?.map((element)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($0bbeef94aa4d52c8$var$CardPermisToSearchResult, {
                            permisLibelle: element.permisLibelle,
                            permisNumero: element.permisNumero,
                            permisGeometrie: element.permisGeometrie
                        }, element.permisId))
                ]
            })
        ]
    });
};
var $0bbeef94aa4d52c8$export$2e2bcd8739ae039 = $0bbeef94aa4d52c8$var$SearchPermis;
const $0bbeef94aa4d52c8$var$CardPermisToSearchResult = ({ permisLibelle: permisLibelle, permisNumero: permisNumero, permisGeometrie: permisGeometrie })=>{
    const navigate = (0, $7a844823b04d4282$export$9770f232ac06a008)();
    const location = (0, $7a844823b04d4282$export$45d76561a5302f2b)();
    const zoomerSurPermis = ()=>{
        const [rawSrid, rawFeature] = permisGeometrie.split(";");
        const srid = rawSrid.split("=").pop();
        const extent = new (0, $15a985d09649bdc2$export$2e2bcd8739ae039)().readGeometry(rawFeature).getExtent();
        navigate((0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).CARTE_PERMIS, {
            state: {
                ...location.state,
                target: {
                    extent: extent,
                    srid: srid
                }
            }
        });
    };
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
        className: "bg-light p-2 border rounded mx-2",
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                xs: "auto",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                    onClick: ()=>zoomerSurPermis(),
                    children: [
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$779959098413998d), {}),
                        " Localiser"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                        children: [
                            "Permis : ",
                            permisNumero
                        ]
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                        children: permisLibelle
                    })
                ]
            })
        ]
    });
};









const $1b59352b860499d0$var$defaultStyle = new (0, $a5fc261473972d1d$export$2e2bcd8739ae039)({
    image: new (0, $f060542c6e9f52e6$export$2e2bcd8739ae039)({
        radius: 5,
        fill: new (0, $8624b871a0af6dab$export$2e2bcd8739ae039)({
            color: "green"
        }),
        stroke: new (0, $281691897fddf9d0$export$2e2bcd8739ae039)({
            color: [
                255,
                0,
                0
            ],
            width: 1
        })
    })
});
const $1b59352b860499d0$export$1f9f792947eb1f71 = ({ map: map, workingLayer: workingLayer, dataPermisLayer: dataPermisLayer })=>{
    const [featureStyle] = (0, $kc00y.useState)($1b59352b860499d0$var$defaultStyle);
    const { error: errorToast } = (0, $6bdae0bad7b05751$export$91b3d218c74c79e4)();
    const voletOuvert = (0, $kc00y.useRef)(false);
    const [showSearchPermis, setShowSearchPermis] = (0, $kc00y.useState)(false);
    const handleCloseSearchPermis = ()=>setShowSearchPermis(false);
    const [showCreatePermis, setShowPermis] = (0, $kc00y.useState)(false);
    const handleClosePermis = ()=>{
        voletOuvert.current = false;
        setShowPermis(false);
        workingLayer.getSource().refresh();
    };
    const [featureState, setFeatureState] = (0, $kc00y.useState)(null);
    const [showUpdatePermis, setShowUpdatePermis] = (0, $kc00y.useState)(false);
    const handleCloseUpdatePermis = ()=>{
        voletOuvert.current = false;
        setShowUpdatePermis(false);
    };
    const [pointPermis, setPointPermis] = (0, $kc00y.useState)(null);
    const tools = (0, $kc00y.useMemo)(()=>{
        if (!map) return {};
        const createPermis = new (0, $2ef894158a48397d$export$2e2bcd8739ae039)({
            source: workingLayer.getSource(),
            type: "Point",
            style: (feature)=>{
                const geometryType = feature.getGeometry().getType();
                if (geometryType === "Point") return $1b59352b860499d0$var$defaultStyle;
            }
        });
        createPermis.on("drawstart", async ()=>{
            if (voletOuvert.current) {
                createPermis.abortDrawing();
                return;
            }
            // Avant de redessiner un point, on supprime les autres points, le but est d'avoir juste un seul point à la fois.
            workingLayer.getSource().clear();
        });
        createPermis.on("drawend", async (event)=>{
            if (voletOuvert.current) {
                workingLayer.getSource().removeFeature(event.feature);
                return;
            }
            (await fetch((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/zone-integration/check`, (0, $fbd4d34e07af0ac7$export$b163ec2f884327db)({
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    geometry: "SRID=" + map.getView().getProjection().getCode().split(":").pop() + ";" + new (0, $15a985d09649bdc2$export$2e2bcd8739ae039)().writeFeature(event.feature)
                })
            }))).text().then((text)=>{
                if (text === "true") {
                    event.feature.setStyle(featureStyle.clone());
                    const geometry = event.feature.getGeometry();
                    setPointPermis(geometry);
                    voletOuvert.current = true;
                    setShowPermis(true);
                } else {
                    workingLayer.getSource().removeFeature(event.feature);
                    errorToast(text);
                }
            }).catch((reason)=>{
                workingLayer.getSource().removeFeature(event.feature);
                errorToast(reason);
            });
        });
        function toggleCreatePermis(active = false) {
            const idx = map?.getInteractions().getArray().indexOf(createPermis);
            if (active) {
                if (idx === -1) map.addInteraction(createPermis);
            } else map.removeInteraction(createPermis);
        }
        const movePermisCtrl = new (0, $2375ecf9b29b2a49$export$2e2bcd8739ae039)({
            source: dataPermisLayer.getSource()
        });
        movePermisCtrl.on("modifyend", async (event)=>{
            if (!event.features || event.features.getLength() !== 1 || voletOuvert.current) return;
            (await fetch((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/zone-integration/check`, (0, $fbd4d34e07af0ac7$export$b163ec2f884327db)({
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    geometry: "SRID=" + map.getView().getProjection().getCode().split(":").pop() + ";" + new (0, $15a985d09649bdc2$export$2e2bcd8739ae039)().writeFeature(event.features.getArray()[0])
                })
            }))).text().then((text)=>{
                if (text === "true") {
                    setFeatureState(event.features.getArray()[0].getProperties());
                    voletOuvert.current = true;
                    setShowUpdatePermis(true);
                } else {
                    dataPermisLayer.getSource().refresh();
                    errorToast(text);
                }
            }).catch((reason)=>{
                dataPermisLayer.getSource().refresh();
                errorToast(reason);
            });
            (0, $1ed1be1197ad1bc4$export$51ba454167fb25ab)(map);
        });
        function toggleDeplacerPermis(active = false) {
            const idx = map?.getInteractions().getArray().indexOf(movePermisCtrl);
            if (active) {
                movePermisCtrl.setActive(true);
                if (idx === -1) map.addInteraction(movePermisCtrl);
            } else {
                movePermisCtrl.setActive(false);
                map.removeInteraction(movePermisCtrl);
            }
        }
        function toggleSearchBarPermis(active = false) {
            if (active) setShowSearchPermis(true);
        }
        const tools = {
            "search-permis": {
                action: toggleSearchBarPermis
            },
            "create-permis": {
                action: toggleCreatePermis
            },
            "deplacer-permis": {
                action: toggleDeplacerPermis,
                actionPossibleEnDeplacement: false
            }
        };
        return tools;
    }, [
        map,
        featureStyle,
        workingLayer,
        errorToast,
        dataPermisLayer
    ]);
    return {
        tools: tools,
        showSearchPermis: showSearchPermis,
        handleCloseSearchPermis: handleCloseSearchPermis,
        showCreatePermis: showCreatePermis,
        handleClosePermis: handleClosePermis,
        showUpdatePermis: showUpdatePermis,
        handleCloseUpdatePermis: handleCloseUpdatePermis,
        pointPermis: pointPermis,
        featureState: featureState,
        setShowUpdatePermis: setShowUpdatePermis,
        setFeatureState: setFeatureState,
        voletOuvert: voletOuvert
    };
};
const $1b59352b860499d0$var$MapToolbarPermis = ({ map: map, dataPermisLayer: dataPermisLayer, showSearchPermis: showSearchPermis, handleCloseSearchPermis: handleCloseSearchPermis, showCreatePermis: showCreatePermis, handleClosePermis: handleClosePermis, showUpdatePermis: showUpdatePermis, handleCloseUpdatePermis: handleCloseUpdatePermis, featureState: featureState, pointPermis: pointPermis, toggleTool: toggleToolCallback, activeTool: activeTool, hasRightToInteract: hasRightToInteract = false, voletOuvert: voletOuvert })=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $a43e6f68e14bab96$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1ac4483a0721609f$export$2e2bcd8739ae039), {
                        codeThematique: (0, $690fed8fd87ee1b4$export$2e2bcd8739ae039).PERMIS,
                        titreVolet: "Liste des documents li\xe9s aux permis"
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $f2eef644ac9323e0$export$2e2bcd8739ae039), {
                        toolName: "search-permis",
                        toolIcon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$2be804e19c04baed), {}),
                        toolLabelTooltip: "Rechercher un permis",
                        toggleTool: toggleToolCallback,
                        activeTool: activeTool,
                        disabled: voletOuvert.current
                    }),
                    hasRightToInteract && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $f2eef644ac9323e0$export$2e2bcd8739ae039), {
                                toolName: "create-permis",
                                toolIcon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$d776d19dfae66ece), {}),
                                toolLabelTooltip: "Cr\xe9er un permis",
                                toggleTool: toggleToolCallback,
                                activeTool: activeTool,
                                disabled: voletOuvert.current
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $f2eef644ac9323e0$export$2e2bcd8739ae039), {
                                toolName: "deplacer-permis",
                                toolIcon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$ef875af7def69d98), {}),
                                toolLabelTooltip: "D\xe9placer un permis",
                                toggleTool: toggleToolCallback,
                                activeTool: activeTool,
                                disabled: voletOuvert.current
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1eee265537f042a4$export$2e2bcd8739ae039), {
                handleClose: handleCloseSearchPermis,
                show: showSearchPermis,
                className: "w-auto",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $0bbeef94aa4d52c8$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1eee265537f042a4$export$2e2bcd8739ae039), {
                handleClose: handleClosePermis,
                show: showCreatePermis,
                className: "w-auto",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $11f0bfe9d65542aa$export$2e2bcd8739ae039), {
                    coordonneeX: pointPermis?.getFlatCoordinates()[0],
                    coordonneeY: pointPermis?.getFlatCoordinates()[1],
                    srid: map.getView().getProjection().getCode().split(":").pop(),
                    onSubmit: ()=>{
                        dataPermisLayer.getSource().refresh();
                        (0, $1ed1be1197ad1bc4$export$51ba454167fb25ab)(map);
                        handleClosePermis();
                    }
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b0759c348c3ed98d$export$561d6732975c09b8), {
                map: map,
                disabledEditPermis: false,
                dataPermisLayer: dataPermisLayer,
                disabled: false,
                hasRightToInteract: hasRightToInteract,
                voletOuvert: voletOuvert
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1eee265537f042a4$export$2e2bcd8739ae039), {
                handleClose: ()=>{
                    handleCloseUpdatePermis();
                    dataPermisLayer.getSource().refresh();
                },
                show: showUpdatePermis,
                className: "w-auto",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $cc4162eb629a87fb$export$2e2bcd8739ae039), {
                    permisId: featureState?.elementId,
                    coordonneeX: featureState?.geometry.getFlatCoordinates()[0],
                    coordonneeY: featureState?.geometry.getFlatCoordinates()[1],
                    srid: map.getView().getProjection().getCode().split(":")[1],
                    deplacement: true,
                    onSubmit: ()=>{
                        handleCloseUpdatePermis();
                        (0, $1ed1be1197ad1bc4$export$51ba454167fb25ab)(map);
                    }
                })
            })
        ]
    });
};
$1b59352b860499d0$var$MapToolbarPermis.displayName = "MapToolbarPermis";
var $1b59352b860499d0$export$2e2bcd8739ae039 = $1b59352b860499d0$var$MapToolbarPermis;


const $6d2a1b0d422996c0$var$MapPermis = ()=>{
    const { state: state } = (0, $7a844823b04d4282$export$45d76561a5302f2b)();
    const { user: user } = (0, $e787cde576104469$export$fdc397e486fa83e7)();
    const mapElement = (0, $kc00y.useRef)();
    const { map: map, availableLayers: availableLayers, addOrRemoveLayer: addOrRemoveLayer, workingLayer: workingLayer, layerListRef: layerListRef, mapToolbarRef: mapToolbarRef, showOutilI: showOutilI, projection: projection } = (0, $cdcdd8e1ff041f79$export$547f9c492d831282)({
        mapElement: mapElement,
        typeModule: (0, $a9754922f4c67d47$export$ef88b514e4bfff34).PERMIS,
        displayPei: false
    });
    /** Permet d'afficher les PEI prescrits */ const dataPermisLayer = (0, $kc00y.useMemo)(()=>{
        if (!map) return;
        return (0, $1ed1be1197ad1bc4$export$a3178456480ccf5b)(map, (extent, projection)=>`/api/permis/layer?bbox=` + extent.join(",") + "&srid=" + projection.getCode(), projection);
    }, [
        map,
        projection
    ]);
    const { tools: extraTools, showSearchPermis: showSearchPermis, handleCloseSearchPermis: handleCloseSearchPermis, showCreatePermis: showCreatePermis, handleClosePermis: handleClosePermis, pointPermis: pointPermis, featureState: featureState, showUpdatePermis: showUpdatePermis, handleCloseUpdatePermis: handleCloseUpdatePermis, voletOuvert: voletOuvert } = (0, $1b59352b860499d0$export$1f9f792947eb1f71)({
        map: map,
        workingLayer: workingLayer,
        dataPermisLayer: dataPermisLayer
    });
    const { toggleTool: toggleTool, activeTool: activeTool, infoOutilI: infoOutilI, handleCloseInfoI: handleCloseInfoI } = (0, $e2b798e23180fa76$export$194c7727cbdc0cac)({
        availableLayers: availableLayers,
        map: map,
        workingLayer: workingLayer,
        extraTools: extraTools
    });
    (0, $kc00y.useEffect)(()=>{
        if (state?.target && map) {
            map.getView().fit((0, $a86eee1c28205a05$export$751c68e0e0efff79)(state.target.extent, `EPSG:${state.target.srid}`, map.getView().getProjection().getCode()), {
                maxZoom: 20
            });
            window.history.replaceState({
                from: state.from
            }, "");
        }
    }, [
        state,
        map
    ]);
    const hasRightToInteract = (0, $e3b8d60f4bb99483$export$4f612ab7b7b1d133)(user, [
        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).PERMIS_A
    ]);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $a0064658a8399ad3$export$2e2bcd8739ae039), {
        navbar: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $5de16d9a2066fdee$export$2e2bcd8739ae039), {}),
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                title: "Carte des Permis",
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$7876caa18827ace7), {})
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $cdcdd8e1ff041f79$export$2e2bcd8739ae039), {
                map: map,
                outilI: infoOutilI,
                showOutilI: showOutilI,
                handleCloseInfoI: handleCloseInfoI,
                availableLayers: availableLayers,
                addOrRemoveLayer: addOrRemoveLayer,
                layerListRef: layerListRef,
                mapToolbarRef: mapToolbarRef,
                mapElement: mapElement,
                toggleTool: toggleTool,
                activeTool: activeTool,
                toolbarElement: mapToolbarRef.current && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1b59352b860499d0$export$2e2bcd8739ae039), {
                    map: map,
                    dataPermisLayer: dataPermisLayer,
                    showSearchPermis: showSearchPermis,
                    handleCloseSearchPermis: handleCloseSearchPermis,
                    showCreatePermis: showCreatePermis,
                    handleClosePermis: handleClosePermis,
                    pointPermis: pointPermis,
                    featureState: featureState,
                    showUpdatePermis: showUpdatePermis,
                    handleCloseUpdatePermis: handleCloseUpdatePermis,
                    toggleTool: toggleTool,
                    activeTool: activeTool,
                    hasRightToInteract: hasRightToInteract,
                    voletOuvert: voletOuvert
                })
            })
        ]
    });
};
var $6d2a1b0d422996c0$export$2e2bcd8739ae039 = $6d2a1b0d422996c0$var$MapPermis;








var $kc00y = parcelRequire("kc00y");

















/**
 * @module ol/interaction/Translate
 */ 







/**
 * @enum {string}
 */ const $20cf82f1816591a4$var$TranslateEventType = {
    /**
   * Triggered upon feature translation start.
   * @event TranslateEvent#translatestart
   * @api
   */ TRANSLATESTART: 'translatestart',
    /**
   * Triggered upon feature translation.
   * @event TranslateEvent#translating
   * @api
   */ TRANSLATING: 'translating',
    /**
   * Triggered upon feature translation end.
   * @event TranslateEvent#translateend
   * @api
   */ TRANSLATEEND: 'translateend'
};
class $20cf82f1816591a4$export$1766f140d6979b9 extends (0, $5c6b0a43c077a98f$export$2e2bcd8739ae039) {
    /**
   * @param {TranslateEventType} type Type.
   * @param {Collection<Feature>} features The features translated.
   * @param {import("../coordinate.js").Coordinate} coordinate The event coordinate.
   * @param {import("../coordinate.js").Coordinate} startCoordinate The original coordinates before.translation started
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   */ constructor(type, features, coordinate, startCoordinate, mapBrowserEvent){
        super(type);
        /**
     * The features being translated.
     * @type {Collection<Feature>}
     * @api
     */ this.features = features;
        /**
     * The coordinate of the drag event.
     * @const
     * @type {import("../coordinate.js").Coordinate}
     * @api
     */ this.coordinate = coordinate;
        /**
     * The coordinate of the start position before translation started.
     * @const
     * @type {import("../coordinate.js").Coordinate}
     * @api
     */ this.startCoordinate = startCoordinate;
        /**
     * Associated {@link module:ol/MapBrowserEvent~MapBrowserEvent}.
     * @type {import("../MapBrowserEvent.js").default}
     * @api
     */ this.mapBrowserEvent = mapBrowserEvent;
    }
}
/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types|
 *     'change:active', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<'translateend'|'translatestart'|'translating', TranslateEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types|
 *     'change:active'|'translateend'|'translatestart'|'translating', Return>} TranslateOnSignature
 */ /**
 * @classdesc
 * Interaction for translating (moving) features.
 * If you want to translate multiple features in a single action (for example,
 * the collection used by a select interaction), construct the interaction with
 * the `features` option.
 *
 * @fires TranslateEvent
 * @api
 */ class $20cf82f1816591a4$var$Translate extends (0, $21bd437a923ad8cf$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        super(/** @type {import("./Pointer.js").Options} */ options);
        /***
     * @type {TranslateOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {TranslateOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {TranslateOnSignature<void>}
     */ this.un;
        /**
     * The last position we translated to.
     * @type {import("../coordinate.js").Coordinate}
     * @private
     */ this.lastCoordinate_ = null;
        /**
     * The start position before translation started.
     * @type {import("../coordinate.js").Coordinate}
     * @private
     */ this.startCoordinate_ = null;
        /**
     * @type {Collection<Feature>|null}
     * @private
     */ this.features_ = options.features !== undefined ? options.features : null;
        /** @type {function(import("../layer/Layer.js").default<import("../source/Source").default>): boolean} */ let layerFilter;
        if (options.layers && !this.features_) {
            if (typeof options.layers === 'function') layerFilter = options.layers;
            else {
                const layers = options.layers;
                layerFilter = function(layer) {
                    return layers.includes(layer);
                };
            }
        } else layerFilter = (0, $bc15bca7780ad95b$export$22e23a2304399231);
        /**
     * @private
     * @type {function(import("../layer/Layer.js").default<import("../source/Source").default>): boolean}
     */ this.layerFilter_ = layerFilter;
        /**
     * @private
     * @type {FilterFunction}
     */ this.filter_ = options.filter && !this.features_ ? options.filter : (0, $bc15bca7780ad95b$export$22e23a2304399231);
        /**
     * @private
     * @type {number}
     */ this.hitTolerance_ = options.hitTolerance ? options.hitTolerance : 0;
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.condition ? options.condition : (0, $638912a122b4daef$export$ba9e5d519bc326ca);
        /**
     * @type {Feature}
     * @private
     */ this.lastFeature_ = null;
        this.addChangeListener((0, $273e59fcc49a5e15$export$2e2bcd8739ae039).ACTIVE, this.handleActiveChanged_);
    }
    /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} event Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleDownEvent(event) {
        if (!event.originalEvent || !this.condition_(event)) return false;
        this.lastFeature_ = this.featuresAtPixel_(event.pixel, event.map);
        if (!this.lastCoordinate_ && this.lastFeature_) {
            this.startCoordinate_ = event.coordinate;
            this.lastCoordinate_ = event.coordinate;
            this.handleMoveEvent(event);
            const features = this.features_ || new (0, $e1f99232eb9bff27$export$2e2bcd8739ae039)([
                this.lastFeature_
            ]);
            this.dispatchEvent(new $20cf82f1816591a4$export$1766f140d6979b9($20cf82f1816591a4$var$TranslateEventType.TRANSLATESTART, features, event.coordinate, this.startCoordinate_, event));
            return true;
        }
        return false;
    }
    /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} event Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleUpEvent(event) {
        if (this.lastCoordinate_) {
            this.lastCoordinate_ = null;
            this.handleMoveEvent(event);
            const features = this.features_ || new (0, $e1f99232eb9bff27$export$2e2bcd8739ae039)([
                this.lastFeature_
            ]);
            this.dispatchEvent(new $20cf82f1816591a4$export$1766f140d6979b9($20cf82f1816591a4$var$TranslateEventType.TRANSLATEEND, features, event.coordinate, this.startCoordinate_, event));
            // cleanup
            this.startCoordinate_ = null;
            return true;
        }
        return false;
    }
    /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} event Event.
   * @override
   */ handleDragEvent(event) {
        if (this.lastCoordinate_) {
            const newCoordinate = event.coordinate;
            const projection = event.map.getView().getProjection();
            const newViewCoordinate = (0, $a86eee1c28205a05$export$d4b8ec0b96db1ee2)(newCoordinate, projection);
            const lastViewCoordinate = (0, $a86eee1c28205a05$export$d4b8ec0b96db1ee2)(this.lastCoordinate_, projection);
            const deltaX = newViewCoordinate[0] - lastViewCoordinate[0];
            const deltaY = newViewCoordinate[1] - lastViewCoordinate[1];
            const features = this.features_ || new (0, $e1f99232eb9bff27$export$2e2bcd8739ae039)([
                this.lastFeature_
            ]);
            const userProjection = (0, $a86eee1c28205a05$export$3973b77d5f6f2790)();
            features.forEach(function(feature) {
                const geom = feature.getGeometry();
                if (userProjection) {
                    geom.transform(userProjection, projection);
                    geom.translate(deltaX, deltaY);
                    geom.transform(projection, userProjection);
                } else geom.translate(deltaX, deltaY);
                feature.setGeometry(geom);
            });
            this.lastCoordinate_ = newCoordinate;
            this.dispatchEvent(new $20cf82f1816591a4$export$1766f140d6979b9($20cf82f1816591a4$var$TranslateEventType.TRANSLATING, features, newCoordinate, this.startCoordinate_, event));
        }
    }
    /**
   * Handle pointer move events.
   * @param {import("../MapBrowserEvent.js").default} event Event.
   * @override
   */ handleMoveEvent(event) {
        const elem = event.map.getViewport();
        // Change the cursor to grab/grabbing if hovering any of the features managed
        // by the interaction
        if (this.featuresAtPixel_(event.pixel, event.map)) {
            elem.classList.remove(this.lastCoordinate_ ? 'ol-grab' : 'ol-grabbing');
            elem.classList.add(this.lastCoordinate_ ? 'ol-grabbing' : 'ol-grab');
        } else elem.classList.remove('ol-grab', 'ol-grabbing');
    }
    /**
   * Tests to see if the given coordinates intersects any of our selected
   * features.
   * @param {import("../pixel.js").Pixel} pixel Pixel coordinate to test for intersection.
   * @param {import("../Map.js").default} map Map to test the intersection on.
   * @return {Feature} Returns the feature found at the specified pixel
   * coordinates.
   * @private
   */ featuresAtPixel_(pixel, map) {
        return map.forEachFeatureAtPixel(pixel, (feature, layer)=>{
            if (!(feature instanceof (0, $df26d2327ced1fa9$export$2e2bcd8739ae039)) || !this.filter_(feature, layer)) return undefined;
            if (this.features_ && !this.features_.getArray().includes(feature)) return undefined;
            return feature;
        }, {
            layerFilter: this.layerFilter_,
            hitTolerance: this.hitTolerance_
        });
    }
    /**
   * Returns the Hit-detection tolerance.
   * @return {number} Hit tolerance in pixels.
   * @api
   */ getHitTolerance() {
        return this.hitTolerance_;
    }
    /**
   * Hit-detection tolerance. Pixels inside the radius around the given position
   * will be checked for features.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @api
   */ setHitTolerance(hitTolerance) {
        this.hitTolerance_ = hitTolerance;
    }
    /**
   * Remove the interaction from its current map and attach it to the new map.
   * Subclasses may set up event handlers to get notified about changes to
   * the map here.
   * @param {import("../Map.js").default} map Map.
   * @override
   */ setMap(map) {
        const oldMap = this.getMap();
        super.setMap(map);
        this.updateState_(oldMap);
    }
    /**
   * @private
   */ handleActiveChanged_() {
        this.updateState_(null);
    }
    /**
   * @param {import("../Map.js").default} oldMap Old map.
   * @private
   */ updateState_(oldMap) {
        let map = this.getMap();
        const active = this.getActive();
        if (!map || !active) {
            map = map || oldMap;
            if (map) {
                const elem = map.getViewport();
                elem.classList.remove('ol-grab', 'ol-grabbing');
            }
        }
    }
}
var $20cf82f1816591a4$export$2e2bcd8739ae039 = $20cf82f1816591a4$var$Translate;









var $kc00y = parcelRequire("kc00y");







const $2d246e081c968426$var$FORMATS = [
    {
        code: "a4landscape",
        label: "A4 (Paysage)",
        value: {
            width: "297mm",
            height: "210mm"
        }
    },
    {
        code: "a4portrait",
        label: "A4 (Portrait)",
        value: {
            width: "210mm",
            height: "297mm"
        }
    },
    {
        code: "a3landscape",
        label: "A3 (Paysage)",
        value: {
            width: "594mm",
            height: "420mm"
        }
    },
    {
        code: "a3portrait",
        label: "A3 (Portrait)",
        value: {
            width: "420mm",
            height: "594mm"
        }
    }
];
const $2d246e081c968426$var$LINE_CAPS = [
    [
        "round",
        "Arrondies"
    ],
    [
        "square",
        "Carr\xe9es"
    ],
    [
        "butt",
        "Droites"
    ]
];
const $2d246e081c968426$var$LINE_DASHES = [
    [
        "solid",
        "Continu"
    ],
    [
        "dot",
        "Pointill\xe9s"
    ],
    [
        "dash",
        "Tirets"
    ],
    [
        "dashdot",
        "Tirets / Pointill\xe9s"
    ],
    [
        "longdash",
        "Tirets longs"
    ],
    [
        "longdashdot",
        "Tirets longs / Pointill\xe9s"
    ]
];
const $2d246e081c968426$export$39e67dd0a56ff3d6 = ({ map: map, cartographiePersoLayer: cartographiePersoLayer, featureStyle: featureStyle, SetFeatureStyle: SetFeatureStyle })=>{
    const [selectedFeatures, setSelectedFeatures] = (0, $kc00y.useState)([]);
    // Ajout pour gestion du select
    const selectCtrlRef = (0, $kc00y.useRef)(null);
    // Ref pour le style courant
    const featureStyleRef = (0, $kc00y.useRef)(featureStyle);
    // Sync ref à chaque changement de style
    (0, $kc00y.useEffect)(()=>{
        featureStyleRef.current = featureStyle;
    }, [
        featureStyle
    ]);
    const tools = (0, $kc00y.useMemo)(()=>{
        if (!map || !cartographiePersoLayer) return {};
        const drawPointCtrl = new (0, $2ef894158a48397d$export$2e2bcd8739ae039)({
            source: cartographiePersoLayer.getSource() ?? undefined,
            type: "Point"
        });
        const drawLineCtrl = new (0, $2ef894158a48397d$export$2e2bcd8739ae039)({
            source: cartographiePersoLayer.getSource() ?? undefined,
            type: "LineString"
        });
        const drawShapeCtrl = new (0, $2ef894158a48397d$export$2e2bcd8739ae039)({
            source: cartographiePersoLayer.getSource() ?? undefined,
            type: "Polygon"
        });
        drawPointCtrl.on("drawend", (event)=>{
            const s = featureStyleRef.current.clone();
            event.feature.setStyle(s);
            event.feature.set("_userStyle", s);
        });
        drawLineCtrl.on("drawend", (event)=>{
            const s = featureStyleRef.current.clone();
            event.feature.setStyle(s);
            event.feature.set("_userStyle", s);
        });
        drawShapeCtrl.on("drawend", (event)=>{
            const s = featureStyleRef.current.clone();
            event.feature.setStyle(s);
            event.feature.set("_userStyle", s);
        });
        const selectCtrl = new (0, $20af4deb83586389$export$2e2bcd8739ae039)({
            layers: [
                cartographiePersoLayer
            ],
            toggleCondition: (0, $638912a122b4daef$export$f3100d8d6292d638)
        });
        selectCtrlRef.current = selectCtrl;
        selectCtrl.on("select", ()=>{
            setSelectedFeatures(selectCtrl.getFeatures().getArray());
        });
        const dragBoxCtrl = new (0, $886371f562c99b97$export$2e2bcd8739ae039)({
            minArea: 25
        });
        dragBoxCtrl.on("boxend", function(e) {
            if (!(0, $638912a122b4daef$export$f3100d8d6292d638)(e.mapBrowserEvent)) selectCtrl.getFeatures().clear();
            const boxExtent = dragBoxCtrl.getGeometry().getExtent();
            const boxFeatures = cartographiePersoLayer.getSource()?.getFeaturesInExtent(boxExtent) ?? [];
            selectCtrl.getFeatures().extend(boxFeatures);
            setSelectedFeatures(selectCtrl.getFeatures().getArray());
        });
        // Désactive select sans clear la sélection
        function toggleSelectDraw(active = false, keepSelection = false) {
            const idx1 = map?.getInteractions().getArray().indexOf(selectCtrl);
            const idx2 = map?.getInteractions().getArray().indexOf(dragBoxCtrl);
            if (active) {
                if (idx1 === -1 && idx2 === -1) {
                    map?.addInteraction(selectCtrl);
                    map?.addInteraction(dragBoxCtrl);
                }
            } else {
                map?.removeInteraction(selectCtrl);
                map?.removeInteraction(dragBoxCtrl);
                if (!keepSelection) {
                    selectCtrl.getFeatures().clear();
                    setSelectedFeatures([]);
                }
            }
        }
        function toggleCtrl(active, ctrl) {
            const idx = map?.getInteractions().getArray().indexOf(ctrl);
            if (active) {
                if (idx === -1) map?.addInteraction(ctrl);
            } else map?.removeInteraction(ctrl);
        }
        function toggleDrawPoint(active = false) {
            toggleCtrl(active, drawPointCtrl);
        }
        function toggleDrawLine(active = false) {
            toggleCtrl(active, drawLineCtrl);
        }
        function toggleDrawShape(active = false) {
            toggleCtrl(active, drawShapeCtrl);
        }
        const modifyShapeCtrl = new (0, $2375ecf9b29b2a49$export$2e2bcd8739ae039)({
            source: cartographiePersoLayer.getSource() ?? undefined
        });
        const defaultStyle = new (0, $2375ecf9b29b2a49$export$2e2bcd8739ae039)({
            source: cartographiePersoLayer.getSource() ?? undefined
        }).getOverlay().getStyleFunction();
        const scaleRotatePreviewSource = new (0, $1020e4d07ddbfab1$export$2e2bcd8739ae039)();
        const scaleRotatePreviewLayer = new (0, $082a79ecb622f84a$export$2e2bcd8739ae039)({
            source: scaleRotatePreviewSource,
            style: (feature)=>{
                const originalFeature = feature.get("originalFeature");
                return originalFeature?.getStyle?.() ?? cartographiePersoLayer.getStyle();
            }
        });
        scaleRotatePreviewLayer.setZIndex((cartographiePersoLayer.getZIndex() ?? 0) + 1);
        const modifyScaleCtrl = new (0, $2375ecf9b29b2a49$export$2e2bcd8739ae039)({
            source: cartographiePersoLayer.getSource() ?? undefined,
            deleteCondition: (0, $638912a122b4daef$export$b3e22bcfd64c1022),
            insertVertexCondition: (0, $638912a122b4daef$export$b3e22bcfd64c1022)
        });
        // Style invisible pour masquer la feature originale
        const invisibleStyle = new (0, $a5fc261473972d1d$export$2e2bcd8739ae039)({
            fill: new (0, $8624b871a0af6dab$export$2e2bcd8739ae039)({
                color: "rgba(0,0,0,0.0)"
            }),
            stroke: new (0, $281691897fddf9d0$export$2e2bcd8739ae039)({
                color: "rgba(0,0,0,0)",
                width: 0
            }),
            image: new (0, $f060542c6e9f52e6$export$2e2bcd8739ae039)({
                radius: 0
            })
        });
        modifyScaleCtrl.on("modifystart", function(event) {
            event.features.forEach(function(feature) {
                const geometry = feature.getGeometry();
                if (!geometry) return;
                // Récupère le style d'origine (objet ou fonction)
                let originalStyle = feature.getStyle?.();
                if (typeof originalStyle === "function") originalStyle = originalStyle(feature, 1) || defaultStyle;
                // Crée la preview avec le style d'origine cloné si possible
                const previewFeature = new (0, $df26d2327ced1fa9$export$2e2bcd8739ae039)(geometry.clone());
                let previewStyle = defaultStyle instanceof (0, $a5fc261473972d1d$export$2e2bcd8739ae039) ? defaultStyle : new (0, $a5fc261473972d1d$export$2e2bcd8739ae039)();
                // Vérifie que le style est bien une instance de Style (et non une fonction)
                if (originalStyle instanceof (0, $a5fc261473972d1d$export$2e2bcd8739ae039)) previewStyle = originalStyle.clone();
                else if (defaultStyle instanceof (0, $a5fc261473972d1d$export$2e2bcd8739ae039)) previewStyle = defaultStyle.clone();
                previewFeature.setStyle(previewStyle);
                scaleRotatePreviewSource.addFeature(previewFeature);
                // Stocke la géométrie et le style d'origine
                feature.set("_geometry0", geometry.clone());
                feature.set("_previewFeature", previewFeature);
                // Si la feature n'a pas de style propre, stocke null (pour restaurer le style du layer)
                feature.set("_originalStyle", feature.getStyle ? feature.getStyle() ?? null : null);
                // Masque la feature originale
                feature.setStyle(invisibleStyle);
            });
        });
        // Gestion du drag pour la preview (écouteur pointerdrag sur la map)
        let pointerDragListener = null;
        modifyScaleCtrl.on("modifystart", function(event) {
            const map = event.mapBrowserEvent?.map || event.target && event.target.getMap && event.target.getMap();
            if (map) {
                // Toujours retirer l'ancien listener si présent
                if (pointerDragListener) {
                    map.un("pointerdrag", pointerDragListener.listener);
                    pointerDragListener = null;
                }
                pointerDragListener = map.on("pointerdrag", function(evt) {
                    event.features.forEach(function(feature) {
                        const previewFeature = feature.get("_previewFeature");
                        const geometry0 = feature.get("_geometry0");
                        if (!previewFeature || !geometry0) return;
                        const coordinate = evt.coordinate;
                        let point0 = feature.get("_point0");
                        let center0 = feature.get("_center0");
                        let radius0 = feature.get("_radius0");
                        let angle0 = feature.get("_angle0");
                        if (!point0) {
                            point0 = coordinate;
                            feature.set("_point0", point0);
                            let center;
                            const type = geometry0.getType();
                            if (type === "Polygon") {
                                let x = 0, y = 0, i = 0;
                                const coords = geometry0.getCoordinates()[0].slice(1);
                                coords.forEach((c)=>{
                                    x += c[0];
                                    y += c[1];
                                    i++;
                                });
                                center = [
                                    x / i,
                                    y / i
                                ];
                            } else if (type === "LineString") center = geometry0.getCoordinateAt(0.5);
                            else center = (0, $dea65c2f666fa450$export$c91255cadecfe081)(geometry0.getExtent());
                            center0 = center;
                            feature.set("_center0", center0);
                            radius0 = Math.sqrt(Math.pow(point0[0] - center0[0], 2) + Math.pow(point0[1] - center0[1], 2));
                            feature.set("_radius0", radius0);
                            angle0 = Math.atan2(point0[1] - center0[1], point0[0] - center0[0]);
                            feature.set("_angle0", angle0);
                        }
                        const currentRadius = Math.sqrt(Math.pow(coordinate[0] - center0[0], 2) + Math.pow(coordinate[1] - center0[1], 2));
                        const currentAngle = Math.atan2(coordinate[1] - center0[1], coordinate[0] - center0[0]);
                        const scale = currentRadius / radius0;
                        const rotate = currentAngle - angle0;
                        const newGeometry = geometry0.clone();
                        newGeometry.scale(scale, undefined, center0);
                        newGeometry.rotate(rotate, center0);
                        previewFeature.setGeometry(newGeometry);
                    });
                });
            }
        });
        modifyScaleCtrl.on("modifyend", function(event) {
            // Retire l'écouteur pointerdrag
            const map = event.mapBrowserEvent?.map || event.target && event.target.getMap && event.target.getMap();
            if (map && pointerDragListener) {
                map.un("pointerdrag", pointerDragListener.listener);
                pointerDragListener = null;
            }
            event.features.forEach(function(feature) {
                const previewFeature = feature.get("_previewFeature");
                if (previewFeature) {
                    const finalGeometry = previewFeature.getGeometry();
                    if (finalGeometry) feature.setGeometry(finalGeometry.clone());
                    scaleRotatePreviewSource.removeFeature(previewFeature);
                    feature.unset("_previewFeature");
                }
                // Restaure le style d'origine (null ou undefined => style du layer)
                const originalStyle = feature.get("_originalStyle");
                if (originalStyle !== undefined && originalStyle !== null) feature.setStyle(originalStyle);
                else feature.setStyle(undefined);
                feature.unset("_originalStyle");
                feature.unset("_geometry0");
                feature.unset("_point0");
                feature.unset("_center0");
                feature.unset("_radius0");
                feature.unset("_angle0");
            });
        });
        function toggleModifyShape(active = false) {
            toggleCtrl(active, modifyShapeCtrl);
        }
        function toggleModifyScale(active = false) {
            toggleCtrl(active, modifyScaleCtrl);
            if (active) {
                if (!map?.getLayers().getArray().includes(scaleRotatePreviewLayer)) map?.addLayer(scaleRotatePreviewLayer);
            } else {
                const source = cartographiePersoLayer?.getSource();
                source?.getFeatures().forEach((feature)=>{
                    const modifyGeometry = feature.get("modifyGeometry");
                    if (modifyGeometry?.previewFeature) scaleRotatePreviewSource.removeFeature(modifyGeometry.previewFeature);
                    feature.unset("modifyGeometry", true);
                });
                scaleRotatePreviewSource.clear();
                map?.removeLayer(scaleRotatePreviewLayer);
            }
        }
        const translateSelectCtrl = new (0, $20af4deb83586389$export$2e2bcd8739ae039)({
            layers: [
                cartographiePersoLayer
            ]
        });
        const translateCtrl = new (0, $20cf82f1816591a4$export$2e2bcd8739ae039)({
            features: translateSelectCtrl.getFeatures()
        });
        function toggleTranslate(active = false) {
            const idx1 = map?.getInteractions().getArray().indexOf(translateSelectCtrl);
            const idx2 = map?.getInteractions().getArray().indexOf(translateCtrl);
            if (active) {
                if (idx1 === -1 && idx2 === -1) {
                    map?.addInteraction(translateSelectCtrl);
                    map?.addInteraction(translateCtrl);
                }
            } else {
                map?.removeInteraction(translateSelectCtrl);
                map?.removeInteraction(translateCtrl);
            }
        }
        const tools = {
            "select-draw": {
                action: toggleSelectDraw,
                actionPossibleEnDeplacement: false
            },
            "draw-point": {
                action: toggleDrawPoint
            },
            "draw-line": {
                action: toggleDrawLine
            },
            "draw-polygon": {
                action: toggleDrawShape
            },
            "edit-shape": {
                action: toggleModifyShape
            },
            "edit-scale-rotate": {
                action: toggleModifyScale
            },
            "edit-translate": {
                action: toggleTranslate
            }
        };
        return tools;
    }, [
        map,
        cartographiePersoLayer
    ]);
    return {
        tools: tools,
        featureStyle: featureStyle,
        SetFeatureStyle: SetFeatureStyle,
        selectedFeatures: selectedFeatures,
        setSelectedFeatures: setSelectedFeatures
    };
};
// Utilitaire pour convertir n'importe quel format OL en hexadécimal #RRGGBB
function $2d246e081c968426$var$colorToHex(color) {
    if (!color) return "#000000";
    let arr = color;
    if (typeof color === "string") {
        if (color.startsWith("#")) return color.substring(0, 7);
        if (color.startsWith("rgba") || color.startsWith("rgb")) arr = (0, $ebac9d8363fa165e$export$75093a47a9fa838d)(color);
        else arr = (0, $ebac9d8363fa165e$export$75093a47a9fa838d)(color);
    } else if (Array.isArray(color)) arr = color;
    else // CanvasPattern, CanvasGradient, PatternDescriptor, etc.
    return "#000000";
    return "#" + (0, $ebac9d8363fa165e$export$75093a47a9fa838d)(arr).slice(0, 3).map((x)=>{
        const hex = Math.round(x).toString(16);
        return hex.length === 1 ? "0" + hex : hex;
    }).join("");
}
const $2d246e081c968426$var$MapToolbarCartographiePerso = ({ toggleTool: toggleToolCallback, activeTool: activeTool, featureStyle: featureStyle, setFeatureStyle: setFeatureStyle, selectedFeatures: selectedFeatures, setSelectedFeatures: setSelectedFeatures, cartographiePersoLayer: cartographiePersoLayer, tools: tools })=>{
    // --- STYLE DE FORMULAIRE ---
    const [formStyle, setFormStyle] = (0, $kc00y.useState)(()=>featureStyle.clone());
    const previewRef = (0, $kc00y.useRef)(null);
    const [showPanel, setShowPanel] = (0, $kc00y.useState)(false);
    // Pour stocker les styles d'origine
    const originalStylesRef = (0, $kc00y.useRef)(new Map());
    // --- SYNCHRONISATION DU FORMULAIRE AVEC LA SÉLECTION ---
    (0, $kc00y.useLayoutEffect)(()=>{
        if (!showPanel) return;
        if (selectedFeatures.length === 1) {
            const style = selectedFeatures[0].getStyle?.();
            if (style instanceof (0, $a5fc261473972d1d$export$2e2bcd8739ae039)) setFormStyle(style.clone());
            else setFormStyle(featureStyle.clone());
        } else setFormStyle(featureStyle.clone());
    }, [
        selectedFeatures,
        featureStyle,
        showPanel
    ]);
    const previewMap = (0, $kc00y.useMemo)(()=>new (0, $fe544abd54013409$export$2e2bcd8739ae039)({
            controls: [],
            interactions: [],
            layers: [],
            view: new (0, $22c5be3317ad81f4$export$2e2bcd8739ae039)({
                extent: [
                    -25,
                    -20,
                    30,
                    20
                ],
                center: [
                    0,
                    0
                ],
                zoom: 2
            })
        }), []);
    (0, $kc00y.useEffect)(()=>{
        if (previewRef.current) previewMap.setTarget(previewRef.current);
        return ()=>{
            previewMap.setTarget(undefined);
        };
    }, [
        previewMap
    ]);
    const previewLayer = (0, $kc00y.useMemo)(()=>{
        // Alimentation des géométries de prévisualisation
        const pointFeature = new (0, $3153df5f3993c8ca$export$2e2bcd8739ae039)([
            -4,
            8
        ]);
        const lineFeature = new (0, $197b31f867e63891$export$2e2bcd8739ae039)([
            [
                -9,
                -12
            ],
            [
                -4,
                -15
            ],
            [
                1,
                -10
            ]
        ]);
        const polygonFeature = new (0, $52cb54ac72de6b07$export$2e2bcd8739ae039)([
            [
                [
                    5,
                    0
                ],
                [
                    10,
                    -3
                ],
                [
                    15,
                    6
                ],
                [
                    9,
                    5
                ],
                [
                    5,
                    0
                ]
            ]
        ]);
        const vectorLayer = new (0, $082a79ecb622f84a$export$2e2bcd8739ae039)({
            source: new (0, $1020e4d07ddbfab1$export$2e2bcd8739ae039)({
                features: [
                    pointFeature,
                    lineFeature,
                    polygonFeature
                ].map((p)=>new (0, $df26d2327ced1fa9$export$2e2bcd8739ae039)(p))
            }),
            style: featureStyle,
            extent: [
                -25,
                -20,
                30,
                20
            ]
        });
        previewMap.addLayer(vectorLayer);
        return vectorLayer;
    }, [
        featureStyle,
        previewMap.addLayer
    ]);
    function updatePreview() {
        if (!previewLayer.getSource()) return;
        previewLayer?.getSource()?.getFeatures().forEach((f)=>{
            f.setStyle(formStyle);
        });
        // Appliquer le style de preview sur les features sélectionnées uniquement pour la preview (pas de persistance)
        if (selectedFeatures.length) selectedFeatures.forEach((f)=>{
            // Stocker le style d'origine si pas déjà fait
            if (!originalStylesRef.current.has(f)) {
                const style = f.getStyle?.();
                if (style === undefined || style instanceof (0, $a5fc261473972d1d$export$2e2bcd8739ae039)) originalStylesRef.current.set(f, style);
                else originalStylesRef.current.set(f, undefined);
            }
            f.setStyle(formStyle.clone());
        });
        else setFeatureStyle(formStyle.clone());
        // Clone pour créer une nouvelle référence et déclencher le re-render React
        setFormStyle(formStyle.clone());
    }
    function updateFeatureStyle() {
        if (selectedFeatures.length) {
            selectedFeatures.forEach((f)=>{
                const s = formStyle.clone();
                f.setStyle(s);
                f.set("_userStyle", s);
                originalStylesRef.current.delete(f);
            });
            originalStylesRef.current.clear();
            // Désactive visuellement le bouton select-draw
            toggleToolCallback("select-draw");
        } else setFeatureStyle(formStyle.clone());
        setShowPanel(false);
    }
    function deleteFeature() {
        selectedFeatures.forEach((f)=>{
            cartographiePersoLayer?.getSource()?.removeFeature(f);
        });
        setSelectedFeatures([]);
    }
    function handleOpenPanel() {
        // Calcule le style à afficher dans le formulaire (et en preview)
        let initialStyle;
        if (selectedFeatures.length === 1) {
            const userStyle = selectedFeatures[0].get("_userStyle");
            initialStyle = userStyle instanceof (0, $a5fc261473972d1d$export$2e2bcd8739ae039) ? userStyle.clone() : featureStyle.clone();
        } else initialStyle = featureStyle.clone();
        setFormStyle(initialStyle);
        if (selectedFeatures.length) {
            // Désactive l'outil select-draw dans la logique métier mais garde la sélection
            if (tools?.["select-draw"] && typeof tools["select-draw"].action === "function") tools["select-draw"].action(false, true);
            // Appliquer le style de preview uniquement pour la preview (pas de persistance)
            selectedFeatures.forEach((f)=>{
                if (!originalStylesRef.current.has(f)) {
                    const style = f.getStyle?.();
                    if (style === undefined || style instanceof (0, $a5fc261473972d1d$export$2e2bcd8739ae039)) originalStylesRef.current.set(f, style);
                    else originalStylesRef.current.set(f, undefined);
                }
                f.setStyle(initialStyle.clone());
            });
        }
        setShowPanel(true);
    }
    function handleClosePanel() {
        // Restaure le style d'origine si on ferme sans appliquer
        if (selectedFeatures.length) {
            selectedFeatures.forEach((f)=>{
                if (originalStylesRef.current.has(f)) {
                    const orig = originalStylesRef.current.get(f);
                    f.setStyle(orig);
                }
            });
            originalStylesRef.current.clear();
            // Désactive visuellement le bouton select-draw
            toggleToolCallback("select-draw");
        }
        setShowPanel(false);
    }
    const { activesKeys: activesKeys, handleShowClose: handleShowClose } = (0, $db860d90b4a42fea$export$dae930a4ba30758b)(Array(selectedFeatures.length > 0 ? 4 : 3).fill(true));
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $a43e6f68e14bab96$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $f2eef644ac9323e0$export$2e2bcd8739ae039), {
                            toolName: "select-draw",
                            toolIcon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$249df474ea45aebc), {}),
                            toolLabelTooltip: "S\xe9lectionner des \xe9l\xe9ments",
                            toggleTool: toggleToolCallback,
                            activeTool: activeTool,
                            disabled: showPanel
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $a43e6f68e14bab96$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $f2eef644ac9323e0$export$2e2bcd8739ae039), {
                                toolName: "draw-point",
                                toolIcon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$fc789d8a435194dc), {}),
                                toolLabelTooltip: "Dessiner un point",
                                toggleTool: toggleToolCallback,
                                activeTool: activeTool,
                                disabled: showPanel
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $f2eef644ac9323e0$export$2e2bcd8739ae039), {
                                toolName: "draw-line",
                                toolIcon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$365092c6388045c9), {}),
                                toolLabelTooltip: "Dessiner une ligne",
                                toggleTool: toggleToolCallback,
                                activeTool: activeTool,
                                disabled: showPanel
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $f2eef644ac9323e0$export$2e2bcd8739ae039), {
                                toolName: "draw-polygon",
                                toolIcon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$fa5eb5b4918005e3), {}),
                                toolLabelTooltip: "Dessiner un polygone",
                                toggleTool: toggleToolCallback,
                                activeTool: activeTool,
                                disabled: showPanel
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $a43e6f68e14bab96$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                                tooltipText: "Modifier le style",
                                tooltipId: "pick-style",
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8b78b8a93971307c$export$2e2bcd8739ae039), {
                                    name: "pick-style",
                                    onClick: ()=>showPanel ? handleClosePanel() : handleOpenPanel(),
                                    id: "pick-style",
                                    value: "pick-style",
                                    type: "radio",
                                    variant: "outline-primary",
                                    checked: showPanel,
                                    className: "m-2",
                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$9c955948016ac53c), {})
                                })
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $f2eef644ac9323e0$export$2e2bcd8739ae039), {
                                toolName: "edit-shape",
                                toolIcon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$b51dd496211ae105), {}),
                                toolLabelTooltip: "Modifier un \xe9l\xe9ment",
                                toggleTool: toggleToolCallback,
                                activeTool: activeTool,
                                disabled: showPanel
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $f2eef644ac9323e0$export$2e2bcd8739ae039), {
                                toolName: "edit-scale-rotate",
                                toolIcon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$57cd704edc5f43cd), {}),
                                toolLabelTooltip: "Mettre \xe0 l'\xe9chelle / effectuer une rotation sur un \xe9l\xe9ment",
                                toggleTool: toggleToolCallback,
                                activeTool: activeTool,
                                disabled: showPanel
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $f2eef644ac9323e0$export$2e2bcd8739ae039), {
                                toolName: "edit-translate",
                                toolIcon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$e4cfe2ae2a038e0f), {}),
                                toolLabelTooltip: "D\xe9placer un \xe9l\xe9ment",
                                toggleTool: toggleToolCallback,
                                activeTool: activeTool,
                                disabled: showPanel
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                                tooltipText: "Supprimer un \xe9l\xe9ment",
                                tooltipId: "delete-features",
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8b78b8a93971307c$export$2e2bcd8739ae039), {
                                    name: "delete-features",
                                    onClick: deleteFeature,
                                    id: "delete-features",
                                    value: "delete-features",
                                    type: "radio",
                                    variant: "outline-primary",
                                    className: "m-2",
                                    disabled: showPanel || selectedFeatures.length === 0,
                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$4d4e10ce882b8153), {})
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $a43e6f68e14bab96$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Group, {
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Group, {
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Select, {
                                    onChange: (evt)=>{
                                        const format = $2d246e081c968426$var$FORMATS.filter((f)=>f.code === evt.target.value)[0];
                                        const papersheet = document.getElementById("papersheet");
                                        if (papersheet) {
                                            papersheet.style.width = format.value.width;
                                            papersheet.style.height = format.value.height;
                                        }
                                    },
                                    children: $2d246e081c968426$var$FORMATS.map((v, k)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("option", {
                                            value: v.code,
                                            children: v.label
                                        }, k))
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1eee265537f042a4$export$2e2bcd8739ae039), {
                show: showPanel,
                handleClose: handleClosePanel,
                title: selectedFeatures.length > 1 ? "Modifier le style des objets s\xe9lectionn\xe9s" : selectedFeatures.length === 1 ? "Modifier le style de l'objet s\xe9lectionn\xe9" : "Modifier le style par d\xe9faut",
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db860d90b4a42fea$export$2e2bcd8739ae039), {
                        activesKeys: activesKeys,
                        list: [
                            {
                                header: "Point",
                                content: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Group, {
                                            children: [
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Label, {
                                                    children: "Rayon"
                                                }),
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $fb281c3c0e7b8a11$export$2e2bcd8739ae039), {
                                                    min: 1,
                                                    max: 200,
                                                    step: 1,
                                                    defaultValue: formStyle?.getImage()?.getRadius(),
                                                    onChange: (evt)=>{
                                                        formStyle?.getImage()?.setRadius(parseInt(evt.target.value));
                                                        updatePreview();
                                                    }
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Group, {
                                            children: [
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Label, {
                                                    children: "Rotation"
                                                }),
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $fb281c3c0e7b8a11$export$2e2bcd8739ae039), {
                                                    min: 0,
                                                    max: 359,
                                                    step: 1,
                                                    defaultValue: formStyle?.getImage()?.getRotation(),
                                                    onChange: (evt)=>{
                                                        formStyle?.getImage()?.setRotation(parseInt(evt.target.value));
                                                        updatePreview();
                                                    }
                                                })
                                            ]
                                        })
                                    ]
                                })
                            },
                            {
                                header: "Ligne",
                                content: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Group, {
                                            children: [
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Label, {
                                                    children: "Couleur"
                                                }),
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Control, {
                                                    type: "color",
                                                    defaultValue: $2d246e081c968426$var$colorToHex(formStyle?.getStroke()?.getColor()),
                                                    onChange: (evt)=>{
                                                        const newColor = (0, $ebac9d8363fa165e$export$590567be997858b6)((0, $ebac9d8363fa165e$export$75093a47a9fa838d)(evt.target.value).concat((()=>{
                                                            const fillColor = formStyle?.getFill()?.getColor() ?? "#000000";
                                                            if (typeof fillColor === "string" || Array.isArray(fillColor)) return (0, $ebac9d8363fa165e$export$75093a47a9fa838d)(fillColor)[3] ?? 1;
                                                            // fallback for CanvasPattern/CanvasGradient or unknown
                                                            return 1;
                                                        })()));
                                                        formStyle?.getStroke()?.setColor(newColor);
                                                        formStyle?.getImage()?.setStroke(formStyle?.getStroke());
                                                        updatePreview();
                                                    }
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Group, {
                                            children: [
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Label, {
                                                    children: "Opacit\xe9"
                                                }),
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $fb281c3c0e7b8a11$export$2e2bcd8739ae039), {
                                                    min: 0,
                                                    max: 1,
                                                    step: 0.01,
                                                    defaultValue: (()=>{
                                                        const color = formStyle?.getStroke()?.getColor();
                                                        if (typeof color === "string" || Array.isArray(color)) return (0, $ebac9d8363fa165e$export$75093a47a9fa838d)(color)[3] ?? 1;
                                                        // fallback for CanvasPattern/CanvasGradient or unknown
                                                        return 1;
                                                    })(),
                                                    onChange: (evt)=>{
                                                        const newColor = (0, $ebac9d8363fa165e$export$590567be997858b6)((()=>{
                                                            const color = formStyle?.getStroke()?.getColor() ?? "#000000";
                                                            if (typeof color === "string" || Array.isArray(color)) return (0, $ebac9d8363fa165e$export$75093a47a9fa838d)(color).slice(0, 3).concat(parseFloat(evt.target.value));
                                                            // fallback for CanvasPattern/CanvasGradient or unknown
                                                            return (0, $ebac9d8363fa165e$export$75093a47a9fa838d)("#000000").slice(0, 3).concat(parseFloat(evt.target.value));
                                                        })());
                                                        formStyle?.getStroke()?.setColor(newColor);
                                                        formStyle?.getImage()?.setStroke(formStyle?.getStroke());
                                                        updatePreview();
                                                    }
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Group, {
                                            children: [
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Label, {
                                                    children: "Epaisseur"
                                                }),
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $fb281c3c0e7b8a11$export$2e2bcd8739ae039), {
                                                    min: 0,
                                                    max: 100,
                                                    step: 1,
                                                    defaultValue: formStyle?.getStroke()?.getWidth(),
                                                    onChange: (evt)=>{
                                                        formStyle?.getStroke()?.setWidth(parseInt(evt.target.value));
                                                        formStyle?.getImage()?.setStroke(formStyle?.getStroke());
                                                        updatePreview();
                                                    }
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Group, {
                                            children: [
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Label, {
                                                    children: "Fins de ligne"
                                                }),
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Select, {
                                                    value: (()=>{
                                                        const stroke = formStyle.getStroke();
                                                        if (stroke && stroke.getLineCap) return stroke.getLineCap?.() || "round";
                                                        return "round";
                                                    })(),
                                                    onChange: (evt)=>{
                                                        const stroke = formStyle.getStroke();
                                                        if (stroke && stroke.setLineCap) {
                                                            stroke.setLineCap(evt.target.value);
                                                            const img = formStyle.getImage();
                                                            if (img && img.setStroke) img.setStroke(stroke);
                                                            updatePreview();
                                                        }
                                                    },
                                                    children: $2d246e081c968426$var$LINE_CAPS.map((v, k)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("option", {
                                                            value: v[0],
                                                            children: v[1]
                                                        }, k))
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Group, {
                                            children: [
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Label, {
                                                    children: "Style de ligne"
                                                }),
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Select, {
                                                    value: (()=>{
                                                        const stroke = formStyle.getStroke();
                                                        if (!stroke) return "solid";
                                                        const dash = stroke.getLineDash?.() || [
                                                            1
                                                        ];
                                                        if (dash.length === 2 && dash[0] === 0 && dash[1] === 10) return "dot";
                                                        if (dash.length === 1 && dash[0] === 10) return "dash";
                                                        if (dash.length === 3 && dash[0] === 10 && dash[1] === 0 && dash[2] === 10) return "dashdot";
                                                        if (dash.length === 1 && dash[0] === 30) return "longdash";
                                                        if (dash.length === 3 && dash[0] === 30 && dash[1] === 0 && dash[2] === 30) return "longdashdot";
                                                        return "solid";
                                                    })(),
                                                    onChange: (evt)=>{
                                                        let dash = [
                                                            1
                                                        ];
                                                        switch(evt.target.value){
                                                            case "dot":
                                                                dash = [
                                                                    0,
                                                                    10
                                                                ];
                                                                break;
                                                            case "dash":
                                                                dash = [
                                                                    10
                                                                ];
                                                                break;
                                                            case "dashdot":
                                                                dash = [
                                                                    10,
                                                                    0,
                                                                    10
                                                                ];
                                                                break;
                                                            case "longdash":
                                                                dash = [
                                                                    30
                                                                ];
                                                                break;
                                                            case "longdashdot":
                                                                dash = [
                                                                    30,
                                                                    0,
                                                                    30
                                                                ];
                                                                break;
                                                            default:
                                                                dash = [
                                                                    1
                                                                ];
                                                        }
                                                        const stroke = formStyle.getStroke();
                                                        if (stroke && stroke.setLineDash) {
                                                            stroke.setLineDash(dash);
                                                            const img = formStyle.getImage();
                                                            if (img && img.setStroke) img.setStroke(stroke);
                                                            updatePreview();
                                                        }
                                                    },
                                                    children: $2d246e081c968426$var$LINE_DASHES.map((v, k)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("option", {
                                                            value: v[0],
                                                            children: v[1]
                                                        }, k))
                                                })
                                            ]
                                        })
                                    ]
                                })
                            },
                            {
                                header: "Remplissage",
                                content: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Group, {
                                            children: [
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Label, {
                                                    children: "Couleur"
                                                }),
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Control, {
                                                    type: "color",
                                                    defaultValue: $2d246e081c968426$var$colorToHex(formStyle?.getFill()?.getColor()),
                                                    onChange: (evt)=>{
                                                        const fillColor = formStyle?.getFill()?.getColor();
                                                        let alpha = 1;
                                                        if (typeof fillColor === "string" || Array.isArray(fillColor)) alpha = (0, $ebac9d8363fa165e$export$75093a47a9fa838d)(fillColor)[3] ?? 1;
                                                        const newColor = (0, $ebac9d8363fa165e$export$590567be997858b6)((0, $ebac9d8363fa165e$export$75093a47a9fa838d)(evt.target.value).concat(alpha));
                                                        formStyle?.getFill()?.setColor(newColor);
                                                        formStyle?.getImage()?.setFill(formStyle?.getFill());
                                                        updatePreview();
                                                    }
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Group, {
                                            children: [
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Label, {
                                                    children: "Opacit\xe9"
                                                }),
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $fb281c3c0e7b8a11$export$2e2bcd8739ae039), {
                                                    min: 0,
                                                    max: 1,
                                                    step: 0.01,
                                                    defaultValue: (()=>{
                                                        const fillColor = formStyle?.getFill()?.getColor();
                                                        if (typeof fillColor === "string" || Array.isArray(fillColor)) return (0, $ebac9d8363fa165e$export$75093a47a9fa838d)(fillColor)[3] ?? 1;
                                                        // fallback for CanvasPattern/CanvasGradient or unknown
                                                        return 1;
                                                    })(),
                                                    onChange: (evt)=>{
                                                        const newColor = (0, $ebac9d8363fa165e$export$590567be997858b6)((()=>{
                                                            const fillColor = formStyle?.getFill()?.getColor();
                                                            if (typeof fillColor === "string" || Array.isArray(fillColor)) return (0, $ebac9d8363fa165e$export$75093a47a9fa838d)(fillColor ?? "#000000");
                                                            // fallback for CanvasPattern/CanvasGradient or unknown
                                                            return (0, $ebac9d8363fa165e$export$75093a47a9fa838d)("#000000");
                                                        })().slice(0, 3).concat(parseFloat(evt.target.value)));
                                                        formStyle?.getFill()?.setColor(newColor);
                                                        formStyle?.getImage()?.setFill(formStyle?.getFill());
                                                        updatePreview();
                                                    }
                                                })
                                            ]
                                        })
                                    ]
                                })
                            },
                            ...selectedFeatures.length > 0 ? [
                                {
                                    header: "Annotation",
                                    content: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Group, {
                                                children: [
                                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Label, {
                                                        children: "Texte"
                                                    }),
                                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Control, {
                                                        type: "text",
                                                        placeholder: "Texte",
                                                        defaultValue: formStyle?.getText()?.getText() ?? "",
                                                        onChange: (evt)=>{
                                                            const text = evt.target.value;
                                                            if (text) {
                                                                const existingText = formStyle.getText();
                                                                if (existingText) existingText.setText(text);
                                                                else formStyle.setText(new (0, $ee3bf0a2c13d7793$export$2e2bcd8739ae039)({
                                                                    text: text,
                                                                    font: "14px sans-serif",
                                                                    fill: new (0, $8624b871a0af6dab$export$2e2bcd8739ae039)({
                                                                        color: "#000000"
                                                                    }),
                                                                    stroke: new (0, $281691897fddf9d0$export$2e2bcd8739ae039)({
                                                                        color: "#ffffff",
                                                                        width: 3
                                                                    }),
                                                                    overflow: true
                                                                }));
                                                            } else formStyle.setText(new (0, $ee3bf0a2c13d7793$export$2e2bcd8739ae039)({
                                                                text: "",
                                                                font: "14px sans-serif",
                                                                fill: new (0, $8624b871a0af6dab$export$2e2bcd8739ae039)({
                                                                    color: "#000000"
                                                                }),
                                                                stroke: new (0, $281691897fddf9d0$export$2e2bcd8739ae039)({
                                                                    color: "#ffffff",
                                                                    width: 3
                                                                })
                                                            }));
                                                            updatePreview();
                                                        }
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Group, {
                                                children: [
                                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Label, {
                                                        children: "Taille"
                                                    }),
                                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $fb281c3c0e7b8a11$export$2e2bcd8739ae039), {
                                                        min: 8,
                                                        max: 72,
                                                        step: 1,
                                                        defaultValue: (()=>{
                                                            const font = formStyle?.getText()?.getFont();
                                                            if (font) {
                                                                const match = font.match(/(\d+)px/);
                                                                return match ? parseInt(match[1]) : 14;
                                                            }
                                                            return 14;
                                                        })(),
                                                        onChange: (evt)=>{
                                                            const size = parseInt(evt.target.value);
                                                            const existingText = formStyle.getText();
                                                            if (existingText) {
                                                                existingText.setFont(`${size}px sans-serif`);
                                                                updatePreview();
                                                            }
                                                        }
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Group, {
                                                children: [
                                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Label, {
                                                        children: "Couleur"
                                                    }),
                                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Control, {
                                                        type: "color",
                                                        defaultValue: $2d246e081c968426$var$colorToHex(formStyle?.getText()?.getFill()?.getColor()) || "#000000",
                                                        onChange: (evt)=>{
                                                            const existingText = formStyle.getText();
                                                            if (existingText) {
                                                                existingText.setFill(new (0, $8624b871a0af6dab$export$2e2bcd8739ae039)({
                                                                    color: evt.target.value
                                                                }));
                                                                updatePreview();
                                                            }
                                                        }
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }
                            ] : []
                        ],
                        handleShowClose: handleShowClose
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                        onClick: updateFeatureStyle,
                        children: "Appliquer"
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                        ref: previewRef,
                        style: {
                            width: "400px",
                            height: "400px"
                        }
                    })
                ]
            })
        ]
    });
};
$2d246e081c968426$var$MapToolbarCartographiePerso.displayName = "MapToolbarPerso";
var $2d246e081c968426$export$2e2bcd8739ae039 = $2d246e081c968426$var$MapToolbarCartographiePerso;



const $f7b9d2d9bb8fc3a8$var$createDefaultStyle = ()=>new (0, $a5fc261473972d1d$export$2e2bcd8739ae039)({
        fill: new (0, $8624b871a0af6dab$export$2e2bcd8739ae039)({
            color: "rgba(5, 176, 255, 1)"
        }),
        stroke: new (0, $281691897fddf9d0$export$2e2bcd8739ae039)({
            color: "rgba(5, 176, 255, 1)",
            width: 2,
            lineDash: [
                1
            ]
        }),
        image: new (0, $f060542c6e9f52e6$export$2e2bcd8739ae039)({
            radius: 7,
            fill: new (0, $8624b871a0af6dab$export$2e2bcd8739ae039)({
                color: "#00c3ffff"
            })
        })
    });
const $f7b9d2d9bb8fc3a8$var$MapCartographiePerso = ()=>{
    const now = new Date();
    const mapElement = (0, $kc00y.useRef)();
    const { map: map, workingLayer: workingLayer, availableLayers: availableLayers, addOrRemoveLayer: addOrRemoveLayer, showOutilI: showOutilI, layerListRef: layerListRef, mapToolbarRef: mapToolbarRef } = (0, $cdcdd8e1ff041f79$export$547f9c492d831282)({
        mapElement: mapElement,
        typeModule: (0, $a9754922f4c67d47$export$ef88b514e4bfff34).CARTOGRAPHIE_PERSONNALISEE
    });
    // Couche dédiée à la cartographie personnalisée. Toutes les formes seront ajoutées à cette couche.
    const cartographiePersoLayer = (0, $kc00y.useMemo)(()=>{
        if (map) {
            const wl = new (0, $082a79ecb622f84a$export$2e2bcd8739ae039)({
                source: new (0, $1020e4d07ddbfab1$export$2e2bcd8739ae039)(),
                style: $f7b9d2d9bb8fc3a8$var$createDefaultStyle(),
                opacity: 1,
                zIndex: 9000
            });
            map.addLayer(wl);
            return wl;
        }
    }, [
        map
    ]);
    // Lever l'état du style général ici
    const [featureStyle, setFeatureStyle] = (0, $kc00y.useState)(()=>$f7b9d2d9bb8fc3a8$var$createDefaultStyle());
    // Synchronise le style du layer à chaque changement du style général
    (0, $kc00y.useEffect)(()=>{
        if (cartographiePersoLayer && featureStyle) cartographiePersoLayer.setStyle(featureStyle.clone());
    }, [
        cartographiePersoLayer,
        featureStyle
    ]);
    const { tools: extraTools, selectedFeatures: selectedFeatures, setSelectedFeatures: setSelectedFeatures } = (0, $2d246e081c968426$export$39e67dd0a56ff3d6)({
        map: map,
        cartographiePersoLayer: cartographiePersoLayer,
        featureStyle: featureStyle,
        SetFeatureStyle: setFeatureStyle
    });
    const { toggleTool: toggleTool, activeTool: activeTool, infoOutilI: infoOutilI, handleCloseInfoI: handleCloseInfoI } = (0, $e2b798e23180fa76$export$194c7727cbdc0cac)({
        availableLayers: availableLayers,
        map: map,
        workingLayer: workingLayer,
        extraTools: extraTools
    });
    // Force le resize de la carte juste avant impression pour garantir le bon rendu
    (0, $kc00y.useEffect)(()=>{
        const handleBeforePrint = ()=>{
            if (map && typeof map.updateSize === "function") map.updateSize();
        };
        window.addEventListener("beforeprint", handleBeforePrint);
        return ()=>window.removeEventListener("beforeprint", handleBeforePrint);
    }, [
        map
    ]);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $a0064658a8399ad3$export$2e2bcd8739ae039), {
        navbar: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $5de16d9a2066fdee$export$2e2bcd8739ae039), {}),
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                style: {
                    marginBottom: "100px"
                },
                className: "noprint",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                    title: "Cartographie personnalis\xe9e",
                    icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$db5ab3e755729b3d), {}),
                    right: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                        variant: "primary",
                        onClick: ()=>{
                            window.print();
                        },
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$61207fb985d79449), {}),
                            " Imprimer"
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                id: "papersheet",
                className: "printable-no-margin mx-auto",
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("h1", {
                        contentEditable: "true",
                        children: "\u270E Titre de la carte"
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $cdcdd8e1ff041f79$export$2e2bcd8739ae039), {
                        map: map,
                        printable: true,
                        outilI: infoOutilI,
                        showOutilI: showOutilI,
                        handleCloseInfoI: handleCloseInfoI,
                        availableLayers: availableLayers,
                        addOrRemoveLayer: addOrRemoveLayer,
                        layerListRef: layerListRef,
                        mapToolbarRef: mapToolbarRef,
                        mapElement: mapElement,
                        toggleTool: toggleTool,
                        activeTool: activeTool,
                        toolbarElement: mapToolbarRef.current && cartographiePersoLayer && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2d246e081c968426$export$2e2bcd8739ae039), {
                            toggleTool: toggleTool,
                            activeTool: activeTool ?? undefined,
                            featureStyle: featureStyle,
                            setFeatureStyle: setFeatureStyle,
                            selectedFeatures: selectedFeatures,
                            setSelectedFeatures: setSelectedFeatures,
                            cartographiePersoLayer: cartographiePersoLayer,
                            tools: extraTools
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                        className: "map-footer",
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                className: "h-100 text-italic col-sm-auto",
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("p", {
                                    className: "text-nowrap",
                                    children: `\xc9dition r\xe9alis\xe9e le ${(0, $00c47c7740afd024$export$c74325cff954054e)(now)} \xe0 partir de ${window.location.origin + window.location.pathname}`
                                })
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("p", {
                                    className: "text-end text-nowrap",
                                    children: "Copyright \xa9 2015 SDIS 83"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $f7b9d2d9bb8fc3a8$export$2e2bcd8739ae039 = $f7b9d2d9bb8fc3a8$var$MapCartographiePerso;




var $bkJfK = parcelRequire("bkJfK");







const $adf8bb069e8339b8$export$a5cab80145b70e98 = ()=>({
        fileRisqueExpress: null,
        risqueLibelle: ""
    });
const $adf8bb069e8339b8$export$c084437b5e3206cd = (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({});
const $adf8bb069e8339b8$export$f97400759cfd946 = (values)=>{
    const formData = new FormData();
    if (values.fileRisqueExpress) formData.append("fileRisqueExpress", values.fileRisqueExpress);
    if (values.risqueLibelle) formData.append("risqueLibelle", values.risqueLibelle);
    return formData;
};
const $adf8bb069e8339b8$var$ImportRisqueExpress = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$c9bef5de7ad5da31), {}),
                title: "Importer un risque express"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                initialValues: $adf8bb069e8339b8$export$a5cab80145b70e98(),
                validationSchema: $adf8bb069e8339b8$export$c084437b5e3206cd,
                isPost: false,
                isMultipartFormData: true,
                submitUrl: `/api/risque/import/`,
                prepareVariables: (values)=>$adf8bb069e8339b8$export$f97400759cfd946(values),
                redirectUrl: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).RISQUE,
                onSubmit: ()=>null,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($adf8bb069e8339b8$var$FormImportRisqueExpress, {})
            })
        ]
    });
};
const $adf8bb069e8339b8$var$FormImportRisqueExpress = ()=>{
    const { setFieldValue: setFieldValue } = (0, $bkJfK.useFormikContext)();
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                name: "risqueLibelle",
                label: "Libell\xe9 du risque",
                required: false
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b57af79a4ab2a1c6), {
                name: "fileRisqueExpress",
                accept: ".kml",
                label: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
                    children: "Fichier KML contenant les g\xe9om\xe9tries \xe0 int\xe9grer"
                }),
                required: false,
                onChange: (e)=>setFieldValue("fileRisqueExpress", e.target.files[0])
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                className: "mt-3",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                    className: "text-center",
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                        type: "submit",
                        variant: "primary",
                        children: "Valider"
                    })
                })
            })
        ]
    });
};
var $adf8bb069e8339b8$export$2e2bcd8739ae039 = $adf8bb069e8339b8$var$ImportRisqueExpress;




var $kc00y = parcelRequire("kc00y");
















const $b0ba16595e31db33$var$MapRisque = ()=>{
    const { user: user } = (0, $e787cde576104469$export$fdc397e486fa83e7)();
    const mapElement = (0, $kc00y.useRef)();
    const paramPeiFicheResumeStandalone = (0, $ee297f06e8568bf4$export$2e2bcd8739ae039).PEI_FICHE_RESUME_STANDALONE;
    const parametresState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/parametres?${{
        listeParametreCode: JSON.stringify(paramPeiFicheResumeStandalone)
    }}`, {});
    const isFicheResumeStandalone = (0, $kc00y.useMemo)(()=>{
        if (!parametresState.isResolved) return false;
        return JSON.parse(parametresState?.data[paramPeiFicheResumeStandalone].parametreValeur);
    }, [
        parametresState
    ]);
    const { map: map, availableLayers: availableLayers, addOrRemoveLayer: addOrRemoveLayer, workingLayer: workingLayer, showOutilI: showOutilI, layerListRef: layerListRef, mapToolbarRef: mapToolbarRef } = (0, $cdcdd8e1ff041f79$export$547f9c492d831282)({
        mapElement: mapElement,
        typeModule: (0, $a9754922f4c67d47$export$ef88b514e4bfff34).RISQUES,
        displayPei: true
    });
    const { toggleTool: toggleTool, activeTool: activeTool, infoOutilI: infoOutilI, handleCloseInfoI: handleCloseInfoI } = (0, $e2b798e23180fa76$export$194c7727cbdc0cac)({
        availableLayers: availableLayers,
        map: map,
        workingLayer: workingLayer,
        extraTools: {}
    });
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $a0064658a8399ad3$export$2e2bcd8739ae039), {
        navbar: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $5de16d9a2066fdee$export$2e2bcd8739ae039), {}),
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                title: "Carte des Risques",
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$926c029a160f0d15), {}),
                right: (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).RISQUE_EXPRESS_A) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8ad69b89456b65bc$export$2e2bcd8739ae039), {
                    href: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).IMPORT_RISQUE_EXPRESS,
                    title: "Importer un risque express"
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $cdcdd8e1ff041f79$export$2e2bcd8739ae039), {
                outilI: infoOutilI,
                showOutilI: showOutilI,
                handleCloseInfoI: handleCloseInfoI,
                map: map,
                availableLayers: availableLayers,
                addOrRemoveLayer: addOrRemoveLayer,
                layerListRef: layerListRef,
                mapToolbarRef: mapToolbarRef,
                mapElement: mapElement,
                toggleTool: toggleTool,
                activeTool: activeTool,
                toolbarElement: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b0759c348c3ed98d$export$d948e7b8d50e3806), {
                    map: map,
                    displayButtonSeeFichePei: !user || isFicheResumeStandalone
                })
            })
        ]
    });
};
var $b0ba16595e31db33$export$2e2bcd8739ae039 = $b0ba16595e31db33$var$MapRisque;








var $kc00y = parcelRequire("kc00y");














var $kc00y = parcelRequire("kc00y");


/**
 * Enumération définissant les types de géométrie
 */ var $72e886a1223521a1$var$SOUS_TYPE_TYPE_GEOMETRIE = /*#__PURE__*/ function(SOUS_TYPE_TYPE_GEOMETRIE) {
    SOUS_TYPE_TYPE_GEOMETRIE["POINT"] = "POINT";
    SOUS_TYPE_TYPE_GEOMETRIE["POLYGON"] = "POLYGON";
    SOUS_TYPE_TYPE_GEOMETRIE["LINESTRING"] = "LINESTRING";
    return SOUS_TYPE_TYPE_GEOMETRIE;
}($72e886a1223521a1$var$SOUS_TYPE_TYPE_GEOMETRIE || {});
var $72e886a1223521a1$export$2e2bcd8739ae039 = $72e886a1223521a1$var$SOUS_TYPE_TYPE_GEOMETRIE;
const $72e886a1223521a1$export$36d781030bd6db16 = [
    {
        id: "POINT",
        code: "POINT",
        libelle: "Point"
    },
    {
        id: "POLYGON",
        code: "POLYGON",
        libelle: "Polygone"
    },
    {
        id: "LINESTRING",
        code: "LINESTRING",
        libelle: "Ligne"
    }
];






var $kc00y = parcelRequire("kc00y");



const $a01bad5522a0e28b$var$CreateElementSignalement = ({ onClick: onClick, geometryString: geometryString, srid: srid, sousTypeElement: sousTypeElement })=>{
    const anomalies = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/signalements/type-anomalie`)?.data;
    const [signalementElement, setSignalementElement] = (0, $kc00y.useState)({
        geometryString: geometryString,
        anomalies: [],
        description: null,
        srid: srid,
        sousType: sousTypeElement
    });
    return anomalies && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039), {
        children: [
            anomalies.map((anomalie)=>{
                return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Check, {
                        type: "switch",
                        label: anomalie.signalementTypeAnomalieLibelle,
                        id: "checkbox" + anomalie.signalementTypeAnomalieCode,
                        onChange: (event)=>{
                            const checked = event.currentTarget.checked;
                            if (checked) {
                                const tableauAnomalie = [
                                    ...signalementElement.anomalies,
                                    anomalie.signalementTypeAnomalieCode
                                ];
                                setSignalementElement((data)=>({
                                        ...data,
                                        anomalies: tableauAnomalie.filter((item, pos)=>tableauAnomalie.indexOf(item) === pos)
                                    }));
                            } else setSignalementElement((data)=>({
                                    ...data,
                                    anomalies: data.anomalies.filter((e)=>e !== anomalie.signalementTypeAnomalieCode)
                                }));
                        }
                    })
                });
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $64fb4d6c077c0e42$export$2e2bcd8739ae039), {
                controlId: "textarea",
                label: "Description",
                className: "mb-3 text-muted",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Control, {
                    as: "textarea",
                    placeholder: "Description",
                    id: "textarea",
                    style: {
                        height: "100px"
                    },
                    onChange: (event)=>{
                        setSignalementElement((data)=>({
                                ...data,
                                description: event.target.value
                            }));
                    }
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                onClick: ()=>onClick(signalementElement),
                children: "Valider"
            })
        ]
    });
};
var $a01bad5522a0e28b$export$2e2bcd8739ae039 = $a01bad5522a0e28b$var$CreateElementSignalement;




var $bkJfK = parcelRequire("bkJfK");






const $517c2443e8ddfae6$var$Signalement = ({ listeElement: listeElement, typeWithSousType: typeWithSousType })=>{
    const listeAnomalie = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/signalements/type-anomalie`)?.data;
    const listeSousType = typeWithSousType.flatMap((type)=>type.listSousType);
    const { setFieldValue: setFieldValue, values: values } = (0, $bkJfK.useFormikContext)();
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("h3", {
                children: "R\xe9capitulatif des \xe9l\xe9ments du signalement"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $69c77a5b3889bd0f$export$2e2bcd8739ae039), {
                alwaysOpen: true,
                children: listeElement.map((e, index)=>{
                    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $69c77a5b3889bd0f$export$2e2bcd8739ae039).Item, {
                            eventKey: index.toString(),
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $69c77a5b3889bd0f$export$2e2bcd8739ae039).Header, {
                                    children: listeSousType.find((sousType)=>sousType.signalementSousTypeElementId === e.sousType).signalementSousTypeElementLibelle
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $69c77a5b3889bd0f$export$2e2bcd8739ae039).Body, {
                                    children: [
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                            className: "fw-bold",
                                            children: "Anomalies"
                                        }),
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("ul", {
                                                    children: e.anomalies.map((anomalie, key)=>{
                                                        return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("li", {
                                                            children: listeAnomalie?.find((ano)=>anomalie === ano.signalementTypeAnomalieCode).signalementTypeAnomalieLibelle
                                                        }, key);
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                            className: "fw-bold",
                                            children: "Description"
                                        }),
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                                children: e.description
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    });
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$ce9b1cc0c34506d0), {
                                name: "description",
                                label: "Description",
                                required: false
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("h3", {
                                className: "mt-5",
                                children: "Document"
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $69d686b1e97c5ea6$export$2e2bcd8739ae039), {
                                documents: values.documents ?? [],
                                setFieldValue: setFieldValue,
                                otherFormParam: (index)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                                        label: "Nom",
                                        name: `documents[${index}].documentLibelle`,
                                        required: false
                                    }),
                                defaultOtherProperties: {
                                    documentLibelle: null
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db9b0e6fdb142a4c$export$2e2bcd8739ae039), {
                                returnLink: false
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var $517c2443e8ddfae6$export$2e2bcd8739ae039 = $517c2443e8ddfae6$var$Signalement;












const $066cce8b2cdc7aed$var$defaultStyle = new (0, $a5fc261473972d1d$export$2e2bcd8739ae039)({
    fill: new (0, $8624b871a0af6dab$export$2e2bcd8739ae039)({
        color: "#64C0FFFF"
    }),
    stroke: new (0, $281691897fddf9d0$export$2e2bcd8739ae039)({
        color: "#64C0FFFF",
        width: 2
    }),
    image: new (0, $f060542c6e9f52e6$export$2e2bcd8739ae039)({
        radius: 5,
        stroke: new (0, $281691897fddf9d0$export$2e2bcd8739ae039)({
            color: "#64C0FFFF"
        }),
        fill: new (0, $8624b871a0af6dab$export$2e2bcd8739ae039)({
            color: "#64C0FFFF"
        })
    })
});
const $066cce8b2cdc7aed$export$c16bc57577892999 = ({ map: map, cartographieSignalementLayer: cartographieSignalementLayer })=>{
    const [featureStyle, setFeatureStyle] = (0, $kc00y.useState)($066cce8b2cdc7aed$var$defaultStyle);
    const [selectedFeatures, setSelectedFeatures] = (0, $kc00y.useState)([]);
    const [showCreateElement, setShowCreateElement] = (0, $kc00y.useState)(false);
    const [sousTypeElement, setSousTypeElement] = (0, $kc00y.useState)(null);
    const [listSignalementElement, setListSignalementElement] = (0, $kc00y.useState)([]);
    const [showCreateSignalement, setShowCreateSignalement] = (0, $kc00y.useState)(false);
    const [geometryElement, setGeometryElement] = (0, $kc00y.useState)(null);
    const handleCloseSignalement = ()=>{
        setShowCreateSignalement(false);
    };
    const handleCloseElement = ()=>{
        cartographieSignalementLayer.getSource()?.removeFeature(cartographieSignalementLayer.getSource()?.getFeatures()?.[cartographieSignalementLayer.getSource().getFeatures().length - 1]);
        setShowCreateElement(false);
    };
    function supprimerFeature() {
        if (selectedFeatures.length > 0) {
            // Suppression de l'objet visible
            selectedFeatures.forEach((f)=>{
                cartographieSignalementLayer.getSource()?.removeFeature(f);
            });
            // Suppression de l'objet passé au formulaire
            setListSignalementElement((prevList)=>prevList.filter((signalement)=>!selectedFeatures.some((feature)=>new (0, $15a985d09649bdc2$export$2e2bcd8739ae039)().writeFeature(feature) === signalement.geometryString)));
        }
    }
    const tools = (0, $kc00y.useMemo)(()=>{
        if (!map) return {};
        const wkt = new (0, $15a985d09649bdc2$export$2e2bcd8739ae039)();
        const drawPointCtrl = new (0, $2ef894158a48397d$export$2e2bcd8739ae039)({
            source: cartographieSignalementLayer.getSource(),
            type: "Point"
        });
        const drawLineCtrl = new (0, $2ef894158a48397d$export$2e2bcd8739ae039)({
            source: cartographieSignalementLayer.getSource(),
            type: "LineString"
        });
        const drawShapeCtrl = new (0, $2ef894158a48397d$export$2e2bcd8739ae039)({
            source: cartographieSignalementLayer.getSource(),
            type: "Polygon"
        });
        const handleDrawEnd = (event)=>{
            setGeometryElement(wkt.writeFeature(event.feature));
            setShowCreateElement(true);
            event.feature.setStyle(featureStyle.clone());
        };
        drawPointCtrl.on("drawend", handleDrawEnd);
        drawLineCtrl.on("drawend", handleDrawEnd);
        drawShapeCtrl.on("drawend", handleDrawEnd);
        const selectCtrl = new (0, $20af4deb83586389$export$2e2bcd8739ae039)({
            layers: [
                cartographieSignalementLayer
            ],
            toggleCondition: (0, $638912a122b4daef$export$f3100d8d6292d638)
        });
        const dragBoxCtrl = new (0, $886371f562c99b97$export$2e2bcd8739ae039)({
            style: new (0, $a5fc261473972d1d$export$2e2bcd8739ae039)({
                stroke: new (0, $281691897fddf9d0$export$2e2bcd8739ae039)({
                    color: [
                        0,
                        0,
                        255,
                        1
                    ]
                })
            }),
            minArea: 25
        });
        dragBoxCtrl.on("boxend", function(e) {
            const selectedCtrlFeatures = selectCtrl.getFeatures().getArray();
            if (!(0, $638912a122b4daef$export$f3100d8d6292d638)(e.mapBrowserEvent)) selectCtrl.getFeatures().clear();
            selectCtrl.getFeatures().extend(cartographieSignalementLayer?.getSource()?.getFeaturesInExtent(dragBoxCtrl.getGeometry().getExtent()) ?? []);
            if (selectedCtrlFeatures.length > 0) setSelectedFeatures(selectedCtrlFeatures);
            else setSelectedFeatures([]);
        });
        function toggleSelectDraw(active = false) {
            const idx1 = map?.getInteractions().getArray().indexOf(selectCtrl);
            const idx2 = map?.getInteractions().getArray().indexOf(dragBoxCtrl);
            if (active) {
                if (idx1 === -1 && idx2 === -1) {
                    map.addInteraction(selectCtrl);
                    map.addInteraction(dragBoxCtrl);
                    if (selectCtrl.getFeatures().getArray().length !== selectedFeatures.length) setSelectedFeatures(selectCtrl.getFeatures().getArray());
                }
            } else {
                map.removeInteraction(selectCtrl);
                map.removeInteraction(dragBoxCtrl);
                setSelectedFeatures([]);
            }
        }
        function toggleCtrl(active, ctrl) {
            const idx = map?.getInteractions().getArray().indexOf(ctrl);
            if (active) {
                if (idx === -1) {
                    map.addInteraction(ctrl);
                    if (selectCtrl.getFeatures().getArray().length !== selectedFeatures.length) setSelectedFeatures(selectCtrl.getFeatures().getArray());
                }
            } else map.removeInteraction(ctrl);
        }
        function toggleDrawPoint(active = false) {
            toggleCtrl(active, drawPointCtrl);
        }
        function toggleDrawLine(active = false) {
            toggleCtrl(active, drawLineCtrl);
        }
        function toggleDrawShape(active = false) {
            toggleCtrl(active, drawShapeCtrl);
        }
        const tools = {
            "select-draw": {
                action: toggleSelectDraw,
                actionPossibleEnDeplacement: false
            },
            "draw-point": {
                action: toggleDrawPoint
            },
            "draw-linestring": {
                action: toggleDrawLine
            },
            "draw-polygon": {
                action: toggleDrawShape
            }
        };
        return tools;
    }, [
        map,
        cartographieSignalementLayer,
        featureStyle.clone,
        selectedFeatures.length
    ]);
    return {
        tools: tools,
        featureStyle: featureStyle,
        setFeatureStyle: setFeatureStyle,
        selectedFeatures: selectedFeatures,
        setSousTypeElement: setSousTypeElement,
        supprimerFeature: supprimerFeature,
        listSignalementElement: listSignalementElement,
        setShowCreateSignalement: setShowCreateSignalement,
        handleCloseElement: handleCloseElement,
        showCreateElement: showCreateElement,
        setListSignalementElement: setListSignalementElement,
        sousTypeElement: sousTypeElement,
        setShowCreateElement: setShowCreateElement,
        geometryElement: geometryElement,
        handleCloseSignalement: handleCloseSignalement,
        showCreateSignalement: showCreateSignalement
    };
};
const $066cce8b2cdc7aed$var$MapToolbarSignalement = ({ map: map, toggleTool: toggleToolCallback, activeTool: activeTool, selectedFeatures: selectedFeatures, cartographieSignalementLayer: cartographieSignalementLayer, setSousTypeElement: setSousTypeElement, supprimerFeature: supprimerFeature, listSignalementElement: listSignalementElement, setShowCreateSignalement: setShowCreateSignalement, handleCloseElement: handleCloseElement, showCreateElement: showCreateElement, setListSignalementElement: setListSignalementElement, sousTypeElement: sousTypeElement, setShowCreateElement: setShowCreateElement, geometryElement: geometryElement, dataSignalementLayer: dataSignalementLayer, handleCloseSignalement: handleCloseSignalement, showCreateSignalement: showCreateSignalement })=>{
    const typeWithSousType = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/signalements/type-sous-type`)?.data;
    return typeWithSousType && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                xs: "auto",
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1ac4483a0721609f$export$2e2bcd8739ae039), {
                        codeThematique: (0, $690fed8fd87ee1b4$export$2e2bcd8739ae039).SIGNALEMENT,
                        titreVolet: "Liste des documents li\xe9s aux signalements"
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $f2eef644ac9323e0$export$2e2bcd8739ae039), {
                        toolName: "select-draw",
                        toolIcon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$249df474ea45aebc), {}),
                        toolLabelTooltip: "S\xe9lectionner des \xe9l\xe9ments (non valid\xe9s uniquement)",
                        toggleTool: toggleToolCallback,
                        activeTool: activeTool
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                        tooltipId: "suppressionSignalement",
                        tooltipText: selectedFeatures.length === 0 ? "Aucun \xe9l\xe9ment s\xe9lectionn\xe9" : "Supprimer le(s) " + selectedFeatures.length + "\xe9l\xe9ment(s) s\xe9lectionn\xe9(s)",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                            variant: "outline-danger",
                            onClick: supprimerFeature,
                            disabled: selectedFeatures.length === 0,
                            className: "m-2",
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$4d4e10ce882b8153), {})
                        })
                    }),
                    typeWithSousType?.map((e)=>{
                        return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $943025b58510539f$export$2e2bcd8739ae039), {
                            className: "py-2 d-flex align-items-center gap-2",
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $943025b58510539f$export$2e2bcd8739ae039).Toggle, {
                                    id: "dropdown-" + e.signalementTypeElementCode,
                                    children: e.signalementTypeElementLibelle?.toString()
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $943025b58510539f$export$2e2bcd8739ae039).Menu, {
                                    children: e.listSousType.map((soustype, key)=>{
                                        let icon;
                                        switch(soustype.signalementSousTypeElementTypeGeom){
                                            case (0, $72e886a1223521a1$export$2e2bcd8739ae039).POINT:
                                                icon = /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$fc789d8a435194dc), {});
                                                break;
                                            case (0, $72e886a1223521a1$export$2e2bcd8739ae039).LINESTRING:
                                                icon = /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$365092c6388045c9), {});
                                                break;
                                            case (0, $72e886a1223521a1$export$2e2bcd8739ae039).POLYGON:
                                                icon = /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$fa5eb5b4918005e3), {});
                                                break;
                                        }
                                        return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $943025b58510539f$export$2e2bcd8739ae039).Item, {
                                            onClick: ()=>{
                                                toggleToolCallback("draw-" + soustype.signalementSousTypeElementTypeGeom.toLowerCase());
                                                setSousTypeElement(soustype.signalementSousTypeElementId);
                                            },
                                            children: [
                                                icon,
                                                " ",
                                                soustype?.signalementSousTypeElementLibelle
                                            ]
                                        }, key);
                                    })
                                })
                            ]
                        }, e.signalementTypeElementCode);
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                        className: "m-2",
                        onClick: ()=>setShowCreateSignalement(true),
                        disabled: listSignalementElement?.length <= 0,
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$d776d19dfae66ece), {}),
                            " Ajouter un signalement"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1eee265537f042a4$export$2e2bcd8739ae039), {
                handleClose: handleCloseElement,
                show: showCreateElement,
                className: "w-auto",
                backdrop: true,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $a01bad5522a0e28b$export$2e2bcd8739ae039), {
                    srid: map?.getView()?.getProjection()?.getCode()?.split(":").pop() ?? "",
                    layer: cartographieSignalementLayer,
                    geometryString: geometryElement,
                    onClick: (element)=>{
                        setListSignalementElement((data)=>{
                            return [
                                ...data,
                                element
                            ];
                        });
                        dataSignalementLayer?.getSource()?.refresh();
                        (0, $1ed1be1197ad1bc4$export$51ba454167fb25ab)(map);
                        setShowCreateElement(false);
                    },
                    sousTypeElement: sousTypeElement
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1eee265537f042a4$export$2e2bcd8739ae039), {
                handleClose: handleCloseSignalement,
                show: showCreateSignalement,
                className: "w-auto",
                backdrop: true,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                    initialValues: $066cce8b2cdc7aed$export$a5cab80145b70e98(listSignalementElement),
                    validationSchema: $066cce8b2cdc7aed$export$c084437b5e3206cd,
                    isPost: true,
                    isMultipartFormData: true,
                    submitUrl: `/api/signalements/create`,
                    prepareVariables: (values)=>$066cce8b2cdc7aed$export$f97400759cfd946(values),
                    onSubmit: ()=>{
                        dataSignalementLayer.getSource().refresh();
                        (0, $1ed1be1197ad1bc4$export$51ba454167fb25ab)(map);
                        setListSignalementElement([]);
                        cartographieSignalementLayer?.getSource()?.clear();
                        setShowCreateSignalement(false);
                    },
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $517c2443e8ddfae6$export$2e2bcd8739ae039), {
                        listeElement: listSignalementElement,
                        typeWithSousType: typeWithSousType
                    })
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b0759c348c3ed98d$export$b8624bc36b7db2ab), {
                map: map
            })
        ]
    });
};
const $066cce8b2cdc7aed$export$c084437b5e3206cd = (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({});
const $066cce8b2cdc7aed$export$f97400759cfd946 = (values)=>{
    const formData = new FormData();
    (0, $69d686b1e97c5ea6$export$3f0f08502708410b)(values?.documents ?? [], [], formData);
    if (values.description !== undefined) formData.append("description", values.description);
    formData.append("listSignalementElement", JSON.stringify(values.listSignalementElement.map((el)=>({
            geometry: {
                wkt: el.geometryString,
                srid: el.srid
            },
            anomalies: el.anomalies,
            description: el.description,
            sousType: el.sousType
        }))));
    return formData;
};
const $066cce8b2cdc7aed$export$a5cab80145b70e98 = (listSignalementElement)=>({
        listSignalementElement: listSignalementElement
    });
$066cce8b2cdc7aed$var$MapToolbarSignalement.displayName = "MapToolbarSignalement2";
var $066cce8b2cdc7aed$export$2e2bcd8739ae039 = $066cce8b2cdc7aed$var$MapToolbarSignalement;


const $c30e76b968281c68$var$MapSignalement = ()=>{
    const mapElement = (0, $kc00y.useRef)();
    const { map: map, workingLayer: workingLayer, availableLayers: availableLayers, addOrRemoveLayer: addOrRemoveLayer, layerListRef: layerListRef, showOutilI: showOutilI, mapToolbarRef: mapToolbarRef, projection: projection } = (0, $cdcdd8e1ff041f79$export$547f9c492d831282)({
        mapElement: mapElement,
        displayPei: false,
        typeModule: (0, $a9754922f4c67d47$export$ef88b514e4bfff34).SIGNALEMENTS
    });
    const dataSignalementLayer = (0, $kc00y.useMemo)(()=>{
        if (!map) return;
        return (0, $1ed1be1197ad1bc4$export$a3178456480ccf5b)(map, (extent, projection)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/signalements/layer?bbox=` + extent.join(",") + "&srid=" + projection.getCode(), projection);
    }, [
        map,
        projection
    ]);
    const cartographieSignalementLayer = (0, $kc00y.useMemo)(()=>{
        if (map) {
            const wl = new (0, $082a79ecb622f84a$export$2e2bcd8739ae039)({
                source: new (0, $1020e4d07ddbfab1$export$2e2bcd8739ae039)(),
                style: ()=>{
                    return new (0, $a5fc261473972d1d$export$2e2bcd8739ae039)({
                        fill: new (0, $8624b871a0af6dab$export$2e2bcd8739ae039)({
                            color: "rgba(5, 176, 255, 1)"
                        }),
                        stroke: new (0, $281691897fddf9d0$export$2e2bcd8739ae039)({
                            color: "rgba(5, 176, 255, 1)",
                            width: 2
                        }),
                        image: new (0, $f060542c6e9f52e6$export$2e2bcd8739ae039)({
                            radius: 7,
                            fill: new (0, $8624b871a0af6dab$export$2e2bcd8739ae039)({
                                color: "#00c3ffff"
                            })
                        })
                    });
                },
                opacity: 1,
                zIndex: 9000
            });
            map.addLayer(wl);
            return wl;
        }
    }, [
        map
    ]);
    const { tools: extraTools, featureStyle: featureStyle, setFeatureStyle: setFeatureStyle, selectedFeatures: selectedFeatures, setSousTypeElement: setSousTypeElement, supprimerFeature: supprimerFeature, listSignalementElement: listSignalementElement, setShowCreateSignalement: setShowCreateSignalement, handleCloseElement: handleCloseElement, showCreateElement: showCreateElement, setListSignalementElement: setListSignalementElement, sousTypeElement: sousTypeElement, setShowCreateElement: setShowCreateElement, geometryElement: geometryElement, handleCloseSignalement: handleCloseSignalement, showCreateSignalement: showCreateSignalement } = (0, $066cce8b2cdc7aed$export$c16bc57577892999)({
        map: map,
        cartographieSignalementLayer: cartographieSignalementLayer
    });
    const { toggleTool: toggleTool, activeTool: activeTool, infoOutilI: infoOutilI, handleCloseInfoI: handleCloseInfoI } = (0, $e2b798e23180fa76$export$194c7727cbdc0cac)({
        availableLayers: availableLayers,
        map: map,
        workingLayer: workingLayer,
        extraTools: extraTools
    });
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                title: "Carte des signalements",
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$6ba70f07963961ce), {})
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $cdcdd8e1ff041f79$export$2e2bcd8739ae039), {
                map: map,
                showOutilI: showOutilI,
                availableLayers: availableLayers,
                addOrRemoveLayer: addOrRemoveLayer,
                layerListRef: layerListRef,
                mapToolbarRef: mapToolbarRef,
                outilI: infoOutilI,
                handleCloseInfoI: handleCloseInfoI,
                mapElement: mapElement,
                toggleTool: toggleTool,
                activeTool: activeTool,
                toolbarElement: mapToolbarRef.current && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $066cce8b2cdc7aed$export$2e2bcd8739ae039), {
                    map: map,
                    toggleTool: toggleTool,
                    activeTool: activeTool,
                    featureStyle: featureStyle,
                    setFeatureStyle: setFeatureStyle,
                    selectedFeatures: selectedFeatures,
                    setSousTypeElement: setSousTypeElement,
                    supprimerFeature: supprimerFeature,
                    listSignalementElement: listSignalementElement,
                    setShowCreateSignalement: setShowCreateSignalement,
                    handleCloseElement: handleCloseElement,
                    showCreateElement: showCreateElement,
                    setListSignalementElement: setListSignalementElement,
                    sousTypeElement: sousTypeElement,
                    setShowCreateElement: setShowCreateElement,
                    geometryElement: geometryElement,
                    dataSignalementLayer: dataSignalementLayer,
                    handleCloseSignalement: handleCloseSignalement,
                    showCreateSignalement: showCreateSignalement,
                    cartographieSignalementLayer: cartographieSignalementLayer
                })
            })
        ]
    });
};
var $c30e76b968281c68$export$2e2bcd8739ae039 = $c30e76b968281c68$var$MapSignalement;










const $239f06cc878a10d1$var$ModuleAdmin = ()=>{
    const { user: user } = (0, $e787cde576104469$export$fdc397e486fa83e7)();
    const navLinks = [
        {
            path: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).MODULE_ADMIN,
            label: "Administrer",
            aLeDroit: (0, $e3b8d60f4bb99483$export$4f612ab7b7b1d133)(user, Object.values((0, $7680c94ec9779ccd$export$2e2bcd8739ae039)))
        }
    ];
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $a0064658a8399ad3$export$2e2bcd8739ae039), {
        navbar: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $5de16d9a2066fdee$export$2e2bcd8739ae039), {
            links: navLinks
        }),
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $7a844823b04d4282$export$910ae8079b2c2852), {})
    });
};
var $239f06cc878a10d1$export$2e2bcd8739ae039 = $239f06cc878a10d1$var$ModuleAdmin;










const $393dcc074d501912$var$ModuleCouvertureHydraulique = ()=>{
    const { user: user } = (0, $e787cde576104469$export$fdc397e486fa83e7)();
    const navLinks = [
        {
            path: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_ETUDE,
            label: "Liste des \xe9tudes",
            aLeDroit: (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ETUDE_R)
        }
    ];
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $a0064658a8399ad3$export$2e2bcd8739ae039), {
        navbar: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $5de16d9a2066fdee$export$2e2bcd8739ae039), {
            links: navLinks
        }),
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $7a844823b04d4282$export$910ae8079b2c2852), {})
    });
};
var $393dcc074d501912$export$2e2bcd8739ae039 = $393dcc074d501912$var$ModuleCouvertureHydraulique;










const $b7f47f02986a78ec$var$ModuleCrise = ()=>{
    const { user: user } = (0, $e787cde576104469$export$fdc397e486fa83e7)();
    const navLinks = [
        {
            path: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_CRISES,
            label: "Liste des crises",
            aLeDroit: (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).CRISE_R)
        }
    ];
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $a0064658a8399ad3$export$2e2bcd8739ae039), {
        navbar: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $5de16d9a2066fdee$export$2e2bcd8739ae039), {
            links: navLinks
        }),
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $7a844823b04d4282$export$910ae8079b2c2852), {})
    });
};
var $b7f47f02986a78ec$export$2e2bcd8739ae039 = $b7f47f02986a78ec$var$ModuleCrise;











const $2d36968a38c909a2$var$ModuleDeci = ()=>{
    const { user: user } = (0, $e787cde576104469$export$fdc397e486fa83e7)();
    const navLinks = [
        {
            path: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).ACCES_RAPIDE,
            label: "Acc\xe8s rapide",
            aLeDroit: (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).PEI_R)
        },
        {
            path: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).PEI,
            label: "Points d'eau",
            aLeDroit: (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).PEI_R)
        },
        {
            path: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_TOURNEE,
            label: "Tourn\xe9es",
            aLeDroit: (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).TOURNEE_R)
        },
        {
            path: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_INDISPONIBILITE_TEMPORAIRE,
            label: "Indisponibilit\xe9s temporaires",
            aLeDroit: (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).INDISPO_TEMP_R)
        },
        {
            path: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).DECI_CARTE,
            label: "Carte",
            aLeDroit: true
        },
        {
            path: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).GENERER_COURRIER((0, $a9754922f4c67d47$export$ef88b514e4bfff34).DECI),
            label: "G\xe9n\xe9rer un courrier",
            aLeDroit: (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).COURRIER_C)
        }
    ];
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $a0064658a8399ad3$export$2e2bcd8739ae039), {
        navbar: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $5de16d9a2066fdee$export$2e2bcd8739ae039), {
            links: navLinks
        }),
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $7a844823b04d4282$export$910ae8079b2c2852), {})
    });
};
var $2d36968a38c909a2$export$2e2bcd8739ae039 = $2d36968a38c909a2$var$ModuleDeci;










const $decbf64d15de7bd5$var$ModuleOldeb = ()=>{
    const { user: user } = (0, $e787cde576104469$export$fdc397e486fa83e7)();
    const navLinks = [
        {
            path: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).OLDEB_ACCES_RAPIDE,
            label: "Acc\xe8s rapide",
            aLeDroit: (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).OLDEB_C) || (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).OLDEB_D) || (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).OLDEB_R) || (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).OLDEB_U)
        },
        {
            path: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).OLDEB_LOCALISATION,
            label: "Localisation",
            aLeDroit: (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).OLDEB_C) || (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).OLDEB_D) || (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).OLDEB_R) || (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).OLDEB_U)
        },
        {
            path: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).OLDEB_LIST,
            label: "Obligations l\xe9gales",
            aLeDroit: (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).OLDEB_C) || (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).OLDEB_D) || (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).OLDEB_R) || (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).OLDEB_U)
        },
        {
            path: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).OLDEB_PROPRIETAIRE_LIST,
            label: "Propri\xe9taires",
            aLeDroit: (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).OLDEB_C) || (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).OLDEB_D) || (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).OLDEB_R) || (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).OLDEB_U)
        }
    ];
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $a0064658a8399ad3$export$2e2bcd8739ae039), {
        navbar: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $5de16d9a2066fdee$export$2e2bcd8739ae039), {
            links: navLinks
        }),
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $7a844823b04d4282$export$910ae8079b2c2852), {})
    });
};
var $decbf64d15de7bd5$export$2e2bcd8739ae039 = $decbf64d15de7bd5$var$ModuleOldeb;










const $6e6d9adb8fee06b8$var$ModuleOperationsDiverses = ()=>{
    const { user: user } = (0, $e787cde576104469$export$fdc397e486fa83e7)();
    const navLinks = [
        {
            path: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).HISTORIQUE_OPERATIONS,
            label: "Historique des op\xe9rations",
            aLeDroit: (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).OPERATIONS_DIVERSES_E)
        },
        {
            path: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).RESULTATS_EXECUTION,
            label: "R\xe9sultats d'ex\xe9cutions",
            aLeDroit: (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).OPERATIONS_DIVERSES_E)
        }
    ];
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $a0064658a8399ad3$export$2e2bcd8739ae039), {
        fluid: false,
        navbar: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $5de16d9a2066fdee$export$2e2bcd8739ae039), {
            links: navLinks
        }),
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $7a844823b04d4282$export$910ae8079b2c2852), {})
    });
};
var $6e6d9adb8fee06b8$export$2e2bcd8739ae039 = $6e6d9adb8fee06b8$var$ModuleOperationsDiverses;










const $cc1ad355e9f5383d$var$ModuleRapportPersonnalise = ()=>{
    const { user: user } = (0, $e787cde576104469$export$fdc397e486fa83e7)();
    const navLinks = [
        {
            path: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).EXECUTER_RAPPORT_PERSONNALISE,
            label: "Ex\xe9cuter des rapports personnalis\xe9s",
            aLeDroit: (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).RAPPORT_PERSONNALISE_E)
        }
    ];
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $a0064658a8399ad3$export$2e2bcd8739ae039), {
        fluid: true,
        navbar: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $5de16d9a2066fdee$export$2e2bcd8739ae039), {
            links: navLinks
        }),
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $7a844823b04d4282$export$910ae8079b2c2852), {})
    });
};
var $cc1ad355e9f5383d$export$2e2bcd8739ae039 = $cc1ad355e9f5383d$var$ModuleRapportPersonnalise;







const $9556e76e51bd2389$var$ModuleRcci = ()=>{
    const navLinks = [
        {
            path: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).RCCI_MAP,
            label: "Carte des d\xe9parts de feu"
        }
    ];
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $a0064658a8399ad3$export$2e2bcd8739ae039), {
        navbar: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $5de16d9a2066fdee$export$2e2bcd8739ae039), {
            links: navLinks
        }),
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $7a844823b04d4282$export$910ae8079b2c2852), {})
    });
};
var $9556e76e51bd2389$export$2e2bcd8739ae039 = $9556e76e51bd2389$var$ModuleRcci;





const $4b625e33952bcf2d$var$NoMatch = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $a0064658a8399ad3$export$2e2bcd8739ae039), {
        navbar: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $5de16d9a2066fdee$export$2e2bcd8739ae039), {}),
        banner: true,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
            children: "La page que vous demandez n'a pas \xe9t\xe9 trouv\xe9e."
        })
    });
};
var $4b625e33952bcf2d$export$2e2bcd8739ae039 = $4b625e33952bcf2d$var$NoMatch;







var $kc00y = parcelRequire("kc00y");









const $91419ff82e7cf259$var$AccesRapidePei = ()=>{
    const [tourneeId, setTourneeId] = (0, $kc00y.useState)();
    const [peiId, setPeiId] = (0, $kc00y.useState)();
    const [communeId, setCommuneId] = (0, $kc00y.useState)();
    const [voieId, setVoieId] = (0, $kc00y.useState)();
    const { run: fetchOptionVoie, data: optionVoieData } = (0, $8d9ebd8892d8a5f5$export$6326fb4463ae1be4)(communeId ? (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/voie/${communeId}` : "");
    const optionVoie = optionVoieData;
    const { fetchGeometry: fetchGeometry } = (0, $a178c3075f0f40bb$export$2e2bcd8739ae039)();
    const handleTourneeObject = (obj)=>{
        setTourneeId(obj?.id ?? null);
    };
    const handlePeiObject = (obj)=>{
        setPeiId(obj?.id ?? null);
    };
    const handleCommuneObject = (obj)=>{
        setCommuneId(obj?.id ?? null);
        if (!obj) setVoieId(null);
    };
    (0, $kc00y.useEffect)(()=>{
        if (communeId && !optionVoie || optionVoie && optionVoie.some((voie)=>voie.voieCommuneId !== communeId)) fetchOptionVoie();
    }, [
        communeId,
        fetchOptionVoie,
        optionVoie
    ]);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                    icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$adb7c12af9c0e6e8), {}),
                    title: "Acc\xe8s rapide"
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
                fluid: true,
                className: "px-5",
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                        className: "align-items-end mb-3",
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                className: "d-flex align-items-start flex-column",
                                sm: 3,
                                children: [
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$842aba50ed0ce9d7), {
                                        name: "tournee",
                                        label: "Tourn\xe9e :",
                                        required: false
                                    }),
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $a1d50030dc0bb103$export$2e2bcd8739ae039), {
                                        className: "w-100",
                                        label: "Tourn\xe9e",
                                        queryUrl: "/api/tournee/acces-rapide",
                                        setter: handleTourneeObject
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                                    variant: "primary",
                                    onClick: ()=>{
                                        fetchGeometry((0, $a178c3075f0f40bb$export$970c58a942355206).TOURNEE, tourneeId);
                                    },
                                    children: "Localiser"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                        className: "align-items-end mb-3",
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                className: "d-flex align-items-start flex-column",
                                sm: 3,
                                children: [
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$842aba50ed0ce9d7), {
                                        name: "pei",
                                        label: "PEI :",
                                        required: false
                                    }),
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $a1d50030dc0bb103$export$2e2bcd8739ae039), {
                                        className: "w-100",
                                        label: "PEI",
                                        queryUrl: "/api/pei/acces-rapide",
                                        setter: handlePeiObject
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                                    variant: "primary",
                                    onClick: ()=>{
                                        fetchGeometry((0, $a178c3075f0f40bb$export$970c58a942355206).PEI, peiId);
                                    },
                                    children: "Localiser"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                        className: "align-items-end mb-3",
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                className: "d-flex align-items-start flex-column",
                                sm: 3,
                                children: [
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$842aba50ed0ce9d7), {
                                        name: "commune",
                                        label: "Commune :",
                                        required: false
                                    }),
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $a1d50030dc0bb103$export$2e2bcd8739ae039), {
                                        className: "w-100",
                                        label: "Commune",
                                        queryUrl: "/api/commune/acces-rapide",
                                        setter: handleCommuneObject
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                className: "d-flex align-items-start flex-column",
                                sm: 2,
                                children: [
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$842aba50ed0ce9d7), {
                                        name: "voie",
                                        label: "Voie :",
                                        required: false
                                    }),
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $3744b2a772efdf44$export$2e2bcd8739ae039), {
                                        name: "voie",
                                        listIdCodeLibelle: (optionVoie || []).map((v)=>{
                                            return {
                                                id: v.voieId,
                                                code: "",
                                                libelle: v.voieLibelle
                                            };
                                        }),
                                        onChange: (e)=>setVoieId(e ? e.value : null),
                                        isClearable: true,
                                        disabled: !communeId
                                    }, communeId ?? "")
                                ]
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                                    variant: "primary",
                                    onClick: ()=>{
                                        if (!voieId) fetchGeometry((0, $a178c3075f0f40bb$export$970c58a942355206).COMMUNE, communeId);
                                        else fetchGeometry((0, $a178c3075f0f40bb$export$970c58a942355206).VOIE, voieId);
                                    },
                                    children: "Localiser"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $91419ff82e7cf259$export$2e2bcd8739ae039 = $91419ff82e7cf259$var$AccesRapidePei;







const $b8cc28a1cee229b7$var$LoginError = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        className: "mt-5",
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $8598ca69ed8b9dca$export$2e2bcd8739ae039), {
            variant: "danger",
            role: "alert",
            children: [
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8598ca69ed8b9dca$export$2e2bcd8739ae039).Heading, {
                    className: "h2 mb-4",
                    children: "Acc\xe8s refus\xe9"
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("p", {
                    className: "fs-6 fw-semibold mb-3",
                    children: "Vous n'avez pas les droits n\xe9cessaires pour acc\xe9der \xe0 l'application."
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("hr", {}),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("p", {
                    className: "fs-6 mb-0",
                    children: "Contactez votre administrateur pour qu'il configure votre profil."
                })
            ]
        })
    });
};
var $b8cc28a1cee229b7$export$2e2bcd8739ae039 = $b8cc28a1cee229b7$var$LoginError;












const $da263764961f84a7$var$AccueilPrive = ({ user: user })=>{
    // On récupère les modules
    const modulesState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/modules/`);
    const messagePeiLongueIndispoState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/message-pei-longue-indispo/`);
    if (!modulesState.isResolved) return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $c21b1c237cfa1d94$export$2e2bcd8739ae039), {});
    const { data: data } = modulesState;
    const mapColonneRow = Object.groupBy(data, ({ moduleColonne: moduleColonne })=>moduleColonne);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
                children: messagePeiLongueIndispoState?.data && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $8598ca69ed8b9dca$export$2e2bcd8739ae039), {
                        variant: "danger",
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8598ca69ed8b9dca$export$2e2bcd8739ae039).Heading, {
                                children: "PEI indisponibles"
                            }),
                            messagePeiLongueIndispoState?.data.message,
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                                variant: "link",
                                href: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).MESSAGE_PEI_LONGUE_INDISPO_LISTE_PEI,
                                children: "Voir plus"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: Object.entries(mapColonneRow).map(([key, values])=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: Array.from(values).map((e)=>{
                            const listeLink = $da263764961f84a7$var$getLinks(e.moduleType, user);
                            const aLeDroit = listeLink?.some((e)=>e.aLeDroit === true);
                            const hasHtmlContent = e.moduleContenuHtml != null && e.moduleContenuHtml.trim() !== "";
                            const isDocumentWithRight = e.moduleType === (0, $a9754922f4c67d47$export$ef88b514e4bfff34).DOCUMENT && (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).DOCUMENTS_R);
                            const isCourrierWithRight = e.moduleType === (0, $a9754922f4c67d47$export$ef88b514e4bfff34).COURRIER && (0, $e3b8d60f4bb99483$export$4f612ab7b7b1d133)(user, [
                                (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).COURRIER_UTILISATEUR_R,
                                (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).COURRIER_ORGANISME_R
                            ]);
                            const hasAccess = aLeDroit || hasHtmlContent || isDocumentWithRight || isCourrierWithRight;
                            return hasAccess && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                className: "m-1",
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $a9754922f4c67d47$export$2e2bcd8739ae039), {
                                    moduleId: e.moduleId,
                                    type: e.moduleType,
                                    titre: e.moduleTitre,
                                    image: e.moduleLinkImage,
                                    contenuHtml: e.moduleContenuHtml,
                                    listeLink: listeLink,
                                    listeDocument: e.listeDocument
                                })
                            }, e.moduleId);
                        })
                    }, key))
            })
        ]
    });
};
/**
 * Fonction à alimenter.
 * Permet de récupérer une liste de liens d'une module.
 * @param typeModuleRemocra type du module
 * @returns
 */ function $da263764961f84a7$var$getLinks(typeModuleRemocra, user) {
    switch(typeModuleRemocra){
        case (0, $a9754922f4c67d47$export$ef88b514e4bfff34).DECI:
            return [
                {
                    aLeDroit: (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).PEI_R),
                    label: "Gestion des points d'eau",
                    link: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).ACCES_RAPIDE
                },
                {
                    aLeDroit: (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).DECLARATION_PEI),
                    label: "D\xe9clarer un PEI",
                    link: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).DECLARATION_PEI
                },
                {
                    aLeDroit: (0, $e3b8d60f4bb99483$export$4f612ab7b7b1d133)(user, [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).IMPORT_CTP_A,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).IMPORT_CTP_PEI_DEPLACEMENT_U
                    ]),
                    label: "Import CTP",
                    link: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).IMPORT_CTP
                },
                {
                    aLeDroit: (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).COURRIER_C),
                    label: "G\xe9n\xe9rer un courrier",
                    link: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).GENERER_COURRIER((0, $a9754922f4c67d47$export$ef88b514e4bfff34).DECI)
                }
            ];
        case (0, $a9754922f4c67d47$export$ef88b514e4bfff34).COUVERTURE_HYDRAULIQUE:
            return [
                {
                    aLeDroit: (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ETUDE_R),
                    label: "Liste des \xe9tudes",
                    link: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_ETUDE
                }
            ];
        case (0, $a9754922f4c67d47$export$ef88b514e4bfff34).CARTOGRAPHIE_PERSONNALISEE:
            return [
                {
                    aLeDroit: (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).CARTOGRAPHIES_E),
                    label: "Cartographie personnalis\xe9e",
                    link: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).CARTOGRAPHIE_PERSONNALISEE
                }
            ];
        case (0, $a9754922f4c67d47$export$ef88b514e4bfff34).RCI:
            return [
                {
                    aLeDroit: (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).RCCI_A) || (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).RCCI_R),
                    label: "Carte des d\xe9parts de feu",
                    link: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).RCCI_MAP
                }
            ];
        case (0, $a9754922f4c67d47$export$ef88b514e4bfff34).OPERATIONS_DIVERSES:
            return [
                {
                    aLeDroit: (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).OPERATIONS_DIVERSES_E),
                    label: "Historique des op\xe9rations",
                    link: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).HISTORIQUE_OPERATIONS
                },
                {
                    aLeDroit: (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).OPERATIONS_DIVERSES_E),
                    label: "R\xe9sultats d'ex\xe9cutions",
                    link: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).RESULTATS_EXECUTION
                }
            ];
        case (0, $a9754922f4c67d47$export$ef88b514e4bfff34).DFCI:
            return [
                {
                    aLeDroit: (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).DFCI_R),
                    label: "Carte DFCI",
                    link: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).CARTE_DFCI
                },
                {
                    aLeDroit: (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).DFCI_RECEPTRAVAUX_C),
                    label: "Recevoir des travaux",
                    link: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).DFCI_RECEPTION_TRAVAUX
                },
                {
                    aLeDroit: (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).DFCI_GESTION_CONFLITS_R),
                    label: "Gestion des conflits",
                    link: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).DFCI_GESTION_CONFLITS
                }
            ];
        case (0, $a9754922f4c67d47$export$ef88b514e4bfff34).OLDEBS:
            return [
                {
                    aLeDroit: (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).OLDEB_C) || (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).OLDEB_D) || (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).OLDEB_R) || (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).OLDEB_U),
                    label: "Liste des Obligations L\xe9gales de D\xe9broussaillement",
                    link: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).OLDEB_LIST
                }
            ];
        case (0, $a9754922f4c67d47$export$ef88b514e4bfff34).PERMIS:
            return [
                {
                    aLeDroit: (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).PERMIS_R),
                    label: "Carte des Permis",
                    link: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).CARTE_PERMIS
                }
            ];
        case (0, $a9754922f4c67d47$export$ef88b514e4bfff34).SIGNALEMENTS:
            return [
                {
                    aLeDroit: (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).SIGNALEMENTS_C),
                    label: "Carte des signalements",
                    link: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).SIGNALEMENTS
                },
                {
                    aLeDroit: (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).DEPOT_DELIB_C),
                    label: "D\xe9poser une d\xe9lib\xe9ration",
                    link: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).SIGNALEMENTS_DELIBERATION
                }
            ];
        case (0, $a9754922f4c67d47$export$ef88b514e4bfff34).RISQUES:
            return [
                {
                    aLeDroit: (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).RISQUE_R),
                    label: "Carte des risques",
                    link: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).RISQUE
                }
            ];
        case (0, $a9754922f4c67d47$export$ef88b514e4bfff34).CRISE:
            return [
                {
                    aLeDroit: (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).CRISE_R),
                    label: "Liste des crises",
                    link: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_CRISES
                }
            ];
        case (0, $a9754922f4c67d47$export$ef88b514e4bfff34).ADMIN:
            return [
                {
                    aLeDroit: (0, $e3b8d60f4bb99483$export$4f612ab7b7b1d133)(user, [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_ANOMALIES,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_API,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_COUCHE_CARTOGRAPHIQUE,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_COURRIER,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_DROITS,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_PARAM_APPLI,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_PARAM_APPLI_MOBILE,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_PARAM_TRAITEMENTS,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_RAPPORTS_PERSO,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_ROLE_CONTACT,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_TYPE_ETUDE,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_UTILISATEURS_A,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_ZONE_COMPETENCE,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).DASHBOARD_A,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).GEST_SITE_A,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).GEST_SITE_R,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_ORGANISME_A,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_ORGANISME_R,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).GEST_CONTACT_A,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ORGANISME_CONTACT_A,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_UTILISATEURS_R,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_UTILISATEURS_A,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_UTILISATEURS_ORGA_A,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_UTILISATEURS_ORGA_R
                    ]),
                    label: "Administrer l'application",
                    link: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).MODULE_ADMIN
                },
                {
                    aLeDroit: (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).DOCUMENTS_R),
                    label: "Liste des documents",
                    link: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_DOCUMENT_HABILITABLE
                }
            ];
        case (0, $a9754922f4c67d47$export$ef88b514e4bfff34).COURRIER:
            return;
        case (0, $a9754922f4c67d47$export$ef88b514e4bfff34).DOCUMENT:
            return;
        case (0, $a9754922f4c67d47$export$ef88b514e4bfff34).RAPPORT_PERSONNALISE:
            return [
                {
                    aLeDroit: (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).RAPPORT_PERSONNALISE_E),
                    label: "Ex\xe9cuter des rapports personnalis\xe9s",
                    link: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).EXECUTER_RAPPORT_PERSONNALISE
                }
            ];
        case (0, $a9754922f4c67d47$export$ef88b514e4bfff34).PEI_PRESCRIT:
            return [
                {
                    aLeDroit: (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).PEI_PRESCRIT_A) || (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).PEI_PRESCRIT_R),
                    label: "Carte des points d'eau prescrits",
                    link: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).PEI_PRESCRIT
                }
            ];
        case (0, $a9754922f4c67d47$export$ef88b514e4bfff34).PERSONNALISE:
            return;
        case (0, $a9754922f4c67d47$export$ef88b514e4bfff34).DASHBOARD:
            return [
                {
                    aLeDroit: (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).DASHBOARD_A) || (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).DASHBOARD_R),
                    label: "Acc\xe9der au tableau de bord",
                    link: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).DASHBOARD_LIST
                }
            ];
    }
}
var $da263764961f84a7$export$2e2bcd8739ae039 = $da263764961f84a7$var$AccueilPrive;






const $a5a7301f74f4f975$var$AccueilPublic = ()=>{
    const parametre = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/parametres?${{
        listeParametreCode: JSON.stringify((0, $ee297f06e8568bf4$export$2e2bcd8739ae039).ACCUEIL_PUBLIC)
    }}`);
    return parametre.data?.[(0, $ee297f06e8568bf4$export$2e2bcd8739ae039).ACCUEIL_PUBLIC].parametreValeur != null && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
            dangerouslySetInnerHTML: {
                __html: parametre.data?.[(0, $ee297f06e8568bf4$export$2e2bcd8739ae039).ACCUEIL_PUBLIC].parametreValeur
            }
        })
    });
};
var $a5a7301f74f4f975$export$2e2bcd8739ae039 = $a5a7301f74f4f975$var$AccueilPublic;


const $527d4c5324a1545c$var$Accueil = ()=>{
    const { user: user } = (0, $e787cde576104469$export$fdc397e486fa83e7)();
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $a0064658a8399ad3$export$2e2bcd8739ae039), {
        navbar: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $5de16d9a2066fdee$export$2e2bcd8739ae039), {}),
        fluid: true,
        banner: true,
        children: user != null ? user.droits.length === 0 ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b8cc28a1cee229b7$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $da263764961f84a7$export$2e2bcd8739ae039), {
            user: user
        }) : /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $a5a7301f74f4f975$export$2e2bcd8739ae039), {})
    });
};
var $527d4c5324a1545c$export$2e2bcd8739ae039 = $527d4c5324a1545c$var$Accueil;




var $bkJfK = parcelRequire("bkJfK");




var $bkJfK = parcelRequire("bkJfK");

var $kc00y = parcelRequire("kc00y");












var $kc00y = parcelRequire("kc00y");










function $0d316f1b75f423b2$export$6d08773d2e66f8f2({ id: id }) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
        className: "bg-white border p-2 rounded text-center",
        children: id
    });
}
function $0d316f1b75f423b2$export$2e2bcd8739ae039({ id: id }) {
    const { attributes: attributes, listeners: listeners, setNodeRef: setNodeRef } = (0, $6e75a0664b0e0f07$export$4ebcb6201122185a)({
        id: id
    });
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
        ref: setNodeRef,
        className: "m-2",
        ...attributes,
        ...listeners,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($0d316f1b75f423b2$export$6d08773d2e66f8f2, {
            id: id
        })
    });
}


function $f178749d4e92fb15$export$2e2bcd8739ae039({ id: id, items: items, setItems: setItems, keyPossibilites: keyPossibilites }) {
    const { setNodeRef: setNodeRef } = (0, $3b30af0a3bfceeb3$export$d74e5d67dc2b3176)({
        id: id
    });
    return items[id] && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
        className: "m-2",
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $6e75a0664b0e0f07$export$86155fde54f06e6a), {
            id: id,
            items: items[id] ?? [],
            strategy: (0, $6e75a0664b0e0f07$export$fe2be640df2ffb9e),
            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                ref: setNodeRef,
                className: "bg-light border p-2 rounded",
                children: [
                    id !== keyPossibilites && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        xs: "auto",
                        className: "ms-auto",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                            variant: "link",
                            className: "text-danger ",
                            onClick: ()=>{
                                const possibilites = items.possibilites;
                                items[id]?.forEach((element)=>{
                                    possibilites.push(element);
                                });
                                const itemsTemp = {
                                    ...items,
                                    possibilites: possibilites
                                };
                                delete itemsTemp[id];
                                setItems({
                                    ...itemsTemp
                                });
                            },
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$e04bcc6127e699bf), {})
                        })
                    }),
                    id === keyPossibilites ? items[id]?.map((id, index)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                            xs: "auto",
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $0d316f1b75f423b2$export$2e2bcd8739ae039), {
                                id: id
                            }, id)
                        }, index)) : items[id]?.map((id)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $0d316f1b75f423b2$export$2e2bcd8739ae039), {
                            id: id
                        }, id))
                ]
            })
        })
    });
}



/**
 * Doit recevoir une liste d'items sous forme de :
 * {
 *  possibilites: ["1", "2", "3"],
 *  colonne1: ["4", "5"]
 *  colonne2: ["3"]
 *  ...
 * }
 * @returns
 */ const $f0d3e69b4aae2863$var$MoveGridComponent = ({ items: items, setItems: setItems, setPossibilites: setPossibilites })=>{
    const keyPossibilites = "possibilites";
    // Permet de récupérer le colonne associée
    function findColonne(id) {
        if (id in items) return id;
        return Object.keys(items).find((key)=>items[key].includes(id));
    }
    function handleDragStart(event) {
        const { active: active } = event;
        const { id: id } = active;
        setActiveId(id);
    }
    function handleDragOver(event) {
        const { active: active, over: over, draggingRect: draggingRect } = event;
        if (!over) return;
        const activeId = active.id;
        const overId = over.id;
        // Trouver les colonnes source et destination
        const activeContainer = findColonne(activeId);
        const overContainer = findColonne(overId);
        if (!activeContainer || !overContainer) return;
        setItems((prev)=>{
            const activeItems = prev[activeContainer];
            const overItems = prev[overContainer];
            const activeIndex = activeItems.indexOf(activeId);
            const overIndex = overItems.indexOf(overId);
            // Vérification de sécurité
            if (activeIndex === -1) return prev;
            let newIndex;
            // Ajout en fin de colonne si elle est vide
            if (overId in prev) newIndex = overItems.length;
            else {
                const isBelowLastItem = overIndex === overItems.length - 1 && draggingRect?.offsetTop > over.rect?.offsetTop + over.rect?.height;
                newIndex = overIndex >= 0 ? overIndex + (isBelowLastItem ? 1 : 0) : overItems.length;
            }
            // Vérifier si l'élément est déjà dans la colonne de destination et l'enlever avant de le réinsérer
            const filteredOverItems = overItems.filter((item)=>item !== activeId);
            // Ajouter l'élément déplacé à la nouvelle position
            const updatedOverItems = [
                ...filteredOverItems.slice(0, newIndex),
                activeId,
                ...filteredOverItems.slice(newIndex)
            ];
            // Supprimer l'élément de la colonne d'origine uniquement si elle est différente sinon utiliser la liste mise à jour
            const updatedActiveItems = activeContainer === overContainer ? updatedOverItems : activeItems.filter((item)=>item !== activeId);
            // Mise à jour des possibilités si besoin
            if (activeContainer === keyPossibilites) setPossibilites(updatedActiveItems);
            if (overContainer === keyPossibilites) setPossibilites(updatedOverItems);
            return {
                ...prev,
                [activeContainer]: updatedActiveItems,
                [overContainer]: updatedOverItems
            };
        });
    }
    function handleDragEnd(event) {
        const { active: active, over: over } = event;
        const { id: id } = active;
        const { id: overId } = over;
        const activeContainer = findColonne(id);
        const overContainer = findColonne(overId);
        if (!activeContainer || !overContainer) return;
        setActiveId(null);
    }
    const [activeId, setActiveId] = (0, $kc00y.useState)();
    const sensors = (0, $3b30af0a3bfceeb3$export$19012f58216d597f)((0, $3b30af0a3bfceeb3$export$cc72dd71f4ec69eb)((0, $3b30af0a3bfceeb3$export$b26af955418d6638)), (0, $3b30af0a3bfceeb3$export$cc72dd71f4ec69eb)((0, $3b30af0a3bfceeb3$export$44d67f2a438aeba9), {
        coordinateGetter: (0, $6e75a0664b0e0f07$export$a6f27ecf02eb3a67)
    }));
    const disabled = Object.entries(items).length >= 7;
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $3b30af0a3bfceeb3$export$2d5c5ceac203fc1e), {
        announcements: (0, $3b30af0a3bfceeb3$export$6acb64047911dd54),
        sensors: sensors,
        collisionDetection: (0, $3b30af0a3bfceeb3$export$c3a6c1c7122b31c9),
        onDragStart: handleDragStart,
        onDragOver: handleDragOver,
        onDragEnd: handleDragEnd,
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("h5", {
                children: "2.1 - Blocs \xe0 placer"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: items.possibilites.length > 0 ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $f178749d4e92fb15$export$2e2bcd8739ae039), {
                            id: keyPossibilites,
                            items: items,
                            setItems: setItems,
                            keyPossibilites: keyPossibilites
                        }) : /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                            className: "bg-light border p-2 rounded",
                            children: "Aucun bloc \xe0 placer"
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                className: "mt-3",
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("h5", {
                        className: "mt-2",
                        children: "2.2 - Emplacement"
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        xs: "auto",
                        className: "ms-auto",
                        children: disabled ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                            tooltipText: "6 colonnes maximum",
                            tooltipId: "limit-colonne-maximum",
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                                variant: "link",
                                disabled: disabled,
                                onClick: ()=>{
                                    const random = Math.random();
                                    const newColonne = {};
                                    newColonne["colonne" + random] = [];
                                    setItems({
                                        ...items,
                                        ...newColonne
                                    });
                                },
                                children: [
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$d776d19dfae66ece), {}),
                                    " Ajouter une colonne"
                                ]
                            })
                        }) : /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                            variant: "link",
                            disabled: disabled,
                            onClick: ()=>{
                                const random = Math.random();
                                const newColonne = {};
                                newColonne["colonne" + random] = [];
                                setItems({
                                    ...items,
                                    ...newColonne
                                });
                            },
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$d776d19dfae66ece), {}),
                                " Ajouter une colonne"
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: [
                    Object.entries(items).map(([key])=>{
                        return key !== keyPossibilites && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $f178749d4e92fb15$export$2e2bcd8739ae039), {
                                id: key,
                                items: items,
                                setItems: setItems,
                                keyPossibilites: keyPossibilites
                            })
                        });
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $3b30af0a3bfceeb3$export$aca73479aa40659d), {
                        children: activeId ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $0d316f1b75f423b2$export$6d08773d2e66f8f2), {
                            id: activeId
                        }) : null
                    })
                ]
            })
        ]
    });
};
var $f0d3e69b4aae2863$export$2e2bcd8739ae039 = $f0d3e69b4aae2863$var$MoveGridComponent;


const $1c269bba4b203358$var$GridDragAndDrop = ({ data: data, colonneProperty: colonneProperty, ligneProperty: ligneProperty, titreProperty: titreProperty, protectedProperty: protectedProperty = false, pageTitle: pageTitle, urlToSubmit: urlToSubmit, validationSchema: validationSchema, getInitialValues: getInitialValues, prepareVariables: prepareVariables, createComponentToRepeat: createComponentToRepeat, name: name, defaultElement: defaultElement, disabledSuivant: disabledSuivant, isMultipartFormData: isMultipartFormData = false, isDisabledButton: isDisabledButton = false })=>{
    const [items, setItems] = (0, $kc00y.useState)();
    (0, $kc00y.useEffect)(()=>{
        if (data) setItems(Object.entries(Object.groupBy(data, (element)=>element[colonneProperty]))?.map(([, value])=>Object.values(value).map((t)=>t[titreProperty])));
    }, [
        data,
        titreProperty,
        colonneProperty
    ]);
    return items && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                    icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$72e0de8e793fca75), {}),
                    title: pageTitle
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                initialValues: getInitialValues(data),
                validationSchema: validationSchema,
                isPost: false,
                isMultipartFormData: isMultipartFormData,
                submitUrl: urlToSubmit,
                prepareVariables: (values)=>prepareVariables(values),
                redirectUrl: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).MODULE_ADMIN,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($1c269bba4b203358$var$Form, {
                    items: items,
                    setItems: setItems,
                    colonneProperty: colonneProperty,
                    createComponentToRepeat: createComponentToRepeat,
                    name: name,
                    defaultElement: defaultElement,
                    ligneProperty: ligneProperty,
                    titreProperty: titreProperty,
                    protectedProperty: protectedProperty,
                    disabledSuivant: disabledSuivant,
                    isDisabledButton: isDisabledButton
                })
            })
        ]
    });
};
var $1c269bba4b203358$export$2e2bcd8739ae039 = $1c269bba4b203358$var$GridDragAndDrop;
const $1c269bba4b203358$var$Form = ({ items: items, setItems: setItems, name: name, defaultElement: defaultElement, createComponentToRepeat: createComponentToRepeat, colonneProperty: colonneProperty, ligneProperty: ligneProperty, titreProperty: titreProperty, protectedProperty: protectedProperty, disabledSuivant: disabledSuivant, isDisabledButton: isDisabledButton = false })=>{
    const { values: values, setFieldValue: setFieldValue } = (0, $bkJfK.useFormikContext)();
    const [possibilites, setPossibilites] = (0, $kc00y.useState)();
    const [show, setShow] = (0, $kc00y.useState)(false);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
        children: !show ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("h3", {
                            children: "1 - Choisissez les blocs qui appara\xeetront"
                        }),
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $665753c43020c55f$export$2e2bcd8739ae039), {
                            name: name,
                            createComponentToRepeat: createComponentToRepeat,
                            defaultElement: defaultElement,
                            protectedProperty: protectedProperty,
                            listeElements: values[name],
                            isDisabledButton: isDisabledButton
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        className: "my-3 d-flex justify-content-center",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                            onClick: ()=>{
                                setShow(true);
                                // Si une valeur a été supprimée, on l'enlève de la liste
                                let p = values[name].filter((e)=>e[colonneProperty] == null).map((e)=>e[titreProperty]);
                                let itemsTemp = {};
                                Object.entries(items).map(([key, value])=>{
                                    if (key === "possibilites") p = new Set(value.filter((e)=>values[name].map((t)=>t[titreProperty]).includes(e)).concat(p));
                                    else itemsTemp[key] = value.filter((e)=>values[name].map((t)=>t[titreProperty]).includes(e));
                                });
                                // Si on a changé le titre d'un bloc, on remet à jour la liste
                                if (Object.values(itemsTemp).flat().length !== values[name].length) itemsTemp = Object.entries(Object.groupBy(values[name].filter((e)=>e[colonneProperty] != null), (element)=>element[colonneProperty]))?.map(([, value])=>Object.values(value).map((t)=>t[titreProperty]));
                                // On enlève les valeurs qui sont déjà placées
                                p = [
                                    ...p
                                ].filter((e)=>!Object.values(itemsTemp).flat().includes(e));
                                setPossibilites(p);
                                setItems({
                                    ...itemsTemp,
                                    possibilites: p
                                });
                            },
                            disabled: values[name].find((e)=>disabledSuivant(e)),
                            children: [
                                "Suivant ",
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$3213a407ffb0559), {})
                            ]
                        })
                    })
                })
            ]
        }) : /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("h3", {
                            children: "2 - Choisissez l'emplacement de ces blocs"
                        }),
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $f0d3e69b4aae2863$export$2e2bcd8739ae039), {
                            items: {
                                ...items,
                                possibilites: possibilites
                            },
                            setPossibilites: setPossibilites,
                            setItems: setItems
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        className: "my-3 d-flex justify-content-center",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                            onClick: ()=>setShow(false),
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$41884575254a94be), {}),
                                " Pr\xe9c\xe9dent"
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db9b0e6fdb142a4c$export$2e2bcd8739ae039), {
                    returnLink: true,
                    disabledValide: items.possibilites.length > 0,
                    onClick: ()=>{
                        const listeWithColRow = [];
                        // On récupère les colonnes et les lignes
                        let indexI = 0;
                        for(const i in items){
                            indexI++;
                            let indexJ = 0;
                            for(const j in items[i]){
                                indexJ++;
                                const bloc = values[name].find((e)=>e[titreProperty] === items[i][j]);
                                bloc[colonneProperty] = indexI;
                                bloc[ligneProperty] = indexJ;
                                listeWithColRow.push(bloc);
                            }
                        }
                        setFieldValue(name, listeWithColRow);
                    }
                })
            ]
        })
    });
};






const $96c21b2d91fc07ff$export$a5cab80145b70e98 = (data)=>({
        listeModule: data,
        listePersisted: data.map((e)=>e.moduleType)
    });
const $96c21b2d91fc07ff$export$c084437b5e3206cd = (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({});
const $96c21b2d91fc07ff$export$f97400759cfd946 = (values)=>{
    const formData = new FormData();
    formData.append("listeModule", JSON.stringify(values.listeModule.map((e)=>({
            moduleId: e.moduleId,
            moduleType: e.moduleType,
            moduleTitre: e.moduleTitre,
            imageName: e.moduleImage?.name,
            moduleColonne: e.moduleColonne,
            moduleLigne: e.moduleLigne,
            moduleContenuHtml: e.moduleContenuHtml,
            moduleNbDocument: e.moduleNbDocument,
            listeThematiqueId: e.listeThematiqueId
        }))));
    values.listeModule.map((e)=>e.moduleImage && formData.append("image_" + e.moduleImage?.name, e.moduleImage));
    return formData;
};
const $96c21b2d91fc07ff$var$AdminAccueil = ()=>{
    const { data: data } = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/modules`);
    return data && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c269bba4b203358$export$2e2bcd8739ae039), {
        isMultipartFormData: true,
        data: data,
        colonneProperty: "moduleColonne",
        ligneProperty: "moduleLigne",
        titreProperty: "moduleTitre",
        protectedProperty: "moduleProtected",
        pageTitle: "Configurer la page d'accueil",
        urlToSubmit: `/api/modules/upsert`,
        validationSchema: $96c21b2d91fc07ff$export$c084437b5e3206cd,
        getInitialValues: $96c21b2d91fc07ff$export$a5cab80145b70e98,
        prepareVariables: $96c21b2d91fc07ff$export$f97400759cfd946,
        createComponentToRepeat: $96c21b2d91fc07ff$var$createComponentToRepeat,
        name: "listeModule",
        defaultElement: {
            moduleType: null,
            moduleTitre: null,
            moduleImage: null,
            moduleLinkImage: null,
            moduleContenuHtml: null,
            moduleColonne: null,
            moduleLigne: null,
            imageRetiree: false
        },
        disabledSuivant: (e)=>e.moduleType == null || e.moduleTitre == null || (e.moduleType === (0, $a9754922f4c67d47$export$ef88b514e4bfff34).COURRIER || e.moduleType === (0, $a9754922f4c67d47$export$ef88b514e4bfff34).DOCUMENT) && e.moduleNbDocument == null
    });
};
var $96c21b2d91fc07ff$export$2e2bcd8739ae039 = $96c21b2d91fc07ff$var$AdminAccueil;
const $96c21b2d91fc07ff$var$ComposantToRepeat = ({ index: index, listeElements: listeElements })=>{
    const thematiqueState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/thematique/actif`);
    const allTypesModules = Object.values((0, $a9754922f4c67d47$export$ef88b514e4bfff34)).map((key)=>{
        return {
            id: key,
            code: key,
            libelle: key
        };
    });
    //Modules pouvant être placés plusieurs fois (donc possédant un paramétrage le justifiant !)
    const multiTypesAutorises = [
        (0, $a9754922f4c67d47$export$ef88b514e4bfff34).COURRIER,
        (0, $a9754922f4c67d47$export$ef88b514e4bfff34).DOCUMENT,
        (0, $a9754922f4c67d47$export$ef88b514e4bfff34).PERSONNALISE
    ];
    // Tous les modules qui peuvent être placés plusieurs fois ou ne sont pas déjà placés
    const availableTypesModules = allTypesModules.filter((typeModule)=>multiTypesAutorises.includes((0, $a9754922f4c67d47$export$ef88b514e4bfff34)[typeModule.id]) || !listeElements.map((e)=>e.moduleType).includes((0, $a9754922f4c67d47$export$ef88b514e4bfff34)[typeModule.id]));
    const { setFieldValue: setFieldValue, values: values } = (0, $bkJfK.useFormikContext)();
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
        xs: 10,
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                className: "align-items-center mt-3",
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$d6701e98ab1a6725), {
                            name: `listeModule[${index}].moduleType`,
                            label: "Type",
                            options: availableTypesModules,
                            getOptionValue: (t)=>t.id,
                            getOptionLabel: (t)=>t.libelle,
                            onChange: (e)=>{
                                setFieldValue(`listeModule[${index}].moduleType`, allTypesModules.find((type)=>type.id === e.id)?.id);
                            },
                            defaultValue: allTypesModules.find((type)=>type.id === listeElements[index].moduleType),
                            required: true,
                            readOnly: values.listePersisted.includes(values.listeModule[index].moduleType)
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                            name: `listeModule[${index}].moduleTitre`,
                            label: "Titre",
                            required: true
                        })
                    }),
                    listeElements[index].moduleType === (0, $a9754922f4c67d47$export$ef88b514e4bfff34).PERSONNALISE && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                            name: `listeModule[${index}].moduleContenuHtml`,
                            label: "Contenu HTML",
                            required: true
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                xs: 10,
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b57af79a4ab2a1c6), {
                            name: `listeModule[${index}].moduleImage`,
                            accept: "image/*",
                            label: "Image",
                            required: false,
                            onChange: (e)=>setFieldValue(`listeModule[${index}].moduleImage`, e.target.files[0])
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: listeElements[index].moduleLinkImage && listeElements[index].moduleImage === null ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ad18c81fdcf37de8$export$2e2bcd8739ae039), {
                            width: 100,
                            fluid: true,
                            src: listeElements[index].moduleLinkImage
                        }) : listeElements[index].moduleImage != null && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ad18c81fdcf37de8$export$2e2bcd8739ae039), {
                            width: 100,
                            fluid: true,
                            src: URL.createObjectURL(listeElements[index].moduleImage)
                        })
                    })
                ]
            }),
            (listeElements[index].moduleType === (0, $a9754922f4c67d47$export$ef88b514e4bfff34).DOCUMENT || listeElements[index].moduleType === (0, $a9754922f4c67d47$export$ef88b514e4bfff34).COURRIER) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$eae70af4b4e3f197), {
                            name: `listeModule[${index}].listeThematiqueId`,
                            label: "Th\xe9matiques \xe0 afficher",
                            options: thematiqueState?.data,
                            getOptionValue: (t)=>t.id,
                            getOptionLabel: (t)=>t.libelle,
                            value: listeElements[index]?.listeThematiqueId?.map((e)=>thematiqueState?.data?.find((r)=>r.id === e)) ?? undefined,
                            onChange: (thematique)=>{
                                const thematiqueId = thematique.map((e)=>e.id);
                                thematiqueId.length > 0 ? setFieldValue(`listeModule[${index}].listeThematiqueId`, thematiqueId) : setFieldValue(`listeModule[${index}].listeThematiqueId`, undefined);
                            },
                            isClearable: true,
                            required: false
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$6bf0cd3a219bbade), {
                            name: `listeModule[${index}].moduleNbDocument`,
                            label: "Nombre \xe0 afficher",
                            required: true,
                            min: 0,
                            step: 1
                        })
                    })
                ]
            })
        ]
    });
};
function $96c21b2d91fc07ff$var$createComponentToRepeat(index, listeElements) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($96c21b2d91fc07ff$var$ComposantToRepeat, {
        index: index,
        listeElements: listeElements
    });
}




var $bkJfK = parcelRequire("bkJfK");

var $kc00y = parcelRequire("kc00y");






var $kc00y = parcelRequire("kc00y");



const $918dca194c1aeb0f$var$SeeMoreButton = ({ headerModal: headerModal = "", children: children })=>{
    const { ref: ref } = (0, $ca8671088139af49$export$2e2bcd8739ae039)();
    const [show, setShow] = (0, $kc00y.useState)(false);
    const handleShow = ()=>setShow(true);
    const handleClose = ()=>setShow(false);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                variant: "info",
                onClick: handleShow,
                size: "sm",
                className: "p-1",
                children: "Plus d'info"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eda4eaeb791cb8f1$export$2e2bcd8739ae039), {
                ref: ref,
                visible: show,
                closeModal: handleClose,
                header: headerModal,
                content: children
            })
        ]
    });
};
var $918dca194c1aeb0f$export$2e2bcd8739ae039 = $918dca194c1aeb0f$var$SeeMoreButton;












var $bkJfK = parcelRequire("bkJfK");

var $kc00y = parcelRequire("kc00y");


const $5ada21a6009b8ce0$var$TransferList = ({ availableOptions: availableOptions, selectedOptions: selectedOptions, setAvailableOptions: setAvailableOptions, setSelectedOptions: setSelectedOptions, required: required = false, label: label, tooltipText: tooltipText, name: name, titleColumnAvailable: titleColumnAvailable = "Options disponibles", titleColumnSelected: titleColumnSelected = "Options s\xe9lectionn\xe9es" })=>{
    const handleDragEnd = (event)=>{
        const { active: active, over: over } = event;
        // Si aucun élément n'est relâché, on ne fait rien
        if (!over) return;
        // Trouve l'élément actif dans l'une des deux listes
        const activeItem = availableOptions?.find((item)=>item.id === active.id) || selectedOptions?.find((item)=>item.id === active.id);
        if (!activeItem) return;
         // Sécurité si active.id ne correspond à aucun élément
        // Déplacement entre les listes
        if (over.id === "available" || availableOptions?.some((item)=>item.id === over.id) && selectedOptions?.some((item)=>item.id === active.id)) {
            // Déplacer de `selectedOptions` vers `availableOptions`
            setSelectedOptions((prev)=>prev.filter((item)=>item.id !== active.id));
            setAvailableOptions((prev)=>[
                    ...prev,
                    activeItem
                ]);
        } else if ((over.id === "selected" || selectedOptions?.some((item)=>item.id === over.id)) && availableOptions?.some((item)=>item.id === active.id)) {
            // Déplacer de `availableOptions` vers `selectedOptions`
            setAvailableOptions((prev)=>prev.filter((item)=>item.id !== active.id));
            setSelectedOptions((prev)=>[
                    ...prev,
                    activeItem
                ]);
        } else if (over.id !== "available" && selectedOptions?.some((item)=>item.id === active.id)) {
            const oldIndex = selectedOptions.findIndex((item)=>item.id === active.id);
            const newIndex = selectedOptions.findIndex((item)=>item.id === over.id);
            setSelectedOptions((items)=>(0, $6e75a0664b0e0f07$export$5d49d615ad5ea2b0)(items, oldIndex, newIndex));
        }
    };
    return availableOptions && selectedOptions && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $3b30af0a3bfceeb3$export$2d5c5ceac203fc1e), {
        collisionDetection: (0, $3b30af0a3bfceeb3$export$c8e785ae6b74bab8),
        onDragEnd: handleDragEnd,
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$842aba50ed0ce9d7), {
                name: name,
                label: label,
                required: required,
                tooltipText: tooltipText
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                className: "bg-secondary p-3",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $6e75a0664b0e0f07$export$86155fde54f06e6a), {
                    items: availableOptions.concat(selectedOptions).map((item)=>item.id),
                    strategy: (0, $6e75a0664b0e0f07$export$fe2be640df2ffb9e),
                    children: [
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                            className: "border border-2 border-primary-subtle rounded-2 m-2 p-2",
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($5ada21a6009b8ce0$var$DroppableList, {
                                id: "available",
                                items: availableOptions,
                                title: titleColumnAvailable
                            })
                        }),
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                            className: "border border-2 rounded-2 border-primary-subtle m-2 p-2",
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($5ada21a6009b8ce0$var$DroppableList, {
                                id: "selected",
                                items: selectedOptions,
                                title: titleColumnSelected
                            })
                        })
                    ]
                })
            })
        ]
    });
};
const $5ada21a6009b8ce0$var$DroppableList = ({ id: id, items: items, title: title })=>{
    const { setNodeRef: setNodeRef } = (0, $3b30af0a3bfceeb3$export$d74e5d67dc2b3176)({
        id: id
    });
    return items && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                xs: 12,
                className: "text-center m-2 h5",
                children: title
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                xs: 12,
                ref: setNodeRef,
                className: "list-group",
                children: items.map((item)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($5ada21a6009b8ce0$var$DraggableItem, {
                        item: item
                    }, item.id))
            })
        ]
    });
};
const $5ada21a6009b8ce0$var$DraggableItem = ({ item: item })=>{
    // Gestion du tri et du drag
    const { attributes: attributes, listeners: listeners, setNodeRef: setNodeRef, transform: transform, transition: transition } = (0, $6e75a0664b0e0f07$export$4ebcb6201122185a)({
        id: item.id
    });
    // Gestion du drop (pour accepter des éléments)
    const { setNodeRef: setDroppableRef } = (0, $3b30af0a3bfceeb3$export$d74e5d67dc2b3176)({
        id: item.id
    });
    // Fusion des refs
    const setRefs = (node)=>{
        setNodeRef(node);
        setDroppableRef(node);
    };
    const style = {
        transform: (0, $f5d873c94758f78f$export$c4ffa16951855e28).Translate.toString(transform),
        transition: transition,
        cursor: "grab"
    };
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
        ref: setRefs,
        style: style,
        ...listeners,
        ...attributes,
        className: "list-group-item d-flex justify-content-between align-items-center",
        children: item.libelle
    });
};
var $5ada21a6009b8ce0$export$2e2bcd8739ae039 = $5ada21a6009b8ce0$var$TransferList;
const $5ada21a6009b8ce0$export$3134abb19e37c62d = ({ listeDisponible: listeDisponible, listeSelectionne: listeSelectionne, nameFormik: nameFormik, useFormik: useFormik = true })=>{
    const { setFieldValue: setFieldValue } = (0, $bkJfK.useFormikContext)() || {};
    const [availableOptions, setAvailableOptions] = (0, $kc00y.useState)(listeDisponible);
    const [selectedOptions, setSelectedOptions] = (0, $kc00y.useState)(listeSelectionne);
    (0, $kc00y.useEffect)(()=>{
        if (useFormik && listeSelectionne != null && selectedOptions?.length !== listeSelectionne?.length) setSelectedOptions(listeSelectionne ? listeSelectionne : []);
    }, [
        listeSelectionne,
        selectedOptions,
        useFormik
    ]);
    (0, $kc00y.useEffect)(()=>{
        if (useFormik && setFieldValue && nameFormik) setFieldValue(nameFormik, selectedOptions);
        const filteredOptions = availableOptions?.filter((option)=>!selectedOptions?.some((selected)=>selected.id === option.id));
        if (availableOptions?.length !== filteredOptions?.length) setAvailableOptions(filteredOptions);
    }, [
        selectedOptions,
        availableOptions,
        useFormik,
        setFieldValue,
        nameFormik
    ]);
    return {
        availableOptions: availableOptions,
        selectedOptions: selectedOptions,
        setAvailableOptions: setAvailableOptions,
        setSelectedOptions: setSelectedOptions
    };
};




const $02fafb2040909791$var$typeAgent = [
    {
        id: "UTILISATEUR_CONNECTE_OBLIGATOIRE",
        libelle: "Utilisateur connect\xe9 obligatoire"
    },
    {
        id: "UTILISATEUR_CONNECTE",
        libelle: "Utilisateur connect\xe9"
    },
    {
        id: "COMPOSANT_AGENT_ONLY",
        libelle: "Liste des agents"
    },
    {
        id: "VALEUR_PRECEDENTE",
        libelle: "Valeur pr\xe9c\xe9dente"
    }
];
var $02fafb2040909791$export$2e2bcd8739ae039 = $02fafb2040909791$var$typeAgent;







var $703a40e91b65be4e$var$TYPE_PARAMETRE = /*#__PURE__*/ function(TYPE_PARAMETRE) {
    TYPE_PARAMETRE["INTEGER"] = "Nombre entier";
    TYPE_PARAMETRE["STRING"] = "Texte";
    TYPE_PARAMETRE["GEOMETRY"] = "G\xe9om\xe9trie";
    TYPE_PARAMETRE["BINARY"] = "Fichier";
    TYPE_PARAMETRE["DOUBLE"] = "Nombre d\xe9cimal";
    TYPE_PARAMETRE["BOOLEAN"] = "Bool\xe9en";
    TYPE_PARAMETRE["MULTI_STRING"] = "Liste de valeurs d\xe9finies";
    TYPE_PARAMETRE["MULTI_INT"] = "Liste d'entiers positifs";
    TYPE_PARAMETRE["SELECT"] = "Choix parmi une liste";
    return TYPE_PARAMETRE;
}($703a40e91b65be4e$var$TYPE_PARAMETRE || {});
var $703a40e91b65be4e$export$2e2bcd8739ae039 = $703a40e91b65be4e$var$TYPE_PARAMETRE;










const $b8fb5829c98aa3b7$var$TypeOrganismeMultiSelectParam = ({ name: name, label: label, selectedCodes: selectedCodes, setFieldValue: setFieldValue, required: required = true })=>{
    const typeOrganismeState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/type-organisme/get-active`);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $bd415ca04deb1f3d$export$4d11f9169b62ad26), {
        type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).MULTI_STRING,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$eae70af4b4e3f197), {
            name: name,
            label: label,
            required: required,
            options: typeOrganismeState?.data ?? [],
            getOptionValue: (t)=>t.typeOrganismeCode,
            getOptionLabel: (t)=>t.typeOrganismeLibelle,
            value: selectedCodes?.map((code)=>typeOrganismeState?.data?.find((r)=>r.typeOrganismeCode === code)) ?? undefined,
            onChange: (typeOrganisme = [])=>{
                const typeOrganismeCode = typeOrganisme.map((e)=>e.typeOrganismeCode);
                setFieldValue(name, typeOrganismeCode.length > 0 ? typeOrganismeCode : []);
            }
        })
    });
};
var $b8fb5829c98aa3b7$export$2e2bcd8739ae039 = $b8fb5829c98aa3b7$var$TypeOrganismeMultiSelectParam;


const $bd415ca04deb1f3d$export$a5cab80145b70e98 = (data)=>({
        general: data?.general,
        signalement: data?.signalement,
        mobile: {
            ...data?.mobile,
            caracteristiquesPibiIds: data?.mobile?.caracteristiquesPibi?.map((e)=>({
                    id: e
                })) ?? [],
            caracteristiquesPenaIds: data?.mobile?.caracteristiquesPena?.map((e)=>({
                    id: e
                })) ?? []
        },
        cartographie: data?.cartographie,
        couvertureHydraulique: {
            ...data?.couvertureHydraulique,
            deciIsodistances: Array.isArray(data?.couvertureHydraulique?.deciIsodistances) ? data.couvertureHydraulique.deciIsodistances.join(",") : typeof data?.couvertureHydraulique?.deciIsodistances === "string" ? data.couvertureHydraulique.deciIsodistances : ""
        },
        dfci: data?.dfci,
        permis: data?.permis,
        pei: {
            ...data?.pei,
            peiColonnesIds: data?.pei?.peiColonnes?.map((e)=>({
                    id: e,
                    libelle: e
                })),
            caracteristiquesPibiTooltipWebIds: data?.pei?.caracteristiquesPibiTooltipWeb?.map((e)=>({
                    id: e
                })) ?? [],
            caracteristiquesPenaTooltipWebIds: data?.pei?.caracteristiquesPenaTooltipWeb?.map((e)=>({
                    id: e
                })) ?? []
        },
        peiLongueIndispo: data?.peiLongueIndispo,
        rcci: data?.rcci,
        utilisateur: data?.utilisateur,
        courrier: data?.courrier
    });
const $bd415ca04deb1f3d$export$c084437b5e3206cd = (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({
    general: (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({
        titrePage: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
        toleranceVoiesMetres: (0, $36ceaed6faf947af$export$d73626444d3ce57a)
    }),
    signalement: (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({
        signalementDeliberationDestinataireEmail: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
        signalementDeliberationObjetEmail: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
        signalementDeliberationCorpsEmail: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba)
    }),
    cartographie: (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({
        coordonneesFormatAffichage: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba)
    }),
    couvertureHydraulique: (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({
        deciDistanceMaxParcours: (0, $36ceaed6faf947af$export$d73626444d3ce57a),
        deciIsodistances: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
        profondeurCouverture: (0, $36ceaed6faf947af$export$d73626444d3ce57a)
    }),
    dfci: (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({
        dfciTravauxDestinataireEmail: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
        dfciTravauxObjetEmail: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
        dfciTravauxCorpsEmail: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba)
    }),
    permis: (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({
        permisToleranceChargementMetres: (0, $36ceaed6faf947af$export$d73626444d3ce57a)
    }),
    pei: (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({
        peiHighlightDuree: (0, $36ceaed6faf947af$export$d73626444d3ce57a),
        peiHighlightRayon: (0, $36ceaed6faf947af$export$d73626444d3ce57a),
        peiHighlightLargeur: (0, $36ceaed6faf947af$export$d73626444d3ce57a),
        peiSelectionRayon: (0, $36ceaed6faf947af$export$d73626444d3ce57a),
        peiSelectionLargeur: (0, $36ceaed6faf947af$export$d73626444d3ce57a),
        peiToleranceCommuneMetres: (0, $36ceaed6faf947af$export$d73626444d3ce57a),
        peiRouteHistorique: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
        vitesseEau: (0, $36ceaed6faf947af$export$d73626444d3ce57a),
        peiDelaiCtrlUrgent: (0, $36ceaed6faf947af$export$d73626444d3ce57a),
        peiDelaiCtrlWarn: (0, $36ceaed6faf947af$export$d73626444d3ce57a),
        peiDelaiRecoUrgent: (0, $36ceaed6faf947af$export$d73626444d3ce57a),
        peiDelaiRecoWarn: (0, $36ceaed6faf947af$export$d73626444d3ce57a),
        peiRenouvellementCtrlPrive: (0, $36ceaed6faf947af$export$d73626444d3ce57a),
        peiRenouvellementCtrlPublic: (0, $36ceaed6faf947af$export$d73626444d3ce57a),
        peiRenouvellementCtrlConventionne: (0, $36ceaed6faf947af$export$d73626444d3ce57a),
        peiRenouvellementCtrlIcpe: (0, $36ceaed6faf947af$export$d73626444d3ce57a),
        peiRenouvellementCtrlIcpeConventionne: (0, $36ceaed6faf947af$export$d73626444d3ce57a),
        peiRenouvellementRecoPrive: (0, $36ceaed6faf947af$export$d73626444d3ce57a),
        peiRenouvellementRecoPublic: (0, $36ceaed6faf947af$export$d73626444d3ce57a),
        peiRenouvellementRecoIcpe: (0, $36ceaed6faf947af$export$d73626444d3ce57a),
        peiRenouvellementRecoIcpeConventionne: (0, $36ceaed6faf947af$export$d73626444d3ce57a),
        peiRenouvellementRecoConventionne: (0, $36ceaed6faf947af$export$d73626444d3ce57a),
        peiDeplacementDistWarn: (0, $36ceaed6faf947af$export$d73626444d3ce57a),
        bufferCarte: (0, $36ceaed6faf947af$export$d73626444d3ce57a),
        declarationPeiDestinataireEmail: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
        declarationPeiObjetEmail: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
        declarationPeiCorpsEmail: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba)
    }),
    peiLongueIndispo: (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({
        peiLongueIndisponibiliteMessage: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
        peiLongueIndisponibiliteJours: (0, $36ceaed6faf947af$export$d73626444d3ce57a)
    }),
    mobile: (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({
        dureeValiditeToken: (0, $36ceaed6faf947af$export$d73626444d3ce57a)
    }),
    courrier: (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({
        courrierRestrictionZC: (0, $36ceaed6faf947af$export$87bba3bb7a1f4285)
    })
});
const $bd415ca04deb1f3d$export$f97400759cfd946 = (values)=>{
    return {
        general: values?.general,
        signalement: values?.signalement,
        mobile: {
            ...values?.mobile,
            caracteristiquesPena: values?.mobile?.caracteristiquesPenaIds?.map((e)=>e.id) ?? [],
            caracteristiquesPibi: values?.mobile?.caracteristiquesPibiIds?.map((e)=>e.id) ?? []
        },
        cartographie: values?.cartographie,
        couvertureHydraulique: {
            ...values?.couvertureHydraulique,
            deciIsodistances: values?.couvertureHydraulique?.deciIsodistances?.toString()
        },
        dfci: values?.dfci,
        permis: values?.permis,
        pei: {
            ...values?.pei,
            peiColonnes: values?.pei?.peiColonnesIds?.map((e)=>e.id) ?? [],
            caracteristiquesPenaTooltipWeb: values?.pei?.caracteristiquesPenaTooltipWebIds?.map((e)=>e.id) ?? [],
            caracteristiquesPibiTooltipWeb: values?.pei?.caracteristiquesPibiTooltipWebIds?.map((e)=>e.id) ?? []
        },
        peiLongueIndispo: values?.peiLongueIndispo,
        rcci: values?.rcci,
        utilisateur: values?.utilisateur,
        courrier: values?.courrier
    };
};
/**
 * Permet de vérifier si le formulaire est conforme. S'il ne l'est pas, on ouvre la section qui doit être modifiée
 * et on scroll jusqu'au premier champ en erreur.
 */ function $bd415ca04deb1f3d$var$checkValidity(values, show, listValuesWithConstraints) {
    let firstErrorField = null;
    listValuesWithConstraints.forEach((e)=>{
        const value = (0, $bkJfK.getIn)(values, e.name);
        if (value === null || value === "" || value === undefined || Array.isArray(value) && value.length === 0) {
            show(e.accordionIndex);
            if (!firstErrorField) firstErrorField = e.name;
        }
    });
    // Scroll vers le premier champ en erreur
    if (firstErrorField) {
        const fieldElement = document.querySelector(`[name="${firstErrorField}"]`);
        if (fieldElement) fieldElement.scrollIntoView({
            behavior: "smooth",
            block: "center"
        });
    }
}
const $bd415ca04deb1f3d$var$AdminParametres = ()=>{
    const adminParametresState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/admin/parametres`);
    const { data: data } = adminParametresState;
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
        initialValues: $bd415ca04deb1f3d$export$a5cab80145b70e98(data),
        validationSchema: $bd415ca04deb1f3d$export$c084437b5e3206cd,
        isPost: false,
        submitUrl: `/api/admin/parametres`,
        prepareVariables: (values)=>$bd415ca04deb1f3d$export$f97400759cfd946(values),
        onSubmit: ()=>null,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$ad1b429e7ac964c6, {})
    });
};
const $bd415ca04deb1f3d$export$ad1b429e7ac964c6 = ()=>{
    const { values: values, setFieldValue: setFieldValue } = (0, $bkJfK.useFormikContext)();
    const allCaracteristiques = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/admin/pei-caracteristique`)?.data;
    const { activesKeys: activesKeys, handleShowClose: handleShowClose, show: show } = (0, $db860d90b4a42fea$export$dae930a4ba30758b)(Array(10).fill(false));
    const { user: user } = (0, $e787cde576104469$export$fdc397e486fa83e7)();
    // Liste des champs obligatoires avec leur index dans l'accordion
    // Permet d'ouvrir la section correspondante si un champ obligatoire n'est pas renseigné
    const listValuesWithConstraints = [
        // Général (0)
        {
            name: "general.titrePage",
            accordionIndex: 0
        },
        {
            name: "general.toleranceVoiesMetres",
            accordionIndex: 0
        },
        // Signalement (1)
        {
            name: "signalement.signalementDeliberationDestinataireEmail",
            accordionIndex: 1
        },
        {
            name: "signalement.signalementDeliberationObjetEmail",
            accordionIndex: 1
        },
        {
            name: "signalement.signalementDeliberationCorpsEmail",
            accordionIndex: 1
        },
        // Cartographie (2)
        {
            name: "cartographie.coordonneesFormatAffichage",
            accordionIndex: 2
        },
        {
            name: "pei.peiHighlightDuree",
            accordionIndex: 2
        },
        {
            name: "pei.peiHighlightRayon",
            accordionIndex: 2
        },
        {
            name: "pei.peiHighlightLargeur",
            accordionIndex: 2
        },
        {
            name: "pei.peiSelectionRayon",
            accordionIndex: 2
        },
        {
            name: "pei.peiSelectionLargeur",
            accordionIndex: 2
        },
        // Couverture hydraulique (3)
        {
            name: "couvertureHydraulique.deciDistanceMaxParcours",
            accordionIndex: 3
        },
        {
            name: "couvertureHydraulique.deciIsodistances",
            accordionIndex: 3
        },
        {
            name: "couvertureHydraulique.profondeurCouverture",
            accordionIndex: 3
        },
        // DFCI (4)
        {
            name: "dfci.dfciTravauxDestinataireEmail",
            accordionIndex: 4
        },
        {
            name: "dfci.dfciTravauxObjetEmail",
            accordionIndex: 4
        },
        {
            name: "dfci.dfciTravauxCorpsEmail",
            accordionIndex: 4
        },
        {
            name: "dfci.dfciToleranceDfciPisteMetres",
            accordionIndex: 4
        },
        // Permis (5)
        {
            name: "permis.permisToleranceChargementMetres",
            accordionIndex: 5
        },
        // PEI (6) - dans l'ordre d'affichage
        {
            name: "pei.peiColonnes",
            accordionIndex: 6
        },
        {
            name: "pei.peiToleranceCommuneMetres",
            accordionIndex: 6
        },
        {
            name: "pei.peiRouteHistorique",
            accordionIndex: 6
        },
        {
            name: "pei.vitesseEau",
            accordionIndex: 6
        },
        {
            name: "pei.peiDelaiCtrlUrgent",
            accordionIndex: 6
        },
        {
            name: "pei.peiDelaiCtrlWarn",
            accordionIndex: 6
        },
        {
            name: "pei.peiDelaiRecoUrgent",
            accordionIndex: 6
        },
        {
            name: "pei.peiDelaiRecoWarn",
            accordionIndex: 6
        },
        {
            name: "pei.peiRenouvellementCtrlPrive",
            accordionIndex: 6
        },
        {
            name: "pei.peiRenouvellementCtrlPublic",
            accordionIndex: 6
        },
        {
            name: "pei.peiRenouvellementCtrlConventionne",
            accordionIndex: 6
        },
        {
            name: "pei.peiRenouvellementCtrlIcpe",
            accordionIndex: 6
        },
        {
            name: "pei.peiRenouvellementCtrlIcpeConventionne",
            accordionIndex: 6
        },
        {
            name: "pei.peiRenouvellementRecoPrive",
            accordionIndex: 6
        },
        {
            name: "pei.peiRenouvellementRecoPublic",
            accordionIndex: 6
        },
        {
            name: "pei.peiRenouvellementRecoIcpe",
            accordionIndex: 6
        },
        {
            name: "pei.peiRenouvellementRecoIcpeConventionne",
            accordionIndex: 6
        },
        {
            name: "pei.peiRenouvellementRecoConventionne",
            accordionIndex: 6
        },
        {
            name: "pei.peiDeplacementDistWarn",
            accordionIndex: 6
        },
        {
            name: "pei.bufferCarte",
            accordionIndex: 6
        },
        {
            name: "pei.declarationPeiDestinataireEmail",
            accordionIndex: 6
        },
        {
            name: "pei.declarationPeiObjetEmail",
            accordionIndex: 6
        },
        {
            name: "pei.declarationPeiCorpsEmail",
            accordionIndex: 6
        },
        ...values?.pei?.autoriserMailVisiteReception ? [
            {
                name: "pei.peiOrganismeNotificationVisiteReception",
                accordionIndex: 6
            }
        ] : [],
        ...values?.pei?.autoriserMailRoi ? [
            {
                name: "pei.peiOrganismeNotificationRoi",
                accordionIndex: 6
            }
        ] : [],
        // PEI longue indisponibilité (7)
        {
            name: "peiLongueIndispo.peiLongueIndisponibiliteMessage",
            accordionIndex: 7
        },
        {
            name: "peiLongueIndispo.peiLongueIndisponibiliteJours",
            accordionIndex: 7
        },
        {
            name: "peiLongueIndispo.peiLongueIndisponibiliteTypeOrganisme",
            accordionIndex: 7
        },
        // Application mobile (9)
        {
            name: "mobile.dureeValiditeToken",
            accordionIndex: 9
        },
        {
            name: "mobile.gestionAgent",
            accordionIndex: 9
        }
    ];
    return values && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                    title: "Param\xe8tres applicatifs",
                    icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$20b7f16ef18cfa38), {})
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db860d90b4a42fea$export$2e2bcd8739ae039), {
                    activesKeys: activesKeys,
                    list: [
                        ...(0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_PARAM_APPLI) ? [
                            {
                                header: "G\xe9n\xe9ral",
                                content: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$var$AdminGeneral, {
                                    values: values.general
                                })
                            },
                            {
                                header: "Signalement",
                                content: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$var$AdminSignalement, {
                                    values: values.signalement
                                })
                            },
                            {
                                header: "Cartographie",
                                content: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$var$AdminCartographie, {
                                    values: values.cartographie
                                })
                            },
                            {
                                header: "Couverture hydraulique",
                                content: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$var$AdminCouvertureHydraulique, {
                                    values: values.couvertureHydraulique
                                })
                            },
                            {
                                header: "DFCI",
                                content: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$var$AdminDfci, {
                                    values: values.dfci
                                })
                            },
                            {
                                header: "Permis",
                                content: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$var$AdminPermis, {
                                    values: values.permis
                                })
                            },
                            {
                                header: "PEI",
                                content: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$var$AdminPei, {
                                    values: values.pei,
                                    allCaracteristiques: allCaracteristiques
                                })
                            },
                            {
                                header: "PEI longue indisponibilit\xe9",
                                content: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$var$AdminPeiLongueIndispo, {
                                    values: values.peiLongueIndispo,
                                    setFieldValue: setFieldValue
                                })
                            },
                            {
                                header: "RCCI",
                                content: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$var$AdminRcci, {
                                    values: values.rcci,
                                    setFieldValue: setFieldValue
                                })
                            },
                            {
                                header: "Utilisateur",
                                content: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$var$AdminUtilisateur, {
                                    values: values.utilisateur,
                                    setFieldValue: setFieldValue
                                })
                            }
                        ] : [],
                        ...(0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_PARAM_APPLI_MOBILE) ? [
                            {
                                header: "Application mobile",
                                content: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$var$AdminApplicationMobile, {
                                    values: values.mobile,
                                    allCaracteristiques: allCaracteristiques
                                })
                            }
                        ] : [],
                        {
                            header: "Courrier",
                            content: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$var$AdminCourrier, {
                                values: values.courrier,
                                setFieldValue: setFieldValue
                            })
                        }
                    ],
                    handleShowClose: handleShowClose
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db9b0e6fdb142a4c$export$2e2bcd8739ae039), {
                    returnLink: true,
                    onClick: ()=>{
                        $bd415ca04deb1f3d$var$checkValidity(values, show, listValuesWithConstraints);
                    }
                })
            ]
        })
    });
};
const $bd415ca04deb1f3d$export$4d11f9169b62ad26 = ({ type: type = (0, $703a40e91b65be4e$export$2e2bcd8739ae039).STRING, children: children })=>{
    let bg = "primary";
    let text = "light";
    switch(type){
        case (0, $703a40e91b65be4e$export$2e2bcd8739ae039).INTEGER:
            bg = "success";
            text = "dark";
            break;
        case (0, $703a40e91b65be4e$export$2e2bcd8739ae039).BOOLEAN:
            bg = "info";
            text = "light";
            break;
        case (0, $703a40e91b65be4e$export$2e2bcd8739ae039).BINARY:
            bg = "dark";
            text = "light";
            break;
        case (0, $703a40e91b65be4e$export$2e2bcd8739ae039).DOUBLE:
            bg = "warning";
            text = "dark";
            break;
        case (0, $703a40e91b65be4e$export$2e2bcd8739ae039).GEOMETRY:
            bg = "danger";
            text = "light";
            break;
        case (0, $703a40e91b65be4e$export$2e2bcd8739ae039).MULTI_STRING:
        case (0, $703a40e91b65be4e$export$2e2bcd8739ae039).MULTI_INT:
            bg = "secondary";
            text = "dark";
            break;
        case (0, $703a40e91b65be4e$export$2e2bcd8739ae039).SELECT:
            bg = "light";
            text = "dark";
            break;
    }
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                    xs: 2,
                    className: "text-end",
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $98f55aa78fbaf278$export$2e2bcd8739ae039), {
                        bg: bg,
                        text: text,
                        pill: true,
                        className: "mt-3 ms-auto",
                        children: type
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                    xs: 10,
                    children: children
                })
            ]
        })
    });
};
var $bd415ca04deb1f3d$export$2e2bcd8739ae039 = $bd415ca04deb1f3d$var$AdminParametres;
const $bd415ca04deb1f3d$var$AdminGeneral = ({ values: values })=>{
    return values && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).STRING,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                    name: "general.mentionCnil",
                    label: "Mention CNIL",
                    tooltipText: "Mention CNIL affich\xe9e en bas de page (peut \xeatre vide)",
                    required: false
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).STRING,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                    name: "general.messageEntete",
                    label: "Message d'ent\xeate",
                    tooltipText: "Message affich\xe9 dans le cartouche d'ent\xeate",
                    required: false
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).STRING,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                    name: "general.titrePage",
                    label: "Titre de la page",
                    tooltipText: "Titre affich\xe9 dans l'ent\xeate du navigateur"
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).INTEGER,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$2e2bcd8739ae039), {
                    name: "general.toleranceVoiesMetres",
                    label: "Tol\xe9rance (en m) de chargement des voies",
                    tooltipText: "Utilis\xe9 dans le chargement des listes d\xe9roulantes des voies lorsque les g\xe9om\xe9tries ne sont pas parfaitement en phase"
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).STRING,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$ce9b1cc0c34506d0), {
                    name: "general.accueilPublic",
                    required: false,
                    label: "Personnaliser la page d'accueil publique",
                    tooltipText: "\xc9crivez du HTML pour personnaliser votre page d'accueil publique."
                })
            })
        ]
    });
};
const $bd415ca04deb1f3d$var$AdminApplicationMobile = ({ values: values, allCaracteristiques: allCaracteristiques })=>{
    const { setFieldValue: setFieldValue } = (0, $bkJfK.useFormikContext)();
    // Charger toutes les caractéristiques
    const { availableOptions: availablePibiOptions, setAvailableOptions: setAvailablePibiOptions, selectedOptions: selectedPibiOptions, setSelectedOptions: setSelectedPibiOptions } = (0, $5ada21a6009b8ce0$export$3134abb19e37c62d)({
        listeDisponible: null,
        listeSelectionne: null,
        nameFormik: "mobile.caracteristiquesPibiIds"
    });
    const { availableOptions: availablePenaOptions, setAvailableOptions: setAvailablePenaOptions, selectedOptions: selectedPenaOptions, setSelectedOptions: setSelectedPenaOptions } = (0, $5ada21a6009b8ce0$export$3134abb19e37c62d)({
        listeDisponible: null,
        listeSelectionne: null,
        nameFormik: "mobile.caracteristiquesPenaIds"
    });
    (0, $kc00y.useMemo)(()=>{
        if (!allCaracteristiques || !values?.caracteristiquesPibiIds || !values?.caracteristiquesPenaIds) return;
        //PIBI
        if (availablePibiOptions == null) setAvailablePibiOptions(allCaracteristiques.filter((item)=>item.type === "PIBI" || item.type === "GENERAL"));
        if (selectedPibiOptions == null) setSelectedPibiOptions(allCaracteristiques.filter((item)=>{
            return values?.caracteristiquesPibiIds?.map((e)=>e.id).includes(item.id);
        }));
        //PENA
        if (availablePenaOptions == null) setAvailablePenaOptions(allCaracteristiques.filter((item)=>item.type === "PENA" || item.type === "GENERAL"));
        if (selectedPenaOptions == null) setSelectedPenaOptions(allCaracteristiques.filter((item)=>{
            return values?.caracteristiquesPenaIds?.map((e)=>e.id).includes(item.id);
        }));
    }, [
        values,
        availablePenaOptions,
        availablePibiOptions,
        selectedPenaOptions,
        selectedPibiOptions,
        setAvailablePenaOptions,
        setAvailablePibiOptions,
        setSelectedPenaOptions,
        setSelectedPibiOptions,
        allCaracteristiques
    ]);
    return values && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).BOOLEAN,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                    name: "mobile.affichageIndispo",
                    label: "Afficher l'\xe9tat de disponibilit\xe9 du PEI",
                    checked: values?.affichageIndispo,
                    tooltipText: "Ajout d'une croix rouge sur le symbole du PEI pour signifier l'indisponibilit\xe9"
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).BOOLEAN,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                    name: "mobile.affichageSymbolesNormalises",
                    label: "Utiliser la symbologie du RNDECI",
                    checked: values?.affichageSymbolesNormalises,
                    tooltipText: "Utiliser la symbologie d\xe9finie dans le RNDECI plut\xf4t que des cercles"
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).MULTI_STRING,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $5ada21a6009b8ce0$export$2e2bcd8739ae039), {
                    availableOptions: availablePibiOptions,
                    selectedOptions: selectedPibiOptions,
                    setAvailableOptions: setAvailablePibiOptions,
                    setSelectedOptions: setSelectedPibiOptions,
                    label: "Caract\xe9ristiques \xe0 afficher pour les PIBI",
                    tooltipText: "Dans l'infobulle d'un PEI sur l'application mobile, on affiche des caract\xe9ristiques. Ce param\xe8tre permet de d\xe9finir lesquelles, et dans quel ordre elles se pr\xe9sentent",
                    required: false,
                    name: "mobile.caracteristiquePibi"
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).MULTI_STRING,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $5ada21a6009b8ce0$export$2e2bcd8739ae039), {
                    availableOptions: availablePenaOptions,
                    selectedOptions: selectedPenaOptions,
                    setAvailableOptions: setAvailablePenaOptions,
                    setSelectedOptions: setSelectedPenaOptions,
                    label: "Caract\xe9ristiques \xe0 afficher pour les PENA",
                    tooltipText: "Dans l'infobulle d'un PEI sur l'application mobile, on affiche des caract\xe9ristiques. Ce param\xe8tre permet de d\xe9finir lesquelles, et dans quel ordre elles se pr\xe9sentent",
                    required: false,
                    name: "mobile.caracteristiquePena"
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).INTEGER,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$2e2bcd8739ae039), {
                    name: "mobile.dureeValiditeToken",
                    label: "Dur\xe9e de validit\xe9 du token",
                    tooltipText: "Dur\xe9e (en heures) de validit\xe9 du jeton de connexion \xe0 l'application mobile."
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).SELECT,
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$d6701e98ab1a6725), {
                        name: "mobile.gestionAgent",
                        label: "Type d'agent s\xe9lectionn\xe9",
                        options: (0, $02fafb2040909791$export$2e2bcd8739ae039),
                        getOptionValue: (v)=>v.id,
                        getOptionLabel: (v)=>v.libelle,
                        onChange: (e)=>setFieldValue(`mobile.gestionAgent`, (0, $02fafb2040909791$export$2e2bcd8739ae039).find((type)=>type.id === e.id)?.id),
                        defaultValue: (0, $02fafb2040909791$export$2e2bcd8739ae039).find((e)=>e.id === values.gestionAgent)
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $918dca194c1aeb0f$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("p", {
                                    className: "m-2",
                                    children: [
                                        "C'est un champ texte mix\xe9 avec une liste d\xe9roulante, comme par exemple les listes d\xe9roulantes de l'acc\xe8s rapide du module point d'eau (application web remocra). Par d\xe9faut il est vide. L'utilisateur saisit ce qu'il veut ( Michel Dupont par exemple, ou toto@sdisXX.fr ), on va stocker cette valeur dans les propri\xe9t\xe9s de l'application (commun \xe0 tous les utilisateurs de cette tablette) A la prochaine saisie, l'utilisateur peut soit rajouter un autre agent, soit retrouver les valeurs pr\xe9c\xe9demment saisies. La liste des agents disponibles pour le composant n'est pas envoy\xe9e au serveur, c'est un facilitateur de saisie ; la tablette enverra le r\xe9sultat de la saisie pour chaque PEI.",
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                                        "Pour l'instant les sc\xe9narios suivants ont \xe9t\xe9 identifi\xe9s"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                    className: "h5",
                                    children: "Cas 1 - Utilisateur connect\xe9 obligatoire"
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("p", {
                                    className: "m-2",
                                    children: "L'agent 1 est toujours l'utilisateur connect\xe9, on pr\xe9remplit donc le champ avec ses informations. On rend le champ inaccessible pour \xe9viter une modification manuelle"
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("p", {
                                    className: "m-2",
                                    children: "L'agent 2 utilise le composant Agent"
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                    className: "h5",
                                    children: "Cas 2 - Utilisateur connect\xe9"
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("p", {
                                    className: "m-2",
                                    children: "L'agent 1 est toujours l'utilisateur connect\xe9, on pr\xe9remplit donc le champ avec ses informations. On laisse possible la saisie manuelle"
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("p", {
                                    className: "m-2",
                                    children: "L'agent 2 utilise le composant Agent"
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                    className: "h5",
                                    children: "Cas 3 - Liste des agents"
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("p", {
                                    className: "m-2",
                                    children: "Les 2 champs de formulaire sont vides par d\xe9faut, et on propose l'utilisation du composant Agent pour les 2"
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                    className: "h5",
                                    children: "Cas 4 - Valeur pr\xe9c\xe9dente"
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("p", {
                                    className: "m-2",
                                    children: "Idem cas 2, mais les valeurs par d\xe9faut correspondent \xe0 la valeur pr\xe9c\xe9demment s\xe9lectionn\xe9e"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).STRING,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                    name: "mobile.mdpAdministrateur",
                    label: "Mot de passe administrateur",
                    tooltipText: "Mot de passe permettant de d\xe9verrouiller l'administration de l'appli mobile, \xe0 savoir la configuration du serveur ; inutile lors d'un param\xe9trage via MDM",
                    password: true,
                    required: false
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).BOOLEAN,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                    name: "mobile.modeDeconnecte",
                    label: "Activer le mode d\xe9connect\xe9",
                    checked: values?.modeDeconnecte,
                    tooltipText: "Si la couverture Internet du d\xe9partement n'est pas satisfaisante, vous pouvez passer par le 'mode d\xe9connect\xe9' pour permettre une connexion d'un utilisateur sur une longue dur\xe9e."
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).BOOLEAN,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                    name: "mobile.creationPeiMobile",
                    label: "Autoriser la cr\xe9ation de PEI",
                    checked: values?.creationPeiMobile,
                    tooltipText: "Active ou non la fonctionnalit\xe9 de cr\xe9ation de PEI depuis l'application mobile ; si activ\xe9e, l'utilisateur devra toujours poss\xe9der le droit ad\xe9quat."
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).BOOLEAN,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                    name: "mobile.bridagePhoto",
                    label: "Brider la taille des photos",
                    checked: values?.bridagePhoto,
                    tooltipText: "Les photos prises par l'application mobile peut \xeatre de taille importante, et en fonction de la volum\xe9trie des PEI des tourn\xe9es, on peut avoir des probl\xe8mes de synchronisation. R\xe9duire \xe0 environ 1920*1080px les photos limite drastiquement le poids de celles-ci, donc les probl\xe8mes li\xe9s lors de la synchronisation."
                })
            })
        ]
    });
};
const $bd415ca04deb1f3d$var$AdminSignalement = ({ values: values })=>{
    return values && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).STRING,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$ce9b1cc0c34506d0), {
                    name: "signalement.signalementDeliberationDestinataireEmail",
                    label: "Adresse email qui recevra une notification lors du d\xe9p\xf4t d'une d\xe9lib\xe9ration"
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).STRING,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$ce9b1cc0c34506d0), {
                    name: "signalement.signalementDeliberationObjetEmail",
                    label: "Objet du mail de notification lors du d\xe9p\xf4t d'une d\xe9lib\xe9ration"
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).STRING,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$ce9b1cc0c34506d0), {
                    name: "signalement.signalementDeliberationCorpsEmail",
                    label: "Contenu du mail de notification lors du d\xe9p\xf4t d'une d\xe9lib\xe9ration",
                    tooltipText: "Vous pouvez utiliser #[ORGANISME_UTILISATEUR]# et #[LIEN_TELECHARGEMENT]# dans votre message. Ces deux valeurs seront remplac\xe9es automatiquement."
                })
            })
        ]
    });
};
const $bd415ca04deb1f3d$var$AdminCartographie = ({ values: values })=>{
    const { setFieldValue: setFieldValue } = (0, $bkJfK.useFormikContext)();
    const { data: zoneCompetence } = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/zone-integration/get-active`);
    const toponymieList = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/toponymie/get-libelle-toponymie`);
    return values && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).SELECT,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$d6701e98ab1a6725), {
                    name: "cartographie.coordonneesFormatAffichage",
                    label: "Format d'affichage des coordonn\xe9es",
                    options: (0, $2787da6a8e84611c$export$2e2bcd8739ae039),
                    getOptionValue: (v)=>v.id,
                    getOptionLabel: (v)=>v.libelle,
                    onChange: (e)=>setFieldValue(`cartographie.coordonneesFormatAffichage`, (0, $2787da6a8e84611c$export$2e2bcd8739ae039).find((type)=>type.id === e.id)?.id),
                    defaultValue: (0, $2787da6a8e84611c$export$2e2bcd8739ae039).find((e)=>e.id === values.coordonneesFormatAffichage)
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).SELECT,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$d6701e98ab1a6725), {
                    name: "cartographie.empriseNative",
                    label: "Emprise par d\xe9faut de la carte",
                    options: zoneCompetence,
                    getOptionValue: (v)=>v.code,
                    getOptionLabel: (v)=>v.libelle,
                    required: false,
                    tooltipText: "Emprise g\xe9ographique affich\xe9e par d\xe9faut sur la carte lorsque l'utilisateur n'est pas connect\xe9 ou lorsqu'il n'a pas de zone de comp\xe9tence d\xe9finie (cas des super administrateurs)",
                    onChange: (e)=>setFieldValue(`cartographie.empriseNative`, zoneCompetence?.find((zc)=>zc.id === e.id)?.code),
                    defaultValue: zoneCompetence?.find((e)=>e.code === values.empriseNative)
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).INTEGER,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$2e2bcd8739ae039), {
                    name: "pei.peiHighlightDuree",
                    label: "Dur\xe9e (en secondes) de mise en surbrillance des PEI",
                    tooltipText: "Lors d'une localisation de PEI depuis une source ext\xe9rieure (PEI, IT, ...), on met en \xe9vidence bri\xe8vement les PEI concern\xe9s"
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).STRING,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$5a1d7ca0a925d9c2), {
                    name: "pei.peiHighlightCouleur",
                    label: "Couleur de mise en surbrillance des PEI",
                    tooltipText: "Couleur du cercle de surbrillance des PEI lors d'une localisation de PEI depuis une source ext\xe9rieure (PEI, IT, ...)",
                    required: false
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).INTEGER,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$2e2bcd8739ae039), {
                    name: "pei.peiHighlightRayon",
                    label: "Rayon du cercle de surbrillance des PEI (en pixels)",
                    tooltipText: "Rayon du cercle de surbrillance des PEI lors d'une localisation de PEI depuis une source ext\xe9rieure (PEI, IT, ...)"
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).INTEGER,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$2e2bcd8739ae039), {
                    name: "pei.peiHighlightLargeur",
                    label: "Largeur du trait de surbrillance des PEI (en pixels)",
                    tooltipText: "Largeur du trait du cercle de surbrillance des PEI lors d'une localisation de PEI depuis une source ext\xe9rieure (PEI, IT, ...)"
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).STRING,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$5a1d7ca0a925d9c2), {
                    name: "pei.peiSelectionCouleur",
                    label: "Couleur de s\xe9lection des PEI",
                    tooltipText: "Couleur du cercle de s\xe9lection des PEI lors de la s\xe9lection sur la carte (Ctrl+clic ou s\xe9lection par zone)",
                    required: false
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).INTEGER,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$2e2bcd8739ae039), {
                    name: "pei.peiSelectionRayon",
                    label: "Rayon du cercle de s\xe9lection des PEI (en pixels)",
                    tooltipText: "Rayon du cercle de s\xe9lection des PEI lors de la s\xe9lection sur la carte (Ctrl+clic ou s\xe9lection par zone)"
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).INTEGER,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$2e2bcd8739ae039), {
                    name: "pei.peiSelectionLargeur",
                    label: "Largeur du trait de s\xe9lection des PEI (en pixels)",
                    tooltipText: "Largeur du trait du cercle de s\xe9lection des PEI lors de la s\xe9lection sur la carte (Ctrl+clic ou s\xe9lection par zone)"
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).BOOLEAN,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                    name: "cartographie.rechercheBan",
                    checked: values.rechercheBan,
                    label: "Rechercher par BAN",
                    tooltipText: "Permet de choisir entre une recherche par BAN ou une recherche parmi les voies et autres donn\xe9es disponibles dans la base de donn\xe9es de l'application."
                })
            }),
            values.rechercheBan && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).STRING,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                    name: "cartographie.banCodeDepartement",
                    label: "Code d\xe9partement pour la recherche BAN",
                    tooltipText: "La recherche BAN sera limit\xe9e aux d\xe9partements sp\xe9cifi\xe9s s\xe9par\xe9s par des virgules (ex: 89, 21). Si ce champ est laiss\xe9 vide, la recherche BAN s'effectuera sur l'ensemble du territoire fran\xe7ais.",
                    required: false
                })
            }),
            !values.rechercheBan && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                    type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).MULTI_STRING,
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$eae70af4b4e3f197), {
                        name: "cartographie.listeToponymieCode",
                        label: "R\xe9pertoire des lieux de recherche",
                        options: toponymieList.data?.filter((item)=>![
                                "COMMUNE",
                                "ROUTES"
                            ].includes(item.code)),
                        getOptionValue: (t)=>t.code,
                        getOptionLabel: (t)=>t.libelle,
                        isClearable: true,
                        required: false,
                        value: values.listeToponymieCode?.map((e)=>toponymieList.data?.find((c)=>c.code === e)) ?? undefined,
                        onChange: (toponymies)=>{
                            const toponymiesCode = toponymies.map((e)=>e.code);
                            toponymiesCode.length > 0 ? setFieldValue("cartographie.listeToponymieCode", toponymiesCode) : setFieldValue("cartographie.listeToponymieCode", []);
                        }
                    })
                })
            })
        ]
    });
};
const $bd415ca04deb1f3d$var$AdminCouvertureHydraulique = ({ values: values })=>{
    return values && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).INTEGER,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$2e2bcd8739ae039), {
                    name: "couvertureHydraulique.deciDistanceMaxParcours",
                    label: "Distance max de parcours (en m)"
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).MULTI_INT,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                    name: "couvertureHydraulique.deciIsodistances",
                    label: "Isodistances \xe0 prendre en compte (en m)",
                    tooltipText: "Plusieurs valeurs s\xe9par\xe9es par des virgules"
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).INTEGER,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$2e2bcd8739ae039), {
                    name: "couvertureHydraulique.profondeurCouverture",
                    label: "Profondeur de couverture (en m)"
                })
            })
        ]
    });
};
const $bd415ca04deb1f3d$var$AdminDfci = ({ values: values })=>{
    const { setFieldValue: setFieldValue } = (0, $bkJfK.useFormikContext)();
    const listeCoucheDfci = (0, $5d863552eb3c939f$export$2e2bcd8739ae039).map((e)=>({
            id: e.code,
            code: e.code,
            libelle: e.libelle
        }));
    return values && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).STRING,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$ce9b1cc0c34506d0), {
                    name: "dfci.dfciTravauxDestinataireEmail",
                    label: "Adresse email qui recevra une notification lors d'une r\xe9ception de travaux"
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).STRING,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$ce9b1cc0c34506d0), {
                    name: "dfci.dfciTravauxObjetEmail",
                    label: "Objet du mail de notification lors d'une r\xe9ception de travaux"
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).STRING,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$ce9b1cc0c34506d0), {
                    name: "dfci.dfciTravauxCorpsEmail",
                    label: "Contenu du mail de notification lors d'une r\xe9ception de travaux",
                    tooltipText: "Vous pouvez utiliser #[ORGANISME_UTILISATEUR]# et #[LIEN_TELECHARGEMENT]# dans votre message. Ces deux valeurs seront remplac\xe9es automatiquement."
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).INTEGER,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$2e2bcd8739ae039), {
                    name: "dfci.dfciToleranceDfciPisteMetres",
                    label: "Tol\xe9rance (en m) de d\xe9tection des pistes"
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).MULTI_STRING,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$eae70af4b4e3f197), {
                    name: "dfci.dfciListeCouche",
                    label: "Liste des couches DFCI \xe0 afficher",
                    options: listeCoucheDfci,
                    getOptionValue: (e)=>e.id,
                    getOptionLabel: (e)=>e.libelle,
                    value: values?.dfciListeCouche?.map((e)=>listeCoucheDfci?.find((r)=>r.id === e)) ?? undefined,
                    onChange: (coucheDfci)=>{
                        const coucheDfciListe = coucheDfci.map((e)=>e.id);
                        coucheDfciListe.length > 0 ? setFieldValue("dfci.dfciListeCouche", coucheDfciListe) : setFieldValue("dfci.dfciListeCouche", []);
                    },
                    required: false
                })
            })
        ]
    });
};
const $bd415ca04deb1f3d$var$AdminPei = ({ values: values, allCaracteristiques: allCaracteristiques })=>{
    const { availableOptions: availableOptions, setAvailableOptions: setAvailableOptions, selectedOptions: selectedOptions, setSelectedOptions: setSelectedOptions } = (0, $5ada21a6009b8ce0$export$3134abb19e37c62d)({
        listeDisponible: null,
        listeSelectionne: null,
        nameFormik: "pei.peiColonnesIds"
    });
    const { setFieldValue: setFieldValue } = (0, $bkJfK.useFormikContext)();
    (0, $kc00y.useMemo)(()=>{
        if (!values?.peiColonnesIds) return;
        if (availableOptions == null) setAvailableOptions((0, $c22d20d038ee5de2$export$afdedc74bb5d98bb).filter((e)=>!values.peiColonnesIds?.includes(e)));
        if (selectedOptions == null) setSelectedOptions((0, $c22d20d038ee5de2$export$afdedc74bb5d98bb).filter(({ id: id })=>values.peiColonnesIds?.map((e)=>e.id).includes(id)));
    }, [
        values,
        setSelectedOptions,
        selectedOptions,
        availableOptions,
        setAvailableOptions
    ]);
    const { availableOptions: availablePibiOptions, setAvailableOptions: setAvailablePibiOptions, selectedOptions: selectedPibiOptions, setSelectedOptions: setSelectedPibiOptions } = (0, $5ada21a6009b8ce0$export$3134abb19e37c62d)({
        listeDisponible: null,
        listeSelectionne: null,
        nameFormik: "pei.caracteristiquesPibiTooltipWebIds"
    });
    const { availableOptions: availablePenaOptions, setAvailableOptions: setAvailablePenaOptions, selectedOptions: selectedPenaOptions, setSelectedOptions: setSelectedPenaOptions } = (0, $5ada21a6009b8ce0$export$3134abb19e37c62d)({
        listeDisponible: null,
        listeSelectionne: null,
        nameFormik: "pei.caracteristiquesPenaTooltipWebIds"
    });
    (0, $kc00y.useMemo)(()=>{
        if (!allCaracteristiques || !values?.caracteristiquesPenaTooltipWebIds || !values?.caracteristiquesPibiTooltipWebIds) return;
        //PIBI
        if (availablePibiOptions == null) setAvailablePibiOptions(allCaracteristiques.filter((item)=>item.type === "PIBI" || item.type === "GENERAL"));
        if (selectedPibiOptions == null) setSelectedPibiOptions(allCaracteristiques.filter((item)=>{
            return values?.caracteristiquesPibiTooltipWebIds?.map((e)=>e.id).includes(item.id);
        }));
        //PENA
        if (availablePenaOptions == null) setAvailablePenaOptions(allCaracteristiques.filter((item)=>item.type === "PENA" || item.type === "GENERAL"));
        if (selectedPenaOptions == null) setSelectedPenaOptions(allCaracteristiques.filter((item)=>{
            return values?.caracteristiquesPenaTooltipWebIds?.map((e)=>e.id).includes(item.id);
        }));
    }, [
        values,
        availablePenaOptions,
        availablePibiOptions,
        selectedPenaOptions,
        selectedPibiOptions,
        setAvailablePenaOptions,
        setAvailablePibiOptions,
        setSelectedPenaOptions,
        setSelectedPibiOptions,
        allCaracteristiques
    ]);
    return values && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("h2", {
                className: "mt-2 ms-5",
                children: "Liste PEI"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).MULTI_STRING,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $5ada21a6009b8ce0$export$2e2bcd8739ae039), {
                    availableOptions: availableOptions,
                    selectedOptions: selectedOptions,
                    setAvailableOptions: setAvailableOptions,
                    setSelectedOptions: setSelectedOptions,
                    required: true,
                    label: "Colonnes affich\xe9es dans la liste des PEI",
                    name: "pei.peiColonnes"
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).BOOLEAN,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                    name: "pei.peiMethodeTriAlphanumerique",
                    label: "Activer le tri alphanum\xe9rique pour les PEI",
                    checked: values?.peiMethodeTriAlphanumerique,
                    tooltipText: "Un tri alphanum\xe9rique compare un \xe0 un les caract\xe8res de chaque cha\xeene, alors qu'un tri 'naturel' va d'abord comparer la longueur de chaque cha\xeene"
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).INTEGER,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$2e2bcd8739ae039), {
                    name: "pei.peiToleranceCommuneMetres",
                    label: "Tol\xe9rance en m\xe8tres pour les communes",
                    tooltipText: "Permet de charger dans la liste d\xe9roulante des communes certaines dont le polygone n'est pas parfaitement en phase avec l'attendu"
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("h2", {
                className: "mt-4 ms-5",
                children: "Infobulle PEI"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).MULTI_STRING,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $5ada21a6009b8ce0$export$2e2bcd8739ae039), {
                    availableOptions: availablePibiOptions,
                    selectedOptions: selectedPibiOptions,
                    setAvailableOptions: setAvailablePibiOptions,
                    setSelectedOptions: setSelectedPibiOptions,
                    label: "Caract\xe9ristiques \xe0 afficher pour les PIBI",
                    tooltipText: "Dans l'infobulle d'un PEI sur la carte de l'application web, on affiche des caract\xe9ristiques. Ce param\xe8tre permet de d\xe9finir lesquelles, et dans quel ordre elles se pr\xe9sentent",
                    required: false,
                    name: "pei.caracteristiquesPibiTooltipWebIds"
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).MULTI_STRING,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $5ada21a6009b8ce0$export$2e2bcd8739ae039), {
                    availableOptions: availablePenaOptions,
                    selectedOptions: selectedPenaOptions,
                    setAvailableOptions: setAvailablePenaOptions,
                    setSelectedOptions: setSelectedPenaOptions,
                    label: "Caract\xe9ristiques \xe0 afficher pour les PENA",
                    tooltipText: "Dans l'infobulle d'un PEI sur la carte de l'application web, on affiche des caract\xe9ristiques. Ce param\xe8tre permet de d\xe9finir lesquelles, et dans quel ordre elles se pr\xe9sentent",
                    required: false,
                    name: "pei.caracteristiquesPenaTooltipWebIds"
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("h2", {
                className: "mt-4 ms-5",
                children: "Fiche R\xe9sum\xe9"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).BOOLEAN,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                    name: "pei.peiFicheResumeStandalone",
                    label: "Activer la fiche R\xe9sum\xe9 en affichage autonome",
                    tooltipText: "La fiche R\xe9sum\xe9 permet d'afficher de l'information condens\xe9e sur le PEI ; outre son accessibilit\xe9 en 1er accord\xe9on de la fiche PEI, vous pouvez, en activant cette option, la voir appara\xeetre comme action sp\xe9cifique dans la liste des PEI et l'infobulle du PEI dans la carto. Attention, elle est forc\xe9ment utilis\xe9e pour le module de risque en mode grand public"
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).STRING,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                    name: "pei.peiLibelleNonConforme",
                    label: 'Libell\xe9 du statut "non conforme" d\'un PEI',
                    tooltipText: 'Libell\xe9 qui sera affich\xe9 pour le statut "Non conforme" d\'un PEI ; par d\xe9faut, la valeur est "Non conforme". Attention, une valeur trop longue pourrait d\xe9grader certains affichages.',
                    required: false
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).INTEGER,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$2e2bcd8739ae039), {
                    name: "pei.peiNombreHistorique",
                    label: "Nombre de donn\xe9es \xe0 afficher sur le graphique de la fiche r\xe9sum\xe9",
                    required: false
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).INTEGER,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$2e2bcd8739ae039), {
                    name: "pei.valeurMinimaleHistogramme",
                    label: "Graduation minimale de l'histogramme de la Fiche R\xe9sum\xe9",
                    required: false,
                    tooltipText: "Saisir une valeur dans ce champ permet de garantir que l'ordonn\xe9e de l'histogramme ira au moins jusqu'\xe0 la valeur en question, mais pourra s'\xe9tendre au besoin."
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).SELECT,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$d6701e98ab1a6725), {
                    name: "pei.peiRouteHistorique",
                    label: "Type de route pour l'historique des PEI",
                    options: (0, $35b7fac87e83d899$export$2e2bcd8739ae039),
                    getOptionValue: (v)=>v.id,
                    getOptionLabel: (v)=>v.libelle,
                    onChange: (e)=>setFieldValue(`pei.peiRouteHistorique`, (0, $35b7fac87e83d899$export$2e2bcd8739ae039).find((type)=>type.id === e.id)?.id),
                    defaultValue: (0, $35b7fac87e83d899$export$2e2bcd8739ae039).find((e)=>e.id === values.peiRouteHistorique),
                    tooltipText: "Le bouton pourra rediriger soit vers l'\xe9cran d'historique des op\xe9rations, en s'appuyant sur l'identifiant technique du PEI, soit vers le rapport personnalis\xe9 d'historique d'un PEI avec son num\xe9ro complet"
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("h2", {
                className: "mt-4 ms-5",
                children: "Fiche PEI"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).BOOLEAN,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                    name: "pei.peiRenumerotationInterneAuto",
                    label: "Activer la renum\xe9rotation interne automatique des PEI",
                    checked: values?.peiRenumerotationInterneAuto,
                    tooltipText: "Si le param\xe8tre est activ\xe9, la saisie du num\xe9ro interne d'un PEI sera impossible m\xeame si l'utilisateur a le droit 'Saisir le num\xe9ro interne d'un PEI' (PEI_NUMERO_INTERNE_U)."
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).BOOLEAN,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                    name: "pei.peiDisplayIdentifiantGestionnaire",
                    label: "Permettre la saisie du num\xe9ro utilis\xe9 par le gestionnaire pour identifier le PIBI.",
                    tooltipText: "Permet d'afficher le composant de saisie de l'identifiant gestionnaire dans la fiche PEI, sinon il sera masqu\xe9"
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).BOOLEAN,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                    name: "pei.voieSaisieLibre",
                    label: "Autoriser la saisie libre pour les voies",
                    checked: values?.voieSaisieLibre
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).BOOLEAN,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                    name: "pei.peiDisplayTypeEngin",
                    label: "Permettre la saisie des types d'engins dans la fiche PEI",
                    tooltipText: "Permet d'afficher le composant de saisie des types d'engins dans la fiche PEI, sinon il sera masqu\xe9"
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).INTEGER,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$2e2bcd8739ae039), {
                    name: "pei.vitesseEau",
                    label: "Vitesse de l'eau en m/s",
                    tooltipText: "Utile pour avoir un calcul fin des d\xe9bits simultan\xe9s"
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("h2", {
                className: "mt-4 ms-5",
                children: "Visites PEI"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).BOOLEAN,
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                        name: "pei.receptionRecoInitObligatoire",
                        label: "Obliger la visite de r\xe9ception et la visite de reconnaissance initiale",
                        checked: values?.receptionRecoInitObligatoire,
                        tooltipText: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                            children: [
                                "Si le param\xe8tre est coch\xe9, l'absence de visite de r\xe9ception et de visite de reconnaissance initiale entra\xeene obligatoirement une indisponibilit\xe9 du PEI.",
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                                "Si ce param\xe8tre change, une t\xe2che de recalcul des disponibilit\xe9s sera lanc\xe9e.",
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                                "Notez que cette t\xe2che peut \xeatre longue en fonction du nombre de PEI \xe0 traiter Vous pouvez consulter la page",
                                " ",
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("b", {
                                    children: "R\xe9sultats d'ex\xe9cution"
                                }),
                                " pour suivre son avancement."
                            ]
                        })
                    }),
                    values?.receptionRecoInitObligatoire && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                                type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).BOOLEAN,
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                                    name: "pei.autoriserMailVisiteReception",
                                    label: "Notification - Visite de r\xe9ception",
                                    checked: values?.autoriserMailVisiteReception
                                })
                            }),
                            values?.autoriserMailVisiteReception && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$var$ActiveOrganismTypes, {
                                recipientsField: "pei.peiOrganismeNotificationVisiteReception"
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                                type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).BOOLEAN,
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                                    name: "pei.autoriserMailRoi",
                                    label: "Notification - Reconnaissance op\xe9rationnelle initiale (ROI)",
                                    checked: values?.autoriserMailRoi
                                })
                            }),
                            values?.autoriserMailRoi && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$var$ActiveOrganismTypes, {
                                recipientsField: "pei.peiOrganismeNotificationRoi"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).BOOLEAN,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                    name: "pei.conserverObservationVisite",
                    label: "Conserver la derni\xe8re observation lors de la saisie d'une nouvelle visite ",
                    checked: values?.conserverObservationVisite,
                    tooltipText: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
                        children: "Choisissez si vous souhaitez conserver l'observation pr\xe9c\xe9dente lors de la saisie d'une nouvelle visite, afin d'\xe9viter de la saisir \xe0 nouveau."
                    })
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).INTEGER,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$2e2bcd8739ae039), {
                    name: "pei.peiDelaiCtrlUrgent",
                    label: "Nombre de jours avant \xe9ch\xe9ance o\xf9 un contr\xf4le est consid\xe9r\xe9 comme urgent"
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).INTEGER,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$2e2bcd8739ae039), {
                    name: "pei.peiDelaiCtrlWarn",
                    label: "Nombre de jours avant \xe9ch\xe9ance o\xf9 un contr\xf4le est consid\xe9r\xe9 comme \xe0 faire bient\xf4t"
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).INTEGER,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$2e2bcd8739ae039), {
                    name: "pei.peiDelaiRecoUrgent",
                    label: "Nombre de jours avant \xe9ch\xe9ance o\xf9 une reconnaisance est consid\xe9r\xe9e comme urgente"
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).INTEGER,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$2e2bcd8739ae039), {
                    name: "pei.peiDelaiRecoWarn",
                    label: "Nombre de jours avant \xe9ch\xe9ance o\xf9 une reconnaisance est consid\xe9r\xe9e comme \xe0 faire bient\xf4t"
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).INTEGER,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$2e2bcd8739ae039), {
                    name: "pei.peiRenouvellementCtrlPrive",
                    label: "Nombre de jours pour le renouvellement des contr\xf4les priv\xe9s",
                    tooltipText: "Permet de calculer la prochaine date du CTP par rapport \xe0 la derni\xe8re saisie"
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).INTEGER,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$2e2bcd8739ae039), {
                    name: "pei.peiRenouvellementCtrlPublic",
                    label: "Nombre de jours pour le renouvellement des contr\xf4les publics",
                    tooltipText: "Permet de calculer la prochaine date du CTP par rapport \xe0 la derni\xe8re saisie"
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).INTEGER,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$2e2bcd8739ae039), {
                    name: "pei.peiRenouvellementCtrlConventionne",
                    label: "Nombre de jours pour le renouvellement des contr\xf4les Priv\xe9s sous convention",
                    tooltipText: "Permet de calculer la prochaine date du CTP par rapport \xe0 la derni\xe8re saisie"
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).INTEGER,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$2e2bcd8739ae039), {
                    name: "pei.peiRenouvellementCtrlIcpe",
                    label: "Nombre de jours pour le renouvellement des contr\xf4les ICPE",
                    tooltipText: "Permet de calculer la prochaine date du CTP par rapport \xe0 la derni\xe8re saisie"
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).INTEGER,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$2e2bcd8739ae039), {
                    name: "pei.peiRenouvellementCtrlIcpeConventionne",
                    label: "Nombre de jours pour le renouvellement des contr\xf4les ICPE conventionn\xe9s",
                    tooltipText: "Permet de calculer la prochaine date du CTP par rapport \xe0 la derni\xe8re saisie"
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).INTEGER,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$2e2bcd8739ae039), {
                    name: "pei.peiRenouvellementRecoPrive",
                    label: "Nombre de jours pour le renouvellement des reconnaissances priv\xe9es",
                    tooltipText: "Permet de calculer la prochaine date de la ROP par rapport \xe0 la derni\xe8re saisie"
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).INTEGER,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$2e2bcd8739ae039), {
                    name: "pei.peiRenouvellementRecoPublic",
                    label: "Nombre de jours pour le renouvellement des reconnaissances publiques",
                    tooltipText: "Permet de calculer la prochaine date de la ROP par rapport \xe0 la derni\xe8re saisie"
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).INTEGER,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$2e2bcd8739ae039), {
                    name: "pei.peiRenouvellementRecoIcpe",
                    label: "Nombre de jours pour le renouvellement des reconnaissances ICPE",
                    tooltipText: "Permet de calculer la prochaine date de la ROP par rapport \xe0 la derni\xe8re saisie"
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).INTEGER,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$2e2bcd8739ae039), {
                    name: "pei.peiRenouvellementRecoIcpeConventionne",
                    label: "Nombre de jours pour le renouvellement des reconnaissances ICPE conventionn\xe9s",
                    tooltipText: "Permet de calculer la prochaine date de la ROP par rapport \xe0 la derni\xe8re saisie"
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).INTEGER,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$2e2bcd8739ae039), {
                    name: "pei.peiRenouvellementRecoConventionne",
                    label: "Nombre de jours pour le renouvellement des reconnaissances Priv\xe9s sous convention",
                    tooltipText: "Permet de calculer la prochaine date de la ROP par rapport \xe0 la derni\xe8re saisie"
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).INTEGER,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$2e2bcd8739ae039), {
                    name: "pei.peiDeplacementDistWarn",
                    label: "Seuil de d\xe9placement d'un PEI import CTP",
                    tooltipText: "Distance de d\xe9placement du PEI au-del\xe0 de laquelle afficher un avertissement lors de l'import de Contr\xf4les Techniques P\xe9riodiques"
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("h2", {
                className: "mt-4 ms-5",
                children: "Carte des tourn\xe9es"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).INTEGER,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$2e2bcd8739ae039), {
                    name: "pei.bufferCarte",
                    label: "Espace tampon pour la g\xe9n\xe9ration de carte (carte des tourn\xe9es)"
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).BOOLEAN,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                    name: "pei.peiGenerationCarteTournee",
                    label: "Active le module de g\xe9n\xe9ration de carte des tourn\xe9es dans le module Point d\u2019eau",
                    checked: values?.peiGenerationCarteTournee,
                    tooltipText: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                        children: [
                            "Le module de g\xe9n\xe9ration n\xe9cessite qu\u2019une aggr\xe9gation de couche nomm\xe9e ",
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("b", {
                                children: "TOURNEE"
                            }),
                            " soit configur\xe9e sur Geoserver. Il est recommand\xe9 que l\u2019aggr\xe9gation de couche contienne ",
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("i", {
                                children: "a minima"
                            }),
                            " ",
                            ":",
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("ul", {
                                children: [
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("li", {
                                        children: "Un fond de plan"
                                    }),
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("li", {
                                        children: "La couche des PEI"
                                    })
                                ]
                            }),
                            "Le module enverra l\u2019identifiant de la tourn\xe9e via le VIEWPARAM tournee_id permettant de discriminer les PEI \xe0 retourner"
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("h2", {
                className: "mt-4 ms-5",
                children: "D\xe9claration d'un PEI"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).STRING,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$ce9b1cc0c34506d0), {
                    name: "pei.declarationPeiDestinataireEmail",
                    label: "Adresse email qui recevra une notification lors de la d\xe9claration d'un PEI"
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).STRING,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$ce9b1cc0c34506d0), {
                    name: "pei.declarationPeiObjetEmail",
                    label: "Objet du mail de notification lors de la d\xe9claration d'un PEI"
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).STRING,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$ce9b1cc0c34506d0), {
                    name: "pei.declarationPeiCorpsEmail",
                    label: "Contenu du mail de notification lors de la d\xe9claration d'un PEI",
                    tooltipText: "Vous pouvez utiliser #[ORGANISME_UTILISATEUR]# et #[LIEN_TELECHARGEMENT]# dans votre message. Ces deux valeurs seront remplac\xe9es automatiquement."
                })
            })
        ]
    });
};
const $bd415ca04deb1f3d$var$AdminPeiLongueIndispo = ({ values: values, setFieldValue: setFieldValue })=>{
    return values && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).STRING,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$ce9b1cc0c34506d0), {
                    name: "peiLongueIndispo.peiLongueIndisponibiliteMessage",
                    label: "Message \xe0 afficher en cas de PEI indisponible depuis trop longtemps",
                    tooltipText: "Vous pouvez utiliser #MOIS# et #JOURS# dans votre message. Ces deux valeurs seront remplac\xe9es automatiquement."
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).INTEGER,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$2e2bcd8739ae039), {
                    name: "peiLongueIndispo.peiLongueIndisponibiliteJours",
                    label: "Nombre de jours avant de consid\xe9rer un PEI comme indisponible depuis trop longtemps"
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b8fb5829c98aa3b7$export$2e2bcd8739ae039), {
                name: "peiLongueIndispo.peiLongueIndisponibiliteTypeOrganisme",
                label: "Types d'organismes concern\xe9s par le message \xe0 afficher en cas de PEI indisponible depuis trop longtemps",
                selectedCodes: values?.peiLongueIndisponibiliteTypeOrganisme,
                setFieldValue: setFieldValue
            })
        ]
    });
};
const $bd415ca04deb1f3d$var$AdminPermis = ({ values: values })=>{
    return values && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
            type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).INTEGER,
            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$2e2bcd8739ae039), {
                name: "permis.permisToleranceChargementMetres",
                label: "Tol\xe9rance de chargement (en m)",
                tooltipText: "TODO"
            })
        })
    });
};
const $bd415ca04deb1f3d$var$AdminRcci = ({ values: values, setFieldValue: setFieldValue })=>{
    return values && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b8fb5829c98aa3b7$export$2e2bcd8739ae039), {
                name: "rcci.listeTypeOrganismeDdtmOnf",
                label: "Types d'organismes dont les utilisateurs seront remont\xe9s dans la liste DDTM/ONF dans les RCCI",
                selectedCodes: values?.listeTypeOrganismeDdtmOnf,
                setFieldValue: setFieldValue,
                required: false
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b8fb5829c98aa3b7$export$2e2bcd8739ae039), {
                name: "rcci.listeTypeOrganismeSdis",
                label: "Types d'organismes dont les utilisateurs seront remont\xe9s dans la liste SDIS dans les RCCI",
                selectedCodes: values?.listeTypeOrganismeSdis,
                setFieldValue: setFieldValue,
                required: false
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b8fb5829c98aa3b7$export$2e2bcd8739ae039), {
                name: "rcci.listeTypeOrganismeGendarmerie",
                label: "Types d'organismes dont les utilisateurs seront remont\xe9s dans la liste Gendarmerie dans les RCCI",
                selectedCodes: values?.listeTypeOrganismeGendarmerie,
                setFieldValue: setFieldValue,
                required: false
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b8fb5829c98aa3b7$export$2e2bcd8739ae039), {
                name: "rcci.listeTypeOrganismePolice",
                label: "Types d'organismes dont les utilisateurs seront remont\xe9s dans la liste Police dans les RCCI",
                selectedCodes: values?.listeTypeOrganismePolice,
                setFieldValue: setFieldValue,
                required: false
            })
        ]
    });
};
const $bd415ca04deb1f3d$var$ActiveOrganismTypes = ({ recipientsField: recipientsField })=>{
    const [{ value: listeTypeOrganismeIds }, , { setValue: setValue }] = (0, $bkJfK.useField)(recipientsField);
    const { data: allOrganismType } = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/type-organisme/get-active`);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$eae70af4b4e3f197), {
        name: recipientsField,
        label: "Types d'organismes concern\xe9s qui recevront le courrier",
        options: allOrganismType,
        getOptionValue: (o)=>o.typeOrganismeId,
        getOptionLabel: (o)=>o.typeOrganismeLibelle,
        value: allOrganismType?.filter((o)=>listeTypeOrganismeIds?.includes(o.typeOrganismeId)),
        onChange: (selection)=>setValue(selection.map((o)=>o.typeOrganismeId))
    });
};
const $bd415ca04deb1f3d$var$AdminUtilisateur = ({ values: values, setFieldValue: setFieldValue })=>{
    const { data: organismeList } = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/organisme/get-all`);
    const { data: profilUtilisateurList } = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/profil-utilisateur/`);
    const [groupeFonctionnalitesDeduit, setGroupeFonctionnalitesDeduit] = (0, $kc00y.useState)();
    const { data: groupeFonctionnalitesWithProfilsList } = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/groupe-fonctionnalites/profils`);
    (0, $kc00y.useEffect)(()=>{
        setGroupeFonctionnalitesDeduit(groupeFonctionnalitesWithProfilsList?.find((e)=>e.profilUtilisateurId === profilUtilisateurList?.find((p)=>p.code === values?.profilUtilisateurDefaut)?.id && e.profilOrganismeId === organismeList?.find((e)=>e.code === values?.organismeDefaut)?.lienId)?.libelle);
    }, [
        groupeFonctionnalitesWithProfilsList,
        organismeList,
        profilUtilisateurList,
        values?.profilUtilisateurDefaut,
        values?.organismeDefaut
    ]);
    return values && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("p", {
                children: "Ces param\xe8tres vont \xeatre appliqu\xe9s \xe0 chaque nouvel utilisateur lors de la synchro LDAP, afin qu'il puisse directement se connecter \xe0 l'application. Attention, si vous saisissez une combinaison invalide, la connexion de l'utilisateur n'aboutira pas."
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).SELECT,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$d6701e98ab1a6725), {
                    name: "utilisateur.organismeDefaut",
                    label: "Organisme par d\xe9faut \xe0 l'ajout d'un utilisateur",
                    options: organismeList,
                    getOptionValue: (v)=>v.id,
                    getOptionLabel: (v)=>v.libelle,
                    required: false,
                    isClearable: true,
                    defaultValue: organismeList?.find((o)=>o.code === values?.organismeDefaut) ?? undefined,
                    onChange: (organisme)=>{
                        setFieldValue(`utilisateur.organismeDefaut`, organismeList?.find((o)=>o.id === organisme?.id)?.code);
                    }
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).SELECT,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$d6701e98ab1a6725), {
                    name: "utilisateur.profilUtilisateurDefaut",
                    label: "Profil utilisateur par d\xe9faut \xe0 l'ajout d'un utilisateur",
                    options: profilUtilisateurList,
                    getOptionValue: (v)=>v.id,
                    getOptionLabel: (v)=>v.libelle,
                    required: false,
                    isClearable: true,
                    defaultValue: profilUtilisateurList?.find((p)=>p.code === values?.profilUtilisateurDefaut) ?? undefined,
                    onChange: (profilUtilisateur)=>{
                        setFieldValue(`utilisateur.profilUtilisateurDefaut`, profilUtilisateurList?.find((p)=>p.id === profilUtilisateur?.id)?.code);
                    }
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                className: "text-center",
                children: groupeFonctionnalitesDeduit != null ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                    children: [
                        "Le groupe de fonctionnalit\xe9s qui sera affect\xe9 sera :",
                        " ",
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("b", {
                            children: groupeFonctionnalitesDeduit
                        })
                    ]
                }) : "Aucun groupe de fonctionnalit\xe9s trouv\xe9."
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
                type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).BOOLEAN,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                    name: "utilisateur.organismeProfilMajSynchro",
                    label: "Mettre \xe0 jour l'organisme et le profil de l'utilisateur lors de la synchronisation utilisateur",
                    checked: values?.organismeProfilMajSynchro,
                    tooltipText: "Si activ\xe9, l'organisme et le profil de l'utilisateur seront mis \xe0 jour lors de chaque synchronisation \xe0 partir du LDAP. Les attributs Keycloak 'organismeCode' et 'profilUtilisateurCode' doivent \xeatre pr\xe9sents (configurez un mapper LDAP dans Keycloak pour mapper vos attributs LDAP vers 'organismeCode' et 'profilUtilisateurCode'). Si l'un de ces attributs est absent, l'utilisateur sera d\xe9sactiv\xe9. Si le param\xe8tre est d\xe9sactiv\xe9, seules les donn\xe9es personnelles (nom, pr\xe9nom, email) seront mises \xe0 jour, tout en conservant l'organisme et le profil affect\xe9s dans REMOcRA."
                })
            })
        ]
    });
};
const $bd415ca04deb1f3d$var$AdminCourrier = ({ values: values })=>{
    return values && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($bd415ca04deb1f3d$export$4d11f9169b62ad26, {
            type: (0, $703a40e91b65be4e$export$2e2bcd8739ae039).BOOLEAN,
            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                name: "courrier.courrierRestrictionZC",
                label: "Permettre \xe0 l'utilisateur de restreindre la recherche des destinataires sur sa zone de comp\xe9tence",
                checked: values?.courrierRestrictionZC,
                tooltipText: "Si ce param\xe8tre est activ\xe9, la notification d\u2019un courrier affichera une case \xe0 cocher permettant de limiter la recherche des destinataires \xe0 la zone de comp\xe9tence de l\u2019utilisateur connect\xe9."
            })
        })
    });
};










var $bkJfK = parcelRequire("bkJfK");


var $kc00y = parcelRequire("kc00y");


var $kc00y = parcelRequire("kc00y");



"use client";
const $104293336995282e$var$CardBody = /*#__PURE__*/ $kc00y.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(bsPrefix, 'card-body');
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, bsPrefix),
        ...props
    });
});
$104293336995282e$var$CardBody.displayName = 'CardBody';
var $104293336995282e$export$2e2bcd8739ae039 = $104293336995282e$var$CardBody;



var $kc00y = parcelRequire("kc00y");



"use client";
const $ae6ac0f2edeae50f$var$CardFooter = /*#__PURE__*/ $kc00y.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(bsPrefix, 'card-footer');
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, bsPrefix),
        ...props
    });
});
$ae6ac0f2edeae50f$var$CardFooter.displayName = 'CardFooter';
var $ae6ac0f2edeae50f$export$2e2bcd8739ae039 = $ae6ac0f2edeae50f$var$CardFooter;




var $kc00y = parcelRequire("kc00y");



"use client";
const $f549c44bde8e5d86$var$CardHeader = /*#__PURE__*/ $kc00y.forwardRef(({ bsPrefix: bsPrefix, className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...props }, ref)=>{
    const prefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(bsPrefix, 'card-header');
    const contextValue = (0, $kc00y.useMemo)(()=>({
            cardHeaderBsPrefix: prefix
        }), [
        prefix
    ]);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e568e6bef19b3ebd$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)(Component, {
            ref: ref,
            ...props,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, prefix)
        })
    });
});
$f549c44bde8e5d86$var$CardHeader.displayName = 'CardHeader';
var $f549c44bde8e5d86$export$2e2bcd8739ae039 = $f549c44bde8e5d86$var$CardHeader;




var $kc00y = parcelRequire("kc00y");


"use client";
const $2496ff1a34190662$var$CardImg = /*#__PURE__*/ $kc00y.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({ bsPrefix: bsPrefix, className: className, variant: variant, as: Component = 'img', ...props }, ref)=>{
    const prefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(bsPrefix, 'card-img');
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(variant ? `${prefix}-${variant}` : prefix, className),
        ...props
    });
});
$2496ff1a34190662$var$CardImg.displayName = 'CardImg';
var $2496ff1a34190662$export$2e2bcd8739ae039 = $2496ff1a34190662$var$CardImg;



var $kc00y = parcelRequire("kc00y");



"use client";
const $29d6362a703937a7$var$CardImgOverlay = /*#__PURE__*/ $kc00y.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(bsPrefix, 'card-img-overlay');
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, bsPrefix),
        ...props
    });
});
$29d6362a703937a7$var$CardImgOverlay.displayName = 'CardImgOverlay';
var $29d6362a703937a7$export$2e2bcd8739ae039 = $29d6362a703937a7$var$CardImgOverlay;



var $kc00y = parcelRequire("kc00y");



"use client";
const $f392f9d50505ef7f$var$CardLink = /*#__PURE__*/ $kc00y.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'a', ...props }, ref)=>{
    bsPrefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(bsPrefix, 'card-link');
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, bsPrefix),
        ...props
    });
});
$f392f9d50505ef7f$var$CardLink.displayName = 'CardLink';
var $f392f9d50505ef7f$export$2e2bcd8739ae039 = $f392f9d50505ef7f$var$CardLink;



var $kc00y = parcelRequire("kc00y");




"use client";
const $036220772594cba7$var$DivStyledAsH6 = (0, $b5bbb0b2ce1c31b6$export$2e2bcd8739ae039)('h6');
const $036220772594cba7$var$CardSubtitle = /*#__PURE__*/ $kc00y.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = $036220772594cba7$var$DivStyledAsH6, ...props }, ref)=>{
    bsPrefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(bsPrefix, 'card-subtitle');
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, bsPrefix),
        ...props
    });
});
$036220772594cba7$var$CardSubtitle.displayName = 'CardSubtitle';
var $036220772594cba7$export$2e2bcd8739ae039 = $036220772594cba7$var$CardSubtitle;



var $kc00y = parcelRequire("kc00y");



"use client";
const $c1e12b416d07cc3a$var$CardText = /*#__PURE__*/ $kc00y.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'p', ...props }, ref)=>{
    bsPrefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(bsPrefix, 'card-text');
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, bsPrefix),
        ...props
    });
});
$c1e12b416d07cc3a$var$CardText.displayName = 'CardText';
var $c1e12b416d07cc3a$export$2e2bcd8739ae039 = $c1e12b416d07cc3a$var$CardText;



var $kc00y = parcelRequire("kc00y");




"use client";
const $00da87eaa7cf462b$var$DivStyledAsH5 = (0, $b5bbb0b2ce1c31b6$export$2e2bcd8739ae039)('h5');
const $00da87eaa7cf462b$var$CardTitle = /*#__PURE__*/ $kc00y.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = $00da87eaa7cf462b$var$DivStyledAsH5, ...props }, ref)=>{
    bsPrefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(bsPrefix, 'card-title');
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, bsPrefix),
        ...props
    });
});
$00da87eaa7cf462b$var$CardTitle.displayName = 'CardTitle';
var $00da87eaa7cf462b$export$2e2bcd8739ae039 = $00da87eaa7cf462b$var$CardTitle;



"use client";
const $1988c313b8430f65$var$Card = /*#__PURE__*/ $kc00y.forwardRef(({ bsPrefix: bsPrefix, className: className, bg: bg, text: text, border: border, body: body = false, children: children, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...props }, ref)=>{
    const prefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(bsPrefix, 'card');
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, prefix, bg && `bg-${bg}`, text && `text-${text}`, border && `border-${border}`),
        children: body ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $104293336995282e$export$2e2bcd8739ae039), {
            children: children
        }) : children
    });
});
$1988c313b8430f65$var$Card.displayName = 'Card';
var $1988c313b8430f65$export$2e2bcd8739ae039 = Object.assign($1988c313b8430f65$var$Card, {
    Img: (0, $2496ff1a34190662$export$2e2bcd8739ae039),
    Title: (0, $00da87eaa7cf462b$export$2e2bcd8739ae039),
    Subtitle: (0, $036220772594cba7$export$2e2bcd8739ae039),
    Body: (0, $104293336995282e$export$2e2bcd8739ae039),
    Link: (0, $f392f9d50505ef7f$export$2e2bcd8739ae039),
    Text: (0, $c1e12b416d07cc3a$export$2e2bcd8739ae039),
    Header: (0, $f549c44bde8e5d86$export$2e2bcd8739ae039),
    Footer: (0, $ae6ac0f2edeae50f$export$2e2bcd8739ae039),
    ImgOverlay: (0, $29d6362a703937a7$export$2e2bcd8739ae039)
});











const $6e72ec37d2303b77$export$a5cab80145b70e98 = (data)=>({
        anomalieCode: data?.anomalieCode ?? null,
        anomalieLibelle: data?.anomalieLibelle ?? null,
        anomalieCommentaire: data?.anomalieCommentaire ?? null,
        anomalieAnomalieCategorieId: data?.anomalieAnomalieCategorieId ?? null,
        anomalieActif: data?.anomalieActif ?? false,
        anomalieProtected: data?.anomalieProtected ?? false,
        anomalieRendNonConforme: data?.anomalieRendNonConforme ?? false,
        poidsAnomalieSystemeValIndispoTerrestre: data?.poidsAnomalieSystemeValIndispoTerrestre,
        poidsAnomalieSystemeValIndispoHbe: data?.poidsAnomalieSystemeValIndispoHbe,
        poidsAnomalieList: data?.poidsAnomalieList ?? []
    });
const $6e72ec37d2303b77$export$8470ef9d0802da38 = (values)=>({
        anomalieCode: values.anomalieCode,
        anomalieLibelle: values.anomalieLibelle,
        anomalieCommentaire: values.anomalieCommentaire,
        anomalieAnomalieCategorieId: values.anomalieAnomalieCategorieId,
        anomalieActif: values.anomalieActif,
        anomalieProtected: values.anomalieProtected ?? false,
        anomalieRendNonConforme: values.anomalieRendNonConforme,
        poidsAnomalieSystemeValIndispoTerrestre: values.poidsAnomalieSystemeValIndispoTerrestre,
        poidsAnomalieSystemeValIndispoHbe: values.poidsAnomalieSystemeValIndispoHbe,
        poidsAnomalieList: values.poidsAnomalieList ?? []
    });
const $6e72ec37d2303b77$export$c084437b5e3206cd = (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({
    anomalieCode: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
    anomalieLibelle: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
    anomalieAnomalieCategorieId: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
    anomalieActif: (0, $36ceaed6faf947af$export$87bba3bb7a1f4285),
    anomalieProtected: (0, $36ceaed6faf947af$export$87bba3bb7a1f4285),
    anomalieRendNonConforme: (0, $36ceaed6faf947af$export$87bba3bb7a1f4285),
    poidsAnomalieSystemeValIndispoTerrestre: (0, $36ceaed6faf947af$export$24a1e2b92fa94c07),
    poidsAnomalieSystemeValIndispoHbe: (0, $36ceaed6faf947af$export$24a1e2b92fa94c07),
    poidsAnomalieList: (0, $ce4de947442b2ab1$export$2f23118c22fb2630)()
});
const $6e72ec37d2303b77$var$AnomalieForm = ()=>{
    const { values: values, setFieldValue: setFieldValue, setValues: setValues } = (0, $bkJfK.useFormikContext)();
    const anomalieReferentielState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/anomalie/referentiel`);
    if (!anomalieReferentielState.isResolved) return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $c21b1c237cfa1d94$export$2e2bcd8739ae039), {});
    const { categorieList: categorieList, natureList: natureList, typeVisiteList: typeVisiteList } = anomalieReferentielState.data;
    const isSysteme = categorieList.filter((c)=>{
        return c.anomalieCategorieCode === "SYSTEME";
    })[0].anomalieCategorieId === values.anomalieAnomalieCategorieId;
    const listCategorie = categorieList.filter((c)=>{
        // On prend les anomalies non système...
        if (c.anomalieCategorieCode !== "SYSTEME") return true;
        else if (// ... sauf si elle l'est déjà
        c.anomalieCategorieId === values.anomalieAnomalieCategorieId) return true;
        return false;
    }).map((c)=>{
        return {
            id: c.anomalieCategorieId,
            libelle: c.anomalieCategorieLibelle
        };
    });
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                label: "Libell\xe9",
                name: "anomalieLibelle",
                required: true
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                label: "Code",
                name: "anomalieCode",
                required: true,
                disabled: values.anomalieProtected
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$ce9b1cc0c34506d0), {
                label: "Commentaire",
                name: "anomalieCommentaire",
                required: false
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                name: "anomalieAnomalieCategorieId",
                listIdCodeLibelle: listCategorie,
                label: "Cat\xe9gorie",
                setValues: setValues,
                required: true,
                defaultValue: listCategorie.find((e)=>e.id === values.anomalieAnomalieCategorieId),
                disabled: values.anomalieProtected
            }),
            !values.anomalieProtected && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                name: "anomalieActif",
                label: "Actif",
                tooltipText: "Si l\u2019anomalie est inactive, elle ne pourra plus \xeatre assign\xe9e \xe0 un PEI ; cependant elle pourra \xeatre d\xe9sassign\xe9e d\u2019un PEI qui l\u2019a d\xe9j\xe0."
            }),
            !values.anomalieProtected && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                name: "anomalieRendNonConforme",
                label: "Rend non conforme"
            }),
            isSysteme && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1988c313b8430f65$export$2e2bcd8739ae039), {
                className: "mt-2",
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1988c313b8430f65$export$2e2bcd8739ae039).Header, {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                xs: "auto",
                                className: "d-flex",
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                    className: "fw-bold align-self-center",
                                    children: "Valeurs op\xe9rationnelle et HBE"
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1988c313b8430f65$export$2e2bcd8739ae039).Body, {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                    xs: "3",
                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$6bf0cd3a219bbade), {
                                        name: `poidsAnomalieSystemeValIndispoTerrestre`,
                                        label: "Indispo terrestre",
                                        required: false,
                                        min: 0,
                                        max: 5,
                                        step: 1
                                    })
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                    xs: "3",
                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$6bf0cd3a219bbade), {
                                        name: `poidsAnomalieSystemeValIndispoHbe`,
                                        label: "Indispo HBE",
                                        required: false,
                                        min: 0,
                                        max: 5,
                                        step: 1
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            !isSysteme && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $bkJfK.FieldArray), {
                name: "poidsAnomalieList",
                render: (arrayHelpers)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1988c313b8430f65$export$2e2bcd8739ae039), {
                        className: "mt-2",
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1988c313b8430f65$export$2e2bcd8739ae039).Header, {
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                            xs: "auto",
                                            className: "d-flex",
                                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                                className: "fw-bold align-self-center",
                                                children: "Nature de points d'eau"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                            xs: "auto",
                                            className: "d-flex",
                                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $943025b58510539f$export$2e2bcd8739ae039), {
                                                className: "align-self-center",
                                                children: [
                                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $943025b58510539f$export$2e2bcd8739ae039).Toggle, {
                                                        variant: "primary",
                                                        id: "dropdown-basic",
                                                        children: [
                                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$d776d19dfae66ece), {}),
                                                            " Ajouter une nature"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $943025b58510539f$export$2e2bcd8739ae039).Menu, {
                                                        children: natureList.filter((n)=>!values.poidsAnomalieList.some((pa)=>pa.poidsAnomalieNatureId === n.natureId)).map((nature, idxN)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $943025b58510539f$export$2e2bcd8739ae039).Item, {
                                                                variant: "link",
                                                                className: "text-info",
                                                                onClick: ()=>arrayHelpers.push({
                                                                        poidsAnomalieNatureId: nature.natureId
                                                                    }),
                                                                children: nature.natureLibelle
                                                            }, idxN))
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1988c313b8430f65$export$2e2bcd8739ae039).Body, {
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $87d0f3f36f67a4f7$export$2e2bcd8739ae039), {
                                    className: "list-group-flush",
                                    children: values.poidsAnomalieList.map((poidsAnomalie, idxPA)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $87d0f3f36f67a4f7$export$2e2bcd8739ae039).Item, {
                                            children: [
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                                            xs: "auto",
                                                            className: "d-flex",
                                                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                                                className: "fw-bold align-self-center",
                                                                children: natureList.filter((n)=>n.natureId === poidsAnomalie.poidsAnomalieNatureId)[0]?.natureLibelle
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                                            xs: "auto",
                                                            className: "d-flex align-self-center",
                                                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                                                                variant: "link",
                                                                className: "text-danger",
                                                                onClick: ()=>arrayHelpers.remove(idxPA),
                                                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$4d4e10ce882b8153), {})
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                                            xs: "3",
                                                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$6bf0cd3a219bbade), {
                                                                name: `poidsAnomalieList[${idxPA}].poidsAnomalieValIndispoTerrestre`,
                                                                label: "Indispo terrestre",
                                                                required: false,
                                                                min: 0,
                                                                max: 5,
                                                                step: 1
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                                            xs: "3",
                                                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$6bf0cd3a219bbade), {
                                                                name: `poidsAnomalieList[${idxPA}].poidsAnomalieValIndispoHbe`,
                                                                label: "Indispo HBE",
                                                                required: false,
                                                                min: 0,
                                                                max: 5,
                                                                step: 1
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                                            xs: "6",
                                                            className: "d-flex",
                                                            children: !values.anomalieProtected && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $a43e6f68e14bab96$export$2e2bcd8739ae039), {
                                                                className: "align-self-center",
                                                                children: typeVisiteList.map((typeVisite, idxTV)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8b78b8a93971307c$export$2e2bcd8739ae039), {
                                                                        value: typeVisite,
                                                                        name: `poidsAnomalieList[${idxPA}].poidsAnomalieTypeVisite[${idxTV}]`,
                                                                        onClick: ()=>{
                                                                            const res = values.poidsAnomalieList[idxPA].poidsAnomalieTypeVisite ?? [];
                                                                            if (res.indexOf(typeVisite) === -1) res.push(typeVisite);
                                                                            else res.splice(res.indexOf(typeVisite), 1);
                                                                            setFieldValue(`poidsAnomalieList[${idxPA}].poidsAnomalieTypeVisite`, res);
                                                                        },
                                                                        checked: values.poidsAnomalieList[idxPA]?.poidsAnomalieTypeVisite?.some((p)=>p === typeVisite),
                                                                        type: "radio",
                                                                        variant: "outline-primary",
                                                                        children: typeVisite
                                                                    }, `${idxPA}-${typeVisite}`))
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, idxPA))
                                })
                            })
                        ]
                    })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db9b0e6fdb142a4c$export$2e2bcd8739ae039), {
                returnLink: true
            })
        ]
    });
};
var $6e72ec37d2303b77$export$2e2bcd8739ae039 = $6e72ec37d2303b77$var$AnomalieForm;


const $50c218009ece03e0$var$AnomalieCreate = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                title: "Cr\xe9ation d'une anomalie",
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$b51dd496211ae105), {})
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                initialValues: (0, $6e72ec37d2303b77$export$a5cab80145b70e98)(),
                prepareVariables: (values)=>(0, $6e72ec37d2303b77$export$8470ef9d0802da38)(values),
                validationSchema: (0, $6e72ec37d2303b77$export$c084437b5e3206cd),
                submitUrl: `/api/anomalie/create`,
                isPost: true,
                redirectUrl: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_ANOMALIE,
                onSubmit: ()=>true,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $6e72ec37d2303b77$export$2e2bcd8739ae039), {})
            })
        ]
    });
};
var $50c218009ece03e0$export$2e2bcd8739ae039 = $50c218009ece03e0$var$AnomalieCreate;




var $kc00y = parcelRequire("kc00y");














const $31e7dde0e854b550$var$AnomalieList = ()=>{
    const anomalieListState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/anomalie/list`);
    const { visible: visible, show: show, close: close, ref: ref } = (0, $ca8671088139af49$export$2e2bcd8739ae039)();
    const [anomalieidToDelete, setAnomalieidToDelete] = (0, $kc00y.useState)();
    if (!anomalieListState.isResolved) return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $c21b1c237cfa1d94$export$2e2bcd8739ae039), {});
    const { anomalieList: anomalieList, categorieList: categorieList, natureList: natureList, typeList: typeList } = anomalieListState.data;
    const typeMap = typeList.map((t)=>{
        return {
            label: t,
            count: natureList.filter((n)=>n.natureTypePei === t).length
        };
    });
    const natureCount = natureList.length;
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                title: "Anomalies",
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$c304c9f6181ead35), {}),
                right: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8ad69b89456b65bc$export$2e2bcd8739ae039), {
                    href: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).ANOMALIE_CREATE,
                    title: "Ajouter une anomalie"
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $13de46b4dfcc473f$export$2e2bcd8739ae039), {
                striped: true,
                bordered: true,
                hover: true,
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("thead", {
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("th", {
                                        rowSpan: 2,
                                        children: "Anomalie"
                                    }),
                                    typeMap.map((_type, idxNT)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("th", {
                                            colSpan: _type.count,
                                            children: _type.label
                                        }, idxNT))
                                ]
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("tr", {
                                children: natureList.map((nature, idxN)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("th", {
                                        children: nature.natureLibelle
                                    }, idxN))
                            })
                        ]
                    }),
                    categorieList.map((categorie, idxC)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("tbody", {
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("tr", {
                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("th", {
                                        colSpan: natureCount + 1,
                                        className: "bg-primary text-light p-0",
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                                            className: "d-flex align-items-center justify-content-between px-3",
                                            style: {
                                                minHeight: "48px"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                                    className: "w-100 text-center",
                                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("span", {
                                                        className: "fs-6",
                                                        children: categorie.anomalieCategorieLibelle
                                                    })
                                                }),
                                                categorie.anomalieCategorieCode !== "SYSTEME" && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                                    className: "d-flex align-items-center",
                                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                                                        tooltipText: "Changer l'ordre des \xe9l\xe9ments",
                                                        tooltipId: "tooltipOrder",
                                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $43f579690a1c166d$export$2e2bcd8739ae039), {
                                                            pathname: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).ANOMALIE_SORT(categorie.anomalieCategorieId),
                                                            variant: "link",
                                                            className: "text-light",
                                                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$94727896c77b7d99), {})
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                }),
                                anomalieList.filter(({ anomalie: anomalie })=>anomalie.anomalieAnomalieCategorieId === categorie.anomalieCategorieId).map(({ anomalie: anomalie, anomaliePoidsList: anomaliePoidsList }, idxA)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("th", {
                                                children: [
                                                    anomalie.anomalieLibelle,
                                                    "\xa0",
                                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $43f579690a1c166d$export$2e2bcd8739ae039), {
                                                        pathname: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).ANOMALIE_UPDATE(anomalie.anomalieId),
                                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$b51dd496211ae105), {})
                                                    }),
                                                    !anomalie.anomalieProtected && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                                                        variant: "link",
                                                        className: "text-danger",
                                                        onClick: ()=>{
                                                            setAnomalieidToDelete(anomalie.anomalieId);
                                                            show();
                                                        },
                                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$4d4e10ce882b8153), {})
                                                    })
                                                ]
                                            }),
                                            categorie.anomalieCategorieCode === (0, $f740b0d032822ba6$export$8c8e0799e4488510) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("td", {
                                                colSpan: natureCount,
                                                children: [
                                                    anomalie.anomaliePoidsAnomalieSystemeValIndispoTerrestre || "-",
                                                    "\xa0/\xa0",
                                                    anomalie.anomaliePoidsAnomalieSystemeValIndispoHbe || "-"
                                                ]
                                            }),
                                            categorie.anomalieCategorieCode !== (0, $f740b0d032822ba6$export$8c8e0799e4488510) && natureList.map((nature, idxN)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("td", {
                                                    children: anomaliePoidsList.filter((ap)=>ap.poidsAnomalieNatureId === nature.natureId).map((ap)=>ap.poidsAnomalieTypeVisite?.length > 0 ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                                                            tooltipId: ap.poidsAnomalieId,
                                                            tooltipHeader: "Types de visite",
                                                            tooltipText: ap.poidsAnomalieTypeVisite.join(", "),
                                                            children: [
                                                                ap.poidsAnomalieValIndispoTerrestre ?? "-",
                                                                "\xa0/\xa0",
                                                                ap.poidsAnomalieValIndispoHbe ?? "-",
                                                                "\xa0",
                                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $98f55aa78fbaf278$export$2e2bcd8739ae039), {
                                                                    bg: "primary",
                                                                    pill: true,
                                                                    children: ap.poidsAnomalieTypeVisite.length
                                                                })
                                                            ]
                                                        }, ap.poidsAnomalieId) : /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                                                            children: [
                                                                ap.poidsAnomalieValIndispoTerrestre ?? "-",
                                                                "\xa0/\xa0",
                                                                ap.poidsAnomalieValIndispoHbe ?? "-"
                                                            ]
                                                        }))
                                                }, `${idxA}${idxN}`))
                                        ]
                                    }, idxA))
                            ]
                        }, idxC))
                ]
            }),
            visible && anomalieidToDelete && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $791e7ee3b0d1ae7e$export$2e2bcd8739ae039), {
                visible: visible,
                onCancel: close,
                onSuccess: close,
                onError: close,
                query: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/anomalie/delete/` + anomalieidToDelete,
                ref: ref,
                onDelete: ()=>{
                    setAnomalieidToDelete(null);
                    anomalieListState.reload();
                }
            })
        ]
    });
};
var $31e7dde0e854b550$export$2e2bcd8739ae039 = $31e7dde0e854b550$var$AnomalieList;









var $kc00y = parcelRequire("kc00y");












const $079903718aba65cb$var$SortableRowIdCodeLibelle = ({ id: id, item: // La propriété id doit impérativement s'appeler id
item })=>{
    const { setNodeRef: setNodeRef, listeners: listeners, transform: transform, transition: transition } = (0, $6e75a0664b0e0f07$export$4ebcb6201122185a)({
        id: id
    });
    const styles = {
        transform: (0, $f5d873c94758f78f$export$c4ffa16951855e28).Transform.toString(transform),
        transition: transition
    };
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("tr", {
        ref: setNodeRef,
        style: styles,
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("td", {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("span", {
                        ...listeners,
                        role: "button",
                        className: "pe-2",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$72e0de8e793fca75), {})
                    }),
                    item.code
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("td", {
                children: item.libelle
            })
        ]
    });
};
const $079903718aba65cb$var$SortableTableIdCodeLibelle = ({ data: data, setData: setData })=>{
    function dragEndEvent(e) {
        const { over: over, active: active } = e;
        setData((data)=>{
            return (0, $6e75a0664b0e0f07$export$5d49d615ad5ea2b0)(data, data.findIndex((item)=>item.id === active.id), data.findIndex((item)=>item.id === over?.id));
        });
    }
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $3b30af0a3bfceeb3$export$2d5c5ceac203fc1e), {
        onDragEnd: dragEndEvent,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $13de46b4dfcc473f$export$2e2bcd8739ae039), {
            bordered: true,
            striped: true,
            children: [
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("thead", {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("th", {
                                children: [
                                    "Code",
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                                        tooltipText: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                                            children: [
                                                "Utilisez la fonctionnalit\xe9 de glisser / d\xe9placer \xe0 l'aide du bouton ",
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$72e0de8e793fca75), {}),
                                                " en d\xe9but de ligne pour placer les \xe9l\xe9ments dans l'ordre souhait\xe9"
                                            ]
                                        }),
                                        tooltipId: "dragDropAnomalie",
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$340bfce9b4df026b), {})
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("th", {
                                children: "Libell\xe9"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("tbody", {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $6e75a0664b0e0f07$export$86155fde54f06e6a), {
                        items: data,
                        children: data.map((v, index)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($079903718aba65cb$var$SortableRowIdCodeLibelle, {
                                id: v.id,
                                item: v
                            }, index))
                    })
                })
            ]
        })
    });
};
const $079903718aba65cb$var$SortIdCodeLibelle = ({ title: title, apiAdressForGetOrder: apiAdressForGetOrder, apiAdressForPutUpdateOrder: apiAdressForPutUpdateOrder, beforeTri: beforeTri })=>{
    const nomenclatureInfo = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`${apiAdressForGetOrder}`);
    const [data, setData] = (0, $kc00y.useState)(null);
    const [errorMessage, setErrorMessage] = (0, $kc00y.useState)(null);
    const { success: successToast, error: errorToast } = (0, $6bdae0bad7b05751$export$91b3d218c74c79e4)();
    const navigate = (0, $7a844823b04d4282$export$9770f232ac06a008)();
    const location = (0, $7a844823b04d4282$export$45d76561a5302f2b)();
    if (nomenclatureInfo.isResolved && data == null) setData(nomenclatureInfo.data.map((e, index)=>{
        return {
            id: e.id,
            code: e.code,
            libelle: e.libelle,
            index: index
        };
    }));
    const execute = (0, $8d9ebd8892d8a5f5$export$f378150f39d4621f)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`${apiAdressForPutUpdateOrder}`, {
        onResolve: ()=>{
            (0, $c066b242635c27a6$export$e37953fa8ba80500)(location, navigate, (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_ANOMALIE_CATEGORIE);
            successToast("L'\xe9l\xe9ment a bien \xe9t\xe9 d\xe9plac\xe9.");
        },
        onReject: async (error)=>{
            setErrorMessage(await error.text());
            errorToast(await error.text());
        }
    }, false);
    const submitList = ()=>{
        const formattedData = data.map((e, index)=>{
            return {
                id: e.id,
                idx: index
            };
        }).sort((a, b)=>{
            return a.idx - b.idx;
        }).map((e)=>{
            return e.id;
        });
        execute.run({
            listeObjet: formattedData
        });
    };
    return data && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$94727896c77b7d99), {}),
                title: title
            }),
            beforeTri,
            errorMessage !== null && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                className: "text-danger",
                children: errorMessage
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($079903718aba65cb$var$SortableTableIdCodeLibelle, {
                data: data,
                setData: setData
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db9b0e6fdb142a4c$export$2e2bcd8739ae039), {
                onClick: submitList
            })
        ]
    });
};
var $079903718aba65cb$export$2e2bcd8739ae039 = $079903718aba65cb$var$SortIdCodeLibelle;


const $342c4304486fda19$var$AnomalieSort = ()=>{
    const { anomalieCategorieId: anomalieCategorieId } = (0, $7a844823b04d4282$export$99eaa27ddbbb95ef)();
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $079903718aba65cb$export$2e2bcd8739ae039), {
        title: "Gestion de l'ordre des anomalies",
        apiAdressForGetOrder: `/api/tri-nomenclature/anomalie/get-ordre/${anomalieCategorieId}`,
        apiAdressForPutUpdateOrder: `/api/tri-nomenclature/anomalie/update-ordre`
    });
};
var $342c4304486fda19$export$2e2bcd8739ae039 = $342c4304486fda19$var$AnomalieSort;













const $62a11b0be133b8a2$var$AnomalieUpdate = ()=>{
    const { anomalieId: anomalieId } = (0, $7a844823b04d4282$export$99eaa27ddbbb95ef)();
    const anomalieState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/anomalie/${anomalieId}`);
    if (!anomalieState.isResolved) return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $c21b1c237cfa1d94$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                title: "Modification d'une anomalie",
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$b51dd496211ae105), {})
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                initialValues: (0, $6e72ec37d2303b77$export$a5cab80145b70e98)(anomalieState.data),
                prepareVariables: (values)=>(0, $6e72ec37d2303b77$export$8470ef9d0802da38)(values),
                validationSchema: (0, $6e72ec37d2303b77$export$c084437b5e3206cd),
                submitUrl: `/api/anomalie/update/${anomalieId}`,
                isPost: false,
                redirectUrl: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_ANOMALIE,
                onSubmit: ()=>true,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $6e72ec37d2303b77$export$2e2bcd8739ae039), {})
            })
        ]
    });
};
var $62a11b0be133b8a2$export$2e2bcd8739ae039 = $62a11b0be133b8a2$var$AnomalieUpdate;











var $bkJfK = parcelRequire("bkJfK");





const $c12226475ed91703$export$a04a503d8277ee43 = (data)=>({
        code: data?.code ?? null,
        libelle: data?.libelle ?? null,
        actif: data?.actif ?? false,
        protected: data?.protected ?? false,
        idFk: data?.idFk ?? null
    });
const $c12226475ed91703$export$8470ef9d0802da38 = (values)=>({
        code: values.code,
        libelle: values.libelle,
        actif: values.actif,
        protected: values.protected,
        idFk: values.idFk
    });
const $c12226475ed91703$export$c084437b5e3206cd = (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({
    code: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
    libelle: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
    actif: (0, $36ceaed6faf947af$export$87bba3bb7a1f4285)
});
const $c12226475ed91703$export$4d91c9a4655386b1 = ({ hasProtectedValue: hasProtectedValue = true, listeFk: listeFk, libelleFk: libelleFk, isFkRequired: isFkRequired })=>{
    const { values: values, setValues: setValues } = (0, $bkJfK.useFormikContext)();
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                label: "Code",
                name: "code",
                required: true,
                disabled: hasProtectedValue && values.protected
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                label: "Libell\xe9",
                name: "libelle",
                required: true
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                name: "actif",
                label: "Actif"
            }),
            hasProtectedValue && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                name: "protected",
                label: "Prot\xe9g\xe9",
                disabled: true
            }),
            listeFk && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                name: "idFk",
                label: libelleFk,
                listIdCodeLibelle: listeFk,
                setValues: setValues,
                defaultValue: listeFk?.find((e)=>e.id === values.idFk),
                required: isFkRequired
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db9b0e6fdb142a4c$export$2e2bcd8739ae039), {
                returnLink: true
            })
        ]
    });
};


const $1cf1e7fff5b3e31a$var$CreateNomenclature = ({ typeNomenclature: typeNomenclature, redirectLink: redirectLink, titrePage: titrePage = "Cr\xe9ation", isFkRequired: isFkRequired = false })=>{
    const location = (0, $7a844823b04d4282$export$45d76561a5302f2b)();
    const state = location.state ?? {};
    const { hasProtectedValue: hasProtectedValue = true, listeFk: listeFk = null, libelleFk: libelleFk = null, ...rest } = state;
    const initialValues = {
        hasProtectedValue: hasProtectedValue,
        listeFk: listeFk,
        libelleFk: libelleFk
    };
    if (state) window.history.replaceState(rest, "");
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                title: titrePage,
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$d776d19dfae66ece), {})
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                initialValues: (0, $c12226475ed91703$export$a04a503d8277ee43)(initialValues),
                prepareVariables: (values)=>(0, $c12226475ed91703$export$8470ef9d0802da38)(values),
                validationSchema: (0, $c12226475ed91703$export$c084437b5e3206cd),
                submitUrl: `/api/nomenclature/${typeNomenclature}/create/`,
                isPost: true,
                redirectUrl: redirectLink,
                onSubmit: ()=>true,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $c12226475ed91703$export$4d91c9a4655386b1), {
                    hasProtectedValue: initialValues.hasProtectedValue,
                    listeFk: initialValues.listeFk,
                    libelleFk: initialValues.libelleFk,
                    isFkRequired: isFkRequired
                })
            })
        ]
    });
};
var $1cf1e7fff5b3e31a$export$2e2bcd8739ae039 = $1cf1e7fff5b3e31a$var$CreateNomenclature;




const $1cd9ddd687574c40$var$CreateAnomalieCategorie = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1cf1e7fff5b3e31a$export$2e2bcd8739ae039), {
        typeNomenclature: (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).ANOMALIE_CATEGORIE,
        redirectLink: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_ANOMALIE_CATEGORIE
    });
};
var $1cd9ddd687574c40$export$2e2bcd8739ae039 = $1cd9ddd687574c40$var$CreateAnomalieCategorie;





















const $4fa37f4c6ac6c8cc$var$FilterValues = ({ code: code, libelle: libelle, protected: isProtected, actif: actif, idFk: idFk })=>{
    const filter = {};
    $4fa37f4c6ac6c8cc$var$filterProperty(filter, code, "code");
    $4fa37f4c6ac6c8cc$var$filterProperty(filter, libelle, "libelle");
    $4fa37f4c6ac6c8cc$var$filterProperty(filter, actif, "actif");
    $4fa37f4c6ac6c8cc$var$filterProperty(filter, isProtected, "protected");
    $4fa37f4c6ac6c8cc$var$filterProperty(filter, idFk, "idFk");
    return filter;
};
function $4fa37f4c6ac6c8cc$var$filterProperty(filter, value, name) {
    if (value != null && value.trim() !== "") filter[name] = value;
}
var $4fa37f4c6ac6c8cc$export$2e2bcd8739ae039 = $4fa37f4c6ac6c8cc$var$FilterValues;


const $e5bcd0ed5e4cafe8$var$ListNomenclature = ({ pageTitle: pageTitle, pageIcon: pageIcon, typeNomenclature: typeNomenclature, lienPageAjout: lienPageAjout, hasProtectedValue: hasProtectedValue = true, listeFk: listeFk, libelleFk: libelleFk, lienPageUpdate: lienPageUpdate, addButtonTitle: addButtonTitle, additionalButton: additionalButton, additionalActionButton: additionalActionButton })=>{
    const { user: user } = (0, $e787cde576104469$export$fdc397e486fa83e7)();
    const listeButton = [];
    if ((0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_PARAM_APPLI) || (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_DROITS)) {
        if (additionalActionButton) listeButton.push(additionalActionButton);
        listeButton.push({
            row: (row)=>{
                return row;
            },
            state: {
                hasProtectedValue: hasProtectedValue,
                listeFk: listeFk,
                libelleFk: libelleFk
            },
            route: lienPageUpdate,
            type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).UPDATE
        });
        listeButton.push({
            disable: (v)=>{
                // return hasProtectedValue ? v.original.protected : false;
                return hasProtectedValue && v.original.protected || v.original.tablesDependantes?.length > 0;
            },
            textDisableFunction: (v)=>{
                if (hasProtectedValue && v.original.protected) return "Impossible de supprimer un \xe9l\xe9ment prot\xe9g\xe9";
                else return "Impossible de supprimer l'\xe9l\xe9ment car il est utilis\xe9 dans les tables suivantes : " + v.original.tablesDependantes?.join(", ");
            },
            row: (row)=>{
                return row;
            },
            type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).DELETE,
            pathname: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/nomenclature/${typeNomenclature}/delete/`
        });
    }
    const colonneFk = listeFk ? [
        {
            Header: libelleFk,
            accessor: "libelleFk",
            sortField: "libelleFk",
            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $3744b2a772efdf44$export$2e2bcd8739ae039), {
                name: "idFk",
                listIdCodeLibelle: listeFk
            })
        }
    ] : [];
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                title: pageTitle,
                icon: pageIcon,
                urlRetour: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).MODULE_ADMIN,
                right: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                            children: additionalButton
                        }),
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8ad69b89456b65bc$export$2e2bcd8739ae039), {
                                title: addButtonTitle,
                                href: lienPageAjout,
                                state: {
                                    hasProtectedValue: hasProtectedValue,
                                    listeFk: listeFk,
                                    libelleFk: libelleFk
                                }
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $9a9eebc3462fba73$export$2e2bcd8739ae039), {
                filterValuesToVariable: (0, $4fa37f4c6ac6c8cc$export$2e2bcd8739ae039),
                query: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/nomenclature/` + typeNomenclature + "/get",
                columns: [
                    {
                        Header: "Code",
                        accessor: "code",
                        sortField: "code",
                        Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                            type: "text",
                            name: "code"
                        })
                    },
                    {
                        Header: "Libell\xe9",
                        accessor: "libelle",
                        sortField: "libelle",
                        Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                            type: "text",
                            name: "libelle"
                        })
                    },
                    (0, $b82b937cc97f6f18$export$38dcf858d3ede0e9)({
                        Header: "Actif",
                        accessor: "actif",
                        sortField: "actif",
                        Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eed37ff3d3e1f28c$export$2e2bcd8739ae039), {
                            options: (0, $a4f278cac9030fb1$export$2e2bcd8739ae039),
                            name: "actif"
                        })
                    }),
                    ...colonneFk,
                    ...hasProtectedValue ? [
                        (0, $b82b937cc97f6f18$export$4f228b0e0fb17419)({
                            Header: "Prot\xe9g\xe9",
                            accessor: "protected",
                            sortField: "protected",
                            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eed37ff3d3e1f28c$export$2e2bcd8739ae039), {
                                options: (0, $a4f278cac9030fb1$export$2e2bcd8739ae039),
                                name: "protected"
                            })
                        })
                    ] : [],
                    (0, $b82b937cc97f6f18$export$36e9f5a475c9f6fc)({
                        Header: "Actions",
                        accessor: "id",
                        buttons: listeButton
                    })
                ],
                idName: "ListNomenclature",
                filterContext: (0, $9a9eebc3462fba73$export$396ef541d9951d45)({
                    code: undefined,
                    libelle: undefined,
                    actif: undefined,
                    protected: undefined
                })
            })
        ]
    });
};
var $e5bcd0ed5e4cafe8$export$2e2bcd8739ae039 = $e5bcd0ed5e4cafe8$var$ListNomenclature;




const $b875d3d827f045ce$var$ListAnomalieCategorie = ()=>{
    const sortButton = /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $43f579690a1c166d$export$2e2bcd8739ae039), {
        pathname: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).SORT_ANOMALIE_CATEGORIE,
        variant: "primary",
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$94727896c77b7d99), {}),
            " Changer l'ordre des \xe9l\xe9ments"
        ]
    });
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e5bcd0ed5e4cafe8$export$2e2bcd8739ae039), {
        pageTitle: "Cat\xe9gories d'anomalies",
        addButtonTitle: "Ajouter une cat\xe9gorie d'anomalie",
        pageIcon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$c304c9f6181ead35), {}),
        lienPageAjout: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).ADD_ANOMALIE_CATEGORIE,
        typeNomenclature: (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).ANOMALIE_CATEGORIE,
        lienPageUpdate: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).UPDATE_ANOMALIE_CATEGORIE,
        additionalButton: sortButton
    });
};
var $b875d3d827f045ce$export$2e2bcd8739ae039 = $b875d3d827f045ce$var$ListAnomalieCategorie;




const $68abd1dbff894189$var$SortAnomalieCategorie = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $079903718aba65cb$export$2e2bcd8739ae039), {
        title: "Gestion de l'ordre des cat\xe9gories d'anomalies",
        apiAdressForGetOrder: `/api/tri-nomenclature/anomalie-categorie/get-ordre`,
        apiAdressForPutUpdateOrder: `/api/tri-nomenclature/anomalie-categorie/update-ordre`
    });
};
var $68abd1dbff894189$export$2e2bcd8739ae039 = $68abd1dbff894189$var$SortAnomalieCategorie;













const $4e0326405bcaf2aa$var$UpdateNomenclature = ({ nomenclatureId: nomenclatureId, typeNomenclature: typeNomenclature, redirectLink: redirectLink, titrePage: titrePage = "Modification", isFkRequired: isFkRequired = false })=>{
    const nomenclatureState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/nomenclature/${typeNomenclature}/get/${nomenclatureId}`);
    const location = (0, $7a844823b04d4282$export$45d76561a5302f2b)();
    const state = location.state ?? {};
    const { hasProtectedValue: hasProtectedValue = true, listeFk: listeFk, libelleFk: libelleFk, ...rest } = state;
    const initialValues = {
        hasProtectedValue: hasProtectedValue,
        listeFk: listeFk,
        libelleFk: libelleFk
    };
    if (state) window.history.replaceState(rest, "");
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                title: titrePage,
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$b51dd496211ae105), {})
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                initialValues: (0, $c12226475ed91703$export$a04a503d8277ee43)({
                    ...initialValues,
                    ...nomenclatureState.data
                }),
                prepareVariables: (values)=>(0, $c12226475ed91703$export$8470ef9d0802da38)(values),
                validationSchema: (0, $c12226475ed91703$export$c084437b5e3206cd),
                submitUrl: `/api/nomenclature/` + typeNomenclature + "/update/" + nomenclatureId,
                isPost: false,
                redirectUrl: redirectLink,
                onSubmit: ()=>true,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $c12226475ed91703$export$4d91c9a4655386b1), {
                    hasProtectedValue: initialValues.hasProtectedValue,
                    listeFk: initialValues.listeFk,
                    libelleFk: initialValues.libelleFk,
                    isFkRequired: isFkRequired
                })
            })
        ]
    });
};
var $4e0326405bcaf2aa$export$2e2bcd8739ae039 = $4e0326405bcaf2aa$var$UpdateNomenclature;




const $4ead303c0a3099b7$var$UpdateAnomalieCategorie = ()=>{
    const { anomalieCategorieId: anomalieCategorieId } = (0, $7a844823b04d4282$export$99eaa27ddbbb95ef)();
    return anomalieCategorieId && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $4e0326405bcaf2aa$export$2e2bcd8739ae039), {
        nomenclatureId: anomalieCategorieId,
        typeNomenclature: (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).ANOMALIE_CATEGORIE,
        redirectLink: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_ANOMALIE_CATEGORIE
    });
};
var $4ead303c0a3099b7$export$2e2bcd8739ae039 = $4ead303c0a3099b7$var$UpdateAnomalieCategorie;




var $bkJfK = parcelRequire("bkJfK");

var $kc00y = parcelRequire("kc00y");























const $74792707776b6587$export$202c97fd1d7c1d9d = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            "Fichier ZIP :",
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                placement: "right",
                tooltipText: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("span", {
                                        className: "text-danger",
                                        children: "*"
                                    }),
                                    " : Champs obligatoires"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                    className: "fw-bold",
                                    children: "Contenu attendu du fichier ZIP"
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                                    className: "ms-2",
                                    children: [
                                        "Le fichier ZIP doit contenir les \xe9l\xe9ments suivants :",
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("ul", {
                                            children: [
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("li", {
                                                    children: [
                                                        "Un dossier ",
                                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("b", {
                                                            children: "PAGES"
                                                        }),
                                                        "."
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("li", {
                                                    children: "Dans ce dossier, les fichiers PDF des pages de l'atlas."
                                                }),
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("li", {
                                                    children: [
                                                        "Un fichier SHAPE au format ",
                                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("code", {
                                                            children: ".zip"
                                                        }),
                                                        " contenant les g\xe9om\xe9tries des pages. Chaque entit\xe9 du SHAPE doit porter le m\xeame identifiant que le fichier PDF correspondant (par exemple ",
                                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("code", {
                                                            children: "001"
                                                        }),
                                                        " \u2194 ",
                                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("code", {
                                                            children: "001.pdf"
                                                        }),
                                                        "). Les fichiers SHAPE doivent contenir les colones suivantes :",
                                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("ul", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("li", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("code", {
                                                                            children: "fichier"
                                                                        }),
                                                                        " : nom du fichier PDF"
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("li", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("code", {
                                                                            children: "the_geom"
                                                                        }),
                                                                        " : g\xe9om\xe9trie du fichier"
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("li", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("code", {
                                                                            children: "actif"
                                                                        }),
                                                                        " : dit si le fichier est actif ou non (TRUE/FALSE)"
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("li", {
                                                            children: [
                                                                "Le dossier ",
                                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("b", {
                                                                    children: "ANNEXES"
                                                                }),
                                                                " est facultatif. Il peut contenir des documents PDF compl\xe9mentaires. Un fichier csv est requis pour l'association des pages visibles aux pages de l'atlas. Il doit contenir les colonnes suivantes :",
                                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("ul", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("li", {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("code", {
                                                                                    children: "nom_fichier_pdf"
                                                                                }),
                                                                                " : nom du fichier PDF pr\xe9sent dans le dossier ANNEXES"
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("li", {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("code", {
                                                                                    children: "actif"
                                                                                }),
                                                                                " : dit si le fichier est actif ou non (TRUE/FALSE)"
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("li", {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("code", {
                                                                                    children: "nom_annexe"
                                                                                }),
                                                                                " : nom du fichier. Peut \xeatre non d\xe9fini. Si non d\xe9fini, le nom du fichier PDF sera utilis\xe9."
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                tooltipHeader: "Contenu du fichier ZIP",
                tooltipId: "importAtlasZIP",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$340bfce9b4df026b), {})
            })
        ]
    });
};




const $e10d887943ac93e2$var$VerificationImportAtlasZip = (data)=>{
    const errors = data?.data?.importZipData?.errors || [];
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
            children: errors.length > 0 ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $13de46b4dfcc473f$export$2e2bcd8739ae039), {
                        bordered: true,
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("thead", {
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("tr", {
                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("th", {
                                        children: "Erreurs"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("tbody", {
                                children: errors.map((error, index)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("tr", {
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("td", {
                                            children: error.message
                                        })
                                    }, `${error.message}-${index}`))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                        className: "alert alert-danger text-center p-5 mt-4",
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("h4", {
                                children: "Les fichiers n'ont pas \xe9t\xe9 enregistr\xe9s."
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("p", {
                                children: "Veuillez corriger les erreurs et r\xe9essayer."
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                className: "alert alert-success text-center p-5 mt-4",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("h4", {
                    children: "Les fichiers ont bien \xe9t\xe9 enregistr\xe9s."
                })
            })
        })
    });
};
var $e10d887943ac93e2$export$2e2bcd8739ae039 = $e10d887943ac93e2$var$VerificationImportAtlasZip;


const $db6ad79f456e3735$var$getInitialValues = ()=>({
        importAtlasZip: null
    });
const $db6ad79f456e3735$var$validationSchema = (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({
    importAtlasZip: (0, $36ceaed6faf947af$export$ec3358fdc98c6c51 // "Le fichier ZIP est requis
    )
});
const $db6ad79f456e3735$var$prepareVariables = (values)=>{
    const formData = new FormData();
    if (values.importAtlasZip) formData.append("importAtlasZip", values.importAtlasZip);
    return formData;
};
const $db6ad79f456e3735$export$6401918d5d43bb8b = ()=>{
    const { user: user } = (0, $e787cde576104469$export$fdc397e486fa83e7)();
    const { handleShowClose: handleShowClose, activesKeys: activesKeys } = (0, $db860d90b4a42fea$export$dae930a4ba30758b)(Array(1).fill(false));
    const [result, setResult] = (0, $kc00y.useState)(null);
    const { isLoading: isLoading, data: hasElements = false } = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)("/api/atlas/has-element", {});
    const importHasErrors = (result?.importZipData?.errors?.length ?? 0) > 0;
    const importSucceeded = result !== null && !importHasErrors;
    const shouldShowAnnexesOrder = (hasElements || importSucceeded) && ((0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ATLAS_C) || (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ATLAS_A));
    const listeAccordion = [];
    listeAccordion.push({
        header: "Importer un fichier ZIP",
        content: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($db6ad79f456e3735$var$FormikImportZip, {
            user: user,
            setResult: setResult,
            hasElements: hasElements
        })
    });
    if (shouldShowAnnexesOrder) listeAccordion.push({
        header: "Ordre des annexes",
        content: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($db6ad79f456e3735$var$AnnexesOrder, {})
    });
    if (isLoading) return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $c21b1c237cfa1d94$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                title: "Gestion de l'Atlas",
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$20b7f16ef18cfa38), {})
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("p", {
                children: "Cet \xe9cran permet la gestion des ressources utilis\xe9es pour l'affichage de l'Atlas."
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db860d90b4a42fea$export$2e2bcd8739ae039), {
                activesKeys: activesKeys,
                handleShowClose: handleShowClose,
                list: listeAccordion
            }),
            result && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e10d887943ac93e2$export$2e2bcd8739ae039), {
                data: result
            })
        ]
    });
};
const $db6ad79f456e3735$var$FormikImportZip = ({ user: user, hasElements: hasElements, setResult: setResult })=>{
    const { visible: visible, show: show, close: close } = (0, $ca8671088139af49$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            hasElements ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("p", {
                className: "text-danger",
                children: "Attention : l'importation d'un fichier ZIP va \xe9craser les fichiers existants."
            }) : /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("p", {
                className: "text-muted",
                children: "Aucune donn\xe9e enregistr\xe9e."
            }),
            ((0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ATLAS_C) || (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ATLAS_A)) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($db6ad79f456e3735$var$ButtonDownloadTemplate, {}),
            (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ATLAS_D) && hasElements && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                        className: "mb-3 ms-3",
                        onClick: ()=>{
                            show();
                        },
                        children: "Supprimer les documents"
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $791e7ee3b0d1ae7e$export$2e2bcd8739ae039), {
                        onCancel: close,
                        onSuccess: close,
                        onError: close,
                        visible: visible,
                        query: `/api/atlas/delete/`,
                        header: "Atlas",
                        content: `Confirmez-vous la purge de l'Atlas ?`,
                        onDelete: ()=>{
                            window.location.reload();
                        },
                        successLibelle: "L'Atlas a \xe9t\xe9 purg\xe9 avec succ\xe8s."
                    })
                ]
            }),
            ((0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ATLAS_A) || (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ATLAS_C)) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                initialValues: $db6ad79f456e3735$var$getInitialValues(),
                validationSchema: $db6ad79f456e3735$var$validationSchema,
                isPost: true,
                isMultipartFormData: true,
                submitUrl: `/api/atlas/import-atlas-zip`,
                prepareVariables: $db6ad79f456e3735$var$prepareVariables,
                onSubmit: (result)=>{
                    setResult(result);
                },
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($db6ad79f456e3735$var$ImportAtlasFormik, {})
            })
        ]
    });
};
const $db6ad79f456e3735$var$ImportAtlasFormik = ()=>{
    const { setFieldValue: setFieldValue } = (0, $bkJfK.useFormikContext)();
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b57af79a4ab2a1c6), {
                label: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $74792707776b6587$export$202c97fd1d7c1d9d), {}),
                name: "importAtlasZip",
                accept: ".zip",
                required: true,
                onChange: (e)=>setFieldValue("importAtlasZip", e.target.files?.[0] ?? null)
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                className: "mt-3",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                    className: "text-center",
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db9b0e6fdb142a4c$export$2e2bcd8739ae039), {
                        submitTitle: "Valider l'import"
                    })
                })
            })
        ]
    });
};
const $db6ad79f456e3735$var$ButtonDownloadTemplate = ()=>{
    const { success: successToast, error: errorToast } = (0, $6bdae0bad7b05751$export$91b3d218c74c79e4)();
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
        className: "mb-3",
        onClick: ()=>(0, $c066b242635c27a6$export$9cca65ea339c61b4)("/api/atlas/download-atlas-zip-template", null, "importAtlasZip.zip", "Export termin\xe9", successToast, errorToast),
        children: [
            "T\xe9l\xe9charger un mod\xe8le",
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$4a5ccdc9878f4668), {})
        ]
    });
};
const $db6ad79f456e3735$var$mapAtlasAnnexeToItem = (annexe)=>({
        id: annexe.atlasAnnexeId,
        libelle: annexe.atlasAnnexeName ?? ""
    });
const $db6ad79f456e3735$var$prepareVariablesDownload = (selectedItems, annexes)=>{
    if (selectedItems.length === 0) return annexes;
    return annexes.map((annexe)=>{
        const selectedIndex = selectedItems.findIndex((item)=>item.id === annexe.atlasAnnexeId);
        return {
            ...annexe,
            atlasAnnexeIsVisible: selectedIndex !== -1,
            atlasAnnexeOrder: selectedIndex !== -1 ? selectedIndex + 1 : null
        };
    });
};
const $db6ad79f456e3735$var$AnnexesOrder = ()=>{
    const { data: atlasDataAnnexes, isLoading: isLoading } = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)("/api/atlas/atlas-documents-annexes", {});
    if (isLoading || !atlasDataAnnexes) return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $c21b1c237cfa1d94$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
        initialValues: {
            downloadAtlasAnnexe: []
        },
        validationSchema: (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({
            downloadAtlasAnnexe: (0, $ce4de947442b2ab1$export$2f23118c22fb2630)().required()
        }),
        isPost: true,
        submitUrl: "/api/atlas/update-pagination-atlas-annexes",
        prepareVariables: (values)=>$db6ad79f456e3735$var$prepareVariablesDownload(values.downloadAtlasAnnexe, atlasDataAnnexes),
        onSubmit: ()=>null,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($db6ad79f456e3735$var$AnnexesOrderForm, {
            atlasDataAnnexes: atlasDataAnnexes
        })
    });
};
const $db6ad79f456e3735$var$AnnexesOrderForm = ({ atlasDataAnnexes: atlasDataAnnexes })=>{
    const { setFieldValue: setFieldValue } = (0, $bkJfK.useFormikContext)();
    const [selectedOptions, setSelectedOptions] = (0, $kc00y.useState)(atlasDataAnnexes.filter((annexe)=>annexe.atlasAnnexeIsVisible).sort((a, b)=>(a.atlasAnnexeOrder ?? 0) - (b.atlasAnnexeOrder ?? 0)).map($db6ad79f456e3735$var$mapAtlasAnnexeToItem));
    const [availableOptions, setAvailableOptions] = (0, $kc00y.useState)(atlasDataAnnexes.filter((annexe)=>!annexe.atlasAnnexeIsVisible).map($db6ad79f456e3735$var$mapAtlasAnnexeToItem));
    const handleSelectedOptions = (options)=>{
        setSelectedOptions((precedent)=>{
            // si on fournit une fonction, elle reçoit la valeur précédente pour calculer
            // la nouvelle valeur. Sinon la valeur passée est utilisée directement.
            const newOptions = typeof options === "function" ? options(precedent) : options;
            setFieldValue("downloadAtlasAnnexe", newOptions);
            return newOptions;
        });
    };
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $5ada21a6009b8ce0$export$2e2bcd8739ae039), {
                availableOptions: availableOptions,
                selectedOptions: selectedOptions,
                setAvailableOptions: setAvailableOptions,
                setSelectedOptions: handleSelectedOptions,
                label: "Pages des annexes \xe0 inclure.",
                tooltipText: "S\xe9lectionnez les pages des annexes que vous souhaitez inclure dans le PDF de l'atlas. L'ordre des pages sera pris en compte.",
                required: false,
                name: "downloadAtlasAnnexe",
                titleColumnAvailable: "Pages d'annexes disponibles",
                titleColumnSelected: "Pages s\xe9lectionn\xe9es"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db9b0e6fdb142a4c$export$2e2bcd8739ae039), {
                submitTitle: "Valider"
            })
        ]
    });
};











var $bkJfK = parcelRequire("bkJfK");








var $e5997c0dce1a3fdf$var$TYPE_CIVILITE = /*#__PURE__*/ function(TYPE_CIVILITE) {
    TYPE_CIVILITE["MADAME"] = "Madame";
    TYPE_CIVILITE["MONSIEUR"] = "Monsieur";
    TYPE_CIVILITE["AUTRE"] = "Autre";
    return TYPE_CIVILITE;
}($e5997c0dce1a3fdf$var$TYPE_CIVILITE || {});
var $e5997c0dce1a3fdf$export$2e2bcd8739ae039 = $e5997c0dce1a3fdf$var$TYPE_CIVILITE;




const $9e8011277f42a0a2$export$a5cab80145b70e98 = (data)=>({
        contactActif: data?.contactActif ?? true,
        contactCivilite: data?.contactCivilite ?? null,
        contactFonctionContactId: data?.contactFonctionContactId ?? null,
        contactNom: data?.contactNom ?? null,
        contactPrenom: data?.contactPrenom ?? null,
        contactNumeroVoie: data?.contactNumeroVoie ?? null,
        contactSuffixeVoie: data?.contactSuffixeVoie ?? null,
        contactLieuDitText: data?.contactLieuDitText ?? null,
        contactLieuDitId: data?.contactLieuDitId ?? null,
        contactVoieText: data?.contactVoieText ?? null,
        contactVoieId: data?.contactVoieId ?? null,
        contactCodePostal: data?.contactCodePostal ?? null,
        contactCommuneText: data?.contactCommuneText ?? null,
        contactCommuneId: data?.contactCommuneId ?? null,
        contactPays: data?.contactPays ?? null,
        contactTelephone: data?.contactTelephone ?? null,
        contactEmail: data?.contactEmail ?? null,
        siteId: data?.siteId ?? null,
        listRoleId: data?.listRoleId ?? [],
        contactIsCompteService: data?.contactIsCompteService ?? false,
        voieSaisieLibre: data?.contactVoieText != null && data?.contactVoieText?.trim() !== "",
        communeSaisieLibre: data?.contactCommuneText != null && data?.contactCommuneText?.trim() !== "",
        lieuDitSaisieLibre: data?.contactLieuDitText != null && data?.contactLieuDitText?.trim() !== ""
    });
const $9e8011277f42a0a2$export$c084437b5e3206cd = (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({
    contactEmail: (0, $36ceaed6faf947af$export$d290fa47940df19d)
});
const $9e8011277f42a0a2$export$f97400759cfd946 = (values)=>({
        contactActif: values.contactActif,
        contactCivilite: values.contactCivilite,
        contactFonctionContactId: values.contactFonctionContactId,
        contactNom: values.contactNom,
        contactPrenom: values.contactPrenom,
        contactNumeroVoie: values.contactNumeroVoie,
        contactSuffixeVoie: values.contactSuffixeVoie,
        contactLieuDitText: values.contactLieuDitText,
        contactLieuDitId: values.contactLieuDitId,
        contactVoieText: values.contactVoieText,
        contactVoieId: values.contactVoieId,
        contactCodePostal: values.contactCodePostal,
        contactCommuneText: values.contactCommuneText,
        contactCommuneId: values.contactCommuneId,
        contactPays: values.contactPays,
        contactTelephone: values.contactTelephone,
        contactEmail: values.contactEmail,
        siteId: values.siteId,
        listRoleId: values.listRoleId,
        contactIsCompteService: values.contactIsCompteService
    });
const $9e8011277f42a0a2$var$Contact = ()=>{
    const { appartenance: appartenance, appartenanceId: appartenanceId } = (0, $7a844823b04d4282$export$99eaa27ddbbb95ef)();
    const roleState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/role/`);
    const siteState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/site/gestionnaire/` + appartenanceId);
    const fonctionContactState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/contact/fonctions`);
    const voieState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/voie/get`);
    const communeState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/commune/get-libelle-commune`);
    const lieuDitState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/lieu-dit/get`);
    const { values: values, setValues: setValues, setFieldValue: setFieldValue } = (0, $bkJfK.useFormikContext)();
    const listCivilite = Object.entries((0, $e5997c0dce1a3fdf$export$2e2bcd8739ae039)).map(([key, value])=>{
        return {
            id: key,
            code: value,
            libelle: value
        };
    });
    const { handleShowClose: handleShowClose, activesKeys: activesKeys } = (0, $db860d90b4a42fea$export$dae930a4ba30758b)([
        true,
        false,
        false,
        false
    ]);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db860d90b4a42fea$export$2e2bcd8739ae039), {
                activesKeys: activesKeys,
                handleShowClose: handleShowClose,
                list: [
                    {
                        header: "Informations g\xe9n\xe9rales",
                        content: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                    className: "mt-3",
                                    children: [
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                                                name: "contactFonctionContactId",
                                                listIdCodeLibelle: fonctionContactState.data,
                                                label: "Fonction",
                                                defaultValue: fonctionContactState.data?.find((e)=>e.id === values.contactFonctionContactId),
                                                required: false,
                                                setValues: setValues
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                                                name: "contactCivilite",
                                                listIdCodeLibelle: listCivilite,
                                                label: "Civilit\xe9",
                                                defaultValue: listCivilite?.find((e)=>e.id === values.contactCivilite),
                                                required: false,
                                                setValues: setValues
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                                                name: "contactActif",
                                                label: "Actif"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                                                label: "Nom",
                                                name: "contactNom",
                                                required: false
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                                                label: "Pr\xe9nom",
                                                name: "contactPrenom",
                                                required: false
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                                                name: "contactIsCompteService",
                                                label: "Compte de service"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                    className: "mt-3",
                                    children: [
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                                                label: "T\xe9l\xe9phone",
                                                name: "contactTelephone",
                                                required: false
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                                                label: "E-mail",
                                                name: "contactEmail",
                                                required: false
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    },
                    {
                        header: "Adresse",
                        content: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                    className: "mt-3",
                                    children: [
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                            children: [
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                                                    name: "contactCommuneId",
                                                    listIdCodeLibelle: communeState.data,
                                                    label: "Commune",
                                                    defaultValue: communeState?.data?.find((e)=>e.id === values.contactCommuneId),
                                                    setValues: setValues,
                                                    disabled: values.communeSaisieLibre
                                                }),
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                                                    name: "communeSaisieLibre",
                                                    label: "Commune non trouv\xe9e"
                                                }),
                                                values.communeSaisieLibre && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                                                                name: "contactCommuneText",
                                                                label: "Commune (saisie libre)",
                                                                required: false
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                                                                label: "Code postal",
                                                                name: "contactCodePostal",
                                                                required: false
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                            children: [
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                                                    name: "contactLieuDitId",
                                                    listIdCodeLibelle: lieuDitState?.data?.filter((e)=>e.communeId === values.contactCommuneId),
                                                    label: "Lieu-dit",
                                                    defaultValue: lieuDitState?.data?.find((e)=>e.id === values.contactLieuDitId),
                                                    optionDisabled: "Veuillez saisir une commune",
                                                    setValues: setValues,
                                                    disabled: values.lieuDitSaisieLibre || !values.contactCommuneId
                                                }),
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                                                    name: "lieuDitSaisieLibre",
                                                    label: "Lieu-dit non trouv\xe9"
                                                }),
                                                values.lieuDitSaisieLibre && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                                                    name: "contactLieuDitText",
                                                    label: "Lieu-dit (saisie libre)",
                                                    required: false
                                                })
                                            ]
                                        }),
                                        appartenance === "gestionnaire" && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                                                name: "siteId",
                                                listIdCodeLibelle: siteState.data,
                                                label: "Site",
                                                defaultValue: siteState?.data?.find((e)=>e.id === values.siteId),
                                                setValues: setValues
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                    className: "mt-3",
                                    children: [
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                                                label: "Num\xe9ro de voie",
                                                name: "contactNumeroVoie",
                                                required: false
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                                                label: "Suffixe",
                                                name: "contactSuffixeVoie",
                                                required: false
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                            children: [
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                                                    name: "contactVoieId",
                                                    listIdCodeLibelle: voieState?.data?.filter((e)=>e.communeId === values.contactCommuneId),
                                                    label: "Voie",
                                                    defaultValue: voieState?.data?.find((e)=>e.id === values.contactVoieId),
                                                    optionDisabled: "Veuillez saisir une commune",
                                                    setValues: setValues,
                                                    disabled: values.voieSaisieLibre || !values.contactCommuneId
                                                }),
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                                                    name: "voieSaisieLibre",
                                                    label: "Voie non trouv\xe9e"
                                                }),
                                                values.voieSaisieLibre && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                                                    name: "contactVoieText",
                                                    label: "Voie (saisie libre)",
                                                    required: false
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                                                label: "Pays",
                                                name: "contactPays",
                                                required: false
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    },
                    {
                        header: "R\xf4les",
                        content: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                            className: "mt-3",
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$eae70af4b4e3f197), {
                                name: "listRoleId",
                                label: "Liste des r\xf4les du contact",
                                options: roleState?.data,
                                getOptionValue: (t)=>t.id,
                                getOptionLabel: (t)=>t.libelle,
                                value: values?.listRoleId?.map((e)=>roleState?.data?.find((r)=>r.id === e)) ?? undefined,
                                onChange: (role)=>{
                                    const roleId = role.map((e)=>e.id);
                                    roleId.length > 0 ? setFieldValue("listRoleId", roleId) : setFieldValue("listRoleId", undefined);
                                },
                                isClearable: true,
                                required: false
                            })
                        })
                    }
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db9b0e6fdb142a4c$export$2e2bcd8739ae039), {
                returnLink: true
            })
        ]
    });
};
var $9e8011277f42a0a2$export$2e2bcd8739ae039 = $9e8011277f42a0a2$var$Contact;


const $3b9dd57c1f2e6dfa$var$CreateContact = ()=>{
    const { appartenanceId: appartenanceId } = (0, $7a844823b04d4282$export$99eaa27ddbbb95ef)();
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$d776d19dfae66ece), {}),
                title: "Cr\xe9ation d'un contact"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                initialValues: (0, $9e8011277f42a0a2$export$a5cab80145b70e98)(),
                validationSchema: (0, $9e8011277f42a0a2$export$c084437b5e3206cd),
                isPost: true,
                submitUrl: `/api/contact/` + appartenanceId + `/create/`,
                prepareVariables: (values)=>(0, $9e8011277f42a0a2$export$f97400759cfd946)(values),
                redirectUrl: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_CONTACT(appartenanceId),
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $9e8011277f42a0a2$export$2e2bcd8739ae039), {})
            })
        ]
    });
};
var $3b9dd57c1f2e6dfa$export$2e2bcd8739ae039 = $3b9dd57c1f2e6dfa$var$CreateContact;




















const $519e426218154f6b$var$FilterValues = ({ contactNom: contactNom, contactCivilite: contactCivilite, contactActif: contactActif, contactPrenom: contactPrenom, fonctionContactLibelle: fonctionContactLibelle, contactTelephone: contactTelephone, contactEmail: contactEmail, siteLibelle: siteLibelle })=>{
    const filter = {};
    $519e426218154f6b$var$filterProperty(filter, contactNom, "contactNom");
    $519e426218154f6b$var$filterProperty(filter, contactCivilite, "contactCivilite");
    $519e426218154f6b$var$filterProperty(filter, contactActif, "contactActif");
    $519e426218154f6b$var$filterProperty(filter, contactPrenom, "contactPrenom");
    $519e426218154f6b$var$filterProperty(filter, fonctionContactLibelle, "fonctionContactLibelle");
    $519e426218154f6b$var$filterProperty(filter, contactTelephone, "contactTelephone");
    $519e426218154f6b$var$filterProperty(filter, siteLibelle, "siteLibelle");
    $519e426218154f6b$var$filterProperty(filter, contactEmail, "contactEmail");
    return filter;
};
function $519e426218154f6b$var$filterProperty(filter, value, name) {
    if (value != null && value.trim() !== "") filter[name] = value;
}
var $519e426218154f6b$export$2e2bcd8739ae039 = $519e426218154f6b$var$FilterValues;


const $18ce4b63951cd018$var$ListContact = ()=>{
    const { appartenanceId: appartenanceId, appartenance: appartenance } = (0, $7a844823b04d4282$export$99eaa27ddbbb95ef)();
    const { user: user } = (0, $e787cde576104469$export$fdc397e486fa83e7)();
    const listeButton = [];
    if (appartenance === "gestionnaire" && (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).GEST_CONTACT_A) || appartenance === "organisme" && (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ORGANISME_CONTACT_A)) {
        listeButton.push({
            row: (row)=>{
                return row;
            },
            route: (contactId)=>(0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).UPDATE_CONTACT(appartenanceId, contactId, appartenance),
            type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).UPDATE
        });
        listeButton.push({
            row: (row)=>{
                return row;
            },
            type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).DELETE,
            pathname: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/contact/${appartenanceId}/delete/`
        });
    }
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                    icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$527d32aa1785fdd4), {}),
                    title: "Liste des contacts",
                    right: ((0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ORGANISME_CONTACT_A) && appartenance === "organisme" || (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).GEST_CONTACT_A) && appartenance === "gestionnaire") && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8ad69b89456b65bc$export$2e2bcd8739ae039), {
                        href: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).ADD_CONTACT(appartenanceId, appartenance),
                        title: "Ajouter un contact"
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $9a9eebc3462fba73$export$2e2bcd8739ae039), {
                    query: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/contact/` + appartenanceId,
                    columns: [
                        (0, $b82b937cc97f6f18$export$38dcf858d3ede0e9)({
                            Header: "Actif",
                            accessor: "contactActif",
                            sortField: "contactActif",
                            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eed37ff3d3e1f28c$export$2e2bcd8739ae039), {
                                options: (0, $a4f278cac9030fb1$export$2e2bcd8739ae039),
                                name: "contactActif"
                            })
                        }),
                        {
                            Header: "Civilit\xe9",
                            accessor: "contactCivilite",
                            sortField: "contactCivilite",
                            Cell: (value)=>{
                                return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                    children: value?.value != null && (0, $e5997c0dce1a3fdf$export$2e2bcd8739ae039)[value.value]
                                });
                            },
                            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eed37ff3d3e1f28c$export$2e2bcd8739ae039), {
                                options: (0, $e5997c0dce1a3fdf$export$2e2bcd8739ae039),
                                name: "contactCivilite"
                            })
                        },
                        {
                            Header: "Nom",
                            accessor: "contactNom",
                            sortField: "contactNom",
                            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                                type: "text",
                                name: "contactNom"
                            })
                        },
                        {
                            Header: "Pr\xe9nom",
                            accessor: "contactPrenom",
                            sortField: "contactPrenom",
                            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                                type: "text",
                                name: "contactPrenom"
                            })
                        },
                        {
                            Header: "Fonction",
                            accessor: "fonctionContactLibelle",
                            sortField: "fonctionContactLibelle",
                            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                                type: "text",
                                name: "fonctionContactLibelle"
                            })
                        },
                        ...appartenance === "gestionnaire" ? [
                            {
                                Header: "Site",
                                accessor: "siteLibelle",
                                sortField: "siteLibelle",
                                Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                                    type: "text",
                                    name: "siteLibelle"
                                })
                            }
                        ] : [],
                        {
                            Header: "T\xe9l\xe9phone",
                            accessor: "contactTelephone",
                            sortField: "contactTelephone",
                            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                                type: "text",
                                name: "contactTelephone"
                            })
                        },
                        {
                            Header: "Email",
                            accessor: "contactEmail",
                            sortField: "contactEmail",
                            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                                type: "text",
                                name: "contactEmail"
                            })
                        },
                        (0, $b82b937cc97f6f18$export$36e9f5a475c9f6fc)({
                            Header: "Actions",
                            accessor: "contactId",
                            buttons: listeButton
                        })
                    ],
                    idName: "tableContact",
                    filterValuesToVariable: (0, $519e426218154f6b$export$2e2bcd8739ae039),
                    filterContext: (0, $9a9eebc3462fba73$export$396ef541d9951d45)({})
                })
            ]
        })
    });
};
var $18ce4b63951cd018$export$2e2bcd8739ae039 = $18ce4b63951cd018$var$ListContact;












const $d5f5c102902e8354$var$UpdateContact = ()=>{
    const { appartenanceId: appartenanceId, contactId: contactId, appartenance: appartenance } = (0, $7a844823b04d4282$export$99eaa27ddbbb95ef)();
    const { data: data } = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/contact/` + appartenanceId + `/get/` + contactId);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$b51dd496211ae105), {}),
                title: "Mise \xe0 jour d'un contact"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                initialValues: (0, $9e8011277f42a0a2$export$a5cab80145b70e98)(data),
                validationSchema: (0, $9e8011277f42a0a2$export$c084437b5e3206cd),
                isPost: false,
                submitUrl: `/api/contact/` + appartenanceId + `/update/` + contactId,
                prepareVariables: (values)=>(0, $9e8011277f42a0a2$export$f97400759cfd946)(values),
                redirectUrl: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_CONTACT(appartenanceId, appartenance),
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $9e8011277f42a0a2$export$2e2bcd8739ae039), {})
            })
        ]
    });
};
var $d5f5c102902e8354$export$2e2bcd8739ae039 = $d5f5c102902e8354$var$UpdateContact;











var $bkJfK = parcelRequire("bkJfK");

var $kc00y = parcelRequire("kc00y");











const $d1c1159335329406$export$a5cab80145b70e98 = (groupeCoucheId, data)=>({
        coucheProtected: data?.coucheProtected ?? false,
        coucheId: data?.coucheId,
        coucheCode: data?.coucheCode,
        coucheLibelle: data?.coucheLibelle,
        coucheSource: data?.coucheSource,
        coucheProjection: data?.coucheProjection,
        coucheUrl: data?.coucheUrl,
        coucheNom: data?.coucheNom,
        coucheFormat: data?.coucheFormat,
        coucheCrossOrigin: data?.coucheCrossOrigin,
        couchePublic: data?.couchePublic ?? false,
        coucheActive: data?.coucheActive ?? true,
        coucheProxy: data?.coucheProxy ?? false,
        coucheTuilage: data?.coucheTuilage ?? false,
        coucheFromGeoserver: data?.coucheFromGeoserver ?? true,
        groupeFonctionnalitesZcList: data?.groupeFonctionnalitesZcList || [],
        groupeFonctionnalitesHorsZcList: data?.groupeFonctionnalitesHorsZcList || [],
        moduleList: data?.moduleList || [],
        groupeCoucheId: groupeCoucheId,
        coucheIconeUrl: data?.coucheIconeUrl,
        coucheLegendeUrl: data?.coucheLegendeUrl,
        coucheOpacite: data?.coucheOpacite ?? 1
    });
const $d1c1159335329406$export$8470ef9d0802da38 = (couche)=>{
    const formData = new FormData();
    formData.append("couche", JSON.stringify({
        coucheId: couche.coucheId,
        coucheCode: couche.coucheCode,
        coucheLibelle: couche.coucheLibelle,
        coucheSource: couche.coucheSource,
        coucheProjection: couche.coucheProjection,
        coucheUrl: couche.coucheUrl,
        coucheNom: couche.coucheNom,
        coucheFormat: couche.coucheFormat,
        coucheCrossOrigin: couche.coucheCrossOrigin,
        couchePublic: couche.couchePublic,
        coucheActive: couche.coucheActive,
        coucheProxy: couche.coucheProxy,
        coucheFromGeoserver: couche.coucheFromGeoserver,
        coucheTuilage: couche.coucheTuilage,
        coucheIconeUrl: couche.coucheIconeUrl,
        coucheLegendeUrl: couche.coucheLegendeUrl,
        groupeFonctionnalitesHorsZcList: couche.couchePublic === false ? couche.groupeFonctionnalitesHorsZcList : [],
        groupeFonctionnalitesZcList: couche.couchePublic === false ? couche.groupeFonctionnalitesZcList : [],
        moduleList: couche.moduleList,
        groupeCoucheId: couche.groupeCoucheId,
        coucheOpacite: couche.coucheOpacite
    }));
    if (couche.icone) formData.append("icone", couche.icone);
    if (couche.legende) formData.append("legende", couche.legende);
    return formData;
};
const $d1c1159335329406$export$c084437b5e3206cd = (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({
    coucheCode: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
    coucheLibelle: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
    groupeCoucheId: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba)
});
const $d1c1159335329406$var$Couche = ()=>{
    const { values: values, setFieldValue: setFieldValue } = (0, $bkJfK.useFormikContext)();
    const [estInitialise, setEstInitialisee] = (0, $kc00y.useState)(false);
    const legendeUrl = (0, $kc00y.useMemo)(()=>{
        if (!values.coucheLegendeUrl) return undefined;
        return `${values.coucheLegendeUrl}?v=${Date.now()}`;
    }, [
        values.coucheLegendeUrl
    ]);
    const iconeUrl = (0, $kc00y.useMemo)(()=>{
        if (!values.coucheIconeUrl) return undefined;
        return `${values.coucheIconeUrl}?v=${Date.now()}`;
    }, [
        values.coucheIconeUrl
    ]);
    const { run: run, data: coucheDisponibleDansGeoserver } = (0, $8d9ebd8892d8a5f5$export$6326fb4463ae1be4)(`/api/geoserver/check-couche-dispo/${values.coucheNom}`);
    (0, $kc00y.useEffect)(()=>{
        if (estInitialise === false && values.coucheNom) {
            setEstInitialisee(true);
            run();
        }
    }, [
        estInitialise,
        values.coucheNom,
        run
    ]);
    const moduleList = Object.entries((0, $a9754922f4c67d47$export$ef88b514e4bfff34)).map(([key, value])=>{
        return {
            id: key,
            libelle: value
        };
    });
    const typeSourceCarto = Object.values((0, $b38d314a5a0d0e6b$export$2e2bcd8739ae039)).map((key)=>{
        return {
            id: key,
            code: key,
            libelle: key
        };
    });
    const groupeFonctionnalitesState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/groupe-fonctionnalites`);
    if (!groupeFonctionnalitesState.isResolved) return null;
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                className: "align-items-end",
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        xs: 12,
                        className: "p-2 bg-secondary mb-3",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("h4", {
                            className: "m-0 p-0 text-center h6",
                            children: "G\xe9n\xe9ral"
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        xs: 12,
                        lg: 6,
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                            name: `coucheCode`,
                            disabled: values.coucheProtected,
                            value: values.coucheCode,
                            label: "Code",
                            placeholder: "Code",
                            required: true
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        xs: 12,
                        lg: 6,
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                            name: `coucheLibelle`,
                            value: values.coucheLibelle,
                            label: "Libell\xe9",
                            placeholder: "Libell\xe9",
                            required: true
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        xs: 12,
                        className: "p-2 bg-secondary mb-3 mt-3",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("h4", {
                            className: "m-0 p-0 text-center h6",
                            children: "Flux"
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        xs: 12,
                        lg: 6,
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$d6701e98ab1a6725), {
                            name: `coucheSource`,
                            disabled: values.coucheProtected,
                            label: "Source",
                            options: typeSourceCarto,
                            getOptionValue: (t)=>t.id,
                            getOptionLabel: (t)=>t.libelle,
                            onChange: (e)=>{
                                setFieldValue(`coucheSource`, typeSourceCarto.find((type)=>type.id === e.id)?.id);
                            },
                            defaultValue: typeSourceCarto.find((type)=>type.id === values.coucheSource),
                            required: true
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        xs: 12,
                        lg: 6,
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                            name: `coucheUrl`,
                            disabled: values.coucheProtected,
                            value: values.coucheUrl,
                            label: "URL",
                            placeholder: "URL",
                            required: true
                        })
                    }),
                    values.coucheSource !== (0, $b38d314a5a0d0e6b$export$2e2bcd8739ae039).OSM && !values.coucheProtected && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                xs: 12,
                                lg: 6,
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                    className: "align-items-end",
                                    children: [
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                                                name: `coucheNom`,
                                                value: values.coucheNom,
                                                label: "Nom",
                                                placeholder: "Nom",
                                                required: true,
                                                onBlur: ()=>{
                                                    run();
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                            xs: "auto",
                                            children: values.coucheSource === (0, $b38d314a5a0d0e6b$export$2e2bcd8739ae039).WMS && (coucheDisponibleDansGeoserver ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                                                tooltipId: "trouvee",
                                                tooltipText: "Couche trouv\xe9e dans Geoserver",
                                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("span", {
                                                    className: "text-success",
                                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$196109e945d3b66f), {})
                                                })
                                            }) : /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                                                tooltipId: "non-trouvee",
                                                tooltipText: "Couche non trouv\xe9e dans Geoserver",
                                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("span", {
                                                    className: "text-danger",
                                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$5be70e40251e6f9b), {})
                                                })
                                            }))
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                xs: 12,
                                lg: 6,
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                                    name: `coucheProjection`,
                                    value: values.coucheProjection,
                                    label: "Projection",
                                    placeholder: "Projection",
                                    required: true
                                })
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                xs: 12,
                                lg: 6,
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                                    name: `coucheFormat`,
                                    value: values.coucheFormat,
                                    label: "Format",
                                    placeholder: "Format",
                                    required: true
                                })
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                xs: 12,
                                lg: 6,
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                                    name: `coucheFromGeoserver`,
                                    label: "Vient de Geoserver"
                                })
                            })
                        ]
                    }),
                    (values.coucheSource === (0, $b38d314a5a0d0e6b$export$2e2bcd8739ae039).WMTS || values.coucheSource === (0, $b38d314a5a0d0e6b$export$2e2bcd8739ae039).OSM) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        xs: 12,
                        lg: 6,
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                            name: `coucheCrossOrigin`,
                            value: values.coucheCrossOrigin,
                            label: "CrossOrigin",
                            placeholder: "CrossOrigin",
                            required: false
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        xs: 12,
                        className: "p-2 bg-secondary mb-3 mt-3",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("h4", {
                            className: "m-0 p-0 text-center h6",
                            children: "Param\xe8tres"
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        xs: 12,
                        lg: 6,
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                            name: `coucheActive`,
                            label: "Active par d\xe9faut"
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        xs: 12,
                        lg: 6,
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                            name: `coucheProxy`,
                            label: "Utiliser le proxy pour charger la couche",
                            tooltipText: "Si la case est d\xe9coch\xe9e, la ressource sera charg\xe9e directement sans passer par le proxy de l'application. Utile pour l'affichage des fonds de plan."
                        })
                    }),
                    values.coucheSource === (0, $b38d314a5a0d0e6b$export$2e2bcd8739ae039).WMS && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        xs: 12,
                        lg: 6,
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                            name: `coucheTuilage`,
                            label: "Utiliser le tuilage WMS",
                            tooltipText: "Si la case est coch\xe9e, la couche sera charg\xe9e sous forme de tuiles. Attention, Geoserver ne peut pas g\xe9rer convenablement l'affichage des attributs calcul\xe9s dans une couche tuil\xe9e (un libell\xe9 affich\xe9 au centro\xefde, une couleur de remplissage al\xe9atoire, ...), donc pour toute couche tuil\xe9e il conviendra de v\xe9rifier son style associ\xe9."
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        xs: 12,
                        className: "p-2 bg-secondary mb-3 mt-3",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("h4", {
                            className: "m-0 p-0 text-center h6",
                            children: "Autorisations"
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        xs: 12,
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$eae70af4b4e3f197), {
                            name: "moduleList",
                            label: "Modules",
                            options: moduleList,
                            getOptionValue: (t)=>t.id,
                            getOptionLabel: (t)=>t.libelle,
                            value: moduleList.filter((el)=>values.moduleList?.some((value)=>value === el.id)),
                            onChange: (value)=>{
                                setFieldValue(`moduleList`, value.map((el)=>el.id));
                            },
                            isClearable: true,
                            required: false
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        xs: 12,
                        lg: 12,
                        className: "mt-1",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                            name: `couchePublic`,
                            label: "Publique"
                        })
                    }),
                    values.couchePublic === false && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                xs: 12,
                                lg: 6,
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$eae70af4b4e3f197), {
                                    name: "groupeFonctionnalitesZcList",
                                    label: "Profils autoris\xe9s sur zone de comp\xe9tence",
                                    tooltipText: "Profils pour lesquels la couche est visible uniquement sur la zone de comp\xe9tence de l'utilisateur connect\xe9",
                                    options: groupeFonctionnalitesState.data.filter((el)=>!values.groupeFonctionnalitesHorsZcList?.some((value)=>value === el.id)),
                                    getOptionValue: (t)=>t.id,
                                    getOptionLabel: (t)=>t.libelle,
                                    value: groupeFonctionnalitesState.data.filter((el)=>values.groupeFonctionnalitesZcList?.some((value)=>value === el.id)),
                                    onChange: (value)=>{
                                        setFieldValue(`groupeFonctionnalitesZcList`, value.map((el)=>el.id));
                                    },
                                    isClearable: true,
                                    required: false
                                })
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                xs: 12,
                                lg: 6,
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$eae70af4b4e3f197), {
                                    name: "groupeFonctionnalitesHorsZcList",
                                    label: "Profils autoris\xe9s hors zone de comp\xe9tence",
                                    tooltipText: "Profils pour lesquels la couche est compl\xe8tement visible, sans prendre en compte la zone de comp\xe9tence de l'utilisateur connect\xe9",
                                    options: groupeFonctionnalitesState.data.filter((el)=>!values.groupeFonctionnalitesZcList?.some((value)=>value === el.id)),
                                    getOptionValue: (t)=>t.id,
                                    getOptionLabel: (t)=>t.libelle,
                                    value: groupeFonctionnalitesState.data.filter((el)=>values.groupeFonctionnalitesHorsZcList?.some((value)=>value === el.id)),
                                    onChange: (value)=>{
                                        setFieldValue(`groupeFonctionnalitesHorsZcList`, value.map((el)=>el.id));
                                    },
                                    isClearable: true,
                                    required: false
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        xs: 12,
                        className: "p-2 bg-secondary mb-3 mt-3",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("h4", {
                            className: "m-0 p-0 text-center h6",
                            children: "Style"
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                            xs: 12,
                            lg: 3,
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$f5603a09670563b9), {
                                name: "coucheOpacite",
                                label: "Opacit\xe9",
                                min: 0,
                                max: 1,
                                step: 0.01,
                                tooltipText: "Opacit\xe9 de la couche (0 = transparent, 1 = opaque)",
                                required: true
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        xs: 12,
                        className: "p-2 bg-secondary mb-3 mt-3",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("h4", {
                            className: "m-0 p-0 text-center h6",
                            children: "Images"
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        xs: 12,
                        lg: 6,
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b57af79a4ab2a1c6), {
                                name: `icone`,
                                accept: "image/*",
                                label: "Ic\xf4ne",
                                required: false,
                                onChange: (e)=>{
                                    setFieldValue(`icone`, e.target.files[0]);
                                    setFieldValue(`coucheIconeUrl`, null);
                                }
                            }),
                            values.coucheIconeUrl && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                                className: "mt-3 d-flex align-items-center gap-3",
                                children: [
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ad18c81fdcf37de8$export$2e2bcd8739ae039), {
                                        thumbnail: true,
                                        src: iconeUrl,
                                        style: {
                                            maxWidth: "100px"
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                                        variant: "link",
                                        className: "text-danger text-decoration-none p-0",
                                        onClick: ()=>{
                                            setFieldValue(`icone`, null);
                                            setFieldValue(`coucheIconeUrl`, null);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$4d4e10ce882b8153), {}),
                                            " Supprimer l'ic\xf4ne"
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        xs: 12,
                        lg: 6,
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b57af79a4ab2a1c6), {
                                name: `legende`,
                                accept: "image/*",
                                label: "L\xe9gende",
                                required: false,
                                onChange: (e)=>{
                                    setFieldValue(`legende`, e.target.files[0]);
                                    setFieldValue(`coucheLegendeUrl`, null);
                                }
                            }),
                            values.coucheLegendeUrl && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                                className: "mt-3",
                                children: [
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ad18c81fdcf37de8$export$2e2bcd8739ae039), {
                                        thumbnail: true,
                                        src: legendeUrl,
                                        style: {
                                            maxWidth: "300px"
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                                        variant: "link",
                                        className: "text-danger text-decoration-none d-block mt-2 p-0",
                                        onClick: ()=>{
                                            setFieldValue(`legende`, null);
                                            setFieldValue(`coucheLegendeUrl`, null);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$4d4e10ce882b8153), {}),
                                            " Supprimer la l\xe9gende"
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db9b0e6fdb142a4c$export$2e2bcd8739ae039), {
                returnLink: true
            })
        ]
    });
};
var $d1c1159335329406$export$2e2bcd8739ae039 = $d1c1159335329406$var$Couche;


const $fa8a60d7d4bd6754$var$CreateCouche = ()=>{
    const navigate = (0, $7a844823b04d4282$export$9770f232ac06a008)();
    const location = (0, $7a844823b04d4282$export$45d76561a5302f2b)();
    const { groupeCoucheId: groupeCoucheId } = (0, $7a844823b04d4282$export$99eaa27ddbbb95ef)();
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                title: "Cr\xe9ation d'une couche",
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$779959098413998d), {})
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                initialValues: (0, $d1c1159335329406$export$a5cab80145b70e98)(groupeCoucheId),
                prepareVariables: (values)=>(0, $d1c1159335329406$export$8470ef9d0802da38)(values),
                validationSchema: (0, $d1c1159335329406$export$c084437b5e3206cd),
                submitUrl: `/api/admin/couche/groupe-couche/${groupeCoucheId}/create`,
                isPost: true,
                onSubmit: ()=>(0, $c066b242635c27a6$export$e37953fa8ba80500)(location, navigate),
                isMultipartFormData: true,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $d1c1159335329406$export$2e2bcd8739ae039), {})
            })
        ]
    });
};
var $fa8a60d7d4bd6754$export$2e2bcd8739ae039 = $fa8a60d7d4bd6754$var$CreateCouche;










var $bkJfK = parcelRequire("bkJfK");




const $dd64fe0cc3f46b7a$export$8470ef9d0802da38 = (values)=>({
        groupeCoucheId: values.groupeCoucheId,
        groupeCoucheCode: values.groupeCoucheCode,
        groupeCoucheLibelle: values.groupeCoucheLibelle,
        groupeCoucheProtected: values.groupeCoucheProtected ?? false
    });
const $dd64fe0cc3f46b7a$export$66362c95221cdbe4 = (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({
    groupeCoucheCode: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
    groupeCoucheLibelle: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba)
});
const $dd64fe0cc3f46b7a$export$a04a503d8277ee43 = (data)=>({
        groupeCoucheId: data?.groupeCoucheId,
        groupeCoucheCode: data?.groupeCoucheCode,
        groupeCoucheLibelle: data?.groupeCoucheLibelle,
        groupeCoucheProtected: data?.groupeCoucheProtected ?? false
    });
const $dd64fe0cc3f46b7a$export$c02a6edc04becf87 = ()=>{
    const { values: values } = (0, $bkJfK.useFormikContext)();
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                name: "groupeCoucheCode",
                label: "Code",
                required: true,
                disabled: values.groupeCoucheProtected
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                name: "groupeCoucheLibelle",
                label: "Libell\xe9",
                required: true
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                name: "groupeCoucheProtected",
                label: "Prot\xe9g\xe9",
                disabled: true
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db9b0e6fdb142a4c$export$2e2bcd8739ae039), {
                returnLink: true
            })
        ]
    });
};


const $f0109cb1d092a909$var$CreateGroupeCouche = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                title: "Cr\xe9ation d'un groupe de couche",
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$779959098413998d), {})
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                initialValues: (0, $dd64fe0cc3f46b7a$export$a04a503d8277ee43)(),
                prepareVariables: (values)=>(0, $dd64fe0cc3f46b7a$export$8470ef9d0802da38)(values),
                validationSchema: (0, $dd64fe0cc3f46b7a$export$66362c95221cdbe4),
                submitUrl: `/api/admin/groupe-couche/create`,
                isPost: true,
                redirectUrl: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_GROUPE_COUCHE,
                onSubmit: ()=>true,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $dd64fe0cc3f46b7a$export$c02a6edc04becf87), {})
            })
        ]
    });
};
var $f0109cb1d092a909$export$2e2bcd8739ae039 = $f0109cb1d092a909$var$CreateGroupeCouche;





















const $7d990e0b4337c262$var$filterValuesToVariable = ({ coucheCode: coucheCode, coucheLibelle: coucheLibelle, coucheSource: coucheSource, coucheNom: coucheNom, coucheProjection: coucheProjection, coucheFormat: coucheFormat, couchePublic: couchePublic, coucheProxy: coucheProxy, coucheActive: coucheActive, coucheFromGeoserver: coucheFromGeoserver, coucheProtected: coucheProtected, groupeFonctionnalitesZc: groupeFonctionnalitesZc, groupeFonctionnalitesHorsZc: groupeFonctionnalitesHorsZc, moduleList: moduleList })=>{
    const filter = {};
    $7d990e0b4337c262$var$filterPropertyStyle(filter, coucheCode, "coucheCode");
    $7d990e0b4337c262$var$filterPropertyStyle(filter, coucheLibelle, "coucheLibelle");
    $7d990e0b4337c262$var$filterPropertyStyle(filter, coucheSource, "coucheSource");
    $7d990e0b4337c262$var$filterPropertyStyle(filter, coucheNom, "coucheNom");
    $7d990e0b4337c262$var$filterPropertyStyle(filter, coucheProjection, "coucheProjection");
    $7d990e0b4337c262$var$filterPropertyStyle(filter, coucheFormat, "coucheFormat");
    $7d990e0b4337c262$var$filterPropertyStyle(filter, couchePublic, "couchePublic");
    $7d990e0b4337c262$var$filterPropertyStyle(filter, coucheProxy, "coucheProxy");
    $7d990e0b4337c262$var$filterPropertyStyle(filter, coucheActive, "coucheActive");
    $7d990e0b4337c262$var$filterPropertyStyle(filter, coucheProtected, "coucheProtected");
    $7d990e0b4337c262$var$filterPropertyStyle(filter, coucheFromGeoserver, "coucheFromGeoserver");
    if (groupeFonctionnalitesZc?.length > 0) filter.groupeFonctionnalitesZc = groupeFonctionnalitesZc;
    if (groupeFonctionnalitesHorsZc?.length > 0) filter.groupeFonctionnalitesHorsZc = groupeFonctionnalitesHorsZc;
    if (moduleList?.length > 0) filter.moduleList = moduleList;
    return filter;
};
var $7d990e0b4337c262$export$2e2bcd8739ae039 = $7d990e0b4337c262$var$filterValuesToVariable;
function $7d990e0b4337c262$var$filterPropertyStyle(filter, value, name) {
    if (value != null && value?.trim().length > 0) filter[name] = value;
}


const $42347a5cb9db41d8$var$ListCouche = ()=>{
    const { groupeCoucheId: groupeCoucheId } = (0, $7a844823b04d4282$export$99eaa27ddbbb95ef)();
    const { data: data } = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)(`/api/admin/groupe-couche/${groupeCoucheId}`);
    const groupeFonctionnalitesState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/groupe-fonctionnalites`);
    const typeModuleState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/modules/get-all-type-module`);
    const listeButton = [];
    listeButton.push({
        row: (row)=>{
            return row;
        },
        type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).UPDATE,
        route: (data)=>(0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).UPDATE_COUCHE(groupeCoucheId, data)
    });
    listeButton.push({
        row: (row)=>{
            return row;
        },
        textDisable: "Cette couche est prot\xe9g\xe9e et ne peut pas \xeatre supprim\xe9e",
        disable: (row)=>row.original.coucheProtected,
        textEnable: "Supprimer la couche",
        type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).DELETE,
        pathname: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/admin/couche/groupe-couche/${groupeCoucheId}/delete/`
    });
    listeButton.push({
        row: (row)=>{
            return row;
        },
        textEnable: "Modifier les m\xe9tadonn\xe9es",
        route: ()=>(0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_COUCHE_METADATA,
        type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).LINK,
        icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$b0c934bdae14c9ef), {}),
        search: (couche)=>{
            return new URLSearchParams({
                filterBy: JSON.stringify({
                    coucheLibelle: couche.original.coucheLibelle
                })
            }).toString();
        }
    });
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        fluid: true,
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                title: `Couches du groupe ${data?.groupeCoucheCode} - ${data?.groupeCoucheLibelle}`,
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$779959098413998d), {}),
                right: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $43f579690a1c166d$export$2e2bcd8739ae039), {
                            pathname: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).SORT_COUCHE(groupeCoucheId),
                            variant: "primary",
                            className: "me-2",
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$94727896c77b7d99), {}),
                                " R\xe9ordonner les couches du groupe"
                            ]
                        }),
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8ad69b89456b65bc$export$2e2bcd8739ae039), {
                            href: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).CREATE_COUCHE(groupeCoucheId),
                            title: "Ajouter une couche au groupe"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $9a9eebc3462fba73$export$2e2bcd8739ae039), {
                query: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/admin/couche/groupe-couche/${groupeCoucheId}`,
                columns: [
                    {
                        Header: "Code",
                        accessor: "coucheCode",
                        sortField: "coucheCode",
                        Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                            type: "text",
                            name: "coucheCode"
                        }),
                        Cell: (cell)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($42347a5cb9db41d8$var$CellTooltip, {
                                maxWidth: 150,
                                value: cell.value
                            })
                    },
                    {
                        Header: "Libell\xe9",
                        accessor: "coucheLibelle",
                        sortField: "coucheLibelle",
                        Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                            type: "text",
                            name: "coucheLibelle"
                        })
                    },
                    {
                        Header: "Source",
                        accessor: ({ coucheSource: coucheSource, coucheTuilage: coucheTuilage, coucheId: coucheId })=>{
                            return {
                                coucheSource: coucheSource,
                                coucheTuilage: coucheTuilage,
                                coucheId: coucheId
                            };
                        },
                        sortField: "coucheSource",
                        Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                            type: "text",
                            name: "coucheSource"
                        }),
                        Cell: ({ value: value })=>value.coucheSource === (0, $b38d314a5a0d0e6b$export$2e2bcd8739ae039).WMS ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                                tooltipId: value.coucheId,
                                tooltipText: value.coucheTuilage ? "Avec tuilage" : "Sans tuilage",
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("span", {
                                    children: [
                                        value.coucheSource,
                                        " ",
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$340bfce9b4df026b), {})
                                    ]
                                })
                            }) : value.coucheSource
                    },
                    {
                        Header: "Nom",
                        accessor: "coucheNom",
                        sortField: "coucheNom",
                        Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                            type: "text",
                            name: "coucheNom"
                        }),
                        Cell: (cell)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($42347a5cb9db41d8$var$CellTooltip, {
                                maxWidth: 150,
                                value: cell.value
                            })
                    },
                    {
                        Header: "EPSG",
                        accessor: "coucheProjection",
                        sortField: "coucheProjection",
                        Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                            type: "text",
                            name: "coucheProjection"
                        })
                    },
                    {
                        Header: "Format",
                        accessor: "coucheFormat",
                        sortField: "coucheFormat",
                        Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                            type: "text",
                            name: "coucheFormat"
                        })
                    },
                    {
                        Header: "Modules",
                        accessor: "moduleList",
                        sortField: "moduleList",
                        Cell: $42347a5cb9db41d8$var$CellTooltip,
                        Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $cc7cbb0460865818$export$2e2bcd8739ae039), {
                            name: "moduleList",
                            listIdCodeLibelle: typeModuleState?.data?.map((typeModule)=>({
                                    id: typeModule,
                                    libelle: typeModule
                                }))
                        })
                    },
                    {
                        Header: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                            children: [
                                " ",
                                "Profils sur ZC",
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                                    tooltipId: "tooltip-profil-hors-zc",
                                    tooltipText: "Profils pour lesquels la couche est visible uniquement sur la zone de comp\xe9tence de l'utilisateur connect\xe9",
                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$340bfce9b4df026b), {})
                                })
                            ]
                        }),
                        accessor: "groupeFonctionnalitesZc",
                        sortField: "groupeFonctionnalitesZc",
                        Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $cc7cbb0460865818$export$2e2bcd8739ae039), {
                            name: "groupeFonctionnalitesZc",
                            listIdCodeLibelle: groupeFonctionnalitesState.data
                        }),
                        Cell: $42347a5cb9db41d8$var$CellTooltip
                    },
                    {
                        Header: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                            children: [
                                "Profils hors ZC",
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                                    tooltipId: "tooltip-profil-hors-zc",
                                    tooltipText: "Profils pour lesquels la couche est compl\xe8tement visible, sans prendre en compte la zone de comp\xe9tence de l'utilisateur connect\xe9",
                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$340bfce9b4df026b), {})
                                })
                            ]
                        }),
                        accessor: "groupeFonctionnalitesHorsZc",
                        sortField: "groupeFonctionnalitesHorsZc",
                        Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $cc7cbb0460865818$export$2e2bcd8739ae039), {
                            name: "groupeFonctionnalitesHorsZc",
                            listIdCodeLibelle: groupeFonctionnalitesState.data
                        }),
                        Cell: $42347a5cb9db41d8$var$CellTooltip
                    },
                    (0, $b82b937cc97f6f18$export$38dcf858d3ede0e9)({
                        Header: "Publique",
                        accessor: "couchePublic",
                        sortField: "couchePublic",
                        Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eed37ff3d3e1f28c$export$2e2bcd8739ae039), {
                            options: (0, $a4f278cac9030fb1$export$2e2bcd8739ae039),
                            name: "couchePublic"
                        })
                    }),
                    (0, $b82b937cc97f6f18$export$38dcf858d3ede0e9)({
                        Header: "Proxy",
                        accessor: "coucheProxy",
                        sortField: "coucheProxy",
                        Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eed37ff3d3e1f28c$export$2e2bcd8739ae039), {
                            options: (0, $a4f278cac9030fb1$export$2e2bcd8739ae039),
                            name: "coucheProxy"
                        })
                    }),
                    (0, $b82b937cc97f6f18$export$38dcf858d3ede0e9)({
                        Header: "Active par d\xe9faut",
                        accessor: "coucheActive",
                        sortField: "coucheActive",
                        Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eed37ff3d3e1f28c$export$2e2bcd8739ae039), {
                            options: (0, $a4f278cac9030fb1$export$2e2bcd8739ae039),
                            name: "coucheActive"
                        })
                    }),
                    (0, $b82b937cc97f6f18$export$38dcf858d3ede0e9)({
                        Header: "Vient de Geoserver",
                        accessor: "coucheFromGeoserver",
                        sortField: "coucheFromGeoserver",
                        Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eed37ff3d3e1f28c$export$2e2bcd8739ae039), {
                            options: (0, $a4f278cac9030fb1$export$2e2bcd8739ae039),
                            name: "coucheFromGeoserver"
                        })
                    }),
                    (0, $b82b937cc97f6f18$export$4f228b0e0fb17419)({
                        Header: "Prot\xe9g\xe9",
                        accessor: "coucheProtected",
                        sortField: "coucheProtected",
                        Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eed37ff3d3e1f28c$export$2e2bcd8739ae039), {
                            options: (0, $a4f278cac9030fb1$export$2e2bcd8739ae039),
                            name: "coucheProtected"
                        })
                    }),
                    (0, $b82b937cc97f6f18$export$36e9f5a475c9f6fc)({
                        Header: "Actions",
                        accessor: "coucheId",
                        buttons: listeButton
                    })
                ],
                idName: "tableCouche",
                filterValuesToVariable: (0, $7d990e0b4337c262$export$2e2bcd8739ae039),
                filterContext: (0, $9a9eebc3462fba73$export$396ef541d9951d45)({
                    coucheLibelle: undefined,
                    coucheCode: undefined
                })
            })
        ]
    });
};
var $42347a5cb9db41d8$export$2e2bcd8739ae039 = $42347a5cb9db41d8$var$ListCouche;
const $42347a5cb9db41d8$var$CellTooltip = ({ value: value, maxWidth: maxWidth = 100 })=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
        tooltipText: value,
        tooltipId: value,
        maxWidth: maxWidth,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
            children: value
        })
    });
















const $19c22418c2c83c5f$var$filterValuesToVariable = ({ groupeCoucheCode: groupeCoucheCode, groupeCoucheLibelle: groupeCoucheLibelle, groupeCoucheProtected: groupeCoucheProtected })=>{
    const filter = {};
    $19c22418c2c83c5f$var$filterPropertyStyle(filter, groupeCoucheCode, "groupeCoucheCode");
    $19c22418c2c83c5f$var$filterPropertyStyle(filter, groupeCoucheLibelle, "groupeCoucheLibelle");
    $19c22418c2c83c5f$var$filterPropertyStyle(filter, groupeCoucheProtected, "groupeCoucheProtected");
    return filter;
};
var $19c22418c2c83c5f$export$2e2bcd8739ae039 = $19c22418c2c83c5f$var$filterValuesToVariable;
function $19c22418c2c83c5f$var$filterPropertyStyle(filter, value, name) {
    if (value != null && value?.trim().length > 0) filter[name] = value;
}


const $c2b1d27dc8167fda$var$ListGroupeCouche = ()=>{
    const listeButton = [];
    listeButton.push({
        row: (row)=>{
            return row;
        },
        textEnable: "Voir les couches",
        route: (data)=>(0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_COUCHE(data),
        type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).LINK,
        icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$527d32aa1785fdd4), {})
    });
    listeButton.push({
        row: (row)=>{
            return row;
        },
        type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).UPDATE,
        route: (data)=>(0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).UPDATE_GROUPE_COUCHE(data)
    });
    listeButton.push({
        disable: (v)=>{
            return v.original.nombreCouche > 0 || v.original.groupeCoucheProtected;
        },
        textDisableFunction: (v)=>{
            if (v.original.groupeCoucheProtected) return "Impossible de supprimer un \xe9l\xe9ment prot\xe9g\xe9";
            else return "Impossible de supprimer le groupe de couche car des couches y sont associ\xe9es";
        },
        row: (row)=>{
            return row;
        },
        type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).DELETE,
        pathname: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/admin/groupe-couche/`
    });
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                title: "Groupes de couches",
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$779959098413998d), {}),
                right: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $43f579690a1c166d$export$2e2bcd8739ae039), {
                            pathname: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).SORT_GROUPE_COUCHE,
                            variant: "primary",
                            className: "me-2",
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$94727896c77b7d99), {}),
                                " R\xe9ordonner les groupes"
                            ]
                        }),
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8ad69b89456b65bc$export$2e2bcd8739ae039), {
                            title: "Ajouter un groupe de couche",
                            href: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).ADD_GROUPE_COUCHE
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8598ca69ed8b9dca$export$2e2bcd8739ae039), {
                variant: "info",
                className: "mt-2 mb-2 text-muted d-flex align-items-center",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("span", {
                    children: [
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$340bfce9b4df026b), {}),
                        " Les couches cartographiques sont accessibles et param\xe9trables au sein d'un groupe, leur gestion se fait donc au travers de leur groupe d'appartenance."
                    ]
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $9a9eebc3462fba73$export$2e2bcd8739ae039), {
                query: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/admin/groupe-couche`,
                columns: [
                    {
                        Header: "Code",
                        accessor: "groupeCoucheCode",
                        sortField: "groupeCoucheCode",
                        Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                            type: "text",
                            name: "groupeCoucheCode"
                        })
                    },
                    {
                        Header: "Libell\xe9",
                        accessor: "groupeCoucheLibelle",
                        sortField: "groupeCoucheLibelle",
                        Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                            type: "text",
                            name: "groupeCoucheLibelle"
                        })
                    },
                    {
                        Header: "Nombre de couches associ\xe9es",
                        accessor: "nombreCouche",
                        sortField: "nombreCouche"
                    },
                    (0, $b82b937cc97f6f18$export$38dcf858d3ede0e9)({
                        Header: "Prot\xe9g\xe9",
                        accessor: "groupeCoucheProtected",
                        sortField: "groupeCoucheProtected",
                        Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eed37ff3d3e1f28c$export$2e2bcd8739ae039), {
                            options: (0, $a4f278cac9030fb1$export$2e2bcd8739ae039),
                            name: "groupeCoucheProtected"
                        })
                    }),
                    (0, $b82b937cc97f6f18$export$36e9f5a475c9f6fc)({
                        Header: "Actions",
                        accessor: "groupeCoucheId",
                        buttons: listeButton
                    })
                ],
                idName: "tableGroupeCouche",
                filterValuesToVariable: (0, $19c22418c2c83c5f$export$2e2bcd8739ae039),
                filterContext: (0, $9a9eebc3462fba73$export$396ef541d9951d45)({
                    groupeCoucheLibelle: undefined,
                    groupeCoucheProtected: undefined
                })
            })
        ]
    });
};
var $c2b1d27dc8167fda$export$2e2bcd8739ae039 = $c2b1d27dc8167fda$var$ListGroupeCouche;







const $417aed7facf81410$var$SortCouche = ()=>{
    const { groupeCoucheId: groupeCoucheId } = (0, $7a844823b04d4282$export$99eaa27ddbbb95ef)();
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $079903718aba65cb$export$2e2bcd8739ae039), {
        beforeTri: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8598ca69ed8b9dca$export$2e2bcd8739ae039), {
            variant: "info",
            className: "mt-2 mb-2 text-muted d-flex align-items-center",
            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("span", {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$340bfce9b4df026b), {}),
                    " Les couches appara\xeetront dans l'ordre que vous d\xe9finissez ici."
                ]
            })
        }),
        title: "R\xe9ordonner les couches",
        apiAdressForGetOrder: `/api/admin/couche/groupe-couche/${groupeCoucheId}/get-ordre`,
        apiAdressForPutUpdateOrder: `/api/admin/couche/update-ordre`
    });
};
var $417aed7facf81410$export$2e2bcd8739ae039 = $417aed7facf81410$var$SortCouche;






const $c3135075c0a34b44$var$SortGroupeCouche = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $079903718aba65cb$export$2e2bcd8739ae039), {
        beforeTri: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8598ca69ed8b9dca$export$2e2bcd8739ae039), {
            variant: "info",
            className: "mt-2 mb-2 text-muted d-flex align-items-center",
            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("span", {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$340bfce9b4df026b), {}),
                    " Les groupes appara\xeetront dans l'ordre que vous d\xe9finissez ici."
                ]
            })
        }),
        title: "R\xe9ordonner les groupes",
        apiAdressForGetOrder: `/api/admin/groupe-couche/get-ordre`,
        apiAdressForPutUpdateOrder: `/api/admin/groupe-couche/update-ordre`
    });
};
var $c3135075c0a34b44$export$2e2bcd8739ae039 = $c3135075c0a34b44$var$SortGroupeCouche;












const $c0542f1caecdc33d$var$UpdateCouche = ()=>{
    const navigate = (0, $7a844823b04d4282$export$9770f232ac06a008)();
    const location = (0, $7a844823b04d4282$export$45d76561a5302f2b)();
    const { groupeCoucheId: groupeCoucheId, coucheId: coucheId } = (0, $7a844823b04d4282$export$99eaa27ddbbb95ef)();
    const { data: data } = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/admin/couche/${coucheId}`);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                title: "Modification d'une couche",
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$779959098413998d), {})
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                initialValues: (0, $d1c1159335329406$export$a5cab80145b70e98)(groupeCoucheId, data),
                prepareVariables: (values)=>(0, $d1c1159335329406$export$8470ef9d0802da38)(values),
                validationSchema: (0, $d1c1159335329406$export$c084437b5e3206cd),
                submitUrl: `/api/admin/couche/groupe-couche/${groupeCoucheId}/update/${coucheId}`,
                isPost: false,
                onSubmit: ()=>(0, $c066b242635c27a6$export$e37953fa8ba80500)(location, navigate),
                isMultipartFormData: true,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $d1c1159335329406$export$2e2bcd8739ae039), {})
            })
        ]
    });
};
var $c0542f1caecdc33d$export$2e2bcd8739ae039 = $c0542f1caecdc33d$var$UpdateCouche;











const $dd4215794f25d066$var$UpdateGroupeCouche = ()=>{
    const { groupeCoucheId: groupeCoucheId } = (0, $7a844823b04d4282$export$99eaa27ddbbb95ef)();
    const { data: data } = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)(`/api/admin/groupe-couche/${groupeCoucheId}`);
    return data && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                title: "Mise \xe0 jour d'un groupe de couche",
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$779959098413998d), {})
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                initialValues: (0, $dd64fe0cc3f46b7a$export$a04a503d8277ee43)(data),
                prepareVariables: (values)=>(0, $dd64fe0cc3f46b7a$export$8470ef9d0802da38)(values),
                validationSchema: (0, $dd64fe0cc3f46b7a$export$66362c95221cdbe4),
                submitUrl: `/api/admin/groupe-couche/${groupeCoucheId}`,
                isPost: false,
                redirectUrl: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_GROUPE_COUCHE,
                onSubmit: ()=>true,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $dd64fe0cc3f46b7a$export$c02a6edc04becf87), {})
            })
        ]
    });
};
var $dd4215794f25d066$export$2e2bcd8739ae039 = $dd4215794f25d066$var$UpdateGroupeCouche;










var $bkJfK = parcelRequire("bkJfK");






const $a06ab28418521777$export$8470ef9d0802da38 = (values)=>({
        evenementCategorieId: values.evenementCategorieId,
        evenementCategorieCode: values.evenementCategorieCode,
        evenementCategorieLibelle: values.evenementCategorieLibelle,
        evenementCategorieActif: values.evenementCategorieActif,
        evenementCategorieTypeCrise: values.evenementCategorieTypeCrise
    });
const $a06ab28418521777$export$612f035c848d1ea9 = (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({
    evenementCategorieCode: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
    evenementCategorieLibelle: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba)
});
const $a06ab28418521777$export$c443b00ed31da642 = (data)=>{
    return {
        evenementCategorieId: data?.evenementCategorieId ?? null,
        evenementCategorieCode: data?.evenementCategorieCode ?? null,
        evenementCategorieLibelle: data?.evenementCategorieLibelle ?? null,
        evenementCategorieActif: data?.evenementCategorieActif ?? true,
        evenementCategorieTypeCrise: data?.evenementCategorieTypeCrise ?? []
    };
};
const $a06ab28418521777$export$4e63eea32234abf5 = ()=>{
    const { values: values, setFieldValue: setFieldValue } = (0, $bkJfK.useFormikContext)();
    const typeCriseState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/nomenclatures/type_crise`);
    const listeTypeCrise = typeCriseState?.data ? Object.values(typeCriseState.data) : [];
    return typeCriseState?.data && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                name: "evenementCategorieActif",
                label: "Actif"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                name: "evenementCategorieCode",
                label: "Code"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                name: "evenementCategorieLibelle",
                label: "Libell\xe9"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$eae70af4b4e3f197), {
                name: "evenementCategorieTypeCrise",
                label: "Types de crise associ\xe9s",
                required: false,
                options: listeTypeCrise,
                getOptionValue: (t)=>t.typeCriseId,
                getOptionLabel: (t)=>t.typeCriseLibelle,
                value: values.evenementCategorieTypeCrise?.map((e)=>listeTypeCrise.find((r)=>r.typeCriseId === e.typeCriseId)),
                onChange: (typeCrise)=>{
                    setFieldValue("evenementCategorieTypeCrise", typeCrise ?? []);
                }
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db9b0e6fdb142a4c$export$2e2bcd8739ae039), {
                returnLink: true
            })
        ]
    });
};


const $354b019645efe8b2$var$CreateEvenementCategorie = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                title: "Cr\xe9ation d'une cat\xe9gorie d'\xe9v\xe8nement",
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$d776d19dfae66ece), {})
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                onSubmit: ()=>true,
                initialValues: (0, $a06ab28418521777$export$c443b00ed31da642)(),
                prepareVariables: (values)=>(0, $a06ab28418521777$export$8470ef9d0802da38)(values),
                validationSchema: (0, $a06ab28418521777$export$612f035c848d1ea9),
                submitUrl: `/api/evenement-categorie/create/`,
                isPost: true,
                redirectUrl: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_EVENEMENT_CATEGORIE,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $a06ab28418521777$export$4e63eea32234abf5), {})
            })
        ]
    });
};
var $354b019645efe8b2$export$2e2bcd8739ae039 = $354b019645efe8b2$var$CreateEvenementCategorie;
















const $f6f68d487d2546d3$var$filterValuesToVariable = ({ evenementCategorieCode: evenementCategorieCode, evenementCategorieLibelle: evenementCategorieLibelle, evenementCategorieTypeCriseId: evenementCategorieTypeCriseId })=>{
    const filter = {};
    $f6f68d487d2546d3$var$filterProperty(filter, evenementCategorieCode, "evenementCategorieCode");
    $f6f68d487d2546d3$var$filterProperty(filter, evenementCategorieLibelle, "evenementCategorieLibelle");
    $f6f68d487d2546d3$var$filterProperty(filter, evenementCategorieTypeCriseId, "evenementCategorieTypeCriseId");
    return filter;
};
var $f6f68d487d2546d3$export$2e2bcd8739ae039 = $f6f68d487d2546d3$var$filterValuesToVariable;
function $f6f68d487d2546d3$var$filterProperty(filter, value, name) {
    if (value && value.trim().length > 0) filter[name] = value;
}


const $5146d2437f0587bf$var$ListEvenementCategorie = ()=>{
    const { user: user } = (0, $e787cde576104469$export$fdc397e486fa83e7)();
    const listeButton = [
        {
            row: (row)=>{
                return row;
            },
            textEnable: "Acc\xe9der aux sous cat\xe9gories d'\xe9v\xe8nement",
            route: ()=>(0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_EVENEMENT_SOUS_CATEGORIE,
            type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).LINK,
            icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$527d32aa1785fdd4), {}),
            search: (obj)=>{
                return new URLSearchParams({
                    filterBy: JSON.stringify({
                        evenementCategorieId: obj.value
                    })
                }).toString();
            }
        }
    ];
    if ((0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE)) listeButton.push({
        row: (row)=>{
            return row;
        },
        textEnable: "Modifier",
        route: (evenementCategorieId)=>(0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).UPDATE_EVENEMENT_CATEGORIE(evenementCategorieId),
        type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).UPDATE
    }, {
        disable: (v)=>{
            return v.original.evenementCategorieEstUtilisee;
        },
        textDisableFunction: ()=>"Impossible de supprimer l'\xe9l\xe9ment car il est utilis\xe9",
        row: (row)=>{
            return row;
        },
        type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).DELETE,
        pathname: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/evenement-categorie/delete/`
    });
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$73b2275057918051), {}),
                title: "Cat\xe9gorie d'\xe9v\xe8nement",
                right: (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8ad69b89456b65bc$export$2e2bcd8739ae039), {
                    href: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).ADD_EVENEMENT_CATEGORIE,
                    title: "Ajouter une cat\xe9gorie d'\xe9v\xe8nement"
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $9a9eebc3462fba73$export$2e2bcd8739ae039), {
                query: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/evenement-categorie/`,
                columns: [
                    {
                        Header: "Code",
                        accessor: "evenementCategorieCode",
                        sortField: "evenementCategorieCode",
                        Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                            type: "text",
                            name: "evenementCategorieCode"
                        })
                    },
                    {
                        Header: "Libell\xe9",
                        accessor: "evenementCategorieLibelle",
                        sortField: "evenementCategorieLibelle",
                        Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                            type: "text",
                            name: "evenementCategorieLibelle"
                        })
                    },
                    (0, $b82b937cc97f6f18$export$38dcf858d3ede0e9)({
                        Header: "Actif",
                        accessor: "evenementCategorieActif"
                    }),
                    (0, $b82b937cc97f6f18$export$36e9f5a475c9f6fc)({
                        Header: "Actions",
                        accessor: "evenementCategorieId",
                        buttons: listeButton
                    })
                ],
                idName: "evenementCategorieId",
                filterValuesToVariable: (0, $f6f68d487d2546d3$export$2e2bcd8739ae039),
                filterContext: (0, $9a9eebc3462fba73$export$396ef541d9951d45)({
                    evenementCategorieCode: undefined,
                    evenementCategorieLibelle: undefined
                })
            })
        ]
    });
};
var $5146d2437f0587bf$export$2e2bcd8739ae039 = $5146d2437f0587bf$var$ListEvenementCategorie;












const $5bafc85b7f697a6a$var$UpdateEvenementCategorie = ()=>{
    const { evenementCategorieId: evenementCategorieId } = (0, $7a844823b04d4282$export$99eaa27ddbbb95ef)();
    const evenementCategorie = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/evenement-categorie/get/` + evenementCategorieId)?.data;
    return evenementCategorie && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                title: "Mise \xe0 jour d'une cat\xe9gorie d'\xe9v\xe8nement",
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$b51dd496211ae105), {})
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                initialValues: (0, $a06ab28418521777$export$c443b00ed31da642)(evenementCategorie),
                prepareVariables: (values)=>(0, $a06ab28418521777$export$8470ef9d0802da38)(values),
                validationSchema: (0, $a06ab28418521777$export$612f035c848d1ea9),
                submitUrl: `/api/evenement-categorie/update/${evenementCategorieId}`,
                isPost: false,
                onSubmit: ()=>true,
                redirectUrl: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_EVENEMENT_CATEGORIE,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $a06ab28418521777$export$4e63eea32234abf5), {})
            })
        ]
    });
};
var $5bafc85b7f697a6a$export$2e2bcd8739ae039 = $5bafc85b7f697a6a$var$UpdateEvenementCategorie;










var $bkJfK = parcelRequire("bkJfK");





var $bkJfK = parcelRequire("bkJfK");

const $0d6bddc95452bd52$var$SortableAddRemoveComponent = ({ nomListe: nomListe, setData: setData, defaultElement: defaultElement, buttonLibelle: buttonLibelle, createComponentToRepeat: createComponentToRepeat, typeModule: typeModule })=>{
    const { values: values } = (0, $bkJfK.useFormikContext)();
    function dragEndEvent(e) {
        const { over: over, active: active } = e;
        setData((0, $6e75a0664b0e0f07$export$5d49d615ad5ea2b0)(values[nomListe], values[nomListe].findIndex((item)=>item.id === active.id), values[nomListe].findIndex((item)=>item.id === over?.id)));
    }
    return values[nomListe] && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $3b30af0a3bfceeb3$export$2d5c5ceac203fc1e), {
        onDragEnd: dragEndEvent,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $6e75a0664b0e0f07$export$86155fde54f06e6a), {
            items: values[nomListe],
            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $665753c43020c55f$export$2e2bcd8739ae039), {
                buttonLibelle: buttonLibelle,
                name: nomListe,
                typeModule: typeModule,
                createComponentToRepeat: createComponentToRepeat,
                listeElements: values[nomListe],
                defaultElement: {
                    id: Math.random(),
                    ...defaultElement
                }
            })
        })
    });
};
var $0d6bddc95452bd52$export$2e2bcd8739ae039 = $0d6bddc95452bd52$var$SortableAddRemoveComponent;






var $78cc0602ae2238c9$var$TYPE_GEOMETRIE = /*#__PURE__*/ function(TYPE_GEOMETRIE) {
    TYPE_GEOMETRIE["POINT"] = "POINT";
    TYPE_GEOMETRIE["POLYGON"] = "POLYGON";
    TYPE_GEOMETRIE["LINESTRING"] = "LINESTRING";
    return TYPE_GEOMETRIE;
}($78cc0602ae2238c9$var$TYPE_GEOMETRIE || {});
var $78cc0602ae2238c9$export$2e2bcd8739ae039 = $78cc0602ae2238c9$var$TYPE_GEOMETRIE;








var $bkJfK = parcelRequire("bkJfK");





var $6c60548ee6786975$export$8d16f5a86c9ce822 = /*#__PURE__*/ function(TYPE_PARAMETRE_COMPOSANT) {
    TYPE_PARAMETRE_COMPOSANT["DATE_INPUT"] = "Champ date";
    TYPE_PARAMETRE_COMPOSANT["NUMBER_INPUT"] = "Champ nombre";
    TYPE_PARAMETRE_COMPOSANT["SELECT_INPUT"] = "Liste d\xe9roulante";
    TYPE_PARAMETRE_COMPOSANT["TEXT_INPUT"] = "Champ texte";
    return TYPE_PARAMETRE_COMPOSANT;
}({});
const $6c60548ee6786975$export$fc37d2004288f088 = (geometry)=>{
    switch(geometry){
        case "POINT":
            return (0, $72e886a1223521a1$export$2e2bcd8739ae039).POINT;
        case "LINESTRING":
            return (0, $72e886a1223521a1$export$2e2bcd8739ae039).LINESTRING;
        default:
            return (0, $72e886a1223521a1$export$2e2bcd8739ae039).POLYGON;
    }
};


const $b925a1370ed4f42d$var$SortableParametreSousCategory = ({ id: id, listeElements: listeElements, index: index })=>{
    const { setNodeRef: setNodeRef, listeners: listeners, transform: transform, transition: transition } = (0, $6e75a0664b0e0f07$export$4ebcb6201122185a)({
        id: id
    });
    const listeTypeComplementetre = Object.entries((0, $6c60548ee6786975$export$8d16f5a86c9ce822)).map(([key, value])=>{
        return {
            id: key,
            code: value,
            libelle: value
        };
    });
    const { setValues: setValues, setFieldValue: setFieldValue } = (0, $bkJfK.useFormikContext)();
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
        ref: setNodeRef,
        style: {
            transform: (0, $f5d873c94758f78f$export$c4ffa16951855e28).Transform.toString(transform),
            transition: transition
        },
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                    ...listeners,
                    role: "button",
                    className: "pe-2",
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$72e0de8e793fca75), {})
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                className: "align-items-end",
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                                name: `evenementSousCategorieComplement[${index}].sousCategorieComplementEstRequis`,
                                label: "Requis"
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                                name: `evenementSousCategorieComplement[${index}].sousCategorieComplementLibelle`,
                                label: "Libelle du param\xe8tre",
                                required: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                            name: `evenementSousCategorieComplement[${index}].sousCategorieComplementType`,
                            listIdCodeLibelle: listeTypeComplementetre,
                            label: "Type du composant param\xe8tre",
                            required: true,
                            onChange: (e)=>{
                                setFieldValue(`evenementSousCategorieComplement[${index}].sousCategorieComplementType`, listeTypeComplementetre.find((type)=>type.id === e?.id)?.id);
                                setFieldValue(`evenementSousCategorieComplement[${index}].sousCategorieComplementValeurDefaut`, null);
                                setFieldValue(`evenementSousCategorieComplement[${index}].sousCategorieComplementSqlDebut`, "SELECT");
                                setFieldValue(`evenementSousCategorieComplement[${index}].sousCategorieComplementSqlFin`, "FROM");
                            },
                            defaultValue: listeTypeComplementetre?.find((e)=>e.id === listeElements[index].sousCategorieComplementType),
                            setValues: setValues
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: $b925a1370ed4f42d$export$808fe5927a892cc6(listeElements, index)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: (0, $6c60548ee6786975$export$8d16f5a86c9ce822)[listeElements[index].sousCategorieComplementType] === (0, $6c60548ee6786975$export$8d16f5a86c9ce822).SELECT_INPUT && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$ce9b1cc0c34506d0), {
                                name: `evenementSousCategorieComplement[${index}].sousCategorieComplementSqlDebut`,
                                label: "Requ\xeate SQL pour alimenter le param\xe8tre"
                            })
                        }),
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                            className: "m-2",
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                                        name: `evenementSousCategorieComplement[${index}].sousCategorieComplementSqlId`
                                    })
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                    children: "as id"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                            className: "m-2",
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                                        name: `evenementSousCategorieComplement[${index}].sousCategorieComplementSqlLibelle`
                                    })
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                    children: "as libelle"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$ce9b1cc0c34506d0), {
                                name: `evenementSousCategorieComplement[${index}].sousCategorieComplementSqlFin`
                            })
                        })
                    ]
                })
            })
        ]
    });
};
function $b925a1370ed4f42d$export$e3b1104a5f84440a(index, listeElements) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($b925a1370ed4f42d$var$SortableParametreSousCategory, {
        index: index,
        listeElements: listeElements,
        id: listeElements[index].id
    });
}
function $b925a1370ed4f42d$export$808fe5927a892cc6(listeElements, index) {
    switch((0, $6c60548ee6786975$export$8d16f5a86c9ce822)[listeElements[index].sousCategorieComplementType]){
        case (0, $6c60548ee6786975$export$8d16f5a86c9ce822).DATE_INPUT:
            return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$183478aa40b5df1), {
                name: `evenementSousCategorieComplement[${index}].sousCategorieComplementValeurDefaut`,
                label: "Valeur par d\xe9faut",
                defaultValue: listeElements[index].sousCategorieComplementValeurDefaut,
                required: false
            });
        case (0, $6c60548ee6786975$export$8d16f5a86c9ce822).NUMBER_INPUT:
            return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$6bf0cd3a219bbade), {
                name: `evenementSousCategorieComplement[${index}].sousCategorieComplementValeurDefaut`,
                label: "Valeur par d\xe9faut",
                required: false
            });
        case (0, $6c60548ee6786975$export$8d16f5a86c9ce822).TEXT_INPUT:
            return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                name: `evenementSousCategorieComplement[${index}].sousCategorieComplementValeurDefaut`,
                label: "Valeur par d\xe9faut",
                required: false
            });
        case (0, $6c60548ee6786975$export$8d16f5a86c9ce822).SELECT_INPUT:
            return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                name: `evenementSousCategorieComplement[${index}].sousCategorieComplementValeurDefaut`,
                label: "Valeur par d\xe9faut (doit correspondre \xe0 l'identifiant technique d'un r\xe9sultat renvoy\xe9 par la requ\xeate SQL)",
                required: false
            });
    }
}


const $43004532355527cd$export$8470ef9d0802da38 = (values)=>({
        evenementSousCategorieId: values.evenementSousCategorieId,
        evenementSousCategorieCode: values.evenementSousCategorieCode,
        evenementSousCategorieLibelle: values.evenementSousCategorieLibelle,
        evenementSousCategorieActif: values.evenementSousCategorieActif,
        evenementSousCategorieTypeGeometrie: values.evenementSousCategorieTypeGeometrie,
        evenementSousCategorieEvenementCategorieId: values.evenementSousCategorieEvenementCategorieId,
        evenementSousCategorieComplement: values.evenementSousCategorieComplement.map((e, index)=>{
            return {
                ...e,
                evenementSousCategorieComplementOrdre: index,
                sousCategorieComplementSql: e.sousCategorieComplementSqlDebut + " " + e.sousCategorieComplementSqlId + " as id, " + e.sousCategorieComplementSqlLibelle + " as libelle " + e.sousCategorieComplementSqlFin
            };
        })
    });
const $43004532355527cd$export$4cf4cf356f3a178b = (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({
    evenementSousCategorieCode: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
    evenementSousCategorieLibelle: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
    evenementSousCategorieTypeGeometrie: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
    evenementSousCategorieEvenementCategorieId: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba)
});
const $43004532355527cd$export$762d1b6daf009358 = (data)=>{
    return {
        evenementSousCategorieId: data?.evenementSousCategorieId ?? null,
        evenementSousCategorieCode: data?.evenementSousCategorieCode ?? null,
        evenementSousCategorieActif: data?.evenementSousCategorieActif ?? true,
        evenementSousCategorieLibelle: data?.evenementSousCategorieLibelle ?? null,
        evenementSousCategorieTypeGeometrie: data?.evenementSousCategorieTypeGeometrie ?? null,
        evenementSousCategorieEvenementCategorieId: data?.evenementSousCategorieEvenementCategorieId ?? null,
        evenementSousCategorieComplement: data?.evenementSousCategorieComplement.map((e)=>({
                ...e,
                sousCategorieComplementSqlDebut: e.sousCategorieComplementSql && e.sousCategorieComplementSqlId ? e.sousCategorieComplementSql.split(e.sousCategorieComplementSqlId)[0] : null,
                sousCategorieComplementSqlFin: e.sousCategorieComplementSql && e.sousCategorieComplementSqlLibelle ? e.sousCategorieComplementSql.split(e.sousCategorieComplementSqlLibelle + " as libelle").slice(-1)[0] : null,
                id: Math.random()
            })) ?? []
    };
};
const $43004532355527cd$export$e5a199e82c32301d = ()=>{
    const listTypeGeometrie = Object.values((0, $78cc0602ae2238c9$export$2e2bcd8739ae039)).map((e)=>{
        return {
            id: e.toString(),
            code: e.toString(),
            libelle: e.toString()
        };
    });
    const { values: values, setValues: setValues, setFieldValue: setFieldValue } = (0, $bkJfK.useFormikContext)();
    const evenementCategorieState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/nomenclatures/evenement_categorie`);
    function setListeComplementetres(value) {
        setFieldValue("evenementSousCategorieComplement", value);
    }
    return evenementCategorieState?.data && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                name: "evenementSousCategorieActif",
                label: "Actif"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                name: "evenementSousCategorieCode",
                label: "Code",
                required: true
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                name: "evenementSousCategorieLibelle",
                label: "Libell\xe9",
                required: true
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                name: "evenementSousCategorieTypeGeometrie",
                listIdCodeLibelle: listTypeGeometrie,
                label: "Type de g\xe9om\xe9trie",
                defaultValue: listTypeGeometrie?.find((e)=>e.code === values.evenementSousCategorieTypeGeometrie),
                required: true,
                setValues: setValues
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$d6701e98ab1a6725), {
                name: "evenementSousCategorieEvenementCategorieId",
                label: "Cat\xe9gorie de l'\xe9v\xe8nement",
                required: false,
                options: evenementCategorieState?.data ? Object.values(evenementCategorieState?.data) : [],
                getOptionValue: (t)=>t.evenementCategorieId,
                getOptionLabel: (t)=>t.evenementCategorieLibelle,
                defaultValue: Object.values(evenementCategorieState.data)?.find((r)=>r.evenementCategorieId === values.evenementSousCategorieEvenementCategorieId) ?? null,
                onChange: (e)=>{
                    setFieldValue(`evenementSousCategorieEvenementCategorieId`, Object.values(evenementCategorieState?.data)?.find((categorie)=>categorie.evenementCategorieId === e.evenementCategorieId)?.evenementCategorieId);
                }
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                className: "mt-4",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $0d6bddc95452bd52$export$2e2bcd8739ae039), {
                    buttonLibelle: "Ajouter des param\xe8tres",
                    createComponentToRepeat: (0, $b925a1370ed4f42d$export$e3b1104a5f84440a),
                    nomListe: "evenementSousCategorieComplement",
                    setData: setListeComplementetres,
                    defaultElement: {
                        sousCategorieComplementLibelle: "",
                        sousCategorieComplementCode: "",
                        sousCategorieComplementEstRequis: false,
                        sousCategorieComplementDescription: "",
                        sousCategorieComplementType: null,
                        sousCategorieComplementValeurDefaut: ""
                    }
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db9b0e6fdb142a4c$export$2e2bcd8739ae039), {
                returnLink: true
            })
        ]
    });
};


const $bbfc62d132294797$var$CreateEvenementSousCategorie = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                title: "Ajouter une sous cat\xe9gorie d'\xe9v\xe8nement",
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$d776d19dfae66ece), {})
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                onSubmit: ()=>true,
                initialValues: (0, $43004532355527cd$export$762d1b6daf009358)(),
                prepareVariables: (values)=>(0, $43004532355527cd$export$8470ef9d0802da38)(values),
                validationSchema: (0, $43004532355527cd$export$4cf4cf356f3a178b),
                submitUrl: `/api/evenement-sous-categorie/create/`,
                isPost: true,
                redirectUrl: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_EVENEMENT_SOUS_CATEGORIE,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $43004532355527cd$export$e5a199e82c32301d), {})
            })
        ]
    });
};
var $bbfc62d132294797$export$2e2bcd8739ae039 = $bbfc62d132294797$var$CreateEvenementSousCategorie;




















const $0f54db426f4a486b$var$filterValuesToVariable = ({ evenementSousCategorieCode: evenementSousCategorieCode, evenementSousCategorieTypeGeometrie: evenementSousCategorieTypeGeometrie, evenementSousCategorieLibelle: evenementSousCategorieLibelle, evenementSousCategorieActif: evenementSousCategorieActif, evenementCategorieId: evenementCategorieId })=>{
    const filter = {};
    $0f54db426f4a486b$var$filterProperty(filter, evenementSousCategorieCode, "evenementSousCategorieCode");
    $0f54db426f4a486b$var$filterProperty(filter, evenementSousCategorieTypeGeometrie, "evenementSousCategorieTypeGeometrie");
    $0f54db426f4a486b$var$filterProperty(filter, evenementSousCategorieLibelle, "evenementSousCategorieLibelle");
    $0f54db426f4a486b$var$filterProperty(filter, evenementSousCategorieActif, "evenementSousCategorieActif");
    $0f54db426f4a486b$var$filterProperty(filter, evenementCategorieId, "evenementCategorieId");
    return filter;
};
var $0f54db426f4a486b$export$2e2bcd8739ae039 = $0f54db426f4a486b$var$filterValuesToVariable;
function $0f54db426f4a486b$var$filterProperty(filter, value, name) {
    if (value && value.trim().length > 0) filter[name] = value;
}


const $71c88b03b9f38f2f$var$EvenementSousCategorieList = ()=>{
    const { user: user } = (0, $e787cde576104469$export$fdc397e486fa83e7)();
    const listeButton = [];
    const categorieCode = "MESSAGE";
    if ((0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_PARAM_APPLI)) listeButton.push({
        row: (row)=>{
            return row;
        },
        textEnable: "Modifier",
        route: (sousTypeId)=>(0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).UPDATE_EVENEMENT_SOUS_CATEGORIE(sousTypeId),
        type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).UPDATE
    }, {
        disable: (v)=>{
            return v.original.evenementsDependants || v.original.typeCriseCategorieCode === categorieCode;
        },
        textDisableFunction: ()=>"Impossible de supprimer l'\xe9l\xe9ment car il est utilis\xe9",
        row: (row)=>{
            return row;
        },
        type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).DELETE,
        pathname: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/evenement-sous-categorie/delete/`
    });
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$6c15dfad3d23e29b), {}),
                title: "Liste des sous cat\xe9gories d'\xe9v\xe8nements",
                right: (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).CRISE_C) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8ad69b89456b65bc$export$2e2bcd8739ae039), {
                    href: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).CREATE_EVENEMENT_SOUS_CATEGORIE,
                    title: "Ajouter une sous cat\xe9gorie"
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $9a9eebc3462fba73$export$2e2bcd8739ae039), {
                query: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/crise/evenement/all-sous-categories`,
                columns: [
                    {
                        Header: "Code",
                        accessor: "evenementSousCategorieCode",
                        sortField: "evenementSousCategorieCode",
                        Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                            type: "text",
                            name: "evenementSousCategorieCode"
                        })
                    },
                    {
                        Header: "Libelle",
                        accessor: "evenementSousCategorieLibelle",
                        sortField: "evenementSousCategorieLibelle",
                        Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                            type: "text",
                            name: "evenementSousCategorieLibelle"
                        })
                    },
                    {
                        Header: "Type de G\xe9om\xe9trie",
                        accessor: "evenementSousCategorieTypeGeometrie",
                        sortField: "evenementSousCategorieTypeGeometrie",
                        Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eed37ff3d3e1f28c$export$2e2bcd8739ae039), {
                            options: (0, $72e886a1223521a1$export$2e2bcd8739ae039),
                            name: "evenementSousCategorieTypeGeometrie"
                        })
                    },
                    (0, $b82b937cc97f6f18$export$38dcf858d3ede0e9)({
                        Header: "Actif",
                        accessor: "evenementSousCategorieActif",
                        sortField: "evenementSousCategorieActif",
                        Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eed37ff3d3e1f28c$export$2e2bcd8739ae039), {
                            options: (0, $a4f278cac9030fb1$export$2e2bcd8739ae039),
                            name: "evenementSousCategorieActif"
                        })
                    }),
                    {
                        Header: "cat\xe9gorie d'\xe9v\xe8nement",
                        accessor: "evenementCategorieLibelle",
                        Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $dd08a763d100724f$export$2e2bcd8739ae039), {
                            url: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/crise/get-evenement-category-libelle`,
                            name: "evenementCategorieId"
                        })
                    },
                    (0, $b82b937cc97f6f18$export$36e9f5a475c9f6fc)({
                        Header: "Actions",
                        accessor: "evenementSousCategorieId",
                        buttons: listeButton
                    })
                ],
                idName: "evenementSousCategorieId",
                filterValuesToVariable: (0, $0f54db426f4a486b$export$2e2bcd8739ae039),
                filterContext: (0, $9a9eebc3462fba73$export$396ef541d9951d45)({
                    evenementSousCategorieCode: undefined,
                    evenementSousCategorieTypeGeometrie: undefined,
                    evenementSousCategorieLibelle: undefined,
                    evenementSousCategorieActif: undefined,
                    evenementCategorieId: undefined
                })
            })
        ]
    });
};
var $71c88b03b9f38f2f$export$2e2bcd8739ae039 = $71c88b03b9f38f2f$var$EvenementSousCategorieList;












const $138285f48f6f51f8$var$UpdateEvenementSousCategorie = ()=>{
    const { evenementSousCategorieId: evenementSousCategorieId } = (0, $7a844823b04d4282$export$99eaa27ddbbb95ef)();
    const evenementSousCategorie = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/evenement-sous-categorie/get/` + evenementSousCategorieId)?.data;
    return evenementSousCategorie && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                title: "Mise \xe0 jour d'une sous cat\xe9gorie d'\xe9v\xe8nement",
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$b51dd496211ae105), {})
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                initialValues: (0, $43004532355527cd$export$762d1b6daf009358)(evenementSousCategorie),
                prepareVariables: (values)=>(0, $43004532355527cd$export$8470ef9d0802da38)(values),
                validationSchema: (0, $43004532355527cd$export$4cf4cf356f3a178b),
                submitUrl: `/api/evenement-sous-categorie/update/${evenementSousCategorieId}`,
                isPost: false,
                onSubmit: ()=>true,
                redirectUrl: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_EVENEMENT_SOUS_CATEGORIE,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $43004532355527cd$export$e5a199e82c32301d), {})
            })
        ]
    });
};
var $138285f48f6f51f8$export$2e2bcd8739ae039 = $138285f48f6f51f8$var$UpdateEvenementSousCategorie;






const $5db36463ed46a763$var$CreateTypeCrise = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1cf1e7fff5b3e31a$export$2e2bcd8739ae039), {
        typeNomenclature: (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).TYPE_CRISE,
        redirectLink: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_TYPE_CRISE,
        titrePage: "Cr\xe9ation d'un type de crise"
    });
};
var $5db36463ed46a763$export$2e2bcd8739ae039 = $5db36463ed46a763$var$CreateTypeCrise;








const $18f238516106c4f1$var$ListTypeCrise = ()=>{
    const additionalActionButton = {
        row: (row)=>{
            return row;
        },
        textEnable: "Acc\xe9der aux cat\xe9gories d'\xe9v\xe8nement associ\xe9es",
        route: ()=>(0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_EVENEMENT_CATEGORIE,
        type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).LINK,
        icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$527d32aa1785fdd4), {}),
        search: (obj)=>{
            return new URLSearchParams({
                filterBy: JSON.stringify({
                    evenementCategorieTypeCriseId: obj.value
                })
            }).toString();
        }
    };
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e5bcd0ed5e4cafe8$export$2e2bcd8739ae039), {
            pageTitle: "Type de crise",
            addButtonTitle: "Ajouter un type de crise",
            pageIcon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$73b2275057918051), {}),
            hasProtectedValue: false,
            lienPageAjout: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).ADD_TYPE_CRISE,
            typeNomenclature: (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).TYPE_CRISE,
            lienPageUpdate: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).UPDATE_TYPE_CRISE,
            additionalActionButton: additionalActionButton
        })
    });
};
var $18f238516106c4f1$export$2e2bcd8739ae039 = $18f238516106c4f1$var$ListTypeCrise;







const $806c80671130d0da$var$UpdateTypeCrise = ()=>{
    const { typeCriseId: typeCriseId } = (0, $7a844823b04d4282$export$99eaa27ddbbb95ef)();
    return typeCriseId && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $4e0326405bcaf2aa$export$2e2bcd8739ae039), {
        nomenclatureId: typeCriseId,
        typeNomenclature: (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).TYPE_CRISE,
        redirectLink: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_TYPE_CRISE,
        titrePage: "Mise \xe0 jour d'un type de crise"
    });
};
var $806c80671130d0da$export$2e2bcd8739ae039 = $806c80671130d0da$var$UpdateTypeCrise;






const $d1fe7f1e9b5255ba$var$CreateDiametre = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1cf1e7fff5b3e31a$export$2e2bcd8739ae039), {
        typeNomenclature: (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).DIAMETRE,
        redirectLink: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_DIAMETRE
    });
};
var $d1fe7f1e9b5255ba$export$2e2bcd8739ae039 = $d1fe7f1e9b5255ba$var$CreateDiametre;







const $025d19a08c961595$var$ListDiametre = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e5bcd0ed5e4cafe8$export$2e2bcd8739ae039), {
            pageTitle: "Diam\xe8tres",
            addButtonTitle: "Ajouter un diam\xe8tre",
            pageIcon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$ba2fbb9644c8bf32), {}),
            lienPageAjout: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).ADD_DIAMETRE,
            typeNomenclature: (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).DIAMETRE,
            lienPageUpdate: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).UPDATE_DIAMETRE
        })
    });
};
var $025d19a08c961595$export$2e2bcd8739ae039 = $025d19a08c961595$var$ListDiametre;







const $bfba589cecdfbf65$var$UpdateDiametre = ()=>{
    const { diametreId: diametreId } = (0, $7a844823b04d4282$export$99eaa27ddbbb95ef)();
    return diametreId && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $4e0326405bcaf2aa$export$2e2bcd8739ae039), {
        nomenclatureId: diametreId,
        typeNomenclature: (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).DIAMETRE,
        redirectLink: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_DIAMETRE
    });
};
var $bfba589cecdfbf65$export$2e2bcd8739ae039 = $bfba589cecdfbf65$var$UpdateDiametre;










var $bkJfK = parcelRequire("bkJfK");





const $96b29a19bf0a2485$export$a5cab80145b70e98 = (data)=>({
        documentHabilitableLibelle: data?.documentHabilitableLibelle ?? null,
        documentHabilitableDescription: data?.documentHabilitableDescription ?? null,
        listeThematiqueId: data?.listeThematiqueId ?? null,
        listeGroupeFonctionnalitesId: data?.listeGroupeFonctionnalitesId ?? null,
        document: null
    });
const $96b29a19bf0a2485$export$c084437b5e3206cd = (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({});
const $96b29a19bf0a2485$export$f97400759cfd946 = (values)=>{
    const formData = new FormData();
    formData.append("document", values.document);
    formData.append("documentHabilitableLibelle", values.documentHabilitableLibelle);
    formData.append("documentHabilitableDescription", values.documentHabilitableDescription);
    formData.append("listeThematiqueId", JSON.stringify(values.listeThematiqueId));
    formData.append("listeGroupeFonctionnalitesId", JSON.stringify(values.listeGroupeFonctionnalitesId));
    return formData;
};
const $96b29a19bf0a2485$var$DocumentHabilitable = ({ isNew: isNew = false })=>{
    const { values: values, setFieldValue: setFieldValue } = (0, $bkJfK.useFormikContext)();
    const thematiqueState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/thematique/actif`);
    const groupeFonctionnalitesState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/groupe-fonctionnalites`);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                label: "Libell\xe9",
                name: "documentHabilitableLibelle",
                required: false
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$ce9b1cc0c34506d0), {
                label: "Description",
                name: "documentHabilitableDescription",
                required: false
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b57af79a4ab2a1c6), {
                name: "document",
                accept: "*.*",
                label: "Document",
                required: isNew,
                onChange: (e)=>setFieldValue("document", e.target.files[0])
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$eae70af4b4e3f197), {
                name: "listeThematiqueId",
                label: "Th\xe9matiques concern\xe9es par le document",
                options: thematiqueState?.data,
                getOptionValue: (t)=>t.id,
                getOptionLabel: (t)=>t.libelle,
                disabled: isNew,
                value: values?.listeThematiqueId?.map((e)=>thematiqueState?.data?.find((r)=>r.id === e)) ?? [],
                onChange: (thematique)=>{
                    const thematiqueId = thematique.map((e)=>e.id);
                    thematiqueId.length > 0 ? setFieldValue("listeThematiqueId", thematiqueId) : setFieldValue("listeThematiqueId", []);
                },
                isClearable: true,
                required: false
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$eae70af4b4e3f197), {
                name: "listeGroupeFonctionnalitesId",
                label: "Groupes de fonctionnalit\xe9s concern\xe9s par le document",
                options: groupeFonctionnalitesState?.data,
                getOptionValue: (t)=>t.id,
                getOptionLabel: (t)=>t.libelle,
                value: values?.listeGroupeFonctionnalitesId?.map((e)=>groupeFonctionnalitesState?.data?.find((r)=>r.id === e)) ?? [],
                onChange: (groupeFonctionnalites)=>{
                    const groupeFonctionnalitesId = groupeFonctionnalites.map((e)=>e.id);
                    groupeFonctionnalitesId.length > 0 ? setFieldValue("listeGroupeFonctionnalitesId", groupeFonctionnalitesId) : setFieldValue("listeGroupeFonctionnalitesId", []);
                },
                isClearable: true,
                required: false
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db9b0e6fdb142a4c$export$2e2bcd8739ae039), {
                returnLink: true
            })
        ]
    });
};
var $96b29a19bf0a2485$export$2e2bcd8739ae039 = $96b29a19bf0a2485$var$DocumentHabilitable;


const $21c51c1f5d8d18ca$var$CreateDocumentHabilitable = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$d776d19dfae66ece), {}),
                title: "Cr\xe9ation d'un document"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                initialValues: (0, $96b29a19bf0a2485$export$a5cab80145b70e98)(),
                validationSchema: (0, $96b29a19bf0a2485$export$c084437b5e3206cd),
                isPost: true,
                isMultipartFormData: true,
                submitUrl: `/api/document-habilitable/create/`,
                prepareVariables: (values)=>(0, $96b29a19bf0a2485$export$f97400759cfd946)(values),
                redirectUrl: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_DOCUMENT_HABILITABLE,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $96b29a19bf0a2485$export$2e2bcd8739ae039), {
                    isNew: true
                })
            })
        ]
    });
};
var $21c51c1f5d8d18ca$export$2e2bcd8739ae039 = $21c51c1f5d8d18ca$var$CreateDocumentHabilitable;




















const $c2c481fda839af11$var$FilterValues = ({ documentHabilitableLibelle: documentHabilitableLibelle, listThematiqueId: listThematiqueId, listGroupeFonctionnalitesId: listGroupeFonctionnalitesId })=>{
    const filter = {};
    $c2c481fda839af11$var$filterProperty(filter, documentHabilitableLibelle, "documentHabilitableLibelle");
    if (listThematiqueId !== null && listThematiqueId?.length > 0) filter.listThematiqueId = listThematiqueId;
    if (listGroupeFonctionnalitesId !== null && listGroupeFonctionnalitesId?.length > 0) filter.listGroupeFonctionnalitesId = listGroupeFonctionnalitesId;
    return filter;
};
function $c2c481fda839af11$var$filterProperty(filter, value, name) {
    if (value != null && value.trim() !== "") filter[name] = value;
}
var $c2c481fda839af11$export$2e2bcd8739ae039 = $c2c481fda839af11$var$FilterValues;


const $5323278bca44277a$var$ListDocumentHabilitable = ()=>{
    const { user: user } = (0, $e787cde576104469$export$fdc397e486fa83e7)();
    const thematiqueState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/thematique/`);
    const groupeFonctionnalitesState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/groupe-fonctionnalites`);
    const listeButton = [];
    const { handleShowClose: handleShowClose, activesKeys: activesKeys } = (0, $db860d90b4a42fea$export$dae930a4ba30758b)([
        false
    ]);
    if ((0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).DOCUMENTS_A)) {
        listeButton.push({
            row: (row)=>{
                return row;
            },
            route: (documentHabilitableId)=>(0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).UPDATE_DOCUMENT_HABILITABLE(documentHabilitableId),
            type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).UPDATE
        });
        listeButton.push({
            row: (row)=>{
                return row;
            },
            type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).DELETE,
            pathname: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/document-habilitable/delete/`
        });
    }
    if ((0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).DOCUMENTS_R)) listeButton.push({
        row: (row)=>{
            return row;
        },
        route: (documentHabilitableId)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/document-habilitable/telecharger/` + documentHabilitableId,
        type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).BUTTON,
        icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$4a5ccdc9878f4668), {}),
        textEnable: "T\xe9l\xe9charger le document",
        classEnable: "warning"
    });
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                    icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$527d32aa1785fdd4), {}),
                    title: "Liste des documents",
                    right: (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).DOCUMENTS_A) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8ad69b89456b65bc$export$2e2bcd8739ae039), {
                        href: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).ADD_DOCUMENT_HABILITABLE,
                        title: "Ajouter un document"
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db860d90b4a42fea$export$2e2bcd8739ae039), {
                    activesKeys: activesKeys,
                    handleShowClose: handleShowClose,
                    list: [
                        {
                            header: "Informations utiles",
                            content: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("p", {
                                children: [
                                    "Les documents sont",
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("ul", {
                                        children: [
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("li", {
                                                children: [
                                                    "rattachables \xe0 z\xe9ro ou plusieurs ",
                                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("b", {
                                                        children: "th\xe9matiques"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("li", {
                                                children: [
                                                    "accessibles \xe0 z\xe9ro ou plusieurs",
                                                    " ",
                                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("b", {
                                                        children: "groupe de fonctionnalit\xe9s"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    "Ils remontent sur la page d'accueil dans le bloc de type",
                                    " ",
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("b", {
                                        children: "document"
                                    }),
                                    " idoine (donc en prenant en compte le param\xe9trage des th\xe9matiques de celui-ci, ainsi que les droits de l'utilisateur connect\xe9).",
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                                    "Attention, aucune th\xe9matique ou aucun groupe de fonctionnalit\xe9s s\xe9lectionn\xe9s --> le document ne pourra pas remonter sur la page d'accueil"
                                ]
                            })
                        }
                    ]
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $9a9eebc3462fba73$export$2e2bcd8739ae039), {
                    query: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/document-habilitable/`,
                    columns: [
                        {
                            Header: "Libell\xe9",
                            accessor: "documentHabilitableLibelle",
                            sortField: "documentHabilitableLibelle",
                            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                                type: "text",
                                name: "documentHabilitableLibelle"
                            })
                        },
                        {
                            Header: "Th\xe9matiques",
                            accessor: "listeThematique",
                            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $cc7cbb0460865818$export$2e2bcd8739ae039), {
                                name: "listThematiqueId",
                                listIdCodeLibelle: thematiqueState.data
                            })
                        },
                        {
                            Header: "Groupe de fonctionnalit\xe9s",
                            accessor: "listeGroupeFonctionnalites",
                            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $cc7cbb0460865818$export$2e2bcd8739ae039), {
                                name: "listGroupeFonctionnalitesId",
                                listIdCodeLibelle: groupeFonctionnalitesState.data
                            })
                        },
                        {
                            Header: "Mise \xe0 jour le",
                            accessor: "documentHabilitableDateMaj",
                            sortField: "documentHabilitableDateMaj",
                            Cell: (value)=>{
                                return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                    children: value?.value != null && (0, $00c47c7740afd024$export$2e2bcd8739ae039)(value.value)
                                });
                            }
                        },
                        (0, $b82b937cc97f6f18$export$36e9f5a475c9f6fc)({
                            Header: "Actions",
                            accessor: "documentHabilitableId",
                            buttons: listeButton
                        })
                    ],
                    idName: "tableDocumentHabilitable",
                    filterValuesToVariable: (0, $c2c481fda839af11$export$2e2bcd8739ae039),
                    filterContext: (0, $9a9eebc3462fba73$export$396ef541d9951d45)({})
                })
            ]
        })
    });
};
var $5323278bca44277a$export$2e2bcd8739ae039 = $5323278bca44277a$var$ListDocumentHabilitable;












const $9caed844f672311b$var$UpdateDocumentHabilitable = ()=>{
    const { documentHabilitableId: documentHabilitableId } = (0, $7a844823b04d4282$export$99eaa27ddbbb95ef)();
    const { data: data } = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/document-habilitable/get/` + documentHabilitableId);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$b51dd496211ae105), {}),
                title: "Mise \xe0 jour d'un document"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                initialValues: (0, $96b29a19bf0a2485$export$a5cab80145b70e98)(data),
                validationSchema: (0, $96b29a19bf0a2485$export$c084437b5e3206cd),
                isPost: false,
                isMultipartFormData: true,
                submitUrl: `/api/document-habilitable/update/` + documentHabilitableId,
                prepareVariables: (values)=>(0, $96b29a19bf0a2485$export$f97400759cfd946)(values),
                redirectUrl: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_DOCUMENT_HABILITABLE,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $96b29a19bf0a2485$export$2e2bcd8739ae039), {})
            })
        ]
    });
};
var $9caed844f672311b$export$2e2bcd8739ae039 = $9caed844f672311b$var$UpdateDocumentHabilitable;






const $48caef1b2068e58e$var$CreateDomaine = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1cf1e7fff5b3e31a$export$2e2bcd8739ae039), {
        typeNomenclature: (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).DOMAINE,
        redirectLink: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_DOMAINE
    });
};
var $48caef1b2068e58e$export$2e2bcd8739ae039 = $48caef1b2068e58e$var$CreateDomaine;







const $ae07dee136c398b8$var$ListDomaine = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e5bcd0ed5e4cafe8$export$2e2bcd8739ae039), {
            pageTitle: "Domaines",
            addButtonTitle: "Ajouter un domaine",
            pageIcon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$ba2fbb9644c8bf32), {}),
            hasProtectedValue: false,
            lienPageAjout: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).ADD_DOMAINE,
            typeNomenclature: (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).DOMAINE,
            lienPageUpdate: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).UPDATE_DOMAINE
        })
    });
};
var $ae07dee136c398b8$export$2e2bcd8739ae039 = $ae07dee136c398b8$var$ListDomaine;







const $e2c624fc51959a35$var$UpdateDomaine = ()=>{
    const { domaineId: domaineId } = (0, $7a844823b04d4282$export$99eaa27ddbbb95ef)();
    return domaineId && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $4e0326405bcaf2aa$export$2e2bcd8739ae039), {
        nomenclatureId: domaineId,
        typeNomenclature: (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).DOMAINE,
        redirectLink: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_DOMAINE
    });
};
var $e2c624fc51959a35$export$2e2bcd8739ae039 = $e2c624fc51959a35$var$UpdateDomaine;













const $021abfd43a00b455$export$a5cab80145b70e98 = (data)=>({
        groupeFonctionnalitesCode: data?.groupeFonctionnalitesCode ?? null,
        groupeFonctionnalitesLibelle: data?.groupeFonctionnalitesLibelle ?? null,
        groupeFonctionnalitesActif: data?.groupeFonctionnalitesActif ?? false
    });
const $021abfd43a00b455$export$8470ef9d0802da38 = (values)=>({
        groupeFonctionnalitesCode: values.groupeFonctionnalitesCode,
        groupeFonctionnalitesLibelle: values.groupeFonctionnalitesLibelle,
        groupeFonctionnalitesActif: values.groupeFonctionnalitesActif
    });
const $021abfd43a00b455$export$c084437b5e3206cd = (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({
    groupeFonctionnalitesCode: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
    groupeFonctionnalitesLibelle: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
    groupeFonctionnalitesActif: (0, $ce4de947442b2ab1$export$87b259aa03e3d267)()
});
const $021abfd43a00b455$var$GroupeFonctionnalitesForm = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                label: "Libell\xe9",
                name: "groupeFonctionnalitesLibelle",
                required: true
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                label: "Code",
                name: "groupeFonctionnalitesCode",
                required: true
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                label: "Actif",
                name: "groupeFonctionnalitesActif"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db9b0e6fdb142a4c$export$2e2bcd8739ae039), {
                returnLink: true
            })
        ]
    });
};
var $021abfd43a00b455$export$2e2bcd8739ae039 = $021abfd43a00b455$var$GroupeFonctionnalitesForm;


const $e14b572d3716a4bc$var$GroupeFonctionnalitesCreate = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                title: "Cr\xe9ation d'un groupe de fonctionnalit\xe9s",
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$b51dd496211ae105), {})
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                initialValues: (0, $021abfd43a00b455$export$a5cab80145b70e98)(),
                prepareVariables: (values)=>(0, $021abfd43a00b455$export$8470ef9d0802da38)(values),
                validationSchema: (0, $021abfd43a00b455$export$c084437b5e3206cd),
                submitUrl: `/api/groupe-fonctionnalites/create`,
                isPost: true,
                redirectUrl: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).GROUPE_FONCTIONNALITES_LIST,
                onSubmit: ()=>true,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $021abfd43a00b455$export$2e2bcd8739ae039), {})
            })
        ]
    });
};
var $e14b572d3716a4bc$export$2e2bcd8739ae039 = $e14b572d3716a4bc$var$GroupeFonctionnalitesCreate;
















const $b3dc38ef1a9b638e$var$GroupeFonctionnalitesList = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$527d32aa1785fdd4), {}),
                title: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                    children: [
                        "Groupes de fonctionnalit\xe9s",
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                            tooltipText: "Un groupe de fonctionnalit\xe9s permet de regrouper des droits d'acc\xe8s afin de les attribuer \xe0 une cat\xe9gorie d'utilisateurs",
                            tooltipId: "tooltip-groupe-fonctionnalites",
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$340bfce9b4df026b), {})
                        })
                    ]
                }),
                right: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8ad69b89456b65bc$export$2e2bcd8739ae039), {
                    href: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).GROUPE_FONCTIONNALITES_CREATE,
                    title: "Ajouter un groupe"
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $9a9eebc3462fba73$export$2e2bcd8739ae039), {
                query: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/groupe-fonctionnalites`,
                columns: [
                    {
                        Header: "Nom",
                        accessor: "groupeFonctionnalitesLibelle",
                        sortField: "groupeFonctionnalitesLibelle",
                        Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                            type: "text",
                            name: "groupeFonctionnalitesLibelle"
                        })
                    },
                    {
                        Header: "Code",
                        accessor: "groupeFonctionnalitesCode",
                        sortField: "groupeFonctionnalitesCode",
                        Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                            type: "text",
                            name: "groupeFonctionnalitesCode"
                        })
                    },
                    (0, $b82b937cc97f6f18$export$38dcf858d3ede0e9)({
                        Header: "Actif",
                        accessor: "groupeFonctionnalitesActif",
                        sortField: "groupeFonctionnalitesActif",
                        Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eed37ff3d3e1f28c$export$2e2bcd8739ae039), {
                            options: (0, $a4f278cac9030fb1$export$2e2bcd8739ae039),
                            name: "groupeFonctionnalitesActif"
                        })
                    }),
                    (0, $b82b937cc97f6f18$export$36e9f5a475c9f6fc)({
                        Header: "Actions",
                        accessor: "groupeFonctionnalitesId",
                        buttons: [
                            {
                                row: (row)=>{
                                    return row;
                                },
                                route: (groupeFonctionnalitesId)=>(0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).GROUPE_FONCTIONNALITES_UPDATE(groupeFonctionnalitesId),
                                type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).UPDATE
                            }
                        ]
                    })
                ],
                idName: "groupe-fonctionnalites",
                filterValuesToVariable: $b3dc38ef1a9b638e$var$filterValuesToVariable,
                filterContext: (0, $9a9eebc3462fba73$export$396ef541d9951d45)({
                    groupeFonctionnalitesLibelle: undefined,
                    groupeFonctionnalitesCode: undefined,
                    groupeFonctionnalitesActif: undefined
                })
            })
        ]
    });
};
var $b3dc38ef1a9b638e$export$2e2bcd8739ae039 = $b3dc38ef1a9b638e$var$GroupeFonctionnalitesList;
const $b3dc38ef1a9b638e$var$filterValuesToVariable = ({ groupeFonctionnalitesLibelle: groupeFonctionnalitesLibelle, groupeFonctionnalitesCode: groupeFonctionnalitesCode, groupeFonctionnalitesActif: groupeFonctionnalitesActif })=>{
    const filter = {};
    $b3dc38ef1a9b638e$var$filterProperty(filter, groupeFonctionnalitesLibelle, "groupeFonctionnalitesLibelle");
    $b3dc38ef1a9b638e$var$filterProperty(filter, groupeFonctionnalitesCode, "groupeFonctionnalitesCode");
    $b3dc38ef1a9b638e$var$filterProperty(filter, groupeFonctionnalitesActif, "groupeFonctionnalitesActif");
    return filter;
};
function $b3dc38ef1a9b638e$var$filterProperty(filter, value, name) {
    if (value?.trim().length > 0) filter[name] = value;
}













const $a389155915939d6d$var$GroupeFonctionnalitesUpdate = ()=>{
    const { groupeFonctionnalitesId: groupeFonctionnalitesId } = (0, $7a844823b04d4282$export$99eaa27ddbbb95ef)();
    const groupeFonctionnalitesState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/groupe-fonctionnalites/${groupeFonctionnalitesId}`);
    if (!groupeFonctionnalitesState.isResolved) return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $c21b1c237cfa1d94$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                title: "Modification d'un groupe de fonctionnalit\xe9s",
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$b51dd496211ae105), {})
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                initialValues: (0, $021abfd43a00b455$export$a5cab80145b70e98)(groupeFonctionnalitesState.data),
                prepareVariables: (values)=>(0, $021abfd43a00b455$export$8470ef9d0802da38)(values),
                validationSchema: (0, $021abfd43a00b455$export$c084437b5e3206cd),
                submitUrl: `/api/groupe-fonctionnalites/update/${groupeFonctionnalitesId}`,
                isPost: false,
                redirectUrl: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).GROUPE_FONCTIONNALITES_LIST,
                onSubmit: ()=>true,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $021abfd43a00b455$export$2e2bcd8739ae039), {})
            })
        ]
    });
};
var $a389155915939d6d$export$2e2bcd8739ae039 = $a389155915939d6d$var$GroupeFonctionnalitesUpdate;










var $bkJfK = parcelRequire("bkJfK");








const $58c000e51de272ab$export$a5cab80145b70e98 = (data)=>({
        profilOrganismeId: data?.profilOrganismeId ?? null,
        profilUtilisateurId: data?.profilUtilisateurId ?? null,
        groupeFonctionnalitesId: data?.groupeFonctionnalitesId ?? null
    });
const $58c000e51de272ab$export$8470ef9d0802da38 = (values)=>({
        profilOrganismeId: values.profilOrganismeId,
        profilUtilisateurId: values.profilUtilisateurId,
        groupeFonctionnalitesId: values.groupeFonctionnalitesId
    });
const $58c000e51de272ab$export$c084437b5e3206cd = (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({
    profilOrganismeId: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
    profilUtilisateurId: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
    groupeFonctionnalitesId: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba)
});
const $58c000e51de272ab$var$LienProfilFonctionnaliteForm = ()=>{
    const { values: values, setFieldValue: setFieldValue, setValues: setValues } = (0, $bkJfK.useFormikContext)();
    const lienProfilFonctionnaliteReferentielState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/lien-profil-fonctionnalite/referentiel`);
    if (!lienProfilFonctionnaliteReferentielState.isResolved) return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $c21b1c237cfa1d94$export$2e2bcd8739ae039), {});
    const { profilOrganismeList: profilOrganismeList, profilUtilisateurList: profilUtilisateurList, groupeFonctionnalitesList: groupeFonctionnalitesList } = lienProfilFonctionnaliteReferentielState.data;
    const profilOrganismeCodeLibelleList = profilOrganismeList.map((o)=>{
        return {
            id: o.profilOrganismeId,
            libelle: o.profilOrganismeLibelle
        };
    });
    const profilUtilisateCodeLibelleList = profilUtilisateurList.filter((u)=>u.profilUtilisateurTypeOrganismeId === profilOrganismeList.find((p)=>p.profilOrganismeId === values.profilOrganismeId)?.profilOrganismeTypeOrganismeId).map((u)=>{
        return {
            id: u.profilUtilisateurId,
            libelle: u.profilUtilisateurLibelle
        };
    });
    const groupeFonctionnalitesCodeLibelleList = groupeFonctionnalitesList.map((d)=>{
        return {
            id: d.groupeFonctionnalitesId,
            libelle: d.groupeFonctionnalitesLibelle
        };
    });
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                name: "profilOrganismeId",
                listIdCodeLibelle: profilOrganismeCodeLibelleList,
                defaultValue: profilOrganismeCodeLibelleList.find((e)=>e.id === values.profilOrganismeId),
                label: "Profil organisme",
                setValues: setValues,
                required: true,
                onChange: (e)=>{
                    setFieldValue("profilOrganismeId", e?.id);
                    const newValue = profilOrganismeList.find((p)=>p.profilOrganismeId === e?.id);
                    const currentUtilisateur = profilUtilisateurList.find((u)=>u.profilUtilisateurId === values.profilUtilisateurId);
                    if (!newValue || currentUtilisateur && newValue.profilOrganismeTypeOrganismeId !== currentUtilisateur.profilUtilisateurTypeOrganismeId) setFieldValue("profilUtilisateurId", null);
                }
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                name: "profilUtilisateurId",
                listIdCodeLibelle: profilUtilisateCodeLibelleList,
                defaultValue: profilUtilisateCodeLibelleList.find((e)=>e.id === values.profilUtilisateurId),
                label: "Profil utilisateur",
                setValues: setValues,
                required: true
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                name: "groupeFonctionnalitesId",
                listIdCodeLibelle: groupeFonctionnalitesCodeLibelleList,
                defaultValue: groupeFonctionnalitesCodeLibelleList.find((e)=>e.id === values.groupeFonctionnalitesId),
                label: "Groupe de fonctionnalit\xe9s",
                setValues: setValues,
                required: true
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db9b0e6fdb142a4c$export$2e2bcd8739ae039), {
                returnLink: true
            })
        ]
    });
};
var $58c000e51de272ab$export$2e2bcd8739ae039 = $58c000e51de272ab$var$LienProfilFonctionnaliteForm;


const $e233fb445d2f80f6$var$GroupeFonctionnalitesCreate = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                title: "Cr\xe9ation d'un lien profil / groupe de fonctionnalit\xe9s",
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$b51dd496211ae105), {})
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                initialValues: (0, $58c000e51de272ab$export$a5cab80145b70e98)(),
                prepareVariables: (values)=>(0, $58c000e51de272ab$export$8470ef9d0802da38)(values),
                validationSchema: (0, $58c000e51de272ab$export$c084437b5e3206cd),
                submitUrl: `/api/lien-profil-fonctionnalite/create`,
                isPost: true,
                redirectUrl: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIEN_PROFIL_FONCTIONNALITE_LIST,
                onSubmit: ()=>true,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $58c000e51de272ab$export$2e2bcd8739ae039), {})
            })
        ]
    });
};
var $e233fb445d2f80f6$export$2e2bcd8739ae039 = $e233fb445d2f80f6$var$GroupeFonctionnalitesCreate;














const $81cf55f993f3c491$var$LienProfilFonctionnaliteList = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$527d32aa1785fdd4), {}),
                title: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                    children: [
                        "Liens profils / groupes de fonctionnalit\xe9s",
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                            tooltipText: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
                                children: "Un lien profil / groupe de fonctionnalit\xe9s permet de d\xe9finir des combinaisons possibles pour affecter des droits (groupe de fonctionnalit\xe9s) \xe0 un utilisateur (profil utilisateur) qui est forc\xe9ment rattach\xe9 \xe0 un organisme (profil organisme). L'\xe9dition d'un utilisateur permettra, en fonction du profil utilisateur et de l'organisme s\xe9lectionn\xe9s, de lui affecter les groupes de fonctionnalit\xe9s disponibles pour cette combinaison."
                            }),
                            tooltipId: "tooltip-lien-profil-fonctionnalite",
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$340bfce9b4df026b), {})
                        })
                    ]
                }),
                right: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8ad69b89456b65bc$export$2e2bcd8739ae039), {
                    href: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIEN_PROFIL_FONCTIONNALITE_CREATE,
                    title: "Ajouter un lien"
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $9a9eebc3462fba73$export$2e2bcd8739ae039), {
                query: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/lien-profil-fonctionnalite`,
                columns: [
                    {
                        accessor: ()=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("span", {
                                className: "fst-italic",
                                children: "Quand"
                            })
                    },
                    {
                        Header: "Profil organisme",
                        accessor: "profilOrganismeLibelle",
                        sortField: "organisme",
                        Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                            name: "profilOrganismeLibelle",
                            type: "text"
                        })
                    },
                    {
                        accessor: ()=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("span", {
                                className: "fst-italic",
                                children: "et"
                            })
                    },
                    {
                        Header: "Profil utilisateur",
                        accessor: "profilUtilisateurLibelle",
                        sortField: "utilisateur",
                        Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                            name: "profilUtilisateurLibelle",
                            type: "text"
                        })
                    },
                    {
                        accessor: ()=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("span", {
                                className: "fst-bold",
                                children: "\u2192"
                            })
                    },
                    {
                        Header: "Groupe de fonctionnalit\xe9s",
                        accessor: "groupeFonctionnalitesLibelle",
                        sortField: "fonctionnalite",
                        Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                            name: "groupeFonctionnalitesLibelle",
                            type: "text"
                        })
                    },
                    (0, $b82b937cc97f6f18$export$36e9f5a475c9f6fc)({
                        Header: "Actions",
                        accessor: (row)=>row,
                        buttons: [
                            {
                                row: (row)=>row,
                                route: ({ profilOrganismeId: profilOrganismeId, profilUtilisateurId: profilUtilisateurId })=>(0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIEN_PROFIL_FONCTIONNALITE_UPDATE({
                                        profilOrganismeId: profilOrganismeId,
                                        profilUtilisateurId: profilUtilisateurId
                                    }),
                                type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).UPDATE
                            },
                            {
                                row: (row)=>row,
                                type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).DELETE,
                                pathname: (row)=>{
                                    const typedRow = row;
                                    return `/api/lien-profil-fonctionnalite/delete/${typedRow.original.profilOrganismeId}/${typedRow.original.profilUtilisateurId}/${typedRow.original.groupeFonctionnalitesId}`;
                                },
                                disable: (row)=>!row.original.canDelete,
                                textDisable: "Impossible de supprimer ce lien car il est utilis\xe9 par au moins un utilisateur"
                            }
                        ]
                    })
                ],
                idName: "lien-groupe-fonctionnalites",
                filterValuesToVariable: $81cf55f993f3c491$var$filterValuesToVariable,
                filterContext: (0, $9a9eebc3462fba73$export$396ef541d9951d45)({
                    profilOrganismeLibelle: undefined,
                    profilUtilisateurLibelle: undefined,
                    groupeFonctionnalitesLibelle: undefined
                })
            })
        ]
    });
};
var $81cf55f993f3c491$export$2e2bcd8739ae039 = $81cf55f993f3c491$var$LienProfilFonctionnaliteList;
const $81cf55f993f3c491$var$filterValuesToVariable = ({ groupeFonctionnalitesLibelle: groupeFonctionnalitesLibelle, profilOrganismeLibelle: profilOrganismeLibelle, profilUtilisateurLibelle: profilUtilisateurLibelle })=>{
    const filter = {};
    $81cf55f993f3c491$var$filterProperty(filter, groupeFonctionnalitesLibelle, "groupeFonctionnalitesLibelle");
    $81cf55f993f3c491$var$filterProperty(filter, profilOrganismeLibelle, "profilOrganismeLibelle");
    $81cf55f993f3c491$var$filterProperty(filter, profilUtilisateurLibelle, "profilUtilisateurLibelle");
    return filter;
};
function $81cf55f993f3c491$var$filterProperty(filter, value, name) {
    if (value?.trim().length > 0) filter[name] = value;
}













const $846dfd8fbbe7ab3b$var$GroupeFonctionnalitesUpdate = ()=>{
    const { profilOrganismeId: profilOrganismeId, profilUtilisateurId: profilUtilisateurId } = (0, $7a844823b04d4282$export$99eaa27ddbbb95ef)();
    const lienProfilFonctionnaliteState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/lien-profil-fonctionnalite/${profilOrganismeId}/${profilUtilisateurId}`);
    if (!lienProfilFonctionnaliteState.isResolved) return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $c21b1c237cfa1d94$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                title: "Modification d'un lien profil / groupe de fonctionnalit\xe9s",
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$b51dd496211ae105), {})
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                initialValues: (0, $58c000e51de272ab$export$a5cab80145b70e98)(lienProfilFonctionnaliteState.data),
                prepareVariables: (values)=>(0, $58c000e51de272ab$export$8470ef9d0802da38)(values),
                validationSchema: (0, $58c000e51de272ab$export$c084437b5e3206cd),
                submitUrl: `/api/lien-profil-fonctionnalite/update/${profilOrganismeId}/${profilUtilisateurId}`,
                isPost: false,
                redirectUrl: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIEN_PROFIL_FONCTIONNALITE_LIST,
                onSubmit: ()=>true,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $58c000e51de272ab$export$2e2bcd8739ae039), {})
            })
        ]
    });
};
var $846dfd8fbbe7ab3b$export$2e2bcd8739ae039 = $846dfd8fbbe7ab3b$var$GroupeFonctionnalitesUpdate;




var $bkJfK = parcelRequire("bkJfK");












const $67d49f8fdb33e7bc$var$LienProfilGroupeFonctionnalitesList = ()=>{
    const lienGroupeFonctionnalitesListState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/lien-groupe-fonctionnalites`);
    if (!lienGroupeFonctionnalitesListState.isResolved) return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $c21b1c237cfa1d94$export$2e2bcd8739ae039), {});
    const { groupeFonctionnalitesList: groupeFonctionnalitesList, typeDroitList: typeDroitList } = lienGroupeFonctionnalitesListState.data;
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
        initialValues: groupeFonctionnalitesList,
        validationSchema: (0, $ce4de947442b2ab1$export$be5493f9613cbbe)(),
        isPost: false,
        submitUrl: `/api/lien-groupe-fonctionnalites/update`,
        onSubmit: ()=>lienGroupeFonctionnalitesListState.reload(),
        fluid: true,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($67d49f8fdb33e7bc$var$LienProfilInner, {
            typeDroitList: typeDroitList
        })
    });
};
const $67d49f8fdb33e7bc$var$LienProfilInner = ({ typeDroitList: typeDroitList })=>{
    const { values: values, setFieldValue: setFieldValue, resetForm: resetForm } = (0, $bkJfK.useFormikContext)();
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                title: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                    children: [
                        "Attribution des fonctionnalit\xe9s",
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                            tooltipText: "Cet \xe9cran permet d'attribuer ou non les diff\xe9rents droits ci-dessous aux groupes de fonctionnalit\xe9s d\xe9finis en amont. Pour chaque groupe, cochez les droits que vous voulez lui attribuer. Certains droits sont li\xe9s entre eux, par exemple si vous cochez le droit d'administration, les droit d'acc\xe8s CRUD associ\xe9s seront automatiquement coch\xe9s.",
                            tooltipId: "tooltip-groupe-fonctionnalites",
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$340bfce9b4df026b), {})
                        })
                    ]
                }),
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$16fcff7afd79949), {})
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($67d49f8fdb33e7bc$var$Parent, {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $13de46b4dfcc473f$export$2e2bcd8739ae039), {
                            striped: true,
                            bordered: true,
                            hover: true,
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("th", {
                                                className: "sticky-col-1",
                                                style: {
                                                    "min-width": "300px",
                                                    "border-right": "1px solid #dee2e6"
                                                },
                                                children: "Libell\xe9"
                                            }),
                                            values.map((groupeFonctionnalites, idxPD)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("th", {
                                                    children: (0, $7680c94ec9779ccd$export$4a72a1b27496d2fa).get(groupeFonctionnalites.groupeFonctionnalitesLibelle) ? (0, $7680c94ec9779ccd$export$4a72a1b27496d2fa).get(groupeFonctionnalites.groupeFonctionnalitesLibelle) : groupeFonctionnalites.groupeFonctionnalitesLibelle
                                                }, idxPD))
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("tbody", {
                                    children: Object.values((0, $7680c94ec9779ccd$export$f1e8c3b59bb3ef17)).map((currentSection)=>{
                                        return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("tr", {
                                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("td", {
                                                        colSpan: 1 + values.length,
                                                        className: "bg-primary text-light text-center fw-bolder",
                                                        style: {
                                                            "border-right": "1px solid #dee2e6"
                                                        },
                                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                                            className: "section-header-cell",
                                                            children: currentSection
                                                        })
                                                    })
                                                }),
                                                (0, $7680c94ec9779ccd$export$e595ee2d27cbfb8c).entries().filter(([, value])=>value === currentSection).map(([key])=>{
                                                    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
                                                        children: typeDroitList.filter((typeDroit)=>key === typeDroit).map((typeDroit, idxTD)=>{
                                                            return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("tr", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("td", {
                                                                        className: "sticky-col-1",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                                                                                maxWidth: 300,
                                                                                tooltipId: `tooltip-${idxTD}`,
                                                                                tooltipText: typeDroit,
                                                                                nowrap: false,
                                                                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                                                                                    children: [
                                                                                        (0, $7680c94ec9779ccd$export$4a72a1b27496d2fa).get(typeDroit) ? (0, $7680c94ec9779ccd$export$4a72a1b27496d2fa).get(typeDroit) : "",
                                                                                        " "
                                                                                    ]
                                                                                })
                                                                            }),
                                                                            (0, $7680c94ec9779ccd$export$77886d1025bbf60d).get(typeDroit) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                                                                                tooltipId: `infobulle-${idxTD}`,
                                                                                tooltipText: (0, $7680c94ec9779ccd$export$77886d1025bbf60d).get(typeDroit),
                                                                                nowrap: false,
                                                                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("span", {
                                                                                    className: "ps-1",
                                                                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$340bfce9b4df026b), {})
                                                                                })
                                                                            })
                                                                        ]
                                                                    }),
                                                                    values.map((groupeFonctionnalites, idxPD)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("td", {
                                                                            className: "text-center",
                                                                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Check, {
                                                                                type: "checkbox",
                                                                                id: `check-${idxTD}-${idxPD}`,
                                                                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Check.Input, {
                                                                                    type: "checkbox",
                                                                                    value: typeDroit,
                                                                                    checked: groupeFonctionnalites.groupeFonctionnalitesDroits?.some((e)=>e === typeDroit),
                                                                                    onChange: (event)=>{
                                                                                        const value = event.currentTarget.value;
                                                                                        const arrayVal = [
                                                                                            value
                                                                                        ];
                                                                                        const right = value.substring(value.lastIndexOf("_") + 1);
                                                                                        const left = value.substring(0, value.lastIndexOf("_"));
                                                                                        if (event.currentTarget.checked) {
                                                                                            const droitsActuels = values[idxPD].groupeFonctionnalitesDroits;
                                                                                            if ((value === "ATLAS_C" && droitsActuels.includes("ATLAS_D") || value === "ATLAS_D" && droitsActuels.includes("ATLAS_C")) && !droitsActuels.includes("ATLAS_A")) arrayVal.push("ATLAS_A");
                                                                                            // si un droit _A est coché, on rajoute les droits équivalents
                                                                                            if (right === "A" && value !== "ADMIN_UTILISATEURS_A" && value !== "GEST_SITE_A") typeDroitList.forEach((typeDroit)=>{
                                                                                                const substr = typeDroit.substring(0, value.lastIndexOf("_"));
                                                                                                if (left === substr && values[idxPD].groupeFonctionnalitesDroits.indexOf(typeDroit) === -1) arrayVal.push(typeDroit);
                                                                                            });
                                                                                            if (value === "ORGANISME_CONTACT_A") arrayVal.push("ADMIN_ORGANISME_A", "ADMIN_ORGANISME_R");
                                                                                            if (value === "GEST_CONTACT_A") arrayVal.push("GEST_SITE_A");
                                                                                            if (value === "ADMIN_UTILISATEURS_A") arrayVal.push("ADMIN_UTILISATEURS_R", "ADMIN_UTILISATEURS_ORGA_A", "ADMIN_UTILISATEURS_ORGA_R");
                                                                                            if (value === "ADMIN_UTILISATEURS_R") arrayVal.push("ADMIN_UTILISATEURS_ORGA_R");
                                                                                            if (value === "IMPORT_UTILISATEUR_A") arrayVal.push("ADMIN_UTILISATEURS_ORGA_R", "ADMIN_UTILISATEURS_ORGA_A");
                                                                                            setFieldValue(`${idxPD}.groupeFonctionnalitesDroits`, [
                                                                                                ...values[idxPD].groupeFonctionnalitesDroits,
                                                                                                ...arrayVal
                                                                                            ]);
                                                                                        } else {
                                                                                            // Si on décoche "Administrer l'atlas", on décoche automatique éditer les documents et supprimer les documents.
                                                                                            if (value === "ATLAS_A") arrayVal.push("ATLAS_C", "ATLAS_D");
                                                                                            if (value === "ADMIN_UTILISATEURS_ORGA_A") arrayVal.push("ADMIN_UTILISATEURS_A", "IMPORT_UTILISATEUR_A");
                                                                                            if (value === "ADMIN_UTILISATEURS_ORGA_R") arrayVal.push("ADMIN_UTILISATEURS_R", "ADMIN_UTILISATEURS_A", "IMPORT_UTILISATEUR_A");
                                                                                            if (value === "ADMIN_ORGANISME_R") arrayVal.push("ORGANISME_CONTACT_A");
                                                                                            if (value === "ADMIN_ORGANISME_A") arrayVal.push("ORGANISME_CONTACT_A");
                                                                                            if (value === "TOURNEE_A") arrayVal.push("TOURNEE_ORDRE_PEIS_U");
                                                                                            if (value === "TOURNEE_R") arrayVal.push("TOURNEE_ORDRE_PEIS_U", "TOURNEE_RESERVATION_D", "TOURNEE_FORCER_POURCENTAGE_E", "RAZ_MES_ROP_E", "ADMIN_ROP_A");
                                                                                            // si un droit _CRUD est décoché, on tente de retirer le droit _A s'il existe
                                                                                            if ("CRUD".split("").some((action)=>action === right)) arrayVal.push(`${left}_A`);
                                                                                            setFieldValue(`${idxPD}.groupeFonctionnalitesDroits`, values[idxPD].groupeFonctionnalitesDroits?.filter((v)=>v && !arrayVal.some((a)=>v === a)));
                                                                                        }
                                                                                    }
                                                                                })
                                                                            })
                                                                        }, `${idxTD}${idxPD}`))
                                                                ]
                                                            }, idxTD);
                                                        })
                                                    });
                                                })
                                            ]
                                        });
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db9b0e6fdb142a4c$export$2e2bcd8739ae039), {
                        onSecondaryActionClick: ()=>resetForm(),
                        secondaryActionTitle: "Annuler"
                    })
                ]
            })
        ]
    });
};
const $67d49f8fdb33e7bc$var$Parent = ({ children: children })=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
        className: "container-profil",
        children: children
    });
};
var $67d49f8fdb33e7bc$export$2e2bcd8739ae039 = $67d49f8fdb33e7bc$var$LienProfilGroupeFonctionnalitesList;






const $166f2e199414f92a$var$CreateFonctionContact = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1cf1e7fff5b3e31a$export$2e2bcd8739ae039), {
        typeNomenclature: (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).FONCTION_CONTACT,
        redirectLink: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_FONCTION_CONTACT,
        titrePage: "Cr\xe9ation d'une fonction de contact"
    });
};
var $166f2e199414f92a$export$2e2bcd8739ae039 = $166f2e199414f92a$var$CreateFonctionContact;







const $bce4ee014dd39b69$var$ListFonctionContact = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e5bcd0ed5e4cafe8$export$2e2bcd8739ae039), {
            pageTitle: "Fonction de contact",
            addButtonTitle: "Ajouter une fonction de contact",
            pageIcon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$ba2fbb9644c8bf32), {}),
            hasProtectedValue: false,
            lienPageAjout: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).ADD_FONCTION_CONTACT,
            typeNomenclature: (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).FONCTION_CONTACT,
            lienPageUpdate: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).UPDATE_FONCTION_CONTACT
        })
    });
};
var $bce4ee014dd39b69$export$2e2bcd8739ae039 = $bce4ee014dd39b69$var$ListFonctionContact;







const $42fcc7866a6ccc7d$var$UpdateFonctionContact = ()=>{
    const { fonctionContactId: fonctionContactId } = (0, $7a844823b04d4282$export$99eaa27ddbbb95ef)();
    return fonctionContactId && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $4e0326405bcaf2aa$export$2e2bcd8739ae039), {
        nomenclatureId: fonctionContactId,
        typeNomenclature: (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).FONCTION_CONTACT,
        redirectLink: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_FONCTION_CONTACT,
        titrePage: "Modification d'une fonction de contact"
    });
};
var $42fcc7866a6ccc7d$export$2e2bcd8739ae039 = $42fcc7866a6ccc7d$var$UpdateFonctionContact;












const $01a04f1ee25085c3$export$a5cab80145b70e98 = (data)=>({
        gestionnaireCode: data?.gestionnaireCode ?? null,
        gestionnaireLibelle: data?.gestionnaireLibelle ?? null,
        gestionnaireActif: data?.gestionnaireActif ?? null
    });
const $01a04f1ee25085c3$export$c084437b5e3206cd = (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({});
const $01a04f1ee25085c3$export$f97400759cfd946 = (values)=>({
        gestionnaireCode: values.gestionnaireCode,
        gestionnaireLibelle: values.gestionnaireLibelle,
        gestionnaireActif: values.gestionnaireActif
    });
const $01a04f1ee25085c3$var$Gestionnaire = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                label: "Code",
                name: "gestionnaireCode",
                required: true
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                label: "Libell\xe9",
                name: "gestionnaireLibelle",
                required: true
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                name: "gestionnaireActif",
                label: "Actif"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db9b0e6fdb142a4c$export$2e2bcd8739ae039), {
                returnLink: true
            })
        ]
    });
};
var $01a04f1ee25085c3$export$2e2bcd8739ae039 = $01a04f1ee25085c3$var$Gestionnaire;


const $560b8785a401018e$var$CreateGestionnaire = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$d776d19dfae66ece), {}),
                title: "Cr\xe9ation d'un gestionnaire"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                initialValues: (0, $01a04f1ee25085c3$export$a5cab80145b70e98)(),
                validationSchema: (0, $01a04f1ee25085c3$export$c084437b5e3206cd),
                isPost: true,
                submitUrl: `/api/gestionnaire/create/`,
                prepareVariables: (values)=>(0, $01a04f1ee25085c3$export$f97400759cfd946)(values),
                redirectUrl: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_GESTIONNAIRE,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $01a04f1ee25085c3$export$2e2bcd8739ae039), {})
            })
        ]
    });
};
var $560b8785a401018e$export$2e2bcd8739ae039 = $560b8785a401018e$var$CreateGestionnaire;


















const $9d925d541962d76f$var$FilterValues = ({ gestionnaireCode: gestionnaireCode, gestionnaireLibelle: gestionnaireLibelle, gestionnaireActif: gestionnaireActif })=>{
    const filter = {};
    $9d925d541962d76f$var$filterProperty(filter, gestionnaireCode, "gestionnaireCode");
    $9d925d541962d76f$var$filterProperty(filter, gestionnaireLibelle, "gestionnaireLibelle");
    $9d925d541962d76f$var$filterProperty(filter, gestionnaireActif, "gestionnaireActif");
    return filter;
};
function $9d925d541962d76f$var$filterProperty(filter, value, name) {
    if (value != null && value.trim() !== "") filter[name] = value;
}
var $9d925d541962d76f$export$2e2bcd8739ae039 = $9d925d541962d76f$var$FilterValues;


const $2d13bf66536e67e2$var$ListGestionnaire = ()=>{
    const { user: user } = (0, $e787cde576104469$export$fdc397e486fa83e7)();
    const listeButton = [];
    if ((0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).GEST_SITE_R) || (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).GEST_CONTACT_A)) listeButton.push({
        row: (row)=>{
            return row;
        },
        route: (gestionnaireId)=>(0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_CONTACT(gestionnaireId, "gestionnaire"),
        type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).LINK,
        icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$3c0742b661df1fc4), {}),
        textEnable: "Afficher les contacts",
        textDisable: "Aucun contact pour ce gestionnaire",
        disable: (row)=>!row.original.listContact || row.original.listContact.length === 0,
        classEnable: "warning"
    });
    if ((0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).GEST_SITE_A)) {
        listeButton.push({
            row: (row)=>{
                return row;
            },
            route: (gestionnaireId)=>(0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).UPDATE_GESTIONNAIRE(gestionnaireId),
            type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).UPDATE
        });
        listeButton.push({
            row: (row)=>{
                return row;
            },
            type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).DELETE,
            pathname: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/gestionnaire/delete/`,
            header: (row)=>"Suppression du gestionnaire " + row.original.gestionnaireLibelle,
            content: (row)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($2d13bf66536e67e2$var$DeleteContent, {
                    row: row
                })
        });
        if ((0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).GEST_CONTACT_A)) listeButton.push({
            row: (row)=>{
                return row;
            },
            route: (gestionnaireId)=>(0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).ADD_CONTACT(gestionnaireId, "gestionnaire"),
            type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).LINK,
            icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$9bc70769102dd23), {}),
            textEnable: "Ajouter un contact",
            classEnable: "warning"
        });
    }
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                    icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$527d32aa1785fdd4), {}),
                    title: "Gestionnaires",
                    right: (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).GEST_SITE_A) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8ad69b89456b65bc$export$2e2bcd8739ae039), {
                        href: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).ADD_GESTIONNAIRE,
                        title: "Ajouter un gestionnaire"
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $9a9eebc3462fba73$export$2e2bcd8739ae039), {
                    query: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/gestionnaire`,
                    columns: [
                        {
                            Header: "Code",
                            accessor: "gestionnaireCode",
                            sortField: "gestionnaireCode",
                            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                                type: "text",
                                name: "gestionnaireCode"
                            })
                        },
                        {
                            Header: "Libell\xe9",
                            accessor: "gestionnaireLibelle",
                            sortField: "gestionnaireLibelle",
                            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                                type: "text",
                                name: "gestionnaireLibelle"
                            })
                        },
                        (0, $b82b937cc97f6f18$export$38dcf858d3ede0e9)({
                            Header: "Actif",
                            accessor: "gestionnaireActif",
                            sortField: "gestionnaireActif",
                            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eed37ff3d3e1f28c$export$2e2bcd8739ae039), {
                                options: (0, $a4f278cac9030fb1$export$2e2bcd8739ae039),
                                name: "gestionnaireActif"
                            })
                        }),
                        (0, $b82b937cc97f6f18$export$36e9f5a475c9f6fc)({
                            Header: "Actions",
                            accessor: "gestionnaireId",
                            buttons: listeButton
                        })
                    ],
                    idName: "tableGestionnaire",
                    filterValuesToVariable: (0, $9d925d541962d76f$export$2e2bcd8739ae039),
                    filterContext: (0, $9a9eebc3462fba73$export$396ef541d9951d45)({
                        gestionnaireCode: undefined,
                        gestionnaireLibelle: undefined,
                        gestionnaireActif: undefined
                    })
                })
            ]
        })
    });
};
var $2d13bf66536e67e2$export$2e2bcd8739ae039 = $2d13bf66536e67e2$var$ListGestionnaire;
const $2d13bf66536e67e2$var$DeleteContent = ({ row: row })=>{
    const peis = row.original.listPei ?? [];
    const contacts = row.original.listContact ?? [];
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            peis.length === 0 ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("p", {
                children: [
                    "\xcates-vous s\xfbr de vouloir supprimer le gestionnaire",
                    " ",
                    row.original.gestionnaireLibelle,
                    " ?"
                ]
            }) : peis.length === 1 ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("p", {
                children: [
                    "Ce gestionnaire est li\xe9 au PEI ",
                    peis[0],
                    ".",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    "Le lien sera supprim\xe9 mais le PEI sera conserv\xe9."
                ]
            }) : /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("p", {
                children: [
                    "Ce gestionnaire est li\xe9 aux PEI suivants.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    "Les liens seront supprim\xe9s mais les PEI seront conserv\xe9s :",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("ul", {
                        children: peis.map((pei, index)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("li", {
                                children: pei
                            }, index))
                    })
                ]
            }),
            contacts.length === 1 ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("p", {
                children: [
                    "Ce gestionnaire est li\xe9 au contact ",
                    contacts[0],
                    ".",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    "La suppression du gestionnaire entra\xeenera la suppression du contact et ses courriers."
                ]
            }) : contacts.length > 1 ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("p", {
                children: [
                    "Ce gestionnaire est li\xe9 aux contacts suivants.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    "La suppression du gestionnaire entra\xeenera la suppression de ces contacts, et leurs courriers :",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("ul", {
                        children: contacts.map((contact, index)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("li", {
                                children: contact
                            }, index))
                    })
                ]
            }) : null
        ]
    });
};












const $f7f591449c45aa5f$var$UpdateGestionnaire = ()=>{
    const { gestionnaireId: gestionnaireId } = (0, $7a844823b04d4282$export$99eaa27ddbbb95ef)();
    const gestionnaireState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/gestionnaire/` + gestionnaireId);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$b51dd496211ae105), {}),
                title: "Mise \xe0 jour d'un gestionnaire"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                initialValues: (0, $01a04f1ee25085c3$export$a5cab80145b70e98)(gestionnaireState?.data),
                validationSchema: (0, $01a04f1ee25085c3$export$c084437b5e3206cd),
                isPost: false,
                submitUrl: `/api/gestionnaire/update/` + gestionnaireId,
                prepareVariables: (values)=>(0, $01a04f1ee25085c3$export$f97400759cfd946)(values),
                redirectUrl: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_GESTIONNAIRE,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $01a04f1ee25085c3$export$2e2bcd8739ae039), {})
            })
        ]
    });
};
var $f7f591449c45aa5f$export$2e2bcd8739ae039 = $f7f591449c45aa5f$var$UpdateGestionnaire;










var $bkJfK = parcelRequire("bkJfK");

var $kc00y = parcelRequire("kc00y");











function $e0b53c5ad3c99ad2$var$generateMetadataProperties(properties) {
    return properties.map((property)=>{
        return `[b]${property.name} : [/b] #${property.name}#\n[br]`;
    }).join("");
}
const $e0b53c5ad3c99ad2$export$a5cab80145b70e98 = (coucheMetadataId, data)=>({
        groupeCoucheId: data?.groupeCoucheId ?? null,
        coucheId: data?.coucheId ?? null,
        coucheMetadataId: coucheMetadataId ?? "",
        coucheMetadataActif: data?.coucheMetadataActif ?? true,
        coucheMetadataPublic: data?.coucheMetadataPublic ?? false,
        coucheMetadataStyle: data?.coucheMetadataStyle ?? null,
        groupeFonctionnaliteIds: data?.groupeFonctionnaliteIds ?? null
    });
const $e0b53c5ad3c99ad2$export$8470ef9d0802da38 = (values, coucheMetadataId)=>({
        coucheMetadataId: coucheMetadataId,
        groupeCoucheId: values.groupeCoucheId,
        coucheId: values.coucheId,
        groupeFonctionnaliteIds: values.groupeFonctionnaliteIds,
        coucheMetadataStyle: values.coucheMetadataStyle,
        coucheMetadataActif: values.coucheMetadataActif,
        coucheMetadataPublic: values.coucheMetadataPublic
    });
const $e0b53c5ad3c99ad2$export$c084437b5e3206cd = (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({
    groupeCoucheId: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
    coucheId: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
    coucheMetadataStyle: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
    groupeFonctionnaliteIds: (0, $ce4de947442b2ab1$export$2f23118c22fb2630)().nullable()
});
const $e0b53c5ad3c99ad2$var$CoucheMetadataForm = ({ coucheInitiale: coucheInitiale })=>{
    const [coucheId, setCoucheId] = (0, $kc00y.useState)(coucheInitiale ?? null);
    const [errorMessage, setErrorMessage] = (0, $kc00y.useState)(null);
    const { handleShowClose: handleShowClose, activesKeys: activesKeys } = (0, $db860d90b4a42fea$export$dae930a4ba30758b)([
        false,
        false
    ]);
    const getError = (0, $kc00y.useCallback)(async (errorPending)=>{
        if (errorPending instanceof Response) return await errorPending?.text();
        return errorPending?.message ?? "An error occurred";
    }, []);
    const { setValues: setValues, setFieldValue: setFieldValue, values: values } = (0, $bkJfK.useFormikContext)();
    const { run: fetchOption, data: describeFeatureType, ...dataLayer } = (0, $8d9ebd8892d8a5f5$export$6326fb4463ae1be4)(`/api/geoserver/describe-feature-type/${coucheId}`, {});
    const properties = (0, $kc00y.useMemo)(()=>{
        if (!describeFeatureType) return [];
        return describeFeatureType.flatMap((df)=>{
            if ("exceptions" in df.paramsCouche) {
                setErrorMessage(df.paramsCouche.exceptions[0].text);
                return [];
            }
            setErrorMessage(null);
            return df.paramsCouche.featureTypes.flatMap((featureType)=>featureType.properties);
        });
    }, [
        describeFeatureType
    ]);
    const queryParam = values.coucheMetadataId ? {
        coucheMetadataId: values.coucheMetadataId
    } : {};
    const coucheData = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/admin/couche-metadata/get-available-layers?${queryParam}`)?.data;
    (0, $kc00y.useEffect)(()=>{
        if (!coucheInitiale) setFieldValue("coucheMetadataStyle", $e0b53c5ad3c99ad2$var$generateMetadataProperties(properties));
    }, [
        setFieldValue,
        coucheInitiale,
        properties
    ]);
    const handleLayerStyleChange = (event)=>{
        if (event.target.value === "") setFieldValue("coucheMetadataStyle", $e0b53c5ad3c99ad2$var$generateMetadataProperties(properties));
        else setFieldValue("coucheMetadataStyle", event.target.value);
    };
    (0, $kc00y.useEffect)(()=>{
        if (dataLayer?.error) getError(dataLayer?.error).then((error)=>{
            setErrorMessage(error);
        });
        else setErrorMessage(null);
    }, [
        getError
    ]);
    (0, $kc00y.useEffect)(()=>{
        if (coucheId) fetchOption();
    }, [
        coucheId,
        fetchOption
    ]);
    if (!coucheData) return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $c21b1c237cfa1d94$export$2e2bcd8739ae039), {});
    // Liste des groupes de couches
    const listGroupeCouche = coucheData.map((groupeCouche)=>({
            id: groupeCouche.groupeCoucheId,
            code: groupeCouche.groupeCoucheCode,
            libelle: groupeCouche.groupeCoucheLibelle,
            listeCouches: groupeCouche.coucheList
        }));
    // On récupère le groupe de couche sélectionné directement depuis values (FormData)
    const selectedGroupeCouche = listGroupeCouche.find((groupeCouche)=>groupeCouche.id === values.groupeCoucheId);
    // Liste des couches en fonction du groupe sélectionné
    let listCouches = [];
    if (selectedGroupeCouche) listCouches = selectedGroupeCouche.listeCouches.map((layer)=>({
            id: layer.coucheId,
            code: layer.coucheCode,
            libelle: layer.coucheLibelle + " (" + layer.coucheCode + ")",
            groupeFonctionnaliteList: layer.groupeFonctionnaliteList
        }));
    // On récupère la couche sélectionnée (valeurs du formulaire)
    const selectedCouche = selectedGroupeCouche?.listeCouches.find((couche)=>couche.coucheId === values.coucheId);
    // Liste des groupes de fonctionnalités en fonction de la couche sélectionnée
    let listGroupeFonctionnalites = [];
    if (selectedCouche) {
        listGroupeFonctionnalites = selectedCouche.groupeFonctionnaliteList.map((groupeFonctionnalite)=>({
                id: groupeFonctionnalite.groupeFonctionnalitesId,
                code: groupeFonctionnalite.groupeFonctionnalitesCode,
                libelle: groupeFonctionnalite.groupeFonctionnalitesLibelle
            }));
        // Tri de la liste des profils droits par libelle
        listGroupeFonctionnalites = listGroupeFonctionnalites.sort((a, b)=>(a?.libelle || "").localeCompare(b?.libelle || ""));
    }
    const paramNotFound = "Aucun param\xe8tre trouv\xe9";
    const params = properties.length ? properties.map((p, idx)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("span", {
            children: [
                "- ",
                p.name,
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {})
            ]
        }, idx)) : null;
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db860d90b4a42fea$export$2e2bcd8739ae039), {
                activesKeys: activesKeys,
                handleShowClose: handleShowClose,
                list: [
                    {
                        header: "Informations g\xe9n\xe9rales",
                        content: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("p", {
                                    children: "Seules les couches requ\xeatant Geoserver sont accessibles dans la liste d\xe9roulante ci-dessous, donc sont exclus les types GeoJSON et OSM."
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("p", {
                                    children: "Une couche ne contenant pas de m\xe9tadonn\xe9es ne peut pas \xeatre enregistr\xe9e."
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("p", {
                                    children: "Les valeurs NULL ne seront pas affich\xe9es dans les m\xe9tadonn\xe9es."
                                })
                            ]
                        })
                    },
                    {
                        header: "Balises disponibles pour la mise en forme",
                        content: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("table", {
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("tbody", {
                                    children: [
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("b", {
                                                        children: "[b]...[/b]"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("td", {
                                                    children: "Texte en gras"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("b", {
                                                        children: "[i]...[/i]"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("td", {
                                                    children: "Texte en italique"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("b", {
                                                        children: "[u]...[/u]"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("td", {
                                                    children: "Texte soulign\xe9"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("b", {
                                                        children: "[br]"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("td", {
                                                    children: "Saut de ligne"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("b", {
                                                        children: "#...#"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("td", {
                                                    children: "Param\xe8tre \xe0 ins\xe9rer"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        })
                    }
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                name: "groupeCoucheId",
                listIdCodeLibelle: listGroupeCouche,
                label: "Groupe de couche",
                required: true,
                setValues: setValues,
                defaultValue: listGroupeCouche.find((e)=>e.id === values?.groupeCoucheId),
                onChange: (value)=>{
                    setFieldValue("groupeCoucheId", value?.id);
                    setFieldValue("coucheId", undefined);
                }
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
                children: errorMessage && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                    className: "text-danger",
                    children: errorMessage
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                name: "coucheId",
                listIdCodeLibelle: listCouches,
                label: "Couche",
                required: true,
                setValues: setValues,
                defaultValue: listCouches.find((e)=>e.id === values?.coucheId),
                onChange: (value)=>{
                    setFieldValue("coucheId", value?.id);
                    setFieldValue("groupeFonctionnaliteIds", undefined);
                    setCoucheId(value?.id);
                }
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$eae70af4b4e3f197), {
                name: "listGroupeFonctionnalites",
                label: "Groupes de fonctionnalit\xe9s",
                options: listGroupeFonctionnalites,
                getOptionValue: (t)=>t.id,
                value: values.groupeFonctionnaliteIds?.map((e)=>listGroupeFonctionnalites.find((p)=>p.id === e)) ?? listGroupeFonctionnalites.filter((e)=>values.groupeFonctionnaliteIds?.includes(e.id)),
                getOptionLabel: (t)=>t.libelle,
                isClearable: true,
                readOnly: values.coucheMetadataPublic,
                required: !values.coucheMetadataPublic,
                onChange: (groupesFonctionnalites)=>{
                    setFieldValue("groupeFonctionnaliteIds", groupesFonctionnalites.map((e)=>e?.id));
                }
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                name: "coucheMetadataActif",
                label: "Actif"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                name: "coucheMetadataPublic",
                label: "Autoriser l'acc\xe8s public",
                onChange: (v)=>{
                    if (v.target.checked === true) setFieldValue("groupeFonctionnaliteIds", null);
                    setFieldValue("coucheMetadataPublic", v.target.checked);
                },
                tooltipText: "Si la case est coch\xe9e, les m\xe9tadonn\xe9es seront accessibles publiquement, y compris par un utilisateur d\xe9connect\xe9."
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                className: "mt-3",
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        md: 4,
                        className: "bg-light border p-2 rounded",
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$340bfce9b4df026b), {}),
                            " Attributs affichables : (",
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("i", {
                                children: "ce sont les attributs fournis par Geoserver lors de l'interrogation de la vue. Assurez-vous qu'ils soient au plus proche de ce que vous voulez afficher en cr\xe9ant une vue Geoserver adapt\xe9e \xe0 vos besoins"
                            }),
                            ")",
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                            " ",
                            params ?? paramNotFound
                        ]
                    }),
                    params !== null && errorMessage === null && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        md: 8,
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$ce9b1cc0c34506d0), {
                            rows: 10,
                            name: "coucheMetadataStyle",
                            readOnly: params === null,
                            label: "M\xe9tadonn\xe9es \xe0 afficher",
                            onChange: handleLayerStyleChange
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                className: "mt-3",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db9b0e6fdb142a4c$export$2e2bcd8739ae039), {
                        disabledValide: params === null || errorMessage !== null,
                        returnLink: true
                    })
                })
            })
        ]
    });
};
var $e0b53c5ad3c99ad2$export$2e2bcd8739ae039 = $e0b53c5ad3c99ad2$var$CoucheMetadataForm;


const $b792a7c7cef2e983$var$CreateCoucheMetadata = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                title: "Ajout des m\xe9tadonn\xe9es",
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$b51dd496211ae105), {})
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                initialValues: (0, $e0b53c5ad3c99ad2$export$a5cab80145b70e98)(),
                prepareVariables: (values)=>(0, $e0b53c5ad3c99ad2$export$8470ef9d0802da38)(values),
                validationSchema: (0, $e0b53c5ad3c99ad2$export$c084437b5e3206cd),
                submitUrl: `/api/admin/couche-metadata/add-couche-metadata`,
                isPost: true,
                redirectUrl: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_COUCHE_METADATA,
                onSubmit: ()=>true,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e0b53c5ad3c99ad2$export$2e2bcd8739ae039), {})
            })
        ]
    });
};
var $b792a7c7cef2e983$export$2e2bcd8739ae039 = $b792a7c7cef2e983$var$CreateCoucheMetadata;


















const $d52e01d02a79dca8$var$filterValuesToVariable = ({ groupeCoucheLibelle: groupeCoucheLibelle, coucheCode: coucheCode, coucheLibelle: coucheLibelle, groupeFonctionnaliteList: groupeFonctionnaliteList, coucheMetadataActif: coucheMetadataActif, coucheMetadataPublic: coucheMetadataPublic })=>{
    const filter = {};
    $d52e01d02a79dca8$var$filterPropertyStyle(filter, groupeCoucheLibelle, "groupeCoucheLibelle");
    $d52e01d02a79dca8$var$filterPropertyStyle(filter, coucheCode, "coucheCode");
    $d52e01d02a79dca8$var$filterPropertyStyle(filter, coucheLibelle, "coucheLibelle");
    $d52e01d02a79dca8$var$filterPropertyStyle(filter, groupeFonctionnaliteList, "groupeFonctionnaliteList");
    $d52e01d02a79dca8$var$filterPropertyStyle(filter, coucheMetadataActif, "coucheMetadataActif");
    $d52e01d02a79dca8$var$filterPropertyStyle(filter, coucheMetadataPublic, "coucheMetadataPublic");
    return filter;
};
var $d52e01d02a79dca8$export$2e2bcd8739ae039 = $d52e01d02a79dca8$var$filterValuesToVariable;
function $d52e01d02a79dca8$var$filterPropertyStyle(filter, value, name) {
    if (value != null && value?.trim().length > 0) filter[name] = value;
}


const $a831bb357ea10201$var$ListCoucheMetadata = ()=>{
    const { user: user } = (0, $e787cde576104469$export$fdc397e486fa83e7)();
    const listeButton = [];
    if ((0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).CARTO_METADATA_A)) listeButton.push({
        row: (row)=>{
            return row;
        },
        classEnable: "info",
        route: (styleId)=>(0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).UPDATE_COUCHE_METADATA(styleId),
        type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).UPDATE
    }, {
        row: (row)=>{
            return row;
        },
        type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).DELETE,
        pathname: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/admin/couche-metadata/delete/`,
        textDisable: "Impossible de supprimer le style"
    });
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$b0c934bdae14c9ef), {}),
                title: "Gestion des m\xe9tadonn\xe9es des couches",
                right: (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_COUCHE_CARTOGRAPHIQUE) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8ad69b89456b65bc$export$2e2bcd8739ae039), {
                    href: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).ADD_COUCHE_METADATA,
                    title: "Ajouter des m\xe9tadonn\xe9es"
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $9a9eebc3462fba73$export$2e2bcd8739ae039), {
                query: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/admin/couche-metadata/get-couches-metadata-table/`,
                columns: [
                    {
                        Header: "Groupe de couche",
                        accessor: "groupeCoucheLibelle",
                        sortField: "groupeCoucheLibelle",
                        Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                            type: "text",
                            name: "groupeCoucheLibelle"
                        })
                    },
                    {
                        Header: "Code de la couche",
                        accessor: "coucheCode",
                        sortField: "coucheCode",
                        Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                            type: "text",
                            name: "coucheCode"
                        })
                    },
                    {
                        Header: "Nom de la couche",
                        accessor: "coucheLibelle",
                        sortField: "coucheLibelle",
                        Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                            type: "text",
                            name: "coucheLibelle"
                        })
                    },
                    {
                        Header: "Groupes affili\xe9s",
                        accessor: "groupeFonctionnaliteList",
                        Cell: (value)=>{
                            return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                children: value?.value.map((item)=>item.groupeFonctionnalitesLibelle).join(", ")
                            });
                        }
                    },
                    (0, $b82b937cc97f6f18$export$38dcf858d3ede0e9)({
                        Header: "Actif",
                        accessor: "coucheMetadataActif",
                        sortField: "coucheMetadataActif",
                        Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eed37ff3d3e1f28c$export$2e2bcd8739ae039), {
                            options: (0, $a4f278cac9030fb1$export$2e2bcd8739ae039),
                            name: "coucheMetadataActif"
                        })
                    }),
                    (0, $b82b937cc97f6f18$export$38dcf858d3ede0e9)({
                        Header: "Public",
                        accessor: "coucheMetadataPublic",
                        sortField: "coucheMetadataPublic",
                        Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eed37ff3d3e1f28c$export$2e2bcd8739ae039), {
                            options: (0, $a4f278cac9030fb1$export$2e2bcd8739ae039),
                            name: "coucheMetadataPublic"
                        })
                    }),
                    (0, $b82b937cc97f6f18$export$36e9f5a475c9f6fc)({
                        Header: "Actions",
                        accessor: "coucheMetadataId",
                        buttons: listeButton
                    })
                ],
                idName: "tableCoucheMetadataId",
                filterValuesToVariable: (0, $d52e01d02a79dca8$export$2e2bcd8739ae039),
                filterContext: (0, $9a9eebc3462fba73$export$396ef541d9951d45)({
                    groupeCoucheLibelle: undefined,
                    coucheLibelle: undefined,
                    groupeFonctionnaliteList: undefined,
                    coucheMetadataActif: undefined,
                    coucheMetadataPublic: undefined
                })
            })
        ]
    });
};
var $a831bb357ea10201$export$2e2bcd8739ae039 = $a831bb357ea10201$var$ListCoucheMetadata;












const $886465b1598df209$var$UpdateCoucheMetadata = ()=>{
    const { coucheMetadataId: coucheMetadataId } = (0, $7a844823b04d4282$export$99eaa27ddbbb95ef)();
    const coucheMetadataState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/admin/couche-metadata/get-couche-metadata/${coucheMetadataId}`)?.data;
    return coucheMetadataState && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                title: "Modification des m\xe9tadonn\xe9es",
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$b51dd496211ae105), {})
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                initialValues: (0, $e0b53c5ad3c99ad2$export$a5cab80145b70e98)(coucheMetadataId, coucheMetadataState),
                prepareVariables: (values)=>(0, $e0b53c5ad3c99ad2$export$8470ef9d0802da38)(values, coucheMetadataId),
                validationSchema: (0, $e0b53c5ad3c99ad2$export$c084437b5e3206cd),
                submitUrl: `/api/admin/couche-metadata/${coucheMetadataId}/update`,
                isPost: true,
                redirectUrl: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_COUCHE_METADATA,
                onSubmit: ()=>true,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e0b53c5ad3c99ad2$export$2e2bcd8739ae039), {
                    coucheInitiale: coucheMetadataState.coucheId
                })
            })
        ]
    });
};
var $886465b1598df209$export$2e2bcd8739ae039 = $886465b1598df209$var$UpdateCoucheMetadata;




var $bkJfK = parcelRequire("bkJfK");








const $4ce42d48179876f4$export$a5cab80145b70e98 = ()=>({
        banniere: null,
        logo: null,
        symbologie: null,
        templateExportCtp: null,
        favicon: null
    });
const $4ce42d48179876f4$export$c084437b5e3206cd = (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({});
const $4ce42d48179876f4$export$f97400759cfd946 = (values)=>{
    const formData = new FormData();
    formData.append("banniere", values.banniere);
    formData.append("logo", values.logo);
    formData.append("symbologie", values.symbologie);
    formData.append("templateExportCtp", values.templateExportCtp);
    formData.append("favicon", values.favicon);
    return formData;
};
const $4ce42d48179876f4$export$bfb425db2787437d = ()=>{
    const { handleShowClose: handleShowClose, activesKeys: activesKeys } = (0, $db860d90b4a42fea$export$dae930a4ba30758b)(Array(4).fill(false));
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                title: "Import des ressources",
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$c9bef5de7ad5da31), {})
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("p", {
                children: [
                    "Cet \xe9cran permet d'importer diff\xe9rentes ressources utiles \xe0 l'outil. Chaque bloc (",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("i", {
                        children: "accord\xe9on"
                    }),
                    ") est ind\xe9pendant, et poss\xe8de son propre bouton d'import."
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db860d90b4a42fea$export$2e2bcd8739ae039), {
                activesKeys: activesKeys,
                handleShowClose: handleShowClose,
                list: [
                    {
                        header: "Importer la banni\xe8re",
                        content: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("p", {
                                    children: [
                                        "Permet d'importer le fichier image correspondant \xe0 la banni\xe8re, au moins pr\xe9sent dans le bandeau (cf page d'accueil) et la page de connexion. ",
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                                        "Pour des raisons des performance, il conviendra d'avoir une taille minimale pour le visuel souhait\xe9 (max 200px de haut)."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                                    initialValues: $4ce42d48179876f4$export$a5cab80145b70e98(),
                                    validationSchema: $4ce42d48179876f4$export$c084437b5e3206cd,
                                    isPost: false,
                                    isMultipartFormData: true,
                                    submitUrl: `/api/admin/import-banniere`,
                                    prepareVariables: (values)=>$4ce42d48179876f4$export$f97400759cfd946(values),
                                    redirectUrl: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).ADMIN_IMPORT_RESSOURCES,
                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($4ce42d48179876f4$var$FormImportBanniere, {})
                                })
                            ]
                        })
                    },
                    {
                        header: "Importer le logo",
                        content: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("p", {
                                    children: [
                                        "Permet d'importer le fichier image correspondant au logo, au moins pr\xe9sent dans le bandeau (cf page d'accueil) et la page de connexion. ",
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                                        "Pour des raisons des performance, il conviendra d'avoir une taille minimale pour le visuel souhait\xe9 (max 200px de haut)."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                                    initialValues: $4ce42d48179876f4$export$a5cab80145b70e98(),
                                    validationSchema: $4ce42d48179876f4$export$c084437b5e3206cd,
                                    isPost: false,
                                    isMultipartFormData: true,
                                    submitUrl: `/api/admin/import-logo`,
                                    prepareVariables: (values)=>$4ce42d48179876f4$export$f97400759cfd946(values),
                                    redirectUrl: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).ADMIN_IMPORT_RESSOURCES,
                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($4ce42d48179876f4$var$FormImportLogo, {})
                                })
                            ]
                        })
                    },
                    {
                        header: "Importer le favicon",
                        content: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("p", {
                                    children: "Permet d'importer le fichier image correspondant au favicon, La taille recommand\xe9e est de 32x32 pixels."
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                                    initialValues: $4ce42d48179876f4$export$a5cab80145b70e98(),
                                    validationSchema: $4ce42d48179876f4$export$c084437b5e3206cd,
                                    isPost: false,
                                    isMultipartFormData: true,
                                    submitUrl: `/api/admin/import-favicon`,
                                    prepareVariables: (values)=>$4ce42d48179876f4$export$f97400759cfd946(values),
                                    redirectUrl: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).ADMIN_IMPORT_RESSOURCES,
                                    onSubmit: ()=>window.location.reload(),
                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($4ce42d48179876f4$var$FormImportFavicon, {})
                                })
                            ]
                        })
                    },
                    {
                        header: "Importer la symbologie",
                        content: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("p", {
                                    children: [
                                        "Cette fonctionnalit\xe9 permet d'envoyer sur le serveur les images correspondant \xe0 la symbologie des PEI ; ",
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                                        "l'archive \xe0 envoyer contiendra \xe0 plat tous les fichiers image correctement nomm\xe9s afin que le m\xe9canisme Geoserver puisse correctement faire le mapping sur la carte."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                                    initialValues: $4ce42d48179876f4$export$a5cab80145b70e98(),
                                    validationSchema: $4ce42d48179876f4$export$c084437b5e3206cd,
                                    isPost: false,
                                    isMultipartFormData: true,
                                    submitUrl: `/api/admin/import-symbologie`,
                                    prepareVariables: (values)=>$4ce42d48179876f4$export$f97400759cfd946(values),
                                    redirectUrl: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).ADMIN_IMPORT_RESSOURCES,
                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($4ce42d48179876f4$var$FormImportSymbologie, {})
                                })
                            ]
                        })
                    },
                    {
                        header: "Importer le mod\xe8le d'Import-CTP",
                        content: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("p", {
                                    children: [
                                        "Permet d'importer le fichier .xlsx utilis\xe9 pour la fonctionnalit\xe9 d'import CTP.",
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                                        "Ce fichier sera ensuite compl\xe9t\xe9 automatiquement par l'application \xe0 l'aide des informations g\xe9n\xe9rales des PEI lors d'un export.",
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                                        "Attention, cette fonctionnalit\xe9 s'appuyant sur un fichier XLSX avec des pseudo-contrats qui ne peuvent pas \xeatre garantis, elle est \xe0 utiliser uniquement lorsque les m\xe9thodes plus robustes ne sont pas applicables."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                                    initialValues: $4ce42d48179876f4$export$a5cab80145b70e98(),
                                    validationSchema: $4ce42d48179876f4$export$c084437b5e3206cd,
                                    isPost: false,
                                    isMultipartFormData: true,
                                    submitUrl: `/api/admin/depot-template-ctp`,
                                    prepareVariables: (values)=>$4ce42d48179876f4$export$f97400759cfd946(values),
                                    redirectUrl: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).ADMIN_IMPORT_RESSOURCES,
                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($4ce42d48179876f4$var$FormImportTemplateExportCTP, {})
                                })
                            ]
                        })
                    }
                ]
            })
        ]
    });
};
const $4ce42d48179876f4$var$FormImportBanniere = ()=>{
    const { setFieldValue: setFieldValue } = (0, $bkJfK.useFormikContext)();
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b57af79a4ab2a1c6), {
                name: "banniere",
                required: true,
                onChange: (e)=>setFieldValue("banniere", e.target.files[0])
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                className: "mt-3",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                    className: "text-center",
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                        type: "submit",
                        variant: "primary",
                        children: "Importer la banni\xe8re"
                    })
                })
            })
        ]
    });
};
const $4ce42d48179876f4$var$FormImportLogo = ()=>{
    const { setFieldValue: setFieldValue } = (0, $bkJfK.useFormikContext)();
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b57af79a4ab2a1c6), {
                name: "logo",
                required: true,
                onChange: (e)=>setFieldValue("logo", e.target.files[0])
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                className: "mt-3",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                    className: "text-center",
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                        type: "submit",
                        variant: "primary",
                        children: "Importer le logo"
                    })
                })
            })
        ]
    });
};
const $4ce42d48179876f4$var$FormImportSymbologie = ()=>{
    const { setFieldValue: setFieldValue } = (0, $bkJfK.useFormikContext)();
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b57af79a4ab2a1c6), {
                name: "symbologie",
                required: true,
                accept: ".zip",
                onChange: (e)=>setFieldValue("symbologie", e.target.files[0])
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                className: "mt-3",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                    className: "text-center",
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                        type: "submit",
                        variant: "primary",
                        children: "Importer la symbologie"
                    })
                })
            })
        ]
    });
};
const $4ce42d48179876f4$var$FormImportTemplateExportCTP = ()=>{
    const { setFieldValue: setFieldValue } = (0, $bkJfK.useFormikContext)();
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b57af79a4ab2a1c6), {
                name: "templateExportCtp",
                accept: ".xlsx",
                required: true,
                onChange: (e)=>setFieldValue("templateExportCtp", e.target.files[0])
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                className: "mt-3",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                    className: "text-center",
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                        type: "submit",
                        variant: "primary",
                        children: "Importer le support"
                    })
                })
            })
        ]
    });
};
const $4ce42d48179876f4$var$FormImportFavicon = ()=>{
    const { setFieldValue: setFieldValue } = (0, $bkJfK.useFormikContext)();
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b57af79a4ab2a1c6), {
                name: "favicon",
                accept: ".png",
                required: true,
                onChange: (e)=>setFieldValue("favicon", e.target.files[0])
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                className: "mt-3",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                    className: "text-center",
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                        type: "submit",
                        variant: "primary",
                        children: "Importer le favicon"
                    })
                })
            })
        ]
    });
};









var $3ba7c490e4fafdb9$var$LOG_LINE_GRAVITY = /*#__PURE__*/ function(LOG_LINE_GRAVITY) {
    LOG_LINE_GRAVITY["INFO"] = "INFO";
    LOG_LINE_GRAVITY["WARN"] = "WARN";
    LOG_LINE_GRAVITY["ERROR"] = "ERROR";
    return LOG_LINE_GRAVITY;
}($3ba7c490e4fafdb9$var$LOG_LINE_GRAVITY || {});
var $3ba7c490e4fafdb9$export$2e2bcd8739ae039 = $3ba7c490e4fafdb9$var$LOG_LINE_GRAVITY;




const $92b1faff34a2eac5$var$filterValuesToVariable = ({ logLineGravity: logLineGravity })=>{
    const filter = {};
    $92b1faff34a2eac5$var$filterProperty(filter, logLineGravity, "logLineGravity");
    return filter;
};
var $92b1faff34a2eac5$export$2e2bcd8739ae039 = $92b1faff34a2eac5$var$filterValuesToVariable;
function $92b1faff34a2eac5$var$filterProperty(filter, value, name) {
    if (value != null && value.trim() !== "") filter[name] = value;
}


const $0df6cafa8bb5af73$var$LogLines = ()=>{
    const { jobId: jobId } = (0, $7a844823b04d4282$export$99eaa27ddbbb95ef)();
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                    title: "D\xe9tails de l'ex\xe9cution du job " + jobId,
                    icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$527d32aa1785fdd4), {})
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
                fluid: true,
                className: "px-5",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $9a9eebc3462fba73$export$2e2bcd8739ae039), {
                    query: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/jobs/log-lines/${jobId}`,
                    filterValuesToVariable: (0, $92b1faff34a2eac5$export$2e2bcd8739ae039),
                    filterContext: (0, $9a9eebc3462fba73$export$396ef541d9951d45)({}),
                    idName: "ListLogLines",
                    columns: [
                        {
                            Header: "Date",
                            accessor: "logLineDate",
                            sortField: "logLineDate",
                            Cell: (value)=>{
                                return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                    children: value?.value != null && (0, $00c47c7740afd024$export$2e2bcd8739ae039)(value.value)
                                });
                            },
                            width: 200
                        },
                        {
                            Header: "Niveau de gravit\xe9",
                            accessor: "logLineGravity",
                            sortField: "logLineGravity",
                            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eed37ff3d3e1f28c$export$2e2bcd8739ae039), {
                                options: (0, $3ba7c490e4fafdb9$export$2e2bcd8739ae039),
                                name: "logLineGravity"
                            }),
                            width: 200
                        },
                        {
                            Header: "Message",
                            accessor: "logLineMessage"
                        }
                    ]
                })
            })
        ]
    });
};
var $0df6cafa8bb5af73$export$2e2bcd8739ae039 = $0df6cafa8bb5af73$var$LogLines;




var $bkJfK = parcelRequire("bkJfK");







/**
 * Enumération définissant les états de jobs.
 */ var $d93da67bdbf7edb6$var$EtatJobEnum = /*#__PURE__*/ function(EtatJobEnum) {
    EtatJobEnum["EN_COURS"] = "En cours";
    EtatJobEnum["TERMINE"] = "Termin\xe9";
    EtatJobEnum["NOTIFIE"] = "Notifi\xe9";
    EtatJobEnum["EN_ERREUR"] = "En erreur";
    return EtatJobEnum;
}($d93da67bdbf7edb6$var$EtatJobEnum || {});
var $d93da67bdbf7edb6$export$2e2bcd8739ae039 = $d93da67bdbf7edb6$var$EtatJobEnum;


var $ba31bf1fada5b2ce$export$bae12dea55379e0c = /*#__PURE__*/ function(TYPE_TASK_PARAMETRE) {
    TYPE_TASK_PARAMETRE["INTEGER"] = "integer";
    TYPE_TASK_PARAMETRE["BOOLEAN"] = "boolean";
    TYPE_TASK_PARAMETRE["STRING"] = "string";
    TYPE_TASK_PARAMETRE["LISTE_TABLE_SYNCHRO_SIG"] = "listeTableSynchroSIG";
    return TYPE_TASK_PARAMETRE;
}({});
var $ba31bf1fada5b2ce$export$b9160f7787a65b1e = /*#__PURE__*/ function(TYPE_CHAMPS_UPDATE_SYNCHRO_COMMUNE) {
    TYPE_CHAMPS_UPDATE_SYNCHRO_COMMUNE["LIBELLE"] = "Libell\xe9";
    TYPE_CHAMPS_UPDATE_SYNCHRO_COMMUNE["CODE_POSTAL"] = "Code postal";
    TYPE_CHAMPS_UPDATE_SYNCHRO_COMMUNE["GEOMETRIE"] = "G\xe9om\xe9trie";
    TYPE_CHAMPS_UPDATE_SYNCHRO_COMMUNE["PPRIF"] = "PPRIF";
    TYPE_CHAMPS_UPDATE_SYNCHRO_COMMUNE["CODE"] = "Code";
    return TYPE_CHAMPS_UPDATE_SYNCHRO_COMMUNE;
}({});
var $ba31bf1fada5b2ce$export$acdf2b5a316b9b1 = /*#__PURE__*/ function(TYPE_SYNCHRONISATION_TABLE_SIG) {
    TYPE_SYNCHRONISATION_TABLE_SIG["MISE_A_JOUR_REMOCRA_COMMUNE"] = "Mise \xe0 jour REMOCRA.COMMUNE";
    TYPE_SYNCHRONISATION_TABLE_SIG["MISE_A_JOUR_REMOCRA_VOIE"] = "Mise \xe0 jour REMOCRA.VOIE";
    TYPE_SYNCHRONISATION_TABLE_SIG["MISE_A_JOUR_DFCI_CATEGORIE_PISTE"] = "Mise \xe0 jour REMOCRA.DFCI_CATEGORIE_PISTE";
    TYPE_SYNCHRONISATION_TABLE_SIG["MISE_A_JOUR_DFCI_MASSIF"] = "Mise \xe0 jour REMOCRA.DFCI_MASSIF";
    TYPE_SYNCHRONISATION_TABLE_SIG["MISE_A_JOUR_DFCI_PRESTATAIRE"] = "Mise \xe0 jour REMOCRA.DFCI_PRESTATAIRE";
    TYPE_SYNCHRONISATION_TABLE_SIG["MISE_A_JOUR_DFCI_OUVRAGE"] = "Mise \xe0 jour REMOCRA.DFCI_OUVRAGE";
    TYPE_SYNCHRONISATION_TABLE_SIG["MISE_A_JOUR_REMOCRA_DFCI_PISTE"] = "Mise \xe0 jour REMOCRA.DFCI_PISTE";
    TYPE_SYNCHRONISATION_TABLE_SIG["MISE_A_JOUR_REMOCRA_DFCI_AIRE"] = "Mise \xe0 jour REMOCRA.DFCI_AIRE";
    TYPE_SYNCHRONISATION_TABLE_SIG["MISE_A_JOUR_REMOCRA_DFCI_DEB"] = "Mise \xe0 jour REMOCRA.DFCI_DEB";
    TYPE_SYNCHRONISATION_TABLE_SIG["MISE_A_JOUR_REMOCRA_DFCI_PANNEAU"] = "Mise \xe0 jour REMOCRA.DFCI_PANNEAU";
    TYPE_SYNCHRONISATION_TABLE_SIG["STOCKAGE_SIMPLE"] = "Stockage simple";
    return TYPE_SYNCHRONISATION_TABLE_SIG;
}({});


const $bd5f3039059066bc$var$TaskType = {
    SYNCHRO_UTILISATEUR: {
        id: "SYNCHRO_UTILISATEUR",
        code: "SynchroUtilisateurTask",
        label: "Synchronisation des utilisateurs",
        commentaire: "",
        parametre: {
            canSuppressUser: {
                typeTaskParametre: (0, $ba31bf1fada5b2ce$export$bae12dea55379e0c).BOOLEAN,
                required: false,
                label: "Supprimer les utilisateurs :",
                tooltipMessage: ""
            },
            accepteUserSansEmail: {
                typeTaskParametre: (0, $ba31bf1fada5b2ce$export$bae12dea55379e0c).BOOLEAN,
                required: false,
                label: "Accepter les utilisateurs sans email :",
                tooltipMessage: ""
            },
            emailParDefaut: {
                typeTaskParametre: (0, $ba31bf1fada5b2ce$export$bae12dea55379e0c).STRING,
                required: false,
                label: "Email par d\xe9faut :",
                tooltipMessage: "Est utile si la case 'Accepter les utilisateurs sans email' est coch\xe9e. Correspond \xe0 l'email qui sera utilis\xe9e pour les utilisateurs sans adresse mail lors de la synchronisation."
            },
            prefixeLdapOrganismeCode: {
                typeTaskParametre: (0, $ba31bf1fada5b2ce$export$bae12dea55379e0c).STRING,
                required: false,
                label: "Pr\xe9fixe utilis\xe9 dans LDAP pour code de l'organisme :",
                tooltipMessage: "Permettra de faire correspondre les codes utilis\xe9s dans LDAP avec ceux de REMOcRA : le syst\xe8me enl\xe8vera ce pr\xe9fixe lors de la synchronisation."
            },
            prefixeLdapProfilUtilisateurCode: {
                typeTaskParametre: (0, $ba31bf1fada5b2ce$export$bae12dea55379e0c).STRING,
                required: false,
                label: "Pr\xe9fixe utilis\xe9 dans LDAP pour code du profil utilisateur :",
                tooltipMessage: "Permettra de faire correspondre les codes utilis\xe9s dans LDAP avec ceux de REMOcRA : le syst\xe8me enl\xe8vera ce pr\xe9fixe lors de la synchronisation."
            },
            suffixeLdapOrganismeCode: {
                typeTaskParametre: (0, $ba31bf1fada5b2ce$export$bae12dea55379e0c).STRING,
                required: false,
                label: "Suffixe utilis\xe9 dans LDAP pour code de l'organisme :",
                tooltipMessage: "Permettra de faire correspondre les codes utilis\xe9s dans LDAP avec ceux de REMOcRA : le syst\xe8me enl\xe8vera ce suffixe lors de la synchronisation."
            },
            suffixeLdapProfilUtilisateurCode: {
                typeTaskParametre: (0, $ba31bf1fada5b2ce$export$bae12dea55379e0c).STRING,
                required: false,
                label: "Suffixe utilis\xe9 dans LDAP pour code du profil utilisateur :",
                tooltipMessage: "Permettra de faire correspondre les codes utilis\xe9s dans LDAP avec ceux de REMOcRA : le syst\xe8me enl\xe8vera ce suffixe lors de la synchronisation."
            }
        },
        notification: false,
        isConfigurable: true
    },
    NOTIFIER_CHANGEMENTS_ETAT: {
        id: "NOTIFIER_CHANGEMENTS_ETAT",
        code: "ChangementEtatPeiTask",
        label: "Changement d'\xe9tat des PEI",
        commentaire: "",
        parametre: {},
        notification: true,
        isConfigurable: true
    },
    IT_NOTIF_AVANT_DEBUT: {
        id: "IT_NOTIF_AVANT_DEBUT",
        code: "NotifAvantDebutIndispoTempTask",
        label: "Notifier avant le d\xe9but d'une IT",
        commentaire: "",
        parametre: {
            deltaMinuteNotificationDebut: {
                typeTaskParametre: (0, $ba31bf1fada5b2ce$export$bae12dea55379e0c).INTEGER,
                required: true,
                label: "D\xe9lai de r\xe9cup\xe9ration des \xe9v\xe8nements (en minutes) :",
                tooltipMessage: "Doit \xeatre en ad\xe9quation avec la fr\xe9quence d'ex\xe9cution de la t\xe2che."
            }
        },
        notification: true,
        isConfigurable: true
    },
    IT_NOTIF_AVANT_FIN: {
        id: "IT_NOTIF_AVANT_FIN",
        code: "NotifAvantFinIndispoTempTask",
        label: "Notifier avant la fin d'une IT",
        commentaire: "",
        parametre: {
            deltaMinuteNotificationFin: {
                typeTaskParametre: (0, $ba31bf1fada5b2ce$export$bae12dea55379e0c).INTEGER,
                required: true,
                label: "D\xe9lai de r\xe9cup\xe9ration des \xe9v\xe8nements (en minutes) :",
                tooltipMessage: "Doit \xeatre en ad\xe9quation avec la fr\xe9quence d'ex\xe9cution de la t\xe2che."
            }
        },
        notification: true,
        isConfigurable: true
    },
    IT_NOTIF_RESTE_INDISPO: {
        id: "IT_NOTIF_RESTE_INDISPO",
        code: "NotifResteIndispoIndispoTempTask",
        label: "Notifier les PEI rest\xe9s indisponibles apr\xe8s la lev\xe9e d'une IT",
        commentaire: "",
        parametre: {},
        notification: true,
        isConfigurable: true
    },
    BASCULE_AUTO_INDISPO_TEMP: {
        id: "BASCULE_AUTO_INDISPO_TEMP",
        code: "BasculeAutoIndispoTempTask",
        label: "Bascule automatique des indisponibilit\xe9s temporaires",
        commentaire: "Cette t\xe2che est n\xe9cessaire au bon fonctionnement des indisponibilit\xe9s temporaires.\nSi celle-ci n'est pas active, le statut de disponibilit\xe9 des PEI ne sera pas mis \xe0 jour automatiquement au d\xe9part ou \xe0 la lev\xe9e d'une indisponibilit\xe9 temporaire.",
        parametre: {},
        notification: false,
        isConfigurable: true
    },
    SYNCHRONISATION_SIG: {
        id: "SYNCHRONISATION_SIG",
        code: "SynchronisationSIGTask",
        label: "Synchronisation SIG vers REMOcRA",
        commentaire: "",
        parametre: {
            batchInsert: {
                typeTaskParametre: (0, $ba31bf1fada5b2ce$export$bae12dea55379e0c).INTEGER,
                required: true,
                label: "Nombre de donn\xe9es \xe0 ins\xe9rer par batch :",
                tooltipMessage: "Un nombre trop \xe9lev\xe9 peut entra\xeener des probl\xe8mes de m\xe9moire, un nombre trop faible peut ralentir la synchronisation."
            },
            listeTableASynchroniser: {
                typeTaskParametre: (0, $ba31bf1fada5b2ce$export$bae12dea55379e0c).LISTE_TABLE_SYNCHRO_SIG,
                required: true,
                label: "",
                tooltipMessage: ""
            }
        },
        notification: false,
        isConfigurable: true
    },
    PURGER: {
        id: "PURGER",
        code: "PurgerTask",
        label: "Purge",
        commentaire: "Permet de purger le contenu du r\xe9pertoire /Document/tmp/. Seuls les \xe9l\xe9ments datant de moins de 24h seront conserv\xe9s.\nPermet de purger les informations relatives \xe0 l'ex\xe9cution des t\xe2ches termin\xe9es.",
        parametre: {
            purgerDocumentTemp: {
                typeTaskParametre: (0, $ba31bf1fada5b2ce$export$bae12dea55379e0c).BOOLEAN,
                required: false,
                label: "Activer la suppresion des \xe9l\xe9ments du r\xe9pertoire /Document/tmp/ :",
                tooltipMessage: "Seuls les \xe9l\xe9ments datant de moins de 24h seront conserv\xe9s."
            },
            purgerJobTermine: {
                typeTaskParametre: (0, $ba31bf1fada5b2ce$export$bae12dea55379e0c).BOOLEAN,
                required: false,
                label: "Activer la suppresion des informations d'ex\xe9cution des t\xe2ches termin\xe9es :",
                tooltipMessage: "Les logs des t\xe2ches en erreur seront conserv\xe9s"
            },
            purgerJobJours: {
                typeTaskParametre: (0, $ba31bf1fada5b2ce$export$bae12dea55379e0c).INTEGER,
                required: false,
                label: "D\xe9lai de conservation des informations d'ex\xe9cution des t\xe2ches termin\xe9es (en jours) :",
                tooltipMessage: "Les logs des t\xe2ches en erreur seront conserv\xe9s. Les logs des t\xe2ches Termin\xe9e, Notifi\xe9 et bloqu\xe9es au statut En cours seront supprim\xe9s si la date d'ex\xe9cution est ant\xe9rieure \xe0 ce param\xe8tre."
            }
        },
        notification: false,
        isConfigurable: true
    },
    PERSONNALISE: {
        id: "PERSONNALISE",
        code: "personnalisee",
        label: "T\xe2che personnalis\xe9e",
        commentaire: "",
        parametre: {
            taskLibelle: {
                typeTaskParametre: (0, $ba31bf1fada5b2ce$export$bae12dea55379e0c).STRING,
                required: true,
                label: "Libell\xe9 de la t\xe2che sp\xe9cifique"
            },
            taskCode: {
                typeTaskParametre: (0, $ba31bf1fada5b2ce$export$bae12dea55379e0c).STRING,
                required: true,
                label: "Nom du worflow dans Apache HOP",
                tooltipMessage: "Il s'agit g\xe9n\xe9ralement du nom du fichier. Vous pouvez ouvrir le fichier xml et reprendre la valeur qui est dans la balise <name> (3\xe8me ligne)"
            }
        },
        notification: false,
        isConfigurable: false
    },
    RELANCER_CALCUL_DISPONIBILITE: {
        id: "RELANCER_CALCUL_DISPONIBILITE",
        code: "RELANCER_CALCUL_DISPONIBILITE",
        label: "Relancer le calcul de disponibilit\xe9",
        commentaire: "",
        parametre: {},
        notification: false,
        isConfigurable: false
    },
    RELANCER_CALCUL_NUMEROTATION: {
        id: "RELANCER_CALCUL_NUMEROTATION",
        code: "RELANCER_CALCUL_NUMEROTATION",
        label: "Relancer le calcul de la num\xe9rotation",
        commentaire: "",
        parametre: {},
        notification: false,
        isConfigurable: false
    },
    INTEGRER_INCOMING_REMOCRA: {
        id: "INTEGRER_INCOMING_REMOCRA",
        code: "INTEGRER_INCOMING_REMOCRA",
        label: "Mobile - Int\xe9grer une tourn\xe9e (incoming vers remocra)",
        commentaire: "",
        parametre: {},
        notification: false,
        isConfigurable: false
    },
    INTEGRER_INCOMING_NEW_PEI_REMOCRA: {
        id: "INTEGRER_INCOMING_NEW_PEI_REMOCRA",
        code: "INTEGRER_INCOMING_NEW_PEI_REMOCRA",
        label: "Mobile - Int\xe9grer un nouveau PEI (incoming vers remocra)",
        commentaire: "",
        parametre: {},
        notification: false,
        isConfigurable: false
    },
    INTEGRER_INCOMING_GESTIONNAIRE_REMOCRA: {
        id: "INTEGRER_INCOMING_GESTIONNAIRE_REMOCRA",
        code: "INTEGRER_INCOMING_GESTIONNAIRE_REMOCRA",
        label: "Mobile - Int\xe9grer un gestionnaire & ses contacts (incoming vers remocra)",
        commentaire: "",
        parametre: {},
        notification: false,
        isConfigurable: false
    },
    MOBILE_EXPORT_LOG: {
        id: "MOBILE_EXPORT_LOG",
        code: "MOBILE_EXPORT_LOG",
        label: "Mobile - Exporter les logs de l'application mobile",
        commentaire: "",
        parametre: {},
        notification: false,
        isConfigurable: false
    },
    IMPORT_CADASTRE: {
        id: "IMPORT_CADASTRE",
        code: "IMPORT_CADASTRE",
        label: "Import des donn\xe9es cadastrales",
        commentaire: "",
        parametre: {},
        notification: false,
        isConfigurable: false
    },
    IMPORTER_CTP: {
        id: "IMPORTER_CTP",
        code: "IMPORTER_CTP",
        label: "Import CTP - Enregistrement des visites",
        commentaire: "",
        parametre: {},
        notification: false,
        isConfigurable: false
    }
};
var $bd5f3039059066bc$export$2e2bcd8739ae039 = $bd5f3039059066bc$var$TaskType;




const $9d99f3c977296a25$var$filterValuesToVariable = ({ typeTask: typeTask, etatJob: etatJob })=>{
    const filter = {};
    $9d99f3c977296a25$var$filterPropertyEtude(filter, typeTask, "typeTask");
    $9d99f3c977296a25$var$filterPropertyEtude(filter, etatJob, "etatJob");
    return filter;
};
var $9d99f3c977296a25$export$2e2bcd8739ae039 = $9d99f3c977296a25$var$filterValuesToVariable;
function $9d99f3c977296a25$var$filterPropertyEtude(filter, value, name) {
    if (value != null && value.trim() !== "") filter[name] = value;
}


const $695d25d5da8e5277$var$ResultatsExecution = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                title: "R\xe9sultats d'ex\xe9cution",
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$527d32aa1785fdd4), {})
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $bkJfK.Formik), {
                initialValues: {
                    typeTache: ""
                },
                onSubmit: ()=>null,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($695d25d5da8e5277$var$FormTable, {})
            })
        ]
    });
};
var $695d25d5da8e5277$export$2e2bcd8739ae039 = $695d25d5da8e5277$var$ResultatsExecution;
const $695d25d5da8e5277$var$FormTable = ()=>{
    const listeButton = [];
    listeButton.push({
        row: (row)=>{
            return row;
        },
        route: (jobId)=>(0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).RESULTATS_EXECUTION_LOGLINES(jobId),
        type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).SEE
    });
    const listeTypeTask = Object.entries((0, $bd5f3039059066bc$export$2e2bcd8739ae039)).map(([, e])=>({
            id: e.id,
            code: e.code,
            libelle: e.label
        }));
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $9a9eebc3462fba73$export$2e2bcd8739ae039), {
        query: "/api/jobs/list",
        getCount: (data)=>data?.count ?? 0,
        getList: (data)=>data?.list ?? [],
        columns: [
            {
                Header: "Type de t\xe2che",
                accessor: "typeTask",
                sortField: "typeTask",
                Cell: (value)=>{
                    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                        children: (0, $bd5f3039059066bc$export$2e2bcd8739ae039)[value?.value]?.label ?? value?.value
                    });
                },
                Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $3744b2a772efdf44$export$2e2bcd8739ae039), {
                    listIdCodeLibelle: listeTypeTask.sort((a, b)=>a.libelle.localeCompare(b.libelle)),
                    name: "typeTask"
                })
            },
            {
                Header: "Date de d\xe9but",
                accessor: "jobDateDebut",
                sortField: "jobDateDebut",
                Cell: (value)=>{
                    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                        children: value?.value != null && (0, $00c47c7740afd024$export$2e2bcd8739ae039)(value.value)
                    });
                }
            },
            {
                Header: "Date de fin",
                accessor: "jobDateFin",
                sortField: "jobDateFin",
                Cell: (value)=>{
                    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                        children: value?.value != null && (0, $00c47c7740afd024$export$2e2bcd8739ae039)(value.value)
                    });
                }
            },
            {
                Header: "\xc9tat",
                accessor: "jobEtatJob",
                sortField: "jobEtatJob",
                Cell: (value)=>{
                    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                        children: (0, $d93da67bdbf7edb6$export$2e2bcd8739ae039)[value?.value] ?? value?.value
                    });
                },
                Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eed37ff3d3e1f28c$export$2e2bcd8739ae039), {
                    options: (0, $d93da67bdbf7edb6$export$2e2bcd8739ae039),
                    name: "etatJob"
                })
            },
            (0, $b82b937cc97f6f18$export$36e9f5a475c9f6fc)({
                Header: "Actions",
                accessor: "jobId",
                buttons: listeButton
            })
        ],
        idName: "jobTable",
        filterValuesToVariable: (0, $9d99f3c977296a25$export$2e2bcd8739ae039),
        filterContext: (0, $9a9eebc3462fba73$export$396ef541d9951d45)({
            typeTask: undefined,
            etatJob: undefined
        }),
        queryParams: [],
        asyncOptions: []
    });
};









const $d324e040d6d3784b$var$MenuAdmin = ()=>{
    const { user: user } = (0, $e787cde576104469$export$fdc397e486fa83e7)();
    const hasDroitAdministrationGenerale = (0, $e3b8d60f4bb99483$export$4f612ab7b7b1d133)(user, [
        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_COURRIER,
        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_PARAM_APPLI,
        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_PARAM_APPLI_MOBILE,
        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_ZONE_COMPETENCE,
        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_RAPPORTS_PERSO,
        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_PARAM_TRAITEMENTS,
        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_ANOMALIES,
        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ATLAS_A,
        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ATLAS_C,
        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ATLAS_D
    ]);
    const hasDroitGererLesDroits = (0, $e3b8d60f4bb99483$export$4f612ab7b7b1d133)(user, [
        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_DROITS,
        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_UTILISATEURS_A,
        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_UTILISATEURS_R,
        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_UTILISATEURS_ORGA_A,
        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_UTILISATEURS_ORGA_R,
        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_COUCHE_CARTOGRAPHIQUE,
        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_API,
        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_ORGANISME_R,
        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_ORGANISME_A,
        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ORGANISME_CONTACT_A
    ]);
    const hasDroitGererLesNomenclatures = (0, $e3b8d60f4bb99483$export$4f612ab7b7b1d133)(user, [
        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE,
        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_ROLE_CONTACT,
        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_PARAM_APPLI,
        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_TYPE_ETUDE
    ]);
    const hasDroitGestionnairesEtSites = (0, $e3b8d60f4bb99483$export$4f612ab7b7b1d133)(user, [
        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).GEST_SITE_A,
        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).GEST_SITE_R
    ]);
    const hasDroitTableauxDeBord = (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).DASHBOARD_A);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            (hasDroitAdministrationGenerale || hasDroitGererLesDroits || hasDroitGererLesNomenclatures) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: [
                    hasDroitAdministrationGenerale && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        className: "bg-light p-2 border rounded mx-2",
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                className: "fw-bold text-center p-2 fs-5",
                                children: "Administration g\xe9n\xe9rale"
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $b9d4d12a3c294259$export$2e2bcd8739ae039), {
                                className: "flex-column",
                                children: [
                                    ((0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_PARAM_APPLI) || (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_PARAM_APPLI_MOBILE)) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b9d4d12a3c294259$export$2e2bcd8739ae039).Item, {
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $43f579690a1c166d$export$2e2bcd8739ae039), {
                                            className: "text-underline text-start",
                                            pathname: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).ADMIN_PARAMETRE,
                                            children: "Param\xe8tres applicatifs"
                                        })
                                    }),
                                    (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_PARAM_APPLI) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b9d4d12a3c294259$export$2e2bcd8739ae039).Item, {
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $43f579690a1c166d$export$2e2bcd8739ae039), {
                                            className: "text-underline text-start",
                                            pathname: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).ADMIN_FICHE_RESUME,
                                            children: "Configurer la fiche de r\xe9sum\xe9 des PEI"
                                        })
                                    }),
                                    (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_PARAM_APPLI) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b9d4d12a3c294259$export$2e2bcd8739ae039).Item, {
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $43f579690a1c166d$export$2e2bcd8739ae039), {
                                            className: "text-underline text-start",
                                            pathname: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).ADMIN_ACCUEIL,
                                            children: "Configurer la page d'accueil"
                                        })
                                    }),
                                    (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_ZONE_COMPETENCE) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b9d4d12a3c294259$export$2e2bcd8739ae039).Item, {
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $43f579690a1c166d$export$2e2bcd8739ae039), {
                                            className: "text-underline text-start",
                                            pathname: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_ZONE_INTEGRATION,
                                            children: "Zones de comp\xe9tence"
                                        })
                                    }),
                                    (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_RAPPORTS_PERSO) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b9d4d12a3c294259$export$2e2bcd8739ae039).Item, {
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $43f579690a1c166d$export$2e2bcd8739ae039), {
                                            className: "text-underline text-start",
                                            pathname: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_RAPPORT_PERSONNALISE,
                                            children: "Rapports personnalis\xe9s"
                                        })
                                    }),
                                    (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_COURRIER) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b9d4d12a3c294259$export$2e2bcd8739ae039).Item, {
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $43f579690a1c166d$export$2e2bcd8739ae039), {
                                            className: "text-underline text-start",
                                            pathname: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_MODELE_COURRIER,
                                            children: "Mod\xe8les de courrier"
                                        })
                                    }),
                                    (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_PARAM_APPLI) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b9d4d12a3c294259$export$2e2bcd8739ae039).Item, {
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $43f579690a1c166d$export$2e2bcd8739ae039), {
                                            className: "text-underline text-start",
                                            pathname: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).ADMIN_IMPORT_RESSOURCES,
                                            children: "Import des ressources"
                                        })
                                    }),
                                    ((0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ATLAS_A) || (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ATLAS_C) || (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ATLAS_D)) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b9d4d12a3c294259$export$2e2bcd8739ae039).Item, {
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $43f579690a1c166d$export$2e2bcd8739ae039), {
                                            className: "text-underline text-start",
                                            pathname: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).ADMIN_GESTION_ATLAS,
                                            children: "Gestion de l'Atlas"
                                        })
                                    }),
                                    (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_ANOMALIES) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b9d4d12a3c294259$export$2e2bcd8739ae039).Item, {
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $43f579690a1c166d$export$2e2bcd8739ae039), {
                                            className: "text-underline text-start",
                                            pathname: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_ANOMALIE,
                                            children: "Anomalies"
                                        })
                                    })
                                ]
                            }),
                            ((0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_PARAM_TRAITEMENTS) || user?.isSuperAdmin) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                        className: "fw-bold text-center p-2 fs-5",
                                        children: "Traitements"
                                    }),
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $b9d4d12a3c294259$export$2e2bcd8739ae039), {
                                        className: "flex-column",
                                        children: [
                                            (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_PARAM_TRAITEMENTS) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b9d4d12a3c294259$export$2e2bcd8739ae039).Item, {
                                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $43f579690a1c166d$export$2e2bcd8739ae039), {
                                                            className: "text-underline text-start",
                                                            pathname: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).TASK,
                                                            children: "Param\xe9trage des traitements"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b9d4d12a3c294259$export$2e2bcd8739ae039).Item, {
                                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $43f579690a1c166d$export$2e2bcd8739ae039), {
                                                            className: "text-underline text-start",
                                                            pathname: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_TASK_SPECIFIQUE,
                                                            children: "Param\xe9trage des traitements sp\xe9cifiques"
                                                        })
                                                    })
                                                ]
                                            }),
                                            user?.isSuperAdmin && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b9d4d12a3c294259$export$2e2bcd8739ae039).Item, {
                                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $43f579690a1c166d$export$2e2bcd8739ae039), {
                                                    className: "text-underline text-start",
                                                    pathname: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).ADMIN_EXECUTE_TASK_MANUELLE,
                                                    children: "Ex\xe9cuter des traitements manuellement"
                                                })
                                            }),
                                            (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).PEI_DEPLACEMENT_U) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b9d4d12a3c294259$export$2e2bcd8739ae039).Item, {
                                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $43f579690a1c166d$export$2e2bcd8739ae039), {
                                                            className: "text-underline text-start",
                                                            pathname: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).MAJ_POSITIONS_PEI,
                                                            children: "Mettre \xe0 jour les positions des PEI"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    hasDroitGererLesDroits && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        className: "bg-light p-2 border rounded mx-2",
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                className: "fw-bold text-center p-2 fs-5",
                                children: "G\xe9rer les droits"
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $b9d4d12a3c294259$export$2e2bcd8739ae039), {
                                className: "flex-column",
                                children: [
                                    (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_DROITS) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b9d4d12a3c294259$export$2e2bcd8739ae039).Item, {
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $43f579690a1c166d$export$2e2bcd8739ae039), {
                                            className: "text-underline text-start",
                                            pathname: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).GROUPE_FONCTIONNALITES_LIST,
                                            children: "Groupes de fonctionnalit\xe9s"
                                        })
                                    }),
                                    (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_DROITS) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b9d4d12a3c294259$export$2e2bcd8739ae039).Item, {
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $43f579690a1c166d$export$2e2bcd8739ae039), {
                                            className: "text-underline text-start",
                                            pathname: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIEN_DROIT_LIST,
                                            children: "Attribution des fonctionnalit\xe9s"
                                        })
                                    }),
                                    (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_DROITS) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b9d4d12a3c294259$export$2e2bcd8739ae039).Item, {
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $43f579690a1c166d$export$2e2bcd8739ae039), {
                                            className: "text-underline text-start",
                                            pathname: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_TYPE_ORGANISME,
                                            children: "Types d'organismes"
                                        })
                                    }),
                                    (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_DROITS) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b9d4d12a3c294259$export$2e2bcd8739ae039).Item, {
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $43f579690a1c166d$export$2e2bcd8739ae039), {
                                            className: "text-underline text-start",
                                            pathname: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_PROFIL_ORGANISME,
                                            children: "Profils d'organismes"
                                        })
                                    }),
                                    (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_DROITS) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b9d4d12a3c294259$export$2e2bcd8739ae039).Item, {
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $43f579690a1c166d$export$2e2bcd8739ae039), {
                                            className: "text-underline text-start",
                                            pathname: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_PROFIL_UTILISATEUR,
                                            children: "Profils d'utilisateurs"
                                        })
                                    }),
                                    (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_DROITS) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b9d4d12a3c294259$export$2e2bcd8739ae039).Item, {
                                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $43f579690a1c166d$export$2e2bcd8739ae039), {
                                                    className: "text-underline text-start",
                                                    pathname: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIEN_PROFIL_FONCTIONNALITE_LIST,
                                                    children: "Liens profils / groupes de fonctionnalit\xe9s"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {})
                                        ]
                                    }),
                                    ((0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_ORGANISME_A) || (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ORGANISME_CONTACT_A) || (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_ORGANISME_R)) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b9d4d12a3c294259$export$2e2bcd8739ae039).Item, {
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $43f579690a1c166d$export$2e2bcd8739ae039), {
                                            className: "text-underline text-start",
                                            pathname: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_ORGANISME,
                                            children: "Organismes"
                                        })
                                    }),
                                    ((0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_UTILISATEURS_A) || (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_UTILISATEURS_R) || (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_UTILISATEURS_ORGA_R) || (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_UTILISATEURS_ORGA_A)) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b9d4d12a3c294259$export$2e2bcd8739ae039).Item, {
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $43f579690a1c166d$export$2e2bcd8739ae039), {
                                            className: "text-underline text-start",
                                            pathname: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_UTILISATEUR,
                                            children: "Utilisateurs"
                                        })
                                    }),
                                    (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_API) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b9d4d12a3c294259$export$2e2bcd8739ae039).Item, {
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $43f579690a1c166d$export$2e2bcd8739ae039), {
                                            className: "text-underline text-start",
                                            pathname: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIEN_TYPE_ORGANISME_DROIT_API,
                                            children: "Attribution des droits API pour les types organismes"
                                        })
                                    }),
                                    ((0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_COUCHE_CARTOGRAPHIQUE) || (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).CARTO_METADATA_A)) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                                className: "fw-bold text-center p-2 fs-5",
                                                children: "Couches cartographiques"
                                            }),
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $b9d4d12a3c294259$export$2e2bcd8739ae039), {
                                                className: "flex-column",
                                                children: [
                                                    (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_COUCHE_CARTOGRAPHIQUE) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b9d4d12a3c294259$export$2e2bcd8739ae039).Item, {
                                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $43f579690a1c166d$export$2e2bcd8739ae039), {
                                                            className: "text-underline text-start",
                                                            pathname: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_GROUPE_COUCHE,
                                                            children: "Groupes de couches"
                                                        })
                                                    }),
                                                    (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).CARTO_METADATA_A) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b9d4d12a3c294259$export$2e2bcd8739ae039).Item, {
                                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $43f579690a1c166d$export$2e2bcd8739ae039), {
                                                            className: "text-underline text-start",
                                                            pathname: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_COUCHE_METADATA,
                                                            children: "Gestion des m\xe9tadonn\xe9es des couches"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    hasDroitGererLesNomenclatures && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        className: "bg-light p-2 border rounded mx-2",
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                className: "fw-bold text-center p-2 fs-5",
                                children: "G\xe9rer les nomenclatures"
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $b9d4d12a3c294259$export$2e2bcd8739ae039), {
                                className: "flex-column",
                                children: [
                                    (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b9d4d12a3c294259$export$2e2bcd8739ae039).Item, {
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $43f579690a1c166d$export$2e2bcd8739ae039), {
                                            className: "text-underline text-start",
                                            pathname: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_ANOMALIE_CATEGORIE,
                                            children: "Cat\xe9gories d'anomalies"
                                        })
                                    }),
                                    (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b9d4d12a3c294259$export$2e2bcd8739ae039).Item, {
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $43f579690a1c166d$export$2e2bcd8739ae039), {
                                            className: "text-underline text-start",
                                            pathname: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_DIAMETRE,
                                            children: "Diam\xe8tres"
                                        })
                                    }),
                                    (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b9d4d12a3c294259$export$2e2bcd8739ae039).Item, {
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $43f579690a1c166d$export$2e2bcd8739ae039), {
                                            className: "text-underline text-start",
                                            pathname: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_DOMAINE,
                                            children: "Domaines"
                                        })
                                    }),
                                    (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b9d4d12a3c294259$export$2e2bcd8739ae039).Item, {
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $43f579690a1c166d$export$2e2bcd8739ae039), {
                                            className: "text-underline text-start",
                                            pathname: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_FONCTION_CONTACT,
                                            children: "Fonctions des contacts"
                                        })
                                    }),
                                    (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b9d4d12a3c294259$export$2e2bcd8739ae039).Item, {
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $43f579690a1c166d$export$2e2bcd8739ae039), {
                                            className: "text-underline text-start",
                                            pathname: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_MARQUE_PIBI,
                                            children: "Marques de PIBI"
                                        })
                                    }),
                                    (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b9d4d12a3c294259$export$2e2bcd8739ae039).Item, {
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $43f579690a1c166d$export$2e2bcd8739ae039), {
                                            className: "text-underline text-start",
                                            pathname: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_MATERIAU,
                                            children: "Mat\xe9riaux"
                                        })
                                    }),
                                    (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b9d4d12a3c294259$export$2e2bcd8739ae039).Item, {
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $43f579690a1c166d$export$2e2bcd8739ae039), {
                                            className: "text-underline text-start",
                                            pathname: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_MODELE_PIBI,
                                            children: "Mod\xe8les PIBI"
                                        })
                                    }),
                                    (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b9d4d12a3c294259$export$2e2bcd8739ae039).Item, {
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $43f579690a1c166d$export$2e2bcd8739ae039), {
                                            className: "text-underline text-start",
                                            pathname: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_NATURE,
                                            children: "Natures de PEI"
                                        })
                                    }),
                                    (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b9d4d12a3c294259$export$2e2bcd8739ae039).Item, {
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $43f579690a1c166d$export$2e2bcd8739ae039), {
                                            className: "text-underline text-start",
                                            pathname: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_NATURE_DECI,
                                            children: "Natures DECI"
                                        })
                                    }),
                                    (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b9d4d12a3c294259$export$2e2bcd8739ae039).Item, {
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $43f579690a1c166d$export$2e2bcd8739ae039), {
                                            className: "text-underline text-start",
                                            pathname: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_NIVEAU,
                                            children: "Niveaux"
                                        })
                                    }),
                                    (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_ROLE_CONTACT) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b9d4d12a3c294259$export$2e2bcd8739ae039).Item, {
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $43f579690a1c166d$export$2e2bcd8739ae039), {
                                            className: "text-underline text-start",
                                            pathname: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_ROLE_CONTACT,
                                            children: "R\xf4les des contacts"
                                        })
                                    }),
                                    (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_PARAM_APPLI) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b9d4d12a3c294259$export$2e2bcd8739ae039).Item, {
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $43f579690a1c166d$export$2e2bcd8739ae039), {
                                            className: "text-underline text-start",
                                            pathname: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_THEMATIQUE,
                                            children: "Th\xe9matiques"
                                        })
                                    }),
                                    (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b9d4d12a3c294259$export$2e2bcd8739ae039).Item, {
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $43f579690a1c166d$export$2e2bcd8739ae039), {
                                            className: "text-underline text-start",
                                            pathname: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_TYPE_CANALISATION,
                                            children: "Types de canalisations"
                                        })
                                    }),
                                    (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b9d4d12a3c294259$export$2e2bcd8739ae039).Item, {
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $43f579690a1c166d$export$2e2bcd8739ae039), {
                                            className: "text-underline text-start",
                                            pathname: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_TYPE_PENA_ASPIRATION,
                                            children: "Types de dispositifs d'aspiration"
                                        })
                                    }),
                                    (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b9d4d12a3c294259$export$2e2bcd8739ae039).Item, {
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $43f579690a1c166d$export$2e2bcd8739ae039), {
                                            className: "text-underline text-start",
                                            pathname: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_TYPE_ENGIN,
                                            children: "Types d'engins"
                                        })
                                    }),
                                    (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_TYPE_ETUDE) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b9d4d12a3c294259$export$2e2bcd8739ae039).Item, {
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $43f579690a1c166d$export$2e2bcd8739ae039), {
                                            className: "text-underline text-start",
                                            pathname: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_TYPE_ETUDE,
                                            children: "Types d'\xe9tudes"
                                        })
                                    }),
                                    (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b9d4d12a3c294259$export$2e2bcd8739ae039).Item, {
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $43f579690a1c166d$export$2e2bcd8739ae039), {
                                            className: "text-underline text-start",
                                            pathname: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_TYPE_RESEAU,
                                            children: "Types de r\xe9seaux"
                                        })
                                    })
                                ]
                            }),
                            (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $b9d4d12a3c294259$export$2e2bcd8739ae039).Item, {
                                children: [
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $43f579690a1c166d$export$2e2bcd8739ae039), {
                                        className: "text-underline text-start",
                                        pathname: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_TYPE_CRISE,
                                        children: "Crise - Types de crise"
                                    })
                                ]
                            }),
                            (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b9d4d12a3c294259$export$2e2bcd8739ae039).Item, {
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $43f579690a1c166d$export$2e2bcd8739ae039), {
                                    className: "text-underline text-start",
                                    pathname: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).EVENEMENT_CATEGORIE_LIST,
                                    children: "Crise - Cat\xe9gories d'\xe9v\xe8nement"
                                })
                            }),
                            (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b9d4d12a3c294259$export$2e2bcd8739ae039).Item, {
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $43f579690a1c166d$export$2e2bcd8739ae039), {
                                    className: "text-underline text-start",
                                    pathname: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).EVENEMENT_SOUS_CATEGORIE_LIST,
                                    children: "Crise - Sous-cat\xe9gorie d'\xe9v\xe8nements"
                                })
                            }),
                            (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $b9d4d12a3c294259$export$2e2bcd8739ae039).Item, {
                                children: [
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $43f579690a1c166d$export$2e2bcd8739ae039), {
                                        className: "text-underline text-start",
                                        pathname: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_SIGNALEMENT_TYPE_ANOMALIE,
                                        children: "Signalement - Type d'anomalie"
                                    })
                                ]
                            }),
                            (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b9d4d12a3c294259$export$2e2bcd8739ae039).Item, {
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $43f579690a1c166d$export$2e2bcd8739ae039), {
                                    className: "text-underline text-start",
                                    pathname: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_SIGNALEMENT_TYPE_ELEMENT,
                                    children: "Signalement - Type d'\xe9l\xe9ment"
                                })
                            }),
                            (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b9d4d12a3c294259$export$2e2bcd8739ae039).Item, {
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $43f579690a1c166d$export$2e2bcd8739ae039), {
                                    className: "text-underline text-start",
                                    pathname: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_SIGNALEMENT_SOUS_TYPE_ELEMENT,
                                    children: "Signalement - Sous type d'\xe9l\xe9ment"
                                })
                            })
                        ]
                    })
                ]
            }),
            (hasDroitGestionnairesEtSites || hasDroitTableauxDeBord) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                className: "mt-2",
                children: [
                    hasDroitGestionnairesEtSites && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        className: "bg-light p-2 border rounded mx-2",
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                className: "fw-bold text-center p-2 fs-5",
                                children: "Gestionnaires & sites"
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $b9d4d12a3c294259$export$2e2bcd8739ae039), {
                                className: "flex-column",
                                children: [
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b9d4d12a3c294259$export$2e2bcd8739ae039).Item, {
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $43f579690a1c166d$export$2e2bcd8739ae039), {
                                            className: "text-underline text-start",
                                            pathname: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_GESTIONNAIRE,
                                            children: "Gestionnaires"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b9d4d12a3c294259$export$2e2bcd8739ae039).Item, {
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $43f579690a1c166d$export$2e2bcd8739ae039), {
                                            className: "text-underline text-start",
                                            pathname: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_SITE,
                                            children: "Sites"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    hasDroitTableauxDeBord && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        className: "bg-light p-2 border rounded mx-2",
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                className: "fw-bold text-center p-2 fs-5",
                                children: "Tableaux de bord"
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $b9d4d12a3c294259$export$2e2bcd8739ae039), {
                                className: "flex-column",
                                children: [
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b9d4d12a3c294259$export$2e2bcd8739ae039).Item, {
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $43f579690a1c166d$export$2e2bcd8739ae039), {
                                            pathname: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).DASHBOARD_ADMIN_QUERY,
                                            className: "text-underline text-start",
                                            children: "\xc9dition des requ\xeates et composants associ\xe9s"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b9d4d12a3c294259$export$2e2bcd8739ae039).Item, {
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $43f579690a1c166d$export$2e2bcd8739ae039), {
                                            pathname: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).DASHBOARD_ADMIN_DASHBOARD,
                                            className: "text-underline text-start",
                                            children: "\xc9dition des tableaux de bord et profils associ\xe9s"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $d324e040d6d3784b$export$2e2bcd8739ae039 = $d324e040d6d3784b$var$MenuAdmin;










var $bkJfK = parcelRequire("bkJfK");

var $kc00y = parcelRequire("kc00y");









var $66dc7f3bc16b2a69$var$TYPE_COURRIER = /*#__PURE__*/ function(TYPE_COURRIER) {
    TYPE_COURRIER["RAPPORT_POST_ROP"] = "Rapport post ROP";
    TYPE_COURRIER["COURRIER_ROI"] = "Courrier ROI";
    TYPE_COURRIER["COURRIER_VISITE_RECEPTION"] = "Courrier visite r\xe9ception";
    TYPE_COURRIER["CANEVAS_ROP"] = "Canevas de ROP";
    return TYPE_COURRIER;
}($66dc7f3bc16b2a69$var$TYPE_COURRIER || {});
var $66dc7f3bc16b2a69$export$2e2bcd8739ae039 = $66dc7f3bc16b2a69$var$TYPE_COURRIER;








var $bkJfK = parcelRequire("bkJfK");

var $kc00y = parcelRequire("kc00y");





const $1fb201e889d7bbaf$var$SortableParametreModeleCourrier = ({ id: id, listeElements: // La propriété id doit impérativement s'appeler id
listeElements, index: index })=>{
    const { setNodeRef: setNodeRef, listeners: listeners, transform: transform, transition: transition } = (0, $6e75a0664b0e0f07$export$4ebcb6201122185a)({
        id: id
    });
    const styles = {
        transform: (0, $f5d873c94758f78f$export$c4ffa16951855e28).Transform.toString(transform),
        transition: transition
    };
    const listeTypeParametre = Object.entries((0, $d44cc71db68851bf$export$3d7fc3ac5152d16e)).map(([key, value])=>{
        return {
            id: key,
            code: value,
            libelle: value
        };
    });
    const listParamUnavailable = (0, $d44cc71db68851bf$export$ece0d44852850b0a);
    const { values: values, setValues: setValues, setFieldValue: setFieldValue } = (0, $bkJfK.useFormikContext)();
    const [codeUnavailableIndex, setCodeUnavailableIndex] = (0, $kc00y.useState)(false);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
        ref: setNodeRef,
        style: styles,
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        ...listeners,
                        role: "button",
                        className: "pe-2",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$72e0de8e793fca75), {})
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                                name: `listeModeleCourrierParametre[${index}].modeleCourrierParametreCode`,
                                label: "Code",
                                onChange: (e)=>{
                                    setFieldValue(`listeModeleCourrierParametre[${index}].modeleCourrierParametreCode`, e.target.value);
                                    // Stock l'index du composant pour désactiver le bouton suivant le si code correspond à un nom réservé
                                    if (listParamUnavailable.includes(e.target.value)) {
                                        setCodeUnavailableIndex(true);
                                        setFieldValue("unavailableCode", values && values.unavailableCode ? [
                                            ...values.unavailableCode,
                                            index
                                        ] : [
                                            index
                                        ]);
                                    } else if (!listParamUnavailable.includes(e.target.value)) {
                                        setCodeUnavailableIndex(false);
                                        if (values.unavailableCode) setFieldValue("unavailableCode", values.unavailableCode.filter((i)=>i !== index));
                                    }
                                }
                            }),
                            codeUnavailableIndex && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8598ca69ed8b9dca$export$2e2bcd8739ae039), {
                                className: "mt-2",
                                variant: "warning",
                                children: "Nom de code reserv\xe9"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                            name: `listeModeleCourrierParametre[${index}].modeleCourrierParametreLibelle`,
                            label: "Libell\xe9"
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                            name: `listeModeleCourrierParametre[${index}].modeleCourrierParametreIsRequired`,
                            label: "Obligatoire"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$ce9b1cc0c34506d0), {
                        name: `listeModeleCourrierParametre[${index}].modeleCourrierParametreDescription`,
                        label: "Description du param\xe8tre",
                        required: false
                    })
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                className: "align-items-end",
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                            name: `listeModeleCourrierParametre[${index}].modeleCourrierParametreType`,
                            listIdCodeLibelle: listeTypeParametre,
                            label: "Type du composant param\xe8tre",
                            required: true,
                            onChange: (e)=>{
                                setFieldValue(`listeModeleCourrierParametre[${index}].modeleCourrierParametreType`, listeTypeParametre.find((type)=>type.id === e?.id)?.id);
                                setFieldValue(`listeModeleCourrierParametre[${index}].modeleCourrierParametreValeurDefaut`, null);
                                // Si c'est un select input et que les champs début de requête et fin ne sont pas initialisés, on les initialise
                                if ((0, $d44cc71db68851bf$export$3d7fc3ac5152d16e)[e?.id] === (0, $d44cc71db68851bf$export$3d7fc3ac5152d16e).SELECT_INPUT && (listeElements[index].modeleCourrierParametreSourceSqlDebut == null || listeElements[index].modeleCourrierParametreSourceSqlFin == null)) {
                                    setFieldValue(`listeModeleCourrierParametre[${index}].modeleCourrierParametreSourceSqlDebut`, "SELECT");
                                    setFieldValue(`listeModeleCourrierParametre[${index}].modeleCourrierParametreSourceSqlFin`, "FROM");
                                }
                            },
                            defaultValue: listeTypeParametre?.find((e)=>e.id === listeElements[index].modeleCourrierParametreType),
                            setValues: setValues
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: $1fb201e889d7bbaf$export$808fe5927a892cc6(listeElements, index)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: (0, $d44cc71db68851bf$export$3d7fc3ac5152d16e)[listeElements[index].modeleCourrierParametreType] === (0, $d44cc71db68851bf$export$3d7fc3ac5152d16e).SELECT_INPUT && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                            className: "mt-2",
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $8598ca69ed8b9dca$export$2e2bcd8739ae039), {
                                    variant: "info",
                                    className: "border rounded",
                                    children: [
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$340bfce9b4df026b), {}),
                                        " Les codes des param\xe8tres que vous pouvez utiliser dans la requ\xeate :",
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("ul", {
                                            children: (0, $d44cc71db68851bf$export$ece0d44852850b0a).map((param)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("li", {
                                                    children: param
                                                }, param))
                                        })
                                    ]
                                }, "info")
                            })
                        }),
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$ce9b1cc0c34506d0), {
                                name: `listeModeleCourrierParametre[${index}].modeleCourrierParametreSourceSqlDebut`,
                                label: "Requ\xeate SQL pour alimenter le param\xe8tre"
                            })
                        }),
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                            className: "m-2",
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                                        name: `listeModeleCourrierParametre[${index}].modeleCourrierParametreSourceSqlId`
                                    })
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                    children: "as id,"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                            className: "m-2",
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                                        name: `listeModeleCourrierParametre[${index}].modeleCourrierParametreSourceSqlLibelle`
                                    })
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                    children: "as libelle"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$ce9b1cc0c34506d0), {
                                name: `listeModeleCourrierParametre[${index}].modeleCourrierParametreSourceSqlFin`
                            })
                        })
                    ]
                })
            })
        ]
    });
};
function $1fb201e889d7bbaf$export$3ae88e8c799b8b5d(index, listeElements) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($1fb201e889d7bbaf$var$SortableParametreModeleCourrier, {
        index: index,
        listeElements: listeElements,
        id: listeElements[index].id
    });
}
function $1fb201e889d7bbaf$export$808fe5927a892cc6(listeElements, index) {
    switch((0, $d44cc71db68851bf$export$3d7fc3ac5152d16e)[listeElements[index].modeleCourrierParametreType]){
        case (0, $d44cc71db68851bf$export$3d7fc3ac5152d16e).CHECKBOX_INPUT:
            return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                name: `listeModeleCourrierParametre[${index}].modeleCourrierParametreValeurDefaut`,
                label: "Valeur par d\xe9faut",
                required: false
            });
        case (0, $d44cc71db68851bf$export$3d7fc3ac5152d16e).DATE_INPUT:
            return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$183478aa40b5df1), {
                name: `listeModeleCourrierParametre[${index}].modeleCourrierParametreValeurDefaut`,
                label: "Valeur par d\xe9faut",
                required: false
            });
        case (0, $d44cc71db68851bf$export$3d7fc3ac5152d16e).NUMBER_INPUT:
            return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$6bf0cd3a219bbade), {
                name: `listeModeleCourrierParametre[${index}].modeleCourrierParametreValeurDefaut`,
                label: "Valeur par d\xe9faut",
                required: false
            });
        case (0, $d44cc71db68851bf$export$3d7fc3ac5152d16e).TEXT_INPUT:
            return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                name: `listeModeleCourrierParametre[${index}].modeleCourrierParametreValeurDefaut`,
                label: "Valeur par d\xe9faut",
                required: false
            });
        case (0, $d44cc71db68851bf$export$3d7fc3ac5152d16e).SELECT_INPUT:
            return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                name: `listeModeleCourrierParametre[${index}].modeleCourrierParametreValeurDefaut`,
                label: "Valeur par d\xe9faut (doit correspondre \xe0 l'identifiant technique d'un r\xe9sultat renvoy\xe9 par la requ\xeate SQL)",
                required: false
            });
    }
}


const $2c107a19e0a25c4a$export$a5cab80145b70e98 = (data)=>({
        modeleCourrierId: data?.modeleCourrierId ?? null,
        modeleCourrierActif: data?.modeleCourrierActif ?? true,
        modeleCourrierCode: data?.modeleCourrierCode ?? null,
        modeleCourrierLibelle: data?.modeleCourrierLibelle ?? null,
        modeleCourrierModule: data?.modeleCourrierModule ?? null,
        modeleCourrierDescription: data?.modeleCourrierDescription ?? null,
        modeleCourrierObjetEmail: data?.modeleCourrierObjetEmail ?? null,
        modeleCourrierCorpsEmailUtilisateur: data?.modeleCourrierCorpsEmailUtilisateur ?? null,
        modeleCourrierCorpsEmailPieceJointe: data?.modeleCourrierCorpsEmailPieceJointe ?? null,
        modeleCourrierType: data?.modeleCourrierType ?? null,
        listeGroupeFonctionnalitesId: data?.listeGroupeFonctionnalitesId ?? [],
        listeModeleCourrierParametre: data?.listeModeleCourrierParametre.map((e)=>({
                ...e,
                modeleCourrierParametreSourceSqlDebut: e.modeleCourrierParametreSourceSql && e.modeleCourrierParametreSourceSqlId ? e.modeleCourrierParametreSourceSql.split(e.modeleCourrierParametreSourceSqlId)[0] : null,
                modeleCourrierParametreSourceSqlFin: e.modeleCourrierParametreSourceSql && e.modeleCourrierParametreSourceSqlLibelle ? e.modeleCourrierParametreSourceSql.split(e.modeleCourrierParametreSourceSqlLibelle + " as libelle").slice(-1)[0] : null,
                // Le composant drag and drop a besoin d'un identifiant unique, donc on passe par un random
                id: Math.random()
            })) ?? [],
        modeleCourrierSourceSql: data?.modeleCourrierSourceSql,
        documentId: data?.documentId,
        documentNomFichier: data?.documentNomFichier,
        documentRepertoire: data?.documentRepertoire,
        part: null
    });
const $2c107a19e0a25c4a$export$c084437b5e3206cd = (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({});
const $2c107a19e0a25c4a$export$f97400759cfd946 = (values)=>{
    const formData = new FormData();
    if (values.part) formData.append("part", values.part);
    formData.append("modeleCourrier", JSON.stringify({
        modeleCourrierId: values?.modeleCourrierId,
        modeleCourrierActif: values.modeleCourrierActif,
        modeleCourrierCode: values.modeleCourrierCode,
        modeleCourrierLibelle: values.modeleCourrierLibelle,
        modeleCourrierDescription: values.modeleCourrierDescription,
        modeleCourrierSourceSql: values.modeleCourrierSourceSql,
        modeleCourrierModule: values.modeleCourrierModule,
        modeleCourrierObjetEmail: values.modeleCourrierObjetEmail,
        modeleCourrierCorpsEmailUtilisateur: values.modeleCourrierCorpsEmailUtilisateur,
        modeleCourrierCorpsEmailPieceJointe: values.modeleCourrierCorpsEmailPieceJointe,
        listeGroupeFonctionnalitesId: values.listeGroupeFonctionnalitesId,
        modeleCourrierType: values.modeleCourrierType,
        documentId: values.documentId,
        documentNomFichier: values.documentNomFichier,
        documentRepertoire: values.documentRepertoire,
        listeModeleCourrierParametre: values.listeModeleCourrierParametre.map((e, index)=>{
            return {
                ...e,
                modeleCourrierParametreCode: e.modeleCourrierParametreCode,
                modeleCourrierParametreOrdre: index,
                modeleCourrierParametreSourceSql: e.modeleCourrierParametreSourceSqlDebut + " " + e.modeleCourrierParametreSourceSqlId + " as id, " + e.modeleCourrierParametreSourceSqlLibelle + " as libelle " + e.modeleCourrierParametreSourceSqlFin
            };
        })
    }));
    return formData;
};
const $2c107a19e0a25c4a$var$ModeleCourrier = ()=>{
    const { setFieldValue: setFieldValue, values: values } = (0, $bkJfK.useFormikContext)();
    const modeleCourrierTypeModule = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/modules/get-type-module`);
    const groupeFonctionnalitesState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/groupe-fonctionnalites`);
    const typesCourrierState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/courriers/modeles/get-types-courrier`);
    const typesCourrier = typesCourrierState.data?.map((e)=>({
            id: e,
            code: e,
            libelle: (0, $66dc7f3bc16b2a69$export$2e2bcd8739ae039)[e]
        }));
    const listeModule = modeleCourrierTypeModule.data?.map((e)=>({
            id: e,
            code: e,
            libelle: e
        }));
    const [stepActive, setStepActive] = (0, $kc00y.useState)(0);
    function setListeParametres(value) {
        setFieldValue("listeModeleCourrierParametre", value);
    }
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
        children: [
            stepActive === 0 ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                        className: "mt-3",
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                                    name: "modeleCourrierActif",
                                    label: "Actif"
                                })
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                                    label: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                                        children: [
                                            "Code",
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                                                tooltipText: "Code unique du mod\xe8le de courrier",
                                                tooltipId: "code-modele-courrier",
                                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$340bfce9b4df026b), {})
                                            })
                                        ]
                                    }),
                                    name: "modeleCourrierCode",
                                    required: true
                                })
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                                    label: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                                        children: [
                                            "Libell\xe9",
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                                                tooltipText: "Libell\xe9 du mod\xe8le",
                                                tooltipId: "libelle-modele-courrier",
                                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$340bfce9b4df026b), {})
                                            })
                                        ]
                                    }),
                                    name: "modeleCourrierLibelle",
                                    required: true
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                        className: "mt-3",
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$eae70af4b4e3f197), {
                                    name: "listeGroupeFonctionnalitesId",
                                    label: "Groupes de fonctionnalit\xe9s ayant le droit d'ex\xe9cuter la requ\xeate",
                                    options: groupeFonctionnalitesState?.data,
                                    getOptionValue: (t)=>t.id,
                                    getOptionLabel: (t)=>t.libelle,
                                    value: values?.listeGroupeFonctionnalitesId?.map((e)=>groupeFonctionnalitesState?.data?.find((r)=>r.id === e)) ?? undefined,
                                    onChange: (groupeFonctionnalites)=>{
                                        const groupeFonctionnalitesId = groupeFonctionnalites.map((e)=>e.id);
                                        groupeFonctionnalitesId.length > 0 ? setFieldValue("listeGroupeFonctionnalitesId", groupeFonctionnalitesId) : setFieldValue("listeGroupeFonctionnalitesId", undefined);
                                    },
                                    isClearable: true,
                                    required: false
                                })
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$d6701e98ab1a6725), {
                                    name: `modeleCourrierModule`,
                                    label: "Rattach\xe9 au module",
                                    options: listeModule,
                                    getOptionValue: (t)=>t.id,
                                    getOptionLabel: (t)=>t.libelle,
                                    onChange: (e)=>{
                                        setFieldValue(`modeleCourrierModule`, listeModule?.find((type)=>type.id === e.id).id);
                                    },
                                    defaultValue: listeModule?.find((type)=>type.id === values.modeleCourrierModule),
                                    required: true
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                        className: "mt-3",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$d6701e98ab1a6725), {
                                name: `modeleCourrierType`,
                                label: "Type de courrier",
                                options: typesCourrier ?? [],
                                getOptionValue: (t)=>t.id,
                                getOptionLabel: (t)=>t.libelle,
                                onChange: (e)=>{
                                    setFieldValue(`modeleCourrierType`, e ? e.id : null);
                                },
                                defaultValue: typesCourrier?.find((type)=>type.id === values.modeleCourrierType),
                                required: false,
                                isClearable: true,
                                tooltipText: "Permet d'identifier des courriers particuliers (rapport post ROP par exemple) ; laisser ce champ vide sauf pour ces courriers."
                            })
                        })
                    })
                ]
            }) : stepActive === 1 ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("h3", {
                        children: "Gestion des param\xe8tres de la requ\xeate"
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("p", {
                        children: "Les codes des param\xe8tres seront utilis\xe9 dans la requ\xeate. Eviter les caract\xe8res sp\xe9ciaux et espace."
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                        className: "mt-3",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $0d6bddc95452bd52$export$2e2bcd8739ae039), {
                                createComponentToRepeat: (0, $1fb201e889d7bbaf$export$3ae88e8c799b8b5d),
                                nomListe: "listeModeleCourrierParametre",
                                setData: setListeParametres,
                                defaultElement: {
                                    modeleCourrierParametreLibelle: "",
                                    modeleCourrierParametreCode: "",
                                    modeleCourrierParametreIsRequired: false,
                                    modeleCourrierParametreDescription: "",
                                    modeleCourrierParametreType: null
                                }
                            })
                        })
                    })
                ]
            }) : stepActive === 2 ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    className: "mt-3",
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        className: "d-flex flex-column gap-4",
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                                name: "modeleCourrierObjetEmail",
                                label: "Objet de l'email"
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$ce9b1cc0c34506d0), {
                                name: "modeleCourrierCorpsEmailUtilisateur",
                                label: "Corps de l'email \xe0 destination d'un utilisateur de REMOcRA",
                                hint: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                                    className: "bg-light border p-2 rounded d-flex align-items-center gap-2",
                                    children: [
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$340bfce9b4df026b), {}),
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("span", {
                                            children: "Vous pouvez utiliser le code '#[LIEN_TELECHARGEMENT]#' dans ce corps de mail. Il sera automatiquement remplac\xe9 par le lien de t\xe9l\xe9chargement du courrier."
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$ce9b1cc0c34506d0), {
                                name: "modeleCourrierCorpsEmailPieceJointe",
                                label: "Corps de l'email \xe0 destination d'un destinataire externe (pi\xe8ce jointe)"
                            })
                        ]
                    })
                })
            }) : /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                        className: "mt-3",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                            className: "bg-light border p-2 rounded",
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$340bfce9b4df026b), {}),
                                " Les codes des param\xe8tres que vous pouvez utiliser dans la requ\xeate :",
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("ul", {
                                    children: [
                                        values.listeModeleCourrierParametre.length > 0 && values.listeModeleCourrierParametre.map((e, key)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("li", {
                                                children: e.modeleCourrierParametreCode
                                            }, key)),
                                        (0, $d44cc71db68851bf$export$ece0d44852850b0a).map((param)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("li", {
                                                children: param
                                            }, param))
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                        className: "mt-3",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$ce9b1cc0c34506d0), {
                                name: "modeleCourrierDescription",
                                label: "Description de la requ\xeate",
                                required: false
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                        className: "mt-3",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$ce9b1cc0c34506d0), {
                                name: "modeleCourrierSourceSql",
                                label: "Requ\xeate SQL"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                        className: "mt-3",
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                xs: values.documentId ? 8 : 12,
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b57af79a4ab2a1c6), {
                                    name: "part",
                                    accept: "*.odt",
                                    label: "Template",
                                    required: !values.documentId,
                                    onChange: (e)=>setFieldValue("part", e.target.files[0])
                                })
                            }),
                            values.documentId && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                xs: 4,
                                className: "d-flex align-items-end",
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                                    variant: "link",
                                    href: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/documents/telecharger/` + values.documentId,
                                    children: [
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$4a5ccdc9878f4668), {}),
                                        " T\xe9l\xe9charger le mod\xe8le de courrier"
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                className: "m-3 text-center",
                children: [
                    stepActive !== 0 && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                            variant: "primary",
                            onClick: ()=>{
                                setStepActive(stepActive - 1);
                            },
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$41884575254a94be), {}),
                                " Pr\xe9c\xe9dent"
                            ]
                        })
                    }),
                    stepActive !== 3 && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                            disabled: stepActive === 1 && values.unavailableCode && values.unavailableCode.length > 0 || (0, $c066b242635c27a6$export$2e2bcd8739ae039)(values.modeleCourrierModule) || (0, $c066b242635c27a6$export$2e2bcd8739ae039)(values.modeleCourrierCode) || (0, $c066b242635c27a6$export$2e2bcd8739ae039)(values.modeleCourrierLibelle) || stepActive === 1 && (values.listeModeleCourrierParametre.some((e)=>(0, $c066b242635c27a6$export$2e2bcd8739ae039)(e.modeleCourrierParametreType)) || values.listeModeleCourrierParametre.some((e)=>(0, $c066b242635c27a6$export$2e2bcd8739ae039)(e.modeleCourrierParametreCode)) || values.listeModeleCourrierParametre.some((e)=>(0, $c066b242635c27a6$export$2e2bcd8739ae039)(e.modeleCourrierParametreLibelle)) || values.listeModeleCourrierParametre.filter((e)=>e.modeleCourrierParametreType === (0, $d44cc71db68851bf$export$3d7fc3ac5152d16e).SELECT_INPUT).some((e)=>(0, $c066b242635c27a6$export$2e2bcd8739ae039)(e.modeleCourrierParametreSourceSqlId) || (0, $c066b242635c27a6$export$2e2bcd8739ae039)(e.modeleCourrierParametreSourceSqlLibelle))) || stepActive === 2 && ((0, $c066b242635c27a6$export$2e2bcd8739ae039)(values.modeleCourrierCorpsEmailUtilisateur) || (0, $c066b242635c27a6$export$2e2bcd8739ae039)(values.modeleCourrierCorpsEmailPieceJointe) || (0, $c066b242635c27a6$export$2e2bcd8739ae039)(values.modeleCourrierObjetEmail)),
                            variant: "primary",
                            onClick: ()=>setStepActive(stepActive + 1),
                            children: [
                                "Suivant ",
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$3213a407ffb0559), {})
                            ]
                        })
                    })
                ]
            }),
            stepActive === 3 && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db9b0e6fdb142a4c$export$2e2bcd8739ae039), {
                returnLink: true
            })
        ]
    });
};
var $2c107a19e0a25c4a$export$2e2bcd8739ae039 = $2c107a19e0a25c4a$var$ModeleCourrier;


const $3582535d1a340d84$var$CreateModeleCourrier = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                title: "Cr\xe9ation d'un mod\xe8le de courrier",
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$d776d19dfae66ece), {})
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                initialValues: (0, $2c107a19e0a25c4a$export$a5cab80145b70e98)(),
                prepareVariables: (values)=>(0, $2c107a19e0a25c4a$export$f97400759cfd946)(values),
                validationSchema: (0, $2c107a19e0a25c4a$export$c084437b5e3206cd),
                submitUrl: `/api/courriers/modeles/create/`,
                isPost: true,
                isMultipartFormData: true,
                redirectUrl: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_MODELE_COURRIER,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2c107a19e0a25c4a$export$2e2bcd8739ae039), {})
            })
        ]
    });
};
var $3582535d1a340d84$export$2e2bcd8739ae039 = $3582535d1a340d84$var$CreateModeleCourrier;



















const $e05c8f6b029ed172$var$filterValuesToVariable = ({ modeleCourrierActif: modeleCourrierActif, modeleCourrierCode: modeleCourrierCode, modeleCourrierLibelle: modeleCourrierLibelle, modeleCourrierProtected: modeleCourrierProtected, listeGroupeFonctionnalitesId: listeGroupeFonctionnalitesId, modeleCourrierModule: modeleCourrierModule })=>{
    const filter = {};
    $e05c8f6b029ed172$var$filterProperty(filter, modeleCourrierCode, "modeleCourrierCode");
    $e05c8f6b029ed172$var$filterProperty(filter, modeleCourrierActif, "modeleCourrierActif");
    $e05c8f6b029ed172$var$filterProperty(filter, modeleCourrierLibelle, "modeleCourrierLibelle");
    $e05c8f6b029ed172$var$filterProperty(filter, modeleCourrierProtected, "modeleCourrierProtected");
    $e05c8f6b029ed172$var$filterProperty(filter, modeleCourrierModule, "modeleCourrierModule");
    if (listeGroupeFonctionnalitesId?.length > 0) filter.listeGroupeFonctionnalitesId = listeGroupeFonctionnalitesId;
    return filter;
};
var $e05c8f6b029ed172$export$2e2bcd8739ae039 = $e05c8f6b029ed172$var$filterValuesToVariable;
function $e05c8f6b029ed172$var$filterProperty(filter, value, name) {
    if (value?.trim() !== "") filter[name] = value;
}


const $173df38c0222d645$var$ListModeleCourrier = ()=>{
    const groupeFonctionnalitesState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/groupe-fonctionnalites`);
    const modeleCourrierTypeModule = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/modules/get-type-module`);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                    icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$527d32aa1785fdd4), {}),
                    title: "Mod\xe8les de courrier",
                    right: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8ad69b89456b65bc$export$2e2bcd8739ae039), {
                        title: "Ajouter un mod\xe8le de courrier",
                        href: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).CREATE_MODELE_COURRIER
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $9a9eebc3462fba73$export$2e2bcd8739ae039), {
                    query: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/courriers/modeles`,
                    columns: [
                        {
                            Header: "Code",
                            accessor: "modeleCourrierCode",
                            sortField: "modeleCourrierCode",
                            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                                type: "text",
                                name: "modeleCourrierCode"
                            })
                        },
                        {
                            Header: "Libell\xe9",
                            accessor: ({ modeleCourrierId: modeleCourrierId, modeleCourrierLibelle: modeleCourrierLibelle, modeleCourrierDescription: modeleCourrierDescription })=>{
                                return {
                                    modeleCourrierId: modeleCourrierId,
                                    modeleCourrierLibelle: modeleCourrierLibelle,
                                    modeleCourrierDescription: modeleCourrierDescription
                                };
                            },
                            sortField: "modeleCourrierLibelle",
                            Cell: (value)=>{
                                return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                                    children: [
                                        value.value.modeleCourrierLibelle,
                                        value.value.modeleCourrierDescription && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                                            tooltipText: value.value.modeleCourrierDescription,
                                            tooltipId: value.value.modeleCourrierId,
                                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$340bfce9b4df026b), {})
                                        })
                                    ]
                                });
                            },
                            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                                type: "text",
                                name: "modeleCourrierLibelle"
                            })
                        },
                        {
                            Header: "Module",
                            accessor: "modeleCourrierModule",
                            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $3744b2a772efdf44$export$2e2bcd8739ae039), {
                                name: "modeleCourrierModule",
                                listIdCodeLibelle: modeleCourrierTypeModule.data?.map((e)=>({
                                        id: e,
                                        code: e,
                                        libelle: e
                                    }))
                            })
                        },
                        {
                            Header: "Groupes de fonctionnalit\xe9s",
                            accessor: "listeGroupeFonctionnalites",
                            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $cc7cbb0460865818$export$2e2bcd8739ae039), {
                                name: "listeGroupeFonctionnalitesId",
                                listIdCodeLibelle: groupeFonctionnalitesState.data
                            })
                        },
                        (0, $b82b937cc97f6f18$export$38dcf858d3ede0e9)({
                            Header: "Actif",
                            accessor: "modeleCourrierActif",
                            sortField: "modeleCourrierActif",
                            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eed37ff3d3e1f28c$export$2e2bcd8739ae039), {
                                options: (0, $a4f278cac9030fb1$export$2e2bcd8739ae039),
                                name: "modeleCourrierActif"
                            })
                        }),
                        (0, $b82b937cc97f6f18$export$4f228b0e0fb17419)({
                            Header: "Prot\xe9g\xe9",
                            accessor: "modeleCourrierProtected",
                            sortField: "modeleCourrierProtected",
                            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eed37ff3d3e1f28c$export$2e2bcd8739ae039), {
                                options: (0, $a4f278cac9030fb1$export$2e2bcd8739ae039),
                                name: "modeleCourrierProtected"
                            })
                        }),
                        (0, $b82b937cc97f6f18$export$36e9f5a475c9f6fc)({
                            Header: "Actions",
                            accessor: "modeleCourrierId",
                            buttons: [
                                {
                                    row: (row)=>{
                                        return row;
                                    },
                                    route: (modeleCourrierId)=>(0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).UPDATE_MODELE_COURRIER(modeleCourrierId),
                                    type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).UPDATE
                                },
                                {
                                    row: (row)=>{
                                        return row;
                                    },
                                    type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).DELETE,
                                    pathname: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/courriers/modele-courrier/delete/`
                                }
                            ]
                        })
                    ],
                    idName: "tableModeleCourrier",
                    filterValuesToVariable: (0, $e05c8f6b029ed172$export$2e2bcd8739ae039),
                    filterContext: (0, $9a9eebc3462fba73$export$396ef541d9951d45)({})
                })
            ]
        })
    });
};
var $173df38c0222d645$export$2e2bcd8739ae039 = $173df38c0222d645$var$ListModeleCourrier;




var $kc00y = parcelRequire("kc00y");









const $8bb0ad4fc5bd7b31$var$UpdateModeleCourrier = ()=>{
    const { modeleCourrierId: modeleCourrierId } = (0, $7a844823b04d4282$export$99eaa27ddbbb95ef)();
    const { data: data } = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/courriers/modele-courrier/get/${modeleCourrierId}`);
    const initialValues = (0, $kc00y.useMemo)(()=>(0, $2c107a19e0a25c4a$export$a5cab80145b70e98)(data), [
        data
    ]);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                title: "Modification d'un mod\xe8le de courrier",
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$b51dd496211ae105), {})
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                initialValues: initialValues,
                prepareVariables: (values)=>(0, $2c107a19e0a25c4a$export$f97400759cfd946)(values),
                validationSchema: (0, $2c107a19e0a25c4a$export$c084437b5e3206cd),
                submitUrl: `/api/courriers/modeles/update/${modeleCourrierId}`,
                isPost: false,
                isMultipartFormData: true,
                redirectUrl: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_MODELE_COURRIER,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2c107a19e0a25c4a$export$2e2bcd8739ae039), {})
            })
        ]
    });
};
var $8bb0ad4fc5bd7b31$export$2e2bcd8739ae039 = $8bb0ad4fc5bd7b31$var$UpdateModeleCourrier;






const $86220e499464048e$var$CreateMarquePibi = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1cf1e7fff5b3e31a$export$2e2bcd8739ae039), {
        typeNomenclature: (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).MARQUE_PIBI,
        redirectLink: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_MARQUE_PIBI
    });
};
var $86220e499464048e$export$2e2bcd8739ae039 = $86220e499464048e$var$CreateMarquePibi;







const $63e1527c00d8691b$var$ListMarquePibi = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e5bcd0ed5e4cafe8$export$2e2bcd8739ae039), {
            pageTitle: "Marques des PIBI",
            addButtonTitle: "Ajouter une marque",
            pageIcon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$ba2fbb9644c8bf32), {}),
            hasProtectedValue: false,
            lienPageAjout: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).ADD_MARQUE_PIBI,
            typeNomenclature: (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).MARQUE_PIBI,
            lienPageUpdate: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).UPDATE_MARQUE_PIBI
        })
    });
};
var $63e1527c00d8691b$export$2e2bcd8739ae039 = $63e1527c00d8691b$var$ListMarquePibi;







const $54976652b03567b1$var$UpdateMarquePibi = ()=>{
    const { marquePibiId: marquePibiId } = (0, $7a844823b04d4282$export$99eaa27ddbbb95ef)();
    return marquePibiId && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $4e0326405bcaf2aa$export$2e2bcd8739ae039), {
        nomenclatureId: marquePibiId,
        typeNomenclature: (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).MARQUE_PIBI,
        redirectLink: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_MARQUE_PIBI
    });
};
var $54976652b03567b1$export$2e2bcd8739ae039 = $54976652b03567b1$var$UpdateMarquePibi;






const $a5a33a89338804c7$var$CreateMateriau = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1cf1e7fff5b3e31a$export$2e2bcd8739ae039), {
        typeNomenclature: (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).MATERIAU,
        redirectLink: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_MATERIAU
    });
};
var $a5a33a89338804c7$export$2e2bcd8739ae039 = $a5a33a89338804c7$var$CreateMateriau;







const $2b7fe80bc4220843$var$ListMateriau = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e5bcd0ed5e4cafe8$export$2e2bcd8739ae039), {
            pageTitle: "Mat\xe9riaux",
            addButtonTitle: "Ajouter un mat\xe9riau",
            pageIcon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$ba2fbb9644c8bf32), {}),
            hasProtectedValue: false,
            lienPageAjout: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).ADD_MATERIAU,
            typeNomenclature: (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).MATERIAU,
            lienPageUpdate: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).UPDATE_MATERIAU
        })
    });
};
var $2b7fe80bc4220843$export$2e2bcd8739ae039 = $2b7fe80bc4220843$var$ListMateriau;







const $77c0018a184fb5cd$var$UpdateMateriau = ()=>{
    const { materiauId: materiauId } = (0, $7a844823b04d4282$export$99eaa27ddbbb95ef)();
    return materiauId && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $4e0326405bcaf2aa$export$2e2bcd8739ae039), {
        nomenclatureId: materiauId,
        typeNomenclature: (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).MATERIAU,
        redirectLink: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_MATERIAU
    });
};
var $77c0018a184fb5cd$export$2e2bcd8739ae039 = $77c0018a184fb5cd$var$UpdateMateriau;






const $e256fa5d712b8643$var$CreateModelePibi = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1cf1e7fff5b3e31a$export$2e2bcd8739ae039), {
        typeNomenclature: (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).MODELE_PIBI,
        redirectLink: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_MODELE_PIBI,
        isFkRequired: true
    });
};
var $e256fa5d712b8643$export$2e2bcd8739ae039 = $e256fa5d712b8643$var$CreateModelePibi;









const $3cfa3c5c3dcf4e83$var$ListModelePibi = ()=>{
    const { data: data } = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/marque-pibi/get`);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e5bcd0ed5e4cafe8$export$2e2bcd8739ae039), {
            pageTitle: "Mod\xe8les PIBI",
            addButtonTitle: "Ajouter un mod\xe8le",
            pageIcon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$ba2fbb9644c8bf32), {}),
            hasProtectedValue: false,
            lienPageAjout: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).ADD_MODELE_PIBI,
            typeNomenclature: (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).MODELE_PIBI,
            lienPageUpdate: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).UPDATE_MODELE_PIBI,
            libelleFk: "Marque",
            listeFk: data
        })
    });
};
var $3cfa3c5c3dcf4e83$export$2e2bcd8739ae039 = $3cfa3c5c3dcf4e83$var$ListModelePibi;







const $07823dfc6f4cfbc8$var$UpdateModelePibi = ()=>{
    const { modelePibiId: modelePibiId } = (0, $7a844823b04d4282$export$99eaa27ddbbb95ef)();
    return modelePibiId && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $4e0326405bcaf2aa$export$2e2bcd8739ae039), {
        nomenclatureId: modelePibiId,
        typeNomenclature: (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).MODELE_PIBI,
        redirectLink: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_MODELE_PIBI
    });
};
var $07823dfc6f4cfbc8$export$2e2bcd8739ae039 = $07823dfc6f4cfbc8$var$UpdateModelePibi;










var $bkJfK = parcelRequire("bkJfK");










const $2ad74c6f7b18e720$export$2ff1aa57b41ba659 = (values)=>({
        actif: values.natureActif,
        code: values.natureCode,
        libelle: values.natureLibelle,
        typePei: values.natureTypePei,
        protected: values.natureProtected,
        participeDfci: values.natureParticipeDfci,
        diametreIds: values.diametreIds,
        typePeiNexsis: values.natureTypePeiNexsis
    });
const $2ad74c6f7b18e720$export$b6a172955bf3ddb0 = (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({
    natureActif: (0, $36ceaed6faf947af$export$87bba3bb7a1f4285),
    natureCode: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
    natureLibelle: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
    natureTypePei: (0, $ce4de947442b2ab1$export$22b082955e083ec3)().nullable(),
    natureProtected: (0, $36ceaed6faf947af$export$87bba3bb7a1f4285),
    natureParticipeDfci: (0, $36ceaed6faf947af$export$87bba3bb7a1f4285),
    diametreIds: (0, $ce4de947442b2ab1$export$2f23118c22fb2630)()
});
const $2ad74c6f7b18e720$export$eeda5382aca566e2 = (data)=>({
        natureActif: data?.natureActif ?? false,
        natureCode: data?.natureCode ?? null,
        natureLibelle: data?.natureLibelle ?? null,
        natureTypePei: data?.natureTypePei ?? null,
        natureProtected: data?.natureProtected ?? false,
        natureParticipeDfci: data?.natureParticipeDfci ?? false,
        diametreIds: data?.diametreIds ?? [],
        natureTypePeiNexsis: data?.natureTypePeiNexsis ?? null
    });
const $2ad74c6f7b18e720$export$d0dc1f5c2d17d156 = ()=>{
    const listTypePei = Object.values((0, $f31f748b1c9fd0fb$export$2e2bcd8739ae039)).map((e)=>{
        return {
            id: e.toString(),
            code: e.toString(),
            libelle: e.toString()
        };
    });
    const { values: values, setValues: setValues, setFieldValue: setFieldValue } = (0, $bkJfK.useFormikContext)();
    const diametreState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/nomenclatures/diametre`);
    const listTypePeiNexsis = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/pei/type-pei-nexsis`)?.data?.map((e)=>{
        return {
            id: e.toString(),
            code: e.toString(),
            libelle: e.toString()
        };
    });
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                name: "natureCode",
                label: "Code",
                required: true,
                disabled: values.natureProtected
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                name: "natureLibelle",
                label: "Libell\xe9",
                required: true
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                name: "natureTypePei",
                listIdCodeLibelle: listTypePei,
                label: "Type de PEI",
                defaultValue: listTypePei?.find((e)=>e.code === values.natureTypePei),
                required: true,
                disabled: values.natureProtected,
                setValues: setValues
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                name: "natureActif",
                label: "Actif"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                name: "natureProtected",
                label: "Prot\xe9g\xe9",
                disabled: true
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                name: "natureParticipeDfci",
                label: "Participe \xe0 la DFCI"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$eae70af4b4e3f197), {
                name: "diametreIds",
                label: "Diam\xe8tres associ\xe9s \xe0 cette nature",
                required: false,
                options: diametreState?.data ? Object.values(diametreState?.data) : [],
                getOptionValue: (t)=>t.diametreId,
                getOptionLabel: (t)=>t.diametreLibelle,
                value: values?.diametreIds?.map((e)=>Object.values(diametreState?.data)?.find((r)=>r.diametreId === e)) ?? undefined,
                onChange: (diametre)=>{
                    const diametreId = diametre.map((e)=>e.diametreId);
                    diametreId.length > 0 ? setFieldValue("diametreIds", diametreId) : setFieldValue("diametreIds", []);
                }
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                name: "natureTypePeiNexsis",
                listIdCodeLibelle: listTypePeiNexsis,
                label: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                    children: [
                        "Type de PEI dans NexSIS",
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                            tooltipId: "typeNexsisPei",
                            tooltipText: "Nature du PEI attendue dans NexSIS. Attention, si cette valeur n'est pas renseign\xe9e, les PEI associ\xe9s \xe0 cette nature ne pourront pas \xeatre mis \xe0 jour dans NexSIS.",
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$340bfce9b4df026b), {})
                        })
                    ]
                }),
                defaultValue: listTypePeiNexsis?.find((e)=>e.code === values.natureTypePeiNexsis),
                setValues: setValues
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db9b0e6fdb142a4c$export$2e2bcd8739ae039), {
                returnLink: true
            })
        ]
    });
};


const $352ffb5a0cd55433$var$CreateNature = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                title: "Ajouter une nature",
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$d776d19dfae66ece), {})
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                initialValues: (0, $2ad74c6f7b18e720$export$eeda5382aca566e2)(),
                prepareVariables: (values)=>(0, $2ad74c6f7b18e720$export$2ff1aa57b41ba659)(values),
                validationSchema: (0, $2ad74c6f7b18e720$export$b6a172955bf3ddb0),
                submitUrl: `/api/nature/create/`,
                isPost: true,
                redirectUrl: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_NATURE,
                onSubmit: ()=>true,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2ad74c6f7b18e720$export$d0dc1f5c2d17d156), {})
            })
        ]
    });
};
var $352ffb5a0cd55433$export$2e2bcd8739ae039 = $352ffb5a0cd55433$var$CreateNature;






















const $ae37b60611194e3d$var$filterValuesNature = ({ natureActif: natureActif, natureCode: natureCode, natureLibelle: natureLibelle, diametreId: diametreId, natureTypePei: natureTypePei, natureProtected: natureProtected, natureParticipeDfci: natureParticipeDfci })=>{
    const filter = {};
    $ae37b60611194e3d$var$filterPropertyNature(filter, natureActif, "natureActif");
    $ae37b60611194e3d$var$filterPropertyNature(filter, natureCode, "natureCode");
    $ae37b60611194e3d$var$filterPropertyNature(filter, natureLibelle, "natureLibelle");
    $ae37b60611194e3d$var$filterPropertyNature(filter, diametreId, "diametreId");
    $ae37b60611194e3d$var$filterPropertyNature(filter, natureTypePei, "natureTypePei");
    $ae37b60611194e3d$var$filterPropertyNature(filter, natureProtected, "natureProtected");
    $ae37b60611194e3d$var$filterPropertyNature(filter, natureParticipeDfci, "natureParticipeDfci");
    return filter;
};
function $ae37b60611194e3d$var$filterPropertyNature(filter, value, name) {
    if (value != null && value.trim() !== "") filter[name] = value;
}
var $ae37b60611194e3d$export$2e2bcd8739ae039 = $ae37b60611194e3d$var$filterValuesNature;


const $7cf041e503d3435c$var$ListNature = ()=>{
    const { user: user } = (0, $e787cde576104469$export$fdc397e486fa83e7)();
    const diametreState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/nomenclatures/diametre`);
    const colonne = [
        {
            Header: "Libell\xe9",
            accessor: "natureLibelle",
            sortField: "natureLibelle",
            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                type: "text",
                name: "natureLibelle"
            })
        },
        {
            Header: "Type",
            accessor: "natureTypePei",
            sortField: "natureTypePei",
            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eed37ff3d3e1f28c$export$2e2bcd8739ae039), {
                options: (0, $f31f748b1c9fd0fb$export$2e2bcd8739ae039),
                name: "natureTypePei"
            })
        },
        {
            Header: "Code",
            accessor: "natureCode",
            sortField: "natureCode",
            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                type: "text",
                name: "natureCode"
            })
        },
        {
            Header: "Diam\xe8tres associ\xe9s",
            accessor: ({ diametreIds: diametreIds })=>{
                return (diametreIds?.map((e)=>diametreState?.data && Object.values(diametreState.data)?.find((r)=>r.diametreId === e)?.diametreLibelle) ?? []).join(", ");
            },
            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $bcc3791b22f76942$export$2e2bcd8739ae039), {
                name: "diametreId",
                nomenclature: (0, $0d1c1a6d7932bf75$export$9a2acd5fd49b44db).DIAMETRE
            })
        },
        (0, $b82b937cc97f6f18$export$38dcf858d3ede0e9)({
            Header: "Actif",
            accessor: "natureActif",
            sortField: "natureActif",
            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eed37ff3d3e1f28c$export$2e2bcd8739ae039), {
                name: "natureActif",
                options: (0, $a4f278cac9030fb1$export$2e2bcd8739ae039)
            })
        }),
        (0, $b82b937cc97f6f18$export$4f228b0e0fb17419)({
            Header: "Prot\xe9g\xe9",
            accessor: "natureProtected",
            sortField: "natureProtected",
            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eed37ff3d3e1f28c$export$2e2bcd8739ae039), {
                name: "natureProtected",
                options: (0, $a4f278cac9030fb1$export$2e2bcd8739ae039)
            })
        })
    ];
    const listeButton = [];
    if ((0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_DROITS)) {
        listeButton.push({
            row: (row)=>{
                return row;
            },
            type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).UPDATE,
            route: (data)=>(0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).UPDATE_NATURE(data)
        });
        listeButton.push({
            row: (row)=>{
                return row;
            },
            type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).DELETE,
            pathname: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/nature/delete/`
        });
    }
    colonne.push((0, $b82b937cc97f6f18$export$36e9f5a475c9f6fc)({
        Header: "Actions",
        accessor: "natureId",
        buttons: listeButton
    }));
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                    title: "Liste des natures",
                    icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$ba2fbb9644c8bf32), {}),
                    right: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8ad69b89456b65bc$export$2e2bcd8739ae039), {
                        title: "Ajouter une nature",
                        href: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).ADD_NATURE
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $9a9eebc3462fba73$export$2e2bcd8739ae039), {
                    query: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/nature/get`,
                    filterValuesToVariable: (0, $ae37b60611194e3d$export$2e2bcd8739ae039),
                    filterContext: (0, $9a9eebc3462fba73$export$396ef541d9951d45)({
                        natureActif: undefined,
                        natureCode: undefined,
                        natureLibelle: undefined,
                        diametreIds: undefined,
                        natureTypePei: undefined,
                        natureProtected: undefined,
                        natureParticipeDfci: undefined
                    }),
                    idName: "ListNature",
                    columns: colonne
                })
            ]
        })
    });
};
var $7cf041e503d3435c$export$2e2bcd8739ae039 = $7cf041e503d3435c$var$ListNature;












const $00f190f7910b59b6$var$UpdateNature = ()=>{
    const { natureId: natureId } = (0, $7a844823b04d4282$export$99eaa27ddbbb95ef)();
    const natureState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/nature/get/` + natureId);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                title: "Mise \xe0 jour d'une nature",
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$b51dd496211ae105), {})
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                initialValues: (0, $2ad74c6f7b18e720$export$eeda5382aca566e2)(natureState.data),
                prepareVariables: (values)=>(0, $2ad74c6f7b18e720$export$2ff1aa57b41ba659)(values),
                validationSchema: (0, $2ad74c6f7b18e720$export$b6a172955bf3ddb0),
                submitUrl: `/api/nature/update/` + natureId,
                isPost: false,
                redirectUrl: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_NATURE,
                onSubmit: ()=>true,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2ad74c6f7b18e720$export$d0dc1f5c2d17d156), {})
            })
        ]
    });
};
var $00f190f7910b59b6$export$2e2bcd8739ae039 = $00f190f7910b59b6$var$UpdateNature;






const $90d7619d5b0c85af$var$CreateNatureDeci = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1cf1e7fff5b3e31a$export$2e2bcd8739ae039), {
        typeNomenclature: (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).NATURE_DECI,
        redirectLink: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_NATURE_DECI
    });
};
var $90d7619d5b0c85af$export$2e2bcd8739ae039 = $90d7619d5b0c85af$var$CreateNatureDeci;







const $4a412c339eaccfd0$var$ListNatureDeci = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e5bcd0ed5e4cafe8$export$2e2bcd8739ae039), {
            pageTitle: "Natures DECI",
            addButtonTitle: "Ajouter une nature DECI",
            pageIcon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$ba2fbb9644c8bf32), {}),
            lienPageAjout: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).ADD_NATURE_DECI,
            typeNomenclature: (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).NATURE_DECI,
            lienPageUpdate: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).UPDATE_NATURE_DECI
        })
    });
};
var $4a412c339eaccfd0$export$2e2bcd8739ae039 = $4a412c339eaccfd0$var$ListNatureDeci;







const $d85e24e4022cc184$var$UpdateNatureDeci = ()=>{
    const { natureDeciId: natureDeciId } = (0, $7a844823b04d4282$export$99eaa27ddbbb95ef)();
    return natureDeciId && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $4e0326405bcaf2aa$export$2e2bcd8739ae039), {
        nomenclatureId: natureDeciId,
        typeNomenclature: (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).NATURE_DECI,
        redirectLink: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_NATURE_DECI
    });
};
var $d85e24e4022cc184$export$2e2bcd8739ae039 = $d85e24e4022cc184$var$UpdateNatureDeci;






const $8f9632c28eb11787$var$CreateNiveau = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1cf1e7fff5b3e31a$export$2e2bcd8739ae039), {
        typeNomenclature: (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).NIVEAU,
        redirectLink: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_NIVEAU
    });
};
var $8f9632c28eb11787$export$2e2bcd8739ae039 = $8f9632c28eb11787$var$CreateNiveau;







const $5607dbdd064f8ed5$var$ListNiveau = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e5bcd0ed5e4cafe8$export$2e2bcd8739ae039), {
            pageTitle: "Niveaux",
            addButtonTitle: "Ajouter un niveau",
            pageIcon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$ba2fbb9644c8bf32), {}),
            lienPageAjout: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).ADD_NIVEAU,
            typeNomenclature: (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).NIVEAU,
            lienPageUpdate: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).UPDATE_NIVEAU
        })
    });
};
var $5607dbdd064f8ed5$export$2e2bcd8739ae039 = $5607dbdd064f8ed5$var$ListNiveau;







const $145bf54b63af6050$var$UpdateNiveau = ()=>{
    const { niveauId: niveauId } = (0, $7a844823b04d4282$export$99eaa27ddbbb95ef)();
    return niveauId && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $4e0326405bcaf2aa$export$2e2bcd8739ae039), {
        nomenclatureId: niveauId,
        typeNomenclature: (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).NIVEAU,
        redirectLink: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_NIVEAU
    });
};
var $145bf54b63af6050$export$2e2bcd8739ae039 = $145bf54b63af6050$var$UpdateNiveau;










var $bkJfK = parcelRequire("bkJfK");









const $d3573aca976257c5$export$f060c9303dbcbf51 = (values)=>({
        actif: values.organismeActif,
        code: values.organismeCode,
        libelle: values.organismeLibelle,
        emailContact: values.organismeEmailContact,
        profilOrganismeId: values.organismeProfilOrganismeId,
        typeOrganismeId: values.organismeTypeOrganismeId,
        zoneIntegrationId: values.organismeZoneIntegrationId,
        parentId: values.organismeParentId
    });
const $d3573aca976257c5$export$bb4bd90ccdd262b5 = (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({
    organismeActif: (0, $36ceaed6faf947af$export$87bba3bb7a1f4285),
    organismeCode: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
    organismeLibelle: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
    organismeProfilOrganismeId: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
    organismeTypeOrganismeId: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
    organismeZoneIntegrationId: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba)
});
const $d3573aca976257c5$export$c9c242d7e33b1dfb = (data)=>({
        organismeId: data?.organismeId ?? null,
        organismeActif: data?.organismeActif ?? true,
        organismeCode: data?.organismeCode ?? null,
        organismeLibelle: data?.organismeLibelle ?? null,
        organismeEmailContact: data?.organismeEmailContact ?? null,
        organismeProfilOrganismeId: data?.organismeProfilOrganismeId ?? null,
        organismeTypeOrganismeId: data?.organismeTypeOrganismeId ?? null,
        organismeZoneIntegrationId: data?.organismeZoneIntegrationId ?? null,
        organismeParentId: data?.organismeParentId ?? null
    });
const $d3573aca976257c5$export$b6e1824af2434a05 = ()=>{
    const { values: values, setValues: setValues, setFieldValue: setFieldValue } = (0, $bkJfK.useFormikContext)();
    const profilOrganisme = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/profil-organisme/get-active`);
    const typeOrganisme = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/type-organisme/get-active`);
    const zoneIntegration = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/zone-integration/get-active`);
    const organismeParent = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)(values?.organismeTypeOrganismeId ? (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/organisme/get-parent-from-type/${values.organismeTypeOrganismeId}` : null);
    if (!profilOrganisme.isResolved || !typeOrganisme.isResolved || !zoneIntegration.isResolved || !organismeParent.isResolved) return;
    const profilOrganismeList = profilOrganisme.data.map((e)=>{
        return {
            id: e.profilOrganismeId,
            libelle: e.profilOrganismeLibelle,
            code: e.profilOrganismeCode,
            typeOrganismeId: e.profilOrganismeTypeOrganismeId
        };
    });
    const typeOrganismeList = typeOrganisme.data.map((e)=>{
        return {
            id: e.typeOrganismeId,
            libelle: e.typeOrganismeLibelle,
            code: e.typeOrganismeCode,
            typeOrganismeParentId: e.typeOrganismeParentId
        };
    });
    const organismeList = organismeParent?.data?.map((e)=>{
        return {
            id: e.organismeId,
            libelle: e.organismeLibelle,
            code: e.organismeCode
        };
    });
    const defaultProfilOrganisme = profilOrganismeList.find((e)=>{
        return e.id === values.organismeProfilOrganismeId;
    });
    const defaultTypeOrganisme = typeOrganismeList.find((e)=>{
        return e.id === values.organismeTypeOrganismeId;
    });
    const defaultZoneIntegration = zoneIntegration.data.find((e)=>{
        return e.id === values.organismeZoneIntegrationId;
    });
    const defaultOrganismeParent = organismeList?.find((e)=>{
        return e.id === values.organismeParentId;
    });
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                name: "organismeActif",
                label: "Actif"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                name: "organismeCode",
                label: "Code",
                required: true
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                name: "organismeLibelle",
                label: "Libell\xe9",
                required: true
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                name: "organismeEmailContact",
                label: "Email",
                required: false
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                name: "organismeZoneIntegrationId",
                label: "Zone de comp\xe9tence",
                listIdCodeLibelle: zoneIntegration.data,
                setValues: setValues,
                required: true,
                defaultValue: defaultZoneIntegration
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                className: "mt-3",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                    className: "bg-light border p-2 rounded",
                    children: [
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$340bfce9b4df026b), {}),
                        " Le profil organisme et l'organisme parent d\xe9pendent du type d'organisme. S\xe9lectionner un type d'organisme pour que les listes s'alimentent."
                    ]
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                name: "organismeTypeOrganismeId",
                label: "Type d'organisme",
                listIdCodeLibelle: typeOrganismeList,
                setValues: setValues,
                onChange: (e)=>{
                    setFieldValue("organismeProfilOrganismeId", null);
                    setFieldValue("organismeParentId", null);
                    setFieldValue("organismeTypeOrganismeId", e?.id);
                },
                required: true,
                defaultValue: defaultTypeOrganisme
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                name: "organismeProfilOrganismeId",
                label: "Profil",
                listIdCodeLibelle: profilOrganismeList.filter((e)=>e.typeOrganismeId === values.organismeTypeOrganismeId),
                setValues: setValues,
                required: true,
                defaultValue: defaultProfilOrganisme
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                name: "organismeParentId",
                label: "Organisme parent",
                listIdCodeLibelle: organismeList,
                setValues: setValues,
                required: false,
                defaultValue: defaultOrganismeParent
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db9b0e6fdb142a4c$export$2e2bcd8739ae039), {
                returnLink: true
            })
        ]
    });
};


const $e1a55cf6206726f3$var$CreateOrganisme = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                title: "Ajouter un organisme",
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$b51dd496211ae105), {})
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                initialValues: {
                    organismeActif: true,
                    organismeCode: null,
                    organismeLibelle: null,
                    organismeEmailContact: null,
                    organismeProfilOrganismeId: null,
                    organismeTypeOrganismeId: null,
                    organismeZoneIntegrationId: null,
                    organismeParentId: null
                },
                prepareVariables: (values)=>(0, $d3573aca976257c5$export$f060c9303dbcbf51)(values),
                validationSchema: (0, $d3573aca976257c5$export$bb4bd90ccdd262b5),
                submitUrl: `/api/organisme/create/`,
                isPost: true,
                redirectUrl: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_ORGANISME,
                onSubmit: ()=>true,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $d3573aca976257c5$export$b6e1824af2434a05), {})
            })
        ]
    });
};
var $e1a55cf6206726f3$export$2e2bcd8739ae039 = $e1a55cf6206726f3$var$CreateOrganisme;


















const $bdde123c8f803c62$var$filterValuesOrganisme = ({ organismeActif: organismeActif, organismeCode: organismeCode, organismeLibelle: organismeLibelle, organismeEmailContact: organismeEmailContact, typeOrganismeLibelle: typeOrganismeLibelle, profilOrganismeLibelle: profilOrganismeLibelle, zoneIntegrationLibelle: zoneIntegrationLibelle, parentLibelle: parentLibelle })=>{
    const filter = {};
    $bdde123c8f803c62$var$filterPropertyOrganisme(filter, organismeActif, "organismeActif");
    $bdde123c8f803c62$var$filterPropertyOrganisme(filter, organismeCode, "organismeCode");
    $bdde123c8f803c62$var$filterPropertyOrganisme(filter, organismeLibelle, "organismeLibelle");
    $bdde123c8f803c62$var$filterPropertyOrganisme(filter, organismeEmailContact, "organismeEmailContact");
    $bdde123c8f803c62$var$filterPropertyOrganisme(filter, typeOrganismeLibelle, "typeOrganismeLibelle");
    $bdde123c8f803c62$var$filterPropertyOrganisme(filter, profilOrganismeLibelle, "profilOrganismeLibelle");
    $bdde123c8f803c62$var$filterPropertyOrganisme(filter, zoneIntegrationLibelle, "zoneIntegrationLibelle");
    $bdde123c8f803c62$var$filterPropertyOrganisme(filter, parentLibelle, "parentLibelle");
    return filter;
};
function $bdde123c8f803c62$var$filterPropertyOrganisme(filter, value, name) {
    if (value != null && value.trim() !== "") filter[name] = value;
}
var $bdde123c8f803c62$export$2e2bcd8739ae039 = $bdde123c8f803c62$var$filterValuesOrganisme;


const $9efb6bc4aa7c5a70$var$ListOrganisme = ()=>{
    const { user: user } = (0, $e787cde576104469$export$fdc397e486fa83e7)();
    const listeButton = [];
    if ((0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ORGANISME_CONTACT_A) || (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_ORGANISME_R) || (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_ORGANISME_A)) listeButton.push({
        row: (row)=>{
            return row;
        },
        route: (organismeId)=>(0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_CONTACT(organismeId, "organisme"),
        type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).LINK,
        icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$3c0742b661df1fc4), {}),
        textEnable: "Afficher les contacts",
        textDisable: "Aucun contact pour cet organisme",
        disable: (row)=>!row.original.hasContact,
        classEnable: "warning"
    });
    if ((0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_ORGANISME_A)) listeButton.push({
        row: (row)=>{
            return row;
        },
        route: (organismeId)=>(0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).UPDATE_ORGANISME(organismeId),
        type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).UPDATE
    });
    if ((0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ORGANISME_CONTACT_A)) listeButton.push({
        row: (row)=>{
            return row;
        },
        route: (organismeId)=>(0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).ADD_CONTACT(organismeId, "organisme"),
        type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).LINK,
        icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$9bc70769102dd23), {}),
        textEnable: "Ajouter un contact",
        classEnable: "warning"
    });
    if ((0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_API)) {
        // TODO alimenter le contenu des modales pour expliquer comment on notifiera un organisme
        listeButton.push({
            row: (row)=>{
                return row;
            },
            type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).CONFIRM,
            hide: (row)=>row.organismeKeycloakId != null,
            textEnable: "Cr\xe9er un acc\xe8s API",
            pathname: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/organisme/create-client-keycloak/`,
            icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$d74eed6863461f9), {}),
            classEnable: "warning",
            confirmModal: {
                header: "Cr\xe9er un acc\xe8s API ?",
                content: "Vous allez cr\xe9er un acc\xe8s API pour l'organisme s\xe9lectionn\xe9. Il recevra un mail avec le mot de passe qu'il lui est associ\xe9.\nVoulez-vous continuer ? "
            }
        });
        listeButton.push({
            row: (row)=>{
                return row;
            },
            type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).CONFIRM,
            hide: (row)=>row.organismeKeycloakId == null,
            textEnable: "Reg\xe9n\xe9rer un acc\xe8s API",
            pathname: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/organisme/regenerer-client-secret/`,
            icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$1875cfea283c88df), {}),
            classEnable: "warning",
            confirmModal: {
                header: "R\xe9g\xe9n\xe9rer le mot de passe de l'API ?",
                content: "Vous allez reg\xe9n\xe9rer le mot de passe de l'API pour l'organisme s\xe9lectionn\xe9. Il recevra un mail avec le nouevau mot de passe qu'il lui est associ\xe9.\nVoulez-vous continuer ? "
            }
        });
    }
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                    title: "Organismes",
                    icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$ba2fbb9644c8bf32), {}),
                    right: (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_ORGANISME_A) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8ad69b89456b65bc$export$2e2bcd8739ae039), {
                        title: "Ajouter un organisme",
                        href: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).ADD_ORGANISME
                    })
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
                fluid: true,
                className: "px-5",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $9a9eebc3462fba73$export$2e2bcd8739ae039), {
                    query: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/organisme/get`,
                    filterValuesToVariable: (0, $bdde123c8f803c62$export$2e2bcd8739ae039),
                    filterContext: (0, $9a9eebc3462fba73$export$396ef541d9951d45)({
                        blob: "blob"
                    }),
                    idName: "ListOrganisme",
                    columns: [
                        {
                            Header: "Code",
                            accessor: "organismeCode",
                            sortField: "organismeCode",
                            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                                type: "text",
                                name: "organismeCode"
                            })
                        },
                        {
                            Header: "Libell\xe9",
                            accessor: "organismeLibelle",
                            sortField: "organismeLibelle",
                            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                                type: "text",
                                name: "organismeLibelle"
                            })
                        },
                        {
                            Header: "Email principal",
                            accessor: "organismeEmailContact",
                            sortField: "organismeEmailContact",
                            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                                type: "text",
                                name: "organismeEmailContact"
                            })
                        },
                        {
                            Header: "Type Organisme",
                            accessor: "typeOrganismeLibelle",
                            sortField: "typeOrganismeLibelle",
                            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                                type: "text",
                                name: "typeOrganismeLibelle"
                            })
                        },
                        {
                            Header: "Profil",
                            accessor: "profilOrganismeLibelle",
                            sortField: "profilOrganismeLibelle",
                            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                                type: "text",
                                name: "profilOrganismeLibelle"
                            })
                        },
                        {
                            Header: "Zone de comp\xe9tence",
                            accessor: "zoneIntegrationLibelle",
                            sortField: "zoneIntegrationLibelle",
                            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                                type: "text",
                                name: "zoneIntegrationLibelle"
                            })
                        },
                        {
                            Header: "Organisme parent",
                            accessor: "parentLibelle",
                            sortField: "parentLibelle",
                            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                                type: "text",
                                name: "parentLibelle"
                            })
                        },
                        (0, $b82b937cc97f6f18$export$38dcf858d3ede0e9)({
                            Header: "Actif",
                            accessor: "organismeActif",
                            sortField: "organismeActif",
                            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eed37ff3d3e1f28c$export$2e2bcd8739ae039), {
                                name: "organismeActif",
                                options: (0, $a4f278cac9030fb1$export$2e2bcd8739ae039)
                            })
                        }),
                        (0, $b82b937cc97f6f18$export$36e9f5a475c9f6fc)({
                            Header: "Actions",
                            accessor: "organismeId",
                            buttons: listeButton
                        })
                    ]
                })
            })
        ]
    });
};
var $9efb6bc4aa7c5a70$export$2e2bcd8739ae039 = $9efb6bc4aa7c5a70$var$ListOrganisme;












const $dca4baa1306090f4$var$UpdateOrganisme = ()=>{
    const { organismeId: organismeId } = (0, $7a844823b04d4282$export$99eaa27ddbbb95ef)();
    const organismeState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/organisme/get/` + organismeId);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                title: "Modification d'un organisme",
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$b51dd496211ae105), {})
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                initialValues: (0, $d3573aca976257c5$export$c9c242d7e33b1dfb)(organismeState.data),
                prepareVariables: (values)=>(0, $d3573aca976257c5$export$f060c9303dbcbf51)(values),
                validationSchema: (0, $d3573aca976257c5$export$bb4bd90ccdd262b5),
                submitUrl: `/api/organisme/update/` + organismeId,
                isPost: false,
                redirectUrl: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_ORGANISME,
                onSubmit: ()=>true,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $d3573aca976257c5$export$b6e1824af2434a05), {})
            })
        ]
    });
};
var $dca4baa1306090f4$export$2e2bcd8739ae039 = $dca4baa1306090f4$var$UpdateOrganisme;






const $91fb64896f34c2be$var$CreateProfilOrganisme = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1cf1e7fff5b3e31a$export$2e2bcd8739ae039), {
        typeNomenclature: (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).PROFIL_ORGANISME,
        redirectLink: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_PROFIL_ORGANISME,
        titrePage: "Cr\xe9ation d'un profil d'organisme",
        isFkRequired: true
    });
};
var $91fb64896f34c2be$export$2e2bcd8739ae039 = $91fb64896f34c2be$var$CreateProfilOrganisme;










const $28344cb136ea89b3$var$ListProfilOrganisme = ()=>{
    const { data: data } = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/type-organisme/get`);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e5bcd0ed5e4cafe8$export$2e2bcd8739ae039), {
            pageTitle: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                children: [
                    "Profils d'organismes",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                        tooltipText: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                            children: [
                                "Un profil d'organisme permet de d\xe9finir diff\xe9rentes typologies pour un m\xeame type d'organisme, par exemple",
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("ul", {
                                    children: [
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("li", {
                                            children: "une ouverture aux communes par \xe9tape (d'abord une partie de l'application, puis le reste)"
                                        }),
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("li", {
                                            children: "une diff\xe9rence de typologie (un acc\xe8s complet pour certaines communes et un acc\xe8s limit\xe9 pour d'autres, ...)"
                                        })
                                    ]
                                }),
                                "Au plus simple, le profil d'un organisme correspond \xe0 son type."
                            ]
                        }),
                        tooltipId: "tooltip-profil-organisme",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$340bfce9b4df026b), {})
                    })
                ]
            }),
            addButtonTitle: "Ajouter un profil d'organisme",
            pageIcon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$ba2fbb9644c8bf32), {}),
            hasProtectedValue: false,
            lienPageAjout: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).ADD_PROFIL_ORGANISME,
            typeNomenclature: (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).PROFIL_ORGANISME,
            lienPageUpdate: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).UPDATE_PROFIL_ORGANISME,
            libelleFk: "Type d'organisme",
            listeFk: data
        })
    });
};
var $28344cb136ea89b3$export$2e2bcd8739ae039 = $28344cb136ea89b3$var$ListProfilOrganisme;







const $5f76d06ca8c86fcb$var$UpdateProfilOrganisme = ()=>{
    const { profilOrganismeId: profilOrganismeId } = (0, $7a844823b04d4282$export$99eaa27ddbbb95ef)();
    return profilOrganismeId && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $4e0326405bcaf2aa$export$2e2bcd8739ae039), {
        nomenclatureId: profilOrganismeId,
        typeNomenclature: (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).PROFIL_ORGANISME,
        redirectLink: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_PROFIL_ORGANISME,
        titrePage: "Modification d'un profil d'organisme",
        isFkRequired: true
    });
};
var $5f76d06ca8c86fcb$export$2e2bcd8739ae039 = $5f76d06ca8c86fcb$var$UpdateProfilOrganisme;






const $3422bc2542d5430b$var$CreateProfilUtilisateur = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1cf1e7fff5b3e31a$export$2e2bcd8739ae039), {
        typeNomenclature: (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).PROFIL_UTILISATEUR,
        redirectLink: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_PROFIL_UTILISATEUR,
        titrePage: "Cr\xe9ation d'un profil utilisateur"
    });
};
var $3422bc2542d5430b$export$2e2bcd8739ae039 = $3422bc2542d5430b$var$CreateProfilUtilisateur;




var $bkJfK = parcelRequire("bkJfK");












const $f523d2f0c767de11$export$a5cab80145b70e98 = ()=>({
        document: null
    });
const $f523d2f0c767de11$export$f97400759cfd946 = (values)=>{
    const formData = new FormData();
    formData.append("document", values.document);
    return formData;
};
const $f523d2f0c767de11$var$ImportUtilisateur = ()=>{
    const navigate = (0, $7a844823b04d4282$export$9770f232ac06a008)();
    const location = (0, $7a844823b04d4282$export$45d76561a5302f2b)();
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$c9bef5de7ad5da31), {}),
                title: "Importer des utilisateurs"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                initialValues: $f523d2f0c767de11$export$a5cab80145b70e98(),
                validationSchema: (0, $96c21b2d91fc07ff$export$c084437b5e3206cd),
                isPost: true,
                isMultipartFormData: true,
                submitUrl: `/api/utilisateur/import/`,
                prepareVariables: (values)=>$f523d2f0c767de11$export$f97400759cfd946(values),
                onSubmit: (result)=>navigate((0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).RESULTAT_VERIF_IMPORT_UTILISATEURS, {
                        state: {
                            ...location.state,
                            result: result
                        }
                    }),
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($f523d2f0c767de11$var$FormImportDocument, {})
            })
        ]
    });
};
const $f523d2f0c767de11$var$ColonnesAttendues = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            "Fichier csv :",
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                placement: "right",
                tooltipText: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("span", {
                                        className: "text-danger",
                                        children: "*"
                                    }),
                                    " : Champs obligatoires"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                                    className: "fw-bold",
                                    children: [
                                        "mail ",
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("span", {
                                            className: "text-danger",
                                            children: "*"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                    className: "ms-2",
                                    children: "L'adresse email de l'utilisateur"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                                    className: "fw-bold",
                                    children: [
                                        "identifiant ",
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("span", {
                                            className: "text-danger",
                                            children: "*"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                    className: "ms-2",
                                    children: "L'identifiant (unique) de l'utilisateur"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                    className: "fw-bold",
                                    children: "telephone"
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                    className: "ms-2",
                                    children: "Le num\xe9ro de t\xe9l\xe9phone de l'utilisateur"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                    className: "fw-bold",
                                    children: "nom"
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                    className: "ms-2",
                                    children: "Le nom de l'utilisateur"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                    className: "fw-bold",
                                    children: "prenom"
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                    className: "ms-2",
                                    children: "Le pr\xe9nom de l'utilisateur"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                                    className: "fw-bold",
                                    children: [
                                        "organisme ",
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("span", {
                                            className: "text-danger",
                                            children: "*"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                    className: "ms-2",
                                    children: "Le code de l'organisme associ\xe9 \xe0 l'utilisateur"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                                    className: "fw-bold",
                                    children: [
                                        "profil_utilisateur ",
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("span", {
                                            className: "text-danger",
                                            children: "*"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                    className: "ms-2",
                                    children: "Le code du profil utilisateur associ\xe9 \xe0 l'utilisateur"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                    className: "fw-bold",
                                    children: "actif"
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                    className: "ms-2",
                                    children: 'D\xe9finit si un utilisateur doit \xeatre actif ou non dans l\'application : "TRUE" / "FALSE". FALSE par d\xe9faut'
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                    className: "fw-bold",
                                    children: "notifie"
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                    className: "ms-2",
                                    children: 'D\xe9finit si l\'utilisateur doit \xeatre notifi\xe9 : "TRUE" / "FALSE". FALSE par d\xe9faut'
                                })
                            ]
                        })
                    ]
                }),
                tooltipHeader: "Colonnes attendues",
                tooltipId: "importUtilisateur",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$340bfce9b4df026b), {})
            })
        ]
    });
};
const $f523d2f0c767de11$var$FormImportDocument = ()=>{
    const { setFieldValue: setFieldValue } = (0, $bkJfK.useFormikContext)();
    const { success: successToast, error: errorToast } = (0, $6bdae0bad7b05751$export$91b3d218c74c79e4)();
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                className: "mb-3",
                onClick: ()=>(0, $c066b242635c27a6$export$9cca65ea339c61b4)("/api/utilisateur/download-user-template", JSON.stringify({}), "import_utilisateur.csv", "Export termin\xe9", successToast, errorToast),
                children: [
                    "T\xe9l\xe9charger un mod\xe8le",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$4a5ccdc9878f4668), {})
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b57af79a4ab2a1c6), {
                        label: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($f523d2f0c767de11$var$ColonnesAttendues, {}),
                        name: "document",
                        accept: ".csv",
                        required: true,
                        onChange: (e)=>setFieldValue("document", e.target.files[0])
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                        className: "mt-3",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                            className: "text-center",
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db9b0e6fdb142a4c$export$2e2bcd8739ae039), {
                                submitTitle: "V\xe9rifier"
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var $f523d2f0c767de11$export$2e2bcd8739ae039 = $f523d2f0c767de11$var$ImportUtilisateur;










const $48f2d088b5c92973$var$ListProfilUtilisateur = ()=>{
    const { data: data } = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/type-organisme/get`);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e5bcd0ed5e4cafe8$export$2e2bcd8739ae039), {
            pageTitle: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                children: [
                    "Profils d'utilisateurs",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                        tooltipText: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
                            children: "Un profil d'utilisateur permet de d\xe9finir diff\xe9rentes typologies d'utilisateurs. Ces profils correspondront naturellement aux diff\xe9rents corps de m\xe9tier utilisant l'application, avec toutes les subtilit\xe9s jug\xe9es utiles pour leur affecter les droits d'acc\xe8s."
                        }),
                        tooltipId: "tooltip-profil-utilisateur",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$340bfce9b4df026b), {})
                    })
                ]
            }),
            addButtonTitle: "Ajouter un profil d'utilisateur",
            pageIcon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$ba2fbb9644c8bf32), {}),
            hasProtectedValue: false,
            lienPageAjout: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).ADD_PROFIL_UTILISATEUR,
            typeNomenclature: (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).PROFIL_UTILISATEUR,
            lienPageUpdate: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).UPDATE_PROFIL_UTILISATEUR,
            libelleFk: "Type d'organisme",
            listeFk: data
        })
    });
};
var $48f2d088b5c92973$export$2e2bcd8739ae039 = $48f2d088b5c92973$var$ListProfilUtilisateur;







const $7c43c1f098161cf2$var$UpdateProfilUtilisateur = ()=>{
    const { profilUtilisateurId: profilUtilisateurId } = (0, $7a844823b04d4282$export$99eaa27ddbbb95ef)();
    return profilUtilisateurId && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $4e0326405bcaf2aa$export$2e2bcd8739ae039), {
        nomenclatureId: profilUtilisateurId,
        typeNomenclature: (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).PROFIL_UTILISATEUR,
        redirectLink: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_PROFIL_UTILISATEUR,
        titrePage: "Modification d'un profil utilisateur"
    });
};
var $7c43c1f098161cf2$export$2e2bcd8739ae039 = $7c43c1f098161cf2$var$UpdateProfilUtilisateur;




var $bkJfK = parcelRequire("bkJfK");









const $e8f60ca44cdcf07e$export$a5cab80145b70e98 = (initialValues)=>{
    return {
        bilanVerifications: (initialValues?.result?.errors ?? []).map((e)=>({
                line: e.line,
                message: e.message
            })),
        utilisateurList: initialValues?.result?.utilisateurList ?? []
    };
};
const $e8f60ca44cdcf07e$export$c084437b5e3206cd = (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({});
const $e8f60ca44cdcf07e$export$f97400759cfd946 = (values)=>{
    return values.utilisateurList ?? null;
};
const $e8f60ca44cdcf07e$var$VerificationImportUtilisateur = ()=>{
    const { state: state } = (0, $7a844823b04d4282$export$45d76561a5302f2b)();
    let initialValues;
    if (state) {
        initialValues = state;
        window.history.replaceState({
            from: state.from
        }, "");
    }
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$2f6d05691f8bfa80), {}),
                title: "Validation de l'import des utilisateurs"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                initialValues: $e8f60ca44cdcf07e$export$a5cab80145b70e98(initialValues),
                validationSchema: $e8f60ca44cdcf07e$export$c084437b5e3206cd,
                isPost: true,
                submitUrl: `/api/utilisateur/importer-utilisateur`,
                prepareVariables: (values)=>$e8f60ca44cdcf07e$export$f97400759cfd946(values),
                redirectUrl: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_UTILISATEUR,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($e8f60ca44cdcf07e$var$ResultatsVerificationImportUser, {})
            })
        ]
    });
};
var $e8f60ca44cdcf07e$export$2e2bcd8739ae039 = $e8f60ca44cdcf07e$var$VerificationImportUtilisateur;
const $e8f60ca44cdcf07e$var$ResultatsVerificationImportUser = ()=>{
    const { values: values } = (0, $bkJfK.useFormikContext)();
    // Regroupement par ligne
    const erreursLigne = (values?.bilanVerifications ?? []).reduce((acc, error)=>{
        if (!acc[error.line]) acc[error.line] = [];
        acc[error.line].push(error.message);
        return acc;
    }, {});
    const groupedEntries = Object.entries(erreursLigne).sort(([a], [b])=>Number(a) - Number(b));
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $13de46b4dfcc473f$export$2e2bcd8739ae039), {
                        bordered: true,
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("thead", {
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("th", {
                                            children: "Lignes"
                                        }),
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("th", {
                                            children: "Erreurs"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("tbody", {
                                children: groupedEntries.length === 0 ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("tr", {
                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("td", {
                                        colSpan: 2,
                                        children: "Aucune erreur"
                                    })
                                }) : groupedEntries.map(([line, messages])=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("td", {
                                                children: line
                                            }),
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("td", {
                                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("ul", {
                                                    className: "list-unstyled ps-3",
                                                    children: messages.map((msg, index)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("li", {
                                                            children: msg
                                                        }, index))
                                                })
                                            })
                                        ]
                                    }, line))
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db9b0e6fdb142a4c$export$2e2bcd8739ae039), {
                        disabledValide: groupedEntries.length !== 0,
                        submitTitle: "Importer les utilisateurs"
                    })
                })
            })
        ]
    });
};










var $bkJfK = parcelRequire("bkJfK");

var $kc00y = parcelRequire("kc00y");















var $bkJfK = parcelRequire("bkJfK");

var $kc00y = parcelRequire("kc00y");





const $59b90363761e9c71$var$SortableParametre = ({ id: id, listeElements: // La propriété id doit impérativement s'appeler id
listeElements, index: index, typeModule: typeModule })=>{
    const { setNodeRef: setNodeRef, listeners: listeners, transform: transform, transition: transition } = (0, $6e75a0664b0e0f07$export$4ebcb6201122185a)({
        id: id
    });
    const styles = {
        transform: (0, $f5d873c94758f78f$export$c4ffa16951855e28).Transform.toString(transform),
        transition: transition
    };
    let entries = Object.entries((0, $d44cc71db68851bf$export$3d7fc3ac5152d16e));
    if (typeModule !== "CRISE") entries = entries.filter(([key])=>![
            "POINT",
            "POLYGON",
            "LINESTRING"
        ].includes(key));
    const listeTypeParametre = entries.map(([key, value])=>({
            id: key,
            code: value,
            libelle: value
        }));
    const listParamUnavailable = (0, $d44cc71db68851bf$export$ece0d44852850b0a);
    const { values: values, setValues: setValues, setFieldValue: setFieldValue } = (0, $bkJfK.useFormikContext)();
    const [codeUnavailableIndex, setCodeUnavailableIndex] = (0, $kc00y.useState)(false);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
        ref: setNodeRef,
        style: styles,
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        ...listeners,
                        role: "button",
                        className: "pe-2",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$72e0de8e793fca75), {})
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                                name: `listeRapportPersonnaliseParametre[${index}].rapportPersonnaliseParametreCode`,
                                label: "Code",
                                onChange: (e)=>{
                                    setFieldValue(`listeRapportPersonnaliseParametre[${index}].rapportPersonnaliseParametreCode`, e.target.value);
                                    // Stock l'index du composant pour désactiver le bouton suivant le si code correspond à un nom réservé
                                    if (listParamUnavailable.includes(e.target.value)) {
                                        setCodeUnavailableIndex(true);
                                        setFieldValue("unavailableCode", values && values.unavailableCode ? [
                                            ...values.unavailableCode,
                                            index
                                        ] : [
                                            index
                                        ]);
                                    } else if (!listParamUnavailable.includes(e.target.value)) {
                                        setCodeUnavailableIndex(false);
                                        if (values.unavailableCode) setFieldValue("unavailableCode", values.unavailableCode.filter((i)=>i !== index));
                                    }
                                }
                            }),
                            codeUnavailableIndex && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8598ca69ed8b9dca$export$2e2bcd8739ae039), {
                                className: "mt-2",
                                variant: "warning",
                                children: "Nom de code reserv\xe9"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                            name: `listeRapportPersonnaliseParametre[${index}].rapportPersonnaliseParametreLibelle`,
                            label: "Libell\xe9"
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                            name: `listeRapportPersonnaliseParametre[${index}].rapportPersonnaliseParametreIsRequired`,
                            label: "Obligatoire"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$ce9b1cc0c34506d0), {
                        name: `listeRapportPersonnaliseParametre[${index}].rapportPersonnaliseParametreDescription`,
                        label: "Description du param\xe8tre",
                        required: false
                    })
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                className: "align-items-end",
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                            name: `listeRapportPersonnaliseParametre[${index}].rapportPersonnaliseParametreType`,
                            listIdCodeLibelle: listeTypeParametre,
                            label: "Type du composant param\xe8tre",
                            required: true,
                            onChange: (e)=>{
                                setFieldValue(`listeRapportPersonnaliseParametre[${index}].rapportPersonnaliseParametreType`, listeTypeParametre.find((type)=>type.id === e?.id)?.id);
                                setFieldValue(`listeRapportPersonnaliseParametre[${index}].rapportPersonnaliseParametreValeurDefaut`, null);
                                // Si c'est un select input et que les champs début de requête et fin ne sont pas initialisés, on les initialise
                                if ((0, $d44cc71db68851bf$export$3d7fc3ac5152d16e)[e?.id] === (0, $d44cc71db68851bf$export$3d7fc3ac5152d16e).SELECT_INPUT && (listeElements[index].rapportPersonnaliseParametreSourceSqlDebut == null || listeElements[index].rapportPersonnaliseParametreSourceSqlFin == null)) {
                                    setFieldValue(`listeRapportPersonnaliseParametre[${index}].rapportPersonnaliseParametreSourceSqlDebut`, "SELECT");
                                    setFieldValue(`listeRapportPersonnaliseParametre[${index}].rapportPersonnaliseParametreSourceSqlFin`, "FROM");
                                }
                            },
                            defaultValue: listeTypeParametre?.find((e)=>e.id === listeElements[index].rapportPersonnaliseParametreType),
                            setValues: setValues
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: $59b90363761e9c71$export$808fe5927a892cc6(listeElements, index)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: (0, $d44cc71db68851bf$export$3d7fc3ac5152d16e)[listeElements[index].rapportPersonnaliseParametreType] === (0, $d44cc71db68851bf$export$3d7fc3ac5152d16e).SELECT_INPUT && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                            className: "mt-2",
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $8598ca69ed8b9dca$export$2e2bcd8739ae039), {
                                    variant: "info",
                                    className: "border rounded",
                                    children: [
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$340bfce9b4df026b), {}),
                                        " Les codes des param\xe8tres que vous pouvez utiliser dans la requ\xeate :",
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("ul", {
                                            children: (0, $d44cc71db68851bf$export$ece0d44852850b0a).map((param)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("li", {
                                                    children: param
                                                }, param))
                                        })
                                    ]
                                }, "info")
                            })
                        }),
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$ce9b1cc0c34506d0), {
                                name: `listeRapportPersonnaliseParametre[${index}].rapportPersonnaliseParametreSourceSqlDebut`,
                                label: "Requ\xeate SQL pour alimenter le param\xe8tre"
                            })
                        }),
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                            className: "m-2",
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                                        name: `listeRapportPersonnaliseParametre[${index}].rapportPersonnaliseParametreSourceSqlId`
                                    })
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                    children: "as id,"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                            className: "m-2",
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                                        name: `listeRapportPersonnaliseParametre[${index}].rapportPersonnaliseParametreSourceSqlLibelle`
                                    })
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                    children: "as libelle"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$ce9b1cc0c34506d0), {
                                name: `listeRapportPersonnaliseParametre[${index}].rapportPersonnaliseParametreSourceSqlFin`
                            })
                        })
                    ]
                })
            })
        ]
    });
};
function $59b90363761e9c71$export$6c041c18691f3c68(index, listeElements, typeModule) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($59b90363761e9c71$var$SortableParametre, {
        typeModule: typeModule,
        index: index,
        listeElements: listeElements,
        id: listeElements[index].id
    });
}
function $59b90363761e9c71$export$808fe5927a892cc6(listeElements, index) {
    switch((0, $d44cc71db68851bf$export$3d7fc3ac5152d16e)[listeElements[index].rapportPersonnaliseParametreType]){
        case (0, $d44cc71db68851bf$export$3d7fc3ac5152d16e).CHECKBOX_INPUT:
            return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                name: `listeRapportPersonnaliseParametre[${index}].rapportPersonnaliseParametreValeurDefaut`,
                label: "Valeur par d\xe9faut",
                required: false
            });
        case (0, $d44cc71db68851bf$export$3d7fc3ac5152d16e).DATE_INPUT:
            return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$183478aa40b5df1), {
                name: `listeRapportPersonnaliseParametre[${index}].rapportPersonnaliseParametreValeurDefaut`,
                label: "Valeur par d\xe9faut",
                required: false
            });
        case (0, $d44cc71db68851bf$export$3d7fc3ac5152d16e).NUMBER_INPUT:
            return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$6bf0cd3a219bbade), {
                name: `listeRapportPersonnaliseParametre[${index}].rapportPersonnaliseParametreValeurDefaut`,
                label: "Valeur par d\xe9faut",
                required: false
            });
        case (0, $d44cc71db68851bf$export$3d7fc3ac5152d16e).TEXT_INPUT:
            return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                name: `listeRapportPersonnaliseParametre[${index}].rapportPersonnaliseParametreValeurDefaut`,
                label: "Valeur par d\xe9faut",
                required: false
            });
        case (0, $d44cc71db68851bf$export$3d7fc3ac5152d16e).SELECT_INPUT:
            return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                name: `listeRapportPersonnaliseParametre[${index}].rapportPersonnaliseParametreValeurDefaut`,
                label: "Valeur par d\xe9faut (doit correspondre \xe0 l'identifiant technique d'un r\xe9sultat renvoy\xe9 par la requ\xeate SQL)",
                required: false
            });
    }
}


/**
 * Permet de découper la requête SQL d'un paramètre en deux parties, avant et après les champs id et libelle
 * @param sourceSql : La requête SQL complète du paramètre
 * @param sourceSqlId : Le nom du champ qui sera utilisé comme identifiant dans la requête SQL
 * @param sourceSqlLibelle : Le nom du champ qui sera utilisé comme libellé dans la requête SQL
 * @returns les propriétés rapportPersonnaliseParametreSourceSqlDebut et rapportPersonnaliseParametreSourceSqlFin
 */ const $37b0287c5fadd5f2$var$splitParametreSourceSql = (sourceSql, sourceSqlId, sourceSqlLibelle)=>{
    if (!sourceSql || !sourceSqlId || !sourceSqlLibelle) return {
        rapportPersonnaliseParametreSourceSqlDebut: null,
        rapportPersonnaliseParametreSourceSqlFin: null
    };
    // on cherche l'emplacement du "as id" et du "as libelle" dans la requête SQL pour découper la requête en deux parties
    const idPattern = `${sourceSqlId} as id,`;
    const libellePattern = `${sourceSqlLibelle} as libelle`;
    const idPatternIndex = sourceSql.indexOf(idPattern);
    if (idPatternIndex !== -1) {
        const libellePatternIndex = sourceSql.indexOf(libellePattern, idPatternIndex + idPattern.length);
        if (libellePatternIndex !== -1) return {
            rapportPersonnaliseParametreSourceSqlDebut: sourceSql.slice(0, idPatternIndex),
            // Si plusieurs "as libelle" existent, on coupe au premier trouvé après "as id".
            rapportPersonnaliseParametreSourceSqlFin: sourceSql.slice(libellePatternIndex + libellePattern.length)
        };
    }
    // Fallback défensif si on ne retrouve pas la structure attendue.
    return {
        rapportPersonnaliseParametreSourceSqlDebut: sourceSql.split(sourceSqlId)[0],
        rapportPersonnaliseParametreSourceSqlFin: sourceSql.includes(sourceSqlLibelle + " as libelle") ? sourceSql.split(sourceSqlLibelle + " as libelle")[1] : null
    };
};
const $37b0287c5fadd5f2$export$a5cab80145b70e98 = (data)=>({
        rapportPersonnaliseProtected: data?.rapportPersonnaliseProtected ?? false,
        rapportPersonnaliseActif: data?.rapportPersonnaliseActif ?? true,
        rapportPersonnaliseCode: data?.rapportPersonnaliseCode ?? null,
        rapportPersonnaliseLibelle: data?.rapportPersonnaliseLibelle ?? null,
        rapportPersonnaliseIsSpatial: data?.rapportPersonnaliseChampGeometrie != null,
        rapportPersonnaliseModule: data?.rapportPersonnaliseModule ?? null,
        rapportPersonnaliseDescription: data?.rapportPersonnaliseDescription ?? null,
        rapportPersonnaliseChampGeometrie: data?.rapportPersonnaliseChampGeometrie ?? null,
        listeGroupeFonctionnalitesId: data?.listeGroupeFonctionnalitesId ?? [],
        listeRapportPersonnaliseParametre: data?.listeRapportPersonnaliseParametre.map((e)=>({
                ...$37b0287c5fadd5f2$var$splitParametreSourceSql(e.rapportPersonnaliseParametreSourceSql, e.rapportPersonnaliseParametreSourceSqlId, e.rapportPersonnaliseParametreSourceSqlLibelle),
                // Le composant drag and drop a besoin d'un identifiant unique, donc on passe par un random
                id: Math.random(),
                ...e
            })) ?? [],
        rapportPersonnaliseSourceSql: data?.rapportPersonnaliseChampGeometrie == null ? data?.rapportPersonnaliseSourceSql : null,
        rapportPersonnaliseSourceSqlDebut: data?.rapportPersonnaliseChampGeometrie !== null ? data?.rapportPersonnaliseSourceSql.split("ST_astext(")[0] : null,
        rapportPersonnaliseSourceSqlFin: data?.rapportPersonnaliseChampGeometrie !== null ? data?.rapportPersonnaliseSourceSql.split(") as geometrie ").slice(-1)[0] : null
    });
const $37b0287c5fadd5f2$export$c084437b5e3206cd = (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({});
const $37b0287c5fadd5f2$export$f97400759cfd946 = (values)=>({
        rapportPersonnaliseProtected: values.rapportPersonnaliseProtected,
        rapportPersonnaliseActif: values.rapportPersonnaliseActif,
        rapportPersonnaliseCode: values.rapportPersonnaliseCode,
        rapportPersonnaliseLibelle: values.rapportPersonnaliseLibelle,
        rapportPersonnaliseChampGeometrie: values.rapportPersonnaliseChampGeometrie,
        rapportPersonnaliseDescription: values.rapportPersonnaliseDescription,
        rapportPersonnaliseSourceSql: values.rapportPersonnaliseIsSpatial ? values.rapportPersonnaliseSourceSqlDebut + " ST_astext(" + values.rapportPersonnaliseChampGeometrie + ") as geometrie " + values.rapportPersonnaliseSourceSqlFin : values.rapportPersonnaliseSourceSql,
        rapportPersonnaliseModule: values.rapportPersonnaliseModule,
        listeGroupeFonctionnalitesId: values.listeGroupeFonctionnalitesId,
        listeRapportPersonnaliseParametre: values.listeRapportPersonnaliseParametre.map((e, index)=>{
            return {
                ...e,
                rapportPersonnaliseParametreOrdre: index,
                rapportPersonnaliseParametreSourceSql: e.rapportPersonnaliseParametreSourceSqlDebut + " " + e.rapportPersonnaliseParametreSourceSqlId + " as id, " + e.rapportPersonnaliseParametreSourceSqlLibelle + " as libelle " + e.rapportPersonnaliseParametreSourceSqlFin
            };
        })
    });
const $37b0287c5fadd5f2$var$RapportPersonnalise = ()=>{
    const { setFieldValue: setFieldValue, values: values } = (0, $bkJfK.useFormikContext)();
    const rapportPersonnaliseTypeModule = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/modules/get-type-module`);
    const groupeFonctionnalitesState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/groupe-fonctionnalites`);
    const listeModule = rapportPersonnaliseTypeModule.data?.map((e)=>({
            id: e,
            code: e,
            libelle: e
        }));
    const [stepActive, setStepActive] = (0, $kc00y.useState)(0);
    function setListeParametres(value) {
        setFieldValue("listeRapportPersonnaliseParametre", value);
    }
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
        children: [
            stepActive === 0 ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                        className: "mt-3",
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                                    name: "rapportPersonnaliseActif",
                                    label: "Actif"
                                })
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                                    label: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                                        children: [
                                            "Code",
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                                                tooltipText: "Code unique du rapport",
                                                tooltipId: "code-rapport-personnalise",
                                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$340bfce9b4df026b), {})
                                            })
                                        ]
                                    }),
                                    name: "rapportPersonnaliseCode",
                                    required: true,
                                    disabled: values?.rapportPersonnaliseProtected
                                })
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                                    label: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                                        children: [
                                            "Libell\xe9",
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                                                tooltipText: "Libell\xe9 du rapport",
                                                tooltipId: "libelle-rapport-personnalise",
                                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$340bfce9b4df026b), {})
                                            })
                                        ]
                                    }),
                                    name: "rapportPersonnaliseLibelle",
                                    required: true
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                        className: "mt-3",
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$eae70af4b4e3f197), {
                                    name: "listeGroupeFonctionnalitesId",
                                    label: "Groupes de fonctionnalit\xe9s ayant le droit d'ex\xe9cuter la requ\xeate",
                                    options: groupeFonctionnalitesState?.data,
                                    getOptionValue: (t)=>t.id,
                                    getOptionLabel: (t)=>t.libelle,
                                    value: values?.listeGroupeFonctionnalitesId?.map((e)=>groupeFonctionnalitesState?.data?.find((r)=>r.id === e)) ?? undefined,
                                    onChange: (groupeFonctionnalites)=>{
                                        const groupeFonctionnalitesId = groupeFonctionnalites.map((e)=>e.id);
                                        groupeFonctionnalitesId.length > 0 ? setFieldValue("listeGroupeFonctionnalitesId", groupeFonctionnalitesId) : setFieldValue("listeGroupeFonctionnalitesId", undefined);
                                    },
                                    isClearable: true,
                                    required: false
                                })
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$d6701e98ab1a6725), {
                                    name: `rapportPersonnaliseModule`,
                                    label: "Rattach\xe9 au module",
                                    options: listeModule,
                                    getOptionValue: (t)=>t.id,
                                    getOptionLabel: (t)=>t.libelle,
                                    onChange: (e)=>{
                                        setFieldValue(`rapportPersonnaliseModule`, listeModule?.find((type)=>type.id === e.id).id);
                                    },
                                    defaultValue: listeModule?.find((type)=>type.id === values.rapportPersonnaliseModule),
                                    required: true,
                                    readOnly: values?.rapportPersonnaliseProtected
                                })
                            })
                        ]
                    })
                ]
            }) : // Si l'élément est protected, on ne donne pas accès à la suite du stepper
            stepActive === 1 && !values.rapportPersonnaliseProtected ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("h3", {
                        children: "Gestion des param\xe8tres de la requ\xeate"
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("p", {
                        children: "Les codes des param\xe8tres seront utilis\xe9 dans la requ\xeate. Eviter les caract\xe8res sp\xe9ciaux et espace."
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                        className: "mt-3",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $0d6bddc95452bd52$export$2e2bcd8739ae039), {
                                typeModule: values.rapportPersonnaliseModule,
                                createComponentToRepeat: (0, $59b90363761e9c71$export$6c041c18691f3c68),
                                nomListe: "listeRapportPersonnaliseParametre",
                                setData: setListeParametres,
                                defaultElement: {
                                    rapportPersonnaliseParametreLibelle: "",
                                    rapportPersonnaliseParametreCode: "",
                                    rapportPersonnaliseParametreIsRequired: false,
                                    rapportPersonnaliseParametreDescription: "",
                                    rapportPersonnaliseParametreType: null
                                }
                            })
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                        className: "mt-3",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                            className: "bg-light border p-2 rounded",
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$340bfce9b4df026b), {}),
                                " Les codes des param\xe8tres que vous pouvez utiliser dans la requ\xeate :",
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("ul", {
                                    children: [
                                        values.listeRapportPersonnaliseParametre.length > 0 && values.listeRapportPersonnaliseParametre.map((e, key)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("li", {
                                                children: e.rapportPersonnaliseParametreCode
                                            }, key)),
                                        (0, $d44cc71db68851bf$export$ece0d44852850b0a).map((param)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("li", {
                                                children: param
                                            }, param))
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                        className: "mt-3",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$ce9b1cc0c34506d0), {
                                name: "rapportPersonnaliseDescription",
                                label: "Description de la requ\xeate",
                                required: false
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                        className: "mt-3",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                                name: "rapportPersonnaliseIsSpatial",
                                label: "Remonte un champ spatial",
                                required: false,
                                onChange: (v)=>{
                                    setFieldValue("rapportPersonnaliseIsSpatial", v.target.checked);
                                    if (v.target.checked && values.rapportPersonnaliseSourceSqlDebut == null) {
                                        setFieldValue("rapportPersonnaliseSourceSqlDebut", "SELECT");
                                        setFieldValue("rapportPersonnaliseSourceSqlFin", "FROM");
                                    } else setFieldValue("rapportPersonnaliseChampGeometrie", null);
                                }
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                        className: "mt-3",
                        children: !values.rapportPersonnaliseIsSpatial ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$ce9b1cc0c34506d0), {
                                name: "rapportPersonnaliseSourceSql",
                                label: "Requ\xeate SQL",
                                rows: 15
                            })
                        }) : /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$ce9b1cc0c34506d0), {
                                        name: "rapportPersonnaliseSourceSqlDebut",
                                        label: "Requ\xeate SQL",
                                        rows: 8
                                    })
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                    className: "m-2",
                                    children: [
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                            children: "St_Astext("
                                        }),
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                                                name: `rapportPersonnaliseChampGeometrie`
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                            children: ") as geometrie"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$ce9b1cc0c34506d0), {
                                        name: "rapportPersonnaliseSourceSqlFin",
                                        rows: 8
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                className: "m-3 text-center",
                children: [
                    stepActive !== 0 && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                            variant: "primary",
                            onClick: ()=>{
                                setStepActive(stepActive - 1);
                            },
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$41884575254a94be), {}),
                                " Pr\xe9c\xe9dent"
                            ]
                        })
                    }),
                    stepActive !== 2 && !values.rapportPersonnaliseProtected && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                            disabled: stepActive === 1 && values.unavailableCode && values.unavailableCode.length > 0 || (0, $c066b242635c27a6$export$2e2bcd8739ae039)(values.rapportPersonnaliseModule) || (0, $c066b242635c27a6$export$2e2bcd8739ae039)(values.rapportPersonnaliseCode) || (0, $c066b242635c27a6$export$2e2bcd8739ae039)(values.rapportPersonnaliseLibelle) || stepActive === 1 && (values.listeRapportPersonnaliseParametre.some((e)=>(0, $c066b242635c27a6$export$2e2bcd8739ae039)(e.rapportPersonnaliseParametreType)) || values.listeRapportPersonnaliseParametre.some((e)=>(0, $c066b242635c27a6$export$2e2bcd8739ae039)(e.rapportPersonnaliseParametreCode)) || values.listeRapportPersonnaliseParametre.some((e)=>(0, $c066b242635c27a6$export$2e2bcd8739ae039)(e.rapportPersonnaliseParametreLibelle)) || values.listeRapportPersonnaliseParametre.filter((e)=>(0, $d44cc71db68851bf$export$3d7fc3ac5152d16e)[e.rapportPersonnaliseParametreType] === (0, $d44cc71db68851bf$export$3d7fc3ac5152d16e).SELECT_INPUT).some((e)=>(0, $c066b242635c27a6$export$2e2bcd8739ae039)(e.rapportPersonnaliseParametreSourceSqlId) || (0, $c066b242635c27a6$export$2e2bcd8739ae039)(e.rapportPersonnaliseParametreSourceSqlLibelle))),
                            variant: "primary",
                            onClick: ()=>setStepActive(stepActive + 1),
                            children: [
                                "Suivant ",
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$3213a407ffb0559), {})
                            ]
                        })
                    })
                ]
            }),
            (stepActive === 2 || values.rapportPersonnaliseProtected) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db9b0e6fdb142a4c$export$2e2bcd8739ae039), {
                returnLink: true
            })
        ]
    });
};
var $37b0287c5fadd5f2$export$2e2bcd8739ae039 = $37b0287c5fadd5f2$var$RapportPersonnalise;


const $1adebabfae3924a1$var$CreateRapportPersonnalise = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                title: "Cr\xe9ation d'un rapport personnalis\xe9",
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$d776d19dfae66ece), {})
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                initialValues: (0, $37b0287c5fadd5f2$export$a5cab80145b70e98)(),
                prepareVariables: (values)=>(0, $37b0287c5fadd5f2$export$f97400759cfd946)(values),
                validationSchema: (0, $37b0287c5fadd5f2$export$c084437b5e3206cd),
                submitUrl: `/api/rapport-personnalise/create/`,
                isPost: true,
                redirectUrl: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_RAPPORT_PERSONNALISE,
                onSubmit: ()=>true,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $37b0287c5fadd5f2$export$2e2bcd8739ae039), {})
            })
        ]
    });
};
var $1adebabfae3924a1$export$2e2bcd8739ae039 = $1adebabfae3924a1$var$CreateRapportPersonnalise;












const $79115d69064b1d7f$var$DuplicateRapportPersonnalise = ()=>{
    const { rapportPersonnaliseId: rapportPersonnaliseId } = (0, $7a844823b04d4282$export$99eaa27ddbbb95ef)();
    const { data: data } = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/rapport-personnalise/get/` + rapportPersonnaliseId);
    return data && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                title: "Duplication d'un rapport personnalis\xe9",
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$62b5e6d9957cff7b), {})
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                initialValues: (0, $37b0287c5fadd5f2$export$a5cab80145b70e98)({
                    ...data,
                    rapportPersonnaliseCode: data.rapportPersonnaliseCode + "_COPY",
                    rapportPersonnaliseLibelle: data.rapportPersonnaliseLibelle + " (copie)",
                    rapportPersonnaliseProtected: false
                }),
                prepareVariables: (values)=>(0, $37b0287c5fadd5f2$export$f97400759cfd946)(values),
                validationSchema: (0, $37b0287c5fadd5f2$export$c084437b5e3206cd),
                submitUrl: `/api/rapport-personnalise/create/`,
                isPost: true,
                redirectUrl: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_RAPPORT_PERSONNALISE,
                onSubmit: ()=>true,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $37b0287c5fadd5f2$export$2e2bcd8739ae039), {})
            })
        ]
    });
};
var $79115d69064b1d7f$export$2e2bcd8739ae039 = $79115d69064b1d7f$var$DuplicateRapportPersonnalise;




var $bkJfK = parcelRequire("bkJfK");










const $9a2756b5e98fa7de$var$getInitialValues = ()=>({
        zipFile: undefined
    });
const $9a2756b5e98fa7de$export$f97400759cfd946 = (values)=>{
    const formData = new FormData();
    formData.append("zipFile", values.zipFile);
    return formData;
};
const $9a2756b5e98fa7de$var$validationSchema = (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({
    zipFile: (0, $36ceaed6faf947af$export$ec3358fdc98c6c51)
});
const $9a2756b5e98fa7de$var$ImportRapportPersonnalise = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                    title: "Importer un rapport personnalis\xe9",
                    icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$c9bef5de7ad5da31), {})
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                    initialValues: $9a2756b5e98fa7de$var$getInitialValues(),
                    validationSchema: $9a2756b5e98fa7de$var$validationSchema,
                    prepareVariables: $9a2756b5e98fa7de$export$f97400759cfd946,
                    submitUrl: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/rapport-personnalise/import`,
                    isMultipartFormData: true,
                    redirectUrl: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_RAPPORT_PERSONNALISE,
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($9a2756b5e98fa7de$var$ImportRapportPersonnaliseForm, {})
                })
            ]
        })
    });
};
const $9a2756b5e98fa7de$var$ImportRapportPersonnaliseForm = ()=>{
    const { setFieldValue: setFieldValue } = (0, $bkJfK.useFormikContext)();
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b57af79a4ab2a1c6), {
                name: "zipFile",
                label: "Fichier ZIP",
                accept: ".zip",
                onChange: (e)=>{
                    setFieldValue("zipFile", e.target.files[0]);
                }
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db9b0e6fdb142a4c$export$2e2bcd8739ae039), {
                returnLink: true
            })
        ]
    });
};
var $9a2756b5e98fa7de$export$2e2bcd8739ae039 = $9a2756b5e98fa7de$var$ImportRapportPersonnalise;




















const $a9f0e3b08007ef74$var$filterValuesToVariable = ({ rapportPersonnaliseActif: rapportPersonnaliseActif, rapportPersonnaliseCode: rapportPersonnaliseCode, rapportPersonnaliseLibelle: rapportPersonnaliseLibelle, rapportPersonnaliseProtected: rapportPersonnaliseProtected, rapportPersonnaliseChampGeometrie: rapportPersonnaliseChampGeometrie, listeGroupeFonctionnalitesId: listeGroupeFonctionnalitesId, rapportPersonnaliseModule: rapportPersonnaliseModule })=>{
    const filter = {};
    $a9f0e3b08007ef74$var$filterProperty(filter, rapportPersonnaliseCode, "rapportPersonnaliseCode");
    $a9f0e3b08007ef74$var$filterProperty(filter, rapportPersonnaliseActif, "rapportPersonnaliseActif");
    $a9f0e3b08007ef74$var$filterProperty(filter, rapportPersonnaliseLibelle, "rapportPersonnaliseLibelle");
    $a9f0e3b08007ef74$var$filterProperty(filter, rapportPersonnaliseProtected, "rapportPersonnaliseProtected");
    $a9f0e3b08007ef74$var$filterProperty(filter, rapportPersonnaliseChampGeometrie, "rapportPersonnaliseChampGeometrie");
    $a9f0e3b08007ef74$var$filterProperty(filter, rapportPersonnaliseModule, "rapportPersonnaliseModule");
    if (listeGroupeFonctionnalitesId?.length > 0) filter.listeGroupeFonctionnalitesId = listeGroupeFonctionnalitesId;
    return filter;
};
var $a9f0e3b08007ef74$export$2e2bcd8739ae039 = $a9f0e3b08007ef74$var$filterValuesToVariable;
function $a9f0e3b08007ef74$var$filterProperty(filter, value, name) {
    if (value?.trim() !== "") filter[name] = value;
}


const $09cdd052c2271909$var$ListRapportPersonnalise = ()=>{
    const groupeFonctionnalitesState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/groupe-fonctionnalites`);
    const rapportPersonnaliseTypeModule = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/modules/get-type-module`);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                    icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$527d32aa1785fdd4), {}),
                    title: "Rapports personnalis\xe9s",
                    right: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8ad69b89456b65bc$export$2e2bcd8739ae039), {
                                    href: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).CREATE_RAPPORT_PERSONNALISE,
                                    title: "Ajouter un rapport"
                                })
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $43f579690a1c166d$export$2e2bcd8739ae039), {
                                    variant: "primary",
                                    pathname: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).IMPORTER_RAPPORT_PERSONNALISE,
                                    children: "Importer"
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $9a9eebc3462fba73$export$2e2bcd8739ae039), {
                    query: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/rapport-personnalise`,
                    columns: [
                        {
                            Header: "Code",
                            accessor: "rapportPersonnaliseCode",
                            sortField: "rapportPersonnaliseCode",
                            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                                type: "text",
                                name: "rapportPersonnaliseCode"
                            })
                        },
                        {
                            Header: "Libell\xe9",
                            accessor: ({ rapportPersonnaliseId: rapportPersonnaliseId, rapportPersonnaliseLibelle: rapportPersonnaliseLibelle, rapportPersonnaliseDescription: rapportPersonnaliseDescription })=>{
                                return {
                                    rapportPersonnaliseId: rapportPersonnaliseId,
                                    rapportPersonnaliseLibelle: rapportPersonnaliseLibelle,
                                    rapportPersonnaliseDescription: rapportPersonnaliseDescription
                                };
                            },
                            sortField: "rapportPersonnaliseLibelle",
                            Cell: (value)=>{
                                return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                                    children: [
                                        value.value.rapportPersonnaliseLibelle,
                                        value.value.rapportPersonnaliseDescription && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                                            tooltipText: value.value.rapportPersonnaliseDescription,
                                            tooltipId: value.value.rapportPersonnaliseId,
                                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$340bfce9b4df026b), {})
                                        })
                                    ]
                                });
                            },
                            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                                type: "text",
                                name: "rapportPersonnaliseLibelle"
                            })
                        },
                        {
                            Header: "Module",
                            accessor: "rapportPersonnaliseModule",
                            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $3744b2a772efdf44$export$2e2bcd8739ae039), {
                                name: "rapportPersonnaliseModule",
                                listIdCodeLibelle: rapportPersonnaliseTypeModule.data?.map((e)=>({
                                        id: e,
                                        code: e,
                                        libelle: e
                                    }))
                            })
                        },
                        {
                            Header: "Groupes de fonctionnalit\xe9s",
                            accessor: "listeGroupeFonctionnalites",
                            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $cc7cbb0460865818$export$2e2bcd8739ae039), {
                                name: "listeGroupeFonctionnalitesId",
                                listIdCodeLibelle: groupeFonctionnalitesState.data
                            })
                        },
                        (0, $b82b937cc97f6f18$export$38dcf858d3ede0e9)({
                            Header: "Spatial",
                            accessor: ({ rapportPersonnaliseChampGeometrie: rapportPersonnaliseChampGeometrie })=>{
                                return rapportPersonnaliseChampGeometrie != null;
                            },
                            sortField: "rapportPersonnaliseChampGeometrie",
                            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eed37ff3d3e1f28c$export$2e2bcd8739ae039), {
                                options: (0, $a4f278cac9030fb1$export$2e2bcd8739ae039),
                                name: "rapportPersonnaliseChampGeometrie"
                            })
                        }),
                        (0, $b82b937cc97f6f18$export$38dcf858d3ede0e9)({
                            Header: "Actif",
                            accessor: "rapportPersonnaliseActif",
                            sortField: "rapportPersonnaliseActif",
                            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eed37ff3d3e1f28c$export$2e2bcd8739ae039), {
                                options: (0, $a4f278cac9030fb1$export$2e2bcd8739ae039),
                                name: "rapportPersonnaliseActif"
                            })
                        }),
                        (0, $b82b937cc97f6f18$export$4f228b0e0fb17419)({
                            Header: "Prot\xe9g\xe9",
                            accessor: "rapportPersonnaliseProtected",
                            sortField: "rapportPersonnaliseProtected",
                            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eed37ff3d3e1f28c$export$2e2bcd8739ae039), {
                                options: (0, $a4f278cac9030fb1$export$2e2bcd8739ae039),
                                name: "rapportPersonnaliseProtected"
                            })
                        }),
                        (0, $b82b937cc97f6f18$export$36e9f5a475c9f6fc)({
                            Header: "Actions",
                            accessor: "rapportPersonnaliseId",
                            buttons: [
                                {
                                    row: (row)=>{
                                        return row;
                                    },
                                    route: (rapportPersonnaliseId)=>(0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).UPDATE_RAPPORT_PERSONNALISE(rapportPersonnaliseId),
                                    type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).UPDATE
                                },
                                {
                                    row: (row)=>{
                                        return row;
                                    },
                                    type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).DELETE,
                                    pathname: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/rapport-personnalise/delete/`,
                                    disable: (row)=>row.original.rapportPersonnaliseProtected,
                                    textDisable: "Impossible de supprimer un rapport prot\xe9g\xe9"
                                },
                                {
                                    row: (row)=>{
                                        return row;
                                    },
                                    route: (rapportPersonnaliseId)=>(0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).DUPLICATE_RAPPORT_PERSONNALISE(rapportPersonnaliseId),
                                    type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).LINK,
                                    textEnable: "Dupliquer le rapport",
                                    icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$62b5e6d9957cff7b), {}),
                                    classEnable: "warning"
                                },
                                {
                                    row: (row)=>{
                                        return row;
                                    },
                                    route: (rapportPersonnaliseId)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/rapport-personnalise/export/` + rapportPersonnaliseId,
                                    type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).BUTTON,
                                    textEnable: "Exporter le rapport",
                                    icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$4a5ccdc9878f4668), {}),
                                    disable: (row)=>row.original.rapportPersonnaliseProtected,
                                    textDisable: "Impossible d'exporter un rapport prot\xe9g\xe9",
                                    classEnable: "warning"
                                }
                            ]
                        })
                    ],
                    idName: "tableRapportPersonnalise",
                    filterValuesToVariable: (0, $a9f0e3b08007ef74$export$2e2bcd8739ae039),
                    filterContext: (0, $9a9eebc3462fba73$export$396ef541d9951d45)({})
                })
            ]
        })
    });
};
var $09cdd052c2271909$export$2e2bcd8739ae039 = $09cdd052c2271909$var$ListRapportPersonnalise;




var $kc00y = parcelRequire("kc00y");









const $1bab07cc7a5e54aa$var$UpdateRapportPersonnalise = ()=>{
    const { rapportPersonnaliseId: rapportPersonnaliseId } = (0, $7a844823b04d4282$export$99eaa27ddbbb95ef)();
    const { data: data } = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/rapport-personnalise/get/` + rapportPersonnaliseId);
    const initialValues = (0, $kc00y.useMemo)(()=>(0, $37b0287c5fadd5f2$export$a5cab80145b70e98)(data), [
        data
    ]);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                title: "Modification d'un rapport personnalis\xe9",
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$b51dd496211ae105), {})
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                initialValues: initialValues,
                prepareVariables: (values)=>(0, $37b0287c5fadd5f2$export$f97400759cfd946)(values),
                validationSchema: (0, $37b0287c5fadd5f2$export$c084437b5e3206cd),
                submitUrl: `/api/rapport-personnalise/update/` + rapportPersonnaliseId,
                isPost: false,
                redirectUrl: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_RAPPORT_PERSONNALISE,
                onSubmit: ()=>true,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $37b0287c5fadd5f2$export$2e2bcd8739ae039), {})
            })
        ]
    });
};
var $1bab07cc7a5e54aa$export$2e2bcd8739ae039 = $1bab07cc7a5e54aa$var$UpdateRapportPersonnalise;




var $bkJfK = parcelRequire("bkJfK");

var $kc00y = parcelRequire("kc00y");







const $285b41d2d2e5cad5$export$a5cab80145b70e98 = (data)=>({
        listeFicheResumeElement: data
    });
const $285b41d2d2e5cad5$export$c084437b5e3206cd = (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({});
const $285b41d2d2e5cad5$export$f97400759cfd946 = (values)=>({
        listeFicheResumeElement: values.listeFicheResumeElement
    });
const $285b41d2d2e5cad5$var$AdminFicheResume = ()=>{
    const { data: data } = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/fiche-resume/get-blocs`);
    const [isDisabledButton, setIsDisabledButton] = (0, $kc00y.useState)(false);
    const availableTypesModulesEmpty = (isEmpty)=>{
        setIsDisabledButton(isEmpty);
    };
    return data && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c269bba4b203358$export$2e2bcd8739ae039), {
        data: data,
        colonneProperty: "ficheResumeBlocColonne",
        ligneProperty: "ficheResumeBlocLigne",
        titreProperty: "ficheResumeBlocTitre",
        pageTitle: "Configurer la fiche de r\xe9sum\xe9 des PEI",
        urlToSubmit: `/api/fiche-resume/upsert`,
        validationSchema: $285b41d2d2e5cad5$export$c084437b5e3206cd,
        getInitialValues: $285b41d2d2e5cad5$export$a5cab80145b70e98,
        prepareVariables: $285b41d2d2e5cad5$export$f97400759cfd946,
        createComponentToRepeat: (index, listeElements)=>$285b41d2d2e5cad5$var$createComponentToRepeat(index, listeElements, availableTypesModulesEmpty),
        name: "listeFicheResumeElement",
        defaultElement: {
            ficheResumeBlocTypeResumeData: null,
            ficheResumeBlocTitre: null,
            ficheResumeBlocColonne: null,
            ficheResumeBlocLigne: null
        },
        disabledSuivant: (e)=>e.ficheResumeBlocTypeResumeData == null || e.ficheResumeBlocTitre == null,
        isDisabledButton: isDisabledButton
    });
};
var $285b41d2d2e5cad5$export$2e2bcd8739ae039 = $285b41d2d2e5cad5$var$AdminFicheResume;
const $285b41d2d2e5cad5$var$ComposantToRepeat = ({ index: index, listeElements: listeElements, onAvailableTypesModulesEmpty: onAvailableTypesModulesEmpty })=>{
    const typesFicheResumeElement = Object.values((0, $885a1319eb55a499$export$2e2bcd8739ae039)).map((key)=>{
        return {
            id: key,
            code: key,
            libelle: key
        };
    });
    // Tous les modules qui ne sont pas déjà placés
    const availableTypesModules = typesFicheResumeElement.filter((typeModule)=>!listeElements.map((e)=>e.ficheResumeBlocTypeResumeData).includes((0, $885a1319eb55a499$export$2e2bcd8739ae039)[typeModule.id]));
    (0, $kc00y.useEffect)(()=>{
        onAvailableTypesModulesEmpty(availableTypesModules.length === 0);
    }, [
        availableTypesModules,
        onAvailableTypesModulesEmpty
    ]);
    const { setFieldValue: setFieldValue } = (0, $bkJfK.useFormikContext)();
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
            className: "align-items-center mt-3",
            children: [
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$d6701e98ab1a6725), {
                        name: `listeFicheResumeElement[${index}].ficheResumeBlocTypeResumeData`,
                        label: "Type",
                        options: availableTypesModules,
                        getOptionValue: (t)=>t.id,
                        getOptionLabel: (t)=>t.libelle,
                        onChange: (e)=>{
                            setFieldValue(`listeFicheResumeElement[${index}].ficheResumeBlocTypeResumeData`, typesFicheResumeElement.find((type)=>type.id === e.id)?.id);
                        },
                        defaultValue: typesFicheResumeElement.find((type)=>type.id === listeElements[index].ficheResumeBlocTypeResumeData),
                        required: true
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                        name: `listeFicheResumeElement[${index}].ficheResumeBlocTitre`,
                        label: "Titre",
                        required: true
                    })
                })
            ]
        })
    });
};
function $285b41d2d2e5cad5$var$createComponentToRepeat(index, listeElements, onAvailableTypesModulesEmpty) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($285b41d2d2e5cad5$var$ComposantToRepeat, {
        index: index,
        listeElements: listeElements,
        onAvailableTypesModulesEmpty: onAvailableTypesModulesEmpty
    });
}






const $f4dec70a56e987ec$var$CreateRoleContact = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1cf1e7fff5b3e31a$export$2e2bcd8739ae039), {
        typeNomenclature: (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).ROLE_CONTACT,
        redirectLink: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_ROLE_CONTACT
    });
};
var $f4dec70a56e987ec$export$2e2bcd8739ae039 = $f4dec70a56e987ec$var$CreateRoleContact;







const $a4ae715c1eab63f2$var$ListRoleContact = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e5bcd0ed5e4cafe8$export$2e2bcd8739ae039), {
            pageTitle: "R\xf4les des contacts",
            addButtonTitle: "Ajouter un r\xf4le de contact",
            pageIcon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$ba2fbb9644c8bf32), {}),
            lienPageAjout: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).ADD_ROLE_CONTACT,
            typeNomenclature: (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).ROLE_CONTACT,
            lienPageUpdate: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).UPDATE_ROLE_CONTACT
        })
    });
};
var $a4ae715c1eab63f2$export$2e2bcd8739ae039 = $a4ae715c1eab63f2$var$ListRoleContact;







const $2d890c99dd2b1995$var$UpdateRoleContact = ()=>{
    const { roleContactId: roleContactId } = (0, $7a844823b04d4282$export$99eaa27ddbbb95ef)();
    return roleContactId && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $4e0326405bcaf2aa$export$2e2bcd8739ae039), {
        nomenclatureId: roleContactId,
        typeNomenclature: (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).ROLE_CONTACT,
        redirectLink: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_ROLE_CONTACT
    });
};
var $2d890c99dd2b1995$export$2e2bcd8739ae039 = $2d890c99dd2b1995$var$UpdateRoleContact;










var $bkJfK = parcelRequire("bkJfK");








const $cf51cc62cfe35c42$var$SignalementSousTypeElement = ({ isUsed: isUsed = false })=>{
    const { values: values, setValues: setValues } = (0, $bkJfK.useFormikContext)();
    const listeTypeElement = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/signalement-sous-type-element/ref`).data;
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                label: "Code",
                name: "signalementSousTypeElementCode",
                required: true
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                label: "Libell\xe9",
                name: "signalementSousTypeElementLibelle",
                required: true
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                name: "signalementSousTypeElementActif",
                label: "Actif"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                name: "signalementSousTypeElementTypeElement",
                label: "Type \xe9l\xe9ment parent",
                listIdCodeLibelle: listeTypeElement,
                setValues: setValues,
                disabled: isUsed,
                defaultValue: listeTypeElement?.find((e)=>e.id === values.signalementSousTypeElementTypeElement),
                required: false
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                name: "signalementSousTypeElementTypeGeometrie",
                label: "Type de g\xe9om\xe9trie",
                listIdCodeLibelle: (0, $72e886a1223521a1$export$36d781030bd6db16),
                setValues: setValues,
                disabled: isUsed,
                defaultValue: (0, $72e886a1223521a1$export$36d781030bd6db16)?.find((e)=>e.id === values.signalementSousTypeElementTypeGeometrie),
                required: true
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db9b0e6fdb142a4c$export$2e2bcd8739ae039), {
                returnLink: true
            })
        ]
    });
};
var $cf51cc62cfe35c42$export$2e2bcd8739ae039 = $cf51cc62cfe35c42$var$SignalementSousTypeElement;
const $cf51cc62cfe35c42$export$a04a503d8277ee43 = (data)=>({
        signalementSousTypeElementCode: data?.signalementSousTypeElementCode ?? null,
        signalementSousTypeElementLibelle: data?.signalementSousTypeElementLibelle ?? null,
        signalementSousTypeElementActif: data?.signalementSousTypeElementActif ?? false,
        signalementSousTypeElementTypeElement: data?.signalementSousTypeElementTypeElement ?? null,
        signalementSousTypeElementTypeGeometrie: data?.signalementSousTypeElementTypeGeometrie ?? null
    });
const $cf51cc62cfe35c42$export$8470ef9d0802da38 = (values)=>({
        signalementSousTypeElementCode: values.signalementSousTypeElementCode,
        signalementSousTypeElementLibelle: values.signalementSousTypeElementLibelle,
        signalementSousTypeElementActif: values.signalementSousTypeElementActif,
        signalementSousTypeElementTypeElement: values.signalementSousTypeElementTypeElement,
        signalementSousTypeElementTypeGeometrie: values.signalementSousTypeElementTypeGeometrie
    });
const $cf51cc62cfe35c42$export$c084437b5e3206cd = (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({
    signalementSousTypeElementCode: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
    signalementSousTypeElementLibelle: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
    signalementSousTypeElementActif: (0, $36ceaed6faf947af$export$87bba3bb7a1f4285),
    // signalementSousTypeElementTypeElement: requiredString, // ISO V2
    signalementSousTypeElementTypeGeometrie: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba)
});


const $455cec8ecf3a2c2a$var$CreateSignalementSousTypeElement = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                title: "Cr\xe9ation d'un sous-type \xe9lement",
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$d776d19dfae66ece), {})
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                initialValues: (0, $cf51cc62cfe35c42$export$a04a503d8277ee43)(),
                prepareVariables: (values)=>(0, $cf51cc62cfe35c42$export$8470ef9d0802da38)(values),
                validationSchema: (0, $cf51cc62cfe35c42$export$c084437b5e3206cd),
                submitUrl: `/api/signalement-sous-type-element/create/`,
                isPost: true,
                redirectUrl: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_SIGNALEMENT_SOUS_TYPE_ELEMENT,
                onSubmit: ()=>true,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $cf51cc62cfe35c42$export$2e2bcd8739ae039), {})
            })
        ]
    });
};
var $455cec8ecf3a2c2a$export$2e2bcd8739ae039 = $455cec8ecf3a2c2a$var$CreateSignalementSousTypeElement;





















const $116c531becbb5c80$var$ListSignalementSousTypeElement = ()=>{
    const { user: user } = (0, $e787cde576104469$export$fdc397e486fa83e7)();
    const listeTypeElement = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/signalement-sous-type-element/ref`).data;
    const listeButton = [];
    const column = [
        {
            Header: "Code",
            accessor: "signalementSousTypeElementCode",
            sortField: "signalementSousTypeElementCode",
            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                type: "text",
                name: "signalementSousTypeElementCode"
            })
        },
        {
            Header: "Libell\xe9",
            accessor: "signalementSousTypeElementLibelle",
            sortField: "signalementSousTypeElementLibelle",
            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                type: "text",
                name: "signalementSousTypeElementLibelle"
            })
        },
        (0, $b82b937cc97f6f18$export$38dcf858d3ede0e9)({
            Header: "Actif",
            accessor: "signalementSousTypeElementActif",
            sortField: "signalementSousTypeElementActif",
            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eed37ff3d3e1f28c$export$2e2bcd8739ae039), {
                options: (0, $a4f278cac9030fb1$export$2e2bcd8739ae039),
                name: "signalementSousTypeElementActif"
            })
        }),
        {
            Header: "Type \xe9l\xe9ment",
            accessor: "signalementTypeElementLibelle",
            sortField: "signalementTypeElementLibelle",
            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $3744b2a772efdf44$export$2e2bcd8739ae039), {
                name: "signalementTypeElementId",
                listIdCodeLibelle: listeTypeElement
            })
        },
        {
            Header: "Type g\xe9om\xe9trie",
            accessor: "signalementSousTypeElementTypeGeometrie",
            sortField: "signalementSousTypeElementTypeGeometrie",
            Cell: (value)=>{
                return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                    children: (0, $72e886a1223521a1$export$36d781030bd6db16).find((e)=>e.code === value.value).libelle
                });
            },
            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $3744b2a772efdf44$export$2e2bcd8739ae039), {
                name: "signalementSousTypeElementTypeGeometrie",
                listIdCodeLibelle: (0, $72e886a1223521a1$export$36d781030bd6db16)
            })
        },
        (0, $b82b937cc97f6f18$export$36e9f5a475c9f6fc)({
            Header: "Actions",
            accessor: "signalementSousTypeElementId",
            buttons: listeButton
        })
    ];
    if ((0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_PARAM_APPLI)) {
        listeButton.push({
            row: (row)=>{
                return row;
            },
            route: (signalementSousTypeElementId)=>(0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).UPDATE_SIGNALEMENT_SOUS_TYPE_ELEMENT(signalementSousTypeElementId),
            type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).UPDATE
        });
        listeButton.push({
            disable: (v)=>v.original.isUsed,
            textDisable: `Impossible de supprimer l'\xe9l\xe9ment car il est utilis\xe9 dans un signalement d\xe9j\xe0 d\xe9clar\xe9.`,
            row: (row)=>{
                return row;
            },
            type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).DELETE,
            pathname: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/signalement-sous-type-element/delete/`
        });
    }
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                title: "Signalement - Sous type \xe9l\xe9ment",
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$6ba70f07963961ce), {}),
                urlRetour: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).MODULE_ADMIN,
                right: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8ad69b89456b65bc$export$2e2bcd8739ae039), {
                    title: "Ajouter un sous type d'\xe9l\xe9ment",
                    href: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).ADD_SIGNALEMENT_SOUS_TYPE_ELEMENT
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $9a9eebc3462fba73$export$2e2bcd8739ae039), {
                columns: column,
                query: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/signalement-sous-type-element/get`,
                idName: "ListNomenclature",
                filterValuesToVariable: $116c531becbb5c80$var$filterValuesToVariable,
                filterContext: (0, $9a9eebc3462fba73$export$396ef541d9951d45)({
                    signalementSousTypeElementCode: undefined,
                    signalementSousTypeElementLibelle: undefined,
                    signalementSousTypeElementActif: undefined,
                    signalementTypeElementId: undefined,
                    signalementSousTypeElementTypeGeometrie: undefined
                })
            })
        ]
    });
};
var $116c531becbb5c80$export$2e2bcd8739ae039 = $116c531becbb5c80$var$ListSignalementSousTypeElement;
const $116c531becbb5c80$var$filterValuesToVariable = ({ signalementSousTypeElementCode: signalementSousTypeElementCode, signalementSousTypeElementLibelle: signalementSousTypeElementLibelle, signalementSousTypeElementActif: signalementSousTypeElementActif, signalementTypeElementId: signalementTypeElementId, signalementSousTypeElementTypeGeometrie: signalementSousTypeElementTypeGeometrie })=>{
    const filter = {};
    if (signalementSousTypeElementCode != null && signalementSousTypeElementCode.trim() !== "") filter.signalementSousTypeElementCode = signalementSousTypeElementCode;
    if (signalementSousTypeElementLibelle != null && signalementSousTypeElementLibelle.trim() !== "") filter.signalementSousTypeElementLibelle = signalementSousTypeElementLibelle;
    if (signalementSousTypeElementActif != null && signalementSousTypeElementActif.trim() !== "") filter.signalementSousTypeElementActif = signalementSousTypeElementActif;
    if (signalementTypeElementId != null && signalementTypeElementId.trim() !== "") filter.signalementTypeElementId = signalementTypeElementId;
    if (signalementSousTypeElementTypeGeometrie != null && signalementSousTypeElementTypeGeometrie.trim() !== "") filter.signalementSousTypeElementTypeGeometrie = signalementSousTypeElementTypeGeometrie;
    return filter;
};












const $68ce6420a68f6106$var$UpdateSignalementSousTypeElement = ()=>{
    const { signalementSousTypeElementId: signalementSousTypeElementId } = (0, $7a844823b04d4282$export$99eaa27ddbbb95ef)();
    const data = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/signalement-sous-type-element/get/${signalementSousTypeElementId}`).data;
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                title: "Modification d'un sous-type \xe9lement",
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$d776d19dfae66ece), {})
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                initialValues: (0, $cf51cc62cfe35c42$export$a04a503d8277ee43)(data?.signalementSousTypeElement),
                prepareVariables: (values)=>(0, $cf51cc62cfe35c42$export$8470ef9d0802da38)(values),
                validationSchema: (0, $cf51cc62cfe35c42$export$c084437b5e3206cd),
                submitUrl: `/api/signalement-sous-type-element/update/${signalementSousTypeElementId}`,
                isPost: false,
                redirectUrl: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_SIGNALEMENT_SOUS_TYPE_ELEMENT,
                onSubmit: ()=>true,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $cf51cc62cfe35c42$export$2e2bcd8739ae039), {
                    isUsed: data?.isUsed
                })
            })
        ]
    });
};
var $68ce6420a68f6106$export$2e2bcd8739ae039 = $68ce6420a68f6106$var$UpdateSignalementSousTypeElement;






const $404080517c04162c$var$CreateSignalementTypeAnomalie = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1cf1e7fff5b3e31a$export$2e2bcd8739ae039), {
        typeNomenclature: (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).SIGNALEMENT_TYPE_ANOMALIE,
        redirectLink: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_SIGNALEMENT_TYPE_ANOMALIE,
        titrePage: "Signalement - Cr\xe9ation d'un type d'anomalie"
    });
};
var $404080517c04162c$export$2e2bcd8739ae039 = $404080517c04162c$var$CreateSignalementTypeAnomalie;







const $8c2f2bdaaecbf5a8$var$ListSignalementTypeAnomalie = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e5bcd0ed5e4cafe8$export$2e2bcd8739ae039), {
            pageTitle: "Signalement - Type anomalie",
            addButtonTitle: "Ajouter un type d'anomalie",
            pageIcon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$6ba70f07963961ce), {}),
            lienPageAjout: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).ADD_SIGNALEMENT_TYPE_ANOMALIE,
            typeNomenclature: (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).SIGNALEMENT_TYPE_ANOMALIE,
            lienPageUpdate: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).UPDATE_SIGNALEMENT_TYPE_ANOMALIE,
            hasProtectedValue: false
        })
    });
};
var $8c2f2bdaaecbf5a8$export$2e2bcd8739ae039 = $8c2f2bdaaecbf5a8$var$ListSignalementTypeAnomalie;







const $411736c61ae06e8d$var$UpdateSignalementTypeAnomalie = ()=>{
    const { signalementTypeAnomalieId: signalementTypeAnomalieId } = (0, $7a844823b04d4282$export$99eaa27ddbbb95ef)();
    return signalementTypeAnomalieId && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $4e0326405bcaf2aa$export$2e2bcd8739ae039), {
        nomenclatureId: signalementTypeAnomalieId,
        typeNomenclature: (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).SIGNALEMENT_TYPE_ANOMALIE,
        redirectLink: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_SIGNALEMENT_TYPE_ANOMALIE,
        titrePage: "Signalement - Modification d'un type d'anomalie"
    });
};
var $411736c61ae06e8d$export$2e2bcd8739ae039 = $411736c61ae06e8d$var$UpdateSignalementTypeAnomalie;






const $f51523342d52bb2c$var$CreateSignalementTypeElement = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1cf1e7fff5b3e31a$export$2e2bcd8739ae039), {
        typeNomenclature: (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).SIGNALEMENT_TYPE_ELEMENT,
        redirectLink: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_SIGNALEMENT_TYPE_ANOMALIE,
        titrePage: "Signalement - Cr\xe9ation d'un type d'element"
    });
};
var $f51523342d52bb2c$export$2e2bcd8739ae039 = $f51523342d52bb2c$var$CreateSignalementTypeElement;







const $17aae1c75e7b31d5$var$ListSignalementTypeElement = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e5bcd0ed5e4cafe8$export$2e2bcd8739ae039), {
            pageTitle: "Signalement - Type \xe9l\xe9ment",
            addButtonTitle: "Ajouter un type d'\xe9l\xe9ment",
            pageIcon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$6ba70f07963961ce), {}),
            lienPageAjout: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).ADD_SIGNALEMENT_TYPE_ELEMENT,
            typeNomenclature: (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).SIGNALEMENT_TYPE_ELEMENT,
            lienPageUpdate: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).UPDATE_SIGNALEMENT_TYPE_ELEMENT,
            hasProtectedValue: false
        })
    });
};
var $17aae1c75e7b31d5$export$2e2bcd8739ae039 = $17aae1c75e7b31d5$var$ListSignalementTypeElement;







const $af10b9b976e5877a$var$UpdateSignalementTypeElement = ()=>{
    const { signalementTypeElementId: signalementTypeElementId } = (0, $7a844823b04d4282$export$99eaa27ddbbb95ef)();
    return signalementTypeElementId && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $4e0326405bcaf2aa$export$2e2bcd8739ae039), {
        nomenclatureId: signalementTypeElementId,
        typeNomenclature: (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).SIGNALEMENT_TYPE_ELEMENT,
        redirectLink: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_SIGNALEMENT_TYPE_ELEMENT,
        titrePage: "Signalement - Modification d'un type d'element"
    });
};
var $af10b9b976e5877a$export$2e2bcd8739ae039 = $af10b9b976e5877a$var$UpdateSignalementTypeElement;




var $bkJfK = parcelRequire("bkJfK");





















const $b4b03972ec4613b3$var$FilterValues = ({ siteCode: siteCode, siteLibelle: siteLibelle, siteGestionnaireId: siteGestionnaireId, siteActif: siteActif })=>{
    const filter = {};
    $b4b03972ec4613b3$var$filterProperty(filter, siteCode, "siteCode");
    $b4b03972ec4613b3$var$filterProperty(filter, siteLibelle, "siteLibelle");
    $b4b03972ec4613b3$var$filterProperty(filter, siteActif, "siteActif");
    $b4b03972ec4613b3$var$filterProperty(filter, siteGestionnaireId, "siteGestionnaireId");
    return filter;
};
function $b4b03972ec4613b3$var$filterProperty(filter, value, name) {
    if (value != null && value.trim() !== "") filter[name] = value;
}
var $b4b03972ec4613b3$export$2e2bcd8739ae039 = $b4b03972ec4613b3$var$FilterValues;


const $b078d110eb631d6f$export$a5cab80145b70e98 = ()=>({
        fileSites: null
    });
const $b078d110eb631d6f$export$c084437b5e3206cd = (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({});
const $b078d110eb631d6f$export$f97400759cfd946 = (values)=>{
    const formData = new FormData();
    formData.append("fileSites", values.fileSites);
    return formData;
};
const $b078d110eb631d6f$var$ListSite = ()=>{
    const { user: user } = (0, $e787cde576104469$export$fdc397e486fa83e7)();
    const { data: data } = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/gestionnaire/get`);
    const listeButton = [];
    if ((0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).GEST_SITE_A)) {
        listeButton.push({
            row: (row)=>{
                return row;
            },
            route: (siteId)=>(0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).UPDATE_SITE(siteId),
            type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).UPDATE
        });
        listeButton.push({
            row: (row)=>{
                return row;
            },
            type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).DELETE,
            pathname: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/site/delete/`
        });
    }
    const { handleShowClose: handleShowClose, activesKeys: activesKeys } = (0, $db860d90b4a42fea$export$dae930a4ba30758b)([
        false
    ]);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                    icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$527d32aa1785fdd4), {}),
                    title: "Sites"
                }),
                (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).GEST_SITE_A) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db860d90b4a42fea$export$2e2bcd8739ae039), {
                            activesKeys: activesKeys,
                            handleShowClose: handleShowClose,
                            list: [
                                {
                                    header: "Importer des sites ",
                                    content: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("p", {
                                                children: "Permet d'importer un fichier SHAPE contenant des sites ; l'identification se fait sur le code, avec un m\xe9canisme d'insertion / mise \xe0 jour."
                                            }),
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                                                initialValues: $b078d110eb631d6f$export$a5cab80145b70e98(),
                                                validationSchema: $b078d110eb631d6f$export$c084437b5e3206cd,
                                                isPost: false,
                                                isMultipartFormData: true,
                                                submitUrl: `/api/site/import/`,
                                                prepareVariables: (values)=>$b078d110eb631d6f$export$f97400759cfd946(values),
                                                redirectUrl: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_SITE,
                                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($b078d110eb631d6f$var$FormImportShape, {})
                                            })
                                        ]
                                    })
                                }
                            ]
                        }),
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {})
                    ]
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $9a9eebc3462fba73$export$2e2bcd8739ae039), {
                    query: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/site`,
                    columns: [
                        {
                            Header: "Code",
                            accessor: "siteCode",
                            sortField: "siteCode",
                            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                                type: "text",
                                name: "siteCode"
                            })
                        },
                        {
                            Header: "Libell\xe9",
                            accessor: "siteLibelle",
                            sortField: "siteLibelle",
                            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                                type: "text",
                                name: "siteLibelle"
                            })
                        },
                        (0, $b82b937cc97f6f18$export$38dcf858d3ede0e9)({
                            Header: "Actif",
                            accessor: "siteActif",
                            sortField: "siteActif",
                            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eed37ff3d3e1f28c$export$2e2bcd8739ae039), {
                                options: (0, $a4f278cac9030fb1$export$2e2bcd8739ae039),
                                name: "siteActif"
                            })
                        }),
                        {
                            Header: "Gestionnaire",
                            accessor: "gestionnaireLibelle",
                            sortField: "gestionnaireLibelle",
                            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $3744b2a772efdf44$export$2e2bcd8739ae039), {
                                name: "siteGestionnaireId",
                                listIdCodeLibelle: data
                            })
                        },
                        (0, $b82b937cc97f6f18$export$36e9f5a475c9f6fc)({
                            Header: "Actions",
                            accessor: "siteId",
                            buttons: listeButton
                        })
                    ],
                    idName: "tableSite",
                    filterValuesToVariable: (0, $b4b03972ec4613b3$export$2e2bcd8739ae039),
                    filterContext: (0, $9a9eebc3462fba73$export$396ef541d9951d45)({
                        siteCode: undefined,
                        siteLibelle: undefined,
                        siteActif: undefined,
                        siteGestionnaireId: undefined
                    })
                })
            ]
        })
    });
};
const $b078d110eb631d6f$var$FormImportShape = ()=>{
    const { setFieldValue: setFieldValue } = (0, $bkJfK.useFormikContext)();
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b57af79a4ab2a1c6), {
                name: "fileSites",
                accept: ".zip",
                label: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                    children: [
                        "Fichier zip contenant les sites",
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                            placement: "right",
                            tooltipText: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("strong", {
                                                children: [
                                                    "the_geom ",
                                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("span", {
                                                        className: "text-danger",
                                                        children: "*"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                                className: "ms-2",
                                                children: "La g\xe9om\xe9trie en Polygon"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("strong", {
                                                children: [
                                                    "code ",
                                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("span", {
                                                        className: "text-danger",
                                                        children: "*"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                                className: "ms-2",
                                                children: "Code (unique) du site"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("strong", {
                                                children: [
                                                    "libelle ",
                                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("span", {
                                                        className: "text-danger",
                                                        children: "*"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                                className: "ms-2",
                                                children: "Libell\xe9 du site"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("span", {
                                                    className: "text-danger",
                                                    children: "*"
                                                }),
                                                " : Champs obligatoires"
                                            ]
                                        })
                                    })
                                ]
                            }),
                            tooltipHeader: "Colonnes attendues",
                            tooltipId: "site",
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$340bfce9b4df026b), {})
                        })
                    ]
                }),
                required: false,
                onChange: (e)=>setFieldValue("fileSites", e.target.files[0])
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                className: "mt-3",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                    className: "text-center",
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                        type: "submit",
                        variant: "primary",
                        children: "Valider"
                    })
                })
            })
        ]
    });
};
var $b078d110eb631d6f$export$2e2bcd8739ae039 = $b078d110eb631d6f$var$ListSite;













var $bkJfK = parcelRequire("bkJfK");






const $60aea99d18224485$export$a5cab80145b70e98 = (data)=>({
        siteGestionnaireId: data?.siteGestionnaireId ?? null,
        siteCode: data?.siteCode ?? null,
        siteLibelle: data?.siteLibelle ?? null,
        siteActif: data?.siteActif ?? false
    });
const $60aea99d18224485$export$c084437b5e3206cd = (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({});
const $60aea99d18224485$export$f97400759cfd946 = (values)=>({
        siteGestionnaireId: values.siteGestionnaireId,
        siteCode: values.siteCode,
        siteLibelle: values.siteLibelle,
        siteActif: values.siteActif
    });
const $60aea99d18224485$var$Site = ()=>{
    const { values: values, setValues: setValues } = (0, $bkJfK.useFormikContext)();
    const { data: data } = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/gestionnaire/get`);
    if (!data) return;
    const defaultGestionnaireId = data.find((gestionnaire)=>{
        return gestionnaire.id === values.siteGestionnaireId;
    });
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("h3", {
                className: "mt-1",
                children: "Informations g\xe9n\xe9rales"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                label: "Code",
                name: "siteCode",
                required: true
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                label: "Libell\xe9",
                name: "siteLibelle",
                required: true
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                name: "siteActif",
                label: "Actif"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                name: "siteGestionnaireId",
                label: "Gestionnaire",
                listIdCodeLibelle: data,
                setValues: setValues,
                defaultValue: defaultGestionnaireId
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db9b0e6fdb142a4c$export$2e2bcd8739ae039), {
                returnLink: true
            })
        ]
    });
};
var $60aea99d18224485$export$2e2bcd8739ae039 = $60aea99d18224485$var$Site;


const $bc67effde39fde39$var$UpdateSite = ()=>{
    const { siteId: siteId } = (0, $7a844823b04d4282$export$99eaa27ddbbb95ef)();
    const siteState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/site/` + siteId);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$3caee6c66795d211), {}),
                title: "Mise \xe0 jour d'un site"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                initialValues: (0, $60aea99d18224485$export$a5cab80145b70e98)(siteState?.data),
                validationSchema: (0, $60aea99d18224485$export$c084437b5e3206cd),
                isPost: false,
                submitUrl: `/api/site/update/` + siteId,
                prepareVariables: (values)=>(0, $60aea99d18224485$export$f97400759cfd946)(values),
                redirectUrl: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_SITE,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $60aea99d18224485$export$2e2bcd8739ae039), {})
            })
        ]
    });
};
var $bc67effde39fde39$export$2e2bcd8739ae039 = $bc67effde39fde39$var$UpdateSite;






function $fa3e410abd05cb1d$export$4393d2ccbbedb219(argument, options) {
    const invalidDate = ()=>(0, $074d8b7777dc6b36$export$ead8a1812b171991)(options?.in, NaN);
    const additionalDigits = options?.additionalDigits ?? 2;
    const dateStrings = $fa3e410abd05cb1d$var$splitDateString(argument);
    let date;
    if (dateStrings.date) {
        const parseYearResult = $fa3e410abd05cb1d$var$parseYear(dateStrings.date, additionalDigits);
        date = $fa3e410abd05cb1d$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(+date)) return invalidDate();
    const timestamp = +date;
    let time = 0;
    let offset;
    if (dateStrings.time) {
        time = $fa3e410abd05cb1d$var$parseTime(dateStrings.time);
        if (isNaN(time)) return invalidDate();
    }
    if (dateStrings.timezone) {
        offset = $fa3e410abd05cb1d$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return invalidDate();
    } else {
        const tmpDate = new Date(timestamp + time);
        const result = (0, $189325ccd94be08c$export$e67a095c620b86fe)(0, options?.in);
        result.setFullYear(tmpDate.getUTCFullYear(), tmpDate.getUTCMonth(), tmpDate.getUTCDate());
        result.setHours(tmpDate.getUTCHours(), tmpDate.getUTCMinutes(), tmpDate.getUTCSeconds(), tmpDate.getUTCMilliseconds());
        return result;
    }
    return (0, $189325ccd94be08c$export$e67a095c620b86fe)(timestamp + time + offset, options?.in);
}
const $fa3e410abd05cb1d$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
const $fa3e410abd05cb1d$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
const $fa3e410abd05cb1d$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
const $fa3e410abd05cb1d$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $fa3e410abd05cb1d$var$splitDateString(dateString) {
    const dateStrings = {};
    const array = dateString.split($fa3e410abd05cb1d$var$patterns.dateTimeDelimiter);
    let timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($fa3e410abd05cb1d$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($fa3e410abd05cb1d$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        const token = $fa3e410abd05cb1d$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], "");
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $fa3e410abd05cb1d$var$parseYear(dateString, additionalDigits) {
    const regex = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + additionalDigits) + "})|(\\d{2}|[+-]\\d{" + (2 + additionalDigits) + "})$)");
    const captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ""
    };
    const year = captures[1] ? parseInt(captures[1]) : null;
    const century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $fa3e410abd05cb1d$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    const captures = dateString.match($fa3e410abd05cb1d$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    const isWeekDate = !!captures[4];
    const dayOfYear = $fa3e410abd05cb1d$var$parseDateUnit(captures[1]);
    const month = $fa3e410abd05cb1d$var$parseDateUnit(captures[2]) - 1;
    const day = $fa3e410abd05cb1d$var$parseDateUnit(captures[3]);
    const week = $fa3e410abd05cb1d$var$parseDateUnit(captures[4]);
    const dayOfWeek = $fa3e410abd05cb1d$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$fa3e410abd05cb1d$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $fa3e410abd05cb1d$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        const date = new Date(0);
        if (!$fa3e410abd05cb1d$var$validateDate(year, month, day) || !$fa3e410abd05cb1d$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $fa3e410abd05cb1d$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $fa3e410abd05cb1d$var$parseTime(timeString) {
    const captures = timeString.match($fa3e410abd05cb1d$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    const hours = $fa3e410abd05cb1d$var$parseTimeUnit(captures[1]);
    const minutes = $fa3e410abd05cb1d$var$parseTimeUnit(captures[2]);
    const seconds = $fa3e410abd05cb1d$var$parseTimeUnit(captures[3]);
    if (!$fa3e410abd05cb1d$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, $36f05d0f10127335$export$7f72910d6dfd237a) + minutes * (0, $36f05d0f10127335$export$91246f0b9bd9beff) + seconds * 1000;
}
function $fa3e410abd05cb1d$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(",", ".")) || 0;
}
function $fa3e410abd05cb1d$var$parseTimezone(timezoneString) {
    if (timezoneString === "Z") return 0;
    const captures = timezoneString.match($fa3e410abd05cb1d$var$timezoneRegex);
    if (!captures) return 0;
    const sign = captures[1] === "+" ? -1 : 1;
    const hours = parseInt(captures[2]);
    const minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$fa3e410abd05cb1d$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, $36f05d0f10127335$export$7f72910d6dfd237a) + minutes * (0, $36f05d0f10127335$export$91246f0b9bd9beff));
}
function $fa3e410abd05cb1d$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    const date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    const fourthOfJanuaryDay = date.getUTCDay() || 7;
    const diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
const $fa3e410abd05cb1d$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $fa3e410abd05cb1d$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $fa3e410abd05cb1d$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($fa3e410abd05cb1d$var$daysInMonths[month] || ($fa3e410abd05cb1d$var$isLeapYearIndex(year) ? 29 : 28));
}
function $fa3e410abd05cb1d$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($fa3e410abd05cb1d$var$isLeapYearIndex(year) ? 366 : 365);
}
function $fa3e410abd05cb1d$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $fa3e410abd05cb1d$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $fa3e410abd05cb1d$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}
var // Fallback for modularized imports:
$fa3e410abd05cb1d$export$2e2bcd8739ae039 = $fa3e410abd05cb1d$export$4393d2ccbbedb219;



var $bkJfK = parcelRequire("bkJfK");

var $kc00y = parcelRequire("kc00y");


var $kc00y = parcelRequire("kc00y");


var $lCkAA = parcelRequire("lCkAA");

function $3640abe270691aeb$export$3d03cefad97f5c33(propType) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).oneOfType([
        propType,
        (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).shape({
            xs: propType,
            sm: propType,
            md: propType,
            lg: propType,
            xl: propType,
            xxl: propType
        })
    ]);
}
function $3640abe270691aeb$export$2e2bcd8739ae039(utilityValues, breakpoints = (0, $6c3886f519efe212$export$666ad80b5007f835), minBreakpoint = (0, $6c3886f519efe212$export$ff817e17bad2e091)) {
    const classes = [];
    Object.entries(utilityValues).forEach(([utilName, utilValue])=>{
        if (utilValue != null) {
            if (typeof utilValue === 'object') breakpoints.forEach((brkPoint)=>{
                const bpValue = utilValue[brkPoint];
                if (bpValue != null) {
                    const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : '';
                    classes.push(`${utilName}${infix}-${bpValue}`);
                }
            });
            else classes.push(`${utilName}-${utilValue}`);
        }
    });
    return classes;
}



"use client";
const $b7f3d0332d09749f$var$Stack = /*#__PURE__*/ $kc00y.forwardRef(({ as: Component = 'div', bsPrefix: bsPrefix, className: className, direction: direction, gap: gap, ...props }, ref)=>{
    bsPrefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(bsPrefix, direction === 'horizontal' ? 'hstack' : 'vstack');
    const breakpoints = (0, $6c3886f519efe212$export$8970c8db816a5863)();
    const minBreakpoint = (0, $6c3886f519efe212$export$d926d6ef38f3fd32)();
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, bsPrefix, ...(0, $3640abe270691aeb$export$2e2bcd8739ae039)({
            gap: gap
        }, breakpoints, minBreakpoint))
    });
});
$b7f3d0332d09749f$var$Stack.displayName = 'Stack';
var $b7f3d0332d09749f$export$2e2bcd8739ae039 = $b7f3d0332d09749f$var$Stack;













const $ba13a167ca839a16$export$14a2d388602b1453 = ()=>{
    const { data: data, isLoading: isLoading } = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)("/api/tracabilite/refs");
    const typeOperations = data ? data.typeOperations.map($ba13a167ca839a16$var$stringToSelectOption) : [];
    const typeObjets = data ? data.typeObjets.map($ba13a167ca839a16$var$stringToSelectOption) : [];
    const typeUtilisateurs = data ? data.typeUtilisateurs.map($ba13a167ca839a16$var$stringToSelectOption) : [];
    return {
        typeOperations: typeOperations,
        typeObjets: typeObjets,
        typeUtilisateurs: typeUtilisateurs,
        isLoading: isLoading
    };
};
const $ba13a167ca839a16$var$stringToSelectOption = (s)=>({
        label: s,
        value: s
    });


const $b5cdcb80485d2f83$var$HistoriqueOperations = ()=>{
    const { typeOperations: typeOperations, typeObjets: typeObjets, typeUtilisateurs: typeUtilisateurs, isLoading: isLoading } = (0, $ba13a167ca839a16$export$14a2d388602b1453)();
    const [searchParams] = (0, $0608a055a17e1a05$export$f1a78c17382fe22a)();
    const navigate = (0, $7a844823b04d4282$export$9770f232ac06a008)();
    const location = (0, $7a844823b04d4282$export$45d76561a5302f2b)();
    const { run: run, data: data } = (0, $8d9ebd8892d8a5f5$export$6326fb4463ae1be4)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/tracabilite/search?${searchParams}`, {});
    const { success: successToast } = (0, $6bdae0bad7b05751$export$91b3d218c74c79e4)();
    const tracabilites = searchParams.size ? data || [] : [];
    const initialValues = (0, $kc00y.useMemo)(()=>{
        return {
            typeObjet: searchParams.get("typeObjet"),
            typeOperation: searchParams.get("typeOperation"),
            typeUtilisateur: searchParams.get("typeUtilisateur"),
            debut: (0, $c082c553d4c367ee$export$1ea939691cdc45b8)((0, $fa3e410abd05cb1d$export$4393d2ccbbedb219)(searchParams.get("debut") ?? "")) ? searchParams.get("debut") : "",
            fin: (0, $c082c553d4c367ee$export$1ea939691cdc45b8)((0, $fa3e410abd05cb1d$export$4393d2ccbbedb219)(searchParams.get("fin") ?? "")) ? searchParams.get("fin") : "",
            utilisateur: searchParams.get("utilisateur") ?? "",
            objetId: searchParams.get("objetId") ?? ""
        };
    }, [
        searchParams
    ]);
    (0, $kc00y.useEffect)(()=>{
        if (data?.length === 0) successToast("Aucune donn\xe9e pour cette recherche.");
    }, [
        data,
        successToast
    ]);
    (0, $kc00y.useEffect)(()=>{
        if (!searchParams.size) return;
        const hasSomeValueFiltered = searchParams.keys().some((k)=>Object.keys(initialValues).includes(k));
        if (hasSomeValueFiltered) run();
    }, [
        searchParams,
        run,
        initialValues
    ]);
    if (isLoading) return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $c21b1c237cfa1d94$export$2e2bcd8739ae039), {});
    const handleSubmit = (values)=>{
        //@ts-expect-error url n'est pas content si on passe une variable string et non object 🤔
        navigate((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`${(0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).HISTORIQUE_OPERATIONS}?${$b5cdcb80485d2f83$var$nullifyEmptyValue(values)}`, {
            state: location.state
        });
    };
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                title: "Historique des op\xe9rations",
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$16fcff7afd79949), {})
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                className: "justify-content-md-center",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                    className: "p-2 border rounded mx-2",
                    xs: 5,
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $bkJfK.Formik), {
                        initialValues: initialValues,
                        enableReinitialize: true,
                        onSubmit: handleSubmit,
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($b5cdcb80485d2f83$var$SearchForm, {
                            typeObjets: typeObjets,
                            typeOperations: typeOperations,
                            typeUtilisateurs: typeUtilisateurs
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                className: "mt-5",
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("h4", {
                        children: "R\xe9sultats de la recherche"
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $13de46b4dfcc473f$export$2e2bcd8739ae039), {
                        bordered: true,
                        striped: true,
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("thead", {
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("th", {
                                            children: "Type objet"
                                        }),
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("th", {
                                            children: "Type op\xe9ration"
                                        }),
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("th", {
                                            children: "Date / Heure"
                                        }),
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("th", {
                                            children: "Auteur"
                                        }),
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("th", {
                                            children: "Objet"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("tbody", {
                                children: tracabilites.length > 0 && tracabilites.map((d, i)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("td", {
                                                children: d.tracabiliteTypeObjet
                                            }),
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("td", {
                                                children: d.tracabiliteTypeOperation
                                            }),
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("td", {
                                                children: (0, $00c47c7740afd024$export$c74325cff954054e)(d.tracabiliteDate)
                                            }),
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("td", {
                                                children: [
                                                    "nom : ",
                                                    d.tracabiliteAuteurData.prenom,
                                                    " ",
                                                    d.tracabiliteAuteurData.nom,
                                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                                                    "email : ",
                                                    d.tracabiliteAuteurData.email
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("td", {
                                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("pre", {
                                                    children: JSON.stringify(d.tracabiliteObjetData, null, 2)
                                                })
                                            })
                                        ]
                                    }, i))
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $b5cdcb80485d2f83$export$2e2bcd8739ae039 = $b5cdcb80485d2f83$var$HistoriqueOperations;
const $b5cdcb80485d2f83$var$SearchForm = ({ typeOperations: typeOperations, typeObjets: typeObjets, typeUtilisateurs: typeUtilisateurs })=>{
    const { values: values, setFieldValue: setFieldValue } = (0, $bkJfK.useFormikContext)();
    const navigate = (0, $7a844823b04d4282$export$9770f232ac06a008)();
    const location = (0, $7a844823b04d4282$export$45d76561a5302f2b)();
    const handleReset = ()=>{
        navigate((0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).HISTORIQUE_OPERATIONS, {
            state: location.state
        });
    };
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$842aba50ed0ce9d7), {
                label: "Type d'objet",
                name: "typeObjets",
                required: false
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$d6701e98ab1a6725), {
                name: "typeObjet",
                required: false,
                isClearable: true,
                options: typeObjets,
                getOptionLabel: (d)=>d.label,
                getOptionValue: (d)=>d.value,
                onChange: (e)=>setFieldValue("typeObjet", typeObjets.find((to)=>to.value === e?.value)?.value),
                defaultValue: typeObjets.find((to)=>to.value === values.typeObjet) ?? null
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$842aba50ed0ce9d7), {
                label: "Type d'op\xe9ration",
                name: "typeOperations",
                required: false
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$d6701e98ab1a6725), {
                name: "typeOperation",
                required: false,
                isClearable: true,
                options: typeOperations,
                getOptionLabel: (d)=>d.label,
                getOptionValue: (d)=>d.value,
                onChange: (e)=>setFieldValue("typeOperation", typeOperations.find((to)=>to.value === e?.value)?.value),
                defaultValue: typeOperations.find((to)=>to.value === values.typeOperation) ?? null
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$842aba50ed0ce9d7), {
                label: "P\xe9riode",
                name: "periode",
                required: false,
                tooltipText: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                    children: [
                        "Saisies possibles :",
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("ul", {
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("li", {
                                    children: "date de d\xe9but uniquement"
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("li", {
                                    children: "date de fin uniquement"
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("li", {
                                    children: "date de d\xe9but et date de fin"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$183478aa40b5df1), {
                            name: "debut",
                            dateType: "datetime-local",
                            required: false
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$183478aa40b5df1), {
                            name: "fin",
                            dateType: "datetime-local",
                            required: false
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$842aba50ed0ce9d7), {
                label: "Type d'utilisateur",
                name: "typeUtilisateurs",
                required: false
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$d6701e98ab1a6725), {
                name: "typeUtilisateur",
                required: false,
                isClearable: true,
                options: typeUtilisateurs,
                getOptionLabel: (d)=>d.label,
                getOptionValue: (d)=>d.value,
                onChange: (e)=>{
                    setFieldValue("typeUtilisateur", typeUtilisateurs.find((to)=>to.value === e?.value)?.value);
                },
                defaultValue: typeUtilisateurs.find((to)=>to.value === values.typeUtilisateur) ?? null
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$842aba50ed0ce9d7), {
                label: "Utilisateur",
                name: "utilisateur",
                required: false,
                tooltipText: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
                    children: "Recherche inclusive (=\"contient la saisie\") insensible \xe0 la casse sur le nom, le pr\xe9nom et l'email de l'auteur de la modification"
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                name: "utilisateur",
                required: false
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$842aba50ed0ce9d7), {
                label: "Id de l'objet",
                name: "objetId",
                required: false
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                name: "objetId",
                required: false
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $b7f3d0332d09749f$export$2e2bcd8739ae039), {
                direction: "horizontal",
                gap: 2,
                className: "mt-3 justify-content-end",
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                        variant: "secondary",
                        type: "reset",
                        onClick: handleReset,
                        children: "R\xe9initialiser"
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                        type: "submit",
                        children: "Rechercher"
                    })
                ]
            })
        ]
    });
};
const $b5cdcb80485d2f83$var$nullifyEmptyValue = (values)=>Object.keys(values).reduce((acc, k)=>({
            ...acc,
            [k]: values[k] === "" ? null : values[k]
        }), values);






const $5f12451354e1008d$var$CreateTypeOrganisme = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1cf1e7fff5b3e31a$export$2e2bcd8739ae039), {
        typeNomenclature: (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).TYPE_ORGANISME,
        redirectLink: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_TYPE_ORGANISME,
        titrePage: "Cr\xe9ation d'un type d'organisme"
    });
};
var $5f12451354e1008d$export$2e2bcd8739ae039 = $5f12451354e1008d$var$CreateTypeOrganisme;









const $6d6512996856028d$var$ListTypeOrganisme = ()=>{
    const { data: data } = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/type-organisme/get`);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e5bcd0ed5e4cafe8$export$2e2bcd8739ae039), {
            pageTitle: "Types d'organismes",
            addButtonTitle: "Ajouter un type d'organisme",
            pageIcon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$ba2fbb9644c8bf32), {}),
            hasProtectedValue: true,
            lienPageAjout: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).ADD_TYPE_ORGANISME,
            typeNomenclature: (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).TYPE_ORGANISME,
            lienPageUpdate: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).UPDATE_TYPE_ORGANISME,
            libelleFk: "Type organisme parent",
            listeFk: data
        })
    });
};
var $6d6512996856028d$export$2e2bcd8739ae039 = $6d6512996856028d$var$ListTypeOrganisme;







const $d83f1d5d71c75787$var$UpdateTypeOrganisme = ()=>{
    const { typeOrganismeId: typeOrganismeId } = (0, $7a844823b04d4282$export$99eaa27ddbbb95ef)();
    return typeOrganismeId && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $4e0326405bcaf2aa$export$2e2bcd8739ae039), {
        nomenclatureId: typeOrganismeId,
        typeNomenclature: (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).TYPE_ORGANISME,
        redirectLink: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_TYPE_ORGANISME,
        titrePage: "Modification d'un type d'organisme"
    });
};
var $d83f1d5d71c75787$export$2e2bcd8739ae039 = $d83f1d5d71c75787$var$UpdateTypeOrganisme;




var $bkJfK = parcelRequire("bkJfK");













const $5fac7c539afc1913$var$UpdateTypeOrganismeDroitApi = ()=>{
    const typeOrganismeWithDroitApiState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/type-organisme/droits-api`);
    if (!typeOrganismeWithDroitApiState.isResolved) return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $c21b1c237cfa1d94$export$2e2bcd8739ae039), {});
    const { listTypeOrganisme: listTypeOrganisme, listTypeDroitApi: listTypeDroitApi } = typeOrganismeWithDroitApiState.data;
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
            initialValues: listTypeOrganisme,
            validationSchema: (0, $ce4de947442b2ab1$export$be5493f9613cbbe)(),
            isPost: false,
            submitUrl: `/api/type-organisme/droits-api/update`,
            onSubmit: ()=>typeOrganismeWithDroitApiState.reload(),
            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($5fac7c539afc1913$var$TypeOrganismeWithDroitApiInner, {
                listTypeDroitApi: listTypeDroitApi
            })
        })
    });
};
const $5fac7c539afc1913$var$TypeOrganismeWithDroitApiInner = ({ listTypeDroitApi: listTypeDroitApi })=>{
    const { values: values, setFieldValue: setFieldValue } = (0, $bkJfK.useFormikContext)();
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                title: "Attribution des droits API pour les types organismes",
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$16fcff7afd79949), {})
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $13de46b4dfcc473f$export$2e2bcd8739ae039), {
                striped: true,
                bordered: true,
                hover: true,
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("thead", {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("th", {
                                    children: "Type Organisme"
                                }),
                                listTypeDroitApi.map((droitApi, idxPD)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("th", {
                                        children: [
                                            droitApi,
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                                                tooltipText: (0, $7680c94ec9779ccd$export$2f28434219a14e94).get(droitApi),
                                                tooltipId: droitApi,
                                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$340bfce9b4df026b), {})
                                            })
                                        ]
                                    }, idxPD))
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("tbody", {
                        children: values.map((typeOrganisme, idxTD)=>{
                            return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("th", {
                                            children: [
                                                typeOrganisme.typeOrganismeLibelle,
                                                " (",
                                                typeOrganisme.typeOrganismeCode,
                                                ")"
                                            ]
                                        }),
                                        listTypeDroitApi.map((droit, idxPD)=>{
                                            return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("td", {
                                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Check, {
                                                    type: "checkbox",
                                                    id: `check-${idxTD}-${idxPD}`,
                                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Check.Input, {
                                                        type: "checkbox",
                                                        value: droit,
                                                        checked: typeOrganisme.typeOrganismeDroitApi?.includes(droit) ?? false,
                                                        disabled: typeOrganisme.typeOrganismeDroitApi?.includes((0, $7680c94ec9779ccd$export$7afc20a3b0894f44).ADMINISTRER) && (0, $7680c94ec9779ccd$export$7afc20a3b0894f44)[droit] !== (0, $7680c94ec9779ccd$export$7afc20a3b0894f44).ADMINISTRER,
                                                        onChange: (event)=>{
                                                            const checked = event.currentTarget.checked;
                                                            if (checked) {
                                                                // Si c'est le droit administer, on ajoute les autres
                                                                if ((0, $7680c94ec9779ccd$export$7afc20a3b0894f44)[droit] === (0, $7680c94ec9779ccd$export$7afc20a3b0894f44).ADMINISTRER) setFieldValue(`${idxTD}.typeOrganismeDroitApi`, listTypeDroitApi);
                                                                else {
                                                                    const tab = [
                                                                        ...values[idxTD].typeOrganismeDroitApi ?? [],
                                                                        droit
                                                                    ];
                                                                    setFieldValue(`${idxTD}.typeOrganismeDroitApi`, tab.filter((item, pos)=>tab.indexOf(item) === pos));
                                                                }
                                                            } else setFieldValue(`${idxTD}.typeOrganismeDroitApi`, values[idxTD]?.typeOrganismeDroitApi?.filter((item)=>item !== droit) ?? []);
                                                        }
                                                    })
                                                })
                                            }, `${idxTD}${idxPD}`);
                                        })
                                    ]
                                }, idxTD)
                            });
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db9b0e6fdb142a4c$export$2e2bcd8739ae039), {
                returnLink: true
            })
        ]
    });
};
var $5fac7c539afc1913$export$2e2bcd8739ae039 = $5fac7c539afc1913$var$UpdateTypeOrganismeDroitApi;










var $bkJfK = parcelRequire("bkJfK");









var $12d6fdd4db9950c8$var$PARAMETRE_TASK_PLANIFICATION = /*#__PURE__*/ function(PARAMETRE_TASK_PLANIFICATION) {
    PARAMETRE_TASK_PLANIFICATION["EVERY_X_MINUTE"] = "everyXMinute";
    PARAMETRE_TASK_PLANIFICATION["EVERY_HOUR_AT_MINUTE_X"] = "everyHourAtMinuteX";
    PARAMETRE_TASK_PLANIFICATION["SPECIFIED_TIME"] = "specifiedTime";
    PARAMETRE_TASK_PLANIFICATION["PERSONALIZED"] = "personalized";
    return PARAMETRE_TASK_PLANIFICATION;
}($12d6fdd4db9950c8$var$PARAMETRE_TASK_PLANIFICATION || {});
var $12d6fdd4db9950c8$export$2e2bcd8739ae039 = $12d6fdd4db9950c8$var$PARAMETRE_TASK_PLANIFICATION;




const $d6b69c1f76b50dec$export$a5cab80145b70e98 = (currentTask)=>({
        taskId: currentTask?.taskId,
        taskType: currentTask?.taskType ?? (0, $bd5f3039059066bc$export$2e2bcd8739ae039).PERSONNALISE.id,
        taskActif: currentTask?.taskActif ?? false,
        taskPlanification: currentTask?.taskPlanification,
        taskExecManuelle: currentTask?.taskExecManuelle ?? false,
        taskParametres: currentTask?.taskParametres ?? null,
        taskNotification: currentTask?.taskNotification ?? null,
        isPlanificationEnabled: currentTask?.isPlanificationEnabled ?? false,
        radioPlanification: "personalized",
        everyXMinute: null,
        everyHourAtMinuteX: null,
        specifiedTimeHoure: null,
        specifiedTimeMinute: null
    });
const $d6b69c1f76b50dec$export$f97400759cfd946 = (values)=>({
        taskId: values.taskId,
        taskType: values.taskType,
        taskActif: values.taskActif ?? false,
        taskPlanification: values.isPlanificationEnabled && $d6b69c1f76b50dec$export$1acba170b8698051(values).trim().length > 0 ? $d6b69c1f76b50dec$export$1acba170b8698051(values).trim() : null,
        taskExecManuelle: values.taskExecManuelle ?? false,
        taskParametres: JSON.stringify(values.taskParametres) ?? null,
        taskNotification: JSON.stringify(values.taskNotification) ?? null
    });
const $d6b69c1f76b50dec$var$ParametreTaskForm = ()=>{
    const { values: values, setFieldValue: setFieldValue } = (0, $bkJfK.useFormikContext)();
    const typeOrganismeState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/type-organisme/get-active`);
    const { handleShowClose: handleShowCloseFormulaire, activesKeys: activesKeysFormulaire } = (0, $db860d90b4a42fea$export$dae930a4ba30758b)([
        true,
        false,
        false
    ]);
    const { handleShowClose: handleShowCloseNotification, activesKeys: activesKeysNotification } = (0, $db860d90b4a42fea$export$dae930a4ba30758b)([]);
    if (!typeOrganismeState.isResolved) return;
    const typeOrganismeList = typeOrganismeState.data.map((e)=>{
        return {
            id: e.typeOrganismeId,
            libelle: e.typeOrganismeLibelle,
            code: e.typeOrganismeCode
        };
    });
    const parametreComponentsList = Object.entries((0, $bd5f3039059066bc$export$2e2bcd8739ae039)[values.taskType]?.parametre ?? {}).map(([key, value])=>{
        switch(value.typeTaskParametre){
            case (0, $ba31bf1fada5b2ce$export$bae12dea55379e0c).INTEGER:
                return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    className: "m-2",
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$6bf0cd3a219bbade), {
                        name: "taskParametres[" + key + "]",
                        label: value.label,
                        required: value.required,
                        tooltipText: value.tooltipMessage
                    })
                });
            case (0, $ba31bf1fada5b2ce$export$bae12dea55379e0c).STRING:
                return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    className: "m-2",
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                        name: "taskParametres[" + key + "]",
                        label: value.label,
                        required: value.required,
                        tooltipText: value.tooltipMessage
                    })
                });
            case (0, $ba31bf1fada5b2ce$export$bae12dea55379e0c).BOOLEAN:
                return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    className: "m-2",
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                        name: "taskParametres[" + key + "]",
                        label: value.label,
                        tooltipText: value.tooltipMessage
                    })
                });
            case (0, $ba31bf1fada5b2ce$export$bae12dea55379e0c).LISTE_TABLE_SYNCHRO_SIG:
                if (values?.taskParametres["listeTableASynchroniser"] === undefined) setFieldValue("taskParametres[listeTableASynchroniser]", []);
                return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    className: "m-2",
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $665753c43020c55f$export$2e2bcd8739ae039), {
                        name: "taskParametres[listeTableASynchroniser]",
                        createComponentToRepeat: $d6b69c1f76b50dec$var$createIterableParametreSynchroSIG,
                        listeElements: values?.taskParametres["listeTableASynchroniser"]
                    })
                });
            default:
                return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                    children: [
                        "Le type de param\xe8tre ",
                        value.typeTaskParametre,
                        " est inconnu."
                    ]
                });
        }
    });
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                            name: "taskActif",
                            label: "T\xe2che active :"
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db9b0e6fdb142a4c$export$2e2bcd8739ae039), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db860d90b4a42fea$export$2e2bcd8739ae039), {
                activesKeys: activesKeysFormulaire,
                handleShowClose: handleShowCloseFormulaire,
                list: [
                    {
                        header: "Planification",
                        content: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                                        name: "isPlanificationEnabled",
                                        label: "T\xe2che planifi\xe9e :"
                                    })
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$83a1b8e4fcf0dd8e), {
                                            name: "radioPlanification",
                                            label: "Toutes les X minutes",
                                            value: (0, $12d6fdd4db9950c8$export$2e2bcd8739ae039).EVERY_X_MINUTE
                                        }),
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$6bf0cd3a219bbade), {
                                            name: "everyXMinute",
                                            disabled: values.radioPlanification !== (0, $12d6fdd4db9950c8$export$2e2bcd8739ae039).EVERY_X_MINUTE || !values.isPlanificationEnabled,
                                            min: 0,
                                            max: 59,
                                            step: 1
                                        }),
                                        " ",
                                        "min"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$83a1b8e4fcf0dd8e), {
                                            name: "radioPlanification",
                                            label: "Toutes les heures \xe0 minute pr\xe9cise",
                                            value: (0, $12d6fdd4db9950c8$export$2e2bcd8739ae039).EVERY_HOUR_AT_MINUTE_X
                                        }),
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$6bf0cd3a219bbade), {
                                            name: "everyHourAtMinuteX",
                                            disabled: values.radioPlanification !== (0, $12d6fdd4db9950c8$export$2e2bcd8739ae039).EVERY_HOUR_AT_MINUTE_X || !values.isPlanificationEnabled,
                                            min: 0,
                                            max: 59,
                                            step: 1
                                        }),
                                        " ",
                                        "min"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$83a1b8e4fcf0dd8e), {
                                            name: "radioPlanification",
                                            label: "Tous les jours \xe0 heure pr\xe9cise",
                                            value: (0, $12d6fdd4db9950c8$export$2e2bcd8739ae039).SPECIFIED_TIME
                                        }),
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                            className: "d-flex align-items-center",
                                            children: [
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                                    xs: "3",
                                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$6bf0cd3a219bbade), {
                                                        name: "specifiedTimeHoure",
                                                        disabled: values.radioPlanification !== (0, $12d6fdd4db9950c8$export$2e2bcd8739ae039).SPECIFIED_TIME || !values.isPlanificationEnabled,
                                                        min: 0,
                                                        max: 23,
                                                        step: 1
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                                    xs: "auto",
                                                    className: "p-0",
                                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("span", {
                                                        className: "mx-1",
                                                        children: ":"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                                    xs: "3",
                                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$6bf0cd3a219bbade), {
                                                        name: "specifiedTimeMinute",
                                                        disabled: values.radioPlanification !== (0, $12d6fdd4db9950c8$export$2e2bcd8739ae039).SPECIFIED_TIME || !values.isPlanificationEnabled,
                                                        min: 0,
                                                        max: 59,
                                                        step: 1
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$83a1b8e4fcf0dd8e), {
                                            name: "radioPlanification",
                                            label: "Personnalis\xe9",
                                            value: (0, $12d6fdd4db9950c8$export$2e2bcd8739ae039).PERSONALIZED
                                        }),
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                                            name: "taskPlanification",
                                            required: false,
                                            disabled: values.radioPlanification !== (0, $12d6fdd4db9950c8$export$2e2bcd8739ae039).PERSONALIZED || !values.isPlanificationEnabled
                                        })
                                    ]
                                }),
                                (0, $bd5f3039059066bc$export$2e2bcd8739ae039)[values.taskType] !== (0, $bd5f3039059066bc$export$2e2bcd8739ae039).PERSONNALISE && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                                        name: "taskExecManuelle",
                                        label: "Permettre l'ex\xe9cution manuelle :"
                                    })
                                })
                            ]
                        })
                    },
                    ...parametreComponentsList.length !== 0 ? [
                        {
                            header: "Param\xe8tres",
                            content: parametreComponentsList
                        }
                    ] : [],
                    ...(0, $bd5f3039059066bc$export$2e2bcd8739ae039)[values.taskType] === (0, $bd5f3039059066bc$export$2e2bcd8739ae039).PERSONNALISE ? [
                        {
                            header: "Fichiers de la t\xe2che",
                            content: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b57af79a4ab2a1c6), {
                                name: "zipFile",
                                label: "Fichier ZIP contenant le ou les fichiers hwf, et hpl",
                                accept: ".zip",
                                onChange: (e)=>{
                                    setFieldValue("zipFile", e.target.files[0]);
                                },
                                tooltipText: "Si des documents sont d\xe9j\xe0 pr\xe9sents sur le serveur pour ce job, ils seront remplac\xe9s par les nouveaux ins\xe9r\xe9s",
                                required: values.taskId == null
                            })
                        }
                    ] : [],
                    ...(0, $bd5f3039059066bc$export$2e2bcd8739ae039)[values.taskType].notification === true ? [
                        {
                            header: "Notification",
                            content: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db860d90b4a42fea$export$2e2bcd8739ae039), {
                                activesKeys: activesKeysNotification,
                                handleShowClose: handleShowCloseNotification,
                                list: [
                                    {
                                        header: "Type de destinataires",
                                        content: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$eae70af4b4e3f197), {
                                                    name: "taskNotification.typeDestinataire.contactOrganisme",
                                                    label: "Contacts d'organisme de type :",
                                                    options: typeOrganismeList,
                                                    getOptionValue: (t)=>t.id,
                                                    getOptionLabel: (t)=>t.libelle,
                                                    value: values?.taskNotification?.typeDestinataire?.contactOrganisme?.map((e)=>typeOrganismeList?.find((r)=>r.id === e)) ?? undefined,
                                                    onChange: (typeOrganisme)=>{
                                                        const typeOrganismeId = typeOrganisme.map((e)=>e.id);
                                                        typeOrganismeId.length > 0 ? setFieldValue("taskNotification.typeDestinataire.contactOrganisme", typeOrganismeId) : setFieldValue("taskNotification.typeDestinataire.contactOrganisme", undefined);
                                                    },
                                                    isClearable: true,
                                                    required: false
                                                }),
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$eae70af4b4e3f197), {
                                                    name: "taskNotification.typeDestinataire.utilisateurOrganisme",
                                                    label: "Utilisateurs associ\xe9s \xe0 un organisme de type :",
                                                    options: typeOrganismeList,
                                                    getOptionValue: (t)=>t.id,
                                                    getOptionLabel: (t)=>t.libelle,
                                                    value: values?.taskNotification?.typeDestinataire?.utilisateurOrganisme?.map((e)=>typeOrganismeList?.find((r)=>r.id === e)) ?? undefined,
                                                    onChange: (typeOrganisme)=>{
                                                        const typeOrganismeId = typeOrganisme.map((e)=>e.id);
                                                        typeOrganismeId.length > 0 ? setFieldValue("taskNotification.typeDestinataire.utilisateurOrganisme", typeOrganismeId) : setFieldValue("taskNotification.typeDestinataire.utilisateurOrganisme", undefined);
                                                    },
                                                    isClearable: true,
                                                    required: false
                                                }),
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                                                    name: "taskNotification.typeDestinataire.contactGestionnaire",
                                                    label: "Notifier les contacts de gestionnaire :"
                                                }),
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                                    className: "bg-light p-2 border rounded mx-2",
                                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $665753c43020c55f$export$2e2bcd8739ae039), {
                                                        name: "taskNotification.typeDestinataire.saisieLibre",
                                                        createComponentToRepeat: $d6b69c1f76b50dec$var$createIterableNotificationSaisieLibre,
                                                        listeElements: values?.taskNotification.typeDestinataire.saisieLibre,
                                                        label: "Saisie libre d'adresse email"
                                                    })
                                                })
                                            ]
                                        })
                                    },
                                    {
                                        header: "Objet",
                                        content: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                                            name: "taskNotification.objet"
                                        })
                                    },
                                    {
                                        header: "Corps",
                                        content: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$ce9b1cc0c34506d0), {
                                            name: "taskNotification.corps"
                                        })
                                    }
                                ]
                            })
                        }
                    ] : []
                ]
            })
        ]
    });
};
var $d6b69c1f76b50dec$export$2e2bcd8739ae039 = $d6b69c1f76b50dec$var$ParametreTaskForm;
function $d6b69c1f76b50dec$var$createIterableNotificationSaisieLibre(index) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($d6b69c1f76b50dec$var$NotificationSaisieLibre, {
        index: index
    });
}
const $d6b69c1f76b50dec$var$NotificationSaisieLibre = ({ index: index })=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
        name: `taskNotification.typeDestinataire.saisieLibre[${index}]`,
        required: false
    });
};
function $d6b69c1f76b50dec$var$createIterableParametreSynchroSIG(index, listeElements) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($d6b69c1f76b50dec$var$ParametreSynchroSIGIterableForm, {
        index: index,
        listeElements: listeElements
    });
}
const $d6b69c1f76b50dec$export$3de122160df01bee = ({ type: type })=>{
    switch(type){
        case (0, $ba31bf1fada5b2ce$export$acdf2b5a316b9b1).MISE_A_JOUR_REMOCRA_COMMUNE:
            return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                children: [
                    'La vue doit s\'appeler "v_commune_sig" et contenir ces colonnes :',
                    " ",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_commune_id"
                    }),
                    ": Identifiant unique de la commune en base de donn\xe9es.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_commune_libelle"
                    }),
                    ": Nom de la commune.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_commune_code_insee"
                    }),
                    ": Code INSEE de la commune.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_commune_code_postal"
                    }),
                    ": Code postal de la commune.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_commune_geometrie"
                    }),
                    ": Emplacement g\xe9ometrique de la commune.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_commune_pprif"
                    }),
                    ": PPRIF de la commune.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_commune_code"
                    }),
                    ": Code unique de la commune.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    "Toutes les colonnes doivent \xeatre d\xe9finies dans la vue. Seule la colonne v_commune_code peut contenir des valeurs nulles."
                ]
            });
        case (0, $ba31bf1fada5b2ce$export$acdf2b5a316b9b1).MISE_A_JOUR_REMOCRA_VOIE:
            return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                children: [
                    'La vue doit s\'appeler "v_voie_sig" et contenir ces colonnes : ',
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_voie_id"
                    }),
                    ": Identifiant unique de la voie en base de donn\xe9es.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_voie_libelle"
                    }),
                    ": Nom de la voie.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_voie_geometrie"
                    }),
                    ": Emplacement g\xe9ometrique de la voie.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_voie_commune_id"
                    }),
                    ": Identifiant unique de la commune o\xf9 se trouve la voie.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    "Toutes les colonnes sont obligatoires."
                ]
            });
        case (0, $ba31bf1fada5b2ce$export$acdf2b5a316b9b1).MISE_A_JOUR_REMOCRA_DFCI_AIRE:
            return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                children: [
                    'La vue doit s\'appeler "v_dfci_aire_sig" et contenir ces colonnes :',
                    " ",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_aire_sig_id"
                    }),
                    ": Identifiant unique de l'aire en base de donn\xe9es.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_aire_sig_amenagement"
                    }),
                    ": Am\xe9nagement de l'aire.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_aire_sig_date_gps"
                    }),
                    ": Date du relev\xe9 GPS de l'aire.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_aire_sig_grande_dimension"
                    }),
                    ": Plus grand dimension de l'aire. Peut \xeatre nul.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_aire_sig_petite_dimension"
                    }),
                    ": Plus petite dimension de l'aire. Peut \xeatre nul.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_aire_sig_type"
                    }),
                    ": Type de l'aire.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_aire_sig_dfci_piste_id"
                    }),
                    ": Piste r\xe9f\xe9renc\xe9e par l'aire. Peut \xeatre nul.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_aire_sig_remarque"
                    }),
                    ": Remarque sur l'aire l'aire. Peut \xeatre nul.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_aire_sig_geometrie"
                    }),
                    ": Emplacement g\xe9ometrique de l'aire.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_aire_sig_code"
                    }),
                    ": Code unique de l'aire.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_aire_sig_version"
                    }),
                    ": Version en base de donn\xe9es de l'aire.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    "Toutes les colonnes sont obligatoires."
                ]
            });
        case (0, $ba31bf1fada5b2ce$export$acdf2b5a316b9b1).MISE_A_JOUR_REMOCRA_DFCI_PISTE:
            return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                children: [
                    'La vue doit s\'appeler "v_dfci_piste_sig" et contenir ces colonnes :',
                    " ",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_piste_sig_id"
                    }),
                    ": Identifiant unique de la piste en base de donn\xe9es.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_piste_sig_adresse"
                    }),
                    ": Adresse de la piste. Peut \xeatre nul.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_piste_sig_annee_programme"
                    }),
                    ": Ann\xe9e de programmation de la piste. Peut \xeatre nul.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_piste_sig_annee_travaux"
                    }),
                    " : Ann\xe9e des derniers travaux. Peut \xeatre nul.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_piste_sig_circulation"
                    }),
                    ": Condition de circulation de la piste.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_piste_sig_date_gps"
                    }),
                    ": Date du relev\xe9 GPS de la piste.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_piste_sig_libelle"
                    }),
                    ": Libell\xe9 de la piste.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_piste_sig_numero"
                    }),
                    ": Num\xe9ro de la piste.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_piste_sig_ouverture"
                    }),
                    ": Ouverture de la piste \xe0 la cirulation publique.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_piste_sig_est_dfci"
                    }),
                    ": La piste est une piste DFCI.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_piste_sig_retournement"
                    }),
                    ": Retournement possible tous les km.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_piste_sig_num_troncon"
                    }),
                    ": Num\xe9ro du tron\xe7on dans la piste.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_piste_sig_num_objectif"
                    }),
                    ": Num\xe9ro de l'objectif. Peut \xeatre nul.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_piste_sig_libelle_objectif"
                    }),
                    ": Libell\xe9 de l'objectif. Peut \xeatre nul.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_piste_sig_geometrie"
                    }),
                    ": Emplacement g\xe9ometrique de la piste.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_piste_sig_impraticabilite"
                    }),
                    ": Cause de l'impraticabilit\xe9 de la piste. Peut \xeatre nul.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_piste_sig_travaux"
                    }),
                    ": Type de travaux sur la piste. Peut \xeatre nul.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_piste_sig_voie"
                    }),
                    ": Type de voie DFCI.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_piste_sig_impasse"
                    }),
                    ": Pr\xe9sence d'une impasse sur la piste.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_piste_sig_foncier"
                    }),
                    ": Assise fonci\xe8re du tron\xe7on de piste. Peut \xeatre nul.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_piste_sig_croisement"
                    }),
                    ": Possibilit\xe9 de croisement sur la piste.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_piste_sig_programme"
                    }),
                    ": Type de programme sur la piste. Peut \xeatre nul.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_piste_sig_praticabilite"
                    }),
                    ": La piste est praticable.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_piste_sig_remarque"
                    }),
                    ": Remarque sur la piste. Peut \xeatre nul.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_piste_sig_code"
                    }),
                    ": Code unique de la piste",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_piste_sig_dfci_categorie_piste_id"
                    }),
                    ": Identifiant de la cat\xe9gorie de piste.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_piste_sig_dfci_massif_id"
                    }),
                    ": Identifiant du massif o\xf9 se trouve la piste.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_piste_sig_dfci_prestataire_id"
                    }),
                    ": Identifiant du prestataire. Peut \xeatre nul.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_piste_sig_dfci_ouvrage_id"
                    }),
                    ": Identifiant de l'ouvrage. Peut \xeatre nul.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_piste_sig_version"
                    }),
                    ": Version en base de donn\xe9e de la piste.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    "Toutes les colonnes sont obligatoires."
                ]
            });
        case (0, $ba31bf1fada5b2ce$export$acdf2b5a316b9b1).MISE_A_JOUR_REMOCRA_DFCI_DEB:
            return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                children: [
                    'La vue doit s\'appeler "v_dfci_deb_sig" et contenir ces colonnes :',
                    " ",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_deb_sig_id"
                    }),
                    ": Identifiant unique du d\xe9broussaillement en base de donn\xe9es.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_deb_sig_libelle"
                    }),
                    ": Libell\xe9 du d\xe9broussaillement.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_deb_sig_annee_programme"
                    }),
                    ": Ann\xe9e de programmation du d\xe9broussaillement. Peut \xeatre nul.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_deb_sig_annee_travaux"
                    }),
                    " : Ann\xe9e des derniers travaux. Peut \xeatre nul.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_deb_sig_mois_travaux"
                    }),
                    ": Mois des travaux. Peut \xeatre nul.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_deb_sig_annee_edition"
                    }),
                    ": Ann\xe9e d'\xe9dition du d\xe9broussaillement. Peut \xeatre nul.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_deb_sig_largeur"
                    }),
                    ": Largeur du d\xe9broussaillement.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_deb_sig_surface"
                    }),
                    ": Surface du d\xe9broussaillement.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_deb_sig_geometrie"
                    }),
                    ": Emplacement g\xe9ometrique du d\xe9broussaillement.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_deb_sig_travaux"
                    }),
                    ": Type de travaux du d\xe9broussaillement. Peut \xeatre nul.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_deb_sig_type"
                    }),
                    ": Type de d\xe9broussaillement.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_deb_sig_programme"
                    }),
                    ": Type de programme sur le d\xe9broussaillement. Peut \xeatre nul.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_deb_sig_remarque"
                    }),
                    ": Remarque sur le d\xe9broussaillement. Peut \xeatre nul.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_deb_sig_code"
                    }),
                    ": Code unique du d\xe9broussaillement.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_deb_sig_dfci_massif_id"
                    }),
                    ": Identifiant du massif o\xf9 se trouve le d\xe9broussaillement.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_deb_sig_dfci_prestataire_id"
                    }),
                    ": Identifiant du prestataire. Peut \xeatre nul.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_deb_sig_dfci_ouvrage_id"
                    }),
                    ": Identifiant de l'ouvrage. Peut \xeatre nul.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_deb_sig_version"
                    }),
                    ": Version en base de donn\xe9e du d\xe9broussaillement.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    "Toutes les colonnes sont obligatoires."
                ]
            });
        case (0, $ba31bf1fada5b2ce$export$acdf2b5a316b9b1).MISE_A_JOUR_REMOCRA_DFCI_PANNEAU:
            return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                children: [
                    'La vue doit s\'appeler "v_dfci_panneau_sig" et contenir ces colonnes :',
                    " ",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_panneau_sig_id"
                    }),
                    ": Identifiant unique du panneau en base de donn\xe9es.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_panneau_sig_type"
                    }),
                    ": Type de panneau.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_panneau_sig_etat"
                    }),
                    ": Etat du panneau.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_panneau_sig_bzero"
                    }),
                    ": B0 du panneau.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_panneau_sig_date_gps"
                    }),
                    " : Relev\xe9 GPS du panneau.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_panneau_sig_position"
                    }),
                    ": Position du panneau.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_panneau_sig_equipement"
                    }),
                    ": Equipement panneaut\xe9.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_panneau_sig_dfci_piste_id"
                    }),
                    ": Piste o\xf9 se trouve le panneau.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_panneau_sig_num_piste"
                    }),
                    ": Pr\xe9sence du num\xe9ro de piste sur le panneau.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_panneau_sig_libelle_piste"
                    }),
                    ": Pr\xe9sence du libelle de piste sur le panneau.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_panneau_sig_geometrie"
                    }),
                    ": Emplacement g\xe9ometrique du panneau.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_panneau_sig_remarque"
                    }),
                    ": Remarque sur le panneau. Peut \xeatre nul.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_panneau_sig_code"
                    }),
                    ": Code unique du panneau.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_panneau_sig_version"
                    }),
                    ": Version en base de donn\xe9e du panneau.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    "Toutes les colonnes sont obligatoires."
                ]
            });
        case (0, $ba31bf1fada5b2ce$export$acdf2b5a316b9b1).MISE_A_JOUR_DFCI_MASSIF:
            return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                children: [
                    'La vue doit s\'appeler "v_dfci_massif_sig" et contenir ces colonnes :',
                    " ",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_massif_sig_id"
                    }),
                    ": Identifiant unique du massif. en base de donn\xe9es.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_massif_sig_code"
                    }),
                    ": Code unique du massif.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_massif_sig_libelle"
                    }),
                    ": Libell\xe9 du massif.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    "Toutes les colonnes sont obligatoires."
                ]
            });
        case (0, $ba31bf1fada5b2ce$export$acdf2b5a316b9b1).MISE_A_JOUR_DFCI_CATEGORIE_PISTE:
            return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                children: [
                    'La vue doit s\'appeler "v_dfci_categorie_piste_sig" et contenir ces colonnes : ',
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_categorie_piste_sig_id"
                    }),
                    ": Identifiant unique de la cat\xe9gorie de piste. en base de donn\xe9es.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_categorie_piste_sig_code"
                    }),
                    ": Code unique de la cat\xe9gorie de piste.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_categorie_piste_sig_libelle"
                    }),
                    ": Libell\xe9 de la cat\xe9gorie de piste.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    "Toutes les colonnes sont obligatoires."
                ]
            });
        case (0, $ba31bf1fada5b2ce$export$acdf2b5a316b9b1).MISE_A_JOUR_DFCI_OUVRAGE:
            return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                children: [
                    'La vue doit s\'appeler "v_dfci_ouvrage_sig" et contenir ces colonnes :',
                    " ",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_ouvrage_sig_id"
                    }),
                    ": Identifiant unique de l'ouvrage en base de donn\xe9es.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_ouvrage_sig_code"
                    }),
                    ": Code unique de l'ouvrage.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_ouvrage_sig_libelle"
                    }),
                    ": Libell\xe9 de l'ouvrage.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    "Toutes les colonnes sont obligatoires."
                ]
            });
        case (0, $ba31bf1fada5b2ce$export$acdf2b5a316b9b1).MISE_A_JOUR_DFCI_PRESTATAIRE:
            return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                children: [
                    'La vue doit s\'appeler "v_dfci_prestataire_sig" et contenir ces colonnes : ',
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_prestataire_sig_id"
                    }),
                    ": Identifiant unique du prestataire. en base de donn\xe9es.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_prestataire_sig_code"
                    }),
                    ": Code unique du prestataire.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                        children: "v_dfci_prestataire_sig_libelle"
                    }),
                    ": Libell\xe9 du prestataire.",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    "Toutes les colonnes sont obligatoires."
                ]
            });
    }
};
function $d6b69c1f76b50dec$export$1489e5e8e237b9d0(type) {
    switch(type){
        case (0, $ba31bf1fada5b2ce$export$acdf2b5a316b9b1).MISE_A_JOUR_REMOCRA_COMMUNE:
            return "CREATE OR REPLACE VIEW entrepotsig.v_commune_sig AS SELECT commune.commune_id AS v_commune_sig_id, commune.commune_libelle AS v_commune_sig_libelle, commune.commune_code_insee AS v_commune_sig_code_insee, commune.commune_code_postal AS v_commune_sig_code_postal, commune.commune_geometrie AS v_commune_sig_geometrie, commune.commune_pprif AS v_commune_sig_pprif, commune.commune_code AS v_commune_sig_code FROM remocra.commune;";
        case (0, $ba31bf1fada5b2ce$export$acdf2b5a316b9b1).MISE_A_JOUR_REMOCRA_VOIE:
            return "CREATE OR REPLACE VIEW entrepotsig.v_voie_sig AS SELECT voie.voie_id AS v_voie_sig_id, voie.voie_libelle AS v_voie_sig_libelle, voie.voie_geometrie AS v_voie_sig_geometrie, voie.voie_commune_id AS v_voie_sig_commune_id FROM remocra.voie;";
        case (0, $ba31bf1fada5b2ce$export$acdf2b5a316b9b1).STOCKAGE_SIMPLE:
            return null;
        case (0, $ba31bf1fada5b2ce$export$acdf2b5a316b9b1).MISE_A_JOUR_REMOCRA_DFCI_AIRE:
            return "CREATE OR REPLACE VIEW entrepotsig.v_dfci_aire_sig AS SELECT dfci_aire_id AS v_dfci_aire_sig_id, dfci_aire_amenagement AS v_dfci_aire_sig_amenagement, dfci_aire_date_gps AS v_dfci_aire_sig_date_gps, dfci_aire_grande_dimension AS v_dfci_aire_sig_grande_dimension, dfci_aire_petite_dimension AS v_dfci_aire_sig_petite_dimension, dfci_aire_type AS v_dfci_aire_sig_type, dfci_aire_dfci_piste_id AS v_dfci_aire_sig_dfci_piste_id, dfci_aire_remarque AS v_dfci_aire_sig_remarque, dfci_aire_geometrie AS v_dfci_aire_sig_geometrie, dfci_aire_code AS v_dfci_aire_sig_code, dfci_aire_version AS v_dfci_aire_sig_version FROM remocra.dfci_aire;";
        case (0, $ba31bf1fada5b2ce$export$acdf2b5a316b9b1).MISE_A_JOUR_DFCI_CATEGORIE_PISTE:
            return "CREATE OR REPLACE VIEW entrepotsig.v_dfci_categorie_piste_sig AS SELECT dfci_categorie_piste_id AS v_dfci_categorie_piste_sig_id, dfci_categorie_piste_code AS v_dfci_categorie_piste_sig_code, dfci_categorie_piste_libelle AS v_dfci_categorie_piste_sig_libelle FROM remocra.dfci_categorie_piste;";
        case (0, $ba31bf1fada5b2ce$export$acdf2b5a316b9b1).MISE_A_JOUR_REMOCRA_DFCI_DEB:
            return "CREATE OR REPLACE VIEW entrepotsig.v_dfci_deb_sig AS SELECT dfci_deb_id AS v_dfci_deb_sig_id, dfci_deb_libelle AS v_dfci_deb_sig_libelle, dfci_deb_annee_programme AS v_dfci_deb_sig_annee_programme, dfci_deb_annee_travaux AS v_dfci_deb_sig_annee_travaux, dfci_deb_mois_travaux AS v_dfci_deb_sig_mois_travaux, dfci_deb_annee_edition AS v_dfci_deb_sig_annee_edition, dfci_deb_largeur AS v_dfci_deb_sig_largeur, dfci_deb_surface AS v_dfci_deb_sig_surface, dfci_deb_geometrie AS v_dfci_deb_sig_geometrie, dfci_deb_type AS v_dfci_deb_sig_type, dfci_deb_programme AS v_dfci_deb_sig_programme, dfci_deb_travaux AS v_dfci_deb_sig_travaux, dfci_deb_remarque AS v_dfci_deb_sig_remarque, dfci_deb_code AS v_dfci_deb_sig_code, dfci_deb_dfci_massif_id AS v_dfci_deb_sig_dfci_massif_id, dfci_deb_dfci_prestataire_id AS v_dfci_deb_sig_dfci_prestataire_id, dfci_deb_dfci_ouvrage_id AS v_dfci_deb_sig_dfci_ouvrage_id, dfci_deb_version AS v_dfci_deb_sig_version FROM remocra.dfci_deb;";
        case (0, $ba31bf1fada5b2ce$export$acdf2b5a316b9b1).MISE_A_JOUR_DFCI_MASSIF:
            return "CREATE OR REPLACE VIEW entrepotsig.v_dfci_massif_sig AS SELECT dfci_massif_id AS v_dfci_massif_sig_id, dfci_massif_code AS v_dfci_massif_sig_code, dfci_massif_libelle AS v_dfci_massif_sig_libelle FROM remocra.dfci_massif;";
        case (0, $ba31bf1fada5b2ce$export$acdf2b5a316b9b1).MISE_A_JOUR_DFCI_OUVRAGE:
            return "CREATE OR REPLACE VIEW entrepotsig.v_dfci_ouvrage_sig AS SELECT dfci_ouvrage_id AS v_dfci_ouvrage_sig_id, dfci_ouvrage_code AS v_dfci_ouvrage_sig_code, dfci_ouvrage_libelle AS v_dfci_ouvrage_sig_libelle FROM remocra.dfci_ouvrage;";
        case (0, $ba31bf1fada5b2ce$export$acdf2b5a316b9b1).MISE_A_JOUR_REMOCRA_DFCI_PANNEAU:
            return "CREATE OR REPLACE VIEW entrepotsig.v_dfci_panneau_sig AS SELECT dfci_panneau_id AS v_dfci_panneau_sig_id, dfci_panneau_type AS v_dfci_panneau_sig_type, dfci_panneau_etat AS v_dfci_panneau_sig_etat, dfci_panneau_bzero AS v_dfci_panneau_sig_bzero, dfci_panneau_date_gps AS v_dfci_panneau_sig_date_gps, dfci_panneau_position AS v_dfci_panneau_sig_position, dfci_panneau_equipement AS v_dfci_panneau_sig_equipement, dfci_panneau_dfci_piste_id AS v_dfci_panneau_sig_dfci_piste_id, dfci_panneau_num_piste AS v_dfci_panneau_sig_num_piste, dfci_panneau_libelle_piste AS v_dfci_panneau_sig_libelle_piste, dfci_panneau_remarque AS v_dfci_panneau_sig_remarque, dfci_panneau_geometrie AS v_dfci_panneau_sig_geometrie, dfci_panneau_code AS v_dfci_panneau_sig_code, dfci_panneau_version AS v_dfci_panneau_sig_version FROM remocra.dfci_panneau;";
        case (0, $ba31bf1fada5b2ce$export$acdf2b5a316b9b1).MISE_A_JOUR_REMOCRA_DFCI_PISTE:
            return "CREATE OR REPLACE VIEW entrepotsig.v_dfci_piste_sig AS SELECT dfci_piste_id AS v_dfci_piste_sig_id, dfci_piste_adresse AS v_dfci_piste_sig_adresse, dfci_piste_annee_programme AS v_dfci_piste_sig_annee_programme, dfci_piste_annee_travaux AS v_dfci_piste_sig_annee_travaux, dfci_piste_circulation AS v_dfci_piste_sig_circulation, dfci_piste_date_gps AS v_dfci_piste_sig_date_gps, dfci_piste_libelle AS v_dfci_piste_sig_libelle, dfci_piste_numero AS v_dfci_piste_sig_numero, dfci_piste_ouverture AS v_dfci_piste_sig_ouverture, dfci_piste_est_dfci AS v_dfci_piste_sig_est_dfci, dfci_piste_retournement AS v_dfci_piste_sig_retournement, dfci_piste_num_troncon AS v_dfci_piste_sig_num_troncon, dfci_piste_num_objectif AS v_dfci_piste_sig_num_objectif, dfci_piste_libelle_objectif AS v_dfci_piste_sig_libelle_objectif, dfci_piste_geometrie AS v_dfci_piste_sig_geometrie, dfci_piste_impraticabilite AS v_dfci_piste_sig_impraticabilite, dfci_piste_travaux AS v_dfci_piste_sig_travaux, dfci_piste_voie AS v_dfci_piste_sig_voie, dfci_piste_impasse AS v_dfci_piste_sig_impasse, dfci_piste_foncier AS v_dfci_piste_sig_foncier, dfci_piste_croisement AS v_dfci_piste_sig_croisement, dfci_piste_programme AS v_dfci_piste_sig_programme, dfci_piste_praticabilite AS v_dfci_piste_sig_praticabilite, dfci_piste_remarque AS v_dfci_piste_sig_remarque, dfci_piste_code AS v_dfci_piste_sig_code, dfci_piste_dfci_categorie_piste_id AS v_dfci_piste_sig_dfci_categorie_piste_id, dfci_piste_dfci_massif_id AS v_dfci_piste_sig_dfci_massif_id, dfci_piste_dfci_prestataire_id AS v_dfci_piste_sig_dfci_prestataire_id, dfci_piste_dfci_ouvrage_id AS v_dfci_piste_sig_dfci_ouvrage_id, dfci_piste_version AS v_dfci_piste_sig_version FROM remocra.dfci_piste;";
        case (0, $ba31bf1fada5b2ce$export$acdf2b5a316b9b1).MISE_A_JOUR_DFCI_PRESTATAIRE:
            return "CREATE OR REPLACE VIEW entrepotsig.v_dfci_prestataire_sig AS SELECT dfci_prestataire_id AS v_dfci_prestataire_sig_id, dfci_prestataire_code AS v_dfci_prestataire_sig_code, dfci_prestataire_libelle AS v_dfci_prestataire_sig_libelle FROM remocra.dfci_prestataire;";
    }
}
const $d6b69c1f76b50dec$var$ParametreSynchroSIGIterableForm = ({ index: index, listeElements: listeElements })=>{
    const { setFieldValue: setFieldValue } = (0, $bkJfK.useFormikContext)();
    const listeTypeSynchronisationTableSig = Object.entries((0, $ba31bf1fada5b2ce$export$acdf2b5a316b9b1)).map(([key, value])=>({
            id: key,
            code: key,
            libelle: value.toString()
        }));
    const listeTypeChampsUpdateSynchroCommune = Object.entries((0, $ba31bf1fada5b2ce$export$b9160f7787a65b1e)).map(([key, value])=>({
            id: key,
            code: key,
            libelle: value.toString()
        }));
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                        name: `taskParametres[listeTableASynchroniser][${index}].schemaSource`,
                        label: "Schema source",
                        placeholder: "public"
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                        name: `taskParametres[listeTableASynchroniser][${index}].tableSource`,
                        label: "Table source",
                        placeholder: "commune"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                    name: `taskParametres[listeTableASynchroniser][${index}].tableDestination`,
                    label: "Table destination",
                    placeholder: "commune_from_sig",
                    required: false
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                        name: `taskParametres[listeTableASynchroniser][${index}].typeSynchronisation`,
                        label: "Type de synchronisation",
                        listIdCodeLibelle: listeTypeSynchronisationTableSig,
                        defaultValue: listeTypeSynchronisationTableSig.find((e)=>e.id === listeElements[index]?.typeSynchronisation),
                        onChange: (e)=>{
                            setFieldValue(`taskParametres[listeTableASynchroniser][${index}].typeSynchronisation`, e.id);
                            setFieldValue(`taskParametres[listeTableASynchroniser][${index}].scriptCreationVue`, $d6b69c1f76b50dec$export$1489e5e8e237b9d0((0, $ba31bf1fada5b2ce$export$acdf2b5a316b9b1)[e.id]));
                        },
                        required: true
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $918dca194c1aeb0f$export$2e2bcd8739ae039), {
                        id: "infoSynchroSig",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("p", {
                                    children: "Le type de synchronisation permet de d\xe9finir le traitement \xe0 effectuer sur les donn\xe9es r\xe9cup\xe9r\xe9es :"
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("ul", {
                                    children: [
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                                                    children: "MISE_A_JOUR_REMOCRA_COMMUNE"
                                                }),
                                                " : Met \xe0 jour les informations de la table ",
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("code", {
                                                    children: "remocra.commune"
                                                }),
                                                ", en ajoutant de nouveaux \xe9l\xe9ments si n\xe9cessaire. L'identification se fait sur le",
                                                " ",
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                                                    children: "Code INSEE"
                                                }),
                                                "."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                                                    children: "MISE_A_JOUR_REMOCRA_VOIE"
                                                }),
                                                " : Met \xe0 jour les informations de la table ",
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("code", {
                                                    children: "remocra.voie"
                                                }),
                                                ". Ici, seule la g\xe9om\xe9trie est mise \xe0 jour. L'identification se fait sur le ",
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                                                    children: "nom de la voie ET la commune"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                                                    children: "STOCKAGE_SIMPLE"
                                                }),
                                                " : Permet d'obtenir des donn\xe9es d'une table source pour les int\xe9grer dans la base de donn\xe9es REMOcRA. Apr\xe8s r\xe9cup\xe9ration, un",
                                                " ",
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                                                    children: "script SQL"
                                                }),
                                                " est ex\xe9cut\xe9 pour, par exemple, transformer les donn\xe9es g\xe9ographiques afin de les mettre en conformit\xe9 avec le format attendu par REMOcRA."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                                                    children: "MISE_A_JOUR_DFCI"
                                                }),
                                                " : Permet de synchroniser les tables pour le module DFCI. La synchronisation est compos\xe9e de 8 tables. Il est indispensable de param\xe8trer plusieurs pour en synchroniser une.",
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("ul", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("li", {
                                                            children: [
                                                                "La table ",
                                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                                                                    children: "dfci_piste"
                                                                }),
                                                                " a besoin de :",
                                                                " ",
                                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("code", {
                                                                    children: "dfci_categorie_piste, dfci_massif, dfci_prestataire, dfci_ouvrage"
                                                                }),
                                                                "."
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("li", {
                                                            children: [
                                                                "La table ",
                                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                                                                    children: "dfci_deb"
                                                                }),
                                                                " a besoin de :",
                                                                " ",
                                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("code", {
                                                                    children: "dfci_massif, dfci_prestataire, dfci_ouvrage"
                                                                }),
                                                                "."
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("li", {
                                                            children: [
                                                                "La table ",
                                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                                                                    children: "dfci_aire"
                                                                }),
                                                                " a besoin de :",
                                                                " ",
                                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("code", {
                                                                    children: "dfci_piste"
                                                                }),
                                                                "."
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("li", {
                                                            children: [
                                                                "La table ",
                                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                                                                    children: "dfci_panneau"
                                                                }),
                                                                " a besoin de :",
                                                                " ",
                                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("code", {
                                                                    children: "dfci_piste"
                                                                }),
                                                                "."
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                "Les autres tables",
                                                " ",
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                                                    children: "(dfci_categorie_piste, dfci_massif, dfci_prestataire, dfci_ouvrage)"
                                                }),
                                                " ",
                                                "sont ind\xe9pendantes \xe9tant des nomenclatures. Chaque identification se fait sur le ",
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                                                    children: "Code"
                                                }),
                                                "."
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            (0, $ba31bf1fada5b2ce$export$acdf2b5a316b9b1)[listeElements[index]?.typeSynchronisation] === (0, $ba31bf1fada5b2ce$export$acdf2b5a316b9b1).MISE_A_JOUR_REMOCRA_COMMUNE && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$eae70af4b4e3f197), {
                    name: `taskParametres[listeTableASynchroniser][${index}].listeChampsAUpdate`,
                    label: "Champs REMOcRA \xe0 mettre \xe0 jour :",
                    options: listeTypeChampsUpdateSynchroCommune,
                    getOptionValue: (t)=>t.id,
                    getOptionLabel: (t)=>t.libelle,
                    value: listeElements[index]?.listeChampsAUpdate?.map((e)=>listeTypeChampsUpdateSynchroCommune?.find((r)=>r.id === e)) ?? undefined,
                    onChange: (champsASynchro)=>{
                        const champsASynchroId = champsASynchro.map((e)=>e.id);
                        champsASynchroId.length > 0 ? setFieldValue(`taskParametres[listeTableASynchroniser][${index}].listeChampsAUpdate`, champsASynchroId) : setFieldValue(`taskParametres[listeTableASynchroniser][${index}].listeChampsAUpdate`, undefined);
                    },
                    isClearable: false,
                    required: false,
                    tooltipText: "REMOcRA mettra \xe0 jour uniquement les informations s\xe9lectionn\xe9es, \xe0 partir des donn\xe9es extraites de la base SIG."
                })
            }),
            (0, $ba31bf1fada5b2ce$export$acdf2b5a316b9b1)[listeElements[index]?.typeSynchronisation] === (0, $ba31bf1fada5b2ce$export$acdf2b5a316b9b1).STOCKAGE_SIMPLE && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$ce9b1cc0c34506d0), {
                    required: false,
                    name: `taskParametres[listeTableASynchroniser][${index}].scriptPostRecuperation`,
                    label: "Script post-r\xe9cup\xe9ration :"
                })
            }),
            (0, $ba31bf1fada5b2ce$export$acdf2b5a316b9b1)[listeElements[index]?.typeSynchronisation] !== (0, $ba31bf1fada5b2ce$export$acdf2b5a316b9b1).STOCKAGE_SIMPLE && (0, $ba31bf1fada5b2ce$export$acdf2b5a316b9b1)[listeElements[index]?.typeSynchronisation] !== undefined && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$ce9b1cc0c34506d0), {
                    required: true,
                    name: `taskParametres[listeTableASynchroniser][${index}].scriptCreationVue`,
                    label: "Script cr\xe9ation de la vue :",
                    tooltipText: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($d6b69c1f76b50dec$export$3de122160df01bee, {
                        type: (0, $ba31bf1fada5b2ce$export$acdf2b5a316b9b1)[listeElements[index]?.typeSynchronisation]
                    })
                })
            })
        ]
    });
};
function $d6b69c1f76b50dec$export$1acba170b8698051(values) {
    switch(values.radioPlanification){
        case (0, $12d6fdd4db9950c8$export$2e2bcd8739ae039).EVERY_X_MINUTE:
            return `0 /${values.everyXMinute ?? 0} * * * ?`;
        case (0, $12d6fdd4db9950c8$export$2e2bcd8739ae039).EVERY_HOUR_AT_MINUTE_X:
            return `0 0 /${values.everyHourAtMinuteX ?? 0} * * ?`;
        case (0, $12d6fdd4db9950c8$export$2e2bcd8739ae039).SPECIFIED_TIME:
            return `0 ${values.specifiedTimeMinute ?? 0} ${values.specifiedTimeHoure ?? 0} * * ?`;
        case (0, $12d6fdd4db9950c8$export$2e2bcd8739ae039).PERSONALIZED:
            return values.taskPlanification;
    }
}


const $dd56e209bb15597b$var$CreateTaskPersonnalisee = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                    icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$d7cfde09abbb52ee), {}),
                    title: "Ajouter une t\xe2che sp\xe9cifique"
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                initialValues: (0, $d6b69c1f76b50dec$export$a5cab80145b70e98)(null),
                isPost: true,
                submitUrl: "/api/task/personnalisee/create",
                prepareVariables: (values)=>{
                    const formData = new FormData();
                    formData.append("taskActif", values.taskActif);
                    formData.append("taskPlanification", values.isPlanificationEnabled && (0, $d6b69c1f76b50dec$export$1acba170b8698051)(values).trim().length > 0 ? (0, $d6b69c1f76b50dec$export$1acba170b8698051)(values).trim() : "null");
                    formData.append("taskParametres", JSON.stringify(values.taskParametres));
                    formData.append("zipFile", values.zipFile);
                    return formData;
                },
                isMultipartFormData: true,
                redirectUrl: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_TASK_SPECIFIQUE,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $d6b69c1f76b50dec$export$2e2bcd8739ae039), {})
            })
        ]
    });
};
var $dd56e209bb15597b$export$2e2bcd8739ae039 = $dd56e209bb15597b$var$CreateTaskPersonnalisee;




var $kc00y = parcelRequire("kc00y");










const $40a7b6af097c9e55$var$ListeTaskPersonnalisee = ()=>{
    const [currentTask, setCurrentTask] = (0, $kc00y.useState)(null);
    const taskInfo = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/task/personnalisees`);
    if (!taskInfo.isResolved) return;
    const listTasks = taskInfo.data.map((element)=>({
            taskId: element.taskId,
            taskActif: element.taskActif,
            taskPlanification: element.taskPlanification,
            taskLibelle: element.taskLibelle,
            taskParametres: element.taskParametres,
            isPlanificationEnabled: element.taskPlanification != null
        }));
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$d7cfde09abbb52ee), {}),
                title: "Param\xe9trage des traitements sp\xe9cifiques",
                right: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8ad69b89456b65bc$export$2e2bcd8739ae039), {
                    href: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).CREATE_TACHE_SPECIFIQUE,
                    title: "Ajouter une t\xe2che sp\xe9cifique"
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        xs: "5",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                            className: "bg-light p-2 border rounded mx-2",
                            children: listTasks.map((e)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                                                variant: "link",
                                                onClick: ()=>setCurrentTask(e),
                                                children: e.taskLibelle
                                            }, e.taskLibelle)
                                        }),
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $261998279c461521$export$2e2bcd8739ae039), {
                                                path: `/api/task/personnalisee/${e.taskId}/delete`,
                                                disabled: false,
                                                title: false,
                                                variant: "link",
                                                header: "Supprimer la t\xe2che",
                                                content: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                                                    children: [
                                                        "Attention en supprimant cette t\xe2che, vous allez perdre tout l'historique de ses ex\xe9cutions. Si vous ne souhaitez pas perdre cet historique, vous pouvez simplement d\xe9sactiver la t\xe2che.",
                                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                                                        "\xcates-vous s\xfbr de vouloir supprimer cette t\xe2che ?"
                                                    ]
                                                }),
                                                className: "text-decoration-none text-danger",
                                                reload: ()=>{
                                                    taskInfo.reload();
                                                }
                                            })
                                        })
                                    ]
                                }, e.taskLibelle))
                        })
                    }),
                    currentTask && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        className: "bg-light p-2 border rounded mx-2",
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("h3", {
                                children: currentTask.taskLibelle
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                                initialValues: (0, $d6b69c1f76b50dec$export$a5cab80145b70e98)(listTasks.find((e)=>e.taskId === currentTask.taskId) ?? currentTask),
                                isPost: false,
                                submitUrl: "/api/task/personnalisee",
                                prepareVariables: (values)=>{
                                    const formData = new FormData();
                                    formData.append("taskId", values.taskId);
                                    formData.append("taskActif", values.taskActif);
                                    formData.append("taskPlanification", values.isPlanificationEnabled && (0, $d6b69c1f76b50dec$export$1acba170b8698051)(values).trim().length > 0 ? (0, $d6b69c1f76b50dec$export$1acba170b8698051)(values).trim() : "null");
                                    formData.append("taskParametres", JSON.stringify(values.taskParametres));
                                    formData.append("zipFile", values.zipFile);
                                    return formData;
                                },
                                isMultipartFormData: true,
                                onSubmit: ()=>window.location.reload(),
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $d6b69c1f76b50dec$export$2e2bcd8739ae039), {})
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $40a7b6af097c9e55$export$2e2bcd8739ae039 = $40a7b6af097c9e55$var$ListeTaskPersonnalisee;




var $kc00y = parcelRequire("kc00y");








const $9b8bcc9a1730b549$var$ListeTask = ()=>{
    const [currentTaskTypeState, setCurrentTaskType] = (0, $kc00y.useState)(null);
    const taskInfo = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/task/`);
    if (!taskInfo.isResolved) return;
    const listTasks = taskInfo.data.map((element)=>({
            taskId: element.taskId,
            taskType: element.taskType,
            taskActif: element.taskActif,
            taskPlanification: element.taskPlanification,
            taskExecManuelle: element.taskExecManuelle,
            taskParametres: element.taskParametres,
            taskNotification: element.taskNotification,
            isPlanificationEnabled: element.taskPlanification != null
        }));
    const typeTaskKey = Object.values((0, $bd5f3039059066bc$export$2e2bcd8739ae039)).filter((e)=>e.isConfigurable).map((e)=>e.id);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$d7cfde09abbb52ee), {}),
                title: "Param\xe9trage des traitements"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        xs: "5",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b9d4d12a3c294259$export$2e2bcd8739ae039), {
                            className: "flex-column bg-light p-2 border rounded mx-2",
                            variant: "pills",
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b9d4d12a3c294259$export$2e2bcd8739ae039).Item, {
                                children: typeTaskKey.map((key)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b9d4d12a3c294259$export$2e2bcd8739ae039).Link, {
                                        eventKey: key,
                                        onClick: ()=>setCurrentTaskType(key),
                                        children: (0, $bd5f3039059066bc$export$2e2bcd8739ae039)[key].label
                                    }, key))
                            })
                        })
                    }),
                    currentTaskTypeState && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        className: "bg-light p-2 border rounded mx-2",
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("h3", {
                                children: (0, $bd5f3039059066bc$export$2e2bcd8739ae039)[currentTaskTypeState].label
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                                initialValues: (0, $d6b69c1f76b50dec$export$a5cab80145b70e98)(listTasks.find((e)=>e.taskType === currentTaskTypeState)),
                                isPost: false,
                                submitUrl: "/api/task",
                                prepareVariables: (values)=>(0, $d6b69c1f76b50dec$export$f97400759cfd946)(values),
                                onSubmit: ()=>window.location.reload(),
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $d6b69c1f76b50dec$export$2e2bcd8739ae039), {})
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $9b8bcc9a1730b549$export$2e2bcd8739ae039 = $9b8bcc9a1730b549$var$ListeTask;











var $bkJfK = parcelRequire("bkJfK");


const $2dfd9a89aed51b7f$var$ImporterCadastre = ()=>{
    const { values: values } = (0, $bkJfK.useFormikContext)();
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("p", {
                children: 'Cette t\xe2che permet de t\xe9l\xe9charger les donn\xe9es du cadastre de votre territoire sur le site "files.data.gouv.fr/", et de faire le lien avec les communes existantes. Les donn\xe9es non int\xe9grables appara\xeetront en \xe9chec dans les logs, mais ne bloqueront pas.'
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                label: "Mill\xe9sime",
                name: "millesime",
                placeholder: "2023-01-01",
                required: false,
                value: values?.millesime
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                label: "Nettoyer les donn\xe9es du cadastre avant l'import",
                tooltipText: "Supprime toutes les donn\xe9es du cadastre non utilis\xe9es avant de r\xe9int\xe9grer les nouvelles donn\xe9es. Permet une r\xe9int\xe9gration propre sans donn\xe9es obsol\xe8tes.",
                name: "supprimerDonneesCadastreNonUtilisees",
                required: false,
                checked: values?.supprimerDonneesCadastreNonUtilisees
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                label: "Remplacer les g\xe9om\xe9tries existantes en cas de doublon",
                tooltipText: "En cas de doublon (m\xeame parcelle/section dans la m\xeame commune), remplace la g\xe9om\xe9trie existante par celle du nouveau cadastre. Si non s\xe9lectionn\xe9, conserve la g\xe9om\xe9trie d'origine.",
                name: "remplacerDonneesCadastre",
                required: false,
                checked: values?.remplacerDonneesCadastre
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db9b0e6fdb142a4c$export$2e2bcd8739ae039), {
                returnLink: false,
                submitTitle: "Ex\xe9cuter"
            })
        ]
    });
};
var $2dfd9a89aed51b7f$export$2e2bcd8739ae039 = $2dfd9a89aed51b7f$var$ImporterCadastre;





const $cbf52628be01e96e$var$LaunchSigTask = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("p", {
                children: "Cette action permet de lancer la synchronisation SIG."
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db9b0e6fdb142a4c$export$2e2bcd8739ae039), {
                returnLink: false,
                submitTitle: "Ex\xe9cuter"
            })
        ]
    });
};
var $cbf52628be01e96e$export$2e2bcd8739ae039 = $cbf52628be01e96e$var$LaunchSigTask;





const $46588bb3c6b1d569$var$RefreshViewMesures = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("p", {
                children: "Cette action permet de rafra\xeechir la vue des mesures."
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db9b0e6fdb142a4c$export$2e2bcd8739ae039), {
                returnLink: false,
                submitTitle: "Ex\xe9cuter"
            })
        ]
    });
};
var $46588bb3c6b1d569$export$2e2bcd8739ae039 = $46588bb3c6b1d569$var$RefreshViewMesures;





const $b8afdbb77a0f43a7$var$RefreshViewVisites = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("p", {
                children: "Cette action permet de rafra\xeechir la vue des visites."
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db9b0e6fdb142a4c$export$2e2bcd8739ae039), {
                returnLink: false,
                submitTitle: "Ex\xe9cuter"
            })
        ]
    });
};
var $b8afdbb77a0f43a7$export$2e2bcd8739ae039 = $b8afdbb77a0f43a7$var$RefreshViewVisites;




var $bkJfK = parcelRequire("bkJfK");


const $32f50669a2add57c$var$RelancerCalculDispo = ()=>{
    const { values: values } = (0, $bkJfK.useFormikContext)();
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("p", {
                children: "Cette t\xe2che permet de relancer en masse le calcul de disponibilit\xe9 de tous les PEI suite \xe0 un changement de r\xe8gles de gestion. Deux booleans sont disponibles pour configurer le comportement de la t\xe2che."
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                name: "eventTracabilite",
                label: "Ajouter les changements dans la tra\xe7abilit\xe9",
                checked: values?.eventTracabilite,
                tooltipText: "Si la case est coch\xe9e, la table tra\xe7abilit\xe9 sera mise \xe0 jour."
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                name: "eventNexSis",
                label: "Mettre \xe0 jour les PEI dans NexSIS",
                checked: values?.eventNexSis,
                tooltipText: "Si la case est coch\xe9e, les changements seront notifi\xe9s \xe0 NexSIS."
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db9b0e6fdb142a4c$export$2e2bcd8739ae039), {
                returnLink: false,
                submitTitle: "Ex\xe9cuter"
            })
        ]
    });
};
var $32f50669a2add57c$export$2e2bcd8739ae039 = $32f50669a2add57c$var$RelancerCalculDispo;




var $bkJfK = parcelRequire("bkJfK");


const $7e37990193f3365a$var$RelancerCalculNumerotation = ()=>{
    const { values: values } = (0, $bkJfK.useFormikContext)();
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("p", {
                children: "Cette t\xe2che permet de relancer en masse le calcul de la num\xe9rotation de tous les PEI suite \xe0 un changement de r\xe8gles de gestion. Deux booleans sont disponibles pour configurer le comportement de la t\xe2che."
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                id: "eventTracabiliteNumero",
                name: "eventTracabilite",
                label: "Ajouter les changements dans la tra\xe7abilit\xe9",
                checked: values?.eventTracabilite,
                tooltipText: "Si la case est coch\xe9e, la table tra\xe7abilit\xe9 sera mise \xe0 jour."
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                id: "eventNexSisNumero",
                name: "eventNexSis",
                label: "Mettre \xe0 jour les PEI dans NexSIS",
                checked: values?.eventNexSis,
                tooltipText: "Si la case est coch\xe9e, les changements seront notifi\xe9s \xe0 NexSIS."
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db9b0e6fdb142a4c$export$2e2bcd8739ae039), {
                returnLink: false,
                submitTitle: "Ex\xe9cuter"
            })
        ]
    });
};
var $7e37990193f3365a$export$2e2bcd8739ae039 = $7e37990193f3365a$var$RelancerCalculNumerotation;


const $12139b22683cc1d3$var$ExecuteTasksManuelles = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$340bfce9b4df026b), {}),
                title: "Ex\xe9cuter des traitements manuellement"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($12139b22683cc1d3$var$CardTask, {
                            title: "Relancer le calcul de disponibilit\xe9",
                            apiUrl: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/admin/relancer-calcul-dispo`,
                            prepareVariables: $12139b22683cc1d3$var$prepareVariablesCalculDispoNumero,
                            initialValues: $12139b22683cc1d3$var$initialValuesCalculDispoNumero,
                            validationSchema: $12139b22683cc1d3$var$validationSchemaCalculDispoNumero,
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $32f50669a2add57c$export$2e2bcd8739ae039), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($12139b22683cc1d3$var$CardTask, {
                            title: "Relancer le calcul de la num\xe9rotation",
                            apiUrl: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/admin/relancer-calcul-numerotation`,
                            prepareVariables: $12139b22683cc1d3$var$prepareVariablesCalculDispoNumero,
                            initialValues: $12139b22683cc1d3$var$initialValuesCalculDispoNumero,
                            validationSchema: $12139b22683cc1d3$var$validationSchemaCalculDispoNumero,
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $7e37990193f3365a$export$2e2bcd8739ae039), {})
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($12139b22683cc1d3$var$CardTask, {
                        title: "Import du cadastre",
                        apiUrl: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/admin/importer-cadastre`,
                        prepareVariables: $12139b22683cc1d3$var$prepareVariablesImporterCadastre,
                        initialValues: $12139b22683cc1d3$var$initialValuesImporterCadastre,
                        validationSchema: $12139b22683cc1d3$var$validationSchemaImporterCadastre,
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2dfd9a89aed51b7f$export$2e2bcd8739ae039), {})
                    })
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($12139b22683cc1d3$var$CardTask, {
                            title: "Rafra\xeechir la vue des visites",
                            apiUrl: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/admin/refresh-view-visites`,
                            prepareVariables: ()=>({}),
                            initialValues: {},
                            validationSchema: (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({}),
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b8afdbb77a0f43a7$export$2e2bcd8739ae039), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($12139b22683cc1d3$var$CardTask, {
                            title: "Rafra\xeechir la vue des mesures",
                            apiUrl: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/admin/refresh-view-mesures`,
                            prepareVariables: ()=>({}),
                            initialValues: {},
                            validationSchema: (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({}),
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $46588bb3c6b1d569$export$2e2bcd8739ae039), {})
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($12139b22683cc1d3$var$CardTask, {
                        title: "Lancer la synchronisation SIG",
                        apiUrl: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/admin/launch-sig-task`,
                        prepareVariables: ()=>({}),
                        initialValues: {},
                        validationSchema: (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({}),
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $cbf52628be01e96e$export$2e2bcd8739ae039), {})
                    })
                })
            })
        ]
    });
};
const $12139b22683cc1d3$var$prepareVariablesCalculDispoNumero = (values)=>{
    return {
        eventTracabilite: values.eventTracabilite,
        eventNexSis: values.eventNexSis
    };
};
const $12139b22683cc1d3$var$initialValuesCalculDispoNumero = {
    eventTracabilite: false,
    eventNexSis: false
};
const $12139b22683cc1d3$var$validationSchemaCalculDispoNumero = (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({
    eventTracabilite: (0, $ce4de947442b2ab1$export$87b259aa03e3d267)().required(),
    eventNexSis: (0, $ce4de947442b2ab1$export$87b259aa03e3d267)().required()
});
const $12139b22683cc1d3$var$prepareVariablesImporterCadastre = (values)=>{
    return values;
};
const $12139b22683cc1d3$var$initialValuesImporterCadastre = {
    millesime: null,
    supprimerDonneesCadastreNonUtilisees: false,
    remplacerDonneesCadastre: false
};
const $12139b22683cc1d3$var$validationSchemaImporterCadastre = (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({
    millesime: (0, $ce4de947442b2ab1$export$22b082955e083ec3)().nullable(),
    supprimerDonneesCadastreNonUtilisees: (0, $ce4de947442b2ab1$export$87b259aa03e3d267)().required(),
    remplacerDonneesCadastre: (0, $ce4de947442b2ab1$export$87b259aa03e3d267)().required()
});
const $12139b22683cc1d3$var$CardTask = ({ title: title, apiUrl: apiUrl, prepareVariables: prepareVariables, initialValues: initialValues, validationSchema: validationSchema, children: children })=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1988c313b8430f65$export$2e2bcd8739ae039), {
        className: "mb-4 shadow",
        style: {
            borderRadius: "1rem",
            overflow: "hidden"
        },
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1988c313b8430f65$export$2e2bcd8739ae039).Header, {
                className: "bg-primary text-white fs-5",
                children: title
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1988c313b8430f65$export$2e2bcd8739ae039).Body, {
                className: "bg-secondary",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                    submitUrl: apiUrl,
                    prepareVariables: (values)=>{
                        return prepareVariables(values);
                    },
                    validationSchema: validationSchema,
                    isPost: true,
                    initialValues: initialValues,
                    onSubmit: ()=>null,
                    children: children
                })
            })
        ]
    });
};
var $12139b22683cc1d3$export$2e2bcd8739ae039 = $12139b22683cc1d3$var$ExecuteTasksManuelles;






const $62b113d43e2fafa5$var$CreateThematique = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1cf1e7fff5b3e31a$export$2e2bcd8739ae039), {
        typeNomenclature: (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).THEMATIQUE,
        redirectLink: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_THEMATIQUE
    });
};
var $62b113d43e2fafa5$export$2e2bcd8739ae039 = $62b113d43e2fafa5$var$CreateThematique;







const $bcb21ecb3f9cc3c8$var$ListThematique = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e5bcd0ed5e4cafe8$export$2e2bcd8739ae039), {
            pageTitle: "Th\xe9matiques",
            addButtonTitle: "Ajouter une th\xe9matique",
            pageIcon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$ba2fbb9644c8bf32), {}),
            lienPageAjout: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).ADD_THEMATIQUE,
            typeNomenclature: (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).THEMATIQUE,
            lienPageUpdate: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).UPDATE_THEMATIQUE
        })
    });
};
var $bcb21ecb3f9cc3c8$export$2e2bcd8739ae039 = $bcb21ecb3f9cc3c8$var$ListThematique;







const $b50b9a868721d5a8$var$UpdateThematique = ()=>{
    const { thematiqueId: thematiqueId } = (0, $7a844823b04d4282$export$99eaa27ddbbb95ef)();
    return thematiqueId && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $4e0326405bcaf2aa$export$2e2bcd8739ae039), {
        nomenclatureId: thematiqueId,
        typeNomenclature: (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).THEMATIQUE,
        redirectLink: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_THEMATIQUE
    });
};
var $b50b9a868721d5a8$export$2e2bcd8739ae039 = $b50b9a868721d5a8$var$UpdateThematique;






const $f44627e567122d89$var$CreateTypeCanalisation = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1cf1e7fff5b3e31a$export$2e2bcd8739ae039), {
        typeNomenclature: (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).TYPE_CANALISATION,
        redirectLink: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_TYPE_CANALISATION
    });
};
var $f44627e567122d89$export$2e2bcd8739ae039 = $f44627e567122d89$var$CreateTypeCanalisation;







const $d7a8f8dd952ec6e5$var$ListTypeCanalisation = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e5bcd0ed5e4cafe8$export$2e2bcd8739ae039), {
            pageTitle: "Types de canalisation",
            addButtonTitle: "Ajouter un type de canalisation",
            pageIcon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$ba2fbb9644c8bf32), {}),
            hasProtectedValue: false,
            lienPageAjout: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).ADD_TYPE_CANALISATION,
            typeNomenclature: (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).TYPE_CANALISATION,
            lienPageUpdate: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).UPDATE_TYPE_CANALISATION
        })
    });
};
var $d7a8f8dd952ec6e5$export$2e2bcd8739ae039 = $d7a8f8dd952ec6e5$var$ListTypeCanalisation;







const $b341973d98a5f2d5$var$UpdateTypeCanalisation = ()=>{
    const { typeCanalisationId: typeCanalisationId } = (0, $7a844823b04d4282$export$99eaa27ddbbb95ef)();
    return typeCanalisationId && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $4e0326405bcaf2aa$export$2e2bcd8739ae039), {
        nomenclatureId: typeCanalisationId,
        typeNomenclature: (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).TYPE_CANALISATION,
        redirectLink: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_TYPE_CANALISATION
    });
};
var $b341973d98a5f2d5$export$2e2bcd8739ae039 = $b341973d98a5f2d5$var$UpdateTypeCanalisation;






const $d40c36bab19bf0a4$var$CreateTypeEngin = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1cf1e7fff5b3e31a$export$2e2bcd8739ae039), {
        typeNomenclature: (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).TYPE_ENGIN,
        redirectLink: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_TYPE_ENGIN,
        titrePage: "Cr\xe9ation d'un type d'engin"
    });
};
var $d40c36bab19bf0a4$export$2e2bcd8739ae039 = $d40c36bab19bf0a4$var$CreateTypeEngin;







const $363073eee7b7b1a4$var$ListTypeEngin = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e5bcd0ed5e4cafe8$export$2e2bcd8739ae039), {
            pageTitle: "Types d'engin",
            addButtonTitle: "Ajouter un type d'engin",
            pageIcon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$ba2fbb9644c8bf32), {}),
            hasProtectedValue: false,
            lienPageAjout: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).ADD_TYPE_ENGIN,
            typeNomenclature: (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).TYPE_ENGIN,
            lienPageUpdate: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).UPDATE_TYPE_ENGIN
        })
    });
};
var $363073eee7b7b1a4$export$2e2bcd8739ae039 = $363073eee7b7b1a4$var$ListTypeEngin;







const $c67383bb1ca7e54f$var$UpdateTypeEngin = ()=>{
    const { typeEnginId: typeEnginId } = (0, $7a844823b04d4282$export$99eaa27ddbbb95ef)();
    return typeEnginId && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $4e0326405bcaf2aa$export$2e2bcd8739ae039), {
        nomenclatureId: typeEnginId,
        typeNomenclature: (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).TYPE_ENGIN,
        redirectLink: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_TYPE_ENGIN,
        titrePage: "Modification d'un type d'engin"
    });
};
var $c67383bb1ca7e54f$export$2e2bcd8739ae039 = $c67383bb1ca7e54f$var$UpdateTypeEngin;






const $fbde39500bdb2cf0$var$CreateTypeEtude = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1cf1e7fff5b3e31a$export$2e2bcd8739ae039), {
        typeNomenclature: (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).TYPE_ETUDE,
        redirectLink: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_TYPE_ETUDE
    });
};
var $fbde39500bdb2cf0$export$2e2bcd8739ae039 = $fbde39500bdb2cf0$var$CreateTypeEtude;







const $6c440898ee7fa736$var$ListTypeEtude = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e5bcd0ed5e4cafe8$export$2e2bcd8739ae039), {
            pageTitle: "Types d'\xe9tudes",
            addButtonTitle: "Ajouter un type d'\xe9tude",
            pageIcon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$ba2fbb9644c8bf32), {}),
            hasProtectedValue: false,
            lienPageAjout: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).ADD_TYPE_ETUDE,
            typeNomenclature: (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).TYPE_ETUDE,
            lienPageUpdate: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).UPDATE_TYPE_ETUDE
        })
    });
};
var $6c440898ee7fa736$export$2e2bcd8739ae039 = $6c440898ee7fa736$var$ListTypeEtude;







const $e9df073b73d1f4d6$var$UpdateTypeEtude = ()=>{
    const { typeEtudeId: typeEtudeId } = (0, $7a844823b04d4282$export$99eaa27ddbbb95ef)();
    return typeEtudeId && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $4e0326405bcaf2aa$export$2e2bcd8739ae039), {
        nomenclatureId: typeEtudeId,
        typeNomenclature: (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).TYPE_ETUDE,
        redirectLink: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_TYPE_ETUDE
    });
};
var $e9df073b73d1f4d6$export$2e2bcd8739ae039 = $e9df073b73d1f4d6$var$UpdateTypeEtude;






const $a2249221b7b8076f$var$CreateTypePenaAspiration = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1cf1e7fff5b3e31a$export$2e2bcd8739ae039), {
        typeNomenclature: (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).TYPE_PENA_ASPIRATION,
        redirectLink: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_TYPE_PENA_ASPIRATION
    });
};
var $a2249221b7b8076f$export$2e2bcd8739ae039 = $a2249221b7b8076f$var$CreateTypePenaAspiration;







const $708025c61e582c3b$var$ListTypePenaAspiration = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e5bcd0ed5e4cafe8$export$2e2bcd8739ae039), {
            pageTitle: "Types de dispositifs d'aspiration",
            addButtonTitle: "Ajouter un type d'aspiration",
            pageIcon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$ba2fbb9644c8bf32), {}),
            hasProtectedValue: false,
            lienPageAjout: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).ADD_TYPE_PENA_ASPIRATION,
            typeNomenclature: (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).TYPE_PENA_ASPIRATION,
            lienPageUpdate: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).UPDATE_TYPE_PENA_ASPIRATION
        })
    });
};
var $708025c61e582c3b$export$2e2bcd8739ae039 = $708025c61e582c3b$var$ListTypePenaAspiration;







const $5bb7009d13f5389b$var$UpdateTypePenaAspiration = ()=>{
    const { typePenaAspirationId: typePenaAspirationId } = (0, $7a844823b04d4282$export$99eaa27ddbbb95ef)();
    return typePenaAspirationId && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $4e0326405bcaf2aa$export$2e2bcd8739ae039), {
        nomenclatureId: typePenaAspirationId,
        typeNomenclature: (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).TYPE_PENA_ASPIRATION,
        redirectLink: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_TYPE_PENA_ASPIRATION
    });
};
var $5bb7009d13f5389b$export$2e2bcd8739ae039 = $5bb7009d13f5389b$var$UpdateTypePenaAspiration;






const $e448f3f461bace02$var$CreateTypeReseau = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1cf1e7fff5b3e31a$export$2e2bcd8739ae039), {
        typeNomenclature: (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).TYPE_RESEAU,
        redirectLink: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_TYPE_RESEAU
    });
};
var $e448f3f461bace02$export$2e2bcd8739ae039 = $e448f3f461bace02$var$CreateTypeReseau;







const $1e886f96e245809c$var$ListTypeReseau = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e5bcd0ed5e4cafe8$export$2e2bcd8739ae039), {
            pageTitle: "Types de r\xe9seaux",
            addButtonTitle: "Ajouter un type de r\xe9seau",
            pageIcon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$ba2fbb9644c8bf32), {}),
            hasProtectedValue: false,
            lienPageAjout: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).ADD_TYPE_RESEAU,
            typeNomenclature: (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).TYPE_RESEAU,
            lienPageUpdate: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).UPDATE_TYPE_RESEAU
        })
    });
};
var $1e886f96e245809c$export$2e2bcd8739ae039 = $1e886f96e245809c$var$ListTypeReseau;







const $4436a729df429bad$var$UpdateTypeReseau = ()=>{
    const { typeReseauId: typeReseauId } = (0, $7a844823b04d4282$export$99eaa27ddbbb95ef)();
    return typeReseauId && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $4e0326405bcaf2aa$export$2e2bcd8739ae039), {
        nomenclatureId: typeReseauId,
        typeNomenclature: (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).TYPE_RESEAU,
        redirectLink: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_TYPE_RESEAU
    });
};
var $4436a729df429bad$export$2e2bcd8739ae039 = $4436a729df429bad$var$UpdateTypeReseau;










var $bkJfK = parcelRequire("bkJfK");

var $kc00y = parcelRequire("kc00y");












const $8141a921eabc8f0b$export$a5cab80145b70e98 = (data)=>({
        utilisateurActif: data?.utilisateurActif ?? true,
        utilisateurEmail: data?.utilisateurEmail ?? null,
        utilisateurNom: data?.utilisateurNom ?? null,
        utilisateurPrenom: data?.utilisateurPrenom ?? null,
        utilisateurTelephone: data?.utilisateurTelephone ?? null,
        utilisateurUsername: data?.utilisateurUsername ?? null,
        utilisateurCanBeNotified: data?.utilisateurCanBeNotified ?? true,
        utilisateurProfilUtilisateurId: data?.utilisateurProfilUtilisateurId ?? null,
        utilisateurOrganismeId: data?.utilisateurOrganismeId ?? null,
        utilisateurIsSuperAdmin: data?.utilisateurIsSuperAdmin ?? false
    });
const $8141a921eabc8f0b$export$c084437b5e3206cd = (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({
    utilisateurEmail: (0, $36ceaed6faf947af$export$f25be618b434f50b)
});
const $8141a921eabc8f0b$export$f97400759cfd946 = (values)=>({
        utilisateurActif: values?.utilisateurActif,
        utilisateurEmail: values.utilisateurEmail,
        utilisateurNom: values.utilisateurNom,
        utilisateurPrenom: values.utilisateurPrenom,
        utilisateurTelephone: values.utilisateurTelephone,
        utilisateurUsername: values.utilisateurUsername,
        utilisateurCanBeNotified: values.utilisateurCanBeNotified,
        utilisateurProfilUtilisateurId: values.utilisateurProfilUtilisateurId,
        utilisateurOrganismeId: values.utilisateurOrganismeId,
        utilisateurIsSuperAdmin: values.utilisateurIsSuperAdmin,
        utilisateurFromLdap: values.utilisateurFromLdap ?? false
    });
const $8141a921eabc8f0b$var$Utilisateur = ()=>{
    const { user: user } = (0, $e787cde576104469$export$fdc397e486fa83e7)();
    const { utilisateurId: utilisateurId } = (0, $7a844823b04d4282$export$99eaa27ddbbb95ef)();
    const [groupeFonctionnalitesDeduit, setGroupeFonctionnalitesDeduit] = (0, $kc00y.useState)();
    const { data: organismeList } = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/organisme/get-all`);
    const { data: profilUtilisateurList } = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/profil-utilisateur`);
    const { data: groupeFonctionnalitesWithProfilsList } = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/groupe-fonctionnalites/profils`);
    const { values: values, setValues: setValues, setFieldValue: setFieldValue } = (0, $bkJfK.useFormikContext)();
    // Vérification de l'origine LDAP de l'utilisateur.
    const { error: fromLdapError } = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)(utilisateurId ? (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/utilisateur/get/` + utilisateurId + `/from-ldap` : "", {
        onResolve: (data)=>setFieldValue("utilisateurFromLdap", Boolean(data?.utilisateurFromLdap)),
        onReject: ()=>setFieldValue("utilisateurFromLdap", false)
    });
    const utilisateurFromLdap = Boolean(values.utilisateurFromLdap);
    (0, $kc00y.useEffect)(()=>{
        setGroupeFonctionnalitesDeduit(groupeFonctionnalitesWithProfilsList?.find((e)=>e.profilUtilisateurId === values.utilisateurProfilUtilisateurId && e.profilOrganismeId === organismeList?.find((e)=>e.id === values.utilisateurOrganismeId)?.lienId)?.libelle);
    }, [
        groupeFonctionnalitesWithProfilsList,
        organismeList,
        values.utilisateurProfilUtilisateurId,
        values.utilisateurOrganismeId
    ]);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
        children: [
            utilisateurFromLdap && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                className: "mt-3",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $8598ca69ed8b9dca$export$2e2bcd8739ae039), {
                        variant: "info",
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$340bfce9b4df026b), {}),
                            " Cet utilisateur provient du LDAP : l'identifiant, l'email, le nom et le pr\xe9nom ne peuvent pas \xeatre modifi\xe9s depuis REMOcRA"
                        ]
                    })
                })
            }),
            fromLdapError && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                className: "mt-3",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $8598ca69ed8b9dca$export$2e2bcd8739ae039), {
                        variant: "warning",
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$5be70e40251e6f9b), {}),
                            " Impossible de v\xe9rifier si cet utilisateur provient du LDAP (Keycloak indisponible). Il sera peut \xeatre impossible de modifier l'identifiant, l'email, le nom ou le pr\xe9nom de cet utilisateur."
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                className: "mt-3",
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                            name: "utilisateurActif",
                            label: "Actif"
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                            name: "utilisateurCanBeNotified",
                            label: "Peut \xeatre notifi\xe9"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                className: "mt-3",
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                            label: "Email",
                            name: "utilisateurEmail",
                            required: true,
                            disabled: utilisateurFromLdap
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                            label: "Identifiant",
                            name: "utilisateurUsername",
                            required: true,
                            disabled: utilisateurFromLdap
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                            label: "T\xe9l\xe9phone",
                            name: "utilisateurTelephone",
                            required: false
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                className: "mt-3",
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                            label: "Nom",
                            name: "utilisateurNom",
                            required: false,
                            disabled: utilisateurFromLdap
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                            label: "Pr\xe9nom",
                            name: "utilisateurPrenom",
                            required: false,
                            disabled: utilisateurFromLdap
                        })
                    })
                ]
            }),
            user?.isSuperAdmin && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                className: "mt-3",
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                            tooltipId: "superAdmin",
                            tooltipText: "Si vous cochez cette case, l'utilisateur aura tous les droits sur l'application ind\xe9pendamment d'une zone de comp\xe9tence.",
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                                name: "utilisateurIsSuperAdmin",
                                label: "Est super administrateur"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: " "
                    }),
                    " ",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: " "
                    })
                ]
            }),
            (!values.utilisateurIsSuperAdmin && user?.isSuperAdmin || !values.utilisateurIsSuperAdmin) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                className: "mt-3",
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                            name: "utilisateurOrganismeId",
                            listIdCodeLibelle: organismeList,
                            label: "Organisme",
                            defaultValue: organismeList?.find((e)=>e.id === values.utilisateurOrganismeId),
                            onChange: (e)=>{
                                setFieldValue("utilisateurOrganismeId", e?.id);
                                setFieldValue("utilisateurProfilUtilisateurId", undefined);
                            },
                            required: true
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        className: "mt-3  d-flex align-items-center justify-content-center display-6",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$4176b1d4e95be624), {})
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                            name: "utilisateurProfilUtilisateurId",
                            listIdCodeLibelle: profilUtilisateurList?.filter((profil)=>groupeFonctionnalitesWithProfilsList?.filter((item)=>item.profilOrganismeId === organismeList?.find((e)=>e.id === values.utilisateurOrganismeId)?.lienId).map((item)=>item.profilUtilisateurId).includes(profil.id)),
                            label: "Profil utilisateur",
                            defaultValue: profilUtilisateurList?.find((e)=>e.id === values.utilisateurProfilUtilisateurId),
                            required: true,
                            setValues: setValues
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        className: "text-center d-flex align-items-center justify-content-center display-6",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$3213a407ffb0559), {})
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        className: "bg-light p-3 border rounded",
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                                className: "fw-bold p-2 text-center",
                                children: [
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$340bfce9b4df026b), {}),
                                    " Groupe de fonctionnalit\xe9s",
                                    " ",
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("span", {
                                        className: "text-danger",
                                        children: "*"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                className: "text-center",
                                children: groupeFonctionnalitesDeduit != null ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                                    children: [
                                        "Le groupe de fonctionnalit\xe9s qui sera utilis\xe9 pour cet utilisateur sera : ",
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("b", {
                                            children: groupeFonctionnalitesDeduit
                                        })
                                    ]
                                }) : "Aucun groupe de fonctionnalit\xe9s trouv\xe9."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db9b0e6fdb142a4c$export$2e2bcd8739ae039), {
                returnLink: true,
                disabledValide: !groupeFonctionnalitesDeduit && !values.utilisateurIsSuperAdmin
            })
        ]
    });
};
var $8141a921eabc8f0b$export$2e2bcd8739ae039 = $8141a921eabc8f0b$var$Utilisateur;


const $d047e2f9b5073ade$var$CreateUtilisateur = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$d776d19dfae66ece), {}),
                title: "Cr\xe9ation d'un utilisateur"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                initialValues: (0, $8141a921eabc8f0b$export$a5cab80145b70e98)(),
                validationSchema: (0, $8141a921eabc8f0b$export$c084437b5e3206cd),
                isPost: true,
                isMultipartFormData: false,
                submitUrl: `/api/utilisateur/create/`,
                prepareVariables: (values)=>(0, $8141a921eabc8f0b$export$f97400759cfd946)(values),
                redirectUrl: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_UTILISATEUR,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8141a921eabc8f0b$export$2e2bcd8739ae039), {})
            })
        ]
    });
};
var $d047e2f9b5073ade$export$2e2bcd8739ae039 = $d047e2f9b5073ade$var$CreateUtilisateur;




















const $729ac2c4c517ef6f$var$FilterValues = ({ utilisateurEmail: utilisateurEmail, utilisateurUsername: utilisateurUsername, utilisateurNom: utilisateurNom, utilisateurPrenom: utilisateurPrenom, utilisateurTelephone: utilisateurTelephone, utilisateurCanBeNotified: utilisateurCanBeNotified, utilisateurOrganismeId: utilisateurOrganismeId, utilisateurProfilUtilisateurId: utilisateurProfilUtilisateurId, groupeFonctionnalitesId: groupeFonctionnalitesId, utilisateurActif: utilisateurActif })=>{
    const filter = {};
    $729ac2c4c517ef6f$var$filterProperty(filter, utilisateurEmail, "utilisateurEmail");
    $729ac2c4c517ef6f$var$filterProperty(filter, utilisateurUsername, "utilisateurUsername");
    $729ac2c4c517ef6f$var$filterProperty(filter, utilisateurNom, "utilisateurNom");
    $729ac2c4c517ef6f$var$filterProperty(filter, utilisateurPrenom, "utilisateurPrenom");
    $729ac2c4c517ef6f$var$filterProperty(filter, utilisateurTelephone, "utilisateurTelephone");
    $729ac2c4c517ef6f$var$filterProperty(filter, utilisateurCanBeNotified, "utilisateurCanBeNotified");
    $729ac2c4c517ef6f$var$filterProperty(filter, utilisateurOrganismeId, "utilisateurOrganismeId");
    $729ac2c4c517ef6f$var$filterProperty(filter, utilisateurProfilUtilisateurId, "utilisateurProfilUtilisateurId");
    $729ac2c4c517ef6f$var$filterProperty(filter, groupeFonctionnalitesId, "groupeFonctionnalitesId");
    $729ac2c4c517ef6f$var$filterProperty(filter, utilisateurActif, "utilisateurActif");
    return filter;
};
function $729ac2c4c517ef6f$var$filterProperty(filter, value, name) {
    if (value != null && value.trim() !== "") filter[name] = value;
}
var $729ac2c4c517ef6f$export$2e2bcd8739ae039 = $729ac2c4c517ef6f$var$FilterValues;


const $6ef4d54939420c74$var$ListUtilisateur = ()=>{
    const { user: user } = (0, $e787cde576104469$export$fdc397e486fa83e7)();
    const canManageUsers = (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_UTILISATEURS_A) || (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_UTILISATEURS_ORGA_A);
    const canImportUsers = (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).IMPORT_UTILISATEUR_A);
    const { data: organismeList } = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/organisme/get-all`);
    const { data: groupeFonctionnalitesList } = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/groupe-fonctionnalites`);
    const { data: profilUtilisateurList } = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/profil-utilisateur`);
    const listeButton = [];
    if (canManageUsers) {
        listeButton.push({
            row: (row)=>{
                return row;
            },
            route: (utilisateurId)=>(0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).UPDATE_UTILISATEUR(utilisateurId),
            type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).UPDATE,
            disable: (v)=>{
                return !v.original.canAdministrate;
            },
            textDisable: "Vous n'avez pas de droits de mises \xe0 jour"
        });
        listeButton.push({
            row: (row)=>{
                return row;
            },
            type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).DELETE,
            disable: (v)=>{
                return v.value === user?.utilisateurId || !v.original.canAdministrate;
            },
            textDisable: "Vous n'avez pas de droits de suppression",
            pathname: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/utilisateur/delete/`,
            textEnable: "Attention, si l'utilisateur vient d'un annuaire, le compte sera de nouveau pr\xe9sent lors de la synchronisation. Si vous souhaitez le supprimer, supprimez-le de l'annuaire, la synchronisation se chargera ensuite de la suppression dans REMOcRA"
        });
    }
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
            fluid: true,
            className: "px-5",
            children: [
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                    icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$3c0742b661df1fc4), {}),
                    title: "Utilisateurs",
                    right: (canManageUsers || canImportUsers) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                        children: [
                            canManageUsers && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8ad69b89456b65bc$export$2e2bcd8739ae039), {
                                href: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).ADD_UTILISATEUR,
                                title: "Ajouter un utilisateur"
                            }),
                            canImportUsers && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8ad69b89456b65bc$export$2e2bcd8739ae039), {
                                classnames: "ms-5",
                                href: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).IMPORT_UTILISATEUR,
                                title: "Importer des utilisateurs"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $9a9eebc3462fba73$export$2e2bcd8739ae039), {
                    query: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/utilisateur`,
                    columns: [
                        {
                            Header: "Email",
                            accessor: "utilisateurEmail",
                            sortField: "utilisateurEmail",
                            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                                type: "text",
                                name: "utilisateurEmail"
                            })
                        },
                        {
                            Header: "Identifiant",
                            accessor: "utilisateurUsername",
                            sortField: "utilisateurUsername",
                            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                                type: "text",
                                name: "utilisateurUsername"
                            })
                        },
                        {
                            Header: "Nom",
                            accessor: "utilisateurNom",
                            sortField: "utilisateurNom",
                            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                                type: "text",
                                name: "utilisateurNom"
                            })
                        },
                        {
                            Header: "Pr\xe9nom",
                            accessor: "utilisateurPrenom",
                            sortField: "utilisateurPrenom",
                            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                                type: "text",
                                name: "utilisateurPrenom"
                            })
                        },
                        {
                            Header: "T\xe9l\xe9phone",
                            accessor: "utilisateurTelephone",
                            sortField: "utilisateurTelephone",
                            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                                type: "text",
                                name: "utilisateurTelephone"
                            })
                        },
                        (0, $b82b937cc97f6f18$export$38dcf858d3ede0e9)({
                            Header: "Peut \xeatre notifi\xe9",
                            accessor: "utilisateurCanBeNotified",
                            sortField: "utilisateurCanBeNotified",
                            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eed37ff3d3e1f28c$export$2e2bcd8739ae039), {
                                options: (0, $a4f278cac9030fb1$export$2e2bcd8739ae039),
                                name: "utilisateurCanBeNotified"
                            })
                        }),
                        {
                            Header: "Organisme",
                            accessor: "organismeLibelle",
                            sortField: "organismeLibelle",
                            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $3744b2a772efdf44$export$2e2bcd8739ae039), {
                                name: "utilisateurOrganismeId",
                                listIdCodeLibelle: organismeList
                            })
                        },
                        {
                            Header: "Profil utilisateur",
                            accessor: "profilUtilisateurLibelle",
                            sortField: "profilUtilisateurLibelle",
                            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $3744b2a772efdf44$export$2e2bcd8739ae039), {
                                name: "utilisateurProfilUtilisateurId",
                                listIdCodeLibelle: profilUtilisateurList
                            })
                        },
                        {
                            Header: "Groupe de fonctionnalit\xe9s",
                            accessor: "groupeFonctionnalitesLibelle",
                            sortField: "groupeFonctionnalitesLibelle",
                            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $3744b2a772efdf44$export$2e2bcd8739ae039), {
                                name: "groupeFonctionnalitesId",
                                listIdCodeLibelle: groupeFonctionnalitesList
                            })
                        },
                        (0, $b82b937cc97f6f18$export$38dcf858d3ede0e9)({
                            Header: "Actif",
                            accessor: "utilisateurActif",
                            sortField: "utilisateurActif",
                            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eed37ff3d3e1f28c$export$2e2bcd8739ae039), {
                                options: (0, $a4f278cac9030fb1$export$2e2bcd8739ae039),
                                name: "utilisateurActif"
                            })
                        }),
                        (0, $b82b937cc97f6f18$export$36e9f5a475c9f6fc)({
                            Header: "Actions",
                            accessor: "utilisateurId",
                            buttons: listeButton
                        })
                    ],
                    idName: "tableUtilisateurId",
                    filterValuesToVariable: (0, $729ac2c4c517ef6f$export$2e2bcd8739ae039),
                    filterContext: (0, $9a9eebc3462fba73$export$396ef541d9951d45)({})
                })
            ]
        })
    });
};
var $6ef4d54939420c74$export$2e2bcd8739ae039 = $6ef4d54939420c74$var$ListUtilisateur;












const $0bfdbc6ad1277f1e$var$UpdateUtilisateur = ()=>{
    const { utilisateurId: utilisateurId } = (0, $7a844823b04d4282$export$99eaa27ddbbb95ef)();
    const { data: data } = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/utilisateur/get/` + utilisateurId);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$b51dd496211ae105), {}),
                title: "Mise \xe0 jour d'un utilisateur"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                initialValues: (0, $8141a921eabc8f0b$export$a5cab80145b70e98)(data),
                validationSchema: (0, $8141a921eabc8f0b$export$c084437b5e3206cd),
                isPost: false,
                isMultipartFormData: false,
                submitUrl: `/api/utilisateur/update/` + utilisateurId,
                prepareVariables: (values)=>(0, $8141a921eabc8f0b$export$f97400759cfd946)(values),
                redirectUrl: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_UTILISATEUR,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8141a921eabc8f0b$export$2e2bcd8739ae039), {})
            })
        ]
    });
};
var $0bfdbc6ad1277f1e$export$2e2bcd8739ae039 = $0bfdbc6ad1277f1e$var$UpdateUtilisateur;




var $bkJfK = parcelRequire("bkJfK");



















const $5178faa7955d3a9c$var$FilterValues = ({ zoneIntegrationCode: zoneIntegrationCode, zoneIntegrationLibelle: zoneIntegrationLibelle, zoneIntegrationActif: zoneIntegrationActif })=>{
    const filter = {};
    $5178faa7955d3a9c$var$filterProperty(filter, zoneIntegrationCode, "zoneIntegrationCode");
    $5178faa7955d3a9c$var$filterProperty(filter, zoneIntegrationLibelle, "zoneIntegrationLibelle");
    $5178faa7955d3a9c$var$filterProperty(filter, zoneIntegrationActif, "zoneIntegrationActif");
    return filter;
};
function $5178faa7955d3a9c$var$filterProperty(filter, value, name) {
    if (value != null && value.trim() !== "") filter[name] = value;
}
var $5178faa7955d3a9c$export$2e2bcd8739ae039 = $5178faa7955d3a9c$var$FilterValues;


const $a62d163b52d0700d$export$a5cab80145b70e98 = ()=>({
        fileGeometries: null
    });
const $a62d163b52d0700d$export$c084437b5e3206cd = (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({});
const $a62d163b52d0700d$export$f97400759cfd946 = (values)=>{
    const formData = new FormData();
    formData.append("fileGeometries", values.fileGeometries);
    return formData;
};
const $a62d163b52d0700d$var$ListZoneIntegration = ()=>{
    const { user: user } = (0, $e787cde576104469$export$fdc397e486fa83e7)();
    const listeButton = [];
    if ((0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_ZONE_COMPETENCE)) {
        listeButton.push({
            row: (row)=>{
                return row;
            },
            route: (zoneIntegrationId)=>(0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).UPDATE_ZONE_INTEGRATION(zoneIntegrationId),
            type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).UPDATE
        });
        listeButton.push({
            row: (row)=>{
                return row;
            },
            type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).DELETE,
            pathname: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/zone-integration/delete/`
        });
    }
    const { handleShowClose: handleShowClose, activesKeys: activesKeys } = (0, $db860d90b4a42fea$export$dae930a4ba30758b)([
        false
    ]);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                    icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$527d32aa1785fdd4), {}),
                    title: "Zones de comp\xe9tence"
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db860d90b4a42fea$export$2e2bcd8739ae039), {
                    activesKeys: activesKeys,
                    handleShowClose: handleShowClose,
                    list: [
                        {
                            header: "Importer des zones de comp\xe9tence",
                            content: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("p", {
                                        children: "Permet d'importer un fichier SHAPE contenant des zones de comp\xe9tence ; l'identification se fait sur le code, avec un m\xe9canisme d'insertion / mise \xe0 jour."
                                    }),
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                                        initialValues: $a62d163b52d0700d$export$a5cab80145b70e98(),
                                        validationSchema: $a62d163b52d0700d$export$c084437b5e3206cd,
                                        isPost: false,
                                        isMultipartFormData: true,
                                        submitUrl: `/api/zone-integration/import/`,
                                        prepareVariables: (values)=>$a62d163b52d0700d$export$f97400759cfd946(values),
                                        redirectUrl: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_ZONE_INTEGRATION,
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($a62d163b52d0700d$var$FormImportShape, {})
                                    })
                                ]
                            })
                        }
                    ]
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $9a9eebc3462fba73$export$2e2bcd8739ae039), {
                    query: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/zone-integration`,
                    columns: [
                        {
                            Header: "Code",
                            accessor: "zoneIntegrationCode",
                            sortField: "zoneIntegrationCode",
                            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                                type: "text",
                                name: "zoneIntegrationCode"
                            })
                        },
                        {
                            Header: "Libell\xe9",
                            accessor: "zoneIntegrationLibelle",
                            sortField: "zoneIntegrationLibelle",
                            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                                type: "text",
                                name: "zoneIntegrationLibelle"
                            })
                        },
                        (0, $b82b937cc97f6f18$export$38dcf858d3ede0e9)({
                            Header: "Actif",
                            accessor: "zoneIntegrationActif",
                            sortField: "zoneIntegrationActif",
                            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eed37ff3d3e1f28c$export$2e2bcd8739ae039), {
                                options: (0, $a4f278cac9030fb1$export$2e2bcd8739ae039),
                                name: "zoneIntegrationActif"
                            })
                        }),
                        (0, $b82b937cc97f6f18$export$36e9f5a475c9f6fc)({
                            Header: "Actions",
                            accessor: "zoneIntegrationId",
                            buttons: listeButton
                        })
                    ],
                    idName: "tableZoneIntegration",
                    filterValuesToVariable: (0, $5178faa7955d3a9c$export$2e2bcd8739ae039),
                    filterContext: (0, $9a9eebc3462fba73$export$396ef541d9951d45)({
                        zoneIntegrationCode: undefined,
                        zoneIntegrationLibelle: undefined,
                        zoneIntegrationActif: undefined,
                        zoneIntegrationGestionnaireId: undefined
                    })
                })
            ]
        })
    });
};
const $a62d163b52d0700d$var$FormImportShape = ()=>{
    const { setFieldValue: setFieldValue } = (0, $bkJfK.useFormikContext)();
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b57af79a4ab2a1c6), {
                name: "fileGeometries",
                accept: ".zip",
                label: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                    children: [
                        "Fichier zip contenant les zones de comp\xe9tence",
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                            placement: "right",
                            tooltipText: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("strong", {
                                                children: [
                                                    "the_geom ",
                                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("span", {
                                                        className: "text-danger",
                                                        children: "*"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                                className: "ms-2",
                                                children: "La g\xe9om\xe9trie en Polygon"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("strong", {
                                                children: [
                                                    "code ",
                                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("span", {
                                                        className: "text-danger",
                                                        children: "*"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                                className: "ms-2",
                                                children: "Code (unique) de la zone de comp\xe9tence"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("strong", {
                                                children: [
                                                    "libelle ",
                                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("span", {
                                                        className: "text-danger",
                                                        children: "*"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                                className: "ms-2",
                                                children: "Libell\xe9 de la zone de comp\xe9tence"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("span", {
                                                    className: "text-danger",
                                                    children: "*"
                                                }),
                                                " : Champs obligatoires"
                                            ]
                                        })
                                    })
                                ]
                            }),
                            tooltipHeader: "Colonnes attendues",
                            tooltipId: "zoneIntegration",
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$340bfce9b4df026b), {})
                        })
                    ]
                }),
                required: false,
                onChange: (e)=>setFieldValue("fileGeometries", e.target.files[0])
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                className: "mt-3",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                    className: "text-center",
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                        type: "submit",
                        variant: "primary",
                        children: "Valider"
                    })
                })
            })
        ]
    });
};
var $a62d163b52d0700d$export$2e2bcd8739ae039 = $a62d163b52d0700d$var$ListZoneIntegration;















const $56707f0a5d1ad508$export$a5cab80145b70e98 = (data)=>({
        zoneIntegrationCode: data?.zoneIntegrationCode ?? null,
        zoneIntegrationLibelle: data?.zoneIntegrationLibelle ?? null,
        zoneIntegrationActif: data?.zoneIntegrationActif ?? false
    });
const $56707f0a5d1ad508$export$c084437b5e3206cd = (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({});
const $56707f0a5d1ad508$export$f97400759cfd946 = (values)=>({
        zoneIntegrationCode: values.zoneIntegrationCode,
        zoneIntegrationLibelle: values.zoneIntegrationLibelle,
        zoneIntegrationActif: values.zoneIntegrationActif
    });
const $56707f0a5d1ad508$var$ZoneIntegration = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("h3", {
                className: "mt-1",
                children: "Informations g\xe9n\xe9rales"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                label: "Code",
                name: "zoneIntegrationCode",
                required: true
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                label: "Libell\xe9",
                name: "zoneIntegrationLibelle",
                required: true
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                name: "zoneIntegrationActif",
                label: "Actif"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db9b0e6fdb142a4c$export$2e2bcd8739ae039), {
                returnLink: true
            })
        ]
    });
};
var $56707f0a5d1ad508$export$2e2bcd8739ae039 = $56707f0a5d1ad508$var$ZoneIntegration;


const $fa21e0a438fbb3d9$var$UpdateZoneIntegration = ()=>{
    const { zoneIntegrationId: zoneIntegrationId } = (0, $7a844823b04d4282$export$99eaa27ddbbb95ef)();
    const zoneIntegrationState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/zone-integration/` + zoneIntegrationId);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$3caee6c66795d211), {}),
                title: "Mise \xe0 jour d'une zone de comp\xe9tence"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                initialValues: (0, $56707f0a5d1ad508$export$a5cab80145b70e98)(zoneIntegrationState?.data),
                validationSchema: (0, $56707f0a5d1ad508$export$c084437b5e3206cd),
                isPost: false,
                submitUrl: `/api/zone-integration/update/` + zoneIntegrationId,
                prepareVariables: (values)=>(0, $56707f0a5d1ad508$export$f97400759cfd946)(values),
                redirectUrl: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_ZONE_INTEGRATION,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $56707f0a5d1ad508$export$2e2bcd8739ae039), {})
            })
        ]
    });
};
var $fa21e0a438fbb3d9$export$2e2bcd8739ae039 = $fa21e0a438fbb3d9$var$UpdateZoneIntegration;




var $kc00y = parcelRequire("kc00y");



















const $7556a51e679767c8$export$a5cab80145b70e98 = ()=>({
        dynamicFormId: null
    });
const $7556a51e679767c8$export$c084437b5e3206cd = (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({});
const $7556a51e679767c8$export$f97400759cfd946 = (values, listeParametres)=>{
    const listeParametre = listeParametres.map((param)=>{
        const code = param.dynamicFormParametreCode;
        const value = values[code] !== undefined ? values[code] : param.dynamicFormParametreValeurDefaut ?? null;
        return {
            nom: code,
            valeur: value,
            estRequis: param.dynamicFormParametreIsRequired
        };
    });
    return {
        modeleCourrierId: values.dynamicFormId,
        courrierReference: values.courrierReference,
        listParametres: listeParametre
    };
};


const $2cda7a18e75d7b57$export$6f2fda70fe261d2e = ({ emailDestinataire: emailDestinataire, listeTypeDestinataire: listeTypeDestinataire, nomDestinataire: nomDestinataire, fonctionDestinataire: fonctionDestinataire, useZoneCompetence: useZoneCompetence })=>{
    const filter = {};
    $2cda7a18e75d7b57$var$filterProperty(filter, emailDestinataire, "emailDestinataire");
    $2cda7a18e75d7b57$var$filterProperty(filter, nomDestinataire, "nomDestinataire");
    $2cda7a18e75d7b57$var$filterProperty(filter, fonctionDestinataire, "fonctionDestinataire");
    if (useZoneCompetence != null) filter.useZoneCompetence = useZoneCompetence;
    if (Array.isArray(listeTypeDestinataire) && listeTypeDestinataire.length > 0) filter.listeTypeDestinataire = listeTypeDestinataire;
    return filter;
};
function $2cda7a18e75d7b57$var$filterProperty(filter, value, name) {
    if (value != null && value.trim() !== "") filter[name] = value;
}
var $2cda7a18e75d7b57$export$2e2bcd8739ae039 = $2cda7a18e75d7b57$export$6f2fda70fe261d2e;


const $f023788f0719ca00$var$GenereCourrier = ()=>{
    const { typeModule: typeModule } = (0, $7a844823b04d4282$export$99eaa27ddbbb95ef)();
    const [listeParametres, setListeParametres] = (0, $kc00y.useState)([]);
    const [urlCourrier, setUrlCourrier] = (0, $kc00y.useState)(null);
    const [formKey, setFormKey] = (0, $kc00y.useState)(0);
    const navigate = (0, $7a844823b04d4282$export$9770f232ac06a008)();
    const { activesKeys: activesKeys, handleShowClose: handleShowClose } = (0, $db860d90b4a42fea$export$dae930a4ba30758b)([
        true,
        false
    ]);
    // On récupère tous les courriers avec leurs paramètres
    const modeleCourrierState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/courriers/modeles-courriers/list?${{
        typeModule: typeModule
    }}`);
    if (!modeleCourrierState.isResolved) return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $c21b1c237cfa1d94$export$2e2bcd8739ae039), {});
    const { data: data } = modeleCourrierState;
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        fluid: true,
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$84ac927778fdc063), {}),
                title: "G\xe9n\xe9rer un courrier"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db860d90b4a42fea$export$2e2bcd8739ae039), {
                activesKeys: activesKeys,
                list: [
                    {
                        header: "G\xe9n\xe9rer le courrier",
                        content: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                    xs: 12,
                                    lg: 4,
                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                                        initialValues: (0, $7556a51e679767c8$export$a5cab80145b70e98)(),
                                        validationSchema: (0, $7556a51e679767c8$export$c084437b5e3206cd),
                                        isPost: true,
                                        submitUrl: `/api/courriers`,
                                        prepareVariables: (values)=>(0, $7556a51e679767c8$export$f97400759cfd946)(values, listeParametres),
                                        onSubmit: (url)=>{
                                            setUrlCourrier(url);
                                            navigate((0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).VIEW_COURRIER(typeModule));
                                        },
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $3dfd663e22480fb2$export$2e2bcd8739ae039), {
                                            listeIdLibelleDescription: data,
                                            contexteLibelle: "Mod\xe8le de courrier",
                                            reference: true,
                                            onParametresChange: setListeParametres,
                                            url: "/api/courriers/parametres/"
                                        })
                                    }, formKey)
                                }),
                                urlCourrier && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                    xs: 12,
                                    lg: 8,
                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $7a844823b04d4282$export$910ae8079b2c2852), {
                                        context: {
                                            urlCourrier: urlCourrier
                                        }
                                    })
                                })
                            ]
                        })
                    },
                    {
                        header: "Notifier le courrier",
                        content: urlCourrier ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($f023788f0719ca00$var$ListDestinataire, {
                            urlCourrier: urlCourrier.url,
                            modeleCourrierId: urlCourrier.modeleCourrierId,
                            courrierReference: urlCourrier.courrierReference,
                            thematique: (0, $c066b242635c27a6$export$791e4878d721fae8)(typeModule),
                            onNotificationSuccess: ()=>{
                                setUrlCourrier(null);
                                setFormKey((prev)=>prev + 1);
                            }
                        }) : /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                            children: "Veuillez g\xe9n\xe9rer le courrier avant de notifier."
                        })
                    }
                ],
                handleShowClose: handleShowClose
            })
        ]
    });
};
function $f023788f0719ca00$export$8e0be626868f6969() {
    return (0, $7a844823b04d4282$export$4138103a3ae699cc)();
}
var $f023788f0719ca00$export$2e2bcd8739ae039 = $f023788f0719ca00$var$GenereCourrier;
const $f023788f0719ca00$var$ListDestinataire = ({ urlCourrier: urlCourrier, modeleCourrierId: modeleCourrierId, courrierReference: courrierReference, thematique: thematique, onNotificationSuccess: onNotificationSuccess })=>{
    const parametresState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/parametres?${{
        listeParametreCode: JSON.stringify([
            (0, $ee297f06e8568bf4$export$2e2bcd8739ae039).COURRIER_RESTRICTION_ZC
        ])
    }}`);
    const restrictionActive = (0, $kc00y.useMemo)(()=>{
        if (!parametresState.isResolved) return undefined;
        return parametresState?.data[(0, $ee297f06e8568bf4$export$2e2bcd8739ae039).COURRIER_RESTRICTION_ZC].parametreValeur === "true";
    }, [
        parametresState
    ]);
    const [listeDestinataire, setListeDestinataire] = (0, $kc00y.useState)([]);
    const { success: successToast, error: errorToast } = (0, $6bdae0bad7b05751$export$91b3d218c74c79e4)();
    async function notifier() {
        (await fetch((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/courriers/create/`, (0, $fbd4d34e07af0ac7$export$b163ec2f884327db)({
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                modeleCourrierId: modeleCourrierId,
                nomDocument: urlCourrier.split("courrierPath=")[1],
                listeDestinataire: listeDestinataire,
                courrierReference: courrierReference,
                codeThematique: thematique
            })
        }))).text().then(()=>{
            successToast("Destinataires notifi\xe9s");
            setListeDestinataire([]);
            onNotificationSuccess();
        }).catch((reason)=>{
            errorToast(reason);
        });
    }
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                xs: 12,
                lg: 6,
                children: restrictionActive === undefined ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $c21b1c237cfa1d94$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($f023788f0719ca00$var$ListDestinataireFilters, {
                    restrictionActive: restrictionActive,
                    listeDestinataire: listeDestinataire,
                    setListeDestinataire: setListeDestinataire
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                xs: 12,
                lg: 6,
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("h3", {
                                    children: "Destinataires s\xe9lectionn\xe9s"
                                })
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                lg: 2,
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                                    className: "mb-2",
                                    onClick: notifier,
                                    children: "Notifier"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                        className: "bg-light p-2 border rounded",
                        children: listeDestinataire.length === 0 ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                            children: "Aucun destinataire s\xe9lectionn\xe9"
                        }) : listeDestinataire.map((e, index)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                className: "mt-2",
                                children: [
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("b", {
                                                children: "Nom"
                                            }),
                                            " : ",
                                            e?.nomDestinataire
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("b", {
                                                children: "Email"
                                            }),
                                            " : ",
                                            e?.emailDestinataire
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                        lg: 2,
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $c094b74d2be2aa67$export$2e2bcd8739ae039), {
                                            title: "Supprimer",
                                            onClick: ()=>setListeDestinataire((liste)=>liste.filter((item)=>item.destinataireId !== e.destinataireId))
                                        })
                                    })
                                ]
                            }, index))
                    })
                ]
            })
        ]
    });
};
const $f023788f0719ca00$var$ListDestinataireFilters = ({ restrictionActive: restrictionActive, listeDestinataire: listeDestinataire, setListeDestinataire: setListeDestinataire })=>{
    const filterContext = (0, $9a9eebc3462fba73$export$396ef541d9951d45)({
        useZoneCompetence: restrictionActive
    });
    const useZoneCompetence = Boolean(filterContext.values?.useZoneCompetence);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            restrictionActive && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Check, {
                type: "checkbox",
                id: "restreindre-zone-competence",
                className: "mb-2 fs-6",
                label: "Restreindre \xe0 ma zone de comp\xe9tence",
                checked: useZoneCompetence,
                onChange: (event)=>filterContext.setFieldValue("useZoneCompetence", event.target.checked)
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $9a9eebc3462fba73$export$2e2bcd8739ae039), {
                query: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/courriers/destinataires`,
                filterContext: filterContext,
                columns: [
                    {
                        Header: "Type",
                        accessor: "typeDestinataire",
                        sortField: "typeDestinataire",
                        Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $cc7cbb0460865818$export$2e2bcd8739ae039), {
                            name: "listeTypeDestinataire",
                            listIdCodeLibelle: [
                                {
                                    id: "UTILISATEUR",
                                    code: "UTILISATEUR",
                                    libelle: "Utilisateur"
                                },
                                {
                                    id: "ORGANISME",
                                    code: "ORGANISME",
                                    libelle: "Organisme"
                                },
                                {
                                    id: "CONTACT_ORGANISME",
                                    code: "CONTACT_ORGANISME",
                                    libelle: "Contact d'organisme"
                                },
                                {
                                    id: "CONTACT_GESTIONNAIRE",
                                    code: "CONTACT_GESTIONNAIRE",
                                    libelle: "Contact de gestionnaire"
                                }
                            ]
                        })
                    },
                    {
                        Header: "Nom",
                        accessor: "nomDestinataire",
                        sortField: "nomDestinataire",
                        Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                            type: "text",
                            name: "nomDestinataire"
                        })
                    },
                    {
                        Header: "Email",
                        accessor: "emailDestinataire",
                        sortField: "emailDestinataire",
                        Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                            type: "text",
                            name: "emailDestinataire"
                        })
                    },
                    {
                        Header: "Fonction",
                        accessor: "fonctionDestinataire",
                        sortField: "fonctionDestinataire",
                        Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                            type: "text",
                            name: "fonctionDestinataire"
                        })
                    },
                    {
                        accessor: ({ destinataireId: destinataireId, nomDestinataire: nomDestinataire, emailDestinataire: emailDestinataire, typeDestinataire: typeDestinataire })=>{
                            return {
                                destinataireId: destinataireId,
                                nomDestinataire: nomDestinataire,
                                emailDestinataire: emailDestinataire,
                                typeDestinataire: typeDestinataire
                            };
                        },
                        Cell: (value)=>{
                            return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                                variant: "link",
                                className: "btn-link text-decoration-none fw-bold text-nowrap",
                                disabled: listeDestinataire.map((e)=>e.destinataireId).includes(value.value.destinataireId),
                                onClick: ()=>{
                                    setListeDestinataire((liste)=>[
                                            ...liste,
                                            {
                                                destinataireId: value.value.destinataireId,
                                                nomDestinataire: value.value.nomDestinataire,
                                                emailDestinataire: value.value.emailDestinataire,
                                                typeDestinataire: value.value.typeDestinataire
                                            }
                                        ]);
                                },
                                children: [
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$4176b1d4e95be624), {}),
                                    " Ajouter"
                                ]
                            });
                        }
                    }
                ],
                filterValuesToVariable: (0, $2cda7a18e75d7b57$export$2e2bcd8739ae039),
                idName: "tableDestinataireId"
            })
        ]
    });
};



var $kc00y = parcelRequire("kc00y");


const $2d86bb80bf213615$var$TelechargerCourrier = ()=>{
    const { documentId: documentId } = (0, $7a844823b04d4282$export$99eaa27ddbbb95ef)();
    // On lance le téléchargement du courrier et on ferme la page après un délai
    // Page nécessaire pour pouvoir fermer après le téléchargement
    (0, $kc00y.useEffect)(()=>{
        if (!documentId) return;
        // Télécharger le fichier
        window.location.assign((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/documents/telecharger/${documentId}`);
        // Fermer la page après un délai
        setTimeout(()=>{
            window.close();
        }, 1000);
    }, [
        documentId
    ]);
    return null;
};
var $2d86bb80bf213615$export$2e2bcd8739ae039 = $2d86bb80bf213615$var$TelechargerCourrier;






var $kc00y = parcelRequire("kc00y");



var $kc00y = parcelRequire("kc00y");


function $69f09258c42ac403$export$2e2bcd8739ae039(promise) {
    let isCancelled = false;
    const wrappedPromise = new Promise((resolve, reject)=>{
        promise.then((value)=>!isCancelled && resolve(value)).catch((error)=>!isCancelled && reject(error));
    });
    return {
        promise: wrappedPromise,
        cancel () {
            isCancelled = true;
        }
    };
}


// As defined on the list of supported events: https://reactjs.org/docs/events.html
const $4c01b1fb52e31b15$export$84fe03429ed1b6d6 = [
    'onCopy',
    'onCut',
    'onPaste'
];
const $4c01b1fb52e31b15$export$dbc46161504615f7 = [
    'onCompositionEnd',
    'onCompositionStart',
    'onCompositionUpdate'
];
const $4c01b1fb52e31b15$export$fb6351c2666f0875 = [
    'onFocus',
    'onBlur'
];
const $4c01b1fb52e31b15$export$4e58c1a9761ed81a = [
    'onInput',
    'onInvalid',
    'onReset',
    'onSubmit'
];
const $4c01b1fb52e31b15$export$3bf7402f2a4eb3af = [
    'onLoad',
    'onError'
];
const $4c01b1fb52e31b15$export$409c4891d97f97cf = [
    'onKeyDown',
    'onKeyPress',
    'onKeyUp'
];
const $4c01b1fb52e31b15$export$6be5aa2386088264 = [
    'onAbort',
    'onCanPlay',
    'onCanPlayThrough',
    'onDurationChange',
    'onEmptied',
    'onEncrypted',
    'onEnded',
    'onError',
    'onLoadedData',
    'onLoadedMetadata',
    'onLoadStart',
    'onPause',
    'onPlay',
    'onPlaying',
    'onProgress',
    'onRateChange',
    'onSeeked',
    'onSeeking',
    'onStalled',
    'onSuspend',
    'onTimeUpdate',
    'onVolumeChange',
    'onWaiting'
];
const $4c01b1fb52e31b15$export$3a6e2b8954613992 = [
    'onClick',
    'onContextMenu',
    'onDoubleClick',
    'onMouseDown',
    'onMouseEnter',
    'onMouseLeave',
    'onMouseMove',
    'onMouseOut',
    'onMouseOver',
    'onMouseUp'
];
const $4c01b1fb52e31b15$export$6c96379d5b8a2df7 = [
    'onDrag',
    'onDragEnd',
    'onDragEnter',
    'onDragExit',
    'onDragLeave',
    'onDragOver',
    'onDragStart',
    'onDrop'
];
const $4c01b1fb52e31b15$export$d93346aa7735a637 = [
    'onSelect'
];
const $4c01b1fb52e31b15$export$fa367689c659e65c = [
    'onTouchCancel',
    'onTouchEnd',
    'onTouchMove',
    'onTouchStart'
];
const $4c01b1fb52e31b15$export$c731eab7619e00a0 = [
    'onPointerDown',
    'onPointerMove',
    'onPointerUp',
    'onPointerCancel',
    'onGotPointerCapture',
    'onLostPointerCapture',
    'onPointerEnter',
    'onPointerLeave',
    'onPointerOver',
    'onPointerOut'
];
const $4c01b1fb52e31b15$export$bac3087b5cb826f6 = [
    'onScroll'
];
const $4c01b1fb52e31b15$export$28298837799e00e8 = [
    'onWheel'
];
const $4c01b1fb52e31b15$export$6ff45424014e7407 = [
    'onAnimationStart',
    'onAnimationEnd',
    'onAnimationIteration'
];
const $4c01b1fb52e31b15$export$78878fc7bd50dc3e = [
    'onTransitionEnd'
];
const $4c01b1fb52e31b15$export$477a88c5b93a108d = [
    'onToggle'
];
const $4c01b1fb52e31b15$export$7212b61f9f58bd1 = [
    'onChange'
];
const $4c01b1fb52e31b15$export$59ef7197c4d7b9dc = [
    ...$4c01b1fb52e31b15$export$84fe03429ed1b6d6,
    ...$4c01b1fb52e31b15$export$dbc46161504615f7,
    ...$4c01b1fb52e31b15$export$fb6351c2666f0875,
    ...$4c01b1fb52e31b15$export$4e58c1a9761ed81a,
    ...$4c01b1fb52e31b15$export$3bf7402f2a4eb3af,
    ...$4c01b1fb52e31b15$export$409c4891d97f97cf,
    ...$4c01b1fb52e31b15$export$6be5aa2386088264,
    ...$4c01b1fb52e31b15$export$3a6e2b8954613992,
    ...$4c01b1fb52e31b15$export$6c96379d5b8a2df7,
    ...$4c01b1fb52e31b15$export$d93346aa7735a637,
    ...$4c01b1fb52e31b15$export$fa367689c659e65c,
    ...$4c01b1fb52e31b15$export$c731eab7619e00a0,
    ...$4c01b1fb52e31b15$export$bac3087b5cb826f6,
    ...$4c01b1fb52e31b15$export$28298837799e00e8,
    ...$4c01b1fb52e31b15$export$6ff45424014e7407,
    ...$4c01b1fb52e31b15$export$78878fc7bd50dc3e,
    ...$4c01b1fb52e31b15$export$7212b61f9f58bd1,
    ...$4c01b1fb52e31b15$export$477a88c5b93a108d
];
function $4c01b1fb52e31b15$export$2e2bcd8739ae039(props, getArgs) {
    const eventProps = {};
    for (const eventName of $4c01b1fb52e31b15$export$59ef7197c4d7b9dc){
        const eventHandler = props[eventName];
        if (!eventHandler) continue;
        if (getArgs) eventProps[eventName] = (event)=>eventHandler(event, getArgs(eventName));
        else eventProps[eventName] = eventHandler;
    }
    return eventProps;
}


var $9ef033443a74bee6$exports = {};

$parcel$export($9ef033443a74bee6$exports, "AnnotationMode", () => $9ef033443a74bee6$export$5a7af0c07e33392e);
$parcel$export($9ef033443a74bee6$exports, "AnnotationEditorType", () => $9ef033443a74bee6$export$72ea3bfdd9a725bf);
$parcel$export($9ef033443a74bee6$exports, "AnnotationEditorParamsType", () => $9ef033443a74bee6$export$cf3df2a6ecc26692);
$parcel$export($9ef033443a74bee6$exports, "PermissionFlag", () => $9ef033443a74bee6$export$bb99a5b8411e07d8);
$parcel$export($9ef033443a74bee6$exports, "ImageKind", () => $9ef033443a74bee6$export$b890e9c15247e0b3);
$parcel$export($9ef033443a74bee6$exports, "AnnotationType", () => $9ef033443a74bee6$export$f50c3066a53a6f2c);
$parcel$export($9ef033443a74bee6$exports, "VerbosityLevel", () => $9ef033443a74bee6$export$b18df09d23c244c4);
$parcel$export($9ef033443a74bee6$exports, "OPS", () => $9ef033443a74bee6$export$3a0f7f7a8a0b306b);
$parcel$export($9ef033443a74bee6$exports, "PasswordResponses", () => $9ef033443a74bee6$export$5e72215208e4d9ad);
$parcel$export($9ef033443a74bee6$exports, "createValidAbsoluteUrl", () => $9ef033443a74bee6$export$e076b47f5805ca0b);
$parcel$export($9ef033443a74bee6$exports, "updateUrlHash", () => $9ef033443a74bee6$export$e1e4297c21ab9d13);
$parcel$export($9ef033443a74bee6$exports, "shadow", () => $9ef033443a74bee6$export$b8972b998723d602);
$parcel$export($9ef033443a74bee6$exports, "InvalidPDFException", () => $9ef033443a74bee6$export$e3d0f4ce5b91e9f1);
$parcel$export($9ef033443a74bee6$exports, "ResponseException", () => $9ef033443a74bee6$export$ea8e9c34f66e603);
$parcel$export($9ef033443a74bee6$exports, "AbortException", () => $9ef033443a74bee6$export$d0e978393d193d1a);
$parcel$export($9ef033443a74bee6$exports, "FeatureTest", () => $9ef033443a74bee6$export$5fb8891d35c36978);
$parcel$export($9ef033443a74bee6$exports, "Util", () => $9ef033443a74bee6$export$f8f26dd395d7e1bd);
$parcel$export($9ef033443a74bee6$exports, "normalizeUnicode", () => $9ef033443a74bee6$export$1fa1e6b1a06bd7fa);
$parcel$export($9ef033443a74bee6$exports, "getUuid", () => $9ef033443a74bee6$export$75f13a91ebdf8eb3);
$parcel$export($9ef033443a74bee6$exports, "MathClamp", () => $9ef033443a74bee6$export$b8106b171181a554);
$parcel$export($9ef033443a74bee6$exports, "XfaLayer", () => $9ef033443a74bee6$export$f6af20c312d4b9a2);
$parcel$export($9ef033443a74bee6$exports, "PixelsPerInch", () => $9ef033443a74bee6$export$6ef3b6b69e65342c);
$parcel$export($9ef033443a74bee6$exports, "fetchData", () => $9ef033443a74bee6$export$8134c072fddab6a5);
$parcel$export($9ef033443a74bee6$exports, "RenderingCancelledException", () => $9ef033443a74bee6$export$245847d31c09154f);
$parcel$export($9ef033443a74bee6$exports, "isDataScheme", () => $9ef033443a74bee6$export$f67aae4532d8295b);
$parcel$export($9ef033443a74bee6$exports, "isPdfFile", () => $9ef033443a74bee6$export$61b52d3570d24719);
$parcel$export($9ef033443a74bee6$exports, "getFilenameFromUrl", () => $9ef033443a74bee6$export$b1c11df0696253ae);
$parcel$export($9ef033443a74bee6$exports, "getPdfFilenameFromUrl", () => $9ef033443a74bee6$export$9de51790aa4bc73a);
$parcel$export($9ef033443a74bee6$exports, "noContextMenu", () => $9ef033443a74bee6$export$455b7811f904cadc);
$parcel$export($9ef033443a74bee6$exports, "stopEvent", () => $9ef033443a74bee6$export$7ae4cd3a66c1e050);
$parcel$export($9ef033443a74bee6$exports, "PDFDateString", () => $9ef033443a74bee6$export$66cbc314498fffc);
$parcel$export($9ef033443a74bee6$exports, "getXfaPageViewport", () => $9ef033443a74bee6$export$dd5d6edf3fc80aae);
$parcel$export($9ef033443a74bee6$exports, "getRGB", () => $9ef033443a74bee6$export$2a2e9b507863ddda);
$parcel$export($9ef033443a74bee6$exports, "setLayerDimensions", () => $9ef033443a74bee6$export$af0a15a86e590226);
$parcel$export($9ef033443a74bee6$exports, "OutputScale", () => $9ef033443a74bee6$export$f16a99f63bccd50b);
$parcel$export($9ef033443a74bee6$exports, "SupportedImageMimeTypes", () => $9ef033443a74bee6$export$3234c88e9de64a88);
$parcel$export($9ef033443a74bee6$exports, "CSSConstants", () => $9ef033443a74bee6$export$cec677744f6a5015);
$parcel$export($9ef033443a74bee6$exports, "applyOpacity", () => $9ef033443a74bee6$export$f8d1472813e87bf9);
$parcel$export($9ef033443a74bee6$exports, "findContrastColor", () => $9ef033443a74bee6$export$7a96203b1fdebe8d);
$parcel$export($9ef033443a74bee6$exports, "renderRichText", () => $9ef033443a74bee6$export$611c480766035c4);
$parcel$export($9ef033443a74bee6$exports, "AnnotationEditorUIManager", () => $9ef033443a74bee6$export$26cb16552a82cf63);
$parcel$export($9ef033443a74bee6$exports, "TouchManager", () => $9ef033443a74bee6$export$9ae7542b430d543e);
$parcel$export($9ef033443a74bee6$exports, "isValidExplicitDest", () => $9ef033443a74bee6$export$b5acece0a447dcdc);
$parcel$export($9ef033443a74bee6$exports, "GlobalWorkerOptions", () => $9ef033443a74bee6$export$edf38ba293eb934);
$parcel$export($9ef033443a74bee6$exports, "TextLayer", () => $9ef033443a74bee6$export$fdbdc423a78c5262);
$parcel$export($9ef033443a74bee6$exports, "getDocument", () => $9ef033443a74bee6$export$f65ca476c09acec0);
$parcel$export($9ef033443a74bee6$exports, "PDFDataRangeTransport", () => $9ef033443a74bee6$export$c06899d9d7bce9ab);
$parcel$export($9ef033443a74bee6$exports, "PDFWorker", () => $9ef033443a74bee6$export$84e2e9f37426b265);
$parcel$export($9ef033443a74bee6$exports, "version", () => $9ef033443a74bee6$export$83d89fbfd8236492);
$parcel$export($9ef033443a74bee6$exports, "build", () => $9ef033443a74bee6$export$3f8fe6489e95757d);
$parcel$export($9ef033443a74bee6$exports, "ColorPicker", () => $9ef033443a74bee6$export$9feb1bc2e5f1ccb3);
$parcel$export($9ef033443a74bee6$exports, "DOMSVGFactory", () => $9ef033443a74bee6$export$425e69f00724e63a);
$parcel$export($9ef033443a74bee6$exports, "AnnotationLayer", () => $9ef033443a74bee6$export$3e7f45c326d9366c);
$parcel$export($9ef033443a74bee6$exports, "SignatureExtractor", () => $9ef033443a74bee6$export$cc4fe8633f466b4a);
$parcel$export($9ef033443a74bee6$exports, "AnnotationEditorLayer", () => $9ef033443a74bee6$export$47948c9fe1adbf1b);
$parcel$export($9ef033443a74bee6$exports, "DrawLayer", () => $9ef033443a74bee6$export$3eb4521511f02450);
/**
 * @licstart The following is the entire license notice for the
 * JavaScript code in this page
 *
 * Copyright 2024 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @licend The above is the entire license notice for the
 * JavaScript code in this page
 */ /**
 * pdfjsVersion = 5.4.296
 * pdfjsBuild = f56dc8601
 */ /******/ // The require scope
/******/ 
var $4qF7V = parcelRequire("4qF7V");
var $9ef033443a74bee6$require$Buffer = $4qF7V.Buffer;
var $a553cffd36fe3594$exports = {};
// shim for using process in browser
var $a553cffd36fe3594$var$process = $a553cffd36fe3594$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $a553cffd36fe3594$var$cachedSetTimeout;
var $a553cffd36fe3594$var$cachedClearTimeout;
function $a553cffd36fe3594$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $a553cffd36fe3594$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $a553cffd36fe3594$var$cachedSetTimeout = setTimeout;
        else $a553cffd36fe3594$var$cachedSetTimeout = $a553cffd36fe3594$var$defaultSetTimout;
    } catch (e) {
        $a553cffd36fe3594$var$cachedSetTimeout = $a553cffd36fe3594$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $a553cffd36fe3594$var$cachedClearTimeout = clearTimeout;
        else $a553cffd36fe3594$var$cachedClearTimeout = $a553cffd36fe3594$var$defaultClearTimeout;
    } catch (e) {
        $a553cffd36fe3594$var$cachedClearTimeout = $a553cffd36fe3594$var$defaultClearTimeout;
    }
})();
function $a553cffd36fe3594$var$runTimeout(fun) {
    if ($a553cffd36fe3594$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($a553cffd36fe3594$var$cachedSetTimeout === $a553cffd36fe3594$var$defaultSetTimout || !$a553cffd36fe3594$var$cachedSetTimeout) && setTimeout) {
        $a553cffd36fe3594$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $a553cffd36fe3594$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $a553cffd36fe3594$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $a553cffd36fe3594$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $a553cffd36fe3594$var$runClearTimeout(marker) {
    if ($a553cffd36fe3594$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($a553cffd36fe3594$var$cachedClearTimeout === $a553cffd36fe3594$var$defaultClearTimeout || !$a553cffd36fe3594$var$cachedClearTimeout) && clearTimeout) {
        $a553cffd36fe3594$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $a553cffd36fe3594$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $a553cffd36fe3594$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $a553cffd36fe3594$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $a553cffd36fe3594$var$queue = [];
var $a553cffd36fe3594$var$draining = false;
var $a553cffd36fe3594$var$currentQueue;
var $a553cffd36fe3594$var$queueIndex = -1;
function $a553cffd36fe3594$var$cleanUpNextTick() {
    if (!$a553cffd36fe3594$var$draining || !$a553cffd36fe3594$var$currentQueue) return;
    $a553cffd36fe3594$var$draining = false;
    if ($a553cffd36fe3594$var$currentQueue.length) $a553cffd36fe3594$var$queue = $a553cffd36fe3594$var$currentQueue.concat($a553cffd36fe3594$var$queue);
    else $a553cffd36fe3594$var$queueIndex = -1;
    if ($a553cffd36fe3594$var$queue.length) $a553cffd36fe3594$var$drainQueue();
}
function $a553cffd36fe3594$var$drainQueue() {
    if ($a553cffd36fe3594$var$draining) return;
    var timeout = $a553cffd36fe3594$var$runTimeout($a553cffd36fe3594$var$cleanUpNextTick);
    $a553cffd36fe3594$var$draining = true;
    var len = $a553cffd36fe3594$var$queue.length;
    while(len){
        $a553cffd36fe3594$var$currentQueue = $a553cffd36fe3594$var$queue;
        $a553cffd36fe3594$var$queue = [];
        while(++$a553cffd36fe3594$var$queueIndex < len)if ($a553cffd36fe3594$var$currentQueue) $a553cffd36fe3594$var$currentQueue[$a553cffd36fe3594$var$queueIndex].run();
        $a553cffd36fe3594$var$queueIndex = -1;
        len = $a553cffd36fe3594$var$queue.length;
    }
    $a553cffd36fe3594$var$currentQueue = null;
    $a553cffd36fe3594$var$draining = false;
    $a553cffd36fe3594$var$runClearTimeout(timeout);
}
$a553cffd36fe3594$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $a553cffd36fe3594$var$queue.push(new $a553cffd36fe3594$var$Item(fun, args));
    if ($a553cffd36fe3594$var$queue.length === 1 && !$a553cffd36fe3594$var$draining) $a553cffd36fe3594$var$runTimeout($a553cffd36fe3594$var$drainQueue);
};
// v8 likes predictible objects
function $a553cffd36fe3594$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$a553cffd36fe3594$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$a553cffd36fe3594$var$process.title = 'browser';
$a553cffd36fe3594$var$process.browser = true;
$a553cffd36fe3594$var$process.env = {};
$a553cffd36fe3594$var$process.argv = [];
$a553cffd36fe3594$var$process.version = ''; // empty string to avoid regexp issues
$a553cffd36fe3594$var$process.versions = {};
function $a553cffd36fe3594$var$noop() {}
$a553cffd36fe3594$var$process.on = $a553cffd36fe3594$var$noop;
$a553cffd36fe3594$var$process.addListener = $a553cffd36fe3594$var$noop;
$a553cffd36fe3594$var$process.once = $a553cffd36fe3594$var$noop;
$a553cffd36fe3594$var$process.off = $a553cffd36fe3594$var$noop;
$a553cffd36fe3594$var$process.removeListener = $a553cffd36fe3594$var$noop;
$a553cffd36fe3594$var$process.removeAllListeners = $a553cffd36fe3594$var$noop;
$a553cffd36fe3594$var$process.emit = $a553cffd36fe3594$var$noop;
$a553cffd36fe3594$var$process.prependListener = $a553cffd36fe3594$var$noop;
$a553cffd36fe3594$var$process.prependOnceListener = $a553cffd36fe3594$var$noop;
$a553cffd36fe3594$var$process.listeners = function(name) {
    return [];
};
$a553cffd36fe3594$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$a553cffd36fe3594$var$process.cwd = function() {
    return '/';
};
$a553cffd36fe3594$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$a553cffd36fe3594$var$process.umask = function() {
    return 0;
};


var $9ef033443a74bee6$var$__webpack_require__ = {};
/******/ /************************************************************************/ /******/ /* webpack/runtime/define property getters */ /******/ (()=>{
    /******/ // define getter functions for harmony exports
    /******/ $9ef033443a74bee6$var$__webpack_require__.d = (exports, definition)=>{
        /******/ for(var key in definition)/******/ if ($9ef033443a74bee6$var$__webpack_require__.o(definition, key) && !$9ef033443a74bee6$var$__webpack_require__.o(exports, key)) /******/ Object.defineProperty(exports, key, {
            enumerable: true,
            get: definition[key]
        });
    /******/ };
/******/ })();
/******/ /******/ /* webpack/runtime/hasOwnProperty shorthand */ /******/ (()=>{
    /******/ $9ef033443a74bee6$var$__webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
/******/ })();
/******/ /************************************************************************/ var $9ef033443a74bee6$var$__webpack_exports__ = {};
const $9ef033443a74bee6$var$isNodeJS = false;
const $9ef033443a74bee6$var$FONT_IDENTITY_MATRIX = [
    0.001,
    0,
    0,
    0.001,
    0,
    0
];
const $9ef033443a74bee6$var$LINE_FACTOR = 1.35;
const $9ef033443a74bee6$var$LINE_DESCENT_FACTOR = 0.35;
const $9ef033443a74bee6$var$BASELINE_FACTOR = $9ef033443a74bee6$var$LINE_DESCENT_FACTOR / $9ef033443a74bee6$var$LINE_FACTOR;
const $9ef033443a74bee6$var$RenderingIntentFlag = {
    ANY: 0x01,
    DISPLAY: 0x02,
    PRINT: 0x04,
    SAVE: 0x08,
    ANNOTATIONS_FORMS: 0x10,
    ANNOTATIONS_STORAGE: 0x20,
    ANNOTATIONS_DISABLE: 0x40,
    IS_EDITING: 0x80,
    OPLIST: 0x100
};
const $9ef033443a74bee6$export$5a7af0c07e33392e = {
    DISABLE: 0,
    ENABLE: 1,
    ENABLE_FORMS: 2,
    ENABLE_STORAGE: 3
};
const $9ef033443a74bee6$var$AnnotationEditorPrefix = "pdfjs_internal_editor_";
const $9ef033443a74bee6$export$72ea3bfdd9a725bf = {
    DISABLE: -1,
    NONE: 0,
    FREETEXT: 3,
    HIGHLIGHT: 9,
    STAMP: 13,
    INK: 15,
    POPUP: 16,
    SIGNATURE: 101,
    COMMENT: 102
};
const $9ef033443a74bee6$export$cf3df2a6ecc26692 = {
    RESIZE: 1,
    CREATE: 2,
    FREETEXT_SIZE: 11,
    FREETEXT_COLOR: 12,
    FREETEXT_OPACITY: 13,
    INK_COLOR: 21,
    INK_THICKNESS: 22,
    INK_OPACITY: 23,
    HIGHLIGHT_COLOR: 31,
    HIGHLIGHT_THICKNESS: 32,
    HIGHLIGHT_FREE: 33,
    HIGHLIGHT_SHOW_ALL: 34,
    DRAW_STEP: 41
};
const $9ef033443a74bee6$export$bb99a5b8411e07d8 = {
    PRINT: 0x04,
    MODIFY_CONTENTS: 0x08,
    COPY: 0x10,
    MODIFY_ANNOTATIONS: 0x20,
    FILL_INTERACTIVE_FORMS: 0x100,
    COPY_FOR_ACCESSIBILITY: 0x200,
    ASSEMBLE: 0x400,
    PRINT_HIGH_QUALITY: 0x800
};
const $9ef033443a74bee6$var$TextRenderingMode = {
    FILL: 0,
    STROKE: 1,
    FILL_STROKE: 2,
    INVISIBLE: 3,
    FILL_ADD_TO_PATH: 4,
    STROKE_ADD_TO_PATH: 5,
    FILL_STROKE_ADD_TO_PATH: 6,
    ADD_TO_PATH: 7,
    FILL_STROKE_MASK: 3,
    ADD_TO_PATH_FLAG: 4
};
const $9ef033443a74bee6$export$b890e9c15247e0b3 = {
    GRAYSCALE_1BPP: 1,
    RGB_24BPP: 2,
    RGBA_32BPP: 3
};
const $9ef033443a74bee6$export$f50c3066a53a6f2c = {
    TEXT: 1,
    LINK: 2,
    FREETEXT: 3,
    LINE: 4,
    SQUARE: 5,
    CIRCLE: 6,
    POLYGON: 7,
    POLYLINE: 8,
    HIGHLIGHT: 9,
    UNDERLINE: 10,
    SQUIGGLY: 11,
    STRIKEOUT: 12,
    STAMP: 13,
    CARET: 14,
    INK: 15,
    POPUP: 16,
    FILEATTACHMENT: 17,
    SOUND: 18,
    MOVIE: 19,
    WIDGET: 20,
    SCREEN: 21,
    PRINTERMARK: 22,
    TRAPNET: 23,
    WATERMARK: 24,
    THREED: 25,
    REDACT: 26
};
const $9ef033443a74bee6$var$AnnotationReplyType = {
    GROUP: "Group",
    REPLY: "R"
};
const $9ef033443a74bee6$var$AnnotationFlag = {
    INVISIBLE: 0x01,
    HIDDEN: 0x02,
    PRINT: 0x04,
    NOZOOM: 0x08,
    NOROTATE: 0x10,
    NOVIEW: 0x20,
    READONLY: 0x40,
    LOCKED: 0x80,
    TOGGLENOVIEW: 0x100,
    LOCKEDCONTENTS: 0x200
};
const $9ef033443a74bee6$var$AnnotationFieldFlag = {
    READONLY: 0x0000001,
    REQUIRED: 0x0000002,
    NOEXPORT: 0x0000004,
    MULTILINE: 0x0001000,
    PASSWORD: 0x0002000,
    NOTOGGLETOOFF: 0x0004000,
    RADIO: 0x0008000,
    PUSHBUTTON: 0x0010000,
    COMBO: 0x0020000,
    EDIT: 0x0040000,
    SORT: 0x0080000,
    FILESELECT: 0x0100000,
    MULTISELECT: 0x0200000,
    DONOTSPELLCHECK: 0x0400000,
    DONOTSCROLL: 0x0800000,
    COMB: 0x1000000,
    RICHTEXT: 0x2000000,
    RADIOSINUNISON: 0x2000000,
    COMMITONSELCHANGE: 0x4000000
};
const $9ef033443a74bee6$var$AnnotationBorderStyleType = {
    SOLID: 1,
    DASHED: 2,
    BEVELED: 3,
    INSET: 4,
    UNDERLINE: 5
};
const $9ef033443a74bee6$var$AnnotationActionEventType = {
    E: "Mouse Enter",
    X: "Mouse Exit",
    D: "Mouse Down",
    U: "Mouse Up",
    Fo: "Focus",
    Bl: "Blur",
    PO: "PageOpen",
    PC: "PageClose",
    PV: "PageVisible",
    PI: "PageInvisible",
    K: "Keystroke",
    F: "Format",
    V: "Validate",
    C: "Calculate"
};
const $9ef033443a74bee6$var$DocumentActionEventType = {
    WC: "WillClose",
    WS: "WillSave",
    DS: "DidSave",
    WP: "WillPrint",
    DP: "DidPrint"
};
const $9ef033443a74bee6$var$PageActionEventType = {
    O: "PageOpen",
    C: "PageClose"
};
const $9ef033443a74bee6$export$b18df09d23c244c4 = {
    ERRORS: 0,
    WARNINGS: 1,
    INFOS: 5
};
const $9ef033443a74bee6$export$3a0f7f7a8a0b306b = {
    dependency: 1,
    setLineWidth: 2,
    setLineCap: 3,
    setLineJoin: 4,
    setMiterLimit: 5,
    setDash: 6,
    setRenderingIntent: 7,
    setFlatness: 8,
    setGState: 9,
    save: 10,
    restore: 11,
    transform: 12,
    moveTo: 13,
    lineTo: 14,
    curveTo: 15,
    curveTo2: 16,
    curveTo3: 17,
    closePath: 18,
    rectangle: 19,
    stroke: 20,
    closeStroke: 21,
    fill: 22,
    eoFill: 23,
    fillStroke: 24,
    eoFillStroke: 25,
    closeFillStroke: 26,
    closeEOFillStroke: 27,
    endPath: 28,
    clip: 29,
    eoClip: 30,
    beginText: 31,
    endText: 32,
    setCharSpacing: 33,
    setWordSpacing: 34,
    setHScale: 35,
    setLeading: 36,
    setFont: 37,
    setTextRenderingMode: 38,
    setTextRise: 39,
    moveText: 40,
    setLeadingMoveText: 41,
    setTextMatrix: 42,
    nextLine: 43,
    showText: 44,
    showSpacedText: 45,
    nextLineShowText: 46,
    nextLineSetSpacingShowText: 47,
    setCharWidth: 48,
    setCharWidthAndBounds: 49,
    setStrokeColorSpace: 50,
    setFillColorSpace: 51,
    setStrokeColor: 52,
    setStrokeColorN: 53,
    setFillColor: 54,
    setFillColorN: 55,
    setStrokeGray: 56,
    setFillGray: 57,
    setStrokeRGBColor: 58,
    setFillRGBColor: 59,
    setStrokeCMYKColor: 60,
    setFillCMYKColor: 61,
    shadingFill: 62,
    beginInlineImage: 63,
    beginImageData: 64,
    endInlineImage: 65,
    paintXObject: 66,
    markPoint: 67,
    markPointProps: 68,
    beginMarkedContent: 69,
    beginMarkedContentProps: 70,
    endMarkedContent: 71,
    beginCompat: 72,
    endCompat: 73,
    paintFormXObjectBegin: 74,
    paintFormXObjectEnd: 75,
    beginGroup: 76,
    endGroup: 77,
    beginAnnotation: 80,
    endAnnotation: 81,
    paintImageMaskXObject: 83,
    paintImageMaskXObjectGroup: 84,
    paintImageXObject: 85,
    paintInlineImageXObject: 86,
    paintInlineImageXObjectGroup: 87,
    paintImageXObjectRepeat: 88,
    paintImageMaskXObjectRepeat: 89,
    paintSolidColorImageMask: 90,
    constructPath: 91,
    setStrokeTransparent: 92,
    setFillTransparent: 93,
    rawFillPath: 94
};
const $9ef033443a74bee6$var$DrawOPS = {
    moveTo: 0,
    lineTo: 1,
    curveTo: 2,
    closePath: 3
};
const $9ef033443a74bee6$export$5e72215208e4d9ad = {
    NEED_PASSWORD: 1,
    INCORRECT_PASSWORD: 2
};
let $9ef033443a74bee6$var$verbosity = $9ef033443a74bee6$export$b18df09d23c244c4.WARNINGS;
function $9ef033443a74bee6$var$setVerbosityLevel(level) {
    if (Number.isInteger(level)) $9ef033443a74bee6$var$verbosity = level;
}
function $9ef033443a74bee6$var$getVerbosityLevel() {
    return $9ef033443a74bee6$var$verbosity;
}
function $9ef033443a74bee6$var$info(msg) {
    if ($9ef033443a74bee6$var$verbosity >= $9ef033443a74bee6$export$b18df09d23c244c4.INFOS) console.info(`Info: ${msg}`);
}
function $9ef033443a74bee6$var$warn(msg) {
    if ($9ef033443a74bee6$var$verbosity >= $9ef033443a74bee6$export$b18df09d23c244c4.WARNINGS) console.warn(`Warning: ${msg}`);
}
function $9ef033443a74bee6$var$unreachable(msg) {
    throw new Error(msg);
}
function $9ef033443a74bee6$var$assert(cond, msg) {
    if (!cond) $9ef033443a74bee6$var$unreachable(msg);
}
function $9ef033443a74bee6$var$_isValidProtocol(url) {
    switch(url?.protocol){
        case "http:":
        case "https:":
        case "ftp:":
        case "mailto:":
        case "tel:":
            return true;
        default:
            return false;
    }
}
function $9ef033443a74bee6$export$e076b47f5805ca0b(url, baseUrl = null, options = null) {
    if (!url) return null;
    if (options && typeof url === "string") {
        if (options.addDefaultProtocol && url.startsWith("www.")) {
            const dots = url.match(/\./g);
            if (dots?.length >= 2) url = `http://${url}`;
        }
        if (options.tryConvertEncoding) try {
            url = $9ef033443a74bee6$var$stringToUTF8String(url);
        } catch  {}
    }
    const absoluteUrl = baseUrl ? URL.parse(url, baseUrl) : URL.parse(url);
    return $9ef033443a74bee6$var$_isValidProtocol(absoluteUrl) ? absoluteUrl : null;
}
function $9ef033443a74bee6$export$e1e4297c21ab9d13(url, hash, allowRel = false) {
    const res = URL.parse(url);
    if (res) {
        res.hash = hash;
        return res.href;
    }
    if (allowRel && $9ef033443a74bee6$export$e076b47f5805ca0b(url, "http://example.com")) return url.split("#", 1)[0] + `${hash ? `#${hash}` : ""}`;
    return "";
}
function $9ef033443a74bee6$export$b8972b998723d602(obj, prop, value, nonSerializable = false) {
    Object.defineProperty(obj, prop, {
        value: value,
        enumerable: !nonSerializable,
        configurable: true,
        writable: false
    });
    return value;
}
const $9ef033443a74bee6$var$BaseException = function BaseExceptionClosure() {
    function BaseException(message, name) {
        this.message = message;
        this.name = name;
    }
    BaseException.prototype = new Error();
    BaseException.constructor = BaseException;
    return BaseException;
}();
class $9ef033443a74bee6$var$PasswordException extends $9ef033443a74bee6$var$BaseException {
    constructor(msg, code){
        super(msg, "PasswordException");
        this.code = code;
    }
}
class $9ef033443a74bee6$var$UnknownErrorException extends $9ef033443a74bee6$var$BaseException {
    constructor(msg, details){
        super(msg, "UnknownErrorException");
        this.details = details;
    }
}
class $9ef033443a74bee6$export$e3d0f4ce5b91e9f1 extends $9ef033443a74bee6$var$BaseException {
    constructor(msg){
        super(msg, "InvalidPDFException");
    }
}
class $9ef033443a74bee6$export$ea8e9c34f66e603 extends $9ef033443a74bee6$var$BaseException {
    constructor(msg, status, missing){
        super(msg, "ResponseException");
        this.status = status;
        this.missing = missing;
    }
}
class $9ef033443a74bee6$var$FormatError extends $9ef033443a74bee6$var$BaseException {
    constructor(msg){
        super(msg, "FormatError");
    }
}
class $9ef033443a74bee6$export$d0e978393d193d1a extends $9ef033443a74bee6$var$BaseException {
    constructor(msg){
        super(msg, "AbortException");
    }
}
function $9ef033443a74bee6$var$bytesToString(bytes) {
    if (typeof bytes !== "object" || bytes?.length === undefined) $9ef033443a74bee6$var$unreachable("Invalid argument for bytesToString");
    const length = bytes.length;
    const MAX_ARGUMENT_COUNT = 8192;
    if (length < MAX_ARGUMENT_COUNT) return String.fromCharCode.apply(null, bytes);
    const strBuf = [];
    for(let i = 0; i < length; i += MAX_ARGUMENT_COUNT){
        const chunkEnd = Math.min(i + MAX_ARGUMENT_COUNT, length);
        const chunk = bytes.subarray(i, chunkEnd);
        strBuf.push(String.fromCharCode.apply(null, chunk));
    }
    return strBuf.join("");
}
function $9ef033443a74bee6$var$stringToBytes(str) {
    if (typeof str !== "string") $9ef033443a74bee6$var$unreachable("Invalid argument for stringToBytes");
    const length = str.length;
    const bytes = new Uint8Array(length);
    for(let i = 0; i < length; ++i)bytes[i] = str.charCodeAt(i) & 0xff;
    return bytes;
}
function $9ef033443a74bee6$var$string32(value) {
    return String.fromCharCode(value >> 24 & 0xff, value >> 16 & 0xff, value >> 8 & 0xff, value & 0xff);
}
function $9ef033443a74bee6$var$objectSize(obj) {
    return Object.keys(obj).length;
}
function $9ef033443a74bee6$var$isLittleEndian() {
    const buffer8 = new Uint8Array(4);
    buffer8[0] = 1;
    const view32 = new Uint32Array(buffer8.buffer, 0, 1);
    return view32[0] === 1;
}
function $9ef033443a74bee6$var$isEvalSupported() {
    try {
        new Function("");
        return true;
    } catch  {
        return false;
    }
}
class $9ef033443a74bee6$export$5fb8891d35c36978 {
    static get isLittleEndian() {
        return $9ef033443a74bee6$export$b8972b998723d602(this, "isLittleEndian", $9ef033443a74bee6$var$isLittleEndian());
    }
    static get isEvalSupported() {
        return $9ef033443a74bee6$export$b8972b998723d602(this, "isEvalSupported", $9ef033443a74bee6$var$isEvalSupported());
    }
    static get isOffscreenCanvasSupported() {
        return $9ef033443a74bee6$export$b8972b998723d602(this, "isOffscreenCanvasSupported", typeof OffscreenCanvas !== "undefined");
    }
    static get isImageDecoderSupported() {
        return $9ef033443a74bee6$export$b8972b998723d602(this, "isImageDecoderSupported", typeof ImageDecoder !== "undefined");
    }
    static get platform() {
        const { platform: platform, userAgent: userAgent } = navigator;
        return $9ef033443a74bee6$export$b8972b998723d602(this, "platform", {
            isAndroid: userAgent.includes("Android"),
            isLinux: platform.includes("Linux"),
            isMac: platform.includes("Mac"),
            isWindows: platform.includes("Win"),
            isFirefox: userAgent.includes("Firefox")
        });
    }
    static get isCSSRoundSupported() {
        return $9ef033443a74bee6$export$b8972b998723d602(this, "isCSSRoundSupported", globalThis.CSS?.supports?.("width: round(1.5px, 1px)"));
    }
}
const $9ef033443a74bee6$var$hexNumbers = Array.from(Array(256).keys(), (n)=>n.toString(16).padStart(2, "0"));
class $9ef033443a74bee6$export$f8f26dd395d7e1bd {
    static makeHexColor(r, g, b) {
        return `#${$9ef033443a74bee6$var$hexNumbers[r]}${$9ef033443a74bee6$var$hexNumbers[g]}${$9ef033443a74bee6$var$hexNumbers[b]}`;
    }
    static domMatrixToTransform(dm) {
        return [
            dm.a,
            dm.b,
            dm.c,
            dm.d,
            dm.e,
            dm.f
        ];
    }
    static scaleMinMax(transform, minMax) {
        let temp;
        if (transform[0]) {
            if (transform[0] < 0) {
                temp = minMax[0];
                minMax[0] = minMax[2];
                minMax[2] = temp;
            }
            minMax[0] *= transform[0];
            minMax[2] *= transform[0];
            if (transform[3] < 0) {
                temp = minMax[1];
                minMax[1] = minMax[3];
                minMax[3] = temp;
            }
            minMax[1] *= transform[3];
            minMax[3] *= transform[3];
        } else {
            temp = minMax[0];
            minMax[0] = minMax[1];
            minMax[1] = temp;
            temp = minMax[2];
            minMax[2] = minMax[3];
            minMax[3] = temp;
            if (transform[1] < 0) {
                temp = minMax[1];
                minMax[1] = minMax[3];
                minMax[3] = temp;
            }
            minMax[1] *= transform[1];
            minMax[3] *= transform[1];
            if (transform[2] < 0) {
                temp = minMax[0];
                minMax[0] = minMax[2];
                minMax[2] = temp;
            }
            minMax[0] *= transform[2];
            minMax[2] *= transform[2];
        }
        minMax[0] += transform[4];
        minMax[1] += transform[5];
        minMax[2] += transform[4];
        minMax[3] += transform[5];
    }
    static transform(m1, m2) {
        return [
            m1[0] * m2[0] + m1[2] * m2[1],
            m1[1] * m2[0] + m1[3] * m2[1],
            m1[0] * m2[2] + m1[2] * m2[3],
            m1[1] * m2[2] + m1[3] * m2[3],
            m1[0] * m2[4] + m1[2] * m2[5] + m1[4],
            m1[1] * m2[4] + m1[3] * m2[5] + m1[5]
        ];
    }
    static multiplyByDOMMatrix(m, md) {
        return [
            m[0] * md.a + m[2] * md.b,
            m[1] * md.a + m[3] * md.b,
            m[0] * md.c + m[2] * md.d,
            m[1] * md.c + m[3] * md.d,
            m[0] * md.e + m[2] * md.f + m[4],
            m[1] * md.e + m[3] * md.f + m[5]
        ];
    }
    static applyTransform(p, m, pos = 0) {
        const p0 = p[pos];
        const p1 = p[pos + 1];
        p[pos] = p0 * m[0] + p1 * m[2] + m[4];
        p[pos + 1] = p0 * m[1] + p1 * m[3] + m[5];
    }
    static applyTransformToBezier(p, transform, pos = 0) {
        const m0 = transform[0];
        const m1 = transform[1];
        const m2 = transform[2];
        const m3 = transform[3];
        const m4 = transform[4];
        const m5 = transform[5];
        for(let i = 0; i < 6; i += 2){
            const pI = p[pos + i];
            const pI1 = p[pos + i + 1];
            p[pos + i] = pI * m0 + pI1 * m2 + m4;
            p[pos + i + 1] = pI * m1 + pI1 * m3 + m5;
        }
    }
    static applyInverseTransform(p, m) {
        const p0 = p[0];
        const p1 = p[1];
        const d = m[0] * m[3] - m[1] * m[2];
        p[0] = (p0 * m[3] - p1 * m[2] + m[2] * m[5] - m[4] * m[3]) / d;
        p[1] = (-p0 * m[1] + p1 * m[0] + m[4] * m[1] - m[5] * m[0]) / d;
    }
    static axialAlignedBoundingBox(rect, transform, output) {
        const m0 = transform[0];
        const m1 = transform[1];
        const m2 = transform[2];
        const m3 = transform[3];
        const m4 = transform[4];
        const m5 = transform[5];
        const r0 = rect[0];
        const r1 = rect[1];
        const r2 = rect[2];
        const r3 = rect[3];
        let a0 = m0 * r0 + m4;
        let a2 = a0;
        let a1 = m0 * r2 + m4;
        let a3 = a1;
        let b0 = m3 * r1 + m5;
        let b2 = b0;
        let b1 = m3 * r3 + m5;
        let b3 = b1;
        if (m1 !== 0 || m2 !== 0) {
            const m1r0 = m1 * r0;
            const m1r2 = m1 * r2;
            const m2r1 = m2 * r1;
            const m2r3 = m2 * r3;
            a0 += m2r1;
            a3 += m2r1;
            a1 += m2r3;
            a2 += m2r3;
            b0 += m1r0;
            b3 += m1r0;
            b1 += m1r2;
            b2 += m1r2;
        }
        output[0] = Math.min(output[0], a0, a1, a2, a3);
        output[1] = Math.min(output[1], b0, b1, b2, b3);
        output[2] = Math.max(output[2], a0, a1, a2, a3);
        output[3] = Math.max(output[3], b0, b1, b2, b3);
    }
    static inverseTransform(m) {
        const d = m[0] * m[3] - m[1] * m[2];
        return [
            m[3] / d,
            -m[1] / d,
            -m[2] / d,
            m[0] / d,
            (m[2] * m[5] - m[4] * m[3]) / d,
            (m[4] * m[1] - m[5] * m[0]) / d
        ];
    }
    static singularValueDecompose2dScale(matrix, output) {
        const m0 = matrix[0];
        const m1 = matrix[1];
        const m2 = matrix[2];
        const m3 = matrix[3];
        const a = m0 ** 2 + m1 ** 2;
        const b = m0 * m2 + m1 * m3;
        const c = m2 ** 2 + m3 ** 2;
        const first = (a + c) / 2;
        const second = Math.sqrt(first ** 2 - (a * c - b ** 2));
        output[0] = Math.sqrt(first + second || 1);
        output[1] = Math.sqrt(first - second || 1);
    }
    static normalizeRect(rect) {
        const r = rect.slice(0);
        if (rect[0] > rect[2]) {
            r[0] = rect[2];
            r[2] = rect[0];
        }
        if (rect[1] > rect[3]) {
            r[1] = rect[3];
            r[3] = rect[1];
        }
        return r;
    }
    static intersect(rect1, rect2) {
        const xLow = Math.max(Math.min(rect1[0], rect1[2]), Math.min(rect2[0], rect2[2]));
        const xHigh = Math.min(Math.max(rect1[0], rect1[2]), Math.max(rect2[0], rect2[2]));
        if (xLow > xHigh) return null;
        const yLow = Math.max(Math.min(rect1[1], rect1[3]), Math.min(rect2[1], rect2[3]));
        const yHigh = Math.min(Math.max(rect1[1], rect1[3]), Math.max(rect2[1], rect2[3]));
        if (yLow > yHigh) return null;
        return [
            xLow,
            yLow,
            xHigh,
            yHigh
        ];
    }
    static pointBoundingBox(x, y, minMax) {
        minMax[0] = Math.min(minMax[0], x);
        minMax[1] = Math.min(minMax[1], y);
        minMax[2] = Math.max(minMax[2], x);
        minMax[3] = Math.max(minMax[3], y);
    }
    static rectBoundingBox(x0, y0, x1, y1, minMax) {
        minMax[0] = Math.min(minMax[0], x0, x1);
        minMax[1] = Math.min(minMax[1], y0, y1);
        minMax[2] = Math.max(minMax[2], x0, x1);
        minMax[3] = Math.max(minMax[3], y0, y1);
    }
    static #getExtremumOnCurve(x0, x1, x2, x3, y0, y1, y2, y3, t, minMax) {
        if (t <= 0 || t >= 1) return;
        const mt = 1 - t;
        const tt = t * t;
        const ttt = tt * t;
        const x = mt * (mt * (mt * x0 + 3 * t * x1) + 3 * tt * x2) + ttt * x3;
        const y = mt * (mt * (mt * y0 + 3 * t * y1) + 3 * tt * y2) + ttt * y3;
        minMax[0] = Math.min(minMax[0], x);
        minMax[1] = Math.min(minMax[1], y);
        minMax[2] = Math.max(minMax[2], x);
        minMax[3] = Math.max(minMax[3], y);
    }
    static #getExtremum(x0, x1, x2, x3, y0, y1, y2, y3, a, b, c, minMax) {
        if (Math.abs(a) < 1e-12) {
            if (Math.abs(b) >= 1e-12) this.#getExtremumOnCurve(x0, x1, x2, x3, y0, y1, y2, y3, -c / b, minMax);
            return;
        }
        const delta = b ** 2 - 4 * c * a;
        if (delta < 0) return;
        const sqrtDelta = Math.sqrt(delta);
        const a2 = 2 * a;
        this.#getExtremumOnCurve(x0, x1, x2, x3, y0, y1, y2, y3, (-b + sqrtDelta) / a2, minMax);
        this.#getExtremumOnCurve(x0, x1, x2, x3, y0, y1, y2, y3, (-b - sqrtDelta) / a2, minMax);
    }
    static bezierBoundingBox(x0, y0, x1, y1, x2, y2, x3, y3, minMax) {
        minMax[0] = Math.min(minMax[0], x0, x3);
        minMax[1] = Math.min(minMax[1], y0, y3);
        minMax[2] = Math.max(minMax[2], x0, x3);
        minMax[3] = Math.max(minMax[3], y0, y3);
        this.#getExtremum(x0, x1, x2, x3, y0, y1, y2, y3, 3 * (-x0 + 3 * (x1 - x2) + x3), 6 * (x0 - 2 * x1 + x2), 3 * (x1 - x0), minMax);
        this.#getExtremum(x0, x1, x2, x3, y0, y1, y2, y3, 3 * (-y0 + 3 * (y1 - y2) + y3), 6 * (y0 - 2 * y1 + y2), 3 * (y1 - y0), minMax);
    }
}
const $9ef033443a74bee6$var$PDFStringTranslateTable = /* unused pure expression or super */ null;
function $9ef033443a74bee6$var$stringToPDFString(str, keepEscapeSequence = false) {
    if (str[0] >= "\xEF") {
        let encoding;
        if (str[0] === "\xFE" && str[1] === "\xFF") {
            encoding = "utf-16be";
            if (str.length % 2 === 1) str = str.slice(0, -1);
        } else if (str[0] === "\xFF" && str[1] === "\xFE") {
            encoding = "utf-16le";
            if (str.length % 2 === 1) str = str.slice(0, -1);
        } else if (str[0] === "\xEF" && str[1] === "\xBB" && str[2] === "\xBF") encoding = "utf-8";
        if (encoding) try {
            const decoder = new TextDecoder(encoding, {
                fatal: true
            });
            const buffer = $9ef033443a74bee6$var$stringToBytes(str);
            const decoded = decoder.decode(buffer);
            if (keepEscapeSequence || !decoded.includes("\x1b")) return decoded;
            return decoded.replaceAll(/\x1b[^\x1b]*(?:\x1b|$)/g, "");
        } catch (ex) {
            $9ef033443a74bee6$var$warn(`stringToPDFString: "${ex}".`);
        }
    }
    const strBuf = [];
    for(let i = 0, ii = str.length; i < ii; i++){
        const charCode = str.charCodeAt(i);
        if (!keepEscapeSequence && charCode === 0x1b) {
            while(++i < ii && str.charCodeAt(i) !== 0x1b);
            continue;
        }
        const code = $9ef033443a74bee6$var$PDFStringTranslateTable[charCode];
        strBuf.push(code ? String.fromCharCode(code) : str.charAt(i));
    }
    return strBuf.join("");
}
function $9ef033443a74bee6$var$stringToUTF8String(str) {
    return decodeURIComponent(escape(str));
}
function $9ef033443a74bee6$var$utf8StringToString(str) {
    return unescape(encodeURIComponent(str));
}
function $9ef033443a74bee6$var$isArrayEqual(arr1, arr2) {
    if (arr1.length !== arr2.length) return false;
    for(let i = 0, ii = arr1.length; i < ii; i++){
        if (arr1[i] !== arr2[i]) return false;
    }
    return true;
}
function $9ef033443a74bee6$var$getModificationDate(date = new Date()) {
    if (!(date instanceof Date)) date = new Date(date);
    const buffer = [
        date.getUTCFullYear().toString(),
        (date.getUTCMonth() + 1).toString().padStart(2, "0"),
        date.getUTCDate().toString().padStart(2, "0"),
        date.getUTCHours().toString().padStart(2, "0"),
        date.getUTCMinutes().toString().padStart(2, "0"),
        date.getUTCSeconds().toString().padStart(2, "0")
    ];
    return buffer.join("");
}
let $9ef033443a74bee6$var$NormalizeRegex = null;
let $9ef033443a74bee6$var$NormalizationMap = null;
function $9ef033443a74bee6$export$1fa1e6b1a06bd7fa(str) {
    if (!$9ef033443a74bee6$var$NormalizeRegex) {
        $9ef033443a74bee6$var$NormalizeRegex = /([\u00a0\u00b5\u037e\u0eb3\u2000-\u200a\u202f\u2126\ufb00-\ufb04\ufb06\ufb20-\ufb36\ufb38-\ufb3c\ufb3e\ufb40-\ufb41\ufb43-\ufb44\ufb46-\ufba1\ufba4-\ufba9\ufbae-\ufbb1\ufbd3-\ufbdc\ufbde-\ufbe7\ufbea-\ufbf8\ufbfc-\ufbfd\ufc00-\ufc5d\ufc64-\ufcf1\ufcf5-\ufd3d\ufd88\ufdf4\ufdfa-\ufdfb\ufe71\ufe77\ufe79\ufe7b\ufe7d]+)|(\ufb05+)/gu;
        $9ef033443a74bee6$var$NormalizationMap = new Map([
            [
                "\uFB05",
                "\u017Ft"
            ]
        ]);
    }
    return str.replaceAll($9ef033443a74bee6$var$NormalizeRegex, (_, p1, p2)=>p1 ? p1.normalize("NFKC") : $9ef033443a74bee6$var$NormalizationMap.get(p2));
}
function $9ef033443a74bee6$export$75f13a91ebdf8eb3() {
    if (typeof crypto.randomUUID === "function") return crypto.randomUUID();
    const buf = new Uint8Array(32);
    crypto.getRandomValues(buf);
    return $9ef033443a74bee6$var$bytesToString(buf);
}
const $9ef033443a74bee6$var$AnnotationPrefix = "pdfjs_internal_id_";
function $9ef033443a74bee6$var$_isValidExplicitDest(validRef, validName, dest) {
    if (!Array.isArray(dest) || dest.length < 2) return false;
    const [page, zoom, ...args] = dest;
    if (!validRef(page) && !Number.isInteger(page)) return false;
    if (!validName(zoom)) return false;
    const argsLen = args.length;
    let allowNull = true;
    switch(zoom.name){
        case "XYZ":
            if (argsLen < 2 || argsLen > 3) return false;
            break;
        case "Fit":
        case "FitB":
            return argsLen === 0;
        case "FitH":
        case "FitBH":
        case "FitV":
        case "FitBV":
            if (argsLen > 1) return false;
            break;
        case "FitR":
            if (argsLen !== 4) return false;
            allowNull = false;
            break;
        default:
            return false;
    }
    for (const arg of args){
        if (typeof arg === "number" || allowNull && arg === null) continue;
        return false;
    }
    return true;
}
function $9ef033443a74bee6$export$b8106b171181a554(v, min, max) {
    return Math.min(Math.max(v, min), max);
}
function $9ef033443a74bee6$var$toHexUtil(arr) {
    if (Uint8Array.prototype.toHex) return arr.toHex();
    return Array.from(arr, (num)=>$9ef033443a74bee6$var$hexNumbers[num]).join("");
}
function $9ef033443a74bee6$var$toBase64Util(arr) {
    if (Uint8Array.prototype.toBase64) return arr.toBase64();
    return btoa($9ef033443a74bee6$var$bytesToString(arr));
}
function $9ef033443a74bee6$var$fromBase64Util(str) {
    if (Uint8Array.fromBase64) return Uint8Array.fromBase64(str);
    return $9ef033443a74bee6$var$stringToBytes(atob(str));
}
if (typeof Promise.try !== "function") Promise.try = function(fn, ...args) {
    return new Promise((resolve)=>{
        resolve(fn(...args));
    });
};
if (typeof Math.sumPrecise !== "function") Math.sumPrecise = function(numbers) {
    return numbers.reduce((a, b)=>a + b, 0);
};
class $9ef033443a74bee6$var$XfaText {
    static textContent(xfa) {
        const items = [];
        const output = {
            items: items,
            styles: Object.create(null)
        };
        function walk(node) {
            if (!node) return;
            let str = null;
            const name = node.name;
            if (name === "#text") str = node.value;
            else if (!$9ef033443a74bee6$var$XfaText.shouldBuildText(name)) return;
            else if (node?.attributes?.textContent) str = node.attributes.textContent;
            else if (node.value) str = node.value;
            if (str !== null) items.push({
                str: str
            });
            if (!node.children) return;
            for (const child of node.children)walk(child);
        }
        walk(xfa);
        return output;
    }
    static shouldBuildText(name) {
        return !(name === "textarea" || name === "input" || name === "option" || name === "select");
    }
}
class $9ef033443a74bee6$export$f6af20c312d4b9a2 {
    static setupStorage(html, id, element, storage, intent) {
        const storedData = storage.getValue(id, {
            value: null
        });
        switch(element.name){
            case "textarea":
                if (storedData.value !== null) html.textContent = storedData.value;
                if (intent === "print") break;
                html.addEventListener("input", (event)=>{
                    storage.setValue(id, {
                        value: event.target.value
                    });
                });
                break;
            case "input":
                if (element.attributes.type === "radio" || element.attributes.type === "checkbox") {
                    if (storedData.value === element.attributes.xfaOn) html.setAttribute("checked", true);
                    else if (storedData.value === element.attributes.xfaOff) html.removeAttribute("checked");
                    if (intent === "print") break;
                    html.addEventListener("change", (event)=>{
                        storage.setValue(id, {
                            value: event.target.checked ? event.target.getAttribute("xfaOn") : event.target.getAttribute("xfaOff")
                        });
                    });
                } else {
                    if (storedData.value !== null) html.setAttribute("value", storedData.value);
                    if (intent === "print") break;
                    html.addEventListener("input", (event)=>{
                        storage.setValue(id, {
                            value: event.target.value
                        });
                    });
                }
                break;
            case "select":
                if (storedData.value !== null) {
                    html.setAttribute("value", storedData.value);
                    for (const option of element.children){
                        if (option.attributes.value === storedData.value) option.attributes.selected = true;
                        else if (option.attributes.hasOwnProperty("selected")) delete option.attributes.selected;
                    }
                }
                html.addEventListener("input", (event)=>{
                    const options = event.target.options;
                    const value = options.selectedIndex === -1 ? "" : options[options.selectedIndex].value;
                    storage.setValue(id, {
                        value: value
                    });
                });
                break;
        }
    }
    static setAttributes({ html: html, element: element, storage: storage = null, intent: intent, linkService: linkService }) {
        const { attributes: attributes } = element;
        const isHTMLAnchorElement = html instanceof HTMLAnchorElement;
        if (attributes.type === "radio") attributes.name = `${attributes.name}-${intent}`;
        for (const [key, value] of Object.entries(attributes)){
            if (value === null || value === undefined) continue;
            switch(key){
                case "class":
                    if (value.length) html.setAttribute(key, value.join(" "));
                    break;
                case "dataId":
                    break;
                case "id":
                    html.setAttribute("data-element-id", value);
                    break;
                case "style":
                    Object.assign(html.style, value);
                    break;
                case "textContent":
                    html.textContent = value;
                    break;
                default:
                    if (!isHTMLAnchorElement || key !== "href" && key !== "newWindow") html.setAttribute(key, value);
            }
        }
        if (isHTMLAnchorElement) linkService.addLinkAttributes(html, attributes.href, attributes.newWindow);
        if (storage && attributes.dataId) this.setupStorage(html, attributes.dataId, element, storage);
    }
    static render(parameters) {
        const storage = parameters.annotationStorage;
        const linkService = parameters.linkService;
        const root = parameters.xfaHtml;
        const intent = parameters.intent || "display";
        const rootHtml = document.createElement(root.name);
        if (root.attributes) this.setAttributes({
            html: rootHtml,
            element: root,
            intent: intent,
            linkService: linkService
        });
        const isNotForRichText = intent !== "richText";
        const rootDiv = parameters.div;
        rootDiv.append(rootHtml);
        if (parameters.viewport) {
            const transform = `matrix(${parameters.viewport.transform.join(",")})`;
            rootDiv.style.transform = transform;
        }
        if (isNotForRichText) rootDiv.setAttribute("class", "xfaLayer xfaFont");
        const textDivs = [];
        if (root.children.length === 0) {
            if (root.value) {
                const node = document.createTextNode(root.value);
                rootHtml.append(node);
                if (isNotForRichText && $9ef033443a74bee6$var$XfaText.shouldBuildText(root.name)) textDivs.push(node);
            }
            return {
                textDivs: textDivs
            };
        }
        const stack = [
            [
                root,
                -1,
                rootHtml
            ]
        ];
        while(stack.length > 0){
            const [parent, i, html] = stack.at(-1);
            if (i + 1 === parent.children.length) {
                stack.pop();
                continue;
            }
            const child = parent.children[++stack.at(-1)[1]];
            if (child === null) continue;
            const { name: name } = child;
            if (name === "#text") {
                const node = document.createTextNode(child.value);
                textDivs.push(node);
                html.append(node);
                continue;
            }
            const childHtml = child?.attributes?.xmlns ? document.createElementNS(child.attributes.xmlns, name) : document.createElement(name);
            html.append(childHtml);
            if (child.attributes) this.setAttributes({
                html: childHtml,
                element: child,
                storage: storage,
                intent: intent,
                linkService: linkService
            });
            if (child.children?.length > 0) stack.push([
                child,
                -1,
                childHtml
            ]);
            else if (child.value) {
                const node = document.createTextNode(child.value);
                if (isNotForRichText && $9ef033443a74bee6$var$XfaText.shouldBuildText(name)) textDivs.push(node);
                childHtml.append(node);
            }
        }
        for (const el of rootDiv.querySelectorAll(".xfaNonInteractive input, .xfaNonInteractive textarea"))el.setAttribute("readOnly", true);
        return {
            textDivs: textDivs
        };
    }
    static update(parameters) {
        const transform = `matrix(${parameters.viewport.transform.join(",")})`;
        parameters.div.style.transform = transform;
        parameters.div.hidden = false;
    }
}
const $9ef033443a74bee6$var$SVG_NS = "http://www.w3.org/2000/svg";
class $9ef033443a74bee6$export$6ef3b6b69e65342c {
    static CSS = 96.0;
    static PDF = 72.0;
    static PDF_TO_CSS_UNITS = this.CSS / this.PDF;
}
async function $9ef033443a74bee6$export$8134c072fddab6a5(url, type = "text") {
    if ($9ef033443a74bee6$var$isValidFetchUrl(url, document.baseURI)) {
        const response = await fetch(url);
        if (!response.ok) throw new Error(response.statusText);
        switch(type){
            case "arraybuffer":
                return response.arrayBuffer();
            case "blob":
                return response.blob();
            case "json":
                return response.json();
        }
        return response.text();
    }
    return new Promise((resolve, reject)=>{
        const request = new XMLHttpRequest();
        request.open("GET", url, true);
        request.responseType = type;
        request.onreadystatechange = ()=>{
            if (request.readyState !== XMLHttpRequest.DONE) return;
            if (request.status === 200 || request.status === 0) {
                switch(type){
                    case "arraybuffer":
                    case "blob":
                    case "json":
                        resolve(request.response);
                        return;
                }
                resolve(request.responseText);
                return;
            }
            reject(new Error(request.statusText));
        };
        request.send(null);
    });
}
class $9ef033443a74bee6$var$PageViewport {
    constructor({ viewBox: viewBox, userUnit: userUnit, scale: scale, rotation: rotation, offsetX: offsetX = 0, offsetY: offsetY = 0, dontFlip: dontFlip = false }){
        this.viewBox = viewBox;
        this.userUnit = userUnit;
        this.scale = scale;
        this.rotation = rotation;
        this.offsetX = offsetX;
        this.offsetY = offsetY;
        scale *= userUnit;
        const centerX = (viewBox[2] + viewBox[0]) / 2;
        const centerY = (viewBox[3] + viewBox[1]) / 2;
        let rotateA, rotateB, rotateC, rotateD;
        rotation %= 360;
        if (rotation < 0) rotation += 360;
        switch(rotation){
            case 180:
                rotateA = -1;
                rotateB = 0;
                rotateC = 0;
                rotateD = 1;
                break;
            case 90:
                rotateA = 0;
                rotateB = 1;
                rotateC = 1;
                rotateD = 0;
                break;
            case 270:
                rotateA = 0;
                rotateB = -1;
                rotateC = -1;
                rotateD = 0;
                break;
            case 0:
                rotateA = 1;
                rotateB = 0;
                rotateC = 0;
                rotateD = -1;
                break;
            default:
                throw new Error("PageViewport: Invalid rotation, must be a multiple of 90 degrees.");
        }
        if (dontFlip) {
            rotateC = -rotateC;
            rotateD = -rotateD;
        }
        let offsetCanvasX, offsetCanvasY;
        let width, height;
        if (rotateA === 0) {
            offsetCanvasX = Math.abs(centerY - viewBox[1]) * scale + offsetX;
            offsetCanvasY = Math.abs(centerX - viewBox[0]) * scale + offsetY;
            width = (viewBox[3] - viewBox[1]) * scale;
            height = (viewBox[2] - viewBox[0]) * scale;
        } else {
            offsetCanvasX = Math.abs(centerX - viewBox[0]) * scale + offsetX;
            offsetCanvasY = Math.abs(centerY - viewBox[1]) * scale + offsetY;
            width = (viewBox[2] - viewBox[0]) * scale;
            height = (viewBox[3] - viewBox[1]) * scale;
        }
        this.transform = [
            rotateA * scale,
            rotateB * scale,
            rotateC * scale,
            rotateD * scale,
            offsetCanvasX - rotateA * scale * centerX - rotateC * scale * centerY,
            offsetCanvasY - rotateB * scale * centerX - rotateD * scale * centerY
        ];
        this.width = width;
        this.height = height;
    }
    get rawDims() {
        const dims = this.viewBox;
        return $9ef033443a74bee6$export$b8972b998723d602(this, "rawDims", {
            pageWidth: dims[2] - dims[0],
            pageHeight: dims[3] - dims[1],
            pageX: dims[0],
            pageY: dims[1]
        });
    }
    clone({ scale: scale = this.scale, rotation: rotation = this.rotation, offsetX: offsetX = this.offsetX, offsetY: offsetY = this.offsetY, dontFlip: dontFlip = false } = {}) {
        return new $9ef033443a74bee6$var$PageViewport({
            viewBox: this.viewBox.slice(),
            userUnit: this.userUnit,
            scale: scale,
            rotation: rotation,
            offsetX: offsetX,
            offsetY: offsetY,
            dontFlip: dontFlip
        });
    }
    convertToViewportPoint(x, y) {
        const p = [
            x,
            y
        ];
        $9ef033443a74bee6$export$f8f26dd395d7e1bd.applyTransform(p, this.transform);
        return p;
    }
    convertToViewportRectangle(rect) {
        const topLeft = [
            rect[0],
            rect[1]
        ];
        $9ef033443a74bee6$export$f8f26dd395d7e1bd.applyTransform(topLeft, this.transform);
        const bottomRight = [
            rect[2],
            rect[3]
        ];
        $9ef033443a74bee6$export$f8f26dd395d7e1bd.applyTransform(bottomRight, this.transform);
        return [
            topLeft[0],
            topLeft[1],
            bottomRight[0],
            bottomRight[1]
        ];
    }
    convertToPdfPoint(x, y) {
        const p = [
            x,
            y
        ];
        $9ef033443a74bee6$export$f8f26dd395d7e1bd.applyInverseTransform(p, this.transform);
        return p;
    }
}
class $9ef033443a74bee6$export$245847d31c09154f extends $9ef033443a74bee6$var$BaseException {
    constructor(msg, extraDelay = 0){
        super(msg, "RenderingCancelledException");
        this.extraDelay = extraDelay;
    }
}
function $9ef033443a74bee6$export$f67aae4532d8295b(url) {
    const ii = url.length;
    let i = 0;
    while(i < ii && url[i].trim() === "")i++;
    return url.substring(i, i + 5).toLowerCase() === "data:";
}
function $9ef033443a74bee6$export$61b52d3570d24719(filename) {
    return typeof filename === "string" && /\.pdf$/i.test(filename);
}
function $9ef033443a74bee6$export$b1c11df0696253ae(url) {
    [url] = url.split(/[#?]/, 1);
    return url.substring(url.lastIndexOf("/") + 1);
}
function $9ef033443a74bee6$export$9de51790aa4bc73a(url, defaultFilename = "document.pdf") {
    if (typeof url !== "string") return defaultFilename;
    if ($9ef033443a74bee6$export$f67aae4532d8295b(url)) {
        $9ef033443a74bee6$var$warn('getPdfFilenameFromUrl: ignore "data:"-URL for performance reasons.');
        return defaultFilename;
    }
    const getURL = (urlString)=>{
        try {
            return new URL(urlString);
        } catch  {
            try {
                return new URL(decodeURIComponent(urlString));
            } catch  {
                try {
                    return new URL(urlString, "https://foo.bar");
                } catch  {
                    try {
                        return new URL(decodeURIComponent(urlString), "https://foo.bar");
                    } catch  {
                        return null;
                    }
                }
            }
        }
    };
    const newURL = getURL(url);
    if (!newURL) return defaultFilename;
    const decode = (name)=>{
        try {
            let decoded = decodeURIComponent(name);
            if (decoded.includes("/")) {
                decoded = decoded.split("/").at(-1);
                if (decoded.test(/^\.pdf$/i)) return decoded;
                return name;
            }
            return decoded;
        } catch  {
            return name;
        }
    };
    const pdfRegex = /\.pdf$/i;
    const filename = newURL.pathname.split("/").at(-1);
    if (pdfRegex.test(filename)) return decode(filename);
    if (newURL.searchParams.size > 0) {
        const values = Array.from(newURL.searchParams.values()).reverse();
        for (const value of values){
            if (pdfRegex.test(value)) return decode(value);
        }
        const keys = Array.from(newURL.searchParams.keys()).reverse();
        for (const key of keys){
            if (pdfRegex.test(key)) return decode(key);
        }
    }
    if (newURL.hash) {
        const reFilename = /[^/?#=]+\.pdf\b(?!.*\.pdf\b)/i;
        const hashFilename = reFilename.exec(newURL.hash);
        if (hashFilename) return decode(hashFilename[0]);
    }
    return defaultFilename;
}
class $9ef033443a74bee6$var$StatTimer {
    started = Object.create(null);
    times = [];
    time(name) {
        if (name in this.started) $9ef033443a74bee6$var$warn(`Timer is already running for ${name}`);
        this.started[name] = Date.now();
    }
    timeEnd(name) {
        if (!(name in this.started)) $9ef033443a74bee6$var$warn(`Timer has not been started for ${name}`);
        this.times.push({
            name: name,
            start: this.started[name],
            end: Date.now()
        });
        delete this.started[name];
    }
    toString() {
        const outBuf = [];
        let longest = 0;
        for (const { name: name } of this.times)longest = Math.max(name.length, longest);
        for (const { name: name, start: start, end: end } of this.times)outBuf.push(`${name.padEnd(longest)} ${end - start}ms\n`);
        return outBuf.join("");
    }
}
function $9ef033443a74bee6$var$isValidFetchUrl(url, baseUrl) {
    const res = baseUrl ? URL.parse(url, baseUrl) : URL.parse(url);
    return res?.protocol === "http:" || res?.protocol === "https:";
}
function $9ef033443a74bee6$export$455b7811f904cadc(e) {
    e.preventDefault();
}
function $9ef033443a74bee6$export$7ae4cd3a66c1e050(e) {
    e.preventDefault();
    e.stopPropagation();
}
function $9ef033443a74bee6$var$deprecated(details) {
    console.log("Deprecated API usage: " + details);
}
class $9ef033443a74bee6$export$66cbc314498fffc {
    static #regex;
    static toDateObject(input) {
        if (input instanceof Date) return input;
        if (!input || typeof input !== "string") return null;
        this.#regex ||= new RegExp("^D:(\\d{4})(\\d{2})?(\\d{2})?(\\d{2})?(\\d{2})?(\\d{2})?([Z|+|-])?(\\d{2})?'?(\\d{2})?'?");
        const matches = this.#regex.exec(input);
        if (!matches) return null;
        const year = parseInt(matches[1], 10);
        let month = parseInt(matches[2], 10);
        month = month >= 1 && month <= 12 ? month - 1 : 0;
        let day = parseInt(matches[3], 10);
        day = day >= 1 && day <= 31 ? day : 1;
        let hour = parseInt(matches[4], 10);
        hour = hour >= 0 && hour <= 23 ? hour : 0;
        let minute = parseInt(matches[5], 10);
        minute = minute >= 0 && minute <= 59 ? minute : 0;
        let second = parseInt(matches[6], 10);
        second = second >= 0 && second <= 59 ? second : 0;
        const universalTimeRelation = matches[7] || "Z";
        let offsetHour = parseInt(matches[8], 10);
        offsetHour = offsetHour >= 0 && offsetHour <= 23 ? offsetHour : 0;
        let offsetMinute = parseInt(matches[9], 10) || 0;
        offsetMinute = offsetMinute >= 0 && offsetMinute <= 59 ? offsetMinute : 0;
        if (universalTimeRelation === "-") {
            hour += offsetHour;
            minute += offsetMinute;
        } else if (universalTimeRelation === "+") {
            hour -= offsetHour;
            minute -= offsetMinute;
        }
        return new Date(Date.UTC(year, month, day, hour, minute, second));
    }
}
function $9ef033443a74bee6$export$dd5d6edf3fc80aae(xfaPage, { scale: scale = 1, rotation: rotation = 0 }) {
    const { width: width, height: height } = xfaPage.attributes.style;
    const viewBox = [
        0,
        0,
        parseInt(width),
        parseInt(height)
    ];
    return new $9ef033443a74bee6$var$PageViewport({
        viewBox: viewBox,
        userUnit: 1,
        scale: scale,
        rotation: rotation
    });
}
function $9ef033443a74bee6$export$2a2e9b507863ddda(color) {
    if (color.startsWith("#")) {
        const colorRGB = parseInt(color.slice(1), 16);
        return [
            (colorRGB & 0xff0000) >> 16,
            (colorRGB & 0x00ff00) >> 8,
            colorRGB & 0x0000ff
        ];
    }
    if (color.startsWith("rgb(")) return color.slice(4, -1).split(",").map((x)=>parseInt(x));
    if (color.startsWith("rgba(")) return color.slice(5, -1).split(",").map((x)=>parseInt(x)).slice(0, 3);
    $9ef033443a74bee6$var$warn(`Not a valid color format: "${color}"`);
    return [
        0,
        0,
        0
    ];
}
function $9ef033443a74bee6$var$getColorValues(colors) {
    const span = document.createElement("span");
    span.style.visibility = "hidden";
    span.style.colorScheme = "only light";
    document.body.append(span);
    for (const name of colors.keys()){
        span.style.color = name;
        const computedColor = window.getComputedStyle(span).color;
        colors.set(name, $9ef033443a74bee6$export$2a2e9b507863ddda(computedColor));
    }
    span.remove();
}
function $9ef033443a74bee6$var$getCurrentTransform(ctx) {
    const { a: a, b: b, c: c, d: d, e: e, f: f } = ctx.getTransform();
    return [
        a,
        b,
        c,
        d,
        e,
        f
    ];
}
function $9ef033443a74bee6$var$getCurrentTransformInverse(ctx) {
    const { a: a, b: b, c: c, d: d, e: e, f: f } = ctx.getTransform().invertSelf();
    return [
        a,
        b,
        c,
        d,
        e,
        f
    ];
}
function $9ef033443a74bee6$export$af0a15a86e590226(div, viewport, mustFlip = false, mustRotate = true) {
    if (viewport instanceof $9ef033443a74bee6$var$PageViewport) {
        const { pageWidth: pageWidth, pageHeight: pageHeight } = viewport.rawDims;
        const { style: style } = div;
        const useRound = $9ef033443a74bee6$export$5fb8891d35c36978.isCSSRoundSupported;
        const w = `var(--total-scale-factor) * ${pageWidth}px`, h = `var(--total-scale-factor) * ${pageHeight}px`;
        const widthStr = useRound ? `round(down, ${w}, var(--scale-round-x))` : `calc(${w})`, heightStr = useRound ? `round(down, ${h}, var(--scale-round-y))` : `calc(${h})`;
        if (!mustFlip || viewport.rotation % 180 === 0) {
            style.width = widthStr;
            style.height = heightStr;
        } else {
            style.width = heightStr;
            style.height = widthStr;
        }
    }
    if (mustRotate) div.setAttribute("data-main-rotation", viewport.rotation);
}
class $9ef033443a74bee6$export$f16a99f63bccd50b {
    constructor(){
        const { pixelRatio: pixelRatio } = $9ef033443a74bee6$export$f16a99f63bccd50b;
        this.sx = pixelRatio;
        this.sy = pixelRatio;
    }
    get scaled() {
        return this.sx !== 1 || this.sy !== 1;
    }
    get symmetric() {
        return this.sx === this.sy;
    }
    limitCanvas(width, height, maxPixels, maxDim, capAreaFactor = -1) {
        let maxAreaScale = Infinity, maxWidthScale = Infinity, maxHeightScale = Infinity;
        maxPixels = $9ef033443a74bee6$export$f16a99f63bccd50b.capPixels(maxPixels, capAreaFactor);
        if (maxPixels > 0) maxAreaScale = Math.sqrt(maxPixels / (width * height));
        if (maxDim !== -1) {
            maxWidthScale = maxDim / width;
            maxHeightScale = maxDim / height;
        }
        const maxScale = Math.min(maxAreaScale, maxWidthScale, maxHeightScale);
        if (this.sx > maxScale || this.sy > maxScale) {
            this.sx = maxScale;
            this.sy = maxScale;
            return true;
        }
        return false;
    }
    static get pixelRatio() {
        return globalThis.devicePixelRatio || 1;
    }
    static capPixels(maxPixels, capAreaFactor) {
        if (capAreaFactor >= 0) {
            const winPixels = Math.ceil(window.screen.availWidth * window.screen.availHeight * this.pixelRatio ** 2 * (1 + capAreaFactor / 100));
            return maxPixels > 0 ? Math.min(maxPixels, winPixels) : winPixels;
        }
        return maxPixels;
    }
}
const $9ef033443a74bee6$export$3234c88e9de64a88 = [
    "image/apng",
    "image/avif",
    "image/bmp",
    "image/gif",
    "image/jpeg",
    "image/png",
    "image/svg+xml",
    "image/webp",
    "image/x-icon"
];
class $9ef033443a74bee6$var$ColorScheme {
    static get isDarkMode() {
        return $9ef033443a74bee6$export$b8972b998723d602(this, "isDarkMode", !!window?.matchMedia?.("(prefers-color-scheme: dark)").matches);
    }
}
class $9ef033443a74bee6$export$cec677744f6a5015 {
    static get commentForegroundColor() {
        const element = document.createElement("span");
        element.classList.add("comment", "sidebar");
        const { style: style } = element;
        style.width = style.height = "0";
        style.display = "none";
        style.color = "var(--comment-fg-color)";
        document.body.append(element);
        const { color: color } = window.getComputedStyle(element);
        element.remove();
        return $9ef033443a74bee6$export$b8972b998723d602(this, "commentForegroundColor", $9ef033443a74bee6$export$2a2e9b507863ddda(color));
    }
}
function $9ef033443a74bee6$export$f8d1472813e87bf9(r, g, b, opacity) {
    opacity = Math.min(Math.max(opacity ?? 1, 0), 1);
    const white = 255 * (1 - opacity);
    r = Math.round(r * opacity + white);
    g = Math.round(g * opacity + white);
    b = Math.round(b * opacity + white);
    return [
        r,
        g,
        b
    ];
}
function $9ef033443a74bee6$var$RGBToHSL(rgb, output) {
    const r = rgb[0] / 255;
    const g = rgb[1] / 255;
    const b = rgb[2] / 255;
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    const l = (max + min) / 2;
    if (max === min) output[0] = output[1] = 0;
    else {
        const d = max - min;
        output[1] = l < 0.5 ? d / (max + min) : d / (2 - max - min);
        switch(max){
            case r:
                output[0] = ((g - b) / d + (g < b ? 6 : 0)) * 60;
                break;
            case g:
                output[0] = ((b - r) / d + 2) * 60;
                break;
            case b:
                output[0] = ((r - g) / d + 4) * 60;
                break;
        }
    }
    output[2] = l;
}
function $9ef033443a74bee6$var$HSLToRGB(hsl, output) {
    const h = hsl[0];
    const s = hsl[1];
    const l = hsl[2];
    const c = (1 - Math.abs(2 * l - 1)) * s;
    const x = c * (1 - Math.abs(h / 60 % 2 - 1));
    const m = l - c / 2;
    switch(Math.floor(h / 60)){
        case 0:
            output[0] = c + m;
            output[1] = x + m;
            output[2] = m;
            break;
        case 1:
            output[0] = x + m;
            output[1] = c + m;
            output[2] = m;
            break;
        case 2:
            output[0] = m;
            output[1] = c + m;
            output[2] = x + m;
            break;
        case 3:
            output[0] = m;
            output[1] = x + m;
            output[2] = c + m;
            break;
        case 4:
            output[0] = x + m;
            output[1] = m;
            output[2] = c + m;
            break;
        case 5:
        case 6:
            output[0] = c + m;
            output[1] = m;
            output[2] = x + m;
            break;
    }
}
function $9ef033443a74bee6$var$computeLuminance(x) {
    return x <= 0.03928 ? x / 12.92 : ((x + 0.055) / 1.055) ** 2.4;
}
function $9ef033443a74bee6$var$contrastRatio(hsl1, hsl2, output) {
    $9ef033443a74bee6$var$HSLToRGB(hsl1, output);
    output.map($9ef033443a74bee6$var$computeLuminance);
    const lum1 = 0.2126 * output[0] + 0.7152 * output[1] + 0.0722 * output[2];
    $9ef033443a74bee6$var$HSLToRGB(hsl2, output);
    output.map($9ef033443a74bee6$var$computeLuminance);
    const lum2 = 0.2126 * output[0] + 0.7152 * output[1] + 0.0722 * output[2];
    return lum1 > lum2 ? (lum1 + 0.05) / (lum2 + 0.05) : (lum2 + 0.05) / (lum1 + 0.05);
}
const $9ef033443a74bee6$var$contrastCache = new Map();
function $9ef033443a74bee6$export$7a96203b1fdebe8d(baseColor, fixedColor) {
    const key = baseColor[0] + baseColor[1] * 0x100 + baseColor[2] * 0x10000 + fixedColor[0] * 0x1000000 + fixedColor[1] * 0x100000000 + fixedColor[2] * 0x10000000000;
    let cachedValue = $9ef033443a74bee6$var$contrastCache.get(key);
    if (cachedValue) return cachedValue;
    const array = new Float32Array(9);
    const output = array.subarray(0, 3);
    const baseHSL = array.subarray(3, 6);
    $9ef033443a74bee6$var$RGBToHSL(baseColor, baseHSL);
    const fixedHSL = array.subarray(6, 9);
    $9ef033443a74bee6$var$RGBToHSL(fixedColor, fixedHSL);
    const isFixedColorDark = fixedHSL[2] < 0.5;
    const minContrast = isFixedColorDark ? 12 : 4.5;
    baseHSL[2] = isFixedColorDark ? Math.sqrt(baseHSL[2]) : 1 - Math.sqrt(1 - baseHSL[2]);
    if ($9ef033443a74bee6$var$contrastRatio(baseHSL, fixedHSL, output) < minContrast) {
        let start, end;
        if (isFixedColorDark) {
            start = baseHSL[2];
            end = 1;
        } else {
            start = 0;
            end = baseHSL[2];
        }
        const PRECISION = 0.005;
        while(end - start > PRECISION){
            const mid = baseHSL[2] = (start + end) / 2;
            if (isFixedColorDark === $9ef033443a74bee6$var$contrastRatio(baseHSL, fixedHSL, output) < minContrast) start = mid;
            else end = mid;
        }
        baseHSL[2] = isFixedColorDark ? end : start;
    }
    $9ef033443a74bee6$var$HSLToRGB(baseHSL, output);
    cachedValue = $9ef033443a74bee6$export$f8f26dd395d7e1bd.makeHexColor(Math.round(output[0] * 255), Math.round(output[1] * 255), Math.round(output[2] * 255));
    $9ef033443a74bee6$var$contrastCache.set(key, cachedValue);
    return cachedValue;
}
function $9ef033443a74bee6$export$611c480766035c4({ html: html, dir: dir, className: className }, container) {
    const fragment = document.createDocumentFragment();
    if (typeof html === "string") {
        const p = document.createElement("p");
        p.dir = dir || "auto";
        const lines = html.split(/(?:\r\n?|\n)/);
        for(let i = 0, ii = lines.length; i < ii; ++i){
            const line = lines[i];
            p.append(document.createTextNode(line));
            if (i < ii - 1) p.append(document.createElement("br"));
        }
        fragment.append(p);
    } else $9ef033443a74bee6$export$f6af20c312d4b9a2.render({
        xfaHtml: html,
        div: fragment,
        intent: "richText"
    });
    fragment.firstChild.classList.add("richText", className);
    container.append(fragment);
}
class $9ef033443a74bee6$var$EditorToolbar {
    #toolbar = null;
    #colorPicker = null;
    #editor;
    #buttons = null;
    #altText = null;
    #comment = null;
    #commentButtonDivider = null;
    #signatureDescriptionButton = null;
    static #l10nRemove = null;
    constructor(editor){
        this.#editor = editor;
        $9ef033443a74bee6$var$EditorToolbar.#l10nRemove ||= Object.freeze({
            freetext: "pdfjs-editor-remove-freetext-button",
            highlight: "pdfjs-editor-remove-highlight-button",
            ink: "pdfjs-editor-remove-ink-button",
            stamp: "pdfjs-editor-remove-stamp-button",
            signature: "pdfjs-editor-remove-signature-button"
        });
    }
    render() {
        const editToolbar = this.#toolbar = document.createElement("div");
        editToolbar.classList.add("editToolbar", "hidden");
        editToolbar.setAttribute("role", "toolbar");
        const signal = this.#editor._uiManager._signal;
        if (signal instanceof AbortSignal && !signal.aborted) {
            editToolbar.addEventListener("contextmenu", $9ef033443a74bee6$export$455b7811f904cadc, {
                signal: signal
            });
            editToolbar.addEventListener("pointerdown", $9ef033443a74bee6$var$EditorToolbar.#pointerDown, {
                signal: signal
            });
        }
        const buttons = this.#buttons = document.createElement("div");
        buttons.className = "buttons";
        editToolbar.append(buttons);
        const position = this.#editor.toolbarPosition;
        if (position) {
            const { style: style } = editToolbar;
            const x = this.#editor._uiManager.direction === "ltr" ? 1 - position[0] : position[0];
            style.insetInlineEnd = `${100 * x}%`;
            style.top = `calc(${100 * position[1]}% + var(--editor-toolbar-vert-offset))`;
        }
        return editToolbar;
    }
    get div() {
        return this.#toolbar;
    }
    static #pointerDown(e) {
        e.stopPropagation();
    }
    #focusIn(e) {
        this.#editor._focusEventsAllowed = false;
        $9ef033443a74bee6$export$7ae4cd3a66c1e050(e);
    }
    #focusOut(e) {
        this.#editor._focusEventsAllowed = true;
        $9ef033443a74bee6$export$7ae4cd3a66c1e050(e);
    }
    #addListenersToElement(element) {
        const signal = this.#editor._uiManager._signal;
        if (!(signal instanceof AbortSignal) || signal.aborted) return false;
        element.addEventListener("focusin", this.#focusIn.bind(this), {
            capture: true,
            signal: signal
        });
        element.addEventListener("focusout", this.#focusOut.bind(this), {
            capture: true,
            signal: signal
        });
        element.addEventListener("contextmenu", $9ef033443a74bee6$export$455b7811f904cadc, {
            signal: signal
        });
        return true;
    }
    hide() {
        this.#toolbar.classList.add("hidden");
        this.#colorPicker?.hideDropdown();
    }
    show() {
        this.#toolbar.classList.remove("hidden");
        this.#altText?.shown();
        this.#comment?.shown();
    }
    addDeleteButton() {
        const { editorType: editorType, _uiManager: _uiManager } = this.#editor;
        const button = document.createElement("button");
        button.classList.add("basic", "deleteButton");
        button.tabIndex = 0;
        button.setAttribute("data-l10n-id", $9ef033443a74bee6$var$EditorToolbar.#l10nRemove[editorType]);
        if (this.#addListenersToElement(button)) button.addEventListener("click", (e)=>{
            _uiManager.delete();
        }, {
            signal: _uiManager._signal
        });
        this.#buttons.append(button);
    }
    get #divider() {
        const divider = document.createElement("div");
        divider.className = "divider";
        return divider;
    }
    async addAltText(altText) {
        const button = await altText.render();
        this.#addListenersToElement(button);
        this.#buttons.append(button, this.#divider);
        this.#altText = altText;
    }
    addComment(comment, beforeElement = null) {
        if (this.#comment) return;
        const button = comment.renderForToolbar();
        if (!button) return;
        this.#addListenersToElement(button);
        const divider = this.#commentButtonDivider = this.#divider;
        if (!beforeElement) this.#buttons.append(button, divider);
        else {
            this.#buttons.insertBefore(button, beforeElement);
            this.#buttons.insertBefore(divider, beforeElement);
        }
        this.#comment = comment;
        comment.toolbar = this;
    }
    addColorPicker(colorPicker) {
        if (this.#colorPicker) return;
        this.#colorPicker = colorPicker;
        const button = colorPicker.renderButton();
        this.#addListenersToElement(button);
        this.#buttons.append(button, this.#divider);
    }
    async addEditSignatureButton(signatureManager) {
        const button = this.#signatureDescriptionButton = await signatureManager.renderEditButton(this.#editor);
        this.#addListenersToElement(button);
        this.#buttons.append(button, this.#divider);
    }
    removeButton(name) {
        switch(name){
            case "comment":
                this.#comment?.removeToolbarCommentButton();
                this.#comment = null;
                this.#commentButtonDivider?.remove();
                this.#commentButtonDivider = null;
                break;
        }
    }
    async addButton(name, tool) {
        switch(name){
            case "colorPicker":
                this.addColorPicker(tool);
                break;
            case "altText":
                await this.addAltText(tool);
                break;
            case "editSignature":
                await this.addEditSignatureButton(tool);
                break;
            case "delete":
                this.addDeleteButton();
                break;
            case "comment":
                this.addComment(tool);
                break;
        }
    }
    async addButtonBefore(name, tool, beforeSelector) {
        const beforeElement = this.#buttons.querySelector(beforeSelector);
        if (!beforeElement) return;
        if (name === "comment") this.addComment(tool, beforeElement);
    }
    updateEditSignatureButton(description) {
        if (this.#signatureDescriptionButton) this.#signatureDescriptionButton.title = description;
    }
    remove() {
        this.#toolbar.remove();
        this.#colorPicker?.destroy();
        this.#colorPicker = null;
    }
}
class $9ef033443a74bee6$var$FloatingToolbar {
    #buttons = null;
    #toolbar = null;
    #uiManager;
    constructor(uiManager){
        this.#uiManager = uiManager;
    }
    #render() {
        const editToolbar = this.#toolbar = document.createElement("div");
        editToolbar.className = "editToolbar";
        editToolbar.setAttribute("role", "toolbar");
        const signal = this.#uiManager._signal;
        if (signal instanceof AbortSignal && !signal.aborted) editToolbar.addEventListener("contextmenu", $9ef033443a74bee6$export$455b7811f904cadc, {
            signal: signal
        });
        const buttons = this.#buttons = document.createElement("div");
        buttons.className = "buttons";
        editToolbar.append(buttons);
        if (this.#uiManager.hasCommentManager()) this.#makeButton("commentButton", `pdfjs-comment-floating-button`, "pdfjs-comment-floating-button-label", ()=>{
            this.#uiManager.commentSelection("floating_button");
        });
        this.#makeButton("highlightButton", `pdfjs-highlight-floating-button1`, "pdfjs-highlight-floating-button-label", ()=>{
            this.#uiManager.highlightSelection("floating_button");
        });
        return editToolbar;
    }
    #getLastPoint(boxes, isLTR) {
        let lastY = 0;
        let lastX = 0;
        for (const box of boxes){
            const y = box.y + box.height;
            if (y < lastY) continue;
            const x = box.x + (isLTR ? box.width : 0);
            if (y > lastY) {
                lastX = x;
                lastY = y;
                continue;
            }
            if (isLTR) {
                if (x > lastX) lastX = x;
            } else if (x < lastX) lastX = x;
        }
        return [
            isLTR ? 1 - lastX : lastX,
            lastY
        ];
    }
    show(parent, boxes, isLTR) {
        const [x, y] = this.#getLastPoint(boxes, isLTR);
        const { style: style } = this.#toolbar ||= this.#render();
        parent.append(this.#toolbar);
        style.insetInlineEnd = `${100 * x}%`;
        style.top = `calc(${100 * y}% + var(--editor-toolbar-vert-offset))`;
    }
    hide() {
        this.#toolbar.remove();
    }
    #makeButton(buttonClass, l10nId, labelL10nId, clickHandler) {
        const button = document.createElement("button");
        button.classList.add("basic", buttonClass);
        button.tabIndex = 0;
        button.setAttribute("data-l10n-id", l10nId);
        const span = document.createElement("span");
        button.append(span);
        span.className = "visuallyHidden";
        span.setAttribute("data-l10n-id", labelL10nId);
        const signal = this.#uiManager._signal;
        if (signal instanceof AbortSignal && !signal.aborted) {
            button.addEventListener("contextmenu", $9ef033443a74bee6$export$455b7811f904cadc, {
                signal: signal
            });
            button.addEventListener("click", clickHandler, {
                signal: signal
            });
        }
        this.#buttons.append(button);
    }
}
function $9ef033443a74bee6$var$bindEvents(obj, element, names) {
    for (const name of names)element.addEventListener(name, obj[name].bind(obj));
}
class $9ef033443a74bee6$var$IdManager {
    #id = 0;
    get id() {
        return `${$9ef033443a74bee6$var$AnnotationEditorPrefix}${this.#id++}`;
    }
}
class $9ef033443a74bee6$var$ImageManager {
    #baseId = $9ef033443a74bee6$export$75f13a91ebdf8eb3();
    #id = 0;
    #cache = null;
    static get _isSVGFittingCanvas() {
        const svg = `data:image/svg+xml;charset=UTF-8,<svg viewBox="0 0 1 1" width="1" height="1" xmlns="http://www.w3.org/2000/svg"><rect width="1" height="1" style="fill:red;"/></svg>`;
        const canvas = new OffscreenCanvas(1, 3);
        const ctx = canvas.getContext("2d", {
            willReadFrequently: true
        });
        const image = new Image();
        image.src = svg;
        const promise = image.decode().then(()=>{
            ctx.drawImage(image, 0, 0, 1, 1, 0, 0, 1, 3);
            return new Uint32Array(ctx.getImageData(0, 0, 1, 1).data.buffer)[0] === 0;
        });
        return $9ef033443a74bee6$export$b8972b998723d602(this, "_isSVGFittingCanvas", promise);
    }
    async #get(key, rawData) {
        this.#cache ||= new Map();
        let data = this.#cache.get(key);
        if (data === null) return null;
        if (data?.bitmap) {
            data.refCounter += 1;
            return data;
        }
        try {
            data ||= {
                bitmap: null,
                id: `image_${this.#baseId}_${this.#id++}`,
                refCounter: 0,
                isSvg: false
            };
            let image;
            if (typeof rawData === "string") {
                data.url = rawData;
                image = await $9ef033443a74bee6$export$8134c072fddab6a5(rawData, "blob");
            } else if (rawData instanceof File) image = data.file = rawData;
            else if (rawData instanceof Blob) image = rawData;
            if (image.type === "image/svg+xml") {
                const mustRemoveAspectRatioPromise = $9ef033443a74bee6$var$ImageManager._isSVGFittingCanvas;
                const fileReader = new FileReader();
                const imageElement = new Image();
                const imagePromise = new Promise((resolve, reject)=>{
                    imageElement.onload = ()=>{
                        data.bitmap = imageElement;
                        data.isSvg = true;
                        resolve();
                    };
                    fileReader.onload = async ()=>{
                        const url = data.svgUrl = fileReader.result;
                        imageElement.src = await mustRemoveAspectRatioPromise ? `${url}#svgView(preserveAspectRatio(none))` : url;
                    };
                    imageElement.onerror = fileReader.onerror = reject;
                });
                fileReader.readAsDataURL(image);
                await imagePromise;
            } else data.bitmap = await createImageBitmap(image);
            data.refCounter = 1;
        } catch (e) {
            $9ef033443a74bee6$var$warn(e);
            data = null;
        }
        this.#cache.set(key, data);
        if (data) this.#cache.set(data.id, data);
        return data;
    }
    async getFromFile(file) {
        const { lastModified: lastModified, name: name, size: size, type: type } = file;
        return this.#get(`${lastModified}_${name}_${size}_${type}`, file);
    }
    async getFromUrl(url) {
        return this.#get(url, url);
    }
    async getFromBlob(id, blobPromise) {
        const blob = await blobPromise;
        return this.#get(id, blob);
    }
    async getFromId(id) {
        this.#cache ||= new Map();
        const data = this.#cache.get(id);
        if (!data) return null;
        if (data.bitmap) {
            data.refCounter += 1;
            return data;
        }
        if (data.file) return this.getFromFile(data.file);
        if (data.blobPromise) {
            const { blobPromise: blobPromise } = data;
            delete data.blobPromise;
            return this.getFromBlob(data.id, blobPromise);
        }
        return this.getFromUrl(data.url);
    }
    getFromCanvas(id, canvas) {
        this.#cache ||= new Map();
        let data = this.#cache.get(id);
        if (data?.bitmap) {
            data.refCounter += 1;
            return data;
        }
        const offscreen = new OffscreenCanvas(canvas.width, canvas.height);
        const ctx = offscreen.getContext("2d");
        ctx.drawImage(canvas, 0, 0);
        data = {
            bitmap: offscreen.transferToImageBitmap(),
            id: `image_${this.#baseId}_${this.#id++}`,
            refCounter: 1,
            isSvg: false
        };
        this.#cache.set(id, data);
        this.#cache.set(data.id, data);
        return data;
    }
    getSvgUrl(id) {
        const data = this.#cache.get(id);
        if (!data?.isSvg) return null;
        return data.svgUrl;
    }
    deleteId(id) {
        this.#cache ||= new Map();
        const data = this.#cache.get(id);
        if (!data) return;
        data.refCounter -= 1;
        if (data.refCounter !== 0) return;
        const { bitmap: bitmap } = data;
        if (!data.url && !data.file) {
            const canvas = new OffscreenCanvas(bitmap.width, bitmap.height);
            const ctx = canvas.getContext("bitmaprenderer");
            ctx.transferFromImageBitmap(bitmap);
            data.blobPromise = canvas.convertToBlob();
        }
        bitmap.close?.();
        data.bitmap = null;
    }
    isValidId(id) {
        return id.startsWith(`image_${this.#baseId}_`);
    }
}
class $9ef033443a74bee6$var$CommandManager {
    #commands = [];
    #locked = false;
    #maxSize;
    #position = -1;
    constructor(maxSize = 128){
        this.#maxSize = maxSize;
    }
    add({ cmd: cmd, undo: undo, post: post, mustExec: mustExec, type: type = NaN, overwriteIfSameType: overwriteIfSameType = false, keepUndo: keepUndo = false }) {
        if (mustExec) cmd();
        if (this.#locked) return;
        const save = {
            cmd: cmd,
            undo: undo,
            post: post,
            type: type
        };
        if (this.#position === -1) {
            if (this.#commands.length > 0) this.#commands.length = 0;
            this.#position = 0;
            this.#commands.push(save);
            return;
        }
        if (overwriteIfSameType && this.#commands[this.#position].type === type) {
            if (keepUndo) save.undo = this.#commands[this.#position].undo;
            this.#commands[this.#position] = save;
            return;
        }
        const next = this.#position + 1;
        if (next === this.#maxSize) this.#commands.splice(0, 1);
        else {
            this.#position = next;
            if (next < this.#commands.length) this.#commands.splice(next);
        }
        this.#commands.push(save);
    }
    undo() {
        if (this.#position === -1) return;
        this.#locked = true;
        const { undo: undo, post: post } = this.#commands[this.#position];
        undo();
        post?.();
        this.#locked = false;
        this.#position -= 1;
    }
    redo() {
        if (this.#position < this.#commands.length - 1) {
            this.#position += 1;
            this.#locked = true;
            const { cmd: cmd, post: post } = this.#commands[this.#position];
            cmd();
            post?.();
            this.#locked = false;
        }
    }
    hasSomethingToUndo() {
        return this.#position !== -1;
    }
    hasSomethingToRedo() {
        return this.#position < this.#commands.length - 1;
    }
    cleanType(type) {
        if (this.#position === -1) return;
        for(let i = this.#position; i >= 0; i--)if (this.#commands[i].type !== type) {
            this.#commands.splice(i + 1, this.#position - i);
            this.#position = i;
            return;
        }
        this.#commands.length = 0;
        this.#position = -1;
    }
    destroy() {
        this.#commands = null;
    }
}
class $9ef033443a74bee6$var$KeyboardManager {
    constructor(callbacks){
        this.buffer = [];
        this.callbacks = new Map();
        this.allKeys = new Set();
        const { isMac: isMac } = $9ef033443a74bee6$export$5fb8891d35c36978.platform;
        for (const [keys, callback, options = {}] of callbacks)for (const key of keys){
            const isMacKey = key.startsWith("mac+");
            if (isMac && isMacKey) {
                this.callbacks.set(key.slice(4), {
                    callback: callback,
                    options: options
                });
                this.allKeys.add(key.split("+").at(-1));
            } else if (!isMac && !isMacKey) {
                this.callbacks.set(key, {
                    callback: callback,
                    options: options
                });
                this.allKeys.add(key.split("+").at(-1));
            }
        }
    }
    #serialize(event) {
        if (event.altKey) this.buffer.push("alt");
        if (event.ctrlKey) this.buffer.push("ctrl");
        if (event.metaKey) this.buffer.push("meta");
        if (event.shiftKey) this.buffer.push("shift");
        this.buffer.push(event.key);
        const str = this.buffer.join("+");
        this.buffer.length = 0;
        return str;
    }
    exec(self, event) {
        if (!this.allKeys.has(event.key)) return;
        const info = this.callbacks.get(this.#serialize(event));
        if (!info) return;
        const { callback: callback, options: { bubbles: bubbles = false, args: args = [], checker: checker = null } } = info;
        if (checker && !checker(self, event)) return;
        callback.bind(self, ...args, event)();
        if (!bubbles) $9ef033443a74bee6$export$7ae4cd3a66c1e050(event);
    }
}
class $9ef033443a74bee6$var$ColorManager {
    static _colorsMapping = new Map([
        [
            "CanvasText",
            [
                0,
                0,
                0
            ]
        ],
        [
            "Canvas",
            [
                255,
                255,
                255
            ]
        ]
    ]);
    get _colors() {
        const colors = new Map([
            [
                "CanvasText",
                null
            ],
            [
                "Canvas",
                null
            ]
        ]);
        $9ef033443a74bee6$var$getColorValues(colors);
        return $9ef033443a74bee6$export$b8972b998723d602(this, "_colors", colors);
    }
    convert(color) {
        const rgb = $9ef033443a74bee6$export$2a2e9b507863ddda(color);
        if (!window.matchMedia("(forced-colors: active)").matches) return rgb;
        for (const [name, RGB] of this._colors){
            if (RGB.every((x, i)=>x === rgb[i])) return $9ef033443a74bee6$var$ColorManager._colorsMapping.get(name);
        }
        return rgb;
    }
    getHexCode(name) {
        const rgb = this._colors.get(name);
        if (!rgb) return name;
        return $9ef033443a74bee6$export$f8f26dd395d7e1bd.makeHexColor(...rgb);
    }
}
class $9ef033443a74bee6$export$26cb16552a82cf63 {
    #abortController = new AbortController();
    #activeEditor = null;
    #allEditableAnnotations = null;
    #allEditors = new Map();
    #allLayers = new Map();
    #altTextManager = null;
    #annotationStorage = null;
    #changedExistingAnnotations = null;
    #commandManager = new $9ef033443a74bee6$var$CommandManager();
    #commentManager = null;
    #copyPasteAC = null;
    #currentDrawingSession = null;
    #currentPageIndex = 0;
    #deletedAnnotationsElementIds = new Set();
    #draggingEditors = null;
    #editorTypes = null;
    #editorsToRescale = new Set();
    _editorUndoBar = null;
    #enableHighlightFloatingButton = false;
    #enableUpdatedAddImage = false;
    #enableNewAltTextWhenAddingImage = false;
    #filterFactory = null;
    #focusMainContainerTimeoutId = null;
    #focusManagerAC = null;
    #highlightColors = null;
    #highlightWhenShiftUp = false;
    #floatingToolbar = null;
    #idManager = new $9ef033443a74bee6$var$IdManager();
    #isEnabled = false;
    #isPointerDown = false;
    #isWaiting = false;
    #keyboardManagerAC = null;
    #lastActiveElement = null;
    #mainHighlightColorPicker = null;
    #missingCanvases = null;
    #mlManager = null;
    #mode = $9ef033443a74bee6$export$72ea3bfdd9a725bf.NONE;
    #selectedEditors = new Set();
    #selectedTextNode = null;
    #signatureManager = null;
    #pageColors = null;
    #showAllStates = null;
    #pdfDocument = null;
    #previousStates = {
        isEditing: false,
        isEmpty: true,
        hasSomethingToUndo: false,
        hasSomethingToRedo: false,
        hasSelectedEditor: false,
        hasSelectedText: false
    };
    #translation = [
        0,
        0
    ];
    #translationTimeoutId = null;
    #container = null;
    #viewer = null;
    #viewerAlert = null;
    #updateModeCapability = null;
    static TRANSLATE_SMALL = 1;
    static TRANSLATE_BIG = 10;
    static get _keyboardManager() {
        const proto = $9ef033443a74bee6$export$26cb16552a82cf63.prototype;
        const arrowChecker = (self)=>self.#container.contains(document.activeElement) && document.activeElement.tagName !== "BUTTON" && self.hasSomethingToControl();
        const textInputChecker = (_self, { target: el })=>{
            if (el instanceof HTMLInputElement) {
                const { type: type } = el;
                return type !== "text" && type !== "number";
            }
            return true;
        };
        const small = this.TRANSLATE_SMALL;
        const big = this.TRANSLATE_BIG;
        return $9ef033443a74bee6$export$b8972b998723d602(this, "_keyboardManager", new $9ef033443a74bee6$var$KeyboardManager([
            [
                [
                    "ctrl+a",
                    "mac+meta+a"
                ],
                proto.selectAll,
                {
                    checker: textInputChecker
                }
            ],
            [
                [
                    "ctrl+z",
                    "mac+meta+z"
                ],
                proto.undo,
                {
                    checker: textInputChecker
                }
            ],
            [
                [
                    "ctrl+y",
                    "ctrl+shift+z",
                    "mac+meta+shift+z",
                    "ctrl+shift+Z",
                    "mac+meta+shift+Z"
                ],
                proto.redo,
                {
                    checker: textInputChecker
                }
            ],
            [
                [
                    "Backspace",
                    "alt+Backspace",
                    "ctrl+Backspace",
                    "shift+Backspace",
                    "mac+Backspace",
                    "mac+alt+Backspace",
                    "mac+ctrl+Backspace",
                    "Delete",
                    "ctrl+Delete",
                    "shift+Delete",
                    "mac+Delete"
                ],
                proto.delete,
                {
                    checker: textInputChecker
                }
            ],
            [
                [
                    "Enter",
                    "mac+Enter"
                ],
                proto.addNewEditorFromKeyboard,
                {
                    checker: (self, { target: el })=>!(el instanceof HTMLButtonElement) && self.#container.contains(el) && !self.isEnterHandled
                }
            ],
            [
                [
                    " ",
                    "mac+ "
                ],
                proto.addNewEditorFromKeyboard,
                {
                    checker: (self, { target: el })=>!(el instanceof HTMLButtonElement) && self.#container.contains(document.activeElement)
                }
            ],
            [
                [
                    "Escape",
                    "mac+Escape"
                ],
                proto.unselectAll
            ],
            [
                [
                    "ArrowLeft",
                    "mac+ArrowLeft"
                ],
                proto.translateSelectedEditors,
                {
                    args: [
                        -small,
                        0
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ctrl+ArrowLeft",
                    "mac+shift+ArrowLeft"
                ],
                proto.translateSelectedEditors,
                {
                    args: [
                        -big,
                        0
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ArrowRight",
                    "mac+ArrowRight"
                ],
                proto.translateSelectedEditors,
                {
                    args: [
                        small,
                        0
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ctrl+ArrowRight",
                    "mac+shift+ArrowRight"
                ],
                proto.translateSelectedEditors,
                {
                    args: [
                        big,
                        0
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ArrowUp",
                    "mac+ArrowUp"
                ],
                proto.translateSelectedEditors,
                {
                    args: [
                        0,
                        -small
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ctrl+ArrowUp",
                    "mac+shift+ArrowUp"
                ],
                proto.translateSelectedEditors,
                {
                    args: [
                        0,
                        -big
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ArrowDown",
                    "mac+ArrowDown"
                ],
                proto.translateSelectedEditors,
                {
                    args: [
                        0,
                        small
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ctrl+ArrowDown",
                    "mac+shift+ArrowDown"
                ],
                proto.translateSelectedEditors,
                {
                    args: [
                        0,
                        big
                    ],
                    checker: arrowChecker
                }
            ]
        ]));
    }
    constructor(container, viewer, viewerAlert, altTextManager, commentManager, signatureManager, eventBus, pdfDocument, pageColors, highlightColors, enableHighlightFloatingButton, enableUpdatedAddImage, enableNewAltTextWhenAddingImage, mlManager, editorUndoBar, supportsPinchToZoom){
        const signal = this._signal = this.#abortController.signal;
        this.#container = container;
        this.#viewer = viewer;
        this.#viewerAlert = viewerAlert;
        this.#altTextManager = altTextManager;
        this.#commentManager = commentManager;
        this.#signatureManager = signatureManager;
        this.#pdfDocument = pdfDocument;
        this._eventBus = eventBus;
        eventBus._on("editingaction", this.onEditingAction.bind(this), {
            signal: signal
        });
        eventBus._on("pagechanging", this.onPageChanging.bind(this), {
            signal: signal
        });
        eventBus._on("scalechanging", this.onScaleChanging.bind(this), {
            signal: signal
        });
        eventBus._on("rotationchanging", this.onRotationChanging.bind(this), {
            signal: signal
        });
        eventBus._on("setpreference", this.onSetPreference.bind(this), {
            signal: signal
        });
        eventBus._on("switchannotationeditorparams", (evt)=>this.updateParams(evt.type, evt.value), {
            signal: signal
        });
        window.addEventListener("pointerdown", ()=>{
            this.#isPointerDown = true;
        }, {
            capture: true,
            signal: signal
        });
        window.addEventListener("pointerup", ()=>{
            this.#isPointerDown = false;
        }, {
            capture: true,
            signal: signal
        });
        this.#addSelectionListener();
        this.#addDragAndDropListeners();
        this.#addKeyboardManager();
        this.#annotationStorage = pdfDocument.annotationStorage;
        this.#filterFactory = pdfDocument.filterFactory;
        this.#pageColors = pageColors;
        this.#highlightColors = highlightColors || null;
        this.#enableHighlightFloatingButton = enableHighlightFloatingButton;
        this.#enableUpdatedAddImage = enableUpdatedAddImage;
        this.#enableNewAltTextWhenAddingImage = enableNewAltTextWhenAddingImage;
        this.#mlManager = mlManager || null;
        this.viewParameters = {
            realScale: $9ef033443a74bee6$export$6ef3b6b69e65342c.PDF_TO_CSS_UNITS,
            rotation: 0
        };
        this.isShiftKeyDown = false;
        this._editorUndoBar = editorUndoBar || null;
        this._supportsPinchToZoom = supportsPinchToZoom !== false;
        commentManager?.setSidebarUiManager(this);
    }
    destroy() {
        this.#updateModeCapability?.resolve();
        this.#updateModeCapability = null;
        this.#abortController?.abort();
        this.#abortController = null;
        this._signal = null;
        for (const layer of this.#allLayers.values())layer.destroy();
        this.#allLayers.clear();
        this.#allEditors.clear();
        this.#editorsToRescale.clear();
        this.#missingCanvases?.clear();
        this.#activeEditor = null;
        this.#selectedEditors.clear();
        this.#commandManager.destroy();
        this.#altTextManager?.destroy();
        this.#commentManager?.destroy();
        this.#signatureManager?.destroy();
        this.#floatingToolbar?.hide();
        this.#floatingToolbar = null;
        this.#mainHighlightColorPicker?.destroy();
        this.#mainHighlightColorPicker = null;
        this.#allEditableAnnotations = null;
        if (this.#focusMainContainerTimeoutId) {
            clearTimeout(this.#focusMainContainerTimeoutId);
            this.#focusMainContainerTimeoutId = null;
        }
        if (this.#translationTimeoutId) {
            clearTimeout(this.#translationTimeoutId);
            this.#translationTimeoutId = null;
        }
        this._editorUndoBar?.destroy();
        this.#pdfDocument = null;
    }
    combinedSignal(ac) {
        return AbortSignal.any([
            this._signal,
            ac.signal
        ]);
    }
    get mlManager() {
        return this.#mlManager;
    }
    get useNewAltTextFlow() {
        return this.#enableUpdatedAddImage;
    }
    get useNewAltTextWhenAddingImage() {
        return this.#enableNewAltTextWhenAddingImage;
    }
    get hcmFilter() {
        return $9ef033443a74bee6$export$b8972b998723d602(this, "hcmFilter", this.#pageColors ? this.#filterFactory.addHCMFilter(this.#pageColors.foreground, this.#pageColors.background) : "none");
    }
    get direction() {
        return $9ef033443a74bee6$export$b8972b998723d602(this, "direction", getComputedStyle(this.#container).direction);
    }
    get _highlightColors() {
        return $9ef033443a74bee6$export$b8972b998723d602(this, "_highlightColors", this.#highlightColors ? new Map(this.#highlightColors.split(",").map((pair)=>{
            pair = pair.split("=").map((x)=>x.trim());
            pair[1] = pair[1].toUpperCase();
            return pair;
        })) : null);
    }
    get highlightColors() {
        const { _highlightColors: _highlightColors } = this;
        if (!_highlightColors) return $9ef033443a74bee6$export$b8972b998723d602(this, "highlightColors", null);
        const map = new Map();
        const hasHCM = !!this.#pageColors;
        for (const [name, color] of _highlightColors){
            const isNameForHCM = name.endsWith("_HCM");
            if (hasHCM && isNameForHCM) {
                map.set(name.replace("_HCM", ""), color);
                continue;
            }
            if (!hasHCM && !isNameForHCM) map.set(name, color);
        }
        return $9ef033443a74bee6$export$b8972b998723d602(this, "highlightColors", map);
    }
    get highlightColorNames() {
        return $9ef033443a74bee6$export$b8972b998723d602(this, "highlightColorNames", this.highlightColors ? new Map(Array.from(this.highlightColors, (e)=>e.reverse())) : null);
    }
    getNonHCMColor(color) {
        if (!this._highlightColors) return color;
        const colorName = this.highlightColorNames.get(color);
        return this._highlightColors.get(colorName) || color;
    }
    getNonHCMColorName(color) {
        return this.highlightColorNames.get(color) || color;
    }
    setCurrentDrawingSession(layer) {
        if (layer) {
            this.unselectAll();
            this.disableUserSelect(true);
        } else this.disableUserSelect(false);
        this.#currentDrawingSession = layer;
    }
    setMainHighlightColorPicker(colorPicker) {
        this.#mainHighlightColorPicker = colorPicker;
    }
    editAltText(editor, firstTime = false) {
        this.#altTextManager?.editAltText(this, editor, firstTime);
    }
    hasCommentManager() {
        return !!this.#commentManager;
    }
    editComment(editor, posX, posY, options) {
        this.#commentManager?.showDialog(this, editor, posX, posY, options);
    }
    selectComment(pageIndex, uid) {
        const layer = this.#allLayers.get(pageIndex);
        const editor = layer?.getEditorByUID(uid);
        editor?.toggleComment(true, true);
    }
    updateComment(editor) {
        this.#commentManager?.updateComment(editor.getData());
    }
    updatePopupColor(editor) {
        this.#commentManager?.updatePopupColor(editor);
    }
    removeComment(editor) {
        this.#commentManager?.removeComments([
            editor.uid
        ]);
    }
    toggleComment(editor, isSelected, visibility) {
        this.#commentManager?.toggleCommentPopup(editor, isSelected, visibility);
    }
    makeCommentColor(color, opacity) {
        return color && this.#commentManager?.makeCommentColor(color, opacity) || null;
    }
    getCommentDialogElement() {
        return this.#commentManager?.dialogElement || null;
    }
    async waitForEditorsRendered(pageNumber) {
        if (this.#allLayers.has(pageNumber - 1)) return;
        const { resolve: resolve, promise: promise } = Promise.withResolvers();
        const onEditorsRendered = (evt)=>{
            if (evt.pageNumber === pageNumber) {
                this._eventBus._off("editorsrendered", onEditorsRendered);
                resolve();
            }
        };
        this._eventBus.on("editorsrendered", onEditorsRendered);
        await promise;
    }
    getSignature(editor) {
        this.#signatureManager?.getSignature({
            uiManager: this,
            editor: editor
        });
    }
    get signatureManager() {
        return this.#signatureManager;
    }
    switchToMode(mode, callback) {
        this._eventBus.on("annotationeditormodechanged", callback, {
            once: true,
            signal: this._signal
        });
        this._eventBus.dispatch("showannotationeditorui", {
            source: this,
            mode: mode
        });
    }
    setPreference(name, value) {
        this._eventBus.dispatch("setpreference", {
            source: this,
            name: name,
            value: value
        });
    }
    onSetPreference({ name: name, value: value }) {
        switch(name){
            case "enableNewAltTextWhenAddingImage":
                this.#enableNewAltTextWhenAddingImage = value;
                break;
        }
    }
    onPageChanging({ pageNumber: pageNumber }) {
        this.#currentPageIndex = pageNumber - 1;
    }
    focusMainContainer() {
        this.#container.focus();
    }
    findParent(x, y) {
        for (const layer of this.#allLayers.values()){
            const { x: layerX, y: layerY, width: width, height: height } = layer.div.getBoundingClientRect();
            if (x >= layerX && x <= layerX + width && y >= layerY && y <= layerY + height) return layer;
        }
        return null;
    }
    disableUserSelect(value = false) {
        this.#viewer.classList.toggle("noUserSelect", value);
    }
    addShouldRescale(editor) {
        this.#editorsToRescale.add(editor);
    }
    removeShouldRescale(editor) {
        this.#editorsToRescale.delete(editor);
    }
    onScaleChanging({ scale: scale }) {
        this.commitOrRemove();
        this.viewParameters.realScale = scale * $9ef033443a74bee6$export$6ef3b6b69e65342c.PDF_TO_CSS_UNITS;
        for (const editor of this.#editorsToRescale)editor.onScaleChanging();
        this.#currentDrawingSession?.onScaleChanging();
    }
    onRotationChanging({ pagesRotation: pagesRotation }) {
        this.commitOrRemove();
        this.viewParameters.rotation = pagesRotation;
    }
    #getAnchorElementForSelection({ anchorNode: anchorNode }) {
        return anchorNode.nodeType === Node.TEXT_NODE ? anchorNode.parentElement : anchorNode;
    }
    #getLayerForTextLayer(textLayer) {
        const { currentLayer: currentLayer } = this;
        if (currentLayer.hasTextLayer(textLayer)) return currentLayer;
        for (const layer of this.#allLayers.values()){
            if (layer.hasTextLayer(textLayer)) return layer;
        }
        return null;
    }
    highlightSelection(methodOfCreation = "", comment = false) {
        const selection = document.getSelection();
        if (!selection || selection.isCollapsed) return;
        const { anchorNode: anchorNode, anchorOffset: anchorOffset, focusNode: focusNode, focusOffset: focusOffset } = selection;
        const text = selection.toString();
        const anchorElement = this.#getAnchorElementForSelection(selection);
        const textLayer = anchorElement.closest(".textLayer");
        const boxes = this.getSelectionBoxes(textLayer);
        if (!boxes) return;
        selection.empty();
        const layer = this.#getLayerForTextLayer(textLayer);
        const isNoneMode = this.#mode === $9ef033443a74bee6$export$72ea3bfdd9a725bf.NONE;
        const callback = ()=>{
            const editor = layer?.createAndAddNewEditor({
                x: 0,
                y: 0
            }, false, {
                methodOfCreation: methodOfCreation,
                boxes: boxes,
                anchorNode: anchorNode,
                anchorOffset: anchorOffset,
                focusNode: focusNode,
                focusOffset: focusOffset,
                text: text
            });
            if (isNoneMode) this.showAllEditors("highlight", true, true);
            if (comment) editor?.editComment();
        };
        if (isNoneMode) {
            this.switchToMode($9ef033443a74bee6$export$72ea3bfdd9a725bf.HIGHLIGHT, callback);
            return;
        }
        callback();
    }
    commentSelection(methodOfCreation = "") {
        this.highlightSelection(methodOfCreation, true);
    }
    #displayFloatingToolbar() {
        const selection = document.getSelection();
        if (!selection || selection.isCollapsed) return;
        const anchorElement = this.#getAnchorElementForSelection(selection);
        const textLayer = anchorElement.closest(".textLayer");
        const boxes = this.getSelectionBoxes(textLayer);
        if (!boxes) return;
        this.#floatingToolbar ||= new $9ef033443a74bee6$var$FloatingToolbar(this);
        this.#floatingToolbar.show(textLayer, boxes, this.direction === "ltr");
    }
    getAndRemoveDataFromAnnotationStorage(annotationId) {
        if (!this.#annotationStorage) return null;
        const key = `${$9ef033443a74bee6$var$AnnotationEditorPrefix}${annotationId}`;
        const storedValue = this.#annotationStorage.getRawValue(key);
        if (storedValue) this.#annotationStorage.remove(key);
        return storedValue;
    }
    addToAnnotationStorage(editor) {
        if (!editor.isEmpty() && this.#annotationStorage && !this.#annotationStorage.has(editor.id)) this.#annotationStorage.setValue(editor.id, editor);
    }
    a11yAlert(messageId, args = null) {
        const viewerAlert = this.#viewerAlert;
        if (!viewerAlert) return;
        viewerAlert.setAttribute("data-l10n-id", messageId);
        if (args) viewerAlert.setAttribute("data-l10n-args", JSON.stringify(args));
        else viewerAlert.removeAttribute("data-l10n-args");
    }
    #selectionChange() {
        const selection = document.getSelection();
        if (!selection || selection.isCollapsed) {
            if (this.#selectedTextNode) {
                this.#floatingToolbar?.hide();
                this.#selectedTextNode = null;
                this.#dispatchUpdateStates({
                    hasSelectedText: false
                });
            }
            return;
        }
        const { anchorNode: anchorNode } = selection;
        if (anchorNode === this.#selectedTextNode) return;
        const anchorElement = this.#getAnchorElementForSelection(selection);
        const textLayer = anchorElement.closest(".textLayer");
        if (!textLayer) {
            if (this.#selectedTextNode) {
                this.#floatingToolbar?.hide();
                this.#selectedTextNode = null;
                this.#dispatchUpdateStates({
                    hasSelectedText: false
                });
            }
            return;
        }
        this.#floatingToolbar?.hide();
        this.#selectedTextNode = anchorNode;
        this.#dispatchUpdateStates({
            hasSelectedText: true
        });
        if (this.#mode !== $9ef033443a74bee6$export$72ea3bfdd9a725bf.HIGHLIGHT && this.#mode !== $9ef033443a74bee6$export$72ea3bfdd9a725bf.NONE) return;
        if (this.#mode === $9ef033443a74bee6$export$72ea3bfdd9a725bf.HIGHLIGHT) this.showAllEditors("highlight", true, true);
        this.#highlightWhenShiftUp = this.isShiftKeyDown;
        if (!this.isShiftKeyDown) {
            const activeLayer = this.#mode === $9ef033443a74bee6$export$72ea3bfdd9a725bf.HIGHLIGHT ? this.#getLayerForTextLayer(textLayer) : null;
            activeLayer?.toggleDrawing();
            if (this.#isPointerDown) {
                const ac = new AbortController();
                const signal = this.combinedSignal(ac);
                const pointerup = (e)=>{
                    if (e.type === "pointerup" && e.button !== 0) return;
                    ac.abort();
                    activeLayer?.toggleDrawing(true);
                    if (e.type === "pointerup") this.#onSelectEnd("main_toolbar");
                };
                window.addEventListener("pointerup", pointerup, {
                    signal: signal
                });
                window.addEventListener("blur", pointerup, {
                    signal: signal
                });
            } else {
                activeLayer?.toggleDrawing(true);
                this.#onSelectEnd("main_toolbar");
            }
        }
    }
    #onSelectEnd(methodOfCreation = "") {
        if (this.#mode === $9ef033443a74bee6$export$72ea3bfdd9a725bf.HIGHLIGHT) this.highlightSelection(methodOfCreation);
        else if (this.#enableHighlightFloatingButton) this.#displayFloatingToolbar();
    }
    #addSelectionListener() {
        document.addEventListener("selectionchange", this.#selectionChange.bind(this), {
            signal: this._signal
        });
    }
    #addFocusManager() {
        if (this.#focusManagerAC) return;
        this.#focusManagerAC = new AbortController();
        const signal = this.combinedSignal(this.#focusManagerAC);
        window.addEventListener("focus", this.focus.bind(this), {
            signal: signal
        });
        window.addEventListener("blur", this.blur.bind(this), {
            signal: signal
        });
    }
    #removeFocusManager() {
        this.#focusManagerAC?.abort();
        this.#focusManagerAC = null;
    }
    blur() {
        this.isShiftKeyDown = false;
        if (this.#highlightWhenShiftUp) {
            this.#highlightWhenShiftUp = false;
            this.#onSelectEnd("main_toolbar");
        }
        if (!this.hasSelection) return;
        const { activeElement: activeElement } = document;
        for (const editor of this.#selectedEditors)if (editor.div.contains(activeElement)) {
            this.#lastActiveElement = [
                editor,
                activeElement
            ];
            editor._focusEventsAllowed = false;
            break;
        }
    }
    focus() {
        if (!this.#lastActiveElement) return;
        const [lastEditor, lastActiveElement] = this.#lastActiveElement;
        this.#lastActiveElement = null;
        lastActiveElement.addEventListener("focusin", ()=>{
            lastEditor._focusEventsAllowed = true;
        }, {
            once: true,
            signal: this._signal
        });
        lastActiveElement.focus();
    }
    #addKeyboardManager() {
        if (this.#keyboardManagerAC) return;
        this.#keyboardManagerAC = new AbortController();
        const signal = this.combinedSignal(this.#keyboardManagerAC);
        window.addEventListener("keydown", this.keydown.bind(this), {
            signal: signal
        });
        window.addEventListener("keyup", this.keyup.bind(this), {
            signal: signal
        });
    }
    #removeKeyboardManager() {
        this.#keyboardManagerAC?.abort();
        this.#keyboardManagerAC = null;
    }
    #addCopyPasteListeners() {
        if (this.#copyPasteAC) return;
        this.#copyPasteAC = new AbortController();
        const signal = this.combinedSignal(this.#copyPasteAC);
        document.addEventListener("copy", this.copy.bind(this), {
            signal: signal
        });
        document.addEventListener("cut", this.cut.bind(this), {
            signal: signal
        });
        document.addEventListener("paste", this.paste.bind(this), {
            signal: signal
        });
    }
    #removeCopyPasteListeners() {
        this.#copyPasteAC?.abort();
        this.#copyPasteAC = null;
    }
    #addDragAndDropListeners() {
        const signal = this._signal;
        document.addEventListener("dragover", this.dragOver.bind(this), {
            signal: signal
        });
        document.addEventListener("drop", this.drop.bind(this), {
            signal: signal
        });
    }
    addEditListeners() {
        this.#addKeyboardManager();
        this.#addCopyPasteListeners();
    }
    removeEditListeners() {
        this.#removeKeyboardManager();
        this.#removeCopyPasteListeners();
    }
    dragOver(event) {
        for (const { type: type } of event.dataTransfer.items){
            for (const editorType of this.#editorTypes)if (editorType.isHandlingMimeForPasting(type)) {
                event.dataTransfer.dropEffect = "copy";
                event.preventDefault();
                return;
            }
        }
    }
    drop(event) {
        for (const item of event.dataTransfer.items){
            for (const editorType of this.#editorTypes)if (editorType.isHandlingMimeForPasting(item.type)) {
                editorType.paste(item, this.currentLayer);
                event.preventDefault();
                return;
            }
        }
    }
    copy(event) {
        event.preventDefault();
        this.#activeEditor?.commitOrRemove();
        if (!this.hasSelection) return;
        const editors = [];
        for (const editor of this.#selectedEditors){
            const serialized = editor.serialize(true);
            if (serialized) editors.push(serialized);
        }
        if (editors.length === 0) return;
        event.clipboardData.setData("application/pdfjs", JSON.stringify(editors));
    }
    cut(event) {
        this.copy(event);
        this.delete();
    }
    async paste(event) {
        event.preventDefault();
        const { clipboardData: clipboardData } = event;
        for (const item of clipboardData.items){
            for (const editorType of this.#editorTypes)if (editorType.isHandlingMimeForPasting(item.type)) {
                editorType.paste(item, this.currentLayer);
                return;
            }
        }
        let data = clipboardData.getData("application/pdfjs");
        if (!data) return;
        try {
            data = JSON.parse(data);
        } catch (ex) {
            $9ef033443a74bee6$var$warn(`paste: "${ex.message}".`);
            return;
        }
        if (!Array.isArray(data)) return;
        this.unselectAll();
        const layer = this.currentLayer;
        try {
            const newEditors = [];
            for (const editor of data){
                const deserializedEditor = await layer.deserialize(editor);
                if (!deserializedEditor) return;
                newEditors.push(deserializedEditor);
            }
            const cmd = ()=>{
                for (const editor of newEditors)this.#addEditorToLayer(editor);
                this.#selectEditors(newEditors);
            };
            const undo = ()=>{
                for (const editor of newEditors)editor.remove();
            };
            this.addCommands({
                cmd: cmd,
                undo: undo,
                mustExec: true
            });
        } catch (ex) {
            $9ef033443a74bee6$var$warn(`paste: "${ex.message}".`);
        }
    }
    keydown(event) {
        if (!this.isShiftKeyDown && event.key === "Shift") this.isShiftKeyDown = true;
        if (this.#mode !== $9ef033443a74bee6$export$72ea3bfdd9a725bf.NONE && !this.isEditorHandlingKeyboard) $9ef033443a74bee6$export$26cb16552a82cf63._keyboardManager.exec(this, event);
    }
    keyup(event) {
        if (this.isShiftKeyDown && event.key === "Shift") {
            this.isShiftKeyDown = false;
            if (this.#highlightWhenShiftUp) {
                this.#highlightWhenShiftUp = false;
                this.#onSelectEnd("main_toolbar");
            }
        }
    }
    onEditingAction({ name: name }) {
        switch(name){
            case "undo":
            case "redo":
            case "delete":
            case "selectAll":
                this[name]();
                break;
            case "highlightSelection":
                this.highlightSelection("context_menu");
                break;
            case "commentSelection":
                this.commentSelection("context_menu");
                break;
        }
    }
    #dispatchUpdateStates(details) {
        const hasChanged = Object.entries(details).some(([key, value])=>this.#previousStates[key] !== value);
        if (hasChanged) {
            this._eventBus.dispatch("annotationeditorstateschanged", {
                source: this,
                details: Object.assign(this.#previousStates, details)
            });
            if (this.#mode === $9ef033443a74bee6$export$72ea3bfdd9a725bf.HIGHLIGHT && details.hasSelectedEditor === false) this.#dispatchUpdateUI([
                [
                    $9ef033443a74bee6$export$cf3df2a6ecc26692.HIGHLIGHT_FREE,
                    true
                ]
            ]);
        }
    }
    #dispatchUpdateUI(details) {
        this._eventBus.dispatch("annotationeditorparamschanged", {
            source: this,
            details: details
        });
    }
    setEditingState(isEditing) {
        if (isEditing) {
            this.#addFocusManager();
            this.#addCopyPasteListeners();
            this.#dispatchUpdateStates({
                isEditing: this.#mode !== $9ef033443a74bee6$export$72ea3bfdd9a725bf.NONE,
                isEmpty: this.#isEmpty(),
                hasSomethingToUndo: this.#commandManager.hasSomethingToUndo(),
                hasSomethingToRedo: this.#commandManager.hasSomethingToRedo(),
                hasSelectedEditor: false
            });
        } else {
            this.#removeFocusManager();
            this.#removeCopyPasteListeners();
            this.#dispatchUpdateStates({
                isEditing: false
            });
            this.disableUserSelect(false);
        }
    }
    registerEditorTypes(types) {
        if (this.#editorTypes) return;
        this.#editorTypes = types;
        for (const editorType of this.#editorTypes)this.#dispatchUpdateUI(editorType.defaultPropertiesToUpdate);
    }
    getId() {
        return this.#idManager.id;
    }
    get currentLayer() {
        return this.#allLayers.get(this.#currentPageIndex);
    }
    getLayer(pageIndex) {
        return this.#allLayers.get(pageIndex);
    }
    get currentPageIndex() {
        return this.#currentPageIndex;
    }
    addLayer(layer) {
        this.#allLayers.set(layer.pageIndex, layer);
        if (this.#isEnabled) layer.enable();
        else layer.disable();
    }
    removeLayer(layer) {
        this.#allLayers.delete(layer.pageIndex);
    }
    async updateMode(mode, editId = null, isFromKeyboard = false, mustEnterInEditMode = false, editComment = false) {
        if (this.#mode === mode) return;
        if (this.#updateModeCapability) {
            await this.#updateModeCapability.promise;
            if (!this.#updateModeCapability) return;
        }
        this.#updateModeCapability = Promise.withResolvers();
        this.#currentDrawingSession?.commitOrRemove();
        if (this.#mode === $9ef033443a74bee6$export$72ea3bfdd9a725bf.POPUP) this.#commentManager?.hideSidebar();
        this.#commentManager?.destroyPopup();
        this.#mode = mode;
        if (mode === $9ef033443a74bee6$export$72ea3bfdd9a725bf.NONE) {
            this.setEditingState(false);
            this.#disableAll();
            for (const editor of this.#allEditors.values())editor.hideStandaloneCommentButton();
            this._editorUndoBar?.hide();
            this.toggleComment(null);
            this.#updateModeCapability.resolve();
            return;
        }
        for (const editor of this.#allEditors.values())editor.addStandaloneCommentButton();
        if (mode === $9ef033443a74bee6$export$72ea3bfdd9a725bf.SIGNATURE) await this.#signatureManager?.loadSignatures();
        this.setEditingState(true);
        await this.#enableAll();
        this.unselectAll();
        for (const layer of this.#allLayers.values())layer.updateMode(mode);
        if (mode === $9ef033443a74bee6$export$72ea3bfdd9a725bf.POPUP) {
            this.#allEditableAnnotations ||= await this.#pdfDocument.getAnnotationsByType(new Set(this.#editorTypes.map((editorClass)=>editorClass._editorType)));
            const elementIds = new Set();
            const allComments = [];
            for (const editor of this.#allEditors.values()){
                const { annotationElementId: annotationElementId, hasComment: hasComment, deleted: deleted } = editor;
                if (annotationElementId) elementIds.add(annotationElementId);
                if (hasComment && !deleted) allComments.push(editor.getData());
            }
            for (const annotation of this.#allEditableAnnotations){
                const { id: id, popupRef: popupRef, contentsObj: contentsObj } = annotation;
                if (popupRef && contentsObj?.str && !elementIds.has(id) && !this.#deletedAnnotationsElementIds.has(id)) allComments.push(annotation);
            }
            this.#commentManager?.showSidebar(allComments);
        }
        if (!editId) {
            if (isFromKeyboard) this.addNewEditorFromKeyboard();
            this.#updateModeCapability.resolve();
            return;
        }
        for (const editor of this.#allEditors.values())if (editor.uid === editId) {
            this.setSelected(editor);
            if (editComment) editor.editComment();
            else if (mustEnterInEditMode) editor.enterInEditMode();
            else editor.focus();
        } else editor.unselect();
        this.#updateModeCapability.resolve();
    }
    addNewEditorFromKeyboard() {
        if (this.currentLayer.canCreateNewEmptyEditor()) this.currentLayer.addNewEditor();
    }
    updateToolbar(options) {
        if (options.mode === this.#mode) return;
        this._eventBus.dispatch("switchannotationeditormode", {
            source: this,
            ...options
        });
    }
    updateParams(type, value) {
        if (!this.#editorTypes) return;
        switch(type){
            case $9ef033443a74bee6$export$cf3df2a6ecc26692.CREATE:
                this.currentLayer.addNewEditor(value);
                return;
            case $9ef033443a74bee6$export$cf3df2a6ecc26692.HIGHLIGHT_SHOW_ALL:
                this._eventBus.dispatch("reporttelemetry", {
                    source: this,
                    details: {
                        type: "editing",
                        data: {
                            type: "highlight",
                            action: "toggle_visibility"
                        }
                    }
                });
                (this.#showAllStates ||= new Map()).set(type, value);
                this.showAllEditors("highlight", value);
                break;
        }
        if (this.hasSelection) for (const editor of this.#selectedEditors)editor.updateParams(type, value);
        else for (const editorType of this.#editorTypes)editorType.updateDefaultParams(type, value);
    }
    showAllEditors(type, visible, updateButton = false) {
        for (const editor of this.#allEditors.values())if (editor.editorType === type) editor.show(visible);
        const state = this.#showAllStates?.get($9ef033443a74bee6$export$cf3df2a6ecc26692.HIGHLIGHT_SHOW_ALL) ?? true;
        if (state !== visible) this.#dispatchUpdateUI([
            [
                $9ef033443a74bee6$export$cf3df2a6ecc26692.HIGHLIGHT_SHOW_ALL,
                visible
            ]
        ]);
    }
    enableWaiting(mustWait = false) {
        if (this.#isWaiting === mustWait) return;
        this.#isWaiting = mustWait;
        for (const layer of this.#allLayers.values()){
            if (mustWait) layer.disableClick();
            else layer.enableClick();
            layer.div.classList.toggle("waiting", mustWait);
        }
    }
    async #enableAll() {
        if (!this.#isEnabled) {
            this.#isEnabled = true;
            const promises = [];
            for (const layer of this.#allLayers.values())promises.push(layer.enable());
            await Promise.all(promises);
            for (const editor of this.#allEditors.values())editor.enable();
        }
    }
    #disableAll() {
        this.unselectAll();
        if (this.#isEnabled) {
            this.#isEnabled = false;
            for (const layer of this.#allLayers.values())layer.disable();
            for (const editor of this.#allEditors.values())editor.disable();
        }
    }
    *getEditors(pageIndex) {
        for (const editor of this.#allEditors.values())if (editor.pageIndex === pageIndex) yield editor;
    }
    getEditor(id) {
        return this.#allEditors.get(id);
    }
    addEditor(editor) {
        this.#allEditors.set(editor.id, editor);
    }
    removeEditor(editor) {
        if (editor.div.contains(document.activeElement)) {
            if (this.#focusMainContainerTimeoutId) clearTimeout(this.#focusMainContainerTimeoutId);
            this.#focusMainContainerTimeoutId = setTimeout(()=>{
                this.focusMainContainer();
                this.#focusMainContainerTimeoutId = null;
            }, 0);
        }
        this.#allEditors.delete(editor.id);
        if (editor.annotationElementId) this.#missingCanvases?.delete(editor.annotationElementId);
        this.unselect(editor);
        if (!editor.annotationElementId || !this.#deletedAnnotationsElementIds.has(editor.annotationElementId)) this.#annotationStorage?.remove(editor.id);
    }
    addDeletedAnnotationElement(editor) {
        this.#deletedAnnotationsElementIds.add(editor.annotationElementId);
        this.addChangedExistingAnnotation(editor);
        editor.deleted = true;
    }
    isDeletedAnnotationElement(annotationElementId) {
        return this.#deletedAnnotationsElementIds.has(annotationElementId);
    }
    removeDeletedAnnotationElement(editor) {
        this.#deletedAnnotationsElementIds.delete(editor.annotationElementId);
        this.removeChangedExistingAnnotation(editor);
        editor.deleted = false;
    }
    #addEditorToLayer(editor) {
        const layer = this.#allLayers.get(editor.pageIndex);
        if (layer) layer.addOrRebuild(editor);
        else {
            this.addEditor(editor);
            this.addToAnnotationStorage(editor);
        }
    }
    setActiveEditor(editor) {
        if (this.#activeEditor === editor) return;
        this.#activeEditor = editor;
        if (editor) this.#dispatchUpdateUI(editor.propertiesToUpdate);
    }
    get #lastSelectedEditor() {
        let ed = null;
        for (ed of this.#selectedEditors);
        return ed;
    }
    updateUI(editor) {
        if (this.#lastSelectedEditor === editor) this.#dispatchUpdateUI(editor.propertiesToUpdate);
    }
    updateUIForDefaultProperties(editorType) {
        this.#dispatchUpdateUI(editorType.defaultPropertiesToUpdate);
    }
    toggleSelected(editor) {
        if (this.#selectedEditors.has(editor)) {
            this.#selectedEditors.delete(editor);
            editor.unselect();
            this.#dispatchUpdateStates({
                hasSelectedEditor: this.hasSelection
            });
            return;
        }
        this.#selectedEditors.add(editor);
        editor.select();
        this.#dispatchUpdateUI(editor.propertiesToUpdate);
        this.#dispatchUpdateStates({
            hasSelectedEditor: true
        });
    }
    setSelected(editor) {
        this.updateToolbar({
            mode: editor.mode,
            editId: editor.id
        });
        this.#currentDrawingSession?.commitOrRemove();
        for (const ed of this.#selectedEditors)if (ed !== editor) ed.unselect();
        this.#selectedEditors.clear();
        this.#selectedEditors.add(editor);
        editor.select();
        this.#dispatchUpdateUI(editor.propertiesToUpdate);
        this.#dispatchUpdateStates({
            hasSelectedEditor: true
        });
    }
    isSelected(editor) {
        return this.#selectedEditors.has(editor);
    }
    get firstSelectedEditor() {
        return this.#selectedEditors.values().next().value;
    }
    unselect(editor) {
        editor.unselect();
        this.#selectedEditors.delete(editor);
        this.#dispatchUpdateStates({
            hasSelectedEditor: this.hasSelection
        });
    }
    get hasSelection() {
        return this.#selectedEditors.size !== 0;
    }
    get isEnterHandled() {
        return this.#selectedEditors.size === 1 && this.firstSelectedEditor.isEnterHandled;
    }
    undo() {
        this.#commandManager.undo();
        this.#dispatchUpdateStates({
            hasSomethingToUndo: this.#commandManager.hasSomethingToUndo(),
            hasSomethingToRedo: true,
            isEmpty: this.#isEmpty()
        });
        this._editorUndoBar?.hide();
    }
    redo() {
        this.#commandManager.redo();
        this.#dispatchUpdateStates({
            hasSomethingToUndo: true,
            hasSomethingToRedo: this.#commandManager.hasSomethingToRedo(),
            isEmpty: this.#isEmpty()
        });
    }
    addCommands(params) {
        this.#commandManager.add(params);
        this.#dispatchUpdateStates({
            hasSomethingToUndo: true,
            hasSomethingToRedo: false,
            isEmpty: this.#isEmpty()
        });
    }
    cleanUndoStack(type) {
        this.#commandManager.cleanType(type);
    }
    #isEmpty() {
        if (this.#allEditors.size === 0) return true;
        if (this.#allEditors.size === 1) {
            for (const editor of this.#allEditors.values())return editor.isEmpty();
        }
        return false;
    }
    delete() {
        this.commitOrRemove();
        const drawingEditor = this.currentLayer?.endDrawingSession(true);
        if (!this.hasSelection && !drawingEditor) return;
        const editors = drawingEditor ? [
            drawingEditor
        ] : [
            ...this.#selectedEditors
        ];
        const cmd = ()=>{
            this._editorUndoBar?.show(undo, editors.length === 1 ? editors[0].editorType : editors.length);
            for (const editor of editors)editor.remove();
        };
        const undo = ()=>{
            for (const editor of editors)this.#addEditorToLayer(editor);
        };
        this.addCommands({
            cmd: cmd,
            undo: undo,
            mustExec: true
        });
    }
    commitOrRemove() {
        this.#activeEditor?.commitOrRemove();
    }
    hasSomethingToControl() {
        return this.#activeEditor || this.hasSelection;
    }
    #selectEditors(editors) {
        for (const editor of this.#selectedEditors)editor.unselect();
        this.#selectedEditors.clear();
        for (const editor of editors){
            if (editor.isEmpty()) continue;
            this.#selectedEditors.add(editor);
            editor.select();
        }
        this.#dispatchUpdateStates({
            hasSelectedEditor: this.hasSelection
        });
    }
    selectAll() {
        for (const editor of this.#selectedEditors)editor.commit();
        this.#selectEditors(this.#allEditors.values());
    }
    unselectAll() {
        if (this.#activeEditor) {
            this.#activeEditor.commitOrRemove();
            if (this.#mode !== $9ef033443a74bee6$export$72ea3bfdd9a725bf.NONE) return;
        }
        if (this.#currentDrawingSession?.commitOrRemove()) return;
        if (!this.hasSelection) return;
        for (const editor of this.#selectedEditors)editor.unselect();
        this.#selectedEditors.clear();
        this.#dispatchUpdateStates({
            hasSelectedEditor: false
        });
    }
    translateSelectedEditors(x, y, noCommit = false) {
        if (!noCommit) this.commitOrRemove();
        if (!this.hasSelection) return;
        this.#translation[0] += x;
        this.#translation[1] += y;
        const [totalX, totalY] = this.#translation;
        const editors = [
            ...this.#selectedEditors
        ];
        const TIME_TO_WAIT = 1000;
        if (this.#translationTimeoutId) clearTimeout(this.#translationTimeoutId);
        this.#translationTimeoutId = setTimeout(()=>{
            this.#translationTimeoutId = null;
            this.#translation[0] = this.#translation[1] = 0;
            this.addCommands({
                cmd: ()=>{
                    for (const editor of editors)if (this.#allEditors.has(editor.id)) {
                        editor.translateInPage(totalX, totalY);
                        editor.translationDone();
                    }
                },
                undo: ()=>{
                    for (const editor of editors)if (this.#allEditors.has(editor.id)) {
                        editor.translateInPage(-totalX, -totalY);
                        editor.translationDone();
                    }
                },
                mustExec: false
            });
        }, TIME_TO_WAIT);
        for (const editor of editors){
            editor.translateInPage(x, y);
            editor.translationDone();
        }
    }
    setUpDragSession() {
        if (!this.hasSelection) return;
        this.disableUserSelect(true);
        this.#draggingEditors = new Map();
        for (const editor of this.#selectedEditors)this.#draggingEditors.set(editor, {
            savedX: editor.x,
            savedY: editor.y,
            savedPageIndex: editor.pageIndex,
            newX: 0,
            newY: 0,
            newPageIndex: -1
        });
    }
    endDragSession() {
        if (!this.#draggingEditors) return false;
        this.disableUserSelect(false);
        const map = this.#draggingEditors;
        this.#draggingEditors = null;
        let mustBeAddedInUndoStack = false;
        for (const [{ x: x, y: y, pageIndex: pageIndex }, value] of map){
            value.newX = x;
            value.newY = y;
            value.newPageIndex = pageIndex;
            mustBeAddedInUndoStack ||= x !== value.savedX || y !== value.savedY || pageIndex !== value.savedPageIndex;
        }
        if (!mustBeAddedInUndoStack) return false;
        const move = (editor, x, y, pageIndex)=>{
            if (this.#allEditors.has(editor.id)) {
                const parent = this.#allLayers.get(pageIndex);
                if (parent) editor._setParentAndPosition(parent, x, y);
                else {
                    editor.pageIndex = pageIndex;
                    editor.x = x;
                    editor.y = y;
                }
            }
        };
        this.addCommands({
            cmd: ()=>{
                for (const [editor, { newX: newX, newY: newY, newPageIndex: newPageIndex }] of map)move(editor, newX, newY, newPageIndex);
            },
            undo: ()=>{
                for (const [editor, { savedX: savedX, savedY: savedY, savedPageIndex: savedPageIndex }] of map)move(editor, savedX, savedY, savedPageIndex);
            },
            mustExec: true
        });
        return true;
    }
    dragSelectedEditors(tx, ty) {
        if (!this.#draggingEditors) return;
        for (const editor of this.#draggingEditors.keys())editor.drag(tx, ty);
    }
    rebuild(editor) {
        if (editor.parent === null) {
            const parent = this.getLayer(editor.pageIndex);
            if (parent) {
                parent.changeParent(editor);
                parent.addOrRebuild(editor);
            } else {
                this.addEditor(editor);
                this.addToAnnotationStorage(editor);
                editor.rebuild();
            }
        } else editor.parent.addOrRebuild(editor);
    }
    get isEditorHandlingKeyboard() {
        return this.getActive()?.shouldGetKeyboardEvents() || this.#selectedEditors.size === 1 && this.firstSelectedEditor.shouldGetKeyboardEvents();
    }
    isActive(editor) {
        return this.#activeEditor === editor;
    }
    getActive() {
        return this.#activeEditor;
    }
    getMode() {
        return this.#mode;
    }
    isEditingMode() {
        return this.#mode !== $9ef033443a74bee6$export$72ea3bfdd9a725bf.NONE;
    }
    get imageManager() {
        return $9ef033443a74bee6$export$b8972b998723d602(this, "imageManager", new $9ef033443a74bee6$var$ImageManager());
    }
    getSelectionBoxes(textLayer) {
        if (!textLayer) return null;
        const selection = document.getSelection();
        for(let i = 0, ii = selection.rangeCount; i < ii; i++){
            if (!textLayer.contains(selection.getRangeAt(i).commonAncestorContainer)) return null;
        }
        const { x: layerX, y: layerY, width: parentWidth, height: parentHeight } = textLayer.getBoundingClientRect();
        let rotator;
        switch(textLayer.getAttribute("data-main-rotation")){
            case "90":
                rotator = (x, y, w, h)=>({
                        x: (y - layerY) / parentHeight,
                        y: 1 - (x + w - layerX) / parentWidth,
                        width: h / parentHeight,
                        height: w / parentWidth
                    });
                break;
            case "180":
                rotator = (x, y, w, h)=>({
                        x: 1 - (x + w - layerX) / parentWidth,
                        y: 1 - (y + h - layerY) / parentHeight,
                        width: w / parentWidth,
                        height: h / parentHeight
                    });
                break;
            case "270":
                rotator = (x, y, w, h)=>({
                        x: 1 - (y + h - layerY) / parentHeight,
                        y: (x - layerX) / parentWidth,
                        width: h / parentHeight,
                        height: w / parentWidth
                    });
                break;
            default:
                rotator = (x, y, w, h)=>({
                        x: (x - layerX) / parentWidth,
                        y: (y - layerY) / parentHeight,
                        width: w / parentWidth,
                        height: h / parentHeight
                    });
                break;
        }
        const boxes = [];
        for(let i = 0, ii = selection.rangeCount; i < ii; i++){
            const range = selection.getRangeAt(i);
            if (range.collapsed) continue;
            for (const { x: x, y: y, width: width, height: height } of range.getClientRects()){
                if (width === 0 || height === 0) continue;
                boxes.push(rotator(x, y, width, height));
            }
        }
        return boxes.length === 0 ? null : boxes;
    }
    addChangedExistingAnnotation({ annotationElementId: annotationElementId, id: id }) {
        (this.#changedExistingAnnotations ||= new Map()).set(annotationElementId, id);
    }
    removeChangedExistingAnnotation({ annotationElementId: annotationElementId }) {
        this.#changedExistingAnnotations?.delete(annotationElementId);
    }
    renderAnnotationElement(annotation) {
        const editorId = this.#changedExistingAnnotations?.get(annotation.data.id);
        if (!editorId) return;
        const editor = this.#annotationStorage.getRawValue(editorId);
        if (!editor) return;
        if (this.#mode === $9ef033443a74bee6$export$72ea3bfdd9a725bf.NONE && !editor.hasBeenModified) return;
        editor.renderAnnotationElement(annotation);
    }
    setMissingCanvas(annotationId, annotationElementId, canvas) {
        const editor = this.#missingCanvases?.get(annotationId);
        if (!editor) return;
        editor.setCanvas(annotationElementId, canvas);
        this.#missingCanvases.delete(annotationId);
    }
    addMissingCanvas(annotationId, editor) {
        (this.#missingCanvases ||= new Map()).set(annotationId, editor);
    }
}
class $9ef033443a74bee6$var$AltText {
    #altText = null;
    #altTextDecorative = false;
    #altTextButton = null;
    #altTextButtonLabel = null;
    #altTextTooltip = null;
    #altTextTooltipTimeout = null;
    #altTextWasFromKeyBoard = false;
    #badge = null;
    #editor = null;
    #guessedText = null;
    #textWithDisclaimer = null;
    #useNewAltTextFlow = false;
    static #l10nNewButton = null;
    static _l10n = null;
    constructor(editor){
        this.#editor = editor;
        this.#useNewAltTextFlow = editor._uiManager.useNewAltTextFlow;
        $9ef033443a74bee6$var$AltText.#l10nNewButton ||= Object.freeze({
            added: "pdfjs-editor-new-alt-text-added-button",
            "added-label": "pdfjs-editor-new-alt-text-added-button-label",
            missing: "pdfjs-editor-new-alt-text-missing-button",
            "missing-label": "pdfjs-editor-new-alt-text-missing-button-label",
            review: "pdfjs-editor-new-alt-text-to-review-button",
            "review-label": "pdfjs-editor-new-alt-text-to-review-button-label"
        });
    }
    static initialize(l10n) {
        $9ef033443a74bee6$var$AltText._l10n ??= l10n;
    }
    async render() {
        const altText = this.#altTextButton = document.createElement("button");
        altText.className = "altText";
        altText.tabIndex = "0";
        const label = this.#altTextButtonLabel = document.createElement("span");
        altText.append(label);
        if (this.#useNewAltTextFlow) {
            altText.classList.add("new");
            altText.setAttribute("data-l10n-id", $9ef033443a74bee6$var$AltText.#l10nNewButton.missing);
            label.setAttribute("data-l10n-id", $9ef033443a74bee6$var$AltText.#l10nNewButton["missing-label"]);
        } else {
            altText.setAttribute("data-l10n-id", "pdfjs-editor-alt-text-button");
            label.setAttribute("data-l10n-id", "pdfjs-editor-alt-text-button-label");
        }
        const signal = this.#editor._uiManager._signal;
        altText.addEventListener("contextmenu", $9ef033443a74bee6$export$455b7811f904cadc, {
            signal: signal
        });
        altText.addEventListener("pointerdown", (event)=>event.stopPropagation(), {
            signal: signal
        });
        const onClick = (event)=>{
            event.preventDefault();
            this.#editor._uiManager.editAltText(this.#editor);
            if (this.#useNewAltTextFlow) this.#editor._reportTelemetry({
                action: "pdfjs.image.alt_text.image_status_label_clicked",
                data: {
                    label: this.#label
                }
            });
        };
        altText.addEventListener("click", onClick, {
            capture: true,
            signal: signal
        });
        altText.addEventListener("keydown", (event)=>{
            if (event.target === altText && event.key === "Enter") {
                this.#altTextWasFromKeyBoard = true;
                onClick(event);
            }
        }, {
            signal: signal
        });
        await this.#setState();
        return altText;
    }
    get #label() {
        return this.#altText && "added" || this.#altText === null && this.guessedText && "review" || "missing";
    }
    finish() {
        if (!this.#altTextButton) return;
        this.#altTextButton.focus({
            focusVisible: this.#altTextWasFromKeyBoard
        });
        this.#altTextWasFromKeyBoard = false;
    }
    isEmpty() {
        if (this.#useNewAltTextFlow) return this.#altText === null;
        return !this.#altText && !this.#altTextDecorative;
    }
    hasData() {
        if (this.#useNewAltTextFlow) return this.#altText !== null || !!this.#guessedText;
        return this.isEmpty();
    }
    get guessedText() {
        return this.#guessedText;
    }
    async setGuessedText(guessedText) {
        if (this.#altText !== null) return;
        this.#guessedText = guessedText;
        this.#textWithDisclaimer = await $9ef033443a74bee6$var$AltText._l10n.get("pdfjs-editor-new-alt-text-generated-alt-text-with-disclaimer", {
            generatedAltText: guessedText
        });
        this.#setState();
    }
    toggleAltTextBadge(visibility = false) {
        if (!this.#useNewAltTextFlow || this.#altText) {
            this.#badge?.remove();
            this.#badge = null;
            return;
        }
        if (!this.#badge) {
            const badge = this.#badge = document.createElement("div");
            badge.className = "noAltTextBadge";
            this.#editor.div.append(badge);
        }
        this.#badge.classList.toggle("hidden", !visibility);
    }
    serialize(isForCopying) {
        let altText = this.#altText;
        if (!isForCopying && this.#guessedText === altText) altText = this.#textWithDisclaimer;
        return {
            altText: altText,
            decorative: this.#altTextDecorative,
            guessedText: this.#guessedText,
            textWithDisclaimer: this.#textWithDisclaimer
        };
    }
    get data() {
        return {
            altText: this.#altText,
            decorative: this.#altTextDecorative
        };
    }
    set data({ altText: altText, decorative: decorative, guessedText: guessedText, textWithDisclaimer: textWithDisclaimer, cancel: cancel = false }) {
        if (guessedText) {
            this.#guessedText = guessedText;
            this.#textWithDisclaimer = textWithDisclaimer;
        }
        if (this.#altText === altText && this.#altTextDecorative === decorative) return;
        if (!cancel) {
            this.#altText = altText;
            this.#altTextDecorative = decorative;
        }
        this.#setState();
    }
    toggle(enabled = false) {
        if (!this.#altTextButton) return;
        if (!enabled && this.#altTextTooltipTimeout) {
            clearTimeout(this.#altTextTooltipTimeout);
            this.#altTextTooltipTimeout = null;
        }
        this.#altTextButton.disabled = !enabled;
    }
    shown() {
        this.#editor._reportTelemetry({
            action: "pdfjs.image.alt_text.image_status_label_displayed",
            data: {
                label: this.#label
            }
        });
    }
    destroy() {
        this.#altTextButton?.remove();
        this.#altTextButton = null;
        this.#altTextButtonLabel = null;
        this.#altTextTooltip = null;
        this.#badge?.remove();
        this.#badge = null;
    }
    async #setState() {
        const button = this.#altTextButton;
        if (!button) return;
        if (this.#useNewAltTextFlow) {
            button.classList.toggle("done", !!this.#altText);
            button.setAttribute("data-l10n-id", $9ef033443a74bee6$var$AltText.#l10nNewButton[this.#label]);
            this.#altTextButtonLabel?.setAttribute("data-l10n-id", $9ef033443a74bee6$var$AltText.#l10nNewButton[`${this.#label}-label`]);
            if (!this.#altText) {
                this.#altTextTooltip?.remove();
                return;
            }
        } else {
            if (!this.#altText && !this.#altTextDecorative) {
                button.classList.remove("done");
                this.#altTextTooltip?.remove();
                return;
            }
            button.classList.add("done");
            button.setAttribute("data-l10n-id", "pdfjs-editor-alt-text-edit-button");
        }
        let tooltip = this.#altTextTooltip;
        if (!tooltip) {
            this.#altTextTooltip = tooltip = document.createElement("span");
            tooltip.className = "tooltip";
            tooltip.setAttribute("role", "tooltip");
            tooltip.id = `alt-text-tooltip-${this.#editor.id}`;
            const DELAY_TO_SHOW_TOOLTIP = 100;
            const signal = this.#editor._uiManager._signal;
            signal.addEventListener("abort", ()=>{
                clearTimeout(this.#altTextTooltipTimeout);
                this.#altTextTooltipTimeout = null;
            }, {
                once: true
            });
            button.addEventListener("mouseenter", ()=>{
                this.#altTextTooltipTimeout = setTimeout(()=>{
                    this.#altTextTooltipTimeout = null;
                    this.#altTextTooltip.classList.add("show");
                    this.#editor._reportTelemetry({
                        action: "alt_text_tooltip"
                    });
                }, DELAY_TO_SHOW_TOOLTIP);
            }, {
                signal: signal
            });
            button.addEventListener("mouseleave", ()=>{
                if (this.#altTextTooltipTimeout) {
                    clearTimeout(this.#altTextTooltipTimeout);
                    this.#altTextTooltipTimeout = null;
                }
                this.#altTextTooltip?.classList.remove("show");
            }, {
                signal: signal
            });
        }
        if (this.#altTextDecorative) tooltip.setAttribute("data-l10n-id", "pdfjs-editor-alt-text-decorative-tooltip");
        else {
            tooltip.removeAttribute("data-l10n-id");
            tooltip.textContent = this.#altText;
        }
        if (!tooltip.parentNode) button.append(tooltip);
        const element = this.#editor.getElementForAltText();
        element?.setAttribute("aria-describedby", tooltip.id);
    }
}
class $9ef033443a74bee6$var$Comment {
    #commentStandaloneButton = null;
    #commentToolbarButton = null;
    #commentWasFromKeyBoard = false;
    #editor = null;
    #initialText = null;
    #richText = null;
    #text = null;
    #date = null;
    #deleted = false;
    #popupPosition = null;
    constructor(editor){
        this.#editor = editor;
    }
    renderForToolbar() {
        const button = this.#commentToolbarButton = document.createElement("button");
        button.className = "comment";
        return this.#render(button, false);
    }
    renderForStandalone() {
        const button = this.#commentStandaloneButton = document.createElement("button");
        button.className = "annotationCommentButton";
        const position = this.#editor.commentButtonPosition;
        if (position) {
            const { style: style } = button;
            style.insetInlineEnd = `calc(${100 * (this.#editor._uiManager.direction === "ltr" ? 1 - position[0] : position[0])}% - var(--comment-button-dim))`;
            style.top = `calc(${100 * position[1]}% - var(--comment-button-dim))`;
            const color = this.#editor.commentButtonColor;
            if (color) style.backgroundColor = color;
        }
        return this.#render(button, true);
    }
    focusButton() {
        setTimeout(()=>{
            (this.#commentStandaloneButton ?? this.#commentToolbarButton)?.focus();
        }, 0);
    }
    onUpdatedColor() {
        if (!this.#commentStandaloneButton) return;
        const color = this.#editor.commentButtonColor;
        if (color) this.#commentStandaloneButton.style.backgroundColor = color;
        this.#editor._uiManager.updatePopupColor(this.#editor);
    }
    get commentButtonWidth() {
        return (this.#commentStandaloneButton?.getBoundingClientRect().width ?? 0) / this.#editor.parent.boundingClientRect.width;
    }
    get commentPopupPositionInLayer() {
        if (this.#popupPosition) return this.#popupPosition;
        if (!this.#commentStandaloneButton) return null;
        const { x: x, y: y, height: height } = this.#commentStandaloneButton.getBoundingClientRect();
        const { x: parentX, y: parentY, width: parentWidth, height: parentHeight } = this.#editor.parent.boundingClientRect;
        return [
            (x - parentX) / parentWidth,
            (y + height - parentY) / parentHeight
        ];
    }
    set commentPopupPositionInLayer(pos) {
        this.#popupPosition = pos;
    }
    hasDefaultPopupPosition() {
        return this.#popupPosition === null;
    }
    removeStandaloneCommentButton() {
        this.#commentStandaloneButton?.remove();
        this.#commentStandaloneButton = null;
    }
    removeToolbarCommentButton() {
        this.#commentToolbarButton?.remove();
        this.#commentToolbarButton = null;
    }
    setCommentButtonStates({ selected: selected, hasPopup: hasPopup }) {
        if (!this.#commentStandaloneButton) return;
        this.#commentStandaloneButton.classList.toggle("selected", selected);
        this.#commentStandaloneButton.ariaExpanded = hasPopup;
    }
    #render(comment, isStandalone) {
        if (!this.#editor._uiManager.hasCommentManager()) return null;
        comment.tabIndex = "0";
        comment.ariaHasPopup = "dialog";
        if (isStandalone) {
            comment.ariaControls = "commentPopup";
            comment.setAttribute("data-l10n-id", "pdfjs-show-comment-button");
        } else {
            comment.ariaControlsElements = [
                this.#editor._uiManager.getCommentDialogElement()
            ];
            comment.setAttribute("data-l10n-id", "pdfjs-editor-edit-comment-button");
        }
        const signal = this.#editor._uiManager._signal;
        if (!(signal instanceof AbortSignal) || signal.aborted) return comment;
        comment.addEventListener("contextmenu", $9ef033443a74bee6$export$455b7811f904cadc, {
            signal: signal
        });
        if (isStandalone) {
            comment.addEventListener("focusin", (e)=>{
                this.#editor._focusEventsAllowed = false;
                $9ef033443a74bee6$export$7ae4cd3a66c1e050(e);
            }, {
                capture: true,
                signal: signal
            });
            comment.addEventListener("focusout", (e)=>{
                this.#editor._focusEventsAllowed = true;
                $9ef033443a74bee6$export$7ae4cd3a66c1e050(e);
            }, {
                capture: true,
                signal: signal
            });
        }
        comment.addEventListener("pointerdown", (event)=>event.stopPropagation(), {
            signal: signal
        });
        const onClick = (event)=>{
            event.preventDefault();
            if (comment === this.#commentToolbarButton) this.edit();
            else this.#editor.toggleComment(true);
        };
        comment.addEventListener("click", onClick, {
            capture: true,
            signal: signal
        });
        comment.addEventListener("keydown", (event)=>{
            if (event.target === comment && event.key === "Enter") {
                this.#commentWasFromKeyBoard = true;
                onClick(event);
            }
        }, {
            signal: signal
        });
        comment.addEventListener("pointerenter", ()=>{
            this.#editor.toggleComment(false, true);
        }, {
            signal: signal
        });
        comment.addEventListener("pointerleave", ()=>{
            this.#editor.toggleComment(false, false);
        }, {
            signal: signal
        });
        return comment;
    }
    edit(options) {
        const position = this.commentPopupPositionInLayer;
        let posX, posY;
        if (position) [posX, posY] = position;
        else {
            [posX, posY] = this.#editor.commentButtonPosition;
            const { width: width, height: height, x: x, y: y } = this.#editor;
            posX = x + posX * width;
            posY = y + posY * height;
        }
        const parentDimensions = this.#editor.parent.boundingClientRect;
        const { x: parentX, y: parentY, width: parentWidth, height: parentHeight } = parentDimensions;
        this.#editor._uiManager.editComment(this.#editor, parentX + posX * parentWidth, parentY + posY * parentHeight, {
            ...options,
            parentDimensions: parentDimensions
        });
    }
    finish() {
        if (!this.#commentToolbarButton) return;
        this.#commentToolbarButton.focus({
            focusVisible: this.#commentWasFromKeyBoard
        });
        this.#commentWasFromKeyBoard = false;
    }
    isDeleted() {
        return this.#deleted || this.#text === "";
    }
    isEmpty() {
        return this.#text === null;
    }
    hasBeenEdited() {
        return this.isDeleted() || this.#text !== this.#initialText;
    }
    serialize() {
        return this.data;
    }
    get data() {
        return {
            text: this.#text,
            richText: this.#richText,
            date: this.#date,
            deleted: this.isDeleted()
        };
    }
    set data(text) {
        if (text !== this.#text) this.#richText = null;
        if (text === null) {
            this.#text = "";
            this.#deleted = true;
            return;
        }
        this.#text = text;
        this.#date = new Date();
        this.#deleted = false;
    }
    setInitialText(text, richText = null) {
        this.#initialText = text;
        this.data = text;
        this.#date = null;
        this.#richText = richText;
    }
    shown() {}
    destroy() {
        this.#commentToolbarButton?.remove();
        this.#commentToolbarButton = null;
        this.#commentStandaloneButton?.remove();
        this.#commentStandaloneButton = null;
        this.#text = "";
        this.#richText = null;
        this.#date = null;
        this.#editor = null;
        this.#commentWasFromKeyBoard = false;
        this.#deleted = false;
    }
}
class $9ef033443a74bee6$export$9ae7542b430d543e {
    #container;
    #isPinching = false;
    #isPinchingStopped = null;
    #isPinchingDisabled;
    #onPinchStart;
    #onPinching;
    #onPinchEnd;
    #pointerDownAC = null;
    #signal;
    #touchInfo = null;
    #touchManagerAC;
    #touchMoveAC = null;
    constructor({ container: container, isPinchingDisabled: isPinchingDisabled = null, isPinchingStopped: isPinchingStopped = null, onPinchStart: onPinchStart = null, onPinching: onPinching = null, onPinchEnd: onPinchEnd = null, signal: signal }){
        this.#container = container;
        this.#isPinchingStopped = isPinchingStopped;
        this.#isPinchingDisabled = isPinchingDisabled;
        this.#onPinchStart = onPinchStart;
        this.#onPinching = onPinching;
        this.#onPinchEnd = onPinchEnd;
        this.#touchManagerAC = new AbortController();
        this.#signal = AbortSignal.any([
            signal,
            this.#touchManagerAC.signal
        ]);
        container.addEventListener("touchstart", this.#onTouchStart.bind(this), {
            passive: false,
            signal: this.#signal
        });
    }
    get MIN_TOUCH_DISTANCE_TO_PINCH() {
        return 35 / $9ef033443a74bee6$export$f16a99f63bccd50b.pixelRatio;
    }
    #onTouchStart(evt) {
        if (this.#isPinchingDisabled?.()) return;
        if (evt.touches.length === 1) {
            if (this.#pointerDownAC) return;
            const pointerDownAC = this.#pointerDownAC = new AbortController();
            const signal = AbortSignal.any([
                this.#signal,
                pointerDownAC.signal
            ]);
            const container = this.#container;
            const opts = {
                capture: true,
                signal: signal,
                passive: false
            };
            const cancelPointerDown = (e)=>{
                if (e.pointerType === "touch") {
                    this.#pointerDownAC?.abort();
                    this.#pointerDownAC = null;
                }
            };
            container.addEventListener("pointerdown", (e)=>{
                if (e.pointerType === "touch") {
                    $9ef033443a74bee6$export$7ae4cd3a66c1e050(e);
                    cancelPointerDown(e);
                }
            }, opts);
            container.addEventListener("pointerup", cancelPointerDown, opts);
            container.addEventListener("pointercancel", cancelPointerDown, opts);
            return;
        }
        if (!this.#touchMoveAC) {
            this.#touchMoveAC = new AbortController();
            const signal = AbortSignal.any([
                this.#signal,
                this.#touchMoveAC.signal
            ]);
            const container = this.#container;
            const opt = {
                signal: signal,
                capture: false,
                passive: false
            };
            container.addEventListener("touchmove", this.#onTouchMove.bind(this), opt);
            const onTouchEnd = this.#onTouchEnd.bind(this);
            container.addEventListener("touchend", onTouchEnd, opt);
            container.addEventListener("touchcancel", onTouchEnd, opt);
            opt.capture = true;
            container.addEventListener("pointerdown", $9ef033443a74bee6$export$7ae4cd3a66c1e050, opt);
            container.addEventListener("pointermove", $9ef033443a74bee6$export$7ae4cd3a66c1e050, opt);
            container.addEventListener("pointercancel", $9ef033443a74bee6$export$7ae4cd3a66c1e050, opt);
            container.addEventListener("pointerup", $9ef033443a74bee6$export$7ae4cd3a66c1e050, opt);
            this.#onPinchStart?.();
        }
        $9ef033443a74bee6$export$7ae4cd3a66c1e050(evt);
        if (evt.touches.length !== 2 || this.#isPinchingStopped?.()) {
            this.#touchInfo = null;
            return;
        }
        let [touch0, touch1] = evt.touches;
        if (touch0.identifier > touch1.identifier) [touch0, touch1] = [
            touch1,
            touch0
        ];
        this.#touchInfo = {
            touch0X: touch0.screenX,
            touch0Y: touch0.screenY,
            touch1X: touch1.screenX,
            touch1Y: touch1.screenY
        };
    }
    #onTouchMove(evt) {
        if (!this.#touchInfo || evt.touches.length !== 2) return;
        $9ef033443a74bee6$export$7ae4cd3a66c1e050(evt);
        let [touch0, touch1] = evt.touches;
        if (touch0.identifier > touch1.identifier) [touch0, touch1] = [
            touch1,
            touch0
        ];
        const { screenX: screen0X, screenY: screen0Y } = touch0;
        const { screenX: screen1X, screenY: screen1Y } = touch1;
        const touchInfo = this.#touchInfo;
        const { touch0X: pTouch0X, touch0Y: pTouch0Y, touch1X: pTouch1X, touch1Y: pTouch1Y } = touchInfo;
        const prevGapX = pTouch1X - pTouch0X;
        const prevGapY = pTouch1Y - pTouch0Y;
        const currGapX = screen1X - screen0X;
        const currGapY = screen1Y - screen0Y;
        const distance = Math.hypot(currGapX, currGapY) || 1;
        const pDistance = Math.hypot(prevGapX, prevGapY) || 1;
        if (!this.#isPinching && Math.abs(pDistance - distance) <= $9ef033443a74bee6$export$9ae7542b430d543e.MIN_TOUCH_DISTANCE_TO_PINCH) return;
        touchInfo.touch0X = screen0X;
        touchInfo.touch0Y = screen0Y;
        touchInfo.touch1X = screen1X;
        touchInfo.touch1Y = screen1Y;
        if (!this.#isPinching) {
            this.#isPinching = true;
            return;
        }
        const origin = [
            (screen0X + screen1X) / 2,
            (screen0Y + screen1Y) / 2
        ];
        this.#onPinching?.(origin, pDistance, distance);
    }
    #onTouchEnd(evt) {
        if (evt.touches.length >= 2) return;
        if (this.#touchMoveAC) {
            this.#touchMoveAC.abort();
            this.#touchMoveAC = null;
            this.#onPinchEnd?.();
        }
        if (!this.#touchInfo) return;
        $9ef033443a74bee6$export$7ae4cd3a66c1e050(evt);
        this.#touchInfo = null;
        this.#isPinching = false;
    }
    destroy() {
        this.#touchManagerAC?.abort();
        this.#touchManagerAC = null;
        this.#pointerDownAC?.abort();
        this.#pointerDownAC = null;
    }
}
class $9ef033443a74bee6$var$AnnotationEditor {
    #accessibilityData = null;
    #allResizerDivs = null;
    #altText = null;
    #comment = null;
    #commentStandaloneButton = null;
    #disabled = false;
    #dragPointerId = null;
    #dragPointerType = "";
    #resizersDiv = null;
    #lastPointerCoords = null;
    #savedDimensions = null;
    #fakeAnnotation = null;
    #focusAC = null;
    #focusedResizerName = "";
    #hasBeenClicked = false;
    #initialRect = null;
    #isEditing = false;
    #isInEditMode = false;
    #isResizerEnabledForKeyboard = false;
    #moveInDOMTimeout = null;
    #prevDragX = 0;
    #prevDragY = 0;
    #telemetryTimeouts = null;
    #touchManager = null;
    isSelected = false;
    _isCopy = false;
    _editToolbar = null;
    _initialOptions = Object.create(null);
    _initialData = null;
    _isVisible = true;
    _uiManager = null;
    _focusEventsAllowed = true;
    static _l10n = null;
    static _l10nResizer = null;
    #isDraggable = false;
    #zIndex = $9ef033443a74bee6$var$AnnotationEditor._zIndex++;
    static _borderLineWidth = -1;
    static _colorManager = new $9ef033443a74bee6$var$ColorManager();
    static _zIndex = 1;
    static _telemetryTimeout = 1000;
    static get _resizerKeyboardManager() {
        const resize = $9ef033443a74bee6$var$AnnotationEditor.prototype._resizeWithKeyboard;
        const small = $9ef033443a74bee6$export$26cb16552a82cf63.TRANSLATE_SMALL;
        const big = $9ef033443a74bee6$export$26cb16552a82cf63.TRANSLATE_BIG;
        return $9ef033443a74bee6$export$b8972b998723d602(this, "_resizerKeyboardManager", new $9ef033443a74bee6$var$KeyboardManager([
            [
                [
                    "ArrowLeft",
                    "mac+ArrowLeft"
                ],
                resize,
                {
                    args: [
                        -small,
                        0
                    ]
                }
            ],
            [
                [
                    "ctrl+ArrowLeft",
                    "mac+shift+ArrowLeft"
                ],
                resize,
                {
                    args: [
                        -big,
                        0
                    ]
                }
            ],
            [
                [
                    "ArrowRight",
                    "mac+ArrowRight"
                ],
                resize,
                {
                    args: [
                        small,
                        0
                    ]
                }
            ],
            [
                [
                    "ctrl+ArrowRight",
                    "mac+shift+ArrowRight"
                ],
                resize,
                {
                    args: [
                        big,
                        0
                    ]
                }
            ],
            [
                [
                    "ArrowUp",
                    "mac+ArrowUp"
                ],
                resize,
                {
                    args: [
                        0,
                        -small
                    ]
                }
            ],
            [
                [
                    "ctrl+ArrowUp",
                    "mac+shift+ArrowUp"
                ],
                resize,
                {
                    args: [
                        0,
                        -big
                    ]
                }
            ],
            [
                [
                    "ArrowDown",
                    "mac+ArrowDown"
                ],
                resize,
                {
                    args: [
                        0,
                        small
                    ]
                }
            ],
            [
                [
                    "ctrl+ArrowDown",
                    "mac+shift+ArrowDown"
                ],
                resize,
                {
                    args: [
                        0,
                        big
                    ]
                }
            ],
            [
                [
                    "Escape",
                    "mac+Escape"
                ],
                $9ef033443a74bee6$var$AnnotationEditor.prototype._stopResizingWithKeyboard
            ]
        ]));
    }
    constructor(parameters){
        this.parent = parameters.parent;
        this.id = parameters.id;
        this.width = this.height = null;
        this.pageIndex = parameters.parent.pageIndex;
        this.name = parameters.name;
        this.div = null;
        this._uiManager = parameters.uiManager;
        this.annotationElementId = null;
        this._willKeepAspectRatio = false;
        this._initialOptions.isCentered = parameters.isCentered;
        this._structTreeParentId = null;
        this.annotationElementId = parameters.annotationElementId || null;
        this.creationDate = parameters.creationDate || new Date();
        this.modificationDate = parameters.modificationDate || null;
        const { rotation: rotation, rawDims: { pageWidth: pageWidth, pageHeight: pageHeight, pageX: pageX, pageY: pageY } } = this.parent.viewport;
        this.rotation = rotation;
        this.pageRotation = (360 + rotation - this._uiManager.viewParameters.rotation) % 360;
        this.pageDimensions = [
            pageWidth,
            pageHeight
        ];
        this.pageTranslation = [
            pageX,
            pageY
        ];
        const [width, height] = this.parentDimensions;
        this.x = parameters.x / width;
        this.y = parameters.y / height;
        this.isAttachedToDOM = false;
        this.deleted = false;
    }
    get editorType() {
        return Object.getPrototypeOf(this).constructor._type;
    }
    get mode() {
        return Object.getPrototypeOf(this).constructor._editorType;
    }
    static get isDrawer() {
        return false;
    }
    static get _defaultLineColor() {
        return $9ef033443a74bee6$export$b8972b998723d602(this, "_defaultLineColor", this._colorManager.getHexCode("CanvasText"));
    }
    static deleteAnnotationElement(editor) {
        const fakeEditor = new $9ef033443a74bee6$var$FakeEditor({
            id: editor.parent.getNextId(),
            parent: editor.parent,
            uiManager: editor._uiManager
        });
        fakeEditor.annotationElementId = editor.annotationElementId;
        fakeEditor.deleted = true;
        fakeEditor._uiManager.addToAnnotationStorage(fakeEditor);
    }
    static initialize(l10n, _uiManager) {
        $9ef033443a74bee6$var$AnnotationEditor._l10n ??= l10n;
        $9ef033443a74bee6$var$AnnotationEditor._l10nResizer ||= Object.freeze({
            topLeft: "pdfjs-editor-resizer-top-left",
            topMiddle: "pdfjs-editor-resizer-top-middle",
            topRight: "pdfjs-editor-resizer-top-right",
            middleRight: "pdfjs-editor-resizer-middle-right",
            bottomRight: "pdfjs-editor-resizer-bottom-right",
            bottomMiddle: "pdfjs-editor-resizer-bottom-middle",
            bottomLeft: "pdfjs-editor-resizer-bottom-left",
            middleLeft: "pdfjs-editor-resizer-middle-left"
        });
        if ($9ef033443a74bee6$var$AnnotationEditor._borderLineWidth !== -1) return;
        const style = getComputedStyle(document.documentElement);
        $9ef033443a74bee6$var$AnnotationEditor._borderLineWidth = parseFloat(style.getPropertyValue("--outline-width")) || 0;
    }
    static updateDefaultParams(_type, _value) {}
    static get defaultPropertiesToUpdate() {
        return [];
    }
    static isHandlingMimeForPasting(mime) {
        return false;
    }
    static paste(item, parent) {
        $9ef033443a74bee6$var$unreachable("Not implemented");
    }
    get propertiesToUpdate() {
        return [];
    }
    get _isDraggable() {
        return this.#isDraggable;
    }
    set _isDraggable(value) {
        this.#isDraggable = value;
        this.div?.classList.toggle("draggable", value);
    }
    get uid() {
        return this.annotationElementId || this.id;
    }
    get isEnterHandled() {
        return true;
    }
    center() {
        const [pageWidth, pageHeight] = this.pageDimensions;
        switch(this.parentRotation){
            case 90:
                this.x -= this.height * pageHeight / (pageWidth * 2);
                this.y += this.width * pageWidth / (pageHeight * 2);
                break;
            case 180:
                this.x += this.width / 2;
                this.y += this.height / 2;
                break;
            case 270:
                this.x += this.height * pageHeight / (pageWidth * 2);
                this.y -= this.width * pageWidth / (pageHeight * 2);
                break;
            default:
                this.x -= this.width / 2;
                this.y -= this.height / 2;
                break;
        }
        this.fixAndSetPosition();
    }
    addCommands(params) {
        this._uiManager.addCommands(params);
    }
    get currentLayer() {
        return this._uiManager.currentLayer;
    }
    setInBackground() {
        this.div.style.zIndex = 0;
    }
    setInForeground() {
        this.div.style.zIndex = this.#zIndex;
    }
    setParent(parent) {
        if (parent !== null) {
            this.pageIndex = parent.pageIndex;
            this.pageDimensions = parent.pageDimensions;
        } else {
            this.#stopResizing();
            this.#fakeAnnotation?.remove();
            this.#fakeAnnotation = null;
        }
        this.parent = parent;
    }
    focusin(event) {
        if (!this._focusEventsAllowed) return;
        if (!this.#hasBeenClicked) this.parent.setSelected(this);
        else this.#hasBeenClicked = false;
    }
    focusout(event) {
        if (!this._focusEventsAllowed) return;
        if (!this.isAttachedToDOM) return;
        const target = event.relatedTarget;
        if (target?.closest(`#${this.id}`)) return;
        event.preventDefault();
        if (!this.parent?.isMultipleSelection) this.commitOrRemove();
    }
    commitOrRemove() {
        if (this.isEmpty()) this.remove();
        else this.commit();
    }
    commit() {
        if (!this.isInEditMode()) return;
        this.addToAnnotationStorage();
    }
    addToAnnotationStorage() {
        this._uiManager.addToAnnotationStorage(this);
    }
    setAt(x, y, tx, ty) {
        const [width, height] = this.parentDimensions;
        [tx, ty] = this.screenToPageTranslation(tx, ty);
        this.x = (x + tx) / width;
        this.y = (y + ty) / height;
        this.fixAndSetPosition();
    }
    _moveAfterPaste(baseX, baseY) {
        const [parentWidth, parentHeight] = this.parentDimensions;
        this.setAt(baseX * parentWidth, baseY * parentHeight, this.width * parentWidth, this.height * parentHeight);
        this._onTranslated();
    }
    #translate([width, height], x, y) {
        [x, y] = this.screenToPageTranslation(x, y);
        this.x += x / width;
        this.y += y / height;
        this._onTranslating(this.x, this.y);
        this.fixAndSetPosition();
    }
    translate(x, y) {
        this.#translate(this.parentDimensions, x, y);
    }
    translateInPage(x, y) {
        this.#initialRect ||= [
            this.x,
            this.y,
            this.width,
            this.height
        ];
        this.#translate(this.pageDimensions, x, y);
        this.div.scrollIntoView({
            block: "nearest"
        });
    }
    translationDone() {
        this._onTranslated(this.x, this.y);
    }
    drag(tx, ty) {
        this.#initialRect ||= [
            this.x,
            this.y,
            this.width,
            this.height
        ];
        const { div: div, parentDimensions: [parentWidth, parentHeight] } = this;
        this.x += tx / parentWidth;
        this.y += ty / parentHeight;
        if (this.parent && (this.x < 0 || this.x > 1 || this.y < 0 || this.y > 1)) {
            const { x: x, y: y } = this.div.getBoundingClientRect();
            if (this.parent.findNewParent(this, x, y)) {
                this.x -= Math.floor(this.x);
                this.y -= Math.floor(this.y);
            }
        }
        let { x: x, y: y } = this;
        const [bx, by] = this.getBaseTranslation();
        x += bx;
        y += by;
        const { style: style } = div;
        style.left = `${(100 * x).toFixed(2)}%`;
        style.top = `${(100 * y).toFixed(2)}%`;
        this._onTranslating(x, y);
        div.scrollIntoView({
            block: "nearest"
        });
    }
    _onTranslating(x, y) {}
    _onTranslated(x, y) {}
    get _hasBeenMoved() {
        return !!this.#initialRect && (this.#initialRect[0] !== this.x || this.#initialRect[1] !== this.y);
    }
    get _hasBeenResized() {
        return !!this.#initialRect && (this.#initialRect[2] !== this.width || this.#initialRect[3] !== this.height);
    }
    getBaseTranslation() {
        const [parentWidth, parentHeight] = this.parentDimensions;
        const { _borderLineWidth: _borderLineWidth } = $9ef033443a74bee6$var$AnnotationEditor;
        const x = _borderLineWidth / parentWidth;
        const y = _borderLineWidth / parentHeight;
        switch(this.rotation){
            case 90:
                return [
                    -x,
                    y
                ];
            case 180:
                return [
                    x,
                    y
                ];
            case 270:
                return [
                    x,
                    -y
                ];
            default:
                return [
                    -x,
                    -y
                ];
        }
    }
    get _mustFixPosition() {
        return true;
    }
    fixAndSetPosition(rotation = this.rotation) {
        const { div: { style: style }, pageDimensions: [pageWidth, pageHeight] } = this;
        let { x: x, y: y, width: width, height: height } = this;
        width *= pageWidth;
        height *= pageHeight;
        x *= pageWidth;
        y *= pageHeight;
        if (this._mustFixPosition) switch(rotation){
            case 0:
                x = $9ef033443a74bee6$export$b8106b171181a554(x, 0, pageWidth - width);
                y = $9ef033443a74bee6$export$b8106b171181a554(y, 0, pageHeight - height);
                break;
            case 90:
                x = $9ef033443a74bee6$export$b8106b171181a554(x, 0, pageWidth - height);
                y = $9ef033443a74bee6$export$b8106b171181a554(y, width, pageHeight);
                break;
            case 180:
                x = $9ef033443a74bee6$export$b8106b171181a554(x, width, pageWidth);
                y = $9ef033443a74bee6$export$b8106b171181a554(y, height, pageHeight);
                break;
            case 270:
                x = $9ef033443a74bee6$export$b8106b171181a554(x, height, pageWidth);
                y = $9ef033443a74bee6$export$b8106b171181a554(y, 0, pageHeight - width);
                break;
        }
        this.x = x /= pageWidth;
        this.y = y /= pageHeight;
        const [bx, by] = this.getBaseTranslation();
        x += bx;
        y += by;
        style.left = `${(100 * x).toFixed(2)}%`;
        style.top = `${(100 * y).toFixed(2)}%`;
        this.moveInDOM();
    }
    static #rotatePoint(x, y, angle) {
        switch(angle){
            case 90:
                return [
                    y,
                    -x
                ];
            case 180:
                return [
                    -x,
                    -y
                ];
            case 270:
                return [
                    -y,
                    x
                ];
            default:
                return [
                    x,
                    y
                ];
        }
    }
    screenToPageTranslation(x, y) {
        return $9ef033443a74bee6$var$AnnotationEditor.#rotatePoint(x, y, this.parentRotation);
    }
    pageTranslationToScreen(x, y) {
        return $9ef033443a74bee6$var$AnnotationEditor.#rotatePoint(x, y, 360 - this.parentRotation);
    }
    #getRotationMatrix(rotation) {
        switch(rotation){
            case 90:
                {
                    const [pageWidth, pageHeight] = this.pageDimensions;
                    return [
                        0,
                        -pageWidth / pageHeight,
                        pageHeight / pageWidth,
                        0
                    ];
                }
            case 180:
                return [
                    -1,
                    0,
                    0,
                    -1
                ];
            case 270:
                {
                    const [pageWidth, pageHeight] = this.pageDimensions;
                    return [
                        0,
                        pageWidth / pageHeight,
                        -pageHeight / pageWidth,
                        0
                    ];
                }
            default:
                return [
                    1,
                    0,
                    0,
                    1
                ];
        }
    }
    get parentScale() {
        return this._uiManager.viewParameters.realScale;
    }
    get parentRotation() {
        return (this._uiManager.viewParameters.rotation + this.pageRotation) % 360;
    }
    get parentDimensions() {
        const { parentScale: parentScale, pageDimensions: [pageWidth, pageHeight] } = this;
        return [
            pageWidth * parentScale,
            pageHeight * parentScale
        ];
    }
    setDims() {
        const { div: { style: style }, width: width, height: height } = this;
        style.width = `${(100 * width).toFixed(2)}%`;
        style.height = `${(100 * height).toFixed(2)}%`;
    }
    getInitialTranslation() {
        return [
            0,
            0
        ];
    }
    #createResizers() {
        if (this.#resizersDiv) return;
        this.#resizersDiv = document.createElement("div");
        this.#resizersDiv.classList.add("resizers");
        const classes = this._willKeepAspectRatio ? [
            "topLeft",
            "topRight",
            "bottomRight",
            "bottomLeft"
        ] : [
            "topLeft",
            "topMiddle",
            "topRight",
            "middleRight",
            "bottomRight",
            "bottomMiddle",
            "bottomLeft",
            "middleLeft"
        ];
        const signal = this._uiManager._signal;
        for (const name of classes){
            const div = document.createElement("div");
            this.#resizersDiv.append(div);
            div.classList.add("resizer", name);
            div.setAttribute("data-resizer-name", name);
            div.addEventListener("pointerdown", this.#resizerPointerdown.bind(this, name), {
                signal: signal
            });
            div.addEventListener("contextmenu", $9ef033443a74bee6$export$455b7811f904cadc, {
                signal: signal
            });
            div.tabIndex = -1;
        }
        this.div.prepend(this.#resizersDiv);
    }
    #resizerPointerdown(name, event) {
        event.preventDefault();
        const { isMac: isMac } = $9ef033443a74bee6$export$5fb8891d35c36978.platform;
        if (event.button !== 0 || event.ctrlKey && isMac) return;
        this.#altText?.toggle(false);
        const savedDraggable = this._isDraggable;
        this._isDraggable = false;
        this.#lastPointerCoords = [
            event.screenX,
            event.screenY
        ];
        const ac = new AbortController();
        const signal = this._uiManager.combinedSignal(ac);
        this.parent.togglePointerEvents(false);
        window.addEventListener("pointermove", this.#resizerPointermove.bind(this, name), {
            passive: true,
            capture: true,
            signal: signal
        });
        window.addEventListener("touchmove", $9ef033443a74bee6$export$7ae4cd3a66c1e050, {
            passive: false,
            signal: signal
        });
        window.addEventListener("contextmenu", $9ef033443a74bee6$export$455b7811f904cadc, {
            signal: signal
        });
        this.#savedDimensions = {
            savedX: this.x,
            savedY: this.y,
            savedWidth: this.width,
            savedHeight: this.height
        };
        const savedParentCursor = this.parent.div.style.cursor;
        const savedCursor = this.div.style.cursor;
        this.div.style.cursor = this.parent.div.style.cursor = window.getComputedStyle(event.target).cursor;
        const pointerUpCallback = ()=>{
            ac.abort();
            this.parent.togglePointerEvents(true);
            this.#altText?.toggle(true);
            this._isDraggable = savedDraggable;
            this.parent.div.style.cursor = savedParentCursor;
            this.div.style.cursor = savedCursor;
            this.#addResizeToUndoStack();
        };
        window.addEventListener("pointerup", pointerUpCallback, {
            signal: signal
        });
        window.addEventListener("blur", pointerUpCallback, {
            signal: signal
        });
    }
    #resize(x, y, width, height) {
        this.width = width;
        this.height = height;
        this.x = x;
        this.y = y;
        this.setDims();
        this.fixAndSetPosition();
        this._onResized();
    }
    _onResized() {}
    #addResizeToUndoStack() {
        if (!this.#savedDimensions) return;
        const { savedX: savedX, savedY: savedY, savedWidth: savedWidth, savedHeight: savedHeight } = this.#savedDimensions;
        this.#savedDimensions = null;
        const newX = this.x;
        const newY = this.y;
        const newWidth = this.width;
        const newHeight = this.height;
        if (newX === savedX && newY === savedY && newWidth === savedWidth && newHeight === savedHeight) return;
        this.addCommands({
            cmd: this.#resize.bind(this, newX, newY, newWidth, newHeight),
            undo: this.#resize.bind(this, savedX, savedY, savedWidth, savedHeight),
            mustExec: true
        });
    }
    static _round(x) {
        return Math.round(x * 10000) / 10000;
    }
    #resizerPointermove(name, event) {
        const [parentWidth, parentHeight] = this.parentDimensions;
        const savedX = this.x;
        const savedY = this.y;
        const savedWidth = this.width;
        const savedHeight = this.height;
        const minWidth = $9ef033443a74bee6$var$AnnotationEditor.MIN_SIZE / parentWidth;
        const minHeight = $9ef033443a74bee6$var$AnnotationEditor.MIN_SIZE / parentHeight;
        const rotationMatrix = this.#getRotationMatrix(this.rotation);
        const transf = (x, y)=>[
                rotationMatrix[0] * x + rotationMatrix[2] * y,
                rotationMatrix[1] * x + rotationMatrix[3] * y
            ];
        const invRotationMatrix = this.#getRotationMatrix(360 - this.rotation);
        const invTransf = (x, y)=>[
                invRotationMatrix[0] * x + invRotationMatrix[2] * y,
                invRotationMatrix[1] * x + invRotationMatrix[3] * y
            ];
        let getPoint;
        let getOpposite;
        let isDiagonal = false;
        let isHorizontal = false;
        switch(name){
            case "topLeft":
                isDiagonal = true;
                getPoint = (w, h)=>[
                        0,
                        0
                    ];
                getOpposite = (w, h)=>[
                        w,
                        h
                    ];
                break;
            case "topMiddle":
                getPoint = (w, h)=>[
                        w / 2,
                        0
                    ];
                getOpposite = (w, h)=>[
                        w / 2,
                        h
                    ];
                break;
            case "topRight":
                isDiagonal = true;
                getPoint = (w, h)=>[
                        w,
                        0
                    ];
                getOpposite = (w, h)=>[
                        0,
                        h
                    ];
                break;
            case "middleRight":
                isHorizontal = true;
                getPoint = (w, h)=>[
                        w,
                        h / 2
                    ];
                getOpposite = (w, h)=>[
                        0,
                        h / 2
                    ];
                break;
            case "bottomRight":
                isDiagonal = true;
                getPoint = (w, h)=>[
                        w,
                        h
                    ];
                getOpposite = (w, h)=>[
                        0,
                        0
                    ];
                break;
            case "bottomMiddle":
                getPoint = (w, h)=>[
                        w / 2,
                        h
                    ];
                getOpposite = (w, h)=>[
                        w / 2,
                        0
                    ];
                break;
            case "bottomLeft":
                isDiagonal = true;
                getPoint = (w, h)=>[
                        0,
                        h
                    ];
                getOpposite = (w, h)=>[
                        w,
                        0
                    ];
                break;
            case "middleLeft":
                isHorizontal = true;
                getPoint = (w, h)=>[
                        0,
                        h / 2
                    ];
                getOpposite = (w, h)=>[
                        w,
                        h / 2
                    ];
                break;
        }
        const point = getPoint(savedWidth, savedHeight);
        const oppositePoint = getOpposite(savedWidth, savedHeight);
        let transfOppositePoint = transf(...oppositePoint);
        const oppositeX = $9ef033443a74bee6$var$AnnotationEditor._round(savedX + transfOppositePoint[0]);
        const oppositeY = $9ef033443a74bee6$var$AnnotationEditor._round(savedY + transfOppositePoint[1]);
        let ratioX = 1;
        let ratioY = 1;
        let deltaX, deltaY;
        if (!event.fromKeyboard) {
            const { screenX: screenX, screenY: screenY } = event;
            const [lastScreenX, lastScreenY] = this.#lastPointerCoords;
            [deltaX, deltaY] = this.screenToPageTranslation(screenX - lastScreenX, screenY - lastScreenY);
            this.#lastPointerCoords[0] = screenX;
            this.#lastPointerCoords[1] = screenY;
        } else ({ deltaX: deltaX, deltaY: deltaY } = event);
        [deltaX, deltaY] = invTransf(deltaX / parentWidth, deltaY / parentHeight);
        if (isDiagonal) {
            const oldDiag = Math.hypot(savedWidth, savedHeight);
            ratioX = ratioY = Math.max(Math.min(Math.hypot(oppositePoint[0] - point[0] - deltaX, oppositePoint[1] - point[1] - deltaY) / oldDiag, 1 / savedWidth, 1 / savedHeight), minWidth / savedWidth, minHeight / savedHeight);
        } else if (isHorizontal) ratioX = $9ef033443a74bee6$export$b8106b171181a554(Math.abs(oppositePoint[0] - point[0] - deltaX), minWidth, 1) / savedWidth;
        else ratioY = $9ef033443a74bee6$export$b8106b171181a554(Math.abs(oppositePoint[1] - point[1] - deltaY), minHeight, 1) / savedHeight;
        const newWidth = $9ef033443a74bee6$var$AnnotationEditor._round(savedWidth * ratioX);
        const newHeight = $9ef033443a74bee6$var$AnnotationEditor._round(savedHeight * ratioY);
        transfOppositePoint = transf(...getOpposite(newWidth, newHeight));
        const newX = oppositeX - transfOppositePoint[0];
        const newY = oppositeY - transfOppositePoint[1];
        this.#initialRect ||= [
            this.x,
            this.y,
            this.width,
            this.height
        ];
        this.width = newWidth;
        this.height = newHeight;
        this.x = newX;
        this.y = newY;
        this.setDims();
        this.fixAndSetPosition();
        this._onResizing();
    }
    _onResizing() {}
    altTextFinish() {
        this.#altText?.finish();
    }
    get toolbarButtons() {
        return null;
    }
    async addEditToolbar() {
        if (this._editToolbar || this.#isInEditMode) return this._editToolbar;
        this._editToolbar = new $9ef033443a74bee6$var$EditorToolbar(this);
        this.div.append(this._editToolbar.render());
        const { toolbarButtons: toolbarButtons } = this;
        if (toolbarButtons) for (const [name, tool] of toolbarButtons)await this._editToolbar.addButton(name, tool);
        if (!this.hasComment) this._editToolbar.addButton("comment", this.addCommentButton());
        this._editToolbar.addButton("delete");
        return this._editToolbar;
    }
    addCommentButtonInToolbar() {
        this._editToolbar?.addButtonBefore("comment", this.addCommentButton(), ".deleteButton");
    }
    removeCommentButtonFromToolbar() {
        this._editToolbar?.removeButton("comment");
    }
    removeEditToolbar() {
        this._editToolbar?.remove();
        this._editToolbar = null;
        this.#altText?.destroy();
    }
    addContainer(container) {
        const editToolbarDiv = this._editToolbar?.div;
        if (editToolbarDiv) editToolbarDiv.before(container);
        else this.div.append(container);
    }
    getClientDimensions() {
        return this.div.getBoundingClientRect();
    }
    createAltText() {
        if (!this.#altText) {
            $9ef033443a74bee6$var$AltText.initialize($9ef033443a74bee6$var$AnnotationEditor._l10n);
            this.#altText = new $9ef033443a74bee6$var$AltText(this);
            if (this.#accessibilityData) {
                this.#altText.data = this.#accessibilityData;
                this.#accessibilityData = null;
            }
        }
        return this.#altText;
    }
    get altTextData() {
        return this.#altText?.data;
    }
    set altTextData(data) {
        if (!this.#altText) return;
        this.#altText.data = data;
    }
    get guessedAltText() {
        return this.#altText?.guessedText;
    }
    async setGuessedAltText(text) {
        await this.#altText?.setGuessedText(text);
    }
    serializeAltText(isForCopying) {
        return this.#altText?.serialize(isForCopying);
    }
    hasAltText() {
        return !!this.#altText && !this.#altText.isEmpty();
    }
    hasAltTextData() {
        return this.#altText?.hasData() ?? false;
    }
    focusCommentButton() {
        this.#comment?.focusButton();
    }
    addCommentButton() {
        return this.#comment ||= new $9ef033443a74bee6$var$Comment(this);
    }
    addStandaloneCommentButton() {
        if (this.#commentStandaloneButton) {
            if (this._uiManager.isEditingMode()) this.#commentStandaloneButton.classList.remove("hidden");
            return;
        }
        if (!this.hasComment) return;
        this.#commentStandaloneButton = this.#comment.renderForStandalone();
        this.div.append(this.#commentStandaloneButton);
    }
    removeStandaloneCommentButton() {
        this.#comment.removeStandaloneCommentButton();
        this.#commentStandaloneButton = null;
    }
    hideStandaloneCommentButton() {
        this.#commentStandaloneButton?.classList.add("hidden");
    }
    get comment() {
        const { data: { richText: richText, text: text, date: date, deleted: deleted } } = this.#comment;
        return {
            text: text,
            richText: richText,
            date: date,
            deleted: deleted,
            color: this.getNonHCMColor(),
            opacity: this.opacity ?? 1
        };
    }
    set comment(text) {
        this.#comment ||= new $9ef033443a74bee6$var$Comment(this);
        this.#comment.data = text;
        if (this.hasComment) {
            this.removeCommentButtonFromToolbar();
            this.addStandaloneCommentButton();
            this._uiManager.updateComment(this);
        } else {
            this.addCommentButtonInToolbar();
            this.removeStandaloneCommentButton();
            this._uiManager.removeComment(this);
        }
    }
    setCommentData({ comment: comment, popupRef: popupRef, richText: richText }) {
        if (!popupRef) return;
        this.#comment ||= new $9ef033443a74bee6$var$Comment(this);
        this.#comment.setInitialText(comment, richText);
        if (!this.annotationElementId) return;
        const storedData = this._uiManager.getAndRemoveDataFromAnnotationStorage(this.annotationElementId);
        if (storedData) this.updateFromAnnotationLayer(storedData);
    }
    get hasEditedComment() {
        return this.#comment?.hasBeenEdited();
    }
    get hasDeletedComment() {
        return this.#comment?.isDeleted();
    }
    get hasComment() {
        return !!this.#comment && !this.#comment.isEmpty() && !this.#comment.isDeleted();
    }
    async editComment(options) {
        this.#comment ||= new $9ef033443a74bee6$var$Comment(this);
        this.#comment.edit(options);
    }
    toggleComment(isSelected, visibility) {
        if (this.hasComment) this._uiManager.toggleComment(this, isSelected, visibility);
    }
    setSelectedCommentButton(selected) {
        this.#comment.setSelectedButton(selected);
    }
    addComment(serialized) {
        if (this.hasEditedComment) {
            const DEFAULT_POPUP_WIDTH = 180;
            const DEFAULT_POPUP_HEIGHT = 100;
            const [, , , trY] = serialized.rect;
            const [pageWidth] = this.pageDimensions;
            const [pageX] = this.pageTranslation;
            const blX = pageX + pageWidth + 1;
            const blY = trY - DEFAULT_POPUP_HEIGHT;
            const trX = blX + DEFAULT_POPUP_WIDTH;
            serialized.popup = {
                contents: this.comment.text,
                deleted: this.comment.deleted,
                rect: [
                    blX,
                    blY,
                    trX,
                    trY
                ]
            };
        }
    }
    updateFromAnnotationLayer({ popup: { contents: contents, deleted: deleted } }) {
        this.#comment.data = deleted ? null : contents;
    }
    get parentBoundingClientRect() {
        return this.parent.boundingClientRect;
    }
    render() {
        const div = this.div = document.createElement("div");
        div.setAttribute("data-editor-rotation", (360 - this.rotation) % 360);
        div.className = this.name;
        div.setAttribute("id", this.id);
        div.tabIndex = this.#disabled ? -1 : 0;
        div.setAttribute("role", "application");
        if (this.defaultL10nId) div.setAttribute("data-l10n-id", this.defaultL10nId);
        if (!this._isVisible) div.classList.add("hidden");
        this.setInForeground();
        this.#addFocusListeners();
        const [parentWidth, parentHeight] = this.parentDimensions;
        if (this.parentRotation % 180 !== 0) {
            div.style.maxWidth = `${(100 * parentHeight / parentWidth).toFixed(2)}%`;
            div.style.maxHeight = `${(100 * parentWidth / parentHeight).toFixed(2)}%`;
        }
        const [tx, ty] = this.getInitialTranslation();
        this.translate(tx, ty);
        $9ef033443a74bee6$var$bindEvents(this, div, [
            "keydown",
            "pointerdown",
            "dblclick"
        ]);
        if (this.isResizable && this._uiManager._supportsPinchToZoom) this.#touchManager ||= new $9ef033443a74bee6$export$9ae7542b430d543e({
            container: div,
            isPinchingDisabled: ()=>!this.isSelected,
            onPinchStart: this.#touchPinchStartCallback.bind(this),
            onPinching: this.#touchPinchCallback.bind(this),
            onPinchEnd: this.#touchPinchEndCallback.bind(this),
            signal: this._uiManager._signal
        });
        this.addStandaloneCommentButton();
        this._uiManager._editorUndoBar?.hide();
        return div;
    }
    #touchPinchStartCallback() {
        this.#savedDimensions = {
            savedX: this.x,
            savedY: this.y,
            savedWidth: this.width,
            savedHeight: this.height
        };
        this.#altText?.toggle(false);
        this.parent.togglePointerEvents(false);
    }
    #touchPinchCallback(_origin, prevDistance, distance) {
        const slowDownFactor = 0.7;
        let factor = slowDownFactor * (distance / prevDistance) + 1 - slowDownFactor;
        if (factor === 1) return;
        const rotationMatrix = this.#getRotationMatrix(this.rotation);
        const transf = (x, y)=>[
                rotationMatrix[0] * x + rotationMatrix[2] * y,
                rotationMatrix[1] * x + rotationMatrix[3] * y
            ];
        const [parentWidth, parentHeight] = this.parentDimensions;
        const savedX = this.x;
        const savedY = this.y;
        const savedWidth = this.width;
        const savedHeight = this.height;
        const minWidth = $9ef033443a74bee6$var$AnnotationEditor.MIN_SIZE / parentWidth;
        const minHeight = $9ef033443a74bee6$var$AnnotationEditor.MIN_SIZE / parentHeight;
        factor = Math.max(Math.min(factor, 1 / savedWidth, 1 / savedHeight), minWidth / savedWidth, minHeight / savedHeight);
        const newWidth = $9ef033443a74bee6$var$AnnotationEditor._round(savedWidth * factor);
        const newHeight = $9ef033443a74bee6$var$AnnotationEditor._round(savedHeight * factor);
        if (newWidth === savedWidth && newHeight === savedHeight) return;
        this.#initialRect ||= [
            savedX,
            savedY,
            savedWidth,
            savedHeight
        ];
        const transfCenterPoint = transf(savedWidth / 2, savedHeight / 2);
        const centerX = $9ef033443a74bee6$var$AnnotationEditor._round(savedX + transfCenterPoint[0]);
        const centerY = $9ef033443a74bee6$var$AnnotationEditor._round(savedY + transfCenterPoint[1]);
        const newTransfCenterPoint = transf(newWidth / 2, newHeight / 2);
        this.x = centerX - newTransfCenterPoint[0];
        this.y = centerY - newTransfCenterPoint[1];
        this.width = newWidth;
        this.height = newHeight;
        this.setDims();
        this.fixAndSetPosition();
        this._onResizing();
    }
    #touchPinchEndCallback() {
        this.#altText?.toggle(true);
        this.parent.togglePointerEvents(true);
        this.#addResizeToUndoStack();
    }
    pointerdown(event) {
        const { isMac: isMac } = $9ef033443a74bee6$export$5fb8891d35c36978.platform;
        if (event.button !== 0 || event.ctrlKey && isMac) {
            event.preventDefault();
            return;
        }
        this.#hasBeenClicked = true;
        if (this._isDraggable) {
            this.#setUpDragSession(event);
            return;
        }
        this.#selectOnPointerEvent(event);
    }
    #selectOnPointerEvent(event) {
        const { isMac: isMac } = $9ef033443a74bee6$export$5fb8891d35c36978.platform;
        if (event.ctrlKey && !isMac || event.shiftKey || event.metaKey && isMac) this.parent.toggleSelected(this);
        else this.parent.setSelected(this);
    }
    #setUpDragSession(event) {
        const { isSelected: isSelected } = this;
        this._uiManager.setUpDragSession();
        let hasDraggingStarted = false;
        const ac = new AbortController();
        const signal = this._uiManager.combinedSignal(ac);
        const opts = {
            capture: true,
            passive: false,
            signal: signal
        };
        const cancelDrag = (e)=>{
            ac.abort();
            this.#dragPointerId = null;
            this.#hasBeenClicked = false;
            if (!this._uiManager.endDragSession()) this.#selectOnPointerEvent(e);
            if (hasDraggingStarted) this._onStopDragging();
        };
        if (isSelected) {
            this.#prevDragX = event.clientX;
            this.#prevDragY = event.clientY;
            this.#dragPointerId = event.pointerId;
            this.#dragPointerType = event.pointerType;
            window.addEventListener("pointermove", (e)=>{
                if (!hasDraggingStarted) {
                    hasDraggingStarted = true;
                    this._uiManager.toggleComment(this, true, false);
                    this._onStartDragging();
                }
                const { clientX: x, clientY: y, pointerId: pointerId } = e;
                if (pointerId !== this.#dragPointerId) {
                    $9ef033443a74bee6$export$7ae4cd3a66c1e050(e);
                    return;
                }
                const [tx, ty] = this.screenToPageTranslation(x - this.#prevDragX, y - this.#prevDragY);
                this.#prevDragX = x;
                this.#prevDragY = y;
                this._uiManager.dragSelectedEditors(tx, ty);
            }, opts);
            window.addEventListener("touchmove", $9ef033443a74bee6$export$7ae4cd3a66c1e050, opts);
            window.addEventListener("pointerdown", (e)=>{
                if (e.pointerType === this.#dragPointerType) {
                    if (this.#touchManager || e.isPrimary) cancelDrag(e);
                }
                $9ef033443a74bee6$export$7ae4cd3a66c1e050(e);
            }, opts);
        }
        const pointerUpCallback = (e)=>{
            if (!this.#dragPointerId || this.#dragPointerId === e.pointerId) {
                cancelDrag(e);
                return;
            }
            $9ef033443a74bee6$export$7ae4cd3a66c1e050(e);
        };
        window.addEventListener("pointerup", pointerUpCallback, {
            signal: signal
        });
        window.addEventListener("blur", pointerUpCallback, {
            signal: signal
        });
    }
    _onStartDragging() {}
    _onStopDragging() {}
    moveInDOM() {
        if (this.#moveInDOMTimeout) clearTimeout(this.#moveInDOMTimeout);
        this.#moveInDOMTimeout = setTimeout(()=>{
            this.#moveInDOMTimeout = null;
            this.parent?.moveEditorInDOM(this);
        }, 0);
    }
    _setParentAndPosition(parent, x, y) {
        parent.changeParent(this);
        this.x = x;
        this.y = y;
        this.fixAndSetPosition();
        this._onTranslated();
    }
    getRect(tx, ty, rotation = this.rotation) {
        const scale = this.parentScale;
        const [pageWidth, pageHeight] = this.pageDimensions;
        const [pageX, pageY] = this.pageTranslation;
        const shiftX = tx / scale;
        const shiftY = ty / scale;
        const x = this.x * pageWidth;
        const y = this.y * pageHeight;
        const width = this.width * pageWidth;
        const height = this.height * pageHeight;
        switch(rotation){
            case 0:
                return [
                    x + shiftX + pageX,
                    pageHeight - y - shiftY - height + pageY,
                    x + shiftX + width + pageX,
                    pageHeight - y - shiftY + pageY
                ];
            case 90:
                return [
                    x + shiftY + pageX,
                    pageHeight - y + shiftX + pageY,
                    x + shiftY + height + pageX,
                    pageHeight - y + shiftX + width + pageY
                ];
            case 180:
                return [
                    x - shiftX - width + pageX,
                    pageHeight - y + shiftY + pageY,
                    x - shiftX + pageX,
                    pageHeight - y + shiftY + height + pageY
                ];
            case 270:
                return [
                    x - shiftY - height + pageX,
                    pageHeight - y - shiftX - width + pageY,
                    x - shiftY + pageX,
                    pageHeight - y - shiftX + pageY
                ];
            default:
                throw new Error("Invalid rotation");
        }
    }
    getRectInCurrentCoords(rect, pageHeight) {
        const [x1, y1, x2, y2] = rect;
        const width = x2 - x1;
        const height = y2 - y1;
        switch(this.rotation){
            case 0:
                return [
                    x1,
                    pageHeight - y2,
                    width,
                    height
                ];
            case 90:
                return [
                    x1,
                    pageHeight - y1,
                    height,
                    width
                ];
            case 180:
                return [
                    x2,
                    pageHeight - y1,
                    width,
                    height
                ];
            case 270:
                return [
                    x2,
                    pageHeight - y2,
                    height,
                    width
                ];
            default:
                throw new Error("Invalid rotation");
        }
    }
    getPDFRect() {
        return this.getRect(0, 0);
    }
    getNonHCMColor() {
        return this.color && $9ef033443a74bee6$var$AnnotationEditor._colorManager.convert(this._uiManager.getNonHCMColor(this.color));
    }
    onUpdatedColor() {
        this.#comment?.onUpdatedColor();
    }
    getData() {
        const { comment: { text: str, color: color, date: date, opacity: opacity, deleted: deleted, richText: richText }, uid: id, pageIndex: pageIndex, creationDate: creationDate, modificationDate: modificationDate } = this;
        return {
            id: id,
            pageIndex: pageIndex,
            rect: this.getPDFRect(),
            richText: richText,
            contentsObj: {
                str: str
            },
            creationDate: creationDate,
            modificationDate: date || modificationDate,
            popupRef: !deleted,
            color: color,
            opacity: opacity
        };
    }
    onceAdded(focus) {}
    isEmpty() {
        return false;
    }
    enableEditMode() {
        if (this.isInEditMode()) return false;
        this.parent.setEditingState(false);
        this.#isInEditMode = true;
        return true;
    }
    disableEditMode() {
        if (!this.isInEditMode()) return false;
        this.parent.setEditingState(true);
        this.#isInEditMode = false;
        return true;
    }
    isInEditMode() {
        return this.#isInEditMode;
    }
    shouldGetKeyboardEvents() {
        return this.#isResizerEnabledForKeyboard;
    }
    needsToBeRebuilt() {
        return this.div && !this.isAttachedToDOM;
    }
    get isOnScreen() {
        const { top: top, left: left, bottom: bottom, right: right } = this.getClientDimensions();
        const { innerHeight: innerHeight, innerWidth: innerWidth } = window;
        return left < innerWidth && right > 0 && top < innerHeight && bottom > 0;
    }
    #addFocusListeners() {
        if (this.#focusAC || !this.div) return;
        this.#focusAC = new AbortController();
        const signal = this._uiManager.combinedSignal(this.#focusAC);
        this.div.addEventListener("focusin", this.focusin.bind(this), {
            signal: signal
        });
        this.div.addEventListener("focusout", this.focusout.bind(this), {
            signal: signal
        });
    }
    rebuild() {
        this.#addFocusListeners();
    }
    rotate(_angle) {}
    resize() {}
    serializeDeleted() {
        return {
            id: this.annotationElementId,
            deleted: true,
            pageIndex: this.pageIndex,
            popupRef: this._initialData?.popupRef || ""
        };
    }
    serialize(isForCopying = false, context = null) {
        return {
            annotationType: this.mode,
            pageIndex: this.pageIndex,
            rect: this.getPDFRect(),
            rotation: this.rotation,
            structTreeParentId: this._structTreeParentId,
            popupRef: this._initialData?.popupRef || ""
        };
    }
    static async deserialize(data, parent, uiManager) {
        const editor = new this.prototype.constructor({
            parent: parent,
            id: parent.getNextId(),
            uiManager: uiManager,
            annotationElementId: data.annotationElementId,
            creationDate: data.creationDate,
            modificationDate: data.modificationDate
        });
        editor.rotation = data.rotation;
        editor.#accessibilityData = data.accessibilityData;
        editor._isCopy = data.isCopy || false;
        const [pageWidth, pageHeight] = editor.pageDimensions;
        const [x, y, width, height] = editor.getRectInCurrentCoords(data.rect, pageHeight);
        editor.x = x / pageWidth;
        editor.y = y / pageHeight;
        editor.width = width / pageWidth;
        editor.height = height / pageHeight;
        return editor;
    }
    get hasBeenModified() {
        return !!this.annotationElementId && (this.deleted || this.serialize() !== null);
    }
    remove() {
        this.#focusAC?.abort();
        this.#focusAC = null;
        if (!this.isEmpty()) this.commit();
        if (this.parent) this.parent.remove(this);
        else this._uiManager.removeEditor(this);
        if (this.#moveInDOMTimeout) {
            clearTimeout(this.#moveInDOMTimeout);
            this.#moveInDOMTimeout = null;
        }
        this.#stopResizing();
        this.removeEditToolbar();
        if (this.#telemetryTimeouts) {
            for (const timeout of this.#telemetryTimeouts.values())clearTimeout(timeout);
            this.#telemetryTimeouts = null;
        }
        this.parent = null;
        this.#touchManager?.destroy();
        this.#touchManager = null;
    }
    get isResizable() {
        return false;
    }
    makeResizable() {
        if (this.isResizable) {
            this.#createResizers();
            this.#resizersDiv.classList.remove("hidden");
        }
    }
    get toolbarPosition() {
        return null;
    }
    get commentButtonPosition() {
        return this._uiManager.direction === "ltr" ? [
            1,
            0
        ] : [
            0,
            0
        ];
    }
    get commentButtonPositionInPage() {
        const { commentButtonPosition: [posX, posY] } = this;
        const [blX, blY, trX, trY] = this.getPDFRect();
        return [
            $9ef033443a74bee6$var$AnnotationEditor._round(blX + (trX - blX) * posX),
            $9ef033443a74bee6$var$AnnotationEditor._round(blY + (trY - blY) * (1 - posY))
        ];
    }
    get commentButtonColor() {
        return this._uiManager.makeCommentColor(this.getNonHCMColor(), this.opacity);
    }
    get commentPopupPosition() {
        return this.#comment.commentPopupPositionInLayer;
    }
    set commentPopupPosition(pos) {
        this.#comment.commentPopupPositionInLayer = pos;
    }
    hasDefaultPopupPosition() {
        return this.#comment.hasDefaultPopupPosition();
    }
    get commentButtonWidth() {
        return this.#comment.commentButtonWidth;
    }
    get elementBeforePopup() {
        return this.div;
    }
    setCommentButtonStates(options) {
        this.#comment.setCommentButtonStates(options);
    }
    keydown(event) {
        if (!this.isResizable || event.target !== this.div || event.key !== "Enter") return;
        this._uiManager.setSelected(this);
        this.#savedDimensions = {
            savedX: this.x,
            savedY: this.y,
            savedWidth: this.width,
            savedHeight: this.height
        };
        const children = this.#resizersDiv.children;
        if (!this.#allResizerDivs) {
            this.#allResizerDivs = Array.from(children);
            const boundResizerKeydown = this.#resizerKeydown.bind(this);
            const boundResizerBlur = this.#resizerBlur.bind(this);
            const signal = this._uiManager._signal;
            for (const div of this.#allResizerDivs){
                const name = div.getAttribute("data-resizer-name");
                div.setAttribute("role", "spinbutton");
                div.addEventListener("keydown", boundResizerKeydown, {
                    signal: signal
                });
                div.addEventListener("blur", boundResizerBlur, {
                    signal: signal
                });
                div.addEventListener("focus", this.#resizerFocus.bind(this, name), {
                    signal: signal
                });
                div.setAttribute("data-l10n-id", $9ef033443a74bee6$var$AnnotationEditor._l10nResizer[name]);
            }
        }
        const first = this.#allResizerDivs[0];
        let firstPosition = 0;
        for (const div of children){
            if (div === first) break;
            firstPosition++;
        }
        const nextFirstPosition = (360 - this.rotation + this.parentRotation) % 360 / 90 * (this.#allResizerDivs.length / 4);
        if (nextFirstPosition !== firstPosition) {
            if (nextFirstPosition < firstPosition) for(let i = 0; i < firstPosition - nextFirstPosition; i++)this.#resizersDiv.append(this.#resizersDiv.firstChild);
            else if (nextFirstPosition > firstPosition) for(let i = 0; i < nextFirstPosition - firstPosition; i++)this.#resizersDiv.firstChild.before(this.#resizersDiv.lastChild);
            let i = 0;
            for (const child of children){
                const div = this.#allResizerDivs[i++];
                const name = div.getAttribute("data-resizer-name");
                child.setAttribute("data-l10n-id", $9ef033443a74bee6$var$AnnotationEditor._l10nResizer[name]);
            }
        }
        this.#setResizerTabIndex(0);
        this.#isResizerEnabledForKeyboard = true;
        this.#resizersDiv.firstChild.focus({
            focusVisible: true
        });
        event.preventDefault();
        event.stopImmediatePropagation();
    }
    #resizerKeydown(event) {
        $9ef033443a74bee6$var$AnnotationEditor._resizerKeyboardManager.exec(this, event);
    }
    #resizerBlur(event) {
        if (this.#isResizerEnabledForKeyboard && event.relatedTarget?.parentNode !== this.#resizersDiv) this.#stopResizing();
    }
    #resizerFocus(name) {
        this.#focusedResizerName = this.#isResizerEnabledForKeyboard ? name : "";
    }
    #setResizerTabIndex(value) {
        if (!this.#allResizerDivs) return;
        for (const div of this.#allResizerDivs)div.tabIndex = value;
    }
    _resizeWithKeyboard(x, y) {
        if (!this.#isResizerEnabledForKeyboard) return;
        this.#resizerPointermove(this.#focusedResizerName, {
            deltaX: x,
            deltaY: y,
            fromKeyboard: true
        });
    }
    #stopResizing() {
        this.#isResizerEnabledForKeyboard = false;
        this.#setResizerTabIndex(-1);
        this.#addResizeToUndoStack();
    }
    _stopResizingWithKeyboard() {
        this.#stopResizing();
        this.div.focus();
    }
    select() {
        if (this.isSelected && this._editToolbar) {
            this._editToolbar.show();
            return;
        }
        this.isSelected = true;
        this.makeResizable();
        this.div?.classList.add("selectedEditor");
        if (!this._editToolbar) {
            this.addEditToolbar().then(()=>{
                if (this.div?.classList.contains("selectedEditor")) this._editToolbar?.show();
            });
            return;
        }
        this._editToolbar?.show();
        this.#altText?.toggleAltTextBadge(false);
    }
    focus() {
        if (this.div && !this.div.contains(document.activeElement)) setTimeout(()=>this.div?.focus({
                preventScroll: true
            }), 0);
    }
    unselect() {
        if (!this.isSelected) return;
        this.isSelected = false;
        this.#resizersDiv?.classList.add("hidden");
        this.div?.classList.remove("selectedEditor");
        if (this.div?.contains(document.activeElement)) this._uiManager.currentLayer.div.focus({
            preventScroll: true
        });
        this._editToolbar?.hide();
        this.#altText?.toggleAltTextBadge(true);
        if (this.hasComment) this._uiManager.toggleComment(this, false, false);
    }
    updateParams(type, value) {}
    disableEditing() {}
    enableEditing() {}
    get canChangeContent() {
        return false;
    }
    enterInEditMode() {
        if (!this.canChangeContent) return;
        this.enableEditMode();
        this.div.focus();
    }
    dblclick(event) {
        if (event.target.nodeName === "BUTTON") return;
        this.enterInEditMode();
        this.parent.updateToolbar({
            mode: this.constructor._editorType,
            editId: this.id
        });
    }
    getElementForAltText() {
        return this.div;
    }
    get contentDiv() {
        return this.div;
    }
    get isEditing() {
        return this.#isEditing;
    }
    set isEditing(value) {
        this.#isEditing = value;
        if (!this.parent) return;
        if (value) {
            this.parent.setSelected(this);
            this.parent.setActiveEditor(this);
        } else this.parent.setActiveEditor(null);
    }
    static get MIN_SIZE() {
        return 16;
    }
    static canCreateNewEmptyEditor() {
        return true;
    }
    get telemetryInitialData() {
        return {
            action: "added"
        };
    }
    get telemetryFinalData() {
        return null;
    }
    _reportTelemetry(data, mustWait = false) {
        if (mustWait) {
            this.#telemetryTimeouts ||= new Map();
            const { action: action } = data;
            let timeout = this.#telemetryTimeouts.get(action);
            if (timeout) clearTimeout(timeout);
            timeout = setTimeout(()=>{
                this._reportTelemetry(data);
                this.#telemetryTimeouts.delete(action);
                if (this.#telemetryTimeouts.size === 0) this.#telemetryTimeouts = null;
            }, $9ef033443a74bee6$var$AnnotationEditor._telemetryTimeout);
            this.#telemetryTimeouts.set(action, timeout);
            return;
        }
        data.type ||= this.editorType;
        this._uiManager._eventBus.dispatch("reporttelemetry", {
            source: this,
            details: {
                type: "editing",
                data: data
            }
        });
    }
    show(visible = this._isVisible) {
        this.div.classList.toggle("hidden", !visible);
        this._isVisible = visible;
    }
    enable() {
        if (this.div) this.div.tabIndex = 0;
        this.#disabled = false;
    }
    disable() {
        if (this.div) this.div.tabIndex = -1;
        this.#disabled = true;
    }
    updateFakeAnnotationElement(annotationLayer) {
        if (!this.#fakeAnnotation && !this.deleted) {
            this.#fakeAnnotation = annotationLayer.addFakeAnnotation(this);
            return;
        }
        if (this.deleted) {
            this.#fakeAnnotation.remove();
            this.#fakeAnnotation = null;
            return;
        }
        if (this.hasEditedComment || this._hasBeenMoved || this._hasBeenResized) this.#fakeAnnotation.updateEdited({
            rect: this.getPDFRect(),
            popup: this.comment
        });
    }
    renderAnnotationElement(annotation) {
        if (this.deleted) {
            annotation.hide();
            return null;
        }
        let content = annotation.container.querySelector(".annotationContent");
        if (!content) {
            content = document.createElement("div");
            content.classList.add("annotationContent", this.editorType);
            annotation.container.prepend(content);
        } else if (content.nodeName === "CANVAS") {
            const canvas = content;
            content = document.createElement("div");
            content.classList.add("annotationContent", this.editorType);
            canvas.before(content);
        }
        return content;
    }
    resetAnnotationElement(annotation) {
        const { firstChild: firstChild } = annotation.container;
        if (firstChild?.nodeName === "DIV" && firstChild.classList.contains("annotationContent")) firstChild.remove();
    }
}
class $9ef033443a74bee6$var$FakeEditor extends $9ef033443a74bee6$var$AnnotationEditor {
    constructor(params){
        super(params);
        this.annotationElementId = params.annotationElementId;
        this.deleted = true;
    }
    serialize() {
        return this.serializeDeleted();
    }
}
const $9ef033443a74bee6$var$SEED = 0xc3d2e1f0;
const $9ef033443a74bee6$var$MASK_HIGH = 0xffff0000;
const $9ef033443a74bee6$var$MASK_LOW = 0xffff;
class $9ef033443a74bee6$var$MurmurHash3_64 {
    constructor(seed){
        this.h1 = seed ? seed & 0xffffffff : $9ef033443a74bee6$var$SEED;
        this.h2 = seed ? seed & 0xffffffff : $9ef033443a74bee6$var$SEED;
    }
    update(input) {
        let data, length;
        if (typeof input === "string") {
            data = new Uint8Array(input.length * 2);
            length = 0;
            for(let i = 0, ii = input.length; i < ii; i++){
                const code = input.charCodeAt(i);
                if (code <= 0xff) data[length++] = code;
                else {
                    data[length++] = code >>> 8;
                    data[length++] = code & 0xff;
                }
            }
        } else if (ArrayBuffer.isView(input)) {
            data = input.slice();
            length = data.byteLength;
        } else throw new Error("Invalid data format, must be a string or TypedArray.");
        const blockCounts = length >> 2;
        const tailLength = length - blockCounts * 4;
        const dataUint32 = new Uint32Array(data.buffer, 0, blockCounts);
        let k1 = 0, k2 = 0;
        let h1 = this.h1, h2 = this.h2;
        const C1 = 0xcc9e2d51, C2 = 0x1b873593;
        const C1_LOW = C1 & $9ef033443a74bee6$var$MASK_LOW, C2_LOW = C2 & $9ef033443a74bee6$var$MASK_LOW;
        for(let i = 0; i < blockCounts; i++)if (i & 1) {
            k1 = dataUint32[i];
            k1 = k1 * C1 & $9ef033443a74bee6$var$MASK_HIGH | k1 * C1_LOW & $9ef033443a74bee6$var$MASK_LOW;
            k1 = k1 << 15 | k1 >>> 17;
            k1 = k1 * C2 & $9ef033443a74bee6$var$MASK_HIGH | k1 * C2_LOW & $9ef033443a74bee6$var$MASK_LOW;
            h1 ^= k1;
            h1 = h1 << 13 | h1 >>> 19;
            h1 = h1 * 5 + 0xe6546b64;
        } else {
            k2 = dataUint32[i];
            k2 = k2 * C1 & $9ef033443a74bee6$var$MASK_HIGH | k2 * C1_LOW & $9ef033443a74bee6$var$MASK_LOW;
            k2 = k2 << 15 | k2 >>> 17;
            k2 = k2 * C2 & $9ef033443a74bee6$var$MASK_HIGH | k2 * C2_LOW & $9ef033443a74bee6$var$MASK_LOW;
            h2 ^= k2;
            h2 = h2 << 13 | h2 >>> 19;
            h2 = h2 * 5 + 0xe6546b64;
        }
        k1 = 0;
        switch(tailLength){
            case 3:
                k1 ^= data[blockCounts * 4 + 2] << 16;
            case 2:
                k1 ^= data[blockCounts * 4 + 1] << 8;
            case 1:
                k1 ^= data[blockCounts * 4];
                k1 = k1 * C1 & $9ef033443a74bee6$var$MASK_HIGH | k1 * C1_LOW & $9ef033443a74bee6$var$MASK_LOW;
                k1 = k1 << 15 | k1 >>> 17;
                k1 = k1 * C2 & $9ef033443a74bee6$var$MASK_HIGH | k1 * C2_LOW & $9ef033443a74bee6$var$MASK_LOW;
                if (blockCounts & 1) h1 ^= k1;
                else h2 ^= k1;
        }
        this.h1 = h1;
        this.h2 = h2;
    }
    hexdigest() {
        let h1 = this.h1, h2 = this.h2;
        h1 ^= h2 >>> 1;
        h1 = h1 * 0xed558ccd & $9ef033443a74bee6$var$MASK_HIGH | h1 * 0x8ccd & $9ef033443a74bee6$var$MASK_LOW;
        h2 = h2 * 0xff51afd7 & $9ef033443a74bee6$var$MASK_HIGH | ((h2 << 16 | h1 >>> 16) * 0xafd7ed55 & $9ef033443a74bee6$var$MASK_HIGH) >>> 16;
        h1 ^= h2 >>> 1;
        h1 = h1 * 0x1a85ec53 & $9ef033443a74bee6$var$MASK_HIGH | h1 * 0xec53 & $9ef033443a74bee6$var$MASK_LOW;
        h2 = h2 * 0xc4ceb9fe & $9ef033443a74bee6$var$MASK_HIGH | ((h2 << 16 | h1 >>> 16) * 0xb9fe1a85 & $9ef033443a74bee6$var$MASK_HIGH) >>> 16;
        h1 ^= h2 >>> 1;
        return (h1 >>> 0).toString(16).padStart(8, "0") + (h2 >>> 0).toString(16).padStart(8, "0");
    }
}
const $9ef033443a74bee6$var$SerializableEmpty = Object.freeze({
    map: null,
    hash: "",
    transfer: undefined
});
class $9ef033443a74bee6$var$AnnotationStorage {
    #modified = false;
    #modifiedIds = null;
    #editorsMap = null;
    #storage = new Map();
    constructor(){
        this.onSetModified = null;
        this.onResetModified = null;
        this.onAnnotationEditor = null;
    }
    getValue(key, defaultValue) {
        const value = this.#storage.get(key);
        if (value === undefined) return defaultValue;
        return Object.assign(defaultValue, value);
    }
    getRawValue(key) {
        return this.#storage.get(key);
    }
    remove(key) {
        const storedValue = this.#storage.get(key);
        if (storedValue === undefined) return;
        if (storedValue instanceof $9ef033443a74bee6$var$AnnotationEditor) this.#editorsMap.delete(storedValue.annotationElementId);
        this.#storage.delete(key);
        if (this.#storage.size === 0) this.resetModified();
        if (typeof this.onAnnotationEditor === "function") {
            for (const value of this.#storage.values()){
                if (value instanceof $9ef033443a74bee6$var$AnnotationEditor) return;
            }
            this.onAnnotationEditor(null);
        }
    }
    setValue(key, value) {
        const obj = this.#storage.get(key);
        let modified = false;
        if (obj !== undefined) {
            for (const [entry, val] of Object.entries(value))if (obj[entry] !== val) {
                modified = true;
                obj[entry] = val;
            }
        } else {
            modified = true;
            this.#storage.set(key, value);
        }
        if (modified) this.#setModified();
        if (value instanceof $9ef033443a74bee6$var$AnnotationEditor) {
            (this.#editorsMap ||= new Map()).set(value.annotationElementId, value);
            if (typeof this.onAnnotationEditor === "function") this.onAnnotationEditor(value.constructor._type);
        }
    }
    has(key) {
        return this.#storage.has(key);
    }
    get size() {
        return this.#storage.size;
    }
    #setModified() {
        if (!this.#modified) {
            this.#modified = true;
            if (typeof this.onSetModified === "function") this.onSetModified();
        }
    }
    resetModified() {
        if (this.#modified) {
            this.#modified = false;
            if (typeof this.onResetModified === "function") this.onResetModified();
        }
    }
    get print() {
        return new $9ef033443a74bee6$var$PrintAnnotationStorage(this);
    }
    get serializable() {
        if (this.#storage.size === 0) return $9ef033443a74bee6$var$SerializableEmpty;
        const map = new Map(), hash = new $9ef033443a74bee6$var$MurmurHash3_64(), transfer = [];
        const context = Object.create(null);
        let hasBitmap = false;
        for (const [key, val] of this.#storage){
            const serialized = val instanceof $9ef033443a74bee6$var$AnnotationEditor ? val.serialize(false, context) : val;
            if (serialized) {
                map.set(key, serialized);
                hash.update(`${key}:${JSON.stringify(serialized)}`);
                hasBitmap ||= !!serialized.bitmap;
            }
        }
        if (hasBitmap) {
            for (const value of map.values())if (value.bitmap) transfer.push(value.bitmap);
        }
        return map.size > 0 ? {
            map: map,
            hash: hash.hexdigest(),
            transfer: transfer
        } : $9ef033443a74bee6$var$SerializableEmpty;
    }
    get editorStats() {
        let stats = null;
        const typeToEditor = new Map();
        let numberOfEditedComments = 0;
        let numberOfDeletedComments = 0;
        for (const value of this.#storage.values()){
            if (!(value instanceof $9ef033443a74bee6$var$AnnotationEditor)) {
                if (value.popup) {
                    if (value.popup.deleted) numberOfDeletedComments += 1;
                    else numberOfEditedComments += 1;
                }
                continue;
            }
            if (value.isCommentDeleted) numberOfDeletedComments += 1;
            else if (value.hasEditedComment) numberOfEditedComments += 1;
            const editorStats = value.telemetryFinalData;
            if (!editorStats) continue;
            const { type: type } = editorStats;
            if (!typeToEditor.has(type)) typeToEditor.set(type, Object.getPrototypeOf(value).constructor);
            stats ||= Object.create(null);
            const map = stats[type] ||= new Map();
            for (const [key, val] of Object.entries(editorStats)){
                if (key === "type") continue;
                let counters = map.get(key);
                if (!counters) {
                    counters = new Map();
                    map.set(key, counters);
                }
                const count = counters.get(val) ?? 0;
                counters.set(val, count + 1);
            }
        }
        if (numberOfDeletedComments > 0 || numberOfEditedComments > 0) {
            stats ||= Object.create(null);
            stats.comments = {
                deleted: numberOfDeletedComments,
                edited: numberOfEditedComments
            };
        }
        if (!stats) return null;
        for (const [type, editor] of typeToEditor)stats[type] = editor.computeTelemetryFinalData(stats[type]);
        return stats;
    }
    resetModifiedIds() {
        this.#modifiedIds = null;
    }
    updateEditor(annotationId, data) {
        const value = this.#editorsMap?.get(annotationId);
        if (value) {
            value.updateFromAnnotationLayer(data);
            return true;
        }
        return false;
    }
    getEditor(annotationId) {
        return this.#editorsMap?.get(annotationId) || null;
    }
    get modifiedIds() {
        if (this.#modifiedIds) return this.#modifiedIds;
        const ids = [];
        if (this.#editorsMap) for (const value of this.#editorsMap.values()){
            if (!value.serialize()) continue;
            ids.push(value.annotationElementId);
        }
        return this.#modifiedIds = {
            ids: new Set(ids),
            hash: ids.join(",")
        };
    }
    [Symbol.iterator]() {
        return this.#storage.entries();
    }
}
class $9ef033443a74bee6$var$PrintAnnotationStorage extends $9ef033443a74bee6$var$AnnotationStorage {
    #serializable;
    constructor(parent){
        super();
        const { map: map, hash: hash, transfer: transfer } = parent.serializable;
        const clone = structuredClone(map, transfer ? {
            transfer: transfer
        } : null);
        this.#serializable = {
            map: clone,
            hash: hash,
            transfer: transfer
        };
    }
    get print() {
        $9ef033443a74bee6$var$unreachable("Should not call PrintAnnotationStorage.print");
    }
    get serializable() {
        return this.#serializable;
    }
    get modifiedIds() {
        return $9ef033443a74bee6$export$b8972b998723d602(this, "modifiedIds", {
            ids: new Set(),
            hash: ""
        });
    }
}
class $9ef033443a74bee6$var$FontLoader {
    #systemFonts = new Set();
    constructor({ ownerDocument: ownerDocument = globalThis.document, styleElement: styleElement = null }){
        this._document = ownerDocument;
        this.nativeFontFaces = new Set();
        this.styleElement = null;
        this.loadingRequests = [];
        this.loadTestFontId = 0;
    }
    addNativeFontFace(nativeFontFace) {
        this.nativeFontFaces.add(nativeFontFace);
        this._document.fonts.add(nativeFontFace);
    }
    removeNativeFontFace(nativeFontFace) {
        this.nativeFontFaces.delete(nativeFontFace);
        this._document.fonts.delete(nativeFontFace);
    }
    insertRule(rule) {
        if (!this.styleElement) {
            this.styleElement = this._document.createElement("style");
            this._document.documentElement.getElementsByTagName("head")[0].append(this.styleElement);
        }
        const styleSheet = this.styleElement.sheet;
        styleSheet.insertRule(rule, styleSheet.cssRules.length);
    }
    clear() {
        for (const nativeFontFace of this.nativeFontFaces)this._document.fonts.delete(nativeFontFace);
        this.nativeFontFaces.clear();
        this.#systemFonts.clear();
        if (this.styleElement) {
            this.styleElement.remove();
            this.styleElement = null;
        }
    }
    async loadSystemFont({ systemFontInfo: info, disableFontFace: disableFontFace, _inspectFont: _inspectFont }) {
        if (!info || this.#systemFonts.has(info.loadedName)) return;
        $9ef033443a74bee6$var$assert(!disableFontFace, "loadSystemFont shouldn't be called when `disableFontFace` is set.");
        if (this.isFontLoadingAPISupported) {
            const { loadedName: loadedName, src: src, style: style } = info;
            const fontFace = new FontFace(loadedName, src, style);
            this.addNativeFontFace(fontFace);
            try {
                await fontFace.load();
                this.#systemFonts.add(loadedName);
                _inspectFont?.(info);
            } catch  {
                $9ef033443a74bee6$var$warn(`Cannot load system font: ${info.baseFontName}, installing it could help to improve PDF rendering.`);
                this.removeNativeFontFace(fontFace);
            }
            return;
        }
        $9ef033443a74bee6$var$unreachable("Not implemented: loadSystemFont without the Font Loading API.");
    }
    async bind(font) {
        if (font.attached || font.missingFile && !font.systemFontInfo) return;
        font.attached = true;
        if (font.systemFontInfo) {
            await this.loadSystemFont(font);
            return;
        }
        if (this.isFontLoadingAPISupported) {
            const nativeFontFace = font.createNativeFontFace();
            if (nativeFontFace) {
                this.addNativeFontFace(nativeFontFace);
                try {
                    await nativeFontFace.loaded;
                } catch (ex) {
                    $9ef033443a74bee6$var$warn(`Failed to load font '${nativeFontFace.family}': '${ex}'.`);
                    font.disableFontFace = true;
                    throw ex;
                }
            }
            return;
        }
        const rule = font.createFontFaceRule();
        if (rule) {
            this.insertRule(rule);
            if (this.isSyncFontLoadingSupported) return;
            await new Promise((resolve)=>{
                const request = this._queueLoadingCallback(resolve);
                this._prepareFontLoadEvent(font, request);
            });
        }
    }
    get isFontLoadingAPISupported() {
        const hasFonts = !!this._document?.fonts;
        return $9ef033443a74bee6$export$b8972b998723d602(this, "isFontLoadingAPISupported", hasFonts);
    }
    get isSyncFontLoadingSupported() {
        return $9ef033443a74bee6$export$b8972b998723d602(this, "isSyncFontLoadingSupported", $9ef033443a74bee6$var$isNodeJS || $9ef033443a74bee6$export$5fb8891d35c36978.platform.isFirefox);
    }
    _queueLoadingCallback(callback) {
        function completeRequest() {
            $9ef033443a74bee6$var$assert(!request.done, "completeRequest() cannot be called twice.");
            request.done = true;
            while(loadingRequests.length > 0 && loadingRequests[0].done){
                const otherRequest = loadingRequests.shift();
                setTimeout(otherRequest.callback, 0);
            }
        }
        const { loadingRequests: loadingRequests } = this;
        const request = {
            done: false,
            complete: completeRequest,
            callback: callback
        };
        loadingRequests.push(request);
        return request;
    }
    get _loadTestFont() {
        const testFont = atob("T1RUTwALAIAAAwAwQ0ZGIDHtZg4AAAOYAAAAgUZGVE1lkzZwAAAEHAAAABxHREVGABQAFQAABDgAAAAeT1MvMlYNYwkAAAEgAAAAYGNtYXABDQLUAAACNAAAAUJoZWFk/xVFDQAAALwAAAA2aGhlYQdkA+oAAAD0AAAAJGhtdHgD6AAAAAAEWAAAAAZtYXhwAAJQAAAAARgAAAAGbmFtZVjmdH4AAAGAAAAAsXBvc3T/hgAzAAADeAAAACAAAQAAAAEAALZRFsRfDzz1AAsD6AAAAADOBOTLAAAAAM4KHDwAAAAAA+gDIQAAAAgAAgAAAAAAAAABAAADIQAAAFoD6AAAAAAD6AABAAAAAAAAAAAAAAAAAAAAAQAAUAAAAgAAAAQD6AH0AAUAAAKKArwAAACMAooCvAAAAeAAMQECAAACAAYJAAAAAAAAAAAAAQAAAAAAAAAAAAAAAFBmRWQAwAAuAC4DIP84AFoDIQAAAAAAAQAAAAAAAAAAACAAIAABAAAADgCuAAEAAAAAAAAAAQAAAAEAAAAAAAEAAQAAAAEAAAAAAAIAAQAAAAEAAAAAAAMAAQAAAAEAAAAAAAQAAQAAAAEAAAAAAAUAAQAAAAEAAAAAAAYAAQAAAAMAAQQJAAAAAgABAAMAAQQJAAEAAgABAAMAAQQJAAIAAgABAAMAAQQJAAMAAgABAAMAAQQJAAQAAgABAAMAAQQJAAUAAgABAAMAAQQJAAYAAgABWABYAAAAAAAAAwAAAAMAAAAcAAEAAAAAADwAAwABAAAAHAAEACAAAAAEAAQAAQAAAC7//wAAAC7////TAAEAAAAAAAABBgAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAAAAAAAD/gwAyAAAAAQAAAAAAAAAAAAAAAAAAAAABAAQEAAEBAQJYAAEBASH4DwD4GwHEAvgcA/gXBIwMAYuL+nz5tQXkD5j3CBLnEQACAQEBIVhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYAAABAQAADwACAQEEE/t3Dov6fAH6fAT+fPp8+nwHDosMCvm1Cvm1DAz6fBQAAAAAAAABAAAAAMmJbzEAAAAAzgTjFQAAAADOBOQpAAEAAAAAAAAADAAUAAQAAAABAAAAAgABAAAAAAAAAAAD6AAAAAAAAA==");
        return $9ef033443a74bee6$export$b8972b998723d602(this, "_loadTestFont", testFont);
    }
    _prepareFontLoadEvent(font, request) {
        function int32(data, offset) {
            return data.charCodeAt(offset) << 24 | data.charCodeAt(offset + 1) << 16 | data.charCodeAt(offset + 2) << 8 | data.charCodeAt(offset + 3) & 0xff;
        }
        function spliceString(s, offset, remove, insert) {
            const chunk1 = s.substring(0, offset);
            const chunk2 = s.substring(offset + remove);
            return chunk1 + insert + chunk2;
        }
        let i, ii;
        const canvas = this._document.createElement("canvas");
        canvas.width = 1;
        canvas.height = 1;
        const ctx = canvas.getContext("2d");
        let called = 0;
        function isFontReady(name, callback) {
            if (++called > 30) {
                $9ef033443a74bee6$var$warn("Load test font never loaded.");
                callback();
                return;
            }
            ctx.font = "30px " + name;
            ctx.fillText(".", 0, 20);
            const imageData = ctx.getImageData(0, 0, 1, 1);
            if (imageData.data[3] > 0) {
                callback();
                return;
            }
            setTimeout(isFontReady.bind(null, name, callback));
        }
        const loadTestFontId = `lt${Date.now()}${this.loadTestFontId++}`;
        let data = this._loadTestFont;
        const COMMENT_OFFSET = 976;
        data = spliceString(data, COMMENT_OFFSET, loadTestFontId.length, loadTestFontId);
        const CFF_CHECKSUM_OFFSET = 16;
        const XXXX_VALUE = 0x58585858;
        let checksum = int32(data, CFF_CHECKSUM_OFFSET);
        for(i = 0, ii = loadTestFontId.length - 3; i < ii; i += 4)checksum = checksum - XXXX_VALUE + int32(loadTestFontId, i) | 0;
        if (i < loadTestFontId.length) checksum = checksum - XXXX_VALUE + int32(loadTestFontId + "XXX", i) | 0;
        data = spliceString(data, CFF_CHECKSUM_OFFSET, 4, $9ef033443a74bee6$var$string32(checksum));
        const url = `url(data:font/opentype;base64,${btoa(data)});`;
        const rule = `@font-face {font-family:"${loadTestFontId}";src:${url}}`;
        this.insertRule(rule);
        const div = this._document.createElement("div");
        div.style.visibility = "hidden";
        div.style.width = div.style.height = "10px";
        div.style.position = "absolute";
        div.style.top = div.style.left = "0px";
        for (const name of [
            font.loadedName,
            loadTestFontId
        ]){
            const span = this._document.createElement("span");
            span.textContent = "Hi";
            span.style.fontFamily = name;
            div.append(span);
        }
        this._document.body.append(div);
        isFontReady(loadTestFontId, ()=>{
            div.remove();
            request.complete();
        });
    }
}
class $9ef033443a74bee6$var$FontFaceObject {
    #fontData;
    constructor(translatedData, inspectFont = null, extra, charProcOperatorList){
        this.compiledGlyphs = Object.create(null);
        this.#fontData = translatedData;
        this._inspectFont = inspectFont;
        if (extra) Object.assign(this, extra);
        if (charProcOperatorList) this.charProcOperatorList = charProcOperatorList;
    }
    createNativeFontFace() {
        if (!this.data || this.disableFontFace) return null;
        let nativeFontFace;
        if (!this.cssFontInfo) nativeFontFace = new FontFace(this.loadedName, this.data, {});
        else {
            const css = {
                weight: this.cssFontInfo.fontWeight
            };
            if (this.cssFontInfo.italicAngle) css.style = `oblique ${this.cssFontInfo.italicAngle}deg`;
            nativeFontFace = new FontFace(this.cssFontInfo.fontFamily, this.data, css);
        }
        this._inspectFont?.(this);
        return nativeFontFace;
    }
    createFontFaceRule() {
        if (!this.data || this.disableFontFace) return null;
        const url = `url(data:${this.mimetype};base64,${$9ef033443a74bee6$var$toBase64Util(this.data)});`;
        let rule;
        if (!this.cssFontInfo) rule = `@font-face {font-family:"${this.loadedName}";src:${url}}`;
        else {
            let css = `font-weight: ${this.cssFontInfo.fontWeight};`;
            if (this.cssFontInfo.italicAngle) css += `font-style: oblique ${this.cssFontInfo.italicAngle}deg;`;
            rule = `@font-face {font-family:"${this.cssFontInfo.fontFamily}";${css}src:${url}}`;
        }
        this._inspectFont?.(this, url);
        return rule;
    }
    getPathGenerator(objs, character) {
        if (this.compiledGlyphs[character] !== undefined) return this.compiledGlyphs[character];
        const objId = this.loadedName + "_path_" + character;
        let cmds;
        try {
            cmds = objs.get(objId);
        } catch (ex) {
            $9ef033443a74bee6$var$warn(`getPathGenerator - ignoring character: "${ex}".`);
        }
        const path = new Path2D(cmds || "");
        if (!this.fontExtraProperties) objs.delete(objId);
        return this.compiledGlyphs[character] = path;
    }
    get black() {
        return this.#fontData.black;
    }
    get bold() {
        return this.#fontData.bold;
    }
    get disableFontFace() {
        return this.#fontData.disableFontFace ?? false;
    }
    get fontExtraProperties() {
        return this.#fontData.fontExtraProperties ?? false;
    }
    get isInvalidPDFjsFont() {
        return this.#fontData.isInvalidPDFjsFont;
    }
    get isType3Font() {
        return this.#fontData.isType3Font;
    }
    get italic() {
        return this.#fontData.italic;
    }
    get missingFile() {
        return this.#fontData.missingFile;
    }
    get remeasure() {
        return this.#fontData.remeasure;
    }
    get vertical() {
        return this.#fontData.vertical;
    }
    get ascent() {
        return this.#fontData.ascent;
    }
    get defaultWidth() {
        return this.#fontData.defaultWidth;
    }
    get descent() {
        return this.#fontData.descent;
    }
    get bbox() {
        return this.#fontData.bbox;
    }
    get fontMatrix() {
        return this.#fontData.fontMatrix;
    }
    get fallbackName() {
        return this.#fontData.fallbackName;
    }
    get loadedName() {
        return this.#fontData.loadedName;
    }
    get mimetype() {
        return this.#fontData.mimetype;
    }
    get name() {
        return this.#fontData.name;
    }
    get data() {
        return this.#fontData.data;
    }
    clearData() {
        this.#fontData.clearData();
    }
    get cssFontInfo() {
        return this.#fontData.cssFontInfo;
    }
    get systemFontInfo() {
        return this.#fontData.systemFontInfo;
    }
    get defaultVMetrics() {
        return this.#fontData.defaultVMetrics;
    }
}
function $9ef033443a74bee6$var$getUrlProp(val) {
    if (val instanceof URL) return val.href;
    if (typeof val === "string") {
        if ($9ef033443a74bee6$var$isNodeJS) return val;
        const url = URL.parse(val, window.location);
        if (url) return url.href;
    }
    throw new Error("Invalid PDF url data: either string or URL-object is expected in the url property.");
}
function $9ef033443a74bee6$var$getDataProp(val) {
    if ($9ef033443a74bee6$var$isNodeJS && typeof $9ef033443a74bee6$require$Buffer !== "undefined" && val instanceof $9ef033443a74bee6$require$Buffer) throw new Error("Please provide binary data as `Uint8Array`, rather than `Buffer`.");
    if (val instanceof Uint8Array && val.byteLength === val.buffer.byteLength) return val;
    if (typeof val === "string") return $9ef033443a74bee6$var$stringToBytes(val);
    if (val instanceof ArrayBuffer || ArrayBuffer.isView(val) || typeof val === "object" && !isNaN(val?.length)) return new Uint8Array(val);
    throw new Error("Invalid PDF binary data: either TypedArray, string, or array-like object is expected in the data property.");
}
function $9ef033443a74bee6$var$getFactoryUrlProp(val) {
    if (typeof val !== "string") return null;
    if (val.endsWith("/")) return val;
    throw new Error(`Invalid factory url: "${val}" must include trailing slash.`);
}
const $9ef033443a74bee6$var$isRefProxy = (v)=>typeof v === "object" && Number.isInteger(v?.num) && v.num >= 0 && Number.isInteger(v?.gen) && v.gen >= 0;
const $9ef033443a74bee6$var$isNameProxy = (v)=>typeof v === "object" && typeof v?.name === "string";
const $9ef033443a74bee6$export$b5acece0a447dcdc = $9ef033443a74bee6$var$_isValidExplicitDest.bind(null, $9ef033443a74bee6$var$isRefProxy, $9ef033443a74bee6$var$isNameProxy);
class $9ef033443a74bee6$var$LoopbackPort {
    #listeners = new Map();
    #deferred = Promise.resolve();
    postMessage(obj, transfer) {
        const event = {
            data: structuredClone(obj, transfer ? {
                transfer: transfer
            } : null)
        };
        this.#deferred.then(()=>{
            for (const [listener] of this.#listeners)listener.call(this, event);
        });
    }
    addEventListener(name, listener, options = null) {
        let rmAbort = null;
        if (options?.signal instanceof AbortSignal) {
            const { signal: signal } = options;
            if (signal.aborted) {
                $9ef033443a74bee6$var$warn("LoopbackPort - cannot use an `aborted` signal.");
                return;
            }
            const onAbort = ()=>this.removeEventListener(name, listener);
            rmAbort = ()=>signal.removeEventListener("abort", onAbort);
            signal.addEventListener("abort", onAbort);
        }
        this.#listeners.set(listener, rmAbort);
    }
    removeEventListener(name, listener) {
        const rmAbort = this.#listeners.get(listener);
        rmAbort?.();
        this.#listeners.delete(listener);
    }
    terminate() {
        for (const [, rmAbort] of this.#listeners)rmAbort?.();
        this.#listeners.clear();
    }
}
const $9ef033443a74bee6$var$CallbackKind = {
    DATA: 1,
    ERROR: 2
};
const $9ef033443a74bee6$var$StreamKind = {
    CANCEL: 1,
    CANCEL_COMPLETE: 2,
    CLOSE: 3,
    ENQUEUE: 4,
    ERROR: 5,
    PULL: 6,
    PULL_COMPLETE: 7,
    START_COMPLETE: 8
};
function $9ef033443a74bee6$var$onFn() {}
function $9ef033443a74bee6$var$wrapReason(ex) {
    if (ex instanceof $9ef033443a74bee6$export$d0e978393d193d1a || ex instanceof $9ef033443a74bee6$export$e3d0f4ce5b91e9f1 || ex instanceof $9ef033443a74bee6$var$PasswordException || ex instanceof $9ef033443a74bee6$export$ea8e9c34f66e603 || ex instanceof $9ef033443a74bee6$var$UnknownErrorException) return ex;
    if (!(ex instanceof Error || typeof ex === "object" && ex !== null)) $9ef033443a74bee6$var$unreachable('wrapReason: Expected "reason" to be a (possibly cloned) Error.');
    switch(ex.name){
        case "AbortException":
            return new $9ef033443a74bee6$export$d0e978393d193d1a(ex.message);
        case "InvalidPDFException":
            return new $9ef033443a74bee6$export$e3d0f4ce5b91e9f1(ex.message);
        case "PasswordException":
            return new $9ef033443a74bee6$var$PasswordException(ex.message, ex.code);
        case "ResponseException":
            return new $9ef033443a74bee6$export$ea8e9c34f66e603(ex.message, ex.status, ex.missing);
        case "UnknownErrorException":
            return new $9ef033443a74bee6$var$UnknownErrorException(ex.message, ex.details);
    }
    return new $9ef033443a74bee6$var$UnknownErrorException(ex.message, ex.toString());
}
class $9ef033443a74bee6$var$MessageHandler {
    #messageAC = new AbortController();
    constructor(sourceName, targetName, comObj){
        this.sourceName = sourceName;
        this.targetName = targetName;
        this.comObj = comObj;
        this.callbackId = 1;
        this.streamId = 1;
        this.streamSinks = Object.create(null);
        this.streamControllers = Object.create(null);
        this.callbackCapabilities = Object.create(null);
        this.actionHandler = Object.create(null);
        comObj.addEventListener("message", this.#onMessage.bind(this), {
            signal: this.#messageAC.signal
        });
    }
    #onMessage({ data: data }) {
        if (data.targetName !== this.sourceName) return;
        if (data.stream) {
            this.#processStreamMessage(data);
            return;
        }
        if (data.callback) {
            const callbackId = data.callbackId;
            const capability = this.callbackCapabilities[callbackId];
            if (!capability) throw new Error(`Cannot resolve callback ${callbackId}`);
            delete this.callbackCapabilities[callbackId];
            if (data.callback === $9ef033443a74bee6$var$CallbackKind.DATA) capability.resolve(data.data);
            else if (data.callback === $9ef033443a74bee6$var$CallbackKind.ERROR) capability.reject($9ef033443a74bee6$var$wrapReason(data.reason));
            else throw new Error("Unexpected callback case");
            return;
        }
        const action = this.actionHandler[data.action];
        if (!action) throw new Error(`Unknown action from worker: ${data.action}`);
        if (data.callbackId) {
            const sourceName = this.sourceName, targetName = data.sourceName, comObj = this.comObj;
            Promise.try(action, data.data).then(function(result) {
                comObj.postMessage({
                    sourceName: sourceName,
                    targetName: targetName,
                    callback: $9ef033443a74bee6$var$CallbackKind.DATA,
                    callbackId: data.callbackId,
                    data: result
                });
            }, function(reason) {
                comObj.postMessage({
                    sourceName: sourceName,
                    targetName: targetName,
                    callback: $9ef033443a74bee6$var$CallbackKind.ERROR,
                    callbackId: data.callbackId,
                    reason: $9ef033443a74bee6$var$wrapReason(reason)
                });
            });
            return;
        }
        if (data.streamId) {
            this.#createStreamSink(data);
            return;
        }
        action(data.data);
    }
    on(actionName, handler) {
        const ah = this.actionHandler;
        if (ah[actionName]) throw new Error(`There is already an actionName called "${actionName}"`);
        ah[actionName] = handler;
    }
    send(actionName, data, transfers) {
        this.comObj.postMessage({
            sourceName: this.sourceName,
            targetName: this.targetName,
            action: actionName,
            data: data
        }, transfers);
    }
    sendWithPromise(actionName, data, transfers) {
        const callbackId = this.callbackId++;
        const capability = Promise.withResolvers();
        this.callbackCapabilities[callbackId] = capability;
        try {
            this.comObj.postMessage({
                sourceName: this.sourceName,
                targetName: this.targetName,
                action: actionName,
                callbackId: callbackId,
                data: data
            }, transfers);
        } catch (ex) {
            capability.reject(ex);
        }
        return capability.promise;
    }
    sendWithStream(actionName, data, queueingStrategy, transfers) {
        const streamId = this.streamId++, sourceName = this.sourceName, targetName = this.targetName, comObj = this.comObj;
        return new ReadableStream({
            start: (controller)=>{
                const startCapability = Promise.withResolvers();
                this.streamControllers[streamId] = {
                    controller: controller,
                    startCall: startCapability,
                    pullCall: null,
                    cancelCall: null,
                    isClosed: false
                };
                comObj.postMessage({
                    sourceName: sourceName,
                    targetName: targetName,
                    action: actionName,
                    streamId: streamId,
                    data: data,
                    desiredSize: controller.desiredSize
                }, transfers);
                return startCapability.promise;
            },
            pull: (controller)=>{
                const pullCapability = Promise.withResolvers();
                this.streamControllers[streamId].pullCall = pullCapability;
                comObj.postMessage({
                    sourceName: sourceName,
                    targetName: targetName,
                    stream: $9ef033443a74bee6$var$StreamKind.PULL,
                    streamId: streamId,
                    desiredSize: controller.desiredSize
                });
                return pullCapability.promise;
            },
            cancel: (reason)=>{
                $9ef033443a74bee6$var$assert(reason instanceof Error, "cancel must have a valid reason");
                const cancelCapability = Promise.withResolvers();
                this.streamControllers[streamId].cancelCall = cancelCapability;
                this.streamControllers[streamId].isClosed = true;
                comObj.postMessage({
                    sourceName: sourceName,
                    targetName: targetName,
                    stream: $9ef033443a74bee6$var$StreamKind.CANCEL,
                    streamId: streamId,
                    reason: $9ef033443a74bee6$var$wrapReason(reason)
                });
                return cancelCapability.promise;
            }
        }, queueingStrategy);
    }
    #createStreamSink(data) {
        const streamId = data.streamId, sourceName = this.sourceName, targetName = data.sourceName, comObj = this.comObj;
        const self = this, action = this.actionHandler[data.action];
        const streamSink = {
            enqueue (chunk, size = 1, transfers) {
                if (this.isCancelled) return;
                const lastDesiredSize = this.desiredSize;
                this.desiredSize -= size;
                if (lastDesiredSize > 0 && this.desiredSize <= 0) {
                    this.sinkCapability = Promise.withResolvers();
                    this.ready = this.sinkCapability.promise;
                }
                comObj.postMessage({
                    sourceName: sourceName,
                    targetName: targetName,
                    stream: $9ef033443a74bee6$var$StreamKind.ENQUEUE,
                    streamId: streamId,
                    chunk: chunk
                }, transfers);
            },
            close () {
                if (this.isCancelled) return;
                this.isCancelled = true;
                comObj.postMessage({
                    sourceName: sourceName,
                    targetName: targetName,
                    stream: $9ef033443a74bee6$var$StreamKind.CLOSE,
                    streamId: streamId
                });
                delete self.streamSinks[streamId];
            },
            error (reason) {
                $9ef033443a74bee6$var$assert(reason instanceof Error, "error must have a valid reason");
                if (this.isCancelled) return;
                this.isCancelled = true;
                comObj.postMessage({
                    sourceName: sourceName,
                    targetName: targetName,
                    stream: $9ef033443a74bee6$var$StreamKind.ERROR,
                    streamId: streamId,
                    reason: $9ef033443a74bee6$var$wrapReason(reason)
                });
            },
            sinkCapability: Promise.withResolvers(),
            onPull: null,
            onCancel: null,
            isCancelled: false,
            desiredSize: data.desiredSize,
            ready: null
        };
        streamSink.sinkCapability.resolve();
        streamSink.ready = streamSink.sinkCapability.promise;
        this.streamSinks[streamId] = streamSink;
        Promise.try(action, data.data, streamSink).then(function() {
            comObj.postMessage({
                sourceName: sourceName,
                targetName: targetName,
                stream: $9ef033443a74bee6$var$StreamKind.START_COMPLETE,
                streamId: streamId,
                success: true
            });
        }, function(reason) {
            comObj.postMessage({
                sourceName: sourceName,
                targetName: targetName,
                stream: $9ef033443a74bee6$var$StreamKind.START_COMPLETE,
                streamId: streamId,
                reason: $9ef033443a74bee6$var$wrapReason(reason)
            });
        });
    }
    #processStreamMessage(data) {
        const streamId = data.streamId, sourceName = this.sourceName, targetName = data.sourceName, comObj = this.comObj;
        const streamController = this.streamControllers[streamId], streamSink = this.streamSinks[streamId];
        switch(data.stream){
            case $9ef033443a74bee6$var$StreamKind.START_COMPLETE:
                if (data.success) streamController.startCall.resolve();
                else streamController.startCall.reject($9ef033443a74bee6$var$wrapReason(data.reason));
                break;
            case $9ef033443a74bee6$var$StreamKind.PULL_COMPLETE:
                if (data.success) streamController.pullCall.resolve();
                else streamController.pullCall.reject($9ef033443a74bee6$var$wrapReason(data.reason));
                break;
            case $9ef033443a74bee6$var$StreamKind.PULL:
                if (!streamSink) {
                    comObj.postMessage({
                        sourceName: sourceName,
                        targetName: targetName,
                        stream: $9ef033443a74bee6$var$StreamKind.PULL_COMPLETE,
                        streamId: streamId,
                        success: true
                    });
                    break;
                }
                if (streamSink.desiredSize <= 0 && data.desiredSize > 0) streamSink.sinkCapability.resolve();
                streamSink.desiredSize = data.desiredSize;
                Promise.try(streamSink.onPull || $9ef033443a74bee6$var$onFn).then(function() {
                    comObj.postMessage({
                        sourceName: sourceName,
                        targetName: targetName,
                        stream: $9ef033443a74bee6$var$StreamKind.PULL_COMPLETE,
                        streamId: streamId,
                        success: true
                    });
                }, function(reason) {
                    comObj.postMessage({
                        sourceName: sourceName,
                        targetName: targetName,
                        stream: $9ef033443a74bee6$var$StreamKind.PULL_COMPLETE,
                        streamId: streamId,
                        reason: $9ef033443a74bee6$var$wrapReason(reason)
                    });
                });
                break;
            case $9ef033443a74bee6$var$StreamKind.ENQUEUE:
                $9ef033443a74bee6$var$assert(streamController, "enqueue should have stream controller");
                if (streamController.isClosed) break;
                streamController.controller.enqueue(data.chunk);
                break;
            case $9ef033443a74bee6$var$StreamKind.CLOSE:
                $9ef033443a74bee6$var$assert(streamController, "close should have stream controller");
                if (streamController.isClosed) break;
                streamController.isClosed = true;
                streamController.controller.close();
                this.#deleteStreamController(streamController, streamId);
                break;
            case $9ef033443a74bee6$var$StreamKind.ERROR:
                $9ef033443a74bee6$var$assert(streamController, "error should have stream controller");
                streamController.controller.error($9ef033443a74bee6$var$wrapReason(data.reason));
                this.#deleteStreamController(streamController, streamId);
                break;
            case $9ef033443a74bee6$var$StreamKind.CANCEL_COMPLETE:
                if (data.success) streamController.cancelCall.resolve();
                else streamController.cancelCall.reject($9ef033443a74bee6$var$wrapReason(data.reason));
                this.#deleteStreamController(streamController, streamId);
                break;
            case $9ef033443a74bee6$var$StreamKind.CANCEL:
                if (!streamSink) break;
                const dataReason = $9ef033443a74bee6$var$wrapReason(data.reason);
                Promise.try(streamSink.onCancel || $9ef033443a74bee6$var$onFn, dataReason).then(function() {
                    comObj.postMessage({
                        sourceName: sourceName,
                        targetName: targetName,
                        stream: $9ef033443a74bee6$var$StreamKind.CANCEL_COMPLETE,
                        streamId: streamId,
                        success: true
                    });
                }, function(reason) {
                    comObj.postMessage({
                        sourceName: sourceName,
                        targetName: targetName,
                        stream: $9ef033443a74bee6$var$StreamKind.CANCEL_COMPLETE,
                        streamId: streamId,
                        reason: $9ef033443a74bee6$var$wrapReason(reason)
                    });
                });
                streamSink.sinkCapability.reject(dataReason);
                streamSink.isCancelled = true;
                delete this.streamSinks[streamId];
                break;
            default:
                throw new Error("Unexpected stream case");
        }
    }
    async #deleteStreamController(streamController, streamId) {
        await Promise.allSettled([
            streamController.startCall?.promise,
            streamController.pullCall?.promise,
            streamController.cancelCall?.promise
        ]);
        delete this.streamControllers[streamId];
    }
    destroy() {
        this.#messageAC?.abort();
        this.#messageAC = null;
    }
}
class $9ef033443a74bee6$var$BaseCanvasFactory {
    #enableHWA = false;
    constructor({ enableHWA: enableHWA = false }){
        this.#enableHWA = enableHWA;
    }
    create(width, height) {
        if (width <= 0 || height <= 0) throw new Error("Invalid canvas size");
        const canvas = this._createCanvas(width, height);
        return {
            canvas: canvas,
            context: canvas.getContext("2d", {
                willReadFrequently: !this.#enableHWA
            })
        };
    }
    reset(canvasAndContext, width, height) {
        if (!canvasAndContext.canvas) throw new Error("Canvas is not specified");
        if (width <= 0 || height <= 0) throw new Error("Invalid canvas size");
        canvasAndContext.canvas.width = width;
        canvasAndContext.canvas.height = height;
    }
    destroy(canvasAndContext) {
        if (!canvasAndContext.canvas) throw new Error("Canvas is not specified");
        canvasAndContext.canvas.width = 0;
        canvasAndContext.canvas.height = 0;
        canvasAndContext.canvas = null;
        canvasAndContext.context = null;
    }
    _createCanvas(width, height) {
        $9ef033443a74bee6$var$unreachable("Abstract method `_createCanvas` called.");
    }
}
class $9ef033443a74bee6$var$DOMCanvasFactory extends $9ef033443a74bee6$var$BaseCanvasFactory {
    constructor({ ownerDocument: ownerDocument = globalThis.document, enableHWA: enableHWA = false }){
        super({
            enableHWA: enableHWA
        });
        this._document = ownerDocument;
    }
    _createCanvas(width, height) {
        const canvas = this._document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;
        return canvas;
    }
}
class $9ef033443a74bee6$var$BaseCMapReaderFactory {
    constructor({ baseUrl: baseUrl = null, isCompressed: isCompressed = true }){
        this.baseUrl = baseUrl;
        this.isCompressed = isCompressed;
    }
    async fetch({ name: name }) {
        if (!this.baseUrl) throw new Error("Ensure that the `cMapUrl` and `cMapPacked` API parameters are provided.");
        if (!name) throw new Error("CMap name must be specified.");
        const url = this.baseUrl + name + (this.isCompressed ? ".bcmap" : "");
        return this._fetch(url).then((cMapData)=>({
                cMapData: cMapData,
                isCompressed: this.isCompressed
            })).catch((reason)=>{
            throw new Error(`Unable to load ${this.isCompressed ? "binary " : ""}CMap at: ${url}`);
        });
    }
    async _fetch(url) {
        $9ef033443a74bee6$var$unreachable("Abstract method `_fetch` called.");
    }
}
class $9ef033443a74bee6$var$DOMCMapReaderFactory extends $9ef033443a74bee6$var$BaseCMapReaderFactory {
    async _fetch(url) {
        const data = await $9ef033443a74bee6$export$8134c072fddab6a5(url, this.isCompressed ? "arraybuffer" : "text");
        return data instanceof ArrayBuffer ? new Uint8Array(data) : $9ef033443a74bee6$var$stringToBytes(data);
    }
}
class $9ef033443a74bee6$var$BaseFilterFactory {
    addFilter(maps) {
        return "none";
    }
    addHCMFilter(fgColor, bgColor) {
        return "none";
    }
    addAlphaFilter(map) {
        return "none";
    }
    addLuminosityFilter(map) {
        return "none";
    }
    addHighlightHCMFilter(filterName, fgColor, bgColor, newFgColor, newBgColor) {
        return "none";
    }
    destroy(keepHCM = false) {}
}
class $9ef033443a74bee6$var$DOMFilterFactory extends $9ef033443a74bee6$var$BaseFilterFactory {
    #baseUrl;
    #_cache;
    #_defs;
    #docId;
    #document;
    #_hcmCache;
    #id = 0;
    constructor({ docId: docId, ownerDocument: ownerDocument = globalThis.document }){
        super();
        this.#docId = docId;
        this.#document = ownerDocument;
    }
    get #cache() {
        return this.#_cache ||= new Map();
    }
    get #hcmCache() {
        return this.#_hcmCache ||= new Map();
    }
    get #defs() {
        if (!this.#_defs) {
            const div = this.#document.createElement("div");
            const { style: style } = div;
            style.visibility = "hidden";
            style.contain = "strict";
            style.width = style.height = 0;
            style.position = "absolute";
            style.top = style.left = 0;
            style.zIndex = -1;
            const svg = this.#document.createElementNS($9ef033443a74bee6$var$SVG_NS, "svg");
            svg.setAttribute("width", 0);
            svg.setAttribute("height", 0);
            this.#_defs = this.#document.createElementNS($9ef033443a74bee6$var$SVG_NS, "defs");
            div.append(svg);
            svg.append(this.#_defs);
            this.#document.body.append(div);
        }
        return this.#_defs;
    }
    #createTables(maps) {
        if (maps.length === 1) {
            const mapR = maps[0];
            const buffer = new Array(256);
            for(let i = 0; i < 256; i++)buffer[i] = mapR[i] / 255;
            const table = buffer.join(",");
            return [
                table,
                table,
                table
            ];
        }
        const [mapR, mapG, mapB] = maps;
        const bufferR = new Array(256);
        const bufferG = new Array(256);
        const bufferB = new Array(256);
        for(let i = 0; i < 256; i++){
            bufferR[i] = mapR[i] / 255;
            bufferG[i] = mapG[i] / 255;
            bufferB[i] = mapB[i] / 255;
        }
        return [
            bufferR.join(","),
            bufferG.join(","),
            bufferB.join(",")
        ];
    }
    #createUrl(id) {
        if (this.#baseUrl === undefined) {
            this.#baseUrl = "";
            const url = this.#document.URL;
            if (url !== this.#document.baseURI) {
                if ($9ef033443a74bee6$export$f67aae4532d8295b(url)) $9ef033443a74bee6$var$warn('#createUrl: ignore "data:"-URL for performance reasons.');
                else this.#baseUrl = $9ef033443a74bee6$export$e1e4297c21ab9d13(url, "");
            }
        }
        return `url(${this.#baseUrl}#${id})`;
    }
    addFilter(maps) {
        if (!maps) return "none";
        let value = this.#cache.get(maps);
        if (value) return value;
        const [tableR, tableG, tableB] = this.#createTables(maps);
        const key = maps.length === 1 ? tableR : `${tableR}${tableG}${tableB}`;
        value = this.#cache.get(key);
        if (value) {
            this.#cache.set(maps, value);
            return value;
        }
        const id = `g_${this.#docId}_transfer_map_${this.#id++}`;
        const url = this.#createUrl(id);
        this.#cache.set(maps, url);
        this.#cache.set(key, url);
        const filter = this.#createFilter(id);
        this.#addTransferMapConversion(tableR, tableG, tableB, filter);
        return url;
    }
    addHCMFilter(fgColor, bgColor) {
        const key = `${fgColor}-${bgColor}`;
        const filterName = "base";
        let info = this.#hcmCache.get(filterName);
        if (info?.key === key) return info.url;
        if (info) {
            info.filter?.remove();
            info.key = key;
            info.url = "none";
            info.filter = null;
        } else {
            info = {
                key: key,
                url: "none",
                filter: null
            };
            this.#hcmCache.set(filterName, info);
        }
        if (!fgColor || !bgColor) return info.url;
        const fgRGB = this.#getRGB(fgColor);
        fgColor = $9ef033443a74bee6$export$f8f26dd395d7e1bd.makeHexColor(...fgRGB);
        const bgRGB = this.#getRGB(bgColor);
        bgColor = $9ef033443a74bee6$export$f8f26dd395d7e1bd.makeHexColor(...bgRGB);
        this.#defs.style.color = "";
        if (fgColor === "#000000" && bgColor === "#ffffff" || fgColor === bgColor) return info.url;
        const map = new Array(256);
        for(let i = 0; i <= 255; i++){
            const x = i / 255;
            map[i] = x <= 0.03928 ? x / 12.92 : ((x + 0.055) / 1.055) ** 2.4;
        }
        const table = map.join(",");
        const id = `g_${this.#docId}_hcm_filter`;
        const filter = info.filter = this.#createFilter(id);
        this.#addTransferMapConversion(table, table, table, filter);
        this.#addGrayConversion(filter);
        const getSteps = (c, n)=>{
            const start = fgRGB[c] / 255;
            const end = bgRGB[c] / 255;
            const arr = new Array(n + 1);
            for(let i = 0; i <= n; i++)arr[i] = start + i / n * (end - start);
            return arr.join(",");
        };
        this.#addTransferMapConversion(getSteps(0, 5), getSteps(1, 5), getSteps(2, 5), filter);
        info.url = this.#createUrl(id);
        return info.url;
    }
    addAlphaFilter(map) {
        let value = this.#cache.get(map);
        if (value) return value;
        const [tableA] = this.#createTables([
            map
        ]);
        const key = `alpha_${tableA}`;
        value = this.#cache.get(key);
        if (value) {
            this.#cache.set(map, value);
            return value;
        }
        const id = `g_${this.#docId}_alpha_map_${this.#id++}`;
        const url = this.#createUrl(id);
        this.#cache.set(map, url);
        this.#cache.set(key, url);
        const filter = this.#createFilter(id);
        this.#addTransferMapAlphaConversion(tableA, filter);
        return url;
    }
    addLuminosityFilter(map) {
        let value = this.#cache.get(map || "luminosity");
        if (value) return value;
        let tableA, key;
        if (map) {
            [tableA] = this.#createTables([
                map
            ]);
            key = `luminosity_${tableA}`;
        } else key = "luminosity";
        value = this.#cache.get(key);
        if (value) {
            this.#cache.set(map, value);
            return value;
        }
        const id = `g_${this.#docId}_luminosity_map_${this.#id++}`;
        const url = this.#createUrl(id);
        this.#cache.set(map, url);
        this.#cache.set(key, url);
        const filter = this.#createFilter(id);
        this.#addLuminosityConversion(filter);
        if (map) this.#addTransferMapAlphaConversion(tableA, filter);
        return url;
    }
    addHighlightHCMFilter(filterName, fgColor, bgColor, newFgColor, newBgColor) {
        const key = `${fgColor}-${bgColor}-${newFgColor}-${newBgColor}`;
        let info = this.#hcmCache.get(filterName);
        if (info?.key === key) return info.url;
        if (info) {
            info.filter?.remove();
            info.key = key;
            info.url = "none";
            info.filter = null;
        } else {
            info = {
                key: key,
                url: "none",
                filter: null
            };
            this.#hcmCache.set(filterName, info);
        }
        if (!fgColor || !bgColor) return info.url;
        const [fgRGB, bgRGB] = [
            fgColor,
            bgColor
        ].map(this.#getRGB.bind(this));
        let fgGray = Math.round(0.2126 * fgRGB[0] + 0.7152 * fgRGB[1] + 0.0722 * fgRGB[2]);
        let bgGray = Math.round(0.2126 * bgRGB[0] + 0.7152 * bgRGB[1] + 0.0722 * bgRGB[2]);
        let [newFgRGB, newBgRGB] = [
            newFgColor,
            newBgColor
        ].map(this.#getRGB.bind(this));
        if (bgGray < fgGray) [fgGray, bgGray, newFgRGB, newBgRGB] = [
            bgGray,
            fgGray,
            newBgRGB,
            newFgRGB
        ];
        this.#defs.style.color = "";
        const getSteps = (fg, bg, n)=>{
            const arr = new Array(256);
            const step = (bgGray - fgGray) / n;
            const newStart = fg / 255;
            const newStep = (bg - fg) / (255 * n);
            let prev = 0;
            for(let i = 0; i <= n; i++){
                const k = Math.round(fgGray + i * step);
                const value = newStart + i * newStep;
                for(let j = prev; j <= k; j++)arr[j] = value;
                prev = k + 1;
            }
            for(let i = prev; i < 256; i++)arr[i] = arr[prev - 1];
            return arr.join(",");
        };
        const id = `g_${this.#docId}_hcm_${filterName}_filter`;
        const filter = info.filter = this.#createFilter(id);
        this.#addGrayConversion(filter);
        this.#addTransferMapConversion(getSteps(newFgRGB[0], newBgRGB[0], 5), getSteps(newFgRGB[1], newBgRGB[1], 5), getSteps(newFgRGB[2], newBgRGB[2], 5), filter);
        info.url = this.#createUrl(id);
        return info.url;
    }
    destroy(keepHCM = false) {
        if (keepHCM && this.#_hcmCache?.size) return;
        this.#_defs?.parentNode.parentNode.remove();
        this.#_defs = null;
        this.#_cache?.clear();
        this.#_cache = null;
        this.#_hcmCache?.clear();
        this.#_hcmCache = null;
        this.#id = 0;
    }
    #addLuminosityConversion(filter) {
        const feColorMatrix = this.#document.createElementNS($9ef033443a74bee6$var$SVG_NS, "feColorMatrix");
        feColorMatrix.setAttribute("type", "matrix");
        feColorMatrix.setAttribute("values", "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0.59 0.11 0 0");
        filter.append(feColorMatrix);
    }
    #addGrayConversion(filter) {
        const feColorMatrix = this.#document.createElementNS($9ef033443a74bee6$var$SVG_NS, "feColorMatrix");
        feColorMatrix.setAttribute("type", "matrix");
        feColorMatrix.setAttribute("values", "0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0");
        filter.append(feColorMatrix);
    }
    #createFilter(id) {
        const filter = this.#document.createElementNS($9ef033443a74bee6$var$SVG_NS, "filter");
        filter.setAttribute("color-interpolation-filters", "sRGB");
        filter.setAttribute("id", id);
        this.#defs.append(filter);
        return filter;
    }
    #appendFeFunc(feComponentTransfer, func, table) {
        const feFunc = this.#document.createElementNS($9ef033443a74bee6$var$SVG_NS, func);
        feFunc.setAttribute("type", "discrete");
        feFunc.setAttribute("tableValues", table);
        feComponentTransfer.append(feFunc);
    }
    #addTransferMapConversion(rTable, gTable, bTable, filter) {
        const feComponentTransfer = this.#document.createElementNS($9ef033443a74bee6$var$SVG_NS, "feComponentTransfer");
        filter.append(feComponentTransfer);
        this.#appendFeFunc(feComponentTransfer, "feFuncR", rTable);
        this.#appendFeFunc(feComponentTransfer, "feFuncG", gTable);
        this.#appendFeFunc(feComponentTransfer, "feFuncB", bTable);
    }
    #addTransferMapAlphaConversion(aTable, filter) {
        const feComponentTransfer = this.#document.createElementNS($9ef033443a74bee6$var$SVG_NS, "feComponentTransfer");
        filter.append(feComponentTransfer);
        this.#appendFeFunc(feComponentTransfer, "feFuncA", aTable);
    }
    #getRGB(color) {
        this.#defs.style.color = color;
        return $9ef033443a74bee6$export$2a2e9b507863ddda(getComputedStyle(this.#defs).getPropertyValue("color"));
    }
}
class $9ef033443a74bee6$var$BaseStandardFontDataFactory {
    constructor({ baseUrl: baseUrl = null }){
        this.baseUrl = baseUrl;
    }
    async fetch({ filename: filename }) {
        if (!this.baseUrl) throw new Error("Ensure that the `standardFontDataUrl` API parameter is provided.");
        if (!filename) throw new Error("Font filename must be specified.");
        const url = `${this.baseUrl}${filename}`;
        return this._fetch(url).catch((reason)=>{
            throw new Error(`Unable to load font data at: ${url}`);
        });
    }
    async _fetch(url) {
        $9ef033443a74bee6$var$unreachable("Abstract method `_fetch` called.");
    }
}
class $9ef033443a74bee6$var$DOMStandardFontDataFactory extends $9ef033443a74bee6$var$BaseStandardFontDataFactory {
    async _fetch(url) {
        const data = await $9ef033443a74bee6$export$8134c072fddab6a5(url, "arraybuffer");
        return new Uint8Array(data);
    }
}
class $9ef033443a74bee6$var$BaseWasmFactory {
    constructor({ baseUrl: baseUrl = null }){
        this.baseUrl = baseUrl;
    }
    async fetch({ filename: filename }) {
        if (!this.baseUrl) throw new Error("Ensure that the `wasmUrl` API parameter is provided.");
        if (!filename) throw new Error("Wasm filename must be specified.");
        const url = `${this.baseUrl}${filename}`;
        return this._fetch(url).catch((reason)=>{
            throw new Error(`Unable to load wasm data at: ${url}`);
        });
    }
    async _fetch(url) {
        $9ef033443a74bee6$var$unreachable("Abstract method `_fetch` called.");
    }
}
class $9ef033443a74bee6$var$DOMWasmFactory extends $9ef033443a74bee6$var$BaseWasmFactory {
    async _fetch(url) {
        const data = await $9ef033443a74bee6$export$8134c072fddab6a5(url, "arraybuffer");
        return new Uint8Array(data);
    }
}
if ($9ef033443a74bee6$var$isNodeJS) $9ef033443a74bee6$var$warn("Please use the `legacy` build in Node.js environments.");
async function $9ef033443a74bee6$var$node_utils_fetchData(url) {
    const fs = $a553cffd36fe3594$exports.getBuiltinModule("fs");
    const data = await fs.promises.readFile(url);
    return new Uint8Array(data);
}
class $9ef033443a74bee6$var$NodeFilterFactory extends $9ef033443a74bee6$var$BaseFilterFactory {
}
class $9ef033443a74bee6$var$NodeCanvasFactory extends $9ef033443a74bee6$var$BaseCanvasFactory {
    _createCanvas(width, height) {
        const require1 = $a553cffd36fe3594$exports.getBuiltinModule("module").createRequire("file:///node_modules/pdfjs-dist/build/pdf.mjs");
        const canvas = require1("@napi-rs/canvas");
        return canvas.createCanvas(width, height);
    }
}
class $9ef033443a74bee6$var$NodeCMapReaderFactory extends $9ef033443a74bee6$var$BaseCMapReaderFactory {
    async _fetch(url) {
        return $9ef033443a74bee6$var$node_utils_fetchData(url);
    }
}
class $9ef033443a74bee6$var$NodeStandardFontDataFactory extends $9ef033443a74bee6$var$BaseStandardFontDataFactory {
    async _fetch(url) {
        return $9ef033443a74bee6$var$node_utils_fetchData(url);
    }
}
class $9ef033443a74bee6$var$NodeWasmFactory extends $9ef033443a74bee6$var$BaseWasmFactory {
    async _fetch(url) {
        return $9ef033443a74bee6$var$node_utils_fetchData(url);
    }
}
const $9ef033443a74bee6$var$FORCED_DEPENDENCY_LABEL = "__forcedDependency";
const { floor: $9ef033443a74bee6$var$floor, ceil: $9ef033443a74bee6$var$ceil } = Math;
function $9ef033443a74bee6$var$expandBBox(array, index, minX, minY, maxX, maxY) {
    array[index * 4 + 0] = Math.min(array[index * 4 + 0], minX);
    array[index * 4 + 1] = Math.min(array[index * 4 + 1], minY);
    array[index * 4 + 2] = Math.max(array[index * 4 + 2], maxX);
    array[index * 4 + 3] = Math.max(array[index * 4 + 3], maxY);
}
const $9ef033443a74bee6$var$EMPTY_BBOX = new Uint32Array(new Uint8Array([
    255,
    255,
    0,
    0
]).buffer)[0];
class $9ef033443a74bee6$var$BBoxReader {
    #bboxes;
    #coords;
    constructor(bboxes, coords){
        this.#bboxes = bboxes;
        this.#coords = coords;
    }
    get length() {
        return this.#bboxes.length;
    }
    isEmpty(i) {
        return this.#bboxes[i] === $9ef033443a74bee6$var$EMPTY_BBOX;
    }
    minX(i) {
        return this.#coords[i * 4 + 0] / 256;
    }
    minY(i) {
        return this.#coords[i * 4 + 1] / 256;
    }
    maxX(i) {
        return (this.#coords[i * 4 + 2] + 1) / 256;
    }
    maxY(i) {
        return (this.#coords[i * 4 + 3] + 1) / 256;
    }
}
const $9ef033443a74bee6$var$ensureDebugMetadata = (map, key)=>{
    if (!map) return undefined;
    let value = map.get(key);
    if (!value) {
        value = {
            dependencies: new Set(),
            isRenderingOperation: false
        };
        map.set(key, value);
    }
    return value;
};
class $9ef033443a74bee6$var$CanvasDependencyTracker {
    #simple = {
        __proto__: null
    };
    #incremental = {
        __proto__: null,
        transform: [],
        moveText: [],
        sameLineText: [],
        [$9ef033443a74bee6$var$FORCED_DEPENDENCY_LABEL]: []
    };
    #namedDependencies = new Map();
    #savesStack = [];
    #markedContentStack = [];
    #baseTransformStack = [
        [
            1,
            0,
            0,
            1,
            0,
            0
        ]
    ];
    #clipBox = [
        -Infinity,
        -Infinity,
        Infinity,
        Infinity
    ];
    #pendingBBox = new Float64Array([
        Infinity,
        Infinity,
        -Infinity,
        -Infinity
    ]);
    #pendingBBoxIdx = -1;
    #pendingDependencies = new Set();
    #operations = new Map();
    #fontBBoxTrustworthy = new Map();
    #canvasWidth;
    #canvasHeight;
    #bboxesCoords;
    #bboxes;
    #debugMetadata;
    constructor(canvas, operationsCount, recordDebugMetadata = false){
        this.#canvasWidth = canvas.width;
        this.#canvasHeight = canvas.height;
        this.#initializeBBoxes(operationsCount);
        if (recordDebugMetadata) this.#debugMetadata = new Map();
    }
    growOperationsCount(operationsCount) {
        if (operationsCount >= this.#bboxes.length) this.#initializeBBoxes(operationsCount, this.#bboxes);
    }
    #initializeBBoxes(operationsCount, oldBBoxes) {
        const buffer = new ArrayBuffer(operationsCount * 4);
        this.#bboxesCoords = new Uint8ClampedArray(buffer);
        this.#bboxes = new Uint32Array(buffer);
        if (oldBBoxes && oldBBoxes.length > 0) {
            this.#bboxes.set(oldBBoxes);
            this.#bboxes.fill($9ef033443a74bee6$var$EMPTY_BBOX, oldBBoxes.length);
        } else this.#bboxes.fill($9ef033443a74bee6$var$EMPTY_BBOX);
    }
    save(opIdx) {
        this.#simple = {
            __proto__: this.#simple
        };
        this.#incremental = {
            __proto__: this.#incremental,
            transform: {
                __proto__: this.#incremental.transform
            },
            moveText: {
                __proto__: this.#incremental.moveText
            },
            sameLineText: {
                __proto__: this.#incremental.sameLineText
            },
            [$9ef033443a74bee6$var$FORCED_DEPENDENCY_LABEL]: {
                __proto__: this.#incremental[$9ef033443a74bee6$var$FORCED_DEPENDENCY_LABEL]
            }
        };
        this.#clipBox = {
            __proto__: this.#clipBox
        };
        this.#savesStack.push(opIdx);
        return this;
    }
    restore(opIdx) {
        const previous = Object.getPrototypeOf(this.#simple);
        if (previous === null) return this;
        this.#simple = previous;
        this.#incremental = Object.getPrototypeOf(this.#incremental);
        this.#clipBox = Object.getPrototypeOf(this.#clipBox);
        const lastSave = this.#savesStack.pop();
        if (lastSave !== undefined) {
            $9ef033443a74bee6$var$ensureDebugMetadata(this.#debugMetadata, opIdx)?.dependencies.add(lastSave);
            this.#bboxes[opIdx] = this.#bboxes[lastSave];
        }
        return this;
    }
    recordOpenMarker(idx) {
        this.#savesStack.push(idx);
        return this;
    }
    getOpenMarker() {
        if (this.#savesStack.length === 0) return null;
        return this.#savesStack.at(-1);
    }
    recordCloseMarker(opIdx) {
        const lastSave = this.#savesStack.pop();
        if (lastSave !== undefined) {
            $9ef033443a74bee6$var$ensureDebugMetadata(this.#debugMetadata, opIdx)?.dependencies.add(lastSave);
            this.#bboxes[opIdx] = this.#bboxes[lastSave];
        }
        return this;
    }
    beginMarkedContent(opIdx) {
        this.#markedContentStack.push(opIdx);
        return this;
    }
    endMarkedContent(opIdx) {
        const lastSave = this.#markedContentStack.pop();
        if (lastSave !== undefined) {
            $9ef033443a74bee6$var$ensureDebugMetadata(this.#debugMetadata, opIdx)?.dependencies.add(lastSave);
            this.#bboxes[opIdx] = this.#bboxes[lastSave];
        }
        return this;
    }
    pushBaseTransform(ctx) {
        this.#baseTransformStack.push($9ef033443a74bee6$export$f8f26dd395d7e1bd.multiplyByDOMMatrix(this.#baseTransformStack.at(-1), ctx.getTransform()));
        return this;
    }
    popBaseTransform() {
        if (this.#baseTransformStack.length > 1) this.#baseTransformStack.pop();
        return this;
    }
    recordSimpleData(name, idx) {
        this.#simple[name] = idx;
        return this;
    }
    recordIncrementalData(name, idx) {
        this.#incremental[name].push(idx);
        return this;
    }
    resetIncrementalData(name, idx) {
        this.#incremental[name].length = 0;
        return this;
    }
    recordNamedData(name, idx) {
        this.#namedDependencies.set(name, idx);
        return this;
    }
    recordSimpleDataFromNamed(name, depName, fallbackIdx) {
        this.#simple[name] = this.#namedDependencies.get(depName) ?? fallbackIdx;
    }
    recordFutureForcedDependency(name, idx) {
        this.recordIncrementalData($9ef033443a74bee6$var$FORCED_DEPENDENCY_LABEL, idx);
        return this;
    }
    inheritSimpleDataAsFutureForcedDependencies(names) {
        for (const name of names)if (name in this.#simple) this.recordFutureForcedDependency(name, this.#simple[name]);
        return this;
    }
    inheritPendingDependenciesAsFutureForcedDependencies() {
        for (const dep of this.#pendingDependencies)this.recordFutureForcedDependency($9ef033443a74bee6$var$FORCED_DEPENDENCY_LABEL, dep);
        return this;
    }
    resetBBox(idx) {
        if (this.#pendingBBoxIdx !== idx) {
            this.#pendingBBoxIdx = idx;
            this.#pendingBBox[0] = Infinity;
            this.#pendingBBox[1] = Infinity;
            this.#pendingBBox[2] = -Infinity;
            this.#pendingBBox[3] = -Infinity;
        }
        return this;
    }
    recordClipBox(idx, ctx, minX, maxX, minY, maxY) {
        const transform = $9ef033443a74bee6$export$f8f26dd395d7e1bd.multiplyByDOMMatrix(this.#baseTransformStack.at(-1), ctx.getTransform());
        const clipBox = [
            Infinity,
            Infinity,
            -Infinity,
            -Infinity
        ];
        $9ef033443a74bee6$export$f8f26dd395d7e1bd.axialAlignedBoundingBox([
            minX,
            minY,
            maxX,
            maxY
        ], transform, clipBox);
        const intersection = $9ef033443a74bee6$export$f8f26dd395d7e1bd.intersect(this.#clipBox, clipBox);
        if (intersection) {
            this.#clipBox[0] = intersection[0];
            this.#clipBox[1] = intersection[1];
            this.#clipBox[2] = intersection[2];
            this.#clipBox[3] = intersection[3];
        } else {
            this.#clipBox[0] = this.#clipBox[1] = Infinity;
            this.#clipBox[2] = this.#clipBox[3] = -Infinity;
        }
        return this;
    }
    recordBBox(idx, ctx, minX, maxX, minY, maxY) {
        const clipBox = this.#clipBox;
        if (clipBox[0] === Infinity) return this;
        const transform = $9ef033443a74bee6$export$f8f26dd395d7e1bd.multiplyByDOMMatrix(this.#baseTransformStack.at(-1), ctx.getTransform());
        if (clipBox[0] === -Infinity) {
            $9ef033443a74bee6$export$f8f26dd395d7e1bd.axialAlignedBoundingBox([
                minX,
                minY,
                maxX,
                maxY
            ], transform, this.#pendingBBox);
            return this;
        }
        const bbox = [
            Infinity,
            Infinity,
            -Infinity,
            -Infinity
        ];
        $9ef033443a74bee6$export$f8f26dd395d7e1bd.axialAlignedBoundingBox([
            minX,
            minY,
            maxX,
            maxY
        ], transform, bbox);
        this.#pendingBBox[0] = Math.min(this.#pendingBBox[0], Math.max(bbox[0], clipBox[0]));
        this.#pendingBBox[1] = Math.min(this.#pendingBBox[1], Math.max(bbox[1], clipBox[1]));
        this.#pendingBBox[2] = Math.max(this.#pendingBBox[2], Math.min(bbox[2], clipBox[2]));
        this.#pendingBBox[3] = Math.max(this.#pendingBBox[3], Math.min(bbox[3], clipBox[3]));
        return this;
    }
    recordCharacterBBox(idx, ctx, font, scale = 1, x = 0, y = 0, getMeasure) {
        const fontBBox = font.bbox;
        let isBBoxTrustworthy;
        let computedBBox;
        if (fontBBox) {
            isBBoxTrustworthy = fontBBox[2] !== fontBBox[0] && fontBBox[3] !== fontBBox[1] && this.#fontBBoxTrustworthy.get(font);
            if (isBBoxTrustworthy !== false) {
                computedBBox = [
                    0,
                    0,
                    0,
                    0
                ];
                $9ef033443a74bee6$export$f8f26dd395d7e1bd.axialAlignedBoundingBox(fontBBox, font.fontMatrix, computedBBox);
                if (scale !== 1 || x !== 0 || y !== 0) $9ef033443a74bee6$export$f8f26dd395d7e1bd.scaleMinMax([
                    scale,
                    0,
                    0,
                    -scale,
                    x,
                    y
                ], computedBBox);
                if (isBBoxTrustworthy) return this.recordBBox(idx, ctx, computedBBox[0], computedBBox[2], computedBBox[1], computedBBox[3]);
            }
        }
        if (!getMeasure) return this.recordFullPageBBox(idx);
        const measure = getMeasure();
        if (fontBBox && computedBBox && isBBoxTrustworthy === undefined) {
            isBBoxTrustworthy = computedBBox[0] <= x - measure.actualBoundingBoxLeft && computedBBox[2] >= x + measure.actualBoundingBoxRight && computedBBox[1] <= y - measure.actualBoundingBoxAscent && computedBBox[3] >= y + measure.actualBoundingBoxDescent;
            this.#fontBBoxTrustworthy.set(font, isBBoxTrustworthy);
            if (isBBoxTrustworthy) return this.recordBBox(idx, ctx, computedBBox[0], computedBBox[2], computedBBox[1], computedBBox[3]);
        }
        return this.recordBBox(idx, ctx, x - measure.actualBoundingBoxLeft, x + measure.actualBoundingBoxRight, y - measure.actualBoundingBoxAscent, y + measure.actualBoundingBoxDescent);
    }
    recordFullPageBBox(idx) {
        this.#pendingBBox[0] = Math.max(0, this.#clipBox[0]);
        this.#pendingBBox[1] = Math.max(0, this.#clipBox[1]);
        this.#pendingBBox[2] = Math.min(this.#canvasWidth, this.#clipBox[2]);
        this.#pendingBBox[3] = Math.min(this.#canvasHeight, this.#clipBox[3]);
        return this;
    }
    getSimpleIndex(dependencyName) {
        return this.#simple[dependencyName];
    }
    recordDependencies(idx, dependencyNames) {
        const pendingDependencies = this.#pendingDependencies;
        const simple = this.#simple;
        const incremental = this.#incremental;
        for (const name of dependencyNames){
            if (name in this.#simple) pendingDependencies.add(simple[name]);
            else if (name in incremental) incremental[name].forEach(pendingDependencies.add, pendingDependencies);
        }
        return this;
    }
    recordNamedDependency(idx, name) {
        if (this.#namedDependencies.has(name)) this.#pendingDependencies.add(this.#namedDependencies.get(name));
        return this;
    }
    recordOperation(idx, preserve = false) {
        this.recordDependencies(idx, [
            $9ef033443a74bee6$var$FORCED_DEPENDENCY_LABEL
        ]);
        if (this.#debugMetadata) {
            const metadata = $9ef033443a74bee6$var$ensureDebugMetadata(this.#debugMetadata, idx);
            const { dependencies: dependencies } = metadata;
            this.#pendingDependencies.forEach(dependencies.add, dependencies);
            this.#savesStack.forEach(dependencies.add, dependencies);
            this.#markedContentStack.forEach(dependencies.add, dependencies);
            dependencies.delete(idx);
            metadata.isRenderingOperation = true;
        }
        if (this.#pendingBBoxIdx === idx) {
            const minX = $9ef033443a74bee6$var$floor(this.#pendingBBox[0] * 256 / this.#canvasWidth);
            const minY = $9ef033443a74bee6$var$floor(this.#pendingBBox[1] * 256 / this.#canvasHeight);
            const maxX = $9ef033443a74bee6$var$ceil(this.#pendingBBox[2] * 256 / this.#canvasWidth);
            const maxY = $9ef033443a74bee6$var$ceil(this.#pendingBBox[3] * 256 / this.#canvasHeight);
            $9ef033443a74bee6$var$expandBBox(this.#bboxesCoords, idx, minX, minY, maxX, maxY);
            for (const depIdx of this.#pendingDependencies)if (depIdx !== idx) $9ef033443a74bee6$var$expandBBox(this.#bboxesCoords, depIdx, minX, minY, maxX, maxY);
            for (const saveIdx of this.#savesStack)if (saveIdx !== idx) $9ef033443a74bee6$var$expandBBox(this.#bboxesCoords, saveIdx, minX, minY, maxX, maxY);
            for (const saveIdx of this.#markedContentStack)if (saveIdx !== idx) $9ef033443a74bee6$var$expandBBox(this.#bboxesCoords, saveIdx, minX, minY, maxX, maxY);
            if (!preserve) {
                this.#pendingDependencies.clear();
                this.#pendingBBoxIdx = -1;
            }
        }
        return this;
    }
    recordShowTextOperation(idx, preserve = false) {
        const deps = Array.from(this.#pendingDependencies);
        this.recordOperation(idx, preserve);
        this.recordIncrementalData("sameLineText", idx);
        for (const dep of deps)this.recordIncrementalData("sameLineText", dep);
        return this;
    }
    bboxToClipBoxDropOperation(idx, preserve = false) {
        if (this.#pendingBBoxIdx === idx) {
            this.#pendingBBoxIdx = -1;
            this.#clipBox[0] = Math.max(this.#clipBox[0], this.#pendingBBox[0]);
            this.#clipBox[1] = Math.max(this.#clipBox[1], this.#pendingBBox[1]);
            this.#clipBox[2] = Math.min(this.#clipBox[2], this.#pendingBBox[2]);
            this.#clipBox[3] = Math.min(this.#clipBox[3], this.#pendingBBox[3]);
            if (!preserve) this.#pendingDependencies.clear();
        }
        return this;
    }
    _takePendingDependencies() {
        const pendingDependencies = this.#pendingDependencies;
        this.#pendingDependencies = new Set();
        return pendingDependencies;
    }
    _extractOperation(idx) {
        const operation = this.#operations.get(idx);
        this.#operations.delete(idx);
        return operation;
    }
    _pushPendingDependencies(dependencies) {
        for (const dep of dependencies)this.#pendingDependencies.add(dep);
    }
    take() {
        this.#fontBBoxTrustworthy.clear();
        return new $9ef033443a74bee6$var$BBoxReader(this.#bboxes, this.#bboxesCoords);
    }
    takeDebugMetadata() {
        return this.#debugMetadata;
    }
}
class $9ef033443a74bee6$var$CanvasNestedDependencyTracker {
    #dependencyTracker;
    #opIdx;
    #ignoreBBoxes;
    #nestingLevel = 0;
    #savesLevel = 0;
    constructor(dependencyTracker, opIdx, ignoreBBoxes){
        if (dependencyTracker instanceof $9ef033443a74bee6$var$CanvasNestedDependencyTracker && dependencyTracker.#ignoreBBoxes === !!ignoreBBoxes) return dependencyTracker;
        this.#dependencyTracker = dependencyTracker;
        this.#opIdx = opIdx;
        this.#ignoreBBoxes = !!ignoreBBoxes;
    }
    growOperationsCount() {
        throw new Error("Unreachable");
    }
    save(opIdx) {
        this.#savesLevel++;
        this.#dependencyTracker.save(this.#opIdx);
        return this;
    }
    restore(opIdx) {
        if (this.#savesLevel > 0) {
            this.#dependencyTracker.restore(this.#opIdx);
            this.#savesLevel--;
        }
        return this;
    }
    recordOpenMarker(idx) {
        this.#nestingLevel++;
        return this;
    }
    getOpenMarker() {
        return this.#nestingLevel > 0 ? this.#opIdx : this.#dependencyTracker.getOpenMarker();
    }
    recordCloseMarker(idx) {
        this.#nestingLevel--;
        return this;
    }
    beginMarkedContent(opIdx) {
        return this;
    }
    endMarkedContent(opIdx) {
        return this;
    }
    pushBaseTransform(ctx) {
        this.#dependencyTracker.pushBaseTransform(ctx);
        return this;
    }
    popBaseTransform() {
        this.#dependencyTracker.popBaseTransform();
        return this;
    }
    recordSimpleData(name, idx) {
        this.#dependencyTracker.recordSimpleData(name, this.#opIdx);
        return this;
    }
    recordIncrementalData(name, idx) {
        this.#dependencyTracker.recordIncrementalData(name, this.#opIdx);
        return this;
    }
    resetIncrementalData(name, idx) {
        this.#dependencyTracker.resetIncrementalData(name, this.#opIdx);
        return this;
    }
    recordNamedData(name, idx) {
        return this;
    }
    recordSimpleDataFromNamed(name, depName, fallbackIdx) {
        this.#dependencyTracker.recordSimpleDataFromNamed(name, depName, this.#opIdx);
        return this;
    }
    recordFutureForcedDependency(name, idx) {
        this.#dependencyTracker.recordFutureForcedDependency(name, this.#opIdx);
        return this;
    }
    inheritSimpleDataAsFutureForcedDependencies(names) {
        this.#dependencyTracker.inheritSimpleDataAsFutureForcedDependencies(names);
        return this;
    }
    inheritPendingDependenciesAsFutureForcedDependencies() {
        this.#dependencyTracker.inheritPendingDependenciesAsFutureForcedDependencies();
        return this;
    }
    resetBBox(idx) {
        if (!this.#ignoreBBoxes) this.#dependencyTracker.resetBBox(this.#opIdx);
        return this;
    }
    recordClipBox(idx, ctx, minX, maxX, minY, maxY) {
        if (!this.#ignoreBBoxes) this.#dependencyTracker.recordClipBox(this.#opIdx, ctx, minX, maxX, minY, maxY);
        return this;
    }
    recordBBox(idx, ctx, minX, maxX, minY, maxY) {
        if (!this.#ignoreBBoxes) this.#dependencyTracker.recordBBox(this.#opIdx, ctx, minX, maxX, minY, maxY);
        return this;
    }
    recordCharacterBBox(idx, ctx, font, scale, x, y, getMeasure) {
        if (!this.#ignoreBBoxes) this.#dependencyTracker.recordCharacterBBox(this.#opIdx, ctx, font, scale, x, y, getMeasure);
        return this;
    }
    recordFullPageBBox(idx) {
        if (!this.#ignoreBBoxes) this.#dependencyTracker.recordFullPageBBox(this.#opIdx);
        return this;
    }
    getSimpleIndex(dependencyName) {
        return this.#dependencyTracker.getSimpleIndex(dependencyName);
    }
    recordDependencies(idx, dependencyNames) {
        this.#dependencyTracker.recordDependencies(this.#opIdx, dependencyNames);
        return this;
    }
    recordNamedDependency(idx, name) {
        this.#dependencyTracker.recordNamedDependency(this.#opIdx, name);
        return this;
    }
    recordOperation(idx) {
        this.#dependencyTracker.recordOperation(this.#opIdx, true);
        return this;
    }
    recordShowTextOperation(idx) {
        this.#dependencyTracker.recordShowTextOperation(this.#opIdx, true);
        return this;
    }
    bboxToClipBoxDropOperation(idx) {
        if (!this.#ignoreBBoxes) this.#dependencyTracker.bboxToClipBoxDropOperation(this.#opIdx, true);
        return this;
    }
    take() {
        throw new Error("Unreachable");
    }
    takeDebugMetadata() {
        throw new Error("Unreachable");
    }
}
const $9ef033443a74bee6$var$Dependencies = {
    stroke: [
        "path",
        "transform",
        "filter",
        "strokeColor",
        "strokeAlpha",
        "lineWidth",
        "lineCap",
        "lineJoin",
        "miterLimit",
        "dash"
    ],
    fill: [
        "path",
        "transform",
        "filter",
        "fillColor",
        "fillAlpha",
        "globalCompositeOperation",
        "SMask"
    ],
    imageXObject: [
        "transform",
        "SMask",
        "filter",
        "fillAlpha",
        "strokeAlpha",
        "globalCompositeOperation"
    ],
    rawFillPath: [
        "filter",
        "fillColor",
        "fillAlpha"
    ],
    showText: [
        "transform",
        "leading",
        "charSpacing",
        "wordSpacing",
        "hScale",
        "textRise",
        "moveText",
        "textMatrix",
        "font",
        "fontObj",
        "filter",
        "fillColor",
        "textRenderingMode",
        "SMask",
        "fillAlpha",
        "strokeAlpha",
        "globalCompositeOperation",
        "sameLineText"
    ],
    transform: [
        "transform"
    ],
    transformAndFill: [
        "transform",
        "fillColor"
    ]
};
const $9ef033443a74bee6$var$PathType = {
    FILL: "Fill",
    STROKE: "Stroke",
    SHADING: "Shading"
};
function $9ef033443a74bee6$var$applyBoundingBox(ctx, bbox) {
    if (!bbox) return;
    const width = bbox[2] - bbox[0];
    const height = bbox[3] - bbox[1];
    const region = new Path2D();
    region.rect(bbox[0], bbox[1], width, height);
    ctx.clip(region);
}
class $9ef033443a74bee6$var$BaseShadingPattern {
    isModifyingCurrentTransform() {
        return false;
    }
    getPattern() {
        $9ef033443a74bee6$var$unreachable("Abstract method `getPattern` called.");
    }
}
class $9ef033443a74bee6$var$RadialAxialShadingPattern extends $9ef033443a74bee6$var$BaseShadingPattern {
    constructor(IR){
        super();
        this._type = IR[1];
        this._bbox = IR[2];
        this._colorStops = IR[3];
        this._p0 = IR[4];
        this._p1 = IR[5];
        this._r0 = IR[6];
        this._r1 = IR[7];
        this.matrix = null;
    }
    _createGradient(ctx) {
        let grad;
        if (this._type === "axial") grad = ctx.createLinearGradient(this._p0[0], this._p0[1], this._p1[0], this._p1[1]);
        else if (this._type === "radial") grad = ctx.createRadialGradient(this._p0[0], this._p0[1], this._r0, this._p1[0], this._p1[1], this._r1);
        for (const colorStop of this._colorStops)grad.addColorStop(colorStop[0], colorStop[1]);
        return grad;
    }
    getPattern(ctx, owner, inverse, pathType) {
        let pattern;
        if (pathType === $9ef033443a74bee6$var$PathType.STROKE || pathType === $9ef033443a74bee6$var$PathType.FILL) {
            const ownerBBox = owner.current.getClippedPathBoundingBox(pathType, $9ef033443a74bee6$var$getCurrentTransform(ctx)) || [
                0,
                0,
                0,
                0
            ];
            const width = Math.ceil(ownerBBox[2] - ownerBBox[0]) || 1;
            const height = Math.ceil(ownerBBox[3] - ownerBBox[1]) || 1;
            const tmpCanvas = owner.cachedCanvases.getCanvas("pattern", width, height);
            const tmpCtx = tmpCanvas.context;
            tmpCtx.clearRect(0, 0, tmpCtx.canvas.width, tmpCtx.canvas.height);
            tmpCtx.beginPath();
            tmpCtx.rect(0, 0, tmpCtx.canvas.width, tmpCtx.canvas.height);
            tmpCtx.translate(-ownerBBox[0], -ownerBBox[1]);
            inverse = $9ef033443a74bee6$export$f8f26dd395d7e1bd.transform(inverse, [
                1,
                0,
                0,
                1,
                ownerBBox[0],
                ownerBBox[1]
            ]);
            tmpCtx.transform(...owner.baseTransform);
            if (this.matrix) tmpCtx.transform(...this.matrix);
            $9ef033443a74bee6$var$applyBoundingBox(tmpCtx, this._bbox);
            tmpCtx.fillStyle = this._createGradient(tmpCtx);
            tmpCtx.fill();
            pattern = ctx.createPattern(tmpCanvas.canvas, "no-repeat");
            const domMatrix = new DOMMatrix(inverse);
            pattern.setTransform(domMatrix);
        } else {
            $9ef033443a74bee6$var$applyBoundingBox(ctx, this._bbox);
            pattern = this._createGradient(ctx);
        }
        return pattern;
    }
}
function $9ef033443a74bee6$var$drawTriangle(data, context, p1, p2, p3, c1, c2, c3) {
    const coords = context.coords, colors = context.colors;
    const bytes = data.data, rowSize = data.width * 4;
    let tmp;
    if (coords[p1 + 1] > coords[p2 + 1]) {
        tmp = p1;
        p1 = p2;
        p2 = tmp;
        tmp = c1;
        c1 = c2;
        c2 = tmp;
    }
    if (coords[p2 + 1] > coords[p3 + 1]) {
        tmp = p2;
        p2 = p3;
        p3 = tmp;
        tmp = c2;
        c2 = c3;
        c3 = tmp;
    }
    if (coords[p1 + 1] > coords[p2 + 1]) {
        tmp = p1;
        p1 = p2;
        p2 = tmp;
        tmp = c1;
        c1 = c2;
        c2 = tmp;
    }
    const x1 = (coords[p1] + context.offsetX) * context.scaleX;
    const y1 = (coords[p1 + 1] + context.offsetY) * context.scaleY;
    const x2 = (coords[p2] + context.offsetX) * context.scaleX;
    const y2 = (coords[p2 + 1] + context.offsetY) * context.scaleY;
    const x3 = (coords[p3] + context.offsetX) * context.scaleX;
    const y3 = (coords[p3 + 1] + context.offsetY) * context.scaleY;
    if (y1 >= y3) return;
    const c1r = colors[c1], c1g = colors[c1 + 1], c1b = colors[c1 + 2];
    const c2r = colors[c2], c2g = colors[c2 + 1], c2b = colors[c2 + 2];
    const c3r = colors[c3], c3g = colors[c3 + 1], c3b = colors[c3 + 2];
    const minY = Math.round(y1), maxY = Math.round(y3);
    let xa, car, cag, cab;
    let xb, cbr, cbg, cbb;
    for(let y = minY; y <= maxY; y++){
        if (y < y2) {
            const k = y < y1 ? 0 : (y1 - y) / (y1 - y2);
            xa = x1 - (x1 - x2) * k;
            car = c1r - (c1r - c2r) * k;
            cag = c1g - (c1g - c2g) * k;
            cab = c1b - (c1b - c2b) * k;
        } else {
            let k;
            if (y > y3) k = 1;
            else if (y2 === y3) k = 0;
            else k = (y2 - y) / (y2 - y3);
            xa = x2 - (x2 - x3) * k;
            car = c2r - (c2r - c3r) * k;
            cag = c2g - (c2g - c3g) * k;
            cab = c2b - (c2b - c3b) * k;
        }
        let k;
        if (y < y1) k = 0;
        else if (y > y3) k = 1;
        else k = (y1 - y) / (y1 - y3);
        xb = x1 - (x1 - x3) * k;
        cbr = c1r - (c1r - c3r) * k;
        cbg = c1g - (c1g - c3g) * k;
        cbb = c1b - (c1b - c3b) * k;
        const x1_ = Math.round(Math.min(xa, xb));
        const x2_ = Math.round(Math.max(xa, xb));
        let j = rowSize * y + x1_ * 4;
        for(let x = x1_; x <= x2_; x++){
            k = (xa - x) / (xa - xb);
            if (k < 0) k = 0;
            else if (k > 1) k = 1;
            bytes[j++] = car - (car - cbr) * k | 0;
            bytes[j++] = cag - (cag - cbg) * k | 0;
            bytes[j++] = cab - (cab - cbb) * k | 0;
            bytes[j++] = 255;
        }
    }
}
function $9ef033443a74bee6$var$drawFigure(data, figure, context) {
    const ps = figure.coords;
    const cs = figure.colors;
    let i, ii;
    switch(figure.type){
        case "lattice":
            const verticesPerRow = figure.verticesPerRow;
            const rows = Math.floor(ps.length / verticesPerRow) - 1;
            const cols = verticesPerRow - 1;
            for(i = 0; i < rows; i++){
                let q = i * verticesPerRow;
                for(let j = 0; j < cols; j++, q++){
                    $9ef033443a74bee6$var$drawTriangle(data, context, ps[q], ps[q + 1], ps[q + verticesPerRow], cs[q], cs[q + 1], cs[q + verticesPerRow]);
                    $9ef033443a74bee6$var$drawTriangle(data, context, ps[q + verticesPerRow + 1], ps[q + 1], ps[q + verticesPerRow], cs[q + verticesPerRow + 1], cs[q + 1], cs[q + verticesPerRow]);
                }
            }
            break;
        case "triangles":
            for(i = 0, ii = ps.length; i < ii; i += 3)$9ef033443a74bee6$var$drawTriangle(data, context, ps[i], ps[i + 1], ps[i + 2], cs[i], cs[i + 1], cs[i + 2]);
            break;
        default:
            throw new Error("illegal figure");
    }
}
class $9ef033443a74bee6$var$MeshShadingPattern extends $9ef033443a74bee6$var$BaseShadingPattern {
    constructor(IR){
        super();
        this._coords = IR[2];
        this._colors = IR[3];
        this._figures = IR[4];
        this._bounds = IR[5];
        this._bbox = IR[6];
        this._background = IR[7];
        this.matrix = null;
    }
    _createMeshCanvas(combinedScale, backgroundColor, cachedCanvases) {
        const EXPECTED_SCALE = 1.1;
        const MAX_PATTERN_SIZE = 3000;
        const BORDER_SIZE = 2;
        const offsetX = Math.floor(this._bounds[0]);
        const offsetY = Math.floor(this._bounds[1]);
        const boundsWidth = Math.ceil(this._bounds[2]) - offsetX;
        const boundsHeight = Math.ceil(this._bounds[3]) - offsetY;
        const width = Math.min(Math.ceil(Math.abs(boundsWidth * combinedScale[0] * EXPECTED_SCALE)), MAX_PATTERN_SIZE);
        const height = Math.min(Math.ceil(Math.abs(boundsHeight * combinedScale[1] * EXPECTED_SCALE)), MAX_PATTERN_SIZE);
        const scaleX = boundsWidth / width;
        const scaleY = boundsHeight / height;
        const context = {
            coords: this._coords,
            colors: this._colors,
            offsetX: -offsetX,
            offsetY: -offsetY,
            scaleX: 1 / scaleX,
            scaleY: 1 / scaleY
        };
        const paddedWidth = width + BORDER_SIZE * 2;
        const paddedHeight = height + BORDER_SIZE * 2;
        const tmpCanvas = cachedCanvases.getCanvas("mesh", paddedWidth, paddedHeight);
        const tmpCtx = tmpCanvas.context;
        const data = tmpCtx.createImageData(width, height);
        if (backgroundColor) {
            const bytes = data.data;
            for(let i = 0, ii = bytes.length; i < ii; i += 4){
                bytes[i] = backgroundColor[0];
                bytes[i + 1] = backgroundColor[1];
                bytes[i + 2] = backgroundColor[2];
                bytes[i + 3] = 255;
            }
        }
        for (const figure of this._figures)$9ef033443a74bee6$var$drawFigure(data, figure, context);
        tmpCtx.putImageData(data, BORDER_SIZE, BORDER_SIZE);
        const canvas = tmpCanvas.canvas;
        return {
            canvas: canvas,
            offsetX: offsetX - BORDER_SIZE * scaleX,
            offsetY: offsetY - BORDER_SIZE * scaleY,
            scaleX: scaleX,
            scaleY: scaleY
        };
    }
    isModifyingCurrentTransform() {
        return true;
    }
    getPattern(ctx, owner, inverse, pathType) {
        $9ef033443a74bee6$var$applyBoundingBox(ctx, this._bbox);
        const scale = new Float32Array(2);
        if (pathType === $9ef033443a74bee6$var$PathType.SHADING) $9ef033443a74bee6$export$f8f26dd395d7e1bd.singularValueDecompose2dScale($9ef033443a74bee6$var$getCurrentTransform(ctx), scale);
        else if (this.matrix) {
            $9ef033443a74bee6$export$f8f26dd395d7e1bd.singularValueDecompose2dScale(this.matrix, scale);
            const [matrixScaleX, matrixScaleY] = scale;
            $9ef033443a74bee6$export$f8f26dd395d7e1bd.singularValueDecompose2dScale(owner.baseTransform, scale);
            scale[0] *= matrixScaleX;
            scale[1] *= matrixScaleY;
        } else $9ef033443a74bee6$export$f8f26dd395d7e1bd.singularValueDecompose2dScale(owner.baseTransform, scale);
        const temporaryPatternCanvas = this._createMeshCanvas(scale, pathType === $9ef033443a74bee6$var$PathType.SHADING ? null : this._background, owner.cachedCanvases);
        if (pathType !== $9ef033443a74bee6$var$PathType.SHADING) {
            ctx.setTransform(...owner.baseTransform);
            if (this.matrix) ctx.transform(...this.matrix);
        }
        ctx.translate(temporaryPatternCanvas.offsetX, temporaryPatternCanvas.offsetY);
        ctx.scale(temporaryPatternCanvas.scaleX, temporaryPatternCanvas.scaleY);
        return ctx.createPattern(temporaryPatternCanvas.canvas, "no-repeat");
    }
}
class $9ef033443a74bee6$var$DummyShadingPattern extends $9ef033443a74bee6$var$BaseShadingPattern {
    getPattern() {
        return "hotpink";
    }
}
function $9ef033443a74bee6$var$getShadingPattern(IR) {
    switch(IR[0]){
        case "RadialAxial":
            return new $9ef033443a74bee6$var$RadialAxialShadingPattern(IR);
        case "Mesh":
            return new $9ef033443a74bee6$var$MeshShadingPattern(IR);
        case "Dummy":
            return new $9ef033443a74bee6$var$DummyShadingPattern();
    }
    throw new Error(`Unknown IR type: ${IR[0]}`);
}
const $9ef033443a74bee6$var$PaintType = {
    COLORED: 1,
    UNCOLORED: 2
};
class $9ef033443a74bee6$var$TilingPattern {
    static MAX_PATTERN_SIZE = 3000;
    constructor(IR, ctx, canvasGraphicsFactory, baseTransform){
        this.color = IR[1];
        this.operatorList = IR[2];
        this.matrix = IR[3];
        this.bbox = IR[4];
        this.xstep = IR[5];
        this.ystep = IR[6];
        this.paintType = IR[7];
        this.tilingType = IR[8];
        this.ctx = ctx;
        this.canvasGraphicsFactory = canvasGraphicsFactory;
        this.baseTransform = baseTransform;
    }
    createPatternCanvas(owner, opIdx) {
        const { bbox: bbox, operatorList: operatorList, paintType: paintType, tilingType: tilingType, color: color, canvasGraphicsFactory: canvasGraphicsFactory } = this;
        let { xstep: xstep, ystep: ystep } = this;
        xstep = Math.abs(xstep);
        ystep = Math.abs(ystep);
        $9ef033443a74bee6$var$info("TilingType: " + tilingType);
        const x0 = bbox[0], y0 = bbox[1], x1 = bbox[2], y1 = bbox[3];
        const width = x1 - x0;
        const height = y1 - y0;
        const scale = new Float32Array(2);
        $9ef033443a74bee6$export$f8f26dd395d7e1bd.singularValueDecompose2dScale(this.matrix, scale);
        const [matrixScaleX, matrixScaleY] = scale;
        $9ef033443a74bee6$export$f8f26dd395d7e1bd.singularValueDecompose2dScale(this.baseTransform, scale);
        const combinedScaleX = matrixScaleX * scale[0];
        const combinedScaleY = matrixScaleY * scale[1];
        let canvasWidth = width, canvasHeight = height, redrawHorizontally = false, redrawVertically = false;
        const xScaledStep = Math.ceil(xstep * combinedScaleX);
        const yScaledStep = Math.ceil(ystep * combinedScaleY);
        const xScaledWidth = Math.ceil(width * combinedScaleX);
        const yScaledHeight = Math.ceil(height * combinedScaleY);
        if (xScaledStep >= xScaledWidth) canvasWidth = xstep;
        else redrawHorizontally = true;
        if (yScaledStep >= yScaledHeight) canvasHeight = ystep;
        else redrawVertically = true;
        const dimx = this.getSizeAndScale(canvasWidth, this.ctx.canvas.width, combinedScaleX);
        const dimy = this.getSizeAndScale(canvasHeight, this.ctx.canvas.height, combinedScaleY);
        const tmpCanvas = owner.cachedCanvases.getCanvas("pattern", dimx.size, dimy.size);
        const tmpCtx = tmpCanvas.context;
        const graphics = canvasGraphicsFactory.createCanvasGraphics(tmpCtx, opIdx);
        graphics.groupLevel = owner.groupLevel;
        this.setFillAndStrokeStyleToContext(graphics, paintType, color);
        tmpCtx.translate(-dimx.scale * x0, -dimy.scale * y0);
        graphics.transform(0, dimx.scale, 0, 0, dimy.scale, 0, 0);
        tmpCtx.save();
        graphics.dependencyTracker?.save();
        this.clipBbox(graphics, x0, y0, x1, y1);
        graphics.baseTransform = $9ef033443a74bee6$var$getCurrentTransform(graphics.ctx);
        graphics.executeOperatorList(operatorList);
        graphics.endDrawing();
        graphics.dependencyTracker?.restore();
        tmpCtx.restore();
        if (redrawHorizontally || redrawVertically) {
            const image = tmpCanvas.canvas;
            if (redrawHorizontally) canvasWidth = xstep;
            if (redrawVertically) canvasHeight = ystep;
            const dimx2 = this.getSizeAndScale(canvasWidth, this.ctx.canvas.width, combinedScaleX);
            const dimy2 = this.getSizeAndScale(canvasHeight, this.ctx.canvas.height, combinedScaleY);
            const xSize = dimx2.size;
            const ySize = dimy2.size;
            const tmpCanvas2 = owner.cachedCanvases.getCanvas("pattern-workaround", xSize, ySize);
            const tmpCtx2 = tmpCanvas2.context;
            const ii = redrawHorizontally ? Math.floor(width / xstep) : 0;
            const jj = redrawVertically ? Math.floor(height / ystep) : 0;
            for(let i = 0; i <= ii; i++)for(let j = 0; j <= jj; j++)tmpCtx2.drawImage(image, xSize * i, ySize * j, xSize, ySize, 0, 0, xSize, ySize);
            return {
                canvas: tmpCanvas2.canvas,
                scaleX: dimx2.scale,
                scaleY: dimy2.scale,
                offsetX: x0,
                offsetY: y0
            };
        }
        return {
            canvas: tmpCanvas.canvas,
            scaleX: dimx.scale,
            scaleY: dimy.scale,
            offsetX: x0,
            offsetY: y0
        };
    }
    getSizeAndScale(step, realOutputSize, scale) {
        const maxSize = Math.max($9ef033443a74bee6$var$TilingPattern.MAX_PATTERN_SIZE, realOutputSize);
        let size = Math.ceil(step * scale);
        if (size >= maxSize) size = maxSize;
        else scale = size / step;
        return {
            scale: scale,
            size: size
        };
    }
    clipBbox(graphics, x0, y0, x1, y1) {
        const bboxWidth = x1 - x0;
        const bboxHeight = y1 - y0;
        graphics.ctx.rect(x0, y0, bboxWidth, bboxHeight);
        $9ef033443a74bee6$export$f8f26dd395d7e1bd.axialAlignedBoundingBox([
            x0,
            y0,
            x1,
            y1
        ], $9ef033443a74bee6$var$getCurrentTransform(graphics.ctx), graphics.current.minMax);
        graphics.clip();
        graphics.endPath();
    }
    setFillAndStrokeStyleToContext(graphics, paintType, color) {
        const context = graphics.ctx, current = graphics.current;
        switch(paintType){
            case $9ef033443a74bee6$var$PaintType.COLORED:
                const { fillStyle: fillStyle, strokeStyle: strokeStyle } = this.ctx;
                context.fillStyle = current.fillColor = fillStyle;
                context.strokeStyle = current.strokeColor = strokeStyle;
                break;
            case $9ef033443a74bee6$var$PaintType.UNCOLORED:
                context.fillStyle = context.strokeStyle = color;
                current.fillColor = current.strokeColor = color;
                break;
            default:
                throw new $9ef033443a74bee6$var$FormatError(`Unsupported paint type: ${paintType}`);
        }
    }
    isModifyingCurrentTransform() {
        return false;
    }
    getPattern(ctx, owner, inverse, pathType, opIdx) {
        let matrix = inverse;
        if (pathType !== $9ef033443a74bee6$var$PathType.SHADING) {
            matrix = $9ef033443a74bee6$export$f8f26dd395d7e1bd.transform(matrix, owner.baseTransform);
            if (this.matrix) matrix = $9ef033443a74bee6$export$f8f26dd395d7e1bd.transform(matrix, this.matrix);
        }
        const temporaryPatternCanvas = this.createPatternCanvas(owner, opIdx);
        let domMatrix = new DOMMatrix(matrix);
        domMatrix = domMatrix.translate(temporaryPatternCanvas.offsetX, temporaryPatternCanvas.offsetY);
        domMatrix = domMatrix.scale(1 / temporaryPatternCanvas.scaleX, 1 / temporaryPatternCanvas.scaleY);
        const pattern = ctx.createPattern(temporaryPatternCanvas.canvas, "repeat");
        pattern.setTransform(domMatrix);
        return pattern;
    }
}
function $9ef033443a74bee6$var$convertToRGBA(params) {
    switch(params.kind){
        case ImageKind.GRAYSCALE_1BPP:
            return $9ef033443a74bee6$var$convertBlackAndWhiteToRGBA(params);
        case ImageKind.RGB_24BPP:
            return $9ef033443a74bee6$var$convertRGBToRGBA(params);
    }
    return null;
}
function $9ef033443a74bee6$var$convertBlackAndWhiteToRGBA({ src: src, srcPos: srcPos = 0, dest: dest, width: width, height: height, nonBlackColor: nonBlackColor = 0xffffffff, inverseDecode: inverseDecode = false }) {
    const black = $9ef033443a74bee6$export$5fb8891d35c36978.isLittleEndian ? 0xff000000 : 0x000000ff;
    const [zeroMapping, oneMapping] = inverseDecode ? [
        nonBlackColor,
        black
    ] : [
        black,
        nonBlackColor
    ];
    const widthInSource = width >> 3;
    const widthRemainder = width & 7;
    const srcLength = src.length;
    dest = new Uint32Array(dest.buffer);
    let destPos = 0;
    for(let i = 0; i < height; i++){
        for(const max = srcPos + widthInSource; srcPos < max; srcPos++){
            const elem = srcPos < srcLength ? src[srcPos] : 255;
            dest[destPos++] = elem & 128 ? oneMapping : zeroMapping;
            dest[destPos++] = elem & 64 ? oneMapping : zeroMapping;
            dest[destPos++] = elem & 32 ? oneMapping : zeroMapping;
            dest[destPos++] = elem & 16 ? oneMapping : zeroMapping;
            dest[destPos++] = elem & 8 ? oneMapping : zeroMapping;
            dest[destPos++] = elem & 4 ? oneMapping : zeroMapping;
            dest[destPos++] = elem & 2 ? oneMapping : zeroMapping;
            dest[destPos++] = elem & 1 ? oneMapping : zeroMapping;
        }
        if (widthRemainder === 0) continue;
        const elem = srcPos < srcLength ? src[srcPos++] : 255;
        for(let j = 0; j < widthRemainder; j++)dest[destPos++] = elem & 1 << 7 - j ? oneMapping : zeroMapping;
    }
    return {
        srcPos: srcPos,
        destPos: destPos
    };
}
function $9ef033443a74bee6$var$convertRGBToRGBA({ src: src, srcPos: srcPos = 0, dest: dest, destPos: destPos = 0, width: width, height: height }) {
    let i = 0;
    const len = width * height * 3;
    const len32 = len >> 2;
    const src32 = new Uint32Array(src.buffer, srcPos, len32);
    if (FeatureTest.isLittleEndian) {
        for(; i < len32 - 2; i += 3, destPos += 4){
            const s1 = src32[i];
            const s2 = src32[i + 1];
            const s3 = src32[i + 2];
            dest[destPos] = s1 | 0xff000000;
            dest[destPos + 1] = s1 >>> 24 | s2 << 8 | 0xff000000;
            dest[destPos + 2] = s2 >>> 16 | s3 << 16 | 0xff000000;
            dest[destPos + 3] = s3 >>> 8 | 0xff000000;
        }
        for(let j = i * 4, jj = srcPos + len; j < jj; j += 3)dest[destPos++] = src[j] | src[j + 1] << 8 | src[j + 2] << 16 | 0xff000000;
    } else {
        for(; i < len32 - 2; i += 3, destPos += 4){
            const s1 = src32[i];
            const s2 = src32[i + 1];
            const s3 = src32[i + 2];
            dest[destPos] = s1 | 0xff;
            dest[destPos + 1] = s1 << 24 | s2 >>> 8 | 0xff;
            dest[destPos + 2] = s2 << 16 | s3 >>> 16 | 0xff;
            dest[destPos + 3] = s3 << 8 | 0xff;
        }
        for(let j = i * 4, jj = srcPos + len; j < jj; j += 3)dest[destPos++] = src[j] << 24 | src[j + 1] << 16 | src[j + 2] << 8 | 0xff;
    }
    return {
        srcPos: srcPos + len,
        destPos: destPos
    };
}
function $9ef033443a74bee6$var$grayToRGBA(src, dest) {
    if (FeatureTest.isLittleEndian) for(let i = 0, ii = src.length; i < ii; i++)dest[i] = src[i] * 0x10101 | 0xff000000;
    else for(let i = 0, ii = src.length; i < ii; i++)dest[i] = src[i] * 0x1010100 | 0x000000ff;
}
const $9ef033443a74bee6$var$MIN_FONT_SIZE = 16;
const $9ef033443a74bee6$var$MAX_FONT_SIZE = 100;
const $9ef033443a74bee6$var$EXECUTION_TIME = 15;
const $9ef033443a74bee6$var$EXECUTION_STEPS = 10;
const $9ef033443a74bee6$var$FULL_CHUNK_HEIGHT = 16;
const $9ef033443a74bee6$var$SCALE_MATRIX = new DOMMatrix();
const $9ef033443a74bee6$var$XY = new Float32Array(2);
const $9ef033443a74bee6$var$MIN_MAX_INIT = new Float32Array([
    Infinity,
    Infinity,
    -Infinity,
    -Infinity
]);
function $9ef033443a74bee6$var$mirrorContextOperations(ctx, destCtx) {
    if (ctx._removeMirroring) throw new Error("Context is already forwarding operations.");
    ctx.__originalSave = ctx.save;
    ctx.__originalRestore = ctx.restore;
    ctx.__originalRotate = ctx.rotate;
    ctx.__originalScale = ctx.scale;
    ctx.__originalTranslate = ctx.translate;
    ctx.__originalTransform = ctx.transform;
    ctx.__originalSetTransform = ctx.setTransform;
    ctx.__originalResetTransform = ctx.resetTransform;
    ctx.__originalClip = ctx.clip;
    ctx.__originalMoveTo = ctx.moveTo;
    ctx.__originalLineTo = ctx.lineTo;
    ctx.__originalBezierCurveTo = ctx.bezierCurveTo;
    ctx.__originalRect = ctx.rect;
    ctx.__originalClosePath = ctx.closePath;
    ctx.__originalBeginPath = ctx.beginPath;
    ctx._removeMirroring = ()=>{
        ctx.save = ctx.__originalSave;
        ctx.restore = ctx.__originalRestore;
        ctx.rotate = ctx.__originalRotate;
        ctx.scale = ctx.__originalScale;
        ctx.translate = ctx.__originalTranslate;
        ctx.transform = ctx.__originalTransform;
        ctx.setTransform = ctx.__originalSetTransform;
        ctx.resetTransform = ctx.__originalResetTransform;
        ctx.clip = ctx.__originalClip;
        ctx.moveTo = ctx.__originalMoveTo;
        ctx.lineTo = ctx.__originalLineTo;
        ctx.bezierCurveTo = ctx.__originalBezierCurveTo;
        ctx.rect = ctx.__originalRect;
        ctx.closePath = ctx.__originalClosePath;
        ctx.beginPath = ctx.__originalBeginPath;
        delete ctx._removeMirroring;
    };
    ctx.save = function() {
        destCtx.save();
        this.__originalSave();
    };
    ctx.restore = function() {
        destCtx.restore();
        this.__originalRestore();
    };
    ctx.translate = function(x, y) {
        destCtx.translate(x, y);
        this.__originalTranslate(x, y);
    };
    ctx.scale = function(x, y) {
        destCtx.scale(x, y);
        this.__originalScale(x, y);
    };
    ctx.transform = function(a, b, c, d, e, f) {
        destCtx.transform(a, b, c, d, e, f);
        this.__originalTransform(a, b, c, d, e, f);
    };
    ctx.setTransform = function(a, b, c, d, e, f) {
        destCtx.setTransform(a, b, c, d, e, f);
        this.__originalSetTransform(a, b, c, d, e, f);
    };
    ctx.resetTransform = function() {
        destCtx.resetTransform();
        this.__originalResetTransform();
    };
    ctx.rotate = function(angle) {
        destCtx.rotate(angle);
        this.__originalRotate(angle);
    };
    ctx.clip = function(rule) {
        destCtx.clip(rule);
        this.__originalClip(rule);
    };
    ctx.moveTo = function(x, y) {
        destCtx.moveTo(x, y);
        this.__originalMoveTo(x, y);
    };
    ctx.lineTo = function(x, y) {
        destCtx.lineTo(x, y);
        this.__originalLineTo(x, y);
    };
    ctx.bezierCurveTo = function(cp1x, cp1y, cp2x, cp2y, x, y) {
        destCtx.bezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y);
        this.__originalBezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y);
    };
    ctx.rect = function(x, y, width, height) {
        destCtx.rect(x, y, width, height);
        this.__originalRect(x, y, width, height);
    };
    ctx.closePath = function() {
        destCtx.closePath();
        this.__originalClosePath();
    };
    ctx.beginPath = function() {
        destCtx.beginPath();
        this.__originalBeginPath();
    };
}
class $9ef033443a74bee6$var$CachedCanvases {
    constructor(canvasFactory){
        this.canvasFactory = canvasFactory;
        this.cache = Object.create(null);
    }
    getCanvas(id, width, height) {
        let canvasEntry;
        if (this.cache[id] !== undefined) {
            canvasEntry = this.cache[id];
            this.canvasFactory.reset(canvasEntry, width, height);
        } else {
            canvasEntry = this.canvasFactory.create(width, height);
            this.cache[id] = canvasEntry;
        }
        return canvasEntry;
    }
    delete(id) {
        delete this.cache[id];
    }
    clear() {
        for(const id in this.cache){
            const canvasEntry = this.cache[id];
            this.canvasFactory.destroy(canvasEntry);
            delete this.cache[id];
        }
    }
}
function $9ef033443a74bee6$var$drawImageAtIntegerCoords(ctx, srcImg, srcX, srcY, srcW, srcH, destX, destY, destW, destH) {
    const [a, b, c, d, tx, ty] = $9ef033443a74bee6$var$getCurrentTransform(ctx);
    if (b === 0 && c === 0) {
        const tlX = destX * a + tx;
        const rTlX = Math.round(tlX);
        const tlY = destY * d + ty;
        const rTlY = Math.round(tlY);
        const brX = (destX + destW) * a + tx;
        const rWidth = Math.abs(Math.round(brX) - rTlX) || 1;
        const brY = (destY + destH) * d + ty;
        const rHeight = Math.abs(Math.round(brY) - rTlY) || 1;
        ctx.setTransform(Math.sign(a), 0, 0, Math.sign(d), rTlX, rTlY);
        ctx.drawImage(srcImg, srcX, srcY, srcW, srcH, 0, 0, rWidth, rHeight);
        ctx.setTransform(a, b, c, d, tx, ty);
        return [
            rWidth,
            rHeight
        ];
    }
    if (a === 0 && d === 0) {
        const tlX = destY * c + tx;
        const rTlX = Math.round(tlX);
        const tlY = destX * b + ty;
        const rTlY = Math.round(tlY);
        const brX = (destY + destH) * c + tx;
        const rWidth = Math.abs(Math.round(brX) - rTlX) || 1;
        const brY = (destX + destW) * b + ty;
        const rHeight = Math.abs(Math.round(brY) - rTlY) || 1;
        ctx.setTransform(0, Math.sign(b), Math.sign(c), 0, rTlX, rTlY);
        ctx.drawImage(srcImg, srcX, srcY, srcW, srcH, 0, 0, rHeight, rWidth);
        ctx.setTransform(a, b, c, d, tx, ty);
        return [
            rHeight,
            rWidth
        ];
    }
    ctx.drawImage(srcImg, srcX, srcY, srcW, srcH, destX, destY, destW, destH);
    const scaleX = Math.hypot(a, b);
    const scaleY = Math.hypot(c, d);
    return [
        scaleX * destW,
        scaleY * destH
    ];
}
class $9ef033443a74bee6$var$CanvasExtraState {
    alphaIsShape = false;
    fontSize = 0;
    fontSizeScale = 1;
    textMatrix = null;
    textMatrixScale = 1;
    fontMatrix = $9ef033443a74bee6$var$FONT_IDENTITY_MATRIX;
    leading = 0;
    x = 0;
    y = 0;
    lineX = 0;
    lineY = 0;
    charSpacing = 0;
    wordSpacing = 0;
    textHScale = 1;
    textRenderingMode = $9ef033443a74bee6$var$TextRenderingMode.FILL;
    textRise = 0;
    fillColor = "#000000";
    strokeColor = "#000000";
    patternFill = false;
    patternStroke = false;
    fillAlpha = 1;
    strokeAlpha = 1;
    lineWidth = 1;
    activeSMask = null;
    transferMaps = "none";
    constructor(width, height, preInit){
        preInit?.(this);
        this.clipBox = new Float32Array([
            0,
            0,
            width,
            height
        ]);
        this.minMax = $9ef033443a74bee6$var$MIN_MAX_INIT.slice();
    }
    clone() {
        const clone = Object.create(this);
        clone.clipBox = this.clipBox.slice();
        clone.minMax = this.minMax.slice();
        return clone;
    }
    getPathBoundingBox(pathType = $9ef033443a74bee6$var$PathType.FILL, transform = null) {
        const box = this.minMax.slice();
        if (pathType === $9ef033443a74bee6$var$PathType.STROKE) {
            if (!transform) $9ef033443a74bee6$var$unreachable("Stroke bounding box must include transform.");
            $9ef033443a74bee6$export$f8f26dd395d7e1bd.singularValueDecompose2dScale(transform, $9ef033443a74bee6$var$XY);
            const xStrokePad = $9ef033443a74bee6$var$XY[0] * this.lineWidth / 2;
            const yStrokePad = $9ef033443a74bee6$var$XY[1] * this.lineWidth / 2;
            box[0] -= xStrokePad;
            box[1] -= yStrokePad;
            box[2] += xStrokePad;
            box[3] += yStrokePad;
        }
        return box;
    }
    updateClipFromPath() {
        const intersect = $9ef033443a74bee6$export$f8f26dd395d7e1bd.intersect(this.clipBox, this.getPathBoundingBox());
        this.startNewPathAndClipBox(intersect || [
            0,
            0,
            0,
            0
        ]);
    }
    isEmptyClip() {
        return this.minMax[0] === Infinity;
    }
    startNewPathAndClipBox(box) {
        this.clipBox.set(box, 0);
        this.minMax.set($9ef033443a74bee6$var$MIN_MAX_INIT, 0);
    }
    getClippedPathBoundingBox(pathType = $9ef033443a74bee6$var$PathType.FILL, transform = null) {
        return $9ef033443a74bee6$export$f8f26dd395d7e1bd.intersect(this.clipBox, this.getPathBoundingBox(pathType, transform));
    }
}
function $9ef033443a74bee6$var$putBinaryImageData(ctx, imgData) {
    if (imgData instanceof ImageData) {
        ctx.putImageData(imgData, 0, 0);
        return;
    }
    const height = imgData.height, width = imgData.width;
    const partialChunkHeight = height % $9ef033443a74bee6$var$FULL_CHUNK_HEIGHT;
    const fullChunks = (height - partialChunkHeight) / $9ef033443a74bee6$var$FULL_CHUNK_HEIGHT;
    const totalChunks = partialChunkHeight === 0 ? fullChunks : fullChunks + 1;
    const chunkImgData = ctx.createImageData(width, $9ef033443a74bee6$var$FULL_CHUNK_HEIGHT);
    let srcPos = 0, destPos;
    const src = imgData.data;
    const dest = chunkImgData.data;
    let i, j, thisChunkHeight, elemsInThisChunk;
    if (imgData.kind === $9ef033443a74bee6$export$b890e9c15247e0b3.GRAYSCALE_1BPP) {
        const srcLength = src.byteLength;
        const dest32 = new Uint32Array(dest.buffer, 0, dest.byteLength >> 2);
        const dest32DataLength = dest32.length;
        const fullSrcDiff = width + 7 >> 3;
        const white = 0xffffffff;
        const black = $9ef033443a74bee6$export$5fb8891d35c36978.isLittleEndian ? 0xff000000 : 0x000000ff;
        for(i = 0; i < totalChunks; i++){
            thisChunkHeight = i < fullChunks ? $9ef033443a74bee6$var$FULL_CHUNK_HEIGHT : partialChunkHeight;
            destPos = 0;
            for(j = 0; j < thisChunkHeight; j++){
                const srcDiff = srcLength - srcPos;
                let k = 0;
                const kEnd = srcDiff > fullSrcDiff ? width : srcDiff * 8 - 7;
                const kEndUnrolled = kEnd & -8;
                let mask = 0;
                let srcByte = 0;
                for(; k < kEndUnrolled; k += 8){
                    srcByte = src[srcPos++];
                    dest32[destPos++] = srcByte & 128 ? white : black;
                    dest32[destPos++] = srcByte & 64 ? white : black;
                    dest32[destPos++] = srcByte & 32 ? white : black;
                    dest32[destPos++] = srcByte & 16 ? white : black;
                    dest32[destPos++] = srcByte & 8 ? white : black;
                    dest32[destPos++] = srcByte & 4 ? white : black;
                    dest32[destPos++] = srcByte & 2 ? white : black;
                    dest32[destPos++] = srcByte & 1 ? white : black;
                }
                for(; k < kEnd; k++){
                    if (mask === 0) {
                        srcByte = src[srcPos++];
                        mask = 128;
                    }
                    dest32[destPos++] = srcByte & mask ? white : black;
                    mask >>= 1;
                }
            }
            while(destPos < dest32DataLength)dest32[destPos++] = 0;
            ctx.putImageData(chunkImgData, 0, i * $9ef033443a74bee6$var$FULL_CHUNK_HEIGHT);
        }
    } else if (imgData.kind === $9ef033443a74bee6$export$b890e9c15247e0b3.RGBA_32BPP) {
        j = 0;
        elemsInThisChunk = width * $9ef033443a74bee6$var$FULL_CHUNK_HEIGHT * 4;
        for(i = 0; i < fullChunks; i++){
            dest.set(src.subarray(srcPos, srcPos + elemsInThisChunk));
            srcPos += elemsInThisChunk;
            ctx.putImageData(chunkImgData, 0, j);
            j += $9ef033443a74bee6$var$FULL_CHUNK_HEIGHT;
        }
        if (i < totalChunks) {
            elemsInThisChunk = width * partialChunkHeight * 4;
            dest.set(src.subarray(srcPos, srcPos + elemsInThisChunk));
            ctx.putImageData(chunkImgData, 0, j);
        }
    } else if (imgData.kind === $9ef033443a74bee6$export$b890e9c15247e0b3.RGB_24BPP) {
        thisChunkHeight = $9ef033443a74bee6$var$FULL_CHUNK_HEIGHT;
        elemsInThisChunk = width * thisChunkHeight;
        for(i = 0; i < totalChunks; i++){
            if (i >= fullChunks) {
                thisChunkHeight = partialChunkHeight;
                elemsInThisChunk = width * thisChunkHeight;
            }
            destPos = 0;
            for(j = elemsInThisChunk; j--;){
                dest[destPos++] = src[srcPos++];
                dest[destPos++] = src[srcPos++];
                dest[destPos++] = src[srcPos++];
                dest[destPos++] = 255;
            }
            ctx.putImageData(chunkImgData, 0, i * $9ef033443a74bee6$var$FULL_CHUNK_HEIGHT);
        }
    } else throw new Error(`bad image kind: ${imgData.kind}`);
}
function $9ef033443a74bee6$var$putBinaryImageMask(ctx, imgData) {
    if (imgData.bitmap) {
        ctx.drawImage(imgData.bitmap, 0, 0);
        return;
    }
    const height = imgData.height, width = imgData.width;
    const partialChunkHeight = height % $9ef033443a74bee6$var$FULL_CHUNK_HEIGHT;
    const fullChunks = (height - partialChunkHeight) / $9ef033443a74bee6$var$FULL_CHUNK_HEIGHT;
    const totalChunks = partialChunkHeight === 0 ? fullChunks : fullChunks + 1;
    const chunkImgData = ctx.createImageData(width, $9ef033443a74bee6$var$FULL_CHUNK_HEIGHT);
    let srcPos = 0;
    const src = imgData.data;
    const dest = chunkImgData.data;
    for(let i = 0; i < totalChunks; i++){
        const thisChunkHeight = i < fullChunks ? $9ef033443a74bee6$var$FULL_CHUNK_HEIGHT : partialChunkHeight;
        ({ srcPos: srcPos } = $9ef033443a74bee6$var$convertBlackAndWhiteToRGBA({
            src: src,
            srcPos: srcPos,
            dest: dest,
            width: width,
            height: thisChunkHeight,
            nonBlackColor: 0
        }));
        ctx.putImageData(chunkImgData, 0, i * $9ef033443a74bee6$var$FULL_CHUNK_HEIGHT);
    }
}
function $9ef033443a74bee6$var$copyCtxState(sourceCtx, destCtx) {
    const properties = [
        "strokeStyle",
        "fillStyle",
        "fillRule",
        "globalAlpha",
        "lineWidth",
        "lineCap",
        "lineJoin",
        "miterLimit",
        "globalCompositeOperation",
        "font",
        "filter"
    ];
    for (const property of properties)if (sourceCtx[property] !== undefined) destCtx[property] = sourceCtx[property];
    if (sourceCtx.setLineDash !== undefined) {
        destCtx.setLineDash(sourceCtx.getLineDash());
        destCtx.lineDashOffset = sourceCtx.lineDashOffset;
    }
}
function $9ef033443a74bee6$var$resetCtxToDefault(ctx) {
    ctx.strokeStyle = ctx.fillStyle = "#000000";
    ctx.fillRule = "nonzero";
    ctx.globalAlpha = 1;
    ctx.lineWidth = 1;
    ctx.lineCap = "butt";
    ctx.lineJoin = "miter";
    ctx.miterLimit = 10;
    ctx.globalCompositeOperation = "source-over";
    ctx.font = "10px sans-serif";
    if (ctx.setLineDash !== undefined) {
        ctx.setLineDash([]);
        ctx.lineDashOffset = 0;
    }
    const { filter: filter } = ctx;
    if (filter !== "none" && filter !== "") ctx.filter = "none";
}
function $9ef033443a74bee6$var$getImageSmoothingEnabled(transform, interpolate) {
    if (interpolate) return true;
    $9ef033443a74bee6$export$f8f26dd395d7e1bd.singularValueDecompose2dScale(transform, $9ef033443a74bee6$var$XY);
    const actualScale = Math.fround($9ef033443a74bee6$export$f16a99f63bccd50b.pixelRatio * $9ef033443a74bee6$export$6ef3b6b69e65342c.PDF_TO_CSS_UNITS);
    return $9ef033443a74bee6$var$XY[0] <= actualScale && $9ef033443a74bee6$var$XY[1] <= actualScale;
}
const $9ef033443a74bee6$var$LINE_CAP_STYLES = [
    "butt",
    "round",
    "square"
];
const $9ef033443a74bee6$var$LINE_JOIN_STYLES = [
    "miter",
    "round",
    "bevel"
];
const $9ef033443a74bee6$var$NORMAL_CLIP = {};
const $9ef033443a74bee6$var$EO_CLIP = {};
class $9ef033443a74bee6$var$CanvasGraphics {
    constructor(canvasCtx, commonObjs, objs, canvasFactory, filterFactory, { optionalContentConfig: optionalContentConfig, markedContentStack: markedContentStack = null }, annotationCanvasMap, pageColors, dependencyTracker){
        this.ctx = canvasCtx;
        this.current = new $9ef033443a74bee6$var$CanvasExtraState(this.ctx.canvas.width, this.ctx.canvas.height);
        this.stateStack = [];
        this.pendingClip = null;
        this.pendingEOFill = false;
        this.res = null;
        this.xobjs = null;
        this.commonObjs = commonObjs;
        this.objs = objs;
        this.canvasFactory = canvasFactory;
        this.filterFactory = filterFactory;
        this.groupStack = [];
        this.baseTransform = null;
        this.baseTransformStack = [];
        this.groupLevel = 0;
        this.smaskStack = [];
        this.smaskCounter = 0;
        this.tempSMask = null;
        this.suspendedCtx = null;
        this.contentVisible = true;
        this.markedContentStack = markedContentStack || [];
        this.optionalContentConfig = optionalContentConfig;
        this.cachedCanvases = new $9ef033443a74bee6$var$CachedCanvases(this.canvasFactory);
        this.cachedPatterns = new Map();
        this.annotationCanvasMap = annotationCanvasMap;
        this.viewportScale = 1;
        this.outputScaleX = 1;
        this.outputScaleY = 1;
        this.pageColors = pageColors;
        this._cachedScaleForStroking = [
            -1,
            0
        ];
        this._cachedGetSinglePixelWidth = null;
        this._cachedBitmapsMap = new Map();
        this.dependencyTracker = dependencyTracker ?? null;
    }
    getObject(opIdx, data, fallback = null) {
        if (typeof data === "string") {
            this.dependencyTracker?.recordNamedDependency(opIdx, data);
            return data.startsWith("g_") ? this.commonObjs.get(data) : this.objs.get(data);
        }
        return fallback;
    }
    beginDrawing({ transform: transform, viewport: viewport, transparency: transparency = false, background: background = null }) {
        const width = this.ctx.canvas.width;
        const height = this.ctx.canvas.height;
        const savedFillStyle = this.ctx.fillStyle;
        this.ctx.fillStyle = background || "#ffffff";
        this.ctx.fillRect(0, 0, width, height);
        this.ctx.fillStyle = savedFillStyle;
        if (transparency) {
            const transparentCanvas = this.cachedCanvases.getCanvas("transparent", width, height);
            this.compositeCtx = this.ctx;
            this.transparentCanvas = transparentCanvas.canvas;
            this.ctx = transparentCanvas.context;
            this.ctx.save();
            this.ctx.transform(...$9ef033443a74bee6$var$getCurrentTransform(this.compositeCtx));
        }
        this.ctx.save();
        $9ef033443a74bee6$var$resetCtxToDefault(this.ctx);
        if (transform) {
            this.ctx.transform(...transform);
            this.outputScaleX = transform[0];
            this.outputScaleY = transform[0];
        }
        this.ctx.transform(...viewport.transform);
        this.viewportScale = viewport.scale;
        this.baseTransform = $9ef033443a74bee6$var$getCurrentTransform(this.ctx);
    }
    executeOperatorList(operatorList, executionStartIdx, continueCallback, stepper, operationsFilter) {
        const argsArray = operatorList.argsArray;
        const fnArray = operatorList.fnArray;
        let i = executionStartIdx || 0;
        const argsArrayLen = argsArray.length;
        if (argsArrayLen === i) return i;
        const chunkOperations = argsArrayLen - i > $9ef033443a74bee6$var$EXECUTION_STEPS && typeof continueCallback === "function";
        const endTime = chunkOperations ? Date.now() + $9ef033443a74bee6$var$EXECUTION_TIME : 0;
        let steps = 0;
        const commonObjs = this.commonObjs;
        const objs = this.objs;
        let fnId, fnArgs;
        while(true){
            if (stepper !== undefined && i === stepper.nextBreakPoint) {
                stepper.breakIt(i, continueCallback);
                return i;
            }
            if (!operationsFilter || operationsFilter(i)) {
                fnId = fnArray[i];
                fnArgs = argsArray[i] ?? null;
                if (fnId !== $9ef033443a74bee6$export$3a0f7f7a8a0b306b.dependency) {
                    if (fnArgs === null) this[fnId](i);
                    else this[fnId](i, ...fnArgs);
                } else for (const depObjId of fnArgs){
                    this.dependencyTracker?.recordNamedData(depObjId, i);
                    const objsPool = depObjId.startsWith("g_") ? commonObjs : objs;
                    if (!objsPool.has(depObjId)) {
                        objsPool.get(depObjId, continueCallback);
                        return i;
                    }
                }
            }
            i++;
            if (i === argsArrayLen) return i;
            if (chunkOperations && ++steps > $9ef033443a74bee6$var$EXECUTION_STEPS) {
                if (Date.now() > endTime) {
                    continueCallback();
                    return i;
                }
                steps = 0;
            }
        }
    }
    #restoreInitialState() {
        while(this.stateStack.length || this.inSMaskMode)this.restore();
        this.current.activeSMask = null;
        this.ctx.restore();
        if (this.transparentCanvas) {
            this.ctx = this.compositeCtx;
            this.ctx.save();
            this.ctx.setTransform(1, 0, 0, 1, 0, 0);
            this.ctx.drawImage(this.transparentCanvas, 0, 0);
            this.ctx.restore();
            this.transparentCanvas = null;
        }
    }
    endDrawing() {
        this.#restoreInitialState();
        this.cachedCanvases.clear();
        this.cachedPatterns.clear();
        for (const cache of this._cachedBitmapsMap.values()){
            for (const canvas of cache.values())if (typeof HTMLCanvasElement !== "undefined" && canvas instanceof HTMLCanvasElement) canvas.width = canvas.height = 0;
            cache.clear();
        }
        this._cachedBitmapsMap.clear();
        this.#drawFilter();
    }
    #drawFilter() {
        if (this.pageColors) {
            const hcmFilterId = this.filterFactory.addHCMFilter(this.pageColors.foreground, this.pageColors.background);
            if (hcmFilterId !== "none") {
                const savedFilter = this.ctx.filter;
                this.ctx.filter = hcmFilterId;
                this.ctx.drawImage(this.ctx.canvas, 0, 0);
                this.ctx.filter = savedFilter;
            }
        }
    }
    _scaleImage(img, inverseTransform) {
        const width = img.width ?? img.displayWidth;
        const height = img.height ?? img.displayHeight;
        let widthScale = Math.max(Math.hypot(inverseTransform[0], inverseTransform[1]), 1);
        let heightScale = Math.max(Math.hypot(inverseTransform[2], inverseTransform[3]), 1);
        let paintWidth = width, paintHeight = height;
        let tmpCanvasId = "prescale1";
        let tmpCanvas, tmpCtx;
        while(widthScale > 2 && paintWidth > 1 || heightScale > 2 && paintHeight > 1){
            let newWidth = paintWidth, newHeight = paintHeight;
            if (widthScale > 2 && paintWidth > 1) {
                newWidth = paintWidth >= 16384 ? Math.floor(paintWidth / 2) - 1 || 1 : Math.ceil(paintWidth / 2);
                widthScale /= paintWidth / newWidth;
            }
            if (heightScale > 2 && paintHeight > 1) {
                newHeight = paintHeight >= 16384 ? Math.floor(paintHeight / 2) - 1 || 1 : Math.ceil(paintHeight) / 2;
                heightScale /= paintHeight / newHeight;
            }
            tmpCanvas = this.cachedCanvases.getCanvas(tmpCanvasId, newWidth, newHeight);
            tmpCtx = tmpCanvas.context;
            tmpCtx.clearRect(0, 0, newWidth, newHeight);
            tmpCtx.drawImage(img, 0, 0, paintWidth, paintHeight, 0, 0, newWidth, newHeight);
            img = tmpCanvas.canvas;
            paintWidth = newWidth;
            paintHeight = newHeight;
            tmpCanvasId = tmpCanvasId === "prescale1" ? "prescale2" : "prescale1";
        }
        return {
            img: img,
            paintWidth: paintWidth,
            paintHeight: paintHeight
        };
    }
    _createMaskCanvas(opIdx, img) {
        const ctx = this.ctx;
        const { width: width, height: height } = img;
        const fillColor = this.current.fillColor;
        const isPatternFill = this.current.patternFill;
        const currentTransform = $9ef033443a74bee6$var$getCurrentTransform(ctx);
        let cache, cacheKey, scaled, maskCanvas;
        if ((img.bitmap || img.data) && img.count > 1) {
            const mainKey = img.bitmap || img.data.buffer;
            cacheKey = JSON.stringify(isPatternFill ? currentTransform : [
                currentTransform.slice(0, 4),
                fillColor
            ]);
            cache = this._cachedBitmapsMap.get(mainKey);
            if (!cache) {
                cache = new Map();
                this._cachedBitmapsMap.set(mainKey, cache);
            }
            const cachedImage = cache.get(cacheKey);
            if (cachedImage && !isPatternFill) {
                const offsetX = Math.round(Math.min(currentTransform[0], currentTransform[2]) + currentTransform[4]);
                const offsetY = Math.round(Math.min(currentTransform[1], currentTransform[3]) + currentTransform[5]);
                this.dependencyTracker?.recordDependencies(opIdx, $9ef033443a74bee6$var$Dependencies.transformAndFill);
                return {
                    canvas: cachedImage,
                    offsetX: offsetX,
                    offsetY: offsetY
                };
            }
            scaled = cachedImage;
        }
        if (!scaled) {
            maskCanvas = this.cachedCanvases.getCanvas("maskCanvas", width, height);
            $9ef033443a74bee6$var$putBinaryImageMask(maskCanvas.context, img);
        }
        let maskToCanvas = $9ef033443a74bee6$export$f8f26dd395d7e1bd.transform(currentTransform, [
            1 / width,
            0,
            0,
            -1 / height,
            0,
            0
        ]);
        maskToCanvas = $9ef033443a74bee6$export$f8f26dd395d7e1bd.transform(maskToCanvas, [
            1,
            0,
            0,
            1,
            0,
            -height
        ]);
        const minMax = $9ef033443a74bee6$var$MIN_MAX_INIT.slice();
        $9ef033443a74bee6$export$f8f26dd395d7e1bd.axialAlignedBoundingBox([
            0,
            0,
            width,
            height
        ], maskToCanvas, minMax);
        const [minX, minY, maxX, maxY] = minMax;
        const drawnWidth = Math.round(maxX - minX) || 1;
        const drawnHeight = Math.round(maxY - minY) || 1;
        const fillCanvas = this.cachedCanvases.getCanvas("fillCanvas", drawnWidth, drawnHeight);
        const fillCtx = fillCanvas.context;
        const offsetX = minX;
        const offsetY = minY;
        fillCtx.translate(-offsetX, -offsetY);
        fillCtx.transform(...maskToCanvas);
        if (!scaled) {
            scaled = this._scaleImage(maskCanvas.canvas, $9ef033443a74bee6$var$getCurrentTransformInverse(fillCtx));
            scaled = scaled.img;
            if (cache && isPatternFill) cache.set(cacheKey, scaled);
        }
        fillCtx.imageSmoothingEnabled = $9ef033443a74bee6$var$getImageSmoothingEnabled($9ef033443a74bee6$var$getCurrentTransform(fillCtx), img.interpolate);
        $9ef033443a74bee6$var$drawImageAtIntegerCoords(fillCtx, scaled, 0, 0, scaled.width, scaled.height, 0, 0, width, height);
        fillCtx.globalCompositeOperation = "source-in";
        const inverse = $9ef033443a74bee6$export$f8f26dd395d7e1bd.transform($9ef033443a74bee6$var$getCurrentTransformInverse(fillCtx), [
            1,
            0,
            0,
            1,
            -offsetX,
            -offsetY
        ]);
        fillCtx.fillStyle = isPatternFill ? fillColor.getPattern(ctx, this, inverse, $9ef033443a74bee6$var$PathType.FILL, opIdx) : fillColor;
        fillCtx.fillRect(0, 0, width, height);
        if (cache && !isPatternFill) {
            this.cachedCanvases.delete("fillCanvas");
            cache.set(cacheKey, fillCanvas.canvas);
        }
        this.dependencyTracker?.recordDependencies(opIdx, $9ef033443a74bee6$var$Dependencies.transformAndFill);
        return {
            canvas: fillCanvas.canvas,
            offsetX: Math.round(offsetX),
            offsetY: Math.round(offsetY)
        };
    }
    setLineWidth(opIdx, width) {
        this.dependencyTracker?.recordSimpleData("lineWidth", opIdx);
        if (width !== this.current.lineWidth) this._cachedScaleForStroking[0] = -1;
        this.current.lineWidth = width;
        this.ctx.lineWidth = width;
    }
    setLineCap(opIdx, style) {
        this.dependencyTracker?.recordSimpleData("lineCap", opIdx);
        this.ctx.lineCap = $9ef033443a74bee6$var$LINE_CAP_STYLES[style];
    }
    setLineJoin(opIdx, style) {
        this.dependencyTracker?.recordSimpleData("lineJoin", opIdx);
        this.ctx.lineJoin = $9ef033443a74bee6$var$LINE_JOIN_STYLES[style];
    }
    setMiterLimit(opIdx, limit) {
        this.dependencyTracker?.recordSimpleData("miterLimit", opIdx);
        this.ctx.miterLimit = limit;
    }
    setDash(opIdx, dashArray, dashPhase) {
        this.dependencyTracker?.recordSimpleData("dash", opIdx);
        const ctx = this.ctx;
        if (ctx.setLineDash !== undefined) {
            ctx.setLineDash(dashArray);
            ctx.lineDashOffset = dashPhase;
        }
    }
    setRenderingIntent(opIdx, intent) {}
    setFlatness(opIdx, flatness) {}
    setGState(opIdx, states) {
        for (const [key, value] of states)switch(key){
            case "LW":
                this.setLineWidth(opIdx, value);
                break;
            case "LC":
                this.setLineCap(opIdx, value);
                break;
            case "LJ":
                this.setLineJoin(opIdx, value);
                break;
            case "ML":
                this.setMiterLimit(opIdx, value);
                break;
            case "D":
                this.setDash(opIdx, value[0], value[1]);
                break;
            case "RI":
                this.setRenderingIntent(opIdx, value);
                break;
            case "FL":
                this.setFlatness(opIdx, value);
                break;
            case "Font":
                this.setFont(opIdx, value[0], value[1]);
                break;
            case "CA":
                this.dependencyTracker?.recordSimpleData("strokeAlpha", opIdx);
                this.current.strokeAlpha = value;
                break;
            case "ca":
                this.dependencyTracker?.recordSimpleData("fillAlpha", opIdx);
                this.ctx.globalAlpha = this.current.fillAlpha = value;
                break;
            case "BM":
                this.dependencyTracker?.recordSimpleData("globalCompositeOperation", opIdx);
                this.ctx.globalCompositeOperation = value;
                break;
            case "SMask":
                this.dependencyTracker?.recordSimpleData("SMask", opIdx);
                this.current.activeSMask = value ? this.tempSMask : null;
                this.tempSMask = null;
                this.checkSMaskState();
                break;
            case "TR":
                this.dependencyTracker?.recordSimpleData("filter", opIdx);
                this.ctx.filter = this.current.transferMaps = this.filterFactory.addFilter(value);
                break;
        }
    }
    get inSMaskMode() {
        return !!this.suspendedCtx;
    }
    checkSMaskState() {
        const inSMaskMode = this.inSMaskMode;
        if (this.current.activeSMask && !inSMaskMode) this.beginSMaskMode();
        else if (!this.current.activeSMask && inSMaskMode) this.endSMaskMode();
    }
    beginSMaskMode(opIdx) {
        if (this.inSMaskMode) throw new Error("beginSMaskMode called while already in smask mode");
        const drawnWidth = this.ctx.canvas.width;
        const drawnHeight = this.ctx.canvas.height;
        const cacheId = "smaskGroupAt" + this.groupLevel;
        const scratchCanvas = this.cachedCanvases.getCanvas(cacheId, drawnWidth, drawnHeight);
        this.suspendedCtx = this.ctx;
        const ctx = this.ctx = scratchCanvas.context;
        ctx.setTransform(this.suspendedCtx.getTransform());
        $9ef033443a74bee6$var$copyCtxState(this.suspendedCtx, ctx);
        $9ef033443a74bee6$var$mirrorContextOperations(ctx, this.suspendedCtx);
        this.setGState(opIdx, [
            [
                "BM",
                "source-over"
            ]
        ]);
    }
    endSMaskMode() {
        if (!this.inSMaskMode) throw new Error("endSMaskMode called while not in smask mode");
        this.ctx._removeMirroring();
        $9ef033443a74bee6$var$copyCtxState(this.ctx, this.suspendedCtx);
        this.ctx = this.suspendedCtx;
        this.suspendedCtx = null;
    }
    compose(dirtyBox) {
        if (!this.current.activeSMask) return;
        if (!dirtyBox) dirtyBox = [
            0,
            0,
            this.ctx.canvas.width,
            this.ctx.canvas.height
        ];
        else {
            dirtyBox[0] = Math.floor(dirtyBox[0]);
            dirtyBox[1] = Math.floor(dirtyBox[1]);
            dirtyBox[2] = Math.ceil(dirtyBox[2]);
            dirtyBox[3] = Math.ceil(dirtyBox[3]);
        }
        const smask = this.current.activeSMask;
        const suspendedCtx = this.suspendedCtx;
        this.composeSMask(suspendedCtx, smask, this.ctx, dirtyBox);
        this.ctx.save();
        this.ctx.setTransform(1, 0, 0, 1, 0, 0);
        this.ctx.clearRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height);
        this.ctx.restore();
    }
    composeSMask(ctx, smask, layerCtx, layerBox) {
        const layerOffsetX = layerBox[0];
        const layerOffsetY = layerBox[1];
        const layerWidth = layerBox[2] - layerOffsetX;
        const layerHeight = layerBox[3] - layerOffsetY;
        if (layerWidth === 0 || layerHeight === 0) return;
        this.genericComposeSMask(smask.context, layerCtx, layerWidth, layerHeight, smask.subtype, smask.backdrop, smask.transferMap, layerOffsetX, layerOffsetY, smask.offsetX, smask.offsetY);
        ctx.save();
        ctx.globalAlpha = 1;
        ctx.globalCompositeOperation = "source-over";
        ctx.setTransform(1, 0, 0, 1, 0, 0);
        ctx.drawImage(layerCtx.canvas, 0, 0);
        ctx.restore();
    }
    genericComposeSMask(maskCtx, layerCtx, width, height, subtype, backdrop, transferMap, layerOffsetX, layerOffsetY, maskOffsetX, maskOffsetY) {
        let maskCanvas = maskCtx.canvas;
        let maskX = layerOffsetX - maskOffsetX;
        let maskY = layerOffsetY - maskOffsetY;
        if (backdrop) {
            if (maskX < 0 || maskY < 0 || maskX + width > maskCanvas.width || maskY + height > maskCanvas.height) {
                const canvas = this.cachedCanvases.getCanvas("maskExtension", width, height);
                const ctx = canvas.context;
                ctx.drawImage(maskCanvas, -maskX, -maskY);
                ctx.globalCompositeOperation = "destination-atop";
                ctx.fillStyle = backdrop;
                ctx.fillRect(0, 0, width, height);
                ctx.globalCompositeOperation = "source-over";
                maskCanvas = canvas.canvas;
                maskX = maskY = 0;
            } else {
                maskCtx.save();
                maskCtx.globalAlpha = 1;
                maskCtx.setTransform(1, 0, 0, 1, 0, 0);
                const clip = new Path2D();
                clip.rect(maskX, maskY, width, height);
                maskCtx.clip(clip);
                maskCtx.globalCompositeOperation = "destination-atop";
                maskCtx.fillStyle = backdrop;
                maskCtx.fillRect(maskX, maskY, width, height);
                maskCtx.restore();
            }
        }
        layerCtx.save();
        layerCtx.globalAlpha = 1;
        layerCtx.setTransform(1, 0, 0, 1, 0, 0);
        if (subtype === "Alpha" && transferMap) layerCtx.filter = this.filterFactory.addAlphaFilter(transferMap);
        else if (subtype === "Luminosity") layerCtx.filter = this.filterFactory.addLuminosityFilter(transferMap);
        const clip = new Path2D();
        clip.rect(layerOffsetX, layerOffsetY, width, height);
        layerCtx.clip(clip);
        layerCtx.globalCompositeOperation = "destination-in";
        layerCtx.drawImage(maskCanvas, maskX, maskY, width, height, layerOffsetX, layerOffsetY, width, height);
        layerCtx.restore();
    }
    save(opIdx) {
        if (this.inSMaskMode) $9ef033443a74bee6$var$copyCtxState(this.ctx, this.suspendedCtx);
        this.ctx.save();
        const old = this.current;
        this.stateStack.push(old);
        this.current = old.clone();
        this.dependencyTracker?.save(opIdx);
    }
    restore(opIdx) {
        this.dependencyTracker?.restore(opIdx);
        if (this.stateStack.length === 0) {
            if (this.inSMaskMode) this.endSMaskMode();
            return;
        }
        this.current = this.stateStack.pop();
        this.ctx.restore();
        if (this.inSMaskMode) $9ef033443a74bee6$var$copyCtxState(this.suspendedCtx, this.ctx);
        this.checkSMaskState();
        this.pendingClip = null;
        this._cachedScaleForStroking[0] = -1;
        this._cachedGetSinglePixelWidth = null;
    }
    transform(opIdx, a, b, c, d, e, f) {
        this.dependencyTracker?.recordIncrementalData("transform", opIdx);
        this.ctx.transform(a, b, c, d, e, f);
        this._cachedScaleForStroking[0] = -1;
        this._cachedGetSinglePixelWidth = null;
    }
    constructPath(opIdx, op, data, minMax) {
        let [path] = data;
        if (!minMax) {
            path ||= data[0] = new Path2D();
            this[op](opIdx, path);
            return;
        }
        if (this.dependencyTracker !== null) {
            const outerExtraSize = op === $9ef033443a74bee6$export$3a0f7f7a8a0b306b.stroke ? this.current.lineWidth / 2 : 0;
            this.dependencyTracker.resetBBox(opIdx).recordBBox(opIdx, this.ctx, minMax[0] - outerExtraSize, minMax[2] + outerExtraSize, minMax[1] - outerExtraSize, minMax[3] + outerExtraSize).recordDependencies(opIdx, [
                "transform"
            ]);
        }
        if (!(path instanceof Path2D)) {
            const path2d = data[0] = new Path2D();
            for(let i = 0, ii = path.length; i < ii;)switch(path[i++]){
                case $9ef033443a74bee6$var$DrawOPS.moveTo:
                    path2d.moveTo(path[i++], path[i++]);
                    break;
                case $9ef033443a74bee6$var$DrawOPS.lineTo:
                    path2d.lineTo(path[i++], path[i++]);
                    break;
                case $9ef033443a74bee6$var$DrawOPS.curveTo:
                    path2d.bezierCurveTo(path[i++], path[i++], path[i++], path[i++], path[i++], path[i++]);
                    break;
                case $9ef033443a74bee6$var$DrawOPS.closePath:
                    path2d.closePath();
                    break;
                default:
                    $9ef033443a74bee6$var$warn(`Unrecognized drawing path operator: ${path[i - 1]}`);
                    break;
            }
            path = path2d;
        }
        $9ef033443a74bee6$export$f8f26dd395d7e1bd.axialAlignedBoundingBox(minMax, $9ef033443a74bee6$var$getCurrentTransform(this.ctx), this.current.minMax);
        this[op](opIdx, path);
        this._pathStartIdx = opIdx;
    }
    closePath(opIdx) {
        this.ctx.closePath();
    }
    stroke(opIdx, path, consumePath = true) {
        const ctx = this.ctx;
        const strokeColor = this.current.strokeColor;
        ctx.globalAlpha = this.current.strokeAlpha;
        if (this.contentVisible) {
            if (typeof strokeColor === "object" && strokeColor?.getPattern) {
                const baseTransform = strokeColor.isModifyingCurrentTransform() ? ctx.getTransform() : null;
                ctx.save();
                ctx.strokeStyle = strokeColor.getPattern(ctx, this, $9ef033443a74bee6$var$getCurrentTransformInverse(ctx), $9ef033443a74bee6$var$PathType.STROKE, opIdx);
                if (baseTransform) {
                    const newPath = new Path2D();
                    newPath.addPath(path, ctx.getTransform().invertSelf().multiplySelf(baseTransform));
                    path = newPath;
                }
                this.rescaleAndStroke(path, false);
                ctx.restore();
            } else this.rescaleAndStroke(path, true);
        }
        this.dependencyTracker?.recordDependencies(opIdx, $9ef033443a74bee6$var$Dependencies.stroke);
        if (consumePath) this.consumePath(opIdx, path, this.current.getClippedPathBoundingBox($9ef033443a74bee6$var$PathType.STROKE, $9ef033443a74bee6$var$getCurrentTransform(this.ctx)));
        ctx.globalAlpha = this.current.fillAlpha;
    }
    closeStroke(opIdx, path) {
        this.stroke(opIdx, path);
    }
    fill(opIdx, path, consumePath = true) {
        const ctx = this.ctx;
        const fillColor = this.current.fillColor;
        const isPatternFill = this.current.patternFill;
        let needRestore = false;
        if (isPatternFill) {
            const baseTransform = fillColor.isModifyingCurrentTransform() ? ctx.getTransform() : null;
            this.dependencyTracker?.save(opIdx);
            ctx.save();
            ctx.fillStyle = fillColor.getPattern(ctx, this, $9ef033443a74bee6$var$getCurrentTransformInverse(ctx), $9ef033443a74bee6$var$PathType.FILL, opIdx);
            if (baseTransform) {
                const newPath = new Path2D();
                newPath.addPath(path, ctx.getTransform().invertSelf().multiplySelf(baseTransform));
                path = newPath;
            }
            needRestore = true;
        }
        const intersect = this.current.getClippedPathBoundingBox();
        if (this.contentVisible && intersect !== null) {
            if (this.pendingEOFill) {
                ctx.fill(path, "evenodd");
                this.pendingEOFill = false;
            } else ctx.fill(path);
        }
        this.dependencyTracker?.recordDependencies(opIdx, $9ef033443a74bee6$var$Dependencies.fill);
        if (needRestore) {
            ctx.restore();
            this.dependencyTracker?.restore(opIdx);
        }
        if (consumePath) this.consumePath(opIdx, path, intersect);
    }
    eoFill(opIdx, path) {
        this.pendingEOFill = true;
        this.fill(opIdx, path);
    }
    fillStroke(opIdx, path) {
        this.fill(opIdx, path, false);
        this.stroke(opIdx, path, false);
        this.consumePath(opIdx, path);
    }
    eoFillStroke(opIdx, path) {
        this.pendingEOFill = true;
        this.fillStroke(opIdx, path);
    }
    closeFillStroke(opIdx, path) {
        this.fillStroke(opIdx, path);
    }
    closeEOFillStroke(opIdx, path) {
        this.pendingEOFill = true;
        this.fillStroke(opIdx, path);
    }
    endPath(opIdx, path) {
        this.consumePath(opIdx, path);
    }
    rawFillPath(opIdx, path) {
        this.ctx.fill(path);
        this.dependencyTracker?.recordDependencies(opIdx, $9ef033443a74bee6$var$Dependencies.rawFillPath).recordOperation(opIdx);
    }
    clip(opIdx) {
        this.dependencyTracker?.recordFutureForcedDependency("clipMode", opIdx);
        this.pendingClip = $9ef033443a74bee6$var$NORMAL_CLIP;
    }
    eoClip(opIdx) {
        this.dependencyTracker?.recordFutureForcedDependency("clipMode", opIdx);
        this.pendingClip = $9ef033443a74bee6$var$EO_CLIP;
    }
    beginText(opIdx) {
        this.current.textMatrix = null;
        this.current.textMatrixScale = 1;
        this.current.x = this.current.lineX = 0;
        this.current.y = this.current.lineY = 0;
        this.dependencyTracker?.recordOpenMarker(opIdx).resetIncrementalData("sameLineText").resetIncrementalData("moveText", opIdx);
    }
    endText(opIdx) {
        const paths = this.pendingTextPaths;
        const ctx = this.ctx;
        if (this.dependencyTracker) {
            const { dependencyTracker: dependencyTracker } = this;
            if (paths !== undefined) dependencyTracker.recordFutureForcedDependency("textClip", dependencyTracker.getOpenMarker()).recordFutureForcedDependency("textClip", opIdx);
            dependencyTracker.recordCloseMarker(opIdx);
        }
        if (paths !== undefined) {
            const newPath = new Path2D();
            const invTransf = ctx.getTransform().invertSelf();
            for (const { transform: transform, x: x, y: y, fontSize: fontSize, path: path } of paths){
                if (!path) continue;
                newPath.addPath(path, new DOMMatrix(transform).preMultiplySelf(invTransf).translate(x, y).scale(fontSize, -fontSize));
            }
            ctx.clip(newPath);
        }
        delete this.pendingTextPaths;
    }
    setCharSpacing(opIdx, spacing) {
        this.dependencyTracker?.recordSimpleData("charSpacing", opIdx);
        this.current.charSpacing = spacing;
    }
    setWordSpacing(opIdx, spacing) {
        this.dependencyTracker?.recordSimpleData("wordSpacing", opIdx);
        this.current.wordSpacing = spacing;
    }
    setHScale(opIdx, scale) {
        this.dependencyTracker?.recordSimpleData("hScale", opIdx);
        this.current.textHScale = scale / 100;
    }
    setLeading(opIdx, leading) {
        this.dependencyTracker?.recordSimpleData("leading", opIdx);
        this.current.leading = -leading;
    }
    setFont(opIdx, fontRefName, size) {
        this.dependencyTracker?.recordSimpleData("font", opIdx).recordSimpleDataFromNamed("fontObj", fontRefName, opIdx);
        const fontObj = this.commonObjs.get(fontRefName);
        const current = this.current;
        if (!fontObj) throw new Error(`Can't find font for ${fontRefName}`);
        current.fontMatrix = fontObj.fontMatrix || $9ef033443a74bee6$var$FONT_IDENTITY_MATRIX;
        if (current.fontMatrix[0] === 0 || current.fontMatrix[3] === 0) $9ef033443a74bee6$var$warn("Invalid font matrix for font " + fontRefName);
        if (size < 0) {
            size = -size;
            current.fontDirection = -1;
        } else current.fontDirection = 1;
        this.current.font = fontObj;
        this.current.fontSize = size;
        if (fontObj.isType3Font) return;
        const name = fontObj.loadedName || "sans-serif";
        const typeface = fontObj.systemFontInfo?.css || `"${name}", ${fontObj.fallbackName}`;
        let bold = "normal";
        if (fontObj.black) bold = "900";
        else if (fontObj.bold) bold = "bold";
        const italic = fontObj.italic ? "italic" : "normal";
        let browserFontSize = size;
        if (size < $9ef033443a74bee6$var$MIN_FONT_SIZE) browserFontSize = $9ef033443a74bee6$var$MIN_FONT_SIZE;
        else if (size > $9ef033443a74bee6$var$MAX_FONT_SIZE) browserFontSize = $9ef033443a74bee6$var$MAX_FONT_SIZE;
        this.current.fontSizeScale = size / browserFontSize;
        this.ctx.font = `${italic} ${bold} ${browserFontSize}px ${typeface}`;
    }
    setTextRenderingMode(opIdx, mode) {
        this.dependencyTracker?.recordSimpleData("textRenderingMode", opIdx);
        this.current.textRenderingMode = mode;
    }
    setTextRise(opIdx, rise) {
        this.dependencyTracker?.recordSimpleData("textRise", opIdx);
        this.current.textRise = rise;
    }
    moveText(opIdx, x, y) {
        this.dependencyTracker?.resetIncrementalData("sameLineText").recordIncrementalData("moveText", opIdx);
        this.current.x = this.current.lineX += x;
        this.current.y = this.current.lineY += y;
    }
    setLeadingMoveText(opIdx, x, y) {
        this.setLeading(opIdx, -y);
        this.moveText(opIdx, x, y);
    }
    setTextMatrix(opIdx, matrix) {
        this.dependencyTracker?.recordSimpleData("textMatrix", opIdx);
        const { current: current } = this;
        current.textMatrix = matrix;
        current.textMatrixScale = Math.hypot(matrix[0], matrix[1]);
        current.x = current.lineX = 0;
        current.y = current.lineY = 0;
    }
    nextLine(opIdx) {
        this.moveText(opIdx, 0, this.current.leading);
        this.dependencyTracker?.recordIncrementalData("moveText", this.dependencyTracker.getSimpleIndex("leading") ?? opIdx);
    }
    #getScaledPath(path, currentTransform, transform) {
        const newPath = new Path2D();
        newPath.addPath(path, new DOMMatrix(transform).invertSelf().multiplySelf(currentTransform));
        return newPath;
    }
    paintChar(opIdx, character, x, y, patternFillTransform, patternStrokeTransform) {
        const ctx = this.ctx;
        const current = this.current;
        const font = current.font;
        const textRenderingMode = current.textRenderingMode;
        const fontSize = current.fontSize / current.fontSizeScale;
        const fillStrokeMode = textRenderingMode & $9ef033443a74bee6$var$TextRenderingMode.FILL_STROKE_MASK;
        const isAddToPathSet = !!(textRenderingMode & $9ef033443a74bee6$var$TextRenderingMode.ADD_TO_PATH_FLAG);
        const patternFill = current.patternFill && !font.missingFile;
        const patternStroke = current.patternStroke && !font.missingFile;
        let path;
        if ((font.disableFontFace || isAddToPathSet || patternFill || patternStroke) && !font.missingFile) path = font.getPathGenerator(this.commonObjs, character);
        if (path && (font.disableFontFace || patternFill || patternStroke)) {
            ctx.save();
            ctx.translate(x, y);
            ctx.scale(fontSize, -fontSize);
            this.dependencyTracker?.recordCharacterBBox(opIdx, ctx, font);
            let currentTransform;
            if (fillStrokeMode === $9ef033443a74bee6$var$TextRenderingMode.FILL || fillStrokeMode === $9ef033443a74bee6$var$TextRenderingMode.FILL_STROKE) {
                if (patternFillTransform) {
                    currentTransform = ctx.getTransform();
                    ctx.setTransform(...patternFillTransform);
                    const scaledPath = this.#getScaledPath(path, currentTransform, patternFillTransform);
                    ctx.fill(scaledPath);
                } else ctx.fill(path);
            }
            if (fillStrokeMode === $9ef033443a74bee6$var$TextRenderingMode.STROKE || fillStrokeMode === $9ef033443a74bee6$var$TextRenderingMode.FILL_STROKE) {
                if (patternStrokeTransform) {
                    currentTransform ||= ctx.getTransform();
                    ctx.setTransform(...patternStrokeTransform);
                    const { a: a, b: b, c: c, d: d } = currentTransform;
                    const invPatternTransform = $9ef033443a74bee6$export$f8f26dd395d7e1bd.inverseTransform(patternStrokeTransform);
                    const transf = $9ef033443a74bee6$export$f8f26dd395d7e1bd.transform([
                        a,
                        b,
                        c,
                        d,
                        0,
                        0
                    ], invPatternTransform);
                    $9ef033443a74bee6$export$f8f26dd395d7e1bd.singularValueDecompose2dScale(transf, $9ef033443a74bee6$var$XY);
                    ctx.lineWidth *= Math.max($9ef033443a74bee6$var$XY[0], $9ef033443a74bee6$var$XY[1]) / fontSize;
                    ctx.stroke(this.#getScaledPath(path, currentTransform, patternStrokeTransform));
                } else {
                    ctx.lineWidth /= fontSize;
                    ctx.stroke(path);
                }
            }
            ctx.restore();
        } else {
            if (fillStrokeMode === $9ef033443a74bee6$var$TextRenderingMode.FILL || fillStrokeMode === $9ef033443a74bee6$var$TextRenderingMode.FILL_STROKE) {
                ctx.fillText(character, x, y);
                this.dependencyTracker?.recordCharacterBBox(opIdx, ctx, font, fontSize, x, y, ()=>ctx.measureText(character));
            }
            if (fillStrokeMode === $9ef033443a74bee6$var$TextRenderingMode.STROKE || fillStrokeMode === $9ef033443a74bee6$var$TextRenderingMode.FILL_STROKE) {
                if (this.dependencyTracker) this.dependencyTracker?.recordCharacterBBox(opIdx, ctx, font, fontSize, x, y, ()=>ctx.measureText(character)).recordDependencies(opIdx, $9ef033443a74bee6$var$Dependencies.stroke);
                ctx.strokeText(character, x, y);
            }
        }
        if (isAddToPathSet) {
            const paths = this.pendingTextPaths ||= [];
            paths.push({
                transform: $9ef033443a74bee6$var$getCurrentTransform(ctx),
                x: x,
                y: y,
                fontSize: fontSize,
                path: path
            });
            this.dependencyTracker?.recordCharacterBBox(opIdx, ctx, font, fontSize, x, y);
        }
    }
    get isFontSubpixelAAEnabled() {
        const { context: ctx } = this.cachedCanvases.getCanvas("isFontSubpixelAAEnabled", 10, 10);
        ctx.scale(1.5, 1);
        ctx.fillText("I", 0, 10);
        const data = ctx.getImageData(0, 0, 10, 10).data;
        let enabled = false;
        for(let i = 3; i < data.length; i += 4)if (data[i] > 0 && data[i] < 255) {
            enabled = true;
            break;
        }
        return $9ef033443a74bee6$export$b8972b998723d602(this, "isFontSubpixelAAEnabled", enabled);
    }
    showText(opIdx, glyphs) {
        if (this.dependencyTracker) {
            this.dependencyTracker.recordDependencies(opIdx, $9ef033443a74bee6$var$Dependencies.showText).resetBBox(opIdx);
            if (this.current.textRenderingMode & $9ef033443a74bee6$var$TextRenderingMode.ADD_TO_PATH_FLAG) this.dependencyTracker.recordFutureForcedDependency("textClip", opIdx).inheritPendingDependenciesAsFutureForcedDependencies();
        }
        const current = this.current;
        const font = current.font;
        if (font.isType3Font) {
            this.showType3Text(opIdx, glyphs);
            this.dependencyTracker?.recordShowTextOperation(opIdx);
            return undefined;
        }
        const fontSize = current.fontSize;
        if (fontSize === 0) {
            this.dependencyTracker?.recordOperation(opIdx);
            return undefined;
        }
        const ctx = this.ctx;
        const fontSizeScale = current.fontSizeScale;
        const charSpacing = current.charSpacing;
        const wordSpacing = current.wordSpacing;
        const fontDirection = current.fontDirection;
        const textHScale = current.textHScale * fontDirection;
        const glyphsLength = glyphs.length;
        const vertical = font.vertical;
        const spacingDir = vertical ? 1 : -1;
        const defaultVMetrics = font.defaultVMetrics;
        const widthAdvanceScale = fontSize * current.fontMatrix[0];
        const simpleFillText = current.textRenderingMode === $9ef033443a74bee6$var$TextRenderingMode.FILL && !font.disableFontFace && !current.patternFill;
        ctx.save();
        if (current.textMatrix) ctx.transform(...current.textMatrix);
        ctx.translate(current.x, current.y + current.textRise);
        if (fontDirection > 0) ctx.scale(textHScale, -1);
        else ctx.scale(textHScale, 1);
        let patternFillTransform, patternStrokeTransform;
        if (current.patternFill) {
            ctx.save();
            const pattern = current.fillColor.getPattern(ctx, this, $9ef033443a74bee6$var$getCurrentTransformInverse(ctx), $9ef033443a74bee6$var$PathType.FILL, opIdx);
            patternFillTransform = $9ef033443a74bee6$var$getCurrentTransform(ctx);
            ctx.restore();
            ctx.fillStyle = pattern;
        }
        if (current.patternStroke) {
            ctx.save();
            const pattern = current.strokeColor.getPattern(ctx, this, $9ef033443a74bee6$var$getCurrentTransformInverse(ctx), $9ef033443a74bee6$var$PathType.STROKE, opIdx);
            patternStrokeTransform = $9ef033443a74bee6$var$getCurrentTransform(ctx);
            ctx.restore();
            ctx.strokeStyle = pattern;
        }
        let lineWidth = current.lineWidth;
        const scale = current.textMatrixScale;
        if (scale === 0 || lineWidth === 0) {
            const fillStrokeMode = current.textRenderingMode & $9ef033443a74bee6$var$TextRenderingMode.FILL_STROKE_MASK;
            if (fillStrokeMode === $9ef033443a74bee6$var$TextRenderingMode.STROKE || fillStrokeMode === $9ef033443a74bee6$var$TextRenderingMode.FILL_STROKE) lineWidth = this.getSinglePixelWidth();
        } else lineWidth /= scale;
        if (fontSizeScale !== 1.0) {
            ctx.scale(fontSizeScale, fontSizeScale);
            lineWidth /= fontSizeScale;
        }
        ctx.lineWidth = lineWidth;
        if (font.isInvalidPDFjsFont) {
            const chars = [];
            let width = 0;
            for (const glyph of glyphs){
                chars.push(glyph.unicode);
                width += glyph.width;
            }
            const joinedChars = chars.join("");
            ctx.fillText(joinedChars, 0, 0);
            if (this.dependencyTracker !== null) {
                const measure = ctx.measureText(joinedChars);
                this.dependencyTracker.recordBBox(opIdx, this.ctx, -measure.actualBoundingBoxLeft, measure.actualBoundingBoxRight, -measure.actualBoundingBoxAscent, measure.actualBoundingBoxDescent).recordShowTextOperation(opIdx);
            }
            current.x += width * widthAdvanceScale * textHScale;
            ctx.restore();
            this.compose();
            return undefined;
        }
        let x = 0, i;
        for(i = 0; i < glyphsLength; ++i){
            const glyph = glyphs[i];
            if (typeof glyph === "number") {
                x += spacingDir * glyph * fontSize / 1000;
                continue;
            }
            let restoreNeeded = false;
            const spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
            const character = glyph.fontChar;
            const accent = glyph.accent;
            let scaledX, scaledY;
            let width = glyph.width;
            if (vertical) {
                const vmetric = glyph.vmetric || defaultVMetrics;
                const vx = -(glyph.vmetric ? vmetric[1] : width * 0.5) * widthAdvanceScale;
                const vy = vmetric[2] * widthAdvanceScale;
                width = vmetric ? -vmetric[0] : width;
                scaledX = vx / fontSizeScale;
                scaledY = (x + vy) / fontSizeScale;
            } else {
                scaledX = x / fontSizeScale;
                scaledY = 0;
            }
            let measure;
            if (font.remeasure && width > 0) {
                measure = ctx.measureText(character);
                const measuredWidth = measure.width * 1000 / fontSize * fontSizeScale;
                if (width < measuredWidth && this.isFontSubpixelAAEnabled) {
                    const characterScaleX = width / measuredWidth;
                    restoreNeeded = true;
                    ctx.save();
                    ctx.scale(characterScaleX, 1);
                    scaledX /= characterScaleX;
                } else if (width !== measuredWidth) scaledX += (width - measuredWidth) / 2000 * fontSize / fontSizeScale;
            }
            if (this.contentVisible && (glyph.isInFont || font.missingFile)) {
                if (simpleFillText && !accent) {
                    ctx.fillText(character, scaledX, scaledY);
                    this.dependencyTracker?.recordCharacterBBox(opIdx, ctx, measure ? {
                        bbox: null
                    } : font, fontSize / fontSizeScale, scaledX, scaledY, ()=>measure ?? ctx.measureText(character));
                } else {
                    this.paintChar(opIdx, character, scaledX, scaledY, patternFillTransform, patternStrokeTransform);
                    if (accent) {
                        const scaledAccentX = scaledX + fontSize * accent.offset.x / fontSizeScale;
                        const scaledAccentY = scaledY - fontSize * accent.offset.y / fontSizeScale;
                        this.paintChar(opIdx, accent.fontChar, scaledAccentX, scaledAccentY, patternFillTransform, patternStrokeTransform);
                    }
                }
            }
            const charWidth = vertical ? width * widthAdvanceScale - spacing * fontDirection : width * widthAdvanceScale + spacing * fontDirection;
            x += charWidth;
            if (restoreNeeded) ctx.restore();
        }
        if (vertical) current.y -= x;
        else current.x += x * textHScale;
        ctx.restore();
        this.compose();
        this.dependencyTracker?.recordShowTextOperation(opIdx);
        return undefined;
    }
    showType3Text(opIdx, glyphs) {
        const ctx = this.ctx;
        const current = this.current;
        const font = current.font;
        const fontSize = current.fontSize;
        const fontDirection = current.fontDirection;
        const spacingDir = font.vertical ? 1 : -1;
        const charSpacing = current.charSpacing;
        const wordSpacing = current.wordSpacing;
        const textHScale = current.textHScale * fontDirection;
        const fontMatrix = current.fontMatrix || $9ef033443a74bee6$var$FONT_IDENTITY_MATRIX;
        const glyphsLength = glyphs.length;
        const isTextInvisible = current.textRenderingMode === $9ef033443a74bee6$var$TextRenderingMode.INVISIBLE;
        let i, glyph, width, spacingLength;
        if (isTextInvisible || fontSize === 0) return;
        this._cachedScaleForStroking[0] = -1;
        this._cachedGetSinglePixelWidth = null;
        ctx.save();
        if (current.textMatrix) ctx.transform(...current.textMatrix);
        ctx.translate(current.x, current.y + current.textRise);
        ctx.scale(textHScale, fontDirection);
        const dependencyTracker = this.dependencyTracker;
        this.dependencyTracker = dependencyTracker ? new $9ef033443a74bee6$var$CanvasNestedDependencyTracker(dependencyTracker, opIdx) : null;
        for(i = 0; i < glyphsLength; ++i){
            glyph = glyphs[i];
            if (typeof glyph === "number") {
                spacingLength = spacingDir * glyph * fontSize / 1000;
                this.ctx.translate(spacingLength, 0);
                current.x += spacingLength * textHScale;
                continue;
            }
            const spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
            const operatorList = font.charProcOperatorList[glyph.operatorListId];
            if (!operatorList) $9ef033443a74bee6$var$warn(`Type3 character "${glyph.operatorListId}" is not available.`);
            else if (this.contentVisible) {
                this.save();
                ctx.scale(fontSize, fontSize);
                ctx.transform(...fontMatrix);
                this.executeOperatorList(operatorList);
                this.restore();
            }
            const p = [
                glyph.width,
                0
            ];
            $9ef033443a74bee6$export$f8f26dd395d7e1bd.applyTransform(p, fontMatrix);
            width = p[0] * fontSize + spacing;
            ctx.translate(width, 0);
            current.x += width * textHScale;
        }
        ctx.restore();
        if (dependencyTracker) this.dependencyTracker = dependencyTracker;
    }
    setCharWidth(opIdx, xWidth, yWidth) {}
    setCharWidthAndBounds(opIdx, xWidth, yWidth, llx, lly, urx, ury) {
        const clip = new Path2D();
        clip.rect(llx, lly, urx - llx, ury - lly);
        this.ctx.clip(clip);
        this.dependencyTracker?.recordBBox(opIdx, this.ctx, llx, urx, lly, ury).recordClipBox(opIdx, this.ctx, llx, urx, lly, ury);
        this.endPath(opIdx);
    }
    getColorN_Pattern(opIdx, IR) {
        let pattern;
        if (IR[0] === "TilingPattern") {
            const baseTransform = this.baseTransform || $9ef033443a74bee6$var$getCurrentTransform(this.ctx);
            const canvasGraphicsFactory = {
                createCanvasGraphics: (ctx, renderingOpIdx)=>new $9ef033443a74bee6$var$CanvasGraphics(ctx, this.commonObjs, this.objs, this.canvasFactory, this.filterFactory, {
                        optionalContentConfig: this.optionalContentConfig,
                        markedContentStack: this.markedContentStack
                    }, undefined, undefined, this.dependencyTracker ? new $9ef033443a74bee6$var$CanvasNestedDependencyTracker(this.dependencyTracker, renderingOpIdx, true) : null)
            };
            pattern = new $9ef033443a74bee6$var$TilingPattern(IR, this.ctx, canvasGraphicsFactory, baseTransform);
        } else pattern = this._getPattern(opIdx, IR[1], IR[2]);
        return pattern;
    }
    setStrokeColorN(opIdx, ...args) {
        this.dependencyTracker?.recordSimpleData("strokeColor", opIdx);
        this.current.strokeColor = this.getColorN_Pattern(opIdx, args);
        this.current.patternStroke = true;
    }
    setFillColorN(opIdx, ...args) {
        this.dependencyTracker?.recordSimpleData("fillColor", opIdx);
        this.current.fillColor = this.getColorN_Pattern(opIdx, args);
        this.current.patternFill = true;
    }
    setStrokeRGBColor(opIdx, color) {
        this.dependencyTracker?.recordSimpleData("strokeColor", opIdx);
        this.ctx.strokeStyle = this.current.strokeColor = color;
        this.current.patternStroke = false;
    }
    setStrokeTransparent(opIdx) {
        this.dependencyTracker?.recordSimpleData("strokeColor", opIdx);
        this.ctx.strokeStyle = this.current.strokeColor = "transparent";
        this.current.patternStroke = false;
    }
    setFillRGBColor(opIdx, color) {
        this.dependencyTracker?.recordSimpleData("fillColor", opIdx);
        this.ctx.fillStyle = this.current.fillColor = color;
        this.current.patternFill = false;
    }
    setFillTransparent(opIdx) {
        this.dependencyTracker?.recordSimpleData("fillColor", opIdx);
        this.ctx.fillStyle = this.current.fillColor = "transparent";
        this.current.patternFill = false;
    }
    _getPattern(opIdx, objId, matrix = null) {
        let pattern;
        if (this.cachedPatterns.has(objId)) pattern = this.cachedPatterns.get(objId);
        else {
            pattern = $9ef033443a74bee6$var$getShadingPattern(this.getObject(opIdx, objId));
            this.cachedPatterns.set(objId, pattern);
        }
        if (matrix) pattern.matrix = matrix;
        return pattern;
    }
    shadingFill(opIdx, objId) {
        if (!this.contentVisible) return;
        const ctx = this.ctx;
        this.save(opIdx);
        const pattern = this._getPattern(opIdx, objId);
        ctx.fillStyle = pattern.getPattern(ctx, this, $9ef033443a74bee6$var$getCurrentTransformInverse(ctx), $9ef033443a74bee6$var$PathType.SHADING, opIdx);
        const inv = $9ef033443a74bee6$var$getCurrentTransformInverse(ctx);
        if (inv) {
            const { width: width, height: height } = ctx.canvas;
            const minMax = $9ef033443a74bee6$var$MIN_MAX_INIT.slice();
            $9ef033443a74bee6$export$f8f26dd395d7e1bd.axialAlignedBoundingBox([
                0,
                0,
                width,
                height
            ], inv, minMax);
            const [x0, y0, x1, y1] = minMax;
            this.ctx.fillRect(x0, y0, x1 - x0, y1 - y0);
        } else this.ctx.fillRect(-10000000000, -10000000000, 2e10, 2e10);
        this.dependencyTracker?.resetBBox(opIdx).recordFullPageBBox(opIdx).recordDependencies(opIdx, $9ef033443a74bee6$var$Dependencies.transform).recordDependencies(opIdx, $9ef033443a74bee6$var$Dependencies.fill).recordOperation(opIdx);
        this.compose(this.current.getClippedPathBoundingBox());
        this.restore(opIdx);
    }
    beginInlineImage() {
        $9ef033443a74bee6$var$unreachable("Should not call beginInlineImage");
    }
    beginImageData() {
        $9ef033443a74bee6$var$unreachable("Should not call beginImageData");
    }
    paintFormXObjectBegin(opIdx, matrix, bbox) {
        if (!this.contentVisible) return;
        this.save(opIdx);
        this.baseTransformStack.push(this.baseTransform);
        if (matrix) this.transform(opIdx, ...matrix);
        this.baseTransform = $9ef033443a74bee6$var$getCurrentTransform(this.ctx);
        if (bbox) {
            $9ef033443a74bee6$export$f8f26dd395d7e1bd.axialAlignedBoundingBox(bbox, this.baseTransform, this.current.minMax);
            const [x0, y0, x1, y1] = bbox;
            const clip = new Path2D();
            clip.rect(x0, y0, x1 - x0, y1 - y0);
            this.ctx.clip(clip);
            this.dependencyTracker?.recordClipBox(opIdx, this.ctx, x0, x1, y0, y1);
            this.endPath(opIdx);
        }
    }
    paintFormXObjectEnd(opIdx) {
        if (!this.contentVisible) return;
        this.restore(opIdx);
        this.baseTransform = this.baseTransformStack.pop();
    }
    beginGroup(opIdx, group) {
        if (!this.contentVisible) return;
        this.save(opIdx);
        if (this.inSMaskMode) {
            this.endSMaskMode();
            this.current.activeSMask = null;
        }
        const currentCtx = this.ctx;
        if (!group.isolated) $9ef033443a74bee6$var$info("TODO: Support non-isolated groups.");
        if (group.knockout) $9ef033443a74bee6$var$warn("Knockout groups not supported.");
        const currentTransform = $9ef033443a74bee6$var$getCurrentTransform(currentCtx);
        if (group.matrix) currentCtx.transform(...group.matrix);
        if (!group.bbox) throw new Error("Bounding box is required.");
        let bounds = $9ef033443a74bee6$var$MIN_MAX_INIT.slice();
        $9ef033443a74bee6$export$f8f26dd395d7e1bd.axialAlignedBoundingBox(group.bbox, $9ef033443a74bee6$var$getCurrentTransform(currentCtx), bounds);
        const canvasBounds = [
            0,
            0,
            currentCtx.canvas.width,
            currentCtx.canvas.height
        ];
        bounds = $9ef033443a74bee6$export$f8f26dd395d7e1bd.intersect(bounds, canvasBounds) || [
            0,
            0,
            0,
            0
        ];
        const offsetX = Math.floor(bounds[0]);
        const offsetY = Math.floor(bounds[1]);
        const drawnWidth = Math.max(Math.ceil(bounds[2]) - offsetX, 1);
        const drawnHeight = Math.max(Math.ceil(bounds[3]) - offsetY, 1);
        this.current.startNewPathAndClipBox([
            0,
            0,
            drawnWidth,
            drawnHeight
        ]);
        let cacheId = "groupAt" + this.groupLevel;
        if (group.smask) cacheId += "_smask_" + this.smaskCounter++ % 2;
        const scratchCanvas = this.cachedCanvases.getCanvas(cacheId, drawnWidth, drawnHeight);
        const groupCtx = scratchCanvas.context;
        groupCtx.translate(-offsetX, -offsetY);
        groupCtx.transform(...currentTransform);
        let clip = new Path2D();
        const [x0, y0, x1, y1] = group.bbox;
        clip.rect(x0, y0, x1 - x0, y1 - y0);
        if (group.matrix) {
            const path = new Path2D();
            path.addPath(clip, new DOMMatrix(group.matrix));
            clip = path;
        }
        groupCtx.clip(clip);
        if (group.smask) this.smaskStack.push({
            canvas: scratchCanvas.canvas,
            context: groupCtx,
            offsetX: offsetX,
            offsetY: offsetY,
            subtype: group.smask.subtype,
            backdrop: group.smask.backdrop,
            transferMap: group.smask.transferMap || null,
            startTransformInverse: null
        });
        if (!group.smask || this.dependencyTracker) {
            currentCtx.setTransform(1, 0, 0, 1, 0, 0);
            currentCtx.translate(offsetX, offsetY);
            currentCtx.save();
        }
        $9ef033443a74bee6$var$copyCtxState(currentCtx, groupCtx);
        this.ctx = groupCtx;
        this.dependencyTracker?.inheritSimpleDataAsFutureForcedDependencies([
            "fillAlpha",
            "strokeAlpha",
            "globalCompositeOperation"
        ]).pushBaseTransform(currentCtx);
        this.setGState(opIdx, [
            [
                "BM",
                "source-over"
            ],
            [
                "ca",
                1
            ],
            [
                "CA",
                1
            ]
        ]);
        this.groupStack.push(currentCtx);
        this.groupLevel++;
    }
    endGroup(opIdx, group) {
        if (!this.contentVisible) return;
        this.groupLevel--;
        const groupCtx = this.ctx;
        const ctx = this.groupStack.pop();
        this.ctx = ctx;
        this.ctx.imageSmoothingEnabled = false;
        this.dependencyTracker?.popBaseTransform();
        if (group.smask) {
            this.tempSMask = this.smaskStack.pop();
            this.restore(opIdx);
            if (this.dependencyTracker) this.ctx.restore();
        } else {
            this.ctx.restore();
            const currentMtx = $9ef033443a74bee6$var$getCurrentTransform(this.ctx);
            this.restore(opIdx);
            this.ctx.save();
            this.ctx.setTransform(...currentMtx);
            const dirtyBox = $9ef033443a74bee6$var$MIN_MAX_INIT.slice();
            $9ef033443a74bee6$export$f8f26dd395d7e1bd.axialAlignedBoundingBox([
                0,
                0,
                groupCtx.canvas.width,
                groupCtx.canvas.height
            ], currentMtx, dirtyBox);
            this.ctx.drawImage(groupCtx.canvas, 0, 0);
            this.ctx.restore();
            this.compose(dirtyBox);
        }
    }
    beginAnnotation(opIdx, id, rect, transform, matrix, hasOwnCanvas) {
        this.#restoreInitialState();
        $9ef033443a74bee6$var$resetCtxToDefault(this.ctx);
        this.ctx.save();
        this.save(opIdx);
        if (this.baseTransform) this.ctx.setTransform(...this.baseTransform);
        if (rect) {
            const width = rect[2] - rect[0];
            const height = rect[3] - rect[1];
            if (hasOwnCanvas && this.annotationCanvasMap) {
                transform = transform.slice();
                transform[4] -= rect[0];
                transform[5] -= rect[1];
                rect = rect.slice();
                rect[0] = rect[1] = 0;
                rect[2] = width;
                rect[3] = height;
                $9ef033443a74bee6$export$f8f26dd395d7e1bd.singularValueDecompose2dScale($9ef033443a74bee6$var$getCurrentTransform(this.ctx), $9ef033443a74bee6$var$XY);
                const { viewportScale: viewportScale } = this;
                const canvasWidth = Math.ceil(width * this.outputScaleX * viewportScale);
                const canvasHeight = Math.ceil(height * this.outputScaleY * viewportScale);
                this.annotationCanvas = this.canvasFactory.create(canvasWidth, canvasHeight);
                const { canvas: canvas, context: context } = this.annotationCanvas;
                this.annotationCanvasMap.set(id, canvas);
                this.annotationCanvas.savedCtx = this.ctx;
                this.ctx = context;
                this.ctx.save();
                this.ctx.setTransform($9ef033443a74bee6$var$XY[0], 0, 0, -$9ef033443a74bee6$var$XY[1], 0, height * $9ef033443a74bee6$var$XY[1]);
                $9ef033443a74bee6$var$resetCtxToDefault(this.ctx);
            } else {
                $9ef033443a74bee6$var$resetCtxToDefault(this.ctx);
                this.endPath(opIdx);
                const clip = new Path2D();
                clip.rect(rect[0], rect[1], width, height);
                this.ctx.clip(clip);
            }
        }
        this.current = new $9ef033443a74bee6$var$CanvasExtraState(this.ctx.canvas.width, this.ctx.canvas.height);
        this.transform(opIdx, ...transform);
        this.transform(opIdx, ...matrix);
    }
    endAnnotation(opIdx) {
        if (this.annotationCanvas) {
            this.ctx.restore();
            this.#drawFilter();
            this.ctx = this.annotationCanvas.savedCtx;
            delete this.annotationCanvas.savedCtx;
            delete this.annotationCanvas;
        }
    }
    paintImageMaskXObject(opIdx, img) {
        if (!this.contentVisible) return;
        const count = img.count;
        img = this.getObject(opIdx, img.data, img);
        img.count = count;
        const ctx = this.ctx;
        const mask = this._createMaskCanvas(opIdx, img);
        const maskCanvas = mask.canvas;
        ctx.save();
        ctx.setTransform(1, 0, 0, 1, 0, 0);
        ctx.drawImage(maskCanvas, mask.offsetX, mask.offsetY);
        this.dependencyTracker?.resetBBox(opIdx).recordBBox(opIdx, this.ctx, mask.offsetX, mask.offsetX + maskCanvas.width, mask.offsetY, mask.offsetY + maskCanvas.height).recordOperation(opIdx);
        ctx.restore();
        this.compose();
    }
    paintImageMaskXObjectRepeat(opIdx, img, scaleX, skewX = 0, skewY = 0, scaleY, positions) {
        if (!this.contentVisible) return;
        img = this.getObject(opIdx, img.data, img);
        const ctx = this.ctx;
        ctx.save();
        const currentTransform = $9ef033443a74bee6$var$getCurrentTransform(ctx);
        ctx.transform(scaleX, skewX, skewY, scaleY, 0, 0);
        const mask = this._createMaskCanvas(opIdx, img);
        ctx.setTransform(1, 0, 0, 1, mask.offsetX - currentTransform[4], mask.offsetY - currentTransform[5]);
        this.dependencyTracker?.resetBBox(opIdx);
        for(let i = 0, ii = positions.length; i < ii; i += 2){
            const trans = $9ef033443a74bee6$export$f8f26dd395d7e1bd.transform(currentTransform, [
                scaleX,
                skewX,
                skewY,
                scaleY,
                positions[i],
                positions[i + 1]
            ]);
            ctx.drawImage(mask.canvas, trans[4], trans[5]);
            this.dependencyTracker?.recordBBox(opIdx, this.ctx, trans[4], trans[4] + mask.canvas.width, trans[5], trans[5] + mask.canvas.height);
        }
        ctx.restore();
        this.compose();
        this.dependencyTracker?.recordOperation(opIdx);
    }
    paintImageMaskXObjectGroup(opIdx, images) {
        if (!this.contentVisible) return;
        const ctx = this.ctx;
        const fillColor = this.current.fillColor;
        const isPatternFill = this.current.patternFill;
        this.dependencyTracker?.resetBBox(opIdx).recordDependencies(opIdx, $9ef033443a74bee6$var$Dependencies.transformAndFill);
        for (const image of images){
            const { data: data, width: width, height: height, transform: transform } = image;
            const maskCanvas = this.cachedCanvases.getCanvas("maskCanvas", width, height);
            const maskCtx = maskCanvas.context;
            maskCtx.save();
            const img = this.getObject(opIdx, data, image);
            $9ef033443a74bee6$var$putBinaryImageMask(maskCtx, img);
            maskCtx.globalCompositeOperation = "source-in";
            maskCtx.fillStyle = isPatternFill ? fillColor.getPattern(maskCtx, this, $9ef033443a74bee6$var$getCurrentTransformInverse(ctx), $9ef033443a74bee6$var$PathType.FILL, opIdx) : fillColor;
            maskCtx.fillRect(0, 0, width, height);
            maskCtx.restore();
            ctx.save();
            ctx.transform(...transform);
            ctx.scale(1, -1);
            $9ef033443a74bee6$var$drawImageAtIntegerCoords(ctx, maskCanvas.canvas, 0, 0, width, height, 0, -1, 1, 1);
            this.dependencyTracker?.recordBBox(opIdx, ctx, 0, width, 0, height);
            ctx.restore();
        }
        this.compose();
        this.dependencyTracker?.recordOperation(opIdx);
    }
    paintImageXObject(opIdx, objId) {
        if (!this.contentVisible) return;
        const imgData = this.getObject(opIdx, objId);
        if (!imgData) {
            $9ef033443a74bee6$var$warn("Dependent image isn't ready yet");
            return;
        }
        this.paintInlineImageXObject(opIdx, imgData);
    }
    paintImageXObjectRepeat(opIdx, objId, scaleX, scaleY, positions) {
        if (!this.contentVisible) return;
        const imgData = this.getObject(opIdx, objId);
        if (!imgData) {
            $9ef033443a74bee6$var$warn("Dependent image isn't ready yet");
            return;
        }
        const width = imgData.width;
        const height = imgData.height;
        const map = [];
        for(let i = 0, ii = positions.length; i < ii; i += 2)map.push({
            transform: [
                scaleX,
                0,
                0,
                scaleY,
                positions[i],
                positions[i + 1]
            ],
            x: 0,
            y: 0,
            w: width,
            h: height
        });
        this.paintInlineImageXObjectGroup(opIdx, imgData, map);
    }
    applyTransferMapsToCanvas(ctx) {
        if (this.current.transferMaps !== "none") {
            ctx.filter = this.current.transferMaps;
            ctx.drawImage(ctx.canvas, 0, 0);
            ctx.filter = "none";
        }
        return ctx.canvas;
    }
    applyTransferMapsToBitmap(imgData) {
        if (this.current.transferMaps === "none") return imgData.bitmap;
        const { bitmap: bitmap, width: width, height: height } = imgData;
        const tmpCanvas = this.cachedCanvases.getCanvas("inlineImage", width, height);
        const tmpCtx = tmpCanvas.context;
        tmpCtx.filter = this.current.transferMaps;
        tmpCtx.drawImage(bitmap, 0, 0);
        tmpCtx.filter = "none";
        return tmpCanvas.canvas;
    }
    paintInlineImageXObject(opIdx, imgData) {
        if (!this.contentVisible) return;
        const width = imgData.width;
        const height = imgData.height;
        const ctx = this.ctx;
        this.save(opIdx);
        const { filter: filter } = ctx;
        if (filter !== "none" && filter !== "") ctx.filter = "none";
        ctx.scale(1 / width, -1 / height);
        let imgToPaint;
        if (imgData.bitmap) imgToPaint = this.applyTransferMapsToBitmap(imgData);
        else if (typeof HTMLElement === "function" && imgData instanceof HTMLElement || !imgData.data) imgToPaint = imgData;
        else {
            const tmpCanvas = this.cachedCanvases.getCanvas("inlineImage", width, height);
            const tmpCtx = tmpCanvas.context;
            $9ef033443a74bee6$var$putBinaryImageData(tmpCtx, imgData);
            imgToPaint = this.applyTransferMapsToCanvas(tmpCtx);
        }
        const scaled = this._scaleImage(imgToPaint, $9ef033443a74bee6$var$getCurrentTransformInverse(ctx));
        ctx.imageSmoothingEnabled = $9ef033443a74bee6$var$getImageSmoothingEnabled($9ef033443a74bee6$var$getCurrentTransform(ctx), imgData.interpolate);
        this.dependencyTracker?.resetBBox(opIdx).recordBBox(opIdx, ctx, 0, width, -height, 0).recordDependencies(opIdx, $9ef033443a74bee6$var$Dependencies.imageXObject).recordOperation(opIdx);
        $9ef033443a74bee6$var$drawImageAtIntegerCoords(ctx, scaled.img, 0, 0, scaled.paintWidth, scaled.paintHeight, 0, -height, width, height);
        this.compose();
        this.restore(opIdx);
    }
    paintInlineImageXObjectGroup(opIdx, imgData, map) {
        if (!this.contentVisible) return;
        const ctx = this.ctx;
        let imgToPaint;
        if (imgData.bitmap) imgToPaint = imgData.bitmap;
        else {
            const w = imgData.width;
            const h = imgData.height;
            const tmpCanvas = this.cachedCanvases.getCanvas("inlineImage", w, h);
            const tmpCtx = tmpCanvas.context;
            $9ef033443a74bee6$var$putBinaryImageData(tmpCtx, imgData);
            imgToPaint = this.applyTransferMapsToCanvas(tmpCtx);
        }
        this.dependencyTracker?.resetBBox(opIdx);
        for (const entry of map){
            ctx.save();
            ctx.transform(...entry.transform);
            ctx.scale(1, -1);
            $9ef033443a74bee6$var$drawImageAtIntegerCoords(ctx, imgToPaint, entry.x, entry.y, entry.w, entry.h, 0, -1, 1, 1);
            this.dependencyTracker?.recordBBox(opIdx, ctx, 0, 1, -1, 0);
            ctx.restore();
        }
        this.dependencyTracker?.recordOperation(opIdx);
        this.compose();
    }
    paintSolidColorImageMask(opIdx) {
        if (!this.contentVisible) return;
        this.dependencyTracker?.resetBBox(opIdx).recordBBox(opIdx, this.ctx, 0, 1, 0, 1).recordDependencies(opIdx, $9ef033443a74bee6$var$Dependencies.fill).recordOperation(opIdx);
        this.ctx.fillRect(0, 0, 1, 1);
        this.compose();
    }
    markPoint(opIdx, tag) {}
    markPointProps(opIdx, tag, properties) {}
    beginMarkedContent(opIdx, tag) {
        this.dependencyTracker?.beginMarkedContent(opIdx);
        this.markedContentStack.push({
            visible: true
        });
    }
    beginMarkedContentProps(opIdx, tag, properties) {
        this.dependencyTracker?.beginMarkedContent(opIdx);
        if (tag === "OC") this.markedContentStack.push({
            visible: this.optionalContentConfig.isVisible(properties)
        });
        else this.markedContentStack.push({
            visible: true
        });
        this.contentVisible = this.isContentVisible();
    }
    endMarkedContent(opIdx) {
        this.dependencyTracker?.endMarkedContent(opIdx);
        this.markedContentStack.pop();
        this.contentVisible = this.isContentVisible();
    }
    beginCompat(opIdx) {}
    endCompat(opIdx) {}
    consumePath(opIdx, path, clipBox) {
        const isEmpty = this.current.isEmptyClip();
        if (this.pendingClip) this.current.updateClipFromPath();
        if (!this.pendingClip) this.compose(clipBox);
        const ctx = this.ctx;
        if (this.pendingClip) {
            if (!isEmpty) {
                if (this.pendingClip === $9ef033443a74bee6$var$EO_CLIP) ctx.clip(path, "evenodd");
                else ctx.clip(path);
            }
            this.pendingClip = null;
            this.dependencyTracker?.bboxToClipBoxDropOperation(opIdx).recordFutureForcedDependency("clipPath", opIdx);
        } else this.dependencyTracker?.recordOperation(opIdx);
        this.current.startNewPathAndClipBox(this.current.clipBox);
    }
    getSinglePixelWidth() {
        if (!this._cachedGetSinglePixelWidth) {
            const m = $9ef033443a74bee6$var$getCurrentTransform(this.ctx);
            if (m[1] === 0 && m[2] === 0) this._cachedGetSinglePixelWidth = 1 / Math.min(Math.abs(m[0]), Math.abs(m[3]));
            else {
                const absDet = Math.abs(m[0] * m[3] - m[2] * m[1]);
                const normX = Math.hypot(m[0], m[2]);
                const normY = Math.hypot(m[1], m[3]);
                this._cachedGetSinglePixelWidth = Math.max(normX, normY) / absDet;
            }
        }
        return this._cachedGetSinglePixelWidth;
    }
    getScaleForStroking() {
        if (this._cachedScaleForStroking[0] === -1) {
            const { lineWidth: lineWidth } = this.current;
            const { a: a, b: b, c: c, d: d } = this.ctx.getTransform();
            let scaleX, scaleY;
            if (b === 0 && c === 0) {
                const normX = Math.abs(a);
                const normY = Math.abs(d);
                if (normX === normY) {
                    if (lineWidth === 0) scaleX = scaleY = 1 / normX;
                    else {
                        const scaledLineWidth = normX * lineWidth;
                        scaleX = scaleY = scaledLineWidth < 1 ? 1 / scaledLineWidth : 1;
                    }
                } else if (lineWidth === 0) {
                    scaleX = 1 / normX;
                    scaleY = 1 / normY;
                } else {
                    const scaledXLineWidth = normX * lineWidth;
                    const scaledYLineWidth = normY * lineWidth;
                    scaleX = scaledXLineWidth < 1 ? 1 / scaledXLineWidth : 1;
                    scaleY = scaledYLineWidth < 1 ? 1 / scaledYLineWidth : 1;
                }
            } else {
                const absDet = Math.abs(a * d - b * c);
                const normX = Math.hypot(a, b);
                const normY = Math.hypot(c, d);
                if (lineWidth === 0) {
                    scaleX = normY / absDet;
                    scaleY = normX / absDet;
                } else {
                    const baseArea = lineWidth * absDet;
                    scaleX = normY > baseArea ? normY / baseArea : 1;
                    scaleY = normX > baseArea ? normX / baseArea : 1;
                }
            }
            this._cachedScaleForStroking[0] = scaleX;
            this._cachedScaleForStroking[1] = scaleY;
        }
        return this._cachedScaleForStroking;
    }
    rescaleAndStroke(path, saveRestore) {
        const { ctx: ctx, current: { lineWidth: lineWidth } } = this;
        const [scaleX, scaleY] = this.getScaleForStroking();
        if (scaleX === scaleY) {
            ctx.lineWidth = (lineWidth || 1) * scaleX;
            ctx.stroke(path);
            return;
        }
        const dashes = ctx.getLineDash();
        if (saveRestore) ctx.save();
        ctx.scale(scaleX, scaleY);
        $9ef033443a74bee6$var$SCALE_MATRIX.a = 1 / scaleX;
        $9ef033443a74bee6$var$SCALE_MATRIX.d = 1 / scaleY;
        const newPath = new Path2D();
        newPath.addPath(path, $9ef033443a74bee6$var$SCALE_MATRIX);
        if (dashes.length > 0) {
            const scale = Math.max(scaleX, scaleY);
            ctx.setLineDash(dashes.map((x)=>x / scale));
            ctx.lineDashOffset /= scale;
        }
        ctx.lineWidth = lineWidth || 1;
        ctx.stroke(newPath);
        if (saveRestore) ctx.restore();
    }
    isContentVisible() {
        for(let i = this.markedContentStack.length - 1; i >= 0; i--){
            if (!this.markedContentStack[i].visible) return false;
        }
        return true;
    }
}
for(const op in $9ef033443a74bee6$export$3a0f7f7a8a0b306b)if ($9ef033443a74bee6$var$CanvasGraphics.prototype[op] !== undefined) $9ef033443a74bee6$var$CanvasGraphics.prototype[$9ef033443a74bee6$export$3a0f7f7a8a0b306b[op]] = $9ef033443a74bee6$var$CanvasGraphics.prototype[op];
class $9ef033443a74bee6$var$CssFontInfo {
    #buffer;
    #view;
    #decoder;
    static strings = [
        "fontFamily",
        "fontWeight",
        "italicAngle"
    ];
    static write(info) {
        const encoder = new TextEncoder();
        const encodedStrings = {};
        let stringsLength = 0;
        for (const prop of $9ef033443a74bee6$var$CssFontInfo.strings){
            const encoded = encoder.encode(info[prop]);
            encodedStrings[prop] = encoded;
            stringsLength += 4 + encoded.length;
        }
        const buffer = new ArrayBuffer(stringsLength);
        const data = new Uint8Array(buffer);
        const view = new DataView(buffer);
        let offset = 0;
        for (const prop of $9ef033443a74bee6$var$CssFontInfo.strings){
            const encoded = encodedStrings[prop];
            const length = encoded.length;
            view.setUint32(offset, length);
            data.set(encoded, offset + 4);
            offset += 4 + length;
        }
        $9ef033443a74bee6$var$assert(offset === buffer.byteLength, "CssFontInfo.write: Buffer overflow");
        return buffer;
    }
    constructor(buffer){
        this.#buffer = buffer;
        this.#view = new DataView(this.#buffer);
        this.#decoder = new TextDecoder();
    }
    #readString(index) {
        $9ef033443a74bee6$var$assert(index < $9ef033443a74bee6$var$CssFontInfo.strings.length, "Invalid string index");
        let offset = 0;
        for(let i = 0; i < index; i++)offset += this.#view.getUint32(offset) + 4;
        const length = this.#view.getUint32(offset);
        return this.#decoder.decode(new Uint8Array(this.#buffer, offset + 4, length));
    }
    get fontFamily() {
        return this.#readString(0);
    }
    get fontWeight() {
        return this.#readString(1);
    }
    get italicAngle() {
        return this.#readString(2);
    }
}
class $9ef033443a74bee6$var$SystemFontInfo {
    #buffer;
    #view;
    #decoder;
    static strings = [
        "css",
        "loadedName",
        "baseFontName",
        "src"
    ];
    static write(info) {
        const encoder = new TextEncoder();
        const encodedStrings = {};
        let stringsLength = 0;
        for (const prop of $9ef033443a74bee6$var$SystemFontInfo.strings){
            const encoded = encoder.encode(info[prop]);
            encodedStrings[prop] = encoded;
            stringsLength += 4 + encoded.length;
        }
        stringsLength += 4;
        let encodedStyleStyle, encodedStyleWeight, lengthEstimate = 1 + stringsLength;
        if (info.style) {
            encodedStyleStyle = encoder.encode(info.style.style);
            encodedStyleWeight = encoder.encode(info.style.weight);
            lengthEstimate += 4 + encodedStyleStyle.length + 4 + encodedStyleWeight.length;
        }
        const buffer = new ArrayBuffer(lengthEstimate);
        const data = new Uint8Array(buffer);
        const view = new DataView(buffer);
        let offset = 0;
        view.setUint8(offset++, info.guessFallback ? 1 : 0);
        view.setUint32(offset, 0);
        offset += 4;
        stringsLength = 0;
        for (const prop of $9ef033443a74bee6$var$SystemFontInfo.strings){
            const encoded = encodedStrings[prop];
            const length = encoded.length;
            stringsLength += 4 + length;
            view.setUint32(offset, length);
            data.set(encoded, offset + 4);
            offset += 4 + length;
        }
        view.setUint32(offset - stringsLength - 4, stringsLength);
        if (info.style) {
            view.setUint32(offset, encodedStyleStyle.length);
            data.set(encodedStyleStyle, offset + 4);
            offset += 4 + encodedStyleStyle.length;
            view.setUint32(offset, encodedStyleWeight.length);
            data.set(encodedStyleWeight, offset + 4);
            offset += 4 + encodedStyleWeight.length;
        }
        $9ef033443a74bee6$var$assert(offset <= buffer.byteLength, "SubstitionInfo.write: Buffer overflow");
        return buffer.transferToFixedLength(offset);
    }
    constructor(buffer){
        this.#buffer = buffer;
        this.#view = new DataView(this.#buffer);
        this.#decoder = new TextDecoder();
    }
    get guessFallback() {
        return this.#view.getUint8(0) !== 0;
    }
    #readString(index) {
        $9ef033443a74bee6$var$assert(index < $9ef033443a74bee6$var$SystemFontInfo.strings.length, "Invalid string index");
        let offset = 5;
        for(let i = 0; i < index; i++)offset += this.#view.getUint32(offset) + 4;
        const length = this.#view.getUint32(offset);
        return this.#decoder.decode(new Uint8Array(this.#buffer, offset + 4, length));
    }
    get css() {
        return this.#readString(0);
    }
    get loadedName() {
        return this.#readString(1);
    }
    get baseFontName() {
        return this.#readString(2);
    }
    get src() {
        return this.#readString(3);
    }
    get style() {
        let offset = 1;
        offset += 4 + this.#view.getUint32(offset);
        const styleLength = this.#view.getUint32(offset);
        const style = this.#decoder.decode(new Uint8Array(this.#buffer, offset + 4, styleLength));
        offset += 4 + styleLength;
        const weightLength = this.#view.getUint32(offset);
        const weight = this.#decoder.decode(new Uint8Array(this.#buffer, offset + 4, weightLength));
        return {
            style: style,
            weight: weight
        };
    }
}
class $9ef033443a74bee6$var$FontInfo {
    static bools = [
        "black",
        "bold",
        "disableFontFace",
        "fontExtraProperties",
        "isInvalidPDFjsFont",
        "isType3Font",
        "italic",
        "missingFile",
        "remeasure",
        "vertical"
    ];
    static numbers = [
        "ascent",
        "defaultWidth",
        "descent"
    ];
    static strings = [
        "fallbackName",
        "loadedName",
        "mimetype",
        "name"
    ];
    static #OFFSET_NUMBERS = Math.ceil(this.bools.length * 2 / 8);
    static #OFFSET_BBOX = this.#OFFSET_NUMBERS + this.numbers.length * 8;
    static #OFFSET_FONT_MATRIX = this.#OFFSET_BBOX + 1 + 8;
    static #OFFSET_DEFAULT_VMETRICS = this.#OFFSET_FONT_MATRIX + 1 + 48;
    static #OFFSET_STRINGS = this.#OFFSET_DEFAULT_VMETRICS + 1 + 6;
    #buffer;
    #decoder;
    #view;
    constructor({ data: data, extra: extra }){
        this.#buffer = data;
        this.#decoder = new TextDecoder();
        this.#view = new DataView(this.#buffer);
        if (extra) Object.assign(this, extra);
    }
    #readBoolean(index) {
        $9ef033443a74bee6$var$assert(index < $9ef033443a74bee6$var$FontInfo.bools.length, "Invalid boolean index");
        const byteOffset = Math.floor(index / 4);
        const bitOffset = index * 2 % 8;
        const value = this.#view.getUint8(byteOffset) >> bitOffset & 0x03;
        return value === 0x00 ? undefined : value === 0x02;
    }
    get black() {
        return this.#readBoolean(0);
    }
    get bold() {
        return this.#readBoolean(1);
    }
    get disableFontFace() {
        return this.#readBoolean(2);
    }
    get fontExtraProperties() {
        return this.#readBoolean(3);
    }
    get isInvalidPDFjsFont() {
        return this.#readBoolean(4);
    }
    get isType3Font() {
        return this.#readBoolean(5);
    }
    get italic() {
        return this.#readBoolean(6);
    }
    get missingFile() {
        return this.#readBoolean(7);
    }
    get remeasure() {
        return this.#readBoolean(8);
    }
    get vertical() {
        return this.#readBoolean(9);
    }
    #readNumber(index) {
        $9ef033443a74bee6$var$assert(index < $9ef033443a74bee6$var$FontInfo.numbers.length, "Invalid number index");
        return this.#view.getFloat64($9ef033443a74bee6$var$FontInfo.#OFFSET_NUMBERS + index * 8);
    }
    get ascent() {
        return this.#readNumber(0);
    }
    get defaultWidth() {
        return this.#readNumber(1);
    }
    get descent() {
        return this.#readNumber(2);
    }
    get bbox() {
        let offset = $9ef033443a74bee6$var$FontInfo.#OFFSET_BBOX;
        const numCoords = this.#view.getUint8(offset);
        if (numCoords === 0) return undefined;
        offset += 1;
        const bbox = [];
        for(let i = 0; i < 4; i++){
            bbox.push(this.#view.getInt16(offset, true));
            offset += 2;
        }
        return bbox;
    }
    get fontMatrix() {
        let offset = $9ef033443a74bee6$var$FontInfo.#OFFSET_FONT_MATRIX;
        const numPoints = this.#view.getUint8(offset);
        if (numPoints === 0) return undefined;
        offset += 1;
        const fontMatrix = [];
        for(let i = 0; i < 6; i++){
            fontMatrix.push(this.#view.getFloat64(offset, true));
            offset += 8;
        }
        return fontMatrix;
    }
    get defaultVMetrics() {
        let offset = $9ef033443a74bee6$var$FontInfo.#OFFSET_DEFAULT_VMETRICS;
        const numMetrics = this.#view.getUint8(offset);
        if (numMetrics === 0) return undefined;
        offset += 1;
        const defaultVMetrics = [];
        for(let i = 0; i < 3; i++){
            defaultVMetrics.push(this.#view.getInt16(offset, true));
            offset += 2;
        }
        return defaultVMetrics;
    }
    #readString(index) {
        $9ef033443a74bee6$var$assert(index < $9ef033443a74bee6$var$FontInfo.strings.length, "Invalid string index");
        let offset = $9ef033443a74bee6$var$FontInfo.#OFFSET_STRINGS + 4;
        for(let i = 0; i < index; i++)offset += this.#view.getUint32(offset) + 4;
        const length = this.#view.getUint32(offset);
        const stringData = new Uint8Array(length);
        stringData.set(new Uint8Array(this.#buffer, offset + 4, length));
        return this.#decoder.decode(stringData);
    }
    get fallbackName() {
        return this.#readString(0);
    }
    get loadedName() {
        return this.#readString(1);
    }
    get mimetype() {
        return this.#readString(2);
    }
    get name() {
        return this.#readString(3);
    }
    get data() {
        let offset = $9ef033443a74bee6$var$FontInfo.#OFFSET_STRINGS;
        const stringsLength = this.#view.getUint32(offset);
        offset += 4 + stringsLength;
        const systemFontInfoLength = this.#view.getUint32(offset);
        offset += 4 + systemFontInfoLength;
        const cssFontInfoLength = this.#view.getUint32(offset);
        offset += 4 + cssFontInfoLength;
        const length = this.#view.getUint32(offset);
        if (length === 0) return undefined;
        return new Uint8Array(this.#buffer, offset + 4, length);
    }
    clearData() {
        let offset = $9ef033443a74bee6$var$FontInfo.#OFFSET_STRINGS;
        const stringsLength = this.#view.getUint32(offset);
        offset += 4 + stringsLength;
        const systemFontInfoLength = this.#view.getUint32(offset);
        offset += 4 + systemFontInfoLength;
        const cssFontInfoLength = this.#view.getUint32(offset);
        offset += 4 + cssFontInfoLength;
        const length = this.#view.getUint32(offset);
        const data = new Uint8Array(this.#buffer, offset + 4, length);
        data.fill(0);
        this.#view.setUint32(offset, 0);
    }
    get cssFontInfo() {
        let offset = $9ef033443a74bee6$var$FontInfo.#OFFSET_STRINGS;
        const stringsLength = this.#view.getUint32(offset);
        offset += 4 + stringsLength;
        const systemFontInfoLength = this.#view.getUint32(offset);
        offset += 4 + systemFontInfoLength;
        const cssFontInfoLength = this.#view.getUint32(offset);
        if (cssFontInfoLength === 0) return null;
        const cssFontInfoData = new Uint8Array(cssFontInfoLength);
        cssFontInfoData.set(new Uint8Array(this.#buffer, offset + 4, cssFontInfoLength));
        return new $9ef033443a74bee6$var$CssFontInfo(cssFontInfoData.buffer);
    }
    get systemFontInfo() {
        let offset = $9ef033443a74bee6$var$FontInfo.#OFFSET_STRINGS;
        const stringsLength = this.#view.getUint32(offset);
        offset += 4 + stringsLength;
        const systemFontInfoLength = this.#view.getUint32(offset);
        if (systemFontInfoLength === 0) return null;
        const systemFontInfoData = new Uint8Array(systemFontInfoLength);
        systemFontInfoData.set(new Uint8Array(this.#buffer, offset + 4, systemFontInfoLength));
        return new $9ef033443a74bee6$var$SystemFontInfo(systemFontInfoData.buffer);
    }
    static write(font) {
        const systemFontInfoBuffer = font.systemFontInfo ? $9ef033443a74bee6$var$SystemFontInfo.write(font.systemFontInfo) : null;
        const cssFontInfoBuffer = font.cssFontInfo ? $9ef033443a74bee6$var$CssFontInfo.write(font.cssFontInfo) : null;
        const encoder = new TextEncoder();
        const encodedStrings = {};
        let stringsLength = 0;
        for (const prop of $9ef033443a74bee6$var$FontInfo.strings){
            encodedStrings[prop] = encoder.encode(font[prop]);
            stringsLength += 4 + encodedStrings[prop].length;
        }
        const lengthEstimate = $9ef033443a74bee6$var$FontInfo.#OFFSET_STRINGS + 4 + stringsLength + 4 + (systemFontInfoBuffer ? systemFontInfoBuffer.byteLength : 0) + 4 + (cssFontInfoBuffer ? cssFontInfoBuffer.byteLength : 0) + 4 + (font.data ? font.data.length : 0);
        const buffer = new ArrayBuffer(lengthEstimate);
        const data = new Uint8Array(buffer);
        const view = new DataView(buffer);
        let offset = 0;
        const numBools = $9ef033443a74bee6$var$FontInfo.bools.length;
        let boolByte = 0, boolBit = 0;
        for(let i = 0; i < numBools; i++){
            const value = font[$9ef033443a74bee6$var$FontInfo.bools[i]];
            const bits = value === undefined ? 0x00 : value ? 0x02 : 0x01;
            boolByte |= bits << boolBit;
            boolBit += 2;
            if (boolBit === 8 || i === numBools - 1) {
                view.setUint8(offset++, boolByte);
                boolByte = 0;
                boolBit = 0;
            }
        }
        $9ef033443a74bee6$var$assert(offset === $9ef033443a74bee6$var$FontInfo.#OFFSET_NUMBERS, "FontInfo.write: Boolean properties offset mismatch");
        for (const prop of $9ef033443a74bee6$var$FontInfo.numbers){
            view.setFloat64(offset, font[prop]);
            offset += 8;
        }
        $9ef033443a74bee6$var$assert(offset === $9ef033443a74bee6$var$FontInfo.#OFFSET_BBOX, "FontInfo.write: Number properties offset mismatch");
        if (font.bbox) {
            view.setUint8(offset++, 4);
            for (const coord of font.bbox){
                view.setInt16(offset, coord, true);
                offset += 2;
            }
        } else {
            view.setUint8(offset++, 0);
            offset += 8;
        }
        $9ef033443a74bee6$var$assert(offset === $9ef033443a74bee6$var$FontInfo.#OFFSET_FONT_MATRIX, "FontInfo.write: BBox properties offset mismatch");
        if (font.fontMatrix) {
            view.setUint8(offset++, 6);
            for (const point of font.fontMatrix){
                view.setFloat64(offset, point, true);
                offset += 8;
            }
        } else {
            view.setUint8(offset++, 0);
            offset += 48;
        }
        $9ef033443a74bee6$var$assert(offset === $9ef033443a74bee6$var$FontInfo.#OFFSET_DEFAULT_VMETRICS, "FontInfo.write: FontMatrix properties offset mismatch");
        if (font.defaultVMetrics) {
            view.setUint8(offset++, 1);
            for (const metric of font.defaultVMetrics){
                view.setInt16(offset, metric, true);
                offset += 2;
            }
        } else {
            view.setUint8(offset++, 0);
            offset += 6;
        }
        $9ef033443a74bee6$var$assert(offset === $9ef033443a74bee6$var$FontInfo.#OFFSET_STRINGS, "FontInfo.write: DefaultVMetrics properties offset mismatch");
        view.setUint32($9ef033443a74bee6$var$FontInfo.#OFFSET_STRINGS, 0);
        offset += 4;
        for (const prop of $9ef033443a74bee6$var$FontInfo.strings){
            const encoded = encodedStrings[prop];
            const length = encoded.length;
            view.setUint32(offset, length);
            data.set(encoded, offset + 4);
            offset += 4 + length;
        }
        view.setUint32($9ef033443a74bee6$var$FontInfo.#OFFSET_STRINGS, offset - $9ef033443a74bee6$var$FontInfo.#OFFSET_STRINGS - 4);
        if (!systemFontInfoBuffer) {
            view.setUint32(offset, 0);
            offset += 4;
        } else {
            const length = systemFontInfoBuffer.byteLength;
            view.setUint32(offset, length);
            $9ef033443a74bee6$var$assert(offset + 4 + length <= buffer.byteLength, "FontInfo.write: Buffer overflow at systemFontInfo");
            data.set(new Uint8Array(systemFontInfoBuffer), offset + 4);
            offset += 4 + length;
        }
        if (!cssFontInfoBuffer) {
            view.setUint32(offset, 0);
            offset += 4;
        } else {
            const length = cssFontInfoBuffer.byteLength;
            view.setUint32(offset, length);
            $9ef033443a74bee6$var$assert(offset + 4 + length <= buffer.byteLength, "FontInfo.write: Buffer overflow at cssFontInfo");
            data.set(new Uint8Array(cssFontInfoBuffer), offset + 4);
            offset += 4 + length;
        }
        if (font.data === undefined) {
            view.setUint32(offset, 0);
            offset += 4;
        } else {
            view.setUint32(offset, font.data.length);
            data.set(font.data, offset + 4);
            offset += 4 + font.data.length;
        }
        $9ef033443a74bee6$var$assert(offset <= buffer.byteLength, "FontInfo.write: Buffer overflow");
        return buffer.transferToFixedLength(offset);
    }
}
class $9ef033443a74bee6$export$edf38ba293eb934 {
    static #port = null;
    static #src = "";
    static get workerPort() {
        return this.#port;
    }
    static set workerPort(val) {
        if (!(typeof Worker !== "undefined" && val instanceof Worker) && val !== null) throw new Error("Invalid `workerPort` type.");
        this.#port = val;
    }
    static get workerSrc() {
        return this.#src;
    }
    static set workerSrc(val) {
        if (typeof val !== "string") throw new Error("Invalid `workerSrc` type.");
        this.#src = val;
    }
}
class $9ef033443a74bee6$var$Metadata {
    #map;
    #data;
    constructor({ parsedData: parsedData, rawData: rawData }){
        this.#map = parsedData;
        this.#data = rawData;
    }
    getRaw() {
        return this.#data;
    }
    get(name) {
        return this.#map.get(name) ?? null;
    }
    [Symbol.iterator]() {
        return this.#map.entries();
    }
}
const $9ef033443a74bee6$var$INTERNAL = Symbol("INTERNAL");
class $9ef033443a74bee6$var$OptionalContentGroup {
    #isDisplay = false;
    #isPrint = false;
    #userSet = false;
    #visible = true;
    constructor(renderingIntent, { name: name, intent: intent, usage: usage, rbGroups: rbGroups }){
        this.#isDisplay = !!(renderingIntent & $9ef033443a74bee6$var$RenderingIntentFlag.DISPLAY);
        this.#isPrint = !!(renderingIntent & $9ef033443a74bee6$var$RenderingIntentFlag.PRINT);
        this.name = name;
        this.intent = intent;
        this.usage = usage;
        this.rbGroups = rbGroups;
    }
    get visible() {
        if (this.#userSet) return this.#visible;
        if (!this.#visible) return false;
        const { print: print, view: view } = this.usage;
        if (this.#isDisplay) return view?.viewState !== "OFF";
        else if (this.#isPrint) return print?.printState !== "OFF";
        return true;
    }
    _setVisible(internal, visible, userSet = false) {
        if (internal !== $9ef033443a74bee6$var$INTERNAL) $9ef033443a74bee6$var$unreachable("Internal method `_setVisible` called.");
        this.#userSet = userSet;
        this.#visible = visible;
    }
}
class $9ef033443a74bee6$var$OptionalContentConfig {
    #cachedGetHash = null;
    #groups = new Map();
    #initialHash = null;
    #order = null;
    constructor(data, renderingIntent = $9ef033443a74bee6$var$RenderingIntentFlag.DISPLAY){
        this.renderingIntent = renderingIntent;
        this.name = null;
        this.creator = null;
        if (data === null) return;
        this.name = data.name;
        this.creator = data.creator;
        this.#order = data.order;
        for (const group of data.groups)this.#groups.set(group.id, new $9ef033443a74bee6$var$OptionalContentGroup(renderingIntent, group));
        if (data.baseState === "OFF") for (const group of this.#groups.values())group._setVisible($9ef033443a74bee6$var$INTERNAL, false);
        for (const on of data.on)this.#groups.get(on)._setVisible($9ef033443a74bee6$var$INTERNAL, true);
        for (const off of data.off)this.#groups.get(off)._setVisible($9ef033443a74bee6$var$INTERNAL, false);
        this.#initialHash = this.getHash();
    }
    #evaluateVisibilityExpression(array) {
        const length = array.length;
        if (length < 2) return true;
        const operator = array[0];
        for(let i = 1; i < length; i++){
            const element = array[i];
            let state;
            if (Array.isArray(element)) state = this.#evaluateVisibilityExpression(element);
            else if (this.#groups.has(element)) state = this.#groups.get(element).visible;
            else {
                $9ef033443a74bee6$var$warn(`Optional content group not found: ${element}`);
                return true;
            }
            switch(operator){
                case "And":
                    if (!state) return false;
                    break;
                case "Or":
                    if (state) return true;
                    break;
                case "Not":
                    return !state;
                default:
                    return true;
            }
        }
        return operator === "And";
    }
    isVisible(group) {
        if (this.#groups.size === 0) return true;
        if (!group) {
            $9ef033443a74bee6$var$info("Optional content group not defined.");
            return true;
        }
        if (group.type === "OCG") {
            if (!this.#groups.has(group.id)) {
                $9ef033443a74bee6$var$warn(`Optional content group not found: ${group.id}`);
                return true;
            }
            return this.#groups.get(group.id).visible;
        } else if (group.type === "OCMD") {
            if (group.expression) return this.#evaluateVisibilityExpression(group.expression);
            if (!group.policy || group.policy === "AnyOn") {
                for (const id of group.ids){
                    if (!this.#groups.has(id)) {
                        $9ef033443a74bee6$var$warn(`Optional content group not found: ${id}`);
                        return true;
                    }
                    if (this.#groups.get(id).visible) return true;
                }
                return false;
            } else if (group.policy === "AllOn") {
                for (const id of group.ids){
                    if (!this.#groups.has(id)) {
                        $9ef033443a74bee6$var$warn(`Optional content group not found: ${id}`);
                        return true;
                    }
                    if (!this.#groups.get(id).visible) return false;
                }
                return true;
            } else if (group.policy === "AnyOff") {
                for (const id of group.ids){
                    if (!this.#groups.has(id)) {
                        $9ef033443a74bee6$var$warn(`Optional content group not found: ${id}`);
                        return true;
                    }
                    if (!this.#groups.get(id).visible) return true;
                }
                return false;
            } else if (group.policy === "AllOff") {
                for (const id of group.ids){
                    if (!this.#groups.has(id)) {
                        $9ef033443a74bee6$var$warn(`Optional content group not found: ${id}`);
                        return true;
                    }
                    if (this.#groups.get(id).visible) return false;
                }
                return true;
            }
            $9ef033443a74bee6$var$warn(`Unknown optional content policy ${group.policy}.`);
            return true;
        }
        $9ef033443a74bee6$var$warn(`Unknown group type ${group.type}.`);
        return true;
    }
    setVisibility(id, visible = true, preserveRB = true) {
        const group = this.#groups.get(id);
        if (!group) {
            $9ef033443a74bee6$var$warn(`Optional content group not found: ${id}`);
            return;
        }
        if (preserveRB && visible && group.rbGroups.length) for (const rbGroup of group.rbGroups){
            for (const otherId of rbGroup)if (otherId !== id) this.#groups.get(otherId)?._setVisible($9ef033443a74bee6$var$INTERNAL, false, true);
        }
        group._setVisible($9ef033443a74bee6$var$INTERNAL, !!visible, true);
        this.#cachedGetHash = null;
    }
    setOCGState({ state: state, preserveRB: preserveRB }) {
        let operator;
        for (const elem of state){
            switch(elem){
                case "ON":
                case "OFF":
                case "Toggle":
                    operator = elem;
                    continue;
            }
            const group = this.#groups.get(elem);
            if (!group) continue;
            switch(operator){
                case "ON":
                    this.setVisibility(elem, true, preserveRB);
                    break;
                case "OFF":
                    this.setVisibility(elem, false, preserveRB);
                    break;
                case "Toggle":
                    this.setVisibility(elem, !group.visible, preserveRB);
                    break;
            }
        }
        this.#cachedGetHash = null;
    }
    get hasInitialVisibility() {
        return this.#initialHash === null || this.getHash() === this.#initialHash;
    }
    getOrder() {
        if (!this.#groups.size) return null;
        if (this.#order) return this.#order.slice();
        return [
            ...this.#groups.keys()
        ];
    }
    getGroup(id) {
        return this.#groups.get(id) || null;
    }
    getHash() {
        if (this.#cachedGetHash !== null) return this.#cachedGetHash;
        const hash = new $9ef033443a74bee6$var$MurmurHash3_64();
        for (const [id, group] of this.#groups)hash.update(`${id}:${group.visible}`);
        return this.#cachedGetHash = hash.hexdigest();
    }
    [Symbol.iterator]() {
        return this.#groups.entries();
    }
}
class $9ef033443a74bee6$var$PDFDataTransportStream {
    constructor(pdfDataRangeTransport, { disableRange: disableRange = false, disableStream: disableStream = false }){
        $9ef033443a74bee6$var$assert(pdfDataRangeTransport, 'PDFDataTransportStream - missing required "pdfDataRangeTransport" argument.');
        const { length: length, initialData: initialData, progressiveDone: progressiveDone, contentDispositionFilename: contentDispositionFilename } = pdfDataRangeTransport;
        this._queuedChunks = [];
        this._progressiveDone = progressiveDone;
        this._contentDispositionFilename = contentDispositionFilename;
        if (initialData?.length > 0) {
            const buffer = initialData instanceof Uint8Array && initialData.byteLength === initialData.buffer.byteLength ? initialData.buffer : new Uint8Array(initialData).buffer;
            this._queuedChunks.push(buffer);
        }
        this._pdfDataRangeTransport = pdfDataRangeTransport;
        this._isStreamingSupported = !disableStream;
        this._isRangeSupported = !disableRange;
        this._contentLength = length;
        this._fullRequestReader = null;
        this._rangeReaders = [];
        pdfDataRangeTransport.addRangeListener((begin, chunk)=>{
            this._onReceiveData({
                begin: begin,
                chunk: chunk
            });
        });
        pdfDataRangeTransport.addProgressListener((loaded, total)=>{
            this._onProgress({
                loaded: loaded,
                total: total
            });
        });
        pdfDataRangeTransport.addProgressiveReadListener((chunk)=>{
            this._onReceiveData({
                chunk: chunk
            });
        });
        pdfDataRangeTransport.addProgressiveDoneListener(()=>{
            this._onProgressiveDone();
        });
        pdfDataRangeTransport.transportReady();
    }
    _onReceiveData({ begin: begin, chunk: chunk }) {
        const buffer = chunk instanceof Uint8Array && chunk.byteLength === chunk.buffer.byteLength ? chunk.buffer : new Uint8Array(chunk).buffer;
        if (begin === undefined) {
            if (this._fullRequestReader) this._fullRequestReader._enqueue(buffer);
            else this._queuedChunks.push(buffer);
        } else {
            const found = this._rangeReaders.some(function(rangeReader) {
                if (rangeReader._begin !== begin) return false;
                rangeReader._enqueue(buffer);
                return true;
            });
            $9ef033443a74bee6$var$assert(found, "_onReceiveData - no `PDFDataTransportStreamRangeReader` instance found.");
        }
    }
    get _progressiveDataLength() {
        return this._fullRequestReader?._loaded ?? 0;
    }
    _onProgress(evt) {
        if (evt.total === undefined) this._rangeReaders[0]?.onProgress?.({
            loaded: evt.loaded
        });
        else this._fullRequestReader?.onProgress?.({
            loaded: evt.loaded,
            total: evt.total
        });
    }
    _onProgressiveDone() {
        this._fullRequestReader?.progressiveDone();
        this._progressiveDone = true;
    }
    _removeRangeReader(reader) {
        const i = this._rangeReaders.indexOf(reader);
        if (i >= 0) this._rangeReaders.splice(i, 1);
    }
    getFullReader() {
        $9ef033443a74bee6$var$assert(!this._fullRequestReader, "PDFDataTransportStream.getFullReader can only be called once.");
        const queuedChunks = this._queuedChunks;
        this._queuedChunks = null;
        return new $9ef033443a74bee6$var$PDFDataTransportStreamReader(this, queuedChunks, this._progressiveDone, this._contentDispositionFilename);
    }
    getRangeReader(begin, end) {
        if (end <= this._progressiveDataLength) return null;
        const reader = new $9ef033443a74bee6$var$PDFDataTransportStreamRangeReader(this, begin, end);
        this._pdfDataRangeTransport.requestDataRange(begin, end);
        this._rangeReaders.push(reader);
        return reader;
    }
    cancelAllRequests(reason) {
        this._fullRequestReader?.cancel(reason);
        for (const reader of this._rangeReaders.slice(0))reader.cancel(reason);
        this._pdfDataRangeTransport.abort();
    }
}
class $9ef033443a74bee6$var$PDFDataTransportStreamReader {
    constructor(stream, queuedChunks, progressiveDone = false, contentDispositionFilename = null){
        this._stream = stream;
        this._done = progressiveDone || false;
        this._filename = $9ef033443a74bee6$export$61b52d3570d24719(contentDispositionFilename) ? contentDispositionFilename : null;
        this._queuedChunks = queuedChunks || [];
        this._loaded = 0;
        for (const chunk of this._queuedChunks)this._loaded += chunk.byteLength;
        this._requests = [];
        this._headersReady = Promise.resolve();
        stream._fullRequestReader = this;
        this.onProgress = null;
    }
    _enqueue(chunk) {
        if (this._done) return;
        if (this._requests.length > 0) {
            const requestCapability = this._requests.shift();
            requestCapability.resolve({
                value: chunk,
                done: false
            });
        } else this._queuedChunks.push(chunk);
        this._loaded += chunk.byteLength;
    }
    get headersReady() {
        return this._headersReady;
    }
    get filename() {
        return this._filename;
    }
    get isRangeSupported() {
        return this._stream._isRangeSupported;
    }
    get isStreamingSupported() {
        return this._stream._isStreamingSupported;
    }
    get contentLength() {
        return this._stream._contentLength;
    }
    async read() {
        if (this._queuedChunks.length > 0) {
            const chunk = this._queuedChunks.shift();
            return {
                value: chunk,
                done: false
            };
        }
        if (this._done) return {
            value: undefined,
            done: true
        };
        const requestCapability = Promise.withResolvers();
        this._requests.push(requestCapability);
        return requestCapability.promise;
    }
    cancel(reason) {
        this._done = true;
        for (const requestCapability of this._requests)requestCapability.resolve({
            value: undefined,
            done: true
        });
        this._requests.length = 0;
    }
    progressiveDone() {
        if (this._done) return;
        this._done = true;
    }
}
class $9ef033443a74bee6$var$PDFDataTransportStreamRangeReader {
    constructor(stream, begin, end){
        this._stream = stream;
        this._begin = begin;
        this._end = end;
        this._queuedChunk = null;
        this._requests = [];
        this._done = false;
        this.onProgress = null;
    }
    _enqueue(chunk) {
        if (this._done) return;
        if (this._requests.length === 0) this._queuedChunk = chunk;
        else {
            const requestsCapability = this._requests.shift();
            requestsCapability.resolve({
                value: chunk,
                done: false
            });
            for (const requestCapability of this._requests)requestCapability.resolve({
                value: undefined,
                done: true
            });
            this._requests.length = 0;
        }
        this._done = true;
        this._stream._removeRangeReader(this);
    }
    get isStreamingSupported() {
        return false;
    }
    async read() {
        if (this._queuedChunk) {
            const chunk = this._queuedChunk;
            this._queuedChunk = null;
            return {
                value: chunk,
                done: false
            };
        }
        if (this._done) return {
            value: undefined,
            done: true
        };
        const requestCapability = Promise.withResolvers();
        this._requests.push(requestCapability);
        return requestCapability.promise;
    }
    cancel(reason) {
        this._done = true;
        for (const requestCapability of this._requests)requestCapability.resolve({
            value: undefined,
            done: true
        });
        this._requests.length = 0;
        this._stream._removeRangeReader(this);
    }
}
function $9ef033443a74bee6$var$getFilenameFromContentDispositionHeader(contentDisposition) {
    let needsEncodingFixup = true;
    let tmp = toParamRegExp("filename\\*", "i").exec(contentDisposition);
    if (tmp) {
        tmp = tmp[1];
        let filename = rfc2616unquote(tmp);
        filename = unescape(filename);
        filename = rfc5987decode(filename);
        filename = rfc2047decode(filename);
        return fixupEncoding(filename);
    }
    tmp = rfc2231getparam(contentDisposition);
    if (tmp) {
        const filename = rfc2047decode(tmp);
        return fixupEncoding(filename);
    }
    tmp = toParamRegExp("filename", "i").exec(contentDisposition);
    if (tmp) {
        tmp = tmp[1];
        let filename = rfc2616unquote(tmp);
        filename = rfc2047decode(filename);
        return fixupEncoding(filename);
    }
    function toParamRegExp(attributePattern, flags) {
        return new RegExp("(?:^|;)\\s*" + attributePattern + "\\s*=\\s*" + "(" + '[^";\\s][^;\\s]*' + "|" + '"(?:[^"\\\\]|\\\\"?)+"?' + ")", flags);
    }
    function textdecode(encoding, value) {
        if (encoding) {
            if (!/^[\x00-\xFF]+$/.test(value)) return value;
            try {
                const decoder = new TextDecoder(encoding, {
                    fatal: true
                });
                const buffer = $9ef033443a74bee6$var$stringToBytes(value);
                value = decoder.decode(buffer);
                needsEncodingFixup = false;
            } catch  {}
        }
        return value;
    }
    function fixupEncoding(value) {
        if (needsEncodingFixup && /[\x80-\xff]/.test(value)) {
            value = textdecode("utf-8", value);
            if (needsEncodingFixup) value = textdecode("iso-8859-1", value);
        }
        return value;
    }
    function rfc2231getparam(contentDispositionStr) {
        const matches = [];
        let match;
        const iter = toParamRegExp("filename\\*((?!0\\d)\\d+)(\\*?)", "ig");
        while((match = iter.exec(contentDispositionStr)) !== null){
            let [, n, quot, part] = match;
            n = parseInt(n, 10);
            if (n in matches) {
                if (n === 0) break;
                continue;
            }
            matches[n] = [
                quot,
                part
            ];
        }
        const parts = [];
        for(let n = 0; n < matches.length; ++n){
            if (!(n in matches)) break;
            let [quot, part] = matches[n];
            part = rfc2616unquote(part);
            if (quot) {
                part = unescape(part);
                if (n === 0) part = rfc5987decode(part);
            }
            parts.push(part);
        }
        return parts.join("");
    }
    function rfc2616unquote(value) {
        if (value.startsWith('"')) {
            const parts = value.slice(1).split('\\"');
            for(let i = 0; i < parts.length; ++i){
                const quotindex = parts[i].indexOf('"');
                if (quotindex !== -1) {
                    parts[i] = parts[i].slice(0, quotindex);
                    parts.length = i + 1;
                }
                parts[i] = parts[i].replaceAll(/\\(.)/g, "$1");
            }
            value = parts.join('"');
        }
        return value;
    }
    function rfc5987decode(extvalue) {
        const encodingend = extvalue.indexOf("'");
        if (encodingend === -1) return extvalue;
        const encoding = extvalue.slice(0, encodingend);
        const langvalue = extvalue.slice(encodingend + 1);
        const value = langvalue.replace(/^[^']*'/, "");
        return textdecode(encoding, value);
    }
    function rfc2047decode(value) {
        if (!value.startsWith("=?") || /[\x00-\x19\x80-\xff]/.test(value)) return value;
        return value.replaceAll(/=\?([\w-]*)\?([QqBb])\?((?:[^?]|\?(?!=))*)\?=/g, function(matches, charset, encoding, text) {
            if (encoding === "q" || encoding === "Q") {
                text = text.replaceAll("_", " ");
                text = text.replaceAll(/=([0-9a-fA-F]{2})/g, function(match, hex) {
                    return String.fromCharCode(parseInt(hex, 16));
                });
                return textdecode(charset, text);
            }
            try {
                text = atob(text);
            } catch  {}
            return textdecode(charset, text);
        });
    }
    return "";
}
function $9ef033443a74bee6$var$createHeaders(isHttp, httpHeaders) {
    const headers = new Headers();
    if (!isHttp || !httpHeaders || typeof httpHeaders !== "object") return headers;
    for(const key in httpHeaders){
        const val = httpHeaders[key];
        if (val !== undefined) headers.append(key, val);
    }
    return headers;
}
function $9ef033443a74bee6$var$getResponseOrigin(url) {
    return URL.parse(url)?.origin ?? null;
}
function $9ef033443a74bee6$var$validateRangeRequestCapabilities({ responseHeaders: responseHeaders, isHttp: isHttp, rangeChunkSize: rangeChunkSize, disableRange: disableRange }) {
    const returnValues = {
        allowRangeRequests: false,
        suggestedLength: undefined
    };
    const length = parseInt(responseHeaders.get("Content-Length"), 10);
    if (!Number.isInteger(length)) return returnValues;
    returnValues.suggestedLength = length;
    if (length <= 2 * rangeChunkSize) return returnValues;
    if (disableRange || !isHttp) return returnValues;
    if (responseHeaders.get("Accept-Ranges") !== "bytes") return returnValues;
    const contentEncoding = responseHeaders.get("Content-Encoding") || "identity";
    if (contentEncoding !== "identity") return returnValues;
    returnValues.allowRangeRequests = true;
    return returnValues;
}
function $9ef033443a74bee6$var$extractFilenameFromHeader(responseHeaders) {
    const contentDisposition = responseHeaders.get("Content-Disposition");
    if (contentDisposition) {
        let filename = $9ef033443a74bee6$var$getFilenameFromContentDispositionHeader(contentDisposition);
        if (filename.includes("%")) try {
            filename = decodeURIComponent(filename);
        } catch  {}
        if ($9ef033443a74bee6$export$61b52d3570d24719(filename)) return filename;
    }
    return null;
}
function $9ef033443a74bee6$var$createResponseError(status, url) {
    return new $9ef033443a74bee6$export$ea8e9c34f66e603(`Unexpected server response (${status}) while retrieving PDF "${url}".`, status, status === 404 || status === 0 && url.startsWith("file:"));
}
function $9ef033443a74bee6$var$validateResponseStatus(status) {
    return status === 200 || status === 206;
}
function $9ef033443a74bee6$var$createFetchOptions(headers, withCredentials, abortController) {
    return {
        method: "GET",
        headers: headers,
        signal: abortController.signal,
        mode: "cors",
        credentials: withCredentials ? "include" : "same-origin",
        redirect: "follow"
    };
}
function $9ef033443a74bee6$var$getArrayBuffer(val) {
    if (val instanceof Uint8Array) return val.buffer;
    if (val instanceof ArrayBuffer) return val;
    $9ef033443a74bee6$var$warn(`getArrayBuffer - unexpected data format: ${val}`);
    return new Uint8Array(val).buffer;
}
class $9ef033443a74bee6$var$PDFFetchStream {
    _responseOrigin = null;
    constructor(source){
        this.source = source;
        this.isHttp = /^https?:/i.test(source.url);
        this.headers = $9ef033443a74bee6$var$createHeaders(this.isHttp, source.httpHeaders);
        this._fullRequestReader = null;
        this._rangeRequestReaders = [];
    }
    get _progressiveDataLength() {
        return this._fullRequestReader?._loaded ?? 0;
    }
    getFullReader() {
        $9ef033443a74bee6$var$assert(!this._fullRequestReader, "PDFFetchStream.getFullReader can only be called once.");
        this._fullRequestReader = new $9ef033443a74bee6$var$PDFFetchStreamReader(this);
        return this._fullRequestReader;
    }
    getRangeReader(begin, end) {
        if (end <= this._progressiveDataLength) return null;
        const reader = new $9ef033443a74bee6$var$PDFFetchStreamRangeReader(this, begin, end);
        this._rangeRequestReaders.push(reader);
        return reader;
    }
    cancelAllRequests(reason) {
        this._fullRequestReader?.cancel(reason);
        for (const reader of this._rangeRequestReaders.slice(0))reader.cancel(reason);
    }
}
class $9ef033443a74bee6$var$PDFFetchStreamReader {
    constructor(stream){
        this._stream = stream;
        this._reader = null;
        this._loaded = 0;
        this._filename = null;
        const source = stream.source;
        this._withCredentials = source.withCredentials || false;
        this._contentLength = source.length;
        this._headersCapability = Promise.withResolvers();
        this._disableRange = source.disableRange || false;
        this._rangeChunkSize = source.rangeChunkSize;
        if (!this._rangeChunkSize && !this._disableRange) this._disableRange = true;
        this._abortController = new AbortController();
        this._isStreamingSupported = !source.disableStream;
        this._isRangeSupported = !source.disableRange;
        const headers = new Headers(stream.headers);
        const url = source.url;
        fetch(url, $9ef033443a74bee6$var$createFetchOptions(headers, this._withCredentials, this._abortController)).then((response)=>{
            stream._responseOrigin = $9ef033443a74bee6$var$getResponseOrigin(response.url);
            if (!$9ef033443a74bee6$var$validateResponseStatus(response.status)) throw $9ef033443a74bee6$var$createResponseError(response.status, url);
            this._reader = response.body.getReader();
            this._headersCapability.resolve();
            const responseHeaders = response.headers;
            const { allowRangeRequests: allowRangeRequests, suggestedLength: suggestedLength } = $9ef033443a74bee6$var$validateRangeRequestCapabilities({
                responseHeaders: responseHeaders,
                isHttp: stream.isHttp,
                rangeChunkSize: this._rangeChunkSize,
                disableRange: this._disableRange
            });
            this._isRangeSupported = allowRangeRequests;
            this._contentLength = suggestedLength || this._contentLength;
            this._filename = $9ef033443a74bee6$var$extractFilenameFromHeader(responseHeaders);
            if (!this._isStreamingSupported && this._isRangeSupported) this.cancel(new $9ef033443a74bee6$export$d0e978393d193d1a("Streaming is disabled."));
        }).catch(this._headersCapability.reject);
        this.onProgress = null;
    }
    get headersReady() {
        return this._headersCapability.promise;
    }
    get filename() {
        return this._filename;
    }
    get contentLength() {
        return this._contentLength;
    }
    get isRangeSupported() {
        return this._isRangeSupported;
    }
    get isStreamingSupported() {
        return this._isStreamingSupported;
    }
    async read() {
        await this._headersCapability.promise;
        const { value: value, done: done } = await this._reader.read();
        if (done) return {
            value: value,
            done: done
        };
        this._loaded += value.byteLength;
        this.onProgress?.({
            loaded: this._loaded,
            total: this._contentLength
        });
        return {
            value: $9ef033443a74bee6$var$getArrayBuffer(value),
            done: false
        };
    }
    cancel(reason) {
        this._reader?.cancel(reason);
        this._abortController.abort();
    }
}
class $9ef033443a74bee6$var$PDFFetchStreamRangeReader {
    constructor(stream, begin, end){
        this._stream = stream;
        this._reader = null;
        this._loaded = 0;
        const source = stream.source;
        this._withCredentials = source.withCredentials || false;
        this._readCapability = Promise.withResolvers();
        this._isStreamingSupported = !source.disableStream;
        this._abortController = new AbortController();
        const headers = new Headers(stream.headers);
        headers.append("Range", `bytes=${begin}-${end - 1}`);
        const url = source.url;
        fetch(url, $9ef033443a74bee6$var$createFetchOptions(headers, this._withCredentials, this._abortController)).then((response)=>{
            const responseOrigin = $9ef033443a74bee6$var$getResponseOrigin(response.url);
            if (responseOrigin !== stream._responseOrigin) throw new Error(`Expected range response-origin "${responseOrigin}" to match "${stream._responseOrigin}".`);
            if (!$9ef033443a74bee6$var$validateResponseStatus(response.status)) throw $9ef033443a74bee6$var$createResponseError(response.status, url);
            this._readCapability.resolve();
            this._reader = response.body.getReader();
        }).catch(this._readCapability.reject);
        this.onProgress = null;
    }
    get isStreamingSupported() {
        return this._isStreamingSupported;
    }
    async read() {
        await this._readCapability.promise;
        const { value: value, done: done } = await this._reader.read();
        if (done) return {
            value: value,
            done: done
        };
        this._loaded += value.byteLength;
        this.onProgress?.({
            loaded: this._loaded
        });
        return {
            value: $9ef033443a74bee6$var$getArrayBuffer(value),
            done: false
        };
    }
    cancel(reason) {
        this._reader?.cancel(reason);
        this._abortController.abort();
    }
}
const $9ef033443a74bee6$var$OK_RESPONSE = 200;
const $9ef033443a74bee6$var$PARTIAL_CONTENT_RESPONSE = 206;
function $9ef033443a74bee6$var$network_getArrayBuffer(xhr) {
    const data = xhr.response;
    if (typeof data !== "string") return data;
    return $9ef033443a74bee6$var$stringToBytes(data).buffer;
}
class $9ef033443a74bee6$var$NetworkManager {
    _responseOrigin = null;
    constructor({ url: url, httpHeaders: httpHeaders, withCredentials: withCredentials }){
        this.url = url;
        this.isHttp = /^https?:/i.test(url);
        this.headers = $9ef033443a74bee6$var$createHeaders(this.isHttp, httpHeaders);
        this.withCredentials = withCredentials || false;
        this.currXhrId = 0;
        this.pendingRequests = Object.create(null);
    }
    request(args) {
        const xhr = new XMLHttpRequest();
        const xhrId = this.currXhrId++;
        const pendingRequest = this.pendingRequests[xhrId] = {
            xhr: xhr
        };
        xhr.open("GET", this.url);
        xhr.withCredentials = this.withCredentials;
        for (const [key, val] of this.headers)xhr.setRequestHeader(key, val);
        if (this.isHttp && "begin" in args && "end" in args) {
            xhr.setRequestHeader("Range", `bytes=${args.begin}-${args.end - 1}`);
            pendingRequest.expectedStatus = $9ef033443a74bee6$var$PARTIAL_CONTENT_RESPONSE;
        } else pendingRequest.expectedStatus = $9ef033443a74bee6$var$OK_RESPONSE;
        xhr.responseType = "arraybuffer";
        $9ef033443a74bee6$var$assert(args.onError, "Expected `onError` callback to be provided.");
        xhr.onerror = ()=>{
            args.onError(xhr.status);
        };
        xhr.onreadystatechange = this.onStateChange.bind(this, xhrId);
        xhr.onprogress = this.onProgress.bind(this, xhrId);
        pendingRequest.onHeadersReceived = args.onHeadersReceived;
        pendingRequest.onDone = args.onDone;
        pendingRequest.onError = args.onError;
        pendingRequest.onProgress = args.onProgress;
        xhr.send(null);
        return xhrId;
    }
    onProgress(xhrId, evt) {
        const pendingRequest = this.pendingRequests[xhrId];
        if (!pendingRequest) return;
        pendingRequest.onProgress?.(evt);
    }
    onStateChange(xhrId, evt) {
        const pendingRequest = this.pendingRequests[xhrId];
        if (!pendingRequest) return;
        const xhr = pendingRequest.xhr;
        if (xhr.readyState >= 2 && pendingRequest.onHeadersReceived) {
            pendingRequest.onHeadersReceived();
            delete pendingRequest.onHeadersReceived;
        }
        if (xhr.readyState !== 4) return;
        if (!(xhrId in this.pendingRequests)) return;
        delete this.pendingRequests[xhrId];
        if (xhr.status === 0 && this.isHttp) {
            pendingRequest.onError(xhr.status);
            return;
        }
        const xhrStatus = xhr.status || $9ef033443a74bee6$var$OK_RESPONSE;
        const ok_response_on_range_request = xhrStatus === $9ef033443a74bee6$var$OK_RESPONSE && pendingRequest.expectedStatus === $9ef033443a74bee6$var$PARTIAL_CONTENT_RESPONSE;
        if (!ok_response_on_range_request && xhrStatus !== pendingRequest.expectedStatus) {
            pendingRequest.onError(xhr.status);
            return;
        }
        const chunk = $9ef033443a74bee6$var$network_getArrayBuffer(xhr);
        if (xhrStatus === $9ef033443a74bee6$var$PARTIAL_CONTENT_RESPONSE) {
            const rangeHeader = xhr.getResponseHeader("Content-Range");
            const matches = /bytes (\d+)-(\d+)\/(\d+)/.exec(rangeHeader);
            if (matches) pendingRequest.onDone({
                begin: parseInt(matches[1], 10),
                chunk: chunk
            });
            else {
                $9ef033443a74bee6$var$warn(`Missing or invalid "Content-Range" header.`);
                pendingRequest.onError(0);
            }
        } else if (chunk) pendingRequest.onDone({
            begin: 0,
            chunk: chunk
        });
        else pendingRequest.onError(xhr.status);
    }
    getRequestXhr(xhrId) {
        return this.pendingRequests[xhrId].xhr;
    }
    isPendingRequest(xhrId) {
        return xhrId in this.pendingRequests;
    }
    abortRequest(xhrId) {
        const xhr = this.pendingRequests[xhrId].xhr;
        delete this.pendingRequests[xhrId];
        xhr.abort();
    }
}
class $9ef033443a74bee6$var$PDFNetworkStream {
    constructor(source){
        this._source = source;
        this._manager = new $9ef033443a74bee6$var$NetworkManager(source);
        this._rangeChunkSize = source.rangeChunkSize;
        this._fullRequestReader = null;
        this._rangeRequestReaders = [];
    }
    _onRangeRequestReaderClosed(reader) {
        const i = this._rangeRequestReaders.indexOf(reader);
        if (i >= 0) this._rangeRequestReaders.splice(i, 1);
    }
    getFullReader() {
        $9ef033443a74bee6$var$assert(!this._fullRequestReader, "PDFNetworkStream.getFullReader can only be called once.");
        this._fullRequestReader = new $9ef033443a74bee6$var$PDFNetworkStreamFullRequestReader(this._manager, this._source);
        return this._fullRequestReader;
    }
    getRangeReader(begin, end) {
        const reader = new $9ef033443a74bee6$var$PDFNetworkStreamRangeRequestReader(this._manager, begin, end);
        reader.onClosed = this._onRangeRequestReaderClosed.bind(this);
        this._rangeRequestReaders.push(reader);
        return reader;
    }
    cancelAllRequests(reason) {
        this._fullRequestReader?.cancel(reason);
        for (const reader of this._rangeRequestReaders.slice(0))reader.cancel(reason);
    }
}
class $9ef033443a74bee6$var$PDFNetworkStreamFullRequestReader {
    constructor(manager, source){
        this._manager = manager;
        this._url = source.url;
        this._fullRequestId = manager.request({
            onHeadersReceived: this._onHeadersReceived.bind(this),
            onDone: this._onDone.bind(this),
            onError: this._onError.bind(this),
            onProgress: this._onProgress.bind(this)
        });
        this._headersCapability = Promise.withResolvers();
        this._disableRange = source.disableRange || false;
        this._contentLength = source.length;
        this._rangeChunkSize = source.rangeChunkSize;
        if (!this._rangeChunkSize && !this._disableRange) this._disableRange = true;
        this._isStreamingSupported = false;
        this._isRangeSupported = false;
        this._cachedChunks = [];
        this._requests = [];
        this._done = false;
        this._storedError = undefined;
        this._filename = null;
        this.onProgress = null;
    }
    _onHeadersReceived() {
        const fullRequestXhrId = this._fullRequestId;
        const fullRequestXhr = this._manager.getRequestXhr(fullRequestXhrId);
        this._manager._responseOrigin = $9ef033443a74bee6$var$getResponseOrigin(fullRequestXhr.responseURL);
        const rawResponseHeaders = fullRequestXhr.getAllResponseHeaders();
        const responseHeaders = new Headers(rawResponseHeaders ? rawResponseHeaders.trimStart().replace(/[^\S ]+$/, "").split(/[\r\n]+/).map((x)=>{
            const [key, ...val] = x.split(": ");
            return [
                key,
                val.join(": ")
            ];
        }) : []);
        const { allowRangeRequests: allowRangeRequests, suggestedLength: suggestedLength } = $9ef033443a74bee6$var$validateRangeRequestCapabilities({
            responseHeaders: responseHeaders,
            isHttp: this._manager.isHttp,
            rangeChunkSize: this._rangeChunkSize,
            disableRange: this._disableRange
        });
        if (allowRangeRequests) this._isRangeSupported = true;
        this._contentLength = suggestedLength || this._contentLength;
        this._filename = $9ef033443a74bee6$var$extractFilenameFromHeader(responseHeaders);
        if (this._isRangeSupported) this._manager.abortRequest(fullRequestXhrId);
        this._headersCapability.resolve();
    }
    _onDone(data) {
        if (data) {
            if (this._requests.length > 0) {
                const requestCapability = this._requests.shift();
                requestCapability.resolve({
                    value: data.chunk,
                    done: false
                });
            } else this._cachedChunks.push(data.chunk);
        }
        this._done = true;
        if (this._cachedChunks.length > 0) return;
        for (const requestCapability of this._requests)requestCapability.resolve({
            value: undefined,
            done: true
        });
        this._requests.length = 0;
    }
    _onError(status) {
        this._storedError = $9ef033443a74bee6$var$createResponseError(status, this._url);
        this._headersCapability.reject(this._storedError);
        for (const requestCapability of this._requests)requestCapability.reject(this._storedError);
        this._requests.length = 0;
        this._cachedChunks.length = 0;
    }
    _onProgress(evt) {
        this.onProgress?.({
            loaded: evt.loaded,
            total: evt.lengthComputable ? evt.total : this._contentLength
        });
    }
    get filename() {
        return this._filename;
    }
    get isRangeSupported() {
        return this._isRangeSupported;
    }
    get isStreamingSupported() {
        return this._isStreamingSupported;
    }
    get contentLength() {
        return this._contentLength;
    }
    get headersReady() {
        return this._headersCapability.promise;
    }
    async read() {
        await this._headersCapability.promise;
        if (this._storedError) throw this._storedError;
        if (this._cachedChunks.length > 0) {
            const chunk = this._cachedChunks.shift();
            return {
                value: chunk,
                done: false
            };
        }
        if (this._done) return {
            value: undefined,
            done: true
        };
        const requestCapability = Promise.withResolvers();
        this._requests.push(requestCapability);
        return requestCapability.promise;
    }
    cancel(reason) {
        this._done = true;
        this._headersCapability.reject(reason);
        for (const requestCapability of this._requests)requestCapability.resolve({
            value: undefined,
            done: true
        });
        this._requests.length = 0;
        if (this._manager.isPendingRequest(this._fullRequestId)) this._manager.abortRequest(this._fullRequestId);
        this._fullRequestReader = null;
    }
}
class $9ef033443a74bee6$var$PDFNetworkStreamRangeRequestReader {
    constructor(manager, begin, end){
        this._manager = manager;
        this._url = manager.url;
        this._requestId = manager.request({
            begin: begin,
            end: end,
            onHeadersReceived: this._onHeadersReceived.bind(this),
            onDone: this._onDone.bind(this),
            onError: this._onError.bind(this),
            onProgress: this._onProgress.bind(this)
        });
        this._requests = [];
        this._queuedChunk = null;
        this._done = false;
        this._storedError = undefined;
        this.onProgress = null;
        this.onClosed = null;
    }
    _onHeadersReceived() {
        const responseOrigin = $9ef033443a74bee6$var$getResponseOrigin(this._manager.getRequestXhr(this._requestId)?.responseURL);
        if (responseOrigin !== this._manager._responseOrigin) {
            this._storedError = new Error(`Expected range response-origin "${responseOrigin}" to match "${this._manager._responseOrigin}".`);
            this._onError(0);
        }
    }
    _close() {
        this.onClosed?.(this);
    }
    _onDone(data) {
        const chunk = data.chunk;
        if (this._requests.length > 0) {
            const requestCapability = this._requests.shift();
            requestCapability.resolve({
                value: chunk,
                done: false
            });
        } else this._queuedChunk = chunk;
        this._done = true;
        for (const requestCapability of this._requests)requestCapability.resolve({
            value: undefined,
            done: true
        });
        this._requests.length = 0;
        this._close();
    }
    _onError(status) {
        this._storedError ??= $9ef033443a74bee6$var$createResponseError(status, this._url);
        for (const requestCapability of this._requests)requestCapability.reject(this._storedError);
        this._requests.length = 0;
        this._queuedChunk = null;
    }
    _onProgress(evt) {
        if (!this.isStreamingSupported) this.onProgress?.({
            loaded: evt.loaded
        });
    }
    get isStreamingSupported() {
        return false;
    }
    async read() {
        if (this._storedError) throw this._storedError;
        if (this._queuedChunk !== null) {
            const chunk = this._queuedChunk;
            this._queuedChunk = null;
            return {
                value: chunk,
                done: false
            };
        }
        if (this._done) return {
            value: undefined,
            done: true
        };
        const requestCapability = Promise.withResolvers();
        this._requests.push(requestCapability);
        return requestCapability.promise;
    }
    cancel(reason) {
        this._done = true;
        for (const requestCapability of this._requests)requestCapability.resolve({
            value: undefined,
            done: true
        });
        this._requests.length = 0;
        if (this._manager.isPendingRequest(this._requestId)) this._manager.abortRequest(this._requestId);
        this._close();
    }
}
const $9ef033443a74bee6$var$urlRegex = /^[a-z][a-z0-9\-+.]+:/i;
function $9ef033443a74bee6$var$parseUrlOrPath(sourceUrl) {
    if ($9ef033443a74bee6$var$urlRegex.test(sourceUrl)) return new URL(sourceUrl);
    const url = $a553cffd36fe3594$exports.getBuiltinModule("url");
    return new URL(url.pathToFileURL(sourceUrl));
}
class $9ef033443a74bee6$var$PDFNodeStream {
    constructor(source){
        this.source = source;
        this.url = $9ef033443a74bee6$var$parseUrlOrPath(source.url);
        $9ef033443a74bee6$var$assert(this.url.protocol === "file:", "PDFNodeStream only supports file:// URLs.");
        this._fullRequestReader = null;
        this._rangeRequestReaders = [];
    }
    get _progressiveDataLength() {
        return this._fullRequestReader?._loaded ?? 0;
    }
    getFullReader() {
        $9ef033443a74bee6$var$assert(!this._fullRequestReader, "PDFNodeStream.getFullReader can only be called once.");
        this._fullRequestReader = new $9ef033443a74bee6$var$PDFNodeStreamFsFullReader(this);
        return this._fullRequestReader;
    }
    getRangeReader(start, end) {
        if (end <= this._progressiveDataLength) return null;
        const rangeReader = new $9ef033443a74bee6$var$PDFNodeStreamFsRangeReader(this, start, end);
        this._rangeRequestReaders.push(rangeReader);
        return rangeReader;
    }
    cancelAllRequests(reason) {
        this._fullRequestReader?.cancel(reason);
        for (const reader of this._rangeRequestReaders.slice(0))reader.cancel(reason);
    }
}
class $9ef033443a74bee6$var$PDFNodeStreamFsFullReader {
    constructor(stream){
        this._url = stream.url;
        this._done = false;
        this._storedError = null;
        this.onProgress = null;
        const source = stream.source;
        this._contentLength = source.length;
        this._loaded = 0;
        this._filename = null;
        this._disableRange = source.disableRange || false;
        this._rangeChunkSize = source.rangeChunkSize;
        if (!this._rangeChunkSize && !this._disableRange) this._disableRange = true;
        this._isStreamingSupported = !source.disableStream;
        this._isRangeSupported = !source.disableRange;
        this._readableStream = null;
        this._readCapability = Promise.withResolvers();
        this._headersCapability = Promise.withResolvers();
        const fs = $a553cffd36fe3594$exports.getBuiltinModule("fs");
        fs.promises.lstat(this._url).then((stat)=>{
            this._contentLength = stat.size;
            this._setReadableStream(fs.createReadStream(this._url));
            this._headersCapability.resolve();
        }, (error)=>{
            if (error.code === "ENOENT") error = $9ef033443a74bee6$var$createResponseError(0, this._url.href);
            this._storedError = error;
            this._headersCapability.reject(error);
        });
    }
    get headersReady() {
        return this._headersCapability.promise;
    }
    get filename() {
        return this._filename;
    }
    get contentLength() {
        return this._contentLength;
    }
    get isRangeSupported() {
        return this._isRangeSupported;
    }
    get isStreamingSupported() {
        return this._isStreamingSupported;
    }
    async read() {
        await this._readCapability.promise;
        if (this._done) return {
            value: undefined,
            done: true
        };
        if (this._storedError) throw this._storedError;
        const chunk = this._readableStream.read();
        if (chunk === null) {
            this._readCapability = Promise.withResolvers();
            return this.read();
        }
        this._loaded += chunk.length;
        this.onProgress?.({
            loaded: this._loaded,
            total: this._contentLength
        });
        const buffer = new Uint8Array(chunk).buffer;
        return {
            value: buffer,
            done: false
        };
    }
    cancel(reason) {
        if (!this._readableStream) {
            this._error(reason);
            return;
        }
        this._readableStream.destroy(reason);
    }
    _error(reason) {
        this._storedError = reason;
        this._readCapability.resolve();
    }
    _setReadableStream(readableStream) {
        this._readableStream = readableStream;
        readableStream.on("readable", ()=>{
            this._readCapability.resolve();
        });
        readableStream.on("end", ()=>{
            readableStream.destroy();
            this._done = true;
            this._readCapability.resolve();
        });
        readableStream.on("error", (reason)=>{
            this._error(reason);
        });
        if (!this._isStreamingSupported && this._isRangeSupported) this._error(new $9ef033443a74bee6$export$d0e978393d193d1a("streaming is disabled"));
        if (this._storedError) this._readableStream.destroy(this._storedError);
    }
}
class $9ef033443a74bee6$var$PDFNodeStreamFsRangeReader {
    constructor(stream, start, end){
        this._url = stream.url;
        this._done = false;
        this._storedError = null;
        this.onProgress = null;
        this._loaded = 0;
        this._readableStream = null;
        this._readCapability = Promise.withResolvers();
        const source = stream.source;
        this._isStreamingSupported = !source.disableStream;
        const fs = $a553cffd36fe3594$exports.getBuiltinModule("fs");
        this._setReadableStream(fs.createReadStream(this._url, {
            start: start,
            end: end - 1
        }));
    }
    get isStreamingSupported() {
        return this._isStreamingSupported;
    }
    async read() {
        await this._readCapability.promise;
        if (this._done) return {
            value: undefined,
            done: true
        };
        if (this._storedError) throw this._storedError;
        const chunk = this._readableStream.read();
        if (chunk === null) {
            this._readCapability = Promise.withResolvers();
            return this.read();
        }
        this._loaded += chunk.length;
        this.onProgress?.({
            loaded: this._loaded
        });
        const buffer = new Uint8Array(chunk).buffer;
        return {
            value: buffer,
            done: false
        };
    }
    cancel(reason) {
        if (!this._readableStream) {
            this._error(reason);
            return;
        }
        this._readableStream.destroy(reason);
    }
    _error(reason) {
        this._storedError = reason;
        this._readCapability.resolve();
    }
    _setReadableStream(readableStream) {
        this._readableStream = readableStream;
        readableStream.on("readable", ()=>{
            this._readCapability.resolve();
        });
        readableStream.on("end", ()=>{
            readableStream.destroy();
            this._done = true;
            this._readCapability.resolve();
        });
        readableStream.on("error", (reason)=>{
            this._error(reason);
        });
        if (this._storedError) this._readableStream.destroy(this._storedError);
    }
}
const $9ef033443a74bee6$var$INITIAL_DATA = Symbol("INITIAL_DATA");
class $9ef033443a74bee6$var$PDFObjects {
    #objs = Object.create(null);
    #ensureObj(objId) {
        return this.#objs[objId] ||= {
            ...Promise.withResolvers(),
            data: $9ef033443a74bee6$var$INITIAL_DATA
        };
    }
    get(objId, callback = null) {
        if (callback) {
            const obj = this.#ensureObj(objId);
            obj.promise.then(()=>callback(obj.data));
            return null;
        }
        const obj = this.#objs[objId];
        if (!obj || obj.data === $9ef033443a74bee6$var$INITIAL_DATA) throw new Error(`Requesting object that isn't resolved yet ${objId}.`);
        return obj.data;
    }
    has(objId) {
        const obj = this.#objs[objId];
        return !!obj && obj.data !== $9ef033443a74bee6$var$INITIAL_DATA;
    }
    delete(objId) {
        const obj = this.#objs[objId];
        if (!obj || obj.data === $9ef033443a74bee6$var$INITIAL_DATA) return false;
        delete this.#objs[objId];
        return true;
    }
    resolve(objId, data = null) {
        const obj = this.#ensureObj(objId);
        obj.data = data;
        obj.resolve();
    }
    clear() {
        for(const objId in this.#objs){
            const { data: data } = this.#objs[objId];
            data?.bitmap?.close();
        }
        this.#objs = Object.create(null);
    }
    *[Symbol.iterator]() {
        for(const objId in this.#objs){
            const { data: data } = this.#objs[objId];
            if (data === $9ef033443a74bee6$var$INITIAL_DATA) continue;
            yield [
                objId,
                data
            ];
        }
    }
}
const $9ef033443a74bee6$var$MAX_TEXT_DIVS_TO_RENDER = 100000;
const $9ef033443a74bee6$var$DEFAULT_FONT_SIZE = 30;
class $9ef033443a74bee6$export$fdbdc423a78c5262 {
    #capability = Promise.withResolvers();
    #container = null;
    #disableProcessItems = false;
    #fontInspectorEnabled = !!globalThis.FontInspector?.enabled;
    #lang = null;
    #layoutTextParams = null;
    #pageHeight = 0;
    #pageWidth = 0;
    #reader = null;
    #rootContainer = null;
    #rotation = 0;
    #scale = 0;
    #styleCache = Object.create(null);
    #textContentItemsStr = [];
    #textContentSource = null;
    #textDivs = [];
    #textDivProperties = new WeakMap();
    #transform = null;
    static #ascentCache = new Map();
    static #canvasContexts = new Map();
    static #canvasCtxFonts = new WeakMap();
    static #minFontSize = null;
    static #pendingTextLayers = new Set();
    constructor({ textContentSource: textContentSource, container: container, viewport: viewport }){
        if (textContentSource instanceof ReadableStream) this.#textContentSource = textContentSource;
        else if (typeof textContentSource === "object") this.#textContentSource = new ReadableStream({
            start (controller) {
                controller.enqueue(textContentSource);
                controller.close();
            }
        });
        else throw new Error('No "textContentSource" parameter specified.');
        this.#container = this.#rootContainer = container;
        this.#scale = viewport.scale * $9ef033443a74bee6$export$f16a99f63bccd50b.pixelRatio;
        this.#rotation = viewport.rotation;
        this.#layoutTextParams = {
            div: null,
            properties: null,
            ctx: null
        };
        const { pageWidth: pageWidth, pageHeight: pageHeight, pageX: pageX, pageY: pageY } = viewport.rawDims;
        this.#transform = [
            1,
            0,
            0,
            -1,
            -pageX,
            pageY + pageHeight
        ];
        this.#pageWidth = pageWidth;
        this.#pageHeight = pageHeight;
        $9ef033443a74bee6$export$fdbdc423a78c5262.#ensureMinFontSizeComputed();
        $9ef033443a74bee6$export$af0a15a86e590226(container, viewport);
        this.#capability.promise.finally(()=>{
            $9ef033443a74bee6$export$fdbdc423a78c5262.#pendingTextLayers.delete(this);
            this.#layoutTextParams = null;
            this.#styleCache = null;
        }).catch(()=>{});
    }
    static get fontFamilyMap() {
        const { isWindows: isWindows, isFirefox: isFirefox } = $9ef033443a74bee6$export$5fb8891d35c36978.platform;
        return $9ef033443a74bee6$export$b8972b998723d602(this, "fontFamilyMap", new Map([
            [
                "sans-serif",
                `${isWindows && isFirefox ? "Calibri, " : ""}sans-serif`
            ],
            [
                "monospace",
                `${isWindows && isFirefox ? "Lucida Console, " : ""}monospace`
            ]
        ]));
    }
    render() {
        const pump = ()=>{
            this.#reader.read().then(({ value: value, done: done })=>{
                if (done) {
                    this.#capability.resolve();
                    return;
                }
                this.#lang ??= value.lang;
                Object.assign(this.#styleCache, value.styles);
                this.#processItems(value.items);
                pump();
            }, this.#capability.reject);
        };
        this.#reader = this.#textContentSource.getReader();
        $9ef033443a74bee6$export$fdbdc423a78c5262.#pendingTextLayers.add(this);
        pump();
        return this.#capability.promise;
    }
    update({ viewport: viewport, onBefore: onBefore = null }) {
        const scale = viewport.scale * $9ef033443a74bee6$export$f16a99f63bccd50b.pixelRatio;
        const rotation = viewport.rotation;
        if (rotation !== this.#rotation) {
            onBefore?.();
            this.#rotation = rotation;
            $9ef033443a74bee6$export$af0a15a86e590226(this.#rootContainer, {
                rotation: rotation
            });
        }
        if (scale !== this.#scale) {
            onBefore?.();
            this.#scale = scale;
            const params = {
                div: null,
                properties: null,
                ctx: $9ef033443a74bee6$export$fdbdc423a78c5262.#getCtx(this.#lang)
            };
            for (const div of this.#textDivs){
                params.properties = this.#textDivProperties.get(div);
                params.div = div;
                this.#layout(params);
            }
        }
    }
    cancel() {
        const abortEx = new $9ef033443a74bee6$export$d0e978393d193d1a("TextLayer task cancelled.");
        this.#reader?.cancel(abortEx).catch(()=>{});
        this.#reader = null;
        this.#capability.reject(abortEx);
    }
    get textDivs() {
        return this.#textDivs;
    }
    get textContentItemsStr() {
        return this.#textContentItemsStr;
    }
    #processItems(items) {
        if (this.#disableProcessItems) return;
        this.#layoutTextParams.ctx ??= $9ef033443a74bee6$export$fdbdc423a78c5262.#getCtx(this.#lang);
        const textDivs = this.#textDivs, textContentItemsStr = this.#textContentItemsStr;
        for (const item of items){
            if (textDivs.length > $9ef033443a74bee6$var$MAX_TEXT_DIVS_TO_RENDER) {
                $9ef033443a74bee6$var$warn("Ignoring additional textDivs for performance reasons.");
                this.#disableProcessItems = true;
                return;
            }
            if (item.str === undefined) {
                if (item.type === "beginMarkedContentProps" || item.type === "beginMarkedContent") {
                    const parent = this.#container;
                    this.#container = document.createElement("span");
                    this.#container.classList.add("markedContent");
                    if (item.id) this.#container.setAttribute("id", `${item.id}`);
                    parent.append(this.#container);
                } else if (item.type === "endMarkedContent") this.#container = this.#container.parentNode;
                continue;
            }
            textContentItemsStr.push(item.str);
            this.#appendText(item);
        }
    }
    #appendText(geom) {
        const textDiv = document.createElement("span");
        const textDivProperties = {
            angle: 0,
            canvasWidth: 0,
            hasText: geom.str !== "",
            hasEOL: geom.hasEOL,
            fontSize: 0
        };
        this.#textDivs.push(textDiv);
        const tx = $9ef033443a74bee6$export$f8f26dd395d7e1bd.transform(this.#transform, geom.transform);
        let angle = Math.atan2(tx[1], tx[0]);
        const style = this.#styleCache[geom.fontName];
        if (style.vertical) angle += Math.PI / 2;
        let fontFamily = this.#fontInspectorEnabled && style.fontSubstitution || style.fontFamily;
        fontFamily = $9ef033443a74bee6$export$fdbdc423a78c5262.fontFamilyMap.get(fontFamily) || fontFamily;
        const fontHeight = Math.hypot(tx[2], tx[3]);
        const fontAscent = fontHeight * $9ef033443a74bee6$export$fdbdc423a78c5262.#getAscent(fontFamily, style, this.#lang);
        let left, top;
        if (angle === 0) {
            left = tx[4];
            top = tx[5] - fontAscent;
        } else {
            left = tx[4] + fontAscent * Math.sin(angle);
            top = tx[5] - fontAscent * Math.cos(angle);
        }
        const scaleFactorStr = "calc(var(--total-scale-factor) *";
        const divStyle = textDiv.style;
        if (this.#container === this.#rootContainer) {
            divStyle.left = `${(100 * left / this.#pageWidth).toFixed(2)}%`;
            divStyle.top = `${(100 * top / this.#pageHeight).toFixed(2)}%`;
        } else {
            divStyle.left = `${scaleFactorStr}${left.toFixed(2)}px)`;
            divStyle.top = `${scaleFactorStr}${top.toFixed(2)}px)`;
        }
        divStyle.fontSize = `${scaleFactorStr}${($9ef033443a74bee6$export$fdbdc423a78c5262.#minFontSize * fontHeight).toFixed(2)}px)`;
        divStyle.fontFamily = fontFamily;
        textDivProperties.fontSize = fontHeight;
        textDiv.setAttribute("role", "presentation");
        textDiv.textContent = geom.str;
        textDiv.dir = geom.dir;
        if (this.#fontInspectorEnabled) textDiv.dataset.fontName = style.fontSubstitutionLoadedName || geom.fontName;
        if (angle !== 0) textDivProperties.angle = angle * (180 / Math.PI);
        let shouldScaleText = false;
        if (geom.str.length > 1) shouldScaleText = true;
        else if (geom.str !== " " && geom.transform[0] !== geom.transform[3]) {
            const absScaleX = Math.abs(geom.transform[0]), absScaleY = Math.abs(geom.transform[3]);
            if (absScaleX !== absScaleY && Math.max(absScaleX, absScaleY) / Math.min(absScaleX, absScaleY) > 1.5) shouldScaleText = true;
        }
        if (shouldScaleText) textDivProperties.canvasWidth = style.vertical ? geom.height : geom.width;
        this.#textDivProperties.set(textDiv, textDivProperties);
        this.#layoutTextParams.div = textDiv;
        this.#layoutTextParams.properties = textDivProperties;
        this.#layout(this.#layoutTextParams);
        if (textDivProperties.hasText) this.#container.append(textDiv);
        if (textDivProperties.hasEOL) {
            const br = document.createElement("br");
            br.setAttribute("role", "presentation");
            this.#container.append(br);
        }
    }
    #layout(params) {
        const { div: div, properties: properties, ctx: ctx } = params;
        const { style: style } = div;
        let transform = "";
        if ($9ef033443a74bee6$export$fdbdc423a78c5262.#minFontSize > 1) transform = `scale(${1 / $9ef033443a74bee6$export$fdbdc423a78c5262.#minFontSize})`;
        if (properties.canvasWidth !== 0 && properties.hasText) {
            const { fontFamily: fontFamily } = style;
            const { canvasWidth: canvasWidth, fontSize: fontSize } = properties;
            $9ef033443a74bee6$export$fdbdc423a78c5262.#ensureCtxFont(ctx, fontSize * this.#scale, fontFamily);
            const { width: width } = ctx.measureText(div.textContent);
            if (width > 0) transform = `scaleX(${canvasWidth * this.#scale / width}) ${transform}`;
        }
        if (properties.angle !== 0) transform = `rotate(${properties.angle}deg) ${transform}`;
        if (transform.length > 0) style.transform = transform;
    }
    static cleanup() {
        if (this.#pendingTextLayers.size > 0) return;
        this.#ascentCache.clear();
        for (const { canvas: canvas } of this.#canvasContexts.values())canvas.remove();
        this.#canvasContexts.clear();
    }
    static #getCtx(lang = null) {
        let ctx = this.#canvasContexts.get(lang ||= "");
        if (!ctx) {
            const canvas = document.createElement("canvas");
            canvas.className = "hiddenCanvasElement";
            canvas.lang = lang;
            document.body.append(canvas);
            ctx = canvas.getContext("2d", {
                alpha: false,
                willReadFrequently: true
            });
            this.#canvasContexts.set(lang, ctx);
            this.#canvasCtxFonts.set(ctx, {
                size: 0,
                family: ""
            });
        }
        return ctx;
    }
    static #ensureCtxFont(ctx, size, family) {
        const cached = this.#canvasCtxFonts.get(ctx);
        if (size === cached.size && family === cached.family) return;
        ctx.font = `${size}px ${family}`;
        cached.size = size;
        cached.family = family;
    }
    static #ensureMinFontSizeComputed() {
        if (this.#minFontSize !== null) return;
        const div = document.createElement("div");
        div.style.opacity = 0;
        div.style.lineHeight = 1;
        div.style.fontSize = "1px";
        div.style.position = "absolute";
        div.textContent = "X";
        document.body.append(div);
        this.#minFontSize = div.getBoundingClientRect().height;
        div.remove();
    }
    static #getAscent(fontFamily, style, lang) {
        const cachedAscent = this.#ascentCache.get(fontFamily);
        if (cachedAscent) return cachedAscent;
        const ctx = this.#getCtx(lang);
        ctx.canvas.width = ctx.canvas.height = $9ef033443a74bee6$var$DEFAULT_FONT_SIZE;
        this.#ensureCtxFont(ctx, $9ef033443a74bee6$var$DEFAULT_FONT_SIZE, fontFamily);
        const metrics = ctx.measureText("");
        const ascent = metrics.fontBoundingBoxAscent;
        const descent = Math.abs(metrics.fontBoundingBoxDescent);
        ctx.canvas.width = ctx.canvas.height = 0;
        let ratio = 0.8;
        if (ascent) ratio = ascent / (ascent + descent);
        else {
            if ($9ef033443a74bee6$export$5fb8891d35c36978.platform.isFirefox) $9ef033443a74bee6$var$warn("Enable the `dom.textMetrics.fontBoundingBox.enabled` preference in `about:config` to improve TextLayer rendering.");
            if (style.ascent) ratio = style.ascent;
            else if (style.descent) ratio = 1 + style.descent;
        }
        this.#ascentCache.set(fontFamily, ratio);
        return ratio;
    }
}
const $9ef033443a74bee6$var$RENDERING_CANCELLED_TIMEOUT = 100;
function $9ef033443a74bee6$export$f65ca476c09acec0(src = {}) {
    if (typeof src === "string" || src instanceof URL) src = {
        url: src
    };
    else if (src instanceof ArrayBuffer || ArrayBuffer.isView(src)) src = {
        data: src
    };
    const task = new $9ef033443a74bee6$var$PDFDocumentLoadingTask();
    const { docId: docId } = task;
    const url = src.url ? $9ef033443a74bee6$var$getUrlProp(src.url) : null;
    const data = src.data ? $9ef033443a74bee6$var$getDataProp(src.data) : null;
    const httpHeaders = src.httpHeaders || null;
    const withCredentials = src.withCredentials === true;
    const password = src.password ?? null;
    const rangeTransport = src.range instanceof $9ef033443a74bee6$export$c06899d9d7bce9ab ? src.range : null;
    const rangeChunkSize = Number.isInteger(src.rangeChunkSize) && src.rangeChunkSize > 0 ? src.rangeChunkSize : 2 ** 16;
    let worker = src.worker instanceof $9ef033443a74bee6$export$84e2e9f37426b265 ? src.worker : null;
    const verbosity = src.verbosity;
    const docBaseUrl = typeof src.docBaseUrl === "string" && !$9ef033443a74bee6$export$f67aae4532d8295b(src.docBaseUrl) ? src.docBaseUrl : null;
    const cMapUrl = $9ef033443a74bee6$var$getFactoryUrlProp(src.cMapUrl);
    const cMapPacked = src.cMapPacked !== false;
    const CMapReaderFactory = src.CMapReaderFactory || ($9ef033443a74bee6$var$isNodeJS ? $9ef033443a74bee6$var$NodeCMapReaderFactory : $9ef033443a74bee6$var$DOMCMapReaderFactory);
    const iccUrl = $9ef033443a74bee6$var$getFactoryUrlProp(src.iccUrl);
    const standardFontDataUrl = $9ef033443a74bee6$var$getFactoryUrlProp(src.standardFontDataUrl);
    const StandardFontDataFactory = src.StandardFontDataFactory || ($9ef033443a74bee6$var$isNodeJS ? $9ef033443a74bee6$var$NodeStandardFontDataFactory : $9ef033443a74bee6$var$DOMStandardFontDataFactory);
    const wasmUrl = $9ef033443a74bee6$var$getFactoryUrlProp(src.wasmUrl);
    const WasmFactory = src.WasmFactory || ($9ef033443a74bee6$var$isNodeJS ? $9ef033443a74bee6$var$NodeWasmFactory : $9ef033443a74bee6$var$DOMWasmFactory);
    const ignoreErrors = src.stopAtErrors !== true;
    const maxImageSize = Number.isInteger(src.maxImageSize) && src.maxImageSize > -1 ? src.maxImageSize : -1;
    const isEvalSupported = src.isEvalSupported !== false;
    const isOffscreenCanvasSupported = typeof src.isOffscreenCanvasSupported === "boolean" ? src.isOffscreenCanvasSupported : !$9ef033443a74bee6$var$isNodeJS;
    const isImageDecoderSupported = typeof src.isImageDecoderSupported === "boolean" ? src.isImageDecoderSupported : !$9ef033443a74bee6$var$isNodeJS && ($9ef033443a74bee6$export$5fb8891d35c36978.platform.isFirefox || !globalThis.chrome);
    const canvasMaxAreaInBytes = Number.isInteger(src.canvasMaxAreaInBytes) ? src.canvasMaxAreaInBytes : -1;
    const disableFontFace = typeof src.disableFontFace === "boolean" ? src.disableFontFace : $9ef033443a74bee6$var$isNodeJS;
    const fontExtraProperties = src.fontExtraProperties === true;
    const enableXfa = src.enableXfa === true;
    const ownerDocument = src.ownerDocument || globalThis.document;
    const disableRange = src.disableRange === true;
    const disableStream = src.disableStream === true;
    const disableAutoFetch = src.disableAutoFetch === true;
    const pdfBug = src.pdfBug === true;
    const CanvasFactory = src.CanvasFactory || ($9ef033443a74bee6$var$isNodeJS ? $9ef033443a74bee6$var$NodeCanvasFactory : $9ef033443a74bee6$var$DOMCanvasFactory);
    const FilterFactory = src.FilterFactory || ($9ef033443a74bee6$var$isNodeJS ? $9ef033443a74bee6$var$NodeFilterFactory : $9ef033443a74bee6$var$DOMFilterFactory);
    const enableHWA = src.enableHWA === true;
    const useWasm = src.useWasm !== false;
    const length = rangeTransport ? rangeTransport.length : src.length ?? NaN;
    const useSystemFonts = typeof src.useSystemFonts === "boolean" ? src.useSystemFonts : !$9ef033443a74bee6$var$isNodeJS && !disableFontFace;
    const useWorkerFetch = typeof src.useWorkerFetch === "boolean" ? src.useWorkerFetch : !!(CMapReaderFactory === $9ef033443a74bee6$var$DOMCMapReaderFactory && StandardFontDataFactory === $9ef033443a74bee6$var$DOMStandardFontDataFactory && WasmFactory === $9ef033443a74bee6$var$DOMWasmFactory && cMapUrl && standardFontDataUrl && wasmUrl && $9ef033443a74bee6$var$isValidFetchUrl(cMapUrl, document.baseURI) && $9ef033443a74bee6$var$isValidFetchUrl(standardFontDataUrl, document.baseURI) && $9ef033443a74bee6$var$isValidFetchUrl(wasmUrl, document.baseURI));
    const styleElement = null;
    $9ef033443a74bee6$var$setVerbosityLevel(verbosity);
    const transportFactory = {
        canvasFactory: new CanvasFactory({
            ownerDocument: ownerDocument,
            enableHWA: enableHWA
        }),
        filterFactory: new FilterFactory({
            docId: docId,
            ownerDocument: ownerDocument
        }),
        cMapReaderFactory: useWorkerFetch ? null : new CMapReaderFactory({
            baseUrl: cMapUrl,
            isCompressed: cMapPacked
        }),
        standardFontDataFactory: useWorkerFetch ? null : new StandardFontDataFactory({
            baseUrl: standardFontDataUrl
        }),
        wasmFactory: useWorkerFetch ? null : new WasmFactory({
            baseUrl: wasmUrl
        })
    };
    if (!worker) {
        worker = $9ef033443a74bee6$export$84e2e9f37426b265.create({
            verbosity: verbosity,
            port: $9ef033443a74bee6$export$edf38ba293eb934.workerPort
        });
        task._worker = worker;
    }
    const docParams = {
        docId: docId,
        apiVersion: "5.4.296",
        data: data,
        password: password,
        disableAutoFetch: disableAutoFetch,
        rangeChunkSize: rangeChunkSize,
        length: length,
        docBaseUrl: docBaseUrl,
        enableXfa: enableXfa,
        evaluatorOptions: {
            maxImageSize: maxImageSize,
            disableFontFace: disableFontFace,
            ignoreErrors: ignoreErrors,
            isEvalSupported: isEvalSupported,
            isOffscreenCanvasSupported: isOffscreenCanvasSupported,
            isImageDecoderSupported: isImageDecoderSupported,
            canvasMaxAreaInBytes: canvasMaxAreaInBytes,
            fontExtraProperties: fontExtraProperties,
            useSystemFonts: useSystemFonts,
            useWasm: useWasm,
            useWorkerFetch: useWorkerFetch,
            cMapUrl: cMapUrl,
            iccUrl: iccUrl,
            standardFontDataUrl: standardFontDataUrl,
            wasmUrl: wasmUrl
        }
    };
    const transportParams = {
        ownerDocument: ownerDocument,
        pdfBug: pdfBug,
        styleElement: styleElement,
        loadingParams: {
            disableAutoFetch: disableAutoFetch,
            enableXfa: enableXfa
        }
    };
    worker.promise.then(function() {
        if (task.destroyed) throw new Error("Loading aborted");
        if (worker.destroyed) throw new Error("Worker was destroyed");
        const workerIdPromise = worker.messageHandler.sendWithPromise("GetDocRequest", docParams, data ? [
            data.buffer
        ] : null);
        let networkStream;
        if (rangeTransport) networkStream = new $9ef033443a74bee6$var$PDFDataTransportStream(rangeTransport, {
            disableRange: disableRange,
            disableStream: disableStream
        });
        else if (!data) {
            if (!url) throw new Error("getDocument - no `url` parameter provided.");
            const NetworkStream = $9ef033443a74bee6$var$isValidFetchUrl(url) ? $9ef033443a74bee6$var$PDFFetchStream : $9ef033443a74bee6$var$isNodeJS ? $9ef033443a74bee6$var$PDFNodeStream : $9ef033443a74bee6$var$PDFNetworkStream;
            networkStream = new NetworkStream({
                url: url,
                length: length,
                httpHeaders: httpHeaders,
                withCredentials: withCredentials,
                rangeChunkSize: rangeChunkSize,
                disableRange: disableRange,
                disableStream: disableStream
            });
        }
        return workerIdPromise.then((workerId)=>{
            if (task.destroyed) throw new Error("Loading aborted");
            if (worker.destroyed) throw new Error("Worker was destroyed");
            const messageHandler = new $9ef033443a74bee6$var$MessageHandler(docId, workerId, worker.port);
            const transport = new $9ef033443a74bee6$var$WorkerTransport(messageHandler, task, networkStream, transportParams, transportFactory, enableHWA);
            task._transport = transport;
            messageHandler.send("Ready", null);
        });
    }).catch(task._capability.reject);
    return task;
}
class $9ef033443a74bee6$var$PDFDocumentLoadingTask {
    static #docId = 0;
    _capability = Promise.withResolvers();
    _transport = null;
    _worker = null;
    docId = `d${$9ef033443a74bee6$var$PDFDocumentLoadingTask.#docId++}`;
    destroyed = false;
    onPassword = null;
    onProgress = null;
    get promise() {
        return this._capability.promise;
    }
    async destroy() {
        this.destroyed = true;
        try {
            if (this._worker?.port) this._worker._pendingDestroy = true;
            await this._transport?.destroy();
        } catch (ex) {
            if (this._worker?.port) delete this._worker._pendingDestroy;
            throw ex;
        }
        this._transport = null;
        this._worker?.destroy();
        this._worker = null;
    }
    async getData() {
        return this._transport.getData();
    }
}
class $9ef033443a74bee6$export$c06899d9d7bce9ab {
    #capability = Promise.withResolvers();
    #progressiveDoneListeners = [];
    #progressiveReadListeners = [];
    #progressListeners = [];
    #rangeListeners = [];
    constructor(length, initialData, progressiveDone = false, contentDispositionFilename = null){
        this.length = length;
        this.initialData = initialData;
        this.progressiveDone = progressiveDone;
        this.contentDispositionFilename = contentDispositionFilename;
    }
    addRangeListener(listener) {
        this.#rangeListeners.push(listener);
    }
    addProgressListener(listener) {
        this.#progressListeners.push(listener);
    }
    addProgressiveReadListener(listener) {
        this.#progressiveReadListeners.push(listener);
    }
    addProgressiveDoneListener(listener) {
        this.#progressiveDoneListeners.push(listener);
    }
    onDataRange(begin, chunk) {
        for (const listener of this.#rangeListeners)listener(begin, chunk);
    }
    onDataProgress(loaded, total) {
        this.#capability.promise.then(()=>{
            for (const listener of this.#progressListeners)listener(loaded, total);
        });
    }
    onDataProgressiveRead(chunk) {
        this.#capability.promise.then(()=>{
            for (const listener of this.#progressiveReadListeners)listener(chunk);
        });
    }
    onDataProgressiveDone() {
        this.#capability.promise.then(()=>{
            for (const listener of this.#progressiveDoneListeners)listener();
        });
    }
    transportReady() {
        this.#capability.resolve();
    }
    requestDataRange(begin, end) {
        $9ef033443a74bee6$var$unreachable("Abstract method PDFDataRangeTransport.requestDataRange");
    }
    abort() {}
}
class $9ef033443a74bee6$var$PDFDocumentProxy {
    constructor(pdfInfo, transport){
        this._pdfInfo = pdfInfo;
        this._transport = transport;
    }
    get annotationStorage() {
        return this._transport.annotationStorage;
    }
    get canvasFactory() {
        return this._transport.canvasFactory;
    }
    get filterFactory() {
        return this._transport.filterFactory;
    }
    get numPages() {
        return this._pdfInfo.numPages;
    }
    get fingerprints() {
        return this._pdfInfo.fingerprints;
    }
    get isPureXfa() {
        return $9ef033443a74bee6$export$b8972b998723d602(this, "isPureXfa", !!this._transport._htmlForXfa);
    }
    get allXfaHtml() {
        return this._transport._htmlForXfa;
    }
    getPage(pageNumber) {
        return this._transport.getPage(pageNumber);
    }
    getPageIndex(ref) {
        return this._transport.getPageIndex(ref);
    }
    getDestinations() {
        return this._transport.getDestinations();
    }
    getDestination(id) {
        return this._transport.getDestination(id);
    }
    getPageLabels() {
        return this._transport.getPageLabels();
    }
    getPageLayout() {
        return this._transport.getPageLayout();
    }
    getPageMode() {
        return this._transport.getPageMode();
    }
    getViewerPreferences() {
        return this._transport.getViewerPreferences();
    }
    getOpenAction() {
        return this._transport.getOpenAction();
    }
    getAttachments() {
        return this._transport.getAttachments();
    }
    getAnnotationsByType(types, pageIndexesToSkip) {
        return this._transport.getAnnotationsByType(types, pageIndexesToSkip);
    }
    getJSActions() {
        return this._transport.getDocJSActions();
    }
    getOutline() {
        return this._transport.getOutline();
    }
    getOptionalContentConfig({ intent: intent = "display" } = {}) {
        const { renderingIntent: renderingIntent } = this._transport.getRenderingIntent(intent);
        return this._transport.getOptionalContentConfig(renderingIntent);
    }
    getPermissions() {
        return this._transport.getPermissions();
    }
    getMetadata() {
        return this._transport.getMetadata();
    }
    getMarkInfo() {
        return this._transport.getMarkInfo();
    }
    getData() {
        return this._transport.getData();
    }
    saveDocument() {
        return this._transport.saveDocument();
    }
    getDownloadInfo() {
        return this._transport.downloadInfoCapability.promise;
    }
    cleanup(keepLoadedFonts = false) {
        return this._transport.startCleanup(keepLoadedFonts || this.isPureXfa);
    }
    destroy() {
        return this.loadingTask.destroy();
    }
    cachedPageNumber(ref) {
        return this._transport.cachedPageNumber(ref);
    }
    get loadingParams() {
        return this._transport.loadingParams;
    }
    get loadingTask() {
        return this._transport.loadingTask;
    }
    getFieldObjects() {
        return this._transport.getFieldObjects();
    }
    hasJSActions() {
        return this._transport.hasJSActions();
    }
    getCalculationOrderIds() {
        return this._transport.getCalculationOrderIds();
    }
}
class $9ef033443a74bee6$var$PDFPageProxy {
    #pendingCleanup = false;
    constructor(pageIndex, pageInfo, transport, pdfBug = false){
        this._pageIndex = pageIndex;
        this._pageInfo = pageInfo;
        this._transport = transport;
        this._stats = pdfBug ? new $9ef033443a74bee6$var$StatTimer() : null;
        this._pdfBug = pdfBug;
        this.commonObjs = transport.commonObjs;
        this.objs = new $9ef033443a74bee6$var$PDFObjects();
        this._intentStates = new Map();
        this.destroyed = false;
        this.recordedBBoxes = null;
    }
    get pageNumber() {
        return this._pageIndex + 1;
    }
    get rotate() {
        return this._pageInfo.rotate;
    }
    get ref() {
        return this._pageInfo.ref;
    }
    get userUnit() {
        return this._pageInfo.userUnit;
    }
    get view() {
        return this._pageInfo.view;
    }
    getViewport({ scale: scale, rotation: rotation = this.rotate, offsetX: offsetX = 0, offsetY: offsetY = 0, dontFlip: dontFlip = false } = {}) {
        return new $9ef033443a74bee6$var$PageViewport({
            viewBox: this.view,
            userUnit: this.userUnit,
            scale: scale,
            rotation: rotation,
            offsetX: offsetX,
            offsetY: offsetY,
            dontFlip: dontFlip
        });
    }
    getAnnotations({ intent: intent = "display" } = {}) {
        const { renderingIntent: renderingIntent } = this._transport.getRenderingIntent(intent);
        return this._transport.getAnnotations(this._pageIndex, renderingIntent);
    }
    getJSActions() {
        return this._transport.getPageJSActions(this._pageIndex);
    }
    get filterFactory() {
        return this._transport.filterFactory;
    }
    get isPureXfa() {
        return $9ef033443a74bee6$export$b8972b998723d602(this, "isPureXfa", !!this._transport._htmlForXfa);
    }
    async getXfa() {
        return this._transport._htmlForXfa?.children[this._pageIndex] || null;
    }
    render({ canvasContext: canvasContext, canvas: canvas = canvasContext.canvas, viewport: viewport, intent: intent = "display", annotationMode: annotationMode = $9ef033443a74bee6$export$5a7af0c07e33392e.ENABLE, transform: transform = null, background: background = null, optionalContentConfigPromise: optionalContentConfigPromise = null, annotationCanvasMap: annotationCanvasMap = null, pageColors: pageColors = null, printAnnotationStorage: printAnnotationStorage = null, isEditing: isEditing = false, recordOperations: recordOperations = false, operationsFilter: operationsFilter = null }) {
        this._stats?.time("Overall");
        const intentArgs = this._transport.getRenderingIntent(intent, annotationMode, printAnnotationStorage, isEditing);
        const { renderingIntent: renderingIntent, cacheKey: cacheKey } = intentArgs;
        this.#pendingCleanup = false;
        optionalContentConfigPromise ||= this._transport.getOptionalContentConfig(renderingIntent);
        let intentState = this._intentStates.get(cacheKey);
        if (!intentState) {
            intentState = Object.create(null);
            this._intentStates.set(cacheKey, intentState);
        }
        if (intentState.streamReaderCancelTimeout) {
            clearTimeout(intentState.streamReaderCancelTimeout);
            intentState.streamReaderCancelTimeout = null;
        }
        const intentPrint = !!(renderingIntent & $9ef033443a74bee6$var$RenderingIntentFlag.PRINT);
        if (!intentState.displayReadyCapability) {
            intentState.displayReadyCapability = Promise.withResolvers();
            intentState.operatorList = {
                fnArray: [],
                argsArray: [],
                lastChunk: false,
                separateAnnots: null
            };
            this._stats?.time("Page Request");
            this._pumpOperatorList(intentArgs);
        }
        const recordForDebugger = Boolean(this._pdfBug && globalThis.StepperManager?.enabled);
        const shouldRecordOperations = !this.recordedBBoxes && (recordOperations || recordForDebugger);
        const complete = (error)=>{
            intentState.renderTasks.delete(internalRenderTask);
            if (shouldRecordOperations) {
                const recordedBBoxes = internalRenderTask.gfx?.dependencyTracker.take();
                if (recordedBBoxes) {
                    if (internalRenderTask.stepper) internalRenderTask.stepper.setOperatorBBoxes(recordedBBoxes, internalRenderTask.gfx.dependencyTracker.takeDebugMetadata());
                    if (recordOperations) this.recordedBBoxes = recordedBBoxes;
                }
            }
            if (intentPrint) this.#pendingCleanup = true;
            this.#tryCleanup();
            if (error) {
                internalRenderTask.capability.reject(error);
                this._abortOperatorList({
                    intentState: intentState,
                    reason: error instanceof Error ? error : new Error(error)
                });
            } else internalRenderTask.capability.resolve();
            if (this._stats) {
                this._stats.timeEnd("Rendering");
                this._stats.timeEnd("Overall");
                if (globalThis.Stats?.enabled) globalThis.Stats.add(this.pageNumber, this._stats);
            }
        };
        const internalRenderTask = new $9ef033443a74bee6$var$InternalRenderTask({
            callback: complete,
            params: {
                canvas: canvas,
                canvasContext: canvasContext,
                dependencyTracker: shouldRecordOperations ? new $9ef033443a74bee6$var$CanvasDependencyTracker(canvas, intentState.operatorList.length, recordForDebugger) : null,
                viewport: viewport,
                transform: transform,
                background: background
            },
            objs: this.objs,
            commonObjs: this.commonObjs,
            annotationCanvasMap: annotationCanvasMap,
            operatorList: intentState.operatorList,
            pageIndex: this._pageIndex,
            canvasFactory: this._transport.canvasFactory,
            filterFactory: this._transport.filterFactory,
            useRequestAnimationFrame: !intentPrint,
            pdfBug: this._pdfBug,
            pageColors: pageColors,
            enableHWA: this._transport.enableHWA,
            operationsFilter: operationsFilter
        });
        (intentState.renderTasks ||= new Set()).add(internalRenderTask);
        const renderTask = internalRenderTask.task;
        Promise.all([
            intentState.displayReadyCapability.promise,
            optionalContentConfigPromise
        ]).then(([transparency, optionalContentConfig])=>{
            if (this.destroyed) {
                complete();
                return;
            }
            this._stats?.time("Rendering");
            if (!(optionalContentConfig.renderingIntent & renderingIntent)) throw new Error("Must use the same `intent`-argument when calling the `PDFPageProxy.render` and `PDFDocumentProxy.getOptionalContentConfig` methods.");
            internalRenderTask.initializeGraphics({
                transparency: transparency,
                optionalContentConfig: optionalContentConfig
            });
            internalRenderTask.operatorListChanged();
        }).catch(complete);
        return renderTask;
    }
    getOperatorList({ intent: intent = "display", annotationMode: annotationMode = $9ef033443a74bee6$export$5a7af0c07e33392e.ENABLE, printAnnotationStorage: printAnnotationStorage = null, isEditing: isEditing = false } = {}) {
        function operatorListChanged() {
            if (intentState.operatorList.lastChunk) {
                intentState.opListReadCapability.resolve(intentState.operatorList);
                intentState.renderTasks.delete(opListTask);
            }
        }
        const intentArgs = this._transport.getRenderingIntent(intent, annotationMode, printAnnotationStorage, isEditing, true);
        let intentState = this._intentStates.get(intentArgs.cacheKey);
        if (!intentState) {
            intentState = Object.create(null);
            this._intentStates.set(intentArgs.cacheKey, intentState);
        }
        let opListTask;
        if (!intentState.opListReadCapability) {
            opListTask = Object.create(null);
            opListTask.operatorListChanged = operatorListChanged;
            intentState.opListReadCapability = Promise.withResolvers();
            (intentState.renderTasks ||= new Set()).add(opListTask);
            intentState.operatorList = {
                fnArray: [],
                argsArray: [],
                lastChunk: false,
                separateAnnots: null
            };
            this._stats?.time("Page Request");
            this._pumpOperatorList(intentArgs);
        }
        return intentState.opListReadCapability.promise;
    }
    streamTextContent({ includeMarkedContent: includeMarkedContent = false, disableNormalization: disableNormalization = false } = {}) {
        const TEXT_CONTENT_CHUNK_SIZE = 100;
        return this._transport.messageHandler.sendWithStream("GetTextContent", {
            pageIndex: this._pageIndex,
            includeMarkedContent: includeMarkedContent === true,
            disableNormalization: disableNormalization === true
        }, {
            highWaterMark: TEXT_CONTENT_CHUNK_SIZE,
            size (textContent) {
                return textContent.items.length;
            }
        });
    }
    getTextContent(params = {}) {
        if (this._transport._htmlForXfa) return this.getXfa().then((xfa)=>$9ef033443a74bee6$var$XfaText.textContent(xfa));
        const readableStream = this.streamTextContent(params);
        return new Promise(function(resolve, reject) {
            function pump() {
                reader.read().then(function({ value: value, done: done }) {
                    if (done) {
                        resolve(textContent);
                        return;
                    }
                    textContent.lang ??= value.lang;
                    Object.assign(textContent.styles, value.styles);
                    textContent.items.push(...value.items);
                    pump();
                }, reject);
            }
            const reader = readableStream.getReader();
            const textContent = {
                items: [],
                styles: Object.create(null),
                lang: null
            };
            pump();
        });
    }
    getStructTree() {
        return this._transport.getStructTree(this._pageIndex);
    }
    _destroy() {
        this.destroyed = true;
        const waitOn = [];
        for (const intentState of this._intentStates.values()){
            this._abortOperatorList({
                intentState: intentState,
                reason: new Error("Page was destroyed."),
                force: true
            });
            if (intentState.opListReadCapability) continue;
            for (const internalRenderTask of intentState.renderTasks){
                waitOn.push(internalRenderTask.completed);
                internalRenderTask.cancel();
            }
        }
        this.objs.clear();
        this.#pendingCleanup = false;
        return Promise.all(waitOn);
    }
    cleanup(resetStats = false) {
        this.#pendingCleanup = true;
        const success = this.#tryCleanup();
        if (resetStats && success) this._stats &&= new $9ef033443a74bee6$var$StatTimer();
        return success;
    }
    #tryCleanup() {
        if (!this.#pendingCleanup || this.destroyed) return false;
        for (const { renderTasks: renderTasks, operatorList: operatorList } of this._intentStates.values()){
            if (renderTasks.size > 0 || !operatorList.lastChunk) return false;
        }
        this._intentStates.clear();
        this.objs.clear();
        this.#pendingCleanup = false;
        return true;
    }
    _startRenderPage(transparency, cacheKey) {
        const intentState = this._intentStates.get(cacheKey);
        if (!intentState) return;
        this._stats?.timeEnd("Page Request");
        intentState.displayReadyCapability?.resolve(transparency);
    }
    _renderPageChunk(operatorListChunk, intentState) {
        for(let i = 0, ii = operatorListChunk.length; i < ii; i++){
            intentState.operatorList.fnArray.push(operatorListChunk.fnArray[i]);
            intentState.operatorList.argsArray.push(operatorListChunk.argsArray[i]);
        }
        intentState.operatorList.lastChunk = operatorListChunk.lastChunk;
        intentState.operatorList.separateAnnots = operatorListChunk.separateAnnots;
        for (const internalRenderTask of intentState.renderTasks)internalRenderTask.operatorListChanged();
        if (operatorListChunk.lastChunk) this.#tryCleanup();
    }
    _pumpOperatorList({ renderingIntent: renderingIntent, cacheKey: cacheKey, annotationStorageSerializable: annotationStorageSerializable, modifiedIds: modifiedIds }) {
        const { map: map, transfer: transfer } = annotationStorageSerializable;
        const readableStream = this._transport.messageHandler.sendWithStream("GetOperatorList", {
            pageIndex: this._pageIndex,
            intent: renderingIntent,
            cacheKey: cacheKey,
            annotationStorage: map,
            modifiedIds: modifiedIds
        }, transfer);
        const reader = readableStream.getReader();
        const intentState = this._intentStates.get(cacheKey);
        intentState.streamReader = reader;
        const pump = ()=>{
            reader.read().then(({ value: value, done: done })=>{
                if (done) {
                    intentState.streamReader = null;
                    return;
                }
                if (this._transport.destroyed) return;
                this._renderPageChunk(value, intentState);
                pump();
            }, (reason)=>{
                intentState.streamReader = null;
                if (this._transport.destroyed) return;
                if (intentState.operatorList) {
                    intentState.operatorList.lastChunk = true;
                    for (const internalRenderTask of intentState.renderTasks)internalRenderTask.operatorListChanged();
                    this.#tryCleanup();
                }
                if (intentState.displayReadyCapability) intentState.displayReadyCapability.reject(reason);
                else if (intentState.opListReadCapability) intentState.opListReadCapability.reject(reason);
                else throw reason;
            });
        };
        pump();
    }
    _abortOperatorList({ intentState: intentState, reason: reason, force: force = false }) {
        if (!intentState.streamReader) return;
        if (intentState.streamReaderCancelTimeout) {
            clearTimeout(intentState.streamReaderCancelTimeout);
            intentState.streamReaderCancelTimeout = null;
        }
        if (!force) {
            if (intentState.renderTasks.size > 0) return;
            if (reason instanceof $9ef033443a74bee6$export$245847d31c09154f) {
                let delay = $9ef033443a74bee6$var$RENDERING_CANCELLED_TIMEOUT;
                if (reason.extraDelay > 0 && reason.extraDelay < 1000) delay += reason.extraDelay;
                intentState.streamReaderCancelTimeout = setTimeout(()=>{
                    intentState.streamReaderCancelTimeout = null;
                    this._abortOperatorList({
                        intentState: intentState,
                        reason: reason,
                        force: true
                    });
                }, delay);
                return;
            }
        }
        intentState.streamReader.cancel(new $9ef033443a74bee6$export$d0e978393d193d1a(reason.message)).catch(()=>{});
        intentState.streamReader = null;
        if (this._transport.destroyed) return;
        for (const [curCacheKey, curIntentState] of this._intentStates)if (curIntentState === intentState) {
            this._intentStates.delete(curCacheKey);
            break;
        }
        this.cleanup();
    }
    get stats() {
        return this._stats;
    }
}
class $9ef033443a74bee6$export$84e2e9f37426b265 {
    #capability = Promise.withResolvers();
    #messageHandler = null;
    #port = null;
    #webWorker = null;
    static #fakeWorkerId = 0;
    static #isWorkerDisabled = false;
    static #workerPorts = new WeakMap();
    static{
        if ($9ef033443a74bee6$var$isNodeJS) {
            this.#isWorkerDisabled = true;
            $9ef033443a74bee6$export$edf38ba293eb934.workerSrc ||= "./pdf.worker.mjs";
        }
        this._isSameOrigin = (baseUrl, otherUrl)=>{
            const base = URL.parse(baseUrl);
            if (!base?.origin || base.origin === "null") return false;
            const other = new URL(otherUrl, base);
            return base.origin === other.origin;
        };
        this._createCDNWrapper = (url)=>{
            const wrapper = `await import("${url}");`;
            return URL.createObjectURL(new Blob([
                wrapper
            ], {
                type: "text/javascript"
            }));
        };
        this.fromPort = (params)=>{
            $9ef033443a74bee6$var$deprecated("`PDFWorker.fromPort` - please use `PDFWorker.create` instead.");
            if (!params?.port) throw new Error("PDFWorker.fromPort - invalid method signature.");
            return this.create(params);
        };
    }
    constructor({ name: name = null, port: port = null, verbosity: verbosity = $9ef033443a74bee6$var$getVerbosityLevel() } = {}){
        this.name = name;
        this.destroyed = false;
        this.verbosity = verbosity;
        if (port) {
            if ($9ef033443a74bee6$export$84e2e9f37426b265.#workerPorts.has(port)) throw new Error("Cannot use more than one PDFWorker per port.");
            $9ef033443a74bee6$export$84e2e9f37426b265.#workerPorts.set(port, this);
            this.#initializeFromPort(port);
        } else this.#initialize();
    }
    get promise() {
        return this.#capability.promise;
    }
    #resolve() {
        this.#capability.resolve();
        this.#messageHandler.send("configure", {
            verbosity: this.verbosity
        });
    }
    get port() {
        return this.#port;
    }
    get messageHandler() {
        return this.#messageHandler;
    }
    #initializeFromPort(port) {
        this.#port = port;
        this.#messageHandler = new $9ef033443a74bee6$var$MessageHandler("main", "worker", port);
        this.#messageHandler.on("ready", ()=>{});
        this.#resolve();
    }
    #initialize() {
        if ($9ef033443a74bee6$export$84e2e9f37426b265.#isWorkerDisabled || $9ef033443a74bee6$export$84e2e9f37426b265.#mainThreadWorkerMessageHandler) {
            this.#setupFakeWorker();
            return;
        }
        let { workerSrc: workerSrc } = $9ef033443a74bee6$export$84e2e9f37426b265;
        try {
            if (!$9ef033443a74bee6$export$84e2e9f37426b265._isSameOrigin(window.location, workerSrc)) workerSrc = $9ef033443a74bee6$export$84e2e9f37426b265._createCDNWrapper(new URL(workerSrc, window.location).href);
            const worker = new Worker(workerSrc, {
                type: "module"
            });
            const messageHandler = new $9ef033443a74bee6$var$MessageHandler("main", "worker", worker);
            const terminateEarly = ()=>{
                ac.abort();
                messageHandler.destroy();
                worker.terminate();
                if (this.destroyed) this.#capability.reject(new Error("Worker was destroyed"));
                else this.#setupFakeWorker();
            };
            const ac = new AbortController();
            worker.addEventListener("error", ()=>{
                if (!this.#webWorker) terminateEarly();
            }, {
                signal: ac.signal
            });
            messageHandler.on("test", (data)=>{
                ac.abort();
                if (this.destroyed || !data) {
                    terminateEarly();
                    return;
                }
                this.#messageHandler = messageHandler;
                this.#port = worker;
                this.#webWorker = worker;
                this.#resolve();
            });
            messageHandler.on("ready", (data)=>{
                ac.abort();
                if (this.destroyed) {
                    terminateEarly();
                    return;
                }
                try {
                    sendTest();
                } catch  {
                    this.#setupFakeWorker();
                }
            });
            const sendTest = ()=>{
                const testObj = new Uint8Array();
                messageHandler.send("test", testObj, [
                    testObj.buffer
                ]);
            };
            sendTest();
            return;
        } catch  {
            $9ef033443a74bee6$var$info("The worker has been disabled.");
        }
        this.#setupFakeWorker();
    }
    #setupFakeWorker() {
        if (!$9ef033443a74bee6$export$84e2e9f37426b265.#isWorkerDisabled) {
            $9ef033443a74bee6$var$warn("Setting up fake worker.");
            $9ef033443a74bee6$export$84e2e9f37426b265.#isWorkerDisabled = true;
        }
        $9ef033443a74bee6$export$84e2e9f37426b265._setupFakeWorkerGlobal.then((WorkerMessageHandler)=>{
            if (this.destroyed) {
                this.#capability.reject(new Error("Worker was destroyed"));
                return;
            }
            const port = new $9ef033443a74bee6$var$LoopbackPort();
            this.#port = port;
            const id = `fake${$9ef033443a74bee6$export$84e2e9f37426b265.#fakeWorkerId++}`;
            const workerHandler = new $9ef033443a74bee6$var$MessageHandler(id + "_worker", id, port);
            WorkerMessageHandler.setup(workerHandler, port);
            this.#messageHandler = new $9ef033443a74bee6$var$MessageHandler(id, id + "_worker", port);
            this.#resolve();
        }).catch((reason)=>{
            this.#capability.reject(new Error(`Setting up fake worker failed: "${reason.message}".`));
        });
    }
    destroy() {
        this.destroyed = true;
        this.#webWorker?.terminate();
        this.#webWorker = null;
        $9ef033443a74bee6$export$84e2e9f37426b265.#workerPorts.delete(this.#port);
        this.#port = null;
        this.#messageHandler?.destroy();
        this.#messageHandler = null;
    }
    static create(params) {
        const cachedPort = this.#workerPorts.get(params?.port);
        if (cachedPort) {
            if (cachedPort._pendingDestroy) throw new Error("PDFWorker.create - the worker is being destroyed.\nPlease remember to await `PDFDocumentLoadingTask.destroy()`-calls.");
            return cachedPort;
        }
        return new $9ef033443a74bee6$export$84e2e9f37426b265(params);
    }
    static get workerSrc() {
        if ($9ef033443a74bee6$export$edf38ba293eb934.workerSrc) return $9ef033443a74bee6$export$edf38ba293eb934.workerSrc;
        throw new Error('No "GlobalWorkerOptions.workerSrc" specified.');
    }
    static get #mainThreadWorkerMessageHandler() {
        try {
            return globalThis.pdfjsWorker?.WorkerMessageHandler || null;
        } catch  {
            return null;
        }
    }
    static get _setupFakeWorkerGlobal() {
        const loader = async ()=>{
            if (this.#mainThreadWorkerMessageHandler) return this.#mainThreadWorkerMessageHandler;
            const worker = await import(/*webpackIgnore: true*/ /*@vite-ignore*/ this.workerSrc);
            return worker.WorkerMessageHandler;
        };
        return $9ef033443a74bee6$export$b8972b998723d602(this, "_setupFakeWorkerGlobal", loader());
    }
}
class $9ef033443a74bee6$var$WorkerTransport {
    #methodPromises = new Map();
    #pageCache = new Map();
    #pagePromises = new Map();
    #pageRefCache = new Map();
    #passwordCapability = null;
    constructor(messageHandler, loadingTask, networkStream, params, factory, enableHWA){
        this.messageHandler = messageHandler;
        this.loadingTask = loadingTask;
        this.commonObjs = new $9ef033443a74bee6$var$PDFObjects();
        this.fontLoader = new $9ef033443a74bee6$var$FontLoader({
            ownerDocument: params.ownerDocument,
            styleElement: params.styleElement
        });
        this.loadingParams = params.loadingParams;
        this._params = params;
        this.canvasFactory = factory.canvasFactory;
        this.filterFactory = factory.filterFactory;
        this.cMapReaderFactory = factory.cMapReaderFactory;
        this.standardFontDataFactory = factory.standardFontDataFactory;
        this.wasmFactory = factory.wasmFactory;
        this.destroyed = false;
        this.destroyCapability = null;
        this._networkStream = networkStream;
        this._fullReader = null;
        this._lastProgress = null;
        this.downloadInfoCapability = Promise.withResolvers();
        this.enableHWA = enableHWA;
        this.setupMessageHandler();
    }
    #cacheSimpleMethod(name, data = null) {
        const cachedPromise = this.#methodPromises.get(name);
        if (cachedPromise) return cachedPromise;
        const promise = this.messageHandler.sendWithPromise(name, data);
        this.#methodPromises.set(name, promise);
        return promise;
    }
    get annotationStorage() {
        return $9ef033443a74bee6$export$b8972b998723d602(this, "annotationStorage", new $9ef033443a74bee6$var$AnnotationStorage());
    }
    getRenderingIntent(intent, annotationMode = $9ef033443a74bee6$export$5a7af0c07e33392e.ENABLE, printAnnotationStorage = null, isEditing = false, isOpList = false) {
        let renderingIntent = $9ef033443a74bee6$var$RenderingIntentFlag.DISPLAY;
        let annotationStorageSerializable = $9ef033443a74bee6$var$SerializableEmpty;
        switch(intent){
            case "any":
                renderingIntent = $9ef033443a74bee6$var$RenderingIntentFlag.ANY;
                break;
            case "display":
                break;
            case "print":
                renderingIntent = $9ef033443a74bee6$var$RenderingIntentFlag.PRINT;
                break;
            default:
                $9ef033443a74bee6$var$warn(`getRenderingIntent - invalid intent: ${intent}`);
        }
        const annotationStorage = renderingIntent & $9ef033443a74bee6$var$RenderingIntentFlag.PRINT && printAnnotationStorage instanceof $9ef033443a74bee6$var$PrintAnnotationStorage ? printAnnotationStorage : this.annotationStorage;
        switch(annotationMode){
            case $9ef033443a74bee6$export$5a7af0c07e33392e.DISABLE:
                renderingIntent += $9ef033443a74bee6$var$RenderingIntentFlag.ANNOTATIONS_DISABLE;
                break;
            case $9ef033443a74bee6$export$5a7af0c07e33392e.ENABLE:
                break;
            case $9ef033443a74bee6$export$5a7af0c07e33392e.ENABLE_FORMS:
                renderingIntent += $9ef033443a74bee6$var$RenderingIntentFlag.ANNOTATIONS_FORMS;
                break;
            case $9ef033443a74bee6$export$5a7af0c07e33392e.ENABLE_STORAGE:
                renderingIntent += $9ef033443a74bee6$var$RenderingIntentFlag.ANNOTATIONS_STORAGE;
                annotationStorageSerializable = annotationStorage.serializable;
                break;
            default:
                $9ef033443a74bee6$var$warn(`getRenderingIntent - invalid annotationMode: ${annotationMode}`);
        }
        if (isEditing) renderingIntent += $9ef033443a74bee6$var$RenderingIntentFlag.IS_EDITING;
        if (isOpList) renderingIntent += $9ef033443a74bee6$var$RenderingIntentFlag.OPLIST;
        const { ids: modifiedIds, hash: modifiedIdsHash } = annotationStorage.modifiedIds;
        const cacheKeyBuf = [
            renderingIntent,
            annotationStorageSerializable.hash,
            modifiedIdsHash
        ];
        return {
            renderingIntent: renderingIntent,
            cacheKey: cacheKeyBuf.join("_"),
            annotationStorageSerializable: annotationStorageSerializable,
            modifiedIds: modifiedIds
        };
    }
    destroy() {
        if (this.destroyCapability) return this.destroyCapability.promise;
        this.destroyed = true;
        this.destroyCapability = Promise.withResolvers();
        this.#passwordCapability?.reject(new Error("Worker was destroyed during onPassword callback"));
        const waitOn = [];
        for (const page of this.#pageCache.values())waitOn.push(page._destroy());
        this.#pageCache.clear();
        this.#pagePromises.clear();
        this.#pageRefCache.clear();
        if (this.hasOwnProperty("annotationStorage")) this.annotationStorage.resetModified();
        const terminated = this.messageHandler.sendWithPromise("Terminate", null);
        waitOn.push(terminated);
        Promise.all(waitOn).then(()=>{
            this.commonObjs.clear();
            this.fontLoader.clear();
            this.#methodPromises.clear();
            this.filterFactory.destroy();
            $9ef033443a74bee6$export$fdbdc423a78c5262.cleanup();
            this._networkStream?.cancelAllRequests(new $9ef033443a74bee6$export$d0e978393d193d1a("Worker was terminated."));
            this.messageHandler?.destroy();
            this.messageHandler = null;
            this.destroyCapability.resolve();
        }, this.destroyCapability.reject);
        return this.destroyCapability.promise;
    }
    setupMessageHandler() {
        const { messageHandler: messageHandler, loadingTask: loadingTask } = this;
        messageHandler.on("GetReader", (data, sink)=>{
            $9ef033443a74bee6$var$assert(this._networkStream, "GetReader - no `IPDFStream` instance available.");
            this._fullReader = this._networkStream.getFullReader();
            this._fullReader.onProgress = (evt)=>{
                this._lastProgress = {
                    loaded: evt.loaded,
                    total: evt.total
                };
            };
            sink.onPull = ()=>{
                this._fullReader.read().then(function({ value: value, done: done }) {
                    if (done) {
                        sink.close();
                        return;
                    }
                    $9ef033443a74bee6$var$assert(value instanceof ArrayBuffer, "GetReader - expected an ArrayBuffer.");
                    sink.enqueue(new Uint8Array(value), 1, [
                        value
                    ]);
                }).catch((reason)=>{
                    sink.error(reason);
                });
            };
            sink.onCancel = (reason)=>{
                this._fullReader.cancel(reason);
                sink.ready.catch((readyReason)=>{
                    if (this.destroyed) return;
                    throw readyReason;
                });
            };
        });
        messageHandler.on("ReaderHeadersReady", async (data)=>{
            await this._fullReader.headersReady;
            const { isStreamingSupported: isStreamingSupported, isRangeSupported: isRangeSupported, contentLength: contentLength } = this._fullReader;
            if (!isStreamingSupported || !isRangeSupported) {
                if (this._lastProgress) loadingTask.onProgress?.(this._lastProgress);
                this._fullReader.onProgress = (evt)=>{
                    loadingTask.onProgress?.({
                        loaded: evt.loaded,
                        total: evt.total
                    });
                };
            }
            return {
                isStreamingSupported: isStreamingSupported,
                isRangeSupported: isRangeSupported,
                contentLength: contentLength
            };
        });
        messageHandler.on("GetRangeReader", (data, sink)=>{
            $9ef033443a74bee6$var$assert(this._networkStream, "GetRangeReader - no `IPDFStream` instance available.");
            const rangeReader = this._networkStream.getRangeReader(data.begin, data.end);
            if (!rangeReader) {
                sink.close();
                return;
            }
            sink.onPull = ()=>{
                rangeReader.read().then(function({ value: value, done: done }) {
                    if (done) {
                        sink.close();
                        return;
                    }
                    $9ef033443a74bee6$var$assert(value instanceof ArrayBuffer, "GetRangeReader - expected an ArrayBuffer.");
                    sink.enqueue(new Uint8Array(value), 1, [
                        value
                    ]);
                }).catch((reason)=>{
                    sink.error(reason);
                });
            };
            sink.onCancel = (reason)=>{
                rangeReader.cancel(reason);
                sink.ready.catch((readyReason)=>{
                    if (this.destroyed) return;
                    throw readyReason;
                });
            };
        });
        messageHandler.on("GetDoc", ({ pdfInfo: pdfInfo })=>{
            this._numPages = pdfInfo.numPages;
            this._htmlForXfa = pdfInfo.htmlForXfa;
            delete pdfInfo.htmlForXfa;
            loadingTask._capability.resolve(new $9ef033443a74bee6$var$PDFDocumentProxy(pdfInfo, this));
        });
        messageHandler.on("DocException", (ex)=>{
            loadingTask._capability.reject($9ef033443a74bee6$var$wrapReason(ex));
        });
        messageHandler.on("PasswordRequest", (ex)=>{
            this.#passwordCapability = Promise.withResolvers();
            try {
                if (!loadingTask.onPassword) throw $9ef033443a74bee6$var$wrapReason(ex);
                const updatePassword = (password)=>{
                    if (password instanceof Error) this.#passwordCapability.reject(password);
                    else this.#passwordCapability.resolve({
                        password: password
                    });
                };
                loadingTask.onPassword(updatePassword, ex.code);
            } catch (err) {
                this.#passwordCapability.reject(err);
            }
            return this.#passwordCapability.promise;
        });
        messageHandler.on("DataLoaded", (data)=>{
            loadingTask.onProgress?.({
                loaded: data.length,
                total: data.length
            });
            this.downloadInfoCapability.resolve(data);
        });
        messageHandler.on("StartRenderPage", (data)=>{
            if (this.destroyed) return;
            const page = this.#pageCache.get(data.pageIndex);
            page._startRenderPage(data.transparency, data.cacheKey);
        });
        messageHandler.on("commonobj", ([id, type, exportedData])=>{
            if (this.destroyed) return null;
            if (this.commonObjs.has(id)) return null;
            switch(type){
                case "Font":
                    if ("error" in exportedData) {
                        const exportedError = exportedData.error;
                        $9ef033443a74bee6$var$warn(`Error during font loading: ${exportedError}`);
                        this.commonObjs.resolve(id, exportedError);
                        break;
                    }
                    const fontData = new $9ef033443a74bee6$var$FontInfo(exportedData);
                    const inspectFont = this._params.pdfBug && globalThis.FontInspector?.enabled ? (font, url)=>globalThis.FontInspector.fontAdded(font, url) : null;
                    const font = new $9ef033443a74bee6$var$FontFaceObject(fontData, inspectFont, exportedData.extra, exportedData.charProcOperatorList);
                    this.fontLoader.bind(font).catch(()=>messageHandler.sendWithPromise("FontFallback", {
                            id: id
                        })).finally(()=>{
                        if (!font.fontExtraProperties && font.data) font.clearData();
                        this.commonObjs.resolve(id, font);
                    });
                    break;
                case "CopyLocalImage":
                    const { imageRef: imageRef } = exportedData;
                    $9ef033443a74bee6$var$assert(imageRef, "The imageRef must be defined.");
                    for (const pageProxy of this.#pageCache.values())for (const [, data] of pageProxy.objs){
                        if (data?.ref !== imageRef) continue;
                        if (!data.dataLen) return null;
                        this.commonObjs.resolve(id, structuredClone(data));
                        return data.dataLen;
                    }
                    break;
                case "FontPath":
                case "Image":
                case "Pattern":
                    this.commonObjs.resolve(id, exportedData);
                    break;
                default:
                    throw new Error(`Got unknown common object type ${type}`);
            }
            return null;
        });
        messageHandler.on("obj", ([id, pageIndex, type, imageData])=>{
            if (this.destroyed) return;
            const pageProxy = this.#pageCache.get(pageIndex);
            if (pageProxy.objs.has(id)) return;
            if (pageProxy._intentStates.size === 0) {
                imageData?.bitmap?.close();
                return;
            }
            switch(type){
                case "Image":
                case "Pattern":
                    pageProxy.objs.resolve(id, imageData);
                    break;
                default:
                    throw new Error(`Got unknown object type ${type}`);
            }
        });
        messageHandler.on("DocProgress", (data)=>{
            if (this.destroyed) return;
            loadingTask.onProgress?.({
                loaded: data.loaded,
                total: data.total
            });
        });
        messageHandler.on("FetchBinaryData", async (data)=>{
            if (this.destroyed) throw new Error("Worker was destroyed.");
            const factory = this[data.type];
            if (!factory) throw new Error(`${data.type} not initialized, see the \`useWorkerFetch\` parameter.`);
            return factory.fetch(data);
        });
    }
    getData() {
        return this.messageHandler.sendWithPromise("GetData", null);
    }
    saveDocument() {
        if (this.annotationStorage.size <= 0) $9ef033443a74bee6$var$warn("saveDocument called while `annotationStorage` is empty, please use the getData-method instead.");
        const { map: map, transfer: transfer } = this.annotationStorage.serializable;
        return this.messageHandler.sendWithPromise("SaveDocument", {
            isPureXfa: !!this._htmlForXfa,
            numPages: this._numPages,
            annotationStorage: map,
            filename: this._fullReader?.filename ?? null
        }, transfer).finally(()=>{
            this.annotationStorage.resetModified();
        });
    }
    getPage(pageNumber) {
        if (!Number.isInteger(pageNumber) || pageNumber <= 0 || pageNumber > this._numPages) return Promise.reject(new Error("Invalid page request."));
        const pageIndex = pageNumber - 1, cachedPromise = this.#pagePromises.get(pageIndex);
        if (cachedPromise) return cachedPromise;
        const promise = this.messageHandler.sendWithPromise("GetPage", {
            pageIndex: pageIndex
        }).then((pageInfo)=>{
            if (this.destroyed) throw new Error("Transport destroyed");
            if (pageInfo.refStr) this.#pageRefCache.set(pageInfo.refStr, pageNumber);
            const page = new $9ef033443a74bee6$var$PDFPageProxy(pageIndex, pageInfo, this, this._params.pdfBug);
            this.#pageCache.set(pageIndex, page);
            return page;
        });
        this.#pagePromises.set(pageIndex, promise);
        return promise;
    }
    getPageIndex(ref) {
        if (!$9ef033443a74bee6$var$isRefProxy(ref)) return Promise.reject(new Error("Invalid pageIndex request."));
        return this.messageHandler.sendWithPromise("GetPageIndex", {
            num: ref.num,
            gen: ref.gen
        });
    }
    getAnnotations(pageIndex, intent) {
        return this.messageHandler.sendWithPromise("GetAnnotations", {
            pageIndex: pageIndex,
            intent: intent
        });
    }
    getFieldObjects() {
        return this.#cacheSimpleMethod("GetFieldObjects");
    }
    hasJSActions() {
        return this.#cacheSimpleMethod("HasJSActions");
    }
    getCalculationOrderIds() {
        return this.messageHandler.sendWithPromise("GetCalculationOrderIds", null);
    }
    getDestinations() {
        return this.messageHandler.sendWithPromise("GetDestinations", null);
    }
    getDestination(id) {
        if (typeof id !== "string") return Promise.reject(new Error("Invalid destination request."));
        return this.messageHandler.sendWithPromise("GetDestination", {
            id: id
        });
    }
    getPageLabels() {
        return this.messageHandler.sendWithPromise("GetPageLabels", null);
    }
    getPageLayout() {
        return this.messageHandler.sendWithPromise("GetPageLayout", null);
    }
    getPageMode() {
        return this.messageHandler.sendWithPromise("GetPageMode", null);
    }
    getViewerPreferences() {
        return this.messageHandler.sendWithPromise("GetViewerPreferences", null);
    }
    getOpenAction() {
        return this.messageHandler.sendWithPromise("GetOpenAction", null);
    }
    getAttachments() {
        return this.messageHandler.sendWithPromise("GetAttachments", null);
    }
    getAnnotationsByType(types, pageIndexesToSkip) {
        return this.messageHandler.sendWithPromise("GetAnnotationsByType", {
            types: types,
            pageIndexesToSkip: pageIndexesToSkip
        });
    }
    getDocJSActions() {
        return this.#cacheSimpleMethod("GetDocJSActions");
    }
    getPageJSActions(pageIndex) {
        return this.messageHandler.sendWithPromise("GetPageJSActions", {
            pageIndex: pageIndex
        });
    }
    getStructTree(pageIndex) {
        return this.messageHandler.sendWithPromise("GetStructTree", {
            pageIndex: pageIndex
        });
    }
    getOutline() {
        return this.messageHandler.sendWithPromise("GetOutline", null);
    }
    getOptionalContentConfig(renderingIntent) {
        return this.#cacheSimpleMethod("GetOptionalContentConfig").then((data)=>new $9ef033443a74bee6$var$OptionalContentConfig(data, renderingIntent));
    }
    getPermissions() {
        return this.messageHandler.sendWithPromise("GetPermissions", null);
    }
    getMetadata() {
        const name = "GetMetadata", cachedPromise = this.#methodPromises.get(name);
        if (cachedPromise) return cachedPromise;
        const promise = this.messageHandler.sendWithPromise(name, null).then((results)=>({
                info: results[0],
                metadata: results[1] ? new $9ef033443a74bee6$var$Metadata(results[1]) : null,
                contentDispositionFilename: this._fullReader?.filename ?? null,
                contentLength: this._fullReader?.contentLength ?? null
            }));
        this.#methodPromises.set(name, promise);
        return promise;
    }
    getMarkInfo() {
        return this.messageHandler.sendWithPromise("GetMarkInfo", null);
    }
    async startCleanup(keepLoadedFonts = false) {
        if (this.destroyed) return;
        await this.messageHandler.sendWithPromise("Cleanup", null);
        for (const page of this.#pageCache.values()){
            const cleanupSuccessful = page.cleanup();
            if (!cleanupSuccessful) throw new Error(`startCleanup: Page ${page.pageNumber} is currently rendering.`);
        }
        this.commonObjs.clear();
        if (!keepLoadedFonts) this.fontLoader.clear();
        this.#methodPromises.clear();
        this.filterFactory.destroy(true);
        $9ef033443a74bee6$export$fdbdc423a78c5262.cleanup();
    }
    cachedPageNumber(ref) {
        if (!$9ef033443a74bee6$var$isRefProxy(ref)) return null;
        const refStr = ref.gen === 0 ? `${ref.num}R` : `${ref.num}R${ref.gen}`;
        return this.#pageRefCache.get(refStr) ?? null;
    }
}
class $9ef033443a74bee6$var$RenderTask {
    #internalRenderTask = null;
    onContinue = null;
    onError = null;
    constructor(internalRenderTask){
        this.#internalRenderTask = internalRenderTask;
    }
    get promise() {
        return this.#internalRenderTask.capability.promise;
    }
    cancel(extraDelay = 0) {
        this.#internalRenderTask.cancel(null, extraDelay);
    }
    get separateAnnots() {
        const { separateAnnots: separateAnnots } = this.#internalRenderTask.operatorList;
        if (!separateAnnots) return false;
        const { annotationCanvasMap: annotationCanvasMap } = this.#internalRenderTask;
        return separateAnnots.form || separateAnnots.canvas && annotationCanvasMap?.size > 0;
    }
}
class $9ef033443a74bee6$var$InternalRenderTask {
    #rAF = null;
    static #canvasInUse = new WeakSet();
    constructor({ callback: callback, params: params, objs: objs, commonObjs: commonObjs, annotationCanvasMap: annotationCanvasMap, operatorList: operatorList, pageIndex: pageIndex, canvasFactory: canvasFactory, filterFactory: filterFactory, useRequestAnimationFrame: useRequestAnimationFrame = false, pdfBug: pdfBug = false, pageColors: pageColors = null, enableHWA: enableHWA = false, operationsFilter: operationsFilter = null }){
        this.callback = callback;
        this.params = params;
        this.objs = objs;
        this.commonObjs = commonObjs;
        this.annotationCanvasMap = annotationCanvasMap;
        this.operatorListIdx = null;
        this.operatorList = operatorList;
        this._pageIndex = pageIndex;
        this.canvasFactory = canvasFactory;
        this.filterFactory = filterFactory;
        this._pdfBug = pdfBug;
        this.pageColors = pageColors;
        this.running = false;
        this.graphicsReadyCallback = null;
        this.graphicsReady = false;
        this._useRequestAnimationFrame = useRequestAnimationFrame === true && typeof window !== "undefined";
        this.cancelled = false;
        this.capability = Promise.withResolvers();
        this.task = new $9ef033443a74bee6$var$RenderTask(this);
        this._cancelBound = this.cancel.bind(this);
        this._continueBound = this._continue.bind(this);
        this._scheduleNextBound = this._scheduleNext.bind(this);
        this._nextBound = this._next.bind(this);
        this._canvas = params.canvas;
        this._canvasContext = params.canvas ? null : params.canvasContext;
        this._enableHWA = enableHWA;
        this._dependencyTracker = params.dependencyTracker;
        this._operationsFilter = operationsFilter;
    }
    get completed() {
        return this.capability.promise.catch(function() {});
    }
    initializeGraphics({ transparency: transparency = false, optionalContentConfig: optionalContentConfig }) {
        if (this.cancelled) return;
        if (this._canvas) {
            if ($9ef033443a74bee6$var$InternalRenderTask.#canvasInUse.has(this._canvas)) throw new Error("Cannot use the same canvas during multiple render() operations. Use different canvas or ensure previous operations were cancelled or completed.");
            $9ef033443a74bee6$var$InternalRenderTask.#canvasInUse.add(this._canvas);
        }
        if (this._pdfBug && globalThis.StepperManager?.enabled) {
            this.stepper = globalThis.StepperManager.create(this._pageIndex);
            this.stepper.init(this.operatorList);
            this.stepper.nextBreakPoint = this.stepper.getNextBreakPoint();
        }
        const { viewport: viewport, transform: transform, background: background, dependencyTracker: dependencyTracker } = this.params;
        const canvasContext = this._canvasContext || this._canvas.getContext("2d", {
            alpha: false,
            willReadFrequently: !this._enableHWA
        });
        this.gfx = new $9ef033443a74bee6$var$CanvasGraphics(canvasContext, this.commonObjs, this.objs, this.canvasFactory, this.filterFactory, {
            optionalContentConfig: optionalContentConfig
        }, this.annotationCanvasMap, this.pageColors, dependencyTracker);
        this.gfx.beginDrawing({
            transform: transform,
            viewport: viewport,
            transparency: transparency,
            background: background
        });
        this.operatorListIdx = 0;
        this.graphicsReady = true;
        this.graphicsReadyCallback?.();
    }
    cancel(error = null, extraDelay = 0) {
        this.running = false;
        this.cancelled = true;
        this.gfx?.endDrawing();
        if (this.#rAF) {
            window.cancelAnimationFrame(this.#rAF);
            this.#rAF = null;
        }
        $9ef033443a74bee6$var$InternalRenderTask.#canvasInUse.delete(this._canvas);
        error ||= new $9ef033443a74bee6$export$245847d31c09154f(`Rendering cancelled, page ${this._pageIndex + 1}`, extraDelay);
        this.callback(error);
        this.task.onError?.(error);
    }
    operatorListChanged() {
        if (!this.graphicsReady) {
            this.graphicsReadyCallback ||= this._continueBound;
            return;
        }
        this.gfx.dependencyTracker?.growOperationsCount(this.operatorList.fnArray.length);
        this.stepper?.updateOperatorList(this.operatorList);
        if (this.running) return;
        this._continue();
    }
    _continue() {
        this.running = true;
        if (this.cancelled) return;
        if (this.task.onContinue) this.task.onContinue(this._scheduleNextBound);
        else this._scheduleNext();
    }
    _scheduleNext() {
        if (this._useRequestAnimationFrame) this.#rAF = window.requestAnimationFrame(()=>{
            this.#rAF = null;
            this._nextBound().catch(this._cancelBound);
        });
        else Promise.resolve().then(this._nextBound).catch(this._cancelBound);
    }
    async _next() {
        if (this.cancelled) return;
        this.operatorListIdx = this.gfx.executeOperatorList(this.operatorList, this.operatorListIdx, this._continueBound, this.stepper, this._operationsFilter);
        if (this.operatorListIdx === this.operatorList.argsArray.length) {
            this.running = false;
            if (this.operatorList.lastChunk) {
                this.gfx.endDrawing();
                $9ef033443a74bee6$var$InternalRenderTask.#canvasInUse.delete(this._canvas);
                this.callback();
            }
        }
    }
}
const $9ef033443a74bee6$export$83d89fbfd8236492 = "5.4.296";
const $9ef033443a74bee6$export$3f8fe6489e95757d = "f56dc8601";
class $9ef033443a74bee6$export$9feb1bc2e5f1ccb3 {
    #button = null;
    #buttonSwatch = null;
    #defaultColor;
    #dropdown = null;
    #dropdownWasFromKeyboard = false;
    #isMainColorPicker = false;
    #editor = null;
    #eventBus;
    #openDropdownAC = null;
    #uiManager = null;
    static #l10nColor = null;
    static get _keyboardManager() {
        return $9ef033443a74bee6$export$b8972b998723d602(this, "_keyboardManager", new $9ef033443a74bee6$var$KeyboardManager([
            [
                [
                    "Escape",
                    "mac+Escape"
                ],
                $9ef033443a74bee6$export$9feb1bc2e5f1ccb3.prototype._hideDropdownFromKeyboard
            ],
            [
                [
                    " ",
                    "mac+ "
                ],
                $9ef033443a74bee6$export$9feb1bc2e5f1ccb3.prototype._colorSelectFromKeyboard
            ],
            [
                [
                    "ArrowDown",
                    "ArrowRight",
                    "mac+ArrowDown",
                    "mac+ArrowRight"
                ],
                $9ef033443a74bee6$export$9feb1bc2e5f1ccb3.prototype._moveToNext
            ],
            [
                [
                    "ArrowUp",
                    "ArrowLeft",
                    "mac+ArrowUp",
                    "mac+ArrowLeft"
                ],
                $9ef033443a74bee6$export$9feb1bc2e5f1ccb3.prototype._moveToPrevious
            ],
            [
                [
                    "Home",
                    "mac+Home"
                ],
                $9ef033443a74bee6$export$9feb1bc2e5f1ccb3.prototype._moveToBeginning
            ],
            [
                [
                    "End",
                    "mac+End"
                ],
                $9ef033443a74bee6$export$9feb1bc2e5f1ccb3.prototype._moveToEnd
            ]
        ]));
    }
    constructor({ editor: editor = null, uiManager: uiManager = null }){
        if (editor) {
            this.#isMainColorPicker = false;
            this.#editor = editor;
        } else this.#isMainColorPicker = true;
        this.#uiManager = editor?._uiManager || uiManager;
        this.#eventBus = this.#uiManager._eventBus;
        this.#defaultColor = editor?.color?.toUpperCase() || this.#uiManager?.highlightColors.values().next().value || "#FFFF98";
        $9ef033443a74bee6$export$9feb1bc2e5f1ccb3.#l10nColor ||= Object.freeze({
            blue: "pdfjs-editor-colorpicker-blue",
            green: "pdfjs-editor-colorpicker-green",
            pink: "pdfjs-editor-colorpicker-pink",
            red: "pdfjs-editor-colorpicker-red",
            yellow: "pdfjs-editor-colorpicker-yellow"
        });
    }
    renderButton() {
        const button = this.#button = document.createElement("button");
        button.className = "colorPicker";
        button.tabIndex = "0";
        button.setAttribute("data-l10n-id", "pdfjs-editor-colorpicker-button");
        button.ariaHasPopup = "true";
        if (this.#editor) button.ariaControls = `${this.#editor.id}_colorpicker_dropdown`;
        const signal = this.#uiManager._signal;
        button.addEventListener("click", this.#openDropdown.bind(this), {
            signal: signal
        });
        button.addEventListener("keydown", this.#keyDown.bind(this), {
            signal: signal
        });
        const swatch = this.#buttonSwatch = document.createElement("span");
        swatch.className = "swatch";
        swatch.ariaHidden = "true";
        swatch.style.backgroundColor = this.#defaultColor;
        button.append(swatch);
        return button;
    }
    renderMainDropdown() {
        const dropdown = this.#dropdown = this.#getDropdownRoot();
        dropdown.ariaOrientation = "horizontal";
        dropdown.ariaLabelledBy = "highlightColorPickerLabel";
        return dropdown;
    }
    #getDropdownRoot() {
        const div = document.createElement("div");
        const signal = this.#uiManager._signal;
        div.addEventListener("contextmenu", $9ef033443a74bee6$export$455b7811f904cadc, {
            signal: signal
        });
        div.className = "dropdown";
        div.role = "listbox";
        div.ariaMultiSelectable = "false";
        div.ariaOrientation = "vertical";
        div.setAttribute("data-l10n-id", "pdfjs-editor-colorpicker-dropdown");
        if (this.#editor) div.id = `${this.#editor.id}_colorpicker_dropdown`;
        for (const [name, color] of this.#uiManager.highlightColors){
            const button = document.createElement("button");
            button.tabIndex = "0";
            button.role = "option";
            button.setAttribute("data-color", color);
            button.title = name;
            button.setAttribute("data-l10n-id", $9ef033443a74bee6$export$9feb1bc2e5f1ccb3.#l10nColor[name]);
            const swatch = document.createElement("span");
            button.append(swatch);
            swatch.className = "swatch";
            swatch.style.backgroundColor = color;
            button.ariaSelected = color === this.#defaultColor;
            button.addEventListener("click", this.#colorSelect.bind(this, color), {
                signal: signal
            });
            div.append(button);
        }
        div.addEventListener("keydown", this.#keyDown.bind(this), {
            signal: signal
        });
        return div;
    }
    #colorSelect(color, event) {
        event.stopPropagation();
        this.#eventBus.dispatch("switchannotationeditorparams", {
            source: this,
            type: $9ef033443a74bee6$export$cf3df2a6ecc26692.HIGHLIGHT_COLOR,
            value: color
        });
        this.updateColor(color);
    }
    _colorSelectFromKeyboard(event) {
        if (event.target === this.#button) {
            this.#openDropdown(event);
            return;
        }
        const color = event.target.getAttribute("data-color");
        if (!color) return;
        this.#colorSelect(color, event);
    }
    _moveToNext(event) {
        if (!this.#isDropdownVisible) {
            this.#openDropdown(event);
            return;
        }
        if (event.target === this.#button) {
            this.#dropdown.firstChild?.focus();
            return;
        }
        event.target.nextSibling?.focus();
    }
    _moveToPrevious(event) {
        if (event.target === this.#dropdown?.firstChild || event.target === this.#button) {
            if (this.#isDropdownVisible) this._hideDropdownFromKeyboard();
            return;
        }
        if (!this.#isDropdownVisible) this.#openDropdown(event);
        event.target.previousSibling?.focus();
    }
    _moveToBeginning(event) {
        if (!this.#isDropdownVisible) {
            this.#openDropdown(event);
            return;
        }
        this.#dropdown.firstChild?.focus();
    }
    _moveToEnd(event) {
        if (!this.#isDropdownVisible) {
            this.#openDropdown(event);
            return;
        }
        this.#dropdown.lastChild?.focus();
    }
    #keyDown(event) {
        $9ef033443a74bee6$export$9feb1bc2e5f1ccb3._keyboardManager.exec(this, event);
    }
    #openDropdown(event) {
        if (this.#isDropdownVisible) {
            this.hideDropdown();
            return;
        }
        this.#dropdownWasFromKeyboard = event.detail === 0;
        if (!this.#openDropdownAC) {
            this.#openDropdownAC = new AbortController();
            window.addEventListener("pointerdown", this.#pointerDown.bind(this), {
                signal: this.#uiManager.combinedSignal(this.#openDropdownAC)
            });
        }
        this.#button.ariaExpanded = "true";
        if (this.#dropdown) {
            this.#dropdown.classList.remove("hidden");
            return;
        }
        const root = this.#dropdown = this.#getDropdownRoot();
        this.#button.append(root);
    }
    #pointerDown(event) {
        if (this.#dropdown?.contains(event.target)) return;
        this.hideDropdown();
    }
    hideDropdown() {
        this.#dropdown?.classList.add("hidden");
        this.#button.ariaExpanded = "false";
        this.#openDropdownAC?.abort();
        this.#openDropdownAC = null;
    }
    get #isDropdownVisible() {
        return this.#dropdown && !this.#dropdown.classList.contains("hidden");
    }
    _hideDropdownFromKeyboard() {
        if (this.#isMainColorPicker) return;
        if (!this.#isDropdownVisible) {
            this.#editor?.unselect();
            return;
        }
        this.hideDropdown();
        this.#button.focus({
            preventScroll: true,
            focusVisible: this.#dropdownWasFromKeyboard
        });
    }
    updateColor(color) {
        if (this.#buttonSwatch) this.#buttonSwatch.style.backgroundColor = color;
        if (!this.#dropdown) return;
        const i = this.#uiManager.highlightColors.values();
        for (const child of this.#dropdown.children)child.ariaSelected = i.next().value === color.toUpperCase();
    }
    destroy() {
        this.#button?.remove();
        this.#button = null;
        this.#buttonSwatch = null;
        this.#dropdown?.remove();
        this.#dropdown = null;
    }
}
class $9ef033443a74bee6$var$BasicColorPicker {
    #input = null;
    #editor = null;
    #uiManager = null;
    static #l10nColor = null;
    constructor(editor){
        this.#editor = editor;
        this.#uiManager = editor._uiManager;
        $9ef033443a74bee6$var$BasicColorPicker.#l10nColor ||= Object.freeze({
            freetext: "pdfjs-editor-color-picker-free-text-input",
            ink: "pdfjs-editor-color-picker-ink-input"
        });
    }
    renderButton() {
        if (this.#input) return this.#input;
        const { editorType: editorType, colorType: colorType, colorValue: colorValue } = this.#editor;
        const input = this.#input = document.createElement("input");
        input.type = "color";
        input.value = colorValue || "#000000";
        input.className = "basicColorPicker";
        input.tabIndex = 0;
        input.setAttribute("data-l10n-id", $9ef033443a74bee6$var$BasicColorPicker.#l10nColor[editorType]);
        input.addEventListener("input", ()=>{
            this.#uiManager.updateParams(colorType, input.value);
        }, {
            signal: this.#uiManager._signal
        });
        return input;
    }
    update(value) {
        if (!this.#input) return;
        this.#input.value = value;
    }
    destroy() {
        this.#input?.remove();
        this.#input = null;
    }
    hideDropdown() {}
}
function $9ef033443a74bee6$var$makeColorComp(n) {
    return Math.floor(Math.max(0, Math.min(1, n)) * 255).toString(16).padStart(2, "0");
}
function $9ef033443a74bee6$var$scaleAndClamp(x) {
    return Math.max(0, Math.min(255, 255 * x));
}
class $9ef033443a74bee6$var$ColorConverters {
    static CMYK_G([c, y, m, k]) {
        return [
            "G",
            1 - Math.min(1, 0.3 * c + 0.59 * m + 0.11 * y + k)
        ];
    }
    static G_CMYK([g]) {
        return [
            "CMYK",
            0,
            0,
            0,
            1 - g
        ];
    }
    static G_RGB([g]) {
        return [
            "RGB",
            g,
            g,
            g
        ];
    }
    static G_rgb([g]) {
        g = $9ef033443a74bee6$var$scaleAndClamp(g);
        return [
            g,
            g,
            g
        ];
    }
    static G_HTML([g]) {
        const G = $9ef033443a74bee6$var$makeColorComp(g);
        return `#${G}${G}${G}`;
    }
    static RGB_G([r, g, b]) {
        return [
            "G",
            0.3 * r + 0.59 * g + 0.11 * b
        ];
    }
    static RGB_rgb(color) {
        return color.map($9ef033443a74bee6$var$scaleAndClamp);
    }
    static RGB_HTML(color) {
        return `#${color.map($9ef033443a74bee6$var$makeColorComp).join("")}`;
    }
    static T_HTML() {
        return "#00000000";
    }
    static T_rgb() {
        return [
            null
        ];
    }
    static CMYK_RGB([c, y, m, k]) {
        return [
            "RGB",
            1 - Math.min(1, c + k),
            1 - Math.min(1, m + k),
            1 - Math.min(1, y + k)
        ];
    }
    static CMYK_rgb([c, y, m, k]) {
        return [
            $9ef033443a74bee6$var$scaleAndClamp(1 - Math.min(1, c + k)),
            $9ef033443a74bee6$var$scaleAndClamp(1 - Math.min(1, m + k)),
            $9ef033443a74bee6$var$scaleAndClamp(1 - Math.min(1, y + k))
        ];
    }
    static CMYK_HTML(components) {
        const rgb = this.CMYK_RGB(components).slice(1);
        return this.RGB_HTML(rgb);
    }
    static RGB_CMYK([r, g, b]) {
        const c = 1 - r;
        const m = 1 - g;
        const y = 1 - b;
        const k = Math.min(c, m, y);
        return [
            "CMYK",
            c,
            m,
            y,
            k
        ];
    }
}
const $9ef033443a74bee6$var$DateFormats = /* unused pure expression or super */ null;
const $9ef033443a74bee6$var$TimeFormats = /* unused pure expression or super */ null;
class $9ef033443a74bee6$var$BaseSVGFactory {
    create(width, height, skipDimensions = false) {
        if (width <= 0 || height <= 0) throw new Error("Invalid SVG dimensions");
        const svg = this._createSVG("svg:svg");
        svg.setAttribute("version", "1.1");
        if (!skipDimensions) {
            svg.setAttribute("width", `${width}px`);
            svg.setAttribute("height", `${height}px`);
        }
        svg.setAttribute("preserveAspectRatio", "none");
        svg.setAttribute("viewBox", `0 0 ${width} ${height}`);
        return svg;
    }
    createElement(type) {
        if (typeof type !== "string") throw new Error("Invalid SVG element type");
        return this._createSVG(type);
    }
    _createSVG(type) {
        $9ef033443a74bee6$var$unreachable("Abstract method `_createSVG` called.");
    }
}
class $9ef033443a74bee6$export$425e69f00724e63a extends $9ef033443a74bee6$var$BaseSVGFactory {
    _createSVG(type) {
        return document.createElementNS($9ef033443a74bee6$var$SVG_NS, type);
    }
}
const $9ef033443a74bee6$var$annotation_layer_DEFAULT_FONT_SIZE = 9;
const $9ef033443a74bee6$var$GetElementsByNameSet = new WeakSet();
const $9ef033443a74bee6$var$TIMEZONE_OFFSET = new Date().getTimezoneOffset() * 60000;
class $9ef033443a74bee6$var$AnnotationElementFactory {
    static create(parameters) {
        const subtype = parameters.data.annotationType;
        switch(subtype){
            case $9ef033443a74bee6$export$f50c3066a53a6f2c.LINK:
                return new $9ef033443a74bee6$var$LinkAnnotationElement(parameters);
            case $9ef033443a74bee6$export$f50c3066a53a6f2c.TEXT:
                return new $9ef033443a74bee6$var$TextAnnotationElement(parameters);
            case $9ef033443a74bee6$export$f50c3066a53a6f2c.WIDGET:
                const fieldType = parameters.data.fieldType;
                switch(fieldType){
                    case "Tx":
                        return new $9ef033443a74bee6$var$TextWidgetAnnotationElement(parameters);
                    case "Btn":
                        if (parameters.data.radioButton) return new $9ef033443a74bee6$var$RadioButtonWidgetAnnotationElement(parameters);
                        else if (parameters.data.checkBox) return new $9ef033443a74bee6$var$CheckboxWidgetAnnotationElement(parameters);
                        return new $9ef033443a74bee6$var$PushButtonWidgetAnnotationElement(parameters);
                    case "Ch":
                        return new $9ef033443a74bee6$var$ChoiceWidgetAnnotationElement(parameters);
                    case "Sig":
                        return new $9ef033443a74bee6$var$SignatureWidgetAnnotationElement(parameters);
                }
                return new $9ef033443a74bee6$var$WidgetAnnotationElement(parameters);
            case $9ef033443a74bee6$export$f50c3066a53a6f2c.POPUP:
                return new $9ef033443a74bee6$var$PopupAnnotationElement(parameters);
            case $9ef033443a74bee6$export$f50c3066a53a6f2c.FREETEXT:
                return new $9ef033443a74bee6$var$FreeTextAnnotationElement(parameters);
            case $9ef033443a74bee6$export$f50c3066a53a6f2c.LINE:
                return new $9ef033443a74bee6$var$LineAnnotationElement(parameters);
            case $9ef033443a74bee6$export$f50c3066a53a6f2c.SQUARE:
                return new $9ef033443a74bee6$var$SquareAnnotationElement(parameters);
            case $9ef033443a74bee6$export$f50c3066a53a6f2c.CIRCLE:
                return new $9ef033443a74bee6$var$CircleAnnotationElement(parameters);
            case $9ef033443a74bee6$export$f50c3066a53a6f2c.POLYLINE:
                return new $9ef033443a74bee6$var$PolylineAnnotationElement(parameters);
            case $9ef033443a74bee6$export$f50c3066a53a6f2c.CARET:
                return new $9ef033443a74bee6$var$CaretAnnotationElement(parameters);
            case $9ef033443a74bee6$export$f50c3066a53a6f2c.INK:
                return new $9ef033443a74bee6$var$InkAnnotationElement(parameters);
            case $9ef033443a74bee6$export$f50c3066a53a6f2c.POLYGON:
                return new $9ef033443a74bee6$var$PolygonAnnotationElement(parameters);
            case $9ef033443a74bee6$export$f50c3066a53a6f2c.HIGHLIGHT:
                return new $9ef033443a74bee6$var$HighlightAnnotationElement(parameters);
            case $9ef033443a74bee6$export$f50c3066a53a6f2c.UNDERLINE:
                return new $9ef033443a74bee6$var$UnderlineAnnotationElement(parameters);
            case $9ef033443a74bee6$export$f50c3066a53a6f2c.SQUIGGLY:
                return new $9ef033443a74bee6$var$SquigglyAnnotationElement(parameters);
            case $9ef033443a74bee6$export$f50c3066a53a6f2c.STRIKEOUT:
                return new $9ef033443a74bee6$var$StrikeOutAnnotationElement(parameters);
            case $9ef033443a74bee6$export$f50c3066a53a6f2c.STAMP:
                return new $9ef033443a74bee6$var$StampAnnotationElement(parameters);
            case $9ef033443a74bee6$export$f50c3066a53a6f2c.FILEATTACHMENT:
                return new $9ef033443a74bee6$var$FileAttachmentAnnotationElement(parameters);
            default:
                return new $9ef033443a74bee6$var$AnnotationElement(parameters);
        }
    }
}
class $9ef033443a74bee6$var$AnnotationElement {
    #updates = null;
    #hasBorder = false;
    #popupElement = null;
    constructor(parameters, { isRenderable: isRenderable = false, ignoreBorder: ignoreBorder = false, createQuadrilaterals: createQuadrilaterals = false } = {}){
        this.isRenderable = isRenderable;
        this.data = parameters.data;
        this.layer = parameters.layer;
        this.linkService = parameters.linkService;
        this.downloadManager = parameters.downloadManager;
        this.imageResourcesPath = parameters.imageResourcesPath;
        this.renderForms = parameters.renderForms;
        this.svgFactory = parameters.svgFactory;
        this.annotationStorage = parameters.annotationStorage;
        this.enableComment = parameters.enableComment;
        this.enableScripting = parameters.enableScripting;
        this.hasJSActions = parameters.hasJSActions;
        this._fieldObjects = parameters.fieldObjects;
        this.parent = parameters.parent;
        if (isRenderable) this.container = this._createContainer(ignoreBorder);
        if (createQuadrilaterals) this._createQuadrilaterals();
    }
    static _hasPopupData({ contentsObj: contentsObj, richText: richText }) {
        return !!(contentsObj?.str || richText?.str);
    }
    get _isEditable() {
        return this.data.isEditable;
    }
    get hasPopupData() {
        return $9ef033443a74bee6$var$AnnotationElement._hasPopupData(this.data) || this.enableComment && !!this.commentText;
    }
    get commentData() {
        const { data: data } = this;
        const editor = this.annotationStorage?.getEditor(data.id);
        if (editor) return editor.getData();
        return data;
    }
    get hasCommentButton() {
        return this.enableComment && this.hasPopupElement;
    }
    get commentButtonPosition() {
        const editor = this.annotationStorage?.getEditor(this.data.id);
        if (editor) return editor.commentButtonPositionInPage;
        const { quadPoints: quadPoints, inkLists: inkLists, rect: rect } = this.data;
        let maxX = -Infinity;
        let maxY = -Infinity;
        if (quadPoints?.length >= 8) {
            for(let i = 0; i < quadPoints.length; i += 8){
                if (quadPoints[i + 1] > maxY) {
                    maxY = quadPoints[i + 1];
                    maxX = quadPoints[i + 2];
                } else if (quadPoints[i + 1] === maxY) maxX = Math.max(maxX, quadPoints[i + 2]);
            }
            return [
                maxX,
                maxY
            ];
        }
        if (inkLists?.length >= 1) {
            for (const inkList of inkLists)for(let i = 0, ii = inkList.length; i < ii; i += 2){
                if (inkList[i + 1] > maxY) {
                    maxY = inkList[i + 1];
                    maxX = inkList[i];
                } else if (inkList[i + 1] === maxY) maxX = Math.max(maxX, inkList[i]);
            }
            if (maxX !== Infinity) return [
                maxX,
                maxY
            ];
        }
        if (rect) return [
            rect[2],
            rect[3]
        ];
        return null;
    }
    _normalizePoint(point) {
        const { page: { view: view }, viewport: { rawDims: { pageWidth: pageWidth, pageHeight: pageHeight, pageX: pageX, pageY: pageY } } } = this.parent;
        point[1] = view[3] - point[1] + view[1];
        point[0] = 100 * (point[0] - pageX) / pageWidth;
        point[1] = 100 * (point[1] - pageY) / pageHeight;
        return point;
    }
    get commentText() {
        const { data: data } = this;
        return this.annotationStorage.getRawValue(`${$9ef033443a74bee6$var$AnnotationEditorPrefix}${data.id}`)?.popup?.contents || data.contentsObj?.str || "";
    }
    set commentText(text) {
        const { data: data } = this;
        const popup = {
            deleted: !text,
            contents: text || ""
        };
        if (!this.annotationStorage.updateEditor(data.id, {
            popup: popup
        })) this.annotationStorage.setValue(`${$9ef033443a74bee6$var$AnnotationEditorPrefix}${data.id}`, {
            id: data.id,
            annotationType: data.annotationType,
            pageIndex: this.parent.page._pageIndex,
            popup: popup,
            popupRef: data.popupRef,
            modificationDate: new Date()
        });
        if (!text) this.removePopup();
    }
    removePopup() {
        (this.#popupElement?.popup || this.popup)?.remove();
        this.#popupElement = this.popup = null;
    }
    updateEdited(params) {
        if (!this.container) return;
        if (params.rect) this.#updates ||= {
            rect: this.data.rect.slice(0)
        };
        const { rect: rect, popup: newPopup } = params;
        if (rect) this.#setRectEdited(rect);
        let popup = this.#popupElement?.popup || this.popup;
        if (!popup && newPopup?.text) {
            this._createPopup(newPopup);
            popup = this.#popupElement.popup;
        }
        if (!popup) return;
        popup.updateEdited(params);
        if (newPopup?.deleted) {
            popup.remove();
            this.#popupElement = null;
            this.popup = null;
        }
    }
    resetEdited() {
        if (!this.#updates) return;
        this.#setRectEdited(this.#updates.rect);
        this.#popupElement?.popup.resetEdited();
        this.#updates = null;
    }
    #setRectEdited(rect) {
        const { container: { style: style }, data: { rect: currentRect, rotation: rotation }, parent: { viewport: { rawDims: { pageWidth: pageWidth, pageHeight: pageHeight, pageX: pageX, pageY: pageY } } } } = this;
        currentRect?.splice(0, 4, ...rect);
        style.left = `${100 * (rect[0] - pageX) / pageWidth}%`;
        style.top = `${100 * (pageHeight - rect[3] + pageY) / pageHeight}%`;
        if (rotation === 0) {
            style.width = `${100 * (rect[2] - rect[0]) / pageWidth}%`;
            style.height = `${100 * (rect[3] - rect[1]) / pageHeight}%`;
        } else this.setRotation(rotation);
    }
    _createContainer(ignoreBorder) {
        const { data: data, parent: { page: page, viewport: viewport } } = this;
        const container = document.createElement("section");
        container.setAttribute("data-annotation-id", data.id);
        if (!(this instanceof $9ef033443a74bee6$var$WidgetAnnotationElement) && !(this instanceof $9ef033443a74bee6$var$LinkAnnotationElement)) container.tabIndex = 0;
        const { style: style } = container;
        style.zIndex = this.parent.zIndex;
        this.parent.zIndex += 2;
        if (data.alternativeText) container.title = data.alternativeText;
        if (data.noRotate) container.classList.add("norotate");
        if (!data.rect || this instanceof $9ef033443a74bee6$var$PopupAnnotationElement) {
            const { rotation: rotation } = data;
            if (!data.hasOwnCanvas && rotation !== 0) this.setRotation(rotation, container);
            return container;
        }
        const { width: width, height: height } = this;
        if (!ignoreBorder && data.borderStyle.width > 0) {
            style.borderWidth = `${data.borderStyle.width}px`;
            const horizontalRadius = data.borderStyle.horizontalCornerRadius;
            const verticalRadius = data.borderStyle.verticalCornerRadius;
            if (horizontalRadius > 0 || verticalRadius > 0) {
                const radius = `calc(${horizontalRadius}px * var(--total-scale-factor)) / calc(${verticalRadius}px * var(--total-scale-factor))`;
                style.borderRadius = radius;
            } else if (this instanceof $9ef033443a74bee6$var$RadioButtonWidgetAnnotationElement) {
                const radius = `calc(${width}px * var(--total-scale-factor)) / calc(${height}px * var(--total-scale-factor))`;
                style.borderRadius = radius;
            }
            switch(data.borderStyle.style){
                case $9ef033443a74bee6$var$AnnotationBorderStyleType.SOLID:
                    style.borderStyle = "solid";
                    break;
                case $9ef033443a74bee6$var$AnnotationBorderStyleType.DASHED:
                    style.borderStyle = "dashed";
                    break;
                case $9ef033443a74bee6$var$AnnotationBorderStyleType.BEVELED:
                    $9ef033443a74bee6$var$warn("Unimplemented border style: beveled");
                    break;
                case $9ef033443a74bee6$var$AnnotationBorderStyleType.INSET:
                    $9ef033443a74bee6$var$warn("Unimplemented border style: inset");
                    break;
                case $9ef033443a74bee6$var$AnnotationBorderStyleType.UNDERLINE:
                    style.borderBottomStyle = "solid";
                    break;
                default:
                    break;
            }
            const borderColor = data.borderColor || null;
            if (borderColor) {
                this.#hasBorder = true;
                style.borderColor = $9ef033443a74bee6$export$f8f26dd395d7e1bd.makeHexColor(borderColor[0] | 0, borderColor[1] | 0, borderColor[2] | 0);
            } else style.borderWidth = 0;
        }
        const rect = $9ef033443a74bee6$export$f8f26dd395d7e1bd.normalizeRect([
            data.rect[0],
            page.view[3] - data.rect[1] + page.view[1],
            data.rect[2],
            page.view[3] - data.rect[3] + page.view[1]
        ]);
        const { pageWidth: pageWidth, pageHeight: pageHeight, pageX: pageX, pageY: pageY } = viewport.rawDims;
        style.left = `${100 * (rect[0] - pageX) / pageWidth}%`;
        style.top = `${100 * (rect[1] - pageY) / pageHeight}%`;
        const { rotation: rotation } = data;
        if (data.hasOwnCanvas || rotation === 0) {
            style.width = `${100 * width / pageWidth}%`;
            style.height = `${100 * height / pageHeight}%`;
        } else this.setRotation(rotation, container);
        return container;
    }
    setRotation(angle, container = this.container) {
        if (!this.data.rect) return;
        const { pageWidth: pageWidth, pageHeight: pageHeight } = this.parent.viewport.rawDims;
        let { width: width, height: height } = this;
        if (angle % 180 !== 0) [width, height] = [
            height,
            width
        ];
        container.style.width = `${100 * width / pageWidth}%`;
        container.style.height = `${100 * height / pageHeight}%`;
        container.setAttribute("data-main-rotation", (360 - angle) % 360);
    }
    get _commonActions() {
        const setColor = (jsName, styleName, event)=>{
            const color = event.detail[jsName];
            const colorType = color[0];
            const colorArray = color.slice(1);
            event.target.style[styleName] = $9ef033443a74bee6$var$ColorConverters[`${colorType}_HTML`](colorArray);
            this.annotationStorage.setValue(this.data.id, {
                [styleName]: $9ef033443a74bee6$var$ColorConverters[`${colorType}_rgb`](colorArray)
            });
        };
        return $9ef033443a74bee6$export$b8972b998723d602(this, "_commonActions", {
            display: (event)=>{
                const { display: display } = event.detail;
                const hidden = display % 2 === 1;
                this.container.style.visibility = hidden ? "hidden" : "visible";
                this.annotationStorage.setValue(this.data.id, {
                    noView: hidden,
                    noPrint: display === 1 || display === 2
                });
            },
            print: (event)=>{
                this.annotationStorage.setValue(this.data.id, {
                    noPrint: !event.detail.print
                });
            },
            hidden: (event)=>{
                const { hidden: hidden } = event.detail;
                this.container.style.visibility = hidden ? "hidden" : "visible";
                this.annotationStorage.setValue(this.data.id, {
                    noPrint: hidden,
                    noView: hidden
                });
            },
            focus: (event)=>{
                setTimeout(()=>event.target.focus({
                        preventScroll: false
                    }), 0);
            },
            userName: (event)=>{
                event.target.title = event.detail.userName;
            },
            readonly: (event)=>{
                event.target.disabled = event.detail.readonly;
            },
            required: (event)=>{
                this._setRequired(event.target, event.detail.required);
            },
            bgColor: (event)=>{
                setColor("bgColor", "backgroundColor", event);
            },
            fillColor: (event)=>{
                setColor("fillColor", "backgroundColor", event);
            },
            fgColor: (event)=>{
                setColor("fgColor", "color", event);
            },
            textColor: (event)=>{
                setColor("textColor", "color", event);
            },
            borderColor: (event)=>{
                setColor("borderColor", "borderColor", event);
            },
            strokeColor: (event)=>{
                setColor("strokeColor", "borderColor", event);
            },
            rotation: (event)=>{
                const angle = event.detail.rotation;
                this.setRotation(angle);
                this.annotationStorage.setValue(this.data.id, {
                    rotation: angle
                });
            }
        });
    }
    _dispatchEventFromSandbox(actions, jsEvent) {
        const commonActions = this._commonActions;
        for (const name of Object.keys(jsEvent.detail)){
            const action = actions[name] || commonActions[name];
            action?.(jsEvent);
        }
    }
    _setDefaultPropertiesFromJS(element) {
        if (!this.enableScripting) return;
        const storedData = this.annotationStorage.getRawValue(this.data.id);
        if (!storedData) return;
        const commonActions = this._commonActions;
        for (const [actionName, detail] of Object.entries(storedData)){
            const action = commonActions[actionName];
            if (action) {
                const eventProxy = {
                    detail: {
                        [actionName]: detail
                    },
                    target: element
                };
                action(eventProxy);
                delete storedData[actionName];
            }
        }
    }
    _createQuadrilaterals() {
        if (!this.container) return;
        const { quadPoints: quadPoints } = this.data;
        if (!quadPoints) return;
        const [rectBlX, rectBlY, rectTrX, rectTrY] = this.data.rect.map((x)=>Math.fround(x));
        if (quadPoints.length === 8) {
            const [trX, trY, blX, blY] = quadPoints.subarray(2, 6);
            if (rectTrX === trX && rectTrY === trY && rectBlX === blX && rectBlY === blY) return;
        }
        const { style: style } = this.container;
        let svgBuffer;
        if (this.#hasBorder) {
            const { borderColor: borderColor, borderWidth: borderWidth } = style;
            style.borderWidth = 0;
            svgBuffer = [
                "url('data:image/svg+xml;utf8,",
                `<svg xmlns="http://www.w3.org/2000/svg"`,
                ` preserveAspectRatio="none" viewBox="0 0 1 1">`,
                `<g fill="transparent" stroke="${borderColor}" stroke-width="${borderWidth}">`
            ];
            this.container.classList.add("hasBorder");
        }
        const width = rectTrX - rectBlX;
        const height = rectTrY - rectBlY;
        const { svgFactory: svgFactory } = this;
        const svg = svgFactory.createElement("svg");
        svg.classList.add("quadrilateralsContainer");
        svg.setAttribute("width", 0);
        svg.setAttribute("height", 0);
        svg.role = "none";
        const defs = svgFactory.createElement("defs");
        svg.append(defs);
        const clipPath = svgFactory.createElement("clipPath");
        const id = `clippath_${this.data.id}`;
        clipPath.setAttribute("id", id);
        clipPath.setAttribute("clipPathUnits", "objectBoundingBox");
        defs.append(clipPath);
        for(let i = 2, ii = quadPoints.length; i < ii; i += 8){
            const trX = quadPoints[i];
            const trY = quadPoints[i + 1];
            const blX = quadPoints[i + 2];
            const blY = quadPoints[i + 3];
            const rect = svgFactory.createElement("rect");
            const x = (blX - rectBlX) / width;
            const y = (rectTrY - trY) / height;
            const rectWidth = (trX - blX) / width;
            const rectHeight = (trY - blY) / height;
            rect.setAttribute("x", x);
            rect.setAttribute("y", y);
            rect.setAttribute("width", rectWidth);
            rect.setAttribute("height", rectHeight);
            clipPath.append(rect);
            svgBuffer?.push(`<rect vector-effect="non-scaling-stroke" x="${x}" y="${y}" width="${rectWidth}" height="${rectHeight}"/>`);
        }
        if (this.#hasBorder) {
            svgBuffer.push(`</g></svg>')`);
            style.backgroundImage = svgBuffer.join("");
        }
        this.container.append(svg);
        this.container.style.clipPath = `url(#${id})`;
    }
    _createPopup(popupData = null) {
        const { data: data } = this;
        let contentsObj, modificationDate;
        if (popupData) {
            contentsObj = {
                str: popupData.text
            };
            modificationDate = popupData.date;
        } else {
            contentsObj = data.contentsObj;
            modificationDate = data.modificationDate;
        }
        const popup = this.#popupElement = new $9ef033443a74bee6$var$PopupAnnotationElement({
            data: {
                color: data.color,
                titleObj: data.titleObj,
                modificationDate: modificationDate,
                contentsObj: contentsObj,
                richText: data.richText,
                parentRect: data.rect,
                borderStyle: 0,
                id: `popup_${data.id}`,
                rotation: data.rotation,
                noRotate: true
            },
            linkService: this.linkService,
            parent: this.parent,
            elements: [
                this
            ]
        });
        if (!this.parent._commentManager) this.parent.div.append(popup.render());
    }
    get hasPopupElement() {
        return !!(this.#popupElement || this.popup || this.data.popupRef);
    }
    get extraPopupElement() {
        return this.#popupElement;
    }
    render() {
        $9ef033443a74bee6$var$unreachable("Abstract method `AnnotationElement.render` called");
    }
    _getElementsByName(name, skipId = null) {
        const fields = [];
        if (this._fieldObjects) {
            const fieldObj = this._fieldObjects[name];
            if (fieldObj) for (const { page: page, id: id, exportValues: exportValues } of fieldObj){
                if (page === -1) continue;
                if (id === skipId) continue;
                const exportValue = typeof exportValues === "string" ? exportValues : null;
                const domElement = document.querySelector(`[data-element-id="${id}"]`);
                if (domElement && !$9ef033443a74bee6$var$GetElementsByNameSet.has(domElement)) {
                    $9ef033443a74bee6$var$warn(`_getElementsByName - element not allowed: ${id}`);
                    continue;
                }
                fields.push({
                    id: id,
                    exportValue: exportValue,
                    domElement: domElement
                });
            }
            return fields;
        }
        for (const domElement of document.getElementsByName(name)){
            const { exportValue: exportValue } = domElement;
            const id = domElement.getAttribute("data-element-id");
            if (id === skipId) continue;
            if (!$9ef033443a74bee6$var$GetElementsByNameSet.has(domElement)) continue;
            fields.push({
                id: id,
                exportValue: exportValue,
                domElement: domElement
            });
        }
        return fields;
    }
    show() {
        if (this.container) this.container.hidden = false;
        this.popup?.maybeShow();
    }
    hide() {
        if (this.container) this.container.hidden = true;
        this.popup?.forceHide();
    }
    getElementsToTriggerPopup() {
        return this.container;
    }
    addHighlightArea() {
        const triggers = this.getElementsToTriggerPopup();
        if (Array.isArray(triggers)) for (const element of triggers)element.classList.add("highlightArea");
        else triggers.classList.add("highlightArea");
    }
    _editOnDoubleClick() {
        if (!this._isEditable) return;
        const { annotationEditorType: mode, data: { id: editId } } = this;
        this.container.addEventListener("dblclick", ()=>{
            this.linkService.eventBus?.dispatch("switchannotationeditormode", {
                source: this,
                mode: mode,
                editId: editId,
                mustEnterInEditMode: true
            });
        });
    }
    get width() {
        return this.data.rect[2] - this.data.rect[0];
    }
    get height() {
        return this.data.rect[3] - this.data.rect[1];
    }
}
class $9ef033443a74bee6$var$EditorAnnotationElement extends $9ef033443a74bee6$var$AnnotationElement {
    constructor(parameters){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: true
        });
        this.editor = parameters.editor;
    }
    render() {
        this.container.className = "editorAnnotation";
        return this.container;
    }
    createOrUpdatePopup() {
        const { editor: editor } = this;
        if (!editor.hasComment) return;
        this._createPopup(editor.comment);
        this.extraPopupElement.popup.renderCommentButton();
    }
    get hasCommentButton() {
        return this.enableComment && this.editor.hasComment;
    }
    get commentButtonPosition() {
        return this.editor.commentButtonPositionInPage;
    }
    get commentText() {
        return this.editor.comment.text;
    }
    set commentText(text) {
        this.editor.comment = text;
        if (!text) this.removePopup();
    }
    get commentData() {
        return this.editor.getData();
    }
    remove() {
        this.container.remove();
        this.container = null;
        this.removePopup();
    }
}
class $9ef033443a74bee6$var$LinkAnnotationElement extends $9ef033443a74bee6$var$AnnotationElement {
    constructor(parameters, options = null){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: !!options?.ignoreBorder,
            createQuadrilaterals: true
        });
        this.isTooltipOnly = parameters.data.isTooltipOnly;
    }
    render() {
        const { data: data, linkService: linkService } = this;
        const link = document.createElement("a");
        link.setAttribute("data-element-id", data.id);
        let isBound = false;
        if (data.url) {
            linkService.addLinkAttributes(link, data.url, data.newWindow);
            isBound = true;
        } else if (data.action) {
            this._bindNamedAction(link, data.action, data.overlaidText);
            isBound = true;
        } else if (data.attachment) {
            this.#bindAttachment(link, data.attachment, data.overlaidText, data.attachmentDest);
            isBound = true;
        } else if (data.setOCGState) {
            this.#bindSetOCGState(link, data.setOCGState, data.overlaidText);
            isBound = true;
        } else if (data.dest) {
            this._bindLink(link, data.dest, data.overlaidText);
            isBound = true;
        } else {
            if (data.actions && (data.actions.Action || data.actions["Mouse Up"] || data.actions["Mouse Down"]) && this.enableScripting && this.hasJSActions) {
                this._bindJSAction(link, data);
                isBound = true;
            }
            if (data.resetForm) {
                this._bindResetFormAction(link, data.resetForm);
                isBound = true;
            } else if (this.isTooltipOnly && !isBound) {
                this._bindLink(link, "");
                isBound = true;
            }
        }
        this.container.classList.add("linkAnnotation");
        if (isBound) this.container.append(link);
        return this.container;
    }
    #setInternalLink() {
        this.container.setAttribute("data-internal-link", "");
    }
    _bindLink(link, destination, overlaidText = "") {
        link.href = this.linkService.getDestinationHash(destination);
        link.onclick = ()=>{
            if (destination) this.linkService.goToDestination(destination);
            return false;
        };
        if (destination || destination === "") this.#setInternalLink();
        if (overlaidText) link.title = overlaidText;
    }
    _bindNamedAction(link, action, overlaidText = "") {
        link.href = this.linkService.getAnchorUrl("");
        link.onclick = ()=>{
            this.linkService.executeNamedAction(action);
            return false;
        };
        if (overlaidText) link.title = overlaidText;
        this.#setInternalLink();
    }
    #bindAttachment(link, attachment, overlaidText = "", dest = null) {
        link.href = this.linkService.getAnchorUrl("");
        if (attachment.description) link.title = attachment.description;
        else if (overlaidText) link.title = overlaidText;
        link.onclick = ()=>{
            this.downloadManager?.openOrDownloadData(attachment.content, attachment.filename, dest);
            return false;
        };
        this.#setInternalLink();
    }
    #bindSetOCGState(link, action, overlaidText = "") {
        link.href = this.linkService.getAnchorUrl("");
        link.onclick = ()=>{
            this.linkService.executeSetOCGState(action);
            return false;
        };
        if (overlaidText) link.title = overlaidText;
        this.#setInternalLink();
    }
    _bindJSAction(link, data) {
        link.href = this.linkService.getAnchorUrl("");
        const map = new Map([
            [
                "Action",
                "onclick"
            ],
            [
                "Mouse Up",
                "onmouseup"
            ],
            [
                "Mouse Down",
                "onmousedown"
            ]
        ]);
        for (const name of Object.keys(data.actions)){
            const jsName = map.get(name);
            if (!jsName) continue;
            link[jsName] = ()=>{
                this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                    source: this,
                    detail: {
                        id: data.id,
                        name: name
                    }
                });
                return false;
            };
        }
        if (data.overlaidText) link.title = data.overlaidText;
        if (!link.onclick) link.onclick = ()=>false;
        this.#setInternalLink();
    }
    _bindResetFormAction(link, resetForm) {
        const otherClickAction = link.onclick;
        if (!otherClickAction) link.href = this.linkService.getAnchorUrl("");
        this.#setInternalLink();
        if (!this._fieldObjects) {
            $9ef033443a74bee6$var$warn(`_bindResetFormAction - "resetForm" action not supported, ` + "ensure that the `fieldObjects` parameter is provided.");
            if (!otherClickAction) link.onclick = ()=>false;
            return;
        }
        link.onclick = ()=>{
            otherClickAction?.();
            const { fields: resetFormFields, refs: resetFormRefs, include: include } = resetForm;
            const allFields = [];
            if (resetFormFields.length !== 0 || resetFormRefs.length !== 0) {
                const fieldIds = new Set(resetFormRefs);
                for (const fieldName of resetFormFields){
                    const fields = this._fieldObjects[fieldName] || [];
                    for (const { id: id } of fields)fieldIds.add(id);
                }
                for (const fields of Object.values(this._fieldObjects)){
                    for (const field of fields)if (fieldIds.has(field.id) === include) allFields.push(field);
                }
            } else for (const fields of Object.values(this._fieldObjects))allFields.push(...fields);
            const storage = this.annotationStorage;
            const allIds = [];
            for (const field of allFields){
                const { id: id } = field;
                allIds.push(id);
                switch(field.type){
                    case "text":
                        {
                            const value = field.defaultValue || "";
                            storage.setValue(id, {
                                value: value
                            });
                            break;
                        }
                    case "checkbox":
                    case "radiobutton":
                        {
                            const value = field.defaultValue === field.exportValues;
                            storage.setValue(id, {
                                value: value
                            });
                            break;
                        }
                    case "combobox":
                    case "listbox":
                        {
                            const value = field.defaultValue || "";
                            storage.setValue(id, {
                                value: value
                            });
                            break;
                        }
                    default:
                        continue;
                }
                const domElement = document.querySelector(`[data-element-id="${id}"]`);
                if (!domElement) continue;
                else if (!$9ef033443a74bee6$var$GetElementsByNameSet.has(domElement)) {
                    $9ef033443a74bee6$var$warn(`_bindResetFormAction - element not allowed: ${id}`);
                    continue;
                }
                domElement.dispatchEvent(new Event("resetform"));
            }
            if (this.enableScripting) this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                source: this,
                detail: {
                    id: "app",
                    ids: allIds,
                    name: "ResetForm"
                }
            });
            return false;
        };
    }
}
class $9ef033443a74bee6$var$TextAnnotationElement extends $9ef033443a74bee6$var$AnnotationElement {
    constructor(parameters){
        super(parameters, {
            isRenderable: true
        });
    }
    render() {
        this.container.classList.add("textAnnotation");
        const image = document.createElement("img");
        image.src = this.imageResourcesPath + "annotation-" + this.data.name.toLowerCase() + ".svg";
        image.setAttribute("data-l10n-id", "pdfjs-text-annotation-type");
        image.setAttribute("data-l10n-args", JSON.stringify({
            type: this.data.name
        }));
        if (!this.data.popupRef && this.hasPopupData) this._createPopup();
        this.container.append(image);
        return this.container;
    }
}
class $9ef033443a74bee6$var$WidgetAnnotationElement extends $9ef033443a74bee6$var$AnnotationElement {
    render() {
        return this.container;
    }
    showElementAndHideCanvas(element) {
        if (this.data.hasOwnCanvas) {
            if (element.previousSibling?.nodeName === "CANVAS") element.previousSibling.hidden = true;
            element.hidden = false;
        }
    }
    _getKeyModifier(event) {
        return $9ef033443a74bee6$export$5fb8891d35c36978.platform.isMac ? event.metaKey : event.ctrlKey;
    }
    _setEventListener(element, elementData, baseName, eventName, valueGetter) {
        if (baseName.includes("mouse")) element.addEventListener(baseName, (event)=>{
            this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                source: this,
                detail: {
                    id: this.data.id,
                    name: eventName,
                    value: valueGetter(event),
                    shift: event.shiftKey,
                    modifier: this._getKeyModifier(event)
                }
            });
        });
        else element.addEventListener(baseName, (event)=>{
            if (baseName === "blur") {
                if (!elementData.focused || !event.relatedTarget) return;
                elementData.focused = false;
            } else if (baseName === "focus") {
                if (elementData.focused) return;
                elementData.focused = true;
            }
            if (!valueGetter) return;
            this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                source: this,
                detail: {
                    id: this.data.id,
                    name: eventName,
                    value: valueGetter(event)
                }
            });
        });
    }
    _setEventListeners(element, elementData, names, getter) {
        for (const [baseName, eventName] of names)if (eventName === "Action" || this.data.actions?.[eventName]) {
            if (eventName === "Focus" || eventName === "Blur") elementData ||= {
                focused: false
            };
            this._setEventListener(element, elementData, baseName, eventName, getter);
            if (eventName === "Focus" && !this.data.actions?.Blur) this._setEventListener(element, elementData, "blur", "Blur", null);
            else if (eventName === "Blur" && !this.data.actions?.Focus) this._setEventListener(element, elementData, "focus", "Focus", null);
        }
    }
    _setBackgroundColor(element) {
        const color = this.data.backgroundColor || null;
        element.style.backgroundColor = color === null ? "transparent" : $9ef033443a74bee6$export$f8f26dd395d7e1bd.makeHexColor(color[0], color[1], color[2]);
    }
    _setTextStyle(element) {
        const TEXT_ALIGNMENT = [
            "left",
            "center",
            "right"
        ];
        const { fontColor: fontColor } = this.data.defaultAppearanceData;
        const fontSize = this.data.defaultAppearanceData.fontSize || $9ef033443a74bee6$var$annotation_layer_DEFAULT_FONT_SIZE;
        const style = element.style;
        let computedFontSize;
        const BORDER_SIZE = 2;
        const roundToOneDecimal = (x)=>Math.round(10 * x) / 10;
        if (this.data.multiLine) {
            const height = Math.abs(this.data.rect[3] - this.data.rect[1] - BORDER_SIZE);
            const numberOfLines = Math.round(height / ($9ef033443a74bee6$var$LINE_FACTOR * fontSize)) || 1;
            const lineHeight = height / numberOfLines;
            computedFontSize = Math.min(fontSize, roundToOneDecimal(lineHeight / $9ef033443a74bee6$var$LINE_FACTOR));
        } else {
            const height = Math.abs(this.data.rect[3] - this.data.rect[1] - BORDER_SIZE);
            computedFontSize = Math.min(fontSize, roundToOneDecimal(height / $9ef033443a74bee6$var$LINE_FACTOR));
        }
        style.fontSize = `calc(${computedFontSize}px * var(--total-scale-factor))`;
        style.color = $9ef033443a74bee6$export$f8f26dd395d7e1bd.makeHexColor(fontColor[0], fontColor[1], fontColor[2]);
        if (this.data.textAlignment !== null) style.textAlign = TEXT_ALIGNMENT[this.data.textAlignment];
    }
    _setRequired(element, isRequired) {
        if (isRequired) element.setAttribute("required", true);
        else element.removeAttribute("required");
        element.setAttribute("aria-required", isRequired);
    }
}
class $9ef033443a74bee6$var$TextWidgetAnnotationElement extends $9ef033443a74bee6$var$WidgetAnnotationElement {
    constructor(parameters){
        const isRenderable = parameters.renderForms || parameters.data.hasOwnCanvas || !parameters.data.hasAppearance && !!parameters.data.fieldValue;
        super(parameters, {
            isRenderable: isRenderable
        });
    }
    setPropertyOnSiblings(base, key, value, keyInStorage) {
        const storage = this.annotationStorage;
        for (const element of this._getElementsByName(base.name, base.id)){
            if (element.domElement) element.domElement[key] = value;
            storage.setValue(element.id, {
                [keyInStorage]: value
            });
        }
    }
    render() {
        const storage = this.annotationStorage;
        const id = this.data.id;
        this.container.classList.add("textWidgetAnnotation");
        let element = null;
        if (this.renderForms) {
            const storedData = storage.getValue(id, {
                value: this.data.fieldValue
            });
            let textContent = storedData.value || "";
            const maxLen = storage.getValue(id, {
                charLimit: this.data.maxLen
            }).charLimit;
            if (maxLen && textContent.length > maxLen) textContent = textContent.slice(0, maxLen);
            let fieldFormattedValues = storedData.formattedValue || this.data.textContent?.join("\n") || null;
            if (fieldFormattedValues && this.data.comb) fieldFormattedValues = fieldFormattedValues.replaceAll(/\s+/g, "");
            const elementData = {
                userValue: textContent,
                formattedValue: fieldFormattedValues,
                lastCommittedValue: null,
                commitKey: 1,
                focused: false
            };
            if (this.data.multiLine) {
                element = document.createElement("textarea");
                element.textContent = fieldFormattedValues ?? textContent;
                if (this.data.doNotScroll) element.style.overflowY = "hidden";
            } else {
                element = document.createElement("input");
                element.type = this.data.password ? "password" : "text";
                element.setAttribute("value", fieldFormattedValues ?? textContent);
                if (this.data.doNotScroll) element.style.overflowX = "hidden";
            }
            if (this.data.hasOwnCanvas) element.hidden = true;
            $9ef033443a74bee6$var$GetElementsByNameSet.add(element);
            element.setAttribute("data-element-id", id);
            element.disabled = this.data.readOnly;
            element.name = this.data.fieldName;
            element.tabIndex = 0;
            const { datetimeFormat: datetimeFormat, datetimeType: datetimeType, timeStep: timeStep } = this.data;
            const hasDateOrTime = !!datetimeType && this.enableScripting;
            if (datetimeFormat) element.title = datetimeFormat;
            this._setRequired(element, this.data.required);
            if (maxLen) element.maxLength = maxLen;
            element.addEventListener("input", (event)=>{
                storage.setValue(id, {
                    value: event.target.value
                });
                this.setPropertyOnSiblings(element, "value", event.target.value, "value");
                elementData.formattedValue = null;
            });
            element.addEventListener("resetform", (event)=>{
                const defaultValue = this.data.defaultFieldValue ?? "";
                element.value = elementData.userValue = defaultValue;
                elementData.formattedValue = null;
            });
            let blurListener = (event)=>{
                const { formattedValue: formattedValue } = elementData;
                if (formattedValue !== null && formattedValue !== undefined) event.target.value = formattedValue;
                event.target.scrollLeft = 0;
            };
            if (this.enableScripting && this.hasJSActions) {
                element.addEventListener("focus", (event)=>{
                    if (elementData.focused) return;
                    const { target: target } = event;
                    if (hasDateOrTime) {
                        target.type = datetimeType;
                        if (timeStep) target.step = timeStep;
                    }
                    if (elementData.userValue) {
                        const value = elementData.userValue;
                        if (hasDateOrTime) {
                            if (datetimeType === "time") {
                                const date = new Date(value);
                                const parts = [
                                    date.getHours(),
                                    date.getMinutes(),
                                    date.getSeconds()
                                ];
                                target.value = parts.map((v)=>v.toString().padStart(2, "0")).join(":");
                            } else target.value = new Date(value - $9ef033443a74bee6$var$TIMEZONE_OFFSET).toISOString().split(datetimeType === "date" ? "T" : ".", 1)[0];
                        } else target.value = value;
                    }
                    elementData.lastCommittedValue = target.value;
                    elementData.commitKey = 1;
                    if (!this.data.actions?.Focus) elementData.focused = true;
                });
                element.addEventListener("updatefromsandbox", (jsEvent)=>{
                    this.showElementAndHideCanvas(jsEvent.target);
                    const actions = {
                        value (event) {
                            elementData.userValue = event.detail.value ?? "";
                            if (!hasDateOrTime) storage.setValue(id, {
                                value: elementData.userValue.toString()
                            });
                            event.target.value = elementData.userValue;
                        },
                        formattedValue (event) {
                            const { formattedValue: formattedValue } = event.detail;
                            elementData.formattedValue = formattedValue;
                            if (formattedValue !== null && formattedValue !== undefined && event.target !== document.activeElement) event.target.value = formattedValue;
                            const data = {
                                formattedValue: formattedValue
                            };
                            if (hasDateOrTime) data.value = formattedValue;
                            storage.setValue(id, data);
                        },
                        selRange (event) {
                            event.target.setSelectionRange(...event.detail.selRange);
                        },
                        charLimit: (event)=>{
                            const { charLimit: charLimit } = event.detail;
                            const { target: target } = event;
                            if (charLimit === 0) {
                                target.removeAttribute("maxLength");
                                return;
                            }
                            target.setAttribute("maxLength", charLimit);
                            let value = elementData.userValue;
                            if (!value || value.length <= charLimit) return;
                            value = value.slice(0, charLimit);
                            target.value = elementData.userValue = value;
                            storage.setValue(id, {
                                value: value
                            });
                            this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                                source: this,
                                detail: {
                                    id: id,
                                    name: "Keystroke",
                                    value: value,
                                    willCommit: true,
                                    commitKey: 1,
                                    selStart: target.selectionStart,
                                    selEnd: target.selectionEnd
                                }
                            });
                        }
                    };
                    this._dispatchEventFromSandbox(actions, jsEvent);
                });
                element.addEventListener("keydown", (event)=>{
                    elementData.commitKey = 1;
                    let commitKey = -1;
                    if (event.key === "Escape") commitKey = 0;
                    else if (event.key === "Enter" && !this.data.multiLine) commitKey = 2;
                    else if (event.key === "Tab") elementData.commitKey = 3;
                    if (commitKey === -1) return;
                    const { value: value } = event.target;
                    if (elementData.lastCommittedValue === value) return;
                    elementData.lastCommittedValue = value;
                    elementData.userValue = value;
                    this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                        source: this,
                        detail: {
                            id: id,
                            name: "Keystroke",
                            value: value,
                            willCommit: true,
                            commitKey: commitKey,
                            selStart: event.target.selectionStart,
                            selEnd: event.target.selectionEnd
                        }
                    });
                });
                const _blurListener = blurListener;
                blurListener = null;
                element.addEventListener("blur", (event)=>{
                    if (!elementData.focused || !event.relatedTarget) return;
                    if (!this.data.actions?.Blur) elementData.focused = false;
                    const { target: target } = event;
                    let { value: value } = target;
                    if (hasDateOrTime) {
                        if (value && datetimeType === "time") {
                            const parts = value.split(":").map((v)=>parseInt(v, 10));
                            value = new Date(2000, 0, 1, parts[0], parts[1], parts[2] || 0).valueOf();
                            target.step = "";
                        } else {
                            if (!value.includes("T")) value = `${value}T00:00`;
                            value = new Date(value).valueOf();
                        }
                        target.type = "text";
                    }
                    elementData.userValue = value;
                    if (elementData.lastCommittedValue !== value) this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                        source: this,
                        detail: {
                            id: id,
                            name: "Keystroke",
                            value: value,
                            willCommit: true,
                            commitKey: elementData.commitKey,
                            selStart: event.target.selectionStart,
                            selEnd: event.target.selectionEnd
                        }
                    });
                    _blurListener(event);
                });
                if (this.data.actions?.Keystroke) element.addEventListener("beforeinput", (event)=>{
                    elementData.lastCommittedValue = null;
                    const { data: data, target: target } = event;
                    const { value: value, selectionStart: selectionStart, selectionEnd: selectionEnd } = target;
                    let selStart = selectionStart, selEnd = selectionEnd;
                    switch(event.inputType){
                        case "deleteWordBackward":
                            {
                                const match = value.substring(0, selectionStart).match(/\w*[^\w]*$/);
                                if (match) selStart -= match[0].length;
                                break;
                            }
                        case "deleteWordForward":
                            {
                                const match = value.substring(selectionStart).match(/^[^\w]*\w*/);
                                if (match) selEnd += match[0].length;
                                break;
                            }
                        case "deleteContentBackward":
                            if (selectionStart === selectionEnd) selStart -= 1;
                            break;
                        case "deleteContentForward":
                            if (selectionStart === selectionEnd) selEnd += 1;
                            break;
                    }
                    event.preventDefault();
                    this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                        source: this,
                        detail: {
                            id: id,
                            name: "Keystroke",
                            value: value,
                            change: data || "",
                            willCommit: false,
                            selStart: selStart,
                            selEnd: selEnd
                        }
                    });
                });
                this._setEventListeners(element, elementData, [
                    [
                        "focus",
                        "Focus"
                    ],
                    [
                        "blur",
                        "Blur"
                    ],
                    [
                        "mousedown",
                        "Mouse Down"
                    ],
                    [
                        "mouseenter",
                        "Mouse Enter"
                    ],
                    [
                        "mouseleave",
                        "Mouse Exit"
                    ],
                    [
                        "mouseup",
                        "Mouse Up"
                    ]
                ], (event)=>event.target.value);
            }
            if (blurListener) element.addEventListener("blur", blurListener);
            if (this.data.comb) {
                const fieldWidth = this.data.rect[2] - this.data.rect[0];
                const combWidth = fieldWidth / maxLen;
                element.classList.add("comb");
                element.style.letterSpacing = `calc(${combWidth}px * var(--total-scale-factor) - 1ch)`;
            }
        } else {
            element = document.createElement("div");
            element.textContent = this.data.fieldValue;
            element.style.verticalAlign = "middle";
            element.style.display = "table-cell";
            if (this.data.hasOwnCanvas) element.hidden = true;
        }
        this._setTextStyle(element);
        this._setBackgroundColor(element);
        this._setDefaultPropertiesFromJS(element);
        this.container.append(element);
        return this.container;
    }
}
class $9ef033443a74bee6$var$SignatureWidgetAnnotationElement extends $9ef033443a74bee6$var$WidgetAnnotationElement {
    constructor(parameters){
        super(parameters, {
            isRenderable: !!parameters.data.hasOwnCanvas
        });
    }
}
class $9ef033443a74bee6$var$CheckboxWidgetAnnotationElement extends $9ef033443a74bee6$var$WidgetAnnotationElement {
    constructor(parameters){
        super(parameters, {
            isRenderable: parameters.renderForms
        });
    }
    render() {
        const storage = this.annotationStorage;
        const data = this.data;
        const id = data.id;
        let value = storage.getValue(id, {
            value: data.exportValue === data.fieldValue
        }).value;
        if (typeof value === "string") {
            value = value !== "Off";
            storage.setValue(id, {
                value: value
            });
        }
        this.container.classList.add("buttonWidgetAnnotation", "checkBox");
        const element = document.createElement("input");
        $9ef033443a74bee6$var$GetElementsByNameSet.add(element);
        element.setAttribute("data-element-id", id);
        element.disabled = data.readOnly;
        this._setRequired(element, this.data.required);
        element.type = "checkbox";
        element.name = data.fieldName;
        if (value) element.setAttribute("checked", true);
        element.setAttribute("exportValue", data.exportValue);
        element.tabIndex = 0;
        element.addEventListener("change", (event)=>{
            const { name: name, checked: checked } = event.target;
            for (const checkbox of this._getElementsByName(name, id)){
                const curChecked = checked && checkbox.exportValue === data.exportValue;
                if (checkbox.domElement) checkbox.domElement.checked = curChecked;
                storage.setValue(checkbox.id, {
                    value: curChecked
                });
            }
            storage.setValue(id, {
                value: checked
            });
        });
        element.addEventListener("resetform", (event)=>{
            const defaultValue = data.defaultFieldValue || "Off";
            event.target.checked = defaultValue === data.exportValue;
        });
        if (this.enableScripting && this.hasJSActions) {
            element.addEventListener("updatefromsandbox", (jsEvent)=>{
                const actions = {
                    value (event) {
                        event.target.checked = event.detail.value !== "Off";
                        storage.setValue(id, {
                            value: event.target.checked
                        });
                    }
                };
                this._dispatchEventFromSandbox(actions, jsEvent);
            });
            this._setEventListeners(element, null, [
                [
                    "change",
                    "Validate"
                ],
                [
                    "change",
                    "Action"
                ],
                [
                    "focus",
                    "Focus"
                ],
                [
                    "blur",
                    "Blur"
                ],
                [
                    "mousedown",
                    "Mouse Down"
                ],
                [
                    "mouseenter",
                    "Mouse Enter"
                ],
                [
                    "mouseleave",
                    "Mouse Exit"
                ],
                [
                    "mouseup",
                    "Mouse Up"
                ]
            ], (event)=>event.target.checked);
        }
        this._setBackgroundColor(element);
        this._setDefaultPropertiesFromJS(element);
        this.container.append(element);
        return this.container;
    }
}
class $9ef033443a74bee6$var$RadioButtonWidgetAnnotationElement extends $9ef033443a74bee6$var$WidgetAnnotationElement {
    constructor(parameters){
        super(parameters, {
            isRenderable: parameters.renderForms
        });
    }
    render() {
        this.container.classList.add("buttonWidgetAnnotation", "radioButton");
        const storage = this.annotationStorage;
        const data = this.data;
        const id = data.id;
        let value = storage.getValue(id, {
            value: data.fieldValue === data.buttonValue
        }).value;
        if (typeof value === "string") {
            value = value !== data.buttonValue;
            storage.setValue(id, {
                value: value
            });
        }
        if (value) for (const radio of this._getElementsByName(data.fieldName, id))storage.setValue(radio.id, {
            value: false
        });
        const element = document.createElement("input");
        $9ef033443a74bee6$var$GetElementsByNameSet.add(element);
        element.setAttribute("data-element-id", id);
        element.disabled = data.readOnly;
        this._setRequired(element, this.data.required);
        element.type = "radio";
        element.name = data.fieldName;
        if (value) element.setAttribute("checked", true);
        element.tabIndex = 0;
        element.addEventListener("change", (event)=>{
            const { name: name, checked: checked } = event.target;
            for (const radio of this._getElementsByName(name, id))storage.setValue(radio.id, {
                value: false
            });
            storage.setValue(id, {
                value: checked
            });
        });
        element.addEventListener("resetform", (event)=>{
            const defaultValue = data.defaultFieldValue;
            event.target.checked = defaultValue !== null && defaultValue !== undefined && defaultValue === data.buttonValue;
        });
        if (this.enableScripting && this.hasJSActions) {
            const pdfButtonValue = data.buttonValue;
            element.addEventListener("updatefromsandbox", (jsEvent)=>{
                const actions = {
                    value: (event)=>{
                        const checked = pdfButtonValue === event.detail.value;
                        for (const radio of this._getElementsByName(event.target.name)){
                            const curChecked = checked && radio.id === id;
                            if (radio.domElement) radio.domElement.checked = curChecked;
                            storage.setValue(radio.id, {
                                value: curChecked
                            });
                        }
                    }
                };
                this._dispatchEventFromSandbox(actions, jsEvent);
            });
            this._setEventListeners(element, null, [
                [
                    "change",
                    "Validate"
                ],
                [
                    "change",
                    "Action"
                ],
                [
                    "focus",
                    "Focus"
                ],
                [
                    "blur",
                    "Blur"
                ],
                [
                    "mousedown",
                    "Mouse Down"
                ],
                [
                    "mouseenter",
                    "Mouse Enter"
                ],
                [
                    "mouseleave",
                    "Mouse Exit"
                ],
                [
                    "mouseup",
                    "Mouse Up"
                ]
            ], (event)=>event.target.checked);
        }
        this._setBackgroundColor(element);
        this._setDefaultPropertiesFromJS(element);
        this.container.append(element);
        return this.container;
    }
}
class $9ef033443a74bee6$var$PushButtonWidgetAnnotationElement extends $9ef033443a74bee6$var$LinkAnnotationElement {
    constructor(parameters){
        super(parameters, {
            ignoreBorder: parameters.data.hasAppearance
        });
    }
    render() {
        const container = super.render();
        container.classList.add("buttonWidgetAnnotation", "pushButton");
        const linkElement = container.lastChild;
        if (this.enableScripting && this.hasJSActions && linkElement) {
            this._setDefaultPropertiesFromJS(linkElement);
            linkElement.addEventListener("updatefromsandbox", (jsEvent)=>{
                this._dispatchEventFromSandbox({}, jsEvent);
            });
        }
        return container;
    }
}
class $9ef033443a74bee6$var$ChoiceWidgetAnnotationElement extends $9ef033443a74bee6$var$WidgetAnnotationElement {
    constructor(parameters){
        super(parameters, {
            isRenderable: parameters.renderForms
        });
    }
    render() {
        this.container.classList.add("choiceWidgetAnnotation");
        const storage = this.annotationStorage;
        const id = this.data.id;
        const storedData = storage.getValue(id, {
            value: this.data.fieldValue
        });
        const selectElement = document.createElement("select");
        $9ef033443a74bee6$var$GetElementsByNameSet.add(selectElement);
        selectElement.setAttribute("data-element-id", id);
        selectElement.disabled = this.data.readOnly;
        this._setRequired(selectElement, this.data.required);
        selectElement.name = this.data.fieldName;
        selectElement.tabIndex = 0;
        let addAnEmptyEntry = this.data.combo && this.data.options.length > 0;
        if (!this.data.combo) {
            selectElement.size = this.data.options.length;
            if (this.data.multiSelect) selectElement.multiple = true;
        }
        selectElement.addEventListener("resetform", (event)=>{
            const defaultValue = this.data.defaultFieldValue;
            for (const option of selectElement.options)option.selected = option.value === defaultValue;
        });
        for (const option of this.data.options){
            const optionElement = document.createElement("option");
            optionElement.textContent = option.displayValue;
            optionElement.value = option.exportValue;
            if (storedData.value.includes(option.exportValue)) {
                optionElement.setAttribute("selected", true);
                addAnEmptyEntry = false;
            }
            selectElement.append(optionElement);
        }
        let removeEmptyEntry = null;
        if (addAnEmptyEntry) {
            const noneOptionElement = document.createElement("option");
            noneOptionElement.value = " ";
            noneOptionElement.setAttribute("hidden", true);
            noneOptionElement.setAttribute("selected", true);
            selectElement.prepend(noneOptionElement);
            removeEmptyEntry = ()=>{
                noneOptionElement.remove();
                selectElement.removeEventListener("input", removeEmptyEntry);
                removeEmptyEntry = null;
            };
            selectElement.addEventListener("input", removeEmptyEntry);
        }
        const getValue = (isExport)=>{
            const name = isExport ? "value" : "textContent";
            const { options: options, multiple: multiple } = selectElement;
            if (!multiple) return options.selectedIndex === -1 ? null : options[options.selectedIndex][name];
            return Array.prototype.filter.call(options, (option)=>option.selected).map((option)=>option[name]);
        };
        let selectedValues = getValue(false);
        const getItems = (event)=>{
            const options = event.target.options;
            return Array.prototype.map.call(options, (option)=>({
                    displayValue: option.textContent,
                    exportValue: option.value
                }));
        };
        if (this.enableScripting && this.hasJSActions) {
            selectElement.addEventListener("updatefromsandbox", (jsEvent)=>{
                const actions = {
                    value (event) {
                        removeEmptyEntry?.();
                        const value = event.detail.value;
                        const values = new Set(Array.isArray(value) ? value : [
                            value
                        ]);
                        for (const option of selectElement.options)option.selected = values.has(option.value);
                        storage.setValue(id, {
                            value: getValue(true)
                        });
                        selectedValues = getValue(false);
                    },
                    multipleSelection (event) {
                        selectElement.multiple = true;
                    },
                    remove (event) {
                        const options = selectElement.options;
                        const index = event.detail.remove;
                        options[index].selected = false;
                        selectElement.remove(index);
                        if (options.length > 0) {
                            const i = Array.prototype.findIndex.call(options, (option)=>option.selected);
                            if (i === -1) options[0].selected = true;
                        }
                        storage.setValue(id, {
                            value: getValue(true),
                            items: getItems(event)
                        });
                        selectedValues = getValue(false);
                    },
                    clear (event) {
                        while(selectElement.length !== 0)selectElement.remove(0);
                        storage.setValue(id, {
                            value: null,
                            items: []
                        });
                        selectedValues = getValue(false);
                    },
                    insert (event) {
                        const { index: index, displayValue: displayValue, exportValue: exportValue } = event.detail.insert;
                        const selectChild = selectElement.children[index];
                        const optionElement = document.createElement("option");
                        optionElement.textContent = displayValue;
                        optionElement.value = exportValue;
                        if (selectChild) selectChild.before(optionElement);
                        else selectElement.append(optionElement);
                        storage.setValue(id, {
                            value: getValue(true),
                            items: getItems(event)
                        });
                        selectedValues = getValue(false);
                    },
                    items (event) {
                        const { items: items } = event.detail;
                        while(selectElement.length !== 0)selectElement.remove(0);
                        for (const item of items){
                            const { displayValue: displayValue, exportValue: exportValue } = item;
                            const optionElement = document.createElement("option");
                            optionElement.textContent = displayValue;
                            optionElement.value = exportValue;
                            selectElement.append(optionElement);
                        }
                        if (selectElement.options.length > 0) selectElement.options[0].selected = true;
                        storage.setValue(id, {
                            value: getValue(true),
                            items: getItems(event)
                        });
                        selectedValues = getValue(false);
                    },
                    indices (event) {
                        const indices = new Set(event.detail.indices);
                        for (const option of event.target.options)option.selected = indices.has(option.index);
                        storage.setValue(id, {
                            value: getValue(true)
                        });
                        selectedValues = getValue(false);
                    },
                    editable (event) {
                        event.target.disabled = !event.detail.editable;
                    }
                };
                this._dispatchEventFromSandbox(actions, jsEvent);
            });
            selectElement.addEventListener("input", (event)=>{
                const exportValue = getValue(true);
                const change = getValue(false);
                storage.setValue(id, {
                    value: exportValue
                });
                event.preventDefault();
                this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                    source: this,
                    detail: {
                        id: id,
                        name: "Keystroke",
                        value: selectedValues,
                        change: change,
                        changeEx: exportValue,
                        willCommit: false,
                        commitKey: 1,
                        keyDown: false
                    }
                });
            });
            this._setEventListeners(selectElement, null, [
                [
                    "focus",
                    "Focus"
                ],
                [
                    "blur",
                    "Blur"
                ],
                [
                    "mousedown",
                    "Mouse Down"
                ],
                [
                    "mouseenter",
                    "Mouse Enter"
                ],
                [
                    "mouseleave",
                    "Mouse Exit"
                ],
                [
                    "mouseup",
                    "Mouse Up"
                ],
                [
                    "input",
                    "Action"
                ],
                [
                    "input",
                    "Validate"
                ]
            ], (event)=>event.target.value);
        } else selectElement.addEventListener("input", function(event) {
            storage.setValue(id, {
                value: getValue(true)
            });
        });
        if (this.data.combo) this._setTextStyle(selectElement);
        this._setBackgroundColor(selectElement);
        this._setDefaultPropertiesFromJS(selectElement);
        this.container.append(selectElement);
        return this.container;
    }
}
class $9ef033443a74bee6$var$PopupAnnotationElement extends $9ef033443a74bee6$var$AnnotationElement {
    constructor(parameters){
        const { data: data, elements: elements, parent: parent } = parameters;
        const hasCommentManager = !!parent._commentManager;
        super(parameters, {
            isRenderable: !hasCommentManager && $9ef033443a74bee6$var$AnnotationElement._hasPopupData(data)
        });
        this.elements = elements;
        if (hasCommentManager && $9ef033443a74bee6$var$AnnotationElement._hasPopupData(data)) {
            const popup = this.popup = this.#createPopup();
            for (const element of elements)element.popup = popup;
        } else this.popup = null;
    }
    #createPopup() {
        return new $9ef033443a74bee6$var$PopupElement({
            container: this.container,
            color: this.data.color,
            titleObj: this.data.titleObj,
            modificationDate: this.data.modificationDate || this.data.creationDate,
            contentsObj: this.data.contentsObj,
            richText: this.data.richText,
            rect: this.data.rect,
            parentRect: this.data.parentRect || null,
            parent: this.parent,
            elements: this.elements,
            open: this.data.open,
            commentManager: this.parent._commentManager
        });
    }
    render() {
        const { container: container } = this;
        container.classList.add("popupAnnotation");
        container.role = "comment";
        const popup = this.popup = this.#createPopup();
        const elementIds = [];
        for (const element of this.elements){
            element.popup = popup;
            element.container.ariaHasPopup = "dialog";
            elementIds.push(element.data.id);
            element.addHighlightArea();
        }
        this.container.setAttribute("aria-controls", elementIds.map((id)=>`${$9ef033443a74bee6$var$AnnotationPrefix}${id}`).join(","));
        return this.container;
    }
}
class $9ef033443a74bee6$var$PopupElement {
    #commentManager = null;
    #boundKeyDown = this.#keyDown.bind(this);
    #boundHide = this.#hide.bind(this);
    #boundShow = this.#show.bind(this);
    #boundToggle = this.#toggle.bind(this);
    #color = null;
    #container = null;
    #contentsObj = null;
    #dateObj = null;
    #elements = null;
    #parent = null;
    #parentRect = null;
    #pinned = false;
    #popup = null;
    #popupAbortController = null;
    #position = null;
    #commentButton = null;
    #commentButtonPosition = null;
    #popupPosition = null;
    #rect = null;
    #richText = null;
    #titleObj = null;
    #updates = null;
    #wasVisible = false;
    #firstElement = null;
    #commentText = null;
    constructor({ container: container, color: color, elements: elements, titleObj: titleObj, modificationDate: modificationDate, contentsObj: contentsObj, richText: richText, parent: parent, rect: rect, parentRect: parentRect, open: open, commentManager: commentManager = null }){
        this.#container = container;
        this.#titleObj = titleObj;
        this.#contentsObj = contentsObj;
        this.#richText = richText;
        this.#parent = parent;
        this.#color = color;
        this.#rect = rect;
        this.#parentRect = parentRect;
        this.#elements = elements;
        this.#commentManager = commentManager;
        this.#firstElement = elements[0];
        this.#dateObj = $9ef033443a74bee6$export$66cbc314498fffc.toDateObject(modificationDate);
        this.trigger = elements.flatMap((e)=>e.getElementsToTriggerPopup());
        if (commentManager) this.renderCommentButton();
        else {
            this.#addEventListeners();
            this.#container.hidden = true;
            if (open) this.#toggle();
        }
    }
    #addEventListeners() {
        if (this.#popupAbortController) return;
        this.#popupAbortController = new AbortController();
        const { signal: signal } = this.#popupAbortController;
        for (const element of this.trigger){
            element.addEventListener("click", this.#boundToggle, {
                signal: signal
            });
            element.addEventListener("pointerenter", this.#boundShow, {
                signal: signal
            });
            element.addEventListener("pointerleave", this.#boundHide, {
                signal: signal
            });
            element.classList.add("popupTriggerArea");
        }
        for (const element of this.#elements)element.container?.addEventListener("keydown", this.#boundKeyDown, {
            signal: signal
        });
    }
    #setCommentButtonPosition() {
        const element = this.#elements.find((e)=>e.hasCommentButton);
        if (!element) return;
        this.#commentButtonPosition = element._normalizePoint(element.commentButtonPosition);
    }
    renderCommentButton() {
        if (this.#commentButton) return;
        if (!this.#commentButtonPosition) this.#setCommentButtonPosition();
        if (!this.#commentButtonPosition) return;
        const { signal: signal } = this.#popupAbortController = new AbortController();
        const hasOwnButton = !!this.#firstElement.extraPopupElement;
        const togglePopup = ()=>{
            this.#commentManager.toggleCommentPopup(this, true, undefined, !hasOwnButton);
        };
        const showPopup = ()=>{
            this.#commentManager.toggleCommentPopup(this, false, true, !hasOwnButton);
        };
        const hidePopup = ()=>{
            this.#commentManager.toggleCommentPopup(this, false, false);
        };
        if (!hasOwnButton) {
            const button = this.#commentButton = document.createElement("button");
            button.className = "annotationCommentButton";
            const parentContainer = this.#firstElement.container;
            button.style.zIndex = parentContainer.style.zIndex + 1;
            button.tabIndex = 0;
            button.ariaHasPopup = "dialog";
            button.ariaControls = "commentPopup";
            button.setAttribute("data-l10n-id", "pdfjs-show-comment-button");
            this.#updateColor();
            this.#updateCommentButtonPosition();
            button.addEventListener("keydown", this.#boundKeyDown, {
                signal: signal
            });
            button.addEventListener("click", togglePopup, {
                signal: signal
            });
            button.addEventListener("pointerenter", showPopup, {
                signal: signal
            });
            button.addEventListener("pointerleave", hidePopup, {
                signal: signal
            });
            parentContainer.after(button);
        } else {
            this.#commentButton = this.#firstElement.container;
            for (const element of this.trigger){
                element.ariaHasPopup = "dialog";
                element.ariaControls = "commentPopup";
                element.addEventListener("keydown", this.#boundKeyDown, {
                    signal: signal
                });
                element.addEventListener("click", togglePopup, {
                    signal: signal
                });
                element.addEventListener("pointerenter", showPopup, {
                    signal: signal
                });
                element.addEventListener("pointerleave", hidePopup, {
                    signal: signal
                });
                element.classList.add("popupTriggerArea");
            }
        }
    }
    #updateCommentButtonPosition() {
        if (this.#firstElement.extraPopupElement && !this.#firstElement.editor) return;
        this.renderCommentButton();
        const [x, y] = this.#commentButtonPosition;
        const { style: style } = this.#commentButton;
        style.left = `calc(${x}%)`;
        style.top = `calc(${y}% - var(--comment-button-dim))`;
    }
    #updateColor() {
        if (this.#firstElement.extraPopupElement) return;
        this.renderCommentButton();
        this.#commentButton.style.backgroundColor = this.commentButtonColor || "";
    }
    get commentButtonColor() {
        const { color: color, opacity: opacity } = this.#firstElement.commentData;
        if (!color) return null;
        return this.#parent._commentManager.makeCommentColor(color, opacity);
    }
    focusCommentButton() {
        setTimeout(()=>{
            this.#commentButton?.focus();
        }, 0);
    }
    getData() {
        const { richText: richText, color: color, opacity: opacity, creationDate: creationDate, modificationDate: modificationDate } = this.#firstElement.commentData;
        return {
            contentsObj: {
                str: this.comment
            },
            richText: richText,
            color: color,
            opacity: opacity,
            creationDate: creationDate,
            modificationDate: modificationDate
        };
    }
    get elementBeforePopup() {
        return this.#commentButton;
    }
    get comment() {
        this.#commentText ||= this.#firstElement.commentText;
        return this.#commentText;
    }
    set comment(text) {
        if (text === this.comment) return;
        this.#firstElement.commentText = this.#commentText = text;
    }
    get parentBoundingClientRect() {
        return this.#firstElement.layer.getBoundingClientRect();
    }
    setCommentButtonStates({ selected: selected, hasPopup: hasPopup }) {
        if (!this.#commentButton) return;
        this.#commentButton.classList.toggle("selected", selected);
        this.#commentButton.ariaExpanded = hasPopup;
    }
    setSelectedCommentButton(selected) {
        this.#commentButton.classList.toggle("selected", selected);
    }
    get commentPopupPosition() {
        if (this.#popupPosition) return this.#popupPosition;
        const { x: x, y: y, height: height } = this.#commentButton.getBoundingClientRect();
        const { x: parentX, y: parentY, width: parentWidth, height: parentHeight } = this.#firstElement.layer.getBoundingClientRect();
        return [
            (x - parentX) / parentWidth,
            (y + height - parentY) / parentHeight
        ];
    }
    set commentPopupPosition(pos) {
        this.#popupPosition = pos;
    }
    hasDefaultPopupPosition() {
        return this.#popupPosition === null;
    }
    get commentButtonPosition() {
        return this.#commentButtonPosition;
    }
    get commentButtonWidth() {
        return this.#commentButton.getBoundingClientRect().width / this.parentBoundingClientRect.width;
    }
    editComment(options) {
        const [posX, posY] = this.#popupPosition || this.commentButtonPosition.map((x)=>x / 100);
        const parentDimensions = this.parentBoundingClientRect;
        const { x: parentX, y: parentY, width: parentWidth, height: parentHeight } = parentDimensions;
        this.#commentManager.showDialog(null, this, parentX + posX * parentWidth, parentY + posY * parentHeight, {
            ...options,
            parentDimensions: parentDimensions
        });
    }
    render() {
        if (this.#popup) return;
        const popup = this.#popup = document.createElement("div");
        popup.className = "popup";
        if (this.#color) {
            const baseColor = popup.style.outlineColor = $9ef033443a74bee6$export$f8f26dd395d7e1bd.makeHexColor(...this.#color);
            popup.style.backgroundColor = `color-mix(in srgb, ${baseColor} 30%, white)`;
        }
        const header = document.createElement("span");
        header.className = "header";
        if (this.#titleObj?.str) {
            const title = document.createElement("span");
            title.className = "title";
            header.append(title);
            ({ dir: title.dir, str: title.textContent } = this.#titleObj);
        }
        popup.append(header);
        if (this.#dateObj) {
            const modificationDate = document.createElement("time");
            modificationDate.className = "popupDate";
            modificationDate.setAttribute("data-l10n-id", "pdfjs-annotation-date-time-string");
            modificationDate.setAttribute("data-l10n-args", JSON.stringify({
                dateObj: this.#dateObj.valueOf()
            }));
            modificationDate.dateTime = this.#dateObj.toISOString();
            header.append(modificationDate);
        }
        $9ef033443a74bee6$export$611c480766035c4({
            html: this.#html || this.#contentsObj.str,
            dir: this.#contentsObj?.dir,
            className: "popupContent"
        }, popup);
        this.#container.append(popup);
    }
    get #html() {
        const richText = this.#richText;
        const contentsObj = this.#contentsObj;
        if (richText?.str && (!contentsObj?.str || contentsObj.str === richText.str)) return this.#richText.html || null;
        return null;
    }
    get #fontSize() {
        return this.#html?.attributes?.style?.fontSize || 0;
    }
    get #fontColor() {
        return this.#html?.attributes?.style?.color || null;
    }
    #makePopupContent(text) {
        const popupLines = [];
        const popupContent = {
            str: text,
            html: {
                name: "div",
                attributes: {
                    dir: "auto"
                },
                children: [
                    {
                        name: "p",
                        children: popupLines
                    }
                ]
            }
        };
        const lineAttributes = {
            style: {
                color: this.#fontColor,
                fontSize: this.#fontSize ? `calc(${this.#fontSize}px * var(--total-scale-factor))` : ""
            }
        };
        for (const line of text.split("\n"))popupLines.push({
            name: "span",
            value: line,
            attributes: lineAttributes
        });
        return popupContent;
    }
    #keyDown(event) {
        if (event.altKey || event.shiftKey || event.ctrlKey || event.metaKey) return;
        if (event.key === "Enter" || event.key === "Escape" && this.#pinned) this.#toggle();
    }
    updateEdited({ rect: rect, popup: popup, deleted: deleted }) {
        if (this.#commentManager) {
            if (deleted) {
                this.remove();
                this.#commentText = null;
            } else if (popup) {
                if (popup.deleted) this.remove();
                else {
                    this.#updateColor();
                    this.#commentText = popup.text;
                }
            }
            if (rect) {
                this.#commentButtonPosition = null;
                this.#setCommentButtonPosition();
                this.#updateCommentButtonPosition();
            }
            return;
        }
        if (deleted || popup?.deleted) {
            this.remove();
            return;
        }
        this.#addEventListeners();
        this.#updates ||= {
            contentsObj: this.#contentsObj,
            richText: this.#richText
        };
        if (rect) this.#position = null;
        if (popup && popup.text) {
            this.#richText = this.#makePopupContent(popup.text);
            this.#dateObj = $9ef033443a74bee6$export$66cbc314498fffc.toDateObject(popup.date);
            this.#contentsObj = null;
        }
        this.#popup?.remove();
        this.#popup = null;
    }
    resetEdited() {
        if (!this.#updates) return;
        ({ contentsObj: this.#contentsObj, richText: this.#richText } = this.#updates);
        this.#updates = null;
        this.#popup?.remove();
        this.#popup = null;
        this.#position = null;
    }
    remove() {
        this.#popupAbortController?.abort();
        this.#popupAbortController = null;
        this.#popup?.remove();
        this.#popup = null;
        this.#wasVisible = false;
        this.#pinned = false;
        this.#commentButton?.remove();
        this.#commentButton = null;
        if (this.trigger) for (const element of this.trigger)element.classList.remove("popupTriggerArea");
    }
    #setPosition() {
        if (this.#position !== null) return;
        const { page: { view: view }, viewport: { rawDims: { pageWidth: pageWidth, pageHeight: pageHeight, pageX: pageX, pageY: pageY } } } = this.#parent;
        let useParentRect = !!this.#parentRect;
        let rect = useParentRect ? this.#parentRect : this.#rect;
        for (const element of this.#elements)if (!rect || $9ef033443a74bee6$export$f8f26dd395d7e1bd.intersect(element.data.rect, rect) !== null) {
            rect = element.data.rect;
            useParentRect = true;
            break;
        }
        const normalizedRect = $9ef033443a74bee6$export$f8f26dd395d7e1bd.normalizeRect([
            rect[0],
            view[3] - rect[1] + view[1],
            rect[2],
            view[3] - rect[3] + view[1]
        ]);
        const HORIZONTAL_SPACE_AFTER_ANNOTATION = 5;
        const parentWidth = useParentRect ? rect[2] - rect[0] + HORIZONTAL_SPACE_AFTER_ANNOTATION : 0;
        const popupLeft = normalizedRect[0] + parentWidth;
        const popupTop = normalizedRect[1];
        this.#position = [
            100 * (popupLeft - pageX) / pageWidth,
            100 * (popupTop - pageY) / pageHeight
        ];
        const { style: style } = this.#container;
        style.left = `${this.#position[0]}%`;
        style.top = `${this.#position[1]}%`;
    }
    #toggle() {
        if (this.#commentManager) {
            this.#commentManager.toggleCommentPopup(this, false);
            return;
        }
        this.#pinned = !this.#pinned;
        if (this.#pinned) {
            this.#show();
            this.#container.addEventListener("click", this.#boundToggle);
            this.#container.addEventListener("keydown", this.#boundKeyDown);
        } else {
            this.#hide();
            this.#container.removeEventListener("click", this.#boundToggle);
            this.#container.removeEventListener("keydown", this.#boundKeyDown);
        }
    }
    #show() {
        if (!this.#popup) this.render();
        if (!this.isVisible) {
            this.#setPosition();
            this.#container.hidden = false;
            this.#container.style.zIndex = parseInt(this.#container.style.zIndex) + 1000;
        } else if (this.#pinned) this.#container.classList.add("focused");
    }
    #hide() {
        this.#container.classList.remove("focused");
        if (this.#pinned || !this.isVisible) return;
        this.#container.hidden = true;
        this.#container.style.zIndex = parseInt(this.#container.style.zIndex) - 1000;
    }
    forceHide() {
        this.#wasVisible = this.isVisible;
        if (!this.#wasVisible) return;
        this.#container.hidden = true;
    }
    maybeShow() {
        if (this.#commentManager) return;
        this.#addEventListeners();
        if (!this.#wasVisible) return;
        if (!this.#popup) this.#show();
        this.#wasVisible = false;
        this.#container.hidden = false;
    }
    get isVisible() {
        if (this.#commentManager) return false;
        return this.#container.hidden === false;
    }
}
class $9ef033443a74bee6$var$FreeTextAnnotationElement extends $9ef033443a74bee6$var$AnnotationElement {
    constructor(parameters){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: true
        });
        this.textContent = parameters.data.textContent;
        this.textPosition = parameters.data.textPosition;
        this.annotationEditorType = $9ef033443a74bee6$export$72ea3bfdd9a725bf.FREETEXT;
    }
    render() {
        this.container.classList.add("freeTextAnnotation");
        if (this.textContent) {
            const content = document.createElement("div");
            content.classList.add("annotationTextContent");
            content.setAttribute("role", "comment");
            for (const line of this.textContent){
                const lineSpan = document.createElement("span");
                lineSpan.textContent = line;
                content.append(lineSpan);
            }
            this.container.append(content);
        }
        if (!this.data.popupRef && this.hasPopupData) this._createPopup();
        this._editOnDoubleClick();
        return this.container;
    }
}
class $9ef033443a74bee6$var$LineAnnotationElement extends $9ef033443a74bee6$var$AnnotationElement {
    #line = null;
    constructor(parameters){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: true
        });
    }
    render() {
        this.container.classList.add("lineAnnotation");
        const { data: data, width: width, height: height } = this;
        const svg = this.svgFactory.create(width, height, true);
        const line = this.#line = this.svgFactory.createElement("svg:line");
        line.setAttribute("x1", data.rect[2] - data.lineCoordinates[0]);
        line.setAttribute("y1", data.rect[3] - data.lineCoordinates[1]);
        line.setAttribute("x2", data.rect[2] - data.lineCoordinates[2]);
        line.setAttribute("y2", data.rect[3] - data.lineCoordinates[3]);
        line.setAttribute("stroke-width", data.borderStyle.width || 1);
        line.setAttribute("stroke", "transparent");
        line.setAttribute("fill", "transparent");
        svg.append(line);
        this.container.append(svg);
        if (!data.popupRef && this.hasPopupData) this._createPopup();
        return this.container;
    }
    getElementsToTriggerPopup() {
        return this.#line;
    }
    addHighlightArea() {
        this.container.classList.add("highlightArea");
    }
}
class $9ef033443a74bee6$var$SquareAnnotationElement extends $9ef033443a74bee6$var$AnnotationElement {
    #square = null;
    constructor(parameters){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: true
        });
    }
    render() {
        this.container.classList.add("squareAnnotation");
        const { data: data, width: width, height: height } = this;
        const svg = this.svgFactory.create(width, height, true);
        const borderWidth = data.borderStyle.width;
        const square = this.#square = this.svgFactory.createElement("svg:rect");
        square.setAttribute("x", borderWidth / 2);
        square.setAttribute("y", borderWidth / 2);
        square.setAttribute("width", width - borderWidth);
        square.setAttribute("height", height - borderWidth);
        square.setAttribute("stroke-width", borderWidth || 1);
        square.setAttribute("stroke", "transparent");
        square.setAttribute("fill", "transparent");
        svg.append(square);
        this.container.append(svg);
        if (!data.popupRef && this.hasPopupData) this._createPopup();
        return this.container;
    }
    getElementsToTriggerPopup() {
        return this.#square;
    }
    addHighlightArea() {
        this.container.classList.add("highlightArea");
    }
}
class $9ef033443a74bee6$var$CircleAnnotationElement extends $9ef033443a74bee6$var$AnnotationElement {
    #circle = null;
    constructor(parameters){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: true
        });
    }
    render() {
        this.container.classList.add("circleAnnotation");
        const { data: data, width: width, height: height } = this;
        const svg = this.svgFactory.create(width, height, true);
        const borderWidth = data.borderStyle.width;
        const circle = this.#circle = this.svgFactory.createElement("svg:ellipse");
        circle.setAttribute("cx", width / 2);
        circle.setAttribute("cy", height / 2);
        circle.setAttribute("rx", width / 2 - borderWidth / 2);
        circle.setAttribute("ry", height / 2 - borderWidth / 2);
        circle.setAttribute("stroke-width", borderWidth || 1);
        circle.setAttribute("stroke", "transparent");
        circle.setAttribute("fill", "transparent");
        svg.append(circle);
        this.container.append(svg);
        if (!data.popupRef && this.hasPopupData) this._createPopup();
        return this.container;
    }
    getElementsToTriggerPopup() {
        return this.#circle;
    }
    addHighlightArea() {
        this.container.classList.add("highlightArea");
    }
}
class $9ef033443a74bee6$var$PolylineAnnotationElement extends $9ef033443a74bee6$var$AnnotationElement {
    #polyline = null;
    constructor(parameters){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: true
        });
        this.containerClassName = "polylineAnnotation";
        this.svgElementName = "svg:polyline";
    }
    render() {
        this.container.classList.add(this.containerClassName);
        const { data: { rect: rect, vertices: vertices, borderStyle: borderStyle, popupRef: popupRef }, width: width, height: height } = this;
        if (!vertices) return this.container;
        const svg = this.svgFactory.create(width, height, true);
        let points = [];
        for(let i = 0, ii = vertices.length; i < ii; i += 2){
            const x = vertices[i] - rect[0];
            const y = rect[3] - vertices[i + 1];
            points.push(`${x},${y}`);
        }
        points = points.join(" ");
        const polyline = this.#polyline = this.svgFactory.createElement(this.svgElementName);
        polyline.setAttribute("points", points);
        polyline.setAttribute("stroke-width", borderStyle.width || 1);
        polyline.setAttribute("stroke", "transparent");
        polyline.setAttribute("fill", "transparent");
        svg.append(polyline);
        this.container.append(svg);
        if (!popupRef && this.hasPopupData) this._createPopup();
        return this.container;
    }
    getElementsToTriggerPopup() {
        return this.#polyline;
    }
    addHighlightArea() {
        this.container.classList.add("highlightArea");
    }
}
class $9ef033443a74bee6$var$PolygonAnnotationElement extends $9ef033443a74bee6$var$PolylineAnnotationElement {
    constructor(parameters){
        super(parameters);
        this.containerClassName = "polygonAnnotation";
        this.svgElementName = "svg:polygon";
    }
}
class $9ef033443a74bee6$var$CaretAnnotationElement extends $9ef033443a74bee6$var$AnnotationElement {
    constructor(parameters){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: true
        });
    }
    render() {
        this.container.classList.add("caretAnnotation");
        if (!this.data.popupRef && this.hasPopupData) this._createPopup();
        return this.container;
    }
}
class $9ef033443a74bee6$var$InkAnnotationElement extends $9ef033443a74bee6$var$AnnotationElement {
    #polylinesGroupElement = null;
    #polylines = [];
    constructor(parameters){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: true
        });
        this.containerClassName = "inkAnnotation";
        this.svgElementName = "svg:polyline";
        this.annotationEditorType = this.data.it === "InkHighlight" ? $9ef033443a74bee6$export$72ea3bfdd9a725bf.HIGHLIGHT : $9ef033443a74bee6$export$72ea3bfdd9a725bf.INK;
    }
    #getTransform(rotation, rect) {
        switch(rotation){
            case 90:
                return {
                    transform: `rotate(90) translate(${-rect[0]},${rect[1]}) scale(1,-1)`,
                    width: rect[3] - rect[1],
                    height: rect[2] - rect[0]
                };
            case 180:
                return {
                    transform: `rotate(180) translate(${-rect[2]},${rect[1]}) scale(1,-1)`,
                    width: rect[2] - rect[0],
                    height: rect[3] - rect[1]
                };
            case 270:
                return {
                    transform: `rotate(270) translate(${-rect[2]},${rect[3]}) scale(1,-1)`,
                    width: rect[3] - rect[1],
                    height: rect[2] - rect[0]
                };
            default:
                return {
                    transform: `translate(${-rect[0]},${rect[3]}) scale(1,-1)`,
                    width: rect[2] - rect[0],
                    height: rect[3] - rect[1]
                };
        }
    }
    render() {
        this.container.classList.add(this.containerClassName);
        const { data: { rect: rect, rotation: rotation, inkLists: inkLists, borderStyle: borderStyle, popupRef: popupRef } } = this;
        const { transform: transform, width: width, height: height } = this.#getTransform(rotation, rect);
        const svg = this.svgFactory.create(width, height, true);
        const g = this.#polylinesGroupElement = this.svgFactory.createElement("svg:g");
        svg.append(g);
        g.setAttribute("stroke-width", borderStyle.width || 1);
        g.setAttribute("stroke-linecap", "round");
        g.setAttribute("stroke-linejoin", "round");
        g.setAttribute("stroke-miterlimit", 10);
        g.setAttribute("stroke", "transparent");
        g.setAttribute("fill", "transparent");
        g.setAttribute("transform", transform);
        for(let i = 0, ii = inkLists.length; i < ii; i++){
            const polyline = this.svgFactory.createElement(this.svgElementName);
            this.#polylines.push(polyline);
            polyline.setAttribute("points", inkLists[i].join(","));
            g.append(polyline);
        }
        if (!popupRef && this.hasPopupData) this._createPopup();
        this.container.append(svg);
        this._editOnDoubleClick();
        return this.container;
    }
    updateEdited(params) {
        super.updateEdited(params);
        const { thickness: thickness, points: points, rect: rect } = params;
        const g = this.#polylinesGroupElement;
        if (thickness >= 0) g.setAttribute("stroke-width", thickness || 1);
        if (points) for(let i = 0, ii = this.#polylines.length; i < ii; i++)this.#polylines[i].setAttribute("points", points[i].join(","));
        if (rect) {
            const { transform: transform, width: width, height: height } = this.#getTransform(this.data.rotation, rect);
            const root = g.parentElement;
            root.setAttribute("viewBox", `0 0 ${width} ${height}`);
            g.setAttribute("transform", transform);
        }
    }
    getElementsToTriggerPopup() {
        return this.#polylines;
    }
    addHighlightArea() {
        this.container.classList.add("highlightArea");
    }
}
class $9ef033443a74bee6$var$HighlightAnnotationElement extends $9ef033443a74bee6$var$AnnotationElement {
    constructor(parameters){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: true,
            createQuadrilaterals: true
        });
        this.annotationEditorType = $9ef033443a74bee6$export$72ea3bfdd9a725bf.HIGHLIGHT;
    }
    render() {
        const { data: { overlaidText: overlaidText, popupRef: popupRef } } = this;
        if (!popupRef && this.hasPopupData) this._createPopup();
        this.container.classList.add("highlightAnnotation");
        this._editOnDoubleClick();
        if (overlaidText) {
            const mark = document.createElement("mark");
            mark.classList.add("overlaidText");
            mark.textContent = overlaidText;
            this.container.append(mark);
        }
        return this.container;
    }
}
class $9ef033443a74bee6$var$UnderlineAnnotationElement extends $9ef033443a74bee6$var$AnnotationElement {
    constructor(parameters){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: true,
            createQuadrilaterals: true
        });
    }
    render() {
        const { data: { overlaidText: overlaidText, popupRef: popupRef } } = this;
        if (!popupRef && this.hasPopupData) this._createPopup();
        this.container.classList.add("underlineAnnotation");
        if (overlaidText) {
            const underline = document.createElement("u");
            underline.classList.add("overlaidText");
            underline.textContent = overlaidText;
            this.container.append(underline);
        }
        return this.container;
    }
}
class $9ef033443a74bee6$var$SquigglyAnnotationElement extends $9ef033443a74bee6$var$AnnotationElement {
    constructor(parameters){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: true,
            createQuadrilaterals: true
        });
    }
    render() {
        const { data: { overlaidText: overlaidText, popupRef: popupRef } } = this;
        if (!popupRef && this.hasPopupData) this._createPopup();
        this.container.classList.add("squigglyAnnotation");
        if (overlaidText) {
            const underline = document.createElement("u");
            underline.classList.add("overlaidText");
            underline.textContent = overlaidText;
            this.container.append(underline);
        }
        return this.container;
    }
}
class $9ef033443a74bee6$var$StrikeOutAnnotationElement extends $9ef033443a74bee6$var$AnnotationElement {
    constructor(parameters){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: true,
            createQuadrilaterals: true
        });
    }
    render() {
        const { data: { overlaidText: overlaidText, popupRef: popupRef } } = this;
        if (!popupRef && this.hasPopupData) this._createPopup();
        this.container.classList.add("strikeoutAnnotation");
        if (overlaidText) {
            const strikeout = document.createElement("s");
            strikeout.classList.add("overlaidText");
            strikeout.textContent = overlaidText;
            this.container.append(strikeout);
        }
        return this.container;
    }
}
class $9ef033443a74bee6$var$StampAnnotationElement extends $9ef033443a74bee6$var$AnnotationElement {
    constructor(parameters){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: true
        });
        this.annotationEditorType = $9ef033443a74bee6$export$72ea3bfdd9a725bf.STAMP;
    }
    render() {
        this.container.classList.add("stampAnnotation");
        this.container.setAttribute("role", "img");
        if (!this.data.popupRef && this.hasPopupData) this._createPopup();
        this._editOnDoubleClick();
        return this.container;
    }
}
class $9ef033443a74bee6$var$FileAttachmentAnnotationElement extends $9ef033443a74bee6$var$AnnotationElement {
    #trigger = null;
    constructor(parameters){
        super(parameters, {
            isRenderable: true
        });
        const { file: file } = this.data;
        this.filename = file.filename;
        this.content = file.content;
        this.linkService.eventBus?.dispatch("fileattachmentannotation", {
            source: this,
            ...file
        });
    }
    render() {
        this.container.classList.add("fileAttachmentAnnotation");
        const { container: container, data: data } = this;
        let trigger;
        if (data.hasAppearance || data.fillAlpha === 0) trigger = document.createElement("div");
        else {
            trigger = document.createElement("img");
            trigger.src = `${this.imageResourcesPath}annotation-${/paperclip/i.test(data.name) ? "paperclip" : "pushpin"}.svg`;
            if (data.fillAlpha && data.fillAlpha < 1) trigger.style = `filter: opacity(${Math.round(data.fillAlpha * 100)}%);`;
        }
        trigger.addEventListener("dblclick", this.#download.bind(this));
        this.#trigger = trigger;
        const { isMac: isMac } = $9ef033443a74bee6$export$5fb8891d35c36978.platform;
        container.addEventListener("keydown", (evt)=>{
            if (evt.key === "Enter" && (isMac ? evt.metaKey : evt.ctrlKey)) this.#download();
        });
        if (!data.popupRef && this.hasPopupData) this._createPopup();
        else trigger.classList.add("popupTriggerArea");
        container.append(trigger);
        return container;
    }
    getElementsToTriggerPopup() {
        return this.#trigger;
    }
    addHighlightArea() {
        this.container.classList.add("highlightArea");
    }
    #download() {
        this.downloadManager?.openOrDownloadData(this.content, this.filename);
    }
}
class $9ef033443a74bee6$export$3e7f45c326d9366c {
    #accessibilityManager = null;
    #annotationCanvasMap = null;
    #annotationStorage = null;
    #editableAnnotations = new Map();
    #structTreeLayer = null;
    #linkService = null;
    constructor({ div: div, accessibilityManager: accessibilityManager, annotationCanvasMap: annotationCanvasMap, annotationEditorUIManager: annotationEditorUIManager, page: page, viewport: viewport, structTreeLayer: structTreeLayer, commentManager: commentManager, linkService: linkService, annotationStorage: annotationStorage }){
        this.div = div;
        this.#accessibilityManager = accessibilityManager;
        this.#annotationCanvasMap = annotationCanvasMap;
        this.#structTreeLayer = structTreeLayer || null;
        this.#linkService = linkService || null;
        this.#annotationStorage = annotationStorage || new $9ef033443a74bee6$var$AnnotationStorage();
        this.page = page;
        this.viewport = viewport;
        this.zIndex = 0;
        this._annotationEditorUIManager = annotationEditorUIManager;
        this._commentManager = commentManager || null;
    }
    hasEditableAnnotations() {
        return this.#editableAnnotations.size > 0;
    }
    async #appendElement(element, id, popupElements) {
        const contentElement = element.firstChild || element;
        const annotationId = contentElement.id = `${$9ef033443a74bee6$var$AnnotationPrefix}${id}`;
        const ariaAttributes = await this.#structTreeLayer?.getAriaAttributes(annotationId);
        if (ariaAttributes) for (const [key, value] of ariaAttributes)contentElement.setAttribute(key, value);
        if (popupElements) popupElements.at(-1).container.after(element);
        else {
            this.div.append(element);
            this.#accessibilityManager?.moveElementInDOM(this.div, element, contentElement, false);
        }
    }
    async render(params) {
        const { annotations: annotations } = params;
        const layer = this.div;
        $9ef033443a74bee6$export$af0a15a86e590226(layer, this.viewport);
        const popupToElements = new Map();
        const elementParams = {
            data: null,
            layer: layer,
            linkService: this.#linkService,
            downloadManager: params.downloadManager,
            imageResourcesPath: params.imageResourcesPath || "",
            renderForms: params.renderForms !== false,
            svgFactory: new $9ef033443a74bee6$export$425e69f00724e63a(),
            annotationStorage: this.#annotationStorage,
            enableComment: params.enableComment === true,
            enableScripting: params.enableScripting === true,
            hasJSActions: params.hasJSActions,
            fieldObjects: params.fieldObjects,
            parent: this,
            elements: null
        };
        for (const data of annotations){
            if (data.noHTML) continue;
            const isPopupAnnotation = data.annotationType === $9ef033443a74bee6$export$f50c3066a53a6f2c.POPUP;
            if (!isPopupAnnotation) {
                if (data.rect[2] === data.rect[0] || data.rect[3] === data.rect[1]) continue;
            } else {
                const elements = popupToElements.get(data.id);
                if (!elements) continue;
                elementParams.elements = elements;
            }
            elementParams.data = data;
            const element = $9ef033443a74bee6$var$AnnotationElementFactory.create(elementParams);
            if (!element.isRenderable) continue;
            if (!isPopupAnnotation && data.popupRef) {
                const elements = popupToElements.get(data.popupRef);
                if (!elements) popupToElements.set(data.popupRef, [
                    element
                ]);
                else elements.push(element);
            }
            const rendered = element.render();
            if (data.hidden) rendered.style.visibility = "hidden";
            await this.#appendElement(rendered, data.id, elementParams.elements);
            element.extraPopupElement?.popup?.renderCommentButton();
            if (element._isEditable) {
                this.#editableAnnotations.set(element.data.id, element);
                this._annotationEditorUIManager?.renderAnnotationElement(element);
            }
        }
        this.#setAnnotationCanvasMap();
    }
    async addLinkAnnotations(annotations) {
        const elementParams = {
            data: null,
            layer: this.div,
            linkService: this.#linkService,
            svgFactory: new $9ef033443a74bee6$export$425e69f00724e63a(),
            parent: this
        };
        for (const data of annotations){
            data.borderStyle ||= $9ef033443a74bee6$export$3e7f45c326d9366c._defaultBorderStyle;
            elementParams.data = data;
            const element = $9ef033443a74bee6$var$AnnotationElementFactory.create(elementParams);
            if (!element.isRenderable) continue;
            const rendered = element.render();
            await this.#appendElement(rendered, data.id, null);
        }
    }
    update({ viewport: viewport }) {
        const layer = this.div;
        this.viewport = viewport;
        $9ef033443a74bee6$export$af0a15a86e590226(layer, {
            rotation: viewport.rotation
        });
        this.#setAnnotationCanvasMap();
        layer.hidden = false;
    }
    #setAnnotationCanvasMap() {
        if (!this.#annotationCanvasMap) return;
        const layer = this.div;
        for (const [id, canvas] of this.#annotationCanvasMap){
            const element = layer.querySelector(`[data-annotation-id="${id}"]`);
            if (!element) continue;
            canvas.className = "annotationContent";
            const { firstChild: firstChild } = element;
            if (!firstChild) element.append(canvas);
            else if (firstChild.nodeName === "CANVAS") firstChild.replaceWith(canvas);
            else if (!firstChild.classList.contains("annotationContent")) firstChild.before(canvas);
            else firstChild.after(canvas);
            const editableAnnotation = this.#editableAnnotations.get(id);
            if (!editableAnnotation) continue;
            if (editableAnnotation._hasNoCanvas) {
                this._annotationEditorUIManager?.setMissingCanvas(id, element.id, canvas);
                editableAnnotation._hasNoCanvas = false;
            } else editableAnnotation.canvas = canvas;
        }
        this.#annotationCanvasMap.clear();
    }
    getEditableAnnotations() {
        return Array.from(this.#editableAnnotations.values());
    }
    getEditableAnnotation(id) {
        return this.#editableAnnotations.get(id);
    }
    addFakeAnnotation(editor) {
        const { div: div } = this;
        const { id: id, rotation: rotation } = editor;
        const element = new $9ef033443a74bee6$var$EditorAnnotationElement({
            data: {
                id: id,
                rect: editor.getPDFRect(),
                rotation: rotation
            },
            editor: editor,
            layer: div,
            parent: this,
            enableComment: !!this._commentManager,
            linkService: this.#linkService,
            annotationStorage: this.#annotationStorage
        });
        const htmlElement = element.render();
        div.append(htmlElement);
        this.#accessibilityManager?.moveElementInDOM(div, htmlElement, htmlElement, false);
        element.createOrUpdatePopup();
        return element;
    }
    static get _defaultBorderStyle() {
        return $9ef033443a74bee6$export$b8972b998723d602(this, "_defaultBorderStyle", Object.freeze({
            width: 1,
            rawWidth: 1,
            style: $9ef033443a74bee6$var$AnnotationBorderStyleType.SOLID,
            dashArray: [
                3
            ],
            horizontalCornerRadius: 0,
            verticalCornerRadius: 0
        }));
    }
}
const $9ef033443a74bee6$var$EOL_PATTERN = /\r\n?|\n/g;
class $9ef033443a74bee6$var$FreeTextEditor extends $9ef033443a74bee6$var$AnnotationEditor {
    #content = "";
    #editorDivId = `${this.id}-editor`;
    #editModeAC = null;
    #fontSize;
    _colorPicker = null;
    static _freeTextDefaultContent = "";
    static _internalPadding = 0;
    static _defaultColor = null;
    static _defaultFontSize = 10;
    static get _keyboardManager() {
        const proto = $9ef033443a74bee6$var$FreeTextEditor.prototype;
        const arrowChecker = (self)=>self.isEmpty();
        const small = $9ef033443a74bee6$export$26cb16552a82cf63.TRANSLATE_SMALL;
        const big = $9ef033443a74bee6$export$26cb16552a82cf63.TRANSLATE_BIG;
        return $9ef033443a74bee6$export$b8972b998723d602(this, "_keyboardManager", new $9ef033443a74bee6$var$KeyboardManager([
            [
                [
                    "ctrl+s",
                    "mac+meta+s",
                    "ctrl+p",
                    "mac+meta+p"
                ],
                proto.commitOrRemove,
                {
                    bubbles: true
                }
            ],
            [
                [
                    "ctrl+Enter",
                    "mac+meta+Enter",
                    "Escape",
                    "mac+Escape"
                ],
                proto.commitOrRemove
            ],
            [
                [
                    "ArrowLeft",
                    "mac+ArrowLeft"
                ],
                proto._translateEmpty,
                {
                    args: [
                        -small,
                        0
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ctrl+ArrowLeft",
                    "mac+shift+ArrowLeft"
                ],
                proto._translateEmpty,
                {
                    args: [
                        -big,
                        0
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ArrowRight",
                    "mac+ArrowRight"
                ],
                proto._translateEmpty,
                {
                    args: [
                        small,
                        0
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ctrl+ArrowRight",
                    "mac+shift+ArrowRight"
                ],
                proto._translateEmpty,
                {
                    args: [
                        big,
                        0
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ArrowUp",
                    "mac+ArrowUp"
                ],
                proto._translateEmpty,
                {
                    args: [
                        0,
                        -small
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ctrl+ArrowUp",
                    "mac+shift+ArrowUp"
                ],
                proto._translateEmpty,
                {
                    args: [
                        0,
                        -big
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ArrowDown",
                    "mac+ArrowDown"
                ],
                proto._translateEmpty,
                {
                    args: [
                        0,
                        small
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ctrl+ArrowDown",
                    "mac+shift+ArrowDown"
                ],
                proto._translateEmpty,
                {
                    args: [
                        0,
                        big
                    ],
                    checker: arrowChecker
                }
            ]
        ]));
    }
    static _type = "freetext";
    static _editorType = $9ef033443a74bee6$export$72ea3bfdd9a725bf.FREETEXT;
    constructor(params){
        super({
            ...params,
            name: "freeTextEditor"
        });
        this.color = params.color || $9ef033443a74bee6$var$FreeTextEditor._defaultColor || $9ef033443a74bee6$var$AnnotationEditor._defaultLineColor;
        this.#fontSize = params.fontSize || $9ef033443a74bee6$var$FreeTextEditor._defaultFontSize;
        if (!this.annotationElementId) this._uiManager.a11yAlert("pdfjs-editor-freetext-added-alert");
    }
    static initialize(l10n, uiManager) {
        $9ef033443a74bee6$var$AnnotationEditor.initialize(l10n, uiManager);
        const style = getComputedStyle(document.documentElement);
        this._internalPadding = parseFloat(style.getPropertyValue("--freetext-padding"));
    }
    static updateDefaultParams(type, value) {
        switch(type){
            case $9ef033443a74bee6$export$cf3df2a6ecc26692.FREETEXT_SIZE:
                $9ef033443a74bee6$var$FreeTextEditor._defaultFontSize = value;
                break;
            case $9ef033443a74bee6$export$cf3df2a6ecc26692.FREETEXT_COLOR:
                $9ef033443a74bee6$var$FreeTextEditor._defaultColor = value;
                break;
        }
    }
    updateParams(type, value) {
        switch(type){
            case $9ef033443a74bee6$export$cf3df2a6ecc26692.FREETEXT_SIZE:
                this.#updateFontSize(value);
                break;
            case $9ef033443a74bee6$export$cf3df2a6ecc26692.FREETEXT_COLOR:
                this.#updateColor(value);
                break;
        }
    }
    static get defaultPropertiesToUpdate() {
        return [
            [
                $9ef033443a74bee6$export$cf3df2a6ecc26692.FREETEXT_SIZE,
                $9ef033443a74bee6$var$FreeTextEditor._defaultFontSize
            ],
            [
                $9ef033443a74bee6$export$cf3df2a6ecc26692.FREETEXT_COLOR,
                $9ef033443a74bee6$var$FreeTextEditor._defaultColor || $9ef033443a74bee6$var$AnnotationEditor._defaultLineColor
            ]
        ];
    }
    get propertiesToUpdate() {
        return [
            [
                $9ef033443a74bee6$export$cf3df2a6ecc26692.FREETEXT_SIZE,
                this.#fontSize
            ],
            [
                $9ef033443a74bee6$export$cf3df2a6ecc26692.FREETEXT_COLOR,
                this.color
            ]
        ];
    }
    get toolbarButtons() {
        this._colorPicker ||= new $9ef033443a74bee6$var$BasicColorPicker(this);
        return [
            [
                "colorPicker",
                this._colorPicker
            ]
        ];
    }
    get colorType() {
        return $9ef033443a74bee6$export$cf3df2a6ecc26692.FREETEXT_COLOR;
    }
    #updateFontSize(fontSize) {
        const setFontsize = (size)=>{
            this.editorDiv.style.fontSize = `calc(${size}px * var(--total-scale-factor))`;
            this.translate(0, -(size - this.#fontSize) * this.parentScale);
            this.#fontSize = size;
            this.#setEditorDimensions();
        };
        const savedFontsize = this.#fontSize;
        this.addCommands({
            cmd: setFontsize.bind(this, fontSize),
            undo: setFontsize.bind(this, savedFontsize),
            post: this._uiManager.updateUI.bind(this._uiManager, this),
            mustExec: true,
            type: $9ef033443a74bee6$export$cf3df2a6ecc26692.FREETEXT_SIZE,
            overwriteIfSameType: true,
            keepUndo: true
        });
    }
    onUpdatedColor() {
        this.editorDiv.style.color = this.color;
        this._colorPicker?.update(this.color);
        super.onUpdatedColor();
    }
    #updateColor(color) {
        const setColor = (col)=>{
            this.color = col;
            this.onUpdatedColor();
        };
        const savedColor = this.color;
        this.addCommands({
            cmd: setColor.bind(this, color),
            undo: setColor.bind(this, savedColor),
            post: this._uiManager.updateUI.bind(this._uiManager, this),
            mustExec: true,
            type: $9ef033443a74bee6$export$cf3df2a6ecc26692.FREETEXT_COLOR,
            overwriteIfSameType: true,
            keepUndo: true
        });
    }
    _translateEmpty(x, y) {
        this._uiManager.translateSelectedEditors(x, y, true);
    }
    getInitialTranslation() {
        const scale = this.parentScale;
        return [
            -$9ef033443a74bee6$var$FreeTextEditor._internalPadding * scale,
            -($9ef033443a74bee6$var$FreeTextEditor._internalPadding + this.#fontSize) * scale
        ];
    }
    rebuild() {
        if (!this.parent) return;
        super.rebuild();
        if (this.div === null) return;
        if (!this.isAttachedToDOM) this.parent.add(this);
    }
    enableEditMode() {
        if (!super.enableEditMode()) return false;
        this.overlayDiv.classList.remove("enabled");
        this.editorDiv.contentEditable = true;
        this._isDraggable = false;
        this.div.removeAttribute("aria-activedescendant");
        this.#editModeAC = new AbortController();
        const signal = this._uiManager.combinedSignal(this.#editModeAC);
        this.editorDiv.addEventListener("keydown", this.editorDivKeydown.bind(this), {
            signal: signal
        });
        this.editorDiv.addEventListener("focus", this.editorDivFocus.bind(this), {
            signal: signal
        });
        this.editorDiv.addEventListener("blur", this.editorDivBlur.bind(this), {
            signal: signal
        });
        this.editorDiv.addEventListener("input", this.editorDivInput.bind(this), {
            signal: signal
        });
        this.editorDiv.addEventListener("paste", this.editorDivPaste.bind(this), {
            signal: signal
        });
        return true;
    }
    disableEditMode() {
        if (!super.disableEditMode()) return false;
        this.overlayDiv.classList.add("enabled");
        this.editorDiv.contentEditable = false;
        this.div.setAttribute("aria-activedescendant", this.#editorDivId);
        this._isDraggable = true;
        this.#editModeAC?.abort();
        this.#editModeAC = null;
        this.div.focus({
            preventScroll: true
        });
        this.isEditing = false;
        this.parent.div.classList.add("freetextEditing");
        return true;
    }
    focusin(event) {
        if (!this._focusEventsAllowed) return;
        super.focusin(event);
        if (event.target !== this.editorDiv) this.editorDiv.focus();
    }
    onceAdded(focus) {
        if (this.width) return;
        this.enableEditMode();
        if (focus) this.editorDiv.focus();
        if (this._initialOptions?.isCentered) this.center();
        this._initialOptions = null;
    }
    isEmpty() {
        return !this.editorDiv || this.editorDiv.innerText.trim() === "";
    }
    remove() {
        this.isEditing = false;
        if (this.parent) {
            this.parent.setEditingState(true);
            this.parent.div.classList.add("freetextEditing");
        }
        super.remove();
    }
    #extractText() {
        const buffer = [];
        this.editorDiv.normalize();
        let prevChild = null;
        for (const child of this.editorDiv.childNodes){
            if (prevChild?.nodeType === Node.TEXT_NODE && child.nodeName === "BR") continue;
            buffer.push($9ef033443a74bee6$var$FreeTextEditor.#getNodeContent(child));
            prevChild = child;
        }
        return buffer.join("\n");
    }
    #setEditorDimensions() {
        const [parentWidth, parentHeight] = this.parentDimensions;
        let rect;
        if (this.isAttachedToDOM) rect = this.div.getBoundingClientRect();
        else {
            const { currentLayer: currentLayer, div: div } = this;
            const savedDisplay = div.style.display;
            const savedVisibility = div.classList.contains("hidden");
            div.classList.remove("hidden");
            div.style.display = "hidden";
            currentLayer.div.append(this.div);
            rect = div.getBoundingClientRect();
            div.remove();
            div.style.display = savedDisplay;
            div.classList.toggle("hidden", savedVisibility);
        }
        if (this.rotation % 180 === this.parentRotation % 180) {
            this.width = rect.width / parentWidth;
            this.height = rect.height / parentHeight;
        } else {
            this.width = rect.height / parentWidth;
            this.height = rect.width / parentHeight;
        }
        this.fixAndSetPosition();
    }
    commit() {
        if (!this.isInEditMode()) return;
        super.commit();
        this.disableEditMode();
        const savedText = this.#content;
        const newText = this.#content = this.#extractText().trimEnd();
        if (savedText === newText) return;
        const setText = (text)=>{
            this.#content = text;
            if (!text) {
                this.remove();
                return;
            }
            this.#setContent();
            this._uiManager.rebuild(this);
            this.#setEditorDimensions();
        };
        this.addCommands({
            cmd: ()=>{
                setText(newText);
            },
            undo: ()=>{
                setText(savedText);
            },
            mustExec: false
        });
        this.#setEditorDimensions();
    }
    shouldGetKeyboardEvents() {
        return this.isInEditMode();
    }
    enterInEditMode() {
        this.enableEditMode();
        this.editorDiv.focus();
    }
    keydown(event) {
        if (event.target === this.div && event.key === "Enter") {
            this.enterInEditMode();
            event.preventDefault();
        }
    }
    editorDivKeydown(event) {
        $9ef033443a74bee6$var$FreeTextEditor._keyboardManager.exec(this, event);
    }
    editorDivFocus(event) {
        this.isEditing = true;
    }
    editorDivBlur(event) {
        this.isEditing = false;
    }
    editorDivInput(event) {
        this.parent.div.classList.toggle("freetextEditing", this.isEmpty());
    }
    disableEditing() {
        this.editorDiv.setAttribute("role", "comment");
        this.editorDiv.removeAttribute("aria-multiline");
    }
    enableEditing() {
        this.editorDiv.setAttribute("role", "textbox");
        this.editorDiv.setAttribute("aria-multiline", true);
    }
    get canChangeContent() {
        return true;
    }
    render() {
        if (this.div) return this.div;
        let baseX, baseY;
        if (this._isCopy || this.annotationElementId) {
            baseX = this.x;
            baseY = this.y;
        }
        super.render();
        this.editorDiv = document.createElement("div");
        this.editorDiv.className = "internal";
        this.editorDiv.setAttribute("id", this.#editorDivId);
        this.editorDiv.setAttribute("data-l10n-id", "pdfjs-free-text2");
        this.editorDiv.setAttribute("data-l10n-attrs", "default-content");
        this.enableEditing();
        this.editorDiv.contentEditable = true;
        const { style: style } = this.editorDiv;
        style.fontSize = `calc(${this.#fontSize}px * var(--total-scale-factor))`;
        style.color = this.color;
        this.div.append(this.editorDiv);
        this.overlayDiv = document.createElement("div");
        this.overlayDiv.classList.add("overlay", "enabled");
        this.div.append(this.overlayDiv);
        if (this._isCopy || this.annotationElementId) {
            const [parentWidth, parentHeight] = this.parentDimensions;
            if (this.annotationElementId) {
                const { position: position } = this._initialData;
                let [tx, ty] = this.getInitialTranslation();
                [tx, ty] = this.pageTranslationToScreen(tx, ty);
                const [pageWidth, pageHeight] = this.pageDimensions;
                const [pageX, pageY] = this.pageTranslation;
                let posX, posY;
                switch(this.rotation){
                    case 0:
                        posX = baseX + (position[0] - pageX) / pageWidth;
                        posY = baseY + this.height - (position[1] - pageY) / pageHeight;
                        break;
                    case 90:
                        posX = baseX + (position[0] - pageX) / pageWidth;
                        posY = baseY - (position[1] - pageY) / pageHeight;
                        [tx, ty] = [
                            ty,
                            -tx
                        ];
                        break;
                    case 180:
                        posX = baseX - this.width + (position[0] - pageX) / pageWidth;
                        posY = baseY - (position[1] - pageY) / pageHeight;
                        [tx, ty] = [
                            -tx,
                            -ty
                        ];
                        break;
                    case 270:
                        posX = baseX + (position[0] - pageX - this.height * pageHeight) / pageWidth;
                        posY = baseY + (position[1] - pageY - this.width * pageWidth) / pageHeight;
                        [tx, ty] = [
                            -ty,
                            tx
                        ];
                        break;
                }
                this.setAt(posX * parentWidth, posY * parentHeight, tx, ty);
            } else this._moveAfterPaste(baseX, baseY);
            this.#setContent();
            this._isDraggable = true;
            this.editorDiv.contentEditable = false;
        } else {
            this._isDraggable = false;
            this.editorDiv.contentEditable = true;
        }
        return this.div;
    }
    static #getNodeContent(node) {
        return (node.nodeType === Node.TEXT_NODE ? node.nodeValue : node.innerText).replaceAll($9ef033443a74bee6$var$EOL_PATTERN, "");
    }
    editorDivPaste(event) {
        const clipboardData = event.clipboardData || window.clipboardData;
        const { types: types } = clipboardData;
        if (types.length === 1 && types[0] === "text/plain") return;
        event.preventDefault();
        const paste = $9ef033443a74bee6$var$FreeTextEditor.#deserializeContent(clipboardData.getData("text") || "").replaceAll($9ef033443a74bee6$var$EOL_PATTERN, "\n");
        if (!paste) return;
        const selection = window.getSelection();
        if (!selection.rangeCount) return;
        this.editorDiv.normalize();
        selection.deleteFromDocument();
        const range = selection.getRangeAt(0);
        if (!paste.includes("\n")) {
            range.insertNode(document.createTextNode(paste));
            this.editorDiv.normalize();
            selection.collapseToStart();
            return;
        }
        const { startContainer: startContainer, startOffset: startOffset } = range;
        const bufferBefore = [];
        const bufferAfter = [];
        if (startContainer.nodeType === Node.TEXT_NODE) {
            const parent = startContainer.parentElement;
            bufferAfter.push(startContainer.nodeValue.slice(startOffset).replaceAll($9ef033443a74bee6$var$EOL_PATTERN, ""));
            if (parent !== this.editorDiv) {
                let buffer = bufferBefore;
                for (const child of this.editorDiv.childNodes){
                    if (child === parent) {
                        buffer = bufferAfter;
                        continue;
                    }
                    buffer.push($9ef033443a74bee6$var$FreeTextEditor.#getNodeContent(child));
                }
            }
            bufferBefore.push(startContainer.nodeValue.slice(0, startOffset).replaceAll($9ef033443a74bee6$var$EOL_PATTERN, ""));
        } else if (startContainer === this.editorDiv) {
            let buffer = bufferBefore;
            let i = 0;
            for (const child of this.editorDiv.childNodes){
                if (i++ === startOffset) buffer = bufferAfter;
                buffer.push($9ef033443a74bee6$var$FreeTextEditor.#getNodeContent(child));
            }
        }
        this.#content = `${bufferBefore.join("\n")}${paste}${bufferAfter.join("\n")}`;
        this.#setContent();
        const newRange = new Range();
        let beforeLength = Math.sumPrecise(bufferBefore.map((line)=>line.length));
        for (const { firstChild: firstChild } of this.editorDiv.childNodes)if (firstChild.nodeType === Node.TEXT_NODE) {
            const length = firstChild.nodeValue.length;
            if (beforeLength <= length) {
                newRange.setStart(firstChild, beforeLength);
                newRange.setEnd(firstChild, beforeLength);
                break;
            }
            beforeLength -= length;
        }
        selection.removeAllRanges();
        selection.addRange(newRange);
    }
    #setContent() {
        this.editorDiv.replaceChildren();
        if (!this.#content) return;
        for (const line of this.#content.split("\n")){
            const div = document.createElement("div");
            div.append(line ? document.createTextNode(line) : document.createElement("br"));
            this.editorDiv.append(div);
        }
    }
    #serializeContent() {
        return this.#content.replaceAll("\xa0", " ");
    }
    static #deserializeContent(content) {
        return content.replaceAll(" ", "\xa0");
    }
    get contentDiv() {
        return this.editorDiv;
    }
    getPDFRect() {
        const padding = $9ef033443a74bee6$var$FreeTextEditor._internalPadding * this.parentScale;
        return this.getRect(padding, padding);
    }
    static async deserialize(data, parent, uiManager) {
        let initialData = null;
        if (data instanceof $9ef033443a74bee6$var$FreeTextAnnotationElement) {
            const { data: { defaultAppearanceData: { fontSize: fontSize, fontColor: fontColor }, rect: rect, rotation: rotation, id: id, popupRef: popupRef, richText: richText, contentsObj: contentsObj, creationDate: creationDate, modificationDate: modificationDate }, textContent: textContent, textPosition: textPosition, parent: { page: { pageNumber: pageNumber } } } = data;
            if (!textContent || textContent.length === 0) return null;
            initialData = data = {
                annotationType: $9ef033443a74bee6$export$72ea3bfdd9a725bf.FREETEXT,
                color: Array.from(fontColor),
                fontSize: fontSize,
                value: textContent.join("\n"),
                position: textPosition,
                pageIndex: pageNumber - 1,
                rect: rect.slice(0),
                rotation: rotation,
                annotationElementId: id,
                id: id,
                deleted: false,
                popupRef: popupRef,
                comment: contentsObj?.str || null,
                richText: richText,
                creationDate: creationDate,
                modificationDate: modificationDate
            };
        }
        const editor = await super.deserialize(data, parent, uiManager);
        editor.#fontSize = data.fontSize;
        editor.color = $9ef033443a74bee6$export$f8f26dd395d7e1bd.makeHexColor(...data.color);
        editor.#content = $9ef033443a74bee6$var$FreeTextEditor.#deserializeContent(data.value);
        editor._initialData = initialData;
        if (data.comment) editor.setCommentData(data);
        return editor;
    }
    serialize(isForCopying = false) {
        if (this.isEmpty()) return null;
        if (this.deleted) return this.serializeDeleted();
        const color = $9ef033443a74bee6$var$AnnotationEditor._colorManager.convert(this.isAttachedToDOM ? getComputedStyle(this.editorDiv).color : this.color);
        const serialized = Object.assign(super.serialize(isForCopying), {
            color: color,
            fontSize: this.#fontSize,
            value: this.#serializeContent()
        });
        this.addComment(serialized);
        if (isForCopying) {
            serialized.isCopy = true;
            return serialized;
        }
        if (this.annotationElementId && !this.#hasElementChanged(serialized)) return null;
        serialized.id = this.annotationElementId;
        return serialized;
    }
    #hasElementChanged(serialized) {
        const { value: value, fontSize: fontSize, color: color, pageIndex: pageIndex } = this._initialData;
        return this.hasEditedComment || this._hasBeenMoved || serialized.value !== value || serialized.fontSize !== fontSize || serialized.color.some((c, i)=>c !== color[i]) || serialized.pageIndex !== pageIndex;
    }
    renderAnnotationElement(annotation) {
        const content = super.renderAnnotationElement(annotation);
        if (!content) return null;
        const { style: style } = content;
        style.fontSize = `calc(${this.#fontSize}px * var(--total-scale-factor))`;
        style.color = this.color;
        content.replaceChildren();
        for (const line of this.#content.split("\n")){
            const div = document.createElement("div");
            div.append(line ? document.createTextNode(line) : document.createElement("br"));
            content.append(div);
        }
        annotation.updateEdited({
            rect: this.getPDFRect(),
            popup: this._uiManager.hasCommentManager() || this.hasEditedComment ? this.comment : {
                text: this.#content
            }
        });
        return content;
    }
    resetAnnotationElement(annotation) {
        super.resetAnnotationElement(annotation);
        annotation.resetEdited();
    }
}
class $9ef033443a74bee6$var$Outline {
    static PRECISION = 1e-4;
    toSVGPath() {
        $9ef033443a74bee6$var$unreachable("Abstract method `toSVGPath` must be implemented.");
    }
    get box() {
        $9ef033443a74bee6$var$unreachable("Abstract getter `box` must be implemented.");
    }
    serialize(_bbox, _rotation) {
        $9ef033443a74bee6$var$unreachable("Abstract method `serialize` must be implemented.");
    }
    static _rescale(src, tx, ty, sx, sy, dest) {
        dest ||= new Float32Array(src.length);
        for(let i = 0, ii = src.length; i < ii; i += 2){
            dest[i] = tx + src[i] * sx;
            dest[i + 1] = ty + src[i + 1] * sy;
        }
        return dest;
    }
    static _rescaleAndSwap(src, tx, ty, sx, sy, dest) {
        dest ||= new Float32Array(src.length);
        for(let i = 0, ii = src.length; i < ii; i += 2){
            dest[i] = tx + src[i + 1] * sx;
            dest[i + 1] = ty + src[i] * sy;
        }
        return dest;
    }
    static _translate(src, tx, ty, dest) {
        dest ||= new Float32Array(src.length);
        for(let i = 0, ii = src.length; i < ii; i += 2){
            dest[i] = tx + src[i];
            dest[i + 1] = ty + src[i + 1];
        }
        return dest;
    }
    static svgRound(x) {
        return Math.round(x * 10000);
    }
    static _normalizePoint(x, y, parentWidth, parentHeight, rotation) {
        switch(rotation){
            case 90:
                return [
                    1 - y / parentWidth,
                    x / parentHeight
                ];
            case 180:
                return [
                    1 - x / parentWidth,
                    1 - y / parentHeight
                ];
            case 270:
                return [
                    y / parentWidth,
                    1 - x / parentHeight
                ];
            default:
                return [
                    x / parentWidth,
                    y / parentHeight
                ];
        }
    }
    static _normalizePagePoint(x, y, rotation) {
        switch(rotation){
            case 90:
                return [
                    1 - y,
                    x
                ];
            case 180:
                return [
                    1 - x,
                    1 - y
                ];
            case 270:
                return [
                    y,
                    1 - x
                ];
            default:
                return [
                    x,
                    y
                ];
        }
    }
    static createBezierPoints(x1, y1, x2, y2, x3, y3) {
        return [
            (x1 + 5 * x2) / 6,
            (y1 + 5 * y2) / 6,
            (5 * x2 + x3) / 6,
            (5 * y2 + y3) / 6,
            (x2 + x3) / 2,
            (y2 + y3) / 2
        ];
    }
}
class $9ef033443a74bee6$var$FreeDrawOutliner {
    #box;
    #bottom = [];
    #innerMargin;
    #isLTR;
    #top = [];
    #last = new Float32Array(18);
    #lastX;
    #lastY;
    #min;
    #min_dist;
    #scaleFactor;
    #thickness;
    #points = [];
    static #MIN_DIST = 8;
    static #MIN_DIFF = 2;
    static #MIN = $9ef033443a74bee6$var$FreeDrawOutliner.#MIN_DIST + $9ef033443a74bee6$var$FreeDrawOutliner.#MIN_DIFF;
    constructor({ x: x, y: y }, box, scaleFactor, thickness, isLTR, innerMargin = 0){
        this.#box = box;
        this.#thickness = thickness * scaleFactor;
        this.#isLTR = isLTR;
        this.#last.set([
            NaN,
            NaN,
            NaN,
            NaN,
            x,
            y
        ], 6);
        this.#innerMargin = innerMargin;
        this.#min_dist = $9ef033443a74bee6$var$FreeDrawOutliner.#MIN_DIST * scaleFactor;
        this.#min = $9ef033443a74bee6$var$FreeDrawOutliner.#MIN * scaleFactor;
        this.#scaleFactor = scaleFactor;
        this.#points.push(x, y);
    }
    isEmpty() {
        return isNaN(this.#last[8]);
    }
    #getLastCoords() {
        const lastTop = this.#last.subarray(4, 6);
        const lastBottom = this.#last.subarray(16, 18);
        const [x, y, width, height] = this.#box;
        return [
            (this.#lastX + (lastTop[0] - lastBottom[0]) / 2 - x) / width,
            (this.#lastY + (lastTop[1] - lastBottom[1]) / 2 - y) / height,
            (this.#lastX + (lastBottom[0] - lastTop[0]) / 2 - x) / width,
            (this.#lastY + (lastBottom[1] - lastTop[1]) / 2 - y) / height
        ];
    }
    add({ x: x, y: y }) {
        this.#lastX = x;
        this.#lastY = y;
        const [layerX, layerY, layerWidth, layerHeight] = this.#box;
        let [x1, y1, x2, y2] = this.#last.subarray(8, 12);
        const diffX = x - x2;
        const diffY = y - y2;
        const d = Math.hypot(diffX, diffY);
        if (d < this.#min) return false;
        const diffD = d - this.#min_dist;
        const K = diffD / d;
        const shiftX = K * diffX;
        const shiftY = K * diffY;
        let x0 = x1;
        let y0 = y1;
        x1 = x2;
        y1 = y2;
        x2 += shiftX;
        y2 += shiftY;
        this.#points?.push(x, y);
        const nX = -shiftY / diffD;
        const nY = shiftX / diffD;
        const thX = nX * this.#thickness;
        const thY = nY * this.#thickness;
        this.#last.set(this.#last.subarray(2, 8), 0);
        this.#last.set([
            x2 + thX,
            y2 + thY
        ], 4);
        this.#last.set(this.#last.subarray(14, 18), 12);
        this.#last.set([
            x2 - thX,
            y2 - thY
        ], 16);
        if (isNaN(this.#last[6])) {
            if (this.#top.length === 0) {
                this.#last.set([
                    x1 + thX,
                    y1 + thY
                ], 2);
                this.#top.push(NaN, NaN, NaN, NaN, (x1 + thX - layerX) / layerWidth, (y1 + thY - layerY) / layerHeight);
                this.#last.set([
                    x1 - thX,
                    y1 - thY
                ], 14);
                this.#bottom.push(NaN, NaN, NaN, NaN, (x1 - thX - layerX) / layerWidth, (y1 - thY - layerY) / layerHeight);
            }
            this.#last.set([
                x0,
                y0,
                x1,
                y1,
                x2,
                y2
            ], 6);
            return !this.isEmpty();
        }
        this.#last.set([
            x0,
            y0,
            x1,
            y1,
            x2,
            y2
        ], 6);
        const angle = Math.abs(Math.atan2(y0 - y1, x0 - x1) - Math.atan2(shiftY, shiftX));
        if (angle < Math.PI / 2) {
            [x1, y1, x2, y2] = this.#last.subarray(2, 6);
            this.#top.push(NaN, NaN, NaN, NaN, ((x1 + x2) / 2 - layerX) / layerWidth, ((y1 + y2) / 2 - layerY) / layerHeight);
            [x1, y1, x0, y0] = this.#last.subarray(14, 18);
            this.#bottom.push(NaN, NaN, NaN, NaN, ((x0 + x1) / 2 - layerX) / layerWidth, ((y0 + y1) / 2 - layerY) / layerHeight);
            return true;
        }
        [x0, y0, x1, y1, x2, y2] = this.#last.subarray(0, 6);
        this.#top.push(((x0 + 5 * x1) / 6 - layerX) / layerWidth, ((y0 + 5 * y1) / 6 - layerY) / layerHeight, ((5 * x1 + x2) / 6 - layerX) / layerWidth, ((5 * y1 + y2) / 6 - layerY) / layerHeight, ((x1 + x2) / 2 - layerX) / layerWidth, ((y1 + y2) / 2 - layerY) / layerHeight);
        [x2, y2, x1, y1, x0, y0] = this.#last.subarray(12, 18);
        this.#bottom.push(((x0 + 5 * x1) / 6 - layerX) / layerWidth, ((y0 + 5 * y1) / 6 - layerY) / layerHeight, ((5 * x1 + x2) / 6 - layerX) / layerWidth, ((5 * y1 + y2) / 6 - layerY) / layerHeight, ((x1 + x2) / 2 - layerX) / layerWidth, ((y1 + y2) / 2 - layerY) / layerHeight);
        return true;
    }
    toSVGPath() {
        if (this.isEmpty()) return "";
        const top = this.#top;
        const bottom = this.#bottom;
        if (isNaN(this.#last[6]) && !this.isEmpty()) return this.#toSVGPathTwoPoints();
        const buffer = [];
        buffer.push(`M${top[4]} ${top[5]}`);
        for(let i = 6; i < top.length; i += 6)if (isNaN(top[i])) buffer.push(`L${top[i + 4]} ${top[i + 5]}`);
        else buffer.push(`C${top[i]} ${top[i + 1]} ${top[i + 2]} ${top[i + 3]} ${top[i + 4]} ${top[i + 5]}`);
        this.#toSVGPathEnd(buffer);
        for(let i = bottom.length - 6; i >= 6; i -= 6)if (isNaN(bottom[i])) buffer.push(`L${bottom[i + 4]} ${bottom[i + 5]}`);
        else buffer.push(`C${bottom[i]} ${bottom[i + 1]} ${bottom[i + 2]} ${bottom[i + 3]} ${bottom[i + 4]} ${bottom[i + 5]}`);
        this.#toSVGPathStart(buffer);
        return buffer.join(" ");
    }
    #toSVGPathTwoPoints() {
        const [x, y, width, height] = this.#box;
        const [lastTopX, lastTopY, lastBottomX, lastBottomY] = this.#getLastCoords();
        return `M${(this.#last[2] - x) / width} ${(this.#last[3] - y) / height} L${(this.#last[4] - x) / width} ${(this.#last[5] - y) / height} L${lastTopX} ${lastTopY} L${lastBottomX} ${lastBottomY} L${(this.#last[16] - x) / width} ${(this.#last[17] - y) / height} L${(this.#last[14] - x) / width} ${(this.#last[15] - y) / height} Z`;
    }
    #toSVGPathStart(buffer) {
        const bottom = this.#bottom;
        buffer.push(`L${bottom[4]} ${bottom[5]} Z`);
    }
    #toSVGPathEnd(buffer) {
        const [x, y, width, height] = this.#box;
        const lastTop = this.#last.subarray(4, 6);
        const lastBottom = this.#last.subarray(16, 18);
        const [lastTopX, lastTopY, lastBottomX, lastBottomY] = this.#getLastCoords();
        buffer.push(`L${(lastTop[0] - x) / width} ${(lastTop[1] - y) / height} L${lastTopX} ${lastTopY} L${lastBottomX} ${lastBottomY} L${(lastBottom[0] - x) / width} ${(lastBottom[1] - y) / height}`);
    }
    newFreeDrawOutline(outline, points, box, scaleFactor, innerMargin, isLTR) {
        return new $9ef033443a74bee6$var$FreeDrawOutline(outline, points, box, scaleFactor, innerMargin, isLTR);
    }
    getOutlines() {
        const top = this.#top;
        const bottom = this.#bottom;
        const last = this.#last;
        const [layerX, layerY, layerWidth, layerHeight] = this.#box;
        const points = new Float32Array((this.#points?.length ?? 0) + 2);
        for(let i = 0, ii = points.length - 2; i < ii; i += 2){
            points[i] = (this.#points[i] - layerX) / layerWidth;
            points[i + 1] = (this.#points[i + 1] - layerY) / layerHeight;
        }
        points[points.length - 2] = (this.#lastX - layerX) / layerWidth;
        points[points.length - 1] = (this.#lastY - layerY) / layerHeight;
        if (isNaN(last[6]) && !this.isEmpty()) return this.#getOutlineTwoPoints(points);
        const outline = new Float32Array(this.#top.length + 24 + this.#bottom.length);
        let N = top.length;
        for(let i = 0; i < N; i += 2){
            if (isNaN(top[i])) {
                outline[i] = outline[i + 1] = NaN;
                continue;
            }
            outline[i] = top[i];
            outline[i + 1] = top[i + 1];
        }
        N = this.#getOutlineEnd(outline, N);
        for(let i = bottom.length - 6; i >= 6; i -= 6)for(let j = 0; j < 6; j += 2){
            if (isNaN(bottom[i + j])) {
                outline[N] = outline[N + 1] = NaN;
                N += 2;
                continue;
            }
            outline[N] = bottom[i + j];
            outline[N + 1] = bottom[i + j + 1];
            N += 2;
        }
        this.#getOutlineStart(outline, N);
        return this.newFreeDrawOutline(outline, points, this.#box, this.#scaleFactor, this.#innerMargin, this.#isLTR);
    }
    #getOutlineTwoPoints(points) {
        const last = this.#last;
        const [layerX, layerY, layerWidth, layerHeight] = this.#box;
        const [lastTopX, lastTopY, lastBottomX, lastBottomY] = this.#getLastCoords();
        const outline = new Float32Array(36);
        outline.set([
            NaN,
            NaN,
            NaN,
            NaN,
            (last[2] - layerX) / layerWidth,
            (last[3] - layerY) / layerHeight,
            NaN,
            NaN,
            NaN,
            NaN,
            (last[4] - layerX) / layerWidth,
            (last[5] - layerY) / layerHeight,
            NaN,
            NaN,
            NaN,
            NaN,
            lastTopX,
            lastTopY,
            NaN,
            NaN,
            NaN,
            NaN,
            lastBottomX,
            lastBottomY,
            NaN,
            NaN,
            NaN,
            NaN,
            (last[16] - layerX) / layerWidth,
            (last[17] - layerY) / layerHeight,
            NaN,
            NaN,
            NaN,
            NaN,
            (last[14] - layerX) / layerWidth,
            (last[15] - layerY) / layerHeight
        ], 0);
        return this.newFreeDrawOutline(outline, points, this.#box, this.#scaleFactor, this.#innerMargin, this.#isLTR);
    }
    #getOutlineStart(outline, pos) {
        const bottom = this.#bottom;
        outline.set([
            NaN,
            NaN,
            NaN,
            NaN,
            bottom[4],
            bottom[5]
        ], pos);
        return pos += 6;
    }
    #getOutlineEnd(outline, pos) {
        const lastTop = this.#last.subarray(4, 6);
        const lastBottom = this.#last.subarray(16, 18);
        const [layerX, layerY, layerWidth, layerHeight] = this.#box;
        const [lastTopX, lastTopY, lastBottomX, lastBottomY] = this.#getLastCoords();
        outline.set([
            NaN,
            NaN,
            NaN,
            NaN,
            (lastTop[0] - layerX) / layerWidth,
            (lastTop[1] - layerY) / layerHeight,
            NaN,
            NaN,
            NaN,
            NaN,
            lastTopX,
            lastTopY,
            NaN,
            NaN,
            NaN,
            NaN,
            lastBottomX,
            lastBottomY,
            NaN,
            NaN,
            NaN,
            NaN,
            (lastBottom[0] - layerX) / layerWidth,
            (lastBottom[1] - layerY) / layerHeight
        ], pos);
        return pos += 24;
    }
}
class $9ef033443a74bee6$var$FreeDrawOutline extends $9ef033443a74bee6$var$Outline {
    #box;
    #bbox = new Float32Array(4);
    #innerMargin;
    #isLTR;
    #points;
    #scaleFactor;
    #outline;
    constructor(outline, points, box, scaleFactor, innerMargin, isLTR){
        super();
        this.#outline = outline;
        this.#points = points;
        this.#box = box;
        this.#scaleFactor = scaleFactor;
        this.#innerMargin = innerMargin;
        this.#isLTR = isLTR;
        this.firstPoint = [
            NaN,
            NaN
        ];
        this.lastPoint = [
            NaN,
            NaN
        ];
        this.#computeMinMax(isLTR);
        const [x, y, width, height] = this.#bbox;
        for(let i = 0, ii = outline.length; i < ii; i += 2){
            outline[i] = (outline[i] - x) / width;
            outline[i + 1] = (outline[i + 1] - y) / height;
        }
        for(let i = 0, ii = points.length; i < ii; i += 2){
            points[i] = (points[i] - x) / width;
            points[i + 1] = (points[i + 1] - y) / height;
        }
    }
    toSVGPath() {
        const buffer = [
            `M${this.#outline[4]} ${this.#outline[5]}`
        ];
        for(let i = 6, ii = this.#outline.length; i < ii; i += 6){
            if (isNaN(this.#outline[i])) {
                buffer.push(`L${this.#outline[i + 4]} ${this.#outline[i + 5]}`);
                continue;
            }
            buffer.push(`C${this.#outline[i]} ${this.#outline[i + 1]} ${this.#outline[i + 2]} ${this.#outline[i + 3]} ${this.#outline[i + 4]} ${this.#outline[i + 5]}`);
        }
        buffer.push("Z");
        return buffer.join(" ");
    }
    serialize([blX, blY, trX, trY], rotation) {
        const width = trX - blX;
        const height = trY - blY;
        let outline;
        let points;
        switch(rotation){
            case 0:
                outline = $9ef033443a74bee6$var$Outline._rescale(this.#outline, blX, trY, width, -height);
                points = $9ef033443a74bee6$var$Outline._rescale(this.#points, blX, trY, width, -height);
                break;
            case 90:
                outline = $9ef033443a74bee6$var$Outline._rescaleAndSwap(this.#outline, blX, blY, width, height);
                points = $9ef033443a74bee6$var$Outline._rescaleAndSwap(this.#points, blX, blY, width, height);
                break;
            case 180:
                outline = $9ef033443a74bee6$var$Outline._rescale(this.#outline, trX, blY, -width, height);
                points = $9ef033443a74bee6$var$Outline._rescale(this.#points, trX, blY, -width, height);
                break;
            case 270:
                outline = $9ef033443a74bee6$var$Outline._rescaleAndSwap(this.#outline, trX, trY, -width, -height);
                points = $9ef033443a74bee6$var$Outline._rescaleAndSwap(this.#points, trX, trY, -width, -height);
                break;
        }
        return {
            outline: Array.from(outline),
            points: [
                Array.from(points)
            ]
        };
    }
    #computeMinMax(isLTR) {
        const outline = this.#outline;
        let lastX = outline[4];
        let lastY = outline[5];
        const minMax = [
            lastX,
            lastY,
            lastX,
            lastY
        ];
        let firstPointX = lastX;
        let firstPointY = lastY;
        let lastPointX = lastX;
        let lastPointY = lastY;
        const ltrCallback = isLTR ? Math.max : Math.min;
        const bezierBbox = new Float32Array(4);
        for(let i = 6, ii = outline.length; i < ii; i += 6){
            const x = outline[i + 4], y = outline[i + 5];
            if (isNaN(outline[i])) {
                $9ef033443a74bee6$export$f8f26dd395d7e1bd.pointBoundingBox(x, y, minMax);
                if (firstPointY > y) {
                    firstPointX = x;
                    firstPointY = y;
                } else if (firstPointY === y) firstPointX = ltrCallback(firstPointX, x);
                if (lastPointY < y) {
                    lastPointX = x;
                    lastPointY = y;
                } else if (lastPointY === y) lastPointX = ltrCallback(lastPointX, x);
            } else {
                bezierBbox[0] = bezierBbox[1] = Infinity;
                bezierBbox[2] = bezierBbox[3] = -Infinity;
                $9ef033443a74bee6$export$f8f26dd395d7e1bd.bezierBoundingBox(lastX, lastY, ...outline.slice(i, i + 6), bezierBbox);
                $9ef033443a74bee6$export$f8f26dd395d7e1bd.rectBoundingBox(bezierBbox[0], bezierBbox[1], bezierBbox[2], bezierBbox[3], minMax);
                if (firstPointY > bezierBbox[1]) {
                    firstPointX = bezierBbox[0];
                    firstPointY = bezierBbox[1];
                } else if (firstPointY === bezierBbox[1]) firstPointX = ltrCallback(firstPointX, bezierBbox[0]);
                if (lastPointY < bezierBbox[3]) {
                    lastPointX = bezierBbox[2];
                    lastPointY = bezierBbox[3];
                } else if (lastPointY === bezierBbox[3]) lastPointX = ltrCallback(lastPointX, bezierBbox[2]);
            }
            lastX = x;
            lastY = y;
        }
        const bbox = this.#bbox;
        bbox[0] = minMax[0] - this.#innerMargin;
        bbox[1] = minMax[1] - this.#innerMargin;
        bbox[2] = minMax[2] - minMax[0] + 2 * this.#innerMargin;
        bbox[3] = minMax[3] - minMax[1] + 2 * this.#innerMargin;
        this.firstPoint = [
            firstPointX,
            firstPointY
        ];
        this.lastPoint = [
            lastPointX,
            lastPointY
        ];
    }
    get box() {
        return this.#bbox;
    }
    newOutliner(point, box, scaleFactor, thickness, isLTR, innerMargin = 0) {
        return new $9ef033443a74bee6$var$FreeDrawOutliner(point, box, scaleFactor, thickness, isLTR, innerMargin);
    }
    getNewOutline(thickness, innerMargin) {
        const [x, y, width, height] = this.#bbox;
        const [layerX, layerY, layerWidth, layerHeight] = this.#box;
        const sx = width * layerWidth;
        const sy = height * layerHeight;
        const tx = x * layerWidth + layerX;
        const ty = y * layerHeight + layerY;
        const outliner = this.newOutliner({
            x: this.#points[0] * sx + tx,
            y: this.#points[1] * sy + ty
        }, this.#box, this.#scaleFactor, thickness, this.#isLTR, innerMargin ?? this.#innerMargin);
        for(let i = 2; i < this.#points.length; i += 2)outliner.add({
            x: this.#points[i] * sx + tx,
            y: this.#points[i + 1] * sy + ty
        });
        return outliner.getOutlines();
    }
}
class $9ef033443a74bee6$var$HighlightOutliner {
    #box;
    #firstPoint;
    #lastPoint;
    #verticalEdges = [];
    #intervals = [];
    constructor(boxes, borderWidth = 0, innerMargin = 0, isLTR = true){
        const minMax = [
            Infinity,
            Infinity,
            -Infinity,
            -Infinity
        ];
        const NUMBER_OF_DIGITS = 4;
        const EPSILON = 10 ** -NUMBER_OF_DIGITS;
        for (const { x: x, y: y, width: width, height: height } of boxes){
            const x1 = Math.floor((x - borderWidth) / EPSILON) * EPSILON;
            const x2 = Math.ceil((x + width + borderWidth) / EPSILON) * EPSILON;
            const y1 = Math.floor((y - borderWidth) / EPSILON) * EPSILON;
            const y2 = Math.ceil((y + height + borderWidth) / EPSILON) * EPSILON;
            const left = [
                x1,
                y1,
                y2,
                true
            ];
            const right = [
                x2,
                y1,
                y2,
                false
            ];
            this.#verticalEdges.push(left, right);
            $9ef033443a74bee6$export$f8f26dd395d7e1bd.rectBoundingBox(x1, y1, x2, y2, minMax);
        }
        const bboxWidth = minMax[2] - minMax[0] + 2 * innerMargin;
        const bboxHeight = minMax[3] - minMax[1] + 2 * innerMargin;
        const shiftedMinX = minMax[0] - innerMargin;
        const shiftedMinY = minMax[1] - innerMargin;
        let firstPointX = isLTR ? -Infinity : Infinity;
        let firstPointY = Infinity;
        const lastEdge = this.#verticalEdges.at(isLTR ? -1 : -2);
        const lastPoint = [
            lastEdge[0],
            lastEdge[2]
        ];
        for (const edge of this.#verticalEdges){
            const [x, y1, y2, left] = edge;
            if (!left && isLTR) {
                if (y1 < firstPointY) {
                    firstPointY = y1;
                    firstPointX = x;
                } else if (y1 === firstPointY) firstPointX = Math.max(firstPointX, x);
            } else if (left && !isLTR) {
                if (y1 < firstPointY) {
                    firstPointY = y1;
                    firstPointX = x;
                } else if (y1 === firstPointY) firstPointX = Math.min(firstPointX, x);
            }
            edge[0] = (x - shiftedMinX) / bboxWidth;
            edge[1] = (y1 - shiftedMinY) / bboxHeight;
            edge[2] = (y2 - shiftedMinY) / bboxHeight;
        }
        this.#box = new Float32Array([
            shiftedMinX,
            shiftedMinY,
            bboxWidth,
            bboxHeight
        ]);
        this.#firstPoint = [
            firstPointX,
            firstPointY
        ];
        this.#lastPoint = lastPoint;
    }
    getOutlines() {
        this.#verticalEdges.sort((a, b)=>a[0] - b[0] || a[1] - b[1] || a[2] - b[2]);
        const outlineVerticalEdges = [];
        for (const edge of this.#verticalEdges)if (edge[3]) {
            outlineVerticalEdges.push(...this.#breakEdge(edge));
            this.#insert(edge);
        } else {
            this.#remove(edge);
            outlineVerticalEdges.push(...this.#breakEdge(edge));
        }
        return this.#getOutlines(outlineVerticalEdges);
    }
    #getOutlines(outlineVerticalEdges) {
        const edges = [];
        const allEdges = new Set();
        for (const edge of outlineVerticalEdges){
            const [x, y1, y2] = edge;
            edges.push([
                x,
                y1,
                edge
            ], [
                x,
                y2,
                edge
            ]);
        }
        edges.sort((a, b)=>a[1] - b[1] || a[0] - b[0]);
        for(let i = 0, ii = edges.length; i < ii; i += 2){
            const edge1 = edges[i][2];
            const edge2 = edges[i + 1][2];
            edge1.push(edge2);
            edge2.push(edge1);
            allEdges.add(edge1);
            allEdges.add(edge2);
        }
        const outlines = [];
        let outline;
        while(allEdges.size > 0){
            const edge = allEdges.values().next().value;
            let [x, y1, y2, edge1, edge2] = edge;
            allEdges.delete(edge);
            let lastPointX = x;
            let lastPointY = y1;
            outline = [
                x,
                y2
            ];
            outlines.push(outline);
            while(true){
                let e;
                if (allEdges.has(edge1)) e = edge1;
                else if (allEdges.has(edge2)) e = edge2;
                else break;
                allEdges.delete(e);
                [x, y1, y2, edge1, edge2] = e;
                if (lastPointX !== x) {
                    outline.push(lastPointX, lastPointY, x, lastPointY === y1 ? y1 : y2);
                    lastPointX = x;
                }
                lastPointY = lastPointY === y1 ? y2 : y1;
            }
            outline.push(lastPointX, lastPointY);
        }
        return new $9ef033443a74bee6$var$HighlightOutline(outlines, this.#box, this.#firstPoint, this.#lastPoint);
    }
    #binarySearch(y) {
        const array = this.#intervals;
        let start = 0;
        let end = array.length - 1;
        while(start <= end){
            const middle = start + end >> 1;
            const y1 = array[middle][0];
            if (y1 === y) return middle;
            if (y1 < y) start = middle + 1;
            else end = middle - 1;
        }
        return end + 1;
    }
    #insert([, y1, y2]) {
        const index = this.#binarySearch(y1);
        this.#intervals.splice(index, 0, [
            y1,
            y2
        ]);
    }
    #remove([, y1, y2]) {
        const index = this.#binarySearch(y1);
        for(let i = index; i < this.#intervals.length; i++){
            const [start, end] = this.#intervals[i];
            if (start !== y1) break;
            if (start === y1 && end === y2) {
                this.#intervals.splice(i, 1);
                return;
            }
        }
        for(let i = index - 1; i >= 0; i--){
            const [start, end] = this.#intervals[i];
            if (start !== y1) break;
            if (start === y1 && end === y2) {
                this.#intervals.splice(i, 1);
                return;
            }
        }
    }
    #breakEdge(edge) {
        const [x, y1, y2] = edge;
        const results = [
            [
                x,
                y1,
                y2
            ]
        ];
        const index = this.#binarySearch(y2);
        for(let i = 0; i < index; i++){
            const [start, end] = this.#intervals[i];
            for(let j = 0, jj = results.length; j < jj; j++){
                const [, y3, y4] = results[j];
                if (end <= y3 || y4 <= start) continue;
                if (y3 >= start) {
                    if (y4 > end) results[j][1] = end;
                    else {
                        if (jj === 1) return [];
                        results.splice(j, 1);
                        j--;
                        jj--;
                    }
                    continue;
                }
                results[j][2] = start;
                if (y4 > end) results.push([
                    x,
                    end,
                    y4
                ]);
            }
        }
        return results;
    }
}
class $9ef033443a74bee6$var$HighlightOutline extends $9ef033443a74bee6$var$Outline {
    #box;
    #outlines;
    constructor(outlines, box, firstPoint, lastPoint){
        super();
        this.#outlines = outlines;
        this.#box = box;
        this.firstPoint = firstPoint;
        this.lastPoint = lastPoint;
    }
    toSVGPath() {
        const buffer = [];
        for (const polygon of this.#outlines){
            let [prevX, prevY] = polygon;
            buffer.push(`M${prevX} ${prevY}`);
            for(let i = 2; i < polygon.length; i += 2){
                const x = polygon[i];
                const y = polygon[i + 1];
                if (x === prevX) {
                    buffer.push(`V${y}`);
                    prevY = y;
                } else if (y === prevY) {
                    buffer.push(`H${x}`);
                    prevX = x;
                }
            }
            buffer.push("Z");
        }
        return buffer.join(" ");
    }
    serialize([blX, blY, trX, trY], _rotation) {
        const outlines = [];
        const width = trX - blX;
        const height = trY - blY;
        for (const outline of this.#outlines){
            const points = new Array(outline.length);
            for(let i = 0; i < outline.length; i += 2){
                points[i] = blX + outline[i] * width;
                points[i + 1] = trY - outline[i + 1] * height;
            }
            outlines.push(points);
        }
        return outlines;
    }
    get box() {
        return this.#box;
    }
    get classNamesForOutlining() {
        return [
            "highlightOutline"
        ];
    }
}
class $9ef033443a74bee6$var$FreeHighlightOutliner extends $9ef033443a74bee6$var$FreeDrawOutliner {
    newFreeDrawOutline(outline, points, box, scaleFactor, innerMargin, isLTR) {
        return new $9ef033443a74bee6$var$FreeHighlightOutline(outline, points, box, scaleFactor, innerMargin, isLTR);
    }
}
class $9ef033443a74bee6$var$FreeHighlightOutline extends $9ef033443a74bee6$var$FreeDrawOutline {
    newOutliner(point, box, scaleFactor, thickness, isLTR, innerMargin = 0) {
        return new $9ef033443a74bee6$var$FreeHighlightOutliner(point, box, scaleFactor, thickness, isLTR, innerMargin);
    }
}
class $9ef033443a74bee6$var$HighlightEditor extends $9ef033443a74bee6$var$AnnotationEditor {
    #anchorNode = null;
    #anchorOffset = 0;
    #boxes;
    #clipPathId = null;
    #colorPicker = null;
    #focusOutlines = null;
    #focusNode = null;
    #focusOffset = 0;
    #highlightDiv = null;
    #highlightOutlines = null;
    #id = null;
    #isFreeHighlight = false;
    #firstPoint = null;
    #lastPoint = null;
    #outlineId = null;
    #text = "";
    #thickness;
    #methodOfCreation = "";
    static _defaultColor = null;
    static _defaultOpacity = 1;
    static _defaultThickness = 12;
    static _type = "highlight";
    static _editorType = $9ef033443a74bee6$export$72ea3bfdd9a725bf.HIGHLIGHT;
    static _freeHighlightId = -1;
    static _freeHighlight = null;
    static _freeHighlightClipId = "";
    static get _keyboardManager() {
        const proto = $9ef033443a74bee6$var$HighlightEditor.prototype;
        return $9ef033443a74bee6$export$b8972b998723d602(this, "_keyboardManager", new $9ef033443a74bee6$var$KeyboardManager([
            [
                [
                    "ArrowLeft",
                    "mac+ArrowLeft"
                ],
                proto._moveCaret,
                {
                    args: [
                        0
                    ]
                }
            ],
            [
                [
                    "ArrowRight",
                    "mac+ArrowRight"
                ],
                proto._moveCaret,
                {
                    args: [
                        1
                    ]
                }
            ],
            [
                [
                    "ArrowUp",
                    "mac+ArrowUp"
                ],
                proto._moveCaret,
                {
                    args: [
                        2
                    ]
                }
            ],
            [
                [
                    "ArrowDown",
                    "mac+ArrowDown"
                ],
                proto._moveCaret,
                {
                    args: [
                        3
                    ]
                }
            ]
        ]));
    }
    constructor(params){
        super({
            ...params,
            name: "highlightEditor"
        });
        this.color = params.color || $9ef033443a74bee6$var$HighlightEditor._defaultColor;
        this.#thickness = params.thickness || $9ef033443a74bee6$var$HighlightEditor._defaultThickness;
        this.opacity = params.opacity || $9ef033443a74bee6$var$HighlightEditor._defaultOpacity;
        this.#boxes = params.boxes || null;
        this.#methodOfCreation = params.methodOfCreation || "";
        this.#text = params.text || "";
        this._isDraggable = false;
        this.defaultL10nId = "pdfjs-editor-highlight-editor";
        if (params.highlightId > -1) {
            this.#isFreeHighlight = true;
            this.#createFreeOutlines(params);
            this.#addToDrawLayer();
        } else if (this.#boxes) {
            this.#anchorNode = params.anchorNode;
            this.#anchorOffset = params.anchorOffset;
            this.#focusNode = params.focusNode;
            this.#focusOffset = params.focusOffset;
            this.#createOutlines();
            this.#addToDrawLayer();
            this.rotate(this.rotation);
        }
        if (!this.annotationElementId) this._uiManager.a11yAlert("pdfjs-editor-highlight-added-alert");
    }
    get telemetryInitialData() {
        return {
            action: "added",
            type: this.#isFreeHighlight ? "free_highlight" : "highlight",
            color: this._uiManager.getNonHCMColorName(this.color),
            thickness: this.#thickness,
            methodOfCreation: this.#methodOfCreation
        };
    }
    get telemetryFinalData() {
        return {
            type: "highlight",
            color: this._uiManager.getNonHCMColorName(this.color)
        };
    }
    static computeTelemetryFinalData(data) {
        return {
            numberOfColors: data.get("color").size
        };
    }
    #createOutlines() {
        const outliner = new $9ef033443a74bee6$var$HighlightOutliner(this.#boxes, 0.001);
        this.#highlightOutlines = outliner.getOutlines();
        [this.x, this.y, this.width, this.height] = this.#highlightOutlines.box;
        const outlinerForOutline = new $9ef033443a74bee6$var$HighlightOutliner(this.#boxes, 0.0025, 0.001, this._uiManager.direction === "ltr");
        this.#focusOutlines = outlinerForOutline.getOutlines();
        const { firstPoint: firstPoint } = this.#highlightOutlines;
        this.#firstPoint = [
            (firstPoint[0] - this.x) / this.width,
            (firstPoint[1] - this.y) / this.height
        ];
        const { lastPoint: lastPoint } = this.#focusOutlines;
        this.#lastPoint = [
            (lastPoint[0] - this.x) / this.width,
            (lastPoint[1] - this.y) / this.height
        ];
    }
    #createFreeOutlines({ highlightOutlines: highlightOutlines, highlightId: highlightId, clipPathId: clipPathId }) {
        this.#highlightOutlines = highlightOutlines;
        const extraThickness = 1.5;
        this.#focusOutlines = highlightOutlines.getNewOutline(this.#thickness / 2 + extraThickness, 0.0025);
        if (highlightId >= 0) {
            this.#id = highlightId;
            this.#clipPathId = clipPathId;
            this.parent.drawLayer.finalizeDraw(highlightId, {
                bbox: highlightOutlines.box,
                path: {
                    d: highlightOutlines.toSVGPath()
                }
            });
            this.#outlineId = this.parent.drawLayer.drawOutline({
                rootClass: {
                    highlightOutline: true,
                    free: true
                },
                bbox: this.#focusOutlines.box,
                path: {
                    d: this.#focusOutlines.toSVGPath()
                }
            }, true);
        } else if (this.parent) {
            const angle = this.parent.viewport.rotation;
            this.parent.drawLayer.updateProperties(this.#id, {
                bbox: $9ef033443a74bee6$var$HighlightEditor.#rotateBbox(this.#highlightOutlines.box, (angle - this.rotation + 360) % 360),
                path: {
                    d: highlightOutlines.toSVGPath()
                }
            });
            this.parent.drawLayer.updateProperties(this.#outlineId, {
                bbox: $9ef033443a74bee6$var$HighlightEditor.#rotateBbox(this.#focusOutlines.box, angle),
                path: {
                    d: this.#focusOutlines.toSVGPath()
                }
            });
        }
        const [x, y, width, height] = highlightOutlines.box;
        switch(this.rotation){
            case 0:
                this.x = x;
                this.y = y;
                this.width = width;
                this.height = height;
                break;
            case 90:
                {
                    const [pageWidth, pageHeight] = this.parentDimensions;
                    this.x = y;
                    this.y = 1 - x;
                    this.width = width * pageHeight / pageWidth;
                    this.height = height * pageWidth / pageHeight;
                    break;
                }
            case 180:
                this.x = 1 - x;
                this.y = 1 - y;
                this.width = width;
                this.height = height;
                break;
            case 270:
                {
                    const [pageWidth, pageHeight] = this.parentDimensions;
                    this.x = 1 - y;
                    this.y = x;
                    this.width = width * pageHeight / pageWidth;
                    this.height = height * pageWidth / pageHeight;
                    break;
                }
        }
        const { firstPoint: firstPoint } = highlightOutlines;
        this.#firstPoint = [
            (firstPoint[0] - x) / width,
            (firstPoint[1] - y) / height
        ];
        const { lastPoint: lastPoint } = this.#focusOutlines;
        this.#lastPoint = [
            (lastPoint[0] - x) / width,
            (lastPoint[1] - y) / height
        ];
    }
    static initialize(l10n, uiManager) {
        $9ef033443a74bee6$var$AnnotationEditor.initialize(l10n, uiManager);
        $9ef033443a74bee6$var$HighlightEditor._defaultColor ||= uiManager.highlightColors?.values().next().value || "#fff066";
    }
    static updateDefaultParams(type, value) {
        switch(type){
            case $9ef033443a74bee6$export$cf3df2a6ecc26692.HIGHLIGHT_COLOR:
                $9ef033443a74bee6$var$HighlightEditor._defaultColor = value;
                break;
            case $9ef033443a74bee6$export$cf3df2a6ecc26692.HIGHLIGHT_THICKNESS:
                $9ef033443a74bee6$var$HighlightEditor._defaultThickness = value;
                break;
        }
    }
    translateInPage(x, y) {}
    get toolbarPosition() {
        return this.#lastPoint;
    }
    get commentButtonPosition() {
        return this.#firstPoint;
    }
    updateParams(type, value) {
        switch(type){
            case $9ef033443a74bee6$export$cf3df2a6ecc26692.HIGHLIGHT_COLOR:
                this.#updateColor(value);
                break;
            case $9ef033443a74bee6$export$cf3df2a6ecc26692.HIGHLIGHT_THICKNESS:
                this.#updateThickness(value);
                break;
        }
    }
    static get defaultPropertiesToUpdate() {
        return [
            [
                $9ef033443a74bee6$export$cf3df2a6ecc26692.HIGHLIGHT_COLOR,
                $9ef033443a74bee6$var$HighlightEditor._defaultColor
            ],
            [
                $9ef033443a74bee6$export$cf3df2a6ecc26692.HIGHLIGHT_THICKNESS,
                $9ef033443a74bee6$var$HighlightEditor._defaultThickness
            ]
        ];
    }
    get propertiesToUpdate() {
        return [
            [
                $9ef033443a74bee6$export$cf3df2a6ecc26692.HIGHLIGHT_COLOR,
                this.color || $9ef033443a74bee6$var$HighlightEditor._defaultColor
            ],
            [
                $9ef033443a74bee6$export$cf3df2a6ecc26692.HIGHLIGHT_THICKNESS,
                this.#thickness || $9ef033443a74bee6$var$HighlightEditor._defaultThickness
            ],
            [
                $9ef033443a74bee6$export$cf3df2a6ecc26692.HIGHLIGHT_FREE,
                this.#isFreeHighlight
            ]
        ];
    }
    onUpdatedColor() {
        this.parent?.drawLayer.updateProperties(this.#id, {
            root: {
                fill: this.color,
                "fill-opacity": this.opacity
            }
        });
        this.#colorPicker?.updateColor(this.color);
        super.onUpdatedColor();
    }
    #updateColor(color) {
        const setColorAndOpacity = (col, opa)=>{
            this.color = col;
            this.opacity = opa;
            this.onUpdatedColor();
        };
        const savedColor = this.color;
        const savedOpacity = this.opacity;
        this.addCommands({
            cmd: setColorAndOpacity.bind(this, color, $9ef033443a74bee6$var$HighlightEditor._defaultOpacity),
            undo: setColorAndOpacity.bind(this, savedColor, savedOpacity),
            post: this._uiManager.updateUI.bind(this._uiManager, this),
            mustExec: true,
            type: $9ef033443a74bee6$export$cf3df2a6ecc26692.HIGHLIGHT_COLOR,
            overwriteIfSameType: true,
            keepUndo: true
        });
        this._reportTelemetry({
            action: "color_changed",
            color: this._uiManager.getNonHCMColorName(color)
        }, true);
    }
    #updateThickness(thickness) {
        const savedThickness = this.#thickness;
        const setThickness = (th)=>{
            this.#thickness = th;
            this.#changeThickness(th);
        };
        this.addCommands({
            cmd: setThickness.bind(this, thickness),
            undo: setThickness.bind(this, savedThickness),
            post: this._uiManager.updateUI.bind(this._uiManager, this),
            mustExec: true,
            type: $9ef033443a74bee6$export$cf3df2a6ecc26692.INK_THICKNESS,
            overwriteIfSameType: true,
            keepUndo: true
        });
        this._reportTelemetry({
            action: "thickness_changed",
            thickness: thickness
        }, true);
    }
    get toolbarButtons() {
        if (this._uiManager.highlightColors) {
            const colorPicker = this.#colorPicker = new $9ef033443a74bee6$export$9feb1bc2e5f1ccb3({
                editor: this
            });
            return [
                [
                    "colorPicker",
                    colorPicker
                ]
            ];
        }
        return super.toolbarButtons;
    }
    disableEditing() {
        super.disableEditing();
        this.div.classList.toggle("disabled", true);
    }
    enableEditing() {
        super.enableEditing();
        this.div.classList.toggle("disabled", false);
    }
    fixAndSetPosition() {
        return super.fixAndSetPosition(this.#getRotation());
    }
    getBaseTranslation() {
        return [
            0,
            0
        ];
    }
    getRect(tx, ty) {
        return super.getRect(tx, ty, this.#getRotation());
    }
    onceAdded(focus) {
        if (!this.annotationElementId) this.parent.addUndoableEditor(this);
        if (focus) this.div.focus();
    }
    remove() {
        this.#cleanDrawLayer();
        this._reportTelemetry({
            action: "deleted"
        });
        super.remove();
    }
    rebuild() {
        if (!this.parent) return;
        super.rebuild();
        if (this.div === null) return;
        this.#addToDrawLayer();
        if (!this.isAttachedToDOM) this.parent.add(this);
    }
    setParent(parent) {
        let mustBeSelected = false;
        if (this.parent && !parent) this.#cleanDrawLayer();
        else if (parent) {
            this.#addToDrawLayer(parent);
            mustBeSelected = !this.parent && this.div?.classList.contains("selectedEditor");
        }
        super.setParent(parent);
        this.show(this._isVisible);
        if (mustBeSelected) this.select();
    }
    #changeThickness(thickness) {
        if (!this.#isFreeHighlight) return;
        this.#createFreeOutlines({
            highlightOutlines: this.#highlightOutlines.getNewOutline(thickness / 2)
        });
        this.fixAndSetPosition();
        this.setDims(this.width, this.height);
    }
    #cleanDrawLayer() {
        if (this.#id === null || !this.parent) return;
        this.parent.drawLayer.remove(this.#id);
        this.#id = null;
        this.parent.drawLayer.remove(this.#outlineId);
        this.#outlineId = null;
    }
    #addToDrawLayer(parent = this.parent) {
        if (this.#id !== null) return;
        ({ id: this.#id, clipPathId: this.#clipPathId } = parent.drawLayer.draw({
            bbox: this.#highlightOutlines.box,
            root: {
                viewBox: "0 0 1 1",
                fill: this.color,
                "fill-opacity": this.opacity
            },
            rootClass: {
                highlight: true,
                free: this.#isFreeHighlight
            },
            path: {
                d: this.#highlightOutlines.toSVGPath()
            }
        }, false, true));
        this.#outlineId = parent.drawLayer.drawOutline({
            rootClass: {
                highlightOutline: true,
                free: this.#isFreeHighlight
            },
            bbox: this.#focusOutlines.box,
            path: {
                d: this.#focusOutlines.toSVGPath()
            }
        }, this.#isFreeHighlight);
        if (this.#highlightDiv) this.#highlightDiv.style.clipPath = this.#clipPathId;
    }
    static #rotateBbox([x, y, width, height], angle) {
        switch(angle){
            case 90:
                return [
                    1 - y - height,
                    x,
                    height,
                    width
                ];
            case 180:
                return [
                    1 - x - width,
                    1 - y - height,
                    width,
                    height
                ];
            case 270:
                return [
                    y,
                    1 - x - width,
                    height,
                    width
                ];
        }
        return [
            x,
            y,
            width,
            height
        ];
    }
    rotate(angle) {
        const { drawLayer: drawLayer } = this.parent;
        let box;
        if (this.#isFreeHighlight) {
            angle = (angle - this.rotation + 360) % 360;
            box = $9ef033443a74bee6$var$HighlightEditor.#rotateBbox(this.#highlightOutlines.box, angle);
        } else box = $9ef033443a74bee6$var$HighlightEditor.#rotateBbox([
            this.x,
            this.y,
            this.width,
            this.height
        ], angle);
        drawLayer.updateProperties(this.#id, {
            bbox: box,
            root: {
                "data-main-rotation": angle
            }
        });
        drawLayer.updateProperties(this.#outlineId, {
            bbox: $9ef033443a74bee6$var$HighlightEditor.#rotateBbox(this.#focusOutlines.box, angle),
            root: {
                "data-main-rotation": angle
            }
        });
    }
    render() {
        if (this.div) return this.div;
        const div = super.render();
        if (this.#text) {
            div.setAttribute("aria-label", this.#text);
            div.setAttribute("role", "mark");
        }
        if (this.#isFreeHighlight) div.classList.add("free");
        else this.div.addEventListener("keydown", this.#keydown.bind(this), {
            signal: this._uiManager._signal
        });
        const highlightDiv = this.#highlightDiv = document.createElement("div");
        div.append(highlightDiv);
        highlightDiv.setAttribute("aria-hidden", "true");
        highlightDiv.className = "internal";
        highlightDiv.style.clipPath = this.#clipPathId;
        this.setDims(this.width, this.height);
        $9ef033443a74bee6$var$bindEvents(this, this.#highlightDiv, [
            "pointerover",
            "pointerleave"
        ]);
        this.enableEditing();
        return div;
    }
    pointerover() {
        if (!this.isSelected) this.parent?.drawLayer.updateProperties(this.#outlineId, {
            rootClass: {
                hovered: true
            }
        });
    }
    pointerleave() {
        if (!this.isSelected) this.parent?.drawLayer.updateProperties(this.#outlineId, {
            rootClass: {
                hovered: false
            }
        });
    }
    #keydown(event) {
        $9ef033443a74bee6$var$HighlightEditor._keyboardManager.exec(this, event);
    }
    _moveCaret(direction) {
        this.parent.unselect(this);
        switch(direction){
            case 0:
            case 2:
                this.#setCaret(true);
                break;
            case 1:
            case 3:
                this.#setCaret(false);
                break;
        }
    }
    #setCaret(start) {
        if (!this.#anchorNode) return;
        const selection = window.getSelection();
        if (start) selection.setPosition(this.#anchorNode, this.#anchorOffset);
        else selection.setPosition(this.#focusNode, this.#focusOffset);
    }
    select() {
        super.select();
        if (!this.#outlineId) return;
        this.parent?.drawLayer.updateProperties(this.#outlineId, {
            rootClass: {
                hovered: false,
                selected: true
            }
        });
    }
    unselect() {
        super.unselect();
        if (!this.#outlineId) return;
        this.parent?.drawLayer.updateProperties(this.#outlineId, {
            rootClass: {
                selected: false
            }
        });
        if (!this.#isFreeHighlight) this.#setCaret(false);
    }
    get _mustFixPosition() {
        return !this.#isFreeHighlight;
    }
    show(visible = this._isVisible) {
        super.show(visible);
        if (this.parent) {
            this.parent.drawLayer.updateProperties(this.#id, {
                rootClass: {
                    hidden: !visible
                }
            });
            this.parent.drawLayer.updateProperties(this.#outlineId, {
                rootClass: {
                    hidden: !visible
                }
            });
        }
    }
    #getRotation() {
        return this.#isFreeHighlight ? this.rotation : 0;
    }
    #serializeBoxes() {
        if (this.#isFreeHighlight) return null;
        const [pageWidth, pageHeight] = this.pageDimensions;
        const [pageX, pageY] = this.pageTranslation;
        const boxes = this.#boxes;
        const quadPoints = new Float32Array(boxes.length * 8);
        let i = 0;
        for (const { x: x, y: y, width: width, height: height } of boxes){
            const sx = x * pageWidth + pageX;
            const sy = (1 - y) * pageHeight + pageY;
            quadPoints[i] = quadPoints[i + 4] = sx;
            quadPoints[i + 1] = quadPoints[i + 3] = sy;
            quadPoints[i + 2] = quadPoints[i + 6] = sx + width * pageWidth;
            quadPoints[i + 5] = quadPoints[i + 7] = sy - height * pageHeight;
            i += 8;
        }
        return quadPoints;
    }
    #serializeOutlines(rect) {
        return this.#highlightOutlines.serialize(rect, this.#getRotation());
    }
    static startHighlighting(parent, isLTR, { target: textLayer, x: x, y: y }) {
        const { x: layerX, y: layerY, width: parentWidth, height: parentHeight } = textLayer.getBoundingClientRect();
        const ac = new AbortController();
        const signal = parent.combinedSignal(ac);
        const pointerUpCallback = (e)=>{
            ac.abort();
            this.#endHighlight(parent, e);
        };
        window.addEventListener("blur", pointerUpCallback, {
            signal: signal
        });
        window.addEventListener("pointerup", pointerUpCallback, {
            signal: signal
        });
        window.addEventListener("pointerdown", $9ef033443a74bee6$export$7ae4cd3a66c1e050, {
            capture: true,
            passive: false,
            signal: signal
        });
        window.addEventListener("contextmenu", $9ef033443a74bee6$export$455b7811f904cadc, {
            signal: signal
        });
        textLayer.addEventListener("pointermove", this.#highlightMove.bind(this, parent), {
            signal: signal
        });
        this._freeHighlight = new $9ef033443a74bee6$var$FreeHighlightOutliner({
            x: x,
            y: y
        }, [
            layerX,
            layerY,
            parentWidth,
            parentHeight
        ], parent.scale, this._defaultThickness / 2, isLTR, 0.001);
        ({ id: this._freeHighlightId, clipPathId: this._freeHighlightClipId } = parent.drawLayer.draw({
            bbox: [
                0,
                0,
                1,
                1
            ],
            root: {
                viewBox: "0 0 1 1",
                fill: this._defaultColor,
                "fill-opacity": this._defaultOpacity
            },
            rootClass: {
                highlight: true,
                free: true
            },
            path: {
                d: this._freeHighlight.toSVGPath()
            }
        }, true, true));
    }
    static #highlightMove(parent, event) {
        if (this._freeHighlight.add(event)) parent.drawLayer.updateProperties(this._freeHighlightId, {
            path: {
                d: this._freeHighlight.toSVGPath()
            }
        });
    }
    static #endHighlight(parent, event) {
        if (!this._freeHighlight.isEmpty()) parent.createAndAddNewEditor(event, false, {
            highlightId: this._freeHighlightId,
            highlightOutlines: this._freeHighlight.getOutlines(),
            clipPathId: this._freeHighlightClipId,
            methodOfCreation: "main_toolbar"
        });
        else parent.drawLayer.remove(this._freeHighlightId);
        this._freeHighlightId = -1;
        this._freeHighlight = null;
        this._freeHighlightClipId = "";
    }
    static async deserialize(data, parent, uiManager) {
        let initialData = null;
        if (data instanceof $9ef033443a74bee6$var$HighlightAnnotationElement) {
            const { data: { quadPoints: quadPoints, rect: rect, rotation: rotation, id: id, color: color, opacity: opacity, popupRef: popupRef, richText: richText, contentsObj: contentsObj, creationDate: creationDate, modificationDate: modificationDate }, parent: { page: { pageNumber: pageNumber } } } = data;
            initialData = data = {
                annotationType: $9ef033443a74bee6$export$72ea3bfdd9a725bf.HIGHLIGHT,
                color: Array.from(color),
                opacity: opacity,
                quadPoints: quadPoints,
                boxes: null,
                pageIndex: pageNumber - 1,
                rect: rect.slice(0),
                rotation: rotation,
                annotationElementId: id,
                id: id,
                deleted: false,
                popupRef: popupRef,
                richText: richText,
                comment: contentsObj?.str || null,
                creationDate: creationDate,
                modificationDate: modificationDate
            };
        } else if (data instanceof $9ef033443a74bee6$var$InkAnnotationElement) {
            const { data: { inkLists: inkLists, rect: rect, rotation: rotation, id: id, color: color, borderStyle: { rawWidth: thickness }, popupRef: popupRef, richText: richText, contentsObj: contentsObj, creationDate: creationDate, modificationDate: modificationDate }, parent: { page: { pageNumber: pageNumber } } } = data;
            initialData = data = {
                annotationType: $9ef033443a74bee6$export$72ea3bfdd9a725bf.HIGHLIGHT,
                color: Array.from(color),
                thickness: thickness,
                inkLists: inkLists,
                boxes: null,
                pageIndex: pageNumber - 1,
                rect: rect.slice(0),
                rotation: rotation,
                annotationElementId: id,
                id: id,
                deleted: false,
                popupRef: popupRef,
                richText: richText,
                comment: contentsObj?.str || null,
                creationDate: creationDate,
                modificationDate: modificationDate
            };
        }
        const { color: color, quadPoints: quadPoints, inkLists: inkLists, opacity: opacity } = data;
        const editor = await super.deserialize(data, parent, uiManager);
        editor.color = $9ef033443a74bee6$export$f8f26dd395d7e1bd.makeHexColor(...color);
        editor.opacity = opacity || 1;
        if (inkLists) editor.#thickness = data.thickness;
        editor._initialData = initialData;
        if (data.comment) editor.setCommentData(data);
        const [pageWidth, pageHeight] = editor.pageDimensions;
        const [pageX, pageY] = editor.pageTranslation;
        if (quadPoints) {
            const boxes = editor.#boxes = [];
            for(let i = 0; i < quadPoints.length; i += 8)boxes.push({
                x: (quadPoints[i] - pageX) / pageWidth,
                y: 1 - (quadPoints[i + 1] - pageY) / pageHeight,
                width: (quadPoints[i + 2] - quadPoints[i]) / pageWidth,
                height: (quadPoints[i + 1] - quadPoints[i + 5]) / pageHeight
            });
            editor.#createOutlines();
            editor.#addToDrawLayer();
            editor.rotate(editor.rotation);
        } else if (inkLists) {
            editor.#isFreeHighlight = true;
            const points = inkLists[0];
            const point = {
                x: points[0] - pageX,
                y: pageHeight - (points[1] - pageY)
            };
            const outliner = new $9ef033443a74bee6$var$FreeHighlightOutliner(point, [
                0,
                0,
                pageWidth,
                pageHeight
            ], 1, editor.#thickness / 2, true, 0.001);
            for(let i = 0, ii = points.length; i < ii; i += 2){
                point.x = points[i] - pageX;
                point.y = pageHeight - (points[i + 1] - pageY);
                outliner.add(point);
            }
            const { id: id, clipPathId: clipPathId } = parent.drawLayer.draw({
                bbox: [
                    0,
                    0,
                    1,
                    1
                ],
                root: {
                    viewBox: "0 0 1 1",
                    fill: editor.color,
                    "fill-opacity": editor._defaultOpacity
                },
                rootClass: {
                    highlight: true,
                    free: true
                },
                path: {
                    d: outliner.toSVGPath()
                }
            }, true, true);
            editor.#createFreeOutlines({
                highlightOutlines: outliner.getOutlines(),
                highlightId: id,
                clipPathId: clipPathId
            });
            editor.#addToDrawLayer();
            editor.rotate(editor.parentRotation);
        }
        return editor;
    }
    serialize(isForCopying = false) {
        if (this.isEmpty() || isForCopying) return null;
        if (this.deleted) return this.serializeDeleted();
        const color = $9ef033443a74bee6$var$AnnotationEditor._colorManager.convert(this._uiManager.getNonHCMColor(this.color));
        const serialized = super.serialize(isForCopying);
        Object.assign(serialized, {
            color: color,
            opacity: this.opacity,
            thickness: this.#thickness,
            quadPoints: this.#serializeBoxes(),
            outlines: this.#serializeOutlines(serialized.rect)
        });
        this.addComment(serialized);
        if (this.annotationElementId && !this.#hasElementChanged(serialized)) return null;
        serialized.id = this.annotationElementId;
        return serialized;
    }
    #hasElementChanged(serialized) {
        const { color: color } = this._initialData;
        return this.hasEditedComment || serialized.color.some((c, i)=>c !== color[i]);
    }
    renderAnnotationElement(annotation) {
        if (this.deleted) {
            annotation.hide();
            return null;
        }
        annotation.updateEdited({
            rect: this.getPDFRect(),
            popup: this.comment
        });
        return null;
    }
    static canCreateNewEmptyEditor() {
        return false;
    }
}
class $9ef033443a74bee6$var$DrawingOptions {
    #svgProperties = Object.create(null);
    updateProperty(name, value) {
        this[name] = value;
        this.updateSVGProperty(name, value);
    }
    updateProperties(properties) {
        if (!properties) return;
        for (const [name, value] of Object.entries(properties))if (!name.startsWith("_")) this.updateProperty(name, value);
    }
    updateSVGProperty(name, value) {
        this.#svgProperties[name] = value;
    }
    toSVGProperties() {
        const root = this.#svgProperties;
        this.#svgProperties = Object.create(null);
        return {
            root: root
        };
    }
    reset() {
        this.#svgProperties = Object.create(null);
    }
    updateAll(options = this) {
        this.updateProperties(options);
    }
    clone() {
        $9ef033443a74bee6$var$unreachable("Not implemented");
    }
}
class $9ef033443a74bee6$var$DrawingEditor extends $9ef033443a74bee6$var$AnnotationEditor {
    #drawOutlines = null;
    #mustBeCommitted;
    _colorPicker = null;
    _drawId = null;
    static _currentDrawId = -1;
    static _currentParent = null;
    static #currentDraw = null;
    static #currentDrawingAC = null;
    static #currentDrawingOptions = null;
    static #currentPointerId = NaN;
    static #currentPointerType = null;
    static #currentPointerIds = null;
    static #currentMoveTimestamp = NaN;
    static _INNER_MARGIN = 3;
    constructor(params){
        super(params);
        this.#mustBeCommitted = params.mustBeCommitted || false;
        this._addOutlines(params);
    }
    onUpdatedColor() {
        this._colorPicker?.update(this.color);
        super.onUpdatedColor();
    }
    _addOutlines(params) {
        if (params.drawOutlines) {
            this.#createDrawOutlines(params);
            this.#addToDrawLayer();
        }
    }
    #createDrawOutlines({ drawOutlines: drawOutlines, drawId: drawId, drawingOptions: drawingOptions }) {
        this.#drawOutlines = drawOutlines;
        this._drawingOptions ||= drawingOptions;
        if (!this.annotationElementId) this._uiManager.a11yAlert(`pdfjs-editor-${this.editorType}-added-alert`);
        if (drawId >= 0) {
            this._drawId = drawId;
            this.parent.drawLayer.finalizeDraw(drawId, drawOutlines.defaultProperties);
        } else this._drawId = this.#createDrawing(drawOutlines, this.parent);
        this.#updateBbox(drawOutlines.box);
    }
    #createDrawing(drawOutlines, parent) {
        const { id: id } = parent.drawLayer.draw($9ef033443a74bee6$var$DrawingEditor._mergeSVGProperties(this._drawingOptions.toSVGProperties(), drawOutlines.defaultSVGProperties), false, false);
        return id;
    }
    static _mergeSVGProperties(p1, p2) {
        const p1Keys = new Set(Object.keys(p1));
        for (const [key, value] of Object.entries(p2))if (p1Keys.has(key)) Object.assign(p1[key], value);
        else p1[key] = value;
        return p1;
    }
    static getDefaultDrawingOptions(_options) {
        $9ef033443a74bee6$var$unreachable("Not implemented");
    }
    static get typesMap() {
        $9ef033443a74bee6$var$unreachable("Not implemented");
    }
    static get isDrawer() {
        return true;
    }
    static get supportMultipleDrawings() {
        return false;
    }
    static updateDefaultParams(type, value) {
        const propertyName = this.typesMap.get(type);
        if (propertyName) this._defaultDrawingOptions.updateProperty(propertyName, value);
        if (this._currentParent) {
            $9ef033443a74bee6$var$DrawingEditor.#currentDraw.updateProperty(propertyName, value);
            this._currentParent.drawLayer.updateProperties(this._currentDrawId, this._defaultDrawingOptions.toSVGProperties());
        }
    }
    updateParams(type, value) {
        const propertyName = this.constructor.typesMap.get(type);
        if (propertyName) this._updateProperty(type, propertyName, value);
    }
    static get defaultPropertiesToUpdate() {
        const properties = [];
        const options = this._defaultDrawingOptions;
        for (const [type, name] of this.typesMap)properties.push([
            type,
            options[name]
        ]);
        return properties;
    }
    get propertiesToUpdate() {
        const properties = [];
        const { _drawingOptions: _drawingOptions } = this;
        for (const [type, name] of this.constructor.typesMap)properties.push([
            type,
            _drawingOptions[name]
        ]);
        return properties;
    }
    _updateProperty(type, name, value) {
        const options = this._drawingOptions;
        const savedValue = options[name];
        const setter = (val)=>{
            options.updateProperty(name, val);
            const bbox = this.#drawOutlines.updateProperty(name, val);
            if (bbox) this.#updateBbox(bbox);
            this.parent?.drawLayer.updateProperties(this._drawId, options.toSVGProperties());
            if (type === this.colorType) this.onUpdatedColor();
        };
        this.addCommands({
            cmd: setter.bind(this, value),
            undo: setter.bind(this, savedValue),
            post: this._uiManager.updateUI.bind(this._uiManager, this),
            mustExec: true,
            type: type,
            overwriteIfSameType: true,
            keepUndo: true
        });
    }
    _onResizing() {
        this.parent?.drawLayer.updateProperties(this._drawId, $9ef033443a74bee6$var$DrawingEditor._mergeSVGProperties(this.#drawOutlines.getPathResizingSVGProperties(this.#convertToDrawSpace()), {
            bbox: this.#rotateBox()
        }));
    }
    _onResized() {
        this.parent?.drawLayer.updateProperties(this._drawId, $9ef033443a74bee6$var$DrawingEditor._mergeSVGProperties(this.#drawOutlines.getPathResizedSVGProperties(this.#convertToDrawSpace()), {
            bbox: this.#rotateBox()
        }));
    }
    _onTranslating(_x, _y) {
        this.parent?.drawLayer.updateProperties(this._drawId, {
            bbox: this.#rotateBox()
        });
    }
    _onTranslated() {
        this.parent?.drawLayer.updateProperties(this._drawId, $9ef033443a74bee6$var$DrawingEditor._mergeSVGProperties(this.#drawOutlines.getPathTranslatedSVGProperties(this.#convertToDrawSpace(), this.parentDimensions), {
            bbox: this.#rotateBox()
        }));
    }
    _onStartDragging() {
        this.parent?.drawLayer.updateProperties(this._drawId, {
            rootClass: {
                moving: true
            }
        });
    }
    _onStopDragging() {
        this.parent?.drawLayer.updateProperties(this._drawId, {
            rootClass: {
                moving: false
            }
        });
    }
    commit() {
        super.commit();
        this.disableEditMode();
        this.disableEditing();
    }
    disableEditing() {
        super.disableEditing();
        this.div.classList.toggle("disabled", true);
    }
    enableEditing() {
        super.enableEditing();
        this.div.classList.toggle("disabled", false);
    }
    getBaseTranslation() {
        return [
            0,
            0
        ];
    }
    get isResizable() {
        return true;
    }
    onceAdded(focus) {
        if (!this.annotationElementId) this.parent.addUndoableEditor(this);
        this._isDraggable = true;
        if (this.#mustBeCommitted) {
            this.#mustBeCommitted = false;
            this.commit();
            this.parent.setSelected(this);
            if (focus && this.isOnScreen) this.div.focus();
        }
    }
    remove() {
        this.#cleanDrawLayer();
        super.remove();
    }
    rebuild() {
        if (!this.parent) return;
        super.rebuild();
        if (this.div === null) return;
        this.#addToDrawLayer();
        this.#updateBbox(this.#drawOutlines.box);
        if (!this.isAttachedToDOM) this.parent.add(this);
    }
    setParent(parent) {
        let mustBeSelected = false;
        if (this.parent && !parent) {
            this._uiManager.removeShouldRescale(this);
            this.#cleanDrawLayer();
        } else if (parent) {
            this._uiManager.addShouldRescale(this);
            this.#addToDrawLayer(parent);
            mustBeSelected = !this.parent && this.div?.classList.contains("selectedEditor");
        }
        super.setParent(parent);
        if (mustBeSelected) this.select();
    }
    #cleanDrawLayer() {
        if (this._drawId === null || !this.parent) return;
        this.parent.drawLayer.remove(this._drawId);
        this._drawId = null;
        this._drawingOptions.reset();
    }
    #addToDrawLayer(parent = this.parent) {
        if (this._drawId !== null && this.parent === parent) return;
        if (this._drawId !== null) {
            this.parent.drawLayer.updateParent(this._drawId, parent.drawLayer);
            return;
        }
        this._drawingOptions.updateAll();
        this._drawId = this.#createDrawing(this.#drawOutlines, parent);
    }
    #convertToParentSpace([x, y, width, height]) {
        const { parentDimensions: [pW, pH], rotation: rotation } = this;
        switch(rotation){
            case 90:
                return [
                    y,
                    1 - x,
                    width * (pH / pW),
                    height * (pW / pH)
                ];
            case 180:
                return [
                    1 - x,
                    1 - y,
                    width,
                    height
                ];
            case 270:
                return [
                    1 - y,
                    x,
                    width * (pH / pW),
                    height * (pW / pH)
                ];
            default:
                return [
                    x,
                    y,
                    width,
                    height
                ];
        }
    }
    #convertToDrawSpace() {
        const { x: x, y: y, width: width, height: height, parentDimensions: [pW, pH], rotation: rotation } = this;
        switch(rotation){
            case 90:
                return [
                    1 - y,
                    x,
                    width * (pW / pH),
                    height * (pH / pW)
                ];
            case 180:
                return [
                    1 - x,
                    1 - y,
                    width,
                    height
                ];
            case 270:
                return [
                    y,
                    1 - x,
                    width * (pW / pH),
                    height * (pH / pW)
                ];
            default:
                return [
                    x,
                    y,
                    width,
                    height
                ];
        }
    }
    #updateBbox(bbox) {
        [this.x, this.y, this.width, this.height] = this.#convertToParentSpace(bbox);
        if (this.div) {
            this.fixAndSetPosition();
            this.setDims();
        }
        this._onResized();
    }
    #rotateBox() {
        const { x: x, y: y, width: width, height: height, rotation: rotation, parentRotation: parentRotation, parentDimensions: [pW, pH] } = this;
        switch((rotation * 4 + parentRotation) / 90){
            case 1:
                return [
                    1 - y - height,
                    x,
                    height,
                    width
                ];
            case 2:
                return [
                    1 - x - width,
                    1 - y - height,
                    width,
                    height
                ];
            case 3:
                return [
                    y,
                    1 - x - width,
                    height,
                    width
                ];
            case 4:
                return [
                    x,
                    y - width * (pW / pH),
                    height * (pH / pW),
                    width * (pW / pH)
                ];
            case 5:
                return [
                    1 - y,
                    x,
                    width * (pW / pH),
                    height * (pH / pW)
                ];
            case 6:
                return [
                    1 - x - height * (pH / pW),
                    1 - y,
                    height * (pH / pW),
                    width * (pW / pH)
                ];
            case 7:
                return [
                    y - width * (pW / pH),
                    1 - x - height * (pH / pW),
                    width * (pW / pH),
                    height * (pH / pW)
                ];
            case 8:
                return [
                    x - width,
                    y - height,
                    width,
                    height
                ];
            case 9:
                return [
                    1 - y,
                    x - width,
                    height,
                    width
                ];
            case 10:
                return [
                    1 - x,
                    1 - y,
                    width,
                    height
                ];
            case 11:
                return [
                    y - height,
                    1 - x,
                    height,
                    width
                ];
            case 12:
                return [
                    x - height * (pH / pW),
                    y,
                    height * (pH / pW),
                    width * (pW / pH)
                ];
            case 13:
                return [
                    1 - y - width * (pW / pH),
                    x - height * (pH / pW),
                    width * (pW / pH),
                    height * (pH / pW)
                ];
            case 14:
                return [
                    1 - x,
                    1 - y - width * (pW / pH),
                    height * (pH / pW),
                    width * (pW / pH)
                ];
            case 15:
                return [
                    y,
                    1 - x,
                    width * (pW / pH),
                    height * (pH / pW)
                ];
            default:
                return [
                    x,
                    y,
                    width,
                    height
                ];
        }
    }
    rotate() {
        if (!this.parent) return;
        this.parent.drawLayer.updateProperties(this._drawId, $9ef033443a74bee6$var$DrawingEditor._mergeSVGProperties({
            bbox: this.#rotateBox()
        }, this.#drawOutlines.updateRotation((this.parentRotation - this.rotation + 360) % 360)));
    }
    onScaleChanging() {
        if (!this.parent) return;
        this.#updateBbox(this.#drawOutlines.updateParentDimensions(this.parentDimensions, this.parent.scale));
    }
    static onScaleChangingWhenDrawing() {}
    render() {
        if (this.div) return this.div;
        let baseX, baseY;
        if (this._isCopy) {
            baseX = this.x;
            baseY = this.y;
        }
        const div = super.render();
        div.classList.add("draw");
        const drawDiv = document.createElement("div");
        div.append(drawDiv);
        drawDiv.setAttribute("aria-hidden", "true");
        drawDiv.className = "internal";
        this.setDims();
        this._uiManager.addShouldRescale(this);
        this.disableEditing();
        if (this._isCopy) this._moveAfterPaste(baseX, baseY);
        return div;
    }
    static createDrawerInstance(_x, _y, _parentWidth, _parentHeight, _rotation) {
        $9ef033443a74bee6$var$unreachable("Not implemented");
    }
    static startDrawing(parent, uiManager, _isLTR, event) {
        const { target: target, offsetX: x, offsetY: y, pointerId: pointerId, pointerType: pointerType } = event;
        if ($9ef033443a74bee6$var$DrawingEditor.#currentPointerType && $9ef033443a74bee6$var$DrawingEditor.#currentPointerType !== pointerType) return;
        const { viewport: { rotation: rotation } } = parent;
        const { width: parentWidth, height: parentHeight } = target.getBoundingClientRect();
        const ac = $9ef033443a74bee6$var$DrawingEditor.#currentDrawingAC = new AbortController();
        const signal = parent.combinedSignal(ac);
        $9ef033443a74bee6$var$DrawingEditor.#currentPointerId ||= pointerId;
        $9ef033443a74bee6$var$DrawingEditor.#currentPointerType ??= pointerType;
        window.addEventListener("pointerup", (e)=>{
            if ($9ef033443a74bee6$var$DrawingEditor.#currentPointerId === e.pointerId) this._endDraw(e);
            else $9ef033443a74bee6$var$DrawingEditor.#currentPointerIds?.delete(e.pointerId);
        }, {
            signal: signal
        });
        window.addEventListener("pointercancel", (e)=>{
            if ($9ef033443a74bee6$var$DrawingEditor.#currentPointerId === e.pointerId) this._currentParent.endDrawingSession();
            else $9ef033443a74bee6$var$DrawingEditor.#currentPointerIds?.delete(e.pointerId);
        }, {
            signal: signal
        });
        window.addEventListener("pointerdown", (e)=>{
            if ($9ef033443a74bee6$var$DrawingEditor.#currentPointerType !== e.pointerType) return;
            ($9ef033443a74bee6$var$DrawingEditor.#currentPointerIds ||= new Set()).add(e.pointerId);
            if ($9ef033443a74bee6$var$DrawingEditor.#currentDraw.isCancellable()) {
                $9ef033443a74bee6$var$DrawingEditor.#currentDraw.removeLastElement();
                if ($9ef033443a74bee6$var$DrawingEditor.#currentDraw.isEmpty()) this._currentParent.endDrawingSession(true);
                else this._endDraw(null);
            }
        }, {
            capture: true,
            passive: false,
            signal: signal
        });
        window.addEventListener("contextmenu", $9ef033443a74bee6$export$455b7811f904cadc, {
            signal: signal
        });
        target.addEventListener("pointermove", this._drawMove.bind(this), {
            signal: signal
        });
        target.addEventListener("touchmove", (e)=>{
            if (e.timeStamp === $9ef033443a74bee6$var$DrawingEditor.#currentMoveTimestamp) $9ef033443a74bee6$export$7ae4cd3a66c1e050(e);
        }, {
            signal: signal
        });
        parent.toggleDrawing();
        uiManager._editorUndoBar?.hide();
        if ($9ef033443a74bee6$var$DrawingEditor.#currentDraw) {
            parent.drawLayer.updateProperties(this._currentDrawId, $9ef033443a74bee6$var$DrawingEditor.#currentDraw.startNew(x, y, parentWidth, parentHeight, rotation));
            return;
        }
        uiManager.updateUIForDefaultProperties(this);
        $9ef033443a74bee6$var$DrawingEditor.#currentDraw = this.createDrawerInstance(x, y, parentWidth, parentHeight, rotation);
        $9ef033443a74bee6$var$DrawingEditor.#currentDrawingOptions = this.getDefaultDrawingOptions();
        this._currentParent = parent;
        ({ id: this._currentDrawId } = parent.drawLayer.draw(this._mergeSVGProperties($9ef033443a74bee6$var$DrawingEditor.#currentDrawingOptions.toSVGProperties(), $9ef033443a74bee6$var$DrawingEditor.#currentDraw.defaultSVGProperties), true, false));
    }
    static _drawMove(event) {
        $9ef033443a74bee6$var$DrawingEditor.#currentMoveTimestamp = -1;
        if (!$9ef033443a74bee6$var$DrawingEditor.#currentDraw) return;
        const { offsetX: offsetX, offsetY: offsetY, pointerId: pointerId } = event;
        if ($9ef033443a74bee6$var$DrawingEditor.#currentPointerId !== pointerId) return;
        if ($9ef033443a74bee6$var$DrawingEditor.#currentPointerIds?.size >= 1) {
            this._endDraw(event);
            return;
        }
        this._currentParent.drawLayer.updateProperties(this._currentDrawId, $9ef033443a74bee6$var$DrawingEditor.#currentDraw.add(offsetX, offsetY));
        $9ef033443a74bee6$var$DrawingEditor.#currentMoveTimestamp = event.timeStamp;
        $9ef033443a74bee6$export$7ae4cd3a66c1e050(event);
    }
    static _cleanup(all) {
        if (all) {
            this._currentDrawId = -1;
            this._currentParent = null;
            $9ef033443a74bee6$var$DrawingEditor.#currentDraw = null;
            $9ef033443a74bee6$var$DrawingEditor.#currentDrawingOptions = null;
            $9ef033443a74bee6$var$DrawingEditor.#currentPointerType = null;
            $9ef033443a74bee6$var$DrawingEditor.#currentMoveTimestamp = NaN;
        }
        if ($9ef033443a74bee6$var$DrawingEditor.#currentDrawingAC) {
            $9ef033443a74bee6$var$DrawingEditor.#currentDrawingAC.abort();
            $9ef033443a74bee6$var$DrawingEditor.#currentDrawingAC = null;
            $9ef033443a74bee6$var$DrawingEditor.#currentPointerId = NaN;
            $9ef033443a74bee6$var$DrawingEditor.#currentPointerIds = null;
        }
    }
    static _endDraw(event) {
        const parent = this._currentParent;
        if (!parent) return;
        parent.toggleDrawing(true);
        this._cleanup(false);
        if (event?.target === parent.div) parent.drawLayer.updateProperties(this._currentDrawId, $9ef033443a74bee6$var$DrawingEditor.#currentDraw.end(event.offsetX, event.offsetY));
        if (this.supportMultipleDrawings) {
            const draw = $9ef033443a74bee6$var$DrawingEditor.#currentDraw;
            const drawId = this._currentDrawId;
            const lastElement = draw.getLastElement();
            parent.addCommands({
                cmd: ()=>{
                    parent.drawLayer.updateProperties(drawId, draw.setLastElement(lastElement));
                },
                undo: ()=>{
                    parent.drawLayer.updateProperties(drawId, draw.removeLastElement());
                },
                mustExec: false,
                type: $9ef033443a74bee6$export$cf3df2a6ecc26692.DRAW_STEP
            });
            return;
        }
        this.endDrawing(false);
    }
    static endDrawing(isAborted) {
        const parent = this._currentParent;
        if (!parent) return null;
        parent.toggleDrawing(true);
        parent.cleanUndoStack($9ef033443a74bee6$export$cf3df2a6ecc26692.DRAW_STEP);
        if (!$9ef033443a74bee6$var$DrawingEditor.#currentDraw.isEmpty()) {
            const { pageDimensions: [pageWidth, pageHeight], scale: scale } = parent;
            const editor = parent.createAndAddNewEditor({
                offsetX: 0,
                offsetY: 0
            }, false, {
                drawId: this._currentDrawId,
                drawOutlines: $9ef033443a74bee6$var$DrawingEditor.#currentDraw.getOutlines(pageWidth * scale, pageHeight * scale, scale, this._INNER_MARGIN),
                drawingOptions: $9ef033443a74bee6$var$DrawingEditor.#currentDrawingOptions,
                mustBeCommitted: !isAborted
            });
            this._cleanup(true);
            return editor;
        }
        parent.drawLayer.remove(this._currentDrawId);
        this._cleanup(true);
        return null;
    }
    createDrawingOptions(_data) {}
    static deserializeDraw(_pageX, _pageY, _pageWidth, _pageHeight, _innerWidth, _data) {
        $9ef033443a74bee6$var$unreachable("Not implemented");
    }
    static async deserialize(data, parent, uiManager) {
        const { rawDims: { pageWidth: pageWidth, pageHeight: pageHeight, pageX: pageX, pageY: pageY } } = parent.viewport;
        const drawOutlines = this.deserializeDraw(pageX, pageY, pageWidth, pageHeight, this._INNER_MARGIN, data);
        const editor = await super.deserialize(data, parent, uiManager);
        editor.createDrawingOptions(data);
        editor.#createDrawOutlines({
            drawOutlines: drawOutlines
        });
        editor.#addToDrawLayer();
        editor.onScaleChanging();
        editor.rotate();
        return editor;
    }
    serializeDraw(isForCopying) {
        const [pageX, pageY] = this.pageTranslation;
        const [pageWidth, pageHeight] = this.pageDimensions;
        return this.#drawOutlines.serialize([
            pageX,
            pageY,
            pageWidth,
            pageHeight
        ], isForCopying);
    }
    renderAnnotationElement(annotation) {
        annotation.updateEdited({
            rect: this.getPDFRect()
        });
        return null;
    }
    static canCreateNewEmptyEditor() {
        return false;
    }
}
class $9ef033443a74bee6$var$InkDrawOutliner {
    #last = new Float64Array(6);
    #line;
    #lines;
    #rotation;
    #thickness;
    #points;
    #lastSVGPath = "";
    #lastIndex = 0;
    #outlines = new $9ef033443a74bee6$var$InkDrawOutline();
    #parentWidth;
    #parentHeight;
    constructor(x, y, parentWidth, parentHeight, rotation, thickness){
        this.#parentWidth = parentWidth;
        this.#parentHeight = parentHeight;
        this.#rotation = rotation;
        this.#thickness = thickness;
        [x, y] = this.#normalizePoint(x, y);
        const line = this.#line = [
            NaN,
            NaN,
            NaN,
            NaN,
            x,
            y
        ];
        this.#points = [
            x,
            y
        ];
        this.#lines = [
            {
                line: line,
                points: this.#points
            }
        ];
        this.#last.set(line, 0);
    }
    updateProperty(name, value) {
        if (name === "stroke-width") this.#thickness = value;
    }
    #normalizePoint(x, y) {
        return $9ef033443a74bee6$var$Outline._normalizePoint(x, y, this.#parentWidth, this.#parentHeight, this.#rotation);
    }
    isEmpty() {
        return !this.#lines || this.#lines.length === 0;
    }
    isCancellable() {
        return this.#points.length <= 10;
    }
    add(x, y) {
        [x, y] = this.#normalizePoint(x, y);
        const [x1, y1, x2, y2] = this.#last.subarray(2, 6);
        const diffX = x - x2;
        const diffY = y - y2;
        const d = Math.hypot(this.#parentWidth * diffX, this.#parentHeight * diffY);
        if (d <= 2) return null;
        this.#points.push(x, y);
        if (isNaN(x1)) {
            this.#last.set([
                x2,
                y2,
                x,
                y
            ], 2);
            this.#line.push(NaN, NaN, NaN, NaN, x, y);
            return {
                path: {
                    d: this.toSVGPath()
                }
            };
        }
        if (isNaN(this.#last[0])) this.#line.splice(6, 6);
        this.#last.set([
            x1,
            y1,
            x2,
            y2,
            x,
            y
        ], 0);
        this.#line.push(...$9ef033443a74bee6$var$Outline.createBezierPoints(x1, y1, x2, y2, x, y));
        return {
            path: {
                d: this.toSVGPath()
            }
        };
    }
    end(x, y) {
        const change = this.add(x, y);
        if (change) return change;
        if (this.#points.length === 2) return {
            path: {
                d: this.toSVGPath()
            }
        };
        return null;
    }
    startNew(x, y, parentWidth, parentHeight, rotation) {
        this.#parentWidth = parentWidth;
        this.#parentHeight = parentHeight;
        this.#rotation = rotation;
        [x, y] = this.#normalizePoint(x, y);
        const line = this.#line = [
            NaN,
            NaN,
            NaN,
            NaN,
            x,
            y
        ];
        this.#points = [
            x,
            y
        ];
        const last = this.#lines.at(-1);
        if (last) {
            last.line = new Float32Array(last.line);
            last.points = new Float32Array(last.points);
        }
        this.#lines.push({
            line: line,
            points: this.#points
        });
        this.#last.set(line, 0);
        this.#lastIndex = 0;
        this.toSVGPath();
        return null;
    }
    getLastElement() {
        return this.#lines.at(-1);
    }
    setLastElement(element) {
        if (!this.#lines) return this.#outlines.setLastElement(element);
        this.#lines.push(element);
        this.#line = element.line;
        this.#points = element.points;
        this.#lastIndex = 0;
        return {
            path: {
                d: this.toSVGPath()
            }
        };
    }
    removeLastElement() {
        if (!this.#lines) return this.#outlines.removeLastElement();
        this.#lines.pop();
        this.#lastSVGPath = "";
        for(let i = 0, ii = this.#lines.length; i < ii; i++){
            const { line: line, points: points } = this.#lines[i];
            this.#line = line;
            this.#points = points;
            this.#lastIndex = 0;
            this.toSVGPath();
        }
        return {
            path: {
                d: this.#lastSVGPath
            }
        };
    }
    toSVGPath() {
        const firstX = $9ef033443a74bee6$var$Outline.svgRound(this.#line[4]);
        const firstY = $9ef033443a74bee6$var$Outline.svgRound(this.#line[5]);
        if (this.#points.length === 2) {
            this.#lastSVGPath = `${this.#lastSVGPath} M ${firstX} ${firstY} Z`;
            return this.#lastSVGPath;
        }
        if (this.#points.length <= 6) {
            const i = this.#lastSVGPath.lastIndexOf("M");
            this.#lastSVGPath = `${this.#lastSVGPath.slice(0, i)} M ${firstX} ${firstY}`;
            this.#lastIndex = 6;
        }
        if (this.#points.length === 4) {
            const secondX = $9ef033443a74bee6$var$Outline.svgRound(this.#line[10]);
            const secondY = $9ef033443a74bee6$var$Outline.svgRound(this.#line[11]);
            this.#lastSVGPath = `${this.#lastSVGPath} L ${secondX} ${secondY}`;
            this.#lastIndex = 12;
            return this.#lastSVGPath;
        }
        const buffer = [];
        if (this.#lastIndex === 0) {
            buffer.push(`M ${firstX} ${firstY}`);
            this.#lastIndex = 6;
        }
        for(let i = this.#lastIndex, ii = this.#line.length; i < ii; i += 6){
            const [c1x, c1y, c2x, c2y, x, y] = this.#line.slice(i, i + 6).map($9ef033443a74bee6$var$Outline.svgRound);
            buffer.push(`C${c1x} ${c1y} ${c2x} ${c2y} ${x} ${y}`);
        }
        this.#lastSVGPath += buffer.join(" ");
        this.#lastIndex = this.#line.length;
        return this.#lastSVGPath;
    }
    getOutlines(parentWidth, parentHeight, scale, innerMargin) {
        const last = this.#lines.at(-1);
        last.line = new Float32Array(last.line);
        last.points = new Float32Array(last.points);
        this.#outlines.build(this.#lines, parentWidth, parentHeight, scale, this.#rotation, this.#thickness, innerMargin);
        this.#last = null;
        this.#line = null;
        this.#lines = null;
        this.#lastSVGPath = null;
        return this.#outlines;
    }
    get defaultSVGProperties() {
        return {
            root: {
                viewBox: "0 0 10000 10000"
            },
            rootClass: {
                draw: true
            },
            bbox: [
                0,
                0,
                1,
                1
            ]
        };
    }
}
class $9ef033443a74bee6$var$InkDrawOutline extends $9ef033443a74bee6$var$Outline {
    #bbox;
    #currentRotation = 0;
    #innerMargin;
    #lines;
    #parentWidth;
    #parentHeight;
    #parentScale;
    #rotation;
    #thickness;
    build(lines, parentWidth, parentHeight, parentScale, rotation, thickness, innerMargin) {
        this.#parentWidth = parentWidth;
        this.#parentHeight = parentHeight;
        this.#parentScale = parentScale;
        this.#rotation = rotation;
        this.#thickness = thickness;
        this.#innerMargin = innerMargin ?? 0;
        this.#lines = lines;
        this.#computeBbox();
    }
    get thickness() {
        return this.#thickness;
    }
    setLastElement(element) {
        this.#lines.push(element);
        return {
            path: {
                d: this.toSVGPath()
            }
        };
    }
    removeLastElement() {
        this.#lines.pop();
        return {
            path: {
                d: this.toSVGPath()
            }
        };
    }
    toSVGPath() {
        const buffer = [];
        for (const { line: line } of this.#lines){
            buffer.push(`M${$9ef033443a74bee6$var$Outline.svgRound(line[4])} ${$9ef033443a74bee6$var$Outline.svgRound(line[5])}`);
            if (line.length === 6) {
                buffer.push("Z");
                continue;
            }
            if (line.length === 12 && isNaN(line[6])) {
                buffer.push(`L${$9ef033443a74bee6$var$Outline.svgRound(line[10])} ${$9ef033443a74bee6$var$Outline.svgRound(line[11])}`);
                continue;
            }
            for(let i = 6, ii = line.length; i < ii; i += 6){
                const [c1x, c1y, c2x, c2y, x, y] = line.subarray(i, i + 6).map($9ef033443a74bee6$var$Outline.svgRound);
                buffer.push(`C${c1x} ${c1y} ${c2x} ${c2y} ${x} ${y}`);
            }
        }
        return buffer.join("");
    }
    serialize([pageX, pageY, pageWidth, pageHeight], isForCopying) {
        const serializedLines = [];
        const serializedPoints = [];
        const [x, y, width, height] = this.#getBBoxWithNoMargin();
        let tx, ty, sx, sy, x1, y1, x2, y2, rescaleFn;
        switch(this.#rotation){
            case 0:
                rescaleFn = $9ef033443a74bee6$var$Outline._rescale;
                tx = pageX;
                ty = pageY + pageHeight;
                sx = pageWidth;
                sy = -pageHeight;
                x1 = pageX + x * pageWidth;
                y1 = pageY + (1 - y - height) * pageHeight;
                x2 = pageX + (x + width) * pageWidth;
                y2 = pageY + (1 - y) * pageHeight;
                break;
            case 90:
                rescaleFn = $9ef033443a74bee6$var$Outline._rescaleAndSwap;
                tx = pageX;
                ty = pageY;
                sx = pageWidth;
                sy = pageHeight;
                x1 = pageX + y * pageWidth;
                y1 = pageY + x * pageHeight;
                x2 = pageX + (y + height) * pageWidth;
                y2 = pageY + (x + width) * pageHeight;
                break;
            case 180:
                rescaleFn = $9ef033443a74bee6$var$Outline._rescale;
                tx = pageX + pageWidth;
                ty = pageY;
                sx = -pageWidth;
                sy = pageHeight;
                x1 = pageX + (1 - x - width) * pageWidth;
                y1 = pageY + y * pageHeight;
                x2 = pageX + (1 - x) * pageWidth;
                y2 = pageY + (y + height) * pageHeight;
                break;
            case 270:
                rescaleFn = $9ef033443a74bee6$var$Outline._rescaleAndSwap;
                tx = pageX + pageWidth;
                ty = pageY + pageHeight;
                sx = -pageWidth;
                sy = -pageHeight;
                x1 = pageX + (1 - y - height) * pageWidth;
                y1 = pageY + (1 - x - width) * pageHeight;
                x2 = pageX + (1 - y) * pageWidth;
                y2 = pageY + (1 - x) * pageHeight;
                break;
        }
        for (const { line: line, points: points } of this.#lines){
            serializedLines.push(rescaleFn(line, tx, ty, sx, sy, isForCopying ? new Array(line.length) : null));
            serializedPoints.push(rescaleFn(points, tx, ty, sx, sy, isForCopying ? new Array(points.length) : null));
        }
        return {
            lines: serializedLines,
            points: serializedPoints,
            rect: [
                x1,
                y1,
                x2,
                y2
            ]
        };
    }
    static deserialize(pageX, pageY, pageWidth, pageHeight, innerMargin, { paths: { lines: lines, points: points }, rotation: rotation, thickness: thickness }) {
        const newLines = [];
        let tx, ty, sx, sy, rescaleFn;
        switch(rotation){
            case 0:
                rescaleFn = $9ef033443a74bee6$var$Outline._rescale;
                tx = -pageX / pageWidth;
                ty = pageY / pageHeight + 1;
                sx = 1 / pageWidth;
                sy = -1 / pageHeight;
                break;
            case 90:
                rescaleFn = $9ef033443a74bee6$var$Outline._rescaleAndSwap;
                tx = -pageY / pageHeight;
                ty = -pageX / pageWidth;
                sx = 1 / pageHeight;
                sy = 1 / pageWidth;
                break;
            case 180:
                rescaleFn = $9ef033443a74bee6$var$Outline._rescale;
                tx = pageX / pageWidth + 1;
                ty = -pageY / pageHeight;
                sx = -1 / pageWidth;
                sy = 1 / pageHeight;
                break;
            case 270:
                rescaleFn = $9ef033443a74bee6$var$Outline._rescaleAndSwap;
                tx = pageY / pageHeight + 1;
                ty = pageX / pageWidth + 1;
                sx = -1 / pageHeight;
                sy = -1 / pageWidth;
                break;
        }
        if (!lines) {
            lines = [];
            for (const point of points){
                const len = point.length;
                if (len === 2) {
                    lines.push(new Float32Array([
                        NaN,
                        NaN,
                        NaN,
                        NaN,
                        point[0],
                        point[1]
                    ]));
                    continue;
                }
                if (len === 4) {
                    lines.push(new Float32Array([
                        NaN,
                        NaN,
                        NaN,
                        NaN,
                        point[0],
                        point[1],
                        NaN,
                        NaN,
                        NaN,
                        NaN,
                        point[2],
                        point[3]
                    ]));
                    continue;
                }
                const line = new Float32Array(3 * (len - 2));
                lines.push(line);
                let [x1, y1, x2, y2] = point.subarray(0, 4);
                line.set([
                    NaN,
                    NaN,
                    NaN,
                    NaN,
                    x1,
                    y1
                ], 0);
                for(let i = 4; i < len; i += 2){
                    const x = point[i];
                    const y = point[i + 1];
                    line.set($9ef033443a74bee6$var$Outline.createBezierPoints(x1, y1, x2, y2, x, y), (i - 2) * 3);
                    [x1, y1, x2, y2] = [
                        x2,
                        y2,
                        x,
                        y
                    ];
                }
            }
        }
        for(let i = 0, ii = lines.length; i < ii; i++)newLines.push({
            line: rescaleFn(lines[i].map((x)=>x ?? NaN), tx, ty, sx, sy),
            points: rescaleFn(points[i].map((x)=>x ?? NaN), tx, ty, sx, sy)
        });
        const outlines = new this.prototype.constructor();
        outlines.build(newLines, pageWidth, pageHeight, 1, rotation, thickness, innerMargin);
        return outlines;
    }
    #getMarginComponents(thickness = this.#thickness) {
        const margin = this.#innerMargin + thickness / 2 * this.#parentScale;
        return this.#rotation % 180 === 0 ? [
            margin / this.#parentWidth,
            margin / this.#parentHeight
        ] : [
            margin / this.#parentHeight,
            margin / this.#parentWidth
        ];
    }
    #getBBoxWithNoMargin() {
        const [x, y, width, height] = this.#bbox;
        const [marginX, marginY] = this.#getMarginComponents(0);
        return [
            x + marginX,
            y + marginY,
            width - 2 * marginX,
            height - 2 * marginY
        ];
    }
    #computeBbox() {
        const bbox = this.#bbox = new Float32Array([
            Infinity,
            Infinity,
            -Infinity,
            -Infinity
        ]);
        for (const { line: line } of this.#lines){
            if (line.length <= 12) {
                for(let i = 4, ii = line.length; i < ii; i += 6)$9ef033443a74bee6$export$f8f26dd395d7e1bd.pointBoundingBox(line[i], line[i + 1], bbox);
                continue;
            }
            let lastX = line[4], lastY = line[5];
            for(let i = 6, ii = line.length; i < ii; i += 6){
                const [c1x, c1y, c2x, c2y, x, y] = line.subarray(i, i + 6);
                $9ef033443a74bee6$export$f8f26dd395d7e1bd.bezierBoundingBox(lastX, lastY, c1x, c1y, c2x, c2y, x, y, bbox);
                lastX = x;
                lastY = y;
            }
        }
        const [marginX, marginY] = this.#getMarginComponents();
        bbox[0] = $9ef033443a74bee6$export$b8106b171181a554(bbox[0] - marginX, 0, 1);
        bbox[1] = $9ef033443a74bee6$export$b8106b171181a554(bbox[1] - marginY, 0, 1);
        bbox[2] = $9ef033443a74bee6$export$b8106b171181a554(bbox[2] + marginX, 0, 1);
        bbox[3] = $9ef033443a74bee6$export$b8106b171181a554(bbox[3] + marginY, 0, 1);
        bbox[2] -= bbox[0];
        bbox[3] -= bbox[1];
    }
    get box() {
        return this.#bbox;
    }
    updateProperty(name, value) {
        if (name === "stroke-width") return this.#updateThickness(value);
        return null;
    }
    #updateThickness(thickness) {
        const [oldMarginX, oldMarginY] = this.#getMarginComponents();
        this.#thickness = thickness;
        const [newMarginX, newMarginY] = this.#getMarginComponents();
        const [diffMarginX, diffMarginY] = [
            newMarginX - oldMarginX,
            newMarginY - oldMarginY
        ];
        const bbox = this.#bbox;
        bbox[0] -= diffMarginX;
        bbox[1] -= diffMarginY;
        bbox[2] += 2 * diffMarginX;
        bbox[3] += 2 * diffMarginY;
        return bbox;
    }
    updateParentDimensions([width, height], scale) {
        const [oldMarginX, oldMarginY] = this.#getMarginComponents();
        this.#parentWidth = width;
        this.#parentHeight = height;
        this.#parentScale = scale;
        const [newMarginX, newMarginY] = this.#getMarginComponents();
        const diffMarginX = newMarginX - oldMarginX;
        const diffMarginY = newMarginY - oldMarginY;
        const bbox = this.#bbox;
        bbox[0] -= diffMarginX;
        bbox[1] -= diffMarginY;
        bbox[2] += 2 * diffMarginX;
        bbox[3] += 2 * diffMarginY;
        return bbox;
    }
    updateRotation(rotation) {
        this.#currentRotation = rotation;
        return {
            path: {
                transform: this.rotationTransform
            }
        };
    }
    get viewBox() {
        return this.#bbox.map($9ef033443a74bee6$var$Outline.svgRound).join(" ");
    }
    get defaultProperties() {
        const [x, y] = this.#bbox;
        return {
            root: {
                viewBox: this.viewBox
            },
            path: {
                "transform-origin": `${$9ef033443a74bee6$var$Outline.svgRound(x)} ${$9ef033443a74bee6$var$Outline.svgRound(y)}`
            }
        };
    }
    get rotationTransform() {
        const [, , width, height] = this.#bbox;
        let a = 0, b = 0, c = 0, d = 0, e = 0, f = 0;
        switch(this.#currentRotation){
            case 90:
                b = height / width;
                c = -width / height;
                e = width;
                break;
            case 180:
                a = -1;
                d = -1;
                e = width;
                f = height;
                break;
            case 270:
                b = -height / width;
                c = width / height;
                f = height;
                break;
            default:
                return "";
        }
        return `matrix(${a} ${b} ${c} ${d} ${$9ef033443a74bee6$var$Outline.svgRound(e)} ${$9ef033443a74bee6$var$Outline.svgRound(f)})`;
    }
    getPathResizingSVGProperties([newX, newY, newWidth, newHeight]) {
        const [marginX, marginY] = this.#getMarginComponents();
        const [x, y, width, height] = this.#bbox;
        if (Math.abs(width - marginX) <= $9ef033443a74bee6$var$Outline.PRECISION || Math.abs(height - marginY) <= $9ef033443a74bee6$var$Outline.PRECISION) {
            const tx = newX + newWidth / 2 - (x + width / 2);
            const ty = newY + newHeight / 2 - (y + height / 2);
            return {
                path: {
                    "transform-origin": `${$9ef033443a74bee6$var$Outline.svgRound(newX)} ${$9ef033443a74bee6$var$Outline.svgRound(newY)}`,
                    transform: `${this.rotationTransform} translate(${tx} ${ty})`
                }
            };
        }
        const s1x = (newWidth - 2 * marginX) / (width - 2 * marginX);
        const s1y = (newHeight - 2 * marginY) / (height - 2 * marginY);
        const s2x = width / newWidth;
        const s2y = height / newHeight;
        return {
            path: {
                "transform-origin": `${$9ef033443a74bee6$var$Outline.svgRound(x)} ${$9ef033443a74bee6$var$Outline.svgRound(y)}`,
                transform: `${this.rotationTransform} scale(${s2x} ${s2y}) ` + `translate(${$9ef033443a74bee6$var$Outline.svgRound(marginX)} ${$9ef033443a74bee6$var$Outline.svgRound(marginY)}) scale(${s1x} ${s1y}) ` + `translate(${$9ef033443a74bee6$var$Outline.svgRound(-marginX)} ${$9ef033443a74bee6$var$Outline.svgRound(-marginY)})`
            }
        };
    }
    getPathResizedSVGProperties([newX, newY, newWidth, newHeight]) {
        const [marginX, marginY] = this.#getMarginComponents();
        const bbox = this.#bbox;
        const [x, y, width, height] = bbox;
        bbox[0] = newX;
        bbox[1] = newY;
        bbox[2] = newWidth;
        bbox[3] = newHeight;
        if (Math.abs(width - marginX) <= $9ef033443a74bee6$var$Outline.PRECISION || Math.abs(height - marginY) <= $9ef033443a74bee6$var$Outline.PRECISION) {
            const tx = newX + newWidth / 2 - (x + width / 2);
            const ty = newY + newHeight / 2 - (y + height / 2);
            for (const { line: line, points: points } of this.#lines){
                $9ef033443a74bee6$var$Outline._translate(line, tx, ty, line);
                $9ef033443a74bee6$var$Outline._translate(points, tx, ty, points);
            }
            return {
                root: {
                    viewBox: this.viewBox
                },
                path: {
                    "transform-origin": `${$9ef033443a74bee6$var$Outline.svgRound(newX)} ${$9ef033443a74bee6$var$Outline.svgRound(newY)}`,
                    transform: this.rotationTransform || null,
                    d: this.toSVGPath()
                }
            };
        }
        const s1x = (newWidth - 2 * marginX) / (width - 2 * marginX);
        const s1y = (newHeight - 2 * marginY) / (height - 2 * marginY);
        const tx = -s1x * (x + marginX) + newX + marginX;
        const ty = -s1y * (y + marginY) + newY + marginY;
        if (s1x !== 1 || s1y !== 1 || tx !== 0 || ty !== 0) for (const { line: line, points: points } of this.#lines){
            $9ef033443a74bee6$var$Outline._rescale(line, tx, ty, s1x, s1y, line);
            $9ef033443a74bee6$var$Outline._rescale(points, tx, ty, s1x, s1y, points);
        }
        return {
            root: {
                viewBox: this.viewBox
            },
            path: {
                "transform-origin": `${$9ef033443a74bee6$var$Outline.svgRound(newX)} ${$9ef033443a74bee6$var$Outline.svgRound(newY)}`,
                transform: this.rotationTransform || null,
                d: this.toSVGPath()
            }
        };
    }
    getPathTranslatedSVGProperties([newX, newY], parentDimensions) {
        const [newParentWidth, newParentHeight] = parentDimensions;
        const bbox = this.#bbox;
        const tx = newX - bbox[0];
        const ty = newY - bbox[1];
        if (this.#parentWidth === newParentWidth && this.#parentHeight === newParentHeight) for (const { line: line, points: points } of this.#lines){
            $9ef033443a74bee6$var$Outline._translate(line, tx, ty, line);
            $9ef033443a74bee6$var$Outline._translate(points, tx, ty, points);
        }
        else {
            const sx = this.#parentWidth / newParentWidth;
            const sy = this.#parentHeight / newParentHeight;
            this.#parentWidth = newParentWidth;
            this.#parentHeight = newParentHeight;
            for (const { line: line, points: points } of this.#lines){
                $9ef033443a74bee6$var$Outline._rescale(line, tx, ty, sx, sy, line);
                $9ef033443a74bee6$var$Outline._rescale(points, tx, ty, sx, sy, points);
            }
            bbox[2] *= sx;
            bbox[3] *= sy;
        }
        bbox[0] = newX;
        bbox[1] = newY;
        return {
            root: {
                viewBox: this.viewBox
            },
            path: {
                d: this.toSVGPath(),
                "transform-origin": `${$9ef033443a74bee6$var$Outline.svgRound(newX)} ${$9ef033443a74bee6$var$Outline.svgRound(newY)}`
            }
        };
    }
    get defaultSVGProperties() {
        const bbox = this.#bbox;
        return {
            root: {
                viewBox: this.viewBox
            },
            rootClass: {
                draw: true
            },
            path: {
                d: this.toSVGPath(),
                "transform-origin": `${$9ef033443a74bee6$var$Outline.svgRound(bbox[0])} ${$9ef033443a74bee6$var$Outline.svgRound(bbox[1])}`,
                transform: this.rotationTransform || null
            },
            bbox: bbox
        };
    }
}
class $9ef033443a74bee6$var$InkDrawingOptions extends $9ef033443a74bee6$var$DrawingOptions {
    constructor(viewerParameters){
        super();
        this._viewParameters = viewerParameters;
        super.updateProperties({
            fill: "none",
            stroke: $9ef033443a74bee6$var$AnnotationEditor._defaultLineColor,
            "stroke-opacity": 1,
            "stroke-width": 1,
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-miterlimit": 10
        });
    }
    updateSVGProperty(name, value) {
        if (name === "stroke-width") {
            value ??= this["stroke-width"];
            value *= this._viewParameters.realScale;
        }
        super.updateSVGProperty(name, value);
    }
    clone() {
        const clone = new $9ef033443a74bee6$var$InkDrawingOptions(this._viewParameters);
        clone.updateAll(this);
        return clone;
    }
}
class $9ef033443a74bee6$var$InkEditor extends $9ef033443a74bee6$var$DrawingEditor {
    static _type = "ink";
    static _editorType = $9ef033443a74bee6$export$72ea3bfdd9a725bf.INK;
    static _defaultDrawingOptions = null;
    constructor(params){
        super({
            ...params,
            name: "inkEditor"
        });
        this._willKeepAspectRatio = true;
        this.defaultL10nId = "pdfjs-editor-ink-editor";
    }
    static initialize(l10n, uiManager) {
        $9ef033443a74bee6$var$AnnotationEditor.initialize(l10n, uiManager);
        this._defaultDrawingOptions = new $9ef033443a74bee6$var$InkDrawingOptions(uiManager.viewParameters);
    }
    static getDefaultDrawingOptions(options) {
        const clone = this._defaultDrawingOptions.clone();
        clone.updateProperties(options);
        return clone;
    }
    static get supportMultipleDrawings() {
        return true;
    }
    static get typesMap() {
        return $9ef033443a74bee6$export$b8972b998723d602(this, "typesMap", new Map([
            [
                $9ef033443a74bee6$export$cf3df2a6ecc26692.INK_THICKNESS,
                "stroke-width"
            ],
            [
                $9ef033443a74bee6$export$cf3df2a6ecc26692.INK_COLOR,
                "stroke"
            ],
            [
                $9ef033443a74bee6$export$cf3df2a6ecc26692.INK_OPACITY,
                "stroke-opacity"
            ]
        ]));
    }
    static createDrawerInstance(x, y, parentWidth, parentHeight, rotation) {
        return new $9ef033443a74bee6$var$InkDrawOutliner(x, y, parentWidth, parentHeight, rotation, this._defaultDrawingOptions["stroke-width"]);
    }
    static deserializeDraw(pageX, pageY, pageWidth, pageHeight, innerMargin, data) {
        return $9ef033443a74bee6$var$InkDrawOutline.deserialize(pageX, pageY, pageWidth, pageHeight, innerMargin, data);
    }
    static async deserialize(data, parent, uiManager) {
        let initialData = null;
        if (data instanceof $9ef033443a74bee6$var$InkAnnotationElement) {
            const { data: { inkLists: inkLists, rect: rect, rotation: rotation, id: id, color: color, opacity: opacity, borderStyle: { rawWidth: thickness }, popupRef: popupRef, richText: richText, contentsObj: contentsObj, creationDate: creationDate, modificationDate: modificationDate }, parent: { page: { pageNumber: pageNumber } } } = data;
            initialData = data = {
                annotationType: $9ef033443a74bee6$export$72ea3bfdd9a725bf.INK,
                color: Array.from(color),
                thickness: thickness,
                opacity: opacity,
                paths: {
                    points: inkLists
                },
                boxes: null,
                pageIndex: pageNumber - 1,
                rect: rect.slice(0),
                rotation: rotation,
                annotationElementId: id,
                id: id,
                deleted: false,
                popupRef: popupRef,
                richText: richText,
                comment: contentsObj?.str || null,
                creationDate: creationDate,
                modificationDate: modificationDate
            };
        }
        const editor = await super.deserialize(data, parent, uiManager);
        editor._initialData = initialData;
        if (data.comment) editor.setCommentData(data);
        return editor;
    }
    get toolbarButtons() {
        this._colorPicker ||= new $9ef033443a74bee6$var$BasicColorPicker(this);
        return [
            [
                "colorPicker",
                this._colorPicker
            ]
        ];
    }
    get colorType() {
        return $9ef033443a74bee6$export$cf3df2a6ecc26692.INK_COLOR;
    }
    get color() {
        return this._drawingOptions.stroke;
    }
    get opacity() {
        return this._drawingOptions["stroke-opacity"];
    }
    onScaleChanging() {
        if (!this.parent) return;
        super.onScaleChanging();
        const { _drawId: _drawId, _drawingOptions: _drawingOptions, parent: parent } = this;
        _drawingOptions.updateSVGProperty("stroke-width");
        parent.drawLayer.updateProperties(_drawId, _drawingOptions.toSVGProperties());
    }
    static onScaleChangingWhenDrawing() {
        const parent = this._currentParent;
        if (!parent) return;
        super.onScaleChangingWhenDrawing();
        this._defaultDrawingOptions.updateSVGProperty("stroke-width");
        parent.drawLayer.updateProperties(this._currentDrawId, this._defaultDrawingOptions.toSVGProperties());
    }
    createDrawingOptions({ color: color, thickness: thickness, opacity: opacity }) {
        this._drawingOptions = $9ef033443a74bee6$var$InkEditor.getDefaultDrawingOptions({
            stroke: $9ef033443a74bee6$export$f8f26dd395d7e1bd.makeHexColor(...color),
            "stroke-width": thickness,
            "stroke-opacity": opacity
        });
    }
    serialize(isForCopying = false) {
        if (this.isEmpty()) return null;
        if (this.deleted) return this.serializeDeleted();
        const { lines: lines, points: points } = this.serializeDraw(isForCopying);
        const { _drawingOptions: { stroke: stroke, "stroke-opacity": opacity, "stroke-width": thickness } } = this;
        const serialized = Object.assign(super.serialize(isForCopying), {
            color: $9ef033443a74bee6$var$AnnotationEditor._colorManager.convert(stroke),
            opacity: opacity,
            thickness: thickness,
            paths: {
                lines: lines,
                points: points
            }
        });
        this.addComment(serialized);
        if (isForCopying) {
            serialized.isCopy = true;
            return serialized;
        }
        if (this.annotationElementId && !this.#hasElementChanged(serialized)) return null;
        serialized.id = this.annotationElementId;
        return serialized;
    }
    #hasElementChanged(serialized) {
        const { color: color, thickness: thickness, opacity: opacity, pageIndex: pageIndex } = this._initialData;
        return this.hasEditedComment || this._hasBeenMoved || this._hasBeenResized || serialized.color.some((c, i)=>c !== color[i]) || serialized.thickness !== thickness || serialized.opacity !== opacity || serialized.pageIndex !== pageIndex;
    }
    renderAnnotationElement(annotation) {
        if (this.deleted) {
            annotation.hide();
            return null;
        }
        const { points: points, rect: rect } = this.serializeDraw(false);
        annotation.updateEdited({
            rect: rect,
            thickness: this._drawingOptions["stroke-width"],
            points: points,
            popup: this.comment
        });
        return null;
    }
}
class $9ef033443a74bee6$var$ContourDrawOutline extends $9ef033443a74bee6$var$InkDrawOutline {
    toSVGPath() {
        let path = super.toSVGPath();
        if (!path.endsWith("Z")) path += "Z";
        return path;
    }
}
const $9ef033443a74bee6$var$BASE_HEADER_LENGTH = 8;
const $9ef033443a74bee6$var$POINTS_PROPERTIES_NUMBER = 3;
class $9ef033443a74bee6$export$cc4fe8633f466b4a {
    static #PARAMETERS = {
        maxDim: 512,
        sigmaSFactor: 0.02,
        sigmaR: 25,
        kernelSize: 16
    };
    static #neighborIndexToId(i0, j0, i, j) {
        i -= i0;
        j -= j0;
        if (i === 0) return j > 0 ? 0 : 4;
        if (i === 1) return j + 6;
        return 2 - j;
    }
    static #neighborIdToIndex = new Int32Array([
        0,
        1,
        -1,
        1,
        -1,
        0,
        -1,
        -1,
        0,
        -1,
        1,
        -1,
        1,
        0,
        1,
        1
    ]);
    static #clockwiseNonZero(buf, width, i0, j0, i, j, offset) {
        const id = this.#neighborIndexToId(i0, j0, i, j);
        for(let k = 0; k < 8; k++){
            const kk = (-k + id - offset + 16) % 8;
            const shiftI = this.#neighborIdToIndex[2 * kk];
            const shiftJ = this.#neighborIdToIndex[2 * kk + 1];
            if (buf[(i0 + shiftI) * width + (j0 + shiftJ)] !== 0) return kk;
        }
        return -1;
    }
    static #counterClockwiseNonZero(buf, width, i0, j0, i, j, offset) {
        const id = this.#neighborIndexToId(i0, j0, i, j);
        for(let k = 0; k < 8; k++){
            const kk = (k + id + offset + 16) % 8;
            const shiftI = this.#neighborIdToIndex[2 * kk];
            const shiftJ = this.#neighborIdToIndex[2 * kk + 1];
            if (buf[(i0 + shiftI) * width + (j0 + shiftJ)] !== 0) return kk;
        }
        return -1;
    }
    static #findContours(buf, width, height, threshold) {
        const N = buf.length;
        const types = new Int32Array(N);
        for(let i = 0; i < N; i++)types[i] = buf[i] <= threshold ? 1 : 0;
        for(let i = 1; i < height - 1; i++)types[i * width] = types[i * width + width - 1] = 0;
        for(let i = 0; i < width; i++)types[i] = types[width * height - 1 - i] = 0;
        let nbd = 1;
        let lnbd;
        const contours = [];
        for(let i = 1; i < height - 1; i++){
            lnbd = 1;
            for(let j = 1; j < width - 1; j++){
                const ij = i * width + j;
                const pix = types[ij];
                if (pix === 0) continue;
                let i2 = i;
                let j2 = j;
                if (pix === 1 && types[ij - 1] === 0) {
                    nbd += 1;
                    j2 -= 1;
                } else if (pix >= 1 && types[ij + 1] === 0) {
                    nbd += 1;
                    j2 += 1;
                    if (pix > 1) lnbd = pix;
                } else {
                    if (pix !== 1) lnbd = Math.abs(pix);
                    continue;
                }
                const points = [
                    j,
                    i
                ];
                const isHole = j2 === j + 1;
                const contour = {
                    isHole: isHole,
                    points: points,
                    id: nbd,
                    parent: 0
                };
                contours.push(contour);
                let contour0;
                for (const c of contours)if (c.id === lnbd) {
                    contour0 = c;
                    break;
                }
                if (!contour0) contour.parent = isHole ? lnbd : 0;
                else if (contour0.isHole) contour.parent = isHole ? contour0.parent : lnbd;
                else contour.parent = isHole ? lnbd : contour0.parent;
                const k = this.#clockwiseNonZero(types, width, i, j, i2, j2, 0);
                if (k === -1) {
                    types[ij] = -nbd;
                    if (types[ij] !== 1) lnbd = Math.abs(types[ij]);
                    continue;
                }
                let shiftI = this.#neighborIdToIndex[2 * k];
                let shiftJ = this.#neighborIdToIndex[2 * k + 1];
                const i1 = i + shiftI;
                const j1 = j + shiftJ;
                i2 = i1;
                j2 = j1;
                let i3 = i;
                let j3 = j;
                while(true){
                    const kk = this.#counterClockwiseNonZero(types, width, i3, j3, i2, j2, 1);
                    shiftI = this.#neighborIdToIndex[2 * kk];
                    shiftJ = this.#neighborIdToIndex[2 * kk + 1];
                    const i4 = i3 + shiftI;
                    const j4 = j3 + shiftJ;
                    points.push(j4, i4);
                    const ij3 = i3 * width + j3;
                    if (types[ij3 + 1] === 0) types[ij3] = -nbd;
                    else if (types[ij3] === 1) types[ij3] = nbd;
                    if (i4 === i && j4 === j && i3 === i1 && j3 === j1) {
                        if (types[ij] !== 1) lnbd = Math.abs(types[ij]);
                        break;
                    } else {
                        i2 = i3;
                        j2 = j3;
                        i3 = i4;
                        j3 = j4;
                    }
                }
            }
        }
        return contours;
    }
    static #douglasPeuckerHelper(points, start, end, output) {
        if (end - start <= 4) {
            for(let i = start; i < end - 2; i += 2)output.push(points[i], points[i + 1]);
            return;
        }
        const ax = points[start];
        const ay = points[start + 1];
        const abx = points[end - 4] - ax;
        const aby = points[end - 3] - ay;
        const dist = Math.hypot(abx, aby);
        const nabx = abx / dist;
        const naby = aby / dist;
        const aa = nabx * ay - naby * ax;
        const m = aby / abx;
        const invS = 1 / dist;
        const phi = Math.atan(m);
        const cosPhi = Math.cos(phi);
        const sinPhi = Math.sin(phi);
        const tmax = invS * (Math.abs(cosPhi) + Math.abs(sinPhi));
        const poly = invS * (1 - tmax + tmax ** 2);
        const partialPhi = Math.max(Math.atan(Math.abs(sinPhi + cosPhi) * poly), Math.atan(Math.abs(sinPhi - cosPhi) * poly));
        let dmax = 0;
        let index = start;
        for(let i = start + 2; i < end - 2; i += 2){
            const d = Math.abs(aa - nabx * points[i + 1] + naby * points[i]);
            if (d > dmax) {
                index = i;
                dmax = d;
            }
        }
        if (dmax > (dist * partialPhi) ** 2) {
            this.#douglasPeuckerHelper(points, start, index + 2, output);
            this.#douglasPeuckerHelper(points, index, end, output);
        } else output.push(ax, ay);
    }
    static #douglasPeucker(points) {
        const output = [];
        const len = points.length;
        this.#douglasPeuckerHelper(points, 0, len, output);
        output.push(points[len - 2], points[len - 1]);
        return output.length <= 4 ? null : output;
    }
    static #bilateralFilter(buf, width, height, sigmaS, sigmaR, kernelSize) {
        const kernel = new Float32Array(kernelSize ** 2);
        const sigmaS2 = -2 * sigmaS ** 2;
        const halfSize = kernelSize >> 1;
        for(let i = 0; i < kernelSize; i++){
            const x = (i - halfSize) ** 2;
            for(let j = 0; j < kernelSize; j++)kernel[i * kernelSize + j] = Math.exp((x + (j - halfSize) ** 2) / sigmaS2);
        }
        const rangeValues = new Float32Array(256);
        const sigmaR2 = -2 * sigmaR ** 2;
        for(let i = 0; i < 256; i++)rangeValues[i] = Math.exp(i ** 2 / sigmaR2);
        const N = buf.length;
        const out = new Uint8Array(N);
        const histogram = new Uint32Array(256);
        for(let i = 0; i < height; i++)for(let j = 0; j < width; j++){
            const ij = i * width + j;
            const center = buf[ij];
            let sum = 0;
            let norm = 0;
            for(let k = 0; k < kernelSize; k++){
                const y = i + k - halfSize;
                if (y < 0 || y >= height) continue;
                for(let l = 0; l < kernelSize; l++){
                    const x = j + l - halfSize;
                    if (x < 0 || x >= width) continue;
                    const neighbour = buf[y * width + x];
                    const w = kernel[k * kernelSize + l] * rangeValues[Math.abs(neighbour - center)];
                    sum += neighbour * w;
                    norm += w;
                }
            }
            const pix = out[ij] = Math.round(sum / norm);
            histogram[pix]++;
        }
        return [
            out,
            histogram
        ];
    }
    static #getHistogram(buf) {
        const histogram = new Uint32Array(256);
        for (const g of buf)histogram[g]++;
        return histogram;
    }
    static #toUint8(buf) {
        const N = buf.length;
        const out = new Uint8ClampedArray(N >> 2);
        let max = -Infinity;
        let min = Infinity;
        for(let i = 0, ii = out.length; i < ii; i++){
            const pix = out[i] = buf[i << 2];
            max = Math.max(max, pix);
            min = Math.min(min, pix);
        }
        const ratio = 255 / (max - min);
        for(let i = 0, ii = out.length; i < ii; i++)out[i] = (out[i] - min) * ratio;
        return out;
    }
    static #guessThreshold(histogram) {
        let i;
        let M = -Infinity;
        let L = -Infinity;
        const min = histogram.findIndex((v)=>v !== 0);
        let pos = min;
        let spos = min;
        for(i = min; i < 256; i++){
            const v = histogram[i];
            if (v > M) {
                if (i - pos > L) {
                    L = i - pos;
                    spos = i - 1;
                }
                M = v;
                pos = i;
            }
        }
        for(i = spos - 1; i >= 0; i--){
            if (histogram[i] > histogram[i + 1]) break;
        }
        return i;
    }
    static #getGrayPixels(bitmap) {
        const originalBitmap = bitmap;
        const { width: width, height: height } = bitmap;
        const { maxDim: maxDim } = this.#PARAMETERS;
        let newWidth = width;
        let newHeight = height;
        if (width > maxDim || height > maxDim) {
            let prevWidth = width;
            let prevHeight = height;
            let steps = Math.log2(Math.max(width, height) / maxDim);
            const isteps = Math.floor(steps);
            steps = steps === isteps ? isteps - 1 : isteps;
            for(let i = 0; i < steps; i++){
                newWidth = Math.ceil(prevWidth / 2);
                newHeight = Math.ceil(prevHeight / 2);
                const offscreen = new OffscreenCanvas(newWidth, newHeight);
                const ctx = offscreen.getContext("2d");
                ctx.drawImage(bitmap, 0, 0, prevWidth, prevHeight, 0, 0, newWidth, newHeight);
                prevWidth = newWidth;
                prevHeight = newHeight;
                if (bitmap !== originalBitmap) bitmap.close();
                bitmap = offscreen.transferToImageBitmap();
            }
            const ratio = Math.min(maxDim / newWidth, maxDim / newHeight);
            newWidth = Math.round(newWidth * ratio);
            newHeight = Math.round(newHeight * ratio);
        }
        const offscreen = new OffscreenCanvas(newWidth, newHeight);
        const ctx = offscreen.getContext("2d", {
            willReadFrequently: true
        });
        ctx.fillStyle = "white";
        ctx.fillRect(0, 0, newWidth, newHeight);
        ctx.filter = "grayscale(1)";
        ctx.drawImage(bitmap, 0, 0, bitmap.width, bitmap.height, 0, 0, newWidth, newHeight);
        const grayImage = ctx.getImageData(0, 0, newWidth, newHeight).data;
        const uint8Buf = this.#toUint8(grayImage);
        return [
            uint8Buf,
            newWidth,
            newHeight
        ];
    }
    static extractContoursFromText(text, { fontFamily: fontFamily, fontStyle: fontStyle, fontWeight: fontWeight }, pageWidth, pageHeight, rotation, innerMargin) {
        let canvas = new OffscreenCanvas(1, 1);
        let ctx = canvas.getContext("2d", {
            alpha: false
        });
        const fontSize = 200;
        const font = ctx.font = `${fontStyle} ${fontWeight} ${fontSize}px ${fontFamily}`;
        const { actualBoundingBoxLeft: actualBoundingBoxLeft, actualBoundingBoxRight: actualBoundingBoxRight, actualBoundingBoxAscent: actualBoundingBoxAscent, actualBoundingBoxDescent: actualBoundingBoxDescent, fontBoundingBoxAscent: fontBoundingBoxAscent, fontBoundingBoxDescent: fontBoundingBoxDescent, width: width } = ctx.measureText(text);
        const SCALE = 1.5;
        const canvasWidth = Math.ceil(Math.max(Math.abs(actualBoundingBoxLeft) + Math.abs(actualBoundingBoxRight) || 0, width) * SCALE);
        const canvasHeight = Math.ceil(Math.max(Math.abs(actualBoundingBoxAscent) + Math.abs(actualBoundingBoxDescent) || fontSize, Math.abs(fontBoundingBoxAscent) + Math.abs(fontBoundingBoxDescent) || fontSize) * SCALE);
        canvas = new OffscreenCanvas(canvasWidth, canvasHeight);
        ctx = canvas.getContext("2d", {
            alpha: true,
            willReadFrequently: true
        });
        ctx.font = font;
        ctx.filter = "grayscale(1)";
        ctx.fillStyle = "white";
        ctx.fillRect(0, 0, canvasWidth, canvasHeight);
        ctx.fillStyle = "black";
        ctx.fillText(text, canvasWidth * (SCALE - 1) / 2, canvasHeight * (3 - SCALE) / 2);
        const uint8Buf = this.#toUint8(ctx.getImageData(0, 0, canvasWidth, canvasHeight).data);
        const histogram = this.#getHistogram(uint8Buf);
        const threshold = this.#guessThreshold(histogram);
        const contourList = this.#findContours(uint8Buf, canvasWidth, canvasHeight, threshold);
        return this.processDrawnLines({
            lines: {
                curves: contourList,
                width: canvasWidth,
                height: canvasHeight
            },
            pageWidth: pageWidth,
            pageHeight: pageHeight,
            rotation: rotation,
            innerMargin: innerMargin,
            mustSmooth: true,
            areContours: true
        });
    }
    static process(bitmap, pageWidth, pageHeight, rotation, innerMargin) {
        const [uint8Buf, width, height] = this.#getGrayPixels(bitmap);
        const [buffer, histogram] = this.#bilateralFilter(uint8Buf, width, height, Math.hypot(width, height) * this.#PARAMETERS.sigmaSFactor, this.#PARAMETERS.sigmaR, this.#PARAMETERS.kernelSize);
        const threshold = this.#guessThreshold(histogram);
        const contourList = this.#findContours(buffer, width, height, threshold);
        return this.processDrawnLines({
            lines: {
                curves: contourList,
                width: width,
                height: height
            },
            pageWidth: pageWidth,
            pageHeight: pageHeight,
            rotation: rotation,
            innerMargin: innerMargin,
            mustSmooth: true,
            areContours: true
        });
    }
    static processDrawnLines({ lines: lines, pageWidth: pageWidth, pageHeight: pageHeight, rotation: rotation, innerMargin: innerMargin, mustSmooth: mustSmooth, areContours: areContours }) {
        if (rotation % 180 !== 0) [pageWidth, pageHeight] = [
            pageHeight,
            pageWidth
        ];
        const { curves: curves, width: width, height: height } = lines;
        const thickness = lines.thickness ?? 0;
        const linesAndPoints = [];
        const ratio = Math.min(pageWidth / width, pageHeight / height);
        const xScale = ratio / pageWidth;
        const yScale = ratio / pageHeight;
        const newCurves = [];
        for (const { points: points } of curves){
            const reducedPoints = mustSmooth ? this.#douglasPeucker(points) : points;
            if (!reducedPoints) continue;
            newCurves.push(reducedPoints);
            const len = reducedPoints.length;
            const newPoints = new Float32Array(len);
            const line = new Float32Array(3 * (len === 2 ? 2 : len - 2));
            linesAndPoints.push({
                line: line,
                points: newPoints
            });
            if (len === 2) {
                newPoints[0] = reducedPoints[0] * xScale;
                newPoints[1] = reducedPoints[1] * yScale;
                line.set([
                    NaN,
                    NaN,
                    NaN,
                    NaN,
                    newPoints[0],
                    newPoints[1]
                ], 0);
                continue;
            }
            let [x1, y1, x2, y2] = reducedPoints;
            x1 *= xScale;
            y1 *= yScale;
            x2 *= xScale;
            y2 *= yScale;
            newPoints.set([
                x1,
                y1,
                x2,
                y2
            ], 0);
            line.set([
                NaN,
                NaN,
                NaN,
                NaN,
                x1,
                y1
            ], 0);
            for(let i = 4; i < len; i += 2){
                const x = newPoints[i] = reducedPoints[i] * xScale;
                const y = newPoints[i + 1] = reducedPoints[i + 1] * yScale;
                line.set($9ef033443a74bee6$var$Outline.createBezierPoints(x1, y1, x2, y2, x, y), (i - 2) * 3);
                [x1, y1, x2, y2] = [
                    x2,
                    y2,
                    x,
                    y
                ];
            }
        }
        if (linesAndPoints.length === 0) return null;
        const outline = areContours ? new $9ef033443a74bee6$var$ContourDrawOutline() : new $9ef033443a74bee6$var$InkDrawOutline();
        outline.build(linesAndPoints, pageWidth, pageHeight, 1, rotation, areContours ? 0 : thickness, innerMargin);
        return {
            outline: outline,
            newCurves: newCurves,
            areContours: areContours,
            thickness: thickness,
            width: width,
            height: height
        };
    }
    static async compressSignature({ outlines: outlines, areContours: areContours, thickness: thickness, width: width, height: height }) {
        let minDiff = Infinity;
        let maxDiff = -Infinity;
        let outlinesLength = 0;
        for (const points of outlines){
            outlinesLength += points.length;
            for(let i = 2, ii = points.length; i < ii; i++){
                const dx = points[i] - points[i - 2];
                minDiff = Math.min(minDiff, dx);
                maxDiff = Math.max(maxDiff, dx);
            }
        }
        let bufferType;
        if (minDiff >= -128 && maxDiff <= 127) bufferType = Int8Array;
        else if (minDiff >= -32768 && maxDiff <= 32767) bufferType = Int16Array;
        else bufferType = Int32Array;
        const len = outlines.length;
        const headerLength = $9ef033443a74bee6$var$BASE_HEADER_LENGTH + $9ef033443a74bee6$var$POINTS_PROPERTIES_NUMBER * len;
        const header = new Uint32Array(headerLength);
        let offset = 0;
        header[offset++] = headerLength * Uint32Array.BYTES_PER_ELEMENT + (outlinesLength - 2 * len) * bufferType.BYTES_PER_ELEMENT;
        header[offset++] = 0;
        header[offset++] = width;
        header[offset++] = height;
        header[offset++] = areContours ? 0 : 1;
        header[offset++] = Math.max(0, Math.floor(thickness ?? 0));
        header[offset++] = len;
        header[offset++] = bufferType.BYTES_PER_ELEMENT;
        for (const points of outlines){
            header[offset++] = points.length - 2;
            header[offset++] = points[0];
            header[offset++] = points[1];
        }
        const cs = new CompressionStream("deflate-raw");
        const writer = cs.writable.getWriter();
        await writer.ready;
        writer.write(header);
        const BufferCtor = bufferType.prototype.constructor;
        for (const points of outlines){
            const diffs = new BufferCtor(points.length - 2);
            for(let i = 2, ii = points.length; i < ii; i++)diffs[i - 2] = points[i] - points[i - 2];
            writer.write(diffs);
        }
        writer.close();
        const buf = await new Response(cs.readable).arrayBuffer();
        const bytes = new Uint8Array(buf);
        return $9ef033443a74bee6$var$toBase64Util(bytes);
    }
    static async decompressSignature(signatureData) {
        try {
            const bytes = $9ef033443a74bee6$var$fromBase64Util(signatureData);
            const { readable: readable, writable: writable } = new DecompressionStream("deflate-raw");
            const writer = writable.getWriter();
            await writer.ready;
            writer.write(bytes).then(async ()=>{
                await writer.ready;
                await writer.close();
            }).catch(()=>{});
            let data = null;
            let offset = 0;
            for await (const chunk of readable){
                data ||= new Uint8Array(new Uint32Array(chunk.buffer, 0, 4)[0]);
                data.set(chunk, offset);
                offset += chunk.length;
            }
            const header = new Uint32Array(data.buffer, 0, data.length >> 2);
            const version = header[1];
            if (version !== 0) throw new Error(`Invalid version: ${version}`);
            const width = header[2];
            const height = header[3];
            const areContours = header[4] === 0;
            const thickness = header[5];
            const numberOfDrawings = header[6];
            const bufferType = header[7];
            const outlines = [];
            const diffsOffset = ($9ef033443a74bee6$var$BASE_HEADER_LENGTH + $9ef033443a74bee6$var$POINTS_PROPERTIES_NUMBER * numberOfDrawings) * Uint32Array.BYTES_PER_ELEMENT;
            let diffs;
            switch(bufferType){
                case Int8Array.BYTES_PER_ELEMENT:
                    diffs = new Int8Array(data.buffer, diffsOffset);
                    break;
                case Int16Array.BYTES_PER_ELEMENT:
                    diffs = new Int16Array(data.buffer, diffsOffset);
                    break;
                case Int32Array.BYTES_PER_ELEMENT:
                    diffs = new Int32Array(data.buffer, diffsOffset);
                    break;
            }
            offset = 0;
            for(let i = 0; i < numberOfDrawings; i++){
                const len = header[$9ef033443a74bee6$var$POINTS_PROPERTIES_NUMBER * i + $9ef033443a74bee6$var$BASE_HEADER_LENGTH];
                const points = new Float32Array(len + 2);
                outlines.push(points);
                for(let j = 0; j < $9ef033443a74bee6$var$POINTS_PROPERTIES_NUMBER - 1; j++)points[j] = header[$9ef033443a74bee6$var$POINTS_PROPERTIES_NUMBER * i + $9ef033443a74bee6$var$BASE_HEADER_LENGTH + j + 1];
                for(let j = 0; j < len; j++)points[j + 2] = points[j] + diffs[offset++];
            }
            return {
                areContours: areContours,
                thickness: thickness,
                outlines: outlines,
                width: width,
                height: height
            };
        } catch (e) {
            $9ef033443a74bee6$var$warn(`decompressSignature: ${e}`);
            return null;
        }
    }
}
class $9ef033443a74bee6$var$SignatureOptions extends $9ef033443a74bee6$var$DrawingOptions {
    constructor(){
        super();
        super.updateProperties({
            fill: $9ef033443a74bee6$var$AnnotationEditor._defaultLineColor,
            "stroke-width": 0
        });
    }
    clone() {
        const clone = new $9ef033443a74bee6$var$SignatureOptions();
        clone.updateAll(this);
        return clone;
    }
}
class $9ef033443a74bee6$var$DrawnSignatureOptions extends $9ef033443a74bee6$var$InkDrawingOptions {
    constructor(viewerParameters){
        super(viewerParameters);
        super.updateProperties({
            stroke: $9ef033443a74bee6$var$AnnotationEditor._defaultLineColor,
            "stroke-width": 1
        });
    }
    clone() {
        const clone = new $9ef033443a74bee6$var$DrawnSignatureOptions(this._viewParameters);
        clone.updateAll(this);
        return clone;
    }
}
class $9ef033443a74bee6$var$SignatureEditor extends $9ef033443a74bee6$var$DrawingEditor {
    #isExtracted = false;
    #description = null;
    #signatureData = null;
    #signatureUUID = null;
    static _type = "signature";
    static _editorType = $9ef033443a74bee6$export$72ea3bfdd9a725bf.SIGNATURE;
    static _defaultDrawingOptions = null;
    constructor(params){
        super({
            ...params,
            mustBeCommitted: true,
            name: "signatureEditor"
        });
        this._willKeepAspectRatio = true;
        this.#signatureData = params.signatureData || null;
        this.#description = null;
        this.defaultL10nId = "pdfjs-editor-signature-editor1";
    }
    static initialize(l10n, uiManager) {
        $9ef033443a74bee6$var$AnnotationEditor.initialize(l10n, uiManager);
        this._defaultDrawingOptions = new $9ef033443a74bee6$var$SignatureOptions();
        this._defaultDrawnSignatureOptions = new $9ef033443a74bee6$var$DrawnSignatureOptions(uiManager.viewParameters);
    }
    static getDefaultDrawingOptions(options) {
        const clone = this._defaultDrawingOptions.clone();
        clone.updateProperties(options);
        return clone;
    }
    static get supportMultipleDrawings() {
        return false;
    }
    static get typesMap() {
        return $9ef033443a74bee6$export$b8972b998723d602(this, "typesMap", new Map());
    }
    static get isDrawer() {
        return false;
    }
    get telemetryFinalData() {
        return {
            type: "signature",
            hasDescription: !!this.#description
        };
    }
    static computeTelemetryFinalData(data) {
        const hasDescriptionStats = data.get("hasDescription");
        return {
            hasAltText: hasDescriptionStats.get(true) ?? 0,
            hasNoAltText: hasDescriptionStats.get(false) ?? 0
        };
    }
    get isResizable() {
        return true;
    }
    onScaleChanging() {
        if (this._drawId === null) return;
        super.onScaleChanging();
    }
    render() {
        if (this.div) return this.div;
        let baseX, baseY;
        const { _isCopy: _isCopy } = this;
        if (_isCopy) {
            this._isCopy = false;
            baseX = this.x;
            baseY = this.y;
        }
        super.render();
        if (this._drawId === null) {
            if (this.#signatureData) {
                const { lines: lines, mustSmooth: mustSmooth, areContours: areContours, description: description, uuid: uuid, heightInPage: heightInPage } = this.#signatureData;
                const { rawDims: { pageWidth: pageWidth, pageHeight: pageHeight }, rotation: rotation } = this.parent.viewport;
                const outline = $9ef033443a74bee6$export$cc4fe8633f466b4a.processDrawnLines({
                    lines: lines,
                    pageWidth: pageWidth,
                    pageHeight: pageHeight,
                    rotation: rotation,
                    innerMargin: $9ef033443a74bee6$var$SignatureEditor._INNER_MARGIN,
                    mustSmooth: mustSmooth,
                    areContours: areContours
                });
                this.addSignature(outline, heightInPage, description, uuid);
            } else {
                this.div.setAttribute("data-l10n-args", JSON.stringify({
                    description: ""
                }));
                this.div.hidden = true;
                this._uiManager.getSignature(this);
            }
        } else this.div.setAttribute("data-l10n-args", JSON.stringify({
            description: this.#description || ""
        }));
        if (_isCopy) {
            this._isCopy = true;
            this._moveAfterPaste(baseX, baseY);
        }
        return this.div;
    }
    setUuid(uuid) {
        this.#signatureUUID = uuid;
        this.addEditToolbar();
    }
    getUuid() {
        return this.#signatureUUID;
    }
    get description() {
        return this.#description;
    }
    set description(description) {
        this.#description = description;
        if (!this.div) return;
        this.div.setAttribute("data-l10n-args", JSON.stringify({
            description: description
        }));
        super.addEditToolbar().then((toolbar)=>{
            toolbar?.updateEditSignatureButton(description);
        });
    }
    getSignaturePreview() {
        const { newCurves: newCurves, areContours: areContours, thickness: thickness, width: width, height: height } = this.#signatureData;
        const maxDim = Math.max(width, height);
        const outlineData = $9ef033443a74bee6$export$cc4fe8633f466b4a.processDrawnLines({
            lines: {
                curves: newCurves.map((points)=>({
                        points: points
                    })),
                thickness: thickness,
                width: width,
                height: height
            },
            pageWidth: maxDim,
            pageHeight: maxDim,
            rotation: 0,
            innerMargin: 0,
            mustSmooth: false,
            areContours: areContours
        });
        return {
            areContours: areContours,
            outline: outlineData.outline
        };
    }
    get toolbarButtons() {
        if (this._uiManager.signatureManager) return [
            [
                "editSignature",
                this._uiManager.signatureManager
            ]
        ];
        return super.toolbarButtons;
    }
    addSignature(data, heightInPage, description, uuid) {
        const { x: savedX, y: savedY } = this;
        const { outline: outline } = this.#signatureData = data;
        this.#isExtracted = outline instanceof $9ef033443a74bee6$var$ContourDrawOutline;
        this.description = description;
        let drawingOptions;
        if (this.#isExtracted) drawingOptions = $9ef033443a74bee6$var$SignatureEditor.getDefaultDrawingOptions();
        else {
            drawingOptions = $9ef033443a74bee6$var$SignatureEditor._defaultDrawnSignatureOptions.clone();
            drawingOptions.updateProperties({
                "stroke-width": outline.thickness
            });
        }
        this._addOutlines({
            drawOutlines: outline,
            drawingOptions: drawingOptions
        });
        const [, pageHeight] = this.pageDimensions;
        let newHeight = heightInPage / pageHeight;
        newHeight = newHeight >= 1 ? 0.5 : newHeight;
        this.width *= newHeight / this.height;
        if (this.width >= 1) {
            newHeight *= 0.9 / this.width;
            this.width = 0.9;
        }
        this.height = newHeight;
        this.setDims();
        this.x = savedX;
        this.y = savedY;
        this.center();
        this._onResized();
        this.onScaleChanging();
        this.rotate();
        this._uiManager.addToAnnotationStorage(this);
        this.setUuid(uuid);
        this._reportTelemetry({
            action: "pdfjs.signature.inserted",
            data: {
                hasBeenSaved: !!uuid,
                hasDescription: !!description
            }
        });
        this.div.hidden = false;
    }
    getFromImage(bitmap) {
        const { rawDims: { pageWidth: pageWidth, pageHeight: pageHeight }, rotation: rotation } = this.parent.viewport;
        return $9ef033443a74bee6$export$cc4fe8633f466b4a.process(bitmap, pageWidth, pageHeight, rotation, $9ef033443a74bee6$var$SignatureEditor._INNER_MARGIN);
    }
    getFromText(text, fontInfo) {
        const { rawDims: { pageWidth: pageWidth, pageHeight: pageHeight }, rotation: rotation } = this.parent.viewport;
        return $9ef033443a74bee6$export$cc4fe8633f466b4a.extractContoursFromText(text, fontInfo, pageWidth, pageHeight, rotation, $9ef033443a74bee6$var$SignatureEditor._INNER_MARGIN);
    }
    getDrawnSignature(curves) {
        const { rawDims: { pageWidth: pageWidth, pageHeight: pageHeight }, rotation: rotation } = this.parent.viewport;
        return $9ef033443a74bee6$export$cc4fe8633f466b4a.processDrawnLines({
            lines: curves,
            pageWidth: pageWidth,
            pageHeight: pageHeight,
            rotation: rotation,
            innerMargin: $9ef033443a74bee6$var$SignatureEditor._INNER_MARGIN,
            mustSmooth: false,
            areContours: false
        });
    }
    createDrawingOptions({ areContours: areContours, thickness: thickness }) {
        if (areContours) this._drawingOptions = $9ef033443a74bee6$var$SignatureEditor.getDefaultDrawingOptions();
        else {
            this._drawingOptions = $9ef033443a74bee6$var$SignatureEditor._defaultDrawnSignatureOptions.clone();
            this._drawingOptions.updateProperties({
                "stroke-width": thickness
            });
        }
    }
    serialize(isForCopying = false) {
        if (this.isEmpty()) return null;
        const { lines: lines, points: points } = this.serializeDraw(isForCopying);
        const { _drawingOptions: { "stroke-width": thickness } } = this;
        const serialized = Object.assign(super.serialize(isForCopying), {
            isSignature: true,
            areContours: this.#isExtracted,
            color: [
                0,
                0,
                0
            ],
            thickness: this.#isExtracted ? 0 : thickness
        });
        this.addComment(serialized);
        if (isForCopying) {
            serialized.paths = {
                lines: lines,
                points: points
            };
            serialized.uuid = this.#signatureUUID;
            serialized.isCopy = true;
        } else serialized.lines = lines;
        if (this.#description) serialized.accessibilityData = {
            type: "Figure",
            alt: this.#description
        };
        return serialized;
    }
    static deserializeDraw(pageX, pageY, pageWidth, pageHeight, innerMargin, data) {
        if (data.areContours) return $9ef033443a74bee6$var$ContourDrawOutline.deserialize(pageX, pageY, pageWidth, pageHeight, innerMargin, data);
        return $9ef033443a74bee6$var$InkDrawOutline.deserialize(pageX, pageY, pageWidth, pageHeight, innerMargin, data);
    }
    static async deserialize(data, parent, uiManager) {
        const editor = await super.deserialize(data, parent, uiManager);
        editor.#isExtracted = data.areContours;
        editor.description = data.accessibilityData?.alt || "";
        editor.#signatureUUID = data.uuid;
        return editor;
    }
}
class $9ef033443a74bee6$var$StampEditor extends $9ef033443a74bee6$var$AnnotationEditor {
    #bitmap = null;
    #bitmapId = null;
    #bitmapPromise = null;
    #bitmapUrl = null;
    #bitmapFile = null;
    #bitmapFileName = "";
    #canvas = null;
    #missingCanvas = false;
    #resizeTimeoutId = null;
    #isSvg = false;
    #hasBeenAddedInUndoStack = false;
    static _type = "stamp";
    static _editorType = $9ef033443a74bee6$export$72ea3bfdd9a725bf.STAMP;
    constructor(params){
        super({
            ...params,
            name: "stampEditor"
        });
        this.#bitmapUrl = params.bitmapUrl;
        this.#bitmapFile = params.bitmapFile;
        this.defaultL10nId = "pdfjs-editor-stamp-editor";
    }
    static initialize(l10n, uiManager) {
        $9ef033443a74bee6$var$AnnotationEditor.initialize(l10n, uiManager);
    }
    static isHandlingMimeForPasting(mime) {
        return $9ef033443a74bee6$export$3234c88e9de64a88.includes(mime);
    }
    static paste(item, parent) {
        parent.pasteEditor({
            mode: $9ef033443a74bee6$export$72ea3bfdd9a725bf.STAMP
        }, {
            bitmapFile: item.getAsFile()
        });
    }
    altTextFinish() {
        if (this._uiManager.useNewAltTextFlow) this.div.hidden = false;
        super.altTextFinish();
    }
    get telemetryFinalData() {
        return {
            type: "stamp",
            hasAltText: !!this.altTextData?.altText
        };
    }
    static computeTelemetryFinalData(data) {
        const hasAltTextStats = data.get("hasAltText");
        return {
            hasAltText: hasAltTextStats.get(true) ?? 0,
            hasNoAltText: hasAltTextStats.get(false) ?? 0
        };
    }
    #getBitmapFetched(data, fromId = false) {
        if (!data) {
            this.remove();
            return;
        }
        this.#bitmap = data.bitmap;
        if (!fromId) {
            this.#bitmapId = data.id;
            this.#isSvg = data.isSvg;
        }
        if (data.file) this.#bitmapFileName = data.file.name;
        this.#createCanvas();
    }
    #getBitmapDone() {
        this.#bitmapPromise = null;
        this._uiManager.enableWaiting(false);
        if (!this.#canvas) return;
        if (this._uiManager.useNewAltTextWhenAddingImage && this._uiManager.useNewAltTextFlow && this.#bitmap) {
            this.addEditToolbar().then(()=>{
                this._editToolbar.hide();
                this._uiManager.editAltText(this, true);
            });
            return;
        }
        if (!this._uiManager.useNewAltTextWhenAddingImage && this._uiManager.useNewAltTextFlow && this.#bitmap) {
            this._reportTelemetry({
                action: "pdfjs.image.image_added",
                data: {
                    alt_text_modal: false,
                    alt_text_type: "empty"
                }
            });
            try {
                this.mlGuessAltText();
            } catch  {}
        }
        this.div.focus();
    }
    async mlGuessAltText(imageData = null, updateAltTextData = true) {
        if (this.hasAltTextData()) return null;
        const { mlManager: mlManager } = this._uiManager;
        if (!mlManager) throw new Error("No ML.");
        if (!await mlManager.isEnabledFor("altText")) throw new Error("ML isn't enabled for alt text.");
        const { data: data, width: width, height: height } = imageData || this.copyCanvas(null, null, true).imageData;
        const response = await mlManager.guess({
            name: "altText",
            request: {
                data: data,
                width: width,
                height: height,
                channels: data.length / (width * height)
            }
        });
        if (!response) throw new Error("No response from the AI service.");
        if (response.error) throw new Error("Error from the AI service.");
        if (response.cancel) return null;
        if (!response.output) throw new Error("No valid response from the AI service.");
        const altText = response.output;
        await this.setGuessedAltText(altText);
        if (updateAltTextData && !this.hasAltTextData()) this.altTextData = {
            alt: altText,
            decorative: false
        };
        return altText;
    }
    #getBitmap() {
        if (this.#bitmapId) {
            this._uiManager.enableWaiting(true);
            this._uiManager.imageManager.getFromId(this.#bitmapId).then((data)=>this.#getBitmapFetched(data, true)).finally(()=>this.#getBitmapDone());
            return;
        }
        if (this.#bitmapUrl) {
            const url = this.#bitmapUrl;
            this.#bitmapUrl = null;
            this._uiManager.enableWaiting(true);
            this.#bitmapPromise = this._uiManager.imageManager.getFromUrl(url).then((data)=>this.#getBitmapFetched(data)).finally(()=>this.#getBitmapDone());
            return;
        }
        if (this.#bitmapFile) {
            const file = this.#bitmapFile;
            this.#bitmapFile = null;
            this._uiManager.enableWaiting(true);
            this.#bitmapPromise = this._uiManager.imageManager.getFromFile(file).then((data)=>this.#getBitmapFetched(data)).finally(()=>this.#getBitmapDone());
            return;
        }
        const input = document.createElement("input");
        input.type = "file";
        input.accept = $9ef033443a74bee6$export$3234c88e9de64a88.join(",");
        const signal = this._uiManager._signal;
        this.#bitmapPromise = new Promise((resolve)=>{
            input.addEventListener("change", async ()=>{
                if (!input.files || input.files.length === 0) this.remove();
                else {
                    this._uiManager.enableWaiting(true);
                    const data = await this._uiManager.imageManager.getFromFile(input.files[0]);
                    this._reportTelemetry({
                        action: "pdfjs.image.image_selected",
                        data: {
                            alt_text_modal: this._uiManager.useNewAltTextFlow
                        }
                    });
                    this.#getBitmapFetched(data);
                }
                resolve();
            }, {
                signal: signal
            });
            input.addEventListener("cancel", ()=>{
                this.remove();
                resolve();
            }, {
                signal: signal
            });
        }).finally(()=>this.#getBitmapDone());
        input.click();
    }
    remove() {
        if (this.#bitmapId) {
            this.#bitmap = null;
            this._uiManager.imageManager.deleteId(this.#bitmapId);
            this.#canvas?.remove();
            this.#canvas = null;
            if (this.#resizeTimeoutId) {
                clearTimeout(this.#resizeTimeoutId);
                this.#resizeTimeoutId = null;
            }
        }
        super.remove();
    }
    rebuild() {
        if (!this.parent) {
            if (this.#bitmapId) this.#getBitmap();
            return;
        }
        super.rebuild();
        if (this.div === null) return;
        if (this.#bitmapId && this.#canvas === null) this.#getBitmap();
        if (!this.isAttachedToDOM) this.parent.add(this);
    }
    onceAdded(focus) {
        this._isDraggable = true;
        if (focus) this.div.focus();
    }
    isEmpty() {
        return !(this.#bitmapPromise || this.#bitmap || this.#bitmapUrl || this.#bitmapFile || this.#bitmapId || this.#missingCanvas);
    }
    get toolbarButtons() {
        return [
            [
                "altText",
                this.createAltText()
            ]
        ];
    }
    get isResizable() {
        return true;
    }
    render() {
        if (this.div) return this.div;
        let baseX, baseY;
        if (this._isCopy) {
            baseX = this.x;
            baseY = this.y;
        }
        super.render();
        this.div.hidden = true;
        this.createAltText();
        if (!this.#missingCanvas) {
            if (this.#bitmap) this.#createCanvas();
            else this.#getBitmap();
        }
        if (this._isCopy) this._moveAfterPaste(baseX, baseY);
        this._uiManager.addShouldRescale(this);
        return this.div;
    }
    setCanvas(annotationElementId, canvas) {
        const { id: bitmapId, bitmap: bitmap } = this._uiManager.imageManager.getFromCanvas(annotationElementId, canvas);
        canvas.remove();
        if (bitmapId && this._uiManager.imageManager.isValidId(bitmapId)) {
            this.#bitmapId = bitmapId;
            if (bitmap) this.#bitmap = bitmap;
            this.#missingCanvas = false;
            this.#createCanvas();
        }
    }
    _onResized() {
        this.onScaleChanging();
    }
    onScaleChanging() {
        if (!this.parent) return;
        if (this.#resizeTimeoutId !== null) clearTimeout(this.#resizeTimeoutId);
        const TIME_TO_WAIT = 200;
        this.#resizeTimeoutId = setTimeout(()=>{
            this.#resizeTimeoutId = null;
            this.#drawBitmap();
        }, TIME_TO_WAIT);
    }
    #createCanvas() {
        const { div: div } = this;
        let { width: width, height: height } = this.#bitmap;
        const [pageWidth, pageHeight] = this.pageDimensions;
        const MAX_RATIO = 0.75;
        if (this.width) {
            width = this.width * pageWidth;
            height = this.height * pageHeight;
        } else if (width > MAX_RATIO * pageWidth || height > MAX_RATIO * pageHeight) {
            const factor = Math.min(MAX_RATIO * pageWidth / width, MAX_RATIO * pageHeight / height);
            width *= factor;
            height *= factor;
        }
        this._uiManager.enableWaiting(false);
        const canvas = this.#canvas = document.createElement("canvas");
        canvas.setAttribute("role", "img");
        this.addContainer(canvas);
        this.width = width / pageWidth;
        this.height = height / pageHeight;
        this.setDims();
        if (this._initialOptions?.isCentered) this.center();
        else this.fixAndSetPosition();
        this._initialOptions = null;
        if (!this._uiManager.useNewAltTextWhenAddingImage || !this._uiManager.useNewAltTextFlow || this.annotationElementId) div.hidden = false;
        this.#drawBitmap();
        if (!this.#hasBeenAddedInUndoStack) {
            this.parent.addUndoableEditor(this);
            this.#hasBeenAddedInUndoStack = true;
        }
        this._reportTelemetry({
            action: "inserted_image"
        });
        if (this.#bitmapFileName) this.div.setAttribute("aria-description", this.#bitmapFileName);
        if (!this.annotationElementId) this._uiManager.a11yAlert("pdfjs-editor-stamp-added-alert");
    }
    copyCanvas(maxDataDimension, maxPreviewDimension, createImageData = false) {
        if (!maxDataDimension) maxDataDimension = 224;
        const { width: bitmapWidth, height: bitmapHeight } = this.#bitmap;
        const outputScale = new $9ef033443a74bee6$export$f16a99f63bccd50b();
        let bitmap = this.#bitmap;
        let width = bitmapWidth, height = bitmapHeight;
        let canvas = null;
        if (maxPreviewDimension) {
            if (bitmapWidth > maxPreviewDimension || bitmapHeight > maxPreviewDimension) {
                const ratio = Math.min(maxPreviewDimension / bitmapWidth, maxPreviewDimension / bitmapHeight);
                width = Math.floor(bitmapWidth * ratio);
                height = Math.floor(bitmapHeight * ratio);
            }
            canvas = document.createElement("canvas");
            const scaledWidth = canvas.width = Math.ceil(width * outputScale.sx);
            const scaledHeight = canvas.height = Math.ceil(height * outputScale.sy);
            if (!this.#isSvg) bitmap = this.#scaleBitmap(scaledWidth, scaledHeight);
            const ctx = canvas.getContext("2d");
            ctx.filter = this._uiManager.hcmFilter;
            let white = "white", black = "#cfcfd8";
            if (this._uiManager.hcmFilter !== "none") black = "black";
            else if ($9ef033443a74bee6$var$ColorScheme.isDarkMode) {
                white = "#8f8f9d";
                black = "#42414d";
            }
            const boxDim = 15;
            const boxDimWidth = boxDim * outputScale.sx;
            const boxDimHeight = boxDim * outputScale.sy;
            const pattern = new OffscreenCanvas(boxDimWidth * 2, boxDimHeight * 2);
            const patternCtx = pattern.getContext("2d");
            patternCtx.fillStyle = white;
            patternCtx.fillRect(0, 0, boxDimWidth * 2, boxDimHeight * 2);
            patternCtx.fillStyle = black;
            patternCtx.fillRect(0, 0, boxDimWidth, boxDimHeight);
            patternCtx.fillRect(boxDimWidth, boxDimHeight, boxDimWidth, boxDimHeight);
            ctx.fillStyle = ctx.createPattern(pattern, "repeat");
            ctx.fillRect(0, 0, scaledWidth, scaledHeight);
            ctx.drawImage(bitmap, 0, 0, bitmap.width, bitmap.height, 0, 0, scaledWidth, scaledHeight);
        }
        let imageData = null;
        if (createImageData) {
            let dataWidth, dataHeight;
            if (outputScale.symmetric && bitmap.width < maxDataDimension && bitmap.height < maxDataDimension) {
                dataWidth = bitmap.width;
                dataHeight = bitmap.height;
            } else {
                bitmap = this.#bitmap;
                if (bitmapWidth > maxDataDimension || bitmapHeight > maxDataDimension) {
                    const ratio = Math.min(maxDataDimension / bitmapWidth, maxDataDimension / bitmapHeight);
                    dataWidth = Math.floor(bitmapWidth * ratio);
                    dataHeight = Math.floor(bitmapHeight * ratio);
                    if (!this.#isSvg) bitmap = this.#scaleBitmap(dataWidth, dataHeight);
                }
            }
            const offscreen = new OffscreenCanvas(dataWidth, dataHeight);
            const offscreenCtx = offscreen.getContext("2d", {
                willReadFrequently: true
            });
            offscreenCtx.drawImage(bitmap, 0, 0, bitmap.width, bitmap.height, 0, 0, dataWidth, dataHeight);
            imageData = {
                width: dataWidth,
                height: dataHeight,
                data: offscreenCtx.getImageData(0, 0, dataWidth, dataHeight).data
            };
        }
        return {
            canvas: canvas,
            width: width,
            height: height,
            imageData: imageData
        };
    }
    #scaleBitmap(width, height) {
        const { width: bitmapWidth, height: bitmapHeight } = this.#bitmap;
        let newWidth = bitmapWidth;
        let newHeight = bitmapHeight;
        let bitmap = this.#bitmap;
        while(newWidth > 2 * width || newHeight > 2 * height){
            const prevWidth = newWidth;
            const prevHeight = newHeight;
            if (newWidth > 2 * width) newWidth = newWidth >= 16384 ? Math.floor(newWidth / 2) - 1 : Math.ceil(newWidth / 2);
            if (newHeight > 2 * height) newHeight = newHeight >= 16384 ? Math.floor(newHeight / 2) - 1 : Math.ceil(newHeight / 2);
            const offscreen = new OffscreenCanvas(newWidth, newHeight);
            const ctx = offscreen.getContext("2d");
            ctx.drawImage(bitmap, 0, 0, prevWidth, prevHeight, 0, 0, newWidth, newHeight);
            bitmap = offscreen.transferToImageBitmap();
        }
        return bitmap;
    }
    #drawBitmap() {
        const [parentWidth, parentHeight] = this.parentDimensions;
        const { width: width, height: height } = this;
        const outputScale = new $9ef033443a74bee6$export$f16a99f63bccd50b();
        const scaledWidth = Math.ceil(width * parentWidth * outputScale.sx);
        const scaledHeight = Math.ceil(height * parentHeight * outputScale.sy);
        const canvas = this.#canvas;
        if (!canvas || canvas.width === scaledWidth && canvas.height === scaledHeight) return;
        canvas.width = scaledWidth;
        canvas.height = scaledHeight;
        const bitmap = this.#isSvg ? this.#bitmap : this.#scaleBitmap(scaledWidth, scaledHeight);
        const ctx = canvas.getContext("2d");
        ctx.filter = this._uiManager.hcmFilter;
        ctx.drawImage(bitmap, 0, 0, bitmap.width, bitmap.height, 0, 0, scaledWidth, scaledHeight);
    }
    #serializeBitmap(toUrl) {
        if (toUrl) {
            if (this.#isSvg) {
                const url = this._uiManager.imageManager.getSvgUrl(this.#bitmapId);
                if (url) return url;
            }
            const canvas = document.createElement("canvas");
            ({ width: canvas.width, height: canvas.height } = this.#bitmap);
            const ctx = canvas.getContext("2d");
            ctx.drawImage(this.#bitmap, 0, 0);
            return canvas.toDataURL();
        }
        if (this.#isSvg) {
            const [pageWidth, pageHeight] = this.pageDimensions;
            const width = Math.round(this.width * pageWidth * $9ef033443a74bee6$export$6ef3b6b69e65342c.PDF_TO_CSS_UNITS);
            const height = Math.round(this.height * pageHeight * $9ef033443a74bee6$export$6ef3b6b69e65342c.PDF_TO_CSS_UNITS);
            const offscreen = new OffscreenCanvas(width, height);
            const ctx = offscreen.getContext("2d");
            ctx.drawImage(this.#bitmap, 0, 0, this.#bitmap.width, this.#bitmap.height, 0, 0, width, height);
            return offscreen.transferToImageBitmap();
        }
        return structuredClone(this.#bitmap);
    }
    static async deserialize(data, parent, uiManager) {
        let initialData = null;
        let missingCanvas = false;
        if (data instanceof $9ef033443a74bee6$var$StampAnnotationElement) {
            const { data: { rect: rect, rotation: rotation, id: id, structParent: structParent, popupRef: popupRef, richText: richText, contentsObj: contentsObj, creationDate: creationDate, modificationDate: modificationDate }, container: container, parent: { page: { pageNumber: pageNumber } }, canvas: canvas } = data;
            let bitmapId, bitmap;
            if (canvas) {
                delete data.canvas;
                ({ id: bitmapId, bitmap: bitmap } = uiManager.imageManager.getFromCanvas(container.id, canvas));
                canvas.remove();
            } else {
                missingCanvas = true;
                data._hasNoCanvas = true;
            }
            const altText = (await parent._structTree.getAriaAttributes(`${$9ef033443a74bee6$var$AnnotationPrefix}${id}`))?.get("aria-label") || "";
            initialData = data = {
                annotationType: $9ef033443a74bee6$export$72ea3bfdd9a725bf.STAMP,
                bitmapId: bitmapId,
                bitmap: bitmap,
                pageIndex: pageNumber - 1,
                rect: rect.slice(0),
                rotation: rotation,
                annotationElementId: id,
                id: id,
                deleted: false,
                accessibilityData: {
                    decorative: false,
                    altText: altText
                },
                isSvg: false,
                structParent: structParent,
                popupRef: popupRef,
                richText: richText,
                comment: contentsObj?.str || null,
                creationDate: creationDate,
                modificationDate: modificationDate
            };
        }
        const editor = await super.deserialize(data, parent, uiManager);
        const { rect: rect, bitmap: bitmap, bitmapUrl: bitmapUrl, bitmapId: bitmapId, isSvg: isSvg, accessibilityData: accessibilityData } = data;
        if (missingCanvas) {
            uiManager.addMissingCanvas(data.id, editor);
            editor.#missingCanvas = true;
        } else if (bitmapId && uiManager.imageManager.isValidId(bitmapId)) {
            editor.#bitmapId = bitmapId;
            if (bitmap) editor.#bitmap = bitmap;
        } else editor.#bitmapUrl = bitmapUrl;
        editor.#isSvg = isSvg;
        const [parentWidth, parentHeight] = editor.pageDimensions;
        editor.width = (rect[2] - rect[0]) / parentWidth;
        editor.height = (rect[3] - rect[1]) / parentHeight;
        if (accessibilityData) editor.altTextData = accessibilityData;
        editor._initialData = initialData;
        if (data.comment) editor.setCommentData(data);
        editor.#hasBeenAddedInUndoStack = !!initialData;
        return editor;
    }
    serialize(isForCopying = false, context = null) {
        if (this.isEmpty()) return null;
        if (this.deleted) return this.serializeDeleted();
        const serialized = Object.assign(super.serialize(isForCopying), {
            bitmapId: this.#bitmapId,
            isSvg: this.#isSvg
        });
        this.addComment(serialized);
        if (isForCopying) {
            serialized.bitmapUrl = this.#serializeBitmap(true);
            serialized.accessibilityData = this.serializeAltText(true);
            serialized.isCopy = true;
            return serialized;
        }
        const { decorative: decorative, altText: altText } = this.serializeAltText(false);
        if (!decorative && altText) serialized.accessibilityData = {
            type: "Figure",
            alt: altText
        };
        if (this.annotationElementId) {
            const changes = this.#hasElementChanged(serialized);
            if (changes.isSame) return null;
            if (changes.isSameAltText) delete serialized.accessibilityData;
            else serialized.accessibilityData.structParent = this._initialData.structParent ?? -1;
            serialized.id = this.annotationElementId;
            delete serialized.bitmapId;
            return serialized;
        }
        if (context === null) return serialized;
        context.stamps ||= new Map();
        const area = this.#isSvg ? (serialized.rect[2] - serialized.rect[0]) * (serialized.rect[3] - serialized.rect[1]) : null;
        if (!context.stamps.has(this.#bitmapId)) {
            context.stamps.set(this.#bitmapId, {
                area: area,
                serialized: serialized
            });
            serialized.bitmap = this.#serializeBitmap(false);
        } else if (this.#isSvg) {
            const prevData = context.stamps.get(this.#bitmapId);
            if (area > prevData.area) {
                prevData.area = area;
                prevData.serialized.bitmap.close();
                prevData.serialized.bitmap = this.#serializeBitmap(false);
            }
        }
        return serialized;
    }
    #hasElementChanged(serialized) {
        const { pageIndex: pageIndex, accessibilityData: { altText: altText } } = this._initialData;
        const isSamePageIndex = serialized.pageIndex === pageIndex;
        const isSameAltText = (serialized.accessibilityData?.alt || "") === altText;
        return {
            isSame: !this.hasEditedComment && !this._hasBeenMoved && !this._hasBeenResized && isSamePageIndex && isSameAltText,
            isSameAltText: isSameAltText
        };
    }
    renderAnnotationElement(annotation) {
        if (this.deleted) {
            annotation.hide();
            return null;
        }
        annotation.updateEdited({
            rect: this.getPDFRect(),
            popup: this.comment
        });
        return null;
    }
}
class $9ef033443a74bee6$export$47948c9fe1adbf1b {
    #accessibilityManager;
    #allowClick = false;
    #annotationLayer = null;
    #clickAC = null;
    #editorFocusTimeoutId = null;
    #editors = new Map();
    #hadPointerDown = false;
    #isDisabling = false;
    #isEnabling = false;
    #drawingAC = null;
    #focusedElement = null;
    #textLayer = null;
    #textSelectionAC = null;
    #textLayerDblClickAC = null;
    #lastPointerDownTimestamp = -1;
    #uiManager;
    static _initialized = false;
    static #editorTypes = new Map([
        $9ef033443a74bee6$var$FreeTextEditor,
        $9ef033443a74bee6$var$InkEditor,
        $9ef033443a74bee6$var$StampEditor,
        $9ef033443a74bee6$var$HighlightEditor,
        $9ef033443a74bee6$var$SignatureEditor
    ].map((type)=>[
            type._editorType,
            type
        ]));
    constructor({ uiManager: uiManager, pageIndex: pageIndex, div: div, structTreeLayer: structTreeLayer, accessibilityManager: accessibilityManager, annotationLayer: annotationLayer, drawLayer: drawLayer, textLayer: textLayer, viewport: viewport, l10n: l10n }){
        const editorTypes = [
            ...$9ef033443a74bee6$export$47948c9fe1adbf1b.#editorTypes.values()
        ];
        if (!$9ef033443a74bee6$export$47948c9fe1adbf1b._initialized) {
            $9ef033443a74bee6$export$47948c9fe1adbf1b._initialized = true;
            for (const editorType of editorTypes)editorType.initialize(l10n, uiManager);
        }
        uiManager.registerEditorTypes(editorTypes);
        this.#uiManager = uiManager;
        this.pageIndex = pageIndex;
        this.div = div;
        this.#accessibilityManager = accessibilityManager;
        this.#annotationLayer = annotationLayer;
        this.viewport = viewport;
        this.#textLayer = textLayer;
        this.drawLayer = drawLayer;
        this._structTree = structTreeLayer;
        this.#uiManager.addLayer(this);
    }
    get isEmpty() {
        return this.#editors.size === 0;
    }
    get isInvisible() {
        return this.isEmpty && this.#uiManager.getMode() === $9ef033443a74bee6$export$72ea3bfdd9a725bf.NONE;
    }
    updateToolbar(options) {
        this.#uiManager.updateToolbar(options);
    }
    updateMode(mode = this.#uiManager.getMode()) {
        this.#cleanup();
        switch(mode){
            case $9ef033443a74bee6$export$72ea3bfdd9a725bf.NONE:
                this.div.classList.toggle("nonEditing", true);
                this.disableTextSelection();
                this.togglePointerEvents(false);
                this.toggleAnnotationLayerPointerEvents(true);
                this.disableClick();
                return;
            case $9ef033443a74bee6$export$72ea3bfdd9a725bf.INK:
                this.disableTextSelection();
                this.togglePointerEvents(true);
                this.enableClick();
                break;
            case $9ef033443a74bee6$export$72ea3bfdd9a725bf.HIGHLIGHT:
                this.enableTextSelection();
                this.togglePointerEvents(false);
                this.disableClick();
                break;
            default:
                this.disableTextSelection();
                this.togglePointerEvents(true);
                this.enableClick();
        }
        this.toggleAnnotationLayerPointerEvents(false);
        const { classList: classList } = this.div;
        classList.toggle("nonEditing", false);
        if (mode === $9ef033443a74bee6$export$72ea3bfdd9a725bf.POPUP) classList.toggle("commentEditing", true);
        else {
            classList.toggle("commentEditing", false);
            for (const editorType of $9ef033443a74bee6$export$47948c9fe1adbf1b.#editorTypes.values())classList.toggle(`${editorType._type}Editing`, mode === editorType._editorType);
        }
        this.div.hidden = false;
    }
    hasTextLayer(textLayer) {
        return textLayer === this.#textLayer?.div;
    }
    setEditingState(isEditing) {
        this.#uiManager.setEditingState(isEditing);
    }
    addCommands(params) {
        this.#uiManager.addCommands(params);
    }
    cleanUndoStack(type) {
        this.#uiManager.cleanUndoStack(type);
    }
    toggleDrawing(enabled = false) {
        this.div.classList.toggle("drawing", !enabled);
    }
    togglePointerEvents(enabled = false) {
        this.div.classList.toggle("disabled", !enabled);
    }
    toggleAnnotationLayerPointerEvents(enabled = false) {
        this.#annotationLayer?.div.classList.toggle("disabled", !enabled);
    }
    get #allEditorsIterator() {
        return this.#editors.size !== 0 ? this.#editors.values() : this.#uiManager.getEditors(this.pageIndex);
    }
    async enable() {
        this.#isEnabling = true;
        this.div.tabIndex = 0;
        this.togglePointerEvents(true);
        this.div.classList.toggle("nonEditing", false);
        this.#textLayerDblClickAC?.abort();
        this.#textLayerDblClickAC = null;
        const annotationElementIds = new Set();
        for (const editor of this.#allEditorsIterator){
            editor.enableEditing();
            editor.show(true);
            if (editor.annotationElementId) {
                this.#uiManager.removeChangedExistingAnnotation(editor);
                annotationElementIds.add(editor.annotationElementId);
            }
        }
        const annotationLayer = this.#annotationLayer;
        if (annotationLayer) for (const editable of annotationLayer.getEditableAnnotations()){
            editable.hide();
            if (this.#uiManager.isDeletedAnnotationElement(editable.data.id)) continue;
            if (annotationElementIds.has(editable.data.id)) continue;
            const editor = await this.deserialize(editable);
            if (!editor) continue;
            this.addOrRebuild(editor);
            editor.enableEditing();
        }
        this.#isEnabling = false;
        this.#uiManager._eventBus.dispatch("editorsrendered", {
            source: this,
            pageNumber: this.pageIndex + 1
        });
    }
    disable() {
        this.#isDisabling = true;
        this.div.tabIndex = -1;
        this.togglePointerEvents(false);
        this.div.classList.toggle("nonEditing", true);
        if (this.#textLayer && !this.#textLayerDblClickAC) {
            this.#textLayerDblClickAC = new AbortController();
            const signal = this.#uiManager.combinedSignal(this.#textLayerDblClickAC);
            this.#textLayer.div.addEventListener("pointerdown", (e)=>{
                const DBL_CLICK_THRESHOLD = 500;
                const { clientX: clientX, clientY: clientY, timeStamp: timeStamp } = e;
                const lastPointerDownTimestamp = this.#lastPointerDownTimestamp;
                if (timeStamp - lastPointerDownTimestamp > DBL_CLICK_THRESHOLD) {
                    this.#lastPointerDownTimestamp = timeStamp;
                    return;
                }
                this.#lastPointerDownTimestamp = -1;
                const { classList: classList } = this.div;
                classList.toggle("getElements", true);
                const elements = document.elementsFromPoint(clientX, clientY);
                classList.toggle("getElements", false);
                if (!this.div.contains(elements[0])) return;
                let id;
                const regex = new RegExp(`^${$9ef033443a74bee6$var$AnnotationEditorPrefix}[0-9]+$`);
                for (const element of elements)if (regex.test(element.id)) {
                    id = element.id;
                    break;
                }
                if (!id) return;
                const editor = this.#editors.get(id);
                if (editor?.annotationElementId === null) {
                    e.stopPropagation();
                    e.preventDefault();
                    editor.dblclick(e);
                }
            }, {
                signal: signal,
                capture: true
            });
        }
        const annotationLayer = this.#annotationLayer;
        if (annotationLayer) {
            const changedAnnotations = new Map();
            const resetAnnotations = new Map();
            for (const editor of this.#allEditorsIterator){
                editor.disableEditing();
                if (!editor.annotationElementId) {
                    editor.updateFakeAnnotationElement(annotationLayer);
                    continue;
                }
                if (editor.serialize() !== null) {
                    changedAnnotations.set(editor.annotationElementId, editor);
                    continue;
                } else resetAnnotations.set(editor.annotationElementId, editor);
                this.getEditableAnnotation(editor.annotationElementId)?.show();
                editor.remove();
            }
            const editables = annotationLayer.getEditableAnnotations();
            for (const editable of editables){
                const { id: id } = editable.data;
                if (this.#uiManager.isDeletedAnnotationElement(id)) {
                    editable.updateEdited({
                        deleted: true
                    });
                    continue;
                }
                let editor = resetAnnotations.get(id);
                if (editor) {
                    editor.resetAnnotationElement(editable);
                    editor.show(false);
                    editable.show();
                    continue;
                }
                editor = changedAnnotations.get(id);
                if (editor) {
                    this.#uiManager.addChangedExistingAnnotation(editor);
                    if (editor.renderAnnotationElement(editable)) editor.show(false);
                }
                editable.show();
            }
        }
        this.#cleanup();
        if (this.isEmpty) this.div.hidden = true;
        const { classList: classList } = this.div;
        for (const editorType of $9ef033443a74bee6$export$47948c9fe1adbf1b.#editorTypes.values())classList.remove(`${editorType._type}Editing`);
        this.disableTextSelection();
        this.toggleAnnotationLayerPointerEvents(true);
        this.#isDisabling = false;
    }
    getEditableAnnotation(id) {
        return this.#annotationLayer?.getEditableAnnotation(id) || null;
    }
    setActiveEditor(editor) {
        const currentActive = this.#uiManager.getActive();
        if (currentActive === editor) return;
        this.#uiManager.setActiveEditor(editor);
    }
    enableTextSelection() {
        this.div.tabIndex = -1;
        if (this.#textLayer?.div && !this.#textSelectionAC) {
            this.#textSelectionAC = new AbortController();
            const signal = this.#uiManager.combinedSignal(this.#textSelectionAC);
            this.#textLayer.div.addEventListener("pointerdown", this.#textLayerPointerDown.bind(this), {
                signal: signal
            });
            this.#textLayer.div.classList.add("highlighting");
        }
    }
    disableTextSelection() {
        this.div.tabIndex = 0;
        if (this.#textLayer?.div && this.#textSelectionAC) {
            this.#textSelectionAC.abort();
            this.#textSelectionAC = null;
            this.#textLayer.div.classList.remove("highlighting");
        }
    }
    #textLayerPointerDown(event) {
        this.#uiManager.unselectAll();
        const { target: target } = event;
        if (target === this.#textLayer.div || (target.getAttribute("role") === "img" || target.classList.contains("endOfContent")) && this.#textLayer.div.contains(target)) {
            const { isMac: isMac } = $9ef033443a74bee6$export$5fb8891d35c36978.platform;
            if (event.button !== 0 || event.ctrlKey && isMac) return;
            this.#uiManager.showAllEditors("highlight", true, true);
            this.#textLayer.div.classList.add("free");
            this.toggleDrawing();
            $9ef033443a74bee6$var$HighlightEditor.startHighlighting(this, this.#uiManager.direction === "ltr", {
                target: this.#textLayer.div,
                x: event.x,
                y: event.y
            });
            this.#textLayer.div.addEventListener("pointerup", ()=>{
                this.#textLayer.div.classList.remove("free");
                this.toggleDrawing(true);
            }, {
                once: true,
                signal: this.#uiManager._signal
            });
            event.preventDefault();
        }
    }
    enableClick() {
        if (this.#clickAC) return;
        this.#clickAC = new AbortController();
        const signal = this.#uiManager.combinedSignal(this.#clickAC);
        this.div.addEventListener("pointerdown", this.pointerdown.bind(this), {
            signal: signal
        });
        const pointerup = this.pointerup.bind(this);
        this.div.addEventListener("pointerup", pointerup, {
            signal: signal
        });
        this.div.addEventListener("pointercancel", pointerup, {
            signal: signal
        });
    }
    disableClick() {
        this.#clickAC?.abort();
        this.#clickAC = null;
    }
    attach(editor) {
        this.#editors.set(editor.id, editor);
        const { annotationElementId: annotationElementId } = editor;
        if (annotationElementId && this.#uiManager.isDeletedAnnotationElement(annotationElementId)) this.#uiManager.removeDeletedAnnotationElement(editor);
    }
    detach(editor) {
        this.#editors.delete(editor.id);
        this.#accessibilityManager?.removePointerInTextLayer(editor.contentDiv);
        if (!this.#isDisabling && editor.annotationElementId) this.#uiManager.addDeletedAnnotationElement(editor);
    }
    remove(editor) {
        this.detach(editor);
        this.#uiManager.removeEditor(editor);
        editor.div.remove();
        editor.isAttachedToDOM = false;
    }
    changeParent(editor) {
        if (editor.parent === this) return;
        if (editor.parent && editor.annotationElementId) {
            this.#uiManager.addDeletedAnnotationElement(editor.annotationElementId);
            $9ef033443a74bee6$var$AnnotationEditor.deleteAnnotationElement(editor);
            editor.annotationElementId = null;
        }
        this.attach(editor);
        editor.parent?.detach(editor);
        editor.setParent(this);
        if (editor.div && editor.isAttachedToDOM) {
            editor.div.remove();
            this.div.append(editor.div);
        }
    }
    add(editor) {
        if (editor.parent === this && editor.isAttachedToDOM) return;
        this.changeParent(editor);
        this.#uiManager.addEditor(editor);
        this.attach(editor);
        if (!editor.isAttachedToDOM) {
            const div = editor.render();
            this.div.append(div);
            editor.isAttachedToDOM = true;
        }
        editor.fixAndSetPosition();
        editor.onceAdded(!this.#isEnabling);
        this.#uiManager.addToAnnotationStorage(editor);
        editor._reportTelemetry(editor.telemetryInitialData);
    }
    moveEditorInDOM(editor) {
        if (!editor.isAttachedToDOM) return;
        const { activeElement: activeElement } = document;
        if (editor.div.contains(activeElement) && !this.#editorFocusTimeoutId) {
            editor._focusEventsAllowed = false;
            this.#editorFocusTimeoutId = setTimeout(()=>{
                this.#editorFocusTimeoutId = null;
                if (!editor.div.contains(document.activeElement)) {
                    editor.div.addEventListener("focusin", ()=>{
                        editor._focusEventsAllowed = true;
                    }, {
                        once: true,
                        signal: this.#uiManager._signal
                    });
                    activeElement.focus();
                } else editor._focusEventsAllowed = true;
            }, 0);
        }
        editor._structTreeParentId = this.#accessibilityManager?.moveElementInDOM(this.div, editor.div, editor.contentDiv, true);
    }
    addOrRebuild(editor) {
        if (editor.needsToBeRebuilt()) {
            editor.parent ||= this;
            editor.rebuild();
            editor.show();
        } else this.add(editor);
    }
    addUndoableEditor(editor) {
        const cmd = ()=>editor._uiManager.rebuild(editor);
        const undo = ()=>{
            editor.remove();
        };
        this.addCommands({
            cmd: cmd,
            undo: undo,
            mustExec: false
        });
    }
    getEditorByUID(uid) {
        for (const editor of this.#editors.values()){
            if (editor.uid === uid) return editor;
        }
        return null;
    }
    getNextId() {
        return this.#uiManager.getId();
    }
    get #currentEditorType() {
        return $9ef033443a74bee6$export$47948c9fe1adbf1b.#editorTypes.get(this.#uiManager.getMode());
    }
    combinedSignal(ac) {
        return this.#uiManager.combinedSignal(ac);
    }
    #createNewEditor(params) {
        const editorType = this.#currentEditorType;
        return editorType ? new editorType.prototype.constructor(params) : null;
    }
    canCreateNewEmptyEditor() {
        return this.#currentEditorType?.canCreateNewEmptyEditor();
    }
    async pasteEditor(options, params) {
        this.updateToolbar(options);
        await this.#uiManager.updateMode(options.mode);
        const { offsetX: offsetX, offsetY: offsetY } = this.#getCenterPoint();
        const id = this.getNextId();
        const editor = this.#createNewEditor({
            parent: this,
            id: id,
            x: offsetX,
            y: offsetY,
            uiManager: this.#uiManager,
            isCentered: true,
            ...params
        });
        if (editor) this.add(editor);
    }
    async deserialize(data) {
        return await $9ef033443a74bee6$export$47948c9fe1adbf1b.#editorTypes.get(data.annotationType ?? data.annotationEditorType)?.deserialize(data, this, this.#uiManager) || null;
    }
    createAndAddNewEditor(event, isCentered, data = {}) {
        const id = this.getNextId();
        const editor = this.#createNewEditor({
            parent: this,
            id: id,
            x: event.offsetX,
            y: event.offsetY,
            uiManager: this.#uiManager,
            isCentered: isCentered,
            ...data
        });
        if (editor) this.add(editor);
        return editor;
    }
    get boundingClientRect() {
        return this.div.getBoundingClientRect();
    }
    #getCenterPoint() {
        const { x: x, y: y, width: width, height: height } = this.boundingClientRect;
        const tlX = Math.max(0, x);
        const tlY = Math.max(0, y);
        const brX = Math.min(window.innerWidth, x + width);
        const brY = Math.min(window.innerHeight, y + height);
        const centerX = (tlX + brX) / 2 - x;
        const centerY = (tlY + brY) / 2 - y;
        const [offsetX, offsetY] = this.viewport.rotation % 180 === 0 ? [
            centerX,
            centerY
        ] : [
            centerY,
            centerX
        ];
        return {
            offsetX: offsetX,
            offsetY: offsetY
        };
    }
    addNewEditor(data = {}) {
        this.createAndAddNewEditor(this.#getCenterPoint(), true, data);
    }
    setSelected(editor) {
        this.#uiManager.setSelected(editor);
    }
    toggleSelected(editor) {
        this.#uiManager.toggleSelected(editor);
    }
    unselect(editor) {
        this.#uiManager.unselect(editor);
    }
    pointerup(event) {
        const { isMac: isMac } = $9ef033443a74bee6$export$5fb8891d35c36978.platform;
        if (event.button !== 0 || event.ctrlKey && isMac) return;
        if (event.target !== this.div) return;
        if (!this.#hadPointerDown) return;
        this.#hadPointerDown = false;
        if (this.#currentEditorType?.isDrawer && this.#currentEditorType.supportMultipleDrawings) return;
        if (!this.#allowClick) {
            this.#allowClick = true;
            return;
        }
        const currentMode = this.#uiManager.getMode();
        if (currentMode === $9ef033443a74bee6$export$72ea3bfdd9a725bf.STAMP || currentMode === $9ef033443a74bee6$export$72ea3bfdd9a725bf.SIGNATURE) {
            this.#uiManager.unselectAll();
            return;
        }
        this.createAndAddNewEditor(event, false);
    }
    pointerdown(event) {
        if (this.#uiManager.getMode() === $9ef033443a74bee6$export$72ea3bfdd9a725bf.HIGHLIGHT) this.enableTextSelection();
        if (this.#hadPointerDown) {
            this.#hadPointerDown = false;
            return;
        }
        const { isMac: isMac } = $9ef033443a74bee6$export$5fb8891d35c36978.platform;
        if (event.button !== 0 || event.ctrlKey && isMac) return;
        if (event.target !== this.div) return;
        this.#hadPointerDown = true;
        if (this.#currentEditorType?.isDrawer) {
            this.startDrawingSession(event);
            return;
        }
        const editor = this.#uiManager.getActive();
        this.#allowClick = !editor || editor.isEmpty();
    }
    startDrawingSession(event) {
        this.div.focus({
            preventScroll: true
        });
        if (this.#drawingAC) {
            this.#currentEditorType.startDrawing(this, this.#uiManager, false, event);
            return;
        }
        this.#uiManager.setCurrentDrawingSession(this);
        this.#drawingAC = new AbortController();
        const signal = this.#uiManager.combinedSignal(this.#drawingAC);
        this.div.addEventListener("blur", ({ relatedTarget: relatedTarget })=>{
            if (relatedTarget && !this.div.contains(relatedTarget)) {
                this.#focusedElement = null;
                this.commitOrRemove();
            }
        }, {
            signal: signal
        });
        this.#currentEditorType.startDrawing(this, this.#uiManager, false, event);
    }
    pause(on) {
        if (on) {
            const { activeElement: activeElement } = document;
            if (this.div.contains(activeElement)) this.#focusedElement = activeElement;
            return;
        }
        if (this.#focusedElement) setTimeout(()=>{
            this.#focusedElement?.focus();
            this.#focusedElement = null;
        }, 0);
    }
    endDrawingSession(isAborted = false) {
        if (!this.#drawingAC) return null;
        this.#uiManager.setCurrentDrawingSession(null);
        this.#drawingAC.abort();
        this.#drawingAC = null;
        this.#focusedElement = null;
        return this.#currentEditorType.endDrawing(isAborted);
    }
    findNewParent(editor, x, y) {
        const layer = this.#uiManager.findParent(x, y);
        if (layer === null || layer === this) return false;
        layer.changeParent(editor);
        return true;
    }
    commitOrRemove() {
        if (this.#drawingAC) {
            this.endDrawingSession();
            return true;
        }
        return false;
    }
    onScaleChanging() {
        if (!this.#drawingAC) return;
        this.#currentEditorType.onScaleChangingWhenDrawing(this);
    }
    destroy() {
        this.commitOrRemove();
        if (this.#uiManager.getActive()?.parent === this) {
            this.#uiManager.commitOrRemove();
            this.#uiManager.setActiveEditor(null);
        }
        if (this.#editorFocusTimeoutId) {
            clearTimeout(this.#editorFocusTimeoutId);
            this.#editorFocusTimeoutId = null;
        }
        for (const editor of this.#editors.values()){
            this.#accessibilityManager?.removePointerInTextLayer(editor.contentDiv);
            editor.setParent(null);
            editor.isAttachedToDOM = false;
            editor.div.remove();
        }
        this.div = null;
        this.#editors.clear();
        this.#uiManager.removeLayer(this);
    }
    #cleanup() {
        for (const editor of this.#editors.values())if (editor.isEmpty()) editor.remove();
    }
    render({ viewport: viewport }) {
        this.viewport = viewport;
        $9ef033443a74bee6$export$af0a15a86e590226(this.div, viewport);
        for (const editor of this.#uiManager.getEditors(this.pageIndex)){
            this.add(editor);
            editor.rebuild();
        }
        this.updateMode();
    }
    update({ viewport: viewport }) {
        this.#uiManager.commitOrRemove();
        this.#cleanup();
        const oldRotation = this.viewport.rotation;
        const rotation = viewport.rotation;
        this.viewport = viewport;
        $9ef033443a74bee6$export$af0a15a86e590226(this.div, {
            rotation: rotation
        });
        if (oldRotation !== rotation) for (const editor of this.#editors.values())editor.rotate(rotation);
    }
    get pageDimensions() {
        const { pageWidth: pageWidth, pageHeight: pageHeight } = this.viewport.rawDims;
        return [
            pageWidth,
            pageHeight
        ];
    }
    get scale() {
        return this.#uiManager.viewParameters.realScale;
    }
}
class $9ef033443a74bee6$export$3eb4521511f02450 {
    #parent = null;
    #mapping = new Map();
    #toUpdate = new Map();
    static #id = 0;
    constructor({ pageIndex: pageIndex }){
        this.pageIndex = pageIndex;
    }
    setParent(parent) {
        if (!this.#parent) {
            this.#parent = parent;
            return;
        }
        if (this.#parent !== parent) {
            if (this.#mapping.size > 0) for (const root of this.#mapping.values()){
                root.remove();
                parent.append(root);
            }
            this.#parent = parent;
        }
    }
    static get _svgFactory() {
        return $9ef033443a74bee6$export$b8972b998723d602(this, "_svgFactory", new $9ef033443a74bee6$export$425e69f00724e63a());
    }
    static #setBox(element, [x, y, width, height]) {
        const { style: style } = element;
        style.top = `${100 * y}%`;
        style.left = `${100 * x}%`;
        style.width = `${100 * width}%`;
        style.height = `${100 * height}%`;
    }
    #createSVG() {
        const svg = $9ef033443a74bee6$export$3eb4521511f02450._svgFactory.create(1, 1, true);
        this.#parent.append(svg);
        svg.setAttribute("aria-hidden", true);
        return svg;
    }
    #createClipPath(defs, pathId) {
        const clipPath = $9ef033443a74bee6$export$3eb4521511f02450._svgFactory.createElement("clipPath");
        defs.append(clipPath);
        const clipPathId = `clip_${pathId}`;
        clipPath.setAttribute("id", clipPathId);
        clipPath.setAttribute("clipPathUnits", "objectBoundingBox");
        const clipPathUse = $9ef033443a74bee6$export$3eb4521511f02450._svgFactory.createElement("use");
        clipPath.append(clipPathUse);
        clipPathUse.setAttribute("href", `#${pathId}`);
        clipPathUse.classList.add("clip");
        return clipPathId;
    }
    #updateProperties(element, properties) {
        for (const [key, value] of Object.entries(properties))if (value === null) element.removeAttribute(key);
        else element.setAttribute(key, value);
    }
    draw(properties, isPathUpdatable = false, hasClip = false) {
        const id = $9ef033443a74bee6$export$3eb4521511f02450.#id++;
        const root = this.#createSVG();
        const defs = $9ef033443a74bee6$export$3eb4521511f02450._svgFactory.createElement("defs");
        root.append(defs);
        const path = $9ef033443a74bee6$export$3eb4521511f02450._svgFactory.createElement("path");
        defs.append(path);
        const pathId = `path_p${this.pageIndex}_${id}`;
        path.setAttribute("id", pathId);
        path.setAttribute("vector-effect", "non-scaling-stroke");
        if (isPathUpdatable) this.#toUpdate.set(id, path);
        const clipPathId = hasClip ? this.#createClipPath(defs, pathId) : null;
        const use = $9ef033443a74bee6$export$3eb4521511f02450._svgFactory.createElement("use");
        root.append(use);
        use.setAttribute("href", `#${pathId}`);
        this.updateProperties(root, properties);
        this.#mapping.set(id, root);
        return {
            id: id,
            clipPathId: `url(#${clipPathId})`
        };
    }
    drawOutline(properties, mustRemoveSelfIntersections) {
        const id = $9ef033443a74bee6$export$3eb4521511f02450.#id++;
        const root = this.#createSVG();
        const defs = $9ef033443a74bee6$export$3eb4521511f02450._svgFactory.createElement("defs");
        root.append(defs);
        const path = $9ef033443a74bee6$export$3eb4521511f02450._svgFactory.createElement("path");
        defs.append(path);
        const pathId = `path_p${this.pageIndex}_${id}`;
        path.setAttribute("id", pathId);
        path.setAttribute("vector-effect", "non-scaling-stroke");
        let maskId;
        if (mustRemoveSelfIntersections) {
            const mask = $9ef033443a74bee6$export$3eb4521511f02450._svgFactory.createElement("mask");
            defs.append(mask);
            maskId = `mask_p${this.pageIndex}_${id}`;
            mask.setAttribute("id", maskId);
            mask.setAttribute("maskUnits", "objectBoundingBox");
            const rect = $9ef033443a74bee6$export$3eb4521511f02450._svgFactory.createElement("rect");
            mask.append(rect);
            rect.setAttribute("width", "1");
            rect.setAttribute("height", "1");
            rect.setAttribute("fill", "white");
            const use = $9ef033443a74bee6$export$3eb4521511f02450._svgFactory.createElement("use");
            mask.append(use);
            use.setAttribute("href", `#${pathId}`);
            use.setAttribute("stroke", "none");
            use.setAttribute("fill", "black");
            use.setAttribute("fill-rule", "nonzero");
            use.classList.add("mask");
        }
        const use1 = $9ef033443a74bee6$export$3eb4521511f02450._svgFactory.createElement("use");
        root.append(use1);
        use1.setAttribute("href", `#${pathId}`);
        if (maskId) use1.setAttribute("mask", `url(#${maskId})`);
        const use2 = use1.cloneNode();
        root.append(use2);
        use1.classList.add("mainOutline");
        use2.classList.add("secondaryOutline");
        this.updateProperties(root, properties);
        this.#mapping.set(id, root);
        return id;
    }
    finalizeDraw(id, properties) {
        this.#toUpdate.delete(id);
        this.updateProperties(id, properties);
    }
    updateProperties(elementOrId, properties) {
        if (!properties) return;
        const { root: root, bbox: bbox, rootClass: rootClass, path: path } = properties;
        const element = typeof elementOrId === "number" ? this.#mapping.get(elementOrId) : elementOrId;
        if (!element) return;
        if (root) this.#updateProperties(element, root);
        if (bbox) $9ef033443a74bee6$export$3eb4521511f02450.#setBox(element, bbox);
        if (rootClass) {
            const { classList: classList } = element;
            for (const [className, value] of Object.entries(rootClass))classList.toggle(className, value);
        }
        if (path) {
            const defs = element.firstChild;
            const pathElement = defs.firstChild;
            this.#updateProperties(pathElement, path);
        }
    }
    updateParent(id, layer) {
        if (layer === this) return;
        const root = this.#mapping.get(id);
        if (!root) return;
        layer.#parent.append(root);
        this.#mapping.delete(id);
        layer.#mapping.set(id, root);
    }
    remove(id) {
        this.#toUpdate.delete(id);
        if (this.#parent === null) return;
        this.#mapping.get(id).remove();
        this.#mapping.delete(id);
    }
    destroy() {
        this.#parent = null;
        for (const root of this.#mapping.values())root.remove();
        this.#mapping.clear();
        this.#toUpdate.clear();
    }
}
globalThis._pdfjsTestingUtils = {
    HighlightOutliner: $9ef033443a74bee6$var$HighlightOutliner
};
globalThis.pdfjsLib = {
    AbortException: $9ef033443a74bee6$export$d0e978393d193d1a,
    AnnotationEditorLayer: $9ef033443a74bee6$export$47948c9fe1adbf1b,
    AnnotationEditorParamsType: $9ef033443a74bee6$export$cf3df2a6ecc26692,
    AnnotationEditorType: $9ef033443a74bee6$export$72ea3bfdd9a725bf,
    AnnotationEditorUIManager: $9ef033443a74bee6$export$26cb16552a82cf63,
    AnnotationLayer: $9ef033443a74bee6$export$3e7f45c326d9366c,
    AnnotationMode: $9ef033443a74bee6$export$5a7af0c07e33392e,
    AnnotationType: $9ef033443a74bee6$export$f50c3066a53a6f2c,
    applyOpacity: $9ef033443a74bee6$export$f8d1472813e87bf9,
    build: $9ef033443a74bee6$export$3f8fe6489e95757d,
    ColorPicker: $9ef033443a74bee6$export$9feb1bc2e5f1ccb3,
    createValidAbsoluteUrl: $9ef033443a74bee6$export$e076b47f5805ca0b,
    CSSConstants: $9ef033443a74bee6$export$cec677744f6a5015,
    DOMSVGFactory: $9ef033443a74bee6$export$425e69f00724e63a,
    DrawLayer: $9ef033443a74bee6$export$3eb4521511f02450,
    FeatureTest: $9ef033443a74bee6$export$5fb8891d35c36978,
    fetchData: $9ef033443a74bee6$export$8134c072fddab6a5,
    findContrastColor: $9ef033443a74bee6$export$7a96203b1fdebe8d,
    getDocument: $9ef033443a74bee6$export$f65ca476c09acec0,
    getFilenameFromUrl: $9ef033443a74bee6$export$b1c11df0696253ae,
    getPdfFilenameFromUrl: $9ef033443a74bee6$export$9de51790aa4bc73a,
    getRGB: $9ef033443a74bee6$export$2a2e9b507863ddda,
    getUuid: $9ef033443a74bee6$export$75f13a91ebdf8eb3,
    getXfaPageViewport: $9ef033443a74bee6$export$dd5d6edf3fc80aae,
    GlobalWorkerOptions: $9ef033443a74bee6$export$edf38ba293eb934,
    ImageKind: $9ef033443a74bee6$export$b890e9c15247e0b3,
    InvalidPDFException: $9ef033443a74bee6$export$e3d0f4ce5b91e9f1,
    isDataScheme: $9ef033443a74bee6$export$f67aae4532d8295b,
    isPdfFile: $9ef033443a74bee6$export$61b52d3570d24719,
    isValidExplicitDest: $9ef033443a74bee6$export$b5acece0a447dcdc,
    MathClamp: $9ef033443a74bee6$export$b8106b171181a554,
    noContextMenu: $9ef033443a74bee6$export$455b7811f904cadc,
    normalizeUnicode: $9ef033443a74bee6$export$1fa1e6b1a06bd7fa,
    OPS: $9ef033443a74bee6$export$3a0f7f7a8a0b306b,
    OutputScale: $9ef033443a74bee6$export$f16a99f63bccd50b,
    PasswordResponses: $9ef033443a74bee6$export$5e72215208e4d9ad,
    PDFDataRangeTransport: $9ef033443a74bee6$export$c06899d9d7bce9ab,
    PDFDateString: $9ef033443a74bee6$export$66cbc314498fffc,
    PDFWorker: $9ef033443a74bee6$export$84e2e9f37426b265,
    PermissionFlag: $9ef033443a74bee6$export$bb99a5b8411e07d8,
    PixelsPerInch: $9ef033443a74bee6$export$6ef3b6b69e65342c,
    RenderingCancelledException: $9ef033443a74bee6$export$245847d31c09154f,
    renderRichText: $9ef033443a74bee6$export$611c480766035c4,
    ResponseException: $9ef033443a74bee6$export$ea8e9c34f66e603,
    setLayerDimensions: $9ef033443a74bee6$export$af0a15a86e590226,
    shadow: $9ef033443a74bee6$export$b8972b998723d602,
    SignatureExtractor: $9ef033443a74bee6$export$cc4fe8633f466b4a,
    stopEvent: $9ef033443a74bee6$export$7ae4cd3a66c1e050,
    SupportedImageMimeTypes: $9ef033443a74bee6$export$3234c88e9de64a88,
    TextLayer: $9ef033443a74bee6$export$fdbdc423a78c5262,
    TouchManager: $9ef033443a74bee6$export$9ae7542b430d543e,
    updateUrlHash: $9ef033443a74bee6$export$e1e4297c21ab9d13,
    Util: $9ef033443a74bee6$export$f8f26dd395d7e1bd,
    VerbosityLevel: $9ef033443a74bee6$export$b18df09d23c244c4,
    version: $9ef033443a74bee6$export$83d89fbfd8236492,
    XfaLayer: $9ef033443a74bee6$export$f6af20c312d4b9a2
};





var $kc00y = parcelRequire("kc00y");
'use client';
const $dc39a01645cfbfe3$var$documentContext = (0, $kc00y.createContext)(null);
var $dc39a01645cfbfe3$export$2e2bcd8739ae039 = $dc39a01645cfbfe3$var$documentContext;


/* Copyright 2015 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
const $b8c1be92a50f4ae2$var$DEFAULT_LINK_REL = 'noopener noreferrer nofollow';
class $b8c1be92a50f4ae2$export$2e2bcd8739ae039 {
    constructor(){
        this.externalLinkEnabled = true;
        this.externalLinkRel = undefined;
        this.externalLinkTarget = undefined;
        this.isInPresentationMode = false;
        this.pdfDocument = undefined;
        this.pdfViewer = undefined;
    }
    setDocument(pdfDocument) {
        this.pdfDocument = pdfDocument;
    }
    setViewer(pdfViewer) {
        this.pdfViewer = pdfViewer;
    }
    setExternalLinkRel(externalLinkRel) {
        this.externalLinkRel = externalLinkRel;
    }
    setExternalLinkTarget(externalLinkTarget) {
        this.externalLinkTarget = externalLinkTarget;
    }
    setHash() {
    // Intentionally empty
    }
    setHistory() {
    // Intentionally empty
    }
    get pagesCount() {
        return this.pdfDocument ? this.pdfDocument.numPages : 0;
    }
    get page() {
        (0, $5e5c9f2b3ce253bc$export$2e2bcd8739ae039)(this.pdfViewer, 'PDF viewer is not initialized.');
        return this.pdfViewer.currentPageNumber || 0;
    }
    set page(value) {
        (0, $5e5c9f2b3ce253bc$export$2e2bcd8739ae039)(this.pdfViewer, 'PDF viewer is not initialized.');
        this.pdfViewer.currentPageNumber = value;
    }
    get rotation() {
        return 0;
    }
    set rotation(_value) {
    // Intentionally empty
    }
    addLinkAttributes(link, url, newWindow) {
        link.href = url;
        link.rel = this.externalLinkRel || $b8c1be92a50f4ae2$var$DEFAULT_LINK_REL;
        link.target = newWindow ? '_blank' : this.externalLinkTarget || '';
    }
    goToDestination(dest) {
        return new Promise((resolve)=>{
            (0, $5e5c9f2b3ce253bc$export$2e2bcd8739ae039)(this.pdfDocument, 'PDF document not loaded.');
            (0, $5e5c9f2b3ce253bc$export$2e2bcd8739ae039)(dest, 'Destination is not specified.');
            if (typeof dest === 'string') this.pdfDocument.getDestination(dest).then(resolve);
            else if (Array.isArray(dest)) resolve(dest);
            else dest.then(resolve);
        }).then((explicitDest)=>{
            (0, $5e5c9f2b3ce253bc$export$2e2bcd8739ae039)(Array.isArray(explicitDest), `"${explicitDest}" is not a valid destination array.`);
            const destRef = explicitDest[0];
            new Promise((resolve)=>{
                (0, $5e5c9f2b3ce253bc$export$2e2bcd8739ae039)(this.pdfDocument, 'PDF document not loaded.');
                if (destRef instanceof Object) this.pdfDocument.getPageIndex(destRef).then((pageIndex)=>{
                    resolve(pageIndex);
                }).catch(()=>{
                    (0, $5e5c9f2b3ce253bc$export$2e2bcd8739ae039)(false, `"${destRef}" is not a valid page reference.`);
                });
                else if (typeof destRef === 'number') resolve(destRef);
                else (0, $5e5c9f2b3ce253bc$export$2e2bcd8739ae039)(false, `"${destRef}" is not a valid destination reference.`);
            }).then((pageIndex)=>{
                const pageNumber = pageIndex + 1;
                (0, $5e5c9f2b3ce253bc$export$2e2bcd8739ae039)(this.pdfViewer, 'PDF viewer is not initialized.');
                (0, $5e5c9f2b3ce253bc$export$2e2bcd8739ae039)(pageNumber >= 1 && pageNumber <= this.pagesCount, `"${pageNumber}" is not a valid page number.`);
                this.pdfViewer.scrollPageIntoView({
                    dest: explicitDest,
                    pageIndex: pageIndex,
                    pageNumber: pageNumber
                });
            });
        });
    }
    goToPage(pageNumber) {
        const pageIndex = pageNumber - 1;
        (0, $5e5c9f2b3ce253bc$export$2e2bcd8739ae039)(this.pdfViewer, 'PDF viewer is not initialized.');
        (0, $5e5c9f2b3ce253bc$export$2e2bcd8739ae039)(pageNumber >= 1 && pageNumber <= this.pagesCount, `"${pageNumber}" is not a valid page number.`);
        this.pdfViewer.scrollPageIntoView({
            pageIndex: pageIndex,
            pageNumber: pageNumber
        });
    }
    goToXY() {
    // Intentionally empty
    }
    cachePageRef() {
    // Intentionally empty
    }
    getDestinationHash() {
        return '#';
    }
    getAnchorUrl() {
        return '#';
    }
    executeNamedAction() {
    // Intentionally empty
    }
    executeSetOCGState() {
    // Intentionally empty
    }
    isPageVisible() {
        return true;
    }
    isPageCached() {
        return true;
    }
    navigateTo(dest) {
        this.goToDestination(dest);
    }
}



function $e7f15cbf32c73f6e$export$2e2bcd8739ae039({ children: children, type: type }) {
    return (0, $948296388fc3e3c9$exports.jsx)("div", {
        className: `react-pdf__message react-pdf__message--${type}`,
        children: children
    });
}


// As defined in https://github.com/mozilla/pdf.js/blob/d9fac3459609a807be6506fb3441b5da4b154d14/src/shared/util.js#L371-L374
const $10aa0f19010d0687$var$PasswordResponses = {
    NEED_PASSWORD: 1,
    INCORRECT_PASSWORD: 2
};
var $10aa0f19010d0687$export$2e2bcd8739ae039 = $10aa0f19010d0687$var$PasswordResponses;



var $kc00y = parcelRequire("kc00y");
function $a34dcd306d539d3e$var$reducer(state, action) {
    switch(action.type){
        case 'RESOLVE':
            return {
                value: action.value,
                error: undefined
            };
        case 'REJECT':
            return {
                value: false,
                error: action.error
            };
        case 'RESET':
            return {
                value: undefined,
                error: undefined
            };
        default:
            return state;
    }
}
function $a34dcd306d539d3e$export$2e2bcd8739ae039() {
    return (0, $kc00y.useReducer)($a34dcd306d539d3e$var$reducer, {
        value: undefined,
        error: undefined
    });
}




const $879cffb8732180de$export$4e09c449d6c407f7 = typeof window !== 'undefined';
const $879cffb8732180de$export$d528e4159a0e221e = $879cffb8732180de$export$4e09c449d6c407f7 && window.location.protocol === 'file:';
function $879cffb8732180de$export$4e62c701997796c1(variable) {
    return typeof variable !== 'undefined';
}
function $879cffb8732180de$export$ef8866826b0b1f6d(variable) {
    return $879cffb8732180de$export$4e62c701997796c1(variable) && variable !== null;
}
function $879cffb8732180de$export$844ec244b1367d54(variable) {
    return typeof variable === 'string';
}
function $879cffb8732180de$export$9dd3754ae86f0017(variable) {
    return variable instanceof ArrayBuffer;
}
function $879cffb8732180de$export$5bcd6e94ed871c88(variable) {
    (0, $5e5c9f2b3ce253bc$export$2e2bcd8739ae039)($879cffb8732180de$export$4e09c449d6c407f7, 'isBlob can only be used in a browser environment');
    return variable instanceof Blob;
}
function $879cffb8732180de$export$4d82193ef6a8d75c(variable) {
    return $879cffb8732180de$export$844ec244b1367d54(variable) && /^data:/.test(variable);
}
function $879cffb8732180de$export$c1553384119518c3(dataURI) {
    (0, $5e5c9f2b3ce253bc$export$2e2bcd8739ae039)($879cffb8732180de$export$4d82193ef6a8d75c(dataURI), 'Invalid data URI.');
    const [headersString = '', dataString = ''] = dataURI.split(',');
    const headers = headersString.split(';');
    if (headers.indexOf('base64') !== -1) return atob(dataString);
    return unescape(dataString);
}
function $879cffb8732180de$export$cf4a949e5ad681d() {
    return $879cffb8732180de$export$4e09c449d6c407f7 && window.devicePixelRatio || 1;
}
const $879cffb8732180de$var$allowFileAccessFromFilesTip = 'On Chromium based browsers, you can use --allow-file-access-from-files flag for debugging purposes.';
function $879cffb8732180de$export$84884c3182d1bdda() {
    (0, (/*@__PURE__*/$parcel$interopDefault($61fad0cb6b7e8586$exports)))(!$879cffb8732180de$export$d528e4159a0e221e, `Loading PDF as base64 strings/URLs may not work on protocols other than HTTP/HTTPS. ${$879cffb8732180de$var$allowFileAccessFromFilesTip}`);
}
function $879cffb8732180de$export$e7ec4a9e2d586a77() {
    (0, (/*@__PURE__*/$parcel$interopDefault($61fad0cb6b7e8586$exports)))(!$879cffb8732180de$export$d528e4159a0e221e, `Loading PDF.js worker may not work on protocols other than HTTP/HTTPS. ${$879cffb8732180de$var$allowFileAccessFromFilesTip}`);
}
function $879cffb8732180de$export$b8c3f1dffc289352(runningTask) {
    if (runningTask === null || runningTask === void 0 ? void 0 : runningTask.cancel) runningTask.cancel();
}
function $879cffb8732180de$export$8cc3f6b8d58bdda0(page, scale) {
    Object.defineProperty(page, 'width', {
        get () {
            return this.getViewport({
                scale: scale
            }).width;
        },
        configurable: true
    });
    Object.defineProperty(page, 'height', {
        get () {
            return this.getViewport({
                scale: scale
            }).height;
        },
        configurable: true
    });
    Object.defineProperty(page, 'originalWidth', {
        get () {
            return this.getViewport({
                scale: 1
            }).width;
        },
        configurable: true
    });
    Object.defineProperty(page, 'originalHeight', {
        get () {
            return this.getViewport({
                scale: 1
            }).height;
        },
        configurable: true
    });
    return page;
}
function $879cffb8732180de$export$ed392050f3fc5849(error) {
    return error.name === 'AbortException' || error.name === 'RenderingCancelledException';
}
function $879cffb8732180de$export$21fedb3a7a137f3d(file) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onload = ()=>{
            if (!reader.result) return reject(new Error('Error while reading a file.'));
            resolve(reader.result);
        };
        reader.onerror = (event)=>{
            if (!event.target) return reject(new Error('Error while reading a file.'));
            const { error: error } = event.target;
            if (!error) return reject(new Error('Error while reading a file.'));
            switch(error.code){
                case error.NOT_FOUND_ERR:
                    return reject(new Error('Error while reading a file: File not found.'));
                case error.SECURITY_ERR:
                    return reject(new Error('Error while reading a file: Security error.'));
                case error.ABORT_ERR:
                    return reject(new Error('Error while reading a file: Aborted.'));
                default:
                    return reject(new Error('Error while reading a file.'));
            }
        };
        reader.readAsArrayBuffer(file);
    });
}


'use client';
const { PDFDataRangeTransport: $92b61959d6e2028b$var$PDFDataRangeTransport } = $9ef033443a74bee6$exports;
const $92b61959d6e2028b$var$defaultOnPassword = (callback, reason)=>{
    switch(reason){
        case (0, $10aa0f19010d0687$export$2e2bcd8739ae039).NEED_PASSWORD:
            {
                const password = prompt('Enter the password to open this PDF file.');
                callback(password);
                break;
            }
        case (0, $10aa0f19010d0687$export$2e2bcd8739ae039).INCORRECT_PASSWORD:
            {
                const password = prompt('Invalid password. Please try again.');
                callback(password);
                break;
            }
        default:
    }
};
function $92b61959d6e2028b$var$isParameterObject(file) {
    return typeof file === 'object' && file !== null && ('data' in file || 'range' in file || 'url' in file);
}
/**
 * Loads a document passed using `file` prop.
 */ const $92b61959d6e2028b$var$Document = (0, $kc00y.forwardRef)(function Document({ children: children, className: className, error: error = 'Failed to load PDF file.', externalLinkRel: externalLinkRel, externalLinkTarget: externalLinkTarget, file: file, inputRef: inputRef, imageResourcesPath: imageResourcesPath, loading: loading = "Loading PDF\u2026", noData: noData = 'No PDF file specified.', onItemClick: onItemClick, onLoadError: onLoadErrorProps, onLoadProgress: onLoadProgress, onLoadSuccess: onLoadSuccessProps, onPassword: onPassword = $92b61959d6e2028b$var$defaultOnPassword, onSourceError: onSourceErrorProps, onSourceSuccess: onSourceSuccessProps, options: options, renderMode: renderMode, rotate: rotate, scale: scale, ...otherProps }, ref) {
    const [sourceState, sourceDispatch] = (0, $a34dcd306d539d3e$export$2e2bcd8739ae039)();
    const { value: source, error: sourceError } = sourceState;
    const [pdfState, pdfDispatch] = (0, $a34dcd306d539d3e$export$2e2bcd8739ae039)();
    const { value: pdf, error: pdfError } = pdfState;
    const linkService = (0, $kc00y.useRef)(new (0, $b8c1be92a50f4ae2$export$2e2bcd8739ae039)());
    const pages = (0, $kc00y.useRef)([]);
    const prevFile = (0, $kc00y.useRef)(undefined);
    const prevOptions = (0, $kc00y.useRef)(undefined);
    if (file && file !== prevFile.current && $92b61959d6e2028b$var$isParameterObject(file)) {
        (0, (/*@__PURE__*/$parcel$interopDefault($61fad0cb6b7e8586$exports)))(!(0, $f035112a1ee37c2c$export$de8294bb3be0322f)(file, prevFile.current), `File prop passed to <Document /> changed, but it's equal to previous one. This might result in unnecessary reloads. Consider memoizing the value passed to "file" prop.`);
        prevFile.current = file;
    }
    // Detect non-memoized changes in options prop
    if (options && options !== prevOptions.current) {
        (0, (/*@__PURE__*/$parcel$interopDefault($61fad0cb6b7e8586$exports)))(!(0, $f035112a1ee37c2c$export$de8294bb3be0322f)(options, prevOptions.current), `Options prop passed to <Document /> changed, but it's equal to previous one. This might result in unnecessary reloads. Consider memoizing the value passed to "options" prop.`);
        prevOptions.current = options;
    }
    const viewer = (0, $kc00y.useRef)({
        // Handling jumping to internal links target
        scrollPageIntoView: (args)=>{
            const { dest: dest, pageNumber: pageNumber, pageIndex: pageIndex = pageNumber - 1 } = args;
            // First, check if custom handling of onItemClick was provided
            if (onItemClick) {
                onItemClick({
                    dest: dest,
                    pageIndex: pageIndex,
                    pageNumber: pageNumber
                });
                return;
            }
            // If not, try to look for target page within the <Document>.
            const page = pages.current[pageIndex];
            if (page) {
                // Scroll to the page automatically
                page.scrollIntoView();
                return;
            }
            (0, (/*@__PURE__*/$parcel$interopDefault($61fad0cb6b7e8586$exports)))(false, `An internal link leading to page ${pageNumber} was clicked, but neither <Document> was provided with onItemClick nor it was able to find the page within itself. Either provide onItemClick to <Document> and handle navigating by yourself or ensure that all pages are rendered within <Document>.`);
        }
    });
    (0, $kc00y.useImperativeHandle)(ref, ()=>({
            linkService: linkService,
            pages: pages,
            viewer: viewer
        }), []);
    /**
     * Called when a document source is resolved correctly
     */ function onSourceSuccess() {
        if (onSourceSuccessProps) onSourceSuccessProps();
    }
    /**
     * Called when a document source failed to be resolved correctly
     */ function onSourceError() {
        if (!sourceError) // Impossible, but TypeScript doesn't know that
        return;
        (0, (/*@__PURE__*/$parcel$interopDefault($61fad0cb6b7e8586$exports)))(false, sourceError.toString());
        if (onSourceErrorProps) onSourceErrorProps(sourceError);
    }
    function resetSource() {
        sourceDispatch({
            type: 'RESET'
        });
    }
    // biome-ignore lint/correctness/useExhaustiveDependencies: See https://github.com/biomejs/biome/issues/3080
    (0, $kc00y.useEffect)(resetSource, [
        file,
        sourceDispatch
    ]);
    const findDocumentSource = (0, $kc00y.useCallback)(async ()=>{
        if (!file) return null;
        // File is a string
        if (typeof file === 'string') {
            if ((0, $879cffb8732180de$export$4d82193ef6a8d75c)(file)) {
                const fileByteString = (0, $879cffb8732180de$export$c1553384119518c3)(file);
                return {
                    data: fileByteString
                };
            }
            (0, $879cffb8732180de$export$84884c3182d1bdda)();
            return {
                url: file
            };
        }
        // File is PDFDataRangeTransport
        if (file instanceof $92b61959d6e2028b$var$PDFDataRangeTransport) return {
            range: file
        };
        // File is an ArrayBuffer
        if ((0, $879cffb8732180de$export$9dd3754ae86f0017)(file)) return {
            data: file
        };
        /**
         * The cases below are browser-only.
         * If you're running on a non-browser environment, these cases will be of no use.
         */ if (0, $879cffb8732180de$export$4e09c449d6c407f7) // File is a Blob
        {
            if ((0, $879cffb8732180de$export$5bcd6e94ed871c88)(file)) {
                const data = await (0, $879cffb8732180de$export$21fedb3a7a137f3d)(file);
                return {
                    data: data
                };
            }
        }
        // At this point, file must be an object
        (0, $5e5c9f2b3ce253bc$export$2e2bcd8739ae039)(typeof file === 'object', 'Invalid parameter in file, need either Uint8Array, string or a parameter object');
        (0, $5e5c9f2b3ce253bc$export$2e2bcd8739ae039)($92b61959d6e2028b$var$isParameterObject(file), 'Invalid parameter object: need either .data, .range or .url');
        // File .url is a string
        if ('url' in file && typeof file.url === 'string') {
            if ((0, $879cffb8732180de$export$4d82193ef6a8d75c)(file.url)) {
                const { url: url, ...otherParams } = file;
                const fileByteString = (0, $879cffb8732180de$export$c1553384119518c3)(url);
                return {
                    data: fileByteString,
                    ...otherParams
                };
            }
            (0, $879cffb8732180de$export$84884c3182d1bdda)();
        }
        return file;
    }, [
        file
    ]);
    (0, $kc00y.useEffect)(()=>{
        const cancellable = (0, $69f09258c42ac403$export$2e2bcd8739ae039)(findDocumentSource());
        cancellable.promise.then((nextSource)=>{
            sourceDispatch({
                type: 'RESOLVE',
                value: nextSource
            });
        }).catch((error)=>{
            sourceDispatch({
                type: 'REJECT',
                error: error
            });
        });
        return ()=>{
            (0, $879cffb8732180de$export$b8c3f1dffc289352)(cancellable);
        };
    }, [
        findDocumentSource,
        sourceDispatch
    ]);
    // biome-ignore lint/correctness/useExhaustiveDependencies: Omitted callbacks so they are not called every time they change
    (0, $kc00y.useEffect)(()=>{
        if (typeof source === 'undefined') return;
        if (source === false) {
            onSourceError();
            return;
        }
        onSourceSuccess();
    }, [
        source
    ]);
    /**
     * Called when a document is read successfully
     */ function onLoadSuccess() {
        if (!pdf) // Impossible, but TypeScript doesn't know that
        return;
        if (onLoadSuccessProps) onLoadSuccessProps(pdf);
        pages.current = new Array(pdf.numPages);
        linkService.current.setDocument(pdf);
    }
    /**
     * Called when a document failed to read successfully
     */ function onLoadError() {
        if (!pdfError) // Impossible, but TypeScript doesn't know that
        return;
        (0, (/*@__PURE__*/$parcel$interopDefault($61fad0cb6b7e8586$exports)))(false, pdfError.toString());
        if (onLoadErrorProps) onLoadErrorProps(pdfError);
    }
    // biome-ignore lint/correctness/useExhaustiveDependencies: useEffect intentionally triggered on source change
    (0, $kc00y.useEffect)(function resetDocument() {
        pdfDispatch({
            type: 'RESET'
        });
    }, [
        pdfDispatch,
        source
    ]);
    // biome-ignore lint/correctness/useExhaustiveDependencies: Omitted callbacks so they are not called every time they change
    (0, $kc00y.useEffect)(function loadDocument() {
        if (!source) return;
        const documentInitParams = options ? {
            ...source,
            ...options
        } : source;
        const destroyable = $9ef033443a74bee6$exports.getDocument(documentInitParams);
        if (onLoadProgress) destroyable.onProgress = onLoadProgress;
        if (onPassword) destroyable.onPassword = onPassword;
        const loadingTask = destroyable;
        loadingTask.promise.then((nextPdf)=>{
            if (loadingTask.destroyed) return;
            pdfDispatch({
                type: 'RESOLVE',
                value: nextPdf
            });
        }).catch((error)=>{
            if (loadingTask.destroyed) return;
            pdfDispatch({
                type: 'REJECT',
                error: error
            });
        });
        return ()=>{
            loadingTask.destroy();
        };
    }, [
        options,
        pdfDispatch,
        source
    ]);
    // biome-ignore lint/correctness/useExhaustiveDependencies: Omitted callbacks so they are not called every time they change
    (0, $kc00y.useEffect)(()=>{
        if (typeof pdf === 'undefined') return;
        if (pdf === false) {
            onLoadError();
            return;
        }
        onLoadSuccess();
    }, [
        pdf
    ]);
    (0, $kc00y.useEffect)(function setupLinkService() {
        linkService.current.setViewer(viewer.current);
        linkService.current.setExternalLinkRel(externalLinkRel);
        linkService.current.setExternalLinkTarget(externalLinkTarget);
    }, [
        externalLinkRel,
        externalLinkTarget
    ]);
    const registerPage = (0, $kc00y.useCallback)((pageIndex, ref)=>{
        pages.current[pageIndex] = ref;
    }, []);
    const unregisterPage = (0, $kc00y.useCallback)((pageIndex)=>{
        delete pages.current[pageIndex];
    }, []);
    const childContext = (0, $kc00y.useMemo)(()=>({
            imageResourcesPath: imageResourcesPath,
            linkService: linkService.current,
            onItemClick: onItemClick,
            pdf: pdf,
            registerPage: registerPage,
            renderMode: renderMode,
            rotate: rotate,
            scale: scale,
            unregisterPage: unregisterPage
        }), [
        imageResourcesPath,
        onItemClick,
        pdf,
        registerPage,
        renderMode,
        rotate,
        scale,
        unregisterPage
    ]);
    const eventProps = (0, $kc00y.useMemo)(()=>(0, $4c01b1fb52e31b15$export$2e2bcd8739ae039)(otherProps, ()=>pdf), // biome-ignore lint/correctness/useExhaustiveDependencies: FIXME
    [
        otherProps,
        pdf
    ]);
    function renderChildren() {
        function isFulfilledContext(context) {
            return Boolean(context === null || context === void 0 ? void 0 : context.pdf);
        }
        if (!isFulfilledContext(childContext)) // Impossible, but TypeScript doesn't know that
        throw new Error('pdf is undefined');
        const resolvedChildren = typeof children === 'function' ? children(childContext) : children;
        return (0, $948296388fc3e3c9$exports.jsx)((0, $dc39a01645cfbfe3$export$2e2bcd8739ae039).Provider, {
            value: childContext,
            children: resolvedChildren
        });
    }
    function renderContent() {
        if (!file) return (0, $948296388fc3e3c9$exports.jsx)((0, $e7f15cbf32c73f6e$export$2e2bcd8739ae039), {
            type: "no-data",
            children: typeof noData === 'function' ? noData() : noData
        });
        if (pdf === undefined || pdf === null) return (0, $948296388fc3e3c9$exports.jsx)((0, $e7f15cbf32c73f6e$export$2e2bcd8739ae039), {
            type: "loading",
            children: typeof loading === 'function' ? loading() : loading
        });
        if (pdf === false) return (0, $948296388fc3e3c9$exports.jsx)((0, $e7f15cbf32c73f6e$export$2e2bcd8739ae039), {
            type: "error",
            children: typeof error === 'function' ? error() : error
        });
        return renderChildren();
    }
    return (0, $948296388fc3e3c9$exports.jsx)("div", {
        className: (0, $328c1c2632e2f292$export$2e2bcd8739ae039)('react-pdf__Document', className),
        // Assertion is needed for React 18 compatibility
        ref: inputRef,
        ...eventProps,
        children: renderContent()
    });
});
var $92b61959d6e2028b$export$2e2bcd8739ae039 = $92b61959d6e2028b$var$Document;



var $kc00y = parcelRequire("kc00y");



/**
 * A function that merges React refs into one.
 * Supports both functions and ref objects created using createRef() and useRef().
 *
 * Usage:
 * ```tsx
 * <div ref={mergeRefs(ref1, ref2, ref3)} />
 * ```
 *
 * @param {(React.Ref<T> | undefined)[]} inputRefs Array of refs
 * @returns {React.Ref<T> | React.RefCallback<T>} Merged refs
 */ function $e61890c2b95ac494$export$2e2bcd8739ae039() {
    var inputRefs = [];
    for(var _i = 0; _i < arguments.length; _i++)inputRefs[_i] = arguments[_i];
    var filteredInputRefs = inputRefs.filter(Boolean);
    if (filteredInputRefs.length <= 1) {
        var firstRef = filteredInputRefs[0];
        return firstRef || null;
    }
    return function mergedRefs(ref) {
        for(var _i = 0, filteredInputRefs_1 = filteredInputRefs; _i < filteredInputRefs_1.length; _i++){
            var inputRef = filteredInputRefs_1[_i];
            if (typeof inputRef === 'function') inputRef(ref);
            else if (inputRef) inputRef.current = ref;
        }
    };
}







var $kc00y = parcelRequire("kc00y");






var $kc00y = parcelRequire("kc00y");

function $3e74bdf76243a25d$export$2e2bcd8739ae039() {
    return (0, $kc00y.useContext)((0, $dc39a01645cfbfe3$export$2e2bcd8739ae039));
}



var $kc00y = parcelRequire("kc00y");

var $kc00y = parcelRequire("kc00y");
'use client';
const $cdfb0451857bfb00$var$pageContext = (0, $kc00y.createContext)(null);
var $cdfb0451857bfb00$export$2e2bcd8739ae039 = $cdfb0451857bfb00$var$pageContext;


function $fbc6612af3cafdd1$export$2e2bcd8739ae039() {
    return (0, $kc00y.useContext)((0, $cdfb0451857bfb00$export$2e2bcd8739ae039));
}




'use client';
function $2d94e2ef29c83ebf$export$2e2bcd8739ae039() {
    const documentContext = (0, $3e74bdf76243a25d$export$2e2bcd8739ae039)();
    const pageContext = (0, $fbc6612af3cafdd1$export$2e2bcd8739ae039)();
    (0, $5e5c9f2b3ce253bc$export$2e2bcd8739ae039)(pageContext, 'Unable to find Page context.');
    const mergedProps = {
        ...documentContext,
        ...pageContext
    };
    const { filterAnnotations: filterAnnotations, imageResourcesPath: imageResourcesPath, linkService: linkService, onGetAnnotationsError: onGetAnnotationsErrorProps, onGetAnnotationsSuccess: onGetAnnotationsSuccessProps, onRenderAnnotationLayerError: onRenderAnnotationLayerErrorProps, onRenderAnnotationLayerSuccess: onRenderAnnotationLayerSuccessProps, page: page, pdf: pdf, renderForms: renderForms, rotate: rotate, scale: scale = 1 } = mergedProps;
    (0, $5e5c9f2b3ce253bc$export$2e2bcd8739ae039)(pdf, 'Attempted to load page annotations, but no document was specified. Wrap <Page /> in a <Document /> or pass explicit `pdf` prop.');
    (0, $5e5c9f2b3ce253bc$export$2e2bcd8739ae039)(page, 'Attempted to load page annotations, but no page was specified.');
    (0, $5e5c9f2b3ce253bc$export$2e2bcd8739ae039)(linkService, 'Attempted to load page annotations, but no linkService was specified.');
    const [annotationsState, annotationsDispatch] = (0, $a34dcd306d539d3e$export$2e2bcd8739ae039)();
    const { value: annotations, error: annotationsError } = annotationsState;
    const layerElement = (0, $kc00y.useRef)(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($61fad0cb6b7e8586$exports)))(Number.parseInt(window.getComputedStyle(document.body).getPropertyValue('--react-pdf-annotation-layer'), 10) === 1, 'AnnotationLayer styles not found. Read more: https://github.com/wojtekmaj/react-pdf#support-for-annotations');
    function onLoadSuccess() {
        if (!annotations) // Impossible, but TypeScript doesn't know that
        return;
        if (onGetAnnotationsSuccessProps) onGetAnnotationsSuccessProps(annotations);
    }
    function onLoadError() {
        if (!annotationsError) // Impossible, but TypeScript doesn't know that
        return;
        (0, (/*@__PURE__*/$parcel$interopDefault($61fad0cb6b7e8586$exports)))(false, annotationsError.toString());
        if (onGetAnnotationsErrorProps) onGetAnnotationsErrorProps(annotationsError);
    }
    // biome-ignore lint/correctness/useExhaustiveDependencies: useEffect intentionally triggered on page change
    (0, $kc00y.useEffect)(function resetAnnotations() {
        annotationsDispatch({
            type: 'RESET'
        });
    }, [
        annotationsDispatch,
        page
    ]);
    (0, $kc00y.useEffect)(function loadAnnotations() {
        if (!page) return;
        const cancellable = (0, $69f09258c42ac403$export$2e2bcd8739ae039)(page.getAnnotations());
        const runningTask = cancellable;
        cancellable.promise.then((nextAnnotations)=>{
            annotationsDispatch({
                type: 'RESOLVE',
                value: nextAnnotations
            });
        }).catch((error)=>{
            annotationsDispatch({
                type: 'REJECT',
                error: error
            });
        });
        return ()=>{
            (0, $879cffb8732180de$export$b8c3f1dffc289352)(runningTask);
        };
    }, [
        annotationsDispatch,
        page
    ]);
    // biome-ignore lint/correctness/useExhaustiveDependencies: Omitted callbacks so they are not called every time they change
    (0, $kc00y.useEffect)(()=>{
        if (annotations === undefined) return;
        if (annotations === false) {
            onLoadError();
            return;
        }
        onLoadSuccess();
    }, [
        annotations
    ]);
    function onRenderSuccess() {
        if (onRenderAnnotationLayerSuccessProps) onRenderAnnotationLayerSuccessProps();
    }
    function onRenderError(error) {
        (0, (/*@__PURE__*/$parcel$interopDefault($61fad0cb6b7e8586$exports)))(false, `${error}`);
        if (onRenderAnnotationLayerErrorProps) onRenderAnnotationLayerErrorProps(error);
    }
    const viewport = (0, $kc00y.useMemo)(()=>page.getViewport({
            scale: scale,
            rotation: rotate
        }), [
        page,
        rotate,
        scale
    ]);
    // biome-ignore lint/correctness/useExhaustiveDependencies: Omitted callbacks so they are not called every time they change
    (0, $kc00y.useEffect)(function renderAnnotationLayer() {
        if (!pdf || !page || !linkService || !annotations) return;
        const { current: layer } = layerElement;
        if (!layer) return;
        const clonedViewport = viewport.clone({
            dontFlip: true
        });
        const annotationLayerParameters = {
            accessibilityManager: null,
            annotationCanvasMap: null,
            annotationEditorUIManager: null,
            annotationStorage: pdf.annotationStorage,
            commentManager: null,
            div: layer,
            l10n: null,
            linkService: linkService,
            page: page,
            structTreeLayer: null,
            viewport: clonedViewport
        };
        const renderParameters = {
            annotations: filterAnnotations ? filterAnnotations({
                annotations: annotations
            }) : annotations,
            annotationStorage: pdf.annotationStorage,
            div: layer,
            imageResourcesPath: imageResourcesPath,
            linkService: linkService,
            page: page,
            renderForms: renderForms,
            viewport: clonedViewport
        };
        layer.innerHTML = '';
        try {
            new $9ef033443a74bee6$export$3e7f45c326d9366c(annotationLayerParameters).render(renderParameters);
            // Intentional immediate callback
            onRenderSuccess();
        } catch (error) {
            onRenderError(error);
        }
        return ()=>{
        // TODO: Cancel running task?
        };
    }, [
        annotations,
        filterAnnotations,
        imageResourcesPath,
        linkService,
        page,
        pdf,
        renderForms,
        viewport
    ]);
    return (0, $948296388fc3e3c9$exports.jsx)("div", {
        className: (0, $328c1c2632e2f292$export$2e2bcd8739ae039)('react-pdf__Page__annotations', 'annotationLayer'),
        ref: layerElement
    });
}




var $kc00y = parcelRequire("kc00y");






var $kc00y = parcelRequire("kc00y");





var $kc00y = parcelRequire("kc00y");
// From pdfjs-dist/lib/web/struct_tree_layer_builder.js
const $4744de619616e3fd$export$789cd800273ee71a = {
    // Document level structure types
    Document: null,
    DocumentFragment: null,
    // Grouping level structure types
    Part: 'group',
    Sect: 'group',
    Div: 'group',
    Aside: 'note',
    NonStruct: 'none',
    // Block level structure types
    P: null,
    // H<n>,
    H: 'heading',
    Title: null,
    FENote: 'note',
    // Sub-block level structure type
    Sub: 'group',
    // General inline level structure types
    Lbl: null,
    Span: null,
    Em: null,
    Strong: null,
    Link: 'link',
    Annot: 'note',
    Form: 'form',
    // Ruby and Warichu structure types
    Ruby: null,
    RB: null,
    RT: null,
    RP: null,
    Warichu: null,
    WT: null,
    WP: null,
    // List standard structure types
    L: 'list',
    LI: 'listitem',
    LBody: null,
    // Table standard structure types
    Table: 'table',
    TR: 'row',
    TH: 'columnheader',
    TD: 'cell',
    THead: 'columnheader',
    TBody: null,
    TFoot: null,
    // Standard structure type Caption
    Caption: null,
    // Standard structure type Figure
    Figure: 'figure',
    // Standard structure type Formula
    Formula: null,
    // standard structure type Artifact
    Artifact: null
};
const $4744de619616e3fd$export$4921bbe0701579e4 = /^H(\d+)$/;


function $c6f318dc626dc4f4$export$80a007e7cc9dad0d(role) {
    return role in (0, $4744de619616e3fd$export$789cd800273ee71a);
}
function $c6f318dc626dc4f4$export$9eeaf208d22fae4f(node) {
    return 'children' in node;
}
function $c6f318dc626dc4f4$export$3b7840712ba182f3(node) {
    if (!$c6f318dc626dc4f4$export$9eeaf208d22fae4f(node)) return false;
    return node.children.length === 1 && 0 in node.children && 'id' in node.children[0];
}
function $c6f318dc626dc4f4$export$aa440a09c67191c2(node) {
    const attributes = {};
    if ($c6f318dc626dc4f4$export$9eeaf208d22fae4f(node)) {
        const { role: role } = node;
        const matches = role.match((0, $4744de619616e3fd$export$4921bbe0701579e4));
        if (matches) {
            attributes.role = 'heading';
            attributes['aria-level'] = Number(matches[1]);
        } else if ($c6f318dc626dc4f4$export$80a007e7cc9dad0d(role)) {
            const htmlRole = (0, $4744de619616e3fd$export$789cd800273ee71a)[role];
            if (htmlRole) attributes.role = htmlRole;
        }
    }
    return attributes;
}
function $c6f318dc626dc4f4$export$e86e6c9c68c5154c(node) {
    const attributes = {};
    if ($c6f318dc626dc4f4$export$9eeaf208d22fae4f(node)) {
        if (node.alt !== undefined) attributes['aria-label'] = node.alt;
        if (node.lang !== undefined) attributes.lang = node.lang;
        if ($c6f318dc626dc4f4$export$3b7840712ba182f3(node)) {
            const [child] = node.children;
            if (child) {
                const childAttributes = $c6f318dc626dc4f4$export$e86e6c9c68c5154c(child);
                return {
                    ...attributes,
                    ...childAttributes
                };
            }
        }
    } else if ('id' in node) attributes['aria-owns'] = node.id;
    return attributes;
}
function $c6f318dc626dc4f4$export$fe94072fee8a6976(node) {
    if (!node) return null;
    return {
        ...$c6f318dc626dc4f4$export$aa440a09c67191c2(node),
        ...$c6f318dc626dc4f4$export$e86e6c9c68c5154c(node)
    };
}


function $e2fecf7b73849932$export$2e2bcd8739ae039({ className: className, node: node }) {
    const attributes = (0, $kc00y.useMemo)(()=>(0, $c6f318dc626dc4f4$export$fe94072fee8a6976)(node), [
        node
    ]);
    const children = (0, $kc00y.useMemo)(()=>{
        if (!(0, $c6f318dc626dc4f4$export$9eeaf208d22fae4f)(node)) return null;
        if ((0, $c6f318dc626dc4f4$export$3b7840712ba182f3)(node)) return null;
        return node.children.map((child, index)=>{
            return(// biome-ignore lint/suspicious/noArrayIndexKey: index is stable here
            (0, $948296388fc3e3c9$exports.jsx)($e2fecf7b73849932$export$2e2bcd8739ae039, {
                node: child
            }, index));
        });
    }, [
        node
    ]);
    return (0, $948296388fc3e3c9$exports.jsx)("span", {
        className: className,
        ...attributes,
        children: children
    });
}





function $e110a12fe63568be$export$2e2bcd8739ae039() {
    const pageContext = (0, $fbc6612af3cafdd1$export$2e2bcd8739ae039)();
    (0, $5e5c9f2b3ce253bc$export$2e2bcd8739ae039)(pageContext, 'Unable to find Page context.');
    const { onGetStructTreeError: onGetStructTreeErrorProps, onGetStructTreeSuccess: onGetStructTreeSuccessProps } = pageContext;
    const [structTreeState, structTreeDispatch] = (0, $a34dcd306d539d3e$export$2e2bcd8739ae039)();
    const { value: structTree, error: structTreeError } = structTreeState;
    const { customTextRenderer: customTextRenderer, page: page } = pageContext;
    function onLoadSuccess() {
        if (!structTree) // Impossible, but TypeScript doesn't know that
        return;
        if (onGetStructTreeSuccessProps) onGetStructTreeSuccessProps(structTree);
    }
    function onLoadError() {
        if (!structTreeError) // Impossible, but TypeScript doesn't know that
        return;
        (0, (/*@__PURE__*/$parcel$interopDefault($61fad0cb6b7e8586$exports)))(false, structTreeError.toString());
        if (onGetStructTreeErrorProps) onGetStructTreeErrorProps(structTreeError);
    }
    // biome-ignore lint/correctness/useExhaustiveDependencies: useEffect intentionally triggered on page change
    (0, $kc00y.useEffect)(function resetStructTree() {
        structTreeDispatch({
            type: 'RESET'
        });
    }, [
        structTreeDispatch,
        page
    ]);
    (0, $kc00y.useEffect)(function loadStructTree() {
        if (customTextRenderer) // TODO: Document why this is necessary
        return;
        if (!page) return;
        const cancellable = (0, $69f09258c42ac403$export$2e2bcd8739ae039)(page.getStructTree());
        const runningTask = cancellable;
        cancellable.promise.then((nextStructTree)=>{
            structTreeDispatch({
                type: 'RESOLVE',
                value: nextStructTree
            });
        }).catch((error)=>{
            structTreeDispatch({
                type: 'REJECT',
                error: error
            });
        });
        return ()=>(0, $879cffb8732180de$export$b8c3f1dffc289352)(runningTask);
    }, [
        customTextRenderer,
        page,
        structTreeDispatch
    ]);
    // biome-ignore lint/correctness/useExhaustiveDependencies: Omitted callbacks so they are not called every time they change
    (0, $kc00y.useEffect)(()=>{
        if (structTree === undefined) return;
        if (structTree === false) {
            onLoadError();
            return;
        }
        onLoadSuccess();
    }, [
        structTree
    ]);
    if (!structTree) return null;
    return (0, $948296388fc3e3c9$exports.jsx)((0, $e2fecf7b73849932$export$2e2bcd8739ae039), {
        className: "react-pdf__Page__structTree structTree",
        node: structTree
    });
}




'use client';
const $e5b7ad1e573e5470$var$ANNOTATION_MODE = $9ef033443a74bee6$export$5a7af0c07e33392e;
function $e5b7ad1e573e5470$export$2e2bcd8739ae039(props) {
    const pageContext = (0, $fbc6612af3cafdd1$export$2e2bcd8739ae039)();
    (0, $5e5c9f2b3ce253bc$export$2e2bcd8739ae039)(pageContext, 'Unable to find Page context.');
    const mergedProps = {
        ...pageContext,
        ...props
    };
    const { _className: _className, canvasBackground: canvasBackground, devicePixelRatio: devicePixelRatio = (0, $879cffb8732180de$export$cf4a949e5ad681d)(), onRenderError: onRenderErrorProps, onRenderSuccess: onRenderSuccessProps, page: page, renderForms: renderForms, renderTextLayer: renderTextLayer, pageColors: pageColors, rotate: rotate, scale: scale } = mergedProps;
    const { canvasRef: canvasRef } = props;
    (0, $5e5c9f2b3ce253bc$export$2e2bcd8739ae039)(page, 'Attempted to render page canvas, but no page was specified.');
    const canvasElement = (0, $kc00y.useRef)(null);
    /**
     * Called when a page is rendered successfully.
     */ function onRenderSuccess() {
        if (!page) // Impossible, but TypeScript doesn't know that
        return;
        if (onRenderSuccessProps) onRenderSuccessProps((0, $879cffb8732180de$export$8cc3f6b8d58bdda0)(page, scale));
    }
    /**
     * Called when a page fails to render.
     */ function onRenderError(error) {
        if ((0, $879cffb8732180de$export$ed392050f3fc5849)(error)) return;
        (0, (/*@__PURE__*/$parcel$interopDefault($61fad0cb6b7e8586$exports)))(false, error.toString());
        if (onRenderErrorProps) onRenderErrorProps(error);
    }
    const renderViewport = (0, $kc00y.useMemo)(()=>page.getViewport({
            scale: scale * devicePixelRatio,
            rotation: rotate
        }), [
        devicePixelRatio,
        page,
        rotate,
        scale
    ]);
    const viewport = (0, $kc00y.useMemo)(()=>page.getViewport({
            scale: scale,
            rotation: rotate
        }), [
        page,
        rotate,
        scale
    ]);
    // biome-ignore lint/correctness/useExhaustiveDependencies: Omitted callbacks so they are not called every time they change
    (0, $kc00y.useEffect)(function drawPageOnCanvas() {
        if (!page) return;
        // Ensures the canvas will be re-rendered from scratch. Otherwise all form data will stay.
        page.cleanup();
        const { current: canvas } = canvasElement;
        if (!canvas) return;
        canvas.width = renderViewport.width;
        canvas.height = renderViewport.height;
        canvas.style.width = `${Math.floor(viewport.width)}px`;
        canvas.style.height = `${Math.floor(viewport.height)}px`;
        canvas.style.visibility = 'hidden';
        const renderContext = {
            annotationMode: renderForms ? $e5b7ad1e573e5470$var$ANNOTATION_MODE.ENABLE_FORMS : $e5b7ad1e573e5470$var$ANNOTATION_MODE.ENABLE,
            canvas: canvas,
            canvasContext: canvas.getContext('2d', {
                alpha: false
            }),
            pageColors: pageColors,
            viewport: renderViewport
        };
        if (canvasBackground) renderContext.background = canvasBackground;
        const cancellable = page.render(renderContext);
        const runningTask = cancellable;
        cancellable.promise.then(()=>{
            canvas.style.visibility = '';
            onRenderSuccess();
        }).catch(onRenderError);
        return ()=>(0, $879cffb8732180de$export$b8c3f1dffc289352)(runningTask);
    }, [
        canvasBackground,
        page,
        pageColors,
        renderForms,
        renderViewport,
        viewport
    ]);
    const cleanup = (0, $kc00y.useCallback)(()=>{
        const { current: canvas } = canvasElement;
        /**
         * Zeroing the width and height cause most browsers to release graphics
         * resources immediately, which can greatly reduce memory consumption.
         */ if (canvas) {
            canvas.width = 0;
            canvas.height = 0;
        }
    }, []);
    (0, $kc00y.useEffect)(()=>cleanup, [
        cleanup
    ]);
    return (0, $948296388fc3e3c9$exports.jsx)("canvas", {
        className: `${_className}__canvas`,
        dir: "ltr",
        ref: (0, $e61890c2b95ac494$export$2e2bcd8739ae039)(canvasRef, canvasElement),
        style: {
            display: 'block',
            userSelect: 'none'
        },
        children: renderTextLayer ? (0, $948296388fc3e3c9$exports.jsx)((0, $e110a12fe63568be$export$2e2bcd8739ae039), {}) : null
    });
}




var $kc00y = parcelRequire("kc00y");








'use client';
function $d65c44bad72b4186$var$isTextItem(item) {
    return 'str' in item;
}
const $d65c44bad72b4186$var$BLOCKED_CUSTOM_TEXT_TAGS = new Set([
    'base',
    'embed',
    'iframe',
    'link',
    'meta',
    'object',
    'script',
    'style',
    'template'
]);
const $d65c44bad72b4186$var$URL_ATTRIBUTES = new Set([
    'action',
    'formaction',
    'href',
    'poster',
    'src',
    'xlink:href'
]);
function $d65c44bad72b4186$var$isDangerousUrl(value) {
    let normalizedValue = '';
    for (const char of value){
        const charCode = char.charCodeAt(0);
        if (charCode <= 32 || charCode === 127) continue;
        normalizedValue += char.toLowerCase();
    }
    return normalizedValue.startsWith('javascript:') || normalizedValue.startsWith('vbscript:');
}
function $d65c44bad72b4186$var$isElementNode(node) {
    return node.nodeType === Node.ELEMENT_NODE;
}
function $d65c44bad72b4186$var$isHtmlElement(node) {
    return $d65c44bad72b4186$var$isElementNode(node) && node instanceof HTMLElement;
}
function $d65c44bad72b4186$var$isBlockedCustomTextElement(node) {
    return $d65c44bad72b4186$var$isHtmlElement(node) && $d65c44bad72b4186$var$BLOCKED_CUSTOM_TEXT_TAGS.has(node.tagName.toLowerCase());
}
function $d65c44bad72b4186$var$sanitizeCustomHtmlElement(element) {
    const sanitizedElement = document.createElement(element.tagName.toLowerCase());
    Array.from(element.attributes).forEach((attribute)=>{
        const attributeName = attribute.name.toLowerCase();
        if (attributeName.startsWith('on') || attributeName === 'srcdoc') return;
        if ($d65c44bad72b4186$var$URL_ATTRIBUTES.has(attributeName) && $d65c44bad72b4186$var$isDangerousUrl(attribute.value)) return;
        sanitizedElement.setAttribute(attribute.name, attribute.value);
    });
    Array.from(element.childNodes).forEach((child)=>{
        sanitizedElement.append($d65c44bad72b4186$var$sanitizeCustomTextNode(child));
    });
    return sanitizedElement;
}
function $d65c44bad72b4186$var$sanitizeCustomTextNode(node) {
    var _a;
    if ($d65c44bad72b4186$var$isHtmlElement(node) && !$d65c44bad72b4186$var$isBlockedCustomTextElement(node)) return $d65c44bad72b4186$var$sanitizeCustomHtmlElement(node);
    return document.createTextNode((_a = node.textContent) !== null && _a !== void 0 ? _a : '');
}
function $d65c44bad72b4186$var$renderSafeCustomText(target, content) {
    const template = document.createElement('template');
    template.innerHTML = content;
    const sanitizedFragment = document.createDocumentFragment();
    Array.from(template.content.childNodes).forEach((child)=>{
        sanitizedFragment.append($d65c44bad72b4186$var$sanitizeCustomTextNode(child));
    });
    target.replaceChildren(sanitizedFragment);
}
function $d65c44bad72b4186$export$2e2bcd8739ae039() {
    const pageContext = (0, $fbc6612af3cafdd1$export$2e2bcd8739ae039)();
    (0, $5e5c9f2b3ce253bc$export$2e2bcd8739ae039)(pageContext, 'Unable to find Page context.');
    const { customTextRenderer: customTextRenderer, onGetTextError: onGetTextError, onGetTextSuccess: onGetTextSuccess, onRenderTextLayerError: onRenderTextLayerError, onRenderTextLayerSuccess: onRenderTextLayerSuccess, page: page, pageIndex: pageIndex, pageNumber: pageNumber, rotate: rotate, scale: scale } = pageContext;
    (0, $5e5c9f2b3ce253bc$export$2e2bcd8739ae039)(page, 'Attempted to load page text content, but no page was specified.');
    const [textContentState, textContentDispatch] = (0, $a34dcd306d539d3e$export$2e2bcd8739ae039)();
    const { value: textContent, error: textContentError } = textContentState;
    const layerElement = (0, $kc00y.useRef)(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($61fad0cb6b7e8586$exports)))(Number.parseInt(window.getComputedStyle(document.body).getPropertyValue('--react-pdf-text-layer'), 10) === 1, 'TextLayer styles not found. Read more: https://github.com/wojtekmaj/react-pdf#support-for-text-layer');
    /**
     * Called when a page text content is read successfully
     */ function onLoadSuccess() {
        if (!textContent) // Impossible, but TypeScript doesn't know that
        return;
        if (onGetTextSuccess) onGetTextSuccess(textContent);
    }
    /**
     * Called when a page text content failed to read successfully
     */ function onLoadError() {
        if (!textContentError) // Impossible, but TypeScript doesn't know that
        return;
        (0, (/*@__PURE__*/$parcel$interopDefault($61fad0cb6b7e8586$exports)))(false, textContentError.toString());
        if (onGetTextError) onGetTextError(textContentError);
    }
    // biome-ignore lint/correctness/useExhaustiveDependencies: useEffect intentionally triggered on page change
    (0, $kc00y.useEffect)(function resetTextContent() {
        textContentDispatch({
            type: 'RESET'
        });
    }, [
        page,
        textContentDispatch
    ]);
    (0, $kc00y.useEffect)(function loadTextContent() {
        if (!page) return;
        const cancellable = (0, $69f09258c42ac403$export$2e2bcd8739ae039)(page.getTextContent());
        const runningTask = cancellable;
        cancellable.promise.then((nextTextContent)=>{
            textContentDispatch({
                type: 'RESOLVE',
                value: nextTextContent
            });
        }).catch((error)=>{
            textContentDispatch({
                type: 'REJECT',
                error: error
            });
        });
        return ()=>(0, $879cffb8732180de$export$b8c3f1dffc289352)(runningTask);
    }, [
        page,
        textContentDispatch
    ]);
    // biome-ignore lint/correctness/useExhaustiveDependencies: Omitted callbacks so they are not called every time they change
    (0, $kc00y.useEffect)(()=>{
        if (textContent === undefined) return;
        if (textContent === false) {
            onLoadError();
            return;
        }
        onLoadSuccess();
    }, [
        textContent
    ]);
    /**
     * Called when a text layer is rendered successfully
     */ const onRenderSuccess = (0, $kc00y.useCallback)(()=>{
        if (onRenderTextLayerSuccess) onRenderTextLayerSuccess();
    }, [
        onRenderTextLayerSuccess
    ]);
    /**
     * Called when a text layer failed to render successfully
     */ const onRenderError = (0, $kc00y.useCallback)((error)=>{
        if ((0, $879cffb8732180de$export$ed392050f3fc5849)(error)) return;
        (0, (/*@__PURE__*/$parcel$interopDefault($61fad0cb6b7e8586$exports)))(false, error.toString());
        if (onRenderTextLayerError) onRenderTextLayerError(error);
    }, [
        onRenderTextLayerError
    ]);
    function onMouseDown() {
        const layer = layerElement.current;
        if (!layer) return;
        layer.classList.add('selecting');
    }
    function onMouseUp() {
        const layer = layerElement.current;
        if (!layer) return;
        layer.classList.remove('selecting');
    }
    const viewport = (0, $kc00y.useMemo)(()=>page.getViewport({
            scale: scale,
            rotation: rotate
        }), [
        page,
        rotate,
        scale
    ]);
    (0, $kc00y.useLayoutEffect)(function renderTextLayer() {
        if (!page || !textContent) return;
        const { current: layer } = layerElement;
        if (!layer) return;
        layer.innerHTML = '';
        const textContentSource = page.streamTextContent({
            includeMarkedContent: true
        });
        const parameters = {
            container: layer,
            textContentSource: textContentSource,
            viewport: viewport
        };
        const cancellable = new $9ef033443a74bee6$export$fdbdc423a78c5262(parameters);
        const runningTask = cancellable;
        cancellable.render().then(()=>{
            const end = document.createElement('div');
            end.className = 'endOfContent';
            layer.append(end);
            const layerChildren = layer.querySelectorAll('[role="presentation"]');
            if (customTextRenderer) {
                let index = 0;
                textContent.items.forEach((item, itemIndex)=>{
                    if (!$d65c44bad72b4186$var$isTextItem(item)) return;
                    const child = layerChildren[index];
                    if (!child) return;
                    const content = customTextRenderer({
                        pageIndex: pageIndex,
                        pageNumber: pageNumber,
                        itemIndex: itemIndex,
                        ...item
                    });
                    $d65c44bad72b4186$var$renderSafeCustomText(child, content);
                    index += item.str && item.hasEOL ? 2 : 1;
                });
            }
            // Intentional immediate callback
            onRenderSuccess();
        }).catch(onRenderError);
        return ()=>(0, $879cffb8732180de$export$b8c3f1dffc289352)(runningTask);
    }, [
        customTextRenderer,
        onRenderError,
        onRenderSuccess,
        page,
        pageIndex,
        pageNumber,
        textContent,
        viewport
    ]);
    return(// biome-ignore lint/a11y/noStaticElementInteractions: False positive caused by non interactive wrapper listening for bubbling events
    (0, $948296388fc3e3c9$exports.jsx)("div", {
        className: (0, $328c1c2632e2f292$export$2e2bcd8739ae039)('react-pdf__Page__textContent', 'textLayer'),
        onMouseUp: onMouseUp,
        onMouseDown: onMouseDown,
        ref: layerElement
    }));
}






'use client';
const $7e7c3557d007a551$var$defaultScale = 1;
function $7e7c3557d007a551$export$2e2bcd8739ae039(props) {
    const documentContext = (0, $3e74bdf76243a25d$export$2e2bcd8739ae039)();
    const mergedProps = {
        ...documentContext,
        ...props
    };
    const { _className: _className = 'react-pdf__Page', _enableRegisterUnregisterPage: _enableRegisterUnregisterPage = true, canvasBackground: canvasBackground, canvasRef: canvasRef, children: children, className: className, customRenderer: CustomRenderer, customTextRenderer: customTextRenderer, devicePixelRatio: devicePixelRatio, error: error = 'Failed to load the page.', filterAnnotations: filterAnnotations, height: height, inputRef: inputRef, loading: loading = "Loading page\u2026", noData: noData = 'No page specified.', onGetAnnotationsError: onGetAnnotationsErrorProps, onGetAnnotationsSuccess: onGetAnnotationsSuccessProps, onGetStructTreeError: onGetStructTreeErrorProps, onGetStructTreeSuccess: onGetStructTreeSuccessProps, onGetTextError: onGetTextErrorProps, onGetTextSuccess: onGetTextSuccessProps, onLoadError: onLoadErrorProps, onLoadSuccess: onLoadSuccessProps, onRenderAnnotationLayerError: onRenderAnnotationLayerErrorProps, onRenderAnnotationLayerSuccess: onRenderAnnotationLayerSuccessProps, onRenderError: onRenderErrorProps, onRenderSuccess: onRenderSuccessProps, onRenderTextLayerError: onRenderTextLayerErrorProps, onRenderTextLayerSuccess: onRenderTextLayerSuccessProps, pageColors: pageColors, pageIndex: pageIndexProps, pageNumber: pageNumberProps, pdf: pdf, registerPage: registerPage, renderAnnotationLayer: renderAnnotationLayerProps = true, renderForms: renderForms = false, renderMode: renderMode = 'canvas', renderTextLayer: renderTextLayerProps = true, rotate: rotateProps, scale: scaleProps = $7e7c3557d007a551$var$defaultScale, unregisterPage: unregisterPage, width: width, ...otherProps } = mergedProps;
    const [pageState, pageDispatch] = (0, $a34dcd306d539d3e$export$2e2bcd8739ae039)();
    const { value: page, error: pageError } = pageState;
    const pageElement = (0, $kc00y.useRef)(null);
    (0, $5e5c9f2b3ce253bc$export$2e2bcd8739ae039)(pdf, 'Attempted to load a page, but no document was specified. Wrap <Page /> in a <Document /> or pass explicit `pdf` prop.');
    const pageIndex = (0, $879cffb8732180de$export$ef8866826b0b1f6d)(pageNumberProps) ? pageNumberProps - 1 : pageIndexProps !== null && pageIndexProps !== void 0 ? pageIndexProps : null;
    const pageNumber = pageNumberProps !== null && pageNumberProps !== void 0 ? pageNumberProps : (0, $879cffb8732180de$export$ef8866826b0b1f6d)(pageIndexProps) ? pageIndexProps + 1 : null;
    const rotate = rotateProps !== null && rotateProps !== void 0 ? rotateProps : page ? page.rotate : null;
    const scale = (0, $kc00y.useMemo)(()=>{
        if (!page) return null;
        // Be default, we'll render page at 100% * scale width.
        let pageScale = 1;
        // Passing scale explicitly null would cause the page not to render
        const scaleWithDefault = scaleProps !== null && scaleProps !== void 0 ? scaleProps : $7e7c3557d007a551$var$defaultScale;
        // If width/height is defined, calculate the scale of the page so it could be of desired width.
        if (width || height) {
            const viewport = page.getViewport({
                scale: 1,
                rotation: rotate
            });
            if (width) pageScale = width / viewport.width;
            else if (height) pageScale = height / viewport.height;
        }
        return scaleWithDefault * pageScale;
    }, [
        height,
        page,
        rotate,
        scaleProps,
        width
    ]);
    // biome-ignore lint/correctness/useExhaustiveDependencies: useEffect intentionally triggered on pdf change
    (0, $kc00y.useEffect)(function hook() {
        return ()=>{
            if (!(0, $879cffb8732180de$export$ef8866826b0b1f6d)(pageIndex)) // Impossible, but TypeScript doesn't know that
            return;
            if (_enableRegisterUnregisterPage && unregisterPage) unregisterPage(pageIndex);
        };
    }, [
        _enableRegisterUnregisterPage,
        pdf,
        pageIndex,
        unregisterPage
    ]);
    /**
     * Called when a page is loaded successfully
     */ function onLoadSuccess() {
        if (onLoadSuccessProps) {
            if (!page || !scale) // Impossible, but TypeScript doesn't know that
            return;
            onLoadSuccessProps((0, $879cffb8732180de$export$8cc3f6b8d58bdda0)(page, scale));
        }
        if (_enableRegisterUnregisterPage && registerPage) {
            if (!(0, $879cffb8732180de$export$ef8866826b0b1f6d)(pageIndex) || !pageElement.current) // Impossible, but TypeScript doesn't know that
            return;
            registerPage(pageIndex, pageElement.current);
        }
    }
    /**
     * Called when a page failed to load
     */ function onLoadError() {
        if (!pageError) // Impossible, but TypeScript doesn't know that
        return;
        (0, (/*@__PURE__*/$parcel$interopDefault($61fad0cb6b7e8586$exports)))(false, pageError.toString());
        if (onLoadErrorProps) onLoadErrorProps(pageError);
    }
    // biome-ignore lint/correctness/useExhaustiveDependencies: useEffect intentionally triggered on pdf and pageIndex change
    (0, $kc00y.useEffect)(function resetPage() {
        pageDispatch({
            type: 'RESET'
        });
    }, [
        pageDispatch,
        pdf,
        pageIndex
    ]);
    (0, $kc00y.useEffect)(function loadPage() {
        if (!pdf || !pageNumber) return;
        const cancellable = (0, $69f09258c42ac403$export$2e2bcd8739ae039)(pdf.getPage(pageNumber));
        const runningTask = cancellable;
        cancellable.promise.then((nextPage)=>{
            pageDispatch({
                type: 'RESOLVE',
                value: nextPage
            });
        }).catch((error)=>{
            pageDispatch({
                type: 'REJECT',
                error: error
            });
        });
        return ()=>(0, $879cffb8732180de$export$b8c3f1dffc289352)(runningTask);
    }, [
        pageDispatch,
        pdf,
        pageNumber
    ]);
    // biome-ignore lint/correctness/useExhaustiveDependencies: Omitted callbacks so they are not called every time they change
    (0, $kc00y.useEffect)(()=>{
        if (page === undefined) return;
        if (page === false) {
            onLoadError();
            return;
        }
        onLoadSuccess();
    }, [
        page,
        scale
    ]);
    const childContext = (0, $kc00y.useMemo)(()=>// Technically there cannot be page without pageIndex, pageNumber, rotate and scale, but TypeScript doesn't know that
        (0, $879cffb8732180de$export$ef8866826b0b1f6d)(pageIndex) && pageNumber && (0, $879cffb8732180de$export$ef8866826b0b1f6d)(rotate) && (0, $879cffb8732180de$export$ef8866826b0b1f6d)(scale) ? {
            _className: _className,
            canvasBackground: canvasBackground,
            customTextRenderer: customTextRenderer,
            devicePixelRatio: devicePixelRatio,
            filterAnnotations: filterAnnotations,
            onGetAnnotationsError: onGetAnnotationsErrorProps,
            onGetAnnotationsSuccess: onGetAnnotationsSuccessProps,
            onGetStructTreeError: onGetStructTreeErrorProps,
            onGetStructTreeSuccess: onGetStructTreeSuccessProps,
            onGetTextError: onGetTextErrorProps,
            onGetTextSuccess: onGetTextSuccessProps,
            onRenderAnnotationLayerError: onRenderAnnotationLayerErrorProps,
            onRenderAnnotationLayerSuccess: onRenderAnnotationLayerSuccessProps,
            onRenderError: onRenderErrorProps,
            onRenderSuccess: onRenderSuccessProps,
            onRenderTextLayerError: onRenderTextLayerErrorProps,
            onRenderTextLayerSuccess: onRenderTextLayerSuccessProps,
            page: page,
            pageColors: pageColors,
            pageIndex: pageIndex,
            pageNumber: pageNumber,
            renderForms: renderForms,
            renderTextLayer: renderTextLayerProps,
            rotate: rotate,
            scale: scale
        } : null, [
        _className,
        canvasBackground,
        customTextRenderer,
        devicePixelRatio,
        filterAnnotations,
        onGetAnnotationsErrorProps,
        onGetAnnotationsSuccessProps,
        onGetStructTreeErrorProps,
        onGetStructTreeSuccessProps,
        onGetTextErrorProps,
        onGetTextSuccessProps,
        onRenderAnnotationLayerErrorProps,
        onRenderAnnotationLayerSuccessProps,
        onRenderErrorProps,
        onRenderSuccessProps,
        onRenderTextLayerErrorProps,
        onRenderTextLayerSuccessProps,
        page,
        pageColors,
        pageIndex,
        pageNumber,
        renderForms,
        renderTextLayerProps,
        rotate,
        scale
    ]);
    const eventProps = (0, $kc00y.useMemo)(()=>(0, $4c01b1fb52e31b15$export$2e2bcd8739ae039)(otherProps, ()=>page ? scale ? (0, $879cffb8732180de$export$8cc3f6b8d58bdda0)(page, scale) : undefined : page), // biome-ignore lint/correctness/useExhaustiveDependencies: FIXME
    [
        otherProps,
        page,
        scale
    ]);
    const pageKey = `${pageIndex}@${scale}/${rotate}`;
    function renderMainLayer() {
        switch(renderMode){
            case 'custom':
                (0, $5e5c9f2b3ce253bc$export$2e2bcd8739ae039)(CustomRenderer, `renderMode was set to "custom", but no customRenderer was passed.`);
                return (0, $948296388fc3e3c9$exports.jsx)(CustomRenderer, {}, `${pageKey}_custom`);
            case 'none':
                return null;
            case 'canvas':
            default:
                return (0, $948296388fc3e3c9$exports.jsx)((0, $e5b7ad1e573e5470$export$2e2bcd8739ae039), {
                    canvasRef: canvasRef
                }, `${pageKey}_canvas`);
        }
    }
    function renderTextLayer() {
        if (!renderTextLayerProps) return null;
        return (0, $948296388fc3e3c9$exports.jsx)((0, $d65c44bad72b4186$export$2e2bcd8739ae039), {}, `${pageKey}_text`);
    }
    function renderAnnotationLayer() {
        if (!renderAnnotationLayerProps) return null;
        return (0, $948296388fc3e3c9$exports.jsx)((0, $2d94e2ef29c83ebf$export$2e2bcd8739ae039), {}, `${pageKey}_annotations`);
    }
    function renderChildren() {
        function isFulfilledContext(context) {
            return Boolean(context === null || context === void 0 ? void 0 : context.page);
        }
        if (!isFulfilledContext(childContext)) // Impossible, but TypeScript doesn't know that
        throw new Error('page is undefined');
        const resolvedChildren = typeof children === 'function' ? children(childContext) : children;
        return (0, $948296388fc3e3c9$exports.jsxs)((0, $cdfb0451857bfb00$export$2e2bcd8739ae039).Provider, {
            value: childContext,
            children: [
                renderMainLayer(),
                renderTextLayer(),
                renderAnnotationLayer(),
                resolvedChildren
            ]
        });
    }
    function renderContent() {
        if (!pageNumber) return (0, $948296388fc3e3c9$exports.jsx)((0, $e7f15cbf32c73f6e$export$2e2bcd8739ae039), {
            type: "no-data",
            children: typeof noData === 'function' ? noData() : noData
        });
        if (pdf === null || page === undefined || page === null) return (0, $948296388fc3e3c9$exports.jsx)((0, $e7f15cbf32c73f6e$export$2e2bcd8739ae039), {
            type: "loading",
            children: typeof loading === 'function' ? loading() : loading
        });
        if (pdf === false || page === false) return (0, $948296388fc3e3c9$exports.jsx)((0, $e7f15cbf32c73f6e$export$2e2bcd8739ae039), {
            type: "error",
            children: typeof error === 'function' ? error() : error
        });
        return renderChildren();
    }
    return (0, $948296388fc3e3c9$exports.jsx)("div", {
        className: (0, $328c1c2632e2f292$export$2e2bcd8739ae039)(_className, className),
        "data-page-number": pageNumber,
        // Assertion is needed for React 18 compatibility
        ref: (0, $e61890c2b95ac494$export$2e2bcd8739ae039)(inputRef, pageElement),
        style: {
            '--scale-round-x': '1px',
            '--scale-round-y': '1px',
            '--scale-factor': '1',
            '--user-unit': `${scale}`,
            '--total-scale-factor': 'calc(var(--scale-factor) * var(--user-unit))',
            backgroundColor: canvasBackground || 'white',
            position: 'relative',
            minWidth: 'min-content',
            minHeight: 'min-content'
        },
        ...eventProps,
        children: renderContent()
    });
}






var $c86cc77fa4053743$exports = {};

$parcel$export($c86cc77fa4053743$exports, "container", () => $c86cc77fa4053743$export$34e0f9847d4c02dd, (v) => $c86cc77fa4053743$export$34e0f9847d4c02dd = v);
$parcel$export($c86cc77fa4053743$exports, "containerError", () => $c86cc77fa4053743$export$b42883fa2b07538b, (v) => $c86cc77fa4053743$export$b42883fa2b07538b = v);
$parcel$export($c86cc77fa4053743$exports, "contentWrapper", () => $c86cc77fa4053743$export$2a82ddc22e8c7fbb, (v) => $c86cc77fa4053743$export$2a82ddc22e8c7fbb = v);
$parcel$export($c86cc77fa4053743$exports, "document", () => $c86cc77fa4053743$export$5a7bfc01df82fcd1, (v) => $c86cc77fa4053743$export$5a7bfc01df82fcd1 = v);
$parcel$export($c86cc77fa4053743$exports, "errorPdf", () => $c86cc77fa4053743$export$d4e5d41b172d90c1, (v) => $c86cc77fa4053743$export$d4e5d41b172d90c1 = v);
$parcel$export($c86cc77fa4053743$exports, "header", () => $c86cc77fa4053743$export$38e42c68cf43b5d4, (v) => $c86cc77fa4053743$export$38e42c68cf43b5d4 = v);
$parcel$export($c86cc77fa4053743$exports, "page", () => $c86cc77fa4053743$export$523fb3936f49e028, (v) => $c86cc77fa4053743$export$523fb3936f49e028 = v);
$parcel$export($c86cc77fa4053743$exports, "pageInfo", () => $c86cc77fa4053743$export$75dd9d864eb27da7, (v) => $c86cc77fa4053743$export$75dd9d864eb27da7 = v);
$parcel$export($c86cc77fa4053743$exports, "pageInput", () => $c86cc77fa4053743$export$7c4b06eeb46b588b, (v) => $c86cc77fa4053743$export$7c4b06eeb46b588b = v);
$parcel$export($c86cc77fa4053743$exports, "pageNavigation", () => $c86cc77fa4053743$export$e6dcc0f0935f9e6f, (v) => $c86cc77fa4053743$export$e6dcc0f0935f9e6f = v);
$parcel$export($c86cc77fa4053743$exports, "scrollContainer", () => $c86cc77fa4053743$export$fad3c8302a7540c6, (v) => $c86cc77fa4053743$export$fad3c8302a7540c6 = v);
$parcel$export($c86cc77fa4053743$exports, "thumbnailItem", () => $c86cc77fa4053743$export$9293d2a53555f4cf, (v) => $c86cc77fa4053743$export$9293d2a53555f4cf = v);
$parcel$export($c86cc77fa4053743$exports, "thumbnailLabel", () => $c86cc77fa4053743$export$3cd852fae42514f9, (v) => $c86cc77fa4053743$export$3cd852fae42514f9 = v);
$parcel$export($c86cc77fa4053743$exports, "thumbnailsSidebar", () => $c86cc77fa4053743$export$d58229a6a573eec9, (v) => $c86cc77fa4053743$export$d58229a6a573eec9 = v);
var $c86cc77fa4053743$export$34e0f9847d4c02dd;
var $c86cc77fa4053743$export$b42883fa2b07538b;
var $c86cc77fa4053743$export$2a82ddc22e8c7fbb;
var $c86cc77fa4053743$export$5a7bfc01df82fcd1;
var $c86cc77fa4053743$export$d4e5d41b172d90c1;
var $c86cc77fa4053743$export$38e42c68cf43b5d4;
var $c86cc77fa4053743$export$523fb3936f49e028;
var $c86cc77fa4053743$export$75dd9d864eb27da7;
var $c86cc77fa4053743$export$7c4b06eeb46b588b;
var $c86cc77fa4053743$export$e6dcc0f0935f9e6f;
var $c86cc77fa4053743$export$fad3c8302a7540c6;
var $c86cc77fa4053743$export$9293d2a53555f4cf;
var $c86cc77fa4053743$export$3cd852fae42514f9;
var $c86cc77fa4053743$export$d58229a6a573eec9;
$c86cc77fa4053743$export$34e0f9847d4c02dd = `YTcxFa_container`;
$c86cc77fa4053743$export$b42883fa2b07538b = `YTcxFa_containerError`;
$c86cc77fa4053743$export$2a82ddc22e8c7fbb = `YTcxFa_contentWrapper`;
$c86cc77fa4053743$export$5a7bfc01df82fcd1 = `YTcxFa_document`;
$c86cc77fa4053743$export$d4e5d41b172d90c1 = `YTcxFa_errorPdf`;
$c86cc77fa4053743$export$38e42c68cf43b5d4 = `YTcxFa_header`;
$c86cc77fa4053743$export$523fb3936f49e028 = `YTcxFa_page`;
$c86cc77fa4053743$export$75dd9d864eb27da7 = `YTcxFa_pageInfo`;
$c86cc77fa4053743$export$7c4b06eeb46b588b = `YTcxFa_pageInput`;
$c86cc77fa4053743$export$e6dcc0f0935f9e6f = `YTcxFa_pageNavigation`;
$c86cc77fa4053743$export$fad3c8302a7540c6 = `YTcxFa_scrollContainer`;
$c86cc77fa4053743$export$9293d2a53555f4cf = `YTcxFa_thumbnailItem`;
$c86cc77fa4053743$export$3cd852fae42514f9 = `YTcxFa_thumbnailLabel`;
$c86cc77fa4053743$export$d58229a6a573eec9 = `YTcxFa_thumbnailsSidebar`;


var $a2bbb520b4e92258$exports = {};
$a2bbb520b4e92258$exports = $parcel$resolve("4EvLf");


// Configuration du worker PDF.js
// Le fichier pdf.worker.min.js est déjà généré dans le build par Parcel
(0, $9ef033443a74bee6$exports).GlobalWorkerOptions.workerSrc = new URL($a2bbb520b4e92258$exports).toString();
const $93ca399ee1d0df0f$var$PdfViewer = ({ url: url })=>{
    const [numPages, setNumPages] = (0, $kc00y.useState)(null);
    const [pageInput, setPageInput] = (0, $kc00y.useState)("");
    const [isFullscreen, setIsFullscreen] = (0, $kc00y.useState)(false);
    const [showThumbnails, setShowThumbnails] = (0, $kc00y.useState)(false);
    const [scale, setScale] = (0, $kc00y.useState)(1);
    const containerRef = (0, $kc00y.useRef)(null);
    const pageRefs = (0, $kc00y.useRef)(new Map());
    const options = (0, $kc00y.useMemo)(()=>({
            cMapUrl: `cmaps/`,
            cMapPacked: true,
            standardFontDataUrl: `standard_fonts/`
        }), []);
    // On met en cache le fichier pour éviter trop d'appels HTTP
    const fileConfig = (0, $kc00y.useMemo)(()=>({
            url: url
        }), [
        url
    ]);
    function onDocumentLoadSuccess({ numPages: numPages }) {
        setNumPages(numPages);
    }
    const toggleFullscreen = async ()=>{
        if (!containerRef.current) return;
        if (!document.fullscreenElement) // Entrer en plein écran
        await containerRef.current.requestFullscreen();
        else // Sortir du plein écran
        await document.exitFullscreen();
    };
    // Écouter les changements de plein écran
    (0, $kc00y.useEffect)(()=>{
        const handleFullscreenChange = ()=>{
            setIsFullscreen(!!document.fullscreenElement);
        };
        document.addEventListener("fullscreenchange", handleFullscreenChange);
        return ()=>{
            document.removeEventListener("fullscreenchange", handleFullscreenChange);
        };
    }, []);
    const goToPage = (pageNumber)=>{
        if (pageNumber >= 1 && pageNumber <= (numPages ?? 0)) {
            const pageElement = pageRefs.current.get(pageNumber);
            if (pageElement) pageElement.scrollIntoView({
                behavior: "smooth",
                block: "start"
            });
        }
    };
    const handlePageInputChange = (e)=>{
        const value = e.target.value;
        setPageInput(value);
    };
    const handleGoToPageClick = ()=>{
        const pageNum = parseInt(pageInput);
        if (!isNaN(pageNum)) goToPage(pageNum);
    };
    const handleZoomIn = ()=>{
        setScale((prevScale)=>Math.min(prevScale + 0.2, 2));
    };
    const handleZoomOut = ()=>{
        setScale((prevScale)=>Math.max(prevScale - 0.2, 0.5));
    };
    const handleResetZoom = ()=>{
        setScale(1);
    };
    const renderError = ()=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($c86cc77fa4053743$exports))).containerError,
            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("p", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($c86cc77fa4053743$exports))).errorPdf,
                children: "Erreur lors du chargement du document"
            })
        });
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
        ref: containerRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($c86cc77fa4053743$exports))).container,
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($c86cc77fa4053743$exports))).header,
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                                    tooltipId: "download-tooltip",
                                    tooltipText: "T\xe9l\xe9charger le PDF",
                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                                        href: url,
                                        target: "_blank",
                                        className: isFullscreen ? "btn bg-white text-primary" : "btn btn-primary",
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$4a5ccdc9878f4668), {})
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                                    tooltipId: "print-tooltip",
                                    tooltipText: "Imprimer le PDF",
                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                                        onClick: ()=>window.print(),
                                        className: isFullscreen ? "btn bg-white text-primary" : "btn btn-primary",
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$61207fb985d79449), {})
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                                    tooltipId: "fullscreen-tooltip",
                                    tooltipText: isFullscreen ? "Quitter le plein \xe9cran" : "Plein \xe9cran",
                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                                        onClick: toggleFullscreen,
                                        className: isFullscreen ? "btn bg-white text-primary" : "btn btn-primary",
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$e817ff83c15c44f9), {})
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                                    tooltipId: "thumbnails-tooltip",
                                    tooltipText: showThumbnails ? "Masquer les miniatures" : "Afficher les miniatures",
                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                                        onClick: ()=>setShowThumbnails(!showThumbnails),
                                        className: isFullscreen ? "btn bg-white text-primary" : "btn btn-primary",
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$527d32aa1785fdd4), {})
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                                    tooltipId: "zoom-in-tooltip",
                                    tooltipText: "Agrandir",
                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                                        onClick: handleZoomIn,
                                        className: isFullscreen ? "btn bg-white text-primary" : "btn btn-primary",
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$279925e52ecb7067), {})
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                                    tooltipId: "zoom-out-tooltip",
                                    tooltipText: "R\xe9duire",
                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                                        onClick: handleZoomOut,
                                        className: isFullscreen ? "btn bg-white text-primary" : "btn btn-primary",
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$8a3fa2b294d0816a), {})
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                                    tooltipId: "zoom-reset-tooltip",
                                    tooltipText: "R\xe9initialiser le zoom",
                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                                        onClick: handleResetZoom,
                                        className: isFullscreen ? "btn bg-white text-primary" : "btn btn-primary",
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$c1a4ecc4992509c4), {})
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($c86cc77fa4053743$exports))).pageNavigation,
                                    children: [
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("input", {
                                            type: "number",
                                            min: "1",
                                            max: numPages ?? 1,
                                            value: pageInput,
                                            onChange: handlePageInputChange,
                                            placeholder: "Page",
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($c86cc77fa4053743$exports))).pageInput
                                        }),
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                                            onClick: handleGoToPageClick,
                                            size: "sm",
                                            className: "bg-primary",
                                            children: "Aller"
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    numPages && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($c86cc77fa4053743$exports))).pageInfo,
                        children: [
                            "Total : ",
                            numPages,
                            " page",
                            numPages > 1 ? "s" : ""
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($c86cc77fa4053743$exports))).contentWrapper,
                children: [
                    showThumbnails && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($c86cc77fa4053743$exports))).thumbnailsSidebar,
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $92b61959d6e2028b$export$2e2bcd8739ae039), {
                            file: fileConfig,
                            onLoadSuccess: onDocumentLoadSuccess,
                            options: options,
                            children: numPages && Array.from({
                                length: numPages
                            }, (_, index)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($c86cc77fa4053743$exports))).thumbnailItem,
                                    onClick: ()=>goToPage(index + 1),
                                    children: [
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $7e7c3557d007a551$export$2e2bcd8739ae039), {
                                            pageNumber: index + 1,
                                            width: 100,
                                            renderTextLayer: false,
                                            renderAnnotationLayer: false
                                        }),
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($c86cc77fa4053743$exports))).thumbnailLabel,
                                            children: [
                                                "Page ",
                                                index + 1
                                            ]
                                        })
                                    ]
                                }, `thumb_${index + 1}`))
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($c86cc77fa4053743$exports))).scrollContainer,
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $92b61959d6e2028b$export$2e2bcd8739ae039), {
                            file: fileConfig,
                            onLoadSuccess: onDocumentLoadSuccess,
                            loading: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                children: "Chargement du PDF..."
                            }),
                            error: renderError,
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($c86cc77fa4053743$exports))).document,
                            options: options,
                            children: numPages && Array.from({
                                length: numPages
                            }, (_, index)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $7e7c3557d007a551$export$2e2bcd8739ae039), {
                                    pageNumber: index + 1,
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($c86cc77fa4053743$exports))).page,
                                    scale: scale,
                                    inputRef: (ref)=>{
                                        if (ref) pageRefs.current.set(index + 1, ref);
                                    }
                                }, `page_${index + 1}`))
                        })
                    })
                ]
            })
        ]
    });
};
var $93ca399ee1d0df0f$export$2e2bcd8739ae039 = $93ca399ee1d0df0f$var$PdfViewer;



const $4787a1f0373e38b8$var$ViewCourrier = ()=>{
    const { urlCourrier: urlCourrier } = (0, $f023788f0719ca00$export$8e0be626868f6969)();
    if (urlCourrier == null) return;
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $93ca399ee1d0df0f$export$2e2bcd8739ae039), {
            url: urlCourrier.url
        })
    });
};
var $4787a1f0373e38b8$export$2e2bcd8739ae039 = $4787a1f0373e38b8$var$ViewCourrier;










var $bkJfK = parcelRequire("bkJfK");







const $e295feb9a7a7a3c0$export$a5cab80145b70e98 = (data)=>({
        typeEtudeId: data?.typeEtudeId ?? null,
        etudeNumero: data?.etudeNumero ?? null,
        etudeLibelle: data?.etudeLibelle ?? null,
        etudeDescription: data?.etudeDescription ?? null,
        listeCommuneId: data?.listeCommuneId ?? null,
        documents: data?.documents ?? []
    });
const $e295feb9a7a7a3c0$export$c084437b5e3206cd = (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({});
const $e295feb9a7a7a3c0$export$f97400759cfd946 = (values, initialData)=>{
    const formData = new FormData();
    (0, $69d686b1e97c5ea6$export$3f0f08502708410b)(values?.documents, initialData?.documents || [], formData);
    formData.append("typeEtudeId", values.typeEtudeId);
    formData.append("etudeNumero", values.etudeNumero);
    formData.append("etudeLibelle", values.etudeLibelle);
    values.etudeDescription && formData.append("etudeDescription", values.etudeDescription);
    formData.append("listeCommuneId", JSON.stringify(values.listeCommuneId));
    return formData;
};
const $e295feb9a7a7a3c0$var$Etude = ()=>{
    const { setValues: setValues, setFieldValue: setFieldValue, values: values } = (0, $bkJfK.useFormikContext)();
    const typeEtudeState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/couverture-hydraulique/type-etudes`);
    const communeState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/commune/get-libelle-commune`);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
            children: [
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("h3", {
                    className: "mt-1",
                    children: "Informations g\xe9n\xe9rales"
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                    name: "typeEtudeId",
                    listIdCodeLibelle: typeEtudeState?.data,
                    label: "Type de l'\xe9tude",
                    defaultValue: typeEtudeState?.data?.find((e)=>e.id === values.typeEtudeId),
                    required: true,
                    setValues: setValues
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                    label: "R\xe9f\xe9rence",
                    name: "etudeNumero",
                    required: true
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                    label: "Libell\xe9",
                    name: "etudeLibelle",
                    required: true
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$ce9b1cc0c34506d0), {
                    name: "etudeDescription",
                    label: "Description",
                    required: false
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("h3", {
                    className: "mt-5",
                    children: "Communes de l'\xe9tude"
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$eae70af4b4e3f197), {
                    name: "listeCommune",
                    label: "Liste des communes de l'\xe9tude",
                    options: communeState?.data,
                    getOptionValue: (t)=>t.id,
                    getOptionLabel: (t)=>t.libelle,
                    value: values?.listeCommuneId?.map((e)=>communeState?.data?.find((c)=>c.id === e)) ?? undefined,
                    onChange: (commune)=>{
                        const communeId = commune.map((e)=>e.id);
                        communeId.length > 0 ? setFieldValue("listeCommuneId", communeId) : setFieldValue("listeCommuneId", undefined);
                    },
                    isClearable: true
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("h3", {
                    className: "mt-5",
                    children: "Documents li\xe9s \xe0 l'\xe9tude"
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $69d686b1e97c5ea6$export$2e2bcd8739ae039), {
                    documents: values.documents,
                    setFieldValue: setFieldValue,
                    otherFormParam: (index)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                                label: "Nom",
                                name: `documents[${index}].etudeDocumentLibelle`,
                                required: false
                            })
                        }),
                    defaultOtherProperties: {
                        letudeDocumentLibelle: null
                    }
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db9b0e6fdb142a4c$export$2e2bcd8739ae039), {})
            ]
        })
    });
};
var $e295feb9a7a7a3c0$export$2e2bcd8739ae039 = $e295feb9a7a7a3c0$var$Etude;


const $295dcd157ddd4a4f$var$CreateEtude = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$3caee6c66795d211), {}),
                title: "Cr\xe9ation d'une \xe9tude"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                initialValues: (0, $e295feb9a7a7a3c0$export$a5cab80145b70e98)(),
                validationSchema: (0, $e295feb9a7a7a3c0$export$c084437b5e3206cd),
                isPost: true,
                isMultipartFormData: true,
                submitUrl: `/api/couverture-hydraulique/etude/create/`,
                prepareVariables: (values)=>(0, $e295feb9a7a7a3c0$export$f97400759cfd946)(values),
                redirectUrl: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_ETUDE,
                onSubmit: ()=>null,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e295feb9a7a7a3c0$export$2e2bcd8739ae039), {})
            })
        ]
    });
};
var $295dcd157ddd4a4f$export$2e2bcd8739ae039 = $295dcd157ddd4a4f$var$CreateEtude;




var $bkJfK = parcelRequire("bkJfK");









const $e796e0d50f5e3eb7$export$a5cab80145b70e98 = ()=>({
        fileReseau: null,
        fileBatiment: null,
        filePeiProjet: null
    });
const $e796e0d50f5e3eb7$export$c084437b5e3206cd = (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({});
const $e796e0d50f5e3eb7$export$f97400759cfd946 = (values)=>{
    const formData = new FormData();
    if (values.fileReseau) formData.append("fileReseau", values.fileReseau);
    if (values.fileBatiment) formData.append("fileBatiment", values.fileBatiment);
    if (values.filePeiProjet) formData.append("filePeiProjet", values.filePeiProjet);
    return formData;
};
const $e796e0d50f5e3eb7$var$ImportShapeEtude = ()=>{
    const { etudeId: etudeId } = (0, $7a844823b04d4282$export$99eaa27ddbbb95ef)();
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$c9bef5de7ad5da31), {}),
                title: "Importer des fichiers shape pour l'\xe9tude"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                initialValues: $e796e0d50f5e3eb7$export$a5cab80145b70e98(),
                validationSchema: $e796e0d50f5e3eb7$export$c084437b5e3206cd,
                isPost: false,
                isMultipartFormData: true,
                submitUrl: `/api/couverture-hydraulique/import/` + etudeId,
                prepareVariables: (values)=>$e796e0d50f5e3eb7$export$f97400759cfd946(values),
                // TODO redirect vers la carte
                redirectUrl: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_ETUDE,
                onSubmit: ()=>null,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($e796e0d50f5e3eb7$var$FormImportShape, {})
            })
        ]
    });
};
const $e796e0d50f5e3eb7$var$FormImportShape = ()=>{
    const { setFieldValue: setFieldValue } = (0, $bkJfK.useFormikContext)();
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b57af79a4ab2a1c6), {
                name: "fileReseau",
                accept: ".zip",
                label: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                    children: [
                        "Fichier zip contenant le r\xe9seau routier",
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                            placement: "right",
                            tooltipText: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("strong", {
                                                children: [
                                                    "the_geom ",
                                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("span", {
                                                        className: "text-danger",
                                                        children: "*"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                                className: "ms-2",
                                                children: "La g\xe9om\xe9trie en LineString en projection EPSG:2154 (RGF93 / Lambert-93)"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("strong", {
                                                children: [
                                                    "traversabl ",
                                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("span", {
                                                        className: "text-danger",
                                                        children: "*"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                                className: "ms-2",
                                                children: "La voie est-elle traversable ?"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("strong", {
                                                children: [
                                                    "sensUniqu ",
                                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("span", {
                                                        className: "text-danger",
                                                        children: "*"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                                className: "ms-2",
                                                children: "La voie est-elle en sens unique ?"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                                                children: "niveau"
                                            }),
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                                className: "ms-2",
                                                children: "Le niveau de la voie, un entier."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("span", {
                                                    className: "text-danger",
                                                    children: "*"
                                                }),
                                                " : Champs obligatoires"
                                            ]
                                        })
                                    })
                                ]
                            }),
                            tooltipHeader: "Colonnes attendues",
                            tooltipId: "reseau",
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$340bfce9b4df026b), {})
                        })
                    ]
                }),
                required: false,
                onChange: (e)=>setFieldValue("fileReseau", e.target.files[0])
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b57af79a4ab2a1c6), {
                name: "fileBatiment",
                accept: ".zip",
                label: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                    children: [
                        "Fichier zip contenant les b\xe2timents",
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                            placement: "right",
                            tooltipText: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("strong", {
                                                children: [
                                                    "the_geom ",
                                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("span", {
                                                        className: "text-danger",
                                                        children: "*"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                                className: "ms-2",
                                                children: "La g\xe9om\xe9trie du b\xe2timent en projection EPSG:2154 (RGF93 / Lambert-93)"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("span", {
                                                    className: "text-danger",
                                                    children: "*"
                                                }),
                                                " : Champs obligatoires"
                                            ]
                                        })
                                    })
                                ]
                            }),
                            tooltipId: "batiment",
                            tooltipHeader: "Colonnes attendues",
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$340bfce9b4df026b), {})
                        })
                    ]
                }),
                required: false,
                onChange: (e)=>setFieldValue("fileBatiment", e.target.files[0])
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b57af79a4ab2a1c6), {
                name: "filePeiProjet",
                accept: ".zip",
                label: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                    children: [
                        "Fichier zip contenant les PEI en projet",
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                            placement: "right",
                            tooltipText: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("strong", {
                                                children: [
                                                    "the_geom ",
                                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("span", {
                                                        className: "text-danger",
                                                        children: "*"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                                className: "ms-2",
                                                children: "La g\xe9om\xe9trie en Point en projection EPSG:2154 (RGF93 / Lambert-93)"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("strong", {
                                                children: [
                                                    "natureDeci ",
                                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("span", {
                                                        className: "text-danger",
                                                        children: "*"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                                className: "ms-2",
                                                children: "Le code de la nature DECI pr\xe9sent en base dans la table remocra.nature_deci (PUBLIC, PRIVE, CONVENTIONNE, ICPE, ICPE_CONVENTIONNE ...)"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("strong", {
                                                children: [
                                                    "type ",
                                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("span", {
                                                        className: "text-danger",
                                                        children: "*"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                                                className: "ms-2",
                                                children: [
                                                    " ",
                                                    'Le type de PEI en projet. Doit \xeatre \xe9gal \xe0 "PA", "PIBI" ou "RESERVE".'
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                                                children: "diametreNo"
                                            }),
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                                className: "ms-2",
                                                children: "Le code de diam\xe8tre nominal pr\xe9sent en base dans remocra.diametre. A renseigner s'il s'agit d'un PIBI."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                                                children: "diametreCa"
                                            }),
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                                className: "ms-2",
                                                children: "Le diam\xe8tre de canalisation, un entier. A renseigner s'il s'agit d'un PIBI."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                                                children: "capacite"
                                            }),
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                                className: "ms-2",
                                                children: "La capacit\xe9 en entier. A renseigner s'il s'agit d'une RESERVE."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                                                children: "debit"
                                            }),
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                                className: "ms-2",
                                                children: "La d\xe9bit en entier. A renseigner s'il s'agit d'une RESERVE ou d'un PA."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("span", {
                                                    className: "text-danger",
                                                    children: "*"
                                                }),
                                                " : Champs obligatoires"
                                            ]
                                        })
                                    })
                                ]
                            }),
                            tooltipHeader: "Colonnes attendues",
                            tooltipId: "peiProjet",
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$340bfce9b4df026b), {})
                        })
                    ]
                }),
                required: false,
                onChange: (e)=>setFieldValue("filePeiProjet", e.target.files[0])
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                className: "mt-3",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                    className: "text-center",
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                        type: "submit",
                        variant: "primary",
                        children: "Valider"
                    })
                })
            })
        ]
    });
};
var $e796e0d50f5e3eb7$export$2e2bcd8739ae039 = $e796e0d50f5e3eb7$var$ImportShapeEtude;

















var $68f492479dc8d251$var$EtudeStatutEnum = /*#__PURE__*/ function(EtudeStatutEnum) {
    EtudeStatutEnum["EN_COURS"] = "En cours";
    EtudeStatutEnum["TERMINEE"] = "Termin\xe9e";
    return EtudeStatutEnum;
}($68f492479dc8d251$var$EtudeStatutEnum || {});
var $68f492479dc8d251$export$2e2bcd8739ae039 = $68f492479dc8d251$var$EtudeStatutEnum;






const $73e72cc56a5bcc5c$var$filterValuesToVariable = ({ typeEtudeId: typeEtudeId, etudeNumero: etudeNumero, etudeLibelle: etudeLibelle, etudeDescription: etudeDescription, etudeStatut: etudeStatut })=>{
    const filter = {};
    $73e72cc56a5bcc5c$var$filterPropertyEtude(filter, typeEtudeId, "typeEtudeId");
    $73e72cc56a5bcc5c$var$filterPropertyEtude(filter, etudeNumero, "etudeNumero");
    $73e72cc56a5bcc5c$var$filterPropertyEtude(filter, etudeLibelle, "etudeLibelle");
    $73e72cc56a5bcc5c$var$filterPropertyEtude(filter, etudeDescription, "etudeDescription");
    $73e72cc56a5bcc5c$var$filterPropertyEtude(filter, etudeStatut, "etudeStatut");
    return filter;
};
var $73e72cc56a5bcc5c$export$2e2bcd8739ae039 = $73e72cc56a5bcc5c$var$filterValuesToVariable;
function $73e72cc56a5bcc5c$var$filterPropertyEtude(filter, value, name) {
    if (value != null && value.trim() !== "") filter[name] = value;
}


const $305d863cb857dd07$var$ListEtude = ()=>{
    const typeEtudeState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/couverture-hydraulique/type-etudes`);
    const { user: user } = (0, $e787cde576104469$export$fdc397e486fa83e7)();
    const { fetchGeometry: fetchGeometry } = (0, $a178c3075f0f40bb$export$2e2bcd8739ae039)();
    const listeButton = [];
    if ((0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ETUDE_R)) listeButton.push({
        row: (row)=>{
            return row;
        },
        onClick: (etudeId, row)=>{
            if (row.listeCommune.length > 0) fetchGeometry((0, $a178c3075f0f40bb$export$970c58a942355206).COMMUNE_ETUDE, etudeId, (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).OUVRIR_ETUDE(etudeId));
        },
        type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).LINK,
        icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$8bb46d5eef767d7), {}),
        textEnable: "Ouvrir l'\xe9tude",
        classEnable: "primary",
        route: (etudeId)=>(0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).OUVRIR_ETUDE(etudeId)
    });
    if ((0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ETUDE_U)) listeButton.push({
        row: (row)=>{
            return row;
        },
        route: (etudeId)=>(0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).UPDATE_ETUDE(etudeId),
        type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).UPDATE
    });
    if ((0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ETUDE_D)) listeButton.push({
        row: (row)=>{
            return row;
        },
        type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).CONFIRM,
        disable: (v)=>{
            return (0, $68f492479dc8d251$export$2e2bcd8739ae039)[v.original.etudeStatut] === (0, $68f492479dc8d251$export$2e2bcd8739ae039).TERMINEE;
        },
        textDisable: "Impossible de clore une \xe9tude qui n'est pas en cours",
        textEnable: "Clore l'\xe9tude",
        pathname: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/couverture-hydraulique/etude/clore/`,
        icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$e04bcc6127e699bf), {}),
        classEnable: "danger",
        confirmModal: {
            header: "Clore l'\xe9tude",
            content: "Voulez-vous continuer ? "
        }
    });
    if ((0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ETUDE_U)) listeButton.push({
        row: (row)=>{
            return row;
        },
        route: (etudeId)=>(0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).IMPORTER_COUVERTURE_HYDRAULIQUE(etudeId),
        type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).LINK,
        icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$c9bef5de7ad5da31), {}),
        textEnable: "Importer des fichiers shapes pour l'\xe9tude",
        classEnable: "warning"
    });
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                    icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$3caee6c66795d211), {}),
                    title: "Liste des \xe9tudes",
                    right: (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ETUDE_C) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8ad69b89456b65bc$export$2e2bcd8739ae039), {
                        href: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).CREATE_ETUDE,
                        title: "Ajouter une \xe9tude"
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $9a9eebc3462fba73$export$2e2bcd8739ae039), {
                    query: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/couverture-hydraulique`,
                    columns: [
                        {
                            Header: "Type d'\xe9tude",
                            accessor: "typeEtudeLibelle",
                            sortField: "typeEtudeLibelle",
                            Filter: typeEtudeState?.data && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $3744b2a772efdf44$export$2e2bcd8739ae039), {
                                listIdCodeLibelle: typeEtudeState?.data,
                                name: "typeEtudeId"
                            })
                        },
                        {
                            Header: "R\xe9f\xe9rence",
                            accessor: "etudeNumero",
                            sortField: "etudeNumero",
                            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                                type: "text",
                                name: "etudeNumero"
                            })
                        },
                        {
                            Header: "Libell\xe9",
                            accessor: "etudeLibelle",
                            sortField: "etudeLibelle",
                            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                                type: "text",
                                name: "etudeLibelle"
                            })
                        },
                        {
                            Header: "Description",
                            accessor: "etudeDescription",
                            sortField: "etudeDescription",
                            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                                type: "text",
                                name: "etudeDescription"
                            })
                        },
                        {
                            Header: "Statut",
                            accessor: "etudeStatut",
                            sortField: "etudeStatut",
                            Cell: (value)=>{
                                return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                    children: value?.value != null && (0, $68f492479dc8d251$export$2e2bcd8739ae039)[value.value]
                                });
                            },
                            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eed37ff3d3e1f28c$export$2e2bcd8739ae039), {
                                options: (0, $68f492479dc8d251$export$2e2bcd8739ae039),
                                name: "etudeStatut"
                            })
                        },
                        {
                            Header: "Communes",
                            accessor: "listeCommune",
                            Cell: (value)=>{
                                return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                    children: value?.value?.map((e)=>e.communeLibelle + " (" + e.communeCodeInsee + ")")?.join(", ")
                                });
                            }
                        },
                        {
                            Header: "Date de derni\xe8re mise \xe0 jour",
                            accessor: "etudeDateMaj",
                            sortField: "etudeDateMaj",
                            Cell: (value)=>{
                                return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                    children: value?.value != null && (0, $00c47c7740afd024$export$2e2bcd8739ae039)(value.value)
                                });
                            }
                        },
                        (0, $b82b937cc97f6f18$export$36e9f5a475c9f6fc)({
                            Header: "Actions",
                            accessor: "etudeId",
                            buttons: listeButton
                        })
                    ],
                    idName: "tableEtudeId",
                    filterValuesToVariable: (0, $73e72cc56a5bcc5c$export$2e2bcd8739ae039),
                    filterContext: (0, $9a9eebc3462fba73$export$396ef541d9951d45)({
                        typeEtudeId: undefined,
                        etudeNumero: undefined,
                        etudeLibelle: undefined,
                        etudeDescription: undefined,
                        etudeStatut: "EN_COURS",
                        etudeDateMaj: undefined
                    })
                })
            ]
        })
    });
};
var $305d863cb857dd07$export$2e2bcd8739ae039 = $305d863cb857dd07$var$ListEtude;










var $kc00y = parcelRequire("kc00y");













var $kc00y = parcelRequire("kc00y");






var $bkJfK = parcelRequire("bkJfK");







const $3f25916af42ffa1d$export$a5cab80145b70e98 = (listePeiId, listePeiProjetId)=>({
        useReseauImporte: false,
        useReseauImporteWithReseauCourant: false,
        listePeiId: listePeiId,
        listePeiProjetId: listePeiProjetId,
        isSubmit: false
    });
const $3f25916af42ffa1d$export$f97400759cfd946 = (values)=>({
        useReseauImporte: values.useReseauImporte,
        useReseauImporteWithReseauCourant: values.useReseauImporteWithReseauCourant,
        listePeiId: values.listePeiId,
        listePeiProjetId: values.listePeiProjetId
    });
const $3f25916af42ffa1d$export$c084437b5e3206cd = (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({});
const $3f25916af42ffa1d$var$TraceeCouvertureForm = ({ etudeId: etudeId, listePeiId: listePeiId, listePeiProjetId: listePeiProjetId, closeVolet: closeVolet })=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$3caee6c66795d211), {}),
                title: "Lancer une simulation",
                displayReturnButton: false
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                initialValues: $3f25916af42ffa1d$export$a5cab80145b70e98(listePeiId, listePeiProjetId),
                validationSchema: $3f25916af42ffa1d$export$c084437b5e3206cd,
                isPost: false,
                isMultipartFormData: false,
                submitUrl: `/api/couverture-hydraulique/calcul/` + etudeId,
                prepareVariables: (values)=>$3f25916af42ffa1d$export$f97400759cfd946(values),
                onSubmit: closeVolet,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($3f25916af42ffa1d$var$Form, {})
            })
        ]
    });
};
const $3f25916af42ffa1d$var$Form = ()=>{
    const { setFieldValue: setFieldValue, submitCount: submitCount } = (0, $bkJfK.useFormikContext)();
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
            children: [
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                    className: "text-center",
                    children: [
                        "Souhaitez-vous calculer la couverture hydraulique de ces PEI",
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                        " sur le r\xe9seau routier commun ou sur le r\xe9seau routier pr\xe9c\xe9demment import\xe9 ?"
                    ]
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    className: "mt-3 text-center",
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                            type: "submit",
                            variant: "primary",
                            onClick: ()=>{
                                setFieldValue("useReseauImporte", false);
                            },
                            disabled: submitCount > 0,
                            children: "Commun"
                        })
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    className: "mt-3 text-center",
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                            type: "submit",
                            variant: "primary",
                            onClick: ()=>{
                                setFieldValue("useReseauImporte", true);
                            },
                            disabled: submitCount > 0,
                            children: "Import\xe9"
                        })
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    className: "mt-3 text-center",
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                            type: "submit",
                            variant: "primary",
                            onClick: ()=>{
                                setFieldValue("useReseauImporteWithReseauCourant", true);
                            },
                            disabled: submitCount > 0,
                            children: "Commun et import\xe9"
                        })
                    })
                }),
                submitCount > 0 && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $c21b1c237cfa1d94$export$2e2bcd8739ae039), {})
            ]
        })
    });
};
var $3f25916af42ffa1d$export$2e2bcd8739ae039 = $3f25916af42ffa1d$var$TraceeCouvertureForm;








const $381bc9ac133181a6$var$CreatePeiProjet = ({ coordonneeX: coordonneeX, coordonneeY: coordonneeY, srid: srid, etudeId: etudeId, onSubmit: onSubmit })=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$ba2fbb9644c8bf32), {}),
                title: "Cr\xe9ation d'un PEI en projet",
                displayReturnButton: false
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                initialValues: (0, $1bfa9c502da04094$export$a5cab80145b70e98)({
                    peiProjetCoordonneeX: coordonneeX,
                    peiProjetCoordonneeY: coordonneeY,
                    peiProjetSrid: srid,
                    peiProjetEtudeId: etudeId
                }),
                validationSchema: (0, $1bfa9c502da04094$export$c084437b5e3206cd),
                isPost: true,
                isMultipartFormData: false,
                submitUrl: `/api/couverture-hydraulique/etude/` + etudeId + `/pei-projet/create`,
                prepareVariables: (values)=>(0, $1bfa9c502da04094$export$f97400759cfd946)(values),
                onSubmit: onSubmit,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1bfa9c502da04094$export$2e2bcd8739ae039), {})
            })
        ]
    });
};
var $381bc9ac133181a6$export$2e2bcd8739ae039 = $381bc9ac133181a6$var$CreatePeiProjet;











const $c14e072537e1de50$var$CREATION_TOPOLOGIE_EN_COURS = "Cr\xe9ation de la topologie en cours, veuillez patienter\u2026";
const $c14e072537e1de50$var$ButtonWithTooltipIfDisabled = ({ tooltipId: tooltipId, tooltipText: tooltipText, children: children, disabled: disabled, ...buttonProps })=>{
    const nativeTooltip = disabled && tooltipText.trim().length > 0 ? tooltipText : undefined;
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("span", {
        className: "d-inline-block",
        id: tooltipId,
        title: nativeTooltip,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
            disabled: disabled,
            style: disabled ? {
                pointerEvents: "none"
            } : undefined,
            ...buttonProps,
            children: children
        })
    });
};
const $c14e072537e1de50$var$drawStyle = new (0, $a5fc261473972d1d$export$2e2bcd8739ae039)({
    fill: new (0, $8624b871a0af6dab$export$2e2bcd8739ae039)({
        color: "rgba(255, 255, 255, 0.2)"
    }),
    stroke: new (0, $281691897fddf9d0$export$2e2bcd8739ae039)({
        color: "rgba(0, 0, 0, 0.5)",
        lineDash: [
            10,
            10
        ],
        width: 2
    }),
    image: new (0, $f060542c6e9f52e6$export$2e2bcd8739ae039)({
        radius: 5,
        stroke: new (0, $281691897fddf9d0$export$2e2bcd8739ae039)({
            color: "rgba(0, 0, 0, 0.7)"
        }),
        fill: new (0, $8624b871a0af6dab$export$2e2bcd8739ae039)({
            color: "rgba(255, 255, 255, 0.2)"
        })
    })
});
const $c14e072537e1de50$export$d6bfead64f0208fd = ({ map: map, workingLayer: workingLayer, dataPeiLayer: dataPeiLayer, dataPeiProjetLayer: dataPeiProjetLayer, etudeId: etudeId, reseauImporte: reseauImporte })=>{
    const { success: successToast, error: errorToast } = (0, $6bdae0bad7b05751$export$91b3d218c74c79e4)();
    const [showCreatePeiProjet, setShowPeiProjet] = (0, $kc00y.useState)(false);
    const handleClosePeiProjet = ()=>setShowPeiProjet(false);
    const [pointPeiProjet, setPointPeiProjet] = (0, $kc00y.useState)(null);
    const [showTraceeCouverture, setShowTraceeCouverture] = (0, $kc00y.useState)(false);
    const handleCloseTraceeCouverture = ()=>setShowTraceeCouverture(false);
    const [listePeiId] = (0, $kc00y.useState)([]);
    const [listePeiProjetId] = (0, $kc00y.useState)([]);
    const { visible: visibleMove, show: showMove, close: closeMove } = (0, $ca8671088139af49$export$2e2bcd8739ae039)();
    const [peiProjetIdMove, setPeiProjetIdMove] = (0, $kc00y.useState)(null);
    const [geometrieMove, setGeometrieMove] = (0, $kc00y.useState)(null);
    const [busy, setBusy] = (0, $kc00y.useState)(false);
    const [loadingPeiPlusProche, setLoadingPeiPlusProche] = (0, $kc00y.useState)(false);
    // Base pour la future logique de création de topologie
    const handleCreerTopologie = async ()=>{
        if (busy) return;
        setBusy(true);
        try {
            const response = await fetch((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/couverture-hydraulique/calcul/create-topologie/` + etudeId, (0, $fbd4d34e07af0ac7$export$b163ec2f884327db)({
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                }
            }));
            if (!response.ok) {
                const message = await response.text();
                throw new Error(message || "Erreur lors de la cr\xe9ation de la topologie");
            }
            successToast("Topologie cr\xe9\xe9e avec succ\xe8s");
            if (workingLayer && map) (0, $1ed1be1197ad1bc4$export$51ba454167fb25ab)(map);
        } catch (reason) {
            const message = reason instanceof Error ? reason.message : "Erreur lors de la cr\xe9ation de la topologie";
            errorToast(message);
        } finally{
            setBusy(false);
        }
    };
    /**
   * Permet de dessiner un point pour la création des PEI en projet
   */ async function calculCouverture() {
        if (listePeiId.length === 0 && listePeiProjetId.length === 0) return;
        // Si l'étude a un réseau importé alors on demande quel réseau utiliser.
        if (reseauImporte) setShowTraceeCouverture(true);
        else (await fetch((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/couverture-hydraulique/calcul/` + etudeId, (0, $fbd4d34e07af0ac7$export$b163ec2f884327db)({
            method: "PUT",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                listePeiId: listePeiId,
                listePeiProjetId: listePeiProjetId,
                useReseauImporte: false,
                useReseauImporteWithReseauCourant: false
            })
        }))).text().then(()=>{
            successToast("Couverture hydraulique trac\xe9e");
        }).catch((reason)=>{
            errorToast(reason);
        });
    }
    /**
   * Permet de dessiner un point pour la création des PEI en projet
   */ async function clearCouverture() {
        (await fetch((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/couverture-hydraulique/calcul/clear/` + etudeId, (0, $fbd4d34e07af0ac7$export$b163ec2f884327db)({
            method: "DELETE",
            headers: {
                "Content-Type": "application/json"
            }
        }))).text().then(()=>{
            successToast("Couverture hydraulique effac\xe9e");
            (0, $1ed1be1197ad1bc4$export$51ba454167fb25ab)(map);
        }).catch((reason)=>{
            errorToast(reason);
        });
    }
    const tools = (0, $kc00y.useMemo)(()=>{
        if (!map) return {};
        const createPeiProjetCtrl = new (0, $2ef894158a48397d$export$2e2bcd8739ae039)({
            source: workingLayer.getSource(),
            type: "Point",
            style: (feature)=>{
                const geometryType = feature.getGeometry()?.getType();
                if (geometryType === "Point") return $c14e072537e1de50$var$drawStyle;
            }
        });
        createPeiProjetCtrl.on("drawstart", async ()=>{
            // Avant de redessiner un point, on supprime les autres points, le but est d'avoir juste un seul point à la fois.
            workingLayer.getSource().clear();
        });
        createPeiProjetCtrl.on("drawend", async (event)=>{
            const geometry = event.feature.getGeometry();
            setPointPeiProjet(geometry);
            setShowPeiProjet(true);
        });
        /**
     * Permet de dessiner un point pour la création des PEI en projet
     */ function toggleCreatePeiProjet(active = false) {
            const idx = map?.getInteractions().getArray().indexOf(createPeiProjetCtrl);
            if (active) {
                if (idx === -1) map.addInteraction(createPeiProjetCtrl);
            } else map.removeInteraction(createPeiProjetCtrl);
        }
        const peiPlusProcheCtrl = new (0, $2ef894158a48397d$export$2e2bcd8739ae039)({
            source: workingLayer.getSource(),
            type: "Point",
            style: (feature)=>{
                const geometryType = feature.getGeometry()?.getType();
                if (geometryType === "Point") return $c14e072537e1de50$var$drawStyle;
            }
        });
        peiPlusProcheCtrl.on("drawstart", async ()=>{
            // Avant de redessiner un point, on supprime les autres points, le but est d'avoir juste un seul point à la fois.
            workingLayer.getSource().clear();
        });
        peiPlusProcheCtrl.on("drawend", async (event)=>{
            setLoadingPeiPlusProche(true);
            try {
                const geometry = event.feature.getGeometry();
                const result = await (0, $8d9ebd8892d8a5f5$export$8ff66c70be1c563a)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/couverture-hydraulique/calcul/pei-plus-proche`, (0, $fbd4d34e07af0ac7$export$b163ec2f884327db)({
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        longitude: geometry.getFlatCoordinates()[0],
                        latitude: geometry.getFlatCoordinates()[1],
                        srid: map.getView().getProjection().getCode().split(":")[1]
                    })
                }));
                if (result?.chemin != null) {
                    const wktChemin = result.chemin;
                    const wktPei = result.peiGeometry;
                    const distance = result.dist;
                    // Affichage des features
                    const sridSource = "EPSG:" + wktPei.split(";")[0].split("=").pop();
                    cheminPlusCourtFeaturePei(workingLayer, wktPei, distance, sridSource);
                    cheminPlusCourtFeatureChemin(workingLayer, wktChemin, sridSource);
                    cheminPlusCourtFeatureClic(workingLayer, geometry);
                } else errorToast("Aucun PEI n'a \xe9t\xe9 trouv\xe9.");
            } finally{
                setLoadingPeiPlusProche(false);
            }
        });
        /**
     * Permet de dessiner un point pour la création des PEI en projet
     */ function togglePeiPlusProche(active = false) {
            const idx = map?.getInteractions().getArray().indexOf(peiPlusProcheCtrl);
            if (active) {
                if (idx === -1) map.addInteraction(peiPlusProcheCtrl);
            } else map.removeInteraction(peiPlusProcheCtrl);
        }
        /**
     * Permet de dessiner un rond rouge sur le PEI le plus proche
     */ function cheminPlusCourtFeaturePei(workingLayer, wktPei, distance, sridSource) {
            if (wktPei == null) return;
            const featurePei = new (0, $15a985d09649bdc2$export$2e2bcd8739ae039)().readFeature(wktPei.split(";")[1]);
            const circle = new (0, $df26d2327ced1fa9$export$2e2bcd8739ae039)(new (0, $0c02e7a8e145dce8$export$2e2bcd8739ae039)(featurePei.get("geometry")?.transform(sridSource, (0, $f740b0d032822ba6$export$3eb968b6a9f43207)).flatCoordinates));
            circle.setStyle(new (0, $a5fc261473972d1d$export$2e2bcd8739ae039)({
                geometry: new (0, $3153df5f3993c8ca$export$2e2bcd8739ae039)(featurePei.get("geometry").flatCoordinates),
                image: new (0, $f060542c6e9f52e6$export$2e2bcd8739ae039)({
                    radius: 12,
                    stroke: new (0, $281691897fddf9d0$export$2e2bcd8739ae039)({
                        color: "#f01f18",
                        width: 3
                    })
                }),
                text: new (0, $ee3bf0a2c13d7793$export$2e2bcd8739ae039)({
                    font: "16px Calibri,sans-serif",
                    overflow: true,
                    fill: new (0, $8624b871a0af6dab$export$2e2bcd8739ae039)({
                        color: "black"
                    }),
                    text: Math.round(distance) + " m",
                    offsetY: -20
                })
            }));
            workingLayer.getSource().addFeature(circle);
        }
        /**
     * Permet de dessiner le chemin entre le clic et le PEI le plus proche
     */ function cheminPlusCourtFeatureChemin(workingLayer, wktChemin, sridSource) {
            const featureChemin = new (0, $15a985d09649bdc2$export$2e2bcd8739ae039)().readFeature(wktChemin);
            const path = new (0, $df26d2327ced1fa9$export$2e2bcd8739ae039)({
                geometry: new (0, $96d2138ace1f7d2d$export$2e2bcd8739ae039)((featureChemin.getGeometry()?.transform(sridSource, (0, $f740b0d032822ba6$export$3eb968b6a9f43207))).getCoordinates()),
                name: "chemin"
            });
            path.setStyle(new (0, $a5fc261473972d1d$export$2e2bcd8739ae039)({
                stroke: new (0, $281691897fddf9d0$export$2e2bcd8739ae039)({
                    color: "#f01f18",
                    width: 3
                })
            }));
            workingLayer.getSource().addFeature(path);
        }
        /**
     * Permet de dessiner un rond à l'endroit du clic de l'utilisateur
     */ function cheminPlusCourtFeatureClic(workingLayer, coordsClic) {
            const pointClic = new (0, $df26d2327ced1fa9$export$2e2bcd8739ae039)(coordsClic);
            pointClic.setStyle(new (0, $a5fc261473972d1d$export$2e2bcd8739ae039)({
                geometry: coordsClic,
                image: new (0, $f060542c6e9f52e6$export$2e2bcd8739ae039)({
                    radius: 6,
                    stroke: new (0, $281691897fddf9d0$export$2e2bcd8739ae039)({
                        color: "black",
                        width: 2
                    }),
                    fill: new (0, $8624b871a0af6dab$export$2e2bcd8739ae039)({
                        color: "white"
                    })
                })
            }));
            workingLayer.getSource().addFeature(pointClic);
        }
        const selectCtrl = new (0, $20af4deb83586389$export$2e2bcd8739ae039)({
            style: new (0, $a5fc261473972d1d$export$2e2bcd8739ae039)({
                image: new (0, $f060542c6e9f52e6$export$2e2bcd8739ae039)({
                    radius: 16,
                    stroke: new (0, $281691897fddf9d0$export$2e2bcd8739ae039)({
                        color: "rgba(255, 0, 0, 0.7)",
                        width: 4
                    })
                })
            }),
            toggleCondition: (0, $638912a122b4daef$export$f3100d8d6292d638),
            hitTolerance: 4
        });
        const dragBoxCtrl = new (0, $886371f562c99b97$export$2e2bcd8739ae039)({
            minArea: 25
        });
        dragBoxCtrl.on("boxend", function(e) {
            if (!(0, $638912a122b4daef$export$f3100d8d6292d638)(e.mapBrowserEvent)) selectCtrl.getFeatures().clear();
            const boxExtent = dragBoxCtrl.getGeometry().getExtent();
            const boxFeatures = dataPeiLayer.getSource().getFeaturesInExtent(boxExtent);
            selectCtrl.getFeatures().extend(boxFeatures);
            const boxFeaturesPeiProjet = dataPeiProjetLayer.getSource().getFeaturesInExtent(boxExtent);
            selectCtrl.getFeatures().extend(boxFeaturesPeiProjet);
            listePeiId.splice(0, listePeiId.length);
            listePeiProjetId.splice(0, listePeiProjetId.length);
            selectCtrl.getFeatures().forEach((e)=>{
                const point = e.getProperties();
                if (point.typeElementCarte === "PEI") listePeiId.push(point.elementId);
                if (point.typeElementCarte === "PEI_PROJET") listePeiProjetId.push(point.elementId);
            });
        });
        function toggleSelect(active = false) {
            const idx1 = map?.getInteractions().getArray().indexOf(selectCtrl);
            const idx2 = map?.getInteractions().getArray().indexOf(dragBoxCtrl);
            if (active) {
                if (idx1 === -1 && idx2 === -1) {
                    map.addInteraction(selectCtrl);
                    map.addInteraction(dragBoxCtrl);
                }
            } else {
                listePeiId.splice(0, listePeiId.length);
                listePeiProjetId.splice(0, listePeiProjetId.length);
                map.removeInteraction(selectCtrl);
                map.removeInteraction(dragBoxCtrl);
            }
        }
        const selectProjetCtrl = new (0, $20af4deb83586389$export$2e2bcd8739ae039)();
        const modifyCtrl = new (0, $2375ecf9b29b2a49$export$2e2bcd8739ae039)({
            features: selectProjetCtrl.getFeatures(),
            source: dataPeiProjetLayer,
            snapToPointer: true
        });
        function toggleDeplacerPeiProjet(active = false) {
            (0, $1ed1be1197ad1bc4$export$2e2bcd8739ae039)(active, selectProjetCtrl, modifyCtrl, map, (feature, point)=>{
                setGeometrieMove(feature);
                setPeiProjetIdMove(point.elementId);
                showMove();
            }, (feature)=>feature.getProperties().typeElementCarte === "PEI_PROJET");
        }
        const tools = {
            "create-pei-projet": {
                action: toggleCreatePeiProjet
            },
            "select-etude": {
                action: toggleSelect,
                actionPossibleEnDeplacement: false
            },
            "pei-plus-proche": {
                action: togglePeiPlusProche
            },
            "deplacer-pei-projet": {
                action: toggleDeplacerPeiProjet
            }
        };
        return tools;
    }, [
        map,
        listePeiProjetId.push,
        listePeiId.push,
        listePeiProjetId.splice,
        listePeiId.splice,
        dataPeiProjetLayer,
        dataPeiLayer,
        workingLayer,
        errorToast,
        listePeiProjetId.length,
        listePeiId.length,
        showMove
    ]);
    return {
        tools: tools,
        calculCouverture: calculCouverture,
        clearCouverture: clearCouverture,
        handleClosePeiProjet: handleClosePeiProjet,
        showCreatePeiProjet: showCreatePeiProjet,
        pointPeiProjet: pointPeiProjet,
        handleCloseTraceeCouverture: handleCloseTraceeCouverture,
        showTraceeCouverture: showTraceeCouverture,
        listePeiId: listePeiId,
        listePeiProjetId: listePeiProjetId,
        peiProjetIdMove: peiProjetIdMove,
        geometrieMove: geometrieMove,
        closeMove: closeMove,
        visibleMove: visibleMove,
        handleCreerTopologie: handleCreerTopologie,
        busy: busy,
        loadingPeiPlusProche: loadingPeiPlusProche
    };
};
const $c14e072537e1de50$var$MapToolbarCouvertureHydraulique = ({ map: map, dataPeiProjetLayer: dataPeiProjetLayer, workingLayer: workingLayer, etudeId: etudeId, disabledEditPeiProjet: disabledEditPeiProjet, calculCouverture: calculCouverture, clearCouverture: clearCouverture, handleClosePeiProjet: handleClosePeiProjet, showCreatePeiProjet: showCreatePeiProjet, pointPeiProjet: pointPeiProjet, handleCloseTraceeCouverture: handleCloseTraceeCouverture, showTraceeCouverture: showTraceeCouverture, listePeiId: listePeiId, listePeiProjetId: listePeiProjetId, toggleTool: toggleToolCallback, activeTool: activeTool, peiProjetIdMove: peiProjetIdMove, geometrieMove: geometrieMove, closeMove: closeMove, visibleMove: visibleMove, handleCreerTopologie: handleCreerTopologie, busy: busy, loadingPeiPlusProche: loadingPeiPlusProche })=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
        className: "d-flex align-items-center",
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $f2eef644ac9323e0$export$2e2bcd8739ae039), {
                toolName: "select-etude",
                toolIcon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$249df474ea45aebc), {}),
                toolLabelTooltip: busy ? $c14e072537e1de50$var$CREATION_TOPOLOGIE_EN_COURS : "S\xe9lectionner",
                toggleTool: toggleToolCallback,
                activeTool: activeTool,
                disabled: disabledEditPeiProjet || busy
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $f2eef644ac9323e0$export$2e2bcd8739ae039), {
                toolName: "create-pei-projet",
                toolIcon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$d776d19dfae66ece), {}),
                toolLabelTooltip: busy ? $c14e072537e1de50$var$CREATION_TOPOLOGIE_EN_COURS : disabledEditPeiProjet ? "L'\xe9tude est termin\xe9e, vous ne pouvez plus cr\xe9er un PEI en projet" : "Cr\xe9er un PEI en projet",
                toggleTool: toggleToolCallback,
                activeTool: activeTool,
                disabled: disabledEditPeiProjet || busy
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $f2eef644ac9323e0$export$2e2bcd8739ae039), {
                toolName: "deplacer-pei-projet",
                toolIcon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$ef875af7def69d98), {}),
                toolLabelTooltip: busy ? $c14e072537e1de50$var$CREATION_TOPOLOGIE_EN_COURS : disabledEditPeiProjet ? "L'\xe9tude est termin\xe9e, vous ne pouvez plus d\xe9placer un PEI en projet" : "D\xe9placer un PEI en projet",
                toggleTool: toggleToolCallback,
                activeTool: activeTool,
                disabled: disabledEditPeiProjet || busy
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $f2eef644ac9323e0$export$2e2bcd8739ae039), {
                toolName: "pei-plus-proche",
                toolIcon: loadingPeiPlusProche ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $3e3841c053791fa3$export$2e2bcd8739ae039), {
                    animation: "border",
                    size: "sm"
                }) : /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$34759e72450b621e), {}),
                toolLabelTooltip: loadingPeiPlusProche ? "Recherche du PEI le plus proche en cours, veuillez patienter\u2026" : busy ? $c14e072537e1de50$var$CREATION_TOPOLOGIE_EN_COURS : disabledEditPeiProjet ? "L'\xe9tude est termin\xe9e, vous ne pouvez plus trouver le PEI le plus proche" : "Trouver le PEI le plus proche",
                toggleTool: toggleToolCallback,
                activeTool: activeTool,
                disabled: disabledEditPeiProjet || busy || loadingPeiPlusProche
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)($c14e072537e1de50$var$ButtonWithTooltipIfDisabled, {
                tooltipId: "creer-topologie-disabled",
                tooltipText: busy ? $c14e072537e1de50$var$CREATION_TOPOLOGIE_EN_COURS : "L'\xe9tude est termin\xe9e, vous ne pouvez plus cr\xe9er la topologie",
                className: "ms-4 me-3",
                variant: "outline-primary",
                onClick: handleCreerTopologie,
                disabled: disabledEditPeiProjet || busy,
                children: [
                    busy && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $3e3841c053791fa3$export$2e2bcd8739ae039), {
                        animation: "border",
                        size: "sm",
                        className: "me-2"
                    }),
                    busy ? "Cr\xe9ation en cours\u2026" : "Cr\xe9er la topologie"
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($c14e072537e1de50$var$ButtonWithTooltipIfDisabled, {
                tooltipId: "lancer-simulation-disabled",
                tooltipText: busy ? $c14e072537e1de50$var$CREATION_TOPOLOGIE_EN_COURS : "L'\xe9tude est termin\xe9e, vous ne pouvez plus lancer de simulation",
                className: "ms-2 me-3",
                variant: "outline-primary",
                onClick: calculCouverture,
                disabled: disabledEditPeiProjet || busy,
                children: "Lancer une simulation"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($c14e072537e1de50$var$ButtonWithTooltipIfDisabled, {
                tooltipId: "effacer-couverture-disabled",
                tooltipText: busy ? $c14e072537e1de50$var$CREATION_TOPOLOGIE_EN_COURS : "L'\xe9tude est termin\xe9e, vous ne pouvez plus effacer la couverture",
                variant: "outline-primary",
                onClick: clearCouverture,
                disabled: disabledEditPeiProjet || busy,
                children: "Effacer la couverture trac\xe9e"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1eee265537f042a4$export$2e2bcd8739ae039), {
                handleClose: handleClosePeiProjet,
                show: showCreatePeiProjet,
                className: "w-auto",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $381bc9ac133181a6$export$2e2bcd8739ae039), {
                    coordonneeX: pointPeiProjet?.getFlatCoordinates()[0] ?? 0,
                    coordonneeY: pointPeiProjet?.getFlatCoordinates()[1] ?? 0,
                    srid: map.getView().getProjection().getCode().split(":").pop(),
                    etudeId: etudeId,
                    onSubmit: ()=>{
                        workingLayer.getSource().clear();
                        dataPeiProjetLayer.getSource().refresh();
                        (0, $1ed1be1197ad1bc4$export$51ba454167fb25ab)(map);
                        handleClosePeiProjet();
                    }
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1eee265537f042a4$export$2e2bcd8739ae039), {
                handleClose: handleCloseTraceeCouverture,
                show: showTraceeCouverture,
                className: "w-auto",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $3f25916af42ffa1d$export$2e2bcd8739ae039), {
                    etudeId: etudeId,
                    listePeiId: listePeiId,
                    listePeiProjetId: listePeiProjetId,
                    closeVolet: ()=>{
                        (0, $1ed1be1197ad1bc4$export$51ba454167fb25ab)(map);
                        handleCloseTraceeCouverture();
                    }
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b0759c348c3ed98d$export$6dc0aa31e09fabda), {
                etudeId: etudeId,
                map: map,
                disabledEditPeiProjet: disabledEditPeiProjet,
                dataPeiProjetLayer: dataPeiProjetLayer,
                disabled: activeTool === "deplacer-pei-projet"
            }),
            peiProjetIdMove && geometrieMove && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $c738870e8199ea0b$export$2e2bcd8739ae039), {
                closeModal: ()=>{
                    dataPeiProjetLayer.getSource().refresh();
                    toggleToolCallback("deplacer-pei-projet");
                    closeMove();
                },
                query: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/couverture-hydraulique/pei-projet/move/${peiProjetIdMove}`,
                submitLabel: "Valider",
                visible: visibleMove,
                header: "D\xe9placer le PEI",
                onSubmit: ()=>{
                    dataPeiProjetLayer.getSource().refresh();
                    (0, $1ed1be1197ad1bc4$export$51ba454167fb25ab)(map);
                },
                prepareVariables: (values)=>({
                        geometry: values.geometrie
                    }),
                getInitialValues: ()=>({
                        geometrie: geometrieMove
                    }),
                validationSchema: (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({}),
                canModify: true,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("p", {
                    children: "Voulez-vous d\xe9placer le PEI ?"
                })
            })
        ]
    });
};
$c14e072537e1de50$var$MapToolbarCouvertureHydraulique.displayName = "MapToolbarCouvertureHydraulique";
var $c14e072537e1de50$export$2e2bcd8739ae039 = $c14e072537e1de50$var$MapToolbarCouvertureHydraulique;


const $c17b0a2f406f8181$var$MapCouvertureHydraulique = ({ etudeId: etudeId, disabledEditPeiProjet: disabledEditPeiProjet, reseauImporte: reseauImporte })=>{
    const mapElement = (0, $kc00y.useRef)();
    const { map: map, workingLayer: workingLayer, dataPeiLayer: dataPeiLayer, availableLayers: availableLayers, addOrRemoveLayer: addOrRemoveLayer, layerListRef: layerListRef, mapToolbarRef: mapToolbarRef, projection: projection, showOutilI: showOutilI } = (0, $cdcdd8e1ff041f79$export$547f9c492d831282)({
        mapElement: mapElement,
        typeModule: (0, $a9754922f4c67d47$export$ef88b514e4bfff34).COUVERTURE_HYDRAULIQUE,
        etudeId: etudeId
    });
    /**
   * Permet d'afficher les PEI en projet
   * @param etudeId l'étude concernée
   * @returns
   */ const dataPeiProjetLayer = (0, $kc00y.useMemo)(()=>{
        if (!map || !etudeId || !projection) return;
        return (0, $1ed1be1197ad1bc4$export$a3178456480ccf5b)(map, (extent, projection)=>`/api/couverture-hydraulique/layer?bbox=` + extent.join(",") + "&srid=" + projection.getCode() + "&etudeId=" + etudeId, projection);
    }, [
        map,
        etudeId,
        projection
    ]);
    const { tools: extraTools, calculCouverture: calculCouverture, clearCouverture: clearCouverture, handleClosePeiProjet: handleClosePeiProjet, showCreatePeiProjet: showCreatePeiProjet, pointPeiProjet: pointPeiProjet, handleCloseTraceeCouverture: handleCloseTraceeCouverture, showTraceeCouverture: showTraceeCouverture, listePeiId: listePeiId, listePeiProjetId: listePeiProjetId, geometrieMove: geometrieMove, peiProjetIdMove: peiProjetIdMove, closeMove: closeMove, visibleMove: visibleMove, handleCreerTopologie: handleCreerTopologie, busy: busy, loadingPeiPlusProche: loadingPeiPlusProche } = (0, $c14e072537e1de50$export$d6bfead64f0208fd)({
        map: map,
        workingLayer: workingLayer,
        dataPeiLayer: dataPeiLayer,
        dataPeiProjetLayer: dataPeiProjetLayer,
        etudeId: etudeId,
        reseauImporte: reseauImporte
    });
    const { toggleTool: toggleTool, activeTool: activeTool, infoOutilI: infoOutilI, handleCloseInfoI: handleCloseInfoI } = (0, $e2b798e23180fa76$export$194c7727cbdc0cac)({
        availableLayers: availableLayers,
        map: map,
        workingLayer: workingLayer,
        extraTools: extraTools
    });
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $cdcdd8e1ff041f79$export$2e2bcd8739ae039), {
        map: map,
        mapElement: mapElement,
        availableLayers: availableLayers,
        addOrRemoveLayer: addOrRemoveLayer,
        layerListRef: layerListRef,
        mapToolbarRef: mapToolbarRef,
        toggleTool: toggleTool,
        activeTool: activeTool,
        outilI: infoOutilI,
        showOutilI: showOutilI,
        handleCloseInfoI: handleCloseInfoI,
        toolbarElement: mapToolbarRef.current && map && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $c14e072537e1de50$export$2e2bcd8739ae039), {
            map: map,
            dataPeiProjetLayer: dataPeiProjetLayer,
            workingLayer: workingLayer,
            etudeId: etudeId,
            disabledEditPeiProjet: disabledEditPeiProjet,
            calculCouverture: calculCouverture,
            clearCouverture: clearCouverture,
            handleClosePeiProjet: handleClosePeiProjet,
            showCreatePeiProjet: showCreatePeiProjet,
            pointPeiProjet: pointPeiProjet,
            handleCloseTraceeCouverture: handleCloseTraceeCouverture,
            showTraceeCouverture: showTraceeCouverture,
            listePeiId: listePeiId,
            listePeiProjetId: listePeiProjetId,
            toggleTool: toggleTool,
            activeTool: activeTool ?? "",
            geometrieMove: geometrieMove,
            peiProjetIdMove: peiProjetIdMove,
            closeMove: closeMove,
            visibleMove: visibleMove,
            handleCreerTopologie: handleCreerTopologie,
            busy: busy,
            loadingPeiPlusProche: loadingPeiPlusProche
        })
    });
};
var $c17b0a2f406f8181$export$2e2bcd8739ae039 = $c17b0a2f406f8181$var$MapCouvertureHydraulique;




const $a2b18b07124b751d$var$MapEtude = ()=>{
    const { etudeId: etudeId } = (0, $7a844823b04d4282$export$99eaa27ddbbb95ef)();
    const etudeState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/couverture-hydraulique/etude/` + etudeId);
    return etudeId && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                title: etudeState?.data?.etudeLibelle,
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$3caee6c66795d211), {})
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $c17b0a2f406f8181$export$2e2bcd8739ae039), {
                etudeId: etudeId,
                disabledEditPeiProjet: (0, $68f492479dc8d251$export$2e2bcd8739ae039)[etudeState?.data?.etudeStatut] === (0, $68f492479dc8d251$export$2e2bcd8739ae039).TERMINEE,
                reseauImporte: etudeState?.data?.reseauImporte
            })
        ]
    });
};
var $a2b18b07124b751d$export$2e2bcd8739ae039 = $a2b18b07124b751d$var$MapEtude;












const $2987c33bfc851c58$var$UpdateEtude = ()=>{
    const { etudeId: etudeId } = (0, $7a844823b04d4282$export$99eaa27ddbbb95ef)();
    const etudeState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/couverture-hydraulique/etude/` + etudeId);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$3caee6c66795d211), {}),
                title: "Mise \xe0 jour d'une \xe9tude"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                initialValues: (0, $e295feb9a7a7a3c0$export$a5cab80145b70e98)(etudeState?.data),
                validationSchema: (0, $e295feb9a7a7a3c0$export$c084437b5e3206cd),
                isPost: false,
                isMultipartFormData: true,
                submitUrl: `/api/couverture-hydraulique/etude/` + etudeId,
                prepareVariables: (values)=>(0, $e295feb9a7a7a3c0$export$f97400759cfd946)(values, etudeState?.data),
                redirectUrl: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_ETUDE,
                onSubmit: ()=>null,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e295feb9a7a7a3c0$export$2e2bcd8739ae039), {})
            })
        ]
    });
};
var $2987c33bfc851c58$export$2e2bcd8739ae039 = $2987c33bfc851c58$var$UpdateEtude;







const $5cf0018c732f1534$var$Dashboard = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $a0064658a8399ad3$export$2e2bcd8739ae039), {
        navbar: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $5de16d9a2066fdee$export$2e2bcd8739ae039), {}),
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $7a844823b04d4282$export$910ae8079b2c2852), {})
    });
};
var $5cf0018c732f1534$export$2e2bcd8739ae039 = $5cf0018c732f1534$var$Dashboard;




var $kc00y = parcelRequire("kc00y");






var $kc00y = parcelRequire("kc00y");











var $kc00y = parcelRequire("kc00y");










var $kc00y = parcelRequire("kc00y");















/**
 * Groups X and Y scale functions together and provides helper methods.
 */ class $49c74039a3e5243a$export$eeb48dcb95ffc5ac {
    constructor(_ref){
        var { x: x, y: y } = _ref;
        this.xAxisScale = x;
        this.yAxisScale = y;
    }
    map(value, _ref2) {
        var _this$xAxisScale$map, _this$yAxisScale$map;
        var { position: position } = _ref2;
        return {
            x: (_this$xAxisScale$map = this.xAxisScale.map(value.x, {
                position: position
            })) !== null && _this$xAxisScale$map !== void 0 ? _this$xAxisScale$map : 0,
            y: (_this$yAxisScale$map = this.yAxisScale.map(value.y, {
                position: position
            })) !== null && _this$yAxisScale$map !== void 0 ? _this$yAxisScale$map : 0
        };
    }
    mapWithFallback(value, _ref3) {
        var _this$xAxisScale$map2, _this$yAxisScale$map2;
        var { position: position, fallback: fallback } = _ref3;
        var fallbackY, fallbackX;
        if (fallback === 'rangeMin') fallbackY = this.yAxisScale.rangeMin();
        else if (fallback === 'rangeMax') fallbackY = this.yAxisScale.rangeMax();
        else fallbackY = 0;
        if (fallback === 'rangeMin') fallbackX = this.xAxisScale.rangeMin();
        else if (fallback === 'rangeMax') fallbackX = this.xAxisScale.rangeMax();
        else fallbackX = 0;
        return {
            x: (_this$xAxisScale$map2 = this.xAxisScale.map(value.x, {
                position: position
            })) !== null && _this$xAxisScale$map2 !== void 0 ? _this$xAxisScale$map2 : fallbackX,
            y: (_this$yAxisScale$map2 = this.yAxisScale.map(value.y, {
                position: position
            })) !== null && _this$yAxisScale$map2 !== void 0 ? _this$yAxisScale$map2 : fallbackY
        };
    }
    isInRange(_ref4) {
        var { x: x, y: y } = _ref4;
        var xInRange = x == null || this.xAxisScale.isInRange(x);
        var yInRange = y == null || this.yAxisScale.isInRange(y);
        return xInRange && yInRange;
    }
}


function $8cb4b18eb8c67636$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8cb4b18eb8c67636$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8cb4b18eb8c67636$var$ownKeys(Object(t), !0).forEach(function(r) {
            $8cb4b18eb8c67636$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8cb4b18eb8c67636$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $8cb4b18eb8c67636$var$_defineProperty(e, r, t) {
    return (r = $8cb4b18eb8c67636$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $8cb4b18eb8c67636$var$_toPropertyKey(t) {
    var i = $8cb4b18eb8c67636$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $8cb4b18eb8c67636$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $8cb4b18eb8c67636$var$_extends() {
    return $8cb4b18eb8c67636$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $8cb4b18eb8c67636$var$_extends.apply(null, arguments);
}
/*
 * Omit width, height, x, y from SVGPropsAndEvents because ReferenceArea receives x1, x2, y1, y2 instead.
 * The position is calculated internally instead.
 */ var $8cb4b18eb8c67636$var$getRect = (hasX1, hasX2, hasY1, hasY2, xAxisScale, yAxisScale, props)=>{
    var _xAxisScale$map, _yAxisScale$map, _xAxisScale$map2, _yAxisScale$map2;
    var { x1: xValue1, x2: xValue2, y1: yValue1, y2: yValue2 } = props;
    if (xAxisScale == null || yAxisScale == null) return null;
    var scales = new (0, $49c74039a3e5243a$export$eeb48dcb95ffc5ac)({
        x: xAxisScale,
        y: yAxisScale
    });
    var p1 = {
        x: hasX1 ? (_xAxisScale$map = xAxisScale.map(xValue1, {
            position: 'start'
        })) !== null && _xAxisScale$map !== void 0 ? _xAxisScale$map : null : xAxisScale.rangeMin(),
        y: hasY1 ? (_yAxisScale$map = yAxisScale.map(yValue1, {
            position: 'start'
        })) !== null && _yAxisScale$map !== void 0 ? _yAxisScale$map : null : yAxisScale.rangeMin()
    };
    var p2 = {
        x: hasX2 ? (_xAxisScale$map2 = xAxisScale.map(xValue2, {
            position: 'end'
        })) !== null && _xAxisScale$map2 !== void 0 ? _xAxisScale$map2 : null : xAxisScale.rangeMax(),
        y: hasY2 ? (_yAxisScale$map2 = yAxisScale.map(yValue2, {
            position: 'end'
        })) !== null && _yAxisScale$map2 !== void 0 ? _yAxisScale$map2 : null : yAxisScale.rangeMax()
    };
    if (props.ifOverflow === 'discard' && (!scales.isInRange(p1) || !scales.isInRange(p2))) return null;
    // @ts-expect-error we're sending nullable coordinates but rectWithPoints expects non-nullable Coordinate
    return (0, $db33454bda932a01$export$c7964a5b9439ae62)(p1, p2);
};
var $8cb4b18eb8c67636$var$renderRect = (option, props)=>{
    var rect;
    if (/*#__PURE__*/ $kc00y.isValidElement(option)) // @ts-expect-error element cloning is not typed
    rect = /*#__PURE__*/ $kc00y.cloneElement(option, props);
    else if (typeof option === 'function') rect = option(props);
    else rect = /*#__PURE__*/ $kc00y.createElement((0, $94f5b831b08677d3$export$4617fb02663045ef), $8cb4b18eb8c67636$var$_extends({}, props, {
        className: "recharts-reference-area-rect"
    }));
    return rect;
};
function $8cb4b18eb8c67636$var$ReportReferenceArea(props) {
    var dispatch = (0, $a441e801d1b41b52$export$f51d452c10d5b956)();
    (0, $kc00y.useEffect)(()=>{
        dispatch((0, $bf04bdacfe1441a0$export$d604a18565cfc1b3)(props));
        return ()=>{
            dispatch((0, $bf04bdacfe1441a0$export$a8da2ad4123475fe)(props));
        };
    });
    return null;
}
function $8cb4b18eb8c67636$var$ReferenceAreaImpl(props) {
    var { x1: x1, x2: x2, y1: y1, y2: y2, className: className, shape: shape, xAxisId: xAxisId, yAxisId: yAxisId } = props;
    var clipPathId = (0, $dca5c408371f3cf1$export$71e825c43eae6ca6)();
    var isPanorama = (0, $10d1d693b6b228cd$export$4b0c59f8845ba920)();
    var xAxisScale = (0, $a441e801d1b41b52$export$a7347740d65f620b)((state)=>(0, $223cdb002ac9c48b$export$22e8e5f8924724ea)(state, 'xAxis', xAxisId, isPanorama));
    var yAxisScale = (0, $a441e801d1b41b52$export$a7347740d65f620b)((state)=>(0, $223cdb002ac9c48b$export$22e8e5f8924724ea)(state, 'yAxis', yAxisId, isPanorama));
    if (xAxisScale == null || yAxisScale == null) return null;
    var hasX1 = (0, $7e613228d3a31273$export$402a499e1ea44294)(x1);
    var hasX2 = (0, $7e613228d3a31273$export$402a499e1ea44294)(x2);
    var hasY1 = (0, $7e613228d3a31273$export$402a499e1ea44294)(y1);
    var hasY2 = (0, $7e613228d3a31273$export$402a499e1ea44294)(y2);
    if (!hasX1 && !hasX2 && !hasY1 && !hasY2 && !shape) return null;
    var rect = $8cb4b18eb8c67636$var$getRect(hasX1, hasX2, hasY1, hasY2, xAxisScale, yAxisScale, props);
    if (!rect && !shape) return null;
    var isOverflowHidden = props.ifOverflow === 'hidden';
    var clipPath = isOverflowHidden ? "url(#".concat(clipPathId, ")") : undefined;
    return /*#__PURE__*/ $kc00y.createElement((0, $a6cde822fe24aa10$export$b37befaf92aba9f1), {
        zIndex: props.zIndex
    }, /*#__PURE__*/ $kc00y.createElement((0, $553c02c7047f2968$export$936d0764594b6eb3), {
        className: (0, $328c1c2632e2f292$export$4f5d2d50c9deca37)('recharts-reference-area', className)
    }, $8cb4b18eb8c67636$var$renderRect(shape, $8cb4b18eb8c67636$var$_objectSpread($8cb4b18eb8c67636$var$_objectSpread({
        clipPath: clipPath
    }, (0, $976509d5bd74ee3b$export$67f8fc03e57e2747)(props)), rect)), rect != null && /*#__PURE__*/ $kc00y.createElement((0, $ef6535e0015ddc73$export$3b4df77eaec10b03), $8cb4b18eb8c67636$var$_extends({}, rect, {
        lowerWidth: rect.width,
        upperWidth: rect.width
    }), /*#__PURE__*/ $kc00y.createElement((0, $ef6535e0015ddc73$export$3c82c3a3704539d8), {
        label: props.label
    }), props.children)));
}
var $8cb4b18eb8c67636$export$82d1d8931e927505 = {
    ifOverflow: 'discard',
    xAxisId: 0,
    yAxisId: 0,
    radius: 0,
    fill: '#ccc',
    label: false,
    fillOpacity: 0.5,
    stroke: 'none',
    strokeWidth: 1,
    zIndex: (0, $2d4105c5b5d94e8f$export$96df16b28aa32702).area
};
function $8cb4b18eb8c67636$export$b4ec4f050ce240b9(outsideProps) {
    var props = (0, $4cc2299923ef69c7$export$45004cc70a390ee8)(outsideProps, $8cb4b18eb8c67636$export$82d1d8931e927505);
    return /*#__PURE__*/ $kc00y.createElement($kc00y.Fragment, null, /*#__PURE__*/ $kc00y.createElement($8cb4b18eb8c67636$var$ReportReferenceArea, {
        yAxisId: props.yAxisId,
        xAxisId: props.xAxisId,
        ifOverflow: props.ifOverflow,
        x1: props.x1,
        x2: props.x2,
        y1: props.y1,
        y2: props.y2
    }), /*#__PURE__*/ $kc00y.createElement($8cb4b18eb8c67636$var$ReferenceAreaImpl, props));
}
$8cb4b18eb8c67636$export$b4ec4f050ce240b9.displayName = 'ReferenceArea';


var $kc00y = parcelRequire("kc00y");

















function $b2123472eb47efeb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b2123472eb47efeb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b2123472eb47efeb$var$ownKeys(Object(t), !0).forEach(function(r) {
            $b2123472eb47efeb$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b2123472eb47efeb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b2123472eb47efeb$var$_defineProperty(e, r, t) {
    return (r = $b2123472eb47efeb$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $b2123472eb47efeb$var$_toPropertyKey(t) {
    var i = $b2123472eb47efeb$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $b2123472eb47efeb$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $b2123472eb47efeb$var$_extends() {
    return $b2123472eb47efeb$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $b2123472eb47efeb$var$_extends.apply(null, arguments);
}
/**
 * Single point that defines one end of a segment.
 * These coordinates are in data space, meaning that you should provide
 * values that correspond to the data domain of the axes.
 * So you would provide a value of `Page A` to indicate the data value `Page A`
 * and then recharts will convert that to pixels.
 *
 * Likewise for numbers. If your x-axis goes from 0 to 100,
 * and you want the line to end at 50, you would provide `50` here.
 *
 * @inline
 */ /**
 * This excludes `viewBox` prop from svg for two reasons:
 * 1. The components wants viewBox of object type, and svg wants string
 *    - so there's a conflict, and the component will throw if it gets string
 * 2. Internally the component calls `svgPropertiesNoEvents` which filters the viewBox away anyway
 */ var $b2123472eb47efeb$var$renderLine = (option, props)=>{
    var line;
    if (/*#__PURE__*/ $kc00y.isValidElement(option)) // @ts-expect-error element cloning is not typed
    line = /*#__PURE__*/ $kc00y.cloneElement(option, props);
    else if (typeof option === 'function') line = option(props);
    else {
        if (!(0, $22869ac8a5888437$export$f8a8fc612ced9bb0)(props.x1) || !(0, $22869ac8a5888437$export$f8a8fc612ced9bb0)(props.y1) || !(0, $22869ac8a5888437$export$f8a8fc612ced9bb0)(props.x2) || !(0, $22869ac8a5888437$export$f8a8fc612ced9bb0)(props.y2)) return null;
        line = /*#__PURE__*/ $kc00y.createElement("line", $b2123472eb47efeb$var$_extends({}, props, {
            className: "recharts-reference-line-line"
        }));
    }
    return line;
};
var $b2123472eb47efeb$var$getHorizontalLineEndPoints = (yCoord, ifOverflow, position, yAxisOrientation, yAxisScale, viewBox)=>{
    var { x: x, width: width } = viewBox;
    var coord = yAxisScale.map(yCoord, {
        position: position
    });
    // don't render the line if the scale can't compute a result that makes sense
    if (!(0, $22869ac8a5888437$export$f8a8fc612ced9bb0)(coord)) return null;
    if (ifOverflow === 'discard' && !yAxisScale.isInRange(coord)) return null;
    var points = [
        {
            x: x + width,
            y: coord
        },
        {
            x: x,
            y: coord
        }
    ];
    return yAxisOrientation === 'left' ? points.reverse() : points;
};
var $b2123472eb47efeb$var$getVerticalLineEndPoints = (xCoord, ifOverflow, position, xAxisOrientation, xAxisScale, viewBox)=>{
    var { y: y, height: height } = viewBox;
    var coord = xAxisScale.map(xCoord, {
        position: position
    });
    // don't render the line if the scale can't compute a result that makes sense
    if (!(0, $22869ac8a5888437$export$f8a8fc612ced9bb0)(coord)) return null;
    if (ifOverflow === 'discard' && !xAxisScale.isInRange(coord)) return null;
    var points = [
        {
            x: coord,
            y: y + height
        },
        {
            x: coord,
            y: y
        }
    ];
    return xAxisOrientation === 'top' ? points.reverse() : points;
};
var $b2123472eb47efeb$var$getSegmentLineEndPoints = (segment, ifOverflow, position, scales)=>{
    var points = [
        scales.mapWithFallback(segment[0], {
            position: position,
            fallback: 'rangeMin'
        }),
        scales.mapWithFallback(segment[1], {
            position: position,
            fallback: 'rangeMax'
        })
    ];
    if (ifOverflow === 'discard' && points.some((p)=>!scales.isInRange(p))) return null;
    return points;
};
var $b2123472eb47efeb$export$f273d496b213b6da = (xAxisScale, yAxisScale, viewBox, position, xAxisOrientation, yAxisOrientation, props)=>{
    var { x: xCoord, y: yCoord, segment: segment, ifOverflow: ifOverflow } = props;
    var isFixedX = (0, $7e613228d3a31273$export$402a499e1ea44294)(xCoord);
    var isFixedY = (0, $7e613228d3a31273$export$402a499e1ea44294)(yCoord);
    if (isFixedY) return $b2123472eb47efeb$var$getHorizontalLineEndPoints(yCoord, ifOverflow, position, yAxisOrientation, yAxisScale, viewBox);
    if (isFixedX) return $b2123472eb47efeb$var$getVerticalLineEndPoints(xCoord, ifOverflow, position, xAxisOrientation, xAxisScale, viewBox);
    if (segment != null && segment.length === 2) return $b2123472eb47efeb$var$getSegmentLineEndPoints(segment, ifOverflow, position, new (0, $49c74039a3e5243a$export$eeb48dcb95ffc5ac)({
        x: xAxisScale,
        y: yAxisScale
    }));
    return null;
};
function $b2123472eb47efeb$var$ReportReferenceLine(props) {
    var dispatch = (0, $a441e801d1b41b52$export$f51d452c10d5b956)();
    (0, $kc00y.useEffect)(()=>{
        dispatch((0, $bf04bdacfe1441a0$export$a9ce8e8146745e3e)(props));
        return ()=>{
            dispatch((0, $bf04bdacfe1441a0$export$fd7919a5491769ec)(props));
        };
    });
    return null;
}
function $b2123472eb47efeb$var$ReferenceLineImpl(props) {
    var { xAxisId: xAxisId, yAxisId: yAxisId, shape: shape, className: className, ifOverflow: ifOverflow } = props;
    var isPanorama = (0, $10d1d693b6b228cd$export$4b0c59f8845ba920)();
    var clipPathId = (0, $dca5c408371f3cf1$export$71e825c43eae6ca6)();
    var xAxis = (0, $a441e801d1b41b52$export$a7347740d65f620b)((state)=>(0, $223cdb002ac9c48b$export$d6895d8ddb4cee5)(state, xAxisId));
    var yAxis = (0, $a441e801d1b41b52$export$a7347740d65f620b)((state)=>(0, $223cdb002ac9c48b$export$1f472705a332f1c9)(state, yAxisId));
    var xAxisScale = (0, $a441e801d1b41b52$export$a7347740d65f620b)((state)=>(0, $223cdb002ac9c48b$export$22e8e5f8924724ea)(state, 'xAxis', xAxisId, isPanorama));
    var yAxisScale = (0, $a441e801d1b41b52$export$a7347740d65f620b)((state)=>(0, $223cdb002ac9c48b$export$22e8e5f8924724ea)(state, 'yAxis', yAxisId, isPanorama));
    var viewBox = (0, $f4c9341f05a18477$export$76b29bb074e0c45a)();
    if (!clipPathId || !viewBox || xAxis == null || yAxis == null || xAxisScale == null || yAxisScale == null) return null;
    var endPoints = $b2123472eb47efeb$export$f273d496b213b6da(xAxisScale, yAxisScale, viewBox, props.position, xAxis.orientation, yAxis.orientation, props);
    if (!endPoints) return null;
    var point1 = endPoints[0];
    var point2 = endPoints[1];
    if (point1 == null || point2 == null) return null;
    var { x: x1, y: y1 } = point1;
    var { x: x2, y: y2 } = point2;
    var clipPath = ifOverflow === 'hidden' ? "url(#".concat(clipPathId, ")") : undefined;
    var lineProps = $b2123472eb47efeb$var$_objectSpread($b2123472eb47efeb$var$_objectSpread({
        clipPath: clipPath
    }, (0, $976509d5bd74ee3b$export$67f8fc03e57e2747)(props)), {}, {
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
    });
    var rect = (0, $db33454bda932a01$export$6df2062b9e15eec0)({
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
    });
    return /*#__PURE__*/ $kc00y.createElement((0, $a6cde822fe24aa10$export$b37befaf92aba9f1), {
        zIndex: props.zIndex
    }, /*#__PURE__*/ $kc00y.createElement((0, $553c02c7047f2968$export$936d0764594b6eb3), {
        className: (0, $328c1c2632e2f292$export$4f5d2d50c9deca37)('recharts-reference-line', className)
    }, $b2123472eb47efeb$var$renderLine(shape, lineProps), /*#__PURE__*/ $kc00y.createElement((0, $ef6535e0015ddc73$export$3b4df77eaec10b03), $b2123472eb47efeb$var$_extends({}, rect, {
        lowerWidth: rect.width,
        upperWidth: rect.width
    }), /*#__PURE__*/ $kc00y.createElement((0, $ef6535e0015ddc73$export$3c82c3a3704539d8), {
        label: props.label
    }), props.children)));
}
var $b2123472eb47efeb$export$c084f126baa053c2 = {
    ifOverflow: 'discard',
    xAxisId: 0,
    yAxisId: 0,
    fill: 'none',
    label: false,
    stroke: '#ccc',
    fillOpacity: 1,
    strokeWidth: 1,
    position: 'middle',
    zIndex: (0, $2d4105c5b5d94e8f$export$96df16b28aa32702).line
};
function $b2123472eb47efeb$export$b2f28e248e7838eb(outsideProps) {
    var props = (0, $4cc2299923ef69c7$export$45004cc70a390ee8)(outsideProps, $b2123472eb47efeb$export$c084f126baa053c2);
    return /*#__PURE__*/ $kc00y.createElement($kc00y.Fragment, null, /*#__PURE__*/ $kc00y.createElement($b2123472eb47efeb$var$ReportReferenceLine, {
        yAxisId: props.yAxisId,
        xAxisId: props.xAxisId,
        ifOverflow: props.ifOverflow,
        x: props.x,
        y: props.y,
        segment: props.segment
    }), /*#__PURE__*/ $kc00y.createElement($b2123472eb47efeb$var$ReferenceLineImpl, props));
}
$b2123472eb47efeb$export$b2f28e248e7838eb.displayName = 'ReferenceLine';


const $e51454bc4e60e998$export$ae027ca1e1457159 = (data, config)=>{
    // Extraire toutes les clés de dataConfig
    const configKeys = Object.keys(config);
    // Mapped les data d'après la valeur de la config
    return data.map((item)=>{
        const transformedItem = {};
        // Itérer sur toutes les clés de la configuration et construire l'objet
        configKeys.forEach((configKey)=>{
            // Clé correspondante dans `data`
            const dataKey = config[configKey];
            // Associer la valeur depuis `data`
            transformedItem[configKey] = item[dataKey] ? item[dataKey] : dataKey;
        });
        return transformedItem;
    });
};
const $e51454bc4e60e998$export$2df36521d18abca0 = (data, config)=>{
    // Extraire toutes les clés de dataConfig
    const configKeys = [
        "value",
        "max"
    ];
    // Mapped les data d'après la valeur de la config
    return data.map((item)=>{
        const transformedItem = {};
        // Itérer sur toutes les clés de la configuration et construire l'objet
        configKeys.forEach((configKey)=>{
            // Clé correspondante dans `data`
            const dataKey = config[configKey];
            // Associer la valeur depuis `data`
            transformedItem[configKey] = item[dataKey] ? item[dataKey] : dataKey;
        });
        return transformedItem;
    });
};
const $e51454bc4e60e998$export$44bc31952417c181 = (data, config)=>{
    // Mapped les data d'après la valeur de la config
    return data.map((item)=>{
        const transformedItem = {};
        // Itérer sur toutes les clés de la configuration et construire l'objet
        config.forEach((configKey)=>{
            // Associer la valeur depuis `data`
            transformedItem[configKey] = item[configKey] ?? configKey;
        });
        return transformedItem;
    });
};


// Utilisations d'interfaces et pas de types, car cela définit
// les contrats auquel les objets doivent se conformer.
parcelRequire("kc00y");
const $d5bd75e66eb45272$export$3e62118628dfb30f = [
    {
        color: "#2ecc71",
        max: 25
    },
    {
        color: "#f1c40f",
        max: 50
    },
    {
        color: "#e67e22",
        max: 75
    }
];
var $d5bd75e66eb45272$export$df54d73aa0ec5e82 = /*#__PURE__*/ function(Orientation) {
    Orientation["HORIZONTAL"] = "horizontal";
    Orientation["VERTICAL"] = "vertical";
    return Orientation;
}({});
var $d5bd75e66eb45272$export$892566d2cc725f39 = /*#__PURE__*/ function(Alignement) {
    Alignement["TOP"] = "top";
    Alignement["LEFT"] = "left";
    Alignement["BOTTOM"] = "bottom";
    return Alignement;
}({});
var $d5bd75e66eb45272$export$e9cc541a1d84538e = /*#__PURE__*/ function(ColorMode) {
    ColorMode["SOLID"] = "solid";
    ColorMode["GRADIANT"] = "gradient";
    return ColorMode;
}({});


const $ee4ed2d6fbcb6852$export$7eb5fca2de5ef61d = (rawData, config)=>{
    return (0, $e51454bc4e60e998$export$ae027ca1e1457159)(rawData, config).map((item)=>{
        // Conversion robuste en nombre (gère les zéros, vides, NaN)
        const v = Number(item.value) ?? 0;
        const m = Number(item.max) ?? 0;
        const pct = Number.isFinite(v) && Number.isFinite(m) && m > 0 ? v / m * 100 : 0;
        return {
            ...item,
            value: v,
            max: m,
            percentage: Math.max(0, Math.min(100, pct))
        };
    });
};
const $ee4ed2d6fbcb6852$export$c08e6c6c0a6a3918 = (config)=>{
    const hasLimits = Array.isArray(config?.limits) && config.limits.length > 0;
    return config?.colorMode === (0, $d5bd75e66eb45272$export$e9cc541a1d84538e).GRADIANT || config?.colorMode == null && (hasLimits || config?.useThresholdColors === true);
};
const $ee4ed2d6fbcb6852$export$b75ee8378911c749 = (config, useThresholdColors)=>{
    if (!useThresholdColors) return [];
    const highColor = config?.highColor || "#e74c3c";
    const rawLimits = Array.isArray(config?.limits) ? config.limits : [];
    const limits = rawLimits.map((l)=>({
            color: l.color || "#cccccc",
            max: Number(l.max)
        })).filter((l)=>!Number.isNaN(l.max)).sort((a, b)=>a.max - b.max).map((l)=>({
            color: l.color,
            max: Math.max(0, Math.min(100, l.max))
        }));
    const sections = [];
    let prev = 0;
    for (const lim of limits){
        const to = Math.max(prev, lim.max);
        if (to > prev) sections.push({
            from: prev,
            to: to,
            color: lim.color
        });
        prev = to;
    }
    if (sections.length === 0) return [
        {
            from: 0,
            to: 25,
            color: "#2ecc71"
        },
        {
            from: 25,
            to: 50,
            color: "#f1c40f"
        },
        {
            from: 50,
            to: 75,
            color: "#e67e22"
        },
        {
            from: 75,
            to: 100,
            color: "#e74c3c"
        }
    ];
    if (prev < 100) sections.push({
        from: prev,
        to: 100,
        color: highColor
    });
    return sections;
};
const $ee4ed2d6fbcb6852$export$3e2882e0396577b7 = (sections)=>{
    if (sections.length === 0) return [
        25,
        50,
        75,
        100
    ];
    return Array.from(new Set(sections.map((s)=>Math.round(s.to)))).filter((val)=>val > 0 && val <= 100).sort((a, b)=>a - b);
};
const $ee4ed2d6fbcb6852$export$ab23858d9d410aae = (pct, sections, barColor)=>{
    for (const sec of sections){
        if (pct >= sec.from && pct <= sec.to) return sec.color;
    }
    return barColor;
};
const $ee4ed2d6fbcb6852$export$a5dbcc48e08b9101 = (sections)=>sections.map((sec)=>({
            value: `${Math.round(sec.from)}\u{2013}${Math.round(sec.to)}%`,
            type: "square",
            id: `${sec.from}-${sec.to}`,
            color: sec.color
        }));



const $871fd39ac38678ee$var$BaseBarChart = ({ data: data, config: config, layout: layout, xAxis: xAxis, yAxis: yAxis, legendPosition: legendPosition, margin: margin })=>{
    if (!data || data.length === 0) return null;
    const barColor = config?.barColor || "#00293e";
    const convertedData = (0, $ee4ed2d6fbcb6852$export$7eb5fca2de5ef61d)(data, config);
    const useThresholdColors = (0, $ee4ed2d6fbcb6852$export$c08e6c6c0a6a3918)(config);
    const sections = (0, $ee4ed2d6fbcb6852$export$b75ee8378911c749)(config, useThresholdColors);
    const thresholdLines = (0, $ee4ed2d6fbcb6852$export$3e2882e0396577b7)(sections);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ffea1da660acf881$export$e60a4704009a0009), {
        width: "100%",
        height: "100%",
        initialDimension: {
            width: 400,
            height: 300
        },
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $67563287da1fa124$export$94aefc399ef206a9), {
            data: convertedData,
            layout: layout,
            margin: margin,
            children: [
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $25891dc342f401f2$export$6440e27b9f186856), {
                    strokeDasharray: "3 3"
                }),
                useThresholdColors && sections.map((sec, idx)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8cb4b18eb8c67636$export$b4ec4f050ce240b9), {
                        ...layout === (0, $d5bd75e66eb45272$export$df54d73aa0ec5e82).VERTICAL ? {
                            x1: sec.from,
                            x2: sec.to
                        } : {
                            y1: sec.from,
                            y2: sec.to
                        },
                        fill: sec.color,
                        fillOpacity: 0.12,
                        ifOverflow: "extendDomain"
                    }, idx)),
                thresholdLines.map((val)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b2123472eb47efeb$export$b2f28e248e7838eb), {
                        ...layout === (0, $d5bd75e66eb45272$export$df54d73aa0ec5e82).VERTICAL ? {
                            x: val
                        } : {
                            y: val
                        },
                        stroke: "#9aa0a6",
                        strokeDasharray: "4 4"
                    }, val)),
                legendPosition === (0, $d5bd75e66eb45272$export$892566d2cc725f39).TOP && sections.length > 0 && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2865094c59f6e421$export$ed247974535929c7), {
                    verticalAlign: (0, $d5bd75e66eb45272$export$892566d2cc725f39).TOP,
                    align: "left",
                    wrapperStyle: {
                        paddingBottom: 8
                    },
                    content: ()=>{
                        const items = (0, $ee4ed2d6fbcb6852$export$a5dbcc48e08b9101)(sections);
                        return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                            style: {
                                display: "flex",
                                gap: "16px"
                            },
                            children: items.map((item)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                                    style: {
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "8px"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                            style: {
                                                width: "12px",
                                                height: "12px",
                                                backgroundColor: item.color,
                                                borderRadius: "2px"
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("span", {
                                            children: item.value
                                        })
                                    ]
                                }, item.id))
                        });
                    }
                }),
                xAxis,
                yAxis,
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $0bd1ee086eb8e81c$export$28c660c63b792dea), {
                    formatter: (value)=>`${value.toFixed(2)}%`
                }),
                useThresholdColors ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec65bf22e0d120c5$export$bbc6c6369b38e3d1), {
                    dataKey: "percentage",
                    barSize: 20,
                    legendType: "square",
                    shape: (props)=>{
                        const { x: x, y: y, width: width, height: height, payload: payload } = props;
                        const fill = (0, $ee4ed2d6fbcb6852$export$ab23858d9d410aae)(payload.percentage, sections, barColor);
                        return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("rect", {
                            x: x,
                            y: y,
                            width: width,
                            height: height,
                            fill: fill
                        });
                    }
                }) : /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec65bf22e0d120c5$export$bbc6c6369b38e3d1), {
                    dataKey: "percentage",
                    barSize: 20,
                    fill: barColor
                }),
                legendPosition === (0, $d5bd75e66eb45272$export$892566d2cc725f39).BOTTOM && sections.length > 0 && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2865094c59f6e421$export$ed247974535929c7), {
                    verticalAlign: (0, $d5bd75e66eb45272$export$892566d2cc725f39).BOTTOM,
                    align: "left",
                    wrapperStyle: {
                        paddingBottom: 8
                    },
                    content: ()=>{
                        const items = (0, $ee4ed2d6fbcb6852$export$a5dbcc48e08b9101)(sections);
                        return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                            style: {
                                display: "flex",
                                gap: "16px"
                            },
                            children: items.map((item)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                                    style: {
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "8px"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                            style: {
                                                width: "12px",
                                                height: "12px",
                                                backgroundColor: item.color,
                                                borderRadius: "2px"
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("span", {
                                            children: item.value
                                        })
                                    ]
                                }, item.id))
                        });
                    }
                })
            ]
        })
    });
};
var $871fd39ac38678ee$export$2e2bcd8739ae039 = $871fd39ac38678ee$var$BaseBarChart;



const $3f57840356a3a115$var$HorizontalChartComponent = ({ data: data, config: config })=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $871fd39ac38678ee$export$2e2bcd8739ae039), {
        data: data,
        config: config,
        layout: (0, $d5bd75e66eb45272$export$df54d73aa0ec5e82).VERTICAL,
        legendPosition: (0, $d5bd75e66eb45272$export$892566d2cc725f39).BOTTOM,
        margin: {
            top: 20,
            right: 30,
            left: 40,
            bottom: 5
        },
        xAxis: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $f743299137566a63$export$ea77231de273b52d), {
            type: "number",
            domain: [
                0,
                100
            ],
            tickFormatter: (tick)=>`${tick}%`
        }),
        yAxis: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $a1266b4e1aea7f0c$export$f96c4024c52de8f4), {
            type: "category",
            dataKey: "name",
            width: 150
        })
    });
};
var $3f57840356a3a115$export$2e2bcd8739ae039 = $3f57840356a3a115$var$HorizontalChartComponent;







var $kc00y = parcelRequire("kc00y");

const $93c1c76d5e76086d$var$useChartColorConfig = ({ config: config, setConfig: setConfig, defaultLimits: defaultLimits })=>{
    // Initialiser limits une seule fois au montage, pas de synch constante
    const [limits, setLimits] = (0, $kc00y.useState)(()=>config.limits && config.limits.length > 0 ? config.limits : defaultLimits);
    // Mémoriser isGradient pour éviter les recalculs inutiles à chaque render
    const isGradient = (0, $kc00y.useMemo)(()=>config.colorMode === (0, $d5bd75e66eb45272$export$e9cc541a1d84538e).GRADIANT || config.colorMode == null && limits.length > 0, [
        config.colorMode,
        limits.length
    ]);
    // Initialiser les limites par défaut uniquement au changement du colorMode
    (0, $kc00y.useEffect)(()=>{
        if (config.colorMode === (0, $d5bd75e66eb45272$export$e9cc541a1d84538e).GRADIANT && (!Array.isArray(config.limits) || config.limits.length === 0) && limits.length === 0) {
            setLimits(defaultLimits);
            setConfig({
                ...config,
                limits: defaultLimits,
                highColor: config.highColor || "#e74c3c",
                colorMode: (0, $d5bd75e66eb45272$export$e9cc541a1d84538e).GRADIANT
            });
        }
    }, [
        config.colorMode,
        setConfig,
        config,
        defaultLimits,
        limits.length
    ]);
    const updateConfig = (field, value)=>{
        setConfig({
            ...config,
            [field]: value
        });
    };
    const updateLimits = (newLimits)=>{
        setLimits(newLimits);
        setConfig({
            ...config,
            limits: newLimits
        });
    };
    const handleColorChange = (index, color)=>{
        const updated = [
            ...limits
        ];
        updated[index].color = color;
        updateLimits(updated);
    };
    const handleMaxChange = (index, max)=>{
        const updated = [
            ...limits
        ];
        updated[index].max = max;
        updateLimits(updated);
    };
    const addLimit = ()=>{
        updateLimits([
            ...limits,
            {
                color: "#000000",
                max: 0
            }
        ]);
    };
    const removeLimit = (index)=>{
        updateLimits(limits.filter((_, i)=>i !== index));
    };
    return {
        limits: limits,
        isGradient: isGradient,
        updateConfig: updateConfig,
        handleColorChange: handleColorChange,
        handleMaxChange: handleMaxChange,
        addLimit: addLimit,
        removeLimit: removeLimit
    };
};
var $93c1c76d5e76086d$export$2e2bcd8739ae039 = $93c1c76d5e76086d$var$useChartColorConfig;





const $52209629f818213b$var$GradientSection = ({ limits: limits, config: config, updateConfig: updateConfig, handleColorChange: handleColorChange, handleMaxChange: handleMaxChange, addLimit: addLimit, removeLimit: removeLimit })=>{
    const styleForm = {
        width: "100px",
        marginRight: "10px"
    };
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Label, {
                className: "fw-bold mt-2",
                children: "Paliers des sections :"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
            limits.map((limit, index)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                    style: {
                        marginBottom: "10px",
                        display: "flex",
                        alignItems: "center"
                    },
                    children: [
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Control, {
                            type: "color",
                            defaultValue: limit.color,
                            onBlur: (e)=>handleColorChange(index, e.target.value),
                            style: {
                                width: "40px",
                                marginRight: "10px"
                            }
                        }),
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Control, {
                            type: "number",
                            disabled: true,
                            value: index === 0 ? 0 : limits[index - 1]?.max ?? 0,
                            style: styleForm
                        }),
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Control, {
                            type: "number",
                            defaultValue: limit.max,
                            onBlur: (e)=>handleMaxChange(index, parseInt(e.target.value, 10)),
                            style: styleForm
                        }),
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                            variant: "warning",
                            onClick: ()=>removeLimit(index),
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$4d4e10ce882b8153), {})
                        })
                    ]
                }, index)),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                style: {
                    marginBottom: "10px",
                    display: "flex",
                    alignItems: "center"
                },
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Control, {
                        type: "color",
                        defaultValue: config.highColor || "#12ca15",
                        onBlur: (e)=>updateConfig("highColor", e.target.value),
                        style: {
                            width: "40px",
                            marginRight: "10px"
                        }
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Control, {
                        type: "number",
                        disabled: true,
                        value: limits.length > 0 ? limits[limits.length - 1].max ?? 0 : 75,
                        style: styleForm
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Control, {
                        type: "number",
                        disabled: true,
                        value: "100",
                        style: styleForm
                    })
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                variant: "primary",
                className: "mt-3",
                onClick: addLimit,
                children: "Ajouter un palier"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {})
        ]
    });
};
var $52209629f818213b$export$2e2bcd8739ae039 = $52209629f818213b$var$GradientSection;



const $cdbfc22e1a1d23b2$var$BaseChartConfig = ({ config: config, setConfig: setConfig, fieldOptions: fieldOptions, defaultLimits: defaultLimits, children: children })=>{
    const { limits: limits, isGradient: isGradient, updateConfig: updateConfig, handleColorChange: handleColorChange, handleMaxChange: handleMaxChange, addLimit: addLimit, removeLimit: removeLimit } = (0, $93c1c76d5e76086d$export$2e2bcd8739ae039)({
        config: config,
        setConfig: setConfig,
        defaultLimits: defaultLimits
    });
    const getFieldValue = (field)=>fieldOptions.find((o)=>o.value === config[field]) || "";
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$d6701e98ab1a6725), {
                name: "name",
                label: "Libell\xe9",
                defaultValue: getFieldValue("name"),
                options: fieldOptions,
                onChange: (v)=>updateConfig("name", v.value),
                getOptionLabel: (option)=>option.value,
                getOptionValue: (option)=>option.value
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$d6701e98ab1a6725), {
                name: "value",
                label: "Valeur initiale",
                defaultValue: getFieldValue("value"),
                options: fieldOptions,
                onChange: (v)=>updateConfig("value", v.value),
                getOptionLabel: (option)=>option.value,
                getOptionValue: (option)=>option.value
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$d6701e98ab1a6725), {
                name: "max",
                label: "Valeur maximum",
                defaultValue: getFieldValue("max"),
                options: fieldOptions,
                onChange: (v)=>updateConfig("max", v.value),
                getOptionLabel: (option)=>option.value,
                getOptionValue: (option)=>option.value
            }),
            children,
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Label, {
                className: "fw-bold mt-3",
                children: "Mode de couleur :"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Check, {
                        type: "radio",
                        label: "Couleur unie",
                        checked: !isGradient,
                        onChange: ()=>updateConfig("colorMode", (0, $d5bd75e66eb45272$export$e9cc541a1d84538e).SOLID)
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Check, {
                        type: "radio",
                        label: "D\xe9grad\xe9 de couleurs",
                        checked: isGradient,
                        onChange: ()=>updateConfig("colorMode", (0, $d5bd75e66eb45272$export$e9cc541a1d84538e).GRADIANT)
                    })
                ]
            }),
            !isGradient && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Label, {
                        className: "fw-bold mt-3",
                        children: "Couleur des barres :"
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Control, {
                        type: "color",
                        defaultValue: config.barColor || "#00293e",
                        onBlur: (e)=>updateConfig("barColor", e.target.value),
                        style: {
                            width: "100px",
                            height: "40px"
                        }
                    })
                ]
            }),
            isGradient && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $52209629f818213b$export$2e2bcd8739ae039), {
                limits: limits,
                config: config,
                updateConfig: updateConfig,
                handleColorChange: handleColorChange,
                handleMaxChange: handleMaxChange,
                addLimit: addLimit,
                removeLimit: removeLimit
            })
        ]
    });
};
var $cdbfc22e1a1d23b2$export$2e2bcd8739ae039 = $cdbfc22e1a1d23b2$var$BaseChartConfig;



const $2186c66ed3f124b7$var$HorizontalChartConfig = (props)=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $cdbfc22e1a1d23b2$export$2e2bcd8739ae039), {
        ...props,
        defaultLimits: (0, $d5bd75e66eb45272$export$3e62118628dfb30f)
    });
};
var $2186c66ed3f124b7$export$2e2bcd8739ae039 = $2186c66ed3f124b7$var$HorizontalChartConfig;






const $a9d4cdc42d828ad9$var$VerticalChartComponent = ({ data: data, config: config })=>{
    const xAxisOrientation = config?.xAxisOrientation || 0;
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $871fd39ac38678ee$export$2e2bcd8739ae039), {
        data: data,
        config: config,
        layout: (0, $d5bd75e66eb45272$export$df54d73aa0ec5e82).HORIZONTAL,
        legendPosition: (0, $d5bd75e66eb45272$export$892566d2cc725f39).TOP,
        margin: {
            top: 20,
            right: 30,
            left: 40,
            bottom: xAxisOrientation !== 0 ? 80 : 5
        },
        xAxis: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $f743299137566a63$export$ea77231de273b52d), {
            type: "category",
            dataKey: "name",
            angle: xAxisOrientation,
            textAnchor: xAxisOrientation !== 0 ? "end" : "middle",
            height: xAxisOrientation !== 0 ? 80 : 30
        }),
        yAxis: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $a1266b4e1aea7f0c$export$f96c4024c52de8f4), {
            type: "number",
            domain: [
                0,
                100
            ],
            tickFormatter: (tick)=>`${tick}%`
        })
    });
};
var $a9d4cdc42d828ad9$export$2e2bcd8739ae039 = $a9d4cdc42d828ad9$var$VerticalChartComponent;





const $f9d87e59e8ad220a$var$AxisOrientationConfig = ({ value: value, onChange: onChange })=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Label, {
                className: "fw-bold mt-3",
                children: "Orientation de l'axe X :"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                style: {
                    display: "flex",
                    alignItems: "center",
                    gap: "15px",
                    marginBottom: "15px"
                },
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Range, {
                        min: -90,
                        max: 0,
                        step: 5,
                        value: value,
                        onChange: (e)=>onChange(Number(e.target.value)),
                        style: {
                            width: "200px"
                        }
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Control, {
                        type: "number",
                        min: -90,
                        max: 0,
                        value: value,
                        onChange: (e)=>onChange(Number(e.target.value)),
                        style: {
                            width: "80px"
                        }
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("span", {
                        children: "\xb0"
                    })
                ]
            })
        ]
    });
};
var $f9d87e59e8ad220a$export$2e2bcd8739ae039 = $f9d87e59e8ad220a$var$AxisOrientationConfig;




const $84dcde0cc8743aa8$var$VerticalChartConfig = ({ config: config, setConfig: setConfig, fieldOptions: fieldOptions })=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $cdbfc22e1a1d23b2$export$2e2bcd8739ae039), {
        config: config,
        setConfig: setConfig,
        fieldOptions: fieldOptions,
        defaultLimits: (0, $d5bd75e66eb45272$export$3e62118628dfb30f),
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $f9d87e59e8ad220a$export$2e2bcd8739ae039), {
            value: config.xAxisOrientation || 0,
            onChange: (value)=>setConfig({
                    ...config,
                    xAxisOrientation: value
                })
        })
    });
};
var $84dcde0cc8743aa8$export$2e2bcd8739ae039 = $84dcde0cc8743aa8$var$VerticalChartConfig;




const $46089813f65271d1$var$CounterComponent = (data)=>{
    const valueColor = "#00293e";
    const valueSize = "40px";
    const labelSize = "20px";
    if (data.data) {
        // On map seulement les valeurs
        const dataMapped = (0, $e51454bc4e60e998$export$ae027ca1e1457159)(data.data, {
            value: data.config.value
        });
        let sumData = 0;
        dataMapped.forEach((data)=>{
            if (!isNaN(data.value)) sumData += data.value;
        });
        return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
            style: {
                textAlign: "center"
            },
            children: [
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                    style: {
                        fontSize: valueSize,
                        fontWeight: "bold",
                        color: valueColor
                    },
                    children: sumData
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                    style: {
                        fontSize: labelSize,
                        fontWeight: "normal",
                        color: "#666",
                        marginTop: "10px"
                    },
                    children: data.config.label
                })
            ]
        });
    }
};
var $46089813f65271d1$export$2e2bcd8739ae039 = $46089813f65271d1$var$CounterComponent;




const $7b8acf38a4c6a221$var$CounterConfig = (options)=>{
    // Valeur par défaut de `value`
    const fieldValue = options.fieldOptions.find((option)=>option.value === options.config.value) || "";
    // Valeur par défaut de `label`
    const fieldLabel = options.config.label || "";
    // Mettre à jour la config du composant avec la nouvelle valeur
    const handleChange = (fieldName, newValue)=>{
        const updatedConfig = {
            ...options.config
        };
        updatedConfig[fieldName] = newValue;
        options.setConfig(updatedConfig);
    };
    // Mettre à jour la valeur `label`
    const handleChangeLabel = (fieldName, newValue)=>{
        const updatedConfig = {
            ...options.config
        };
        updatedConfig[fieldName] = newValue;
        options.setConfig(updatedConfig);
    };
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                required: false,
                name: "label",
                label: "Libell\xe9",
                onChange: (e)=>handleChangeLabel("label", e.target.value),
                value: fieldLabel
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$d6701e98ab1a6725), {
                required: false,
                name: "value",
                label: "Somme de",
                onChange: (value)=>handleChange("value", value.value),
                defaultValue: fieldValue,
                options: options.fieldOptions,
                getOptionLabel: (option)=>option.value,
                getOptionValue: (option)=>option.value
            })
        ]
    });
};
var $7b8acf38a4c6a221$export$2e2bcd8739ae039 = $7b8acf38a4c6a221$var$CounterConfig;




var $kc00y = parcelRequire("kc00y");
















var $f2e5001ad25b8b9e$export$1d9b78e3a3685311 = (state)=>state.graphicalItems.polarItems;
var $f2e5001ad25b8b9e$var$selectAxisPredicate = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    (0, $0356005269dcff20$export$8a7d579879340d98),
    (0, $8a59510828e5484a$export$6a2efa106dc9c8f6)
], (0, $223cdb002ac9c48b$export$a3923f321c6572c3));
var $f2e5001ad25b8b9e$export$cf006504ac494d1 = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $f2e5001ad25b8b9e$export$1d9b78e3a3685311,
    (0, $223cdb002ac9c48b$export$fc14c3706e09c50c),
    $f2e5001ad25b8b9e$var$selectAxisPredicate
], (0, $223cdb002ac9c48b$export$ad35679ce4582010));
var $f2e5001ad25b8b9e$var$selectPolarGraphicalItemsData = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $f2e5001ad25b8b9e$export$cf006504ac494d1
], (0, $223cdb002ac9c48b$export$d945cee965d266f0));
var $f2e5001ad25b8b9e$export$2a78a128a7055193 = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $f2e5001ad25b8b9e$var$selectPolarGraphicalItemsData,
    (0, $8c22b3d5bf36186c$export$3b10e41b7db2c36)
], (0, $223cdb002ac9c48b$export$c2c6d012cffe2c75));
var $f2e5001ad25b8b9e$export$9adf998427b6c073 = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $f2e5001ad25b8b9e$export$2a78a128a7055193,
    (0, $223cdb002ac9c48b$export$fc14c3706e09c50c),
    $f2e5001ad25b8b9e$export$cf006504ac494d1
], (0, $223cdb002ac9c48b$export$3051da2013ba9cfe));
var $f2e5001ad25b8b9e$export$a41fa0a103b05ea = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $f2e5001ad25b8b9e$export$2a78a128a7055193,
    (0, $223cdb002ac9c48b$export$fc14c3706e09c50c),
    $f2e5001ad25b8b9e$export$cf006504ac494d1
], (data, axisSettings, items)=>{
    if (items.length > 0) return data.flatMap((entry)=>{
        return items.flatMap((item)=>{
            var _axisSettings$dataKey;
            var valueByDataKey = (0, $d5958b0668c58531$export$f97fc4a450f29a)(entry, (_axisSettings$dataKey = axisSettings.dataKey) !== null && _axisSettings$dataKey !== void 0 ? _axisSettings$dataKey : item.dataKey);
            return {
                value: valueByDataKey,
                errorDomain: [] // polar charts do not have error bars
            };
        });
    }).filter(Boolean);
    if ((axisSettings === null || axisSettings === void 0 ? void 0 : axisSettings.dataKey) != null) return data.map((item)=>({
            value: (0, $d5958b0668c58531$export$f97fc4a450f29a)(item, axisSettings.dataKey),
            errorDomain: []
        }));
    return data.map((entry)=>({
            value: entry,
            errorDomain: []
        }));
});
var $f2e5001ad25b8b9e$var$unsupportedInPolarChart = ()=>undefined;
var $f2e5001ad25b8b9e$var$selectDomainOfAllPolarAppliedNumericalValues = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $f2e5001ad25b8b9e$export$2a78a128a7055193,
    (0, $223cdb002ac9c48b$export$fc14c3706e09c50c),
    $f2e5001ad25b8b9e$export$cf006504ac494d1,
    (0, $223cdb002ac9c48b$export$9429ab4550237b6d),
    (0, $0356005269dcff20$export$8a7d579879340d98),
    (0, $8c22b3d5bf36186c$export$e6f0a66ed1f5780f)
], (0, $223cdb002ac9c48b$export$df56c8e9a3e45e65));
var $f2e5001ad25b8b9e$var$selectPolarNumericalDomain = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    (0, $223cdb002ac9c48b$export$fc14c3706e09c50c),
    (0, $223cdb002ac9c48b$export$5d46410c3f089eb2),
    (0, $223cdb002ac9c48b$export$c21dc69ecce61f8a),
    $f2e5001ad25b8b9e$var$unsupportedInPolarChart,
    $f2e5001ad25b8b9e$var$selectDomainOfAllPolarAppliedNumericalValues,
    $f2e5001ad25b8b9e$var$unsupportedInPolarChart,
    (0, $f4c9341f05a18477$export$8426b6d9af801dee),
    (0, $0356005269dcff20$export$8a7d579879340d98)
], (0, $223cdb002ac9c48b$export$b9eca0fd568f66a4));
var $f2e5001ad25b8b9e$export$853e8eb91c358168 = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    (0, $223cdb002ac9c48b$export$fc14c3706e09c50c),
    (0, $f4c9341f05a18477$export$8426b6d9af801dee),
    $f2e5001ad25b8b9e$export$2a78a128a7055193,
    $f2e5001ad25b8b9e$export$9adf998427b6c073,
    (0, $1728a742f9386be1$export$73aff39176364def),
    (0, $0356005269dcff20$export$8a7d579879340d98),
    $f2e5001ad25b8b9e$var$selectPolarNumericalDomain
], (0, $223cdb002ac9c48b$export$70e6ef68424edf74));
var $f2e5001ad25b8b9e$export$e2d1beea1ea428fd = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $f2e5001ad25b8b9e$export$853e8eb91c358168,
    (0, $223cdb002ac9c48b$export$f5176fa96b596697),
    (0, $223cdb002ac9c48b$export$a1a58ca78bb13ce7)
], (0, $223cdb002ac9c48b$export$aa1ef6c8f610e48c));
var $f2e5001ad25b8b9e$export$5dd396e660cc1d86 = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    (0, $223cdb002ac9c48b$export$fc14c3706e09c50c),
    $f2e5001ad25b8b9e$export$853e8eb91c358168,
    $f2e5001ad25b8b9e$export$e2d1beea1ea428fd,
    (0, $0356005269dcff20$export$8a7d579879340d98)
], (0, $223cdb002ac9c48b$export$3a4530026b1860ff));
var $f2e5001ad25b8b9e$export$8667a1028ac2a3c5 = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    (0, $223cdb002ac9c48b$export$a1a58ca78bb13ce7),
    $f2e5001ad25b8b9e$export$5dd396e660cc1d86
], (0, $37a0c522921b7bfa$export$cd6ce636c480934e));


function $3e4db49ddc0ada48$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3e4db49ddc0ada48$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3e4db49ddc0ada48$var$ownKeys(Object(t), !0).forEach(function(r) {
            $3e4db49ddc0ada48$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3e4db49ddc0ada48$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $3e4db49ddc0ada48$var$_defineProperty(e, r, t) {
    return (r = $3e4db49ddc0ada48$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $3e4db49ddc0ada48$var$_toPropertyKey(t) {
    var i = $3e4db49ddc0ada48$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $3e4db49ddc0ada48$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $3e4db49ddc0ada48$var$pickId = (_state, id)=>id;
var $3e4db49ddc0ada48$var$selectSynchronisedPieSettings = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    (0, $f2e5001ad25b8b9e$export$1d9b78e3a3685311),
    $3e4db49ddc0ada48$var$pickId
], (graphicalItems, id)=>graphicalItems.filter((item)=>item.type === 'pie').find((item)=>item.id === id));
// Keep stable reference to an empty array to prevent re-renders
var $3e4db49ddc0ada48$var$emptyArray = [];
var $3e4db49ddc0ada48$var$pickCells = (_state, _id, cells)=>{
    if ((cells === null || cells === void 0 ? void 0 : cells.length) === 0) return $3e4db49ddc0ada48$var$emptyArray;
    return cells;
};
var $3e4db49ddc0ada48$export$6099ba314905f0c4 = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    (0, $8c22b3d5bf36186c$export$3b10e41b7db2c36),
    $3e4db49ddc0ada48$var$selectSynchronisedPieSettings,
    $3e4db49ddc0ada48$var$pickCells
], (_ref, pieSettings, cells)=>{
    var { chartData: chartData } = _ref;
    if (pieSettings == null) return undefined;
    var displayedData;
    if ((pieSettings === null || pieSettings === void 0 ? void 0 : pieSettings.data) != null && pieSettings.data.length > 0) displayedData = pieSettings.data;
    else displayedData = chartData;
    if ((!displayedData || !displayedData.length) && cells != null) displayedData = cells.map((cell)=>$3e4db49ddc0ada48$var$_objectSpread($3e4db49ddc0ada48$var$_objectSpread({}, pieSettings.presentationProps), cell.props));
    if (displayedData == null) return undefined;
    return displayedData;
});
var $3e4db49ddc0ada48$export$3b28bf469d4906d8 = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $3e4db49ddc0ada48$export$6099ba314905f0c4,
    $3e4db49ddc0ada48$var$selectSynchronisedPieSettings,
    $3e4db49ddc0ada48$var$pickCells
], (displayedData, pieSettings, cells)=>{
    if (displayedData == null || pieSettings == null) return undefined;
    return displayedData.map((entry, i)=>{
        var _cells$i;
        var name = (0, $d5958b0668c58531$export$f97fc4a450f29a)(entry, pieSettings.nameKey, pieSettings.name);
        var color;
        if (cells !== null && cells !== void 0 && (_cells$i = cells[i]) !== null && _cells$i !== void 0 && (_cells$i = _cells$i.props) !== null && _cells$i !== void 0 && _cells$i.fill) color = cells[i].props.fill;
        else if (typeof entry === 'object' && entry != null && 'fill' in entry) color = entry.fill;
        else color = pieSettings.fill;
        return {
            value: (0, $d5958b0668c58531$export$d3207de44081d2b3)(name, pieSettings.dataKey),
            color: color,
            // @ts-expect-error Legend payload.payload says it wants objects but our data can be unknown
            payload: entry,
            type: pieSettings.legendType
        };
    });
});
var $3e4db49ddc0ada48$export$c6af8a90408f4a64 = (0, $757e1d271f969f78$export$595d22ed68ca2841)([
    $3e4db49ddc0ada48$export$6099ba314905f0c4,
    $3e4db49ddc0ada48$var$selectSynchronisedPieSettings,
    $3e4db49ddc0ada48$var$pickCells,
    (0, $cd6092f0bbb953fd$export$1e34c8efb0bc9b3b)
], (displayedData, pieSettings, cells, offset)=>{
    if (pieSettings == null || displayedData == null) return undefined;
    return (0, $2aaafd309dd678f7$export$c404972144c91fdf)({
        offset: offset,
        pieSettings: pieSettings,
        displayedData: displayedData,
        cells: cells
    });
});




























var $2aaafd309dd678f7$var$_excluded = [
    "key"
], $2aaafd309dd678f7$var$_excluded2 = [
    "onMouseEnter",
    "onClick",
    "onMouseLeave"
], $2aaafd309dd678f7$var$_excluded3 = [
    "id"
], $2aaafd309dd678f7$var$_excluded4 = [
    "id"
];
function $2aaafd309dd678f7$var$_extends() {
    return $2aaafd309dd678f7$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $2aaafd309dd678f7$var$_extends.apply(null, arguments);
}
function $2aaafd309dd678f7$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $2aaafd309dd678f7$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $2aaafd309dd678f7$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $2aaafd309dd678f7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2aaafd309dd678f7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2aaafd309dd678f7$var$ownKeys(Object(t), !0).forEach(function(r) {
            $2aaafd309dd678f7$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2aaafd309dd678f7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $2aaafd309dd678f7$var$_defineProperty(e, r, t) {
    return (r = $2aaafd309dd678f7$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $2aaafd309dd678f7$var$_toPropertyKey(t) {
    var i = $2aaafd309dd678f7$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $2aaafd309dd678f7$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
/**
 * The `label` prop in Pie accepts a variety of alternatives.
 */ /**
 * We spread the data object into the sector data item,
 * so we can't really know what is going to be inside.
 *
 * This type represents our best effort, but it all depends on the input data
 * and what is inside of it.
 *
 * https://github.com/recharts/recharts/issues/6380
 * https://github.com/recharts/recharts/discussions/6375
 */ /**
 * Internal props, combination of external props + defaultProps + private Recharts state
 */ function $2aaafd309dd678f7$var$SetPiePayloadLegend(props) {
    var cells = (0, $kc00y.useMemo)(()=>(0, $b54930f6e6643156$export$fdd5e64c0e8495bb)(props.children, (0, $af579bd742156f26$export$f6f0c3fe4ec306ea)), [
        props.children
    ]);
    var legendPayload = (0, $a441e801d1b41b52$export$a7347740d65f620b)((state)=>(0, $3e4db49ddc0ada48$export$3b28bf469d4906d8)(state, props.id, cells));
    if (legendPayload == null) return null;
    return /*#__PURE__*/ $kc00y.createElement((0, $969c2df561fbe708$export$eb937fedea4aab3a), {
        legendPayload: legendPayload
    });
}
function $2aaafd309dd678f7$var$getActiveShapeFill(activeShape) {
    // activeShape can be boolean/function/element/object; only element/object can carry a static fill value.
    if (activeShape == null || typeof activeShape === 'boolean' || typeof activeShape === 'function') return undefined;
    if (/*#__PURE__*/ $kc00y.isValidElement(activeShape)) {
        var _activeShape$props;
        // React element form: <Sector fill="..."/> or custom element with fill prop.
        var _fill = (_activeShape$props = activeShape.props) === null || _activeShape$props === void 0 ? void 0 : _activeShape$props.fill;
        return typeof _fill === 'string' ? _fill : undefined;
    }
    var { fill: fill } = activeShape;
    return typeof fill === 'string' ? fill : undefined;
}
var $2aaafd309dd678f7$var$SetPieTooltipEntrySettings = /*#__PURE__*/ $kc00y.memo((_ref)=>{
    var { dataKey: dataKey, nameKey: nameKey, sectors: sectors, stroke: stroke, strokeWidth: strokeWidth, fill: fill, name: name, hide: hide, tooltipType: tooltipType, id: id, activeShape: activeShape } = _ref;
    var activeShapeFill = $2aaafd309dd678f7$var$getActiveShapeFill(activeShape);
    var tooltipDataDefinedOnItem = sectors.map((sector)=>{
        var sectorTooltipPayload = sector.tooltipPayload;
        if (activeShapeFill == null || sectorTooltipPayload == null) return sectorTooltipPayload;
        return sectorTooltipPayload.map((item)=>$2aaafd309dd678f7$var$_objectSpread($2aaafd309dd678f7$var$_objectSpread({}, item), {}, {
                color: activeShapeFill,
                fill: activeShapeFill
            }));
    });
    var tooltipEntrySettings = {
        dataDefinedOnItem: tooltipDataDefinedOnItem,
        getPosition: (index)=>{
            var _sectors$Number;
            return (_sectors$Number = sectors[Number(index)]) === null || _sectors$Number === void 0 ? void 0 : _sectors$Number.tooltipPosition;
        },
        settings: {
            stroke: stroke,
            strokeWidth: strokeWidth,
            fill: fill,
            dataKey: dataKey,
            nameKey: nameKey,
            name: (0, $d5958b0668c58531$export$d3207de44081d2b3)(name, dataKey),
            hide: hide,
            type: tooltipType,
            color: fill,
            unit: '',
            // why doesn't Pie support unit?
            graphicalItemId: id
        }
    };
    return /*#__PURE__*/ $kc00y.createElement((0, $1cd65dea66eb2265$export$7fa09c17ce18f3e8), {
        tooltipEntrySettings: tooltipEntrySettings
    });
});
var $2aaafd309dd678f7$var$getTextAnchor = (x, cx)=>{
    if (x > cx) return 'start';
    if (x < cx) return 'end';
    return 'middle';
};
var $2aaafd309dd678f7$var$getOuterRadius = (dataPoint, outerRadius, maxPieRadius)=>{
    if (typeof outerRadius === 'function') return (0, $7e613228d3a31273$export$476354dbf49bdff6)(outerRadius(dataPoint), maxPieRadius, maxPieRadius * 0.8);
    return (0, $7e613228d3a31273$export$476354dbf49bdff6)(outerRadius, maxPieRadius, maxPieRadius * 0.8);
};
var $2aaafd309dd678f7$var$parseCoordinateOfPie = (pieSettings, offset, dataPoint)=>{
    var { top: top, left: left, width: width, height: height } = offset;
    var maxPieRadius = (0, $68befda7de8b3621$export$ad5c48602371adfa)(width, height);
    var cx = left + (0, $7e613228d3a31273$export$476354dbf49bdff6)(pieSettings.cx, width, width / 2);
    var cy = top + (0, $7e613228d3a31273$export$476354dbf49bdff6)(pieSettings.cy, height, height / 2);
    var innerRadius = (0, $7e613228d3a31273$export$476354dbf49bdff6)(pieSettings.innerRadius, maxPieRadius, 0);
    var outerRadius = $2aaafd309dd678f7$var$getOuterRadius(dataPoint, pieSettings.outerRadius, maxPieRadius);
    var maxRadius = pieSettings.maxRadius || Math.sqrt(width * width + height * height) / 2;
    return {
        cx: cx,
        cy: cy,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        maxRadius: maxRadius
    };
};
var $2aaafd309dd678f7$var$parseDeltaAngle = (startAngle, endAngle)=>{
    var sign = (0, $7e613228d3a31273$export$9d334328eb75e624)(endAngle - startAngle);
    var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
    return sign * deltaAngle;
};
var $2aaafd309dd678f7$var$renderLabelLineItem = (option, props)=>{
    if (/*#__PURE__*/ $kc00y.isValidElement(option)) // @ts-expect-error we can't know if the type of props matches the element
    return /*#__PURE__*/ $kc00y.cloneElement(option, props);
    if (typeof option === 'function') return option(props);
    var className = (0, $328c1c2632e2f292$export$4f5d2d50c9deca37)('recharts-pie-label-line', typeof option !== 'boolean' ? option.className : '');
    // React doesn't like it when we spread a key property onto an element
    var { key: key } = props, otherProps = $2aaafd309dd678f7$var$_objectWithoutProperties(props, $2aaafd309dd678f7$var$_excluded);
    return /*#__PURE__*/ $kc00y.createElement((0, $75a56cb375d58ce0$export$b0e83c3ef8d2db1), $2aaafd309dd678f7$var$_extends({}, otherProps, {
        type: "linear",
        className: className
    }));
};
var $2aaafd309dd678f7$var$renderLabelItem = (option, props, value)=>{
    if (/*#__PURE__*/ $kc00y.isValidElement(option)) // @ts-expect-error element cloning is not typed
    return /*#__PURE__*/ $kc00y.cloneElement(option, props);
    var label = value;
    if (typeof option === 'function') {
        label = option(props);
        if (/*#__PURE__*/ $kc00y.isValidElement(label)) return label;
    }
    var className = (0, $328c1c2632e2f292$export$4f5d2d50c9deca37)('recharts-pie-label-text', (0, $cb92b2c01b9bd3ed$export$154498af6dc3c303)(option));
    return /*#__PURE__*/ $kc00y.createElement((0, $0f46b46b80ac2f75$export$5f1af8db9871e1d6), $2aaafd309dd678f7$var$_extends({}, props, {
        alignmentBaseline: "middle",
        className: className
    }), label);
};
function $2aaafd309dd678f7$var$PieLabels(_ref2) {
    var { sectors: sectors, props: props, showLabels: showLabels } = _ref2;
    var { label: label, labelLine: labelLine, dataKey: dataKey } = props;
    if (!showLabels || !label || !sectors) return null;
    var pieProps = (0, $34cf66bbb2aff04f$export$8b56257912140094)(props);
    var customLabelProps = (0, $34cf66bbb2aff04f$export$6d5921c09aa671a9)(label);
    var customLabelLineProps = (0, $34cf66bbb2aff04f$export$6d5921c09aa671a9)(labelLine);
    var offsetRadius = typeof label === 'object' && 'offsetRadius' in label && typeof label.offsetRadius === 'number' && label.offsetRadius || 20;
    var labels = sectors.map((entry, i)=>{
        var midAngle = (entry.startAngle + entry.endAngle) / 2;
        var endPoint = (0, $68befda7de8b3621$export$5c9a959bb3fc7749)(entry.cx, entry.cy, entry.outerRadius + offsetRadius, midAngle);
        var labelProps = $2aaafd309dd678f7$var$_objectSpread($2aaafd309dd678f7$var$_objectSpread($2aaafd309dd678f7$var$_objectSpread($2aaafd309dd678f7$var$_objectSpread({}, pieProps), entry), {}, {
            // @ts-expect-error customLabelProps is contributing unknown props
            stroke: 'none'
        }, customLabelProps), {}, {
            index: i,
            textAnchor: $2aaafd309dd678f7$var$getTextAnchor(endPoint.x, entry.cx)
        }, endPoint);
        var lineProps = $2aaafd309dd678f7$var$_objectSpread($2aaafd309dd678f7$var$_objectSpread($2aaafd309dd678f7$var$_objectSpread($2aaafd309dd678f7$var$_objectSpread({}, pieProps), entry), {}, {
            // @ts-expect-error customLabelLineProps is contributing unknown props
            fill: 'none',
            // @ts-expect-error customLabelLineProps is contributing unknown props
            stroke: entry.fill
        }, customLabelLineProps), {}, {
            index: i,
            points: [
                (0, $68befda7de8b3621$export$5c9a959bb3fc7749)(entry.cx, entry.cy, entry.outerRadius, midAngle),
                endPoint
            ],
            key: 'line'
        });
        return /*#__PURE__*/ $kc00y.createElement((0, $a6cde822fe24aa10$export$b37befaf92aba9f1), {
            zIndex: (0, $2d4105c5b5d94e8f$export$96df16b28aa32702).label,
            key: "label-".concat(entry.startAngle, "-").concat(entry.endAngle, "-").concat(entry.midAngle, "-").concat(i)
        }, /*#__PURE__*/ $kc00y.createElement((0, $553c02c7047f2968$export$936d0764594b6eb3), null, labelLine && $2aaafd309dd678f7$var$renderLabelLineItem(labelLine, lineProps), $2aaafd309dd678f7$var$renderLabelItem(label, labelProps, (0, $d5958b0668c58531$export$f97fc4a450f29a)(entry, dataKey))));
    });
    return /*#__PURE__*/ $kc00y.createElement((0, $553c02c7047f2968$export$936d0764594b6eb3), {
        className: "recharts-pie-labels"
    }, labels);
}
function $2aaafd309dd678f7$var$PieLabelList(_ref3) {
    var { sectors: sectors, props: props, showLabels: showLabels } = _ref3;
    var { label: label } = props;
    if (typeof label === 'object' && label != null && 'position' in label) return /*#__PURE__*/ $kc00y.createElement((0, $acfbbd67802b75bf$export$9a402bc8de2b410e), {
        label: label
    });
    return /*#__PURE__*/ $kc00y.createElement($2aaafd309dd678f7$var$PieLabels, {
        sectors: sectors,
        props: props,
        showLabels: showLabels
    });
}
function $2aaafd309dd678f7$var$PieSectors(props) {
    var { sectors: sectors, activeShape: activeShape, inactiveShape: inactiveShapeProp, allOtherPieProps: allOtherPieProps, shape: shape, id: id } = props;
    var activeIndex = (0, $a441e801d1b41b52$export$a7347740d65f620b)((0, $dbde609d2e66e7f4$export$8b2762260f5891c9));
    var activeDataKey = (0, $a441e801d1b41b52$export$a7347740d65f620b)((0, $dbde609d2e66e7f4$export$999f7a7ced063fab));
    var activeGraphicalItemId = (0, $a441e801d1b41b52$export$a7347740d65f620b)((0, $dbde609d2e66e7f4$export$3bddf33d79812741));
    var { onMouseEnter: onMouseEnterFromProps, onClick: onItemClickFromProps, onMouseLeave: onMouseLeaveFromProps } = allOtherPieProps, restOfAllOtherProps = $2aaafd309dd678f7$var$_objectWithoutProperties(allOtherPieProps, $2aaafd309dd678f7$var$_excluded2);
    var onMouseEnterFromContext = (0, $757384ec7d27bd7d$export$6162f642d41f88ea)(onMouseEnterFromProps, allOtherPieProps.dataKey, id);
    var onMouseLeaveFromContext = (0, $757384ec7d27bd7d$export$27cbf444bf0be2d0)(onMouseLeaveFromProps);
    var onClickFromContext = (0, $757384ec7d27bd7d$export$c9154937ad8393fc)(onItemClickFromProps, allOtherPieProps.dataKey, id);
    if (sectors == null || sectors.length === 0) return null;
    return /*#__PURE__*/ $kc00y.createElement($kc00y.Fragment, null, sectors.map((entry, i)=>{
        if ((entry === null || entry === void 0 ? void 0 : entry.startAngle) === 0 && (entry === null || entry === void 0 ? void 0 : entry.endAngle) === 0 && sectors.length !== 1) return null;
        // For Pie charts, when multiple Pies share the same dataKey, we need to ensure only the hovered Pie's sector is active.
        // We do this by checking if the active graphical item ID matches this Pie's ID.
        var graphicalItemMatches = activeGraphicalItemId == null || activeGraphicalItemId === id;
        var isActive = String(i) === activeIndex && (activeDataKey == null || allOtherPieProps.dataKey === activeDataKey) && graphicalItemMatches;
        var inactiveShape = activeIndex ? inactiveShapeProp : null;
        var sectorOptions = activeShape && isActive ? activeShape : inactiveShape;
        var sectorProps = $2aaafd309dd678f7$var$_objectSpread($2aaafd309dd678f7$var$_objectSpread({}, entry), {}, {
            stroke: entry.stroke,
            tabIndex: -1,
            [(0, $868751348c5652f4$export$c0f3d78d63b3e065)]: i,
            [(0, $868751348c5652f4$export$5c80c48c1d137460)]: id
        });
        return /*#__PURE__*/ $kc00y.createElement((0, $553c02c7047f2968$export$936d0764594b6eb3), $2aaafd309dd678f7$var$_extends({
            key: "sector-".concat(entry === null || entry === void 0 ? void 0 : entry.startAngle, "-").concat(entry === null || entry === void 0 ? void 0 : entry.endAngle, "-").concat(entry.midAngle, "-").concat(i),
            tabIndex: -1,
            className: "recharts-pie-sector"
        }, (0, $435e27a3bdb96447$export$ca62be0d67a3158c)(restOfAllOtherProps, entry, i), {
            onMouseEnter: onMouseEnterFromContext(entry, i),
            onMouseLeave: onMouseLeaveFromContext(entry, i),
            onClick: onClickFromContext(entry, i)
        }), /*#__PURE__*/ $kc00y.createElement((0, $92586c98c87e3a95$export$6428a7f2611ef1fa), $2aaafd309dd678f7$var$_extends({
            option: shape !== null && shape !== void 0 ? shape : sectorOptions,
            index: i,
            shapeType: "sector",
            isActive: isActive
        }, sectorProps)));
    }));
}
function $2aaafd309dd678f7$export$c404972144c91fdf(_ref4) {
    var _pieSettings$paddingA;
    var { pieSettings: pieSettings, displayedData: displayedData, cells: cells, offset: offset } = _ref4;
    var { cornerRadius: cornerRadius, startAngle: startAngle, endAngle: endAngle, dataKey: dataKey, nameKey: nameKey, tooltipType: tooltipType } = pieSettings;
    var minAngle = Math.abs(pieSettings.minAngle);
    var deltaAngle = $2aaafd309dd678f7$var$parseDeltaAngle(startAngle, endAngle);
    var absDeltaAngle = Math.abs(deltaAngle);
    var paddingAngle = displayedData.length <= 1 ? 0 : (_pieSettings$paddingA = pieSettings.paddingAngle) !== null && _pieSettings$paddingA !== void 0 ? _pieSettings$paddingA : 0;
    var notZeroItemCount = displayedData.filter((entry)=>(0, $d5958b0668c58531$export$f97fc4a450f29a)(entry, dataKey, 0) !== 0).length;
    var totalPaddingAngle = (absDeltaAngle >= 360 ? notZeroItemCount : notZeroItemCount - 1) * paddingAngle;
    var sum = displayedData.reduce((result, entry)=>{
        var val = (0, $d5958b0668c58531$export$f97fc4a450f29a)(entry, dataKey, 0);
        return result + ((0, $7e613228d3a31273$export$7e4aa119212bc614)(val) ? val : 0);
    }, 0);
    // Only apply minAngle redistribution when at least one non-zero segment's
    // natural angle falls below the minAngle threshold. Otherwise, minAngle
    // unnecessarily shifts all segments even when none need the boost.
    // See: https://github.com/recharts/recharts/issues/6814
    var needsMinAngleAdjustment = minAngle > 0 && sum > 0 && displayedData.some((entry)=>{
        var val = (0, $d5958b0668c58531$export$f97fc4a450f29a)(entry, dataKey, 0);
        var percent = ((0, $7e613228d3a31273$export$7e4aa119212bc614)(val) ? val : 0) / sum;
        return val !== 0 && percent * absDeltaAngle < minAngle;
    });
    var effectiveMinAngle = needsMinAngleAdjustment ? minAngle : 0;
    var realTotalAngle = absDeltaAngle - notZeroItemCount * effectiveMinAngle - totalPaddingAngle;
    var sectors;
    if (sum > 0) {
        var prev;
        sectors = displayedData.map((entry, i)=>{
            var val = (0, $d5958b0668c58531$export$f97fc4a450f29a)(entry, dataKey, 0);
            var name = (0, $d5958b0668c58531$export$f97fc4a450f29a)(entry, nameKey, i);
            var coordinate = $2aaafd309dd678f7$var$parseCoordinateOfPie(pieSettings, offset, entry);
            var percent = ((0, $7e613228d3a31273$export$7e4aa119212bc614)(val) ? val : 0) / sum;
            var tempStartAngle;
            // @ts-expect-error can't spread unknown
            var entryWithCellInfo = $2aaafd309dd678f7$var$_objectSpread($2aaafd309dd678f7$var$_objectSpread({}, entry), cells && cells[i] && cells[i].props);
            var sectorColor = entryWithCellInfo != null && 'fill' in entryWithCellInfo && typeof entryWithCellInfo.fill === 'string' ? entryWithCellInfo.fill : pieSettings.fill;
            if (i) tempStartAngle = prev.endAngle + (0, $7e613228d3a31273$export$9d334328eb75e624)(deltaAngle) * paddingAngle * (val !== 0 ? 1 : 0);
            else tempStartAngle = startAngle;
            var tempEndAngle = tempStartAngle + (0, $7e613228d3a31273$export$9d334328eb75e624)(deltaAngle) * ((val !== 0 ? effectiveMinAngle : 0) + percent * realTotalAngle);
            var midAngle = (tempStartAngle + tempEndAngle) / 2;
            var middleRadius = (coordinate.innerRadius + coordinate.outerRadius) / 2;
            var tooltipPayload = [
                {
                    name: name,
                    value: val,
                    payload: entryWithCellInfo,
                    dataKey: dataKey,
                    type: tooltipType,
                    color: sectorColor,
                    fill: sectorColor,
                    graphicalItemId: pieSettings.id
                }
            ];
            var tooltipPosition = (0, $68befda7de8b3621$export$5c9a959bb3fc7749)(coordinate.cx, coordinate.cy, middleRadius, midAngle);
            prev = $2aaafd309dd678f7$var$_objectSpread($2aaafd309dd678f7$var$_objectSpread($2aaafd309dd678f7$var$_objectSpread($2aaafd309dd678f7$var$_objectSpread({}, pieSettings.presentationProps), {}, {
                percent: percent,
                cornerRadius: typeof cornerRadius === 'string' ? parseFloat(cornerRadius) : cornerRadius,
                name: name,
                tooltipPayload: tooltipPayload,
                midAngle: midAngle,
                middleRadius: middleRadius,
                tooltipPosition: tooltipPosition
            }, entryWithCellInfo), coordinate), {}, {
                value: val,
                dataKey: dataKey,
                startAngle: tempStartAngle,
                endAngle: tempEndAngle,
                payload: entryWithCellInfo,
                paddingAngle: val !== 0 ? (0, $7e613228d3a31273$export$9d334328eb75e624)(deltaAngle) * paddingAngle : 0
            });
            return prev;
        });
    }
    return sectors;
}
function $2aaafd309dd678f7$var$PieLabelListProvider(_ref5) {
    var { showLabels: showLabels, sectors: sectors, children: children } = _ref5;
    var labelListEntries = (0, $kc00y.useMemo)(()=>{
        if (!showLabels || !sectors) return [];
        return sectors.map((entry)=>({
                value: entry.value,
                payload: entry.payload,
                clockWise: false,
                parentViewBox: undefined,
                viewBox: {
                    cx: entry.cx,
                    cy: entry.cy,
                    innerRadius: entry.innerRadius,
                    outerRadius: entry.outerRadius,
                    startAngle: entry.startAngle,
                    endAngle: entry.endAngle,
                    clockWise: false
                },
                fill: entry.fill
            }));
    }, [
        sectors,
        showLabels
    ]);
    return /*#__PURE__*/ $kc00y.createElement((0, $acfbbd67802b75bf$export$38a852d7976af0fe), {
        value: showLabels ? labelListEntries : undefined
    }, children);
}
function $2aaafd309dd678f7$var$SectorsWithAnimation(_ref6) {
    var { props: props, previousSectorsRef: previousSectorsRef, id: id } = _ref6;
    var { sectors: sectors, isAnimationActive: isAnimationActive, animationBegin: animationBegin, animationDuration: animationDuration, animationEasing: animationEasing, activeShape: activeShape, inactiveShape: inactiveShape, onAnimationStart: onAnimationStart, onAnimationEnd: onAnimationEnd } = props;
    var animationId = (0, $706e1fa6aaf57212$export$e1042b2944b80b7f)(props, 'recharts-pie-');
    var prevSectors = previousSectorsRef.current;
    var [isAnimating, setIsAnimating] = (0, $kc00y.useState)(false);
    var handleAnimationEnd = (0, $kc00y.useCallback)(()=>{
        if (typeof onAnimationEnd === 'function') onAnimationEnd();
        setIsAnimating(false);
    }, [
        onAnimationEnd
    ]);
    var handleAnimationStart = (0, $kc00y.useCallback)(()=>{
        if (typeof onAnimationStart === 'function') onAnimationStart();
        setIsAnimating(true);
    }, [
        onAnimationStart
    ]);
    return /*#__PURE__*/ $kc00y.createElement($2aaafd309dd678f7$var$PieLabelListProvider, {
        showLabels: !isAnimating,
        sectors: sectors
    }, /*#__PURE__*/ $kc00y.createElement((0, $a2871794a7a679f0$export$5d41821894c47c52), {
        animationId: animationId,
        begin: animationBegin,
        duration: animationDuration,
        isActive: isAnimationActive,
        easing: animationEasing,
        onAnimationStart: handleAnimationStart,
        onAnimationEnd: handleAnimationEnd,
        key: animationId
    }, (t)=>{
        var _first$startAngle;
        var stepData = [];
        var first = sectors && sectors[0];
        var curAngle = (_first$startAngle = first === null || first === void 0 ? void 0 : first.startAngle) !== null && _first$startAngle !== void 0 ? _first$startAngle : 0;
        sectors === null || sectors === void 0 || sectors.forEach((entry, index)=>{
            var prev = prevSectors && prevSectors[index];
            var paddingAngle = index > 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($c09fe069b4c20e1b$exports)))(entry, 'paddingAngle', 0) : 0;
            if (prev) {
                var angle = (0, $7e613228d3a31273$export$89e29e4ab65e70a9)(prev.endAngle - prev.startAngle, entry.endAngle - entry.startAngle, t);
                var latest = $2aaafd309dd678f7$var$_objectSpread($2aaafd309dd678f7$var$_objectSpread({}, entry), {}, {
                    startAngle: curAngle + paddingAngle,
                    endAngle: curAngle + angle + paddingAngle
                });
                stepData.push(latest);
                curAngle = latest.endAngle;
            } else {
                var { endAngle: endAngle, startAngle: startAngle } = entry;
                var deltaAngle = (0, $7e613228d3a31273$export$89e29e4ab65e70a9)(0, endAngle - startAngle, t);
                var _latest = $2aaafd309dd678f7$var$_objectSpread($2aaafd309dd678f7$var$_objectSpread({}, entry), {}, {
                    startAngle: curAngle + paddingAngle,
                    endAngle: curAngle + deltaAngle + paddingAngle
                });
                stepData.push(_latest);
                curAngle = _latest.endAngle;
            }
        });
        // eslint-disable-next-line no-param-reassign
        previousSectorsRef.current = stepData;
        return /*#__PURE__*/ $kc00y.createElement((0, $553c02c7047f2968$export$936d0764594b6eb3), null, /*#__PURE__*/ $kc00y.createElement($2aaafd309dd678f7$var$PieSectors, {
            sectors: stepData,
            activeShape: activeShape,
            inactiveShape: inactiveShape,
            allOtherPieProps: props,
            shape: props.shape,
            id: id
        }));
    }), /*#__PURE__*/ $kc00y.createElement($2aaafd309dd678f7$var$PieLabelList, {
        showLabels: !isAnimating,
        sectors: sectors,
        props: props
    }), props.children);
}
var $2aaafd309dd678f7$export$822a6bceb86ebb81 = {
    animationBegin: 400,
    animationDuration: 1500,
    animationEasing: 'ease',
    cx: '50%',
    cy: '50%',
    dataKey: 'value',
    endAngle: 360,
    fill: '#808080',
    hide: false,
    innerRadius: 0,
    isAnimationActive: 'auto',
    label: false,
    labelLine: true,
    legendType: 'rect',
    minAngle: 0,
    nameKey: 'name',
    outerRadius: '80%',
    paddingAngle: 0,
    rootTabIndex: 0,
    startAngle: 0,
    stroke: '#fff',
    zIndex: (0, $2d4105c5b5d94e8f$export$96df16b28aa32702).area
};
function $2aaafd309dd678f7$var$PieImpl(props) {
    var { id: id } = props, propsWithoutId = $2aaafd309dd678f7$var$_objectWithoutProperties(props, $2aaafd309dd678f7$var$_excluded3);
    var { hide: hide, className: className, rootTabIndex: rootTabIndex } = props;
    var cells = (0, $kc00y.useMemo)(()=>(0, $b54930f6e6643156$export$fdd5e64c0e8495bb)(props.children, (0, $af579bd742156f26$export$f6f0c3fe4ec306ea)), [
        props.children
    ]);
    var sectors = (0, $a441e801d1b41b52$export$a7347740d65f620b)((state)=>(0, $3e4db49ddc0ada48$export$c6af8a90408f4a64)(state, id, cells));
    var previousSectorsRef = (0, $kc00y.useRef)(null);
    var layerClass = (0, $328c1c2632e2f292$export$4f5d2d50c9deca37)('recharts-pie', className);
    if (hide || sectors == null) {
        previousSectorsRef.current = null;
        return /*#__PURE__*/ $kc00y.createElement((0, $553c02c7047f2968$export$936d0764594b6eb3), {
            tabIndex: rootTabIndex,
            className: layerClass
        });
    }
    return /*#__PURE__*/ $kc00y.createElement((0, $a6cde822fe24aa10$export$b37befaf92aba9f1), {
        zIndex: props.zIndex
    }, /*#__PURE__*/ $kc00y.createElement($2aaafd309dd678f7$var$SetPieTooltipEntrySettings, {
        dataKey: props.dataKey,
        nameKey: props.nameKey,
        sectors: sectors,
        stroke: props.stroke,
        strokeWidth: props.strokeWidth,
        fill: props.fill,
        name: props.name,
        hide: props.hide,
        tooltipType: props.tooltipType,
        id: id,
        activeShape: props.activeShape
    }), /*#__PURE__*/ $kc00y.createElement((0, $553c02c7047f2968$export$936d0764594b6eb3), {
        tabIndex: rootTabIndex,
        className: layerClass
    }, /*#__PURE__*/ $kc00y.createElement($2aaafd309dd678f7$var$SectorsWithAnimation, {
        props: $2aaafd309dd678f7$var$_objectSpread($2aaafd309dd678f7$var$_objectSpread({}, propsWithoutId), {}, {
            sectors: sectors
        }),
        previousSectorsRef: previousSectorsRef,
        id: id
    })));
}
/**
 * @consumes PolarChartContext
 * @provides LabelListContext
 * @provides CellReader
 */ function $2aaafd309dd678f7$var$PieFn(outsideProps) {
    var props = (0, $4cc2299923ef69c7$export$45004cc70a390ee8)(outsideProps, $2aaafd309dd678f7$export$822a6bceb86ebb81);
    var { id: externalId } = props, propsWithoutId = $2aaafd309dd678f7$var$_objectWithoutProperties(props, $2aaafd309dd678f7$var$_excluded4);
    var presentationProps = (0, $34cf66bbb2aff04f$export$8b56257912140094)(propsWithoutId);
    return /*#__PURE__*/ $kc00y.createElement((0, $f34dba1288eb5faf$export$8c2f307ff93f02ba), {
        id: externalId,
        type: "pie"
    }, (id)=>/*#__PURE__*/ $kc00y.createElement($kc00y.Fragment, null, /*#__PURE__*/ $kc00y.createElement((0, $b22a299c3f7b2080$export$8d7124402ca6b71c), {
            type: "pie",
            id: id,
            data: propsWithoutId.data,
            dataKey: propsWithoutId.dataKey,
            hide: propsWithoutId.hide,
            angleAxisId: 0,
            radiusAxisId: 0,
            name: propsWithoutId.name,
            nameKey: propsWithoutId.nameKey,
            tooltipType: propsWithoutId.tooltipType,
            legendType: propsWithoutId.legendType,
            fill: propsWithoutId.fill,
            cx: propsWithoutId.cx,
            cy: propsWithoutId.cy,
            startAngle: propsWithoutId.startAngle,
            endAngle: propsWithoutId.endAngle,
            paddingAngle: propsWithoutId.paddingAngle,
            minAngle: propsWithoutId.minAngle,
            innerRadius: propsWithoutId.innerRadius,
            outerRadius: propsWithoutId.outerRadius,
            cornerRadius: propsWithoutId.cornerRadius,
            presentationProps: presentationProps,
            maxRadius: props.maxRadius
        }), /*#__PURE__*/ $kc00y.createElement($2aaafd309dd678f7$var$SetPiePayloadLegend, $2aaafd309dd678f7$var$_extends({}, propsWithoutId, {
            id: id
        })), /*#__PURE__*/ $kc00y.createElement($2aaafd309dd678f7$var$PieImpl, $2aaafd309dd678f7$var$_extends({}, propsWithoutId, {
            id: id
        }))));
}
var $2aaafd309dd678f7$export$2ae8800cf67c848c = $2aaafd309dd678f7$var$PieFn;
// @ts-expect-error we need to set the displayName for debugging purposes
$2aaafd309dd678f7$export$2ae8800cf67c848c.displayName = 'Pie';


var $kc00y = parcelRequire("kc00y");


var $kc00y = parcelRequire("kc00y");






var $kc00y = parcelRequire("kc00y");


function $1ef0f0ab61b7ee0a$export$babaff6c249d1f4b(props) {
    var dispatch = (0, $a441e801d1b41b52$export$f51d452c10d5b956)();
    (0, $kc00y.useEffect)(()=>{
        dispatch((0, $0632eb616bc08bfd$export$5dfe4dcb848af93f)(props));
    }, [
        dispatch,
        props
    ]);
    return null;
}





var $8e6ee35d45dde7b5$var$_excluded = [
    "layout"
];
function $8e6ee35d45dde7b5$var$_extends() {
    return $8e6ee35d45dde7b5$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $8e6ee35d45dde7b5$var$_extends.apply(null, arguments);
}
function $8e6ee35d45dde7b5$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $8e6ee35d45dde7b5$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $8e6ee35d45dde7b5$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $8e6ee35d45dde7b5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8e6ee35d45dde7b5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8e6ee35d45dde7b5$var$ownKeys(Object(t), !0).forEach(function(r) {
            $8e6ee35d45dde7b5$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8e6ee35d45dde7b5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $8e6ee35d45dde7b5$var$_defineProperty(e, r, t) {
    return (r = $8e6ee35d45dde7b5$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $8e6ee35d45dde7b5$var$_toPropertyKey(t) {
    var i = $8e6ee35d45dde7b5$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $8e6ee35d45dde7b5$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $8e6ee35d45dde7b5$var$defaultMargin = {
    top: 5,
    right: 5,
    bottom: 5,
    left: 5
};
var $8e6ee35d45dde7b5$export$20a5c0f1a1e0268d = $8e6ee35d45dde7b5$var$_objectSpread({
    accessibilityLayer: true,
    stackOffset: 'none',
    barCategoryGap: '10%',
    barGap: 4,
    margin: $8e6ee35d45dde7b5$var$defaultMargin,
    reverseStackOrder: false,
    syncMethod: 'index',
    layout: 'radial',
    responsive: false,
    cx: '50%',
    cy: '50%',
    innerRadius: 0,
    outerRadius: '80%'
}, (0, $a6ede7080be43fb0$export$b8b957c7b621f147));
var $8e6ee35d45dde7b5$export$8de722e497513838 = /*#__PURE__*/ (0, $kc00y.forwardRef)(function PolarChart(props, ref) {
    var _polarChartProps$id;
    var polarChartProps = (0, $4cc2299923ef69c7$export$45004cc70a390ee8)(props.categoricalChartProps, $8e6ee35d45dde7b5$export$20a5c0f1a1e0268d);
    var { layout: layout } = polarChartProps, otherCategoricalProps = $8e6ee35d45dde7b5$var$_objectWithoutProperties(polarChartProps, $8e6ee35d45dde7b5$var$_excluded);
    var { chartName: chartName, defaultTooltipEventType: defaultTooltipEventType, validateTooltipEventTypes: validateTooltipEventTypes, tooltipPayloadSearcher: tooltipPayloadSearcher } = props;
    var options = {
        chartName: chartName,
        defaultTooltipEventType: defaultTooltipEventType,
        validateTooltipEventTypes: validateTooltipEventTypes,
        tooltipPayloadSearcher: tooltipPayloadSearcher,
        eventEmitter: undefined
    };
    return /*#__PURE__*/ $kc00y.createElement((0, $a0ffcc501bd4818e$export$debe87639f2707f9), {
        preloadedState: {
            options: options
        },
        reduxStoreName: (_polarChartProps$id = polarChartProps.id) !== null && _polarChartProps$id !== void 0 ? _polarChartProps$id : chartName
    }, /*#__PURE__*/ $kc00y.createElement((0, $2fbac5019ff11bb3$export$2100a1dedbca0238), {
        chartData: polarChartProps.data
    }), /*#__PURE__*/ $kc00y.createElement((0, $62df92852f2f4482$export$6faeaad6e02c2e9d), {
        layout: layout,
        margin: polarChartProps.margin
    }), /*#__PURE__*/ $kc00y.createElement((0, $f463b6c2910c27e9$export$dcb02be33c78f8ab), {
        throttleDelay: polarChartProps.throttleDelay,
        throttledEvents: polarChartProps.throttledEvents
    }), /*#__PURE__*/ $kc00y.createElement((0, $a435dfd6f3838af8$export$6fabfb9ba230d12b), {
        baseValue: undefined,
        accessibilityLayer: polarChartProps.accessibilityLayer,
        barCategoryGap: polarChartProps.barCategoryGap,
        maxBarSize: polarChartProps.maxBarSize,
        stackOffset: polarChartProps.stackOffset,
        barGap: polarChartProps.barGap,
        barSize: polarChartProps.barSize,
        syncId: polarChartProps.syncId,
        syncMethod: polarChartProps.syncMethod,
        className: polarChartProps.className,
        reverseStackOrder: polarChartProps.reverseStackOrder
    }), /*#__PURE__*/ $kc00y.createElement((0, $1ef0f0ab61b7ee0a$export$babaff6c249d1f4b), {
        cx: polarChartProps.cx,
        cy: polarChartProps.cy,
        startAngle: polarChartProps.startAngle,
        endAngle: polarChartProps.endAngle,
        innerRadius: polarChartProps.innerRadius,
        outerRadius: polarChartProps.outerRadius
    }), /*#__PURE__*/ $kc00y.createElement((0, $f6c0644c6a73bda5$export$d49e03133b3316a9), $8e6ee35d45dde7b5$var$_extends({}, otherCategoricalProps, {
        ref: ref
    })));
});



function $8eaae397f0969b90$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8eaae397f0969b90$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8eaae397f0969b90$var$ownKeys(Object(t), !0).forEach(function(r) {
            $8eaae397f0969b90$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8eaae397f0969b90$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $8eaae397f0969b90$var$_defineProperty(e, r, t) {
    return (r = $8eaae397f0969b90$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $8eaae397f0969b90$var$_toPropertyKey(t) {
    var i = $8eaae397f0969b90$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $8eaae397f0969b90$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $8eaae397f0969b90$var$allowedTooltipTypes = [
    'item'
];
var $8eaae397f0969b90$export$3c2b6064ceeac6d0 = $8eaae397f0969b90$var$_objectSpread($8eaae397f0969b90$var$_objectSpread({}, (0, $8e6ee35d45dde7b5$export$20a5c0f1a1e0268d)), {}, {
    layout: 'centric',
    startAngle: 0,
    endAngle: 360
});
var $8eaae397f0969b90$export$b99d3348f709c998 = /*#__PURE__*/ (0, $kc00y.forwardRef)((props, ref)=>{
    var propsWithDefaults = (0, $4cc2299923ef69c7$export$45004cc70a390ee8)(props, $8eaae397f0969b90$export$3c2b6064ceeac6d0);
    return /*#__PURE__*/ $kc00y.createElement((0, $8e6ee35d45dde7b5$export$8de722e497513838), {
        chartName: "PieChart",
        defaultTooltipEventType: "item",
        validateTooltipEventTypes: $8eaae397f0969b90$var$allowedTooltipTypes,
        tooltipPayloadSearcher: (0, $06bd4d083c59b4ed$export$3d996ff386c7802d),
        categoricalChartProps: propsWithDefaults,
        ref: ref
    });
});



const $73975e5a26a2357b$var$GaugeComponent = ({ data: data, config: config })=>{
    if (!data || data.length === 0) return;
    const dataMapped = (0, $e51454bc4e60e998$export$2df36521d18abca0)(data, config);
    // Calcule le pourcentage à afficher
    const safeParseFloat = (str)=>{
        const num = parseFloat(parseFloat(str).toFixed(2));
        return isNaN(num) ? 0 : num;
    };
    const sumValues = dataMapped.reduce((sum, item)=>sum + safeParseFloat(item.value), 0);
    const sumMax = dataMapped.reduce((sum, item)=>sum + safeParseFloat(item.max), 0);
    const percentage = safeParseFloat((sumMax === 0 ? 0 : sumValues / sumMax * 100).toFixed(2));
    const colorMode = config?.colorMode;
    const useThresholdColors = colorMode === "gradient" || colorMode == null && Array.isArray(config?.limits) && config.limits.length > 0;
    const rawLimits = Array.isArray(config?.limits) ? config.limits : [];
    const highColor = config?.highColor || "#e74c3c";
    const barColor = config?.barColor || "#00293e";
    const sections = (()=>{
        if (!useThresholdColors) return [];
        const limits = rawLimits.map((l)=>({
                color: l.color || "#cccccc",
                max: Number(l.max)
            })).filter((l)=>!Number.isNaN(l.max)).map((l)=>({
                color: l.color,
                max: Math.max(0, Math.min(100, l.max))
            }));
        const s = [];
        let prev = 0;
        for (const lim of limits){
            const to = Math.max(prev, lim.max);
            if (to > prev) s.push({
                from: prev,
                to: to,
                color: lim.color
            });
            prev = to;
        }
        if (s.length === 0) return [
            {
                from: 0,
                to: 25,
                color: "#2ecc71"
            },
            {
                from: 25,
                to: 50,
                color: "#f1c40f"
            },
            {
                from: 50,
                to: 75,
                color: "#e67e22"
            },
            {
                from: 75,
                to: 100,
                color: highColor
            }
        ];
        if (prev < 100) s.push({
            from: prev,
            to: 100,
            color: highColor
        });
        return s;
    })();
    // Préparer les données pour la jauge extérieure
    const outerGaugeData = useThresholdColors ? sections.map((sec)=>({
            value: sec.to - sec.from,
            color: sec.color
        })) : [
        {
            value: 100,
            color: barColor
        }
    ];
    // Préparer les données pour la jauge intérieure (segments en fonction de la valeur)
    const innerGaugeData = [
        {
            value: percentage - 1,
            color: "#f2f4f6"
        },
        // Segment de 0 à (value - 1)
        {
            value: 2,
            color: "#000000"
        },
        // Segment de (value - 1) à (value + 1)
        {
            value: 100 - (percentage + 1),
            color: "#f2f4f6"
        } // Segment de (value + 1) à 100
    ];
    const PieCell = (props)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $704464b332847712$export$e98c2c7eb2b14f45), {
            ...props,
            fill: props.payload?.color || props.fill,
            stroke: "none"
        });
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
        className: "w-100 h-100 d-flex flex-column justify-content-center align-items-center",
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ffea1da660acf881$export$e60a4704009a0009), {
                width: "100%",
                height: "70%",
                initialDimension: {
                    width: 400,
                    height: 300
                },
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $8eaae397f0969b90$export$b99d3348f709c998), {
                    className: "d-flex flex-column justify-content-center align-items-center",
                    children: [
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2aaafd309dd678f7$export$2ae8800cf67c848c), {
                            data: outerGaugeData,
                            cx: "50%",
                            cy: "100%",
                            innerRadius: "130%",
                            outerRadius: "170%",
                            startAngle: 180,
                            endAngle: 0,
                            dataKey: "value",
                            shape: PieCell
                        }),
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2aaafd309dd678f7$export$2ae8800cf67c848c), {
                            data: innerGaugeData,
                            cx: "50%",
                            cy: "100%",
                            innerRadius: "0%",
                            outerRadius: "130%",
                            startAngle: 180,
                            endAngle: 0,
                            dataKey: "value",
                            shape: PieCell
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                style: {
                    fontSize: "40px",
                    fontWeight: "bold",
                    color: barColor
                },
                className: "text-center",
                children: percentage + "%"
            })
        ]
    });
};
var $73975e5a26a2357b$export$2e2bcd8739ae039 = $73975e5a26a2357b$var$GaugeComponent;




var $kc00y = parcelRequire("kc00y");



const $b612425d814cc007$var$GaugeConfig = ({ config: config, setConfig: setConfig, fieldOptions: fieldOptions })=>{
    const [limits, setLimits] = (0, $kc00y.useState)(config.limits || []);
    // Mettre à jour la couleur d'une limite
    const handleColorChange = (index, newColor)=>{
        const updatedLimits = [
            ...limits
        ];
        updatedLimits[index].color = newColor;
        setLimits(updatedLimits);
        const updatedConfig = {
            ...config,
            limits: updatedLimits
        };
        setConfig(updatedConfig);
    };
    // Mettre à jour la valeur maximale d'une limite
    const handleMaxChange = (index, newMax)=>{
        const updatedLimits = [
            ...limits
        ];
        updatedLimits[index].max = newMax;
        setLimits(updatedLimits);
        const updatedConfig = {
            ...config,
            limits: updatedLimits
        };
        setConfig(updatedConfig);
    };
    // Ajouter une nouvelle limite
    const addLimit = ()=>{
        const newLimit = {
            color: "#000000",
            max: 0
        }; // Valeurs par défaut
        const updatedLimits = [
            ...limits,
            newLimit
        ];
        setLimits(updatedLimits);
        const updatedConfig = {
            ...config,
            limits: updatedLimits
        };
        setConfig(updatedConfig);
    };
    // Supprimer une limite
    const removeLimit = (index)=>{
        const updatedLimits = limits.filter((_, i)=>i !== index);
        setLimits(updatedLimits);
        const updatedConfig = {
            ...config,
            limits: updatedLimits
        };
        setConfig(updatedConfig);
    };
    // Valeur par défaut de `value`
    const fieldValue = fieldOptions.find((option)=>option.value === config.value) || "";
    // Valeur par défaut de `max`
    const fieldMax = fieldOptions.find((option)=>option.value === config.max) || "";
    // Mettre à jour la config du composant avec la nouvelle valeur
    const handleChange = (fieldName, newValue)=>{
        const updatedConfig = {
            ...config
        };
        updatedConfig[fieldName] = newValue;
        setConfig(updatedConfig);
    };
    // Mode gradient detection & defaults
    const isGradient = config.colorMode === "gradient" || config.colorMode == null && (config.limits?.length || 0) > 0;
    const defaultLimits = [
        {
            color: "#2ecc71",
            max: 25
        },
        {
            color: "#f1c40f",
            max: 50
        },
        {
            color: "#e67e22",
            max: 75
        }
    ];
    const hasInitializedDefaults = (0, $kc00y.useRef)(false);
    (0, $kc00y.useEffect)(()=>{
        if (isGradient && limits.length === 0 && !hasInitializedDefaults.current) {
            hasInitializedDefaults.current = true;
            setLimits(defaultLimits);
            setConfig({
                ...config,
                limits: defaultLimits,
                highColor: config.highColor || "#e74c3c",
                colorMode: "gradient"
            });
        }
    }, [
        isGradient,
        limits.length,
        config,
        setConfig
    ]);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$d6701e98ab1a6725), {
                required: false,
                name: "value",
                label: "Num\xe9rateur",
                onChange: (value)=>handleChange("value", value.value),
                defaultValue: fieldValue,
                options: fieldOptions,
                getOptionLabel: (option)=>option.value,
                getOptionValue: (option)=>option.value
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$d6701e98ab1a6725), {
                required: false,
                name: "max",
                label: "D\xe9nominateur",
                onChange: (value)=>handleChange("max", value.value),
                defaultValue: fieldMax,
                options: fieldOptions,
                getOptionLabel: (option)=>option.value,
                getOptionValue: (option)=>option.value
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Label, {
                className: "fw-bold mt-3",
                children: "Mode de couleur :"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Check, {
                        type: "radio",
                        name: "colorMode",
                        id: "gauge-colorMode-solid",
                        label: "Couleur unie",
                        checked: !isGradient,
                        onChange: ()=>handleChange("colorMode", "solid")
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Check, {
                        type: "radio",
                        name: "colorMode",
                        id: "gauge-colorMode-gradient",
                        label: "D\xe9grad\xe9 de couleurs",
                        checked: isGradient,
                        onChange: ()=>handleChange("colorMode", "gradient")
                    })
                ]
            }),
            !isGradient && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Label, {
                        className: "fw-bold mt-3",
                        children: "Couleur de la jauge :"
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                        style: {
                            marginBottom: "10px"
                        },
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Control, {
                            type: "color",
                            defaultValue: config.barColor || "#00293e",
                            onBlur: (e)=>handleChange("barColor", e.target.value),
                            style: {
                                width: "100px",
                                height: "40px"
                            }
                        })
                    })
                ]
            }),
            isGradient && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Label, {
                        className: "fw-bold mt-2",
                        children: "Paliers des sections :"
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    limits.map((limit, index)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                            style: {
                                marginBottom: "10px",
                                display: "flex",
                                alignItems: "center"
                            },
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Control, {
                                    type: "color",
                                    defaultValue: limit.color,
                                    onBlur: (e)=>handleColorChange(index, e.target.value),
                                    style: {
                                        width: "40px",
                                        marginRight: "10px"
                                    }
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Control, {
                                    type: "number",
                                    min: 0,
                                    step: 1,
                                    max: 100,
                                    disabled: true,
                                    value: index === 0 ? 0 : limits[index - 1]?.max ?? 0,
                                    style: {
                                        width: "100px",
                                        marginRight: "10px"
                                    }
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Control, {
                                    type: "number",
                                    min: 0,
                                    step: 1,
                                    max: 100,
                                    required: false,
                                    defaultValue: limit.max,
                                    onBlur: (e)=>handleMaxChange(index, parseInt(e.target.value, 10)),
                                    style: {
                                        width: "100px",
                                        marginRight: "10px"
                                    }
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                                    variant: "warning",
                                    onClick: ()=>removeLimit(index),
                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$4d4e10ce882b8153), {})
                                })
                            ]
                        }, index)),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                        style: {
                            marginBottom: "10px",
                            display: "flex",
                            alignItems: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Control, {
                                type: "color",
                                defaultValue: config.highColor || "#e74c3c",
                                onBlur: (e)=>handleChange("highColor", e.target.value),
                                style: {
                                    width: "40px",
                                    marginRight: "10px"
                                }
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Control, {
                                type: "number",
                                min: 0,
                                step: 1,
                                max: 100,
                                disabled: true,
                                value: limits.length > 0 ? limits[limits.length - 1].max ?? 0 : 75,
                                style: {
                                    width: "100px",
                                    marginRight: "10px"
                                }
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Control, {
                                type: "number",
                                disabled: true,
                                value: "100",
                                style: {
                                    width: "100px",
                                    marginRight: "10px"
                                }
                            })
                        ]
                    }, "last"),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                        variant: "primary",
                        className: "mt-3",
                        onClick: addLimit,
                        children: "Ajouter un palier"
                    })
                ]
            })
        ]
    });
};
var $b612425d814cc007$export$2e2bcd8739ae039 = $b612425d814cc007$var$GaugeConfig;














var $kc00y = parcelRequire("kc00y");





// ne pas partager la même instance entre plusieurs carte
function $ec93d95b9fbddcee$var$createOSMLayer() {
    return new (0, $db51b5c8e297e6ef$export$2e2bcd8739ae039)({
        source: new (0, $6944b8b0ce57af59$export$2e2bcd8739ae039)()
    });
}
const $ec93d95b9fbddcee$var$MapDashboardComponent = (data)=>{
    const mapRef = (0, $kc00y.useRef)(null);
    const tooltipRef = (0, $kc00y.useRef)(null);
    const baseLayerRef = (0, $kc00y.useRef)(null);
    const { user: user, epsg: projection, extent: defaultExtent, extentSRID: extentSRID } = (0, $e787cde576104469$export$fdc397e486fa83e7)();
    const { warning: warningToast } = (0, $6bdae0bad7b05751$export$91b3d218c74c79e4)();
    const dataMapped = (0, $e51454bc4e60e998$export$ae027ca1e1457159)(data?.data ? data.data : [], data.config ? data.config : []);
    const toNumber = (0, $kc00y.useCallback)((v)=>{
        const n = Number(v);
        return Number.isFinite(n) ? n : 0;
    }, []);
    const computePercentage = (0, $kc00y.useCallback)((value, max)=>{
        if (max <= 0) return 0;
        return value / max * 100;
    }, []);
    // Fonction pour déterminer la couleur en fonction du pourcentage
    const getColorForPercentage = (0, $kc00y.useCallback)((percentage, limits)=>{
        if (!limits || limits.length === 0) return "#000000";
        const sortedLimits = [
            ...limits
        ].sort((a, b)=>parseFloat(a.value) - parseFloat(b.value));
        // Si NaN/Infinity, on force le palier 0%
        if (!Number.isFinite(percentage)) percentage = 0;
        for (const limit of sortedLimits){
            if (percentage <= parseFloat(limit.value)) return limit.color;
        }
        // Si le pourcentage dépasse toutes les limites, utiliser la dernière couleur
        return sortedLimits[sortedLimits.length - 1].color;
    }, []);
    const [map, setMap] = (0, $kc00y.useState)(null);
    const [, setTooltip] = (0, $kc00y.useState)(null);
    // Initialisation de la carte
    (0, $kc00y.useEffect)(()=>{
        const currentRef = mapRef.current;
        const tooltipElement = tooltipRef.current;
        if (!currentRef || !tooltipElement) return;
        baseLayerRef.current = $ec93d95b9fbddcee$var$createOSMLayer();
        const newMap = new (0, $fe544abd54013409$export$2e2bcd8739ae039)({
            target: currentRef,
            layers: [
                baseLayerRef.current
            ],
            view: new (0, $22c5be3317ad81f4$export$2e2bcd8739ae039)({
                zoom: 6,
                projection: (0, $f740b0d032822ba6$export$3eb968b6a9f43207),
                center: [
                    244598,
                    5921729
                ],
                // FIXME : récupérer la zone de l'utilisateur ?
                padding: [
                    50,
                    50,
                    50,
                    50
                ]
            })
        });
        // Créer l'overlay pour la tooltip
        const newTooltip = new (0, $bedb0af9b4c870c1$export$2e2bcd8739ae039)({
            element: tooltipElement,
            offset: [
                10,
                0
            ],
            positioning: "bottom-left"
        });
        newMap.addOverlay(newTooltip);
        setTooltip(newTooltip);
        // Évènements pour la tooltip
        newMap.on("pointermove", (evt)=>{
            const feature = newMap.forEachFeatureAtPixel(evt.pixel, (feature)=>feature);
            if (feature) {
                const properties = feature.getProperties();
                const coordinate = evt.coordinate;
                const value = toNumber(properties.value);
                const max = toNumber(properties.max);
                const percentage = computePercentage(value, max).toFixed(1);
                tooltipElement.innerHTML = `
          <div style="
            background: rgba(0, 0, 0, 0.8);
            color: white;
            padding: 8px 12px;
            border-radius: 4px;
            font-size: 12px;
            width: 300px;
          ">
            <div><strong>${properties.libelle ?? "Informations"}</strong></div>
            <div>${data.config.value} : ${value}</div>
            <div>${data.config.max} : ${max}</div>
            <div>Pourcentage: ${percentage}%</div>
          </div>
        `;
                newTooltip.setPosition(coordinate);
                tooltipElement.style.display = "block";
            } else tooltipElement.style.display = "none";
        });
        // L'extent de la map est défini par défaut à la zone de compétence de l'utilisateur ou à l'emprise définie par défaut
        if (user?.zoneIntegrationExtent) {
            const rawExtent = new (0, $15a985d09649bdc2$export$2e2bcd8739ae039)().readGeometry(user.zoneIntegrationExtent.split(";").pop()).getExtent();
            newMap?.getView().fit((0, $a86eee1c28205a05$export$751c68e0e0efff79)(rawExtent, projection.name, (0, $f740b0d032822ba6$export$3eb968b6a9f43207)), {
                maxZoom: 20
            });
        } else newMap.getView().fit((0, $a86eee1c28205a05$export$751c68e0e0efff79)(defaultExtent, extentSRID, (0, $f740b0d032822ba6$export$3eb968b6a9f43207)), {
            maxZoom: 20
        }); // Centre depuis l'étendue fournie par le serveur)
        setMap(newMap);
        // Cleanup function pour détruire la carte quand le composant se démonte
        return ()=>{
            newMap.setTarget(undefined);
        };
    }, [
        user?.zoneIntegrationExtent,
        projection.name,
        defaultExtent,
        extentSRID,
        data.config,
        computePercentage,
        toNumber
    ]);
    (0, $kc00y.useEffect)(()=>{
        if (!map || !dataMapped || !Array.isArray(dataMapped) || data.data === undefined) return;
        // On rafraîchit la vue en supprimant les couches hors OSM
        map.getLayers().getArray().filter((l)=>l !== baseLayerRef.current).forEach((l)=>{
            map.removeLayer(l);
        });
        // JSONParseException
        try {
            // Transformation des données en FeatureCollection pour pouvoir créer une seule couche
            const geojsonObject = {
                type: "FeatureCollection",
                features: dataMapped.map((item)=>{
                    // eslint-disable-next-line @typescript-eslint/no-unused-vars
                    const { geojson: _, ...properties } = item;
                    const geometry = JSON.parse(item.geojson);
                    return {
                        type: "Feature",
                        properties: {
                            ...properties,
                            epsg: geometry.crs.properties.name
                        },
                        geometry: geometry
                    };
                })
            };
            const vectorSource = new (0, $1020e4d07ddbfab1$export$2e2bcd8739ae039)({
                // Garde-fou : conversion individuelle des géométries depuis leur propre EPSG
                features: new (0, $93342158ce8701e7$export$2e2bcd8739ae039)().readFeatures(geojsonObject).map((feature)=>{
                    const geometry = feature.getGeometry();
                    if (geometry) geometry.transform(feature.getProperties().epsg, (0, $f740b0d032822ba6$export$3eb968b6a9f43207)); // EPSG par défaut de la View
                    return feature;
                })
            });
            const dataLayer = new (0, $082a79ecb622f84a$export$2e2bcd8739ae039)({
                source: vectorSource,
                style: (feature)=>{
                    const properties = feature.getProperties();
                    // Calculer le pourcentage
                    const value = toNumber(properties.value);
                    const max = toNumber(properties.max);
                    const percentage = computePercentage(value, max);
                    // Obtenir la couleur en fonction du pourcentage
                    const color = getColorForPercentage(percentage, data.config?.limits || []);
                    // Créer un style dynamique pour la couche vectorielle
                    return new (0, $a5fc261473972d1d$export$2e2bcd8739ae039)({
                        stroke: new (0, $281691897fddf9d0$export$2e2bcd8739ae039)({
                            color: color,
                            // Couleur du contour
                            width: 2
                        }),
                        fill: new (0, $8624b871a0af6dab$export$2e2bcd8739ae039)({
                            color: `${color}40` // Couleur de remplissage avec transparence (ajout de '40' pour 25% d'opacité)
                        })
                    });
                }
            });
            // On ajoute la couche dans un groupe (pour la distinguer de la couche OSM)
            map.addLayer(new (0, $7b793edad973bda2$export$2e2bcd8739ae039)({
                layers: [
                    dataLayer
                ]
            }));
            // Zoomer et centrer sur les données
            const extent = vectorSource.getExtent(); // Obtient l'étendue des données
            map.getView().fit(extent, {
                padding: [
                    50,
                    50,
                    50,
                    50
                ],
                // Marge autour des données (en pixels)
                maxZoom: 15 // Zoom maximum pour éviter un zoom trop rapproché
            });
        } catch (_e) {
            warningToast("G\xe9om\xe9trie invalide");
        }
    }, [
        map,
        data.config,
        dataMapped,
        warningToast,
        data.data,
        getColorForPercentage,
        computePercentage,
        toNumber
    ]);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        fluid: true,
        className: "h-100",
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
            className: "h-100",
            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                className: "h-100",
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                        ref: mapRef,
                        style: {
                            width: "100%",
                            height: "100%"
                        }
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                        ref: tooltipRef,
                        style: {
                            position: "absolute",
                            pointerEvents: "none",
                            display: "none",
                            zIndex: 1000
                        }
                    })
                ]
            })
        })
    });
};
var $ec93d95b9fbddcee$export$2e2bcd8739ae039 = $ec93d95b9fbddcee$var$MapDashboardComponent;




var $kc00y = parcelRequire("kc00y");



const $b52a2a3463509d08$var$MapConfig = (options)=>{
    // Valeur par défaut de `geojson`
    const fieldGeojson = options.fieldOptions.find((option)=>option.value === options.config.geojson) || "";
    // Valeur par défaut de `geojson`
    const fieldValue = options.fieldOptions.find((option)=>option.value === options.config.value) || "";
    // Valeur par défaut de `geojson`
    const fieldMax = options.fieldOptions.find((option)=>option.value === options.config.max) || "";
    const fieldLibelle = options.fieldOptions.find((option)=>option.value === options.config.libelle) || "";
    const nextId = (0, $kc00y.useRef)(0);
    // Gérer les limites dynamiquement, chaque limite porte un _id stable
    const [limits, setLimits] = (0, $kc00y.useState)(()=>(options.config.limits || []).map((l)=>({
                ...l,
                _id: nextId.current++
            })));
    // Mettre à jour la config du composant avec la nouvelle valeur
    const handleChange = (fieldName, newValue)=>{
        const updatedConfig = {
            ...options.config,
            [fieldName]: newValue
        };
        options.setConfig(updatedConfig);
    };
    // Debounce pour le color picker pour limiter le nombre de refraîchissements OpenLayers
    const debounceColorPick = (0, $d054b7aa3e6e48aa$export$e70e6da722faba05)((id, field, value)=>handleLimitsChange(id, field, value), 500);
    // Mettre à jour les limites et trier par valeur croissante
    const handleLimitsChange = (id, field, value)=>{
        const updatedLimits = limits.map((limit)=>limit._id === id ? {
                ...limit,
                [field]: value
            } : limit);
        const sortedLimits = [
            ...updatedLimits
        ].sort((a, b)=>parseFloat(a.value || "0") - parseFloat(b.value || "0"));
        setLimits(sortedLimits);
        // Propager sans les _id internes
        const configLimits = sortedLimits.map(({ _id: _id, ...rest })=>rest);
        const updatedConfig = {
            ...options.config,
            limits: configLimits
        };
        options.setConfig(updatedConfig);
    };
    // Ajouter une nouvelle limite
    const addLimit = ()=>{
        const newLimit = {
            color: "#000000",
            value: "",
            _id: nextId.current++
        };
        const updatedLimits = [
            ...limits,
            newLimit
        ];
        setLimits(updatedLimits);
        const configLimits = updatedLimits.map(({ _id: _id, ...rest })=>rest);
        const updatedConfig = {
            ...options.config,
            limits: configLimits
        };
        options.setConfig(updatedConfig);
    };
    // Supprimer une limite
    const removeLimit = (id)=>{
        const updatedLimits = limits.filter((l)=>l._id !== id);
        setLimits(updatedLimits);
        const configLimits = updatedLimits.map(({ _id: _id, ...rest })=>rest);
        const updatedConfig = {
            ...options.config,
            limits: configLimits
        };
        options.setConfig(updatedConfig);
    };
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$d6701e98ab1a6725), {
                required: false,
                name: "value",
                label: "Libell\xe9 de l'objet",
                onChange: (value)=>handleChange("libelle", value.value),
                defaultValue: fieldLibelle,
                options: options.fieldOptions,
                getOptionLabel: (option)=>option.value,
                getOptionValue: (option)=>option.value
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$d6701e98ab1a6725), {
                required: false,
                name: "geojson",
                label: "Valeur g\xe9om\xe9trique",
                onChange: (value)=>handleChange("geojson", value.value),
                defaultValue: fieldGeojson,
                options: options.fieldOptions,
                getOptionLabel: (option)=>option.value,
                getOptionValue: (option)=>option.value
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$d6701e98ab1a6725), {
                required: false,
                name: "value",
                label: "Valeur de r\xe9f\xe9rence",
                onChange: (value)=>handleChange("value", value.value),
                defaultValue: fieldValue,
                options: options.fieldOptions,
                getOptionLabel: (option)=>option.value,
                getOptionValue: (option)=>option.value
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$d6701e98ab1a6725), {
                required: false,
                name: "max",
                label: "Valeur maximale",
                onChange: (value)=>handleChange("max", value.value),
                defaultValue: fieldMax,
                options: options.fieldOptions,
                getOptionLabel: (option)=>option.value,
                getOptionValue: (option)=>option.value
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("hr", {}),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Label, {
                        className: "fw-bold mt-2",
                        children: "Couleur du pourcentage :"
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    limits.map((limit)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                            className: "mb-2",
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Control, {
                                        type: "color",
                                        value: limit.color,
                                        onChange: (e)=>debounceColorPick(limit._id, "color", e.target.value),
                                        style: {
                                            width: "100px",
                                            height: "40px",
                                            marginRight: "10px"
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Control, {
                                    type: "number",
                                    min: 0,
                                    step: 1,
                                    max: 100,
                                    required: false,
                                    defaultValue: limit.value,
                                    onBlur: (e)=>handleLimitsChange(limit._id, "value", e.target.value)
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                                    variant: "warning",
                                    className: "mt-3",
                                    onClick: ()=>removeLimit(limit._id),
                                    children: "Supprimer"
                                })
                            ]
                        }, limit._id)),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                        variant: "primary",
                        className: "mt-3",
                        onClick: addLimit,
                        children: "Ajouter une limite"
                    })
                ]
            })
        ]
    });
};
var $b52a2a3463509d08$export$2e2bcd8739ae039 = $b52a2a3463509d08$var$MapConfig;





const $f3dc9d46a9fd70e6$var$COLORS = [
    "#00293e",
    "#82ca9d",
    "#ffc658",
    "#ff8042",
    "#0088FE",
    "#00C49F",
    "pink",
    "#cf5340",
    "#851c7e",
    "#0b8000"
]; // Couleurs des sections du pie chart
const $f3dc9d46a9fd70e6$var$PieChartComponent = (data)=>{
    if (!data.data || data.data.length === 0) return;
    const dataMapped = (0, $e51454bc4e60e998$export$ae027ca1e1457159)(data.data, data.config);
    // Fonction pour obtenir la couleur d'un élément
    const getColorForItem = (item, index)=>{
        // Si les intervalles personnalisés sont activés
        if (data.config.useCustomIntervals && data.config.colorIntervals) {
            const intervals = data.config.colorIntervals;
            // Rechercher une correspondance par nom
            const matchingInterval = intervals.find((interval)=>interval.value === item.name);
            if (matchingInterval) return matchingInterval.color;
        }
        // Sinon, utiliser les couleurs par défaut
        return $f3dc9d46a9fd70e6$var$COLORS[index % $f3dc9d46a9fd70e6$var$COLORS.length];
    };
    const convertedData = dataMapped.map((item, index)=>({
            ...item,
            // Conserver les autres propriétés de l'objet
            value: parseInt(item.value),
            // Convertir `value` en entier
            fill: getColorForItem(item, index) // Ajouter la couleur
        }));
    const renderCustomizedLabel = ({ percent: percent, value: value })=>{
        if (!percent) return null;
        return `${value} (${(percent * 100).toFixed(2)}%)`;
    };
    const PieCell = (props)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $704464b332847712$export$e98c2c7eb2b14f45), {
            ...props,
            fill: props.payload?.fill || $f3dc9d46a9fd70e6$var$COLORS[props.index || 0]
        });
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ffea1da660acf881$export$e60a4704009a0009), {
        width: "100%",
        height: "100%",
        initialDimension: {
            width: 400,
            height: 300
        },
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $8eaae397f0969b90$export$b99d3348f709c998), {
            children: [
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2aaafd309dd678f7$export$2ae8800cf67c848c), {
                    data: convertedData,
                    dataKey: "value",
                    nameKey: "name",
                    outerRadius: "80%" // Rayon externe du pie
                    ,
                    innerRadius: "30%" // Rayon interne (pour un graphique en donut, par exemple)
                    ,
                    fill: "#00293e",
                    label: renderCustomizedLabel,
                    shape: PieCell
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2865094c59f6e421$export$ed247974535929c7), {})
            ]
        })
    });
};
var $f3dc9d46a9fd70e6$export$2e2bcd8739ae039 = $f3dc9d46a9fd70e6$var$PieChartComponent;








const $d44729ed25786703$var$PieChartConfig = (options)=>{
    // Valeur par défaut de `value`
    const fieldValue = options.fieldOptions.find((option)=>option.value === options.config.value) || "";
    // Valeur par défaut de `name`
    const fieldName = options.fieldOptions.find((option)=>option.value === options.config.name) || "";
    // Mettre à jour la config du composant avec la nouvelle valeur
    const handleChange = (fieldName, newValue)=>{
        const updatedConfig = {
            ...options.config
        };
        updatedConfig[fieldName] = newValue;
        options.setConfig(updatedConfig);
    };
    // Ajouter un nouvel intervalle
    const addInterval = ()=>{
        const intervals = options.config.colorIntervals || [];
        handleChange("colorIntervals", [
            ...intervals,
            {
                value: "",
                color: "#00293e"
            }
        ]);
    };
    // Supprimer un intervalle
    const removeInterval = (index)=>{
        const intervals = options.config.colorIntervals || [];
        handleChange("colorIntervals", intervals.filter((_, i)=>i !== index));
    };
    // Mettre à jour un intervalle
    const updateInterval = (index, field, value)=>{
        const intervals = [
            ...options.config.colorIntervals || []
        ];
        intervals[index] = {
            ...intervals[index],
            [field]: value
        };
        handleChange("colorIntervals", intervals);
    };
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$d6701e98ab1a6725), {
                required: false,
                name: "name",
                label: "Libell\xe9",
                onChange: (value)=>handleChange("name", value.value),
                options: options.fieldOptions,
                defaultValue: fieldName,
                getOptionLabel: (option)=>option.value,
                getOptionValue: (option)=>option.value
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$d6701e98ab1a6725), {
                required: false,
                name: "value",
                label: "Valeur",
                onChange: (value)=>handleChange("value", value.value),
                defaultValue: fieldValue,
                options: options.fieldOptions,
                getOptionLabel: (option)=>option.value,
                getOptionValue: (option)=>option.value
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                className: "mt-3 d-flex align-items-center",
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Check, {
                        type: "checkbox",
                        id: "useCustomIntervals",
                        label: "Plage d\xe9finie de valeurs",
                        checked: options.config.useCustomIntervals || false,
                        onChange: (e)=>handleChange("useCustomIntervals", e.target.checked)
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                        tooltipText: "Permet de d\xe9finir des plages de valeurs avec des couleurs sp\xe9cifiques. Si d\xe9sactiv\xe9, les couleurs seront attribu\xe9es arbitrairement (cas par d\xe9faut)",
                        tooltipId: "useCustomIntervals-tooltip",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$340bfce9b4df026b), {})
                    })
                ]
            }),
            options.config.useCustomIntervals && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                className: "mt-3",
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Label, {
                        className: "fw-bold mt-2",
                        children: "Valeurs possibles :"
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                    (options.config.colorIntervals || []).map((interval, index)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                            style: {
                                marginBottom: "10px",
                                display: "flex",
                                alignItems: "center"
                            },
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Control, {
                                    type: "color",
                                    defaultValue: interval.color,
                                    onBlur: (e)=>updateInterval(index, "color", e.target.value),
                                    style: {
                                        width: "40px",
                                        marginRight: "10px"
                                    }
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Control, {
                                    type: "text",
                                    placeholder: "Valeur",
                                    defaultValue: interval.value,
                                    onBlur: (e)=>updateInterval(index, "value", e.target.value),
                                    style: {
                                        marginRight: "10px"
                                    }
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                                    variant: "warning",
                                    onClick: ()=>removeInterval(index),
                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$4d4e10ce882b8153), {})
                                })
                            ]
                        }, index)),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                        variant: "primary",
                        className: "mt-3",
                        onClick: addInterval,
                        children: "Ajouter une valeur"
                    })
                ]
            })
        ]
    });
};
var $d44729ed25786703$export$2e2bcd8739ae039 = $d44729ed25786703$var$PieChartConfig;





const $8ebed6dca63f2907$var$TableComponent = (data)=>{
    if (!data.data || data.data.length === 0) return;
    const dataMapped = (0, $e51454bc4e60e998$export$44bc31952417c181)(data.data, data.config.map((item)=>item.col.value));
    // Extraire les noms des colonnes (clés du premier objet)
    const columns = data.config.map((item)=>item.col.name);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
        style: {
            width: "100%",
            height: "100%"
        },
        className: "overflow-auto",
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $13de46b4dfcc473f$export$2e2bcd8739ae039), {
            striped: true,
            bordered: true,
            hover: true,
            responsive: true,
            children: [
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("thead", {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("tr", {
                        children: columns.map((column, index)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("th", {
                                children: column
                            }, index) // En-têtes de colonnes
                        )
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("tbody", {
                    children: dataMapped.map((row, rowIndex)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("tr", {
                            children: Object.values(row).map((value, colIndex)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("td", {
                                    children: value
                                }, colIndex))
                        }, rowIndex))
                })
            ]
        })
    });
};
var $8ebed6dca63f2907$export$2e2bcd8739ae039 = $8ebed6dca63f2907$var$TableComponent;




var $kc00y = parcelRequire("kc00y");


const $3a68cece57bc69f3$var$TableConfig = (options)=>{
    // État pour stocker les colonnes configurées
    const [columns, setColumns] = (0, $kc00y.useState)(options.config || []);
    // Ajouter un nouveau champ
    const addSelectInput = ()=>{
        setColumns([
            ...columns,
            {
                col: {
                    value: "",
                    name: ""
                }
            }
        ]);
    };
    // Supprimer un champ
    const removeSelectInput = (index)=>{
        const newColumns = columns.filter((_, i)=>i !== index);
        setColumns(newColumns);
        options.setConfig(newColumns);
    };
    // Mettre à jour la valeur d'un champ
    const handleSelectChange = (index, value)=>{
        const newColumns = [
            ...columns
        ];
        newColumns[index].col.value = value;
        setColumns(newColumns);
        options.setConfig(newColumns);
    };
    // Mettre à jour le nom d'un champ
    const handleNameChange = (index, name)=>{
        const newColumns = [
            ...columns
        ];
        newColumns[index].col.name = name;
        setColumns(newColumns);
        options.setConfig(newColumns);
    };
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039), {
        children: [
            columns.map((column, index)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Group, {
                    className: "mb-3",
                    children: [
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                            required: false,
                            name: `name-${index}`,
                            label: "Nom de la colonne",
                            onChange: (e)=>handleNameChange(index, e.target.value),
                            value: column.col.name
                        }),
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$d6701e98ab1a6725), {
                            required: false,
                            name: `value-${index}`,
                            label: "Valeur de la colonne",
                            options: options.fieldOptions,
                            getOptionLabel: (option)=>option.value,
                            getOptionValue: (option)=>option.value,
                            defaultValue: column.col.value ? options.fieldOptions.find((option)=>option.value === column.col.value) : [],
                            onChange: (selected)=>handleSelectChange(index, selected.value || "")
                        }),
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                            variant: "danger",
                            size: "sm",
                            onClick: ()=>removeSelectInput(index),
                            className: "mt-2",
                            children: "Supprimer"
                        })
                    ]
                }, index)),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                variant: "primary",
                onClick: addSelectInput,
                children: "Ajouter un champ"
            })
        ]
    });
};
var $3a68cece57bc69f3$export$2e2bcd8739ae039 = $3a68cece57bc69f3$var$TableConfig;


const $aa18615e791616b9$export$1f26277db27165ba = (data)=>{
    // Format les données en sortie de service pour exploitation par les composants
    if (data) {
        const { name: name, values: values } = data;
        return values?.map((valueArray)=>{
            const dict = {};
            name.forEach((key, index)=>{
                dict[key] = valueArray[index];
            });
            return dict;
        });
    }
};
const $aa18615e791616b9$export$3230d9bab6b7e3b1 = {
    TEXT: {
        type: "text",
        valueType: "string",
        validate: (value)=>typeof value === "string"
    },
    NUMBER: {
        type: "number",
        valueType: "number",
        validate: (value)=>!isNaN(value)
    },
    SELECT: {
        type: "select",
        valueType: "string",
        validate: (value)=>Array.isArray(value)
    }
};
const $aa18615e791616b9$export$d70b11e36b5eeabf = {
    name: "",
    value: ""
};
const $aa18615e791616b9$export$abe0b82c026e0c1b = {
    value: "",
    max: "",
    limits: []
};
const $aa18615e791616b9$export$93abf8845938219b = {
    name: "",
    value: "",
    max: ""
};
const $aa18615e791616b9$export$9a67ce372a89ea35 = {
    name: "",
    value: "",
    max: ""
};
const $aa18615e791616b9$export$71b553ef914ccf29 = [];
const $aa18615e791616b9$export$ea739e05818e94bc = {
    label: "",
    value: 0
};
const $aa18615e791616b9$export$b8586192aead8a7e = {
    geojson: ""
};
const $aa18615e791616b9$export$128b094d0092ceb0 = {
    PIECHART: $aa18615e791616b9$export$d70b11e36b5eeabf,
    GAUGE: $aa18615e791616b9$export$abe0b82c026e0c1b,
    HORIZONTALCHAR: $aa18615e791616b9$export$93abf8845938219b,
    VERTICAL_BAR_CHART: $aa18615e791616b9$export$9a67ce372a89ea35,
    TABLE: $aa18615e791616b9$export$71b553ef914ccf29,
    COUNTER: $aa18615e791616b9$export$ea739e05818e94bc,
    MAP: $aa18615e791616b9$export$b8586192aead8a7e
};
const $aa18615e791616b9$export$cbedbfe2cd0caec7 = {
    PIECHART: {
        component: (0, $f3dc9d46a9fd70e6$export$2e2bcd8739ae039),
        label: "Camembert"
    },
    GAUGE: {
        component: (0, $73975e5a26a2357b$export$2e2bcd8739ae039),
        label: "Jauge"
    },
    HORIZONTALCHAR: {
        component: (0, $3f57840356a3a115$export$2e2bcd8739ae039),
        label: "Histogramme horizontal"
    },
    VERTICAL_BAR_CHART: {
        component: (0, $a9d4cdc42d828ad9$export$2e2bcd8739ae039),
        label: "Histogramme vertical"
    },
    TABLE: {
        component: (0, $8ebed6dca63f2907$export$2e2bcd8739ae039),
        label: "Tableau"
    },
    COUNTER: {
        component: (0, $46089813f65271d1$export$2e2bcd8739ae039),
        label: "Compteur"
    },
    MAP: {
        component: (0, $ec93d95b9fbddcee$export$2e2bcd8739ae039),
        label: "Carte"
    }
};
const $aa18615e791616b9$export$c05356b7a36e8e14 = {
    PIECHART: (0, $d44729ed25786703$export$2e2bcd8739ae039),
    GAUGE: (0, $b612425d814cc007$export$2e2bcd8739ae039),
    HORIZONTALCHAR: (0, $2186c66ed3f124b7$export$2e2bcd8739ae039),
    VERTICAL_BAR_CHART: (0, $84dcde0cc8743aa8$export$2e2bcd8739ae039),
    TABLE: (0, $3a68cece57bc69f3$export$2e2bcd8739ae039),
    COUNTER: (0, $7b8acf38a4c6a221$export$2e2bcd8739ae039),
    MAP: (0, $b52a2a3463509d08$export$2e2bcd8739ae039)
};
const $aa18615e791616b9$export$fde44257752a9f60 = {
    PIECHART: (0, $8603b77743deb39a$export$91aad23dbc00e487),
    GAUGE: (0, $8603b77743deb39a$export$d112062dd42154c4),
    HORIZONTALCHAR: (0, $8603b77743deb39a$export$26f6a63b41d0ff2a),
    VERTICAL_BAR_CHART: (0, $8603b77743deb39a$export$26f6a63b41d0ff2a),
    TABLE: (0, $8603b77743deb39a$export$f78aa240ba8eef75),
    COUNTER: (0, $8603b77743deb39a$export$257bd3ea676c4e1e),
    MAP: (0, $8603b77743deb39a$export$779959098413998d)
};
const $aa18615e791616b9$export$20a432be20af881b = (key, config)=>{
    if (!config) return config;
    if (key === "GAUGE") return $aa18615e791616b9$var$normalizeGaugeConfig(config);
    return config;
};
const $aa18615e791616b9$var$normalizeGaugeConfig = (config)=>{
    // Si le nouveau format est déjà présent, pas de transformation
    if (config.colorMode || config.highColor) return config;
    // Ancien format : pas de colorMode ni highColor,
    // les max sont des valeurs relatives (largeur de chaque segment)
    const limits = config.limits;
    if (!Array.isArray(limits) || limits.length === 0) return config;
    // Convertir les max relatifs en max absolus cumulés, dans l'ordre d'origine
    let cumulative = 0;
    const absoluteLimits = limits.map((l)=>{
        cumulative += l.max;
        return {
            max: cumulative,
            color: l.color
        };
    });
    // Extraire le dernier comme highColor
    const lastLimit = absoluteLimits[absoluteLimits.length - 1];
    return {
        ...config,
        limits: absoluteLimits.slice(0, -1),
        highColor: lastLimit.color || "#e74c3c",
        colorMode: "gradient"
    };
};




var $bkJfK = parcelRequire("bkJfK");

var $kc00y = parcelRequire("kc00y");







const $4cb4851535f96f9b$var$MAX_SIZE = 4;
const $4cb4851535f96f9b$var$ConfigFormDashboard = (props)=>{
    const { values: values, setFieldValue: setFieldValue } = (0, $bkJfK.useFormikContext)();
    const { error: errorToast } = (0, $6bdae0bad7b05751$export$91b3d218c74c79e4)();
    const [disabledModal, setDisabledModal] = (0, $kc00y.useState)(false); // Affiche la modale de confirmation
    // Récupère la liste de tous les profils utilisateur
    const { data: profilUtilisateurList } = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/dashboard/get-dashboard-profil-available`, {});
    const handleChangeSize = (largeur, hauteur, id)=>{
        // Change la taille du composant
        if (props.componentsListDashboard) {
            const componentFiltered = props.componentsListDashboard.find((component)=>component.id === id);
            // Vérifie qu'on ne dépasse pas la grille
            if (componentFiltered && componentFiltered.configPosition && componentFiltered.configPosition.x + largeur <= $4cb4851535f96f9b$var$MAX_SIZE && componentFiltered.configPosition.y + hauteur <= props.numberRowGrid) {
                componentFiltered.configPosition.hauteur = hauteur;
                componentFiltered.configPosition.largeur = largeur;
                props.setComponentSelected(componentFiltered);
                const newComponentList = props.componentsListDashboard.map((component)=>component.index === id ? componentFiltered : component);
                props.setComponentsListDashboard(newComponentList);
                props.removeRowUnused(newComponentList);
            } else errorToast("Le composant ne doit pas d\xe9passer de la grille");
        }
    };
    const handleRemoveComponent = ()=>{
        // Supprime de la grille le composant sélectionné
        if (props.componentSelected) {
            const newComponentList = props.componentsListDashboard.filter((componentInList)=>componentInList.id !== props.componentSelected?.id);
            props.setComponentsListDashboard(newComponentList);
            props.setComponentSelected(null);
            props.removeRowUnused(newComponentList);
        }
    };
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
        className: "mb-3",
        children: [
            props.editTabIndex !== null && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8598ca69ed8b9dca$export$2e2bcd8739ae039), {
                        variant: "info",
                        className: "mb-3 d-flex align-items-center",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("span", {
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$340bfce9b4df026b), {}),
                                " S\xe9lectionner un composant dans la liste de droite pour l'ajouter dans la grille, puis d\xe9placer le composant voulu \xe0 l'endroit voulu."
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                        className: "align-items-start",
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                xs: 8,
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                                    name: "title",
                                    label: "Titre du dashboard :",
                                    value: values.title ? values.title : props.dashboardTitle,
                                    onChange: (event)=>{
                                        if (!event) {
                                            setFieldValue("title", "");
                                            return;
                                        }
                                        props.setDashboardTitle(event.target.value);
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                xs: 4,
                                style: {
                                    zIndex: "11"
                                },
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$eae70af4b4e3f197), {
                                    name: "listGroupAuthorized",
                                    label: "Liste des profils utilisateurs autoris\xe9s :",
                                    options: profilUtilisateurList,
                                    value: values.profilsId ? profilUtilisateurList?.filter((p)=>values.profilsId.includes(p)) : props.dashboardProfilsUtilisateur,
                                    getOptionValue: (p)=>p.profilUtilisateurId,
                                    getOptionLabel: (p)=>p.profilUtilisateurLibelle,
                                    onChange: (profils)=>{
                                        if (!profils) {
                                            setFieldValue("profilsId", []);
                                            return;
                                        }
                                        props.setDashboardProfil(profils);
                                    },
                                    isClearable: true,
                                    required: false
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                            xs: 3,
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                                type: "submit",
                                variant: "success",
                                className: "mt-3",
                                children: "Enregistrer"
                            })
                        })
                    })
                ]
            }),
            props.componentSelected && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("hr", {}),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                        className: "d-flex justify-content-between align-items-end",
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$6bf0cd3a219bbade), {
                                min: 1,
                                step: 1,
                                max: $4cb4851535f96f9b$var$MAX_SIZE,
                                required: false,
                                name: "largeurComponent",
                                label: `Largeur du composant (1-${$4cb4851535f96f9b$var$MAX_SIZE}) :`,
                                onChange: (e)=>{
                                    const size = parseInt(e.target.value);
                                    if (!isNaN(size)) handleChangeSize(size, values.hauteurComponent, props.componentSelected?.id);
                                }
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$6bf0cd3a219bbade), {
                                min: 1,
                                step: 1,
                                max: $4cb4851535f96f9b$var$MAX_SIZE,
                                required: false,
                                name: "hauteurComponent",
                                label: `Hauteur du composant (1-${$4cb4851535f96f9b$var$MAX_SIZE}) :`,
                                onChange: (e)=>{
                                    const size = parseInt(e.target.value);
                                    if (!isNaN(size)) handleChangeSize(values.largeurComponent, size, props.componentSelected?.id);
                                }
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                                variant: "danger",
                                className: "ms-2",
                                onClick: ()=>setDisabledModal(true),
                                children: "Retirer le composant"
                            })
                        ]
                    }),
                    disabledModal && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $7d5f25ee93f10b42$export$2e2bcd8739ae039), {
                        visible: true,
                        content: "Retirer le composant ?",
                        closeModal: ()=>setDisabledModal(false),
                        query: "",
                        href: "#",
                        onConfirm: ()=>handleRemoveComponent()
                    })
                ]
            })
        ]
    });
};
var $4cb4851535f96f9b$export$2e2bcd8739ae039 = $4cb4851535f96f9b$var$ConfigFormDashboard;





var $kc00y = parcelRequire("kc00y");





const $c43176df88c7c7ef$var$componentDataCache = new Map();
const $c43176df88c7c7ef$var$pendingComponentQueryIds = new Set();
const $c43176df88c7c7ef$var$DATA_EMPTY = null;
// Subscribers notifiés quand une data queryId arrive (ou est annulée)
const $c43176df88c7c7ef$var$querySubscribers = new Map();
const $c43176df88c7c7ef$var$getComponentDataCacheKey = (queryId)=>queryId ? `query:${queryId}` : null;
const $c43176df88c7c7ef$var$subscribeToQuery = (queryId, callback)=>{
    if (!$c43176df88c7c7ef$var$querySubscribers.has(queryId)) $c43176df88c7c7ef$var$querySubscribers.set(queryId, new Set());
    $c43176df88c7c7ef$var$querySubscribers.get(queryId).add(callback);
    return ()=>{
        $c43176df88c7c7ef$var$querySubscribers.get(queryId)?.delete(callback);
    };
};
const $c43176df88c7c7ef$var$notifyQuerySubscribers = (queryId)=>{
    $c43176df88c7c7ef$var$querySubscribers.get(queryId)?.forEach((cb)=>cb());
    $c43176df88c7c7ef$var$querySubscribers.delete(queryId);
};
const $c43176df88c7c7ef$var$DashboardItem = (props)=>{
    const queryId = props.component?.queryId;
    const cacheKey = $c43176df88c7c7ef$var$getComponentDataCacheKey(queryId);
    const [formattedData, setFormattedData] = (0, $kc00y.useState)(()=>{
        if (props.component.data !== undefined) return Array.isArray(props.component.data) ? props.component.data : $c43176df88c7c7ef$var$DATA_EMPTY;
        if (!cacheKey) return undefined;
        return $c43176df88c7c7ef$var$componentDataCache.has(cacheKey) ? $c43176df88c7c7ef$var$componentDataCache.get(cacheKey) : undefined;
    });
    const { data: dataQuerys, run: runDataQuerys, isRejected: isDataQueryRejected } = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/dashboard/get-list-data-query/` + queryId);
    const runDataQuerysRef = (0, $kc00y.useRef)(runDataQuerys);
    runDataQuerysRef.current = runDataQuerys;
    const { attributes: attributes, listeners: listeners, setNodeRef: setNodeRef, transform: transform } = (0, $3b30af0a3bfceeb3$export$df30c81f5aa01ff7)({
        id: props.component.id
    });
    (0, $kc00y.useEffect)(()=>{
        if (props.component.data !== undefined) {
            const value = Array.isArray(props.component.data) ? props.component.data : $c43176df88c7c7ef$var$DATA_EMPTY;
            setFormattedData(value);
            if (cacheKey) $c43176df88c7c7ef$var$componentDataCache.set(cacheKey, value);
            return;
        }
        if (!cacheKey) {
            setFormattedData(undefined);
            return;
        }
        if ($c43176df88c7c7ef$var$componentDataCache.has(cacheKey)) setFormattedData($c43176df88c7c7ef$var$componentDataCache.get(cacheKey));
        else setFormattedData(undefined);
    }, [
        props.component.data,
        cacheKey
    ]);
    (0, $kc00y.useEffect)(()=>{
        if (!queryId || formattedData !== undefined) return;
        if (!cacheKey) return;
        // Vérifie d'abord si la data est arrivée dans le cache entre temps
        if ($c43176df88c7c7ef$var$componentDataCache.has(cacheKey)) {
            setFormattedData($c43176df88c7c7ef$var$componentDataCache.get(cacheKey));
            return;
        }
        // S'abonne pour être notifié quand la data arrive (via un autre item ou retard)
        const unsubscribe = $c43176df88c7c7ef$var$subscribeToQuery(queryId, ()=>{
            if ($c43176df88c7c7ef$var$componentDataCache.has(cacheKey)) setFormattedData($c43176df88c7c7ef$var$componentDataCache.get(cacheKey));
        });
        if ($c43176df88c7c7ef$var$pendingComponentQueryIds.has(queryId)) // Un autre item a déjà lancé le fetch, on attend juste la notification
        return unsubscribe;
        $c43176df88c7c7ef$var$pendingComponentQueryIds.add(queryId);
        runDataQuerysRef.current({
            dashboardQueryIds: [
                queryId
            ]
        });
        return unsubscribe;
    }, [
        queryId,
        cacheKey,
        formattedData
    ]);
    (0, $kc00y.useEffect)(()=>{
        if (!dataQuerys || !queryId) return;
        const resolvedQueryData = Array.isArray(dataQuerys) ? dataQuerys : [
            dataQuerys
        ];
        const queryData = resolvedQueryData.find((query)=>query.queryId === queryId);
        if (!queryData) return;
        $c43176df88c7c7ef$var$pendingComponentQueryIds.delete(queryId);
        try {
            const rawFormattedData = (0, $aa18615e791616b9$export$1f26277db27165ba)(queryData);
            const nextFormattedData = Array.isArray(rawFormattedData) ? rawFormattedData : $c43176df88c7c7ef$var$DATA_EMPTY;
            if (cacheKey) $c43176df88c7c7ef$var$componentDataCache.set(cacheKey, nextFormattedData);
            setFormattedData(nextFormattedData);
            // Notifie tous les autres items qui attendaient cette queryId
            $c43176df88c7c7ef$var$notifyQuerySubscribers(queryId);
        } catch (_error) {
            $c43176df88c7c7ef$var$pendingComponentQueryIds.delete(queryId);
            $c43176df88c7c7ef$var$notifyQuerySubscribers(queryId);
            setFormattedData($c43176df88c7c7ef$var$DATA_EMPTY);
        }
    }, [
        dataQuerys,
        queryId,
        cacheKey
    ]);
    (0, $kc00y.useEffect)(()=>{
        if (isDataQueryRejected && queryId) {
            // Libère le verrou pour permettre un retry et notifie les subscribers
            $c43176df88c7c7ef$var$pendingComponentQueryIds.delete(queryId);
            $c43176df88c7c7ef$var$notifyQuerySubscribers(queryId);
        }
    }, [
        isDataQueryRejected,
        queryId
    ]);
    // Cleanup : retire cet item du pending s'il est démonté avant la réponse
    (0, $kc00y.useEffect)(()=>{
        return ()=>{
            if (queryId) $c43176df88c7c7ef$var$pendingComponentQueryIds.delete(queryId);
        };
    }, [
        queryId
    ]);
    const componentPosition = props.component.configPosition ?? {
        x: 0,
        y: 0,
        largeur: 1,
        hauteur: 1
    };
    const style = {
        transform: `translate3d(${transform?.x || 0}px, ${transform?.y || 0}px, 0)`,
        position: "absolute",
        top: `${componentPosition.y * props.heightRow}px`,
        left: `${componentPosition.x * 25}%`,
        width: `${(componentPosition.largeur ?? 1) * 25}%`,
        height: `calc(${(componentPosition.hauteur ?? 1) * props.heightRow}px - 2rem)`,
        zIndex: props.isSelected ? 10 : 1
    };
    // Set le composant associé à la clé
    const componentEntry = (0, $aa18615e791616b9$export$cbedbfe2cd0caec7)[props.component.key];
    const Component = componentEntry?.component;
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
        ref: setNodeRef,
        ...attributes,
        ...listeners,
        style: style,
        className: `dashboard-item ${props.isSelected ? "active" : ""}`,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1988c313b8430f65$export$2e2bcd8739ae039), {
            bg: "secondary",
            className: "p-2",
            style: {
                border: props.isSelected ? "2px solid blue" : "1px solid grey",
                boxShadow: props.isSelected ? "0 0 10px rgba(0, 0, 255, 0.5)" : "none"
            },
            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1988c313b8430f65$export$2e2bcd8739ae039).Body, {
                className: "p-0",
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1988c313b8430f65$export$2e2bcd8739ae039).Header, {
                        children: props.component.title
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                        style: {
                            height: `calc(${style.height} - 2rem)`
                        },
                        children: formattedData === undefined ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $c21b1c237cfa1d94$export$2e2bcd8739ae039), {}) : formattedData === $c43176df88c7c7ef$var$DATA_EMPTY || Array.isArray(formattedData) && formattedData.length === 0 ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                            className: "text-center text-muted p-3",
                            children: "Aucune donn\xe9e disponible"
                        }) : Component ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)(Component, {
                            data: formattedData,
                            config: props.component.config
                        }) : /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                            className: "text-center text-danger p-3",
                            children: "Composant indisponible"
                        })
                    })
                ]
            })
        })
    });
};
var $c43176df88c7c7ef$export$2e2bcd8739ae039 = $c43176df88c7c7ef$var$DashboardItem;


const $e805bf7d3bc37ed5$var$HEIGHT_ROW = 200;
const $e805bf7d3bc37ed5$var$NB_COL = 4; // Nombre de colonnes dans la grille
const $e805bf7d3bc37ed5$var$normalizeDashboardProfilIds = (dashboardProfil)=>{
    if (!dashboardProfil) return null;
    const normalized = dashboardProfil.map((profilEntry)=>{
        if (typeof profilEntry === "string") return profilEntry;
        if (profilEntry && profilEntry.profilUtilisateurId !== undefined) return String(profilEntry.profilUtilisateurId);
        return null;
    }).filter((profilId)=>Boolean(profilId));
    return normalized;
};
const $e805bf7d3bc37ed5$var$getInitialValues = (componentSelected)=>({
        // Initialise la taille par défaut d'un nouveau composant
        hauteurComponent: componentSelected && componentSelected.configPosition ? componentSelected.configPosition.hauteur ?? 1 : 1,
        largeurComponent: componentSelected && componentSelected.configPosition ? componentSelected.configPosition.largeur ?? 1 : 1
    });
const $e805bf7d3bc37ed5$var$getPrepareVariables = (activeDashboard, componentsListDashboard, dashboardTitle, dashboardProfil)=>{
    // Configure les données à envoyés au service
    return {
        ...activeDashboard.id && {
            dashboardId: activeDashboard.id
        },
        dashboardTitle: dashboardTitle,
        dashboardComponents: componentsListDashboard ? componentsListDashboard.map((component)=>({
                componentId: component.id,
                componentConfig: JSON.stringify({
                    componentLargeur: component.configPosition?.largeur,
                    componentHauteur: component.configPosition?.hauteur,
                    componentX: component.configPosition?.x,
                    componentY: component.configPosition?.y
                })
            })) : null,
        dashboardProfilsId: $e805bf7d3bc37ed5$var$normalizeDashboardProfilIds(dashboardProfil)
    };
};
// Référence stable pour éviter de recréer `run` à chaque render
const $e805bf7d3bc37ed5$var$EMPTY_OPTIONS = {};
const $e805bf7d3bc37ed5$var$ConfigDynamicGrid = ({ editTabIndex: editTabIndex, componentsListDashboard: componentsListDashboard, setComponentsListDashboard: setComponentsListDashboard, activeDashboard: activeDashboard, setActiveDashboard: setActiveDashboard, dashboardCacheRef: dashboardCacheRef, onSave: onSave })=>{
    // Initialiser le profil depuis le cache si disponible
    const [dashboardProfil, setDashboardProfil] = (0, $kc00y.useState)(()=>{
        const cached = activeDashboard.id ? dashboardCacheRef.current.get(activeDashboard.id) : null;
        return cached?.profils ?? null;
    });
    const [dashboardTitle, setDashboardtitle] = (0, $kc00y.useState)("Nouveau Dashboard");
    const [numberRowGrid, setNumberRowGrid] = (0, $kc00y.useState)(componentsListDashboard ? componentsListDashboard.length * $e805bf7d3bc37ed5$var$NB_COL : 0);
    const [componentSelected, setComponentSelected] = (0, $kc00y.useState)();
    const loadedConfigIdsRef = (0, $kc00y.useRef)(new Set());
    const configRequestInProgressIdRef = (0, $kc00y.useRef)(null);
    const profilRequestInProgressIdRef = (0, $kc00y.useRef)(null);
    const handleDragStart = (event)=>{
        // Set le composant sélectionné
        setComponentSelected(componentsListDashboard?.find((component)=>component.id === event.active.id));
    };
    const handleDragEnd = (event)=>{
        const tagCol = document.getElementById("col-grid-component"); // Largeur d'une colonne (variable selon taille écran)
        const widthCol = tagCol?.offsetWidth ? tagCol.offsetWidth : 0;
        const newX = Math.round(event.delta.x / widthCol);
        const newY = Math.round(event.delta.y / $e805bf7d3bc37ed5$var$HEIGHT_ROW);
        // S'assure que le composant ne dépasse pas de la grille
        const posX = componentSelected && componentSelected.configPosition ? componentSelected.configPosition.x + newX : -1;
        const posY = componentSelected && componentSelected.configPosition ? componentSelected.configPosition.y + newY : -1;
        if (componentsListDashboard && componentsListDashboard.length > 0 && componentSelected && componentSelected.configPosition && posX + (componentSelected.configPosition.largeur ?? 1) <= $e805bf7d3bc37ed5$var$NB_COL && posY + (componentSelected.configPosition.hauteur ?? 1) <= numberRowGrid && posX >= 0 && posY >= 0) {
            // Set les nouvelles coordonnées dans la grille
            const newComponentConfig = componentsListDashboard.find((component)=>component.id === event.active.id);
            if (newComponentConfig && newComponentConfig.configPosition) {
                newComponentConfig.configPosition.x = posX;
                newComponentConfig.configPosition.y = posY;
                setComponentSelected(newComponentConfig);
                const newComponentList = componentsListDashboard.map((component)=>component.id === event.active.id ? newComponentConfig : component);
                setComponentsListDashboard(newComponentList);
                // Supprime les lignes en trop si existe
                removeRowUnused(newComponentList);
            }
        }
    };
    const removeRowUnused = (componentList)=>{
        // Supprime les lignes innocupés après le composant le plus bas
        let lowestRow = -1;
        componentList.forEach((component)=>{
            const y = component.configPosition?.y ?? 0;
            const hauteur = component.configPosition?.hauteur ?? 1;
            const bottomLine = Number(y) + Number(hauteur); // Ligne la plus basse occupée par ce composant
            if (bottomLine > lowestRow) lowestRow = bottomLine; // Mettre à jour la ligne la plus basse
        });
        lowestRow = lowestRow < componentList.length * $e805bf7d3bc37ed5$var$NB_COL // S'assure qu'on affiche toujours un minimum de ligne égale au nombre de composants
         ? componentList.length * $e805bf7d3bc37ed5$var$NB_COL : lowestRow;
        setNumberRowGrid(lowestRow);
    };
    (0, $kc00y.useEffect)(()=>{
        setNumberRowGrid(componentsListDashboard ? componentsListDashboard.length * $e805bf7d3bc37ed5$var$NB_COL : 0);
    }, [
        componentsListDashboard
    ]);
    const urlApiDashboard = (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/dashboard/get-dashboard-config/`;
    const { run: runListComponents, data: listComponents } = (0, $8d9ebd8892d8a5f5$export$6326fb4463ae1be4)(urlApiDashboard + activeDashboard.id, $e805bf7d3bc37ed5$var$EMPTY_OPTIONS);
    // Ref toujours à jour vers run, mais hors des deps de useEffect
    const runListComponentsRef = (0, $kc00y.useRef)(runListComponents);
    runListComponentsRef.current = runListComponents;
    // On initialise la liste des composants du dashboard
    (0, $kc00y.useEffect)(()=>{
        if (listComponents) // si on a déjà des composants AVEC leurs data
        // on n'écrase pas avec une version "fraîche" sans data
        setComponentsListDashboard((prev)=>{
            if (prev && prev.length > 0 && prev.every((c)=>"data" in c)) return prev;
            const newComponentList = [];
            listComponents?.forEach((element)=>{
                newComponentList.push({
                    id: element.componentId,
                    key: element.componentKey,
                    title: element.componentTitle,
                    config: (0, $aa18615e791616b9$export$20a432be20af881b)(element.componentKey, element.componentConfig),
                    configPosition: {
                        x: element.componentConfigPosition ? element.componentConfigPosition.componentX : 0,
                        y: element.componentConfigPosition ? element.componentConfigPosition.componentY : 0,
                        largeur: element.componentConfigPosition ? element.componentConfigPosition.componentLargeur : 2,
                        hauteur: element.componentConfigPosition ? element.componentConfigPosition.componentHauteur : 2
                    },
                    queryId: element.componentQueryId
                });
            });
            if (activeDashboard.id) {
                loadedConfigIdsRef.current.add(activeDashboard.id);
                if (configRequestInProgressIdRef.current === activeDashboard.id) configRequestInProgressIdRef.current = null;
            }
            return newComponentList;
        });
    }, [
        listComponents,
        setComponentsListDashboard,
        activeDashboard.id
    ]);
    // Récupère en base les profils liés à un dashboard
    const fetchDashboardProfils = (0, $8d9ebd8892d8a5f5$export$6326fb4463ae1be4)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/dashboard/get-dashboard-list-profil/` + activeDashboard.id, $e805bf7d3bc37ed5$var$EMPTY_OPTIONS);
    // Extraction de valeurs
    const profilsResolved = fetchDashboardProfils.isResolved;
    const profilsData = fetchDashboardProfils.data;
    const runProfilsRef = (0, $kc00y.useRef)(fetchDashboardProfils.run);
    runProfilsRef.current = fetchDashboardProfils.run;
    (0, $kc00y.useEffect)(()=>{
        if (profilsResolved) {
            const normalizedProfils = Array.isArray(profilsData) ? profilsData : null;
            setDashboardProfil(normalizedProfils);
            if (activeDashboard.id) {
                if (profilRequestInProgressIdRef.current === activeDashboard.id) profilRequestInProgressIdRef.current = null;
            }
        }
    }, [
        profilsData,
        profilsResolved,
        activeDashboard.id
    ]);
    (0, $kc00y.useEffect)(()=>{
        const dashboardId = activeDashboard.id;
        const cached = dashboardId ? dashboardCacheRef.current.get(dashboardId) : null;
        setDashboardtitle(activeDashboard.title);
        setComponentsListDashboard((prev)=>prev === null ? [] : prev);
        if (cached) {
            setDashboardProfil(cached.profils);
            return;
        }
        setDashboardProfil(null);
    }, [
        activeDashboard.id,
        activeDashboard.title,
        setComponentsListDashboard,
        dashboardCacheRef
    ]);
    // Au changement de dashboard : check cache et fetch sans doublon
    (0, $kc00y.useEffect)(()=>{
        const dashboardId = activeDashboard.id;
        if (!dashboardId) return;
        const cached = dashboardCacheRef.current.get(dashboardId);
        if (cached) loadedConfigIdsRef.current.add(dashboardId);
        if (!loadedConfigIdsRef.current.has(dashboardId) && configRequestInProgressIdRef.current !== dashboardId) {
            configRequestInProgressIdRef.current = dashboardId;
            runListComponentsRef.current();
        }
        if (profilRequestInProgressIdRef.current !== dashboardId) {
            profilRequestInProgressIdRef.current = dashboardId;
            runProfilsRef.current();
        }
    }, [
        activeDashboard.id,
        dashboardCacheRef
    ]);
    // Reset à la fermeture
    (0, $kc00y.useEffect)(()=>{
        return ()=>{
            loadedConfigIdsRef.current = new Set();
            configRequestInProgressIdRef.current = null;
            profilRequestInProgressIdRef.current = null;
        };
    }, []);
    const handleDashboardProfilChange = (profilsIds)=>{
        setDashboardProfil(profilsIds);
    };
    const urlApiSaveDashboard = (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/dashboard/create-dashboard/`;
    const urlApiUpdateDashboard = (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/dashboard/update-dashboard/`;
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        fluid: true,
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                validationSchema: (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({}),
                onSubmit: (dashboard)=>{
                    const savedDashboardId = dashboard.dashboardId ?? activeDashboard.id;
                    const savedDashboardTitle = dashboard.dashboardTitle ?? dashboardTitle ?? activeDashboard.title;
                    if (savedDashboardId) dashboardCacheRef.current.set(savedDashboardId, {
                        components: componentsListDashboard ?? [],
                        profils: dashboardProfil ?? []
                    });
                    setActiveDashboard({
                        id: savedDashboardId,
                        title: savedDashboardTitle,
                        index: activeDashboard.index
                    });
                    onSave();
                },
                initialValues: $e805bf7d3bc37ed5$var$getInitialValues(componentSelected),
                submitUrl: activeDashboard.id ? urlApiUpdateDashboard : urlApiSaveDashboard,
                successToastMessage: "Le tableau de bord a correctement \xe9t\xe9 enregistr\xe9",
                errorToastMessage: "Le tableau de bord n'a pas \xe9t\xe9 correctement enregistr\xe9",
                prepareVariables: ()=>$e805bf7d3bc37ed5$var$getPrepareVariables(activeDashboard, componentsListDashboard, dashboardTitle, dashboardProfil),
                isPost: activeDashboard.id ? false : true,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $4cb4851535f96f9b$export$2e2bcd8739ae039), {
                    editTabIndex: editTabIndex,
                    setComponentSelected: setComponentSelected,
                    componentsListDashboard: componentsListDashboard ?? [],
                    setComponentsListDashboard: setComponentsListDashboard,
                    componentSelected: componentSelected ?? undefined,
                    numberRowGrid: numberRowGrid,
                    setNumberRowGrid: setNumberRowGrid,
                    removeRowUnused: removeRowUnused,
                    dashboardProfilsUtilisateur: dashboardProfil,
                    setDashboardProfil: handleDashboardProfilChange,
                    dashboardTitle: activeDashboard.title,
                    setDashboardTitle: setDashboardtitle
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                className: "position-relative",
                children: [
                    Array.from({
                        length: $e805bf7d3bc37ed5$var$NB_COL
                    }, (_, colIndex)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                            id: "col-grid-component",
                            className: "border p-0 position-relative",
                            style: {
                                height: "100%"
                            },
                            children: Array.from({
                                length: numberRowGrid
                            }, (_, rowIndex)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                    id: `${colIndex}-${rowIndex}`,
                                    className: "droppable border",
                                    style: {
                                        height: $e805bf7d3bc37ed5$var$HEIGHT_ROW + "px" // Hauteur des lignes
                                    }
                                }, `${colIndex}-${rowIndex}`))
                        }, colIndex)),
                    editTabIndex !== null ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $3b30af0a3bfceeb3$export$2d5c5ceac203fc1e), {
                        onDragStart: handleDragStart,
                        onDragEnd: handleDragEnd,
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($e805bf7d3bc37ed5$var$ListComponents, {
                            componentsListDashboard: componentsListDashboard,
                            componentSelected: componentSelected
                        })
                    }) : /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($e805bf7d3bc37ed5$var$ListComponents, {
                        componentsListDashboard: componentsListDashboard,
                        componentSelected: componentSelected
                    })
                ]
            })
        ]
    });
};
var $e805bf7d3bc37ed5$export$2e2bcd8739ae039 = $e805bf7d3bc37ed5$var$ConfigDynamicGrid;
/**
 * Permet d'afficher la liste des composants du dashboard
 * Va chercher les données des requêtes associées aux composants
 * @param param0
 * @returns
 */ const $e805bf7d3bc37ed5$var$ListComponents = ({ componentsListDashboard: componentsListDashboard, componentSelected: componentSelected })=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
        children: componentsListDashboard && componentsListDashboard.map((component)=>{
            return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $c43176df88c7c7ef$export$2e2bcd8739ae039), {
                component: component,
                isSelected: componentSelected?.id === component.id,
                heightRow: $e805bf7d3bc37ed5$var$HEIGHT_ROW
            }, component.id);
        })
    });
};


const $755e362237c9dc81$var$ConfigDynamicDashboard = (props)=>{
    const { error: errorToast, success: successToast } = (0, $6bdae0bad7b05751$export$91b3d218c74c79e4)();
    const [disabledModal, setDisabledModal] = (0, $kc00y.useState)(false);
    const [indexToRemove, setIndexToRemove] = (0, $kc00y.useState)(null);
    const [gridReloadVersion, setGridReloadVersion] = (0, $kc00y.useState)(0);
    const abortControllerRef = (0, $kc00y.useRef)(null);
    (0, $kc00y.useEffect)(()=>{
        return ()=>{
            abortControllerRef.current?.abort();
        };
    }, []);
    const urlApiDeleteDashboard = (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/dashboard/delete-dashboard/`;
    // Sélectionne l'onglet du dashboard cliqué
    const handleDashboardClick = (indexKey)=>{
        if (props.openListDashboard && props.editTabIndex === null) {
            if (props.activeDashboard?.index === indexKey) return;
            const target = props.openListDashboard[indexKey];
            const cached = target?.id ? props.dashboardCacheRef.current.get(target.id) : null;
            if (cached) //  on restaure instantanément, aucun fetch
            props.setComponentsListDashboard(cached.components);
            else // on déclenche le chargement normal
            props.setComponentsListDashboard(null);
            props.setActiveDashboard(target);
        }
    };
    // édite le dashboard
    const handleEditTab = (indexKey)=>{
        if (props.openListDashboard) {
            props.setEditTabIndex(indexKey);
            props.setActiveDashboard(props.openListDashboard[indexKey ?? 0]);
        }
    };
    // Ferme l'onglet sélectionné
    const handleCloseTab = (indexKey)=>{
        if (props.openListDashboard) {
            const dashboardToRemove = props.openListDashboard.find((dashboard)=>dashboard.index === indexKey);
            if (dashboardToRemove && dashboardToRemove.id) fetchDeleteDashboard(dashboardToRemove, indexKey);
            else updateDashboardList(indexKey);
        }
    };
    // Met à jour les onglets
    const updateDashboardList = (indexKey)=>{
        if (props.openListDashboard) {
            const updatedDashboard = props.openListDashboard.filter((dashboard)=>dashboard?.index !== indexKey);
            // Réinitialisation des indexKey pour chaque onglet
            const resetOpenListDashboard = updatedDashboard.map((dashboard, index)=>({
                    ...dashboard,
                    index: index
                }));
            props.setActiveDashboard(null);
            props.setOpenListDashboard(resetOpenListDashboard);
        }
    };
    // Supprime le dashboard en base
    const fetchDeleteDashboard = async (dashboard, indexKey)=>{
        // Annuler une éventuelle requête précédente
        abortControllerRef.current?.abort();
        abortControllerRef.current = new AbortController();
        try {
            const response = await fetch(urlApiDeleteDashboard + dashboard.id, (0, $fbd4d34e07af0ac7$export$b163ec2f884327db)({
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json"
                },
                signal: abortControllerRef.current.signal
            }));
            await response.json();
            // le dashboard n'existe plus
            if (dashboard.id) props.dashboardCacheRef.current.delete(dashboard.id);
            updateDashboardList(indexKey);
            successToast("Le tableau de bord a correctement \xe9t\xe9 supprim\xe9");
        } catch (e) {
            const errorName = e instanceof Error ? e.name : undefined;
            // Ne pas afficher d'erreur si c'est une annulation volontaire
            if (errorName !== "AbortError") errorToast(String(e));
        }
    };
    // Ajoute un nouvel onglet pour un nouveau dashoard
    const handleAddDashboard = ()=>{
        const newDashboard = {
            index: null,
            title: "Nouveau tableau de bord"
        };
        const newOpenListDashboard = props.openListDashboard ? [
            ...props.openListDashboard,
            newDashboard
        ] : [];
        // Réinitialise les index
        const resetOpenListDashboard = newOpenListDashboard.map((dashboard, index)=>({
                ...dashboard,
                index: index
            }));
        // On vide le dashboard des composants présents à l'écran
        props.setComponentsListDashboard(null);
        props.setOpenListDashboard(resetOpenListDashboard);
        props.setActiveDashboard(resetOpenListDashboard[resetOpenListDashboard.length - 1]);
    };
    // Annule l'édition du dashboard
    const handleCancelEdit = ()=>{
        //  Annuler les requêtes en cours
        abortControllerRef.current?.abort();
        if (!props.openListDashboard || props.openListDashboard.length === 0) {
            props.setComponentsListDashboard(null);
            props.setActiveDashboard(null);
            props.setEditTabIndex(null);
            return;
        }
        const editedDashboard = props.openListDashboard.find((dashboard)=>dashboard.index === props.editTabIndex);
        const dashboardToRestore = editedDashboard ?? props.openListDashboard[0];
        if (dashboardToRestore?.id) props.dashboardCacheRef.current.delete(dashboardToRestore.id);
        props.setComponentsListDashboard(null);
        props.setActiveDashboard(dashboardToRestore);
        setGridReloadVersion((prev)=>prev + 1);
        props.setEditTabIndex(null);
    };
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$d112062dd42154c4), {}),
                title: "\xc9dition des tableaux de bord et profils associ\xe9s",
                urlRetour: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).MODULE_ADMIN
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                className: "flex-grow-1 d-flex flex-column",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                    className: "d-flex align-items-center",
                    children: [
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b9d4d12a3c294259$export$2e2bcd8739ae039), {
                            variant: "tabs",
                            activeKey: props.activeDashboard?.index ?? undefined,
                            children: props.openListDashboard && props.openListDashboard.map((dashboard)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b9d4d12a3c294259$export$2e2bcd8739ae039).Item, {
                                    className: props.editTabIndex !== null && props.editTabIndex !== dashboard.index ? "d-none" : "",
                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $b9d4d12a3c294259$export$2e2bcd8739ae039).Link, {
                                        eventKey: dashboard.index,
                                        onClick: ()=>handleDashboardClick(dashboard.index ?? 0),
                                        className: "d-flex align-items-center",
                                        children: [
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                                className: "align-items-center text-truncate",
                                                title: dashboard.title,
                                                style: {
                                                    width: "11rem"
                                                },
                                                children: dashboard.title
                                            }),
                                            props.editTabIndex === null ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                                                        variant: "link",
                                                        size: "sm",
                                                        className: "text-info ms-2 text-decoration-none",
                                                        onClick: (e)=>{
                                                            e.stopPropagation();
                                                            handleEditTab(dashboard.index ?? 0);
                                                        },
                                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$b51dd496211ae105), {})
                                                    }),
                                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                                                        variant: "link",
                                                        size: "sm",
                                                        onClick: (e)=>{
                                                            e.stopPropagation();
                                                            setIndexToRemove(dashboard.index ?? 0);
                                                            setDisabledModal(true);
                                                        },
                                                        className: "ms-2 text-danger text-decoration-none",
                                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$4d4e10ce882b8153), {})
                                                    })
                                                ]
                                            }) : null
                                        ]
                                    })
                                }, dashboard.index))
                        }),
                        props.editTabIndex === null ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                            className: "ms-auto",
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8ad69b89456b65bc$export$2e2bcd8739ae039), {
                                title: "Ajouter",
                                onClick: handleAddDashboard
                            })
                        }) : /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                            variant: "secondary",
                            className: "ms-2",
                            onClick: handleCancelEdit,
                            children: "Annuler"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                className: "flex-grow-1 mt-3",
                children: props.activeDashboard ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e805bf7d3bc37ed5$export$2e2bcd8739ae039), {
                    editTabIndex: props.editTabIndex,
                    componentsListDashboard: props.componentsListDashboard,
                    setComponentsListDashboard: props.setComponentsListDashboard,
                    activeDashboard: props.activeDashboard,
                    setActiveDashboard: props.setActiveDashboard,
                    dashboardCacheRef: props.dashboardCacheRef,
                    onSave: handleCancelEdit
                }, props.activeDashboard.id ? `dashboard-${props.activeDashboard.id}-${gridReloadVersion}` : `dashboard-new-${props.activeDashboard.index ?? "default"}-${gridReloadVersion}`) : /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                    className: "alert alert-primary",
                    role: "alert",
                    children: "Aucun dashboard n'est s\xe9lectionn\xe9, veuillez en choisir un ou en ajouter."
                })
            }),
            disabledModal && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $7d5f25ee93f10b42$export$2e2bcd8739ae039), {
                visible: true,
                content: "Supprimer le tableau de bord ?",
                closeModal: ()=>setDisabledModal(false),
                query: "",
                href: "#",
                onConfirm: ()=>{
                    if (indexToRemove !== null) handleCloseTab(indexToRemove);
                }
            })
        ]
    });
};
var $755e362237c9dc81$export$2e2bcd8739ae039 = $755e362237c9dc81$var$ConfigDynamicDashboard;




var $kc00y = parcelRequire("kc00y");




const $9b2c6a3f81211437$var$QueryComponentList = ({ openListQuery: openListQuery, setComponentsListDashboard: setComponentsListDashboard, componentsListDashboard: componentsListDashboard })=>{
    const [queryId, setQueryId] = (0, $kc00y.useState)(null); // ID de la requête sélectionnée
    const { run: runDataQuerys, data: configDataQuerys } = (0, $8d9ebd8892d8a5f5$export$6326fb4463ae1be4)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/dashboard/get-component-config/` + queryId, {});
    (0, $kc00y.useEffect)(()=>{
        if (queryId) runDataQuerys();
    }, [
        queryId,
        runDataQuerys
    ]);
    (0, $kc00y.useEffect)(()=>{
        if (configDataQuerys) {
            // Position initial lors de l'ajout d'un nouveau composant
            const configPosition = {
                largeur: 2,
                hauteur: 2,
                x: 0,
                y: 0
            };
            // Créer le nouveau composant
            const componentAdd = {
                id: configDataQuerys.dashboardComponentId,
                queryId: configDataQuerys.dashboardComponentDahsboardQueryId,
                key: configDataQuerys.dashboardComponentKey,
                title: configDataQuerys.dashboardComponentTitle,
                config: (0, $aa18615e791616b9$export$20a432be20af881b)(configDataQuerys.dashboardComponentKey, configDataQuerys.dashboardComponentConfig),
                configPosition: configPosition
            };
            setComponentsListDashboard((prev)=>[
                    ...prev ?? [],
                    componentAdd
                ]);
        }
    }, [
        configDataQuerys,
        setComponentsListDashboard
    ]);
    // Ajoute l'ID du composant sélectionné
    const handleItemClick = (id)=>{
        setQueryId(id);
    };
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1988c313b8430f65$export$2e2bcd8739ae039), {
        bg: "secondary",
        className: "m-3",
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1988c313b8430f65$export$2e2bcd8739ae039).Header, {
                className: "d-flex justify-content-center align-items-center",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("span", {
                    children: "Liste requ\xeates et composants"
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $87d0f3f36f67a4f7$export$2e2bcd8739ae039), {
                variant: "flush",
                className: "overflow-auto",
                style: {
                    maxHeight: "400px"
                },
                children: openListQuery && openListQuery.map((query)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $87d0f3f36f67a4f7$export$2e2bcd8739ae039).Item, {
                        className: "mb-3",
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $4c986386eda483ee$export$2e2bcd8739ae039), {
                                placement: "top",
                                overlay: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $fbf962b4d348672d$export$2e2bcd8739ae039), {
                                    id: `tooltip-${query.id}`,
                                    children: [
                                        query.title,
                                        " "
                                    ]
                                }),
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("strong", {
                                    className: "d-block",
                                    children: query.title
                                })
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1988c313b8430f65$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $87d0f3f36f67a4f7$export$2e2bcd8739ae039), {
                                    variant: "flush",
                                    className: "overflow-auto",
                                    children: query.components.map((component)=>{
                                        // Si composant déjà sélectionné on le désactive
                                        const isInDashboard = componentsListDashboard ? componentsListDashboard.find((componentInDashboard)=>componentInDashboard.id === component.componentId) : false;
                                        return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $87d0f3f36f67a4f7$export$2e2bcd8739ae039).Item, {
                                            role: "button",
                                            className: `d-flex justify-content-between align-items-center ${isInDashboard ? "bg-light text-muted" : queryId === component.componentId ? "bg-primary text-white" : ""}`,
                                            style: {
                                                cursor: isInDashboard ? "default" : "pointer"
                                            },
                                            ...!isInDashboard && {
                                                onClick: ()=>handleItemClick(component.componentId)
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("span", {
                                                    className: "text-truncate",
                                                    children: component.componentTitle
                                                }),
                                                (0, $aa18615e791616b9$export$fde44257752a9f60)[component.componentKey]
                                            ]
                                        }, component.componentId);
                                    })
                                })
                            })
                        ]
                    }, query.id))
            })
        ]
    });
};
var $9b2c6a3f81211437$export$2e2bcd8739ae039 = $9b2c6a3f81211437$var$QueryComponentList;


const $661778a0caccebd1$var$ComponentBoardDashboardAdmin = ()=>{
    const [openListDashboard, setOpenListDashboard] = (0, $kc00y.useState)(); // Liste des onglets Dashboard
    const [openListQuery, setOpenListQuery] = (0, $kc00y.useState)(); // Liste des dashboard et ses composants
    const [editTabIndex, setEditTabIndex] = (0, $kc00y.useState)(null); // Index du dashboard à éditer
    const [activeDashboard, setActiveDashboard] = (0, $kc00y.useState)(null); // Dashboard ouvert à l'écran
    // Cache mémoire : survit aux remontages de ConfigDynamicDashboard
    const dashboardCacheRef = (0, $kc00y.useRef)(new Map());
    const [componentsListDashboard, setComponentsListDashboard] = (0, $kc00y.useState)(undefined); // Composant sélectionner dans la grid
    const urlApiQuerys = (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/dashboard/get-query-list-all`;
    const urlApiDashboards = (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/dashboard/get-list-dashboard`;
    // Récupère les Composants de chaque requête en base
    const fetchDataQuery = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)(urlApiQuerys);
    (0, $kc00y.useMemo)(()=>{
        if (fetchDataQuery.isResolved) {
            const resOpenQueryList = [];
            fetchDataQuery.data.forEach((element)=>{
                resOpenQueryList.push({
                    id: element.queryId,
                    title: element.queryTitle,
                    components: element.queryComponents
                });
            });
            setOpenListQuery(resOpenQueryList);
        }
    }, [
        fetchDataQuery.data,
        fetchDataQuery.isResolved
    ]);
    // Récupère tous les dashboard en base
    const fetchDataDashboard = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)(urlApiDashboards);
    (0, $kc00y.useMemo)(()=>{
        if (fetchDataDashboard.isResolved) {
            const resOpenDashboardList = [];
            fetchDataDashboard.data.forEach((element, index)=>{
                resOpenDashboardList.push({
                    id: element.dashboardId,
                    title: element.dashboardTitle,
                    index: index
                });
            });
            setOpenListDashboard(resOpenDashboardList);
        }
    }, [
        fetchDataDashboard.data,
        fetchDataDashboard.isResolved
    ]);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $7a844823b04d4282$export$910ae8079b2c2852), {}),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        sm: activeDashboard && editTabIndex !== null ? 9 : 12,
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $755e362237c9dc81$export$2e2bcd8739ae039), {
                            openListDashboard: openListDashboard,
                            setOpenListDashboard: setOpenListDashboard,
                            activeDashboard: activeDashboard,
                            setActiveDashboard: setActiveDashboard,
                            editTabIndex: editTabIndex,
                            setEditTabIndex: setEditTabIndex,
                            componentsListDashboard: componentsListDashboard,
                            setComponentsListDashboard: setComponentsListDashboard,
                            dashboardCacheRef: dashboardCacheRef
                        })
                    }),
                    activeDashboard && editTabIndex !== null && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        sm: 3,
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $9b2c6a3f81211437$export$2e2bcd8739ae039), {
                            openListQuery: openListQuery,
                            setComponentsListDashboard: setComponentsListDashboard,
                            componentsListDashboard: componentsListDashboard
                        })
                    })
                ]
            })
        ]
    });
};
var $661778a0caccebd1$export$2e2bcd8739ae039 = $661778a0caccebd1$var$ComponentBoardDashboardAdmin;




var $kc00y = parcelRequire("kc00y");












var $kc00y = parcelRequire("kc00y");



const $6f461fe5fe88dd4e$var$ConfigDynamicComponent = (props)=>{
    const [disabledModal, setDisabledModal] = (0, $kc00y.useState)(false); // Affiche la modal de confirmation
    const [indexToRemove, setIndextoremove] = (0, $kc00y.useState)(); // Stocke l'index de l'onglet à fermer
    // Ajoute un nouvel onglet avec une configuration unique
    const handleAddTab = (key)=>{
        const componentEntry = (0, $aa18615e791616b9$export$cbedbfe2cd0caec7)[key];
        if (!componentEntry) return;
        const component = componentEntry.component;
        const formConfig = (0, $aa18615e791616b9$export$c05356b7a36e8e14)[key];
        const dataConfig = (0, $aa18615e791616b9$export$128b094d0092ceb0)[key];
        const newTab = {
            index: null,
            key: // Sert uniquement en front pour la gestion des onglets
            key,
            title: componentEntry.label,
            component: component,
            formConfig: formConfig,
            config: dataConfig // Stockage d’une config unique
        };
        const newOpenComponent = props.openListComponent ? [
            ...props.openListComponent,
            newTab
        ] : [
            newTab
        ];
        // Réinitialisation des indexKey pour chaque onglet
        const resetOpenTabs = newOpenComponent.map((tab, index)=>({
                ...tab,
                index: index
            }));
        props.setOpenListComponent(resetOpenTabs);
        props.setSelectedComponent(resetOpenTabs[resetOpenTabs.length - 1]);
        props.setData(null);
    };
    // Ferme l'onglet sélectionné
    const handleCloseTab = ()=>{
        if (props.openListComponent) {
            const updatedComponent = props.openListComponent.filter((tab)=>tab.index !== indexToRemove);
            // Réinitialisation des index pour chaque onglet
            const resetOpenTabs = updatedComponent.map((tab, index)=>({
                    ...tab,
                    index: index
                }));
            props.setOpenListComponent(resetOpenTabs);
            if (resetOpenTabs.length > 0) {
                props.setSelectedComponent(0);
                handleTabClick(0);
            } else props.setSelectedComponent(null);
            setIndextoremove(null);
        }
    };
    // Sélectionne l'onglet
    const handleTabClick = (indexKey)=>{
        if (props.openListComponent) {
            const updateActiveComponent = props.openListComponent.find((tab)=>tab.index === indexKey);
            props.setSelectedComponent(updateActiveComponent);
        }
    };
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1988c313b8430f65$export$2e2bcd8739ae039), {
        bg: "secondary",
        className: "m-3",
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1988c313b8430f65$export$2e2bcd8739ae039).Body, {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                    className: "flex-grow-1 d-flex flex-column",
                    children: [
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                            className: "d-flex align-items-center",
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b9d4d12a3c294259$export$2e2bcd8739ae039), {
                                    variant: "tabs",
                                    children: props.openListComponent && props.openListComponent.map((component)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b9d4d12a3c294259$export$2e2bcd8739ae039).Item, {
                                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $b9d4d12a3c294259$export$2e2bcd8739ae039).Link, {
                                                eventKey: component.index,
                                                onClick: ()=>handleTabClick(component.index || 0),
                                                className: props.selectedComponent && props.selectedComponent.index === component.index ? "active d-flex align-items-center" : "d-flex align-items-center",
                                                children: [
                                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                                        className: "col-4d-flex align-items-center text-truncate",
                                                        title: component.title,
                                                        style: {
                                                            width: "11rem"
                                                        },
                                                        children: component.title
                                                    }),
                                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                                                        variant: "link",
                                                        size: "sm",
                                                        onClick: (e)=>{
                                                            e.stopPropagation();
                                                            setIndextoremove(component.index);
                                                            setDisabledModal(true);
                                                        },
                                                        className: "ms-2",
                                                        children: "\xd7"
                                                    })
                                                ]
                                            })
                                        }, component.index))
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $943025b58510539f$export$2e2bcd8739ae039), {
                                    className: "ms-2",
                                    children: [
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $943025b58510539f$export$2e2bcd8739ae039).Toggle, {
                                            variant: "primary",
                                            children: "+"
                                        }),
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $943025b58510539f$export$2e2bcd8739ae039).Menu, {
                                            children: Object.entries((0, $aa18615e791616b9$export$cbedbfe2cd0caec7)).map(([key, meta])=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $943025b58510539f$export$2e2bcd8739ae039).Item, {
                                                    onClick: ()=>handleAddTab(key),
                                                    children: meta.label
                                                }, key))
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                            className: "flex-grow-1 mt-3",
                            style: {
                                height: "400px"
                            },
                            children: props.selectedComponent && props.openListComponent ? props.openListComponent.map(({ index: index, key: key, component: Component, config: config })=>index === props.selectedComponent?.index && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)(Component, {
                                    data: props.queryGlobalData,
                                    config: config
                                }, key)) : /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                className: "alert alert-primary",
                                role: "alert",
                                children: "Aucun composant n'est s\xe9lectionn\xe9."
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $7d5f25ee93f10b42$export$2e2bcd8739ae039), {
                visible: disabledModal,
                content: "Supprimer le composant ?",
                closeModal: ()=>setDisabledModal(false),
                query: "",
                href: "#",
                onConfirm: ()=>handleCloseTab()
            })
        ]
    });
};
var $6f461fe5fe88dd4e$export$2e2bcd8739ae039 = $6f461fe5fe88dd4e$var$ConfigDynamicComponent;





const $7aa871a23cdcc20e$var$ConfigForm = (props)=>{
    // Config pour l'initialisation des champs
    const config = props.selectedComponent ? props.selectedComponent.config : null;
    // Options disponibles pour les champs select
    const fieldOptions = props.availableOptions.map((key)=>({
            value: key,
            label: key
        }));
    // Mise à jour de la config et des datas après chaque changement
    const setConfig = (newConfig)=>{
        const updateSelectedTab = {
            ...props.selectedComponent,
            config: newConfig
        };
        const updateOpenListComponent = props.openListComponent ? props.openListComponent.map((tab)=>tab.index === updateSelectedTab.index ? updateSelectedTab : tab) : null;
        props.setSelectedComponent(updateSelectedTab);
        props.setOpenListComponent(updateOpenListComponent);
    };
    // Mise à jour du titre du composant
    const setTitleActive = (newTitle)=>{
        const updateSelectedTab = {
            ...props.selectedComponent,
            title: newTitle
        };
        const newOpenListComponent = props.openListComponent ? props.openListComponent.map((tab)=>tab.index === props.selectedComponent?.index ? updateSelectedTab : tab) : null;
        props.setSelectedComponent(updateSelectedTab);
        props.setOpenListComponent(newOpenListComponent);
    };
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
        children: props.selectedComponent && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1988c313b8430f65$export$2e2bcd8739ae039), {
            bg: "secondary",
            className: "m-3",
            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1988c313b8430f65$export$2e2bcd8739ae039).Body, {
                children: props.selectedComponent && props.selectedComponent.formConfig && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                            required: false,
                            name: "titleComponent",
                            label: "Titre composant",
                            onBlur: (e)=>{
                                setTitleActive(e.target.value);
                            }
                        }),
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("hr", {}),
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)(props.selectedComponent.formConfig, {
                            config: config,
                            fieldOptions: fieldOptions,
                            setConfig: setConfig
                        })
                    ]
                })
            })
        })
    });
};
var $7aa871a23cdcc20e$export$2e2bcd8739ae039 = $7aa871a23cdcc20e$var$ConfigForm;




var $bkJfK = parcelRequire("bkJfK");









const $ebea7208af8abdae$var$QueryForm = (props)=>{
    const urlApiQuery = (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/dashboard/validate-query`;
    const handleTestQuery = async (values)=>{
        props.validateAbortRef?.current?.abort();
        const controller = new AbortController();
        if (props.validateAbortRef) props.validateAbortRef.current = controller;
        try {
            const response = await fetch(urlApiQuery, {
                ...(0, $fbd4d34e07af0ac7$export$b163ec2f884327db)({
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        query: values.query,
                        queryTitle: values.queryTitle
                    })
                }),
                signal: controller.signal
            });
            const raw = await response.text();
            let parsed = raw;
            try {
                parsed = raw ? JSON.parse(raw) : null;
            } catch  {
            // réponse non JSON => erreur SQL brute
            }
            if (typeof parsed === "string") {
                props.setSqlErrorMessage(parsed);
                return;
            }
            if (!response.ok) {
                const message = parsed && typeof parsed === "object" && "message" in parsed ? String(parsed.message ?? "Erreur SQL") : "Erreur SQL";
                props.setSqlErrorMessage(message);
                return;
            }
            props.setSqlErrorMessage(null);
            updateData(parsed);
        } catch (error) {
            if (error instanceof DOMException && error.name === "AbortError") return;
            props.setSqlErrorMessage(error instanceof Error ? error.message : String(error));
        }
    };
    const updateData = (data)=>{
        props.setActiveQuery({
            ...props.activeQuery,
            title: data.queryTitle,
            query: data.querySql
        });
        const dataFormatted = (0, $aa18615e791616b9$export$1f26277db27165ba)(data);
        props.setQueryData(dataFormatted);
        props.setAvailableOptions(dataFormatted?.[0] ? Object.keys(dataFormatted[0]) : []);
        props.setSqlErrorMessage(null);
    };
    const getInitialValues = (activeQuery)=>({
            queryId: activeQuery.id,
            query: activeQuery.query,
            queryTitle: activeQuery.title
        });
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1988c313b8430f65$export$2e2bcd8739ae039), {
        bg: "secondary",
        className: "m-3",
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1988c313b8430f65$export$2e2bcd8739ae039).Body, {
            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                initialValues: getInitialValues(props.activeQuery),
                isPost: true,
                submitUrl: urlApiQuery,
                onSubmit: (values)=>updateData(values),
                successToastMessage: "La requ\xeate est valide",
                prepareVariables: (values)=>values,
                validationSchema: (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({}),
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($ebea7208af8abdae$var$InnerQueryForm, {
                    zoneCompetenceList: props.zoneCompetenceList,
                    utilisateurList: props.utilisateurList,
                    organismeList: props.organismeList,
                    sqlErrorMessage: props.sqlErrorMessage,
                    onTest: handleTestQuery
                })
            })
        })
    });
};
const $ebea7208af8abdae$var$InnerQueryForm = ({ zoneCompetenceList: zoneCompetenceList, utilisateurList: utilisateurList, organismeList: organismeList, sqlErrorMessage: sqlErrorMessage, onTest: onTest })=>{
    const { values: values, setValues: setValues } = (0, $bkJfK.useFormikContext)();
    const { activesKeys: activesKeys, handleShowClose: handleShowClose } = (0, $db860d90b4a42fea$export$dae930a4ba30758b)(Array(2).fill(false));
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
        children: [
            sqlErrorMessage && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("span", {
                className: "text-danger",
                children: sqlErrorMessage
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db860d90b4a42fea$export$2e2bcd8739ae039), {
                activesKeys: activesKeys,
                list: [
                    {
                        header: "Informations g\xe9n\xe9rales",
                        content: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("span", {
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$340bfce9b4df026b), {}),
                                " Certaines requ\xeates ont besoin de s'appuyer sur des param\xe8tres qui d\xe9pendent de l'utilisateur connect\xe9 :",
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("ul", {
                                    children: [
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("li", {
                                            children: "l'organisme"
                                        }),
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("li", {
                                            children: "la zone de comp\xe9tence"
                                        }),
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("li", {
                                            children: "l'utilisateur en lui-m\xeame"
                                        })
                                    ]
                                }),
                                "Ces param\xe8tres sont accessibles au travers de 3 constantes qui seront remplac\xe9es \xe0 l'ex\xe9cution :",
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("ul", {
                                    children: [
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("li", {
                                            children: "#ORGANISME_ID#"
                                        }),
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("li", {
                                            children: "#ZONE_COMPETENCE_ID#"
                                        }),
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("li", {
                                            children: "#UTILISATEUR_ID#"
                                        })
                                    ]
                                }),
                                "A utiliser tel quel, et ne pas entourer de quotes ou autre. Exemple pour une jointure sur les donn\xe9es de l'organisme de l'utilisateur connect\xe9 : \"WHERE organisme_id = #ORGANISME_ID#\""
                            ]
                        })
                    },
                    {
                        header: "Param\xe8tres",
                        content: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("span", {
                                    children: 'Lorsque les constantes sont utilis\xe9es, il faut fournir une valeur "coh\xe9rente" dans la requ\xeate, pour que celle-ci retourne des r\xe9sultats qui permettront de construire les visualisations. Les valeurs saisies ne sont ni stock\xe9es ni utilis\xe9es par l\'utilisateur final du tableau de bord, pour lequel elles sont remplac\xe9es par la "bonne" valeur'
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                                    name: "zoneCompetenceId",
                                    listIdCodeLibelle: zoneCompetenceList,
                                    label: "Zone de comp\xe9tence",
                                    required: false,
                                    setValues: setValues,
                                    defaultValue: zoneCompetenceList?.find((e)=>e.id === values.zoneCompetenceId)
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                                    name: "utilisateurId",
                                    listIdCodeLibelle: utilisateurList,
                                    label: "Utilisateur",
                                    required: false,
                                    setValues: setValues,
                                    defaultValue: utilisateurList?.find((e)=>e.id === values.utilisateurId)
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                                    name: "organismeId",
                                    listIdCodeLibelle: organismeList,
                                    label: "Organisme",
                                    required: false,
                                    setValues: setValues,
                                    defaultValue: organismeList?.find((e)=>e.id === values.organismeId)
                                })
                            ]
                        })
                    }
                ],
                handleShowClose: handleShowClose
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                required: false,
                name: "queryTitle",
                label: "Titre de la requ\xeate"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$ce9b1cc0c34506d0), {
                name: "query",
                label: "Requ\xeate SQL :",
                required: false
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8598ca69ed8b9dca$export$2e2bcd8739ae039), {
                        variant: "info",
                        className: "mt-2 mb-2 text-muted d-flex align-items-center",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("span", {
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$340bfce9b4df026b), {}),
                                " Tester la requ\xeate pour enregistrer les modifications sur le titre et/ou la requ\xeate."
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                        type: "button",
                        variant: "info",
                        className: "mt-3",
                        onClick: ()=>onTest({
                                query: values.query,
                                queryTitle: values.queryTitle
                            }),
                        children: "Tester la requ\xeate"
                    })
                ]
            })
        ]
    });
};
var $ebea7208af8abdae$export$2e2bcd8739ae039 = $ebea7208af8abdae$var$QueryForm;




var $kc00y = parcelRequire("kc00y");









const $9c72e7a8356fbe76$var$QueryList = /*#__PURE__*/ (0, $kc00y.forwardRef)(({ validateAbortRef: validateAbortRef, setData: setData, activeQuery: activeQuery, setActiveQuery: setActiveQuery, setOpenListComponent: setOpenListComponent, setSelectedComponent: setSelectedComponent, setQueryGlobalData: setQueryGlobalData, setAvailableOptions: setAvailableOptions, formikRef: formikRef, isAdding: isAdding, setIsAdding: setIsAdding, setSqlErrorMessage: setSqlErrorMessage }, ref)=>{
    const { error: errorToast } = (0, $6bdae0bad7b05751$export$91b3d218c74c79e4)();
    const [openListQuery, setOpenListQuery] = (0, $kc00y.useState)(null);
    const [isLoadingList, setIsLoadingList] = (0, $kc00y.useState)(false);
    const [isLoadingQuery, setIsLoadingQuery] = (0, $kc00y.useState)(false);
    const [isValidatingQuery, setIsValidatingQuery] = (0, $kc00y.useState)(false);
    const urlApiQueryList = (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/dashboard/get-list-query`;
    const urlApiGetQueryComponent = (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/dashboard/get-components/`;
    const urlApiDeleteQuery = (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/dashboard/delete-query/`;
    const urlApiQuery = (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/dashboard/validate-query`;
    const validateRequestIdRef = (0, $kc00y.useRef)(0);
    const loadQueryList = (0, $kc00y.useCallback)(async ()=>{
        setIsLoadingList(true);
        try {
            const response = await fetch(urlApiQueryList, (0, $fbd4d34e07af0ac7$export$b163ec2f884327db)({
                method: "GET"
            }));
            const raw = await response.json();
            const queryList = Array.isArray(raw) ? raw.map((element)=>({
                    id: element.dashboardQueryId,
                    query: element.dashboardQueryQuery,
                    title: element.dashboardQueryTitle
                })) : [];
            setOpenListQuery(queryList);
        } catch (reason) {
            errorToast(String(reason));
        } finally{
            setIsLoadingList(false);
        }
    }, [
        errorToast,
        urlApiQueryList
    ]);
    const loadComponentsForQuery = (0, $kc00y.useCallback)(async (queryId)=>{
        const response = await fetch(`${urlApiGetQueryComponent}${queryId}`, (0, $fbd4d34e07af0ac7$export$b163ec2f884327db)({
            method: "GET"
        }));
        const raw = await response.json();
        const componentList = Array.isArray(raw) ? raw.map((element, index)=>{
            const key = element.dashboardComponentKey;
            const componentEntry = (0, $aa18615e791616b9$export$cbedbfe2cd0caec7)[key] ?? {
                component: ()=>null,
                label: key
            };
            return {
                id: element.dashboardComponentId,
                queryId: element.dashboardComponentDahsboardQueryId || "",
                index: index,
                key: key,
                component: componentEntry.component,
                formConfig: (0, $aa18615e791616b9$export$c05356b7a36e8e14)[key],
                title: element.dashboardComponentTitle || componentEntry.label,
                config: (0, $aa18615e791616b9$export$20a432be20af881b)(key, element.dashboardComponentConfig)
            };
        }) : [];
        setOpenListComponent(componentList);
    }, [
        setOpenListComponent,
        urlApiGetQueryComponent
    ]);
    const validateQuery = (0, $kc00y.useCallback)(async (query)=>{
        validateAbortRef?.current?.abort();
        const controller = new AbortController();
        if (validateAbortRef) validateAbortRef.current = controller;
        const requestId = ++validateRequestIdRef.current;
        setIsValidatingQuery(true);
        try {
            const response = await fetch(urlApiQuery, {
                ...(0, $fbd4d34e07af0ac7$export$b163ec2f884327db)({
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        query: query.query,
                        queryTitle: query.title
                    })
                }),
                signal: controller.signal
            });
            if (requestId !== validateRequestIdRef.current) return false;
            const raw = await response.text();
            let parsed = raw;
            try {
                parsed = raw ? JSON.parse(raw) : null;
            } catch  {
            //continuer
            }
            if (typeof parsed === "string") {
                setSqlErrorMessage(parsed);
                return false;
            }
            if (!response.ok) {
                setSqlErrorMessage("Erreur SQL");
                return false;
            }
            const dataFormatted = (0, $aa18615e791616b9$export$1f26277db27165ba)(parsed);
            setAvailableOptions(dataFormatted?.[0] ? Object.keys(dataFormatted[0]) : []);
            setQueryGlobalData(dataFormatted);
            setSqlErrorMessage(null);
            setData(null);
            return true;
        } catch (reason) {
            if (reason instanceof DOMException && reason.name === "AbortError") return false;
            errorToast(String(reason));
            return false;
        } finally{
            if (requestId === validateRequestIdRef.current) setIsValidatingQuery(false);
        }
    }, [
        errorToast,
        setAvailableOptions,
        setData,
        setQueryGlobalData,
        setSqlErrorMessage,
        urlApiQuery,
        validateAbortRef
    ]);
    (0, $kc00y.useImperativeHandle)(ref, ()=>({
            refreshList () {
                loadQueryList();
            }
        }), [
        loadQueryList
    ]);
    (0, $kc00y.useEffect)(()=>{
        loadQueryList();
    }, [
        loadQueryList
    ]);
    const handleAddQuery = ()=>{
        const newQuery = {
            query: "",
            title: "Titre nouvelle requ\xeate"
        };
        setIsAdding(true);
        setOpenListComponent([]);
        setData(null);
        setSqlErrorMessage(null);
        setActiveQuery(newQuery);
        setSelectedComponent(null);
        setAvailableOptions([]);
        setQueryGlobalData(null);
    };
    const handleEditQuery = async (id)=>{
        const selected = openListQuery?.find((query)=>String(query.id) === String(id)) ?? null;
        if (!selected || !selected.id) return;
        setIsAdding(true);
        setIsLoadingQuery(true);
        setSqlErrorMessage(null);
        setActiveQuery(selected);
        setSelectedComponent(null);
        setAvailableOptions([]);
        setQueryGlobalData(null);
        setData(null);
        setOpenListComponent(null);
        try {
            await loadComponentsForQuery(selected.id);
            await validateQuery(selected);
        } catch (reason) {
            errorToast(String(reason));
        } finally{
            setIsLoadingQuery(false);
        }
    };
    const handleSaveQuery = async ()=>{
        if (isValidatingQuery) return;
        await formikRef.current?.submitForm();
    };
    const handleCancelQuery = ()=>{
        setIsAdding(false);
        setActiveQuery(null);
        setSelectedComponent(null);
        setOpenListComponent(null);
        setAvailableOptions([]);
        setQueryGlobalData(null);
    };
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1988c313b8430f65$export$2e2bcd8739ae039), {
        className: "m-3",
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1988c313b8430f65$export$2e2bcd8739ae039).Header, {
                className: "d-flex justify-content-between align-items-center",
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("h3", {
                        children: "Liste des requ\xeates"
                    }),
                    !isAdding && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8ad69b89456b65bc$export$2e2bcd8739ae039), {
                        title: "Ajouter",
                        onClick: handleAddQuery
                    })
                ]
            }),
            isAdding && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1988c313b8430f65$export$2e2bcd8739ae039).Body, {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("h5", {
                        className: "mb-3",
                        children: activeQuery?.title
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                        className: "d-flex justify-content-between",
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                                variant: "secondary",
                                onClick: handleCancelQuery,
                                disabled: isValidatingQuery,
                                children: "Annuler"
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                                variant: "primary",
                                onClick: handleSaveQuery,
                                disabled: isValidatingQuery,
                                children: isValidatingQuery ? "Validation..." : "Enregistrer"
                            })
                        ]
                    })
                ]
            }),
            !isAdding && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $87d0f3f36f67a4f7$export$2e2bcd8739ae039), {
                variant: "flush",
                style: {
                    maxHeight: "65vh",
                    overflowY: "auto"
                },
                children: isLoadingList ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $c21b1c237cfa1d94$export$2e2bcd8739ae039), {}) : openListQuery && openListQuery.length > 0 ? openListQuery.map(({ id: id, title: title })=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $87d0f3f36f67a4f7$export$2e2bcd8739ae039).Item, {
                        className: "d-flex justify-content-between align-items-center",
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                className: "text-truncate me-3",
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                                    tooltipId: `query-title-tooltip-${id}`,
                                    tooltipText: title,
                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("span", {
                                        children: title
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                                className: "d-flex flex-nowrap",
                                children: [
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                                        variant: "link",
                                        size: "sm",
                                        className: "me-2 text-info text-decoration-none",
                                        onClick: ()=>handleEditQuery(id),
                                        disabled: isLoadingQuery || isValidatingQuery,
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$b51dd496211ae105), {})
                                    }),
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $261998279c461521$export$2e2bcd8739ae039), {
                                        path: urlApiDeleteQuery + id,
                                        reload: ()=>{
                                            loadQueryList();
                                        },
                                        variant: "link",
                                        className: "text-danger text-decoration-none",
                                        title: false,
                                        disabled: isLoadingQuery || isValidatingQuery,
                                        header: "Supprimer la requ\xeate",
                                        content: "\xcates-vous s\xfbr de vouloir supprimer cette requ\xeate ?"
                                    })
                                ]
                            })
                        ]
                    }, id)) : /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $87d0f3f36f67a4f7$export$2e2bcd8739ae039).Item, {
                    children: "Aucune requ\xeate ajout\xe9e."
                })
            })
        ]
    });
});
$9c72e7a8356fbe76$var$QueryList.displayName = "QueryList";
var $9c72e7a8356fbe76$export$2e2bcd8739ae039 = $9c72e7a8356fbe76$var$QueryList;


const $43e0d0005f28cb47$var$ComponentBoardQueryAdmin = ()=>{
    const queryListRef = (0, $kc00y.useRef)(null);
    const validateAbortRef = (0, $kc00y.useRef)(null);
    const { error: errorToast } = (0, $6bdae0bad7b05751$export$91b3d218c74c79e4)();
    const [queryGlobalData, setQueryGlobalData] = (0, $kc00y.useState)(null); // Données globales retournées par la requête
    const [data, setData] = (0, $kc00y.useState)(null); // Données mappées pour le composant à l'écran
    const [activeQuery, setActiveQuery] = (0, $kc00y.useState)(null); // Requête actif
    const [selectedComponent, setSelectedComponent] = (0, $kc00y.useState)(null); // Index composant ouvert actif
    const [openListComponent, setOpenListComponent] = (0, $kc00y.useState)(); // Liste composants de la requête
    const [availableOptions, setAvailableOptions] = (0, $kc00y.useState)([]); // liste des options disponibles pour les champs
    const [sqlErrorMessage, setSqlErrorMessage] = (0, $kc00y.useState)(null);
    const [isAdding, setIsAdding] = (0, $kc00y.useState)(false);
    const formikRef = (0, $kc00y.useRef)(); // Créer une référence pour Formik
    // Données de référence chargées une seule fois
    const { data: zoneCompetenceList } = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/zone-integration/list`);
    const { data: utilisateurList } = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/utilisateur/list`);
    const { data: organismeList } = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/organisme/get-all`);
    const urlApiRegister = (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/dashboard/create-query`;
    const urlApiUpdateRegister = (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/dashboard/update-query`;
    const getPrepareVariables = ()=>{
        const componentData = openListComponent ? openListComponent.map((component)=>{
            return {
                ...component.id && {
                    componentId: component.id
                },
                ...component.queryId && {
                    componentQueryId: component.queryId
                },
                componentKey: component.key,
                componentTitle: component.title,
                componentConfig: JSON.stringify(component.config)
            };
        }) : null;
        if (componentData) {
            const queryComponentData = {
                ...(activeQuery?.id, {
                    queryId: activeQuery?.id
                }),
                queryTitle: activeQuery?.title ?? "",
                queryQuery: activeQuery?.query ?? "",
                queryComponents: componentData
            };
            return queryComponentData;
        } else errorToast("Veuillez ajouter au moins un composant");
    };
    const getInitialValues = ()=>({
            titleComponent: selectedComponent ? selectedComponent.title : ""
        });
    const toSubmit = ()=>{
        setIsAdding(false);
        setSelectedComponent(null);
        setActiveQuery(null);
        setOpenListComponent(null);
        setSqlErrorMessage(null);
        // Rafraîchit la liste après enregistrement réussi
        queryListRef.current?.refreshList();
    };
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        fluid: true,
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $7a844823b04d4282$export$910ae8079b2c2852), {}),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$26f6a63b41d0ff2a), {}),
                title: "\xc9dition des requ\xeates et composants associ\xe9s"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                className: !activeQuery ? "justify-content-center" : "",
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        sm: activeQuery ? 3 : 9,
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $9c72e7a8356fbe76$export$2e2bcd8739ae039), {
                            ref: queryListRef,
                            validateAbortRef: validateAbortRef,
                            setData: setData,
                            activeQuery: activeQuery,
                            setActiveQuery: setActiveQuery,
                            openListComponent: openListComponent,
                            setOpenListComponent: setOpenListComponent,
                            setSelectedComponent: setSelectedComponent,
                            queryGlobalData: queryGlobalData,
                            setQueryGlobalData: setQueryGlobalData,
                            setAvailableOptions: setAvailableOptions,
                            formikRef: formikRef,
                            isAdding: isAdding,
                            setIsAdding: setIsAdding,
                            setSqlErrorMessage: setSqlErrorMessage
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        sm: 9,
                        children: activeQuery && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ebea7208af8abdae$export$2e2bcd8739ae039), {
                            validateAbortRef: validateAbortRef,
                            activeQuery: activeQuery,
                            setActiveQuery: setActiveQuery,
                            setQueryData: setQueryGlobalData,
                            setAvailableOptions: setAvailableOptions,
                            zoneCompetenceList: zoneCompetenceList,
                            utilisateurList: utilisateurList,
                            organismeList: organismeList,
                            sqlErrorMessage: sqlErrorMessage,
                            setSqlErrorMessage: setSqlErrorMessage
                        })
                    }),
                    activeQuery && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                        validationSchema: (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({}),
                        initialValues: getInitialValues(),
                        innerRef: formikRef,
                        isPost: activeQuery.id ? false : true,
                        prepareVariables: getPrepareVariables,
                        submitUrl: activeQuery.id ? urlApiUpdateRegister : urlApiRegister,
                        onSubmit: toSubmit,
                        successToastMessage: "La requ\xeate a \xe9t\xe9 correctement enregistr\xe9e",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                        sm: 3,
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $7aa871a23cdcc20e$export$2e2bcd8739ae039), {
                                            openListComponent: openListComponent,
                                            setOpenListComponent: setOpenListComponent,
                                            selectedComponent: selectedComponent,
                                            setSelectedComponent: setSelectedComponent,
                                            availableOptions: availableOptions,
                                            queryGlobalData: queryGlobalData ?? [],
                                            setData: setData
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                        sm: 9,
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $6f461fe5fe88dd4e$export$2e2bcd8739ae039), {
                                            data: data,
                                            setData: setData,
                                            openListComponent: openListComponent,
                                            setOpenListComponent: setOpenListComponent,
                                            queryGlobalData: queryGlobalData ?? [],
                                            selectedComponent: selectedComponent,
                                            setSelectedComponent: setSelectedComponent
                                        })
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var $43e0d0005f28cb47$export$2e2bcd8739ae039 = $43e0d0005f28cb47$var$ComponentBoardQueryAdmin;




var $kc00y = parcelRequire("kc00y");







const $16ed3be1353805cf$var$ComponentBoardList = ()=>{
    const [dashboardUser, setDashoardUser] = (0, $kc00y.useState)(); // Liste des onglets dashboard
    const [componentsListDashboard, setComponentsListDashboard] = (0, $kc00y.useState)(); // Composant sélectionner dans la grid
    const [numberRowGrid, setNumberRowGrid] = (0, $kc00y.useState)(0);
    const heightRow = 200;
    // Récupère tous les composants en base liés au profil utilisateur
    const fetchDataDashboard = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/dashboard/get-dashboard-user/`, {});
    // Calcule le nombre de lignes nécessaires = bord bas du composant le plus bas
    const calculateRows = (0, $kc00y.useCallback)((componentList)=>{
        const maxBottom = componentList.reduce((acc, component)=>{
            const bottom = component.configPosition ? component.configPosition.y + component.configPosition.hauteur : 0;
            return bottom > acc ? bottom : acc;
        }, 0);
        setNumberRowGrid(maxBottom);
    }, []);
    (0, $kc00y.useEffect)(()=>{
        if (fetchDataDashboard.isResolved && fetchDataDashboard.data) {
            setDashoardUser({
                id: fetchDataDashboard.data?.dashboardId,
                title: fetchDataDashboard.data?.dashboardTitle
            });
            const newComponentList = [];
            fetchDataDashboard.data?.dashboardComponents?.forEach((element)=>{
                // Set les composants à affiché dans la grille
                newComponentList.push({
                    id: element.componentId,
                    key: element.componentKey,
                    title: element.componentTitle,
                    config: (0, $aa18615e791616b9$export$20a432be20af881b)(element.componentKey, element.componentConfig),
                    configPosition: {
                        x: element.componentConfigPosition ? element.componentConfigPosition.componentX : 0,
                        y: element.componentConfigPosition ? element.componentConfigPosition.componentY : 0,
                        largeur: element.componentConfigPosition ? element.componentConfigPosition.componentLargeur : 2,
                        hauteur: element.componentConfigPosition ? element.componentConfigPosition.componentHauteur : 2
                    },
                    queryId: element.componentQueryId
                });
            });
            if (newComponentList.length > 0) {
                calculateRows(newComponentList);
                setComponentsListDashboard(newComponentList);
            }
        }
    }, [
        fetchDataDashboard.data,
        fetchDataDashboard.isResolved,
        calculateRows
    ]);
    // Si pas de dashboard on les récupère en base
    (0, $kc00y.useEffect)(()=>{
        if (!dashboardUser && !fetchDataDashboard.isLoading) fetchDataDashboard.run();
    }, [
        dashboardUser,
        fetchDataDashboard
    ]);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
        children: dashboardUser && dashboardUser.id ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
            fluid: true,
            children: [
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                    icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$d112062dd42154c4), {}),
                    title: dashboardUser?.title
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    className: "position-relative",
                    style: {
                        minHeight: `${numberRowGrid * heightRow}px`
                    },
                    children: [
                        !componentsListDashboard && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                            className: "alert alert-primary",
                            role: "alert",
                            children: "Ce dashboard n'a aucun composant pour le moment."
                        }),
                        Array.from({
                            length: 4
                        }, (_, colIndex)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                id: "col-grid-component",
                                className: "p-0 position-relative",
                                style: {
                                    height: "100%"
                                },
                                children: Array.from({
                                    length: numberRowGrid
                                }, (_, rowIndex)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                        id: `${colIndex}-${rowIndex}`,
                                        className: "droppable",
                                        style: {
                                            height: heightRow + "px" // Hauteur des lignes
                                        }
                                    }, `${colIndex}-${rowIndex}`))
                            }, colIndex)),
                        componentsListDashboard && componentsListDashboard.length > 0 && componentsListDashboard.map((component)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $c43176df88c7c7ef$export$2e2bcd8739ae039), {
                                component: component,
                                isSelected: false,
                                heightRow: heightRow
                            }, component.id))
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
            className: "alert alert-primary",
            role: "alert",
            children: "Aucun dashboard n'est disponible pour votre profil."
        })
    });
};
var $16ed3be1353805cf$export$2e2bcd8739ae039 = $16ed3be1353805cf$var$ComponentBoardList;


















const $76d629425ffb9f41$export$bca954bf5a03b6e3 = ({ dfciConflitTable: dfciConflitTable, dfciConflitElementId: dfciConflitElementId, dfciConflitChamp: dfciConflitChamp })=>{
    const filter = {};
    $76d629425ffb9f41$var$filterPropertyDfciConflit(filter, dfciConflitTable, "dfciConflitTable");
    $76d629425ffb9f41$var$filterPropertyDfciConflit(filter, dfciConflitElementId, "dfciConflitElementId");
    $76d629425ffb9f41$var$filterPropertyDfciConflit(filter, dfciConflitChamp, "dfciConflitChamp");
    return filter;
};
function $76d629425ffb9f41$var$filterPropertyDfciConflit(filter, value, name) {
    if (value?.trim().length > 0) filter[name] = value;
}


var $26d9d1c403583064$var$DFCI_TABLE_NOM = /*#__PURE__*/ function(DFCI_TABLE_NOM) {
    DFCI_TABLE_NOM["DFCI_AIRE"] = "dfci_aire";
    DFCI_TABLE_NOM["DFCI_PISTE"] = "dfci_piste";
    DFCI_TABLE_NOM["DFCI_DEB"] = "dfci_deb";
    DFCI_TABLE_NOM["DFCI_PANNEAU"] = "dfci_panneau";
    return DFCI_TABLE_NOM;
}($26d9d1c403583064$var$DFCI_TABLE_NOM || {});
const $26d9d1c403583064$var$DfciGestionConflits = ()=>{
    const listeButton = [];
    const { user: user } = (0, $e787cde576104469$export$fdc397e486fa83e7)();
    const { fetchGeometry: fetchGeometry } = (0, $a178c3075f0f40bb$export$2e2bcd8739ae039)();
    function onClickLocalisation(typeGeom, elementId) {
        fetchGeometry(typeGeom, elementId, (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).CARTE_DFCI);
    }
    if ((0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).DFCI_GESTION_CONFLITS_A)) listeButton.push({
        row: (row)=>{
            return row;
        },
        route: (dfciConflitId)=>(0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).RESOLVE_DFCI_CONFLIT(dfciConflitId),
        icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$b51dd496211ae105), {}),
        type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).LINK,
        textEnable: "Corriger le conflit"
    });
    if ((0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).DFCI_R)) listeButton.push({
        row: (row)=>{
            return row;
        },
        icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$cbe811cb8e919f27), {}),
        type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).LINK,
        textEnable: "Localiser l'\xe9l\xe9ment",
        onClick: (idConflit, row)=>{
            switch(row.dfciConflitTable){
                case "dfci_piste":
                    onClickLocalisation((0, $a178c3075f0f40bb$export$970c58a942355206).DFCI_PISTE, row.dfciConflitElementId);
                    break;
                case "dfci_deb":
                    onClickLocalisation((0, $a178c3075f0f40bb$export$970c58a942355206).DFCI_DEB, row.dfciConflitElementId);
                    break;
                case "dfci_aire":
                    onClickLocalisation((0, $a178c3075f0f40bb$export$970c58a942355206).DFCI_AIRE, row.dfciConflitElementId);
                    break;
                case "dfci_panneau":
                    onClickLocalisation((0, $a178c3075f0f40bb$export$970c58a942355206).DFCI_PANNEAU, row.dfciConflitElementId);
                    break;
            }
        }
    });
    const filterContext = (0, $9a9eebc3462fba73$export$396ef541d9951d45)({
        dfciConflitTable: undefined,
        dfciConflitElementId: undefined,
        dfciConflitChamp: undefined
    });
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
            fluid: true,
            className: "px-5",
            children: [
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                    icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$81608868aefa31ce), {}),
                    title: "Gestion des conflits"
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $9a9eebc3462fba73$export$2e2bcd8739ae039), {
                    query: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/dfci-conflit/list`,
                    columns: [
                        {
                            Header: "Table",
                            accessor: "dfciConflitTable",
                            sortField: "dfciConflitTable",
                            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                                type: "text",
                                name: "dfciConflitTable"
                            })
                        },
                        {
                            Header: "ID \xe9l\xe9ment",
                            accessor: "dfciConflitElementId",
                            sortField: "dfciConflitElementId",
                            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                                type: "text",
                                name: "dfciConflitElementId"
                            })
                        },
                        {
                            Header: "Champ",
                            accessor: "dfciConflitChamp",
                            sortField: "dfciConflitChamp",
                            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                                type: "text",
                                name: "dfciConflitChamp"
                            })
                        },
                        {
                            Header: "Valeur REMOcRA",
                            accessor: "dfciConflitValeurRemocra"
                        },
                        {
                            Header: "Valeur SIG",
                            accessor: "dfciConflitValeurSig"
                        },
                        {
                            Header: "Date du conflit",
                            accessor: "dfciConflitDate",
                            sortField: "dfciConflitDate",
                            Cell: (value)=>{
                                return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                    children: value?.value != null && (0, $00c47c7740afd024$export$2e2bcd8739ae039)(value.value)
                                });
                            }
                        },
                        (0, $b82b937cc97f6f18$export$36e9f5a475c9f6fc)({
                            Header: "Actions",
                            accessor: "dfciConflitId",
                            buttons: listeButton
                        })
                    ],
                    idName: "tableDfciConflitId",
                    filterValuesToVariable: (0, $76d629425ffb9f41$export$bca954bf5a03b6e3),
                    filterContext: filterContext
                })
            ]
        })
    });
};
var $26d9d1c403583064$export$2e2bcd8739ae039 = $26d9d1c403583064$var$DfciGestionConflits;










const $1005687cc76c60e9$var$ModuleDfci = ()=>{
    const { user: user } = (0, $e787cde576104469$export$fdc397e486fa83e7)();
    const navLinks = [
        {
            path: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).CARTE_DFCI,
            label: "Carte DFCI",
            aLeDroit: (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).DFCI_R)
        },
        {
            path: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).DFCI_RECEPTION_TRAVAUX,
            label: "Recevoir des travaux",
            aLeDroit: (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).DFCI_RECEPTRAVAUX_C)
        },
        {
            path: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).DFCI_GESTION_CONFLITS,
            label: "Gestion des conflits",
            aLeDroit: (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).DFCI_GESTION_CONFLITS_R)
        }
    ];
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $a0064658a8399ad3$export$2e2bcd8739ae039), {
        navbar: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $5de16d9a2066fdee$export$2e2bcd8739ae039), {
            links: navLinks
        }),
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $7a844823b04d4282$export$910ae8079b2c2852), {})
    });
};
var $1005687cc76c60e9$export$2e2bcd8739ae039 = $1005687cc76c60e9$var$ModuleDfci;




var $bkJfK = parcelRequire("bkJfK");







const $0d67dd9fb9f532e5$export$a5cab80145b70e98 = ()=>({
        document: null
    });
const $0d67dd9fb9f532e5$export$c084437b5e3206cd = (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({});
const $0d67dd9fb9f532e5$export$f97400759cfd946 = (values)=>{
    const formData = new FormData();
    formData.append("document", values.document);
    return formData;
};
const $0d67dd9fb9f532e5$var$ReceptionTravaux = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$c9bef5de7ad5da31), {}),
                title: "Recevoir des travaux"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                initialValues: $0d67dd9fb9f532e5$export$a5cab80145b70e98(),
                validationSchema: $0d67dd9fb9f532e5$export$c084437b5e3206cd,
                isPost: false,
                isMultipartFormData: true,
                submitUrl: `/api/dfci/reception-travaux/`,
                prepareVariables: (values)=>$0d67dd9fb9f532e5$export$f97400759cfd946(values),
                redirectUrl: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).ACCUEIL,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($0d67dd9fb9f532e5$var$FormImportDocument, {})
            })
        ]
    });
};
const $0d67dd9fb9f532e5$var$FormImportDocument = ()=>{
    const { setFieldValue: setFieldValue } = (0, $bkJfK.useFormikContext)();
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b57af79a4ab2a1c6), {
                name: "document",
                accept: ".*",
                required: true,
                onChange: (e)=>setFieldValue("document", e.target.files[0])
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                className: "mt-3",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                    className: "text-center",
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                        type: "submit",
                        variant: "primary",
                        children: "Valider"
                    })
                })
            })
        ]
    });
};
var $0d67dd9fb9f532e5$export$2e2bcd8739ae039 = $0d67dd9fb9f532e5$var$ReceptionTravaux;












var $bkJfK = parcelRequire("bkJfK");






const $67a0f30aebb93da6$export$49c648f20ddc97db = (data)=>({
        dfciConflitId: data?.dfciConflitId,
        dfciConflitTable: data?.dfciConflitTable,
        dfciConflitElementId: data?.dfciConflitElementId,
        dfciConflitChamp: data?.dfciConflitChamp,
        dfciConflitValeurRemocra: data?.dfciConflitValeurRemocra,
        dfciConflitValeurSig: data?.dfciConflitValeurSig,
        dfciConflitDate: (0, $00c47c7740afd024$export$c6834cb9c1260d15)(data?.dfciConflitDate ?? new Date())
    });
const $67a0f30aebb93da6$export$d6b4869b40ced7c = (values)=>({
        dfciConflitId: values.dfciConflitId,
        dfciConflitTable: values.dfciConflitTable,
        dfciConflitElementId: values.dfciConflitElementId,
        dfciConflitChamp: values.dfciConflitChamp,
        dfciConflitValeurRemocra: values.dfciConflitValeurRemocra,
        dfciConflitValeurSig: values.dfciConflitValeurSig,
        dfciConflitDate: values.dfciConflitDate ? new Date(values.dfciConflitDate).toISOString() : null
    });
const $67a0f30aebb93da6$export$fbdfed9ab0503e65 = (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({
    dfciConflitElementId: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
    dfciConflitChamp: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba)
});
const $67a0f30aebb93da6$export$2a3fa67263c7d7c4 = ()=>{
    const { values: values, setFieldValue: setFieldValue } = (0, $bkJfK.useFormikContext)();
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                    name: "dfciConflitTable",
                    label: "Table en conflit",
                    value: values.dfciConflitTable,
                    disabled: true,
                    required: false
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                    name: "dfciConflitElementId",
                    label: "ID de l'\xe9l\xe9ment en conflit",
                    value: values.dfciConflitElementId,
                    disabled: true,
                    required: false
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$7edc06cf1783b30f), {
                    name: "dfciConflitDate",
                    label: "Date du conflit",
                    readOnly: true,
                    value: (0, $00c47c7740afd024$export$c6834cb9c1260d15)(values.dfciConflitDate),
                    required: false
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                    name: "dfciConflitChamp",
                    label: "Champ en conflit",
                    value: values.dfciConflitChamp,
                    disabled: true,
                    required: false
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                                    name: "dfciConflitValeurRemocra",
                                    label: "Valeur de REMOcRA",
                                    value: values.dfciConflitValeurRemocra,
                                    disabled: true,
                                    required: false
                                })
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db9b0e6fdb142a4c$export$2e2bcd8739ae039), {
                                    onClick: ()=>{
                                        setFieldValue("dfciConflitValeurSig", values.dfciConflitValeurRemocra);
                                    },
                                    submitTitle: "Choisir la valeur de REMOcRA"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                                    name: "dfciConflitValeurSig",
                                    label: "Valeur du SIG",
                                    value: values.dfciConflitValeurSig,
                                    disabled: true,
                                    required: false
                                })
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db9b0e6fdb142a4c$export$2e2bcd8739ae039), {
                                    onClick: ()=>{
                                        setFieldValue("dfciConflitValeurRemocra", values.dfciConflitValeurSig);
                                    },
                                    submitTitle: "Choisir la valeur du SIG"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


const $8e87f5a539f829da$export$dd6ac16f03f78be8 = ()=>{
    const { dfciConflitId: dfciConflitId } = (0, $7a844823b04d4282$export$99eaa27ddbbb95ef)();
    const { data: data } = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/dfci-conflit/` + dfciConflitId);
    if (!data) return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("p", {
        children: "Chargement en cours\u2026"
    });
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$81608868aefa31ce), {}),
                title: "R\xe9soudre le conflit"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                initialValues: (0, $67a0f30aebb93da6$export$49c648f20ddc97db)(data),
                isPost: false,
                prepareVariables: (0, $67a0f30aebb93da6$export$d6b4869b40ced7c),
                validationSchema: (0, $67a0f30aebb93da6$export$fbdfed9ab0503e65),
                onSubmit: ()=>null,
                submitUrl: "/api/dfci-conflit/resolve",
                redirectUrl: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).DFCI_GESTION_CONFLITS,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $67a0f30aebb93da6$export$2a3fa67263c7d7c4), {})
            })
        ]
    });
};




var $bkJfK = parcelRequire("bkJfK");











const $2a4c508f21c8ff6f$export$a5cab80145b70e98 = ()=>({
        communeId: null
    });
const $2a4c508f21c8ff6f$export$f97400759cfd946 = (values)=>({
        communeId: values.communeId ?? null
    });
const $2a4c508f21c8ff6f$export$c084437b5e3206cd = (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({});
const $2a4c508f21c8ff6f$var$ExportCTP = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$4a5ccdc9878f4668), {}),
                title: "Exporter des donn\xe9es pour la saisie CTP"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                initialValues: $2a4c508f21c8ff6f$export$a5cab80145b70e98(),
                validationSchema: $2a4c508f21c8ff6f$export$c084437b5e3206cd,
                isPost: true,
                isMultipartFormData: false,
                submitUrl: `/api/importctp/export`,
                prepareVariables: (values)=>$2a4c508f21c8ff6f$export$f97400759cfd946(values),
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($2a4c508f21c8ff6f$var$FormExportCTP, {})
            })
        ]
    });
};
var $2a4c508f21c8ff6f$export$2e2bcd8739ae039 = $2a4c508f21c8ff6f$var$ExportCTP;
const $2a4c508f21c8ff6f$var$FormExportCTP = ()=>{
    const { values: values, setValues: setValues } = (0, $bkJfK.useFormikContext)();
    const { success: successToast, error: errorToast } = (0, $6bdae0bad7b05751$export$91b3d218c74c79e4)();
    const listeCommune = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/commune/get-libelle-commune`);
    if (!listeCommune.isResolved) return;
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                name: "communeId",
                label: "Commune",
                listIdCodeLibelle: listeCommune.data,
                required: false,
                setValues: setValues,
                defaultValue: listeCommune.data.find((e)=>e.id === values.communeId)
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                className: "mt-3",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                    className: "text-center",
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                        onClick: ()=>(0, $c066b242635c27a6$export$9cca65ea339c61b4)("/api/importctp/export", JSON.stringify({
                                communeId: values.communeId ?? null
                            }), `export-ctp${values.communeId ? `_${listeCommune.data.find((e)=>e.id === values.communeId)?.libelle}` : ""}.xlsx`, "Export termin\xe9", successToast, errorToast),
                        disabled: false,
                        children: "Exporter et t\xe9l\xe9charger"
                    })
                })
            })
        ]
    });
};




var $bkJfK = parcelRequire("bkJfK");








const $8de12d73634099f7$export$a5cab80145b70e98 = ()=>({
        file: null
    });
const $8de12d73634099f7$export$f97400759cfd946 = (values)=>{
    const formData = new FormData();
    formData.append("file", values.file);
    return formData;
};
const $8de12d73634099f7$export$c084437b5e3206cd = (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({});
const $8de12d73634099f7$var$ImportCTP = ()=>{
    const navigate = (0, $7a844823b04d4282$export$9770f232ac06a008)();
    const location = (0, $7a844823b04d4282$export$45d76561a5302f2b)();
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$c9bef5de7ad5da31), {}),
                title: "Importer un fichier de saisie CTP",
                right: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                    href: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).EXPORT_CTP,
                    children: "R\xe9aliser un export CTP"
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                initialValues: $8de12d73634099f7$export$a5cab80145b70e98(),
                validationSchema: $8de12d73634099f7$export$c084437b5e3206cd,
                isPost: true,
                isMultipartFormData: true,
                submitUrl: `/api/importctp/verification`,
                prepareVariables: (values)=>$8de12d73634099f7$export$f97400759cfd946(values),
                onSubmit: (result)=>navigate((0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).RESULTAT_VERIF_IMPORT_CTP, {
                        state: {
                            ...location.state,
                            result: result
                        }
                    }),
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($8de12d73634099f7$var$FormImportCTP, {})
            })
        ]
    });
};
var $8de12d73634099f7$export$2e2bcd8739ae039 = $8de12d73634099f7$var$ImportCTP;
const $8de12d73634099f7$var$FormImportCTP = ()=>{
    const { setFieldValue: setFieldValue } = (0, $bkJfK.useFormikContext)();
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b57af79a4ab2a1c6), {
                name: "file",
                accept: ".xlsx",
                required: true,
                onChange: (e)=>setFieldValue("file", e.target.files[0])
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                className: "mt-3",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                    className: "text-center",
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                        type: "submit",
                        variant: "primary",
                        children: "V\xe9rifier les donn\xe9es"
                    })
                })
            })
        ]
    });
};




var $bkJfK = parcelRequire("bkJfK");

var $14d3fd906319adea$exports = {};

$14d3fd906319adea$exports = (parcelRequire("avW6N"));











const $52a039f76bee8f8d$export$a5cab80145b70e98 = (initialValues)=>({
        bilanVerifications: initialValues?.result?.bilanVerifications ?? []
    });
const $52a039f76bee8f8d$export$c084437b5e3206cd = (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({});
const $52a039f76bee8f8d$export$f97400759cfd946 = (values)=>({
        bilanVerifications: values.bilanVerifications ?? null
    });
const $52a039f76bee8f8d$var$VerificationImportCTP = ()=>{
    const { state: state } = (0, $7a844823b04d4282$export$45d76561a5302f2b)();
    let initialValues;
    if (state) {
        initialValues = state;
        // On vide le state
        window.history.replaceState({
            from: state.from
        }, "");
    }
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$2f6d05691f8bfa80), {}),
                title: "Validation de l'import CTP"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                initialValues: $52a039f76bee8f8d$export$a5cab80145b70e98(initialValues),
                validationSchema: $52a039f76bee8f8d$export$c084437b5e3206cd,
                isPost: true,
                submitUrl: `/api/importctp/enregistrement`,
                prepareVariables: (values)=>$52a039f76bee8f8d$export$f97400759cfd946(values),
                redirectUrl: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).ACCUEIL,
                successToastMessage: "L'import CTP a \xe9t\xe9 lanc\xe9",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($52a039f76bee8f8d$var$ResultatsVerificationImportCTP, {})
            })
        ]
    });
};
var $52a039f76bee8f8d$export$2e2bcd8739ae039 = $52a039f76bee8f8d$var$VerificationImportCTP;
const $52a039f76bee8f8d$var$ResultatsVerificationImportCTP = ()=>{
    const { values: values } = (0, $bkJfK.useFormikContext)();
    const navigate = (0, $7a844823b04d4282$export$9770f232ac06a008)();
    const data = (0, $c066b242635c27a6$export$e19edaf2912e7bf)(values);
    const dataCsv = [];
    values.bilanVerifications.map((element)=>{
        dataCsv.push({
            numeroLigne: element.numeroLigne,
            codeInsee: element.codeInsee,
            numeroInterne: element.numeroInterne,
            dateCtp: element.dateCtp,
            warnings: element.warnings.length > 0 ? element.warnings.toString() : element.bilan
        });
    });
    const headers = [
        {
            label: "N\xb0Ligne",
            key: "numeroLigne"
        },
        {
            label: "Code INSEE",
            key: "codeInsee"
        },
        {
            label: "N\xb0 interne du PEI",
            key: "numeroInterne"
        },
        {
            label: "Date du CT",
            key: "dateCtp"
        },
        {
            label: "Bilan du contr\xf4le",
            key: "warnings"
        }
    ];
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $13de46b4dfcc473f$export$2e2bcd8739ae039), {
                        bordered: true,
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("thead", {
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("th", {
                                            children: "N\xb0Ligne"
                                        }),
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("th", {
                                            children: "Code INSEE"
                                        }),
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("th", {
                                            children: "N\xb0 interne du PEI"
                                        }),
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("th", {
                                            children: "Date du CT"
                                        }),
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("th", {
                                            children: "Bilan du contr\xf4le"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("tbody", {
                                children: values.bilanVerifications?.map((element, index)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("tr", {
                                        className: element.bilanStyle === "ERROR" ? "table-danger" : element.bilanStyle === "WARNING" ? "table-warning" : "table-success",
                                        children: [
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("td", {
                                                children: element.numeroLigne
                                            }),
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("td", {
                                                children: element.codeInsee
                                            }),
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("td", {
                                                children: element.numeroInterne
                                            }),
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("td", {
                                                children: element.dateCtp
                                            }),
                                            element.warnings && element.warnings.length > 0 ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("td", {
                                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("ul", {
                                                    children: element.warnings.map((warning, index)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("li", {
                                                            children: warning
                                                        }, index))
                                                })
                                            }) : /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("td", {
                                                children: element.bilan
                                            })
                                        ]
                                    }, index))
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("p", {
                        children: [
                            "Nombre de CT valides : ",
                            data.nbValides
                        ]
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("p", {
                        children: [
                            "Dont : ",
                            data.nbValidesWarn,
                            " CT valides avec avertissements"
                        ]
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("p", {
                        children: [
                            "Nombre de CT rejet\xe9s : ",
                            data.nbRejetes
                        ]
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("p", {
                        children: [
                            "Dont : ",
                            data.nbRejetesNR,
                            " CT rejet\xe9s car non renseign\xe9s"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                            onClick: ()=>navigate((0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).ACCUEIL),
                            children: "Annuler"
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $14d3fd906319adea$exports.CSVLink), {
                            data: dataCsv,
                            headers: headers,
                            filename: "resultats_import_ctp.csv",
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$4a5ccdc9878f4668), {}),
                                "Exporter le rapport"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db9b0e6fdb142a4c$export$2e2bcd8739ae039), {
                            submitTitle: "Importer les visites"
                        })
                    })
                ]
            })
        ]
    });
};











const $d8b03e3e0518a115$var$UpdateIndisponibiliteTemporaire = ()=>{
    const { indisponibiliteTemporaireId: indisponibiliteTemporaireId } = (0, $7a844823b04d4282$export$99eaa27ddbbb95ef)();
    const indisponibiliteTemporaireState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/indisponibilite-temporaire/` + indisponibiliteTemporaireId);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
        initialValues: (0, $98b3054bb852b7dd$export$a5cab80145b70e98)({
            ...indisponibiliteTemporaireState?.data,
            listePeiId: indisponibiliteTemporaireState?.data?.indisponibiliteTemporaireListePeiId
        }),
        validationSchema: (0, $98b3054bb852b7dd$export$c084437b5e3206cd),
        submitUrl: `/api/indisponibilite-temporaire/` + indisponibiliteTemporaireId,
        prepareVariables: (values)=>(0, $98b3054bb852b7dd$export$f97400759cfd946)(values),
        redirectUrl: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_INDISPONIBILITE_TEMPORAIRE,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $98b3054bb852b7dd$export$2e2bcd8739ae039), {
            title: "Modifier une indisponibilit\xe9 temporaire",
            indisponibiliteTemporaireId: indisponibiliteTemporaireId
        })
    });
};
var $d8b03e3e0518a115$export$2e2bcd8739ae039 = $d8b03e3e0518a115$var$UpdateIndisponibiliteTemporaire;











var $bkJfK = parcelRequire("bkJfK");

var $kc00y = parcelRequire("kc00y");










const $35b25f8a96785a66$export$a5cab80145b70e98 = (data)=>({
        typeCriseId: data?.typeCriseId ?? null,
        criseLibelle: data?.criseLibelle ?? null,
        criseDescription: data?.criseDescription ?? null,
        listeCommuneId: data?.listeCommuneId ?? null,
        criseDateDebut: data?.criseDateDebut ? (0, $00c47c7740afd024$export$cc23f907e4acb548)(data?.criseDateDebut) : (0, $00c47c7740afd024$export$cc23f907e4acb548)(new Date()),
        listeToponymieId: data?.listeToponymieId ?? null,
        couchesWMS: data?.couchesWMS ?? []
    });
const $35b25f8a96785a66$export$fc70085a30e92f86 = (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({
    typeCriseId: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
    criseLibelle: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
    criseDateDebut: (0, $36ceaed6faf947af$export$5cbf64e9c4f743ca),
    listeCommuneId: (0, $36ceaed6faf947af$export$6e10f2f70d298df6)
});
const $35b25f8a96785a66$export$bb754639dd100f3c = (values)=>({
        typeCriseId: values.typeCriseId,
        criseLibelle: values.criseLibelle,
        criseDescription: values.criseDescription,
        listeCommuneId: values.listeCommuneId,
        criseDateDebut: new Date(values.criseDateDebut).toISOString(),
        listeToponymieId: values.listeToponymieId,
        couchesWMS: values.couchesWMS
    });
const $35b25f8a96785a66$var$Crise = ()=>{
    const { setValues: setValues, setFieldValue: setFieldValue, values: values } = (0, $bkJfK.useFormikContext)();
    const typeCriseState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/crise/get-type-crise`);
    const communeState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/commune/get-libelle-commune`);
    const toponymieList = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/toponymie/get-libelle-toponymie`);
    const listTypeCrise = typeCriseState.data ?? [];
    // Récupération des couches disponibles (toutes les couches WMS)
    const couchesWMSState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/crise/get-couches-wms`);
    const toutesLesCouches = couchesWMSState.data || [];
    // Cas où il n'y a aucune couche associée au module de Crise
    const aucuneCouchesAssociee = toutesLesCouches.length === 0;
    // Cas où toutes les couches sont déjà ajoutées
    const plusDeCouchesDispo = toutesLesCouches.length > 0 && toutesLesCouches.every((c)=>values.couchesWMS?.some((w)=>w.coucheId === c.coucheId));
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
        noValidate: true,
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("h3", {
                className: "mt-1",
                children: "Informations g\xe9n\xe9rales"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                name: "typeCriseId",
                listIdCodeLibelle: listTypeCrise,
                label: "Type de la crise",
                required: true,
                setValues: setValues,
                defaultValue: listTypeCrise.find((e)=>e.id === values?.typeCriseId)
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                label: "Nom",
                name: "criseLibelle",
                required: true
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$ce9b1cc0c34506d0), {
                name: "criseDescription",
                label: "Description",
                required: false
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$183478aa40b5df1), {
                name: "criseDateDebut",
                label: "Date et heure d\u2019activation",
                value: values.criseDateDebut,
                required: true
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$eae70af4b4e3f197), {
                name: "listeCommuneId",
                label: "Liste des communes de la crise",
                options: communeState.data,
                getOptionValue: (t)=>t.id,
                getOptionLabel: (t)=>t.libelle,
                value: values.listeCommuneId?.map((e)=>communeState.data?.find((c)=>c.id === e)) ?? undefined,
                onChange: (commune)=>{
                    const communeId = commune.map((e)=>e.id);
                    communeId.length > 0 ? setFieldValue("listeCommuneId", communeId) : setFieldValue("listeCommuneId", undefined);
                },
                isClearable: true
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$eae70af4b4e3f197), {
                name: "listeTyponymieId",
                label: "R\xe9pertoire des lieux",
                options: toponymieList.data,
                getOptionValue: (t)=>t.id,
                getOptionLabel: (t)=>t.libelle,
                isClearable: true,
                required: false,
                value: values.listeToponymieId?.map((e)=>toponymieList.data?.find((c)=>c.id === e)) ?? undefined,
                onChange: (toponymie)=>{
                    const toponymieId = toponymie.map((e)=>e.id);
                    toponymieId.length > 0 ? setFieldValue("listeToponymieId", toponymieId) : setFieldValue("listeToponymieId", undefined);
                }
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $665753c43020c55f$export$2e2bcd8739ae039), {
                name: "couchesWMS",
                label: "Liste des couches WMS",
                canAdd: true,
                createComponentToRepeat: $35b25f8a96785a66$var$createComponentToRepeat,
                listeElements: values.couchesWMS,
                defaultElement: {
                    coucheId: null,
                    operationnel: false,
                    anticipation: false
                },
                isDisabledButton: plusDeCouchesDispo || aucuneCouchesAssociee,
                disableText: aucuneCouchesAssociee ? "Aucune couche associ\xe9e au module de Crise" : plusDeCouchesDispo ? "Toutes les couches disponibles ont d\xe9j\xe0 \xe9t\xe9 ajout\xe9es" : undefined
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db9b0e6fdb142a4c$export$2e2bcd8739ae039), {
                returnLink: true
            })
        ]
    });
};
function $35b25f8a96785a66$var$createComponentToRepeat(index, listeElements) {
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($35b25f8a96785a66$var$ComposantToRepeat, {
        index: index,
        listeElements: listeElements
    });
}
const $35b25f8a96785a66$var$ComposantToRepeat = ({ index: index, listeElements: listeElements })=>{
    const couchesWMS = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/crise/get-couches-wms`);
    // logique de mappage et d'unicité
    const selectedIds = listeElements?.map(({ coucheId: coucheId })=>coucheId).filter(Boolean);
    const TypesCouches = (0, $kc00y.useMemo)(()=>couchesWMS.data?.filter(({ coucheId: coucheId })=>!selectedIds.includes(coucheId)) || [], [
        couchesWMS.data,
        selectedIds
    ]);
    const { setFieldValue: setFieldValue } = (0, $bkJfK.useFormikContext)();
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
        className: "align-items-center mt-3",
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$d6701e98ab1a6725), {
                    name: `couchesWMS[${index}].coucheId`,
                    label: "Type",
                    options: TypesCouches,
                    getOptionValue: (t)=>t.coucheId,
                    getOptionLabel: (t)=>t.coucheLibelle,
                    onChange: (e)=>{
                        setFieldValue(`couchesWMS[${index}].coucheId`, TypesCouches.find((type)=>type.coucheId === e.coucheId)?.coucheId);
                    },
                    defaultValue: couchesWMS.data?.find((type)=>type.coucheId === listeElements[index].coucheId),
                    required: true
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                    name: `couchesWMS[${index}].operationnel`,
                    label: "Op\xe9rationnel"
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                    name: `couchesWMS[${index}].anticipation`,
                    label: "Anticipation"
                })
            })
        ]
    });
};
var $35b25f8a96785a66$export$2e2bcd8739ae039 = $35b25f8a96785a66$var$Crise;


const $037869659ef735e1$var$CreateCrise = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$d776d19dfae66ece), {}),
                title: "Cr\xe9ation d'une crise"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                initialValues: (0, $35b25f8a96785a66$export$a5cab80145b70e98)(),
                prepareVariables: (values)=>(0, $35b25f8a96785a66$export$bb754639dd100f3c)(values),
                validationSchema: (0, $35b25f8a96785a66$export$fc70085a30e92f86),
                submitUrl: `/api/crise/create`,
                isPost: true,
                redirectUrl: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_CRISES,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $35b25f8a96785a66$export$2e2bcd8739ae039), {})
            })
        ]
    });
};
var $037869659ef735e1$export$2e2bcd8739ae039 = $037869659ef735e1$var$CreateCrise;




var $kc00y = parcelRequire("kc00y");






const $c1a9e5f6cbf38896$export$b0def9349e7d1439 = ({ name: name, label: label, onChange: onChangeCallback, required: required = false, disabled: disabled = false, type: type = "checkbox", checked: checked = false })=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Check, {
        className: "form-check form-switch fs-4",
        type: type,
        label: label,
        required: required,
        disabled: disabled,
        onChange: (data)=>{
            onChangeCallback({
                name: name,
                value: data.target.checked
            });
        },
        checked: checked
    });
};
var $c1a9e5f6cbf38896$export$2e2bcd8739ae039 = $c1a9e5f6cbf38896$export$b0def9349e7d1439;



const $2933276d290b4a54$export$924b20232949ea01 = ({ name: name, label: label, required: required = true, readOnly: readOnly = false, onChange: onChangeCallback, value: value, dateType: dateType = "datetime-local" })=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("label", {
                children: label
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("input", {
                id: name,
                type: dateType,
                value: value,
                required: required,
                disabled: readOnly,
                max: "9999-12-31T23:59",
                onChange: (data)=>{
                    onChangeCallback({
                        name: name,
                        value: data.currentTarget.value
                    });
                }
            })
        ]
    });
};
var $2933276d290b4a54$export$2e2bcd8739ae039 = $2933276d290b4a54$export$924b20232949ea01;






const $528d179ef5f8cb95$var$ExportCrise = ()=>{
    const { criseId: criseId } = (0, $7a844823b04d4282$export$99eaa27ddbbb95ef)();
    const crise = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/crise/${criseId}`);
    const [exportParams, setExportParams] = (0, $kc00y.useState)({
        dateDebExtraction: new Date(),
        dateFinExtraction: new Date(),
        hasMessage: true,
        hasDoc: true
    });
    const loop = (0, $kc00y.useRef)(0);
    (0, $kc00y.useMemo)(()=>{
        if (crise.isResolved && loop.current === 0) {
            loop.current += 1;
            if (crise.data?.criseDateDebut && crise.data?.criseDateFin) setExportParams({
                ...exportParams,
                dateDebExtraction: new Date(crise.data?.criseDateDebut),
                dateFinExtraction: new Date(crise.data?.criseDateFin)
            });
        }
    }, [
        crise,
        exportParams
    ]);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$4a5ccdc9878f4668), {}),
                title: "Export des donn\xe9es de la crise"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("h1", {
                            children: "P\xe9riode d'extraction"
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                        className: "my-3",
                        xs: 3,
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                            className: "text-center mx-auto",
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2933276d290b4a54$export$924b20232949ea01), {
                                        name: "dateDebExtraction",
                                        label: "Extraire les informations entre le",
                                        required: true,
                                        value: (0, $00c47c7740afd024$export$cc23f907e4acb548)(exportParams.dateDebExtraction),
                                        onChange: (e)=>setExportParams({
                                                ...exportParams,
                                                dateDebExtraction: e.value
                                            })
                                    })
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2933276d290b4a54$export$924b20232949ea01), {
                                        name: "dateFinExtraction",
                                        label: "et le",
                                        required: true,
                                        value: (0, $00c47c7740afd024$export$cc23f907e4acb548)(exportParams.dateFinExtraction),
                                        onChange: (e)=>setExportParams({
                                                ...exportParams,
                                                dateFinExtraction: e.value
                                            })
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                        className: "my-3",
                        xs: 3,
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                            className: "mx-auto",
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $c1a9e5f6cbf38896$export$2e2bcd8739ae039), {
                                        name: "hasMessage",
                                        label: "Exporter les messages associ\xe9s aux \xe9v\xe8nements",
                                        checked: exportParams.hasMessage,
                                        onChange: (e)=>setExportParams({
                                                ...exportParams,
                                                hasMessage: e.value
                                            })
                                    })
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $c1a9e5f6cbf38896$export$2e2bcd8739ae039), {
                                        name: "hasDoc",
                                        label: "Exporter les documents associ\xe9s aux \xe9v\xe8nements",
                                        checked: exportParams.hasDoc,
                                        onChange: (e)=>setExportParams({
                                                ...exportParams,
                                                hasDoc: e.value
                                            })
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                        xs: 4,
                        className: "mx-auto",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                            className: "mx-auto",
                            variant: "primary",
                            onClick: ()=>{
                                const exp = {
                                    dateDebExtraction: new Date(exportParams?.dateDebExtraction).toISOString(),
                                    dateFinExtraction: new Date(exportParams?.dateFinExtraction).toISOString(),
                                    hasMessage: exportParams?.hasMessage,
                                    hasDoc: exportParams?.hasDoc
                                };
                                window.open((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/crise/${criseId}/export?${exp}`, "_blank");
                            },
                            href: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_CRISES,
                            children: "Valider"
                        })
                    })
                ]
            })
        ]
    });
};
var $528d179ef5f8cb95$export$2e2bcd8739ae039 = $528d179ef5f8cb95$var$ExportCrise;




var $bkJfK = parcelRequire("bkJfK");













var $6979eb5e225fccef$var$CriseStatutEnum = /*#__PURE__*/ function(CriseStatutEnum) {
    CriseStatutEnum["EN_COURS"] = "En cours";
    CriseStatutEnum["TERMINEE"] = "Termin\xe9e";
    CriseStatutEnum["FUSIONNEE"] = "Fusionn\xe9e";
    return CriseStatutEnum;
}($6979eb5e225fccef$var$CriseStatutEnum || {});
var $6979eb5e225fccef$export$2e2bcd8739ae039 = $6979eb5e225fccef$var$CriseStatutEnum;






const $ead6c07989a3dfe8$var$filterValuesToVariable = ({ typeCriseLibelle: typeCriseLibelle, criseLibelle: criseLibelle, criseDescription: criseDescription, criseStatutType: criseStatutType, criseDateDebut: criseDateDebut, criseDateFin: criseDateFin })=>{
    const filter = {};
    $ead6c07989a3dfe8$var$filterPropertyCrise(filter, typeCriseLibelle, "typeCriseLibelle");
    $ead6c07989a3dfe8$var$filterPropertyCrise(filter, criseLibelle, "criseLibelle");
    $ead6c07989a3dfe8$var$filterPropertyCrise(filter, criseDescription, "criseDescription");
    $ead6c07989a3dfe8$var$filterPropertyCrise(filter, criseStatutType, "criseStatutType");
    $ead6c07989a3dfe8$var$filterPropertyCrise(filter, criseDateDebut, "criseDateDebut");
    $ead6c07989a3dfe8$var$filterPropertyCrise(filter, criseDateFin, "criseDateFin");
    return filter;
};
var $ead6c07989a3dfe8$export$2e2bcd8739ae039 = $ead6c07989a3dfe8$var$filterValuesToVariable;
function $ead6c07989a3dfe8$var$filterPropertyCrise(filter, value, name) {
    if (value?.trim().length > 0) filter[name] = value;
}


const $f34af43330f31af1$export$8470ef9d0802da38 = (data)=>{
    return {
        criseDateFin: new Date(data.criseDateFin).toISOString()
    };
};
const $f34af43330f31af1$var$ListCrise = ()=>{
    const { user: user } = (0, $e787cde576104469$export$fdc397e486fa83e7)();
    const { fetchGeometry: fetchGeometry } = (0, $a178c3075f0f40bb$export$2e2bcd8739ae039)();
    const listeButton = [];
    if ((0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).CRISE_R)) listeButton.push({
        row: (row)=>{
            return row;
        },
        type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).LINK,
        onClick: (criseId, row)=>{
            if (row.listeCommune.length > 0) fetchGeometry((0, $a178c3075f0f40bb$export$970c58a942355206).COMMUNE_CRISE, criseId, (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).OUVRIR_CRISE(criseId));
        },
        icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$8bb46d5eef767d7), {}),
        textEnable: "Ouvrir la crise",
        classEnable: "primary",
        disable: (v)=>[
                (0, $6979eb5e225fccef$export$2e2bcd8739ae039).TERMINEE,
                (0, $6979eb5e225fccef$export$2e2bcd8739ae039).FUSIONNEE
            ].includes((0, $6979eb5e225fccef$export$2e2bcd8739ae039)[v.original.criseStatutType]),
        textDisable: "Impossible d'ouvrir une crise cl\xf4tur\xe9e"
    });
    if ((0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).CRISE_U)) {
        listeButton.push({
            row: (row)=>{
                return row;
            },
            textEnable: "Modifier",
            disable: (v)=>[
                    (0, $6979eb5e225fccef$export$2e2bcd8739ae039).TERMINEE,
                    (0, $6979eb5e225fccef$export$2e2bcd8739ae039).FUSIONNEE
                ].includes((0, $6979eb5e225fccef$export$2e2bcd8739ae039)[v.original.criseStatutType]),
            textDisable: "Impossible de modifier une crise qui n'est plus en cours",
            classEnable: "danger",
            route: (criseId)=>(0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).UPDATE_CRISE(criseId),
            type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).UPDATE
        });
        listeButton.push({
            row: (row)=>{
                return row;
            },
            disable: (v)=>[
                    (0, $6979eb5e225fccef$export$2e2bcd8739ae039).TERMINEE,
                    (0, $6979eb5e225fccef$export$2e2bcd8739ae039).FUSIONNEE
                ].includes((0, $6979eb5e225fccef$export$2e2bcd8739ae039)[v.original.criseStatutType]),
            classEnable: "info",
            textDisable: "Impossible de fusionner une crise qui n'est plus en cours",
            route: (criseId)=>(0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).MERGE_CRISE(criseId),
            type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).LINK,
            icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$81608868aefa31ce), {}),
            textEnable: "Fusionner"
        });
        listeButton.push({
            row: (row)=>{
                return row;
            },
            disable: (v)=>[
                    (0, $6979eb5e225fccef$export$2e2bcd8739ae039).EN_COURS
                ].includes((0, $6979eb5e225fccef$export$2e2bcd8739ae039)[v.original.criseStatutType]),
            classEnable: "danger",
            textDisable: "Impossible d'exporter une crise qui n'est pas close",
            route: (criseId)=>(0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).EXPORT_CRISE(criseId),
            type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).BUTTON,
            icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$4019ac48f69e96df), {}),
            textEnable: "Exporter"
        });
        listeButton.push({
            row: (row)=>{
                return row;
            },
            type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).EDIT_MODAL,
            disable: (v)=>[
                    (0, $6979eb5e225fccef$export$2e2bcd8739ae039).TERMINEE,
                    (0, $6979eb5e225fccef$export$2e2bcd8739ae039).FUSIONNEE
                ].includes((0, $6979eb5e225fccef$export$2e2bcd8739ae039)[v.original.criseStatutType]),
            icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$e04bcc6127e699bf), {}),
            classEnable: "danger",
            textEnable: "Clore la crise",
            textDisable: "Impossible de clore une crise qui n'est plus en cours",
            editModal: {
                content: ()=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($f34af43330f31af1$var$PrivateDate, {}),
                header: (row)=>"Clore la crise : " + row.original.criseLibelle,
                path: (row)=>`/api/crise/${row.original.criseId}/clore`,
                prepareVariable: (value)=>$f34af43330f31af1$export$8470ef9d0802da38(value),
                value: {
                    criseDateFin: (0, $00c47c7740afd024$export$cc23f907e4acb548)(new Date())
                }
            }
        });
    }
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$6c15dfad3d23e29b), {}),
                title: "Liste des crises",
                right: (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).CRISE_C) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8ad69b89456b65bc$export$2e2bcd8739ae039), {
                    href: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).CREATE_CRISE,
                    title: "Ajouter une crise"
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $9a9eebc3462fba73$export$2e2bcd8739ae039), {
                query: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/crise`,
                columns: [
                    {
                        Header: "Type de crise",
                        accessor: "typeCriseLibelle",
                        sortField: "typeCriseLibelle"
                    },
                    {
                        Header: "Nom",
                        accessor: "criseLibelle",
                        sortField: "criseLibelle",
                        Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                            type: "text",
                            name: "criseLibelle"
                        })
                    },
                    {
                        Header: "Description",
                        accessor: "criseDescription",
                        sortField: "criseDescription",
                        Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                            type: "text",
                            name: "criseDescription"
                        })
                    },
                    {
                        Header: "Date d'activation",
                        accessor: "criseDateDebut",
                        sortField: "criseDateDebut",
                        Cell: (value)=>{
                            return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                children: value?.value != null && (0, $00c47c7740afd024$export$2e2bcd8739ae039)(value.value)
                            });
                        }
                    },
                    {
                        Header: "Date de cl\xf4ture",
                        accessor: "criseDateFin",
                        sortField: "criseDateFin",
                        Cell: (value)=>{
                            return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                children: value?.value != null && (0, $00c47c7740afd024$export$2e2bcd8739ae039)(value.value)
                            });
                        }
                    },
                    {
                        Header: "Statut",
                        accessor: "criseStatutType",
                        sortField: "criseStatutType",
                        Cell: (value)=>{
                            return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                children: value?.value != null && (0, $6979eb5e225fccef$export$2e2bcd8739ae039)[value.value]
                            });
                        },
                        Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eed37ff3d3e1f28c$export$2e2bcd8739ae039), {
                            options: (0, $6979eb5e225fccef$export$2e2bcd8739ae039),
                            name: "criseStatutType"
                        })
                    },
                    {
                        Header: "Communes",
                        accessor: "listeCommune",
                        Cell: (value)=>{
                            return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                children: value?.value?.join(", ")
                            });
                        }
                    },
                    (0, $b82b937cc97f6f18$export$36e9f5a475c9f6fc)({
                        Header: "Actions",
                        accessor: "criseId",
                        buttons: listeButton
                    })
                ],
                idName: "tableCriseId",
                filterValuesToVariable: (0, $ead6c07989a3dfe8$export$2e2bcd8739ae039),
                filterContext: (0, $9a9eebc3462fba73$export$396ef541d9951d45)({
                    typeCriseLibelle: undefined,
                    criseLibelle: undefined,
                    criseDescription: undefined,
                    criseStatutType: undefined,
                    criseDateDebut: undefined,
                    criseDateFin: undefined
                })
            })
        ]
    });
};
const $f34af43330f31af1$var$PrivateDate = ()=>{
    const { values: values } = (0, $bkJfK.useFormikContext)();
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$183478aa40b5df1), {
        name: "criseDateFin",
        label: "Date et heure de fin",
        required: true,
        value: values.criseDateFin
    });
};
var $f34af43330f31af1$export$2e2bcd8739ae039 = $f34af43330f31af1$var$ListCrise;




var $kc00y = parcelRequire("kc00y");













var $kc00y = parcelRequire("kc00y");












var $kc00y = parcelRequire("kc00y");










const $85dfd19055b5d7fc$export$1636a9582e7974ce = (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({
    docLibelle: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba)
});
const $85dfd19055b5d7fc$export$a04a503d8277ee43 = ()=>({
        docLibelle: ""
    });
const $85dfd19055b5d7fc$export$f97400759cfd946 = (document, values, localisation)=>{
    const formData = new FormData();
    formData.append("document", document);
    formData.append("criseDocName", values.docLibelle);
    formData.append("documentGeometry", JSON.stringify(localisation));
    return formData;
};
const $85dfd19055b5d7fc$var$AddTitleForm = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$f76670b5e5897c33), {
            title: "Ajouter un titre \xe0 la capture",
            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                label: "Nom de la capture",
                name: "docLibelle",
                required: true
            })
        })
    });
};
var $85dfd19055b5d7fc$export$2e2bcd8739ae039 = $85dfd19055b5d7fc$var$AddTitleForm;
























var $bkJfK = parcelRequire("bkJfK");



const $5c1715f273c75a5a$export$1636a9582e7974ce = (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({});
const $5c1715f273c75a5a$export$a04a503d8277ee43 = ()=>({
        documents: []
    });
const $5c1715f273c75a5a$export$f97400759cfd946 = (values)=>{
    const formData = new FormData();
    (0, $69d686b1e97c5ea6$export$3f0f08502708410b)(values?.documents, null, formData);
    return formData;
};
const $5c1715f273c75a5a$var$MessageForm = ()=>{
    const { setFieldValue: setFieldValue, values: values } = (0, $bkJfK.useFormikContext)();
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$f76670b5e5897c33), {
            title: "Ajouter un document",
            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $69d686b1e97c5ea6$export$2e2bcd8739ae039), {
                documents: values.documents,
                setFieldValue: setFieldValue,
                autreFormParam: (index)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                            label: "Nom",
                            name: `documents[${index}].evenementDocumentLibelle`,
                            required: false
                        })
                    }),
                defaultOtherProperties: {
                    levenementDocumentLibelle: null
                }
            })
        })
    });
};
var $5c1715f273c75a5a$export$2e2bcd8739ae039 = $5c1715f273c75a5a$var$MessageForm;


const $2f9a50d6d0120c12$var$filterValuesToVariable = ({ documentDate: documentDate, type: type, documentNomFichier: documentNomFichier })=>{
    const filter = {};
    $2f9a50d6d0120c12$var$filterPropertyCrise(filter, documentDate, "documentDate");
    $2f9a50d6d0120c12$var$filterPropertyCrise(filter, type, "type");
    $2f9a50d6d0120c12$var$filterPropertyCrise(filter, documentNomFichier, "documentNomFichier");
    return filter;
};
var $2f9a50d6d0120c12$export$2e2bcd8739ae039 = $2f9a50d6d0120c12$var$filterValuesToVariable;
function $2f9a50d6d0120c12$var$filterPropertyCrise(filter, value, name) {
    if (value?.trim().length > 0) filter[name] = value;
}


const $b8f2df69c6c1f6d5$var$ListDocument = ({ criseId: criseId, onSubmit: onSubmit, map: map })=>{
    const { visible: visible, show: show, close: close } = (0, $ca8671088139af49$export$2e2bcd8739ae039)();
    const { user: user } = (0, $e787cde576104469$export$fdc397e486fa83e7)();
    const listeButton = [];
    const showEventLocation = (geometry)=>{
        const geom = new (0, $15a985d09649bdc2$export$2e2bcd8739ae039)().readFeature(geometry.split(";").pop());
        map?.getView().fit(geom.get("geometry"));
    };
    if ((0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).CRISE_U)) listeButton.push({
        row: (row)=>{
            return row;
        },
        type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).DELETE,
        textEnable: "Supprimer le document",
        pathname: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/crise/documents/supprimer/`,
        classEnable: "danger"
    });
    listeButton.push({
        row: (row)=>{
            return row;
        },
        classEnable: "info",
        route: (documentId)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/documents/telecharger/${documentId}`,
        type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).BUTTON,
        icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$4a5ccdc9878f4668), {}),
        textEnable: "T\xe9l\xe9charger"
    });
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            (0, $e3b8d60f4bb99483$export$4f612ab7b7b1d133)(user, [
                (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).CRISE_C,
                (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).CRISE_U
            ]) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                    xs: 12,
                    className: "d-flex justify-content-end",
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8ad69b89456b65bc$export$2e2bcd8739ae039), {
                        title: "Ajouter un document",
                        classnames: "my-2",
                        onClick: ()=>{
                            show();
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $9a9eebc3462fba73$export$2e2bcd8739ae039), {
                query: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/crise/documents/getAllFromCrise/${criseId}`,
                columns: [
                    {
                        Header: "Origine",
                        accessor: "type"
                    },
                    {
                        Header: "Libell\xe9",
                        accessor: "documentNomFichier",
                        sortField: "documentNomFichier",
                        Cell: (value)=>{
                            return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                children: (0, $c066b242635c27a6$export$b139bd30bc162c86)(value.value, 20)
                            });
                        }
                    },
                    {
                        Header: "Mise \xe0 jour le",
                        accessor: "documentDate",
                        sortField: "documentDate",
                        Cell: (value)=>{
                            return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                children: value?.value != null && (0, $00c47c7740afd024$export$2e2bcd8739ae039)(value.value)
                            });
                        }
                    },
                    {
                        Header: "Localiser",
                        accessor: "documentGeometrie",
                        Cell: (value)=>{
                            return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                                    disabled: value.value == null,
                                    style: {
                                        backgroundColor: "transparent",
                                        border: "none"
                                    },
                                    className: value.value != null ? "text-warning" : "text-muted",
                                    onClick: ()=>{
                                        showEventLocation(value.value);
                                    },
                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$cbe811cb8e919f27), {})
                                })
                            });
                        }
                    },
                    (0, $b82b937cc97f6f18$export$36e9f5a475c9f6fc)({
                        Header: "Actions",
                        accessor: "documentId",
                        buttons: listeButton
                    })
                ],
                idName: "tableModuleDocument",
                filterValuesToVariable: (0, $2f9a50d6d0120c12$export$2e2bcd8739ae039),
                filterContext: (0, $9a9eebc3462fba73$export$396ef541d9951d45)({
                    documentDate: undefined,
                    documentNomFichier: undefined,
                    type: undefined
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $c738870e8199ea0b$export$2e2bcd8739ae039), {
                closeModal: close,
                canModify: true,
                query: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/crise/document/addDocument/${criseId}`,
                submitLabel: "Valider",
                visible: visible,
                isMultipartFormData: true,
                header: null,
                validationSchema: (0, $5c1715f273c75a5a$export$1636a9582e7974ce),
                onSubmit: onSubmit,
                prepareVariables: (values)=>(0, $5c1715f273c75a5a$export$f97400759cfd946)(values),
                getInitialValues: ()=>(0, $5c1715f273c75a5a$export$a04a503d8277ee43)(),
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $5c1715f273c75a5a$export$2e2bcd8739ae039), {})
            })
        ]
    });
};
var $b8f2df69c6c1f6d5$export$2e2bcd8739ae039 = $b8f2df69c6c1f6d5$var$ListDocument;


const $2455128491488306$var$CreateListDocuments = ({ criseIdentifiant: criseIdentifiant, onSubmit: onSubmit, map: map })=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$84ac927778fdc063), {}),
                title: "Liste des documents",
                displayReturnButton: false
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b8f2df69c6c1f6d5$export$2e2bcd8739ae039), {
                criseId: criseIdentifiant,
                onSubmit: onSubmit,
                map: map
            })
        ]
    });
};
var $2455128491488306$export$2e2bcd8739ae039 = $2455128491488306$var$CreateListDocuments;




var $kc00y = parcelRequire("kc00y");











var $kc00y = parcelRequire("kc00y");

var $lCkAA = parcelRequire("lCkAA");

var $kc00y = parcelRequire("kc00y");





var $kc00y = parcelRequire("kc00y");




const $6b6e7489b41f1b19$var$_excluded = [
    "active",
    "eventKey",
    "mountOnEnter",
    "transition",
    "unmountOnExit",
    "role",
    "onEnter",
    "onEntering",
    "onEntered",
    "onExit",
    "onExiting",
    "onExited"
], $6b6e7489b41f1b19$var$_excluded2 = [
    "activeKey",
    "getControlledId",
    "getControllerId"
], $6b6e7489b41f1b19$var$_excluded3 = [
    "as"
];
function $6b6e7489b41f1b19$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $6b6e7489b41f1b19$export$fae0121b5afe572d(_ref) {
    let { active: active, eventKey: eventKey, mountOnEnter: mountOnEnter, transition: transition, unmountOnExit: unmountOnExit, role: role = 'tabpanel', onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited } = _ref, props = $6b6e7489b41f1b19$var$_objectWithoutPropertiesLoose(_ref, $6b6e7489b41f1b19$var$_excluded);
    const context = (0, $kc00y.useContext)((0, $26ddc764548e04cb$export$2e2bcd8739ae039));
    if (!context) return [
        Object.assign({}, props, {
            role: role
        }),
        {
            eventKey: eventKey,
            isActive: active,
            mountOnEnter: mountOnEnter,
            transition: transition,
            unmountOnExit: unmountOnExit,
            onEnter: onEnter,
            onEntering: onEntering,
            onEntered: onEntered,
            onExit: onExit,
            onExiting: onExiting,
            onExited: onExited
        }
    ];
    const { activeKey: activeKey, getControlledId: getControlledId, getControllerId: getControllerId } = context, rest = $6b6e7489b41f1b19$var$_objectWithoutPropertiesLoose(context, $6b6e7489b41f1b19$var$_excluded2);
    const key = (0, $218ada47f6b11566$export$eef49b42fde998a3)(eventKey);
    return [
        Object.assign({}, props, {
            role: role,
            id: getControlledId(eventKey),
            'aria-labelledby': getControllerId(eventKey)
        }),
        {
            eventKey: eventKey,
            isActive: active == null && key != null ? (0, $218ada47f6b11566$export$eef49b42fde998a3)(activeKey) === key : active,
            transition: transition || rest.transition,
            mountOnEnter: mountOnEnter != null ? mountOnEnter : rest.mountOnEnter,
            unmountOnExit: unmountOnExit != null ? unmountOnExit : rest.unmountOnExit,
            onEnter: onEnter,
            onEntering: onEntering,
            onEntered: onEntered,
            onExit: onExit,
            onExiting: onExiting,
            onExited: onExited
        }
    ];
}
const $6b6e7489b41f1b19$var$TabPanel = /*#__PURE__*/ $kc00y.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
(_ref2, ref)=>{
    let { as: Component = 'div' } = _ref2, props = $6b6e7489b41f1b19$var$_objectWithoutPropertiesLoose(_ref2, $6b6e7489b41f1b19$var$_excluded3);
    const [tabPanelProps, { isActive: isActive, onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited, mountOnEnter: mountOnEnter, unmountOnExit: unmountOnExit, transition: Transition = (0, $45ae2d5550567d5b$export$2e2bcd8739ae039) }] = $6b6e7489b41f1b19$export$fae0121b5afe572d(props);
    // We provide an empty the TabContext so `<Nav>`s in `<TabPanel>`s don't
    // conflict with the top level one.
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26ddc764548e04cb$export$2e2bcd8739ae039).Provider, {
        value: null,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $218ada47f6b11566$export$2e2bcd8739ae039).Provider, {
            value: null,
            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)(Transition, {
                in: isActive,
                onEnter: onEnter,
                onEntering: onEntering,
                onEntered: onEntered,
                onExit: onExit,
                onExiting: onExiting,
                onExited: onExited,
                mountOnEnter: mountOnEnter,
                unmountOnExit: unmountOnExit,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)(Component, Object.assign({}, tabPanelProps, {
                    ref: ref,
                    hidden: !isActive,
                    "aria-hidden": !isActive
                }))
            })
        })
    });
});
$6b6e7489b41f1b19$var$TabPanel.displayName = 'TabPanel';
var $6b6e7489b41f1b19$export$2e2bcd8739ae039 = $6b6e7489b41f1b19$var$TabPanel;



const $57b1be649182ba93$var$Tabs = (props)=>{
    const { id: userId, generateChildId: generateCustomChildId, onSelect: propsOnSelect, activeKey: propsActiveKey, defaultActiveKey: defaultActiveKey, transition: transition, mountOnEnter: mountOnEnter, unmountOnExit: unmountOnExit, children: children } = props;
    const [activeKey, onSelect] = (0, $dc977c09674889c6$export$2ee51287a16ca325)(propsActiveKey, defaultActiveKey, propsOnSelect);
    const id = (0, $ee9ef19153721bae$export$619500959fc48b26)(userId);
    const generateChildId = (0, $kc00y.useMemo)(()=>generateCustomChildId || ((key, type)=>id ? `${id}-${type}-${key}` : null), [
        id,
        generateCustomChildId
    ]);
    const tabContext = (0, $kc00y.useMemo)(()=>({
            onSelect: onSelect,
            activeKey: activeKey,
            transition: transition,
            mountOnEnter: mountOnEnter || false,
            unmountOnExit: unmountOnExit || false,
            getControlledId: (key)=>generateChildId(key, 'tabpane'),
            getControllerId: (key)=>generateChildId(key, 'tab')
        }), [
        onSelect,
        activeKey,
        transition,
        mountOnEnter,
        unmountOnExit,
        generateChildId
    ]);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26ddc764548e04cb$export$2e2bcd8739ae039).Provider, {
        value: tabContext,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $218ada47f6b11566$export$2e2bcd8739ae039).Provider, {
            value: onSelect || null,
            children: children
        })
    });
};
$57b1be649182ba93$var$Tabs.Panel = (0, $6b6e7489b41f1b19$export$2e2bcd8739ae039);
var $57b1be649182ba93$export$2e2bcd8739ae039 = $57b1be649182ba93$var$Tabs;




function $116ee0b5e7d86666$export$2e2bcd8739ae039(transition) {
    if (typeof transition === 'boolean') return transition ? (0, $25d8c693c355530c$export$2e2bcd8739ae039) : (0, $45ae2d5550567d5b$export$2e2bcd8739ae039);
    return transition;
}



const $22f0ed49aa16e767$var$TabContainer = ({ transition: transition, ...props })=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $57b1be649182ba93$export$2e2bcd8739ae039), {
        ...props,
        transition: (0, $116ee0b5e7d86666$export$2e2bcd8739ae039)(transition)
    });
$22f0ed49aa16e767$var$TabContainer.displayName = 'TabContainer';
var $22f0ed49aa16e767$export$2e2bcd8739ae039 = $22f0ed49aa16e767$var$TabContainer;



var $kc00y = parcelRequire("kc00y");



"use client";
const $00a9bbc20343c87e$var$TabContent = /*#__PURE__*/ $kc00y.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(bsPrefix, 'tab-content');
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, bsPrefix),
        ...props
    });
});
$00a9bbc20343c87e$var$TabContent.displayName = 'TabContent';
var $00a9bbc20343c87e$export$2e2bcd8739ae039 = $00a9bbc20343c87e$var$TabContent;




var $kc00y = parcelRequire("kc00y");







"use client";
const $b38126256fab3db5$var$TabPane = /*#__PURE__*/ $kc00y.forwardRef(({ bsPrefix: bsPrefix, transition: transition, ...props }, ref)=>{
    const [{ className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div', ...rest }, { isActive: isActive, onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited, mountOnEnter: mountOnEnter, unmountOnExit: unmountOnExit, transition: Transition = (0, $25d8c693c355530c$export$2e2bcd8739ae039) }] = (0, $6b6e7489b41f1b19$export$fae0121b5afe572d)({
        ...props,
        transition: (0, $116ee0b5e7d86666$export$2e2bcd8739ae039)(transition)
    });
    const prefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(bsPrefix, 'tab-pane');
    // We provide an empty the TabContext so `<Nav>`s in `<TabPanel>`s don't
    // conflict with the top level one.
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26ddc764548e04cb$export$2e2bcd8739ae039).Provider, {
        value: null,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $218ada47f6b11566$export$2e2bcd8739ae039).Provider, {
            value: null,
            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)(Transition, {
                in: isActive,
                onEnter: onEnter,
                onEntering: onEntering,
                onEntered: onEntered,
                onExit: onExit,
                onExiting: onExiting,
                onExited: onExited,
                mountOnEnter: mountOnEnter,
                unmountOnExit: unmountOnExit,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)(Component, {
                    ...rest,
                    ref: ref,
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, prefix, isActive && 'active')
                })
            })
        })
    });
});
$b38126256fab3db5$var$TabPane.displayName = 'TabPane';
var $b38126256fab3db5$export$2e2bcd8739ae039 = $b38126256fab3db5$var$TabPane;


const $ec8c33620b91a894$var$propTypes = {
    eventKey: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).number
    ]),
    /**
   * Content for the tab title.
   */ title: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).node.isRequired,
    /**
   * The disabled state of the tab.
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).bool,
    /**
   * Class to pass to the underlying nav link.
   */ tabClassName: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).string,
    /**
   * Object containing attributes to pass to underlying nav link.
   */ tabAttrs: (0, (/*@__PURE__*/$parcel$interopDefault($lCkAA))).object
};
const $ec8c33620b91a894$var$Tab = ()=>{
    throw new Error("ReactBootstrap: The `Tab` component is not meant to be rendered! It's an abstract component that is only valid as a direct Child of the `Tabs` Component. For custom tabs components use TabPane and TabsContainer directly");
};
$ec8c33620b91a894$var$Tab.propTypes = $ec8c33620b91a894$var$propTypes;
var $ec8c33620b91a894$export$2e2bcd8739ae039 = Object.assign($ec8c33620b91a894$var$Tab, {
    Container: (0, $22f0ed49aa16e767$export$2e2bcd8739ae039),
    Content: (0, $00a9bbc20343c87e$export$2e2bcd8739ae039),
    Pane: (0, $b38126256fab3db5$export$2e2bcd8739ae039)
});

parcelRequire("kc00y");










function $5f8ed132be8030d8$var$getDefaultActiveKey(children) {
    let defaultActiveKey;
    (0, $539f969aeabf579c$export$4b80e395e36b5a56)(children, (child)=>{
        if (defaultActiveKey == null) defaultActiveKey = child.props.eventKey;
    });
    return defaultActiveKey;
}
function $5f8ed132be8030d8$var$renderTab(child) {
    const { title: title, eventKey: eventKey, disabled: disabled, tabClassName: tabClassName, tabAttrs: tabAttrs, id: id } = child.props;
    if (title == null) return null;
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $436178a401adbb7f$export$2e2bcd8739ae039), {
        as: "li",
        role: "presentation",
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $37ba031b10fc30fb$export$2e2bcd8739ae039), {
            as: "button",
            type: "button",
            eventKey: eventKey,
            disabled: disabled,
            id: id,
            className: tabClassName,
            ...tabAttrs,
            children: title
        })
    });
}
const $5f8ed132be8030d8$var$Tabs = (props)=>{
    const { id: id, onSelect: onSelect, transition: transition, mountOnEnter: mountOnEnter = false, unmountOnExit: unmountOnExit = false, variant: variant = 'tabs', children: children, activeKey: activeKey = $5f8ed132be8030d8$var$getDefaultActiveKey(children), ...controlledProps } = (0, $b0582fd40c314767$export$2e2bcd8739ae039)(props, {
        activeKey: 'onSelect'
    });
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $57b1be649182ba93$export$2e2bcd8739ae039), {
        id: id,
        activeKey: activeKey,
        onSelect: onSelect,
        transition: (0, $116ee0b5e7d86666$export$2e2bcd8739ae039)(transition),
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit,
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b9d4d12a3c294259$export$2e2bcd8739ae039), {
                id: id,
                ...controlledProps,
                role: "tablist",
                as: "ul",
                variant: variant,
                children: (0, $539f969aeabf579c$export$871de8747c9eaa88)(children, $5f8ed132be8030d8$var$renderTab)
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $00a9bbc20343c87e$export$2e2bcd8739ae039), {
                children: (0, $539f969aeabf579c$export$871de8747c9eaa88)(children, (child)=>{
                    const childProps = {
                        ...child.props
                    };
                    delete childProps.title;
                    delete childProps.disabled;
                    delete childProps.tabClassName;
                    delete childProps.tabAttrs;
                    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b38126256fab3db5$export$2e2bcd8739ae039), {
                        ...childProps
                    });
                })
            })
        ]
    });
};
$5f8ed132be8030d8$var$Tabs.displayName = 'Tabs';
var $5f8ed132be8030d8$export$2e2bcd8739ae039 = $5f8ed132be8030d8$var$Tabs;










var $kc00y = parcelRequire("kc00y");





const $be1724c94bc89867$var$MapRapportPersonnalise = ({ wkt: wkt })=>{
    const mapElement = (0, $kc00y.useRef)();
    const { map: map, workingLayer: workingLayer, availableLayers: availableLayers, addOrRemoveLayer: addOrRemoveLayer, showOutilI: showOutilI, layerListRef: layerListRef, mapToolbarRef: mapToolbarRef, projection: projection } = (0, $cdcdd8e1ff041f79$export$547f9c492d831282)({
        mapElement: mapElement,
        typeModule: (0, $a9754922f4c67d47$export$ef88b514e4bfff34).RAPPORT_PERSONNALISE,
        displayPei: false
    });
    const { toggleTool: toggleTool, activeTool: activeTool, infoOutilI: infoOutilI, handleCloseInfoI: handleCloseInfoI } = (0, $e2b798e23180fa76$export$194c7727cbdc0cac)({
        availableLayers: availableLayers,
        map: map,
        workingLayer: workingLayer,
        extraTools: {}
    });
    (0, $kc00y.useMemo)(()=>{
        if (!map || !projection || !wkt || wkt.length === 0) {
            workingLayer?.getSource()?.clear();
            return;
        }
        const wktString = "GEOMETRYCOLLECTION(" + wkt.join(",") + ")";
        (0, $1ed1be1197ad1bc4$export$3e0671d22771d76c)(map, wktString, workingLayer, projection);
    }, [
        map,
        projection,
        wkt,
        workingLayer
    ]);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
        className: "map-wrapper-rapport",
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $cdcdd8e1ff041f79$export$2e2bcd8739ae039), {
            map: map,
            showOutilI: showOutilI,
            outilI: infoOutilI,
            handleCloseInfoI: handleCloseInfoI,
            availableLayers: availableLayers,
            addOrRemoveLayer: addOrRemoveLayer,
            layerListRef: layerListRef,
            mapToolbarRef: mapToolbarRef,
            mapElement: mapElement,
            toggleTool: toggleTool,
            activeTool: activeTool
        })
    });
};
var $be1724c94bc89867$export$2e2bcd8739ae039 = $be1724c94bc89867$var$MapRapportPersonnalise;




var $kc00y = parcelRequire("kc00y");


var $kc00y = parcelRequire("kc00y");



var $kc00y = parcelRequire("kc00y");


const $7ae1fd508b5f637a$var$PageItem = /*#__PURE__*/ $kc00y.forwardRef(({ active: active = false, disabled: disabled = false, className: className, style: style, activeLabel: activeLabel = '(current)', children: children, linkStyle: linkStyle, linkClassName: linkClassName, as: as = (0, $68efbe85ab599b20$export$2e2bcd8739ae039), ...props }, ref)=>{
    const Component = active || disabled ? 'span' : as;
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("li", {
        ref: ref,
        style: style,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, 'page-item', {
            active: active,
            disabled: disabled
        }),
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)(Component, {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))('page-link', linkClassName),
            style: linkStyle,
            ...props,
            children: [
                children,
                active && activeLabel && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("span", {
                    className: "visually-hidden",
                    children: activeLabel
                })
            ]
        })
    });
});
$7ae1fd508b5f637a$var$PageItem.displayName = 'PageItem';
var $7ae1fd508b5f637a$export$2e2bcd8739ae039 = $7ae1fd508b5f637a$var$PageItem;
function $7ae1fd508b5f637a$var$createButton(name, defaultValue, label = name) {
    const Button = /*#__PURE__*/ $kc00y.forwardRef(({ children: children, ...props }, ref)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)($7ae1fd508b5f637a$var$PageItem, {
            ...props,
            ref: ref,
            children: [
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("span", {
                    "aria-hidden": "true",
                    children: children || defaultValue
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("span", {
                    className: "visually-hidden",
                    children: label
                })
            ]
        }));
    Button.displayName = name;
    return Button;
}
const $7ae1fd508b5f637a$export$b25abba66f7be210 = $7ae1fd508b5f637a$var$createButton('First', "\xab");
const $7ae1fd508b5f637a$export$1b265216817111b9 = $7ae1fd508b5f637a$var$createButton('Prev', "\u2039", 'Previous');
const $7ae1fd508b5f637a$export$1297970233533a7d = $7ae1fd508b5f637a$var$createButton('Ellipsis', "\u2026", 'More');
const $7ae1fd508b5f637a$export$b820fc49f2736e85 = $7ae1fd508b5f637a$var$createButton('Next', "\u203A");
const $7ae1fd508b5f637a$export$bed9238d8933c9a8 = $7ae1fd508b5f637a$var$createButton('Last', "\xbb");



"use client";
const $b263c33cc4622b3d$var$Pagination = /*#__PURE__*/ $kc00y.forwardRef(({ bsPrefix: bsPrefix, className: className, size: size, ...props }, ref)=>{
    const decoratedBsPrefix = (0, $6c3886f519efe212$export$7f387860ebffb32c)(bsPrefix, 'pagination');
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("ul", {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(className, decoratedBsPrefix, size && `${decoratedBsPrefix}-${size}`)
    });
});
$b263c33cc4622b3d$var$Pagination.displayName = 'Pagination';
var $b263c33cc4622b3d$export$2e2bcd8739ae039 = Object.assign($b263c33cc4622b3d$var$Pagination, {
    First: $7ae1fd508b5f637a$export$b25abba66f7be210,
    Prev: $7ae1fd508b5f637a$export$1b265216817111b9,
    Ellipsis: $7ae1fd508b5f637a$export$1297970233533a7d,
    Item: (0, $7ae1fd508b5f637a$export$2e2bcd8739ae039),
    Next: $7ae1fd508b5f637a$export$b820fc49f2736e85,
    Last: $7ae1fd508b5f637a$export$bed9238d8933c9a8
});




const $2086e6cd232611d1$var$PAGINATION_DEFAULT = (0, $f740b0d032822ba6$export$910193943608ef65).toString();
const $2086e6cd232611d1$var$PAGINATION_KEY = "itemsPerPage";
const $2086e6cd232611d1$var$PAGINATION_VALUES = (0, $f740b0d032822ba6$export$c12542e899d17513).map((data)=>{
    return {
        value: data,
        label: data
    };
});
const $2086e6cd232611d1$var$PaginationFront = ({ values: values, setOffset: setOffset, setLimit: setLimit })=>{
    const [currentPage, setCurrentPage] = (0, $kc00y.useState)(1);
    const [pageInput, setPageInput] = (0, $kc00y.useState)("1");
    const [totalPage, setTotalPage] = (0, $kc00y.useState)();
    const [itemsPerPage, setItemsPerPage] = (0, $kc00y.useState)(parseInt(localStorage.getItem($2086e6cd232611d1$var$PAGINATION_KEY) || $2086e6cd232611d1$var$PAGINATION_DEFAULT));
    (0, $kc00y.useEffect)(()=>{
        localStorage.setItem($2086e6cd232611d1$var$PAGINATION_KEY, itemsPerPage.toString());
    }, [
        itemsPerPage
    ]);
    // Fonction pour naviguer vers une page spécifique
    const goToPage = (0, $kc00y.useCallback)((page)=>{
        if (page >= 1 && page <= (totalPage || 1)) {
            setCurrentPage(page);
            setOffset((page - 1) * itemsPerPage);
            setPageInput(page.toString());
        }
    }, [
        totalPage,
        setOffset,
        itemsPerPage
    ]);
    const handleItemsPerPageChange = (0, $kc00y.useCallback)((newLimit)=>{
        setItemsPerPage(newLimit);
        setLimit?.(newLimit);
        setCurrentPage(1);
        setOffset(0);
        setPageInput("1");
    }, [
        setLimit,
        setOffset
    ]);
    const paginationItems = (0, $kc00y.useMemo)(()=>{
        const pages = [];
        const nbPage = Math.ceil((values?.length || 0) / itemsPerPage);
        setTotalPage(nbPage);
        if (nbPage <= 5) // Affiche toutes les pages si le total est <= 5
        for(let i = 1; i <= nbPage; i++)pages.push(/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b263c33cc4622b3d$export$2e2bcd8739ae039).Item, {
            active: i === currentPage,
            onClick: ()=>goToPage(i),
            children: i
        }, i));
        else {
            // Toujours afficher les premières, dernières et autour de la page actuelle
            if (currentPage !== 1) pages.push(/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b263c33cc4622b3d$export$2e2bcd8739ae039).Item, {
                active: 1 === currentPage,
                onClick: ()=>goToPage(1),
                children: "1"
            }, 1));
            if (currentPage > 3) pages.push(/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b263c33cc4622b3d$export$2e2bcd8739ae039).Ellipsis, {}));
            if (currentPage > 2) pages.push(/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b263c33cc4622b3d$export$2e2bcd8739ae039).Item, {
                active: false,
                onClick: ()=>goToPage(currentPage - 1),
                children: currentPage - 1
            }, currentPage - 1));
            pages.push(/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b263c33cc4622b3d$export$2e2bcd8739ae039).Item, {
                active: true,
                children: currentPage
            }, currentPage));
            if (currentPage < nbPage - 1) pages.push(/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b263c33cc4622b3d$export$2e2bcd8739ae039).Item, {
                active: false,
                onClick: ()=>goToPage(currentPage + 1),
                children: currentPage + 1
            }, currentPage + 1));
            if (currentPage < nbPage - 2) pages.push(/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b263c33cc4622b3d$export$2e2bcd8739ae039).Ellipsis, {}));
            if (currentPage !== nbPage) pages.push(/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b263c33cc4622b3d$export$2e2bcd8739ae039).Item, {
                active: nbPage === currentPage,
                onClick: ()=>goToPage(nbPage),
                children: nbPage
            }, nbPage));
        }
        return pages;
    }, [
        values,
        currentPage,
        goToPage,
        itemsPerPage
    ]);
    // Gérer la saisie dans le champ de page
    const handlePageInputChange = (value)=>{
        setPageInput(value);
    };
    // Gérer l'appui sur Entrée ou la perte de focus
    const handlePageInputSubmit = ()=>{
        const page = parseInt(pageInput, 10);
        if (!isNaN(page)) goToPage(page);
        else // Remettre la valeur actuelle si la saisie est invalide
        setPageInput(currentPage.toString());
    };
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
        className: "align-items-center",
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                xs: 2,
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4077d7882ac62206$export$2e2bcd8739ae039), {
                        size: "sm",
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $4077d7882ac62206$export$2e2bcd8739ae039).Text, {
                                children: "Page"
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Control, {
                                type: "text",
                                value: pageInput,
                                onChange: (e)=>handlePageInputChange(e.target.value),
                                onBlur: handlePageInputSubmit,
                                onKeyDown: (e)=>{
                                    if (e.key === "Enter") handlePageInputSubmit();
                                },
                                style: {
                                    maxWidth: "60px"
                                }
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4077d7882ac62206$export$2e2bcd8739ae039).Text, {
                                children: [
                                    "/ ",
                                    totalPage || 1
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("small", {
                        children: [
                            values?.length,
                            " r\xe9sultat(s)"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                xs: 8,
                className: "text-center",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $b263c33cc4622b3d$export$2e2bcd8739ae039), {
                    className: "my-3 d-flex justify-content-center",
                    children: [
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b263c33cc4622b3d$export$2e2bcd8739ae039).Prev, {
                            onClick: ()=>goToPage(currentPage - 1),
                            disabled: currentPage === 1
                        }),
                        paginationItems,
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b263c33cc4622b3d$export$2e2bcd8739ae039).Next, {
                            onClick: ()=>goToPage(currentPage + 1),
                            disabled: currentPage === totalPage
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                xs: 2,
                className: "text-center",
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("small", {
                        className: "mb-1",
                        children: "R\xe9sultats par page :"
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ac15ab874ad2390c$export$2e2bcd8739ae039), {
                        menuPlacement: "top",
                        value: $2086e6cd232611d1$var$PAGINATION_VALUES.find((o)=>o.value === itemsPerPage) || {
                            value: itemsPerPage,
                            label: itemsPerPage
                        },
                        options: $2086e6cd232611d1$var$PAGINATION_VALUES,
                        onChange: (opt)=>opt && handleItemsPerPageChange(opt.value),
                        isClearable: false,
                        closeMenuOnSelect: true
                    })
                ]
            })
        ]
    });
};
var $2086e6cd232611d1$export$2e2bcd8739ae039 = $2086e6cd232611d1$var$PaginationFront;









const $00daf475f54b3c5d$var$ExecuteRapportPersonnalise = ()=>{
    const { success: successToast, error: errorToast } = (0, $6bdae0bad7b05751$export$91b3d218c74c79e4)();
    const location = (0, $7a844823b04d4282$export$45d76561a5302f2b)();
    const locationState = location.state;
    // Récupérer les paramètres GET depuis l'URL
    const searchParams = new URLSearchParams(location.search);
    const urlRapportId = searchParams.get("rapportPersonnaliseId");
    const urlPeiNumeroComplet = searchParams.get("peiNumeroComplet");
    // Les paramètres URL ont la priorité sur location.state
    const selectedRapportId = urlRapportId || locationState?.rapportPersonnaliseId;
    const peiNumeroComplet = urlPeiNumeroComplet || locationState?.peiNumeroComplet;
    const { data: listeRapportPerso } = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/rapport-personnalise/list`);
    const [tableau, setTableau] = (0, $kc00y.useState)();
    const [offset, setOffset] = (0, $kc00y.useState)(0);
    const [limit, setLimit] = (0, $kc00y.useState)(Number(localStorage.getItem("itemsPerPage")) || (0, $f740b0d032822ba6$export$910193943608ef65));
    const [activeTab, setActiveTab] = (0, $kc00y.useState)("data");
    const [valuesFormik, setValuesFormik] = (0, $kc00y.useState)();
    const [isDownload, setIsDownload] = (0, $kc00y.useState)(false);
    const [listeParametres, setListeParametres] = (0, $kc00y.useState)([]);
    const [columnWidths, setColumnWidths] = (0, $kc00y.useState)({});
    const tableRef = (0, $kc00y.useRef)(null);
    const formikRef = (0, $kc00y.useRef)(null);
    const [hasAutoExecuted, setHasAutoExecuted] = (0, $kc00y.useState)(false);
    const [selectedRowIndex, setSelectedRowIndex] = (0, $kc00y.useState)(null);
    const table = tableRef.current;
    // Hook pour gérer le redimensionnement des colonnes
    (0, $kc00y.useEffect)(()=>{
        if (!tableau || !tableau.headers) return;
        let currentColumnIndex = -1;
        let startX = 0;
        let startWidth = 0;
        const handleMouseMove = (e)=>{
            e.preventDefault();
            if (currentColumnIndex === -1) return;
            const newWidth = Math.max(50, startWidth + e.clientX - startX);
            setColumnWidths((prev)=>({
                    ...prev,
                    [currentColumnIndex]: newWidth
                }));
        };
        const handleMouseUp = ()=>{
            document.removeEventListener("mousemove", handleMouseMove);
            document.removeEventListener("mouseup", handleMouseUp);
            document.body.classList.remove("resizing");
            currentColumnIndex = -1;
        };
        const handleMouseDown = (e, columnIndex)=>{
            e.preventDefault();
            e.stopPropagation();
            const th = e.target.closest("th");
            if (!th) return;
            currentColumnIndex = columnIndex;
            startX = e.clientX;
            startWidth = th.offsetWidth;
            document.addEventListener("mousemove", handleMouseMove);
            document.addEventListener("mouseup", handleMouseUp);
            document.body.classList.add("resizing");
        };
        if (table) {
            const resizers = table.querySelectorAll(".column-resizer");
            resizers.forEach((resizer, index)=>{
                const handler = (e)=>handleMouseDown(e, index);
                resizer.addEventListener("mousedown", handler);
                // Stocker le handler pour le nettoyage
                resizer._handler = handler;
            });
        }
        return ()=>{
            document.removeEventListener("mousemove", handleMouseMove);
            document.removeEventListener("mouseup", handleMouseUp);
            document.body.classList.remove("resizing");
            // Nettoyer les gestionnaires d'évènements
            if (table) {
                const resizers = table.querySelectorAll(".column-resizer");
                resizers.forEach((resizer)=>{
                    const handler = resizer._handler;
                    if (handler) resizer.removeEventListener("mousedown", handler);
                });
            }
        };
    }, [
        tableau,
        table
    ]);
    // On exécute directement le rapport si on a tous les éléments nécessaires (cas de la navigation depuis la fiche résumé)
    (0, $kc00y.useEffect)(()=>{
        if (!hasAutoExecuted && selectedRapportId && peiNumeroComplet && formikRef.current && listeParametres.length > 0) {
            formikRef.current?.submitForm();
            setHasAutoExecuted(true);
        }
    }, [
        selectedRapportId,
        peiNumeroComplet,
        hasAutoExecuted,
        listeParametres.length
    ]);
    (0, $kc00y.useEffect)(()=>{
        setSelectedRowIndex(null);
    }, [
        offset,
        limit
    ]);
    const getColumnStyle = (index)=>{
        const width = columnWidths[index];
        if (width) return {
            width: `${width}px`,
            maxWidth: `${width}px`
        };
        return undefined;
    };
    const hasManualResize = Object.keys(columnWidths).length > 0;
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        fluid: true,
        style: {
            maxWidth: "95vw"
        },
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$527d32aa1785fdd4), {}),
                title: "Ex\xe9cuter des rapports personnalis\xe9s"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        xs: "auto",
                        className: "ms-auto",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                            onClick: ()=>(0, $c066b242635c27a6$export$9cca65ea339c61b4)("/api/rapport-personnalise/export-data", JSON.stringify({
                                    rapportPersonnaliseId: valuesFormik?.rapportPersonnaliseId,
                                    listeParametre: valuesFormik?.listeParametre
                                }), "rapport-personnalise.csv", "Export termin\xe9", successToast, errorToast),
                            disabled: valuesFormik == null || tableau == null,
                            children: [
                                "Exporter les donn\xe9es ",
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$4a5ccdc9878f4668), {})
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        xs: "auto",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                            onClick: ()=>{
                                setIsDownload(true);
                                (0, $c066b242635c27a6$export$9cca65ea339c61b4)("/api/rapport-personnalise/export-shp", JSON.stringify({
                                    rapportPersonnaliseId: valuesFormik?.rapportPersonnaliseId,
                                    listeParametre: valuesFormik?.listeParametre
                                }), "rapport-personnalise.zip", "", ()=>{
                                    setIsDownload(false);
                                    successToast("Export termin\xe9");
                                }, ()=>{
                                    setIsDownload(false);
                                    return errorToast("Erreur lors de l'export");
                                });
                            },
                            disabled: valuesFormik == null || tableau == null || tableau?.geometries == null || tableau.geometries.length === 0 || isDownload,
                            children: [
                                "Exporter les donn\xe9es carto ",
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$4a5ccdc9878f4668), {})
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        xs: 12,
                        lg: 3,
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                            innerRef: formikRef,
                            initialValues: $00daf475f54b3c5d$export$a5cab80145b70e98(selectedRapportId, peiNumeroComplet),
                            validationSchema: $00daf475f54b3c5d$export$c084437b5e3206cd,
                            isPost: false,
                            successToastMessage: "La requ\xeate a bien \xe9t\xe9 ex\xe9cut\xe9e",
                            submitUrl: `/api/rapport-personnalise/generer`,
                            prepareVariables: (values)=>{
                                const value = $00daf475f54b3c5d$export$f97400759cfd946(values, listeParametres);
                                setValuesFormik(value);
                                return value;
                            },
                            onSubmit: (e)=>{
                                setTableau(e);
                                setActiveTab("data");
                                // Réinitialiser les largeurs de colonnes pour le nouveau tableau
                                setColumnWidths({});
                                setSelectedRowIndex(null);
                                setOffset(0);
                            },
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $3dfd663e22480fb2$export$2e2bcd8739ae039), {
                                listeIdLibelleDescription: listeRapportPerso,
                                contexteLibelle: "Rapport personnalis\xe9",
                                url: "/api/rapport-personnalise/parametres/",
                                onParametresChange: setListeParametres,
                                visibleMap: tableau?.geometries != null && tableau.geometries.length !== 0
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        xs: 12,
                        lg: 9,
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $5f8ed132be8030d8$export$2e2bcd8739ae039), {
                            activeKey: activeTab,
                            onSelect: (k)=>k && setActiveTab(k),
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec8c33620b91a894$export$2e2bcd8739ae039), {
                                    eventKey: "data",
                                    title: "Donn\xe9es",
                                    children: tableau === null ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                        className: "m-3 text-center",
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                            className: "text-center",
                                            children: "Aucune donn\xe9e \xe0 afficher"
                                        })
                                    }) : /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                                className: "rapport-table-scroll",
                                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $13de46b4dfcc473f$export$2e2bcd8739ae039), {
                                                    bordered: true,
                                                    striped: true,
                                                    ref: tableRef,
                                                    className: `resizable-table ${hasManualResize ? "manual" : "auto"}`,
                                                    children: [
                                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("thead", {
                                                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("tr", {
                                                                children: tableau?.headers?.map((e, index)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("th", {
                                                                        style: getColumnStyle(index),
                                                                        title: e,
                                                                        children: [
                                                                            e,
                                                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                                                                className: "column-resizer"
                                                                            })
                                                                        ]
                                                                    }, index))
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("tbody", {
                                                            children: tableau?.values?.slice(offset, offset + limit)?.map((ligne, index)=>{
                                                                const rowIndex = offset + index;
                                                                return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("tr", {
                                                                    className: `fw-normal ${selectedRowIndex === rowIndex ? "selected-row" : ""}`,
                                                                    onClick: ()=>setSelectedRowIndex(rowIndex),
                                                                    children: ligne.map((e, key)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("td", {
                                                                            style: getColumnStyle(key),
                                                                            title: e?.toString(),
                                                                            children: e?.toString()
                                                                        }, key))
                                                                }, index);
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            tableau?.values && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2086e6cd232611d1$export$2e2bcd8739ae039), {
                                                values: tableau?.values,
                                                setOffset: setOffset,
                                                setLimit: setLimit
                                            }, tableau?.values?.length)
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec8c33620b91a894$export$2e2bcd8739ae039), {
                                    eventKey: "map",
                                    title: "Carte",
                                    disabled: tableau?.geometries == null || tableau.geometries.length === 0,
                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $be1724c94bc89867$export$2e2bcd8739ae039), {
                                        wkt: tableau?.geometries || []
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
const $00daf475f54b3c5d$export$a5cab80145b70e98 = (selectedRapportId, peiNumeroComplet)=>({
        dynamicFormId: selectedRapportId || null,
        PEI_NUMERO_COMPLET: peiNumeroComplet || null
    });
const $00daf475f54b3c5d$export$c084437b5e3206cd = (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({
    dynamicFormId: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba)
});
const $00daf475f54b3c5d$export$f97400759cfd946 = (values, listeParametres)=>{
    // Créer la liste complète des paramètres avec toutes les valeurs (valeur par défaut si non spécifiées)
    const listeParametre = listeParametres.map((param)=>{
        const code = param.dynamicFormParametreCode;
        // Récupérer la valeur depuis les values, ou la valeur par défaut si non définie/vide
        const value = values[code] !== undefined && values[code] !== "" && values[code] !== null ? values[code] : param.dynamicFormParametreValeurDefaut ?? null;
        return {
            rapportPersonnaliseParametreCode: code,
            value: value
        };
    });
    return {
        rapportPersonnaliseId: values.dynamicFormId,
        listeParametre: listeParametre
    };
};
var $00daf475f54b3c5d$export$2e2bcd8739ae039 = $00daf475f54b3c5d$var$ExecuteRapportPersonnalise;


const $4485bb756c9cef26$var$ExecuteCriseRapportPersonnalise = ({ onGeometrySelect: onGeometrySelect, geometry: geometry })=>{
    const { data: criseReports } = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/crise/rapports-personnalises`);
    const { success: successToast, error: errorToast } = (0, $6bdae0bad7b05751$export$91b3d218c74c79e4)();
    const [valuesFormik, setValuesFormik] = (0, $kc00y.useState)();
    const [listeParametres, setListeParametres] = (0, $kc00y.useState)([]);
    const [tableau, setTableau] = (0, $kc00y.useState)({
        headers: [],
        values: [],
        geometries: []
    });
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$9963061ea3f5d8da), {}),
                title: "Rapport personnalis\xe9",
                displayReturnButton: false
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                initialValues: (0, $00daf475f54b3c5d$export$a5cab80145b70e98)(),
                validationSchema: (0, $00daf475f54b3c5d$export$c084437b5e3206cd),
                isPost: false,
                successToastMessage: "La requ\xeate a bien \xe9t\xe9 ex\xe9cut\xe9e",
                submitUrl: `/api/rapport-personnalise/generer`,
                prepareVariables: (values)=>{
                    const finalValues = (0, $00daf475f54b3c5d$export$f97400759cfd946)(values, listeParametres);
                    // Transformer la géométrie en paramètres
                    if (geometry && Object.keys(geometry).length > 0) Object.entries(geometry).forEach(([key, value])=>{
                        // Chercher si ce paramètre existe déjà
                        const existingIndex = finalValues.listeParametre.findIndex((p)=>p.rapportPersonnaliseParametreCode === key);
                        if (existingIndex !== -1) // Remplacer la valeur existante
                        finalValues.listeParametre[existingIndex].value = value;
                        else // Ajouter le nouveau paramètre
                        finalValues.listeParametre.push({
                            rapportPersonnaliseParametreCode: key,
                            value: value
                        });
                    });
                    setValuesFormik(finalValues);
                    return finalValues;
                },
                onSubmit: (e)=>{
                    setTableau(e);
                },
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $3dfd663e22480fb2$export$2e2bcd8739ae039), {
                    listeIdLibelleDescription: criseReports,
                    contexteLibelle: "Executer un rapport personnalis\xe9",
                    url: "/api/rapport-personnalise/parametres/",
                    onParametresChange: setListeParametres,
                    onGeometrySelect: onGeometrySelect
                })
            }),
            tableau && tableau.headers.length > 0 && tableau.values.length > 0 ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                        onClick: ()=>(0, $c066b242635c27a6$export$9cca65ea339c61b4)("/api/rapport-personnalise/export-data", JSON.stringify({
                                rapportPersonnaliseId: valuesFormik?.rapportPersonnaliseId,
                                listeParametre: valuesFormik?.listeParametre
                            }), "rapport-personnalise.csv", "Export termin\xe9", successToast, errorToast),
                        children: [
                            "Exporter les donn\xe9es",
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$4a5ccdc9878f4668), {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $13de46b4dfcc473f$export$2e2bcd8739ae039), {
                        bordered: true,
                        striped: true,
                        className: "resizable-table",
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("thead", {
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("tr", {
                                    children: tableau?.headers?.map((e, index)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("th", {
                                            title: e,
                                            children: [
                                                e,
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                                    className: "column-resizer"
                                                })
                                            ]
                                        }, index))
                                })
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("tbody", {
                                children: tableau?.values?.map((ligne, index)=>{
                                    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("tr", {
                                        className: "fw-normal",
                                        children: ligne.map((e, key)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("td", {
                                                title: e?.toString(),
                                                children: e?.toString()
                                            }, key))
                                    }, index);
                                })
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("p", {
                children: "Aucun r\xe9sultat"
            }) // Message lorsque tableau est vide
        ]
    });
};
var $4485bb756c9cef26$export$2e2bcd8739ae039 = $4485bb756c9cef26$var$ExecuteCriseRapportPersonnalise;











const $2350e70239c6d180$var$CreateEvenement = ({ criseId: criseId, state: state, evenementSousCategorieId: evenementSousCategorieId, geometrieEvenement: geometrieEvenement, onSubmit: onSubmit })=>{
    const { user: user } = (0, $e787cde576104469$export$fdc397e486fa83e7)();
    const sousCategoriesEvenement = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/crise/evenement/get-evenement-sous-categorie${evenementSousCategorieId ? `?evenementSousCategorieId=${evenementSousCategorieId}` : ""}`)?.data;
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$16ae26c700600e84), {}),
                title: "Nouvel \xe9v\xe8nement",
                displayReturnButton: false
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                initialValues: (0, $2764f711dbde8826$export$a5cab80145b70e98)(null, geometrieEvenement, evenementSousCategorieId, sousCategoriesEvenement),
                validationSchema: (0, $2764f711dbde8826$export$c084437b5e3206cd),
                isPost: true,
                isMultipartFormData: true,
                submitUrl: `/api/crise/${criseId}/evenement/${state}/create`,
                prepareVariables: (values)=>(0, $2764f711dbde8826$export$f97400759cfd946)(values, null, user.utilisateurId),
                onSubmit: onSubmit,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2764f711dbde8826$export$2e2bcd8739ae039), {
                    isReadOnly: false,
                    sousCategoriesEvenement: sousCategoriesEvenement
                })
            })
        ]
    });
};
var $2350e70239c6d180$export$2e2bcd8739ae039 = $2350e70239c6d180$var$CreateEvenement;










var $kc00y = parcelRequire("kc00y");











/**
 * Permet d'afficher un message
 */ function $8dce4ffbe87d1a32$var$capitalizeFirstLetter(str) {
    if (!str || str.length === 0) return str;
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}
const $8dce4ffbe87d1a32$var$MessageElement = ({ message: message })=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1988c313b8430f65$export$2e2bcd8739ae039), {
        bg: "light",
        style: {
            width: "18rem"
        },
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1988c313b8430f65$export$2e2bcd8739ae039).Body, {
            children: [
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1988c313b8430f65$export$2e2bcd8739ae039).Title, {
                    children: message.messageObjet
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1988c313b8430f65$export$2e2bcd8739ae039).Text, {
                    children: [
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("b", {
                            children: "Auteur."
                        }),
                        " ",
                        $8dce4ffbe87d1a32$var$capitalizeFirstLetter(message.messageUtilisateur),
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("b", {
                            children: "Date."
                        }),
                        " ",
                        (0, $00c47c7740afd024$export$2e2bcd8739ae039)(message.messageDateConstat),
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("b", {
                            children: "Desc."
                        }),
                        " ",
                        message.messageDescription
                    ]
                })
            ]
        })
    });
};
var $8dce4ffbe87d1a32$export$2e2bcd8739ae039 = $8dce4ffbe87d1a32$var$MessageElement;












const $650f4e884874d2db$export$afec914d7f5e798 = ({ name: name, min: min, max: max, step: step, onChange: onChangeCallback, required: required = false, disabled: disabled = false })=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $fb281c3c0e7b8a11$export$2e2bcd8739ae039), {
        required: required,
        id: name,
        name: name,
        min: min,
        max: max,
        step: step,
        disabled: disabled,
        onChange: (data)=>{
            onChangeCallback({
                name: name,
                value: data.currentTarget.value
            });
        }
    });
};
var $650f4e884874d2db$export$2e2bcd8739ae039 = $650f4e884874d2db$export$afec914d7f5e798;




var $b78b9de907ad9f43$export$5ba8f899d3c4b6d4 = /*#__PURE__*/ function(DATE_FILTER) {
    DATE_FILTER["EN_COURS"] = "En cours";
    DATE_FILTER["CLOS"] = "Clos";
    return DATE_FILTER;
}({});
var $b78b9de907ad9f43$export$5616e71b17d01376 = /*#__PURE__*/ function(LAST_MESSAGE_FILTER) {
    LAST_MESSAGE_FILTER["DIX_MINUTES"] = "inf\xe9rieur \xe0 10 minutes";
    LAST_MESSAGE_FILTER["TRENTE_MINUTES"] = "inf\xe9rieur \xe0 30 minutes";
    LAST_MESSAGE_FILTER["UNE_HEURE"] = "inf\xe9rieur \xe0 1 heure";
    LAST_MESSAGE_FILTER["VINGT_QUATRE_HEURES"] = "inf\xe9rieur \xe0 24 heures";
    return LAST_MESSAGE_FILTER;
}({});
var $b78b9de907ad9f43$export$2e2bcd8739ae039 = $b78b9de907ad9f43$export$5ba8f899d3c4b6d4;



const $fe48274aaa49ba54$var$FilterEvent = ({ criseId: criseId, setSearchParam: setSearchParam, run: run, statut: statut })=>{
    const typeCriseState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/crise/${criseId}/get-type-event-from-crise/${statut}`)?.data?.[0];
    const setValue = (name, value)=>{
        setSearchParam((previous)=>({
                ...previous || {},
                [name]: value === "0" || value === "" || value === "[]" ? undefined : value
            }));
    };
    const allTags = typeCriseState?.evenement?.flatMap((event)=>{
        return event.evenementTags?.map((tagName)=>tagName.trim()) || [];
    }) || [];
    const uniqueTags = [];
    allTags.filter((tagName)=>tagName !== "").forEach((tagName)=>{
        const isDuplicate = uniqueTags.some((tag)=>tag.libelle === tagName);
        if (!isDuplicate) uniqueTags.push({
            id: tagName,
            libelle: tagName
        });
    });
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f76670b5e5897c33), {
                title: "Filtrer les \xe9v\xe8nements",
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("p", {
                                children: "Type d'\xe9v\xe8nement"
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $cc7cbb0460865818$export$2e2bcd8739ae039), {
                                name: "listTypeEvent",
                                listIdCodeLibelle: typeCriseState?.typeEvenement,
                                onChange: (e)=>setValue("filterType", e.value.length > 0 ? e.value : null)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("p", {
                                        children: "Auteur"
                                    }),
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $cc7cbb0460865818$export$2e2bcd8739ae039), {
                                        name: "listAuteur",
                                        listIdCodeLibelle: typeCriseState?.utilisateur,
                                        onChange: (e)=>setValue("filterAuthor", e.value.length > 0 ? e.value : null)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("p", {
                                        children: "Tags"
                                    }),
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $cc7cbb0460865818$export$2e2bcd8739ae039), {
                                        name: "filterTag",
                                        listIdCodeLibelle: uniqueTags,
                                        onChange: (e)=>setValue("filterTag", e.value.length > 0 ? e.value : null)
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("p", {
                                        children: "Dernier message"
                                    }),
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eed37ff3d3e1f28c$export$2e2bcd8739ae039), {
                                        options: (0, $b78b9de907ad9f43$export$5616e71b17d01376),
                                        name: "dernierMessage",
                                        onChange: (e)=>setValue("filterMessage", e.value)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("p", {
                                        children: "Importance"
                                    }),
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $650f4e884874d2db$export$2e2bcd8739ae039), {
                                        step: 1,
                                        min: 0,
                                        name: "evenementImportance",
                                        max: 5,
                                        required: false,
                                        onChange: (e)=>setValue("filterImportance", e.value)
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("p", {
                                        children: "Statut"
                                    }),
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eed37ff3d3e1f28c$export$2e2bcd8739ae039), {
                                        options: (0, $b78b9de907ad9f43$export$2e2bcd8739ae039),
                                        name: "statut",
                                        onChange: (e)=>setValue("filterStatut", e.value)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                className: "text-center",
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                                    className: "mt-4",
                                    onClick: ()=>run(),
                                    children: "Rechercher"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {})
        ]
    });
};
var $fe48274aaa49ba54$export$2e2bcd8739ae039 = $fe48274aaa49ba54$var$FilterEvent;




var $bkJfK = parcelRequire("bkJfK");






const $91931cfb9956bbfc$export$26e4c24862284a9b = (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({
    messageObjet: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
    messageDescription: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
    messageDateConstat: (0, $36ceaed6faf947af$export$5cbf64e9c4f743ca)
});
const $91931cfb9956bbfc$export$a04a503d8277ee43 = (values, utilisateurId)=>({
        messageUtilisateurId: utilisateurId,
        messageDateConstat: (0, $00c47c7740afd024$export$cc23f907e4acb548)(new Date()),
        messageImportance: 3,
        messageTags: []
    });
const $91931cfb9956bbfc$export$20e1dd96b1411278 = (values)=>({
        messageObjet: values.messageObjet,
        messageDescription: values.messageDescription,
        messageDateConstat: new Date(values.messageDateConstat).toISOString(),
        messageImportance: values.messageImportance,
        messageOrigine: values.messageOrigine,
        messageTags: values.messageTags.join(", "),
        messageUtilisateurId: values.messageUtilisateurId
    });
const $91931cfb9956bbfc$var$MessageForm = ()=>{
    const { setFieldValue: setFieldValue } = (0, $bkJfK.useFormikContext)();
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f76670b5e5897c33), {
            title: "Nouveau message",
            children: [
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                            label: "Objet",
                            name: "messageObjet",
                            required: true
                        })
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$ce9b1cc0c34506d0), {
                            label: "Description",
                            name: "messageDescription",
                            required: true
                        })
                    })
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$183478aa40b5df1), {
                                label: "Date de constat",
                                name: "messageDateConstat",
                                required: true
                            })
                        }),
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$f5603a09670563b9), {
                                step: 1,
                                min: 0,
                                name: "messageImportance",
                                label: "Importance",
                                max: 5
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                                label: "Origine",
                                name: "messageOrigine",
                                required: true
                            })
                        }),
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $08d896774a042b59$export$2e2bcd8739ae039), {
                                onTagsChange: (tags)=>setFieldValue("messageTags", tags),
                                name: "messageTags",
                                label: "Liste des tags"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var $91931cfb9956bbfc$export$2e2bcd8739ae039 = $91931cfb9956bbfc$var$MessageForm;


var $2b93ad108dbbb375$var$EvenementStatutEnum = /*#__PURE__*/ function(EvenementStatutEnum) {
    EvenementStatutEnum["CLOS"] = "Clos";
    EvenementStatutEnum["EN_COURS"] = "En cours";
    return EvenementStatutEnum;
}($2b93ad108dbbb375$var$EvenementStatutEnum || {});
const $2b93ad108dbbb375$var$ListEvenement = ({ criseId: criseId, map: map, evenementStatutMode: evenementStatutMode, onEvenementIdsFiltresChange: onEvenementIdsFiltresChange })=>{
    const [params, setSearchParam] = (0, $kc00y.useState)({});
    const [buttonClicked, setButtonClick] = (0, $kc00y.useState)(false);
    const { data: data, run: run } = (0, $8d9ebd8892d8a5f5$export$6326fb4463ae1be4)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/crise/${criseId}/evenement/${evenementStatutMode}/?${params}`, {});
    (0, $kc00y.useEffect)(()=>{
        if (!data) run();
    }, [
        data,
        run
    ]);
    // On récupère les id des évènements pour les passer à la carte et donc pouvoir passer le filtre à la couche
    (0, $kc00y.useEffect)(()=>{
        if (onEvenementIdsFiltresChange && data) {
            const uuids = data.map((e)=>e.evenementId);
            onEvenementIdsFiltresChange(uuids);
        }
    }, [
        data,
        onEvenementIdsFiltresChange
    ]);
    const { user: user } = (0, $e787cde576104469$export$fdc397e486fa83e7)();
    const { visible: visible, show: show, close: close } = (0, $ca8671088139af49$export$2e2bcd8739ae039)();
    const [evenementId, setEvenementId] = (0, $kc00y.useState)();
    const tableau = [];
    const listMessage = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/crise/evenement/message`);
    const { activesKeys: activesKeys, handleShowClose: handleShowClose } = (0, $db860d90b4a42fea$export$dae930a4ba30758b)(Array(6).fill(false));
    const showEventLocation = (eventId)=>{
        for(let i = 0; i < data?.length; i++){
            const eventGeometry = data?.[i].evenementGeometrie;
            if (eventGeometry && data?.[i].evenementId === eventId) {
                const tabGeom = eventGeometry.split(";");
                const geom = new (0, $15a985d09649bdc2$export$2e2bcd8739ae039)().readFeature(tabGeom.pop());
                (0, $1ed1be1197ad1bc4$export$856bbc3500e88ad3)(geom.get("geometry").getExtent(), map, tabGeom[0].split("=").pop());
            }
        }
    };
    data?.map((e)=>{
        const eventMessages = listMessage?.data?.filter((message)=>message.messageEvenementId === e.evenementId);
        tableau.push({
            header: (0, $c066b242635c27a6$export$b139bd30bc162c86)(e.evenementLibelle, 35),
            content: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                children: [
                    (0, $e3b8d60f4bb99483$export$4f612ab7b7b1d133)(user, [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).CRISE_C,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).CRISE_U
                    ]) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                        style: {
                            marginBottom: "10px",
                            marginRight: "15px"
                        },
                        onClick: ()=>{
                            setEvenementId(e.evenementId);
                            show();
                        },
                        children: "Nouveau message"
                    }),
                    e.evenementGeometrie && e.evenementStatut !== "Clos" && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))("mb-1"),
                        onClick: ()=>{
                            showEventLocation(e.evenementId);
                        },
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$cbe811cb8e919f27), {})
                    }),
                    eventMessages?.map((message, index)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8dce4ffbe87d1a32$export$2e2bcd8739ae039), {
                                message: message
                            })
                        }, index))
                ]
            })
        });
    });
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                style: {
                    marginBottom: "10px"
                },
                onClick: ()=>{
                    setButtonClick(!buttonClicked);
                },
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$625671e92c10ce58), {})
            }),
            buttonClicked && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $fe48274aaa49ba54$export$2e2bcd8739ae039), {
                statut: evenementStatutMode,
                setSearchParam: setSearchParam,
                run: run,
                criseId: criseId
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db860d90b4a42fea$export$2e2bcd8739ae039), {
                activesKeys: activesKeys,
                list: tableau,
                handleShowClose: handleShowClose
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $c738870e8199ea0b$export$2e2bcd8739ae039), {
                closeModal: close,
                canModify: true,
                query: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/crise/evenement/${evenementId}/message/create`,
                submitLabel: "Valider",
                visible: visible,
                header: null,
                validationSchema: (0, $91931cfb9956bbfc$export$26e4c24862284a9b),
                onSubmit: ()=>{
                    listMessage.reload();
                },
                prepareVariables: (values)=>(0, $91931cfb9956bbfc$export$20e1dd96b1411278)(values),
                getInitialValues: (values)=>(0, $91931cfb9956bbfc$export$a04a503d8277ee43)(values, user.utilisateurId),
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $91931cfb9956bbfc$export$2e2bcd8739ae039), {})
            })
        ]
    });
};
var $2b93ad108dbbb375$export$2e2bcd8739ae039 = $2b93ad108dbbb375$var$ListEvenement;


const $f74ed971711305fd$var$CreateListEvenement = ({ criseIdentifiant: criseIdentifiant, mapType: mapType, evenementStatutMode: evenementStatutMode, onEvenementIdsFiltresChange: onEvenementIdsFiltresChange })=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$527d32aa1785fdd4), {}),
                title: "Liste des \xe9v\xe8nements",
                displayReturnButton: false
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2b93ad108dbbb375$export$2e2bcd8739ae039), {
                criseId: criseIdentifiant,
                map: mapType,
                evenementStatutMode: evenementStatutMode,
                onEvenementIdsFiltresChange: onEvenementIdsFiltresChange
            })
        ]
    });
};
var $f74ed971711305fd$export$2e2bcd8739ae039 = $f74ed971711305fd$var$CreateListEvenement;













const $468cb52a95264278$var$drawStyle = new (0, $a5fc261473972d1d$export$2e2bcd8739ae039)({
    fill: new (0, $8624b871a0af6dab$export$2e2bcd8739ae039)({
        color: "rgba(255, 255, 255, 0.2)"
    }),
    stroke: new (0, $281691897fddf9d0$export$2e2bcd8739ae039)({
        color: "rgba(0, 0, 0, 0.5)",
        width: 2
    }),
    image: new (0, $f060542c6e9f52e6$export$2e2bcd8739ae039)({
        radius: 5,
        stroke: new (0, $281691897fddf9d0$export$2e2bcd8739ae039)({
            color: "rgba(0, 0, 0, 0.7)"
        }),
        fill: new (0, $8624b871a0af6dab$export$2e2bcd8739ae039)({
            color: "rgba(255, 255, 255, 0.2)"
        })
    })
});
const $468cb52a95264278$export$393aec6287785336 = ({ map: map, workingLayer: workingLayer, dataEvenementLayer: dataEvenementLayer })=>{
    const [showCreateEvent, setShowCreateEvent] = (0, $kc00y.useState)(false);
    const [showListEvent, setShowListEvent] = (0, $kc00y.useState)(false);
    const [showListDocument, setShowListDocument] = (0, $kc00y.useState)(false);
    const { success: successToast, error: errorToast } = (0, $6bdae0bad7b05751$export$91b3d218c74c79e4)();
    const [showPersonalReports, setShowPersonalReports] = (0, $kc00y.useState)(false);
    const [geometryReportCode, setGeometryReportCode] = (0, $kc00y.useState)("");
    const handleCloseEvent = ()=>{
        setShowListDocument(false);
        setShowListEvent(false);
        setShowCreateEvent(false);
        setShowPersonalReports(false);
        workingLayer.getSource().clear();
        workingLayer.getSource().refresh();
        setGeometryElement(null);
    };
    const [showTracee, setShowTracee] = (0, $kc00y.useState)(false);
    const handleCloseTracee = ()=>setShowTracee(false);
    const [listeEventId] = (0, $kc00y.useState)([]);
    const [sousTypeElement, setSousTypeElement] = (0, $kc00y.useState)(null);
    const [geometryElement, setGeometryElement] = (0, $kc00y.useState)(null);
    const [reportGeometryElement, setReportGeometryElement] = (0, $kc00y.useState)({});
    const [wkt, setWkt] = (0, $kc00y.useState)(null); // état pour le wkt
    (0, $kc00y.useEffect)(()=>{
        if (geometryReportCode && wkt) setReportGeometryElement((prev)=>{
            return {
                ...prev ?? {},
                [geometryReportCode]: wkt
            };
        });
    }, [
        geometryReportCode,
        wkt
    ]);
    const tools = (0, $kc00y.useMemo)(()=>{
        if (!map) return {};
        /**
     * Fonction pour modifier la géométrie d'un évènement sur la carte
     */ const moveCtrl = new (0, $2375ecf9b29b2a49$export$2e2bcd8739ae039)({
            source: dataEvenementLayer.getSource()
        });
        moveCtrl.on("modifyend", (event)=>{
            if (!event.features || event.features.getLength() !== 1) {
                dataEvenementLayer.getSource().clear();
                dataEvenementLayer.getSource().refresh();
                (0, $1ed1be1197ad1bc4$export$51ba454167fb25ab)(map);
                return;
            }
            event.features.forEach(async (feature)=>{
                (await fetch((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/zone-integration/check`, (0, $fbd4d34e07af0ac7$export$b163ec2f884327db)({
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        geometry: "SRID=" + map.getView().getProjection().getCode().split(":").pop() + ";" + new (0, $15a985d09649bdc2$export$2e2bcd8739ae039)().writeFeature(feature)
                    })
                }))).text().then((text)=>{
                    if (text === "true") fetch((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/crise/${feature.getProperties().elementId}/geometry`, (0, $fbd4d34e07af0ac7$export$b163ec2f884327db)({
                        method: "PATCH",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify({
                            eventId: feature.getProperties().elementId,
                            eventGeometrie: `SRID=${map.getView().getProjection().getCode().split(":").pop()};${new (0, $15a985d09649bdc2$export$2e2bcd8739ae039)().writeFeature(feature)}`
                        })
                    })).then((res)=>{
                        if (res.status === 200) successToast("G\xe9om\xe9trie modifi\xe9e");
                    });
                    else {
                        dataEvenementLayer.getSource().clear();
                        dataEvenementLayer.getSource().refresh();
                        errorToast(text);
                    }
                }).catch((reason)=>{
                    dataEvenementLayer.getSource().clear();
                    dataEvenementLayer.getSource().refresh();
                    errorToast(reason);
                });
            });
            (0, $1ed1be1197ad1bc4$export$51ba454167fb25ab)(map);
        });
        /**
     * Fonction pour dessiner des types de géométries
     */ function createDrawInteraction(geometryType, isReport = false) {
            const drawCtrl = new (0, $2ef894158a48397d$export$2e2bcd8739ae039)({
                source: workingLayer.getSource(),
                type: geometryType,
                style: (feature)=>{
                    const featureType = feature.getGeometry()?.getType();
                    if (featureType === geometryType) return $468cb52a95264278$var$drawStyle;
                }
            });
            drawCtrl.on("drawend", async (event)=>{
                const wkt = `SRID=${map.getView().getProjection().getCode().split(":").pop()};${new (0, $15a985d09649bdc2$export$2e2bcd8739ae039)().writeFeature(event.feature)}`;
                setGeometryElement(wkt);
                setWkt(wkt);
                if (!isReport) setShowCreateEvent(true);
            });
            drawCtrl.on("drawstart", async ()=>{
                // Avant de redessiner un point, on supprime les autres points
                if (!isReport) workingLayer.getSource().clear();
            });
            return drawCtrl;
        }
        /**
     * Fonction pour activer ou désactiver une interaction
     */ function toggleInteraction(active = false, draw) {
            const idx = map?.getInteractions().getArray().indexOf(draw);
            if (active) {
                if (idx === -1) map.addInteraction(draw);
                if (draw instanceof (0, $2375ecf9b29b2a49$export$2e2bcd8739ae039)) (0, $1ed1be1197ad1bc4$export$7c332a2c034a88e4)(map);
            } else if (!active && idx !== -1) map.removeInteraction(draw);
        }
        function toggleReportInteraction(active = false, draw) {
            const idx = map?.getInteractions().getArray().indexOf(draw);
            if (active) {
                if (idx === -1) map.addInteraction(draw);
                if (draw instanceof (0, $2375ecf9b29b2a49$export$2e2bcd8739ae039)) (0, $1ed1be1197ad1bc4$export$7c332a2c034a88e4)(map);
            }
        }
        const drawPoint = createDrawInteraction("Point");
        const drawPolygon = createDrawInteraction("Polygon"); // remplit
        const drawLineString = createDrawInteraction("LineString");
        const drawReportPoint = createDrawInteraction("Point", true);
        const drawReportPolygon = createDrawInteraction("Polygon", true);
        const drawReportLineString = createDrawInteraction("LineString", true);
        function toggleCreateReportPoint(active = false) {
            toggleReportInteraction(active, drawReportPoint);
        }
        function toggleCreateReportPolygon(active = false) {
            toggleReportInteraction(active, drawReportPolygon);
        }
        function toggleCreateReportLinestring(active = false) {
            toggleReportInteraction(active, drawReportLineString);
        }
        /**
     * Permet de dessiner un point pour la création des évènements
     */ function toggleCreatePointEvenement(active = false) {
            toggleInteraction(active, drawPoint);
        }
        /**
     * Permet de dessiner un Polygon pour la création des évènements
     */ function toggleCreatePolygonEvenement(active = false) {
            toggleInteraction(active, drawPolygon);
        }
        /**
     * Permet de dessiner une linestring pour la création des évènements
     */ function toggleCreateLinestringEvenement(active = false) {
            toggleInteraction(active, drawLineString);
        }
        function toggleMoveEvent(active = false) {
            const idx = map?.getInteractions().getArray().indexOf(moveCtrl);
            if (active) // Délai pour synchroniser l'interaction avec les features chargées sur la carte, afin d'éviter des bugs d'interaction
            setTimeout(()=>{
                if (idx === -1) map.addInteraction(moveCtrl);
                (0, $1ed1be1197ad1bc4$export$7c332a2c034a88e4)(map);
            });
            else if (!active && idx !== -1) map.removeInteraction(moveCtrl);
        }
        const tools = {
            "create-report-point": {
                action: toggleCreateReportPoint
            },
            "create-report-polygon": {
                action: toggleCreateReportPolygon
            },
            "create-report-linestring": {
                action: toggleCreateReportLinestring
            },
            "create-point": {
                action: toggleCreatePointEvenement
            },
            "create-polygon": {
                action: toggleCreatePolygonEvenement
            },
            "create-linestring": {
                action: toggleCreateLinestringEvenement
            },
            "move-event": {
                action: toggleMoveEvent
            }
        };
        return tools;
    }, [
        dataEvenementLayer,
        errorToast,
        map,
        successToast,
        workingLayer
    ]);
    return {
        tools: tools,
        handleCloseEvent: handleCloseEvent,
        showCreateEvent: showCreateEvent,
        showListEvent: showListEvent,
        showListDocument: showListDocument,
        setShowListDocument: setShowListDocument,
        setShowListEvent: setShowListEvent,
        setShowCreateEvent: setShowCreateEvent,
        handleCloseTracee: handleCloseTracee,
        showTracee: showTracee,
        geometryElement: geometryElement,
        reportGeometryElement: reportGeometryElement,
        listeEventId: listeEventId,
        setSousTypeElement: setSousTypeElement,
        sousTypeElement: sousTypeElement,
        showPersonalReports: showPersonalReports,
        setShowPersonalReports: setShowPersonalReports,
        setGeometryReportCode: setGeometryReportCode
    };
};
const $468cb52a95264278$var$MapToolbarCrise = /*#__PURE__*/ (0, $kc00y.forwardRef)(({ map: map, evenementStatutMode: evenementStatutMode, criseId: criseId, geometryElement: geometryElement, reportGeometryElement: reportGeometryElement, handleCloseEvent: handleCloseEvent, showCreateEvent: showCreateEvent, showListEvent: showListEvent, dataCriseLayer: dataCriseLayer, showListDocument: showListDocument, toggleTool: toggleToolCallback, activeTool: activeTool, setSousTypeElement: setSousTypeElement, setShowListDocument: setShowListDocument, setShowListEvent: setShowListEvent, setShowCreateEvent: setShowCreateEvent, setShowPersonalReports: setShowPersonalReports, setGeometryReportCode: setGeometryReportCode, showPersonalReports: showPersonalReports, variant: variant = "primary", onEvenementIdsFiltresChange: onEvenementIdsFiltresChange })=>{
    const { user: user } = (0, $e787cde576104469$export$fdc397e486fa83e7)();
    const { visible: visible, show: show, close: close } = (0, $ca8671088139af49$export$2e2bcd8739ae039)();
    const getMapGeometry = ()=>{
        return `SRID=${map.getView().getProjection().getCode().split(":").pop()};` + new (0, $15a985d09649bdc2$export$2e2bcd8739ae039)().writeGeometry((0, $52cb54ac72de6b07$export$c16b671815801c75)(map.getView().calculateExtent()));
    };
    const captureMap = ()=>{
        map.updateSize();
        const canvas = document.createElement("canvas");
        const size = map.getSize();
        canvas.width = size[0];
        canvas.height = size[1];
        const ctx = canvas.getContext("2d");
        document.querySelectorAll(".ol-layer canvas").forEach((c)=>{
            if (c.width > 0) {
                ctx.globalAlpha = parseFloat(c.parentElement?.style.opacity || "1");
                ctx.drawImage(c, 0, 0, canvas.width, canvas.height);
            }
        });
        // Convertir le canvas en Blob (image PNG)
        const dataURL = canvas.toDataURL("image/png");
        const byteString = atob(dataURL.split(",")[1]); // Décoder base64
        const mimeString = dataURL.split(",")[0].split(":")[1].split(";")[0];
        const listBits = new Uint8Array(byteString.length);
        for(let i = 0; i < byteString.length; i++)listBits[i] = byteString.charCodeAt(i);
        const blob = new Blob([
            listBits
        ], {
            type: mimeString
        });
        return new File([
            blob
        ], "capture.png", {
            type: "image/png"
        });
    };
    const [evenementSousCategorieId, setEvenementSousCategorieId] = (0, $kc00y.useState)(undefined);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                xs: "auto",
                children: [
                    (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).CRISE_C) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $f2eef644ac9323e0$export$2e2bcd8739ae039), {
                                toolName: "move-event",
                                toolIcon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$ef875af7def69d98), {}),
                                toolLabelTooltip: "D\xe9placer un \xe9v\xe8nement",
                                toggleTool: toggleToolCallback,
                                activeTool: activeTool,
                                variant: variant
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                                tooltipId: "crise-create-event",
                                tooltipText: "Cr\xe9er un nouvel \xe9v\xe8nement",
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                                    className: "m-2",
                                    onClick: ()=>{
                                        setEvenementSousCategorieId(undefined);
                                        setShowCreateEvent(!showCreateEvent);
                                    },
                                    variant: variant,
                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$16ae26c700600e84), {})
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                        tooltipId: "crise-list-event",
                        tooltipText: "Afficher la liste des \xe9v\xe8nements",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                            className: "m-2",
                            onClick: ()=>{
                                setShowListEvent(!showListEvent);
                            },
                            variant: variant,
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$527d32aa1785fdd4), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                        tooltipId: "crise-list-docs",
                        tooltipText: "Afficher la liste des documents",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                            className: "m-2",
                            onClick: ()=>{
                                setShowListDocument(!showListDocument);
                            },
                            variant: variant,
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$84ac927778fdc063), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                        tooltipId: "crise-custom-report",
                        tooltipText: "Exectuer des rapports personnalis\xe9s",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                            className: "m-2",
                            onClick: ()=>{
                                setShowPersonalReports(!showPersonalReports);
                            },
                            variant: variant,
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$9963061ea3f5d8da), {})
                        })
                    }),
                    (0, $e3b8d60f4bb99483$export$4f612ab7b7b1d133)(user, [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).CRISE_C,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).CRISE_U
                    ]) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                        tooltipId: "crise-capture",
                        tooltipText: "Enregistre une capture",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                            className: "m-2",
                            onClick: ()=>{
                                show();
                            },
                            variant: variant,
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$e817ff83c15c44f9), {})
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                xs: "auto",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ef04aa6164ff9f18$export$2e2bcd8739ae039), {
                    map: map,
                    urlAPI: `/api/crise/${criseId}`
                })
            }),
            (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).CRISE_C) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                xs: "auto",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($468cb52a95264278$var$DropdownTypeSousType, {
                    criseId: criseId,
                    variant: variant,
                    setTypeEvenement: setEvenementSousCategorieId,
                    toggleToolCallback: toggleToolCallback,
                    setSousTypeElement: setSousTypeElement
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1eee265537f042a4$export$2e2bcd8739ae039), {
                handleClose: handleCloseEvent,
                show: showListEvent,
                className: "w-auto",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $f74ed971711305fd$export$2e2bcd8739ae039), {
                    evenementStatutMode: evenementStatutMode,
                    criseIdentifiant: criseId,
                    mapType: map,
                    onEvenementIdsFiltresChange: onEvenementIdsFiltresChange
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1eee265537f042a4$export$2e2bcd8739ae039), {
                handleClose: handleCloseEvent,
                show: showListDocument,
                className: "w-auto",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2455128491488306$export$2e2bcd8739ae039), {
                    map: map,
                    criseIdentifiant: criseId,
                    onSubmit: handleCloseEvent
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1eee265537f042a4$export$2e2bcd8739ae039), {
                handleClose: handleCloseEvent,
                show: showPersonalReports,
                className: "w-auto",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $4485bb756c9cef26$export$2e2bcd8739ae039), {
                    geometry: reportGeometryElement,
                    onGeometrySelect: (geometryType, geometryCode)=>{
                        setGeometryReportCode(geometryCode);
                        toggleToolCallback("create-report-" + geometryType.toLowerCase());
                    }
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1eee265537f042a4$export$2e2bcd8739ae039), {
                handleClose: handleCloseEvent,
                show: showCreateEvent,
                className: "w-auto",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2350e70239c6d180$export$2e2bcd8739ae039), {
                    geometrieEvenement: geometryElement,
                    evenementSousCategorieId: evenementSousCategorieId,
                    criseId: criseId,
                    state: evenementStatutMode,
                    onSubmit: ()=>{
                        dataCriseLayer.getSource().refresh();
                        (0, $1ed1be1197ad1bc4$export$51ba454167fb25ab)(map);
                        handleCloseEvent();
                    }
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b0759c348c3ed98d$export$bb9fc698d6b9459f), {
                state: evenementStatutMode,
                map: map,
                dataEvenementLayer: dataCriseLayer,
                disabled: "move-event" === activeTool,
                criseId: criseId,
                onClose: ()=>{
                    dataCriseLayer.getSource().refresh();
                    (0, $1ed1be1197ad1bc4$export$51ba454167fb25ab)(map);
                    handleCloseEvent();
                }
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $c738870e8199ea0b$export$2e2bcd8739ae039), {
                closeModal: close,
                canModify: true,
                query: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/crise/${criseId}/screen`,
                submitLabel: "Valider",
                visible: visible,
                isMultipartFormData: true,
                header: null,
                validationSchema: (0, $85dfd19055b5d7fc$export$1636a9582e7974ce),
                onSubmit: close,
                prepareVariables: (values)=>(0, $85dfd19055b5d7fc$export$f97400759cfd946)(captureMap(), values, getMapGeometry()),
                getInitialValues: (0, $85dfd19055b5d7fc$export$a04a503d8277ee43),
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $85dfd19055b5d7fc$export$2e2bcd8739ae039), {})
            })
        ]
    });
});
$468cb52a95264278$var$MapToolbarCrise.displayName = "MapToolbarCrise";
var $468cb52a95264278$export$2e2bcd8739ae039 = $468cb52a95264278$var$MapToolbarCrise;
const $468cb52a95264278$var$DropdownTypeSousType = ({ criseId: criseId, variant: variant, setTypeEvenement: setTypeEvenement, toggleToolCallback: toggleToolCallback, setSousTypeElement: setSousTypeElement })=>{
    const typeWithSousType = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/crise/${criseId}/evenement/type-sous-type`)?.data;
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $943025b58510539f$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $943025b58510539f$export$2e2bcd8739ae039).Toggle, {
                className: "m-2",
                id: "dropdown-",
                variant: variant,
                children: "Dessiner"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $943025b58510539f$export$2e2bcd8739ae039).Menu, {
                children: typeWithSousType?.map((e, key)=>{
                    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                        xs: "auto",
                        className: "m-2",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $943025b58510539f$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $943025b58510539f$export$2e2bcd8739ae039).Toggle, {
                                    id: "dropdown-",
                                    variant: variant,
                                    children: e.evenementCategorieLibelle?.toString()
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $943025b58510539f$export$2e2bcd8739ae039).Menu, {
                                    children: e.listSousType.map((soustype, key)=>{
                                        let icon;
                                        switch(soustype.evenementSousCategorieGeometrie){
                                            case (0, $72e886a1223521a1$export$2e2bcd8739ae039).POINT:
                                                icon = /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$fc789d8a435194dc), {});
                                                break;
                                            case (0, $72e886a1223521a1$export$2e2bcd8739ae039).LINESTRING:
                                                icon = /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$365092c6388045c9), {});
                                                break;
                                            case (0, $72e886a1223521a1$export$2e2bcd8739ae039).POLYGON:
                                                icon = /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$fa5eb5b4918005e3), {});
                                                break;
                                        }
                                        return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $943025b58510539f$export$2e2bcd8739ae039).Item, {
                                            onClick: ()=>{
                                                setTypeEvenement(soustype.evenementSousCategorieId);
                                                toggleToolCallback("create-" + soustype.evenementSousCategorieGeometrie.toLowerCase());
                                                setSousTypeElement(soustype.evenementSousCategorieId);
                                            },
                                            children: [
                                                icon,
                                                " ",
                                                soustype?.evenementSousCategorieLibelle
                                            ]
                                        }, key);
                                    })
                                })
                            ]
                        })
                    }, key);
                })
            })
        ]
    });
};


const $3f3f3c1530b23dfd$var$MapCrise = ({ criseId: criseId, evenementStatutMode: evenementStatutMode, variant: variant })=>{
    const mapElement = (0, $kc00y.useRef)();
    const [evenementIdsFiltres, setEvenementIdsFiltres] = (0, $kc00y.useState)([]);
    const evenementIdsRef = (0, $kc00y.useRef)([]);
    const handleEvenementIdsFiltresChange = (0, $kc00y.useCallback)((listeEvenementId)=>{
        setEvenementIdsFiltres(listeEvenementId);
        evenementIdsRef.current = listeEvenementId;
    }, []);
    // Construire les viewParams supplémentaires avec les IDs filtrés - VERSION STABLE (sans dépendances)
    // La ref sera mise à jour mais viewParamsExtras ne changera pas de référence
    const viewParamsExtras = (0, $kc00y.useMemo)(()=>{
        return {};
    }, []);
    /** Permet d'afficher les géometries évènements */ const getLayerUrl = (0, $kc00y.useCallback)((extent, projection, evenementIdsFiltres)=>{
        const params = new URLSearchParams();
        if (evenementIdsFiltres?.length > 0) params.append("evenementIds", JSON.stringify(evenementIdsFiltres));
        params.append("bbox", extent.join(","));
        params.append("srid", projection.getCode());
        params.append("criseId", criseId);
        params.append("state", evenementStatutMode);
        return `/api/crise/evenement/layer?${params.toString()}`;
    }, [
        criseId,
        evenementStatutMode
    ]);
    const listeCouches = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/crise/${criseId}/get-couches`)?.data;
    const { map: map, workingLayer: workingLayer, availableLayers: availableLayers, addOrRemoveLayer: addOrRemoveLayer, layerListRef: layerListRef, projection: projection, showOutilI: showOutilI, mapToolbarRef: mapToolbarRef } = (0, $cdcdd8e1ff041f79$export$547f9c492d831282)({
        mapElement: mapElement,
        typeModule: (0, $a9754922f4c67d47$export$ef88b514e4bfff34).CRISE,
        criseId: criseId,
        evenementStatutMode: evenementStatutMode,
        viewParamsExtras: viewParamsExtras
    });
    const dataEvenementLayer = (0, $kc00y.useMemo)(()=>{
        if (!map) return;
        // on met en place un style transparent pour que les SDIS le définissent directement dans geoserver (invisible à l'oeil nu mais pas totalement transparent pour que les interactions fonctionnent)
        const style = new (0, $a5fc261473972d1d$export$2e2bcd8739ae039)({
            fill: new (0, $8624b871a0af6dab$export$2e2bcd8739ae039)({
                color: "rgba(0, 0, 0, 0.01)"
            }),
            stroke: new (0, $281691897fddf9d0$export$2e2bcd8739ae039)({
                color: "rgba(0, 0, 0, 0.01)",
                width: 1
            }),
            image: new (0, $f060542c6e9f52e6$export$2e2bcd8739ae039)({
                radius: 5,
                stroke: new (0, $281691897fddf9d0$export$2e2bcd8739ae039)({
                    color: "rgba(0, 0, 0, 0.01)"
                }),
                fill: new (0, $8624b871a0af6dab$export$2e2bcd8739ae039)({
                    color: "rgba(0, 0, 0, 0.01)"
                })
            })
        });
        const vectorSource = new (0, $1020e4d07ddbfab1$export$2e2bcd8739ae039)({
            strategy: (0, $6a8cacaa690463df$export$bf67010aacbe66fa),
            format: new (0, $93342158ce8701e7$export$2e2bcd8739ae039)({
                dataProjection: projection,
                featureProjection: projection
            })
        });
        const layer = new (0, $082a79ecb622f84a$export$2e2bcd8739ae039)({
            source: vectorSource,
            style: style,
            opacity: 1,
            visible: true,
            minZoom: 8,
            maxResolution: 99999,
            zIndex: 9999
        });
        map.addLayer(layer);
        return layer;
    }, [
        map,
        projection
    ]);
    (0, $kc00y.useEffect)(()=>{
        if (!map || !dataEvenementLayer) return;
        const source = dataEvenementLayer.getSource();
        source?.clear();
        source.setLoader(async (extent, _, projection, success, failure)=>{
            try {
                const res = await fetch(getLayerUrl(extent, projection, evenementIdsFiltres), (0, $fbd4d34e07af0ac7$export$b163ec2f884327db)({
                    method: "GET"
                }));
                const features = source.getFormat().readFeatures(await res.json());
                source.addFeatures(features);
                success(features);
            } catch  {
                source.removeLoadedExtent(extent);
                failure();
            }
        });
        // Vider complètement la source et forcer le rechargement
        source.clear();
        // Forcer le rechargement de toutes les extents actuellement visibles
        const view = map.getView();
        const extent = view.calculateExtent(map.getSize());
        source.removeLoadedExtent(extent);
        source.refresh();
    }, [
        dataEvenementLayer,
        getLayerUrl,
        map,
        evenementIdsFiltres
    ]);
    const { tools: extraTools, handleCloseEvent: handleCloseEvent, showCreateEvent: showCreateEvent, showListEvent: showListEvent, showListDocument: showListDocument, showPersonalReports: showPersonalReports, setShowPersonalReports: setShowPersonalReports, setShowListEvent: setShowListEvent, setShowCreateEvent: setShowCreateEvent, setShowListDocument: setShowListDocument, listeEventId: listeEventId, setSousTypeElement: setSousTypeElement, geometryElement: geometryElement, setGeometryReportCode: setGeometryReportCode, reportGeometryElement: reportGeometryElement, sousTypeElement: sousTypeElement } = (0, $468cb52a95264278$export$393aec6287785336)({
        map: map,
        workingLayer: workingLayer,
        dataEvenementLayer: dataEvenementLayer
    });
    /**
   * Met à jour la liste des couches actives sur la carte en fonction des couches WMS sélectionnées.
   */ const listeDesCouches = (0, $kc00y.useMemo)(()=>{
        if (!listeCouches) return [];
        return availableLayers.map((group)=>({
                ...group,
                layers: group.layers.filter((layer)=>{
                    const isActive = listeCouches.some((c)=>c.code === layer.code && c[evenementStatutMode.toLowerCase()]);
                    return isActive;
                })
            }));
    }, [
        availableLayers,
        listeCouches,
        evenementStatutMode
    ]);
    const { toggleTool: toggleTool, activeTool: activeTool, infoOutilI: infoOutilI, handleCloseInfoI: handleCloseInfoI } = (0, $e2b798e23180fa76$export$194c7727cbdc0cac)({
        availableLayers: listeDesCouches,
        map: map,
        workingLayer: workingLayer,
        extraTools: extraTools
    });
    (0, $kc00y.useEffect)(()=>{
        if (!map || !listeCouches) return;
        const activeCoucheCodes = new Set(listeCouches.filter((c)=>c[evenementStatutMode.toLowerCase()]).map((c)=>c.code));
        availableLayers.flatMap((group)=>group.layers).forEach((layer)=>{
            const currentLayer = map.getLayers().getArray().find((l)=>l === layer.openlayer);
            if (currentLayer) currentLayer.setVisible(activeCoucheCodes.has(layer.code));
        });
    }, [
        availableLayers,
        listeCouches,
        map,
        evenementStatutMode
    ]);
    // Rafraîchir les couches WMS/WMTS quand les IDs filtrés changent
    (0, $kc00y.useEffect)(()=>{
        if (!map) return;
        map.getLayers().forEach((layer)=>{
            if (layer.getSource().updateParams) {
                // Récupérer les paramètres actuels
                const currentParams = layer.getSource().getParams();
                const currentViewParams = currentParams?.viewParams || "";
                // Parser les viewParams existants pour extraire les autres paramètres
                const viewParamsMap = {};
                if (currentViewParams) currentViewParams.split(";").forEach((param)=>{
                    const [key, value] = param.split(":");
                    if (key && value) viewParamsMap[key.trim()] = value;
                });
                // Mettre à jour ou ajouter evenementIds
                if (evenementIdsRef.current.length > 0) viewParamsMap.evenementIds = evenementIdsRef.current.join("|");
                else delete viewParamsMap.evenementIds;
                // Reconstruire le string viewParams avec tous les paramètres
                const newViewParams = Object.entries(viewParamsMap).map(([key, value])=>`${key}:${value}`).join(";");
                layer.getSource().updateParams({
                    time: Date.now(),
                    viewParams: newViewParams
                });
                layer.getSource().refresh();
            }
        });
    }, [
        map
    ]);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $cdcdd8e1ff041f79$export$2e2bcd8739ae039), {
        map: map,
        showZoomPlace: false,
        mapElement: mapElement,
        availableLayers: listeDesCouches,
        addOrRemoveLayer: addOrRemoveLayer,
        layerListRef: layerListRef,
        mapToolbarRef: mapToolbarRef,
        toggleTool: toggleTool,
        outilI: infoOutilI,
        showOutilI: showOutilI,
        handleCloseInfoI: handleCloseInfoI,
        activeTool: activeTool,
        toolbarElement: mapToolbarRef.current && dataEvenementLayer && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $468cb52a95264278$export$2e2bcd8739ae039), {
            setGeometryReportCode: setGeometryReportCode,
            evenementStatutMode: evenementStatutMode,
            map: map,
            criseId: criseId,
            handleCloseEvent: handleCloseEvent,
            listeEventId: listeEventId,
            toggleTool: toggleTool,
            activeTool: activeTool,
            reportGeometryElement: reportGeometryElement,
            geometryElement: geometryElement,
            workingLayer: workingLayer,
            setSousTypeElement: setSousTypeElement,
            sousTypeElement: sousTypeElement,
            dataCriseLayer: dataEvenementLayer,
            showListEvent: showListEvent,
            showListDocument: showListDocument,
            showCreateEvent: showCreateEvent,
            setShowListEvent: setShowListEvent,
            setShowCreateEvent: setShowCreateEvent,
            setShowListDocument: setShowListDocument,
            setShowPersonalReports: setShowPersonalReports,
            showPersonalReports: showPersonalReports,
            variant: variant,
            onEvenementIdsFiltresChange: handleEvenementIdsFiltresChange
        }),
        variant: variant
    }, evenementStatutMode);
};
var $3f3f3c1530b23dfd$export$2e2bcd8739ae039 = $3f3f3c1530b23dfd$var$MapCrise;



const $3e48f0f93abb6fed$var$ModuleMapCrise = ()=>{
    const { criseId: criseId } = (0, $7a844823b04d4282$export$99eaa27ddbbb95ef)();
    const criseState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/crise/` + criseId);
    const options = [
        {
            name: "Op\xe9rationnel",
            code: "OPERATIONNEL"
        },
        {
            name: "Anticipation",
            code: "ANTICIPATION"
        }
    ];
    const [checkBoxOption, setCheckBoxOption] = (0, $kc00y.useState)(options[0]);
    return criseId && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                title: criseState?.data?.criseLibelle,
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$73b2275057918051), {}),
                right: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $a43e6f68e14bab96$export$2e2bcd8739ae039), {
                    children: options.map((opt, idx)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8b78b8a93971307c$export$2e2bcd8739ae039), {
                            id: `opt-${idx}`,
                            type: "radio",
                            variant: idx % 2 ? "outline-warning" : "outline-primary",
                            name: "switch-operationnel-anticipation",
                            value: opt.code,
                            checked: checkBoxOption.code === opt.code,
                            onChange: ()=>setCheckBoxOption(options[idx]),
                            children: opt.name
                        }, idx))
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $3f3f3c1530b23dfd$export$2e2bcd8739ae039), {
                criseId: criseId,
                evenementStatutMode: checkBoxOption.code,
                variant: checkBoxOption.code === options[1].code ? "warning" : "primary"
            })
        ]
    });
};
var $3e48f0f93abb6fed$export$2e2bcd8739ae039 = $3e48f0f93abb6fed$var$ModuleMapCrise;











var $bkJfK = parcelRequire("bkJfK");







const $319c602f9691d2cf$export$a5cab80145b70e98 = (criseId)=>({
        criseId: criseId,
        criseDateFin: new Date()
    });
const $319c602f9691d2cf$export$c084437b5e3206cd = (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({
    criseDateFin: (0, $36ceaed6faf947af$export$5cbf64e9c4f743ca)
});
const $319c602f9691d2cf$export$bb754639dd100f3c = (values)=>({
        criseDateFin: new Date(values.criseDateFin ?? new Date()),
        listeCriseId: values.listeCriseId,
        criseId: values.criseId
    });
const $319c602f9691d2cf$var$CriseMergePage = ({ criseId: criseId })=>{
    const { setFieldValue: setFieldValue, values: values } = (0, $bkJfK.useFormikContext)();
    const listeCriseFusion = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/crise/getCriseForMerge`)?.data;
    const index = listeCriseFusion?.findIndex((element)=>element.criseId === criseId);
    if (index !== -1) listeCriseFusion?.splice(index, 1);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
        noValidate: true,
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$eae70af4b4e3f197), {
                options: listeCriseFusion,
                name: "listeCrises",
                label: "Liste des crises \xe0 fusionner",
                getOptionValue: (t)=>t.criseId,
                getOptionLabel: (t)=>t.criseLibelle,
                isClearable: true,
                onChange: (crise)=>{
                    const criseId = crise.map((e)=>e.criseId);
                    criseId.length > 0 ? setFieldValue("listeCriseId", criseId) : setFieldValue("listeCriseId", undefined);
                }
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$183478aa40b5df1), {
                name: "criseDateFin",
                label: "Date et heure de fusion",
                required: true,
                value: values.criseDateFin && (0, $00c47c7740afd024$export$cc23f907e4acb548)(values.criseDateFin)
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db9b0e6fdb142a4c$export$2e2bcd8739ae039), {
                returnLink: true
            })
        ]
    });
};
var $319c602f9691d2cf$export$2e2bcd8739ae039 = $319c602f9691d2cf$var$CriseMergePage;


const $024b1e5e401e6092$var$UpdateCrise = ()=>{
    const { criseId: criseId } = (0, $7a844823b04d4282$export$99eaa27ddbbb95ef)();
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$81608868aefa31ce), {}),
                title: "Fusionner la crise"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                initialValues: (0, $319c602f9691d2cf$export$a5cab80145b70e98)(criseId),
                validationSchema: (0, $319c602f9691d2cf$export$c084437b5e3206cd),
                isPost: false,
                submitUrl: `/api/crise/${criseId}/merge`,
                prepareVariables: (values)=>(0, $319c602f9691d2cf$export$bb754639dd100f3c)(values),
                redirectUrl: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_CRISES,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $319c602f9691d2cf$export$2e2bcd8739ae039), {
                    criseId: criseId
                })
            })
        ]
    });
};
var $024b1e5e401e6092$export$2e2bcd8739ae039 = $024b1e5e401e6092$var$UpdateCrise;












const $3ffcddd6bd1de12d$var$UpdateCrise = ()=>{
    const { criseId: criseId } = (0, $7a844823b04d4282$export$99eaa27ddbbb95ef)();
    const criseState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/crise/${criseId}`);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$b51dd496211ae105), {}),
                title: "Mise \xe0 jour d'une crise"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                initialValues: (0, $35b25f8a96785a66$export$a5cab80145b70e98)(criseState?.data),
                validationSchema: (0, $35b25f8a96785a66$export$fc70085a30e92f86),
                isPost: false,
                submitUrl: `/api/crise/${criseId}/update`,
                prepareVariables: (values)=>(0, $35b25f8a96785a66$export$bb754639dd100f3c)(values),
                redirectUrl: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_CRISES,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $35b25f8a96785a66$export$2e2bcd8739ae039), {})
            })
        ]
    });
};
var $3ffcddd6bd1de12d$export$2e2bcd8739ae039 = $3ffcddd6bd1de12d$var$UpdateCrise;


















const $b6b08beed39d7992$var$FilterValues = ({ courrierObjet: courrierObjet, courrierReference: courrierReference, courrierExpediteur: courrierExpediteur, emailDestinataire: emailDestinataire, accuse: accuse, documentDate: documentDate })=>{
    const filter = {};
    $b6b08beed39d7992$var$filterProperty(filter, courrierObjet, "courrierObjet");
    $b6b08beed39d7992$var$filterProperty(filter, courrierReference, "courrierReference");
    $b6b08beed39d7992$var$filterProperty(filter, courrierExpediteur, "courrierExpediteur");
    $b6b08beed39d7992$var$filterProperty(filter, accuse, "accuse");
    $b6b08beed39d7992$var$filterProperty(filter, documentDate, "documentDate");
    if (emailDestinataire && emailDestinataire?.length > 0) filter.emailDestinataire = emailDestinataire;
    return filter;
};
function $b6b08beed39d7992$var$filterProperty(filter, value, name) {
    if (value != null && value.trim() !== "") filter[name] = value;
}
var $b6b08beed39d7992$export$2e2bcd8739ae039 = $b6b08beed39d7992$var$FilterValues;


var $00aa4b3a67b380d4$var$OUVERT_NON_OUVERT = /*#__PURE__*/ function(OUVERT_NON_OUVERT) {
    OUVERT_NON_OUVERT["true"] = "Ouvert";
    OUVERT_NON_OUVERT["false"] = "Non-ouvert";
    return OUVERT_NON_OUVERT;
}($00aa4b3a67b380d4$var$OUVERT_NON_OUVERT || {});
const $00aa4b3a67b380d4$var$ListModuleCourrier = ()=>{
    const { moduleId: moduleId } = (0, $7a844823b04d4282$export$99eaa27ddbbb95ef)();
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $a0064658a8399ad3$export$2e2bcd8739ae039), {
        navbar: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $5de16d9a2066fdee$export$2e2bcd8739ae039), {}),
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                    icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$527d32aa1785fdd4), {}),
                    title: "Liste des courriers"
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $9a9eebc3462fba73$export$2e2bcd8739ae039), {
                    query: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/modules/courriers/all?${{
                        moduleId: moduleId
                    }}`,
                    columns: [
                        {
                            Header: "Date d'envoi",
                            accessor: "documentDate",
                            sortField: "documentDate",
                            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eed37ff3d3e1f28c$export$2e2bcd8739ae039), {
                                options: (0, $70f33b4ac8b2af85$export$d1513a971ccb2ea8),
                                name: "documentDate"
                            }),
                            Cell: (value)=>{
                                return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                    children: value.value ? (0, $00c47c7740afd024$export$2e2bcd8739ae039)(value.value) : ""
                                });
                            }
                        },
                        {
                            Header: "Objet",
                            accessor: "courrierObjet",
                            sortField: "courrierObjet",
                            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                                type: "text",
                                name: "courrierObjet"
                            })
                        },
                        {
                            Header: "R\xe9f\xe9rence",
                            accessor: "courrierReference",
                            sortField: "courrierReference",
                            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                                type: "text",
                                name: "courrierReference"
                            })
                        },
                        {
                            Header: "Exp\xe9diteur",
                            accessor: "courrierExpediteur",
                            sortField: "courrierExpediteur",
                            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                                type: "text",
                                name: "courrierExpediteur"
                            })
                        },
                        {
                            Header: "Destinataires",
                            accessor: "emailDestinataire",
                            sortField: "emailDestinataire",
                            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                                type: "text",
                                name: "emailDestinataire"
                            }),
                            Cell: (value)=>{
                                return value.value.map((v, key)=>{
                                    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                            className: "mt-2",
                                            children: v.email
                                        })
                                    }, key);
                                });
                            }
                        },
                        {
                            Header: "Accus\xe9",
                            accessor: "emailDestinataire",
                            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eed37ff3d3e1f28c$export$2e2bcd8739ae039), {
                                options: $00aa4b3a67b380d4$var$OUVERT_NON_OUVERT,
                                name: "accuse"
                            }),
                            Cell: (value)=>{
                                return value.value.map((v, key)=>{
                                    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                        className: "align-items-center",
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                            className: "text-center mt-2",
                                            xs: 12,
                                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                                                tooltipText: v.accuse ? "Courrier ouvert" : "Courrier non-ouvert",
                                                tooltipId: value,
                                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $98f55aa78fbaf278$export$2e2bcd8739ae039), {
                                                    bg: v.accuse ? "success" : "danger",
                                                    pill: true,
                                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$196109e945d3b66f), {})
                                                })
                                            })
                                        })
                                    }, key);
                                });
                            }
                        },
                        (0, $b82b937cc97f6f18$export$36e9f5a475c9f6fc)({
                            Header: "Actions",
                            accessor: "courrierDocumentId",
                            buttons: [
                                {
                                    row: (row)=>{
                                        return row;
                                    },
                                    route: (id)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/documents/telecharger/` + id,
                                    type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).BUTTON,
                                    icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$4a5ccdc9878f4668), {}),
                                    textEnable: "T\xe9l\xe9charger le courrier",
                                    classEnable: "warning"
                                }
                            ],
                            width: 90
                        })
                    ],
                    idName: "tableModuleCourrier",
                    filterValuesToVariable: (0, $b6b08beed39d7992$export$2e2bcd8739ae039),
                    filterContext: (0, $9a9eebc3462fba73$export$396ef541d9951d45)({})
                })
            ]
        })
    });
};
var $00aa4b3a67b380d4$export$2e2bcd8739ae039 = $00aa4b3a67b380d4$var$ListModuleCourrier;















const $9d1a0243758327f1$var$FilterValues = ({ libelle: libelle })=>{
    const filter = {};
    $9d1a0243758327f1$var$filterProperty(filter, libelle, "libelle");
    return filter;
};
function $9d1a0243758327f1$var$filterProperty(filter, value, name) {
    if (value != null && value.trim() !== "") filter[name] = value;
}
var $9d1a0243758327f1$export$2e2bcd8739ae039 = $9d1a0243758327f1$var$FilterValues;


const $4f44af54e0715d5f$var$ListModuleDocument = ()=>{
    const { moduleType: moduleType, moduleId: moduleId } = (0, $7a844823b04d4282$export$99eaa27ddbbb95ef)();
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $a0064658a8399ad3$export$2e2bcd8739ae039), {
        navbar: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $5de16d9a2066fdee$export$2e2bcd8739ae039), {}),
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                    icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$527d32aa1785fdd4), {}),
                    title: "Liste des " + moduleType?.toLowerCase() + "s"
                }),
                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $9a9eebc3462fba73$export$2e2bcd8739ae039), {
                    query: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/modules/${moduleType}/all?${{
                        moduleId: moduleId,
                        moduleType: moduleType
                    }}`,
                    columns: [
                        {
                            Header: "Libell\xe9",
                            accessor: "libelle",
                            sortField: "libelle",
                            Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                                type: "text",
                                name: "libelle"
                            })
                        },
                        {
                            Header: "Mise \xe0 jour le",
                            accessor: "date",
                            sortField: "date",
                            Cell: (value)=>{
                                return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                    children: value?.value != null && (0, $00c47c7740afd024$export$2e2bcd8739ae039)(value.value)
                                });
                            }
                        },
                        (0, $b82b937cc97f6f18$export$36e9f5a475c9f6fc)({
                            Header: "Actions",
                            accessor: "id",
                            buttons: [
                                {
                                    row: (row)=>{
                                        return row;
                                    },
                                    route: (id)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/document-habilitable/telecharger/` + id,
                                    type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).BUTTON,
                                    icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$4a5ccdc9878f4668), {}),
                                    textEnable: "T\xe9l\xe9charger le document",
                                    classEnable: "warning"
                                }
                            ]
                        })
                    ],
                    idName: "tableModuleDocument",
                    filterValuesToVariable: (0, $9d1a0243758327f1$export$2e2bcd8739ae039),
                    filterContext: (0, $9a9eebc3462fba73$export$396ef541d9951d45)({})
                })
            ]
        })
    });
};
var $4f44af54e0715d5f$export$2e2bcd8739ae039 = $4f44af54e0715d5f$var$ListModuleDocument;












var $bkJfK = parcelRequire("bkJfK");

var $kc00y = parcelRequire("kc00y");













const $c8405874ffdb506c$export$a5cab80145b70e98 = (data)=>({
        oldeb: data?.oldeb || {
            caracteristiqueList: [],
            oldebVolume: 0,
            oldebGeometrie: null,
            oldebActif: true
        },
        propriete: data?.propriete || {},
        locataire: data?.locataire,
        visiteList: data?.visiteList,
        documentList: data?.documentList || {},
        isRent: data?.locataire ? true : false
    });
const $c8405874ffdb506c$export$8470ef9d0802da38 = (values)=>{
    const formData = new FormData();
    formData.append("oldeb", JSON.stringify(values.oldeb));
    formData.append("propriete", JSON.stringify(values.propriete));
    if (values.isRent && values.locataire) formData.append("locataire", JSON.stringify(values.locataire));
    values.visiteList && formData.append("visiteList", JSON.stringify(values.visiteList?.map((v)=>({
            ...v,
            oldebVisiteDateVisite: new Date(v.oldebVisiteDateVisite ?? "")?.toISOString() || null,
            suiteList: v.suiteList?.map((s)=>({
                    ...s,
                    oldebVisiteSuiteDate: new Date(s.oldebVisiteSuiteDate ?? "")?.toISOString() || null
                }))
        }))));
    if (values.documentList) Object.keys(values.documentList).forEach((code)=>{
        if (values.documentList) values.documentList[code].forEach((file)=>{
            formData.append(`document_${code}[]`, file);
        });
    });
    return formData;
};
const $c8405874ffdb506c$export$c084437b5e3206cd = (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({
    oldeb: (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({
        oldebId: (0, $ce4de947442b2ab1$export$22b082955e083ec3)(),
        oldebGeometrie: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
        oldebCommuneId: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
        oldebCadastreSectionId: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
        oldebCadastreParcelleId: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
        oldebOldebTypeAccesId: (0, $ce4de947442b2ab1$export$22b082955e083ec3)(),
        oldebOldebTypeZoneUrbanismeId: (0, $ce4de947442b2ab1$export$22b082955e083ec3)(),
        oldebNumVoie: (0, $ce4de947442b2ab1$export$22b082955e083ec3)(),
        oldebVoieId: (0, $ce4de947442b2ab1$export$22b082955e083ec3)(),
        oldebLieuDitId: (0, $ce4de947442b2ab1$export$22b082955e083ec3)(),
        oldebVolume: (0, $36ceaed6faf947af$export$67e44a5301f37174),
        oldebLargeurAcces: (0, $36ceaed6faf947af$export$67e44a5301f37174),
        oldebPortailElectrique: (0, $ce4de947442b2ab1$export$87b259aa03e3d267)(),
        oldebCodePortail: (0, $ce4de947442b2ab1$export$22b082955e083ec3)()
    }).required(),
    locataire: (0, $ce4de947442b2ab1$export$be5493f9613cbbe)().when("isRent", {
        is: true,
        then: ()=>(0, $ce4de947442b2ab1$export$be5493f9613cbbe)({
                oldebLocataireOrganisme: (0, $ce4de947442b2ab1$export$87b259aa03e3d267)(),
                oldebLocataireRaisonSociale: (0, $ce4de947442b2ab1$export$22b082955e083ec3)(),
                oldebLocataireCivilite: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
                oldebLocataireNom: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
                oldebLocatairePrenom: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
                oldebLocataireTelephone: (0, $ce4de947442b2ab1$export$22b082955e083ec3)(),
                oldebLocataireEmail: (0, $36ceaed6faf947af$export$d290fa47940df19d)
            }).required()
    }),
    propriete: (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({
        oldebProprieteOldebProprietaireId: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
        oldebProprieteOldebTypeResidenceId: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba)
    }),
    visiteList: (0, $ce4de947442b2ab1$export$2f23118c22fb2630)().of((0, $ce4de947442b2ab1$export$be5493f9613cbbe)({
        oldebVisiteId: (0, $ce4de947442b2ab1$export$22b082955e083ec3)(),
        oldebVisiteCode: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
        oldebVisiteDateVisite: (0, $36ceaed6faf947af$export$324d90190a8b822a),
        oldebVisiteAgent: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
        oldebVisiteObservation: (0, $ce4de947442b2ab1$export$22b082955e083ec3)(),
        oldebVisiteDebroussaillementParcelleId: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
        oldebVisiteDebroussaillementAccesId: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
        oldebVisiteOldebTypeAvisId: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
        oldebVisiteOldebTypeActionId: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
        anomalieList: (0, $ce4de947442b2ab1$export$2f23118c22fb2630)().of((0, $ce4de947442b2ab1$export$22b082955e083ec3)()),
        suiteList: (0, $ce4de947442b2ab1$export$2f23118c22fb2630)().of((0, $ce4de947442b2ab1$export$be5493f9613cbbe)({
            oldebVisiteSuiteId: (0, $ce4de947442b2ab1$export$22b082955e083ec3)(),
            oldebVisiteSuiteOldebTypeSuiteId: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
            oldebVisiteSuiteDate: (0, $36ceaed6faf947af$export$324d90190a8b822a),
            oldebVisiteSuiteObservation: (0, $ce4de947442b2ab1$export$22b082955e083ec3)()
        })),
        documentList: (0, $ce4de947442b2ab1$export$2f23118c22fb2630)()
    })),
    isRent: (0, $ce4de947442b2ab1$export$87b259aa03e3d267)()
});
const $c8405874ffdb506c$var$removeFromLocalStorage = ()=>{
    localStorage.removeItem("mapContent");
};
const $c8405874ffdb506c$var$OldebForm = ({ returnButton: returnButton })=>{
    const [currentTab, setCurrentTab] = (0, $kc00y.useState)("parcelle");
    const [currentVisite, setCurrentVisite] = (0, $kc00y.useState)(null);
    const { values: values, setFieldValue: setFieldValue } = (0, $bkJfK.useFormikContext)();
    const civiliteList = Object.entries((0, $e5997c0dce1a3fdf$export$2e2bcd8739ae039)).map(([key, value])=>{
        return {
            id: key,
            code: value,
            libelle: value
        };
    });
    const communeState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/commune/get-libelle-commune`);
    const { run: fetchVoie, data: voieList } = (0, $8d9ebd8892d8a5f5$export$6326fb4463ae1be4)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/commune/${values.oldeb.oldebCommuneId}/voie`, {});
    const { run: fetchLieuDit, data: lieuDitList } = (0, $8d9ebd8892d8a5f5$export$6326fb4463ae1be4)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/commune/${values.oldeb.oldebCommuneId}/lieu-dit`, {});
    const { run: fetchCadastreSection, data: cadastreSectionList } = (0, $8d9ebd8892d8a5f5$export$6326fb4463ae1be4)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/cadastre/commune/${values.oldeb.oldebCommuneId}/section`, {});
    const { run: fetchCadastreParcelle, data: cadastreParcelleList } = (0, $8d9ebd8892d8a5f5$export$6326fb4463ae1be4)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/cadastre/section/${values.oldeb.oldebCadastreSectionId}/available-parcelle${values.oldeb.oldebId ? "?oldebId=" + values.oldeb.oldebId : ""}`, {});
    const proprietaireState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/proprietaire/options`);
    const typeCategorieZoneUrbanismeState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/nomenclatures/list/${(0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).OLDEB_TYPE_ZONE_URBANISME}`);
    const typeAccesState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/nomenclatures/list/${(0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).OLDEB_TYPE_ACCES}`);
    const typeResidenceState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/nomenclatures/list/${(0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).OLDEB_TYPE_RESIDENCE}`);
    const typeCategorieCaracteristiqueState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/nomenclatures/list/${(0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).OLDEB_TYPE_CATEGORIE_CARACTERISTIQUE}`);
    const typeCaracteristiqueState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/oldeb/caracteristique`);
    const typeOldebTypeDebrousaillementState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/nomenclatures/list/${(0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).OLDEB_TYPE_DEBROUSSAILLEMENT}`);
    const typeOldebTypeAvisState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/nomenclatures/list/${(0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).OLDEB_TYPE_AVIS}`);
    const typeOldebTypeActionState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/nomenclatures/list/${(0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).OLDEB_TYPE_ACTION}`);
    (0, $kc00y.useEffect)(()=>{
        if (values.oldeb.oldebCommuneId) {
            fetchVoie();
            fetchLieuDit();
            fetchCadastreSection();
        }
    }, [
        fetchVoie,
        fetchLieuDit,
        fetchCadastreSection,
        values.oldeb.oldebCommuneId
    ]);
    (0, $kc00y.useEffect)(()=>{
        if (values.oldeb.oldebCadastreSectionId) fetchCadastreParcelle();
    }, [
        fetchCadastreParcelle,
        values.oldeb.oldebCadastreSectionId
    ]);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$f76670b5e5897c33), {
                title: "Informations OLD",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                                name: "oldeb.oldebCommuneId",
                                listIdCodeLibelle: communeState.data,
                                label: "Commune",
                                defaultValue: communeState?.data?.find((v)=>v.id === values.oldeb.oldebCommuneId),
                                required: true,
                                onChange: (e)=>{
                                    setFieldValue("oldeb.oldebVoieId", undefined);
                                    setFieldValue("oldeb.oldebLieuDitId", undefined);
                                    setFieldValue("oldeb.oldebCadastreSectionId", undefined);
                                    setFieldValue("oldeb.oldebCommuneId", e?.id);
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                                name: "oldeb.oldebCadastreSectionId",
                                listIdCodeLibelle: cadastreSectionList && cadastreSectionList.map((v)=>{
                                    return {
                                        id: v.cadastreSectionId,
                                        libelle: v.cadastreSectionNumero
                                    };
                                }),
                                label: "Section",
                                defaultValue: cadastreSectionList?.map((v)=>({
                                        id: v.cadastreSectionId,
                                        libelle: v.cadastreSectionNumero
                                    })).find((v)=>v.id === values.oldeb.oldebCadastreSectionId),
                                required: true,
                                onChange: (e)=>{
                                    setFieldValue("oldeb.oldebCadastreParcelleId", undefined);
                                    setFieldValue("oldeb.oldebCadastreSectionId", e?.id);
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                                name: "oldeb.oldebCadastreParcelleId",
                                listIdCodeLibelle: values.oldeb.oldebCadastreSectionId ? cadastreParcelleList?.map((v)=>{
                                    return {
                                        id: v.cadastreParcelleId,
                                        libelle: v.cadastreParcelleNumero
                                    };
                                }) : [],
                                label: "Parcelle",
                                defaultValue: values.oldeb.oldebCadastreSectionId && cadastreParcelleList?.map((v)=>({
                                        id: v.cadastreParcelleId,
                                        libelle: v.cadastreParcelleNumero
                                    })).find((v)=>v.id === values.oldeb.oldebCadastreParcelleId),
                                required: true,
                                setFieldValue: setFieldValue
                            })
                        }),
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                                name: "oldeb.oldebOldebTypeZoneUrbanismeId",
                                listIdCodeLibelle: typeCategorieZoneUrbanismeState?.data,
                                label: "Zone",
                                defaultValue: typeCategorieZoneUrbanismeState?.data?.find((v)=>v.id === values.oldeb.oldebOldebTypeZoneUrbanismeId),
                                required: true,
                                setFieldValue: setFieldValue
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $5f8ed132be8030d8$export$2e2bcd8739ae039), {
                id: "tabs",
                activeKey: currentTab,
                onSelect: (key)=>key && setCurrentTab(key),
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $ec8c33620b91a894$export$2e2bcd8739ae039), {
                        eventKey: "parcelle",
                        title: "Parcelle",
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f76670b5e5897c33), {
                                title: "Localisation et acc\xe8s",
                                children: [
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                                                    label: "Num\xe9ro",
                                                    name: "oldeb.oldebNumVoie",
                                                    required: false
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                                                    label: "Voie",
                                                    name: "oldeb.oldebVoieId",
                                                    required: false,
                                                    listIdCodeLibelle: voieList,
                                                    defaultValue: voieList?.find((e)=>e.id === values.oldeb.oldebVoieId),
                                                    setFieldValue: setFieldValue
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                                                    label: "Lieu-dit",
                                                    name: "oldeb.oldebLieuDitId",
                                                    required: false,
                                                    listIdCodeLibelle: lieuDitList,
                                                    defaultValue: lieuDitList?.find((e)=>e.id === values.oldeb.oldebLieuDitId),
                                                    setFieldValue: setFieldValue
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                                                    name: "oldeb.oldebOldebTypeAccesId",
                                                    listIdCodeLibelle: typeAccesState?.data,
                                                    label: "Type d'acc\xe8s",
                                                    defaultValue: typeAccesState?.data?.find((v)=>v.id === values.oldeb.oldebOldebTypeAccesId),
                                                    required: false,
                                                    setFieldValue: setFieldValue
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                                                    label: "Largeur",
                                                    name: "oldeb.oldebLargeurAcces",
                                                    required: false
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                                                    label: "Portail \xe9lectrique",
                                                    name: "oldeb.oldebPortailElectrique",
                                                    required: false
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                                                    label: "Code portail",
                                                    name: "oldeb.oldebCodePortail",
                                                    required: false,
                                                    disabled: !values.oldeb.oldebPortailElectrique
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$f76670b5e5897c33), {
                                title: "Propri\xe9taire",
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                                                name: "propriete.oldebProprieteOldebProprietaireId",
                                                listIdCodeLibelle: proprietaireState.data,
                                                label: "Propri\xe9taire",
                                                defaultValue: proprietaireState?.data?.find((v)=>v.id === values.propriete.oldebProprieteOldebProprietaireId),
                                                required: true,
                                                setFieldValue: setFieldValue
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                                                name: "propriete.oldebProprieteOldebTypeResidenceId",
                                                listIdCodeLibelle: typeResidenceState.data,
                                                label: "Type de propri\xe9t\xe9",
                                                defaultValue: typeResidenceState?.data?.find((v)=>v.id === values.propriete.oldebProprieteOldebTypeResidenceId),
                                                required: true,
                                                setFieldValue: setFieldValue
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                                                name: "isRent",
                                                label: "La propri\xe9t\xe9 est en location",
                                                checked: values.isRent,
                                                onChange: ()=>{
                                                    const newValue = !values.isRent;
                                                    setFieldValue("isRent", newValue);
                                                    if (!newValue) setFieldValue("locataire", undefined);
                                                    else setFieldValue("locataire", {});
                                                }
                                            })
                                        })
                                    ]
                                })
                            }),
                            values.isRent && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f76670b5e5897c33), {
                                title: "Locataire",
                                children: [
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                                                    label: "Le locataire est un organisme",
                                                    name: "locataire.oldebLocataireOrganisme",
                                                    required: false
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                                                    label: "Raison sociale",
                                                    name: "locataire.oldebLocataireRaisonSociale",
                                                    disabled: !values.locataire?.oldebLocataireOrganisme,
                                                    required: false
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                                                    name: "locataire.oldebLocataireCivilite",
                                                    listIdCodeLibelle: civiliteList,
                                                    label: "Civilit\xe9",
                                                    defaultValue: civiliteList?.find((v)=>v.id === values.locataire?.oldebLocataireCivilite),
                                                    required: true,
                                                    setFieldValue: setFieldValue
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                                                    label: "Nom",
                                                    name: "locataire.oldebLocataireNom",
                                                    required: true
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                                                    label: "Pr\xe9nom",
                                                    name: "locataire.oldebLocatairePrenom",
                                                    required: true
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                                                    label: "T\xe9l\xe9phone",
                                                    name: "locataire.oldebLocataireTelephone",
                                                    required: false
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                                                    label: "E-mail",
                                                    name: "locataire.oldebLocataireEmail",
                                                    required: false
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec8c33620b91a894$export$2e2bcd8739ae039), {
                        eventKey: "environnement",
                        title: "Environnement",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f76670b5e5897c33), {
                            title: "Environnement",
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$6bf0cd3a219bbade), {
                                            name: "oldeb.oldebVolume",
                                            required: true,
                                            label: "Volume de la ressource en eau mobilisable (m\xb3)",
                                            min: 0,
                                            step: 1
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                            xs: 6,
                                            children: [
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Label, {
                                                    children: "\xc9lements \xe0 v\xe9rifier"
                                                }),
                                                typeCategorieCaracteristiqueState.data?.map((categorie, categorieIdx)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1988c313b8430f65$export$2e2bcd8739ae039), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1988c313b8430f65$export$2e2bcd8739ae039).Header, {
                                                                children: categorie.libelle
                                                            }),
                                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $87d0f3f36f67a4f7$export$2e2bcd8739ae039), {
                                                                children: typeCaracteristiqueState.data?.filter((caracteristique)=>caracteristique.lienId === categorie.id && values.oldeb.caracteristiqueList.indexOf(caracteristique.id) === -1).map((caracteristique)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $87d0f3f36f67a4f7$export$2e2bcd8739ae039).Item, {
                                                                        onClick: ()=>{
                                                                            if (values.oldeb.caracteristiqueList?.indexOf(caracteristique.id) === -1) setFieldValue("oldeb.caracteristiqueList", [
                                                                                ...values.oldeb.caracteristiqueList,
                                                                                caracteristique.id
                                                                            ]);
                                                                        },
                                                                        children: [
                                                                            "(+) ",
                                                                            caracteristique.libelle
                                                                        ]
                                                                    }, caracteristique.id))
                                                            })
                                                        ]
                                                    }, categorieIdx))
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                            xs: 6,
                                            children: [
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $951ad4dd33e349d1$export$2e2bcd8739ae039).Label, {
                                                    children: "\xc9lements pr\xe9sents"
                                                }),
                                                typeCategorieCaracteristiqueState.data?.map((categorie, categorieIdx)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1988c313b8430f65$export$2e2bcd8739ae039), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1988c313b8430f65$export$2e2bcd8739ae039).Header, {
                                                                children: categorie.libelle
                                                            }),
                                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $87d0f3f36f67a4f7$export$2e2bcd8739ae039), {
                                                                className: "list-group-flush",
                                                                children: typeCaracteristiqueState.data?.filter((caracteristique)=>caracteristique.lienId === categorie.id && values.oldeb.caracteristiqueList.indexOf(caracteristique.id) !== -1).map((caracteristique)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $87d0f3f36f67a4f7$export$2e2bcd8739ae039).Item, {
                                                                        onClick: ()=>{
                                                                            setFieldValue("oldeb.caracteristiqueList", values.oldeb.caracteristiqueList.filter((c)=>c !== caracteristique.id));
                                                                        },
                                                                        children: [
                                                                            "(-) ",
                                                                            caracteristique.libelle
                                                                        ]
                                                                    }, caracteristique.id))
                                                            })
                                                        ]
                                                    }, categorieIdx))
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $ec8c33620b91a894$export$2e2bcd8739ae039), {
                        eventKey: "visite",
                        title: "Visites",
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $bkJfK.FieldArray), {
                                name: "visiteList",
                                render: (arrayHelpers)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f76670b5e5897c33), {
                                        title: "Visites",
                                        children: [
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                                                variant: "primary",
                                                onClick: ()=>{
                                                    const now = new Date();
                                                    arrayHelpers.push({
                                                        oldebVisiteCode: (+now).toString(36),
                                                        // code basé sur le timestamp pour upload
                                                        oldebVisiteDateVisite: now,
                                                        oldebVisiteAgent: undefined,
                                                        oldebVisiteObservation: undefined,
                                                        oldebVisiteDebroussaillementParcelleId: undefined,
                                                        oldebVisiteDebroussaillementAccesId: undefined,
                                                        oldebVisiteOldebTypeAvisId: undefined,
                                                        oldebVisiteOldebTypeActionId: undefined,
                                                        anomalieList: [],
                                                        documentList: []
                                                    });
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$4176b1d4e95be624), {}),
                                                    " Ajouter une visite"
                                                ]
                                            }),
                                            currentVisite != null && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $c094b74d2be2aa67$export$2e2bcd8739ae039), {
                                                title: "Supprimer la visite",
                                                onClick: ()=>{
                                                    const toRemove = currentVisite;
                                                    // Suppression des documents associés
                                                    const { // eslint-disable-next-line @typescript-eslint/no-unused-vars
                                                    [values.visiteList[currentVisite].oldebVisiteCode]: _, ...rest } = values.documentList;
                                                    setFieldValue(`documentList`, rest);
                                                    setCurrentVisite(null);
                                                    arrayHelpers.remove(toRemove);
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $13de46b4dfcc473f$export$2e2bcd8739ae039), {
                                                bordered: true,
                                                striped: true,
                                                hover: true,
                                                children: [
                                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("tr", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("th", {
                                                                children: "Date"
                                                            }),
                                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("th", {
                                                                children: "Agent"
                                                            }),
                                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("th", {
                                                                children: "Parcelle"
                                                            }),
                                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("th", {
                                                                children: "Voie"
                                                            }),
                                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("th", {
                                                                children: "Anomalies"
                                                            }),
                                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("th", {
                                                                children: "Avis"
                                                            }),
                                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("th", {
                                                                children: "Action"
                                                            })
                                                        ]
                                                    }),
                                                    values.visiteList?.map((visite, idx)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("tr", {
                                                            onClick: ()=>setCurrentVisite(idx),
                                                            children: [
                                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("td", {
                                                                    children: visite.oldebVisiteDateVisite && (0, $00c47c7740afd024$export$3ae94a2503e890a1)(visite.oldebVisiteDateVisite)
                                                                }),
                                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("td", {
                                                                    children: visite.oldebVisiteAgent
                                                                }),
                                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("td", {
                                                                    children: typeOldebTypeDebrousaillementState?.data?.find((v)=>v.id === visite.oldebVisiteDebroussaillementParcelleId)?.libelle
                                                                }),
                                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("td", {
                                                                    children: typeOldebTypeDebrousaillementState?.data?.find((v)=>v.id === visite.oldebVisiteDebroussaillementAccesId)?.libelle
                                                                }),
                                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("td", {
                                                                    children: visite.anomalieList.length
                                                                }),
                                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("td", {
                                                                    children: typeOldebTypeAvisState?.data?.find((v)=>v.id === visite.oldebVisiteOldebTypeAvisId)?.libelle
                                                                }),
                                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("td", {
                                                                    children: typeOldebTypeActionState?.data?.find((v)=>v.id === visite.oldebVisiteOldebTypeActionId)?.libelle
                                                                })
                                                            ]
                                                        }, idx))
                                                ]
                                            })
                                        ]
                                    })
                            }),
                            currentVisite != null && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$f76670b5e5897c33), {
                                title: "D\xe9tail de la visite",
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($c8405874ffdb506c$var$VisiteForm, {
                                    visiteList: values.visiteList,
                                    documentList: values.documentList,
                                    currentVisite: currentVisite,
                                    setFieldValue: setFieldValue,
                                    typeOldebTypeDebrousaillement: typeOldebTypeDebrousaillementState?.data,
                                    typeOldebTypeAvis: typeOldebTypeAvisState?.data,
                                    typeOldebTypeAction: typeOldebTypeActionState?.data
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db9b0e6fdb142a4c$export$2e2bcd8739ae039), {
                returnLink: returnButton,
                onClick: $c8405874ffdb506c$var$removeFromLocalStorage,
                beforeReturn: $c8405874ffdb506c$var$removeFromLocalStorage
            })
        ]
    });
};
const $c8405874ffdb506c$var$VisiteForm = ({ visiteList: visiteList, documentList: documentList, currentVisite: currentVisite, setFieldValue: setFieldValue, typeOldebTypeDebrousaillement: typeOldebTypeDebrousaillement, typeOldebTypeAvis: typeOldebTypeAvis, typeOldebTypeAction: typeOldebTypeAction })=>{
    const [currentTab, setCurrentTab] = (0, $kc00y.useState)("anomalieList");
    const [currentVisiteSuite, setCurrentVisiteSuite] = (0, $kc00y.useState)(null);
    const typeOldebTypeSuiteState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/nomenclatures/list/${(0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).OLDEB_TYPE_SUITE}`);
    const typeCategorieAnomalieState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/nomenclatures/list/${(0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).OLDEB_TYPE_CATEGORIE_ANOMALIE}`);
    const typeAnomalieState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/oldeb/anomalie`);
    (0, $kc00y.useEffect)(()=>{
        // Changement de visite => reset de la partie "Suites"
        setCurrentVisiteSuite(null);
    }, []);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$183478aa40b5df1), {
                            label: "Date",
                            name: `visiteList.${currentVisite}.oldebVisiteDateVisite`,
                            required: true,
                            value: visiteList[currentVisite].oldebVisiteDateVisite && (0, $00c47c7740afd024$export$cc23f907e4acb548)(visiteList[currentVisite].oldebVisiteDateVisite)
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                            label: "Agent",
                            name: `visiteList.${currentVisite}.oldebVisiteAgent`,
                            required: true
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                            name: `visiteList.${currentVisite}.oldebVisiteDebroussaillementParcelleId`,
                            label: "D\xe9broussaillement parcelle",
                            listIdCodeLibelle: typeOldebTypeDebrousaillement,
                            defaultValue: typeOldebTypeDebrousaillement?.find((v)=>v.id === visiteList[currentVisite].oldebVisiteDebroussaillementParcelleId),
                            required: true,
                            setFieldValue: setFieldValue
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                            name: `visiteList.${currentVisite}.oldebVisiteDebroussaillementAccesId`,
                            label: "D\xe9broussaillement acc\xe8s",
                            listIdCodeLibelle: typeOldebTypeDebrousaillement,
                            defaultValue: typeOldebTypeDebrousaillement?.find((v)=>v.id === visiteList[currentVisite].oldebVisiteDebroussaillementAccesId),
                            required: true,
                            setFieldValue: setFieldValue
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                            name: `visiteList.${currentVisite}.oldebVisiteOldebTypeAvisId`,
                            label: "Avis",
                            listIdCodeLibelle: typeOldebTypeAvis,
                            defaultValue: typeOldebTypeAvis?.find((v)=>v.id === visiteList[currentVisite].oldebVisiteOldebTypeAvisId),
                            required: true,
                            setFieldValue: setFieldValue
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                            name: `visiteList.${currentVisite}.oldebVisiteOldebTypeActionId`,
                            label: "Action",
                            listIdCodeLibelle: typeOldebTypeAction,
                            defaultValue: typeOldebTypeAction?.find((v)=>v.id === visiteList[currentVisite].oldebVisiteOldebTypeActionId),
                            required: true,
                            setFieldValue: setFieldValue
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $5f8ed132be8030d8$export$2e2bcd8739ae039), {
                id: "tabs",
                activeKey: currentTab,
                onSelect: (key)=>key && setCurrentTab(key),
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec8c33620b91a894$export$2e2bcd8739ae039), {
                        eventKey: "anomalieList",
                        title: "Anomalies",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $69c77a5b3889bd0f$export$2e2bcd8739ae039), {
                            children: typeCategorieAnomalieState.data?.map((categorie, categorieIdx)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $69c77a5b3889bd0f$export$2e2bcd8739ae039).Item, {
                                    eventKey: categorieIdx.toString(),
                                    children: [
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $69c77a5b3889bd0f$export$2e2bcd8739ae039).Header, {
                                            children: categorie.libelle
                                        }),
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $69c77a5b3889bd0f$export$2e2bcd8739ae039).Body, {
                                            children: typeAnomalieState?.data?.filter((anomalie)=>anomalie.lienId === categorie.id).map((anomalie, anomalieIdx)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                                                        label: anomalie.libelle,
                                                        name: `visiteList.${currentVisite}.anomalieList[]`,
                                                        checked: visiteList[currentVisite].anomalieList.indexOf(anomalie.id) !== -1,
                                                        onChange: ()=>{
                                                            if (visiteList[currentVisite].anomalieList.indexOf(anomalie.id) === -1) setFieldValue(`visiteList.${currentVisite}.anomalieList`, [
                                                                ...visiteList[currentVisite].anomalieList,
                                                                anomalie.id
                                                            ]);
                                                            else setFieldValue(`visiteList.${currentVisite}.anomalieList`, visiteList[currentVisite].anomalieList.filter((a)=>a !== anomalie.id));
                                                        }
                                                    })
                                                }, anomalieIdx))
                                        })
                                    ]
                                }, categorieIdx))
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec8c33620b91a894$export$2e2bcd8739ae039), {
                        eventKey: "suiteList",
                        title: "Suites",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $bkJfK.FieldArray), {
                            name: `visiteList.${currentVisite}.suiteList`,
                            render: (arrayHelpers)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                                            variant: "primary",
                                            onClick: ()=>arrayHelpers.push({
                                                    oldebVisiteSuiteDate: new Date(),
                                                    oldebVisiteSuiteOldebTypeSuiteId: undefined,
                                                    oldebVisiteSuiteObservation: undefined
                                                }),
                                            children: [
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$4176b1d4e95be624), {}),
                                                " Ajouter une suite"
                                            ]
                                        }),
                                        currentVisiteSuite != null && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $c094b74d2be2aa67$export$2e2bcd8739ae039), {
                                            title: "Supprimer la suite",
                                            onClick: ()=>{
                                                const toRemove = currentVisiteSuite;
                                                setCurrentVisiteSuite(null);
                                                arrayHelpers.remove(toRemove);
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $13de46b4dfcc473f$export$2e2bcd8739ae039), {
                                            bordered: true,
                                            striped: true,
                                            hover: true,
                                            children: [
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("th", {
                                                            children: "Date"
                                                        }),
                                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("th", {
                                                            children: "Type"
                                                        }),
                                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("th", {
                                                            children: "Observation"
                                                        })
                                                    ]
                                                }),
                                                visiteList[currentVisite]?.suiteList?.map((visiteSuite, idx)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("tr", {
                                                        onClick: ()=>setCurrentVisiteSuite(idx),
                                                        children: [
                                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("td", {
                                                                children: visiteSuite.oldebVisiteSuiteDate && (0, $00c47c7740afd024$export$3ae94a2503e890a1)(visiteSuite.oldebVisiteSuiteDate)
                                                            }),
                                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("td", {
                                                                children: typeOldebTypeSuiteState?.data?.find((v)=>v.id === visiteSuite.oldebVisiteSuiteOldebTypeSuiteId)?.libelle
                                                            }),
                                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("td", {
                                                                children: visiteSuite.oldebVisiteSuiteObservation
                                                            })
                                                        ]
                                                    }, idx))
                                            ]
                                        }),
                                        currentVisiteSuite != null && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($c8405874ffdb506c$var$VisiteSuiteForm, {
                                            fieldName: `visiteList.${currentVisite}`,
                                            setFieldValue: setFieldValue,
                                            currentVisiteSuiteList: visiteList[currentVisite].suiteList,
                                            currentVisiteSuiteIdx: currentVisiteSuite,
                                            typeOldebTypeSuite: typeOldebTypeSuiteState?.data
                                        })
                                    ]
                                })
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $ec8c33620b91a894$export$2e2bcd8739ae039), {
                        eventKey: "documentList",
                        title: "Documents",
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b57af79a4ab2a1c6), {
                                multiple: true,
                                accept: "image/*,.pdf",
                                required: false,
                                name: `documentHolder`,
                                onChange: (e)=>{
                                    if (e.target.files.length) // /!\ CASCADE RÉALISÉE PAR UN PROFESSIONNEL /!\
                                    setFieldValue(`documentList`, {
                                        ...documentList,
                                        [visiteList[currentVisite].oldebVisiteCode]: [
                                            ...documentList[visiteList[currentVisite].oldebVisiteCode] || [],
                                            ...e.target.files
                                        ]
                                    });
                                    e.target.value = null;
                                    setFieldValue(`documentHolder`, null);
                                }
                            }),
                            visiteList[currentVisite].documentList.length > 0 && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$f76670b5e5897c33), {
                                title: "Fichiers existants",
                                children: visiteList[currentVisite].documentList?.map((file, index)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                                        children: [
                                            file.documentNom,
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $98f55aa78fbaf278$export$2e2bcd8739ae039), {
                                                pill: true,
                                                bg: "info",
                                                onClick: ()=>{
                                                    const win = window.open(file.documentUrl, "_blank");
                                                    win?.focus();
                                                },
                                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$4a5ccdc9878f4668), {})
                                            }),
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $98f55aa78fbaf278$export$2e2bcd8739ae039), {
                                                pill: true,
                                                bg: "danger",
                                                onClick: ()=>{
                                                    setFieldValue(`visiteList.${currentVisite}.documentList`, visiteList[currentVisite].documentList.filter((v, i)=>i !== index));
                                                },
                                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$4d4e10ce882b8153), {})
                                            })
                                        ]
                                    }, index))
                            }),
                            documentList[visiteList[currentVisite].oldebVisiteCode] && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$f76670b5e5897c33), {
                                title: "Fichiers ajout\xe9s",
                                children: documentList[visiteList[currentVisite].oldebVisiteCode].map((file, index)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                                        children: [
                                            file.name,
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $98f55aa78fbaf278$export$2e2bcd8739ae039), {
                                                pill: true,
                                                bg: "danger",
                                                onClick: ()=>{
                                                    setFieldValue(`documentList.${visiteList[currentVisite].oldebVisiteCode}`, documentList[visiteList[currentVisite].oldebVisiteCode].filter((v, i)=>i !== index));
                                                },
                                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$4d4e10ce882b8153), {})
                                            })
                                        ]
                                    }, index))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec8c33620b91a894$export$2e2bcd8739ae039), {
                        eventKey: "observation",
                        title: "Observations",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$ce9b1cc0c34506d0), {
                            name: `visiteList.${currentVisite}.oldebVisiteObservation`,
                            required: false
                        })
                    })
                ]
            })
        ]
    });
};
const $c8405874ffdb506c$var$VisiteSuiteForm = ({ fieldName: fieldName, setFieldValue: setFieldValue, currentVisiteSuiteList: currentVisiteSuiteList, currentVisiteSuiteIdx: currentVisiteSuiteIdx, typeOldebTypeSuite: typeOldebTypeSuite })=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$183478aa40b5df1), {
                    label: "Date",
                    name: `${fieldName}.suiteList.${currentVisiteSuiteIdx}.oldebVisiteSuiteDate`,
                    required: true,
                    value: currentVisiteSuiteList[currentVisiteSuiteIdx].oldebVisiteSuiteDate && (0, $00c47c7740afd024$export$cc23f907e4acb548)(currentVisiteSuiteList[currentVisiteSuiteIdx].oldebVisiteSuiteDate)
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                    name: `${fieldName}.suiteList.${currentVisiteSuiteIdx}.oldebVisiteSuiteOldebTypeSuiteId`,
                    label: "Type",
                    listIdCodeLibelle: typeOldebTypeSuite,
                    defaultValue: typeOldebTypeSuite?.find((v)=>v.id === currentVisiteSuiteList[currentVisiteSuiteIdx].oldebVisiteSuiteOldebTypeSuiteId),
                    required: true,
                    setFieldValue: setFieldValue
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                    label: "Observation",
                    name: `${fieldName}.suiteList.${currentVisiteSuiteIdx}.oldebVisiteSuiteObservation`,
                    required: false
                })
            })
        ]
    });
};
var $c8405874ffdb506c$export$2e2bcd8739ae039 = $c8405874ffdb506c$var$OldebForm;


const $b4a8af4eb541f4bc$var$OldebCreate = ()=>{
    // En cas de création via la carte, on récupère les coordonnées via localStorage
    const state = JSON.parse(localStorage.getItem("mapContent") || "{}");
    const { epsg: contextEpsg, srid: contextSrid } = (0, $e787cde576104469$export$fdc397e486fa83e7)();
    const initialValues = (0, $c8405874ffdb506c$export$a5cab80145b70e98)();
    const { wkt: wkt = null, epsg: epsg = null, ...rest } = state;
    if (wkt && epsg) {
        // On récupère le WKT et on s'assure de repecter la projection du serveur
        const wkt = new (0, $15a985d09649bdc2$export$2e2bcd8739ae039)();
        const geometry = wkt.readFeature(state.wkt, {
            dataProjection: epsg,
            // Projection du WKT depuis la carte
            featureProjection: contextEpsg.name // ESPG fourni par le serveur
        });
        initialValues.oldeb.oldebGeometrie = `SRID=${contextSrid};${wkt.writeFeature(geometry)}`;
        // On vide le state
        window.history.replaceState(rest, "");
    }
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$5d9c28f3fa3ba1a), {}),
                title: "Cr\xe9ation d'une Obligation L\xe9gale de D\xe9broussaillement"
            }),
            initialValues.oldeb.oldebGeometrie ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                initialValues: initialValues,
                validationSchema: (0, $c8405874ffdb506c$export$c084437b5e3206cd),
                isPost: true,
                isMultipartFormData: true,
                submitUrl: `/api/oldeb/create`,
                prepareVariables: (values)=>(0, $c8405874ffdb506c$export$8470ef9d0802da38)(values),
                redirectUrl: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).OLDEB_LIST,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $c8405874ffdb506c$export$2e2bcd8739ae039), {
                    isNew: true
                })
            }) : /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
                children: "Impossible de cr\xe9er une Obligation L\xe9gale de D\xe9broussaillement sans utiliser l'onglet Localisation."
            })
        ]
    });
};
var $b4a8af4eb541f4bc$export$2e2bcd8739ae039 = $b4a8af4eb541f4bc$var$OldebCreate;

















const $6b5abb3c84394e92$var$filterValuesToVariable = ({ oldebCommune: oldebCommune, oldebSection: oldebSection, oldebParcelle: oldebParcelle, oldebTypeZoneUrbanisme: oldebTypeZoneUrbanisme, oldebTypeDebroussaillement: oldebTypeDebroussaillement, oldebTypeAvis: oldebTypeAvis })=>{
    const filter = {};
    $6b5abb3c84394e92$var$pushFilterItem(filter, oldebCommune, "oldebCommune");
    $6b5abb3c84394e92$var$pushFilterItem(filter, oldebSection, "oldebSection");
    $6b5abb3c84394e92$var$pushFilterItem(filter, oldebParcelle, "oldebParcelle");
    $6b5abb3c84394e92$var$pushFilterItem(filter, oldebTypeZoneUrbanisme, "oldebTypeZoneUrbanisme");
    $6b5abb3c84394e92$var$pushFilterItem(filter, oldebTypeDebroussaillement, "oldebTypeDebroussaillement");
    $6b5abb3c84394e92$var$pushFilterItem(filter, oldebTypeAvis, "oldebTypeAvis");
    return filter;
};
var $6b5abb3c84394e92$export$2e2bcd8739ae039 = $6b5abb3c84394e92$var$filterValuesToVariable;
function $6b5abb3c84394e92$var$pushFilterItem(filter, value, name) {
    if (value?.trim().length > 0) filter[name] = value;
}


const $f6ecdcec5b37cf39$var$OldebList = ()=>{
    const { fetchGeometry: fetchGeometry } = (0, $a178c3075f0f40bb$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$5d9c28f3fa3ba1a), {}),
                title: "Liste des Obligations L\xe9gales de D\xe9broussaillement"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $9a9eebc3462fba73$export$2e2bcd8739ae039), {
                query: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/oldeb`,
                columns: [
                    {
                        Header: "Commune",
                        accessor: "oldebCommune",
                        sortField: "oldebCommune",
                        Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $dd08a763d100724f$export$2e2bcd8739ae039), {
                            name: "oldebCommune",
                            url: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/commune/get-libelle-commune`
                        })
                    },
                    {
                        Header: "Section",
                        accessor: "oldebSection",
                        sortField: "oldebSection",
                        Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                            type: "text",
                            name: "oldebSection"
                        })
                    },
                    {
                        Header: "Parcelle",
                        accessor: "oldebParcelle",
                        sortField: "oldebParcelle",
                        Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                            type: "text",
                            name: "oldebParcelle"
                        })
                    },
                    {
                        Header: "Adresse",
                        accessor: "oldebAdresse"
                    },
                    {
                        Header: "Type zone",
                        accessor: "oldebTypeZoneUrbanisme",
                        sortField: "oldebTypeZoneUrbanisme",
                        Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $bcc3791b22f76942$export$2e2bcd8739ae039), {
                            name: "oldebTypeZoneUrbanisme",
                            nomenclature: (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).OLDEB_TYPE_ZONE_URBANISME
                        })
                    },
                    {
                        Header: "Derni\xe8re visite",
                        accessor: "oldebDateDerniereVisite",
                        sortField: "oldebDateDerniereVisite",
                        Cell: (value)=>{
                            return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                children: value?.value != null && (0, $00c47c7740afd024$export$3ae94a2503e890a1)(value.value)
                            });
                        }
                    },
                    {
                        Header: "D\xe9broussaillement",
                        accessor: "oldebTypeDebroussaillement",
                        sortField: "oldebTypeDebroussaillement",
                        Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $bcc3791b22f76942$export$2e2bcd8739ae039), {
                            name: "oldebTypeDebroussaillement",
                            nomenclature: (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).OLDEB_TYPE_DEBROUSSAILLEMENT
                        })
                    },
                    {
                        Header: "Avis",
                        accessor: "oldebTypeAvis",
                        sortField: "oldebTypeAvis",
                        Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $bcc3791b22f76942$export$2e2bcd8739ae039), {
                            name: "oldebTypeAvis",
                            nomenclature: (0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).OLDEB_TYPE_AVIS
                        })
                    },
                    (0, $b82b937cc97f6f18$export$36e9f5a475c9f6fc)({
                        Header: "Actions",
                        accessor: "oldebId",
                        buttons: [
                            {
                                row: (row)=>{
                                    return row;
                                },
                                route: (oldebId)=>(0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).OLDEB_UPDATE(oldebId),
                                type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).UPDATE,
                                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$b51dd496211ae105), {})
                            },
                            {
                                row: (row)=>{
                                    return row;
                                },
                                pathname: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/oldeb/`,
                                type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).DELETE,
                                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$4d4e10ce882b8153), {})
                            },
                            {
                                row: (row)=>{
                                    return row;
                                },
                                onClick: (oldebId)=>{
                                    fetchGeometry((0, $a178c3075f0f40bb$export$970c58a942355206).OLDEB, oldebId, (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).OLDEB_LOCALISATION);
                                },
                                type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).LINK,
                                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$cbe811cb8e919f27), {}),
                                textEnable: "Localiser",
                                classEnable: "primary"
                            }
                        ]
                    })
                ],
                idName: "oldebId",
                filterValuesToVariable: (0, $6b5abb3c84394e92$export$2e2bcd8739ae039),
                filterContext: (0, $9a9eebc3462fba73$export$396ef541d9951d45)({})
            })
        ]
    });
};
var $f6ecdcec5b37cf39$export$2e2bcd8739ae039 = $f6ecdcec5b37cf39$var$OldebList;





var $kc00y = parcelRequire("kc00y");












var $kc00y = parcelRequire("kc00y");













const $ad3c623442282343$export$8d8a7eb954585c17 = ({ map: map, workingLayer: workingLayer, dataOldebLayer: dataOldebLayer })=>{
    const navigate = (0, $7a844823b04d4282$export$9770f232ac06a008)();
    const location = (0, $7a844823b04d4282$export$45d76561a5302f2b)();
    const { success: successToast } = (0, $6bdae0bad7b05751$export$91b3d218c74c79e4)();
    const { error: errorToast } = (0, $6bdae0bad7b05751$export$91b3d218c74c79e4)();
    const [editOldebs, setEditOldebs] = (0, $kc00y.useState)(null);
    function closeEdit() {
        workingLayer?.getSource().clear();
        setEditOldebs(null);
    }
    const tools = (0, $kc00y.useMemo)(()=>{
        if (!map) return {};
        const createCtrl = new (0, $2ef894158a48397d$export$2e2bcd8739ae039)({
            source: workingLayer?.getSource(),
            type: "Polygon"
        });
        createCtrl.on("drawend", async (event)=>{
            (await fetch((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/zone-integration/check`, (0, $fbd4d34e07af0ac7$export$b163ec2f884327db)({
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    geometry: "SRID=" + map.getView().getProjection().getCode().split(":").pop() + ";" + new (0, $15a985d09649bdc2$export$2e2bcd8739ae039)().writeFeature(event.feature)
                })
            }))).text().then((text)=>{
                if (text === "true") {
                    localStorage.setItem("mapContent", JSON.stringify({
                        wkt: new (0, $15a985d09649bdc2$export$2e2bcd8739ae039)().writeFeature(event.feature),
                        epsg: map.getView().getProjection().getCode()
                    }));
                    navigate((0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).OLDEB_CREATE, {
                        state: {
                            ...location.state
                        }
                    });
                } else {
                    workingLayer?.getSource().removeFeature(event.feature);
                    errorToast(text);
                }
            }).catch((reason)=>{
                workingLayer?.getSource().removeFeature(event.feature);
                errorToast(reason);
            });
        });
        const selectCtrl = new (0, $20af4deb83586389$export$2e2bcd8739ae039)({
            toggleCondition: (0, $638912a122b4daef$export$f3100d8d6292d638)
        });
        const dragBoxCtrl = new (0, $886371f562c99b97$export$2e2bcd8739ae039)({
            style: new (0, $a5fc261473972d1d$export$2e2bcd8739ae039)({
                stroke: new (0, $281691897fddf9d0$export$2e2bcd8739ae039)({
                    color: [
                        0,
                        0,
                        255,
                        1
                    ]
                })
            }),
            minArea: 25
        });
        dragBoxCtrl.on("boxend", (e)=>{
            if (!(0, $638912a122b4daef$export$f3100d8d6292d638)(e.mapBrowserEvent)) selectCtrl.getFeatures().clear();
            const boxExtent = dragBoxCtrl.getGeometry().getExtent();
            const boxFeatures = dataOldebLayer?.getSource().getFeaturesInExtent(boxExtent);
            selectCtrl.getFeatures().extend(boxFeatures);
        });
        const editGeometrieCtrl = new (0, $2375ecf9b29b2a49$export$2e2bcd8739ae039)({
            source: dataOldebLayer.getSource()
        });
        editGeometrieCtrl.on("modifyend", (event)=>{
            if (!event.features || event.features.getLength() !== 1) return;
            event.features.forEach(async (feature)=>{
                (await fetch((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/zone-integration/check`, (0, $fbd4d34e07af0ac7$export$b163ec2f884327db)({
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        geometry: "SRID=" + map.getView().getProjection().getCode().split(":").pop() + ";" + new (0, $15a985d09649bdc2$export$2e2bcd8739ae039)().writeFeature(feature)
                    })
                }))).text().then((text)=>{
                    if (text === "true") fetch((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/oldeb/${feature.getProperties().elementId}/geometry`, (0, $fbd4d34e07af0ac7$export$b163ec2f884327db)({
                        method: "PATCH",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify({
                            oldebId: feature.getProperties().elementId,
                            oldebGeometrie: `SRID=${map.getView().getProjection().getCode().split(":").pop()};${new (0, $15a985d09649bdc2$export$2e2bcd8739ae039)().writeFeature(feature)}`
                        })
                    })).then((res)=>{
                        if (res.status === 200) {
                            successToast("G\xe9om\xe9trie modifi\xe9e");
                            (0, $1ed1be1197ad1bc4$export$51ba454167fb25ab)(map);
                        }
                    });
                    else {
                        workingLayer?.getSource().removeFeature(event.feature);
                        errorToast(text);
                    }
                }).catch((reason)=>{
                    workingLayer?.getSource().removeFeature(event.feature);
                    errorToast(reason);
                });
            });
        });
        const editSelectCtrl = new (0, $2ef894158a48397d$export$2e2bcd8739ae039)({
            source: workingLayer?.getSource(),
            type: "Point"
        });
        editSelectCtrl.on("drawstart", async ()=>{
            // on clear le workingLayer avant de dessiner un nouveau point
            workingLayer?.getSource().clear();
        });
        editSelectCtrl.on("drawend", async (event)=>{
            const pointGeom = event.feature.getGeometry();
            const workingSource = workingLayer?.getSource();
            if (workingSource) workingSource.removeFeature(event.feature);
            const tolerance = 5;
            const pixel = map.getPixelFromCoordinate(pointGeom.getCoordinates());
            const featuresAtPixel = [];
            map.forEachFeatureAtPixel(pixel, (feature, layer)=>{
                if (layer === dataOldebLayer) featuresAtPixel.push({
                    oldebId: feature.getProperties().elementId,
                    properties: feature.getProperties().propertiesToDisplay
                });
            }, {
                hitTolerance: tolerance
            });
            if (featuresAtPixel.length > 0) setEditOldebs(JSON.stringify(featuresAtPixel));
            else {
                workingLayer?.getSource().clear();
                errorToast("Aucune OLDEB trouv\xe9e");
            }
        });
        function toggleCreate(active = false) {
            const idx = map?.getInteractions().getArray().indexOf(createCtrl);
            if (active) {
                if (idx === -1) map.addInteraction(createCtrl);
            } else map.removeInteraction(createCtrl);
        }
        function toggleEditGeometrie(active = false) {
            const idx = map?.getInteractions().getArray().indexOf(editGeometrieCtrl);
            if (active) {
                if (idx === -1) map.addInteraction(editGeometrieCtrl);
            } else map.removeInteraction(editGeometrieCtrl);
        }
        function toggleEdit(active = false) {
            const idx = map?.getInteractions().getArray().indexOf(editSelectCtrl);
            if (active) {
                if (idx === -1) map.addInteraction(editSelectCtrl);
            } else map.removeInteraction(editSelectCtrl);
        }
        const tools = {
            "edit-geometrie-oldeb": {
                action: toggleEditGeometrie,
                actionPossibleEnDeplacement: false
            },
            "create-oldeb": {
                action: toggleCreate
            },
            "edit-oldeb": {
                action: toggleEdit
            }
        };
        return tools;
    }, [
        map,
        dataOldebLayer,
        successToast,
        errorToast,
        navigate,
        location,
        workingLayer?.getSource
    ]);
    return {
        tools: tools,
        editOldebs: editOldebs,
        setEditOldebs: setEditOldebs,
        closeEdit: closeEdit
    };
};
const $ad3c623442282343$var$OldebMapToolbar = ({ toggleTool: toggleToolCallback, activeTool: activeTool, selectedOldebId: selectedOldebId, dataOldebLayer: dataOldebLayer })=>{
    const { user: user } = (0, $e787cde576104469$export$fdc397e486fa83e7)();
    // Style de surbrillance bleu
    const blueHighlightStyle = new (0, $a5fc261473972d1d$export$2e2bcd8739ae039)({
        stroke: new (0, $281691897fddf9d0$export$2e2bcd8739ae039)({
            color: "blue",
            width: 3
        }),
        fill: new (0, $8624b871a0af6dab$export$2e2bcd8739ae039)({
            color: "rgba(0, 0, 255, 0.1)"
        })
    });
    // Surbrillance sur la carte lors de la sélection
    const lastHighlightedRef = (0, $kc00y.useRef)(null);
    (0, $kc00y.useEffect)(()=>{
        if (!dataOldebLayer) return;
        const features = dataOldebLayer.getSource()?.getFeatures() || [];
        // Enlève la surbrillance de l'ancien
        if (lastHighlightedRef.current) {
            lastHighlightedRef.current.setStyle(null);
            lastHighlightedRef.current = null;
        }
        // Applique la surbrillance uniquement sur le nouveau
        if (selectedOldebId) {
            const feat = features.find((f)=>f.getProperties().elementId === selectedOldebId);
            if (feat) {
                feat.setStyle(blueHighlightStyle);
                lastHighlightedRef.current = feat;
            }
        }
        return ()=>{
            if (lastHighlightedRef.current) {
                lastHighlightedRef.current.setStyle(null);
                lastHighlightedRef.current = null;
            }
        };
    }, [
        selectedOldebId,
        dataOldebLayer,
        blueHighlightStyle
    ]);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $a43e6f68e14bab96$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1ac4483a0721609f$export$2e2bcd8739ae039), {
                codeThematique: (0, $690fed8fd87ee1b4$export$2e2bcd8739ae039).OLDEBS,
                titreVolet: "Liste des documents li\xe9s aux OLDEB"
            }),
            (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).OLDEB_C) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $f2eef644ac9323e0$export$2e2bcd8739ae039), {
                toolName: "create-oldeb",
                toolIcon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$d776d19dfae66ece), {}),
                toolLabelTooltip: "Cr\xe9er une OLDEB",
                toggleTool: toggleToolCallback,
                activeTool: activeTool
            }),
            (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).OLDEB_U) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $f2eef644ac9323e0$export$2e2bcd8739ae039), {
                toolName: "edit-geometrie-oldeb",
                toolIcon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$3581a0f12e3918d1), {}),
                toolLabelTooltip: "Modifier la g\xe9om\xe9trie d'une OLDEB",
                toggleTool: toggleToolCallback,
                activeTool: activeTool
            }),
            ((0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).OLDEB_U) || (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).OLDEB_D)) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $f2eef644ac9323e0$export$2e2bcd8739ae039), {
                toolName: "edit-oldeb",
                toolIcon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$b51dd496211ae105), {}),
                toolLabelTooltip: "Modifier une OLDEB",
                toggleTool: toggleToolCallback,
                activeTool: activeTool
            })
        ]
    });
};
$ad3c623442282343$var$OldebMapToolbar.displayName = "OldebMapToolbar";
var $ad3c623442282343$export$2e2bcd8739ae039 = $ad3c623442282343$var$OldebMapToolbar;












const $c950aa48c8abce84$var$OldebSelectionForUpdate = ({ editOldebs: editOldebs, onClose: onClose, onEdit: onEdit, selectedOldebId: selectedOldebId, setSelectedOldebId: setSelectedOldebId, dataOldebLayer: dataOldebLayer, map: map, closeEdit: closeEdit })=>{
    const { user: user } = (0, $e787cde576104469$export$fdc397e486fa83e7)();
    let oldebsArray = [];
    if (editOldebs) oldebsArray = JSON.parse(editOldebs);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
        className: "bg-light p-3 h-100 d-flex flex-column",
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                className: "d-flex justify-content-between align-items-center mb-2 flex-shrink-0",
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                        icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$5d9c28f3fa3ba1a), {}),
                        displayReturnButton: false,
                        title: "Modifier une OLDEB"
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $80bef9dfc5e82bc1$export$2e2bcd8739ae039), {
                        "aria-label": "Fermer",
                        onClick: onClose
                    })
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                className: "overflow-auto flex-grow-1",
                children: oldebsArray.map((oldebs)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                        className: `card bg-secondary mb-3 rounded${selectedOldebId === oldebs.oldebId ? " border-primary border-3" : ""}`,
                        onMouseEnter: ()=>setSelectedOldebId(oldebs.oldebId),
                        onMouseLeave: ()=>setSelectedOldebId(null),
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                            className: "card-body",
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                className: "justify-content-center align-items-center",
                                children: [
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                        xs: 8,
                                        className: "card-text",
                                        dangerouslySetInnerHTML: {
                                            __html: oldebs.properties
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                        xs: 1,
                                        className: "d-flex justify-content-center align-items-center",
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                                            tooltipText: "Modifier cette OLDEB",
                                            tooltipId: oldebs.oldebId,
                                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                                                variant: "link",
                                                className: "p-0 m-0 text-decoration-none text-info",
                                                onClick: ()=>{
                                                    onEdit(oldebs.oldebId);
                                                    setSelectedOldebId(oldebs.oldebId);
                                                },
                                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$b51dd496211ae105), {})
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                        className: "d-flex justify-content-center align-items-center",
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                                            tooltipText: "Supprimer cette OLDEB",
                                            tooltipId: oldebs.oldebId,
                                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $261998279c461521$export$2e2bcd8739ae039), {
                                                path: `/api/oldeb/${oldebs.oldebId}`,
                                                disabled: !(0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).OLDEB_D),
                                                title: false,
                                                header: "Suppression d'une OLDEB",
                                                content: `Voulez-vous supprimer cette OLDEB ?`,
                                                variant: "link",
                                                className: "text-decoration-none text-danger",
                                                reload: ()=>{
                                                    closeEdit();
                                                    dataOldebLayer.getSource()?.refresh();
                                                    (0, $1ed1be1197ad1bc4$export$51ba454167fb25ab)(map);
                                                }
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    }, oldebs.oldebId))
            })
        ]
    });
};
var $c950aa48c8abce84$export$2e2bcd8739ae039 = $c950aa48c8abce84$var$OldebSelectionForUpdate;












const $4e92f660e4837a43$var$OldebUpdate = ({ oldebIdCarte: oldebIdCarte, onClose: onClose })=>{
    const { oldebId: oldebId } = (0, $7a844823b04d4282$export$99eaa27ddbbb95ef)();
    const oldebIdFinal = oldebIdCarte ?? oldebId;
    const oldebState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)(oldebIdFinal ? (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/oldeb/${oldebIdFinal}` : "");
    return oldebIdFinal && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$5d9c28f3fa3ba1a), {}),
                title: "Mise \xe0 jour d'une Obligation L\xe9gale de D\xe9broussaillement",
                displayReturnButton: oldebIdCarte == null
            }),
            oldebState.data && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                initialValues: (0, $c8405874ffdb506c$export$a5cab80145b70e98)(oldebState.data),
                validationSchema: (0, $c8405874ffdb506c$export$c084437b5e3206cd),
                isPost: false,
                isMultipartFormData: true,
                submitUrl: `/api/oldeb/${oldebIdFinal}`,
                prepareVariables: (values)=>(0, $c8405874ffdb506c$export$8470ef9d0802da38)(values),
                redirectUrl: !oldebIdCarte ? (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).OLDEB_LIST : undefined,
                onSubmit: ()=>onClose(),
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $c8405874ffdb506c$export$2e2bcd8739ae039), {
                    returnButton: oldebIdCarte == null
                })
            })
        ]
    });
};
var $4e92f660e4837a43$export$2e2bcd8739ae039 = $4e92f660e4837a43$var$OldebUpdate;


const $a3eff75f5a09a065$var$OldebMap = ()=>{
    const { state: state } = (0, $7a844823b04d4282$export$45d76561a5302f2b)();
    const mapElement = (0, $kc00y.useRef)();
    const { map: map, workingLayer: workingLayer, availableLayers: availableLayers, addOrRemoveLayer: addOrRemoveLayer, showOutilI: showOutilI, layerListRef: layerListRef, mapToolbarRef: mapToolbarRef, projection: projection } = (0, $cdcdd8e1ff041f79$export$547f9c492d831282)({
        mapElement: mapElement,
        typeModule: (0, $a9754922f4c67d47$export$ef88b514e4bfff34).OLDEBS,
        displayPei: false
    });
    const dataOldebLayer = (0, $kc00y.useMemo)(()=>{
        if (!map) return;
        return (0, $1ed1be1197ad1bc4$export$a3178456480ccf5b)(map, (extent, projection)=>`/api/oldeb/layer?bbox=` + extent.join(",") + "&srid=" + projection.getCode(), projection);
    }, [
        map,
        projection
    ]);
    const { tools: extraTools, editOldebs: editOldebs, setEditOldebs: setEditOldebs, closeEdit: closeEdit } = (0, $ad3c623442282343$export$8d8a7eb954585c17)({
        map: map,
        workingLayer: workingLayer,
        dataOldebLayer: dataOldebLayer
    });
    const [oldebIdModifie, setOldebIdModifie] = (0, $kc00y.useState)(null);
    const [selectedOldebId, setSelectedOldebId] = (0, $kc00y.useState)(null);
    const { toggleTool: toggleTool, activeTool: activeTool, handleCloseInfoI: handleCloseInfoI, infoOutilI: infoOutilI } = (0, $e2b798e23180fa76$export$194c7727cbdc0cac)({
        availableLayers: availableLayers,
        map: map,
        workingLayer: workingLayer,
        extraTools: extraTools
    });
    (0, $kc00y.useEffect)(()=>{
        if (state?.target && map) {
            map.getView().fit((0, $a86eee1c28205a05$export$751c68e0e0efff79)(state.target.extent, `EPSG:${state.target.srid}`, map.getView().getProjection().getCode()), {
                maxZoom: 20
            });
            window.history.replaceState({
                from: state.from
            }, "");
        }
    }, [
        state,
        map
    ]);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
        className: "map-page-wrapper",
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                className: "map-page-map-col",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $cdcdd8e1ff041f79$export$2e2bcd8739ae039), {
                    outilI: infoOutilI,
                    handleCloseInfoI: handleCloseInfoI,
                    showOutilI: showOutilI,
                    map: map,
                    availableLayers: availableLayers,
                    addOrRemoveLayer: addOrRemoveLayer,
                    layerListRef: layerListRef,
                    mapToolbarRef: mapToolbarRef,
                    mapElement: mapElement,
                    toggleTool: toggleTool,
                    activeTool: activeTool || "",
                    toolbarElement: mapToolbarRef.current && map && dataOldebLayer && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ad3c623442282343$export$2e2bcd8739ae039), {
                        toggleTool: toggleTool,
                        activeTool: activeTool || "",
                        oldebIdModifie: oldebIdModifie,
                        setOldebIdModifie: setOldebIdModifie,
                        selectedOldebId: selectedOldebId,
                        setSelectedOldebId: setSelectedOldebId,
                        closeEdit: ()=>{
                            closeEdit();
                            setOldebIdModifie(null);
                            setSelectedOldebId(null);
                        },
                        dataOldebLayer: dataOldebLayer
                    })
                })
            }),
            editOldebs && !oldebIdModifie && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                xs: 3,
                className: "border-primary border-start border-3 position-static",
                style: {
                    maxHeight: "85vh"
                },
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $c950aa48c8abce84$export$2e2bcd8739ae039), {
                    editOldebs: editOldebs,
                    onClose: ()=>setEditOldebs(null),
                    onEdit: (id)=>{
                        setOldebIdModifie(id);
                        setSelectedOldebId(id);
                    },
                    selectedOldebId: selectedOldebId,
                    setSelectedOldebId: setSelectedOldebId,
                    dataOldebLayer: dataOldebLayer,
                    map: map,
                    closeEdit: closeEdit
                })
            }),
            oldebIdModifie && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                xs: 5,
                className: "border-primary border-start border-3 overflow-y-scroll position-static",
                style: {
                    maxHeight: "85vh"
                },
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                    className: "bg-light p-2",
                    children: [
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                            className: "d-flex justify-content-end mb-2",
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $80bef9dfc5e82bc1$export$2e2bcd8739ae039), {
                                "aria-label": "Fermer",
                                onClick: ()=>setOldebIdModifie(null)
                            })
                        }),
                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $4e92f660e4837a43$export$2e2bcd8739ae039), {
                            oldebIdCarte: oldebIdModifie,
                            onClose: ()=>{
                                closeEdit();
                                dataOldebLayer?.getSource()?.refresh();
                                setOldebIdModifie(null);
                            }
                        })
                    ]
                })
            })
        ]
    });
};
var $a3eff75f5a09a065$export$2e2bcd8739ae039 = $a3eff75f5a09a065$var$OldebMap;










var $bkJfK = parcelRequire("bkJfK");







const $c440bb37f7608098$export$a5cab80145b70e98 = (data)=>data || {};
const $c440bb37f7608098$export$8470ef9d0802da38 = (values)=>values;
const $c440bb37f7608098$export$c084437b5e3206cd = (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({
    oldebProprietaireOrganisme: (0, $ce4de947442b2ab1$export$87b259aa03e3d267)(),
    oldebProprietaireRaisonSociale: (0, $ce4de947442b2ab1$export$22b082955e083ec3)(),
    oldebProprietaireCivilite: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
    oldebProprietaireNom: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
    oldebProprietairePrenom: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
    oldebProprietaireTelephone: (0, $ce4de947442b2ab1$export$22b082955e083ec3)(),
    oldebProprietaireEmail: (0, $36ceaed6faf947af$export$d290fa47940df19d),
    oldebProprietaireNumVoie: (0, $ce4de947442b2ab1$export$22b082955e083ec3)(),
    oldebProprietaireVoie: (0, $ce4de947442b2ab1$export$22b082955e083ec3)(),
    oldebProprietaireLieuDit: (0, $ce4de947442b2ab1$export$22b082955e083ec3)(),
    oldebProprietaireCodePostal: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
    oldebProprietaireVille: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
    oldebProprietairePays: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba)
});
const $c440bb37f7608098$var$OldebProprietaireForm = ()=>{
    const { values: values, setFieldValue: setFieldValue } = (0, $bkJfK.useFormikContext)();
    const civiliteList = Object.entries((0, $e5997c0dce1a3fdf$export$2e2bcd8739ae039)).map(([key, value])=>{
        return {
            id: key,
            code: value,
            libelle: value
        };
    });
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                            label: "Le propri\xe9taire est un organisme",
                            name: "oldebProprietaireOrganisme",
                            required: false
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                            label: "Raison sociale",
                            name: "oldebProprietaireRaisonSociale",
                            required: false,
                            disabled: !values?.oldebProprietaireOrganisme
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                            name: "oldebProprietaireCivilite",
                            listIdCodeLibelle: civiliteList,
                            label: "Civilit\xe9",
                            defaultValue: civiliteList?.find((v)=>v.id === values?.oldebProprietaireCivilite),
                            required: true,
                            setFieldValue: setFieldValue
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                            label: "Nom",
                            name: "oldebProprietaireNom",
                            required: true
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                            label: "Pr\xe9nom",
                            name: "oldebProprietairePrenom",
                            required: true
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                            label: "Num\xe9ro",
                            name: "oldebProprietaireNumVoie",
                            required: false
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                            label: "Voie",
                            name: "oldebProprietaireVoie",
                            required: false
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                        label: "Lieu-dit",
                        name: "oldebProprietaireLieuDit",
                        required: false
                    })
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                            label: "Code postal",
                            name: "oldebProprietaireCodePostal",
                            required: true
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                            label: "Ville",
                            name: "oldebProprietaireVille",
                            required: true
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                            label: "Pays",
                            name: "oldebProprietairePays",
                            required: true
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                            label: "T\xe9l\xe9phone",
                            name: "oldebProprietaireTelephone",
                            required: false
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                            label: "E-mail",
                            name: "oldebProprietaireEmail",
                            required: false
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db9b0e6fdb142a4c$export$2e2bcd8739ae039), {
                returnLink: true
            })
        ]
    });
};
var $c440bb37f7608098$export$2e2bcd8739ae039 = $c440bb37f7608098$var$OldebProprietaireForm;


const $329dc4c2759b9760$var$OldebProprietaireCreate = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$f3f0c8a5b29f8e52), {}),
                title: "Cr\xe9ation d'un propri\xe9taire"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                initialValues: (0, $c440bb37f7608098$export$a5cab80145b70e98),
                validationSchema: (0, $c440bb37f7608098$export$c084437b5e3206cd),
                isPost: true,
                submitUrl: `/api/proprietaire/create`,
                prepareVariables: (values)=>(0, $c440bb37f7608098$export$8470ef9d0802da38)(values),
                redirectUrl: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).OLDEB_PROPRIETAIRE_LIST,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $c440bb37f7608098$export$2e2bcd8739ae039), {
                    isNew: true
                })
            })
        ]
    });
};
var $329dc4c2759b9760$export$2e2bcd8739ae039 = $329dc4c2759b9760$var$OldebProprietaireCreate;
















const $ff4936d24a06a6a1$var$filterValuesToVariable = ({ oldebProprietaireNom: oldebProprietaireNom, oldebProprietairePrenom: oldebProprietairePrenom, oldebProprietaireVille: oldebProprietaireVille })=>{
    const filter = {};
    $ff4936d24a06a6a1$var$pushFilterItem(filter, oldebProprietaireNom, "oldebProprietaireNom");
    $ff4936d24a06a6a1$var$pushFilterItem(filter, oldebProprietairePrenom, "oldebProprietairePrenom");
    $ff4936d24a06a6a1$var$pushFilterItem(filter, oldebProprietaireVille, "oldebProprietaireVille");
    return filter;
};
var $ff4936d24a06a6a1$export$2e2bcd8739ae039 = $ff4936d24a06a6a1$var$filterValuesToVariable;
function $ff4936d24a06a6a1$var$pushFilterItem(filter, value, name) {
    if (value?.trim().length > 0) filter[name] = value;
}


const $a575bb1f58db9b30$var$OldebProprietaireList = ()=>{
    const { user: user } = (0, $e787cde576104469$export$fdc397e486fa83e7)();
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$f3f0c8a5b29f8e52), {}),
                title: "Liste des propri\xe9taires",
                right: (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).OLDEB_C) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8ad69b89456b65bc$export$2e2bcd8739ae039), {
                    href: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).OLDEB_PROPRIETAIRE_CREATE,
                    title: "Cr\xe9er un propri\xe9taire"
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $9a9eebc3462fba73$export$2e2bcd8739ae039), {
                query: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/proprietaire`,
                columns: [
                    {
                        Header: "Nom",
                        accessor: "oldebProprietaireNom",
                        sortField: "oldebProprietaireNom",
                        Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                            type: "text",
                            name: "oldebProprietaireNom"
                        })
                    },
                    {
                        Header: "Prenom",
                        accessor: "oldebProprietairePrenom",
                        sortField: "oldebProprietairePrenom",
                        Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                            type: "text",
                            name: "oldebProprietairePrenom"
                        })
                    },
                    {
                        Header: "Ville",
                        accessor: "oldebProprietaireVille",
                        sortField: "oldebProprietaireVille",
                        Filter: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $eebfdd72ecf3e7e5$export$2e2bcd8739ae039), {
                            type: "text",
                            name: "oldebProprietaireVille"
                        })
                    },
                    (0, $b82b937cc97f6f18$export$36e9f5a475c9f6fc)({
                        Header: "Actions",
                        accessor: "oldebProprietaireId",
                        buttons: [
                            {
                                row: (row)=>{
                                    return row;
                                },
                                route: (oldebProprietaireId)=>(0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).OLDEB_PROPRIETAIRE_UPDATE(oldebProprietaireId),
                                type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).UPDATE,
                                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$b51dd496211ae105), {})
                            },
                            {
                                row: (row)=>{
                                    return row;
                                },
                                pathname: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/proprietaire/`,
                                type: (0, $dd99a466fda4f852$export$324d92f8c11376d5).DELETE,
                                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$4d4e10ce882b8153), {})
                            }
                        ]
                    })
                ],
                idName: "oldebProprietaireId",
                filterValuesToVariable: (0, $ff4936d24a06a6a1$export$2e2bcd8739ae039),
                filterContext: (0, $9a9eebc3462fba73$export$396ef541d9951d45)({})
            })
        ]
    });
};
var $a575bb1f58db9b30$export$2e2bcd8739ae039 = $a575bb1f58db9b30$var$OldebProprietaireList;












const $518d651e5a5f4af5$var$OldebProprietaireUpdate = ()=>{
    const { proprietaireId: proprietaireId } = (0, $7a844823b04d4282$export$99eaa27ddbbb95ef)();
    const proprietaireState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/proprietaire/${proprietaireId}`);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$f3f0c8a5b29f8e52), {}),
                title: "Mise \xe0 jour d'un propri\xe9taire"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                initialValues: (0, $c440bb37f7608098$export$a5cab80145b70e98)(proprietaireState.data),
                validationSchema: (0, $c440bb37f7608098$export$c084437b5e3206cd),
                isPost: false,
                submitUrl: `/api/proprietaire/${proprietaireId}`,
                prepareVariables: (values)=>(0, $c440bb37f7608098$export$8470ef9d0802da38)(values),
                redirectUrl: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).OLDEB_PROPRIETAIRE_LIST,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $c440bb37f7608098$export$2e2bcd8739ae039), {
                    isNew: false
                })
            })
        ]
    });
};
var $518d651e5a5f4af5$export$2e2bcd8739ae039 = $518d651e5a5f4af5$var$OldebProprietaireUpdate;





var $kc00y = parcelRequire("kc00y");








const $0f75f1ca349a33ff$var$OldebSearch = ()=>{
    const navigate = (0, $7a844823b04d4282$export$9770f232ac06a008)();
    const location = (0, $7a844823b04d4282$export$45d76561a5302f2b)();
    const [radioValue, setRadioValue] = (0, $kc00y.useState)("oldeb");
    const [communeId, setCommuneId] = (0, $kc00y.useState)(null);
    const [section, setSection] = (0, $kc00y.useState)(null);
    const [parcelle, setParcelle] = (0, $kc00y.useState)(null);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$5d9c28f3fa3ba1a), {}),
                title: "Recherche des Obligations L\xe9gales de D\xe9broussaillement"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f76670b5e5897c33), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                            className: "py-2",
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $a43e6f68e14bab96$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8b78b8a93971307c$export$2e2bcd8739ae039), {
                                        id: "oldeb",
                                        type: "radio",
                                        variant: "outline-primary",
                                        name: "radio",
                                        value: "oldeb",
                                        checked: radioValue === "oldeb",
                                        onChange: (e)=>setRadioValue(e.currentTarget.value),
                                        children: "Parcelles soumises \xe0 une obligation l\xe9gale de d\xe9broussaillement"
                                    }),
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8b78b8a93971307c$export$2e2bcd8739ae039), {
                                        id: "cadastre",
                                        type: "radio",
                                        variant: "outline-primary",
                                        name: "radio",
                                        value: "cadastre",
                                        checked: radioValue === "cadastre",
                                        onChange: (e)=>setRadioValue(e.currentTarget.value),
                                        children: "Parcelles cadastrales"
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                            xl: 6,
                            lg: 9,
                            className: "py-2",
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $dd08a763d100724f$export$2e2bcd8739ae039), {
                                name: "communeId",
                                url: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/commune/get-libelle-commune`,
                                onChange: (e)=>setCommuneId(e.value)
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                            xl: 6,
                            lg: 9,
                            className: "py-2",
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$dc7fb17466c6914d), {
                                labelKey: "cadastreSectionNumero",
                                url: communeId ? (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/cadastre/commune/${communeId}/section` : "",
                                onChange: (e)=>setSection(e),
                                disabled: !communeId
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                            xl: 6,
                            lg: 9,
                            className: "py-2",
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$dc7fb17466c6914d), {
                                labelKey: "cadastreParcelleNumero",
                                url: section ? (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/cadastre/section/${section.cadastreSectionId}/parcelle${radioValue === "oldeb" ? "-old" : ""}` : "",
                                onChange: (e)=>{
                                    setParcelle(e);
                                },
                                disabled: !section
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                            className: "py-3",
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                                disabled: !parcelle,
                                onClick: ()=>{
                                    if (parcelle) {
                                        const [rawSrid, rawFeature] = parcelle.cadastreParcelleGeometrie.split(";");
                                        const srid = rawSrid.split("=").pop();
                                        const extent = new (0, $15a985d09649bdc2$export$2e2bcd8739ae039)().readGeometry(rawFeature).getExtent();
                                        navigate((0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).OLDEB_LOCALISATION, {
                                            state: {
                                                ...location.state,
                                                target: {
                                                    extent: extent,
                                                    srid: srid
                                                }
                                            }
                                        });
                                    }
                                },
                                children: "Localiser"
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var $0f75f1ca349a33ff$export$2e2bcd8739ae039 = $0f75f1ca349a33ff$var$OldebSearch;








const $2492bb2a576156bb$var$AccueilPei = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                    icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$ba2fbb9644c8bf32), {}),
                    title: "Liste des points d'eau"
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
                fluid: true,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $20418e8270719735$export$2e2bcd8739ae039), {})
            })
        ]
    });
};
var $2492bb2a576156bb$export$2e2bcd8739ae039 = $2492bb2a576156bb$var$AccueilPei;





var $bkJfK = parcelRequire("bkJfK");







const $8c5991efe7d738aa$export$a5cab80145b70e98 = ()=>({
        document: null
    });
const $8c5991efe7d738aa$export$c084437b5e3206cd = (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({});
const $8c5991efe7d738aa$export$f97400759cfd946 = (values)=>{
    const formData = new FormData();
    formData.append("document", values.document);
    return formData;
};
const $8c5991efe7d738aa$var$DeclarationPei = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$c9bef5de7ad5da31), {}),
                title: "D\xe9poser un document de d\xe9claration d'un PEI"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                initialValues: $8c5991efe7d738aa$export$a5cab80145b70e98(),
                validationSchema: $8c5991efe7d738aa$export$c084437b5e3206cd,
                isPost: false,
                isMultipartFormData: true,
                submitUrl: `/api/documents/import/`,
                prepareVariables: (values)=>$8c5991efe7d738aa$export$f97400759cfd946(values),
                redirectUrl: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).ACCUEIL,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($8c5991efe7d738aa$var$FormImportDocument, {})
            })
        ]
    });
};
const $8c5991efe7d738aa$var$FormImportDocument = ()=>{
    const { setFieldValue: setFieldValue } = (0, $bkJfK.useFormikContext)();
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b57af79a4ab2a1c6), {
                name: "document",
                accept: ".*",
                required: true,
                onChange: (e)=>setFieldValue("document", e.target.files[0])
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                className: "mt-3",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                    className: "text-center",
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                        type: "submit",
                        variant: "primary",
                        children: "Valider"
                    })
                })
            })
        ]
    });
};
var $8c5991efe7d738aa$export$2e2bcd8739ae039 = $8c5991efe7d738aa$var$DeclarationPei;





var $bkJfK = parcelRequire("bkJfK");












const $e97e04de6714d38d$export$a5cab80145b70e98 = ()=>({
        file: null
    });
const $e97e04de6714d38d$export$f97400759cfd946 = (values)=>{
    const formData = new FormData();
    formData.append("file", values.file);
    return formData;
};
const $e97e04de6714d38d$export$c084437b5e3206cd = (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({});
const $e97e04de6714d38d$var$ImportPositionsPEI = ()=>{
    const navigate = (0, $7a844823b04d4282$export$9770f232ac06a008)();
    const location = (0, $7a844823b04d4282$export$45d76561a5302f2b)();
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$c9bef5de7ad5da31), {}),
                title: "Importer un fichier de mise \xe0 jour des positions des PEI"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                initialValues: $e97e04de6714d38d$export$a5cab80145b70e98(),
                validationSchema: $e97e04de6714d38d$export$c084437b5e3206cd,
                isPost: true,
                isMultipartFormData: true,
                submitUrl: `/api/maj-positions-pei/verification`,
                prepareVariables: (values)=>$e97e04de6714d38d$export$f97400759cfd946(values),
                onSubmit: (result)=>navigate((0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).RESULTAT_VERIF_MAJ_POSITIONS_PEI, {
                        state: {
                            ...location.state,
                            result: result
                        }
                    }),
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($e97e04de6714d38d$var$FormImportPositionsPEI, {})
            })
        ]
    });
};
var $e97e04de6714d38d$export$2e2bcd8739ae039 = $e97e04de6714d38d$var$ImportPositionsPEI;
const $e97e04de6714d38d$var$FormImportPositionsPEI = ()=>{
    const { setFieldValue: setFieldValue } = (0, $bkJfK.useFormikContext)();
    const { success: successToast, error: errorToast } = (0, $6bdae0bad7b05751$export$91b3d218c74c79e4)();
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                className: "mb-3",
                onClick: ()=>(0, $c066b242635c27a6$export$9cca65ea339c61b4)("/api/maj-positions-pei/download-template", JSON.stringify({}), "deplacement-pei.csv", "Export termin\xe9", successToast, errorToast),
                children: [
                    "T\xe9l\xe9charger un mod\xe8le de fichier CSV \xa0",
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$4a5ccdc9878f4668), {})
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b57af79a4ab2a1c6), {
                        label: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                            children: [
                                "Fichier CSV",
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                                    placement: "right",
                                    tooltipText: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                                children: [
                                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                                                        className: "fw-bold",
                                                        children: [
                                                            "EPSG ",
                                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("span", {
                                                                className: "text-danger",
                                                                children: "*"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                                        className: "ms-2",
                                                        children: "Le code EPSG du syst\xe8me de coordonn\xe9es."
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                                children: [
                                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                                                        className: "fw-bold",
                                                        children: [
                                                            "X ",
                                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("span", {
                                                                className: "text-danger",
                                                                children: "*"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                                        className: "ms-2",
                                                        children: "La coordonn\xe9e X de la position du PEI."
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                                children: [
                                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                                                        className: "fw-bold",
                                                        children: [
                                                            "Y ",
                                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("span", {
                                                                className: "text-danger",
                                                                children: "*"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                                        className: "ms-2",
                                                        children: "La coordonn\xe9e Y de la position du PEI."
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                                children: [
                                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                                        className: "fw-bold",
                                                        children: "DATE_GPS"
                                                    }),
                                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                                        className: "ms-2",
                                                        children: 'La date et l\'heure de la mesure GPS, format "dd/MM/yy HH:mm" (exemple : 31/12/23 14:30).'
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                                children: [
                                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                                        className: "fw-bold",
                                                        children: "OBSERVATION"
                                                    }),
                                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                                        className: "ms-2",
                                                        children: "La description de l'observation du PEI."
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                                children: [
                                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                                                        className: "fw-bold",
                                                        children: [
                                                            "NUMERO ",
                                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("span", {
                                                                className: "text-danger",
                                                                children: "*"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                                        className: "ms-2",
                                                        children: "Le num\xe9ro du PEI."
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("br", {}),
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("span", {
                                                            className: "text-danger",
                                                            children: "*"
                                                        }),
                                                        " : Champs obligatoires"
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    tooltipHeader: "Colonnes attendues",
                                    tooltipId: "importCSV",
                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$340bfce9b4df026b), {})
                                })
                            ]
                        }),
                        name: "file",
                        accept: ".csv",
                        required: true,
                        onChange: (e)=>setFieldValue("file", e.target.files[0])
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                        className: "mt-3",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                            className: "text-center",
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db9b0e6fdb142a4c$export$2e2bcd8739ae039), {
                                submitTitle: "V\xe9rifier les donn\xe9es"
                            })
                        })
                    })
                ]
            })
        ]
    });
};












const $8a1e46e15c88850d$var$ListePeiIndisponibiliteTemporaire = ()=>{
    const { indisponibiliteTemporaireId: indisponibiliteTemporaireId } = (0, $7a844823b04d4282$export$99eaa27ddbbb95ef)();
    const indisponibiliteTemporaireInfo = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/indisponibilite-temporaire/` + indisponibiliteTemporaireId);
    const data = indisponibiliteTemporaireInfo?.data;
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                        icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$ba2fbb9644c8bf32), {}),
                        title: "Liste des points d'eau indisponibles temporairement"
                    }),
                    data && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                        className: "mt-1 fs-6",
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                                className: "mb-2",
                                children: [
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("span", {
                                        className: "fw-bold",
                                        children: "Motif :"
                                    }),
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("span", {
                                        className: "ms-2",
                                        children: data?.indisponibiliteTemporaireMotif
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                                className: "mb-2",
                                children: [
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("span", {
                                        className: "fw-bold",
                                        children: data?.indisponibiliteTemporaireDateFin ? "P\xe9riode :" : "\xc0 partir du :"
                                    }),
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("span", {
                                        className: "ms-2",
                                        children: [
                                            (0, $00c47c7740afd024$export$beb50dcdba5b8943)(data?.indisponibiliteTemporaireDateDebut),
                                            data?.indisponibiliteTemporaireDateFin && ` - ${(0, $00c47c7740afd024$export$beb50dcdba5b8943)(data.indisponibiliteTemporaireDateFin)}`
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
                fluid: true,
                className: "px-5",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $20418e8270719735$export$2e2bcd8739ae039), {
                    filterPage: (0, $e8a2c985711dfc19$export$2e2bcd8739ae039).INDISPONIBILITE_TEMPORAIRE,
                    filterId: indisponibiliteTemporaireId
                })
            })
        ]
    });
};
var $8a1e46e15c88850d$export$2e2bcd8739ae039 = $8a1e46e15c88850d$var$ListePeiIndisponibiliteTemporaire;











const $89ce6591ed81099f$var$ListePeiTournee = ()=>{
    const { tourneeId: tourneeId } = (0, $7a844823b04d4282$export$99eaa27ddbbb95ef)();
    const tourneeLibelle = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/tournee/get-libelle/` + tourneeId);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                    icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$ba2fbb9644c8bf32), {}),
                    title: `Points d'eau de la tourn\xe9e : ${tourneeLibelle?.data?.libelle ?? ""}`
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
                fluid: true,
                className: "px-5",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $20418e8270719735$export$2e2bcd8739ae039), {
                    filterPage: (0, $e8a2c985711dfc19$export$2e2bcd8739ae039).TOURNEE,
                    filterId: tourneeId
                })
            })
        ]
    });
};
var $89ce6591ed81099f$export$2e2bcd8739ae039 = $89ce6591ed81099f$var$ListePeiTournee;










const $3c965143f4385f8c$var$MessagePeiLongueIndispoListePei = ()=>{
    const messagePeiLongueIndispoState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/message-pei-longue-indispo/`);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                    icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$ba2fbb9644c8bf32), {}),
                    title: `Liste des PEI indisponibles depuis plus de${messagePeiLongueIndispoState?.data?.nbMois && messagePeiLongueIndispoState?.data?.nbMois !== 0 ? ` ${messagePeiLongueIndispoState.data.nbMois} mois et` : ""} ${messagePeiLongueIndispoState?.data?.nbJour && messagePeiLongueIndispoState?.data?.nbJour !== 0 ? `${messagePeiLongueIndispoState?.data?.nbJour} jours` : ""}`
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
                fluid: true,
                className: "px-5",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $20418e8270719735$export$2e2bcd8739ae039), {
                    filterPage: (0, $e8a2c985711dfc19$export$2e2bcd8739ae039).PEI_LONGUE_INDISPO
                })
            })
        ]
    });
};
var $3c965143f4385f8c$export$2e2bcd8739ae039 = $3c965143f4385f8c$var$MessagePeiLongueIndispoListePei;





var $bkJfK = parcelRequire("bkJfK");










const $03e676c79e46c88d$export$a5cab80145b70e98 = (initialValues)=>({
        bilanVerifications: initialValues.result.bilanVerifications
    });
const $03e676c79e46c88d$export$c084437b5e3206cd = (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({});
const $03e676c79e46c88d$export$f97400759cfd946 = (values)=>({
        bilanVerifications: values.bilanVerifications ?? null
    });
const $03e676c79e46c88d$var$VerificationImportPei = ()=>{
    const { state: state } = (0, $7a844823b04d4282$export$45d76561a5302f2b)();
    let initialValues;
    if (state) {
        initialValues = state;
        window.history.replaceState({
            from: state.from
        }, "");
    }
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$2f6d05691f8bfa80), {}),
                title: "Validation de l'import des positions des PEI"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                initialValues: $03e676c79e46c88d$export$a5cab80145b70e98(initialValues),
                validationSchema: $03e676c79e46c88d$export$c084437b5e3206cd,
                isPost: true,
                submitUrl: `/api/maj-positions-pei/enregistrement`,
                prepareVariables: (values)=>$03e676c79e46c88d$export$f97400759cfd946(values),
                redirectUrl: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).MAJ_POSITIONS_PEI,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($03e676c79e46c88d$var$ResultatsVerificationImportPei, {})
            })
        ]
    });
};
var $03e676c79e46c88d$export$2e2bcd8739ae039 = $03e676c79e46c88d$var$VerificationImportPei;
const $03e676c79e46c88d$var$ResultatsVerificationImportPei = ()=>{
    const { values: values } = (0, $bkJfK.useFormikContext)();
    const data = (0, $c066b242635c27a6$export$e19edaf2912e7bf)(values);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $13de46b4dfcc473f$export$2e2bcd8739ae039), {
                        bordered: true,
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("thead", {
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("th", {
                                            children: "N\xb0Ligne"
                                        }),
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("th", {
                                            children: "N\xb0 du PEI"
                                        }),
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("th", {
                                            children: "Date de relev\xe9"
                                        }),
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("th", {
                                            children: "Bilan du contr\xf4le"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("tbody", {
                                children: values.bilanVerifications?.map((element, index)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("tr", {
                                        className: element.bilanStyle === "ERROR" ? "table-danger" : element.bilanStyle === "WARNING" ? "table-warning" : "table-success",
                                        children: [
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("td", {
                                                children: element.numeroLigne
                                            }),
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("td", {
                                                children: element.numeroPei
                                            }),
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("td", {
                                                children: element.dateReleve
                                            }),
                                            element.warnings && element.warnings.length > 0 ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("td", {
                                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("ul", {
                                                    children: element.warnings.map((warning, idx)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("li", {
                                                            children: warning
                                                        }, idx))
                                                })
                                            }) : /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("td", {
                                                children: element.infos && element.infos.length > 0 ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("ul", {
                                                    children: element.infos.map((info, index)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("li", {
                                                            children: info
                                                        }, index))
                                                }) : /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("span", {
                                                    children: "Aucune information disponible"
                                                })
                                            })
                                        ]
                                    }, index))
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("p", {
                        children: [
                            "Nombre de PEI valides : ",
                            data.nbValides
                        ]
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("p", {
                        children: [
                            "Dont : ",
                            data.nbValidesWarn,
                            " PEI valides avec avertissements"
                        ]
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("p", {
                        children: [
                            "Nombre de PEI rejet\xe9s : ",
                            data.nbRejetes
                        ]
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("p", {
                        children: [
                            "Dont : ",
                            data.nbRejetesNR,
                            " PEI rejet\xe9s car non renseign\xe9s"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db9b0e6fdb142a4c$export$2e2bcd8739ae039), {
                        returnLink: false,
                        submitTitle: "Importer les positions"
                    })
                })
            })
        ]
    });
};








var $kc00y = parcelRequire("kc00y");


var $209200b1607d20a0$exports = {};
$209200b1607d20a0$exports = $parcel$resolve("5ugjC");


var $5e0d23e26a39fa9c$exports = {};
$5e0d23e26a39fa9c$exports = $parcel$resolve("2Fh4p");












var $kc00y = parcelRequire("kc00y");














var $bkJfK = parcelRequire("bkJfK");


var $kc00y = parcelRequire("kc00y");










/**
 * Enumération définissant les différentes directions (du vent)
 */ var $059bc2b75ef03255$var$DIRECTION = /*#__PURE__*/ function(DIRECTION) {
    DIRECTION["N"] = "Nord";
    DIRECTION["E"] = "Est";
    DIRECTION["S"] = "Sud";
    DIRECTION["O"] = "Ouest";
    DIRECTION["NE"] = "Nord-Est";
    DIRECTION["SE"] = "Sud-Est";
    DIRECTION["SO"] = "Sud-Ouest";
    DIRECTION["NO"] = "Nord-Ouest";
    return DIRECTION;
}($059bc2b75ef03255$var$DIRECTION || {});
var $059bc2b75ef03255$export$2e2bcd8739ae039 = $059bc2b75ef03255$var$DIRECTION;



var $5ced9b26b3420067$var$OUI_NON_NA = /*#__PURE__*/ function(OUI_NON_NA) {
    OUI_NON_NA["NA"] = "Non renseign\xe9";
    OUI_NON_NA["OUI"] = "Oui";
    OUI_NON_NA["NON"] = "Non";
    return OUI_NON_NA;
}($5ced9b26b3420067$var$OUI_NON_NA || {});
var $5ced9b26b3420067$export$2e2bcd8739ae039 = $5ced9b26b3420067$var$OUI_NON_NA;


var $e9329478c70b6d7b$var$RISQUE_METEO = /*#__PURE__*/ function(RISQUE_METEO) {
    RISQUE_METEO["NA"] = "Non renseign\xe9";
    RISQUE_METEO["FAIBLE"] = "Faible";
    RISQUE_METEO["LEGER"] = "L\xe9ger";
    RISQUE_METEO["MODERE"] = "Mod\xe9r\xe9";
    RISQUE_METEO["SEVERE"] = "S\xe9v\xe8re";
    RISQUE_METEO["TRES_SEVERE"] = "Tr\xe8s s\xe9v\xe8re";
    RISQUE_METEO["EXTREME"] = "Extr\xeame";
    return RISQUE_METEO;
}($e9329478c70b6d7b$var$RISQUE_METEO || {});
var $e9329478c70b6d7b$export$2e2bcd8739ae039 = $e9329478c70b6d7b$var$RISQUE_METEO;







const $6968f3a041d56083$export$a5cab80145b70e98 = (data, userId)=>{
    const [srid, geom] = data.rcci?.rcciGeometrie ? data.rcci.rcciGeometrie.split(/SRID=|;/).filter(Boolean) : [
        null,
        null
    ];
    const feature = geom ? new (0, $15a985d09649bdc2$export$2e2bcd8739ae039)().readFeature(geom) : null;
    const [x, y] = feature ? feature.getGeometry().getFlatCoordinates() : [
        null,
        null
    ];
    return {
        rcci: {
            rcciId: data.rcci?.rcciId ?? undefined,
            rcciCommentaireConclusion: data.rcci?.rcciCommentaireConclusion ?? undefined,
            rcciComplement: data.rcci?.rcciComplement ?? undefined,
            rcciCarroyageDfci: data.rcci?.rcciCarroyageDfci ?? undefined,
            rcciDateIncendie: data.rcci?.rcciDateIncendie ?? new Date(),
            rcciDateModification: data.rcci?.rcciDateModification ?? new Date(),
            rcciDirectionVent: data.rcci?.rcciDirectionVent ?? undefined,
            rcciForceVent: data.rcci?.rcciForceVent ?? undefined,
            rcciForcesOrdre: data.rcci?.rcciForcesOrdre ?? undefined,
            rcciGdh: data.rcci?.rcciGdh ?? undefined,
            rcciGelLieux: data.rcci?.rcciGelLieux ?? undefined,
            rcciGeometrie: data.rcci?.rcciGeometrie ?? undefined,
            rcciX: x,
            rcciY: y,
            rcciSrid: srid ?? undefined,
            rcciHygrometrie: data.rcci?.rcciHygrometrie ?? undefined,
            rcciRcciIndiceRothermelId: data.rcci?.rcciRcciIndiceRothermelId ?? undefined,
            rcciPointEclosion: data.rcci?.rcciPointEclosion ?? undefined,
            rcciPremierCos: data.rcci?.rcciPremierCos ?? undefined,
            rcciPremierEngin: data.rcci?.rcciPremierEngin ?? undefined,
            rcciSuperficieFinale: data.rcci?.rcciSuperficieFinale ?? undefined,
            rcciSuperficieReferent: data.rcci?.rcciSuperficieReferent ?? undefined,
            rcciSuperficieSecours: data.rcci?.rcciSuperficieSecours ?? undefined,
            rcciTemperature: data.rcci?.rcciTemperature ?? undefined,
            rcciVentLocal: data.rcci?.rcciVentLocal ?? undefined,
            rcciVoieTexte: data.rcci?.rcciVoieTexte ?? undefined,
            rcciVoieId: data.rcci?.rcciVoieId ?? undefined,
            rcciCommuneId: data.rcci?.rcciCommuneId ?? undefined,
            rcciRcciTypePrometheeFamilleId: data.rcci?.rcciRcciTypePrometheeFamilleId ?? undefined,
            rcciRcciTypePrometheePartitionId: data.rcci?.rcciRcciTypePrometheePartitionId ?? undefined,
            rcciRcciTypePrometheeCategorieId: data.rcci?.rcciRcciTypePrometheeCategorieId ?? undefined,
            rcciRcciTypeDegreCertitudeId: data.rcci?.rcciRcciTypeDegreCertitudeId ?? undefined,
            rcciRcciTypeOrigineAlerteId: data.rcci?.rcciRcciTypeOrigineAlerteId ?? null,
            rcciRcciArriveeDdtmOnfId: data.rcci?.rcciRcciArriveeDdtmOnfId ?? undefined,
            rcciRcciArriveeSdisId: data.rcci?.rcciRcciArriveeSdisId ?? undefined,
            rcciRcciArriveeGendarmerieId: data.rcci?.rcciRcciArriveeGendarmerieId ?? undefined,
            rcciRcciArriveePoliceId: data.rcci?.rcciRcciArriveePoliceId ?? undefined,
            rcciRisqueMeteo: data.rcci?.rcciRisqueMeteo ?? undefined,
            rcciUtilisateurId: data.rcci?.rcciUtilisateurId ?? userId,
            documentList: data.rcci?.documentList ?? undefined,
            voieSaisieLibre: data?.rcci?.rcciVoieTexte != null && data?.rcci?.rcciVoieTexte?.trim() !== "",
            ...data.rcci
        },
        documentList: data?.documentList || [],
        typeSystemeSrid: (0, $e2315562ed43d638$export$2e2bcd8739ae039).find((e)=>e.srid === Number(data?.rcci?.rcciSrid))?.srid ?? (0, $e2315562ed43d638$export$2e2bcd8739ae039)[0].srid.toString(),
        coordonneeXToDisplay: x,
        coordonneeYToDisplay: y
    };
};
const $6968f3a041d56083$export$8470ef9d0802da38 = (values, appSrid)=>{
    const formData = new FormData();
    formData.append("rcci", JSON.stringify({
        rcciId: values.rcci?.rcciId,
        rcciCommentaireConclusion: values.rcci?.rcciCommentaireConclusion,
        rcciComplement: values.rcci?.rcciComplement,
        rcciCarroyageDfci: values.rcci?.rcciCarroyageDfci,
        rcciDateIncendie: values.rcci?.rcciDateIncendie ? new Date(values.rcci?.rcciDateIncendie).toISOString() : null,
        rcciDateModification: values.rcci?.rcciDateModification ? new Date(values.rcci?.rcciDateModification).toISOString() : new Date(),
        rcciDirectionVent: values.rcci?.rcciDirectionVent,
        rcciForceVent: values.rcci?.rcciForceVent,
        rcciForcesOrdre: values.rcci?.rcciForcesOrdre,
        rcciGdh: values.rcci?.rcciGdh ? new Date(values.rcci?.rcciGdh).toISOString() : null,
        rcciGelLieux: values.rcci?.rcciGelLieux,
        rcciGeometrie: "SRID=" + appSrid + ";POINT(" + values.rcci?.rcciX + " " + values.rcci?.rcciY + ")",
        rcciHygrometrie: values.rcci?.rcciHygrometrie,
        rcciRcciIndiceRothermelId: values.rcci?.rcciRcciIndiceRothermelId,
        rcciPointEclosion: values.rcci?.rcciPointEclosion,
        rcciPremierCos: values.rcci?.rcciPremierCos,
        rcciPremierEngin: values.rcci?.rcciPremierEngin,
        rcciSuperficieFinale: values.rcci?.rcciSuperficieFinale,
        rcciSuperficieReferent: values.rcci?.rcciSuperficieReferent,
        rcciSuperficieSecours: values.rcci?.rcciSuperficieSecours,
        rcciTemperature: values.rcci?.rcciTemperature,
        rcciVentLocal: values.rcci?.rcciVentLocal,
        rcciVoieTexte: values.rcci?.rcciVoieTexte != null && values.rcci?.rcciVoieTexte?.trim() !== "" ? values.rcci?.rcciVoieTexte : null,
        rcciVoieId: values.rcci?.rcciVoieId,
        rcciCommuneId: values.rcci?.rcciCommuneId,
        rcciRcciTypePrometheeCategorieId: values.rcci?.rcciRcciTypePrometheeCategorieId,
        rcciRcciTypePrometheeFamilleId: values.rcci.rcciRcciTypePrometheeFamilleId,
        rcciRcciTypePrometheePartitionId: values.rcci.rcciRcciTypePrometheePartitionId,
        rcciRcciTypeDegreCertitudeId: values.rcci?.rcciRcciTypeDegreCertitudeId,
        rcciRcciTypeOrigineAlerteId: values.rcci?.rcciRcciTypeOrigineAlerteId,
        rcciRcciArriveeDdtmOnfId: values.rcci?.rcciRcciArriveeDdtmOnfId,
        rcciRcciArriveeSdisId: values.rcci?.rcciRcciArriveeSdisId,
        rcciRcciArriveeGendarmerieId: values.rcci?.rcciRcciArriveeGendarmerieId,
        rcciRcciArriveePoliceId: values.rcci?.rcciRcciArriveePoliceId,
        rcciUtilisateurId: values.rcci?.rcciUtilisateurId,
        rcciRisqueMeteo: values.rcci?.rcciRisqueMeteo,
        documentList: values.rcci?.documentList
    }));
    if (values.documentList) values.documentList.forEach((file)=>{
        formData.append(`document[]`, file);
    });
    return formData;
};
const $6968f3a041d56083$export$c084437b5e3206cd = (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({
    rcci: (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({
        rcciId: (0, $ce4de947442b2ab1$export$22b082955e083ec3)(),
        rcciCommentaireConclusion: (0, $ce4de947442b2ab1$export$22b082955e083ec3)(),
        rcciComplement: (0, $ce4de947442b2ab1$export$22b082955e083ec3)(),
        rcciCarroyageDfci: (0, $ce4de947442b2ab1$export$22b082955e083ec3)(),
        rcciDateIncendie: (0, $36ceaed6faf947af$export$5cbf64e9c4f743ca),
        rcciDateModification: (0, $36ceaed6faf947af$export$5cbf64e9c4f743ca),
        rcciDirectionVent: (0, $ce4de947442b2ab1$export$22b082955e083ec3)(),
        rcciForceVent: (0, $36ceaed6faf947af$export$24a1e2b92fa94c07),
        rcciForcesOrdre: (0, $ce4de947442b2ab1$export$22b082955e083ec3)(),
        rcciGdh: (0, $36ceaed6faf947af$export$324d90190a8b822a),
        rcciGelLieux: (0, $ce4de947442b2ab1$export$22b082955e083ec3)(),
        rcciX: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
        rcciY: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
        rcciSrid: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
        rcciHygrometrie: (0, $36ceaed6faf947af$export$a3560dfa62c7efe0),
        rcciIndiceRothermelId: (0, $ce4de947442b2ab1$export$22b082955e083ec3)(),
        rcciPointEclosion: (0, $ce4de947442b2ab1$export$22b082955e083ec3)(),
        rcciPremierCos: (0, $ce4de947442b2ab1$export$22b082955e083ec3)(),
        rcciPremierEngin: (0, $ce4de947442b2ab1$export$22b082955e083ec3)(),
        rcciSuperficieFinale: (0, $36ceaed6faf947af$export$24a1e2b92fa94c07),
        rcciSuperficieReferent: (0, $36ceaed6faf947af$export$24a1e2b92fa94c07),
        rcciSuperficieSecours: (0, $36ceaed6faf947af$export$24a1e2b92fa94c07),
        rcciTemperature: (0, $ce4de947442b2ab1$export$98e628dec113755e)(),
        rcciVentLocal: (0, $ce4de947442b2ab1$export$22b082955e083ec3)(),
        voieSaisieLibre: (0, $ce4de947442b2ab1$export$87b259aa03e3d267)(),
        rcciVoieTexte: (0, $ce4de947442b2ab1$export$22b082955e083ec3)().nullable().when("voieSaisieLibre", ([voieSaisieLibre], schema)=>voieSaisieLibre ? schema.required("La voie en saisie libre est obligatoire") : schema.nullable()),
        rcciVoieId: (0, $ce4de947442b2ab1$export$22b082955e083ec3)().nullable().when("voieSaisieLibre", ([voieSaisieLibre], schema)=>!voieSaisieLibre ? schema.required("La voie est obligatoire") : schema.nullable()),
        rcciCommuneId: (0, $ce4de947442b2ab1$export$22b082955e083ec3)(),
        rcciRcciTypePrometheeCategorieId: (0, $ce4de947442b2ab1$export$22b082955e083ec3)(),
        rcciRcciTypeDegreCertitudeId: (0, $ce4de947442b2ab1$export$22b082955e083ec3)(),
        rcciRcciTypeOrigineAlerteId: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
        rcciRcciArriveeDdtmOnfId: (0, $ce4de947442b2ab1$export$22b082955e083ec3)(),
        rcciRcciArriveeSdisId: (0, $ce4de947442b2ab1$export$22b082955e083ec3)(),
        rcciRcciArriveeGendarmerieId: (0, $ce4de947442b2ab1$export$22b082955e083ec3)(),
        rcciRcciArriveePoliceId: (0, $ce4de947442b2ab1$export$22b082955e083ec3)(),
        rcciUtilisateurId: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
        rcciRisqueMeteo: (0, $ce4de947442b2ab1$export$22b082955e083ec3)(),
        documentList: (0, $ce4de947442b2ab1$export$2f23118c22fb2630)()
    }),
    coordonneeXToDisplay: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
    coordonneeYToDisplay: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba),
    typeSystemeSrid: (0, $36ceaed6faf947af$export$8bc4fdb2734276ba)
});
const $6968f3a041d56083$var$RcciForm = ()=>{
    const { user: user, epsg: epsg } = (0, $e787cde576104469$export$fdc397e486fa83e7)();
    const [currentTab, setCurrentTab] = (0, $kc00y.useState)("renseignements");
    const [sectionWarning, setSectionWarning] = (0, $kc00y.useState)();
    const { values: values, setFieldValue: setFieldValue, setValues: setValues, errors: errors, isSubmitting: isSubmitting } = (0, $bkJfK.useFormikContext)();
    const appSrid = epsg.name.split(":").pop();
    const { error: errorToast } = (0, $6bdae0bad7b05751$export$91b3d218c74c79e4)();
    const sridList = (0, $e2315562ed43d638$export$2e2bcd8739ae039).filter((v)=>v.actif || v.srid === Number(appSrid)).map((v)=>({
            id: `${v.srid}`,
            code: `${v.srid}`,
            libelle: v.nomSystem
        }));
    const geometrieState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/rcci/get-geometrie-by-srid?${{
        coordonneeX: values.coordonneeXToDisplay,
        coordonneeY: values.coordonneeYToDisplay,
        srid: values.typeSystemeSrid
    }}`);
    const rcciTypePrometheeFamilleState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/nomenclatures/list/${(0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).RCCI_TYPE_PROMETHEE_FAMILLE}`);
    const rcciTypePrometheePartitionState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/nomenclatures/list/${(0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).RCCI_TYPE_PROMETHEE_PARTITION}`);
    const rcciTypePrometheeCategorieState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/nomenclatures/list/${(0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).RCCI_TYPE_PROMETHEE_CATEGORIE}`);
    const rcciTypeDegreCertitudeState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/nomenclatures/list/${(0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).RCCI_TYPE_DEGRE_CERTITUDE}`);
    const rcciTypeOrigineAlerteState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/nomenclatures/list/${(0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).RCCI_TYPE_ORIGINE_ALERTE}`);
    const rcciIndiceRothermelState = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/nomenclatures/list/${(0, $0d1c1a6d7932bf75$export$2e2bcd8739ae039).RCCI_INDICE_ROTHERMEL}`);
    const directionList = Object.entries((0, $059bc2b75ef03255$export$2e2bcd8739ae039)).map(([key, value])=>{
        return {
            id: key,
            code: value,
            libelle: value
        };
    });
    const referentielState = (0, $8d9ebd8892d8a5f5$export$6326fb4463ae1be4)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/rcci/refs?${{
        geometrie: (()=>{
            const projectionAppSrid = geometrieState?.data?.find((e)=>e.srid?.toString() === appSrid);
            if (projectionAppSrid && projectionAppSrid.coordonneeX && projectionAppSrid.coordonneeY) return `SRID=${appSrid};POINT(${projectionAppSrid.coordonneeX} ${projectionAppSrid.coordonneeY})`;
            return `SRID=${values.typeSystemeSrid};POINT(${values.rcci?.rcciX} ${values.rcci?.rcciY})`;
        })()
    }}`);
    const { data: data, run: run } = (0, $8d9ebd8892d8a5f5$export$9158e33c8d0ca687)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/dfci/check`);
    const { run: runReferentielState } = referentielState;
    (0, $kc00y.useEffect)(()=>{
        if (!values.rcci?.rcciX || !values.rcci?.rcciY || !values.rcci?.rcciSrid) return;
        if (values.coordonneeXToDisplay != null && values.coordonneeYToDisplay != null) {
            geometrieState?.run({
                coordonneeX: values.coordonneeXToDisplay,
                coordonneeY: values.coordonneeYToDisplay,
                srid: values.typeSystemeSrid
            });
            const geometry = `SRID=${values.rcci.rcciSrid};POINT(${values.rcci.rcciX} ${values.rcci.rcciY})`;
            if (geometry) {
                run({
                    geometry: geometry
                });
                runReferentielState({
                    geometrie: geometry
                });
            }
        }
        const coordonnees = geometrieState?.data?.find((e)=>e.srid === Number(appSrid));
        if (coordonnees != null) {
            setFieldValue("rcci.rcciX", coordonnees?.coordonneeX);
            setFieldValue("rcci.rcciY", coordonnees?.coordonneeY);
        }
    }, [
        run,
        values.rcci?.rcciSrid,
        values.rcci?.rcciX,
        values.rcci?.rcciY,
        values.coordonneeXToDisplay,
        values.coordonneeYToDisplay,
        values.typeSystemeSrid,
        geometrieState,
        runReferentielState,
        setFieldValue,
        appSrid
    ]);
    (0, $kc00y.useEffect)(()=>{
        if (!values.rcci?.rcciX || !values.rcci?.rcciY) return;
        if (referentielState.data?.listCommune != null && referentielState.data?.listCommune?.length !== 0 && !values.rcci?.rcciCommuneId) setFieldValue("rcci.rcciCommuneId", referentielState.data?.listCommune[0].id);
    }, [
        values.rcci?.rcciX,
        values.rcci?.rcciY,
        referentielState.data?.listCommune,
        values.rcci?.rcciCommuneId,
        setFieldValue
    ]);
    (0, $kc00y.useEffect)(()=>{
        setFieldValue("rcci.rcciCarroyageDfci", data?.carroyageDfciCoordonneee);
    }, [
        data,
        setFieldValue
    ]);
    (0, $kc00y.useEffect)(()=>{
        if (values.coordonneeXToDisplay !== undefined && values.coordonneeYToDisplay !== undefined) {
            const projection = geometrieState?.data?.find((e)=>Number(e.srid) === Number(appSrid));
            if (projection) {
                setFieldValue("rcci.rcciX", projection.coordonneeX);
                setFieldValue("rcci.rcciY", projection.coordonneeY);
            }
        }
    }, [
        values.coordonneeXToDisplay,
        values.coordonneeYToDisplay,
        appSrid,
        setFieldValue,
        geometrieState?.data
    ]);
    (0, $kc00y.useEffect)(()=>{
        if (isSubmitting && errors) {
            const hasRenseignementsErrors = !!(errors.rcci?.rcciDateIncendie || errors.rcci?.rcciRcciTypeOrigineAlerteId || errors.rcci?.rcciCommuneId || errors.rcci?.rcciVoieId || errors.rcci?.rcciVoieTexte);
            const hasConstatatationsErrors = !!(errors.coordonneeXToDisplay || errors.coordonneeYToDisplay || errors.typeSystemeSrid);
            setSectionWarning({
                renseignements: hasRenseignementsErrors,
                constatations: hasConstatatationsErrors
            });
            // Switcher automatiquement vers le premier onglet avec erreur
            if (hasRenseignementsErrors) setCurrentTab("renseignements");
            else if (hasConstatatationsErrors) setCurrentTab("constatations");
            errorToast("Veuillez remplir tous les champs obligatoires");
        }
    }, [
        isSubmitting,
        errors,
        errorToast
    ]);
    const listOuiNonNA = Object.entries((0, $5ced9b26b3420067$export$2e2bcd8739ae039)).map(([key, value])=>{
        return {
            id: key,
            code: value,
            libelle: value
        };
    });
    const listRisqueMeteo = Object.entries((0, $e9329478c70b6d7b$export$2e2bcd8739ae039)).map(([key, value])=>{
        return {
            id: key,
            code: value,
            libelle: value
        };
    });
    const { activesKeys: activesKeys, handleShowClose: handleShowClose } = (0, $db860d90b4a42fea$export$dae930a4ba30758b)([
        true,
        ...Array(2).fill(false)
    ]);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
        noValidate: true,
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                    children: [
                        "Nouveau d\xe9part en cours de saisie par ",
                        user.username
                    ]
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $5f8ed132be8030d8$export$2e2bcd8739ae039), {
                id: "tabs",
                activeKey: currentTab,
                onSelect: (key)=>setCurrentTab(key),
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $ec8c33620b91a894$export$2e2bcd8739ae039), {
                        eventKey: "renseignements",
                        title: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("span", {
                            children: [
                                "Renseignements incendie",
                                " ",
                                sectionWarning?.renseignements && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$5be70e40251e6f9b), {})
                            ]
                        }),
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f76670b5e5897c33), {
                                title: "Renseignements",
                                children: [
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$183478aa40b5df1), {
                                                    label: "Date",
                                                    name: "rcci.rcciDateIncendie",
                                                    required: true,
                                                    value: (0, $00c47c7740afd024$export$cc23f907e4acb548)(values.rcci?.rcciDateIncendie)
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                                                    name: "rcci.rcciRcciTypeOrigineAlerteId",
                                                    label: "Origine",
                                                    listIdCodeLibelle: rcciTypeOrigineAlerteState.data,
                                                    defaultValue: rcciTypeOrigineAlerteState.data?.find((v)=>v.id === values.rcci?.rcciRcciTypeOrigineAlerteId),
                                                    required: true,
                                                    setFieldValue: setFieldValue
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                                                    label: "Commune",
                                                    name: "rcci.rcciCommuneId",
                                                    listIdCodeLibelle: referentielState.data?.listCommune,
                                                    defaultValue: referentielState.data?.listCommune?.find((v)=>v.id === values.rcci?.rcciCommuneId),
                                                    onChange: (e)=>{
                                                        setFieldValue("rcci.rcciCommuneId", e?.id);
                                                        setFieldValue("rcci.rcciVoieId", null);
                                                    },
                                                    setFieldValue: setFieldValue,
                                                    required: true
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                                children: [
                                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                                                        name: "rcci.rcciVoieId",
                                                        listIdCodeLibelle: referentielState.data?.listVoie?.filter((e)=>e.communeId === values.rcci?.rcciCommuneId),
                                                        label: "Voie",
                                                        defaultValue: referentielState.data?.listVoie?.find((e)=>e.id === values.rcci?.rcciVoieId),
                                                        required: !values.rcci.voieSaisieLibre,
                                                        setFieldValue: setFieldValue,
                                                        disabled: values.rcci?.voieSaisieLibre || values.rcci?.rcciVoieTexte != null && values.rcci?.rcciVoieTexte.trim() !== ""
                                                    }),
                                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                                                        name: "rcci.voieSaisieLibre",
                                                        label: "Voie non trouv\xe9e",
                                                        onChange: ()=>{
                                                            const newValue = !values.rcci?.voieSaisieLibre;
                                                            setFieldValue("rcci.voieSaisieLibre", newValue);
                                                            if (newValue) // on passe en saisie libre : on vide l'id de voie
                                                            setFieldValue("rcci.rcciVoieId", null);
                                                            else // on repasse sur la liste : on vide le texte libre
                                                            setFieldValue("rcci.rcciVoieTexte", null);
                                                        }
                                                    }),
                                                    values.rcci?.voieSaisieLibre && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                                                        name: "rcci.rcciVoieTexte",
                                                        label: "Voie (saisie libre)",
                                                        required: values.rcci.voieSaisieLibre,
                                                        disabled: values.rcci?.rcciVoieId != null && values.rcci?.rcciVoieId?.trim() !== ""
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$ce9b1cc0c34506d0), {
                                                label: "Compl\xe9ment",
                                                name: "rcci.rcciComplement",
                                                required: false
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f76670b5e5897c33), {
                                title: "Arriv\xe9e sur site des r\xe9f\xe9rents",
                                children: [
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                                                    name: "rcci.rcciRcciArriveeDdtmOnfId",
                                                    label: "DDTM - ONF",
                                                    listIdCodeLibelle: referentielState.data?.ddtmonf,
                                                    defaultValue: referentielState.data?.ddtmonf?.find((v)=>v.id === values.rcci?.rcciRcciArriveeDdtmOnfId),
                                                    required: false,
                                                    setFieldValue: setFieldValue
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                                                    name: "rcci.rcciRcciArriveeSdisId",
                                                    label: "SDIS",
                                                    listIdCodeLibelle: referentielState.data?.sdis,
                                                    defaultValue: referentielState.data?.sdis?.find((v)=>v.id === values.rcci?.rcciRcciArriveeSdisId),
                                                    required: false,
                                                    setFieldValue: setFieldValue
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                                                    name: "rcci.rcciRcciArriveeGendarmerieId",
                                                    label: "Gendarmerie",
                                                    listIdCodeLibelle: referentielState.data?.gendarmerie,
                                                    defaultValue: referentielState.data?.gendarmerie?.find((v)=>v.id === values.rcci?.rcciRcciArriveeGendarmerieId),
                                                    required: false,
                                                    setFieldValue: setFieldValue
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                                                    name: "rcci.rcciRcciArriveePoliceId",
                                                    label: "Police",
                                                    listIdCodeLibelle: referentielState.data?.police,
                                                    defaultValue: referentielState.data?.police?.find((v)=>v.id === values.rcci?.rcciRcciArriveePoliceId),
                                                    required: false,
                                                    setFieldValue: setFieldValue
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec8c33620b91a894$export$2e2bcd8739ae039), {
                        eventKey: "constatations",
                        title: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("span", {
                            children: [
                                "Constatations ",
                                sectionWarning?.constatations && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$5be70e40251e6f9b), {})
                            ]
                        }),
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db860d90b4a42fea$export$2e2bcd8739ae039), {
                            activesKeys: activesKeys,
                            list: [
                                {
                                    header: "Coordonn\xe9es",
                                    content: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f76670b5e5897c33), {
                                        children: [
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                                children: [
                                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {}),
                                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                                                            label: "Syst\xe8me",
                                                            name: "typeSystemeSrid",
                                                            required: true,
                                                            listIdCodeLibelle: sridList,
                                                            defaultValue: sridList.find((v)=>v.id === values.typeSystemeSrid),
                                                            onChange: (e)=>{
                                                                setValues((prevValues)=>({
                                                                        ...prevValues,
                                                                        typeSystemeSrid: e.code
                                                                    }));
                                                                const sridActif = e.code;
                                                                const projectionValeur = geometrieState.data?.find((e)=>e.srid === parseInt(sridActif));
                                                                setFieldValue("coordonneeXToDisplay", projectionValeur?.coordonneeX);
                                                                setFieldValue("coordonneeYToDisplay", projectionValeur?.coordonneeY);
                                                                // Coordonnées en 2154 ou autres
                                                                const coordonneesToSave = geometrieState.data?.find((e)=>e.srid === appSrid);
                                                                setFieldValue("coordonneeX", coordonneesToSave?.coordonneeX);
                                                                setFieldValue("coordonneeY", coordonneesToSave?.coordonneeY);
                                                            },
                                                            setFieldValue: setFieldValue
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                                children: [
                                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                                                            label: "X",
                                                            name: "coordonneeXToDisplay",
                                                            required: true,
                                                            onChange: (v)=>{
                                                                setFieldValue("coordonneeXToDisplay", v.target.value);
                                                                setFieldValue("rcci.rcciX", v.target.value);
                                                                setFieldValue("rcci.rcciSrid", values.typeSystemeSrid);
                                                                runReferentielState({
                                                                    geometrie: `SRID=${values.typeSystemeSrid};POINT(${v.target.value} ${values.coordonneeYToDisplay})`
                                                                });
                                                            }
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                                                            label: "Y",
                                                            name: "coordonneeYToDisplay",
                                                            required: true,
                                                            onChange: (v)=>{
                                                                setFieldValue("coordonneeYToDisplay", v.target.value);
                                                                setFieldValue("rcci.rcciY", v.target.value);
                                                                setFieldValue("rcci.rcciSrid", values.typeSystemeSrid);
                                                                runReferentielState({
                                                                    geometrie: `SRID=${values.typeSystemeSrid};POINT(${values.coordonneeXToDisplay} ${v.target.value})`
                                                                });
                                                            }
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                                children: [
                                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                                                            label: "Carroyage DFCI",
                                                            name: "rcci.rcciCarroyageDfci",
                                                            required: false,
                                                            readOnly: true,
                                                            disabled: true
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                                                            label: "Point d'\xe9closion",
                                                            name: "rcci.rcciPointEclosion",
                                                            required: false
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                },
                                {
                                    header: "M\xe9t\xe9o",
                                    content: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f76670b5e5897c33), {
                                        children: [
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                                children: [
                                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$183478aa40b5df1), {
                                                            label: "GDH",
                                                            name: "rcci.rcciGdh",
                                                            required: false,
                                                            value: values.rcci?.rcciGdh && (0, $00c47c7740afd024$export$cc23f907e4acb548)(values.rcci?.rcciGdh)
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                                                            name: "rcci.rcciVentLocal",
                                                            listIdCodeLibelle: listOuiNonNA,
                                                            label: "Vent local",
                                                            defaultValue: listOuiNonNA?.find((v)=>v.id === values?.rcci.rcciVentLocal),
                                                            required: false,
                                                            setFieldValue: setFieldValue
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                                children: [
                                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$6bf0cd3a219bbade), {
                                                            label: "Hygrom\xe9trie (%)",
                                                            name: "rcci.rcciHygrometrie",
                                                            required: false,
                                                            min: 0,
                                                            max: 100,
                                                            step: 1
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                                                            name: "rcci.rcciDirectionVent",
                                                            listIdCodeLibelle: directionList,
                                                            label: "Direction",
                                                            defaultValue: directionList?.find((v)=>v.id === values?.rcci.rcciDirectionVent),
                                                            required: false,
                                                            setFieldValue: setFieldValue
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                                children: [
                                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$6bf0cd3a219bbade), {
                                                            label: "Temp\xe9rature (\xb0C)",
                                                            name: "rcci.rcciTemperature",
                                                            required: false,
                                                            step: 1
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$6bf0cd3a219bbade), {
                                                            label: "Force (km/h)",
                                                            name: "rcci.rcciForceVent",
                                                            required: false,
                                                            min: 0,
                                                            step: 1
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                                children: [
                                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                                                            name: "rcci.rcciRcciIndiceRothermelId",
                                                            label: "Indice ROTHERMEL",
                                                            listIdCodeLibelle: rcciIndiceRothermelState.data,
                                                            defaultValue: rcciIndiceRothermelState.data?.find((v)=>v.id === values.rcci?.rcciRcciIndiceRothermelId),
                                                            required: false,
                                                            setFieldValue: setFieldValue
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                                                            name: "rcci.rcciRisqueMeteo",
                                                            listIdCodeLibelle: listRisqueMeteo,
                                                            label: "Risque m\xe9t\xe9o",
                                                            defaultValue: listRisqueMeteo?.find((v)=>v.id === values?.rcci.rcciRisqueMeteo),
                                                            required: false,
                                                            setFieldValue: setFieldValue
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                },
                                {
                                    header: "Feu",
                                    content: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f76670b5e5897c33), {
                                        children: [
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                                children: [
                                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$6bf0cd3a219bbade), {
                                                            label: "Superficie arriv\xe9e secours (m\xb2)",
                                                            name: "rcci.rcciSuperficieSecours",
                                                            required: false,
                                                            step: 0.01,
                                                            min: 0
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                                                            label: "Premier engin sur les lieux",
                                                            name: "rcci.rcciPremierEngin",
                                                            required: false
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                                children: [
                                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$6bf0cd3a219bbade), {
                                                            label: "Superficie arriv\xe9e r\xe9f\xe9rent (m\xb2)",
                                                            name: "rcci.rcciSuperficieReferent",
                                                            required: false,
                                                            step: 0.01,
                                                            min: 0
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                                                            label: "Premier COS",
                                                            name: "rcci.rcciPremierCos",
                                                            required: false
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                                children: [
                                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$6bf0cd3a219bbade), {
                                                            label: "Superficie finale (m\xb2)",
                                                            name: "rcci.rcciSuperficieFinale",
                                                            required: false,
                                                            step: 0.01,
                                                            min: 0
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                                                            label: "Forces de l'ordre pr\xe9sentes",
                                                            name: "rcci.rcciForcesOrdre",
                                                            required: false
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                                children: [
                                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                                                            name: "rcci.rcciGelLieux",
                                                            listIdCodeLibelle: listOuiNonNA,
                                                            label: "Gel des lieux",
                                                            defaultValue: listOuiNonNA?.find((v)=>v.id === values?.rcci.rcciGelLieux),
                                                            required: false,
                                                            setFieldValue: setFieldValue
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {})
                                                ]
                                            })
                                        ]
                                    })
                                }
                            ],
                            handleShowClose: handleShowClose
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec8c33620b91a894$export$2e2bcd8739ae039), {
                        eventKey: "causes",
                        title: "Causes et r\xe9sultats des investigations",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f76670b5e5897c33), {
                            title: "Localisation et acc\xe8s",
                            children: [
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                            children: [
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                                                    name: "rcci.rcciRcciTypePrometheeFamilleId",
                                                    label: "Prom\xe9th\xe9e famille",
                                                    listIdCodeLibelle: rcciTypePrometheeFamilleState.data,
                                                    defaultValue: rcciTypePrometheeFamilleState.data?.find((v)=>v.id === values.rcci?.rcciRcciTypePrometheeFamilleId),
                                                    required: false,
                                                    setFieldValue: (name, value)=>{
                                                        setFieldValue("rcci.rcciRcciTypePrometheePartitionId", null);
                                                        setFieldValue("rcci.rcciRcciTypePrometheeCategorieId", undefined);
                                                        setFieldValue(name, value);
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                                                    name: "rcci.rcciRcciTypePrometheePartitionId",
                                                    label: "Prom\xe9th\xe9e partition",
                                                    listIdCodeLibelle: rcciTypePrometheePartitionState.data?.filter((v)=>v.lienId === values.rcci?.rcciRcciTypePrometheeFamilleId),
                                                    defaultValue: rcciTypePrometheePartitionState.data?.find((v)=>v.id === values.rcci?.rcciRcciTypePrometheePartitionId),
                                                    required: false,
                                                    setFieldValue: (name, value)=>{
                                                        setFieldValue("rcci.rcciRcciTypePrometheeCategorieId", undefined);
                                                        setFieldValue(name, value);
                                                    },
                                                    disabled: values.rcci?.rcciRcciTypePrometheeFamilleId == null
                                                }),
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                                                    name: "rcci.rcciRcciTypePrometheeCategorieId",
                                                    label: "Prom\xe9th\xe9e cat\xe9gorie",
                                                    listIdCodeLibelle: rcciTypePrometheeCategorieState.data?.filter((v)=>v.lienId === values.rcci?.rcciRcciTypePrometheePartitionId),
                                                    defaultValue: rcciTypePrometheeCategorieState.data?.find((v)=>v.id === values.rcci?.rcciRcciTypePrometheeCategorieId),
                                                    required: false,
                                                    setFieldValue: setFieldValue,
                                                    disabled: values.rcci?.rcciRcciTypePrometheeFamilleId == null || values.rcci?.rcciRcciTypePrometheePartitionId == null
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                                                name: "rcci.rcciRcciTypeDegreCertitudeId",
                                                label: "Degr\xe9 certitude",
                                                listIdCodeLibelle: rcciTypeDegreCertitudeState.data,
                                                defaultValue: rcciTypeDegreCertitudeState.data?.find((v)=>v.id === values.rcci?.rcciRcciTypeDegreCertitudeId),
                                                required: false,
                                                setFieldValue: setFieldValue
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$ce9b1cc0c34506d0), {
                                            name: "rcci.rcciCommentaireConclusion",
                                            label: "Commentaires et conclusions",
                                            required: false
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $ec8c33620b91a894$export$2e2bcd8739ae039), {
                        eventKey: "documents",
                        title: "Documents",
                        children: [
                            values.rcci?.documentList?.length > 0 && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$f76670b5e5897c33), {
                                title: "Documents existants",
                                children: values.rcci?.documentList?.map((file, index)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                                        children: [
                                            file.documentNom,
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $98f55aa78fbaf278$export$2e2bcd8739ae039), {
                                                pill: true,
                                                variant: "info",
                                                onClick: ()=>{
                                                    const win = window.open(file.documentUrl, "_blank");
                                                    win.focus();
                                                },
                                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$4a5ccdc9878f4668), {})
                                            }),
                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $98f55aa78fbaf278$export$2e2bcd8739ae039), {
                                                pill: true,
                                                variant: "danger",
                                                onClick: ()=>{
                                                    setFieldValue(`rcci.documentList`, values.rcci?.documentList.filter((v, i)=>i !== index));
                                                },
                                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$4d4e10ce882b8153), {})
                                            })
                                        ]
                                    }, index))
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f76670b5e5897c33), {
                                title: "Documents ajout\xe9s",
                                children: [
                                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b57af79a4ab2a1c6), {
                                        multiple: true,
                                        accept: "image/*,.pdf",
                                        required: false,
                                        name: `documentHolder`,
                                        onChange: (e)=>{
                                            if (e.target.files.length) setFieldValue(`documentList`, [
                                                ...values.documentList,
                                                ...e.target.files
                                            ]);
                                            setFieldValue(`documentHolder`, null);
                                        }
                                    }),
                                    values.documentList?.length > 0 && values.documentList.map((file, index)=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                                            children: [
                                                file.name,
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $c094b74d2be2aa67$export$2e2bcd8739ae039), {
                                                    onClick: ()=>{
                                                        setFieldValue("documentList", values.documentList.filter((v, i)=>i !== index));
                                                    },
                                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$4d4e10ce882b8153), {})
                                                })
                                            ]
                                        }, index))
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db9b0e6fdb142a4c$export$2e2bcd8739ae039), {})
        ]
    });
};
var $6968f3a041d56083$export$2e2bcd8739ae039 = $6968f3a041d56083$var$RcciForm;


const $d54ef715299088f0$var$CreateRcci = ({ creationRcciGeometrie: creationRcciGeometrie, onSubmit: onSubmit })=>{
    const { user: user, epsg: epsg } = (0, $e787cde576104469$export$fdc397e486fa83e7)();
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                displayReturnButton: false,
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$6abbf1cbc7a5c0f9), {}),
                title: "Cr\xe9ation d'une RCCI"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                initialValues: (0, $6968f3a041d56083$export$a5cab80145b70e98)(creationRcciGeometrie ? {
                    rcci: creationRcciGeometrie.rcci
                } : {
                    rcci: undefined
                }, user.utilisateurId),
                validationSchema: (0, $6968f3a041d56083$export$c084437b5e3206cd),
                isPost: true,
                isMultipartFormData: true,
                submitUrl: `/api/rcci/create/`,
                prepareVariables: (values)=>(0, $6968f3a041d56083$export$8470ef9d0802da38)(values, epsg.name.split(":").pop()),
                onSubmit: onSubmit,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $6968f3a041d56083$export$2e2bcd8739ae039), {})
            })
        ]
    });
};
var $d54ef715299088f0$export$2e2bcd8739ae039 = $d54ef715299088f0$var$CreateRcci;










const $a115b05eb30517ce$var$UpdateRcci = ({ rcciId: rcciId, onSubmit: onSubmit })=>{
    const { user: user, epsg: epsg } = (0, $e787cde576104469$export$fdc397e486fa83e7)();
    const { data: data } = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)(`/api/rcci/${rcciId}/`, {});
    return data && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                displayReturnButton: false,
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$6abbf1cbc7a5c0f9), {}),
                title: "Mise \xe0 jour d'une RCCI"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                initialValues: (0, $6968f3a041d56083$export$a5cab80145b70e98)(data, user.utilisateurId),
                validationSchema: (0, $6968f3a041d56083$export$c084437b5e3206cd),
                isPost: false,
                isMultipartFormData: true,
                submitUrl: `/api/rcci/${rcciId}/`,
                prepareVariables: (values)=>(0, $6968f3a041d56083$export$8470ef9d0802da38)(values, epsg.name.split(":").pop()),
                onSubmit: onSubmit,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $6968f3a041d56083$export$2e2bcd8739ae039), {})
            })
        ]
    });
};
var $a115b05eb30517ce$export$2e2bcd8739ae039 = $a115b05eb30517ce$var$UpdateRcci;











const $899eea1af2e14673$export$1d7df3593004b8d = ({ map: map, workingLayer: workingLayer, dataRcciLayerRef: dataRcciLayerRef })=>{
    const { success: successToast, error: errorToast } = (0, $6bdae0bad7b05751$export$91b3d218c74c79e4)();
    const [creationRcciGeometrie, setCreationRcciGeometrie] = (0, $kc00y.useState)(null);
    const { epsg: epsg } = (0, $e787cde576104469$export$fdc397e486fa83e7)();
    const handleCloseCreationRcci = ()=>setCreationRcciGeometrie(null);
    const { value: deleteValue, visible: deleteVisible, show: deleteShow, close: deleteClose, ref: deleteRef } = (0, $ca8671088139af49$export$2e2bcd8739ae039)();
    const [rcciModifieId, setRcciModifieId] = (0, $kc00y.useState)(null);
    const tools = (0, $kc00y.useMemo)(()=>{
        if (!map) return {};
        const createCtrl = new (0, $2ef894158a48397d$export$2e2bcd8739ae039)({
            source: workingLayer.getSource(),
            type: "Point"
        });
        createCtrl.on("drawend", async (event)=>{
            const carteProjection = map.getView().getProjection();
            const targetProjection = epsg.name;
            let coords = event.feature.getGeometry().getCoordinates();
            if (carteProjection.getCode() !== targetProjection) coords = (0, $a86eee1c28205a05$export$51186ad6e864892a)(coords, carteProjection, targetProjection);
            (await fetch((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/zone-integration/check`, (0, $fbd4d34e07af0ac7$export$b163ec2f884327db)({
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    geometry: "SRID=" + map.getView().getProjection().getCode().split(":").pop() + ";" + new (0, $15a985d09649bdc2$export$2e2bcd8739ae039)().writeFeature(event.feature)
                })
            }))).text().then((text)=>{
                if (text === "true") {
                    const geometry = "SRID=" + epsg.name.split(":").pop() + ";POINT(" + coords[0] + " " + coords[1] + ")";
                    setCreationRcciGeometrie({
                        rcci: {
                            rcciGeometrie: geometry
                        }
                    });
                    (0, $1ed1be1197ad1bc4$export$51ba454167fb25ab)(map);
                    workingLayer.getSource().removeFeature(event.feature);
                } else workingLayer.getSource().removeFeature(event.feature);
            }).catch((reason)=>{
                workingLayer.getSource().removeFeature(event.feature);
                errorToast(reason?.message || reason?.toString?.() || "Erreur inconnue");
            });
        });
        let moveCtrl = dataRcciLayerRef.current ? new (0, $2375ecf9b29b2a49$export$2e2bcd8739ae039)({
            source: dataRcciLayerRef.current.getSource()
        }) : undefined;
        function toggleCreate(active = false) {
            const idx = map?.getInteractions().getArray().indexOf(createCtrl);
            if (active) {
                if (idx === -1) map.addInteraction(createCtrl);
            } else map.removeInteraction(createCtrl);
        }
        let deleteCtrl = dataRcciLayerRef.current ? new (0, $20af4deb83586389$export$2e2bcd8739ae039)({
            layers: [
                dataRcciLayerRef.current
            ]
        }) : undefined;
        let editCtrl = dataRcciLayerRef.current ? new (0, $20af4deb83586389$export$2e2bcd8739ae039)({
            layers: [
                dataRcciLayerRef.current
            ]
        }) : undefined;
        function toggleEdit(active = false) {
            if (!editCtrl) editCtrl = dataRcciLayerRef.current ? new (0, $20af4deb83586389$export$2e2bcd8739ae039)({
                layers: [
                    dataRcciLayerRef.current
                ]
            }) : undefined;
            if (!editCtrl || !map) return;
            const hasSelectListener = (editCtrl?.getListeners("select")?.length ?? 0) > 0;
            if (!hasSelectListener) editCtrl?.on("select", function(evt) {
                if (!evt.selected || evt.selected.length !== 1) return;
                evt.selected.forEach(async function(feature) {
                    setRcciModifieId(feature.getProperties().elementId);
                });
                // Supprimer la sélection après avoir sélectionné l'élément
                if (editCtrl) editCtrl.getFeatures().clear();
            });
            const idx = map?.getInteractions().getArray().indexOf(editCtrl);
            if (active) {
                if (idx === -1) map.addInteraction(editCtrl);
            } else map.removeInteraction(editCtrl);
        }
        function toggleDelete(active = false) {
            if (!deleteCtrl) deleteCtrl = dataRcciLayerRef.current ? new (0, $20af4deb83586389$export$2e2bcd8739ae039)({
                layers: [
                    dataRcciLayerRef.current
                ]
            }) : undefined;
            if (!deleteCtrl || !map) return;
            const hasSelectListener = (deleteCtrl?.getListeners("select")?.length ?? 0) > 0;
            if (!hasSelectListener) deleteCtrl?.on("select", function(evt) {
                if (!evt.selected || evt.selected.length !== 1) return;
                evt.selected.forEach(async function(feature) {
                    deleteShow(feature.getProperties().elementId);
                });
            });
            const idx = map?.getInteractions().getArray().indexOf(deleteCtrl);
            if (active) {
                if (idx === -1) map.addInteraction(deleteCtrl);
            } else map.removeInteraction(deleteCtrl);
        }
        function toggleMove(active = false) {
            if (!moveCtrl) moveCtrl = dataRcciLayerRef.current ? new (0, $2375ecf9b29b2a49$export$2e2bcd8739ae039)({
                source: dataRcciLayerRef.current.getSource()
            }) : undefined;
            if (!moveCtrl || !map) return;
            const hasModifyEndListener = (moveCtrl?.getListeners("modifyend")?.length ?? 0) > 0;
            if (!hasModifyEndListener) moveCtrl?.on("modifyend", (event)=>{
                if (!event.features || event.features.getLength() !== 1) return;
                event.features.forEach(async (feature)=>{
                    (await fetch((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/zone-integration/check`, (0, $fbd4d34e07af0ac7$export$b163ec2f884327db)({
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify({
                            geometry: "SRID=" + map.getView().getProjection().getCode().split(":").pop() + ";" + new (0, $15a985d09649bdc2$export$2e2bcd8739ae039)().writeFeature(feature)
                        })
                    }))).text().then((text)=>{
                        if (text === "true") fetch((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/rcci/${feature.getProperties().elementId}/geometry`, (0, $fbd4d34e07af0ac7$export$b163ec2f884327db)({
                            method: "PATCH",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify({
                                rcciId: feature.getProperties().elementId,
                                rcciGeometrie: `SRID=${map.getView().getProjection().getCode().split(":").pop()};${new (0, $15a985d09649bdc2$export$2e2bcd8739ae039)().writeFeature(feature)}`
                            })
                        })).then((res)=>{
                            if (res.status === 200) {
                                (0, $1ed1be1197ad1bc4$export$51ba454167fb25ab)(map);
                                successToast("G\xe9om\xe9trie modifi\xe9e");
                            }
                        });
                        else {
                            workingLayer.getSource().removeFeature(event.feature);
                            errorToast(text);
                        }
                    }).catch((reason)=>{
                        workingLayer.getSource().removeFeature(event.feature);
                        errorToast(reason);
                    });
                });
            });
            const idx = map.getInteractions().getArray().indexOf(moveCtrl);
            if (active) {
                if (idx === -1) {
                    moveCtrl.setActive(true);
                    map.addInteraction(moveCtrl);
                }
            } else {
                moveCtrl.setActive(false);
                map.removeInteraction(moveCtrl);
            }
        }
        const tools = {
            "create-rcci": {
                action: toggleCreate
            },
            "edit-rcci": {
                action: toggleEdit
            },
            "delete-rcci": {
                action: toggleDelete
            },
            "move-rcci": {
                action: toggleMove,
                actionPossibleEnDeplacement: false
            }
        };
        return tools;
    }, [
        map,
        dataRcciLayerRef.current,
        workingLayer,
        epsg.name,
        deleteShow,
        successToast,
        errorToast
    ]);
    return {
        tools: tools,
        creationRcciGeometrie: creationRcciGeometrie,
        handleCloseCreationRcci: handleCloseCreationRcci,
        deleteModalRefs: {
            visible: deleteVisible,
            value: deleteValue,
            show: deleteShow,
            close: deleteClose,
            ref: deleteRef
        },
        rcciModifieId: rcciModifieId,
        setRcciModifieId: setRcciModifieId
    };
};
const $899eea1af2e14673$var$MapToolbarRcci = ({ map: map, toggleTool: toggleToolCallback, activeTool: activeTool, dataRcciLayerRef: dataRcciLayerRef, creationRcciGeometrie: creationRcciGeometrie, handleCloseCreationRcci: handleCloseCreationRcci, deleteModalRefs: deleteModalRefs, anneeCivileRef: anneeCivileRef, rcciModifieId: rcciModifieId, setRcciModifieId: setRcciModifieId })=>{
    const { user: user } = (0, $e787cde576104469$export$fdc397e486fa83e7)();
    const [, forceUpdate] = (0, $kc00y.useReducer)((x)=>x + 1, 0);
    const [creationSansGeom, setCreationSansGeom] = (0, $kc00y.useState)(false);
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $a43e6f68e14bab96$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1ac4483a0721609f$export$2e2bcd8739ae039), {
                    codeThematique: (0, $690fed8fd87ee1b4$export$2e2bcd8739ae039).RCI,
                    titreVolet: "Liste des documents li\xe9s aux RCCI"
                })
            }),
            (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).RCCI_A) && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $a43e6f68e14bab96$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $f2eef644ac9323e0$export$2e2bcd8739ae039), {
                        toolName: "create-rcci",
                        toolIcon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$e52728f4e2dd782d), {}),
                        toolLabelTooltip: "Cr\xe9er une RCCI",
                        toggleTool: toggleToolCallback,
                        activeTool: activeTool
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                        tooltipText: "Cr\xe9er une RCCI (saisie X/Y)",
                        tooltipId: "create-rcci-xy",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                            name: "tool",
                            onClick: ()=>setCreationSansGeom(true),
                            id: "create-rcci-xy",
                            value: "create-rcci-xy",
                            variant: "outline-primary",
                            className: "m-2",
                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$d776d19dfae66ece), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $f2eef644ac9323e0$export$2e2bcd8739ae039), {
                        toolName: "edit-rcci",
                        toolIcon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$b51dd496211ae105), {}),
                        toolLabelTooltip: "Modifier une RCCI",
                        toggleTool: toggleToolCallback,
                        activeTool: activeTool
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $f2eef644ac9323e0$export$2e2bcd8739ae039), {
                        toolName: "delete-rcci",
                        toolIcon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$4d4e10ce882b8153), {}),
                        toolLabelTooltip: "Supprimer une RCCI",
                        toggleTool: toggleToolCallback,
                        activeTool: activeTool
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $f2eef644ac9323e0$export$2e2bcd8739ae039), {
                        toolName: "move-rcci",
                        toolIcon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$ef875af7def69d98), {}),
                        toolLabelTooltip: "D\xe9placer une RCCI",
                        toggleTool: toggleToolCallback,
                        activeTool: activeTool
                    })
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $a43e6f68e14bab96$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                    tooltipText: "Masquer les d\xe9parts ant\xe9rieurs \xe0 l'ann\xe9e civile",
                    tooltipId: "hide-rcci",
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                        name: "tool",
                        onClick: ()=>{
                            anneeCivileRef.displayAnneCivile();
                            forceUpdate(); // forcer rerender pour relire le ref
                        },
                        toolName: "edit-rcci",
                        value: "hide-rcci",
                        variant: "outline-primary",
                        className: "m-2",
                        active: anneeCivileRef.anneeCivileRef.current,
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$e9e91475793130c8), {})
                    })
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1eee265537f042a4$export$2e2bcd8739ae039), {
                handleClose: ()=>{
                    handleCloseCreationRcci();
                    setCreationSansGeom(false);
                },
                show: creationRcciGeometrie !== null || creationSansGeom,
                className: "w-auto",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $d54ef715299088f0$export$2e2bcd8739ae039), {
                    creationRcciGeometrie: creationRcciGeometrie,
                    onSubmit: ()=>{
                        dataRcciLayerRef.current?.getSource().refresh();
                        (0, $1ed1be1197ad1bc4$export$51ba454167fb25ab)(map);
                        handleCloseCreationRcci();
                        setCreationSansGeom(false);
                    }
                })
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1eee265537f042a4$export$2e2bcd8739ae039), {
                handleClose: ()=>{
                    setRcciModifieId(null);
                },
                show: rcciModifieId !== null,
                className: "w-auto",
                backdrop: true,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $a115b05eb30517ce$export$2e2bcd8739ae039), {
                    rcciId: rcciModifieId,
                    onSubmit: ()=>{
                        dataRcciLayerRef.current?.getSource().refresh();
                        (0, $1ed1be1197ad1bc4$export$51ba454167fb25ab)(map);
                        setRcciModifieId(null);
                    }
                })
            }),
            deleteModalRefs.visible && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $791e7ee3b0d1ae7e$export$2e2bcd8739ae039), {
                visible: deleteModalRefs.visible,
                onCancel: deleteModalRefs.close,
                onSuccess: deleteModalRefs.close,
                onError: deleteModalRefs.close,
                query: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/rcci`,
                ref: deleteModalRefs.ref,
                id: deleteModalRefs.value,
                onDelete: ()=>{
                    dataRcciLayerRef.current?.getSource().refresh();
                    (0, $1ed1be1197ad1bc4$export$51ba454167fb25ab)(map);
                }
            })
        ]
    });
};
$899eea1af2e14673$var$MapToolbarRcci.displayName = "MapToolbarRcci";
var $899eea1af2e14673$export$2e2bcd8739ae039 = $899eea1af2e14673$var$MapToolbarRcci;


const $087e705b3d412400$var$MapRcci = ()=>{
    const mapElement = (0, $kc00y.useRef)();
    const dataRcciLayerRef = (0, $kc00y.useRef)();
    const anneeCivileRef = (0, $kc00y.useRef)(false);
    function displayAnneCivile() {
        anneeCivileRef.current = !anneeCivileRef.current;
        dataRcciLayerRef.current?.changed();
    }
    const { map: map, workingLayer: workingLayer, availableLayers: availableLayers, addOrRemoveLayer: addOrRemoveLayer, layerListRef: layerListRef, showOutilI: showOutilI, mapToolbarRef: mapToolbarRef } = (0, $cdcdd8e1ff041f79$export$547f9c492d831282)({
        mapElement: mapElement,
        typeModule: (0, $a9754922f4c67d47$export$ef88b514e4bfff34).RCI,
        displayPei: false
    });
    const rcciStyle = (0, $kc00y.useCallback)((feature)=>{
        const date = feature.get("rcciDateIncendie");
        const year = date ? new Date(date).getFullYear() : null;
        const currentYear = new Date().getFullYear();
        if (anneeCivileRef.current && year !== currentYear) return undefined;
        const iconSrc = year === currentYear ? (0, (/*@__PURE__*/$parcel$interopDefault($209200b1607d20a0$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($5e0d23e26a39fa9c$exports)));
        const textColor = year === currentYear ? "red" : "orange";
        return new (0, $a5fc261473972d1d$export$2e2bcd8739ae039)({
            image: new (0, $39b0ac330ad6f6e7$export$2e2bcd8739ae039)({
                src: iconSrc,
                scale: 1,
                anchor: [
                    0.5,
                    1
                ]
            }),
            text: new (0, $ee3bf0a2c13d7793$export$2e2bcd8739ae039)({
                text: (0, $00c47c7740afd024$export$3ae94a2503e890a1)(date),
                font: "12px Calibri,sans-serif",
                offsetY: 5,
                fill: new (0, $8624b871a0af6dab$export$2e2bcd8739ae039)({
                    color: textColor
                }),
                stroke: new (0, $281691897fddf9d0$export$2e2bcd8739ae039)({
                    color: "#ffffff",
                    width: 4
                })
            })
        });
    }, []);
    dataRcciLayerRef.current = (0, $kc00y.useMemo)(()=>{
        if (!map || availableLayers.length === 0) return undefined;
        const group = availableLayers.find((e)=>e.code === (0, $f740b0d032822ba6$export$3ad03f8706c2f84c));
        if (!group || !group.layers) return undefined;
        const layerObj = group.layers.find((e)=>e.code === (0, $f740b0d032822ba6$export$3ad03f8706c2f84c));
        if (!layerObj || !layerObj.openlayer) return undefined;
        const layer = layerObj.openlayer;
        layer.setMinZoom((layer.getMinZoom?.() ?? 0) - 2);
        layer.setStyle(rcciStyle);
        return layer;
    }, [
        map,
        availableLayers,
        rcciStyle
    ]);
    const { tools: extraTools, creationRcciGeometrie: creationRcciGeometrie, handleCloseCreationRcci: handleCloseCreationRcci, deleteModalRefs: deleteModalRefs, rcciModifieId: rcciModifieId, setRcciModifieId: setRcciModifieId } = (0, $899eea1af2e14673$export$1d7df3593004b8d)({
        map: map,
        workingLayer: workingLayer,
        dataRcciLayerRef: dataRcciLayerRef
    });
    const { toggleTool: toggleTool, activeTool: activeTool, infoOutilI: infoOutilI, handleCloseInfoI: handleCloseInfoI } = (0, $e2b798e23180fa76$export$194c7727cbdc0cac)({
        availableLayers: availableLayers,
        map: map,
        workingLayer: workingLayer,
        extraTools: extraTools
    });
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                title: "Recherche des Causes et des Circonstances d'Incendie (RCCI)",
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$6abbf1cbc7a5c0f9), {})
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $cdcdd8e1ff041f79$export$2e2bcd8739ae039), {
                map: map,
                outilI: infoOutilI,
                showOutilI: showOutilI,
                handleCloseInfoI: handleCloseInfoI,
                workingLayer: workingLayer,
                availableLayers: availableLayers,
                addOrRemoveLayer: addOrRemoveLayer,
                layerListRef: layerListRef,
                mapToolbarRef: mapToolbarRef,
                mapElement: mapElement,
                toggleTool: toggleTool,
                activeTool: activeTool,
                toolbarElement: mapToolbarRef.current && dataRcciLayerRef.current && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $899eea1af2e14673$export$2e2bcd8739ae039), {
                    map: map,
                    toggleTool: toggleTool,
                    activeTool: activeTool,
                    dataRcciLayerRef: dataRcciLayerRef,
                    creationRcciGeometrie: creationRcciGeometrie,
                    handleCloseCreationRcci: handleCloseCreationRcci,
                    deleteModalRefs: deleteModalRefs,
                    rcciModifieId: rcciModifieId,
                    setRcciModifieId: setRcciModifieId,
                    anneeCivileRef: {
                        anneeCivileRef: anneeCivileRef,
                        displayAnneCivile: displayAnneCivile
                    }
                })
            })
        ]
    });
};
var $087e705b3d412400$export$2e2bcd8739ae039 = $087e705b3d412400$var$MapRcci;


const $4226cb44342fe5b6$var$Rcci = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $087e705b3d412400$export$2e2bcd8739ae039), {});
};
var $4226cb44342fe5b6$export$2e2bcd8739ae039 = $4226cb44342fe5b6$var$Rcci;




var $bkJfK = parcelRequire("bkJfK");







const $4103b2e2c988da42$export$a5cab80145b70e98 = ()=>({
        document: null
    });
const $4103b2e2c988da42$export$c084437b5e3206cd = (0, $ce4de947442b2ab1$export$be5493f9613cbbe)({});
const $4103b2e2c988da42$export$f97400759cfd946 = (values)=>{
    const formData = new FormData();
    formData.append("document", values.document);
    return formData;
};
const $4103b2e2c988da42$var$DepotDeliberation = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$c9bef5de7ad5da31), {}),
                title: "D\xe9poser une d\xe9lib\xe9ration"
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
                initialValues: $4103b2e2c988da42$export$a5cab80145b70e98(),
                validationSchema: $4103b2e2c988da42$export$c084437b5e3206cd,
                isPost: false,
                isMultipartFormData: true,
                submitUrl: `/api/signalements/deliberation/`,
                prepareVariables: (values)=>$4103b2e2c988da42$export$f97400759cfd946(values),
                redirectUrl: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).ACCUEIL,
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($4103b2e2c988da42$var$FormImportDocument, {})
            })
        ]
    });
};
const $4103b2e2c988da42$var$FormImportDocument = ()=>{
    const { setFieldValue: setFieldValue } = (0, $bkJfK.useFormikContext)();
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b57af79a4ab2a1c6), {
                name: "document",
                accept: ".*",
                required: true,
                onChange: (e)=>setFieldValue("document", e.target.files[0])
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                className: "mt-3",
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                    className: "text-center",
                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                        type: "submit",
                        variant: "primary",
                        children: "Valider"
                    })
                })
            })
        ]
    });
};
var $4103b2e2c988da42$export$2e2bcd8739ae039 = $4103b2e2c988da42$var$DepotDeliberation;










const $4000938da69a64f9$var$ModuleSignalement = ()=>{
    const { user: user } = (0, $e787cde576104469$export$fdc397e486fa83e7)();
    const navLinks = [
        {
            path: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).SIGNALEMENTS,
            label: "Carte des signalements",
            aLeDroit: (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).SIGNALEMENTS_C)
        },
        {
            path: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).SIGNALEMENTS_DELIBERATION,
            label: "D\xe9poser une d\xe9lib\xe9ration",
            aLeDroit: (0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).DEPOT_DELIB_C)
        }
    ];
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $a0064658a8399ad3$export$2e2bcd8739ae039), {
        navbar: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $5de16d9a2066fdee$export$2e2bcd8739ae039), {
            links: navLinks
        }),
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $7a844823b04d4282$export$910ae8079b2c2852), {})
    });
};
var $4000938da69a64f9$export$2e2bcd8739ae039 = $4000938da69a64f9$var$ModuleSignalement;













const $e3baa122da989549$var$UpdateTournee = ()=>{
    const { tourneeId: tourneeId } = (0, $7a844823b04d4282$export$99eaa27ddbbb95ef)();
    const tourneeInfo = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/tournee/` + tourneeId);
    if (!tourneeInfo.isResolved) return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $c21b1c237cfa1d94$export$2e2bcd8739ae039), {});
    const { data: data } = tourneeInfo;
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
        initialValues: (0, $8e1c372a2c39ab17$export$a5cab80145b70e98)(data),
        isPost: false,
        isMultipartFormData: false,
        submitUrl: `/api/tournee/updateTournee`,
        prepareVariables: (values)=>(0, $8e1c372a2c39ab17$export$f97400759cfd946)(values),
        redirectUrl: (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_TOURNEE,
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8e1c372a2c39ab17$export$2e2bcd8739ae039), {
            tourneeLibelle: data.tourneeLibelle
        })
    });
};
var $e3baa122da989549$export$2e2bcd8739ae039 = $e3baa122da989549$var$UpdateTournee;




var $bkJfK = parcelRequire("bkJfK");

var $kc00y = parcelRequire("kc00y");


















var $bkJfK = parcelRequire("bkJfK");










var $bkJfK = parcelRequire("bkJfK");






const $7cd47734986047b3$var$SimplifiedVisiteForm = ({ index: index, typeVisite: typeVisite, listeAnomaliesAssignable: listeAnomaliesAssignable, typePei: typePei })=>{
    const { values: values, setFieldValue: setFieldValue } = (0, $bkJfK.useFormikContext)();
    const { handleShowClose: handleShowCloseFormulaire, activesKeys: activesKeysFormulaire } = (0, $db860d90b4a42fea$export$dae930a4ba30758b)([
        false
    ]);
    const { handleShowClose: handleShowCloseAnomalies, activesKeys: activesKeysAnomalies } = (0, $db860d90b4a42fea$export$dae930a4ba30758b)([
        false
    ]);
    let filteredListAnomalie = [];
    if (typeVisite) switch(typeVisite){
        case (0, $d1d6244030f5b65c$export$75645a4de2ddb107).RECEPTION:
            filteredListAnomalie = listeAnomaliesAssignable?.filter((e)=>e.isReceptionAssignable === true) ?? [];
            break;
        case (0, $d1d6244030f5b65c$export$75645a4de2ddb107).RECO_INIT:
            filteredListAnomalie = listeAnomaliesAssignable?.filter((e)=>e.isRecoInitAssignable === true) ?? [];
            break;
        case (0, $d1d6244030f5b65c$export$75645a4de2ddb107).CTP:
            filteredListAnomalie = listeAnomaliesAssignable?.filter((e)=>e.isCTPAssignable === true) ?? [];
            break;
        case (0, $d1d6244030f5b65c$export$75645a4de2ddb107).ROP:
            filteredListAnomalie = listeAnomaliesAssignable?.filter((e)=>e.isRopAssignable === true) ?? [];
            break;
        case (0, $d1d6244030f5b65c$export$75645a4de2ddb107).NP:
            filteredListAnomalie = listeAnomaliesAssignable?.filter((e)=>e.isNPAssignable === true) ?? [];
            break;
        default:
            break;
    }
    const groupedListeAnomalies = Object.groupBy(filteredListAnomalie, (item)=>item.anomalieCategorieLibelle);
    const listeVoletsAccordion = [];
    Object.entries(groupedListeAnomalies).map(([categorie, listAno])=>listeVoletsAccordion.push({
            header: categorie,
            // TODO : Ajouter une indication du nombre d'anomalies cochées
            content: listAno?.map((element)=>{
                const anomalieIndex = values.listeSimplifiedVisite[index].listeAnomalie?.findIndex((e)=>e.anomalieId === element.anomalieId);
                return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                    name: `listeSimplifiedVisite[${index}].listeAnomalie[${anomalieIndex}].isAssigned`,
                    label: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("span", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))(element.poidsAnomalieValIndispoTerrestre === 5 && "fw-bold", element.poidsAnomalieValIndispoHbe === 5 && "text-decoration-underline"),
                        children: element.anomalieLibelle
                    }),
                    disabled: values.listeSimplifiedVisite[index].isNoAnomalieChecked || values.listeSimplifiedVisite[index].isSameAnomalieChecked,
                    onChange: ()=>{
                        setFieldValue(`listeSimplifiedVisite[${index}].listeAnomalie[${anomalieIndex}].isAssigned`, !values.listeSimplifiedVisite[index].listeAnomalie[anomalieIndex].isAssigned);
                        setFieldValue(`listeSimplifiedVisite[${index}].isModified`, true);
                    }
                }, element.anomalieId);
            })
        }));
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $948296388fc3e3c9$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                                name: `listeSimplifiedVisite[${index}].isNoAnomalieChecked`,
                                label: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                                    tooltipText: `Le PEI contr\xf4l\xe9 ne pr\xe9sente aucune anomalie`,
                                    tooltipId: `${index}.isNoAnomalieChecked`,
                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
                                        children: "Aucune anomalie"
                                    })
                                }),
                                onChange: ()=>{
                                    setFieldValue(`listeSimplifiedVisite[${index}].isNoAnomalieChecked`, !values.listeSimplifiedVisite[index].isNoAnomalieChecked);
                                    // Pour l'appli, la valeur isNoAnomalieChecked n'est pas encore update quand on arrive au niveau du if
                                    // il faut donc mettre à jour la liste d'anomalie en prenant pour référence la valeur avant update
                                    if (values.listeSimplifiedVisite[index].isNoAnomalieChecked) {
                                        setFieldValue(`listeSimplifiedVisite[${index}].listeAnomalie`, listeAnomaliesAssignable);
                                        setFieldValue(`listeSimplifiedVisite[${index}].isModified`, false);
                                    } else {
                                        const listeAnomalieUnasigned = listeAnomaliesAssignable.map((anomalie)=>({
                                                ...anomalie,
                                                isAssigned: false
                                            }));
                                        setFieldValue(`listeSimplifiedVisite[${index}].listeAnomalie`, listeAnomalieUnasigned);
                                        setFieldValue(`listeSimplifiedVisite[${index}].isModified`, true);
                                    }
                                },
                                disabled: values.listeSimplifiedVisite[index].isSameAnomalieChecked
                            }, `listeSimplifiedVisite[${index}].isNoAnomalieChecked`),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                                name: `listeSimplifiedVisite[${index}].isSameAnomalieChecked`,
                                label: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $26478c730c1b77dd$export$2e2bcd8739ae039), {
                                    tooltipText: `Les anomalies relev\xe9es lors du contr\xf4le du PEI correspondent en tout point \xe0 celles du pr\xe9c\xe9dent contr\xf4le`,
                                    tooltipId: `${index}.isSameAnomalieChecked`,
                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
                                        children: "Rien \xe0 modifier"
                                    })
                                }),
                                onChange: ()=>{
                                    setFieldValue(`listeSimplifiedVisite[${index}].isSameAnomalieChecked`, !values.listeSimplifiedVisite[index].isSameAnomalieChecked);
                                    setFieldValue(`listeSimplifiedVisite[${index}].listeAnomalie`, listeAnomaliesAssignable);
                                    if (values.listeSimplifiedVisite[index].isSameAnomalieChecked) setFieldValue(`listeSimplifiedVisite[${index}].isModified`, false);
                                    else setFieldValue(`listeSimplifiedVisite[${index}].isModified`, true);
                                },
                                disabled: values.listeSimplifiedVisite[index].isNoAnomalieChecked
                            }, `listeSimplifiedVisite[${index}].isSameAnomalieChecked`)
                        ]
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                        xs: "auto",
                        className: "text-align-center",
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                            onClick: ()=>{
                                setFieldValue(`listeSimplifiedVisite[${index}].listeAnomalie`, listeAnomaliesAssignable);
                                setFieldValue(`listeSimplifiedVisite[${index}].isModified`, false);
                            },
                            disabled: values.listeSimplifiedVisite[index].isNoAnomalieChecked || values.listeSimplifiedVisite[index].isSameAnomalieChecked,
                            children: "R\xe9initialiser les anomalies \xe0 l'\xe9tat initial"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db860d90b4a42fea$export$2e2bcd8739ae039), {
                    activesKeys: activesKeysFormulaire,
                    handleShowClose: handleShowCloseFormulaire,
                    list: [
                        ...values.isCtrlDebitPression === true && typePei === (0, $f31f748b1c9fd0fb$export$2e2bcd8739ae039).PIBI ? [
                            {
                                header: "Mesures",
                                content: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$2e2bcd8739ae039), {
                                                name: `listeSimplifiedVisite[${index}].ctrlDebitPression.ctrlPression`,
                                                label: "Pression statique (bar) : ",
                                                min: 0,
                                                step: 0.01,
                                                required: false
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$2e2bcd8739ae039), {
                                                name: `listeSimplifiedVisite[${index}].ctrlDebitPression.ctrlPressionDyn`,
                                                label: "Pression dynamique au d\xe9bit nominal (bar) : ",
                                                min: 0,
                                                step: 0.01,
                                                required: false
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$2e2bcd8739ae039), {
                                                name: `listeSimplifiedVisite[${index}].ctrlDebitPression.ctrlDebit`,
                                                label: "D\xe9bit \xe0 1 bar (m\xb3/h) : ",
                                                min: 0,
                                                required: false
                                            })
                                        })
                                    ]
                                })
                            }
                        ] : [],
                        {
                            header: "Points d'attention",
                            content: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("div", {
                                children: values.visiteTypeVisite ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $db860d90b4a42fea$export$2e2bcd8739ae039), {
                                    activesKeys: activesKeysAnomalies,
                                    handleShowClose: handleShowCloseAnomalies,
                                    list: listeVoletsAccordion
                                }) : /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("p", {
                                    children: "S\xe9lectionnez le type de visite pour acc\xe9der \xe0 la liste des anomalies assignables"
                                })
                            })
                        },
                        {
                            header: "Observations",
                            content: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$ce9b1cc0c34506d0), {
                                name: `listeSimplifiedVisite[${index}].visiteObservation`,
                                required: false
                            })
                        }
                    ]
                })
            })
        ]
    });
};
var $7cd47734986047b3$export$2e2bcd8739ae039 = $7cd47734986047b3$var$SimplifiedVisiteForm;


const $1446a19b1a20d7c3$var$IterableVisiteForm = ({ name: name, listeElements: listeElements, typeVisite: typeVisite, listeAnomaliesAssignable: listeAnomaliesAssignable, listPeiInformations: listPeiInformations, results: results })=>{
    let libelleNonConforme = "";
    const listeParametre = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/parametres?${{
        listeParametreCode: JSON.stringify([
            (0, $ee297f06e8568bf4$export$2e2bcd8739ae039).PEI_LIBELLE_NON_CONFORME
        ])
    }}`);
    if (listeParametre.isResolved) libelleNonConforme = listeParametre?.data?.[(0, $ee297f06e8568bf4$export$2e2bcd8739ae039).PEI_LIBELLE_NON_CONFORME].parametreValeur.toUpperCase();
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $bkJfK.FieldArray), {
        name: name,
        render: ()=>/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
                children: listeElements?.map((value, index)=>{
                    const currentPeiId = value.visitePeiId;
                    const currentInformation = listPeiInformations[listPeiInformations.findIndex((peiInfo)=>peiInfo.peiId === currentPeiId)];
                    const canHaveGestionnaire = currentInformation.natureDeciCode === (0, $e2b283d869a75a62$export$2e2bcd8739ae039).PRIVE || currentInformation.natureDeciCode === (0, $e2b283d869a75a62$export$2e2bcd8739ae039).CONVENTIONNE || currentInformation.natureDeciCode === (0, $e2b283d869a75a62$export$2e2bcd8739ae039).ICPE || currentInformation.natureDeciCode === (0, $e2b283d869a75a62$export$2e2bcd8739ae039).ICPE_CONVENTIONNE;
                    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $948296388fc3e3c9$exports.Fragment), {
                        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($f7a9c14f75da0acc$exports)))("bg-light m-4 p-3 border rounded-3", value.isModified && "border border-success"),
                            children: [
                                results && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                    className: "bg-danger",
                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                        children: results[currentPeiId]?.message
                                    })
                                }),
                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                            className: "col-6",
                                            children: [
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("b", {
                                                                children: "Num\xe9ro complet :"
                                                            }),
                                                            " ",
                                                            currentInformation.peiNumeroComplet
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("b", {
                                                                children: "Nature PEI :"
                                                            }),
                                                            " ",
                                                            currentInformation.natureLibelle,
                                                            " ",
                                                            "(",
                                                            currentInformation.peiTypePei,
                                                            ")"
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("b", {
                                                                children: "Adresse :"
                                                            }),
                                                            " ",
                                                            currentInformation.adresse,
                                                            " ",
                                                            currentInformation.communeCodePostal,
                                                            " ",
                                                            currentInformation.communeLibelle,
                                                            " (",
                                                            currentInformation.communeCodeInsee,
                                                            ")"
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("b", {
                                                                children: "Nature DECI :"
                                                            }),
                                                            " ",
                                                            currentInformation.natureDeciLibelle
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("b", {
                                                                children: "Domaine :"
                                                            }),
                                                            " ",
                                                            currentInformation.domaineLibelle
                                                        ]
                                                    })
                                                }),
                                                canHaveGestionnaire && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("b", {
                                                                children: "Propri\xe9taire :"
                                                            }),
                                                            " ",
                                                            currentInformation.gestionnaireLibelle
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                                        className: "d-flex align-items-center gap-2",
                                                        children: [
                                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("b", {
                                                                children: "Etat :"
                                                            }),
                                                            (0, $f808952c311684ce$export$2e2bcd8739ae039)[currentInformation.peiDisponibiliteTerrestre] === (0, $f808952c311684ce$export$2e2bcd8739ae039).DISPONIBLE ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("span", {
                                                                className: "text-white bg-success rounded px-1 text-nowrap",
                                                                children: "DISPONIBLE"
                                                            }) : (0, $f808952c311684ce$export$2e2bcd8739ae039)[currentInformation.peiDisponibiliteTerrestre] === (0, $f808952c311684ce$export$2e2bcd8739ae039).INDISPONIBLE ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("span", {
                                                                className: "text-white bg-danger rounded px-1 text-nowrap",
                                                                children: "INDISPONIBLE"
                                                            }) : (0, $f808952c311684ce$export$2e2bcd8739ae039)[currentInformation.peiDisponibiliteTerrestre] === (0, $f808952c311684ce$export$2e2bcd8739ae039).NON_CONFORME ? /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("span", {
                                                                className: "text-white bg-warning rounded px-1 text-nowrap",
                                                                children: libelleNonConforme.toUpperCase()
                                                            }) : ""
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("b", {
                                                                children: "Date derni\xe8re ROP :"
                                                            }),
                                                            " ",
                                                            currentInformation.peiLastRop ? (0, $00c47c7740afd024$export$3ae94a2503e890a1)(currentInformation.peiLastRop) : ""
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("b", {
                                                                children: "Date dernier CTP :"
                                                            }),
                                                            " ",
                                                            currentInformation.peiLastCtp ? (0, $00c47c7740afd024$export$3ae94a2503e890a1)(currentInformation.peiLastCtp) : ""
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                                                    children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)("b", {
                                                                children: "Anomalies :"
                                                            }),
                                                            " ",
                                                            currentInformation.listeAnomalies
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                            className: "col-6",
                                            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $7cd47734986047b3$export$2e2bcd8739ae039), {
                                                index: index,
                                                typeVisite: typeVisite,
                                                listeAnomaliesAssignable: listeAnomaliesAssignable[currentPeiId],
                                                typePei: currentInformation.peiTypePei
                                            })
                                        })
                                    ]
                                })
                            ]
                        }, index)
                    });
                })
            })
    });
};
var $1446a19b1a20d7c3$export$2e2bcd8739ae039 = $1446a19b1a20d7c3$var$IterableVisiteForm;


// Pour respecter la loi des Hooks et empécher de charger des données (useGet) pour un utilisateur qui n'a pas les droits
// Le router appel ce composant qui s'occupe de vérifier les droits et de valider ou non le passage vers le formulaire
const $8da2bbfb15d82bb7$var$ValidateAccessSaisieVisiteTournee = ()=>{
    const { user: user } = (0, $e787cde576104469$export$fdc397e486fa83e7)();
    const { tourneeId: tourneeId } = (0, $7a844823b04d4282$export$99eaa27ddbbb95ef)();
    // La vérification suivante s'ajoute aux conditions dans l'appel au composant dans routes.tsx
    // Pour accéder à cet écran il faut :
    // - le droit TOURNEE_R ou TOURNEE_A
    // - au moins un droit de création de visite (parmis les 5 types de visite)
    if (!(0, $e3b8d60f4bb99483$export$4f612ab7b7b1d133)(user, [
        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).VISITE_RECEP_C,
        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).VISITE_RECO_INIT_C,
        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).VISITE_NON_PROGRAMME_C,
        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).VISITE_CONTROLE_TECHNIQUE_C,
        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).VISITE_RECO_C
    ])) return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$19e402bf0a6cad34), {});
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($8da2bbfb15d82bb7$var$SaisieVisiteTournee, {
        user: user,
        tourneeId: tourneeId
    });
};
var $8da2bbfb15d82bb7$export$2e2bcd8739ae039 = $8da2bbfb15d82bb7$var$ValidateAccessSaisieVisiteTournee;
const $8da2bbfb15d82bb7$var$SaisieVisiteTournee = ({ user: user, tourneeId: tourneeId })=>{
    const navigate = (0, $7a844823b04d4282$export$9770f232ac06a008)();
    const listeAnomaliesAssignable = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/anomalie/getAssignablesAnomaliesByTourneeId/` + tourneeId, {});
    const tourneeInformations = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/tournee/fetchTourneeVisiteInfo/` + tourneeId, {});
    function onSubmitResult(result) {
        // Result est une map <peiId, Erreur> issue de l'appel à CreateMultipleVisiteUseCase
        // Si j'ai des erreurs, je "relance" le formulaire avec uniquement les éléments qui ont causé l'erreur
        if (Object.keys(result).length > 0) {
            setSaveValues({
                tourneeId: tourneeId,
                visiteDate: saveValues.visiteDate,
                visiteTypeVisite: saveValues.visiteTypeVisite,
                visiteAgent1: saveValues.visiteAgent1,
                visiteAgent2: saveValues.visiteAgent2,
                isCtrlDebitPression: saveValues.isCtrlDebitPression,
                listeSimplifiedVisite: saveValues.listeSimplifiedVisite.filter((e)=>Object.keys(result).includes(e.visitePeiId))
            });
            setResult(result);
        } else navigate((0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).LIST_TOURNEE);
    }
    const valuesMemo = (0, $kc00y.useMemo)(()=>{
        const listeElements = [];
        tourneeInformations.data?.listCDPByPeiTournee.forEach((cdp)=>listeElements.push({
                visitePeiId: cdp.peiId,
                visiteObservation: "",
                listeAnomalie: listeAnomaliesAssignable.data?.[cdp.peiId] ?? [],
                ctrlDebitPression: {
                    visiteCtrlDebitPressionDebit: cdp.visiteCtrlDebitPressionDebit,
                    visiteCtrlDebitPressionPression: cdp.visiteCtrlDebitPressionPression,
                    visiteCtrlDebitPressionPressionDyn: cdp.visiteCtrlDebitPressionPressionDyn
                },
                isNoAnomalieChecked: false,
                isSameAnomalieChecked: false,
                isModified: false
            }));
        return {
            tourneeId: tourneeId,
            listeSimplifiedVisite: listeElements
        };
    }, [
        tourneeInformations,
        listeAnomaliesAssignable,
        tourneeId
    ]);
    const [saveValues, setSaveValues] = (0, $kc00y.useState)(null);
    const [resultState, setResult] = (0, $kc00y.useState)(null);
    (0, $kc00y.useEffect)(()=>{
        setSaveValues(valuesMemo);
    }, [
        valuesMemo
    ]);
    return listeAnomaliesAssignable.isResolved && tourneeInformations.isResolved && saveValues && /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $034ce07d723030fb$export$2e2bcd8739ae039), {
        initialValues: $8da2bbfb15d82bb7$var$getInitialValues(saveValues),
        isPost: true,
        submitUrl: `/api/visite/createVisiteTournee`,
        prepareVariables: (values)=>$8da2bbfb15d82bb7$export$f97400759cfd946(values),
        onSubmit: onSubmitResult,
        isPartialSuccess: function(result) {
            if (Object.keys(result).length > 0) return true;
            else return false;
        },
        successToastMessage: "Toutes les visites ont \xe9t\xe9 enregistr\xe9es",
        warningToastMessage: "Une ou plusieurs visites n'ont pas pu \xeatre enregistr\xe9es",
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($8da2bbfb15d82bb7$export$68b1d55de65d34c4, {
            user: user,
            tourneeLibelle: tourneeInformations.data.tourneeLibelle,
            listPeiInformations: tourneeInformations.data.listPeiInformations,
            listeAnomaliesAssignable: listeAnomaliesAssignable.data,
            setSaveValues: setSaveValues,
            results: resultState
        })
    });
};
const $8da2bbfb15d82bb7$var$getInitialValues = (_saveValues)=>({
        tourneeId: _saveValues.tourneeId,
        visiteDate: _saveValues.visiteDate ?? null,
        visiteTypeVisite: _saveValues.visiteTypeVisite ?? null,
        visiteAgent1: _saveValues.visiteAgent1 ?? null,
        visiteAgent2: _saveValues.visiteAgent2 ?? null,
        isCtrlDebitPression: _saveValues.isCtrlDebitPression ?? false,
        listeSimplifiedVisite: _saveValues.listeSimplifiedVisite
    });
const $8da2bbfb15d82bb7$export$f97400759cfd946 = (_values)=>({
        tourneeId: _values.tourneeId,
        visiteDate: new Date(_values.visiteDate).toISOString(),
        visiteTypeVisite: _values.visiteTypeVisite,
        visiteAgent1: _values.visiteAgent1,
        visiteAgent2: _values.visiteAgent2 ?? null,
        isCtrlDebitPression: _values.isCtrlDebitPression ?? false,
        listeSimplifiedVisite: _values.listeSimplifiedVisite.map((visite)=>{
            return {
                visitePeiId: visite.visitePeiId,
                visiteObservation: visite.visiteObservation?.trim().length > 0 ? visite.visiteObservation : null,
                listeAnomalie: visite.listeAnomalie // ne retourne que les anomalieId pour le back
                .filter((e)=>e.isAssigned === true).map((e)=>e.anomalieId) ?? [],
                ctrlDebitPression: visite.ctrlDebitPression ?? null
            };
        })
    });
const $8da2bbfb15d82bb7$export$68b1d55de65d34c4 = ({ user: user, tourneeLibelle: tourneeLibelle, listPeiInformations: listPeiInformations, listeAnomaliesAssignable: listeAnomaliesAssignable, setSaveValues: setSaveValues, results: results })=>{
    const { values: values, setValues: setValues } = (0, $bkJfK.useFormikContext)();
    const listTypeVisite = (0, $d1d6244030f5b65c$export$2e2bcd8739ae039).map((e)=>({
            id: e.code,
            code: e.code,
            libelle: e.libelle
        }));
    // Retire les types de visite que l'utilisateur n'a pas le droit de sasir
    const dynamicListTypeVisite = listTypeVisite.filter((e)=>(!(0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).VISITE_RECEP_C) ? e.code !== (0, $d1d6244030f5b65c$export$75645a4de2ddb107).RECEPTION : true) && (!(0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).VISITE_RECO_INIT_C) ? e.code !== (0, $d1d6244030f5b65c$export$75645a4de2ddb107).RECO_INIT : true) && (!(0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).VISITE_CONTROLE_TECHNIQUE_C) ? e.code !== (0, $d1d6244030f5b65c$export$75645a4de2ddb107).CTP : true) && (!(0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).VISITE_RECO_C) ? e.code !== (0, $d1d6244030f5b65c$export$75645a4de2ddb107).ROP : true) && (!(0, $e3b8d60f4bb99483$export$6a5b32721de9ef11)(user, (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).VISITE_NON_PROGRAMME_C) ? e.code !== (0, $d1d6244030f5b65c$export$75645a4de2ddb107).NP : true));
    const parametreVisiteTypeCdp = (0, $ee297f06e8568bf4$export$2e2bcd8739ae039).TYPE_VISITE_CDP;
    const listeParametre = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/parametres?${{
        listeParametreCode: JSON.stringify(parametreVisiteTypeCdp)
    }}`);
    let listeTypeVisiteCdp = [];
    if (listeParametre.isResolved) listeTypeVisiteCdp = JSON.parse(listeParametre?.data[parametreVisiteTypeCdp].parametreValeur);
    let enableCDP = false;
    if (values.visiteTypeVisite) {
        if (listeTypeVisiteCdp.some((typeVisite)=>values.visiteTypeVisite === typeVisite)) enableCDP = true;
        else values.isCtrlDebitPression = false;
    }
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $1c0a8d1838dcbbd7$export$f06621d9ad29af97), {
        children: [
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $751ac88b6dffd6cc$export$2e2bcd8739ae039), {
                        icon: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $8603b77743deb39a$export$5ee68ae963bf2bda), {}),
                        title: `Saisir les visites pour la tourn\xe9e ${tourneeLibelle}`
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                        className: "align-items-center",
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$183478aa40b5df1), {
                                    name: "visiteDate",
                                    label: "Date et Heure : "
                                })
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $41485b498b8865f9$export$2e2bcd8739ae039), {
                                    name: "visiteTypeVisite",
                                    listIdCodeLibelle: dynamicListTypeVisite,
                                    label: "Type de visite : ",
                                    required: true,
                                    setValues: setValues,
                                    defaultValue: dynamicListTypeVisite.find((e)=>e.id === values.visiteTypeVisite)
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $2fbf711edf8913b6$export$2e2bcd8739ae039), {
                        className: "align-items-center",
                        children: [
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$b0def9349e7d1439), {
                                    name: "isCtrlDebitPression",
                                    label: "Contr\xf4le d\xe9bit et pression (CDP)",
                                    disabled: !enableCDP
                                })
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                                    name: "visiteAgent1",
                                    label: "Agent 1 : ",
                                    required: true
                                })
                            }),
                            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $360599dc87384838$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1c0a8d1838dcbbd7$export$c86715117507e8e5), {
                                    name: "visiteAgent2",
                                    label: "Agent 2 : ",
                                    required: false
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsxs)((0, $4c73f725f3c8b0a1$export$2e2bcd8739ae039), {
                fluid: true,
                children: [
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $1446a19b1a20d7c3$export$2e2bcd8739ae039), {
                        name: "listeSimplifiedVisite",
                        listeElements: values.listeSimplifiedVisite,
                        typeVisite: values.visiteTypeVisite,
                        listeAnomaliesAssignable: listeAnomaliesAssignable,
                        listPeiInformations: listPeiInformations,
                        results: results
                    }),
                    /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $ec326a924dcbf351$export$2e2bcd8739ae039), {
                        type: "submit",
                        variant: "primary",
                        onClick: ()=>setSaveValues(values),
                        disabled: values.listeSimplifiedVisite.some((visite)=>visite.isModified === false),
                        children: "Valider"
                    })
                ]
            })
        ]
    });
};



const $972f9f5d1854d2f4$export$2389c26b9ec125dd = {
    ACCUEIL: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/`,
    LOGOUT: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/logout`,
    LOGIN: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/login`,
    LOGINERROR: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/loginerror`,
    LIST_INDISPONIBILITE_TEMPORAIRE: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/deci/indisponibilite-temporaire/`,
    VIEW_COURRIER: (typeModule)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/deci/create-courrier/${typeModule}/view-courrier`,
    // Module DECI
    DECI_CARTE: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/deci/carte`,
    ACCES_RAPIDE: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/deci/acces-rapide`,
    PEI: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/deci/pei`,
    DECLARATION_PEI: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/deci/declaration-pei`,
    IMPORT_CTP: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/deci/import-ctp`,
    RESULTAT_VERIF_IMPORT_CTP: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/deci/import-ctp/verification`,
    EXPORT_CTP: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/deci/export-ctp`,
    CREATE_INDISPONIBILITE_TEMPORAIRE: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/deci/indisponibilite-temporaire/create`,
    UPDATE_INDISPONIBILITE_TEMPORAIRE: (indisponibiliteTemporaireId)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/deci/indisponibilite-temporaire/` + indisponibiliteTemporaireId,
    INDISPONIBILITE_TEMPORAIRE_LISTE_PEI: (indisponibiliteTemporaireId)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/deci/indisponibilite-temporaire/pei/` + indisponibiliteTemporaireId,
    UPDATE_PEI: (peiId)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/deci/pei/` + peiId,
    PEI_TOURNEE: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/deci/pei/tournee`,
    UPDATE_PENA_ASPIRATION: (peiId)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/deci/pena-aspiration/` + peiId,
    VISITE: (peiId)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/deci/visite/` + peiId,
    LIST_TOURNEE: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/deci/tournee`,
    CREATE_TOURNEE: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/deci/tournee/create`,
    UPDATE_TOURNEE: (tourneeId)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/deci/tournee/update/` + tourneeId,
    TOURNEE_PEI: (tourneeId)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/deci/tournee/pei/` + tourneeId,
    TOURNEE_LISTE_PEI: (tourneeId)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/deci/tournee/liste-pei/` + tourneeId,
    TOURNEE_VISITE: (tourneeId)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/deci/tournee/visite-tournee/` + tourneeId,
    FICHE_RESUME: (peiId)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/deci/pei/fiche/` + peiId,
    MESSAGE_PEI_LONGUE_INDISPO_LISTE_PEI: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/deci/message-pei-longue-indispo/pei`,
    // Module couverture hydraulique
    CREATE_ETUDE: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/couverture-hydraulique/etudes/create`,
    UPDATE_ETUDE: (etudeId)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/couverture-hydraulique/etudes/` + etudeId,
    LIST_ETUDE: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/couverture-hydraulique/etudes/`,
    IMPORTER_COUVERTURE_HYDRAULIQUE: (etudeId)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/couverture-hydraulique/etudes/import/` + etudeId,
    UPDATE_PEI_PROJET: (etudeId, peiProjetId)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/couverture-hydraulique/etudes/` + etudeId + `/pei-projet/` + peiProjetId,
    OUVRIR_ETUDE: (etudeId)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/couverture-hydraulique/etudes/open/` + etudeId,
    // Module liste crises
    LIST_CRISES: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/gestion-crise/crise/`,
    CREATE_CRISE: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/gestion-crise/crise/create`,
    UPDATE_CRISE: (criseId)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/gestion-crise/crise/` + criseId,
    OUVRIR_CRISE: (criseId)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/gestion-crise/crise/open/` + criseId,
    MERGE_CRISE: (criseId)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/gestion-crise/crise/merge/` + criseId,
    EXPORT_CRISE: (criseId)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/gestion-crise/crise/export/` + criseId,
    UPDATE_EVENEMENT_SOUS_CATEGORIE: (evenementSousCategorieId)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/evenement-sous-categorie/update/` + evenementSousCategorieId,
    CREATE_EVENEMENT_SOUS_CATEGORIE: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/evenement-sous-categorie/create`,
    // Module carto perso
    CARTOGRAPHIE_PERSONNALISEE: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/cartographie-personnalisee`,
    // Module Carte pei prescrit
    PEI_PRESCRIT: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/pei-prescrit`,
    // MODULE OLDEB
    OLDEB_ACCES_RAPIDE: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/oldeb/recherche`,
    OLDEB_LIST: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/oldeb/liste`,
    OLDEB_CREATE: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/oldeb/create`,
    OLDEB_UPDATE: (oldebId)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/oldeb/${oldebId}`,
    OLDEB_LOCALISATION: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/oldeb/localisation`,
    OLDEB_PROPRIETAIRE_LIST: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/oldeb/proprietaire`,
    OLDEB_PROPRIETAIRE_CREATE: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/oldeb/proprietaire/create`,
    OLDEB_PROPRIETAIRE_UPDATE: (oldebProprietaireId)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/oldeb/proprietaire/${oldebProprietaireId}`,
    // Module RCCI
    RCCI_MAP: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/rcci`,
    // Module Carte Permis
    CARTE_PERMIS: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/permis`,
    // Module Carte des risques
    RISQUE: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/risque`,
    IMPORT_RISQUE_EXPRESS: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/risque/import-risque-express`,
    // MODULE ADMIN
    MODULE_ADMIN: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/menu`,
    UPDATE_DIAMETRE: (diametreId)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/diametre/` + diametreId,
    LIST_DIAMETRE: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/diametre/`,
    ADD_DIAMETRE: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/diametre/create/`,
    ADD_NATURE: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/nature/create`,
    UPDATE_NATURE: (natureId)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/nature/update/` + natureId,
    LIST_NATURE: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/nature`,
    LIST_SIGNALEMENT_TYPE_ANOMALIE: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/signalement-type-anomalie/`,
    ADD_SIGNALEMENT_TYPE_ANOMALIE: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/signalement-type-anomalie/create/`,
    UPDATE_SIGNALEMENT_TYPE_ANOMALIE: (signalementTypeAnomalieId)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/signalement-type-anomalie/` + signalementTypeAnomalieId,
    LIST_SIGNALEMENT_TYPE_ELEMENT: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/signalement-type-element/`,
    ADD_SIGNALEMENT_TYPE_ELEMENT: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/signalement-type-element/create/`,
    UPDATE_SIGNALEMENT_TYPE_ELEMENT: (signalementTypeElementId)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/signalement-type-element/` + signalementTypeElementId,
    LIST_SIGNALEMENT_SOUS_TYPE_ELEMENT: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/signalement-sous-type-element`,
    ADD_SIGNALEMENT_SOUS_TYPE_ELEMENT: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/signalement-sous-type-element/create`,
    UPDATE_SIGNALEMENT_SOUS_TYPE_ELEMENT: (signalementSousTypeElementId)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/signalement-sous-type-element/${signalementSousTypeElementId}`,
    GROUPE_FONCTIONNALITES_LIST: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/groupe-fonctionnalites`,
    GROUPE_FONCTIONNALITES_CREATE: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/groupe-fonctionnalites/create`,
    GROUPE_FONCTIONNALITES_UPDATE: (groupeFonctionnalitesId)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/groupe-fonctionnalites/${groupeFonctionnalitesId}`,
    LIEN_DROIT_LIST: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/lien-groupe-fonctionnalites`,
    LIEN_PROFIL_FONCTIONNALITE_LIST: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/lien-profil-fonctionnalite`,
    LIEN_PROFIL_FONCTIONNALITE_CREATE: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/lien-profil-fonctionnalite/create`,
    LIEN_PROFIL_FONCTIONNALITE_UPDATE: ({ profilOrganismeId: profilOrganismeId, profilUtilisateurId: profilUtilisateurId })=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/lien-profil-fonctionnalite/${profilOrganismeId}/${profilUtilisateurId}`,
    LIEN_TYPE_ORGANISME_DROIT_API: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/type-organisme-droits-api`,
    COUCHES_LIST: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/couches`,
    LIST_GROUPE_COUCHE: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/groupe-couche`,
    ADD_GROUPE_COUCHE: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/groupe-couche/create`,
    SORT_GROUPE_COUCHE: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/groupe-couche/sort`,
    UPDATE_GROUPE_COUCHE: (groupeCoucheId)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/groupe-couche/update/` + groupeCoucheId,
    LIST_COUCHE: (groupeCoucheId)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/groupe-couche/${groupeCoucheId}/couches`,
    CREATE_COUCHE: (groupeCoucheId)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/groupe-couche/${groupeCoucheId}/couche/create`,
    UPDATE_COUCHE: (groupeCoucheId, coucheId)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/groupe-couche/${groupeCoucheId}/couche/update/` + coucheId,
    SORT_COUCHE: (groupeCoucheId)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/groupe-couche/${groupeCoucheId}/couches/sort`,
    ADD_ORGANISME: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/organisme/create/`,
    UPDATE_ORGANISME: (organismeId)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/organisme/update/` + organismeId,
    LIST_ORGANISME: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/organisme`,
    ADD_NATURE_DECI: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/nature-deci/create`,
    UPDATE_NATURE_DECI: (natureDeciId)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/nature-deci/update/` + natureDeciId,
    LIST_NATURE_DECI: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/nature-deci`,
    ADD_DOMAINE: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/domaine/create`,
    UPDATE_DOMAINE: (domaineId)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/domaine/update/` + domaineId,
    LIST_DOMAINE: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/domaine`,
    ADD_FONCTION_CONTACT: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/fonction-contact/create`,
    UPDATE_FONCTION_CONTACT: (fonctionContactId)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/fonction-contact/update/` + fonctionContactId,
    LIST_FONCTION_CONTACT: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/fonction-contact`,
    ADD_MARQUE_PIBI: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/marque-pibi/create`,
    UPDATE_MARQUE_PIBI: (marquePibiId)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/marque-pibi/update/` + marquePibiId,
    LIST_MARQUE_PIBI: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/marque-pibi`,
    ADD_TYPE_ENGIN: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/type-engin/create`,
    UPDATE_TYPE_ENGIN: (typeEnginId)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/type-engin/update/` + typeEnginId,
    LIST_TYPE_ENGIN: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/type-engin`,
    ADD_MATERIAU: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/materiau/create`,
    UPDATE_MATERIAU: (materiauId)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/materiau/update/` + materiauId,
    LIST_MATERIAU: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/materiau`,
    ADD_TYPE_CANALISATION: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/type-canalisation/create`,
    UPDATE_TYPE_CANALISATION: (typeCanalisationId)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/type-canalisation/update/` + typeCanalisationId,
    LIST_TYPE_CANALISATION: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/type-canalisation`,
    ADD_TYPE_RESEAU: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/type-reseau/create`,
    UPDATE_TYPE_RESEAU: (typeReseauId)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/type-reseau/update/` + typeReseauId,
    LIST_TYPE_RESEAU: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/type-reseau`,
    ADD_ANOMALIE_CATEGORIE: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/anomalie-categorie/create`,
    UPDATE_ANOMALIE_CATEGORIE: (anomalieCategorieId)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/anomalie-categorie/update/` + anomalieCategorieId,
    LIST_ANOMALIE_CATEGORIE: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/anomalie-categorie`,
    SORT_ANOMALIE_CATEGORIE: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/anomalie-categorie/sort`,
    ADD_NIVEAU: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/niveau/create`,
    UPDATE_NIVEAU: (niveauId)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/niveau/update/` + niveauId,
    LIST_NIVEAU: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/niveau`,
    ADD_MODELE_PIBI: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/modele-pibi/create`,
    UPDATE_MODELE_PIBI: (modelePibiId)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/modele-pibi/update/` + modelePibiId,
    LIST_MODELE_PIBI: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/modele-pibi`,
    ADD_TYPE_ETUDE: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/type-etude/create`,
    UPDATE_TYPE_ETUDE: (typeEtudeId)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/type-etude/update/` + typeEtudeId,
    LIST_TYPE_ETUDE: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/type-etude`,
    ADD_TYPE_PENA_ASPIRATION: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/type-pena-aspiration/create`,
    UPDATE_TYPE_PENA_ASPIRATION: (typePenaAspirationId)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/type-pena-aspiration/update/` + typePenaAspirationId,
    LIST_TYPE_PENA_ASPIRATION: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/type-pena-aspiration`,
    ADD_TYPE_ORGANISME: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/type-organisme/create`,
    UPDATE_TYPE_ORGANISME: (typeOrganismeId)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/type-organisme/update/` + typeOrganismeId,
    LIST_TYPE_ORGANISME: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/type-organisme`,
    ADD_PROFIL_ORGANISME: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/profil-organisme/create`,
    UPDATE_PROFIL_ORGANISME: (profilOrganismeId)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/profil-organisme/update/` + profilOrganismeId,
    LIST_PROFIL_ORGANISME: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/profil-organisme`,
    ADD_PROFIL_UTILISATEUR: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/profil-utilisateur/create`,
    UPDATE_PROFIL_UTILISATEUR: (profilUtilisateurId)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/profil-utilisateur/update/` + profilUtilisateurId,
    LIST_PROFIL_UTILISATEUR: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/profil-utilisateur`,
    ADD_THEMATIQUE: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/thematique/create`,
    UPDATE_THEMATIQUE: (thematiqueId)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/thematique/update/` + thematiqueId,
    LIST_THEMATIQUE: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/thematique`,
    ADD_TYPE_CRISE: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/type-crise/create`,
    UPDATE_TYPE_CRISE: (typeCriseId)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/type-crise/update/` + typeCriseId,
    LIST_TYPE_CRISE: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/type-crise`,
    ADD_EVENEMENT_CATEGORIE: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/evenement-categorie/create`,
    UPDATE_EVENEMENT_CATEGORIE: (evenementCategorieId)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/evenement-categorie/update/` + evenementCategorieId,
    LIST_EVENEMENT_CATEGORIE: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/evenement-categorie`,
    EVENEMENT_CATEGORIE_LIST: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/evenement-categorie-list`,
    EVENEMENT_SOUS_CATEGORIE_LIST: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/evenement-sous-categorie-list`,
    ADD_EVENEMENT_SOUS_CATEGORIE: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/evenement-sous-categorie/create`,
    LIST_EVENEMENT_SOUS_CATEGORIE: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/evenement-sous-categorie`,
    UPDATE_TYPE_CRISE_CATEGORIE: (evenementSousCategorieId)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/evenement-sous-categorie/update/` + evenementSousCategorieId,
    ADD_ROLE_CONTACT: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/role-contact/create`,
    UPDATE_ROLE_CONTACT: (roleContactId)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/role-contact/update/` + roleContactId,
    LIST_ROLE_CONTACT: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/role-contact`,
    LIST_SITE: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/site`,
    UPDATE_SITE: (siteId)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/site/update/` + siteId,
    LIST_ZONE_INTEGRATION: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/zone-integration`,
    UPDATE_ZONE_INTEGRATION: (zoneIntegrationId)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/zone-integration/update/` + zoneIntegrationId,
    LIST_GESTIONNAIRE: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/gestionnaire`,
    ADD_GESTIONNAIRE: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/gestionnaire/create`,
    UPDATE_GESTIONNAIRE: (gestionnaireId)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/gestionnaire/update/` + gestionnaireId,
    LIST_COUCHE_METADATA: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/couche-metadata`,
    ADD_COUCHE_METADATA: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/couche-metadata/create-couche-metadata/`,
    UPDATE_COUCHE_METADATA: (coucheMetadataId)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/couche-metadata/update-couche-metadata/` + coucheMetadataId,
    ADD_CONTACT: (appartenanceId, appartenance)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/` + appartenance + `/` + appartenanceId + `/contact/create/`,
    LIST_CONTACT: (appartenanceId, appartenance)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/` + appartenance + `/` + appartenanceId + `/contact/`,
    UPDATE_CONTACT: (appartenanceId, contactId, appartenance)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/` + appartenance + `/` + appartenanceId + `/contact/update/` + contactId,
    ADD_DOCUMENT_HABILITABLE: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/document-habilitable/create`,
    LIST_DOCUMENT_HABILITABLE: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/document-habilitable`,
    UPDATE_DOCUMENT_HABILITABLE: (documentHabilitableId)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/document-habilitable/update/` + documentHabilitableId,
    LIST_ANOMALIE: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/anomalie`,
    ANOMALIE_CREATE: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/anomalie/create`,
    ANOMALIE_UPDATE: (anomalieId)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/anomalie/${anomalieId}`,
    ANOMALIE_SORT: (anomalieCategorieId)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/anomalie/sort/${anomalieCategorieId}`,
    ADD_UTILISATEUR: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/utilisateur/create`,
    IMPORT_UTILISATEUR: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/utilisateur/import`,
    RESULTAT_VERIF_IMPORT_UTILISATEURS: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/utilisateur/verification-import`,
    LIST_UTILISATEUR: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/utilisateur`,
    UPDATE_UTILISATEUR: (utilisateurId)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/utilisateur/update/` + utilisateurId,
    ADMIN_FICHE_RESUME: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/fiche-resume`,
    ADMIN_ACCUEIL: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/module-accueil`,
    ADMIN_PARAMETRE: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/parametres`,
    ADMIN_IMPORT_RESSOURCES: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/import-ressources`,
    CREATE_TACHE_SPECIFIQUE: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/tache-specifique/create`,
    LIST_TASK_SPECIFIQUE: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/tache-specifique`,
    ADMIN_EXECUTE_TASK_MANUELLE: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/tasks-manuelles/`,
    ADMIN_GESTION_ATLAS: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/gestion-atlas`,
    LIST_MODULE_DOCUMENT_COURRIER: (moduleType, moduleId)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/documents/` + moduleType.toLocaleLowerCase() + "/thematiques/" + moduleId,
    UPDATE_DEBIT_SIMULTANE: (debitSimultaneId)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/deci/debit-simultane/update/` + debitSimultaneId,
    LIST_RAPPORT_PERSONNALISE: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/rapport-personnalise`,
    CREATE_RAPPORT_PERSONNALISE: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/rapport-personnalise/create`,
    UPDATE_RAPPORT_PERSONNALISE: (rapportPersonnaliseId)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/rapport-personnalise/update/` + rapportPersonnaliseId,
    DUPLICATE_RAPPORT_PERSONNALISE: (rapportPersonnaliseId)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/rapport-personnalise/duplicate/` + rapportPersonnaliseId,
    IMPORTER_RAPPORT_PERSONNALISE: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/rapport-personnalise/import`,
    TASK: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/tache-planifiee`,
    LIST_MODELE_COURRIER: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/modele-courrier`,
    CREATE_MODELE_COURRIER: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/modele-courrier/create`,
    UPDATE_MODELE_COURRIER: (modeleCourrierId)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/modele-courrier/update/` + modeleCourrierId,
    GENERER_COURRIER: (typeModule)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/deci/create-courrier/` + typeModule,
    // Module Rapports personnalisés
    EXECUTER_RAPPORT_PERSONNALISE: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/rapport-personnalise/execute`,
    // Module DFCI
    CARTE_DFCI: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/dfci/carte`,
    DFCI_RECEPTION_TRAVAUX: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/dfci/reception-travaux`,
    DFCI_GESTION_CONFLITS: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/dfci/gestion-conflits`,
    RESOLVE_DFCI_CONFLIT: (dfciConflitId)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/dfci/gestion-conflits/resolve/` + dfciConflitId,
    // Module Signalements
    SIGNALEMENTS: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/signalements/carte`,
    SIGNALEMENTS_DELIBERATION: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/signalements/deliberation`,
    // Module dashboard
    DASHBOARD_ADMIN_QUERY: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/dashboard/query`,
    DASHBOARD_ADMIN_DASHBOARD: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/dashboard/dashboard`,
    DASHBOARD_LIST: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/dashboard`,
    // Module Opérations diverses
    HISTORIQUE_OPERATIONS: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/operations-diverses/historique-operations`,
    RESULTATS_EXECUTION: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/operations-diverses/resultats-execution`,
    RESULTATS_EXECUTION_LOGLINES: (jobId)=>(0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/operations-diverses/log-lines/` + jobId,
    //Tracabilité
    TRACABILITE: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/tracabilite`,
    MAJ_POSITIONS_PEI: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/maj-positions-pei`,
    RESULTAT_VERIF_MAJ_POSITIONS_PEI: (0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/admin/maj-positions-pei/verification`
};
var // On définit les routes par module pour que les enfants héritent du header ou d'autres éléments
$972f9f5d1854d2f4$export$2e2bcd8739ae039 = [
    {
        path: "/",
        element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
            Component: (0, $527d4c5324a1545c$export$2e2bcd8739ae039),
            isPublic: true
        })
    },
    {
        //Doit toujours être correspondre au returnTo dans le backend de DocumentEndpoit -> telechargerRessource
        path: "/telecharger-courrier/:documentId",
        element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
            Component: (0, $2d86bb80bf213615$export$2e2bcd8739ae039),
            isPublic: true
        })
    },
    {
        path: "/dfci/",
        element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
            Component: (0, $1005687cc76c60e9$export$2e2bcd8739ae039),
            droits: [
                (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).DFCI_R,
                (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).DFCI_RECEPTRAVAUX_C
            ]
        }),
        children: [
            {
                path: "carte",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $8be8331dcad9d257$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).DFCI_R
                    ]
                })
            },
            {
                path: "reception-travaux",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $0d67dd9fb9f532e5$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).DFCI_RECEPTRAVAUX_C
                    ]
                })
            },
            {
                path: "gestion-conflits",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $26d9d1c403583064$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).DFCI_GESTION_CONFLITS_R
                    ]
                })
            },
            {
                path: "gestion-conflits/resolve/:dfciConflitId",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $8e87f5a539f829da$export$dd6ac16f03f78be8),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).DFCI_GESTION_CONFLITS_A
                    ]
                })
            }
        ]
    },
    {
        path: "/deci/",
        element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
            Component: (0, $2d36968a38c909a2$export$2e2bcd8739ae039),
            droits: Object.values((0, $7680c94ec9779ccd$export$2e2bcd8739ae039))
        }),
        children: [
            {
                path: "",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $7a844823b04d4282$export$444b3ab0cb9aec40), {
                    to: "acces-rapide",
                    replace: true
                })
            },
            {
                path: "acces-rapide",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $91419ff82e7cf259$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).PEI_R
                    ]
                })
            },
            {
                path: "pei",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $2492bb2a576156bb$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).PEI_R
                    ]
                })
            },
            {
                path: "pei/:peiId",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $b5a42a59076ab4fc$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).PEI_R,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).PEI_U,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).PEI_CARACTERISTIQUES_U,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).PEI_NUMERO_INTERNE_U,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).PEI_DEPLACEMENT_U,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).PEI_ADRESSE_C
                    ]
                })
            },
            {
                path: "pei/tournee",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $d0b6210124247401$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).TOURNEE_R
                    ]
                })
            },
            {
                path: "pei/fiche/:peiId",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $4c401fa322fe4af6$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).PEI_R
                    ]
                })
            },
            {
                path: "pei/create",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $948eb983c24fac1c$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).PEI_C
                    ]
                })
            },
            {
                path: "pena-aspiration/:penaId",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $8bff802721744b7b$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).PEI_CARACTERISTIQUES_U,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).PEI_U
                    ]
                })
            },
            {
                path: "carte",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $acaa38b73f277215$export$2e2bcd8739ae039),
                    isPublic: true
                })
            },
            {
                path: "tournee",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $32ff803568ba9e09$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).TOURNEE_R,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).TOURNEE_A
                    ]
                })
            },
            {
                path: "tournee/create",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $a1be20d90875d36b$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).TOURNEE_A
                    ]
                })
            },
            {
                path: "tournee/update/:tourneeId",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $e3baa122da989549$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).TOURNEE_A
                    ]
                })
            },
            {
                path: "tournee/pei/:tourneeId",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $d5414c57b72b1aae$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).TOURNEE_A,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).TOURNEE_ORDRE_PEIS_U
                    ]
                })
            },
            {
                path: "tournee/liste-pei/:tourneeId",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $89ce6591ed81099f$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).TOURNEE_R,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).PEI_R
                    ]
                })
            },
            {
                path: "tournee/visite-tournee/:tourneeId",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $8da2bbfb15d82bb7$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).TOURNEE_R,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).TOURNEE_A
                    ]
                })
            },
            {
                path: "visite/:peiId",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $1398c46fdaf43768$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).VISITE_R
                    ]
                })
            },
            {
                path: "indisponibilite-temporaire/create",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $cb6c3964a06abc13$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).INDISPO_TEMP_C
                    ]
                })
            },
            {
                path: "indisponibilite-temporaire/",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $e7fda6f52dff7328$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).INDISPO_TEMP_R
                    ]
                })
            },
            {
                path: "indisponibilite-temporaire/pei/:indisponibiliteTemporaireId",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $8a1e46e15c88850d$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).INDISPO_TEMP_R,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).PEI_R
                    ]
                })
            },
            {
                path: "indisponibilite-temporaire/:indisponibiliteTemporaireId",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $d8b03e3e0518a115$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).INDISPO_TEMP_U
                    ]
                })
            },
            {
                path: "debit-simultane/update/:debitSimultaneId",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $c0d401b6231ce1af$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).DEBITS_SIMULTANES_A
                    ]
                })
            },
            {
                path: "declaration-pei",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $8c5991efe7d738aa$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).DECLARATION_PEI
                    ]
                })
            },
            {
                path: "import-ctp",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $8de12d73634099f7$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).IMPORT_CTP_A
                    ]
                })
            },
            {
                path: "import-ctp/verification",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $52a039f76bee8f8d$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).IMPORT_CTP_A
                    ]
                })
            },
            {
                path: "export-ctp",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $2a4c508f21c8ff6f$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).IMPORT_CTP_A
                    ]
                })
            },
            {
                path: "message-pei-longue-indispo/pei",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $3c965143f4385f8c$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).PEI_R
                    ]
                })
            },
            {
                path: "create-courrier/:typeModule",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $f023788f0719ca00$export$2e2bcd8739ae039), {}),
                children: [
                    {
                        path: "",
                        element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $7a844823b04d4282$export$444b3ab0cb9aec40), {
                            to: "view-courrier",
                            replace: true
                        })
                    },
                    {
                        path: "view-courrier",
                        element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                            Component: (0, $4787a1f0373e38b8$export$2e2bcd8739ae039),
                            droits: [
                                (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).COURRIER_C
                            ]
                        })
                    }
                ]
            }
        ]
    },
    {
        path: "/couverture-hydraulique/",
        element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $393dcc074d501912$export$2e2bcd8739ae039), {}),
        children: [
            {
                path: "",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $7a844823b04d4282$export$444b3ab0cb9aec40), {
                    to: "etudes",
                    replace: true
                })
            },
            {
                path: "etudes",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $305d863cb857dd07$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ETUDE_R
                    ]
                })
            },
            {
                path: "etudes/create",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $295dcd157ddd4a4f$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ETUDE_C
                    ]
                })
            },
            {
                path: "etudes/:etudeId",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $2987c33bfc851c58$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ETUDE_U
                    ]
                })
            },
            {
                path: "etudes/open/:etudeId",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $a2b18b07124b751d$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ETUDE_U,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ETUDE_R,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ETUDE_D,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ETUDE_C
                    ]
                })
            },
            {
                path: "etudes/import/:etudeId",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $e796e0d50f5e3eb7$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ETUDE_U
                    ]
                })
            },
            {
                path: "etudes/:etudeId/pei-projet/:peiProjetId",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $bb50efe5e52f41fa$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ETUDE_U
                    ]
                })
            }
        ]
    },
    {
        path: "/gestion-crise",
        element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b7f47f02986a78ec$export$2e2bcd8739ae039), {}),
        children: [
            {
                path: "",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $7a844823b04d4282$export$444b3ab0cb9aec40), {
                    to: "crise",
                    replace: true
                })
            },
            {
                path: "crise",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $f34af43330f31af1$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).CRISE_R
                    ]
                })
            },
            {
                path: "crise/create",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $037869659ef735e1$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).CRISE_R
                    ]
                })
            },
            {
                path: "crise/:criseId",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $3ffcddd6bd1de12d$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).CRISE_R
                    ]
                })
            },
            {
                path: "crise/open/:criseId",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $3e48f0f93abb6fed$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).CRISE_U,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).CRISE_R,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).CRISE_D,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).CRISE_C
                    ]
                })
            },
            {
                path: "crise/merge/:criseId",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $024b1e5e401e6092$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).CRISE_U,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).CRISE_D,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).CRISE_C
                    ]
                })
            },
            {
                path: "crise/export/:criseId",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $528d179ef5f8cb95$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).CRISE_U,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).CRISE_R,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).CRISE_D,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).CRISE_C
                    ]
                })
            }
        ]
    },
    {
        path: "/oldeb/",
        element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
            Component: (0, $decbf64d15de7bd5$export$2e2bcd8739ae039),
            droits: Object.values((0, $7680c94ec9779ccd$export$2e2bcd8739ae039))
        }),
        children: [
            {
                path: "",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $7a844823b04d4282$export$444b3ab0cb9aec40), {
                    to: "recherche",
                    replace: true
                })
            },
            {
                path: "recherche",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $0f75f1ca349a33ff$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).OLDEB_R
                    ]
                })
            },
            {
                path: "liste",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $f6ecdcec5b37cf39$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).OLDEB_R
                    ]
                })
            },
            {
                path: "create",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $b4a8af4eb541f4bc$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).OLDEB_C
                    ]
                })
            },
            {
                path: ":oldebId",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $4e92f660e4837a43$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).OLDEB_U
                    ]
                })
            },
            {
                path: "localisation",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $a3eff75f5a09a065$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).OLDEB_R
                    ]
                })
            },
            {
                path: "proprietaire",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $a575bb1f58db9b30$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).OLDEB_R
                    ]
                })
            },
            {
                path: "proprietaire/create",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $329dc4c2759b9760$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).OLDEB_C
                    ]
                })
            },
            {
                path: "proprietaire/:proprietaireId",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $518d651e5a5f4af5$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).OLDEB_U
                    ]
                })
            }
        ]
    },
    {
        path: "/cartographie-personnalisee",
        element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
            Component: (0, $f7b9d2d9bb8fc3a8$export$2e2bcd8739ae039),
            droits: [
                (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).CARTOGRAPHIES_E
            ]
        })
    },
    {
        path: "/pei-prescrit",
        element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
            Component: (0, $f0932257f8def3d4$export$2e2bcd8739ae039),
            droits: [
                (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).PEI_PRESCRIT_R
            ]
        })
    },
    {
        path: "/rcci/",
        element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $9556e76e51bd2389$export$2e2bcd8739ae039), {}),
        children: [
            {
                path: "",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $4226cb44342fe5b6$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).RCCI_A,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).RCCI_R
                    ]
                })
            }
        ]
    },
    {
        path: "/permis",
        element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
            Component: (0, $6d2a1b0d422996c0$export$2e2bcd8739ae039),
            droits: [
                (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).PERMIS_R
            ]
        })
    },
    {
        path: "/risque",
        element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
            Component: (0, $b0ba16595e31db33$export$2e2bcd8739ae039),
            isPublic: true
        })
    },
    {
        path: "/risque/import-risque-express",
        element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
            Component: (0, $adf8bb069e8339b8$export$2e2bcd8739ae039),
            droits: [
                (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).RISQUE_EXPRESS_A
            ]
        })
    },
    {
        path: "/admin/",
        element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
            Component: (0, $239f06cc878a10d1$export$2e2bcd8739ae039),
            droits: Object.values((0, $7680c94ec9779ccd$export$2e2bcd8739ae039))
        }),
        children: [
            {
                path: "",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $7a844823b04d4282$export$444b3ab0cb9aec40), {
                    to: "menu",
                    replace: true
                })
            },
            {
                path: "menu",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $d324e040d6d3784b$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_ANOMALIES,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_API,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_COUCHE_CARTOGRAPHIQUE,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_COURRIER,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).DASHBOARD_A,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_DROITS,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_PARAM_APPLI,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_PARAM_APPLI_MOBILE,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_PARAM_TRAITEMENTS,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_RAPPORTS_PERSO,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_ROLE_CONTACT,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_TYPE_ETUDE,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_UTILISATEURS_A,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_ZONE_COMPETENCE,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).GEST_SITE_A,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).GEST_SITE_R,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).GEST_CONTACT_A,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ORGANISME_CONTACT_A,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_ORGANISME_A,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_ORGANISME_R,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_UTILISATEURS_R,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_UTILISATEURS_A,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_UTILISATEURS_ORGA_A,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_UTILISATEURS_ORGA_R,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).PEI_DEPLACEMENT_U
                    ]
                })
            },
            {
                path: "/admin/couche-metadata",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $a831bb357ea10201$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).CARTO_METADATA_A
                    ]
                })
            },
            {
                path: "/admin/couche-metadata/update-couche-metadata/:coucheMetadataId",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $886465b1598df209$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).CARTO_METADATA_A
                    ]
                })
            },
            {
                path: "/admin/couche-metadata/create-couche-metadata",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $b792a7c7cef2e983$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).CARTO_METADATA_A
                    ]
                })
            },
            {
                path: "/admin/parametres",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $bd415ca04deb1f3d$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_PARAM_APPLI,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_PARAM_APPLI_MOBILE
                    ]
                })
            },
            {
                path: "/admin/import-ressources",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $4ce42d48179876f4$export$bfb425db2787437d),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_PARAM_APPLI
                    ]
                })
            },
            {
                path: "/admin/gestion-atlas",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $db6ad79f456e3735$export$6401918d5d43bb8b),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ATLAS_A,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ATLAS_C,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ATLAS_D
                    ]
                })
            },
            {
                path: "signalement-type-anomalie",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $8c2f2bdaaecbf5a8$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE
                    ]
                })
            },
            {
                path: "signalement-type-anomalie/create",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $404080517c04162c$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE
                    ]
                })
            },
            {
                path: "signalement-type-anomalie/:signalementTypeAnomalieId",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $411736c61ae06e8d$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE
                    ]
                })
            },
            {
                path: "signalement-type-element",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $17aae1c75e7b31d5$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE
                    ]
                })
            },
            {
                path: "signalement-type-element/create",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $f51523342d52bb2c$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE
                    ]
                })
            },
            {
                path: "signalement-type-element/:signalementTypeElementId",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $af10b9b976e5877a$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE
                    ]
                })
            },
            {
                path: "signalement-sous-type-element",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $116c531becbb5c80$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE
                    ]
                })
            },
            {
                path: "signalement-sous-type-element/create",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $455cec8ecf3a2c2a$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE
                    ]
                })
            },
            {
                path: "signalement-sous-type-element/:signalementSousTypeElementId",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $68ce6420a68f6106$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE
                    ]
                })
            },
            {
                path: "diametre",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $025d19a08c961595$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE
                    ]
                })
            },
            {
                path: "diametre/:diametreId",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $bfba589cecdfbf65$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE
                    ]
                })
            },
            {
                path: "diametre/create",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $d1fe7f1e9b5255ba$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE
                    ]
                })
            },
            {
                path: "nature/",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $7cf041e503d3435c$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE
                    ]
                })
            },
            {
                path: "nature/update/:natureId",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $00f190f7910b59b6$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE
                    ]
                })
            },
            {
                path: "nature/create",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $352ffb5a0cd55433$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE
                    ]
                })
            },
            {
                path: "nature-deci/",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $4a412c339eaccfd0$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE
                    ]
                })
            },
            {
                path: "nature-deci/update/:natureDeciId",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $d85e24e4022cc184$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE
                    ]
                })
            },
            {
                path: "nature-deci/create",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $90d7619d5b0c85af$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE
                    ]
                })
            },
            {
                path: "domaine",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $ae07dee136c398b8$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE
                    ]
                })
            },
            {
                path: "domaine/update/:domaineId",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $e2c624fc51959a35$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE
                    ]
                })
            },
            {
                path: "domaine/create",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $48caef1b2068e58e$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE
                    ]
                })
            },
            {
                path: "fonction-contact",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $bce4ee014dd39b69$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE
                    ]
                })
            },
            {
                path: "fonction-contact/update/:fonctionContactId",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $42fcc7866a6ccc7d$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE
                    ]
                })
            },
            {
                path: "fonction-contact/create",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $166f2e199414f92a$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE
                    ]
                })
            },
            {
                path: "marque-pibi",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $63e1527c00d8691b$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE
                    ]
                })
            },
            {
                path: "marque-pibi/update/:marquePibiId",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $54976652b03567b1$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE
                    ]
                })
            },
            {
                path: "marque-pibi/create",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $86220e499464048e$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE
                    ]
                })
            },
            {
                path: "materiau",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $2b7fe80bc4220843$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE
                    ]
                })
            },
            {
                path: "materiau/update/:materiauId",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $77c0018a184fb5cd$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE
                    ]
                })
            },
            {
                path: "materiau/create",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $a5a33a89338804c7$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE
                    ]
                })
            },
            {
                path: "type-canalisation",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $d7a8f8dd952ec6e5$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE
                    ]
                })
            },
            {
                path: "type-canalisation/update/:typeCanalisationId",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $b341973d98a5f2d5$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE
                    ]
                })
            },
            {
                path: "type-canalisation/create",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $f44627e567122d89$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE
                    ]
                })
            },
            {
                path: "type-engin",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $363073eee7b7b1a4$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE
                    ]
                })
            },
            {
                path: "type-engin/update/:typeEnginId",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $c67383bb1ca7e54f$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE
                    ]
                })
            },
            {
                path: "type-engin/create",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $d40c36bab19bf0a4$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE
                    ]
                })
            },
            {
                path: "type-reseau",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $1e886f96e245809c$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE
                    ]
                })
            },
            {
                path: "type-reseau/update/:typeReseauId",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $4436a729df429bad$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE
                    ]
                })
            },
            {
                path: "type-reseau/create",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $e448f3f461bace02$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE
                    ]
                })
            },
            {
                path: "anomalie-categorie",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $b875d3d827f045ce$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE
                    ]
                })
            },
            {
                path: "anomalie-categorie/sort",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $68abd1dbff894189$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE
                    ]
                })
            },
            {
                path: "anomalie-categorie/update/:anomalieCategorieId",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $4ead303c0a3099b7$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE
                    ]
                })
            },
            {
                path: "anomalie-categorie/create",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $1cd9ddd687574c40$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE
                    ]
                })
            },
            {
                path: "niveau",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $5607dbdd064f8ed5$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE
                    ]
                })
            },
            {
                path: "niveau/update/:niveauId",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $145bf54b63af6050$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE
                    ]
                })
            },
            {
                path: "niveau/create",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $8f9632c28eb11787$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE
                    ]
                })
            },
            {
                path: "modele-pibi",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $3cfa3c5c3dcf4e83$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE
                    ]
                })
            },
            {
                path: "modele-pibi/update/:modelePibiId",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $07823dfc6f4cfbc8$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE
                    ]
                })
            },
            {
                path: "modele-pibi/create",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $e256fa5d712b8643$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE
                    ]
                })
            },
            {
                path: "type-etude",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $6c440898ee7fa736$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_TYPE_ETUDE
                    ]
                })
            },
            {
                path: "type-etude/update/:typeEtudeId",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $e9df073b73d1f4d6$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_TYPE_ETUDE
                    ]
                })
            },
            {
                path: "type-etude/create",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $fbde39500bdb2cf0$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_TYPE_ETUDE
                    ]
                })
            },
            {
                path: "type-pena-aspiration",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $708025c61e582c3b$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE
                    ]
                })
            },
            {
                path: "type-pena-aspiration/update/:typePenaAspirationId",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $5bb7009d13f5389b$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE
                    ]
                })
            },
            {
                path: "type-pena-aspiration/create",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $a2249221b7b8076f$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE
                    ]
                })
            },
            {
                path: "groupe-fonctionnalites",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $b3dc38ef1a9b638e$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_DROITS
                    ]
                })
            },
            {
                path: "groupe-fonctionnalites/create",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $e14b572d3716a4bc$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_DROITS
                    ]
                })
            },
            {
                path: "groupe-fonctionnalites/:groupeFonctionnalitesId",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $a389155915939d6d$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_DROITS
                    ]
                })
            },
            {
                path: "lien-groupe-fonctionnalites",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $67d49f8fdb33e7bc$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_DROITS
                    ]
                })
            },
            {
                path: "lien-profil-fonctionnalite",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $81cf55f993f3c491$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_DROITS
                    ]
                })
            },
            {
                path: "lien-profil-fonctionnalite/create",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $e233fb445d2f80f6$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_DROITS
                    ]
                })
            },
            {
                path: "lien-profil-fonctionnalite/:profilOrganismeId/:profilUtilisateurId",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $846dfd8fbbe7ab3b$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_DROITS
                    ]
                })
            },
            {
                path: "thematique",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $bcb21ecb3f9cc3c8$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_PARAM_APPLI
                    ]
                })
            },
            {
                path: "thematique/update/:thematiqueId",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $b50b9a868721d5a8$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_PARAM_APPLI
                    ]
                })
            },
            {
                path: "thematique/create",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $62b113d43e2fafa5$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_PARAM_APPLI
                    ]
                })
            },
            {
                path: "groupe-couche",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $c2b1d27dc8167fda$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_COUCHE_CARTOGRAPHIQUE
                    ]
                })
            },
            {
                path: "groupe-couche/:groupeCoucheId/couches",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $42347a5cb9db41d8$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_COUCHE_CARTOGRAPHIQUE
                    ]
                })
            },
            {
                path: "groupe-couche/:groupeCoucheId/couche/create",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $fa8a60d7d4bd6754$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_COUCHE_CARTOGRAPHIQUE
                    ]
                })
            },
            {
                path: "groupe-couche/:groupeCoucheId/couche/update/:coucheId",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $c0542f1caecdc33d$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_COUCHE_CARTOGRAPHIQUE
                    ]
                })
            },
            {
                path: "groupe-couche/:groupeCoucheId/couches/sort",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $417aed7facf81410$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_COUCHE_CARTOGRAPHIQUE
                    ]
                })
            },
            {
                path: "groupe-couche/create",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $f0109cb1d092a909$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_COUCHE_CARTOGRAPHIQUE
                    ]
                })
            },
            {
                path: "groupe-couche/sort",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $c3135075c0a34b44$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_COUCHE_CARTOGRAPHIQUE
                    ]
                })
            },
            {
                path: "groupe-couche/update/:groupeCoucheId",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $dd4215794f25d066$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_COUCHE_CARTOGRAPHIQUE
                    ]
                })
            },
            {
                path: "organisme",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $9efb6bc4aa7c5a70$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ORGANISME_CONTACT_A,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_ORGANISME_R,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_ORGANISME_A
                    ]
                })
            },
            {
                path: "organisme/create",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $e1a55cf6206726f3$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ORGANISME_CONTACT_A,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_ORGANISME_A
                    ]
                })
            },
            {
                path: "organisme/update/:organismeId",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $dca4baa1306090f4$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ORGANISME_CONTACT_A,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_ORGANISME_A
                    ]
                })
            },
            {
                path: "type-organisme",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $6d6512996856028d$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_DROITS,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_ORGANISME_A
                    ]
                })
            },
            {
                path: "type-organisme/create",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $5f12451354e1008d$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_DROITS,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_ORGANISME_A
                    ]
                })
            },
            {
                path: "type-organisme/update/:typeOrganismeId",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $d83f1d5d71c75787$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_DROITS,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_ORGANISME_A
                    ]
                })
            },
            {
                path: "profil-organisme",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $28344cb136ea89b3$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_DROITS,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_ORGANISME_R,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_ORGANISME_A
                    ]
                })
            },
            {
                path: "profil-organisme/create",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $91fb64896f34c2be$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_DROITS,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_ORGANISME_A
                    ]
                })
            },
            {
                path: "profil-organisme/update/:profilOrganismeId",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $5f76d06ca8c86fcb$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_DROITS,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_ORGANISME_A
                    ]
                })
            },
            {
                path: "profil-utilisateur",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $48f2d088b5c92973$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_DROITS
                    ]
                })
            },
            {
                path: "profil-utilisateur/create",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $3422bc2542d5430b$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_DROITS,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_UTILISATEURS_A
                    ]
                })
            },
            {
                path: "role-contact/update/:roleContactId",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $2d890c99dd2b1995$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_ROLE_CONTACT
                    ]
                })
            },
            {
                path: "role-contact",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $a4ae715c1eab63f2$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_ROLE_CONTACT
                    ]
                })
            },
            {
                path: "role-contact/create",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $f4dec70a56e987ec$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_ROLE_CONTACT
                    ]
                })
            },
            {
                path: "profil-utilisateur/update/:profilUtilisateurId",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $7c43c1f098161cf2$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_DROITS
                    ]
                })
            },
            {
                path: "site",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $b078d110eb631d6f$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).GEST_SITE_R,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).GEST_SITE_A
                    ]
                })
            },
            {
                path: "site/update/:siteId",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $bc67effde39fde39$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).GEST_SITE_A
                    ]
                })
            },
            {
                path: "gestionnaire",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $2d13bf66536e67e2$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).GEST_SITE_R,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).GEST_SITE_A
                    ]
                })
            },
            {
                path: "gestionnaire/update/:gestionnaireId",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $f7f591449c45aa5f$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).GEST_SITE_A
                    ]
                })
            },
            {
                path: "gestionnaire/create",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $560b8785a401018e$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).GEST_SITE_A
                    ]
                })
            },
            {
                path: ":appartenance/:appartenanceId/contact/create",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $3b9dd57c1f2e6dfa$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).GEST_CONTACT_A,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ORGANISME_CONTACT_A
                    ]
                })
            },
            {
                path: ":appartenance/:appartenanceId/contact",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $18ce4b63951cd018$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).GEST_SITE_R,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).GEST_CONTACT_A,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ORGANISME_CONTACT_A,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_ORGANISME_R
                    ]
                })
            },
            {
                path: ":appartenance/:appartenanceId/contact/update/:contactId",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $d5f5c102902e8354$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).GEST_CONTACT_A,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ORGANISME_CONTACT_A
                    ]
                })
            },
            {
                path: "type-crise/update/:typeCriseId",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $806c80671130d0da$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE
                    ]
                })
            },
            {
                path: "type-crise",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $18f238516106c4f1$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE
                    ]
                })
            },
            {
                path: "type-crise/create",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $5db36463ed46a763$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE
                    ]
                })
            },
            {
                path: "evenement-categorie/update/:evenementCategorieId",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $5bafc85b7f697a6a$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE
                    ]
                })
            },
            {
                path: "evenement-sous-categorie-list",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $71c88b03b9f38f2f$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE
                    ]
                })
            },
            {
                path: "evenement-categorie-list",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $5146d2437f0587bf$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE
                    ]
                })
            },
            {
                path: "evenement-sous-categorie/update/:evenementSousCategorieId",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $138285f48f6f51f8$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE
                    ]
                })
            },
            {
                path: "evenement-categorie",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $5146d2437f0587bf$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE
                    ]
                })
            },
            {
                path: "evenement-categorie/create",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $354b019645efe8b2$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE
                    ]
                })
            },
            {
                path: "evenement-sous-categorie",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $71c88b03b9f38f2f$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE
                    ]
                })
            },
            {
                path: "evenement-sous-categorie/create",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $bbfc62d132294797$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE
                    ]
                })
            },
            {
                path: "evenement-sous-categorie/update/:EvenementSousCategorieId",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $138285f48f6f51f8$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE
                    ]
                })
            },
            {
                path: "document-habilitable",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $5323278bca44277a$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).DOCUMENTS_R
                    ]
                })
            },
            {
                path: "document-habilitable/create",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $21c51c1f5d8d18ca$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).DOCUMENTS_A
                    ]
                })
            },
            {
                path: "document-habilitable/update/:documentHabilitableId",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $9caed844f672311b$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).DOCUMENTS_A
                    ]
                })
            },
            {
                path: "anomalie",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $31e7dde0e854b550$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_ANOMALIES
                    ]
                })
            },
            {
                path: "anomalie/create",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $50c218009ece03e0$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_ANOMALIES
                    ]
                })
            },
            {
                path: "anomalie/:anomalieId",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $62a11b0be133b8a2$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_ANOMALIES
                    ]
                })
            },
            {
                path: "anomalie/sort/:anomalieCategorieId",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $342c4304486fda19$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_NOMENCLATURE
                    ]
                })
            },
            {
                path: "utilisateur",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $6ef4d54939420c74$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_UTILISATEURS_A,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_UTILISATEURS_R,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_UTILISATEURS_ORGA_A,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_UTILISATEURS_ORGA_R,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).IMPORT_UTILISATEUR_A
                    ]
                })
            },
            {
                path: "utilisateur/create",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $d047e2f9b5073ade$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_UTILISATEURS_A,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_UTILISATEURS_ORGA_A
                    ]
                })
            },
            {
                path: "utilisateur/import",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $f523d2f0c767de11$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).IMPORT_UTILISATEUR_A
                    ]
                })
            },
            {
                path: "utilisateur/verification-import",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $e8f60ca44cdcf07e$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).IMPORT_UTILISATEUR_A
                    ]
                })
            },
            {
                path: "utilisateur/update/:utilisateurId",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $0bfdbc6ad1277f1e$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_UTILISATEURS_A,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_UTILISATEURS_ORGA_A
                    ]
                })
            },
            {
                path: "fiche-resume",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $285b41d2d2e5cad5$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_PARAM_APPLI
                    ]
                })
            },
            {
                path: "module-accueil",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $96c21b2d91fc07ff$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_PARAM_APPLI
                    ]
                })
            },
            {
                path: "zone-integration",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $a62d163b52d0700d$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_ZONE_COMPETENCE
                    ]
                })
            },
            {
                path: "zone-integration/update/:zoneIntegrationId",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $fa21e0a438fbb3d9$export$2e2bcd8739ae039),
                    // TODO
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_ZONE_COMPETENCE
                    ]
                })
            },
            {
                path: "rapport-personnalise",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $09cdd052c2271909$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_RAPPORTS_PERSO
                    ]
                })
            },
            {
                path: "rapport-personnalise/create",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $1adebabfae3924a1$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_RAPPORTS_PERSO
                    ]
                })
            },
            {
                path: "rapport-personnalise/update/:rapportPersonnaliseId",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $1bab07cc7a5e54aa$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_RAPPORTS_PERSO
                    ]
                })
            },
            {
                path: "rapport-personnalise/import",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $9a2756b5e98fa7de$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_RAPPORTS_PERSO
                    ]
                })
            },
            {
                path: "rapport-personnalise/duplicate/:rapportPersonnaliseId",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $79115d69064b1d7f$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_RAPPORTS_PERSO
                    ]
                })
            },
            {
                path: "modele-courrier",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $173df38c0222d645$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_COURRIER
                    ]
                })
            },
            {
                path: "modele-courrier/create",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $3582535d1a340d84$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_COURRIER
                    ]
                })
            },
            {
                path: "modele-courrier/update/:modeleCourrierId",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $8bb0ad4fc5bd7b31$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_COURRIER
                    ]
                })
            },
            {
                path: "maj-positions-pei",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $e97e04de6714d38d$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).PEI_DEPLACEMENT_U
                    ]
                })
            },
            {
                path: "maj-positions-pei/verification",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $03e676c79e46c88d$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).PEI_DEPLACEMENT_U
                    ]
                })
            },
            {
                path: "tache-planifiee",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $9b8bcc9a1730b549$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_PARAM_TRAITEMENTS
                    ]
                })
            },
            {
                path: "tache-specifique",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $40a7b6af097c9e55$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_PARAM_TRAITEMENTS
                    ]
                })
            },
            {
                path: "tasks-manuelles",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $12139b22683cc1d3$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_PARAM_TRAITEMENTS
                    ]
                })
            },
            {
                path: "tache-specifique/create",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $dd56e209bb15597b$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_PARAM_TRAITEMENTS
                    ]
                })
            },
            {
                path: "type-organisme-droits-api",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $5fac7c539afc1913$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).ADMIN_API
                    ]
                })
            },
            {
                path: "dashboard/query",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $43e0d0005f28cb47$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).DASHBOARD_A
                    ]
                })
            },
            {
                path: "dashboard/dashboard",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $661778a0caccebd1$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).DASHBOARD_A
                    ]
                })
            }
        ]
    },
    {
        path: "/documents/:moduleType/thematiques/:moduleId",
        element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
            Component: (0, $4f44af54e0715d5f$export$2e2bcd8739ae039),
            // TODO courrier droit
            droits: [
                (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).DOCUMENTS_R
            ]
        })
    },
    {
        path: "/documents/courrier/thematiques/:moduleId",
        element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
            Component: (0, $00aa4b3a67b380d4$export$2e2bcd8739ae039),
            droits: [
                (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).COURRIER_UTILISATEUR_R,
                (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).COURRIER_ADMIN_R,
                (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).COURRIER_ORGANISME_R
            ]
        })
    },
    {
        path: "/rapport-personnalise/",
        element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
            Component: (0, $cc1ad355e9f5383d$export$2e2bcd8739ae039),
            // TODO
            droits: Object.values((0, $7680c94ec9779ccd$export$2e2bcd8739ae039))
        }),
        children: [
            {
                path: "",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $7a844823b04d4282$export$444b3ab0cb9aec40), {
                    to: "execute",
                    replace: true
                })
            },
            {
                path: "execute/",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $00daf475f54b3c5d$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).RAPPORT_PERSONNALISE_E
                    ]
                })
            }
        ]
    },
    {
        path: "/operations-diverses/",
        element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
            Component: (0, $6e6d9adb8fee06b8$export$2e2bcd8739ae039),
            droits: [
                (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).OPERATIONS_DIVERSES_E
            ]
        }),
        children: [
            {
                path: "",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $7a844823b04d4282$export$444b3ab0cb9aec40), {
                    to: "historique-operations",
                    replace: true
                })
            },
            {
                path: "historique-operations",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $b5cdcb80485d2f83$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).OPERATIONS_DIVERSES_E
                    ]
                })
            },
            {
                path: "resultats-execution",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $695d25d5da8e5277$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).OPERATIONS_DIVERSES_E
                    ]
                })
            },
            {
                path: "log-lines/:jobId",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $0df6cafa8bb5af73$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).OPERATIONS_DIVERSES_E
                    ]
                })
            }
        ]
    },
    {
        path: "/dashboard/",
        element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
            Component: (0, $5cf0018c732f1534$export$2e2bcd8739ae039),
            droits: [
                (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).DASHBOARD_R,
                (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).DASHBOARD_A
            ]
        }),
        children: [
            {
                path: "",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $16ed3be1353805cf$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).DASHBOARD_R,
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).DASHBOARD_A
                    ]
                })
            }
        ]
    },
    {
        path: "/signalements/",
        element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
            Component: (0, $4000938da69a64f9$export$2e2bcd8739ae039),
            droits: [
                (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).SIGNALEMENTS_C
            ]
        }),
        children: [
            {
                path: "carte",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $c30e76b968281c68$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).SIGNALEMENTS_C
                    ]
                })
            },
            {
                path: "deliberation",
                element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e3b8d60f4bb99483$export$552522b64eb5db81), {
                    Component: (0, $4103b2e2c988da42$export$2e2bcd8739ae039),
                    droits: [
                        (0, $7680c94ec9779ccd$export$2e2bcd8739ae039).DEPOT_DELIB_C
                    ]
                })
            }
        ]
    },
    {
        path: "loginerror",
        element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b8cc28a1cee229b7$export$2e2bcd8739ae039), {})
    },
    {
        path: "*",
        element: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $4b625e33952bcf2d$export$2e2bcd8739ae039), {})
    }
];


const $8d9ebd8892d8a5f5$export$8ff66c70be1c563a = async (url, options = {})=>{
    if (!url) return null;
    const res = await fetch(url === decodeURIComponent(url) ? encodeURI(url) : url, options);
    if (res.status === 401) window.location.reload();
    // On ne redirige vers l'accueil que pour les requêtes GET,
    // un accès direct à une page/ressource interdite.
    // Pour les actions (DELETE/POST/PUT), on gère déjà l'erreur là où on l'appel
    // avec un toast et une redirection empêcherait de lire ce message.
    const method = options?.method ?? "GET";
    if (res.status === 403 && method.toUpperCase() === "GET") document.location.href = (0, $972f9f5d1854d2f4$export$2389c26b9ec125dd).ACCUEIL;
    if (!res.ok) throw res;
    if (res.status === 204) return null;
    return res.text().then((text)=>{
        return text ? JSON.parse(text) : null;
    });
};
function $8d9ebd8892d8a5f5$export$99b32c99608275e1(url, asyncOptions = {}) {
    return (0, $77fae5be6c2b1145$export$cdf1dc76b55502e3)({
        ...asyncOptions,
        promiseFn: (0, $kc00y.useCallback)((props, { signal: signal })=>{
            const options = (0, $fbd4d34e07af0ac7$export$b163ec2f884327db)({
                signal: signal,
                method: "GET"
            });
            return $8d9ebd8892d8a5f5$export$8ff66c70be1c563a(url, options);
        }, [
            url
        ])
    });
}
function $8d9ebd8892d8a5f5$export$6326fb4463ae1be4(url, asyncOptions = {}) {
    return (0, $77fae5be6c2b1145$export$cdf1dc76b55502e3)({
        ...asyncOptions,
        deferFn: (0, $kc00y.useCallback)((args, props, { signal: signal })=>{
            const options = (0, $fbd4d34e07af0ac7$export$b163ec2f884327db)({
                signal: signal,
                method: "GET"
            });
            return $8d9ebd8892d8a5f5$export$8ff66c70be1c563a(url, options);
        }, [
            url
        ])
    });
}
function $8d9ebd8892d8a5f5$export$9158e33c8d0ca687(url, asyncOptions = {}, isMultipartFormData = false) {
    return (0, $77fae5be6c2b1145$export$cdf1dc76b55502e3)({
        ...asyncOptions,
        deferFn: (0, $kc00y.useCallback)(async ([body, { setSubmitting: setSubmitting } = {}], props, { signal: signal })=>{
            const options = isMultipartFormData ? (0, $fbd4d34e07af0ac7$export$b163ec2f884327db)({
                signal: signal,
                method: "POST",
                body: body
            }) : (0, $fbd4d34e07af0ac7$export$b163ec2f884327db)({
                signal: signal,
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(body)
            });
            try {
                return await $8d9ebd8892d8a5f5$export$8ff66c70be1c563a(url, options);
            } finally{
                if (typeof setSubmitting === "function") setSubmitting(false);
            }
        }, [
            isMultipartFormData,
            url
        ])
    });
}
function $8d9ebd8892d8a5f5$export$60acb8fd13afd60d(url, asyncOptions = {}) {
    return (0, $77fae5be6c2b1145$export$cdf1dc76b55502e3)({
        ...asyncOptions,
        deferFn: (0, $kc00y.useCallback)((args, props, { signal: signal })=>{
            const options = (0, $fbd4d34e07af0ac7$export$b163ec2f884327db)({
                signal: signal,
                method: "DELETE"
            });
            return $8d9ebd8892d8a5f5$export$8ff66c70be1c563a(url, options);
        }, [
            url
        ])
    });
}
function $8d9ebd8892d8a5f5$export$f378150f39d4621f(url, asyncOptions = {}, isMultipartFormData) {
    return (0, $77fae5be6c2b1145$export$cdf1dc76b55502e3)({
        ...asyncOptions,
        deferFn: (0, $kc00y.useCallback)(async ([body, { setSubmitting: setSubmitting } = {}], props, { signal: signal })=>{
            const options = isMultipartFormData ? (0, $fbd4d34e07af0ac7$export$b163ec2f884327db)({
                signal: signal,
                method: "PUT",
                body: body
            }) : (0, $fbd4d34e07af0ac7$export$b163ec2f884327db)({
                signal: signal,
                method: "PUT",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(body)
            });
            try {
                return await $8d9ebd8892d8a5f5$export$8ff66c70be1c563a(url, options);
            } finally{
                if (typeof setSubmitting === "function") setSubmitting(false);
            }
        }, [
            isMultipartFormData,
            url
        ])
    });
}


const $e787cde576104469$var$AppContext = /*#__PURE__*/ (0, $kc00y.createContext)({});
const $e787cde576104469$export$fdc397e486fa83e7 = ()=>{
    return (0, $kc00y.useContext)($e787cde576104469$var$AppContext);
};
const $e787cde576104469$export$c7dacf3845253dcf = ({ children: children })=>{
    const { isLoading: isLoading, data: projectionProps } = (0, $8d9ebd8892d8a5f5$export$99b32c99608275e1)((0, $fbd4d34e07af0ac7$export$2e2bcd8739ae039)`/api/app-settings/epsg`);
    if (isLoading && !projectionProps) return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $c21b1c237cfa1d94$export$2e2bcd8739ae039), {});
    if (!(0, $a86eee1c28205a05$export$3988ae62b71be9a3)(projectionProps.name)) {
        (0, $ca159ace55b1c3df$export$2e2bcd8739ae039).defs(projectionProps.name, projectionProps.projection);
        (0, $9bd389b40b2d77bd$export$6503ec6e8aabbaf)((0, $ca159ace55b1c3df$export$2e2bcd8739ae039));
    }
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)($e787cde576104469$var$AppContext.Provider, {
        value: {
            user: userInfo,
            epsg: {
                name: projectionProps.name,
                projection: projectionProps.projection
            },
            srid: projectionProps.name.split(":").pop(),
            extent: projectionProps.extent,
            extentSRID: projectionProps.extentSRID
        },
        children: children
    });
};




const $87db66f40a8a1f13$var$RouteConfig = ({ routes: routes })=>{
    return (0, $7a844823b04d4282$export$5d3fca4a98652595)(routes);
};
var $87db66f40a8a1f13$export$2e2bcd8739ae039 = $87db66f40a8a1f13$var$RouteConfig;





const $b47d7e5c3492bee6$var$App = ()=>{
    return /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $e787cde576104469$export$c7dacf3845253dcf), {
        children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $6bdae0bad7b05751$export$f5d03d415824e0e), {
            children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $0608a055a17e1a05$export$9ba4e89fdfa1fc54), {
                children: /*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $87db66f40a8a1f13$export$2e2bcd8739ae039), {
                    routes: (0, $972f9f5d1854d2f4$export$2e2bcd8739ae039)
                })
            })
        })
    });
};
var $b47d7e5c3492bee6$export$2e2bcd8739ae039 = $b47d7e5c3492bee6$var$App;



// FIXME: remettre en place <StrictMode> quand on n'utilisera plus react-async
// cf. src/components/Fetch/useFetch.tsx
document.querySelector('link[rel="icon"]').setAttribute("href", "/images/favicon");
const $9e298d4cbc305cdb$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($945b3b548e437ca7$exports))).createRoot(document.getElementById("root"));
$9e298d4cbc305cdb$var$root.render(/*#__PURE__*/ (0, $948296388fc3e3c9$exports.jsx)((0, $b47d7e5c3492bee6$export$2e2bcd8739ae039), {}));


//# sourceMappingURL=frontend.bed02885.js.map
